/* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.folder = {
   angularModule: angular.module('com.vmware.vsphere.client.folder', [
      'com.vmware.vsphere.client.licenseLibUi'])
};

/*
 * Registers folder specific column renderers.
 */
angular.module('com.vmware.vsphere.client.folder').run([
   'actionDialogService',
   'clarityModalService',
   'dataService',
   'i18nService',
   'assignLicenseService',
   'vscExportWizardLauncherService',
   'moveFolderService',
   function(actionDialogService, clarityModalService, dataService, i18nService, assignLicenseService,
      vscExportWizardLauncherService, moveFolderService) {
      /*
       * Register the action invoker function in the h5.actions cache.
       */


      h5.actions['vsphere.core.datacenter.actions.addDatacenter'] = function(actionEval, availableTargets) {

         var modalOptions = {
            title: i18nService.getString('DatacenterUi', 'createDatacenterDialog.title'),
            contentTemplate: 'folder-ui/resources/folder/views/datacenter/addDatacenter.html',
            defaultButton: 'submit',
            dialogData: {
               objectId: availableTargets[0]
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);

      };


      h5.actions['vsphere.core.vcenter.actions.addFolder'] = function(actionEval, availableTargets) {
         clarityModalService.openModal(
            actionEval,
            availableTargets,
            {
               objectId: availableTargets[0],
               title: i18nService.getString('FolderUi', 'actionCreateFolderLabel')
            },
            'folder-ui/resources/folder/views/folder/addFolder.html'
         );
      };

      h5.actions['vsphere.core.vcenter.actions.removeFolder'] = function(actionEval, availableTargets) {
         clarityModalService.openModal(
            actionEval,
            availableTargets,
            null,
            'folder-ui/resources/folder/views/folder/removeFolder.html'
         );
      };

      /*
       * Action 'Assign License' for a vc.
       */
      h5.actions["vsphere.core.vc.assignLicenseKeyAction"] = function(actionEval, availableTargets) {
         if (_.isEmpty(availableTargets)) {
            return;
         }

         assignLicenseService.showAssignLicenseForm(availableTargets);
      };

      h5.actions["vsphere.core.folder.exportLogsAction"] = function(actionEval, availableTargets) {
         if (_.isEmpty(availableTargets)) {
            return;
         }
         vscExportWizardLauncherService.showSystemLogExportDialog(availableTargets);
      };

      h5.actions["vsphere.core.folder.actions.moveFolder"] =
         function (actionEval, availableTargets, destinationTarget) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            moveFolderService.openMoveToDialog(availableTargets);
         };

      h5.actions["vsphere.core.network.actions.moveNetworkToDropTarget"] =
         function (actionEval, availableTargets, destinationTarget) {
            if (!availableTargets || !availableTargets.length || !destinationTarget) {
               return;
            }

            moveFolderService.move(availableTargets, destinationTarget.dropTarget);
         };

      h5.actions["vsphere.core.datacenter.actions.move"] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            moveFolderService.openMoveToDialog(availableTargets);
         };

      h5.actions['vsphere.core.datacenter.actions.editDefaultHwVersionAction'] =
         function (actionEval, availableTargets) {
            var modalOptions = {
               title: i18nService.getString('HostUi', 'defaultVmCompatibilityDialog.title'),
               subTitle: {
                  objectId: availableTargets[0]
               },
               defaultButton: 'submit',
               contentTemplate: 'host-ui/resources/host/views/settings/EditDefaultVmCompatibility.html',
               dialogData: {
                  availableTargets: availableTargets
               }
            };

            clarityModalService.openOkCancelModal(modalOptions);
         };

      h5.actions["vsphere.core.datacenter.actions.dragAndDropToFolder"] =
         function (actionEval, availableTargets, destinationTarget) {
            if (!availableTargets || !availableTargets.length || !destinationTarget) {
               return;
            }

            moveFolderService.move(availableTargets, destinationTarget.dropTarget);
         };
   }]
);

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var folder_ui;
(function (folder_ui) {
    var ManagedEntityMoveSpec = com.vmware.vsphere.client.mixed.ManagedEntityMoveSpec;
    var MoveFolderService = (function () {
        function MoveFolderService(clarityModalService, i18nService, mutationService, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        MoveFolderService.prototype.openMoveToDialog = function (availableTargets) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("FolderUi", "moveto.dialog.title"),
                defaultButton: "submit",
                dialogData: {
                    objectIds: availableTargets
                },
                contentTemplate: "folder-ui/resources/folder/views/folder/move/moveFolderDialog.html"
            };
            if (availableTargets.length === 1) {
                modalOptions.subTitle = {
                    objectId: availableTargets[0]
                };
            }
            modalOptions.onSubmit = function () {
                _this.move(modalOptions.dialogData.objectIds, modalOptions.dialogData.targetEntity);
                return true;
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        MoveFolderService.prototype.move = function (folderIds, targetEntity) {
            var _this = this;
            var folderMors = folderIds.map(function (folderId) {
                return _this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            });
            var moveSpec = new ManagedEntityMoveSpec();
            moveSpec.entities = folderMors;
            this.mutationService.apply(targetEntity, moveSpec._type, moveSpec).then(function () { });
        };
        MoveFolderService.$inject = [
            "clarityModalService",
            "i18nService",
            "mutationService",
            "defaultUriSchemeUtil"
        ];
        return MoveFolderService;
    }());
    folder_ui.MoveFolderService = MoveFolderService;
    angular.module("com.vmware.vsphere.client.folder")
        .service("moveFolderService", MoveFolderService);
})(folder_ui || (folder_ui = {}));



(function() {
   angular.module('com.vmware.vsphere.client.folder')
      .controller('addDatacenterController', addDatacenterController);

   addDatacenterController.$inject = ['$scope', 'datacenterService', 'dataService'];

   function addDatacenterController($scope, datacenterService, dataService) {
      var self = this;

      self.loading = true;
      $scope.modalOptions.submitDisabled=true;
      self.moRef = $scope.modalOptions.dialogData.objectId;
      self.icon = $scope.modalOptions.iconClass;

      $scope.modalOptions.onSubmit = createDatacenter;

      dataService.getProperties(self.moRef , ['name', 'primaryIconId', 'newUniqueDatacenterName']).then(function(data) {
         self.name = data.newUniqueDatacenterName;
         self.location = data.name;
         self.parentIconClass = data.primaryIconId;
         self.loading = false;
         $scope.modalOptions.submitDisabled=false;
      });

      function createDatacenter() {
         datacenterService.createDatacenter(self.name, self.moRef);
         $scope.closeModal();

      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Datacenter service
 */
angular
   .module('com.vmware.vsphere.client.folder')
   .service('datacenterService', datacenterService);

datacenterService.$inject = ['mutationService', 'defaultUriSchemeUtil'];

function datacenterService(mutationService, defaultUriSchemeUtil) {
   var MUTATION_ADD_DATACENTER_SPEC = 'com.vmware.vsphere.client.datacenter.DatacenterInfo';
   this.createDatacenter = function(name, moRef) {
      var datacenterCreationSpec = {
         name: name,
         parent: defaultUriSchemeUtil.getManagedObjectReference(moRef)
      };
      mutationService.add(MUTATION_ADD_DATACENTER_SPEC, datacenterCreationSpec);
   };
}

(function() {
   angular.module('com.vmware.vsphere.client.folder').controller('addFolderController', addFolderController);

   addFolderController.$inject = ['$scope', 'folderService', 'i18nService'];

   function addFolderController($scope, folderService, i18nService) {
      var self = this;
      self.name = '';
      self.moRef = $scope.modalOptions.dialogData.objectId;
      self.FOLDER_MAX_LENGTH = 80;
      this.$onInit = function () {
         self.i18n = i18nService.getString;
      };
      self.closeModal = function() {
         $scope.closeModal();
      };

      self.createFolder = function() {
         self.compatibilityMessage = validateFolderName();

         if(self.compatibilityMessage === null) {
            var folderType = getFolderType();
            if (folderType) {
               folderService.createFolder(self.name, self.moRef, folderType);
            } else {
               folderService.createFolder(self.name, self.moRef);
            }
            $scope.closeModal();
         }
      };

      function getFolderType() {
         var actionUid = $scope.modalOptions.actionEval.action.uid;
         var folderType;

         if (/Vm/.test(actionUid)) {
            folderType = 'VirtualMachineFolder';
         } else if(/Host/.test(actionUid)) {
            folderType = 'HostFolder';
         } else if(/Storage/.test(actionUid)) {
            folderType = 'DatastoreFolder';
         } else if(/Network/.test(actionUid)) {
            folderType = 'NetworkFolder';
         }

         return folderType;
      }

      function validateFolderName() {
         var hasValidLength = self.name.length <= self.FOLDER_MAX_LENGTH;
         if (!hasValidLength) {
            return self.i18n('VmUi',
               'NameValidator.nameTooLongSpecialChars');
         }
         return null;
      }

   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Datacenter service
 */
angular
   .module('com.vmware.vsphere.client.folder')
   .service('folderService', folderService);

folderService.$inject = ['mutationService', 'defaultUriSchemeUtil'];

function folderService (mutationService, defaultUriSchemeUtil) {
   var MUTATION_ADD_FOLDER_SPEC = 'com.vmware.vsphere.client.folder.FolderInfo';
   var MUTATION_REMOVE_FOLDER_SPEC = 'com.vmware.vsphere.client.folder.FolderRemovalSpec';

   this.createFolder = function(name, moRef, folderType) {
      var folderCreationSpec = {
         name: name,
         parent: defaultUriSchemeUtil.getManagedObjectReference(moRef),
         folderType: folderType
      };
      mutationService.add(MUTATION_ADD_FOLDER_SPEC, folderCreationSpec);
   };

   this.removeFolder = function(objectId) {
      //deleteFromDisk is changed from true to false, this was removing vm from disks too. this fix is for bug 2265349
      var folderRemovalSpec = {
         deleteFromDisk: false
      };
      mutationService.remove(objectId, MUTATION_REMOVE_FOLDER_SPEC, folderRemovalSpec);
   };
}

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var folder_ui;
(function (folder_ui) {
    var MoveFolderComponent = (function () {
        function MoveFolderComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = MoveFolderComponentController;
            this.templateUrl =
                "folder-ui/resources/folder/views/folder/move/moveFolderComponentTemplate.html";
        }
        return MoveFolderComponent;
    }());
    folder_ui.MoveFolderComponent = MoveFolderComponent;
    var MoveFolderComponentController = (function () {
        function MoveFolderComponentController(defaultUriSchemeUtil, managedEntityConstants) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.isDatacenterFolder = false;
            this.isNetworkFolder = false;
            this.isHostFolder = false;
            this.isVmFolder = false;
            this.isDatastoreFolder = false;
        }
        MoveFolderComponentController.prototype.$onInit = function () {
            var _this = this;
            this.folderId = this.getFolderId();
            this.updateFolderType();
            this.onLocationSelected = function (objectReference) {
                _this.model.targetEntity = objectReference;
            };
        };
        MoveFolderComponentController.prototype.updateFolderType = function () {
            if (this.isDcFolder(this.folderId)) {
                this.isDatacenterFolder = true;
            }
            else if (this.folderId.indexOf(MoveFolderComponentController.VM_FOLDER_VALUE) > 0) {
                this.isVmFolder = true;
            }
            else if (this.folderId.indexOf(MoveFolderComponentController.NETWORK_FOLDER_VALUE) > 0) {
                this.isNetworkFolder = true;
            }
            else if (this.folderId.indexOf(MoveFolderComponentController.HOST_FOLDER_VALUE) > 0) {
                this.isHostFolder = true;
            }
            else if (this.folderId.indexOf(MoveFolderComponentController.DATASTORE_FOLDER_VALUE) > 0) {
                this.isDatastoreFolder = true;
            }
        };
        MoveFolderComponentController.prototype.getFolderId = function () {
            // Assume that if there are 1+ objects of the same type
            // (folders of the same type or datacenters)
            // The move operation should not be available otherwise.
            var objId = this.model.objectIds[0];
            var objRef = this.defaultUriSchemeUtil.getManagedObjectReference(objId);
            if (objRef.type === this.managedEntityConstants.FOLDER
                && !this.isDcFolder(objId)) {
                return objId;
            }
            // For datacenters and datacenter folder the folderId should point to the root
            return this.defaultUriSchemeUtil.getRootFolder(objRef.serverGuid);
        };
        MoveFolderComponentController.prototype.isDcFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            return folderRef.value
                .indexOf(MoveFolderComponentController.DATACENTER_FOLDER_VALUE) === 0;
        };
        MoveFolderComponentController.$inject = ["defaultUriSchemeUtil", "managedEntityConstants"];
        MoveFolderComponentController.DATACENTER_FOLDER_VALUE = "group-d";
        MoveFolderComponentController.VM_FOLDER_VALUE = "group-v";
        MoveFolderComponentController.NETWORK_FOLDER_VALUE = "group-n";
        MoveFolderComponentController.HOST_FOLDER_VALUE = "group-h";
        MoveFolderComponentController.DATASTORE_FOLDER_VALUE = "group-s";
        return MoveFolderComponentController;
    }());
    angular.module("com.vmware.vsphere.client.folder")
        .component("moveFolderComponent", new MoveFolderComponent());
})(folder_ui || (folder_ui = {}));



(function() {
   angular.module('com.vmware.vsphere.client.folder').controller('removeFolderController', removeFolderController);

   removeFolderController.$inject = ['folderService', '$scope'];

   function removeFolderController (folderService, $scope) {
      var self = this;
      var objectId = $scope.modalOptions.availableTargets[0];
      self.closeModal = function() {
         $scope.closeModal();
      };

      self.removeFolder = function() {
         folderService.removeFolder(objectId);
         $scope.closeModal();
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.folder').controller('VcAdvancedSettingsController', VcAdvancedSettingsController);

   VcAdvancedSettingsController.$inject = ['$scope', 'i18nService'];

   function VcAdvancedSettingsController($scope, i18nService) {
      var self = this;
      var objectId = $scope._route.objectId;

      var headerOptions = {
            title: i18nService.getString('FolderUi', 'advancedSettings.view.title'),
            actions: [],
            objectId: objectId
      };
      var settingsViewOptions = {
            propertyName: 'vcServerSettings.advancedSettings',
            objectId: objectId
      };

      self.headerOptions = headerOptions;
      self.settingsViewOptions = settingsViewOptions;
   }
})();

(function() {
  'use strict';
  angular.module('com.vmware.vsphere.client.folder')
    .controller('VchaPortletController', VchaPortletController);

  VchaPortletController.$inject = ['$scope', 'i18nService'];

  function VchaPortletController($scope, i18nService) {
    $scope.portlet.footerLinks = [{
      label: i18nService.getString('FolderUi', 'vcha.portlet.footer.settings'),
      onClick: function () {
        $scope._navigate('vsphere.core.folder.manage.settings.vchaView', $scope._route.objectId);
      },
      enabled: true
    }];
  }
}());


/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var spbm_ui;
(function (spbm_ui) {
    h5 = h5 || {};
    h5.spbm = {
        angularModule: angular.module('com.vmware.vsphere.client.spbm', ['ngCookies'])
    };
    angular.module('com.vmware.vsphere.client.spbm')
        .run(['columnRenderersRegistry', 'i18nService',
        function (columnRenderersRegistry, i18nService) {
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * Vcenter name column - icon-text renderer.
                 *
                 * @param  {array} props Array of property names, where 1st property is
                 *    vcenter name. Other properties are ignored.
                 * @param  {object} data  Map of values, contains the specificType.
                 */
                'storage-policy-vc-name': function (props, data) {
                    var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('icon-text');
                    return iconTextRenderer(['vcIcon', 'vcName'], {
                        vcIcon: 'vsphere-icon-vcenter',
                        vcName: data[props[0]]
                    });
                }
            });
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * Text renderer that localizes lineOfService values.
                 *
                 * @param  {array} props Array of property names, where 1st property is
                 *    lineOfService name. Other properties are ignored.
                 * @param  {object} data  Map of values, contains the unlocalized
                 *    lineOfService value.
                 */
                "spbm-localized-line-of-service": function (props, data) {
                    var localizedLineOfService = "";
                    if (data[props[0]]) {
                        var resourceKey = "lineOfService." + data[props[0]];
                        localizedLineOfService = i18nService.getString("SpbmUi", resourceKey);
                        // If resource key is not localized, return the raw lineOfService value
                        if (!localizedLineOfService || localizedLineOfService === resourceKey) {
                            localizedLineOfService = data[props[0]];
                        }
                    }
                    var textRenderer = columnRenderersRegistry.getColumnRenderer("text");
                    return textRenderer(["localizedLineOfService"], { localizedLineOfService: localizedLineOfService });
                }
            });
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * VM policies compliance status column - icon-text renderer.
                 *
                 * @param  {array} props Array of property names, where 1st property is
                 *    compliance status.
                 * @param  {object} data  Map of values, contains the specificType.
                 */
                'storage-policy-compliance-status': function (props, data) {
                    var complianceStatus = data[props[0]];
                    var iconClass = "";
                    var complianceStatusKey = "";
                    switch (complianceStatus) {
                        case 'compliant':
                            complianceStatusKey = "complianceStatus.compliant";
                            iconClass = 'vsphere-icon-status-ok';
                            break;
                        case 'nonCompliant':
                            complianceStatusKey = "complianceStatus.nonCompliant";
                            iconClass = 'vsphere-icon-status-error';
                            break;
                        case 'outOfDate':
                            complianceStatusKey = "complianceStatus.outOfDate";
                            iconClass = 'vsphere-icon-status-error';
                            break;
                        case 'unknown':
                            complianceStatusKey = "complianceStatus.unknown";
                            iconClass = 'vui-icon-datagrid-status-unknown';
                            break;
                        case 'notApplicable':
                            complianceStatusKey = "complianceStatus.notApplicable";
                            iconClass = 'vui-icon-datagrid-status-notApplicable';
                            break;
                    }
                    var label = complianceStatusKey === "" ? complianceStatusKey
                        : i18nService.getString("SpbmUi", complianceStatusKey);
                    var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('icon-text');
                    return iconTextRenderer(["complianceStatusIcon", "complianceStatusText"], {
                        complianceStatusIcon: iconClass,
                        complianceStatusText: label
                    });
                }
            });
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * VM name column - renders VM name as link to the Manage > Profiles view.
                 */
                "spbm-compliance-vm-name": function (props, data) {
                    var objectNameRenderer = columnRenderersRegistry.getColumnRenderer('object-name');
                    var config = {
                        navigatable: true,
                        extensionName: "vsphere.core.vm.manage.settings.spbmPolicies"
                    };
                    return objectNameRenderer(props, data, config);
                }
            });
        }])
        .run(['checkVmRollupComplianceService', 'i18nService',
        function (checkVmRollupComplianceService, i18nService) {
            h5.actions['vsphere.core.vm.actions.checkVmRollupComplianceAction'] =
                function (actionEval, availableTargets) {
                    if (!availableTargets || !availableTargets.length) {
                        return;
                    }
                    checkVmRollupComplianceService.invokeAction(availableTargets);
                };
        }])
        .run(["spbmManageVmStorageProfilesActionService",
        function (spbmManageVmStorageProfilesActionService) {
            h5.actions["vsphere.core.pbm.storage.manageVmStorageProfilesAction"] =
                function (actionEval, availableTargets) {
                    if (!availableTargets || !availableTargets.length) {
                        return;
                    }
                    spbmManageVmStorageProfilesActionService.openDialog(availableTargets);
                };
        }])
        .run(['spbmReapplyStoragePolicyActionService',
        function (spbmReapplyStoragePolicyActionService) {
            h5.actions["vsphere.core.pbm.storage.reapplyProfileForVms"] =
                function (actionEval, availableTargets) {
                    if (!availableTargets || !availableTargets.length) {
                        return;
                    }
                    spbmReapplyStoragePolicyActionService.openDialogForVm(availableTargets);
                };
        }])
        .run(['spbmReapplyStoragePolicyActionService',
        function (spbmReapplyStoragePolicyActionService) {
            h5.actions["vsphere.core.pbm.storage.reapplyProfile"] =
                function (actionEval, availableTargets, context) {
                    if (!availableTargets || !availableTargets.length || !context || !context.length) {
                        return;
                    }
                    spbmReapplyStoragePolicyActionService.openDialogForProfile(context[0]);
                };
        }])
        .run(['drpEditPolicyModalService', function (drpEditPolicyModalService) {
            h5.actions["vsphere.core.datastore.drp.edit"] =
                function (actionEval, availableTargets) {
                    if (!availableTargets || !availableTargets.length) {
                        return;
                    }
                    drpEditPolicyModalService.openModal(availableTargets[0]);
                };
        }])
        .run(['spbmFcdProfileService', function (spbmFcdProfileService) {
            h5.actions["vsphere.core.datastore.fcdNamespaceProfile.edit"] = function (actionEval, availableTargets) {
                if (!availableTargets || !availableTargets.length) {
                    return;
                }
                spbmFcdProfileService.updateFcdNamespaceProfile(availableTargets[0]);
            };
        }])
        .run(['spbmProfileCheckComplianceActionService',
        function (spbmProfileCheckComplianceActionService) {
            h5.actions["vsphere.core.pbm.storage.checkProfileComplianceActionPrivate"] =
                function (actionEval, availableTargets, context) {
                    if (!context || !context.length) {
                        return;
                    }
                    spbmProfileCheckComplianceActionService.checkProfilesCompliance(context);
                };
        }])
        .run(['spbmRemoveProfileActionService', function (spbmRemoveProfileActionService) {
            h5.actions["vsphere.core.pbm.storage.removeProfileAction"] =
                function (actionEval, availableTargets, context) {
                    if (!context || !context.length) {
                        return;
                    }
                    spbmRemoveProfileActionService.removeStoragePolicies(context);
                };
        }])
        .run(['spbmCreateProfileActionService', function (spbmCreateProfileActionService) {
            h5.actions["vsphere.core.pbm.storage.createStorageProfileAction"] =
                function (actionEval, availableTargets, context) {
                    spbmCreateProfileActionService.createProfile();
                };
            h5.actions["vsphere.core.pbm.storage.editProfileAction"] =
                function (actionEval, availableTargets, context) {
                    if (!context) {
                        return;
                    }
                    spbmCreateProfileActionService.editProfile(context);
                };
            h5.actions["vsphere.core.pbm.storage.cloneProfileAction"] =
                function (actionEval, availableTargets, context) {
                    if (!context) {
                        return;
                    }
                    spbmCreateProfileActionService.cloneProfile(context);
                };
        }])
        .run(['spbmDspActionService', function (spbmDspActionService) {
            h5.actions["vsphere.core.pbm.storage.createDspAction"] =
                function (actionEval, availableTargets, context) {
                    spbmDspActionService.createProfile();
                };
            h5.actions["vsphere.core.pbm.storage.editDspAction"] =
                function (actionEval, availableTargets, context) {
                    if (context && context.length === 1) {
                        spbmDspActionService.editProfile(context[0]);
                    }
                };
            h5.actions["vsphere.core.pbm.storage.cloneDspAction"] =
                function (actionEval, availableTargets, context) {
                    if (context && context.length === 1) {
                        spbmDspActionService.cloneProfile(context[0]);
                    }
                };
            h5.actions["vsphere.core.pbm.storage.removeDspAction"] =
                function (actionEval, availableTargets, context) {
                    spbmDspActionService.removeProfiles(context);
                };
        }])
        .run(['spbmResetDefaultVsanProfileActionService',
        function (spbmResetDefaultVsanProfileActionService) {
            h5.actions["vsphere.core.pbm.storage.resetVsanDefaultProfileAction"] =
                function (actionEval, availableTargets, context) {
                    if (!context) {
                        return;
                    }
                    spbmResetDefaultVsanProfileActionService.resetDefaultVsanProfile(context);
                };
        }]);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var CapabilityProfilesCapacityPortletViewController = (function () {
        function CapabilityProfilesCapacityPortletViewController(navigation) {
            this.navigation = navigation;
            this.datastoreId = this.navigation.getRoute().objectId;
        }
        CapabilityProfilesCapacityPortletViewController.$inject = ["navigation"];
        return CapabilityProfilesCapacityPortletViewController;
    }());
    spbm_ui.CapabilityProfilesCapacityPortletViewController = CapabilityProfilesCapacityPortletViewController;
    angular.module("com.vmware.vsphere.client.spbm").controller("CapabilityProfilesCapacityPortletViewController", CapabilityProfilesCapacityPortletViewController);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var DspViewController = (function () {
        function DspViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("SpbmUi", "h5.profile.details.rules"),
                        templateUrl: "spbm-ui/resources/spbm/views/profile/details/StorageProfileGeneralTab.html",
                        uid: "profile.generalTab"
                    },
                    {
                        name: this.i18nService.getString("SpbmUi", "dataservice.tabs.usedInTitle"),
                        templateUrl: "spbm-ui/resources/spbm/views/dsp/details/UsedInTab.html",
                        uid: "profile.usedInTab"
                    }
                ])
            };
        }
        DspViewController.$inject = ["i18nService", "$q"];
        return DspViewController;
    }());
    angular.module("com.vmware.vsphere.client.spbm")
        .controller("DspViewController", DspViewController);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var DspListViewController = (function () {
        function DspListViewController($scope, commonActionBarService, vuiConstants) {
            var _this = this;
            this.$scope = $scope;
            this.commonActionBarService = commonActionBarService;
            this.vuiConstants = vuiConstants;
            this.ACTION_BAR_ACTIONS = "actions";
            this.$scope.onSelectionChanged = function (newItems, oldItems) {
                if (newItems === oldItems) {
                    return;
                }
                _this.selectedProfiles = newItems;
                $scope.masterDetailsViewContext.selectedItems = newItems;
                _this.updateActionBar();
            };
            this.actionBarOptions = {
                actions: []
            };
            this.updateActionBar();
        }
        DspListViewController.prototype.updateActionBar = function () {
            var _this = this;
            if (this.actionBarOptions && this.actionBarOptions.actions && this.actionBarOptions.actions.length) {
                this.actionBarOptions.actions.forEach(function (action) {
                    if (action.actionId && action.actionId !== DspListViewController.CREATE_DSP_ACTION) {
                        action.enabled = false;
                    }
                });
            }
            var updateActionBarOptions = { actions: [] };
            this.commonActionBarService.updateActionBar(updateActionBarOptions, this.ACTION_BAR_ACTIONS, this.getProfilesIds(), this.getActions()).then(function () {
                _this.actionBarOptions = updateActionBarOptions;
            });
        };
        DspListViewController.prototype.getProfilesIds = function () {
            return _.pluck(this.selectedProfiles, "id");
        };
        DspListViewController.prototype.getActions = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: DspListViewController.CREATE_DSP_ACTION
            });
            actionDefs.push(this.vuiConstants.actions.SEPARATOR);
            actionDefs.push({
                actionId: DspListViewController.EDIT_DSP_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles &&
                        _this.selectedProfiles.length === 1 &&
                        actionDef && actionDef.available;
                }
            });
            actionDefs.push({
                actionId: DspListViewController.CLONE_DSP_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles &&
                        _this.selectedProfiles.length === 1 &&
                        actionDef && actionDef.available;
                }
            });
            actionDefs.push({
                actionId: DspListViewController.REMOVE_DSP_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles &&
                        _this.selectedProfiles.length &&
                        actionDef && actionDef.available;
                }
            });
            return actionDefs;
        };
        DspListViewController.CREATE_DSP_ACTION = "vsphere.core.pbm.storage.createDspAction";
        DspListViewController.REMOVE_DSP_ACTION = "vsphere.core.pbm.storage.removeDspAction";
        DspListViewController.EDIT_DSP_ACTION = "vsphere.core.pbm.storage.editDspAction";
        DspListViewController.CLONE_DSP_ACTION = "vsphere.core.pbm.storage.cloneDspAction";
        DspListViewController.$inject = ["$scope",
            "commonActionBarService",
            "vuiConstants"];
        return DspListViewController;
    }());
    spbm_ui.DspListViewController = DspListViewController;
    angular.module("com.vmware.vsphere.client.spbm")
        .controller("DspListViewController", DspListViewController);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmCreateProfileActionService = (function () {
        function SpbmCreateProfileActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmCreateProfileActionService.prototype, "vcsSpbmCreateProfileActionService", {
            get: function () {
                if (!this._vcsSpbmCreateProfileActionService) {
                    this._vcsSpbmCreateProfileActionService = this.$injector.get("vcsSpbmCreateProfileActionService");
                }
                return this._vcsSpbmCreateProfileActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmCreateProfileActionService.prototype.createProfile = function () {
            return this.vcsSpbmCreateProfileActionService.createProfile();
        };
        SpbmCreateProfileActionService.prototype.editProfile = function (profileId) {
            return this.vcsSpbmCreateProfileActionService.editProfile(profileId);
        };
        SpbmCreateProfileActionService.prototype.cloneProfile = function (profileId) {
            return this.vcsSpbmCreateProfileActionService.cloneProfile(profileId);
        };
        SpbmCreateProfileActionService.$inject = ['$injector'];
        return SpbmCreateProfileActionService;
    }());
    spbm_ui.SpbmCreateProfileActionService = SpbmCreateProfileActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmCreateProfileActionService", SpbmCreateProfileActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmDspActionService = (function () {
        function SpbmDspActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmDspActionService.prototype, "vcsSpbmDspActionService", {
            get: function () {
                if (!this._vcsSpbmDspActionService) {
                    this._vcsSpbmDspActionService = this.$injector.get("vcsSpbmDspActionService");
                }
                return this._vcsSpbmDspActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmDspActionService.prototype.createProfile = function () {
            this.vcsSpbmDspActionService.createProfile();
        };
        SpbmDspActionService.prototype.editProfile = function (profileId) {
            this.vcsSpbmDspActionService.editProfile(profileId);
        };
        SpbmDspActionService.prototype.cloneProfile = function (profileId) {
            this.vcsSpbmDspActionService.cloneProfile(profileId);
        };
        SpbmDspActionService.prototype.removeProfiles = function (profileIds) {
            this.vcsSpbmDspActionService.removeProfiles(profileIds);
        };
        SpbmDspActionService.$inject = ['$injector'];
        return SpbmDspActionService;
    }());
    spbm_ui.SpbmDspActionService = SpbmDspActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmDspActionService", SpbmDspActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmProfileCheckComplianceActionService = (function () {
        function SpbmProfileCheckComplianceActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmProfileCheckComplianceActionService.prototype, "vcSpbmProfileCheckComplianceActionService", {
            get: function () {
                if (!this._vcSpbmProfileCheckComplianceActionService) {
                    this._vcSpbmProfileCheckComplianceActionService = this.$injector.get('vcSpbmProfileCheckComplianceActionService');
                }
                return this._vcSpbmProfileCheckComplianceActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmProfileCheckComplianceActionService.prototype.checkProfilesCompliance = function (pbmProfiles) {
            return this.vcSpbmProfileCheckComplianceActionService.checkProfilesCompliance(pbmProfiles);
        };
        SpbmProfileCheckComplianceActionService.$inject = ['$injector'];
        return SpbmProfileCheckComplianceActionService;
    }());
    spbm_ui.SpbmProfileCheckComplianceActionService = SpbmProfileCheckComplianceActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmProfileCheckComplianceActionService", SpbmProfileCheckComplianceActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmRemoveProfileActionService = (function () {
        function SpbmRemoveProfileActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmRemoveProfileActionService.prototype, "vcSpbmRemoveProfileActionService", {
            get: function () {
                if (!this._vcSpbmRemoveProfileActionService) {
                    this._vcSpbmRemoveProfileActionService = this.$injector.get('vcSpbmRemoveProfileActionService');
                }
                return this._vcSpbmRemoveProfileActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmRemoveProfileActionService.prototype.removeStoragePolicies = function (storagePolicies) {
            return this.vcSpbmRemoveProfileActionService.removeStoragePolicies(storagePolicies);
        };
        SpbmRemoveProfileActionService.$inject = ['$injector'];
        return SpbmRemoveProfileActionService;
    }());
    spbm_ui.SpbmRemoveProfileActionService = SpbmRemoveProfileActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmRemoveProfileActionService", SpbmRemoveProfileActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmResetDefaultVsanProfileActionService = (function () {
        function SpbmResetDefaultVsanProfileActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmResetDefaultVsanProfileActionService.prototype, "vcSpbmResetDefaultVsanProfileActionService", {
            get: function () {
                if (!this._vcSpbmResetDefaultVsanProfileActionService) {
                    this._vcSpbmResetDefaultVsanProfileActionService = this.$injector.get('vcSpbmResetDefaultVsanProfileActionService');
                }
                return this._vcSpbmResetDefaultVsanProfileActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmResetDefaultVsanProfileActionService.prototype.resetDefaultVsanProfile = function (storagePolicy) {
            return this.vcSpbmResetDefaultVsanProfileActionService.resetDefaultVsanProfile(storagePolicy);
        };
        SpbmResetDefaultVsanProfileActionService.$inject = ['$injector'];
        return SpbmResetDefaultVsanProfileActionService;
    }());
    spbm_ui.SpbmResetDefaultVsanProfileActionService = SpbmResetDefaultVsanProfileActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmResetDefaultVsanProfileActionService", SpbmResetDefaultVsanProfileActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var AssignDrpSpec = com.vmware.vsphere.client.spbm.spec.AssignDrpSpec;
    var QueryDrpSpec = com.vmware.vsphere.client.common.spbm.spec.QueryDrpSpec;
    var DrpEditPolicyModalService = (function () {
        function DrpEditPolicyModalService(clarityModalService, i18nService, defaultUriSchemeUtil, dataService, clarityConstants, mutationService, $q) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.clarityConstants = clarityConstants;
            this.mutationService = mutationService;
            this.$q = $q;
            this.AVAILABLE_DRP_PROPERTY = "availableDefaultResourceProfiles";
            this.DEFAULT_PROFILE_PROPERTY = "datastore:defaultRequirementProfileName";
        }
        DrpEditPolicyModalService.prototype.openModal = function (datastoreRef) {
            var _this = this;
            var datastoreMor = this.defaultUriSchemeUtil.getManagedObjectReference(datastoreRef);
            var vcRef = this.defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(datastoreRef);
            var self = this;
            this.modalOptions = {
                title: this.i18nService.getString("SpbmUi", "h5.drp.defaultProfileDialog.title"),
                contentTemplate: "spbm-ui/resources/spbm/views/profile/edit/EditDefaultStoragePolicy.html",
                defaultButton: "submit",
                size: "lg",
                subTitle: {
                    objectId: datastoreRef
                },
                dialogData: {
                    policies: [],
                    selectedPolicy: null
                },
                onSubmit: function () {
                    if (!this.dialogData.selectedPolicy) {
                        this.alerts = [{
                                text: self.i18nService.getString("CommonUi", "objectSelectorDialog.noSelection"),
                                type: self.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    var spec = new AssignDrpSpec();
                    spec.datastores = [datastoreMor];
                    spec.defaultProfile = this.dialogData.selectedPolicy.profileId;
                    self.mutationService.apply(vcRef, spec._type, spec);
                    return true;
                },
                alerts: []
            };
            this.modalOptions.dialogData.isLoading = true;
            var profilesPromise = this.loadData(datastoreMor, vcRef);
            var currentProfilePromise = this.getCurrentProfile(datastoreRef);
            this.$q.all([profilesPromise, currentProfilePromise]).then(function (_a) {
                var profilesResponse = _a[0], currentProfileResponse = _a[1];
                var policies = profilesResponse[_this.AVAILABLE_DRP_PROPERTY];
                var selection = currentProfileResponse[_this.DEFAULT_PROFILE_PROPERTY][0];
                var item = _.find(policies, function (policy) { return policy.name === selection.value; });
                if (item) {
                    _this.modalOptions.dialogData.defaultSelectedPolicy = item;
                }
                _this.modalOptions.dialogData.isLoading = false;
                _this.modalOptions.dialogData.policies = policies;
            })
                .catch(function () {
                _this.modalOptions.dialogData.isLoading = false;
                _this.modalOptions.alerts = [{
                        text: _this.i18nService.getString("SpbmUi", "h5.drp.serviceUnavailable"),
                        type: _this.clarityConstants.notifications.type.ERROR
                    }];
                _this.modalOptions.dialogData.policies = [];
            });
            this.clarityModalService.openOkCancelModal(this.modalOptions);
        };
        DrpEditPolicyModalService.prototype.getCurrentProfile = function (dsRef) {
            return this.dataService.getProperties(dsRef, this.DEFAULT_PROFILE_PROPERTY);
        };
        DrpEditPolicyModalService.prototype.loadData = function (datastoreRef, vcRef) {
            var spec = new QueryDrpSpec();
            spec.datastores = [datastoreRef];
            var params = [{
                    propertyName: this.AVAILABLE_DRP_PROPERTY,
                    parameterType: spec._type,
                    parameter: spec
                }];
            return this.dataService.getProperties(vcRef, this.AVAILABLE_DRP_PROPERTY, {
                propertyParams: params
            });
        };
        DrpEditPolicyModalService.$inject = ["clarityModalService", "i18nService",
            "defaultUriSchemeUtil", "dataService", "clarityConstants",
            "mutationService", "$q"];
        return DrpEditPolicyModalService;
    }());
    spbm_ui.DrpEditPolicyModalService = DrpEditPolicyModalService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("drpEditPolicyModalService", DrpEditPolicyModalService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var EditDefaultStoragePolicyComponentController = (function () {
        function EditDefaultStoragePolicyComponentController(i18nService, dataService, vuiConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.preselectComparator = function (data) {
                return _this.defaultSelectedPolicy && data.name === _this.defaultSelectedPolicy.name;
            };
            this.initDatagrid();
            this.message = this.i18nService.getString("SpbmUi", "drp.defaultProfileDialog.infoSingle");
        }
        EditDefaultStoragePolicyComponentController.prototype.$onChanges = function () {
            if (this.policies && this.policies.length) {
                this.datagridOptions.data = this.policies;
            }
        };
        EditDefaultStoragePolicyComponentController.prototype.initDatagrid = function () {
            var _this = this;
            this.datagridOptions = {
                resizable: true,
                height: "100%",
                columnDefs: this.getColumnDefs(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.policies,
                onChange: function () {
                    _this.selectedPolicy = _this.datagridOptions.selectedItems[0];
                }
            };
        };
        EditDefaultStoragePolicyComponentController.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("SpbmUi", "drp.defaultProfileDialog.policyColumn"),
                    field: "name",
                    template: "#:name#"
                },
                {
                    displayName: this.i18nService.getString("SpbmUi", "drp.defaultProfileDialog.descriptionColumn"),
                    field: "description",
                    template: "#:description#"
                }
            ];
        };
        EditDefaultStoragePolicyComponentController.$inject = ["i18nService", "dataService", "vuiConstants"];
        return EditDefaultStoragePolicyComponentController;
    }());
    angular.module("com.vmware.vsphere.client.spbm").component("editDefaultStoragePolicyComponent", {
        controller: EditDefaultStoragePolicyComponentController,
        templateUrl: "spbm-ui/resources/spbm/views/profile/edit/EditDefaultStoragePolicyComponent.html",
        bindings: {
            policies: "<",
            defaultSelectedPolicy: "<",
            selectedPolicy: "=",
            isLoading: '<'
        }
    });
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmFcdProfileService = (function () {
        function SpbmFcdProfileService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmFcdProfileService.prototype, "vscSpbmFcdProfileActionService", {
            get: function () {
                if (!this._vsdSpbmFcdProfileService) {
                    this._vsdSpbmFcdProfileService = this.$injector.get("vscSpbmFcdProfileService");
                }
                return this._vsdSpbmFcdProfileService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmFcdProfileService.prototype.updateFcdNamespaceProfile = function (datastoreId) {
            return this.vscSpbmFcdProfileActionService.updateFcdNamespaceProfile(datastoreId);
        };
        SpbmFcdProfileService.$inject = ['$injector'];
        return SpbmFcdProfileService;
    }());
    spbm_ui.SpbmFcdProfileService = SpbmFcdProfileService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmFcdProfileService", SpbmFcdProfileService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var StorageProfilesListViewController = (function () {
        function StorageProfilesListViewController($scope, commonActionBarService, defaultUriSchemeUtil, dataService, vuiConstants, userSessionService) {
            var _this = this;
            this.$scope = $scope;
            this.commonActionBarService = commonActionBarService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.userSessionService = userSessionService;
            this.isCreateActionAvailable = false;
            this.GRANTED_PRIVILEGES = "grantedPrivileges";
            this.SPBM_UPDATE_PRIVILEGE = "StorageProfile.Update";
            this.STORAGE_PROFILE_VIEW_PRIVILEGE = "StorageProfile.View";
            this.CHECK_COMPLIANCE_ACTION = "vsphere.core.pbm.storage.checkProfileComplianceActionPrivate";
            this.REAPPLY_PROFILE_ACTION = "vsphere.core.pbm.storage.reapplyProfile";
            this.REMOVE_STORAGE_POLICY = "vsphere.core.pbm.storage.removeProfileAction";
            this.EDIT_STORAGE_POLICY = "vsphere.core.pbm.storage.editProfileAction";
            this.CLONE_STORAGE_POLICY = "vsphere.core.pbm.storage.cloneProfileAction";
            this.CREATE_PROFILE_ACTION = "vsphere.core.pbm.storage.createStorageProfileAction";
            this.REVERT_DEFAULT_VSAN_POLICY_ACTION = "vsphere.core.pbm.storage.resetVsanDefaultProfileAction";
            this.ACTION_BAR_ACTIONS = "actions";
            this.$scope.onSelectionChanged = function (newItems, oldItems) {
                $scope.masterDetailsViewContext.selectedItems = newItems;
                _this.selectedProfiles = newItems;
                _this.hasWritePrivilegeOnAllVcs = false;
                if (_this.selectedProfiles && _this.selectedProfiles.length) {
                    var currentDsRequest_1 = _this.lastDsRequest = _this.dataService.getPropertiesForObjects(_this.getDistinctVCs(), [_this.GRANTED_PRIVILEGES])
                        .then(function (privilegesOnVCs) {
                        if (currentDsRequest_1 === _this.lastDsRequest) {
                            _this.hasWritePrivilegeOnAllVcs = _.every(privilegesOnVCs, function (vcPrivileges) {
                                return _.contains(vcPrivileges.grantedPrivileges, _this.SPBM_UPDATE_PRIVILEGE);
                            });
                        }
                    })
                        .finally(function () {
                        if (currentDsRequest_1 === _this.lastDsRequest) {
                            _this.updateActionBar();
                        }
                    });
                }
                else {
                    _this.updateActionBar();
                }
            };
            this.actionBarOptions = {
                actions: []
            };
            this.getCreateActionAvailability();
            this.updateActionBar();
        }
        StorageProfilesListViewController.prototype.updateActionBar = function () {
            var _this = this;
            if (this.actionBarOptions && this.actionBarOptions.actions && this.actionBarOptions.actions.length) {
                this.actionBarOptions.actions.forEach(function (action) {
                    if (action.actionId && action.actionId !== _this.CREATE_PROFILE_ACTION) {
                        action.enabled = false;
                    }
                });
            }
            var updateActionBarOptions = { actions: [] };
            this.commonActionBarService.updateActionBar(updateActionBarOptions, this.ACTION_BAR_ACTIONS, this.getProfilesIds(), this.getActions()).then(function () {
                _this.actionBarOptions = updateActionBarOptions;
            });
        };
        StorageProfilesListViewController.prototype.getActions = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: this.CREATE_PROFILE_ACTION,
                isActionAvailable: function (actionDef) {
                    return _this.isCreateActionAvailable && actionDef;
                }
            });
            actionDefs.push(this.vuiConstants.actions.SEPARATOR);
            actionDefs.push({
                actionId: this.EDIT_STORAGE_POLICY,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds()[0];
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length === 1
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            }, {
                actionId: this.CLONE_STORAGE_POLICY,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds()[0];
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length === 1
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            }, {
                actionId: this.CHECK_COMPLIANCE_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            }, {
                actionId: this.REAPPLY_PROFILE_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            }, {
                actionId: this.REMOVE_STORAGE_POLICY,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds();
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            });
            actionDefs.push({
                actionId: this.REVERT_DEFAULT_VSAN_POLICY_ACTION,
                getActionInvocationContext: function () {
                    return _this.getProfilesIds()[0];
                },
                isActionVisible: function (actionDef) {
                    return _this.selectedProfiles && _this.selectedProfiles.length === 1
                        && actionDef && actionDef.available && _this.hasWritePrivilegeOnAllVcs;
                }
            });
            return actionDefs;
        };
        StorageProfilesListViewController.prototype.getDistinctVCs = function () {
            var _this = this;
            var vcGuids = _.map(this.selectedProfiles, function (profile) {
                // This method returns the URI segments in an array,
                // the third one being the VC guid
                return _this.defaultUriSchemeUtil.getUriIdSegments(profile.id)[2];
            });
            var vcMoRefs = _.map(vcGuids, function (vcGuid) {
                return _this.defaultUriSchemeUtil.getRootFolder(vcGuid);
            });
            return _.uniq(vcMoRefs);
        };
        StorageProfilesListViewController.prototype.getProfilesIds = function () {
            return _.pluck(this.selectedProfiles, "id");
        };
        StorageProfilesListViewController.prototype.getCreateActionAvailability = function () {
            var _this = this;
            this.isCreateActionAvailable = false;
            this.getServersInfo().then(function (result) {
                if (result.length) {
                    var vcMoRefs = _.map(result, function (info) {
                        return _this.defaultUriSchemeUtil.getRootFolder(info.serviceGuid);
                    });
                    _this.dataService.getPropertiesForObjects(vcMoRefs, [_this.GRANTED_PRIVILEGES])
                        .then(function (privilegesOnVCs) {
                        _this.isCreateActionAvailable = _.some(privilegesOnVCs, function (vcPrivileges) {
                            return _.contains(vcPrivileges.grantedPrivileges, _this.SPBM_UPDATE_PRIVILEGE) &&
                                _.contains(vcPrivileges.grantedPrivileges, _this.STORAGE_PROFILE_VIEW_PRIVILEGE);
                        });
                        _this.updateActionBar();
                    });
                }
                else {
                    _this.updateActionBar();
                }
            });
        };
        StorageProfilesListViewController.prototype.getServersInfo = function () {
            var _this = this;
            return this.userSessionService.getAllServersInfo().then(function (info) {
                var serversInfo = [];
                if (info && info.serversInfo) {
                    info.serversInfo.forEach(function (serverInfo) {
                        if (!serverInfo.errorCode ||
                            serverInfo.errorCode === _this.userSessionService.VC_NO_ERROR_CODE) {
                            serversInfo.push(serverInfo);
                        }
                    });
                }
                return serversInfo;
            });
        };
        StorageProfilesListViewController.$inject = ["$scope", "commonActionBarService",
            "defaultUriSchemeUtil", "dataService", "vuiConstants", "userSessionService"];
        return StorageProfilesListViewController;
    }());
    spbm_ui.StorageProfilesListViewController = StorageProfilesListViewController;
    angular.module("com.vmware.vsphere.client.spbm")
        .controller("StorageProfilesListViewController", StorageProfilesListViewController);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var StorageProfilesViewController = (function () {
        function StorageProfilesViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("SpbmUi", "h5.profile.details.rules"),
                        templateUrl: "spbm-ui/resources/spbm/views/profile/details/StorageProfileGeneralTab.html",
                        uid: "profile.generalTab"
                    },
                    {
                        name: this.i18nService.getString("SpbmUi", "h5.profile.details.vmCompliance"),
                        templateUrl: "spbm-ui/resources/spbm/views/profile/details/VmComplianceTab.html",
                        uid: "profile.vmComplianceTab"
                    },
                    {
                        name: this.i18nService.getString("Common", "typeResource.vmTemplate"),
                        templateUrl: "spbm-ui/resources/spbm/views/profile/details/VmTemplatesTab.html",
                        uid: "profile.vmTemplatesTab"
                    },
                    {
                        name: this.i18nService.getString("SpbmUi", "h5.profile.details.storageCompatibility"),
                        templateUrl: "spbm-ui/resources/spbm/views/profile/details/StorageCompatibilityTab.html",
                        uid: "profile.storageCompatibilityTab"
                    }
                ])
            };
        }
        StorageProfilesViewController.$inject = ["i18nService", "$q"];
        return StorageProfilesViewController;
    }());
    angular.module("com.vmware.vsphere.client.spbm")
        .controller("StorageProfilesViewController", StorageProfilesViewController);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmManageVmStorageProfilesActionService = (function () {
        function SpbmManageVmStorageProfilesActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmManageVmStorageProfilesActionService.prototype, "vscSpbmManageVmStorageProfilesActionService", {
            get: function () {
                if (!this._vscSpbmManageVmStorageProfilesActionService) {
                    this._vscSpbmManageVmStorageProfilesActionService =
                        this.$injector.get('vscSpbmManageVmStorageProfilesModalService');
                }
                return this._vscSpbmManageVmStorageProfilesActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmManageVmStorageProfilesActionService.prototype.openDialog = function (vmIds) {
            this.vscSpbmManageVmStorageProfilesActionService.openDialog(vmIds);
        };
        SpbmManageVmStorageProfilesActionService.$inject = ['$injector'];
        return SpbmManageVmStorageProfilesActionService;
    }());
    spbm_ui.SpbmManageVmStorageProfilesActionService = SpbmManageVmStorageProfilesActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmManageVmStorageProfilesActionService", SpbmManageVmStorageProfilesActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var SpbmReapplyStoragePolicyActionService = (function () {
        function SpbmReapplyStoragePolicyActionService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SpbmReapplyStoragePolicyActionService.prototype, "vcSpbmReapplyStoragePolicyActionService", {
            get: function () {
                if (!this._vcSpbmReapplyStoragePolicyActionService) {
                    this._vcSpbmReapplyStoragePolicyActionService = this.$injector.get('vcReapplyVmStoragePolicyService');
                }
                return this._vcSpbmReapplyStoragePolicyActionService;
            },
            enumerable: true,
            configurable: true
        });
        SpbmReapplyStoragePolicyActionService.prototype.openDialogForVm = function (vms) {
            this.vcSpbmReapplyStoragePolicyActionService.openDialogForVm(vms);
        };
        SpbmReapplyStoragePolicyActionService.prototype.openDialogForProfile = function (profile) {
            this.vcSpbmReapplyStoragePolicyActionService.openDialogForProfile(profile);
        };
        SpbmReapplyStoragePolicyActionService.$inject = ['$injector'];
        return SpbmReapplyStoragePolicyActionService;
    }());
    spbm_ui.SpbmReapplyStoragePolicyActionService = SpbmReapplyStoragePolicyActionService;
    angular.module("com.vmware.vsphere.client.spbm")
        .service("spbmReapplyStoragePolicyActionService", SpbmReapplyStoragePolicyActionService);
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var CheckVmRollupComplianceService = (function () {
        function CheckVmRollupComplianceService(i18nService, mutationService, dataService, clarityModalService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
        }
        CheckVmRollupComplianceService.prototype.invokeAction = function (vms) {
            var _this = this;
            if (vms.length > 1) {
                this.makeMutationCall(vms);
                return;
            }
            var outdatedProfilesProperty = "areVmProfilesOutdated";
            this.dataService.getProperties(vms[0], [outdatedProfilesProperty]).then(function (response) {
                if (response[outdatedProfilesProperty]) {
                    _this.showWarning();
                }
                else {
                    _this.makeMutationCall(vms);
                }
            });
        };
        CheckVmRollupComplianceService.prototype.showWarning = function () {
            var modalOptions = {
                title: this.i18nService.getString("SpbmUi", "checkCompliance.warning.title"),
                hideCancelButton: true,
                message: this.i18nService.getString("SpbmUi", "checkCompliance.warning.text"),
                icon: "icon-warning-32",
                submit: function () { return true; },
                preserveNewlines: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        CheckVmRollupComplianceService.prototype.makeMutationCall = function (vms) {
            var spec = {
                _type: 'com.vmware.vsphere.client.spbm.spec.CheckVmRollupComplianceSpec'
            };
            this.mutationService.applyOnMultiEntity(vms, spec._type, spec, this.i18nService.getString('SpbmUi', 'checkVmRollupComplianceAction.label'));
        };
        CheckVmRollupComplianceService.$inject = ["i18nService", "mutationService", "dataService", "clarityModalService"];
        return CheckVmRollupComplianceService;
    }());
    spbm_ui.CheckVmRollupComplianceService = CheckVmRollupComplianceService;
    angular.module("com.vmware.vsphere.client.spbm").
        service("checkVmRollupComplianceService", CheckVmRollupComplianceService);
})(spbm_ui || (spbm_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var spbm_ui;
(function (spbm_ui) {
    angular.module("com.vmware.vsphere.client.spbm").constant("VmStoragePoliciesConstants", {
        device: {
            type: {
                VM_HOME: "vmHome",
                VM_DISK: "vmDisk"
            }
        }
    });
})(spbm_ui || (spbm_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var spbm_ui;
(function (spbm_ui) {
    var VmStoragePoliciesListController = (function () {
        function VmStoragePoliciesListController(i18nService, vuiConstants, columnRenderersRegistry, timeFormatterService, $q, datagridActionBarService, listUtil, VmStoragePoliciesConstants, $scope) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.timeFormatterService = timeFormatterService;
            this.$q = $q;
            this.datagridActionBarService = datagridActionBarService;
            this.listUtil = listUtil;
            this.VmStoragePoliciesConstants = VmStoragePoliciesConstants;
            this.$scope = $scope;
            this.preselectComparator = function (gridDataItem) {
                if (_this.itemToSelect) {
                    return _this.itemToSelect.name === gridDataItem.name;
                }
                return false;
            };
            this.updateActionBar = function () {
                return _this.datagridActionBarService.updateActionBar(_this.datagridOptions, [_this.vmId], [
                    {
                        actionId: _this.ACTIONS.CHECK_VM_COMPLIANCE
                    },
                    {
                        actionId: _this.ACTIONS.REAPPLY_VM_STORAGE_POLICY
                    },
                ]);
            };
            this.i18n = i18nService.getString;
            this.ACTIONS = {
                CHECK_VM_COMPLIANCE: 'vsphere.core.vm.actions.checkVmRollupComplianceAction',
                REAPPLY_VM_STORAGE_POLICY: 'vsphere.core.pbm.storage.reapplyProfileForVms'
            };
        }
        VmStoragePoliciesListController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                resizable: true,
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (_this.masterDetailsViewContext) {
                        _this.masterDetailsViewContext.selectedItems = newValue;
                    }
                }
            });
        };
        VmStoragePoliciesListController.prototype.$onChanges = function () {
            var _this = this;
            if (this.policyAssignments) {
                var lastCheckedTimeFormatPromises_1 = [];
                _.forEach(this.policyAssignments, function (policyAssignment) {
                    var lastChecked = policyAssignment.lastChecked ? policyAssignment.lastChecked : "";
                    lastCheckedTimeFormatPromises_1.push(_this.timeFormatterService.formatDate(lastChecked));
                    policyAssignment._complianceFailures = policyAssignment.complianceFailures;
                    var complianceItem = _this.formatComplianceItem(policyAssignment.complianceStatus);
                    policyAssignment.complianceStatus = complianceItem.complianceStatusText;
                    policyAssignment.complianceStatusIcon = complianceItem.complianceStatusIcon;
                });
                this.$q.all(lastCheckedTimeFormatPromises_1).then(function (result) {
                    _.forEach(result, function (formatedDate, formatteDateIndex) {
                        _this.policyAssignments[formatteDateIndex].formatedDate = formatedDate;
                    });
                    if (_this.masterDetailsViewContext && _this.masterDetailsViewContext.selectedItems &&
                        _this.masterDetailsViewContext.selectedItems.length === 1) {
                        _this.itemToSelect = _this.masterDetailsViewContext.selectedItems[0];
                    }
                    else {
                        _this.itemToSelect = null;
                    }
                    _this.datagridOptions.data = _this.policyAssignments;
                    _this.updateActionBar();
                });
            }
        };
        VmStoragePoliciesListController.prototype.getColumnDefinitions = function () {
            var _this = this;
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var storagePolicyComplianceStatus = this.columnRenderersRegistry.getColumnRenderer('storage-policy-compliance-status');
            var compareNumericValues = this.listUtil.compareNumericValues;
            return [
                {
                    displayName: this.i18nService.getString("SpbmUi", "nameColumnHeader"),
                    field: "name",
                    template: function (item) {
                        var iconClass = item.type === _this.VmStoragePoliciesConstants.device.type.VM_HOME
                            ? "vx-icon-virtualMachineFolder" : "vx-icon-vmDisk";
                        var profileItem = {
                            name: item.name,
                            icon: iconClass
                        };
                        return iconTextRenderer(["icon", "name"], profileItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("SpbmUi", "manageVmReplicationGroupsForm.profileColumn"),
                    field: "storagePolicy",
                    template: function (item) {
                        var profileItem = {
                            storagePolicy: item.storagePolicy,
                            icon: ""
                        };
                        if (profileItem.storagePolicy) {
                            profileItem.icon = "spbm-ui-icon-storage-profile";
                        }
                        else {
                            profileItem.storagePolicy = _this.i18nService.getString("SpbmUi", "viewVmProfileAssignments.noneProfileLabel");
                        }
                        return iconTextRenderer(["icon", "storagePolicy"], profileItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("SpbmUi", "complianceStatusColumnHeader"),
                    field: "complianceStatus",
                    template: function (item) {
                        var complianceItem = {
                            complianceStatusIcon: item.complianceStatusIcon,
                            complianceStatusText: item.complianceStatus
                        };
                        return iconTextRenderer(["complianceStatusIcon", "complianceStatusText"], complianceItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("SpbmUi", "lastCheckedColumnHeader"),
                    field: "lastChecked",
                    template: function (item) {
                        return item.formatedDate;
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "lastChecked");
                    }
                }
            ];
        };
        VmStoragePoliciesListController.prototype.formatComplianceItem = function (complianceStatus) {
            var iconClass = "";
            var complianceStatusKey = "";
            switch (complianceStatus) {
                case 'compliant':
                    complianceStatusKey = "complianceStatus.compliant";
                    iconClass = 'vsphere-icon-status-ok';
                    break;
                case 'nonCompliant':
                    complianceStatusKey = "complianceStatus.nonCompliant";
                    iconClass = 'vsphere-icon-status-error';
                    break;
                case 'outOfDate':
                    complianceStatusKey = "complianceStatus.outOfDate";
                    iconClass = 'vsphere-icon-status-error';
                    break;
                case 'unknown':
                    complianceStatusKey = "complianceStatus.unknown";
                    iconClass = 'vui-icon-datagrid-status-unknown';
                    break;
                case 'notApplicable':
                    complianceStatusKey = "complianceStatus.notApplicable";
                    iconClass = 'vui-icon-datagrid-status-notApplicable';
                    break;
            }
            var label = complianceStatusKey === "" ? complianceStatusKey
                : this.i18nService.getString("SpbmUi", complianceStatusKey);
            return {
                complianceStatusIcon: iconClass,
                complianceStatusText: label
            };
        };
        VmStoragePoliciesListController.$inject = [
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry",
            "timeFormatterService",
            "$q",
            "datagridActionBarService",
            "listUtil",
            "VmStoragePoliciesConstants",
            "$scope"];
        return VmStoragePoliciesListController;
    }());
    spbm_ui.VmStoragePoliciesListController = VmStoragePoliciesListController;
    angular.module("com.vmware.vsphere.client.spbm")
        .component("vmStoragePoliciesList", {
        templateUrl: "spbm-ui/resources/spbm/views/vm/configurePolicies/VmStoragePoliciesList.html",
        bindings: {
            policyAssignments: "<",
            vmId: "<",
            masterDetailsViewContext: "<"
        },
        controller: VmStoragePoliciesListController
    });
})(spbm_ui || (spbm_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var spbm_ui;
(function (spbm_ui) {
    var VmStoragePoliciesViewController = (function () {
        function VmStoragePoliciesViewController(navigation, dataService, i18nService, $q) {
            var _this = this;
            this.navigation = navigation;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.loading = false;
            this.refresh = function () {
                _this.loading = true;
                _this.dataService.getProperties(_this.vmId, ["storagePoliciesData"]).then(function (result) {
                    _this.hasSpbmViewPrivilege = result.storagePoliciesData.hasSpbmViewPrivilege;
                    _this.storagePolicies = result.storagePoliciesData.profilesDataList;
                    _this.masterDetailsViewContext.storagePolicies = _this.storagePolicies;
                })
                    .finally(function () {
                    _this.loading = false;
                });
            };
            this.vmId = this.navigation.getRoute().objectId;
            this.watchedObjects = [this.vmId];
            this.i18n = this.i18nService.getString;
            this.headerOptions = {
                objectId: this.vmId,
                actions: [{
                        actionUid: "vsphere.core.pbm.storage.manageVmStorageProfilesAction",
                        customLabel: this.i18nService.getString("SpbmUi", "manageVmProfiles.dialogTitle")
                    }]
            };
            this.masterDetailsViewContext = {};
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("SpbmUi", "h5.complianceFailuresList.complianceFailures"),
                        templateUrl: "spbm-ui/resources/spbm/views/vm/configurePolicies/VmComplianceFailuresView.html",
                        uid: "complianceFailures"
                    }
                ])
            };
        }
        VmStoragePoliciesViewController.prototype.$onInit = function () {
            this.refresh();
        };
        VmStoragePoliciesViewController.$inject = ["navigation", "dataService", "i18nService", "$q"];
        return VmStoragePoliciesViewController;
    }());
    spbm_ui.VmStoragePoliciesViewController = VmStoragePoliciesViewController;
    angular.module("com.vmware.vsphere.client.spbm")
        .component("vmStoragePolicies", {
        templateUrl: "spbm-ui/resources/spbm/views/vm/configurePolicies/VmStoragePoliciesView.html",
        controller: VmStoragePoliciesViewController
    });
})(spbm_ui || (spbm_ui = {}));



var spbm_ui;
(function (spbm_ui) {
    var VmStoragePoliciesPortletController = (function () {
        function VmStoragePoliciesPortletController(i18nService, dataService, navigation, timeFormatterService, $scope, actionsService) {
            var _this = this;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.timeFormatterService = timeFormatterService;
            this.$scope = $scope;
            this.actionsService = actionsService;
            this.PROPERTY = "vmComplianceSummary";
            this.ACTION_ID = "vsphere.core.vm.actions.checkVmRollupComplianceAction";
            this.loadData = function () {
                _this.dataService.getProperties(_this.watchedObjects[0], [_this.PROPERTY]).then(_this.render);
            };
            this.render = function (response) {
                var vmProfileData = response.vmComplianceSummary;
                if (!vmProfileData || !vmProfileData.hasSpbmViewPrivilege) {
                    _this.complianceStatus = null;
                    _this.associatedProfiles = null;
                    _this.lastCheckedDate = null;
                    return;
                }
                if (vmProfileData.oldestCheckTime) {
                    _this.timeFormatterService.formatDate(vmProfileData.oldestCheckTime)
                        .then(function (formattedDate) {
                        _this.lastCheckedDate = formattedDate;
                    });
                }
                var storagePolicyNames = vmProfileData.storagePolicyNames;
                _this.associatedProfiles = _.map(storagePolicyNames, function (policyName) {
                    return {
                        text: policyName,
                        iconClass: 'spbm-ui-icon-storage-profile'
                    };
                });
                _this.associatedReplicationGroups = vmProfileData.replicationGroupNames;
                if (vmProfileData.complianceStatus) {
                    _this.complianceStatus = _this.formatComplianceStatus(vmProfileData.complianceStatus);
                }
            };
            this.watchedObjects = [this.navigation.getRoute().objectId];
            this.EMPTY = {
                text: i18nService.getString('SpbmUi', 'string.na'),
                iconClass: ''
            };
        }
        VmStoragePoliciesPortletController.prototype.$onInit = function () {
            this.loadData();
            this.initPortletFooterLink();
        };
        VmStoragePoliciesPortletController.prototype.initPortletFooterLink = function () {
            var _this = this;
            var linkLabel = this.i18nService.getString('SpbmUi', 'storageProfile.actions.checkCompliance');
            this.actionsService.getActions(this.watchedObjects, [this.ACTION_ID]).then(function (response) {
                var actionEval = response[0];
                _this.portletConfigObject.footerLinks = [{
                        enabled: actionEval && actionEval.available,
                        label: linkLabel,
                        ariaLabel: _this.i18nService.getString("SpbmUi", "checkVmRollupComplianceAction.label"),
                        onClick: function () {
                            _this.actionsService.invokeAction(actionEval);
                        }
                    }];
            });
        };
        VmStoragePoliciesPortletController.prototype.formatComplianceStatus = function (status) {
            var iconClass;
            var statusLabel = "complianceStatus." + status;
            switch (status) {
                case "compliant":
                    {
                        iconClass = "vx-icon-statusCompliant";
                        break;
                    }
                case "nonCompliant":
                    {
                        iconClass = "vx-icon-statusNotCompliant";
                        break;
                    }
                case "outOfDate":
                    {
                        iconClass = "vx-icon-statusNotCompliant";
                        break;
                    }
                case "notApplicable":
                    {
                        iconClass = "vx-icon-statusNotApplicable";
                        break;
                    }
                default:
                    iconClass = "vsphere-icon-status-unknown";
                    break;
            }
            return {
                text: this.i18nService.getString('SpbmUi', statusLabel),
                iconClass: iconClass
            };
        };
        VmStoragePoliciesPortletController.$inject = ["i18nService", "dataService", "navigation",
            "timeFormatterService", "$scope", "actionsService"];
        return VmStoragePoliciesPortletController;
    }());
    spbm_ui.VmStoragePoliciesPortletController = VmStoragePoliciesPortletController;
    angular.module("com.vmware.vsphere.client.spbm")
        .component("vmStoragePoliciesPortlet", {
        templateUrl: "spbm-ui/resources/spbm/views/vm/VmStoragePoliciesPortlet.html",
        controller: VmStoragePoliciesPortletController,
        bindings: {
            portletConfigObject: "="
        }
    });
})(spbm_ui || (spbm_ui = {}));





/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This ts file has to be loaded first
 */
var h5_vapp;
(function (h5_vapp) {
    h5 = h5 || {};
    h5.vapp = {
        angularModule: angular.module("com.vmware.vsphere.client.vapp", ["com.vmware.platform.ui"])
    };
    /*
     * Registers vapp-ui actions.
     */
    angular.module("com.vmware.vsphere.client.vapp")
        .run([
        "clarityModalService",
        "mutationService",
        "i18nService",
        "$injector",
        "vAppDragAndDropService",
        "dragAndDropStockExpressionsService",
        "moveVAppService",
        "vappRemovalService",
        function (clarityModalService, mutationService, i18nService, $injector, vAppDragAndDropService, dragAndDropStockExpressionsService, moveVAppService, vappRemovalService) {
            h5.actions["vsphere.core.vApp.actions.editNotes"] = function (actionEval, availableTargets) {
                var onUpdateVappNotes = function (objectId, notesValue, operationName) {
                    var specType = "com.vmware.vim.binding.vim.vApp.VAppConfigSpec";
                    var propSpec = {
                        _type: specType,
                        annotation: notesValue
                    };
                    mutationService.apply(objectId, specType, propSpec, operationName);
                    return true;
                };
                var dialogData = {
                    notesPropName: "vAppConfig.annotation",
                    onUpdateNotesCallback: onUpdateVappNotes
                };
                clarityModalService.openModal(actionEval, availableTargets, dialogData, "common-module-ui/resources/common-module/views/notes/NotesDialog.html");
            };
            h5.actions["vsphere.core.vApp.actions.edit"] = function (actionEval, availableTargets) {
                $injector.get("vcVappEditActionService").editVapp(availableTargets[0]);
            };
            h5.actions["vsphere.core.vApp.actions.create"] = function (actionEval, availableTargets) {
                $injector.get("vcVappCreateActionService").createVapp(actionEval, availableTargets);
            };
            h5.actions["vsphere.core.vApp.powerOnAction"] = function (actionEval, availableTargets) {
                $injector.get("vcVappPoweropsService").powerOn(availableTargets[0]);
            };
            h5.actions["vsphere.core.vApp.powerOffAction"] = function (actionEval, availableTargets) {
                $injector.get("vcVappPoweropsService").powerOff(availableTargets[0]);
            };
            h5.actions["vsphere.core.vApp.shutdownAction"] = function (actionEval, availableTargets) {
                $injector.get("vcVappPoweropsService").shutdown(availableTargets[0]);
            };
            h5.actions["vsphere.core.vApp.suspendAction"] = function (actionEval, availableTargets) {
                $injector.get("vcVappPoweropsService").suspend(availableTargets[0]);
            };
            h5.actions["vsphere.core.vApp.cloneAction"] = function (actionEval, availableTargets) {
                $injector.get("vcVappCreateActionService").cloneVapp(actionEval, availableTargets);
            };
            h5.actions["vsphere.core.vApp.actions.exportAsOVF"] = function (actionEval, availableTargets) {
                if (availableTargets.length === 0) {
                    return;
                }
                var objectId = availableTargets[0];
                var service = $injector.get("vscExportOvfModalService");
                service.openExportOvfDialog(objectId);
            };
            h5.actions["vsphere.core.vApp.actions.moveVapp"] = function (actionEval, availableTargets) {
                moveVAppService.moveVApps(availableTargets);
            };
            h5.actions["vsphere.core.vApp.actions.dragAndDrop"] = function (actionEval, availableTargets, destinationTarget) {
                vAppDragAndDropService.dragAndDropVapp(availableTargets, destinationTarget, actionEval);
            };
            h5.actions["vsphere.core.vApp.actions.unregisterAction"] = function (actionEval, availableTargets) {
                vappRemovalService.unregisterVapps(availableTargets);
            };
            h5.actions["vsphere.core.vApp.actions.deleteAction"] = function (actionEval, availableTargets) {
                vappRemovalService.deleteVapps(availableTargets);
            };
            h5.dragAndDropValidationMethods["isVappWithinSameStandaloneAccessibleHost"] = function (dropTargetData, dragObjectsData) {
                if (!dragAndDropStockExpressionsService.isTargetAccessible(dropTargetData)) {
                    return false;
                }
                return dragAndDropStockExpressionsService.isWithinSameStandaloneHost(dropTargetData, dragObjectsData);
            };
        }]);
})(h5_vapp || (h5_vapp = {}));



var h5_vapp;
(function (h5_vapp) {
    var ManagedEntityMoveSpec = com.vmware.vsphere.client.mixed.ManagedEntityMoveSpec;
    var ValidateMoveVappSpec = com.vmware.vsphere.client.h5.vapp.data.ValidateMoveVappSpec;
    var MoveVAppService = (function () {
        function MoveVAppService(mutationService, defaultUriSchemeUtil, i18nService, $q, nameAndFolderValidatorService, managedEntityConstants, clarityModalService, dataService) {
            this.PROPERTY_OWNER = "owner";
            this.PROPERTY_DATACENTER = "dc";
            this.PROPERTY_HOST = "host";
            this.PROPERTY_RESOURCE_POOL = "resourcePool";
            this._mutationService = mutationService;
            this._defaultUriSchemeUtil = defaultUriSchemeUtil;
            this._i18nService = i18nService;
            this._q = $q;
            this._nameAndFolderValidatorService = nameAndFolderValidatorService;
            this._managedEntityConstants = managedEntityConstants;
            this._clarityModalService = clarityModalService;
            this._dataService = dataService;
        }
        /**
         * If a drop target is supplied invokes the move action for the provided virtual
         * apps to the target. If the drop target is not supplied
         * then opens a wizard from which the drop target can be selected
         * @param vAppIds
         * @param target
         */
        MoveVAppService.prototype.moveVApps = function (vAppIds, target) {
            var _this = this;
            if (target && target.dropTarget) {
                this.applyMove(vAppIds, target.dropTarget);
                return;
            }
            this.requestProperties(vAppIds).then(function (response) {
                _this.showDialog(vAppIds, response);
            });
        };
        /**
         * Builds a ManagedEntityMoveSpec that is used for the apply of the move action
         * @param virtualApps
         * @returns {ManagedEntityMoveSpec}
         */
        MoveVAppService.prototype.buildMoveSpec = function (virtualApps) {
            var entities = this._defaultUriSchemeUtil.getManagedObjectReferences(virtualApps);
            var moveSpec = new ManagedEntityMoveSpec();
            moveSpec.entities = entities;
            return moveSpec;
        };
        /**
         * Invokes the mutation service's apply operation to initiate the move entities
         * operation for the supplied virtual apps to the target. If the selected target is
         * HostSystem or ClusterComputeResource it's resource pool will be requested as the
         * move operation is executed over it.
         * @param virtualAppIds
         * @param targetId
         */
        MoveVAppService.prototype.applyMove = function (virtualAppIds, targetId) {
            var _this = this;
            var moveSpec = this.buildMoveSpec(virtualAppIds);
            var entityType = this._defaultUriSchemeUtil.getEntityType(targetId);
            if (entityType === this._managedEntityConstants.HOST ||
                entityType === this._managedEntityConstants.CLUSTER) {
                this._dataService.getPropertiesForObjects([targetId], [this.PROPERTY_RESOURCE_POOL]).
                    then(function (properties) {
                    targetId = _this._defaultUriSchemeUtil.getVsphereObjectId(properties[targetId][_this.PROPERTY_RESOURCE_POOL]);
                    _this._mutationService.apply(targetId, moveSpec._type, moveSpec);
                });
            }
            else if (entityType === this._managedEntityConstants.DATACENTER) {
                this._dataService.getProperties(targetId, ["vmFolder"]).
                    then(function (properties) {
                    targetId = _this._defaultUriSchemeUtil.getVsphereObjectId(properties["vmFolder"]);
                    _this._mutationService.apply(targetId, moveSpec._type, moveSpec);
                });
            }
            else {
                this._mutationService.apply(targetId, moveSpec._type, moveSpec);
            }
        };
        /**
         * Validates if the given virtual apps can be moved to the supplied target.
         * 1. Checks if the targets is of allowed type (Datacenter, VM Folder)
         * 2. Invokes the backend for additional validation
         * @param virtualAppIds
         * @param targetId
         * @returns {any}
         */
        MoveVAppService.prototype.validateMove = function (virtualAppIds, targetId) {
            var targetType = this._defaultUriSchemeUtil.getEntityType(targetId);
            switch (targetType) {
                case this._managedEntityConstants.FOLDER:
                    if (this._nameAndFolderValidatorService.isVmFolder(targetId)) {
                        return this.retrieveValidationMessage(virtualAppIds, targetId);
                    }
                    break;
                case this._managedEntityConstants.DATACENTER:
                case this._managedEntityConstants.CLUSTER:
                case this._managedEntityConstants.HOST:
                case this._managedEntityConstants.RESOURCE_POOL:
                case this._managedEntityConstants.V_APP:
                    return this.retrieveValidationMessage(virtualAppIds, targetId);
                default:
                    break;
            }
            // if the target is not VM Folder, return error
            return this._q.when(this._i18nService.getString("Common", "moveTo.incorrectTargetTypeError"));
        };
        /**
         * Ask the backend for validation if the given virtual machines
         * can be moved to the supplied target.
         *
         * @param virtualAppIds
         * @param targetId
         * @returns {any}
         */
        MoveVAppService.prototype.retrieveValidationMessage = function (virtualAppIds, targetId) {
            var entities = this._defaultUriSchemeUtil.getManagedObjectReferences(virtualAppIds);
            var moveSpec = new ValidateMoveVappSpec();
            moveSpec.entities = entities;
            return this._mutationService
                .validate(targetId, moveSpec._type, moveSpec)
                .then(function (result) {
                if (result.error) {
                    return result.error;
                }
                return result.result;
            });
        };
        /**
         * Opens a clarity modal from which a drop target can be selected for the move
         * operation.
         * @param virtualAppIds
         * @param properties
         */
        MoveVAppService.prototype.showDialog = function (virtualAppIds, dialogData) {
            var subTitleObject = this.buildSubtitle(virtualAppIds);
            var modalOptions = {
                title: this._i18nService.getString("VAppUi", "moveVappDialog.Title"),
                subTitle: subTitleObject,
                defaultButton: "submit",
                dialogData: {
                    objectIds: virtualAppIds,
                    datacenter: this._defaultUriSchemeUtil.getVsphereObjectId(dialogData.datacenter),
                    rpOwner: this._defaultUriSchemeUtil.getVsphereObjectId(dialogData.owner)
                },
                contentTemplate: "vapp-ui/resources/vapp/views/moveVapp/moveVappDialog.html"
            };
            this._clarityModalService.openOkCancelModal(modalOptions);
        };
        /**
         * Builds the subtitle object that is sent to the clarity modal service
         * If the virtual app is only one, sets the objectId property of the
         * subtitle object, and the clarityModalService will retrieve and display its name
         * If the virtual apps are more than one, builds a text, that is set as a property
         * to the subtitle object and will directly be displayed in the dialog
         * @param virtualAppIds
         * @returns {any}
         */
        MoveVAppService.prototype.buildSubtitle = function (virtualAppIds) {
            var subTitleObject = {};
            if (virtualAppIds.length === 1) {
                subTitleObject.objectId = virtualAppIds[0];
                return subTitleObject;
            }
            subTitleObject.text = this._i18nService.getString("Common", "contextMenu.title.nObjects", virtualAppIds.length);
            return subTitleObject;
        };
        /**
         *  Requests the host, owner and datacenter of the vApp so they can be used as tree
         *  roots in the dialog.
         *  In move folder: The datacenter is used as tree.
         *  In move host and cluster: The root compute resource is the root of the tree.
         *     We can have vApp in Standalone host or DRS Cluster. The compute resource of
         *     the cluster is the cluster itself but for a standalone host we have special
         *     compute resource so we have to use the host of the vApp as tree root.
         *
         * @param vappIds
         * @returns {IPromise<T>}
         */
        MoveVAppService.prototype.requestProperties = function (vappIds) {
            var _this = this;
            var deferred = this._q.defer();
            var response = {};
            this._dataService.getPropertiesForObjects(vappIds, [this.PROPERTY_OWNER, this.PROPERTY_DATACENTER, this.PROPERTY_HOST])
                .then(function (properties) {
                response.datacenter = properties[vappIds[0]][_this.PROPERTY_DATACENTER];
                var owner = _this._defaultUriSchemeUtil.getVsphereObjectId(properties[vappIds[0]][_this.PROPERTY_OWNER]);
                var isSingleOwner = _.every(properties, function (prop) {
                    return owner === _this._defaultUriSchemeUtil.getVsphereObjectId(prop[_this.PROPERTY_OWNER]);
                });
                if (isSingleOwner) {
                    var ownerType = properties[vappIds[0]][_this.PROPERTY_OWNER].type;
                    if (ownerType === _this._managedEntityConstants.COMPUTE_RESOURCE) {
                        response.owner = properties[vappIds[0]][_this.PROPERTY_HOST];
                    }
                    else {
                        response.owner = properties[vappIds[0]][_this.PROPERTY_OWNER];
                    }
                }
                else {
                    response.owner = null;
                }
                deferred.resolve(response);
            });
            return deferred.promise;
        };
        MoveVAppService.$inject = [
            "mutationService",
            "defaultUriSchemeUtil",
            "i18nService",
            "$q",
            "nameAndFolderValidatorService",
            "managedEntityConstants",
            "clarityModalService",
            "dataService"
        ];
        return MoveVAppService;
    }());
    h5_vapp.MoveVAppService = MoveVAppService;
    angular.module("com.vmware.vsphere.client.vapp")
        .service("moveVAppService", MoveVAppService);
})(h5_vapp || (h5_vapp = {}));



var h5_vapp;
(function (h5_vapp) {
    /**
     * Implements the action code which is invoked when the user drops a VApp over some target
     */
    var VAppDragAndDropService = (function () {
        function VAppDragAndDropService(defaultUriSchemeUtil, i18nService, actionConfirmationService, moveVAppService, dragAndDropStockExpressionsService) {
            this._defaultUriSchemeUtil = defaultUriSchemeUtil;
            this._i18nService = i18nService;
            this._actionConfirmationService = actionConfirmationService;
            this._moveVAppService = moveVAppService;
        }
        VAppDragAndDropService.prototype.dragAndDropVapp = function (availableTargets, destinationTarget, actionEval) {
            var _this = this;
            this._moveVAppService.validateMove(availableTargets, destinationTarget.dropTarget).then(function (result) {
                if (result) {
                    _this.displayWarning(actionEval.action, result);
                }
                else {
                    _this._moveVAppService.moveVApps(availableTargets, destinationTarget);
                }
            });
        };
        /**
         * Displays a warning message
         * if it is passed as parameter(waning)
         * if no message is passed it is retrieved from the action
         * if no message is found the default warning is shown
         * @param action
         * @param warning
         */
        VAppDragAndDropService.prototype.displayWarning = function (action, warning) {
            if (action === void 0) { action = {}; }
            if (warning === void 0) { warning = ""; }
            var confirmationTitle = !!action.confirmationTitle ?
                action.confirmationTitle :
                action.label;
            var alertProperties = {
                title: confirmationTitle,
                message: warning
            };
            this._actionConfirmationService.showWarningDialog(alertProperties);
        };
        VAppDragAndDropService.$inject = [
            "defaultUriSchemeUtil",
            "i18nService",
            "actionConfirmationService",
            "moveVAppService"
        ];
        return VAppDragAndDropService;
    }());
    h5_vapp.VAppDragAndDropService = VAppDragAndDropService;
    angular.module("com.vmware.vsphere.client.vapp")
        .service("vAppDragAndDropService", VAppDragAndDropService);
})(h5_vapp || (h5_vapp = {}));



var h5_vapp;
(function (h5_vapp) {
    var VAppRemovalSpec = com.vmware.vsphere.client.vapp.VAppRemovalSpec;
    var VappRemovalService = (function () {
        function VappRemovalService(mutationService) {
            this.mutationService = mutationService;
        }
        VappRemovalService.prototype.unregisterVapps = function (vappIds) {
            var unregisterSpec = VappRemovalService.buildRemovalSpec(false);
            this.mutationService.removeOnMultiEntity(vappIds, unregisterSpec._type, unregisterSpec);
        };
        VappRemovalService.prototype.deleteVapps = function (vappIds) {
            var deleteSpec = VappRemovalService.buildRemovalSpec(true);
            this.mutationService.removeOnMultiEntity(vappIds, deleteSpec._type, deleteSpec);
        };
        VappRemovalService.buildRemovalSpec = function (deleteFromDisk) {
            var removalSpec = new VAppRemovalSpec();
            removalSpec.deleteFromDisk = deleteFromDisk;
            return removalSpec;
        };
        VappRemovalService.$inject = [
            "mutationService"];
        return VappRemovalService;
    }());
    h5_vapp.VappRemovalService = VappRemovalService;
    angular.module("com.vmware.vsphere.client.vapp")
        .service("vappRemovalService", VappRemovalService);
})(h5_vapp || (h5_vapp = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vapp;
(function (h5_vapp) {
    var LegacyVappEulaPageView = (function () {
        function LegacyVappEulaPageView() {
        }
        return LegacyVappEulaPageView;
    }());
    angular.module("com.vmware.vsphere.client.vapp").component("legacyVappEulaPageView", {
        bindings: {
            vappId: "<"
        },
        controller: LegacyVappEulaPageView,
        template: "\n            <vapp-eula-page-view\n               class=\"eula-flex-fill-parent\"\n               [vapp-id]=\"$ctrl.vappId\"\n            >\n            </vapp-eula-page-view>\n      "
    });
})(h5_vapp || (h5_vapp = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vapp;
(function (h5_vapp) {
    var MoveVappViewComponent = (function () {
        function MoveVappViewComponent() {
            this.bindings = {
                objectIds: "<",
                datacenter: "<",
                // for move of a single vapp
                owner: "<",
                // If the VApps have different owners, this property is null.
                // If the vApps are under standlaone host the property holds not
                // the owner but the host system itself.
                onSubmit: "=",
                // when `Ok` is pressed
                submitDisabled: "=",
                // `OK` button should be disabled
                alerts: "=",
                // an alert will be shown
                closeModal: "<" // method of the modal dialog, when invoked the modal closes
            };
            this.controller = MoveVappController;
            this.templateUrl = "vapp-ui/resources/vapp/views/moveVapp/moveVappViewComponent.html";
        }
        return MoveVappViewComponent;
    }());
    h5_vapp.MoveVappViewComponent = MoveVappViewComponent;
    var MoveVappController = (function () {
        /**
         * Builds the initial state of the modal dialog content
         * - sets the `OK` button as disabled
         * - builds the tabOptions for the possible tabs with trees from which the target
         * could be selected
         * - initializes the onSubmit method that will be called after `OK` is pressed
         * @param $scope
         * @param moveVappService
         * @param i18nService
         * @param vuiConstants
         */
        function MoveVappController($scope, moveVappService, i18nService, vuiConstants, $element, $timeout) {
            var _this = this;
            this.$element = $element;
            this.$timeout = $timeout;
            this.loading = false;
            this._scope = $scope;
            this._moveVappService = moveVappService;
            this._i18nService = i18nService;
            this._vuiConstants = vuiConstants;
            // initialise the targets array
            this._targetId = {};
            // set the selected tab index;
            this.selectedTabUrl = "vapp_host_and_cluster_tree.html";
            // mark the `OK` button as disabled
            this.submitDisabled = true;
            // set a label for aria-label of the focused element when dialog is opened
            this.actionMoveInstruction = this._i18nService.getString("VAppUi", "actionMoveInstruction");
            this.loadingLabel = this._i18nService.getString("CommonUi", "wizard.loading");
            // initialize the possible tabs with trees from which the target could be selected
            this._scope.tabOptions = {
                tabType: this._vuiConstants.tabs.type.PRIMARY,
                tabs: this.getTabs()
            };
            // initializes the onSubmit method that will be called after `OK` is pressed
            // it closes the modal and applies the move operation
            this.onSubmit = function () {
                _this.submitDisabled = true;
                _this.loading = true;
                var targetId = _this._targetId[_this.selectedTabUrl];
                _this._moveVappService
                    .validateMove(_this.objectIds, targetId).then(function (error) {
                    if (!error) {
                        _this._moveVappService.applyMove(_this.objectIds, targetId);
                        _this.closeModal();
                    }
                    else {
                        var alert_1 = {
                            type: vuiConstants.validationBanner.type.ERROR,
                            text: error
                        };
                        _this.alerts = [alert_1];
                    }
                    _this.loading = false;
                    _this.submitDisabled = false;
                });
            };
            this.onTabSelected = function (index) {
                var tabs = _this.getTabs();
                _this.selectedTabUrl = tabs[index].contentUrl;
            };
        }
        MoveVappController.prototype.$onInit = function () {
            var _this = this;
            this.$timeout(function () {
                var firstTab = _this.$element[0].querySelector("button");
                if (firstTab) {
                    firstTab.focus();
                }
            }, 0);
        };
        /**
         * Invoked when the selection in the tree is changed.
         * Marks the `OK` button as enabled, because now we have a selection in the tree
         * And saves the selected object id
         * @param objectId
         */
        MoveVappController.prototype.onLocationSelected = function (objectId, treeUrl) {
            this.submitDisabled = false;
            this._targetId[treeUrl] = objectId;
        };
        /**
         * Builds an array of tabs that will contain the different types of trees
         * the tab's content (ex. vapp_folders_tree.html), should be defined
         * as a template in the component's template
         * @returns {Tab[]}
         */
        MoveVappController.prototype.getTabs = function () {
            var vappHostAndClusterTree = {
                iconClass: "vsphere-icon-cluster-24x",
                tooltipText: this._i18nService.getString("VAppUi", "actionMoveHostInventoryFolder"),
                contentUrl: "vapp_host_and_cluster_tree.html"
            };
            var vappFoldersTree = {
                iconClass: "vsphere-icon-vm-templates-24x",
                tooltipText: this._i18nService.getString("VAppUi", "actionMoveVmInventoryFolder"),
                contentUrl: "vapp_folders_in_datacenter_tree.html"
            };
            return [vappHostAndClusterTree, vappFoldersTree];
        };
        MoveVappController.$inject = [
            "$scope",
            "moveVAppService",
            "i18nService",
            "vuiConstants",
            "$element",
            "$timeout"
        ];
        return MoveVappController;
    }());
    h5_vapp.MoveVappController = MoveVappController;
    angular.module("com.vmware.vsphere.client.vapp")
        .component("moveVappView", new MoveVappViewComponent());
})(h5_vapp || (h5_vapp = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vapp;
(function (h5_vapp) {
    var LegacyVappPropertiesView = (function () {
        function LegacyVappPropertiesView(vcH5ConstantsService) {
            this.vcH5ConstantsService = vcH5ConstantsService;
            this.version = -1;
            this.watchObjects = [];
            this.liveProperties = ["config.vAppConfig.property"];
            this.refreshEventTypes = [];
            this.refreshEventTypes.push(vcH5ConstantsService.DATA_REFRESH_INVOCATION_EVENT);
            this.refreshEventTypes.push(vcH5ConstantsService.OBJECT_DETAILS_CHANGED_EVENT);
        }
        LegacyVappPropertiesView.prototype.$onInit = function () {
            this.watchObjects = [this.vappId];
        };
        LegacyVappPropertiesView.prototype.onRefresh = function () {
            this.version++;
        };
        LegacyVappPropertiesView.$inject = ["vcH5ConstantsService"];
        return LegacyVappPropertiesView;
    }());
    angular.module("com.vmware.vsphere.client.vapp").component("legacyVappPropertiesView", {
        bindings: {
            vappId: "<"
        },
        controller: LegacyVappPropertiesView,
        template: "\n         <div vx-refreshable\n            watch-objects=\"{{$ctrl.watchObjects}}\"\n            refresh=\"$ctrl.onRefresh()\"\n            live-refresh-properties=\"$ctrl.liveProperties\"\n            refresh-event-types=\"{{$ctrl.refreshEventTypes}}\"\n            class=\"vapp-properties-view-legacy-page-component\"\n         >\n            <vapp-properties-view-component\n               [vapp-id]=\"$ctrl.vappId\"\n               [version]=\"$ctrl.version\"\n            >\n            </vapp-properties-view-component>\n         </div>"
    });
})(h5_vapp || (h5_vapp = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
angular.
module('com.vmware.vsphere.client.vapp').
controller('VAppStatusController', [
   '$scope',
   '$controller',
   'i18nService',
   'entityStatusService',
   function ($scope, $controller, i18nService, entityStatusService) {
      angular.extend(this, $controller('GenericPortletController', {$scope: $scope}));


      $scope.$watch('data', function (data) {
         if (_.isEmpty(data)) {
            return;
         }

         var statusProperties = entityStatusService.statusProperties(data.overallStatus);
         $scope.data.statusLabel = statusProperties.label;
         $scope.data.statusClass = statusProperties.iconClass;

         humanizeState($scope);
      });

      function humanizeState(scope) {
         var state = scope.data.powerState;
         var suspended = $scope.data.isSuspended;

         var products = $scope.data.products;
         var appUrl;
         var key;

         if (state === 'started') {
            appUrl = _.isEmpty(products) ? null : products[0].appUrl;
            if (appUrl) {
               key = "VAppStatusView.available";
            } else {
               key = "VAppStatusView.running";
            }
         } else if (state === 'stopped') {
            if (suspended) {
               key = "VAppStatusView.suspended";
            } else {
               key = "VAppStatusView.stopped";
            }
         } else if (state === 'stopping') {
            if (suspended) {
               key = "VAppStatusView.suspending";
            } else {
               key = "VAppStatusView.stopping";
            }
         } else if (state === 'starting') {
            if (suspended) {
               key = "VAppStatusView.resuming";
            } else {
               key = "VAppStatusView.starting";
            }
         } else {
            $scope.data.state = null;
            return;
         }

         $scope.data.state = i18nService.getString('VAppUi', key);
         $scope.data.appUrl = appUrl;
      }
   }]);



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
h5 = h5 || {};
h5.dvs = {
    angularModule: angular.module("com.vmware.vsphere.client.dvs", [])
};
/*
 * Registers dvs-ui actions.
 */
angular.module("com.vmware.vsphere.client.dvs")
    .run([
    "dvsAddHostWizardService",
    "exportDvsDialogService",
    "dvsImportWizardService",
    "dvsEditSettingsDialogService",
    "dvsCreateWizardService",
    "dvpgCreateWizardService",
    "dvpgCreateWizardConstants",
    "mutationService",
    "dataService",
    "clarityModalService",
    "dvsEditPvlanDialogService",
    "dvsEditNetFlowDialogService",
    "dvpgManageWizardService",
    "dvsAddSpanSessionWizardService",
    "dvsPortMirroringRemoveSessionService",
    "networkUiConstants",
    "editDvPortgroupDialogService",
    "dvsEditSpanSessionDialogService",
    "dvsUpgradeWizardService",
    "dvsUpgradeNiocWizardService",
    "dvsUpgradeLacpWizardService",
    "defaultUriSchemeUtil",
    "dvsOutOfSyncHostService",
    "removeDvsDialogService",
    "dvsRectifyHostsOutOfSyncService",
    "dvpgTrafficFilterService",
    "dvsPortTrafficFilterService",
    "dvsPortEditDialogService",
    "dvsHealthCheckManageDialogService",
    'moveDvsToService',
    function (dvsAddHostWizardService, exportDvsDialogService, dvsImportWizardService, dvsEditSettingsDialogService, dvsCreateWizardService, dvpgCreateWizardService, dvpgCreateWizardConstants, mutationService, dataService, clarityModalService, dvsEditPvlanDialogService, dvsEditNetFlowDialogService, dvpgManageWizardService, dvsAddSpanSessionWizardService, dvsPortMirroringRemoveSessionService, networkUiConstants, editDvPortgroupDialogService, dvsEditSpanSessionDialogService, dvsUpgradeWizardService, dvsUpgradeNiocWizardService, dvsUpgradeLacpWizardService, defaultUriSchemeUtil, dvsOutOfSyncHostService, removeDvsDialogService, dvsRectifyHostsOutOfSyncService, dvpgTrafficFilterService, dvsPortTrafficFilterService, dvsPortEditDialogService, dvsHealthCheckManageDialogService, moveDvsToService) {
        function showAddHostWizard(actionEval, availableTargets, context) {
            if (context && context.selectedSwitch &&
                context.selectedSwitch.dvsRef) {
                var dvsId = defaultUriSchemeUtil.getVsphereObjectId(context.selectedSwitch.dvsRef);
                dvsAddHostWizardService.show(dvsId, availableTargets[0]);
            }
            else {
                dvsAddHostWizardService.show(availableTargets[0]);
            }
        }
        h5.actions["vsphere.core.dvs.manageHostOnDvsAction"] = showAddHostWizard;
        h5.actions["vsphere.core.dvs.migrateHostNetworkingAction"] = showAddHostWizard;
        function showExportDvsDialog(actionEval, availableTargets) {
            exportDvsDialogService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.exportConfigAction"] = showExportDvsDialog;
        function showImportDvsWizard(actionEval, availableTargets) {
            dvsImportWizardService.show(availableTargets[0], false, false);
        }
        h5.actions["vsphere.core.dvs.importDvsAction"] = showImportDvsWizard;
        function showRestoreDvsWizard(actionEval, availableTargets) {
            dvsImportWizardService.show(availableTargets[0], false, true);
        }
        h5.actions["vsphere.core.dvs.restoreConfigAction"] = showRestoreDvsWizard;
        function showDvsEditSettingsDialog(actionEval, availableTargets) {
            dvsEditSettingsDialogService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.editSettings"] = showDvsEditSettingsDialog;
        function showCreateDvpgWizardForDvs(actionEval, availableTargets) {
            dvpgCreateWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.createDvs"] = showDvsCreateWizard;
        function showDvsCreateWizard(actionEval, availableTargets) {
            dvsCreateWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.deleteDvs"] = showDvsDeleteConfirm;
        function showDvsDeleteConfirm(actionEval, availableTargets) {
            if (availableTargets.length === 1) {
                mutationService.remove(availableTargets[0]);
            }
        }
        h5.actions["vsphere.core.dvs.spanSession.addAction"] = showAddSpanSessionWizard;
        function showAddSpanSessionWizard(actionEval, availableTargets) {
            dvsAddSpanSessionWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.spanSession.editAction"] = showEditSpanSessionDialog;
        function showEditSpanSessionDialog(actionEval, availableTargets, context) {
            var sessionType = null;
            if (context.selectedSession.isDvPortMirrorSession) {
                sessionType = "dvPortMirror";
            }
            else if (context.selectedSession.isRemoteDestinationSession) {
                sessionType = "remoteMirrorDest";
            }
            else if (context.selectedSession.isRemoteSourceSession) {
                sessionType = "remoteMirrorSource";
            }
            else if (context.selectedSession.isEncapsulatedSession) {
                sessionType = "encapsulatedRemoteMirrorSource";
            }
            if (sessionType) {
                dvsEditSpanSessionDialogService.show(availableTargets[0], context.selectedSession.key, sessionType);
            }
        }
        h5.actions["vsphere.core.dvs.spanSession.removeAction"] =
            showRemoveSpanSessionDialog;
        function showRemoveSpanSessionDialog(actionEval, availableTargets, context) {
            dvsPortMirroringRemoveSessionService
                .removeSpanSession(availableTargets, context);
        }
        h5.actions["vsphere.core.dvs.createPortgroup"] = showCreateDvpgWizardForDvs;
        h5.actions["vsphere.core.dvs.managePortgroups"] = showManageDvpgWizardForDvs;
        function showManageDvpgWizardForDvs(actionEval, availableTargets) {
            dvpgManageWizardService.show(availableTargets[0]);
        }
        function showDeleteDvPgConfirm(actionEval, availableTargets) {
            if (availableTargets.length === 1) {
                mutationService.remove(availableTargets[0]);
            }
            else if (availableTargets.length > 1) {
                mutationService.removeOnMultiEntity(availableTargets);
            }
        }
        h5.actions["vsphere.core.dvPortgroup.deletePortgroupAction"] =
            showDeleteDvPgConfirm;
        h5.actions["vsphere.core.dvs.actions.renameAction"] =
            showRenameModalDialog;
        function showRenameModalDialog(actionEval, availableTargets) {
            var dvsRef = availableTargets[0];
            dataService.getProperties(dvsRef, ["config.name"]).then(function (dvsResponse) {
                var dvsUnescapedName = dvsResponse["config.name"]
                    .replace(/%25/g, "%")
                    .replace(/%2f/g, "\/")
                    .replace(/%5c/g, "\\");
                clarityModalService.openModal(actionEval, availableTargets, {
                    objectId: dvsRef,
                    existingObjectName: dvsUnescapedName
                }, "common-module-ui/resources/common-module/views/rename/renameObject.html");
            });
        }
        function showDvsEditNetFlowDialog(actionEval, availableTargets) {
            dvsEditNetFlowDialogService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.editNetFlow"] = showDvsEditNetFlowDialog;
        function showDvsEditPvlanDialog(actionEval, availableTargets) {
            dvsEditPvlanDialogService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.editHealthCheckSettings"] = showDvsEditHealthCheckDialog;
        function showDvsEditHealthCheckDialog(actionEval, availableTargets) {
            dvsHealthCheckManageDialogService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.editPvlan"] = showDvsEditPvlanDialog;
        function showUpgradeDvsWizard(actionEval, availableTargets) {
            dvsUpgradeWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.upgradeNioc"] = showUpgradeNiocWizard;
        function showUpgradeNiocWizard(actionEval, availableTargets) {
            dvsUpgradeNiocWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.upgradeLacp"] = showUpgradeLacpWizard;
        function showUpgradeLacpWizard(actionEval, availableTargets) {
            dvsUpgradeLacpWizardService.show(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.upgradeDvs"] = showUpgradeDvsWizard;
        function showEditDvpgDialog(actionEval, availableTargets) {
            editDvPortgroupDialogService.show(availableTargets[0], actionEval);
        }
        h5.actions[networkUiConstants.actions.EDIT_DVPG] = showEditDvpgDialog;
        h5.actions[networkUiConstants.actions.EXPORT_DVPG] = showExportDpvgDialog;
        function showExportDpvgDialog(actionEval, availableTargets) {
            exportDvsDialogService.show(availableTargets[0]);
        }
        ;
        h5.actions[networkUiConstants.actions.IMPORT_DVPG] = showImportDvpgDialog;
        function showImportDvpgDialog(actionEval, availableTargets) {
            dvsImportWizardService.show(availableTargets[0], true, false);
        }
        ;
        h5.actions[networkUiConstants.actions.RESTORE_DVPG] = showRestoreDvpgDialog;
        function showRestoreDvpgDialog(actionEval, availableTargets) {
            dvsImportWizardService.show(availableTargets[0], true, true);
        }
        ;
        function renameDvpg(actionEval, availableTargets) {
            var dvPortgroupRef = availableTargets[0];
            dataService.getProperties(dvPortgroupRef, ["config.name"]).then(function (dvPortgroupResponse) {
                var dvPortgroupName = dvPortgroupResponse["config.name"];
                var dvPortgroupUnescapedName = dvPortgroupName
                    .replace(/%25/g, "%")
                    .replace(/%2f/g, "\/")
                    .replace(/%5c/g, "\\");
                clarityModalService.openModal(actionEval, availableTargets, {
                    objectId: dvPortgroupRef,
                    existingObjectName: dvPortgroupUnescapedName
                }, "common-module-ui/resources/common-module/views/rename/renameObject.html");
            });
        }
        h5.actions[networkUiConstants.actions.RENAME_DV_PORTGROUP] = renameDvpg;
        function showEditTrafficFiltersDialog(actionEval, availableTargets, context) {
            dvpgTrafficFilterService.showEditTrafficFilterDialog(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.trafficFilters.editRulesAction"] =
            showEditTrafficFiltersDialog;
        function showCloneTrafficFiltersDialog(actionEval, availableTargets, context) {
            dvpgTrafficFilterService.showCloneTrafficFilterDialog(availableTargets[0]);
        }
        h5.actions["vsphere.core.dvs.trafficFilters.cloneRulesAction"] =
            showCloneTrafficFiltersDialog;
        function showEditPortTrafficFilterDialog(actionEval, availableTargets, context) {
            dvsPortTrafficFilterService.showPortEditTrafficFilterDialog(availableTargets[0], context.isPortGroupContext, context.selectedPort);
        }
        h5.actions["vsphere.core.dvs.trafficFilters.editPortRulesAction"] =
            showEditPortTrafficFilterDialog;
        function showOutOfSyncDvsDetails(actionEval, availableTargets, context) {
            dvsOutOfSyncHostService.showDetails(context.details.hostOutOfSync, context.description, context.entityId);
        }
        h5.actions[networkUiConstants.actions.HOST_OF_SYNC_DVS_HOST] = showOutOfSyncDvsDetails;
        function removeDvs(actionEval, availableTargets, context) {
            if (context.selectedSwitch.isGhost || context.selectedSwitch.isDvsDetached) {
                removeDvsDialogService.removeGhostDvs(availableTargets[0], context.selectedSwitch.name, context.selectedSwitch.dvsUuid);
            }
            else {
                removeDvsDialogService.removeDvs(availableTargets[0], context.selectedSwitch.name, defaultUriSchemeUtil.getVsphereObjectId(context.selectedSwitch.dvsRef));
            }
        }
        h5.actions[networkUiConstants.actions.REMOVE_DVS] = removeDvs;
        function showRectifyOutOfSyncHostsDvs(actionEval, availableTargets, context) {
            dvsRectifyHostsOutOfSyncService.show(context.entityId);
        }
        h5.actions[networkUiConstants.actions.RECTIFY_HOSTS_OUT_OF_SYNC_DVS] = showRectifyOutOfSyncHostsDvs;
        function showEditPortDialog(actionEval, availableTargets, context) {
            dvsPortEditDialogService.show(availableTargets[0], context.selectedPort, context.isPortGroupContext, context.dSwitchUri);
        }
        h5.actions[networkUiConstants.actions.EDIT_DVPORT] = showEditPortDialog;
        h5.actions[networkUiConstants.actions.DVS_MOVE_TO_ACTION] = showMoveToDialog;
        function showMoveToDialog(actionEval, availableTargets, context) {
            moveDvsToService.openMoveToDialog(availableTargets);
        }
        h5.actions[networkUiConstants.actions.DVS_MOVE_TO_DRAG_AND_DROP_ACTION] = moveDvs;
        function moveDvs(actionEval, availableTargets, destinationTarget) {
            if (!availableTargets || !availableTargets.length || !destinationTarget) {
                return;
            }
            moveDvsToService.moveDvsTo(availableTargets, destinationTarget.dropTarget);
        }
    }]);



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var AssignUplinkComponent = (function () {
        function AssignUplinkComponent() {
            this.bindings = {
                config: "<"
            };
            this.controller = AssignUplinkController;
            this.templateUrl = 'dvs-ui/resources/dvs/addhost/components/assignUplink/assignUplinkTemplate.html';
        }
        return AssignUplinkComponent;
    }());
    dvs_ui.AssignUplinkComponent = AssignUplinkComponent;
    var AssignUplinkComponentConfig = (function () {
        function AssignUplinkComponentConfig() {
        }
        return AssignUplinkComponentConfig;
    }());
    dvs_ui.AssignUplinkComponentConfig = AssignUplinkComponentConfig;
    var ApplyToAllSignPostConfig = (function () {
        function ApplyToAllSignPostConfig() {
        }
        return ApplyToAllSignPostConfig;
    }());
    dvs_ui.ApplyToAllSignPostConfig = ApplyToAllSignPostConfig;
    var AssignUplinkController = (function () {
        function AssignUplinkController(vuiConstants, i18nService, columnRenderersRegistry) {
            var _this = this;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.preselectComparator = function (item) { return _this.uplinkSelectedByDefault === item; };
        }
        AssignUplinkController.prototype.$onInit = function () {
            var self = this;
            var _selectedItems = [];
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: false
                },
                columnDefs: this.buildColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: this.getData(),
                get selectedItems() {
                    return _selectedItems;
                },
                set selectedItems(selectedItems) {
                    _selectedItems = selectedItems;
                    if (_selectedItems && _selectedItems.length === 1) {
                        self.config.selectedUplink = _selectedItems[0][0];
                    }
                    else {
                        self.config.selectedUplink = undefined;
                    }
                },
                resizable: true
            };
            this.assignDefaults();
        };
        AssignUplinkController.prototype.getData = function () {
            var data = [];
            data.push.apply(data, this.config.uplinkMappings);
            //push the auto-assign item
            data.push([dvs_ui.DvsAddHostWizardConstants.AUTO_ASSIGN, undefined]);
            return data;
        };
        AssignUplinkController.prototype.assignDefaults = function () {
            var _this = this;
            if (this.config.selectedUplinkPortgroup === undefined) {
                this.config.selectedUplinkPortgroup = this.config.uplinkPortgroups[0];
            }
            if (this.config.selectedUplink !== undefined) {
                this.uplinkSelectedByDefault = _.find(this.datagridOptions.data, function (item) { return item[0] === _this.config.selectedUplink; });
            }
            else {
                //select first free uplink
                this.uplinkSelectedByDefault = _.find(this.datagridOptions.data, function (item) { return item[1] === undefined; });
            }
        };
        AssignUplinkController.prototype.buildColumnDefinitions = function () {
            var _this = this;
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var itemToDisplayItem = function (item) {
                var uplinkLabel = item[0];
                var pnicLabel = item[1];
                if (uplinkLabel === dvs_ui.DvsAddHostWizardConstants.AUTO_ASSIGN) {
                    //auto-assign
                    uplinkLabel = _this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.autoAssign");
                    pnicLabel = "";
                }
                else if (pnicLabel === undefined) {
                    // no mapped pnic
                    pnicLabel = _this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.noUplink");
                } // Otherwise the entry is a LAG.
                var displayItem = {
                    uplink: item[0],
                    uplinkDisplayValue: uplinkLabel,
                    pnicDisplayValue: pnicLabel,
                    icon: "vui-icon" /* Fake icon, used only to indent label */
                };
                return displayItem;
            };
            return [{
                    displayName: this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.uplinkNameHeader"),
                    width: "150px",
                    template: function (item) {
                        var isIndented = item[2];
                        if (isIndented) {
                            return iconTextRenderer(["icon", "uplinkDisplayValue"], itemToDisplayItem(item));
                        }
                        else if (item[1] === "") {
                            // A LAG.
                            var displayItem = itemToDisplayItem(item);
                            return "<span class='dvs-assign-uplink-dialog-lag-group'>" + displayItem.uplinkDisplayValue + "</span>";
                        }
                        else {
                            return textRenderer(["uplinkDisplayValue"], itemToDisplayItem(item));
                        }
                    }
                }, {
                    displayName: this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.assignedAdapterHeader"),
                    width: "150px",
                    template: function (item) {
                        return textRenderer(["pnicDisplayValue"], itemToDisplayItem(item));
                    }
                }];
        };
        AssignUplinkController.$inject = [
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry"
        ];
        return AssignUplinkController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("assignUplink", new AssignUplinkComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHostListComponent = (function () {
        function DvsHostListComponent() {
            this.bindings = {
                onHostsChange: "&",
                hostsRetriever: "&",
                showVdsStateColumn: "<",
                allowAnySelection: "<",
                addedHosts: "<",
                showIncompatibleHostsButton: "<",
                dvsId: "<",
                addActionLabel: "@",
                addDialogTitle: "@",
                hostColumnFormat: "@"
            };
            this.controller = DvsHostListController;
            this.template =
                "<div class=\"fill-parent flexbox flex-grow-auto\">\n                  <div ng-if=\"$ctrl.datagridOptions\"\n                       vui-datagrid=\"$ctrl.datagridOptions\"\n                       vx-stretch-grid\n                       autofocus tabindex=\"-1\"\n                       aria-label=\"{{$ctrl.gridDescription}}\"\n                       class=\"flex-grid\"\n                       id=\"selectedHostsGrid\"/>\n               </div>";
        }
        return DvsHostListComponent;
    }());
    dvs_ui.DvsHostListComponent = DvsHostListComponent;
    var DvsHostListController = (function () {
        function DvsHostListController(vuiConstants, i18nService, selectHostsDialogService, defaultUriSchemeUtil) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.selectHostsDialogService = selectHostsDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.hostColumnFormat = "{0}";
        }
        DvsHostListController.prototype.$onInit = function () {
            var selectedItems = [];
            var hostListController = this;
            this.gridDescription = this.i18nService.getString("DvsUi", "DvsHostSelector.selectedHostsList.description");
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: false
                },
                columnDefs: this.buildColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                data: this.addedHosts,
                get selectedItems() {
                    return selectedItems;
                },
                set selectedItems(selectedItems) {
                    hostListController.selectedHostItems =
                        hostListController.mapGridItemsToHostListItems(selectedItems);
                    hostListController.updateRemoveActionEnabledState();
                },
                resizable: true,
                actionBarOptions: this.createActionBarOptions()
            };
            this.updateRemoveActionEnabledState();
        };
        DvsHostListController.prototype.createActionBarOptions = function () {
            return {
                actions: [{
                        id: "add-action",
                        label: this.addActionLabel,
                        enabled: true,
                        iconClass: "network-lib-ui-icon-add",
                        onClick: this.onAddClicked.bind(this)
                    }, {
                        id: "remove-action",
                        label: this.i18nService.getString("DvsUi", "DvsHostSelector.removeHostsButton.title"),
                        iconClass: "network-lib-ui-icon-deleteIcon",
                        onClick: this.onRemoveClicked.bind(this)
                    }]
            };
        };
        DvsHostListController.prototype.updateRemoveActionEnabledState = function () {
            this.datagridOptions.actionBarOptions.actions[1].enabled =
                this.selectedHostItems && this.selectedHostItems.length !== 0;
        };
        DvsHostListController.prototype.mapGridItemsToHostListItems = function (selectedItems) {
            return _.filter(this.addedHosts, function (item) {
                return _.findWhere(selectedItems, { hostName: item.hostName });
            });
        };
        DvsHostListController.prototype.onAddClicked = function () {
            var _this = this;
            var hostsPromise = this.hostsRetriever().then(function (hosts) {
                return _this.hostItemsDifference(hosts, _this.addedHosts);
            });
            this.showDialog(hostsPromise);
        };
        DvsHostListController.prototype.onRemoveClicked = function () {
            if (this.selectedHostItems.length > 0) {
                this.updateData(this.hostItemsDifference(this.addedHosts, this.selectedHostItems));
            }
        };
        DvsHostListController.prototype.buildColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DvsUi", "DvsHostSelector.selectedHostsList.hostNameColumn.title"),
                    field: "hostName",
                    width: "180px",
                    template: function (data) {
                        return _this.buildCellHtml(_this.i18nService.interpolate(_this.hostColumnFormat, [data.hostName]), data.hostIconId);
                    }
                }, {
                    displayName: this.i18nService.getString("DvsUi", "DvsHostSelector.selectedHostsList.hostStatusColumn.title"),
                    field: "connectionState",
                    width: "150px",
                    template: function (data) { return _this.buildCellHtml(data.connectionStateLabel); }
                }];
        };
        DvsHostListController.prototype.buildCellHtml = function (text, icon) {
            if (icon === void 0) { icon = ""; }
            var template = "<div>%icon%text</div>";
            return template
                .replace("%icon", "<span class='" + icon + "'></span>")
                .replace("%text", "<span class='vertical-align-cell'>" + text + "</span>");
        };
        DvsHostListController.prototype.updateData = function (hosts) {
            this.addedHosts = hosts;
            this.datagridOptions.data = hosts;
            this.onHostsChange({ hosts: hosts });
        };
        DvsHostListController.prototype.showDialog = function (hostsPromise) {
            var _this = this;
            this.selectHostsDialogService.show(hostsPromise, function (selectedHostItems) {
                _this.updateData(_this.addedHosts.concat(selectedHostItems));
            }, this.addDialogTitle, this.showVdsStateColumn, this.showIncompatibleHostsButton, this.allowAnySelection, this.dvsId);
        };
        DvsHostListController.prototype.hostItemsDifference = function (items, itemsToBeRemoved) {
            var _this = this;
            return _.filter(items, function (item) {
                return !_.some(itemsToBeRemoved, function (itemToBeRemoved) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(itemToBeRemoved.hostRef) === _this.defaultUriSchemeUtil.getVsphereObjectId(item.hostRef);
                });
            });
        };
        DvsHostListController.$inject = [
            "vuiConstants",
            "i18nService",
            "selectHostsDialogService",
            "defaultUriSchemeUtil"
        ];
        return DvsHostListController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHostList", new DvsHostListComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var SelectHostsComponent = (function () {
        function SelectHostsComponent() {
            this.bindings = {
                hosts: "<",
                allowAnySelection: "<",
                showVdsStateColumn: "<",
                showIncompatibleHostsButton: "<",
                onSelectedHostsChange: "&",
                selectAllConnectedHosts: "<?"
            };
            this.controller = SelectHostsController;
            this.template =
                "<div class=\"fill-parent dvs-select-hosts\">\n                  <button ng-if=\"$ctrl.showIncompatibleHostsButton\"\n                          type=\"submit\"\n                          class=\"btn btn-sm btn-link\"\n                          ng-click=\"$ctrl.onShowIncompatibleHostsButtonClicked()\"\n                  >{{$ctrl.showIncompatibleHostsButtonLabel}}</button>\n                  <div class=\"filter-input pull-right\">\n                     <span class=\"nav-icon fa fa-filter\"/>\n                     <input type=\"text\"\n                            ng-model=\"$ctrl.searchTerm\"\n                            ng-model-options=\"{ getterSetter: true }\"\n                            ng-trim=\"true\"\n                            aria-label=\"{{$ctrl.i18nService.getString('Common', 'filter.label')}}\"\n                            placeholder=\"{{$ctrl.i18nService.getString('Common', 'filter.label')}}\"/>\n                  </div>\n                  <div class=\"flex-grid\"\n                       ng-if=\"$ctrl.datagridOptions\"\n                       vx-stretch-grid\n                       autofocus tabindex=\"-1\"\n                       aria-label=\"{{$ctrl.gridDescription}}\"\n                       vui-datagrid=\"$ctrl.datagridOptions\"></div>\n               </div>";
        }
        return SelectHostsComponent;
    }());
    dvs_ui.SelectHostsComponent = SelectHostsComponent;
    var SelectHostsController = (function () {
        function SelectHostsController(vuiConstants, i18nService, columnRenderersRegistry, defaultUriSchemeUtil) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.selectMasterCheckbox = false;
            this.areIncompatibleHostsShown = false;
        }
        Object.defineProperty(SelectHostsController.prototype, "searchTerm", {
            get: function () {
                return this._searchTerm;
            },
            set: function (value) {
                this._searchTerm = value;
                this.datagridOptions.data = this.getDatagridData();
            },
            enumerable: true,
            configurable: true
        });
        SelectHostsController.prototype.$onInit = function () {
            this.gridDescription = this.i18nService.getString("DvsUi", "DvsHostSelector.selectedHostsList.description");
            if (this.allowAnySelection === undefined) {
                this.allowAnySelection = false;
            }
            if (this.showIncompatibleHostsButton === undefined) {
                this.showIncompatibleHostsButton = false;
            }
            if (this.showVdsStateColumn === undefined) {
                this.showVdsStateColumn = false;
            }
            this.showIncompatibleHostsButtonLabel = this.getShowIncompatibleHostsButtonLabel();
            this.datagridOptions = this.createDatagridOptions();
            if (this.selectAllConnectedHosts) {
                this.notifySelectionChange();
            }
        };
        SelectHostsController.prototype.onShowIncompatibleHostsButtonClicked = function () {
            this.areIncompatibleHostsShown = !this.areIncompatibleHostsShown;
            this.showIncompatibleHostsButtonLabel = this.getShowIncompatibleHostsButtonLabel();
            this.datagridOptions.data = this.getDatagridData();
        };
        SelectHostsController.prototype.getShowIncompatibleHostsButtonLabel = function () {
            var label;
            if (!this.areIncompatibleHostsShown) {
                label = this.i18nService.getString("DvsUi", "SelectHostsComponent.showIncompatibleHostsButtonLabel.show");
            }
            else {
                label = this.i18nService.getString("DvsUi", "SelectHostsComponent.showIncompatibleHostsButtonLabel.hide");
            }
            return label;
        };
        SelectHostsController.prototype.buildResult = function () {
            var _this = this;
            var selectedItems = _.filter(this.datagridOptions.data, function (item) {
                return _this.datagridOptions.selectedHosts[item.hostName] && !_this.isHostItemSelectionDisabled(item);
            });
            // return back only the HostListItemData that are selected
            return _.filter(this.hosts, function (host) {
                return _.some(selectedItems, function (selectedItem) {
                    return selectedItem.hostName === host.hostName;
                });
            });
        };
        SelectHostsController.prototype.createDatagridOptions = function () {
            var _this = this;
            var selectHostsController = this;
            return {
                height: "300",
                pageConfig: {
                    hidePager: false
                },
                columnDefs: this.buildColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                data: this.getDatagridData(),
                resizable: true,
                actionBarOptions: { actions: [] },
                isItemDisabledCallback: function (item) {
                    return selectHostsController.isHostItemSelectionDisabled(item);
                },
                onMasterCheckboxClick: function (event) {
                    var checked = event.currentTarget.checked;
                    for (var key in selectHostsController.datagridOptions.selectedHosts) {
                        if (selectHostsController.isHostVisible(key)) {
                            selectHostsController.datagridOptions.selectedHosts[key] = checked;
                        }
                    }
                    selectHostsController.notifySelectionChange();
                },
                onItemCheckboxClick: function () {
                    selectHostsController.notifySelectionChange();
                },
                selectedHosts: (function () {
                    var value = {};
                    _.forEach(selectHostsController.hosts, function (item) {
                        value[item.hostName] = !!_this.selectAllConnectedHosts;
                    });
                    return value;
                })()
            };
        };
        SelectHostsController.prototype.notifySelectionChange = function () {
            this.onSelectedHostsChange({ selectedHostItems: this.buildResult() });
        };
        SelectHostsController.prototype.getDatagridData = function () {
            var _this = this;
            var hostsToShow = this.hosts;
            if (!this.areIncompatibleHostsShown) {
                hostsToShow =
                    _.filter(hostsToShow, function (item) { return _this.isHostCompatible(item); });
            }
            if (this._searchTerm) {
                hostsToShow = _.filter(hostsToShow, function (item) { return _this.isItemMatchingSearchTerm(item); });
            }
            return hostsToShow;
        };
        SelectHostsController.prototype.isHostCompatible = function (item) {
            return item.compatibilityErrors.length === 0;
        };
        SelectHostsController.prototype.isItemMatchingSearchTerm = function (item) {
            var _this = this;
            var filterableFields = _.pluck(this.datagridOptions.columnDefs, "field");
            return _.some(filterableFields, function (field) { return _this.isSubstringIgnoreCase(item[field], _this._searchTerm); });
        };
        SelectHostsController.prototype.isHostVisible = function (hostName) {
            return this.datagridOptions.data.some(function (item) { return item.hostName === hostName; });
        };
        SelectHostsController.prototype.isSubstringIgnoreCase = function (str, substr) {
            if (!str) {
                return false;
            }
            if (!substr) {
                return true;
            }
            return str.toLowerCase().indexOf(substr.toLowerCase()) !== -1;
        };
        SelectHostsController.prototype.isHostItemSelectionDisabled = function (item) {
            return !this.allowAnySelection &&
                (item.connectionState === dvs_ui.DvsAddHostWizardConstants.hostConnectionState.DISCONNECTED ||
                    item.connectionState === dvs_ui.DvsAddHostWizardConstants.hostConnectionState.NOT_RESPONDING)
                || !this.isHostCompatible(item);
        };
        SelectHostsController.prototype.buildColumnDefinitions = function () {
            var _this = this;
            var self = this;
            var columnns = [];
            this.selectMasterCheckbox = !!this.selectAllConnectedHosts
                && !_.every(this.hosts, function (host) {
                    return _this.isHostItemSelectionDisabled(host);
                });
            var headerTemplate = "<input data-test-id=\"selectHostsMasterCheckBox\" type=\"checkbox\" class=\"select-hosts-master-checkbox\" \n                       ng-checked=" + this.selectMasterCheckbox + "\n                       ng-click=\"datagridOptions.onMasterCheckboxClick($event)\"/>";
            columnns.push({
                filterable: false,
                sortable: false,
                groupable: false,
                searchable: false,
                width: "25px",
                headerTemplate: headerTemplate,
                field: "selected",
                template: function (item) {
                    var value = "datagridOptions.selectedHosts[\"" + item.hostName + "\"]";
                    return self.isHostItemSelectionDisabled(item)
                        ? "<input type=\"checkbox\" disabled/>"
                        : "<input type=\"checkbox\" %checked %model\n                                     ng-click=\"datagridOptions.onItemCheckboxClick($event)\"/>"
                            .replace("%checked", "ng-checked=" + value)
                            .replace("%model", "ng-model=" + value);
                }
            });
            columnns.push({
                searchable: false,
                displayName: self.i18nService.getString("DvsUi", "DvsSelectHostsDialog.columnHostName.title"),
                field: "hostName",
                width: "150px",
                template: function (item) {
                    return self.buildCellHtml(item.hostName, item.hostIconId, self.isHostItemSelectionDisabled(item));
                }
            });
            columnns.push({
                searchable: false,
                displayName: self.i18nService.getString("DvsUi", "DvsSelectHostsDialog.columnHostState.title"),
                field: "connectionStateLabel",
                width: "150px",
                template: self.getHostConnectionStateColumnRenderer()
            });
            if (this.showVdsStateColumn) {
                columnns.push({
                    searchable: false,
                    displayName: self.i18nService.getString("DvsUi", "DvsSelectHostsDialog.columnDvsState.title"),
                    field: "vdsState",
                    width: "150px",
                    template: self.getVdsStateColumnRenderer(),
                });
            }
            columnns.push({
                searchable: false,
                displayName: self.i18nService.getString("DvsUi", "DvsSelectHostsDialog.columnClusters.title"),
                field: "clusterName",
                width: "150px",
                template: self.getClusterColumnRenderer()
            });
            if (this.showIncompatibleHostsButton) {
                columnns.push({
                    searchable: false,
                    displayName: self.i18nService.getString("DvsUi", "SelectHostsComponent.compatibilityColumnHeader"),
                    width: "150px",
                    template: self.getCompatibilityColumnRenderer()
                });
            }
            return columnns;
        };
        SelectHostsController.prototype.getIncompatibleHostTooltip = function (item) {
            var tooltip = "";
            if (item.compatibilityErrors && item.compatibilityErrors.length > 0) {
                _.forEach(item.compatibilityErrors, function (error) {
                    tooltip += '<span>' + error + '</span>';
                });
            }
            return tooltip;
        };
        SelectHostsController.prototype.getCompatibilityColumnRenderer = function () {
            var _this = this;
            return function (item) {
                if (_this.isHostCompatible(item)) {
                    return _this.buildCellHtml(_this.i18nService.getString("DvsUi", "HostsCompatibilityList.compatibleText"), "vsphere-icon-status-ok", _this.isHostItemSelectionDisabled(item));
                }
                else {
                    return _this.buildIncompatibleHostCell(item);
                }
            };
        };
        SelectHostsController.prototype.getClusterColumnRenderer = function () {
            var _this = this;
            return (function (item) {
                if (item.clusterName) {
                    return _this.buildCellHtml(item.clusterName, "vsphere-icon-cluster", _this.isHostItemSelectionDisabled(item));
                }
                else {
                    return _this.buildCellHtml(_this.i18nService.getString("DvsUi", "DvsSelectHostsDialog.na"), "", _this.isHostItemSelectionDisabled(item));
                }
            });
        };
        SelectHostsController.prototype.getHostConnectionStateColumnRenderer = function () {
            var _this = this;
            return (function (item) {
                return _this.buildCellHtml(item.connectionStateLabel, "", _this.isHostItemSelectionDisabled(item));
            });
        };
        SelectHostsController.prototype.getVdsStateColumnRenderer = function () {
            var _this = this;
            var self = this;
            return function (item) {
                return self.buildCellHtml(item.vdsState, SelectHostsController.ICON_PREFIX + item.vdsStateIcon, _this.isHostItemSelectionDisabled(item));
            };
        };
        SelectHostsController.prototype.buildCellHtml = function (text, icon, disabled) {
            var template = "<div class=\"no-tooltip-cell %disabled\">%icon%text</div>";
            return template
                .replace("%icon", "<span class='" + icon + "'></span>")
                .replace("%text", "<span ng-non-bindable class='vertical-align-cell'>" + text + "</span>")
                .replace("%disabled", disabled ? "disabled-cell" : "");
        };
        SelectHostsController.prototype.buildIncompatibleHostCell = function (dataItem) {
            var tooltip = this.getIncompatibleHostTooltip(dataItem);
            var text = this.i18nService.getString("DvsUi", "HostsCompatibilityList.incompatibleText");
            var disabled = this.isHostItemSelectionDisabled(dataItem) ?
                "class='element-disabled'" : "";
            var template = "\n            <span class=\"vertical-align-cell\">\n               <a role=\"tooltip\" aria-haspopup=\"true\" class=\"tooltip tooltip-md tooltip-top-left\">\n                  <clr-icon shape=\"error\" size=\"24\" class=\"is-error\"></clr-icon>\n                  <span class=\"tooltip-content\">" + tooltip + "</span>\n               </a>\n               <span " + disabled + "><span class='vertical-align-cell'>" + text + "</span></span>\n            </span>\n         ";
            return template;
        };
        SelectHostsController.$inject = [
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry",
            "defaultUriSchemeUtil"
        ];
        SelectHostsController.ICON_PREFIX = "network-lib-ui-icon-";
        return SelectHostsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("selectHosts", new SelectHostsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var UnassignUplinkDialogComponent = (function () {
        function UnassignUplinkDialogComponent() {
            this.bindings = {
                dialogData: "<"
            };
            this.controller = UnassignUplinkDialogController;
            this.templateUrl = 'dvs-ui/resources/dvs/addhost/components/unassignUplink/unassignUplinkDialogTemplate.html';
        }
        return UnassignUplinkDialogComponent;
    }());
    dvs_ui.UnassignUplinkDialogComponent = UnassignUplinkDialogComponent;
    var UnassignUplinkDialogController = (function () {
        function UnassignUplinkDialogController(i18nService) {
            this.i18nService = i18nService;
        }
        UnassignUplinkDialogController.$inject = [
            "i18nService"
        ];
        return UnassignUplinkDialogController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("unassignUplink", new UnassignUplinkDialogComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmVnicSettingsComponent = (function () {
        function VmVnicSettingsComponent() {
            this.bindings = {
                vmRef: "<",
                nicKey: "<"
            };
            this.controller = VmVnicSettingsController;
            this.templateUrl = "dvs-ui/resources/dvs/addhost/components/vmVnicSettings/vmVnicSettingsTemplate.html";
        }
        return VmVnicSettingsComponent;
    }());
    dvs_ui.VmVnicSettingsComponent = VmVnicSettingsComponent;
    var VmVnicSettingsController = (function () {
        function VmVnicSettingsController(i18nService, dataService, defaultUriSchemeUtil, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vxPropertyViewService = vxPropertyViewService;
            this.loadingData = false;
        }
        VmVnicSettingsController.prototype.$onInit = function () {
            this.requestData();
        };
        VmVnicSettingsController.prototype.requestData = function () {
            var _this = this;
            this.loadingData = true;
            var dsOptions = {};
            if (this.nicKey !== undefined) {
                dsOptions.propertyParams = [{
                        propertyName: VmVnicSettingsController.VM_VNIC_SETTINGS_PROPERTY,
                        parameterType: "java.lang.Integer",
                        parameter: this.nicKey
                    }];
            }
            this.dataService.getProperties(this.defaultUriSchemeUtil.getVsphereObjectId(this.vmRef), [VmVnicSettingsController.VM_VNIC_SETTINGS_PROPERTY], dsOptions).then(function (response) {
                if (response) {
                    _this.buildPropertyViewData(response[VmVnicSettingsController.VM_VNIC_SETTINGS_PROPERTY]);
                }
            }).finally(function () {
                _this.loadingData = false;
            });
        };
        VmVnicSettingsController.prototype.buildPropertyViewData = function (vmVnicSettingsDataItems) {
            var _this = this;
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var defaultCategory = builder.category("default");
            _.each(vmVnicSettingsDataItems, function (item) {
                var vmVnicSection = defaultCategory.section(item.key.toString()).title(item.adapterName);
                vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.macAddress"), item.macAddress);
                if (item.adapterType) {
                    vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.adapterType"), item.adapterType);
                }
                if (item.portgroupName) {
                    vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.portGroup"), item.portgroupName);
                }
                if (item.sriovInfo) {
                    vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.virtualFunctionId"), item.sriovInfo.virtualFunctionId
                        ? item.sriovInfo.virtualFunctionId
                        : _this.i18nService.getString("DvsUi", "VmVnicPropertiesView.noData"));
                    vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.physicalFunctionId"), _this.i18nService.getString("DvsUi", "VmVnicPropertiesView.physicalFunctionFormat", item.sriovInfo.physicalFunctionId, item.sriovInfo.physicalFunctionDeviceId));
                    vmVnicSection.property(_this.i18nService.getString("DvsUi", "VmVnicPropertiesView.gosMtu"), item.sriovInfo.allowGuestOsMtuChange
                        ? _this.i18nService.getString("DvsUi", "VmVnicPropertiesView.gosMtu.allowed")
                        : _this.i18nService.getString("DvsUi", "VmVnicPropertiesView.gosMtu.disallowed"));
                }
            });
            this.propertyViewData = builder.build();
        };
        VmVnicSettingsController.$inject = [
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "vxPropertyViewService"
        ];
        VmVnicSettingsController.VM_VNIC_SETTINGS_PROPERTY = "dvsAddHost:vmVnicSettingsData";
        return VmVnicSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmVnicSettings", new VmVnicSettingsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostWizardConstants = (function () {
        function DvsAddHostWizardConstants() {
        }
        DvsAddHostWizardConstants.targetType = {
            DVS_RECONFIGURE_COMMAND_SPEC_TYPE: "com.vmware.vsphere.client.dvs.specs.DvsReconfigureCommandSpec",
            DVS_HOST_MEMBER_CONFIG_SPEC_TYPE: "com.vmware.vim.binding.vim.dvs.HostMember$ConfigSpec"
        };
        DvsAddHostWizardConstants.page = {
            DVS_SELECT_WORKFLOW_PAGE: "selectWorkflowPage",
            DVS_SELECT_HOSTS_PAGE: "selectHostsPage",
            DVS_SELECT_HOSTS_TO_REMOVE_PAGE: "selectHostsToRemovePage",
            DVS_SELECT_HOSTS_TO_MANAGE_PAGE: "selectHostsToManagePage",
            DVS_SELECT_PHYSICAL_ADAPTERS_PAGE: "selectPhysicalAdaptersPage",
            DVS_SELECT_VIRTUAL_ADAPTERS_PAGE: "selectVirtualAdaptersPage",
            DVS_SELECT_VIRTUAL_MACHINES_PAGE: "selectVirtualMachinesPage",
            DVS_READY_TO_COMPLETE_PAGE: "dvsAddHostReadyToCompletePage"
        };
        DvsAddHostWizardConstants.nicListItemType = {
            PNIC_TYPE: "DvsAddHostHierarchicalListPnicItem",
            GROUPING_TYPE: "DvsAddHostHierarchicalListGroupingItem",
            HOST_TYPE: "DvsAddHostHierarchicalListHostItem",
            VNIC_TYPE: "DvsAddHostHierarchicalListVnicItem",
            VM_TYPE: "DvsAddHostHierarchicalListVmItem",
            VM_VNIC_TYPE: "DvsAddHostHierarchicalListVmVnicItem"
        };
        DvsAddHostWizardConstants.operationType = {
            ADD_HOST: "addHostOperation",
            REMOVE_HOST: "removeHostOperation",
            MANAGE_HOST: "manageHostOperation",
            MIGRATE_NETWORKING: "migrateNetworkingOperation"
        };
        DvsAddHostWizardConstants.AUTO_ASSIGN = "";
        DvsAddHostWizardConstants.hostConnectionState = {
            CONNECTED: "connected",
            DISCONNECTED: "disconnected",
            NOT_RESPONDING: "notResponding"
        };
        return DvsAddHostWizardConstants;
    }());
    dvs_ui.DvsAddHostWizardConstants = DvsAddHostWizardConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Manages the page states of the DVS Add and Manage Hosts wizard.
 */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostWizardFlowManager = (function () {
        function DvsAddHostWizardFlowManager(pageStateManagementService, vuiConstants) {
            this.pageStateManagementService = pageStateManagementService;
            this.vuiConstants = vuiConstants;
        }
        DvsAddHostWizardFlowManager.prototype.init = function (wizardScope) {
            var _this = this;
            this.pages = wizardScope.wizardConfig.pages;
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            wizardScope.$watchGroup([
                "model.selectOperationPageModel.selectedOperationType"], function (newValues) {
                _this.updatePagesVisibility.apply(_this, newValues);
            });
        };
        DvsAddHostWizardFlowManager.prototype.updatePagesVisibility = function (operationType) {
            var isAddWorkflow = operationType === dvs_ui.DvsAddHostWizardConstants.operationType.ADD_HOST;
            var isRemoveWorkflow = operationType === dvs_ui.DvsAddHostWizardConstants.operationType.REMOVE_HOST;
            var isManageWorkflow = operationType === dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST;
            var isMigrateWorkflow = operationType === dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_WORKFLOW_PAGE, isAddWorkflow || isRemoveWorkflow || isManageWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_PAGE, isAddWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_PHYSICAL_ADAPTERS_PAGE, isAddWorkflow || isManageWorkflow || isMigrateWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_VIRTUAL_ADAPTERS_PAGE, isAddWorkflow || isManageWorkflow || isMigrateWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_VIRTUAL_MACHINES_PAGE, isAddWorkflow || isManageWorkflow || isMigrateWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_TO_MANAGE_PAGE, isManageWorkflow);
            this.togglePageVisibility(dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_TO_REMOVE_PAGE, isRemoveWorkflow);
        };
        DvsAddHostWizardFlowManager.prototype.togglePageVisibility = function (pageId, isVisible) {
            var page = _.findWhere(this.pages, { id: pageId });
            if (isVisible) {
                // change the state to DISABLED only if the page is currently invisible.
                if (page.state === this.vuiConstants.wizard.pageState.SKIPPED) {
                    page.state = this.vuiConstants.wizard.pageState.DISABLED;
                }
            }
            else if (page) {
                page.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvsAddHostWizardFlowManager.$inject = [
            "pageStateManagementService",
            "vuiConstants"];
        return DvsAddHostWizardFlowManager;
    }());
    dvs_ui.DvsAddHostWizardFlowManager = DvsAddHostWizardFlowManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddHostWizardFlowManager", DvsAddHostWizardFlowManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var DvsAddHostWizardPages = dvs_ui.DvsAddHostWizardPages;
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostWizardPages = (function () {
        function DvsAddHostWizardPages(i18nService, dvsSelectHostsPageValidator, dvsSelectPhysicalAdaptersPageValidator, dvsSelectVirtualAdaptersPageValidator, dvsSelectVirtualMachinesPageValidator, vuiConstants) {
            this.i18nService = i18nService;
            this.dvsSelectHostsPageValidator = dvsSelectHostsPageValidator;
            this.dvsSelectPhysicalAdaptersPageValidator = dvsSelectPhysicalAdaptersPageValidator;
            this.dvsSelectVirtualAdaptersPageValidator = dvsSelectVirtualAdaptersPageValidator;
            this.dvsSelectVirtualMachinesPageValidator = dvsSelectVirtualMachinesPageValidator;
            this.vuiConstants = vuiConstants;
        }
        /**
         * Creates an array of page definitions for the Add and Manage Hosts wizard.
         */
        DvsAddHostWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var selectWorkflowPage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_WORKFLOW_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectOperationPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectOperationPage.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/selectOperationPage.html",
                validationFunction: function () {
                    return [];
                }
            };
            var selectHostsPage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectHostsPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectHostsPage.addhosts.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectHostsPage.html",
                validationFunction: function () {
                    return _this.dvsSelectHostsPageValidator.getValidationError(wizardScope.model.selectHostsPageModel.hosts);
                },
                validationParams: ["model.selectHostsPageModel.hosts"]
            };
            var selectHostsToRemovePage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_TO_REMOVE_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectHostsPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectHostsPage.removeHosts.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectHostsToRemovePage.html",
                validationFunction: function () {
                    return _this.dvsSelectHostsPageValidator.getValidationError(wizardScope.model.selectHostsToRemovePageModel.hosts);
                },
                validationParams: ["model.selectHostsToRemovePageModel.hosts"]
            };
            var selectHostsToManagePage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_HOSTS_TO_MANAGE_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectHostsPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectHostsPage.managehosts.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectHostsToManagePage.html",
                validationFunction: function () {
                    return _this.dvsSelectHostsPageValidator.getValidationError(wizardScope.model.selectHostsToManagePageModel.hosts);
                },
                validationParams: ["model.selectHostsToManagePageModel.hosts"]
            };
            var selectPhysicalAdaptersPage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_PHYSICAL_ADAPTERS_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.title.default"),
                description: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectPhysicalAdaptersPage.html",
                validationParams: ["model.selectPhysicalAdaptersPageModel.generationNumber"],
                onCommit: function () {
                    return _this.dvsSelectPhysicalAdaptersPageValidator.validate(wizardScope.model.selectPhysicalAdaptersPageModel)
                        .then(function (isValid) {
                        wizardScope.wizardConfig.currentPage.state = isValid
                            ? _this.vuiConstants.wizard.pageState.COMPLETED
                            : _this.vuiConstants.wizard.pageState.INCOMPLETE;
                        return isValid;
                    });
                }
            };
            var selectVirtualAdaptersPage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_VIRTUAL_ADAPTERS_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.title.default"),
                description: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectVirtualAdaptersPage.html",
                validationFunction: function () {
                    return _this.dvsSelectVirtualAdaptersPageValidator.getValidationError(wizardScope.model.selectVirtualAdaptersPageModel.hosts, wizardScope.model.selectPhysicalAdaptersPageModel.hosts, wizardScope.model.selectVirtualAdaptersPageModel.hosts);
                }
            };
            var selectVirtualMachinesPage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_SELECT_VIRTUAL_MACHINES_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsSelectVirtualMachinesPage.html",
                validationFunction: function () {
                    return _this.dvsSelectVirtualMachinesPageValidator.getValidationError(wizardScope.model.selectVirtualMachinesPageModel);
                }
            };
            var readyToCompletePage = {
                id: dvs_ui.DvsAddHostWizardConstants.page.DVS_READY_TO_COMPLETE_PAGE,
                title: this.i18nService.getString("DvsUi", "AddHostWizard.readyToCompletePage.title"),
                description: this.i18nService.getString("DvsUi", "AddHostWizard.readyToCompletePage.description"),
                contentUrl: "dvs-ui/resources/dvs/addhost/views/dvsAddHostReadyToCompletePage.html",
                onCommit: function () {
                    return true;
                }
            };
            var pages = [selectWorkflowPage,
                selectHostsPage,
                selectHostsToRemovePage,
                selectHostsToManagePage,
                selectPhysicalAdaptersPage,
                selectVirtualAdaptersPage,
                selectVirtualMachinesPage,
                readyToCompletePage];
            if (wizardScope.model.selectOperationPageModel.selectedOperationType ===
                dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING) {
                // Remove workflow and host selection pages.
                pages.splice(0 /*start from the beginning*/, 4 /*remove 4 pages*/);
            }
            return pages;
        };
        DvsAddHostWizardPages.$inject = ["i18nService",
            "dvsSelectHostsPageValidator",
            "dvsSelectPhysicalAdaptersPageValidator",
            "dvsSelectVirtualAdaptersPageValidator",
            "dvsSelectVirtualMachinesPageValidator",
            "vuiConstants"];
        return DvsAddHostWizardPages;
    }());
    dvs_ui.DvsAddHostWizardPages = DvsAddHostWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddHostWizardPages", DvsAddHostWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostWizardService = (function () {
        function DvsAddHostWizardService($rootScope, i18nService, vuiWizardService, dvsAddHostWizardSpecFactory, mutationService, dvsAddHostWizardFlowManager, dvsAddHostWizardPages, dataService, wizardValidationService, defaultUriSchemeUtil, $q, vimEntityEscapingService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.dvsAddHostWizardSpecFactory = dvsAddHostWizardSpecFactory;
            this.mutationService = mutationService;
            this.dvsAddHostWizardFlowManager = dvsAddHostWizardFlowManager;
            this.dvsAddHostWizardPages = dvsAddHostWizardPages;
            this.dataService = dataService;
            this.wizardValidationService = wizardValidationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
            this.vimEntityEscapingService = vimEntityEscapingService;
        }
        /**
         * Shows the Add and Manage Hosts wizard.
         *
         * If hostId is specified, the wizard is invoked in the
         * Migrate Networking mode where the specified host is preselected
         * and the first pages of the wizard are not shown.
         */
        DvsAddHostWizardService.prototype.show = function (dvsId, hostId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsAddHostWizardModel();
            wizardScope.model.dvsId = dvsId;
            var isInMigrateNetworkingMode = hostId !== undefined;
            if (isInMigrateNetworkingMode) {
                // Migrate networking mode.
                wizardScope.model.selectOperationPageModel.selectedOperationType =
                    dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
                var host = new HostListItemData();
                host.hostRef =
                    this.defaultUriSchemeUtil.getManagedObjectReference(hostId);
                wizardScope.model.selectHostsToManagePageModel.hosts = [host];
            }
            var wizardConfig = new dvs_ui.WizardConfig();
            wizardConfig.title = isInMigrateNetworkingMode
                ? this.i18nService.getString("DvsUi", "actionMigrateHostNetworkingOnDvsTitle")
                : this.i18nService.getString("DvsUi", "actionManageHostOnDvsTitle");
            wizardConfig.loadingMessage = this.i18nService.getString("CommonUi", "wizard.loading");
            wizardConfig.cssClass = "dvs-add-host-wizard";
            wizardConfig.onFinish = function () {
                var operationType = wizardScope.model.selectOperationPageModel.selectedOperationType;
                if (operationType === dvs_ui.DvsAddHostWizardConstants.operationType.ADD_HOST ||
                    operationType === dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST ||
                    operationType === dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING) {
                    var spec = _this.dvsAddHostWizardSpecFactory.buildSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.dvsId, spec._type, spec);
                }
                else if (operationType === dvs_ui.DvsAddHostWizardConstants.operationType.REMOVE_HOST) {
                    var spec = _this.dvsAddHostWizardSpecFactory.buildRemoveSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.dvsId, spec._type, spec);
                }
                return true;
            };
            wizardConfig.pages =
                this.dvsAddHostWizardPages.createPages(wizardScope);
            wizardScope.wizardConfig = wizardConfig;
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.dvsAddHostWizardFlowManager.init(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
            var configVersionPropertyName = "config.configVersion";
            var dvsNameProperty = "config.name";
            var hostNameProperty = "name";
            var dvsPropertiesPromise;
            var hostNamePromise;
            var dataServiceRequests = [];
            dvsPropertiesPromise = this.dataService.getProperties(wizardScope.model.dvsId, [dvsNameProperty, configVersionPropertyName]);
            dataServiceRequests.push(dvsPropertiesPromise);
            if (isInMigrateNetworkingMode) {
                hostNamePromise = this.dataService.getProperties(hostId, [hostNameProperty]);
                dataServiceRequests.push(hostNamePromise);
            }
            this.$q.all(dataServiceRequests).then(function (values) {
                if (values && values.length > 0) {
                    var dvsProperties = values[0];
                    var hostProperties = values[1];
                    var dvsName = void 0;
                    var hostName = void 0;
                    if (dvsProperties) {
                        if (dvsProperties[configVersionPropertyName]) {
                            wizardScope.model.dvsConfigVersion =
                                dvsProperties[configVersionPropertyName];
                        }
                        if (dvsProperties[dvsNameProperty]) {
                            dvsName = _this.vimEntityEscapingService
                                .unescapeSpecialCharacters(dvsProperties[dvsNameProperty]);
                        }
                    }
                    if (hostProperties) {
                        if (hostProperties[hostNameProperty]) {
                            hostName = _this.vimEntityEscapingService
                                .unescapeSpecialCharacters(hostProperties[hostNameProperty]);
                        }
                    }
                    if (isInMigrateNetworkingMode) {
                        if (dvsName && hostName) {
                            wizardConfig.title = _this.i18nService.getString("DvsUi", "actionMigrateHostNetworkingOnDvsTitleWithNames", hostName, dvsName);
                        }
                    }
                    else {
                        if (dvsName) {
                            wizardConfig.title =
                                _this.i18nService.getString("DvsUi", "actionManageHostOnDvsTitleWithName", dvsName);
                        }
                    }
                }
            });
            // Reset next pages when host selection has changed.
            wizardScope.$watchCollection(function () {
                return wizardScope.model.selectedHosts;
            }, function () {
                wizardScope.model.selectPhysicalAdaptersPageModel.isInitialized = false;
                wizardScope.model.selectVirtualAdaptersPageModel.isInitialized = false;
                wizardScope.model.selectVirtualMachinesPageModel.isInitialized = false;
            });
        };
        DvsAddHostWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "dvsAddHostWizardSpecFactory",
            "mutationService",
            "dvsAddHostWizardFlowManager",
            "dvsAddHostWizardPages",
            "dataService",
            "wizardValidationService",
            "defaultUriSchemeUtil",
            "$q",
            "vimEntityEscapingService"];
        return DvsAddHostWizardService;
    }());
    dvs_ui.DvsAddHostWizardService = DvsAddHostWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddHostWizardService", DvsAddHostWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddAndManageHostsSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvsAddAndManageHostsSpec;
    var PnicAssignmentSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.PnicAssignmentSpec;
    var DvsHostRemoveSpec = com.vmware.vsphere.client.dvs.api.spec.DvsHostRemoveSpec;
    var VnicAssignmentSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.VnicAssignmentSpec;
    var VmVnicAssignmentSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.VmVnicAssignmentSpec;
    /**
     * Provides methods from creating the mutation spec hierarchy sent to the backend
     * services after the completion of the DVS Add Host wizard.
     */
    var DvsAddHostWizardSpecFactory = (function () {
        function DvsAddHostWizardSpecFactory(dvsSelectPhysicalAdaptersPageService, dvsSelectVirtualAdaptersPageService, dvsSelectVirtualMachinesPageService, defaultUriSchemeUtil) {
            this.dvsSelectPhysicalAdaptersPageService = dvsSelectPhysicalAdaptersPageService;
            this.dvsSelectVirtualAdaptersPageService = dvsSelectVirtualAdaptersPageService;
            this.dvsSelectVirtualMachinesPageService = dvsSelectVirtualMachinesPageService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Builds the spec the DVS mutation.
         *
         * @param model DvsAddHostWizardModel
         */
        DvsAddHostWizardSpecFactory.prototype.buildSpec = function (model) {
            var _this = this;
            // All selected hosts in the wizard.
            var hosts = _.map(model.selectedHosts, function (host) {
                return host.hostRef;
            });
            // All items on the Select physical adapters page.
            var pnicListItems = model.selectPhysicalAdaptersPageModel.hosts;
            // All items on the Select virtual adapters page.
            var vnicListItems = model.selectVirtualAdaptersPageModel.hosts;
            // Hosts that should be mutated as a result of the wizard completion
            // (updateNetworkConfig should be applied).
            var hostsToMutate = this.getHostsToMutate(pnicListItems, vnicListItems);
            // Physical NICs that should be sent to the server.
            var pnicItemsToUpdate = _.filter(pnicListItems, function (pnicListItem) {
                if (pnicListItem.type !== dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                    return false;
                }
                var pnicItem = pnicListItem;
                var hostUrn = _this.defaultUriSchemeUtil.getVsphereObjectId(pnicItem.hostRef);
                return (_this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(pnicItem) ||
                    _this.dvsSelectPhysicalAdaptersPageService.isPnicUnassigned(pnicListItem)) &&
                    hostsToMutate[hostUrn] !== undefined;
            });
            var pnicAssignmentSpecs = _.map(pnicItemsToUpdate, function (item) {
                var listItem = item;
                var pnicItem = listItem;
                var pnicAssignmentSpec = new PnicAssignmentSpec();
                pnicAssignmentSpec.host = pnicItem.hostRef;
                pnicAssignmentSpec.pnicDevice = pnicItem.device;
                pnicAssignmentSpec.uplinkPortgroupKey = pnicItem.uplinkPortgroup.key;
                if (pnicItem.uplink !== dvs_ui.DvsAddHostWizardConstants.AUTO_ASSIGN) {
                    pnicAssignmentSpec.uplink = pnicItem.uplink;
                }
                pnicAssignmentSpec.isPnicReassigned =
                    _this.dvsSelectPhysicalAdaptersPageService.isPnicOriginallyOnThisSwitch(pnicItem) &&
                        _this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(pnicItem);
                return pnicAssignmentSpec;
            });
            // VMkernel NICs that should be sent to the server.
            var vnicItemsToUpdate = _.filter(vnicListItems, function (vnicListItem) {
                if (vnicListItem.type !== dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                    return false;
                }
                var vnicItem = vnicListItem;
                var hostUrn = _this.defaultUriSchemeUtil.getVsphereObjectId(vnicItem.hostRef);
                var isVnicModified = _this.dvsSelectVirtualAdaptersPageService.isVnicModified(vnicListItem) &&
                    hostsToMutate[hostUrn] !== undefined;
                return isVnicModified;
            });
            var vnicAssignmentSpecs = _.map(vnicItemsToUpdate, function (vnicItem) {
                var vnicAssignmentSpec = new VnicAssignmentSpec();
                vnicAssignmentSpec.host = vnicItem.hostRef;
                vnicAssignmentSpec.vnicDevice = vnicItem.device;
                if (vnicItem.isStandardPortgroup) {
                    vnicAssignmentSpec.standardPortgroupName = vnicItem.sourcePortgroup;
                }
                vnicAssignmentSpec.distributedPortgroupRef = vnicItem.portgroupRef;
                return vnicAssignmentSpec;
            });
            // All list items on the Select Virtual Machines page.
            var vmVnicListItems = model.selectVirtualMachinesPageModel.hosts;
            var vmVnicItemsToUpdate = _.filter(vmVnicListItems, function (vmVnicListItem) {
                return vmVnicListItem && vmVnicListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE &&
                    _this.dvsSelectVirtualMachinesPageService.isVnicModified(vmVnicListItem);
            });
            var vmVnicAssignmentSpecs = _.map(vmVnicItemsToUpdate, function (vmVnicItem) {
                var vmVnicAssignmentSpec = new VmVnicAssignmentSpec();
                vmVnicAssignmentSpec.host = vmVnicItem.hostRef;
                vmVnicAssignmentSpec.vm = vmVnicItem.vmRef;
                vmVnicAssignmentSpec.key = vmVnicItem.key;
                vmVnicAssignmentSpec.distributedPortgroupRef = vmVnicItem.destinationPortgroupRef;
                vmVnicAssignmentSpec.changeVersion = vmVnicItem.changeVersion;
                return vmVnicAssignmentSpec;
            });
            // The final spec sent to the server.
            var spec = new DvsAddAndManageHostsSpec();
            spec.dvsConfigVersion = model.dvsConfigVersion;
            spec.hosts = hosts;
            spec.hostsToMutate = _.values(hostsToMutate);
            spec.pnicAssignmentSpecs = pnicAssignmentSpecs;
            spec.vnicAssignmentSpecs = vnicAssignmentSpecs;
            spec.vmVnicAssignmentSpecs = vmVnicAssignmentSpecs;
            spec.areMemberHosts = model.selectOperationPageModel.selectedOperationType ===
                dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST ||
                model.selectOperationPageModel.selectedOperationType ===
                    dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
            return spec;
        };
        DvsAddHostWizardSpecFactory.prototype.buildRemoveSpec = function (model) {
            var dvsHostRemoveSpec = new DvsHostRemoveSpec();
            dvsHostRemoveSpec.hosts = _.map(model.selectHostsToRemovePageModel.hosts, function (item) {
                return item.hostRef;
            });
            return dvsHostRemoveSpec;
        };
        DvsAddHostWizardSpecFactory.prototype.getHostsToMutate = function (pnicListItems, vnicListItems) {
            var _this = this;
            var hostToMutate = {};
            var modifiedPnicItems = _.filter(pnicListItems, function (pnicListItem) {
                return pnicListItem && pnicListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE &&
                    _this.dvsSelectPhysicalAdaptersPageService.isPnicModified(pnicListItem);
            });
            _.each(modifiedPnicItems, function (item) {
                var listItem = item;
                var pnicItem = listItem;
                hostToMutate[_this.defaultUriSchemeUtil.getVsphereObjectId(pnicItem.hostRef)] =
                    pnicItem.hostRef;
            });
            var modifiedVnicItems = _.filter(vnicListItems, function (vnicListItem) {
                return vnicListItem && vnicListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE &&
                    _this.dvsSelectVirtualAdaptersPageService.isVnicModified(vnicListItem);
            });
            _.each(modifiedVnicItems, function (item) {
                var listItem = item;
                var vnicItem = listItem;
                hostToMutate[_this.defaultUriSchemeUtil.getVsphereObjectId(vnicItem.hostRef)] =
                    vnicItem.hostRef;
            });
            return hostToMutate;
        };
        DvsAddHostWizardSpecFactory.$inject = [
            "dvsSelectPhysicalAdaptersPageService",
            "dvsSelectVirtualAdaptersPageService",
            "dvsSelectVirtualMachinesPageService",
            "defaultUriSchemeUtil"];
        return DvsAddHostWizardSpecFactory;
    }());
    dvs_ui.DvsAddHostWizardSpecFactory = DvsAddHostWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddHostWizardSpecFactory", DvsAddHostWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostHierarchicalListItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListItem;
    var DvsAddHostTreeListItemWrapper = (function (_super) {
        __extends(DvsAddHostTreeListItemWrapper, _super);
        function DvsAddHostTreeListItemWrapper() {
            _super.apply(this, arguments);
        }
        return DvsAddHostTreeListItemWrapper;
    }(DvsAddHostHierarchicalListItem));
    dvs_ui.DvsAddHostTreeListItemWrapper = DvsAddHostTreeListItemWrapper;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostWizardModel = (function () {
        function DvsAddHostWizardModel() {
            this.operationTypes = dvs_ui.DvsAddHostWizardConstants.operationType;
            this.selectOperationPageModel = new dvs_ui.SelectOperationPageModel();
            this.selectHostsPageModel = new dvs_ui.DvsSelectHostsPageModel();
            this.selectHostsToManagePageModel = new dvs_ui.DvsSelectHostsPageModel();
            this.selectHostsToRemovePageModel = new dvs_ui.DvsSelectHostsPageModel();
            this.selectPhysicalAdaptersPageModel = new dvs_ui.DvsSelectPhysicalAdaptersPageModel();
            this.selectVirtualAdaptersPageModel = new dvs_ui.DvsSelectVirtualAdaptersPageModel();
            this.selectVirtualMachinesPageModel = new dvs_ui.DvsSelectVirtualMachinesPageModel();
        }
        Object.defineProperty(DvsAddHostWizardModel.prototype, "selectedHosts", {
            get: function () {
                var hosts = [];
                switch (this.selectOperationPageModel.selectedOperationType) {
                    case dvs_ui.DvsAddHostWizardConstants.operationType.ADD_HOST:
                        hosts = this.selectHostsPageModel.hosts;
                        break;
                    case dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST:
                        hosts = this.selectHostsToManagePageModel.hosts;
                        break;
                    case dvs_ui.DvsAddHostWizardConstants.operationType.REMOVE_HOST:
                        hosts = this.selectHostsToRemovePageModel.hosts;
                        break;
                    case dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING:
                        hosts = this.selectHostsToManagePageModel.hosts;
                        break;
                }
                return hosts;
            },
            enumerable: true,
            configurable: true
        });
        ;
        return DvsAddHostWizardModel;
    }());
    dvs_ui.DvsAddHostWizardModel = DvsAddHostWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectHostsPageModel = (function () {
        function DvsSelectHostsPageModel() {
            this.hosts = [];
        }
        return DvsSelectHostsPageModel;
    }());
    dvs_ui.DvsSelectHostsPageModel = DvsSelectHostsPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectPhysicalAdaptersPageModel = (function () {
        function DvsSelectPhysicalAdaptersPageModel() {
            this.isInitialized = false;
            /**
             * The generation number of this model. Increased each time the model is updated.
             * Needed to mark the page as incomplete.
             */
            this.generationNumber = 0;
        }
        return DvsSelectPhysicalAdaptersPageModel;
    }());
    dvs_ui.DvsSelectPhysicalAdaptersPageModel = DvsSelectPhysicalAdaptersPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectVirtualAdaptersPageModel = (function () {
        function DvsSelectVirtualAdaptersPageModel() {
            this.isInitialized = false;
        }
        return DvsSelectVirtualAdaptersPageModel;
    }());
    dvs_ui.DvsSelectVirtualAdaptersPageModel = DvsSelectVirtualAdaptersPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectVirtualMachinesPageModel = (function () {
        function DvsSelectVirtualMachinesPageModel() {
            this.isInitialized = false;
        }
        return DvsSelectVirtualMachinesPageModel;
    }());
    dvs_ui.DvsSelectVirtualMachinesPageModel = DvsSelectVirtualMachinesPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var SelectOperationPageModel = (function () {
        function SelectOperationPageModel() {
            this.selectedOperationType = dvs_ui.DvsAddHostWizardConstants.operationType.ADD_HOST;
        }
        return SelectOperationPageModel;
    }());
    dvs_ui.SelectOperationPageModel = SelectOperationPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var AssingUplinkDialogService = (function () {
        function AssingUplinkDialogService(i18nService, clarityModalService, clarityConstants) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
        }
        AssingUplinkDialogService.prototype.show = function (pnic, assignUplinkComponentConfig, isBatchAssignmentEnabled, signPostConfig, okHandler) {
            var _this = this;
            var dialogData = {
                assignUplinkComponentConfig: assignUplinkComponentConfig,
                applyToAll: false,
                applyToAllLabel: this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.applyToAllLabel"),
                isBatchAssignmentEnabled: isBatchAssignmentEnabled,
                signPostConfig: signPostConfig
            };
            this.modalOptions = {
                title: this.i18nService.getString("DvsUi", "assignUplinkDialogService.title"),
                subTitle: { text: pnic },
                defaultButton: "submit",
                alerts: [],
                dialogData: dialogData,
                contentTemplate: "dvs-ui/resources/dvs/addhost/components/assignUplink/assignUplinkDialog.html",
                onSubmit: function () {
                    if (dialogData.assignUplinkComponentConfig.selectedUplink !== undefined &&
                        !_.contains(dialogData.assignUplinkComponentConfig.lagNames, dialogData.assignUplinkComponentConfig.selectedUplink)) {
                        okHandler(assignUplinkComponentConfig, dialogData.applyToAll);
                        return true;
                    }
                    else {
                        _this.modalOptions.alerts = [{
                                text: _this.i18nService.getString("DvsUi", "assignUplinkDialogService.noUplinkSelected"),
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                }
            };
            this.clarityModalService.openOkCancelModal(this.modalOptions);
        };
        AssingUplinkDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "clarityConstants"
        ];
        return AssingUplinkDialogService;
    }());
    dvs_ui.AssingUplinkDialogService = AssingUplinkDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("assingUplinkDialogService", AssingUplinkDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var DvsSelectPhysicalAdaptersPageService = dvs_ui.DvsSelectPhysicalAdaptersPageService;
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectPhysicalAdaptersPageService = (function () {
        function DvsSelectPhysicalAdaptersPageService(i18nService, vuiConstants, columnRenderersRegistry) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
        }
        /**
         * Returns the actionBarOptions object for the select physical adapters page.
         *
         * @param assignUplinkHandler
         *    The handler for the assign uplink button.
         *
         * @param resetChangesHandler
         *    The handler for the reset changes button.
         * @param viewSettingsHandler
         * @param unassignAdapterHandler
         */
        DvsSelectPhysicalAdaptersPageService.prototype.getActionBarOptions = function (assignUplinkHandler, viewSettingsHandler, unassignAdapterHandler) {
            var result = { actions: [] };
            result.actions.push({
                id: DvsSelectPhysicalAdaptersPageService.actionId.ASSIGN_UPLINK,
                label: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.assignUplinkButtonTitle"),
                tooltipText: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.assignUplinkButtonTooltip"),
                // Disabled initially, only enabled when selection occurs.
                enabled: false,
                iconClass: "network-lib-ui-icon-dvsUplinks",
                onClick: assignUplinkHandler
            });
            if (unassignAdapterHandler) {
                result.actions.push({
                    id: DvsSelectPhysicalAdaptersPageService.actionId.UNASSIGN_UPLINK,
                    label: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.unAssignUplinkButtonLabel"),
                    tooltipText: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.unAssignUplinkButtonTooltip"),
                    // Disabled initially, only enabled when proper selection occurs.
                    enabled: false,
                    iconClass: "network-lib-ui-icon-deleteIcon",
                    onClick: unassignAdapterHandler
                });
            }
            result.actions.push({
                id: DvsSelectPhysicalAdaptersPageService.actionId.VIEW_SETTINGS,
                label: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.showSelectedPnicDetailsButton"),
                tooltipText: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.showSelectedPnicDetailsToolTipButton"),
                // Disabled initially, only enabled when selection occurs.
                enabled: false,
                iconClass: "network-lib-ui-icon-info",
                onClick: viewSettingsHandler
            });
            return result;
        };
        /**
         * Reeturns the column definitions for the select physical adapters page.
         */
        DvsSelectPhysicalAdaptersPageService.prototype.getColumnDefs = function () {
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            var itemToDisplayItem = this.itemToDisplayItem.bind(this);
            return [{
                    field: "label",
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.hostPhysicalNic"),
                    // The width is calculated so that it can accommodate a host name
                    // that is an IPv6 address, e.g. "2001:0db8:0a0b:12f0:0000:0000:0000:0001".
                    width: "260px",
                    template: function (item) {
                        return iconTextRenderer(["icon", "label"], {
                            icon: item.iconClass,
                            label: item.label
                        });
                    }
                }, {
                    field: "inUseBySwitch",
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.inUseBySwitch"),
                    width: "150px",
                    template: (function (item) {
                        return textRenderer(["inUseBySwitch"], item, true /*unescapeCharacters*/);
                    })
                }, {
                    field: "uplink",
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.uplinkColumnTitle"),
                    // The width is calculated so that it can accommodate the (Auto-assign)
                    // uplink name in English. In German locale, it is trimmed, but this is
                    // still the most optimal distribution of the available real estate
                    // and the columns are resizable.
                    width: "102px",
                    template: (function (item) {
                        return textRenderer(["uplink"], itemToDisplayItem(item), true /*unescapeCharacters*/);
                    })
                }, {
                    field: "uplinkPortgroup",
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.dvUplinkPortgroup"),
                    template: (function (item) {
                        return textRenderer(["uplinkPortgroup"], itemToDisplayItem(item), true /*unescapeCharacters*/);
                    })
                }];
        };
        DvsSelectPhysicalAdaptersPageService.prototype.itemToDisplayItem = function (item) {
            var displayItem = {};
            if (item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                displayItem.uplink =
                    item.uplink;
                displayItem.uplinkPortgroup =
                    item.uplinkPortgroup.name;
            }
            if (displayItem.uplink === dvs_ui.DvsAddHostWizardConstants.AUTO_ASSIGN) {
                displayItem.uplink =
                    this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.autoAssign");
            }
            return displayItem;
        };
        /**
         * Returns the schema for the hierarchical grid data model in the
         * select physical adapters page.
         */
        DvsSelectPhysicalAdaptersPageService.prototype.getTreeListSchema = function () {
            return {
                model: {
                    id: "id",
                    expanded: true
                }
            };
        };
        ;
        /**
         * Returns true if the provided physical adapter is on the context DVS (no matter
         * whether it was assigned throughout the wizard session lifetime or before that).
         *
         * @param pnicItem
         *    The item to check.
         */
        DvsSelectPhysicalAdaptersPageService.prototype.isPnicOnThisSwitch = function (pnicItem) {
            return pnicItem.parentId === pnicItem.onThisSwitchItemId;
        };
        /**
         * Returns true if the provided physical adapter is originally on the context DVS.
         *
         * @param pnicItemWrapper
         *    The item to check.
         *
         * @returns {boolean}
         */
        DvsSelectPhysicalAdaptersPageService.prototype.isPnicOriginallyOnThisSwitch = function (pnicItemWrapper) {
            var originalItem = pnicItemWrapper.originalItem;
            return originalItem.parentId === originalItem.onThisSwitchItemId;
        };
        /**
         * Returns true if the provided physical adapter is assigned to the dvs within
         * the wizard session lifetime.
         *
         * @param pnicItemWrapper
         *    The item to check.
         */
        DvsSelectPhysicalAdaptersPageService.prototype.isPnicAssigned = function (pnicItemWrapper) {
            var originalItem = pnicItemWrapper.originalItem;
            var pnicItem = pnicItemWrapper;
            var updatedItem = pnicItem;
            return this.isPnicOnThisSwitch(updatedItem) &&
                originalItem.parentId !== updatedItem.parentId;
        };
        /**
         * Returns true if the provided physical adapter is modified throughout the
         * lifetime of the wizard session.
         *
         * @param pnicItemWrapper
         *    The item to check.
         *
         * @returns {boolean}
         */
        DvsSelectPhysicalAdaptersPageService.prototype.isPnicModified = function (pnicItemWrapper) {
            var originalPnicItem = pnicItemWrapper.originalItem;
            var updatedItem = pnicItemWrapper;
            var updatedPnicItem = updatedItem;
            return originalPnicItem.parentId !== updatedPnicItem.parentId ||
                originalPnicItem.uplink !== updatedPnicItem.uplink ||
                originalPnicItem.uplinkPortgroup.key !==
                    updatedPnicItem.uplinkPortgroup.key;
        };
        /**
         * Returns true if the provided physical adapter is unassigned from the DVS within
         * the wizard session lifetime.
         *
         * @param pnicItemWrapper
         *    The item to check.
         *
         * @returns {boolean}
         */
        DvsSelectPhysicalAdaptersPageService.prototype.isPnicUnassigned = function (pnicItemWrapper) {
            var originalItem = pnicItemWrapper.originalItem;
            var originalPnicItem = originalItem;
            var updatedItem = pnicItemWrapper;
            var updatedPnicItem = updatedItem;
            return originalPnicItem.parentId === originalPnicItem.onThisSwitchItemId &&
                updatedPnicItem.parentId === originalPnicItem.onOtherSwitchesItemId;
        };
        /**
         * Returns the number of updated physical adapters in the wizard.
         *
         * @param treeListItems
         *    The array of all items on the Select physical adapters page.
         */
        DvsSelectPhysicalAdaptersPageService.prototype.getNumberOfUpdatedPhysicalAdapters = function (treeListItems) {
            var _this = this;
            var assignedAdapters = _.filter(treeListItems, function (treeListItem) {
                return treeListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE &&
                    _this.isPnicModified(treeListItem);
            });
            return assignedAdapters.length;
        };
        DvsSelectPhysicalAdaptersPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry"
        ];
        DvsSelectPhysicalAdaptersPageService.actionId = {
            ASSIGN_UPLINK: "assign-uplink-action",
            UNASSIGN_UPLINK: "unassign-uplink-action",
            VIEW_SETTINGS: "view-settings-action"
        };
        return DvsSelectPhysicalAdaptersPageService;
    }());
    dvs_ui.DvsSelectPhysicalAdaptersPageService = DvsSelectPhysicalAdaptersPageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectPhysicalAdaptersPageService", DvsSelectPhysicalAdaptersPageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectVirtualAdaptersPageService = (function () {
        function DvsSelectVirtualAdaptersPageService(i18nService, columnRenderersRegistry) {
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
        }
        /**
         * Returns the actionBarOptions object for the select virtual adapters page.
         *
         * @param assignPortgroupHandler
         *    The handler for the assign port group button.
         *
         * @param resetChangesHandler
         *    The handler for the reset changes button.
         */
        DvsSelectVirtualAdaptersPageService.prototype.getActionBarOptions = function (assignPortgroupHandler, resetChangesHandler, viewSettingsHandler) {
            return {
                actions: [{
                        id: "assign-portgroup-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.assignPortGroupButtonLabel"),
                        tooltipText: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.assignPortGroupButtonToolTipLabel"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-dvPortGroup",
                        onClick: assignPortgroupHandler
                    }, {
                        id: "reset-changes-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.revertVmkernelButtonLabel"),
                        tooltipText: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.revertVmkernelButtonTooltipLabel"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-undo",
                        onClick: resetChangesHandler
                    }, {
                        id: "view-settings-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.viewSelectedVnicDetailsButtonLabel"),
                        tooltipText: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.viewSelectedVnicDetailsButtonToolTipLabel"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-info",
                        onClick: viewSettingsHandler
                    }]
            };
        };
        /**
         * Reeturns the column definitions for the select virtual adapters page.
         */
        DvsSelectVirtualAdaptersPageService.prototype.getColumnDefs = function () {
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            return [{
                    field: "label",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.hostColumnHeader"),
                    // The width is calculated so that it can accommodate a host name
                    // that is an IPv6 address, e.g. "2001:0db8:0a0b:12f0:0000:0000:0000:0001".
                    width: "260px",
                    template: function (dataItem) {
                        return iconTextRenderer(["icon", "label"], {
                            icon: dataItem.iconClass,
                            label: dataItem.label
                        });
                    }
                }, {
                    field: "inUseBySwitch",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.switchColumnHeader"),
                    // Calculated so that it can accommodate "Inc Use by Switch" in English
                    // locale. Might be trimmed in other locales.
                    width: "114px",
                    template: function (dataItem) {
                        return textRenderer(["inUseBySwitch"], dataItem, true /*unescapeCharacters*/);
                    }
                }, {
                    field: "sourcePortgroup",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.sourcePortgroupColumnHeader"),
                    // Calculated so that it can accommodate "Source port group" in English
                    // locale. The maximum column width so that other column names are not
                    // trimmed in English. Typically the port group is the longes identifier
                    // (longer than the switch).
                    // Might be trimmed in non-English other locales.
                    width: "140px",
                    template: function (dataItem) {
                        return textRenderer(["sourcePortgroup"], dataItem, true /*unescapeCharacters*/);
                    }
                }, {
                    field: "destinationPortgroup",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.destPortgroupColumnHeader"),
                    template: function (dataItem) {
                        return textRenderer(["destinationPortgroup"], dataItem, true /*unescapeCharacters*/);
                    }
                }];
        };
        /**
         * Returns the schema for the hierarchical grid data model in the
         * select virtual adapters page.
         */
        DvsSelectVirtualAdaptersPageService.prototype.getTreeListSchema = function () {
            return {
                model: {
                    id: "id",
                    expanded: true
                }
            };
        };
        ;
        /**
         * Returns true if the provided virtual adapter is assigned to the dvs.
         *
         * @param pnicItem
         *    The item to check.
         */
        DvsSelectVirtualAdaptersPageService.prototype.isVnicAssigned = function (item) {
            var vnicItem = item;
            return vnicItem && vnicItem.parentId === vnicItem.onThisSwitchItemId;
        };
        /**
         * Returns true if the provided virtual adapter is modified throughout the
         * lifetime of the wizard session.
         *
         * @param vnicItemWrapper
         *    The item to check.
         */
        DvsSelectVirtualAdaptersPageService.prototype.isVnicModified = function (vnicItemWrapper) {
            var originalVnicItem = vnicItemWrapper.originalItem;
            var updatedItem = vnicItemWrapper;
            var updatedVnicItem = updatedItem;
            return originalVnicItem.parentId !== updatedVnicItem.parentId ||
                originalVnicItem.label !== updatedVnicItem.label;
        };
        /**
         * Returns the number of updated virtual adapters in the wizard.
         *
         * @param treeListItems
         *    The array of all items on the Select virtual adapters page.
         */
        DvsSelectVirtualAdaptersPageService.prototype.getNumberOfUpdatedVirtualAdapters = function (treeListItems) {
            var _this = this;
            var reassginedAdapters = _.filter(treeListItems, function (treeListItem) {
                return treeListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE &&
                    _this.isVnicModified(treeListItem);
            });
            return reassginedAdapters.length;
        };
        DvsSelectVirtualAdaptersPageService.$inject = [
            "i18nService",
            "columnRenderersRegistry"
        ];
        return DvsSelectVirtualAdaptersPageService;
    }());
    dvs_ui.DvsSelectVirtualAdaptersPageService = DvsSelectVirtualAdaptersPageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectVirtualAdaptersPageService", DvsSelectVirtualAdaptersPageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectVirtualMachinesPageService = (function () {
        function DvsSelectVirtualMachinesPageService(i18nService, columnRenderersRegistry) {
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
        }
        /**
         * Returns the actionBarOptions object for the select virtual machines page.
         *
         * @param assignPortgroupHandler
         *    The handler for the assign port group button.
         *
         * @param resetChangesHandler
         *    The handler for the reset changes button.
         */
        DvsSelectVirtualMachinesPageService.prototype.getActionBarOptions = function (assignPortgroupHandler, resetChangesHandler, viewSettingsHandler) {
            return {
                actions: [{
                        id: "assign-portgroup-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.assignPortGroupButton.title"),
                        tooltipText: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.assignPortGroupButton.tooltip"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-dvPortGroup",
                        onClick: assignPortgroupHandler
                    }, {
                        id: "reset-changes-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.unassignPortGroupButton.title"),
                        tooltipText: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.unassignPortGroupButton.tooltip"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-undo",
                        onClick: resetChangesHandler
                    }, {
                        id: "view-settings-action",
                        label: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.viewSelectedVnicDetailsButton.title"),
                        // Disabled initially, only enabled when selection occurs.
                        enabled: false,
                        iconClass: "network-lib-ui-icon-info",
                        onClick: viewSettingsHandler
                    }]
            };
        };
        /**
         * Reeturns the column definitions for the select virtual machines page.
         */
        DvsSelectVirtualMachinesPageService.prototype.getColumnDefs = function () {
            var _this = this;
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            return [{
                    field: "label",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.hostVmVnic"),
                    // The width is calculated so that it can accommodate a host name
                    // that is an IPv6 address, e.g. "2001:0db8:0a0b:12f0:0000:0000:0000:0001".
                    width: "260px",
                    template: function (dataItem) {
                        return iconTextRenderer(["icon", "label"], {
                            icon: dataItem.iconClass,
                            label: dataItem.label
                        });
                    }
                }, {
                    field: "nicCount",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.nicCount"),
                    width: "84px",
                    template: function (dataItem) {
                        return textRenderer(["nicCount"], dataItem);
                    }
                }, {
                    field: "sourcePortgroup",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.sourcePortgroup"),
                    // Calculated so that it can accommodate "Source port group" in English
                    // locale. The maximum column width so that other column names are not
                    // trimmed in English.
                    // Might be trimmed in non-English other locales.
                    width: "142px",
                    template: function (dataItem) {
                        return textRenderer(["sourcePortgroup"], dataItem);
                    }
                }, {
                    field: "destinationPortgroup",
                    title: this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.destPortgroup"),
                    template: function (dataItem) {
                        if (dataItem.type ===
                            dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                            // A VM.
                            var label = dataItem.isReassigned
                                ? _this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.virtualMachineState.reassigned")
                                : "";
                            return $("<span/>")
                                .attr("ng-non-bindable", "")
                                .addClass("dvs-add-host-vm-reassigned-column")
                                .text(label)[0].outerHTML;
                        }
                        else {
                            // An  adapter or a host.
                            return textRenderer(["destinationPortgroup"], dataItem);
                        }
                    }
                }];
        };
        /**
         * Returns the schema for the hierarchical grid data model in the
         * select virtual machines page.
         */
        DvsSelectVirtualMachinesPageService.prototype.getTreeListSchema = function () {
            return {
                model: {
                    id: "id",
                    expanded: false
                }
            };
        };
        ;
        /**
         * Returns true if the provided VM virtual adapter is modified throughout the
         * lifetime of the wizard session.
         *
         * @param vnicItemWrapper
         *    The item to check.
         */
        DvsSelectVirtualMachinesPageService.prototype.isVnicModified = function (vnicItemWrapper) {
            var originalVnicItem = vnicItemWrapper.originalItem;
            var updatedItem = vnicItemWrapper;
            var updatedVnicItem = updatedItem;
            return originalVnicItem.destinationPortgroupRef !==
                updatedVnicItem.destinationPortgroupRef;
        };
        /**
         * Returns the number of updated virtual machines adapters in the wizard.
         *
         * @param treeListItems
         *    The array of all items on the Select virtual machines page.
         */
        DvsSelectVirtualMachinesPageService.prototype.getNumberOfUpdatedVirtualMachineAdapters = function (treeListItems) {
            var _this = this;
            var reassginedAdapters = _.filter(treeListItems, function (treeListItem) {
                return treeListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE &&
                    _this.isVnicModified(treeListItem);
            });
            return reassginedAdapters.length;
        };
        /**
         * Expands only the host items in the hosts/vms grid.
         *
         * @param treeListWidget
         *    A reference to the the kendo data grid.
         * @param treeListDataSource
         *    The data source of the grid.
         */
        DvsSelectVirtualMachinesPageService.prototype.expandHostItems = function (treeListWidget, treeListDataSource) {
            var itemExpanded = false;
            if (!treeListDataSource || !treeListWidget) {
                return itemExpanded;
            }
            _.forEach(treeListDataSource.rootNodes(), function (item) {
                if (item.parentId === null) {
                    // Expand the host items
                    var hostItemRow = treeListWidget.itemFor(item);
                    if (hostItemRow && !hostItemRow.expanded) {
                        treeListWidget.expand(hostItemRow);
                        itemExpanded = true;
                    }
                }
            });
            return itemExpanded;
        };
        DvsSelectVirtualMachinesPageService.$inject = [
            "i18nService",
            "columnRenderersRegistry"
        ];
        return DvsSelectVirtualMachinesPageService;
    }());
    dvs_ui.DvsSelectVirtualMachinesPageService = DvsSelectVirtualMachinesPageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectVirtualMachinesPageService", DvsSelectVirtualMachinesPageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PnicSettingsDialogService = (function () {
        function PnicSettingsDialogService(i18nService, clarityModalService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        PnicSettingsDialogService.prototype.show = function (hostId, pnicDevice, hostname) {
            var templateUrl = "dvs-ui/resources/dvs/addhost/services/pnicSettingsDialog.html";
            var title = this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.pnicPopupTitle", pnicDevice, hostname);
            var dialogData = {
                title: title,
                hostId: hostId,
                pnicDevice: pnicDevice,
            };
            this.clarityModalService.openModal(undefined, [], dialogData, templateUrl);
        };
        PnicSettingsDialogService.$inject = [
            "i18nService",
            "clarityModalService"
        ];
        return PnicSettingsDialogService;
    }());
    dvs_ui.PnicSettingsDialogService = PnicSettingsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("pnicSettingsDialogService", PnicSettingsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var SelectHostsDialogService = (function () {
        function SelectHostsDialogService(i18nService, clarityModalService, authorizationService, defaultUriSchemeUtil, clarityConstants) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.authorizationService = authorizationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityConstants = clarityConstants;
        }
        SelectHostsDialogService.prototype.show = function (hostsPromise, okHandler, dialogTitle, showVdsStateColumn, showIncompatibleHostsButton, allowAnySelection, dvsId) {
            var _this = this;
            var selectedHostItems = [];
            var dialogData = {
                onSelectedHostsChange: function (value) {
                    selectedHostItems = value;
                },
                showVdsStateColumn: showVdsStateColumn,
                allowAnySelection: allowAnySelection,
                showIncompatibleHostsButton: showIncompatibleHostsButton,
                loading: true
            };
            var modalOptions = {
                title: dialogTitle,
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                dialogData: dialogData,
                contentTemplate: "dvs-ui/resources/dvs/addhost/components/selectHosts/selectHostsDialog.html",
                modalClass: "dvs-select-hosts-modal",
                subTitle: {
                    objectId: dvsId
                }
            };
            var getHostNamesWithoutPrivileges = function (privilegesPerObjectId) {
                var entriesWithoutPrivileges = _.filter(_.pairs(privilegesPerObjectId), function (entry) {
                    return !entry[1][dvs_ui.Privileges.HOST_CONFIG_NETWORK];
                });
                return _.map(entriesWithoutPrivileges, function (entry) {
                    var itemWithoutPrivileges = _.find(selectedHostItems, function (item) {
                        return entry[0] === _this.defaultUriSchemeUtil.getVsphereObjectId(item.hostRef);
                    });
                    return itemWithoutPrivileges.hostName;
                });
            };
            modalOptions.onSubmit = function () {
                var hostObjectIds = _this.defaultUriSchemeUtil.getVsphereObjectIds(_.map(selectedHostItems, function (item) { return item.hostRef; }));
                return _this.authorizationService.checkPrivilegesForMultipleObjects(hostObjectIds, [dvs_ui.Privileges.HOST_CONFIG_NETWORK])
                    .then(getHostNamesWithoutPrivileges)
                    .then(function (hostNamesWithoutPrivileges) {
                    if (hostNamesWithoutPrivileges.length > 0) {
                        modalOptions.alerts = [{
                                text: _this.i18nService.getString("DvsUi", "DvsSelectHostsDialog.noPrivileges", hostNamesWithoutPrivileges.join(", ")),
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    else {
                        okHandler(selectedHostItems);
                        return true;
                    }
                });
            };
            hostsPromise
                .then(function (hosts) {
                dialogData.hosts = hosts;
                dialogData.loading = false;
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        SelectHostsDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "clarityConstants"
        ];
        return SelectHostsDialogService;
    }());
    dvs_ui.SelectHostsDialogService = SelectHostsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("selectHostsDialogService", SelectHostsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var UnassingUplinkDialogService = (function () {
        function UnassingUplinkDialogService(i18nService, clarityModalService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        UnassingUplinkDialogService.prototype.show = function (pnic, okHandler) {
            var dialogData = {
                applyToAll: false,
                applyToAllLabel: this.i18nService.getString("DvsUi", "unassignUplinkDialog.applyToAllLabel"),
                pnicName: pnic
            };
            this.modalOptions = {
                title: this.i18nService.getString("DvsUi", "unassignUplinkDialog.title"),
                subTitle: { text: pnic },
                defaultButton: "submit",
                saveButtonLabel: this.i18nService.getString("DvsUi", "unassignUplinkDialog.unassignBtn"),
                alerts: [],
                dialogData: dialogData,
                contentTemplate: "dvs-ui/resources/dvs/addhost/components/unassignUplink/unassignUplinkDialog.html",
                submit: function () {
                    okHandler(dialogData.applyToAll);
                    return true;
                }
            };
            this.clarityModalService.openConfirmationModal(this.modalOptions);
        };
        UnassingUplinkDialogService.$inject = [
            "i18nService",
            "clarityModalService"
        ];
        return UnassingUplinkDialogService;
    }());
    dvs_ui.UnassingUplinkDialogService = UnassingUplinkDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("unassingUplinkDialogService", UnassingUplinkDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmVnicSettingsDialogService = (function () {
        function VmVnicSettingsDialogService(clarityModalService) {
            this.clarityModalService = clarityModalService;
        }
        VmVnicSettingsDialogService.prototype.show = function (vmName, vmRef, vmVnicKey) {
            var templateUrl = "dvs-ui/resources/dvs/addhost/services/vmVnicSettingsDialog.html";
            var dialogData = {
                title: vmName,
                vmVnicKey: vmVnicKey,
                vmRef: vmRef
            };
            this.clarityModalService.openModal(undefined, [], dialogData, templateUrl);
        };
        VmVnicSettingsDialogService.$inject = [
            "clarityModalService"
        ];
        return VmVnicSettingsDialogService;
    }());
    dvs_ui.VmVnicSettingsDialogService = VmVnicSettingsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("vmVnicSettingsDialogService", VmVnicSettingsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VnicSettingsDialogService = (function () {
        function VnicSettingsDialogService(i18nService, clarityModalService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        VnicSettingsDialogService.prototype.show = function (hostId, vnicDevice, hostname) {
            var templateUrl = "dvs-ui/resources/dvs/addhost/services/vnicSettingsDialog.html";
            var title = this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.vnicPopupTitle", vnicDevice, hostname);
            var dialogData = {
                title: title,
                hostId: hostId,
                vnicDevice: vnicDevice,
            };
            this.clarityModalService.openModal(undefined, [], dialogData, templateUrl);
        };
        VnicSettingsDialogService.$inject = [
            "i18nService",
            "clarityModalService"
        ];
        return VnicSettingsDialogService;
    }());
    dvs_ui.VnicSettingsDialogService = VnicSettingsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("vnicSettingsDialogService", VnicSettingsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectHostsPageValidator = (function () {
        function DvsSelectHostsPageValidator(i18nService) {
            this.i18nService = i18nService;
        }
        DvsSelectHostsPageValidator.prototype.getValidationError = function (hosts) {
            var errors = [];
            if (hosts.length === 0) {
                errors.push(this.i18nService.getString("DvsUi", "SelectHostsPage.validator.noHostsSelected"));
            }
            return errors;
        };
        DvsSelectHostsPageValidator.$inject = ["i18nService"];
        return DvsSelectHostsPageValidator;
    }());
    dvs_ui.DvsSelectHostsPageValidator = DvsSelectHostsPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectHostsPageValidator", DvsSelectHostsPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var DvsSelectPhysicalAdaptersPageValidator = dvs_ui.DvsSelectPhysicalAdaptersPageValidator;
var DvsSelectPhysicalAdaptersPageModel = dvs_ui.DvsSelectPhysicalAdaptersPageModel;
var DvsAddHostHierarchicalListGroupingItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListGroupingItem;
var DvsAddHostHierarchicalListItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListItem;
var dvs_ui;
(function (dvs_ui) {
    /**
     * A validator class for the Select Physical Adapters page.
     */
    var DvsSelectPhysicalAdaptersPageValidator = (function () {
        function DvsSelectPhysicalAdaptersPageValidator(i18nService, clarityModalService, $q) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
        }
        /**
         * Validates the supplied pageModel.
         *
         * Shows warnings/errors if such exist and returns a promise with the validation
         * result.
         */
        DvsSelectPhysicalAdaptersPageValidator.prototype.validate = function (pageModel) {
            var maxUplinksCount = 0;
            if (pageModel && pageModel.uplinkNames) {
                maxUplinksCount += pageModel.uplinkNames.length;
            }
            var onThisSwitchGroupingItems = _.filter(pageModel.hosts, function (item) {
                if (item && item.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.GROUPING_TYPE) {
                    var listItem = item;
                    var groupingItem = listItem;
                    return groupingItem.isOnThisSwitch;
                }
                return false;
            });
            var groupingItemIdToNumberOfPnicsMap = {};
            _.each(onThisSwitchGroupingItems, function (groupingItem) {
                groupingItemIdToNumberOfPnicsMap[groupingItem.id] = 0;
            });
            _.each(pageModel.hosts, function (item) {
                if (item && item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                    // If the pnic is assigned to the DVS.
                    groupingItemIdToNumberOfPnicsMap[item.parentId]++;
                }
            });
            var deferred = this.$q.defer();
            if (_.some(_.values(groupingItemIdToNumberOfPnicsMap), function (pnicsCount) {
                return pnicsCount > maxUplinksCount;
            })) {
                this.clarityModalService.openConfirmationModal({
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.error"),
                    message: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.uplinkError"),
                    clarityIcon: {
                        class: "is-error",
                        shape: "error-standard",
                        size: "32"
                    },
                    saveButtonLabel: this.i18nService.getString("Common", "alert.ok"),
                    hideCancelButton: true,
                    submit: function () {
                        deferred.resolve(false);
                    }
                });
            }
            else if (_.some(_.values(groupingItemIdToNumberOfPnicsMap), function (pnicsCount) {
                return pnicsCount === 0;
            })) {
                this.clarityModalService.openConfirmationModal({
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.warning"),
                    message: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.noPnicsSelected"),
                    clarityIcon: {
                        class: "is-warning",
                        shape: "warning-standard",
                        size: "32"
                    },
                    preserveNewlines: true,
                    submit: function () {
                        deferred.resolve(true);
                    },
                    onCancel: function () {
                        deferred.resolve(false);
                    }
                });
            }
            else {
                deferred.resolve(true);
            }
            return deferred.promise;
        };
        DvsSelectPhysicalAdaptersPageValidator.$inject = ["i18nService",
            "clarityModalService",
            "$q"];
        return DvsSelectPhysicalAdaptersPageValidator;
    }());
    dvs_ui.DvsSelectPhysicalAdaptersPageValidator = DvsSelectPhysicalAdaptersPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectPhysicalAdaptersPageValidator", DvsSelectPhysicalAdaptersPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var HostListItemData = com.vmware.vsphere.client.dvs.api.host.HostListItemData;
var DvsAddHostHierarchicalListHostItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListHostItem;
var DvsAddHostHierarchicalListPnicItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListPnicItem;
var DvsAddHostHierarchicalListVnicItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListVnicItem;
var dvs_ui;
(function (dvs_ui) {
    var SwitchConfig = (function () {
        function SwitchConfig() {
            this.pnics = [];
            this.vnics = [];
        }
        return SwitchConfig;
    }());
    var HostConfig = (function () {
        function HostConfig() {
        }
        return HostConfig;
    }());
    var DvsSelectVirtualAdaptersPageValidator = (function () {
        function DvsSelectVirtualAdaptersPageValidator(i18nService, dvsSelectPhysicalAdaptersPageService, dvsSelectVirtualAdaptersPageService, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.dvsSelectPhysicalAdaptersPageService = dvsSelectPhysicalAdaptersPageService;
            this.dvsSelectVirtualAdaptersPageService = dvsSelectVirtualAdaptersPageService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            /**
             * A special value representing the name of this switch (the context switch).
             * We don't have the actual name here and we don't care what it actually is as
             * long as we can pick a value which does not coincide with some other switch name.
             * Empty string is invalid for a switch name so it is a safe pick.
             */
            this.THIS_SWITCH_NAME = "";
        }
        DvsSelectVirtualAdaptersPageValidator.prototype.getValidationError = function (hosts, pnics, vnics) {
            hosts = _.filter(hosts, function (itemWrapper) {
                return (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE);
            });
            pnics = _.filter(pnics, function (itemWrapper) {
                return (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE);
            });
            var hostConfigMap = {};
            this.addHosts(hostConfigMap, hosts);
            this.addPnics(hostConfigMap, pnics);
            this.addVnics(hostConfigMap, vnics);
            var hostWithError = _.find(_.values(hostConfigMap), function (hostConfig) {
                var switchForMgmt = _.find(_.values(hostConfig.standardSwitches)
                    .concat(_.values(hostConfig.distributedSwitches)), function (standardSwitchConfig) {
                    return standardSwitchConfig.vnics &&
                        standardSwitchConfig.vnics.length > 0 &&
                        standardSwitchConfig.pnics &&
                        standardSwitchConfig.pnics.length > 0;
                });
                return !switchForMgmt;
            });
            var errors = [];
            if (hostWithError) {
                errors.push(this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.errorForNetworkConnectivityLoss", hostWithError.name));
            }
            return errors;
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.getVnicsWithConnectivityWarning = function (hosts, pnics, vnics) {
            var _this = this;
            hosts = _.filter(hosts, function (itemWrapper) {
                return (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE);
            });
            pnics = _.filter(pnics, function (itemWrapper) {
                return (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE);
            });
            var hostConfigMap = {};
            this.addHosts(hostConfigMap, hosts);
            this.addPnics(hostConfigMap, pnics);
            var originalHostConfigMap = {};
            this.addHosts(originalHostConfigMap, hosts);
            this.addOriginalPnics(originalHostConfigMap, pnics);
            var notAssignedVnics = _.filter(vnics, function (itemWrapper) {
                return (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE
                    && !_this.dvsSelectVirtualAdaptersPageService.isVnicAssigned(itemWrapper));
            });
            return _.filter(notAssignedVnics, function (itemWrapper) {
                var item = itemWrapper;
                var vnicItem = item;
                var switchConfig = _this.getSwitchConfigForVnic(hostConfigMap, vnicItem);
                var originalSwitchConfig = _this.getSwitchConfigForVnic(originalHostConfigMap, vnicItem);
                return switchConfig.pnics.length === 0 && originalSwitchConfig.pnics.length > 0;
            });
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.addHosts = function (hostConfigMap, hosts) {
            var _this = this;
            _.each(hosts, function (itemWrapper) {
                var item = itemWrapper;
                var hostItem = item;
                var hostConfig = new HostConfig();
                hostConfig.name = hostItem.label;
                hostConfig.standardSwitches = {};
                hostConfig.distributedSwitches = {};
                hostConfigMap[_this.defaultUriSchemeUtil.getVsphereObjectId(hostItem.hostRef)] =
                    hostConfig;
            });
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.addOriginalPnics = function (hostConfigMap, pnics) {
            var _this = this;
            _.each(_.map(pnics, function (pnic) { return pnic.originalItem; }), function (originalPnicItem) {
                return _this.addPnicItem(hostConfigMap, originalPnicItem);
            });
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.addPnics = function (hostConfigMap, pnics) {
            var _this = this;
            var notUnassginedPnics = _.filter(pnics, function (itemWrapper) {
                return !_this.dvsSelectPhysicalAdaptersPageService.isPnicUnassigned(itemWrapper);
            });
            _.each(notUnassginedPnics, function (pnic) { return _this.addPnicItem(hostConfigMap, pnic); });
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.addPnicItem = function (hostConfigMap, item) {
            var pnicItem = item;
            var hostConfig = hostConfigMap[this.defaultUriSchemeUtil.getVsphereObjectId(pnicItem.hostRef)];
            var switchesMap = this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(pnicItem)
                || !pnicItem.isStandardSwitch
                ? hostConfig.distributedSwitches : hostConfig.standardSwitches;
            var switchName = null;
            if (this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(pnicItem)) {
                switchName = this.THIS_SWITCH_NAME;
            }
            else if (pnicItem.isAssigned) {
                // inUseBySwitch cannot be empty and cannot be this switch.
                switchName = pnicItem.inUseBySwitch;
            }
            if (switchName !== null) {
                var switchConfig = this.getOrCreateSwitchConfig(switchesMap, switchName);
                switchConfig.pnics.push(pnicItem.device);
            }
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.addVnics = function (hostConfigMap, vnics) {
            var _this = this;
            _.each(vnics, function (item) {
                if (item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                    var vnicItem = item;
                    if (vnicItem.isOnManagementStack) {
                        // Ignore vnics on other stacks as they cannot be used for management
                        // traffic.
                        var switchConfig = _this.getSwitchConfigForVnic(hostConfigMap, vnicItem);
                        switchConfig.vnics.push(vnicItem.device);
                    }
                }
            });
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.getSwitchConfigForVnic = function (hostConfigMap, vnicItem) {
            var hostConfig = hostConfigMap[this.defaultUriSchemeUtil.getVsphereObjectId(vnicItem.hostRef)];
            var switchesMap = this.dvsSelectVirtualAdaptersPageService.isVnicAssigned(vnicItem)
                || !vnicItem.isStandardSwitch
                ? hostConfig.distributedSwitches : hostConfig.standardSwitches;
            var switchName;
            if (this.dvsSelectVirtualAdaptersPageService.isVnicAssigned(vnicItem)) {
                switchName = this.THIS_SWITCH_NAME;
            }
            else {
                // inUseBySwitch cannot be empty and cannot be this switch.
                switchName = vnicItem.inUseBySwitch;
            }
            return this.getOrCreateSwitchConfig(switchesMap, switchName);
        };
        DvsSelectVirtualAdaptersPageValidator.prototype.getOrCreateSwitchConfig = function (switchesMap, switchName) {
            var result = switchesMap[switchName];
            if (!result) {
                result = new SwitchConfig();
                switchesMap[switchName] = result;
            }
            return result;
        };
        DvsSelectVirtualAdaptersPageValidator.$inject = ["i18nService",
            "dvsSelectPhysicalAdaptersPageService",
            "dvsSelectVirtualAdaptersPageService",
            "defaultUriSchemeUtil"];
        return DvsSelectVirtualAdaptersPageValidator;
    }());
    dvs_ui.DvsSelectVirtualAdaptersPageValidator = DvsSelectVirtualAdaptersPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectVirtualAdaptersPageValidator", DvsSelectVirtualAdaptersPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectVirtualMachinesPageValidator = (function () {
        function DvsSelectVirtualMachinesPageValidator(i18nService, authorizationService, $q, dvsSelectVirtualMachinesPageService, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.authorizationService = authorizationService;
            this.$q = $q;
            this.dvsSelectVirtualMachinesPageService = dvsSelectVirtualMachinesPageService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Validates the supplied pageModel.
         *
         * Returns a promise containing validation errors if such exist.
         */
        DvsSelectVirtualMachinesPageValidator.prototype.getValidationError = function (pageModel) {
            var _this = this;
            var deferred = this.$q.defer();
            if (!pageModel || !pageModel.hosts || pageModel.hosts.length === 0) {
                deferred.resolve([]);
                return deferred.promise;
            }
            var vmEditDevicePrivilege = "VirtualMachine.Config.EditDevice";
            var vmsToUpdate = [];
            _.each(pageModel.hosts, function (vmVnicListItem) {
                if (vmVnicListItem && vmVnicListItem.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE &&
                    _this.dvsSelectVirtualMachinesPageService.isVnicModified(vmVnicListItem)) {
                    var listItem = vmVnicListItem;
                    var vnicItem = listItem;
                    vmsToUpdate.push(_this.defaultUriSchemeUtil.getVsphereObjectId(vnicItem.vmRef));
                }
            });
            if (!vmsToUpdate || vmsToUpdate.length === 0) {
                deferred.resolve([]);
                return deferred.promise;
            }
            this.authorizationService
                .checkPrivilegesForMultipleObjects(vmsToUpdate, [vmEditDevicePrivilege])
                .then(function (privilegesById) {
                var validationMessages = [];
                // Collect the VMs that do not have edit privilege granted.
                Object.keys(privilegesById).forEach(function (id) {
                    if (privilegesById[id][vmEditDevicePrivilege] === false) {
                        var vmName = _this.getVmName(id, pageModel.hosts);
                        validationMessages.push(_this.i18nService.getString("DvsUi", "SelectVirtualMachinesPage.errorNoPermissionForVm", vmName));
                    }
                });
                deferred.resolve(validationMessages);
            });
            return deferred.promise;
        };
        DvsSelectVirtualMachinesPageValidator.prototype.getVmName = function (id, items) {
            var _this = this;
            var vmItem = _.find(items, function (item) {
                if (item && item.type ===
                    dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                    var listItem = item;
                    var vmItem_1 = listItem;
                    return id === _this.defaultUriSchemeUtil.getVsphereObjectId(vmItem_1.vmRef);
                }
                return false;
            });
            if (vmItem) {
                return vmItem.label;
            }
            else {
                return "";
            }
        };
        DvsSelectVirtualMachinesPageValidator.$inject = ["i18nService",
            "authorizationService",
            "$q",
            "dvsSelectVirtualMachinesPageService",
            "defaultUriSchemeUtil"];
        return DvsSelectVirtualMachinesPageValidator;
    }());
    dvs_ui.DvsSelectVirtualMachinesPageValidator = DvsSelectVirtualMachinesPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSelectVirtualMachinesPageValidator", DvsSelectVirtualMachinesPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostReadyToCompletePageController = (function () {
        function DvsAddHostReadyToCompletePageController($scope, i18nService, vxPropertyViewService, dvsSelectPhysicalAdaptersPageService, dvsSelectVirtualAdaptersPageService, dvsSelectVirtualMachinesPageService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.dvsSelectPhysicalAdaptersPageService = dvsSelectPhysicalAdaptersPageService;
            this.dvsSelectVirtualAdaptersPageService = dvsSelectVirtualAdaptersPageService;
            this.dvsSelectVirtualMachinesPageService = dvsSelectVirtualMachinesPageService;
            var operationType = $scope.model.selectOperationPageModel.selectedOperationType;
            var builder = vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            if (operationType === dvs_ui.DvsAddHostWizardConstants.operationType.ADD_HOST) {
                generalSection.title(i18nService.getString("DvsUi", "ManageHostsSummayPage.heading.hostsForUpdate"));
                generalSection.property(i18nService.getString("DvsUi", "ManageHostsSummayPage.property.hostsToAddCount"), $scope.model.selectHostsPageModel.hosts.length);
            }
            else if (operationType === dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST) {
                generalSection.title(this.i18nService.getString("DvsUi", "ManageHostsSummayPage.heading.hostsForUpdate"));
                generalSection.property(i18nService.getString("DvsUi", "ManageHostsSummayPage.property.hostsToUpdateCount"), $scope.model.selectHostsToManagePageModel.hosts.length);
            }
            else if (operationType === dvs_ui.DvsAddHostWizardConstants.operationType.REMOVE_HOST) {
                generalSection.property(i18nService.getString("DvsUi", "ManageHostsSummayPage.property.hostsToRemoveCount"), $scope.model.selectHostsToRemovePageModel.hosts.length);
            }
            var numberOfUpdatedPhysicalAdapters = this.dvsSelectPhysicalAdaptersPageService
                .getNumberOfUpdatedPhysicalAdapters($scope.model.selectPhysicalAdaptersPageModel.hosts);
            var numberOfUpdatedVirtualAdapters = this.dvsSelectVirtualAdaptersPageService
                .getNumberOfUpdatedVirtualAdapters($scope.model.selectVirtualAdaptersPageModel.hosts);
            var numberOfUpdatedVirtualMachineAdapters = this.dvsSelectVirtualMachinesPageService
                .getNumberOfUpdatedVirtualMachineAdapters($scope.model.selectVirtualMachinesPageModel.hosts);
            if (operationType !== dvs_ui.DvsAddHostWizardConstants.operationType.REMOVE_HOST &&
                (numberOfUpdatedPhysicalAdapters > 0
                    || numberOfUpdatedVirtualAdapters > 0
                    || numberOfUpdatedVirtualMachineAdapters > 0)) {
                // Show number of network adapters summary section only when such are
                // reassigned.
                var numberOfNetworkAdaptersSection = generalCategory.section("networkAdapters")
                    .title(i18nService.getString("DvsUi", "ManageHostsSummayPage.heading.adaptersForUpdate"));
                if (numberOfUpdatedPhysicalAdapters > 0) {
                    numberOfNetworkAdaptersSection.property(i18nService.getString("DvsUi", "ManageHostsSummayPage.property.pNicsCount"), numberOfUpdatedPhysicalAdapters);
                }
                if (numberOfUpdatedVirtualAdapters > 0) {
                    numberOfNetworkAdaptersSection.property(i18nService.getString("DvsUi", "ManageHostsSummayPage.property.vNicsReassignedCount"), numberOfUpdatedVirtualAdapters);
                }
                if (numberOfUpdatedVirtualMachineAdapters > 0) {
                    numberOfNetworkAdaptersSection.property(this.i18nService.getString("DvsUi", "ManageHostsSummayPage.property.vmNicsCount"), numberOfUpdatedVirtualMachineAdapters);
                }
            }
            this.$scope.model.summaryData = builder.build();
        }
        DvsAddHostReadyToCompletePageController.$inject = [
            "$scope",
            "i18nService",
            "vxPropertyViewService",
            "dvsSelectPhysicalAdaptersPageService",
            "dvsSelectVirtualAdaptersPageService",
            "dvsSelectVirtualMachinesPageService"
        ];
        return DvsAddHostReadyToCompletePageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsAddHostReadyToCompletePageController", DvsAddHostReadyToCompletePageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectHostsPageController = (function () {
        function DvsSelectHostsPageController($scope, dataService, $q) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.$q = $q;
        }
        DvsSelectHostsPageController.prototype.onHostsChanged = function (addedHosts) {
            this.$scope.model.selectHostsPageModel.hosts = addedHosts;
        };
        DvsSelectHostsPageController.prototype.requestHosts = function () {
            var _this = this;
            if (!this.allHosts) {
                return this.dataService.getProperties(this.$scope.model.dvsId, [DvsSelectHostsPageController.NEW_HOSTS_DATA_PROP])
                    .then(function (response) {
                    var data = response[DvsSelectHostsPageController.NEW_HOSTS_DATA_PROP];
                    if (data) {
                        _this.allHosts = data.hosts;
                    }
                    else {
                        _this.allHosts = [];
                    }
                    return _this.allHosts;
                });
            }
            else {
                return this.$q.when(this.allHosts);
            }
        };
        DvsSelectHostsPageController.NEW_HOSTS_DATA_PROP = "dvs:newHostsData";
        DvsSelectHostsPageController.$inject = ["$scope",
            "dataService",
            "$q"];
        return DvsSelectHostsPageController;
    }());
    dvs_ui.DvsSelectHostsPageController = DvsSelectHostsPageController;
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectHostsPageController", DvsSelectHostsPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectHostsToManagePageController = (function () {
        function DvsSelectHostsToManagePageController($scope, dataService, $q) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.$q = $q;
        }
        DvsSelectHostsToManagePageController.prototype.onHostsChanged = function (addedHosts) {
            this.$scope.model.selectHostsToManagePageModel.hosts = addedHosts;
        };
        DvsSelectHostsToManagePageController.prototype.requestHosts = function () {
            var _this = this;
            if (!this.allHosts) {
                return this.dataService.getProperties(this.$scope.model.dvsId, [DvsSelectHostsToManagePageController.DVS_HOSTS_DATA_PROP])
                    .then(function (response) {
                    var data = response[DvsSelectHostsToManagePageController.DVS_HOSTS_DATA_PROP];
                    if (data) {
                        _this.allHosts = data.dvsHosts;
                    }
                    else {
                        _this.allHosts = [];
                    }
                    return _this.allHosts;
                });
            }
            else {
                return this.$q.when(this.allHosts);
            }
        };
        DvsSelectHostsToManagePageController.DVS_HOSTS_DATA_PROP = "dvs:dvsHostsData";
        DvsSelectHostsToManagePageController.$inject = ["$scope",
            "dataService",
            "$q"];
        return DvsSelectHostsToManagePageController;
    }());
    dvs_ui.DvsSelectHostsToManagePageController = DvsSelectHostsToManagePageController;
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectHostsToManagePageController", DvsSelectHostsToManagePageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSelectHostsToRemovePageController = (function () {
        function DvsSelectHostsToRemovePageController($scope, dataService, $q) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.$q = $q;
        }
        DvsSelectHostsToRemovePageController.prototype.onHostsChanged = function (addedHosts) {
            this.$scope.model.selectHostsToRemovePageModel.hosts = addedHosts;
        };
        DvsSelectHostsToRemovePageController.prototype.requestHosts = function () {
            var _this = this;
            if (!this.allHosts) {
                return this.dataService.getProperties(this.$scope.model.dvsId, [DvsSelectHostsToRemovePageController.DVS_HOSTS_DATA_PROP])
                    .then(function (response) {
                    var data = response[DvsSelectHostsToRemovePageController.DVS_HOSTS_DATA_PROP];
                    if (data) {
                        _this.allHosts = data.dvsHosts;
                    }
                    else {
                        _this.allHosts = [];
                    }
                    return _this.allHosts;
                });
            }
            else {
                return this.$q.when(this.allHosts);
            }
        };
        DvsSelectHostsToRemovePageController.DVS_HOSTS_DATA_PROP = "dvs:dvsHostsData";
        DvsSelectHostsToRemovePageController.$inject = ["$scope",
            "dataService",
            "$q"];
        return DvsSelectHostsToRemovePageController;
    }());
    dvs_ui.DvsSelectHostsToRemovePageController = DvsSelectHostsToRemovePageController;
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectHostsToRemovePageController", DvsSelectHostsToRemovePageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostHierarchicalListItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListItem;
    var DvsHostsSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvsHostsSpec;
    var DvPortgroupModel = com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvPortgroupModel;
    var DvsSelectPhysicalAdaptersPageController = (function () {
        function DvsSelectPhysicalAdaptersPageController($q, $wizardScope, i18nService, dataService, dvsSelectPhysicalAdaptersPageService, assingUplinkDialogService, unassingUplinkDialogService, clarityModalService, pnicSettingsDialogService, defaultUriSchemeUtil, networkUtil) {
            this.$q = $q;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.dvsSelectPhysicalAdaptersPageService = dvsSelectPhysicalAdaptersPageService;
            this.assingUplinkDialogService = assingUplinkDialogService;
            this.unassingUplinkDialogService = unassingUplinkDialogService;
            this.clarityModalService = clarityModalService;
            this.pnicSettingsDialogService = pnicSettingsDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.networkUtil = networkUtil;
            this._actionsMap = new Object();
            this.treeListWidget = null;
            this.actionBarOptions =
                this.dvsSelectPhysicalAdaptersPageService.getActionBarOptions(this.onAssignUplinkClicked.bind(this), this.onViewSettingsClicked.bind(this), this.onUnassignUplinkClicked.bind(this));
            this.initActionsMap(this.actionBarOptions.actions, this._actionsMap);
            if (!this.$wizardScope.model.selectPhysicalAdaptersPageModel.isInitialized) {
                // Initialize physical adapters tree list with empty data provider
                // so that it is rendered while loading the data.
                this.initializePhysicalAdaptersTreeList([]);
                this.requestPageData();
            }
            else {
                this.initializePhysicalAdaptersTreeList(this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts);
            }
            this.$wizardScope.$on("$destroy", function () {
                kendo.destroy($(".dvs-add-host-adapters-tree-list"));
            });
        }
        DvsSelectPhysicalAdaptersPageController.prototype.updateToolbar = function () {
            if (this.treeListWidget === null) {
                return;
            }
            var row = this.treeListWidget.select();
            var data = this.treeListWidget.dataItem(row);
            this._selectedItem = data;
            if (!data) {
                // No item is selected, typically triggered by a deselection.
                // Disable all actions.
                _.each(this.actionBarOptions.actions, function (action) {
                    action.enabled = false;
                });
            }
            if (data && data.type) {
                var assignUplinkAction = this._actionsMap[dvs_ui.DvsSelectPhysicalAdaptersPageService.actionId.ASSIGN_UPLINK];
                var unassignUplinkAction = this._actionsMap[dvs_ui.DvsSelectPhysicalAdaptersPageService.actionId.UNASSIGN_UPLINK];
                var viewSettingsAction = this._actionsMap[dvs_ui.DvsSelectPhysicalAdaptersPageService.actionId.VIEW_SETTINGS];
                assignUplinkAction.enabled =
                    data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE;
                viewSettingsAction.enabled =
                    data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE;
                if (unassignUplinkAction) {
                    unassignUplinkAction.enabled =
                        (data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE
                            && this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(data));
                }
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onDataBound = function () {
            if (this._selectedItem) {
                var row = this.treeListWidget.itemFor(this._selectedItem);
                this.treeListWidget.select(row);
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.containsModifications = function (itemWrapper) {
            if (!itemWrapper) {
                return false;
            }
            if (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                return this.dvsSelectPhysicalAdaptersPageService.isPnicModified(itemWrapper);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.GROUPING_TYPE) {
                var childPnics = this.treeListDataSource.childNodes(itemWrapper);
                return _.some(childPnics, this.dvsSelectPhysicalAdaptersPageService.isPnicModified);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                var childGroupingItems = this.treeListDataSource.childNodes(itemWrapper);
                var childPnicsOnThisSwitch = this.treeListDataSource.childNodes(childGroupingItems[0]);
                var childPnicsOnOtherSwitches = this.treeListDataSource.childNodes(childGroupingItems[1]);
                return _.some(childPnicsOnThisSwitch, this.dvsSelectPhysicalAdaptersPageService.isPnicModified) ||
                    _.some(childPnicsOnOtherSwitches, this.dvsSelectPhysicalAdaptersPageService.isPnicModified);
            }
            else {
                throw new Error("Unknown item type: " + itemWrapper.type);
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.initActionsMap = function (actions, actionsMap) {
            _.each(actions, function (action) {
                if (action && action.id) {
                    actionsMap[action.id] = action;
                }
            });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.markPageDirty = function () {
            this.$wizardScope.model.selectPhysicalAdaptersPageModel.generationNumber++;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.requestPageData = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            var physicalAdaptersPromise = this.requestPhysicalAdapters();
            var uplinkDataPromise = this.requestUplinkData();
            this.$q.all([physicalAdaptersPromise, uplinkDataPromise])
                .then(function (values) {
                _this.createHostPnicTreeModel(values[0]);
                var uplinkData = values[1][DvsSelectPhysicalAdaptersPageController.UPLINK_DATA_PROPERTY];
                _this.$wizardScope.model.selectPhysicalAdaptersPageModel.lags = [];
                _this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkNames =
                    _this.getAllUplinkNames(uplinkData.uplinkNames, uplinkData.lacpGroupConfigs, _this.$wizardScope.model.selectPhysicalAdaptersPageModel.lags);
                _this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkPortgroups = uplinkData.uplinkPortgroups;
                _this.$wizardScope.wizardConfig.loading = false;
            }, function (errors) {
                _this.$wizardScope.wizardConfig.loading = false;
            });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.getAllUplinkNames = function (uplinkNames, lacpConfigs, lags) {
            var _this = this;
            // Add uplinks.
            var result = _.map(uplinkNames, function (uplinkName) {
                return [uplinkName, false /*isLagPort*/];
            });
            // Add LAGs
            var lagNameToPortsMap = {};
            if (lacpConfigs && lacpConfigs.length > 0) {
                _.forEach(lacpConfigs, function (lacpConfig) {
                    if (lacpConfig.name && lacpConfig.uplinkName &&
                        lacpConfig.uplinkName.length > 0) {
                        _.forEach(lacpConfig.uplinkName, function (uplinkName) {
                            if (!lagNameToPortsMap[lacpConfig.name]) {
                                lagNameToPortsMap[lacpConfig.name] = [];
                            }
                            lagNameToPortsMap[lacpConfig.name].push(uplinkName);
                        });
                    }
                });
            }
            var lagNames = _.keys(lagNameToPortsMap);
            if (lagNames.length > 0) {
                lagNames.sort();
                _.each(lagNames, function (lagName) {
                    var lagPorts = lagNameToPortsMap[lagName];
                    if (lagPorts && lagPorts.length > 0) {
                        // Add lag.
                        var lagEntry = _this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.lacpCategory", lagName);
                        result.push([lagEntry, false /*isLagPort*/]);
                        lags.push(lagEntry);
                        // Sort ports.
                        lagPorts.sort();
                        _.each(lagPorts, function (port) {
                            // Add LAG port.
                            result.push([port, true /*isLagPort*/]);
                        });
                    }
                });
            }
            return result;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onAssignUplinkClicked = function () {
            if (this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkPortgroups &&
                this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkPortgroups.length > 0) {
                var assignUplinkComponentConfig = new dvs_ui.AssignUplinkComponentConfig();
                assignUplinkComponentConfig.uplinkPortgroups =
                    this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkPortgroups;
                var selectedPnicItem_1 = this.asPnicItem(this._selectedItem);
                assignUplinkComponentConfig.uplinkMappings =
                    this.getUplinkMappings(selectedPnicItem_1);
                assignUplinkComponentConfig.lagNames =
                    this.$wizardScope.model.selectPhysicalAdaptersPageModel.lags;
                if (this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(selectedPnicItem_1)) {
                    assignUplinkComponentConfig.selectedUplink =
                        selectedPnicItem_1.uplink;
                    assignUplinkComponentConfig.selectedUplinkPortgroup =
                        _.find(assignUplinkComponentConfig.uplinkPortgroups, function (uplinkPortGroup) {
                            return uplinkPortGroup.name ===
                                selectedPnicItem_1.uplinkPortgroup.name;
                        });
                }
                var isBatchAssignmentEnabled = this.hostItems().length > 1;
                var signPostConfig = new dvs_ui.ApplyToAllSignPostConfig();
                signPostConfig.applyToAllSignPostTitle =
                    this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.applyToAll.signPostTitle");
                var pnicDeviceName = this.asPnicItem(this._selectedItem).device;
                var hostsWithoutPnic = this.getHostItemsWithoutPnicDevice(pnicDeviceName);
                if (hostsWithoutPnic.length > 0) {
                    var hostsWithoutPnicDeviceLabels = hostsWithoutPnic.map(function (item) { return item.label; });
                    signPostConfig.applyToAllSingPostMessage = hostsWithoutPnic.length > 3 ?
                        this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.applyToAll.warnMessageManyHosts", pnicDeviceName, hostsWithoutPnicDeviceLabels.slice(0, 3).join(", ")) :
                        this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.applyToAll.warnMessage", pnicDeviceName, hostsWithoutPnicDeviceLabels.join(", "));
                    signPostConfig.applyToAllSignPostIcon = "exclamation-triangle";
                }
                else {
                    signPostConfig.applyToAllSingPostMessage =
                        this.i18nService.getString("DvsUi", "UplinkPortMappingAssignDialog.applyToAll.infoMessage", pnicDeviceName);
                    signPostConfig.applyToAllSignPostIcon = "info-circle";
                }
                this.assingUplinkDialogService.show(selectedPnicItem_1.device, assignUplinkComponentConfig, isBatchAssignmentEnabled, signPostConfig, this.onUplinkAssigned.bind(this));
            }
            else {
                this.clarityModalService.openConfirmationModal({
                    title: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.error"),
                    message: this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.noUplinkPortgroupsError"),
                    clarityIcon: {
                        class: "is-error",
                        shape: "error-standard",
                        size: "32"
                    },
                    saveButtonLabel: this.i18nService.getString("Common", "alert.ok"),
                    hideCancelButton: true,
                    submit: function () { return true; }
                });
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onUnassignUplinkClicked = function () {
            var selectedPnicItem = this.asPnicItem(this._selectedItem);
            var pnicsWithTheSameName = this.getPnicItemsWithName(selectedPnicItem.device);
            var indexOfSelectedItem = pnicsWithTheSameName.indexOf(selectedPnicItem);
            // Remove the selected item from the array
            pnicsWithTheSameName.splice(indexOfSelectedItem, 1);
            var isBatchUnassignmentEnabled = false;
            var multipleSelectedHostsToManage = this.$wizardScope.model.selectedHosts.length > 1;
            for (var _i = 0, pnicsWithTheSameName_1 = pnicsWithTheSameName; _i < pnicsWithTheSameName_1.length; _i++) {
                var pnicItem = pnicsWithTheSameName_1[_i];
                isBatchUnassignmentEnabled =
                    pnicItem.uplink !== "--"
                        && multipleSelectedHostsToManage;
            }
            var unassignCallBack;
            if (this.dvsSelectPhysicalAdaptersPageService.isPnicAssigned(this._selectedItem)) {
                unassignCallBack = this.onUnassignClicked.bind(this);
            }
            else {
                unassignCallBack = this.onUnclaimAdapter.bind(this);
            }
            if (isBatchUnassignmentEnabled) {
                this.unassingUplinkDialogService.show(selectedPnicItem.device, unassignCallBack.bind(this));
            }
            else {
                unassignCallBack(false);
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onViewSettingsClicked = function () {
            var selectedItem = this._selectedItem;
            var pnicItem = selectedItem;
            var groupingItem = this.treeListDataSource.parentNode(pnicItem);
            var hostItem = this.treeListDataSource
                .parentNode(groupingItem);
            this.pnicSettingsDialogService.show(this.defaultUriSchemeUtil.getVsphereObjectId(pnicItem.hostRef), pnicItem.device, hostItem.label);
        };
        DvsSelectPhysicalAdaptersPageController.prototype.getUplinkMappings = function (item) {
            var _this = this;
            var pnicsItemsInTheSameHost = this.getPnicItemsInTheSameHost(item);
            return _.map(this.$wizardScope.model.selectPhysicalAdaptersPageModel.uplinkNames, function (uplinkName) {
                var pnicItemAssignedToUplink = _.find(pnicsItemsInTheSameHost, function (pnicItem) { return pnicItem.uplink === uplinkName[0]; });
                var pnicDevice = undefined; // Show "--".
                if (pnicItemAssignedToUplink) {
                    pnicDevice = pnicItemAssignedToUplink.device;
                }
                else if (_.contains(_this.$wizardScope.model.selectPhysicalAdaptersPageModel.lags, uplinkName[0])) {
                    // Don't show "--" for LAGs.
                    pnicDevice = "";
                }
                return [uplinkName[0], pnicDevice, uplinkName[1]];
            });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onUplinkAssigned = function (assignUplinkComponentConfig, applyToAll) {
            if (assignUplinkComponentConfig.selectedUplink !== undefined
                && assignUplinkComponentConfig.selectedUplinkPortgroup !== undefined) {
                var selectedUplink = assignUplinkComponentConfig.selectedUplink;
                var selectedUplinkPortgroup = assignUplinkComponentConfig.selectedUplinkPortgroup;
                var selectedPnic = this.asPnicItem(this._selectedItem);
                if (applyToAll) {
                    this.assignUplinkToPnics(selectedUplink, selectedUplinkPortgroup, this.getPnicItemsWithName(selectedPnic.device));
                }
                else {
                    this.assignUplinkToPnics(selectedUplink, selectedUplinkPortgroup, [selectedPnic]);
                }
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.getPnicItemsWithName = function (device) {
            return this.pnicItems().filter(function (item) { return item.device === device; });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.getHostItemsWithoutPnicDevice = function (device) {
            var allHostsWithThisPnic = this.getPnicItemsWithName(device).map(function (pnic) {
                return pnic.hostRef;
            });
            var allHostItemsWithoutThisPnic = this.hostItems()
                .filter(function (item) {
                return !_.some(allHostsWithThisPnic, function (hostRef) {
                    return _.isEqual(hostRef.value, item.hostRef.value);
                });
            });
            return allHostItemsWithoutThisPnic;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.hostItems = function () {
            return this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts
                .filter(function (item) {
                return item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE;
            })
                .map(function (item) {
                return item;
            });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.pnicItems = function () {
            return this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts
                .filter(function (item) {
                return item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE;
            })
                .map(function (item) {
                return item;
            });
        };
        DvsSelectPhysicalAdaptersPageController.prototype.freeUpUplink = function (uplink, contextPnic) {
            var pnicItem = _.find(this.getPnicItemsInTheSameHost(contextPnic), function (item) {
                return item.uplink === uplink;
            });
            if (pnicItem && pnicItem !== contextPnic) {
                this.updatePnicItem(pnicItem, dvs_ui.DvsAddHostWizardConstants.AUTO_ASSIGN, pnicItem.uplinkPortgroup);
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.assignUplinkToPnics = function (selectedUplink, selectedUplinkPortgroup, pnics) {
            var _this = this;
            _.each(pnics, function (pnicItem) {
                _this.freeUpUplink(selectedUplink, pnicItem);
                _this.updatePnicItem(pnicItem, selectedUplink, selectedUplinkPortgroup);
            });
            this.updateDataSource(pnics);
            // Mark page dirty after user interaction.
            this.markPageDirty();
            this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectPhysicalAdaptersPageController.prototype.updateListOfItems = function (pnicItems) {
            var allListItems = angular.copy(this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts, []);
            var _loop_1 = function(pnicItem) {
                var itemIndexToRemove = _.findIndex(allListItems, function (itemWrapper) {
                    return itemWrapper.id === pnicItem.id;
                });
                if (itemIndexToRemove >= 0) {
                    allListItems.splice(itemIndexToRemove, 1);
                }
            };
            for (var _i = 0, pnicItems_1 = pnicItems; _i < pnicItems_1.length; _i++) {
                var pnicItem = pnicItems_1[_i];
                _loop_1(pnicItem);
            }
            for (var _a = 0, pnicItems_2 = pnicItems; _a < pnicItems_2.length; _a++) {
                var pnicItem = pnicItems_2[_a];
                var pnicAdded = false;
                for (var index = 0; index < allListItems.length; index++) {
                    var itemWarpper = allListItems[index];
                    if (itemWarpper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                        var itemWrapperAsPnic = this.asPnicItem(itemWarpper);
                        if (itemWrapperAsPnic.hostRef.value === pnicItem.hostRef.value) {
                            if (itemWrapperAsPnic.orderInList > pnicItem.orderInList) {
                                allListItems.splice(index, 0, this.asWrapper(pnicItem));
                                pnicAdded = true;
                                break;
                            }
                        }
                    }
                }
                // If the pnic has not been added, there are no pnic items at the given host at the moment
                // Push the item in the array, it will go under the expected parent based on parentId
                if (!pnicAdded) {
                    allListItems.push(this.asWrapper(pnicItem));
                }
            }
            return allListItems;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.updatePnicItem = function (pnicItem, uplink, uplinkPortgroup) {
            var originalPnicItem = this.asWrapper(pnicItem).originalItem;
            var pnicAssignmentStatus = "SelectPhysicalAdaptersPage.adapterState.assigned";
            if (this.dvsSelectPhysicalAdaptersPageService.isPnicOnThisSwitch(originalPnicItem)) {
                // Reassign to potentially new uplink/uplink port group.
                if (uplink === originalPnicItem.uplink &&
                    uplinkPortgroup.name === originalPnicItem.uplinkPortgroup.name) {
                    // Reassigned to its original values.
                    this.unassignAdapter(this.asWrapper(pnicItem));
                    return;
                }
                else {
                    // Reassigned to a new uplink/uplink port group.
                    pnicAssignmentStatus =
                        "SelectPhysicalAdaptersPage.adapterState.reassigned";
                }
            }
            pnicItem.label = this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.displayName.formatter", originalPnicItem.label, this.i18nService.getString("DvsUi", pnicAssignmentStatus));
            pnicItem.parentId = pnicItem.onThisSwitchItemId;
            pnicItem.uplinkPortgroup.key = uplinkPortgroup.key;
            pnicItem.uplinkPortgroup.name = uplinkPortgroup.name;
            pnicItem.uplink = uplink;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onUnassignClicked = function (applyToAll) {
            var _this = this;
            if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE) {
                var pnicItems_3 = [];
                var selectedPnic = this.asPnicItem(this._selectedItem);
                if (applyToAll) {
                    var pnicItemsWithName = this.getPnicItemsWithName(selectedPnic.device);
                    _.each(pnicItemsWithName, function (pnicItem) {
                        _this.unassignAdapter(_this.asWrapper(pnicItem));
                        pnicItems_3.push(pnicItem);
                    });
                }
                else {
                    this.unassignAdapter(this._selectedItem);
                    pnicItems_3.push(selectedPnic);
                }
                this.updateDataSource(pnicItems_3);
            }
            // Mark page dirty after user interaction.
            this.markPageDirty();
            this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectPhysicalAdaptersPageController.prototype.unassignAdapter = function (pnicItemWrapper) {
            if (!this.dvsSelectPhysicalAdaptersPageService.isPnicModified(pnicItemWrapper)) {
                return;
            }
            var originalPnicItem = pnicItemWrapper.originalItem;
            var updatedItem = pnicItemWrapper;
            var updatedPnicItem = updatedItem;
            if (this.dvsSelectPhysicalAdaptersPageService.isPnicOriginallyOnThisSwitch(pnicItemWrapper)) {
                this.freeUpUplink(originalPnicItem.uplink, updatedPnicItem);
            }
            updatedPnicItem.parentId = originalPnicItem.parentId;
            updatedPnicItem.label = originalPnicItem.label;
            updatedPnicItem.uplink = originalPnicItem.uplink;
            updatedPnicItem.uplinkPortgroup.key = originalPnicItem.uplinkPortgroup.key;
            updatedPnicItem.uplinkPortgroup.name = originalPnicItem.uplinkPortgroup.name;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.onUnclaimAdapter = function (applyToAll) {
            var _this = this;
            var pnicItems = [];
            var selectedPnic = this.asPnicItem(this._selectedItem);
            if (applyToAll) {
                var pnicItemsWithName = this.getPnicItemsWithName(selectedPnic.device);
                _.each(pnicItemsWithName, function (pnicItem) {
                    var pnicAsWrapper = _this.asWrapper(pnicItem);
                    var originalItem = pnicAsWrapper.originalItem;
                    _this.unclaimAdapter(originalItem, pnicItem);
                    pnicItems.push(pnicItem);
                });
            }
            else {
                var originalPnicItem = this._selectedItem.originalItem;
                var pnicItem = this.asPnicItem(this._selectedItem);
                this.unclaimAdapter(originalPnicItem, pnicItem);
                pnicItems.push(pnicItem);
            }
            this.updateDataSource(pnicItems);
            // Mark page dirty after user interaction.
            this.markPageDirty();
            this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectPhysicalAdaptersPageController.prototype.unclaimAdapter = function (originalPnicItem, pnicItem) {
            pnicItem.parentId = originalPnicItem.onOtherSwitchesItemId;
            pnicItem.label = this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.displayName.formatter", originalPnicItem.label, this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.adapterState.unassigned"));
            pnicItem.uplink = this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.noUplink");
            // Creating a new instance to nullify the uplink port group key.
            pnicItem.uplinkPortgroup = new DvPortgroupModel();
            pnicItem.uplinkPortgroup.name = this.i18nService.getString("DvsUi", "SelectPhysicalAdaptersPage.noUplinkPortgroupLabel");
        };
        DvsSelectPhysicalAdaptersPageController.prototype.updateDataSource = function (pnicItems) {
            var selectedItemId = this._selectedItem.id;
            var updatedListItems = this.updateListOfItems(pnicItems);
            this.treeListDataSource = new kendo.data.TreeListDataSource({
                data: updatedListItems,
                schema: this.dvsSelectPhysicalAdaptersPageService.getTreeListSchema()
            });
            this.treeListDataSource.read();
            this._selectedItem = _.filter(updatedListItems, function (item) {
                return item.id === selectedItemId;
            })[0];
        };
        DvsSelectPhysicalAdaptersPageController.prototype.requestUplinkData = function () {
            return this.dataService.getProperties(this.$wizardScope.model.dvsId, DvsSelectPhysicalAdaptersPageController.UPLINK_DATA_PROPERTY);
        };
        DvsSelectPhysicalAdaptersPageController.prototype.requestPhysicalAdapters = function () {
            var hostRefs = _.pluck(this.$wizardScope.model.selectedHosts, "hostRef");
            var dvsHostSpec = new DvsHostsSpec();
            dvsHostSpec.hosts = hostRefs;
            dvsHostSpec.areMemberHosts =
                this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                    dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST ||
                    this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                        dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
            var params = {
                propertyParams: [{
                        propertyName: DvsSelectPhysicalAdaptersPageController.PHYSICAL_ADAPTERS_PROPERTY,
                        parameterType: dvsHostSpec._type,
                        parameter: dvsHostSpec
                    }]
            };
            var physicalAdaptersPromise = this.dataService.getProperties(this.$wizardScope.model.dvsId, [DvsSelectPhysicalAdaptersPageController.PHYSICAL_ADAPTERS_PROPERTY], params);
            return physicalAdaptersPromise;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.createHostPnicTreeModel = function (hostPhysicalAdaptersData) {
            if (hostPhysicalAdaptersData) {
                var hostDataArray = hostPhysicalAdaptersData[DvsSelectPhysicalAdaptersPageController.PHYSICAL_ADAPTERS_PROPERTY];
                var dataProvider = _.map(hostDataArray, this.mapListItemToWrapper);
                this.initializePhysicalAdaptersTreeList(dataProvider);
                this.$wizardScope.model.selectPhysicalAdaptersPageModel.isInitialized = true;
            }
        };
        DvsSelectPhysicalAdaptersPageController.prototype.mapListItemToWrapper = function (item) {
            var wrapperItem = item;
            wrapperItem.originalItem =
                angular.copy(item, new DvsAddHostHierarchicalListItem());
            var pnicItem = item;
            var uplinkPortgroupCopy = angular.copy(pnicItem.uplinkPortgroup, new DvPortgroupModel());
            var originalPnicItem = wrapperItem.originalItem;
            originalPnicItem.uplinkPortgroup = uplinkPortgroupCopy;
            return wrapperItem;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.initializePhysicalAdaptersTreeList = function (data) {
            this.treeListDataSource = new kendo.data.TreeListDataSource({
                data: data,
                schema: this.dvsSelectPhysicalAdaptersPageService.getTreeListSchema()
            });
            this.treeListDataSource.read();
            this.treeListColumns = this.dvsSelectPhysicalAdaptersPageService.getColumnDefs();
            this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectPhysicalAdaptersPageController.prototype.getPnicItemsInTheSameHost = function (item) {
            var isPnicItemInTheSameHostPredicate = function (listItem) {
                return listItem.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.PNIC_TYPE
                    && _.isEqual(item.hostRef.value, listItem.hostRef.value);
            };
            return _.filter(this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts, isPnicItemInTheSameHostPredicate);
        };
        DvsSelectPhysicalAdaptersPageController.prototype.asPnicItem = function (listItem) {
            var pnicItem = listItem;
            return pnicItem;
        };
        DvsSelectPhysicalAdaptersPageController.prototype.asWrapper = function (listItem) {
            return listItem;
        };
        DvsSelectPhysicalAdaptersPageController.$inject = [
            "$q",
            "$scope",
            "i18nService",
            "dataService",
            "dvsSelectPhysicalAdaptersPageService",
            "assingUplinkDialogService",
            "unassingUplinkDialogService",
            "clarityModalService",
            "pnicSettingsDialogService",
            "defaultUriSchemeUtil",
            "networkUtil"];
        DvsSelectPhysicalAdaptersPageController.UPLINK_DATA_PROPERTY = "dvsAddHost:uplinkData";
        DvsSelectPhysicalAdaptersPageController.PHYSICAL_ADAPTERS_PROPERTY = "dvsAddHost:hostPnicData";
        return DvsSelectPhysicalAdaptersPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectPhysicalAdaptersPageController", DvsSelectPhysicalAdaptersPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostHierarchicalListItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListItem;
    var DvsHostsSpec = com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvsHostsSpec;
    var DvsSelectVirtualAdaptersPageController = (function () {
        function DvsSelectVirtualAdaptersPageController($q, $wizardScope, i18nService, dataService, defaultUriSchemeUtil, networkSelectorDialogService, dvsSelectVirtualAdaptersPageService, vnicSettingsDialogService, dvsSelectVirtualAdaptersPageValidator) {
            this.$q = $q;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.dvsSelectVirtualAdaptersPageService = dvsSelectVirtualAdaptersPageService;
            this.vnicSettingsDialogService = vnicSettingsDialogService;
            this.dvsSelectVirtualAdaptersPageValidator = dvsSelectVirtualAdaptersPageValidator;
            this.treeListWidget = null;
            this.actionBarOptions =
                this.dvsSelectVirtualAdaptersPageService.getActionBarOptions(this.onAssignPortgroupClicked.bind(this), this.onResetChangesClicked.bind(this), this.onViewSettingsClicked.bind(this));
            if (!this.$wizardScope.model.selectVirtualAdaptersPageModel.isInitialized) {
                // Initialize virtual adapters tree list with empty data provider
                // so that it is rendered while loading the data.
                this.initializeVirtualAdaptersTreeList([]);
                this.requestPageData();
            }
            else {
                this.initializeVirtualAdaptersTreeList(this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts);
            }
            this.$wizardScope.$on("$destroy", function () {
                kendo.destroy($(".dvs-add-host-adapters-tree-list"));
            });
        }
        DvsSelectVirtualAdaptersPageController.prototype.onDataBound = function () {
            if (this._selectedItem) {
                var row = this.treeListWidget.itemFor(this._selectedItem);
                this.treeListWidget.select(row);
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.requestPageData = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            var virtualAdaptersPromise = this.requestVirtualAdapters();
            virtualAdaptersPromise.then(function (response, error) {
                _this.createHostVnicTreeModel(response);
                _this.$wizardScope.wizardConfig.loading = false;
            });
        };
        DvsSelectVirtualAdaptersPageController.prototype.onNetworkSelectorClosed = function (selectedNetworks, applyToAll) {
            if (selectedNetworks && selectedNetworks.length > 0) {
                var selectedPortgroup = selectedNetworks[0];
                var selectedPortgroupName = selectedPortgroup.name;
                var selectedPortgroupRef = selectedPortgroup.networkRef;
                var vnicsToUpdate = void 0;
                if (applyToAll) {
                    vnicsToUpdate = this.getVnicItemsWithName(this.asVnicItem(this._selectedItem).device);
                }
                else {
                    vnicsToUpdate = [this._selectedItem];
                }
                var selectedItemId_1 = this._selectedItem.id;
                var updatedListItems = this.assignVnics(vnicsToUpdate, selectedPortgroupName, selectedPortgroupRef);
                this.treeListDataSource = new kendo.data.TreeListDataSource({
                    data: updatedListItems,
                    schema: this.dvsSelectVirtualAdaptersPageService.getTreeListSchema()
                });
                this.treeListDataSource.read();
                this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts =
                    this.treeListDataSource.data();
                this._selectedItem = _.filter(updatedListItems, function (item) {
                    return item.id === selectedItemId_1;
                })[0];
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.assignVnics = function (vnicItems, portgroupName, portgroupRef) {
            var _this = this;
            vnicItems.forEach(function (updatedVnicItem) {
                var originalVnicItem = _this.asVnicItem(_this.asWrapper(updatedVnicItem).originalItem);
                updatedVnicItem.parentId = originalVnicItem.onThisSwitchItemId;
                updatedVnicItem.label = _this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.displayName.formatter", originalVnicItem.label, _this.i18nService.getString("DvsUi", "SelectVirtualAdaptersPage.virtualAdapterState.reassigned"));
                updatedVnicItem.destinationPortgroup = portgroupName;
                updatedVnicItem.portgroupRef = portgroupRef;
            });
            this.checkVnicsForConnectivityLoss(this.treeListDataSource.data());
            return this.updateListOfItems(vnicItems);
        };
        DvsSelectVirtualAdaptersPageController.prototype.checkVnicsForConnectivityLoss = function (vnics) {
            var _this = this;
            if (vnics && vnics.length > 0) {
                this.vnicsWithoutBackingPnic = this.dvsSelectVirtualAdaptersPageValidator
                    .getVnicsWithConnectivityWarning(vnics, this.$wizardScope.model.selectPhysicalAdaptersPageModel.hosts, vnics);
                _.each(vnics, function (itemWrapper) {
                    if (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                        var vnicItem = itemWrapper;
                        if (_.contains(_this.vnicsWithoutBackingPnic, itemWrapper)) {
                            vnicItem.iconClass = "network-lib-ui-icon-virtualAdapterWarning";
                        }
                        else {
                            vnicItem.iconClass = "network-lib-ui-icon-virtualAdapter";
                        }
                    }
                });
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.updateListOfItems = function (vnicItems) {
            var allListItems = angular.copy(this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts, []);
            var _loop_1 = function(vnicItem) {
                var itemIndexToRemove = _.findIndex(allListItems, function (itemWrapper) {
                    return itemWrapper.id === vnicItem.id;
                });
                if (itemIndexToRemove >= 0) {
                    allListItems.splice(itemIndexToRemove, 1);
                }
            };
            for (var _i = 0, vnicItems_1 = vnicItems; _i < vnicItems_1.length; _i++) {
                var vnicItem = vnicItems_1[_i];
                _loop_1(vnicItem);
            }
            for (var _a = 0, vnicItems_2 = vnicItems; _a < vnicItems_2.length; _a++) {
                var vnicItem = vnicItems_2[_a];
                var vnicAdded = false;
                for (var index = 0; index < allListItems.length; index++) {
                    var itemWarpper = allListItems[index];
                    if (itemWarpper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                        var itemWrapperAsVnic = this.asVnicItem(itemWarpper);
                        if (itemWrapperAsVnic.hostRef.value === vnicItem.hostRef.value) {
                            if (itemWrapperAsVnic.orderInList > vnicItem.orderInList) {
                                allListItems.splice(index, 0, this.asWrapper(vnicItem));
                                vnicAdded = true;
                                break;
                            }
                        }
                    }
                }
                // If the vnic has not been added, there are no vnic items at the given host at the moment
                // Push the item in the array, it will go under the expected parent based on parentId
                if (!vnicAdded) {
                    allListItems.push(this.asWrapper(vnicItem));
                }
            }
            return allListItems;
        };
        DvsSelectVirtualAdaptersPageController.prototype.onAssignPortgroupClicked = function () {
            var dialogSpec = this.networkSelectorDialogService.createNetworkSelectorDialogSpec(['Network.Assign']);
            dialogSpec.isBatchAssignmentRelevant = false;
            if (this.hostItems().length > 1) {
                dialogSpec.isBatchAssignmentRelevant = true;
                var vnicItem = this.asVnicItem(this._selectedItem).device;
                var hostsWithoutVnicArray = this.getHostsWithoutVnic(vnicItem);
                // Batch assignment is enabled on all hosts if there are no hosts
                // that don't have the vmk
                dialogSpec.isBatchAssignmentEnabled = !hostsWithoutVnicArray.length;
                // Based on the hosts that have or don't have vmk with given name
                // get the signpost message
                if (dialogSpec.isBatchAssignmentEnabled) {
                    dialogSpec.applyToAllSingPostMessage = this.i18nService.getString("Common", "NetworkSelectorDialog.applyToAll.infoMessage", vnicItem);
                }
                else {
                    dialogSpec.applyToAllSingPostMessage = hostsWithoutVnicArray.length > 3 ?
                        this.i18nService.getString("Common", "NetworkSelectorDialog.applyToAll.warnMessageManyHosts", vnicItem, hostsWithoutVnicArray.slice(0, 3).join(", ")) :
                        this.i18nService.getString("Common", "NetworkSelectorDialog.applyToAll.warnMessage", vnicItem, hostsWithoutVnicArray.join(", "));
                }
            }
            // Open network selector.
            this.networkSelectorDialogService.openNetworkSelectorDialog(this.$wizardScope.model.dvsId, this.networkSelectorDialogService.createNetworkSelectorFilterSpec(false, false, true, false, false), 
            // TODO vchomakov: add custom message
            dialogSpec, this.onNetworkSelectorClosed.bind(this));
        };
        DvsSelectVirtualAdaptersPageController.prototype.onResetChangesClicked = function () {
            if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                this.resetChangesForVnic(this._selectedItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.GROUPING_TYPE) {
                this.resetChangesForGroupingItem(this._selectedItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                this.resetChangesForHostItem(this._selectedItem);
            }
            this.updateToolbar();
            this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectVirtualAdaptersPageController.prototype.onViewSettingsClicked = function () {
            var vnicItem = this._selectedItem;
            var groupingItem = this.treeListDataSource.parentNode(vnicItem);
            var hostItem = this.treeListDataSource
                .parentNode(groupingItem);
            this.vnicSettingsDialogService.show(this.defaultUriSchemeUtil.getVsphereObjectId(vnicItem.hostRef), vnicItem.device, hostItem.label);
        };
        DvsSelectVirtualAdaptersPageController.prototype.resetChangesForHostItem = function (hostItem) {
            var childGroupingItems = this.treeListDataSource.childNodes(hostItem);
            if (childGroupingItems && childGroupingItems.length === 2) {
                var onThisSwitchGroupingItem = childGroupingItems[0];
                var onOtherSwitchesGroupingItem = childGroupingItems[1];
                this.resetChangesForGroupingItem(onThisSwitchGroupingItem);
                this.resetChangesForGroupingItem(onOtherSwitchesGroupingItem);
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.resetChangesForGroupingItem = function (groupingItem) {
            var _this = this;
            var childVnicItems = this.treeListDataSource.childNodes(groupingItem);
            _.each(childVnicItems, function (vnicItem) {
                _this.resetChangesForVnic(vnicItem);
            });
        };
        DvsSelectVirtualAdaptersPageController.prototype.resetChangesForVnic = function (vnicItemWrapper) {
            if (!this.dvsSelectVirtualAdaptersPageService.isVnicModified(vnicItemWrapper)) {
                return;
            }
            var originalVnicItem = vnicItemWrapper.originalItem;
            var updatedItem = vnicItemWrapper;
            var updatedVnicItem = updatedItem;
            updatedVnicItem.parentId = originalVnicItem.parentId;
            updatedVnicItem.label = originalVnicItem.label;
            updatedVnicItem.destinationPortgroup = originalVnicItem.destinationPortgroup;
            updatedVnicItem.portgroupRef = originalVnicItem.portgroupRef;
            this.checkVnicsForConnectivityLoss(this.treeListDataSource.data());
            this.treeListDataSource.pushUpdate(updatedVnicItem);
        };
        DvsSelectVirtualAdaptersPageController.prototype.updateToolbar = function () {
            if (this.treeListWidget === null) {
                return;
            }
            var row = this.treeListWidget.select();
            var data = this.treeListWidget.dataItem(row);
            this._selectedItem = data;
            if (!data) {
                // No item is selected, typically triggered by a deselection.
                // Disable all actions.
                _.each(this.actionBarOptions.actions, function (action) {
                    action.enabled = false;
                });
            }
            if (data && data.type) {
                var assignPortgroupAction = this.actionBarOptions.actions[0];
                var resetChangesAction = this.actionBarOptions.actions[1];
                var viewDetailsAction = this.actionBarOptions.actions[2];
                assignPortgroupAction.enabled =
                    data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE;
                resetChangesAction.enabled = this.containsModifications(this._selectedItem);
                viewDetailsAction.enabled =
                    data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE;
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.containsModifications = function (itemWrapper) {
            if (!itemWrapper) {
                return false;
            }
            if (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE) {
                return this.dvsSelectVirtualAdaptersPageService.isVnicModified(itemWrapper);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.GROUPING_TYPE) {
                var childVnics = this.treeListDataSource.childNodes(itemWrapper);
                return _.some(childVnics, this.dvsSelectVirtualAdaptersPageService.isVnicModified);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                var childGroupingItems = this.treeListDataSource.childNodes(itemWrapper);
                var childVnicsOnThisSwitch = this.treeListDataSource.childNodes(childGroupingItems[0]);
                var childVnicsOnOtherSwitches = this.treeListDataSource.childNodes(childGroupingItems[1]);
                return _.some(childVnicsOnThisSwitch, this.dvsSelectVirtualAdaptersPageService.isVnicModified) ||
                    _.some(childVnicsOnOtherSwitches, this.dvsSelectVirtualAdaptersPageService.isVnicModified);
            }
            else {
                throw new Error("Unknown item type: " + itemWrapper.type);
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.requestVirtualAdapters = function () {
            var hostRefs = _.map(this.$wizardScope.model.selectedHosts, function (item) { return item.hostRef; });
            var requestParameter = new DvsHostsSpec();
            requestParameter.hosts = hostRefs;
            requestParameter.areMemberHosts =
                this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                    dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST ||
                    this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                        dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
            var params = {
                propertyParams: [{
                        propertyName: DvsSelectVirtualAdaptersPageController.VIRTUAL_ADAPTERS_PROPERTY,
                        parameterType: requestParameter._type,
                        parameter: requestParameter
                    }]
            };
            return this.dataService.getProperties(this.$wizardScope.model.dvsId, [DvsSelectVirtualAdaptersPageController.VIRTUAL_ADAPTERS_PROPERTY], params);
        };
        DvsSelectVirtualAdaptersPageController.prototype.createHostVnicTreeModel = function (hostVirtualAdaptersData) {
            if (hostVirtualAdaptersData) {
                var hostDataArray = hostVirtualAdaptersData[DvsSelectVirtualAdaptersPageController.VIRTUAL_ADAPTERS_PROPERTY];
                if (hostDataArray === null) {
                    // Workaround for kendo ObservableArray which throws an error in case of
                    // a null constructor argument.
                    hostDataArray = [];
                }
                var dataProvider = _.map(hostDataArray, function (item) {
                    var wrapperItem = item;
                    wrapperItem.originalItem =
                        angular.copy(item, new DvsAddHostHierarchicalListItem());
                    return wrapperItem;
                });
                this.initializeVirtualAdaptersTreeList(dataProvider);
                this.$wizardScope.model.selectVirtualAdaptersPageModel.isInitialized = true;
            }
        };
        DvsSelectVirtualAdaptersPageController.prototype.initializeVirtualAdaptersTreeList = function (data) {
            this.checkVnicsForConnectivityLoss(data);
            this.treeListDataSource = new kendo.data.TreeListDataSource({
                data: data,
                schema: this.dvsSelectVirtualAdaptersPageService.getTreeListSchema()
            });
            this.treeListDataSource.read();
            this.treeListColumns = this.dvsSelectVirtualAdaptersPageService.getColumnDefs();
            this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectVirtualAdaptersPageController.prototype.hostItems = function () {
            return this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts
                .filter(function (item) {
                return item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE;
            })
                .map(function (item) {
                return item;
            });
        };
        DvsSelectVirtualAdaptersPageController.prototype.vnicItems = function () {
            return this.$wizardScope.model.selectVirtualAdaptersPageModel.hosts
                .filter(function (item) {
                return item.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VNIC_TYPE;
            })
                .map(function (item) {
                return item;
            });
        };
        DvsSelectVirtualAdaptersPageController.prototype.asVnicItem = function (listItem) {
            var vnicItem = listItem;
            return vnicItem;
        };
        DvsSelectVirtualAdaptersPageController.prototype.asWrapper = function (listItem) {
            return listItem;
        };
        DvsSelectVirtualAdaptersPageController.prototype.getHostsWithoutVnic = function (device) {
            var vnicItemsWithName = this.getVnicItemsWithName(device);
            return this.hostItems()
                .filter(function (hostItem) {
                return !vnicItemsWithName.some(function (vnicItem) {
                    return vnicItem.hostRef.value === hostItem.hostRef.value;
                });
            }).map(function (hostItem) {
                return hostItem.label;
            });
        };
        DvsSelectVirtualAdaptersPageController.prototype.getVnicItemsWithName = function (device) {
            return this.vnicItems().filter(function (item) { return item.device === device; });
        };
        DvsSelectVirtualAdaptersPageController.VIRTUAL_ADAPTERS_PROPERTY = "dvsAddHost:hostVnicData";
        DvsSelectVirtualAdaptersPageController.$inject = [
            "$q",
            "$scope",
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "networkSelectorDialogService",
            "dvsSelectVirtualAdaptersPageService",
            "vnicSettingsDialogService",
            "dvsSelectVirtualAdaptersPageValidator"];
        return DvsSelectVirtualAdaptersPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectVirtualAdaptersPageController", DvsSelectVirtualAdaptersPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddHostHierarchicalListItem = com.vmware.vsphere.client.h5.network.dvs.addhost.hierarchicalList.DvsAddHostHierarchicalListItem;
    var DvsSelectVirtualMachinesPageController = (function () {
        function DvsSelectVirtualMachinesPageController($q, $wizardScope, i18nService, dataService, defaultUriSchemeUtil, networkSelectorDialogService, dvsSelectVirtualMachinesPageService, vmVnicSettingsDialogService, $timeout) {
            this.$q = $q;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.dvsSelectVirtualMachinesPageService = dvsSelectVirtualMachinesPageService;
            this.vmVnicSettingsDialogService = vmVnicSettingsDialogService;
            this.$timeout = $timeout;
            this.treeListWidget = null;
            this.treeListItemExpanded = false;
            this.actionBarOptions =
                this.dvsSelectVirtualMachinesPageService.getActionBarOptions(this.onAssignPortgroupClicked.bind(this), this.onResetChangesClicked.bind(this), this.onViewSettingsClicked.bind(this));
            if (!this.$wizardScope.model.selectVirtualMachinesPageModel.isInitialized) {
                // Initialize virtual machines tree list with empty data provider
                // so that it is rendered while loading the data.
                this.initializeVirtualMachinesTreeList([]);
                this.requestPageData();
            }
            else {
                // Do not auto-expand hosts in order to preserve the expand state
                // that the user had previously specified.
                this.treeListItemExpanded = true;
                this.initializeVirtualMachinesTreeList(this.$wizardScope.model.selectVirtualMachinesPageModel.hosts);
            }
            this.$wizardScope.$on("$destroy", function () {
                kendo.destroy($(".dvs-add-host-adapters-tree-list"));
            });
        }
        DvsSelectVirtualMachinesPageController.prototype.requestPageData = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            var virtualMachinesPromise = this.requestVirtualMachines();
            virtualMachinesPromise.then(function (response, error) {
                _this.createVmVnicTreeModel(response);
                _this.$wizardScope.wizardConfig.loading = false;
            });
        };
        DvsSelectVirtualMachinesPageController.prototype.onNetworkSelectorClosed = function (selectedNetworks) {
            var _this = this;
            if (selectedNetworks && selectedNetworks.length > 0) {
                var selectedPortgroup = selectedNetworks[0];
                var selectedPortgroupName_1 = selectedPortgroup.name;
                var selectedPortgroupRef_1 = selectedPortgroup.networkRef;
                if (this._selectedItem) {
                    if (this._selectedItem.type ===
                        dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE) {
                        this.assignVnic(this._selectedItem, selectedPortgroupName_1, selectedPortgroupRef_1);
                    }
                    else if (this._selectedItem.type ===
                        dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                        var childVnicItems = this.treeListDataSource.childNodes(this._selectedItem);
                        _.each(childVnicItems, function (vnicItem) {
                            _this.assignVnic(vnicItem, selectedPortgroupName_1, selectedPortgroupRef_1);
                        });
                    }
                }
                // Update toolbar since the assigned item's selection is preserved but
                // no selection event is triggered.
                this.updateToolbar();
                this.updateReassignedLabels();
                this.$wizardScope.model.selectVirtualMachinesPageModel.hosts =
                    this.treeListDataSource.data();
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.assignVnic = function (vnicItemWrapper, portgroupName, portgroupRef) {
            var listItem = vnicItemWrapper;
            var updatedVnicItem = listItem;
            updatedVnicItem.destinationPortgroup = portgroupName;
            updatedVnicItem.destinationPortgroupRef = portgroupRef;
            this.treeListDataSource.pushUpdate(updatedVnicItem);
        };
        DvsSelectVirtualMachinesPageController.prototype.onAssignPortgroupClicked = function () {
            // Open network selector.
            this.networkSelectorDialogService.openNetworkSelectorDialog(this.$wizardScope.model.dvsId, this.networkSelectorDialogService.createNetworkSelectorFilterSpec(false, false, true, false, false), 
            // TODO vchomakov: add custom message
            this.networkSelectorDialogService.createNetworkSelectorDialogSpec(['Network.Assign']), this.onNetworkSelectorClosed.bind(this));
        };
        DvsSelectVirtualMachinesPageController.prototype.onViewSettingsClicked = function () {
            var selectedItem = this._selectedItem;
            var vmItem;
            var vmVnicItemKey;
            if (selectedItem.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE) {
                var vmVnicItem = selectedItem;
                vmVnicItemKey = vmVnicItem.key;
                vmItem = this.treeListDataSource.parentNode(vmVnicItem);
            }
            else if (selectedItem.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                vmItem = selectedItem;
            }
            else {
                throw Error("View settings action is invoked for item different than vm or vm vnic");
            }
            this.vmVnicSettingsDialogService.show(vmItem.label, vmItem.vmRef, vmVnicItemKey);
        };
        DvsSelectVirtualMachinesPageController.prototype.onResetChangesClicked = function () {
            if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE) {
                this.resetChangesForVnic(this._selectedItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                this.resetChangesForVm(this._selectedItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                this.resetChangesForHostItem(this._selectedItem);
            }
            this.updateToolbar();
            this.updateReassignedLabels();
            this.$wizardScope.model.selectVirtualMachinesPageModel.hosts =
                this.treeListDataSource.data();
        };
        DvsSelectVirtualMachinesPageController.prototype.resetChangesForHostItem = function (hostItem) {
            var childVmItems = this.treeListDataSource.childNodes(hostItem);
            if (childVmItems && childVmItems.length > 0) {
                _.each(childVmItems, this.resetChangesForVm.bind(this));
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.resetChangesForVm = function (vmItemWrapper) {
            var _this = this;
            var childVnicItems = this.treeListDataSource.childNodes(vmItemWrapper);
            _.each(childVnicItems, function (vnicItem) {
                _this.resetChangesForVnic(vnicItem);
            });
        };
        DvsSelectVirtualMachinesPageController.prototype.resetChangesForVnic = function (vnicItemWrapper) {
            if (!this.dvsSelectVirtualMachinesPageService.isVnicModified(vnicItemWrapper)) {
                return;
            }
            var originalVnicItem = vnicItemWrapper.originalItem;
            var updatedItem = vnicItemWrapper;
            var updatedVnicItem = updatedItem;
            updatedVnicItem.destinationPortgroup = originalVnicItem.destinationPortgroup;
            updatedVnicItem.destinationPortgroupRef =
                originalVnicItem.destinationPortgroupRef;
            this.treeListDataSource.pushUpdate(updatedVnicItem);
        };
        DvsSelectVirtualMachinesPageController.prototype.updateReassignedLabelForVm = function (vmItemWrapper) {
            var childNics = this.treeListDataSource.childNodes(vmItemWrapper);
            var item = vmItemWrapper;
            var vmItem = item;
            vmItem.isReassigned =
                _.some(childNics, this.dvsSelectVirtualMachinesPageService.isVnicModified);
            this.treeListDataSource.pushUpdate(vmItem);
        };
        DvsSelectVirtualMachinesPageController.prototype.updateReassignedLabels = function () {
            var _this = this;
            if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE) {
                var parentVmItem = this.treeListDataSource.parentNode(this._selectedItem);
                this.updateReassignedLabelForVm(parentVmItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                this.updateReassignedLabelForVm(this._selectedItem);
            }
            else if (this._selectedItem.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                var childVmItems = this.treeListDataSource.childNodes(this._selectedItem);
                _.each(childVmItems, function (vmItem) {
                    _this.updateReassignedLabelForVm(vmItem);
                });
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.onTreeListDataBound = function () {
            var _this = this;
            if (this.treeListItemExpanded) {
                return;
            }
            this.$timeout(function () {
                if (_this.treeListItemExpanded || !_this.treeListWidget) {
                    return;
                }
                _this.treeListItemExpanded =
                    _this.dvsSelectVirtualMachinesPageService.expandHostItems(_this.treeListWidget, _this.treeListDataSource);
            }, 0);
        };
        DvsSelectVirtualMachinesPageController.prototype.updateToolbar = function () {
            if (this.treeListWidget === null) {
                return;
            }
            var row = this.treeListWidget.select();
            var data = this.treeListWidget.dataItem(row);
            this._selectedItem = data;
            if (!data) {
                // No item is selected, typically triggered by a deselection.
                // Disable all actions.
                _.each(this.actionBarOptions.actions, function (action) {
                    action.enabled = false;
                });
            }
            if (data && data.type) {
                var assignPortgroupAction = this.actionBarOptions.actions[0];
                var resetChangesAction = this.actionBarOptions.actions[1];
                assignPortgroupAction.enabled =
                    !data.isOrphaned &&
                        (data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE
                            || data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE);
                resetChangesAction.enabled = !data.isOrphaned &&
                    this.containsModifications(this._selectedItem);
                var viewSettingsAction = this.actionBarOptions.actions[2];
                viewSettingsAction.enabled =
                    data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE
                        || data.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE;
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.containsModifications = function (itemWrapper) {
            if (!itemWrapper) {
                return false;
            }
            if (itemWrapper.type === dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_VNIC_TYPE) {
                return this.dvsSelectVirtualMachinesPageService.isVnicModified(itemWrapper);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                return this.containsModificationsVm(itemWrapper);
            }
            else if (itemWrapper.type ===
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.HOST_TYPE) {
                var childVmItems = this.treeListDataSource.childNodes(itemWrapper);
                return _.some(childVmItems, this.containsModificationsVm.bind(this));
            }
            else {
                throw new Error("Unknown item type: " + itemWrapper.type);
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.containsModificationsVm = function (itemWrapper) {
            if (!itemWrapper || itemWrapper.type !==
                dvs_ui.DvsAddHostWizardConstants.nicListItemType.VM_TYPE) {
                return false;
            }
            var childVnics = this.treeListDataSource.childNodes(itemWrapper);
            return _.some(childVnics, this.dvsSelectVirtualMachinesPageService.isVnicModified);
        };
        DvsSelectVirtualMachinesPageController.prototype.requestVirtualMachines = function () {
            var hostRefs = _.pluck(this.$wizardScope.model.selectedHosts, 'hostRef');
            var dvsHostSpec = "com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvsHostsSpec";
            var areMemberHosts = this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                dvs_ui.DvsAddHostWizardConstants.operationType.MANAGE_HOST ||
                this.$wizardScope.model.selectOperationPageModel.selectedOperationType ===
                    dvs_ui.DvsAddHostWizardConstants.operationType.MIGRATE_NETWORKING;
            var params = {
                propertyParams: [{
                        propertyName: DvsSelectVirtualMachinesPageController.VIRTUAL_MACHINES_PROPERTY,
                        parameterType: dvsHostSpec,
                        parameter: {
                            _type: dvsHostSpec,
                            hosts: hostRefs,
                            areMemberHosts: areMemberHosts
                        }
                    }]
            };
            var virtualMachinesPromise = this.dataService.getProperties(this.$wizardScope.model.dvsId, [DvsSelectVirtualMachinesPageController.VIRTUAL_MACHINES_PROPERTY], params);
            return virtualMachinesPromise;
        };
        DvsSelectVirtualMachinesPageController.prototype.createVmVnicTreeModel = function (hostVmsData) {
            if (hostVmsData) {
                var hostDataArray = hostVmsData[DvsSelectVirtualMachinesPageController.VIRTUAL_MACHINES_PROPERTY];
                if (hostDataArray === null) {
                    // Workaround for kendo ObservableArray which throws an error in case of
                    // a null constructor argument.
                    hostDataArray = [];
                }
                var dataProvider = _.map(hostDataArray, function (item) {
                    var wrapperItem = item;
                    wrapperItem.originalItem =
                        angular.copy(item, new DvsAddHostHierarchicalListItem());
                    return wrapperItem;
                });
                this.initializeVirtualMachinesTreeList(dataProvider);
                this.$wizardScope.model.selectVirtualMachinesPageModel.isInitialized = true;
            }
        };
        DvsSelectVirtualMachinesPageController.prototype.initializeVirtualMachinesTreeList = function (data) {
            this.treeListDataSource = new kendo.data.TreeListDataSource({
                data: data,
                schema: this.dvsSelectVirtualMachinesPageService.getTreeListSchema()
            });
            this.treeListDataSource.read();
            this.treeListColumns = this.dvsSelectVirtualMachinesPageService.getColumnDefs();
            this.$wizardScope.model.selectVirtualMachinesPageModel.hosts =
                this.treeListDataSource.data();
            this.updateWarningState();
        };
        DvsSelectVirtualMachinesPageController.prototype.updateWarningState = function () {
            if (this.$wizardScope.model.selectVirtualMachinesPageModel.hosts) {
                this.showWarning =
                    _.some(this.$wizardScope.model.selectVirtualMachinesPageModel.hosts, function (vnicItem) {
                        return vnicItem.showWarning;
                    });
            }
        };
        DvsSelectVirtualMachinesPageController.$inject = [
            "$q",
            "$scope",
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "networkSelectorDialogService",
            "dvsSelectVirtualMachinesPageService",
            "vmVnicSettingsDialogService",
            "$timeout"];
        DvsSelectVirtualMachinesPageController.VIRTUAL_MACHINES_PROPERTY = "dvsAddHost:hostVmData";
        return DvsSelectVirtualMachinesPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsSelectVirtualMachinesPageController", DvsSelectVirtualMachinesPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsOverviewPageComponent = (function () {
        function DvsOverviewPageComponent() {
            this.bindings = {
                feature: "<",
                objectId: "<"
            };
            this.controller = DvsOverviewPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/common/component/" +
                "dvsOverviewPageComponentTemplate.html";
        }
        return DvsOverviewPageComponent;
    }());
    dvs_ui.DvsOverviewPageComponent = DvsOverviewPageComponent;
    var DvsOverviewPageComponentController = (function () {
        function DvsOverviewPageComponentController(i18nService, $scope, dvsUpgradeWizardConstants, $sce, exportDvsDialogService) {
            var _this = this;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.dvsUpgradeWizardConstants = dvsUpgradeWizardConstants;
            this.$sce = $sce;
            this.exportDvsDialogService = exportDvsDialogService;
            switch (this.feature) {
                case this.dvsUpgradeWizardConstants.features.LACP:
                    this.featureHeading = this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.overview.changesHeading");
                    this.featureContent = this.$sce.trustAsHtml(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.overview.changesContent"));
                    this.warningHint = this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.backup.hint");
                    this.exportLabel = this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.backup.name");
                    this.exportDvsLinkClicked = function () {
                        exportDvsDialogService.show(_this.objectId);
                    };
                    break;
                case this.dvsUpgradeWizardConstants.features.NIOC:
                    this.featureHeading = this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.overview.changesHeading");
                    this.featureContent = this.$sce.trustAsHtml(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.overview.changesContent"));
                    break;
                default:
                    break;
            }
        }
        DvsOverviewPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsUpgradeWizardConstants",
            "$sce",
            "exportDvsDialogService"
        ];
        return DvsOverviewPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsOverviewPage", new DvsOverviewPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPrerequisitesPageComponent = (function () {
        function DvsPrerequisitesPageComponent() {
            this.bindings = {
                prerequisitesValidationData: "<"
            };
            this.controller = DvsPrerequisitesPageController;
            this.templateUrl =
                "dvs-ui/resources/dvs/common/component/" +
                    "dvsPrerequisitesPageComponentTemplate.html";
        }
        return DvsPrerequisitesPageComponent;
    }());
    dvs_ui.DvsPrerequisitesPageComponent = DvsPrerequisitesPageComponent;
    var DvsPrerequisitesPageController = (function () {
        function DvsPrerequisitesPageController(vuiConstants, i18nService, columnRenderersRegistry, dvsPrerequisitesValidationService, dvsUpgradeLacpWizardConstants) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dvsPrerequisitesValidationService = dvsPrerequisitesValidationService;
            this.dvsUpgradeLacpWizardConstants = dvsUpgradeLacpWizardConstants;
            this.gridDescription = this.i18nService.getString("DvsUi", "PrerequisitesPage.description");
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.buildColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                resizable: true,
                data: this.prerequisitesValidationData,
                actionBarOptions: {
                    actions: []
                },
                onChange: this.onSelectionChange.bind(this)
            };
            this.prerequisiteCheckDetailsHeader = this.i18nService.getString("DvsUi", "PrerequisitesPage.validationDetails");
            this.setOverallValidationStatus();
        }
        DvsPrerequisitesPageController.prototype.$onInit = function () {
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [{ size: '65%', min: '120px' }, { size: '35%', min: '50px' }]
            };
            this.iconTextRenderer =
                this.columnRenderersRegistry.getColumnRenderer('icon-text');
        };
        DvsPrerequisitesPageController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.prerequisitesValidationData ?
                this.prerequisitesValidationData : [];
        };
        DvsPrerequisitesPageController.prototype.setOverallValidationStatus = function () {
            this.prerequisiteCheckDetails = this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.label");
            this.overallCheckStatus =
                this.dvsPrerequisitesValidationService.getPrerequisitesOverallStatus(this.prerequisitesValidationData);
            this.showOverallStatusWarning =
                this.overallCheckStatus === this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.warn");
            this.showOverallStatusFail =
                this.overallCheckStatus === this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.fail");
            this.checkAffectedEntities = [];
            this.showOverallStatus = true;
        };
        DvsPrerequisitesPageController.prototype.buildColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DvsUi", "PrerequisitesPage.checkNameColumn"),
                    field: "checkName",
                    width: "310px"
                }, {
                    displayName: this.i18nService.getString("DvsUi", "PrerequisitesPage.checkResultColumn"),
                    width: "100%",
                    template: function (item) {
                        var itemStatus;
                        switch (item.type) {
                            case _this.dvsUpgradeLacpWizardConstants.validationResult.FAIL:
                                itemStatus = _this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.fail");
                                return "<span><clr-icon shape='error' size='24' " +
                                    "class='is-error dvs-upgrade-prerequisites-error'></clr-icon>" +
                                    ("<span class='vertical-align-cell'>" + itemStatus + "</span></span>");
                            case _this.dvsUpgradeLacpWizardConstants.validationResult.WARNING:
                                itemStatus = _this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.warn");
                                return "<span><span class='vsphere-icon-status-warning'></span>" +
                                    ("<span class='vertical-align-cell'>" + itemStatus + "</span></span>");
                            default: {
                                itemStatus = _this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.pass");
                                return "<span><span class='vsphere-icon-status-ok'></span>" +
                                    ("<span class='vertical-align-cell'>" + itemStatus + "</span></span>");
                            }
                        }
                        ;
                    }
                }];
        };
        DvsPrerequisitesPageController.prototype.onSelectionChange = function (items) {
            if (items && items.length > 0) {
                var validationResult = items[0];
                this.prerequisiteCheckDetails = validationResult.message;
                this.checkAffectedEntities = validationResult.affectedEntities;
                this.showOverallStatus = false;
            }
            else {
                this.setOverallValidationStatus();
            }
        };
        DvsPrerequisitesPageController.$inject = [
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry",
            "dvsPrerequisitesValidationService",
            "dvsUpgradeLacpWizardConstants"
        ];
        return DvsPrerequisitesPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPrerequisitesPage", new DvsPrerequisitesPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsVersionPageComponent = (function () {
        function DvsVersionPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsVersionPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/common/component/" +
                "dvsVersionPageComponentTemplate.html";
        }
        return DvsVersionPageComponent;
    }());
    dvs_ui.DvsVersionPageComponent = DvsVersionPageComponent;
    var DvsVersionPageComponentController = (function () {
        function DvsVersionPageComponentController(i18nService, $scope, wizardConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.wizardConstants = wizardConstants;
            this.esxVersionByDvs = {
                "5.0.0": "5.0",
                "5.1.0": "5.1",
                "5.5.0": "5.5",
                "6.0.0": "6.0",
                "6.5.0": "6.5",
                "6.6.0": "6.7"
            };
            $scope.i18n = this.i18nService.getString;
            $scope.$watch("$ctrl.wizardModel.supportedVersions", function () {
                _this.initComponent();
            });
        }
        DvsVersionPageComponentController.prototype.$onInit = function () {
            this.initComponent();
        };
        DvsVersionPageComponentController.prototype.initComponent = function () {
            var _this = this;
            this.versions = _.map(this.wizardModel.supportedVersions, function (version) {
                return {
                    dvs: version,
                    esx: _this.esxVersionByDvs[version]
                };
            });
            this.initDescriptions();
            this.buildSignpostItems();
        };
        DvsVersionPageComponentController.prototype.getVersionDescriptions = function (version) {
            return this._descriptionsByVersion[version]
                || this._descriptionsByVersion[this.wizardConstants.versions._unknown];
        };
        DvsVersionPageComponentController.prototype.initDescriptions = function () {
            this._descriptionsByVersion = {};
            this._descriptionsByVersion[this.wizardConstants.versions._66] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.6_6_0")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._65] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.6_5_0")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._60] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.6_0_0.nioc"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.6_0_0.igmp")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._55] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_5_0.filtering"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_5_0.lacp")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._51] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_1_0.rollback"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_1_0.healthcheck"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_1_0.portmirroring"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_1_0.lacp")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._50] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_0_0.nioc"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_0_0.netflow"),
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.5_0_0.portmirroring")
            ];
            this._descriptionsByVersion[this.wizardConstants.versions._unknown] = [
                this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.unknown")
            ];
        };
        DvsVersionPageComponentController.prototype.buildSignpostItems = function () {
            var _this = this;
            var signpostMessage = "";
            _.forEach(this.wizardModel.supportedVersions, function (version) {
                var title = "<b>%title%</b><br/>"
                    .replace("%title%", _this.i18nService.getString("DvsUi", "DvsVersionPage.supportedVersion.descriptionItem.tltleTemplate", version));
                var items = "";
                var descriptions = _this.getVersionDescriptions(version);
                _.forEach(descriptions, function (description) {
                    var template = "<div class='horizontal-flex-container'>" +
                        "<span class='new-dvs-version-description-bullet'></span>" +
                        "<span class='new-dvs-version-description-item'>%description%</span><br/></div>";
                    items += template
                        .replace("%description%", description);
                });
                var content = title + items;
                var sectionTemplate = "<div data-test-id='dvs-version-section-%version%'>%content%<br/></div>";
                signpostMessage += sectionTemplate
                    .replace("%version%", version)
                    .replace("%content%", content);
            });
            this.signPostConfig = {
                message: "<div class='new-dvs-version-signpost-content'>%content%</div>"
                    .replace("%content%", signpostMessage)
            };
        };
        DvsVersionPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsVersionPageConstants"
        ];
        return DvsVersionPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsVersionPage", new DvsVersionPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvsVersionPageConstants", {
        versions: {
            _66: "6.6.0",
            _65: "6.5.0",
            _60: "6.0.0",
            _55: "5.5.0",
            _51: "5.1.0",
            _50: "5.0.0",
            _unknown: "unknown"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPrerequisitesValidationService = (function () {
        function DvsPrerequisitesValidationService(wizardConstants, i18nService) {
            this.wizardConstants = wizardConstants;
            this.i18nService = i18nService;
        }
        DvsPrerequisitesValidationService.prototype.getPrerequisitesOverallStatus = function (validationChecksData) {
            var _this = this;
            if (!validationChecksData || validationChecksData.length === 0) {
                return this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.pass");
            }
            var failedValidationCheck = _.find(validationChecksData, function (item) {
                return item.type === _this.wizardConstants.validationResult.FAIL;
            });
            if (failedValidationCheck !== undefined) {
                return this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.fail");
            }
            var warningValidationCheck = _.find(validationChecksData, function (item) {
                return item.type === _this.wizardConstants.validationResult.WARNING;
            });
            if (warningValidationCheck !== undefined) {
                return this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.warn");
            }
            return this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.pass");
        };
        DvsPrerequisitesValidationService.$inject = ["dvsUpgradeLacpWizardConstants", "i18nService"];
        return DvsPrerequisitesValidationService;
    }());
    dvs_ui.DvsPrerequisitesValidationService = DvsPrerequisitesValidationService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPrerequisitesValidationService", DvsPrerequisitesValidationService);
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsCommonPropertiesValidator = (function () {
        function DvsCommonPropertiesValidator(i18nService, mutationService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
        }
        DvsCommonPropertiesValidator.prototype.getNameError = function (name) {
            var trimmedName = name.trim();
            var escapedName = trimmedName.replace(/%/g, "%25")
                .replace(/\//g, "%2f").replace(/\\/g, "%5c");
            if (escapedName.length === 0) {
                return this.i18nService.getString("DvsUi", "DvsName.validation.noDvsName");
            }
            else if (escapedName.length > DvsCommonPropertiesValidator.NAME_MAX_LENGTH) {
                return this.i18nService.getString("DvsUi", "DvsName.validation.tooLongDvsName");
            }
            return null;
        };
        DvsCommonPropertiesValidator.prototype.getNameServerError = function (urn, name) {
            return this.mutationService.validate(urn, "com.vmware.vsphere.client.h5.network.dvs.editsettings.model.DvsNameSpec", {
                _type: "com.vmware.vsphere.client.h5.network.dvs.editsettings.model.DvsNameSpec",
                name: name.trim()
            })
                .then(function (validationResult) {
                if (validationResult.error && validationResult.error.localizedMessage) {
                    return validationResult.error.localizedMessage;
                }
                if (validationResult.result) {
                    return validationResult.result;
                }
                return null;
            }, function () {
                return null;
            });
        };
        DvsCommonPropertiesValidator.prototype.getNumberOfUplinksError = function (numUplinks, maxNumUplinks) {
            if (maxNumUplinks === void 0) { maxNumUplinks = 32; }
            var isPositiveInteger = (numUplinks !== null && numUplinks !== undefined)
                && new RegExp("^[0-9]+$").test(numUplinks.toString());
            if (numUplinks < 1 || typeof numUplinks !== "number" || !isPositiveInteger) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.generalPage.numUplinks.error.min");
            }
            if (numUplinks > maxNumUplinks) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.generalPage.numUplinks.error.max", maxNumUplinks);
            }
            return null;
        };
        DvsCommonPropertiesValidator.$inject = [
            "i18nService",
            "mutationService"
        ];
        DvsCommonPropertiesValidator.NAME_MAX_LENGTH = 80;
        return DvsCommonPropertiesValidator;
    }());
    dvs_ui.DvsCommonPropertiesValidator = DvsCommonPropertiesValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsCommonPropertiesValidator", DvsCommonPropertiesValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPrerequisitesPageValidator = (function () {
        function DvsPrerequisitesPageValidator(i18nService, $q, dvsPrerequisitesValidationService, clarityModalService) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.dvsPrerequisitesValidationService = dvsPrerequisitesValidationService;
            this.clarityModalService = clarityModalService;
        }
        DvsPrerequisitesPageValidator.prototype.getValidationResult = function (prerequisiteChecks, model) {
            var overallUpgradeStatus = this.dvsPrerequisitesValidationService.getPrerequisitesOverallStatus(prerequisiteChecks);
            if (overallUpgradeStatus === this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.fail")) {
                return this.$q.resolve([this.i18nService.getString("DvsUi", "PrerequisitesPage.unmetPrerequisites")]);
            }
            return this.$q.resolve(this.showValidationWarning(prerequisiteChecks, model));
        };
        DvsPrerequisitesPageValidator.prototype.showValidationWarning = function (prerequisiteChecks, model) {
            if (model.prerequisiteWarningShown) {
                return [];
            }
            var overallUpgradeStatus = this.dvsPrerequisitesValidationService
                .getPrerequisitesOverallStatus(prerequisiteChecks);
            if (overallUpgradeStatus === this.i18nService.getString("DvsUi", "PrerequisitesPage.overallStatus.warn")) {
                var deferred_1 = this.$q.defer();
                var modalOptions = {
                    size: "md",
                    title: this.i18nService.getString("DvsUi", "PrerequisitesPage.confirmation.title"),
                    defaultButton: "submit",
                    modalClass: "dvs-upgrade-warning-modal",
                    alerts: [],
                    dialogData: {
                        message: this.i18nService.getString("DvsUi", "PrerequisitesPage.confirmation.text")
                    },
                    contentTemplate: "dvs-ui/resources/dvs/common/component/" +
                        "dvsUpgradeWarningDialog.html",
                    preserveNewlines: true,
                    clarityIcon: {
                        shape: "warning",
                        class: "is-warning",
                        size: 32
                    },
                    onSubmit: function () {
                        deferred_1.resolve(true);
                        model.prerequisiteWarningShown = true;
                        return true;
                    },
                    onCancel: function () {
                        deferred_1.resolve(false);
                    }
                };
                this.clarityModalService.openOkCancelModal(modalOptions);
                return deferred_1.promise.then(function (result) {
                    return result;
                });
            }
            else {
                return [];
            }
        };
        DvsPrerequisitesPageValidator.$inject = [
            "i18nService",
            "$q",
            "dvsPrerequisitesValidationService",
            "clarityModalService"];
        return DvsPrerequisitesPageValidator;
    }());
    dvs_ui.DvsPrerequisitesPageValidator = DvsPrerequisitesPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPrerequisitesPageValidator", DvsPrerequisitesPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvsCreateWizardConstants", {
        page: {
            DVS_SELECT_NAME_AND_LOCATION_PAGE: "selectNameAndLocationPage",
            DVS_SELECT_VERSION_PAGE: "selectVersionPage",
            DVS_CONFIGURE_SETTINGS_PAGE: "configureSettingsPage",
            DVS_READY_TO_COMPLETE_PAGE: "readyToCompletePage"
        },
        properties: {
            DVS_NEW_UNIQUE_NAME: "newUniqueDvsName",
            DVPG_NEW_UNIQUE_NAME: "newUniquePortGroupName",
            PRIMARY_ICON_ID: "primaryIconId",
            LOCATION_NAME_PROPERTY: "name",
            SUPPORTED_PRODUCT_SPEC: "supportedProductSpec"
        },
        spec: {
            DVS_CREATE_WIZARD_MUTATION_SPEC: "com.vmware.vsphere.client.h5.network.dvs.create.model.DvsCreateWizardMutationSpec",
            DVS_CREATE_SPEC: "com.vmware.vim.binding.vim.DistributedVirtualSwitch$CreateSpec",
            DVS_CONFIG_SPEC: "com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$ConfigSpec",
            DVS_PRODUCT_SPEC: "com.vmware.vim.binding.vim.dvs.ProductSpec",
            DVS_UPLINK_PORT_POLICY: "com.vmware.vim.binding.vim.DistributedVirtualSwitch$NameArrayUplinkPortPolicy"
        },
        niocVersions: {
            na: null,
            _2: "version2",
            _3: "version3"
        },
        lacpVersions: {
            na: null,
            singleLag: "singleLag",
            multipleLag: "multipleLag"
        },
        defaultUplinkName: "Uplink "
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsCreateWizardPages = (function () {
        function DvsCreateWizardPages(i18nService, dvsCreateWizardConstants, simpleValidationCommit, validator, dvpgPropertiesService) {
            this.i18nService = i18nService;
            this.dvsCreateWizardConstants = dvsCreateWizardConstants;
            this.simpleValidationCommit = simpleValidationCommit;
            this.validator = validator;
            this.dvpgPropertiesService = dvpgPropertiesService;
        }
        /**
         * Creates an array of page definitions for the Dvs create wizard.
         */
        DvsCreateWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var selectNameAndLocationPage = {
                id: this.dvsCreateWizardConstants.page.DVS_SELECT_NAME_AND_LOCATION_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsNameAndLocationPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsNameAndLocationPage.description"),
                contentUrl: "dvs-ui/resources/dvs/create/views/dvsNameAndLocationPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    var nameError = _this.validator.getNameError(wizardScope.model.uniqueDvsName);
                    if (!nameError) {
                        return _this.validator.getNameServerError(wizardScope.model.parentEntityUrn, wizardScope.model.uniqueDvsName)
                            .then(function (error) {
                            return error ? [error] : [];
                        });
                    }
                    else {
                        return [nameError];
                    }
                }, wizardScope.wizardConfig),
                validationParams: ["model.uniqueDvsName"]
            };
            var selectVersionPage = {
                id: this.dvsCreateWizardConstants.page.DVS_SELECT_VERSION_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsVersionPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsVersionPage.description"),
                contentUrl: "dvs-ui/resources/dvs/create/views/dvsVersionPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.selectedVersion"]
            };
            var configureSettingsPage = {
                id: this.dvsCreateWizardConstants.page.DVS_CONFIGURE_SETTINGS_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.description"),
                contentUrl: "dvs-ui/resources/dvs/create/views/dvsConfigureSettingsPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    var errors = [];
                    var numUplinksError = _this.validator.getNumberOfUplinksError(wizardScope.model.numberOfUplinks);
                    if (numUplinksError) {
                        errors.push(numUplinksError);
                    }
                    if (wizardScope.model.createDefaultPortgroup) {
                        var portgroupNameError = _this.dvpgPropertiesService.getInvalidNameError(wizardScope.model.defaultPortgroupName);
                        if (portgroupNameError) {
                            errors.push(portgroupNameError);
                        }
                    }
                    if (errors.length > 0) {
                        return errors;
                    }
                    else {
                        if (wizardScope.model.createDefaultPortgroup) {
                            return _this.dvpgPropertiesService.getDuplicateOrTooLongNameError(wizardScope.model.parentEntityUrn, wizardScope.model.defaultPortgroupName)
                                .then(function (errors) {
                                return errors;
                            });
                        }
                        else {
                            return [];
                        }
                    }
                }, wizardScope.wizardConfig),
                validationParams: ["model.numberOfUplinks",
                    "model.createDefaultPortgroup",
                    "model.defaultPortgroupName"]
            };
            var readyToCompletePage = {
                id: this.dvsCreateWizardConstants.page.DVS_READY_TO_COMPLETE_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.title"),
                description: this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.description"),
                contentUrl: "dvs-ui/resources/dvs/create/views/dvsReadyToCompletePage.html",
                onCommit: function () {
                    return true;
                },
                validationParams: []
            };
            return [selectNameAndLocationPage, selectVersionPage, configureSettingsPage,
                readyToCompletePage];
        };
        DvsCreateWizardPages.$inject = [
            "i18nService",
            "dvsCreateWizardConstants",
            "simpleValidationCommit",
            "dvsCommonPropertiesValidator",
            "dvpgPropertiesService"
        ];
        return DvsCreateWizardPages;
    }());
    dvs_ui.DvsCreateWizardPages = DvsCreateWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsCreateWizardPages", DvsCreateWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsCreateWizardService = (function () {
        function DvsCreateWizardService($rootScope, i18nService, vuiWizardService, pageStateManagementService, mutationService, wizardConstants, dvsCreateWizardPages, dataService, wizardValidationService, defaultUriSchemeUtil) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.pageStateManagementService = pageStateManagementService;
            this.mutationService = mutationService;
            this.wizardConstants = wizardConstants;
            this.dvsCreateWizardPages = dvsCreateWizardPages;
            this.dataService = dataService;
            this.wizardValidationService = wizardValidationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Shows the Create Distributed Switch wizard.
         */
        DvsCreateWizardService.prototype.show = function (parentUrn) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsCreateWizardModel();
            wizardScope.model.parentEntityUrn = parentUrn;
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("DvsUi", "actionCreateDvsTitle"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                onFinish: function () {
                    var spec = {
                        parentEntityMor: _this.defaultUriSchemeUtil
                            .getManagedObjectReference(wizardScope.model.parentEntityUrn),
                        uniqueDvsName: wizardScope.model.uniqueDvsName,
                        selectedVersion: wizardScope.model.selectedVersion,
                        numberOfUplinks: wizardScope.model.numberOfUplinks,
                        niocEnabled: wizardScope.model.niocEnabled,
                        createDefaultPortgroup: wizardScope.model.createDefaultPortgroup,
                        defaultPortgroupName: wizardScope.model.defaultPortgroupName
                    };
                    _this.mutationService.add(_this.wizardConstants.spec.DVS_CREATE_WIZARD_MUTATION_SPEC, spec);
                    return true;
                },
                configureSettingsPageInitialized: false
            };
            wizardScope.wizardConfig.pages =
                this.dvsCreateWizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
            this.requestProperties(wizardScope);
        };
        DvsCreateWizardService.prototype.requestProperties = function (wizardScope) {
            var _this = this;
            wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(wizardScope.model.parentEntityUrn, [
                this.wizardConstants.properties.DVS_NEW_UNIQUE_NAME,
                this.wizardConstants.properties.LOCATION_NAME_PROPERTY,
                this.wizardConstants.properties.PRIMARY_ICON_ID,
                this.wizardConstants.properties.SUPPORTED_PRODUCT_SPEC])
                .then(function (response) {
                wizardScope.model.uniqueDvsName = response[_this.wizardConstants.properties.DVS_NEW_UNIQUE_NAME];
                wizardScope.model.parentEntityName = response[_this.wizardConstants.properties.LOCATION_NAME_PROPERTY];
                wizardScope.model.parentEntityIcon = response[_this.wizardConstants.properties.PRIMARY_ICON_ID];
                wizardScope.model.supportedVersions = _.map(response[_this.wizardConstants.properties.SUPPORTED_PRODUCT_SPEC], function (productSpec) {
                    return productSpec.version;
                }).sort(function (versionA, versionB) {
                    if (versionA < versionB) {
                        return 1;
                    }
                    else if (versionB < versionA) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
                if (wizardScope.model.supportedVersions
                    && wizardScope.model.supportedVersions.length > 0) {
                    wizardScope.model.selectedVersion =
                        wizardScope.model.supportedVersions[0];
                }
                wizardScope.model.numberOfUplinks = 4;
                wizardScope.model.niocEnabled = true;
                wizardScope.model.createDefaultPortgroup = true;
                wizardScope.wizardConfig.loading = false;
            });
        };
        DvsCreateWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "pageStateManagementService",
            "mutationService",
            "dvsCreateWizardConstants",
            "dvsCreateWizardPages",
            "dataService",
            "wizardValidationService",
            "defaultUriSchemeUtil"];
        return DvsCreateWizardService;
    }());
    dvs_ui.DvsCreateWizardService = DvsCreateWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsCreateWizardService", DvsCreateWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsCreateWizardModel = (function () {
        function DvsCreateWizardModel() {
        }
        return DvsCreateWizardModel;
    }());
    dvs_ui.DvsCreateWizardModel = DvsCreateWizardModel;
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsConfigureSettingsPageComponent = (function () {
        function DvsConfigureSettingsPageComponent() {
            this.bindings = {
                wizardModel: "<",
                wizardConfig: "<"
            };
            this.controller = DvsConfigureSettingsPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/create/views/" +
                "dvsConfigureSettingsPageComponentTemplate.html";
        }
        return DvsConfigureSettingsPageComponent;
    }());
    dvs_ui.DvsConfigureSettingsPageComponent = DvsConfigureSettingsPageComponent;
    var DvsConfigureSettingsPageComponentController = (function () {
        function DvsConfigureSettingsPageComponentController(i18nService, $scope, validator, dataService, wizardConstants, dvpgPropertiesService) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.validator = validator;
            this.dataService = dataService;
            this.wizardConstants = wizardConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            $scope.i18n = this.i18nService.getString;
            this._numUplinksValidator = {
                message: null,
                isVisible: false
            };
            this._portgroupNameValidator = {
                message: null,
                isVisible: false
            };
            this._niocStatusOptions = [{
                    label: this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.resmgmt.enabled"),
                    value: true
                }, {
                    label: this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.resmgmt.disabled"),
                    value: false
                }];
            if (!this.wizardConfig.configureSettingsPageInitialized) {
                this.wizardConfig.loading = true;
                this.requestUniquePortgroupName();
            }
            else {
                // triggers validation in case the user returns to this page
                this.onNumUplinksChange();
                if (this.wizardModel.createDefaultPortgroup) {
                    this.onPortgroupNameChange();
                }
            }
        }
        Object.defineProperty(DvsConfigureSettingsPageComponentController.prototype, "numUplinksValidator", {
            get: function () {
                return this._numUplinksValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsConfigureSettingsPageComponentController.prototype.onNumUplinksChange = function () {
            var message = this.validator.getNumberOfUplinksError(this.wizardModel.numberOfUplinks);
            this.numUplinksValidator.message = message;
            this.numUplinksValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsConfigureSettingsPageComponentController.prototype, "portgroupNameValidator", {
            get: function () {
                return this._portgroupNameValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsConfigureSettingsPageComponentController.prototype.onPortgroupNameChange = function () {
            var message = this.dvpgPropertiesService.getInvalidNameError(this.wizardModel.defaultPortgroupName);
            this.portgroupNameValidator.message = message;
            this.portgroupNameValidator.isVisible = message !== null;
        };
        DvsConfigureSettingsPageComponentController.prototype.onCreatePortGroupCheckBoxChange = function () {
            if (this.wizardModel.createDefaultPortgroup) {
                this.onPortgroupNameChange();
            }
            else {
                this.portgroupNameValidator.message = null;
                this.portgroupNameValidator.isVisible = false;
            }
        };
        Object.defineProperty(DvsConfigureSettingsPageComponentController.prototype, "niocStatusOptions", {
            get: function () {
                return this._niocStatusOptions;
            },
            enumerable: true,
            configurable: true
        });
        DvsConfigureSettingsPageComponentController.prototype.requestUniquePortgroupName = function () {
            var _this = this;
            this.dataService.getProperties(this.wizardModel.parentEntityUrn, [this.wizardConstants.properties.DVPG_NEW_UNIQUE_NAME])
                .then(function (response) {
                _this.wizardModel.defaultPortgroupName
                    = response[_this.wizardConstants.properties.DVPG_NEW_UNIQUE_NAME];
                _this.wizardConfig.loading = false;
                _this.wizardConfig.configureSettingsPageInitialized = true;
            });
        };
        DvsConfigureSettingsPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsCommonPropertiesValidator",
            "dataService",
            "dvsCreateWizardConstants",
            "dvpgPropertiesService"
        ];
        return DvsConfigureSettingsPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsConfigureSettingsPage", new DvsConfigureSettingsPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNameAndLocationPageComponent = (function () {
        function DvsNameAndLocationPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsNameAndLocationPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/create/views/" +
                "dvsNameAndLocationPageComponentTemplate.html";
        }
        return DvsNameAndLocationPageComponent;
    }());
    dvs_ui.DvsNameAndLocationPageComponent = DvsNameAndLocationPageComponent;
    var DvsNameAndLocationPageComponentController = (function () {
        function DvsNameAndLocationPageComponentController(i18nService, $scope, validator) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.validator = validator;
            $scope.i18n = this.i18nService.getString;
            this._nameValidator = {
                message: null,
                isVisible: false
            };
        }
        Object.defineProperty(DvsNameAndLocationPageComponentController.prototype, "nameValidator", {
            get: function () {
                return this._nameValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsNameAndLocationPageComponentController.prototype.onNameChange = function () {
            var message = this.validator.getNameError(this.wizardModel.uniqueDvsName);
            this.nameValidator.message = message;
            this.nameValidator.isVisible = message !== null;
        };
        DvsNameAndLocationPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsCommonPropertiesValidator"
        ];
        return DvsNameAndLocationPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNameAndLocationPage", new DvsNameAndLocationPageComponent());
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsReadyToCompletePageComponent = (function () {
        function DvsReadyToCompletePageComponent() {
            this.bindings = {
                wizardModel: "<",
                wizardConfig: "<"
            };
            this.controller = DvsReadyToCompletePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/create/views/" +
                "dvsReadyToCompletePageComponentTemplate.html";
        }
        return DvsReadyToCompletePageComponent;
    }());
    dvs_ui.DvsReadyToCompletePageComponent = DvsReadyToCompletePageComponent;
    var DvsReadyToCompletePageComponentController = (function () {
        function DvsReadyToCompletePageComponentController(i18nService, $scope, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$scope.i18n = this.i18nService.getString;
            this.wizardConfig.loading = true;
            this.buildPropertyView();
            this.wizardConfig.loading = false;
        }
        DvsReadyToCompletePageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            generalSection.property(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.dvsName"), this.wizardModel.uniqueDvsName);
            generalSection.property(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.dvsVersion"), this.wizardModel.selectedVersion);
            generalSection.property(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.numberOfUplinks"), this.wizardModel.numberOfUplinks);
            var niocStatusLabel = this.wizardModel.niocEnabled
                ? this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.resmgmt.enabled")
                : this.i18nService.getString("DvsUi", "DvsConfigureSettingsPage.resmgmt.disabled");
            generalSection.property(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.niocStatus"), niocStatusLabel);
            if (this.wizardModel.createDefaultPortgroup) {
                generalSection.property(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.defaultPortgroup"), this.wizardModel.defaultPortgroupName);
            }
            var suggestedActionsSection = generalCategory.section("suggestedActionsSection")
                .title(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.section.nextActions.title"));
            var portgroupActionKeyBuilder = suggestedActionsSection.propertyBuilder()
                .keyBuilder();
            portgroupActionKeyBuilder.text(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.newPortgroup"));
            portgroupActionKeyBuilder.icon("vsphere-icon-virtual-port-group");
            var addHostsActionKeyBuilder = suggestedActionsSection.propertyBuilder()
                .keyBuilder();
            addHostsActionKeyBuilder.text(this.i18nService.getString("DvsUi", "DvsReadyToCompletePage.property.addAndManageHosts"));
            addHostsActionKeyBuilder
                .icon("non-clarity-icon k-sprite network-lib-ui-icon-dvsManageHost");
            this._propertyViewData = builder.build();
        };
        Object.defineProperty(DvsReadyToCompletePageComponentController.prototype, "propertyViewData", {
            get: function () {
                return this._propertyViewData;
            },
            enumerable: true,
            configurable: true
        });
        DvsReadyToCompletePageComponentController.$inject = [
            "i18nService",
            "$scope",
            "vxPropertyViewService"
        ];
        return DvsReadyToCompletePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsReadyToCompletePage", new DvsReadyToCompletePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgAdvancedPageComponent = (function () {
        function DvpgAdvancedPageComponent() {
            this.bindings = {
                model: "<",
                hasPolicyPrivilege: "<"
            };
            this.controller = DvpgAdvancedPageController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgAdvancedPageTemplate.html";
        }
        return DvpgAdvancedPageComponent;
    }());
    dvs_ui.DvpgAdvancedPageComponent = DvpgAdvancedPageComponent;
    var DvpgAdvancedPageController = (function () {
        function DvpgAdvancedPageController(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
            this.options = [{
                    value: true,
                    label: this.i18n("NetworkUi", "dvpg.properties.resetAtDisconnect.on")
                }, {
                    value: false,
                    label: this.i18n("NetworkUi", "dvpg.properties.resetAtDisconnect.off")
                }];
            this.supportedPolicies = {};
            _.each(this.model, function (value, key) {
                if (value !== null && typeof value !== "undefined") {
                    _this.supportedPolicies[key] = true;
                }
            });
        }
        DvpgAdvancedPageController.$inject = [
            "i18nService"
        ];
        return DvpgAdvancedPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvpgAdvancedPage", new DvpgAdvancedPageComponent());
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvpgFailoverPolicyPageComponent = (function () {
        function DvpgFailoverPolicyPageComponent() {
            this.bindings = {
                model: "<",
                failoverOrderOptions: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgFailoverPolicyPageController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgFailoverPolicyPageTemplate.html";
        }
        return DvpgFailoverPolicyPageComponent;
    }());
    dvs_ui.DvpgFailoverPolicyPageComponent = DvpgFailoverPolicyPageComponent;
    var DvpgFailoverPolicyPageController = (function () {
        function DvpgFailoverPolicyPageController(i18nService, $scope, dvpgFailoverPolicyPageService, networkUiConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
            this.networkUiConstants = networkUiConstants;
            this.i18n = this.i18nService.getString;
            this.loadBalancingOptions = [];
            this.onFailoverOrderChange = this.updateFailoverOrder.bind(this);
            if (this.model.loadBalancingModes && this.model.loadBalancingModes.length > 0) {
                this.model.loadBalancingModes.forEach(function (mode) {
                    var option = {
                        label: _this.dvpgFailoverPolicyPageService.getNicTeamingModeLabel(mode),
                        val: mode
                    };
                    _this.loadBalancingOptions.push(option);
                });
            }
            this.failoverOrderHeaderOptions = {
                title: this.i18n("NetworkUi", "dvpg.policy.failover.page.order.label")
            };
            this.hasLoadBalancingWarningMessage = function () {
                return _this.dvpgFailoverPolicyPageService.hasLoadBalancingWarningMessage(_this.failoverOrderOptions.connectees.active, _this.failoverOrderOptions.connectees.standby, _this.model.loadBalancing, _this.model.beaconProbing, false /*showNoActiveUplinksWarning*/, _this.overrideOptions);
            };
            this.beaconProbingOptions = [{
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.detection.beaconProbing"),
                    val: true
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.detection.linkStatus"),
                    val: false
                }];
            this.notifySwitchesOptions = [{
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.notify.off"),
                    val: false
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.notify.on"),
                    val: true
                }];
            this.rollingOrderOptions = [{
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.failback.off"),
                    val: true
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.failover.failback.on"),
                    val: false
                }];
            this.failoverOrderActions = [
                this.networkUiConstants.failoverOrderActions.MOVE_UP,
                this.networkUiConstants.failoverOrderActions.MOVE_DOWN
            ];
            this.signPostConfig = {
                message: null,
                title: this.i18n("NetworkUi", "dvpg.policy.failover.lb.loadbalance_ip.popup.title"),
                class: "edit-dv-pg-signpost"
            };
        }
        DvpgFailoverPolicyPageController.prototype.updateFailoverOrder = function () {
            var isFailoverOrderChanged = this.dvpgFailoverPolicyPageService.hasFailoverOrderChanged(this.failoverOrderOptions, this.model.failoverOrder.activeUplinkPortNames, this.model.failoverOrder.standbyUplinkPortNames);
            if (isFailoverOrderChanged) {
                this.model.failoverOrder.activeUplinkPortNames =
                    this.failoverOrderOptions.connectees.active.slice();
                this.model.failoverOrder.standbyUplinkPortNames =
                    this.failoverOrderOptions.connectees.standby.slice();
                this.model.failoverOrder.unusedUplinkPortNames =
                    this.failoverOrderOptions.connectees.unused.slice();
            }
            this.getLoadBalancingMessages();
        };
        DvpgFailoverPolicyPageController.prototype.getLoadBalancingMessages = function () {
            this.signPostConfig.message = null;
            var loadBalancingMessages = this.dvpgFailoverPolicyPageService.getLoadBalancingMessages(this.failoverOrderOptions.connectees, this.model.loadBalancing, this.model.beaconProbing, this.overrideOptions);
            this.signPostConfig.message = loadBalancingMessages ?
                loadBalancingMessages.join(" ") : null;
            this.signPostIconShape = this.hasLoadBalancingWarningMessage() ?
                'exclamation-triangle' : 'info-circle';
        };
        DvpgFailoverPolicyPageController.$inject = [
            "i18nService",
            "$scope",
            "dvpgFailoverPolicyPageService",
            "networkUiConstants"
        ];
        return DvpgFailoverPolicyPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgFailoverPolicyPage", new DvpgFailoverPolicyPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgMiscPageComponent = (function () {
        function DvpgMiscPageComponent() {
            this.bindings = {
                model: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgMiscPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgMiscPageTemplate.html";
        }
        return DvpgMiscPageComponent;
    }());
    dvs_ui.DvpgMiscPageComponent = DvpgMiscPageComponent;
    var DvpgMiscPageComponentController = (function () {
        function DvpgMiscPageComponentController(i18nService) {
            this.i18nService = i18nService;
            this.options = [{
                    value: true,
                    label: this.i18nService.getString("DvsUi", "dvpg.policy.misc.block.on")
                }, {
                    value: false,
                    label: this.i18nService.getString("DvsUi", "dvpg.policy.misc.block.off")
                }];
            this.blockPortLabel = this.overrideEnabled
                ? this.i18nService.getString("NetworkUi", "port.policy.misc.block.label")
                : this.i18nService.getString("DvsUi", "dvpg.manage.policy.misc.block");
            this.blockPortWarning = this.overrideEnabled
                ? this.i18nService.getString("NetworkUi", "port.policy.misc.block.warning")
                : this.i18nService.getString("DvsUi", "dvpg.policy.misc.block.warning");
        }
        DvpgMiscPageComponentController.$inject = ["i18nService"];
        return DvpgMiscPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvpgMiscPage", new DvpgMiscPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgMonitoringPageComponent = (function () {
        function DvpgMonitoringPageComponent() {
            this.bindings = {
                model: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgMonitoringPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgMonitoringPageTemplate.html";
        }
        return DvpgMonitoringPageComponent;
    }());
    dvs_ui.DvpgMonitoringPageComponent = DvpgMonitoringPageComponent;
    var DvpgMonitoringPageComponentController = (function () {
        function DvpgMonitoringPageComponentController(i18nService) {
            this.i18nService = i18nService;
            this.options = [{
                    value: true,
                    label: this.i18nService.getString("DvsUi", "dvpg.manage.policy.monitoring.status.on")
                }, {
                    value: false,
                    label: this.i18nService.getString("DvsUi", "dvpg.manage.policy.monitoring.status.off")
                }];
        }
        DvpgMonitoringPageComponentController.$inject = ["i18nService"];
        return DvpgMonitoringPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvpgMonitoringPage", new DvpgMonitoringPageComponent());
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvpgSecurityPolicyPageComponent = (function () {
        function DvpgSecurityPolicyPageComponent() {
            this.bindings = {
                model: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgSecurityPolicyPageController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgSecurityPolicyPageTemplate.html";
        }
        return DvpgSecurityPolicyPageComponent;
    }());
    dvs_ui.DvpgSecurityPolicyPageComponent = DvpgSecurityPolicyPageComponent;
    var DvpgSecurityPolicyPageController = (function () {
        function DvpgSecurityPolicyPageController(i18nService, $scope) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.i18n = this.i18nService.getString;
            this.securityPolicyOptions = [{
                    label: this.i18n("NetworkUi", "dvpg.policy.security.accept"),
                    val: true
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.security.reject"),
                    val: false
                }];
        }
        DvpgSecurityPolicyPageController.$inject = [
            "i18nService",
            "$scope"
        ];
        return DvpgSecurityPolicyPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgSecurityPolicyPage", new DvpgSecurityPolicyPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficShapingPageComponent = (function () {
        function DvpgTrafficShapingPageComponent() {
            this.bindings = {
                model: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgTrafficShapingPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgTrafficShapingPageTemplate.html";
        }
        return DvpgTrafficShapingPageComponent;
    }());
    dvs_ui.DvpgTrafficShapingPageComponent = DvpgTrafficShapingPageComponent;
    var DvpgTrafficShapingPageComponentController = (function () {
        function DvpgTrafficShapingPageComponentController($scope, i18nService, networkUiConstants, trafficShapingPolicyValidator) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.trafficShapingPolicyValidator = trafficShapingPolicyValidator;
            this.i18n = i18nService.getString;
            this.attributeNames = [
                networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH,
                networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH,
                networkUiConstants.TrafficShapingSetting.BURST_SIZE
            ];
            this.initPage();
        }
        DvpgTrafficShapingPageComponentController.prototype.onIngressStatusChange = function () {
            var _this = this;
            _.forEach(this.attributeNames, function (attributeName) {
                _this.onIngressTrafficShapingChange(attributeName);
            });
        };
        DvpgTrafficShapingPageComponentController.prototype.onEgressStatusChange = function () {
            var _this = this;
            _.forEach(this.attributeNames, function (attributeName) {
                _this.onEgressTrafficShapingChange(attributeName);
            });
        };
        DvpgTrafficShapingPageComponentController.prototype.onIngressTrafficShapingChange = function (attributeName) {
            var value = this.model.inShapingPolicy[attributeName];
            var message = this.trafficShapingPolicyValidator
                .getTrafficShapingErrorMessage(value, attributeName);
            this.validators.ingress[attributeName].message = message;
            this.validators.ingress[attributeName].isVisible =
                this.model.inShapingPolicy.enabled && message !== null;
        };
        DvpgTrafficShapingPageComponentController.prototype.onEgressTrafficShapingChange = function (attributeName) {
            var value = this.model.outShapingPolicy[attributeName];
            var message = this.trafficShapingPolicyValidator
                .getTrafficShapingErrorMessage(value, attributeName);
            this.validators.egress[attributeName].message = message;
            this.validators.egress[attributeName].isVisible =
                this.model.outShapingPolicy.enabled && message !== null;
        };
        DvpgTrafficShapingPageComponentController.prototype.initPage = function () {
            this.validators = this.buildInputValidators();
            this.statusPolicyOptions = this.buildStatusPolicyOptions();
        };
        DvpgTrafficShapingPageComponentController.prototype.buildInputValidators = function () {
            return {
                ingress: {
                    averageBandwidth: this.buildDefaultValidator(),
                    peakBandwidth: this.buildDefaultValidator(),
                    burstSize: this.buildDefaultValidator()
                }, egress: {
                    averageBandwidth: this.buildDefaultValidator(),
                    peakBandwidth: this.buildDefaultValidator(),
                    burstSize: this.buildDefaultValidator()
                }
            };
        };
        DvpgTrafficShapingPageComponentController.prototype.buildDefaultValidator = function () {
            return {
                message: null,
                isVisible: false
            };
        };
        DvpgTrafficShapingPageComponentController.prototype.buildStatusPolicyOptions = function () {
            return [{
                    label: this.i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.on'),
                    val: true
                }, {
                    label: this.i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.off'),
                    val: false
                }];
        };
        DvpgTrafficShapingPageComponentController.$inject = [
            "$scope",
            "i18nService",
            "networkUiConstants",
            "trafficShapingPolicyValidator"];
        return DvpgTrafficShapingPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgTrafficShapingPage", new DvpgTrafficShapingPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgVlanPageComponent = (function () {
        function DvpgVlanPageComponent() {
            this.bindings = {
                model: "<",
                overrideOptions: "<?",
                overrideEnabled: "<?",
                overrideDisallowed: "<?"
            };
            this.controller = DvpgVlanPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/common/components/" +
                "dvpgVlanPageTemplate.html";
        }
        return DvpgVlanPageComponent;
    }());
    dvs_ui.DvpgVlanPageComponent = DvpgVlanPageComponent;
    var DvpgVlanPageComponentController = (function () {
        function DvpgVlanPageComponentController($scope, i18nService, networkUiConstants, dvpgPropertiesService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            this.vlanIdValidator = {};
            this.i18n = i18nService.getString;
            this.initPage();
        }
        DvpgVlanPageComponentController.prototype.onVlanTypeChange = function () {
            var newType = this.model.vlanType;
            if (newType === this.networkUiConstants.Vlan.Type.VLAN) {
                this.model.vlanId = this.networkUiConstants.Vlan.Id.MIN;
                this.setVlanIdValidator();
            }
            else if (newType === this.networkUiConstants.Vlan.Type.PRIVATE) {
                if (this.model.pvlanConfig &&
                    this.model.pvlanConfig.length > 0) {
                    this.model.pvlanId =
                        this.model.pvlanConfig[0].secondaryVlanId;
                }
            }
            else if (newType === this.networkUiConstants.Vlan.Type.TRUNK) {
                this.model.vlanTrunkRanges =
                    this.networkUiConstants.Vlan.DEFAULT_VLAN_TRUNK_RANGE;
            }
        };
        DvpgVlanPageComponentController.prototype.initPage = function () {
            this.vlanTypeOptions = [{
                    label: this.i18n("NetworkUi", "dvpg.policy.vlan.type.none"),
                    val: this.networkUiConstants.Vlan.Type.NONE
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.vlan.type.vlan"),
                    val: this.networkUiConstants.Vlan.Type.VLAN
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.vlan.type.trunk"),
                    val: this.networkUiConstants.Vlan.Type.TRUNK
                }, {
                    label: this.i18n("NetworkUi", "dvpg.policy.vlan.type.private"),
                    val: this.networkUiConstants.Vlan.Type.PRIVATE
                }];
            this.pvlanTypeOptions = this.buildPvlanOptions();
            this.isPvlanAllowed =
                this.model.pvlanConfig && this.model.pvlanConfig.length > 0;
        };
        DvpgVlanPageComponentController.prototype.setVlanIdValidator = function () {
            var message = this.dvpgPropertiesService.getVlanIdError(this.model.vlanId);
            this.vlanIdValidator.message = message;
            this.vlanIdValidator.isVisible = message !== null;
        };
        DvpgVlanPageComponentController.prototype.buildPvlanOptions = function () {
            var _this = this;
            var options = [];
            if (!this.model.pvlanConfig) {
                return options;
            }
            this.model.pvlanConfig.forEach(function (pvlanData) {
                var pvlanTypeLabel = _this.getPvlanTypeLabel(pvlanData.pvlanType);
                options.push({
                    label: _this.i18n("DvsUi", "dvpg.policy.vlan.displayFormat", pvlanTypeLabel, pvlanData.primaryVlanId, pvlanData.secondaryVlanId),
                    val: pvlanData.secondaryVlanId
                });
            });
            return options;
        };
        DvpgVlanPageComponentController.prototype.getPvlanTypeLabel = function (pvlanType) {
            switch (pvlanType) {
                case this.networkUiConstants.Vlan.PvlanType.ISOLATED: {
                    return this.i18n("DvsUi", "dvpg.policy.vlan.private.type.isolated");
                }
                case this.networkUiConstants.Vlan.PvlanType.PROMISCUOUS: {
                    return this.i18n("DvsUi", "dvpg.policy.vlan.private.type.promiscuous");
                }
                case this.networkUiConstants.Vlan.PvlanType.COMMUNITY: {
                    return this.i18n("DvsUi", "dvpg.policy.vlan.private.type.community");
                }
                default:
                    return "";
            }
        };
        DvpgVlanPageComponentController.$inject = [
            "$scope",
            "i18nService",
            "networkUiConstants",
            "dvpgPropertiesService"];
        return DvpgVlanPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgVlanPage", new DvpgVlanPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgFailoverPolicyPageService = (function () {
        function DvpgFailoverPolicyPageService(networkUtil, networkUiConstants, clarityModalService, $q) {
            this.networkUtil = networkUtil;
            this.networkUiConstants = networkUiConstants;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
        }
        DvpgFailoverPolicyPageService.prototype.hasFailoverOrderChanged = function (failoverOrder, activeUplinkPortNames, standbyUplinkPortNames) {
            if (failoverOrder.connectees.active.length !== activeUplinkPortNames.length
                || failoverOrder.connectees.standby.length !==
                    standbyUplinkPortNames.length) {
                return true;
            }
            else {
                var i = void 0;
                for (i = 0; i < failoverOrder.connectees.active.length; i++) {
                    if (failoverOrder.connectees.active[i] !== activeUplinkPortNames[i]) {
                        return true;
                    }
                }
                for (i = 0; i < failoverOrder.connectees.standby.length; i++) {
                    if (failoverOrder.connectees.standby[i] !== standbyUplinkPortNames[i]) {
                        return true;
                    }
                }
                return false;
            }
        };
        DvpgFailoverPolicyPageService.prototype.getNicTeamingModeLabel = function (mode) {
            switch (mode) {
                case this.networkUiConstants.LoadBalancingPolicy.IP: {
                    return this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip");
                }
                case this.networkUiConstants.LoadBalancingPolicy.EXPLICIT: {
                    return this.networkUtil.getString("dvpg.policy.failover.lb.failover_explicit");
                }
                case this.networkUiConstants.LoadBalancingPolicy.LOADBASED: {
                    return this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_loadbased");
                }
                case this.networkUiConstants.LoadBalancingPolicy.SRCID: {
                    return this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_srcid");
                }
                case this.networkUiConstants.LoadBalancingPolicy.SRCMAC: {
                    return this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_srcmac");
                }
                default: {
                    return "";
                }
            }
        };
        DvpgFailoverPolicyPageService.prototype.createFailoverOrderSettings = function (failoverOrder) {
            return {
                connectees: {
                    active: failoverOrder.activeUplinkPortNames.slice(),
                    standby: failoverOrder.standbyUplinkPortNames.slice(),
                    unused: failoverOrder.unusedUplinkPortNames.slice(),
                    lagNames: failoverOrder.lagNames ? failoverOrder.lagNames.slice() : null
                },
                labels: {
                    active: this.networkUtil.getString("dvpg.policy.failover.order.active.group"),
                    standby: this.networkUtil.getString("dvpg.policy.failover.order.standby.group"),
                    unused: this.networkUtil.getString("dvpg.policy.failover.order.unused.group")
                }
            };
        };
        DvpgFailoverPolicyPageService.prototype.getLoadBalancingMessages = function (failoverOrderConnectees, loadBalancing, beaconProbing, overrideOptions) {
            var messages = this.getFormattedLoadBalancingInfoMessages(failoverOrderConnectees, loadBalancing);
            if (loadBalancing !== this.networkUiConstants.LoadBalancingPolicy.IP) {
                return messages;
            }
            var warningMessage = this.getFormattedLoadBalancingWarningMessages(failoverOrderConnectees.active, failoverOrderConnectees.standby, loadBalancing, beaconProbing, false /*showNoActiveUplinksWarning*/, overrideOptions);
            if (warningMessage) {
                messages = warningMessage.concat(messages);
            }
            return messages;
        };
        DvpgFailoverPolicyPageService.prototype.getLoadBalancingWarningMessages = function (activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions) {
            var messages = [];
            if (overrideOptions) {
                return this.getLoadBalancingOverrideWarningMessages(activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions);
            }
            if (showNoActiveUplinksWarning && activeUplinks.length === 0) {
                messages = [this.networkUtil.getString("dvpg.policy.failover.order.warn.noActiveUplinks")];
            }
            if (loadBalancing !== this.networkUiConstants.LoadBalancingPolicy.IP) {
                return messages;
            }
            var standbyUplinksExist = standbyUplinks && standbyUplinks.length > 0;
            var warning;
            if (standbyUplinksExist && beaconProbing) {
                warning = [this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip." +
                        "warn.beaconProbingAndStandbyUplinks")];
                messages = messages.concat(warning);
            }
            else if (standbyUplinksExist) {
                warning = [this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.warn.standbyUplinks")];
                messages = messages.concat(warning);
            }
            else if (beaconProbing) {
                warning = [this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.warn.beaconProbing")];
                messages = messages.concat(warning);
            }
            return messages;
        };
        DvpgFailoverPolicyPageService.prototype.getLoadBalancingOverrideWarningMessages = function (activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions) {
            if (!overrideOptions.loadBalancing && !overrideOptions.failoverOrder
                && !overrideOptions.beaconProbing) {
                return [];
            }
            var messages = [];
            var standbyUplinksExist = standbyUplinks && standbyUplinks.length > 0;
            if (overrideOptions.failoverOrder
                && showNoActiveUplinksWarning && activeUplinks.length === 0) {
                messages = [this.networkUtil.getString("dvpg.policy.failover.order.warn.noActiveUplinks")];
            }
            if (overrideOptions.loadBalancing
                && loadBalancing !== this.networkUiConstants.LoadBalancingPolicy.IP) {
                return messages;
            }
            if (overrideOptions.loadBalancing) {
                if (overrideOptions.beaconProbing && overrideOptions.failoverOrder
                    && beaconProbing && standbyUplinksExist) {
                    messages.push(this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip." +
                        "warn.beaconProbingAndStandbyUplinks"));
                }
                else if (overrideOptions.beaconProbing && beaconProbing) {
                    messages.push(this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.warn.beaconProbing"));
                }
                else if (overrideOptions.failoverOrder && standbyUplinksExist) {
                    messages.push(this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.warn.standbyUplinks"));
                }
            }
            return messages;
        };
        DvpgFailoverPolicyPageService.prototype.hasLoadBalancingWarningMessage = function (activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions) {
            if (overrideOptions) {
                return this.hasLoadBalancingOverrideWarningMessage(activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions);
            }
            if (showNoActiveUplinksWarning && activeUplinks.length === 0) {
                return true;
            }
            if (loadBalancing !== this.networkUiConstants.LoadBalancingPolicy.IP) {
                return false;
            }
            return (standbyUplinks && standbyUplinks.length > 0) || beaconProbing;
        };
        DvpgFailoverPolicyPageService.prototype.shouldShowErrorWarningDialog = function (failoverOrderConnectees, loadBalancing, beaconProbing, overrideOptions) {
            return this.hasLagErrorMessage(failoverOrderConnectees, overrideOptions) ||
                this.hasLoadBalancingWarningMessage(failoverOrderConnectees.active, failoverOrderConnectees.standby, loadBalancing, beaconProbing, true /*showNoActieUplinkWarning*/, overrideOptions) ||
                this.hasLagWarningMessages(failoverOrderConnectees, beaconProbing, overrideOptions);
        };
        DvpgFailoverPolicyPageService.prototype.showErrorWarningDialog = function (failoverOrderConnectees, loadBalancing, beaconProbing, overrideOptions) {
            var errorMessage = this.getLagErrorMessage(failoverOrderConnectees, overrideOptions);
            var loadBalancingWarningMessages = this.getLoadBalancingWarningMessages(failoverOrderConnectees.active, failoverOrderConnectees.standby, loadBalancing, beaconProbing, true /*showNoActiveUplinksWarning*/, overrideOptions);
            var lagWarningMessages = this.getLagWarningMessages(failoverOrderConnectees, beaconProbing, overrideOptions);
            var warningMessages = loadBalancingWarningMessages.concat(lagWarningMessages);
            var deferred = this.$q.defer();
            var modalOptions = {
                size: "md",
                defaultButton: "close",
                alerts: [],
                dialogData: {},
                contentTemplate: "network-lib-ui/resources/network-lib/dvpg/" +
                    "edit/portgroupFailoverErrorWarningDialog.html",
                submit: function () {
                    deferred.resolve(true);
                    return true;
                },
                onCancel: function () {
                    deferred.resolve(false);
                    return true;
                }
            };
            var dialogWarningMessages = this.getDialogWarningMessages(warningMessages);
            if (errorMessage === null) {
                modalOptions.title =
                    this.networkUtil.getString("dvpg.policy.failover.confirmation.title");
                modalOptions.dialogData.messages = dialogWarningMessages;
            }
            else {
                var dialogErrorMessages = this.getDialogErrorMessages([errorMessage]);
                var dialogMessages = dialogErrorMessages.concat(dialogWarningMessages);
                modalOptions.title =
                    this.networkUtil.getString("dvpg.policy.failover.error.title");
                modalOptions.dialogData.messages = dialogMessages;
                modalOptions.hideSubmitButton = true;
                modalOptions.closeButtonTitle =
                    this.networkUtil.getString("MessageDialog.okButton");
            }
            // Append the confirmation tip message to the end
            modalOptions.dialogData.dialogInfo =
                this.networkUtil.getString("IssuesConfirmationDialog.tip");
            this.clarityModalService.openConfirmationModal(modalOptions);
            return deferred.promise.then(function (value) {
                return value;
            });
        };
        DvpgFailoverPolicyPageService.prototype.getFormattedLoadBalancingWarningMessages = function (activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions) {
            var warnMessageIconClass = 'vsphere-icon-status-warning';
            var message = this.getLoadBalancingWarningMessages(activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions);
            return this.networkUtil.formatTextMessagesWithIcon(message, warnMessageIconClass);
        };
        DvpgFailoverPolicyPageService.prototype.getLagWarningMessages = function (failoverOrderConnectees, beaconProbing, overrideOptions) {
            var lagWarningMessages = [];
            var activeUplinks = failoverOrderConnectees.active;
            var standbyUplinks = failoverOrderConnectees.standby;
            var lagNames = failoverOrderConnectees.lagNames;
            var activeLagCount = this.getLagCount(activeUplinks, lagNames);
            var standbyLagCount = this.getLagCount(standbyUplinks, lagNames);
            var activeStandaloneUplinkCount = activeUplinks.length - activeLagCount;
            if (standbyLagCount === 1 && activeStandaloneUplinkCount >= 1) {
                lagWarningMessages.push(this.networkUtil.getString("dvpg.policy.failover.order.warn.migrationMode"));
            }
            if (overrideOptions && !overrideOptions.beaconProbing) {
                return lagWarningMessages;
            }
            if (beaconProbing
                && !this.hasLagErrorMessage(failoverOrderConnectees, overrideOptions)
                && (activeLagCount + standbyLagCount) >= 1) {
                lagWarningMessages.push(this.networkUtil.getString("dvpg.policy.failover.order.warn.lacpBeaconProbing"));
            }
            return lagWarningMessages;
        };
        DvpgFailoverPolicyPageService.prototype.hasLagErrorMessage = function (failoverOrderConnectees, overrideOptions) {
            return this.getLagErrorMessage(failoverOrderConnectees, overrideOptions) !== null;
        };
        DvpgFailoverPolicyPageService.prototype.getLagErrorMessage = function (failoverOrderConnectees, overrideOptions) {
            if (overrideOptions && !overrideOptions.failoverOrder) {
                return null;
            }
            var activeUplinks = failoverOrderConnectees.active;
            var standbyUplinks = failoverOrderConnectees.standby;
            var unusedUplinks = failoverOrderConnectees.unused;
            var lagNames = failoverOrderConnectees.lagNames;
            if (!lagNames || lagNames.length === 0) {
                return null;
            }
            var activeAndStandbyLagCount = lagNames.length - this.getLagCount(unusedUplinks, lagNames);
            var activeAndStandbyStandaloneUplinkCount = activeUplinks.length + standbyUplinks.length - activeAndStandbyLagCount;
            if (activeAndStandbyLagCount > 1 &&
                activeAndStandbyStandaloneUplinkCount === 0) {
                return this.networkUtil.getString("dvpg.policy.failover.order.error.multipleLags");
            }
            var activeLagCount = this.getLagCount(activeUplinks, lagNames);
            var standbyLagCount = this.getLagCount(standbyUplinks, lagNames);
            var standbyStandaloneUplinkCount = standbyUplinks.length - standbyLagCount;
            if ((activeLagCount >= 1 && activeAndStandbyStandaloneUplinkCount >= 1) ||
                (standbyLagCount >= 1 && standbyStandaloneUplinkCount >= 1)) {
                return this.networkUtil.getString("dvpg.policy.failover.order.error.hybridMode");
            }
            return null;
        };
        DvpgFailoverPolicyPageService.prototype.hasLagWarningMessages = function (failoverOrderConnectees, beaconProbing, overrideOptions) {
            if (overrideOptions && !overrideOptions.failoverOrder) {
                return false;
            }
            return this.getLagWarningMessages(failoverOrderConnectees, beaconProbing, overrideOptions).length > 0;
        };
        DvpgFailoverPolicyPageService.prototype.getLagCount = function (uplinks, lagNames) {
            var lagCount = 0;
            if (!uplinks || !lagNames || uplinks.length === 0 || lagNames.length === 0) {
                return lagCount;
            }
            _.forEach(uplinks, function (uplink) {
                if (_.indexOf(lagNames, uplink) !== -1) {
                    lagCount++;
                }
            });
            return lagCount;
        };
        DvpgFailoverPolicyPageService.prototype.getFormattedLoadBalancingInfoMessages = function (failoverOrderConnectees, loadBalancing) {
            var infoMessageIconClass = "vsphere-icon-info";
            var messages = [];
            if (loadBalancing === this.networkUiConstants.LoadBalancingPolicy.IP) {
                messages = [
                    this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.info.etherChannel"),
                    this.networkUtil.getString("dvpg.policy.failover.lb.loadbalance_ip.info.portGroupPolicies")
                ];
            }
            if (this.hasSingleLagBacking(failoverOrderConnectees)) {
                messages.push(this.networkUtil.getString("dvpg.policy.failover.lb.sinlgeLag.info"));
            }
            return this.networkUtil.formatTextMessagesWithIcon(messages, infoMessageIconClass);
        };
        DvpgFailoverPolicyPageService.prototype.getDialogWarningMessages = function (warningMessages) {
            var dialogWarningMessages = [];
            _.forEach(warningMessages, function (warningMessage) {
                dialogWarningMessages.push({
                    iconClass: "warning",
                    text: warningMessage
                });
            });
            return dialogWarningMessages;
        };
        DvpgFailoverPolicyPageService.prototype.getDialogErrorMessages = function (errorMessages) {
            var dialogErrorMessages = [];
            _.forEach(errorMessages, function (errorMessage) {
                dialogErrorMessages.push({
                    iconClass: "danger",
                    text: errorMessage
                });
            });
            return dialogErrorMessages;
        };
        DvpgFailoverPolicyPageService.prototype.hasSingleLagBacking = function (failoverOrderConnectees) {
            if (failoverOrderConnectees) {
                if (failoverOrderConnectees.active.length +
                    failoverOrderConnectees.standby.length === 1) {
                    if (failoverOrderConnectees.lagNames &&
                        failoverOrderConnectees.lagNames.length > 0) {
                        var singleConnecteeName = failoverOrderConnectees.active.length === 1 ?
                            failoverOrderConnectees.active[0] :
                            failoverOrderConnectees.standby[0];
                        return _.indexOf(failoverOrderConnectees.lagNames, singleConnecteeName) !== -1;
                    }
                }
            }
            return false;
        };
        DvpgFailoverPolicyPageService.prototype.hasLoadBalancingOverrideWarningMessage = function (activeUplinks, standbyUplinks, loadBalancing, beaconProbing, showNoActiveUplinksWarning, overrideOptions) {
            if (!overrideOptions.loadBalancing && !overrideOptions.failoverOrder
                && !overrideOptions.beaconProbing) {
                return false;
            }
            if (overrideOptions.failoverOrder
                && showNoActiveUplinksWarning && activeUplinks.length === 0) {
                return true;
            }
            if (overrideOptions.loadBalancing
                && loadBalancing === this.networkUiConstants.LoadBalancingPolicy.IP) {
                if (overrideOptions.beaconProbing && overrideOptions.failoverOrder) {
                    return (standbyUplinks && standbyUplinks.length > 0) || beaconProbing;
                }
                else if (overrideOptions.beaconProbing) {
                    return beaconProbing;
                }
                else if (overrideOptions.failoverOrder) {
                    return standbyUplinks && standbyUplinks.length > 0;
                }
            }
            return false;
        };
        DvpgFailoverPolicyPageService.$inject = [
            "networkUtil",
            "networkUiConstants",
            "clarityModalService",
            "$q"];
        return DvpgFailoverPolicyPageService;
    }());
    dvs_ui.DvpgFailoverPolicyPageService = DvpgFailoverPolicyPageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgFailoverPolicyPageService", DvpgFailoverPolicyPageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VlanIdSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VlanIdSpec;
    var TrunkVlanSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$TrunkVlanSpec;
    var PvlanSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$PvlanSpec;
    var TrafficShapingPolicy = com.vmware.vim.binding.vim.dvs.DistributedVirtualPort$TrafficShapingPolicy;
    var UplinkPortTeamingPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$UplinkPortTeamingPolicy;
    var SecurityPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$SecurityPolicy;
    var FailureCriteria = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$FailureCriteria;
    var UplinkPortOrder = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$UplinkPortOrderPolicy;
    var BoolPolicy = com.vmware.vim.binding.vim.BoolPolicy;
    var StringPolicy = com.vmware.vim.binding.vim.StringPolicy;
    var LongPolicy = com.vmware.vim.binding.vim.LongPolicy;
    var VMwarePortgroupPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VMwarePortgroupPolicy;
    var DvpgSpecFactory = (function () {
        function DvpgSpecFactory(networkUiConstants) {
            this.networkUiConstants = networkUiConstants;
        }
        DvpgSpecFactory.prototype.buildVlanSpec = function (vlanData) {
            switch (vlanData.vlanType) {
                case this.networkUiConstants.Vlan.Type.NONE: {
                    var vlanSpec = new VlanIdSpec();
                    vlanSpec.vlanId = this.networkUiConstants.Vlan.Id.NONE;
                    return vlanSpec;
                }
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    var vlanSpec = new VlanIdSpec();
                    vlanSpec.vlanId = vlanData.vlanId;
                    return vlanSpec;
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    var vlanSpec = new TrunkVlanSpec();
                    vlanSpec.vlanId = vlanData.vlanTrunkNumericRanges;
                    return vlanSpec;
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    var vlanSpec = new PvlanSpec();
                    vlanSpec.pvlanId = vlanData.pvlanId;
                    return vlanSpec;
                }
                default: {
                    return null;
                }
            }
        };
        DvpgSpecFactory.prototype.buildSecurityPolicySpec = function (securityPolicy) {
            var securityPolicySpec = new SecurityPolicy();
            securityPolicySpec.inherited = false;
            securityPolicySpec.allowPromiscuous =
                this.buildBoolPolicy(securityPolicy.allowPromiscuous);
            securityPolicySpec.forgedTransmits =
                this.buildBoolPolicy(securityPolicy.forgedTransmits);
            securityPolicySpec.macChanges =
                this.buildBoolPolicy(securityPolicy.macChanges);
            return securityPolicySpec;
        };
        DvpgSpecFactory.prototype.buildTrafficShapingSpec = function (trafficShaping) {
            return this.buildTrafficShaping(trafficShaping, false);
        };
        DvpgSpecFactory.prototype.buildTrafficShapingSpecPort = function (trafficShaping, isInherited) {
            return this.buildTrafficShaping(trafficShaping, isInherited);
        };
        DvpgSpecFactory.prototype.buildTrafficShaping = function (trafficShaping, isInherited) {
            var trafficShapingEnabled = new BoolPolicy();
            trafficShapingEnabled.value = trafficShaping.enabled;
            trafficShapingEnabled.inherited = false;
            var trafficShapingPolicySpec = new TrafficShapingPolicy();
            trafficShapingPolicySpec.enabled = trafficShapingEnabled;
            trafficShapingPolicySpec.inherited = isInherited;
            if (trafficShapingPolicySpec.enabled.value && !isInherited) {
                trafficShapingPolicySpec.averageBandwidth = this.buildLongPolicy(trafficShaping.averageBandwidth * this.networkUiConstants.UnitFormat.KBPS);
                trafficShapingPolicySpec.peakBandwidth = this.buildLongPolicy(trafficShaping.peakBandwidth * this.networkUiConstants.UnitFormat.KBPS);
                trafficShapingPolicySpec.burstSize = this.buildLongPolicy(trafficShaping.burstSize * this.networkUiConstants.UnitFormat.KB);
            }
            return trafficShapingPolicySpec;
        };
        DvpgSpecFactory.prototype.buildTeamingAndFailoverPortSpec = function (teamingAndFailoverPolicy, overrideOptions) {
            return this.buildTeamingAndFailover(teamingAndFailoverPolicy, overrideOptions);
        };
        DvpgSpecFactory.prototype.buildTeamingAndFailoverSpec = function (teamingAndFailoverPolicy) {
            return this.buildTeamingAndFailover(teamingAndFailoverPolicy, null);
        };
        DvpgSpecFactory.prototype.buildTeamingAndFailover = function (teamingAndFailoverPolicy, overrideOptions) {
            var uplinkPortTeamingPolicy = new UplinkPortTeamingPolicy();
            uplinkPortTeamingPolicy.inherited = false;
            uplinkPortTeamingPolicy.policy = this.buildStringPolicy(teamingAndFailoverPolicy.loadBalancing);
            uplinkPortTeamingPolicy.policy.inherited =
                overrideOptions ? !overrideOptions.loadBalancing : false;
            var failureCriteria = new FailureCriteria();
            failureCriteria.inherited =
                overrideOptions ? !overrideOptions.beaconProbing : false;
            failureCriteria.checkBeacon = this.buildBoolPolicy(teamingAndFailoverPolicy.beaconProbing);
            failureCriteria.checkBeacon.inherited =
                overrideOptions ? !overrideOptions.beaconProbing : false;
            uplinkPortTeamingPolicy.failureCriteria = failureCriteria;
            uplinkPortTeamingPolicy.notifySwitches = this.buildBoolPolicy(teamingAndFailoverPolicy.notifySwitches);
            uplinkPortTeamingPolicy.notifySwitches.inherited =
                overrideOptions ? !overrideOptions.notifySwitches : false;
            uplinkPortTeamingPolicy.rollingOrder = this.buildBoolPolicy(teamingAndFailoverPolicy.rollingOrder);
            uplinkPortTeamingPolicy.rollingOrder.inherited =
                overrideOptions ? !overrideOptions.rollingOrder : false;
            uplinkPortTeamingPolicy.uplinkPortOrder = new UplinkPortOrder();
            uplinkPortTeamingPolicy.uplinkPortOrder.inherited =
                overrideOptions ? !overrideOptions.failoverOrder : false;
            uplinkPortTeamingPolicy.uplinkPortOrder.activeUplinkPort =
                teamingAndFailoverPolicy.failoverOrder.activeUplinkPortNames;
            uplinkPortTeamingPolicy.uplinkPortOrder.standbyUplinkPort =
                teamingAndFailoverPolicy.failoverOrder.standbyUplinkPortNames;
            return uplinkPortTeamingPolicy;
        };
        /**
         * Builds the resoirce pool allocation spec for reconfiguring a distributed portgroup.
         *
         * @param resourceAllocPolicy
         *    - the policyModel provided from the backend
         *
         * @returns
         *    - string for NIOCv3
         *    - StringPolicy for NIOCv2
         */
        DvpgSpecFactory.prototype.buildResourcePoolAllocationSpec = function (resourceAllocPolicy) {
            if (resourceAllocPolicy.isVmVnicResourcePoolSupported) {
                return resourceAllocPolicy.networkResourcePoolKey;
            }
            else {
                var policy = new StringPolicy();
                policy.inherited = false;
                policy.value = resourceAllocPolicy.networkResourcePoolKey;
                return policy;
            }
        };
        /**
         * Builds the monitoring spec for reconfiguring a distributed portgroup.
         *
         * @param monitoringPolicyModel
         *    - the policyModel provided from the backend
         *
         * @returns
         *    - the correct BoolPolicy
         */
        DvpgSpecFactory.prototype.buildMonitoringSpec = function (monitoringPolicyModel) {
            return this.buildBoolPolicy(monitoringPolicyModel.ipfixEnabled);
        };
        /**
         * Builds the misc spec for reconfiguring a distributed portgroup.
         *
         * @param miscPolicyModel
         *    - the policyModel provided from the backend
         *
         * @returns
         *    - the correct BoolPolicy
         */
        DvpgSpecFactory.prototype.buildMiscSpec = function (miscPolicyModel) {
            return this.buildBoolPolicy(miscPolicyModel.arePortsBlocked);
        };
        /**
         * Builds the portgroup overridden port policies
         *
         * @param portPoliciesModel
         *    - the model used in the 'Advanced' page
         * @returns {PortgroupPolicy}
         *    - the correct VMwarePortgroupPolicy
         */
        DvpgSpecFactory.prototype.buildPortPoliciesSpec = function (portPoliciesModel) {
            var policiesSpec = new VMwarePortgroupPolicy();
            if (this.isPolicySupported(portPoliciesModel.blockOverrideAllowed)) {
                policiesSpec.blockOverrideAllowed = portPoliciesModel.blockOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.portConfigResetAtDisconnect)) {
                policiesSpec.portConfigResetAtDisconnect
                    = portPoliciesModel.portConfigResetAtDisconnect;
            }
            if (this.isPolicySupported(portPoliciesModel.shapingOverrideAllowed)) {
                policiesSpec.shapingOverrideAllowed = portPoliciesModel.shapingOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.vendorConfigOverrideAllowed)) {
                policiesSpec.vendorConfigOverrideAllowed
                    = portPoliciesModel.vendorConfigOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.vlanOverrideAllowed)) {
                policiesSpec.vlanOverrideAllowed
                    = portPoliciesModel.vlanOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.uplinkTeamingOverrideAllowed)) {
                policiesSpec.uplinkTeamingOverrideAllowed
                    = portPoliciesModel.uplinkTeamingOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.networkResourcePoolOverrideAllowed)) {
                policiesSpec.networkResourcePoolOverrideAllowed
                    = portPoliciesModel.networkResourcePoolOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.securityPolicyOverrideAllowed)) {
                policiesSpec.securityPolicyOverrideAllowed
                    = portPoliciesModel.securityPolicyOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.ipfixOverrideAllowed)) {
                policiesSpec.ipfixOverrideAllowed = portPoliciesModel.ipfixOverrideAllowed;
            }
            if (this.isPolicySupported(portPoliciesModel.trafficFilterOverrideAllowed)) {
                policiesSpec.trafficFilterOverrideAllowed
                    = portPoliciesModel.trafficFilterOverrideAllowed;
            }
            return policiesSpec;
        };
        DvpgSpecFactory.prototype.buildLongPolicy = function (value) {
            var policy = new LongPolicy();
            policy.inherited = false;
            policy.value = value;
            return policy;
        };
        DvpgSpecFactory.prototype.buildStringPolicy = function (value) {
            var policy = new StringPolicy();
            policy.inherited = false;
            policy.value = value;
            return policy;
        };
        DvpgSpecFactory.prototype.buildBoolPolicy = function (value) {
            var policy = new BoolPolicy();
            policy.inherited = false;
            policy.value = value;
            return policy;
        };
        DvpgSpecFactory.prototype.isPolicySupported = function (value) {
            return value !== null && typeof value !== "undefined";
        };
        DvpgSpecFactory.$inject = ["networkUiConstants"];
        return DvpgSpecFactory;
    }());
    dvs_ui.DvpgSpecFactory = DvpgSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgSpecFactory", DvpgSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficShapingPolicyService = (function () {
        function DvpgTrafficShapingPolicyService(trafficShapingPolicyValidator, networkUiConstants, i18nService) {
            this.trafficShapingPolicyValidator = trafficShapingPolicyValidator;
            this.networkUiConstants = networkUiConstants;
            this.i18nService = i18nService;
            this.attributeNames = [
                networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH,
                networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH,
                networkUiConstants.TrafficShapingSetting.BURST_SIZE
            ];
        }
        /**
         * Validates the Ingress- and Egress Traffic Shaping policies.
         *
         * Returns an array of all related error messages, or an empty array when the
         * validations pass successfully.
         */
        DvpgTrafficShapingPolicyService.prototype.getErrorMessages = function (inShapingPolicy, outShapingPolicy) {
            var _this = this;
            var messages = [];
            _.forEach(this.attributeNames, function (attributeName) {
                var inValue = inShapingPolicy[attributeName];
                var outValue = outShapingPolicy[attributeName];
                if (inShapingPolicy.enabled) {
                    var inErrorMessage = _this.trafficShapingPolicyValidator
                        .getTrafficShapingErrorMessage(inValue, attributeName);
                    if (inErrorMessage !== null) {
                        messages.push(inErrorMessage);
                    }
                }
                if (outShapingPolicy.enabled) {
                    var outErrorMessage = _this.trafficShapingPolicyValidator
                        .getTrafficShapingErrorMessage(outValue, attributeName);
                    if (outErrorMessage !== null) {
                        messages.push(outErrorMessage);
                    }
                }
            });
            if (messages.length === 0) {
                var isOutShapingPolicyValid = this.isTrafficShapingPolicyValid(outShapingPolicy);
                var isInShapingPolicyValid = this.isTrafficShapingPolicyValid(inShapingPolicy);
                if (!isInShapingPolicyValid && !isOutShapingPolicyValid) {
                    messages.push(this.i18nService.getString('NetworkUi', 'dvpg.policy.shaping.both.avgBwGreaterThanPeakBw'));
                }
                else if (!isInShapingPolicyValid) {
                    messages.push(this.i18nService.getString('NetworkUi', 'dvpg.policy.shaping.ingress.avgBwGreaterThanPeakBw'));
                }
                else if (!isOutShapingPolicyValid) {
                    messages.push(this.i18nService.getString('NetworkUi', 'dvpg.policy.shaping.egress.avgBwGreaterThanPeakBw'));
                }
            }
            return messages;
        };
        DvpgTrafficShapingPolicyService.prototype.isTrafficShapingPolicyValid = function (policy) {
            if (!policy.enabled) {
                return true;
            }
            return policy.averageBandwidth <= policy.peakBandwidth;
        };
        DvpgTrafficShapingPolicyService.$inject = [
            "trafficShapingPolicyValidator",
            "networkUiConstants",
            "i18nService"];
        return DvpgTrafficShapingPolicyService;
    }());
    dvs_ui.DvpgTrafficShapingPolicyService = DvpgTrafficShapingPolicyService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgTrafficShapingPolicyService", DvpgTrafficShapingPolicyService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvpgCreateWizardConstants", {
        properties: {
            DVPG_NEW_UNIQUE_NAME: "newUniquePortGroupName",
            PRIMARY_ICON_ID: "primaryIconId",
            NAME_PROPERTY: "name",
            DVPG_PROPERTIES: "createdvpg:settingsdata"
        },
        portBinding: {
            EARLY_BINDING: "earlyBinding",
            EPHEMERAL: "ephemeral"
        },
        portAllocation: {
            DEFAULT_AUTO_EXPAND: true
        },
        numPorts: {
            MIN: 0,
            MAX: 8192,
            DEFAULT_NUMBER_OF_PORTS_FIXED: 128,
            DEFAULT_NUMBER_OF_PORTS_ELASTIC: 8
        },
        objectType: {
            DISTRIBUTED_SWITCH: "DistributedSwitch",
            ROOT_FOLDER: "RootFolder",
            DATACENTER: "Datacenter",
        },
        DVPG_DEFAULT_NETWORK_RESOURCE_POOL_KEY: "-1",
        MAX_ALLOWED_DVPG_NAME_LENGTH: 80,
        DC_DVS_NODE_TYPE_ID: "DcDvs",
        NETWORK_FOLDER_DVS_NODE_TYPE_ID: "NetworkFolderDvs"
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateWizardFlowManager = (function () {
        function DvpgCreateWizardFlowManager(pageStateManagementService) {
            this.pageStateManagementService = pageStateManagementService;
        }
        DvpgCreateWizardFlowManager.prototype.init = function (wizardScope) {
            var _this = this;
            this.pageStateManagementService.registerWizardForDefaultStateManagementStrategy(wizardScope);
            this.pages = wizardScope.wizardConfig.pages;
            wizardScope.$watchGroup([
                "model.isPolicyConfigurationEnabled",
                "model.monitoringPolicyModel.ipfixSupported"], function (newValues) { return _this.updatePagesVisibility.apply(_this, newValues); });
        };
        ;
        DvpgCreateWizardFlowManager.prototype.updatePagesVisibility = function (isPolicyConfigurationEnabled, ipfixSupported) {
            this.togglePageVisibility(dvs_ui.DvpgCreateWizardPages.PAGES.SECURITY_POLICY, isPolicyConfigurationEnabled);
            this.togglePageVisibility(dvs_ui.DvpgCreateWizardPages.PAGES.TRAFFIC_SHAPING, isPolicyConfigurationEnabled);
            this.togglePageVisibility(dvs_ui.DvpgCreateWizardPages.PAGES.FAILOVER_POLICY, isPolicyConfigurationEnabled);
            this.togglePageVisibility(dvs_ui.DvpgCreateWizardPages.PAGES.MONITORING, isPolicyConfigurationEnabled && ipfixSupported);
            this.togglePageVisibility(dvs_ui.DvpgCreateWizardPages.PAGES.MISC, isPolicyConfigurationEnabled);
        };
        DvpgCreateWizardFlowManager.prototype.togglePageVisibility = function (pageId, isVisible) {
            var page = _.findWhere(this.pages, { id: pageId });
            this.pageStateManagementService.togglePageVisibility(page, isVisible);
        };
        DvpgCreateWizardFlowManager.$inject = ["pageStateManagementService"];
        return DvpgCreateWizardFlowManager;
    }());
    dvs_ui.DvpgCreateWizardFlowManager = DvpgCreateWizardFlowManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCreateWizardFlowManager", DvpgCreateWizardFlowManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateWizardPages = (function () {
        function DvpgCreateWizardPages(i18nService, simpleValidationCommit, nameAndLocationPageValidator, generalPropertiesPageValidator, dvpgTrafficShapingPolicyService, dvpgFailoverPolicyPageValidator) {
            this.i18nService = i18nService;
            this.simpleValidationCommit = simpleValidationCommit;
            this.nameAndLocationPageValidator = nameAndLocationPageValidator;
            this.generalPropertiesPageValidator = generalPropertiesPageValidator;
            this.dvpgTrafficShapingPolicyService = dvpgTrafficShapingPolicyService;
            this.dvpgFailoverPolicyPageValidator = dvpgFailoverPolicyPageValidator;
        }
        DvpgCreateWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var nameAndLocationPage = {
                id: DvpgCreateWizardPages.PAGES.NAME_AND_LOCATION,
                title: this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/create/views/dvpgNameAndLocationPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.nameAndLocationPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var generalPropertiesPage = {
                id: DvpgCreateWizardPages.PAGES.GENERAL_PROPERTIES,
                title: this.i18nService.getString("DvsUi", "dvpg.create.properties.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.create.properties.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/create/views/" +
                    "dvpgGeneralPropertiesPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.generalPropertiesPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var securityPolicyPage = {
                id: DvpgCreateWizardPages.PAGES.SECURITY_POLICY,
                title: this.i18nService.getString("DvsUi", "dvpg.policy.security.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.policy.security.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgSecurityPolicyPage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: [
                    "model.securityPolicyModel.allowPromiscuous",
                    "model.securityPolicyModel.forgedTransmits",
                    "model.securityPolicyModel.macChanges"]
            };
            var trafficShapingPage = {
                id: DvpgCreateWizardPages.PAGES.TRAFFIC_SHAPING,
                title: this.i18nService.getString("DvsUi", "dvpg.policy.shaping.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.policy.shaping.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgTrafficShapingPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvpgTrafficShapingPolicyService.getErrorMessages(wizardScope.model.trafficShapingPolicyModel.inShapingPolicy, wizardScope.model.trafficShapingPolicyModel.outShapingPolicy);
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.trafficShapingPolicyModel.inShapingPolicy.enabled",
                    "model.trafficShapingPolicyModel.inShapingPolicy.averageBandwidth",
                    "model.trafficShapingPolicyModel.inShapingPolicy.peakBandwidth",
                    "model.trafficShapingPolicyModel.inShapingPolicy.burstSize",
                    "model.trafficShapingPolicyModel.outShapingPolicy.enabled",
                    "model.trafficShapingPolicyModel.outShapingPolicy.averageBandwidth",
                    "model.trafficShapingPolicyModel.outShapingPolicy.peakBandwidth",
                    "model.trafficShapingPolicyModel.outShapingPolicy.burstSize"]
            };
            var failoverPage = {
                id: DvpgCreateWizardPages.PAGES.FAILOVER_POLICY,
                title: this.i18nService.getString("DvsUi", "dvpg.policy.failover.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.policy.failover.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgFailoverPolicyPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvpgFailoverPolicyPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.failoverPolicyModel.loadBalancing",
                    "model.failoverPolicyModel.beaconProbing",
                    "model.failoverPolicyModel.notifySwitches",
                    "model.failoverPolicyModel.rollingOrder",
                    "model.failoverPolicyModel.failoverOrder.activeUplinkPortNames",
                    "model.failoverPolicyModel.failoverOrder.standbyUplinkPortNames",
                    "model.failoverPolicyModel.failoverOrder.unusedUplinkPortNames"]
            };
            var monitoringPage = {
                id: DvpgCreateWizardPages.PAGES.MONITORING,
                title: this.i18nService.getString("DvsUi", "dvpg.policy.monitoring.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.policy.monitoring.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgMonitoringPage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: ["model.monitoringPolicyModel.ipfixEnabled"]
            };
            var miscPage = {
                id: DvpgCreateWizardPages.PAGES.MISC,
                title: this.i18nService.getString("DvsUi", "dvpg.policy.misc.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.policy.misc.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgMiscPage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: ["model.miscPolicyModel.arePortsBlocked"]
            };
            var readyToCompletePage = {
                id: DvpgCreateWizardPages.PAGES.READY_TO_COMPLETE,
                title: this.i18nService.getString("DvsUi", "dvpg.create.finish.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.create.finish.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/create/views/" +
                    "dvpgCreateReadyToCompletePage.html",
                onCommit: function () {
                    return true;
                },
                validationParams: []
            };
            return [nameAndLocationPage,
                generalPropertiesPage,
                securityPolicyPage,
                trafficShapingPage,
                failoverPage,
                monitoringPage,
                miscPage,
                readyToCompletePage];
        };
        DvpgCreateWizardPages.$inject = [
            "i18nService",
            "simpleValidationCommit",
            "dvpgNameAndLocationPageValidator",
            "dvpgGeneralPropertiesPageValidator",
            "dvpgTrafficShapingPolicyService",
            "dvpgFailoverPolicyPageValidator"
        ];
        DvpgCreateWizardPages.PAGES = (function () {
            function class_1() {
            }
            class_1.NAME_AND_LOCATION = "nameAndLocationPage";
            class_1.GENERAL_PROPERTIES = "generalPropertiesPage";
            class_1.SECURITY_POLICY = "securityPolicyPage";
            class_1.TRAFFIC_SHAPING = "trafficShapingPage";
            class_1.FAILOVER_POLICY = "teamingAndFailoverPage";
            class_1.MONITORING = "monitoringPage";
            class_1.MISC = "miscPage";
            class_1.READY_TO_COMPLETE = "readyToCompletePage";
            return class_1;
        }());
        return DvpgCreateWizardPages;
    }());
    dvs_ui.DvpgCreateWizardPages = DvpgCreateWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCreateWizardPages", DvpgCreateWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateWizardService = (function () {
        function DvpgCreateWizardService($rootScope, i18nService, vuiWizardService, mutationService, specFactory, wizardConstants, dvpgCreateWizardFlowManager, wizardPages) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.mutationService = mutationService;
            this.specFactory = specFactory;
            this.wizardConstants = wizardConstants;
            this.dvpgCreateWizardFlowManager = dvpgCreateWizardFlowManager;
            this.wizardPages = wizardPages;
        }
        /**
         * Shows the New Distributed Port Group wizard.
         */
        DvpgCreateWizardService.prototype.show = function (objectId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = this.initWizardDataModel(objectId);
            wizardScope.flags = this.initWizardFlags();
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("DvsUi", "dvpg.create.title"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                onFinish: function () {
                    var spec = _this.specFactory.buildDvpgCreateSpec(wizardScope.model);
                    _this.mutationService.add(spec._type, spec);
                    return true;
                }
            };
            wizardScope.wizardConfig.pages = this.wizardPages.createPages(wizardScope);
            this.dvpgCreateWizardFlowManager.init(wizardScope);
            wizardScope.wizardConfig.cssClass = "dvpg-create-wizard";
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        DvpgCreateWizardService.prototype.initWizardDataModel = function (contextObjId) {
            var model = new dvs_ui.DvpgCreateWizardModel();
            model.dvsId = contextObjId;
            model.contextObjId = contextObjId;
            model.name = this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.defaultName");
            model.isPolicyConfigurationEnabled = false;
            return model;
        };
        DvpgCreateWizardService.prototype.initWizardFlags = function () {
            var flags = new dvs_ui.DvpgCreateWizardFlags();
            flags.isNameAndLocationPageInitialized = false;
            flags.isGeneralPropertiesPageInitialized = false;
            return flags;
        };
        DvpgCreateWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "mutationService",
            "dvpgCreateWizardSpecFactory",
            "dvpgCreateWizardConstants",
            "dvpgCreateWizardFlowManager",
            "dvpgCreateWizardPages"
        ];
        return DvpgCreateWizardService;
    }());
    dvs_ui.DvpgCreateWizardService = DvpgCreateWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCreateWizardService", DvpgCreateWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmwareDistributedVirtualSwitch$VlanIdSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VlanIdSpec;
    var VmwareDistributedVirtualSwitch$TrunkVlanSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$TrunkVlanSpec;
    var VmwareDistributedVirtualSwitch$PvlanSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$PvlanSpec;
    var VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy;
    var DvPortgroupCreateSpec = com.vmware.vsphere.client.dvportgroup.DvPortgroupCreateSpec;
    var StringPolicy = com.vmware.vim.binding.vim.StringPolicy;
    /**
     * Provides methods from creating the mutation spec sent to the backend
     * after the completion of the New Distributed Port Group wizard.
     */
    var DvpgCreateWizardSpecFactory = (function () {
        function DvpgCreateWizardSpecFactory(defaultUriSchemeUtil, wizardConstants, networkUiConstants, dvpgSpecFactory) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardConstants = wizardConstants;
            this.networkUiConstants = networkUiConstants;
            this.dvpgSpecFactory = dvpgSpecFactory;
        }
        /**
         * Builds the spec the create distributed port group mutation operation.
         */
        DvpgCreateWizardSpecFactory.prototype.buildDvpgCreateSpec = function (model) {
            var defaultPortConfig = new VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy();
            defaultPortConfig.vlan = this.createVlanSpec(model);
            if (model.isPolicyConfigurationEnabled) {
                defaultPortConfig.inShapingPolicy = this.dvpgSpecFactory
                    .buildTrafficShapingSpec(model.trafficShapingPolicyModel.inShapingPolicy);
                defaultPortConfig.outShapingPolicy = this.dvpgSpecFactory
                    .buildTrafficShapingSpec(model.trafficShapingPolicyModel.outShapingPolicy);
                defaultPortConfig.securityPolicy = this.dvpgSpecFactory
                    .buildSecurityPolicySpec(model.securityPolicyModel);
                defaultPortConfig.uplinkTeamingPolicy = this.dvpgSpecFactory
                    .buildTeamingAndFailoverSpec(model.failoverPolicyModel);
                defaultPortConfig.ipfixEnabled = this.dvpgSpecFactory
                    .buildMonitoringSpec(model.monitoringPolicyModel);
                defaultPortConfig.blocked = this.dvpgSpecFactory
                    .buildMiscSpec(model.miscPolicyModel);
            }
            var configSpec = new com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroup$ConfigSpec();
            configSpec.defaultPortConfig = defaultPortConfig;
            if (model.portBinding === this.wizardConstants.portBinding.EARLY_BINDING) {
                configSpec.autoExpand = model.autoExpand;
            }
            if (model.isVmVnicResourcePoolSupported) {
                configSpec.vmVnicNetworkResourcePoolKey = model.networkResourcePoolKey;
            }
            else if (model.isNetworkResourcePoolSupported) {
                configSpec.defaultPortConfig.networkResourcePoolKey = new StringPolicy();
                configSpec.defaultPortConfig.networkResourcePoolKey.value = model.networkResourcePoolKey;
                configSpec.defaultPortConfig.networkResourcePoolKey.inherited = false;
            }
            configSpec.name = model.name;
            configSpec.type = model.portBinding;
            configSpec.numPorts = model.numPorts;
            var spec = new DvPortgroupCreateSpec();
            spec.switchRef = this.defaultUriSchemeUtil.getManagedObjectReference(model.dvsId);
            spec.configSpec = configSpec;
            return spec;
        };
        DvpgCreateWizardSpecFactory.prototype.createVlanSpec = function (model) {
            var vlanSpec;
            if (model.vlanType === this.networkUiConstants.Vlan.Type.NONE) {
                vlanSpec = new VmwareDistributedVirtualSwitch$VlanIdSpec();
                vlanSpec.vlanId = this.networkUiConstants.Vlan.Id.NONE;
            }
            else if (model.vlanType === this.networkUiConstants.Vlan.Type.VLAN) {
                vlanSpec = new VmwareDistributedVirtualSwitch$VlanIdSpec();
                vlanSpec.vlanId = model.vlanId;
            }
            else if (model.vlanType === this.networkUiConstants.Vlan.Type.TRUNK) {
                vlanSpec = new VmwareDistributedVirtualSwitch$TrunkVlanSpec();
                vlanSpec.vlanId = model.vlanTrunkNumericRanges;
            }
            else if (model.vlanType === this.networkUiConstants.Vlan.Type.PRIVATE) {
                vlanSpec = new VmwareDistributedVirtualSwitch$PvlanSpec();
                vlanSpec.pvlanId = model.pvlanId;
            }
            return vlanSpec;
        };
        DvpgCreateWizardSpecFactory.$inject = [
            "defaultUriSchemeUtil",
            "dvpgCreateWizardConstants",
            "networkUiConstants",
            "dvpgSpecFactory"
        ];
        return DvpgCreateWizardSpecFactory;
    }());
    dvs_ui.DvpgCreateWizardSpecFactory = DvpgCreateWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCreateWizardSpecFactory", DvpgCreateWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateWizardFlags = (function () {
        function DvpgCreateWizardFlags() {
        }
        return DvpgCreateWizardFlags;
    }());
    dvs_ui.DvpgCreateWizardFlags = DvpgCreateWizardFlags;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateWizardModel = (function () {
        function DvpgCreateWizardModel() {
        }
        return DvpgCreateWizardModel;
    }());
    dvs_ui.DvpgCreateWizardModel = DvpgCreateWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateReadyToCompletePageService = (function () {
        function DvpgCreateReadyToCompletePageService(i18nService, networkUiConstants, wizardConstants) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.wizardConstants = wizardConstants;
        }
        DvpgCreateReadyToCompletePageService.prototype.getNetworkResourcePoolLabel = function (resourcePoolKey, resourcePools) {
            var networkResourcePoolLabel = this.i18nService.getString("DvsUi", "dvpg.create.finish.resourcePool.default");
            if (resourcePoolKey ===
                this.wizardConstants.DVPG_DEFAULT_NETWORK_RESOURCE_POOL_KEY ||
                !resourcePools ||
                resourcePools.length === 0) {
                return networkResourcePoolLabel;
            }
            _.each(resourcePools, function (resourcePool) {
                if (resourcePool.key === resourcePoolKey) {
                    networkResourcePoolLabel = resourcePool.name;
                }
            });
            return networkResourcePoolLabel;
        };
        DvpgCreateReadyToCompletePageService.prototype.getPortAllocationLabel = function (autoExpand) {
            return autoExpand
                ? this.i18nService.getString("DvsUi", "dvpg.create.properties.portAllocation.autoExpand.true")
                : this.i18nService.getString("DvsUi", "dvpg.create.properties.portAllocation.autoExpand.false");
        };
        DvpgCreateReadyToCompletePageService.prototype.getPortBindingLabel = function (portBinding) {
            var portBindingLabel = this.i18nService.getString("DvsUi", "dvpg.create.finish.property.na");
            if (!portBinding) {
                return portBindingLabel;
            }
            switch (portBinding) {
                case this.wizardConstants.portBinding.EARLY_BINDING: {
                    portBindingLabel = this.i18nService.getString("DvsUi", "dvpg.create.properties.portBinding.earlyBinding");
                    break;
                }
                case this.wizardConstants.portBinding.EPHEMERAL: {
                    portBindingLabel = this.i18nService.getString("DvsUi", "dvpg.create.properties.portBinding.ephemeral");
                    break;
                }
            }
            return portBindingLabel;
        };
        DvpgCreateReadyToCompletePageService.prototype.getVlanPropertyName = function (vlanType) {
            var vlanPropertyName = this.i18nService.getString("DvsUi", "dvpg.create.finish.vlan");
            if (!vlanType) {
                return vlanPropertyName;
            }
            switch (vlanType) {
                case this.networkUiConstants.Vlan.Type.NONE:
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    vlanPropertyName = this.i18nService.getString("DvsUi", "dvpg.create.finish.vlan.id");
                    break;
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    vlanPropertyName = this.i18nService.getString("DvsUi", "dvpg.create.finish.vlan.private");
                    break;
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    vlanPropertyName = this.i18nService.getString("DvsUi", "dvpg.create.finish.vlan.trunk");
                    break;
                }
            }
            return vlanPropertyName;
        };
        DvpgCreateReadyToCompletePageService.prototype.getVlanPropertyValue = function (model) {
            var vlanPropertyValue = this.i18nService.getString("DvsUi", "dvpg.create.finish.property.na");
            if (!model) {
                return vlanPropertyValue;
            }
            switch (model.vlanType) {
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    return model.vlanId.toString();
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    return this.getPvlanLabel(model.pvlanId, model.pvlanConfig);
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    return model.vlanTrunkRanges.replace(/ +/g, '').replace(/,/g, ', ');
                }
            }
            return vlanPropertyValue;
        };
        DvpgCreateReadyToCompletePageService.prototype.getPvlanTypeLabel = function (pvlanType) {
            switch (pvlanType) {
                case this.networkUiConstants.Vlan.PvlanType.ISOLATED: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.isolated");
                }
                case this.networkUiConstants.Vlan.PvlanType.PROMISCUOUS: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.promiscuous");
                }
                case this.networkUiConstants.Vlan.PvlanType.COMMUNITY: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.community");
                }
                default:
                    return "";
            }
        };
        DvpgCreateReadyToCompletePageService.prototype.getPvlanLabel = function (secondaryVlanId, pvlanConfigs) {
            var _this = this;
            var pvlanLabel = this.i18nService.getString("DvsUi", "dvpg.create.finish.property.na");
            if (!pvlanConfigs) {
                return pvlanLabel;
            }
            _.each(pvlanConfigs, function (pvlanConfig) {
                if (pvlanConfig.secondaryVlanId === secondaryVlanId) {
                    var pvlanTypeLabel = _this.getPvlanTypeLabel(pvlanConfig.pvlanType);
                    pvlanLabel = _this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.displayFormat", pvlanTypeLabel, pvlanConfig.primaryVlanId, pvlanConfig.secondaryVlanId);
                }
            });
            return pvlanLabel;
        };
        DvpgCreateReadyToCompletePageService.$inject = [
            "i18nService",
            "networkUiConstants",
            "dvpgCreateWizardConstants"
        ];
        return DvpgCreateReadyToCompletePageService;
    }());
    dvs_ui.DvpgCreateReadyToCompletePageService = DvpgCreateReadyToCompletePageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCreateReadyToCompletePageService", DvpgCreateReadyToCompletePageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgGeneralPropertiesPageService = (function () {
        function DvpgGeneralPropertiesPageService(i18nService, networkUiConstants) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
        }
        DvpgGeneralPropertiesPageService.prototype.getNetworkResourcePoolsOptions = function (networkResourcePools) {
            var networkResourcePoolOptions = [];
            if (networkResourcePools && networkResourcePools.length > 0) {
                _.each(networkResourcePools, function (resourcePool) {
                    networkResourcePoolOptions.push({
                        label: resourcePool.name,
                        val: resourcePool.key
                    });
                });
            }
            return networkResourcePoolOptions;
        };
        DvpgGeneralPropertiesPageService.prototype.getPvlanOptions = function (pvlanConfig) {
            var _this = this;
            var pvlanTypeOptions = [];
            if (!pvlanConfig) {
                return pvlanTypeOptions;
            }
            _.each(pvlanConfig, function (pvlanData) {
                var pvlanTypeLabel = _this.getPvlanTypeLabel(pvlanData.pvlanType);
                pvlanTypeOptions.push({
                    label: _this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.displayFormat", pvlanTypeLabel, pvlanData.primaryVlanId, pvlanData.secondaryVlanId),
                    val: pvlanData.secondaryVlanId
                });
            });
            return pvlanTypeOptions;
        };
        DvpgGeneralPropertiesPageService.prototype.getPvlanTypeLabel = function (pvlanType) {
            switch (pvlanType) {
                case this.networkUiConstants.Vlan.PvlanType.ISOLATED: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.isolated");
                }
                case this.networkUiConstants.Vlan.PvlanType.PROMISCUOUS: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.promiscuous");
                }
                case this.networkUiConstants.Vlan.PvlanType.COMMUNITY: {
                    return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.community");
                }
                default:
                    return "";
            }
        };
        DvpgGeneralPropertiesPageService.$inject = [
            "i18nService",
            "networkUiConstants"
        ];
        return DvpgGeneralPropertiesPageService;
    }());
    dvs_ui.DvpgGeneralPropertiesPageService = DvpgGeneralPropertiesPageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgGeneralPropertiesPageService", DvpgGeneralPropertiesPageService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgGeneralPropertiesPageValidator = (function () {
        function DvpgGeneralPropertiesPageValidator(i18nService, mutationService, networkUiConstants, dvpgPropertiesService, wizardConstants, $q) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.networkUiConstants = networkUiConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            this.wizardConstants = wizardConstants;
            this.$q = $q;
        }
        DvpgGeneralPropertiesPageValidator.prototype.getValidationError = function (wizardScope) {
            var errors = [];
            if (wizardScope.model.portBinding ===
                this.wizardConstants.portBinding.EARLY_BINDING) {
                var numPortsError = this.dvpgPropertiesService.getNumPortsError(wizardScope.model.numPorts);
                if (numPortsError) {
                    errors.push(numPortsError);
                }
            }
            switch (wizardScope.model.vlanType) {
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    var vlanIdError = this.dvpgPropertiesService.getVlanIdError(wizardScope.model.vlanId);
                    if (vlanIdError) {
                        errors.push(vlanIdError);
                    }
                    break;
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    return this.getTrunkVlanRanges(wizardScope);
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    var error = this.getPvlanError(wizardScope);
                    if (error) {
                        errors.push(error);
                    }
                    break;
                }
            }
            return this.$q.resolve(errors);
        };
        DvpgGeneralPropertiesPageValidator.prototype.getPvlanError = function (wizardScope) {
            if (wizardScope.model.showPvlanError) {
                return this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private.noConfig");
            }
        };
        DvpgGeneralPropertiesPageValidator.prototype.getTrunkVlanRanges = function (wizardScope) {
            var _this = this;
            var errors = [];
            var trunkVlanRangesString = wizardScope.model.vlanTrunkRanges;
            wizardScope.wizardConfig.loading = true;
            return this.mutationService.validate(wizardScope.model.dvsId, "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupTrunkVlanSpec", {
                _type: "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupTrunkVlanSpec",
                numericRanges: trunkVlanRangesString.trim()
            })
                .then(function (validationResult) {
                if (validationResult && validationResult.result) {
                    wizardScope.model.vlanTrunkNumericRanges = validationResult.result;
                }
                else {
                    errors.push(_this.i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.trunk.error"));
                }
                wizardScope.wizardConfig.loading = false;
                return errors;
            }, function () {
                wizardScope.wizardConfig.loading = false;
                return errors;
            });
        };
        DvpgGeneralPropertiesPageValidator.$inject = [
            "i18nService",
            "mutationService",
            "networkUiConstants",
            "dvpgPropertiesService",
            "dvpgCreateWizardConstants",
            "$q"];
        return DvpgGeneralPropertiesPageValidator;
    }());
    dvs_ui.DvpgGeneralPropertiesPageValidator = DvpgGeneralPropertiesPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgGeneralPropertiesPageValidator", DvpgGeneralPropertiesPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgNameAndLocationPageValidator = (function () {
        function DvpgNameAndLocationPageValidator(i18nService, mutationService, $q, wizardConstants) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.$q = $q;
            this.wizardConstants = wizardConstants;
        }
        DvpgNameAndLocationPageValidator.prototype.getValidationError = function (wizardScope) {
            // client side validation
            var nameError = this.getInvalidNameError(wizardScope.model.name);
            if (nameError) {
                return this.$q.resolve([nameError]);
            }
            var dvsErrors = this.getDvsErrors(wizardScope);
            if (dvsErrors.length > 0) {
                return this.$q.resolve(dvsErrors);
            }
            // server side validation
            return this.getNameValidationError(wizardScope);
        };
        DvpgNameAndLocationPageValidator.prototype.getInvalidNameError = function (name) {
            var dvpgName = name
                ? name.trim()
                : name;
            var escapedDvpgName = dvpgName.replace(/%/g, "%25")
                .replace(/\//g, "%2f").replace(/\\/g, "%5c");
            if (!escapedDvpgName || escapedDvpgName.length === 0) {
                return this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.nameRequired");
            }
            if (escapedDvpgName.length >
                this.wizardConstants.MAX_ALLOWED_DVPG_NAME_LENGTH) {
                return this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.tooLong");
            }
            return null;
        };
        DvpgNameAndLocationPageValidator.prototype.getDvsErrors = function (wizardScope) {
            if (wizardScope.model.dvsId === null) {
                return [this.i18nService.getString("DvsUi", "dvpg.create.nameAndLocation.noSelectionError")];
            }
            return [];
        };
        DvpgNameAndLocationPageValidator.prototype.getNameValidationError = function (wizardScope) {
            wizardScope.wizardConfig.loading = true;
            return this.mutationService.validate(wizardScope.model.dvsId, "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupNameSpec", { _type: "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupNameSpec",
                name: wizardScope.model.name.trim()
            }).then(function (validationResult) {
                var errors = [];
                if (validationResult.error && validationResult.error.localizedMessage) {
                    errors.push(validationResult.error.localizedMessage);
                }
                else if (validationResult.result) {
                    errors.push(validationResult.result);
                }
                wizardScope.wizardConfig.loading = false;
                return errors;
            }, function () {
                wizardScope.wizardConfig.loading = false;
                return [];
            });
        };
        DvpgNameAndLocationPageValidator.$inject = [
            "i18nService",
            "mutationService",
            "$q",
            "dvpgCreateWizardConstants"
        ];
        return DvpgNameAndLocationPageValidator;
    }());
    dvs_ui.DvpgNameAndLocationPageValidator = DvpgNameAndLocationPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgNameAndLocationPageValidator", DvpgNameAndLocationPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCreateReadyToCompletePageController = (function () {
        function DvpgCreateReadyToCompletePageController($wizardScope, i18nService, vxPropertyViewService, networkUiConstants, wizardConstants, pageService) {
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.networkUiConstants = networkUiConstants;
            this.wizardConstants = wizardConstants;
            this.pageService = pageService;
            var builder = vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            // Distributed Portgroup Name
            generalSection.property(this.i18nService.getString("DvsUi", "dvpg.create.finish.name"), this.$wizardScope.model.name);
            // Port Binding
            generalSection.property(this.i18nService.getString("DvsUi", "dvpg.create.finish.portBinding"), this.pageService.getPortBindingLabel(this.$wizardScope.model.portBinding));
            if (this.$wizardScope.model.portBinding ===
                this.wizardConstants.portBinding.EARLY_BINDING) {
                // Number of Ports
                generalSection.property(this.i18nService.getString("DvsUi", "dvpg.create.finish.numberOfPorts"), this.$wizardScope.model.numPorts);
                // Port Allocation
                generalSection.property(this.i18nService.getString("DvsUi", "dvpg.create.finish.portAllocation"), this.pageService.getPortAllocationLabel(this.$wizardScope.model.autoExpand));
            }
            // Network Resource Pool
            generalSection.property(this.i18nService.getString("DvsUi", "dvpg.create.finish.resourcePool"), this.pageService.getNetworkResourcePoolLabel(this.$wizardScope.model.networkResourcePoolKey, this.$wizardScope.model.networkResourcePools));
            // VLAN
            generalSection.property(this.pageService.getVlanPropertyName(this.$wizardScope.model.vlanType), this.pageService.getVlanPropertyValue(this.$wizardScope.model));
            this.$wizardScope.model.summaryData = builder.build();
        }
        DvpgCreateReadyToCompletePageController.$inject = [
            "$scope",
            "i18nService",
            "vxPropertyViewService",
            "networkUiConstants",
            "dvpgCreateWizardConstants",
            "dvpgCreateReadyToCompletePageService"
        ];
        return DvpgCreateReadyToCompletePageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvpgCreateReadyToCompletePageController", DvpgCreateReadyToCompletePageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgGeneralPropertiesPageController = (function () {
        function DvpgGeneralPropertiesPageController($wizardScope, i18nService, wizardConstants, networkUtil, dataService, networkUiConstants, dvpgPropertiesService, dvpgGeneralPropertiesPageService, dvpgFailoverPolicyPageService) {
            var _this = this;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.networkUtil = networkUtil;
            this.dataService = dataService;
            this.networkUiConstants = networkUiConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            this.dvpgGeneralPropertiesPageService = dvpgGeneralPropertiesPageService;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
            this.numPortsValidator = {};
            this.vlanIdValidator = {};
            if (!this.$wizardScope.flags.isGeneralPropertiesPageInitialized) {
                this.initModel();
                this.requestProperties();
            }
            else {
                this.networkResourcePoolOptions =
                    this.dvpgGeneralPropertiesPageService.getNetworkResourcePoolsOptions(this.$wizardScope.model.networkResourcePools);
                this.pvlanTypeOptions =
                    this.dvpgGeneralPropertiesPageService.getPvlanOptions(this.$wizardScope.model.pvlanConfig);
            }
            this.portBindingOptions = [{
                    label: this.i18nService.getString("DvsUi", "dvpg.create.properties.portBinding.earlyBinding"),
                    val: this.wizardConstants.portBinding.EARLY_BINDING
                }, {
                    label: this.i18nService.getString("DvsUi", "dvpg.create.properties.portBinding.ephemeral"),
                    val: this.wizardConstants.portBinding.EPHEMERAL
                }];
            this.portAllocationOptions = [{
                    label: this.i18nService.getString("DvsUi", "dvpg.create.properties.portAllocation.autoExpand.true"),
                    val: true
                }, {
                    label: this.i18nService.getString("DvsUi", "dvpg.create.properties.portAllocation.autoExpand.false"),
                    val: false
                }];
            this.vlanTypeOptions = [{
                    label: i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.none"),
                    val: this.networkUiConstants.Vlan.Type.NONE
                }, {
                    label: i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.vlan"),
                    val: this.networkUiConstants.Vlan.Type.VLAN
                }, {
                    label: i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.trunk"),
                    val: this.networkUiConstants.Vlan.Type.TRUNK
                }, {
                    label: i18nService.getString("DvsUi", "dvpg.create.properties.vlan.type.private"),
                    val: this.networkUiConstants.Vlan.Type.PRIVATE
                }];
            this.setNumPortsValidator();
            this.setVlanIdValidator();
            this.onVlanIdChange = function () {
                this.setVlanIdValidator();
            };
            this.onNumPortsChange = function () {
                this.setNumPortsValidator();
            };
            this.$wizardScope.$watch(function () {
                return _this.$wizardScope.model.numPorts;
            }, function () {
                if (!_this.$wizardScope.model.defaultNumPortsChanged) {
                    var defaultNumPorts = _this.$wizardScope.model.autoExpand ?
                        _this.wizardConstants.numPorts.DEFAULT_NUMBER_OF_PORTS_ELASTIC :
                        _this.wizardConstants.numPorts.DEFAULT_NUMBER_OF_PORTS_FIXED;
                    _this.$wizardScope.model.defaultNumPortsChanged =
                        _this.$wizardScope.model.numPorts !== defaultNumPorts;
                }
            });
            this.$wizardScope.$watch(function () {
                return _this.$wizardScope.model.autoExpand;
            }, function () {
                if (!_this.$wizardScope.model.defaultNumPortsChanged) {
                    if (_this.$wizardScope.model.autoExpand) {
                        _this.$wizardScope.model.numPorts =
                            _this.wizardConstants.numPorts.DEFAULT_NUMBER_OF_PORTS_ELASTIC;
                    }
                    else {
                        _this.$wizardScope.model.numPorts =
                            _this.wizardConstants.numPorts.DEFAULT_NUMBER_OF_PORTS_FIXED;
                    }
                }
            });
            this.$wizardScope.$watch(function () {
                return _this.$wizardScope.model.vlanType;
            }, function (newType, oldType) {
                if (oldType !== newType) {
                    _this.clearVlanSettings();
                    if (newType === _this.networkUiConstants.Vlan.Type.VLAN) {
                        _this.$wizardScope.model.vlanId = _this.networkUiConstants.Vlan.Id.MIN;
                        _this.setVlanIdValidator();
                    }
                    else if (newType === _this.networkUiConstants.Vlan.Type.PRIVATE) {
                        if (_this.$wizardScope.model.pvlanConfig &&
                            _this.$wizardScope.model.pvlanConfig.length > 0) {
                            _this.$wizardScope.model.pvlanId =
                                _this.$wizardScope.model.pvlanConfig[0].secondaryVlanId;
                        }
                    }
                }
            });
        }
        DvpgGeneralPropertiesPageController.prototype.initModel = function () {
            this.$wizardScope.model.portBinding =
                this.wizardConstants.portBinding.EARLY_BINDING;
            this.$wizardScope.model.autoExpand =
                this.wizardConstants.portAllocation.DEFAULT_AUTO_EXPAND;
            this.$wizardScope.model.numPorts =
                this.wizardConstants.numPorts.DEFAULT_NUMBER_OF_PORTS_ELASTIC;
            this.$wizardScope.model.defaultNumPortsChanged = false;
            this.$wizardScope.model.vlanType = this.networkUiConstants.Vlan.Type.NONE;
            this.$wizardScope.model.vlanId = 0;
            this.$wizardScope.model.pvlanId = 0;
        };
        DvpgGeneralPropertiesPageController.prototype.clearVlanSettings = function () {
            this.$wizardScope.model.vlanTrunkRanges =
                this.networkUiConstants.Vlan.DEFAULT_VLAN_TRUNK_RANGE;
            this.$wizardScope.model.vlanTrunkNumericRanges = null;
            this.$wizardScope.model.vlanId = 0;
        };
        DvpgGeneralPropertiesPageController.prototype.setVlanIdValidator = function () {
            var message = this.dvpgPropertiesService.getVlanIdError(this.$wizardScope.model.vlanId);
            this.vlanIdValidator.message = message;
            this.vlanIdValidator.isVisible = message !== null;
        };
        DvpgGeneralPropertiesPageController.prototype.setNumPortsValidator = function () {
            var message = this.dvpgPropertiesService.getNumPortsError(this.$wizardScope.model.numPorts);
            this.numPortsValidator.message = message;
            this.numPortsValidator.isVisible = message !== null;
        };
        DvpgGeneralPropertiesPageController.prototype.requestProperties = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(this.$wizardScope.model.dvsId, [this.wizardConstants.properties.DVPG_PROPERTIES,
                DvpgGeneralPropertiesPageController.POLICIES_PROPERTY])
                .then(function (response) {
                var dvpgProperties = response[_this.wizardConstants.properties.DVPG_PROPERTIES];
                _this.$wizardScope.model.isNetworkResourcePoolSupported =
                    dvpgProperties.isNetworkResourcePoolSupported;
                _this.$wizardScope.model.isVmVnicResourcePoolSupported =
                    dvpgProperties.isVmVnicResourcePoolSupported;
                _this.$wizardScope.model.networkResourcePools =
                    dvpgProperties.networkResourcePools;
                _this.$wizardScope.model.networkResourcePoolKey =
                    dvpgProperties.networkResourcePoolKey;
                _this.$wizardScope.model.pvlanConfig = dvpgProperties.pvlanConfig;
                _this.$wizardScope.model.showPvlanError = !dvpgProperties.pvlanConfig ||
                    dvpgProperties.pvlanConfig.length === 0;
                _this.networkResourcePoolOptions =
                    _this.dvpgGeneralPropertiesPageService.getNetworkResourcePoolsOptions(_this.$wizardScope.model.networkResourcePools);
                _this.pvlanTypeOptions =
                    _this.dvpgGeneralPropertiesPageService.getPvlanOptions(_this.$wizardScope.model.pvlanConfig);
                _this.initPoliciesConfiguration(response[DvpgGeneralPropertiesPageController.POLICIES_PROPERTY]);
                _this.$wizardScope.flags.isGeneralPropertiesPageInitialized = true;
                _this.$wizardScope.wizardConfig.loading = false;
            });
        };
        DvpgGeneralPropertiesPageController.prototype.initPoliciesConfiguration = function (policiesModel) {
            this.$wizardScope.model.securityPolicyModel = policiesModel.securityPolicyModel;
            this.$wizardScope.model.trafficShapingPolicyModel = policiesModel.trafficShapingPolicyModel;
            this.$wizardScope.model.monitoringPolicyModel = policiesModel.monitoringPolicyModel;
            this.$wizardScope.model.miscPolicyModel = policiesModel.miscPolicyModel;
            this.$wizardScope.model.failoverPolicyModel = policiesModel.failoverPolicyModel;
            this.$wizardScope.model.failoverOrderOptions =
                this.dvpgFailoverPolicyPageService.createFailoverOrderSettings(this.$wizardScope.model.failoverPolicyModel.failoverOrder);
        };
        DvpgGeneralPropertiesPageController.$inject = [
            "$scope",
            "i18nService",
            "dvpgCreateWizardConstants",
            "networkUtil",
            "dataService",
            "networkUiConstants",
            "dvpgPropertiesService",
            "dvpgGeneralPropertiesPageService",
            "dvpgFailoverPolicyPageService"];
        DvpgGeneralPropertiesPageController.POLICIES_PROPERTY = "createdvpg:policiesModel";
        return DvpgGeneralPropertiesPageController;
    }());
    dvs_ui.DvpgGeneralPropertiesPageController = DvpgGeneralPropertiesPageController;
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvpgGeneralPropertiesPageController", DvpgGeneralPropertiesPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgNameAndLocationPageController = (function () {
        function DvpgNameAndLocationPageController($wizardScope, validator, dataService, wizardConstants) {
            this.$wizardScope = $wizardScope;
            this.validator = validator;
            this.dataService = dataService;
            this.wizardConstants = wizardConstants;
            if (!this.$wizardScope.flags.isNameAndLocationPageInitialized) {
                this.requestProperties();
            }
            this.nameValidator = {
                message: null,
                isVisible: false
            };
            this.onNameChange = function () {
                var message = this.validator.getInvalidNameError($wizardScope.model.name);
                this.nameValidator.message = message;
                this.nameValidator.isVisible = message !== null;
            };
        }
        DvpgNameAndLocationPageController.prototype.requestProperties = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(this.$wizardScope.model.dvsId, [
                this.wizardConstants.properties.DVPG_NEW_UNIQUE_NAME,
                this.wizardConstants.properties.NAME_PROPERTY,
                this.wizardConstants.properties.PRIMARY_ICON_ID])
                .then(function (response) {
                _this.$wizardScope.model.name = response[_this.wizardConstants.properties.DVPG_NEW_UNIQUE_NAME];
                _this.$wizardScope.model.switchName = response[_this.wizardConstants.properties.NAME_PROPERTY];
                _this.$wizardScope.model.switchIconId = response[_this.wizardConstants.properties.PRIMARY_ICON_ID];
                _this.$wizardScope.wizardConfig.loading = false;
                _this.$wizardScope.flags.isNameAndLocationPageInitialized = true;
            });
        };
        DvpgNameAndLocationPageController.$inject = [
            "$scope",
            "dvpgNameAndLocationPageValidator",
            "dataService",
            "dvpgCreateWizardConstants"
        ];
        return DvpgNameAndLocationPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvpgNameAndLocationPageController", DvpgNameAndLocationPageController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * Factory that handles distributed port groups edit related operations.
    * Builds all the edit distributed port groups dialog page models and submits
    * the edited distributed port group data to the server.
    */
   angular
         .module('com.vmware.vsphere.client.dvs')
         .factory('EditDvPortgroupDialogManager', DvPortgroupDialogManager);

   DvPortgroupDialogManager.$inject = [
         'i18nService',
         'mutationService',
         'vuiConstants',
         'networkUiConstants',
         'dvpgSpecFactory'];

   function DvPortgroupDialogManager(
         i18nService,
         mutationService,
         vuiConstants,
         networkUiConstants,
         dvpgSpecFactory) {

      return function (dvPortgroupData, dialogOptions) {
         var EDIT_DV_PORT_GROUP_SPEC =
               'com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroup$ConfigSpec';

         var generalPageDef;
         var vlanPageDef;
         var securityPolicyPageDef;
         var failoverPolicyPageDef;
         var trafficShapingPageDef;
         var monitoringPolicyPageDef;
         var miscellaneousPolicyPageDef;
         var advancedPageDef;

         /**
          * Contains onCommit page callbacks.
          */
         var commitPageCallbacks = {
            commitGeneralPropertiesPage: function () { return true; },
            commitVlanPage: function () { return true; },
            commitSecurityPolicyPage: function() { return true; },
            commitFailoverPolicyPage: function() { return true; },
            commitTrafficShapingPage: function() { return true; },
            commitMonitoringPolicyPage: function() { return true; },
            commitMiscellaneousPolicyPage: function() { return true; },
            commitAdvancedPage: function() { return true; }
         };

         /**
          * Page dirty flags.
          */
         var pageDirtyFlags = {
            isGeneralPropertiesPageDirty: false,
            isVlanPageDirty: false,
            isFailoverPolicyPageDirty: false,
            isSecurityPolicyPageDirty: false,
            isTrafficShapingPageDirty: false,
            isMonitoringPolicyPageDirty: false,
            isMiscellaneousPolicyPageDirty: false,
            isAdvancedPageDirty: false
         };

         createPages();

         return {
            dvPortgroupData: dvPortgroupData,
            commitPageCallbacks: commitPageCallbacks,
            pageDirtyFlags: pageDirtyFlags,
            getPageDefinitions: getPageDefinitions,
            showDialogErrors: showDialogErrors,
            submit: submit
         };

         function createPages() {
            generalPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.properties.general'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupGeneralPropertiesPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitGeneralPropertiesPage);
                  }
               }
            };

            vlanPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.vlan.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupVlanPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitVlanPage);
                  }
               }
            };

            securityPolicyPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.security.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupSecurityPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitSecurityPolicyPage);
                  }
               }
            };

            failoverPolicyPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.failover.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupFailoverPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitFailoverPolicyPage);
                  }
               }
            };

            trafficShapingPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.shaping.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupTrafficShapingPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitTrafficShapingPage);
                  }
               }
            };

            monitoringPolicyPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.monitoring.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupMonitoringPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitMonitoringPolicyPage);
                  }
               }
            };

            miscellaneousPolicyPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.policy.misc.title'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                        'edit/pages/dvPortgroupMiscellaneousPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitMiscellaneousPolicyPage);
                  }
               }
            };

            advancedPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'dvpg.properties.advanced'),
                  contentUrl: 'dvs-ui/resources/dvs/dvpg/' +
                  'edit/pages/dvPortgroupAdvancedPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitAdvancedPage);
                  }
               }
            };
         }

         function getPageDefinitions() {
            var pages = [];

            pages.push(generalPageDef.page);
            pages.push(advancedPageDef.page);
            pages.push(vlanPageDef.page);

            if (!dvPortgroupData.isUplink) {
               pages.push(securityPolicyPageDef.page);
               pages.push(failoverPolicyPageDef.page);
               pages.push(trafficShapingPageDef.page);
            }

            if (dvPortgroupData.ipfixSupported) {
               pages.push(monitoringPolicyPageDef.page);
            }

            pages.push(miscellaneousPolicyPageDef.page);

            return pages;
         }

         /**
          * Shows provided error messages in dialog overlay banner.
          */
         function showDialogErrors(errors /* String[] */) {
            if (!errors || errors.length < 1) {
               return;
            }

            clearValidationMessages();
            dialogOptions.validationBanner.messages = _.map(
                  errors,
                  function(message) {
                     return {
                        type: vuiConstants.validationBanner.type.ERROR,
                        text: message
                     };
                  });
         }

         function clearValidationMessages() {
            dialogOptions.validationBanner.messages = [];
         }

         function submit() {
            if (!hasChanged()) {
               return true;
            }

            var editDvPortgroupSpec = {
               _type: EDIT_DV_PORT_GROUP_SPEC,
               configVersion: dvPortgroupData.configVersion
            };

            if (pageDirtyFlags.isGeneralPropertiesPageDirty) {
               editDvPortgroupSpec.name = dvPortgroupData.name;
               editDvPortgroupSpec.description = dvPortgroupData.description;
               editDvPortgroupSpec.type = dvPortgroupData.type;
               editDvPortgroupSpec.numPorts = dvPortgroupData.numPorts;

               if (!dvPortgroupData.isUplink) {
                  if (dvPortgroupData.type ===
                        networkUiConstants.PortgroupType.EARLY_BINDING) {
                     editDvPortgroupSpec.autoExpand = dvPortgroupData.autoExpand;
                  }

                  if (dvPortgroupData.isNetworkResourcePoolSupported) {
                     if (dvPortgroupData.isVmVnicResourcePoolSupported) {
                        editDvPortgroupSpec.vmVnicNetworkResourcePoolKey =
                              dvPortgroupData.networkResourcePoolKey;
                     } else {
                        editDvPortgroupSpec.defaultPortConfig = {
                           _type: 'com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy',
                           networkResourcePoolKey: {
                              _type: 'com.vmware.vim.binding.vim.StringPolicy',
                              value: dvPortgroupData.networkResourcePoolKey,
                              inherited: false
                           }
                        };
                     }
                  }
               }
            }

            if (pageDirtyFlags.isVlanPageDirty ||
                  pageDirtyFlags.isSecurityPolicyPageDirty ||
                  pageDirtyFlags.isFailoverPolicyPageDirty ||
                  pageDirtyFlags.isTrafficShapingPageDirty ||
                  pageDirtyFlags.isMonitoringPolicyPageDirty ||
                  pageDirtyFlags.isMiscellaneousPolicyPageDirty ||
                  pageDirtyFlags.isAdvancedPageDirty) {

               if (!editDvPortgroupSpec.defaultPortConfig) {
                  editDvPortgroupSpec.defaultPortConfig = {
                     _type: 'com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy'
                  };
               }

               if (pageDirtyFlags.isVlanPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.vlan =
                        dvpgSpecFactory.buildVlanSpec(dvPortgroupData);
               }

               if (pageDirtyFlags.isSecurityPolicyPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.securityPolicy =
                     dvPortgroupData.isUplink ? null :
                           dvpgSpecFactory.buildSecurityPolicySpec(dvPortgroupData);
               }

               if (pageDirtyFlags.isFailoverPolicyPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.uplinkTeamingPolicy =
                     dvPortgroupData.isUplink ? null :
                           dvpgSpecFactory.buildTeamingAndFailoverSpec(dvPortgroupData);
               }

               if (pageDirtyFlags.isTrafficShapingPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.inShapingPolicy =
                        dvPortgroupData.isUplink ? null :
                              dvpgSpecFactory.buildTrafficShapingSpec(
                                    dvPortgroupData.inShapingPolicy);

                  editDvPortgroupSpec.defaultPortConfig.outShapingPolicy =
                        dvPortgroupData.isUplink ? null :
                              dvpgSpecFactory.buildTrafficShapingSpec(
                                    dvPortgroupData.outShapingPolicy);
               }

               if (pageDirtyFlags.isMonitoringPolicyPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.ipfixEnabled =
                        createMonitoringPolicySpec(dvPortgroupData.ipfixEnabled);
               }

               if (pageDirtyFlags.isMiscellaneousPolicyPageDirty) {
                  editDvPortgroupSpec.defaultPortConfig.blocked =
                        createMiscellaneousPolicySpec(dvPortgroupData.arePortsBlocked);
               }

               if (pageDirtyFlags.isAdvancedPageDirty) {
                  editDvPortgroupSpec.policy = dvpgSpecFactory.buildPortPoliciesSpec(
                        dvPortgroupData.dvPortgroupPortProperties);
               }
            }

            mutationService.apply(
                  dvPortgroupData.dvPortgroupId, EDIT_DV_PORT_GROUP_SPEC,
                  editDvPortgroupSpec);

            return true;
         }

         function hasChanged() {
            return pageDirtyFlags.isGeneralPropertiesPageDirty ||
                  pageDirtyFlags.isVlanPageDirty ||
                  pageDirtyFlags.isSecurityPolicyPageDirty ||
                  pageDirtyFlags.isFailoverPolicyPageDirty ||
                  pageDirtyFlags.isTrafficShapingPageDirty ||
                  pageDirtyFlags.isMonitoringPolicyPageDirty ||
                  pageDirtyFlags.isMiscellaneousPolicyPageDirty ||
                  pageDirtyFlags.isAdvancedPageDirty;
         }

         function createMonitoringPolicySpec(ipfixEnabled) {
            return {
               _type: 'com.vmware.vim.binding.vim.BoolPolicy',
               value: ipfixEnabled,
               inherited: false
            };
         }

         function createMiscellaneousPolicySpec(arePortsBlocked) {
            return {
               _type: 'com.vmware.vim.binding.vim.BoolPolicy',
               value: arePortsBlocked,
               inherited: false
            };
         }
      };
   }

   function execute(func) {
      if (typeof func === 'function') {
         return func();
      }
   }
})();

(function () {
   'use strict';

   /**
    * Opens Edit port group dialog as a multi page dialog.
    */
   angular
         .module('com.vmware.vsphere.client.dvs')
         .service('editDvPortgroupDialogService', editDvPortgroupDialogService);

   editDvPortgroupDialogService.$inject = [
      'dataService',
      '$rootScope',
      'i18nService',
      'vxMultiPageDialogService',
      'networkUiConstants',
      'EditDvPortgroupDialogManager'];

   function editDvPortgroupDialogService(dataService,
         $rootScope,
         i18nService,
         vxMultiPageDialogService,
         networkUiConstants,
         EditDvPortgroupDialogManager) {

      return {
         show: show
      };

      function show(dvPortgroupId, actionEval) {
         var editDvPortgroupDialogPropertyName =
               'dvpg:editDvPortgroupDialogProperties';

         var dvPortgroupData = {
            dvPortgroupId: dvPortgroupId
         };

         var dialogScope = $rootScope.$new();
         dialogScope.dialogOptions = {};

         var dvPortgroupDialogManager = new EditDvPortgroupDialogManager(dvPortgroupData,
               dialogScope.dialogOptions);
         dialogScope.manager = dvPortgroupDialogManager;

         _.extend(dialogScope.dialogOptions, {
            title: i18nService.getString('NetworkUi', 'dvpg.settings.initialTitle'),
            iconClass: actionEval.action.icon,
            actionDetails: {
               actionEval: actionEval,
               availableTargets: [dvPortgroupId]
            },
            show: true,
            height: "640px",
            width: "960px",
            loading: true, // this prevents the dialog from being initialized
                           // until distributed port group data is loaded
            loadingMessage: i18nService.getString('CommonUi', 'wizard.loading'),
            confirmOptions: {
               onClick: dvPortgroupDialogManager.submit
            },
            validationBanner: {},
            rejectOptions: {
               rejectOnEsc: true
            },
            resizable: true,
            draggable: true,
            maximizable: true
         });

         var options = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vxMultiPageDialogService(options);

         dataService.getProperties(dvPortgroupId, [editDvPortgroupDialogPropertyName])
               .then(function(response) {
                  _.extend(dvPortgroupData, response[editDvPortgroupDialogPropertyName]);

                  dvPortgroupData.initialNumPorts = dvPortgroupData.numPorts;
                  dvPortgroupData.showPortAllocation = !dvPortgroupData.isUplink &&
                        dvPortgroupData.type !== networkUiConstants.PortgroupType.EPHEMERAL;
                  dvPortgroupData.showPortAllocationInfo = false;

                  dvPortgroupData.showPvlanError = !dvPortgroupData.pvlanConfig ||
                        dvPortgroupData.pvlanConfig.length === 0;

                  dialogScope.dialogOptions.title = i18nService.getString('NetworkUi',
                        'dvpg.settings.title', dvPortgroupData.name);
                  dialogScope.dialogOptions.loading = false;

                  dialogScope.dialogOptions.pages =
                        dvPortgroupDialogManager.getPageDefinitions();

                  dialogScope.initialData = angular.copy(dvPortgroupData);
               });
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvPortgroupAdvancedPageComponent = (function () {
        function DvPortgroupAdvancedPageComponent() {
            this.bindings = {
                model: "<",
                initialModel: "<",
                pageDirtyFlags: "<",
                commitCallbacks: "<"
            };
            this.controller = DvPortgroupAdvancedPageController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/edit/pages/" +
                "dvPortgroupAdvancedPageTemplate.html";
        }
        return DvPortgroupAdvancedPageComponent;
    }());
    dvs_ui.DvPortgroupAdvancedPageComponent = DvPortgroupAdvancedPageComponent;
    var DvPortgroupAdvancedPageController = (function () {
        function DvPortgroupAdvancedPageController(i18nService, authorizationService, navigation) {
            var _this = this;
            this.i18nService = i18nService;
            this.authorizationService = authorizationService;
            this.navigation = navigation;
            this.hasPolicyPrivilege = true;
            var dvportGroupUrn = this.navigation.getRoute().objectId;
            this.commitCallbacks.commitAdvancedPage = function () { return _this.onCommit(); };
            this.authorizationService.checkPrivilege(dvportGroupUrn, DvPortgroupAdvancedPageController.PRIVILEDGE_POLICY_OP).then(function (isAuthorized) {
                _this.hasPolicyPrivilege = isAuthorized;
            });
        }
        DvPortgroupAdvancedPageController.prototype.onCommit = function () {
            this.pageDirtyFlags.isAdvancedPageDirty =
                this.hasConfigureResetAtDisconnectChanged()
                    || this.havePortPoliciesChanged();
            return true;
        };
        DvPortgroupAdvancedPageController.prototype.hasConfigureResetAtDisconnectChanged = function () {
            return this.model.portConfigResetAtDisconnect
                !== this.initialModel.portConfigResetAtDisconnect;
        };
        DvPortgroupAdvancedPageController.prototype.havePortPoliciesChanged = function () {
            if (!this.hasPolicyPrivilege) {
                return false;
            }
            return !_.isEqual(this.initialModel, this.model);
        };
        DvPortgroupAdvancedPageController.$inject = [
            "i18nService",
            "authorizationService",
            "navigation"
        ];
        DvPortgroupAdvancedPageController.PRIVILEDGE_POLICY_OP = "DVPortgroup.PolicyOp";
        return DvPortgroupAdvancedPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvPortgroupAdvancedPage", new DvPortgroupAdvancedPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupFailoverPolicyPageController',
               DvPortgroupFailoverPolicyPageController);

   DvPortgroupFailoverPolicyPageController.$inject = [
         '$scope',
         'dvpgFailoverPolicyPageService'
   ];

   function DvPortgroupFailoverPolicyPageController(
         $scope,
         dvpgFailoverPolicyPageService) {

      $scope.manager.commitPageCallbacks.commitFailoverPolicyPage = onCommit;

      $scope.failoverOrder = dvpgFailoverPolicyPageService.createFailoverOrderSettings(
            $scope.manager.dvPortgroupData.failoverOrder);

      var initialFailoverPolicyData = getInitialPolicyData();
      var initialFailoverOrderData = getInitialFailoverOrderData();

      function onCommit() {

         $scope.manager.pageDirtyFlags.isFailoverPolicyPageDirty =
               hasTeamingPolicyChanged(initialFailoverPolicyData,
                     $scope.manager.dvPortgroupData) ||
               dvpgFailoverPolicyPageService.hasFailoverOrderChanged(
                     initialFailoverOrderData,
                     $scope.manager.dvPortgroupData.failoverOrder.activeUplinkPortNames,
                     $scope.manager.dvPortgroupData.failoverOrder.standbyUplinkPortNames);

         if ($scope.manager.pageDirtyFlags.isFailoverPolicyPageDirty &&
               dvpgFailoverPolicyPageService.shouldShowErrorWarningDialog(
                     $scope.failoverOrder.connectees,
                     $scope.manager.dvPortgroupData.loadBalancing,
                     $scope.manager.dvPortgroupData.beaconProbing)) {

            return dvpgFailoverPolicyPageService.showErrorWarningDialog(
                  $scope.failoverOrder.connectees,
                  $scope.manager.dvPortgroupData.loadBalancing,
                  $scope.manager.dvPortgroupData.beaconProbing);
         }

         return true;
      }

      function hasTeamingPolicyChanged(initialPolicy, actualPolicy) {
         return initialPolicy.loadBalancing !== actualPolicy.loadBalancing ||
            initialPolicy.beaconProbing !== actualPolicy.beaconProbing ||
            initialPolicy.notifySwitches !== actualPolicy.notifySwitches ||
            initialPolicy.rollingOrder !== actualPolicy.rollingOrder;
      }

      function getInitialFailoverOrderData () {
         return {
            connectees: {
               active: $scope.initialData.failoverOrder.activeUplinkPortNames,
               standby: $scope.initialData.failoverOrder.standbyUplinkPortNames,
               unused: $scope.initialData.failoverOrder.unusedUplinkPortNames
            }
         };
      }

      function getInitialPolicyData() {
         return {
            loadBalancing: $scope.initialData.loadBalancing,
            beaconProbing: $scope.initialData.beaconProbing,
            notifySwitches: $scope.initialData.notifySwitches,
            rollingOrder: $scope.initialData.rollingOrder
         };
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupGeneralPropertiesPageController',
               DvPortgroupGeneralPropertiesPageController);

   DvPortgroupGeneralPropertiesPageController.$inject = [
      '$scope',
      'dvPortgroupGeneralPropertiesPageService',
      '$q',
      'i18nService',
      'networkUiConstants',
      'dvpgPropertiesService',
      'networkUtil'];

   function DvPortgroupGeneralPropertiesPageController($scope,
         dvPortgroupGeneralPropertiesPageService,
         $q,
         i18nService,
         networkUiConstants,
         dvpgPropertiesService,
         networkUtil) {

      $scope.nameValidator = {
         message: null,
         isVisible: false
      };

      $scope.descriptionValidator = {
         message: null,
         isVisible: false
      };

      $scope.numPortsValidator = {};

      $scope.portBindingOptions = [{
         label: networkUtil.getString('NetworkUtil.earlyBinding'),
         val: networkUiConstants.PortgroupType.EARLY_BINDING
      }, {
         label: networkUtil.getString('NetworkUtil.ephemeral'),
         val: networkUiConstants.PortgroupType.EPHEMERAL
      }];

      $scope.portAllocationOptions = [{
         label: i18nService.getString(
               'NetworkUi', 'dvpg.properties.portAllocation.autoExpand.true'),
         val: true
      }, {
         label: i18nService.getString(
               'NetworkUi', 'dvpg.properties.portAllocation.autoExpand.false'),
         val: false
      }];

      $scope.networkResourcePoolOptions = [];

      if ($scope.manager.dvPortgroupData.networkResourcePools &&
            $scope.manager.dvPortgroupData.networkResourcePools.length > 0) {

         $scope.manager.dvPortgroupData.networkResourcePools.forEach(
               function (resourcePool) {

            $scope.networkResourcePoolOptions.push({
               label: resourcePool.name,
               val: resourcePool.key
            });
         });
      }

      $scope.onNameChange = function () {
         var message = dvpgPropertiesService.getInvalidNameError(
               $scope.manager.dvPortgroupData.name);
         $scope.nameValidator.message = message;
         $scope.nameValidator.isVisible = message !== null;
      };

      $scope.onDescriptionChange = function () {
         var message = dvPortgroupGeneralPropertiesPageService.getInvalidDescriptionError(
               $scope.manager.dvPortgroupData.description);
         $scope.descriptionValidator.message = message;
         $scope.descriptionValidator.isVisible = message !== null;
      };

      setNumPortsValidator();

      $scope.onNumPortsChange = function () {
         setNumPortsValidator();
      };

      $scope.manager.commitPageCallbacks.commitGeneralPropertiesPage = onCommit;

      if (!$scope.manager.dvPortgroupData.isUplink) {
         $scope.$watch(function() {
            return $scope.manager.dvPortgroupData.type;
         }, function(newType, oldType) {

            switch(newType) {
               case networkUiConstants.PortgroupType.EARLY_BINDING: {
                  $scope.manager.dvPortgroupData.showPortAllocation = true;
                  $scope.manager.dvPortgroupData.showPortAllocationInfo =
                        $scope.manager.dvPortgroupData.autoExpand;
                  break;
               }
               case networkUiConstants.PortgroupType.EPHEMERAL: {
                  $scope.manager.dvPortgroupData.showPortAllocation = false;
                  $scope.manager.dvPortgroupData.showPortAllocationInfo = false;
                  break;
               }
            }

            if ($scope.manager.dvPortgroupData.oldType === networkUiConstants.PortgroupType.LATE_BINDING
                  && oldType !== newType) {
               $scope.manager.dvPortgroupData.showDynamicPortBindingWarning = false;
            }
         });

         $scope.$watch(function() {
            return $scope.manager.dvPortgroupData.autoExpand;
         }, function(newPortAllocation) {
            $scope.manager.dvPortgroupData.showPortAllocationInfo = newPortAllocation &&
                  networkUiConstants.PortgroupType.EARLY_BINDING ===
                        $scope.manager.dvPortgroupData.type;
         });
      }

      function onCommit() {
         $scope.manager.pageDirtyFlags.isGeneralPropertiesPageDirty =
               haveGeneralPropertiesChanged();

         if ($scope.manager.pageDirtyFlags.isGeneralPropertiesPageDirty) {
            return validateProperties().then(function(errors) {
               if (errors.length > 0) {
                  $scope.manager.showDialogErrors(errors);
               }

               return errors.length === 0;
            });
         }

         return true;
      }

      function validateProperties() {
         var errors = [];

         var invalidNameError = dvpgPropertiesService
               .getInvalidNameError($scope.manager.dvPortgroupData.name);

         if (invalidNameError) {
            errors.push(invalidNameError);
         }

         if ($scope.manager.dvPortgroupData.type ===
               networkUiConstants.PortgroupType.EARLY_BINDING) {
            var numPortsError = getNumPortErrorMessage();

            if (numPortsError) {
               errors.push(numPortsError);
            }
         }

         var descriptionError = dvPortgroupGeneralPropertiesPageService
               .getInvalidDescriptionError($scope.manager.dvPortgroupData.description);

         if (descriptionError) {
            errors.push(descriptionError);
         }

         if (errors.length > 0) {
            return $q.resolve(errors);
         }

         var data = $scope.manager.dvPortgroupData;

         if ($scope.initialData.name === data.name) {
            return $q.resolve([]);
         }

         return dvpgPropertiesService.getDuplicateOrTooLongNameError(
               data.dvPortgroupId, data.name);
      }

      function getNumPortErrorMessage() {
         var message;

         if ($scope.manager.dvPortgroupData.initialNumPorts >
               networkUiConstants.DvPortgroupNumPorts.MAX) {
            message = dvpgPropertiesService.getNumPortsError(
                  $scope.manager.dvPortgroupData.numPorts,
                  $scope.manager.dvPortgroupData.initialNumPorts);
         } else {
            message = dvpgPropertiesService.getNumPortsError(
                  $scope.manager.dvPortgroupData.numPorts);
         }
         return message;
      }

      function setNumPortsValidator() {
         var message = getNumPortErrorMessage();
         $scope.numPortsValidator.message = message;
         $scope.numPortsValidator.isVisible = message !== null;
      }

      function haveGeneralPropertiesChanged() {
         return $scope.manager.dvPortgroupData.name !== $scope.initialData.name ||
               $scope.manager.dvPortgroupData.type !== $scope.initialData.type ||
               $scope.manager.dvPortgroupData.autoExpand !== $scope.initialData.autoExpand ||
               $scope.manager.dvPortgroupData.numPorts !== $scope.initialData.numPorts ||
               $scope.manager.dvPortgroupData.description !== $scope.initialData.description ||
               $scope.manager.dvPortgroupData.networkResourcePoolKey !== $scope.initialData.networkResourcePoolKey;
      }

      return this;
   }
})();

(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.dvs')
         .service('dvPortgroupGeneralPropertiesPageService',
               dvPortgroupGeneralPropertiesPageService);

   /**
    * Service dedicated for dvPortgroupGeneralPropertiesPage template.
    */
   dvPortgroupGeneralPropertiesPageService.$inject = [
      'i18nService',
      'mutationService'];

   function dvPortgroupGeneralPropertiesPageService(i18nService,
         mutationService) {

      var MAX_ALLOWED_DESCRIPTION_LENGTH = 255;

      return {
         getInvalidDescriptionError: getInvalidDescriptionError
      };

      /**
       * Validates the description of a distributed port group and
       * return an appropriate localized error message.
       */
      function getInvalidDescriptionError(description) {
         if (description) {
            description = description.trim();

            if (description.length > MAX_ALLOWED_DESCRIPTION_LENGTH) {
               return i18nService.getString(
                     'H5NetworkUi', 'dvpg.properties.description.tooLong');
            }
         }

         return null;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupMiscellaneousPolicyPageController',
               DvPortgroupMiscellaneousPolicyPageController);

   DvPortgroupMiscellaneousPolicyPageController.$inject = ['$scope'];

   function DvPortgroupMiscellaneousPolicyPageController($scope) {

      $scope.manager.commitPageCallbacks.commitMiscellaneousPolicyPage = onCommit;

      function onCommit () {
         $scope.manager.pageDirtyFlags.isMiscellaneousPolicyPageDirty =
               hasInitialMiscDataChanged();
         return true;
      }

      function hasInitialMiscDataChanged() {
         return $scope.initialData.arePortsBlocked !==
               $scope.manager.dvPortgroupData.arePortsBlocked;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupMonitoringPageController',
               DvPortgroupMonitoringPageController);

   DvPortgroupMonitoringPageController.$inject = ['$scope'];

   function DvPortgroupMonitoringPageController($scope) {


      $scope.manager.commitPageCallbacks.commitMonitoringPolicyPage = onCommit;

      function onCommit() {
         $scope.manager.pageDirtyFlags.isMonitoringPolicyPageDirty =
               hasMonitoringPolicyChanged();
         return true;
      }

      function hasMonitoringPolicyChanged () {
         return $scope.initialData.ipfixEnabled !==
               $scope.manager.dvPortgroupData.ipfixEnabled;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupSecurityPolicyPageController',
               DvPortgroupSecurityPolicyPageController);

   DvPortgroupSecurityPolicyPageController.$inject = [
      '$scope'
   ];

   function DvPortgroupSecurityPolicyPageController($scope) {

      $scope.manager.commitPageCallbacks.commitSecurityPolicyPage = onCommit;

      function onCommit() {
            $scope.manager.pageDirtyFlags.isSecurityPolicyPageDirty =
               hasSecurityPolicyChanged(
                     $scope.initialData,
                     $scope.manager.dvPortgroupData);
         return true;
      }

      function hasSecurityPolicyChanged(initialPolicy, actualPolicy) {
         return initialPolicy.allowPromiscuous !== actualPolicy.allowPromiscuous ||
               initialPolicy.forgedTransmits !== actualPolicy.forgedTransmits ||
               initialPolicy.macChanges !== actualPolicy.macChanges;
      }

      return this;
   }

})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupTrafficShapingPageController',
               DvPortgroupTrafficShapingPageController);

   DvPortgroupTrafficShapingPageController.$inject = [
      '$scope',
      'vuiConstants',
      'dvpgTrafficShapingPolicyService'
   ];

   function DvPortgroupTrafficShapingPageController($scope, vuiConstants,
         dvpgTrafficShapingPolicyService) {

      $scope.manager.commitPageCallbacks.commitTrafficShapingPage = onCommit;

      function onCommit() {
         $scope.manager.pageDirtyFlags.isTrafficShapingPageDirty =
               hasShapingPolicyChanged($scope.initialData.inShapingPolicy,
                     $scope.manager.dvPortgroupData.inShapingPolicy) ||
               hasShapingPolicyChanged($scope.initialData.outShapingPolicy,
                     $scope.manager.dvPortgroupData.outShapingPolicy);

         if ($scope.manager.pageDirtyFlags.isTrafficShapingPageDirty) {
            var errors = dvpgTrafficShapingPolicyService.getErrorMessages(
                  $scope.manager.dvPortgroupData.inShapingPolicy,
                  $scope.manager.dvPortgroupData.outShapingPolicy);

            return _.map(errors, function(message) {
               return {
                  type: vuiConstants.validationBanner.type.ERROR,
                  text: message
               };
            });
         }

         return true;
      }

      function hasShapingPolicyChanged(initialPolicy, actualPolicy) {
         return initialPolicy.enabled !== actualPolicy.enabled ||
               initialPolicy.averageBandwidth !== actualPolicy.averageBandwidth ||
               initialPolicy.peakBandwidth !== actualPolicy.peakBandwidth ||
               initialPolicy.burstSize !== actualPolicy.burstSize;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.dvs')
         .controller('DvPortgroupVlanPageController',
               DvPortgroupVlanPageController);

   DvPortgroupVlanPageController.$inject = [
      '$scope',
      'i18nService',
      'networkUiConstants',
      'dvpgPropertiesService',
      'dvPortgroupVlanPageService'];

   function DvPortgroupVlanPageController($scope,
         i18nService,
         networkUiConstants,
         dvpgPropertiesService,
         dvPortgroupVlanPageService) {

      $scope.manager.commitPageCallbacks.commitVlanPage = onCommit;

      function onCommit () {
         $scope.manager.pageDirtyFlags.isVlanPageDirty =
               hasVlanDataChanged();

         if ($scope.manager.pageDirtyFlags.isVlanPageDirty) {
            switch ($scope.manager.dvPortgroupData.vlanType) {
               case networkUiConstants.Vlan.Type.VLAN: {

                  var vlanIdError = dvpgPropertiesService.getVlanIdError(
                        $scope.manager.dvPortgroupData.vlanId);

                  if (vlanIdError) {
                     $scope.manager.showDialogErrors([vlanIdError]);
                     return false;
                  }

                  break;
               }
               case networkUiConstants.Vlan.Type.TRUNK: {
                  return dvPortgroupVlanPageService.getTrunkVlanRanges(
                        $scope.manager.dvPortgroupData.dvPortgroupId,
                        $scope.manager.dvPortgroupData.vlanTrunkRanges
                  ).then(function(numericRanges) {
                     $scope.manager.dvPortgroupData.vlanTrunkNumericRanges = numericRanges;

                     if (!numericRanges) {
                        $scope.manager.showDialogErrors([
                           i18nService.getString(
                                 'DvsUi', 'dvpg.policy.vlan.trunk.errorMessage')]);
                        return false;
                     }

                     return true;
                  });
               }
               case networkUiConstants.Vlan.Type.PRIVATE: {
                  if ($scope.manager.dvPortgroupData.showPvlanError) {
                     $scope.manager.showDialogErrors([
                        i18nService.getString(
                              'DvsUi', 'dvpg.policy.vlan.private.noConfig')]);
                     return false;
                  }

                  break;
               }
            }
         }
         return true;
      }

      function hasVlanDataChanged() {
         return $scope.manager.dvPortgroupData.vlanType !== $scope.initialData.vlanType ||
               $scope.manager.dvPortgroupData.vlanId !== $scope.initialData.vlanId ||
               $scope.manager.dvPortgroupData.vlanTrunkRanges !== $scope.initialData.vlanTrunkRanges ||
               $scope.manager.dvPortgroupData.pvlanId !== $scope.initialData.pvlanId;
      }

      return this;
   }
})();

(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.dvs')
         .service('dvPortgroupVlanPageService',
               dvPortgroupVlanPageService);

   /**
    * Service dedicated for dvPortgroupVlanPage template.
    */
   dvPortgroupVlanPageService.$inject = [
      'mutationService',
      '$q'];

   function dvPortgroupVlanPageService(mutationService, $q) {

      return {
         getTrunkVlanRanges: getTrunkVlanRanges
      };

      /**
       * Validates and retrieves the NumericRanges corresponding
       * to the provided string value.
       */
      function getTrunkVlanRanges(dvPgId, trunkVlanRangesString) {
         if (!trunkVlanRangesString) {
            return $q.resolve(null);
         }

         return mutationService.validate(dvPgId,
               'com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupTrunkVlanSpec',
               {
                  _type: 'com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupTrunkVlanSpec',
                  numericRanges: trunkVlanRangesString.trim()
               })
               .then(function (validationResult) {
                  return validationResult && validationResult.result;
               }, function () {
                  return null;
               });
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvpgManageWizardConstants", {
        page: {
            POLICY_TYPE: "policyTypePage",
            SELECT_PORTGROUPS: "selectPortgroupsPage",
            SECURITY_POLICY: "securityPolicyPage",
            VLAN: "vlanPage",
            TRAFFIC_SHAPING: "trafficShapingPage",
            FAILOVER_POLICY: "teamingAndFailoverPage",
            VM_VNIC_RESOURCE_POOL: "vmVnicResourcePoolPage",
            MONITORING: "monitoringPage",
            MISC: "miscPage",
            SUMMARY: "readyToCompletePage"
        },
        properties: {
            WIZARD_DATA: "manageDvpg:wizardData",
            POLICY_DATA: "manageDvpg:policiesData"
        },
        privileges: {
            DVPORTGROUP_MODIFY: "DVPortgroup.Modify"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Manages the page states of the Manage DVPG Wizard.
 */
var dvs_ui;
(function (dvs_ui) {
    var DvpgManageWizardFlowManager = (function () {
        function DvpgManageWizardFlowManager(pageStateManagementService, dvpgManageWizardConstants, vuiConstants) {
            this.pageStateManagementService = pageStateManagementService;
            this.dvpgManageWizardConstants = dvpgManageWizardConstants;
            this.vuiConstants = vuiConstants;
            // Preserve the same order as in the watchGroup array
            this.pageIds = [
                this.dvpgManageWizardConstants.page.SECURITY_POLICY,
                this.dvpgManageWizardConstants.page.VLAN,
                this.dvpgManageWizardConstants.page.TRAFFIC_SHAPING,
                this.dvpgManageWizardConstants.page.FAILOVER_POLICY,
                this.dvpgManageWizardConstants.page.VM_VNIC_RESOURCE_POOL,
                this.dvpgManageWizardConstants.page.MONITORING,
                this.dvpgManageWizardConstants.page.MISC
            ];
        }
        DvpgManageWizardFlowManager.prototype.init = function (wizardScope) {
            var _this = this;
            this.pages = wizardScope.wizardConfig.pages;
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            wizardScope.$watchGroup([
                "model.policies.isSecurityPolicySelected",
                "model.policies.isVlanPolicySelected",
                "model.policies.isTrafficShapingPolicySelected",
                "model.policies.isFailoverPolicySelected",
                "model.policies.isResAllocPolicySelected",
                "model.policies.isMonitoringPolicySelected",
                "model.policies.isMiscPolicySelected"], function (newValues) {
                _this.updatePagesVisibility(newValues);
            });
        };
        DvpgManageWizardFlowManager.prototype.updatePagesVisibility = function (policies) {
            var _this = this;
            policies.forEach(function (isPolicySelected, index) {
                _this.togglePageVisibility(_this.pageIds[index], isPolicySelected);
            });
        };
        DvpgManageWizardFlowManager.prototype.togglePageVisibility = function (pageId, isVisible) {
            var page = _.findWhere(this.pages, { id: pageId });
            if (isVisible) {
                // change the state to DISABLED only if the page is currently invisible.
                if (page.state === this.vuiConstants.wizard.pageState.SKIPPED) {
                    page.state = this.vuiConstants.wizard.pageState.DISABLED;
                }
            }
            else {
                page.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvpgManageWizardFlowManager.$inject = [
            "pageStateManagementService",
            "dvpgManageWizardConstants",
            "vuiConstants"];
        return DvpgManageWizardFlowManager;
    }());
    dvs_ui.DvpgManageWizardFlowManager = DvpgManageWizardFlowManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgManageWizardFlowManager", DvpgManageWizardFlowManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgManageWizardPages = (function () {
        function DvpgManageWizardPages(i18nService, dvpgManageWizardConstants, simpleValidationCommit, policyTypeValidator, dvpgSelectPortgroupsPageValidator, dvpgVlanPageValidator, dvpgTrafficShapingPolicyService, dvpgFailoverPolicyPageValidator) {
            this.i18nService = i18nService;
            this.dvpgManageWizardConstants = dvpgManageWizardConstants;
            this.simpleValidationCommit = simpleValidationCommit;
            this.policyTypeValidator = policyTypeValidator;
            this.dvpgSelectPortgroupsPageValidator = dvpgSelectPortgroupsPageValidator;
            this.dvpgVlanPageValidator = dvpgVlanPageValidator;
            this.dvpgTrafficShapingPolicyService = dvpgTrafficShapingPolicyService;
            this.dvpgFailoverPolicyPageValidator = dvpgFailoverPolicyPageValidator;
        }
        /**
         * Creates an array of page definitions for the Manage DVPG wizard.
         */
        DvpgManageWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var policyTypePage = {
                id: this.dvpgManageWizardConstants.page.POLICY_TYPE,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policyType.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policyType.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgPolicyTypePage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.policyTypeValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.policies.isSecurityPolicySelected",
                    "model.policies.isTrafficShapingPolicySelected",
                    "model.policies.isVlanPolicySelected",
                    "model.policies.isFailoverPolicySelected",
                    "model.policies.isResAllocPolicySelected",
                    "model.policies.isTrafficFilterPolicySelected",
                    "model.policies.isMonitoringPolicySelected",
                    "model.policies.isMiscPolicySelected"]
            };
            var selectPortgroups = {
                id: this.dvpgManageWizardConstants.page.SELECT_PORTGROUPS,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.portGroupList.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.portGroupList.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgSelectPortgroupsPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvpgSelectPortgroupsPageValidator
                        .getValidationError(wizardScope.model);
                }, wizardScope.wizardConfig),
                validationParams: ["model.selectedPortgroups"]
            };
            var securityPolicyPage = {
                id: this.dvpgManageWizardConstants.page.SECURITY_POLICY,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.security.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.security.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgSecurityPolicyPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.securityPolicyModel.allowPromiscuous",
                    "model.securityPolicyModel.forgedTransmits",
                    "model.securityPolicyModel.macChanges"]
            };
            var vlanPage = {
                id: this.dvpgManageWizardConstants.page.VLAN,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.vlan.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.vlan.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgVlanPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvpgVlanPageValidator
                        .getValidationError(wizardScope.model.selectedPortgroups[0].id, wizardScope.model.vlanPolicyModel);
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.vlanPolicyModel.vlanType",
                    "model.vlanPolicyModel.vlanId",
                    "model.vlanPolicyModel.pvlanId",
                    "model.vlanPolicyModel.vlanTrunkRanges"]
            };
            var trafficShapingPage = {
                id: this.dvpgManageWizardConstants.page.TRAFFIC_SHAPING,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.shaping.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.shaping.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgTrafficShapingPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvpgTrafficShapingPolicyService.getErrorMessages(wizardScope.model.trafficShapingPolicyModel.inShapingPolicy, wizardScope.model.trafficShapingPolicyModel.outShapingPolicy);
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.trafficShapingPolicyModel.inShapingPolicy.enabled",
                    "model.trafficShapingPolicyModel.inShapingPolicy.averageBandwidth",
                    "model.trafficShapingPolicyModel.inShapingPolicy.peakBandwidth",
                    "model.trafficShapingPolicyModel.inShapingPolicy.burstSize",
                    "model.trafficShapingPolicyModel.outShapingPolicy.enabled",
                    "model.trafficShapingPolicyModel.outShapingPolicy.averageBandwidth",
                    "model.trafficShapingPolicyModel.outShapingPolicy.peakBandwidth",
                    "model.trafficShapingPolicyModel.outShapingPolicy.burstSize"]
            };
            var failoverPage = {
                id: this.dvpgManageWizardConstants.page.FAILOVER_POLICY,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.failover.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.failover.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgFailoverPolicyPage.html",
                onCommit: function () {
                    return _this.dvpgFailoverPolicyPageValidator.getValidationError(wizardScope)
                        .then(function (result) {
                        return _this.simpleValidationCommit(function () {
                            return result;
                        }, wizardScope.wizardConfig).call(_this);
                    });
                },
                validationParams: [
                    "model.failoverPolicyModel.loadBalancing",
                    "model.failoverPolicyModel.beaconProbing",
                    "model.failoverPolicyModel.notifySwitches",
                    "model.failoverPolicyModel.rollingOrder",
                    "model.failoverPolicyModel.failoverOrder.activeUplinkPortNames",
                    "model.failoverPolicyModel.failoverOrder.standbyUplinkPortNames",
                    "model.failoverPolicyModel.failoverOrder.unusedUplinkPortNames"]
            };
            var resourcePoolAllocationPage = {
                id: this.dvpgManageWizardConstants.page.VM_VNIC_RESOURCE_POOL,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.resourceAllocation.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.resourceAllocation.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgResourceAllocationPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: [
                    "model.resourceAllocationPolicyModel.networkResourcePoolKey"]
            };
            var monitoringPage = {
                id: this.dvpgManageWizardConstants.page.MONITORING,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.monitoring.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.monitoring.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgMonitoringPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.monitoringPolicyModel.ipfixEnabled"]
            };
            var miscPage = {
                id: this.dvpgManageWizardConstants.page.MISC,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policy.misc.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.policy.misc.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgMiscPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.miscPolicyModel.arePortsBlocked"]
            };
            var readyToCompletePage = {
                id: this.dvpgManageWizardConstants.page.SUMMARY,
                title: this.i18nService.getString("DvsUi", "dvpg.manage.summary.title"),
                description: this.i18nService.getString("DvsUi", "dvpg.manage.summary.description"),
                contentUrl: "dvs-ui/resources/dvs/dvpg/manage/views/dvpgReadyToCompletePage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            return [policyTypePage, selectPortgroups, securityPolicyPage, vlanPage,
                trafficShapingPage, failoverPage, resourcePoolAllocationPage, monitoringPage,
                miscPage, readyToCompletePage];
        };
        DvpgManageWizardPages.$inject = [
            "i18nService",
            "dvpgManageWizardConstants",
            "simpleValidationCommit",
            "dvpgPolicyTypePageValidator",
            "dvpgSelectPortgroupsPageValidator",
            "dvpgVlanPageValidator",
            "dvpgTrafficShapingPolicyService",
            "dvpgFailoverPolicyPageValidator"
        ];
        return DvpgManageWizardPages;
    }());
    dvs_ui.DvpgManageWizardPages = DvpgManageWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgManageWizardPages", DvpgManageWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgConfigSpec = com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroup$ConfigSpec;
    var VmwarePortConfigPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy;
    var StringPolicy = com.vmware.vim.binding.vim.StringPolicy;
    var DvpgManageWizardService = (function () {
        function DvpgManageWizardService($rootScope, i18nService, vuiWizardService, wizardValidationService, dvpgManageWizardFlowManager, dvpgManageWizardPages, dvpgSpecFactory, dvpgManageWizardConstants, networkUiConstants, dataService, mutationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.wizardValidationService = wizardValidationService;
            this.dvpgManageWizardFlowManager = dvpgManageWizardFlowManager;
            this.dvpgManageWizardPages = dvpgManageWizardPages;
            this.dvpgSpecFactory = dvpgSpecFactory;
            this.dvpgManageWizardConstants = dvpgManageWizardConstants;
            this.networkUiConstants = networkUiConstants;
            this.dataService = dataService;
            this.mutationService = mutationService;
        }
        /**
         * Shows the Manage distributed port groups wizard.
         */
        DvpgManageWizardService.prototype.show = function (dvsMor) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.flags = this.buildWizardFlags();
            wizardScope.model = this.buildWizardModel(dvsMor);
            wizardScope.wizardConfig = new dvs_ui.WizardConfig();
            wizardScope.wizardConfig.title =
                this.i18nService.getString("DvsUi", "dvpg.manage.initialTitle");
            wizardScope.wizardConfig.loading = true;
            wizardScope.wizardConfig.loadingMessage = this.i18nService.getString("CommonUi", "wizard.loading");
            wizardScope.wizardConfig.cssClass = "dvpg-manage-wizard";
            wizardScope.wizardConfig.onFinish = function () {
                _this.submitData(wizardScope);
                return true;
            };
            wizardScope.wizardConfig.pages =
                this.dvpgManageWizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.dvpgManageWizardFlowManager.init(wizardScope);
            this.retrieveData(dvsMor, wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        DvpgManageWizardService.prototype.retrieveData = function (dvsMor, wizardScope) {
            var _this = this;
            var promise = this.dataService.getProperties(dvsMor, [this.dvpgManageWizardConstants.properties.WIZARD_DATA]);
            promise.then(function (data) {
                var result = data[_this.dvpgManageWizardConstants.properties.WIZARD_DATA];
                wizardScope.model.dvsName = result.dvsName;
                wizardScope.wizardConfig.title = _this.i18nService.getString("DvsUi", "dvpg.manage.titleFormat", wizardScope.model.dvsName);
                wizardScope.wizardConfig.loading = false;
            });
        };
        DvpgManageWizardService.prototype.submitData = function (wizardScope) {
            var _this = this;
            var specs = [];
            wizardScope.model.selectedPortgroups.forEach(function (portgroup) {
                var spec = _this.buildDvpgConfigSpec(portgroup, wizardScope.model);
                var specPair = {
                    entity: portgroup.id,
                    spec: spec
                };
                specs.push(specPair);
            });
            this.mutationService.applyMulti(specs[0].spec._type, specs);
        };
        DvpgManageWizardService.prototype.buildWizardModel = function (parentId) {
            var model = new dvs_ui.DvpgManageWizardModel();
            model.parentId = parentId;
            model.policies = new dvs_ui.DvpgManagePolicyModel();
            model.policies.isFailoverPolicySelected = false;
            model.policies.isResAllocPolicySelected = false;
            model.policies.isTrafficShapingPolicySelected = false;
            model.policies.isTrafficFilterPolicySelected = false;
            model.policies.isVlanPolicySelected = false;
            model.policies.isMiscPolicySelected = false;
            model.policies.isMonitoringPolicySelected = false;
            model.policies.isSecurityPolicySelected = false;
            return model;
        };
        DvpgManageWizardService.prototype.buildWizardFlags = function () {
            var flags = new dvs_ui.DvpgManageWizardFlags;
            flags.isPolicyTypePageInitialized = false;
            return flags;
        };
        DvpgManageWizardService.prototype.buildDvpgConfigSpec = function (portgroup, model) {
            var configSpec = new DvpgConfigSpec();
            var configVersionProp = this.networkUiConstants.ManageDvpgWizard.DVPG_CONFIG_VERSION_PROP;
            configSpec.configVersion = portgroup.rawData[configVersionProp];
            var defaultPortConfig = new VmwarePortConfigPolicy();
            configSpec.defaultPortConfig = defaultPortConfig;
            if (model.policies.isVlanPolicySelected) {
                defaultPortConfig.vlan =
                    this.dvpgSpecFactory.buildVlanSpec(model.vlanPolicyModel);
            }
            if (model.policies.isTrafficShapingPolicySelected) {
                defaultPortConfig.inShapingPolicy = this.dvpgSpecFactory
                    .buildTrafficShapingSpec(model.trafficShapingPolicyModel.inShapingPolicy);
                defaultPortConfig.outShapingPolicy = this.dvpgSpecFactory
                    .buildTrafficShapingSpec(model.trafficShapingPolicyModel.outShapingPolicy);
            }
            if (model.policies.isSecurityPolicySelected) {
                defaultPortConfig.securityPolicy = this.dvpgSpecFactory
                    .buildSecurityPolicySpec(model.securityPolicyModel);
            }
            if (model.policies.isFailoverPolicySelected) {
                defaultPortConfig.uplinkTeamingPolicy = this.dvpgSpecFactory
                    .buildTeamingAndFailoverSpec(model.failoverPolicyModel);
            }
            if (model.policies.isMonitoringPolicySelected) {
                defaultPortConfig.ipfixEnabled = this.dvpgSpecFactory
                    .buildMonitoringSpec(model.monitoringPolicyModel);
            }
            if (model.policies.isMiscPolicySelected) {
                defaultPortConfig.blocked = this.dvpgSpecFactory
                    .buildMiscSpec(model.miscPolicyModel);
            }
            if (model.policies.isResAllocPolicySelected) {
                var policy = this.dvpgSpecFactory
                    .buildResourcePoolAllocationSpec(model.resourceAllocationPolicyModel);
                if (policy instanceof StringPolicy) {
                    configSpec.defaultPortConfig.networkResourcePoolKey = policy;
                }
                else {
                    configSpec.vmVnicNetworkResourcePoolKey = policy;
                }
            }
            return configSpec;
        };
        DvpgManageWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "wizardValidationService",
            "dvpgManageWizardFlowManager",
            "dvpgManageWizardPages",
            "dvpgSpecFactory",
            "dvpgManageWizardConstants",
            "networkUiConstants",
            "dataService",
            "mutationService"];
        return DvpgManageWizardService;
    }());
    dvs_ui.DvpgManageWizardService = DvpgManageWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgManageWizardService", DvpgManageWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgManagePolicyModel = (function () {
        function DvpgManagePolicyModel() {
        }
        return DvpgManagePolicyModel;
    }());
    dvs_ui.DvpgManagePolicyModel = DvpgManagePolicyModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgManageWizardFlags = (function () {
        function DvpgManageWizardFlags() {
        }
        return DvpgManageWizardFlags;
    }());
    dvs_ui.DvpgManageWizardFlags = DvpgManageWizardFlags;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var DvpgSecurityPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgSecurityPolicyModel;
var DvpgFailoverPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgFailoverPolicyModel;
var DvpgResourceAllocationPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgResourceAllocationPolicyModel;
var DvpgTrafficShapingPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgTrafficShapingPolicyModel;
var DvpgVlanPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgVlanPolicyModel;
var DvpgMonitoringPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgMonitoringPolicyModel;
var DvpgMiscPolicyModel = com.vmware.vsphere.client.h5.network.dvportgroup.common.model.DvpgMiscPolicyModel;
var dvs_ui;
(function (dvs_ui) {
    var DvpgManageWizardModel = (function () {
        function DvpgManageWizardModel() {
        }
        return DvpgManageWizardModel;
    }());
    dvs_ui.DvpgManageWizardModel = DvpgManageWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgFailoverPolicyPageValidator = (function () {
        function DvpgFailoverPolicyPageValidator(i18nService, $q, dvpgFailoverPolicyPageService) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
        }
        DvpgFailoverPolicyPageValidator.prototype.getValidationError = function (wizardScope) {
            if (this.dvpgFailoverPolicyPageService.shouldShowErrorWarningDialog(wizardScope.model.failoverOrderOptions.connectees, wizardScope.model.failoverPolicyModel.loadBalancing, wizardScope.model.failoverPolicyModel.beaconProbing)) {
                return this.dvpgFailoverPolicyPageService.showErrorWarningDialog(wizardScope.model.failoverOrderOptions.connectees, wizardScope.model.failoverPolicyModel.loadBalancing, wizardScope.model.failoverPolicyModel.beaconProbing);
            }
            else {
                return this.$q.resolve(true);
            }
        };
        DvpgFailoverPolicyPageValidator.$inject = [
            "i18nService",
            "$q",
            "dvpgFailoverPolicyPageService"];
        return DvpgFailoverPolicyPageValidator;
    }());
    dvs_ui.DvpgFailoverPolicyPageValidator = DvpgFailoverPolicyPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgFailoverPolicyPageValidator", DvpgFailoverPolicyPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgPolicyTypePageValidator = (function () {
        function DvpgPolicyTypePageValidator(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
        }
        DvpgPolicyTypePageValidator.prototype.getValidationError = function (wizardScope) {
            var errors = [];
            if (!wizardScope.model.policies.isSecurityPolicySelected &&
                !wizardScope.model.policies.isVlanPolicySelected &&
                !wizardScope.model.policies.isTrafficShapingPolicySelected &&
                !wizardScope.model.policies.isTrafficFilterPolicySelected &&
                !wizardScope.model.policies.isMonitoringPolicySelected &&
                !wizardScope.model.policies.isMiscPolicySelected &&
                !wizardScope.model.policies.isResAllocPolicySelected &&
                !wizardScope.model.policies.isFailoverPolicySelected) {
                errors.push(this.i18nService.getString("DvsUi", "dvpg.manage.policyType.noPoliciesSelected"));
            }
            return this.$q.resolve(errors);
        };
        DvpgPolicyTypePageValidator.$inject = [
            "i18nService",
            "$q"];
        return DvpgPolicyTypePageValidator;
    }());
    dvs_ui.DvpgPolicyTypePageValidator = DvpgPolicyTypePageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgPolicyTypePageValidator", DvpgPolicyTypePageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgSelectPortgroupsPageValidator = (function () {
        function DvpgSelectPortgroupsPageValidator(i18nService, dvpgManageWizardConstants, authorizationService, $q) {
            this.i18nService = i18nService;
            this.dvpgManageWizardConstants = dvpgManageWizardConstants;
            this.authorizationService = authorizationService;
            this.$q = $q;
            this.dvpgEditPrivilege =
                this.dvpgManageWizardConstants.privileges.DVPORTGROUP_MODIFY;
        }
        DvpgSelectPortgroupsPageValidator.prototype.getValidationError = function (model) {
            var errors = [];
            if (!model.selectedPortgroups || model.selectedPortgroups.length === 0) {
                errors.push(this.i18nService.getString("DvsUi", "dvpg.manage.portGroupList.noPortGroupsSelected"));
                return this.$q.when(errors);
            }
            else {
                return this.getNoPrivilegesValidationError(model);
            }
        };
        DvpgSelectPortgroupsPageValidator.prototype.getNoPrivilegesValidationError = function (model) {
            var _this = this;
            var dvPortgroupIds = _.map(model.selectedPortgroups, function (pg) {
                return pg.id;
            });
            return this.authorizationService
                .checkPrivilegesForMultipleObjects(dvPortgroupIds, [this.dvpgEditPrivilege])
                .then(function (result) {
                return _this.buildNoPrivilegesValidationMessages(result, model.selectedPortgroups);
            });
        };
        DvpgSelectPortgroupsPageValidator.prototype.buildNoPrivilegesValidationMessages = function (privilegesById, selectedPortgroups) {
            var _this = this;
            var validationMessages = [];
            // Collect the portgroups that do not have edit privilege granted.
            Object.keys(privilegesById).forEach(function (id) {
                if (privilegesById[id][_this.dvpgEditPrivilege] === false) {
                    var portgroupName = _this.getPortgroupName(id, selectedPortgroups);
                    if (portgroupName) {
                        validationMessages.push(_this.i18nService.getString("DvsUi", "dvpg.manage.portGroupList.noPrivilegesFormat", portgroupName));
                    }
                }
            });
            return validationMessages;
        };
        DvpgSelectPortgroupsPageValidator.prototype.getPortgroupName = function (id, portgroups) {
            for (var i = 0; i < portgroups.length; i++) {
                if (id === portgroups[i].id) {
                    return portgroups[i].name;
                }
            }
            return null;
        };
        DvpgSelectPortgroupsPageValidator.$inject = ["i18nService",
            "dvpgManageWizardConstants",
            "authorizationService",
            "$q"];
        return DvpgSelectPortgroupsPageValidator;
    }());
    dvs_ui.DvpgSelectPortgroupsPageValidator = DvpgSelectPortgroupsPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgSelectPortgroupsPageValidator", DvpgSelectPortgroupsPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgVlanPageValidator = (function () {
        function DvpgVlanPageValidator($q, i18nService, networkUiConstants, dvpgPropertiesService, dvPortgroupVlanPageService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            this.dvPortgroupVlanPageService = dvPortgroupVlanPageService;
        }
        DvpgVlanPageValidator.prototype.getValidationError = function (dvPortgroupId, vlanPageModel) {
            var _this = this;
            var errors = [];
            switch (vlanPageModel.vlanType) {
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    var vlanIdError = this.dvpgPropertiesService.getVlanIdError(vlanPageModel.vlanId);
                    if (vlanIdError) {
                        return this.$q.resolve([vlanIdError]);
                    }
                    break;
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    return this.dvPortgroupVlanPageService.getTrunkVlanRanges(dvPortgroupId, vlanPageModel.vlanTrunkRanges).then(function (numericRanges) {
                        if (!numericRanges) {
                            var vlanRangesError = _this.i18nService.getString('DvsUi', 'dvpg.policy.vlan.trunk.errorMessage');
                            return [vlanRangesError];
                        }
                        vlanPageModel.vlanTrunkNumericRanges = numericRanges;
                        return _this.$q.resolve(errors);
                    });
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    if (!vlanPageModel.pvlanConfig ||
                        vlanPageModel.pvlanConfig.length === 0) {
                        var pvlanError = this.i18nService.getString('DvsUi', 'dvpg.policy.vlan.private.noConfig');
                        return this.$q.resolve([pvlanError]);
                    }
                    break;
                }
            }
            return this.$q.resolve(errors);
        };
        DvpgVlanPageValidator.$inject = [
            "$q",
            "i18nService",
            "networkUiConstants",
            "dvpgPropertiesService",
            "dvPortgroupVlanPageService"];
        return DvpgVlanPageValidator;
    }());
    dvs_ui.DvpgVlanPageValidator = DvpgVlanPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgVlanPageValidator", DvpgVlanPageValidator);
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvpgPolicyTypePageComponent = (function () {
        function DvpgPolicyTypePageComponent() {
            this.bindings = {
                wizardModel: "<",
                wizardFlags: "<",
                wizardConfig: "<"
            };
            this.controller = DvpgPolicyTypePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/manage/views/" +
                "dvpgPolicyTypePageTemplate.html";
        }
        return DvpgPolicyTypePageComponent;
    }());
    dvs_ui.DvpgPolicyTypePageComponent = DvpgPolicyTypePageComponent;
    var DvpgPolicyTypePageComponentController = (function () {
        function DvpgPolicyTypePageComponentController(i18nService, $scope, dataService, wizardConstants, dvpgFailoverPolicyPageService) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.dataService = dataService;
            this.wizardConstants = wizardConstants;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
            this.i18n = this.i18nService.getString;
            if (!this.wizardFlags.isPolicyTypePageInitialized) {
                this.wizardConfig.loading = true;
                this.requestPolicyAvailabilityData();
            }
            else {
                this.buildSignpostItems();
            }
        }
        DvpgPolicyTypePageComponentController.prototype.requestPolicyAvailabilityData = function () {
            var _this = this;
            this.dataService.getProperties(this.wizardModel.parentId, [this.wizardConstants.properties.POLICY_DATA])
                .then(function (response) {
                var policyData = response[_this.wizardConstants.properties.POLICY_DATA];
                _this.wizardModel.policies.availability = policyData.policyTypeModel;
                _this.wizardModel.securityPolicyModel = policyData.securityPolicyModel;
                _this.wizardModel.failoverPolicyModel = policyData.failoverPolicyModel;
                _this.wizardModel.failoverOrderOptions =
                    _this.dvpgFailoverPolicyPageService.createFailoverOrderSettings(_this.wizardModel.failoverPolicyModel.failoverOrder);
                _this.wizardModel.resourceAllocationPolicyModel =
                    policyData.resourceAllocationPolicyModel;
                _this.wizardModel.trafficShapingPolicyModel =
                    policyData.trafficShapingPolicyModel;
                _this.wizardModel.vlanPolicyModel = policyData.vlanPolicyModel;
                _this.wizardModel.monitoringPolicyModel =
                    policyData.monitoringPolicyModel;
                _this.wizardModel.miscPolicyModel = policyData.miscPolicyModel;
                _this.buildSignpostItems();
                _this.wizardConfig.loading = false;
                _this.wizardFlags.isPolicyTypePageInitialized = true;
            });
        };
        DvpgPolicyTypePageComponentController.prototype.buildSignpostItem = function (title, description, id) {
            var titleTemplate = "<b>%title%</b><br/>"
                .replace("%title%", title);
            var descriptionTemplate = "<div class='horizontal-flex-container'>" +
                "<span class='dvpg-manage-policy-type-description-item'>%description%</span><br/></div>"
                    .replace("%description%", description);
            var content = titleTemplate + descriptionTemplate;
            var sectionTemplate = "<div data-test-id='dvpg-manage-policy-type-%id%'>%content%<br/></div>"
                .replace("%content%", content).replace("%id%", id);
            return sectionTemplate;
        };
        DvpgPolicyTypePageComponentController.prototype.buildSignpostItems = function () {
            var signpostMessage = "";
            if (this.wizardModel.policies.availability.isSecurityPolicyAvailable) {
                signpostMessage = this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.security.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.security.description'), "security");
            }
            signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.shaping.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.shaping.description'), "traffic-shaping");
            if (this.wizardModel.policies.availability.isVlanPolicyAvailable) {
                signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.vlan.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.vlan.description'), "vlan");
            }
            if (this.wizardModel.policies.availability.isFailoverPolicyAvailable) {
                signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.failover.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.failover.description'), "failover");
            }
            if (this.wizardModel.policies.availability.isResAllocPolicyAvailable) {
                signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.resourceAllocation.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.resourceAllocation.description'), "resource-allocation");
            }
            if (this.wizardModel.policies.availability.isMonitoringPolicyAvailable) {
                signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.monitoring.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.monitoring.description'), "monitoring");
            }
            if (this.wizardModel.policies.availability.isTrafficFilterPolicyAvailable) {
                signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.trafficFilter.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.trafficFilter.description'), "traffic-filter");
            }
            signpostMessage += this.buildSignpostItem(this.i18nService.getString('DvsUi', 'dvpg.manage.policy.misc.title'), this.i18nService.getString('DvsUi', 'dvpg.manage.policy.misc.description'), "misc");
            this.signPostConfig = {
                message: "<div class='dvpg-manage-policy-type-content'>%content%</div>"
                    .replace("%content%", signpostMessage),
                title: this.i18nService.getString("DvsUi", "dvpg.manage.policyType.signpost.title")
            };
        };
        DvpgPolicyTypePageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dataService",
            "dvpgManageWizardConstants",
            "dvpgFailoverPolicyPageService"
        ];
        return DvpgPolicyTypePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgPolicyTypePage", new DvpgPolicyTypePageComponent());
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvpgReadyToCompletePageComponent = (function () {
        function DvpgReadyToCompletePageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvpgReadyToCompletePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/manage/views/" +
                "dvpgReadyToCompletePageTemplate.html";
        }
        return DvpgReadyToCompletePageComponent;
    }());
    dvs_ui.DvpgReadyToCompletePageComponent = DvpgReadyToCompletePageComponent;
    var DvpgReadyToCompletePageComponentController = (function () {
        function DvpgReadyToCompletePageComponentController(i18nService, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.buildPropertyView();
        }
        DvpgReadyToCompletePageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            var updatedPoliciesSection = generalCategory.section("updatedPoliciesSection")
                .title(this.i18nService.getString("DvsUi", "dvpg.manage.summary.policiesToUpdate"));
            generalSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.summary.portGroupCount"), this.wizardModel.selectedPortgroups.length);
            // Security policy
            if (this.wizardModel.policies.isSecurityPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.security.title"));
            }
            // Traffic shaping policy
            if (this.wizardModel.policies.isTrafficShapingPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.shaping.title"));
            }
            // VLAN policy
            if (this.wizardModel.policies.isVlanPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.vlan.title"));
            }
            // Failover policy
            if (this.wizardModel.policies.isFailoverPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.failover.title"));
            }
            // Resource allocation policy
            if (this.wizardModel.policies.isResAllocPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.resourceAllocation.title"));
            }
            // Monitoring policy
            if (this.wizardModel.policies.isMonitoringPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.monitoring.title"));
            }
            // Traffic filtering policy
            if (this.wizardModel.policies.isTrafficFilterPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.trafficFilter.title"));
            }
            // Miscellaneous policy
            if (this.wizardModel.policies.isMiscPolicySelected) {
                updatedPoliciesSection.property(this.i18nService.getString("DvsUi", "dvpg.manage.policy.misc.title"));
            }
            this.propertyViewData = builder.build();
        };
        DvpgReadyToCompletePageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService"
        ];
        return DvpgReadyToCompletePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgReadyToCompletePage", new DvpgReadyToCompletePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgResourceAllocationPageComponent = (function () {
        function DvpgResourceAllocationPageComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = DvpgResourceAllocationPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/manage/views/" +
                "dvpgResourceAllocationPageTemplate.html";
        }
        return DvpgResourceAllocationPageComponent;
    }());
    dvs_ui.DvpgResourceAllocationPageComponent = DvpgResourceAllocationPageComponent;
    var DvpgResourceAllocationPageComponentController = (function () {
        function DvpgResourceAllocationPageComponentController(i18nService) {
            this.i18nService = i18nService;
        }
        DvpgResourceAllocationPageComponentController.$inject = ["i18nService"];
        return DvpgResourceAllocationPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvpgResourceAllocationPage", new DvpgResourceAllocationPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgSelectPortgroupsPageComponent = (function () {
        function DvpgSelectPortgroupsPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvpgSelectPortgroupsPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/manage/views/" +
                "dvpgSelectPortgroupsPageTemplate.html";
        }
        return DvpgSelectPortgroupsPageComponent;
    }());
    dvs_ui.DvpgSelectPortgroupsPageComponent = DvpgSelectPortgroupsPageComponent;
    var DvpgSelectPortgroupsPageComponentController = (function () {
        function DvpgSelectPortgroupsPageComponentController(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.isInitializing = true;
            this.config = {
                contextObject: this.wizardModel.parentId,
                multipleSelect: true,
                listTabConfig: {
                    label: i18nService
                        .getString("DvsUi", "dvpg.manage.portGroupList.tabs.filter"),
                    listConfig: [{
                            label: "Select distributed portgroups",
                            listViewId: "vsphere.core.dvs.dvpg.manage.list",
                            dataModels: ['DistributedVirtualPortgroup'],
                            filterId: "dvpgObjectsFilter",
                            filterParams: []
                        }]
                },
                selectedObjects: _.map(this.wizardModel.selectedPortgroups, function (portgroup) {
                    return portgroup.id;
                }),
                onSelectionChanged: function (newSelectedItems) {
                    // Avoid wizardModel.selectedPortgroups reassignment when the component
                    // is being initialized with a non-empty array of selected portgroups.
                    // This occurs in a wizard context, when the user has already completed
                    // the current page and comes back to the same page later.
                    // In this case the wizardModel.selectedPortgroups reassignment must be
                    // skipped until the previous selection is fully restored,
                    // because otherwise it would mark the page as INCOMPLETE.
                    //
                    // Do not skip the wizardModel.selectedPortgroups reassignment when
                    // the #onSelectionChanged method is triggered by a user's click (isInitializing = false).
                    if (!_this.isInitializing || _.isEmpty(_this.wizardModel.selectedPortgroups)) {
                        _this.isInitializing = false;
                        _this.wizardModel.selectedPortgroups = newSelectedItems;
                    }
                    else if (newSelectedItems.length ===
                        _this.wizardModel.selectedPortgroups.length) {
                        _this.isInitializing = false;
                    }
                }
            };
        }
        DvpgSelectPortgroupsPageComponentController.$inject = ["i18nService"];
        return DvpgSelectPortgroupsPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgSelectPortgroupsPage", new DvpgSelectPortgroupsPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.dvs').controller(
         'DvPortrgroupPoliciesViewController', DvPortrgroupPoliciesViewController);

   DvPortrgroupPoliciesViewController.$inject = [
         '$scope',
         'dataService',
         'distributedPortgroupPoliciesViewService',
         'i18nService'];

   function DvPortrgroupPoliciesViewController(
         $scope,
         dataService,
         distributedPortgroupPoliciesViewService,
         i18nService) {
      var self = this;
      self.dvPortgroupId = $scope._route.objectId;
      var dvPortgroupPolicies = 'dvpg:dvPortgroupPolicies';

      var headerOptions = {
         title: i18nService.getString(
               'NetworkUi', 'dvpg.manage.settings.policiesHeader'),
         objectId: self.dvPortgroupId,
         actions: [
            {
               actionUid: 'vsphere.core.dvPortgroup.editSettingsAction',
               customLabel: i18nService.getString(
                     'H5NetworkUi', 'dvpg.properties.actions.edit.label')
            }]
      };
      self.settingsViewHeaderAccessor = {};
      self.headerOptions = headerOptions;

      self.refresh = function() {
         self.loading = true;

         if (self.settingsViewHeaderAccessor && self.settingsViewHeaderAccessor.refresh) {
            self.settingsViewHeaderAccessor.refresh();
         }

         dataService.getProperties(self.dvPortgroupId, [dvPortgroupPolicies])
               .then(function(response) {
                  self.loading = false;
                  if (response) {
                     if (response[dvPortgroupPolicies]) {
                        buildPolicies(response[dvPortgroupPolicies]);
                     }
                  }
               });

         self.liveRefreshProperties = [
            "config.defaultPortConfig.vlan",
            "config.defaultPortConfig.vlan.vlanId",
            "config.defaultPortConfig.vlan.pvlanId",
            "config.defaultPortConfig.uplinkTeamingPolicy.failureCriteria.checkBeacon.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.policy.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.notifySwitches.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.rollingOrder.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.uplinkPortOrder.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.uplinkPortOrder.activeUplinkPort",
            "config.defaultPortConfig.uplinkTeamingPolicy.uplinkPortOrder.standbyUplinkPort",
            "config.defaultPortConfig.securityPolicy.macChanges.value",
            "config.defaultPortConfig.securityPolicy.forgedTransmits.value",
            "config.defaultPortConfig.securityPolicy.allowPromiscuous.value",
            "config.defaultPortConfig.outShapingPolicy.burstSize.value",
            "config.defaultPortConfig.outShapingPolicy.peakBandwidth.value",
            "config.defaultPortConfig.outShapingPolicy.averageBandwidth.value",
            "config.defaultPortConfig.outShapingPolicy.enabled.value",
            "config.defaultPortConfig.inShapingPolicy.averageBandwidth.value",
            "config.defaultPortConfig.inShapingPolicy.peakBandwidth.value",
            "config.defaultPortConfig.inShapingPolicy.enabled.value",
            "config.defaultPortConfig.inShapingPolicy.burstSize.value",
            "config.defaultPortConfig.blocked.value",
            "config.defaultPortConfig.ipfixEnabled.value"
         ];
      };

      self.refresh();

      function buildPolicies(policiesData) {
         self.dvPortgroupPoliciesData = distributedPortgroupPoliciesViewService.build(policiesData);
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.dvs').controller(
         'DvPortrgroupPropertiesViewController', DvPortrgroupPropertiesViewController);

   DvPortrgroupPropertiesViewController.$inject = ['i18nService', '$scope',
      'dataService', 'dvPortgroupPropertiesService'];

   function DvPortrgroupPropertiesViewController(i18nService, $scope,
         dataService, dvPortgroupPropertiesService) {
      var self = this;
      self.dvPortgroupId = $scope._route.objectId;
      var dvPortgroupProperties = 'dvpg:dvPortgroupProperties';

      var headerOptions = {
         title: i18nService.getString(
               'NetworkUi', 'dvpg.manage.settings.propertiesHeader'),
         objectId: self.dvPortgroupId,
         actions: [
            {
               actionUid: 'vsphere.core.dvPortgroup.editSettingsAction',
               customLabel: i18nService.getString(
                     'H5NetworkUi', 'dvpg.properties.actions.edit.label')
            }]
      };
      self.settingsViewHeaderAccessor = {};
      self.headerOptions = headerOptions;

      self.refresh = function() {
         self.loading = true;

         if (self.settingsViewHeaderAccessor && self.settingsViewHeaderAccessor.refresh) {
            self.settingsViewHeaderAccessor.refresh();
         }

         dataService.getProperties(self.dvPortgroupId, [dvPortgroupProperties])
               .then(function (response) {
                  self.loading = false;
                  if (response && response[dvPortgroupProperties]) {
                     self.dvPortgroupPropertiesData = dvPortgroupPropertiesService.buildProperties(
                           response[dvPortgroupProperties]);
                  }
               });

         self.liveRefreshProperties = [
            "config.name",
            "config.description",
            "config.type",
            "config.numPorts",
            "config.autoExpand",
            "config.vmVnicNetworkResourcePoolKey",
            "config.policy.portConfigResetAtDisconnect",
            "config.policy.securityPolicyOverrideAllowed",
            "config.policy.vlanOverrideAllowed",
            "config.policy.vendorConfigOverrideAllowed",
            "config.policy.uplinkTeamingOverrideAllowed",
            "config.policy.ipfixOverrideAllowed",
            "config.policy.trafficFilterOverrideAllowed",
            "config.policy.blockOverrideAllowed",
            "config.policy.shapingOverrideAllowed"
         ];
      };

      self.refresh();

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgDetailsComponent = (function () {
        function DvpgDetailsComponent() {
            this.bindings = {};
            this.controller = DvpgDetailsController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/summary/components/dvpgDetailsComponentTemplate.html";
        }
        return DvpgDetailsComponent;
    }());
    dvs_ui.DvpgDetailsComponent = DvpgDetailsComponent;
    var DvpgDetailsController = (function () {
        function DvpgDetailsController(i18nService, $rootScope, dataService, defaultUriSchemeUtil, navigation) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.navigation = navigation;
        }
        DvpgDetailsController.prototype.$onInit = function () {
            this.requestData();
        };
        DvpgDetailsController.prototype.refresh = function () {
            this.requestData();
        };
        Object.defineProperty(DvpgDetailsController.prototype, "switchName", {
            get: function () {
                return this._data && this._data.switchName;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "switchIconId", {
            get: function () {
                return this._data && this._data.switchIconId;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "numHosts", {
            get: function () {
                return this._data && this._data.numHosts;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "numVms", {
            get: function () {
                return this._data && this._data.numVms;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "ipPoolName", {
            get: function () {
                return this._data &&
                    (this._data.ipPoolName || this.i18nService.getString("NetworkUi", "NetworkUtil.noData"));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "nrpName", {
            get: function () {
                return this._data &&
                    (this._data.nrpName || this.i18nService.getString("NetworkUi", "NetworkUtil.noData"));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "isUplink", {
            get: function () {
                return this._data && this._data.isUplink;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "showNrpIcon", {
            get: function () {
                return this._data && this._data.nrpName;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "showDvs", {
            get: function () {
                return this._data && this._data.showDvsData;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvpgDetailsController.prototype, "showNrp", {
            get: function () {
                return this._data && this._data.showNrp;
            },
            enumerable: true,
            configurable: true
        });
        DvpgDetailsController.prototype.navigateToDvs = function () {
            var dvsUrn = this.defaultUriSchemeUtil.getVsphereObjectId(this._data.switchMor);
            this.navigation.navigateToViewAndObject(DvpgDetailsController.SERVER_OBJECT_VIEWS_EXTENSION, dvsUrn);
        };
        DvpgDetailsController.prototype.navigateToNrp = function () {
            var nrpUrn = this.defaultUriSchemeUtil.getVsphereObjectId(this._data.nrpMor).replace("vmomi", "nrp");
            var dvsUrn = this.defaultUriSchemeUtil.getVsphereObjectId(this._data.switchMor);
            this.navigation.navigateToRelatedObject(dvsUrn, DvpgDetailsController.NRPS_FOR_DVS_RELATION, nrpUrn);
        };
        DvpgDetailsController.prototype.requestData = function () {
            var self = this;
            this.dvpgUri = this.$rootScope._route.objectId;
            self.loadingData = true;
            self.dataService.getProperties(this.dvpgUri, ["dvpg:dvPortgroupDetails"])
                .then(function (res) {
                self._data = res["dvpg:dvPortgroupDetails"];
                self.loadingData = false;
            });
            self.liveRefreshProperties = [
                "vm", "summary", "host"
            ];
        };
        DvpgDetailsController.$inject = [
            "i18nService",
            "$rootScope",
            "dataService",
            "defaultUriSchemeUtil",
            "navigation"
        ];
        DvpgDetailsController.SERVER_OBJECT_VIEWS_EXTENSION = "vsphere.core.inventory.serverObjectViewsExtension";
        DvpgDetailsController.NRPS_FOR_DVS_RELATION = "nrpsForDvs";
        return DvpgDetailsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgDetails", new DvpgDetailsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgAddTrafficRuleComponent = (function () {
        function DvpgAddTrafficRuleComponent() {
            this.bindings = {
                model: "<",
                onIpValidate: "=",
                onMacValidate: "="
            };
            this.controller = DvpgAddTrafficRuleContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/add/" +
                "dvpgAddTrafficRuleTemplate.html";
        }
        return DvpgAddTrafficRuleComponent;
    }());
    dvs_ui.DvpgAddTrafficRuleComponent = DvpgAddTrafficRuleComponent;
    var DvpgAddTrafficRuleContoller = (function () {
        function DvpgAddTrafficRuleContoller(i18nService, trafficFilterService, trafficFilterConstants, dvpgTrafficRuleValidator, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.trafficFilterService = trafficFilterService;
            this.trafficFilterConstants = trafficFilterConstants;
            this.dvpgTrafficRuleValidator = dvpgTrafficRuleValidator;
            this.vxValidatorFactory = vxValidatorFactory;
            this.i18n = this.i18nService.getString;
            this.directions = this.trafficFilterService.getTrafficFilterDirections();
            this.actions = this.trafficFilterService.getTrafficFilterActions();
            this.qosTagPlaceholderText = this.trafficFilterConstants.tag.MIN_MAX_COS_TAG;
            this.dscpTagPlaceholderText = this.trafficFilterConstants.tag.MIN_MAX_DSCP_TAG;
            this.validateRuleName = this.ruleNameValidator.bind(this);
            this.validateTags = this.tagsValidator.bind(this);
            this.validator = this.vxValidatorFactory.create();
        }
        DvpgAddTrafficRuleContoller.prototype.$onInit = function () {
            this.signPostConfig = {
                message: this.i18n("DvsUi", "trafficFilter.ruleDialog.trafficDirectionInfo"),
                title: this.i18n("DvsUi", "trafficFilter.ruleDialog.trafficDirectionInfo.title"),
                class: "traffic-rule-direction-signpost"
            };
        };
        DvpgAddTrafficRuleContoller.prototype.ruleNameValidator = function () {
            if (!this.dvpgTrafficRuleValidator.isValidRuleName(this.model.name)) {
                return [this.i18n("DvsUi", "trafficFilter.ruleDialog.exceededMaxLength")];
            }
            return [];
        };
        DvpgAddTrafficRuleContoller.prototype.tagsValidator = function () {
            var errors = [];
            if (this.model.qosTagSelected &&
                !this.dvpgTrafficRuleValidator.isValidQosTag(this.model.qosTagValue)) {
                errors.push(this.i18n("DvsUi", "trafficFilter.ruleDialog.invalidQosTag"));
            }
            if (this.model.dscpTagSelected &&
                !this.dvpgTrafficRuleValidator.isValidDscpTag(this.model.dscpTagValue)) {
                errors.push(this.i18n("DvsUi", "trafficFilter.ruleDialog.invalidDscpTag"));
            }
            return errors;
        };
        DvpgAddTrafficRuleContoller.$inject = [
            "i18nService",
            "dvpgTrafficFilterService",
            "dvpgTrafficFilterConstants",
            "dvpgTrafficRuleValidator",
            "vxValidatorFactory"
        ];
        return DvpgAddTrafficRuleContoller;
    }());
    dvs_ui.DvpgAddTrafficRuleContoller = DvpgAddTrafficRuleContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgAddTrafficRule", new DvpgAddTrafficRuleComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCloneTrafficRulesComponent = (function () {
        function DvpgCloneTrafficRulesComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = DvpgCloneTrafficRulesComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/clone/" +
                "dvpgCloneTrafficRulesTemplate.html";
        }
        return DvpgCloneTrafficRulesComponent;
    }());
    dvs_ui.DvpgCloneTrafficRulesComponent = DvpgCloneTrafficRulesComponent;
    var DvpgCloneTrafficRulesComponentController = (function () {
        function DvpgCloneTrafficRulesComponentController(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.selectPortgroupsMessage =
                this.i18nService.getString('DvsUi', 'trafficFilter.cloneRulesDialog.description');
            this.cloneRulesInfoMessage =
                this.i18nService.getString("DvsUi", "trafficFilter.cloneRulesDialog.info", this.model.dvpgName);
            this.portGroupConfig = {
                contextObject: this.model.dvsId,
                multipleSelect: true,
                listTabConfig: {
                    label: i18nService
                        .getString("DvsUi", "dvpg.manage.portGroupList.tabs.filter"),
                    listConfig: [{
                            label: "",
                            listViewId: "vsphere.core.dvs.dvpg.manage.list",
                            dataModels: ['DistributedVirtualPortgroup'],
                            filterId: "dvpgExcludedObjectsFilter",
                            filterParams: [this.model.dvpgId]
                        }]
                },
                selectedObjects: _.map(this.model.selectedPortgroups, function (portgroup) {
                    return portgroup.id;
                }),
                onSelectionChanged: function (newSelectedItems) {
                    _this.model.selectedPortgroups = newSelectedItems;
                }
            };
        }
        DvpgCloneTrafficRulesComponentController.$inject = ["i18nService"];
        return DvpgCloneTrafficRulesComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgCloneTrafficRules", new DvpgCloneTrafficRulesComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCloneTrafficRulesModel = (function () {
        function DvpgCloneTrafficRulesModel() {
        }
        return DvpgCloneTrafficRulesModel;
    }());
    dvs_ui.DvpgCloneTrafficRulesModel = DvpgCloneTrafficRulesModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgIpQualifierComponent = (function () {
        function DvpgIpQualifierComponent() {
            this.bindings = {
                model: "<",
                onValidate: "="
            };
            this.controller = DvpgIpQualifierContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/common/" +
                "dvpgIpQualifierTemplate.html";
        }
        return DvpgIpQualifierComponent;
    }());
    dvs_ui.DvpgIpQualifierComponent = DvpgIpQualifierComponent;
    var DvpgIpQualifierContoller = (function () {
        function DvpgIpQualifierContoller(i18nService, trafficFilterService, trafficFilterConstants, ipQualifierValidator, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.trafficFilterService = trafficFilterService;
            this.trafficFilterConstants = trafficFilterConstants;
            this.ipQualifierValidator = ipQualifierValidator;
            this.vxValidatorFactory = vxValidatorFactory;
            this.showProtocolError = false;
            this.showSourcePortError = false;
            this.showSourcePortEndError = false;
            this.showDestPortError = false;
            this.showDestPortEndError = false;
            this.showSourceIpError = false;
            this.showDestIpError = false;
            this.showSourcePrefixError = false;
            this.showDestPrefixError = false;
            this.showAllErrors = false;
            this.i18n = this.i18nService.getString;
            this.constants = this.trafficFilterConstants;
            this.protocolTypes =
                this.trafficFilterService.getIpQualifierProtocolTypes();
            this.protocolOperations =
                this.trafficFilterService.getQualifiersProtocolOperations();
            this.portOperations =
                this.trafficFilterService.getIpQualifierPortOperations();
            this.ipAddressOperations =
                this.trafficFilterService.getQualifiersAddressOperations();
            this.ipAddressTypes =
                this.trafficFilterService.getIpQualifierIpAddressTypes();
            this.cosTagPlaceholderText = this.trafficFilterConstants.tag.MIN_MAX_COS_TAG;
            this.dscpTagPlaceholderText = this.trafficFilterConstants.tag.MIN_MAX_DSCP_TAG;
            this.protocolValidationFunction = this.validateProtocol.bind(this);
            this.sourcePortValidationFunction = this.validateSourcePort.bind(this);
            this.destPortValidationFunction = this.validateDestPort.bind(this);
            this.sourcePortEndValidationFunction = this.validateSourcePortEnd.bind(this);
            this.destPortEndValidationFunction = this.validateDestPortEnd.bind(this);
            this.sourceIpValidationFunction = this.validateSourceIpAddress.bind(this);
            this.destIpValidationFunction = this.validateDestIpAddress.bind(this);
            this.sourcePrefixValidationFunction =
                this.validateSourcePrefixLength.bind(this);
            this.destPrefixValidationFunction = this.validateDestPrefixLength.bind(this);
            this.initValidators();
            if (this.onValidate) {
                this.onValidate.validate = this.validate.bind(this);
            }
        }
        DvpgIpQualifierContoller.prototype.validate = function () {
            this.showAllErrors = true;
            this.ipProtocolValidator.validate();
            this.sourcePortValidator.validate();
            this.sourcePortEndValidator.validate();
            this.destPortValidator.validate();
            this.destPortEndValidator.validate();
            this.sourceIpValidator.validate();
            this.sourcePrefixLengthValidator.validate();
            this.destIpValidator.validate();
            this.destPrefixLengthValidator.validate();
            this.showAllErrors = false;
        };
        DvpgIpQualifierContoller.prototype.initValidators = function () {
            this.ipProtocolValidator = this.vxValidatorFactory.create();
            this.sourcePortValidator = this.vxValidatorFactory.create();
            this.sourcePortEndValidator = this.vxValidatorFactory.create();
            this.destPortValidator = this.vxValidatorFactory.create();
            this.destPortEndValidator = this.vxValidatorFactory.create();
            this.sourceIpValidator = this.vxValidatorFactory.create();
            this.sourcePrefixLengthValidator = this.vxValidatorFactory.create();
            this.destIpValidator = this.vxValidatorFactory.create();
            this.destPrefixLengthValidator = this.vxValidatorFactory.create();
        };
        DvpgIpQualifierContoller.prototype.onProtocolChanged = function () {
            if (!this.model.protocol.customValue) {
                this.showProtocolError = false;
            }
            this.ipProtocolValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.onProtocolBlur = function () {
            this.showProtocolError = true;
            this.ipProtocolValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateProtocol = function () {
            if (this.showAllErrors || this.showProtocolError) {
                var error = this.ipQualifierValidator.getProtocolError(this.model.protocol);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onSourcePortChanged = function () {
            if (!this.model.sourcePort.port) {
                this.showSourcePortError = false;
            }
            if (!this.model.sourcePort.portRangeEnd) {
                this.showSourcePortEndError = false;
            }
            this.sourcePortValidator.validate();
            this.sourcePortEndValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.onSourcePortBlur = function () {
            this.showSourcePortError = true;
            this.sourcePortValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateSourcePort = function () {
            if (this.showAllErrors || this.showSourcePortError) {
                var error = this.ipQualifierValidator.getPortError(this.model.sourcePort, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onSourcePortEndBlur = function () {
            this.showSourcePortEndError = true;
            this.sourcePortEndValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateSourcePortEnd = function () {
            if (this.showAllErrors || this.showSourcePortEndError) {
                var error = this.ipQualifierValidator.getPortRangeError(this.model.sourcePort, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onDestPortChanged = function () {
            if (!this.model.destinationPort.port) {
                this.showDestPortError = false;
            }
            if (!this.model.destinationPort.portRangeEnd) {
                this.showDestPortEndError = false;
            }
            this.destPortValidator.validate();
            this.destPortEndValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.onDestPortBlur = function () {
            this.showDestPortError = true;
            this.destPortValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateDestPort = function () {
            if (this.showAllErrors || this.showDestPortError) {
                var error = this.ipQualifierValidator.getPortError(this.model.destinationPort, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onDestPortEndBlur = function () {
            this.showDestPortEndError = true;
            this.destPortEndValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateDestPortEnd = function () {
            if (this.showAllErrors || this.showDestPortEndError) {
                var error = this.ipQualifierValidator.getPortRangeError(this.model.destinationPort, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onSourceIpChanged = function () {
            if (!this.model.sourceIpAddress.ipAddress) {
                this.showSourceIpError = false;
            }
            if (!this.model.sourceIpAddress.prefixLength) {
                this.showSourcePrefixError = false;
            }
            this.sourceIpValidator.validate();
            this.sourcePrefixLengthValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.onSourceIpBlur = function () {
            this.showSourceIpError = true;
            this.sourceIpValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateSourceIpAddress = function () {
            if (this.showAllErrors || this.showSourceIpError) {
                var error = this.ipQualifierValidator.getIpAddressError(this.model.sourceIpAddress, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onSourcePrefixLengthBlur = function () {
            this.showSourcePrefixError = true;
            this.sourcePrefixLengthValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateSourcePrefixLength = function () {
            if (this.showAllErrors || this.showSourcePrefixError) {
                var error = this.ipQualifierValidator.getPrefixLengthError(this.model.sourceIpAddress, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onDestIpChanged = function () {
            if (!this.model.destinationIpAddress.ipAddress) {
                this.showDestIpError = false;
            }
            if (!this.model.destinationIpAddress.prefixLength) {
                this.showDestPrefixError = false;
            }
            this.destIpValidator.validate();
            this.destPrefixLengthValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.onDestIpBlur = function () {
            this.showDestIpError = true;
            this.destIpValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateDestIpAddress = function () {
            if (this.showAllErrors || this.showDestIpError) {
                var error = this.ipQualifierValidator.getIpAddressError(this.model.destinationIpAddress, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.prototype.onDestPrefixLengthBlur = function () {
            this.showDestPrefixError = true;
            this.destPrefixLengthValidator.validate();
        };
        DvpgIpQualifierContoller.prototype.validateDestPrefixLength = function () {
            if (this.showAllErrors || this.showDestPrefixError) {
                var error = this.ipQualifierValidator.getPrefixLengthError(this.model.destinationIpAddress, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgIpQualifierContoller.$inject = [
            "i18nService",
            "dvpgTrafficFilterService",
            "dvpgTrafficFilterConstants",
            "dvpgIpQualifierValidator",
            "vxValidatorFactory"
        ];
        return DvpgIpQualifierContoller;
    }());
    dvs_ui.DvpgIpQualifierContoller = DvpgIpQualifierContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgIpQualifier", new DvpgIpQualifierComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgMacQualifierComponent = (function () {
        function DvpgMacQualifierComponent() {
            this.bindings = {
                model: "<",
                onValidate: "="
            };
            this.controller = DvpgMacQualifierContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/common/" +
                "dvpgMacQualifierTemplate.html";
        }
        return DvpgMacQualifierComponent;
    }());
    dvs_ui.DvpgMacQualifierComponent = DvpgMacQualifierComponent;
    var DvpgMacQualifierContoller = (function () {
        function DvpgMacQualifierContoller(i18nService, trafficFilterService, trafficFilterConstants, macQualifierValidator, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.trafficFilterService = trafficFilterService;
            this.trafficFilterConstants = trafficFilterConstants;
            this.macQualifierValidator = macQualifierValidator;
            this.vxValidatorFactory = vxValidatorFactory;
            this.showProtocolError = false;
            this.showVlanError = false;
            this.showSourceMacError = false;
            this.showDestMacError = false;
            this.showSourceWildcardError = false;
            this.showDestWildcardError = false;
            this.showErrors = false;
            this.i18n = this.i18nService.getString;
            this.constants = this.trafficFilterConstants;
            this.protocolTypes =
                this.trafficFilterService.getMacQualifierProtocolTypes();
            this.protocolOperations =
                this.trafficFilterService.getQualifiersProtocolOperations();
            this.vlanOperations =
                this.trafficFilterService.getMacQualifierVlanOperations();
            this.macAddressOperations =
                this.trafficFilterService.getQualifiersAddressOperations();
            this.protocolValidationFunction = this.validateProtocol.bind(this);
            this.vlanIdValidationFunction = this.validateVlan.bind(this);
            this.sourceMacValidationFunction = this.validateSourceMac.bind(this);
            this.destMacValidationFunction = this.validateDestMac.bind(this);
            this.sourceWildcardValidationFunction = this.validateSourceWildcard.bind(this);
            this.destWildcardValidationFunction = this.validateDestWildcard.bind(this);
            this.initValidators();
            if (this.onValidate) {
                this.onValidate.validate = this.validate.bind(this);
            }
        }
        DvpgMacQualifierContoller.prototype.validate = function () {
            this.showErrors = true;
            this.macProtocolValidator.validate();
            this.vlanIdValidator.validate();
            this.sourceMacValidator.validate();
            this.sourceWildcardValidator.validate();
            this.destMacValidator.validate();
            this.destWildcardValidator.validate();
            this.showErrors = false;
        };
        DvpgMacQualifierContoller.prototype.initValidators = function () {
            this.macProtocolValidator = this.vxValidatorFactory.create();
            this.vlanIdValidator = this.vxValidatorFactory.create();
            this.sourceMacValidator = this.vxValidatorFactory.create();
            this.sourceWildcardValidator = this.vxValidatorFactory.create();
            this.destMacValidator = this.vxValidatorFactory.create();
            this.destWildcardValidator = this.vxValidatorFactory.create();
        };
        DvpgMacQualifierContoller.prototype.onProtocolChanged = function () {
            if (!this.model.protocol.customValue) {
                this.showProtocolError = false;
            }
            this.macProtocolValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.onProtocolBlur = function () {
            this.showProtocolError = true;
            this.macProtocolValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateProtocol = function () {
            if (this.showErrors || this.showProtocolError) {
                var error = this.macQualifierValidator.getProtocolError(this.model.protocol);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.prototype.onVlanChanged = function () {
            if (!this.model.vlanId) {
                this.showVlanError = false;
            }
            this.vlanIdValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.onVlanBlur = function () {
            this.showVlanError = true;
            this.vlanIdValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateVlan = function () {
            if (this.showErrors || this.showVlanError) {
                var error = this.macQualifierValidator.getVlanError(this.model.vlanId, this.model.vlanOperation);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.prototype.onSourceMacChanged = function () {
            if (!this.model.sourceMacAddress.macAddress) {
                this.showSourceMacError = false;
            }
            if (!this.model.sourceMacAddress.wildcardMask) {
                this.showSourceWildcardError = false;
            }
            this.sourceMacValidator.validate();
            this.sourceWildcardValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.onSourceMacBlur = function () {
            this.showSourceMacError = true;
            this.sourceMacValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateSourceMac = function () {
            if (this.showErrors || this.showSourceMacError) {
                var error = this.macQualifierValidator.getMacAddressError(this.model.sourceMacAddress, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.prototype.onSourceWildcardBlur = function () {
            this.showSourceWildcardError = true;
            this.sourceWildcardValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateSourceWildcard = function () {
            if (this.showErrors || this.showSourceWildcardError) {
                var error = this.macQualifierValidator.getWildcardMaskError(this.model.sourceMacAddress, true /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.prototype.onDestMacChanged = function () {
            if (!this.model.destinationMacAddress.macAddress) {
                this.showDestMacError = false;
            }
            if (!this.model.destinationMacAddress.wildcardMask) {
                this.showDestWildcardError = false;
            }
            this.destMacValidator.validate();
            this.destWildcardValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.onDestMacBlur = function () {
            this.showDestMacError = true;
            this.destMacValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateDestMac = function () {
            if (this.showErrors || this.showDestMacError) {
                var error = this.macQualifierValidator.getMacAddressError(this.model.destinationMacAddress, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.prototype.onDestWildcardBlur = function () {
            this.showDestWildcardError = true;
            this.destWildcardValidator.validate();
        };
        DvpgMacQualifierContoller.prototype.validateDestWildcard = function () {
            if (this.showErrors || this.showDestWildcardError) {
                var error = this.macQualifierValidator.getWildcardMaskError(this.model.destinationMacAddress, false /*isSource*/);
                return error !== this.trafficFilterConstants.EMPTY ? [error] : [];
            }
            return [];
        };
        DvpgMacQualifierContoller.$inject = [
            "i18nService",
            "dvpgTrafficFilterService",
            "dvpgTrafficFilterConstants",
            "dvpgMacQualifierValidator",
            "vxValidatorFactory"
        ];
        return DvpgMacQualifierContoller;
    }());
    dvs_ui.DvpgMacQualifierContoller = DvpgMacQualifierContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgMacQualifier", new DvpgMacQualifierComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgSystemQualifierComponent = (function () {
        function DvpgSystemQualifierComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = DvpgSystemQualifierContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/common/" +
                "dvpgSystemQualifierTemplate.html";
        }
        return DvpgSystemQualifierComponent;
    }());
    dvs_ui.DvpgSystemQualifierComponent = DvpgSystemQualifierComponent;
    var DvpgSystemQualifierContoller = (function () {
        function DvpgSystemQualifierContoller(i18nService, trafficFilterService) {
            this.i18nService = i18nService;
            this.trafficFilterService = trafficFilterService;
            this.i18n = this.i18nService.getString;
            this.trafficOperations =
                this.trafficFilterService.getSystemQualifierOperations();
            this.trafficTypes =
                this.trafficFilterService.getSystemQualifierTypes();
        }
        DvpgSystemQualifierContoller.$inject = [
            "i18nService",
            "dvpgTrafficFilterService"
        ];
        return DvpgSystemQualifierContoller;
    }());
    dvs_ui.DvpgSystemQualifierContoller = DvpgSystemQualifierContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgSystemQualifier", new DvpgSystemQualifierComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficQualifiersComponent = (function () {
        function DvpgTrafficQualifiersComponent() {
            this.bindings = {
                model: "<",
                onIpValidate: "=",
                onMacValidate: "="
            };
            this.controller = DvpgTrafficQualifiersController;
            this.templateUrl =
                "dvs-ui/resources/dvs/dvpg/trafficfilter/common/" +
                    "dvpgTrafficQualifiersTemplate.html";
        }
        return DvpgTrafficQualifiersComponent;
    }());
    dvs_ui.DvpgTrafficQualifiersComponent = DvpgTrafficQualifiersComponent;
    var DvpgTrafficQualifiersController = (function () {
        function DvpgTrafficQualifiersController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
        }
        DvpgTrafficQualifiersController.$inject = [
            "$scope",
            "i18nService"
        ];
        return DvpgTrafficQualifiersController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgTrafficQualifiers", new DvpgTrafficQualifiersComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficRuleListItem = (function () {
        function DvpgTrafficRuleListItem() {
        }
        return DvpgTrafficRuleListItem;
    }());
    dvs_ui.DvpgTrafficRuleListItem = DvpgTrafficRuleListItem;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvpgTrafficFilterConstants", {
        properties: {
            DVPG_NAME: "name",
            DVPG_DVS: "config/distributedVirtualSwitch",
            TRAFFIC_FILTER_PROPERTY: "dvpg:dvPortgroupTrafficFilter",
            TRAFFIC_RULE_PROPERTY: "trafficRuleModel",
            DVS_PORT_TRAFFIC_FILTER_PROPERTY: "dvsport:portTrafficFilterData",
            DVPG_PORT_TRAFFIC_FILTER_PROPERTY: "dvportgroupport:portTrafficFilterData",
            DVS_PORT_EDIT_TRAFFIC_FILTER_PROPERTY: "dvsport:portEditTrafficRuleData",
            DVPG_PORT_EDIT_TRAFFIC_FILTER_PROPERTY: "dvportgroupport:portEditTrafficRuleData"
        },
        privileges: {
            DVPG_MODIFY: "DVPortgroup.Modify"
        },
        direction: {
            BOTH: "both",
            EGRESS: "incomingPackets",
            INGRESS: "outgoingPackets"
        },
        action: {
            ALLOW: "allow",
            DROP: "drop",
            TAG: "tag"
        },
        tag: {
            MIN_COS_TAG: 0,
            MAX_COS_TAG: 7,
            MIN_DSCP_TAG: 0,
            MAX_DSCP_TAG: 63,
            MIN_MAX_DSCP_TAG: "0 - 63",
            MIN_MAX_COS_TAG: "0 - 7"
        },
        addressType: {
            IPV4: "ipv4",
            IPV6: "ipv6",
            MIXED: "mixed"
        },
        mac: {
            IPV4_PROTOCOL_HEX_VALUE: 0x0800,
            IPV6_PROTOCOL_HEX_VALUE: 0x86DD,
            ARP_PROTOCOL_HEX_VALUE: 0x0806,
            MIN_PROTOCOL_HEX_VALUE: 0x0000,
            MAX_PROTOCOL_HEX_VALUE: 0xFFFF
        },
        vlan: {
            MIN: 0,
            MAX: 4094,
            CUSTOM: -1
        },
        operator: {
            ANY: 0,
            IS: 1,
            IS_NOT: 2,
            IN_RANGE: 3,
            NOT_IN_RANGE: 4,
            MATCHES: 5,
            DOES_NOT_MATCH: 6,
        },
        protocol: {
            ICMP: 1,
            ICMP6: 58,
            TCP: 6,
            UDP: 17,
            CUSTOM: 0
        },
        systemTraffic: {
            FT: "faultTolerance",
            HBR: "hbr",
            ISCSI: "iSCSI",
            MANAGEMENT: "management",
            NFS: "nfs",
            VM: "virtualMachine",
            VMOTION: "vmotion",
            VSAN: "vsan",
            VDP: "vdp"
        },
        spec: {
            DVPG_EDIT_TRAFFIC_RULES_SPEC: "com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditTrafficFilterSpec",
            DVPG_CLONE_TRAFFIC_RULES_SPEC: "com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgCloneTrafficRulesSpec",
            DVPG_ADD_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgAddTrafficRuleSpec",
            DVPG_EDIT_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditTrafficRuleSpec",
            DVPG_REMOVE_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgRemoveTrafficRuleSpec",
            DVS_PORT_EDIT_TRAFFIC_RULES_SPEC: "com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortEditTrafficFilterSpec",
            DVS_PORT_ADD_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortAddTrafficRuleSpec",
            DVS_PORT_EDIT_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortEditTrafficRuleSpec",
            DVS_PORT_REMOVE_TRAFFIC_RULE_SPEC: "com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortRemoveTrafficRuleSpec"
        },
        EMPTY: "",
        SEQUENCE_NUMBER: 10,
        MAX_RULE_NAME_LENGTH: 255,
        MAX_PORT_NUMBER: 65535,
        IPV4_ADDRESS_MAX_PREFIX: 32,
        IPV6_ADDRESS_MAX_PREFIX: 128,
        IP_ADDRESS_MIN_PREFIX: 1,
        MIN_PROTOCOL_VALUE: 0,
        MAX_PROTOCOL_VALUE: 255,
        MIN_PROTOCOL_HEX_VALUE: 0x0000,
        MAX_PROTOCOL_HEX_VALUE: 0xFFFF,
        EMPTY_MAC_ADDRESS: "00:00:00:00:00:00"
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficFilterModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgTrafficFilterModel;
    var DvpgTrafficRuleModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgTrafficRuleModel;
    var DvpgIpQualifierModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgIpQualifierModel;
    var DvpgProtocolModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgProtocolModel;
    var DvpgPortModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgPortModel;
    var DvpgIpAddressModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgIpAddressModel;
    var DvpgMacQualifierModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgMacQualifierModel;
    var DvpgMacAddressModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgMacAddressModel;
    var DvpgSystemQualifierModel = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.model.DvpgSystemQualifierModel;
    var DvpgTrafficFilterService = (function () {
        function DvpgTrafficFilterService(i18nService, clarityConstants, trafficFilterConstants, trafficFilterSpecFactory, dvpgTrafficRuleValidator, dvpgCloneTrafficRulesValidator, clarityModalService, dataService, mutationService, defaultUriSchemeUtil, $q) {
            this.i18nService = i18nService;
            this.clarityConstants = clarityConstants;
            this.trafficFilterConstants = trafficFilterConstants;
            this.trafficFilterSpecFactory = trafficFilterSpecFactory;
            this.dvpgTrafficRuleValidator = dvpgTrafficRuleValidator;
            this.dvpgCloneTrafficRulesValidator = dvpgCloneTrafficRulesValidator;
            this.clarityModalService = clarityModalService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
        }
        DvpgTrafficFilterService.prototype.showEditTrafficFilterDialog = function (dvpgId) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.rulesDialog.title"),
                subTitle: {
                    objectId: dvpgId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/edit/" +
                    "dvpgEditTrafficFilterDialog.html",
                size: "lg",
                modalClass: "edit-traffic-filter-dialog",
                dialogData: {
                    objectId: dvpgId,
                    model: new dvs_ui.DvpgEditTrafficFilterModel()
                },
                onSubmit: function () {
                    var isRulesOrderChanged = _this.isRuleOrderChanged(modalOptions.dialogData.model.rules, modalOptions.dialogData.model.originalRulesKeys);
                    var isRulsetEnabledChanged = modalOptions.dialogData.model.initialTrafficRulesetEnabled !==
                        modalOptions.dialogData.model.isTrafficRulesetEnabled;
                    if (isRulsetEnabledChanged || isRulesOrderChanged) {
                        var dvpgEditTrafficFilterSpec = _this.trafficFilterSpecFactory.buildEditTrafficFilterSpec(modalOptions.dialogData.model, isRulesOrderChanged);
                        _this.mutationService.apply(dvpgId, _this.trafficFilterConstants.spec.DVPG_EDIT_TRAFFIC_RULES_SPEC, dvpgEditTrafficFilterSpec);
                    }
                    return true;
                }
            };
            this.dataService.getProperties(dvpgId, this.trafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY)
                .then(function (response) { return response[_this.trafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY]; })
                .then(function (model) {
                if (model) {
                    modalOptions.dialogData.model.initialTrafficRulesetEnabled =
                        model.isTrafficRulesetEnabled;
                    modalOptions.dialogData.model.isTrafficRulesetEnabled =
                        model.isTrafficRulesetEnabled;
                    modalOptions.dialogData.model.rules = model.rules;
                    modalOptions.dialogData.model.originalRulesKeys =
                        _this.getRulesKeys(model.rules);
                }
                else {
                    modalOptions.dialogData.model.rules = [];
                    modalOptions.dialogData.model.originalRulesKeys = [];
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvpgTrafficFilterService.prototype.showCloneTrafficFilterDialog = function (dvpgId) {
            var _this = this;
            var model = new dvs_ui.DvpgCloneTrafficRulesModel();
            model.dvpgId = dvpgId;
            model.selectedPortgroups = [];
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.cloneRulesDialog.title"),
                subTitle: {
                    objectId: dvpgId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/clone/" +
                    "dvpgCloneTrafficRulesDialog.html",
                size: "lg",
                modalClass: "clone-traffic-filter-dialog",
                dialogData: {
                    objectId: dvpgId,
                    model: model
                },
                onSubmit: function () {
                    return _this.dvpgCloneTrafficRulesValidator.getValidationError(modalOptions.dialogData.model).then(function (errors) {
                        if (_.isArray(errors) && errors.length > 0) {
                            _this.showAllErrors(errors, modalOptions);
                            return false;
                        }
                        else if (!errors) {
                            return false;
                        }
                        var dvpgCloneTrafficRulesSpec = _this.trafficFilterSpecFactory.buildCloneTrafficFilterSpec(modalOptions.dialogData.model);
                        _this.mutationService.apply(dvpgId, _this.trafficFilterConstants.spec.DVPG_CLONE_TRAFFIC_RULES_SPEC, dvpgCloneTrafficRulesSpec);
                        return true;
                    });
                }
            };
            this.dataService.getProperties(dvpgId, [this.trafficFilterConstants.properties.DVPG_NAME,
                this.trafficFilterConstants.properties.DVPG_DVS])
                .then(function (response) {
                modalOptions.dialogData.model.dvsId =
                    _this.defaultUriSchemeUtil.getVsphereObjectId(response[_this.trafficFilterConstants.properties.DVPG_DVS]);
                modalOptions.dialogData.model.dvpgName =
                    response[_this.trafficFilterConstants.properties.DVPG_NAME];
                _this.clarityModalService.openOkCancelModal(modalOptions);
            });
        };
        DvpgTrafficFilterService.prototype.showAddRuleDialog = function (dvpgId) {
            var _this = this;
            var onIpValidate = {};
            var onMacValidate = {};
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.title"),
                subTitle: {
                    objectId: dvpgId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/add/" +
                    "dvpgAddTrafficRuleDialog.html",
                size: "lg",
                modalClass: "add-traffic-rule-dialog",
                dialogData: {
                    availableTargets: [dvpgId],
                    objectId: dvpgId,
                    ipValidator: onIpValidate,
                    macValidator: onMacValidate,
                    newRuleModel: this.initAddTrafficRuleModel(),
                    trafficFiltersModel: new DvpgTrafficFilterModel()
                },
                onSubmit: function () {
                    return _this.dvpgTrafficRuleValidator.getValidationResult(modalOptions.dialogData.newRuleModel).then(function (errors) {
                        modalOptions.dialogData.ipValidator.validate();
                        modalOptions.dialogData.macValidator.validate();
                        if (_.isArray(errors) && errors.length > 0) {
                            _this.showErrors(errors, modalOptions);
                            return false;
                        }
                        else if (!errors) {
                            return false;
                        }
                        var dvpgAddTrafficRuleSpec = _this.trafficFilterSpecFactory.buildAddTrafficRuleSpec(modalOptions.dialogData.newRuleModel);
                        _this.mutationService.apply(dvpgId, _this.trafficFilterConstants.spec.DVPG_ADD_TRAFFIC_RULE_SPEC, dvpgAddTrafficRuleSpec);
                        return true;
                    });
                }
            };
            this.dataService.getProperties(dvpgId, this.trafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY)
                .then(function (response) { return response[_this.trafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY]; })
                .then(function (model) {
                modalOptions.dialogData.trafficFiltersModel = model;
                modalOptions.dialogData.newRuleModel.name =
                    _this.getUniqueRuleName(model.rules);
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvpgTrafficFilterService.prototype.showEditRuleDialog = function (dvpgId, editedRuleKey) {
            var _this = this;
            var onIpValidate = {};
            var onMacValidate = {};
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.editTitle"),
                subTitle: {
                    objectId: dvpgId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/add/" +
                    "dvpgEditTrafficRuleDialog.html",
                size: "lg",
                modalClass: "edit-traffic-rule-dialog",
                dialogData: {
                    availableTargets: [dvpgId],
                    objectId: dvpgId,
                    ipValidator: onIpValidate,
                    macValidator: onMacValidate,
                    editRuleModel: this.initNewTrafficRuleModel()
                },
                onSubmit: function () {
                    return _this.dvpgTrafficRuleValidator.getValidationResult(modalOptions.dialogData.editRuleModel).then(function (errors) {
                        modalOptions.dialogData.ipValidator.validate();
                        modalOptions.dialogData.macValidator.validate();
                        if (_.isArray(errors) && errors.length > 0) {
                            _this.showErrors(errors, modalOptions);
                            return false;
                        }
                        else if (!errors) {
                            return false;
                        }
                        var dvpgEditTrafficRuleSpec = _this.trafficFilterSpecFactory.buildEditTrafficRuleSpec(modalOptions.dialogData.editRuleModel);
                        _this.mutationService.apply(dvpgId, _this.trafficFilterConstants.spec.DVPG_EDIT_TRAFFIC_RULE_SPEC, dvpgEditTrafficRuleSpec);
                        return true;
                    });
                }
            };
            var params = {
                propertyParams: [{
                        propertyName: this.trafficFilterConstants.properties.TRAFFIC_RULE_PROPERTY,
                        parameterType: "java.lang.String",
                        parameter: editedRuleKey
                    }]
            };
            this.dataService.getProperties(dvpgId, [this.trafficFilterConstants.properties.TRAFFIC_RULE_PROPERTY], params)
                .then(function (response) { return response[_this.trafficFilterConstants.properties.TRAFFIC_RULE_PROPERTY]; })
                .then(function (model) {
                var ruleModel = _this.initEditTrafficRuleModel(model);
                modalOptions.title = _this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.editTitleUpdated", ruleModel.name);
                _.extend(ruleModel, { defaultQualifierTabIndex: _this.getDefaultQualifierTabIndex(ruleModel) });
                modalOptions.dialogData.editRuleModel = ruleModel;
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvpgTrafficFilterService.prototype.removeRule = function (dvpgId, ruleKey, ruleName) {
            var _this = this;
            var submitFuncion = function () {
                var dvpgRemoveTrafficRuleSpec = _this.trafficFilterSpecFactory.buildRemoveTrafficRuleSpec(ruleKey);
                _this.mutationService.apply(dvpgId, _this.trafficFilterConstants.spec.DVPG_REMOVE_TRAFFIC_RULE_SPEC, dvpgRemoveTrafficRuleSpec);
            };
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.caption"),
                message: (ruleName && ruleName.trim().length > 0) ?
                    this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.warning", ruleName) :
                    this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.noNameWarning"),
                submit: submitFuncion,
                subTitle: {
                    objectId: dvpgId
                },
                preserveNewlines: true,
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                }
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        DvpgTrafficFilterService.prototype.isRuleOrderChanged = function (modifiedRules, originalRulesKeys) {
            if (!modifiedRules || !originalRulesKeys ||
                modifiedRules.length !== originalRulesKeys.length) {
                return false;
            }
            for (var i = 0; i < modifiedRules.length; i++) {
                if (modifiedRules[i].key !== originalRulesKeys[i]) {
                    return true;
                }
            }
            return false;
        };
        DvpgTrafficFilterService.prototype.getRulesKeys = function (originalRules) {
            var rulesKeys = [];
            if (!originalRules || originalRules.length === 0) {
                return rulesKeys;
            }
            for (var i = 0; i < originalRules.length; i++) {
                rulesKeys.push(originalRules[i].key);
            }
            return rulesKeys;
        };
        DvpgTrafficFilterService.prototype.initAddTrafficRuleModel = function () {
            return this.initNewTrafficRuleModel();
        };
        DvpgTrafficFilterService.prototype.initEditTrafficRuleModel = function (existingRuleModel) {
            if (!existingRuleModel) {
                return this.initNewTrafficRuleModel();
            }
            else {
                if (existingRuleModel.ipQualifierModel === null) {
                    existingRuleModel.ipQualifierModel = this.initIpQualifierModel();
                }
                else {
                    if (existingRuleModel.ipQualifierModel.sourcePort === null) {
                        existingRuleModel.ipQualifierModel.sourcePort = this.initPortModel();
                    }
                    if (existingRuleModel.ipQualifierModel.destinationPort === null) {
                        existingRuleModel.ipQualifierModel.destinationPort =
                            this.initPortModel();
                    }
                }
                if (existingRuleModel.macQualifierModel === null) {
                    existingRuleModel.macQualifierModel = this.initMacQualifierModel();
                }
                if (existingRuleModel.systemQualifierModel === null) {
                    existingRuleModel.systemQualifierModel = this.initSystemQualifierModel();
                }
                return existingRuleModel;
            }
        };
        DvpgTrafficFilterService.prototype.getTrafficFilterActions = function () {
            return [{
                    value: this.trafficFilterConstants.action.ALLOW,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.allow")
                }, {
                    value: this.trafficFilterConstants.action.DROP,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.drop")
                }, {
                    value: this.trafficFilterConstants.action.TAG,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.tag")
                }];
        };
        DvpgTrafficFilterService.prototype.getTrafficFilterDirections = function () {
            return [{
                    value: this.trafficFilterConstants.direction.BOTH,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.direction.ingressEgress")
                }, {
                    value: this.trafficFilterConstants.direction.EGRESS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.direction.egress")
                }, {
                    value: this.trafficFilterConstants.direction.INGRESS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.direction.ingress")
                }];
        };
        DvpgTrafficFilterService.prototype.getQualifiersProtocolOperations = function () {
            return [{
                    value: this.trafficFilterConstants.operator.ANY,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.any")
                }, {
                    value: this.trafficFilterConstants.operator.IS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.is")
                }, {
                    value: this.trafficFilterConstants.operator.IS_NOT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.isNot")
                }];
        };
        DvpgTrafficFilterService.prototype.getIpQualifierProtocolTypes = function () {
            return [{
                    value: this.trafficFilterConstants.protocol.ICMP,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.icmp", this.trafficFilterConstants.protocol.ICMP.toString())
                }, {
                    value: this.trafficFilterConstants.protocol.TCP,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.tcp", this.trafficFilterConstants.protocol.TCP.toString())
                }, {
                    value: this.trafficFilterConstants.protocol.UDP,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.udp", this.trafficFilterConstants.protocol.UDP.toString())
                }, {
                    value: this.trafficFilterConstants.protocol.ICMP6,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.icmp6", this.trafficFilterConstants.protocol.ICMP6.toString())
                }, {
                    value: this.trafficFilterConstants.protocol.CUSTOM,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.custom")
                }];
        };
        DvpgTrafficFilterService.prototype.getMacQualifierProtocolTypes = function () {
            return [{
                    value: this.trafficFilterConstants.mac.IPV4_PROTOCOL_HEX_VALUE,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.mac.ipv4", this.getHexRepresentation(this.trafficFilterConstants.mac.IPV4_PROTOCOL_HEX_VALUE))
                }, {
                    value: this.trafficFilterConstants.mac.IPV6_PROTOCOL_HEX_VALUE,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.mac.ipv6", this.getHexRepresentation(this.trafficFilterConstants.mac.IPV6_PROTOCOL_HEX_VALUE))
                }, {
                    value: this.trafficFilterConstants.mac.ARP_PROTOCOL_HEX_VALUE,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.mac.arp", this.getHexRepresentation(this.trafficFilterConstants.mac.ARP_PROTOCOL_HEX_VALUE))
                }, {
                    value: this.trafficFilterConstants.protocol.CUSTOM,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.protocol.custom")
                }];
        };
        DvpgTrafficFilterService.prototype.getMacQualifierVlanOperations = function () {
            return [{
                    value: this.trafficFilterConstants.operator.ANY,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.any")
                }, {
                    value: this.trafficFilterConstants.operator.IS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.is")
                }, {
                    value: this.trafficFilterConstants.operator.IS_NOT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.isNot")
                }];
        };
        DvpgTrafficFilterService.prototype.getIpQualifierPortOperations = function () {
            return [{
                    value: this.trafficFilterConstants.operator.ANY,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.any")
                }, {
                    value: this.trafficFilterConstants.operator.IS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.is")
                }, {
                    value: this.trafficFilterConstants.operator.IS_NOT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.isNot")
                }, {
                    value: this.trafficFilterConstants.operator.IN_RANGE,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.inRange")
                }, {
                    value: this.trafficFilterConstants.operator.NOT_IN_RANGE,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.notInRange")
                }];
        };
        DvpgTrafficFilterService.prototype.getQualifiersAddressOperations = function () {
            return [{
                    value: this.trafficFilterConstants.operator.ANY,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.any")
                }, {
                    value: this.trafficFilterConstants.operator.IS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.is")
                }, {
                    value: this.trafficFilterConstants.operator.IS_NOT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.isNot")
                }, {
                    value: this.trafficFilterConstants.operator.MATCHES,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.matches")
                }, {
                    value: this.trafficFilterConstants.operator.DOES_NOT_MATCH,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.doesNotMatch")
                }];
        };
        DvpgTrafficFilterService.prototype.getIpQualifierIpAddressTypes = function () {
            return [{
                    value: this.trafficFilterConstants.addressType.IPV4,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.addressType.ipv4")
                }, {
                    value: this.trafficFilterConstants.addressType.IPV6,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.addressType.ipv6")
                }, {
                    value: this.trafficFilterConstants.addressType.MIXED,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.addressType.all")
                }];
        };
        DvpgTrafficFilterService.prototype.getSystemQualifierOperations = function () {
            return [{
                    value: this.trafficFilterConstants.operator.IS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.is")
                }, {
                    value: this.trafficFilterConstants.operator.IS_NOT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.operation.isNot")
                }];
        };
        DvpgTrafficFilterService.prototype.getSystemQualifierTypes = function () {
            return [{
                    value: this.trafficFilterConstants.systemTraffic.FT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.faultTolerance")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.HBR,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.hbr")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.ISCSI,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.iscsi")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.MANAGEMENT,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.management")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.NFS,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.nfs")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.VM,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.vm")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.VMOTION,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.vMotion")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.VSAN,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.vsan")
                }, {
                    value: this.trafficFilterConstants.systemTraffic.VDP,
                    label: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.vdp")
                }];
        };
        DvpgTrafficFilterService.prototype.getUniqueRuleName = function (trafficFilterRules) {
            var count = 1;
            var uniqueRuleName = this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.defaultName", count.toString());
            if (!trafficFilterRules || trafficFilterRules.length === 0) {
                return uniqueRuleName;
            }
            var trafficRuleNames = trafficFilterRules.map(function (rule) {
                return rule.name;
            });
            while (trafficRuleNames.indexOf(uniqueRuleName) !== -1) {
                count++;
                uniqueRuleName = this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.defaultName", count.toString());
            }
            return uniqueRuleName;
        };
        DvpgTrafficFilterService.prototype.getHexRepresentation = function (value) {
            if (!value || isNaN(value)) {
                return "";
            }
            var hexValue = value.toString(16).toUpperCase();
            while (hexValue.length < 4) {
                hexValue = '0' + hexValue;
            }
            return hexValue;
        };
        DvpgTrafficFilterService.prototype.initNewTrafficRuleModel = function () {
            var model = new DvpgTrafficRuleModel();
            model.action = this.trafficFilterConstants.action.TAG;
            model.direction = this.trafficFilterConstants.direction.BOTH;
            model.ipQualifierModel = this.initIpQualifierModel();
            model.macQualifierModel = this.initMacQualifierModel();
            model.systemQualifierModel = this.initSystemQualifierModel();
            return model;
        };
        DvpgTrafficFilterService.prototype.areRulesChanged = function (oldRules, newRules) {
            if (!oldRules || !newRules || oldRules.length !== newRules.length) {
                return true;
            }
            for (var i = 0; i < newRules.length; i++) {
                if (this.isRuleChanged(oldRules[i], newRules[i])) {
                    return true;
                }
            }
            return false;
        };
        DvpgTrafficFilterService.prototype.isRuleChanged = function (oldRule, newRule) {
            if (!oldRule || !newRule ||
                oldRule.key !== newRule.key ||
                oldRule.sequence !== newRule.sequence ||
                oldRule.displaySequence !== newRule.displaySequence ||
                oldRule.action !== newRule.action ||
                oldRule.name !== newRule.name ||
                oldRule.direction !== newRule.direction) {
                return true;
            }
            if (!newRule.qualifiers || !oldRule.qualifiers ||
                newRule.qualifiers.length !== oldRule.qualifiers.length) {
                return true;
            }
            for (var i = 0; i < newRule.qualifiers.length; i++) {
                if (oldRule.qualifiers[i] !== newRule.qualifiers[i]) {
                    return true;
                }
            }
            return false;
        };
        DvpgTrafficFilterService.prototype.initPortModel = function () {
            var portModel = new DvpgPortModel();
            portModel.operation = this.trafficFilterConstants.operator.ANY;
            return portModel;
        };
        DvpgTrafficFilterService.prototype.initIpAddressModel = function () {
            var ipAddressModel = new DvpgIpAddressModel();
            ipAddressModel.operation = this.trafficFilterConstants.operator.ANY;
            ipAddressModel.ipAddressType = this.trafficFilterConstants.addressType.MIXED;
            return ipAddressModel;
        };
        DvpgTrafficFilterService.prototype.initIpProtocolModel = function () {
            var ipProtocolModel = new DvpgProtocolModel();
            ipProtocolModel.operation = this.trafficFilterConstants.operator.IS;
            ipProtocolModel.type = this.trafficFilterConstants.protocol.TCP;
            return ipProtocolModel;
        };
        DvpgTrafficFilterService.prototype.initMacProtocolModel = function () {
            var macProtocolModel = new DvpgProtocolModel();
            macProtocolModel.operation =
                this.trafficFilterConstants.operator.ANY;
            macProtocolModel.type = this.trafficFilterConstants.mac.IPV4_PROTOCOL_HEX_VALUE;
            return macProtocolModel;
        };
        DvpgTrafficFilterService.prototype.initMacAddressModel = function () {
            var macAddressModel = new DvpgMacAddressModel();
            macAddressModel.operation = this.trafficFilterConstants.operator.ANY;
            return macAddressModel;
        };
        DvpgTrafficFilterService.prototype.initIpQualifierModel = function () {
            var model = new DvpgIpQualifierModel();
            model.protocol = this.initIpProtocolModel();
            model.sourcePort = this.initPortModel();
            model.destinationPort = this.initPortModel();
            model.sourceIpAddress = this.initIpAddressModel();
            model.destinationIpAddress = this.initIpAddressModel();
            return model;
        };
        DvpgTrafficFilterService.prototype.initMacQualifierModel = function () {
            var model = new DvpgMacQualifierModel();
            model.protocol = this.initMacProtocolModel();
            model.vlanOperation = this.trafficFilterConstants.operator.ANY;
            model.sourceMacAddress = this.initMacAddressModel();
            model.destinationMacAddress = this.initMacAddressModel();
            return model;
        };
        DvpgTrafficFilterService.prototype.initSystemQualifierModel = function () {
            var model = new DvpgSystemQualifierModel();
            model.trafficOperation = this.trafficFilterConstants.operator.IS;
            model.trafficType = this.trafficFilterConstants.systemTraffic.FT;
            return model;
        };
        DvpgTrafficFilterService.prototype.showErrors = function (errors, modalOptions) {
            if (_.isArray(errors) && errors.length > 0) {
                if (errors.length === 1) {
                    modalOptions.alerts = [{
                            type: this.clarityConstants.notifications.type.ERROR,
                            text: errors[0]
                        }];
                }
                else {
                    modalOptions.alerts = [{
                            type: this.clarityConstants.notifications.type.ERROR,
                            text: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.generalError"),
                        }];
                }
            }
        };
        DvpgTrafficFilterService.prototype.showAllErrors = function (errors, modalOptions) {
            var _this = this;
            if (_.isArray(errors) && errors.length > 0) {
                modalOptions.alerts = [];
                _.each(errors, function (error) {
                    modalOptions.alerts.push({
                        type: _this.clarityConstants.notifications.type.ERROR,
                        text: error
                    });
                });
            }
        };
        DvpgTrafficFilterService.prototype.getDefaultQualifierTabIndex = function (model) {
            if (!model || model.ipQualifierModel.enableIpQualifier ||
                (!model.macQualifierModel.enableMacQualifier &&
                    !model.systemQualifierModel.enableSystemQualifier)) {
                return 0;
            }
            if (model.macQualifierModel.enableMacQualifier) {
                return 1;
            }
            else {
                // the system qualifier tab is the default
                return 2;
            }
        };
        DvpgTrafficFilterService.$inject = [
            "i18nService",
            "clarityConstants",
            "dvpgTrafficFilterConstants",
            "dvpgTrafficFilterSpecFactory",
            "dvpgTrafficRuleValidator",
            "dvpgCloneTrafficRulesValidator",
            "clarityModalService",
            "dataService",
            "mutationService",
            "defaultUriSchemeUtil",
            "$q"
        ];
        return DvpgTrafficFilterService;
    }());
    dvs_ui.DvpgTrafficFilterService = DvpgTrafficFilterService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgTrafficFilterService", DvpgTrafficFilterService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgEditTrafficFilterSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditTrafficFilterSpec;
    var DvpgEditRuleSequenceSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditRuleSequenceSpec;
    var DvpgAddTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgAddTrafficRuleSpec;
    var DvpgRemoveTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgRemoveTrafficRuleSpec;
    var DvpgEditTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditTrafficRuleSpec;
    var DvpgCloneTrafficRulesSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgCloneTrafficRulesSpec;
    var DvpgTrafficFilterSpecFactory = (function () {
        function DvpgTrafficFilterSpecFactory(defaultUriSchemeUtil) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Builds the spec for enable and/or reorder the traffic filter rules of
         * distributed port group.
         *
         * @param model DvpgEditTrafficFilterModel
         */
        DvpgTrafficFilterSpecFactory.prototype.buildEditTrafficFilterSpec = function (model, isRuleOrderChanged) {
            var configSpec = new DvpgEditTrafficFilterSpec();
            configSpec.isTrafficRulesetEnabled = model.isTrafficRulesetEnabled;
            if (isRuleOrderChanged) {
                var trafficRuleSpecs_1 = [];
                model.rules.forEach(function (rule) {
                    var trafficRuleSpec = new DvpgEditRuleSequenceSpec();
                    trafficRuleSpec.ruleKey = rule.key;
                    trafficRuleSpec.sequence = rule.sequence;
                    trafficRuleSpecs_1.push(trafficRuleSpec);
                });
                configSpec.rules = trafficRuleSpecs_1;
            }
            return configSpec;
        };
        /**
         * Builds the spec for clone traffic filter rules of
         * distributed port group to another port groups.
         *
         * @param model DvpgCloneTrafficRulesSpec
         */
        DvpgTrafficFilterSpecFactory.prototype.buildCloneTrafficFilterSpec = function (model) {
            var _this = this;
            var configSpec = new DvpgCloneTrafficRulesSpec();
            var portgroupRefs = [];
            model.selectedPortgroups.forEach(function (portgroupId) {
                portgroupRefs.push(_this.defaultUriSchemeUtil.getManagedObjectReference(portgroupId.id));
            });
            configSpec.portgroups = portgroupRefs;
            return configSpec;
        };
        /**
         * Builds the spec for adding a traffic rule to the current rules configuration
         * of the distributed port group.
         *
         * @param model DvpgTrafficRuleModel
         */
        DvpgTrafficFilterSpecFactory.prototype.buildAddTrafficRuleSpec = function (model) {
            var spec = new DvpgAddTrafficRuleSpec();
            spec.newRule = model;
            return spec;
        };
        /**
         * Builds the spec for editing a traffic rule to the current rules configuration
         * of the distributed port group.
         *
         * @param model DvpgTrafficRuleModel
         */
        DvpgTrafficFilterSpecFactory.prototype.buildEditTrafficRuleSpec = function (editedRuleModel) {
            var spec = new DvpgEditTrafficRuleSpec();
            spec.editedRule = editedRuleModel;
            return spec;
        };
        /**
         * Builds the spec for removing a traffic rule to the current rules configuration
         * of the distributed port group.
         *
         * @param key The key of the removed traffic rule
         */
        DvpgTrafficFilterSpecFactory.prototype.buildRemoveTrafficRuleSpec = function (ruleKey) {
            var spec = new DvpgRemoveTrafficRuleSpec();
            spec.key = ruleKey;
            return spec;
        };
        DvpgTrafficFilterSpecFactory.$inject = ["defaultUriSchemeUtil"];
        return DvpgTrafficFilterSpecFactory;
    }());
    dvs_ui.DvpgTrafficFilterSpecFactory = DvpgTrafficFilterSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgTrafficFilterSpecFactory", DvpgTrafficFilterSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficFilterViewComponent = (function () {
        function DvpgTrafficFilterViewComponent() {
            this.bindings = {
                dvpgId: "<"
            };
            this.controller = DvpgTrafficFilterViewContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/" +
                "dvpgTrafficFilterViewTemplate.html";
        }
        return DvpgTrafficFilterViewComponent;
    }());
    dvs_ui.DvpgTrafficFilterViewComponent = DvpgTrafficFilterViewComponent;
    var DvpgTrafficFilterViewContoller = (function () {
        function DvpgTrafficFilterViewContoller(dataService, i18nService, dvpgTrafficFilterService, dvpgTrafficFilterConstants) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.dvpgTrafficFilterService = dvpgTrafficFilterService;
            this.dvpgTrafficFilterConstants = dvpgTrafficFilterConstants;
            this.liveRefreshProperties = [
                "config.defaultPortConfig.filterPolicy",
                "config.defaultPortConfig.filterPolicy.filterConfig"
            ];
            this.settingsViewHeaderAccessor = {};
            this.headerOptions = {
                title: this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.disabled"),
                objectId: this.dvpgId,
                actions: [
                    {
                        actionUid: "vsphere.core.dvs.trafficFilters.editRulesAction",
                        customLabel: this.i18nService.getString("DvsUi", "actionEditTrafficFiltersLabel")
                    }, {
                        actionUid: "vsphere.core.dvs.trafficFilters.cloneRulesAction",
                        customLabel: this.i18nService.getString("DvsUi", "actionCloneTrafficFiltersLabel")
                    }
                ]
            };
        }
        DvpgTrafficFilterViewContoller.prototype.$onInit = function () {
            this.getData();
        };
        DvpgTrafficFilterViewContoller.prototype.getData = function () {
            var _this = this;
            this.hasPendingRequest = true;
            this.dataService.getProperties(this.dvpgId, this.dvpgTrafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY)
                .then(function (response) { return response[_this.dvpgTrafficFilterConstants.properties.TRAFFIC_FILTER_PROPERTY]; })
                .then(function (model) {
                _this.hasPendingRequest = false;
                if (model) {
                    if (_this.dvpgTrafficFilterService.areRulesChanged(_this.trafficFilterRules, model.rules)) {
                        _this.trafficFilterRules = model.rules;
                    }
                    _this.headerOptions.title = model.isTrafficRulesetEnabled ?
                        _this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.enabled") :
                        _this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.disabled");
                }
                else {
                    _this.trafficFilterRules = [];
                }
                // Call the settings-view-header's accessor #refresh function to recalculate
                // the actions availability
                if (_this.settingsViewHeaderAccessor.refresh) {
                    _this.settingsViewHeaderAccessor.refresh();
                }
            });
        };
        DvpgTrafficFilterViewContoller.prototype.onAddRule = function () {
            this.dvpgTrafficFilterService.showAddRuleDialog(this.dvpgId);
        };
        DvpgTrafficFilterViewContoller.prototype.onEditRule = function (rule) {
            this.dvpgTrafficFilterService.showEditRuleDialog(this.dvpgId, rule.key);
        };
        DvpgTrafficFilterViewContoller.prototype.onRemoveRule = function (rule) {
            this.dvpgTrafficFilterService.removeRule(this.dvpgId, rule.key, rule.name);
        };
        DvpgTrafficFilterViewContoller.$inject = [
            "dataService",
            "i18nService",
            "dvpgTrafficFilterService",
            "dvpgTrafficFilterConstants"
        ];
        return DvpgTrafficFilterViewContoller;
    }());
    dvs_ui.DvpgTrafficFilterViewContoller = DvpgTrafficFilterViewContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgTrafficFilterView", new DvpgTrafficFilterViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgEditTrafficFilterComponent = (function () {
        function DvpgEditTrafficFilterComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = DvpgEditTrafficFilterContoller;
            this.templateUrl = "dvs-ui/resources/dvs/dvpg/trafficfilter/edit/" +
                "dvpgEditTrafficFilterTemplate.html";
        }
        return DvpgEditTrafficFilterComponent;
    }());
    dvs_ui.DvpgEditTrafficFilterComponent = DvpgEditTrafficFilterComponent;
    var DvpgEditTrafficFilterContoller = (function () {
        function DvpgEditTrafficFilterContoller(i18nService, $sce) {
            this.i18nService = i18nService;
            this.$sce = $sce;
            this.i18n = this.i18nService;
            this.enableOverrideInfoText = this.$sce.trustAsHtml(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.enableOverrideInfoText"));
        }
        DvpgEditTrafficFilterContoller.$inject = ["i18nService", "$sce"];
        return DvpgEditTrafficFilterContoller;
    }());
    dvs_ui.DvpgEditTrafficFilterContoller = DvpgEditTrafficFilterContoller;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgEditTrafficFilter", new DvpgEditTrafficFilterComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgEditTrafficFilterModel = (function () {
        function DvpgEditTrafficFilterModel() {
            this.showTrafficFilterOverride = false;
            this.enableTrafficFilterOverride = false;
            this.isTrafficRulesetOverwritten = false;
            this.initialIsTrafficRulesetOverwritten = false;
            this.initialTrafficRulesetEnabled = false;
            this.isTrafficRulesetEnabled = false;
        }
        return DvpgEditTrafficFilterModel;
    }());
    dvs_ui.DvpgEditTrafficFilterModel = DvpgEditTrafficFilterModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgCloneTrafficRulesValidator = (function () {
        function DvpgCloneTrafficRulesValidator(i18nService, dvpgTrafficFilterConstants, authorizationService, $q) {
            this.i18nService = i18nService;
            this.dvpgTrafficFilterConstants = dvpgTrafficFilterConstants;
            this.authorizationService = authorizationService;
            this.$q = $q;
            this.privilegeToCheck =
                this.dvpgTrafficFilterConstants.privileges.DVPG_MODIFY;
        }
        DvpgCloneTrafficRulesValidator.prototype.getValidationError = function (model) {
            var errors = [];
            if (!model.selectedPortgroups || model.selectedPortgroups.length === 0) {
                errors.push(this.i18nService.getString("DvsUi", "trafficFilter.cloneRulesDialog.noPortGroupsSelected"));
                return this.$q.when(errors);
            }
            else {
                return this.getNoPrivilegesValidationError(model);
            }
        };
        DvpgCloneTrafficRulesValidator.prototype.getNoPrivilegesValidationError = function (model) {
            var _this = this;
            var dvPortgroupIds = _.map(model.selectedPortgroups, function (pg) {
                return pg.id;
            });
            return this.authorizationService
                .checkPrivilegesForMultipleObjects(dvPortgroupIds, [this.privilegeToCheck])
                .then(function (result) {
                return _this.buildNoPrivilegesValidationMessages(result, model.selectedPortgroups);
            });
        };
        DvpgCloneTrafficRulesValidator.prototype.buildNoPrivilegesValidationMessages = function (privilegesById, selectedPortgroups) {
            var _this = this;
            var validationMessages = [];
            Object.keys(privilegesById).forEach(function (id) {
                if (privilegesById[id][_this.privilegeToCheck] === false) {
                    var dvpgName = _this.getPortgroupName(id, selectedPortgroups);
                    if (dvpgName !== "") {
                        validationMessages.push(_this.i18nService.getString("DvsUi", "trafficFilter.cloneRulesDialog.noPrivilegesFormat", dvpgName));
                    }
                }
            });
            return validationMessages;
        };
        DvpgCloneTrafficRulesValidator.prototype.getPortgroupName = function (id, portgroups) {
            for (var i = 0; i < portgroups.length; i++) {
                if (id === portgroups[i].id) {
                    return portgroups[i].name;
                }
            }
            return "";
        };
        DvpgCloneTrafficRulesValidator.$inject = [
            "i18nService",
            "dvpgTrafficFilterConstants",
            "authorizationService",
            "$q"
        ];
        return DvpgCloneTrafficRulesValidator;
    }());
    dvs_ui.DvpgCloneTrafficRulesValidator = DvpgCloneTrafficRulesValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgCloneTrafficRulesValidator", DvpgCloneTrafficRulesValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgIpQualifierValidator = (function () {
        function DvpgIpQualifierValidator(i18nService, trafficFilterConstants, validatorService, ipParserService, networkUtil) {
            this.i18nService = i18nService;
            this.trafficFilterConstants = trafficFilterConstants;
            this.validatorService = validatorService;
            this.ipParserService = ipParserService;
            this.networkUtil = networkUtil;
        }
        DvpgIpQualifierValidator.prototype.getValidationErrors = function (model) {
            var errors = [];
            if (!model) {
                return errors;
            }
            // 1. Source and destination ports
            if (model.protocol.type === this.trafficFilterConstants.protocol.TCP ||
                model.protocol.type === this.trafficFilterConstants.protocol.UDP) {
                var sourcePortError = this.getPortError(model.sourcePort, true /*isSource*/);
                var sourcePortRangeError = this.getPortRangeError(model.sourcePort, true /*isSource*/);
                var destinationPortError = this.getPortError(model.destinationPort, false /*isSource*/);
                var destinationPortRangeError = this.getPortRangeError(model.destinationPort, false /*isSource*/);
                if (sourcePortError !== this.trafficFilterConstants.EMPTY) {
                    errors.push(sourcePortError);
                }
                else if (sourcePortRangeError !== this.trafficFilterConstants.EMPTY) {
                    errors.push(sourcePortRangeError);
                }
                if (destinationPortError !== this.trafficFilterConstants.EMPTY) {
                    errors.push(destinationPortError);
                }
                else if (destinationPortRangeError !== this.trafficFilterConstants.EMPTY) {
                    errors.push(destinationPortRangeError);
                }
            }
            // 2. Source and destination IP addresses
            var sourceIpError = this.getIpAddressError(model.sourceIpAddress, true /*isSource*/);
            var sourcePrefixLengthError = this.getPrefixLengthError(model.sourceIpAddress, true /*isSource*/);
            var destinationIpError = this.getIpAddressError(model.destinationIpAddress, false /*isSource*/);
            var destinationPrefixLengthError = this.getPrefixLengthError(model.destinationIpAddress, false /*isSource*/);
            if (sourceIpError !== this.trafficFilterConstants.EMPTY) {
                errors.push(sourceIpError);
            }
            if (sourcePrefixLengthError !== this.trafficFilterConstants.EMPTY) {
                errors.push(sourcePrefixLengthError);
            }
            if (destinationIpError !== this.trafficFilterConstants.EMPTY) {
                errors.push(destinationIpError);
            }
            if (destinationPrefixLengthError !== this.trafficFilterConstants.EMPTY) {
                errors.push(destinationPrefixLengthError);
            }
            // 3. IP mismatch errors
            var ipMismatchError = this.getIpMatchError(model.sourceIpAddress, model.destinationIpAddress);
            if (ipMismatchError !== this.trafficFilterConstants.EMPTY) {
                errors.push(ipMismatchError);
            }
            // 4. Protocol errors
            var protocolError = this.getProtocolError(model.protocol);
            if (protocolError !== this.trafficFilterConstants.EMPTY) {
                errors.push(protocolError);
            }
            return errors;
        };
        DvpgIpQualifierValidator.prototype.getPortError = function (portModel, isSourcePort) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!portModel ||
                (portModel.operation !==
                    this.trafficFilterConstants.operator.IS &&
                    portModel.operation !==
                        this.trafficFilterConstants.operator.IS_NOT)) {
                return error;
            }
            if (!this.validatorService.isValidInteger(portModel.port, 0, this.trafficFilterConstants.MAX_PORT_NUMBER)) {
                return isSourcePort
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourcePort")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationPort");
            }
            return error;
        };
        DvpgIpQualifierValidator.prototype.getPortRangeError = function (portModel, isSourcePort) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!portModel ||
                (portModel.operation !==
                    this.trafficFilterConstants.operator.IN_RANGE &&
                    portModel.operation !==
                        this.trafficFilterConstants.operator.NOT_IN_RANGE)) {
                return error;
            }
            var startPortId = parseInt(portModel.port);
            var endPortId = parseInt(portModel.portRangeEnd);
            if (isNaN(startPortId) || isNaN(endPortId)) {
                return isSourcePort
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.emptySourcePortRange")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.emptyDestinationPortRange");
            }
            else if (!this.validatorService.isValidInteger(portModel.port, 0, this.trafficFilterConstants.MAX_PORT_NUMBER) ||
                !this.validatorService.isValidInteger(portModel.portRangeEnd, 0, this.trafficFilterConstants.MAX_PORT_NUMBER)) {
                return isSourcePort
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourcePortRange")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationPortRange");
            }
            else if (startPortId >= endPortId) {
                return isSourcePort
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidEndSourcePortRange")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidEndDestinationPortRange");
            }
            return error;
        };
        DvpgIpQualifierValidator.prototype.getIpAddressError = function (ipAddressModel, isSourceAddress) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!ipAddressModel ||
                ipAddressModel.operation === this.trafficFilterConstants.operator.ANY) {
                return error;
            }
            var ipAddress = (ipAddressModel.ipAddress &&
                ipAddressModel.ipAddress.length > 0) ?
                ipAddressModel.ipAddress.trim() : ipAddressModel.ipAddress;
            var isIpv4 = this.ipParserService.isIpv4AddressValid(ipAddress);
            var isIpv6 = false;
            if (!isIpv4) {
                isIpv6 = this.ipParserService.isIpv6AddressValid(ipAddress);
            }
            if (!isIpv4 && !isIpv6) {
                return isSourceAddress
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourceIp")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationIp");
            }
            return error;
        };
        DvpgIpQualifierValidator.prototype.getPrefixLengthError = function (ipAddressModel, isSource) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!ipAddressModel ||
                (ipAddressModel.operation !==
                    this.trafficFilterConstants.operator.MATCHES &&
                    ipAddressModel.operation !==
                        this.trafficFilterConstants.operator.DOES_NOT_MATCH)) {
                return error;
            }
            var ipAddress = (ipAddressModel.ipAddress &&
                ipAddressModel.ipAddress.length > 0) ?
                ipAddressModel.ipAddress.trim() : ipAddressModel.ipAddress;
            var isIpv4 = this.ipParserService.isIpv4AddressValid(ipAddress);
            var maxIpPrefix = isIpv4
                ? this.trafficFilterConstants.IPV4_ADDRESS_MAX_PREFIX
                : this.trafficFilterConstants.IPV6_ADDRESS_MAX_PREFIX;
            if (!this.validatorService.isValidInteger(ipAddressModel.prefixLength, this.trafficFilterConstants.IP_ADDRESS_MIN_PREFIX, maxIpPrefix)) {
                return isSource
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourcePrefix", this.trafficFilterConstants.IP_ADDRESS_MIN_PREFIX, maxIpPrefix)
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationPrefix", this.trafficFilterConstants.IP_ADDRESS_MIN_PREFIX, maxIpPrefix);
            }
            return error;
        };
        DvpgIpQualifierValidator.prototype.getIpMatchError = function (sourceIpAddressModel, destinationIpAddressModel) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!sourceIpAddressModel || !destinationIpAddressModel) {
                return error;
            }
            var sourceIpVersion = this.getIpAddressVersion(sourceIpAddressModel);
            var destinationIpVersion = this.getIpAddressVersion(destinationIpAddressModel);
            if (sourceIpVersion !== this.trafficFilterConstants.addressType.MIXED &&
                destinationIpVersion !== this.trafficFilterConstants.addressType.MIXED &&
                sourceIpVersion !== destinationIpVersion) {
                error = this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.ipMismatch");
            }
            return error;
        };
        DvpgIpQualifierValidator.prototype.getIpAddressVersion = function (ipAddressModel) {
            if (!ipAddressModel) {
                return this.trafficFilterConstants.addressType.MIXED;
            }
            if (ipAddressModel.operation === this.trafficFilterConstants.operator.ANY) {
                return ipAddressModel.ipAddressType;
            }
            var ipAddress = (ipAddressModel.ipAddress &&
                ipAddressModel.ipAddress.length > 0)
                ? ipAddressModel.ipAddress.trim()
                : ipAddressModel.ipAddress;
            var isIpv4 = this.ipParserService.isIpv4AddressValid(ipAddress);
            var isIpv6 = this.ipParserService.isIpv6AddressValid(ipAddress);
            if (isIpv4) {
                return this.trafficFilterConstants.addressType.IPV4;
            }
            else if (isIpv6) {
                return this.trafficFilterConstants.addressType.IPV6;
            }
            return this.trafficFilterConstants.addressType.MIXED;
        };
        DvpgIpQualifierValidator.prototype.getProtocolError = function (protocolModel) {
            if (!protocolModel ||
                protocolModel.operation === this.trafficFilterConstants.operator.ANY) {
                return this.trafficFilterConstants.EMPTY;
            }
            var protocolCode;
            if (protocolModel.type === this.trafficFilterConstants.protocol.CUSTOM) {
                protocolCode = protocolModel.customValue;
            }
            else {
                protocolCode = protocolModel.type.toString();
            }
            if (!this.validatorService.isValidInteger(protocolCode, this.trafficFilterConstants.MIN_PROTOCOL_VALUE, this.trafficFilterConstants.MAX_PROTOCOL_VALUE)) {
                return this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidProtocol");
            }
            return this.trafficFilterConstants.EMPTY;
        };
        DvpgIpQualifierValidator.$inject = [
            "i18nService",
            "dvpgTrafficFilterConstants",
            "dvpgQualifierValidatorService",
            "ipParserService",
            "networkUtil"
        ];
        return DvpgIpQualifierValidator;
    }());
    dvs_ui.DvpgIpQualifierValidator = DvpgIpQualifierValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgIpQualifierValidator", DvpgIpQualifierValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgMacQualifierValidator = (function () {
        function DvpgMacQualifierValidator(i18nService, validatorService, trafficFilterConstants) {
            this.i18nService = i18nService;
            this.validatorService = validatorService;
            this.trafficFilterConstants = trafficFilterConstants;
        }
        DvpgMacQualifierValidator.prototype.getValidationErrors = function (model) {
            var errors = [];
            if (!model) {
                return errors;
            }
            // 1. Protocol errors
            var protocolError = this.getProtocolError(model.protocol);
            if (protocolError !== this.trafficFilterConstants.EMPTY) {
                errors.push(protocolError);
            }
            // 2. VLAN
            var vlanError = this.getVlanError(model.vlanId, model.vlanOperation);
            if (vlanError !== this.trafficFilterConstants.EMPTY) {
                errors.push(vlanError);
            }
            // 3. Source and destination MAC addresses and wildcards
            var sourceMacError = this.getMacAddressError(model.sourceMacAddress, true /*isSource*/);
            var sourceWildcardMaskError = this.getWildcardMaskError(model.sourceMacAddress, true /*isSource*/);
            var destinationMacError = this.getMacAddressError(model.destinationMacAddress, false /*isSource*/);
            var destinationWildcardMaskError = this.getWildcardMaskError(model.destinationMacAddress, false /*isSource*/);
            if (sourceMacError !== this.trafficFilterConstants.EMPTY) {
                errors.push(sourceMacError);
            }
            if (sourceWildcardMaskError !== this.trafficFilterConstants.EMPTY) {
                errors.push(sourceWildcardMaskError);
            }
            if (destinationMacError !== this.trafficFilterConstants.EMPTY) {
                errors.push(destinationMacError);
            }
            if (destinationWildcardMaskError !== this.trafficFilterConstants.EMPTY) {
                errors.push(destinationWildcardMaskError);
            }
            return errors;
        };
        DvpgMacQualifierValidator.prototype.getProtocolError = function (protocolModel) {
            if (!protocolModel ||
                protocolModel.operation === this.trafficFilterConstants.operator.ANY) {
                return this.trafficFilterConstants.EMPTY;
            }
            var protocol;
            if (protocolModel.type === this.trafficFilterConstants.protocol.CUSTOM) {
                protocol = parseInt(protocolModel.customValue, 16);
            }
            else {
                protocol = protocolModel.type;
            }
            if (isNaN(protocol) ||
                protocol < this.trafficFilterConstants.MIN_PROTOCOL_HEX_VALUE ||
                protocol > this.trafficFilterConstants.MAX_PROTOCOL_HEX_VALUE) {
                return this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidProtocolHex");
            }
            return this.trafficFilterConstants.EMPTY;
        };
        DvpgMacQualifierValidator.prototype.getVlanError = function (vlanId, vlanOperation) {
            var error = this.trafficFilterConstants.EMPTY;
            if (vlanOperation === this.trafficFilterConstants.operator.ANY) {
                return error;
            }
            if (!this.validatorService.isValidInteger(vlanId, this.trafficFilterConstants.vlan.MIN, this.trafficFilterConstants.vlan.MAX)) {
                return this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidVlan");
            }
            return error;
        };
        DvpgMacQualifierValidator.prototype.getMacAddressError = function (macAddressModel, isSourceAddress) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!macAddressModel ||
                macAddressModel.operation === this.trafficFilterConstants.operator.ANY) {
                return error;
            }
            var macAddress = macAddressModel.macAddress &&
                macAddressModel.macAddress.length > 0 ?
                macAddressModel.macAddress.trim() : macAddressModel.macAddress;
            if (!this.validatorService.isValidMac(macAddress) ||
                macAddress === this.trafficFilterConstants.EMPTY_MAC_ADDRESS) {
                return isSourceAddress
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourceMac")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationMac");
            }
            if (this.validatorService.isMulticastOrBroadcastAddress(macAddress) &&
                isSourceAddress) {
                return this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourceMacFirstHex");
            }
            return error;
        };
        DvpgMacQualifierValidator.prototype.getWildcardMaskError = function (macAddressModel, isSourceAddress) {
            var error = this.trafficFilterConstants.EMPTY;
            if (!macAddressModel ||
                macAddressModel.operation === this.trafficFilterConstants.operator.ANY ||
                (macAddressModel.operation !==
                    this.trafficFilterConstants.operator.MATCHES &&
                    macAddressModel.operation !==
                        this.trafficFilterConstants.operator.DOES_NOT_MATCH)) {
                return error;
            }
            var wildcardMask = macAddressModel.wildcardMask &&
                macAddressModel.wildcardMask.length > 0 ?
                macAddressModel.wildcardMask.trim() : macAddressModel.wildcardMask;
            if (!this.validatorService.isValidMac(wildcardMask)) {
                return isSourceAddress
                    ? this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidSourceMask")
                    : this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDestinationMask");
            }
            return error;
        };
        DvpgMacQualifierValidator.$inject = [
            "i18nService",
            "dvpgQualifierValidatorService",
            "dvpgTrafficFilterConstants"
        ];
        return DvpgMacQualifierValidator;
    }());
    dvs_ui.DvpgMacQualifierValidator = DvpgMacQualifierValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgMacQualifierValidator", DvpgMacQualifierValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgQualifierValidatorService = (function () {
        function DvpgQualifierValidatorService(networkUiConstants) {
            this.networkUiConstants = networkUiConstants;
        }
        DvpgQualifierValidatorService.prototype.isValidInteger = function (value, minValue, maxValue) {
            return this.networkUiConstants.POSITIVE_INTEGER_REG_EXP.test(value)
                && parseInt(value) >= minValue
                && parseInt(value) <= maxValue;
        };
        DvpgQualifierValidatorService.prototype.isValidMac = function (macAddress) {
            return macAddress !== undefined && macAddress !== null &&
                macAddress.length > 0 &&
                new RegExp("^([0-9a-fA-F]{1,2}[:-]){5}[0-9a-fA-F]{1,2}$")
                    .test(macAddress);
        };
        DvpgQualifierValidatorService.prototype.isMulticastOrBroadcastAddress = function (macAddress) {
            if (!macAddress || macAddress.length === 0) {
                return false;
            }
            macAddress = macAddress.trim();
            var delimInd = -1;
            var delimArray = [":", "-", ".", " "];
            _.each(delimArray, function (delimeter) {
                delimInd = macAddress.indexOf(delimeter);
                if (delimInd !== -1) {
                    return;
                }
            });
            var firstHex = delimInd === -1
                ? macAddress.substr(0, 2)
                : macAddress.substr(0, delimInd);
            return (parseInt(firstHex, 16) & 0x1) === 1;
        };
        DvpgQualifierValidatorService.$inject = [
            "networkUiConstants"
        ];
        return DvpgQualifierValidatorService;
    }());
    dvs_ui.DvpgQualifierValidatorService = DvpgQualifierValidatorService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgQualifierValidatorService", DvpgQualifierValidatorService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgTrafficRuleValidator = (function () {
        function DvpgTrafficRuleValidator(i18nService, dvpgTrafficFilterConstants, dvpgQualifierValidatorService, dvpgIpQualifierValidator, dvpgMacQualifierValidator, clarityModalService, $q) {
            this.i18nService = i18nService;
            this.dvpgTrafficFilterConstants = dvpgTrafficFilterConstants;
            this.dvpgQualifierValidatorService = dvpgQualifierValidatorService;
            this.dvpgIpQualifierValidator = dvpgIpQualifierValidator;
            this.dvpgMacQualifierValidator = dvpgMacQualifierValidator;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
        }
        DvpgTrafficRuleValidator.prototype.getValidationResult = function (model) {
            if (!model) {
                return this.$q.resolve(false);
            }
            var errors = [];
            // 1. The rule name must be < 255
            if (!this.isValidRuleName(model.name)) {
                errors.push(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.exceededMaxLength"));
            }
            if (model.action === this.dvpgTrafficFilterConstants.action.TAG) {
                // 2. The Cos and DSCP tags
                if (model.qosTagSelected && !this.isValidQosTag(model.qosTagValue)) {
                    errors.push(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidQosTag"));
                }
                if (model.dscpTagSelected && !this.isValidDscpTag(model.dscpTagValue)) {
                    errors.push(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.invalidDscpTag"));
                }
            }
            // 3. The selected action must be Allow/Drop/Tag
            if (model.action !== this.dvpgTrafficFilterConstants.action.ALLOW &&
                model.action !== this.dvpgTrafficFilterConstants.action.DROP &&
                model.action !== this.dvpgTrafficFilterConstants.action.TAG) {
                errors.push(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.unsupportedAction"));
            }
            // 4. The rule must have at least one enabled qualifier
            if (!model.ipQualifierModel.enableIpQualifier &&
                !model.macQualifierModel.enableMacQualifier &&
                !model.systemQualifierModel.enableSystemQualifier) {
                errors.push(this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.missingQualifier"));
            }
            // 5. Validate qualifiers
            var qualifiersErrors = this.getQualifiersErrors(model);
            if (qualifiersErrors.length > 0) {
                _.each(qualifiersErrors, function (error) {
                    errors.push(error);
                });
            }
            if (errors.length > 0) {
                return this.$q.resolve(errors);
            }
            // 6. The tag action should have selected CoS or DSCP parameters
            if (model.action === this.dvpgTrafficFilterConstants.action.TAG &&
                (!model.dscpTagSelected && !model.qosTagSelected)) {
                return this.showTagActionWarning();
            }
            return this.$q.resolve([]);
        };
        DvpgTrafficRuleValidator.prototype.getQualifiersErrors = function (model) {
            if (!model) {
                return [];
            }
            var errors = [];
            if (model.ipQualifierModel.enableIpQualifier) {
                var ipQualifierErrors = this.dvpgIpQualifierValidator.getValidationErrors(model.ipQualifierModel);
                if (ipQualifierErrors.length > 0) {
                    _.each(ipQualifierErrors, function (ipQualifierError) {
                        errors.push(ipQualifierError);
                    });
                }
            }
            if (model.macQualifierModel.enableMacQualifier) {
                var macQualifierErrors = this.dvpgMacQualifierValidator.getValidationErrors(model.macQualifierModel);
                if (macQualifierErrors.length > 0) {
                    _.each(macQualifierErrors, function (macQualifierError) {
                        errors.push(macQualifierError);
                    });
                }
            }
            return errors;
        };
        DvpgTrafficRuleValidator.prototype.isValidRuleName = function (name) {
            // The rule name must be <= 255
            return name !== undefined && name.length <=
                this.dvpgTrafficFilterConstants.MAX_RULE_NAME_LENGTH;
        };
        DvpgTrafficRuleValidator.prototype.isValidQosTag = function (tag) {
            if (tag === undefined || tag === null || tag.length === 0) {
                // 0 by default, if the value is not specified
                return true;
            }
            // The valid Cos tag must be between 0 and 7
            return this.dvpgQualifierValidatorService.isValidInteger(tag, this.dvpgTrafficFilterConstants.tag.MIN_COS_TAG, this.dvpgTrafficFilterConstants.tag.MAX_COS_TAG);
        };
        DvpgTrafficRuleValidator.prototype.isValidDscpTag = function (tag) {
            if (tag === undefined || tag === null || tag.length === 0) {
                // 0 by default, if the value is not specified
                return true;
            }
            // The valid DSCP tag must be between 0 and 63
            return this.dvpgQualifierValidatorService.isValidInteger(tag, this.dvpgTrafficFilterConstants.tag.MIN_DSCP_TAG, this.dvpgTrafficFilterConstants.tag.MAX_DSCP_TAG);
        };
        DvpgTrafficRuleValidator.prototype.showTagActionWarning = function () {
            var deferred = this.$q.defer();
            var modalOptions = {
                size: "md",
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.noTagSpecifiedTitle"),
                defaultButton: "submit",
                modalClass: "dvpg-traffic-rule-tag-warning",
                alerts: [],
                dialogData: {
                    message: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.noTagSpecified")
                },
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/validators/" +
                    "dvpgTrafficRuleWarningDialog.html",
                preserveNewlines: true,
                clarityIcon: {
                    shape: "warning",
                    class: "is-warning",
                    size: 32
                },
                onSubmit: function () {
                    deferred.resolve(true);
                    return true;
                },
                onCancel: function () {
                    deferred.resolve(false);
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            return deferred.promise.then(function (result) {
                return result;
            });
        };
        DvpgTrafficRuleValidator.$inject = [
            "i18nService",
            "dvpgTrafficFilterConstants",
            "dvpgQualifierValidatorService",
            "dvpgIpQualifierValidator",
            "dvpgMacQualifierValidator",
            "clarityModalService",
            "$q"
        ];
        return DvpgTrafficRuleValidator;
    }());
    dvs_ui.DvpgTrafficRuleValidator = DvpgTrafficRuleValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvpgTrafficRuleValidator", DvpgTrafficRuleValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var ExportDvsComponent = (function () {
        function ExportDvsComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = ExportDvsComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/export/exportDvsComponentTemplate.html";
        }
        return ExportDvsComponent;
    }());
    dvs_ui.ExportDvsComponent = ExportDvsComponent;
    var ExportDvsComponentController = (function () {
        function ExportDvsComponentController(i18nService, exportDvsConstants) {
            this.i18nService = i18nService;
            this.exportDvsConstants = exportDvsConstants;
        }
        ExportDvsComponentController.$inject = [
            "i18nService",
            "exportDvsConstants"
        ];
        return ExportDvsComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("exportDvsComponent", new ExportDvsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("exportDvsConstants", {
        configurationsToExport: {
            DVS_AND_ALL_PORTGROUPS: "dvsAndAllPortgroups",
            DVS_ONLY: "dvsOnly"
        },
        configurationRestoreTypes: {
            FROM_PREVIOUS_CONFIGURATION: "previous",
            FROM_FILE: "file"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var ExportDvsSpec = com.vmware.vsphere.client.h5.network.dvs.exp.model.ExportDvsSpec;
    var ExportDvsDialogService = (function () {
        function ExportDvsDialogService(i18nService, clarityModalService, exportDvsConstants, dataService, exportDvsService, $q, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.exportDvsConstants = exportDvsConstants;
            this.dataService = dataService;
            this.exportDvsService = exportDvsService;
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        ExportDvsDialogService.prototype.show = function (dvsId) {
            var _this = this;
            var isDvpg = this.defaultUriSchemeUtil.getManagedObjectReference(dvsId).type ===
                "DistributedVirtualPortgroup";
            var dialogTitle = this.i18nService.getString("DvsUi", "dvs.backup.dialog.title");
            var contentTemplate = "dvs-ui/resources/dvs/export/exportDvsDialog.html";
            if (isDvpg) {
                dialogTitle = this.i18nService.getString("DvsUi", "dvpg.export.dialog.title");
                contentTemplate = "dvs-ui/resources/dvs/export/exportDvsDialog.html";
            }
            var dialogData = {};
            var modalOptions = {
                title: dialogTitle,
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                loading: false,
                dialogData: dialogData,
                contentTemplate: contentTemplate,
                subTitle: {
                    objectId: dvsId
                }
            };
            modalOptions.dialogData.pageModel = new dvs_ui.ExportDvsPageModel();
            modalOptions.dialogData.pageModel.type = isDvpg ? "dvpg" : "dvs";
            if (!isDvpg) {
                modalOptions.dialogData.pageModel.selectedConfigurationToExport =
                    this.exportDvsConstants.configurationsToExport.DVS_AND_ALL_PORTGROUPS;
            }
            modalOptions.onSubmit = function () {
                var EXPORT_CONFIGURATION_PROPERTY = "dvs:exportDvsConfiguration";
                var exportDvsSpec = new ExportDvsSpec();
                exportDvsSpec.description =
                    modalOptions.dialogData.pageModel.description || "";
                if (!isDvpg) {
                    exportDvsSpec.includePortGroups =
                        modalOptions.dialogData.pageModel.selectedConfigurationToExport ===
                            _this.exportDvsConstants.configurationsToExport.DVS_AND_ALL_PORTGROUPS;
                }
                modalOptions.loading = true;
                modalOptions.submitDisabled = true;
                var resultPromise = _this.dataService.getProperties(dvsId, EXPORT_CONFIGURATION_PROPERTY, {
                    propertyParams: [{
                            propertyName: EXPORT_CONFIGURATION_PROPERTY,
                            parameterType: exportDvsSpec._type,
                            parameter: exportDvsSpec
                        }]
                })
                    .then(function (response) {
                    var resultInBytes = response[EXPORT_CONFIGURATION_PROPERTY];
                    _this.exportDvsService.saveCharArrayToDisk(resultInBytes);
                    modalOptions.loading = false;
                    modalOptions.submitDisabled = false;
                    return _this.$q.when(true);
                }, function (error) {
                    return _this.$q.when(true);
                });
                return resultPromise;
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        ExportDvsDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "exportDvsConstants",
            "dataService",
            "exportDvsService",
            "$q",
            "defaultUriSchemeUtil"
        ];
        return ExportDvsDialogService;
    }());
    dvs_ui.ExportDvsDialogService = ExportDvsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("exportDvsDialogService", ExportDvsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var ExportDvsService = (function () {
        function ExportDvsService() {
        }
        ExportDvsService.prototype.saveCharArrayToDisk = function (charArray) {
            var saveByteArray = (function () {
                return function (data, name) {
                    var blob = new Blob(data, { type: "octet/stream" });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, name);
                    }
                    else {
                        var a = document.getElementsByClassName("invisibleExportDvsDownloadAnchor")[0];
                        var url = window.URL.createObjectURL(blob);
                        if (a) {
                            a.href = url;
                            a.download = name;
                            a.click();
                        }
                        window.URL.revokeObjectURL(url);
                    }
                };
            }());
            var bytes = this.base64ToArrayBuffer(charArray);
            saveByteArray([bytes], 'backup.zip');
        };
        ExportDvsService.prototype.base64ToArrayBuffer = function (base64) {
            var binaryString = window.atob(base64);
            var binaryLength = binaryString.length;
            var bytes = new Uint8Array(binaryLength);
            for (var i = 0; i < binaryLength; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        };
        return ExportDvsService;
    }());
    dvs_ui.ExportDvsService = ExportDvsService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("exportDvsService", ExportDvsService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var ExportDvsPageModel = (function () {
        function ExportDvsPageModel() {
        }
        return ExportDvsPageModel;
    }());
    dvs_ui.ExportDvsPageModel = ExportDvsPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckManageViewComponent = (function () {
        function DvsHealthCheckManageViewComponent() {
            this.bindings = {};
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/manage/dvsHealthCheckManageViewTemplate.html";
            this.controller = DvsHealthCheckManageViewController;
        }
        return DvsHealthCheckManageViewComponent;
    }());
    dvs_ui.DvsHealthCheckManageViewComponent = DvsHealthCheckManageViewComponent;
    var DvsHealthCheckManageViewController = (function () {
        function DvsHealthCheckManageViewController($scope, $rootScope, i18nService, propertyViewService, dataService) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
            this.dataService = dataService;
            this.liveRefreshProperties = [
                "config.healthCheckConfig"
            ];
        }
        DvsHealthCheckManageViewController.prototype.$onChanges = function () {
            this.refreshPropertyView();
        };
        DvsHealthCheckManageViewController.prototype.refreshPropertyView = function () {
            var _this = this;
            this.$scope.healthCheckManageLoading = true;
            this.dvsUri = this.$rootScope._route.objectId;
            this.title = this.i18nService.getString("DvsUi", "healthCheck.manage.view.title");
            this.action = [{
                    actionUid: "vsphere.core.dvs.editHealthCheckSettings",
                    customLabel: this.i18nService.getString("DvsUi", "DvsPropertiesView.edit.label")
                }];
            var requestPromise = this.dataService.getProperties(this.dvsUri, [DvsHealthCheckManageViewController
                    .HEALTH_CHECK_DETAILS_DATA_PROPERTY]);
            requestPromise.then(function (healthCheckManageResult) {
                if (healthCheckManageResult &&
                    healthCheckManageResult[DvsHealthCheckManageViewController
                        .HEALTH_CHECK_DETAILS_DATA_PROPERTY]) {
                    var healthCheckSettingsData = healthCheckManageResult[DvsHealthCheckManageViewController
                        .HEALTH_CHECK_DETAILS_DATA_PROPERTY];
                    _this.healthCheckManagePropertyViewData =
                        _this.buildPropertyView(healthCheckSettingsData.vlanMtuEnabledLabel, healthCheckSettingsData.teamingAndFailoverEnabledLabel);
                }
                else {
                    _this.healthCheckManagePropertyViewData =
                        _this.buildPropertyView(_this.i18nService.getString("DvsUi", "healthCheck.manage.view.na"), _this.i18nService.getString("DvsUi", "healthCheck.manage.view.na"));
                }
                _this.$scope.healthCheckManageLoading = false;
            });
        };
        DvsHealthCheckManageViewController.prototype.buildPropertyView = function (vlanMtuEnabledValue, teamingAndFailoverEnabledValue) {
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var propertiesCategory = builder.category("properties");
            var generalSection = propertiesCategory.section("general");
            generalSection.property(this.i18nService.getString("DvsUi", "healthCheck.manage.view.vlanMtuProperty"), vlanMtuEnabledValue);
            generalSection.property(this.i18nService.getString("DvsUi", "healthCheck.manage.view.teamingProperty"), teamingAndFailoverEnabledValue);
            return builder.build();
        };
        DvsHealthCheckManageViewController.$inject = [
            "$scope",
            "$rootScope",
            "i18nService",
            "vxPropertyViewService",
            "dataService"];
        DvsHealthCheckManageViewController.HEALTH_CHECK_DETAILS_DATA_PROPERTY = "dvsHealthCheckManage:dvsHealthCheckSettingsData";
        return DvsHealthCheckManageViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHealthCheckManageView", new DvsHealthCheckManageViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckManageDialogComponent = (function () {
        function DvsHealthCheckManageDialogComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/manage/editdialog/dvsHealthCheckManageDialogTemplate.html";
            this.controller = DvsHealthCheckManageDialogController;
        }
        return DvsHealthCheckManageDialogComponent;
    }());
    dvs_ui.DvsHealthCheckManageDialogComponent = DvsHealthCheckManageDialogComponent;
    var DvsHealthCheckManageDialogController = (function () {
        function DvsHealthCheckManageDialogController(i18nService, vxValidatorFactory, dvsHealthCheckManageDialogValidator) {
            this.i18nService = i18nService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.dvsHealthCheckManageDialogValidator = dvsHealthCheckManageDialogValidator;
            this.i18n = this.i18nService.getString;
            this.validator = vxValidatorFactory.create();
            this.validateVlanAndMtuInterval =
                this.vlanAndMtuIntervalValidator.bind(this);
            this.validateTeamingAndFailoverInterval =
                this.teamingAndFailoverIntervalValidator.bind(this);
            this.options = [{
                    value: true,
                    label: this.i18nService.getString("DvsUi", "healthCheck.manage.enabled")
                }, {
                    value: false,
                    label: this.i18nService.getString("DvsUi", "healthCheck.manage.disabled")
                }];
        }
        DvsHealthCheckManageDialogController.prototype.vlanAndMtuIntervalValidator = function () {
            var message = this.dvsHealthCheckManageDialogValidator
                .getMonitoringIntervalValidationMessage(this.pageModel.vlanMtuInterval, this.i18n('DvsUi', 'healthCheck.manage.view.vlanMtuProperty'));
            return message ? [message] : [];
        };
        DvsHealthCheckManageDialogController.prototype.teamingAndFailoverIntervalValidator = function () {
            var message = this.dvsHealthCheckManageDialogValidator
                .getMonitoringIntervalValidationMessage(this.pageModel.teamingAndFailoverInterval, this.i18n('DvsUi', 'healthCheck.manage.view.teamingProperty'));
            return message ? [message] : [];
        };
        DvsHealthCheckManageDialogController.$inject = [
            "i18nService",
            "vxValidatorFactory",
            "dvsHealthCheckManageDialogValidator"];
        return DvsHealthCheckManageDialogController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHealthCheckManageDialog", new DvsHealthCheckManageDialogComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpdateHealthCheckSpec = com.vmware.vsphere.client.dvs.api.spec.DvsUpdateHealthCheckSpec;
    var VmwareDistributedVirtualSwitch$VlanMtuHealthCheckConfig = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VlanMtuHealthCheckConfig;
    var VmwareDistributedVirtualSwitch$TeamingHealthCheckConfig = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$TeamingHealthCheckConfig;
    var DvsHealthCheckManageDialogModel = (function () {
        function DvsHealthCheckManageDialogModel(data) {
            this.data = data;
            this.vlanMtuEanbled = data.vlanMtuEnabled;
            this.teamingAndFailoverEanbled = data.teamingAndFailoverEnabled;
            this.vlanMtuInterval = data.vlanMtuEnabled ? data.vlanMtuInterval : 1;
            this.teamingAndFailoverInterval = data.teamingAndFailoverEnabled ?
                data.teamingAndFailoverInterval : 1;
        }
        DvsHealthCheckManageDialogModel.prototype.buildSpec = function (model) {
            var dvsHealthCheckConfig = this.getInitialConfig();
            var hasUpdates = false;
            for (var _i = 0, dvsHealthCheckConfig_1 = dvsHealthCheckConfig; _i < dvsHealthCheckConfig_1.length; _i++) {
                var config = dvsHealthCheckConfig_1[_i];
                if (config instanceof VmwareDistributedVirtualSwitch$VlanMtuHealthCheckConfig &&
                    (config.enable !== model.vlanMtuEanbled ||
                        config.interval !== model.vlanMtuInterval)) {
                    var index = dvsHealthCheckConfig.indexOf(config);
                    dvsHealthCheckConfig[index].enable = model.vlanMtuEanbled;
                    dvsHealthCheckConfig[index].interval =
                        dvsHealthCheckConfig[index].enable ? model.vlanMtuInterval : 0;
                    hasUpdates = true;
                }
                else if (config instanceof VmwareDistributedVirtualSwitch$TeamingHealthCheckConfig &&
                    (config.enable !== model.teamingAndFailoverEanbled ||
                        config.interval !== model.teamingAndFailoverInterval)) {
                    var index = dvsHealthCheckConfig.indexOf(config);
                    dvsHealthCheckConfig[index].enable =
                        model.teamingAndFailoverEanbled;
                    dvsHealthCheckConfig[index].interval =
                        dvsHealthCheckConfig[index].enable ?
                            model.teamingAndFailoverInterval : 0;
                    hasUpdates = true;
                }
            }
            var spec = new DvsUpdateHealthCheckSpec();
            spec.config = dvsHealthCheckConfig;
            return hasUpdates ? spec : null;
        };
        DvsHealthCheckManageDialogModel.prototype.getInitialConfig = function () {
            var healthCheckConfig = [];
            // VLAN and MTU config
            var vlanHealthCheckConfig = new VmwareDistributedVirtualSwitch$VlanMtuHealthCheckConfig();
            vlanHealthCheckConfig.enable = this.vlanMtuEanbled;
            vlanHealthCheckConfig.interval = this.vlanMtuInterval;
            // Teaming and Fail config
            var teamingHealthCheckConfig = new VmwareDistributedVirtualSwitch$TeamingHealthCheckConfig();
            teamingHealthCheckConfig.enable = this.teamingAndFailoverEanbled;
            teamingHealthCheckConfig.interval = this.teamingAndFailoverInterval;
            healthCheckConfig.push(vlanHealthCheckConfig);
            healthCheckConfig.push(teamingHealthCheckConfig);
            return healthCheckConfig;
        };
        return DvsHealthCheckManageDialogModel;
    }());
    dvs_ui.DvsHealthCheckManageDialogModel = DvsHealthCheckManageDialogModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckManageDialogService = (function () {
        function DvsHealthCheckManageDialogService(dataService, i18nService, $q, clarityModalService, mutationService, clarityConstants, dvsHealthCheckManageDialogValidator) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.clarityConstants = clarityConstants;
            this.dvsHealthCheckManageDialogValidator = dvsHealthCheckManageDialogValidator;
        }
        DvsHealthCheckManageDialogService.prototype.show = function (dvsUrn) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "healthCheck.manage.editTitle"),
                defaultButton: "submit",
                alerts: [],
                dialogData: {},
                contentTemplate: "dvs-ui/resources/dvs/healthcheck/manage/editdialog/dvsHealthCheckManageDialog.html"
            };
            var dvsPromise = this.dataService.getProperties(dvsUrn, DvsHealthCheckManageDialogService.DVS_HEALTH_CHECK_DATA_PROPERTY);
            var initialModel = null;
            dvsPromise.then(function (dataServiceResponse) {
                if (dataServiceResponse && dataServiceResponse[DvsHealthCheckManageDialogService.DVS_HEALTH_CHECK_DATA_PROPERTY]) {
                    var dataResponse = dataServiceResponse[DvsHealthCheckManageDialogService.DVS_HEALTH_CHECK_DATA_PROPERTY];
                    var trimmedName = dataResponse.name.trim();
                    var escapedName = trimmedName.replace(/%25/g, "%")
                        .replace(/%2f/g, "\/").replace(/%5c/g, "\\");
                    modalOptions.subTitle = escapedName;
                    modalOptions.dialogData.pageModel =
                        new dvs_ui.DvsHealthCheckManageDialogModel(dataResponse);
                    initialModel = new dvs_ui.DvsHealthCheckManageDialogModel(dataResponse);
                }
            });
            modalOptions.onSubmit = function () { return _this.onSubmit(initialModel, modalOptions, dvsUrn); };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsHealthCheckManageDialogService.prototype.onSubmit = function (initialModel, modalOptions, dvsUrn) {
            var _this = this;
            var dvsHealthConfigSpec = initialModel ?
                initialModel.buildSpec(modalOptions.dialogData.pageModel) : null;
            if (dvsHealthConfigSpec === null) {
                return true;
            }
            var messages = this.dvsHealthCheckManageDialogValidator.getAllErrors(modalOptions.dialogData.pageModel);
            if (messages.length > 0) {
                modalOptions.alerts = _.map(messages, function (message) {
                    return {
                        type: _this.clarityConstants.notifications.type.ERROR,
                        text: message
                    };
                });
                return false;
            }
            if ((modalOptions.dialogData.pageModel.vlanMtuEanbled &&
                modalOptions.dialogData.pageModel.vlanMtuInterval === 0) ||
                (modalOptions.dialogData.pageModel.teamingAndFailoverEanbled &&
                    modalOptions.dialogData.pageModel.teamingAndFailoverInterval === 0)) {
                return this.showWarningDialog(dvsUrn, dvsHealthConfigSpec._type, dvsHealthConfigSpec);
            }
            this.mutationService.apply(dvsUrn, dvsHealthConfigSpec._type, dvsHealthConfigSpec);
            return true;
        };
        DvsHealthCheckManageDialogService.prototype.showWarningDialog = function (dvsUrn, type, dvsHealthConfigSpec) {
            var _this = this;
            var confirmationDefered = this.$q.defer();
            var onSubmit = function () {
                _this.mutationService.apply(dvsUrn, type, dvsHealthConfigSpec);
                confirmationDefered.resolve(true);
            };
            var onCancel = function () {
                confirmationDefered.resolve(false);
            };
            var modalOptions = {
                title: this.i18nService.getString('DvsUi', 'healthCheck.manage.dialog.warningDialogTitle'),
                message: this.i18nService.getString('DvsUi', 'healthCheck.manage.dialog.warningMessage'),
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                },
                submit: onSubmit,
                onCancel: onCancel,
                preserveNewlines: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
            return confirmationDefered.promise;
        };
        DvsHealthCheckManageDialogService.$inject = [
            "dataService",
            "i18nService",
            "$q",
            "clarityModalService",
            "mutationService",
            "clarityConstants",
            "dvsHealthCheckManageDialogValidator"];
        DvsHealthCheckManageDialogService.DVS_HEALTH_CHECK_DATA_PROPERTY = "dvsHealthCheckManage:dvsHealthCheckSettingsData";
        return DvsHealthCheckManageDialogService;
    }());
    dvs_ui.DvsHealthCheckManageDialogService = DvsHealthCheckManageDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsHealthCheckManageDialogService", DvsHealthCheckManageDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckManageDialogValidator = (function () {
        function DvsHealthCheckManageDialogValidator(i18nService, networkUtil) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this.i18n = i18nService.getString;
        }
        DvsHealthCheckManageDialogValidator.prototype.getAllErrors = function (pageModel) {
            var messages = [];
            if (pageModel.vlanMtuInterval === null || pageModel.vlanMtuInterval === undefined) {
                var errorMessage = this.i18n('DvsUi', 'healthCheck.manage.dialog.errorMessage', this.i18n('DvsUi', 'healthCheck.manage.view.vlanMtuProperty'));
                messages.push(errorMessage);
            }
            else {
                var message = this.getMonitoringIntervalValidationMessage(pageModel.vlanMtuInterval, this.i18n('DvsUi', 'healthCheck.manage.view.vlanMtuProperty'));
                if (message) {
                    messages.push(message);
                }
            }
            if (pageModel.teamingAndFailoverInterval === null ||
                pageModel.teamingAndFailoverInterval === undefined) {
                var errorMessage = this.i18n('DvsUi', 'healthCheck.manage.dialog.errorMessage', this.i18n('DvsUi', 'healthCheck.manage.view.teamingProperty'));
                messages.push(errorMessage);
            }
            else {
                var message = this.getMonitoringIntervalValidationMessage(pageModel.teamingAndFailoverInterval, this.i18n('DvsUi', 'healthCheck.manage.view.teamingProperty'));
                if (message) {
                    messages.push(message);
                }
            }
            return messages;
        };
        DvsHealthCheckManageDialogValidator.prototype.getMonitoringIntervalValidationMessage = function (monitoringInterval, monitoringType) {
            var errorMessage = this.i18n('DvsUi', 'healthCheck.manage.dialog.errorMessage', monitoringType);
            if (monitoringInterval === null || monitoringInterval === undefined) {
                return errorMessage;
            }
            else {
                return this.getNumericInputValidationMessage(monitoringInterval, errorMessage);
            }
        };
        DvsHealthCheckManageDialogValidator.prototype.getNumericInputValidationMessage = function (value, errorMessage) {
            if (!this.networkUtil.isPositiveInteger(Number(value))) {
                return errorMessage;
            }
            return null;
        };
        DvsHealthCheckManageDialogValidator.$inject = [
            "i18nService",
            "networkUtil"
        ];
        return DvsHealthCheckManageDialogValidator;
    }());
    dvs_ui.DvsHealthCheckManageDialogValidator = DvsHealthCheckManageDialogValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsHealthCheckManageDialogValidator", DvsHealthCheckManageDialogValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckMonitorDetailsViewComponent = (function () {
        function DvsHealthCheckMonitorDetailsViewComponent() {
            this.bindings = {
                hostName: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/monitor/components/dvsHealthCheckMonitorDetailsViewTemplate.html";
            this.controller = DvsHealthCheckMonitorDetailsViewController;
        }
        return DvsHealthCheckMonitorDetailsViewComponent;
    }());
    dvs_ui.DvsHealthCheckMonitorDetailsViewComponent = DvsHealthCheckMonitorDetailsViewComponent;
    var DvsHealthCheckMonitorDetailsViewController = (function () {
        function DvsHealthCheckMonitorDetailsViewController(i18nService, $rootScope, $scope, vuiConstants, dataService) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.i18n = this.i18nService.getString;
        }
        DvsHealthCheckMonitorDetailsViewController.prototype.$onChanges = function () {
            if (!this.healthCheckDetailsData) {
                this.refresh(this.hostName);
            }
            else {
                this.$scope.healthCheckDetailsLoading = true;
                this.filterDataForHost(this.hostName);
                this.$scope.healthCheckDetailsLoading = false;
            }
        };
        DvsHealthCheckMonitorDetailsViewController.prototype.refresh = function (hostName) {
            var _this = this;
            this.dvsUrn = this.$rootScope._route.objectId;
            this.$scope.healthCheckDetailsLoading = true;
            var requestPromise = this.dataService.getProperties(this.dvsUrn, [DvsHealthCheckMonitorDetailsViewController
                    .HEALTH_CHECK_DETAILS_DATA_PROPERTY]);
            requestPromise
                .then(function (healthCheckDetailsDataResult) {
                if (healthCheckDetailsDataResult &&
                    healthCheckDetailsDataResult[DvsHealthCheckMonitorDetailsViewController
                        .HEALTH_CHECK_DETAILS_DATA_PROPERTY]) {
                    _this.healthCheckDetailsData =
                        healthCheckDetailsDataResult[DvsHealthCheckMonitorDetailsViewController
                            .HEALTH_CHECK_DETAILS_DATA_PROPERTY];
                    _this.filterDataForHost(hostName);
                }
            }).finally(function () {
                _this.$scope.healthCheckDetailsLoading = false;
            });
            this.liveRefreshProperties = [
                "runtime"
            ];
        };
        DvsHealthCheckMonitorDetailsViewController.prototype.filterDataForHost = function (hostName) {
            var filteredHealthCheckVlanData = new Array();
            var filteredHealthCheckMtuData = new Array();
            for (var _i = 0, _a = this.healthCheckDetailsData.detailsItemsData; _i < _a.length; _i++) {
                var dataItem = _a[_i];
                if (dataItem !== null) {
                    if (dataItem.hostName === hostName && dataItem.vlanStatus !== null) {
                        filteredHealthCheckVlanData.push(dataItem);
                    }
                    if (dataItem.hostName === hostName && dataItem.mtuStatus !== null) {
                        filteredHealthCheckMtuData.push(dataItem);
                    }
                    if (dataItem.hostName === hostName && dataItem.teamingStatus !== null) {
                        this.$scope.healthCheckIpHashData = dataItem;
                    }
                }
                else {
                    this.$scope.healthCheckIpHashData = null;
                }
            }
            this.$scope.healthCheckVlanItemsData = filteredHealthCheckVlanData ?
                filteredHealthCheckVlanData : [];
            this.$scope.healthCheckMtuItemsData = filteredHealthCheckMtuData ?
                filteredHealthCheckMtuData : [];
        };
        DvsHealthCheckMonitorDetailsViewController.$inject = ["i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "dataService"];
        DvsHealthCheckMonitorDetailsViewController.HEALTH_CHECK_DETAILS_DATA_PROPERTY = "dvsHealthCheckMonitor:dvsHealthCheckDetailsData";
        return DvsHealthCheckMonitorDetailsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHealthCheckMonitorDetailsView", new DvsHealthCheckMonitorDetailsViewComponent());
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckMonitorIpHashViewComponent = (function () {
        function DvsHealthCheckMonitorIpHashViewComponent() {
            this.bindings = {
                healthCheckIpHashData: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/monitor/components/dvsHealthCheckMonitorIpHashViewTemplate.html";
            this.controller = DvsHealthCheckMonitorIpHashViewController;
        }
        return DvsHealthCheckMonitorIpHashViewComponent;
    }());
    dvs_ui.DvsHealthCheckMonitorIpHashViewComponent = DvsHealthCheckMonitorIpHashViewComponent;
    var DvsHealthCheckMonitorIpHashViewController = (function () {
        function DvsHealthCheckMonitorIpHashViewController(i18nService, propertyViewService) {
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
        }
        DvsHealthCheckMonitorIpHashViewController.prototype.$onChanges = function () {
            this.buildPropertyView();
        };
        DvsHealthCheckMonitorIpHashViewController.prototype.buildPropertyView = function () {
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var propertiesCategory = builder.category("properties");
            var generalSection = propertiesCategory.section("general");
            var teamingStatus;
            var teamingStatusIcon;
            if (this.healthCheckIpHashData) {
                if (this.healthCheckIpHashData.teamingStatus &&
                    this.healthCheckIpHashData.teamingStatusIcon) {
                    teamingStatus = this.healthCheckIpHashData.teamingStatus;
                    teamingStatusIcon = this.healthCheckIpHashData.teamingStatusIcon;
                }
                else {
                    teamingStatus = this.i18nService.getString("DvsUi", "healthCheck.monitor.status.unknwon");
                    teamingStatusIcon = "vsphere-icon-status-unknown";
                }
                generalSection.propertyBuilder()
                    .keyBuilder().text(this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.statusPropName"))
                    .exit()
                    .valueBuilder()
                    .icon(teamingStatusIcon)
                    .text(teamingStatus)
                    .exit()
                    .exit();
                if (this.healthCheckIpHashData.ipHashDetails) {
                    generalSection.property(this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.detailsPropName"), this.healthCheckIpHashData.ipHashDetails);
                }
                else {
                    generalSection.property(this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.detailsPropName"), this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.na"));
                }
            }
            else {
                teamingStatus = this.i18nService.getString("DvsUi", "healthCheck.monitor.status.unknwon");
                teamingStatusIcon = "vsphere-icon-status-unknown";
                generalSection.propertyBuilder()
                    .keyBuilder().text(this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.statusPropName"))
                    .exit()
                    .valueBuilder()
                    .icon(teamingStatusIcon)
                    .text(teamingStatus)
                    .exit()
                    .exit();
                generalSection.property(this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.detailsPropName"), this.i18nService.getString("DvsUi", "healthCheck.monitor.health.tab.teaming.na"));
            }
            this.healthCheckIpHashPropertyViewData = builder.build();
        };
        DvsHealthCheckMonitorIpHashViewController.$inject = [
            "i18nService",
            "vxPropertyViewService"];
        return DvsHealthCheckMonitorIpHashViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvsHealthCheckMonitorIpHashView", new DvsHealthCheckMonitorIpHashViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckMonitorMtuViewComponent = (function () {
        function DvsHealthCheckMonitorMtuViewComponent() {
            this.bindings = {
                healthCheckMtuItemsData: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/monitor/components/dvsHealthCheckMonitorVlanMtuViewTemplate.html";
            this.controller = DvsHealthCheckMonitorMtuController;
        }
        return DvsHealthCheckMonitorMtuViewComponent;
    }());
    dvs_ui.DvsHealthCheckMonitorMtuViewComponent = DvsHealthCheckMonitorMtuViewComponent;
    var DvsHealthCheckMonitorMtuController = (function () {
        function DvsHealthCheckMonitorMtuController(i18nService, $rootScope, $scope, vuiConstants, columnRenderersRegistry, pnicSettingsDialogService, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.pnicSettingsDialogService = pnicSettingsDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.createDataGrid(this.healthCheckMtuItemsData);
        }
        DvsHealthCheckMonitorMtuController.prototype.$onInit = function () {
            this.refresh();
        };
        DvsHealthCheckMonitorMtuController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.healthCheckMtuItemsData ?
                this.healthCheckMtuItemsData : [];
        };
        DvsHealthCheckMonitorMtuController.prototype.refresh = function () {
            this.createDataGrid(this.healthCheckMtuItemsData);
        };
        DvsHealthCheckMonitorMtuController.prototype.createDataGrid = function (healthCheckVlanItemsData) {
            var _this = this;
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: healthCheckVlanItemsData,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                showPnicDialog: function (item) {
                    _this.pnicSettingsDialogService.show(_this.defaultUriSchemeUtil.getVsphereObjectId(item.hostMor), item.pnicName, item.hostName);
                }
            };
        };
        DvsHealthCheckMonitorMtuController.prototype.createColumnDefinitions = function () {
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("icon-text");
            return [{
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.uplink.column"),
                    field: "uplinkName",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.pnic.column"),
                    field: "pnicName",
                    width: "150px",
                    template: function (dataItem) {
                        var renderer = columnRenderer(["icon", "text"], {
                            icon: DvsHealthCheckMonitorMtuController.PNIC_ICON_ID,
                            text: dataItem.pnicName });
                        var renderClickable = [
                            '<a ng-click="datagridOptions.showPnicDialog(dataItem)">',
                            renderer,
                            '</a>'].join('');
                        return renderClickable;
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.mtu.mtuStatus.column"),
                    field: "mtuStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer(["icon", "text"], {
                            icon: data.mtuStatusIcon,
                            text: data.mtuStatus });
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.trunk.column"),
                    field: "vlanTrunk",
                    width: "150px"
                }];
        };
        DvsHealthCheckMonitorMtuController.$inject = ["i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "pnicSettingsDialogService",
            "defaultUriSchemeUtil"];
        DvsHealthCheckMonitorMtuController.PNIC_ICON_ID = "network-lib-ui-icon-physicalAdapter";
        return DvsHealthCheckMonitorMtuController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHealthCheckMonitorMtuView", new DvsHealthCheckMonitorMtuViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckMonitorViewComponent = (function () {
        function DvsHealthCheckMonitorViewComponent() {
            this.bindings = {
                healthCheckStatusData: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/monitor/components/dvsHealthCheckMonitorViewTemplate.html";
            this.controller = DvsHealthCheckMonitorViewController;
        }
        return DvsHealthCheckMonitorViewComponent;
    }());
    dvs_ui.DvsHealthCheckMonitorViewComponent = DvsHealthCheckMonitorViewComponent;
    var DvsHealthCheckMonitorViewController = (function () {
        function DvsHealthCheckMonitorViewController($q, $rootScope, $scope, i18nService, dataService, vuiConstants, columnRenderersRegistry, networkUiConstants) {
            var _this = this;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUiConstants = networkUiConstants;
            this.preselectComparator = function (item) {
                return !!_this.$scope.hostName &&
                    _this.$scope.hostName === item.hostName;
            };
            this.i18n = this.i18nService.getString;
            this.createHealthCheckStatusDatagridOptions(this.dvsHealthCheckItemsData);
        }
        DvsHealthCheckMonitorViewController.prototype.$onInit = function () {
            this.showNoItemSelected = true;
            this.refresh();
        };
        DvsHealthCheckMonitorViewController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.dvsHealthCheckItemsData ?
                this.dvsHealthCheckItemsData : [];
            this.$scope.refreshDetails = true;
        };
        DvsHealthCheckMonitorViewController.prototype.refresh = function () {
            var _this = this;
            this.$scope.healthCheckLoading = true;
            this.$scope.refreshDetails = true;
            this.dvsUri = this.$rootScope._route.objectId;
            this.headerOptions = {
                title: this.i18nService.getString("DvsUi", "healthCheck.monitor.masterTitle"),
                objectId: this.dvsUri,
                actions: null
            };
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "150px",
                        size: "45%"
                    }, {
                        min: "250px",
                        size: "55%"
                    }
                ]
            };
            var dvsHealthCheckDataPromise = this.dataService
                .getProperties(this.dvsUri, [DvsHealthCheckMonitorViewController
                    .HEALTH_CHECK_DATA_PROPERTY_NAME]);
            dvsHealthCheckDataPromise
                .then(function (response) {
                if (response[DvsHealthCheckMonitorViewController
                    .HEALTH_CHECK_DATA_PROPERTY_NAME]) {
                    var dvsHealthCheckData = response[DvsHealthCheckMonitorViewController
                        .HEALTH_CHECK_DATA_PROPERTY_NAME];
                    _this.overallHealthCheckStatus =
                        dvsHealthCheckData.normalOverallHealthCheckStatus ?
                            _this.i18n("DvsUi", "healthCheck.monitor.status.normal") :
                            _this.i18n("DvsUi", "healthCheck.monitor.status.warning");
                    _this.overallHealthCheckStatusIcon =
                        dvsHealthCheckData.overallHealthCheckStatusIcon;
                    _this.showWarningsLinkBtn =
                        !dvsHealthCheckData.normalOverallHealthCheckStatus;
                    if (_this.showWarningsLinkBtn) {
                        _this.signPostContent =
                            _this.buildSignPostContentView(dvsHealthCheckData);
                        _this.signPostCustomTriggerBtnLabel =
                            _this.i18n("DvsUi", "healthCheck.monitor.status.issues", dvsHealthCheckData.overallWarningsCount);
                    }
                    _this.vlanMtuHealthCheckEnablement =
                        dvsHealthCheckData.vlanAndMtuHealthCheckEnabled ?
                            _this.i18n("DvsUi", "healthCheck.monitor.enabled") :
                            _this.i18n("DvsUi", "healthCheck.monitor.disabled");
                    _this.teamingHealthCheckEnablement =
                        dvsHealthCheckData.teamingAndFailoverHealthCheckEnabled ?
                            _this.i18n("DvsUi", "healthCheck.monitor.enabled") :
                            _this.i18n("DvsUi", "healthCheck.monitor.disabled");
                    _this.dvsHealthCheckItemsData =
                        dvsHealthCheckData.dvsHealthCheckItems ?
                            dvsHealthCheckData.dvsHealthCheckItems : [];
                    _this.createHealthCheckStatusDatagridOptions(_this.dvsHealthCheckItemsData);
                    _this.$scope.healthCheckLoading = false;
                }
            });
            this.liveRefreshProperties = [
                "runtime",
                "config.healthCheckConfig"
            ];
        };
        DvsHealthCheckMonitorViewController.prototype.createHealthCheckStatusDatagridOptions = function (dvsHealthCheckItemsData) {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: dvsHealthCheckItemsData,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                actionBarOptions: {
                    actions: []
                },
                onChange: this.onSelectionChange.bind(this)
            };
        };
        DvsHealthCheckMonitorViewController.prototype.createColumnDefinitions = function () {
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            return [{
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.hostName.column"),
                    field: "hostNameFormated",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "hostNameFormated",
                            data.hostIcon], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.state.column"),
                    field: "hostState",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.vdsStatus.column"),
                    field: "dvsStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "dvsStatus",
                            data.dvsStatusIcon], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.vlanHealthStatus.column"),
                    field: "vlanHealthStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "vlanHealthStatus",
                            data.vlanHealthStatusIcon], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.mtuHealthStatus.column"),
                    field: "mtuHealthStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "mtuHealthStatus",
                            data.mtuHealthStatusIcon], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.grid.teamingHealthStatus.column"),
                    field: "teamingAndFailoverHealthStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "teamingAndFailoverHealthStatus",
                            data.teamingAndFailoverHealthStatusIcon], data);
                    }
                }];
        };
        DvsHealthCheckMonitorViewController.prototype.onSelectionChange = function (items) {
            if (items && items.length > 0) {
                this.$scope.hostName = items[0].hostName;
                this.showNoItemSelected = false;
            }
            else {
                this.$scope.hostName = null;
                this.showNoItemSelected = true;
            }
        };
        DvsHealthCheckMonitorViewController.prototype.buildSignPostContentView = function (dvsHealthCheckData) {
            this.propertyValueDictionary = [];
            this.propertyValueDictionary.push({
                property: this.i18n("DvsUi", "healthCheck.monitor.signpost.disconnectedHosts"),
                value: dvsHealthCheckData.disconnectedHostsCount
            }, {
                property: this.i18n("DvsUi", "healthCheck.monitor.signpost.outOfSyncHosts"),
                value: dvsHealthCheckData.outOfSyncHostsCount
            }, {
                property: this.i18n("DvsUi", "healthCheck.monitor.signpost.unsupportedVlan"),
                value: dvsHealthCheckData.unsupportedVlansCount
            }, {
                property: this.i18n("DvsUi", "healthCheck.monitor.signpost.mtuMismatch"),
                value: dvsHealthCheckData.mtuMismatchCount
            }, {
                property: this.i18n("DvsUi", "healthCheck.monitor.signpost.ipHashMismatch"),
                value: dvsHealthCheckData.ipHashMismatchCount
            });
            var rowElements = [];
            for (var _i = 0, _a = this.propertyValueDictionary; _i < _a.length; _i++) {
                var propertyValuePair = _a[_i];
                rowElements.push("<div class=\"row\">\n               <div class=\"col-md-8\">\n                  <span class=\"nw-property-label-group\">\n                     " + propertyValuePair.property + "\n                  </span>\n               </div>\n               <div class=\"col-md-2\">\n                  <span class=\"nw-property-label-group\">\n                     " + propertyValuePair.value + "\n                  </span>\n               </div>\n            </div>");
            }
            return rowElements.join(" ");
        };
        DvsHealthCheckMonitorViewController.$inject = [
            "$q",
            "$rootScope",
            "$scope",
            "i18nService",
            "dataService",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUiConstants",
            "vxPropertyViewService"
        ];
        DvsHealthCheckMonitorViewController.HEALTH_CHECK_DATA_PROPERTY_NAME = "dvsHealthCheckMonitor:dvsHealthCheckData";
        return DvsHealthCheckMonitorViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs").component("dvsHealthCheckMonitorView", new DvsHealthCheckMonitorViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHealthCheckMonitorVlanViewComponent = (function () {
        function DvsHealthCheckMonitorVlanViewComponent() {
            this.bindings = {
                healthCheckVlanItemsData: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/healthcheck/monitor/components/dvsHealthCheckMonitorVlanMtuViewTemplate.html";
            this.controller = DvsHealthCheckMonitorVlanController;
        }
        return DvsHealthCheckMonitorVlanViewComponent;
    }());
    dvs_ui.DvsHealthCheckMonitorVlanViewComponent = DvsHealthCheckMonitorVlanViewComponent;
    var DvsHealthCheckMonitorVlanController = (function () {
        function DvsHealthCheckMonitorVlanController(i18nService, $rootScope, $scope, vuiConstants, columnRenderersRegistry, pnicSettingsDialogService, defaultUriSchemeUtil, $compile) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.pnicSettingsDialogService = pnicSettingsDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$compile = $compile;
            this.createDataGrid(this.healthCheckVlanItemsData);
        }
        DvsHealthCheckMonitorVlanController.prototype.$onInit = function () {
            this.refresh();
        };
        DvsHealthCheckMonitorVlanController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.healthCheckVlanItemsData ?
                this.healthCheckVlanItemsData : [];
        };
        DvsHealthCheckMonitorVlanController.prototype.refresh = function () {
            this.createDataGrid(this.healthCheckVlanItemsData);
        };
        DvsHealthCheckMonitorVlanController.prototype.createDataGrid = function (healthCheckVlanItemsData) {
            var _this = this;
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: healthCheckVlanItemsData,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                showPnicDialog: function (item) {
                    _this.pnicSettingsDialogService.show(_this.defaultUriSchemeUtil.getVsphereObjectId(item.hostMor), item.pnicName, item.hostName);
                }
            };
        };
        DvsHealthCheckMonitorVlanController.prototype.createColumnDefinitions = function () {
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("icon-text");
            return [{
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.uplink.column"),
                    field: "uplinkName",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.pnic.column"),
                    field: "pnicName",
                    width: "150px",
                    template: function (dataItem) {
                        var renderer = columnRenderer(["icon", "text"], {
                            icon: DvsHealthCheckMonitorVlanController.PNIC_ICON_ID,
                            text: dataItem.pnicName });
                        var renderClickable = [
                            '<a ng-click="datagridOptions.showPnicDialog(dataItem)">',
                            renderer,
                            '</a>'].join('');
                        return renderClickable;
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.trunk.column"),
                    field: "vlanTrunk",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "healthCheck.monitor.health.vlan.vlanStatus.column"),
                    field: "vlanStatus",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer(["icon", "text"], {
                            icon: data.vlanStatusIcon,
                            text: data.vlanStatus });
                    }
                }];
        };
        DvsHealthCheckMonitorVlanController.$inject = ["i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "pnicSettingsDialogService",
            "defaultUriSchemeUtil",
            "$compile"];
        DvsHealthCheckMonitorVlanController.PNIC_ICON_ID = "network-lib-ui-icon-physicalAdapter";
        return DvsHealthCheckMonitorVlanController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHealthCheckMonitorVlanView", new DvsHealthCheckMonitorVlanViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportComponent = (function () {
        function DvsImportComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsImportComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/import/dvsImportComponentTemplate.html";
        }
        return DvsImportComponent;
    }());
    dvs_ui.DvsImportComponent = DvsImportComponent;
    var DvpgRestoreComponent = (function () {
        function DvpgRestoreComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsImportComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/import/dvpgRestoreComponentTemplate.html";
        }
        return DvpgRestoreComponent;
    }());
    dvs_ui.DvpgRestoreComponent = DvpgRestoreComponent;
    var DvsImportComponentController = (function () {
        function DvsImportComponentController(i18nService, exportDvsConstants, $element, $timeout) {
            this.i18nService = i18nService;
            this.exportDvsConstants = exportDvsConstants;
            this.$element = $element;
            this.$timeout = $timeout;
            this.hintLabel = "";
            this.FILE_INPUT_SELECTOR = ".import-dvs-upload-file-input";
        }
        DvsImportComponentController.prototype.$onInit = function () {
            var ctrl = this;
            this.hintLabel = this.wizardModel.isDvpgConfig ?
                this.i18nService.getString("DvsUi", "dvpg.import.filePage.hintLabel") :
                this.i18nService.getString("DvsUi", "dvs.import.wizard.filePage.hintLabel");
            var dvsImportFileInput = this.$element.find(this.FILE_INPUT_SELECTOR);
            dvsImportFileInput.on("change", function (event) {
                if (event.target.files && event.target.files.length) {
                    ctrl.setImportFile(event.target.files[0]);
                }
            });
        };
        DvsImportComponentController.prototype.setImportFile = function (file) {
            // Clear out any previous configuration data until the new file
            // is completely read from the file system.
            this.wizardModel.configurationPageModel.configurationData = "";
            this._fileReader = new FileReader();
            if (this._fileReader && file) {
                this._fileReader.readAsArrayBuffer(file);
                this._fileReader.onload = this.onLoad.bind(this);
                this.wizardModel.configurationPageModel.fileLocation = file.name;
            }
        };
        DvsImportComponentController.prototype.onLoad = function () {
            var rawData = this._fileReader.result;
            var byteArray = new Uint8Array(rawData);
            this.saveByteArray(byteArray);
        };
        DvsImportComponentController.prototype.saveByteArray = function (byteArray) {
            if (this.wizardModel.isRestoreAction && this.wizardModel.isDvpgConfig) {
                if (this.wizardModel.configurationPageModel.restoreType ===
                    this.exportDvsConstants.configurationRestoreTypes.FROM_FILE) {
                    this.wizardModel.configurationPageModel.restoreDvpgConfigurationData =
                        [].slice.call(byteArray);
                }
            }
            else {
                var binaryString = this.arrayBufferToString(byteArray);
                binaryString = window.btoa(binaryString);
                this.wizardModel.configurationPageModel.configurationData =
                    binaryString;
            }
        };
        DvsImportComponentController.prototype.onBrowseButtonClicked = function () {
            var fileInput = this.$element.find(this.FILE_INPUT_SELECTOR);
            this.$timeout(function () {
                fileInput.click();
            });
        };
        /**
         * Converts a Uint8Array to a string in chunks so that
         * RangeError is prevented when Uint8Array is of a large size.
         *
         * @param {Uint8Array} byteArray
         *
         * @returns {string}
         */
        DvsImportComponentController.prototype.arrayBufferToString = function (byteArray) {
            var length = byteArray.length;
            var result = "";
            // Chunk size less than the allowed maximum number of arguments in
            // JavaScript but big enough to achieve a good performance.
            var chunkSize = Math.pow(2, 16) - 1;
            for (var i = 0; i < length; i += chunkSize) {
                if (i + chunkSize > length) {
                    chunkSize = length - i;
                }
                // Without dividing the byte array into chunks,
                // the String.fromCharCode.apply method throws
                // "Maximum call stack size exceeded" error when the file size is
                // big enough.
                result += String.fromCharCode.apply(null, byteArray.subarray(i, i + chunkSize));
            }
            return result;
        };
        DvsImportComponentController.$inject = [
            "i18nService",
            "exportDvsConstants",
            "$element",
            "$timeout"
        ];
        return DvsImportComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsImportComponent", new DvsImportComponent());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvpgRestoreComponent", new DvpgRestoreComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportReadyToCompletePageComponent = (function () {
        function DvsImportReadyToCompletePageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsImportReadyToCompletePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/import/dvsImportReadyToCompletePageComponentTemplate.html";
        }
        return DvsImportReadyToCompletePageComponent;
    }());
    dvs_ui.DvsImportReadyToCompletePageComponent = DvsImportReadyToCompletePageComponent;
    var DvsImportReadyToCompletePageComponentController = (function () {
        function DvsImportReadyToCompletePageComponentController(i18nService, vxPropertyViewService, vimEntityEscapingService, networkUiConstants) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.vimEntityEscapingService = vimEntityEscapingService;
            this.networkUiConstants = networkUiConstants;
            this.buildPropertyView();
        }
        DvsImportReadyToCompletePageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            if (this.wizardModel.isDvpgConfig) {
                if (this.wizardModel.isRestoreAction) {
                    this.buildDvpgRestorePropView(generalCategory);
                }
                else {
                    this.buildDvpgImportPropView(generalCategory);
                }
            }
            else {
                this.buildDvsImportPropView(generalCategory);
            }
            this.propertyViewData = builder.build();
        };
        DvsImportReadyToCompletePageComponentController.prototype.getPortBindingLabel = function (portBinding) {
            var portBindingValue = "";
            if (this.networkUiConstants.PortgroupType.EARLY_BINDING === portBinding) {
                portBindingValue = "dvpg.import.summary.portBinding.static";
            }
            else if (this.networkUiConstants.PortgroupType.LATE_BINDING === portBinding) {
                portBindingValue = "dvpg.import.summary.portBinding.dynamic";
            }
            else if (this.networkUiConstants.PortgroupType.EPHEMERAL === portBinding) {
                portBindingValue = "dvpg.import.summary.portBinding.ephemeral";
            }
            return this.i18nService.getString("DvsUi", portBindingValue);
        };
        DvsImportReadyToCompletePageComponentController.prototype.buildDvpgImportPropView = function (generalCategory) {
            var model = this.wizardModel.configurationPageModel;
            var importSettingsSection = generalCategory.section("importSettings")
                .title(this.i18nService.getString("DvsUi", "dvpg.import.summary.settingsHeader"));
            var dvsImportPortgroupSpec = model.dvsImportPortgroupWrapperSpec.dvsImportPortgroupSpec;
            // Name
            importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.nameLabel"), dvsImportPortgroupSpec.portgroupName);
            //Name error
            if (dvsImportPortgroupSpec.nameAlreadyExists) {
                importSettingsSection.message(this.i18nService.getString("DvsUi", "dvpg.import.summary.nameConflictError", dvsImportPortgroupSpec.newPortgroupName), 'vsphere-icon-status-warning');
            }
            // VLAN
            importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.vlanLabel"), model.dvsImportPortgroupWrapperSpec.vlanLabel);
            // Type
            var typeLabel = dvsImportPortgroupSpec.isUplink ?
                this.i18nService.getString("DvsUi", "dvpg.import.summary.type.uplink") :
                this.i18nService.getString("DvsUi", "dvpg.import.summary.type.standard");
            importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.typeLabel"), typeLabel);
            // Port binding
            importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.portBindingLabel"), this.getPortBindingLabel(dvsImportPortgroupSpec.portBinding));
            // Port allocation
            if (this.networkUiConstants.PortgroupType.EARLY_BINDING ===
                dvsImportPortgroupSpec.portBinding && !dvsImportPortgroupSpec.isUplink) {
                var portAllocationLabel = dvsImportPortgroupSpec.autoExpand ?
                    this.i18nService.getString("DvsUi", "dvpg.import.summary.portAllocation.elastic") :
                    this.i18nService.getString("DvsUi", "dvpg.import.summary.portAllocation.fixed");
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.portAllocationLabel"), portAllocationLabel);
            }
            //Description
            if (dvsImportPortgroupSpec.annotation) {
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvpg.import.summary.annotation"), dvsImportPortgroupSpec.annotation);
            }
        };
        DvsImportReadyToCompletePageComponentController.prototype.buildDvsImportPropView = function (generalCategory) {
            var model = this.wizardModel.configurationPageModel;
            var importSettingsSection = generalCategory.section("importSettings");
            if (this.wizardModel.isRestoreAction) {
                importSettingsSection.title(this.i18nService.getString("DvsUi", "dvs.restore.wizard.summaryPage.header"));
            }
            else {
                importSettingsSection.title(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.header"));
            }
            // File name
            importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.fileName"), model.fileLocation);
            if (model.dvsImportInfoSpec !== undefined) {
                // Switch name
                var unescapedSwitchName = this.vimEntityEscapingService
                    .unescapeSpecialCharacters(model.dvsImportInfoSpec.dvsName);
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.switchName"), unescapedSwitchName);
                // Switch version
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.switchVersion"), model.dvsImportInfoSpec.dvsVersion);
                if (model.dvsImportInfoSpec.differentContextKey &&
                    this.wizardModel.isRestoreAction) {
                    importSettingsSection.message(this.i18nService.getString("DvsUi", "dvs.restore.wizard.summaryPage.differentSwitch"), 'vsphere-icon-status-warning');
                }
                // Port groups count
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.pgCount"), model.dvsImportInfoSpec.portgroupCount);
                // Uplink count
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.uplinkCount"), model.dvsImportInfoSpec.uplinksCount);
                // NRP count
                importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.nrpCount"), model.dvsImportInfoSpec.nrpCount);
                if (model.dvsImportInfoSpec.lagCount !== undefined) {
                    // LAG count
                    importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.lagCount"), model.dvsImportInfoSpec.lagCount);
                }
                if (model.dvsImportInfoSpec.annotation) {
                    // Description
                    importSettingsSection.property(this.i18nService.getString("DvsUi", "dvs.import.wizard.summaryPage.annotation"), model.dvsImportInfoSpec.annotation).renderAsHtml(true);
                }
            }
        };
        DvsImportReadyToCompletePageComponentController.prototype.buildDvpgRestorePropView = function (generalCategory) {
            var model = this.wizardModel.configurationPageModel;
            for (var _i = 0, _a = model.dvPortgroupRestoreInfoWrapperSpec.dvpgRestoreSectionRepresentationSpec; _i < _a.length; _i++) {
                var section = _a[_i];
                var propViewSectionSection = generalCategory.section(section.sectionTitle)
                    .title(section.sectionTitle);
                for (var _b = 0, _c = section.sectionSettings; _b < _c.length; _b++) {
                    var setting = _c[_b];
                    propViewSectionSection.property(setting.key, setting.value);
                }
            }
        };
        DvsImportReadyToCompletePageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "vimEntityEscapingService",
            "networkUiConstants"
        ];
        return DvsImportReadyToCompletePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsImportReadyToCompletePageComponent", new DvsImportReadyToCompletePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportWizardConstants = (function () {
        function DvsImportWizardConstants() {
        }
        DvsImportWizardConstants.page = {
            SWITCH_CONFIGURATION_PAGE: "switchConfigurationPage",
            READY_TO_COMPLETE_PAGE: "readyToCompletePage"
        };
        return DvsImportWizardConstants;
    }());
    dvs_ui.DvsImportWizardConstants = DvsImportWizardConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Manages the page states of the Import DVS wizard.
 */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportWizardFlowManager = (function () {
        function DvsImportWizardFlowManager(pageStateManagementService) {
            this.pageStateManagementService = pageStateManagementService;
        }
        DvsImportWizardFlowManager.prototype.init = function (wizardScope) {
            this.pages = wizardScope.wizardConfig.pages;
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
        };
        DvsImportWizardFlowManager.$inject = [
            "pageStateManagementService",
            "vuiConstants"];
        return DvsImportWizardFlowManager;
    }());
    dvs_ui.DvsImportWizardFlowManager = DvsImportWizardFlowManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsImportWizardFlowManager", DvsImportWizardFlowManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvPortgroupQueryRestoreSpec = com.vmware.vsphere.client.dvs.api.spec.DvPortgroupQueryRestoreSpec;
    var DvsImportWizardPages = (function () {
        function DvsImportWizardPages(i18nService, dataService, $q, wizardPageService, clarityModalService, exportDvsConstants) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.$q = $q;
            this.wizardPageService = wizardPageService;
            this.clarityModalService = clarityModalService;
            this.exportDvsConstants = exportDvsConstants;
        }
        /**
         * Creates an array of page definitions for the Import DVS wizard.
         */
        DvsImportWizardPages.prototype.createPages = function (wizardScope, isDvpg, isRestoreAction) {
            var _this = this;
            var filePageProperties = this.getFilePageProperties(isDvpg, isRestoreAction);
            var importSwitchConfigurationPage = {
                id: dvs_ui.DvsImportWizardConstants.page.SWITCH_CONFIGURATION_PAGE,
                title: filePageProperties.filePageTitle,
                description: filePageProperties.filePageDescription,
                contentUrl: filePageProperties.filePageTemplate,
                onCommit: function () {
                    return _this.onConfigurationPageCommit(wizardScope, isDvpg, isRestoreAction);
                }
            };
            var readyToCompletePage = {
                id: dvs_ui.DvsImportWizardConstants.page.READY_TO_COMPLETE_PAGE,
                title: this.i18nService.getString("DvsUi", "dvs.import.wizard.readyToCompletePage.title"),
                description: this.i18nService.getString("DvsUi", "dvs.import.wizard.readyToCompletePage.description"),
                contentUrl: "dvs-ui/resources/dvs/import/views/dvsImportReadyToCompletePage.html",
                validationParams: [],
                validationFunction: function () {
                    return true;
                }
            };
            var pages = [importSwitchConfigurationPage,
                readyToCompletePage];
            return pages;
        };
        DvsImportWizardPages.prototype.getFilePageProperties = function (isDvpg, isRestoreAction) {
            var pageProperties = {
                filePageTitle: "",
                filePageDescription: "",
                filePageTemplate: ""
            };
            if (isRestoreAction) {
                pageProperties.filePageTitle = isDvpg ?
                    this.i18nService.getString("DvsUi", "dvpg.restore.selectPage.title") :
                    this.i18nService.getString("DvsUi", "dvs.restore.wizard.filePage.tocTitle");
                pageProperties.filePageDescription = isDvpg ?
                    this.i18nService.getString("DvsUi", "dvpg.restore.selectPage.desc") :
                    this.i18nService.getString("DvsUi", "dvs.restore.wizard.filePage.desc");
                pageProperties.filePageTemplate = isDvpg ?
                    "dvs-ui/resources/dvs/import/views/dvpgRestoreConfigurationPage.html" :
                    "dvs-ui/resources/dvs/import/views/dvsImportSwitchConfigurationPage.html";
            }
            else {
                pageProperties.filePageTitle = isDvpg ?
                    this.i18nService.getString("DvsUi", "dvpg.import.filePage.title") :
                    this.i18nService.getString("DvsUi", "dvs.import.wizard.filePage.title");
                pageProperties.filePageDescription = isDvpg ?
                    this.i18nService.getString("DvsUi", "dvpg.import.filePage.desc") :
                    this.i18nService.getString("DvsUi", "dvs.import.wizard.filePage.desc");
                pageProperties.filePageTemplate =
                    "dvs-ui/resources/dvs/import/views/dvsImportSwitchConfigurationPage.html";
            }
            return pageProperties;
        };
        DvsImportWizardPages.prototype.onConfigurationPageCommit = function (wizardScope, isDvpg, isRestoreAction) {
            var _this = this;
            var deferred = this.$q.defer();
            var hasNoConfigData = !wizardScope.model.configurationPageModel.configurationData && !(isDvpg && isRestoreAction);
            var hasNoRestoreDvpgConfigData = isDvpg && isRestoreAction &&
                wizardScope.model.configurationPageModel.restoreType !==
                    this.exportDvsConstants.configurationRestoreTypes.FROM_PREVIOUS_CONFIGURATION &&
                !wizardScope.model.configurationPageModel.restoreDvpgConfigurationData;
            if (hasNoConfigData || hasNoRestoreDvpgConfigData) {
                var localizedErrorMessage = void 0;
                if (isDvpg) {
                    localizedErrorMessage = isRestoreAction ?
                        this.i18nService.getString("DvsUi", "dvpg.restore.selectPage.selectNote") :
                        this.i18nService.getString("DvsUi", "dvpg.import.filePage.selectNote");
                }
                else {
                    localizedErrorMessage = this.i18nService.getString("DvsUi", "dvs.import.wizard.filePage.selectNote");
                }
                this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, localizedErrorMessage);
                deferred.resolve(false);
            }
            else {
                var SWITCH_IMPORT_INFO_WRAPPER_PROPERTY = "dvs:switchImportInfoWrapper";
                var DVPG_IMPORT_INFO_WRAPPER_PROPERTY_1 = "dvpg:dvpgImportInfoWrapper";
                var DVPG_RESTORE_INFO_WRAPPER_PROPERTY = "dvpg:dvpgRestoreInfoWrapper";
                var READY_TO_COMPLETE_PROPERTY_1 = SWITCH_IMPORT_INFO_WRAPPER_PROPERTY;
                if (isDvpg) {
                    READY_TO_COMPLETE_PROPERTY_1 = isRestoreAction ?
                        DVPG_RESTORE_INFO_WRAPPER_PROPERTY :
                        DVPG_IMPORT_INFO_WRAPPER_PROPERTY_1;
                }
                // [B is the string representation of the
                // Java byte[] type.
                var JAVA_BYTE_ARRAY_TYPE = "[B";
                var DVPG_RESTORE_SPEC_TYPE = new DvPortgroupQueryRestoreSpec()._type;
                wizardScope.wizardConfig.loading = true;
                var propertyParams = void 0;
                if (isDvpg && isRestoreAction) {
                    var dvpgRestoreSpec = new DvPortgroupQueryRestoreSpec();
                    if (wizardScope.model.configurationPageModel.restoreType ===
                        this.exportDvsConstants.configurationRestoreTypes.FROM_PREVIOUS_CONFIGURATION) {
                        dvpgRestoreSpec.fromMemory = true;
                    }
                    else {
                        dvpgRestoreSpec.fromMemory = false;
                        dvpgRestoreSpec.fileConfig =
                            wizardScope.model.configurationPageModel.restoreDvpgConfigurationData;
                    }
                    propertyParams = [{
                            propertyName: READY_TO_COMPLETE_PROPERTY_1,
                            parameterType: DVPG_RESTORE_SPEC_TYPE,
                            parameter: dvpgRestoreSpec
                        }];
                }
                else {
                    propertyParams = [{
                            propertyName: READY_TO_COMPLETE_PROPERTY_1,
                            parameterType: JAVA_BYTE_ARRAY_TYPE,
                            parameter: wizardScope.model.configurationPageModel.configurationData
                        }];
                }
                this.dataService.getProperties(wizardScope.model.objectId, READY_TO_COMPLETE_PROPERTY_1, {
                    propertyParams: propertyParams
                })
                    .then(function (response) {
                    if (!response || !response[READY_TO_COMPLETE_PROPERTY_1]) {
                        wizardScope.wizardConfig.loading = false;
                        deferred.resolve(false);
                    }
                    if (isDvpg) {
                        if (isRestoreAction) {
                            var dvPortgroupRestoreInfoWrapperSpec = response[READY_TO_COMPLETE_PROPERTY_1];
                            if (dvPortgroupRestoreInfoWrapperSpec) {
                                if (dvPortgroupRestoreInfoWrapperSpec.error) {
                                    _this.wizardPageService.clearErrors(wizardScope.wizardConfig);
                                    _this.showErrorDialog(dvPortgroupRestoreInfoWrapperSpec.error, function () {
                                        deferred.resolve(false);
                                    }, isDvpg);
                                }
                                else {
                                    wizardScope.model.configurationPageModel.dvPortgroupRestoreInfoWrapperSpec = dvPortgroupRestoreInfoWrapperSpec;
                                    _this.wizardPageService.markPageComplete(wizardScope.wizardConfig);
                                    deferred.resolve(true);
                                }
                            }
                        }
                        else {
                            var dvpgImportInfoWrapperSpec = response[DVPG_IMPORT_INFO_WRAPPER_PROPERTY_1];
                            if (dvpgImportInfoWrapperSpec) {
                                if (dvpgImportInfoWrapperSpec.error) {
                                    _this.wizardPageService.clearErrors(wizardScope.wizardConfig);
                                    _this.showErrorDialog(dvpgImportInfoWrapperSpec.error, function () {
                                        deferred.resolve(false);
                                    }, isDvpg);
                                }
                                else {
                                    if (dvpgImportInfoWrapperSpec.dvsImportPortgroupWrapperSpec) {
                                        wizardScope.model.configurationPageModel.dvsImportPortgroupWrapperSpec =
                                            dvpgImportInfoWrapperSpec.dvsImportPortgroupWrapperSpec;
                                    }
                                    _this.wizardPageService.markPageComplete(wizardScope.wizardConfig);
                                    deferred.resolve(true);
                                }
                            }
                        }
                    }
                    else {
                        var dvsImportInfoWrapperSpec = response[READY_TO_COMPLETE_PROPERTY_1];
                        if (dvsImportInfoWrapperSpec) {
                            if (dvsImportInfoWrapperSpec.error) {
                                _this.wizardPageService.clearErrors(wizardScope.wizardConfig);
                                _this.showErrorDialog(dvsImportInfoWrapperSpec.error, function () {
                                    deferred.resolve(false);
                                }, isDvpg);
                            }
                            else {
                                if (dvsImportInfoWrapperSpec.dvsImportInfoSpec) {
                                    wizardScope.model.configurationPageModel.dvsImportInfoSpec =
                                        dvsImportInfoWrapperSpec.dvsImportInfoSpec;
                                }
                                _this.wizardPageService.markPageComplete(wizardScope.wizardConfig);
                                deferred.resolve(true);
                            }
                        }
                    }
                    wizardScope.wizardConfig.loading = false;
                }, function (error) {
                    wizardScope.wizardConfig.loading = false;
                    deferred.resolve(false);
                });
            }
            return deferred.promise;
        };
        DvsImportWizardPages.prototype.showErrorDialog = function (message, callback, isDvpg) {
            this.clarityModalService.openConfirmationModal({
                title: this.i18nService.getString("DvsUi", "dvs.import.wizard.error"),
                message: isDvpg ? message : this.i18nService.getString("DvsUi", "dvs.import.wizard.filePage.internalError", message),
                clarityIcon: {
                    class: "is-error",
                    shape: "error-standard",
                    size: "32"
                },
                saveButtonLabel: this.i18nService.getString("Common", "alert.ok"),
                hideCancelButton: true,
                submit: callback
            });
        };
        DvsImportWizardPages.$inject = ["i18nService",
            "dataService",
            "$q",
            "wizardPageService",
            "clarityModalService",
            "exportDvsConstants"];
        return DvsImportWizardPages;
    }());
    dvs_ui.DvsImportWizardPages = DvsImportWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsImportWizardPages", DvsImportWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportActionSpec = com.vmware.vsphere.client.dvs.api.spec.DvsImportActionSpec;
    var DvsRestoreActionSpec = com.vmware.vsphere.client.dvs.api.spec.DvsRestoreActionSpec;
    var DvsImportPortgroupSpec = com.vmware.vsphere.client.dvs.api.spec.DvsImportPortgroupSpec;
    var DvPortgroupApplyRestoreSpec = com.vmware.vsphere.client.dvs.api.spec.DvPortgroupApplyRestoreSpec;
    var DvsImportWizardService = (function () {
        function DvsImportWizardService($rootScope, i18nService, vuiWizardService, mutationService, dataService, wizardValidationService, vimEntityEscapingService, dvsImportWizardPages, dvsImportWizardFlowManager, exportDvsConstants) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.wizardValidationService = wizardValidationService;
            this.vimEntityEscapingService = vimEntityEscapingService;
            this.dvsImportWizardPages = dvsImportWizardPages;
            this.dvsImportWizardFlowManager = dvsImportWizardFlowManager;
            this.exportDvsConstants = exportDvsConstants;
        }
        /**
         * Shows the Import/Restore DVS/DVPortgroup wizard.
         */
        DvsImportWizardService.prototype.show = function (objectId, isDvpgConfig, isRestoreAction) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsImportWizardModel();
            wizardScope.model.objectId = objectId;
            wizardScope.model.isDvpgConfig = isDvpgConfig;
            wizardScope.model.isRestoreAction = isRestoreAction;
            var wizardConfig = new dvs_ui.WizardConfig();
            if (isRestoreAction) {
                wizardConfig.title = isDvpgConfig ? this.i18nService.getString("DvsUi", "dvs.restore.wizard.titleInitial") :
                    this.i18nService.getString("DvsUi", "dvs.restore.wizard.titleInitial");
            }
            else {
                wizardConfig.title = isDvpgConfig ?
                    this.i18nService.getString("DvsUi", "dvpg.import.wizard.titleInitial") :
                    this.i18nService.getString("DvsUi", "dvs.import.wizard.titleInitial");
            }
            wizardConfig.loadingMessage = this.i18nService.getString("CommonUi", "wizard.loading");
            wizardConfig.cssClass = "vui-wizard.dvs-import-wizard";
            wizardConfig.onFinish = function () {
                var spec;
                var specType;
                if (isRestoreAction) {
                    if (isDvpgConfig) {
                        spec = {
                            configSpec: wizardScope.model.configurationPageModel.dvPortgroupRestoreInfoWrapperSpec.dvPortgroupRestoreInfoSpec.configSpecDiff
                        };
                        specType = new DvPortgroupApplyRestoreSpec()._type;
                    }
                    else {
                        spec = {
                            configData: wizardScope.model.configurationPageModel.configurationData,
                            restorePortgroups: wizardScope.model.configurationPageModel.restorePortgroups ===
                                _this.exportDvsConstants.configurationsToExport.DVS_AND_ALL_PORTGROUPS,
                            infoSpec: wizardScope.model.configurationPageModel.dvsImportInfoSpec
                        };
                        specType = new DvsRestoreActionSpec()._type;
                    }
                }
                else {
                    if (isDvpgConfig) {
                        spec = wizardScope.model.configurationPageModel.dvsImportPortgroupWrapperSpec.dvsImportPortgroupSpec;
                        specType = new DvsImportPortgroupSpec()._type;
                    }
                    else {
                        spec = {
                            configData: wizardScope.model.configurationPageModel.configurationData,
                            createNewObjectKeys: !wizardScope.model.configurationPageModel.preserveOriginalIdentifiers,
                            infoSpec: wizardScope.model.configurationPageModel.dvsImportInfoSpec
                        };
                        specType = new DvsImportActionSpec()._type;
                    }
                }
                _this.mutationService.apply(wizardScope.model.objectId, specType, spec);
                return true;
            };
            wizardConfig.pages =
                this.dvsImportWizardPages.createPages(wizardScope, isDvpgConfig, isRestoreAction);
            wizardScope.wizardConfig = wizardConfig;
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.dvsImportWizardFlowManager.init(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
            var entityNameProperty = "name";
            this.dataService.getProperties(wizardScope.model.objectId, [entityNameProperty])
                .then(function (response) {
                if (response && response[entityNameProperty]) {
                    var objectName = _this.vimEntityEscapingService
                        .unescapeSpecialCharacters(response[entityNameProperty]);
                    if (objectName) {
                        if (isRestoreAction) {
                            wizardConfig.title = isDvpgConfig ?
                                _this.i18nService.getString("DvsUi", "dvpg.restore.wizard.title", objectName) :
                                _this.i18nService.getString("DvsUi", "dvs.restore.wizard.title", objectName);
                        }
                        else {
                            wizardConfig.title = isDvpgConfig ?
                                _this.i18nService.getString("DvsUi", "dvpg.import.wizard.title", objectName) :
                                _this.i18nService.getString("DvsUi", "dvs.import.wizard.title", objectName);
                        }
                    }
                }
            });
        };
        DvsImportWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "mutationService",
            "dataService",
            "wizardValidationService",
            "vimEntityEscapingService",
            "dvsImportWizardPages",
            "dvsImportWizardFlowManager",
            "exportDvsConstants"];
        return DvsImportWizardService;
    }());
    dvs_ui.DvsImportWizardService = DvsImportWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsImportWizardService", DvsImportWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportWizardConfigurationPageModel = (function () {
        function DvsImportWizardConfigurationPageModel() {
            /**
             * Whether to preserve original distributed switch and distributed
             * port group identifiers.
             */
            this.preserveOriginalIdentifiers = false;
            /**
             * Whether to restore dvs and all port groups or dvs only.
             */
            this.restorePortgroups = "dvsAndAllPortgroups";
            /**
             * Whether to restore dvpg from file or from previous configuration.
             */
            this.restoreType = "previous";
        }
        return DvsImportWizardConfigurationPageModel;
    }());
    dvs_ui.DvsImportWizardConfigurationPageModel = DvsImportWizardConfigurationPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsImportWizardModel = (function () {
        function DvsImportWizardModel() {
            this.configurationPageModel = new dvs_ui.DvsImportWizardConfigurationPageModel();
        }
        return DvsImportWizardModel;
    }());
    dvs_ui.DvsImportWizardModel = DvsImportWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var WizardConfig = (function () {
        function WizardConfig() {
            this.loading = false;
            this.pages = [];
        }
        return WizardConfig;
    }());
    dvs_ui.WizardConfig = WizardConfig;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LacpConfigComponent = (function () {
        function LacpConfigComponent() {
            this.bindings = {
                dvsId: "<"
            };
            this.controller = LacpConfigController;
            this.templateUrl = "dvs-ui/resources/dvs/lacp/lacpConfigTemplate.html";
        }
        return LacpConfigComponent;
    }());
    dvs_ui.LacpConfigComponent = LacpConfigComponent;
    var LacpConfigController = (function () {
        function LacpConfigController(dataService, i18n, lagPropertiesService, configurationService) {
            this.dataService = dataService;
            this.i18n = i18n;
            this.lagPropertiesService = lagPropertiesService;
            this.configurationService = configurationService;
            this.liveRefreshProperties = [LacpConfigController.LAGS_PROPERTY];
        }
        LacpConfigController.prototype.$onInit = function () {
            this.getData();
        };
        LacpConfigController.prototype.getData = function () {
            var _this = this;
            this.hasPendingRequest = true;
            this.dataService.getProperties(this.dvsId, LacpConfigController.LAGS_PROPERTY)
                .then(function (response) { return response[LacpConfigController.LAGS_PROPERTY]; })
                .then(function (value) {
                if (!value) {
                    value = [];
                }
                _this.lacpGroupConfig = value;
                _this.hasPendingRequest = false;
            });
        };
        LacpConfigController.prototype.selectionChanged = function (lag) {
            if (lag !== null) {
                this.propertiesData = this.lagPropertiesService.getPropertyViewData(lag);
                this.selectedLagName = lag.name;
                this.hasSelection = true;
            }
            else {
                this.hasSelection = false;
            }
        };
        LacpConfigController.LAGS_PROPERTY = "config.lacpGroupConfig";
        LacpConfigController.$inject = ["dataService",
            "i18nService",
            "lagPropertiesService",
            "configurationService"];
        return LacpConfigController;
    }());
    dvs_ui.LacpConfigController = LacpConfigController;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("lacpConfig", new LacpConfigComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LagConstants = (function () {
        function LagConstants() {
        }
        LagConstants.Mode = (function () {
            function class_1() {
            }
            class_1.ACTIVE = "active";
            class_1.PASSIVE = "passive";
            return class_1;
        }());
        LagConstants.Vlan = (function () {
            function class_2() {
            }
            class_2.OUT_RANGE_DELIMITER = ", ";
            class_2.OUT_RANGE_DIVIDER = "-";
            return class_2;
        }());
        return LagConstants;
    }());
    dvs_ui.LagConstants = LagConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LagConstants = dvs_ui.LagConstants;
    var LagPropertiesFormattingService = (function () {
        function LagPropertiesFormattingService(i18nService) {
            this.i18nService = i18nService;
        }
        LagPropertiesFormattingService.prototype.getLacpModeText = function (lacpMode) {
            switch (lacpMode) {
                case LagConstants.Mode.ACTIVE:
                    return this.i18nService.getString("DvsUi", "lag.mode.active");
                case LagConstants.Mode.PASSIVE:
                    return this.i18nService.getString("DvsUi", "lag.mode.passive");
                default:
                    return "";
            }
        };
        LagPropertiesFormattingService.prototype.getLoadBalancingModeText = function (loadBalancingMode) {
            return this.i18nService.getString("DvsUi", "lag.loadBalancingMode." +
                loadBalancingMode);
        };
        LagPropertiesFormattingService.prototype.getVlanText = function (lag) {
            if (!lag || lag.vlan === null || lag.vlan.vlanId === null ||
                lag.vlan.vlanId.length === 0) {
                return this.i18nService.getString("DvsUi", "lag.vlan.inherit");
            }
            var vlanTrunkRanges = "";
            _.forEach(lag.vlan.vlanId, function (range) {
                if (range.start === range.end) {
                    vlanTrunkRanges += range.start.toString();
                }
                else {
                    vlanTrunkRanges += range.start.toString() +
                        LagConstants.Vlan.OUT_RANGE_DIVIDER +
                        range.end.toString();
                }
                vlanTrunkRanges += LagConstants.Vlan.OUT_RANGE_DELIMITER;
            });
            if (vlanTrunkRanges.length > 0) {
                vlanTrunkRanges = vlanTrunkRanges.substring(0, vlanTrunkRanges.length -
                    LagConstants.Vlan.OUT_RANGE_DELIMITER.length);
            }
            return vlanTrunkRanges;
        };
        LagPropertiesFormattingService.prototype.getIpfixText = function (lag) {
            if (!lag || lag.ipfix === null || lag.ipfix.ipfixEnabled === null) {
                return this.i18nService.getString("DvsUi", "lag.ipfix.inherit");
            }
            return lag.ipfix.ipfixEnabled ?
                this.i18nService.getString("DvsUi", "lag.ipfix.on") :
                this.i18nService.getString("DvsUi", "lag.ipfix.off");
        };
        LagPropertiesFormattingService.$inject = ["i18nService"];
        return LagPropertiesFormattingService;
    }());
    dvs_ui.LagPropertiesFormattingService = LagPropertiesFormattingService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("lagPropertiesFormattingService", LagPropertiesFormattingService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LagPropertiesService = (function () {
        function LagPropertiesService(formattingService, vxPropertyViewService, i18n) {
            this.formattingService = formattingService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18n = i18n;
        }
        LagPropertiesService.prototype.getPropertyViewData = function (lag) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            var policySection = generalCategory.section("policies").title(this.i18n.getString("DvsUi", "lag.properties.policies"));
            generalSection.property(this.i18n.getString("DvsUi", "lag.properties.name"), lag.name);
            generalSection.property(this.i18n.getString("DvsUi", "lag.properties.numPorts"), lag.uplinkNum.toString());
            generalSection.property(this.i18n.getString("DvsUi", "lag.properties.mode"), this.formattingService.getLacpModeText(lag.mode));
            generalSection.property(this.i18n.getString("DvsUi", "lag.properties.loadBalancing"), this.formattingService.getLoadBalancingModeText(lag.loadbalanceAlgorithm));
            policySection.property(this.i18n.getString("DvsUi", "lag.properties.vlanLabel"), this.formattingService.getVlanText(lag));
            policySection.property(this.i18n.getString("DvsUi", "lag.properties.ipfixLabel"), this.formattingService.getIpfixText(lag));
            return builder.build();
        };
        LagPropertiesService.$inject = [
            "lagPropertiesFormattingService",
            "vxPropertyViewService",
            "i18nService"];
        return LagPropertiesService;
    }());
    dvs_ui.LagPropertiesService = LagPropertiesService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("lagPropertiesService", LagPropertiesService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsLagPageComponent = (function () {
        function DvsLagPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsLagPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/lacpupgrade/components/" +
                "dvsLagPageComponentTemplate.html";
        }
        return DvsLagPageComponent;
    }());
    dvs_ui.DvsLagPageComponent = DvsLagPageComponent;
    var DvsLagPageComponentController = (function () {
        function DvsLagPageComponentController(i18nService, vxPropertyViewService, vxValidatorFactory, formattingService, dvsLagPageValidator) {
            var _this = this;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.formattingService = formattingService;
            this.dvsLagPageValidator = dvsLagPageValidator;
            this.validateLagName = function (value) {
                return _this.dvsLagPageValidator.getLagNameError(value);
            };
            this.i18n = this.i18nService.getString;
            this.lagNameValidator = this.vxValidatorFactory.create();
            this.buildLagDetails();
        }
        DvsLagPageComponentController.prototype.buildLagDetails = function () {
            this.uplinkNum = this.wizardModel.lag.uplinkNum.toString();
            this.lagMode =
                this.formattingService.getLacpModeText(this.wizardModel.lag.mode);
            this.loadBalancing = this.formattingService.getLoadBalancingModeText(this.wizardModel.lag.loadbalanceAlgorithm);
            this.vlan = this.formattingService.getVlanText(this.wizardModel.lag);
            this.netFlow = this.formattingService.getIpfixText(this.wizardModel.lag);
        };
        DvsLagPageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "vxValidatorFactory",
            "lagPropertiesFormattingService",
            "dvsLagPageValidator"
        ];
        return DvsLagPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsLagPage", new DvsLagPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeLacpSummaryPageComponent = (function () {
        function DvsUpgradeLacpSummaryPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsUpgradeLacpSummaryPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/lacpupgrade/components/" +
                "dvsUpgradeLacpSummaryPageTemplate.html";
        }
        return DvsUpgradeLacpSummaryPageComponent;
    }());
    dvs_ui.DvsUpgradeLacpSummaryPageComponent = DvsUpgradeLacpSummaryPageComponent;
    var DvsUpgradeLacpSummaryPageComponentController = (function () {
        function DvsUpgradeLacpSummaryPageComponentController(i18nService, vxPropertyViewService, $sce, formattingService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$sce = $sce;
            this.formattingService = formattingService;
            this.overviewInfo = this.$sce.trustAsHtml(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.overview"));
            this.buildPropertyView();
        }
        DvsUpgradeLacpSummaryPageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var lagSection = generalCategory.section("lagSection").title(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.lag"));
            if (this.wizardModel.lag !== null) {
                // LAG name
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.lagName"), this.wizardModel.lag.name);
                // Number of ports
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.numPorts"), this.wizardModel.lag.uplinkNum.toString());
                // Mode
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.mode"), this.formattingService.getLacpModeText(this.wizardModel.lag.mode));
                // Load balancing
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.loadBalancing"), this.formattingService.getLoadBalancingModeText(this.wizardModel.lag.loadbalanceAlgorithm));
                // VLAN
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.vlanLabel"), this.formattingService.getVlanText(this.wizardModel.lag));
                // NetFlow
                lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.ipfixLabel"), this.formattingService.getIpfixText(this.wizardModel.lag));
                // Modified objects
                var entitySection = generalCategory.section("entitySection").title(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.affectedEntities"));
                // Number ot port groups
                entitySection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.numberOfPortGroups"), this.wizardModel.portgroupCount.toString());
                if (this.wizardModel.portgroupCount > 0) {
                    entitySection.warning(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.portGroupChanges"));
                }
                // Number ot hosts
                entitySection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.numberOfHosts"), this.wizardModel.hostCount.toString());
                if (this.wizardModel.hostCount > 0) {
                    entitySection.warning(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.hostChanges"));
                }
            }
            else {
                lagSection.warning(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.lag.notNeeded"));
            }
            this.propertyViewData = builder.build();
        };
        DvsUpgradeLacpSummaryPageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "$sce",
            "lagPropertiesFormattingService"
        ];
        return DvsUpgradeLacpSummaryPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsUpgradeLacpSummaryPage", new DvsUpgradeLacpSummaryPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvsUpgradeLacpWizardConstants", {
        pages: {
            DVS_LACP_OVERVIEW_PAGE: "lacpOverviewPage",
            DVS_LACP_VALIDATION_PAGE: "lacpValidatePrerequisitesPage",
            DVS_LACP_LAG_PAGE: "lacpLagPage",
            DVS_LACP_SUMMARY_PAGE: "lacpReadyToCompletePage"
        },
        properties: {
            DVS_UPGRADE_LACP_WIZARD_DATA: "lacpupgrade:wizardData"
        },
        validationResult: {
            FAIL: "fail",
            WARNING: "warning",
            PASS: "pass"
        },
        spec: {
            MUTATION_SPEC_TYPE: "com.vmware.vim.binding.vim.dvs.DvsUpgradeLacpSpec"
        },
        lag: {
            NAME_MAX_LENGTH: 16,
            ACTIVE_LACP_MODE: "active",
            PASSIVE_LACP_MODE: "passive",
            OUT_RANGE_DELIMITER: ", ",
            OUT_RANGE_DIVIDER: "-"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeLacpWizardManager = (function () {
        function DvsUpgradeLacpWizardManager(pageStateManagementService) {
            this.pageStateManagementService = pageStateManagementService;
        }
        DvsUpgradeLacpWizardManager.prototype.init = function (wizardScope) {
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
        };
        DvsUpgradeLacpWizardManager.$inject = ["pageStateManagementService"];
        return DvsUpgradeLacpWizardManager;
    }());
    dvs_ui.DvsUpgradeLacpWizardManager = DvsUpgradeLacpWizardManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeLacpWizardManager", DvsUpgradeLacpWizardManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeLacpWizardPages = (function () {
        function DvsUpgradeLacpWizardPages(i18nService, wizardConstants, simpleValidationCommit, dvsPrerequisitesPageValidator, dvsLagPageValidator, vuiConstants) {
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.simpleValidationCommit = simpleValidationCommit;
            this.dvsPrerequisitesPageValidator = dvsPrerequisitesPageValidator;
            this.dvsLagPageValidator = dvsLagPageValidator;
            this.vuiConstants = vuiConstants;
        }
        /**
         * Creates an array of page definitions for the Enhance LACP Support wizard.
         */
        DvsUpgradeLacpWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var overviewPage = {
                id: this.wizardConstants.pages.DVS_LACP_OVERVIEW_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.overview.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.overview.description"),
                contentUrl: "dvs-ui/resources/dvs/lacpupgrade/views/" +
                    "dvsUpgradeLacpOverviewPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var prerequisitesPage = {
                id: this.wizardConstants.pages.DVS_LACP_VALIDATION_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.prerequisites.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.prerequisites.description"),
                contentUrl: "dvs-ui/resources/dvs/lacpupgrade/views/" +
                    "dvsUpgradeLacpPrerequisitesPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvsPrerequisitesPageValidator.getValidationResult(wizardScope.model.prerequisiteChecks, wizardScope.model);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var lagPage = {
                id: this.wizardConstants.pages.DVS_LACP_LAG_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.description"),
                contentUrl: "dvs-ui/resources/dvs/lacpupgrade/views/" +
                    "dvsUpgradeLacpLagPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvsLagPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: ["model.lag.name"]
            };
            var summaryPage = {
                id: this.wizardConstants.pages.DVS_LACP_SUMMARY_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.description"),
                contentUrl: "dvs-ui/resources/dvs/lacpupgrade/views/" +
                    "dvsUpgradeLacpSummaryPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var pages = [
                overviewPage,
                prerequisitesPage
            ];
            if (wizardScope.model.lag !== null) {
                pages.push(lagPage);
            }
            pages.push(summaryPage);
            return pages;
        };
        DvsUpgradeLacpWizardPages.prototype.skipPage = function (pages, pageToSkipId) {
            var page = _.findWhere(pages, { id: pageToSkipId });
            if (page) {
                page.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvsUpgradeLacpWizardPages.$inject = [
            "i18nService",
            "dvsUpgradeLacpWizardConstants",
            "simpleValidationCommit",
            "dvsPrerequisitesPageValidator",
            "dvsLagPageValidator",
            "vuiConstants"
        ];
        return DvsUpgradeLacpWizardPages;
    }());
    dvs_ui.DvsUpgradeLacpWizardPages = DvsUpgradeLacpWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeLacpWizardPages", DvsUpgradeLacpWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeLacpWizardService = (function () {
        function DvsUpgradeLacpWizardService($rootScope, i18nService, vuiWizardService, mutationService, dataService, specFactory, wizardConstants, wizardManager, wizardPages, wizardValidationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.specFactory = specFactory;
            this.wizardConstants = wizardConstants;
            this.wizardManager = wizardManager;
            this.wizardPages = wizardPages;
            this.wizardValidationService = wizardValidationService;
        }
        /**
         * Shows the Enhance LACP Support wizard.
         */
        DvsUpgradeLacpWizardService.prototype.show = function (objectId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsUpgradeLacpWizardModel();
            wizardScope.model.dvsId = objectId;
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.initialTitle"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                cssClass: "dvs-upgrade-lacp-wizard",
                onFinish: function () {
                    var spec = _this.specFactory.buildDvsLacpUpgradeSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.dvsId, spec._type, spec);
                    return true;
                }
            };
            wizardScope.wizardConfig.pages = this.wizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.wizardManager.init(wizardScope);
            this.requestProperties(wizardScope);
        };
        DvsUpgradeLacpWizardService.prototype.requestProperties = function (wizardScope) {
            var _this = this;
            wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(wizardScope.model.dvsId, [this.wizardConstants.properties
                    .DVS_UPGRADE_LACP_WIZARD_DATA])
                .then(function (response) {
                var wizardData = response[_this.wizardConstants.properties.
                    DVS_UPGRADE_LACP_WIZARD_DATA];
                wizardScope.model.dvsName = wizardData.dvsName;
                wizardScope.model.portgroupCount = wizardData.portgroupCount !== null
                    ? wizardData.portgroupCount : 0;
                wizardScope.model.hostCount = wizardData.hostCount !== null
                    ? wizardData.hostCount : 0;
                wizardScope.model.prerequisiteChecks =
                    wizardData.prerequisiteCheckResults;
                wizardScope.model.lag = wizardData.lagConfig;
                wizardScope.wizardConfig.title = _this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.titleFormat", wizardScope.model.dvsName);
                if (wizardScope.model.lag === null) {
                    _this.wizardPages.skipPage(wizardScope.wizardConfig.pages, _this.wizardConstants.pages.DVS_LACP_LAG_PAGE);
                }
                wizardScope.wizardConfig.loading = false;
                _this.vuiWizardService({
                    scope: wizardScope,
                    configObjectName: "wizardConfig"
                }).show();
            });
        };
        DvsUpgradeLacpWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "mutationService",
            "dataService",
            "dvsUpgradeLacpWizardSpecFactory",
            "dvsUpgradeLacpWizardConstants",
            "dvsUpgradeLacpWizardManager",
            "dvsUpgradeLacpWizardPages",
            "wizardValidationService"
        ];
        return DvsUpgradeLacpWizardService;
    }());
    dvs_ui.DvsUpgradeLacpWizardService = DvsUpgradeLacpWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeLacpWizardService", DvsUpgradeLacpWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LacpUpgradeSpec = com.vmware.vsphere.client.dvs.api.spec.LacpUpgradeSpec;
    /**
     * Provides methods from creating the mutation spec sent to the backend
     * after the completion of the Enhance LACP Support wizard.
     */
    var DvsUpgradeLacpWizardSpecFactory = (function () {
        function DvsUpgradeLacpWizardSpecFactory(defaultUriSchemeUtil) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Builds the spec the Enhance LACP Support mutation operation.
         */
        DvsUpgradeLacpWizardSpecFactory.prototype.buildDvsLacpUpgradeSpec = function (model) {
            var upgradeSpec = new LacpUpgradeSpec();
            upgradeSpec.lag = model.lag;
            return upgradeSpec;
        };
        DvsUpgradeLacpWizardSpecFactory.$inject = ["defaultUriSchemeUtil"];
        return DvsUpgradeLacpWizardSpecFactory;
    }());
    dvs_ui.DvsUpgradeLacpWizardSpecFactory = DvsUpgradeLacpWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeLacpWizardSpecFactory", DvsUpgradeLacpWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeLacpWizardModel = (function () {
        function DvsUpgradeLacpWizardModel() {
            this.prerequisiteWarningShown = false;
        }
        return DvsUpgradeLacpWizardModel;
    }());
    dvs_ui.DvsUpgradeLacpWizardModel = DvsUpgradeLacpWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsLagPageValidator = (function () {
        function DvsLagPageValidator(i18nService, wizardConstants) {
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
        }
        DvsLagPageValidator.prototype.getValidationError = function (wizardScope) {
            return this.getLagNameError(wizardScope.model.lag.name);
        };
        DvsLagPageValidator.prototype.getLagNameError = function (lagName) {
            if (!lagName || lagName.trim().length === 0) {
                return [this.i18nService.getString("DvsUi", "lag.name.nameRequired")];
            }
            else if (lagName.trim().length > this.wizardConstants.lag.NAME_MAX_LENGTH) {
                return [this.i18nService.getString("DvsUi", "lag.name.nameTooLong")];
            }
            return [];
        };
        DvsLagPageValidator.$inject = [
            "i18nService",
            "dvsUpgradeLacpWizardConstants"];
        return DvsLagPageValidator;
    }());
    dvs_ui.DvsLagPageValidator = DvsLagPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsLagPageValidator", DvsLagPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var MoveDvsToComponent = (function () {
        function MoveDvsToComponent() {
            this.bindings = {
                pageModel: "="
            };
            this.controller = MoveDvsToComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/moveTo/moveDvsToComponentTemplate.html";
        }
        return MoveDvsToComponent;
    }());
    dvs_ui.MoveDvsToComponent = MoveDvsToComponent;
    var MoveDvsToComponentController = (function () {
        function MoveDvsToComponentController() {
            var _this = this;
            this.dvsIds = this.pageModel.objectIds;
            this.onLocationSelected = function (objectReference) {
                _this.pageModel.entityToMoveDvsTo = objectReference;
            };
        }
        MoveDvsToComponentController.$inject = [];
        return MoveDvsToComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("moveDvsToComponent", new MoveDvsToComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var MoveNetworkSpec = com.vmware.vsphere.client.h5.network.MoveNetworkSpec;
    var MoveDvsToService = (function () {
        function MoveDvsToService(clarityModalService, i18nService, mutationService, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        MoveDvsToService.prototype.openMoveToDialog = function (availableTargets) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "moveto.dialog.title"),
                subTitle: {
                    objectId: availableTargets[0]
                },
                defaultButton: 'submit',
                dialogData: {
                    objectIds: availableTargets
                },
                contentTemplate: "dvs-ui/resources/dvs/moveTo/moveDvsToDialog.html"
            };
            modalOptions.onSubmit = function () {
                _this.moveDvsTo(modalOptions.dialogData.objectIds, modalOptions.dialogData.entityToMoveDvsTo);
                return true;
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        MoveDvsToService.prototype.moveDvsTo = function (dvsIds, entityToMoveDvsTo) {
            var _this = this;
            var dvsMors = dvsIds.map(function (dvsId) {
                return _this.defaultUriSchemeUtil.getManagedObjectReference(dvsId);
            });
            var moveSpec = new MoveNetworkSpec();
            moveSpec.entities = dvsMors;
            this.mutationService.apply(entityToMoveDvsTo, moveSpec._type, moveSpec).then(function () {
            });
            return true;
        };
        MoveDvsToService.$inject = [
            "clarityModalService",
            "i18nService",
            "mutationService",
            "defaultUriSchemeUtil"
        ];
        return MoveDvsToService;
    }());
    dvs_ui.MoveDvsToService = MoveDvsToService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("moveDvsToService", MoveDvsToService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNetFlowViewComponent = (function () {
        function DvsNetFlowViewComponent() {
            this.bindings = {};
            this.controller = DvsNetFlowViewController;
            this.templateUrl = "dvs-ui/resources/dvs/netflow/dvsNetFlowViewTemplate.html";
        }
        return DvsNetFlowViewComponent;
    }());
    dvs_ui.DvsNetFlowViewComponent = DvsNetFlowViewComponent;
    var DvsNetFlowViewController = (function () {
        function DvsNetFlowViewController($rootScope, i18nService, dataService, dvsNetFlowViewService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.dvsNetFlowViewService = dvsNetFlowViewService;
            this.dvsNetFlowLoading = false;
            this.settingsViewHeaderAccessor = {};
            this._actions = [{
                    actionUid: "vsphere.core.dvs.editNetFlow",
                    customLabel: this.i18nService.getString("DvsUi", "DvsPropertiesView.edit.label")
                }];
        }
        DvsNetFlowViewController.prototype.$onInit = function () {
            this.refresh();
        };
        Object.defineProperty(DvsNetFlowViewController.prototype, "title", {
            get: function () {
                return this.i18nService.getString("DvsUi", "dvs.netFlowView.title");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsNetFlowViewController.prototype, "actions", {
            get: function () {
                return this._actions;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsNetFlowViewController.prototype, "dvsUri", {
            get: function () {
                return this._dvsUri;
            },
            enumerable: true,
            configurable: true
        });
        DvsNetFlowViewController.prototype.refresh = function () {
            var self = this;
            self.dvsNetFlowLoading = true;
            self._dvsUri = this.$rootScope._route.objectId;
            var dvsPromise = self.dataService.getProperties(self._dvsUri, [DvsNetFlowViewController.NETFLOW_DATA_PROPERTY_NAME]);
            self._selectedDistributedSwitchPromise = dvsPromise;
            dvsPromise
                .then(function (dataServiceResponse) {
                if (self._selectedDistributedSwitchPromise === dvsPromise) {
                    var dvsNetFlowData = dataServiceResponse
                        ? dataServiceResponse[DvsNetFlowViewController.NETFLOW_DATA_PROPERTY_NAME]
                        : null;
                    if (dvsNetFlowData) {
                        self.dvsNetFlowData = self.dvsNetFlowViewService
                            .buildProperties(dvsNetFlowData);
                    }
                    self.dvsNetFlowLoading = false;
                }
            }, function (error) {
                self.dvsNetFlowLoading = false;
            });
            // Call the settings-view-header's accessor #refresh function to recalculate
            // the actions availability
            if (self.settingsViewHeaderAccessor.refresh) {
                self.settingsViewHeaderAccessor.refresh();
            }
            this.liveRefreshProperties = [
                "config.ipfixConfig.collectorPort",
                "config.ipfixConfig.collectorIpAddress",
                "config.ipfixConfig.observationDomainId",
                "config.ipfixConfig.activeFlowTimeout",
                "config.ipfixConfig.idleFlowTimeout",
                "config.ipfixConfig.internalFlowsOnly",
                "config.ipfixConfig.samplingRate",
                "config.switchIpAddress"
            ];
        };
        DvsNetFlowViewController.$inject = [
            "$rootScope",
            "i18nService",
            "dataService",
            "dvsNetFlowViewService"
        ];
        DvsNetFlowViewController.NETFLOW_DATA_PROPERTY_NAME = "dvswitchproperties:netFlowDetails";
        return DvsNetFlowViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNetFlowView", new DvsNetFlowViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNetFlowViewService = (function () {
        function DvsNetFlowViewService(i18nService, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18n = this.i18nService.getString;
        }
        DvsNetFlowViewService.prototype.buildProperties = function (properties) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            this.addPropertiesToSection(properties, generalCategory);
            return builder.build();
        };
        DvsNetFlowViewService.prototype.addPropertiesToSection = function (properties, category) {
            var generalSection = category.section("generalSection");
            var unsetProperty = this.i18n("NetworkUi", "NetworkUtil.noData");
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.collector.ipAddress"), (properties.collectorIpAddress !== null
                && properties.collectorIpAddress !== "")
                ? properties.collectorIpAddress : unsetProperty);
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.collector.port"), properties.collectorPort !== null
                ? properties.collectorPort : unsetProperty);
            if (properties.ipfixV10Supported) {
                generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.collector.observationDomainId"), properties.observationDomainId !== null
                    ? properties.observationDomainId : unsetProperty);
            }
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.switch.ipAddress"), (properties.switchIpAddress !== null
                && properties.switchIpAddress !== "")
                ? properties.switchIpAddress : unsetProperty);
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.activeFlowTimeout"), properties.activeFlowTimeout !== null
                ? this.i18n("DvsUi", "dvs.netFlowView.flowTimeout.unitFormat", properties.activeFlowTimeout)
                : unsetProperty);
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.idleFlowTimeout"), properties.idleFlowTimeout !== null
                ? this.i18n("DvsUi", "dvs.netFlowView.flowTimeout.unitFormat", properties.idleFlowTimeout)
                : unsetProperty);
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.samplingRate"), properties.samplingRate !== null
                ? properties.samplingRate : unsetProperty);
            generalSection.property(this.i18n("DvsUi", "dvs.netFlowView.internalFlowsOnly"), properties.internalFlowsOnly
                ? this.i18n("DvsUi", "dvs.netFlowView.internalFlowsOnlyEnabled")
                : this.i18n("DvsUi", "dvs.netFlowView.internalFlowsOnlyDisabled"));
        };
        DvsNetFlowViewService.$inject = [
            "i18nService",
            "vxPropertyViewService"];
        return DvsNetFlowViewService;
    }());
    dvs_ui.DvsNetFlowViewService = DvsNetFlowViewService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsNetFlowViewService", DvsNetFlowViewService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditNetFlowDialogComponent = (function () {
        function DvsEditNetFlowDialogComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = DvsEditNetFlowController;
            this.templateUrl = "dvs-ui/resources/dvs/netflow/edit/dvsEditNetFlowDialogTemplate.html";
        }
        return DvsEditNetFlowDialogComponent;
    }());
    dvs_ui.DvsEditNetFlowDialogComponent = DvsEditNetFlowDialogComponent;
    var DvsEditNetFlowController = (function () {
        function DvsEditNetFlowController(i18nService, networkUtil, vxValidatorFactory, dvsEditNetFlowDialogValidator) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this.vxValidatorFactory = vxValidatorFactory;
            this.dvsEditNetFlowDialogValidator = dvsEditNetFlowDialogValidator;
            this.i18n = i18nService.getString;
            this.validator = vxValidatorFactory.create();
            this.validateCollectorIpAddress = this.collectorIpValidator.bind(this);
            this.validateSwitchIpAddress = this.switchIpValidator.bind(this);
            this.validateCollectorPort = this.collectorPortValidator.bind(this);
            this.validateObservationDomainId = this.observationDomainIdValidator.bind(this);
            this.validateActiveFlowTimeout = this.activeFlowTimeoutValidator.bind(this);
            this.validateIdleFlowTimeout = this.idleFlowTimeoutValidator.bind(this);
            this.validateSamplingRate = this.samplingRateValidator.bind(this);
        }
        DvsEditNetFlowController.prototype.$onInit = function () {
            this.collectorIpAddressPlaceholder = this.pageModel.ipv6ForIpfixSupported ?
                this.i18n("NetworkUi", "NetFlowPage.collector.ipAllPrompt") :
                this.i18n("NetworkUi", "NetFlowPage.collector.ipv4Prompt");
            this.initSwitchAddressSignPost();
            this.internalFlowsOnlyOptions = [{
                    label: this.i18nService.getString("NetworkUi", "NetFlowPage.advanced.internalFlowsOnlyEnabled"),
                    value: dvs_ui.DvsEditNetFlowDialogConstants.INTERNAL_FLOWS_ONLY_ENABLED
                }, {
                    label: this.i18nService.getString("NetworkUi", "NetFlowPage.advanced.internalFlowsOnlyDisabled"),
                    value: dvs_ui.DvsEditNetFlowDialogConstants.INTERNAL_FLOWS_ONLY_DISABLED
                }];
        };
        DvsEditNetFlowController.prototype.collectorIpValidator = function () {
            var message = null;
            if (this.pageModel.collectorIpAddress) {
                message = this.dvsEditNetFlowDialogValidator.getCollectorIpValidationMessage(this.pageModel.collectorIpAddress, this.pageModel.ipv6ForIpfixSupported);
            }
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.switchIpValidator = function () {
            var message = null;
            if (this.pageModel.switchIpAddress) {
                message = this.dvsEditNetFlowDialogValidator
                    .getSwitchIpValidationMessage(this.pageModel.switchIpAddress);
            }
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.collectorPortValidator = function () {
            var message = this.dvsEditNetFlowDialogValidator
                .getCollectorPortValidationMessage(this.pageModel.collectorPort);
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.observationDomainIdValidator = function () {
            var message = this.dvsEditNetFlowDialogValidator
                .getObservationDomainIdValidationMessage(this.pageModel.observationDomainId);
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.activeFlowTimeoutValidator = function () {
            var message = this.dvsEditNetFlowDialogValidator
                .getActiveFlowTimeoutValidationMessage(this.pageModel.activeFlowTimeout);
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.idleFlowTimeoutValidator = function () {
            var message = this.dvsEditNetFlowDialogValidator
                .getIdleFlowTimeoutValidationMessage(this.pageModel.idleFlowTimeout);
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.samplingRateValidator = function () {
            var message = this.dvsEditNetFlowDialogValidator
                .getSamplingRateValidationMessage(this.pageModel.samplingRate);
            return message ? [message] : [];
        };
        DvsEditNetFlowController.prototype.initSwitchAddressSignPost = function () {
            var messages = [
                this.i18n("NetworkUi", "NetFlowPage.info.switchIp.message")
            ];
            if (this.pageModel.ipv6ForIpfixSupported) {
                messages.push(this.i18n("NetworkUi", "NetFlowPage.info.switchIp.ipv6Disclaimer"));
            }
            this.signPostConfig = {
                message: this.formatTextMessages(messages),
                title: this.i18n("NetworkUi", "NetFlowPage.info.switchIp.title"),
                class: "edit-netflow-switchAddress-signpost"
            };
        };
        DvsEditNetFlowController.prototype.formatTextMessages = function (messages) {
            var formattedMessage = "";
            var template = "<div class='horizontal-flex-container'><span class='info-msg-color'>%msg%</span></div>";
            messages.forEach(function (message) {
                if (formattedMessage) {
                    formattedMessage += "<br>";
                }
                formattedMessage += template.replace("%msg%", message);
            });
            return formattedMessage;
        };
        DvsEditNetFlowController.$inject = [
            "i18nService",
            "networkUtil",
            "vxValidatorFactory",
            "dvsEditNetFlowDialogValidator"
        ];
        return DvsEditNetFlowController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsEditNetFlowDialog", new DvsEditNetFlowDialogComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditNetFlowDialogConstants = (function () {
        function DvsEditNetFlowDialogConstants() {
        }
        DvsEditNetFlowDialogConstants.COLLECTOR_PORT_MIN_VAL = 0;
        DvsEditNetFlowDialogConstants.COLLECTOR_PORT_MAX_VAL = 65535;
        DvsEditNetFlowDialogConstants.OBSERVATION_DOMAIN_ID_MIN_VAL = 0;
        DvsEditNetFlowDialogConstants.OBSERVATION_DOMAIN_ID_MAX_VAL = 4294967295;
        DvsEditNetFlowDialogConstants.ACTIVE_FLOW_MIN_VAL = 60;
        DvsEditNetFlowDialogConstants.ACTIVE_FLOW_MAX_VAL = 3600;
        DvsEditNetFlowDialogConstants.IDLE_FLOW_MIN_VAL = 10;
        DvsEditNetFlowDialogConstants.IDLE_FLOW_MAX_VAL = 600;
        DvsEditNetFlowDialogConstants.SAMPLING_RATE_MIN_VAL = 0;
        DvsEditNetFlowDialogConstants.SAMPLING_RATE_MAX_VAL = 1000;
        DvsEditNetFlowDialogConstants.INTERNAL_FLOWS_ONLY_ENABLED = true;
        DvsEditNetFlowDialogConstants.INTERNAL_FLOWS_ONLY_DISABLED = false;
        return DvsEditNetFlowDialogConstants;
    }());
    dvs_ui.DvsEditNetFlowDialogConstants = DvsEditNetFlowDialogConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditNetFlowDialogService = (function () {
        function DvsEditNetFlowDialogService(dataService, i18nService, clarityModalService, mutationService, dvsEditNetFlowDialogValidator, clarityConstants) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.dvsEditNetFlowDialogValidator = dvsEditNetFlowDialogValidator;
            this.clarityConstants = clarityConstants;
            this.i18n = this.i18nService.getString;
        }
        DvsEditNetFlowDialogService.prototype.show = function (dvsUrn) {
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "actionEditNetFlowCaption"),
                defaultButton: "submit",
                alerts: [],
                dialogData: {},
                contentTemplate: "dvs-ui/resources/dvs/netflow/edit/dvsEditNetFlowDialog.html",
                onSubmit: onSubmit.bind(this)
            };
            var dvsPromise = this.dataService.getData(dvsUrn, DvsEditNetFlowDialogService.EDIT_NETFLOW_DATA_MODEL);
            var initialModel = null;
            dvsPromise.then(function (dataServiceResponse) {
                if (dataServiceResponse) {
                    modalOptions.subTitle = dataServiceResponse.name;
                    modalOptions.dialogData.pageModel =
                        new dvs_ui.DvsEditNetFlowDialogModel(dataServiceResponse);
                    initialModel = new dvs_ui.DvsEditNetFlowDialogModel(dataServiceResponse);
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
            function onSubmit() {
                var _this = this;
                var dvsConfigSpec = initialModel ?
                    initialModel.buildSpec(modalOptions.dialogData.pageModel) : null;
                if (dvsConfigSpec === null) {
                    return true;
                }
                var messages = this.dvsEditNetFlowDialogValidator.getAllErrors(modalOptions.dialogData.pageModel);
                if (messages.length > 0) {
                    modalOptions.alerts = _.map(messages, function (message) {
                        return {
                            type: _this.clarityConstants.notifications.type.ERROR,
                            text: message
                        };
                    });
                    return false;
                }
                this.mutationService.apply(dvsUrn, dvsConfigSpec._type, dvsConfigSpec);
                return true;
            }
        };
        DvsEditNetFlowDialogService.$inject = [
            "dataService",
            "i18nService",
            "clarityModalService",
            "mutationService",
            "dvsEditNetFlowDialogValidator",
            "clarityConstants"];
        DvsEditNetFlowDialogService.EDIT_NETFLOW_DATA_MODEL = "com.vmware.vsphere.client.h5.network.dvs.netflow.model.DvsEditNetFlowDialogData";
        return DvsEditNetFlowDialogService;
    }());
    dvs_ui.DvsEditNetFlowDialogService = DvsEditNetFlowDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditNetFlowDialogService", DvsEditNetFlowDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsConfigSpec = com.vmware.vsphere.client.dvs.api.spec.DvsConfigSpec;
    var VmwareDistributedVirtualSwitch$ConfigSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$ConfigSpec;
    var DvsEditNetFlowDialogModel = (function () {
        function DvsEditNetFlowDialogModel(data) {
            this.name = data.name;
            this.configVersion = data.configVersion;
            this.ipv6ForIpfixSupported = data.ipv6ForIpfixSupported;
            if (data.dvsConfigNetflow) {
                _.extend(this, data.dvsConfigNetflow);
            }
        }
        DvsEditNetFlowDialogModel.prototype.buildSpec = function (pageModel) {
            var configSpec = this.getDefaultSpec();
            var spec = new DvsConfigSpec();
            spec.configSpec = configSpec;
            var hasChanges = false;
            if (this.collectorIpAddress !== pageModel.collectorIpAddress) {
                configSpec.ipfixConfig.collectorIpAddress = pageModel.collectorIpAddress;
                hasChanges = true;
            }
            if (this.collectorPort !== Number(pageModel.collectorPort)) {
                configSpec.ipfixConfig.collectorPort = pageModel.collectorPort;
                hasChanges = true;
            }
            if (this.observationDomainId !== Number(pageModel.observationDomainId)) {
                configSpec.ipfixConfig.observationDomainId = pageModel.observationDomainId;
                hasChanges = true;
            }
            if (this.switchIpAddress !== pageModel.switchIpAddress) {
                configSpec.switchIpAddress = pageModel.switchIpAddress;
                hasChanges = true;
            }
            if (this.activeFlowTimeout !== Number(pageModel.activeFlowTimeout)) {
                configSpec.ipfixConfig.activeFlowTimeout = pageModel.activeFlowTimeout;
                hasChanges = true;
            }
            if (this.idleFlowTimeout !== Number(pageModel.idleFlowTimeout)) {
                configSpec.ipfixConfig.idleFlowTimeout = pageModel.idleFlowTimeout;
                hasChanges = true;
            }
            if (this.samplingRate !== Number(pageModel.samplingRate)) {
                configSpec.ipfixConfig.samplingRate = pageModel.samplingRate;
                hasChanges = true;
            }
            if (this.internalFlowsOnly !== pageModel.internalFlowsOnly) {
                configSpec.ipfixConfig.internalFlowsOnly = pageModel.internalFlowsOnly;
                hasChanges = true;
            }
            return hasChanges ? spec : null;
        };
        DvsEditNetFlowDialogModel.prototype.getDefaultSpec = function () {
            var defaultSpec = new VmwareDistributedVirtualSwitch$ConfigSpec();
            defaultSpec.configVersion = this.configVersion;
            defaultSpec.ipfixConfig = new com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$IpfixConfig();
            defaultSpec.ipfixConfig.idleFlowTimeout = this.idleFlowTimeout;
            defaultSpec.ipfixConfig.internalFlowsOnly = this.internalFlowsOnly;
            defaultSpec.ipfixConfig.samplingRate = this.samplingRate;
            defaultSpec.ipfixConfig.activeFlowTimeout = this.activeFlowTimeout;
            return defaultSpec;
        };
        return DvsEditNetFlowDialogModel;
    }());
    dvs_ui.DvsEditNetFlowDialogModel = DvsEditNetFlowDialogModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditNetFlowDialogValidator = (function () {
        function DvsEditNetFlowDialogValidator(i18nService, ipParserService, networkUtil) {
            this.i18nService = i18nService;
            this.ipParserService = ipParserService;
            this.networkUtil = networkUtil;
            this.i18n = i18nService.getString;
        }
        DvsEditNetFlowDialogValidator.prototype.getAllErrors = function (pageModel) {
            var messages = [];
            if (pageModel.collectorIpAddress) {
                var message = this.getCollectorIpValidationMessage(pageModel.collectorIpAddress, pageModel.ipv6ForIpfixSupported);
                if (message) {
                    messages.push(message);
                }
            }
            if (pageModel.switchIpAddress) {
                var message = this.getSwitchIpValidationMessage(pageModel.switchIpAddress);
                if (message) {
                    messages.push(message);
                }
            }
            var collectorsPortMessage = this.getCollectorPortValidationMessage(pageModel.collectorPort);
            if (collectorsPortMessage) {
                messages.push(collectorsPortMessage);
            }
            if (pageModel.ipfixV10Supported) {
                var observationDomainIdMessage = this.getObservationDomainIdValidationMessage(pageModel.observationDomainId);
                if (observationDomainIdMessage) {
                    messages.push(observationDomainIdMessage);
                }
            }
            var activeFlowTimeoutMessage = this.getActiveFlowTimeoutValidationMessage(pageModel.activeFlowTimeout);
            if (activeFlowTimeoutMessage) {
                messages.push(activeFlowTimeoutMessage);
            }
            var idleFlowTimeoutMessage = this.getIdleFlowTimeoutValidationMessage(pageModel.idleFlowTimeout);
            if (idleFlowTimeoutMessage) {
                messages.push(idleFlowTimeoutMessage);
            }
            var samplingRateMessage = this.getSamplingRateValidationMessage(pageModel.samplingRate);
            if (samplingRateMessage) {
                messages.push(samplingRateMessage);
            }
            return messages;
        };
        DvsEditNetFlowDialogValidator.prototype.getCollectorIpValidationMessage = function (collectorIpAddress, isIpv6Enabled) {
            if (isIpv6Enabled) {
                if (!this.ipParserService.isIpv4AddressValid(collectorIpAddress)
                    && !this.ipParserService.isIpv6AddressValid(collectorIpAddress)) {
                    return this.i18n("NetworkUi", "NetFlowPage.error.invalidCollectorAddress.allIp");
                }
            }
            else {
                if (!this.ipParserService.isIpv4AddressValid(collectorIpAddress)) {
                    return this.i18n("NetworkUi", "NetFlowPage.error.invalidCollectorAddress.ipv4");
                }
            }
            return null;
        };
        DvsEditNetFlowDialogValidator.prototype.getSwitchIpValidationMessage = function (switchIp) {
            if (!this.ipParserService.isIpv4AddressValid(switchIp)) {
                return this.i18n("NetworkUi", "NetFlowPage.error.invalidIpAddress");
            }
            return null;
        };
        DvsEditNetFlowDialogValidator.prototype.getCollectorPortValidationMessage = function (collectorPort) {
            var min = dvs_ui.DvsEditNetFlowDialogConstants.COLLECTOR_PORT_MIN_VAL;
            var max = dvs_ui.DvsEditNetFlowDialogConstants.COLLECTOR_PORT_MAX_VAL;
            var errorMessage = this.i18n("NetworkUi", "NetFlowPage.error.collectorPort", min, max);
            return this.getNumericInputValidationMessage(collectorPort, min, max, errorMessage);
        };
        DvsEditNetFlowDialogValidator.prototype.getObservationDomainIdValidationMessage = function (domainId) {
            var min = dvs_ui.DvsEditNetFlowDialogConstants.OBSERVATION_DOMAIN_ID_MIN_VAL;
            var max = dvs_ui.DvsEditNetFlowDialogConstants.OBSERVATION_DOMAIN_ID_MAX_VAL;
            var errorMessage = this.i18n("NetworkUi", "NetFlowPage.error.observationDomainId", min, max);
            return this.getNumericInputValidationMessage(domainId, min, max, errorMessage);
        };
        DvsEditNetFlowDialogValidator.prototype.getActiveFlowTimeoutValidationMessage = function (activeFlowTimeout) {
            var min = dvs_ui.DvsEditNetFlowDialogConstants.ACTIVE_FLOW_MIN_VAL;
            var max = dvs_ui.DvsEditNetFlowDialogConstants.ACTIVE_FLOW_MAX_VAL;
            var errorMessage = this.i18n("DvsUi", "NetFlowPage.error.activeFlowTimeout", min, max);
            return this.getNumericInputValidationMessage(activeFlowTimeout, min, max, errorMessage);
        };
        DvsEditNetFlowDialogValidator.prototype.getIdleFlowTimeoutValidationMessage = function (idleFlowTimeout) {
            var min = dvs_ui.DvsEditNetFlowDialogConstants.IDLE_FLOW_MIN_VAL;
            var max = dvs_ui.DvsEditNetFlowDialogConstants.IDLE_FLOW_MAX_VAL;
            var errorMessage = this.i18n("DvsUi", "NetFlowPage.error.idleFlowTimeout", min, max);
            return this.getNumericInputValidationMessage(idleFlowTimeout, min, max, errorMessage);
        };
        DvsEditNetFlowDialogValidator.prototype.getSamplingRateValidationMessage = function (samplingRate) {
            var min = dvs_ui.DvsEditNetFlowDialogConstants.SAMPLING_RATE_MIN_VAL;
            var max = dvs_ui.DvsEditNetFlowDialogConstants.SAMPLING_RATE_MAX_VAL;
            var errorMessage = this.i18n("DvsUi", "NetFlowPage.error.samplingRate", min, max);
            return this.getNumericInputValidationMessage(samplingRate, min, max, errorMessage);
        };
        DvsEditNetFlowDialogValidator.prototype.getNumericInputValidationMessage = function (value, minValue, maxValue, errorMessage) {
            if (!this.networkUtil.isPositiveInteger(Number(value), minValue, maxValue)) {
                return errorMessage;
            }
            return null;
        };
        DvsEditNetFlowDialogValidator.$inject = [
            "i18nService",
            "ipParserService",
            "networkUtil"
        ];
        return DvsEditNetFlowDialogValidator;
    }());
    dvs_ui.DvsEditNetFlowDialogValidator = DvsEditNetFlowDialogValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditNetFlowDialogValidator", DvsEditNetFlowDialogValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNiocSharesPageComponent = (function () {
        function DvsNiocSharesPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsNiocSharesPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/niocupgrade/components/" +
                "dvsNiocSharesPageComponentTemplate.html";
        }
        return DvsNiocSharesPageComponent;
    }());
    dvs_ui.DvsNiocSharesPageComponent = DvsNiocSharesPageComponent;
    var DvsNiocSharesPageComponentController = (function () {
        function DvsNiocSharesPageComponentController(i18nService) {
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
        }
        DvsNiocSharesPageComponentController.$inject = [
            "i18nService"
        ];
        return DvsNiocSharesPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNiocSharesPage", new DvsNiocSharesPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeNiocSummaryPageComponent = (function () {
        function DvsUpgradeNiocSummaryPageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsUpgradeNiocSummaryPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/niocupgrade/components/" +
                "dvsUpgradeNiocSummaryPageTemplate.html";
        }
        return DvsUpgradeNiocSummaryPageComponent;
    }());
    dvs_ui.DvsUpgradeNiocSummaryPageComponent = DvsUpgradeNiocSummaryPageComponent;
    var DvsUpgradeNiocSummaryPageComponentController = (function () {
        function DvsUpgradeNiocSummaryPageComponentController(i18nService, vxPropertyViewService, $scope) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$scope = $scope;
            this.$scope.i18n = this.i18nService.getString;
            this.buildPropertyView();
        }
        DvsUpgradeNiocSummaryPageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            if (this.wizardModel.niocUpgradeStatistics &&
                this.wizardModel.niocUpgradeStatistics.userDefinedNrpCount > 0) {
                var modifiedObjectSection = generalCategory.section("modifiedObjectSection").title(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.modifiedObjects"));
                modifiedObjectSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.userDefinedNrpsCount"), this.wizardModel.niocUpgradeStatistics
                    .userDefinedNrpCount.toString());
                modifiedObjectSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.portGroupCount"), this.wizardModel.niocUpgradeStatistics
                    .modifiedPortGroupCount.toString());
                if (this.wizardModel.migrateShares) {
                    modifiedObjectSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares"), this.wizardModel.migrateShares
                        ? this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares.on")
                        : this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares.off"));
                    modifiedObjectSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.vmCount"), this.wizardModel.niocUpgradeStatistics.modifiedVmCount.toString());
                }
            }
            var nextStepsSection = generalCategory.section("nextStepSection")
                .title(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.nextSteps"));
            this.propertyViewData = builder.build();
        };
        DvsUpgradeNiocSummaryPageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "$scope"
        ];
        return DvsUpgradeNiocSummaryPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsUpgradeNiocSummaryPage", new DvsUpgradeNiocSummaryPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvsUpgradeNiocWizardConstants", {
        pages: {
            DVS_NIOC_OVERVIEW_PAGE: "niocOverviewPage",
            DVS_NIOC_VALIDATION_PAGE: "niocValidatePrerequisitesPage",
            DVS_NIOC_MIGRATE_SHARES_PAGE: "niocLagPage",
            DVS_NIOC_SUMMARY_PAGE: "niocReadyToCompletePage"
        },
        properties: {
            DVS_UPGRADE_NIOC_WIZARD_DATA: "niocupgrade:wizardData"
        },
        validationResult: {
            FAIL: "fail",
            WARNING: "warning",
            PASS: "pass"
        },
        spec: {
            MUTATION_SPEC_TYPE: "com.vmware.vsphere.client.dvs.specs.DvsResControlUpgradeSpec"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeNiocWizardManager = (function () {
        function DvsUpgradeNiocWizardManager(pageStateManagementService) {
            this.pageStateManagementService = pageStateManagementService;
        }
        DvsUpgradeNiocWizardManager.prototype.init = function (wizardScope) {
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
        };
        DvsUpgradeNiocWizardManager.$inject = ["pageStateManagementService"];
        return DvsUpgradeNiocWizardManager;
    }());
    dvs_ui.DvsUpgradeNiocWizardManager = DvsUpgradeNiocWizardManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeNiocWizardManager", DvsUpgradeNiocWizardManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeNiocWizardPages = (function () {
        function DvsUpgradeNiocWizardPages(i18nService, wizardConstants, simpleValidationCommit, dvsPrerequisitesPageValidator, vuiConstants) {
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.simpleValidationCommit = simpleValidationCommit;
            this.dvsPrerequisitesPageValidator = dvsPrerequisitesPageValidator;
            this.vuiConstants = vuiConstants;
        }
        /**
         * Creates an array of page definitions for the Upgrade NIOC wizard.
         */
        DvsUpgradeNiocWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var overviewPage = {
                id: this.wizardConstants.pages.DVS_NIOC_OVERVIEW_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.overview.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.overview.description"),
                contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                    "dvsUpgradeNiocOverviewPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var prerequisitesPage = {
                id: this.wizardConstants.pages.DVS_NIOC_VALIDATION_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.prerequisites.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.prerequisites.description"),
                contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                    "dvsUpgradeNiocPrerequisitesPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvsPrerequisitesPageValidator.getValidationResult(wizardScope.model.prerequisiteChecks, wizardScope.model);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var migrateSharesPage = {
                id: this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.migrateShares.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.migrateShares.description"),
                contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                    "dvsUpgradeNiocSharesPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.migrateShares"]
            };
            var summaryPage = {
                id: this.wizardConstants.pages.DVS_NIOC_SUMMARY_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.description"),
                contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                    "dvsUpgradeNiocSummaryPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var pages = [
                overviewPage,
                prerequisitesPage,
                migrateSharesPage,
                summaryPage
            ];
            return pages;
        };
        DvsUpgradeNiocWizardPages.prototype.skipPage = function (pages, pageToSkipId) {
            var page = _.findWhere(pages, { id: pageToSkipId });
            if (page) {
                page.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvsUpgradeNiocWizardPages.$inject = [
            "i18nService",
            "dvsUpgradeNiocWizardConstants",
            "simpleValidationCommit",
            "dvsPrerequisitesPageValidator",
            "vuiConstants"
        ];
        return DvsUpgradeNiocWizardPages;
    }());
    dvs_ui.DvsUpgradeNiocWizardPages = DvsUpgradeNiocWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeNiocWizardPages", DvsUpgradeNiocWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeNiocWizardService = (function () {
        function DvsUpgradeNiocWizardService($rootScope, i18nService, vuiWizardService, mutationService, dataService, specFactory, wizardConstants, wizardManager, wizardPages, wizardValidationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.specFactory = specFactory;
            this.wizardConstants = wizardConstants;
            this.wizardManager = wizardManager;
            this.wizardPages = wizardPages;
            this.wizardValidationService = wizardValidationService;
        }
        /**
         * Shows the Upgrade Network I/O Control wizard.
         */
        DvsUpgradeNiocWizardService.prototype.show = function (objectId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsUpgradeNiocWizardModel();
            wizardScope.model.dvsId = objectId;
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.initialTitle"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                cssClass: "dvs-upgrade-nioc-wizard",
                onFinish: function () {
                    var spec = _this.specFactory.buildDvsNiocUpgradeSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.dvsId, spec._type, spec);
                    return true;
                }
            };
            wizardScope.wizardConfig.pages = this.wizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.wizardManager.init(wizardScope);
            this.requestProperties(wizardScope);
        };
        DvsUpgradeNiocWizardService.prototype.requestProperties = function (wizardScope) {
            var _this = this;
            wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(wizardScope.model.dvsId, [this.wizardConstants.properties
                    .DVS_UPGRADE_NIOC_WIZARD_DATA])
                .then(function (response) {
                var wizardData = response[_this.wizardConstants.properties.
                    DVS_UPGRADE_NIOC_WIZARD_DATA];
                wizardScope.model.dvsName = wizardData.dvsName;
                wizardScope.model.prerequisiteChecks =
                    wizardData.prerequisiteCheckResults;
                wizardScope.model.niocUpgradeStatistics =
                    wizardData.niocUpgradeStatistics;
                wizardScope.wizardConfig.title = _this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.titleFormat", wizardScope.model.dvsName);
                if (!wizardScope.model.niocUpgradeStatistics ||
                    wizardScope.model.niocUpgradeStatistics
                        .userDefinedNrpCount === 0) {
                    _this.wizardPages.skipPage(wizardScope.wizardConfig.pages, _this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE);
                }
                wizardScope.wizardConfig.loading = false;
                _this.vuiWizardService({
                    scope: wizardScope,
                    configObjectName: "wizardConfig"
                }).show();
            });
        };
        DvsUpgradeNiocWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "mutationService",
            "dataService",
            "dvsUpgradeNiocWizardSpecFactory",
            "dvsUpgradeNiocWizardConstants",
            "dvsUpgradeNiocWizardManager",
            "dvsUpgradeNiocWizardPages",
            "wizardValidationService"
        ];
        return DvsUpgradeNiocWizardService;
    }());
    dvs_ui.DvsUpgradeNiocWizardService = DvsUpgradeNiocWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeNiocWizardService", DvsUpgradeNiocWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsResControlUpgradeSpec = com.vmware.vsphere.client.dvs.api.spec.DvsResControlUpgradeSpec;
    /**
     * Provides methods from creating the mutation spec sent to the backend
     * after the completion of the Upgrade NIOC wizard.
     */
    var DvsUpgradeNiocWizardSpecFactory = (function () {
        function DvsUpgradeNiocWizardSpecFactory(defaultUriSchemeUtil) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        /**
         * Builds the spec the Upgrade NIOC mutation operation.
         */
        DvsUpgradeNiocWizardSpecFactory.prototype.buildDvsNiocUpgradeSpec = function (model) {
            var upgradeSpec = new DvsResControlUpgradeSpec();
            upgradeSpec.migrateShares = model.migrateShares;
            return upgradeSpec;
        };
        DvsUpgradeNiocWizardSpecFactory.$inject = ["defaultUriSchemeUtil"];
        return DvsUpgradeNiocWizardSpecFactory;
    }());
    dvs_ui.DvsUpgradeNiocWizardSpecFactory = DvsUpgradeNiocWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeNiocWizardSpecFactory", DvsUpgradeNiocWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeNiocWizardModel = (function () {
        function DvsUpgradeNiocWizardModel() {
            this.prerequisiteWarningShown = false;
            this.migrateShares = false;
        }
        return DvsUpgradeNiocWizardModel;
    }());
    dvs_ui.DvsUpgradeNiocWizardModel = DvsUpgradeNiocWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionEditableListComponent = (function () {
        function DvsSpanSessionEditableListComponent() {
            this.bindings = {
                model: "<",
                validator: "<",
                pageId: "@"
            };
            this.controller = DvsSpanSessionEditableListComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/common/components/" +
                "dvsSpanSessionEditableListComponentTemplate.html";
        }
        return DvsSpanSessionEditableListComponent;
    }());
    dvs_ui.DvsSpanSessionEditableListComponent = DvsSpanSessionEditableListComponent;
    var DvsSpanSessionEditableListComponentController = (function () {
        function DvsSpanSessionEditableListComponentController(i18nService, vuiConstants, ipParserService, vxValidatorFactory, dvsSpanSessionEditableListValidator, networkUtil) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.ipParserService = ipParserService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.dvsSpanSessionEditableListValidator = dvsSpanSessionEditableListValidator;
            this.networkUtil = networkUtil;
            this.getString = function (key, bundle) {
                if (bundle === void 0) { bundle = "DvsUi"; }
                return i18nService.getString(bundle, key);
            };
            this._loaded = false;
            switch (this.pageId) {
                case dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS:
                    this.getInvalidValueError = function (item) {
                        return _this.dvsSpanSessionEditableListValidator.getVlanIdError(item);
                    };
                    this.getDuplicateValueError = function (value, allValues) {
                        var occurrences = 0;
                        var isDuplicate = (_.any(allValues, function (dataItem) {
                            return dataItem.value === value && occurrences++ === 1;
                        }));
                        return isDuplicate
                            ? _this.getString("AddSpanSessionWizard.sourceVlansPage.duplicateVlanIdError")
                            : null;
                    };
                    this.columnName = this.getString("AddSpanSessionWizard.sourceVlansPage.vlanId");
                    break;
                case dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES:
                    this.getInvalidValueError = function (item) {
                        return _this.dvsSpanSessionEditableListValidator.getIpAddressError(item);
                    };
                    this.getDuplicateValueError = function (value, allValues) {
                        var actualAddress = _this.ipParserService.isIpv6AddressValid(value)
                            ? _this.ipParserService.expandIpv6Address(value) : value;
                        var actualValues = allValues.map(function (item) {
                            return _this.ipParserService.isIpv6AddressValid(item.value)
                                ? _this.ipParserService.expandIpv6Address(item.value) : item.value;
                        });
                        var occurrences = 0;
                        var isDuplicate = (_.any(actualValues, function (addr) {
                            return addr === actualAddress && occurrences++ === 1;
                        }));
                        return isDuplicate
                            ? _this.getString("AddSpanSessionWizard.destinationsPage.IpAddressList.ipAddress.error")
                            : null;
                    };
                    this.columnName = this.getString("AddSpanSessionWizard.destinationsPage.IpAddressList.ipAddress");
                    break;
                default:
                    throw new Error("Page ID not supported or not specified!");
            }
            // create a new vxValidator so that validation callbacks from previous instances
            // of this page are not called and can be GC-ed
            this.validator.vxValidator = this.vxValidatorFactory.create();
        }
        DvsSpanSessionEditableListComponentController.prototype.$onInit = function () {
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                selectedItems: [],
                resizable: true,
                showCheckboxesOnMultiSelection: false,
                actionBarOptions: { actions: this.getActionDefinitions() },
                onChange: this.onSelectionChange.bind(this),
                validator: this.validator,
                syncListModel: this.syncListModel.bind(this),
                validateAndSyncModel: this.validateAndSyncModel.bind(this),
                selectItem: function (item) {
                    var grid = $(".dvs-span-session-editable-grid [kendo-grid]").data("kendoGrid");
                    var selector = "tr[data-uid='" + item.uid + "']";
                    var trElement = $(selector)["0"];
                    grid.select(trElement);
                }
            };
            setTimeout(this.loadExistingValues.bind(this), 0);
        };
        DvsSpanSessionEditableListComponentController.prototype.$onDestroy = function () {
            delete this.validator["vxValidator"];
        };
        DvsSpanSessionEditableListComponentController.prototype.onSelectionChange = function (items) {
            this.setActionAvailability(DvsSpanSessionEditableListComponentController.REMOVE_ACTION, items && items.length > 0);
            if (this._loaded) {
                this.datagridOptions.validator.validate();
                this.datagridOptions.dataSource._data.forEach(function (item) {
                    item.active = !item.valid || _.contains(items, item) || false;
                });
                this.syncListModel();
            }
        };
        DvsSpanSessionEditableListComponentController.prototype.loadExistingValues = function () {
            var _this = this;
            if (this.model.cachedData) {
                this.model.cachedData.forEach(function (item) {
                    _this.datagridOptions.dataSource.add(item);
                });
                this.setItemCallbacks();
            }
            this._loaded = true;
        };
        DvsSpanSessionEditableListComponentController.prototype.getColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.columnName,
                    field: "value",
                    type: "string",
                    template: function (dataItem) {
                        var validator = "datagridOptions.validator";
                        var vxValidator = "datagridOptions.validator.vxValidator";
                        return "<vsc-validate class='validateable-input' ng-if='dataItem.active' [validator]='" + vxValidator + "'\n                           [required]='false' [custom-validation-function]='dataItem.validationFunction'\n                           [clr-tooltip-direction]=\"'top-left'\">\n                           <input class='fill-parent' ng-model='dataItem.value' type='text'\n                                 vx-focus-and-select ng-blur='datagridOptions.validateAndSyncModel()'\n                                 ng-change='datagridOptions.syncListModel()'\n                                 ng-click='datagridOptions.selectItem(dataItem)'/>\n                        </vsc-validate>\n                        <span ng-if='!dataItem.active' ng-bind='dataItem.value' ng-click='dataItem.onClick()'>";
                    },
                    sortable: function (item1, item2) {
                        return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "value");
                    }
                }];
        };
        DvsSpanSessionEditableListComponentController.prototype.getActionDefinitions = function () {
            var _this = this;
            return [{
                    id: DvsSpanSessionEditableListComponentController.ADD_ACTION,
                    iconClass: "vsphere-icon-add",
                    enabled: true,
                    onClick: function () { _this.addRow(); }
                }, {
                    id: DvsSpanSessionEditableListComponentController.REMOVE_ACTION,
                    iconClass: "vsphere-icon-remove",
                    enabled: true,
                    onClick: function () { _this.removeSelectedRows(); }
                }];
        };
        DvsSpanSessionEditableListComponentController.prototype.addRow = function () {
            // add a row only if the last one is not empty and is valid
            var canAddRow = !this.datagridOptions.dataSource._data ||
                !this.datagridOptions.dataSource._data.length ||
                _.last(this.datagridOptions.dataSource._data).valid; // no implicit any :(
            if (canAddRow) {
                // deactivate all valid rows
                this.datagridOptions.dataSource._data.forEach(function (item) {
                    item.active = !item.valid;
                });
                var item = {
                    value: "",
                    active: true,
                    valid: true
                };
                this.datagridOptions.dataSource.add(item);
                this.setItemCallbacks();
                this.datagridOptions.selectItem(_.last(this.datagridOptions.dataSource._data));
            }
        };
        DvsSpanSessionEditableListComponentController.prototype.setItemCallbacks = function () {
            var _this = this;
            this.datagridOptions.dataSource._data.forEach(function (item) {
                item.validationFunction = function () {
                    if (item.deleted) {
                        return [];
                    }
                    var error = _this.getInvalidValueError(item.value) ||
                        _this.getDuplicateValueError(item.value, _this.datagridOptions.dataSource._data);
                    item.valid = error === null;
                    return !item.valid ? [error] : [];
                };
                item.onClick = function () {
                    item.active = true;
                };
            });
        };
        DvsSpanSessionEditableListComponentController.prototype.removeSelectedRows = function () {
            var _this = this;
            if (this.datagridOptions.selectedItems) {
                this.datagridOptions.selectedItems.forEach(function (item) {
                    _this.datagridOptions.dataSource.remove(item);
                    // this item's validation callback is active as long as the
                    // vxValidator instance exists, there is no way to unhook it so
                    // mark it as inactive
                    item.deleted = true;
                });
                this.validateAndSyncModel();
                this.setActionAvailability(DvsSpanSessionEditableListComponentController.REMOVE_ACTION, false);
            }
        };
        DvsSpanSessionEditableListComponentController.prototype.syncListModel = function () {
            var values = [];
            var cachedData = [];
            this.datagridOptions.dataSource._data.forEach(function (item) {
                values.push(item.value);
                cachedData.push({
                    value: item.value,
                    active: item.active,
                    valid: item.valid
                });
            });
            this.model.values = (typeof this.model.values === "undefined"
                || this.hasCollectionChanged(values, this.model.values))
                ? values : this.model.values;
            this.model.cachedData = (typeof this.model.cachedData === "undefined"
                || this.hasCollectionChanged(values, this.model.cachedData))
                ? cachedData : this.model.cachedData;
        };
        DvsSpanSessionEditableListComponentController.prototype.hasCollectionChanged = function (original, proposed) {
            if (original.length !== proposed.length) {
                return true;
            }
            return _.zip(original, proposed).some(function (tuple) {
                return tuple[0] !== tuple[1];
            });
        };
        DvsSpanSessionEditableListComponentController.prototype.validateAndSyncModel = function () {
            this.datagridOptions.validator.validate();
            this.syncListModel();
        };
        DvsSpanSessionEditableListComponentController.prototype.setActionAvailability = function (actionId, enabled) {
            for (var _i = 0, _a = this.datagridOptions.actionBarOptions.actions; _i < _a.length; _i++) {
                var actionDef = _a[_i];
                if (actionDef.id === actionId) {
                    actionDef.enabled = enabled;
                    break;
                }
            }
        };
        DvsSpanSessionEditableListComponentController.$inject = [
            "i18nService",
            "vuiConstants",
            "ipParserService",
            "vxValidatorFactory",
            "dvsSpanSessionEditableListValidator",
            "networkUtil"
        ];
        // action IDs
        DvsSpanSessionEditableListComponentController.ADD_ACTION = "addIpAction";
        DvsSpanSessionEditableListComponentController.REMOVE_ACTION = "removeIpAction";
        return DvsSpanSessionEditableListComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionEditableList", new DvsSpanSessionEditableListComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortBrowserComponent = (function () {
        function DvsSpanSessionPortBrowserComponent() {
            this.bindings = {
                dvsUrn: "<",
                portsToIgnore: "<",
                onSelectionChange: "<"
            };
            this.controller = DvsSpanSessionPortBrowserComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/common/components/" +
                "dvsSpanSessionPortBrowserComponentTemplate.html";
        }
        return DvsSpanSessionPortBrowserComponent;
    }());
    dvs_ui.DvsSpanSessionPortBrowserComponent = DvsSpanSessionPortBrowserComponent;
    var DvsSpanSessionPortBrowserComponentController = (function () {
        function DvsSpanSessionPortBrowserComponentController(i18nService, vuiConstants, portBrowserService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.portBrowserService = portBrowserService;
            this.getString = function (key, bundle) {
                if (bundle === void 0) { bundle = "DvsUi"; }
                return i18nService.getString(bundle, key);
            };
            this.datagridOptions = this.portBrowserService.createDatagridOptions(this.onSelectionChange);
            this.loading = false;
        }
        DvsSpanSessionPortBrowserComponentController.prototype.$onInit = function () {
            var _this = this;
            this.loading = true;
            this.portBrowserService.getData(this.dvsUrn)
                .then(function (data) {
                var filteredData;
                if (_this.portsToIgnore && data) {
                    // minor optimization
                    var ignoredPorts_1 = {};
                    _this.portsToIgnore.forEach(function (portId) {
                        ignoredPorts_1[portId] = true;
                    });
                    filteredData = data.filter(function (portData) {
                        return !ignoredPorts_1[portData.portId];
                    });
                }
                else {
                    filteredData = data;
                }
                _this.datagridOptions.data = filteredData || [];
                _this.loading = false;
            });
        };
        DvsSpanSessionPortBrowserComponentController.$inject = [
            "i18nService",
            "vuiConstants",
            "dvsSpanSessionPortBrowserService"
        ];
        return DvsSpanSessionPortBrowserComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionPortBrowser", new DvsSpanSessionPortBrowserComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortListItemData = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.portlist.DvsSpanSessionPortListItemData;
    var DvsSpanSessionPortsListComponent = (function () {
        function DvsSpanSessionPortsListComponent() {
            this.bindings = {
                dvsUrn: "<",
                model: "<",
                trafficDirectionEnabled: "<",
                editMode: "<"
            };
            this.controller = DvsSpanSessionPortsListComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/common/components/" +
                "dvsSpanSessionPortsListComponentTemplate.html";
        }
        return DvsSpanSessionPortsListComponent;
    }());
    dvs_ui.DvsSpanSessionPortsListComponent = DvsSpanSessionPortsListComponent;
    var DvsSpanSessionPortsListComponentController = (function () {
        function DvsSpanSessionPortsListComponentController(i18nService, vuiConstants, dataService, portBrowserDialogService, portsListService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.portBrowserDialogService = portBrowserDialogService;
            this.portsListService = portsListService;
            this.getString = function (key, bundle) {
                if (bundle === void 0) { bundle = "DvsUi"; }
                return i18nService.getString(bundle, key);
            };
            this.preselectComparator = function (item) {
                return _this._selectedPortsIds
                    && _this._selectedPortsIds.indexOf(item.portId) > -1;
            };
            this.loading = false;
        }
        DvsSpanSessionPortsListComponentController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions =
                this.portsListService.createDatagridOptions(this.getActionDefinitions(), this.onSelectionChange.bind(this), this.trafficDirectionEnabled);
            if (this.editMode) {
                this.loading = true;
                var portIds = this.model.ports.map(function (portData) {
                    return portData.id;
                });
                this.portsListService.getData(this.dvsUrn, portIds)
                    .then(function (data) {
                    _this.datagridOptions.data =
                        _this.model.ports.map(function (data) {
                            var listItemData = new DvsSpanSessionPortListItemData();
                            listItemData.portId = data.id;
                            listItemData.trafficDirection = data.trafficDirection;
                            return listItemData;
                        });
                    _this.onDataRetrieved(data);
                });
            }
            else if (this.model.cachedData) {
                setTimeout(function () { _this.datagridOptions.data = _this.model.cachedData; }, 0);
            }
        };
        DvsSpanSessionPortsListComponentController.prototype.getActionDefinitions = function () {
            var _this = this;
            var actionDefinitions = [];
            actionDefinitions.push({
                id: DvsSpanSessionPortsListComponentController.ADD_ACTION,
                enabled: true,
                iconClass: "network-lib-ui-icon-portAdd",
                tooltipText: this.i18nService.getString("DvsUi", "sessionDvPortSourceList.addPortByPortSelector"),
                onClick: function () {
                    var portsToIgnore = [];
                    if (_this.model.ports) {
                        portsToIgnore = _.map(_this.model.ports, function (port) {
                            return port.id;
                        });
                    }
                    _this.portBrowserDialogService.show(_this.dvsUrn, portsToIgnore, function (portIds) {
                        if (!portIds || portIds.length === 0) {
                            return;
                        }
                        _this.loading = true;
                        _this.portsListService.getData(_this.dvsUrn, portIds)
                            .then(function (data) {
                            _this.onDataRetrieved(data);
                        });
                    });
                }
            });
            actionDefinitions.push({
                id: DvsSpanSessionPortsListComponentController.REMOVE_ACTION,
                enabled: true,
                iconClass: "vx-icon-removeIcon",
                tooltipText: this.i18nService.getString("DvsUi", "sessionDvPortSourceList.remove"),
                onClick: function () {
                    var selectedPortIds = _.map(_this.datagridOptions.selectedItems, function (item) {
                        return item.portId;
                    });
                    _this.model.ports = _.filter(_this.model.ports, function (port) {
                        return selectedPortIds.indexOf(port.id) < 0;
                    });
                    _this.datagridOptions.data =
                        _.filter(_this.datagridOptions.data, function (item) {
                            return selectedPortIds.indexOf(item.portId) < 0;
                        });
                    _this.model.cachedData = _this.datagridOptions.data;
                }
            });
            if (this.trafficDirectionEnabled) {
                actionDefinitions.push(this.vuiConstants.actions.SEPARATOR);
                actionDefinitions.push({
                    id: DvsSpanSessionPortsListComponentController.INGRESS_ACTION,
                    enabled: true,
                    iconClass: "network-lib-ui-icon-ingressTraffic",
                    tooltipText: this.i18nService.getString("DvsUi", "sessionDvPortSourceList.ingress"),
                    onClick: function () {
                        _this.onTrafficDirectionChange(dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS);
                    }
                });
                actionDefinitions.push({
                    id: DvsSpanSessionPortsListComponentController.EGRESS_ACTION,
                    enabled: true,
                    iconClass: "network-lib-ui-icon-egressTraffic",
                    tooltipText: this.i18nService.getString("DvsUi", "sessionDvPortSourceList.egress"),
                    onClick: function () {
                        _this.onTrafficDirectionChange(dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS);
                    }
                });
                actionDefinitions.push({
                    id: DvsSpanSessionPortsListComponentController.BOTH_ACTION,
                    enabled: true,
                    iconClass: "network-lib-ui-icon-ingressEgressTraffic",
                    tooltipText: this.i18nService.getString("DvsUi", "sessionDvPortSourceList.both"),
                    onClick: function () {
                        _this.onTrafficDirectionChange(dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH);
                    }
                });
            }
            return actionDefinitions;
        };
        DvsSpanSessionPortsListComponentController.prototype.onDataRetrieved = function (data) {
            var _this = this;
            var existingKeys = [];
            var newData = [];
            this.datagridOptions.data.forEach(function (item) {
                newData.push(item);
                existingKeys.push(item.portId);
            });
            data.items.forEach(function (item) {
                if (existingKeys.indexOf(item.portId) < 0) {
                    item.trafficDirection =
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH;
                    newData.push(item);
                    _this.model.ports.push(new dvs_ui.PortData(item.portId, item.trafficDirection));
                }
                else {
                    newData.forEach(function (existingItem) {
                        if (existingItem.portId === item.portId) {
                            existingItem.host = item.host;
                            existingItem.connectee = item.connectee;
                            existingItem.connecteeType = item.connecteeType;
                        }
                    });
                }
            });
            this.datagridOptions.data = newData;
            this.model.cachedData = newData;
            this.loading = false;
        };
        DvsSpanSessionPortsListComponentController.prototype.onSelectionChange = function (items) {
            if (this._ignoreNextItemSelection) {
                this._ignoreNextItemSelection = false;
                return;
            }
            var hasSelectedItems = items && items.length > 0;
            if (hasSelectedItems) {
                this._selectedPortsIds = _.map(items, function (item) {
                    return item.portId;
                });
            }
            else {
                this._selectedPortsIds = [];
            }
            for (var _i = 0, _a = this.datagridOptions.actionBarOptions.actions; _i < _a.length; _i++) {
                var actionDef = _a[_i];
                if (actionDef.id === DvsSpanSessionPortsListComponentController.REMOVE_ACTION
                    || actionDef.id === DvsSpanSessionPortsListComponentController.BOTH_ACTION
                    || actionDef.id === DvsSpanSessionPortsListComponentController.EGRESS_ACTION
                    || actionDef.id === DvsSpanSessionPortsListComponentController.INGRESS_ACTION) {
                    actionDef.enabled = hasSelectedItems;
                }
            }
        };
        DvsSpanSessionPortsListComponentController.prototype.onTrafficDirectionChange = function (direction) {
            this._ignoreNextItemSelection = true;
            var selectedPortIds = _.map(this.datagridOptions.selectedItems, function (item) {
                return item.portId;
            });
            this.model.ports.forEach(function (port) {
                if (selectedPortIds.indexOf(port.id) > -1) {
                    port.trafficDirection = direction;
                }
            });
            this.datagridOptions.data.forEach(function (item) {
                if (selectedPortIds.indexOf(item.portId) > -1) {
                    item.trafficDirection = direction;
                }
            });
            // reset grid data
            this.datagridOptions.data = this.datagridOptions.data.slice();
            this.model.cachedData = this.datagridOptions.data;
        };
        DvsSpanSessionPortsListComponentController.$inject = [
            "i18nService",
            "vuiConstants",
            "dataService",
            "dvsSpanSessionPortBrowserDialogService",
            "dvsSpanSessionPortsListService"
        ];
        // action IDs
        DvsSpanSessionPortsListComponentController.ADD_ACTION = "add-ports";
        DvsSpanSessionPortsListComponentController.REMOVE_ACTION = "remove-ports";
        DvsSpanSessionPortsListComponentController.INGRESS_ACTION = "set-ingress";
        DvsSpanSessionPortsListComponentController.EGRESS_ACTION = "set-egress";
        DvsSpanSessionPortsListComponentController.BOTH_ACTION = "set-both";
        return DvsSpanSessionPortsListComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionPortsList", new DvsSpanSessionPortsListComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPropertiesPageComponent = (function () {
        function DvsSpanSessionPropertiesPageComponent() {
            this.bindings = {
                pageModel: "<",
                validator: "<",
                sessionType: "<",
                editMode: "<",
                loading: "<"
            };
            this.controller = DvsSpanSessionPropertiesPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/common/components/" +
                "dvsSpanSessionPropertiesPageComponentTemplate.html";
        }
        return DvsSpanSessionPropertiesPageComponent;
    }());
    dvs_ui.DvsSpanSessionPropertiesPageComponent = DvsSpanSessionPropertiesPageComponent;
    var DvsSpanSessionPropertiesPageComponentController = (function () {
        function DvsSpanSessionPropertiesPageComponentController(i18nService, vxValidatorFactory, propertiesValidator) {
            this.i18nService = i18nService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.propertiesValidator = propertiesValidator;
            this.getString = function (key) {
                return i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionPropertiesPageComponentController.prototype.$onInit = function () {
            // create a new vxValidator so that validation callbacks from previous instances
            // of this page are not called and can be GC-ed
            this.validator.vxValidator = this.vxValidatorFactory.create();
            this.initDropdownOptions();
            this.initValidationFunctions();
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.$onDestroy = function () {
            delete this.validator["vxValidator"];
        };
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "sessionTypeLabel", {
            get: function () {
                switch (this.sessionType) {
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                        return this.getString("span.session.type.encapsulatedRemoteMirrorSource");
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                        return this.getString("span.session.type.remoteMirrorSource");
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                        return this.getString("span.session.type.dvPortMirror");
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST: {
                        return this.getString("span.session.type.remoteMirrorDest");
                    }
                    default:
                        return this.getString("AddSpanSessionWizard.noData");
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "sessionIdEnabled", {
            get: function () {
                return this.pageModel.encapsulationType !==
                    dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "encapsulationTypeEnabled", {
            get: function () {
                return !this.editMode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "sessionIdAvailable", {
            get: function () {
                return !this.editMode || this.pageModel.encapsulationType !==
                    dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "encapsulationOptionsAvailable", {
            get: function () {
                return this.sessionType ===
                    dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE
                    && this.pageModel.erspanSupported;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "vlanOptionsAvailable", {
            get: function () {
                return this.sessionType ===
                    dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsSpanSessionPropertiesPageComponentController.prototype, "normalIoOptionsAvailable", {
            get: function () {
                return this.sessionType !==
                    dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE;
            },
            enumerable: true,
            configurable: true
        });
        DvsSpanSessionPropertiesPageComponentController.prototype.initDropdownOptions = function () {
            this.sessionStatusOptions = [{
                    value: false,
                    label: this.getString("AddSpanSessionWizard.propertiesPage.status.disabled")
                }, {
                    value: true,
                    label: this.getString("AddSpanSessionWizard.propertiesPage.status.enabled")
                }];
            this.encapsulationTypeOptions = [{
                    value: dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE,
                    label: this.getString("SpanSessionEncapsulation.type.gre")
                }, {
                    value: dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN2,
                    label: this.getString("SpanSessionEncapsulation.type.erspan2")
                }, {
                    value: dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN3,
                    label: this.getString("SpanSessionEncapsulation.type.erspan3")
                }];
            this.isTcpIpStackInVspanSessionSupported = this.pageModel.isTcpIpStackSupported &&
                this.sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE;
            if (this.isTcpIpStackInVspanSessionSupported) {
                this.tcpIpNetStackOptions = [{
                        value: dvs_ui.DvsSpanSessionConstants.TCP_IP_STACK.DEFAULT_STACK,
                        label: this.getString("spanSession.tcpip.stack.default")
                    }, {
                        value: dvs_ui.DvsSpanSessionConstants.TCP_IP_STACK.MIRROR_STACK,
                        label: this.getString("spanSession.tcpip.stack.mirror")
                    }];
            }
            this.normalTrafficAllowedOptions = [{
                    value: false,
                    label: this.getString("AddSpanSessionWizard.propertiesPage.normalTrafficAllowed.off")
                }, {
                    value: true,
                    label: this.getString("AddSpanSessionWizard.propertiesPage.normalTrafficAllowed.on")
                }];
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.initValidationFunctions = function () {
            this.validationFunctions = {};
            this.validationFunctions["sessionName"] =
                this.getSessionNameValidationFunction();
            this.validationFunctions["sessionId"] =
                this.getSessionIdValidationFunction();
            this.validationFunctions["mirroredPacketLength"] =
                this.getPacketLengthValidationFunction();
            this.validationFunctions["samplingRate"] =
                this.getSamplingRateValidationFunction();
            this.validationFunctions["encapsulationVlanId"] =
                this.getEncapsulationVlanIdValidationFunction();
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.getSessionNameValidationFunction = function () {
            var _this = this;
            return function () {
                var error = _this.propertiesValidator.getNameError(_this.pageModel.sessionName);
                return error ? [error] : [];
            };
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.getSessionIdValidationFunction = function () {
            var _this = this;
            return function () {
                if (_this.pageModel.encapsulationType ===
                    dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE) {
                    return [];
                }
                var error = _this.propertiesValidator.getSessionIdError(_this.pageModel.sessionId);
                return error ? [error] : [];
            };
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.getPacketLengthValidationFunction = function () {
            var _this = this;
            return function () {
                if (!_this.pageModel.mirroredPacketLengthEnabled) {
                    return [];
                }
                var error = _this.propertiesValidator.getPacketLengthError(_this.pageModel.mirroredPacketLength);
                return error ? [error] : [];
            };
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.getSamplingRateValidationFunction = function () {
            var _this = this;
            return function () {
                var error = _this.propertiesValidator.getSamplingRateError(_this.pageModel.samplingRate);
                return error ? [error] : [];
            };
        };
        DvsSpanSessionPropertiesPageComponentController.prototype.getEncapsulationVlanIdValidationFunction = function () {
            var _this = this;
            return function () {
                var error = _this.propertiesValidator.getEncapsulationVlanIdError(_this.pageModel.encapsulationVlanId);
                return error ? [error] : [];
            };
        };
        DvsSpanSessionPropertiesPageComponentController.$inject = [
            "i18nService",
            "vxValidatorFactory",
            "dvsSpanSessionPropertiesValidator"
        ];
        return DvsSpanSessionPropertiesPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionPropertiesPage", new DvsSpanSessionPropertiesPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionSelectDestinationUplinksPageComponent = (function () {
        function DvsSpanSessionSelectDestinationUplinksPageComponent() {
            this.bindings = {
                model: "<",
                dvsUrn: "<"
            };
            this.controller = DvsSpanSessionSelectDestinationUplinksPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/common/components/" +
                "dvsSpanSessionSelectDestinationUplinksPageComponentTemplate.html";
        }
        return DvsSpanSessionSelectDestinationUplinksPageComponent;
    }());
    dvs_ui.DvsSpanSessionSelectDestinationUplinksPageComponent = DvsSpanSessionSelectDestinationUplinksPageComponent;
    var DvsSpanSessionSelectDestinationUplinksPageComponentController = (function () {
        function DvsSpanSessionSelectDestinationUplinksPageComponentController(i18nService, vuiConstants, dvsSpanSessionDestinationUplinksService, $scope) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dvsSpanSessionDestinationUplinksService = dvsSpanSessionDestinationUplinksService;
            this.$scope = $scope;
            $scope.i18n = this.i18nService.getString;
            this._loaded = false;
        }
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.$onInit = function () {
            this.existingUplinksDatagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.NONE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                data: [],
                selectedItems: [],
                resizable: true,
                onChange: this.onPrimaryGridSelectionChange.bind(this)
            };
            this.selectedUplinksDatagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getSelectedUplinksColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.NONE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                data: [],
                selectedItems: [],
                resizable: true,
                onChange: this.onSecondaryGridSelectionChange.bind(this)
            };
            this.getDestinationUplinkNames(this.dvsUrn);
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.getDestinationUplinkNames = function (dvsUrn) {
            var _this = this;
            var existingUplinksNotLoaded = !this.model.notSelectedUplinks ||
                this.model.notSelectedUplinks.length === 0;
            var selectedUplinksNotLoaded = !this.model.uplinks ||
                this.model.uplinks.length === 0;
            if (existingUplinksNotLoaded && selectedUplinksNotLoaded) {
                // If the page is loaded for the first time and the model is not filled
                // reuqest data and fill the datagridOptions for the existing uplinks
                var uplinksRequestPromise_1 = this.dvsSpanSessionDestinationUplinksService
                    .getDestinationUplinkNames(dvsUrn);
                this.uplinksPromise = uplinksRequestPromise_1;
                uplinksRequestPromise_1
                    .then(function (uplinkNamesReceived) {
                    if (_this.uplinksPromise === uplinksRequestPromise_1) {
                        _this.existingUplinksDatagridOptions.data
                            = uplinkNamesReceived ? uplinkNamesReceived : [];
                        _this._loaded = true;
                        _this.isAddAllBtnEnabled =
                            _this.existingUplinksDatagridOptions.data.length > 0;
                        _this.isRemoveAllBtnEnabled =
                            _this.selectedUplinksDatagridOptions.data.length > 0;
                    }
                });
            }
            else {
                // If the page is loaded for the second time, fill both grids with
                // the data from the model
                this.fillDataForDataGrid(this.model.notSelectedUplinks, this.existingUplinksDatagridOptions);
                this.fillDataForDataGrid(this.model.uplinks, this.selectedUplinksDatagridOptions);
                this.isAddAllBtnEnabled =
                    this.existingUplinksDatagridOptions.data.length > 0;
                this.isRemoveAllBtnEnabled =
                    this.selectedUplinksDatagridOptions.data.length > 0;
            }
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.fillDataForDataGrid = function (uplinkNames, datagridOptions) {
            var dataArray = [];
            for (var i = 0; i < uplinkNames.length; i++) {
                var dataObj = {
                    uplinkName: uplinkNames[i]
                };
                dataArray.push(dataObj);
            }
            datagridOptions.data = dataArray;
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.getColumnDefinitions = function () {
            return [
                {
                    displayName: this.$scope.i18n("DvsUi", "AddSpanSessionWizard.destinationsPage.UplinksLists.existingUplinksTitle"),
                    width: "150px",
                    field: "uplinkName",
                    sortable: true,
                    type: "string"
                }
            ];
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.getSelectedUplinksColumnDefinitions = function () {
            return [
                {
                    displayName: this.$scope.i18n("DvsUi", "AddSpanSessionWizard.destinationsPage.UplinksLists.selectedUplinksTitle"),
                    width: "150px",
                    field: "uplinkName",
                    sortable: true,
                    type: "string"
                }
            ];
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onPrimaryGridSelectionChange = function (items) {
            this.isAddBtnEnabled = items && items.length > 0;
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onSecondaryGridSelectionChange = function (items) {
            this.isRemoveBtnEnabled = items && items.length > 0;
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onAddBtnClicked = function () {
            if (this.existingUplinksDatagridOptions.selectedItems &&
                this.existingUplinksDatagridOptions.selectedItems.length > 0) {
                var selectedUplinksDatagridData_1 = this.selectedUplinksDatagridOptions.data.slice();
                var datagridData_1 = this.existingUplinksDatagridOptions.data.slice();
                this.existingUplinksDatagridOptions.selectedItems.forEach(function (item) {
                    var dataObj = {
                        uplinkName: item.uplinkName
                    };
                    var whereRes = _.where(datagridData_1, dataObj);
                    datagridData_1 = _.without(datagridData_1, whereRes[0]);
                    selectedUplinksDatagridData_1.push(dataObj);
                });
                this.selectedUplinksDatagridOptions.data = selectedUplinksDatagridData_1;
                this.existingUplinksDatagridOptions.data = datagridData_1;
                this.isAddAllBtnEnabled =
                    this.existingUplinksDatagridOptions.data.length > 0;
                this.isRemoveAllBtnEnabled =
                    this.selectedUplinksDatagridOptions.data.length > 0;
                this.existingUplinksDatagridOptions.selectedItems = [];
                this.syncListModel();
            }
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onAddAllBtnClicked = function () {
            if (this.existingUplinksDatagridOptions.data &&
                this.existingUplinksDatagridOptions.data.length > 0) {
                var selectedUplinksDatagridData = this.selectedUplinksDatagridOptions.data.slice();
                if (!this.existingUplinksDatagridOptions.data.length) {
                    this.selectedUplinksDatagridOptions.data
                        = this.existingUplinksDatagridOptions.data;
                }
                else {
                    this.selectedUplinksDatagridOptions.data =
                        _.union(selectedUplinksDatagridData, this.existingUplinksDatagridOptions.data);
                }
                this.existingUplinksDatagridOptions.data = [];
                this.isRemoveAllBtnEnabled = true;
                this.isAddAllBtnEnabled = false;
                this.syncListModel();
            }
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onRemoveBtnClicked = function () {
            if (this.selectedUplinksDatagridOptions.selectedItems &&
                this.selectedUplinksDatagridOptions.selectedItems.length > 0) {
                var datagridData_2 = this.existingUplinksDatagridOptions.data.slice();
                var selectedUplinksDatagridData_2 = this.selectedUplinksDatagridOptions.data.slice();
                this.selectedUplinksDatagridOptions.selectedItems.forEach(function (item) {
                    var dataObj = {
                        uplinkName: item.uplinkName
                    };
                    var whereRes = _.where(selectedUplinksDatagridData_2, dataObj);
                    selectedUplinksDatagridData_2 =
                        _.without(selectedUplinksDatagridData_2, whereRes[0]);
                    datagridData_2.push(dataObj);
                });
                this.selectedUplinksDatagridOptions.data = selectedUplinksDatagridData_2;
                this.existingUplinksDatagridOptions.data = datagridData_2;
                this.selectedUplinksDatagridOptions.selectedItems = [];
                this.isRemoveAllBtnEnabled =
                    this.selectedUplinksDatagridOptions.data.length > 0;
                this.isAddAllBtnEnabled =
                    this.existingUplinksDatagridOptions.data.length > 0;
                this.syncListModel();
            }
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.onRemoveAllBtnClicked = function () {
            if (this.selectedUplinksDatagridOptions.data &&
                this.selectedUplinksDatagridOptions.data.length > 0) {
                var datagridData = this.existingUplinksDatagridOptions.data.slice();
                if (!this.existingUplinksDatagridOptions.data.length) {
                    this.existingUplinksDatagridOptions.data =
                        this.selectedUplinksDatagridOptions.data;
                }
                else {
                    this.existingUplinksDatagridOptions.data =
                        _.union(datagridData, this.selectedUplinksDatagridOptions.data);
                }
                this.selectedUplinksDatagridOptions.data = [];
                this.isRemoveAllBtnEnabled = false;
                this.isAddAllBtnEnabled = true;
                this.syncListModel();
            }
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.prototype.syncListModel = function () {
            var _this = this;
            this.model.uplinks = [];
            this.model.notSelectedUplinks = [];
            this.selectedUplinksDatagridOptions.data.forEach(function (item) {
                _this.model.uplinks.push(item.uplinkName);
            });
            this.existingUplinksDatagridOptions.data.forEach(function (item) {
                _this.model.notSelectedUplinks.push(item.uplinkName);
            });
        };
        DvsSpanSessionSelectDestinationUplinksPageComponentController.$inject = [
            "i18nService",
            "vuiConstants",
            "dvsSpanSessionDestinationUplinksService",
            "$scope"
        ];
        return DvsSpanSessionSelectDestinationUplinksPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionSelectDestinationUplinksPageComponent", new DvsSpanSessionSelectDestinationUplinksPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var SessionType = (function () {
        function SessionType() {
            this.DV_PORT_MIRROR = "dvPortMirror";
            this.REMOTE_MIRROR_DEST = "remoteMirrorDest";
            this.REMOTE_MIRROR_SOURCE = "remoteMirrorSource";
            this.L3_SOURCE = "encapsulatedRemoteMirrorSource";
        }
        return SessionType;
    }());
    var EncapsulationType = (function () {
        function EncapsulationType() {
            this.GRE = "gre";
            this.ERSPAN2 = "erspan2";
            this.ERSPAN3 = "erspan3";
        }
        return EncapsulationType;
    }());
    var TrafficDirection = (function () {
        function TrafficDirection() {
            this.INGRESS = "ingress";
            this.EGRESS = "egress";
            this.BOTH = "both";
        }
        return TrafficDirection;
    }());
    var TcpIpNetStack = (function () {
        function TcpIpNetStack() {
            this.DEFAULT_STACK = "defaultTcpipStack";
            this.MIRROR_STACK = "mirror";
        }
        return TcpIpNetStack;
    }());
    var DvsSpanSessionConstants = (function () {
        function DvsSpanSessionConstants() {
        }
        DvsSpanSessionConstants.PAGE_ID = {
            SELECT_SESSION_TYPE: "selectSessionTypePage",
            EDIT_PROPERIES: "editPropertiesPage",
            SELECT_SOURCE_PORTS: "selectSourcePortsPage",
            SELECT_SOURCE_VLANS: "selectSourceVlansPage",
            SELECT_DESTINATION_PORTS: "selectDestinationPortsPage",
            SELECT_DESTINATION_ADDRESSES: "selectDestinationAddressesPage",
            SELECT_DESTINATION_UPLINKS: "selectDestinationUplinksPage",
            READY_TO_COMPLETE: "readyToCompletePage"
        };
        DvsSpanSessionConstants.SESSION_TYPE = new SessionType();
        DvsSpanSessionConstants.ENCAPSULATION_TYPE = new EncapsulationType();
        DvsSpanSessionConstants.TRAFFIC_DIRECTION = new TrafficDirection();
        DvsSpanSessionConstants.TCP_IP_STACK = new TcpIpNetStack();
        DvsSpanSessionConstants.VLAN_ID_MIN = 1;
        DvsSpanSessionConstants.VLAN_ID_MAX = 4094;
        return DvsSpanSessionConstants;
    }());
    dvs_ui.DvsSpanSessionConstants = DvsSpanSessionConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionDestinationUplinksModel = (function () {
        function DvsSpanSessionDestinationUplinksModel() {
            this.uplinks = [];
            this.notSelectedUplinks = [];
        }
        return DvsSpanSessionDestinationUplinksModel;
    }());
    dvs_ui.DvsSpanSessionDestinationUplinksModel = DvsSpanSessionDestinationUplinksModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionEditableListModel = (function () {
        function DvsSpanSessionEditableListModel() {
            this.values = [];
        }
        return DvsSpanSessionEditableListModel;
    }());
    dvs_ui.DvsSpanSessionEditableListModel = DvsSpanSessionEditableListModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortsListModel = (function () {
        function DvsSpanSessionPortsListModel() {
            this.ports = [];
        }
        return DvsSpanSessionPortsListModel;
    }());
    dvs_ui.DvsSpanSessionPortsListModel = DvsSpanSessionPortsListModel;
    var PortData = (function () {
        function PortData(id, direction) {
            this.id = id;
            this.trafficDirection = direction;
        }
        return PortData;
    }());
    dvs_ui.PortData = PortData;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPropertiesPageModel = (function () {
        function DvsSpanSessionPropertiesPageModel() {
        }
        return DvsSpanSessionPropertiesPageModel;
    }());
    dvs_ui.DvsSpanSessionPropertiesPageModel = DvsSpanSessionPropertiesPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionSelectDestinationsPageModel = (function () {
        function DvsSpanSessionSelectDestinationsPageModel() {
            this.ipAddressesListModel = new dvs_ui.DvsSpanSessionEditableListModel();
            this.portsListModel = new dvs_ui.DvsSpanSessionPortsListModel();
            this.uplinksListModel = new dvs_ui.DvsSpanSessionDestinationUplinksModel();
        }
        return DvsSpanSessionSelectDestinationsPageModel;
    }());
    dvs_ui.DvsSpanSessionSelectDestinationsPageModel = DvsSpanSessionSelectDestinationsPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionSelectSourcesPageModel = (function () {
        function DvsSpanSessionSelectSourcesPageModel() {
            this.portsListModel = new dvs_ui.DvsSpanSessionPortsListModel();
            this.vlanIdListModel = new dvs_ui.DvsSpanSessionEditableListModel();
        }
        return DvsSpanSessionSelectSourcesPageModel;
    }());
    dvs_ui.DvsSpanSessionSelectSourcesPageModel = DvsSpanSessionSelectSourcesPageModel;
})(dvs_ui || (dvs_ui = {}));







/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionDestinationUplinksService = (function () {
        function DvsSpanSessionDestinationUplinksService($q, i18nService, vuiConstants, dataService) {
            var _this = this;
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.getString = function (key) {
                return _this.i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionDestinationUplinksService.prototype.getDestinationUplinkNames = function (dvsUrn) {
            return this.dataService.getProperties(dvsUrn, [DvsSpanSessionDestinationUplinksService.DATA_PROPERTY])
                .then(function (response) {
                return response[DvsSpanSessionDestinationUplinksService.DATA_PROPERTY];
            });
        };
        DvsSpanSessionDestinationUplinksService.$inject = [
            "$q",
            "i18nService",
            "vuiConstants",
            "dataService"
        ];
        DvsSpanSessionDestinationUplinksService.DATA_PROPERTY = "dvswitchportmirroring:dvsuplinks";
        return DvsSpanSessionDestinationUplinksService;
    }());
    dvs_ui.DvsSpanSessionDestinationUplinksService = DvsSpanSessionDestinationUplinksService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionDestinationUplinksService", DvsSpanSessionDestinationUplinksService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortBrowserDialogService = (function () {
        function DvsSpanSessionPortBrowserDialogService($q, i18nService, clarityModalService, mutationService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
        }
        DvsSpanSessionPortBrowserDialogService.prototype.show = function (dvsUrn, portsToIgnore, okHandler) {
            var dialogData = new PortBrowserDialogData(dvsUrn, portsToIgnore);
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "PortBrowserDialog.title"),
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                dialogData: dialogData,
                contentTemplate: "dvs-ui/resources/dvs/portmirroring/common/components/dvsSpanSessionPortBrowserDialog.html",
                onSubmit: function () {
                    okHandler(dialogData.portIds);
                    return true;
                },
                onSelectionChange: function (portIds) {
                    dialogData.portIds = portIds;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsSpanSessionPortBrowserDialogService.$inject = [
            "$q",
            "i18nService",
            "clarityModalService",
            "mutationService"
        ];
        return DvsSpanSessionPortBrowserDialogService;
    }());
    dvs_ui.DvsSpanSessionPortBrowserDialogService = DvsSpanSessionPortBrowserDialogService;
    var PortBrowserDialogData = (function () {
        function PortBrowserDialogData(urn, portsToIgnore) {
            this.dvsUrn = urn;
            this.portsToIgnore = portsToIgnore;
            this.portIds = [];
        }
        return PortBrowserDialogData;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionPortBrowserDialogService", DvsSpanSessionPortBrowserDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortBrowserService = (function () {
        function DvsSpanSessionPortBrowserService($q, i18nService, vuiConstants, dataService) {
            var _this = this;
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.getString = function (key) {
                return _this.i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionPortBrowserService.prototype.createDatagridOptions = function (callback) {
            var gridOptions = {
                height: "300",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                data: [],
                resizable: true,
                actionBarOptions: { actions: [] },
                selectedPorts: {}
            };
            var onSelectionChange = this.getOnSelectionChangeCallback(callback, gridOptions);
            gridOptions.onSelectionChange = onSelectionChange;
            gridOptions.onMasterCheckboxClick = function (event) {
                var checked = event.currentTarget.checked;
                for (var _i = 0, _a = gridOptions.data; _i < _a.length; _i++) {
                    var port = _a[_i];
                    gridOptions.selectedPorts[port.portId] = checked;
                }
                onSelectionChange();
            };
            return gridOptions;
        };
        DvsSpanSessionPortBrowserService.prototype.getData = function (dvsUrn) {
            return this.dataService.getProperties(dvsUrn, [DvsSpanSessionPortBrowserService.DATA_PROPERTY])
                .then(function (response) {
                var rawData = response[DvsSpanSessionPortBrowserService.DATA_PROPERTY];
                return rawData ? rawData.ports : [];
            })
                .catch(function () {
                // return empty data
                return [];
            });
        };
        DvsSpanSessionPortBrowserService.prototype.getColumnDefinitions = function () {
            var columns = [];
            columns.push({
                width: "35px",
                headerTemplate: "<input type='checkbox' " +
                    "ng-click='datagridOptions.onMasterCheckboxClick($event)'/>",
                template: function (item) {
                    var model = "'datagridOptions.selectedPorts[\"" + item.portId + "\"]'";
                    return "<input type='checkbox' %model %change/>"
                        .replace("%model", "ng-model=" + model)
                        .replace("%change", "ng-change='datagridOptions.onSelectionChange()'");
                }
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.portId"),
                field: "portId",
                width: "90px",
                template: this.getGenericColumnRenderer("portId")
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.name"),
                field: "name",
                width: "150px",
                template: this.getGenericColumnRenderer("name")
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.connectedEntityName"),
                field: "connectedEntity",
                width: "150px",
                template: this.getConnectedEntityColumnRenderer()
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.proxyHostName"),
                field: "host",
                width: "150px",
                template: this.getHostColumnRenderer()
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.macAddress"),
                field: "mac",
                width: "150px",
                template: this.getGenericColumnRenderer("mac")
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.portgroupName"),
                field: "portgroup",
                width: "150px",
                template: this.getPortgroupColumnRenderer()
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.portState"),
                field: "state",
                width: "150px",
                template: this.getPortStateColumnRenderer()
            });
            columns.push({
                displayName: this.getString("PortBrowser.columnHeader.vlanIds"),
                field: "vlan",
                width: "150px",
                template: this.getGenericColumnRenderer("vlan")
            });
            return columns;
        };
        DvsSpanSessionPortBrowserService.prototype.getOnSelectionChangeCallback = function (callback, gridOptions) {
            return function () {
                var selectedPortIds = [];
                gridOptions.data.forEach(function (item) {
                    if (gridOptions.selectedPorts[item.portId]) {
                        selectedPortIds.push(item.portId);
                    }
                });
                callback(selectedPortIds);
            };
        };
        DvsSpanSessionPortBrowserService.prototype.getGenericColumnRenderer = function (property) {
            var _this = this;
            return function (data) {
                var label = data[property] || DvsSpanSessionPortBrowserService.NO_DATA;
                return _this.buildCellHtml(label);
            };
        };
        DvsSpanSessionPortBrowserService.prototype.getConnectedEntityColumnRenderer = function () {
            var _this = this;
            return function (data) {
                if (data.connectedEntityType === "vmVnic") {
                    return _this.buildCellHtml(data.connectedEntity, "vsphere-icon-vm");
                }
                else if (data.connectedEntityType === "hostVmkVnic") {
                    return _this.buildCellHtml(data.connectedEntity, "network-lib-ui-icon-virtualAdapter");
                }
                else {
                    return _this.buildCellHtml(data.connectedEntity);
                }
            };
        };
        DvsSpanSessionPortBrowserService.prototype.getPortStateColumnRenderer = function () {
            var _this = this;
            return function (data) {
                var label;
                var icon;
                switch (data.state) {
                    case "LINK_UP": {
                        label = _this.getString("PortState.linkUp");
                        icon = "network-lib-ui-icon-dvsPortConnectedLf";
                        break;
                    }
                    case "LINK_DOWN": {
                        label = _this.getString("PortState.linkDown");
                        icon = "network-lib-ui-icon-dvsPortNotconnectedLf";
                        break;
                    }
                    case "BLOCKED": {
                        label = _this.getString("PortState.blocked");
                        icon = "network-lib-ui-icon-dvsPortBlockedLf";
                        break;
                    }
                    default: {
                        label = DvsSpanSessionPortBrowserService.NO_DATA;
                        icon = "";
                    }
                }
                return _this.buildCellHtml(label, icon);
            };
        };
        DvsSpanSessionPortBrowserService.prototype.getHostColumnRenderer = function () {
            var _this = this;
            return function (data) {
                var icon = data.host ? "vsphere-icon-host" : "";
                return _this.buildCellHtml(data.host, icon);
            };
        };
        DvsSpanSessionPortBrowserService.prototype.getPortgroupColumnRenderer = function () {
            var _this = this;
            return function (data) {
                var icon = data.portgroup ? "vsphere-icon-virtual-port-group" : "";
                return _this.buildCellHtml(data.portgroup || DvsSpanSessionPortBrowserService.NO_DATA, icon);
            };
        };
        DvsSpanSessionPortBrowserService.prototype.buildCellHtml = function (text, icon) {
            if (icon === void 0) { icon = ""; }
            var template = "<div>%icon%text</div>";
            return template
                .replace("%icon", "<span class='" + icon + "'></span>")
                .replace("%text", "<span>" + text + "</span>");
        };
        DvsSpanSessionPortBrowserService.$inject = [
            "$q",
            "i18nService",
            "vuiConstants",
            "dataService"
        ];
        DvsSpanSessionPortBrowserService.DATA_PROPERTY = "dvswitchportmirroring:portBrowserData";
        DvsSpanSessionPortBrowserService.NO_DATA = "--";
        return DvsSpanSessionPortBrowserService;
    }());
    dvs_ui.DvsSpanSessionPortBrowserService = DvsSpanSessionPortBrowserService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionPortBrowserService", DvsSpanSessionPortBrowserService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPortListData = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.portlist.DvsSpanSessionPortListData;
    var DvsSpanSessionPortListSpec = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.portlist.DvsSpanSessionPortListSpec;
    var DvsSpanSessionPortsListService = (function () {
        function DvsSpanSessionPortsListService($q, i18nService, vuiConstants, dataService) {
            var _this = this;
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.getString = function (key) {
                return _this.i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionPortsListService.prototype.createDatagridOptions = function (actions, onChange, trafficDirectionEnabled) {
            return {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefinitions(trafficDirectionEnabled),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedItems: [],
                data: [],
                resizable: true,
                actionBarOptions: { actions: actions },
                onChange: onChange
            };
        };
        DvsSpanSessionPortsListService.prototype.getData = function (dvsUrn, portIds) {
            var spec = new DvsSpanSessionPortListSpec();
            spec.portIds = portIds;
            var params = {
                propertyParams: [{
                        propertyName: DvsSpanSessionPortsListService.DATA_PROPERTY,
                        parameterType: spec._type,
                        parameter: spec
                    }]
            };
            if (portIds && portIds.length > 0) {
                return this.dataService.getProperties(dvsUrn, [DvsSpanSessionPortsListService.DATA_PROPERTY], params).then(function (resp) {
                    var data = resp[DvsSpanSessionPortsListService.DATA_PROPERTY];
                    return data;
                });
            }
            else {
                var emptyData = new DvsSpanSessionPortListData();
                emptyData.items = [];
                return this.$q.when(emptyData);
            }
        };
        DvsSpanSessionPortsListService.prototype.getColumnDefinitions = function (trafficDirectionEnabled) {
            var columns = [];
            columns.push({
                displayName: this.getString("AddSpanSessionWizard.sourcesPage.PortList.port"),
                field: "portId",
                width: "90px",
                template: this.getGenericColumnRenderer("portId")
            });
            columns.push({
                displayName: this.getString("AddSpanSessionWizard.sourcesPage.PortList.host"),
                field: "host",
                width: "150px",
                template: this.getHostColumnRenderer()
            });
            columns.push({
                displayName: this.getString("AddSpanSessionWizard.sourcesPage.PortList.connectee"),
                field: "connectee",
                width: "150px",
                template: this.getConnectedEntityColumnRenderer()
            });
            if (trafficDirectionEnabled) {
                columns.push({
                    displayName: this.getString("AddSpanSessionWizard.sourcesPage.PortList.direction"),
                    field: "trafficDirection",
                    width: "180px",
                    template: this.getTrafficDirectionColumnRenderer()
                });
            }
            return columns;
        };
        DvsSpanSessionPortsListService.prototype.getGenericColumnRenderer = function (property) {
            var _this = this;
            return function (data) {
                return _this.buildCellHtml(data[property]);
            };
        };
        DvsSpanSessionPortsListService.prototype.getConnectedEntityColumnRenderer = function () {
            var _this = this;
            return function (data) {
                if (data.connecteeType === "vmVnic") {
                    return _this.buildCellHtml(data.connectee, "vsphere-icon-vm");
                }
                else if (data.connecteeType === "hostVmkVnic") {
                    return _this.buildCellHtml(data.connectee, "network-lib-ui-icon-virtualAdapter");
                }
                else {
                    return _this.buildCellHtml(data.connectee);
                }
            };
        };
        DvsSpanSessionPortsListService.prototype.getHostColumnRenderer = function () {
            var _this = this;
            return function (data) {
                var icon = data.host ? "vsphere-icon-host" : "";
                return _this.buildCellHtml(data.host, icon);
            };
        };
        DvsSpanSessionPortsListService.prototype.getTrafficDirectionColumnRenderer = function () {
            var _this = this;
            return function (data) {
                var label;
                var icon;
                switch (data.trafficDirection) {
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH: {
                        label = _this.getString("NetworkTrafficRuleDirection.ingressEgress");
                        icon = "network-lib-ui-icon-ingressEgressTraffic";
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS: {
                        label = _this.getString("NetworkTrafficRuleDirection.ingress");
                        icon = "network-lib-ui-icon-ingressTraffic";
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS: {
                        label = _this.getString("NetworkTrafficRuleDirection.egress");
                        icon = "network-lib-ui-icon-egressTraffic";
                        break;
                    }
                    default: {
                        label = "";
                        icon = "";
                    }
                }
                return _this.buildCellHtml(label, icon);
            };
        };
        DvsSpanSessionPortsListService.prototype.buildCellHtml = function (text, icon) {
            if (text === void 0) { text = dvs_ui.DvsSpanSessionPortBrowserService.NO_DATA; }
            if (icon === void 0) { icon = ""; }
            var template = "<div>%icon%text</div>";
            return template
                .replace("%icon", "<span class='" + icon + "'></span>")
                .replace("%text", "<span>" + text + "</span>");
        };
        DvsSpanSessionPortsListService.$inject = [
            "$q",
            "i18nService",
            "vuiConstants",
            "dataService"
        ];
        DvsSpanSessionPortsListService.DATA_PROPERTY = "dvswitchportmirroring:portListData";
        return DvsSpanSessionPortsListService;
    }());
    dvs_ui.DvsSpanSessionPortsListService = DvsSpanSessionPortsListService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionPortsListService", DvsSpanSessionPortsListService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionReadyToCompletePageService = (function () {
        function DvsSpanSessionReadyToCompletePageService(i18nService, vxPropertyViewService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.getString = function (key) {
                return _this.i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionReadyToCompletePageService.prototype.buildPropertyViewData = function (wizardModel) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            this.buildCommonPropertiesSection(builder, wizardModel);
            this.buildAdvancedPropertiesSection(builder, wizardModel);
            return builder.build();
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildCommonPropertiesSection = function (builder, wizardModel) {
            var category = builder.category("main");
            var commonSection = category.section("commonSection");
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.name"), wizardModel.propertiesPageModel.sessionName);
            var statusLabel = wizardModel.propertiesPageModel.enabled
                ? this.getString("AddSpanSessionWizard.readyToCompletePage.enabled")
                : this.getString("AddSpanSessionWizard.readyToCompletePage.disabled");
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.status"), statusLabel);
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.type"), this.getSessionTypeLocalized(wizardModel.sessionType));
            switch (wizardModel.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE:
                    this.buildL3SourceCommonPropertiesSection(commonSection, wizardModel);
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE:
                    this.buildRemoteSourceCommonPropertiesSection(commonSection, wizardModel);
                    break;
            }
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildL3SourceCommonPropertiesSection = function (commonSection, wizardModel) {
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.encapsulation.type"), this.getEncapsulationTypeLocalized(wizardModel.propertiesPageModel.encapsulationType));
            if (wizardModel.propertiesPageModel.encapsulationType
                === dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN2 ||
                wizardModel.propertiesPageModel.encapsulationType
                    === dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN3) {
                commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.encapsulation.sessionId"), wizardModel.propertiesPageModel.sessionId);
            }
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildRemoteSourceCommonPropertiesSection = function (commonSection, wizardModel) {
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.encapsulationVlanId"), wizardModel.propertiesPageModel.encapsulationVlanId);
            commonSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.preserveOriginalVlan"), this.getPreserveOriginalVlanLocalized(wizardModel.propertiesPageModel.preserveOriginalVlan));
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildAdvancedPropertiesSection = function (builder, wizardModel) {
            var category = builder.getCategory("main");
            var advancedSection = category.section("advancedSection")
                .title(this.getString("AddSpanSessionWizard.readyToCompletePage.advancedProperties"));
            if (wizardModel.sessionType !== dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE) {
                advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.normalTrafficAllowed"), this.getNormalTrafficAllowedLocalized(wizardModel.propertiesPageModel.normalTrafficAllowed));
            }
            if (wizardModel.propertiesPageModel.tcpIpStack &&
                wizardModel.propertiesPageModel.isTcpIpStackSupported
                && wizardModel.sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE) {
                advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.encapsulation.tcpipStack"), this.getTcpIpStackLocalized(wizardModel.propertiesPageModel.tcpIpStack));
            }
            if (wizardModel.propertiesPageModel.mirroredPacketLengthEnabled) {
                advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.mirroredPacketLength"), this.i18nService.getString("DvsUi", "AddSpanSessionWizard.readyToCompletePage.mirroredPacketLengthSummary", wizardModel.propertiesPageModel.mirroredPacketLength));
            }
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.samplingRate"), this.i18nService.getString("DvsUi", "AddSpanSessionWizard.readyToCompletePage.samplingRateSummary", wizardModel.propertiesPageModel.samplingRate));
            switch (wizardModel.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                    this.buildL3SourceAdvancedPropertiesSection(advancedSection, wizardModel);
                    break;
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                    this.buildRemoteSourceAdvancedPropertiesSection(advancedSection, wizardModel);
                    break;
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                    this.buildDvPortMirroradvancedPropertiesSection(advancedSection, wizardModel);
                    break;
                }
                case (dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST):
                    this.buildRemoteMirroringDestAdvancedPropertiesSection(advancedSection, wizardModel);
                    break;
            }
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.sessionDescription"), wizardModel.propertiesPageModel.description
                || this.getString("AddSpanSessionWizard.readyToCompletePage.noData"));
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildL3SourceAdvancedPropertiesSection = function (advancedSection, wizardModel) {
            var numberOfSourcePorts = (wizardModel.selectSourcesPageModel.portsListModel.ports
                && wizardModel.selectSourcesPageModel.portsListModel.ports.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numSourcePorts"), numberOfSourcePorts);
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.destinationIpAddresses"), wizardModel.selectDestinationsPageModel.ipAddressesListModel.values);
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildRemoteSourceAdvancedPropertiesSection = function (advancedSection, wizardModel) {
            var numberOfSourcePorts = (wizardModel.selectSourcesPageModel.portsListModel.ports
                && wizardModel.selectSourcesPageModel.portsListModel.ports.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numSourcePorts"), numberOfSourcePorts);
            var uplinkNamesArr = wizardModel.selectDestinationsPageModel.uplinksListModel.uplinks;
            var uplinkNames = uplinkNamesArr && uplinkNamesArr.length > 0
                ? uplinkNamesArr.join(", ") : "";
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.destinationUplinks"), uplinkNames);
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildDvPortMirroradvancedPropertiesSection = function (advancedSection, wizardModel) {
            var numberOfSourcePorts = (wizardModel.selectSourcesPageModel.portsListModel.ports
                && wizardModel.selectSourcesPageModel.portsListModel.ports.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numSourcePorts"), numberOfSourcePorts);
            var numberOfDestPorts = (wizardModel.selectDestinationsPageModel.portsListModel.ports
                && wizardModel.selectDestinationsPageModel.portsListModel.ports.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numDestinationPorts"), numberOfDestPorts);
        };
        DvsSpanSessionReadyToCompletePageService.prototype.buildRemoteMirroringDestAdvancedPropertiesSection = function (advancedSection, wizardModel) {
            // Number of source VLAN IDs
            var numberOfSourceVlanIds = (wizardModel.selectSourcesPageModel.vlanIdListModel.values
                && wizardModel.selectSourcesPageModel.vlanIdListModel.values.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numVlanIds"), numberOfSourceVlanIds);
            // Number of destination ports
            var numberOfDestPorts = (wizardModel.selectDestinationsPageModel.portsListModel.ports
                && wizardModel.selectDestinationsPageModel.portsListModel.ports.length) || 0;
            advancedSection.property(this.getString("AddSpanSessionWizard.readyToCompletePage.numDestinationPorts"), numberOfDestPorts);
        };
        DvsSpanSessionReadyToCompletePageService.prototype.getSessionTypeLocalized = function (type) {
            switch (type) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                    return this.getString("span.session.type.encapsulatedRemoteMirrorSource");
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                    return this.getString("span.session.type.remoteMirrorSource");
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST: {
                    return this.getString("dvsPortMirror.sessionType.remoteMirrorDest");
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                    return this.getString("span.session.type.dvPortMirror");
                }
                default: {
                    return this.getString("AddSpanSessionWizard.readyToCompletePage.noData");
                }
            }
        };
        DvsSpanSessionReadyToCompletePageService.prototype.getEncapsulationTypeLocalized = function (type) {
            switch (type) {
                case dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE: {
                    return this.getString("SpanSessionEncapsulation.type.gre");
                }
                case dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN2: {
                    return this.getString("SpanSessionEncapsulation.type.erspan2");
                }
                case dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.ERSPAN3: {
                    return this.getString("SpanSessionEncapsulation.type.erspan3");
                }
                default: {
                    return this.getString("AddSpanSessionWizard.readyToCompletePage.noData");
                }
            }
        };
        DvsSpanSessionReadyToCompletePageService.prototype.getTcpIpStackLocalized = function (type) {
            switch (type) {
                case dvs_ui.DvsSpanSessionConstants.TCP_IP_STACK.DEFAULT_STACK: {
                    return this.getString("spanSession.tcpip.stack.default");
                }
                case dvs_ui.DvsSpanSessionConstants.TCP_IP_STACK.MIRROR_STACK: {
                    return this.getString("spanSession.tcpip.stack.mirror");
                }
                default: {
                    return this.getString("spanSession.tcpip.stack.default");
                }
            }
        };
        DvsSpanSessionReadyToCompletePageService.prototype.getPreserveOriginalVlanLocalized = function (preserveOriginalVlan) {
            return preserveOriginalVlan ?
                this.getString("AddSpanSessionWizard.readyToCompletePage.yes") :
                this.getString("AddSpanSessionWizard.readyToCompletePage.no");
        };
        DvsSpanSessionReadyToCompletePageService.prototype.getNormalTrafficAllowedLocalized = function (NormalTrafficAllowed) {
            return NormalTrafficAllowed ?
                this.getString("AddSpanSessionWizard.readyToCompletePage.on") :
                this.getString("AddSpanSessionWizard.readyToCompletePage.off");
        };
        DvsSpanSessionReadyToCompletePageService.$inject = [
            "i18nService",
            "vxPropertyViewService"
        ];
        return DvsSpanSessionReadyToCompletePageService;
    }());
    dvs_ui.DvsSpanSessionReadyToCompletePageService = DvsSpanSessionReadyToCompletePageService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionReadyToCompletePageService", DvsSpanSessionReadyToCompletePageService);
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionEditableListValidator = (function () {
        function DvsSpanSessionEditableListValidator(i18nService, ipParserService, networkUtil) {
            this.i18nService = i18nService;
            this.ipParserService = ipParserService;
            this.networkUtil = networkUtil;
        }
        DvsSpanSessionEditableListValidator.prototype.getIpAddressError = function (address) {
            var trimmedAddress = address.trim();
            var isEmpty = !trimmedAddress.length;
            var isInvalid = !this.ipParserService.isIpv4AddressValid(trimmedAddress)
                && !this.ipParserService.isIpv6AddressValid(trimmedAddress);
            if (isEmpty || isInvalid) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.ipAddress");
            }
            return null;
        };
        DvsSpanSessionEditableListValidator.prototype.getVlanIdError = function (vlanId) {
            var isValid = this.networkUtil.isPositiveInteger(vlanId, dvs_ui.DvsSpanSessionConstants.VLAN_ID_MIN, dvs_ui.DvsSpanSessionConstants.VLAN_ID_MAX);
            return isValid ? null : this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sourceVlansPage.invalidVlanIdError", dvs_ui.DvsSpanSessionConstants.VLAN_ID_MIN, dvs_ui.DvsSpanSessionConstants.VLAN_ID_MAX);
        };
        DvsSpanSessionEditableListValidator.$inject = [
            "i18nService",
            "ipParserService",
            "networkUtil"
        ];
        return DvsSpanSessionEditableListValidator;
    }());
    dvs_ui.DvsSpanSessionEditableListValidator = DvsSpanSessionEditableListValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionEditableListValidator", DvsSpanSessionEditableListValidator);
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionPageValidator = (function () {
        function DvsSpanSessionPageValidator(model, vxValidator) {
            this._model = model;
            this.vxValidator = vxValidator;
        }
        Object.defineProperty(DvsSpanSessionPageValidator.prototype, "model", {
            get: function () {
                return this._model;
            },
            enumerable: true,
            configurable: true
        });
        DvsSpanSessionPageValidator.prototype.validate = function () {
            if (this.vxValidator && this.vxValidator.validate) {
                var errors = this.vxValidator.validate();
                if (this._model) {
                    this._model.errors = errors;
                }
                return errors && errors.length === 0;
            }
            return true;
        };
        return DvsSpanSessionPageValidator;
    }());
    dvs_ui.DvsSpanSessionPageValidator = DvsSpanSessionPageValidator;
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionNameSpec = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.wizard.DvsSpanSessionNameSpec;
    var IntegerInterval = (function () {
        function IntegerInterval(beginning, end) {
            this._beginning = Math.floor(beginning);
            this._end = Math.floor(end);
        }
        Object.defineProperty(IntegerInterval.prototype, "beginning", {
            get: function () {
                return this._beginning;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IntegerInterval.prototype, "end", {
            get: function () {
                return this._end;
            },
            enumerable: true,
            configurable: true
        });
        return IntegerInterval;
    }());
    var DvsSpanSessionPropertiesValidator = (function () {
        function DvsSpanSessionPropertiesValidator(i18nService, mutationService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
        }
        DvsSpanSessionPropertiesValidator.prototype.getNameError = function (name) {
            var trimmedName = name ? name.trim() : "";
            var escapedName = trimmedName.replace(/%/g, "%25")
                .replace(/\//g, "%2f").replace(/\\/g, "%5c");
            if (escapedName.length === 0) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.blankName");
            }
            else if (escapedName.length > DvsSpanSessionPropertiesValidator.NAME_MAX_LENGTH) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.tooLongName");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.getNameServerError = function (urn, name) {
            var _this = this;
            var spec = new DvsSpanSessionNameSpec();
            spec.name = name;
            return this.mutationService.validate(urn, spec._type, spec)
                .then(function (validationResult) {
                if (validationResult.result) {
                    return validationResult.result;
                }
                return null;
            }, function () {
                return _this.i18nService.getString("DvsUi", "networkConnectionError");
            });
        };
        DvsSpanSessionPropertiesValidator.prototype.getSessionIdError = function (sessionId) {
            if (!this.isInteger(sessionId) || !this.isWithinInterval(sessionId, DvsSpanSessionPropertiesValidator.SESSION_ID_INTERVAL)) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.sessionId");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.getPacketLengthError = function (packetLength) {
            if (!this.isInteger(packetLength) || !this.isWithinInterval(packetLength, DvsSpanSessionPropertiesValidator.PACKET_LENGTH_INTERVAL)) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.packetLength");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.getSamplingRateError = function (samplingRate) {
            if (!this.isInteger(samplingRate) || !this.isWithinInterval(samplingRate, DvsSpanSessionPropertiesValidator.SAMPLING_RATE_INTERVAL)) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.samplingRate");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.getEncapsulationVlanIdError = function (encapsulationVlanId) {
            if (!this.isInteger(encapsulationVlanId) || !this.isWithinInterval(encapsulationVlanId, DvsSpanSessionPropertiesValidator.ENCAPSULATION_VLAN_INTERVAL)) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.encapsulationVlan");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.getDescriptionError = function (description) {
            if (description &&
                description.length > DvsSpanSessionPropertiesValidator.DESCRIPTION_MAX_LENGHT) {
                return this.i18nService.getString("DvsUi", "SpanSession.error.description");
            }
            return null;
        };
        DvsSpanSessionPropertiesValidator.prototype.isWithinInterval = function (value, interval) {
            return value >= interval.beginning && value <= interval.end;
        };
        DvsSpanSessionPropertiesValidator.prototype.isInteger = function (value) {
            return value % 1 === 0;
        };
        DvsSpanSessionPropertiesValidator.$inject = [
            "i18nService",
            "mutationService"
        ];
        DvsSpanSessionPropertiesValidator.NAME_MAX_LENGTH = 80;
        DvsSpanSessionPropertiesValidator.SESSION_ID_INTERVAL = new IntegerInterval(0, 1023);
        DvsSpanSessionPropertiesValidator.PACKET_LENGTH_INTERVAL = new IntegerInterval(60, 9000);
        DvsSpanSessionPropertiesValidator.SAMPLING_RATE_INTERVAL = new IntegerInterval(1, 65535);
        DvsSpanSessionPropertiesValidator.ENCAPSULATION_VLAN_INTERVAL = new IntegerInterval(1, 4094);
        DvsSpanSessionPropertiesValidator.DESCRIPTION_MAX_LENGHT = 255;
        return DvsSpanSessionPropertiesValidator;
    }());
    dvs_ui.DvsSpanSessionPropertiesValidator = DvsSpanSessionPropertiesValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsSpanSessionPropertiesValidator", DvsSpanSessionPropertiesValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionSelectTypePageComponent = (function () {
        function DvsAddSpanSessionSelectTypePageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsAddSpanSessionSelectTypePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/create/components/" +
                "dvsAddSpanSessionSelectTypePageComponentTemplate.html";
        }
        return DvsAddSpanSessionSelectTypePageComponent;
    }());
    dvs_ui.DvsAddSpanSessionSelectTypePageComponent = DvsAddSpanSessionSelectTypePageComponent;
    var DvsAddSpanSessionSelectTypePageComponentController = (function () {
        function DvsAddSpanSessionSelectTypePageComponentController(i18nService, $scope) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            $scope.i18n = this.i18nService.getString;
        }
        DvsAddSpanSessionSelectTypePageComponentController.prototype.$onInit = function () {
            this.initSessionNameByType();
            this.initDescriptions();
            this.buildSignpostItems();
        };
        DvsAddSpanSessionSelectTypePageComponentController.prototype.initDescriptions = function () {
            this.descriptionsByType = {};
            this.descriptionsByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR] =
                this.i18nService.getString("DvsUi", "span.session.type.dvPortMirrorDescription");
            this.descriptionsByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE] =
                this.i18nService.getString("DvsUi", "span.session.type.remoteMirrorSourceDescription");
            this.descriptionsByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE] =
                this.i18nService.getString("DvsUi", "span.session.type.encapsulatedRemoteMirrorSourceDescription");
            this.descriptionsByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST] =
                this.i18nService.getString("DvsUi", "span.session.type.remoteMirrorDestDescription");
        };
        DvsAddSpanSessionSelectTypePageComponentController.prototype.initSessionNameByType = function () {
            this.sessionNameByType = {};
            this.sessionNameByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR] =
                this.i18nService.getString("DvsUi", "span.session.type.dvPortMirror");
            this.sessionNameByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE] =
                this.i18nService.getString("DvsUi", "span.session.type.remoteMirrorSource");
            this.sessionNameByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE] =
                this.i18nService.getString("DvsUi", "span.session.type.encapsulatedRemoteMirrorSource");
            this.sessionNameByType[dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST] =
                this.i18nService.getString("DvsUi", "span.session.type.remoteMirrorDest");
        };
        DvsAddSpanSessionSelectTypePageComponentController.prototype.buildSignpostItems = function () {
            var _this = this;
            var signpostMessage = "";
            _.forEach(this.wizardModel.supportedSessionTypes, function (sessionType) {
                var title = "<b>%title%</b><br/>"
                    .replace("%title%", _this.getSessionName(sessionType));
                var description = _this.getSessionDescription(sessionType);
                var template = "<div class='horizontal-flex-container'>" +
                    "<span class='new-span-session-description-bullet'></span>" +
                    "<span class='new-span-session-description-item'>%description%</span><br/></div>";
                var content = title + template.replace("%description%", description);
                var sectionTemplate = "<div data-test-id='span-session-section-%sessionType%'>%content%</div>";
                signpostMessage += sectionTemplate
                    .replace("%sessionType%", sessionType)
                    .replace("%content%", content);
            });
            this.signPostConfig = {
                message: "<div class='new-span-session-signpost-content'>%content%</div>"
                    .replace("%content%", signpostMessage)
            };
        };
        DvsAddSpanSessionSelectTypePageComponentController.prototype.getSessionDescription = function (sessionType) {
            return this.descriptionsByType[sessionType];
        };
        DvsAddSpanSessionSelectTypePageComponentController.prototype.getSessionName = function (sessionType) {
            return this.sessionNameByType[sessionType];
        };
        DvsAddSpanSessionSelectTypePageComponentController.$inject = ["i18nService", "$scope"];
        return DvsAddSpanSessionSelectTypePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsAddSpanSessionSelectTypePage", new DvsAddSpanSessionSelectTypePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSpanSessionReadyToCompletePageComponent = (function () {
        function DvsSpanSessionReadyToCompletePageComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = DvsSpanSessionReadyToCompletePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/create/components/" +
                "dvsSpanSessionReadyToCompletePageComponentTemplate.html";
        }
        return DvsSpanSessionReadyToCompletePageComponent;
    }());
    dvs_ui.DvsSpanSessionReadyToCompletePageComponent = DvsSpanSessionReadyToCompletePageComponent;
    var DvsSpanSessionReadyToCompletePageComponentController = (function () {
        function DvsSpanSessionReadyToCompletePageComponentController(i18nService, propertyViewService) {
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
            this.getString = function (key) {
                return i18nService.getString("DvsUi", key);
            };
        }
        DvsSpanSessionReadyToCompletePageComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.propertyViewService.buildPropertyViewData(this.model);
        };
        DvsSpanSessionReadyToCompletePageComponentController.$inject = [
            "i18nService",
            "dvsSpanSessionReadyToCompletePageService"
        ];
        return DvsSpanSessionReadyToCompletePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSpanSessionReadyToCompletePage", new DvsSpanSessionReadyToCompletePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Manages the page states of the DVS Add and Manage Hosts wizard.
 */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionWizardFlowManager = (function () {
        function DvsAddSpanSessionWizardFlowManager(pageStateManagementService, vuiConstants) {
            this.pageStateManagementService = pageStateManagementService;
            this.vuiConstants = vuiConstants;
        }
        DvsAddSpanSessionWizardFlowManager.prototype.init = function (wizardScope) {
            var _this = this;
            this.pages = wizardScope.wizardConfig.pages;
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            wizardScope.$watchGroup([
                "model.sessionType"], function (newValues) {
                _this.updatePagesVisibility.apply(_this, newValues);
            });
        };
        DvsAddSpanSessionWizardFlowManager.prototype.updatePagesVisibility = function (sessionType) {
            var isSourcePortsPageVisible = sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE
                || sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE
                || sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR;
            this.togglePageVisibility(dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_PORTS, isSourcePortsPageVisible);
            var isSourceVlansPageVisible = sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST;
            this.togglePageVisibility(dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS, isSourceVlansPageVisible);
            var isDestAddressesPageVisible = sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE;
            this.togglePageVisibility(dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES, isDestAddressesPageVisible);
            var isDestPortsPageVisible = sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR
                || sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST;
            this.togglePageVisibility(dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_PORTS, isDestPortsPageVisible);
            var isDestUplinksPageVisible = sessionType === dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE;
            this.togglePageVisibility(dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_UPLINKS, isDestUplinksPageVisible);
        };
        DvsAddSpanSessionWizardFlowManager.prototype.togglePageVisibility = function (pageId, isVisible) {
            var page = _.findWhere(this.pages, { id: pageId });
            if (isVisible) {
                // change the state to DISABLED only if the page is currently invisible.
                if (page.state === this.vuiConstants.wizard.pageState.SKIPPED) {
                    page.state = this.vuiConstants.wizard.pageState.DISABLED;
                }
            }
            else {
                page.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvsAddSpanSessionWizardFlowManager.$inject = [
            "pageStateManagementService",
            "vuiConstants"];
        return DvsAddSpanSessionWizardFlowManager;
    }());
    dvs_ui.DvsAddSpanSessionWizardFlowManager = DvsAddSpanSessionWizardFlowManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddSpanSessionWizardFlowManager", DvsAddSpanSessionWizardFlowManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionWizardPages = (function () {
        function DvsAddSpanSessionWizardPages(i18nService, simpleValidationCommit, propertiesValidator) {
            this.i18nService = i18nService;
            this.simpleValidationCommit = simpleValidationCommit;
            this.propertiesValidator = propertiesValidator;
        }
        /**
         * Creates an array of page definitions for the Add Span Session wizard.
         */
        DvsAddSpanSessionWizardPages.prototype.createPages = function (wizardScope) {
            var pages = [];
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SESSION_TYPE,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sessionType.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sessionType.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectTypePage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: ["model.sessionType"]
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.EDIT_PROPERIES,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.propertiesPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.propertiesPage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionEditPropertiesPage.html",
                onCommit: this.simpleValidationCommit(this.buildPropertiesPageCommitCallback(wizardScope), wizardScope.wizardConfig),
                validationParams: [
                    "model.propertiesPageModel.sessionName",
                    "model.propertiesPageModel.sessionName",
                    "model.propertiesPageModel.enabled",
                    "model.propertiesPageModel.mirroredPacketLength",
                    "model.propertiesPageModel.mirroredPacketLengthEnabled",
                    "model.propertiesPageModel.samplingRate",
                    "model.propertiesPageModel.description",
                    "model.propertiesPageModel.erspanSupported",
                    "model.propertiesPageModel.encapsulationType",
                    "model.propertiesPageModel.sessionId",
                    "model.propertiesPageModel.preserveOriginalVlan",
                    "model.propertiesPageModel.encapsulationVlanId",
                    "model.propertiesPageModel.normalTrafficAllowed"
                ]
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_PORTS,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sourcesPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sourcesPage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectSourcePortsPage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: []
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sourcesPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.sourceVlansPage.descriptionLabel"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectSourceVlansPage.html",
                onCommit: this.simpleValidationCommit(this.buildSourceVlansPageCommitCallback(wizardScope), wizardScope.wizardConfig),
                validationParams: ["model.selectSourcesPageModel.vlanIdListModel.values"]
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectDestinationAddressesPage.html",
                onCommit: this.simpleValidationCommit(this.buildDestinationsPageCommitCallback(wizardScope), wizardScope.wizardConfig),
                validationParams: ["model.selectDestinationsPageModel.ipAddressesListModel.values"]
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_PORTS,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectDestinationPortsPage.html",
                onCommit: this.simpleValidationCommit(this.buildDestinationsPageCommitCallback(wizardScope), wizardScope.wizardConfig),
                validationParams: []
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_UPLINKS,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.destinationsPage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionSelectDestUplinkPage.html",
                onCommit: this.simpleValidationCommit(this.buildDestinationsPageCommitCallback(wizardScope), wizardScope.wizardConfig),
                validationParams: []
            });
            pages.push({
                id: dvs_ui.DvsSpanSessionConstants.PAGE_ID.READY_TO_COMPLETE,
                title: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.readyToCompletePage.title"),
                description: this.i18nService.getString("DvsUi", "AddSpanSessionWizard.readyToCompletePage.description"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/create/views/dvsAddSpanSessionReadyToCompletePage.html",
                onCommit: this.simpleValidationCommit(function () { return []; }, wizardScope.wizardConfig),
                validationParams: []
            });
            return pages;
        };
        DvsAddSpanSessionWizardPages.prototype.buildPropertiesPageCommitCallback = function (wizardScope) {
            var _this = this;
            return function () {
                wizardScope.model.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.EDIT_PROPERIES].validate();
                var pageModel = wizardScope.model.propertiesPageModel;
                var errors = pageModel.errors
                    ? pageModel.errors.slice()
                    : [];
                var descriptionError = _this.propertiesValidator.getDescriptionError(wizardScope.model.propertiesPageModel.description);
                if (descriptionError) {
                    errors.push(descriptionError);
                }
                if (errors.length > 0) {
                    return errors;
                }
                wizardScope.busy = true;
                return _this.propertiesValidator.getNameServerError(wizardScope.model.dvsUrn, wizardScope.model.propertiesPageModel.sessionName)
                    .then(function (error) {
                    wizardScope.busy = false;
                    return error ? [error] : [];
                });
            };
        };
        DvsAddSpanSessionWizardPages.prototype.buildDestinationsPageCommitCallback = function (wizardScope) {
            var _this = this;
            return function () {
                var pageModel = wizardScope.model.selectDestinationsPageModel;
                if (wizardScope.model.sessionType ===
                    dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE) {
                    wizardScope.model.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES].validate();
                    return pageModel.ipAddressesListModel.errors
                        ? pageModel.ipAddressesListModel.errors.slice()
                        : [];
                }
                else if (wizardScope.model.sessionType ===
                    dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR) {
                    var sourcePorts_1 = wizardScope.model.selectSourcesPageModel.portsListModel.ports;
                    var duplicatePorts = pageModel.portsListModel.ports.filter(function (data) {
                        return sourcePorts_1.some(function (sourcePort) {
                            return sourcePort.id === data.id;
                        });
                    }).map(function (data) {
                        return data.id;
                    }) || [];
                    if (!duplicatePorts.length) {
                        return [];
                    }
                    else if (duplicatePorts.length === 1) {
                        return [
                            _this.i18nService.getString("DvsUi", "SpanSession.error.alreadyUsedSourcePort", duplicatePorts[0])
                        ];
                    }
                    else {
                        return [
                            _this.i18nService.getString("DvsUi", "SpanSession.error.alreadyUsedSourcePorts", duplicatePorts.join(", "))
                        ];
                    }
                }
                return [];
            };
        };
        DvsAddSpanSessionWizardPages.prototype.buildSourceVlansPageCommitCallback = function (wizardScope) {
            return function () {
                var pageModel = wizardScope.model.selectSourcesPageModel;
                wizardScope.model.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS].validate();
                return pageModel.vlanIdListModel.errors
                    ? pageModel.vlanIdListModel.errors.slice()
                    : [];
            };
        };
        DvsAddSpanSessionWizardPages.$inject = [
            "i18nService",
            "simpleValidationCommit",
            "dvsSpanSessionPropertiesValidator"
        ];
        return DvsAddSpanSessionWizardPages;
    }());
    dvs_ui.DvsAddSpanSessionWizardPages = DvsAddSpanSessionWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddSpanSessionWizardPages", DvsAddSpanSessionWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionWizardService = (function () {
        function DvsAddSpanSessionWizardService($rootScope, i18nService, vxValidatorFactory, vuiWizardService, wizardValidationService, pageStateManagementService, mutationService, dataService, wizardPages, specFactory, flowManager) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.vuiWizardService = vuiWizardService;
            this.wizardValidationService = wizardValidationService;
            this.pageStateManagementService = pageStateManagementService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.wizardPages = wizardPages;
            this.specFactory = specFactory;
            this.flowManager = flowManager;
        }
        /**
         * Shows the Add Port Mirroring Session wizard.
         */
        DvsAddSpanSessionWizardService.prototype.show = function (dvsUrn) {
            var wizardScope = this.$rootScope.$new();
            wizardScope.busy = false;
            wizardScope.model = new dvs_ui.DvsAddSpanSessionWizardModel();
            wizardScope.model.dvsUrn = dvsUrn;
            wizardScope.wizardConfig = this.createWizardConfig(wizardScope.model);
            wizardScope.wizardConfig.pages = this.wizardPages.createPages(wizardScope);
            wizardScope.wizardConfig.loading = true;
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.flowManager.init(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
            this.requestData(wizardScope);
        };
        DvsAddSpanSessionWizardService.prototype.requestData = function (wizardScope) {
            var _this = this;
            this.dataService.getProperties(wizardScope.model.dvsUrn, [DvsAddSpanSessionWizardService.DATA_PROPERTY])
                .then(function (response) {
                var wizardData = response[DvsAddSpanSessionWizardService.DATA_PROPERTY];
                if (wizardData) {
                    _this.updateWizardModel(wizardScope, wizardData);
                    _this.updatePageModels(wizardScope, wizardData);
                    _this.initPageValidators(wizardScope.model);
                    wizardScope.wizardConfig.title = _this.i18nService
                        .getString("DvsUi", "AddSpanSessionWizard.titleFormat", wizardData.dvsName);
                    wizardScope.wizardConfig.loading = false;
                }
            });
        };
        DvsAddSpanSessionWizardService.prototype.createWizardConfig = function (wizardModel) {
            var _this = this;
            var wizardConfig = new dvs_ui.WizardConfig();
            wizardConfig.title =
                this.i18nService.getString("DvsUi", "AddSpanSessionWizard.initialTitle");
            wizardConfig.loadingMessage =
                this.i18nService.getString("CommonUi", "wizard.loading");
            wizardConfig.cssClass = "add-span-session";
            wizardConfig.onFinish = function () {
                var addSpanSessionSpec = _this.specFactory.buildSpec(wizardModel);
                _this.mutationService.apply(wizardModel.dvsUrn, addSpanSessionSpec._type, addSpanSessionSpec);
                return true;
            };
            return wizardConfig;
        };
        DvsAddSpanSessionWizardService.prototype.updateWizardModel = function (wizardScope, wizardData) {
            wizardScope.model.sessionType =
                dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR;
            // Select session page
            wizardScope.model.supportedSessionTypes = [];
            if (wizardData.dvPortMirrorSupported) {
                wizardScope.model.supportedSessionTypes.push(dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR);
            }
            if (wizardData.remoteSourceSupported) {
                wizardScope.model.supportedSessionTypes.push(dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE);
            }
            if (wizardData.remoteDestSupported) {
                wizardScope.model.supportedSessionTypes.push(dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST);
            }
            wizardScope.model.supportedSessionTypes.push(dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE);
        };
        DvsAddSpanSessionWizardService.prototype.updatePageModels = function (wizardScope, wizardData) {
            // Set session name for the properties page model
            wizardScope.model.propertiesPageModel.sessionName =
                wizardScope.model.retrievedSessionName = wizardData.sessionName;
            wizardScope.model.propertiesPageModel.erspanSupported =
                wizardData.erspanSupported;
            wizardScope.model.propertiesPageModel.isTcpIpStackSupported =
                wizardData.mirrorNetstackSupported;
        };
        DvsAddSpanSessionWizardService.prototype.initPageValidators = function (wizardModel) {
            wizardModel.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.EDIT_PROPERIES] =
                new dvs_ui.DvsSpanSessionPageValidator(wizardModel.propertiesPageModel, this.vxValidatorFactory.create());
            wizardModel.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES] =
                new dvs_ui.DvsSpanSessionPageValidator(wizardModel.selectDestinationsPageModel.ipAddressesListModel, this.vxValidatorFactory.create());
            wizardModel.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS] =
                new dvs_ui.DvsSpanSessionPageValidator(wizardModel.selectSourcesPageModel.vlanIdListModel, this.vxValidatorFactory.create());
        };
        DvsAddSpanSessionWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vxValidatorFactory",
            "vuiWizardService",
            "wizardValidationService",
            "pageStateManagementService",
            "mutationService",
            "dataService",
            "dvsAddSpanSessionWizardPages",
            "dvsAddSpanSessionWizardSpecFactory",
            "dvsAddSpanSessionWizardFlowManager"
        ];
        DvsAddSpanSessionWizardService.DATA_PROPERTY = "dvswitchportmirroring:addSpanSessionWizardData";
        return DvsAddSpanSessionWizardService;
    }());
    dvs_ui.DvsAddSpanSessionWizardService = DvsAddSpanSessionWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddSpanSessionWizardService", DvsAddSpanSessionWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionSpec = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.wizard.DvsAddSpanSessionSpec;
    /**
     * Provides methods for creating the mutation spec sent to the backend
     * services after the completion of the DVS Add Port Mirroring Session wizard.
     */
    var DvsAddSpanSessionWizardSpecFactory = (function () {
        function DvsAddSpanSessionWizardSpecFactory() {
        }
        /**
         * Builds the spec the span session creation.
         *
         * @param model DvsAddSpanSessionWizardModel
         */
        DvsAddSpanSessionWizardSpecFactory.prototype.buildSpec = function (model) {
            var spec = new DvsAddSpanSessionSpec();
            spec.sessionType = model.sessionType;
            spec.sessionName = model.propertiesPageModel.sessionName;
            spec.enabled = model.propertiesPageModel.enabled;
            spec.mirroredPacketLength = model.propertiesPageModel.mirroredPacketLengthEnabled
                ? model.propertiesPageModel.mirroredPacketLength : -1;
            spec.samplingRate = model.propertiesPageModel.samplingRate;
            spec.description = model.propertiesPageModel.description;
            switch (model.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE:
                    this.buildEncapsulatedSessionSpec(spec, model);
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE:
                    this.buildRemoteSourceSessionSpec(spec, model);
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR:
                    this.buildDvPortSessionSpec(spec, model);
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST:
                    this.buildRemoteDestSessionSpec(spec, model);
                    break;
            }
            return spec;
        };
        DvsAddSpanSessionWizardSpecFactory.prototype.buildEncapsulatedSessionSpec = function (spec, model) {
            spec.encapsulationType = model.propertiesPageModel.encapsulationType;
            if (model.propertiesPageModel.encapsulationType !==
                dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE) {
                spec.sessionId = model.propertiesPageModel.sessionId;
            }
            if (model.propertiesPageModel.isTcpIpStackSupported) {
                spec.tcpIpStack = model.propertiesPageModel.tcpIpStack;
            }
            this.buildSourcePortsSpec(spec, model);
            if (model.selectDestinationsPageModel.ipAddressesListModel.values) {
                spec.destinationIps =
                    model.selectDestinationsPageModel.ipAddressesListModel.values
                        .filter(function (ip) {
                        return ip;
                    });
            }
        };
        DvsAddSpanSessionWizardSpecFactory.prototype.buildRemoteSourceSessionSpec = function (spec, model) {
            spec.encapsulationVlanId = model.propertiesPageModel.encapsulationVlanId;
            spec.preserveOriginalVlan = model.propertiesPageModel.preserveOriginalVlan;
            spec.normalTrafficAllowed = model.propertiesPageModel.normalTrafficAllowed;
            this.buildSourcePortsSpec(spec, model);
            spec.destinationUplinks = model.selectDestinationsPageModel
                .uplinksListModel.uplinks;
        };
        DvsAddSpanSessionWizardSpecFactory.prototype.buildSourcePortsSpec = function (spec, model) {
            if (model.selectSourcesPageModel.portsListModel.ports) {
                spec.sourcePortsEgress = [];
                spec.sourcePortsIngress = [];
                model.selectSourcesPageModel.portsListModel.ports
                    .forEach(function (port) {
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        spec.sourcePortsEgress.push(port.id);
                    }
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        spec.sourcePortsIngress.push(port.id);
                    }
                });
            }
        };
        DvsAddSpanSessionWizardSpecFactory.prototype.buildDvPortSessionSpec = function (spec, model) {
            spec.normalTrafficAllowed = model.propertiesPageModel.normalTrafficAllowed;
            if (model.selectSourcesPageModel.portsListModel.ports) {
                spec.sourcePortsEgress = [];
                spec.sourcePortsIngress = [];
                model.selectSourcesPageModel.portsListModel.ports
                    .forEach(function (port) {
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        spec.sourcePortsEgress.push(port.id);
                    }
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        spec.sourcePortsIngress.push(port.id);
                    }
                });
            }
            spec.destinationPorts = _.map(model.selectDestinationsPageModel.portsListModel.ports, function (data) {
                return data.id;
            });
        };
        DvsAddSpanSessionWizardSpecFactory.prototype.buildRemoteDestSessionSpec = function (spec, model) {
            spec.normalTrafficAllowed = model.propertiesPageModel.normalTrafficAllowed;
            spec.sourceVlanIds = _.map(model.selectSourcesPageModel.vlanIdListModel.values, function (vlanId) {
                return +vlanId; //convert to number
            });
            spec.destinationPorts = _.map(model.selectDestinationsPageModel.portsListModel.ports, function (port) {
                return port.id;
            });
        };
        return DvsAddSpanSessionWizardSpecFactory;
    }());
    dvs_ui.DvsAddSpanSessionWizardSpecFactory = DvsAddSpanSessionWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsAddSpanSessionWizardSpecFactory", DvsAddSpanSessionWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsAddSpanSessionWizardModel = (function () {
        function DvsAddSpanSessionWizardModel() {
            this.pageValidators = {};
            this.propertiesPageModel = new dvs_ui.DvsSpanSessionPropertiesPageModel();
            this.selectSourcesPageModel = new dvs_ui.DvsSpanSessionSelectSourcesPageModel();
            this.selectDestinationsPageModel = new dvs_ui.DvsSpanSessionSelectDestinationsPageModel();
        }
        Object.defineProperty(DvsAddSpanSessionWizardModel.prototype, "sessionType", {
            get: function () {
                return this._sessionType;
            },
            /**
             * Resets the page models upon change.
             *
             * @param value The new session type
             */
            set: function (value) {
                if (value === this._sessionType) {
                    return;
                }
                this._sessionType = value;
                // properties page
                this.propertiesPageModel.sessionName = this.retrievedSessionName;
                this.propertiesPageModel.enabled = false;
                this.propertiesPageModel.mirroredPacketLengthEnabled = false;
                this.propertiesPageModel.mirroredPacketLength = 60;
                this.propertiesPageModel.samplingRate = 1;
                this.propertiesPageModel.description = "";
                switch (this.sessionType) {
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                        this.propertiesPageModel.encapsulationType =
                            dvs_ui.DvsSpanSessionConstants.ENCAPSULATION_TYPE.GRE;
                        this.propertiesPageModel.sessionId = 0;
                        this.propertiesPageModel.tcpIpStack =
                            dvs_ui.DvsSpanSessionConstants.TCP_IP_STACK.DEFAULT_STACK;
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                        this.propertiesPageModel.preserveOriginalVlan = true;
                        this.propertiesPageModel.encapsulationVlanId = 1;
                        this.propertiesPageModel.normalTrafficAllowed = false;
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                        this.propertiesPageModel.normalTrafficAllowed = false;
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST: {
                        this.propertiesPageModel.normalTrafficAllowed = false;
                        break;
                    }
                }
                this.selectSourcesPageModel.portsListModel.ports = [];
                delete this.selectSourcesPageModel.portsListModel["cachedData"];
                this.selectSourcesPageModel.vlanIdListModel.values = [];
                delete this.selectSourcesPageModel.vlanIdListModel["cachedData"];
                this.selectDestinationsPageModel.portsListModel.ports = [];
                delete this.selectDestinationsPageModel.portsListModel["cachedData"];
                this.selectDestinationsPageModel.ipAddressesListModel.values = [];
                delete this.selectDestinationsPageModel.ipAddressesListModel["cachedData"];
            },
            enumerable: true,
            configurable: true
        });
        return DvsAddSpanSessionWizardModel;
    }());
    dvs_ui.DvsAddSpanSessionWizardModel = DvsAddSpanSessionWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringDetailsViewService = (function () {
        function DvsPortMirroringDetailsViewService(dataService, i18nService, propertyViewService) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
            this.i18n = this.i18nService.getString;
        }
        DvsPortMirroringDetailsViewService.prototype.getDvsPortMirrorSessionDetails = function (dvsUrn, sessionKey) {
            var dvsPortMirroringSpec = {
                _type: "com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSpec",
                sessionKey: sessionKey
            };
            var params = {
                propertyParams: [{
                        propertyName: DvsPortMirroringDetailsViewService.DATA_PROPERTY,
                        parameterType: "com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSpec",
                        parameter: dvsPortMirroringSpec
                    }]
            };
            return this.dataService.getProperties(dvsUrn, [DvsPortMirroringDetailsViewService.DATA_PROPERTY], params)
                .then(function (response) {
                return response[DvsPortMirroringDetailsViewService.DATA_PROPERTY];
            });
        };
        DvsPortMirroringDetailsViewService.prototype.buildDvsPortMirrorSessionPropertiesView = function (dvsPortMirrorSessionData) {
            if (dvsPortMirrorSessionData) {
                var builder = this.propertyViewService.createPropertyViewBuilder();
                this.buildDvsPortMirrorSessionPropertiesCategory(builder, dvsPortMirrorSessionData);
                return builder.build();
            }
        };
        DvsPortMirroringDetailsViewService.prototype.buildDvsPortMirrorSessionPropertiesCategory = function (builder, dvsPortMirrorSessionData) {
            // Add "Properties" tab
            var propertiesCategory = builder.category("properties");
            propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.name"), dvsPortMirrorSessionData.name);
            propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.type"), dvsPortMirrorSessionData.sessionType);
            if (dvsPortMirrorSessionData.encapsulationType) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.encapsulationType"), dvsPortMirrorSessionData.encapsulationType);
            }
            if (dvsPortMirrorSessionData.sessionId !== -1) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.erspanId"), dvsPortMirrorSessionData.sessionId);
            }
            if (dvsPortMirrorSessionData.tcpIpStack) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.tcpIpStack"), dvsPortMirrorSessionData.tcpIpStack);
            }
            propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.status"), dvsPortMirrorSessionData.enabled);
            if (dvsPortMirrorSessionData.normalTrafficOnDestPorts) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.normalTrafficAllowed"), dvsPortMirrorSessionData.normalTrafficOnDestPorts);
            }
            if (dvsPortMirrorSessionData.encapsulationVlanId) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.encapsulationVlanId"), dvsPortMirrorSessionData.encapsulationVlanId);
            }
            if (dvsPortMirrorSessionData.preserveOriginalVlan) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.preserveOriginalVlan"), dvsPortMirrorSessionData.preserveOriginalVlan);
            }
            propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.mirroredPacketLength"), dvsPortMirrorSessionData.mirroredPacketLength);
            if (dvsPortMirrorSessionData.samplingRate) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.samplingRate"), dvsPortMirrorSessionData.samplingRate);
            }
            if (dvsPortMirrorSessionData.description) {
                propertiesCategory.section("general").property(this.i18n("DvsUi", "SpanSessionDetailsView.description"), dvsPortMirrorSessionData.description);
            }
        };
        DvsPortMirroringDetailsViewService.$inject = ["dataService",
            "i18nService",
            "vxPropertyViewService"];
        DvsPortMirroringDetailsViewService.DATA_PROPERTY = "dvswitchportmirroring:portMirroringSessionDetails";
        return DvsPortMirroringDetailsViewService;
    }());
    dvs_ui.DvsPortMirroringDetailsViewService = DvsPortMirroringDetailsViewService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortMirroringDetailsViewService", DvsPortMirroringDetailsViewService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringComponent = (function () {
        function DvsPortMirroringComponent() {
            this.bindings = {
                portMirrorSessions: "<"
            };
            this.controller = DvsPortMirroringController;
            this.templateUrl =
                "dvs-ui/resources/dvs/portmirroring/dvsPortMirroringTemplate.html";
        }
        return DvsPortMirroringComponent;
    }());
    dvs_ui.DvsPortMirroringComponent = DvsPortMirroringComponent;
    var DvsPortMirroringController = (function () {
        function DvsPortMirroringController($q, $rootScope, $scope, i18nService, dataService, vuiConstants, actionToolbarFactory, columnRenderersRegistry, networkUiConstants, dvsPortMirroringComponentService) {
            var _this = this;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.actionToolbarFactory = actionToolbarFactory;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUiConstants = networkUiConstants;
            this.dvsPortMirroringComponentService = dvsPortMirroringComponentService;
            this.preselectComparator = function (item) {
                return !!_this.$scope.selectedSession &&
                    _this.$scope.selectedSession.key === item.key;
            };
            this.createPortMirrorDatagridOptions(this.portMirrorSessions);
        }
        DvsPortMirroringController.prototype.$onInit = function () {
            this.showNoItemSelected = true;
            this.refresh();
        };
        DvsPortMirroringController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.portMirrorSessions ?
                this.portMirrorSessions : [];
        };
        DvsPortMirroringController.prototype.refresh = function () {
            var _this = this;
            this.$scope.portMirrorLoading = true;
            this.dSwitchUri = this.$rootScope._route.objectId;
            this.headerOptions = {
                title: this.i18nService.getString("DvsUi", "dvs.portMirroringView.title"),
                objectId: this.dSwitchUri,
                actions: null
            };
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "150px",
                        size: "45%"
                    }, {
                        min: "250px",
                        size: "55%"
                    }
                ]
            };
            var dvsPromise = this.dvsPortMirroringComponentService
                .getDvsPortMirroringData(this.dSwitchUri);
            this._selectedDvsPromise = dvsPromise;
            this.evaluationContext = {};
            var actionIds = [
                DvsPortMirroringController.ADD_SPAN_SESSION_ACTION,
                this.vuiConstants.actions.SEPARATOR,
                DvsPortMirroringController.EDIT_SPAN_SESSION_ACTION,
                this.networkUiConstants.actions.REMOVE_SPAN_SESSION
            ];
            var actionPromise = this.actionToolbarFactory.createActionbarOptions([this.$rootScope._route.objectId], actionIds, this.evaluationContext);
            this._actionPromise = actionPromise;
            var dvsSpanSessionCapabilityPromise = this.dvsPortMirroringComponentService
                .getDvsPortMirroringCapability(this.dSwitchUri);
            this._newSpanSessionActionPromise = dvsSpanSessionCapabilityPromise;
            this.$q.all([dvsPromise, actionPromise, dvsSpanSessionCapabilityPromise])
                .then(function (results) {
                if (_this._selectedDvsPromise === dvsPromise) {
                    var dvsPortMirroringData = results[0];
                    if (dvsPortMirroringData) {
                        _this.portMirrorSessions =
                            dvsPortMirroringData.portMirroringSessionsData ?
                                dvsPortMirroringData.portMirroringSessionsData : [];
                        _this.createPortMirrorDatagridOptions(_this.portMirrorSessions);
                    }
                }
                if (_this._actionPromise === actionPromise) {
                    _this.datagridOptions.actionBarOptions = results[1];
                }
                if (_this._newSpanSessionActionPromise === dvsSpanSessionCapabilityPromise) {
                    _this.newSpanSessionActionEnabled = results[2];
                }
            })
                .finally(function () {
                _this.$scope.portMirrorLoading = false;
            });
            this.liveRefreshProperties = [
                "config.vspanSession"
            ];
        };
        DvsPortMirroringController.prototype.createPortMirrorDatagridOptions = function (portMirrorSessions) {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: portMirrorSessions,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                actionBarOptions: {
                    actions: []
                },
                onChange: this.onSelectionChange.bind(this)
            };
        };
        DvsPortMirroringController.prototype.createColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DvsUi", "dvs.portMirroring.grid.sessionName.columnHeader"),
                    field: "name",
                    width: "150px",
                    template: (function (data) {
                        return _this.columnRenderersRegistry.getColumnRenderer("text")(["name"], data, true /*unescapeCharacters*/);
                    })
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "dvs.portMirroring.grid.type.columnHeader"),
                    field: "sessionType",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "dvs.portMirroring.grid.status.columnHeader"),
                    field: "enabled",
                    width: "150px"
                }];
        };
        DvsPortMirroringController.prototype.onSelectionChange = function (items) {
            if (items && items.length > 0) {
                this.$scope.selectedSession = items[0];
                this.evaluationContext.selectedSession = items[0];
                this.portMirrorDetailsHeader = this.i18nService.getString("DvsUi", "SpanSessionDetailsView.title", items[0].name);
            }
            else {
                this.$scope.selectedSession = null;
                this.evaluationContext.selectedSession = null;
            }
            this.showNoItemSelected = this.$scope.selectedSession === null;
            this.toggleActionsAvailability();
        };
        // Toggles the enabled/disabled flag of actions that depend on some item's
        // selection (e.g. Edit, Remove, etc..)
        DvsPortMirroringController.prototype.toggleActionsAvailability = function () {
            var _this = this;
            if (this.datagridOptions.actionBarOptions &&
                this.datagridOptions.actionBarOptions.actions) {
                this.datagridOptions.actionBarOptions.actions.forEach(function (action) {
                    if (action.actionId === DvsPortMirroringController.ADD_SPAN_SESSION_ACTION) {
                        action.enabled = _this.newSpanSessionActionEnabled;
                    }
                    else if (action.actionId === DvsPortMirroringController.EDIT_SPAN_SESSION_ACTION) {
                        action.enabled = _this.$scope.selectedSession !== null
                            && !_this.$scope.selectedSession.isLegacySession;
                    }
                    else if (action.actionId === _this.networkUiConstants.actions.REMOVE_SPAN_SESSION) {
                        action.enabled = _this.$scope.selectedSession !== null;
                    }
                });
            }
        };
        DvsPortMirroringController.$inject = [
            "$q",
            "$rootScope",
            "$scope",
            "i18nService",
            "dataService",
            "vuiConstants",
            "actionToolbarFactory",
            "columnRenderersRegistry",
            "networkUiConstants",
            "dvsPortMirroringComponentService"
        ];
        DvsPortMirroringController.PORT_MIRRORING_DATA_PROPERTY_NAME = "dvswitchportmirroring:portMirroringDetails";
        DvsPortMirroringController.PORT_MIRRORING_CAPABILITY = "dvswitchportmirroring:isAnySpanSessionSupported";
        DvsPortMirroringController.ADD_SPAN_SESSION_ACTION = "vsphere.core.dvs.spanSession.addAction";
        DvsPortMirroringController.EDIT_SPAN_SESSION_ACTION = "vsphere.core.dvs.spanSession.editAction";
        return DvsPortMirroringController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringView", new DvsPortMirroringComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringComponentService = (function () {
        function DvsPortMirroringComponentService(dataService) {
            this.dataService = dataService;
        }
        DvsPortMirroringComponentService.prototype.getDvsPortMirroringData = function (dvsUrn) {
            return this.dataService
                .getProperties(dvsUrn, [DvsPortMirroringComponentService
                    .PORT_MIRRORING_DATA_PROPERTY_NAME])
                .then(function (response) {
                return response ? response[DvsPortMirroringComponentService
                    .PORT_MIRRORING_DATA_PROPERTY_NAME] : null;
            });
        };
        DvsPortMirroringComponentService.prototype.getDvsPortMirroringCapability = function (dvsUrn) {
            return this.dataService
                .getProperties(dvsUrn, [DvsPortMirroringComponentService
                    .PORT_MIRRORING_CAPABILITY])
                .then(function (response) {
                return response ? response[DvsPortMirroringComponentService
                    .PORT_MIRRORING_CAPABILITY] : false;
            });
        };
        DvsPortMirroringComponentService.$inject = ["dataService",
            "vxPropertyViewService"];
        DvsPortMirroringComponentService.PORT_MIRRORING_DATA_PROPERTY_NAME = "dvswitchportmirroring:portMirroringDetails";
        DvsPortMirroringComponentService.PORT_MIRRORING_CAPABILITY = "dvswitchportmirroring:isAnySpanSessionSupported";
        return DvsPortMirroringComponentService;
    }());
    dvs_ui.DvsPortMirroringComponentService = DvsPortMirroringComponentService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortMirroringComponentService", DvsPortMirroringComponentService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringDestinationsViewComponent = (function () {
        function DvsPortMirroringDestinationsViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringDestinationsViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringDestinationsViewComponent;
    }());
    dvs_ui.DvsPortMirroringDestinationsViewComponent = DvsPortMirroringDestinationsViewComponent;
    var DvsPortMirroringDestinationsViewController = (function () {
        function DvsPortMirroringDestinationsViewController(i18nService, $rootScope, $scope, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringDestinationsViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        DvsPortMirroringDestinationsViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringDestinationView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
                this.dSwitchUri = this.$rootScope._route.objectId;
                this.liveRefreshProperties = [
                    "config.vspanSession"
                ];
            }
        };
        DvsPortMirroringDestinationsViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.destinationPortData ?
                    detailsData.destinationPortData : [];
                this.sortEntities();
            }
            else {
                this.datagridOptions.data = [];
            }
            this.$scope.portMirrorLoading = false;
            this.onRefresh();
        };
        DvsPortMirroringDestinationsViewController.prototype.sortEntities = function () {
            var _this = this;
            var sortedEntries = [];
            if (this.tableEntries) {
                sortedEntries = this.tableEntries.sort(function (item1, item2) {
                    return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portKey");
                });
            }
            this.datagridOptions.data = sortedEntries;
        };
        DvsPortMirroringDestinationsViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringDestinationsViewController.prototype.createColumnDefinitions = function () {
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            return [
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.port"),
                    field: "portKey",
                    width: "150px"
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.host"),
                    field: "hostProxyName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([
                            undefined, "hostProxyName",
                            data.hostIcon
                        ], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.connectee"),
                    field: "connectedEntityName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([
                            undefined, "connectedEntityName",
                            data.connecteeIconId
                        ], data);
                    }
                }
            ];
        };
        DvsPortMirroringDestinationsViewController.$inject = [
            "i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringDestinationsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringDestinationsView", new DvsPortMirroringDestinationsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringDetailsComponent = (function () {
        function DvsPortMirroringDetailsComponent() {
            this.bindings = {
                selectedSession: "<"
            };
            this.controller = DvsPortMirroringDetailsController;
            this.templateUrl =
                "dvs-ui/resources/dvs/portmirroring/dvsPortMirroringDetailsViewTemplate.html";
        }
        return DvsPortMirroringDetailsComponent;
    }());
    dvs_ui.DvsPortMirroringDetailsComponent = DvsPortMirroringDetailsComponent;
    var DvsPortMirroringDetailsController = (function () {
        function DvsPortMirroringDetailsController($rootScope, $scope, i18nService, dvsPortMirroringDetailsViewService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dvsPortMirroringDetailsViewService = dvsPortMirroringDetailsViewService;
            this.i18n = this.i18nService.getString;
            this.isLegacySession = false;
            this.isRemoteDestinationSession = false;
            this.isRemoteSourceSession = false;
            this.isEncapsulatedSession = false;
            this.showDestinationsView = false;
            this.selectedTabIndex = 0;
            this.$scope.onSourcesViewRefreshed = function () {
                _this.$scope.shouldRefreshSourcesView = false;
            };
            this.$scope.onDestinationsViewRefreshed = function () {
                _this.$scope.shouldRefreshDestinationsView = false;
            };
            this.$scope.onTabSelected = function (index) {
                _this.$scope.isSourcesTabLoaded = index === 1
                    || !!_this.$scope.isSourcesTabLoaded;
                _this.$scope.isDestinationsTabLoaded = index === 2
                    || _this.$scope.isDestinationsTabLoaded;
                _this.selectedTabIndex = index;
            };
        }
        DvsPortMirroringDetailsController.prototype.$onChanges = function () {
            this.$scope.portMirrorLoading = true;
            this.refresh(this.selectedSession);
        };
        DvsPortMirroringDetailsController.prototype.refresh = function (selectedSession) {
            var _this = this;
            this.$scope.portMirrorLoading = true;
            this.dSwitchUri = this.$rootScope._route.objectId;
            var requestPromise = this.dvsPortMirroringDetailsViewService
                .getDvsPortMirrorSessionDetails(this.dSwitchUri, selectedSession);
            this._selectedSessionPromise = requestPromise;
            this.$scope.isSourcesTabLoaded = this.selectedTabIndex === 1;
            this.$scope.isDestinationsTabLoaded = this.selectedTabIndex === 2;
            requestPromise.then(function (results) {
                if (_this._selectedSessionPromise === requestPromise) {
                    var detailsData = results;
                    _this.$scope.dvsPortMirrorSessionData =
                        _this.dvsPortMirroringDetailsViewService
                            .buildDvsPortMirrorSessionPropertiesView(detailsData);
                    if (detailsData) {
                        _this.isLegacySession = detailsData.isLegacySession;
                        _this.isRemoteSourceSession = detailsData.isRemoteSourceSession;
                        _this.isEncapsulatedSession = detailsData.isEncapsulatedSession;
                        _this.isRemoteDestinationSession =
                            detailsData.isRemoteDestinationSession;
                        _this.showDestinationsView =
                            detailsData.isRemoteDestinationSession ||
                                detailsData.isDvPortMirrorSession;
                        _this.$scope.shouldRefreshSourcesView = true;
                        _this.$scope.shouldRefreshDestinationsView = true;
                        _this.$scope.selectedSession = selectedSession;
                    }
                    _this.$scope.portMirrorLoading = false;
                }
            });
            this.liveRefreshProperties = ["config.vspanSession"];
        };
        DvsPortMirroringDetailsController.$inject = [
            "$rootScope",
            "$scope",
            "i18nService",
            "dvsPortMirroringDetailsViewService"
        ];
        return DvsPortMirroringDetailsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringDetailsView", new DvsPortMirroringDetailsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringEncapsulationDestinationsViewComponent = (function () {
        function DvsPortMirroringEncapsulationDestinationsViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringEncapsulationDestinationsViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringEncapsulationDestinationsViewComponent;
    }());
    dvs_ui.DvsPortMirroringEncapsulationDestinationsViewComponent = DvsPortMirroringEncapsulationDestinationsViewComponent;
    var DvsPortMirroringEncapsulationDestinationsViewController = (function () {
        function DvsPortMirroringEncapsulationDestinationsViewController(i18nService, $rootScope, $scope, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringEncapsulationDestinationsViewController.prototype.$onInit = function () {
            this.createDatagridOptions();
        };
        DvsPortMirroringEncapsulationDestinationsViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringDestinationView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
            }
        };
        DvsPortMirroringEncapsulationDestinationsViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.destinationPortData ?
                    detailsData.destinationPortData : [];
            }
            else {
                this.tableEntries = [];
            }
            this.$scope.portMirrorLoading = false;
            this.onRefresh();
            this.datagridOptions.data = this.tableEntries;
        };
        DvsPortMirroringEncapsulationDestinationsViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringEncapsulationDestinationsViewController.prototype.createColumnDefinitions = function () {
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            return [
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.ipAddress"),
                    field: "ipAddress",
                    width: "150px"
                }
            ];
        };
        DvsPortMirroringEncapsulationDestinationsViewController.$inject = [
            "i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringEncapsulationDestinationsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringEncapsulationDestinationsView", new DvsPortMirroringEncapsulationDestinationsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringLegacyDestinationsViewComponent = (function () {
        function DvsPortMirroringLegacyDestinationsViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringLegacyDestinationsViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringLegacyDestinationsViewComponent;
    }());
    dvs_ui.DvsPortMirroringLegacyDestinationsViewComponent = DvsPortMirroringLegacyDestinationsViewComponent;
    var DvsPortMirroringLegacyDestinationsViewController = (function () {
        function DvsPortMirroringLegacyDestinationsViewController(i18nService, $scope, $rootScope, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringLegacyDestinationsViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        DvsPortMirroringLegacyDestinationsViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringDestinationView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
            }
        };
        DvsPortMirroringLegacyDestinationsViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.destinationPortData ?
                    detailsData.destinationPortData : [];
                this.sortEntities();
            }
            else {
                this.datagridOptions.data = [];
            }
            this.$scope.portMirrorLoading = false;
            this.onRefresh();
        };
        DvsPortMirroringLegacyDestinationsViewController.prototype.sortEntities = function () {
            var _this = this;
            var sortedEntries = [];
            if (this.tableEntries) {
                sortedEntries = this.tableEntries.sort(function (item1, item2) {
                    return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portKey");
                });
            }
            this.datagridOptions.data = sortedEntries;
        };
        DvsPortMirroringLegacyDestinationsViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringLegacyDestinationsViewController.prototype.createColumnDefinitions = function () {
            var _this = this;
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            return [
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.portIdAndUplink"),
                    field: "portKey",
                    width: "150px",
                    sortable: function (item1, item2) {
                        return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portKey");
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.host"),
                    field: "hostProxyName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([
                            undefined, "hostProxyName",
                            data.hostIcon
                        ], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.connectee"),
                    field: "connectedEntityName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([
                            undefined, "connectedEntityName",
                            data.connecteeIconId
                        ], data);
                    }
                }
            ];
        };
        DvsPortMirroringLegacyDestinationsViewController.$inject = [
            "i18nService",
            "$scope",
            "$rootScope",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringLegacyDestinationsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringLegacyDestinationsView", new DvsPortMirroringLegacyDestinationsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringPortsDetailsDataService = (function () {
        function DvsPortMirroringPortsDetailsDataService(dataService) {
            this.dataService = dataService;
        }
        DvsPortMirroringPortsDetailsDataService.prototype.getDvsPortMirrorSourcePortsDataDetails = function (dvsUrn, sessionKey) {
            var dvsPortMirroringSpec = {
                _type: DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_SPEC_TYPE,
                sessionKey: sessionKey
            };
            var params = {
                propertyParams: [
                    {
                        propertyName: DvsPortMirroringPortsDetailsDataService.SOURCE_PORTS_DATA_PROPERTY,
                        parameterType: dvsPortMirroringSpec._type,
                        parameter: dvsPortMirroringSpec
                    }
                ]
            };
            return this.dataService.getProperties(dvsUrn, [DvsPortMirroringPortsDetailsDataService.SOURCE_PORTS_DATA_PROPERTY], params)
                .then(function (response) {
                return response[DvsPortMirroringPortsDetailsDataService.SOURCE_PORTS_DATA_PROPERTY];
            });
        };
        DvsPortMirroringPortsDetailsDataService.prototype.getDvsPortMirrorDestPortsDataDetails = function (dvsUrn, sessionKey) {
            var dvsPortMirroringSpec = {
                _type: DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_SPEC_TYPE,
                sessionKey: sessionKey
            };
            var params = {
                propertyParams: [
                    {
                        propertyName: DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_DATA_PROPERTY,
                        parameterType: dvsPortMirroringSpec._type,
                        parameter: dvsPortMirroringSpec
                    }
                ]
            };
            return this.dataService.getProperties(dvsUrn, [DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_DATA_PROPERTY], params)
                .then(function (response) {
                return response[DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_DATA_PROPERTY];
            });
        };
        DvsPortMirroringPortsDetailsDataService.$inject = [
            "dataService"
        ];
        DvsPortMirroringPortsDetailsDataService.SOURCE_PORTS_DATA_PROPERTY = "dvswitchportmirroring:portMirroringSourcePortsDetails";
        DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_DATA_PROPERTY = "dvswitchportmirroring:portMirroringDestinationPortsDetails";
        DvsPortMirroringPortsDetailsDataService.DESTINATION_PORTS_SPEC_TYPE = "com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSpec";
        return DvsPortMirroringPortsDetailsDataService;
    }());
    dvs_ui.DvsPortMirroringPortsDetailsDataService = DvsPortMirroringPortsDetailsDataService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortMirroringPortsDetailsDataService", DvsPortMirroringPortsDetailsDataService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringRemoteSourceDestinationsViewComponent = (function () {
        function DvsPortMirroringRemoteSourceDestinationsViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringRemoteSourceDestinationsViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringRemoteSourceDestinationsViewComponent;
    }());
    dvs_ui.DvsPortMirroringRemoteSourceDestinationsViewComponent = DvsPortMirroringRemoteSourceDestinationsViewComponent;
    var DvsPortMirroringRemoteSourceDestinationsViewController = (function () {
        function DvsPortMirroringRemoteSourceDestinationsViewController(i18nService, $scope, $rootScope, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringRemoteSourceDestinationsViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        DvsPortMirroringRemoteSourceDestinationsViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringDestinationView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
            }
        };
        DvsPortMirroringRemoteSourceDestinationsViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.destinationPortData ?
                    detailsData.destinationPortData : [];
            }
            else {
                this.tableEntries = [];
            }
            this.$scope.portMirrorLoading = false;
            this.datagridOptions.data = this.tableEntries;
            this.onRefresh();
        };
        DvsPortMirroringRemoteSourceDestinationsViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringRemoteSourceDestinationsViewController.prototype.createColumnDefinitions = function () {
            return [
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.uplink"),
                    field: "portKey",
                    width: "150px"
                },
            ];
        };
        DvsPortMirroringRemoteSourceDestinationsViewController.$inject = [
            "i18nService",
            "$scope",
            "$rootScope",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringRemoteSourceDestinationsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringRemoteSourceDestinationsView", new DvsPortMirroringRemoteSourceDestinationsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringSourcesAndDestRefreshService = (function () {
        function DvsPortMirroringSourcesAndDestRefreshService(dataService, dvsPortMirroringPortsDetailsDataService) {
            this.dataService = dataService;
            this.dvsPortMirroringPortsDetailsDataService = dvsPortMirroringPortsDetailsDataService;
        }
        DvsPortMirroringSourcesAndDestRefreshService.prototype.refreshDvsPortMirroringSourcesView = function ($scope, $rootScope, selectedSession, fillTableEntries) {
            var _this = this;
            $scope.portMirrorLoading = true;
            var dSwitchUri = $rootScope._route.objectId;
            var requestPromise = this.dvsPortMirroringPortsDetailsDataService
                .getDvsPortMirrorSourcePortsDataDetails(dSwitchUri, selectedSession);
            this._sourcePortsDataPromise = requestPromise;
            requestPromise
                .then(function (detailsData) {
                if (_this._sourcePortsDataPromise === requestPromise) {
                    fillTableEntries(detailsData);
                }
            });
        };
        DvsPortMirroringSourcesAndDestRefreshService.prototype.refreshDvsPortMirroringDestinationView = function ($scope, $rootScope, selectedSession, fillTableEntries) {
            var _this = this;
            $scope.portMirrorLoading = true;
            var dSwitchUri = $rootScope._route.objectId;
            var requestPromise = this.dvsPortMirroringPortsDetailsDataService
                .getDvsPortMirrorDestPortsDataDetails(dSwitchUri, selectedSession);
            this._destinationPortsDataPromise = requestPromise;
            requestPromise
                .then(function (detailsData) {
                if (_this._destinationPortsDataPromise === requestPromise) {
                    fillTableEntries(detailsData);
                }
            });
        };
        DvsPortMirroringSourcesAndDestRefreshService.$inject = [
            "dataService",
            "dvsPortMirroringPortsDetailsDataService"
        ];
        return DvsPortMirroringSourcesAndDestRefreshService;
    }());
    dvs_ui.DvsPortMirroringSourcesAndDestRefreshService = DvsPortMirroringSourcesAndDestRefreshService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortMirroringSourcesAndDestRefreshService", DvsPortMirroringSourcesAndDestRefreshService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringSourcesViewComponent = (function () {
        function DvsPortMirroringSourcesViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringSourcesViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringSourcesViewComponent;
    }());
    dvs_ui.DvsPortMirroringSourcesViewComponent = DvsPortMirroringSourcesViewComponent;
    var DvsPortMirroringSourcesViewController = (function () {
        function DvsPortMirroringSourcesViewController(i18nService, $rootScope, $scope, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringSourcesViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        DvsPortMirroringSourcesViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringSourcesView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
                this.dSwitchUri = this.$rootScope._route.objectId;
                this.liveRefreshProperties = [
                    "config.vspanSession"
                ];
            }
        };
        DvsPortMirroringSourcesViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.sourcePortData ?
                    detailsData.sourcePortData : [];
                this.sortEntities();
            }
            else {
                this.datagridOptions.data = [];
            }
            this.$scope.portMirrorLoading = false;
            this.onRefresh();
        };
        DvsPortMirroringSourcesViewController.prototype.sortEntities = function () {
            var _this = this;
            var sortedEntries = [];
            if (this.tableEntries) {
                sortedEntries = this.tableEntries.sort(function (item1, item2) {
                    return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portKey");
                });
            }
            this.datagridOptions.data = sortedEntries;
        };
        DvsPortMirroringSourcesViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringSourcesViewController.prototype.createColumnDefinitions = function () {
            var _this = this;
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            return [{
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.port"),
                    field: "portKey",
                    width: "150px",
                    sortable: function (item1, item2) {
                        return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portKey");
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.host"),
                    field: "hostProxyName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "hostProxyName",
                            data.hostIcon], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.connectee"),
                    field: "connectedEntityName",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "connectedEntityName",
                            data.connecteeIconId], data);
                    }
                },
                {
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.direction"),
                    field: "trafficDirection",
                    width: "150px",
                    template: function (data) {
                        return columnRenderer([undefined, "trafficDirection",
                            data.trafficDirectionIconId], data);
                    }
                }];
        };
        DvsPortMirroringSourcesViewController.$inject = [
            "i18nService",
            "$rootScope",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringSourcesViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringSourcesView", new DvsPortMirroringSourcesViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringSourcesVlanViewComponent = (function () {
        function DvsPortMirroringSourcesVlanViewComponent() {
            this.bindings = {
                selectedSession: "<",
                shouldRefresh: "<",
                onRefresh: "<"
            };
            this.controller = DvsPortMirroringSourcesVlanViewController;
            this.templateUrl = "dvs-ui/resources/dvs/portmirroring/" +
                "dvsPortMirroringSourcesDestViewTemplate.html";
        }
        return DvsPortMirroringSourcesVlanViewComponent;
    }());
    dvs_ui.DvsPortMirroringSourcesVlanViewComponent = DvsPortMirroringSourcesVlanViewComponent;
    var DvsPortMirroringSourcesVlanViewController = (function () {
        function DvsPortMirroringSourcesVlanViewController($rootScope, $scope, i18nService, vuiConstants, columnRenderersRegistry, networkUtil, dvsPortMirroringSourcesAndDestRefreshService) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.dvsPortMirroringSourcesAndDestRefreshService = dvsPortMirroringSourcesAndDestRefreshService;
            this.createDatagridOptions();
        }
        DvsPortMirroringSourcesVlanViewController.prototype.$onInit = function () {
            this.createDatagridOptions();
        };
        DvsPortMirroringSourcesVlanViewController.prototype.$onChanges = function () {
            if (this.shouldRefresh) {
                this.dvsPortMirroringSourcesAndDestRefreshService
                    .refreshDvsPortMirroringSourcesView(this.$scope, this.$rootScope, this.selectedSession, this.fillTableEntries.bind(this));
            }
        };
        DvsPortMirroringSourcesVlanViewController.prototype.fillTableEntries = function (detailsData) {
            if (detailsData) {
                this.tableEntries = detailsData.sourcePortData ?
                    detailsData.sourcePortData : [];
            }
            else {
                this.tableEntries = [];
            }
            this.$scope.portMirrorLoading = false;
            this.datagridOptions.data = this.tableEntries;
            this.onRefresh();
        };
        DvsPortMirroringSourcesVlanViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        DvsPortMirroringSourcesVlanViewController.prototype.createColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DvsUi", "SessionDvPortSourceList.vlanId"),
                    field: "vlan",
                    width: "150px",
                    sortable: function (item1, item2) {
                        return _this.networkUtil.compareNumericValues(item1, item2, "vlan");
                    }
                }];
        };
        DvsPortMirroringSourcesVlanViewController.$inject = [
            "$rootScope",
            "$scope",
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry",
            "networkUtil",
            "dvsPortMirroringSourcesAndDestRefreshService"
        ];
        return DvsPortMirroringSourcesVlanViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortMirroringSourcesVlanView", new DvsPortMirroringSourcesVlanViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Sets pages visibility of the Dvs Edit Span Session Dialog
 */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSpanSessionDialogPages = (function () {
        function DvsEditSpanSessionDialogPages(vuiConstants, i18nService, propertiesValidator) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.propertiesValidator = propertiesValidator;
        }
        DvsEditSpanSessionDialogPages.prototype.createPageDefinitions = function (dialogScope, sessionType) {
            var pages = [];
            pages.push({
                title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.propertiesPage.title"),
                contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionPropertiesPage.html",
                onCommit: this.buildPropertiesPageCommitCallback(dialogScope)
            });
            switch (sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE:
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.sourcesPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectSourcePortsPage.html",
                        onCommit: function () {
                            return true;
                        }
                    });
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.destinationsPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectDestinationAddressesPage.html",
                        onCommit: this.buildDestinationAddressesPageCommitCallback(dialogScope)
                    });
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE:
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.sourcesPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectSourcePortsPage.html",
                        onCommit: function () {
                            return true;
                        }
                    });
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.destinationsPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectDestinationUplinksPage.html",
                        onCommit: function () {
                            return true;
                        }
                    });
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST:
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.sourcesPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectSourceVlansPage.html",
                        onCommit: this.buildSourceVlansPageCommitCallback(dialogScope)
                    });
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.destinationsPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectDestinationPortsPage.html",
                        onCommit: function () {
                            return true;
                        }
                    });
                    break;
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR:
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.sourcesPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectSourcePortsPage.html",
                        onCommit: this.buildPortsPageCommitCallback(dialogScope, "SpanSession.error.alreadyUsedDestPort", "SpanSession.error.alreadyUsedDestPorts")
                    });
                    pages.push({
                        title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.destinationsPage.title"),
                        contentUrl: "dvs-ui/resources/dvs/portmirroring/edit/views/dvsEditSpanSessionSelectDestinationPortsPage.html",
                        onCommit: this.buildPortsPageCommitCallback(dialogScope, "SpanSession.error.alreadyUsedSourcePort", "SpanSession.error.alreadyUsedSourcePorts")
                    });
                    break;
            }
            return pages;
        };
        DvsEditSpanSessionDialogPages.prototype.buildPropertiesPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                dialogScope.model.pageValidators["editPropertiesPage"].validate();
                var pageModel = dialogScope.model.propertiesPageModel;
                var errors = pageModel.errors
                    ? pageModel.errors.slice()
                    : [];
                var descriptionError = _this.propertiesValidator.getDescriptionError(dialogScope.model.propertiesPageModel.description);
                if (descriptionError) {
                    errors.push(descriptionError);
                }
                if (errors.length > 0) {
                    _this.showDialogErrors(dialogScope, errors);
                    return false;
                }
                if (dialogScope.model.originalData.sessionName
                    !== dialogScope.model.propertiesPageModel.sessionName) {
                    dialogScope.busy = true;
                    return _this.propertiesValidator.getNameServerError(dialogScope.model.dvsUrn, dialogScope.model.propertiesPageModel.sessionName)
                        .then(function (error) {
                        _this.showDialogErrors(dialogScope, [error]);
                        dialogScope.busy = false;
                        return !error;
                    });
                }
                return true;
            };
        };
        DvsEditSpanSessionDialogPages.prototype.buildDestinationAddressesPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                dialogScope.model.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_DESTINATION_ADDRESSES].validate();
                var pageModel = dialogScope.model.selectDestinationsPageModel;
                if (pageModel.ipAddressesListModel.errors
                    && pageModel.ipAddressesListModel.errors.length) {
                    _this.showDialogErrors(dialogScope, pageModel.ipAddressesListModel.errors);
                    return false;
                }
                return true;
            };
        };
        DvsEditSpanSessionDialogPages.prototype.buildSourceVlansPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                dialogScope.model.pageValidators[dvs_ui.DvsSpanSessionConstants.PAGE_ID.SELECT_SOURCE_VLANS].validate();
                var pageModel = dialogScope.model.selectSourcesPageModel;
                if (pageModel.vlanIdListModel.errors
                    && pageModel.vlanIdListModel.errors.length) {
                    _this.showDialogErrors(dialogScope, pageModel.vlanIdListModel.errors);
                    return false;
                }
                return true;
            };
        };
        DvsEditSpanSessionDialogPages.prototype.buildPortsPageCommitCallback = function (dialogScope, singleEntityMessage, multipleEntitiesMessage) {
            var _this = this;
            return function () {
                var sourcePorts = dialogScope.model.selectSourcesPageModel.portsListModel.ports
                    .map(function (port) { return port.id; });
                var destinationPorts = dialogScope.model.selectDestinationsPageModel.portsListModel.ports
                    .map(function (port) { return port.id; });
                var usedPorts = _.intersection(sourcePorts, destinationPorts);
                if (usedPorts.length === 1) {
                    _this.showDialogErrors(dialogScope, [
                        _this.i18nService.getString("DvsUi", singleEntityMessage, usedPorts[0])
                    ]);
                    return false;
                }
                else if (usedPorts.length > 1) {
                    _this.showDialogErrors(dialogScope, [
                        _this.i18nService.getString("DvsUi", multipleEntitiesMessage, usedPorts.join(", "))
                    ]);
                    return false;
                }
                return true;
            };
        };
        DvsEditSpanSessionDialogPages.prototype.showDialogErrors = function (dialogScope, errors) {
            var _this = this;
            dialogScope.dialogOptions.validationBanner.messages = _.map(errors, function (message) {
                return {
                    type: _this.vuiConstants.validationBanner.type.ERROR,
                    text: message
                };
            });
        };
        DvsEditSpanSessionDialogPages.$inject = [
            "vuiConstants",
            "i18nService",
            "dvsSpanSessionPropertiesValidator"
        ];
        return DvsEditSpanSessionDialogPages;
    }());
    dvs_ui.DvsEditSpanSessionDialogPages = DvsEditSpanSessionDialogPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSpanSessionDialogPages", DvsEditSpanSessionDialogPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSpanSessionDialogService = (function () {
        function DvsEditSpanSessionDialogService($rootScope, vuiConstants, vxValidatorFactory, vxMultiPageDialogService, i18nService, dataService, mutationService, dvsEditSpanSessionDialogPages, specFactory) {
            this.$rootScope = $rootScope;
            this.vuiConstants = vuiConstants;
            this.vxValidatorFactory = vxValidatorFactory;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.dvsEditSpanSessionDialogPages = dvsEditSpanSessionDialogPages;
            this.specFactory = specFactory;
        }
        DvsEditSpanSessionDialogService.prototype.show = function (dvsUrn, sessionKey, sessionType) {
            var _this = this;
            var dialogScope = this.$rootScope.$new();
            dialogScope.dvsUrn = dvsUrn;
            dialogScope.sessionKey = sessionKey;
            dialogScope.sessionType = sessionType;
            dialogScope.busy = false;
            dialogScope.dialogOptions =
                this.createDialogOptions(dialogScope, sessionType);
            dialogScope.dialogOptions.confirmOptions = {
                onClick: function () {
                    _this.submitDialog(dialogScope.model);
                    return true;
                }
            };
            dialogScope.model = new dvs_ui.DvsEditSpanSessionDialogModel();
            dialogScope.model.dvsUrn = dvsUrn;
            var options = {
                scope: dialogScope,
                configObjectName: "dialogOptions"
            };
            this.vxMultiPageDialogService(options);
            this.requestData(dialogScope);
        };
        DvsEditSpanSessionDialogService.prototype.createDialogOptions = function (dialogScope, sessionType) {
            return {
                title: this.i18nService.getString("DvsUi", "EditSpanSessionDialog.initialTitle"),
                pages: this.dvsEditSpanSessionDialogPages
                    .createPageDefinitions(dialogScope, sessionType),
                show: true,
                loading: true,
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                validationBanner: {},
                rejectOptions: {
                    rejectOnEsc: true
                },
                resizable: true,
                draggable: true,
                maximizable: true,
                height: "600px",
                width: "920px"
            };
        };
        DvsEditSpanSessionDialogService.prototype.requestData = function (dialogScope) {
            var _this = this;
            this.dataService.getProperties(dialogScope.dvsUrn, [DvsEditSpanSessionDialogService.DATA_PROPERTY], {
                propertyParams: [{
                        propertyName: DvsEditSpanSessionDialogService.DATA_PROPERTY,
                        parameterType: "java.lang.String",
                        parameter: dialogScope.sessionKey
                    }]
            })
                .then(function (result) {
                if (result && result[DvsEditSpanSessionDialogService.DATA_PROPERTY]) {
                    _this.updateDialogModel(dialogScope.model, result[DvsEditSpanSessionDialogService.DATA_PROPERTY]);
                    _this.initPageValidators(dialogScope.model);
                    dialogScope.dialogOptions.title = _this.i18nService
                        .getString("DvsUi", "EditSpanSessionDialog.titleFormat", result[DvsEditSpanSessionDialogService.DATA_PROPERTY].dvsName);
                    dialogScope.dialogOptions.loading = false;
                }
            });
        };
        DvsEditSpanSessionDialogService.prototype.updateDialogModel = function (model, data) {
            model.originalData = data;
            model.sessionType = data.sessionType;
            this.updatePropertiesPageModel(model.propertiesPageModel, data);
            model.originalData.mirroredPacketLength =
                model.propertiesPageModel.mirroredPacketLength;
            this.updateSourcesPageModel(model.selectSourcesPageModel, data);
            this.updateDestinationsPageModel(model.selectDestinationsPageModel, data);
        };
        DvsEditSpanSessionDialogService.prototype.updatePropertiesPageModel = function (model, data) {
            model.sessionName = data.sessionName;
            model.enabled = data.enabled;
            model.description = data.description;
            model.samplingRate = data.samplingRate;
            model.mirroredPacketLengthEnabled =
                data.mirroredPacketLengthEnabled;
            model.mirroredPacketLength = data.mirroredPacketLengthEnabled
                ? data.mirroredPacketLength : 60;
            model.encapsulationType = data.encapsulationType;
            model.sessionId = data.sessionId;
            model.isTcpIpStackSupported = data.mirrorNetstackSupported;
            model.tcpIpStack = data.tcpIpStack;
            model.erspanSupported = data.erspanSupported;
            model.encapsulationVlanId = data.encapsulationVlanId;
            model.preserveOriginalVlan = data.preserveOriginalVlan;
            model.normalTrafficAllowed = data.normalTrafficAllowed;
        };
        DvsEditSpanSessionDialogService.prototype.updateSourcesPageModel = function (model, data) {
            var trafficDirectionByPortId = {};
            (data.sourcePortsIngress || []).forEach(function (portId) {
                trafficDirectionByPortId[portId] =
                    dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS;
            });
            (data.sourcePortsEgress || []).forEach(function (portId) {
                trafficDirectionByPortId[portId] =
                    typeof trafficDirectionByPortId[portId] === "undefined"
                        ? dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS
                        : dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH;
            });
            model.portsListModel.ports = [];
            Object.getOwnPropertyNames(trafficDirectionByPortId)
                .forEach(function (portId) {
                model.portsListModel.ports.push(new dvs_ui.PortData(portId, trafficDirectionByPortId[portId]));
            });
            model.vlanIdListModel.values = [];
            model.vlanIdListModel.cachedData = [];
            (data.sourceVlans || []).forEach(function (vlan) {
                model.vlanIdListModel.values.push(String(vlan));
                model.vlanIdListModel.cachedData.push({
                    value: String(vlan),
                    active: false,
                    valid: true
                });
            });
        };
        DvsEditSpanSessionDialogService.prototype.updateDestinationsPageModel = function (model, data) {
            model.ipAddressesListModel.values = [];
            model.ipAddressesListModel.cachedData = [];
            (data.destinationAddresses || []).forEach(function (ip) {
                model.ipAddressesListModel.values.push(ip);
                model.ipAddressesListModel.cachedData.push({
                    value: ip,
                    active: false,
                    valid: true
                });
            });
            (data.destinationPorts || []).forEach(function (portId) {
                model.portsListModel.ports.push(new dvs_ui.PortData(portId, dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH));
            });
            (data.uplinkPortsSelected || []).forEach(function (uplinkName) {
                model.uplinksListModel.uplinks.push(uplinkName);
            });
            (data.uplinkPortsExisting || []).forEach(function (uplinkName) {
                model.uplinksListModel.notSelectedUplinks.push(uplinkName);
            });
        };
        DvsEditSpanSessionDialogService.prototype.initPageValidators = function (dialogModel) {
            dialogModel.pageValidators["editPropertiesPage"] =
                new dvs_ui.DvsSpanSessionPageValidator(dialogModel.propertiesPageModel, this.vxValidatorFactory.create());
            dialogModel.pageValidators["selectDestinationAddressesPage"] =
                new dvs_ui.DvsSpanSessionPageValidator(dialogModel.selectDestinationsPageModel.ipAddressesListModel, this.vxValidatorFactory.create());
            dialogModel.pageValidators["selectSourceVlansPage"] =
                new dvs_ui.DvsSpanSessionPageValidator(dialogModel.selectSourcesPageModel.vlanIdListModel, this.vxValidatorFactory.create());
        };
        DvsEditSpanSessionDialogService.prototype.submitDialog = function (dialogModel) {
            var data = this.specFactory.buildChanges(dialogModel);
            if (data) {
                this.mutationService.apply(dialogModel.dvsUrn, data._type, data);
            }
        };
        DvsEditSpanSessionDialogService.$inject = [
            "$rootScope",
            "vuiConstants",
            "vxValidatorFactory",
            "vxMultiPageDialogService",
            "i18nService",
            "dataService",
            "mutationService",
            "dvsEditSpanSessionDialogPages",
            "dvsEditSpanSessionDialogSpecFactory"
        ];
        DvsEditSpanSessionDialogService.DATA_PROPERTY = "dvswitchportmirroring:editSpanSessionDialogData";
        return DvsEditSpanSessionDialogService;
    }());
    dvs_ui.DvsEditSpanSessionDialogService = DvsEditSpanSessionDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSpanSessionDialogService", DvsEditSpanSessionDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSpanSessionDialogData = com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.dialog.DvsEditSpanSessionDialogData;
    var DvsEditSpanSessionDialogSpecFactory = (function () {
        function DvsEditSpanSessionDialogSpecFactory() {
        }
        DvsEditSpanSessionDialogSpecFactory.prototype.buildChanges = function (model) {
            var hasChanges = this.havePropertiesChanged(model)
                || this.haveSourcesChanged(model)
                || this.haveDestinationsChanged(model);
            if (hasChanges) {
                return _.extend(this.buildCommonPropertiesChanges(model), this.buildSourcesChanges(model), this.buildDestinationChanges(model));
            }
            else {
                return null;
            }
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.buildCommonPropertiesChanges = function (model) {
            var changes = new DvsEditSpanSessionDialogData();
            changes.key = model.originalData.key;
            changes.sessionType = model.originalData.sessionType;
            changes.sessionName = model.propertiesPageModel.sessionName;
            changes.enabled = model.propertiesPageModel.enabled;
            changes.sessionId = model.propertiesPageModel.sessionId;
            if (model.propertiesPageModel.isTcpIpStackSupported) {
                changes.tcpIpStack = model.propertiesPageModel.tcpIpStack;
            }
            changes.preserveOriginalVlan =
                model.propertiesPageModel.preserveOriginalVlan;
            changes.encapsulationVlanId =
                model.propertiesPageModel.encapsulationVlanId;
            changes.normalTrafficAllowed =
                model.propertiesPageModel.normalTrafficAllowed;
            changes.mirroredPacketLength = model.propertiesPageModel.mirroredPacketLengthEnabled
                ? model.propertiesPageModel.mirroredPacketLength : -1;
            changes.samplingRate = model.propertiesPageModel.samplingRate;
            changes.description = model.propertiesPageModel.description;
            return changes;
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.buildSourcesChanges = function (model) {
            var changes = new DvsEditSpanSessionDialogData();
            if (model.originalData.sessionType !==
                dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST) {
                changes.sourcePortsEgress = [];
                changes.sourcePortsIngress = [];
                model.selectSourcesPageModel.portsListModel.ports
                    .forEach(function (port) {
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        changes.sourcePortsEgress.push(port.id);
                    }
                    if (port.trafficDirection ===
                        dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS
                        || port.trafficDirection ===
                            dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH) {
                        changes.sourcePortsIngress.push(port.id);
                    }
                });
            }
            else if (model.originalData.sessionType ===
                dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST) {
                changes.sourceVlans =
                    model.selectSourcesPageModel.vlanIdListModel.values
                        .map(function (vlanId) {
                        return parseInt(vlanId);
                    });
            }
            return changes;
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.buildDestinationChanges = function (model) {
            var changes = new DvsEditSpanSessionDialogData();
            switch (model.originalData.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                    changes.destinationAddresses =
                        model.selectDestinationsPageModel.ipAddressesListModel.values;
                    break;
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST:
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                    changes.destinationPorts =
                        model.selectDestinationsPageModel.portsListModel.ports
                            .map(function (port) {
                            return port.id;
                        });
                    break;
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                    changes.uplinkPortsSelected =
                        model.selectDestinationsPageModel.uplinksListModel.uplinks;
                    break;
                }
            }
            return changes;
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.havePropertiesChanged = function (model) {
            var props = Object.getOwnPropertyNames(model.propertiesPageModel);
            for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
                var prop = props_1[_i];
                if (prop === "errors") {
                    continue;
                }
                if (model.originalData[prop]
                    !== model.propertiesPageModel[prop]) {
                    return true;
                }
            }
            return false;
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveSourcesChanged = function (model) {
            switch (model.originalData.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE:
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR:
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                    return this.haveSourcePortsChanged(model);
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST: {
                    return this.haveSourceVlansChanged(model);
                }
                default: {
                    return false;
                }
            }
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveDestinationsChanged = function (model) {
            switch (model.originalData.sessionType) {
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.L3_SOURCE: {
                    return this.haveDestinationAddressesChanged(model);
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_DEST:
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.DV_PORT_MIRROR: {
                    return this.haveDestinationPortsChanged(model);
                }
                case dvs_ui.DvsSpanSessionConstants.SESSION_TYPE.REMOTE_MIRROR_SOURCE: {
                    return this.haveDestinationUplinksChanged(model);
                }
                default: {
                    return false;
                }
            }
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveSourcePortsChanged = function (model) {
            return DvsEditSpanSessionDialogSpecFactory
                .havePortsListValuesChanged(model.selectSourcesPageModel.portsListModel.ports, model.originalData.sourcePortsEgress, model.originalData.sourcePortsIngress);
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveSourceVlansChanged = function (model) {
            var currentVlans = model.selectSourcesPageModel.vlanIdListModel.values || [];
            var originalVlans = (model.originalData.sourceVlans || [])
                .map(function (value) { return String(value); });
            return DvsEditSpanSessionDialogSpecFactory
                .haveEditableListValuesChanged(currentVlans, originalVlans);
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveDestinationAddressesChanged = function (model) {
            var currentAddresses = model.selectDestinationsPageModel.ipAddressesListModel.values || [];
            var originalAddresses = model.originalData.destinationAddresses || [];
            return DvsEditSpanSessionDialogSpecFactory
                .haveEditableListValuesChanged(currentAddresses, originalAddresses);
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveDestinationPortsChanged = function (model) {
            return DvsEditSpanSessionDialogSpecFactory
                .havePortsListValuesChanged(model.selectDestinationsPageModel.portsListModel.ports, model.originalData.destinationPorts, model.originalData.destinationPorts);
        };
        DvsEditSpanSessionDialogSpecFactory.haveEditableListValuesChanged = function (currentValues, originalValues) {
            if (currentValues.length !== originalValues.length) {
                return true;
            }
            for (var i = 0; i < currentValues.length; i++) {
                if (currentValues[i] !== originalValues[i]) {
                    return true;
                }
            }
            return false;
        };
        DvsEditSpanSessionDialogSpecFactory.havePortsListValuesChanged = function (values, originalEgress, originalIngress) {
            var egress = [];
            var ingress = [];
            values.forEach(function (portData) {
                switch (portData.trafficDirection) {
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.BOTH: {
                        egress.push(portData.id);
                        ingress.push(portData.id);
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.EGRESS: {
                        egress.push(portData.id);
                        break;
                    }
                    case dvs_ui.DvsSpanSessionConstants.TRAFFIC_DIRECTION.INGRESS: {
                        ingress.push(portData.id);
                        break;
                    }
                }
            });
            return _.difference(egress, originalEgress).length > 0
                || _.difference(originalEgress, egress).length > 0
                || _.difference(ingress, originalIngress).length > 0
                || _.difference(originalIngress, ingress).length > 0;
        };
        DvsEditSpanSessionDialogSpecFactory.prototype.haveDestinationUplinksChanged = function (model) {
            var currentUplinks = model.selectDestinationsPageModel.uplinksListModel.uplinks || [];
            var originalUplinks = model.originalData.uplinkPortsSelected || [];
            if (currentUplinks.length !== originalUplinks.length) {
                return true;
            }
            for (var i = 0; i < currentUplinks.length; i++) {
                if (currentUplinks[i] !== originalUplinks[i]) {
                    return true;
                }
            }
            return false;
        };
        return DvsEditSpanSessionDialogSpecFactory;
    }());
    dvs_ui.DvsEditSpanSessionDialogSpecFactory = DvsEditSpanSessionDialogSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSpanSessionDialogSpecFactory", DvsEditSpanSessionDialogSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSpanSessionDialogModel = (function () {
        function DvsEditSpanSessionDialogModel() {
            this.pageValidators = {};
            this.propertiesPageModel = new dvs_ui.DvsSpanSessionPropertiesPageModel();
            this.selectSourcesPageModel = new dvs_ui.DvsSpanSessionSelectSourcesPageModel();
            this.selectDestinationsPageModel = new dvs_ui.DvsSpanSessionSelectDestinationsPageModel();
            this.selectDestinationUplinksPageModel = new dvs_ui.DvsSpanSessionDestinationUplinksModel();
        }
        return DvsEditSpanSessionDialogModel;
    }());
    dvs_ui.DvsEditSpanSessionDialogModel = DvsEditSpanSessionDialogModel;
})(dvs_ui || (dvs_ui = {}));



var dvs_ui;
(function (dvs_ui) {
    var DvsPortMirroringRemoveSessionService = (function () {
        function DvsPortMirroringRemoveSessionService(mutationService, actionConfirmationService, i18nService, clarityModalService) {
            this.mutationService = mutationService;
            this.actionConfirmationService = actionConfirmationService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        DvsPortMirroringRemoveSessionService.prototype.removeSpanSession = function (availableTargets, context) {
            var _this = this;
            var DVS_SPAN_SESSOIN_SPEC_TYPE = "com.vmware.vsphere.client.h5.network.dvs.portmirroring.model.DvsPortMirroringSpec";
            var dvsSpanSessionSpec = {
                _type: DVS_SPAN_SESSOIN_SPEC_TYPE,
                sessionKey: context.selectedSession.key
            };
            var submitFunc = function () {
                _this.mutationService.apply(availableTargets[0], dvsSpanSessionSpec._type, dvsSpanSessionSpec);
            };
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "actionRemoveSpanSessionCaption"),
                message: this.i18nService.getString("DvsUi", "actionRemoveSpanSessionWarning", context.selectedSession.name),
                submit: submitFunc,
                subTitle: {
                    text: context.selectedSession.name,
                    objectId: availableTargets[0]
                },
                preserveNewlines: true,
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                }
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        DvsPortMirroringRemoveSessionService.$inject = [
            "mutationService",
            "actionConfirmationService",
            "i18nService",
            "clarityModalService"
        ];
        return DvsPortMirroringRemoveSessionService;
    }());
    dvs_ui.DvsPortMirroringRemoveSessionService = DvsPortMirroringRemoveSessionService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortMirroringRemoveSessionService", DvsPortMirroringRemoveSessionService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortsComponent = (function () {
        function DvsPortsComponent() {
            this.controller = DvsPortsController;
            this.bindings = {
                isPortGroupContext: "<"
            };
            this.templateUrl =
                "dvs-ui/resources/dvs/ports/dvsPortsTemplate.html";
        }
        return DvsPortsComponent;
    }());
    dvs_ui.DvsPortsComponent = DvsPortsComponent;
    var DvsPortsController = (function () {
        function DvsPortsController($q, $scope, i18nService, dataService, vuiConstants, navigation, dvsPortsService, actionToolbarFactory, networkUiConstants, authorizationService, defaultUriSchemeUtil) {
            var _this = this;
            this.$q = $q;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.navigation = navigation;
            this.dvsPortsService = dvsPortsService;
            this.actionToolbarFactory = actionToolbarFactory;
            this.networkUiConstants = networkUiConstants;
            this.authorizationService = authorizationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.selectedPorts = [];
            this.preselectComparator = function (item) {
                return _.contains(_.pluck(_this.selectedPorts, "portId"), item.portId);
            };
            this.i18n = this.i18nService.getString;
        }
        DvsPortsController.prototype.$onInit = function () {
            this.portContextId = this.navigation.getRoute().objectId;
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "250px",
                        size: "55%"
                    }, {
                        min: "150px",
                        size: "45%"
                    }
                ]
            };
            this.datagridOptions = {
                columnDefs: this.dvsPortsService.getColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                showCheckboxesOnMultiSelection: false,
                selectedItems: [],
                data: [],
                resizable: true,
                height: "100%",
                actionBarOptions: {
                    actions: []
                },
                onChange: this.onSelectionChanged.bind(this)
            };
            this.liveRefreshProperties =
                this.dvsPortsService.assignLiveRefreshProperties(this.isPortGroupContext);
            this.watchForObjects = [this.portContextId];
            this.refresh();
        };
        DvsPortsController.prototype.refresh = function () {
            var _this = this;
            this.portsLoading = true;
            var portsDataProperty = this.isPortGroupContext
                ? DvsPortsController.DVPG_PORTS_VIEW_DATA_PROPERTY_NAME
                : DvsPortsController.DVS_PORTS_VIEW_DATA_PROPERTY_NAME;
            var dvsPromise = this.dataService
                .getProperties(this.portContextId, [portsDataProperty]);
            this._currentDvsPromise = dvsPromise;
            this.evaluationContext = {};
            this.evaluationContext.isPortGroupContext = this.isPortGroupContext;
            var actionIds = [
                this.networkUiConstants.actions.EDIT_DVPORT
            ];
            var actionPromise = this.actionToolbarFactory.createActionbarOptions([this.portContextId], actionIds, this.evaluationContext);
            this._actionPromise = actionPromise;
            var authorizationPromise = this.authorizationService.checkPrivilege(this.portContextId, DvsPortsController.PRIVILEGE_PORT_CONFIG);
            this._authorizationPromise = authorizationPromise;
            this.$q.all([dvsPromise, actionPromise, authorizationPromise]).then(function (dataServiceResponse) {
                if (_this._currentDvsPromise === dvsPromise) {
                    var dvsPortsResponse = dataServiceResponse[0];
                    if (dvsPortsResponse && dvsPortsResponse[portsDataProperty]) {
                        _this.dSwitchUri = _this.defaultUriSchemeUtil.getVsphereObjectId(dvsPortsResponse[portsDataProperty].dvsMor);
                        _this.isPortTrafficFilterSupported =
                            dvsPortsResponse[portsDataProperty].portTrafficFilterSupported;
                        _this.evaluationContext.dSwitchUri = _this.dSwitchUri;
                        _this.datagridOptions.data =
                            dvsPortsResponse[portsDataProperty].ports;
                        if (_this.isPortGroupContext && _this.watchForObjects
                            && _this.watchForObjects.length < 2) {
                            _this.watchForObjects.push(_this.dSwitchUri);
                        }
                    }
                }
                if (_this._actionPromise === actionPromise) {
                    _this.datagridOptions.actionBarOptions = dataServiceResponse[1];
                }
                if (_this._authorizationPromise === authorizationPromise) {
                    _this.hasPortConfigPrivilege = dataServiceResponse[2];
                    if (_this.datagridOptions.actionBarOptions.actions.length > 0) {
                        _this.datagridOptions.actionBarOptions.actions[0].enabled =
                            dataServiceResponse[2];
                    }
                }
            }).finally(function () {
                _this.portsLoading = false;
            });
        };
        DvsPortsController.prototype.onSelectionChanged = function (selectedItems) {
            if (selectedItems && selectedItems.length > 0) {
                this.selectedPorts = selectedItems;
                this.evaluationContext.selectedPort = selectedItems[0];
            }
            else {
                this.selectedPorts = [];
                this.evaluationContext.selectedPort = null;
            }
            if (this.hasPortConfigPrivilege) {
                this.toggleActionsAvailability();
            }
        };
        // Toggles the enabled/disabled flag of Edit action which depends on item selection
        DvsPortsController.prototype.toggleActionsAvailability = function () {
            if (this.datagridOptions.actionBarOptions
                && this.datagridOptions.actionBarOptions.actions.length === 1) {
                this.datagridOptions.actionBarOptions.actions[0].enabled =
                    this.selectedPorts && this.selectedPorts.length > 0;
            }
        };
        DvsPortsController.DVS_PORTS_VIEW_DATA_PROPERTY_NAME = "dvsports:portsViewData";
        DvsPortsController.DVPG_PORTS_VIEW_DATA_PROPERTY_NAME = "dvportgroupports:portsViewData";
        DvsPortsController.PRIVILEGE_PORT_CONFIG = "DVSwitch.PortConfig";
        DvsPortsController.$inject = [
            "$q",
            "$scope",
            "i18nService",
            "dataService",
            "vuiConstants",
            "navigation",
            "dvsPortsService",
            "actionToolbarFactory",
            "networkUiConstants",
            "authorizationService",
            "defaultUriSchemeUtil"
        ];
        return DvsPortsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortsView", new DvsPortsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortsConstants = (function () {
        function DvsPortsConstants() {
        }
        DvsPortsConstants.VM_VNIC = "vmVnic";
        DvsPortsConstants.PNIC = "pnic";
        DvsPortsConstants.VMK_VNIC = "hostVmkVnic";
        DvsPortsConstants.LIVE_REFRESH_PROPERTIES = [
            "config.defaultPortConfig.vlan.vlanId",
            "config.defaultPortConfig.vlan",
            "config.defaultPortConfig.securityPolicy.allowPromiscuous.value",
            "config.defaultPortConfig.securityPolicy.macChanges.value",
            "config.defaultPortConfig.securityPolicy.forgedTransmits.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.policy.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.failureCriteria.checkBeacon.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.notifySwitches.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.rollingOrder.value",
            "config.defaultPortConfig.uplinkTeamingPolicy.uplinkPortOrder.standbyUplinkPort",
            "config.defaultPortConfig.uplinkTeamingPolicy.uplinkPortOrder.activeUplinkPort",
            "config.defaultPortConfig.inShapingPolicy.averageBandwidth.value",
            "config.defaultPortConfig.inShapingPolicy.peakBandwidth.value",
            "config.defaultPortConfig.inShapingPolicy.burstSize.value",
            "config.defaultPortConfig.inShapingPolicy.enabled.value",
            "config.defaultPortConfig.outShapingPolicy.averageBandwidth.value",
            "config.defaultPortConfig.outShapingPolicy.peakBandwidth.value",
            "config.defaultPortConfig.outShapingPolicy.burstSize.value",
            "config.defaultPortConfig.outShapingPolicy.enabled.value",
            "config.defaultPortConfig.ipfixEnabled.value",
            "config.defaultPortConfig.blocked.value"
        ];
        return DvsPortsConstants;
    }());
    dvs_ui.DvsPortsConstants = DvsPortsConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortsSerivce = (function () {
        function DvsPortsSerivce(i18nService, columnRenderersRegistry, networkUtil, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.networkUtil = networkUtil;
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18n = this.i18nService.getString;
            this.EMPTY_PROPERTY_VALUE = this.i18n("DvsUi", "PortList.noData");
        }
        DvsPortsSerivce.prototype.getColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18n("DvsUi", "PortList.keyHeaderText"),
                    field: "portId",
                    width: "50px",
                    template: function (dataItem) {
                        return _this.columnRenderersRegistry.getColumnRenderer("text")(["portId"], dataItem, false);
                    },
                    sortable: function (item1, item2) {
                        return _this.networkUtil.compareNumericAndNonNumericValues(item1, item2, "portId");
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.nameHeaderText"),
                    field: "name",
                    width: "90px",
                    template: function (dataItem) {
                        return dataItem.name ?
                            _this.columnRenderersRegistry.getColumnRenderer("text")(["name"], dataItem, false)
                            : _this.EMPTY_PROPERTY_VALUE;
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.connecteeHeaderText"),
                    field: "connectee",
                    width: "90px",
                    template: function (dataItem) {
                        if (!dataItem.connectedEntity) {
                            dataItem.formattedName = _this.EMPTY_PROPERTY_VALUE;
                        }
                        else if (dataItem.connectedEntityType === dvs_ui.DvsPortsConstants.VM_VNIC) {
                            dataItem.formattedName = dataItem.connectedEntity;
                        }
                        else {
                            dataItem.formattedName = dataItem.host + " - " + dataItem.connectedEntity;
                        }
                        return _this.columnRenderersRegistry.getColumnRenderer("text")(["formattedName"], dataItem, false);
                    },
                    sortable: function (item1, item2) {
                        return item1.formattedName.localeCompare(item2.formattedName);
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.macHeaderText"),
                    field: "mac",
                    width: "90px",
                    template: function (dataItem) {
                        return dataItem.mac ?
                            _this.columnRenderersRegistry.getColumnRenderer("text")(["mac"], dataItem, false)
                            : _this.EMPTY_PROPERTY_VALUE;
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.pgHeaderText"),
                    field: "portgroup",
                    width: "90px",
                    template: function (dataItem) {
                        return dataItem.portgroup ?
                            _this.columnRenderersRegistry.getColumnRenderer("text")(["portgroup"], dataItem, false)
                            : _this.EMPTY_PROPERTY_VALUE;
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.stateHeaderText"),
                    field: "state",
                    width: "90px",
                    template: function (dataItem) {
                        var stateObj = {
                            icon: "",
                            text: _this.EMPTY_PROPERTY_VALUE
                        };
                        switch (dataItem.state) {
                            case "LINK_UP": {
                                stateObj.text = _this.i18n("DvsUi", "PortState.linkUp");
                                stateObj.icon = "network-lib-ui-icon-dvsPortConnectedLf";
                                break;
                            }
                            case "LINK_DOWN": {
                                stateObj.text = _this.i18n("DvsUi", "PortState.linkDown");
                                stateObj.icon = "network-lib-ui-icon-dvsPortNotconnectedLf";
                                break;
                            }
                            case "BLOCKED": {
                                stateObj.text = _this.i18n("DvsUi", "PortState.blocked");
                                stateObj.icon = "network-lib-ui-icon-dvsPortBlockedLf";
                                break;
                            }
                        }
                        return _this.columnRenderersRegistry.getColumnRenderer("icon-text")(["icon", "text"], stateObj, false);
                    }
                },
                {
                    displayName: this.i18n("DvsUi", "PortList.vlanIdHeaderText"),
                    field: "vlan",
                    width: "90px",
                    template: function (dataItem) {
                        return dataItem.vlan ?
                            _this.columnRenderersRegistry.getColumnRenderer("text")(["vlan"], dataItem, false)
                            : _this.EMPTY_PROPERTY_VALUE;
                    }
                }];
        };
        DvsPortsSerivce.prototype.buildDvsPortNetworkConnectionPropertiesView = function (dvsPortDetailsData) {
            if (dvsPortDetailsData) {
                var builder = this.vxPropertyViewService.createPropertyViewBuilder();
                this.buildDvsPortNetworkConnectionCategory(builder, dvsPortDetailsData);
                return builder.build();
            }
        };
        DvsPortsSerivce.prototype.assignLiveRefreshProperties = function (isPortgroupContext) {
            return isPortgroupContext ? dvs_ui.DvsPortsConstants.LIVE_REFRESH_PROPERTIES : [];
        };
        DvsPortsSerivce.prototype.buildDvsPortNetworkConnectionCategory = function (builder, dvsPortDetailsData) {
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            generalSection.property(this.i18n("DvsUi", "PortDetails.portId"), dvsPortDetailsData.portId);
            if (dvsPortDetailsData.name) {
                generalSection.property(this.i18n("DvsUi", "PortDetails.name"), dvsPortDetailsData.name);
            }
            if (dvsPortDetailsData.description) {
                generalSection.property(this.i18n("DvsUi", "PortDetails.description"), dvsPortDetailsData.description);
            }
            if (dvsPortDetailsData.lagName) {
                generalSection.property(this.i18n("DvsUi", "PortDetails.lagName"), dvsPortDetailsData.lagName);
            }
            if (dvsPortDetailsData.connectedEntity) {
                var connecteeObj = {
                    icon: "",
                    text: this.EMPTY_PROPERTY_VALUE
                };
                switch (dvsPortDetailsData.connectedEntityType) {
                    case dvs_ui.DvsPortsConstants.VMK_VNIC: {
                        connecteeObj.text =
                            dvsPortDetailsData.host + " - " + dvsPortDetailsData.connectedEntity;
                        connecteeObj.icon = "network-lib-ui-icon-virtualAdapter";
                        break;
                    }
                    case dvs_ui.DvsPortsConstants.VM_VNIC: {
                        connecteeObj.text = "" + dvsPortDetailsData.connectedEntity;
                        connecteeObj.icon = "vsphere-icon-vm";
                        break;
                    }
                    case dvs_ui.DvsPortsConstants.PNIC: {
                        connecteeObj.text =
                            dvsPortDetailsData.host + " - " + dvsPortDetailsData.connectedEntity;
                        connecteeObj.icon = "network-lib-ui-icon-physicalAdapter";
                        break;
                    }
                }
                this.addPropertyValueWithIcon(generalSection, this.i18n("DvsUi", "PortDetails.connectee"), connecteeObj);
            }
            var stateObj = {
                icon: "",
                text: this.EMPTY_PROPERTY_VALUE
            };
            switch (dvsPortDetailsData.state) {
                case "LINK_UP": {
                    stateObj.text = this.i18n("DvsUi", "PortState.linkUp");
                    stateObj.icon = "network-lib-ui-icon-dvsPortConnectedLf";
                    break;
                }
                case "LINK_DOWN": {
                    stateObj.text = this.i18n("DvsUi", "PortState.linkDown");
                    stateObj.icon = "network-lib-ui-icon-dvsPortNotconnectedLf";
                    break;
                }
                case "BLOCKED": {
                    stateObj.text = this.i18n("DvsUi", "PortState.blocked");
                    stateObj.icon = "network-lib-ui-icon-dvsPortBlockedLf";
                    break;
                }
            }
            this.addPropertyValueWithIcon(generalSection, this.i18n("DvsUi", "PortDetails.state"), stateObj);
            if (dvsPortDetailsData.mac) {
                generalSection.property(this.i18n("DvsUi", "PortDetails.mac"), dvsPortDetailsData.mac);
            }
        };
        DvsPortsSerivce.prototype.addPropertyValueWithIcon = function (section, propertyName, propValue) {
            return section.propertyBuilder()
                .keyBuilder().text(propertyName)
                .exit()
                .valueBuilder()
                .icon(propValue.icon)
                .text(propValue.text)
                .exit()
                .exit();
        };
        DvsPortsSerivce.$inject = [
            "i18nService",
            "columnRenderersRegistry",
            "networkUtil",
            "vxPropertyViewService"
        ];
        return DvsPortsSerivce;
    }());
    dvs_ui.DvsPortsSerivce = DvsPortsSerivce;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortsService", DvsPortsSerivce);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortTabsDetailsComponent = (function () {
        function DvsPortTabsDetailsComponent() {
            this.bindings = {
                selectedPort: "<",
                isPortGroupContext: "<",
                isPortTrafficFilterSupported: "<",
                portContextId: "<"
            };
            this.controller = DvsPortTabsDetailsController;
            this.templateUrl =
                "dvs-ui/resources/dvs/ports/dvsPortsDetailsViewTemplate.html";
        }
        return DvsPortTabsDetailsComponent;
    }());
    dvs_ui.DvsPortTabsDetailsComponent = DvsPortTabsDetailsComponent;
    var DvsPortTabsDetailsController = (function () {
        function DvsPortTabsDetailsController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
        }
        DvsPortTabsDetailsController.$inject = [
            "$scope",
            "i18nService"
        ];
        return DvsPortTabsDetailsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortTabsDetailsView", new DvsPortTabsDetailsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditPropertiesPage = (function () {
        function DvsPortEditPropertiesPage() {
            this.bindings = {
                pageModel: "<",
                isLagOrUplink: "<",
                disableNetworkResourcePool: "<"
            };
            this.controller = DvsPortEditPropertiesPageController;
            this.templateUrl = "dvs-ui/resources/dvs/ports/edit/components/" +
                "dvsPortEditPropertiesPageComponentTemplate.html";
        }
        return DvsPortEditPropertiesPage;
    }());
    dvs_ui.DvsPortEditPropertiesPage = DvsPortEditPropertiesPage;
    var DvsPortEditPropertiesPageController = (function () {
        function DvsPortEditPropertiesPageController($scope, i18nService, dvsPortEditPropertiesPageValidator) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dvsPortEditPropertiesPageValidator = dvsPortEditPropertiesPageValidator;
            this.i18n = this.i18nService.getString;
            this.nameValidator = {
                message: null,
                isVisible: false
            };
            this.descriptionValidator = {
                message: null,
                isVisible: false
            };
            if (this.pageModel.networkResourcePools
                && this.pageModel.networkResourcePools.length) {
                this.resourcePoolOptions = [];
                _.forEach(this.pageModel.networkResourcePools, function (resourcePool) {
                    _this.resourcePoolOptions.push({
                        label: resourcePool.name,
                        val: resourcePool.key
                    });
                });
            }
        }
        DvsPortEditPropertiesPageController.prototype.onNameChange = function () {
            var message = "";
            if (this.pageModel.name) {
                message = this.dvsPortEditPropertiesPageValidator
                    .getNameError(this.pageModel.name);
            }
            this.nameValidator.message = message;
            this.nameValidator.isVisible = !!message;
        };
        DvsPortEditPropertiesPageController.prototype.onDescriptionChange = function () {
            var message = "";
            if (this.pageModel.description) {
                message = this.dvsPortEditPropertiesPageValidator
                    .getDescriptionError(this.pageModel.description);
            }
            this.descriptionValidator.message = message;
            this.descriptionValidator.isVisible = !!message;
        };
        DvsPortEditPropertiesPageController.$inject = [
            "$scope",
            "i18nService",
            "dvsPortEditPropertiesPageValidator"
        ];
        return DvsPortEditPropertiesPageController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortEditPropertiesPage", new DvsPortEditPropertiesPage());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditDialogConstants = (function () {
        function DvsPortEditDialogConstants() {
        }
        DvsPortEditDialogConstants.EDIT_OPERATION = "edit";
        DvsPortEditDialogConstants.DATA_DVS_PROPERTY = "dvsports:portEditData";
        DvsPortEditDialogConstants.DATA_DVS_VLAN_TRUNK_PROPERTY = "dvsport:vlanTrunkRanges";
        DvsPortEditDialogConstants.DATA_DVPG_PROPERTY = "dvportgroupport:portEditData";
        DvsPortEditDialogConstants.POLICY_ALLOW_PROMISCUOUS = "allowPromiscuous";
        DvsPortEditDialogConstants.POLICY_MAC_CHANGES = "macChanges";
        DvsPortEditDialogConstants.POLICY_FORGET_TRANSMITS = "forgedTransmits";
        DvsPortEditDialogConstants.NAME_MAX_BYTE_LENGTH = 80;
        DvsPortEditDialogConstants.DESCRIPTION_MAX_CHAR_LENGTH = 255;
        return DvsPortEditDialogConstants;
    }());
    dvs_ui.DvsPortEditDialogConstants = DvsPortEditDialogConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditDialogPages = (function () {
        function DvsPortEditDialogPages(i18nService, dvsPortEditVlanPageValidator, dvsPortEditPropertiesPageValidator, dvpgTrafficShapingPolicyService, dvpgFailoverPolicyPageService, vuiConstants) {
            this.i18nService = i18nService;
            this.dvsPortEditVlanPageValidator = dvsPortEditVlanPageValidator;
            this.dvsPortEditPropertiesPageValidator = dvsPortEditPropertiesPageValidator;
            this.dvpgTrafficShapingPolicyService = dvpgTrafficShapingPolicyService;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
            this.vuiConstants = vuiConstants;
        }
        /**
         * Creates an array of page definitions for the Edit Port Settings dialog
         */
        DvsPortEditDialogPages.prototype.createPages = function (dialogScope) {
            var pages = [];
            var propertiesPage = {
                title: this.i18nService.getString("NetworkUi", "port.properties.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditPropertiesPage.html",
                onCommit: this.buildPropertiesPageCommitCallback(dialogScope)
            };
            var securityPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.security.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditSecurityPage.html",
                onCommit: function () {
                    return true;
                }
            };
            var vlanPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.vlan.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditVlanPage.html",
                onCommit: this.buildVlanPageCommitCallback(dialogScope)
            };
            var trafficShapingPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.shaping.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditTrafficShapingPage.html",
                onCommit: this.buildTrafficShapingPageCommitCallback(dialogScope)
            };
            var failoverPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.failover.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditFailoverPage.html",
                onCommit: this.buildTeamingAndFailoverCommitCallback(dialogScope)
            };
            var monitoringPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.monitoring.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditMonitoringPage.html",
                onCommit: function () {
                    return true;
                }
            };
            var miscellaneousPage = {
                title: this.i18nService.getString("NetworkUi", "dvpg.policy.misc.title"),
                contentUrl: "dvs-ui/resources/dvs/ports/edit/views/dvsPortEditMiscellaneousPage.html",
                onCommit: function () {
                    return true;
                }
            };
            pages.push(propertiesPage);
            pages.push(vlanPage);
            if (!dialogScope.model.isUplink) {
                pages.splice(1, 0, securityPage, trafficShapingPage);
                pages.push(failoverPage);
            }
            if (dialogScope.model.monitoringPage
                && dialogScope.model.monitoringPage.monitoringPolicy
                && dialogScope.model.monitoringPage.monitoringPolicy.ipfixSupported) {
                pages.push(monitoringPage);
            }
            pages.push(miscellaneousPage);
            return pages;
        };
        DvsPortEditDialogPages.prototype.buildPropertiesPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                if (!dialogScope.model.propertiesPage) {
                    return true;
                }
                var errors = _this.dvsPortEditPropertiesPageValidator
                    .getErrors(dialogScope.model.propertiesPage);
                if (errors && errors.length > 0) {
                    _this.showDialogErrors(dialogScope, errors);
                    return false;
                }
                return true;
            };
        };
        DvsPortEditDialogPages.prototype.buildVlanPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                if (!dialogScope.model.vlanPage
                    || !dialogScope.model.vlanPage.overrideOptions
                    || !dialogScope.model.vlanPage.overrideOptions.overrideVlan) {
                    return true;
                }
                return _this.dvsPortEditVlanPageValidator.getValidationError(dialogScope.model.portDvsUrn, dialogScope.model.vlanPage.vlanPolicy)
                    .then(function (errors) {
                    if (errors && errors.length > 0) {
                        _this.showDialogErrors(dialogScope, errors);
                        return false;
                    }
                    return true;
                });
            };
        };
        DvsPortEditDialogPages.prototype.buildTrafficShapingPageCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                if (!dialogScope.model.trafficShapingPage
                    || dialogScope.model.trafficShapingPage.shouldSkipValidation()) {
                    return true;
                }
                var errors = _this.dvpgTrafficShapingPolicyService.getErrorMessages(dialogScope.model.trafficShapingPage.trafficShapingPolicy.inShapingPolicy, dialogScope.model.trafficShapingPage.trafficShapingPolicy.outShapingPolicy);
                if (errors && errors.length > 0) {
                    _this.showDialogErrors(dialogScope, errors);
                    return false;
                }
                return true;
            };
        };
        DvsPortEditDialogPages.prototype.buildTeamingAndFailoverCommitCallback = function (dialogScope) {
            var _this = this;
            return function () {
                if (!dialogScope.model.failoverPolicyPage
                    || dialogScope.model.failoverPolicyPage.shouldSkipValidation()) {
                    return true;
                }
                if (_this.dvpgFailoverPolicyPageService.shouldShowErrorWarningDialog(dialogScope.model.failoverPolicyPage.failoverOrder.connectees, dialogScope.model.failoverPolicyPage.failoverPolicy.loadBalancing, dialogScope.model.failoverPolicyPage.failoverPolicy.beaconProbing, dialogScope.model.failoverPolicyPage.overrideOptions)) {
                    return _this.dvpgFailoverPolicyPageService.showErrorWarningDialog(dialogScope.model.failoverPolicyPage.failoverOrder.connectees, dialogScope.model.failoverPolicyPage.failoverPolicy.loadBalancing, dialogScope.model.failoverPolicyPage.failoverPolicy.beaconProbing, dialogScope.model.failoverPolicyPage.overrideOptions);
                }
                return true;
            };
        };
        DvsPortEditDialogPages.prototype.showDialogErrors = function (dialogScope, errors) {
            var _this = this;
            dialogScope.dialogOptions.validationBanner.messages = _.map(errors, function (message) {
                return {
                    type: _this.vuiConstants.validationBanner.type.ERROR,
                    text: message
                };
            });
        };
        DvsPortEditDialogPages.$inject = [
            "i18nService",
            "dvsPortEditVlanPageValidator",
            "dvsPortEditPropertiesPageValidator",
            "dvpgTrafficShapingPolicyService",
            "dvpgFailoverPolicyPageService",
            "vuiConstants"
        ];
        return DvsPortEditDialogPages;
    }());
    dvs_ui.DvsPortEditDialogPages = DvsPortEditDialogPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortEditDialogPages", DvsPortEditDialogPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditDialogService = (function () {
        function DvsPortEditDialogService($rootScope, vxMultiPageDialogService, i18nService, dataService, mutationService, dvsPortEditDialogPages, defaultUriSchemeUtil, dvsPortEditDialogSpecFactory, dvpgFailoverPolicyPageService) {
            this.$rootScope = $rootScope;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.dvsPortEditDialogPages = dvsPortEditDialogPages;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dvsPortEditDialogSpecFactory = dvsPortEditDialogSpecFactory;
            this.dvpgFailoverPolicyPageService = dvpgFailoverPolicyPageService;
        }
        /**
         * Shows the Edit Port Settings dialog
         */
        DvsPortEditDialogService.prototype.show = function (portContextUrn, selectedPort, isPortgoupContext, dSwitchMor) {
            var _this = this;
            var dialogScope = this.$rootScope.$new();
            dialogScope.portContextUrn = portContextUrn;
            dialogScope.isPortgoupContext = isPortgoupContext;
            dialogScope.selectedPort = selectedPort;
            dialogScope.model = new dvs_ui.DvsPortEditDialogModel();
            dialogScope.model.portId = selectedPort.portId;
            dialogScope.dialogOptions = this.createDialogOptions();
            dialogScope.dialogOptions.confirmOptions = {
                onClick: function () {
                    _this.submitDialog(dialogScope.model, dialogScope.initialModel);
                    return true;
                }
            };
            var options = {
                scope: dialogScope,
                configObjectName: "dialogOptions"
            };
            this.vxMultiPageDialogService(options);
            this.requestData(dialogScope, dSwitchMor);
        };
        DvsPortEditDialogService.prototype.requestData = function (dialogScope, dSwitchUri) {
            var _this = this;
            var portEditProperty = dialogScope.isPortgoupContext
                ? dvs_ui.DvsPortEditDialogConstants.DATA_DVPG_PROPERTY
                : dvs_ui.DvsPortEditDialogConstants.DATA_DVS_PROPERTY;
            var portPromise;
            if (dialogScope.isPortgoupContext) {
                portPromise = this.dataService.getProperties(dialogScope.portContextUrn, [portEditProperty], {
                    propertyParams: [{
                            propertyName: portEditProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                dSwitchUri: dSwitchUri,
                                portId: dialogScope.selectedPort.portId
                            }
                        }]
                });
            }
            else {
                portPromise = this.dataService.getProperties(dialogScope.portContextUrn, [portEditProperty], {
                    propertyParams: [{
                            propertyName: portEditProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: dialogScope.selectedPort.portgroupKey,
                                portId: dialogScope.selectedPort.portId
                            }
                        }]
                });
            }
            portPromise.then(function (dataServiceResponse) {
                if (dataServiceResponse && dataServiceResponse[portEditProperty]) {
                    var data = dataServiceResponse[portEditProperty];
                    dialogScope.initialModel = angular.copy(data);
                    dialogScope.model.propertiesPage =
                        new dvs_ui.DvsPortEditPropertiesPageModel(data.properties);
                    dialogScope.model.portDvsUrn =
                        _this.defaultUriSchemeUtil.getVsphereObjectId(data.switchRef);
                    dialogScope.model.isUplink = data.isUplink;
                    dialogScope.model.isLag = data.isLag;
                    dialogScope.model.configVersion = data.configVersion;
                    dialogScope.model.securityPage =
                        new dvs_ui.DvsPortEditSecurityPageModel(data.securityPolicy);
                    dialogScope.model.vlanPage = new dvs_ui.DvsPortEditVlanPageModel(data.vlanPolicy);
                    dialogScope.model.trafficShapingPage =
                        new dvs_ui.DvsPortEditTrafficShapingPageModel(data.trafficShapingPolicy);
                    dialogScope.model.failoverPolicyPage =
                        _this.assignFailoverPolicies(data.failoverPolicy);
                    dialogScope.model.monitoringPage =
                        new dvs_ui.DvsPortEditMonitoringPageModel(data.monitoringPolicy);
                    dialogScope.model.miscellaneousPage =
                        new dvs_ui.DvsPortEditMiscellaneousPageModel(data.miscPolicy);
                    dialogScope.model.dvPortgroupPortProperties = data.dvPortgroupPortProperties;
                    dialogScope.dialogOptions.title = _this.i18nService
                        .getString("NetworkUi", "port.settings.title", dialogScope.selectedPort.portId, data.switchName);
                    dialogScope.dialogOptions.pages =
                        _this.dvsPortEditDialogPages.createPages(dialogScope);
                    dialogScope.dialogOptions.loading = false;
                }
            });
        };
        DvsPortEditDialogService.prototype.assignFailoverPolicies = function (failoverPolicyModel) {
            if (!failoverPolicyModel) {
                return null;
            }
            var failoverOrder = this.dvpgFailoverPolicyPageService
                .createFailoverOrderSettings(failoverPolicyModel.failoverOrder);
            return new dvs_ui.DvsPortEditFailoverPageModel(failoverPolicyModel, failoverOrder);
        };
        DvsPortEditDialogService.prototype.createDialogOptions = function () {
            return {
                title: this.i18nService.getString("NetworkUi", "port.settings.initialTitle"),
                show: true,
                loading: true,
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                validationBanner: {},
                rejectOptions: {
                    rejectOnEsc: true
                },
                resizable: true,
                draggable: true,
                height: "640px",
                width: "960px",
                maximizable: true
            };
        };
        DvsPortEditDialogService.prototype.submitDialog = function (dialogModel, initialDialogModel) {
            var data = this.dvsPortEditDialogSpecFactory.buildSpec(dialogModel, initialDialogModel);
            if (data) {
                this.mutationService.apply(dialogModel.portDvsUrn, data._type, data);
            }
        };
        DvsPortEditDialogService.$inject = [
            "$rootScope",
            "vxMultiPageDialogService",
            "i18nService",
            "dataService",
            "mutationService",
            "dvsPortEditDialogPages",
            "defaultUriSchemeUtil",
            "dvsPortEditDialogSpecFactory",
            "dvpgFailoverPolicyPageService"
        ];
        return DvsPortEditDialogService;
    }());
    dvs_ui.DvsPortEditDialogService = DvsPortEditDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortEditDialogService", DvsPortEditDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PortConfigSpec = com.vmware.vim.binding.vim.dvs.DistributedVirtualPort$ConfigSpec;
    var VmwarePortConfigPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$VmwarePortConfigPolicy;
    var SecurityPolicy = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$SecurityPolicy;
    var BoolPolicy = com.vmware.vim.binding.vim.BoolPolicy;
    var StringPolicy = com.vmware.vim.binding.vim.StringPolicy;
    var DvsPortEditDialogSpecFactory = (function () {
        function DvsPortEditDialogSpecFactory(i18nService, dvpgSpecFactory) {
            this.i18nService = i18nService;
            this.dvpgSpecFactory = dvpgSpecFactory;
        }
        DvsPortEditDialogSpecFactory.prototype.buildSpec = function (pageData, initialData) {
            if (!initialData || !pageData || !pageData.dvPortgroupPortProperties) {
                return null;
            }
            // properties changes
            var hasPropertyChanges = pageData.propertiesPage
                && pageData.propertiesPage.isPropertiesPageChanged(initialData.properties);
            // settings changes
            var hasSecurityChanges = pageData.securityPage && !pageData.isUplink
                && pageData.dvPortgroupPortProperties.securityPolicyOverrideAllowed
                && pageData.securityPage.isSecurityPageChanged(initialData.securityPolicy);
            var hasVlanChanges = pageData.vlanPage
                && pageData.dvPortgroupPortProperties.vlanOverrideAllowed
                && pageData.vlanPage.isVlanPageChanged(initialData.vlanPolicy);
            var hasTrafficShapingChanges = pageData.trafficShapingPage
                && pageData.dvPortgroupPortProperties.shapingOverrideAllowed
                && pageData.trafficShapingPage.isTrafficShapingPageChanged(initialData.trafficShapingPolicy);
            var hasFailoverChanges = pageData.failoverPolicyPage
                && pageData.dvPortgroupPortProperties.uplinkTeamingOverrideAllowed
                && pageData.failoverPolicyPage.isFailoverPageChanged(initialData.failoverPolicy);
            var hasMonitoringChanges = pageData.monitoringPage
                && pageData.dvPortgroupPortProperties.ipfixOverrideAllowed
                && pageData.monitoringPage.isMonitoringPageChanged(initialData.monitoringPolicy);
            var hasMiscellaneousChanges = pageData.miscellaneousPage
                && pageData.dvPortgroupPortProperties.blockOverrideAllowed
                && pageData.miscellaneousPage.isMiscellaneousPageChanged(initialData.miscPolicy);
            var hasNetworkResourcePoolChange = pageData.propertiesPage
                && pageData.dvPortgroupPortProperties.networkResourcePoolOverrideAllowed
                && pageData.propertiesPage.isResourcePoolChanged(initialData.properties);
            var hasSettingsChanges = hasSecurityChanges || hasVlanChanges
                || hasTrafficShapingChanges || hasFailoverChanges || hasMonitoringChanges
                || hasMiscellaneousChanges || hasNetworkResourcePoolChange;
            if (!hasPropertyChanges && !hasSettingsChanges) {
                return null;
            }
            var portConfigSpec = new PortConfigSpec();
            portConfigSpec.key = pageData.portId;
            portConfigSpec.configVersion = pageData.configVersion;
            portConfigSpec.operation = dvs_ui.DvsPortEditDialogConstants.EDIT_OPERATION;
            if (hasPropertyChanges) {
                if (pageData.propertiesPage.name !== initialData.properties.name) {
                    portConfigSpec.name = pageData.propertiesPage.name;
                }
                if (pageData.propertiesPage.description !== initialData.properties.description) {
                    portConfigSpec.description = pageData.propertiesPage.description;
                }
            }
            var settingsPolicy = new VmwarePortConfigPolicy();
            if (hasNetworkResourcePoolChange) {
                settingsPolicy.networkResourcePoolKey = this.buildNetworkResourcePoolPolicy(pageData.propertiesPage.selectedResourcePool);
            }
            if (hasSecurityChanges) {
                settingsPolicy.securityPolicy =
                    this.buildSecurityPolicy(initialData.securityPolicy, pageData);
            }
            if (hasVlanChanges) {
                settingsPolicy.vlan = this.buildVlanPolicy(pageData.vlanPage);
            }
            if (hasTrafficShapingChanges
                && pageData.trafficShapingPage.trafficShapingPolicy
                && pageData.trafficShapingPage.overrideOptions) {
                settingsPolicy.inShapingPolicy = this.dvpgSpecFactory.buildTrafficShapingSpecPort(pageData.trafficShapingPage.trafficShapingPolicy.inShapingPolicy /*policy*/, !pageData.trafficShapingPage.overrideOptions.inShapingPolicy /*inherited*/);
                settingsPolicy.outShapingPolicy = this.dvpgSpecFactory.buildTrafficShapingSpecPort(pageData.trafficShapingPage.trafficShapingPolicy.outShapingPolicy /*policy*/, !pageData.trafficShapingPage.overrideOptions.outShapingPolicy /*inherited*/);
            }
            if (hasFailoverChanges) {
                settingsPolicy.uplinkTeamingPolicy =
                    this.dvpgSpecFactory.buildTeamingAndFailoverPortSpec(pageData.failoverPolicyPage.failoverPolicy, pageData.failoverPolicyPage.overrideOptions);
            }
            if (hasMonitoringChanges) {
                settingsPolicy.ipfixEnabled = this.buildBoolPolicy(pageData.monitoringPage.monitoringPolicy.ipfixEnabled, pageData.monitoringPage.monitoringPolicy.ipfixOverrided);
            }
            if (hasMiscellaneousChanges) {
                settingsPolicy.blocked = this.buildBoolPolicy(pageData.miscellaneousPage.policy.arePortsBlocked, pageData.miscellaneousPage.policy.blockPortsOverrided);
            }
            if (hasSettingsChanges) {
                portConfigSpec.setting = settingsPolicy;
            }
            return portConfigSpec;
        };
        DvsPortEditDialogSpecFactory.prototype.buildNetworkResourcePoolPolicy = function (networkResourcePool) {
            var networkResourcePoolPolicy = new StringPolicy();
            networkResourcePoolPolicy.value = networkResourcePool.key;
            networkResourcePoolPolicy.inherited = !networkResourcePool.overrided;
            return networkResourcePoolPolicy;
        };
        DvsPortEditDialogSpecFactory.prototype.buildSecurityPolicy = function (initialSecurityPolicy, pageData) {
            var securityPolicy = new SecurityPolicy();
            securityPolicy.inherited = pageData.securityPage.isInherited();
            if (pageData.securityPage.policyValues && pageData.securityPage.overrideOptions) {
                if (pageData.securityPage.isPolicyChanged(initialSecurityPolicy.allowPromiscuous, dvs_ui.DvsPortEditDialogConstants.POLICY_ALLOW_PROMISCUOUS)) {
                    securityPolicy.allowPromiscuous = this.buildBoolPolicy(pageData.securityPage.policyValues.allowPromiscuous, pageData.securityPage.overrideOptions.allowPromiscuous);
                }
                if (pageData.securityPage.isPolicyChanged(initialSecurityPolicy.macChanges, dvs_ui.DvsPortEditDialogConstants.POLICY_MAC_CHANGES)) {
                    securityPolicy.macChanges = this.buildBoolPolicy(pageData.securityPage.policyValues.macChanges, pageData.securityPage.overrideOptions.macChanges);
                }
                if (pageData.securityPage.isPolicyChanged(initialSecurityPolicy.forgedTransmits, dvs_ui.DvsPortEditDialogConstants.POLICY_FORGET_TRANSMITS)) {
                    securityPolicy.forgedTransmits = this.buildBoolPolicy(pageData.securityPage.policyValues.forgedTransmits, pageData.securityPage.overrideOptions.forgedTransmits);
                }
            }
            return securityPolicy;
        };
        DvsPortEditDialogSpecFactory.prototype.buildVlanPolicy = function (vlanData) {
            var vlanSpec = this.dvpgSpecFactory.buildVlanSpec(vlanData.vlanPolicy);
            vlanSpec.inherited = vlanData.overrideOptions
                && !vlanData.overrideOptions.overrideVlan;
            return vlanSpec;
        };
        DvsPortEditDialogSpecFactory.prototype.buildBoolPolicy = function (value, isOverridden) {
            var policy = new BoolPolicy();
            policy.inherited = !isOverridden;
            policy.value = value;
            return policy;
        };
        DvsPortEditDialogSpecFactory.$inject = [
            "i18nService",
            "dvpgSpecFactory"
        ];
        return DvsPortEditDialogSpecFactory;
    }());
    dvs_ui.DvsPortEditDialogSpecFactory = DvsPortEditDialogSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortEditDialogSpecFactory", DvsPortEditDialogSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditDialogModel = (function () {
        function DvsPortEditDialogModel() {
        }
        return DvsPortEditDialogModel;
    }());
    dvs_ui.DvsPortEditDialogModel = DvsPortEditDialogModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditFailoverPageModel = (function () {
        function DvsPortEditFailoverPageModel(failoverPolicy, failoverOrder) {
            if (failoverPolicy && failoverOrder) {
                this.failoverPolicy = failoverPolicy;
                this.failoverOrder = failoverOrder;
                this.overrideOptions = failoverPolicy.overrideOptions;
                this.isFailoverPageChanged = this.isFailoverPageChangedFunction.bind(this);
                this.shouldSkipValidation = this.shouldSkipValidationFunction.bind(this);
            }
        }
        DvsPortEditFailoverPageModel.prototype.isFailoverPageChangedFunction = function (initialData) {
            if (!initialData || !this.overrideOptions || !this.failoverPolicy) {
                return false;
            }
            return !_.isEqual(initialData.overrideOptions, this.overrideOptions)
                || !_.isEqual(initialData, this.failoverPolicy);
        };
        DvsPortEditFailoverPageModel.prototype.shouldSkipValidationFunction = function () {
            if (!this.overrideOptions) {
                return true;
            }
            for (var prop in this.overrideOptions) {
                if (this.overrideOptions[prop]) {
                    return false;
                }
            }
            return true;
        };
        return DvsPortEditFailoverPageModel;
    }());
    dvs_ui.DvsPortEditFailoverPageModel = DvsPortEditFailoverPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditMiscellaneousPageModel = (function () {
        function DvsPortEditMiscellaneousPageModel(miscellaneousPolicy) {
            if (miscellaneousPolicy) {
                this.policy = miscellaneousPolicy;
                this.isMiscellaneousPageChanged =
                    this.isMiscellaneousPageChangedFunction.bind(this);
            }
        }
        DvsPortEditMiscellaneousPageModel.prototype.isMiscellaneousPageChangedFunction = function (initialData) {
            if (!initialData || !this.policy) {
                return false;
            }
            return initialData.blockPortsOverrided !== this.policy.blockPortsOverrided
                || initialData.arePortsBlocked !== this.policy.arePortsBlocked;
        };
        return DvsPortEditMiscellaneousPageModel;
    }());
    dvs_ui.DvsPortEditMiscellaneousPageModel = DvsPortEditMiscellaneousPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditMonitoringPageModel = (function () {
        function DvsPortEditMonitoringPageModel(monitoringPolicy) {
            if (monitoringPolicy) {
                this.monitoringPolicy = monitoringPolicy;
                this.isMonitoringPageChanged =
                    this.isMonitoringPageChangedFunction.bind(this);
            }
        }
        DvsPortEditMonitoringPageModel.prototype.isMonitoringPageChangedFunction = function (initialData) {
            if (!initialData || !this.monitoringPolicy) {
                return false;
            }
            return initialData.ipfixOverrided !== this.monitoringPolicy.ipfixOverrided
                || initialData.ipfixEnabled !== this.monitoringPolicy.ipfixEnabled;
        };
        return DvsPortEditMonitoringPageModel;
    }());
    dvs_ui.DvsPortEditMonitoringPageModel = DvsPortEditMonitoringPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditPropertiesPageModel = (function () {
        function DvsPortEditPropertiesPageModel(portProperties) {
            if (portProperties) {
                this.name = portProperties.name;
                this.description = portProperties.description;
                if (portProperties.networkResourcePools
                    && portProperties.networkResourcePools.length) {
                    this.selectedResourcePool = portProperties.selectedResourcePool;
                    this.networkResourcePools = portProperties.networkResourcePools;
                }
                this.isPropertiesPageChanged = this.isPropertiesPageChangedFunction.bind(this);
                this.isResourcePoolChanged = this.isResourcePoolChangedFunction.bind(this);
            }
        }
        DvsPortEditPropertiesPageModel.prototype.isResourcePoolChangedFunction = function (initialData) {
            if (!initialData || !this.selectedResourcePool) {
                return false;
            }
            return !_.isEqual(this.selectedResourcePool, initialData.selectedResourcePool);
        };
        DvsPortEditPropertiesPageModel.prototype.isPropertiesPageChangedFunction = function (initialData) {
            if (!initialData) {
                return false;
            }
            return this.name !== initialData.name
                || this.description !== initialData.description;
        };
        return DvsPortEditPropertiesPageModel;
    }());
    dvs_ui.DvsPortEditPropertiesPageModel = DvsPortEditPropertiesPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditSecurityPageModel = (function () {
        function DvsPortEditSecurityPageModel(securityPolicy) {
            if (securityPolicy) {
                this.overrideOptions =
                    _.mapObject(securityPolicy, function (val) {
                        return !val.inherited;
                    });
                this.policyValues =
                    _.mapObject(securityPolicy, function (val) {
                        return val.value;
                    });
                this.isInherited = this.isInheritedFunction.bind(this);
                this.isSecurityPageChanged = this.isSecurityPageChangedFunction.bind(this);
                this.isPolicyChanged = this.isPolicyChangedFunction.bind(this);
            }
        }
        // returns true if the all page policies should be inherited from the portgroup
        DvsPortEditSecurityPageModel.prototype.isInheritedFunction = function () {
            if (!this.overrideOptions) {
                return true;
            }
            return !this.overrideOptions.macChanges
                && !this.overrideOptions.allowPromiscuous
                && !this.overrideOptions.forgedTransmits;
        };
        DvsPortEditSecurityPageModel.prototype.isSecurityPageChangedFunction = function (initialData) {
            if (!initialData) {
                return false;
            }
            return this.isPolicyChanged(initialData.allowPromiscuous, dvs_ui.DvsPortEditDialogConstants.POLICY_ALLOW_PROMISCUOUS)
                || this.isPolicyChanged(initialData.macChanges, dvs_ui.DvsPortEditDialogConstants.POLICY_MAC_CHANGES)
                || this.isPolicyChanged(initialData.forgedTransmits, dvs_ui.DvsPortEditDialogConstants.POLICY_FORGET_TRANSMITS);
        };
        // returns true if the page settings of a given policy differ
        // from the page settings for that policy
        DvsPortEditSecurityPageModel.prototype.isPolicyChangedFunction = function (policy, policyType) {
            if (!policy || !this.overrideOptions || !this.policyValues) {
                return false;
            }
            switch (policyType) {
                case dvs_ui.DvsPortEditDialogConstants.POLICY_ALLOW_PROMISCUOUS:
                    return this.overrideOptions.allowPromiscuous === policy.inherited
                        || this.policyValues.allowPromiscuous !== policy.value;
                case dvs_ui.DvsPortEditDialogConstants.POLICY_FORGET_TRANSMITS:
                    return this.overrideOptions.forgedTransmits === policy.inherited
                        || this.policyValues.forgedTransmits !== policy.value;
                case dvs_ui.DvsPortEditDialogConstants.POLICY_MAC_CHANGES:
                    return this.overrideOptions.macChanges === policy.inherited
                        || this.policyValues.macChanges !== policy.value;
            }
            return false;
        };
        return DvsPortEditSecurityPageModel;
    }());
    dvs_ui.DvsPortEditSecurityPageModel = DvsPortEditSecurityPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditTrafficShapingPageModel = (function () {
        function DvsPortEditTrafficShapingPageModel(trafficShapingPolicy) {
            if (trafficShapingPolicy) {
                this.trafficShapingPolicy = trafficShapingPolicy;
                this.overrideOptions = {
                    inShapingPolicy: trafficShapingPolicy.inShapingOverrided,
                    outShapingPolicy: trafficShapingPolicy.outShapingOverrided
                };
                this.isTrafficShapingPageChanged =
                    this.isTrafficShapingPageChangedFunction.bind(this);
                this.shouldSkipValidation =
                    this.shouldSkipValidationFunction.bind(this);
            }
        }
        DvsPortEditTrafficShapingPageModel.prototype.isTrafficShapingPageChangedFunction = function (initialData) {
            if (!initialData) {
                return false;
            }
            return initialData.inShapingOverrided !== this.overrideOptions.inShapingPolicy
                || initialData.outShapingOverrided !== this.overrideOptions.outShapingPolicy
                || !_.isEqual(initialData, this.trafficShapingPolicy);
        };
        DvsPortEditTrafficShapingPageModel.prototype.shouldSkipValidationFunction = function () {
            return !this.overrideOptions || !this.trafficShapingPolicy
                || (!this.overrideOptions.inShapingPolicy
                    && !this.overrideOptions.outShapingPolicy);
        };
        return DvsPortEditTrafficShapingPageModel;
    }());
    dvs_ui.DvsPortEditTrafficShapingPageModel = DvsPortEditTrafficShapingPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditVlanPageModel = (function () {
        function DvsPortEditVlanPageModel(vlanPolicy) {
            if (vlanPolicy) {
                this.vlanPolicy = vlanPolicy;
                this.overrideOptions = {
                    overrideVlan: vlanPolicy.isVlanPolicyOverrided
                };
                this.isVlanPageChanged = this.isVlanPageChangedFunction.bind(this);
            }
        }
        DvsPortEditVlanPageModel.prototype.isVlanPageChangedFunction = function (initialData) {
            if (!initialData) {
                return false;
            }
            return initialData.isVlanPolicyOverrided !== this.overrideOptions.overrideVlan
                || !_.isEqual(initialData, this.vlanPolicy);
        };
        return DvsPortEditVlanPageModel;
    }());
    dvs_ui.DvsPortEditVlanPageModel = DvsPortEditVlanPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortEditPropertiesPageValidator = (function () {
        function DvsPortEditPropertiesPageValidator(i18nService, networkUtil) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
        }
        DvsPortEditPropertiesPageValidator.prototype.getErrors = function (propetriesData) {
            var errors = [];
            if (!propetriesData) {
                return errors;
            }
            var nameError = this.getNameError(propetriesData.name);
            var descriptionError = this.getDescriptionError(propetriesData.description);
            if (nameError) {
                errors.push(nameError);
            }
            if (descriptionError) {
                errors.push(descriptionError);
            }
            return errors;
        };
        DvsPortEditPropertiesPageValidator.prototype.getNameError = function (portName) {
            if (portName && this.networkUtil.getStringLengthInUtf8Bytes(portName) >
                dvs_ui.DvsPortEditDialogConstants.NAME_MAX_BYTE_LENGTH) {
                return this.i18nService.getString("DvsUi", "portEdit.propertiesPage.name.error");
            }
            return "";
        };
        DvsPortEditPropertiesPageValidator.prototype.getDescriptionError = function (portDescription) {
            if (portDescription && portDescription.length >
                dvs_ui.DvsPortEditDialogConstants.DESCRIPTION_MAX_CHAR_LENGTH) {
                return this.i18nService.getString("DvsUi", "portEdit.propertiesPage.description.error");
            }
            return "";
        };
        DvsPortEditPropertiesPageValidator.$inject = [
            "i18nService",
            "networkUtil"
        ];
        return DvsPortEditPropertiesPageValidator;
    }());
    dvs_ui.DvsPortEditPropertiesPageValidator = DvsPortEditPropertiesPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortEditPropertiesPageValidator", DvsPortEditPropertiesPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortTrunkVlanSpec = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortTrunkVlanSpec;
    var DvsPortEditVlanPageValidator = (function () {
        function DvsPortEditVlanPageValidator($q, i18nService, networkUiConstants, dvpgPropertiesService, dataService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.dvpgPropertiesService = dvpgPropertiesService;
            this.dataService = dataService;
        }
        DvsPortEditVlanPageValidator.prototype.getValidationError = function (dvsPortId, vlanPageModel) {
            var _this = this;
            switch (vlanPageModel.vlanType) {
                case this.networkUiConstants.Vlan.Type.VLAN: {
                    var vlanIdError = this.dvpgPropertiesService.getVlanIdError(vlanPageModel.vlanId);
                    if (vlanIdError) {
                        return this.$q.resolve([vlanIdError]);
                    }
                    break;
                }
                case this.networkUiConstants.Vlan.Type.TRUNK: {
                    if (!vlanPageModel.vlanTrunkRanges) {
                        var vlanRangesError = this.i18nService.getString("DvsUi", "dvpg.policy.vlan.trunk.errorMessage");
                        return this.$q.resolve([vlanRangesError]);
                    }
                    var vlanTrunkSpec = new DvsPortTrunkVlanSpec();
                    vlanTrunkSpec.numericRanges = vlanPageModel.vlanTrunkRanges;
                    var portPromise = this.dataService.getProperties(dvsPortId, [dvs_ui.DvsPortEditDialogConstants.DATA_DVS_VLAN_TRUNK_PROPERTY], {
                        propertyParams: [{
                                propertyName: dvs_ui.DvsPortEditDialogConstants.DATA_DVS_VLAN_TRUNK_PROPERTY,
                                parameterType: vlanTrunkSpec._type,
                                parameter: vlanTrunkSpec
                            }]
                    });
                    return portPromise.then(function (trunkRanges) {
                        if (!trunkRanges
                            || !trunkRanges[dvs_ui.DvsPortEditDialogConstants.DATA_DVS_VLAN_TRUNK_PROPERTY]) {
                            var vlanRangesError = _this.i18nService.getString("DvsUi", "dvpg.policy.vlan.trunk.errorMessage");
                            return [vlanRangesError];
                        }
                        vlanPageModel.vlanTrunkNumericRanges =
                            trunkRanges[dvs_ui.DvsPortEditDialogConstants.DATA_DVS_VLAN_TRUNK_PROPERTY];
                        return _this.$q.resolve([]);
                    }, function () {
                        return null;
                    });
                }
                case this.networkUiConstants.Vlan.Type.PRIVATE: {
                    if (!vlanPageModel.pvlanConfig ||
                        vlanPageModel.pvlanConfig.length === 0) {
                        var pvlanError = this.i18nService.getString("DvsUi", "dvpg.policy.vlan.private.noConfig");
                        return this.$q.resolve([pvlanError]);
                    }
                    break;
                }
            }
            return this.$q.resolve([]);
        };
        DvsPortEditVlanPageValidator.$inject = [
            "$q",
            "i18nService",
            "networkUiConstants",
            "dvpgPropertiesService",
            "dataService"];
        return DvsPortEditVlanPageValidator;
    }());
    dvs_ui.DvsPortEditVlanPageValidator = DvsPortEditVlanPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortEditVlanPageValidator", DvsPortEditVlanPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortNetworkConnectionComponent = (function () {
        function DvsPortNetworkConnectionComponent() {
            this.bindings = {
                selectedPort: "<"
            };
            this.controller = DvsPortNetworkConnectionController;
            this.templateUrl =
                "dvs-ui/resources/dvs/ports/networkConnection/dvsPortNetworkConnectionViewTemplate.html";
        }
        return DvsPortNetworkConnectionComponent;
    }());
    dvs_ui.DvsPortNetworkConnectionComponent = DvsPortNetworkConnectionComponent;
    var DvsPortNetworkConnectionController = (function () {
        function DvsPortNetworkConnectionController($scope, i18nService, dvsPortsService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dvsPortsService = dvsPortsService;
            this.i18n = this.i18nService.getString;
        }
        DvsPortNetworkConnectionController.prototype.$onChanges = function () {
            this.refresh(this.selectedPort);
        };
        DvsPortNetworkConnectionController.prototype.refresh = function (selectedPort) {
            this.dvsPortNetworkConnectionData =
                this.dvsPortsService.buildDvsPortNetworkConnectionPropertiesView(selectedPort);
        };
        DvsPortNetworkConnectionController.$inject = [
            "$scope",
            "i18nService",
            "dvsPortsService"
        ];
        return DvsPortNetworkConnectionController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortNetworkConnectionView", new DvsPortNetworkConnectionComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortPoliciesComponent = (function () {
        function DvsPortPoliciesComponent() {
            this.bindings = {
                selectedPort: "<",
                portContextId: "<",
                isPortGroupContext: "<"
            };
            this.controller = DvsPortPoliciesController;
            this.templateUrl =
                "dvs-ui/resources/dvs/ports/policies/dvsPortPoliciesViewTemplate.html";
        }
        return DvsPortPoliciesComponent;
    }());
    dvs_ui.DvsPortPoliciesComponent = DvsPortPoliciesComponent;
    var DvsPortPoliciesController = (function () {
        function DvsPortPoliciesController($scope, i18nService, dataService, distributedPortgroupPoliciesViewService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.distributedPortgroupPoliciesViewService = distributedPortgroupPoliciesViewService;
            this.i18n = this.i18nService.getString;
        }
        DvsPortPoliciesController.prototype.$onChanges = function () {
            this.refresh(this.selectedPort);
        };
        DvsPortPoliciesController.prototype.refresh = function (selectedPort) {
            var _this = this;
            if (!selectedPort) {
                return;
            }
            this.portsLoading = true;
            var dvsPromise;
            var portsDataProperty = this.isPortGroupContext
                ? DvsPortPoliciesController.DVPG_PORTS_POLICIES_DATA_PROPERTY_NAME
                : DvsPortPoliciesController.DVS_PORTS_POLICIES_DATA_PROPERTY_NAME;
            if (this.isPortGroupContext) {
                dvsPromise = this.dataService.getProperties(this.portContextId, [portsDataProperty], {
                    propertyParams: [{
                            propertyName: portsDataProperty,
                            parameterType: "java.lang.String",
                            parameter: selectedPort.portId
                        }]
                });
            }
            else {
                dvsPromise = this.dataService.getProperties(this.portContextId, [portsDataProperty], {
                    propertyParams: [{
                            propertyName: portsDataProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: selectedPort.portgroupKey,
                                portId: selectedPort.portId
                            }
                        }]
                });
            }
            this._currentDvsPromise = dvsPromise;
            dvsPromise.then(function (dataServiceResponse) {
                if (_this._currentDvsPromise === dvsPromise
                    && dataServiceResponse[portsDataProperty]) {
                    _this.dvsPortPoliciesData =
                        _this.distributedPortgroupPoliciesViewService
                            .buildDistributedPortPoliciesView(dataServiceResponse[portsDataProperty]);
                }
            }).finally(function () {
                _this.portsLoading = false;
            });
        };
        DvsPortPoliciesController.DVS_PORTS_POLICIES_DATA_PROPERTY_NAME = "dvsport:portPoliciesData";
        DvsPortPoliciesController.DVPG_PORTS_POLICIES_DATA_PROPERTY_NAME = "dvportgroupport:portPoliciesData";
        DvsPortPoliciesController.$inject = [
            "$scope",
            "i18nService",
            "dataService",
            "distributedPortgroupPoliciesViewService"
        ];
        return DvsPortPoliciesController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortPoliciesView", new DvsPortPoliciesComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortStatisticsComponent = (function () {
        function DvsPortStatisticsComponent() {
            this.bindings = {
                selectedPort: "<",
                portContextId: "<",
                isPortGroupContext: "<"
            };
            this.controller = DvsPortStatisticsController;
            this.templateUrl =
                "dvs-ui/resources/dvs/ports/statistics/dvsPortStatisticsViewTemplate.html";
        }
        return DvsPortStatisticsComponent;
    }());
    dvs_ui.DvsPortStatisticsComponent = DvsPortStatisticsComponent;
    var DvsPortStatisticsController = (function () {
        function DvsPortStatisticsController($scope, i18nService, dataService, vxPropertyViewService, dvsPortStatisticsService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.dvsPortStatisticsService = dvsPortStatisticsService;
            this.PORT_STATISTICS_PROPERTY = "dvsport:portStatisticsData";
            this.DVPG_PORT_STATISTICS_PROPERTY = "dvpgport:portStatisticsData";
            this.REFRESH_PORT_STATISTICS_PROPERTY = "dvsports:refreshedPortsData";
            this.DVPG_REFRESH_PORT_STATISTICS_PROPERTY = "dvpgports:refreshedPortsData";
            this.REFRESH_STATISTICS_TIMEOUT = 2000;
            this.i18n = this.i18nService.getString;
            this.refreshStatistics = false;
        }
        DvsPortStatisticsController.prototype.$onChanges = function () {
            this.refresh(this.selectedPort);
        };
        DvsPortStatisticsController.prototype.$onDestroy = function () {
            this.refreshStatistics = false;
            clearTimeout(this.refreshTimeout);
        };
        DvsPortStatisticsController.prototype.refresh = function (selectedPort) {
            var _this = this;
            clearTimeout(this.refreshTimeout);
            if (!selectedPort) {
                return;
            }
            this.portsLoading = true;
            var statsProperty = this.isPortGroupContext ?
                this.DVPG_PORT_STATISTICS_PROPERTY : this.PORT_STATISTICS_PROPERTY;
            this.dataService.getProperties(this.portContextId, [statsProperty], {
                propertyParams: [{
                        propertyName: statsProperty,
                        parameterType: "java.util.Map",
                        parameter: {
                            portgroupKey: selectedPort.portgroupKey,
                            portId: selectedPort.portId
                        }
                    }]
            }).then(function (dataServiceResponse) {
                if (dataServiceResponse !== null) {
                    _this.dvsPortStatisticsData =
                        _this.dvsPortStatisticsService
                            .buildDistributedPortStatisticsView(dataServiceResponse[statsProperty]);
                }
                if (_this.refreshStatistics) {
                    _this.refreshTimeout = setTimeout(_this.enableRefreshStatistics(), _this.REFRESH_STATISTICS_TIMEOUT);
                }
            }).finally(function () {
                _this.portsLoading = false;
            });
        };
        DvsPortStatisticsController.prototype.enableRefreshStatistics = function () {
            var _this = this;
            if (this.refreshStatistics) {
                var refreshProperty_1 = this.isPortGroupContext ?
                    this.DVPG_REFRESH_PORT_STATISTICS_PROPERTY : this.REFRESH_PORT_STATISTICS_PROPERTY;
                this.dataService.getProperties(this.portContextId, [refreshProperty_1], {
                    propertyParams: [{
                            propertyName: refreshProperty_1,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: this.selectedPort.portgroupKey,
                                portId: this.selectedPort.portId
                            }
                        }]
                }).then(function (dataServiceResponse) {
                    if (dataServiceResponse !== null) {
                        if (dataServiceResponse[refreshProperty_1].isErrorFound) {
                            _this.refreshStatistics = false;
                        }
                        else {
                            _this.dvsPortStatisticsData =
                                _this.dvsPortStatisticsService
                                    .buildDistributedPortStatisticsView(dataServiceResponse[refreshProperty_1]);
                            _this.refreshTimeout = setTimeout(function () { return _this.enableRefreshStatistics(); }, _this.REFRESH_STATISTICS_TIMEOUT);
                        }
                    }
                });
            }
            else {
                clearTimeout(this.refreshTimeout);
            }
        };
        DvsPortStatisticsController.$inject = [
            "$scope",
            "i18nService",
            "dataService",
            "vxPropertyViewService",
            "dvsPortStatisticsService"
        ];
        return DvsPortStatisticsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortStatisticsView", new DvsPortStatisticsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortStatisticsService = (function () {
        function DvsPortStatisticsService(i18nService, vxPropertyViewService, browserLanguage) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.browserLanguage = browserLanguage;
        }
        DvsPortStatisticsService.prototype.buildDistributedPortStatisticsView = function (statistics) {
            var statisticsBuilder = this.vxPropertyViewService.createPropertyViewBuilder();
            var statisticsCategory = statisticsBuilder
                .category("statistics");
            var statisticsSection = statisticsCategory
                .section("statistics")
                .title(this.i18nService.getString("DvsUi", "PortList.statistics.title"));
            if (statistics) {
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesInUnicastHeaderText"), statistics.bytesInUnicast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesOutUnicastHeaderText"), statistics.bytesOutUnicast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesInBroadcastHeaderText"), statistics.bytesInBroadcast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesOutBroadcastnameHeaderText"), statistics.bytesOutBroadcast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesInMulticastHeaderText"), statistics.bytesInMulticast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.bytesOutMulticastHeaderText"), statistics.bytesOutMulticast);
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsInUnicastHeaderText"), this.getLocalizedPacketsValue(statistics.packetsInUnicast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsOutUnicastHeaderText"), this.getLocalizedPacketsValue(statistics.packetsOutUnicast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsInBroadcastHeaderText"), this.getLocalizedPacketsValue(statistics.packetsInBroadcast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsOutBroadcastnameHeaderText"), this.getLocalizedPacketsValue(statistics.packetsOutBroadcast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsInMulticastHeaderText"), this.getLocalizedPacketsValue(statistics.packetsInMulticast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsOutMulticastHeaderText"), this.getLocalizedPacketsValue(statistics.packetsOutMulticast));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsInDroppedHeaderText"), this.getLocalizedPacketsValue(statistics.packetsInDropped));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsOutDroppedHeaderText"), this.getLocalizedPacketsValue(statistics.packetsOutDropped));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsInExceptionHeaderText"), this.getLocalizedPacketsValue(statistics.packetsInException));
                statisticsSection.property(this.i18nService.getString("DvsUi", "PortList.packetsOutExceptionHeaderText"), this.getLocalizedPacketsValue(statistics.packetsOutException));
            }
            return statisticsBuilder.build();
        };
        DvsPortStatisticsService.prototype.getLocalizedPacketsValue = function (packets) {
            if (packets === -1) {
                return this.i18nService.getString("DvsUi", "PortList.noData");
            }
            return packets.toLocaleString(this.browserLanguage.get(), {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            });
        };
        DvsPortStatisticsService.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "browserLanguage"];
        return DvsPortStatisticsService;
    }());
    dvs_ui.DvsPortStatisticsService = DvsPortStatisticsService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortStatisticsService", DvsPortStatisticsService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortTrafficFilterModel = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortTrafficFilterModel;
    var DvsPortTrafficFilterService = (function () {
        function DvsPortTrafficFilterService(i18nService, clarityConstants, trafficFilterConstants, dvpgTrafficFilterService, dvpgTrafficRuleValidator, dvsPortTrafficFilterSpecFactory, clarityModalService, dataService, mutationService, $q) {
            this.i18nService = i18nService;
            this.clarityConstants = clarityConstants;
            this.trafficFilterConstants = trafficFilterConstants;
            this.dvpgTrafficFilterService = dvpgTrafficFilterService;
            this.dvpgTrafficRuleValidator = dvpgTrafficRuleValidator;
            this.dvsPortTrafficFilterSpecFactory = dvsPortTrafficFilterSpecFactory;
            this.clarityModalService = clarityModalService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.$q = $q;
        }
        DvsPortTrafficFilterService.prototype.showPortEditTrafficFilterDialog = function (portContextId, isPortGroupContext, selectedPort) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.rulesDialog.title"),
                subTitle: {
                    objectId: portContextId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/edit/" +
                    "dvpgEditTrafficFilterDialog.html",
                size: "lg",
                modalClass: "edit-traffic-filter-dialog",
                dialogData: {
                    objectId: selectedPort.portId,
                    model: new dvs_ui.DvpgEditTrafficFilterModel()
                },
                onSubmit: function () {
                    var isRulesOrderChanged = _this.dvpgTrafficFilterService.isRuleOrderChanged(modalOptions.dialogData.model.rules, modalOptions.dialogData.model.originalRulesKeys);
                    var isRulsetEnabledChanged = modalOptions.dialogData.model.initialTrafficRulesetEnabled !==
                        modalOptions.dialogData.model.isTrafficRulesetEnabled;
                    var isRulsetOverrideChanged = modalOptions.dialogData.model.initialIsTrafficRulesetOverwritten !==
                        modalOptions.dialogData.model.isTrafficRulesetOverwritten;
                    if (isRulsetOverrideChanged ||
                        isRulsetEnabledChanged ||
                        isRulesOrderChanged) {
                        var dvsPortEditTrafficFilterSpec = _this.dvsPortTrafficFilterSpecFactory.buildEditTrafficFilterSpec(selectedPort.portId, modalOptions.dialogData.model, isRulesOrderChanged);
                        _this.mutationService.apply(portContextId, _this.trafficFilterConstants.spec.DVS_PORT_EDIT_TRAFFIC_RULES_SPEC, dvsPortEditTrafficFilterSpec);
                    }
                    return true;
                }
            };
            var portDataProperty = isPortGroupContext
                ? this.trafficFilterConstants.properties.DVPG_PORT_TRAFFIC_FILTER_PROPERTY
                : this.trafficFilterConstants.properties.DVS_PORT_TRAFFIC_FILTER_PROPERTY;
            var dvsPromise;
            if (isPortGroupContext) {
                dvsPromise = this.dataService.getProperties(portContextId, [portDataProperty], {
                    propertyParams: [{
                            propertyName: portDataProperty,
                            parameterType: "java.lang.String",
                            parameter: selectedPort.portId
                        }]
                });
            }
            else {
                dvsPromise = this.dataService.getProperties(portContextId, [portDataProperty], {
                    propertyParams: [{
                            propertyName: portDataProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: selectedPort.portgroupKey,
                                portId: selectedPort.portId
                            }
                        }]
                });
            }
            dvsPromise.then(function (response) {
                var model = response[portDataProperty];
                if (model) {
                    modalOptions.dialogData.model.initialTrafficRulesetEnabled =
                        model.isTrafficRulesetEnabled;
                    modalOptions.dialogData.model.isTrafficRulesetEnabled =
                        model.isTrafficRulesetEnabled;
                    modalOptions.dialogData.model.showTrafficFilterOverride = true;
                    modalOptions.dialogData.model.enableTrafficFilterOverride =
                        model.isTrafficRulesetOverrideEnabled;
                    modalOptions.dialogData.model.initialIsTrafficRulesetOverwritten =
                        model.isTrafficRulesetOverwritten;
                    modalOptions.dialogData.model.isTrafficRulesetOverwritten =
                        model.isTrafficRulesetOverwritten;
                    modalOptions.dialogData.model.rules = model.rules;
                    modalOptions.dialogData.model.originalRulesKeys =
                        _this.dvpgTrafficFilterService.getRulesKeys(model.rules);
                }
                else {
                    modalOptions.dialogData.model.rules = [];
                    modalOptions.dialogData.model.originalRulesKeys = [];
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsPortTrafficFilterService.prototype.showPortAddRuleDialog = function (portContextId, isPortGroupContext, portgroupKey, portId) {
            var _this = this;
            var onIpValidate = {};
            var onMacValidate = {};
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.title"),
                subTitle: {
                    objectId: portContextId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/add/" +
                    "dvpgAddTrafficRuleDialog.html",
                size: "lg",
                modalClass: "add-traffic-rule-dialog",
                dialogData: {
                    availableTargets: [portContextId],
                    objectId: portId,
                    ipValidator: onIpValidate,
                    macValidator: onMacValidate,
                    newRuleModel: this.dvpgTrafficFilterService.initAddTrafficRuleModel(),
                    trafficFiltersModel: new DvsPortTrafficFilterModel()
                },
                onSubmit: function () {
                    return _this.dvpgTrafficRuleValidator.getValidationResult(modalOptions.dialogData.newRuleModel).then(function (errors) {
                        modalOptions.dialogData.ipValidator.validate();
                        modalOptions.dialogData.macValidator.validate();
                        if (_.isArray(errors) && errors.length > 0) {
                            _this.dvpgTrafficFilterService.showErrors(errors, modalOptions);
                            return false;
                        }
                        else if (!errors) {
                            return false;
                        }
                        var dvsPortAddTrafficRuleSpec = _this.dvsPortTrafficFilterSpecFactory.buildAddTrafficRuleSpec(portId, modalOptions.dialogData.newRuleModel);
                        _this.mutationService.apply(portContextId, _this.trafficFilterConstants.spec.DVS_PORT_ADD_TRAFFIC_RULE_SPEC, dvsPortAddTrafficRuleSpec);
                        return true;
                    });
                }
            };
            var dataProperty = isPortGroupContext
                ? this.trafficFilterConstants.properties.DVPG_PORT_TRAFFIC_FILTER_PROPERTY
                : this.trafficFilterConstants.properties.DVS_PORT_TRAFFIC_FILTER_PROPERTY;
            var dvsPromise;
            if (isPortGroupContext) {
                dvsPromise = this.dataService.getProperties(portContextId, [dataProperty], {
                    propertyParams: [{
                            propertyName: dataProperty,
                            parameterType: "java.lang.String",
                            parameter: portId
                        }]
                });
            }
            else {
                dvsPromise = this.dataService.getProperties(portContextId, [dataProperty], {
                    propertyParams: [{
                            propertyName: dataProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: portgroupKey,
                                portId: portId
                            }
                        }]
                });
            }
            dvsPromise.then(function (response) {
                var model = response[dataProperty];
                if (model) {
                    modalOptions.dialogData.trafficFiltersModel = model;
                    modalOptions.dialogData.newRuleModel.name =
                        _this.dvpgTrafficFilterService.getUniqueRuleName(model.rules);
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsPortTrafficFilterService.prototype.showPortEditRuleDialog = function (portContextId, isPortGroupContext, portId, editedRuleKey) {
            var _this = this;
            var onIpValidate = {};
            var onMacValidate = {};
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.editTitle"),
                subTitle: {
                    objectId: portContextId
                },
                defaultButton: "submit",
                contentTemplate: "dvs-ui/resources/dvs/dvpg/trafficfilter/add/" +
                    "dvpgEditTrafficRuleDialog.html",
                size: "lg",
                modalClass: "edit-traffic-rule-dialog",
                dialogData: {
                    availableTargets: [portContextId],
                    objectId: portId,
                    ipValidator: onIpValidate,
                    macValidator: onMacValidate,
                    editRuleModel: this.dvpgTrafficFilterService.initNewTrafficRuleModel()
                },
                onSubmit: function () {
                    return _this.dvpgTrafficRuleValidator.getValidationResult(modalOptions.dialogData.editRuleModel).then(function (errors) {
                        modalOptions.dialogData.ipValidator.validate();
                        modalOptions.dialogData.macValidator.validate();
                        if (_.isArray(errors) && errors.length > 0) {
                            _this.dvpgTrafficFilterService.showErrors(errors, modalOptions);
                            return false;
                        }
                        else if (!errors) {
                            return false;
                        }
                        var dvsPortEditTrafficRuleSpec = _this.dvsPortTrafficFilterSpecFactory.buildEditTrafficRuleSpec(portId, modalOptions.dialogData.editRuleModel);
                        _this.mutationService.apply(portContextId, _this.trafficFilterConstants.spec.DVS_PORT_EDIT_TRAFFIC_RULE_SPEC, dvsPortEditTrafficRuleSpec);
                        return true;
                    });
                }
            };
            var editRuleProperty = isPortGroupContext
                ? this.trafficFilterConstants.properties.
                    DVPG_PORT_EDIT_TRAFFIC_FILTER_PROPERTY
                : this.trafficFilterConstants.properties.
                    DVS_PORT_EDIT_TRAFFIC_FILTER_PROPERTY;
            var dvsPromise = this.dataService.getProperties(portContextId, [editRuleProperty], {
                propertyParams: [{
                        propertyName: editRuleProperty,
                        parameterType: "java.util.Map",
                        parameter: {
                            ruleKey: editedRuleKey,
                            portId: portId
                        }
                    }]
            });
            dvsPromise.then(function (response) {
                var ruleModel = _this.dvpgTrafficFilterService.initEditTrafficRuleModel(response[editRuleProperty]);
                modalOptions.title = _this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.editTitleUpdated", ruleModel.name);
                _.extend(ruleModel, { defaultQualifierTabIndex: _this.dvpgTrafficFilterService.getDefaultQualifierTabIndex(ruleModel) });
                modalOptions.dialogData.editRuleModel = ruleModel;
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsPortTrafficFilterService.prototype.removePortRule = function (portContextId, portId, ruleKey, ruleName) {
            var _this = this;
            var submitFuncion = function () {
                var dvsPortRemoveTrafficRuleSpec = _this.dvsPortTrafficFilterSpecFactory.buildRemoveTrafficRuleSpec(portId, ruleKey);
                _this.mutationService.apply(portContextId, _this.trafficFilterConstants.spec.DVS_PORT_REMOVE_TRAFFIC_RULE_SPEC, dvsPortRemoveTrafficRuleSpec);
            };
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.caption"),
                message: (ruleName && ruleName.trim().length > 0) ?
                    this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.warning", ruleName) :
                    this.i18nService.getString("DvsUi", "trafficFilter.ruleDialog.remove.noNameWarning"),
                submit: submitFuncion,
                subTitle: {
                    objectId: portContextId
                },
                preserveNewlines: true,
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                }
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        DvsPortTrafficFilterService.$inject = [
            "i18nService",
            "clarityConstants",
            "dvpgTrafficFilterConstants",
            "dvpgTrafficFilterService",
            "dvpgTrafficRuleValidator",
            "dvsPortTrafficFilterSpecFactory",
            "clarityModalService",
            "dataService",
            "mutationService",
            "$q"
        ];
        return DvsPortTrafficFilterService;
    }());
    dvs_ui.DvsPortTrafficFilterService = DvsPortTrafficFilterService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortTrafficFilterService", DvsPortTrafficFilterService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvpgEditRuleSequenceSpec = com.vmware.vsphere.client.h5.network.dvportgroup.trafficfilter.DvpgEditRuleSequenceSpec;
    var DvsPortEditTrafficFilterSpec = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortEditTrafficFilterSpec;
    var DvsPortAddTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortAddTrafficRuleSpec;
    var DvsPortEditTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortEditTrafficRuleSpec;
    var DvsPortRemoveTrafficRuleSpec = com.vmware.vsphere.client.h5.network.dvs.ports.model.DvsPortRemoveTrafficRuleSpec;
    var DvsPortTrafficFilterSpecFactory = (function () {
        function DvsPortTrafficFilterSpecFactory() {
        }
        /**
         * Builds the spec for enable and/or reorder the traffic filter rules of
         * distributed virtual port.
         *
         * @param portId The key of port which is updated
         * @param model DvpgEditTrafficFilterModel
         * @param isRuleOrderChanged True if the rule order has been changed.
         */
        DvsPortTrafficFilterSpecFactory.prototype.buildEditTrafficFilterSpec = function (portId, model, isRuleOrderChanged) {
            var configSpec = new DvsPortEditTrafficFilterSpec();
            configSpec.isTrafficRulesetEnabled = model.isTrafficRulesetEnabled;
            configSpec.isTrafficRulesetOverwritten = model.isTrafficRulesetOverwritten;
            configSpec.portKey = portId;
            if (isRuleOrderChanged) {
                var trafficRuleSpecs_1 = [];
                model.rules.forEach(function (rule) {
                    var trafficRuleSpec = new DvpgEditRuleSequenceSpec();
                    trafficRuleSpec.ruleKey = rule.key;
                    trafficRuleSpec.sequence = rule.sequence;
                    trafficRuleSpecs_1.push(trafficRuleSpec);
                });
                configSpec.rules = trafficRuleSpecs_1;
            }
            return configSpec;
        };
        /**
         * Builds the spec for adding a traffic rule to the current rules
         * configuration of the distributed virtual port.
         *
         * @param portId The key of port which is updated
         * @param model DvpgTrafficRuleModel
         */
        DvsPortTrafficFilterSpecFactory.prototype.buildAddTrafficRuleSpec = function (portId, model) {
            var spec = new DvsPortAddTrafficRuleSpec();
            spec.portKey = portId;
            spec.newRule = model;
            return spec;
        };
        /**
         * Builds the spec for editing a traffic rule from the current rules
         * configuration of the distributed virtual port.
         *
         * @param portId The key of port which is updated
         * @param editedRuleModel DvpgTrafficRuleModel
         */
        DvsPortTrafficFilterSpecFactory.prototype.buildEditTrafficRuleSpec = function (portId, editedRuleModel) {
            var spec = new DvsPortEditTrafficRuleSpec();
            spec.portKey = portId;
            spec.editedRule = editedRuleModel;
            return spec;
        };
        /**
         * Builds the spec for removing a traffic rule from the current rules
         * configuration of the distributed port group.
         *
         * @param portId The key of port which is updated
         * @param ruleKey The key of the removed traffic rule
         */
        DvsPortTrafficFilterSpecFactory.prototype.buildRemoveTrafficRuleSpec = function (portId, ruleKey) {
            var spec = new DvsPortRemoveTrafficRuleSpec();
            spec.portKey = portId;
            spec.ruleKey = ruleKey;
            return spec;
        };
        DvsPortTrafficFilterSpecFactory.$inject = [];
        return DvsPortTrafficFilterSpecFactory;
    }());
    dvs_ui.DvsPortTrafficFilterSpecFactory = DvsPortTrafficFilterSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPortTrafficFilterSpecFactory", DvsPortTrafficFilterSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPortTrafficFilterViewComponent = (function () {
        function DvsPortTrafficFilterViewComponent() {
            this.bindings = {
                selectedPort: "<",
                portContextId: "<",
                isPortGroupContext: "<"
            };
            this.controller = DvsPortTrafficFilterViewController;
            this.templateUrl = "dvs-ui/resources/dvs/ports/trafficfilter/" +
                "dvsPortTrafficFilterViewTemplate.html";
        }
        return DvsPortTrafficFilterViewComponent;
    }());
    dvs_ui.DvsPortTrafficFilterViewComponent = DvsPortTrafficFilterViewComponent;
    var DvsPortTrafficFilterViewController = (function () {
        function DvsPortTrafficFilterViewController(dataService, i18nService, actionsService, dvpgTrafficFilterService, dvsPortTrafficFilterService, dvpgTrafficFilterConstants) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.dvpgTrafficFilterService = dvpgTrafficFilterService;
            this.dvsPortTrafficFilterService = dvsPortTrafficFilterService;
            this.dvpgTrafficFilterConstants = dvpgTrafficFilterConstants;
            this.isTrafficFilterEnabled = false;
            this.liveRefreshProperties = [
                "config.defaultPortConfig.filterPolicy",
                "config.defaultPortConfig.filterPolicy.filterConfig"
            ];
            this.trafficFilterSettingsTitle = this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.disabled");
            this.enableAndReorderActionLabel = this.i18nService.getString("DvsUi", "actionEditTrafficFiltersLabel");
        }
        DvsPortTrafficFilterViewController.prototype.$onChanges = function () {
            this.refresh(this.selectedPort);
        };
        DvsPortTrafficFilterViewController.prototype.invokeEnableAndReorderAction = function () {
            var _this = this;
            this.actionsService.getAction("vsphere.core.dvs.trafficFilters.editPortRulesAction", [this.portContextId])
                .then(function (action) {
                var context = {};
                context.isPortGroupContext = _this.isPortGroupContext;
                context.selectedPort = _this.selectedPort;
                _this.actionsService.invokeAction(action, context);
            });
        };
        DvsPortTrafficFilterViewController.prototype.refresh = function (selectedPort) {
            var _this = this;
            if (!selectedPort) {
                return;
            }
            this.isLoading = true;
            var dvsPromise;
            var portsDataProperty = this.isPortGroupContext
                ? this.dvpgTrafficFilterConstants.properties.
                    DVPG_PORT_TRAFFIC_FILTER_PROPERTY
                : this.dvpgTrafficFilterConstants.properties.
                    DVS_PORT_TRAFFIC_FILTER_PROPERTY;
            if (this.isPortGroupContext) {
                dvsPromise = this.dataService.getProperties(this.portContextId, [portsDataProperty], {
                    propertyParams: [{
                            propertyName: portsDataProperty,
                            parameterType: "java.lang.String",
                            parameter: selectedPort.portId
                        }]
                });
            }
            else {
                dvsPromise = this.dataService.getProperties(this.portContextId, [portsDataProperty], {
                    propertyParams: [{
                            propertyName: portsDataProperty,
                            parameterType: "java.util.Map",
                            parameter: {
                                portgroupKey: selectedPort.portgroupKey,
                                portId: selectedPort.portId
                            }
                        }]
                });
            }
            dvsPromise.then(function (dataServiceResponse) {
                var model = dataServiceResponse[portsDataProperty];
                if (model) {
                    _this.isTrafficFilterEnabled =
                        model.isTrafficRulesetOverrideEnabled &&
                            model.isTrafficRulesetOverwritten;
                    if (_this.dvpgTrafficFilterService.areRulesChanged(_this.trafficFilterRules, model.rules)) {
                        _this.trafficFilterRules = model.rules;
                    }
                    _this.trafficFilterSettingsTitle = model.isTrafficRulesetEnabled ?
                        _this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.enabled") :
                        _this.i18nService.getString("DvsUi", "dvpg.trafficFilter.title.disabled");
                }
                else {
                    _this.trafficFilterRules = [];
                }
            }).finally(function () {
                _this.isLoading = false;
            });
        };
        DvsPortTrafficFilterViewController.prototype.onAddRule = function () {
            this.dvsPortTrafficFilterService.showPortAddRuleDialog(this.portContextId, this.isPortGroupContext, this.selectedPort.portgroupKey, this.selectedPort.portId);
        };
        DvsPortTrafficFilterViewController.prototype.onEditRule = function (rule) {
            this.dvsPortTrafficFilterService.showPortEditRuleDialog(this.portContextId, this.isPortGroupContext, this.selectedPort.portId, rule.key);
        };
        DvsPortTrafficFilterViewController.prototype.onRemoveRule = function (rule) {
            this.dvsPortTrafficFilterService.removePortRule(this.portContextId, this.selectedPort.portId, rule.key, rule.name);
        };
        DvsPortTrafficFilterViewController.$inject = [
            "dataService",
            "i18nService",
            "actionsService",
            "dvpgTrafficFilterService",
            "dvsPortTrafficFilterService",
            "dvpgTrafficFilterConstants"
        ];
        return DvsPortTrafficFilterViewController;
    }());
    dvs_ui.DvsPortTrafficFilterViewController = DvsPortTrafficFilterViewController;
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPortTrafficFilterView", new DvsPortTrafficFilterViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var Privileges = (function () {
        function Privileges() {
        }
        Privileges.HOST_CONFIG_NETWORK = "Host.Config.Network";
        return Privileges;
    }());
    dvs_ui.Privileges = Privileges;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPvlanData = com.vmware.vsphere.client.h5.network.dvs.pvlan.model.DvsPvlanData;
    var DvsPvlanViewComponent = (function () {
        function DvsPvlanViewComponent() {
            this.bindings = {};
            this.controller = DvsPvlanViewController;
            this.templateUrl = "dvs-ui/resources/dvs/pvlan/dvsPvlanViewTemplate.html";
        }
        return DvsPvlanViewComponent;
    }());
    dvs_ui.DvsPvlanViewComponent = DvsPvlanViewComponent;
    var DvsPvlanViewController = (function () {
        function DvsPvlanViewController($rootScope, $scope, i18nService, dataService, dvsPvlanViewService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.dvsPvlanViewService = dvsPvlanViewService;
            this.dvsPvlanLoading = false;
            this.$scope.preselectComparator =
                function (gridDataItem) {
                    return gridDataItem.secondaryVlanId === _this._selectedItemSecondaryId;
                };
            this.settingsViewHeaderAccessor = {};
            this.actions = [{
                    actionUid: "vsphere.core.dvs.editPvlan",
                    customLabel: this.i18nService.getString("DvsUi", "dvs.pvlanView.edit.label")
                }];
        }
        DvsPvlanViewController.prototype.$onInit = function () {
            this.refresh();
        };
        Object.defineProperty(DvsPvlanViewController.prototype, "title", {
            get: function () {
                return this.i18nService.getString("DvsUi", "dvs.pvlanView.title");
            },
            enumerable: true,
            configurable: true
        });
        DvsPvlanViewController.prototype.refresh = function () {
            var _this = this;
            this.dvsPvlanLoading = true;
            this.dvsUri = this.$rootScope._route.objectId;
            var dvsPromise = this.dataService
                .getData(this.dvsUri, new DvsPvlanData()._type);
            this._selectedDistributedSwitchPromise = dvsPromise;
            dvsPromise.then(function (dataServiceResponse) {
                if (_this._selectedDistributedSwitchPromise === dvsPromise) {
                    var pvlans = (dataServiceResponse && dataServiceResponse.pvlans) || [];
                    var sortedPvlans = _this.dvsPvlanViewService
                        .formatPvlanEntries(pvlans);
                    if (!_this.datagridOptions) {
                        // init
                        _this.datagridOptions = _this.dvsPvlanViewService
                            .createPvlanDatagridOptions(sortedPvlans, _this.onSelectionChange.bind(_this));
                    }
                    else {
                        // refresh
                        _this.datagridOptions.data = sortedPvlans;
                        // When the datagridOptions.data is refreshed, the callback for the
                        // selectedItems is called with an empty array before the grid
                        // preselection directive tries to preselect the last selected
                        // item. This flag is used to skip the first trigger of the watch
                        // when the data is refreshed.
                        _this._ignoreNextItemSelection = true;
                    }
                }
                _this.dvsPvlanLoading = false;
            }, function (error) {
                _this.dvsPvlanLoading = false;
            });
            this.liveRefreshProperties = ["config.pvlanConfig"];
            // Call the settings-view-header's accessor #refresh function to recalculate
            // the actions availability
            if (this.settingsViewHeaderAccessor.refresh) {
                this.settingsViewHeaderAccessor.refresh();
            }
        };
        DvsPvlanViewController.prototype.onSelectionChange = function (items) {
            if (this._ignoreNextItemSelection) {
                this._ignoreNextItemSelection = false;
                return;
            }
            if (items && items.length > 0) {
                this._selectedItemSecondaryId = items[0].secondaryVlanId;
            }
            else {
                this._selectedItemSecondaryId = -1;
            }
        };
        DvsPvlanViewController.$inject = [
            "$rootScope",
            "$scope",
            "i18nService",
            "dataService",
            "dvsPvlanViewService"
        ];
        return DvsPvlanViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsPvlanView", new DvsPvlanViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPvlanViewService = (function () {
        function DvsPvlanViewService(vuiConstants, i18nService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
        }
        DvsPvlanViewService.prototype.formatPvlanEntries = function (pvlans) {
            var _this = this;
            if (pvlans !== undefined && pvlans !== null && pvlans.length > 0) {
                pvlans.map(function (pvlan) {
                    pvlan.pvlanType = _this.localizePvlanType(pvlan);
                });
            }
            var sortedBySecondaryVlanId = _.sortBy(pvlans, function (pvlanMap) {
                return pvlanMap.secondaryVlanId;
            });
            return _.sortBy(sortedBySecondaryVlanId, function (pvlanMap) {
                return pvlanMap.primaryVlanId;
            });
        };
        DvsPvlanViewService.prototype.createPvlanDatagridOptions = function (pvlans, onSelectionChange) {
            return {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: pvlans,
                resizable: true,
                height: "100%",
                onChange: onSelectionChange
            };
        };
        DvsPvlanViewService.prototype.createColumnDefinitions = function () {
            return [{
                    displayName: this.i18n("NetworkUi", "PrivateVlanView.list.primary.header"),
                    field: "primaryVlanId",
                    type: "number",
                    sortable: true,
                    width: "50px"
                }, {
                    displayName: this.i18n("NetworkUi", "PrivateVlanView.list.secondary.header"),
                    field: "secondaryVlanId",
                    type: "number",
                    sortable: true,
                    width: "50px"
                }, {
                    displayName: this.i18n("NetworkUi", "PrivateVlanView.list.type.header"),
                    field: "pvlanType",
                    type: "string",
                    sortable: true,
                    width: "200px"
                }];
        };
        DvsPvlanViewService.prototype.localizePvlanType = function (row) {
            if (row.pvlanType !== dvs_ui.PvlanType.promiscuous &&
                row.pvlanType !== dvs_ui.PvlanType.isolated &&
                row.pvlanType !== dvs_ui.PvlanType.community) {
                return "";
            }
            return this.i18n("DvsUi", "PrivateVlanPage.type." + row.pvlanType);
        };
        DvsPvlanViewService.$inject = [
            "vuiConstants",
            "i18nService"
        ];
        return DvsPvlanViewService;
    }());
    dvs_ui.DvsPvlanViewService = DvsPvlanViewService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsPvlanViewService", DvsPvlanViewService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditPvlanDialogComponent = (function () {
        function DvsEditPvlanDialogComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = DvsEditNetFlowController;
            this.templateUrl =
                "dvs-ui/resources/dvs/pvlan/edit/dvsEditPvlanDialogTemplate.html";
        }
        return DvsEditPvlanDialogComponent;
    }());
    dvs_ui.DvsEditPvlanDialogComponent = DvsEditPvlanDialogComponent;
    var DvsEditNetFlowController = (function () {
        function DvsEditNetFlowController(dvsEditPvlanDialogService, vuiConstants, i18nService, $scope) {
            var _this = this;
            this.dvsEditPvlanDialogService = dvsEditPvlanDialogService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.i18n = this.i18nService.getString;
            this.$scope.primaryPreselectComparator = function (item) {
                return _this.selectedPrimaryIdKey === item.primaryId.key;
            };
            this.$scope.secondaryPreselectComparator = function (item) {
                return _this.selectedSecondaryIdKey === item.secondaryId.key;
            };
            this.primaryDatagridCallbacks = {
                selectPrimaryIdRow: this.selectPrimaryIdRow.bind(this),
                updatePvlanIdValue: this.onPrimaryPvlanIdChange.bind(this),
                addPromiscuousPvlanMap: this.addPromiscuousPvlanMap.bind(this),
                removePrimaryVlanId: this.removePrimaryVlanId.bind(this),
                validateDuplicatePvlanMaps: this.validateDuplicatePrimaryPvlanMaps.bind(this)
            };
            this.secondaryDatagridCallbacks = {
                selectSecondaryIdRow: this.selectSecondaryIdRow.bind(this),
                updatePvlanType: this.updatePvlanType.bind(this),
                updatePvlanIdValue: this.onSecondaryPvlanIdChange.bind(this),
                addCommunityPvlanMap: this.addCommunityPvlanMap.bind(this),
                removeSecondaryVlanId: this.removeSecondaryVlanId.bind(this),
                validateDuplicatePvlanMaps: this.validateDuplicateSecondaryPvlanMaps.bind(this)
            };
            this.valueToBeUsedForNewPvlan = [];
        }
        DvsEditNetFlowController.prototype.$onInit = function () {
            var _this = this;
            this.primaryDatagridDescription =
                this.i18n("DvsUi", "PrivateVlanView.list.primary.header");
            this.primaryDatagridOptions = this.dvsEditPvlanDialogService
                .createPrimaryVlanIdDatagridOptions(this.pageModel.pvlanMaps, this.primaryDatagridCallbacks);
            var promiscuousPlanMaps = this.primaryDatagridOptions.data;
            _.forEach(promiscuousPlanMaps, function (pvlanMap) {
                var filteredPvlanMaps = _this.dvsEditPvlanDialogService
                    .filterPvlanMapsByPrimaryId(_this.pageModel.pvlanMaps, pvlanMap.primaryId.key);
                _this.pageModel.updateIsolatedError(pvlanMap.primaryId.key, filteredPvlanMaps);
            });
        };
        DvsEditNetFlowController.prototype.removePrimaryVlanId = function () {
            var _this = this;
            if (this.primaryDatagridOptions.selectedItems.length > 0) {
                // need copy to iterate over originally selected items
                var selectedItems = this.primaryDatagridOptions.selectedItems.slice();
                _.forEach(selectedItems, function (pvlanMap) {
                    var filtered = _this.dvsEditPvlanDialogService
                        .filterPvlanMapsByPrimaryId(_this.pageModel.pvlanMaps, pvlanMap.primaryId.key);
                    _.forEach(filtered, function (pvlanMap) {
                        delete _this.pageModel.pvlanMaps[pvlanMap.secondaryId.key];
                        delete _this.pageModel.pvlanIds[pvlanMap.secondaryId.key];
                        _this.removeValueToBeUsedForNewPvlan(pvlanMap.secondaryId.key);
                    });
                    _this.primaryDatagridOptions.data = _this.dvsEditPvlanDialogService
                        .removePvlanIdFromData(_this.primaryDatagridOptions.data, pvlanMap);
                });
                this.lastEditedPrimaryVlan = null;
            }
        };
        DvsEditNetFlowController.prototype.addPromiscuousPvlanMap = function () {
            var pvlanMapNew = this.addNewPvlanMap(dvs_ui.PvlanType.promiscuous);
            this.selectedPrimaryIdKey = pvlanMapNew.primaryId.key;
            this.primaryDatagridOptions.data = this.primaryDatagridOptions.data
                .concat(pvlanMapNew);
        };
        DvsEditNetFlowController.prototype.removeSecondaryVlanId = function () {
            var _this = this;
            if (this.primaryDatagridOptions.selectedItems.length > 0 &&
                this.secondaryDatagridOptions.selectedItems.length > 0) {
                // need copy to iterate over originally selected items
                var selectedItems = this.secondaryDatagridOptions.selectedItems.slice();
                _.forEach(selectedItems, function (pvlanMap) {
                    var selectedKey = pvlanMap.secondaryId.key;
                    delete _this.pageModel.pvlanMaps[selectedKey];
                    delete _this.pageModel.pvlanIds[selectedKey];
                    _this.removeValueToBeUsedForNewPvlan(selectedKey);
                    _this.secondaryDatagridOptions.data = _this.dvsEditPvlanDialogService
                        .removePvlanIdFromData(_this.secondaryDatagridOptions.data, pvlanMap);
                    _this.pageModel.updateIsolatedError(_this.selectedPrimaryIdKey, _this.secondaryDatagridOptions.data);
                    _this.lastEditedSecondaryVlan = null;
                });
            }
        };
        DvsEditNetFlowController.prototype.addCommunityPvlanMap = function () {
            var selectedPrimaryId = this.pageModel.pvlanIds[this.primaryDatagridOptions.selectedItems[0].primaryId.key];
            var pvlanMapNew = this.addNewPvlanMap(dvs_ui.PvlanType.community, selectedPrimaryId);
            this.selectedSecondaryIdKey = pvlanMapNew.secondaryId.key;
            this.secondaryDatagridOptions.data = this.secondaryDatagridOptions.data
                .concat(pvlanMapNew);
        };
        DvsEditNetFlowController.prototype.addNewPvlanMap = function (pvlanType, primaryVlanId) {
            var keys = this.dvsEditPvlanDialogService.getKeys(this.pageModel.pvlanIds);
            var firstAvailableKey = this.dvsEditPvlanDialogService
                .getFirstAvailableKey(keys);
            var secondaryVlanId = this.createNextPvlanId(firstAvailableKey);
            this.pageModel.pvlanIds[secondaryVlanId.key] = secondaryVlanId;
            if (!primaryVlanId) {
                primaryVlanId = secondaryVlanId;
            }
            var pvlanMapNew = new dvs_ui.PvlanMapModel(primaryVlanId, secondaryVlanId, pvlanType);
            this.pageModel.pvlanMaps[secondaryVlanId.key] = pvlanMapNew;
            return pvlanMapNew;
        };
        /**
         * A callback method, passed to the primary datagrid options, triggered
         * when a row is selected.
         * Creates the second datagrid, based on the selection in the first one.
         */
        DvsEditNetFlowController.prototype.selectPrimaryIdRow = function (selectedItems) {
            this.pageModel.updateDuplicateError();
            this.updateSelectedPrimaryIdValue();
            if (!_.isEmpty(selectedItems)) {
                if (selectedItems.length === 1) {
                    this.selectedPrimaryIdKey = selectedItems[0].primaryId.key;
                    this.secondaryDatagridOptions = this.dvsEditPvlanDialogService
                        .createSecondaryVlanIdDatagridOptions(this.pageModel.pvlanMaps, this.selectedPrimaryIdKey, this.secondaryDatagridCallbacks);
                }
                this.primaryDatagridOptions.actionBarOptions.actions[1].enabled = true;
            }
            else {
                this.primaryDatagridOptions.actionBarOptions.actions[1].enabled = false;
            }
            // needed to avoid null pointer exception in datagrid rerendering
            this.selectedSecondaryIdKey = -1;
        };
        DvsEditNetFlowController.prototype.selectSecondaryIdRow = function (selectedItems) {
            this.pageModel.updateDuplicateError();
            this.updateSelectedSecondaryIdValue();
            if (!_.isEmpty(selectedItems)) {
                this.secondaryDatagridOptions.actionBarOptions.actions[1].enabled =
                    !this.dvsEditPvlanDialogService.hasPromiscuousPvlanMap(selectedItems);
                this.selectedSecondaryIdKey = selectedItems[0].secondaryId.key;
            }
            else {
                this.secondaryDatagridOptions.actionBarOptions.actions[1].enabled = false;
            }
        };
        DvsEditNetFlowController.prototype.onPrimaryPvlanIdChange = function (pvlanId) {
            this.pageModel.pvlanIds[pvlanId.key].val = pvlanId.val;
            this.lastEditedPrimaryVlan = this.primaryDatagridOptions.selectedItems[0];
        };
        DvsEditNetFlowController.prototype.onSecondaryPvlanIdChange = function (pvlanId) {
            this.pageModel.pvlanIds[pvlanId.key].val = pvlanId.val;
            this.lastEditedSecondaryVlan = this.secondaryDatagridOptions.selectedItems[0];
        };
        DvsEditNetFlowController.prototype.validateDuplicatePrimaryPvlanMaps = function () {
            this.pageModel.updateDuplicateError();
            this.updateSelectedPrimaryIdValue();
        };
        DvsEditNetFlowController.prototype.validateDuplicateSecondaryPvlanMaps = function () {
            this.pageModel.updateDuplicateError();
            this.updateSelectedSecondaryIdValue();
        };
        DvsEditNetFlowController.prototype.updatePvlanType = function (pvlanMap) {
            this.pageModel.pvlanMaps[pvlanMap.secondaryId.key].type = pvlanMap.type;
            this.pageModel.updateIsolatedError(this.selectedPrimaryIdKey, this.secondaryDatagridOptions.data);
        };
        DvsEditNetFlowController.prototype.updateSelectedPrimaryIdValue = function () {
            if (this.lastEditedPrimaryVlan) {
                this.lastEditedPrimaryVlan.primaryId.val =
                    this.pageModel.pvlanIds[this.lastEditedPrimaryVlan.primaryId.key].val;
            }
        };
        DvsEditNetFlowController.prototype.updateSelectedSecondaryIdValue = function () {
            if (this.lastEditedSecondaryVlan) {
                this.lastEditedSecondaryVlan.secondaryId.val =
                    this.pageModel.pvlanIds[this.lastEditedSecondaryVlan.secondaryId.key].val;
            }
        };
        DvsEditNetFlowController.prototype.createNextPvlanId = function (firstAvailableKey) {
            var vals = [];
            _.forEach(this.pageModel.pvlanIds, function (pvlanId) {
                vals.push(pvlanId.val);
            });
            var lastAvailablePvlanId = _.last(this.valueToBeUsedForNewPvlan)
                ? _.last(this.valueToBeUsedForNewPvlan).val : 0;
            var nextAvailableValue = this.dvsEditPvlanDialogService
                .getNextAvailableValue(vals, lastAvailablePvlanId);
            var pvlanIdNew = new dvs_ui.PvlanIdModel(firstAvailableKey, nextAvailableValue);
            this.valueToBeUsedForNewPvlan.push(pvlanIdNew);
            return pvlanIdNew;
        };
        DvsEditNetFlowController.prototype.removeValueToBeUsedForNewPvlan = function (selectedIdKey) {
            var index = _.findIndex(this.valueToBeUsedForNewPvlan, function (pvlanId) {
                return pvlanId.key === selectedIdKey;
            });
            if (index !== -1) {
                this.valueToBeUsedForNewPvlan.splice(index, 1);
            }
        };
        DvsEditNetFlowController.$inject = [
            "dvsEditPvlanDialogService",
            "vuiConstants",
            "i18nService",
            "$scope"
        ];
        return DvsEditNetFlowController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsEditPvlanDialog", new DvsEditPvlanDialogComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditPvlanDialogConstants = (function () {
        function DvsEditPvlanDialogConstants() {
        }
        DvsEditPvlanDialogConstants.ADD = "add-action";
        DvsEditPvlanDialogConstants.REMOVE = "remove-action";
        DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MIN = 1;
        DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MAX = 4094;
        return DvsEditPvlanDialogConstants;
    }());
    dvs_ui.DvsEditPvlanDialogConstants = DvsEditPvlanDialogConstants;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditPvlanData = com.vmware.vsphere.client.h5.network.dvs.pvlan.model.DvsEditPvlanData;
    var DvsEditPvlanDialogConstants = dvs_ui.DvsEditPvlanDialogConstants;
    var DvsEditPvlanDialogService = (function () {
        function DvsEditPvlanDialogService(dataService, mutationService, i18nService, clarityModalService, clarityConstants, vuiConstants, vimEntityEscapingService) {
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.vuiConstants = vuiConstants;
            this.vimEntityEscapingService = vimEntityEscapingService;
            this.i18n = this.i18nService.getString;
        }
        DvsEditPvlanDialogService.prototype.show = function (dvsUrn) {
            var _this = this;
            var modalOptions = {
                title: this.i18n("DvsUi", "PrivateVlanPage.titleFormat"),
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                dialogData: {},
                contentTemplate: "dvs-ui/resources/dvs/pvlan/edit/dvsEditPvlanDialog.html",
                onSubmit: onSubmit.bind(this)
            };
            var dvsPromise = this.dataService
                .getData(dvsUrn, new DvsEditPvlanData()._type);
            dvsPromise.then(function (dataServiceResponse) {
                if (dataServiceResponse) {
                    modalOptions.subTitle = _this.vimEntityEscapingService
                        .unescapeSpecialCharacters(dataServiceResponse.name);
                    modalOptions.dialogData.pageModel =
                        new dvs_ui.DvsEditPvlanDialogModel(dataServiceResponse);
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
            function onSubmit() {
                var _this = this;
                var errorMessage = "";
                _.forEach(modalOptions.dialogData.pageModel.pvlanMaps, function (pageModelPvlan) {
                    if (pageModelPvlan.hasErrors()) {
                        errorMessage =
                            _this.i18n("DvsUi", "PrivateVlanPage.errorSummary");
                        return;
                    }
                });
                if (errorMessage) {
                    modalOptions.alerts = [{
                            type: this.clarityConstants.notifications.type.ERROR,
                            text: errorMessage
                        }];
                    return false;
                }
                var dvsConfigSpec = modalOptions.dialogData.pageModel.buildSpec();
                if (dvsConfigSpec !== null) {
                    this.mutationService.apply(dvsUrn, dvsConfigSpec._type, dvsConfigSpec);
                }
                return true;
            }
        };
        DvsEditPvlanDialogService.prototype.createPrimaryVlanIdDatagridOptions = function (pvlanMaps, callbacks) {
            var promiscuousPvlanMaps = this.filterPromiscuousPvlanMaps(pvlanMaps);
            return {
                columnDefs: this.createPrimaryVlanIdColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedItems: [],
                data: promiscuousPvlanMaps,
                pvlanMaps: pvlanMaps,
                resizable: true,
                height: "100%",
                onChange: callbacks.selectPrimaryIdRow,
                validateDuplicatePvlanMaps: callbacks.validateDuplicatePvlanMaps,
                updatePvlanIdValue: callbacks.updatePvlanIdValue,
                pageConfig: {
                    hidePager: true
                },
                actionBarOptions: {
                    actions: [
                        {
                            id: DvsEditPvlanDialogConstants.ADD,
                            enabled: true,
                            iconClass: "vsphere-icon-toolbar-add",
                            onClick: callbacks.addPromiscuousPvlanMap
                        },
                        {
                            id: DvsEditPvlanDialogConstants.REMOVE,
                            enabled: false,
                            iconClass: "vsphere-icon-toolbar-remove",
                            onClick: callbacks.removePrimaryVlanId
                        },
                    ]
                }
            };
        };
        DvsEditPvlanDialogService.prototype.createPrimaryVlanIdColumnDefinitions = function () {
            return [{
                    width: "50px",
                    template: this.createPrimaryValidationCellTemplate.bind(this)
                }, {
                    displayName: this.i18n("DvsUi", "PrivateVlanView.list.primary.header"),
                    type: "number",
                    field: "primaryId.val",
                    sortable: true,
                    template: this.createPrimaryIdCellTemplate
                }];
        };
        DvsEditPvlanDialogService.prototype.createSecondaryVlanIdDatagridOptions = function (pvlanMaps, selectedPrimaryIdKey, callbacks) {
            var filteredPvlanMaps = this.filterPvlanMapsByPrimaryId(pvlanMaps, selectedPrimaryIdKey);
            var sortedPvlanMaps = this.sortPvlanMaps(filteredPvlanMaps);
            return {
                columnDefs: this.createSecondaryVlanIdColumnDefinitions(),
                data: sortedPvlanMaps,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedItems: [],
                resizable: true,
                height: "100%",
                onChange: callbacks.selectSecondaryIdRow,
                validateDuplicatePvlanMaps: callbacks.validateDuplicatePvlanMaps,
                typeOptions: [
                    {
                        value: dvs_ui.PvlanType.isolated,
                        label: this.i18nService.getString("DvsUi", "PrivateVlanPage.type.isolated")
                    }, {
                        value: dvs_ui.PvlanType.community,
                        label: this.i18nService.getString("DvsUi", "PrivateVlanPage.type.community")
                    }
                ],
                pvlanMaps: pvlanMaps,
                pvlanMap: pvlanMaps[selectedPrimaryIdKey],
                localizePvlanType: this.localizePvlanType.bind(this),
                updatePvlanIdValue: callbacks.updatePvlanIdValue,
                updatePvlanType: callbacks.updatePvlanType,
                pageConfig: {
                    hidePager: true
                },
                actionBarOptions: {
                    actions: [
                        {
                            id: DvsEditPvlanDialogConstants.ADD,
                            enabled: true,
                            iconClass: "vsphere-icon-toolbar-add",
                            onClick: callbacks.addCommunityPvlanMap
                        },
                        {
                            id: DvsEditPvlanDialogConstants.REMOVE,
                            enabled: false,
                            iconClass: "vsphere-icon-toolbar-remove",
                            onClick: callbacks.removeSecondaryVlanId
                        },
                    ]
                }
            };
        };
        DvsEditPvlanDialogService.prototype.createSecondaryVlanIdColumnDefinitions = function () {
            return [{
                    width: "50px",
                    template: this.createSecondaryValidationCellTemplate.bind(this)
                }, {
                    displayName: this.i18n("DvsUi", "PrivateVlanView.list.secondary.header"),
                    type: "number",
                    field: "secondaryId.val",
                    sortable: true,
                    template: this.createSecondaryIdCellTemplate
                }, {
                    displayName: this.i18n("DvsUi", "PrivateVlanView.list.type.header"),
                    type: "string",
                    field: "type",
                    sortable: true,
                    template: this.createPvlanTypeCellTemplate.bind(this)
                }];
        };
        DvsEditPvlanDialogService.prototype.localizePvlanType = function (pvlanType) {
            if (pvlanType !== dvs_ui.PvlanType.promiscuous &&
                pvlanType !== dvs_ui.PvlanType.isolated &&
                pvlanType !== dvs_ui.PvlanType.community) {
                return "";
            }
            return this.i18n("DvsUi", "PrivateVlanPage.type." + pvlanType);
        };
        DvsEditPvlanDialogService.prototype.filterPromiscuousPvlanMaps = function (pvlanMaps) {
            return _.where(_.values(pvlanMaps), { type: dvs_ui.PvlanType.promiscuous });
        };
        DvsEditPvlanDialogService.prototype.filterPvlanMapsByPrimaryId = function (pvlanMaps, selectedPrimaryIdKey) {
            return _.filter(_.values(pvlanMaps), function (pvlanMap) {
                return pvlanMap.primaryId.key === selectedPrimaryIdKey;
            });
        };
        DvsEditPvlanDialogService.prototype.getFirstAvailableKey = function (nums) {
            for (var i = 0; i < nums.length; i++) {
                if ((i + 1) !== nums[i]) {
                    return i + 1;
                }
            }
            return nums.length + 1;
        };
        DvsEditPvlanDialogService.prototype.getKeys = function (pvlanIds) {
            var keys = [];
            for (var key in pvlanIds) {
                keys.push(Number(key));
            }
            return keys;
        };
        DvsEditPvlanDialogService.prototype.getNextAvailableValue = function (nums, base) {
            nums.sort(function (a, b) { return a - b; });
            var index = _.indexOf(nums, base + 1);
            var nextNumber = base + 1;
            if (index !== -1) {
                for (var i = index; i < nums.length; i++) {
                    if (nextNumber !== nums[i]) {
                        return nextNumber;
                    }
                    nextNumber++;
                }
            }
            if (nextNumber <= DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MAX) {
                return nextNumber;
            }
            // traversing nums for the first available value
            nextNumber = this.getFirstAvailableKey(nums);
            return nextNumber <= DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MAX ?
                nextNumber : DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MIN;
        };
        DvsEditPvlanDialogService.prototype.removePvlanIdFromData = function (pvlanMaps, mapModel) {
            if (!mapModel || !mapModel.secondaryId) {
                return pvlanMaps;
            }
            var pvlanMap = _.find(pvlanMaps, function (pvlanMap) {
                return pvlanMap.secondaryId.key === mapModel.secondaryId.key;
            });
            return _.without(pvlanMaps, pvlanMap);
        };
        DvsEditPvlanDialogService.prototype.hasPromiscuousPvlanMap = function (pvlanMaps) {
            if (!pvlanMaps) {
                return false;
            }
            for (var i = 0; i < pvlanMaps.length; i++) {
                if (pvlanMaps[i].type === dvs_ui.PvlanType.promiscuous) {
                    return true;
                }
            }
            return false;
        };
        DvsEditPvlanDialogService.prototype.sortPvlanMaps = function (pvlanMaps) {
            return _.sortBy(pvlanMaps, function (pvlanMap) {
                if (pvlanMap.type === dvs_ui.PvlanType.promiscuous) {
                    return 0;
                }
                return pvlanMap.secondaryId.val;
            });
        };
        DvsEditPvlanDialogService.prototype.createPrimaryValidationCellTemplate = function (dataItem) {
            var duplicateErrorText = this.i18n("DvsUi", "PrivateVlanPage.id.duplicate");
            var secondaryErrorText = this.i18n("DvsUi", "PrivateVlanPage.entries.errors");
            var hasDuplicateError = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].errors.duplicate";
            var hasSecondaryDuplicateError = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].errors.secondaryDuplicate";
            var hasSecondaryIsolatedError = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].errors.secondaryIsolated";
            var hasErrors = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].hasErrors()";
            return "\n            <div class=\"icon-container\" ng-if=\"" + hasErrors + "\">\n               <a role=\"tooltip\" aria-haspopup=\"true\" class=\"tooltip tooltip-sm tooltip-bottom-right\">\n                  <clr-icon shape=\"error\" class=\"is-error\" size=\"24\"></clr-icon>\n                  <span class=\"tooltip-content\">\n                     <div ng-if=\"" + hasDuplicateError + "\">\n                        " + duplicateErrorText + "\n                     </div>\n                     <div ng-if=\"" + hasSecondaryDuplicateError + " || " + hasSecondaryIsolatedError + "\">\n                        " + secondaryErrorText + "\n                     </div>\n                  </span>\n               </a>\n            </div>\n         ";
        };
        DvsEditPvlanDialogService.prototype.createSecondaryValidationCellTemplate = function (dataItem) {
            var duplicateErrorText = this.i18n("DvsUi", "PrivateVlanPage.id.duplicate");
            var isolatedErrorText = this.i18n("DvsUi", "PrivateVlanPage.isolated.duplicate");
            var isPromiscuous = dataItem.type === dvs_ui.PvlanType.promiscuous;
            var hasDuplicateError = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].errors.duplicate";
            var hasIsolatedError = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].errors.isolated";
            var hasErrors = "datagridOptions.pvlanMaps[" +
                dataItem.secondaryId.key + "].hasErrors()";
            return "\n            <div class=\"icon-container\" ng-if=\"!" + isPromiscuous + " && " + hasErrors + "\">\n               <a role=\"tooltip\" aria-haspopup=\"true\" class=\"tooltip tooltip-md tooltip-bottom-right\">\n                  <clr-icon shape=\"error\" class=\"is-error\" size=\"24\"></clr-icon>\n                  <span class=\"tooltip-content\">\n                     <div ng-if=\"" + hasDuplicateError + "\">\n                        " + duplicateErrorText + "\n                     </div>\n                     <div ng-if=\"" + hasIsolatedError + "\">\n                        " + isolatedErrorText + "\n                     </div>\n                  </span>\n               </a>\n            </div>\n         ";
        };
        DvsEditPvlanDialogService.prototype.createPrimaryIdCellTemplate = function (dataItem) {
            return "\n            <div ng-if=\"datagridOptions.selectedItems[0] === dataItem\">\n               <input type=\"number\"\n                   ng-model=\"dataItem.primaryId.val\"\n                   vx-focus-and-select\n                   ng-change=\"datagridOptions.updatePvlanIdValue(dataItem.primaryId)\"\n                   ng-blur=\"datagridOptions.validateDuplicatePvlanMaps()\"/>\n            </div>\n            <div ng-if=\"datagridOptions.selectedItems[0] !== dataItem\">{{dataItem.primaryId.val}}</div>\n         ";
        };
        DvsEditPvlanDialogService.prototype.createSecondaryIdCellTemplate = function (dataItem) {
            if (dataItem.type === dvs_ui.PvlanType.promiscuous) {
                return "{{ datagridOptions.pvlanMap.secondaryId.val }}";
            }
            return "\n            <div ng-if=\"datagridOptions.selectedItems[0] === dataItem\">\n            <input type=\"number\"\n                   ng-model=\"dataItem.secondaryId.val\"\n                   vx-focus-and-select\n                   ng-change=\"datagridOptions.updatePvlanIdValue(dataItem.secondaryId)\"\n                   ng-blur=\"datagridOptions.validateDuplicatePvlanMaps()\"/>\n            </div>\n            <div ng-if=\"datagridOptions.selectedItems[0] !== dataItem\">{{dataItem.secondaryId.val}}</div>\n         ";
        };
        DvsEditPvlanDialogService.prototype.createPvlanTypeCellTemplate = function (dataItem) {
            if (dataItem.type === dvs_ui.PvlanType.promiscuous) {
                return this.localizePvlanType(dvs_ui.PvlanType.promiscuous);
            }
            return "\n            <div class='select' ng-if=\"datagridOptions.selectedItems[0] === dataItem\"> \n               <select \n                       ng-options=\"item.value as item.label for item in datagridOptions.typeOptions\"\n                       ng-change=\"datagridOptions.updatePvlanType(dataItem)\"\n                       ng-model=\"dataItem.type\">\n               </select> \n            </div>\n            <div ng-if=\"datagridOptions.selectedItems[0] !== dataItem\">{{datagridOptions.localizePvlanType(dataItem.type)}}</div>\n         ";
        };
        DvsEditPvlanDialogService.$inject = [
            "dataService",
            "mutationService",
            "i18nService",
            "clarityModalService",
            "clarityConstants",
            "vuiConstants",
            "vimEntityEscapingService"
        ];
        return DvsEditPvlanDialogService;
    }());
    dvs_ui.DvsEditPvlanDialogService = DvsEditPvlanDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditPvlanDialogService", DvsEditPvlanDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PvlanMapEntry = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$PvlanMapEntry;
    var DvsConfigSpec = com.vmware.vsphere.client.dvs.api.spec.DvsConfigSpec;
    var VmwareDvsConfigSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$ConfigSpec;
    var PvlanConfigSpec = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$PvlanConfigSpec;
    /**
     * Represents the data, received from the backend
     */
    var DvsEditPvlanDialogModel = (function () {
        function DvsEditPvlanDialogModel(data) {
            this.name = data.name;
            this.configVersion = data.configVersion;
            this.pvlansInitial = data.pvlans;
            this.pvlanIds = this.extractUniqueIds();
            this.pvlanMaps = this.buildPvlanMaps();
        }
        DvsEditPvlanDialogModel.prototype.buildSpec = function () {
            var _this = this;
            var pvlansUpdated = this.buildPvlansUpdated();
            var pvlanConfigSpecs = [];
            _.forEach(this.pvlansInitial, function (iterated) {
                var found = _.findWhere(pvlansUpdated, { secondaryVlanId: iterated.secondaryVlanId });
                if (found) {
                    found.isFound = true;
                    if (iterated.primaryVlanId !== found.primaryVlanId ||
                        iterated.pvlanType !== found.pvlanType) {
                        pvlanConfigSpecs
                            .push(_this.buildPvlanSpec(found, PvlanOperationType.edit));
                    }
                }
                else {
                    pvlanConfigSpecs
                        .push(_this.buildPvlanSpec(iterated, PvlanOperationType.remove));
                }
            });
            _.forEach(pvlansUpdated, function (iterated) {
                if (!iterated.isFound) {
                    pvlanConfigSpecs
                        .push(_this.buildPvlanSpec(iterated, PvlanOperationType.add));
                }
            });
            if (_.isEmpty(pvlanConfigSpecs)) {
                return null;
            }
            var dvsConfigSpec = new DvsConfigSpec();
            dvsConfigSpec.configSpec = new VmwareDvsConfigSpec();
            dvsConfigSpec.configSpec.configVersion = this.configVersion;
            dvsConfigSpec.configSpec.pvlanConfigSpec = pvlanConfigSpecs;
            return dvsConfigSpec;
        };
        DvsEditPvlanDialogModel.prototype.updateIsolatedError = function (selectedPrimaryIdKey, secondaryDatagridData) {
            var isolated = _.filter(secondaryDatagridData, function (map) {
                return map.type === dvs_ui.PvlanType.isolated;
            });
            var nonIsolated = _.difference(secondaryDatagridData, isolated);
            _.forEach(isolated, function (pvlanMap) {
                pvlanMap.errors.isolated = isolated.length > 1;
            });
            _.forEach(nonIsolated, function (pvlanMap) {
                pvlanMap.errors.isolated = false;
            });
            this.pvlanMaps[selectedPrimaryIdKey].errors.secondaryIsolated =
                isolated.length > 1;
        };
        DvsEditPvlanDialogModel.prototype.updateDuplicateError = function () {
            var _this = this;
            var duplicatePvlanMaps = this.getDuplicatePvlanMaps();
            var nonDuplicatePvlanMaps = _.difference(_.values(this.pvlanMaps), duplicatePvlanMaps);
            _.forEach(duplicatePvlanMaps, function (pvlanMap) {
                pvlanMap.errors.duplicate = true;
                if (pvlanMap.type !== dvs_ui.PvlanType.promiscuous) {
                    _this.pvlanMaps[pvlanMap.primaryId.key].errors.secondaryDuplicate =
                        true;
                }
            });
            _.forEach(nonDuplicatePvlanMaps, function (pvlanMap) {
                pvlanMap.errors.duplicate = false;
                if (pvlanMap.type === dvs_ui.PvlanType.promiscuous) {
                    _this.pvlanMaps[pvlanMap.primaryId.key].errors.secondaryDuplicate =
                        true;
                }
            });
            _.forEach(this.pvlanMaps, function (pvlanMapPrimary) {
                if (pvlanMapPrimary.type === dvs_ui.PvlanType.promiscuous) {
                    pvlanMapPrimary.errors.secondaryDuplicate =
                        _this.isDuplicateInPvlanMaps(pvlanMapPrimary);
                }
            });
        };
        DvsEditPvlanDialogModel.prototype.isDuplicateInPvlanMaps = function (pvlanMapPrimary) {
            var filtered = this.filterPvlanMapsByPrimaryId(this.pvlanMaps, pvlanMapPrimary.primaryId.key);
            var found = _.find(filtered, function (pvlanMapSecondary) {
                return pvlanMapSecondary.type !== dvs_ui.PvlanType.promiscuous &&
                    pvlanMapSecondary.errors.duplicate;
            });
            return !!found;
        };
        DvsEditPvlanDialogModel.prototype.getDuplicatePvlanMaps = function () {
            // create an array to fill with the duplicate items
            var duplicate = [];
            // sort the items by their value
            var sorted = this.sortPvlanMaps(_.values(this.pvlanMaps));
            // compare the value of each item with the previous one
            for (var i = 1; i < sorted.length; i++) {
                var current = sorted[i];
                var previous = sorted[i - 1];
                if (current.secondaryId.val === previous.secondaryId.val) {
                    // current and previous have the same values
                    if (_.last(duplicate) !== previous) {
                        // previous has not been pushed
                        duplicate.push(previous);
                    }
                    duplicate.push(current);
                }
            }
            return duplicate;
        };
        DvsEditPvlanDialogModel.prototype.sortPvlanMaps = function (pvlanMaps) {
            return _.sortBy(pvlanMaps, function (pvlanMap) {
                return pvlanMap.secondaryId.val;
            });
        };
        DvsEditPvlanDialogModel.prototype.filterPvlanMapsByPrimaryId = function (pvlanMaps, selectedPrimaryIdKey) {
            return _.filter(_.values(pvlanMaps), function (pvlanMap) {
                return pvlanMap.primaryId.key === selectedPrimaryIdKey;
            });
        };
        /**
         * Extract all the unique ids from a PvlanMapEntry array
         * and wraps them in a PvlanIdModel
         *
         * @returns {Dictionary<PvlanIdModel>} - all the unique pvlanIDs wrapped in
         * PvlanIdModel objects so they can be accessed by reference and can contain
         * a unique readonly key, but still their value can be modified
         */
        DvsEditPvlanDialogModel.prototype.extractUniqueIds = function () {
            var secondaryVlanIds = _.pluck(this.pvlansInitial, "secondaryVlanId");
            var uniqueIds = {};
            _.forEach(secondaryVlanIds, function (vlanId) {
                uniqueIds[vlanId] = new dvs_ui.PvlanIdModel(vlanId, vlanId);
            });
            return uniqueIds;
        };
        /**
         * @returns {Dictionary<PvlanMapModel>} - a duplicate of the PvlanMapEntry[] array
         * that is received as a parameter, with its numeric primary and secondary ids
         * replaced by their PvlanIdModel wrapper
         */
        DvsEditPvlanDialogModel.prototype.buildPvlanMaps = function () {
            var _this = this;
            var pvlanMaps = {};
            _.forEach(this.pvlansInitial, function (pvlanMapEntry) {
                var primaryId = _this.pvlanIds[pvlanMapEntry.primaryVlanId];
                var secondaryId = _this.pvlanIds[pvlanMapEntry.secondaryVlanId];
                pvlanMaps[pvlanMapEntry.secondaryVlanId] =
                    new dvs_ui.PvlanMapModel(primaryId, secondaryId, pvlanMapEntry.pvlanType);
            });
            return pvlanMaps;
        };
        DvsEditPvlanDialogModel.prototype.buildPvlanSpec = function (model, operation) {
            var entry = new PvlanMapEntry();
            entry.primaryVlanId = model.primaryVlanId;
            entry.secondaryVlanId = model.secondaryVlanId;
            entry.pvlanType = model.pvlanType;
            var spec = new PvlanConfigSpec();
            spec.pvlanEntry = entry;
            spec.operation = operation;
            return spec;
        };
        DvsEditPvlanDialogModel.prototype.buildPvlansUpdated = function () {
            return _.map(this.pvlanMaps, function (iterated) {
                return new dvs_ui.PvlanMapEntryExtended(iterated.primaryId.val, iterated.secondaryId.val, iterated.type);
            });
        };
        return DvsEditPvlanDialogModel;
    }());
    dvs_ui.DvsEditPvlanDialogModel = DvsEditPvlanDialogModel;
    var PvlanOperationType = (function () {
        function PvlanOperationType() {
        }
        PvlanOperationType.add = "add";
        PvlanOperationType.remove = "remove";
        PvlanOperationType.edit = "edit";
        return PvlanOperationType;
    }());
    dvs_ui.PvlanOperationType = PvlanOperationType;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    /**
     * Represents a pvlan id (primary or secondary)
     * Applicable when a pvlan id should be edited by value, not by reference
     */
    var PvlanIdModel = (function () {
        function PvlanIdModel(key, val) {
            this.key = key;
            this._val = val;
        }
        Object.defineProperty(PvlanIdModel.prototype, "val", {
            get: function () {
                return this._val;
            },
            set: function (val) {
                if (val !== null) {
                    if (val > dvs_ui.DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MAX) {
                        this._val = dvs_ui.DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MAX;
                    }
                    else if (val < dvs_ui.DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MIN) {
                        this._val = dvs_ui.DvsEditPvlanDialogConstants.PVLAN_ID_VALUE_MIN;
                    }
                    else if (val % 1 === 0) {
                        // the number is not an integer
                        this._val = val;
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        return PvlanIdModel;
    }());
    dvs_ui.PvlanIdModel = PvlanIdModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var dvs_ui;
(function (dvs_ui) {
    var PvlanMapEntry = com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$PvlanMapEntry;
    var PvlanMapEntryExtended = (function (_super) {
        __extends(PvlanMapEntryExtended, _super);
        function PvlanMapEntryExtended(primaryVlanId, secondaryVlanId, pvlanType) {
            _super.call(this);
            this.primaryVlanId = primaryVlanId;
            this.secondaryVlanId = secondaryVlanId;
            this.pvlanType = pvlanType;
            this.isFound = false;
        }
        return PvlanMapEntryExtended;
    }(PvlanMapEntry));
    dvs_ui.PvlanMapEntryExtended = PvlanMapEntryExtended;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    /**
     * Represents a PvlanMapEntry, but the primary and secondary pvlan ids
     * are replaced with PvlanIdModel, so their value can be modified,
     * but not their reference and they can keep a unique, non editable key
     */
    var PvlanMapModel = (function () {
        function PvlanMapModel(primaryId, secondaryId, type) {
            this.primaryId = primaryId;
            this.secondaryId = secondaryId;
            this.type = type;
            this.errors = new PvlanMapErrors();
        }
        PvlanMapModel.prototype.hasErrors = function () {
            return this.errors.duplicate || this.errors.isolated ||
                this.errors.secondaryDuplicate || this.errors.secondaryIsolated;
        };
        return PvlanMapModel;
    }());
    dvs_ui.PvlanMapModel = PvlanMapModel;
    var PvlanType = (function () {
        function PvlanType() {
        }
        PvlanType.promiscuous = "promiscuous";
        PvlanType.isolated = "isolated";
        PvlanType.community = "community";
        return PvlanType;
    }());
    dvs_ui.PvlanType = PvlanType;
    var PvlanMapErrors = (function () {
        function PvlanMapErrors() {
            this.duplicate = false;
            this.isolated = false;
            this.secondaryDuplicate = false;
            this.secondaryIsolated = false;
        }
        return PvlanMapErrors;
    }());
    dvs_ui.PvlanMapErrors = PvlanMapErrors;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var RemoveDvsDialogService = (function () {
        function RemoveDvsDialogService(clarityModalService, i18nService, dataService, mutationService, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        RemoveDvsDialogService.prototype.removeDvs = function (hostUrn, dvsName, dvsRef) {
            var _this = this;
            var removeDvsSpec = {
                _type: "com.vmware.vsphere.client.dvs.api.spec.DvsHostRemoveSpec",
                hosts: [this.defaultUriSchemeUtil.getManagedObjectReference(hostUrn)]
            };
            var submitCallback = function () {
                _this.mutationService.apply(dvsRef, removeDvsSpec._type, removeDvsSpec);
            };
            this.openConfirmationDialog(hostUrn, dvsName, submitCallback);
        };
        RemoveDvsDialogService.prototype.removeGhostDvs = function (hostUrn, dvsName, dvsUuid) {
            var _this = this;
            var ghostProxySwitchRemoveSpec = {
                _type: "com.vmware.vsphere.client.network.GhostProxySwitchRemoveSpec",
                dvsUuid: dvsUuid
            };
            var submitCallback = function () {
                _this.mutationService.apply(hostUrn, ghostProxySwitchRemoveSpec._type, ghostProxySwitchRemoveSpec);
            };
            this.openConfirmationDialog(hostUrn, dvsName, submitCallback);
        };
        RemoveDvsDialogService.prototype.openConfirmationDialog = function (hostUrn, dvsName, submitCallback) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "removeHostFromDvs.dialogCaption"),
                submit: submitCallback,
                saveButtonLabel: this.i18nService.getString('NetworkUi', 'NetworkUtil.labelYes'),
                cancelButtonLabel: this.i18nService.getString('NetworkUi', 'NetworkUtil.labelNo'),
                preserveNewlines: true,
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                }
            };
            this.dataService.getProperties(hostUrn, ["name"]).then(function (resp) {
                modalOptions.message = _this.i18nService.getString("DvsUi", "removeHostFromDvs.confirmWarning", resp.name, dvsName);
            });
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        RemoveDvsDialogService.$inject = [
            "clarityModalService",
            "i18nService",
            "dataService",
            "mutationService",
            "defaultUriSchemeUtil"
        ];
        return RemoveDvsDialogService;
    }());
    dvs_ui.RemoveDvsDialogService = RemoveDvsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("removeDvsDialogService", RemoveDvsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var NrpNavigatorService = (function () {
        function NrpNavigatorService() {
        }
        NrpNavigatorService.prototype.getNrpKey = function (objectId) {
            if (!this.isObjectIdValid(objectId)) {
                return "";
            }
            return objectId.substring(objectId.lastIndexOf(NrpNavigatorService.COLON_DELIMITER) + 1);
        };
        NrpNavigatorService.prototype.getDvsUrn = function (objectId) {
            if (!this.isObjectIdValid(objectId)) {
                return "";
            }
            var switchIdentifier = objectId.split(NrpNavigatorService.COLON_DELIMITER)[3];
            if (!this.isSwitchIdentifierValid(switchIdentifier)) {
                return "";
            }
            var serverUid = switchIdentifier.split(NrpNavigatorService.UNDERSCORE_DELIMITER)[0];
            var switchKey = switchIdentifier.split(NrpNavigatorService.UNDERSCORE_DELIMITER)[1];
            return "urn:vmomi:VmwareDistributedVirtualSwitch:" + switchKey + ":" + serverUid;
        };
        NrpNavigatorService.prototype.isObjectIdValid = function (objectId) {
            return !!objectId && objectId.split(NrpNavigatorService.COLON_DELIMITER).length === 5;
        };
        NrpNavigatorService.prototype.isSwitchIdentifierValid = function (switchIdentifier) {
            return !!switchIdentifier && switchIdentifier.split(NrpNavigatorService.UNDERSCORE_DELIMITER).length === 2;
        };
        NrpNavigatorService.UNDERSCORE_DELIMITER = "_";
        NrpNavigatorService.COLON_DELIMITER = ":";
        return NrpNavigatorService;
    }());
    dvs_ui.NrpNavigatorService = NrpNavigatorService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("nrpNavigatorService", NrpNavigatorService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var NrpNavigatorPortgroupsViewComponent = (function () {
        function NrpNavigatorPortgroupsViewComponent() {
            this.bindings = {};
            this.controller = NrpNavigatorViewPortgroupsController;
            this.template = "<nrp-portgroups-list [dvs-urn]=\"$ctrl.dvsUrn\"\n                                               [selected-nrp-key]=\"$ctrl.nrpKey\"\n                                               class=\"fill-parent dvs-nrp-navigator-view\"></nrp-portgroups-list>";
        }
        return NrpNavigatorPortgroupsViewComponent;
    }());
    dvs_ui.NrpNavigatorPortgroupsViewComponent = NrpNavigatorPortgroupsViewComponent;
    var NrpNavigatorViewPortgroupsController = (function () {
        function NrpNavigatorViewPortgroupsController($rootScope, nrpNavigatorService) {
            this.$rootScope = $rootScope;
            this.nrpNavigatorService = nrpNavigatorService;
            var objectId = this.$rootScope._route.objectId;
            this.nrpKey = this.nrpNavigatorService.getNrpKey(objectId);
            this.dvsUrn = this.nrpNavigatorService.getDvsUrn(objectId);
        }
        NrpNavigatorViewPortgroupsController.$inject = [
            "$rootScope",
            "nrpNavigatorService"
        ];
        return NrpNavigatorViewPortgroupsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("nrpNavigatorPortgroupsView", new NrpNavigatorPortgroupsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var NrpNavigatorVmViewComponent = (function () {
        function NrpNavigatorVmViewComponent() {
            this.bindings = {};
            this.controller = NrpNavigatorViewVmsController;
            this.template = "<nrp-vms-list [dvs-urn]=\"$ctrl.dvsUrn\"\n                                        [selected-nrp-key]=\"$ctrl.nrpKey\"\n                                        class=\"fill-parent dvs-nrp-navigator-view\"></nrp-vms-list>";
        }
        return NrpNavigatorVmViewComponent;
    }());
    dvs_ui.NrpNavigatorVmViewComponent = NrpNavigatorVmViewComponent;
    var NrpNavigatorViewVmsController = (function () {
        function NrpNavigatorViewVmsController($rootScope, nrpNavigatorService) {
            this.$rootScope = $rootScope;
            this.nrpNavigatorService = nrpNavigatorService;
            var objectId = this.$rootScope._route.objectId;
            this.nrpKey = this.nrpNavigatorService.getNrpKey(objectId);
            this.dvsUrn = this.nrpNavigatorService.getDvsUrn(objectId);
        }
        NrpNavigatorViewVmsController.$inject = [
            "$rootScope",
            "nrpNavigatorService"
        ];
        return NrpNavigatorViewVmsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("nrpNavigatorVmsView", new NrpNavigatorVmViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNrpOverviewComponent = (function () {
        function DvsNrpOverviewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = DvsNrpOverviewComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/resmgmt/nrp/views/dvsNrpOverviewComponentTemplate.html";
        }
        return DvsNrpOverviewComponent;
    }());
    dvs_ui.DvsNrpOverviewComponent = DvsNrpOverviewComponent;
    var DvsNrpOverviewComponentController = (function () {
        function DvsNrpOverviewComponentController(i18nService, vxPropertyViewService, numberFormatterService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.numberFormatterService = numberFormatterService;
        }
        DvsNrpOverviewComponentController.prototype.$onChanges = function () {
            if (this.data) {
                this.buildPropertyViewData();
            }
        };
        DvsNrpOverviewComponentController.prototype.buildPropertyViewData = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            var NO_DATA = this.i18nService.getString("DvsUi", "networkResourcePools.noData");
            var capacity = (this.data.capacity && this.data.capacity > 0)
                ? this.numberFormatterService.formatBandwidth(this.data.capacity, BandwidthUnit.MBITPS, BandwidthUnit.AUTO, 2, false)
                : NO_DATA;
            generalSection.property(this.i18nService.getString("DvsUi", "networkResourcePools.summary.totalBandwidth"), capacity);
            var vmTrafficReservation = (this.data.vmTrafficReservation && this.data.vmTrafficReservation > 0)
                ? this.numberFormatterService.formatBandwidth(this.data.vmTrafficReservation, BandwidthUnit.MBITPS, BandwidthUnit.AUTO)
                : NO_DATA;
            generalSection.property(this.i18nService.getString("DvsUi", "networkResourcePools.summary.vmTrafficReservation"), vmTrafficReservation);
            this.propertyViewData = builder.build();
        };
        DvsNrpOverviewComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "numberFormatterService"
        ];
        return DvsNrpOverviewComponentController;
    }());
    // in sync with format.ts in ng-next-app
    var BandwidthUnit;
    (function (BandwidthUnit) {
        BandwidthUnit[BandwidthUnit["BITPS"] = 0] = "BITPS";
        BandwidthUnit[BandwidthUnit["KBITPS"] = 1] = "KBITPS";
        BandwidthUnit[BandwidthUnit["MBITPS"] = 2] = "MBITPS";
        BandwidthUnit[BandwidthUnit["GBITPS"] = 3] = "GBITPS";
        BandwidthUnit[BandwidthUnit["TBITPS"] = 4] = "TBITPS";
        BandwidthUnit[BandwidthUnit["AUTO"] = 5] = "AUTO";
    })(BandwidthUnit || (BandwidthUnit = {}));
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNrpOverview", new DvsNrpOverviewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNrpReservationComponent = (function () {
        function DvsNrpReservationComponent() {
            this.bindings = {
                data: "<",
                dvsUrn: "<"
            };
            this.controller = DvsNrpReservationComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/resmgmt/nrp/views/dvsNrpReservationComponentTemplate.html";
        }
        return DvsNrpReservationComponent;
    }());
    dvs_ui.DvsNrpReservationComponent = DvsNrpReservationComponent;
    var DvsNrpReservationComponentController = (function () {
        function DvsNrpReservationComponentController(numberFormatterService) {
            this.numberFormatterService = numberFormatterService;
        }
        DvsNrpReservationComponentController.prototype.$onChanges = function () {
            if (this.data) {
                this.buildMeterData();
            }
        };
        DvsNrpReservationComponentController.prototype.buildMeterData = function () {
            this.groupedMeters = this.buildMeters();
            this.maxValue = this.numberFormatterService.formatBandwidth(this.data.configuredReservation, BandwidthUnit.MBITPS, BandwidthUnit.GBITPS, 2, false);
        };
        DvsNrpReservationComponentController.prototype.buildMeters = function () {
            var totalReservedPercentage = 0;
            if (this.data.configuredReservation > 0) {
                totalReservedPercentage =
                    ((this.data.grantedQuota + this.data.vmReservation)
                        / this.data.configuredReservation) * 100;
            }
            var nrpReservedPercentage = (this.data.grantedQuota / this.data.configuredReservation) * 100 || 0;
            var vmVnicReservedPercentage = (this.data.vmReservation / this.data.configuredReservation) * 100 || 0;
            var grantedQuotaMeter;
            var vmReservationMeter;
            var unusedBandwidthMeter;
            if (totalReservedPercentage <= 100) {
                grantedQuotaMeter = {
                    colorClass: "dvs-meter-light-blue",
                    value: nrpReservedPercentage
                };
                vmReservationMeter = {
                    colorClass: "dvs-meter-normal-blue",
                    value: vmVnicReservedPercentage
                };
                unusedBandwidthMeter = {
                    colorClass: "dvs-meter-white",
                    value: 100 - totalReservedPercentage
                };
            }
            else {
                grantedQuotaMeter = {
                    colorClass: "dvs-meter-red",
                    value: 100
                };
                vmReservationMeter = {
                    colorClass: "dvs-meter-normal-blue",
                    value: 0
                };
                unusedBandwidthMeter = {
                    colorClass: "dvs-meter-white",
                    value: 0
                };
            }
            return [grantedQuotaMeter, vmReservationMeter, unusedBandwidthMeter];
        };
        DvsNrpReservationComponentController.$inject = [
            "numberFormatterService"
        ];
        return DvsNrpReservationComponentController;
    }());
    // in sync with format.ts in ng-next-app
    var BandwidthUnit;
    (function (BandwidthUnit) {
        BandwidthUnit[BandwidthUnit["BITPS"] = 0] = "BITPS";
        BandwidthUnit[BandwidthUnit["KBITPS"] = 1] = "KBITPS";
        BandwidthUnit[BandwidthUnit["MBITPS"] = 2] = "MBITPS";
        BandwidthUnit[BandwidthUnit["GBITPS"] = 3] = "GBITPS";
        BandwidthUnit[BandwidthUnit["TBITPS"] = 4] = "TBITPS";
        BandwidthUnit[BandwidthUnit["AUTO"] = 5] = "AUTO";
    })(BandwidthUnit || (BandwidthUnit = {}));
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNrpReservation", new DvsNrpReservationComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsNrpViewComponent = (function () {
        function DvsNrpViewComponent() {
            this.bindings = {};
            this.controller = DvsNrpViewComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/resmgmt/nrp/views/dvsNrpViewComponentTemplate.html";
        }
        return DvsNrpViewComponent;
    }());
    dvs_ui.DvsNrpViewComponent = DvsNrpViewComponent;
    var DvsNrpViewComponentController = (function () {
        function DvsNrpViewComponentController($rootScope, i18nService, dataService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.liveRefreshProperties = ["config.vmVnicNetworkResourcePool"];
            this.dvsUrn = $rootScope._route.objectId;
        }
        DvsNrpViewComponentController.prototype.$onInit = function () {
            if (this.dvsUrn) {
                this.refresh();
            }
        };
        DvsNrpViewComponentController.prototype.refresh = function () {
            var _this = this;
            this.dataService.getProperties(this.dvsUrn, [DvsNrpViewComponentController.DATA_PROPERTY])
                .then(function (response) {
                if (response) {
                    var data = response[DvsNrpViewComponentController.DATA_PROPERTY];
                    if (data) {
                        _this.meterData = data.meterData;
                        _this.overviewData = data.overviewData;
                        _this.setAlertText();
                        _this.setShowInfoBanner();
                    }
                }
            });
        };
        DvsNrpViewComponentController.prototype.setAlertText = function () {
            if (!this.meterData) {
                this.alertText = null;
                return;
            }
            var totalReservation = this.meterData.grantedQuota + this.meterData.vmReservation;
            this.alertText = (totalReservation > this.meterData.configuredReservation)
                ? this.i18nService.getString("DvsUi", "networkResourcePools.error.reservationQuota")
                : null;
        };
        DvsNrpViewComponentController.prototype.setShowInfoBanner = function () {
            this.showInfoBanner =
                this.overviewData && this.overviewData.vmTrafficReservation <= 0;
        };
        DvsNrpViewComponentController.$inject = [
            "$rootScope",
            "i18nService",
            "dataService"
        ];
        DvsNrpViewComponentController.DATA_PROPERTY = "dvsresmgmt:networkResourcePoolsData";
        return DvsNrpViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsNrpView", new DvsNrpViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSystemTrafficOverviewComponent = (function () {
        function DvsSystemTrafficOverviewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = DvsSystemTrafficOverviewComponentController;
            this.template =
                "<vx-property-view data=\"$ctrl.propertyViewData\"></vx-property-view>";
        }
        return DvsSystemTrafficOverviewComponent;
    }());
    dvs_ui.DvsSystemTrafficOverviewComponent = DvsSystemTrafficOverviewComponent;
    var DvsSystemTrafficOverviewComponentController = (function () {
        function DvsSystemTrafficOverviewComponentController(i18nService, vxPropertyViewService, numberFormatterService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.numberFormatterService = numberFormatterService;
        }
        DvsSystemTrafficOverviewComponentController.prototype.$onChanges = function () {
            if (this.data) {
                this.buildPropertyViewData(this.data);
            }
        };
        DvsSystemTrafficOverviewComponentController.prototype.buildPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            var NO_DATA = this.i18nService.getString("DvsUi", "systemTrafficList.noData");
            var niocEnabled = data.niocEnabled
                ? this.i18nService.getString("DvsUi", "systemTrafficView.summary.niocStatus.enabled")
                : this.i18nService.getString("DvsUi", "systemTrafficView.summary.niocStatus.disabled");
            generalSection.property(this.i18nService.getString("DvsUi", "systemTrafficView.summary.resourceManagementStatus"), niocEnabled || NO_DATA);
            generalSection.property(this.i18nService.getString("DvsUi", "systemTrafficView.summary.resourceManagementVersion"), data.niocVersion || NO_DATA);
            var numPnics = (data.excludedPnics && data.excludedPnics > 0)
                ? this.i18nService.getString("DvsUi", "systemTrafficView.summary.totalPhysicalNicCountWithExclusion", data.numPnics, data.excludedPnics)
                : data.numPnics;
            generalSection.property(this.i18nService.getString("DvsUi", "systemTrafficView.summary.totalPhysicalNicCount"), numPnics || NO_DATA);
            var minLinkSpeed = (data.minPnicSpeed && data.minPnicSpeed > 0)
                ? this.numberFormatterService.formatBandwidth(data.minPnicSpeed, BandwidthUnit.MBITPS, BandwidthUnit.AUTO)
                : NO_DATA;
            generalSection.property(this.i18nService.getString("DvsUi", "systemTrafficView.summary.minimumLinkSpeed"), minLinkSpeed);
            this.propertyViewData = builder.build();
        };
        DvsSystemTrafficOverviewComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "numberFormatterService"
        ];
        return DvsSystemTrafficOverviewComponentController;
    }());
    // in sync with format.ts in ng-next-app
    var BandwidthUnit;
    (function (BandwidthUnit) {
        BandwidthUnit[BandwidthUnit["BITPS"] = 0] = "BITPS";
        BandwidthUnit[BandwidthUnit["KBITPS"] = 1] = "KBITPS";
        BandwidthUnit[BandwidthUnit["MBITPS"] = 2] = "MBITPS";
        BandwidthUnit[BandwidthUnit["GBITPS"] = 3] = "GBITPS";
        BandwidthUnit[BandwidthUnit["TBITPS"] = 4] = "TBITPS";
        BandwidthUnit[BandwidthUnit["AUTO"] = 5] = "AUTO";
    })(BandwidthUnit || (BandwidthUnit = {}));
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSystemTrafficOverview", new DvsSystemTrafficOverviewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSystemTrafficReservationComponent = (function () {
        function DvsSystemTrafficReservationComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = DvsSystemTrafficReservationComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/resmgmt/systemtraffic/views/dvsSystemTrafficReservationComponentTemplate.html";
        }
        return DvsSystemTrafficReservationComponent;
    }());
    dvs_ui.DvsSystemTrafficReservationComponent = DvsSystemTrafficReservationComponent;
    var DvsSystemTrafficReservationComponentController = (function () {
        function DvsSystemTrafficReservationComponentController(i18nService, numberFormatterService) {
            this.i18nService = i18nService;
            this.numberFormatterService = numberFormatterService;
        }
        DvsSystemTrafficReservationComponentController.prototype.$onChanges = function () {
            if (!this.data) {
                return;
            }
            var reservedPercentage = (this.data.reserved / this.data.capacity) * 100 || 0;
            var colorClass = reservedPercentage <= this.data.ratio
                ? "bandwidth-reservation-satisfied"
                : "bandwidth-reservation-unsatisfied";
            this.meters = [{
                    colorClass: colorClass,
                    value: reservedPercentage < this.data.ratio
                        ? reservedPercentage
                        : Math.min(reservedPercentage, 100),
                    label: reservedPercentage + "%"
                }];
            this.maxValue = this.numberFormatterService.formatBandwidth(this.data.capacity, BandwidthUnit.MBITPS, BandwidthUnit.GBITPS, 2, false);
            if (this.data.capacity > 0) {
                this.pointers = [{
                        colorClass: "bandwidth-reservation-margin",
                        value: this.data.ratio,
                        size: 19,
                        label: this.numberFormatterService.formatBandwidth(this.data.capacity * (this.data.ratio / 100), BandwidthUnit.MBITPS, BandwidthUnit.GBITPS, 2, false)
                    }];
            }
            else {
                this.pointers = [];
            }
            this.buildLegendData();
        };
        DvsSystemTrafficReservationComponentController.prototype.buildLegendData = function () {
            this.legendData = {
                capacity: this.data.capacity,
                allowed: this.data.capacity * (this.data.ratio / 100),
                reserved: this.data.reserved,
                available: this.data.available > 0 ? this.data.available : 0,
                ratio: this.data.ratio
            };
        };
        DvsSystemTrafficReservationComponentController.$inject = [
            "i18nService",
            "numberFormatterService"
        ];
        return DvsSystemTrafficReservationComponentController;
    }());
    // in sync with format.ts in ng-next-app
    var BandwidthUnit;
    (function (BandwidthUnit) {
        BandwidthUnit[BandwidthUnit["BITPS"] = 0] = "BITPS";
        BandwidthUnit[BandwidthUnit["KBITPS"] = 1] = "KBITPS";
        BandwidthUnit[BandwidthUnit["MBITPS"] = 2] = "MBITPS";
        BandwidthUnit[BandwidthUnit["GBITPS"] = 3] = "GBITPS";
        BandwidthUnit[BandwidthUnit["TBITPS"] = 4] = "TBITPS";
        BandwidthUnit[BandwidthUnit["AUTO"] = 5] = "AUTO";
    })(BandwidthUnit || (BandwidthUnit = {}));
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSystemTrafficReservation", new DvsSystemTrafficReservationComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsSystemTrafficViewData = com.vmware.vsphere.client.h5.network.dvs.resmgmt.systemtraffic.model.DvsSystemTrafficViewData;
    var DvsSystemTrafficViewComponent = (function () {
        function DvsSystemTrafficViewComponent() {
            this.bindings = {};
            this.controller = DvsSystemTrafficViewComponentController;
            this.templateUrl =
                "dvs-ui/resources/dvs/resmgmt/systemtraffic/views/dvsSystemTrafficViewComponentTemplate.html";
        }
        return DvsSystemTrafficViewComponent;
    }());
    dvs_ui.DvsSystemTrafficViewComponent = DvsSystemTrafficViewComponent;
    var DvsSystemTrafficViewComponentController = (function () {
        function DvsSystemTrafficViewComponentController($rootScope, i18nService, dataService, vxPropertyViewService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.dvsUrn = $rootScope._route.objectId;
            this.watchForObjects = [this.dvsUrn];
            this.liveRefreshProperties = [
                "config.networkResourceManagementEnabled",
                "config.networkResourceManagementVersion",
                "config.infrastructureTrafficResourceConfig"
            ];
            this.data = new DvsSystemTrafficViewData();
            this.loading = false;
        }
        DvsSystemTrafficViewComponentController.prototype.$onInit = function () {
            this.loading = true;
            this.requestData();
        };
        DvsSystemTrafficViewComponentController.prototype.requestData = function () {
            var _this = this;
            this.dataService.getProperties(this.dvsUrn, [DvsSystemTrafficViewComponentController.DATA_PROPERTY])
                .then(function (response) {
                if (response) {
                    _this.data =
                        response[DvsSystemTrafficViewComponentController.DATA_PROPERTY];
                    _this.alertText = null;
                    if (_this.data) {
                        _this.setAlertText();
                    }
                    _this.loading = false;
                }
            });
        };
        DvsSystemTrafficViewComponentController.prototype.setAlertText = function () {
            if (!this.data.overviewData || !this.data.meterData) {
                return;
            }
            if (this.data.overviewData.numPnics > 0) {
                var allowedReservation = this.data.meterData.capacity * (this.data.meterData.ratio / 100);
                if (this.data.meterData.reserved > allowedReservation) {
                    this.alertText =
                        this.i18nService.getString("DvsUi", "systemTrafficView.error.reservationExceedsMaximum", this.data.meterData.ratio);
                }
            }
            else {
                if (this.data.meterData.reserved > 0) {
                    this.alertText =
                        this.i18nService.getString("DvsUi", "systemTrafficView.error.cannotGuaranteeReservation");
                }
            }
        };
        DvsSystemTrafficViewComponentController.$inject = [
            "$rootScope",
            "i18nService",
            "dataService",
            "vxPropertyViewService"
        ];
        DvsSystemTrafficViewComponentController.DATA_PROPERTY = "dvsresmgmt:systemTrafficViewData";
        return DvsSystemTrafficViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsSystemTrafficView", new DvsSystemTrafficViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsPropertiesComponent = (function () {
        function DvsPropertiesComponent() {
            this.bindings = {};
            this.controller = DvsPropertiesController;
            this.templateUrl = "dvs-ui/resources/dvs/settings/dvsPropertiesTemplate.html";
        }
        return DvsPropertiesComponent;
    }());
    dvs_ui.DvsPropertiesComponent = DvsPropertiesComponent;
    var DvsPropertiesController = (function () {
        function DvsPropertiesController($rootScope, i18nService, networkUtil) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this._actions = [{
                    actionUid: "vsphere.core.dvs.editSettings",
                    customLabel: this.i18nService.getString("DvsUi", "DvsPropertiesView.edit.label")
                }];
        }
        Object.defineProperty(DvsPropertiesController.prototype, "actions", {
            get: function () {
                return this._actions;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsPropertiesController.prototype, "dvsUri", {
            get: function () {
                var currentRouteId = this.$rootScope._route.objectId;
                // Ignore if the route object is not a distributed switch
                if (this.networkUtil.isDistributedSwitch(currentRouteId)) {
                    return currentRouteId;
                }
                return "";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsPropertiesController.prototype, "title", {
            get: function () {
                return this.i18nService.getString("NetworkUi", "VSwitchPropertiesView.title");
            },
            enumerable: true,
            configurable: true
        });
        DvsPropertiesController.$inject = [
            "$rootScope",
            "i18nService",
            "networkUtil"
        ];
        return DvsPropertiesController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsProperties", new DvsPropertiesComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsDialogManager = (function () {
        function DvsEditSettingsDialogManager(dialogScope, vuiConstants, mutationService) {
            this.dialogScope = dialogScope;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
        }
        DvsEditSettingsDialogManager.prototype.showDialogErrors = function (errors) {
            var _this = this;
            if (!errors || errors.length < 1) {
                return;
            }
            this.dialogScope.dialogOptions.validationBanner.messages = _.map(errors, function (message) {
                return {
                    type: _this.vuiConstants.validationBanner.type.ERROR,
                    text: message
                };
            });
        };
        DvsEditSettingsDialogManager.prototype.submitDialog = function () {
            var generalPageChanges = this.dialogScope.generalPageModel.buildChanges(this.dialogScope.originalData);
            var advancedPageChanges = this.dialogScope.advancedPageModel.buildChanges(this.dialogScope.originalData);
            // Whether any page has changes
            var hasChanges = generalPageChanges !== null || advancedPageChanges !== null;
            if (hasChanges) {
                var dvsConfigSpec = {
                    _type: DvsEditSettingsDialogManager.DVS_CONFIG_SPEC,
                    configSpec: {
                        _type: DvsEditSettingsDialogManager.DVS_CONFIG_SPEC_BINDING,
                        configVersion: this.dialogScope.originalData.configVersion
                    }
                };
                // General page
                if (generalPageChanges !== null) {
                    dvsConfigSpec.configSpec.name = generalPageChanges.name;
                    dvsConfigSpec.configSpec.description = generalPageChanges.description;
                    if (generalPageChanges.uplinkPortNames) {
                        dvsConfigSpec.configSpec.uplinkPortPolicy = {
                            _type: DvsEditSettingsDialogManager.UPLINK_POLICY_SPEC,
                            uplinkPortName: generalPageChanges.uplinkPortNames
                        };
                    }
                    dvsConfigSpec.enableResourceManagement = generalPageChanges.isNiocEnabled;
                }
                // Advanced page
                if (advancedPageChanges !== null) {
                    if (advancedPageChanges.mtu !== null) {
                        dvsConfigSpec.configSpec.maxMtu = advancedPageChanges.mtu;
                    }
                    if (advancedPageChanges.multicastFilteringMode !== null) {
                        dvsConfigSpec.configSpec.multicastFilteringMode = advancedPageChanges.multicastFilteringMode;
                    }
                    if (advancedPageChanges.ldpProtocol !== null
                        || advancedPageChanges.ldpOperation !== null) {
                        dvsConfigSpec.configSpec.linkDiscoveryProtocolConfig = {
                            _type: DvsEditSettingsDialogManager.LDP_CONFIG_SPEC,
                            protocol: advancedPageChanges.ldpProtocol,
                            operation: advancedPageChanges.ldpOperation
                        };
                    }
                    if (advancedPageChanges.contactName !== null
                        || advancedPageChanges.contactDetails !== null) {
                        dvsConfigSpec.configSpec.contact = {
                            _type: DvsEditSettingsDialogManager.DVS_CONTACT_INFO,
                            name: advancedPageChanges.contactName !== null
                                ? advancedPageChanges.contactName
                                : this.dialogScope.originalData.contactName,
                            contact: advancedPageChanges.contactDetails !== null
                                ? advancedPageChanges.contactDetails
                                : this.dialogScope.originalData.contactDetails
                        };
                    }
                }
                this.mutationService.apply(this.dialogScope.dvsUrn, DvsEditSettingsDialogManager.DVS_CONFIG_SPEC, dvsConfigSpec);
            }
            return true;
        };
        DvsEditSettingsDialogManager.DVS_CONFIG_SPEC = "com.vmware.vsphere.client.dvs.api.spec.DvsConfigSpec";
        DvsEditSettingsDialogManager.DVS_CONFIG_SPEC_BINDING = "com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$ConfigSpec";
        DvsEditSettingsDialogManager.UPLINK_POLICY_SPEC = "com.vmware.vim.binding.vim.DistributedVirtualSwitch$NameArrayUplinkPortPolicy";
        DvsEditSettingsDialogManager.LDP_CONFIG_SPEC = "com.vmware.vim.binding.vim.host.LinkDiscoveryProtocolConfig";
        DvsEditSettingsDialogManager.DVS_CONTACT_INFO = "com.vmware.vim.binding.vim.DistributedVirtualSwitch$ContactInfo";
        return DvsEditSettingsDialogManager;
    }());
    dvs_ui.DvsEditSettingsDialogManager = DvsEditSettingsDialogManager;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsDialogManagerFactory = (function () {
        function DvsEditSettingsDialogManagerFactory(vuiConstants, mutationService) {
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
        }
        DvsEditSettingsDialogManagerFactory.prototype.createManager = function (dialogScope) {
            return new dvs_ui.DvsEditSettingsDialogManager(dialogScope, this.vuiConstants, this.mutationService);
        };
        DvsEditSettingsDialogManagerFactory.$inject = [
            "vuiConstants",
            "mutationService"
        ];
        return DvsEditSettingsDialogManagerFactory;
    }());
    dvs_ui.DvsEditSettingsDialogManagerFactory = DvsEditSettingsDialogManagerFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSettingsDialogManagerFactory", DvsEditSettingsDialogManagerFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsDialogService = (function () {
        function DvsEditSettingsDialogService($rootScope, vxMultiPageDialogService, i18nService, dataService, mutationService, authorizationService, networkUiConstants, generalPageValidator, advancedPageValidator, managerFactory) {
            this.$rootScope = $rootScope;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.authorizationService = authorizationService;
            this.networkUiConstants = networkUiConstants;
            this.generalPageValidator = generalPageValidator;
            this.advancedPageValidator = advancedPageValidator;
            this.managerFactory = managerFactory;
        }
        /**
         * Shows the Edit DVS settings dialog.
         */
        DvsEditSettingsDialogService.prototype.show = function (dvsUrn) {
            var dialogScope = this.$rootScope.$new();
            var dialogManager = this.managerFactory.createManager(dialogScope);
            dialogScope.dvsUrn = dvsUrn;
            dialogScope.generalPageModel = new dvs_ui.DvsEditSettingsGeneralPageModel();
            dialogScope.advancedPageModel = new dvs_ui.DvsEditSettingsAdvancedPageModel();
            dialogScope.dialogOptions = this.createDialogOptions();
            dialogScope.dialogOptions.pages = this.createPages(dialogManager);
            dialogScope.dialogOptions.confirmOptions = {
                onClick: function () {
                    return dialogManager.submitDialog();
                }
            };
            var options = {
                scope: dialogScope,
                configObjectName: "dialogOptions"
            };
            this.vxMultiPageDialogService(options);
            this.requestData(dialogScope);
            this.requestPrivileges(dialogScope);
        };
        DvsEditSettingsDialogService.prototype.requestData = function (dialogScope) {
            var _this = this;
            this.dataService.getProperties(dialogScope.dvsUrn, [DvsEditSettingsDialogService.DATA_PROPERTY])
                .then(function (result) {
                if (result && result[DvsEditSettingsDialogService.DATA_PROPERTY]) {
                    var data = result[DvsEditSettingsDialogService.DATA_PROPERTY];
                    var trimmedName = data.name.trim();
                    var escapedName = trimmedName.replace(/%25/g, "%")
                        .replace(/%2f/g, "\/").replace(/%5c/g, "\\");
                    data.name = escapedName;
                    dialogScope.generalPageModel.name = data.name;
                    dialogScope.generalPageModel.description = data.description;
                    dialogScope.generalPageModel.maxNumUplinks = data.maxNumUplinks;
                    dialogScope.generalPageModel.uplinkPortNames = data.uplinkPortNames;
                    dialogScope.generalPageModel.isNiocEnabled = data.isNiocEnabled;
                    dialogScope.generalPageModel.isNiocSupported = data.isNiocSupported;
                    dialogScope.advancedPageModel.mtu = data.mtu;
                    dialogScope.advancedPageModel.multicastFilteringMode =
                        data.multicastFilteringMode;
                    dialogScope.advancedPageModel.multicastSnoopingSupported =
                        data.multicastSnoopingSupported;
                    dialogScope.advancedPageModel.lldpSupported = data.lldpSupported;
                    if (data.ldpOperation !== _this.networkUiConstants.LinkDiscoveryOperation.DISABLED) {
                        dialogScope.advancedPageModel.ldpProtocol = data.ldpProtocol;
                        dialogScope.advancedPageModel.ldpOperation = data.ldpOperation;
                    }
                    else {
                        dialogScope.advancedPageModel.ldpProtocol =
                            dvs_ui.DvsEditSettingsAdvancedPageModel.LDP_PROTOCOL_DISABLED;
                        dialogScope.advancedPageModel.ldpOperation =
                            _this.networkUiConstants.LinkDiscoveryOperation.LISTEN;
                    }
                    dialogScope.advancedPageModel.contactName = data.contactName;
                    dialogScope.advancedPageModel.contactDetails = data.contactDetails;
                    dialogScope.originalData = data;
                    dialogScope.originalData.initialLdpProtocol =
                        dialogScope.advancedPageModel.ldpProtocol;
                    dialogScope.originalData.initialLdpOperation =
                        dialogScope.advancedPageModel.ldpOperation;
                    dialogScope.dialogOptions.title =
                        _this.i18nService.getString("NetworkUi", "DvsConfigPage.titleFormat", data.name);
                    dialogScope.dialogOptions.loading = false;
                }
            });
        };
        DvsEditSettingsDialogService.prototype.requestPrivileges = function (dialogScope) {
            var privileges = [
                DvsEditSettingsDialogService.DVS_MODIFY_PRIVILEGE,
                DvsEditSettingsDialogService.DVS_RES_MGMT_PRIVILEGE
            ];
            this.authorizationService.checkPrivileges(dialogScope.dvsUrn, privileges)
                .then(function (result) {
                if (result) {
                    dialogScope.generalPageModel.hasModifyPrivilege = result[0];
                    dialogScope.generalPageModel.hasNiocPrivilege = result[1];
                    dialogScope.advancedPageModel.hasModifyPrivilege = result[0];
                }
            });
        };
        DvsEditSettingsDialogService.prototype.createDialogOptions = function () {
            return {
                title: this.i18nService.getString("NetworkUi", "DvsConfigPage.initialTitle"),
                iconClass: "network-lib-ui-icon-dvsEdit",
                show: true,
                loading: true,
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                validationBanner: {},
                rejectOptions: {
                    rejectOnEsc: true
                },
                resizable: true,
                draggable: true,
                maximizable: true
            };
        };
        DvsEditSettingsDialogService.prototype.createPages = function (dialogManager) {
            var _this = this;
            var pages = [];
            // General page
            pages.push({
                title: this.i18nService.getString("NetworkUi", "DvsConfigPage.general.title"),
                contentUrl: "dvs-ui/resources/dvs/settings/edit/pages/dvsEditSettingsGeneralPage.html",
                onCommit: function () {
                    var errors = _this.generalPageValidator.getAllErrors(dialogManager.dialogScope.generalPageModel);
                    if (errors && errors.length > 0) {
                        dialogManager.showDialogErrors(errors);
                        return false;
                    }
                    else {
                        return _this.generalPageValidator.getNameServerError(dialogManager.dialogScope.dvsUrn, dialogManager.dialogScope.generalPageModel.name)
                            .then(function (error) {
                            if (error) {
                                dialogManager.showDialogErrors([error]);
                                return false;
                            }
                            dialogManager.dialogScope.generalPageModel
                                .updateUplinkPortNames();
                            return true;
                        });
                    }
                }
            });
            // Advanced page
            pages.push({
                title: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.title"),
                contentUrl: "dvs-ui/resources/dvs/settings/edit/pages/dvsEditSettingsAdvancedPage.html",
                onCommit: function () {
                    var errors = _this.advancedPageValidator.getAllErrors(dialogManager.dialogScope.advancedPageModel);
                    if (errors && errors.length > 0) {
                        dialogManager.showDialogErrors(errors);
                        return false;
                    }
                    return true;
                }
            });
            return pages;
        };
        DvsEditSettingsDialogService.$inject = [
            "$rootScope",
            "vxMultiPageDialogService",
            "i18nService",
            "dataService",
            "mutationService",
            "authorizationService",
            "networkUiConstants",
            "dvsEditSettingsGeneralPageValidator",
            "dvsEditSettingsAdvancedPageValidator",
            "dvsEditSettingsDialogManagerFactory"
        ];
        DvsEditSettingsDialogService.DATA_PROPERTY = "dvsedit:settingsdata";
        DvsEditSettingsDialogService.DVS_MODIFY_PRIVILEGE = "DVSwitch.Modify";
        DvsEditSettingsDialogService.DVS_RES_MGMT_PRIVILEGE = "DVSwitch.ResourceManagement";
        return DvsEditSettingsDialogService;
    }());
    dvs_ui.DvsEditSettingsDialogService = DvsEditSettingsDialogService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSettingsDialogService", DvsEditSettingsDialogService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsAdvancedPageModel = (function () {
        function DvsEditSettingsAdvancedPageModel() {
        }
        DvsEditSettingsAdvancedPageModel.prototype.buildChanges = function (originalData) {
            var changesObject = {
                mtu: null,
                multicastFilteringMode: null,
                ldpProtocol: null,
                ldpOperation: null,
                contactName: null,
                contactDetails: null
            };
            if (this.mtu !== originalData.mtu) {
                changesObject.mtu = this.mtu;
            }
            if (this.multicastSnoopingSupported
                && this.multicastFilteringMode !== originalData.multicastFilteringMode) {
                changesObject.multicastFilteringMode = this.multicastFilteringMode;
            }
            var operationChanged = this.ldpOperation !== originalData.initialLdpOperation;
            var protocolChanged = this.ldpProtocol !== originalData.initialLdpProtocol;
            if (this.ldpProtocol !==
                DvsEditSettingsAdvancedPageModel.LDP_PROTOCOL_DISABLED) {
                if (operationChanged || protocolChanged) {
                    changesObject.ldpOperation = this.ldpOperation;
                    changesObject.ldpProtocol = this.ldpProtocol;
                }
            }
            else {
                if (protocolChanged) {
                    changesObject.ldpProtocol = originalData.ldpProtocol;
                    changesObject.ldpOperation =
                        DvsEditSettingsAdvancedPageModel.LDP_OPERATION_NONE;
                }
            }
            if (this.contactName !== originalData.contactName) {
                changesObject.contactName = this.contactName;
            }
            if (this.contactDetails !== originalData.contactDetails) {
                changesObject.contactDetails = this.contactDetails;
            }
            return this.hasChanges(changesObject) ? changesObject : null;
        };
        DvsEditSettingsAdvancedPageModel.prototype.hasChanges = function (changesObject) {
            for (var key in changesObject) {
                if (changesObject[key] !== null) {
                    return true;
                }
            }
            return false;
        };
        DvsEditSettingsAdvancedPageModel.LDP_OPERATION_NONE = "none";
        DvsEditSettingsAdvancedPageModel.LDP_PROTOCOL_DISABLED = "disabled";
        return DvsEditSettingsAdvancedPageModel;
    }());
    dvs_ui.DvsEditSettingsAdvancedPageModel = DvsEditSettingsAdvancedPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsGeneralPageModel = (function () {
        function DvsEditSettingsGeneralPageModel() {
        }
        Object.defineProperty(DvsEditSettingsGeneralPageModel.prototype, "uplinkPortNames", {
            get: function () {
                return this._uplinkPortNames;
            },
            set: function (value) {
                this._uplinkPortNames = value;
                if (!this.numUplinks && value) {
                    this.numUplinks = value.length;
                }
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsGeneralPageModel.prototype.buildChanges = function (originalData) {
            var changesObject = {
                name: null,
                description: null,
                uplinkPortNames: null,
                isNiocEnabled: null
            };
            if (originalData.name !== this.name) {
                changesObject.name = this.name;
            }
            if (originalData.description !== this.description) {
                changesObject.description = this.description;
            }
            if (originalData.isNiocSupported && originalData.isNiocEnabled !== this.isNiocEnabled) {
                changesObject.isNiocEnabled = this.isNiocEnabled;
            }
            if (this.uplinkPortsChanged(originalData)) {
                changesObject.uplinkPortNames = this.uplinkPortNames;
            }
            return this.hasChanges(changesObject) ? changesObject : null;
        };
        DvsEditSettingsGeneralPageModel.prototype.updateUplinkPortNames = function () {
            if (!this.uplinkPortNames) {
                return;
            }
            var existingNames = this.uplinkPortNames;
            var newUplinkPortNames = existingNames.slice();
            if (existingNames) {
                // remove deleted uplinks
                if (existingNames.length >= this.numUplinks) {
                    newUplinkPortNames.splice(this.numUplinks);
                }
                else {
                    // generate new uplinks
                    var uplinksToAdd = this.numUplinks - existingNames.length;
                    while (uplinksToAdd > 0) {
                        uplinksToAdd--;
                        newUplinkPortNames.push(this.generateUniqueUplinkName(newUplinkPortNames));
                    }
                }
            }
            this.uplinkPortNames = newUplinkPortNames;
        };
        DvsEditSettingsGeneralPageModel.prototype.hasChanges = function (changesObject) {
            for (var key in changesObject) {
                if (changesObject[key] !== null) {
                    return true;
                }
            }
            return false;
        };
        DvsEditSettingsGeneralPageModel.prototype.uplinkPortsChanged = function (originalData) {
            var zipped = _.zip(originalData.uplinkPortNames, this.uplinkPortNames);
            return _.some(zipped, function (pair) {
                return pair[0] !== pair[1];
            });
        };
        DvsEditSettingsGeneralPageModel.prototype.generateUniqueUplinkName = function (existingNames) {
            var index = 1;
            var name = this.buildUplinkName(index);
            while (_.contains(existingNames, name)) {
                index++;
                name = this.buildUplinkName(index);
            }
            return name;
        };
        DvsEditSettingsGeneralPageModel.prototype.buildUplinkName = function (index) {
            return "Uplink " + index;
        };
        return DvsEditSettingsGeneralPageModel;
    }());
    dvs_ui.DvsEditSettingsGeneralPageModel = DvsEditSettingsGeneralPageModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsAdvancedPageComponent = (function () {
        function DvsEditSettingsAdvancedPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = DvsEditSettingsAdvancedPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/settings/edit/pages/" +
                "dvsEditSettingsAdvancedPageComponentTemplate.html";
        }
        return DvsEditSettingsAdvancedPageComponent;
    }());
    dvs_ui.DvsEditSettingsAdvancedPageComponent = DvsEditSettingsAdvancedPageComponent;
    var DvsEditSettingsAdvancedPageComponentController = (function () {
        function DvsEditSettingsAdvancedPageComponentController(i18nService, $scope, validator, networkUiConstants) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.validator = validator;
            this.networkUiConstants = networkUiConstants;
            this._mtuValidator = {
                message: null,
                isVisible: false
            };
            this._contactNameValidator = {
                message: null,
                isVisible: false
            };
            this._contactDetailsValidator = {
                message: null,
                isVisible: false
            };
            this.initDropdownOptions();
        }
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "mtuValidator", {
            get: function () {
                return this._mtuValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsAdvancedPageComponentController.prototype.onMtuChange = function () {
            var message = this.validator.getMtuError(this.pageModel.mtu);
            this.mtuValidator.message = message;
            this.mtuValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "contactNameValidator", {
            get: function () {
                return this._contactNameValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsAdvancedPageComponentController.prototype.onContactNameChange = function () {
            var message = this.validator.getContactNameError(this.pageModel.contactName);
            this.contactNameValidator.message = message;
            this.contactNameValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "contactDetailsValidator", {
            get: function () {
                return this._contactDetailsValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsAdvancedPageComponentController.prototype.onContactDetailsChange = function () {
            var message = this.validator.getContactDetailsError(this.pageModel.contactDetails);
            this.contactDetailsValidator.message = message;
            this.contactDetailsValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "multicastFilteringOptions", {
            get: function () {
                return this._multicastFilteringOptions;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "ldpProtocolOptions", {
            get: function () {
                return this._ldpProtocolOptions;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "ldpOperationOptions", {
            get: function () {
                return this._ldpOperationOptions;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsEditSettingsAdvancedPageComponentController.prototype, "ldpOperationDropdownDisabled", {
            get: function () {
                return this.pageModel.ldpProtocol ===
                    dvs_ui.DvsEditSettingsAdvancedPageModel.LDP_PROTOCOL_DISABLED
                    || !this.pageModel.hasModifyPrivilege;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsAdvancedPageComponentController.prototype.initDropdownOptions = function () {
            this._multicastFilteringOptions = [{
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.multicastMode.basic"),
                    value: this.networkUiConstants.MulticastFiltering.BASIC
                }, {
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.multicastMode.snooping"),
                    value: this.networkUiConstants.MulticastFiltering.SNOOPING
                }];
            this._ldpProtocolOptions = [{
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.type.disabled"),
                    value: dvs_ui.DvsEditSettingsAdvancedPageModel.LDP_PROTOCOL_DISABLED
                }, {
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.type.cdp"),
                    value: this.networkUiConstants.LinkDiscoveryProtocol.CDP
                }];
            if (this.pageModel.lldpSupported) {
                this._ldpProtocolOptions.push({
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.type.lldp"),
                    value: this.networkUiConstants.LinkDiscoveryProtocol.LLDP
                });
            }
            this._ldpOperationOptions = [{
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.operation.listen"),
                    value: this.networkUiConstants.LinkDiscoveryOperation.LISTEN
                }, {
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.operation.advertise"),
                    value: this.networkUiConstants.LinkDiscoveryOperation.ADVERTISE
                }, {
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.advanced.dp.operation.both"),
                    value: this.networkUiConstants.LinkDiscoveryOperation.BOTH
                }];
        };
        DvsEditSettingsAdvancedPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsEditSettingsAdvancedPageValidator",
            "networkUiConstants"
        ];
        return DvsEditSettingsAdvancedPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsEditSettingsAdvancedPage", new DvsEditSettingsAdvancedPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsGeneralPageComponent = (function () {
        function DvsEditSettingsGeneralPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = DvsEditSettingsGeneralPageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/settings/edit/pages/" +
                "dvsEditSettingsGeneralPageComponentTemplate.html";
        }
        return DvsEditSettingsGeneralPageComponent;
    }());
    dvs_ui.DvsEditSettingsGeneralPageComponent = DvsEditSettingsGeneralPageComponent;
    var DvsEditSettingsGeneralPageComponentController = (function () {
        function DvsEditSettingsGeneralPageComponentController(i18nService, $scope, validator, clarityModalService, clarityConstants) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.validator = validator;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this._descriptionValidator = {
                message: null,
                isVisible: false
            };
            this._nameValidator = {
                message: null,
                isVisible: false
            };
            this._numUplinksValidator = {
                message: null,
                isVisible: false
            };
            this.niocSelectOptions = [{
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.resmgmt.enabled"),
                    value: true
                }, {
                    label: this.i18nService.getString("NetworkUi", "DvsConfigPage.resmgmt.disabled"),
                    value: false
                }];
        }
        Object.defineProperty(DvsEditSettingsGeneralPageComponentController.prototype, "editUplinkNamesAvailable", {
            get: function () {
                return !this.numUplinksValidator.isVisible && this.pageModel.hasModifyPrivilege;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsEditSettingsGeneralPageComponentController.prototype, "descriptionValidator", {
            get: function () {
                return this._descriptionValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsGeneralPageComponentController.prototype.onDescriptionChange = function () {
            var message = this.validator.getDescriptionError(this.pageModel.description);
            this.descriptionValidator.message = message;
            this.descriptionValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsEditSettingsGeneralPageComponentController.prototype, "nameValidator", {
            get: function () {
                return this._nameValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsGeneralPageComponentController.prototype.onNameChange = function () {
            var message = this.validator.getNameError(this.pageModel.name);
            this.nameValidator.message = message;
            this.nameValidator.isVisible = message !== null;
        };
        Object.defineProperty(DvsEditSettingsGeneralPageComponentController.prototype, "numUplinksValidator", {
            get: function () {
                return this._numUplinksValidator;
            },
            enumerable: true,
            configurable: true
        });
        DvsEditSettingsGeneralPageComponentController.prototype.onNumUplinksChange = function () {
            var message = this.validator.getNumberOfUplinksError(this.pageModel.numUplinks, this.pageModel.maxNumUplinks);
            this.numUplinksValidator.message = message;
            this.numUplinksValidator.isVisible = message !== null;
        };
        DvsEditSettingsGeneralPageComponentController.prototype.onEditUplinkNamesClick = function () {
            var _this = this;
            this.pageModel.updateUplinkPortNames();
            var dialogData = {
                uplinks: [],
                onUplinkNameChange: function () {
                    _this.onUplinkNameChange(dialogData.uplinks);
                }
            };
            _.forEach(this.pageModel.uplinkPortNames, function (uplink, index) {
                dialogData.uplinks.push({
                    name: uplink,
                    index: index + 1,
                    validator: {
                        message: null,
                        isVisible: false
                    }
                });
            });
            var modalOptions = {
                title: this.i18nService.getString("NetworkUi", "UplinkNamingDialog.title"),
                defaultButton: "submit",
                size: "sm",
                alerts: [],
                dialogData: dialogData,
                contentTemplate: "dvs-ui/resources/dvs/settings/edit/pages/editUplinkNamesDialogTemplate.html",
                onSubmit: function () {
                    var alerts = _this.onEditUplinkNamesDialogSubmitted(dialogData.uplinks);
                    modalOptions.alerts = alerts;
                    return !alerts || alerts.length === 0;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsEditSettingsGeneralPageComponentController.prototype.onUplinkNameChange = function (allUplinks) {
            var _this = this;
            _.forEach(allUplinks, function (uplink) {
                var message = _this.validator.getUplinkNameError(uplink.name);
                uplink.validator.message = message;
                uplink.validator.isVisible = message !== null;
            });
            var uplinksByName = [];
            _.forEach(allUplinks, function (uplinkData) {
                if (!uplinksByName[uplinkData.name]) {
                    uplinksByName[uplinkData.name] = [];
                }
                uplinksByName[uplinkData.name].push(uplinkData);
            });
            var _loop_1 = function(name_1) {
                _.forEach(uplinksByName[name_1], function (uplink) {
                    uplink.validator.message = (uplinksByName[name_1].length > 1)
                        ? _this.i18nService.getString("NetworkUi", "UplinkNamingDialog.duplicate")
                        : uplink.validator.message;
                    uplink.validator.isVisible = uplink.validator.message !== null;
                });
            };
            for (var name_1 in uplinksByName) {
                _loop_1(name_1);
            }
        };
        DvsEditSettingsGeneralPageComponentController.prototype.onEditUplinkNamesDialogSubmitted = function (uplinks) {
            var alerts = [];
            var hasInvalidUplink = _.some(uplinks, function (uplink) {
                return uplink.validator.isVisible;
            });
            if (hasInvalidUplink) {
                alerts.push({
                    text: this.i18nService.getString("NetworkUi", "UplinkNamingDialog.error.validationSummary"),
                    type: this.clarityConstants.notifications.type.ERROR
                });
            }
            else {
                this.pageModel.uplinkPortNames = _.map(uplinks, function (uplink) {
                    return uplink.name;
                });
            }
            return alerts;
        };
        DvsEditSettingsGeneralPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "dvsEditSettingsGeneralPageValidator",
            "clarityModalService",
            "clarityConstants"
        ];
        return DvsEditSettingsGeneralPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsEditSettingsGeneralPage", new DvsEditSettingsGeneralPageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEditSettingsAdvancedPageValidator = (function () {
        function DvsEditSettingsAdvancedPageValidator(i18nService, networkUtil) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
        }
        DvsEditSettingsAdvancedPageValidator.prototype.getAllErrors = function (pageModel) {
            var errors = [];
            var mtuError = this.getMtuError(pageModel.mtu);
            if (mtuError) {
                errors.push(mtuError);
            }
            var contactNameError = this.getContactNameError(pageModel.contactName);
            if (contactNameError) {
                errors.push(contactNameError);
            }
            var contactDetailsError = this.getContactDetailsError(pageModel.contactDetails);
            if (contactDetailsError) {
                errors.push(contactDetailsError);
            }
            return errors;
        };
        DvsEditSettingsAdvancedPageValidator.prototype.getMtuError = function (mtu) {
            if (!this.networkUtil.isMtuValid(mtu)) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.advancedPage.mtu.error");
            }
            return null;
        };
        DvsEditSettingsAdvancedPageValidator.prototype.getContactNameError = function (contactName) {
            if (contactName &&
                contactName.length > DvsEditSettingsAdvancedPageValidator.CONTACT_MAX_LENGTH) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.advancedPage.contactName.error");
            }
            return null;
        };
        DvsEditSettingsAdvancedPageValidator.prototype.getContactDetailsError = function (contactDetails) {
            if (contactDetails &&
                contactDetails.length > DvsEditSettingsAdvancedPageValidator.CONTACT_MAX_LENGTH) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.advancedPage.contactDetails.error");
            }
            return null;
        };
        DvsEditSettingsAdvancedPageValidator.CONTACT_MAX_LENGTH = 128;
        DvsEditSettingsAdvancedPageValidator.$inject = [
            "i18nService",
            "networkUtil"
        ];
        return DvsEditSettingsAdvancedPageValidator;
    }());
    dvs_ui.DvsEditSettingsAdvancedPageValidator = DvsEditSettingsAdvancedPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSettingsAdvancedPageValidator", DvsEditSettingsAdvancedPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var dvs_ui;
(function (dvs_ui) {
    var DvsCommonPropertiesValidator = dvs_ui.DvsCommonPropertiesValidator;
    var DvsEditSettingsGeneralPageValidator = (function (_super) {
        __extends(DvsEditSettingsGeneralPageValidator, _super);
        function DvsEditSettingsGeneralPageValidator() {
            _super.apply(this, arguments);
        }
        DvsEditSettingsGeneralPageValidator.prototype.getAllErrors = function (pageModel) {
            var errors = [];
            var nameError = this.getNameError(pageModel.name);
            if (nameError) {
                errors.push(nameError);
            }
            var numUplinksError = this.getNumberOfUplinksError(pageModel.numUplinks, pageModel.maxNumUplinks);
            if (numUplinksError) {
                errors.push(numUplinksError);
            }
            var descriptionError = this.getDescriptionError(pageModel.description);
            if (descriptionError) {
                errors.push(descriptionError);
            }
            return errors;
        };
        DvsEditSettingsGeneralPageValidator.prototype.getDescriptionError = function (description) {
            if (description &&
                description.length > DvsEditSettingsGeneralPageValidator.DESCRIPTION_MAX_LENGHT) {
                return this.i18nService.getString("DvsUi", "DvsEditSettingsDialog.generalPage.description.error");
            }
            return null;
        };
        DvsEditSettingsGeneralPageValidator.prototype.getUplinkNameError = function (uplinkName) {
            if (!uplinkName || uplinkName.length === 0) {
                return this.i18nService.getString("NetworkUi", "UplinkNamingDialog.empty");
            }
            else if (uplinkName.length > DvsEditSettingsGeneralPageValidator.MAX_UPLINK_NAME_LENGTH) {
                return this.i18nService.getString("NetworkUi", "UplinkNamingDialog.tooLong");
            }
            else {
                return null;
            }
        };
        DvsEditSettingsGeneralPageValidator.DESCRIPTION_MAX_LENGHT = 255;
        DvsEditSettingsGeneralPageValidator.MAX_UPLINK_NAME_LENGTH = 80;
        return DvsEditSettingsGeneralPageValidator;
    }(DvsCommonPropertiesValidator));
    dvs_ui.DvsEditSettingsGeneralPageValidator = DvsEditSettingsGeneralPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsEditSettingsGeneralPageValidator", DvsEditSettingsGeneralPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsDetailsComponent = (function () {
        function DvsDetailsComponent() {
            this.bindings = {};
            this.controller = DvsDetailsController;
            this.templateUrl = "dvs-ui/resources/dvs/summary/components/dvsDetailsComponentTemplate.html";
        }
        return DvsDetailsComponent;
    }());
    dvs_ui.DvsDetailsComponent = DvsDetailsComponent;
    var DvsDetailsController = (function () {
        function DvsDetailsController(i18nService, $rootScope, dataService) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.dataService = dataService;
        }
        DvsDetailsController.prototype.$onInit = function () {
            this.requestData();
        };
        DvsDetailsController.prototype.refresh = function () {
            this.requestData();
        };
        Object.defineProperty(DvsDetailsController.prototype, "networks", {
            get: function () {
                return this._data && this._data.numPortgroups;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsDetailsController.prototype, "hosts", {
            get: function () {
                return this._data && this._data.numHosts;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsDetailsController.prototype, "vms", {
            get: function () {
                return this._data && this._data.numVms;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsDetailsController.prototype, "ports", {
            get: function () {
                return this._data && this._data.numPorts;
            },
            enumerable: true,
            configurable: true
        });
        DvsDetailsController.prototype.requestData = function () {
            var self = this;
            var dvsUri = this.$rootScope._route.objectId;
            self.loadingData = true;
            self.dataService.getData(dvsUri, DvsDetailsController.DATA_MODEL)
                .then(function (dvsDetailsPortletData) {
                self._data = dvsDetailsPortletData;
                self.loadingData = false;
            });
            this.dSwitchUri = this.$rootScope._route.objectId;
            this.liveRefreshProperties = [
                "summary.vm",
                "portgroup",
                "config.numPorts",
                "summary.hostMember"
            ];
        };
        DvsDetailsController.$inject = [
            "i18nService",
            "$rootScope",
            "dataService"
        ];
        DvsDetailsController.DATA_MODEL = "com.vmware.vsphere.client.h5.network.dvs.model.DvsDetailsPortletData";
        return DvsDetailsController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsDetails", new DvsDetailsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsFeaturesComponent = (function () {
        function DvsFeaturesComponent() {
            this.bindings = {};
            this.controller = DvsFeaturesController;
            this.templateUrl = "dvs-ui/resources/dvs/summary/components/dvsFeaturesComponentTemplate.html";
        }
        return DvsFeaturesComponent;
    }());
    dvs_ui.DvsFeaturesComponent = DvsFeaturesComponent;
    var DvsFeaturesController = (function () {
        function DvsFeaturesController(i18nService, $rootScope, dataService, networkUiConstants) {
            this.i18nService = i18nService;
            this.$rootScope = $rootScope;
            this.dataService = dataService;
            this.networkUiConstants = networkUiConstants;
        }
        DvsFeaturesController.prototype.$onInit = function () {
            this.requestData();
            this.niocStackBlockExpanded = false;
        };
        DvsFeaturesController.prototype.refresh = function () {
            this.requestData();
        };
        Object.defineProperty(DvsFeaturesController.prototype, "loadingData", {
            get: function () {
                return this._loadingData;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DvsFeaturesController.prototype, "data", {
            get: function () {
                return this._data;
            },
            enumerable: true,
            configurable: true
        });
        DvsFeaturesController.prototype.getFeatureSupportedText = function (isSupported) {
            return isSupported
                ? this.i18nService.getString("NetworkUi", "DvsFeaturesView.supported")
                : this.i18nService.getString("NetworkUi", "DvsFeaturesView.notSupported");
        };
        DvsFeaturesController.prototype.getLacpSupportText = function () {
            if (this._data.lacpSupported) {
                if (this._data.lacpApiVersion === this.networkUiConstants.LacpSupport.BASIC) {
                    return this.i18nService.getString("NetworkUi", "DvsFeaturesView.lacp.basicSupport");
                }
                else if (this._data.lacpApiVersion === this.networkUiConstants.LacpSupport.ENHANCED) {
                    return this.i18nService.getString("NetworkUi", "DvsFeaturesView.lacp.enhancedSupport");
                }
            }
            return this.i18nService.getString("NetworkUi", "DvsFeaturesView.notSupported");
        };
        DvsFeaturesController.prototype.requestData = function () {
            var self = this;
            var dvsUri = this.$rootScope._route.objectId;
            self._loadingData = true;
            self.dataService.getProperties(dvsUri, [DvsFeaturesController.DATA_PROPERTY])
                .then(function (response) {
                var dvsFeaturesPortletData = response[DvsFeaturesController.DATA_PROPERTY];
                if (dvsFeaturesPortletData) {
                    self._data = dvsFeaturesPortletData;
                    self._loadingData = false;
                }
            });
            this.dSwitchUri = this.$rootScope._route.objectId;
            this.liveRefreshProperties = [
                "capability.featuresSupported.ipfixCapability.ipv6ForIpfixSupported",
                "capability.featuresSupported.multicastSnoopingSupported",
                "capability.featuresSupported.lacpCapability.multiLacpGroupSupported",
                "capability.featuresSupported.vspanCapability.erspanProtocolSupported",
                "capability.featuresSupported.networkFilterSupported",
                "capability.featuresSupported.ipfixCapability.observationDomainIdSupported",
                "capability.featuresSupported.networkResourceManagementCapability.networkResourceControlVersion3Supported",
                "config.networkResourceControlVersion",
                "config.productInfo.version"
            ];
        };
        DvsFeaturesController.$inject = [
            "i18nService",
            "$rootScope",
            "dataService",
            "networkUiConstants"
        ];
        DvsFeaturesController.DATA_PROPERTY = "dvs:featuresPortletData";
        return DvsFeaturesController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsFeatures", new DvsFeaturesComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsRectifyHostsOutOfSyncComponent = (function () {
        function DvsRectifyHostsOutOfSyncComponent() {
            this.bindings = {
                hosts: "<",
                selectedHosts: "="
            };
            this.controller = DvsRectifyHostsOutOfSyncController;
            this.templateUrl = "dvs-ui/resources/dvs/summary/components/dvsRectifyHostsOutOfSyncTemplate.html";
        }
        return DvsRectifyHostsOutOfSyncComponent;
    }());
    dvs_ui.DvsRectifyHostsOutOfSyncComponent = DvsRectifyHostsOutOfSyncComponent;
    var DvsRectifyHostsOutOfSyncController = (function () {
        function DvsRectifyHostsOutOfSyncController(i18nService, networkUiConstants) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
        }
        DvsRectifyHostsOutOfSyncController.prototype.onSelectedHostsChange = function (value) {
            this.selectedHosts = value;
        };
        DvsRectifyHostsOutOfSyncController.$inject = [
            "i18nService",
            "networkUiConstants"
        ];
        return DvsRectifyHostsOutOfSyncController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsRectifyHostsOutOfSync", new DvsRectifyHostsOutOfSyncComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsOutOfSyncHostService = (function () {
        function DvsOutOfSyncHostService(clarityModalService, i18nService, vxPropertyViewService, columnRenderersRegistry, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        DvsOutOfSyncHostService.prototype.showDetails = function (hostOutOfSyncData, description, entityId) {
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.details"),
                subTitle: {
                    objectId: entityId
                },
                size: "lg",
                defaultButton: "close",
                closeButtonTitle: this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.close"),
                hideSubmitButton: true,
                alerts: [],
                dialogData: {
                    desc: description,
                    dvsOutOfSyncHostData: this.buildHostOutOfSyncPropertiesView(hostOutOfSyncData)
                },
                contentTemplate: "dvs-ui/resources/dvs/summary/views/dvsOutOfSyncHost.html",
                modalClass: "dvs-out-of-sync-host-details-modal"
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsOutOfSyncHostService.prototype.buildHostOutOfSyncPropertiesView = function (hostOutOfSyncData) {
            if (hostOutOfSyncData) {
                var builder = this.vxPropertyViewService.createPropertyViewBuilder();
                var dvsOutOfSyncHostCategory = builder
                    .category("dvsOutOfSyncHost");
                this.buildHostOutOfSyncSection(dvsOutOfSyncHostCategory, hostOutOfSyncData);
                return builder.build();
            }
        };
        DvsOutOfSyncHostService.prototype.buildHostOutOfSyncSection = function (category, dvsPortDetailsData) {
            var linkAndTextRenderer = this.columnRenderersRegistry.getColumnRenderer("link-and-text");
            for (var _i = 0, dvsPortDetailsData_1 = dvsPortDetailsData; _i < dvsPortDetailsData_1.length; _i++) {
                var host = dvsPortDetailsData_1[_i];
                var hostLinkObject = {
                    hostName: host.outOfSyncHost.name,
                    hostId: this.defaultUriSchemeUtil.getVsphereObjectId(host.outOfSyncHost.host)
                };
                var hostSection = category.section(hostLinkObject.hostName)
                    .compileAsHtml(true)
                    .title(linkAndTextRenderer(hostLinkObject.hostId, hostLinkObject.hostName, null, "Host:", true));
                hostSection.property(this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.params"), host.configParamters);
            }
        };
        DvsOutOfSyncHostService.$inject = [
            "clarityModalService",
            "i18nService",
            "vxPropertyViewService",
            "columnRenderersRegistry",
            "defaultUriSchemeUtil"
        ];
        return DvsOutOfSyncHostService;
    }());
    dvs_ui.DvsOutOfSyncHostService = DvsOutOfSyncHostService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsOutOfSyncHostService", DvsOutOfSyncHostService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsRectifyHostsOutOfSyncService = (function () {
        function DvsRectifyHostsOutOfSyncService(clarityModalService, i18nService, dataService, mutationService, clarityConstants) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.clarityConstants = clarityConstants;
        }
        DvsRectifyHostsOutOfSyncService.prototype.show = function (entityId) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.rectifyDetails"),
                subTitle: {
                    objectId: entityId
                },
                size: "lg",
                submitButtonTitle: this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.rectifyButton"),
                defaultButton: "submit",
                alerts: [],
                dialogData: {
                    hosts: [],
                    loading: true,
                    selectedHosts: null
                },
                onSubmit: function () {
                    if (!modalOptions.dialogData.selectedHosts.length) {
                        modalOptions.alerts = [{
                                text: _this.i18nService.getString("DvsUi", "OutOfSyncDvsHost.message.noHostSelected"),
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    var DVS_RECTIFY_HOST_SPEC = "com.vmware.vsphere.client.h5.network.dvs.summary.spec.DvsRectifyOutOfSyncHostSpec";
                    var rectifyOutOfSyncHost = {
                        _type: DVS_RECTIFY_HOST_SPEC,
                        hosts: _.pluck(modalOptions.dialogData.selectedHosts, "hostRef")
                    };
                    _this.mutationService.apply(entityId, DVS_RECTIFY_HOST_SPEC, rectifyOutOfSyncHost);
                    return true;
                },
                contentTemplate: "dvs-ui/resources/dvs/summary/views/dvsRectifyHostsOutOfSync.html",
                modalClass: "rectify-out-of-sync-hosts-modal"
            };
            var dvsHostsPromise = this.dataService
                .getProperties(entityId, [DvsRectifyHostsOutOfSyncService.DVS_HOSTS_DATA_PROP]);
            dvsHostsPromise.then(function (dataServiceResponse) {
                var data = dataServiceResponse[DvsRectifyHostsOutOfSyncService.DVS_HOSTS_DATA_PROP];
                if (data) {
                    modalOptions.dialogData.hosts = data.dvsHosts;
                }
            }).finally(function () {
                modalOptions.dialogData.loading = false;
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DvsRectifyHostsOutOfSyncService.DVS_HOSTS_DATA_PROP = "dvs:dvsOutOfSyncHostsData";
        DvsRectifyHostsOutOfSyncService.$inject = [
            "clarityModalService",
            "i18nService",
            "dataService",
            "mutationService",
            "clarityConstants"
        ];
        return DvsRectifyHostsOutOfSyncService;
    }());
    dvs_ui.DvsRectifyHostsOutOfSyncService = DvsRectifyHostsOutOfSyncService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsRectifyHostsOutOfSyncService", DvsRectifyHostsOutOfSyncService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsOutOfSyncHostController = (function () {
        function DvsOutOfSyncHostController($scope) {
            this.$scope = $scope;
            this.description = $scope.modalOptions.dialogData.desc;
            this.dvsOutOfSyncHostData = $scope.modalOptions.dialogData.dvsOutOfSyncHostData;
            var onRouteChangeEventHandler = $scope.$on("vxRouteChangeSuccess", function () {
                $scope.modalOptions.modalOpen = false;
            });
            $scope.$on("$destroy", function () {
                onRouteChangeEventHandler();
            });
        }
        DvsOutOfSyncHostController.$inject = ["$scope"];
        return DvsOutOfSyncHostController;
    }());
    dvs_ui.DvsOutOfSyncHostController = DvsOutOfSyncHostController;
    angular.module('com.vmware.vsphere.client.dvs')
        .controller('DvsOutOfSyncHostController', DvsOutOfSyncHostController);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var LagDetailsDialogContent = (function () {
        function LagDetailsDialogContent() {
            this.bindings = {
                data: "<"
            };
            this.controller = LagDetailsDialogContentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return LagDetailsDialogContent;
    }());
    dvs_ui.LagDetailsDialogContent = LagDetailsDialogContent;
    var LagDetailsDialogContentController = (function () {
        function LagDetailsDialogContentController(lagPropertiesService) {
            this.lagPropertiesService = lagPropertiesService;
        }
        LagDetailsDialogContentController.prototype.$onInit = function () {
            this.propertyViewData = this.lagPropertiesService.getPropertyViewData(this.data);
        };
        LagDetailsDialogContentController.$inject = [
            "lagPropertiesService"
        ];
        return LagDetailsDialogContentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("lagDetailsDialogContent", new LagDetailsDialogContent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PnicDetailsDialogCdpViewComponent = (function () {
        function PnicDetailsDialogCdpViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = PnicDetailsDialogCdpViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return PnicDetailsDialogCdpViewComponent;
    }());
    dvs_ui.PnicDetailsDialogCdpViewComponent = PnicDetailsDialogCdpViewComponent;
    var PnicDetailsDialogCdpViewComponentController = (function () {
        function PnicDetailsDialogCdpViewComponentController(physicalAdapterDetailsViewService) {
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
        }
        PnicDetailsDialogCdpViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.physicalAdapterDetailsViewService.buildOnlyCdp(this.data);
        };
        PnicDetailsDialogCdpViewComponentController.$inject = [
            "physicalAdapterDetailsViewService"
        ];
        return PnicDetailsDialogCdpViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("pnicDetailsDialogCdpView", new PnicDetailsDialogCdpViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PnicDetailsDialogLldpViewComponent = (function () {
        function PnicDetailsDialogLldpViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = PnicDetailsDialogLldpViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return PnicDetailsDialogLldpViewComponent;
    }());
    dvs_ui.PnicDetailsDialogLldpViewComponent = PnicDetailsDialogLldpViewComponent;
    var PnicDetailsDialogLldpViewComponentController = (function () {
        function PnicDetailsDialogLldpViewComponentController(physicalAdapterDetailsViewService) {
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
        }
        PnicDetailsDialogLldpViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.physicalAdapterDetailsViewService.buildOnlyLldp(this.data);
        };
        PnicDetailsDialogLldpViewComponentController.$inject = [
            "physicalAdapterDetailsViewService"
        ];
        return PnicDetailsDialogLldpViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("pnicDetailsDialogLldpView", new PnicDetailsDialogLldpViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PnicDetailsDialogPropertiesViewComponent = (function () {
        function PnicDetailsDialogPropertiesViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = PnicDetailsDialogPropertiesViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return PnicDetailsDialogPropertiesViewComponent;
    }());
    dvs_ui.PnicDetailsDialogPropertiesViewComponent = PnicDetailsDialogPropertiesViewComponent;
    var PnicDetailsDialogPropertiesViewComponentController = (function () {
        function PnicDetailsDialogPropertiesViewComponentController(physicalAdapterDetailsViewService) {
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
        }
        PnicDetailsDialogPropertiesViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.physicalAdapterDetailsViewService.buildOnlyProperties(this.data);
        };
        PnicDetailsDialogPropertiesViewComponentController.$inject = [
            "physicalAdapterDetailsViewService"
        ];
        return PnicDetailsDialogPropertiesViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("pnicDetailsDialogPropertiesView", new PnicDetailsDialogPropertiesViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PortgroupDetailsDialogPoliciesView = (function () {
        function PortgroupDetailsDialogPoliciesView() {
            this.bindings = {
                data: "<"
            };
            this.controller = PortgroupDetailsDialogPoliciesViewController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return PortgroupDetailsDialogPoliciesView;
    }());
    dvs_ui.PortgroupDetailsDialogPoliciesView = PortgroupDetailsDialogPoliciesView;
    var PortgroupDetailsDialogPoliciesViewController = (function () {
        function PortgroupDetailsDialogPoliciesViewController(distributedPortgroupPoliciesViewService, networkDetailsViewService) {
            this.distributedPortgroupPoliciesViewService = distributedPortgroupPoliciesViewService;
            this.networkDetailsViewService = networkDetailsViewService;
        }
        PortgroupDetailsDialogPoliciesViewController.prototype.$onInit = function () {
            if (this.isDvPortgroup) {
                this.propertyViewData =
                    this.distributedPortgroupPoliciesViewService.build(this.data);
            }
            else {
                this.propertyViewData =
                    this.networkDetailsViewService.buildOnlyPolicies(this.data);
            }
        };
        PortgroupDetailsDialogPoliciesViewController.$inject = [
            "distributedPortgroupPoliciesViewService",
            "networkDetailsViewService"
        ];
        return PortgroupDetailsDialogPoliciesViewController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("portgroupDetailsDialogPoliciesView", new PortgroupDetailsDialogPoliciesView());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PortgroupDetailsDialogPropertiesViewComponent = (function () {
        function PortgroupDetailsDialogPropertiesViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = PortgroupDetailsDialogPropertiesViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return PortgroupDetailsDialogPropertiesViewComponent;
    }());
    dvs_ui.PortgroupDetailsDialogPropertiesViewComponent = PortgroupDetailsDialogPropertiesViewComponent;
    var PortgroupDetailsDialogPropertiesViewComponentController = (function () {
        function PortgroupDetailsDialogPropertiesViewComponentController(dvPortgroupPropertiesService, networkDetailsViewService) {
            this.dvPortgroupPropertiesService = dvPortgroupPropertiesService;
            this.networkDetailsViewService = networkDetailsViewService;
        }
        PortgroupDetailsDialogPropertiesViewComponentController.prototype.$onInit = function () {
            if (this.isDvPortgroup) {
                this.propertyViewData =
                    this.dvPortgroupPropertiesService.buildProperties(this.data);
            }
            else {
                this.propertyViewData =
                    this.networkDetailsViewService.buildOnlyProperties(this.data);
            }
        };
        PortgroupDetailsDialogPropertiesViewComponentController.$inject = [
            "dvPortgroupPropertiesService",
            "networkDetailsViewService"
        ];
        return PortgroupDetailsDialogPropertiesViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("portgroupDetailsDialogPropertiesView", new PortgroupDetailsDialogPropertiesViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmkDetailsDialogIpSettingsViewComponent = (function () {
        function VmkDetailsDialogIpSettingsViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = VmkDetailsDialogIpSettingsViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return VmkDetailsDialogIpSettingsViewComponent;
    }());
    dvs_ui.VmkDetailsDialogIpSettingsViewComponent = VmkDetailsDialogIpSettingsViewComponent;
    var VmkDetailsDialogIpSettingsViewComponentController = (function () {
        function VmkDetailsDialogIpSettingsViewComponentController(networkDetailsViewService) {
            this.networkDetailsViewService = networkDetailsViewService;
        }
        VmkDetailsDialogIpSettingsViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.networkDetailsViewService.buildOnlyIpSettings(this.data);
        };
        VmkDetailsDialogIpSettingsViewComponentController.$inject = [
            "networkDetailsViewService"
        ];
        return VmkDetailsDialogIpSettingsViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmkDetailsDialogIpSettingsView", new VmkDetailsDialogIpSettingsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmkDetailsDialogNetworkConnectionViewComponent = (function () {
        function VmkDetailsDialogNetworkConnectionViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = VmkDetailsDialogNetworkConnectionViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view vmk-details-dialog-network-connection-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return VmkDetailsDialogNetworkConnectionViewComponent;
    }());
    dvs_ui.VmkDetailsDialogNetworkConnectionViewComponent = VmkDetailsDialogNetworkConnectionViewComponent;
    var VmkDetailsDialogNetworkConnectionViewComponentController = (function () {
        function VmkDetailsDialogNetworkConnectionViewComponentController(propertyViewService, i18nService) {
            this.propertyViewService = propertyViewService;
            this.i18nService = i18nService;
        }
        VmkDetailsDialogNetworkConnectionViewComponentController.prototype.$onInit = function () {
            this.propertyViewData = this.buildPropertyViewData();
        };
        VmkDetailsDialogNetworkConnectionViewComponentController.prototype.buildPropertyViewData = function () {
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var categoryBuilder = builder.category("");
            if (!!this.data) {
                var sectionBuilder = categoryBuilder
                    .section("networkConnection")
                    .title(this.getString("switchdiagram.nic.details.networkConnection"))
                    .property(this.getString("switchdiagram.nic.details.portId"), this.data.portId);
                var propertyBuilder = sectionBuilder.propertyBuilder();
                var stateIconAndLabel = this.getStateIconAndLabel(this.data.state);
                propertyBuilder
                    .keyBuilder()
                    .text(this.getString("switchdiagram.nic.details.state"));
                propertyBuilder
                    .valueBuilder()
                    .icon(stateIconAndLabel.icon)
                    .text(stateIconAndLabel.label);
                if (!!this.data.mac) {
                    sectionBuilder.property(this.getString("switchdiagram.nic.details.macRuntime"), this.data.mac);
                }
            }
            return builder.build();
        };
        VmkDetailsDialogNetworkConnectionViewComponentController.prototype.getStateIconAndLabel = function (portState) {
            var icon = "";
            var label = "";
            if (portState === "LINK_UP") {
                icon = "vsphere-icon-port_green";
                label = this.getString("PortState.linkUp");
            }
            else if (portState === "LINK_DOWN") {
                icon = "vsphere-icon-port_white";
                label = this.getString("PortState.linkDown");
            }
            else if (portState === "BLOCKED") {
                icon = "vsphere-icon-port_blocked";
                label = this.getString("PortState.blocked");
            }
            return { icon: icon, label: label };
        };
        VmkDetailsDialogNetworkConnectionViewComponentController.prototype.getString = function (key) {
            return this.i18nService.getString("DvsUi", key);
        };
        VmkDetailsDialogNetworkConnectionViewComponentController.$inject = [
            "vxPropertyViewService",
            "i18nService"
        ];
        return VmkDetailsDialogNetworkConnectionViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmkDetailsDialogNetworkConnectionView", new VmkDetailsDialogNetworkConnectionViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmkDetailsDialogNicSettingsViewComponent = (function () {
        function VmkDetailsDialogNicSettingsViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = VmkDetailsDialogNicSettingsViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return VmkDetailsDialogNicSettingsViewComponent;
    }());
    dvs_ui.VmkDetailsDialogNicSettingsViewComponent = VmkDetailsDialogNicSettingsViewComponent;
    var VmkDetailsDialogNicSettingsViewComponentController = (function () {
        function VmkDetailsDialogNicSettingsViewComponentController(networkDetailsViewService) {
            this.networkDetailsViewService = networkDetailsViewService;
        }
        VmkDetailsDialogNicSettingsViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.networkDetailsViewService.buildOnlyNicSettings(this.data);
        };
        VmkDetailsDialogNicSettingsViewComponentController.$inject = [
            "networkDetailsViewService"
        ];
        return VmkDetailsDialogNicSettingsViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmkDetailsDialogNicSettingsView", new VmkDetailsDialogNicSettingsViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmkDetailsDialogPropertiesViewComponent = (function () {
        function VmkDetailsDialogPropertiesViewComponent() {
            this.bindings = {
                data: "<"
            };
            this.controller = VmkDetailsDialogPropertiesViewComponentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return VmkDetailsDialogPropertiesViewComponent;
    }());
    dvs_ui.VmkDetailsDialogPropertiesViewComponent = VmkDetailsDialogPropertiesViewComponent;
    var VmkDetailsDialogPropertiesViewComponentController = (function () {
        function VmkDetailsDialogPropertiesViewComponentController(networkDetailsViewService) {
            this.networkDetailsViewService = networkDetailsViewService;
        }
        VmkDetailsDialogPropertiesViewComponentController.prototype.$onInit = function () {
            this.propertyViewData =
                this.networkDetailsViewService.buildOnlyProperties(this.data);
        };
        VmkDetailsDialogPropertiesViewComponentController.$inject = [
            "networkDetailsViewService"
        ];
        return VmkDetailsDialogPropertiesViewComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmkDetailsDialogPropertiesView", new VmkDetailsDialogPropertiesViewComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VmVnicDetailsDialogContent = (function () {
        function VmVnicDetailsDialogContent() {
            this.bindings = {
                data: "<"
            };
            this.controller = VmVnicDetailsDialogContentController;
            this.template = "<vx-property-view class=\"network-ui-fixed-size-vx-property-view vm-vnic-details-dialog-content\"\n                                            data=\"$ctrl.propertyViewData\"/>";
        }
        return VmVnicDetailsDialogContent;
    }());
    dvs_ui.VmVnicDetailsDialogContent = VmVnicDetailsDialogContent;
    var VmVnicDetailsDialogContentController = (function () {
        function VmVnicDetailsDialogContentController(propertyViewService, i18nService, numberFormatterService) {
            this.propertyViewService = propertyViewService;
            this.i18nService = i18nService;
            this.numberFormatterService = numberFormatterService;
        }
        VmVnicDetailsDialogContentController.prototype.$onInit = function () {
            this.propertyViewData = this.buildPropertyViewData();
        };
        VmVnicDetailsDialogContentController.prototype.buildPropertyViewData = function () {
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var categoryBuilder = builder.category("");
            if (!!this.data.dvsPortData) {
                var networkConnection = categoryBuilder
                    .section("networkConnection")
                    .title(this.getString("switchdiagram.nic.details.networkConnection"))
                    .property(this.getString("switchdiagram.nic.details.portId"), this.data.dvsPortData.portId);
                var propertyBuilder = networkConnection.propertyBuilder();
                var stateIconAndLabel = this.getStateIconAndLabel(this.data.dvsPortData.state);
                propertyBuilder
                    .keyBuilder()
                    .text(this.getString("switchdiagram.nic.details.state"));
                propertyBuilder
                    .valueBuilder()
                    .icon(stateIconAndLabel.icon)
                    .text(stateIconAndLabel.label);
                if (!!this.data.dvsPortData.mac) {
                    networkConnection.property(this.getString("switchdiagram.nic.details.macRuntime"), this.data.dvsPortData.mac);
                }
            }
            var adapterBuilder = categoryBuilder
                .section("adapter")
                .title(this.data.vmVnicModel.adapterName)
                .property(this.getString("switchdiagram.nic.details.mac"), this.data.vmVnicModel.macAddress)
                .property(this.getString("switchdiagram.nic.details.adapterType"), this.data.vmVnicModel.adapterType);
            if (this.data.vmVnicModel.resourceAllocation) {
                adapterBuilder
                    .property(this.getString("switchdiagram.nic.details.shares"), this.i18nService.getString("DvsUi", "switchdiagram.nic.details.sharesValueFormat", this.data.vmVnicModel.resourceAllocation.sharesValue, this.getSharesLevelLabel(this.data.vmVnicModel.resourceAllocation.sharesLevel)))
                    .property(this.getString("switchdiagram.nic.details.reservation"), this.numberFormatterService.formatBandwidth(this.data.vmVnicModel.resourceAllocation.reservation, BandwidthUnit.MBITPS, BandwidthUnit.AUTO));
                var limitValue = this.data.vmVnicModel.resourceAllocation.limit > -1
                    ? this.numberFormatterService.formatBandwidth(this.data.vmVnicModel.resourceAllocation.limit, BandwidthUnit.MBITPS, BandwidthUnit.AUTO)
                    : this.getString("switchdiagram.nic.details.unlimited");
                adapterBuilder.property(this.getString("switchdiagram.nic.details.limit"), limitValue);
            }
            if (this.data.vmVnicModel.sriovCapable) {
                categoryBuilder
                    .section("sriov")
                    .title(this.getString("switchdiagram.nic.details.sriov"))
                    .property(this.getString("switchdiagram.nic.details.sriovStatus"), this.getSriovStatusLabel(this.data.vmVnicModel.sriovCapable))
                    .property(this.getString("switchdiagram.nic.details.sriov.virtualFunction"), this.data.vmVnicModel.virtualFunctionId)
                    .property(this.getString("switchdiagram.nic.details.sriov.physicalFunction"), this.i18nService.getString("DvsUi", "switchdiagram.nic.details.sriov.physicalFunctionFormat", this.data.vmVnicModel.physicalFunctionId, this.data.vmVnicModel.physicalFunctionDeviceId))
                    .property(this.getString("switchdiagram.nic.details.gosMtu"), this.getGuestOsMtuChangesLabel(this.data.vmVnicModel.guestOsMtuChange));
            }
            return builder.build();
        };
        VmVnicDetailsDialogContentController.prototype.getStateIconAndLabel = function (portState) {
            var icon = "";
            var label = this.getString("switchdiagram.noData");
            if (portState === "LINK_UP") {
                icon = "vsphere-icon-port_green";
                label = this.getString("PortState.linkUp");
            }
            else if (portState === "LINK_DOWN") {
                icon = "vsphere-icon-port_white";
                label = this.getString("PortState.linkDown");
            }
            else if (portState === "BLOCKED") {
                icon = "vsphere-icon-port_blocked";
                label = this.getString("PortState.blocked");
            }
            return { icon: icon, label: label };
        };
        VmVnicDetailsDialogContentController.prototype.getSriovStatusLabel = function (sriovCapable) {
            return this.getString(sriovCapable
                ? "switchdiagram.nic.details.sriov.enabled"
                : "switchdiagram.nic.details.sriov.notSupported");
        };
        VmVnicDetailsDialogContentController.prototype.getGuestOsMtuChangesLabel = function (allowed) {
            return this.getString(allowed
                ? "switchdiagram.nic.details.gosMtu.allowed"
                : "switchdiagram.nic.details.gosMtu.disallowed");
        };
        VmVnicDetailsDialogContentController.prototype.getSharesLevelLabel = function (value) {
            switch (value) {
                case "low": {
                    return this.getString("switchdiagram.nic.details.sharesLevel.low");
                }
                case "normal": {
                    return this.getString("switchdiagram.nic.details.sharesLevel.normal");
                }
                case "high": {
                    return this.getString("switchdiagram.nic.details.sharesLevel.high");
                }
                case "custom": {
                    return this.getString("switchdiagram.nic.details.sharesLevel.custom");
                }
                default: {
                    return "";
                }
            }
        };
        VmVnicDetailsDialogContentController.prototype.getString = function (key) {
            return this.i18nService.getString("DvsUi", key);
        };
        VmVnicDetailsDialogContentController.$inject = [
            "vxPropertyViewService",
            "i18nService",
            "numberFormatterService"
        ];
        return VmVnicDetailsDialogContentController;
    }());
    var BandwidthUnit;
    (function (BandwidthUnit) {
        BandwidthUnit[BandwidthUnit["BITPS"] = 0] = "BITPS";
        BandwidthUnit[BandwidthUnit["KBITPS"] = 1] = "KBITPS";
        BandwidthUnit[BandwidthUnit["MBITPS"] = 2] = "MBITPS";
        BandwidthUnit[BandwidthUnit["GBITPS"] = 3] = "GBITPS";
        BandwidthUnit[BandwidthUnit["TBITPS"] = 4] = "TBITPS";
        BandwidthUnit[BandwidthUnit["AUTO"] = 5] = "AUTO";
    })(BandwidthUnit || (BandwidthUnit = {}));
    angular.module("com.vmware.vsphere.client.dvs")
        .component("vmVnicDetailsDialogContent", new VmVnicDetailsDialogContent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsEnableFeatureComponent = (function () {
        function DvsEnableFeatureComponent() {
            this.bindings = {
                model: "<",
                feature: "<",
            };
            this.controller = DvsEnableFeatureController;
            this.templateUrl =
                "dvs-ui/resources/dvs/upgrade/components/" +
                    "dvsEnableFeatureTemplate.html";
        }
        return DvsEnableFeatureComponent;
    }());
    dvs_ui.DvsEnableFeatureComponent = DvsEnableFeatureComponent;
    var DvsEnableFeatureController = (function () {
        function DvsEnableFeatureController(i18nService, dvsUpgradeWizardConstants) {
            this.i18nService = i18nService;
            this.dvsUpgradeWizardConstants = dvsUpgradeWizardConstants;
            this.i18n = this.i18nService.getString;
            switch (this.feature) {
                case this.dvsUpgradeWizardConstants.features.LACP:
                    this.featureLabel = this.i18n("DvsUi", "DvsLacpPrerequisitesPage.feature.label");
                    this.featureProperty = "isExplicitLacpUpgradeEnabled";
                    this.featureInfo = this.i18n("DvsUi", "DvsLacpPrerequisitesPage.feature.description");
                    this.signPostConfig = {
                        message: this.i18n("DvsUi", "DvsLacpPrerequisitesPage.info"),
                        title: this.i18n("DvsUi", "DvsLacpPrerequisitesPage.title"),
                        class: "dvs-upgrade-info-signpost"
                    };
                    break;
                case this.dvsUpgradeWizardConstants.features.NIOC:
                    this.featureLabel = this.i18n("DvsUi", "DvsNiocPrerequisitesPage.feature.label");
                    this.featureInfo = this.i18n("DvsUi", "DvsNiocPrerequisitesPage.feature.description");
                    this.featureProperty = "isExplicitNiocUpgradeEnabled";
                    this.signPostConfig = {
                        message: this.i18n("DvsUi", "DvsNiocPrerequisitesPage.info"),
                        title: this.i18n("DvsUi", "DvsNiocPrerequisitesPage.title"),
                        class: "dvs-upgrade-info-signpost"
                    };
                    break;
                default:
                    break;
            }
        }
        DvsEnableFeatureController.$inject = [
            "i18nService",
            "dvsUpgradeWizardConstants"
        ];
        return DvsEnableFeatureController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsEnableFeature", new DvsEnableFeatureComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHostCompatibilityListComponent = (function () {
        function DvsHostCompatibilityListComponent() {
            this.bindings = {
                hostCompatibilityData: "<"
            };
            this.controller = DvsHostCompatibilityListController;
            this.templateUrl =
                "dvs-ui/resources/dvs/upgrade/components/dvsHostCompatibilityListTemplate.html";
        }
        return DvsHostCompatibilityListComponent;
    }());
    dvs_ui.DvsHostCompatibilityListComponent = DvsHostCompatibilityListComponent;
    var DvsHostCompatibilityListController = (function () {
        function DvsHostCompatibilityListController(vuiConstants, i18nService, columnRenderersRegistry, dvsHostCompatibilityService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dvsHostCompatibilityService = dvsHostCompatibilityService;
            this.hasCompatibilityError = false;
            this.datagridDescription = this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.compatibilityIssuesHeader");
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.buildColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                resizable: true,
                data: this.hostCompatibilityData,
                actionBarOptions: {
                    actions: []
                },
                onChange: this.onSelectionChange.bind(this)
            };
            this.compatibilityIssuesHeader = this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.compatibilityIssuesHeader");
        }
        DvsHostCompatibilityListController.prototype.$onInit = function () {
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [{ size: '70%', min: '120px' }, { size: '30%', min: '50px' }]
            };
            this.iconTextRenderer =
                this.columnRenderersRegistry.getColumnRenderer('icon-text');
        };
        DvsHostCompatibilityListController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.hostCompatibilityData ?
                this.hostCompatibilityData : [];
        };
        DvsHostCompatibilityListController.prototype.setOverallCompatibilityStatus = function () {
            if (!this.hostCompatibilityData || this.hostCompatibilityData.length === 0) {
                this.hostCompatibilityIssues = [this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.noHosts")];
                this.hasCompatibilityError = false;
            }
            else if (this.dvsHostCompatibilityService.isIncompatibleHostAvailable(this.hostCompatibilityData)) {
                this.hostCompatibilityIssues = [this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.incompatibleHostsPresent")];
                this.hasCompatibilityError = true;
            }
            else {
                this.hostCompatibilityIssues = [this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.allHostsCompatible")];
                this.hasCompatibilityError = false;
            }
        };
        DvsHostCompatibilityListController.prototype.buildColumnDefinitions = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.hostColumnHeader"),
                    field: "hostName",
                    width: "300px",
                    template: function (item) {
                        return _this.iconTextRenderer(["hostIcon", "hostName"], {
                            hostName: item.hostName,
                            hostIcon: item.hostIcon
                        });
                    }
                }, {
                    displayName: this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.compatibilityColumnHeader"),
                    width: "100%",
                    template: function (item) {
                        var isHostCompatible = _this.isHostCompatible(item);
                        var compatibilityStatus = isHostCompatible
                            ? _this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.compatibleText", item.hostName)
                            : _this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.incompatibleText");
                        return isHostCompatible ?
                            "<span><span class='vsphere-icon-status-ok'></span>" +
                                ("<span class='vertical-align-cell'>" + compatibilityStatus + "</span></span>") :
                            "<span><clr-icon shape='error' size='24' " +
                                "class='is-error dvs-host-compatibility-error'></clr-icon>" +
                                ("<span class='vertical-align-cell'>" + compatibilityStatus + "</span></span>");
                    }
                }];
        };
        DvsHostCompatibilityListController.prototype.isHostCompatible = function (item) {
            return item.compatibilityErrors === null ||
                item.compatibilityErrors.length === 0;
        };
        DvsHostCompatibilityListController.prototype.onSelectionChange = function (items) {
            if (items && items.length > 0) {
                if (this.isHostCompatible(items[0])) {
                    this.hostCompatibilityIssues = [this.i18nService.getString("DvsUi", "DvsHostCompatibilityList.compatibleHost", items[0].hostName)];
                    this.hasCompatibilityError = false;
                }
                else {
                    this.hostCompatibilityIssues = items[0].compatibilityErrors;
                    this.hasCompatibilityError = true;
                }
            }
            else {
                this.setOverallCompatibilityStatus();
            }
        };
        DvsHostCompatibilityListController.$inject = [
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry",
            "dvsHostCompatibilityService"
        ];
        return DvsHostCompatibilityListController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsHostCompatibilityList", new DvsHostCompatibilityListComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeReadyToCompletePageComponent = (function () {
        function DvsUpgradeReadyToCompletePageComponent() {
            this.bindings = {
                wizardModel: "<"
            };
            this.controller = DvsReadyToCompletePageComponentController;
            this.templateUrl = "dvs-ui/resources/dvs/upgrade/components/" +
                "dvsUpgradeReadyToCompletePageTemplate.html";
        }
        return DvsUpgradeReadyToCompletePageComponent;
    }());
    dvs_ui.DvsUpgradeReadyToCompletePageComponent = DvsUpgradeReadyToCompletePageComponent;
    var DvsReadyToCompletePageComponentController = (function () {
        function DvsReadyToCompletePageComponentController(i18nService, vxPropertyViewService, formattingService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.formattingService = formattingService;
            this.dvsUpgradeWarning = this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.warningMessage");
            this.buildPropertyView();
        }
        DvsReadyToCompletePageComponentController.prototype.buildPropertyView = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            // Distributed switch name
            generalSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.dvsName"), this.wizardModel.dvsName);
            // Current distributed switch version
            generalSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.currentDvsVersion"), this.wizardModel.currentVersion);
            // Upgrade distributed switch version
            generalSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.upgradeDvsVersion"), this.wizardModel.selectedVersion);
            // Upgrade Network I/O Control
            if (this.wizardModel.isExplicitNiocUpgradeSupported) {
                generalSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.upgradeNioc"), this.wizardModel.isExplicitNiocUpgradeSupported &&
                    this.wizardModel.isExplicitNiocUpgradeEnabled
                    ? this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.enabled")
                    : this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.disabled"));
            }
            // Upgrade LACP Support
            if (this.wizardModel.isExplicitLacpUpgradeSupported) {
                generalSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.upgradeLacp"), this.wizardModel.isExplicitLacpUpgradeSupported &&
                    this.wizardModel.isExplicitLacpUpgradeEnabled
                    ? this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.enabled")
                    : this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.disabled"));
            }
            // NIOC - migrate shares
            if (this.wizardModel.isExplicitNiocUpgradeSupported &&
                this.wizardModel.isExplicitNiocUpgradeEnabled &&
                this.wizardModel.niocUpgradeStatistics &&
                this.wizardModel.niocUpgradeStatistics.userDefinedNrpCount > 0) {
                var niocSection = generalCategory.section("niocSection").title(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.niocSettings"));
                niocSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares"), this.wizardModel.migrateShares
                    ? this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares.on")
                    : this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.summary.migrateShares.off"));
            }
            // LACP support
            if (this.wizardModel.isExplicitLacpUpgradeSupported &&
                this.wizardModel.isExplicitLacpUpgradeEnabled) {
                if (this.wizardModel.lag !== null) {
                    var lagSection = generalCategory.section("lagSection").title(this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.lacpSettings"));
                    // LAG name
                    lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.summary.lagName"), this.wizardModel.lag.name);
                    // Number of ports
                    lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.numPorts"), this.wizardModel.lag.uplinkNum.toString());
                    // Mode
                    lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.mode"), this.formattingService.getLacpModeText(this.wizardModel.lag.mode));
                    // Load balancing
                    lagSection.property(this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.loadBalancing"), this.formattingService.getLoadBalancingModeText(this.wizardModel.lag.loadbalanceAlgorithm));
                }
            }
            this.propertyViewData = builder.build();
        };
        DvsReadyToCompletePageComponentController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "lagPropertiesFormattingService"
        ];
        return DvsReadyToCompletePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dvs")
        .component("dvsUpgradeReadyToCompletePage", new DvsUpgradeReadyToCompletePageComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    angular.module("com.vmware.vsphere.client.dvs").constant("dvsUpgradeWizardConstants", {
        pages: {
            DVS_SELECT_VERSION_PAGE: "selectVersionPage",
            DVS_NIOC_PREREQUISITES_PAGE: "upgradeNiocPage",
            DVS_NIOC_MIGRATE_SHARES_PAGE: "niocMigrateSharesPage",
            DVS_LACP_PREREQUISITES_PAGE: "enhanceLacpPage",
            DVS_LACP_CREATE_LAG_PAGE: "lacpCreateLag",
            DVS_HOST_COMPATIBILITY_PAGE: "hostCompatibilityPage",
            DVS_READY_TO_COMPLETE_PAGE: "readyToCompletePage"
        },
        properties: {
            DVS_UPGRADE_WIZARD_DATA: "dvsupgrade:wizardData",
            DVS_HOST_COMPATIBILITY_DATA: "dvsupgrade:hostCompatibility"
        },
        spec: {
            PRODUCT_SPEC_TYPE: "com.vmware.vim.binding.vim.dvs.ProductSpec"
        },
        features: {
            LACP: "lacp",
            NIOC: "nioc"
        }
    });
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeWizardManager = (function () {
        function DvsUpgradeWizardManager(pageStateManagementService, wizardConstants, vuiConstants, featureService) {
            this.pageStateManagementService = pageStateManagementService;
            this.wizardConstants = wizardConstants;
            this.vuiConstants = vuiConstants;
            this.featureService = featureService;
        }
        DvsUpgradeWizardManager.prototype.init = function (wizardScope) {
            var _this = this;
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            // Hide the Upgrade NIOC pages initially
            this.showHideUpgradeNiocPages(wizardScope.wizardConfig.pages, false /*isExplicitNiocUpgradeSupported*/, false /*isExplicitNiocUpgradeEnabled*/, false /*isUserDefinedNrpAvailable*/);
            // Hide the Upgrade LACP pages initially
            this.showHideUpgradeLacpPages(wizardScope.wizardConfig.pages, false /*isExplicitLacpUpgradeSupported*/, false /*isExplicitLacpUpgradeEnabled*/, false /*isLagConfigAvailable*/);
            wizardScope.$watch("model.isExplicitLacpUpgradeEnabled", function () {
                var showLagPage = wizardScope.model.isExplicitLacpUpgradeSupported &&
                    wizardScope.model.isExplicitLacpUpgradeEnabled &&
                    wizardScope.model.lag !== null;
                _this.showHidePage(wizardScope.wizardConfig.pages, _this.wizardConstants.pages.DVS_LACP_CREATE_LAG_PAGE, showLagPage);
            });
            wizardScope.$watch("model.isExplicitNiocUpgradeEnabled", function () {
                var showMigrateSharesPage = wizardScope.model.isExplicitNiocUpgradeSupported &&
                    wizardScope.model.isExplicitNiocUpgradeEnabled &&
                    wizardScope.model.niocUpgradeStatistics !== null &&
                    wizardScope.model.niocUpgradeStatistics.userDefinedNrpCount > 0;
                _this.showHidePage(wizardScope.wizardConfig.pages, _this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE, showMigrateSharesPage);
            });
        };
        DvsUpgradeWizardManager.prototype.showHideUpgradeNiocPages = function (pages, isExplicitNiocUpgradeSupported, isExplicitNiocUpgradeEnabled, isUserDefinedNrpAvailable) {
            var showMigrateSharesPage = isExplicitNiocUpgradeSupported &&
                isUserDefinedNrpAvailable &&
                isExplicitNiocUpgradeEnabled;
            this.showHidePage(pages, this.wizardConstants.pages.DVS_NIOC_PREREQUISITES_PAGE, isExplicitNiocUpgradeSupported);
            this.showHidePage(pages, this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE, showMigrateSharesPage);
        };
        DvsUpgradeWizardManager.prototype.showHideUpgradeLacpPages = function (pages, isExplicitLacpUpgradeSupported, isExplicitLacpUpgradeEnabled, isLagConfigAvailable) {
            var showLagPage = isExplicitLacpUpgradeSupported &&
                isLagConfigAvailable &&
                isExplicitLacpUpgradeEnabled;
            this.showHidePage(pages, this.wizardConstants.pages.DVS_LACP_PREREQUISITES_PAGE, isExplicitLacpUpgradeSupported);
            this.showHidePage(pages, this.wizardConstants.pages.DVS_LACP_CREATE_LAG_PAGE, showLagPage);
        };
        DvsUpgradeWizardManager.prototype.updateExplicitUpgradesPages = function (wizardScope) {
            wizardScope.model.isExplicitLacpUpgradeSupported =
                this.featureService.isExplicitLacpUpgradeSupported(wizardScope.model.selectedVersion, wizardScope.model.isLacpConfigured, wizardScope.model.currentLacpVersion);
            this.showHideUpgradeLacpPages(wizardScope.wizardConfig.pages, wizardScope.model.isExplicitLacpUpgradeSupported, wizardScope.model.isExplicitLacpUpgradeEnabled, wizardScope.model.lag !== null);
            wizardScope.model.isExplicitNiocUpgradeSupported =
                this.featureService.isExplicitNiocUpgradeSupported(wizardScope.model.selectedVersion, wizardScope.model.currentNiocVersion, wizardScope.model.niocUpgradeStatistics);
            var isUserDefinedNrpAvailable = wizardScope.model.niocUpgradeStatistics !== null &&
                wizardScope.model.niocUpgradeStatistics.userDefinedNrpCount > 0;
            this.showHideUpgradeNiocPages(wizardScope.wizardConfig.pages, wizardScope.model.isExplicitNiocUpgradeSupported, wizardScope.model.isExplicitNiocUpgradeEnabled, isUserDefinedNrpAvailable);
        };
        DvsUpgradeWizardManager.prototype.showHidePage = function (pages, pageId, showPage) {
            var page = _.findWhere(pages, { id: pageId });
            if (page) {
                page.state = showPage
                    ? this.vuiConstants.wizard.pageState.INCOMPLETE
                    : this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        DvsUpgradeWizardManager.$inject = [
            "pageStateManagementService",
            "dvsUpgradeWizardConstants",
            "vuiConstants",
            "dvsUpgradeFeaturesService"];
        return DvsUpgradeWizardManager;
    }());
    dvs_ui.DvsUpgradeWizardManager = DvsUpgradeWizardManager;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeWizardManager", DvsUpgradeWizardManager);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var DvsUpdateWizardPages = dvs_ui.DvsUpgradeWizardPages;
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeWizardPages = (function () {
        function DvsUpgradeWizardPages(i18nService, wizardManager, wizardConstants, simpleValidationCommit, vuiConstants, dvsHostCompatibilityPageValidator, dvsPrerequisitesPageValidator, dvsLagPageValidator) {
            this.i18nService = i18nService;
            this.wizardManager = wizardManager;
            this.wizardConstants = wizardConstants;
            this.simpleValidationCommit = simpleValidationCommit;
            this.vuiConstants = vuiConstants;
            this.dvsHostCompatibilityPageValidator = dvsHostCompatibilityPageValidator;
            this.dvsPrerequisitesPageValidator = dvsPrerequisitesPageValidator;
            this.dvsLagPageValidator = dvsLagPageValidator;
        }
        /**
         * Creates an array of page definitions for the Upgrade Distributed Switch wizard.
         */
        DvsUpgradeWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var selectDvsVersionPage = {
                id: this.wizardConstants.pages.DVS_SELECT_VERSION_PAGE,
                title: this.i18nService.getString("DvsUi", "SelectDvsVersionPage.title"),
                description: this.i18nService.getString("DvsUi", "SelectDvsVersionPage.description"),
                contentUrl: "dvs-ui/resources/dvs/upgrade/views/dvsSelectVersionPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    _this.wizardManager.updateExplicitUpgradesPages(wizardScope);
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.selectedVersion"]
            };
            var hostCompatibilityPage = {
                id: this.wizardConstants.pages.DVS_HOST_COMPATIBILITY_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.description"),
                contentUrl: "dvs-ui/resources/dvs/upgrade/views/" +
                    "dvsHostCompatibilityPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvsHostCompatibilityPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var niocPrerequisitesPage = {
                id: this.wizardConstants.pages.DVS_NIOC_PREREQUISITES_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsNiocPrerequisitesPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsNiocPrerequisitesPage.description"),
                contentUrl: "dvs-ui/resources/dvs/upgrade/views/" +
                    "dvsNiocPrerequisitesPage.html",
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
                onCommit: this.simpleValidationCommit(function () {
                    if (!wizardScope.model.isExplicitNiocUpgradeEnabled) {
                        return true;
                    }
                    return _this.dvsPrerequisitesPageValidator.getValidationResult(wizardScope.model.niocPrerequisiteChecks, wizardScope.model);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var migrateSharesPage = {
                id: this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.migrateShares.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeNiocWizard.migrateShares.description"),
                contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                    "dvsUpgradeNiocSharesPage.html",
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: ["model.migrateShares"]
            };
            var lacpPrerequisitesPage = {
                id: this.wizardConstants.pages.DVS_LACP_PREREQUISITES_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsLacpPrerequisitesPage.title"),
                description: this.i18nService.getString("DvsUi", "DvsLacpPrerequisitesPage.description"),
                contentUrl: "dvs-ui/resources/dvs/upgrade/views/" +
                    "dvsLacpPrerequisitesPage.html",
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
                onCommit: this.simpleValidationCommit(function () {
                    if (!wizardScope.model.isExplicitLacpUpgradeEnabled) {
                        return true;
                    }
                    return _this.dvsPrerequisitesPageValidator.getValidationResult(wizardScope.model.lacpPrerequisiteChecks, wizardScope.model);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var lacpLagPage = {
                id: this.wizardConstants.pages.DVS_LACP_CREATE_LAG_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeLacpWizard.createLag.description"),
                contentUrl: "dvs-ui/resources/dvs/lacpupgrade/views/" +
                    "dvsUpgradeLacpLagPage.html",
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
                onCommit: this.simpleValidationCommit(function () {
                    return _this.dvsLagPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: ["model.lag.name"]
            };
            var summaryPage = {
                id: this.wizardConstants.pages.DVS_READY_TO_COMPLETE_PAGE,
                title: this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.title"),
                description: this.i18nService.getString("DvsUi", "DvsUpgradeWizard.summary.description"),
                contentUrl: "dvs-ui/resources/dvs/upgrade/views/" +
                    "dvsUpgradeReadyToCompletePage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return [];
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var pages = [
                selectDvsVersionPage,
                hostCompatibilityPage,
                niocPrerequisitesPage,
                migrateSharesPage,
                lacpPrerequisitesPage,
                lacpLagPage,
                summaryPage
            ];
            return pages;
        };
        DvsUpgradeWizardPages.$inject = [
            "i18nService",
            "dvsUpgradeWizardManager",
            "dvsUpgradeWizardConstants",
            "simpleValidationCommit",
            "vuiConstants",
            "dvsHostCompatibilityPageValidator",
            "dvsPrerequisitesPageValidator",
            "dvsLagPageValidator"];
        return DvsUpgradeWizardPages;
    }());
    dvs_ui.DvsUpgradeWizardPages = DvsUpgradeWizardPages;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeWizardPages", DvsUpgradeWizardPages);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeWizardService = (function () {
        function DvsUpgradeWizardService($rootScope, i18nService, vuiWizardService, mutationService, dataService, specFactory, wizardConstants, wizardManager, wizardPages, wizardValidationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.specFactory = specFactory;
            this.wizardConstants = wizardConstants;
            this.wizardManager = wizardManager;
            this.wizardPages = wizardPages;
            this.wizardValidationService = wizardValidationService;
        }
        /**
         * Shows the Upgrade Distributed Switch wizard.
         */
        DvsUpgradeWizardService.prototype.show = function (objectId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new dvs_ui.DvsUpgradeWizardModel();
            wizardScope.model.dvsId = objectId;
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("DvsUi", "DvsUpgradeWizard.title"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                cssClass: "dvs-upgrade-wizard",
                onFinish: function () {
                    var spec = _this.specFactory.buildDvsUpgradeSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.dvsId, spec._type, spec);
                    return true;
                }
            };
            wizardScope.wizardConfig.pages = this.wizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.wizardManager.init(wizardScope);
            this.requestProperties(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        DvsUpgradeWizardService.prototype.requestProperties = function (wizardScope) {
            var _this = this;
            wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(wizardScope.model.dvsId, [
                this.wizardConstants.properties.DVS_UPGRADE_WIZARD_DATA])
                .then(function (response) {
                var upgradeDvsData = response[_this.wizardConstants.properties.DVS_UPGRADE_WIZARD_DATA];
                wizardScope.model.dvsName = upgradeDvsData.dvsName;
                wizardScope.model.supportedVersionSpecs =
                    upgradeDvsData.supportedSwitchSpec;
                wizardScope.model.currentVersion =
                    upgradeDvsData.currentSwitchSpec.version;
                var supportedSwitchSpecs = _.filter(upgradeDvsData.supportedSwitchSpec, function (switchSpec) {
                    return switchSpec.version > wizardScope.model.currentVersion;
                });
                wizardScope.model.supportedVersions = _.map(supportedSwitchSpecs, function (productSpec) {
                    return productSpec.version;
                }).sort(function (versionA, versionB) {
                    if (versionA < versionB) {
                        return 1;
                    }
                    else if (versionB < versionA) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
                if (wizardScope.model.supportedVersions
                    && wizardScope.model.supportedVersions.length > 0) {
                    wizardScope.model.selectedVersion =
                        wizardScope.model.supportedVersions[0];
                }
                wizardScope.model.currentNiocVersion =
                    upgradeDvsData.currentNiocVersion;
                wizardScope.model.niocUpgradeStatistics =
                    upgradeDvsData.niocUpgradeStatistics;
                wizardScope.model.isLacpConfigured =
                    upgradeDvsData.isLacpConfigured;
                if (upgradeDvsData.isLacpSupported) {
                    wizardScope.model.currentLacpVersion =
                        upgradeDvsData.currentLacpVersion;
                }
                wizardScope.model.niocPrerequisiteChecks =
                    upgradeDvsData.niocPrerequisiteCheckResults;
                wizardScope.model.lacpPrerequisiteChecks =
                    upgradeDvsData.lacpPrerequisiteCheckResults;
                wizardScope.model.lag = upgradeDvsData.lagConfig;
                wizardScope.wizardConfig.title = _this.i18nService.getString("DvsUi", "DvsUpgradeWizard.titleFormat", wizardScope.model.dvsName);
                wizardScope.wizardConfig.loading = false;
            });
        };
        DvsUpgradeWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "mutationService",
            "dataService",
            "dvsUpgradeWizardSpecFactory",
            "dvsUpgradeWizardConstants",
            "dvsUpgradeWizardManager",
            "dvsUpgradeWizardPages",
            "wizardValidationService"
        ];
        return DvsUpgradeWizardService;
    }());
    dvs_ui.DvsUpgradeWizardService = DvsUpgradeWizardService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeWizardService", DvsUpgradeWizardService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeWizardSpec = com.vmware.vsphere.client.h5.network.dvs.upgrade.model.DvsUpgradeWizardSpec;
    /**
     * Provides methods from creating the mutation spec sent to the backend
     * after the completion of the Upgrade Distributed Switch wizard.
     */
    var DvsUpgradeWizardSpecFactory = (function () {
        function DvsUpgradeWizardSpecFactory(defaultUriSchemeUtil, dvsVersionPageConstants, featureService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dvsVersionPageConstants = dvsVersionPageConstants;
            this.featureService = featureService;
        }
        /**
         * Builds the spec the Upgrade Distributed Switch mutation operation.
         */
        DvsUpgradeWizardSpecFactory.prototype.buildDvsUpgradeSpec = function (model) {
            var spec = new DvsUpgradeWizardSpec();
            spec.productSpec = _.find(model.supportedVersionSpecs, function (versionSpec) {
                return versionSpec.version === model.selectedVersion;
            });
            spec.implicitNiocUpgrade = this.featureService.isImplicitNiocUpgradeSupported(model.selectedVersion, model.currentNiocVersion, model.niocUpgradeStatistics);
            spec.explicitNiocUpgrade = model.isExplicitNiocUpgradeSupported &&
                model.isExplicitNiocUpgradeEnabled;
            spec.implicitLacpUpgrade = this.featureService.isImplicitLacpUpgradeSupported(model.selectedVersion, model.isLacpConfigured, model.currentLacpVersion);
            spec.explicitLacpUpgrade = model.isExplicitLacpUpgradeSupported &&
                model.isExplicitLacpUpgradeEnabled;
            spec.migrateShares = model.migrateShares;
            spec.lag = model.lag;
            spec.isMultiLagLacpSupported =
                this.featureService.isMultiLagLacpSupported(model.selectedVersion);
            return spec;
        };
        DvsUpgradeWizardSpecFactory.$inject = [
            "defaultUriSchemeUtil",
            "dvsVersionPageConstants",
            "dvsUpgradeFeaturesService"];
        return DvsUpgradeWizardSpecFactory;
    }());
    dvs_ui.DvsUpgradeWizardSpecFactory = DvsUpgradeWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeWizardSpecFactory", DvsUpgradeWizardSpecFactory);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeWizardModel = (function () {
        function DvsUpgradeWizardModel() {
            this.selectedVersion = "";
            this.currentVersion = "";
            this.migrateShares = false;
            this.prerequisiteWarningShown = false;
            this.isCompatibilityDataRetrievedForVersion = "";
            this.isExplicitNiocUpgradeSupported = false;
            this.isExplicitLacpUpgradeSupported = false;
            this.isExplicitLacpUpgradeEnabled = true;
            this.isExplicitNiocUpgradeEnabled = true;
        }
        return DvsUpgradeWizardModel;
    }());
    dvs_ui.DvsUpgradeWizardModel = DvsUpgradeWizardModel;
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHostCompatibilityService = (function () {
        function DvsHostCompatibilityService() {
        }
        DvsHostCompatibilityService.prototype.isIncompatibleHostAvailable = function (hostCompatibilityData) {
            if (!hostCompatibilityData || hostCompatibilityData.length === 0) {
                return false;
            }
            var incompatibleHostItem = _.find(hostCompatibilityData, function (item) {
                return item.compatibilityErrors &&
                    item.compatibilityErrors.length !== 0;
            });
            return incompatibleHostItem !== undefined;
        };
        DvsHostCompatibilityService.$inject = [];
        return DvsHostCompatibilityService;
    }());
    dvs_ui.DvsHostCompatibilityService = DvsHostCompatibilityService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsHostCompatibilityService", DvsHostCompatibilityService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsUpgradeFeaturesService = (function () {
        function DvsUpgradeFeaturesService(dvsVersionPageConstants) {
            this.dvsVersionPageConstants = dvsVersionPageConstants;
            this.LACP_API_VERSION_SINGLE_LAG = "singleLag";
        }
        DvsUpgradeFeaturesService.prototype.isMultiLagLacpSupported = function (selectedVersion) {
            // The multi LAG LACP support is added in 5.5.0
            return this.isSupportedForVersion(selectedVersion, this.dvsVersionPageConstants.versions._55);
        };
        DvsUpgradeFeaturesService.prototype.isImplicitNiocUpgradeSupported = function (selectedProductSpecVersion, currentNiocVersion, niocUpgradeStatistics) {
            // Returns true if the DVS supports NIOCv3 and if the existing NIOC
            // version is earlier than ver 3
            // NIOCv3 support is added in DVS 6.0.0
            var isUpgradeSupported = this.isNiocUpgradeSupported(selectedProductSpecVersion, currentNiocVersion);
            return isUpgradeSupported &&
                niocUpgradeStatistics &&
                (isNaN(niocUpgradeStatistics.modifiedSystemNrpCount) ||
                    niocUpgradeStatistics.modifiedSystemNrpCount === 0) &&
                (isNaN(niocUpgradeStatistics.userDefinedNrpCount) ||
                    niocUpgradeStatistics.userDefinedNrpCount === 0);
        };
        DvsUpgradeFeaturesService.prototype.isExplicitNiocUpgradeSupported = function (selectedProductSpecVersion, currentNiocVersion, niocUpgradeStatistics) {
            var isUpgradeSupported = this.isNiocUpgradeSupported(selectedProductSpecVersion, currentNiocVersion);
            // Returns true if the DVS supports NIOCv3 and if the existing NIOC
            // version is earlier than ver 3, and the implicit upgrade
            // is not possible
            // NIOCv3 support is added in DVS 6.0.0
            return isUpgradeSupported &&
                !this.isImplicitNiocUpgradeSupported(selectedProductSpecVersion, currentNiocVersion, niocUpgradeStatistics);
        };
        DvsUpgradeFeaturesService.prototype.isImplicitLacpUpgradeSupported = function (selectedProductSpecVersion, isLacpConfigured, currentLacpVersion) {
            // Returns true if the target DVS version
            // supports multi lag LACP and the protocol is
            // currently disabled or not available
            return this.isMultiLagLacpSupported(selectedProductSpecVersion) &&
                (!currentLacpVersion ||
                    (currentLacpVersion === this.LACP_API_VERSION_SINGLE_LAG &&
                        !isLacpConfigured));
        };
        DvsUpgradeFeaturesService.prototype.isExplicitLacpUpgradeSupported = function (selectedProductSpecVersion, isLacpConfigured, currentLacpVersion) {
            // Returns true if the target DVS version
            // supports multi lag LACP and the protocol is
            // currently disabled or not available and the implicit
            // upgrade is not possible
            return this.isMultiLagLacpSupported(selectedProductSpecVersion) &&
                (!currentLacpVersion ||
                    currentLacpVersion === this.LACP_API_VERSION_SINGLE_LAG) &&
                !this.isImplicitLacpUpgradeSupported(selectedProductSpecVersion, isLacpConfigured, currentLacpVersion);
        };
        DvsUpgradeFeaturesService.prototype.isNiocUpgradeSupported = function (selectedProductSpecVersion, currentNiocVersion) {
            return this.isSupportedForVersion(selectedProductSpecVersion, this.dvsVersionPageConstants.versions._60) &&
                !isNaN(currentNiocVersion) && currentNiocVersion < 3;
        };
        DvsUpgradeFeaturesService.prototype.isSupportedForVersion = function (selectedProductSpecVersion, minSupportedProductSpecVersion) {
            if (!selectedProductSpecVersion || !minSupportedProductSpecVersion) {
                return false;
            }
            var selectedVersion = parseInt(selectedProductSpecVersion.replace(".", ""));
            var minSupportedVersion = parseInt(minSupportedProductSpecVersion.replace(".", ""));
            if (isNaN(selectedVersion) || isNaN(minSupportedVersion)) {
                return false;
            }
            return selectedVersion >= minSupportedVersion;
        };
        DvsUpgradeFeaturesService.$inject = ["dvsVersionPageConstants"];
        return DvsUpgradeFeaturesService;
    }());
    dvs_ui.DvsUpgradeFeaturesService = DvsUpgradeFeaturesService;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsUpgradeFeaturesService", DvsUpgradeFeaturesService);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHostCompatibilityPageValidator = (function () {
        function DvsHostCompatibilityPageValidator(i18nService, $q, dvsHostCompatibilityService) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.dvsHostCompatibilityService = dvsHostCompatibilityService;
        }
        DvsHostCompatibilityPageValidator.prototype.getValidationError = function (wizardScope) {
            if (this.dvsHostCompatibilityService.isIncompatibleHostAvailable(wizardScope.model.hostCompatibilityData)) {
                return this.$q.resolve([this.i18nService.getString("DvsUi", "DvsHostCompatibilityPage.incompatibleHostsPresent")]);
            }
            return this.$q.resolve([]);
        };
        DvsHostCompatibilityPageValidator.$inject = ["i18nService", "$q", "dvsHostCompatibilityService"];
        return DvsHostCompatibilityPageValidator;
    }());
    dvs_ui.DvsHostCompatibilityPageValidator = DvsHostCompatibilityPageValidator;
    angular.module("com.vmware.vsphere.client.dvs")
        .service("dvsHostCompatibilityPageValidator", DvsHostCompatibilityPageValidator);
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var DvsHostCompatibilityPageController = (function () {
        function DvsHostCompatibilityPageController($scope, dataService, $q, i18nService, wizardConstants) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.$q = $q;
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            if (this.$scope.model.isCompatibilityDataRetrievedForVersion !==
                this.$scope.model.selectedVersion) {
                this.requestHostCompatibilityData();
            }
            else {
                this.hostCompatibilityData = this.$scope.model.hostCompatibilityData;
            }
        }
        DvsHostCompatibilityPageController.prototype.requestHostCompatibilityData = function () {
            var _this = this;
            this.$scope.wizardConfig.loading = true;
            this.dataService.getProperties(this.$scope.model.dvsId, [this.wizardConstants.properties.DVS_HOST_COMPATIBILITY_DATA], {
                propertyParams: [{
                        propertyName: this.wizardConstants.properties.DVS_HOST_COMPATIBILITY_DATA,
                        parameterType: this.wizardConstants.spec.PRODUCT_SPEC_TYPE,
                        parameter: _.find(this.$scope.model.supportedVersionSpecs, function (versionSpec) {
                            return versionSpec.version === _this.$scope.model.selectedVersion;
                        })
                    }]
            }).then(function (response) {
                var hostData = response[_this.wizardConstants.properties.DVS_HOST_COMPATIBILITY_DATA];
                if (hostData) {
                    _this.hostCompatibilityData = hostData;
                }
                else {
                    _this.hostCompatibilityData = [];
                }
                _this.$scope.model.hostCompatibilityData = _this.hostCompatibilityData;
                _this.$scope.model.isCompatibilityDataRetrievedForVersion =
                    _this.$scope.model.selectedVersion;
                _this.$scope.wizardConfig.loading = false;
            });
        };
        ;
        DvsHostCompatibilityPageController.$inject = [
            "$scope",
            "dataService",
            "$q",
            "i18nService",
            "dvsUpgradeWizardConstants"
        ];
        return DvsHostCompatibilityPageController;
    }());
    dvs_ui.DvsHostCompatibilityPageController = DvsHostCompatibilityPageController;
    angular.module("com.vmware.vsphere.client.dvs")
        .controller("DvsHostCompatibilityPageController", DvsHostCompatibilityPageController);
})(dvs_ui || (dvs_ui = {}));





/* Copyright 2015 - 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.commonModule = {
   angularModule: angular.module('com.vmware.vsphere.client.commonModule', [
      'com.vmware.platform.ui', 'ui.bootstrap'])
};

// Add action
angular.module('com.vmware.vsphere.client.commonModule')
   .run(['mutationService',
      'vuiModalService',
      '$rootScope',
      '$document',
      'clarityConstants',
      '$timeout',
      'actionDialogService',
      'clarityModalService',
      'dataService',
      'i18nService',
      'libraryService',
      'categoryService',
      'categoryActionService',
      'createContentLibraryService',
      '$injector',
      'AngularInjector',
      'defaultUriSchemeUtil',
      'dragAndDropStockExpressionsService',
      'vscAssignTagsLauncherService',
      'vscOpenManageAlarmService',
      'managedEntityConstants',
      function (mutationService,
         vuiModalService,
         $rootScope,
         $document,
         clarityConstants,
         $timeout,
         actionDialogService,
         clarityModalService,
         dataService,
         i18nService,
         libraryService,
         categoryService,
         categoryActionService,
         createContentLibraryService,
         $injector,
         AngularInjector,
         defaultUriSchemeUtil,
         dragAndDropStockExpressionsService,
         vscAssignTagsLauncherService,
         vscOpenManageAlarmService,
         managedEntityConstants) {

         var NAME_PROPERTY = 'name';
         var TYPE_PROPERTY = 'type';
         var MOR_ID_OF_VMTX_PROPERTY = 'morIdOfVmtx';

         /*
          * Register the action invoker function in the h5.actions cache.
          */
         h5.actions['vsphere.core.actions.openAboutVsphere'] = function (actionEval, availableTargets) {
            openAboutVspherePopup();
         };
         h5.actions['vsphere.opsmgmt.alarms.acknowledge'] = function (actionEval, availableTargets, context) {
            var alarm = context.alarm ? context.alarm : context.details.alarmInfo.alarm;
            return mutationService
               .apply(
                  context.entityId,
                  'com.vmware.opsmgmt.client.alarms.AlarmAcknowledgementSpec',
                  {alarm: alarm})
               .then(function (operationResult) {
                  if (operationResult && operationResult.error) {
                     return;
                  }
                  // Since the above mutation does not cause a generation
                  // number change, we need to manually refresh the object.
                  // Here, we are refreshing only the issues, under the
                  // assumption that alarm acknowledgement should not change
                  // the status of an object.
                  $rootScope.$broadcast('IssueChangeEvent');
               });
         };
         h5.actions['vsphere.opsmgmt.alarms.reset'] = function (actionEval, availableTargets, context) {
            var alarm = context.alarm ? context.alarm : context.details.alarmInfo.alarm;
            return mutationService
               .apply(
                  context.entityId,
                  'com.vmware.opsmgmt.client.alarms.AlarmStatusSpec',
                  {
                     alarm: alarm,
                     status: 'green'
                  })
               .then(function (operationResult) {
                  if (operationResult && operationResult.error) {
                     return;
                  }
                  // Since the above mutation does not cause a generation
                  // number change, we need to manually refresh the object.
                  var objectChangeInfo = {
                     operationType: 'CHANGE',
                     objectId: context.entityId,
                     object: context.entity
                  };
                  $rootScope.$broadcast('modelChanged', objectChangeInfo);
                  $rootScope.$broadcast('IssueChangeEvent');
               });
         };

         function invokeEnableAlarmAction(availableTarget, isEnabled) {
            return mutationService
               .apply(availableTarget, 'com.vmware.opsmgmt.client.alarms.EnableAlarmActionsSpec', {
                  enabled: isEnabled
               });
         }

         h5.actions['vsphere.opsmgmt.alarms.enableAlarmActions'] = function (actionEval, availableTargets, context) {
            return invokeEnableAlarmAction(availableTargets[0], true);
         };

         h5.actions['vsphere.opsmgmt.alarms.disableAlarmActions'] = function (actionEval, availableTargets, context) {
            return invokeEnableAlarmAction(availableTargets[0], false);
         };

         h5.actions['vsphere.core.actions.editCustomAttributesAction'] = function (actionEval, availableTargets, context) {
            clarityModalService.openModal(
               actionEval,
               availableTargets,
               context,
               'common-module-ui/resources/common-module/views/custom-attributes/EditCustomAttributesDialog.html'
            );
         };

         h5.actions['vsphere.core.inventory.actions.addPermission'] = function (actionEval, availableTargets, context) {
            if (!context) {
               context = {edit: false};
            }
            clarityModalService.openModal(actionEval, availableTargets, context,
               'common-module-ui/resources/common-module/views/permission/AddPermissionDialog.html',
               {height: 'auto'});
         };

         h5.actions['vsphere.core.common.actions.removeTagAction'] = function (actionEval, availableTargets, context) {
            clarityModalService.openModal(actionEval, availableTargets, context,
               'common-module-ui/resources/common-module/views/tags/removeTagDialog.html',
               {height: 'auto'});
         };

         h5.actions['vsphere.core.common.actions.assignTag'] = function (actionEval, availableTargets, context) {
             vscAssignTagsLauncherService.showAssignTagsModal(availableTargets, context);
         };

         h5.actions['vsphere.core.common.actions.addCategory'] = function (actionEval, availableTargets, context) {
            clarityModalService.openModal(actionEval, availableTargets, context,
               'common-module-ui/resources/common-module/views/categories/add-edit-category.html');
         };

         function transformCategoriesData (categories) {
            return _.map(categories, function(category) {
               if (category.associableEntityTypes.length === 0) {
                  category.displayAssociableEntityTypesString = i18nService.getString('Common', 'tag.dashboard.categories.associable.all');
               } else {
                  category.displayAssociableEntityTypesString = lookupEntityNames(category.associableEntityTypes).join(', ');
               }
               return category;
            });
         }

         function lookupEntityNames (entityTypes) {
             return _.map(entityTypes, function(entityType) {
                 return i18nService.getString('Common', 'typeResource.entityType.' + entityType + 'Plural');
             });
         }

         h5.actions['vsphere.core.common.actions.editCategory'] = function (actionEval, availableTargets) {
              if (availableTargets) {
                  categoryService.getAll().then(function(data) {
                      var categories = transformCategoriesData(data);
                      dataService.getProperties(availableTargets[0], ['name','description',
                          'multipleCardinality', 'associableEntityType']).then(function (data) {
                           var entityTypesString = '';
                          if (data.associableEntityType === null) {
                              entityTypesString = i18nService.getString('Common', 'tag.dashboard.categories.associable.all');
                          }
                          var parts = availableTargets[0].split(':');
                          var mor = {
                              type: parts[2],
                              value: parts[3],
                              serverGuid: parts[4]
                          };
                          var categoryData = {
                              categoryName: data.name,
                              managedObjectReference: mor,
                              categoryDescription: data.description,
                              multipleCardinality: data.multipleCardinality,
                              displayAssociableEntityTypesString: entityTypesString,
                              associableEntityTypes: data.associableEntityType
                          };
                          categoryActionService.addEditCategory(categories, categoryData);
                      });
                  });
              } else {
                  return;
              }
          };

         h5.actions['vsphere.core.common.actions.deleteCategory'] = function (actionEval, availableTargets) {
            if (availableTargets) {
               var spec = "com.vmware.vsphere.client.tagging.CategoryCreateSpec";
               mutationService.remove(availableTargets, spec, {});
               $rootScope._navigateToView('vsphere.core.tagsAndCustomAttributes.domainView');
              } else {
               return;
              }
         };

         h5.actions["vsphere.opsmgmt.alarms.creation"] = function(actionEval, availableTargets) {
            if (_.isEmpty(availableTargets)) {
               return;
            }
            vscOpenManageAlarmService.openManageAlarmWizard(availableTargets);
         };

         function renameObject(availableTargets, actionEval) {
            dataService.getProperties(availableTargets[0], ['name']).then(function (data) {
               clarityModalService.openModal(
                  actionEval,
                  availableTargets,
                  {objectId: availableTargets[0], existingObjectName: data.name, defaultButton: 'submit'},
                  'common-module-ui/resources/common-module/views/rename/renameObject.html'
               );
            });
         }

         h5.actions['vsphere.core.common.actions.rename'] = function (actionEval, availableTargets) {
            renameObject(availableTargets, actionEval);
         };

         h5.actions['vsphere.core.common.actions.delete'] = function (actionEval, availableTargets) {
            mutationService.remove(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.delete'] = function (actionEval, availableTargets) {
             function submit() {
                 libraryService.deleteContentLibrary(availableTargets[0]).then(function (result){
                     if (result && result.error) {
                         return;
                     }
                     $rootScope._navigateToView('vsphere.core.viLibraries.domainView');
                 });
             }

            var modalOptions = {
               title: i18nService.getString('LibraryUi', 'libraryDelete.Warning'),
               message: i18nService.getString('LibraryUi', 'libraryDelete.DeleteConfirmationLabel'),
               submit: submit,
               preserveNewlines: true,
               icon: 'icon-warning-32'
            };

            clarityModalService.openConfirmationModal(modalOptions);
         };

         h5.actions['vsphere.core.library.subscribed.editSettings'] = function (actionEval, availableTargets) {
            var editSettingsService = AngularInjector.get('vscSubscribedLibraryEditSettingsModalService');
            editSettingsService.openSubscribedLibraryEditSettingsDialog(availableTargets[0]);
         };

         h5.actions["vsphere.core.library.editNotesAction"] = function (actionEval, availableTargets, context) {
            function onUpdateNotes(objectId, notesValue, operationName) {
               var specType = "com.vmware.vsphere.client.library.specs.EditLibraryBasicSpec";
               var propSpec = {
                  description: notesValue
               };
               mutationService.apply(objectId, specType, propSpec, operationName);
               return true;
            }

            var dialogData = {
               notesPropName: "com.vmware.content.LibraryModel/description",
               onUpdateNotesCallback: onUpdateNotes,
               focusTarget: context ? context.focusTarget : undefined
            };

            clarityModalService.openModal(actionEval, availableTargets, dialogData,
               "common-module-ui/resources/common-module/views/notes/NotesDialog.html");
         };

         h5.actions["vsphere.core.library.item.actions.editNotesAction"] = function (actionEval, availableTargets, context) {
            function onUpdateNotes(objectId, notesValue, operationName) {
               var specType = "com.vmware.vsphere.client.libraryItem.specs.EditLibraryItemSpec";
               var propSpec = {
                  itemDescription: notesValue
               };
               mutationService.apply(objectId, specType, propSpec, operationName);
               return true;
            }

            var dialogData = {
               notesPropName: "com.vmware.content.library.ItemModel/description",
               onUpdateNotesCallback: onUpdateNotes,
               focusTarget: context ? context.focusTarget : undefined
            };

            clarityModalService.openModal(actionEval, availableTargets, dialogData,
               "common-module-ui/resources/common-module/views/notes/NotesDialog.html");
         };


         h5.actions['vsphere.core.library.add'] = function (actionEval, availableTargets) {
            createContentLibraryService.showWizard(availableTargets[0]);
         };

         h5.actions['vsphere.core.libraryItem.import'] = function (actionEval, availableTargets) {
            var svc = $injector.get('vscImportLibraryItemInvoker');
            svc.openImportLibraryItemModal(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.rename'] = function (actionEval, availableTargets) {
            var renameLibraryService = AngularInjector.get('vscRenameLibraryService');
            renameLibraryService.renameLibrary(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.local.editSettings'] = function (actionEval, availableTargets, context) {
            var editSettingsService = AngularInjector.get('vscLocalEditSettingsModalService');
            editSettingsService.openLocalEditSettingsDialog(availableTargets[0], context);
         };

         h5.actions['vsphere.core.library.sync'] = function (actionEval, availableTargets) {
            var svc = $injector.get('vscSyncLibraryService');
            svc.startLibrarySync(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.deployFromTemplate'] = function (actionEval, availableTargets) {
            var createVmWizardService = $injector.get('createVmWizardService');
            var creationTypeConstants = $injector.get('creationTypeConstants');

            dataService.getProperties(availableTargets[0], [TYPE_PROPERTY, MOR_ID_OF_VMTX_PROPERTY, NAME_PROPERTY])
                  .then(function (data) {
                     var creationType, contextObjectId, context;
                     if (data &&
                           data[TYPE_PROPERTY] === managedEntityConstants.VM_TEMPLATE &&
                           data.hasOwnProperty(MOR_ID_OF_VMTX_PROPERTY)) {
                        var vmtxItemMor = data[MOR_ID_OF_VMTX_PROPERTY];
                        creationType = creationTypeConstants.DEPLOY_VM_FROM_VMTX;
                        contextObjectId = defaultUriSchemeUtil.createVmomiUri(vmtxItemMor.type,
                              vmtxItemMor.value, vmtxItemMor.serverGuid);
                        context = {
                           libraryItemId: availableTargets[0],
                           vmtxLibraryItemId: contextObjectId,
                           libraryItemName: data[NAME_PROPERTY]
                        };
                     }
                     else {
                        creationType = creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE;
                        contextObjectId = availableTargets[0];
                     }
                     createVmWizardService.showWizard(contextObjectId, creationType, context);
                  });
         };

         h5.actions['vsphere.core.library.item.actions.publishVmtxTemplate'] = function (actionEval, availableTargets) {
            var publishVmtxTemplateService = AngularInjector.get('vscPublishVmtxTemplateService');
            publishVmtxTemplateService.invokePublishDialog(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.deployFromVapp'] = function (actionEval, availableTargets) {
            var createVmWizardService = $injector.get('createVmWizardService');
            var creationTypeConstants = $injector.get('creationTypeConstants');
            var context = {};

            var creationType = creationTypeConstants.DEPLOY_VM_FROM_VAPP;
            var contextObjectId = availableTargets[0];
            createVmWizardService.showWizard(contextObjectId, creationType, context);
         };

         h5.actions['vsphere.core.library.item.actions.updateItem'] = function (actionEval, availableTargets) {
            var svc = $injector.get('vscImportLibraryItemInvoker');
            svc.openImportLibraryItemModal(availableTargets[0], true);
         };

         h5.actions['vsphere.core.library.item.actions.exportItem'] = function (actionEval, availableTargets) {
            var exportLibraryItemService = $injector.get('vscExportLibraryItemService');
            exportLibraryItemService.exportLibraryItem(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.cloneItem'] = function (actionEval, availableTargets) {
            var cloneItemService = $injector.get('vscCloneItemModalInvokerService');
            cloneItemService.openModal(availableTargets);
         };

         h5.actions['vsphere.core.library.item.actions.deleteItem'] = function (actionEval, availableTargets) {
            var deleteLibraryItemModalService = AngularInjector.get('vscDeleteLibraryItemModalService');
            deleteLibraryItemModalService.openModal(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.syncItem'] = function (actionEval, availableTargets) {
            var syncLibraryItemService = AngularInjector.get('vscSyncLibraryItemService');
            syncLibraryItemService.syncLibraryItem(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.evictLibraryItem'] = function (actionEval, availableTargets) {
            var evictLibraryItemModalService = AngularInjector.get('vscEvictLibraryItemModalService');
            evictLibraryItemModalService.openModal(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.renameItem'] = function (actionEval, availableTargets) {
            var renameLibraryItemService = AngularInjector.get('vscRenameLibraryItemService');
            renameLibraryItemService.renameLibraryItem(availableTargets[0]);
         };

         h5.actions['vsphere.core.library.item.actions.createSubscription'] = function (actionEval, availableTargets) {
            var createSubscriptionService = AngularInjector.get('vscCreateSubscriptionWizardActionInvokerService');
            createSubscriptionService.invoke(actionEval, availableTargets);
         };

         //
         // Common validation methods accessible to all modules.
         //
         // A rule of thumb for all stock methods is that if they cannot firmly
         // decide whether the condition is true or false - they return true
         //
         h5.dragAndDropValidationMethods["equalServerGuid"] = function (
               targetId /*string*/, sourceId /*string*/) {
            var targetReference = defaultUriSchemeUtil.getManagedObjectReference(targetId);
            var sourceReference = defaultUriSchemeUtil.getManagedObjectReference(sourceId);
            return targetReference.serverGuid === sourceReference.serverGuid;
         };

         h5.dragAndDropValidationMethods["isDatacenterFolder"] = function (targetId /*string*/) {
            return dragAndDropStockExpressionsService.isDatacenterFolder(targetId);
         };

         h5.dragAndDropValidationMethods["isVmFolder"] = function (targetId /*string*/) {
            return dragAndDropStockExpressionsService.isVmFolder(targetId);
         };

         h5.dragAndDropValidationMethods["isTargetAccessible"] = function (dropTargetData) {
            return dragAndDropStockExpressionsService.isTargetAccessible(dropTargetData);
         };

         h5.dragAndDropValidationMethods["isWithinSameDatacenter"] = function (dropTargetData, dragObjectsData) {
            return dragAndDropStockExpressionsService.isWithinSameDatacenter(dropTargetData, dragObjectsData);
         };

         h5.dragAndDropValidationMethods["isVmFolderWithinSameDatacenter"] = function (dropTargetData, dragObjectsData) {
            return dragAndDropStockExpressionsService.isVmFolderWithinSameDatacenter(dropTargetData, dragObjectsData);
         };

         h5.dragAndDropValidationMethods["isWithinSameClusterOrHost"] = function (dropTargetData, dragObjectsData) {
            return dragAndDropStockExpressionsService.isWithinSameClusterOrHost(dropTargetData, dragObjectsData);
         };

         h5.dragAndDropValidationMethods["isWithinSameStandaloneHost"] = function (dropTargetData, dragObjectsData) {
            return dragAndDropStockExpressionsService.isWithinSameStandaloneHost(dropTargetData, dragObjectsData);
         };

         h5.dragAndDropValidationMethods["notDirectParent"] = function (dropTargetData, dragObjectsData) {
            return !dragAndDropStockExpressionsService.hasDirectParent(dropTargetData, dragObjectsData);
         };

         h5.dragAndDropValidationMethods["isInVmFolderWithinSameDatacenter"] = function (dropTargetData, dragObjectsData) {
            return dragAndDropStockExpressionsService.isInVmFolderWithinSameDatacenter(dropTargetData, dragObjectsData);
         };

         function openAboutVspherePopup() {
            var modalScope = $rootScope.$new();
            var modalOptions = {
               title: i18nService.getString('CommonUi', 'about.vsphere.title'),
               subTitle: i18nService.getString('CommonUi', 'about.vsphere.version'),
               contentUrl: 'common-module-ui/resources/common-module/views/about-vsphere/AboutVsphere.html',
               size: 'lg'
            };
            modalScope.modalOptions = modalOptions;
            clarityModalService.openPopUp(modalScope);
         }
      }
   ])
   .run([
      'tagActionService',
      'i18nService',
      'defaultUriSchemeUtil',
      'mutationService',
      'dataService',
      '$rootScope',
      function (tagActionService, i18nService, defaultUriSchemeUtil, mutationService, dataService, $rootScope) {
         h5.actions['vsphere.core.common.actions.addTag'] = function () {
            tagActionService.modifyTag({
               name: i18nService.getString('CommonModuleUi', 'tag.create.form.defaultName'),
               description: "",
               mode: 0
            });
         };
         h5.actions['vsphere.core.common.actions.editTag'] = function (actionEval, availableTargets, context) {
            if (!context || !context.tag) {
                if (availableTargets) {
                    dataService.getProperties(availableTargets[0], ['name', 'description', 'categoryName']).then(function (data) {
                        tagActionService.modifyTag({
                            name: data.name,
                            description: data.description,
                            mode: 1,
                            categoryName: data.categoryName
                        }, availableTargets);
                        return;
                    });
                } else {
                    return;
                }
            } else {
               var tagId = defaultUriSchemeUtil.getVsphereObjectId(context.tag.resourceObject);
               tagActionService.modifyTag({
                  name: context.tag.name,
                  description: context.tag.description,
                  mode: 1,
                  categoryName: context.tag.categoryName
                  // TODO: When available, pass the categoryMoRef along so that the category can be fetched
                  // and shown in edit mode.
                  // categoryMoRef: context.tag.categoryMoRef
               }, tagId);
            }
         };
         h5.actions['vsphere.core.common.actions.deleteTag'] = function (actionEval, availableTargets, context) {
            if (!context || !context.tag) {
               if (availableTargets) {
                   var spec = "com.vmware.vsphere.client.tagging.TagCreateSpec";
                   mutationService.remove(availableTargets, spec, {});
                   $rootScope._navigateToView('vsphere.core.tagsAndCustomAttributes.domainView');
               } else {
                  return;
               }
            }
            tagActionService.deleteTag(JSON.parse(JSON.stringify(context.tag.resourceObject)));
         };
      }])
   .run(['columnRenderersRegistry', 'templateHelperService',
      function (columnRenderersRegistry, templateHelperService) {
         columnRenderersRegistry.registerColumnRenderers({
            /**
             * VC name column - icon-link/label renderer.
             *
             * @param  {array} props Array of property names, where:
             *    1st property is VC name.
             *    2nd property (optional) is VC reference.
             *    Other properties are ignored.
             * @param  {object} data  Map of values, contains the specificType.
             * @param {object} config A dictionary (key/value) to control the renderer behavior.
             */
            'vcenter-name': function (props, data, config) {
               var vcName = props[0],
                  vcRef = props[1];
               var objLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
               return objLinkRenderer(
                  [vcRef, vcName, 'vsphere-icon-vcenter'], data, config);
            },
            'tpm-supported': function (props, data, config) {
               var isTpmSupported = data[props[0]];
               var text = "Not Supported";
               if (isTpmSupported) {
                  text = "Supported";
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: text});
            },
            'tpm-version': function (props, data, config) {
               var tpmVersion = data[props[0]];
               if (!tpmVersion) {
                  tpmVersion = "N/A";
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: tpmVersion});
            },
            'txtEnabled': function (props, data, config) {
               var txtEnabled = data[props[0]];
               if (!txtEnabled) {
                  txtEnabled = "N/A";
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: txtEnabled});
            },
            'tpm-attestion-status': function (props, data, config) {
               var tpmAttestionStatus = data[props[0]];
               var text = "N/A";
               var textTemplate = "<div><span>{{text}}</span></div>";
               if (tpmAttestionStatus === 'accepted') {
                  text = "Passed";
               } else if (tpmAttestionStatus === 'notAccepted') {
                  textTemplate = "<div><clr-icon shape='exclamation-circle' class='is-error' size='25'></clr-icon><span>{{text}}</span></div>";
                  text = "Failed";
               }
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: text});
            },
            'tpm-attestion-time': function (props, data, config) {
               var tpmAttestionTime = data[props[0]];
               var text = "N/A";
               if (tpmAttestionTime) {
                  text = moment(tpmAttestionTime).format('MM/DD/YYYY, h:mm A');
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: text});
            },
            'tpm-attestion-message': function (props, data, config) {
               var tpmAttestionMessage = data[props[0]];
               var text = "";
               if (tpmAttestionMessage) {
                  text = tpmAttestionMessage;
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: text});
            },
            'tpm-txt-enabled': function (props, data, config) {
               var tpmTxtEnabled = data[props[0]];
               var text = "Off";
               if (tpmTxtEnabled) {
                  text = "On";
               }
               var textTemplate = "<span>{{text}}</span>";
               var compiledTextTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(textTemplate);
               return compiledTextTemplate({text: text});
            }
         });
      }]);

var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        (function (LibraryOperations) {
            LibraryOperations[LibraryOperations["invalid"] = 0] = "invalid";
            LibraryOperations[LibraryOperations["fetchLibrary"] = 1] = "fetchLibrary";
            LibraryOperations[LibraryOperations["addLibrary"] = 2] = "addLibrary";
            LibraryOperations[LibraryOperations["deleteLibrary"] = 3] = "deleteLibrary";
            LibraryOperations[LibraryOperations["updateLibrary"] = 4] = "updateLibrary";
        })(common_module_ui.LibraryOperations || (common_module_ui.LibraryOperations = {}));
        var LibraryOperations = common_module_ui.LibraryOperations;
        var ContentLibraryConstants = (function () {
            function ContentLibraryConstants() {
            }
            ContentLibraryConstants.LIBRARYTYPE_LOCAL = "LOCAL";
            ContentLibraryConstants.LIBRARYTYPE_SUBSCRIBED = "SUBSCRIBED";
            ContentLibraryConstants.SYNC_STRATEGY_IMMEDIATE = "SYNC_IMMEDIATE";
            ContentLibraryConstants.SYNC_STRATEGY_ONDEMAND = "SYNC_ONDEMAND";
            ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER = "vcsp";
            ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_BASIC = "BASIC";
            ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_NONE = "NONE";
            return ContentLibraryConstants;
        }());
        common_module_ui.ContentLibraryConstants = ContentLibraryConstants;
        var ContentLibraryConstants;
        (function (ContentLibraryConstants) {
            var Api = (function () {
                function Api() {
                }
                Api.SCHEME = "https://";
                Api.VAPI_REST_BASE = "/rest/com/vmware";
                Api.VAPI_REST_SESSION = "/cis/session";
                Api.ADD_LIBRARY_LOCAL = "/content/local-library";
                Api.ADD_LIBRARY_SUBSCRIBED = "/content/subscribed-library";
                Api.FETCH_LIBRARY = "/content/library/id:";
                Api.DELETE_LIBRARY_LOCAL = "/content/local-library/id:";
                Api.DELETE_LIBRARY_SUBSCRIBED = "/content/subscribed-library/id:";
                return Api;
            }());
            ContentLibraryConstants.Api = Api;
        })(ContentLibraryConstants = common_module_ui.ContentLibraryConstants || (common_module_ui.ContentLibraryConstants = {}));
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



/**
 * Faults view constants.
 *
 * @name com.vmware.vsphere.client.cluster:drsFaultsViewConstants
 * @module com.vmware.vsphere.client.commonModule
 */
angular.module("com.vmware.vsphere.client.commonModule")
      .constant("drsFaultsViewConstants", {
   FIELD_KEY: "field",
   ICON_KEY: "icon",
   TARGET_KEY: "target",
   DETAILS_KEY: "details",
   REASON: "reason",
   LOCALIZED_REASON: "reasonLocalized",
   ICON_FIELD: "icon",
   ICON_TARGET_FIELD: "target.icon",
   TARGET_TEXT_FIELD: "target.text",
   REASON_ICON_CLASS: "reasonIconClass",
   PREVENTED_RECOMMENDATION: "preventedRecommendation",
   PREVENTED_RECOMMENDATION_ICON_CLASS: "preventedRecommendationIconClass",
   ID_KEY: "id",
   NAME_KEY: "name",
   TEXT_KEY: "text",
   DESCRIPTION_KEY: "description",
   HOST_NAME_KEY: "hostName",
   HOST_ICON_KEY: "hostIcon",
   VM_NAME_KEY: "vmName",
   VM_ICON_KEY: "vmIcon",
   DISK_NAME_KEY: "disk"
});

(function () {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:hostConnectionState
    *
    * @description
    *    Represents HostSystemConnectionState enum values.
    */
   angular
      .module('com.vmware.vsphere.client.commonModule')
      .constant('hostConnectionState', {
         CONNECTED: 'connected',
         DISCONNECTED: 'disconnected',
         NOT_RESPONDING: 'notResponding'
      });
})();

var h5_client;
(function (h5_client) {
    var ManagedEntityConstants = (function () {
        function ManagedEntityConstants() {
        }
        ManagedEntityConstants.ANY_COMPUTE_RESOURCE = "AnyComputeResource";
        ManagedEntityConstants.COMPUTE_RESOURCE = "ComputeResource";
        ManagedEntityConstants.CLUSTER = "ClusterComputeResource";
        ManagedEntityConstants.DATACENTER = "Datacenter";
        ManagedEntityConstants.DATASTORE = "Datastore";
        ManagedEntityConstants.FOLDER = "Folder";
        ManagedEntityConstants.HOST = "HostSystem";
        ManagedEntityConstants.HOST_PROFILE = "HostProfile";
        ManagedEntityConstants.RESOURCE_POOL = "ResourcePool";
        ManagedEntityConstants.STORAGE_POD = "StoragePod";
        ManagedEntityConstants.V_APP = "VirtualApp";
        ManagedEntityConstants.VIRTUAL_MACHINE = "VirtualMachine";
        ManagedEntityConstants.NETWORK = "Network";
        ManagedEntityConstants.DISTRIBUTED_VIRTUAL_PORTGROUP = "DistributedVirtualPortgroup";
        ManagedEntityConstants.OPAQUE_NETWORK = "OpaqueNetwork";
        ManagedEntityConstants.VM_TEMPLATE = "vm-template";
        return ManagedEntityConstants;
    }());
    h5_client.ManagedEntityConstants = ManagedEntityConstants;
    angular.module("com.vmware.vsphere.client.commonModule")
        .constant("managedEntityConstants", ManagedEntityConstants);
})(h5_client || (h5_client = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 *  Replaces all <input type="range"/> elements in storage-ui with ones,
 *  that return Numbers as their ng-model value, not strings
 */
(function() {
   angular.module('com.vmware.vsphere.client.commonModule').directive('rangeInput', function() {
      return {
         restrict: 'A',
         require: '?ngModel',
         scope: {
            ngModel: '='
         },
         link: function(scope, element, attrs, ngModel) {

            if ('type' in attrs && attrs.type.toLowerCase() === 'range') {
               ngModel.$parsers.push(Number);
               scope.$watch('ngModel', function(newValue) {
                  if (!newValue) {
                     newValue = 0;
                  }
                  element.val(newValue);
               });
            }
         }
      };
   });
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.commonModule')
      .service('advancedOptionsBuilderFactory', advancedOptionsBuilderFactory);

   advancedOptionsBuilderFactory.$inject = [];

   function advancedOptionsBuilderFactory() {

      /**
       * Gets advanced options builder object based on initial advanced options.
       *
       * @param initialOptions
       * @returns The constructed advanced options builder object
       */
      function getBuilder(initialOptions, isCluster) {
         var lastId = 0;
         initialOptions = initialOptions || [];

         var options = initialOptions.map(function(optionValue) {
            return {
               key: optionValue.key,
               value: optionValue.value,
               id: generateId()
            };
         });

         var optionsToRemove = [];
         var optionsById = [];
         options.forEach(function(option) {
            optionsById[option.id] = option;
         });

         /**
          * Returns the current advanced options.
          *
          * @returns the current advanced options
          */
         function getOptions() {
            return options;
         }

         function getOptionByKey(key) {
            return options.find(function (option) {
               return option.key === key;
            });
         }

         /**
          * Builds an array with advanced options to submit, adding the deleted
          * options and options with modified keys with null values in order to
          * be properly handled by the backend.
          *
          * @returns the advanced options to submit
          */
         function buildOptions() {
            var optionsResult = [];
            if(isCluster){
               optionsResult = angular.copy(initialOptions);
            }
            var advOptionsByKey = {};
            optionsResult.forEach(function(optionValue) {
               optionValue.value = null;
               advOptionsByKey[optionValue.key] = optionValue;
            });

            if(!isCluster) {
               _.each(optionsToRemove, function(option) {
                  optionsResult.push({
                     _type: "com.vmware.vim.binding.vim.storageDrs.OptionSpec",
                     option: {
                        _type: 'com.vmware.vim.binding.vim.option.OptionValue',
                        key: option.key,
                        value: option.value
                     },
                     operation: "remove",
                     removeKey: option.key
                  });
               });
            }

            options.forEach(function(optionValue) {
               if (!optionValue || !optionValue.key || !optionValue.value) {
                  return true;
               }
               if (advOptionsByKey[optionValue.key]) {
                  advOptionsByKey[optionValue.key].value = optionValue.value;
               } else {

                  if(isCluster){
                     optionsResult.push({
                        _type: 'com.vmware.vim.binding.vim.option.OptionValue',
                        key: optionValue.key,
                        value: optionValue.value
                     });
                  } else {
                     if(optionValue.type !== undefined) {
                        optionsResult.push({
                           _type: "com.vmware.vim.binding.vim.storageDrs.OptionSpec",
                           option: {
                              _type: 'com.vmware.vim.binding.vim.option.OptionValue',
                              key: optionValue.key,
                              value: optionValue.value
                           },
                           operation: optionValue.type
                        });
                     }
                  }

               }
            });
            return optionsResult;
         }

         /**
          * Adds a new advanced option.
          *
          * @param option to add
          */
         function addOption(option) {
            var newOptionId = generateId();
            var advancedOption = {
               key: option.key,
               value: option.value,
               id: newOptionId,
               type: "add"
            };
            optionsById[newOptionId] = advancedOption;
            options = options.concat([advancedOption]);

            return newOptionId;
         }

         /**
          * Updates advanced option by id.
          *
          * @param optionId
          * @param advancedOption option with new values
          */
         function updateOption(optionId, advancedOption) {
            var optionToUpdate = optionsById[optionId];

            if(isCluster) {
               optionToUpdate.key = advancedOption.key;
               optionToUpdate.value = advancedOption.value;
               optionToUpdate.type = "edit";
            } else {
               var optionToRemove;
               var optionExists = false;

               _.each(initialOptions, function(option,index) {
                  if(index + 1 === optionToUpdate.id && option.key === optionToUpdate.key) {
                     optionToRemove = {
                        key: option.key,
                        value: option.value,
                        type: "remove"
                     };
                     optionExists = true;
                  }
               });
               if (optionToUpdate.key === advancedOption.key && optionExists){
                  optionToUpdate.value = advancedOption.value;
                  optionToUpdate.type = "edit";
               } else {
                  if (optionExists) {
                     optionsToRemove.push(optionToRemove);
                  }

                  optionToUpdate.key = advancedOption.key;
                  optionToUpdate.value = advancedOption.value;
                  optionToUpdate.type = "add";
               }
            }
         }

         /**
          * Removes an advanced option by id.
          *
          * @param optionId
          */
         function removeOption(optionId) {
            var optionExists = false;
            if(optionsById[optionId] !== undefined ) {
               _.each(initialOptions, function(option, index) {
                  if (index + 1 === optionsById[optionId].id) {
                     optionExists = true;
                  }
               });
            }
            options = options.filter(function(option) {
               return option.id !== optionId;
            });
            if(optionExists) {
               optionsToRemove.push(optionsById[optionId]);
            }
            delete optionsById[optionId];
         }

         //generate autoincrement id-s
         function generateId() {
            return ++lastId;
         }

         return {
            getOptions: getOptions,
            getOptionByKey: getOptionByKey,
            buildOptions: buildOptions,
            addOption: addOption,
            updateOption: updateOption,
            removeOption: removeOption
         };
      }

      return {
         getBuilder: getBuilder
      };
   }
})();

var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var AngularInjector = (function () {
            function AngularInjector($injector) {
                this.$injector = $injector;
            }
            AngularInjector.prototype.get = function (serviceName) {
                return this.$injector.get(serviceName);
            };
            AngularInjector.$inject = ['$injector'];
            return AngularInjector;
        }());
        common_module_ui.AngularInjector = AngularInjector;
        angular.module('com.vmware.vsphere.client.commonModule').service('AngularInjector', AngularInjector);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   angular.module('com.vmware.vsphere.client.commonModule')
      .factory('associableObjectTypesService', associableObjectTypesService);

   function associableObjectTypesService() {
      var objectTypes = {
         get: get,
         getTypeDataForAttributes: getTypeDataForAttributes
      };

      return objectTypes;

      function get() {
         return {
            Folder: { displayName: 'folder', selection: true, associableType: 'Folder', associableTypeString: 'Folder' },
            Cluster: { displayName: 'cluster', selection: true, associableType: 'ClusterComputeResource', associableTypeString: 'ClusterComputeResource' },
            Datacenter: { displayName: 'datacenter', selection: true, associableType: 'Datacenter', associableTypeString: 'Datacenter' },
            Datastore: { displayName: 'datastore', selection: true, associableType: 'Datastore', associableTypeString: 'Datastore' },
            DatastoreCluster: { displayName: 'storagePod', selection: true, associableType: 'StoragePod', associableTypeString: 'StoragePod' },
            DistributedPortGroup: { displayName: 'dvpg', selection: true , associableType: 'DistributedVirtualPortgroup', associableTypeString: 'DistributedVirtualPortgroup' },
            DistributedSwitch: { displayName: 'dvs', selection: true , associableType: 'DistributedVirtualSwitch', associableTypeString: 'DistributedVirtualSwitch', associatedTypes: ['VmwareDistributedVirtualSwitch'] },
            Host: { displayName: 'host', selection: true, associableType: 'HostSystem', associableTypeString: 'HostSystem' },
            Library: { displayName: 'library', selection: true, associableType: 'com.vmware.content.Library', associableTypeString: 'Library' },
            LibraryItem: { displayName: 'libraryItem', selection: true, associableType: 'com.vmware.content.library.Item', associableTypeString: 'LibraryItem' },
            Network: { displayName: 'network', selection: true, associableType: 'HostNetwork', associableTypeString: 'HostNetwork', associatedTypes: ['Network', 'OpaqueNetwork'] },
            ResourcePool: { displayName: 'rp', selection: true, associableType: 'ResourcePool', associableTypeString: 'ResourcePool' },
            vApp: { displayName: 'vapp', selection: true, associableType: 'VirtualApp', associableTypeString: 'VirtualApp' },
            VirtualMachine: { displayName: 'vm', selection: true, associableType: 'VirtualMachine', associableTypeString: 'VirtualMachine' }         };
      }

      function getTypeDataForAttributes() {
         return {
            Folder: { displayName: 'folder', associableType: 'Folder', associableTypeString: 'Folder' },
            Cluster: { displayName: 'cluster', associableType: 'ClusterComputeResource', associableTypeString: 'ClusterComputeResource' },
            Datacenter: { displayName: 'datacenter', associableType: 'Datacenter', associableTypeString: 'Datacenter' },
            Datastore: { displayName: 'datastore', associableType: 'Datastore', associableTypeString: 'Datastore' },
            DatastoreCluster: { displayName: 'storagePod', associableType: 'StoragePod', associableTypeString: 'StoragePod' },
            DistributedPortGroup: { displayName: 'dvpg' , associableType: 'DistributedVirtualPortgroup', associableTypeString: 'DistributedVirtualPortgroup' },
            DistributedSwitch: { displayName: 'dvs' , associableType: 'DistributedVirtualSwitch', associableTypeString: 'DistributedVirtualSwitch'},
            Host: { displayName: 'host', associableType: 'HostSystem', associableTypeString: 'HostSystem' },
            Network: { displayName: 'network', associableType: 'HostNetwork', associableTypeString: 'Network'},
            OpaqueNetwork: { displayName: 'opaqueNetwork', associableType: 'OpaqueNetwork', associableTypeString: 'OpaqueNetwork'},
            ResourcePool: { displayName: 'rp', associableType: 'ResourcePool', associableTypeString: 'ResourcePool' },
            vApp: { displayName: 'vapp', associableType: 'VirtualApp', associableTypeString: 'VirtualApp' },
            VirtualMachine: { displayName: 'vm', associableType: 'VirtualMachine', associableTypeString: 'VirtualMachine' }
         };
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   /**
    * Provide information about the user agent (browser)
    */
   angular.module('com.vmware.vsphere.client.commonModule')
      .factory('browserService', browserService);

   browserService.$inject = ['$window', '$q'];

   function browserService($window, $q) {

      var _isWebkitDirectorySupported;
      var _arePopupsAllowed;

      var browserInfo = {
         name: getBrowserName(),
         version: getBrowserVersion(),
         isSafari: isSafari(),
         isEdge: isEdge(),
         isIe: isIe(),
         isFirefox: isFirefox,
         isWebkitDirectorySupported: isWebkitDirectorySupported,
         areBlockingPopupsAllowed: areBlockingPopupsAllowed
      };

      return browserInfo;

      function getBrowserName() {
         return $window.bowser.name;
      }

      function getBrowserVersion() {
         return $window.bowser.version;
      }

      function isSafari() {
         var is_safari = /^((?!chrome|android).)*safari/i.test($window.navigator.userAgent.toLowerCase());

         return is_safari;
      }

      function isChrome() {
         return $window.navigator.userAgent.toLowerCase().indexOf('chrome') >= 0 &&
               $window.navigator.vendor.toLowerCase().indexOf('google inc') >= 0;
      }

      function isEdge() {
         return $window.navigator.userAgent.toLowerCase().indexOf('edge') >= 0;
      }

      function isIe() {
         var userAgent = $window.navigator.userAgent.toLowerCase();
         var isIe10orBelow = userAgent.indexOf('msie') >= 0;
         var isIe11 = userAgent.indexOf('trident/7') >= 0;
         return isIe10orBelow || isIe11;
      }

      function isFirefox() {
         return $window.navigator.userAgent.toLowerCase().indexOf('firefox') >= 0;
      }

      function isWebkitDirectorySupported() {
         if (_isWebkitDirectorySupported !== undefined) {
            return _isWebkitDirectorySupported;
         }

         _isWebkitDirectorySupported = false;

         if (isEdge() || isChrome()) {
            _isWebkitDirectorySupported = true;
         }

         if (isFirefox()) {
            var version = parseInt(getBrowserVersion());
            if (version >= 50) {
               _isWebkitDirectorySupported = true;
            }
         }

         return _isWebkitDirectorySupported;
      }

      function areBlockingPopupsAllowed() {
         var deferred = $q.defer();
         if (_arePopupsAllowed) {
            deferred.resolve(_arePopupsAllowed);
         } else {
            var popup = $window.open();

            setTimeout(
                  function () {
                     _arePopupsAllowed = closePopup(popup);
                     deferred.resolve(_arePopupsAllowed);
                  },
                  100
            );
         }

         return deferred.promise;
      }

      function closePopup (popup) {
         if (!popup || popup.outerHeight === 0) {
            return false;
         } else {
            popup.close();
            return true;
         }
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CategoryActionService = (function () {
            function CategoryActionService(categoryService, clarityModalService, i18nService, $q, $rootScope) {
                this.categoryService = categoryService;
                this.clarityModalService = clarityModalService;
                this.i18nService = i18nService;
                this.$q = $q;
                this.$rootScope = $rootScope;
            }
            /**
             * Confirm and delete a category.
             */
            CategoryActionService.prototype.deleteCategory = function (categoryMoRef) {
                var self = this;
                this.categoryService.getCategoryDetails(categoryMoRef).then(function (response) {
                    var tagCount = response.childTags !== null ? response.childTags.length : 0;
                    var modalOptions = {
                        title: self.i18nService.getString('CommonModuleUi', 'categoryAction.remove.dialog.title'),
                        message: self.i18nService.getString('CommonModuleUi', 'categoryAction.remove.warning', response.name) + self.i18nService.getString('CommonModuleUi', 'categoryAction.remove.warning.tags', tagCount),
                        icon: 'vsphere-icon-status-warning',
                        submit: function () {
                            self.categoryService.deleteCategory(categoryMoRef)
                                .then(function () {
                                // deferred promise does not work with $http,
                                // so just using a broadcast.
                                self.$rootScope.$broadcast('refreshCategories');
                            });
                        },
                        preserveNewlines: true
                    };
                    self.clarityModalService.openConfirmationModal(modalOptions);
                });
            };
            CategoryActionService.prototype.addEditCategory = function (categories, categoryData) {
                var categoryState = {};
                var dialogTitle = this.i18nService.getString('CommonModuleUi', 'add.category');
                if (categoryData) {
                    var allSelected = categoryData.displayAssociableEntityTypesString === this.i18nService.getString('Common', 'tag.dashboard.categories.associable.all');
                    categoryState = {
                        allSelected: allSelected,
                        categoryMoRef: categoryData.managedObjectReference,
                        description: categoryData.categoryDescription,
                        displayAssociableEntityTypesString: categoryData.displayAssociableEntityTypesString,
                        multipleCardinality: categoryData.multipleCardinality,
                        name: categoryData.categoryName,
                        selectedAssociableEntityTypes: categoryData.associableEntityTypes
                    };
                    dialogTitle = this.i18nService.getString('CommonModuleUi', 'edit.category');
                }
                var actionEval = {
                    action: {
                        label: dialogTitle
                    }
                };
                var context = {
                    categories: categories,
                    categoryState: categoryState,
                    title: dialogTitle
                };
                this.clarityModalService.openModal(actionEval, null, context, 'common-module-ui/resources/common-module/views/categories/add-edit-category.html');
            };
            CategoryActionService.$inject = ['categoryService', 'clarityModalService', 'i18nService', '$q', '$rootScope'];
            return CategoryActionService;
        }());
        common_module_ui.CategoryActionService = CategoryActionService;
        angular.module('com.vmware.vsphere.client.commonModule').service('categoryActionService', CategoryActionService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



/* Copyright 2016-2017 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Category service
 */
(function () {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.commonModule')
      .service('categoryService', categoryService);

   categoryService.$inject = ['$http', 'dataService','defaultUriSchemeUtil'];

   var CATEGORIES_URL = 'tagging-ui/ctrl/categories';

   function categoryService($http, dataService, defaultUriSchemeUtil) {
      return {
         getAll: getAll,
         addCategory: addCategory,
         deleteCategory: deleteCategory,
         getCategoryDetails: getCategoryDetails,
         editCategory: editCategory
      };

      function getAll() {
         return $http.get(CATEGORIES_URL)
            .then(function(response) {
               return response.data;
            });
      }

      function addCategory(name, description, cardinality, associableEntityTypes) {
         var categorySpec = {
            categoryName: name,
            categoryDescription: description,
            multipleCardinality: cardinality,
            associableEntityTypes: associableEntityTypes
         };
         return $http.post(CATEGORIES_URL, categorySpec);
      }

      function deleteCategory(categoryMoRef) {
         return $http.delete(CATEGORIES_URL + "/" + categoryMoRef.value);
      }

      function getCategoryDetails(categoryMoRef) {
         return dataService.getProperties(defaultUriSchemeUtil.createVmomiUri(categoryMoRef.type,
               categoryMoRef.value,categoryMoRef.serverGuid), ['name','childTags']);
      }

      function editCategory(categoryMoRef, name, description, cardinality, associableEntityTypes) {
         var categorySpec = {
            categoryName: name,
            categoryDescription: description,
            multipleCardinality: cardinality,
            associableEntityTypes: associableEntityTypes
         };
         return $http.put(CATEGORIES_URL + "/" + categoryMoRef.value, categorySpec);
      }
   }
}());

var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        /**
         * Class to manage the session for vAPI endpoint
         */
        var VapiSessionService = (function () {
            function VapiSessionService($http, $q, $location, dataService) {
                var _this = this;
                this.$http = $http;
                this.$q = $q;
                this.$location = $location;
                this.dataService = dataService;
                this.PROP_REST_AUTH_TOKEN_TYPE = "urn:vri:vsphere:vSphereClientInstance:root";
                this.PROP_REST_AUTH_TOKEN = "vApiRestAuthToken";
                this.PROP_REST_ENDPOINT = "vApiRestEndpoint";
                this.HTTP_MIME_TYPE = "application/json";
                this.endpoint = null;
                /**
                 * Perform the login to vAPI service for the logged in client instance
                 * @returns Promise {any}
                 */
                this.login = function () {
                    if (_this.vmwareApiSessionId) {
                        return _this.$q.when({});
                    }
                    return _this.dataService.getProperties(_this.PROP_REST_AUTH_TOKEN_TYPE, [_this.PROP_REST_AUTH_TOKEN, _this.PROP_REST_ENDPOINT])
                        .then(function (data) {
                        if (_this.$location.host() === 'localhost') {
                            _this.setEndpoint(data.vApiRestEndpoint);
                        }
                        var headers = {
                            Authorization: "SIGN token = \"" + data.vApiRestAuthToken + "\""
                        };
                        headers["Accept"] = _this.HTTP_MIME_TYPE;
                        headers["Content-Type"] = _this.HTTP_MIME_TYPE;
                        headers["vmware-use-header-authn"] = "true";
                        return _this.$http({
                            method: "POST",
                            url: _this.getEndpoint() + ContentLibraryConstants.Api.VAPI_REST_SESSION,
                            headers: headers
                        });
                    }).then(function (response) {
                        if (response.data) {
                            _this.vmwareApiSessionId = response.data.value;
                        }
                    }, function (failure) {
                        delete _this.vmwareApiSessionId;
                    });
                };
            }
            /**
             * Perform logout from vAPI service
             */
            VapiSessionService.prototype.logout = function () {
                var _this = this;
                this.$http({
                    method: "DELETE",
                    url: this.getEndpoint() + ContentLibraryConstants.Api.VAPI_REST_SESSION,
                }).then(function () {
                    delete _this.vmwareApiSessionId;
                    return;
                }, function (failure) {
                    delete _this.vmwareApiSessionId;
                });
            };
            /**
             * checks if this vAPI session is still active.
             * not used currently.
             * @returns {PromiseLike<boolean>}
             */
            VapiSessionService.prototype.isVapiSessionAlive = function () {
                return this.$http({
                    method: "POST",
                    url: this.getEndpoint() + "/cis/session?~action=get",
                }).then(function () {
                    return true;
                }, function (exception) {
                    //console.log(exception);
                    return false;
                });
            };
            /**
             * checks if this session has been logged in/ready
             * @returns {boolean}
             */
            VapiSessionService.prototype.isSessionReady = function () {
                return !!this.vmwareApiSessionId;
            };
            /**
             * returns the vAPI endpoint for this client session
             * @returns {string}
             */
            VapiSessionService.prototype.getEndpoint = function () {
                return this.endpoint ?
                    this.endpoint :
                    ContentLibraryConstants.Api.SCHEME + this.$location.host() + ContentLibraryConstants.Api.VAPI_REST_BASE;
            };
            VapiSessionService.prototype.getVmwareApiSessionId = function () {
                return this.vmwareApiSessionId;
            };
            VapiSessionService.prototype.setEndpoint = function (endpoint) {
                this.endpoint = ContentLibraryConstants.Api.SCHEME +
                    this.parseHostName(endpoint) +
                    ContentLibraryConstants.Api.VAPI_REST_BASE;
            };
            VapiSessionService.prototype.parseHostName = function (url) {
                var l = document.createElement("a");
                l.href = url;
                return l.hostname;
            };
            VapiSessionService.prototype.removePort = function (url) {
                var scheme = ContentLibraryConstants.Api.SCHEME;
                var secondIndex = url.indexOf("/", scheme.length + 1);
                var firstIndex = url.indexOf(":", scheme.length + 1);
                return url.substring(0, firstIndex) + url.substring(secondIndex);
            };
            VapiSessionService.$inject = ["$http", "$q", "$location", "dataService"];
            return VapiSessionService;
        }());
        common_module_ui.VapiSessionService = VapiSessionService;
        angular.module("com.vmware.vsphere.client.commonModule").service("vapiSessionService", VapiSessionService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        /**
         * class to build the data to be passed on to vAPI REST endpoints for Add New Content Library.
         */
        var AddLibraryDataBuilder = (function () {
            function AddLibraryDataBuilder(defaultUriSchemeUtil) {
                var _this = this;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                /**
                 * the first method to call in the addLibraryDataBuilder method chain
                 * resets all data.
                 * @returns {h5_client.common_module_ui.AddLibraryDataBuilder}
                 */
                this.reset = function () {
                    _this.libraryData = null;
                    return _this;
                };
                /**
                 * set the data for a specific LibraryOperation.
                 * @param data
                 * @returns {h5_client.common_module_ui.AddLibraryDataBuilder}
                 */
                this.setData = function (data) {
                    _this.libraryData = data;
                    return _this;
                };
                /**
                 * finally build the model to be passed on to $http to invoke the vAPI call.
                 * last call in the method chain.
                 * @returns
                 * {
                 *    {
                 *       create_spec:
                 *       {
                 *          storage_backings:
                 *             {
                 *                datastore_id,
                 *                type: string
                 *             }[],
                 *             name,
                 *             type,
                 *             server_guid: (string|string),
                 *             version: string,
                 *             id: string,
                 *             description
                 *        }
                 *     }
                 * }
                 */
                this.buildModel = function () {
                    if (!_this.libraryData || !_this.libraryData.datastore) {
                        return {};
                    }
                    var json = {
                        create_spec: {
                            storage_backings: [{
                                    datastore_id: _this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(_this.libraryData.datastore.id).value,
                                    type: "DATASTORE"
                                }],
                            name: _this.libraryData.name,
                            type: _this.libraryData.type,
                            server_guid: _this.libraryData.vcService.serviceGuid,
                            version: "string",
                            id: "string",
                            description: _this.libraryData.description,
                        }
                    };
                    if (_this.libraryData.isPublished) {
                        _this.buildPublishInfo(_this.libraryData, json.create_spec);
                    }
                    if (_this.libraryData.type === ContentLibraryConstants.LIBRARYTYPE_SUBSCRIBED) {
                        var isSubscriptionAuthenticated = !!_this.libraryData.subscriptionPassword &&
                            _this.libraryData.subscriptionPassword.length > 0;
                        angular.extend(json.create_spec, { subscription_info: {
                                on_demand: _this.libraryData.syncStrategy !== ContentLibraryConstants.SYNC_STRATEGY_IMMEDIATE,
                                authentication_method: isSubscriptionAuthenticated ?
                                    ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_BASIC :
                                    ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_NONE,
                                ssl_thumbprint: _this.libraryData.sslThumbprint ? _this.libraryData.sslThumbprint : "",
                                automatic_sync_enabled: true,
                                user_name: isSubscriptionAuthenticated ?
                                    ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER :
                                    "",
                                subscription_url: _this.libraryData.subscriptionUrl
                            } });
                        if (isSubscriptionAuthenticated) {
                            angular.merge(json.create_spec, { subscription_info: {
                                    password: _this.libraryData.subscriptionPassword
                                } });
                        }
                    }
                    return json;
                };
                this.buildPublishInfo = function (libraryData, spec) {
                    var authMethod = ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_NONE;
                    if (libraryData.isAuthenticationEnabled) {
                        authMethod = ContentLibraryConstants.CREATE_LIBRARY_AUTHENTICATION_BASIC;
                    }
                    angular.extend(spec, { publish_info: {
                            persist_json_enabled: false,
                            authentication_method: authMethod,
                            publish_url: "",
                            current_password: "",
                            published: true,
                            password: libraryData.password,
                            user_name: libraryData.userName
                        } });
                    if (libraryData.isStreamingOptimized) {
                        angular.extend(spec, { optimization_info: {
                                optimize_remote_publishing: libraryData.isStreamingOptimized
                            } });
                    }
                };
            }
            AddLibraryDataBuilder.$inject = ['defaultUriSchemeUtil'];
            return AddLibraryDataBuilder;
        }());
        common_module_ui.AddLibraryDataBuilder = AddLibraryDataBuilder;
        angular.module('com.vmware.vsphere.client.commonModule').service('addLibraryDataBuilder', AddLibraryDataBuilder);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        var LibraryDataModel = (function () {
            function LibraryDataModel() {
                this.name = "";
                this.type = ContentLibraryConstants.LIBRARYTYPE_LOCAL;
                this.description = "";
                this.isPublished = false;
                this.isAuthenticationEnabled = false;
                this.userName = ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER;
                this.password = "";
                this.syncStrategy = ContentLibraryConstants.SYNC_STRATEGY_IMMEDIATE;
                this.subscriptionUrl = "";
                this.isSubscriptionAuthenticated = false;
                this.subscriptionPassword = "";
                this.sslThumbprint = "";
                this.vcService = {
                    name: ""
                };
                this.datastore = {
                    id: ""
                };
                //if this Library exists, its id
                this.id = "";
            }
            return LibraryDataModel;
        }());
        common_module_ui.LibraryDataModel = LibraryDataModel;
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var LibraryOperations = h5_client.common_module_ui.LibraryOperations;
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        /**
         * Class contains the method, the url and the data required for a $http request.
         */
        var RequestObject = (function () {
            function RequestObject() {
                this.method = RequestObject.HTTP_POST;
            }
            RequestObject.HTTP_GET = "GET";
            RequestObject.HTTP_POST = "POST";
            RequestObject.HTTP_DELETE = "DELETE";
            return RequestObject;
        }());
        common_module_ui.RequestObject = RequestObject;
        /*
         * Content library service based on vAPI REST endpoints.
         */
        var LibraryApiBuilderService = (function () {
            function LibraryApiBuilderService(addLibraryDataBuilder, defaultUriSchemeUtil) {
                var _this = this;
                this.addLibraryDataBuilder = addLibraryDataBuilder;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                /**
                 * set the base URL upon which extra redirect will be added
                 * @param url
                 * @returns {h5_client.common_module_ui.LibraryApiBuilderService}
                 */
                this.setBaseUrl = function (url) {
                    _this.baseUrl = url;
                    return _this;
                };
                /**
                 * Set the operation type
                 * @param opType : see LibraryOperations
                 * @returns {h5_client.common_module_ui.AddLibraryDataBuilder}
                 */
                this.setOperation = function (opType) {
                    _this.op = opType;
                    return _this;
                };
                /**
                 * Set the headers for the request
                 * @param headers : string[]
                 * @returns {h5_client.common_module_ui.AddLibraryDataBuilder}
                 */
                this.setHeaders = function (headers) {
                    _this.headers = headers;
                    return _this;
                };
                /**
                 * given the LibraryOperation type:  returns the request object to be used
                 * directly for a XHR http call.
                 * @param libraryData : based on LibraryOperations, this data will change
                 * @returns {RequestObject} : the object to be passed to $http
                 */
                this.buildApiRequest = function (libraryData) {
                    var requestObject = null;
                    if (!libraryData) {
                        return null;
                    }
                    switch (_this.op) {
                        case LibraryOperations.addLibrary:
                            requestObject = _this.getAddLibraryRequest(libraryData);
                            break;
                        case LibraryOperations.fetchLibrary:
                            requestObject = _this.getFetchLibraryRequest(libraryData);
                            break;
                        case LibraryOperations.deleteLibrary:
                            requestObject = _this.getDeleteLibraryRequest(libraryData);
                            break;
                        case LibraryOperations.updateLibrary:
                            break;
                        default:
                            throw Error("Library operation unsupported");
                    }
                    if (requestObject) {
                        requestObject.headers = _this.headers;
                    }
                    return requestObject;
                };
            }
            /**
             * reset all data before reuse
             */
            LibraryApiBuilderService.prototype.reset = function () {
                this.baseUrl = "";
                this.op = LibraryOperations.invalid;
                return this;
            };
            LibraryApiBuilderService.prototype.getAddLibraryRequest = function (libraryData) {
                var reqObj = new RequestObject();
                reqObj.data = this.addLibraryDataBuilder
                    .setData(libraryData)
                    .buildModel();
                var urlForAdd = libraryData.type === ContentLibraryConstants.LIBRARYTYPE_LOCAL ?
                    ContentLibraryConstants.Api.ADD_LIBRARY_LOCAL :
                    ContentLibraryConstants.Api.ADD_LIBRARY_SUBSCRIBED;
                reqObj.url = this.baseUrl + urlForAdd;
                return reqObj;
            };
            LibraryApiBuilderService.prototype.getFetchLibraryRequest = function (libraryData) {
                var reqObj = new RequestObject();
                var libraryId = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(libraryData.id).value;
                reqObj.url = this.baseUrl + ContentLibraryConstants.Api.FETCH_LIBRARY + libraryId;
                reqObj.method = RequestObject.HTTP_GET;
                reqObj.data = {};
                return reqObj;
            };
            LibraryApiBuilderService.prototype.getDeleteLibraryRequest = function (libraryData) {
                var reqObj = new RequestObject();
                var urlForDelete = libraryData.type === ContentLibraryConstants.LIBRARYTYPE_LOCAL ?
                    ContentLibraryConstants.Api.DELETE_LIBRARY_LOCAL :
                    ContentLibraryConstants.Api.DELETE_LIBRARY_SUBSCRIBED;
                reqObj.url = this.baseUrl + urlForDelete + libraryData.id;
                reqObj.method = RequestObject.HTTP_DELETE;
                return reqObj;
            };
            LibraryApiBuilderService.$inject = ['addLibraryDataBuilder', 'defaultUriSchemeUtil'];
            return LibraryApiBuilderService;
        }());
        common_module_ui.LibraryApiBuilderService = LibraryApiBuilderService;
        angular.module('com.vmware.vsphere.client.commonModule').service('libraryApiBuilderService', LibraryApiBuilderService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        /*
         * Content library service : using the Virgo mutation service.
         */
        var LibraryMutationService = (function () {
            function LibraryMutationService(mutationService, defaultUriSchemeUtil) {
                this.mutationService = mutationService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.DELETE_LIBRARY_SPEC = 'com.vmware.vsphere.client.library.specs.DeleteLibrarySpec';
                this.ADD_LIBRARY_SPEC = 'com.vmware.vsphere.client.library.CreateLibrarySpec';
                this.VALIDATE_LIBRARY_SPEC = 'com.vmware.vsphere.client.library.specs.SubscriptionUrlValidatorSpec';
                this.DUMMY_LIBRARY = 'urn:vapi:com.vmware.content.Library:dummy';
            }
            /**
             * Confirm and delete a library.
             */
            LibraryMutationService.prototype.deleteContentLibrary = function (libraryId) {
                return this.mutationService.remove(libraryId, this.DELETE_LIBRARY_SPEC, {});
            };
            LibraryMutationService.prototype.addContentLibrary = function (libraryData) {
                var librarySpec = {
                    name: libraryData.name,
                    description: libraryData.description,
                    vcServiceGuid: libraryData.vcService.serviceGuid,
                    type: libraryData.type,
                    subscriptionUrl: libraryData.subscriptionUrl,
                    datastoreRefs: [this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(libraryData.datastore.id)],
                    isAuthBasic: (!!libraryData.subscriptionPassword || !!libraryData.isAuthenticationEnabled),
                    isStreamOptimized: !!libraryData.isStreamingOptimized,
                    isExternallyPublished: !!libraryData.isPublished,
                    localPublishedUsername: !!libraryData.isPublished ? libraryData.userName : null,
                    localPublishedPassword: !!libraryData.isPublished ? libraryData.password : null,
                    sslThumbprint: libraryData.sslThumbprint ? libraryData.sslThumbprint : '',
                    subscribedUsername: this.getSubscriptionUsername(libraryData),
                    subscribedPassword: (libraryData.type === ContentLibraryConstants.LIBRARYTYPE_SUBSCRIBED) ? libraryData.subscriptionPassword : "",
                    storageFileSystemPath: null,
                    createLocalCopy: (libraryData.syncStrategy === ContentLibraryConstants.SYNC_STRATEGY_IMMEDIATE),
                    useFilesystem: false,
                    useDatastore: true
                };
                return this.mutationService.add(this.ADD_LIBRARY_SPEC, librarySpec, 'ADD');
            };
            LibraryMutationService.prototype.validateSubscription = function (libraryUrl, sslThumbprint, password) {
                var librarySpec = {
                    name: '',
                    subscriptionUrl: libraryUrl,
                    isAuthBasic: !!password,
                    sslThumbprint: sslThumbprint ? sslThumbprint : '',
                    username: ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER,
                    password: password
                };
                return this.mutationService.validate(this.DUMMY_LIBRARY, this.VALIDATE_LIBRARY_SPEC, librarySpec);
            };
            LibraryMutationService.prototype.isSubscriptionAuthenticated = function (libraryData) {
                return !!libraryData.subscriptionPassword && libraryData.subscriptionPassword.length > 0;
            };
            LibraryMutationService.prototype.getSubscriptionUsername = function (libraryData) {
                if (libraryData.type === ContentLibraryConstants.LIBRARYTYPE_SUBSCRIBED) {
                    return this.isSubscriptionAuthenticated(libraryData) ?
                        ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER : "";
                }
                else {
                    return "";
                }
            };
            LibraryMutationService.$inject = ['mutationService', 'defaultUriSchemeUtil'];
            return LibraryMutationService;
        }());
        common_module_ui.LibraryMutationService = LibraryMutationService;
        angular.module('com.vmware.vsphere.client.commonModule').service('libraryMutationService', LibraryMutationService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var LibraryOperations = h5_client.common_module_ui.LibraryOperations;
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        var LibraryDataModel = h5_client.common_module_ui.LibraryDataModel;
        /*
         * Content library service using vAPI endpoint invocation.
         */
        var LibraryVapiService = (function () {
            function LibraryVapiService(mutationService, vapiSessionService, libraryApiBuilderService, defaultUriSchemeUtil, $http, $location) {
                var _this = this;
                this.mutationService = mutationService;
                this.vapiSessionService = vapiSessionService;
                this.libraryApiBuilderService = libraryApiBuilderService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.$http = $http;
                this.$location = $location;
                this.VALIDATE_LIBRARY_SPEC = 'com.vmware.vsphere.client.library.specs.SubscriptionUrlValidatorSpec';
                this.DUMMY_LIBRARY = 'urn:vapi:com.vmware.content.Library:dummy';
                /**
                 * Given the libraryId, delete a Library.
                 * @param libraryId
                 */
                this.deleteContentLibrary = function (libraryId) {
                    _this.vapiSessionService.login().then(function () {
                        var endpoint = _this.vapiSessionService.getEndpoint();
                        var libraryData = new LibraryDataModel();
                        libraryData.id = libraryId;
                        var requestToFetch = _this.libraryApiBuilderService
                            .reset()
                            .setBaseUrl(endpoint)
                            .setOperation(LibraryOperations.fetchLibrary)
                            .buildApiRequest(libraryData);
                        _this.$http(requestToFetch)
                            .then(function (response) {
                            var requestToDelete = _this.libraryApiBuilderService
                                .reset()
                                .setBaseUrl(endpoint)
                                .setOperation(LibraryOperations.deleteLibrary)
                                .buildApiRequest(response.data.value);
                            return _this.$http(requestToDelete);
                        })
                            .then();
                    });
                };
            }
            /**
             * addContentLibrary using vAPI REST endpoints
             * @param libraryData
             */
            LibraryVapiService.prototype.addContentLibrary = function (libraryData) {
                var _this = this;
                this.vapiSessionService.login()
                    .then(function () {
                    var endpoint = _this.vapiSessionService.getEndpoint();
                    var request = _this.libraryApiBuilderService
                        .reset()
                        .setBaseUrl(endpoint)
                        .setOperation(LibraryOperations.addLibrary)
                        .setHeaders({ "vmware-api-session-id": _this.vapiSessionService.getVmwareApiSessionId() })
                        .buildApiRequest(libraryData);
                    return _this.$http(request);
                })
                    .then();
            };
            /**
             * Validate the SubscriptionUrl field for Subscribed Library
             * uses mutation service
             * @param libraryUrl
             * @returns {any}
             */
            LibraryVapiService.prototype.validateSubscription = function (libraryUrl, sslThumbprint, password) {
                var librarySpec = {
                    name: '',
                    subscriptionUrl: libraryUrl,
                    isAuthBasic: !!password,
                    sslThumbprint: sslThumbprint ? sslThumbprint : '',
                    username: ContentLibraryConstants.CREATE_LIBRARY_DEFAULT_USER,
                    password: password
                };
                return this.mutationService.validate(this.DUMMY_LIBRARY, this.VALIDATE_LIBRARY_SPEC, librarySpec);
            };
            LibraryVapiService.$inject = ['mutationService', 'vapiSessionService', 'libraryApiBuilderService', 'defaultUriSchemeUtil', '$http', '$location'];
            return LibraryVapiService;
        }());
        common_module_ui.LibraryVapiService = LibraryVapiService;
        angular.module('com.vmware.vsphere.client.commonModule').service('libraryVapiService', LibraryVapiService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        /*
         * Content library service proxy class. Switches to different implementation based on the feature switch
         * actual implementations are in libraryMutationService and libraryVapiService
         */
        var LibraryService = (function () {
            function LibraryService(libraryMutationService, libraryVapiService, featureFlagsService, defaultUriSchemeUtil, dataService) {
                this.libraryMutationService = libraryMutationService;
                this.libraryVapiService = libraryVapiService;
                this.featureFlagsService = featureFlagsService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.dataService = dataService;
                this.TARGET_LIBRARIES_PROP = "targetLibraries";
                this.FOLDER = "Folder";
                this.GROUPD1 = "group-d1";
            }
            LibraryService.prototype.usingVapiService = function () {
                // snanda: TODO: removing featureswitch - vAPI enabled on vmkernel-main by default
                // h5c-dev is still using old mutation based workflow
                // return this.featureFlagsService.h5uiCLSoverVAPIEnabled();
                return false;
            };
            LibraryService.prototype.init = function () {
                this.service = this.usingVapiService() ? this.libraryVapiService : this.libraryMutationService;
            };
            /**
             * Confirm and delete a Library.
             * Defaulting delete action through MutationService. Avoiding REST VAPI call.
             */
            LibraryService.prototype.deleteContentLibrary = function (libraryId) {
                this.init();
                return this.service.deleteContentLibrary(libraryId);
            };
            /**
             * Add a new ContentLibrary
             * @param libraryData : contains full model of the content library to add
             * @returns {any}
             */
            LibraryService.prototype.addContentLibrary = function (libraryData) {
                this.init();
                return this.service.addContentLibrary(libraryData);
            };
            /**
             * validate the library against
             * @param libraryUrl
             * @returns {any}
             */
            LibraryService.prototype.validateSubscription = function (libraryUrl, sslThumbprint, password) {
                this.init();
                return this.service.validateSubscription(libraryUrl, sslThumbprint, password);
            };
            /**
             * Get all library in vc
             * @param vc
             * @returns {any}
             */
            LibraryService.prototype.getAllContentLibraryInVc = function (vc) {
                var serverGuid = vc.serviceGuid;
                var rootFolder = this.defaultUriSchemeUtil.createVmomiUri(this.FOLDER, this.GROUPD1, serverGuid);
                return this.dataService.getProperties(rootFolder, [this.TARGET_LIBRARIES_PROP]);
            };
            LibraryService.$inject = ['libraryMutationService', 'libraryVapiService', 'featureFlagsService', 'defaultUriSchemeUtil', 'dataService'];
            return LibraryService;
        }());
        common_module_ui.LibraryService = LibraryService;
        angular.module('com.vmware.vsphere.client.commonModule').service('libraryService', LibraryService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CustomAttributesActionService = (function () {
            function CustomAttributesActionService(customAttributesService, clarityModalService, i18nService, $rootScope) {
                this.customAttributesService = customAttributesService;
                this.clarityModalService = clarityModalService;
                this.i18nService = i18nService;
                this.$rootScope = $rootScope;
            }
            CustomAttributesActionService.prototype.createCustomAttribute = function () {
                var self = this;
                var title = self.i18nService.getString('Common', 'editCustomFieldDefinitionView.add.title');
                self.openAddEditCustomAttributeModal(title, {});
            };
            CustomAttributesActionService.prototype.editCustomAttribute = function (customAttributeData) {
                var self = this;
                var title = self.i18nService.getString('Common', 'editCustomAttributesView.title');
                self.openAddEditCustomAttributeModal(title, customAttributeData);
            };
            CustomAttributesActionService.prototype.deleteCustomAttribute = function (customAttributeData) {
                var self = this;
                var modalOptions = {
                    title: self.i18nService.getString('Common', 'customFieldAction.delete.confirmation.title'),
                    message: self.i18nService.getString('Common', 'customFieldAction.delete.confirmation.message'),
                    icon: 'vsphere-icon-status-warning',
                    submit: function () {
                        self.customAttributesService.deleteCustomAttribute(customAttributeData)
                            .then(function () {
                            // deferred promise does not work with $http,
                            // so just using a broadcast.
                            self.$rootScope.$broadcast('refreshCustomAttributes');
                        });
                    },
                    preserveNewlines: true
                };
                self.clarityModalService.openConfirmationModal(modalOptions);
            };
            CustomAttributesActionService.prototype.openAddEditCustomAttributeModal = function (title, customAttributeData) {
                var actionEval = {
                    action: {
                        label: title
                    }
                };
                var context = {
                    customAttributeState: angular.copy(customAttributeData),
                    title: title
                };
                this.clarityModalService.openModal(actionEval, null, context, 'common-module-ui/resources/common-module/views/custom-attributes/add-edit-custom-attribute.html');
            };
            CustomAttributesActionService.$inject = ['customAttributesService', 'clarityModalService', 'i18nService', '$rootScope'];
            return CustomAttributesActionService;
        }());
        common_module_ui.CustomAttributesActionService = CustomAttributesActionService;
        angular.module('com.vmware.vsphere.client.commonModule').service('customAttributesActionService', CustomAttributesActionService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .factory('customAttributesService', customAttributesService);

   customAttributesService.$inject = [
      'dataService',
      'mutationService',
      'i18nService',
      'defaultUriSchemeUtil',
      'userSessionService'];

   function customAttributesService(
         dataService,
         mutationService,
         i18nService,
         defaultUriSchemeUtil,
         userSessionService) {
      return {
         getCustomAttributes: getCustomAttributes,
         modifyCustomAttributes: modifyCustomAttributes,
         getAllCustomAttributes: getAllCustomAttributes,
         deleteCustomAttribute: deleteCustomAttribute,
         renameCustomAttribute: renameCustomAttribute,
         addCustomAttribute: addCustomAttribute
      };


      function deleteCustomAttribute(item) {
         return userSessionService.getAllServersInfo().then(function(response) {
            var customAttribute = [{
               key: item.key,
               operationId: 'REMOVE'
            }];
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', response.serversInfo[0].serviceGuid);
            return modifyCustomAttributes(rootFolder, customAttribute);
         });
      }

      function addCustomAttribute(customAttribute, type) {
         return userSessionService.getAllServersInfo().then(function(response) {
            var customAttr = [{
               attribute: customAttribute.attribute,
               operationId: 'ADD',
               value: '',
               type: type.associableTypeString !== 'global' ? type.associableTypeString : null
            }];
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', response.serversInfo[0].serviceGuid);
            return modifyCustomAttributes(rootFolder, customAttr);
         });
      }

      function renameCustomAttribute(customAttribute) {
         return userSessionService.getAllServersInfo().then(function(response) {
            var customAttributeSpec = [{
               key: customAttribute.key,
               attribute: customAttribute.attribute,
               operationId: 'RENAME'
            }];
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', response.serversInfo[0].serviceGuid);
            return modifyCustomAttributes(rootFolder, customAttributeSpec);
         });
      }

      function getCustomAttributes(objectId) {
         return dataService.getProperties(objectId, ['availableField', 'customValue'], {
            queryName: getCustomAttributes.name + ":" + objectId
         }).then(function(response) {
               return _.map(response.availableField, function(availableField) {
                  var key = availableField.key;
                  var customValue = _.find(response.customValue, function(customValue) {
                        return customValue.key === key;
                     }) || {};
                  var  attributeType = availableField.managedObjectType ?
                        availableField.managedObjectType.wsdlName : "global";
                  var result = {
                     attribute: availableField.name,
                     value: customValue.value,
                     key: key,
                     type: attributeType,
                     typeLabel: formatAttributeType(attributeType)
                  };
                  return result;
            });
         });
      }

      function getAllCustomAttributes() {
         return userSessionService.getAllServersInfo().then(function(response) {
            var paramSpec = {
               propertyName: "customAttributeFields",
               parameter: 'anyObjectType',
               parameterType: 'java.lang.String'
            };
            var datacenterId = defaultUriSchemeUtil.getVsphereObjectId(response.serversInfo[0].serviceInstance);
            var properties = ['customAttributeFields'];
            return dataService.getProperties(datacenterId, properties, {
               propertyParams: [paramSpec],
               queryName: getAllCustomAttributes.name + ":" + datacenterId
            }).then(formatAllCustomAttributesList);
         });
      }

      function formatAllCustomAttributesList(response) {
         return response.customAttributeFields.map(function(customAttribute) {
            var attributeType = customAttribute.fieldDef.managedObjectType ? customAttribute.fieldDef.managedObjectType.wsdlName : 'global';
            return {
               attribute: customAttribute.fieldDef.name,
               type: attributeType,
               typeFormatted: formatAttributeType(attributeType),
               key: customAttribute.fieldDef.key
            };
         });
      }

      function modifyCustomAttributes(objectId, newAttributeValues) {
         var propertyObjectType = "com.vmware.vsphere.client.attribute.CustomFieldSpec";
         var propertySpecs = [];
         var managedObjectReference = defaultUriSchemeUtil.getManagedObjectReference(objectId);
         _.map(newAttributeValues, function(customAttribute) {
            var propertySpec = generatePropertySpec(managedObjectReference, customAttribute);
            propertySpecs.push(propertySpec);
         });
         return mutationService.applyMultiSpec(objectId, propertyObjectType, propertySpecs, "Modifying Custom Attributes");
      }

      function generatePropertySpec(managedObjectReference, customAttribute) {
         switch (customAttribute.operationId) {
            case 'ADD':
               return {
                  "name": customAttribute.attribute,
                  "owner": managedObjectReference,
                  "value": customAttribute.value,
                  "operationId": customAttribute.operationId,
                  "typeName": customAttribute.type !== 'global' ? customAttribute.type : null
               };
            case 'REMOVE':
               return {
                  "owner": managedObjectReference,
                  "operationId": customAttribute.operationId,
                  "key": customAttribute.key
               };
            default:
               return {
                  "name": customAttribute.attribute,
                  "owner": managedObjectReference,
                  "value": customAttribute.value,
                  "operationId": customAttribute.operationId,
                  "key": customAttribute.key
               };
         }
      }

      function formatAttributeType(attributeType) {
         return i18nService.getString('Common', 'fieldType.' + attributeType);
      }
   }
})();

var common_module_ui;
(function (common_module_ui) {
    var DrsFaultsViewService = (function () {
        function DrsFaultsViewService(vuiConstants, i18nService, drsFaultsViewConstants, defaultUriSchemeUtil, linksUtil) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.drsFaultsViewConstants = drsFaultsViewConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.linksUtil = linksUtil;
        }
        DrsFaultsViewService.prototype.getMasterViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getMasterColumnDefs(),
                height: "100%"
            };
        };
        DrsFaultsViewService.prototype.getDetailsViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getDetailsColumnDefs(),
                height: "100%"
            };
        };
        /**
         * Interpolates the template string with the target objects links.
         *
         * @param templateStr
         * @param targetObjects
         * @returns {*}
         */
        DrsFaultsViewService.prototype.interpolateWithLinks = function (templateStr, targetObjects) {
            var _this = this;
            var interpolations = [];
            targetObjects.forEach(function (targetObject) {
                var objectType = typeof targetObject;
                var text = "";
                if (objectType === "object") {
                    var id = _this.defaultUriSchemeUtil.getVsphereObjectId(targetObject[_this.drsFaultsViewConstants.ID_KEY]);
                    text = _this.linksUtil.generateObjectLink(id, targetObject[_this.drsFaultsViewConstants.NAME_KEY]);
                }
                else if (objectType === "string") {
                    text = targetObject;
                }
                interpolations.push(text);
            });
            return this.i18nService.interpolate(templateStr, interpolations);
        };
        DrsFaultsViewService.prototype.getMasterColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("Common", "drs.faultControl.reasonColumnHeaderLabel"),
                    field: this.drsFaultsViewConstants.LOCALIZED_REASON,
                    type: "string",
                    template: function (data) {
                        return _this.gridColumnTemplate(_this.drsFaultsViewConstants.LOCALIZED_REASON, _this.drsFaultsViewConstants.ICON_FIELD, data);
                    }
                },
                {
                    displayName: this.i18nService.getString("Common", "drs.faultControl.targetColumnHeaderLabel"),
                    field: this.drsFaultsViewConstants.TARGET_TEXT_FIELD,
                    type: "string",
                    template: function (data) {
                        return _this.gridColumnTemplate(_this.drsFaultsViewConstants.TARGET_TEXT_FIELD, _this.drsFaultsViewConstants.ICON_TARGET_FIELD, data);
                    }
                }
            ];
        };
        DrsFaultsViewService.prototype.getDetailsColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("Common", "drs.faultControl.details.faultColumnHeaderLabel"),
                    field: this.drsFaultsViewConstants.REASON,
                    type: "string",
                    template: function (data) {
                        return _this.gridColumnTemplate(_this.drsFaultsViewConstants.REASON, _this.drsFaultsViewConstants.REASON_ICON_CLASS, data);
                    }
                },
                {
                    displayName: this.i18nService.getString("Common", "drs.faultControl.details" +
                        ".preventedRecommendationColumnHeaderLabel"),
                    field: this.drsFaultsViewConstants.PREVENTED_RECOMMENDATION,
                    type: "string",
                    template: function (data) {
                        return _this.gridColumnTemplate(_this.drsFaultsViewConstants.PREVENTED_RECOMMENDATION, _this.drsFaultsViewConstants.PREVENTED_RECOMMENDATION_ICON_CLASS, data);
                    }
                }
            ];
        };
        DrsFaultsViewService.prototype.gridColumnTemplate = function (fieldValue, iconValue, data) {
            var props = {};
            props[this.drsFaultsViewConstants.FIELD_KEY] = fieldValue;
            props[this.drsFaultsViewConstants.ICON_KEY] = iconValue;
            return this.iconWithTextItemRenderer(props, data);
        };
        /**
         * Renders an icon along with text in a datagrid.
         *
         * @param props
         * @param data
         * @returns {string}
         */
        DrsFaultsViewService.prototype.iconWithTextItemRenderer = function (props, data) {
            var objData = data || {};
            objData.text = this.getNestedObjectProperty(data, props[this.drsFaultsViewConstants.FIELD_KEY]);
            objData.icon = this.getNestedObjectProperty(data, props[this.drsFaultsViewConstants.ICON_KEY]);
            var iconSpan = "<span class=\"" + objData.icon + "\"></span>";
            return [iconSpan, objData.text].join("");
        };
        /**
         * Returns the nested property of the object.
         *
         * @param object
         * @param property
         * @returns {*}
         */
        DrsFaultsViewService.prototype.getNestedObjectProperty = function (object, property) {
            var o = object;
            property.split(".").forEach(function (property) {
                o = o[property];
            });
            return o;
        };
        DrsFaultsViewService.$inject = ["vuiConstants", "i18nService",
            "drsFaultsViewConstants", "defaultUriSchemeUtil", "linksUtil"];
        return DrsFaultsViewService;
    }());
    common_module_ui.DrsFaultsViewService = DrsFaultsViewService;
    angular.module("com.vmware.vsphere.client.commonModule")
        .service("drsFaultsViewService", DrsFaultsViewService);
})(common_module_ui || (common_module_ui = {}));



var common_module_ui;
(function (common_module_ui) {
    var DrsRecommendationsService = (function () {
        function DrsRecommendationsService() {
        }
        DrsRecommendationsService.prototype.createRecommendationsStore = function (recommendationsData) {
            return new RecommendationsStore(recommendationsData);
        };
        return DrsRecommendationsService;
    }());
    common_module_ui.DrsRecommendationsService = DrsRecommendationsService;
    var RecommendationsStore = (function () {
        function RecommendationsStore(recommendations) {
            var _this = this;
            this.recommendations = recommendations;
            var selectableActions = recommendations.filter(function (item) {
                return item.isFirst;
            });
            this.selectableActionsByKey = _.indexBy(selectableActions, function (action) {
                return action.parentRecommendation.key;
            });
            this.checkedRecommendations = {};
            selectableActions.forEach(function (action) {
                _this.checkedRecommendations[action.parentRecommendation.key] = true;
            });
            this.selectableActionsCount = selectableActions.length;
        }
        RecommendationsStore.prototype.getRecommendationsToApply = function () {
            var _this = this;
            var checkedRecommendationKeys = [];
            this.recommendations.forEach(function (action) {
                if (action.isFirst === true) {
                    var recKey = action.parentRecommendation.key;
                    if (_this.checkedRecommendations[recKey] === true) {
                        checkedRecommendationKeys.push(recKey);
                    }
                }
            });
            // Remove prerequisite recommendations from the list
            var recommendationKeysToApply = checkedRecommendationKeys.slice();
            checkedRecommendationKeys.forEach(function (checkedKey) {
                var prerequisites = _this.selectableActionsByKey[checkedKey]
                    .prerequisiteRecommendations;
                recommendationKeysToApply = recommendationKeysToApply.filter(function (keyToApply) {
                    return prerequisites.indexOf(keyToApply) === -1;
                });
            });
            return recommendationKeysToApply;
        };
        RecommendationsStore.prototype.getCheckedRecommendationCount = function () {
            var checkedNumber = _.filter(this.checkedRecommendations, function (recommendation) {
                return recommendation === true;
            });
            return checkedNumber.length;
        };
        RecommendationsStore.prototype.getSelectableActionsCount = function () {
            return this.selectableActionsCount;
        };
        RecommendationsStore.prototype.isRecommendationChecked = function (key) {
            return this.checkedRecommendations[key] === true;
        };
        RecommendationsStore.prototype.uncheckRecommendation = function (key) {
            var _this = this;
            var shouldShowNotification = false;
            this.checkedRecommendations[key] = false;
            var action = this.selectableActionsByKey[key];
            action.dependantRecommendations.forEach(function (dependantKey) {
                if (_this.checkedRecommendations[dependantKey] === true) {
                    _this.checkedRecommendations[dependantKey] = false;
                    shouldShowNotification = true;
                }
            });
            return shouldShowNotification;
        };
        RecommendationsStore.prototype.checkRecommendation = function (key) {
            var _this = this;
            var shouldShowNotification = false;
            this.checkedRecommendations[key] = true;
            var action = this.selectableActionsByKey[key];
            action.prerequisiteRecommendations.forEach(function (prerequisiteKey) {
                if (_this.checkedRecommendations[prerequisiteKey] === false) {
                    _this.checkedRecommendations[prerequisiteKey] = true;
                    shouldShowNotification = true;
                }
            });
            return shouldShowNotification;
        };
        RecommendationsStore.prototype.getRecommendationKeys = function () {
            return this.recommendations.map(function (rec) { return rec.parentRecommendation.key; });
        };
        return RecommendationsStore;
    }());
    common_module_ui.RecommendationsStore = RecommendationsStore;
    angular.module("com.vmware.vsphere.client.commonModule")
        .service("drsRecommendationsService", DrsRecommendationsService);
})(common_module_ui || (common_module_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
         .service('iconService', iconService);

   function iconService() {
      var iconMap = {
         Datacenter: 'vsphere-icon-datacenter',
         ClusterComputeResource: 'vsphere-icon-cluster',
         HostSystem: 'vsphere-icon-host',
         Folder: 'vsphere-icon-folder',
         Datastore: 'vsphere-icon-datastore'
      };

      return {
         getByObjectRef: function(ref) {
            return iconMap[ref.type];
         },
         getByObjectType: function(type) {
            return iconMap[type];
         },
         /**
          *
          * Splits the icon id on colon - :
          * the first part is used as namespace i.e. indicator how the
          * icon should be rendered if custom rendering is needed
          *
          * the second part contains the name of the icon as string
          * @param iconId the id of the icon as it is defined in the plugin.xml
          * @returns {Array} containing 2 elements
          *    - the namespace(type) of the icon or undefined if there is no namespace(type)
          *    - the name of the icon
          */
         parseIcon: function parseIcon(iconId) {
            iconId = typeof iconId !== 'string'? '' : iconId;
            var parts =  iconId.split(':');
            if (parts.length === 1) {
               parts.unshift(undefined);
            }

            return parts;
         }
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

angular.module('com.vmware.vsphere.client.commonModule')
.service('managedEntityMutationService',
['mutationService', function(mutationService) {
   return {
      // operation parameter is optional, to be used in case of error notification
      rename: function(objectId, nameInfo, operation) {
         return mutationService.apply(objectId,
               'com.vmware.vsphere.client.mixed.ManagedEntityNameInfo', nameInfo, operation);
      }
   };
}]);
/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * Retrieves objects related to given objectId.
 * Used by related objects portlet in entity summary screen.
 */
angular.module('com.vmware.vsphere.client.commonModule').factory('relatedItemsService', ['$http',
   function ($http) {
      return {
         /**
          * Gets the related objects to given objectId.
          */
         getRelatedItems: function (objectId) {
            return $http({
               method: 'get',
               url: 'relateditems/simple/' + objectId
            }).then(function (resp) {
               return resp.data;
            });
         },

         /**
          * Gets the related items for the given <code>objectId</code> for
          * the given <code>relationId</code>.
          * @param objectId Unique relation id. e.g. vmsForHost
          * @param relationId Unique object id. e.g. urn:vmomi:HostSystem:ha-host:null
          * @param defaultProperties
          *    If true, only the default properties are fetched (like name, primaryIconId).
          *    If false, properties to be fetched are computed based on the relationId.
          * @returns {*}
          */
         getRelatedItemsByRelationId: function (objectId, relationId, defaultProperties) {
            return $http({
               method: 'get',
               url: 'relateditems/' + relationId + '/' + objectId + '?defaultProperties=' + defaultProperties
            }).then(function (resp) {
               return resp.data;
            });
         }
      };
   }]);
/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var TagActionService = (function () {
            function TagActionService(tagService, clarityModalService, i18nService, $rootScope) {
                var _this = this;
                this.tagService = tagService;
                this.clarityModalService = clarityModalService;
                this.i18nService = i18nService;
                this.$rootScope = $rootScope;
                this.i18n = function (key, data) { return _this.i18nService.getString("CommonModuleUi", key, data); };
            }
            /**
             * Confirm and delete a tag.
             */
            TagActionService.prototype.deleteTag = function (tagMoRef) {
                var _this = this;
                this.tagService.getEntityObjectsCount(tagMoRef).then(function (count) {
                    var modalMessage = _this.i18n('tagAction.remove.warning');
                    if (count) {
                        modalMessage = modalMessage + '\n' + _this.i18n('tagAction.remove.entity.count', count);
                    }
                    var modalOptions = {
                        title: _this.i18n('tagAction.remove.dialog.title'),
                        message: modalMessage,
                        icon: 'vsphere-icon-status-warning',
                        submit: function () {
                            _this.tagService.deleteTag(tagMoRef)
                                .then(function () {
                                // deferred promise does not work with $http,
                                // so just using a broadcast.
                                _this.$rootScope.$broadcast('refreshTagGrid');
                            });
                        },
                        preserveNewlines: true
                    };
                    _this.clarityModalService.openConfirmationModal(modalOptions);
                });
            };
            /**
             * Create/Edit a tag
             *
             * @param modifyTagData
             * @param tagId (Optional) Needed for edit
             */
            TagActionService.prototype.modifyTag = function (modifyTagData, tagId) {
                var dialogData = {
                    modifyTagData: modifyTagData,
                    categoryData: {}
                };
                var modalOptions = {
                    contentTemplate: "common-module-ui/resources/common-module/views/tags/modify-tag-dialog.html",
                    title: modifyTagData.mode === common_module_ui.ModifyTagMode.ADD ? this.i18n("tag.action.add") : this.i18n("tag.action.edit"),
                    defaultButton: "submit",
                    onSubmit: modifyTagData.mode === common_module_ui.ModifyTagMode.ADD
                        ? this.onTagAdd.bind(this, dialogData)
                        : this.onTagModify.bind(this, tagId, dialogData),
                    dialogData: dialogData,
                    submitDisabled: true
                };
                if (modifyTagData.mode === common_module_ui.ModifyTagMode.EDIT) {
                    modalOptions.subTitle = { text: angular.copy(modifyTagData.name) };
                }
                this.clarityModalService.openOkCancelModal(modalOptions);
            };
            TagActionService.prototype.onTagAdd = function (dialogData) {
                var _this = this;
                return this.tagService
                    .createTag(dialogData.modifyTagData.name, dialogData.modifyTagData.description, dialogData.categoryData.selectedCategory.managedObjectReference)
                    .then(function (response) {
                    _this.$rootScope.$broadcast("refreshTagGrid");
                    return response;
                });
            };
            TagActionService.prototype.onTagModify = function (tagId, dialogData) {
                var _this = this;
                return this.tagService
                    .editTag(tagId, dialogData.modifyTagData.name, dialogData.modifyTagData.description)
                    .then(function (response) {
                    _this.$rootScope.$broadcast("refreshTagGrid");
                    return response;
                });
            };
            TagActionService.$inject = ["tagService", "clarityModalService", "i18nService", "$rootScope"];
            return TagActionService;
        }());
        common_module_ui.TagActionService = TagActionService;
        angular.module("com.vmware.vsphere.client.commonModule").service("tagActionService", TagActionService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



/* Copyright 2016-2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Tag service
 */
(function () {
   'use strict';
   angular
   .module('com.vmware.vsphere.client.commonModule')
   .service('tagService', tagService);

   tagService.$inject = ['dataService', 'mutationService', 'defaultUriSchemeUtil', '$http'];

   function tagService(dataService, mutationService, defaultUriSchemeUtil, $http) {

      var MUTATION_TAG_DETACH_SPEC = 'com.vmware.vsphere.client.tagging.TagDetachSpec';
      var MUTATION_TAG_ATTACH_SPEC = 'com.vmware.vsphere.client.tagging.TagAttachSpec';
      var MUTATION_TAG_CREATE_SPEC = 'com.vmware.vsphere.client.tagging.TagCreateSpec';
      var TAGS_URL = 'tagging-ui/ctrl/tags';

      return {
         getTagInfoForObject: getTagInfoForObject,
         getAssignableTagsForObject: getAssignableTagsForObject,
         detachTag: detachTag,
         attachTag: attachTag,
         getAllTags: getAllTags,
         createTag: createTag,
         deleteTag: deleteTag,
         getEntityObjectsCount: getEntityObjectsCount,
         editTag: editTag
      };

      function formatTags(tagProperties) {
         var formattedTagsDictionary = {};

         _.each(tagProperties, function(value, object) {
            var objRef = defaultUriSchemeUtil.getPartsFromVsphereObjectId(object);
            formattedTagsDictionary[object] = angular.extend({resourceObject: objRef}, value);
         });
         return _.values(formattedTagsDictionary);
      }

      function getAllTags() {
         return $http.get(TAGS_URL).then(function(response) {
            return response.data;
         });
      }

      function getTagInfoForObject(objectId) {
         var relation = 'entity';
         var targetType = 'inventoryservice:InventoryServiceTag';
         var tagProperties = ['name', 'description', 'categoryName'];

         return dataService.getPropertiesByRelation(objectId, relation,
               targetType, tagProperties, { queryName: "getTagInfoForObject:" + objectId })
               .then(formatTags);
      }

      function getAssignableTagsForObject(objectId) {
         return dataService.getProperties(objectId, ['assignableTagsForTarget'],
               { queryName: "getAssignableTagsForObject:" + objectId });
      }

      function detachTag(tagObject, objectId) {
         // objectId can be a MoRef or a URI like Library
         var tagDetachSpec = {
            resources: [defaultUriSchemeUtil.getMoRefOrURIref(objectId)]
         };
        return mutationService.apply(defaultUriSchemeUtil.getVsphereObjectId(tagObject), MUTATION_TAG_DETACH_SPEC, tagDetachSpec);
      }

      function attachTag(tagObject, objectId) {
         // objectId can be a MoRef or a URI like Library
         var tagAttachSpec = {
            resources: [defaultUriSchemeUtil.getMoRefOrURIref(objectId)],
            ignoreAlreadyAttached: true
         };
         return mutationService.apply(defaultUriSchemeUtil.getVsphereObjectId(tagObject.resourceObject), MUTATION_TAG_ATTACH_SPEC, tagAttachSpec);

      }

      function createTag(tagName, tagDescription, categoryMoRef) {
         var tagSpec = {
            tagName: tagName,
            tagDescription: tagDescription,
            categoryMoRef: categoryMoRef
         };
         return mutationService.add(MUTATION_TAG_CREATE_SPEC, tagSpec);
      }

      function editTag(tagId, tagName, tagDescription) {
         var tagSpec = {
            tagName: tagName,
            tagDescription: tagDescription
         };
         return mutationService.apply(tagId, MUTATION_TAG_CREATE_SPEC, tagSpec);
      }

      function deleteTag(tagMoRef) {
         var tagId = defaultUriSchemeUtil.getVsphereObjectId(tagMoRef);
         return mutationService.remove(tagId, MUTATION_TAG_CREATE_SPEC, {});
      }

      function getEntityObjectsCount(tagMoRef) {
         var entityId = defaultUriSchemeUtil.createVmomiUri(tagMoRef.type, tagMoRef.value, tagMoRef.serverGuid);
         return dataService.getProperties(entityId, ["entityObjects"], { queryName: "getEntityObjectsCount:" + entityId })
            .then(function(response) {
            return response.entityObjects.totalMatchedObjectCount;
         });
      }
   }
}());

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    /**
     * Implements some stock expressions that can be used to construct more complex
     * validation expressions.
     */
    var DragAndDropStockExpressionsService = (function () {
        function DragAndDropStockExpressionsService(defaultUriSchemeUtil, managedEntityConstants) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.FAILED_STATUS = "__FAILED__";
            this.NOT_FOUND_STATUS = "__NOT_FOUND__";
            this.DC_FOLDER_VALUE = "group-d";
            this.HOST_FOLDER_VALUE = "group-h";
            this.VM_FOLDER_VALUE = "group-v";
        }
        DragAndDropStockExpressionsService.prototype.isTargetAccessible = function (dropTargetData) {
            // spriteCssClass comes form the data object maintained by the tree,
            // and primaryIconId comes from the data kept in the object navigator
            var objectIconId = dropTargetData.spriteCssClass ?
                dropTargetData.spriteCssClass : dropTargetData.primaryIconId;
            switch (objectIconId) {
                case "vsphere-icon-host-maintenance":
                case "vsphere-icon-host-disconnected":
                case "vsphere-icon-datastore-inaccessible":
                case "vsphere-icon-datastore-error":
                case "vsphere-icon-datastore-maintenance":
                    return false;
                default:
                    return true;
            }
        };
        DragAndDropStockExpressionsService.prototype.isVmFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            var folderType = folderRef.type;
            var folderValue = folderRef.value;
            return (folderType === this.managedEntityConstants.FOLDER &&
                folderValue.indexOf(this.VM_FOLDER_VALUE) !== -1);
        };
        DragAndDropStockExpressionsService.prototype.isDatacenterFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            var folderType = folderRef.type;
            var folderValue = folderRef.value;
            return (folderType === this.managedEntityConstants.FOLDER &&
                folderValue.indexOf(this.DC_FOLDER_VALUE) !== -1);
        };
        DragAndDropStockExpressionsService.prototype.isHostFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            var folderType = folderRef.type;
            var folderValue = folderRef.value;
            return (folderType === this.managedEntityConstants.FOLDER
                && folderValue.indexOf(this.HOST_FOLDER_VALUE) !== -1);
        };
        DragAndDropStockExpressionsService.prototype.isWithinSameDatacenter = function (dropTargetData, dragObjectsData) {
            var result = this.hasCommonParent(dropTargetData, dragObjectsData, "Datacenter");
            if (result === undefined) {
                return true;
            }
            return result;
        };
        DragAndDropStockExpressionsService.prototype.isVmFolderWithinSameDatacenter = function (dropTargetData, dragObjectsData) {
            if (!this.isVmFolder(dropTargetData.id)) {
                return false;
            }
            return this.isWithinSameDatacenter(dropTargetData, dragObjectsData);
        };
        /**
         * Checks if the direct parent of some of the drag objects is the drop target
         * or if the direct parent of the drop target is in the drag objects
         *
         * @param dropTargetData
         * @param dragObjectsData
         * @returns {boolean}
         */
        DragAndDropStockExpressionsService.prototype.hasDirectParent = function (dropTargetData, dragObjectsData) {
            var _this = this;
            if (!dropTargetData || !dragObjectsData) {
                return false;
            }
            var dragParentIds = _.map(dragObjectsData, function (dragObjectData) {
                return _this.getDirectParent(dragObjectData);
            });
            if (_.contains(dragParentIds, this.FAILED_STATUS)) {
                return false;
            }
            var targetIsParent = _.some(dragParentIds, function (dragParentId) {
                return dropTargetData.id === dragParentId;
            });
            var targetParentId = this.getDirectParent(dropTargetData);
            if (targetParentId === this.FAILED_STATUS) {
                return false;
            }
            var dragObjIsParent = _.some(dragObjectsData, function (dragObjectData) {
                return dragObjectData.id === targetParentId;
            });
            return targetIsParent || dragObjIsParent;
        };
        /**
         * Checks if all the drag objects and the drop target have common first parent
         * of the selected type
         *
         * @param dropTargetData
         * @param dragObjectsData
         * @param parentType
         * @returns {any}
         * returns true if parent is found
         * returns false if parent is not found but the whole chain is traversed
         * returns undefined if parent is not found but not the whole chain is traversed
         * due to some error
         */
        DragAndDropStockExpressionsService.prototype.hasCommonParent = function (dropTargetData, dragObjectsData, parentType) {
            var _this = this;
            var targetParentId = this.getFirstParentOfType(dropTargetData, parentType);
            switch (targetParentId) {
                case this.FAILED_STATUS:
                    return undefined;
                case this.NOT_FOUND_STATUS:
                    return false;
                default:
                    break;
            }
            var dragParentIds = _.map(dragObjectsData, function (dragObjectData) {
                return _this.getFirstParentOfType(dragObjectData, parentType);
            });
            if (_.contains(dragParentIds, this.FAILED_STATUS)) {
                return undefined;
            }
            var isSameParent = _.every(dragParentIds, function (dragParentId) {
                return dragParentId === targetParentId;
            });
            return isSameParent;
        };
        DragAndDropStockExpressionsService.prototype.isWithinSameClusterOrHost = function (dropTargetData, dragObjectsData) {
            var sameCluster = this.hasCommonParent(dropTargetData, dragObjectsData, "ClusterComputeResource");
            if (sameCluster) {
                return true;
            }
            var sameHost = this.hasCommonParent(dropTargetData, dragObjectsData, "HostSystem");
            if ((sameHost === undefined) || (sameCluster === undefined)) {
                return true;
            }
            return sameHost;
        };
        DragAndDropStockExpressionsService.prototype.isWithinSameStandaloneHost = function (dropTargetData, dragObjectsData) {
            if (!this.isStandaloneHost(dropTargetData)) {
                return false;
            }
            return this.isWithinSameClusterOrHost(dropTargetData, dragObjectsData);
        };
        DragAndDropStockExpressionsService.prototype.isInVmFolderWithinSameDatacenter = function (dropTargetData, dragObjectsData) {
            var _this = this;
            var dragParentIds = _.map(dragObjectsData, function (dragObjectData) {
                return _this.getDirectParent(dragObjectData);
            });
            // If dragged items are from outside of a tree, e.g. from a grid, they
            // do not possess parents so their status is failed. That's the only way
            // to detect if dragged objects are not from a tree.
            if (_.contains(dragParentIds, this.FAILED_STATUS)) {
                return true;
            }
            return this.hasCommonParent(dropTargetData, dragObjectsData, "Datacenter")
                && _.every(dragParentIds, function (dragParentId) {
                    return _this.isVmFolder(dragParentId);
                });
        };
        /**
         * Checks if the dropTarget is a standalone host or not
         *
         * @returns 'false' only if the parent hierarchy can be traversed and a cluster
         *    is found in it. Otherwise return true. That is - return 'false' only
         *    if we are certain it IS a part of a cluster. If we cannot decide -
         *    consider it standalone. The latter logic is applicable when the
         *    dropTargetData comes from the ObjectNavigator which does not provide
         *    hierarchical information.
         */
        DragAndDropStockExpressionsService.prototype.isStandaloneHost = function (dropTargetData) {
            var targetParentId = this.getFirstParentOfType(dropTargetData, "ClusterComputeResource");
            switch (targetParentId) {
                case this.FAILED_STATUS:
                    // Could not traverse the parent hierarchy.
                    // Consider this a standalone host.
                    return true;
                case this.NOT_FOUND_STATUS:
                    // No cluster parent - this is a standalone host for sure
                    return true;
                default:
                    // Must be a valid cluster id - so this is NOT a standalone host
                    return false;
            }
        };
        DragAndDropStockExpressionsService.prototype.getFirstParentOfType = function (targetData, parentType) {
            if (!targetData) {
                return this.FAILED_STATUS;
            }
            while (targetData) {
                var entityType = this.defaultUriSchemeUtil.getEntityType(targetData.id);
                if (!entityType) {
                    return this.FAILED_STATUS;
                }
                if (entityType === parentType) {
                    return targetData.id;
                }
                if (!targetData.parentNode) {
                    return this.FAILED_STATUS;
                }
                targetData = targetData.parentNode();
            }
            return this.NOT_FOUND_STATUS;
        };
        DragAndDropStockExpressionsService.prototype.getDirectParent = function (targetData) {
            if (!targetData || !targetData.parentNode) {
                return this.FAILED_STATUS;
            }
            var parent = targetData.parentNode();
            if (!parent || !parent.id) {
                return this.FAILED_STATUS;
            }
            return parent.id;
        };
        DragAndDropStockExpressionsService.$inject = [
            "defaultUriSchemeUtil",
            "managedEntityConstants"
        ];
        return DragAndDropStockExpressionsService;
    }());
    h5_client.DragAndDropStockExpressionsService = DragAndDropStockExpressionsService;
    angular.module("com.vmware.vsphere.client.commonModule")
        .service("dragAndDropStockExpressionsService", DragAndDropStockExpressionsService);
})(h5_client || (h5_client = {}));



(function () {
   'use strict';

   /**
    * Generates link based on given moId and text.
    */
   angular.module('com.vmware.vsphere.client.commonModule')
         .factory('linksUtil', linksUtil);

   function linksUtil() {

      return {
         generateObjectLink: generateObjectLink
      };

      /**
       * Given a moId it generates a link to that object which can be used for navigation.
       *
       * @param objectId
       * @param text
       * @returns {*}
       */
      function generateObjectLink(objectId, text) {
         var anchorCssClass = '';

         var extensionName = 'vsphere.core.inventory.serverObjectViewsExtension';
         var navParams = [
            '"' + extensionName + '"',
            '"' + objectId + '"'
         ];

         var textElement = $('<a/>')
               .addClass(anchorCssClass)
               .attr('ng-click', "$root._navigateToViewAndObject("
                     + navParams.join(', ') + ")")
               .attr('title', text)
               .text(text)
               [0].outerHTML;

         return '<div class="object object-link">' + textElement + '</div>';
      }
   }
})();

var common_module_ui;
(function (common_module_ui) {
    var UnitFormatterService = (function () {
        function UnitFormatterService() {
            this.UNIT_STEP = 1024;
        }
        /**
         * Convert the given size (in Kilobytes) to Megabytes
         *
         * @param size
         *          Size in Kilobytes
         @param round (Optional)
         *          Decimal places
         * @returns {number}
         *          Size in Megabytes
         */
        UnitFormatterService.prototype.toMegabytes = function (size, round) {
            var convertedSize = size / this.UNIT_STEP;
            return round ? this.roundNumber(convertedSize, round) : convertedSize;
        };
        /**
         * Convert the given size in Megabytes to Kilobytes
         *
         * @param size
         *          Size in Megabytes
         * @returns {number}
         *          Size in Kilobytes
         */
        UnitFormatterService.prototype.fromMegabytes = function (size) {
            return size * this.UNIT_STEP;
        };
        /**
         * Convert the given size (in Kilobytes) to Gigabytes
         *
         * @param size
         *          Size in Kilobytes
         * @param round (Optional)
         *          Decimal places
         * @returns {number}
         *          Size in Gigabytes
         */
        UnitFormatterService.prototype.toGigabytes = function (size, round) {
            var convertedSize = this.toMegabytes(size) / this.UNIT_STEP;
            return round ? this.roundNumber(convertedSize, round) : convertedSize;
        };
        /**
         * Round the given number to the decimals provided
         * E.g.: roundNumber(17.1234, 2) => 17.12
         *
         * @param value
         * @param decimals
         * @returns {number}
         */
        UnitFormatterService.prototype.roundNumber = function (value, decimals) {
            return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
        };
        return UnitFormatterService;
    }());
    common_module_ui.UnitFormatterService = UnitFormatterService;
    angular.module("com.vmware.vsphere.client.commonModule")
        .service("unitFormatterService", UnitFormatterService);
})(common_module_ui || (common_module_ui = {}));



angular.module('com.vmware.vsphere.client.commonModule').service('wizardPageService', ['vuiConstants',
   function (vuiConstants) {
      return {
         clearErrors: function(config) {
            config.validationBanner.messages = [];
         },
         showLoadingIndicator: function(config){
            config.loading = true;
         },
         hideLoadingIndicator: function(config){
            config.loading = false;
         },
         markPageComplete: function (config, flowId) {
            config.currentPage.state = vuiConstants.wizard.pageState.COMPLETED;

            var nextPage;
            if (flowId && config.flows) {
               var pageIsBranchingPage = _.any(config.pages, function (page) {
                  return page.title === config.currentPage.title;
               });

               if (pageIsBranchingPage) {
                  // If we haven't branched into flows yet, the current page should be in config.pages
                  // In that case, the 'next page' is the first page in the correct flow
                  nextPage = findFlowById(config, flowId).pages[0];
               } else {
                  // Otherwise, we should be able to find the page in one of the flows,
                  // in which case the next page is the next index in that flow array.
                  // Consider also pages that are part of the selected flow in case some
                  // of the pages of the current flow has a decision option
                  var pages = getPages(config, flowId);
                  nextPage = findPageThatFollows(pages, config.currentPage.title);
               }

               if (nextPage && nextPage.state === vuiConstants.wizard.pageState.DISABLED) {
                  nextPage.state = vuiConstants.wizard.pageState.INCOMPLETE;
               }
            } else {
               nextPage = findPageThatFollows(config.pages, config.currentPage.title);
               if (nextPage && nextPage.state !== vuiConstants.wizard.pageState.COMPLETED) {
                  nextPage.state = vuiConstants.wizard.pageState.INCOMPLETE;
               }
            }
         },
         markPageIncompleteWithError: function (config, message) {
            config.currentPage.state = vuiConstants.wizard.pageState.INCOMPLETE;
            config.validationBanner.messages = [{
               text: message,
               type: vuiConstants.validationBanner.type.ERROR
            }];
         },
         markPageIncompleteWithErrors: function (config, messages) {
            config.currentPage.state = vuiConstants.wizard.pageState.INCOMPLETE;
            config.validationBanner.messages = _.map(messages, function (message) {
               return {
                  text: message,
                  type: vuiConstants.validationBanner.type.ERROR
               };
            });
         },
         invalidateNextPages: function (config, flowId, currentPageTitle) {
            var pages;
            if (config.flows && config.flows.length > 0) {
               pages = getPages(config, flowId);
            } else {
               pages = config.pages;
            }

            var currentPageIdx = _.findIndex(pages, function (page) {
               return page.title === currentPageTitle;
            });

            if (currentPageIdx === -1) {
               throw new Error('Cannot find page index');
            }

            _.each(pages, function (page, i) {
               if (i > currentPageIdx) {
                  if(page.state !== vuiConstants.wizard.pageState.SKIPPED){
                     page.state = vuiConstants.wizard.pageState.DISABLED;
                  }
               }
            });
         },
         initializePageStates: function (pages) {
            var newPages = _.map(pages, function (page) {
               page.state = page.defaultState || vuiConstants.wizard.pageState.DISABLED;
               return page;
            });
            newPages[0].state = vuiConstants.wizard.pageState.INCOMPLETE;
            return newPages;
         },
         initializeFlowStates: function (flows) {
            return _.map(flows, function (flow) {
               flow.pages = _.map(flow.pages, function (page) {
                  page.state = page.defaultState || vuiConstants.wizard.pageState.DISABLED;
                  return page;
               });
               return flow;
            });
         },
         markPageSkipped: function(pages, pageTitle) {
            findPageByTitle(pages, pageTitle).state = vuiConstants.wizard.pageState.SKIPPED;
         },
         markPageDisabled: function(pages, pageTitle) {
            findPageByTitle(pages, pageTitle).state = vuiConstants.wizard.pageState.DISABLED;
         },
         showWarningMessages: function (config, messages) {
            config.validationBanner.messages = _.map(messages, function (message) {
               return {
                  text: message,
                  type: vuiConstants.validationBanner.type.WARNING
               };
            });
         }
      };

      function findPageByTitle(pages, pageTitle) {
         return _.find(pages, function(page) {
            return page.title === pageTitle;
         });
      }

      function findFlowById(config, flowId) {
         var flow = _.find(config.flows, function (flow) {
            return flow.id === flowId;
         });
         if (!flow) {
            throw new Error('Could not find a valid flow with ID: ' + flowId);
         }
         return flow;
      }

      function findPageThatFollows(pages, currentPageTitle) {
         var currentPageIdx = _.findIndex(pages, function (page) {
            return page.title === currentPageTitle;
         });

         if (currentPageIdx === -1) {
            throw new Error('Cannot find page index');
         }

         var nextUnskippedPage = _.find(pages.slice(currentPageIdx + 1), function(page){
            return page.state !== vuiConstants.wizard.pageState.SKIPPED;
         });

         return nextUnskippedPage;
      }

      function getPages(config, flowId) {
         var wizardPages = [];
         var flow = findFlowById(config, flowId);
         if (!flow || !flow.pages || flow.pages.length === 0) {
            return wizardPages;
         }

         var flowPages = flow.pages;
         for (var  i = 0; i < flowPages.length; i++) {
            wizardPages.push(flowPages[i]);
            // Decision Page
            var subFlowId;
            if (flowPages[i].hasOwnProperty('decisionOptions')) {
               var decisionPage = flowPages[i].decisionOptions;
               if (decisionPage.hasOwnProperty('selectedFlowId')) {
                  subFlowId = decisionPage.selectedFlowId;
               } else {
                  subFlowId = decisionPage.flowIds[0];
               }

               var subFlowPages = getPages(config, subFlowId);
               wizardPages = wizardPages.concat(subFlowPages);
            }
         }
         return wizardPages;
      }
   }
]);

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.commonModule')
      .controller('AboutVsphereController', AboutVsphereController);

   AboutVsphereController.$inject = ['$scope', '$sce', 'i18nService'];

   function AboutVsphereController($scope, $sce, i18nService) {
      var i18n = i18nService.getString;
      $scope.contentPatent = $sce.trustAsHtml(
            i18n('CommonUi', 'about.vsphere.content.patent',
            i18n('CommonUi', 'about.content.content.patentUrl')));
   }

})();

(function () {
   /**
    * Directive for HA and DRS advanced options grid.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .directive('advancedOptions', advancedOptions);

   advancedOptions.$inject = ['i18nService', 'vuiConstants'];

   function advancedOptions(i18nService, vuiConstants) {
      return {
         restrict: 'E',
         templateUrl: 'common-module-ui/resources/common-module/views/advanced-options/advancedOptions.html',
         scope: {
            items: '=',
            builder: '=',
            editable: '@',
            accessibility: '@?'
         },
         controller: ['$scope', '$element', function($scope, $element) {
            //grid toolbar actions
            var addAction = {
               id: 'advancedOptionsGridAddButton',
               label: getString('config.advancedOptions.button.add'),
               enabled: true,
               iconClass: 'vui-icon-action-add',
               onClick: addRow
            };

            var removeAction = {
               id: 'advancedOptionsGridRemoveButton',
               label: getString('config.advancedOptions.button.delete'),
               enabled: true,
               iconClass: 'vui-icon-action-delete',
               onClick: removeRow
            };
            $scope.gridOptions = getGridOptions($scope.editable);

            //region Event handlers

            if ($scope.editable) {
               // enable/disable delete button based on selection
               $scope.$watch('gridOptions.selectedItems', function(selectedItems) {
                  removeAction.enabled = selectedItems.length !== 0;
               });

               // listener for scope builder items changed event in order to get the items
               $scope.$watch('builder.getOptions()', function(items) {
                  var advOptions = !!items ? items : [];
                  $scope.gridOptions.data = advOptions;
               });
            } else {
               // listener for scope.items changed event in order to get the items
               $scope.$watch('items', function(items) {
                  var advOptions = !!items ? items : [];
                  $scope.gridOptions.data = advOptions;
               });
            }

            //endregion

            //region Advanced options grid functions

            function getGridOptions(editable) {

               // grid height for five rows including header and footer
               var gridHeight = 252;
               // add toolbar height to total grid height
               if (editable) {
                  gridHeight += 33;
               }

               var options  = {
                  selectionMode: vuiConstants.grid.selectionMode.SINGLE,
                  sortMode: vuiConstants.grid.sortMode.SINGLE,
                  searchable: false,
                  resizable: true,
                  selectedItems: [],
                  data: [],
                  columnDefs: getColumnDefs(),
                  height: gridHeight + 'px'
               };

               // editable grid options
               if (editable) {
                  angular.extend(options, {
                     editable: {
                        mode: 'incell',
                        createAt: 'bottom'
                     },
                     actionBarOptions: {
                        actions: [
                           addAction,
                           removeAction
                        ]
                     },
                     // handler for grid save
                     save: function(event) {
                        var optionData = {
                           key: event.model.key,
                           value: event.model.value
                        };
                        angular.extend(optionData, event.values);

                        if (angular.isDefined(event.model.id)) {
                           $scope.builder.updateOption(event.model.id, optionData);
                        } else {
                           event.model.id = $scope.builder.addOption(optionData);
                        }
                     }
                  });
               }

               return options;
            }

            function getColumnDefs() {
               return [
                  {
                     displayName: getString('config.advancedOptions.optionColumnHeaderLabel'),
                     field: 'key',
                     type: 'string'
                  },
                  {
                     displayName: getString('config.advancedOptions.valueColumnHeaderLabel'),
                     field: 'value',
                     type: 'string'
                  }
               ];
            }

            function addRow() {
               $element.find('[kendo-grid]').data('kendoGrid').addRow();
            }

            function removeRow() {
               var selectedItems = $scope.gridOptions.selectedItems;

               if (selectedItems.length !== 0) {
                  selectedItems.forEach(function(item) {
                     $scope.builder.removeOption(item.id);
                  });
               }
            }

            //endregion

            //region Helper functions

            function getString(key) {
               return i18nService.getString('ClusterUi', key);
            }

            //endregion
         }]
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Controller for alarm definitions (VM(other type) > Manage > Alarm Definitions).
 */
(function() {
   'use strict';
    angular.module('com.vmware.vsphere.client.commonModule')
           .controller('AlarmDefinitionsController', AlarmDefinitionsController);
    angular.module('com.vmware.vsphere.client.commonModule').filter('trusted', ['$sce', function($sce) {
       return function(text) { return $sce.trustAsHtml(text); };
    }]);
    AlarmDefinitionsController.$inject = ['$scope', 'vuiConstants', 'dataService', 'mutationService',
                                          'i18nService', 'defaultUriSchemeUtil', 'clarityModalService'];

    function AlarmDefinitionsController($scope, vuiConstants, dataService, mutationService,
            i18nService, defaultUriSchemeUtil, clarityModalService) {
       var self = this;
       self.bundle = 'AlarmsUi';

       var REMOVE_ALARM_SPEC = 'com.vmware.opsmgmt.client.alarms.RemoveAlarmDefinitionSpec';

       var nameColumn = i18nService.getString(self.bundle, 'alarmsDefTabView.tableHeaderText.name');
       var definedInColumn = i18nService.getString(self.bundle, 'alarmsDefTabView.tableHeaderText.definedIn');

       /**
        * Open Delete Confirmation Modal
        */
       self.openDeleteModal = function () {
          var modalOptions = {
             title: i18nService.getString('AlarmsUi', 'alarmSettingsWizard.confirm.removeAlarmDefinition.shorttitle'),
             message: i18nService.getString('AlarmsUi', 'alarmSettingsWizard.confirm.removeAlarmDefinition.message', self.selectedItem.alarmInfo.name),
             icon: 'vsphere-icon-status-warning',
             submit: self.deleteAlarm
          };

          clarityModalService.openConfirmationModal(modalOptions);
       };

       var deleteAction = {
          id: 'delete-alarm-action',
          iconClass: 'vsphere-icon-toolbar-remove',
          enabled: false,
          tooltipText: i18nService.getString('AlarmsUi', 'alarmAction.remove.description'),
          onClick: self.openDeleteModal
       };

       self.dataGridOptions = {
          actionBarOptions: {
             actions: [
                deleteAction
             ]
          },
          columnDefs: [
             { displayName: nameColumn, field: 'alarmInfo.name', width: '150px'},
             { displayName: definedInColumn, field: 'definedInName', width: '150px'}
          ],
          sortMode: vuiConstants.grid.sortMode.SINGLE,
          selectionMode: vuiConstants.grid.selectionMode.SINGLE,
          selectedItems: [],
          data: [],
          height: '100%',
          resizable: true
       };
       self.splitterOptions = {
          orientation: vuiConstants.splitter.orientation.VERTICAL,
          panes: [{
             min: '140px'
          }, {
             min: '100px'
          }]
       };

       /*
        * Detects click events of the vui-datagrid.
        */
       $scope.$watch('c.dataGridOptions.selectedItems', function(selectedItems) {
          if (selectedItems.length > 0) {
             self.selectedItem = selectedItems[0];
             self.stackViewOptions = {
                header: { title: self.selectedItem.alarmInfo.name }
             };
             self.triggersTitle = computeTriggersTitle();
             deleteAction.enabled = isDeleteActionAvailable();
             getAlarmDetails();
          } else {
             deleteAction.enabled = false;
             self.selectedItem = null;
          }
       });

       /*
        * Fetches the data for the Alarm Definitions (vui-datagrid).
        */
       self.refreshAlarmsGrid = function () {
          return dataService.getProperties($scope._route.objectId, "alarmDefinitions").then(function(res) {
             self.dataGridOptions.data = res.alarmDefinitions;
          });
       };

       function getAlarmDetails() {
          self.alarmDetails = null;
          var objectId = defaultUriSchemeUtil.getVsphereObjectId(self.selectedItem.alarmState.alarm);
          dataService.getProperties(objectId, "alarmDetails").then(function (res) {
             self.alarmDetails = res.alarmDetails || undefined;
          });
       }

       self.getStatusImage = function(status) {
          var imageClass;
          switch (status) {
             case 'statusGreen':
                imageClass = "vsphere-icon-status-ok";
                break;
             case 'statusYellow':
                imageClass = "vsphere-icon-status-warning";
                break;
             case 'statusRed':
                imageClass = "vsphere-icon-status-error";
                break;
             case 'statusUnknown':
                imageClass = "vsphere-icon-status-unknown";
                break;
          }
          return imageClass;
       };

       /*
        * Localize the title text for the triggers stack block.
        */
       function computeTriggersTitle() {
          if (!self.selectedItem) {
             return;
          }
          var exp = self.selectedItem.alarmInfo.expression;
          if (!exp) {
             return;
          }
          var orExpType = 'com.vmware.vim.binding.vim.alarm.OrAlarmExpression';
          var pred = (exp._type === orExpType) ? 'triggers.any' : 'triggers.all';
          var predicate = i18nService.getString(self.bundle, pred);
          return i18nService.getString(self.bundle, 'triggersBlock.lblAllAny.states', [predicate]);
       }

       /**
        * Check whether the delete action is enabled or not based on the level of the object
        *
        * @returns {boolean}
        */
       function isDeleteActionAvailable() {
          var entityServerGuid = self.selectedItem.alarmInfo.entity.serverGuid;
          var entityType = self.selectedItem.alarmInfo.entity.type;
          var entityValue = self.selectedItem.alarmInfo.entity.value;
          var alarmObjectId = defaultUriSchemeUtil.createVmomiUri(entityType, entityValue, entityServerGuid);

          return alarmObjectId === $scope._route.objectId;
       }

       /**
        * Delete the alarm definition
        */
       self.deleteAlarm = function () {
          var objectId = defaultUriSchemeUtil.getVsphereObjectId(self.selectedItem.alarmState.alarm);
          return mutationService.remove(objectId, REMOVE_ALARM_SPEC, {}).then(function () {
             self.refreshAlarmsGrid();
          });
       };

       self.refreshAlarmsGrid();
    }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('addEditCategoryController', AddEditCategoryController);

   AddEditCategoryController.$inject = ['categoryService', 'i18nService', '$scope', 'associableObjectTypesService', '$rootScope', '$q'];

   function AddEditCategoryController (categoryService, i18nService, $scope, associableObjectTypesService, $rootScope, $q) {
      var self = this;

      var categoryState = $scope.modalOptions.dialogData.categoryState;
      var selectedObjectTypes = categoryState.selectedAssociableEntityTypes;
      self.associableObjectTypes = associableObjectTypesService.get();
      self.multipleCardinality = categoryState.multipleCardinality + "" === 'true' ? 'multiple' : 'single';
      self.description = categoryState.description || '';
      self.name = categoryState.name || '';
      if (typeof categoryState.allSelected !== 'undefined') {
        self.disableInputs = selectedObjectTypes && Object.keys(self.associableObjectTypes).every(isObjectTypeSelected);
        self.allCheckbox = self.allCheckbox || !selectedObjectTypes || self.disableInputs;
          if (self.multipleCardinality === 'multiple') {
              self.isCardinalityDisabled = true;
          }
      } else {
          self.allCheckbox = true;
      }
      if (selectedObjectTypes) {
         Object.keys(self.associableObjectTypes).forEach(function(key) {
            if (selectedObjectTypes.indexOf(self.associableObjectTypes[key].associableTypeString) !== -1) {
               self.associableObjectTypes[key].selection = true;
               self.associableObjectTypes[key].disabled = true;
            } else {
               self.associableObjectTypes[key].selection = self.allCheckbox;  // if allCheckbox is checked, initialize to true
               self.associableObjectTypes[key].disabled = self.allCheckbox;
            }
         });
      }

      self.toggleAllTypes = toggleAllTypes;
      self.toggleAllCheckbox = toggleAllCheckbox;
      self.submit = submitCategories;
      self.okButtonDisabled = okButtonDisabled;

      function invalidateForm () {
         self.errorMessage = i18nService.getString('Common', 'tag.create.form.error.server.category.create');
         self.validity = 'invalid';
      }

      function toggleAllTypes () {
         self.allCheckbox = _.map(self.associableObjectTypes, 'selection').filter(function(selected) {
               return !selected;
            }).length === 0;
      }

      function toggleAllCheckbox () {
         Object.keys(self.associableObjectTypes).forEach(function(key) {
            if (!self.associableObjectTypes[key].disabled) {
                self.associableObjectTypes[key].selection = self.allCheckbox;
            }
         });
      }

      function submitCategories () {
         var associationObject = [];
         var promise;
         
         for (var key in self.associableObjectTypes) {
             if(self.associableObjectTypes[key].selection) {
                 associationObject.push(self.associableObjectTypes[key].associableType);
                 if (self.associableObjectTypes[key].associatedTypes) {
                     associationObject = associationObject.concat(self.associableObjectTypes[key].associatedTypes);
                 }
             }
         }

         if (categoryState.name === self.name || validateCategories(self.name)) {
            var categoryPromise;
            if (categoryState.categoryMoRef) {
               categoryPromise = categoryService.editCategory(
                  categoryState.categoryMoRef,
                  self.name,
                  self.description,
                  hasMultipleCardinality(),
                  associationObject
               );
            } else {
               categoryPromise = categoryService.addCategory(
                  self.name,
                  self.description,
                  hasMultipleCardinality(),
                  associationObject
               );
            }
            promise = $q.all([categoryPromise]).then(function () {
               $rootScope.$broadcast('refreshCategories');
            });
            self.closeModal();
         } else {
            invalidateForm();
            promise = $q.resolve();
         }
         return promise;
      }

      function hasMultipleCardinality () {
         return self.multipleCardinality === 'multiple';
      }

      function validateCategories (newCategoryName) {
         return _.filter($scope.modalOptions.dialogData.categories, function(category) {
               return category.categoryName === newCategoryName;
            }).length === 0;
      }

      function okButtonDisabled() {
         if(self.name === "") {
            return true;
         }
         return !(self.name || isAssociableObjectTypeIsChecked());
      }

      function isAssociableObjectTypeIsChecked() {
         if(self.allCheckbox) {
            return true;
         }

         return Object.keys(self.associableObjectTypes).some(function(key) {
            return self.associableObjectTypes[key].selection;
         });
      }

      function isObjectTypeSelected(key){
        return selectedObjectTypes.indexOf(self.associableObjectTypes[key].associableTypeString) !== -1;
      }


      self.closeModal = function() {
         $scope.closeModal();
      };
   }
})();

/* Copyright 2016-2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('CategoriesController', CategoriesController);

   CategoriesController.$inject = ['categoryService', 'categoryActionService', 'i18nService', '$scope', 'vuiConstants'];

   function CategoriesController (categoryService, categoryActionService, i18nService, $scope, vuiConstants) {
      var self = this;

      function addCategory () {
         categoryActionService.addEditCategory(self.datagridOptions.data);
      }

      function deleteCategory() {
         var item = self.datagridOptions.selectedItems[0];
         categoryActionService.deleteCategory(item.managedObjectReference);
      }

      function editCategory() {
         categoryActionService.addEditCategory(self.datagridOptions.data, self.datagridOptions.selectedItems[0]);
      }

      var addAction = {
         id: 'add-category-action',
         iconClass: 'vsphere-icon-toolbar-add',
         tooltipText: i18nService.getString('CommonModuleUi', 'add.category'),
         enabled: true,
         onClick: addCategory
      };
      var editAction = {
         id: 'edit-tag-action',
         iconClass: 'vsphere-icon-toolbar-edit',
         tooltipText: i18nService.getString('CommonModuleUi', 'edit.category'),
         enabled: true,
         onClick : editCategory
      };
      var deleteAction = {
         id: 'delete-category-action',
         iconClass: 'vsphere-icon-toolbar-remove',
         tooltipText: i18nService.getString('CommonModuleUi', 'categoryAction.remove.desc'),
         enabled: false,
         onClick: deleteCategory
      };

      self.datagridOptions = {
         actionBarOptions: {
            actions: [
               addAction,
               editAction,
               deleteAction
            ]
         },
         columnDefs: [
            {
               displayName: i18nService.getString('Common', 'tag.dashboard.categories.name'),
               field: 'categoryName',
               sortable: true,
               searchable: false,
               template: function(dataItem) {
                  return dataGridTemplate(dataItem,'categoryName');
               }
            },
            {
               displayName: i18nService.getString('Common', 'tag.dashboard.categories.desc'),
               field: 'categoryDescription',
               sortable: true,
               searchable: false,
               template: function(dataItem) {
                  return dataGridTemplate(dataItem,'categoryDescription');
               }
            },
            {
               displayName: i18nService.getString('Common', 'tag.dashboard.categories.cardinality'),
               field: 'multipleCardinality',
               sortable: true,
               searchable: false,
               template: function(dataItem) {
                  return dataGridTemplate(dataItem,'multipleCardinality');
               }
            },
            {
               displayName: i18nService.getString('Common', 'tag.dashboard.categories.associable'),
               field: 'displayAssociableEntityTypesString',
               sortable: true,
               searchable: false,
               template: function(dataItem) {
                  return dataGridTemplate(dataItem,'displayAssociableEntityTypesString');
               }
            }
         ],
         sortOrder: [{
            field: 'categoryName',
            dir: 'asc'
         }],
         height: '100%',
         resizable: true,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         data: []
      };

      function transform (categories) {
         return _.map(categories, function(category) {
            if (category.associableEntityTypes.length === 0) {
               category.displayAssociableEntityTypesString = i18nService.getString('Common', 'tag.dashboard.categories.associable.all');
            } else {
               category.displayAssociableEntityTypesString = lookupEntityNames(category.associableEntityTypes).join(', ');
            }
            return category;
         });
      }

      function lookupEntityNames (entityTypes) {
         return _.map(entityTypes, function(entityType) {
            return i18nService.getString('Common', 'typeResource.entityType.' + entityType + 'Plural');
         });
      }

      function refreshCategories () {
         categoryService.getAll().then(function(data) {
            self.datagridOptions.data = transform(data);
         });
      }

      /**
       *  Generate html template for datagrid
       */
      function dataGridTemplate (dataItem, fieldName) {
         var ele = document.createElement("span");
         ele.setAttribute("ng-non-bindable", "ng-non-bindable");
         ele.title = dataItem[fieldName];
         ele.textContent = dataItem[fieldName];
         return ele.outerHTML;
      }

      $scope.$watch('ctrl.datagridOptions.selectedItems', function (selectedItems) {
         var selected = selectedItems.length > 0;
         deleteAction.enabled = selected;
         editAction.enabled = selected;
      });

      $scope.$on('refreshCategories', function(){
         refreshCategories();
      });

      refreshCategories();
   }
})();

(function () {
   /**
    * A node of the messages inside the compatibility box.
    *
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule').directive('vxCompatibilityMessageNode', [
      '$compile',
      function vxCompatibilityMessageNode($compile) {
         return {
            restrict: 'A',
            templateUrl: 'common-module-ui/resources/common-module/views/compatibility/vxCompatibilityMessageNode.html',
            scope: {
               content: '='
            },
            link: function ($scope, element) {
               if (!_.isEmpty($scope.content.contents)) {
                  var innerElement = $compile('<li vx-compatibility-message-node ' +
                        'content="childContent" ng-repeat="childContent in content.contents"' +
                        'class="horizontal-flex-container"></li>')($scope);
                  element.find('ul').append(innerElement);
               }
            }
         };
      }]);
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule').directive('vxCompatibilityView', VxCompatibilityView);

   VxCompatibilityView.$inject = [
      'clarityModalService',
      'i18nService',
      '$injector',
      '$q'
   ];

   /**
    * A compatibility box that holds the results from the compatibility check in wizards (i.e migrate, create VM...).
    *
    * onShowDetailsClick - A callback that can accept the contents as a parameter.
    *    If it returns a promise, the compatibility box will wait for the promise to be
    *    resolved and then it will display the dialog.
    *    If the callback is not of type 'function', it will be ignored.
    * summarize - if 'true', the messages are summarized and 'Show details..' link is displayed
    *    It is 'true' by default.
    */
   function VxCompatibilityView(clarityModalService, i18nService, $injector, $q) {
      return {
         restrict: 'E',
         replace: true,
         templateUrl: 'common-module-ui/resources/common-module/views/compatibility/vxCompatibilityView.html',
         scope: {
            compatibilityTitle: '<',
            contents: '<',
            summarize: '<?',
            onShowDetailsClick: '&?',
            isLoading: '<',
            validatingAriaLabel: '@?'
         },
         link: function(scope, element, attrs) {
            _.defaults(scope, {
               summarize: true
            });

            if (!scope.summarize) {
               return;
            }

            scope.showDetailsLabel = i18nService.getString("CommonModuleUi", "compatibilityView.showDetails");
            scope.validationMessage =  i18nService.getString("CommonModuleUi", "compatibilityView.validating");

            scope.openPopup = function() {
               var advancedCompatibilityContentsArr = _.pluck(scope.contents,
                     "advancedCompatibilityContents");
               advancedCompatibilityContentsArr = _.filter(advancedCompatibilityContentsArr,
                     function(item) {
                        return item;
                     });
               if (!_.isEmpty(advancedCompatibilityContentsArr)) {
                  var vscAdvancedCompatibilityDialogOpenService =
                        $injector.get("vscAdvancedCompatibilityDialogOpenService");
                  vscAdvancedCompatibilityDialogOpenService.open(advancedCompatibilityContentsArr);
                  return;
               }
               var modalOptions = {
                  dialogData: {
                     compatibilityTitle: scope.compatibilityTitle,
                     contents: scope.contents
                  },
                  title: i18nService.getString('CommonModuleUi', 'compatibilityViewPopup.title'),
                  contentTemplate: 'common-module-ui/resources/common-module/views/compatibility/vxCompatibilityViewPopup.html',
                  hideSubmitButton: true,
                  defaultButton: 'close',
                  closeButtonTitle: i18nService.getString('Common', 'close.label')
               };

               if (typeof scope.onShowDetailsClick === 'function') {
                  $q.resolve(scope.onShowDetailsClick({ contents: scope.contents }))
                        .then(function() {
                           clarityModalService.openOkCancelModal(modalOptions);
                        });
               } else {
                  clarityModalService.openOkCancelModal(modalOptions);
               }
            };

            scope.$watchCollection(function() {
               return scope.contents;
            }, function(newContents, oldContents) {
               var issuesCount = countCompatibilityProblems(newContents);
               setCompatibilityMessages(issuesCount);
            });

            function countCompatibilityProblems(contents) {
               var issuesCount = {
                  errors: 0,
                  warnings: 0,
                  unknown: 0,
                  ok: 0
               };

               _.each(contents, function(contentItem) {
                  if (contentItem.icon === 'vsphere-icon-status-error'
                        || contentItem.icon === 'vui-icon-datagrid-status-red') {
                     issuesCount.errors++;
                  } else if (contentItem.icon === 'vsphere-icon-status-warning'
                        || contentItem.icon === 'vui-icon-datagrid-status-yellow') {
                     issuesCount.warnings++;
                  } else if (contentItem.icon === 'vsphere-icon-status-unknown'
                        || contentItem.icon === 'vui-icon-datagrid-status-unknown') {
                     issuesCount.unknown++;
                  } else if (contentItem.icon === 'vsphere-icon-status-ok'
                        || contentItem.icon === 'vui-icon-datagrid-status-green') {
                     issuesCount.ok++;
                  }
                  if (!_.isEmpty(contentItem.contents)) {
                     var childIssueCount = countCompatibilityProblems(contentItem.contents);
                     issuesCount = sum(issuesCount, childIssueCount);
                  }
               });

               return issuesCount;
            }

            function sum(issues, additionalIssues) {
               return _.mapObject(issues, function(val, key) {
                  return val + additionalIssues[key];
               });
            }

            function setCompatibilityMessages(issuesCount) {
               scope.issuesSummaryMessage = {
                  message: '',
                  icon: ''
               };

               scope.issuesLength = issuesCount.errors +
                     issuesCount.warnings + issuesCount.unknown;

               if (scope.issuesLength > 1) {
                  if (issuesCount.errors > 0) {
                     scope.issuesSummaryMessage.message = i18nService.getString("CommonModuleUi",
                           "compatibilityView.errorStateDefaultMessage");
                     scope.issuesSummaryMessage.icon = 'vsphere-icon-status-error';
                  } else if (issuesCount.warnings > 0) {
                     scope.issuesSummaryMessage.message = i18nService.getString("CommonModuleUi",
                           "compatibilityView.warningStateDefaultMessage");
                     scope.issuesSummaryMessage.icon = 'vsphere-icon-status-warning';
                  } else if (issuesCount.unknown > 0) {
                     scope.issuesSummaryMessage.message = i18nService.getString("CommonModuleUi",
                           "compatibilityView.infoStateDefaultMessage");
                     scope.issuesSummaryMessage.icon = 'vsphere-icon-status-unknown';
                  }
               }
            }
         }
      };
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Controller for Content Library Publication Portlet.
 *
 */
var h5_client;
(function (h5_client) {
    var ContentLibraryPublicationPortletController = (function () {
        function ContentLibraryPublicationPortletController($scope, i18nService, actionsService) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.libraryId = this.$scope._route.objectId;
            this.actionsService.getAction("vsphere.core.library.local.editSettings", [this.libraryId])
                .then(function (action) {
                _this.$scope.portlet.footerLinks = [{
                        label: _this.i18nService.getString("LibraryUi", "library.editAction"),
                        onClick: function ($event) { return _this.actionsService.invokeAction(action, { focusTarget: $event.currentTarget }); },
                        ariaLabel: _this.i18nService.getString("LibraryUi", "library.editPublicationSettings"),
                        enabled: action && action.available
                    }];
            });
        }
        ContentLibraryPublicationPortletController.$inject = ["$scope", "i18nService", "actionsService"];
        return ContentLibraryPublicationPortletController;
    }());
    h5_client.ContentLibraryPublicationPortletController = ContentLibraryPublicationPortletController;
    angular.module("com.vmware.vsphere.client.commonModule")
        .controller("contentLibraryPublicationPortletController", ContentLibraryPublicationPortletController);
})(h5_client || (h5_client = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    var ContentLibraryStoragePortletController = (function () {
        function ContentLibraryStoragePortletController($scope) {
            this.$scope = $scope;
            this.libraryId = this.$scope._route.objectId;
        }
        ContentLibraryStoragePortletController.$inject = ["$scope"];
        return ContentLibraryStoragePortletController;
    }());
    h5_client.ContentLibraryStoragePortletController = ContentLibraryStoragePortletController;
    angular.module("com.vmware.vsphere.client.commonModule")
        .controller("contentLibraryStoragePortletController", ContentLibraryStoragePortletController);
})(h5_client || (h5_client = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Controller for Content Library Subscription Portlet.
 *
 */
var h5_client;
(function (h5_client) {
    var ContentLibrarySubscriptionPortletController = (function () {
        function ContentLibrarySubscriptionPortletController($scope, AngularInjector, i18nService, actionsService) {
            var _this = this;
            this.$scope = $scope;
            this.AngularInjector = AngularInjector;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.libraryId = this.$scope._route.objectId;
            this.editSettingsService = AngularInjector.get("vscSubscribedLibraryEditSettingsModalService");
            this.actionsService.getAction("vsphere.core.library.subscribed.editSettings", [this.libraryId])
                .then(function (action) {
                _this.$scope.portlet.footerLinks = [
                    {
                        label: _this.i18nService.getString("LibraryUi", "library.editAction"),
                        ariaLabel: _this.i18nService.getString("LibraryUi", "library.editSubscriptionSettings"),
                        onClick: _this.onEditSettingsClicked.bind(_this),
                        enabled: action && action.available
                    }
                ];
            });
        }
        ContentLibrarySubscriptionPortletController.prototype.onEditSettingsClicked = function ($event) {
            var triggerElement = $event.currentTarget;
            this.editSettingsService.openSubscribedLibraryEditSettingsDialog(this.libraryId, triggerElement);
        };
        ContentLibrarySubscriptionPortletController.$inject = ["$scope", "AngularInjector", "i18nService", "actionsService"];
        return ContentLibrarySubscriptionPortletController;
    }());
    h5_client.ContentLibrarySubscriptionPortletController = ContentLibrarySubscriptionPortletController;
    angular.module("com.vmware.vsphere.client.commonModule")
        .controller("contentLibrarySubscriptionPortletController", ContentLibrarySubscriptionPortletController);
})(h5_client || (h5_client = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryTemplatesViewController = (function () {
            function ContentLibraryTemplatesViewController(i18nService, navigation, dataService, featureFlagsService) {
                this.i18nService = i18nService;
                this.navigation = navigation;
                this.dataService = dataService;
                this.featureFlagsService = featureFlagsService;
                this.showVmtxNotAvailableAlert = false;
                this.showPublishAvailableAlert = false;
            }
            ContentLibraryTemplatesViewController.prototype.$onInit = function () {
                var _this = this;
                this.i18n = this.i18nService.getString.bind(this.i18nService, "LibraryUi");
                if (!this.featureFlagsService.CL_VMTX_SyncEnabled()) {
                    return;
                }
                this.dataService.getProperties(this.navigation.getRoute().objectId, ["isLocalLibrary", "publishInfo.published", "isSubscriptionsCapabilitySupported"])
                    .then(function (response) {
                    _this.showVmtxNotAvailableAlert = response["isLocalLibrary"] === false
                        && response["publishInfo.published"] === false;
                    _this.showPublishAvailableAlert = response["isLocalLibrary"] === true
                        && response["publishInfo.published"] === true
                        && response["isSubscriptionsCapabilitySupported"] === true;
                });
            };
            ContentLibraryTemplatesViewController.prototype.hideWarning = function () {
                this.showVmtxNotAvailableAlert = false;
                this.showPublishAvailableAlert = false;
            };
            ContentLibraryTemplatesViewController.$inject = [
                "i18nService",
                "navigation",
                "dataService",
                "featureFlagsService",
            ];
            return ContentLibraryTemplatesViewController;
        }());
        common_module_ui.ContentLibraryTemplatesViewController = ContentLibraryTemplatesViewController;
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("ContentLibraryTemplatesViewController", ContentLibraryTemplatesViewController);
    })(common_module_ui || (common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var LibraryDataModel = h5_client.common_module_ui.LibraryDataModel;
        var CreateContentLibraryService = (function () {
            function CreateContentLibraryService(vuiWizardService, $rootScope, i18nService, featureFlagsService, libraryService, wizardPageService, contentLibraryNamePageService, createContentLibraryFinishPageService, createContentLibrarySelectDataStorePageService, createContentLibraryConfigurePageService, createContentLibraryConfigureVapiPageService) {
                this.vuiWizardService = vuiWizardService;
                this.$rootScope = $rootScope;
                this.i18nService = i18nService;
                this.featureFlagsService = featureFlagsService;
                this.libraryService = libraryService;
                this.wizardPageService = wizardPageService;
                this.contentLibraryNamePageService = contentLibraryNamePageService;
                this.createContentLibraryFinishPageService = createContentLibraryFinishPageService;
                this.createContentLibrarySelectDataStorePageService = createContentLibrarySelectDataStorePageService;
                this.createContentLibraryConfigurePageService = createContentLibraryConfigurePageService;
                this.createContentLibraryConfigureVapiPageService = createContentLibraryConfigureVapiPageService;
            }
            CreateContentLibraryService.prototype.showWizard = function () {
                var _this = this;
                var wizardScope = this.$rootScope.$new();
                var createLibraryNamePage = this.contentLibraryNamePageService.build();
                var createLibraryFinishPage = this.createContentLibraryFinishPageService.build();
                var createLibrarySelectStoragePage = this.createContentLibrarySelectDataStorePageService.build();
                var createLibraryConfigurePage = this.createContentLibraryConfigureVapiPageService.build();
                var flows = [];
                flows.push({
                    id: "create.contentLibrary.flowId",
                    pages: [
                        createLibraryNamePage,
                        createLibraryConfigurePage,
                        createLibrarySelectStoragePage,
                        createLibraryFinishPage
                    ]
                });
                wizardScope.wizardConfig = {
                    pages: this.wizardPageService.initializePageStates(flows[0].pages),
                    flows: this.wizardPageService.initializeFlowStates(flows)
                };
                wizardScope.wizardConfig.title = this.i18nService.getString("LibraryUi", "createLibraryWizard.title");
                wizardScope.wizardState = new LibraryDataModel();
                wizardScope.wizardConfig.onFinish = function () {
                    _this.libraryService.addContentLibrary(angular.copy(wizardScope.wizardState));
                    return true;
                };
                this.vuiWizardService({
                    scope: wizardScope,
                    configObjectName: "wizardConfig",
                    validationBanner: {}
                }).show();
            };
            CreateContentLibraryService.$inject = ['vuiWizardService',
                '$rootScope',
                'i18nService',
                'featureFlagsService',
                'libraryService',
                'wizardPageService',
                'contentLibraryNamePageService',
                'createContentLibraryFinishPageService',
                'createContentLibrarySelectDataStorePageService',
                'createContentLibraryConfigurePageService',
                'createContentLibraryConfigureVapiPageService'];
            return CreateContentLibraryService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("createContentLibraryService", CreateContentLibraryService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryNamePageService = (function () {
            function ContentLibraryNamePageService(i18nService) {
                this.i18nService = i18nService;
            }
            ContentLibraryNamePageService.prototype.build = function () {
                return {
                    title: this.i18nService.getString('LibraryUi', 'createLibraryWizard.libraryNamePage.title'),
                    description: this.i18nService.getString('LibraryUi', 'createLibraryWizard.libraryNamePage.description'),
                    contentUrl: 'common-module-ui/resources/common-module/views/content-library/wizard/pages/createContentLibraryName.html'
                };
            };
            ContentLibraryNamePageService.$inject = ['i18nService'];
            return ContentLibraryNamePageService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("contentLibraryNamePageService", ContentLibraryNamePageService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibraryConfigurePageService = (function () {
            function CreateContentLibraryConfigurePageService(i18nService) {
                this.i18nService = i18nService;
            }
            CreateContentLibraryConfigurePageService.prototype.build = function () {
                return {
                    title: this.i18nService.getString('LibraryUi', 'createLibraryWizard.configurePage.title'),
                    description: this.i18nService.getString('LibraryUi', 'createLibraryWizard.configurePage.description'),
                    contentUrl: 'common-module-ui/resources/common-module/views/content-library/wizard/pages/createContentLibraryConfigure.html'
                };
            };
            CreateContentLibraryConfigurePageService.$inject = ['i18nService'];
            return CreateContentLibraryConfigurePageService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("createContentLibraryConfigurePageService", CreateContentLibraryConfigurePageService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibraryConfigureController = (function () {
            function CreateContentLibraryConfigureController($scope, i18nService, libraryService, vuiConstants, clarityModalService) {
                this.$scope = $scope;
                this.i18nService = i18nService;
                this.libraryService = libraryService;
                this.vuiConstants = vuiConstants;
                this.clarityModalService = clarityModalService;
                this.CERTIFICATE_ERROR_STATUS = "CERTIFICATE_ERROR";
                this.subscriptionUrl = this.$scope.wizardState.subscriptionUrl;
                this.sslThumbprint = "";
                this.i18n = i18nService.getString;
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
                this.init();
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
            }
            CreateContentLibraryConfigureController.prototype.init = function () {
                var _this = this;
                var self = this;
                this.$scope.vuiWizard.currentPage.disableNext = function () {
                    return !self.subscriptionUrl.length;
                };
                this.$scope.vuiWizard.currentPage.onCommit = function () {
                    return _this.getValidateSubscriptionUrlPromise.call(_this);
                };
            };
            CreateContentLibraryConfigureController.prototype.getValidateSubscriptionUrlPromise = function () {
                var self = this;
                return this.libraryService.validateSubscription(self.subscriptionUrl, self.sslThumbprint).then(function (result) {
                    var errorMessage = '';
                    if (result.error) {
                        errorMessage = result.error.localizedMessage;
                    }
                    if (result.result) {
                        if (self.isSslThumbprintError(result.result)) {
                            self.sslThumbprint = result.result.sslThumbprint;
                            self.openSslThumbprintAlert(self.sslThumbprint);
                            return false;
                        }
                        else if (result.result.errorMessages.length) {
                            errorMessage = result.result.errorMessages[0].defaultMessage;
                        }
                        else {
                            self.$scope.wizardState.type = { name: 'SUBSCRIBED' };
                            self.$scope.wizardState.subscriptionUrl = self.subscriptionUrl;
                            self.$scope.vuiWizard.currentPage.state = self.vuiConstants.wizard.pageState.COMPLETED;
                            return true;
                        }
                    }
                    if (errorMessage) {
                        self.$scope.wizardConfig.validationBanner.messages = [{
                                text: errorMessage,
                                type: self.vuiConstants.validationBanner.type.ERROR
                            }];
                        self.$scope.wizardConfig.validationBanner.showAllMessages = true;
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            };
            CreateContentLibraryConfigureController.prototype.isSslThumbprintError = function (resultObj) {
                if (resultObj && resultObj.status && resultObj.status.enumValue) {
                    return (resultObj.status.enumValue === this.CERTIFICATE_ERROR_STATUS);
                }
                return false;
            };
            CreateContentLibraryConfigureController.prototype.openSslThumbprintAlert = function (sslThumbprint) {
                var self = this;
                this.clarityModalService.openConfirmationModal({
                    title: this.i18n('LibraryUi', 'sslDialog.securityAlertTitle', self.$scope.wizardState.name),
                    message: this.i18nService.getString('LibraryUi', 'sslDialog.securityAlertText', sslThumbprint),
                    preserveNewlines: true,
                    saveButtonLabel: this.i18n('LibraryUi', 'yes'),
                    clarityIcon: {
                        shape: "warning",
                        class: "is-warning",
                        size: 64
                    },
                    submit: function () {
                        self.$scope.wizardState.sslThumbprint = self.sslThumbprint;
                        self.$scope.wizardManager.onNextClick();
                        return true;
                    },
                    onCancel: function () {
                        self.sslThumbprint = "";
                    }
                });
            };
            CreateContentLibraryConfigureController.$inject = ['$scope', 'i18nService', 'libraryService', 'vuiConstants', 'clarityModalService'];
            return CreateContentLibraryConfigureController;
        }());
        angular.module('com.vmware.vsphere.client.commonModule')
            .controller('createContentLibraryConfigureController', CreateContentLibraryConfigureController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibraryFinishPageService = (function () {
            function CreateContentLibraryFinishPageService(i18nService) {
                this.i18nService = i18nService;
            }
            CreateContentLibraryFinishPageService.prototype.build = function () {
                return {
                    title: this.i18nService.getString('LibraryUi', 'createLibraryWizard.readyToCompletePage.title'),
                    description: this.i18nService.getString('LibraryUi', 'createLibraryWizard.readyToCompletePage.description'),
                    contentUrl: 'common-module-ui/resources/common-module/views/content-library/wizard/pages/createContentLibraryFinish.html'
                };
            };
            CreateContentLibraryFinishPageService.$inject = ['i18nService'];
            return CreateContentLibraryFinishPageService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("createContentLibraryFinishPageService", CreateContentLibraryFinishPageService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        var CreateContentLibraryFinishController = (function () {
            function CreateContentLibraryFinishController($scope, i18nService, vuiConstants) {
                this.$scope = $scope;
                this.i18nService = i18nService;
                this.vuiConstants = vuiConstants;
                this.i18n = i18nService.getString;
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
            }
            CreateContentLibraryFinishController.prototype.getLibraryTypeString = function () {
                return this.$scope.wizardState.type === ContentLibraryConstants.LIBRARYTYPE_LOCAL ?
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.localLibrary") :
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.subscribedLibrary");
            };
            CreateContentLibraryFinishController.prototype.isLibraryLocal = function () {
                return this.$scope.wizardState.type === ContentLibraryConstants.LIBRARYTYPE_LOCAL;
            };
            CreateContentLibraryFinishController.prototype.getPublishedString = function () {
                return !this.$scope.wizardState.isPublished ?
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.published.no") :
                    this.getDetailedPublishedString();
            };
            CreateContentLibraryFinishController.prototype.getDetailedPublishedString = function () {
                var streamOptimized = this.$scope.wizardState.isStreamingOptimized ?
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.streamOptimized") :
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.streamNotOptimized");
                var passwordProtection = this.$scope.wizardState.isAuthenticationEnabled ?
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.passwordRequired") :
                    this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.passwordNotRequired");
                return this.i18n("LibraryUi", "createLibraryWizard.readyToCompletePage.published.yes", streamOptimized, passwordProtection);
            };
            CreateContentLibraryFinishController.$inject = ['$scope', 'i18nService', 'vuiConstants'];
            return CreateContentLibraryFinishController;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("createContentLibraryFinishController", CreateContentLibraryFinishController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibrarySelectDataStorePageService = (function () {
            function CreateContentLibrarySelectDataStorePageService(i18nService) {
                this.i18nService = i18nService;
            }
            CreateContentLibrarySelectDataStorePageService.prototype.build = function () {
                return {
                    title: this.i18nService.getString('LibraryUi', 'createLibraryWizard.addStoragePage.title'),
                    description: this.i18nService.getString('LibraryUi', 'createLibraryWizard.addStoragePage.description'),
                    contentUrl: 'common-module-ui/resources/common-module/views/content-library/wizard/pages/createContentLibrarySelectStorage.html'
                };
            };
            CreateContentLibrarySelectDataStorePageService.$inject = ['i18nService'];
            return CreateContentLibrarySelectDataStorePageService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("createContentLibrarySelectDataStorePageService", CreateContentLibrarySelectDataStorePageService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibrarySelectDatastoreController = (function () {
            function CreateContentLibrarySelectDatastoreController($scope, i18nService, defaultUriSchemeUtil, dataService, vuiConstants, authorizationService, $q) {
                var _this = this;
                this.$scope = $scope;
                this.i18nService = i18nService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.dataService = dataService;
                this.vuiConstants = vuiConstants;
                this.authorizationService = authorizationService;
                this.$q = $q;
                this.DATASTORE_ALLOCATESPACE_PRIVILEGE = 'Datastore.AllocateSpace';
                this.i18n = i18nService.getString;
                var datastoreListConfig = {
                    listViewId: 'vsphere.core.datastore.list',
                    dataModels: ['Datastore']
                };
                this.objSelectorConf = {
                    contextObject: this.defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', this.$scope.wizardState.vcService.serviceGuid),
                    multipleSelect: false,
                    listTabConfig: {
                        selectedTabIndex: 0,
                        listConfig: [datastoreListConfig]
                    },
                    selectedObjects: this.$scope.wizardState.datastore ? [this.$scope.wizardState.datastore.id] : null,
                    onSelectionChanged: this.onDatastoreSelectionChange.bind(this)
                };
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
                this.$scope.vuiWizard.currentPage.onCommit = function () {
                    var self = _this;
                    if (!_this.$scope.wizardState.datastore.id) {
                        _this.showValidationMessage('createLibraryWizard.addStoragePage.selectDatastore');
                        return self.$q.when(false);
                    }
                    return _this.isValidDatastore(_this.$scope.wizardState.datastore.id).then(function (validDatastore) {
                        if (validDatastore) {
                            self.$scope.vuiWizard.currentPage.state = self.vuiConstants.wizard.pageState.COMPLETED;
                            return true;
                        }
                        else {
                            self.$scope.wizardConfig.validationBanner.messages = [{
                                    text: i18nService.getString('LibraryUi', 'error.datastore.inaccessible'),
                                    type: self.vuiConstants.validationBanner.type.ERROR
                                }];
                            self.$scope.wizardConfig.validationBanner.showAllMessages = true;
                            return false;
                        }
                    });
                };
            }
            CreateContentLibrarySelectDatastoreController.prototype.isValidDatastore = function (datastore) {
                return this.dataService.getProperties(datastore, ['summary.accessible']).then(function (properties) {
                    return properties['summary.accessible'];
                });
            };
            CreateContentLibrarySelectDatastoreController.prototype.onDatastoreSelectionChange = function (datastore) {
                var _this = this;
                this.$scope.vuiWizard.currentPage.state =
                    this.vuiConstants.wizard.pageState.INCOMPLETE;
                this.hasPrivilegeOnDatastore(datastore[0].id).then(function (isAuthorized) {
                    if (isAuthorized) {
                        _this.$scope.wizardState.datastore = { id: datastore[0].id, name: datastore[0].name };
                        _this.$scope.vuiWizard.currentPage.state =
                            _this.vuiConstants.wizard.pageState.COMPLETED;
                    }
                    else {
                        _this.$scope.wizardState.datastore = {};
                        _this.showValidationMessage('h5.error.noDatastorePrivilege');
                    }
                });
            };
            CreateContentLibrarySelectDatastoreController.prototype.hasPrivilegeOnDatastore = function (datastoreId) {
                return this.authorizationService.checkPrivilege(datastoreId, this.DATASTORE_ALLOCATESPACE_PRIVILEGE);
            };
            CreateContentLibrarySelectDatastoreController.prototype.showValidationMessage = function (messageKey) {
                this.$scope.wizardConfig.validationBanner.messages = [{
                        text: this.i18nService.getString('LibraryUi', messageKey),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.wizardConfig.validationBanner.showAllMessages = true;
            };
            CreateContentLibrarySelectDatastoreController.$inject = [
                '$scope',
                'i18nService',
                'defaultUriSchemeUtil',
                'dataService',
                'vuiConstants',
                'authorizationService',
                '$q'
            ];
            return CreateContentLibrarySelectDatastoreController;
        }());
        angular.module('com.vmware.vsphere.client.commonModule')
            .controller('createContentLibrarySelectDatastoreController', CreateContentLibrarySelectDatastoreController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibraryController = (function () {
            function CreateContentLibraryController($scope, $rootScope, i18nService, userSessionService, vuiConstants, clarityModalService, $q, libraryService) {
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.i18nService = i18nService;
                this.userSessionService = userSessionService;
                this.vuiConstants = vuiConstants;
                this.clarityModalService = clarityModalService;
                this.$q = $q;
                this.libraryService = libraryService;
                this.name = this.$scope.wizardState.name;
                this.description = this.$scope.wizardState.description;
                this.vcService = this.$scope.wizardState.vcService;
                this.MAX_LENGTH = 80;
                this.i18n = i18nService.getString;
                var self = this;
                self.$scope.vuiWizard.currentPage.state = self.vuiConstants.wizard.pageState.INCOMPLETE;
                userSessionService.getAllServersInfo().then(function (data) {
                    self.vCenters = data.serversInfo.filter(function (s) { return s.name && s.errorCode === 'noError'; });
                    if (!self.$scope.wizardState.vcService.name) {
                        self.vcService = self.vCenters[0];
                    }
                    else {
                        if (self.vCenters) {
                            var vcServiceName_1 = self.$scope.wizardState.vcService.serviceGuid;
                            self.vcService = _.find(self.vCenters, function (vcenter) {
                                return (vcServiceName_1 === vcenter.serviceGuid);
                            });
                        }
                    }
                    self.init();
                });
            }
            CreateContentLibraryController.prototype.init = function () {
                var self = this;
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
                this.$scope.vuiWizard.currentPage.disableNext = function () {
                    return !self.name.length;
                };
                this.$scope.vuiWizard.currentPage.onCommit = function () {
                    var nextConfirmationDeferred = self.$q.defer();
                    if (self.name.length > self.MAX_LENGTH) {
                        self.$scope.wizardConfig.validationBanner.messages = [{
                                text: self.i18n('VmUi', 'NameValidator.nameTooLongSpecialChars'),
                                type: self.vuiConstants.validationBanner.type.ERROR
                            }];
                        self.$scope.wizardConfig.validationBanner.showAllMessages = true;
                        nextConfirmationDeferred.resolve(false);
                    }
                    else {
                        self.isDuplicateLibraryName().then(function (isDup) {
                            if (isDup) {
                                self.clarityModalService.openConfirmationModal({
                                    title: self.i18nService.getString('LibraryUi', 'library.dupeNameWarning.dialogDescriptionHeader'),
                                    message: self.i18nService.getString('LibraryUi', 'library.dupeNameWarning.dialogDescriptionBodyCreate', self.name),
                                    icon: 'vsphere-icon-status-warning',
                                    submit: function () {
                                        self.onSubmit(nextConfirmationDeferred);
                                    },
                                    onCancel: function () {
                                        nextConfirmationDeferred.resolve(false);
                                    },
                                    preserveNewlines: true
                                });
                            }
                            else {
                                self.onSubmit(nextConfirmationDeferred);
                            }
                        });
                    }
                    return nextConfirmationDeferred.promise;
                };
            };
            CreateContentLibraryController.prototype.onSubmit = function (nextConfirmationDeferred) {
                this.$scope.wizardState.name = this.name;
                this.$scope.wizardState.description = this.description;
                this.$scope.wizardState.vcService = this.vcService;
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.COMPLETED;
                nextConfirmationDeferred.resolve(true);
            };
            CreateContentLibraryController.prototype.isDuplicateLibraryName = function () {
                var _this = this;
                return this.libraryService.getAllContentLibraryInVc(this.vcService).then(function (libraries) {
                    _this.libraries = libraries;
                    return _.findIndex(_this.libraries.targetLibraries, { name: _this.name }) !== -1;
                });
            };
            CreateContentLibraryController.$inject = ['$scope', '$rootScope', 'i18nService', 'userSessionService', 'vuiConstants', 'clarityModalService', '$q', 'libraryService'];
            return CreateContentLibraryController;
        }());
        angular.module('com.vmware.vsphere.client.commonModule')
            .controller('createContentLibraryController', CreateContentLibraryController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var CreateContentLibraryConfigureVapiPageService = (function () {
            function CreateContentLibraryConfigureVapiPageService(i18nService) {
                this.i18nService = i18nService;
            }
            CreateContentLibraryConfigureVapiPageService.prototype.build = function () {
                return {
                    title: this.i18nService.getString('LibraryUi', 'createLibraryWizard.configurePage.title'),
                    description: this.i18nService.getString('LibraryUi', 'createLibraryWizard.configurePage.description'),
                    contentUrl: 'common-module-ui/resources/common-module/views/content-library/wizard/pages/vapi/createContentLibraryConfigureVapi.html'
                };
            };
            CreateContentLibraryConfigureVapiPageService.$inject = ['i18nService'];
            return CreateContentLibraryConfigureVapiPageService;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .service("createContentLibraryConfigureVapiPageService", CreateContentLibraryConfigureVapiPageService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ContentLibraryConstants = h5_client.common_module_ui.ContentLibraryConstants;
        var CreateContentLibraryConfigureVapiController = (function () {
            function CreateContentLibraryConfigureVapiController($scope, i18nService, libraryService, vuiConstants, clarityModalService, authorizationService, defaultUriSchemeUtil) {
                var _this = this;
                this.$scope = $scope;
                this.i18nService = i18nService;
                this.libraryService = libraryService;
                this.vuiConstants = vuiConstants;
                this.clarityModalService = clarityModalService;
                this.authorizationService = authorizationService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.CERTIFICATE_ERROR_STATUS = "CERTIFICATE_ERROR";
                this.CREATE_LOC_LIB_PRIVILEGE = "ContentLibrary.CreateLocalLibrary";
                this.CREATE_SUB_LIB_PRIVILEGE = "ContentLibrary.CreateSubscribedLibrary";
                this.PROBE_SUBSCRIPTION_PRIVILEGE = "ContentLibrary.ProbeSubscription";
                this.PASSWORD_PATTERN = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,})/;
                this.subscriptionUrl = "";
                this.local = ContentLibraryConstants.LIBRARYTYPE_LOCAL;
                this.SYNC_IMMEDIATE = ContentLibraryConstants.SYNC_STRATEGY_IMMEDIATE;
                this.SYNC_ONDEMAND = ContentLibraryConstants.SYNC_STRATEGY_ONDEMAND;
                this.placeholderSubscription = "";
                //activity indicator
                this.loading = false;
                //privilege flags
                this.isLocalLibraryPrivilege = true;
                this.isPublishedLibraryPrivilege = true;
                this.isProbeSubscriptionPrivilege = true;
                /*Publish Library*/
                this.publishExternally = false;
                this.isAuthenticationEnabled = false;
                this.password = "";
                this.isPasswordValid = false;
                this.isStreamingOptimized = false;
                /*Subscribed library*/
                this.subscribed = ContentLibraryConstants.LIBRARYTYPE_SUBSCRIBED;
                this.sslThumbprint = "";
                this.isSubscribeAuthEnabled = false;
                this.subscribePassword = "";
                //default selections
                this.selectedLibraryType = this.local;
                this.syncStrategy = this.SYNC_IMMEDIATE;
                this.init = function () {
                    var rootFolderId = _this.defaultUriSchemeUtil
                        .getRootFolder(_this.$scope.wizardState.vcService.serviceGuid);
                    _this.authorizationService.checkPrivileges(rootFolderId, [
                        _this.CREATE_LOC_LIB_PRIVILEGE,
                        _this.CREATE_SUB_LIB_PRIVILEGE,
                        _this.PROBE_SUBSCRIPTION_PRIVILEGE])
                        .then(function (privileges) {
                        if (privileges && privileges.length === 3) {
                            _this.isLocalLibraryPrivilege = privileges[0];
                            _this.isPublishedLibraryPrivilege = privileges[1];
                            _this.isProbeSubscriptionPrivilege = privileges[2];
                        }
                        _this.$scope.vuiWizard.currentPage.disableNext = function () {
                            return _this.loading ||
                                _this.isLocalLibrarySelected() ?
                                !_this.isLocalLibraryValid() :
                                !_this.isSubscribedLibraryValid();
                        };
                        //Apply pre-set values, if any.
                        _this.selectedLibraryType = _this.$scope.wizardState.type;
                        if (_this.isLocalLibrarySelected()) {
                            _this.publishExternally = _this.$scope.wizardState.isPublished;
                            _this.isStreamingOptimized = _this.$scope.wizardState.isStreamingOptimized;
                            _this.isAuthenticationEnabled = _this.$scope.wizardState.isAuthenticationEnabled;
                            if (_this.isAuthenticationEnabled) {
                                _this.password = _this.$scope.wizardState.password;
                                _this.isPasswordValid = true;
                            }
                        }
                        else {
                            _this.subscriptionUrl = _this.$scope.wizardState.subscriptionUrl;
                            _this.isSubscribeAuthEnabled = _this.$scope.wizardState.isSubscriptionAuthenticated;
                            _this.syncStrategy = _this.$scope.wizardState.syncStrategy;
                            _this.subscribePassword = _this.$scope.wizardState.subscriptionPassword;
                        }
                        _this.$scope.vuiWizard.currentPage.onCommit = function () {
                            var self = _this;
                            //Privilege checks
                            if (_this.isLocalLibrarySelected()) {
                                if (!self.isLocalLibraryPrivilege) {
                                    _this.setBannerErrorMessage(_this.i18n('LibraryUi', 'error.noPrivileges.localLibrary'));
                                    return false;
                                }
                            }
                            else {
                                if (!self.isPublishedLibraryPrivilege) {
                                    _this.setBannerErrorMessage(_this.i18n('LibraryUi', 'error.noPrivileges.subscribedLibrary'));
                                    return false;
                                }
                                else if (!self.isProbeSubscriptionPrivilege) {
                                    _this.setBannerErrorMessage(_this.i18n('LibraryUi', 'error.noPrivileges.probeSubscription'));
                                    return false;
                                }
                            }
                            self.$scope.wizardState.type = _this.selectedLibraryType;
                            if (_this.selectedLibraryType === ContentLibraryConstants.LIBRARYTYPE_LOCAL) {
                                self.$scope.wizardState.isPublished = _this.publishExternally;
                                self.$scope.wizardState.isStreamingOptimized = _this.isStreamingOptimized;
                                self.$scope.wizardState.isAuthenticationEnabled = _this.isAuthenticationEnabled;
                                if (_this.isAuthenticationEnabled) {
                                    self.$scope.wizardState.password = _this.password;
                                }
                                self.$scope.vuiWizard.currentPage.state = self.vuiConstants.wizard.pageState.COMPLETED;
                                return true;
                            }
                            else {
                                _this.loading = true;
                                return _this.libraryService.validateSubscription(self.subscriptionUrl, self.sslThumbprint, self.subscribePassword)
                                    .then(function (result) {
                                    _this.loading = false;
                                    var errorMessage = '';
                                    var invalidCredentials = false;
                                    if (result.error) {
                                        errorMessage = result.error.localizedMessage;
                                        errorMessage = _this.translateErrorMessage(errorMessage);
                                    }
                                    if (result.result) {
                                        if (self.isSslThumbprintError(result.result)) {
                                            self.sslThumbprint = result.result.sslThumbprint;
                                            self.openSslThumbprintAlert(self.sslThumbprint);
                                            return false;
                                        }
                                        else if (result.result.errorMessages.length) {
                                            errorMessage = result.result.errorMessages[0].defaultMessage;
                                            if (result.result.status.name === "INVALID_CREDENTIALS") {
                                                self.isSubscribeAuthEnabled = true;
                                                invalidCredentials = true;
                                            }
                                        }
                                        else {
                                            self.$scope.wizardState.subscriptionUrl = self.subscriptionUrl;
                                            self.$scope.wizardState.syncStrategy = self.syncStrategy;
                                            self.$scope.wizardState.isSubscriptionAuthenticated = self.isSubscribeAuthEnabled;
                                            self.$scope.wizardState.subscriptionPassword = self.subscribePassword;
                                            self.$scope.vuiWizard.currentPage.state = self.vuiConstants.wizard.pageState.COMPLETED;
                                            return true;
                                        }
                                    }
                                    if (errorMessage) {
                                        self.$scope.wizardConfig.validationBanner.messages = [{
                                                text: errorMessage,
                                                type: invalidCredentials ?
                                                    self.vuiConstants.validationBanner.type.WARNING :
                                                    self.vuiConstants.validationBanner.type.ERROR
                                            }];
                                        self.$scope.wizardConfig.validationBanner.showAllMessages = true;
                                        return false;
                                    }
                                    return true;
                                });
                            }
                        };
                    });
                };
                this.i18n = i18nService.getString;
                this.$scope.vuiWizard.currentPage.state = this.vuiConstants.wizard.pageState.INCOMPLETE;
                this.placeholderSubscription = this.i18n("LibraryUi", "createLibraryWizard.configurePage.exampleSubscriptionURL");
                this.init();
            }
            CreateContentLibraryConfigureVapiController.prototype.isSubscribedLibraryValid = function () {
                var passwordReady = (this.isSubscribeAuthEnabled) ?
                    !!this.subscribePassword : true;
                return !!this.subscriptionUrl && passwordReady;
            };
            CreateContentLibraryConfigureVapiController.prototype.onPublishedChanged = function () {
                if (!this.publishExternally) {
                    this.isAuthenticationEnabled = false;
                }
            };
            CreateContentLibraryConfigureVapiController.prototype.isLocalLibrarySelected = function () {
                return this.selectedLibraryType === ContentLibraryConstants.LIBRARYTYPE_LOCAL;
            };
            CreateContentLibraryConfigureVapiController.prototype.isLocalLibraryValid = function () {
                return this.isAuthenticationEnabled ? this.getPasswordValid() : true;
            };
            CreateContentLibraryConfigureVapiController.prototype.getPasswordValid = function () {
                return this.isPasswordValid;
            };
            CreateContentLibraryConfigureVapiController.prototype.isSslThumbprintError = function (resultObj) {
                if (resultObj && resultObj.status && resultObj.status.enumValue) {
                    return (resultObj.status.enumValue === this.CERTIFICATE_ERROR_STATUS);
                }
                return false;
            };
            CreateContentLibraryConfigureVapiController.prototype.onPublishPasswordStatusChange = function (data) {
                this.isPasswordValid = data.isValid;
                this.password = data.password;
            };
            CreateContentLibraryConfigureVapiController.prototype.openSslThumbprintAlert = function (sslThumbprint) {
                var self = this;
                this.clarityModalService.openConfirmationModal({
                    title: this.i18n("LibraryUi", "sslDialog.securityAlertTitle", self.$scope.wizardState.name),
                    message: this.i18nService.getString("LibraryUi", "sslDialog.securityAlertText", sslThumbprint),
                    preserveNewlines: true,
                    saveButtonLabel: this.i18n("LibraryUi", "yes"),
                    clarityIcon: {
                        shape: "warning",
                        class: "is-warning",
                        size: 64
                    },
                    submit: function () {
                        self.$scope.wizardState.sslThumbprint = self.sslThumbprint;
                        self.$scope.wizardManager.onNextClick();
                        return true;
                    },
                    onCancel: function () {
                        self.sslThumbprint = "";
                    }
                });
            };
            CreateContentLibraryConfigureVapiController.prototype.setBannerErrorMessage = function (errorMsg) {
                if (errorMsg) {
                    this.$scope.wizardConfig.validationBanner.messages = [{
                            text: errorMsg,
                            type: this.vuiConstants.validationBanner.type.ERROR
                        }];
                    this.$scope.wizardConfig.validationBanner.showAllMessages = true;
                }
            };
            CreateContentLibraryConfigureVapiController.prototype.radioChanged = function () {
                this.$scope.wizardConfig.validationBanner.messages = [];
            };
            CreateContentLibraryConfigureVapiController.prototype.translateErrorMessage = function (message) {
                if (message) {
                    if (message.toLowerCase().indexOf("unknown protocol") > -1) {
                        return this.i18nService
                            .getString("LibraryUi", "h5.probe.subscription.url.unknownProtocol");
                    }
                    else if (message.toLowerCase().indexOf("no protocol") > -1) {
                        return this.i18nService
                            .getString("LibraryUi", "h5.probe.subscription.url.noProtocol");
                    }
                }
                return message;
            };
            CreateContentLibraryConfigureVapiController.$inject = ['$scope', 'i18nService',
                'libraryService', 'vuiConstants', 'clarityModalService', 'authorizationService', 'defaultUriSchemeUtil'];
            return CreateContentLibraryConfigureVapiController;
        }());
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("createContentLibraryConfigureVapiController", CreateContentLibraryConfigureVapiController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var AddEditCustomAttributeController = (function () {
            function AddEditCustomAttributeController($scope, $rootScope, i18nService, associableObjectTypesService, customAttributesService) {
                var _this = this;
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.i18nService = i18nService;
                this.associableObjectTypesService = associableObjectTypesService;
                this.customAttributesService = customAttributesService;
                this.isInEditMode = false;
                this.closeModal = function () {
                    _this.$scope.closeModal();
                };
                this.okButtonDisabled = function () {
                    return !_this.attributeState.attribute;
                };
                this.submit = function () {
                    if (_this.isInEditMode) {
                        _this.customAttributesService.renameCustomAttribute(_this.attributeState).then(function () {
                            _this.$rootScope.$broadcast('refreshCustomAttributes');
                            _this.closeModal();
                        });
                    }
                    else {
                        _this.customAttributesService.addCustomAttribute(_this.attributeState, _this.selectedType).then(function () {
                            _this.$rootScope.$broadcast('refreshCustomAttributes');
                            _this.closeModal();
                        });
                    }
                };
                var self = this;
                self.i18n = i18nService.getString;
                self.attributeState = $scope.modalOptions.dialogData.customAttributeState;
                if (self.attributeState && self.attributeState.attribute) {
                    self.isInEditMode = true;
                }
                else {
                    self.attributeState = { attribute: '' };
                }
                if (self.isInEditMode) {
                    self.selectedType = self.attributeState.typeFormatted;
                }
                else {
                    self.associableObjectTypes = associableObjectTypesService.getTypeDataForAttributes();
                    self.associableObjectTypes.global = {
                        associableTypeString: 'global',
                        displayName: 'global'
                    };
                    for (var _i = 0, _a = Object.keys(self.associableObjectTypes); _i < _a.length; _i++) {
                        var key = _a[_i];
                        self.associableObjectTypes[key].i18nString =
                            self.i18n('Common', 'fieldType.' + self.associableObjectTypes[key].associableTypeString);
                    }
                    self.selectedType = self.associableObjectTypes.global;
                }
            }
            AddEditCustomAttributeController.$inject = ['$scope', '$rootScope', 'i18nService', 'associableObjectTypesService', 'customAttributesService'];
            return AddEditCustomAttributeController;
        }());
        angular.module('com.vmware.vsphere.client.commonModule')
            .controller('addEditCustomAttributeController', AddEditCustomAttributeController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('CustomAttributesController', CustomAttributesController);

   CustomAttributesController.$inject = ['i18nService', 'vuiConstants', 'customAttributesService', '$scope', 'customAttributesActionService'];

   function CustomAttributesController(i18nService, vuiConstants, customAttributesService, $scope, customAttributesActionService) {
      var self = this;

      function refreshCustomAttributes() {
         customAttributesService.getAllCustomAttributes().then(function(customAttributesData) {
            self.datagridOptions.data = customAttributesData;
         });
      }

      function deleteCustomAttribute() {
         customAttributesActionService.deleteCustomAttribute(self.datagridOptions.selectedItems[0]);
      }

      function editCustomAttribute() {
         customAttributesActionService.editCustomAttribute(self.datagridOptions.selectedItems[0], i18nService.getString('CommonModuleUi', 'edit.attribute'));
      }

      function addCustomAttribute() {
         customAttributesActionService.editCustomAttribute(null, i18nService.getString('Common', 'editCustomFieldDefinitionView.add.title'));
      }

      var deleteAction = {
         id: 'delete-custom-action',
         iconClass: 'vsphere-icon-toolbar-remove',
         tooltipText: i18nService.getString('Common', 'ca.delete.delete'),
         enabled: false,
         onClick: deleteCustomAttribute
      };
      var editAction = {
         id: 'edit-tag-action',
         iconClass: 'vsphere-icon-toolbar-edit',
         tooltipText: i18nService.getString('CommonModuleUi', 'edit.attribute'),
         enabled: true,
         onClick : editCustomAttribute
      };

      var addAction = {
         id: 'add-tag-action',
         iconClass: 'vsphere-icon-toolbar-add',
         tooltipText: i18nService.getString('CommonModuleUi', 'add.attribute'),
         enabled: true,
         onClick : addCustomAttribute
      };

      self.datagridOptions = {
         actionBarOptions: {
            actions: [
               addAction,
               editAction,
               deleteAction
            ]
         },
         columnDefs: [
            {
               displayName: i18nService.getString('Common', 'attributesName'),
               field: 'attribute',
               sortable: true,
               searchable: false
            },
            {
               displayName: i18nService.getString('Common', 'attributesGrid.typeColumnHeaderText'),
               field: 'type',
               sortable: true,
               searchable: false,
               template: function(dataItem) {
                  return i18nService.getString('Common', 'fieldType.' + dataItem.type);
               }
            },
            {
               displayName: i18nService.getString('Common', 'ca.values.key'),
               field: 'key',
               visible: false
            }
         ],
         sortOrder: [{
            field: 'attribute',
            dir: 'asc'
         }],
         height: '100%',
         resizable: false,
         reorderable: true,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         data: []
      };

      $scope.$watch('ctrl.datagridOptions.selectedItems', function(selectedItems) {
         var selected = selectedItems && selectedItems.length;
         deleteAction.enabled = selected;
         editAction.enabled = selected;
      });

      $scope.$on('refreshCustomAttributes', function(){
         refreshCustomAttributes();
      });

      refreshCustomAttributes();
   }
}());

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('CustomAttributesPortletController', CustomAttributesPortletController);

   CustomAttributesPortletController.$inject = ['$scope', 'customAttributesService', 'i18nService', 'actionsService'];

   function CustomAttributesPortletController($scope, customAttributesService, i18nService, actionsService) {
      var self = this;
      var objectId = $scope._route.objectId;
      self.objectId = objectId;
      self.liveRefreshProperties = [
         'availableField',
         'customValue'
      ];
      self.datagridOptions = {
         columnDefs: [
            {
               displayName: i18nService.getString('Common','attributesName'),
               field: 'attribute',
               sortable: false,
               searchable: false
            },
            {
               displayName: i18nService.getString('Common','ca.values.value'),
               field: 'value',
               sortable: false,
               searchable: false
            }
         ],
         height: '200px',
         resizable: false,
         reorderable: false
      };

      var context = {
         summaryViewCustomAttributeDatagridOptions: self.datagridOptions
      };

      actionsService.getAction("vsphere.core.actions.editCustomAttributesAction", [objectId])
         .then(function (action) {
            var linkEnabled = (action && action.available) ? true : false;

            $scope.portlet.footerLinks = [{
               label: i18nService.getString('Common','action.editCustomAttributes.label'),
               ariaLabel: i18nService.getString('Common','action.editCustomAttributes.description'),
               onClick: function () {
                  actionsService.invokeAction(action, context);
               },
               enabled: linkEnabled
            }];
         });

      self.refresh = function() {
         customAttributesService.getCustomAttributes(objectId).then(function(customAttributes) {
            self.datagridOptions.data = customAttributes;
         });
      };

      self.refresh();
   }
}());

(function() {
    'use strict';
    angular
        .module('com.vmware.vsphere.client.commonModule')
        .controller('EditCustomAttributesDialogController', EditCustomAttributesDialogController);

    EditCustomAttributesDialogController.$inject = [
        '$scope',
        'customAttributesService',
        'i18nService',
        'defaultUriSchemeUtil',
        'vuiConstants'
    ];

    function EditCustomAttributesDialogController($scope, customAttributesService, i18nService, defaultUriSchemeUtil, vuiConstants) {
        var self = this;
        self.FOLDER_MAX_LENGTH = 80;
        var objectId = $scope.modalOptions.availableTargets[0];
        var modifiedAttributes = [];
        var entityMor = defaultUriSchemeUtil.getManagedObjectReference(objectId);
        self.addAttribute = addAttribute;
        self.deleteCustomAttribute = deleteCustomAttribute;
        self.saveModifiedCustomAttributes = saveModifiedCustomAttributes;

        resetAddAttributeForm();
        self.attributeTypeOptions = [
            {
                label: i18nService.getString('Common', 'fieldType.global'),
                value: 'global'
            },
            {
                label: i18nService.getString('Common', 'fieldType.' + entityMor.type),
                value:  entityMor.type
            }
        ];

        self.datagridOptions = {
            actionBarOptions: {
                actions: [{
                    id: 'deleteCustomAttributeAction',
                    enabled: false,
                    tooltipText: i18nService.getString('Common', 'ca.delete.delete'),
                    iconClass: 'vsphere-icon-toolbar-remove',
                    onClick: self.deleteCustomAttribute
                }]
            },
            columnDefs: [
                {
                    displayName: i18nService.getString('Common', 'ca.values.attribute'),
                    field: 'attribute',
                    sortable: false,
                    searchable: false,
                    editable: {
                        validator: {
                            required: true,
                            uniqueAttribute: function(input) {
                                var hasValidLength = input.val().length < self.FOLDER_MAX_LENGTH;
                                if (!hasValidLength) {
                                    input.attr("data-uniqueAttribute-msg", "The name is too long");
                                    return false;
                                }
                                var attributeNames = input.parents('table').find('[ng-bind="dataItem.attribute"]').map(function(i, td) {
                                    return $(td).html();
                                });
                                input.attr("data-uniqueAttribute-msg", "Attribute is not unique");
                                return !_.contains(attributeNames, input.val());
                            }
                        }
                    }
                },
                {
                    displayName: i18nService.getString('Common', 'ca.values.key'),
                    field: 'key',
                    visible: false
                },
                {
                    displayName: i18nService.getString('Common', 'ca.values.value'),
                    field: 'value',
                    sortable: false,
                    searchable: false,
                    editable: {
                        validator: {
                            uniqueAttribute: function(input) {
                                var hasValidLength = input.val().length < self.FOLDER_MAX_LENGTH;

                                if (!hasValidLength) {
                                    input.attr("maxlength", self.FOLDER_MAX_LENGTH);
                                    input.attr("data-uniqueAttribute-msg", "The value is too long");
                                    input.val(input.val().substring(0, self.FOLDER_MAX_LENGTH));
                                    return false;
                                }

                                return true;
                            }
                        }
                    }
                },
                {
                    displayName: i18nService.getString('Common', 'ca.values.type'),
                    field: 'typeLabel',
                    sortable: false,
                    searchable: false,
                    editable: false
                }
            ],
            height: '200px',
            resizable: false,
            reorderable: false,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            editable: true,
            selectedItems: [],
            save: updateModifiedAttributes
        };

        $scope.$watch('editCtrl.datagridOptions.selectedItems', function(selectedItems) {
            self.datagridOptions.actionBarOptions.actions[0].enabled = (selectedItems.length > 0);
        });

        customAttributesService.getCustomAttributes(objectId).then(function(customAttributes) {
            self.datagridOptions.data = customAttributes;
        });

        self.newAttributeErrorConfig = {
            message: '',
            isVisible: function(inputElement) {
                if (inputElement.$error.duplicateAttributeError) {
                    this.message = i18nService.getString('Common', 'ca.error.duplicate');
                    return true;
                }
                if (inputElement.$error.emptyAttributeError) {
                    this.message = i18nService.getString('Common', 'ca.error.empty');
                    return true;
                }
                if (inputElement.$error.maxLengthError) {
                    this.message = i18nService.getString('Common', 'ca.error.length');
                    return true;
                }

                return false;
            }
        };

        function updateModifiedAttributes(saveData) {
            var newModifiedAttribute = angular.extend({}, saveData.model, saveData.values);
            newModifiedAttribute.operationId = saveData.values.value ? 'EDIT' : 'RENAME';
            // Add operations are ignored until final "Ok" button is clicked
            // key is undefined for newly added attributes
            if (saveData.model.key) {
                modifiedAttributes.push(newModifiedAttribute);
            }
        }

        function saveModifiedCustomAttributes() {
            //getting the newly added attributes
            var newAttributes = self.datagridOptions.dataSource.view().filter(function(o) {
                return !o.key;
            });

            var allAttributesToBeSaved = modifiedAttributes.concat(newAttributes);
            if (allAttributesToBeSaved.length > 0) {
                customAttributesService.modifyCustomAttributes(objectId, allAttributesToBeSaved).then(function(response) {
                    if (!response.error) {
                        updateSummaryViewDatagrid();
                        self.closeModal();
                    }
                });
            }
        }


        self.closeModal = function() {
            $scope.closeModal();
        };

        function resetAddAttributeForm() {
            $scope.attribute = '';
            $scope.value = '';
            $scope.type = entityMor.type;
        }

        function deleteCustomAttribute() {
            var dialogData = self.datagridOptions.dataSource.view().filter(function(data) {
                return self.datagridOptions.selectedItems[0].attribute !== data.attribute;
            });
            self.datagridOptions.data = dialogData;

            if (self.datagridOptions.selectedItems[0].key) {
                self.datagridOptions.selectedItems[0].operationId = 'REMOVE';
                modifiedAttributes.push(self.datagridOptions.selectedItems[0]);
            }
        }

        function addAttribute(attributeName, attributeValue, attributeType) {
            if (_.isUndefined(attributeName) || _.isNull(attributeName) || _.isEmpty(attributeName.trim())) {
                setPopulatedValidityOnAttributeInputField(false);
                return;
            }
            var hasValidLength = attributeName.length < self.FOLDER_MAX_LENGTH;
            if (!hasValidLength) {
                setMaxLengthValidityOnAttributeInputField(false);
                return;
            }

            var valueHasValidLength = attributeValue.length < self.FOLDER_MAX_LENGTH;
            if (!valueHasValidLength) {
                setMaxLengthValidityOnValueInputField(false);
                return;
            }

            var newAttribute = {
                attribute: attributeName,
                value: attributeValue,
                type: attributeType,
                typeLabel: i18nService.getString('Common', 'fieldType.' + attributeType),
                operationId: 'ADD'
            };
            addToDialogDatagrid(newAttribute);
        }

        function updateSummaryViewDatagrid() {
            refreshWithUpdatedData();
        }

        function addToDialogDatagrid(attributeToAdd) {
            var dialogData = [];
            angular.copy(self.datagridOptions.dataSource.view(), dialogData);

            if (isAttributeDuplicate(attributeToAdd.attribute)) {
                setUniquenessValidityOnAttributeInputField(false);
                return;
            }

            dialogData.splice(0, 0, attributeToAdd);
            self.datagridOptions.data = dialogData;
            resetAddAttributeForm();
            setUniquenessValidityOnAttributeInputField(true);
        }

        function refreshWithUpdatedData() {
            _.forEach(modifiedAttributes, function(modifiedAttribute) {
                _.forEach(self.datagridOptions.data, function(currentAttribute) {
                    if (modifiedAttribute.key && modifiedAttribute.key === currentAttribute.key) {
                        currentAttribute.value = modifiedAttribute.value;
                        currentAttribute.attribute = modifiedAttribute.attribute;
                    }
                });
            });
        }

        function isAttributeDuplicate(attributeName) {
            var foundElement = _.find(self.datagridOptions.dataSource.view(), function(item) {
                return (item.attribute === attributeName);
            });
            return (foundElement !== undefined) ? true : false;
        }

        function setUniquenessValidityOnAttributeInputField(validity) {
            if (self.addForm) {
                self.addForm.newCustomAttributeName.$setValidity("duplicateAttributeError", validity);
                self.newAttributeErrorConfig.isVisible(self.addForm.newCustomAttributeName);
            }
        }

        function setPopulatedValidityOnAttributeInputField(validity) {
            if (self.addForm) {
                self.addForm.newCustomAttributeName.$setValidity("emptyAttributeError", validity);
                self.newAttributeErrorConfig.isVisible(self.addForm.newCustomAttributeName);
            }
        }

        function setMaxLengthValidityOnAttributeInputField(validity) {
            if (self.addForm) {
                self.addForm.newCustomAttributeName.$setValidity("maxLengthError", validity);
                self.newAttributeErrorConfig.isVisible(self.addForm.newCustomAttributeName);
            }
        }

        function setMaxLengthValidityOnValueInputField(validity) {
            if (self.addForm) {
                self.addForm.newCustomAttributeValue.$setValidity("maxLengthError", validity);
                self.newAttributeErrorConfig.isVisible(self.addForm.newCustomAttributeValue);
            }
        }
    }
}());

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Controller for the 'Edit notes' action.
 */
angular.module('com.vmware.vsphere.client.commonModule')
      .controller('NotesController',
            ['$scope', 'dataService', 'actionsService', 'i18nService',
     function($scope, dataService, actionsService, i18nService) {
   var self = this;
   var objectId = $scope._route.objectId;
   var notesPropName, editNotesActionId;
   var liveRefreshProperties = [];
   if ($scope.portlet._view.contentSpec.metadata) {
      notesPropName = $scope.portlet._view.contentSpec.metadata.notesPropName;
      editNotesActionId = $scope.portlet._view.contentSpec.metadata.editNotesActionId;
      liveRefreshProperties.push(notesPropName);
   }

   self.watchForObjects = [objectId];
   self.getNotes = getNotes;
   self.liveRefreshProperties = liveRefreshProperties;

   function getNotes() {
      if (!notesPropName) {
         throw new Error("Unknown notes property name");
      }

      dataService
         .getProperties(objectId, [notesPropName])
         .then(function(data) {
            self.notes = data[notesPropName];
         });
   }

   /**
    * Create a footer link in portlet for the 'edit notes' action.
    */
   function createLink() {
      if (!editNotesActionId) {
         return;
      }

      // TODO this is a work-around to avoid an ActionServiceController exception when using actionService.getAction
      // (case where the EditNotes action is being evaluated and filtered out at the same time)
      actionsService.getActions([$scope._route.objectId], [editNotesActionId]
            ).then(function(res) {
               if (res) {
                  createFooterLink(res);
               }
            });
   }

   function createFooterLink(actionDataArray) {
      var linkLabel = i18nService.getString('CommonModuleUi', 'notes.editLabel');
      var enabled = actionDataArray && actionDataArray.length > 0 && actionDataArray[0].available;

      $scope.portlet.footerLinks = [{
         enabled: enabled,
         label: linkLabel,
         onClick: function($event) {
            var target = $event.currentTarget;
            actionsService.invokeAction(actionDataArray[0], {focusTarget: target});
         }
      }];
   }

   getNotes();
   createLink();
}]);

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Controller for the edit notes action.
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
          .controller('NotesDialogController', NotesDialogController);

   NotesDialogController.$inject = ['$scope', 'dataService'];

   function NotesDialogController($scope, dataService) {
      var self = this;
      self.loading = true;

      var objectId = $scope.modalOptions.availableTargets[0];
      var notesPropName = $scope.modalOptions.dialogData.notesPropName;
      var additionalPropForEdit = $scope.modalOptions.dialogData.additionalPropForEdit;
      var onUpdateNotesCallback =
         $scope.modalOptions.dialogData.onUpdateNotesCallback;
      var additionalPropForEditValue;

      var propsToRequest = [notesPropName, 'name'];
      if (additionalPropForEdit) {
         propsToRequest.push(additionalPropForEdit);
      }
      dataService.getProperties(objectId, propsToRequest).then(
         function(data) {
            self.notes = data[notesPropName];
            self.name = data.name;
            self.loading = false;
            if (additionalPropForEdit) {
               additionalPropForEditValue = data[additionalPropForEdit];
            }
         }
      );


      var operationName = $scope.modalOptions.title;

      self.closeModal = function() {
         $scope.closeModal();
      };

      self.save = function() {
         self.closeModal();
         var notesValue = self.notes;

         return onUpdateNotesCallback(objectId, notesValue, operationName, additionalPropForEditValue);
      };
   }
})();

(function() {
      'use strict';
      angular.module('com.vmware.vsphere.client.commonModule')
         .controller('AddPermissionDialogController', AddPermissionDialogController);

      AddPermissionDialogController.$inject = [
         '$scope',
         'PermissionDataService',
         'defaultUriSchemeUtil',
         'dataService'
      ];

      function AddPermissionDialogController ($scope, permissionDataService, defaultUriSchemeUtil, dataService) {
         var self = this;

         self.selectedRole = null;
         self.selectedUserGroup = null;
         self.domainList = null;
         self.propagateToChildren = false;
         self.selectedDomainForPermission = null;
         self.selectedUserForPermission = null;
         self.userGroupListLoading = false;

         $scope.$watch(function() {
            return self.selectedDomain;
         }, function() {
             self.selectedUserGroup = null;
         });

         function init () {
            self.objectIds = $scope.modalOptions.availableTargets;
            if($scope.modalOptions.dialogData.selectedPermission) {
               self.selectedPermission = $scope.modalOptions.dialogData.selectedPermission;
               if(self.selectedPermission.principal) {
                  var domainUser = self.selectedPermission.principal.split('\\');
                  if(domainUser.length >= 2) {
                     self.selectedDomainForPermission = domainUser[0];
                     self.selectedUserForPermission = domainUser[1];
                  }
               }
               self.propagateToChildren = $scope.modalOptions.dialogData.selectedPermission.propagateToChildren;
            }
            self.getDomainList().then(function() {
               self.selectedDomain = self.domainList[0];
            });
            self.getUserRoles().then(function() {
               self.selectedRole = self.userRolesList[0];
               if($scope.modalOptions.dialogData.edit) {
                  var role = self.userRolesList.filter(function(userRole) {
                     return userRole.id === self.selectedPermission.roleId;
                  });
                  if(role.length > 0) {
                     self.selectedRole = role[0];
                  }
               }
            });

            self.getParentObjectReference();
         }

         self.getUserRoles = function() {
            return permissionDataService.getRolesInfo(self.objectIds[0]).then(function(rolesInfo) {
               self.userRolesList = rolesInfo;
            });
         };

         self.getParentObjectReference = function() {
            return dataService.getPropertiesForObjects(self.objectIds, ['parent']).then(function(result) {
               self.parentObjects = {};
               _.each(result, function(parentInfo, objId) {
                  self.parentObjects[objId] = parentInfo.parent;
               });
            });
         };

         self.onAddPermissionButtonClicked = function() {
            addPermissions();
            $scope.closeModal();
         };

         self.onCancelButtonClicked = function() {
            $scope.closeModal();
         };

         self.getDomainList  = function() {
           return permissionDataService.getDomains().then(function(domains) {
              self.domainList = domains;
           });
         };

         self.getUserGroupsList = function(searchString) {
            self.userGroupListLoading = true;
            searchString = searchString || "";
            return permissionDataService.getUserGroups(self.objectIds[0], self.selectedDomain.name, searchString).then(function(userGroupData) {
               self.userGroupListLoading = false;
               return userGroupData['vsphere:userGroups'].map(function(userGroupDataItem) {
                  return {
                     name: userGroupDataItem.principal,
                     description: userGroupDataItem.fullName,
                     group: userGroupDataItem.group
                  };
               });
            });
         };

         function addPermissions () {
            _.each(self.objectIds, function(entityId) {
               if(self.parentObjects && self.parentObjects[entityId]
                     && self.parentObjects[entityId].type === "ComputeResource") {
                  entityId = defaultUriSchemeUtil.getVsphereObjectId(self.parentObjects[entityId]);
               }
               if($scope.modalOptions.dialogData.edit) {
                  var permission = [{
                     roleId: self.selectedRole.id,
                     propagate: self.propagateToChildren,
                     id: self.selectedPermission.permissionId,
                     principal: self.selectedPermission.principal,
                     group: self.selectedPermission.isGroup
                  }];
                  permissionDataService.editUserGroupPermissions(entityId, permission);
               } else {
                  var permissionsList = [self.selectedUserGroup].map(function(dataItem) {
                     return {
                        principal: [self.selectedDomain.name, dataItem.name].join("\\"),
                        group: dataItem.group,
                        roleId: self.selectedRole.id,
                        propagate: self.propagateToChildren
                     };
                  });
                  permissionDataService.saveUserGroupPermissions(entityId, permissionsList);
               }
            });
         }

         init();
      }
   }()
);

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .service('PermissionDataService', PermissionDataService);

   PermissionDataService.$inject = ['dataService', 'mutationService', 'objectTypesService', '$q', 'defaultUriSchemeUtil'];

   function PermissionDataService (dataService, mutationService, objectTypesService, $q, defaultUriSchemeUtil) {

      return {
         getName: getName,
         getRolesInfo: getRolesInfo,
         getUserGroups: getUserGroups,
         getDomains: getDomains,
         saveUserGroupPermissions: saveUserGroupPermissions,
         getEntityPermissions: getEntityPermissions,
         removeUserGroupPermissions: removeUserGroupPermissions,
         editUserGroupPermissions: editUserGroupPermissions
      };

      function getName (vsphereObjectId) {
         return dataService.getProperties(vsphereObjectId, ['name']).then(function(data) {
            return data.name;
         });
      }

      function getRolesInfo (vsphereObjectId) {
         return dataService.getProperties(vsphereObjectId, ["rolesInfo"]).then(function(data) {
            return data.rolesInfo;
         });
      }

      function getDomains () {
         return dataService.getProperties('urn:vri:sso:UserDirectory', ['vsphere:domainList']).then(function(data) {
            return _.map(data["vsphere:domainList"], function(dataItem) {
               return {
                  name: dataItem.name,
                  label: dataItem.label
               };
            });
         });
      }

      function getUserGroups (vsphereObjectId, domain, searchString) {
         var paramSpec = {
            propertyName: "vsphere:userGroups",
            parameterType: "com.vmware.vise.vim.users.UserDirectorySpec",
            parameter: {
               domain: domain,
               searchString: searchString || "",
               exactMatch: false,
               findUsers: true,
               findGroups: true
            }
         };

         return dataService.getProperties(vsphereObjectId, ['vsphere:userGroups'], {
            propertyParams: [paramSpec]
         });
      }

      function saveUserGroupPermissions (entityId, permissionsList) {
         return mutationService.apply(
            entityId,
            "com.vmware.vise.vim.security.data.UpdatePermissionsSpec",
            { permissions: permissionsList },
            "Add permission"
         );
      }

      function editUserGroupPermissions (entityId, permissions) {
         return mutationService.apply(
            entityId,
            "com.vmware.vise.vim.security.data.UpdatePermissionsSpec",
            { permissions: permissions },
            "Edit permission"
         );
      }

      function removeUserGroupPermissions (entityId, permissions) {
         permissions.id = permissions.permissionId;
         permissions.group = permissions.isGroup;
         return mutationService.apply(
               entityId,
               "com.vmware.vise.vim.security.data.RemovePermissionSpec",
               { permission: permissions },
               "Remove permission"
         );
      }

      function getPermissionViewData (objectId) {
         return dataService.getProperties(objectId, ['permissionViewData']).then(function(data) {
            return $q.all(_.map(data.permissionViewData, function(dataItem) {
               var deferred = $q.defer();
               if (!dataItem.entityType) {
                  deferred.resolve(dataItem);
               } else {
                  objectTypesService.getObjectTypeSpec(dataItem.entityType).then(function(iconObject) {
                     if (dataItem.isRootFolder) {
                        dataItem.icon = 'vsphere-icon-vcenter';
                     } else {
                        dataItem.icon = iconObject.icon;
                     }
                     deferred.resolve(dataItem);
                  }, function(err) {
                     deferred.reject(err);
                  });
               }
               return deferred.promise;
            }));
         });
      }

      function getEntityPermissions(objectId) {
         return getPermissionViewData(objectId);
      }
   }
}());

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Controller for the permission view.
 */
(function() {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.commonModule')
         .controller('PermissionViewController', PermissionViewController);

   PermissionViewController.$inject = ['$scope', '$q', 'i18nService', 'PermissionDataService',
      'columnRenderersRegistry', 'vuiConstants', 'actionsService', 'clarityModalService',
      'userPrivilegeService'];

   function PermissionViewController($scope, $q, i18nService, PermissionDataService,
         columnRenderersRegistry, vuiConstants, actionsService, clarityModalService,
      userPrivilegeService) {

      var self = this;
      var objectId = $scope._route.objectId ||  $scope._vxViewNodeData.node.contentSpec.metadata.objectId;
      var i18n = i18nService.getString.bind(i18nService, 'Common');
      var targetNameRenderer =
         columnRenderersRegistry.getColumnRenderer('object-name');

      self.watchForObjects = [objectId];
      self.havePrivilege = false;
      //Set column definitions
      self.datagridOptions = {
         columnDefs: [{
            displayName: i18n('PermissionView.userGroupName'),
            field: 'principal',
            width: '40%',
            template: function(dataItem) {
               var value = dataItem.principal;
               var principalIcon;
               var principalIconAriaLabel;
               if (dataItem.isGroup) {
                  principalIcon = 'icon-vSphere-group';
                  principalIconAriaLabel = i18n("PermissionView.group");
               } else {
                  principalIcon = 'icon-vSphere-user';
                  principalIconAriaLabel = i18n("PermissionView.user");
               }
               return '<div>' +
                        '<i class="' + principalIcon + '" aria-label="' + _.escape(principalIconAriaLabel) + '"></i>' +
                        '<span' +
                        ' title="' + _.escape(value) + '">' +
                        _.escape(value) + '</span>' +
                      '</div>';
            }
         }, {
            displayName: i18n('PermissionView.role'),
            field: 'role',
            width: '30%',
            template: function(dataItem) {
               return '<span>' + dataItem.role + '</span>';
            }
         }, {
            displayName: i18n('PermissionView.defined'),
            width: '30%',
            field: 'entityId',
            searchable: false,
            template: function(dataItem) {
               return getDefinedIn(dataItem);
            }
         }],
         data: [],
         sortOrder: [{
            field: 'principal',
            dir: 'asc'
         }],
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         height: '100%',
         resizable: true,
         actionBarOptions: {
            actions: [
               {
                  id: 'add-permission-action',
                  iconClass: 'vsphere-icon-toolbar-add',
                  tooltipText: i18n('permissionAction.add.label'),
                  enabled: self.havePrivilege,
                  onClick : addPermission
               }, {
                  id: 'edit-permission-action',
                  iconClass: 'vsphere-icon-toolbar-edit',
                  tooltipText: i18n('permissionAction.edit.label'),
                  enabled: false,
                  onClick: editPermission
               }, {
                  id: 'delete-permission-action',
                  iconClass: 'vsphere-icon-toolbar-remove',
                  tooltipText: i18n('permissionAction.remove.label'),
                  enabled: self.havePrivilege,
                  onClick : removePermission
               }
            ]
         }
      };

      $scope.$watch(function() {
         return self.datagridOptions.selectedItems;
      }, function(selectedItems) {

         self.datagridOptions.actionBarOptions.actions[0].enabled=false;
         self.datagridOptions.actionBarOptions.actions[1].enabled=false;
         self.datagridOptions.actionBarOptions.actions[2].enabled=false;

         if (self.havePrivilege) {
            self.datagridOptions.actionBarOptions.actions[0].enabled=true;
            if (!_.isEmpty(selectedItems)) {
               self.datagridOptions.actionBarOptions.actions[1].enabled = true;
               if ((selectedItems[0].isDefinedOnCurrentObject ||
                     (objectId === 'urn:vri:acl:RootPermissionNode:root' && selectedItems[0].isGlobal))) {
                  self.datagridOptions.actionBarOptions.actions[2].enabled = true;
               }
            }
         }
      });

      // Determines the content of "Defined In" column
      function getDefinedIn(dataItem) {
         if (dataItem.isGlobal) {
            return '<span>' + i18n('globalPermission') + '</span>';
         }

         if (dataItem.isDefinedOnCurrentObject) {
            var result = dataItem.propagateToChildren ?
                  'permissionView.thisEntity.propagate' : 'PermissionView.thisEntity';
            return '<span>' + i18n(result) + '</span>';
         }
         return targetNameRenderer(['entityId', 'icon', 'entityName'], dataItem);
      }

      function addPermission(){
         return h5.actions['vsphere.core.inventory.actions.addPermission'](
            {
                action: {
                   label: i18n('permissionAction.add.label')
                }
            }, [objectId], {edit: false} );
      }

      function editPermission(){
         return h5.actions['vsphere.core.inventory.actions.addPermission'](
            {
               action: {
                  label: i18n('permissionAction.edit.dialog.title')
               }
            }, [objectId], {edit: true, selectedPermission: JSON.parse(JSON.stringify(self.datagridOptions.selectedItems[0]))});
      }

      function removePermission() {
         var confirmProperties = {
            title: i18nService.getString('Common', 'permissionAction.remove.dialog.title'),
            message: i18nService.getString('Common', 'permissionAction.remove.warning'),
             icon: 'icon-warning-32',
             defaultButton: 'close',
            submit: function () {
               PermissionDataService.removeUserGroupPermissions(objectId, self.datagridOptions.selectedItems[0].toJSON());
            }
         };
         clarityModalService.openConfirmationModal(confirmProperties);
      }


      self.fetchPermissions = function() {
         if (!objectId) {
            objectId = $scope._vxViewNodeData.node.contentSpec.metadata.objectId;
         }
         var privilegesRequest = userPrivilegeService.getUserPrivileges(objectId);
         var permissionViewDataRequest = PermissionDataService.getEntityPermissions(objectId);

         $q.all([privilegesRequest, permissionViewDataRequest]).then(function(responses) {
            var privileges = responses[0];
            var viewData = responses[1];
            self.havePrivilege = privileges.grantedPrivileges &&
                  privileges.grantedPrivileges.indexOf('Authorization.ModifyPermissions') >= 0;
            self.datagridOptions.data = viewData;
         });
      };

      self.showActionsMenu = function(event) {
         var left =  event.clientX;
         var top = event.clientY;
         var selectedObjectIds = event.data;
         actionsService.showObjectContextMenu(event, $scope, selectedObjectIds, left, top);
      };

      self.fetchPermissions();
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .factory('privilegeTreeDataPresenter', privilegeTreeDataPresenter);

   function privilegeTreeDataPresenter() {
      return {
         formatData: formatData
      };

      function formatData(properties, privilegeData) {
         var treeData = new TreeData(properties, privilegeData);
         return treeData.formatPrivilegeData();
      }
   }

   function TreeData(properties, privilegeData) {
      this._nodesByName = {};
      this._roots = [];
      this._properties = properties;
      this._privilegeData = privilegeData;

      this.formatPrivilegeData = function() {
         _.forEach(this.filterOutSystemPrivileges(), function(privilegeDataItem) {
            this.placeInTree(privilegeDataItem.group.split('.'), privilegeDataItem.name, this._properties);
         }, this);

         return this.getData();
      };

      this.filterOutSystemPrivileges = function() {
         return _.filter(this._privilegeData, function(privilegeDataItem) {
            return !_.contains(['System.Read', 'System.View', 'System.Anonymous'], privilegeDataItem.name);
         });
      };

      this.getItem = function(itemName) {
         return this._nodesByName[itemName];
      };

      this.placeInTree = function(parentPath, childName) {
         var treeItem = this.getItem(childName);
         if (treeItem) {
            return treeItem;
         }

         if (parentPath.length === 0) {
            return this.addRoot(childName);
         }

         var parentNode = this.placeInTree(parentPath.slice(0, parentPath.length - 1), parentPath.join('.'));
         return this.addChild(parentNode, childName);
      };

      this.addRoot = function(rootName) {
         var item = this.buildTreeItem(rootName);
         this._nodesByName[rootName] = item;
         this._roots.push(item);
         this._roots = _.sortBy(this._roots, sortByLowerCaseLabel);
         return item;
      };

      this.addChild = function(parentNode, childName) {
         var item = this.buildTreeItem(childName);
         this._nodesByName[childName] = item;
         parentNode.items.push(item);
         parentNode.items = _.sortBy(parentNode.items, sortByLowerCaseLabel);
         return item;
      };

      this.getData = function() {
         return [{
            label: 'All Privileges',
            expanded: true,
            items: this._roots
         }];
      };

      this.buildTreeItem = function(itemName) {
         return {
            label: this._properties["privilege." + itemName + ".label"],
            items: [],
            privilegeId: itemName
         };
      };

      function sortByLowerCaseLabel(item) {
         return item.label.toLowerCase();
      }
   }
}());

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Controller for Related Objects Portlet.
 *
 */
angular.module('com.vmware.vsphere.client.commonModule')
      .controller('RelatedItemsPortletController',
      ['$scope', 'relatedItemsService',
      function($scope, relatedItemsService) {
   'use strict';

   var self = this;
   var id = $scope._route.objectId;
   if (id === 'undefined' || id === null) {
      // Get the different object type if specified
      id = $scope._view.contentSpec.metadata.objectId;
   }

   self.watchForObjects = [id];

   self.getData = function() {
      var promise = relatedItemsService.getRelatedItems(id);
      promise.then(function (data) {
         self.stackViewData = data;
      });
   };

   self.getData();
}]);
(function() {
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('renameObjectController', renameObjectController);

   renameObjectController.$inject = ['$scope', 'managedEntityMutationService', 'mutationService', 'i18nService'];

   function renameObjectController ($scope, managedEntityMutationService, mutationService, i18nService) {
      var self = this;
      self.validity = "";
      self.errorMessage = "";
      self.name = $scope.modalOptions.dialogData.existingObjectName;
      self.maxNameLength = $scope.modalOptions.dialogData.maxNameLength || 80;
      self.renameObject = function() {
         if(self.name) {
            mutationService.validate($scope.modalOptions.dialogData.objectId,
               'com.vmware.vsphere.client.mixed.ManagedEntityExtendedNameInfo',
               {
                  name: self.name,
                  targetType: null
               }).then(function(data) {
               if(!data.result) {
                  self.invalidateForm(i18nService.getString('Common', 'rename.name.exist', self.name));
               } else {
                  managedEntityMutationService.rename($scope.modalOptions.dialogData.objectId,
                                                      { name: self.name },
                                                      $scope.modalOptions.secondaryTitle + '-' + $scope.modalOptions.title);
                  self.closeModal();
               }
            });
         } else {
            self.invalidateForm(i18nService.getString('CommonModuleUi', 'NameValidator.emptyName'));
         }
      };

      self.invalidateForm = function (errorMessage) {
         self.validity = "invalid";
         self.errorMessage = errorMessage;
      };

      self.closeModal = function() {
         $scope.closeModal();
      };
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var HostSecurityOverviewController = (function () {
        function HostSecurityOverviewController(i18nService, navigation) {
            this.i18nService = i18nService;
            this.navigation = navigation;
            this.i18n = i18nService.getString.bind(this, "HostUi");
        }
        HostSecurityOverviewController.prototype.$onInit = function () {
            this.listViewType = 'HostSystem';
            this.objectId = this.navigation.getRoute().objectId;
        };
        HostSecurityOverviewController.$inject = ['i18nService', 'navigation'];
        return HostSecurityOverviewController;
    }());
    cluster_ui.HostSecurityOverviewController = HostSecurityOverviewController;
    angular.module('com.vmware.vsphere.client.commonModule')
        .component('hostSecurityOverview', {
        templateUrl: 'common-module-ui/resources/common-module/views/security/host-security-overview.html',
        controller: HostSecurityOverviewController,
        bindings: {
            relationId: "@"
        }
    });
})(cluster_ui || (cluster_ui = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var SessionViewController = (function () {
            function SessionViewController($scope, i18nService, vuiConstants, dataService, timeFormatterService, mutationService, userSessionService, clarityModalService, defaultUriSchemeUtil) {
                var _this = this;
                this.$scope = $scope;
                this.i18nService = i18nService;
                this.vuiConstants = vuiConstants;
                this.dataService = dataService;
                this.timeFormatterService = timeFormatterService;
                this.mutationService = mutationService;
                this.userSessionService = userSessionService;
                this.clarityModalService = clarityModalService;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.PROP_USER_SESSION = "vcUserSessions";
                this.PROP_USER_CURRENT_SESSION = "currentSessionId";
                this.SESSION_TERMINATE_SPEC = "com.vmware.vsphere.client.folder.VcSessionTerminationSpec";
                this.objectId = this.$scope._route.objectId ||
                    this.$scope._vxViewNodeData.node.contentSpec.metadata.objectId;
                this.watchForObjects = [this.objectId];
                this.terminateAction = this.getTerminateAction();
                this.dataGridOptions = this.getDataGridOptions();
                this.getUserSessionData();
                this.$scope.$watch('sessionViewCtrl.dataGridOptions.selectedItems', function (selectedItems) {
                    var canTerminate = !!selectedItems && selectedItems.length > 0 && !selectedItems[0].currentSession;
                    _this.terminateAction.enabled = canTerminate;
                });
            }
            SessionViewController.prototype.openDeleteModal = function () {
                var modalOptions = {
                    title: this.i18nService.getString('FolderUi', 'vcSessions.terminateSessionCaption'),
                    message: this.i18nService.getString('FolderUi', 'vcSessions.terminateSessionWarning'),
                    icon: 'vsphere-icon-status-warning',
                    submit: this.terminateSession.bind(this)
                };
                this.clarityModalService.openConfirmationModal(modalOptions);
            };
            /**
             * Terminate the user session (if possible)
             */
            SessionViewController.prototype.terminateSession = function () {
                var _this = this;
                var terminateSpec = {
                    userSessionId: [this.dataGridOptions.selectedItems[0].key]
                };
                return this.userSessionService.getAllServersInfo().then(function (response) {
                    var rootFolder = _this.defaultUriSchemeUtil
                        .createVmomiUri('Folder', 'group-d1', response.serversInfo[0].serviceGuid);
                    _this.mutationService.apply(rootFolder, _this.SESSION_TERMINATE_SPEC, terminateSpec);
                });
            };
            /**
             * Get the sessions' data
             */
            SessionViewController.prototype.getUserSessionData = function () {
                var _this = this;
                this.activeSessions = 0;
                this.idleSessions = 0;
                return this.dataService.getProperties(this.objectId, [this.PROP_USER_SESSION, this.PROP_USER_CURRENT_SESSION])
                    .then(function (sessions) {
                    _this.dataGridOptions.data = sessions.vcUserSessions;
                    _this.timeFormatterService.getUserTimeFormatPreference().then(function (savedDateTimeFormat) {
                        var currentTime = new Date().getTime();
                        _this.parseUserSessionData(savedDateTimeFormat, currentTime, sessions.currentSessionId);
                    });
                });
            };
            /**
             * Parse the data to include the following data:
             * - onlineSince
             * - Status
             *
             * @param savedDateTimeFormat The saved user date/time preference
             */
            SessionViewController.prototype.parseUserSessionData = function (savedDateTimeFormat, currentTime, currentSessionId) {
                var timeOptions = {
                    day: "numeric",
                    month: "numeric",
                    year: "2-digit",
                    hour: "numeric",
                    minute: "numeric"
                };
                for (var _i = 0, _a = this.dataGridOptions.data; _i < _a.length; _i++) {
                    var data = _a[_i];
                    data.onlineSince =
                        this.timeFormatterService.timestampToText(data.loginTime, savedDateTimeFormat, timeOptions);
                    data.idleTime = Math.floor((currentTime - data.lastActiveTime) / (1000 * 60));
                    data.currentSession = currentSessionId === data.key;
                    data.status = this.getStatus(data);
                }
            };
            /**
             * Get the status string for the provided session
             * Update the active/idle session count
             *
             * @param session A session with idleTime and currentSession specified
             * @returns {string}
             */
            SessionViewController.prototype.getStatus = function (session) {
                // Is Current session
                if (session.currentSession) {
                    this.activeSessions++;
                    return this.i18nService.getString("FolderUi", "vcSessions.sessionStatusThisSession");
                }
                // Is Active session
                if (this.isActiveSession(session)) {
                    this.activeSessions++;
                    return this.i18nService.getString("FolderUi", "vcSessions.sessionStatusActive");
                }
                // Idle session
                this.idleSessions++;
                var days = Math.floor(session.idleTime / 1440);
                var hours = Math.floor((session.idleTime % 1440) / 60);
                var minutes = session.idleTime % 60;
                if (days > 0) {
                    return this.i18nService.getString("FolderUi", "vcSessions.sessionStatusIdleDays", days, hours, minutes);
                }
                else if (hours > 0) {
                    return this.i18nService.getString("FolderUi", "vcSessions.sessionStatusIdleHours", hours, minutes);
                }
                else {
                    return this.i18nService.getString("FolderUi", "vcSessions.sessionStatusIdleMinutes", minutes);
                }
            };
            /**
             * Check if the provided session is active
             *
             * @param session
             * @returns {boolean}
             */
            SessionViewController.prototype.isActiveSession = function (session) {
                return session.currentSession || session.idleTime <= 10;
            };
            /**
             * Get the sessions' data-grid options
             */
            SessionViewController.prototype.getDataGridOptions = function () {
                return {
                    actionBarOptions: {
                        actions: [
                            this.terminateAction
                        ]
                    },
                    columnDefs: [{
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.userName"),
                            field: 'userName',
                            width: '20%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.fullName"),
                            field: 'fullName',
                            width: '15%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.onlineSince"),
                            field: 'onlineSince',
                            width: '13%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.status"),
                            field: 'status',
                            width: '15%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.ipAddress"),
                            field: 'ipAddress',
                            width: '11%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.userAgent"),
                            field: 'userAgent',
                            width: '15%'
                        }, {
                            displayName: this.i18nService.getString("FolderUi", "vcSessions.userSessions.callCount"),
                            field: 'callCount',
                            type: 'number',
                            width: '11%'
                        }],
                    data: [],
                    sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                    selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                    selectedItems: [],
                    height: '100%',
                    resizable: true
                };
            };
            /**
             * Get the terminate action button options
             */
            SessionViewController.prototype.getTerminateAction = function () {
                return {
                    id: 'delete-session-action',
                    iconClass: 'vsphere-icon-toolbar-remove',
                    tooltipText: this.i18nService.getString('FolderUi', 'vcSessions.terminateSessionCaption'),
                    enabled: false,
                    onClick: this.openDeleteModal.bind(this)
                };
            };
            SessionViewController.prototype.getActiveSessionString = function () {
                return this.i18nService.getString("FolderUi", "vcSessions.activeSessions", this.activeSessions);
            };
            SessionViewController.prototype.getIdleSessionString = function () {
                return this.i18nService.getString("FolderUi", "vcSessions.idleSessions", this.idleSessions);
            };
            SessionViewController.$inject = [
                "$scope",
                "i18nService",
                "vuiConstants",
                "dataService",
                "timeFormatterService",
                "mutationService",
                "userSessionService",
                "clarityModalService",
                "defaultUriSchemeUtil"
            ];
            return SessionViewController;
        }());
        common_module_ui.SessionViewController = SessionViewController;
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("SessionViewController", SessionViewController);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .factory('AssignTagGridFactory', AssignTagGridFactory);

   AssignTagGridFactory.$inject = ['$rootScope', 'tagService', 'i18nService', 'vuiConstants'];

   function AssignTagGridFactory($rootScope, tagService, i18nService, vuiConstants) {

      function TagGrid(objectId) {
         var self = this;
         self.objectId = objectId;

         self.datagridOptions = {
            actionBarOptions: {
               actions: [{
                  id: 'addTag',
                  enabled: true,
                  label: i18nService.getString('CommonModuleUi', 'add.tag'),
                  iconClass: 'vx-icon-tag'
               }]
            },
            columnDefs: [
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.assignedNameColumn'),
                  field: 'name',
                  sortable: true,
                  searchable: false
               },
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.categoryColumn'),
                  field: 'categoryName',
                  sortable: false,
                  searchable: false
               },
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.descColumn'),
                  field: 'description',
                  sortable: false,
                  searchable: false
               }
            ],
            height: '200px',
            resizable: false,
            reorderable: true,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: []
         };
      }

      TagGrid.prototype.populateDataGrid = function() {
         var self = this;
         tagService.getAssignableTagsForObject(self.objectId).then(function(tagData) {
            self.datagridOptions.data = tagData.assignableTagsForTarget || [];
         });
      };

      TagGrid.prototype.assignTag = function() {
         var self = this;
         tagService.attachTag(self.datagridOptions.selectedItems[0], self.objectId).then(function() {
            $rootScope.$broadcast('tagUpdate', self.objectId);
         });
      };

      TagGrid.prototype.setTagSelectionListener = function(tagSelectionListener) {
         var self = this;
         $rootScope.$watch(
            function() {
               return self.datagridOptions.selectedItems;
            },
            function(selectedItems) {
               var selectedItem = (selectedItems && selectedItems.length) ? selectedItems[0] : null;
               tagSelectionListener.call(this, selectedItem);
            }
         );
      };

      function make(objectId) {
         return new TagGrid(objectId);
      }

      return {
         make: make
      };
   }
}());
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('AssignTagsDialogController', AssignTagsDialogController);

   AssignTagsDialogController.$inject = [
      '$scope',
      'AssignTagGridFactory',
      'i18nService',
      'actionsService'];

   function AssignTagsDialogController ($scope, AssignTagGridFactory, i18nService, actionsService) {
      var self = this;
      var CREATE_TAG_ACTION_ID = "vsphere.core.common.actions.addTag";
      var objectId = $scope.modalOptions.availableTargets[0];

      self.tagGrid = AssignTagGridFactory.make(objectId);

      function addTags () {
         actionsService.getAction(CREATE_TAG_ACTION_ID)
               .then(function (actionEval) {
                  var context = {
                     title: i18nService.getString("CommonModuleUi", "add.tag")
                  };
                  actionsService.invokeAction(actionEval, context);
               });
      }

      self.tagGrid.datagridOptions.actionBarOptions.actions[0].onClick = addTags;
      self.tagGrid.populateDataGrid();

      self.onTagSelectionChanged = function(selectedTag) {
         self.assignDisabled = !selectedTag;
      };

      self.tagGrid.setTagSelectionListener(self.onTagSelectionChanged);

      $scope.$on('refreshTagGrid', function(){
         self.tagGrid.populateDataGrid();
      });
      self.assignTag = function() {
         self.tagGrid.assignTag();
         self.closeModal();
      };

      self.closeModal = function() {
         $scope.closeModal();
      };

   }
}());

var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var ModifyTagComponent = (function () {
            function ModifyTagComponent() {
                this.bindings = {
                    modifyTagData: "<",
                    categoryData: "<",
                    submitDisabled: "=",
                    onSubmit: "="
                };
                this.controller = ModifyTagController;
                this.templateUrl = "common-module-ui/resources/common-module/views/tags/modify-tag-component.html";
            }
            return ModifyTagComponent;
        }());
        common_module_ui.ModifyTagComponent = ModifyTagComponent;
        var ModifyTagController = (function () {
            function ModifyTagController(i18nService, $rootScope, categoryService, actionsService, tagService) {
                var _this = this;
                this.i18nService = i18nService;
                this.$rootScope = $rootScope;
                this.categoryService = categoryService;
                this.actionsService = actionsService;
                this.tagService = tagService;
                this.CREATE_CATEGORY_ACTION_ID = "vsphere.core.common.actions.addCategory";
                this.validity = "valid";
                this.errorMessage = "";
                this.unModifiedName = angular.copy(this.modifyTagData.name);
                this.createTagCategoryPromiseResolved = false;
                this.i18n = function (key) { return _this.i18nService.getString("CommonModuleUi", key); };
                this.onSubmitCaller = this.onSubmit;
                this.onSubmit = function () {
                    return _this.onSubmitFunction();
                };
                this.disableSubmit();
            }
            ModifyTagController.prototype.$onInit = function () {
                var _this = this;
                if (this.modifyTagData.mode === ModifyTagMode.ADD) {
                    this.populateCategorySelect();
                    this.createTagCategoryPromise = this.actionsService
                        .getAction(this.CREATE_CATEGORY_ACTION_ID)
                        .then(function (result) {
                        if (result) {
                            _this.createTagCategoryPromiseResolved = true;
                            return result;
                        }
                    });
                }
                this.$rootScope.$on("refreshCategories", function () {
                    _this.populateCategorySelect();
                });
            };
            ModifyTagController.prototype.disableSubmit = function () {
                if (this.modifyTagData.mode === ModifyTagMode.ADD) {
                    this.submitDisabled = !this.modifyTagData.name || !this.categoryData.selectedCategory;
                }
                else {
                    this.submitDisabled = !this.modifyTagData.name;
                }
            };
            ModifyTagController.prototype.populateCategorySelect = function () {
                var _this = this;
                this.categoryService.getAll()
                    .then(function (categories) {
                    if (categories && categories.length) {
                        _this.categoryData.selectedCategory = categories[0];
                        _this.categories = categories;
                    }
                    _this.disableSubmit();
                });
            };
            ModifyTagController.prototype.isCategoryAvailable = function () {
                return this.modifyTagData.mode === ModifyTagMode.EDIT || !this.createTagCategoryPromiseResolved;
            };
            ModifyTagController.prototype.addCategory = function () {
                var _this = this;
                this.createTagCategoryPromise
                    .then(function (actionEval) {
                    var context = {
                        title: _this.i18n("add.category"),
                        categoryState: {}
                    };
                    // TODO: Instead of broadcasting 'refreshCategories' and binding to it
                    // a deferred promise could be passed to the context object of the invokeAction.
                    // Once the category is created, the promise should be resolved.
                    // In this case, the handling (.then) of this promise comes here
                    // instead of this.$rootScope.$on('refreshCategories', fn).
                    //
                    // It would also be good to modify the back-end controllers to return the objects
                    // they created (tags/categories) on success.
                    _this.actionsService.invokeAction(actionEval, context);
                });
            };
            ModifyTagController.prototype.onSubmitFunction = function () {
                var _this = this;
                return this.onSubmitCaller().then(function (result) {
                    if (result.error && result.error.message && result.error.message.indexOf('AlreadyExistsFault') >= 0) {
                        _this.displayDuplicateError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            };
            ModifyTagController.prototype.displayDuplicateError = function () {
                var categoryName = this.modifyTagData.mode === ModifyTagMode.ADD ?
                    this.categoryData.selectedCategory.categoryName :
                    this.modifyTagData.categoryName;
                this.validity = "invalid";
                this.errorMessage = this.i18nService.getString("Common", "tag.create.form.error.tag.duplicate", categoryName);
            };
            ModifyTagController.$inject = ["i18nService", "$rootScope", "categoryService", "actionsService", "tagService"];
            return ModifyTagController;
        }());
        (function (ModifyTagMode) {
            ModifyTagMode[ModifyTagMode["ADD"] = 0] = "ADD";
            ModifyTagMode[ModifyTagMode["EDIT"] = 1] = "EDIT";
        })(common_module_ui.ModifyTagMode || (common_module_ui.ModifyTagMode = {}));
        var ModifyTagMode = common_module_ui.ModifyTagMode;
        angular.module("com.vmware.vsphere.client.commonModule")
            .component("modifyTagComponent", new ModifyTagComponent());
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



/* Copyright (c) 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
    angular.module('com.vmware.vsphere.client.commonModule')
        .factory('RemoveMultiTagsGridFactory', RemoveMultiTagsGridFactory);

    RemoveMultiTagsGridFactory.$inject = ['$rootScope', 'tagService', 'i18nService', 'vuiConstants'];

    function RemoveMultiTagsGridFactory($rootScope, tagService, i18nService, vuiConstants) {

        function MultiTagGrid(objectIds) {
            var self = this;
            self.objectIds = objectIds;

            self.datagridOptions = {
                columnDefs: [
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.assignedNameColumn'),
                        field: 'name',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.categoryColumn'),
                        field: 'categoryName',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.descColumn'),
                        field: 'description',
                        sortable: false,
                        searchable: false
                    }
                ],
                height: '200px',
                resizable: false,
                reorderable: false,
                selectedItems: [],
                selectionMode: vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedTags: [],
                data: []
            };

            $rootScope.$on('tagUpdate', function (event, changedObjectId) {
                if (self.objectIds.indexOf(changedObjectId) !== -1) {
                    self.populateDataGrid();
                }
            });
        }

        MultiTagGrid.prototype.populateDataGrid = function () {
            var self = this;
            self.objectIds.forEach(function (objectId) {
                tagService.getTagInfoForObject(objectId).then(function (tagData) {
                    var newArrival = tagData.filter(function (arrived) {
                        return !self.datagridOptions.data.some(function (item) {
                            return _.isEqual(arrived, item);
                        });
                    });
                    self.datagridOptions.data = self.datagridOptions.data.concat(newArrival);
                });
            });
        };

        MultiTagGrid.prototype.removeTag = function () {
            var self = this;
            var numOfSelectedTags = self.datagridOptions.selectedItems.length;
            var lastTagInTheList = self.datagridOptions.selectedItems[numOfSelectedTags - 1];
            for (var tag = 0; tag < numOfSelectedTags - 1; tag++) {
                this.removeMultiple(self.objectIds, self.datagridOptions.selectedItems[tag]);
            }
            if (lastTagInTheList) {
                this.removeMultiple(self.objectIds, lastTagInTheList, true);
            }
        };

        MultiTagGrid.prototype.removeMultiple = function (objectIds, selectedTag, shouldSendUpdate) {
            objectIds.forEach(function (objectId) {
                tagService.detachTag(selectedTag.resourceObject, objectId).then(function () {
                    if (shouldSendUpdate) {
                        $rootScope.$broadcast('tagUpdate', objectId);
                    }
                });
            });
        };

        MultiTagGrid.prototype.setTagSelectionListener = function (tagSelectionListener) {
            var self = this;
            $rootScope.$watch(
                function () {
                    return self.datagridOptions.selectedItems;
                },
                function (selectedItems) {
                    var selectedTagsInPortlet = (selectedItems && selectedItems.length) ? selectedItems : null;
                    tagSelectionListener.call(this, selectedTagsInPortlet);
                }
            );
        };

        MultiTagGrid.prototype.refresh = function () {
            this.populateDataGrid();
        };

        function make(objectIds) {
            return new MultiTagGrid(objectIds);
        }

        return {
            make: make
        };
    }
}());
(function () {
    'use strict';
    angular.module('com.vmware.vsphere.client.commonModule')
        .controller('RemoveTagDialogController', RemoveTagDialogController);

    RemoveTagDialogController.$inject = ['$scope', 'RemoveTagGridFactory', 'RemoveMultiTagsGridFactory', 'i18nService'];

    function RemoveTagDialogController($scope, RemoveTagGridFactory, RemoveMultiTagsGridFactory, i18nService) {
        var self = this,
            targets = $scope.modalOptions.availableTargets;

        if (targets.length > 1) {
            self.bulkRemoval = true;
            self.tagGrid = RemoveMultiTagsGridFactory.make(targets);
            $scope.modalOptions.title = i18nService
                .getString("Common", "tag.remove.form.batch.title", targets.length + '');
            $scope.modalOptions.secondaryTitle = "";
        } else {
            self.tagGrid = RemoveTagGridFactory.make(targets[0]);
        }

        self.tagGrid.populateDataGrid();

        self.onTagSelectionChanged = function (selectedTag) {
            self.removeDisabled = !selectedTag;
        };

        self.tagGrid.setTagSelectionListener(self.onTagSelectionChanged);

        self.removeTag = function () {
            self.tagGrid.removeTag();
            self.closeModal();
        };

        self.closeModal = function () {
            $scope.closeModal();
        };
    }
}());

(function() {
    'use strict';
    angular.module('com.vmware.vsphere.client.commonModule')
        .factory('RemoveTagGridFactory', RemoveTagGridFactory);

    RemoveTagGridFactory.$inject = ['$rootScope', 'tagService', 'i18nService', 'vuiConstants'];

    function RemoveTagGridFactory($rootScope, tagService, i18nService, vuiConstants) {

        function TagGrid(objectId) {
            var self = this;
            self.objectId = objectId;

            self.datagridOptions = {
                columnDefs: [
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.assignedNameColumn'),
                        field: 'name',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.categoryColumn'),
                        field: 'categoryName',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.descColumn'),
                        field: 'description',
                        sortable: false,
                        searchable: false
                    }
                ],
                height: '200px',
                resizable: false,
                reorderable: false,
                selectedItems: [],
                selectionMode: vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedTags: []
            };

            $rootScope.$on('tagUpdate', function(event, changedObjectId) {
                if (self.objectId === changedObjectId) {
                    self.populateDataGrid();
                }
            });
        }

        TagGrid.prototype.populateDataGrid = function() {
            var self = this;
            tagService.getTagInfoForObject(self.objectId).then(function(tagData) {
                self.datagridOptions.data = tagData;
            });
        };

        TagGrid.prototype.removeTag = function() {
            var self = this;
            var numOfSelectedTags = self.datagridOptions.selectedItems.length;
            for (var tag = 0; tag<numOfSelectedTags-1; tag++) {
                var selectedTag = self.datagridOptions.selectedItems[tag];
                tagService.detachTag(selectedTag.resourceObject, self.objectId);
            }
            var lastTagInTheList = self.datagridOptions.selectedItems[numOfSelectedTags-1];
            if(lastTagInTheList) {
                tagService.detachTag(lastTagInTheList.resourceObject, self.objectId).then(function(resp) {
                    $rootScope.$broadcast('tagUpdate', self.objectId);
                    return true;
                });
            }
        };

        TagGrid.prototype.setTagSelectionListener = function(tagSelectionListener) {
            var self = this;
            $rootScope.$watch(
                function() {
                    return self.datagridOptions.selectedItems;
                },
                function(selectedItems) {
                    var selectedTagsInPortlet = (selectedItems && selectedItems.length) ? selectedItems : null;
                    tagSelectionListener.call(this, selectedTagsInPortlet);
                }
            );
        };

        TagGrid.prototype.refresh = function(){
            var self = this;
            tagService.getTagInfoForObject(self.objectId).then(function(tagData) {
                self.datagridOptions.data = tagData;
            });
        };

        function make(objectId) {
            return new TagGrid(objectId);
        }

        return {
            make: make
        };
    }
}());
/* Copyright 2016-2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('TagsController', TagsController);

   TagsController.$inject = ['i18nService', 'vuiConstants', '$scope', 'datagridActionBarService',
         'defaultUriSchemeUtil', 'dataService', '$element', 'userSessionService'];

   function TagsController(i18nService, vuiConstants, $scope, datagridActionBarService,
         defaultUriSchemeUtil, dataService, $element, userSessionService) {

      var GRANTED_PRIVILEGES_PROP = "grantedPrivileges";
      var AUTHZ_ROOT_TYPE = "acl:RootPermissionNode";
      var AUTHZ_ROOT_ID = "root";

      var CREATE_TAG_PRIV = "InventoryService.Tagging.CreateTag";
      var EDIT_TAG_PRIV = "InventoryService.Tagging.EditTag";
      var DELETE_TAG_PRIV = "InventoryService.Tagging.DeleteTag";

      var self = this;
      self.grantedPrivileges = [];
      self.onSelectionChange = function(selectedItems) {
         self.selectedItem = selectedItems && selectedItems.length === 1 ? selectedItems[0] : null;
         updateActionBar();
      };
      self.datagridOptions = {
            actionBarOptions: {actions: []},
            columnDefs: [
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.nameColumn'),
                  field: 'name',
                  sortable: true,
                  searchable: false,
                  template: function(dataItem) {
                     return dataGridTemplate(dataItem.name);
                  }
               },
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.categoryColumn'),
                  field: 'categoryName',
                  sortable: true,
                  searchable: false,
                  template: function(dataItem) {
                     return dataGridTemplate(dataItem.categoryName);
                  }
               },
               {
                  displayName: i18nService.getString('Common', 'tag.dashboard.descColumn'),
                  field: 'description',
                  sortable: true,
                  searchable: false,
                  template: function(dataItem) {
                     return dataGridTemplate(dataItem.description);
                  }
               }
            ],
            sortOrder: [{
               field: 'categoryName',
               dir: 'asc'
            }],
            height: '100%',
            resizable: true,
            reorderable: true,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            onChange: self.onSelectionChange.bind(self),
            selectedItems: [],
            pageable: true,
            pageConfig: {
               displayMode: vuiConstants.grid.displayMode.VIRTUAL_SCROLLING,
               size: 50
            },
            data: {
               url: 'tagging-ui/ctrl/tags',
               dataType: vuiConstants.grid.dataType.JSON,
               method: vuiConstants.grid.dataMethod.GET,
               data: 'summaryItemSpecs',
               total: 'totalMatchedObjectCount',
               beforeSend: function(req) {
                  req.setRequestHeader(userSessionService.WEB_CLIENT_SESSION_ID, userSessionService.webClientSessionId);
               }
            },
            pageSize: 50
      };

      /**
       *  Generate html template for datagrid
       */
      function dataGridTemplate (item) {
         var ele = document.createElement("span");
         ele.setAttribute("ng-non-bindable", "ng-non-bindable");
         ele.title = item;
         ele.textContent = item;
         return ele.outerHTML;
      }

      function updateActionBar() {
         var actions = [{
            actionId: 'vsphere.core.common.actions.addTag',
            isActionAvailable: function(actionDef) {
               return actionDef.available
                  && self.grantedPrivileges.indexOf(CREATE_TAG_PRIV) !== -1;
            }
         }, {
            actionId: 'vsphere.core.common.actions.editTag',
            isActionAvailable: function(actionDef) {
               return actionDef.available
                     && self.selectedItem
                     && self.grantedPrivileges.indexOf(EDIT_TAG_PRIV) !== -1;
            },
            getActionInvocationContext: function() {
               return {tag: self.selectedItem};
            }
         }, {
            actionId: 'vsphere.core.common.actions.deleteTag',
            isActionAvailable: function(actionDef) {
               return actionDef.available
                     && self.selectedItem
                     && self.grantedPrivileges.indexOf(DELETE_TAG_PRIV) !== -1;
            },
            getActionInvocationContext: function() {
               return {tag: self.selectedItem};
            }
         }];
         datagridActionBarService.updateActionBar(self.datagridOptions, [], actions);
      }


      /**
       * Get all the TAG privileges and provide restriction
       */
      function getGrantedPrivileges() {
         dataService.getProperties(
               defaultUriSchemeUtil.createUri(AUTHZ_ROOT_TYPE, AUTHZ_ROOT_ID),
               [GRANTED_PRIVILEGES_PROP])
               .then(function (result) {
                  if (result && result[GRANTED_PRIVILEGES_PROP]) {
                     self.grantedPrivileges = result[GRANTED_PRIVILEGES_PROP];
                     updateActionBar();
                  }
               });
      }

      $scope.$on('refreshTagGrid', function() {
         $element.find("[kendo-grid]").data('kendoGrid').dataSource.read();
      });


      getGrantedPrivileges();
   }
}());

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule')
      .controller('TagsPortletController', TagsPortletController);

   TagsPortletController.$inject = ['$scope', 'RemoveTagGridFactory', 'i18nService', 'actionsService', 'clarityModalService'];

   function TagsPortletController($scope, RemoveTagGridFactory, i18nService, actionsService, clarityModalService) {
      var self = this;
      self.objectId = $scope._route.objectId;

      $scope.portlet.footerLinks = [
         {
            label: i18nService.getString('Common', 'tag.dashboard.assign'),
            ariaLabel: i18nService.getString('Common', 'tag.dashboard.assignAriaLabel'),
            onClick: onAssignTagClicked,
            enabled: true
         },
         {
            label: i18nService.getString('Common', 'tag.dashboard.remove'),
            ariaLabel: i18nService.getString('Common', 'tag.dashboard.removeAriaLabel'),
            onClick: onDetachTagClicked,
            enabled: false
         }];

      self.tagGrid = RemoveTagGridFactory.make(self.objectId);
      self.tagGrid.populateDataGrid(self.objectId);

      self.refresh = function(){
         self.tagGrid.refresh(self.objectId);
      };

      self.onTagSelectionChanged = function(selectedTags) {
         setRemoveTagLinkEnabled(!!selectedTags);
         self.selectedTags = selectedTags;
      };

      self.tagGrid.setTagSelectionListener(self.onTagSelectionChanged);

      function setRemoveTagLinkEnabled(linkEnabled) {
         $scope.portlet.footerLinks[1].enabled = linkEnabled;
      }

      function onDetachTagClicked($event) {
         if(self.selectedTags) {
            var modalOptions = {
               title: i18nService.getString('Common', 'tag.remove.warning.title'),
               message: i18nService.getString('Common', 'tag.remove.warning.text', self.selectedTags[0].name, $scope.currentObject.name),
               saveButtonLabel: i18nService.getString('Common', 'tag.remove.warning.submit'),
               submit: function() {
                  self.tagGrid.removeTag();
                  return true;
               },
               focusTarget: $event.currentTarget
            };
            if(self.selectedTags.length > 1) {
               modalOptions.message = i18nService.getString('Common', 'tag.multi.remove.warning.text',
                   self.selectedTags.length, $scope.currentObject.name);
            }
            clarityModalService.openConfirmationModal(modalOptions);
         }
      }

      self.assignMutex = false;

      function onAssignTagClicked($event) {
         if (!self.assignMutex) {
            self.assignMutex = true;
            actionsService.getAction("vsphere.core.common.actions.assignTag", [self.objectId])
               .then(function(action) {
                  actionsService.invokeAction(action, {focusTarget: $event.currentTarget});
               }).finally(function () {
                  self.assignMutex = false;
               });
         }
      }
   }
}());

var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var TriggeredAlarmsRefreshService = (function () {
            function TriggeredAlarmsRefreshService($q, defaultUriSchemeUtil, objectTypesService, dataService, timeFormatterService) {
                this.$q = $q;
                this.defaultUriSchemeUtil = defaultUriSchemeUtil;
                this.objectTypesService = objectTypesService;
                this.dataService = dataService;
                this.timeFormatterService = timeFormatterService;
                this.SOURCE_OBJECTS_PROPERTY = "sourceObjects";
            }
            TriggeredAlarmsRefreshService.prototype.handleAlarmUpdates = function (partialUpdate, objectId, alarms) {
                var _this = this;
                // Update to an existing alarm
                if (partialUpdate.isDelta) {
                    // Reset to green
                    if (!partialUpdate.data) {
                        return this.handleResetToGreenAlarm(partialUpdate, alarms);
                    }
                    // Acknowledge
                    if (partialUpdate.data) {
                        return this.handleAcknowledgeAlarm(partialUpdate, alarms);
                    }
                }
                return this.isNewAlarmRelevant(partialUpdate, objectId)
                    .then(function (isAlarmRelevant) {
                    if (isAlarmRelevant) {
                        return _this.handleNewAlarm(partialUpdate, alarms);
                    }
                    return _this.$q.resolve(false);
                });
            };
            TriggeredAlarmsRefreshService.prototype.isNewAlarmRelevant = function (partialUpdate, objectId) {
                if (this.isAlarmEntitySameAsCurrentView(partialUpdate, objectId)) {
                    return this.$q.resolve(true);
                }
                if (this.isCurrentViewRootFolder(objectId) && this.isAlarmEntityRootFolderMatching(partialUpdate, objectId)) {
                    return this.$q.resolve(true);
                }
                return this.isAlarmEntityUnderCurrentView(partialUpdate, objectId);
            };
            TriggeredAlarmsRefreshService.prototype.isAlarmEntitySameAsCurrentView = function (partialUpdate, objectId) {
                var alarmEntityId = this.defaultUriSchemeUtil.getVsphereObjectId(partialUpdate.data.entity);
                return alarmEntityId === objectId;
            };
            TriggeredAlarmsRefreshService.prototype.isCurrentViewRootFolder = function (objectId) {
                return this.defaultUriSchemeUtil.isRootFolder(objectId);
            };
            TriggeredAlarmsRefreshService.prototype.isAlarmEntityUnderCurrentView = function (partialUpdate, objectId) {
                var _this = this;
                var alarmEntityId = this.defaultUriSchemeUtil.getVsphereObjectId(partialUpdate.data.entity);
                return this.dataService.getProperties(alarmEntityId, this.SOURCE_OBJECTS_PROPERTY)
                    .then(function (response) {
                    if (response && response[_this.SOURCE_OBJECTS_PROPERTY]) {
                        var sourceObjects = response[_this.SOURCE_OBJECTS_PROPERTY];
                        var hostedObjectId = _this.defaultUriSchemeUtil.getVsphereObjectId(sourceObjects.hostedObject);
                        var vmFolder = _this.defaultUriSchemeUtil.getVsphereObjectId(sourceObjects.vmFolder);
                        return (hostedObjectId === objectId) || (vmFolder === objectId);
                    }
                    return false;
                });
            };
            TriggeredAlarmsRefreshService.prototype.isAlarmEntityRootFolderMatching = function (partialUpdate, objectId) {
                var alarmEntityMor = this.defaultUriSchemeUtil.getNormalizedVsphereObject(partialUpdate.data.entity);
                var objectMor = this.defaultUriSchemeUtil.getManagedObjectReference(objectId);
                return alarmEntityMor.serverGuid === objectMor.serverGuid;
            };
            TriggeredAlarmsRefreshService.prototype.handleNewAlarm = function (partialUpdate, alarms) {
                var alarmKey = partialUpdate.data.key;
                var alarmInfo = {
                    entity: partialUpdate.data.entity,
                    entityName: partialUpdate.metadata.issueInfo.entityName,
                    details: {
                        alarmState: {
                            _type: "com.vmware.vim.binding.vim.alarm.AlarmState",
                            key: alarmKey,
                            overallStatus: partialUpdate.data.overallStatus,
                            time: this.getTimestampFromDate(partialUpdate.data.time),
                            acknowledged: partialUpdate.data.acknowledged,
                            entity: partialUpdate.data.entity
                        },
                        alarmInfo: {
                            _type: "com.vmware.vim.binding.vim.alarm.AlarmInfo",
                            name: partialUpdate.metadata[alarmKey].name,
                            entity: partialUpdate.metadata[alarmKey].entity,
                            alarm: partialUpdate.data.alarm
                        },
                        definedInEntityName: partialUpdate.metadata.alarmInfoName
                    }
                };
                return this.getDefinedInEntityObject(alarmInfo)
                    .then(function (typeInfo) {
                    alarmInfo.definedInEntityIcon = typeInfo.icon;
                    alarmInfo.definedInEntityNamespace = typeInfo.namespace;
                    alarms.push(alarmInfo);
                    return true;
                });
            };
            TriggeredAlarmsRefreshService.prototype.handleResetToGreenAlarm = function (partialUpdate, alarms) {
                var alarmIndex = _.findIndex(alarms, function (alarm) {
                    return partialUpdate.source === alarm.details.alarmState.key;
                });
                if (alarmIndex === -1) {
                    return this.$q.resolve(false);
                }
                alarms.splice(alarmIndex, 1);
                return this.$q.resolve(true);
            };
            TriggeredAlarmsRefreshService.prototype.handleAcknowledgeAlarm = function (partialUpdate, alarms) {
                var alarmIndex = _.findIndex(alarms, function (alarm) {
                    return partialUpdate.data.key === alarm.details.alarmState.key;
                });
                if (alarmIndex === -1) {
                    return this.$q.resolve(false);
                }
                var alarmStateToUpdate = alarms[alarmIndex].details.alarmState;
                alarmStateToUpdate.acknowledged = partialUpdate.data.acknowledged;
                alarmStateToUpdate.acknowledgedTime = this.getTimestampFromDate(partialUpdate.data.acknowledgedTime);
                alarmStateToUpdate.acknowledgedByUser = partialUpdate.data.acknowledgedByUser;
                return this.$q.resolve(true);
            };
            TriggeredAlarmsRefreshService.prototype.getTimestampFromDate = function (time) {
                return new Date(Date.UTC(time.year, time.month, time.dayOfMonth, time.hourOfDay, time.minute, time.second)).valueOf();
            };
            TriggeredAlarmsRefreshService.prototype.getDefinedInEntityObject = function (alarmInfo) {
                var definedInType = alarmInfo.details.alarmInfo.entity._type;
                return this.objectTypesService.getObjectTypeSpec(definedInType);
            };
            TriggeredAlarmsRefreshService.$inject = [
                "$q",
                "defaultUriSchemeUtil",
                "objectTypesService",
                "dataService",
                "timeFormatterService"
            ];
            return TriggeredAlarmsRefreshService;
        }());
        common_module_ui.TriggeredAlarmsRefreshService = TriggeredAlarmsRefreshService;
        angular
            .module("com.vmware.vsphere.client.commonModule")
            .service("triggeredAlarmsRefreshService", TriggeredAlarmsRefreshService);
    })(common_module_ui = h5_client.common_module_ui || (h5_client.common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.commonModule').controller(
         'TriggeredAlarmsViewController', TriggeredAlarmsViewController);
   TriggeredAlarmsViewController.$inject = [
      '$q',
      '$scope',
      '$rootScope',
      'i18nService',
      'alarmService',
      'defaultUriSchemeUtil',
      'objectTypesService',
      'columnRenderersRegistry',
      'vuiConstants',
      'alarmIssueActionService',
      'datagridActionBarService',
      'timeFormatterService',
      'configurationService',
      'vuiUtils',
      'triggeredAlarmsRefreshService'
   ];

   function TriggeredAlarmsViewController($q, $scope, $rootScope, i18nService, alarmService, defaultUriSchemeUtil,
         objectTypesService, columnRenderersRegistry, vuiConstants, alarmIssueActionService,
         datagridActionBarService, timeFormatterService, configurationService, vuiUtils,
         triggeredAlarmsRefreshService) {
      var linkRenderer = columnRenderersRegistry.getColumnRenderer('link');

      var self = this;
      var datagridActionBarServiceCacheObject = null;

      var acknowledgeActionSpec = {
         actionId: 'vsphere.opsmgmt.alarms.acknowledge',
         noLabel: true,
         getActionInvocationContext: getActionInvocationContext,
         isActionAvailable: function(actionDef) {
            var selectedItems = self.datagridOptions.selectedItems;
            if (selectedItems.length === 0) {
               return false;
            }
            if (selectedItems[0].details.alarmState.acknowledged) {
               return false;
            }
            return actionDef.available;
         }
      };
      self.savedDateFormat = null;

      var resetActionSpec = {
         actionId: 'vsphere.opsmgmt.alarms.reset',
         noLabel: true,
         getActionInvocationContext: getActionInvocationContext,
         isActionAvailable: function(actionDef) {
            return actionDef.available && self.datagridOptions.selectedItems.length > 0;
         }
      };

      var actionSpecs = [acknowledgeActionSpec, resetActionSpec];

      self.objectId = $scope._route.objectId;
      self.watchForObjects = [ self.objectId ];
      self.alarms = [];

      // flag indicating if a request for alarms is currently in progress
      self.pendingRequest = false;

      self.datagridOptions = {
         actionBarOptions: {
            actions: []
         },
         resizable: true,
         searchable: false,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         height: '99%',
         selectedItems: [],
         columnDefs: [
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.object'),
               field: 'entityName',
               template: function (dataItem) {
                  return linkRenderer(defaultUriSchemeUtil.getVsphereObjectId(dataItem.entity), dataItem.entityName);
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.severity'),
               field: 'details.alarmState.overallStatus',
               template: function (dataItem) {
                  var text = alarmService.getSeverity(dataItem.details.alarmState.overallStatus);
                  var icon = alarmService.getStatusIconClass(dataItem.details.alarmState.overallStatus);
                  return linkRenderer(null, text, icon);
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.name'),
               field: 'details.alarmInfo.name',
               template: function (dataItem) {
                  var definedInRef = defaultUriSchemeUtil.getVsphereObjectId(dataItem.details.alarmInfo.entity);

                  var extensionName = dataItem.definedInEntityNamespace + '.manage.alarmDefinitions';

                  return linkRenderer(definedInRef, dataItem.details.alarmInfo.name, null, false, {extensionName: extensionName});
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.triggered'),
               field: 'details.alarmState.time',
               template: function (dataItem) {
                  return timeFormatterService.timestampToText(parseInt(dataItem.details.alarmState.time), self.savedDateFormat);
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.acknowledgedTime'),
               field: 'details.alarmState.acknowledgedTime',
               template: function (dataItem) {
                  return dataItem.details.alarmState.acknowledgedTime ?
                        timeFormatterService.timestampToText(parseInt(dataItem.details.alarmState.acknowledgedTime), self.savedDateFormat) : '';
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.acknowledgedByUser'),
               field: 'details.alarmState.acknowledgedByUser',
               template: function (dataItem) {
                  return (dataItem.details.alarmState.acknowledgedByUser) ?
                        dataItem.details.alarmState.acknowledgedByUser :'';
               }
            },
            {
               displayName: i18nService.getString('Common', 'alarmsView.tableHeaderText.definedIn'),
               field: 'details.definedInEntityName',
               template: function (dataItem) {
                  var link, text, iconClass;
                  if (dataItem.details.alarmInfo.entity.value === 'group-d1' ||
                        dataItem.details.alarmInfo.entity._value === 'group-d1') {
                     iconClass = 'vsphere-icon-vcenter';
                  } else {
                     iconClass = dataItem.definedInEntityIcon;
                  }

                  var definedInRef = defaultUriSchemeUtil.getVsphereObjectId(dataItem.details.alarmInfo.entity);
                  if (definedInRef === self.objectId) {
                     text = i18nService.getString('AlarmsUi', "definedIn.this.object");
                     link = null;
                  } else {
                     text = dataItem.details.definedInEntityName;
                     link = definedInRef;
                  }

                  return linkRenderer(link, text, iconClass);
               }
            }
         ],
         data: []
      };

      self.showActionsMenu = function(event) {
         var alarm = event.data[0];
         if (alarm && alarm.details) {
            alarmIssueActionService.showActionsMenu(
                event,
                $scope,
                alarm.details.alarmInfo,
                alarm.details.alarmState,
                event.clientX,
                event.clientY,
                event.currentTarget);
         }
      };


      createActionBar();

      $scope.$watch('ctrl.datagridOptions.selectedItems', function() {
         refreshActionBar();
      });

      $scope.$on('IssueChangeEvent', self.getAlarms);

      self.getAlarms = function() {
         if (self.pendingRequest === true) {
            return;
         }
         self.pendingRequest = true;
         alarmService.getAlarms(self.objectId).then(function(result) {
            var promises = _.map(result, function (triggeredAlarm) {
               var definedInType = triggeredAlarm.details.alarmInfo.entity.type;
               return objectTypesService.getObjectTypeSpec(definedInType).then(function (typeInfo) {
                  triggeredAlarm.definedInEntityIcon = typeInfo.icon;
                  triggeredAlarm.definedInEntityNamespace = typeInfo.namespace;
                  return triggeredAlarm;
               });
            });

            return $q.all(promises);
         }).then(function(triggeredAlarms) {
            self.alarms = triggeredAlarms;
            self.datagridOptions.data = triggeredAlarms;
         })['finally'](function() {
            self.pendingRequest = false;

            if (!self.cancelLiveRefreshFn) {
               subscribeToLiveRefresh()
                     .then(function (cancelLiveRefreshFn) {
                        self.cancelLiveRefreshFn = cancelLiveRefreshFn;
                        $scope.$on('$destroy', function() {
                           self.cancelLiveRefreshFn();
                        });
                     });
            }
         });
      };

      refresh(self.getAlarms);

      function subscribeToLiveRefresh() {
         var LIVE_ALARM_UPDATES_FLAG = 'live.updates.alarms.enabled';

         return configurationService.getProperty(LIVE_ALARM_UPDATES_FLAG)
            .then(function(isAlarmRefreshEnabled) {
               // Subscribe for alarm updates after initial alarm loading.
               if (isAlarmRefreshEnabled !== 'false') {
                  return $rootScope.$on('alarms', onAlarmsUpdates);
               }
            });
      }

      function onAlarmsUpdates(event, partialUpdates) {
         var promises = [];

         _.each(partialUpdates.updates, function(partialUpdate) {
            promises.push(
               triggeredAlarmsRefreshService.handleAlarmUpdates(partialUpdate, self.objectId, self.alarms)
            );
         });

         $q.all(promises).then(function() {
            vuiUtils.safeApply($scope, function () {
               self.datagridOptions.data = _.sortBy(self.alarms, function (alarm) {
                  return alarm.details.alarmState.time;
               }).reverse();
            });
         });
      }

      function refresh(cb) {
         return timeFormatterService.getUserTimeFormatPreference().then(function(savedFormatId) {
            self.savedDateFormat = savedFormatId;
            if (cb) {
               cb(savedFormatId);
            }
         });
      }

      function createActionBar() {
         datagridActionBarService
               .updateActionBar(self.datagridOptions, [self.objectId], actionSpecs)
               .then(function(value) {
                  datagridActionBarServiceCacheObject = value;
               });
      }

      function refreshActionBar() {
         if (!datagridActionBarServiceCacheObject) {
            return;
         }

         datagridActionBarService.updateActionBar(
            self.datagridOptions, [self.objectId], actionSpecs, datagridActionBarServiceCacheObject
         );
      }

      function getActionInvocationContext() {
         var selectedItems = self.datagridOptions.selectedItems;
         var alarmInfo = selectedItems[0].details.alarmInfo;
         return {
            entityId: defaultUriSchemeUtil.getVsphereObjectId(selectedItems[0].details.alarmState.entity),
            alarm: defaultUriSchemeUtil.getNormalizedVsphereObject(alarmInfo.alarm)
         };
      }
   }
})();

var common_module_ui;
(function (common_module_ui) {
    var ObjectUtilizationMeterGroupController = (function () {
        function ObjectUtilizationMeterGroupController() {
        }
        ObjectUtilizationMeterGroupController.prototype.$onChanges = function (changes) {
            var maxValue = (typeof changes.maxValue !== "undefined") ?
                changes.maxValue.currentValue : "";
            var groupedMeters = (typeof changes.groupedMeters !== "undefined") ?
                changes.groupedMeters.currentValue : [];
            if (maxValue && maxValue !== "") {
                this.minValue = this.getMinValue(maxValue);
            }
            if (groupedMeters && groupedMeters.length > 0) {
                // find biggest grouped meter
                var maxGroupedMeter_1 = _.max(groupedMeters, function (groupMeter) {
                    return parseFloat(groupMeter.value);
                });
                var groupedMeterValues = _.pluck(groupedMeters, "value");
                var offset_1 = 100 - _.reduce(groupedMeterValues, function (total, num) {
                    return total + parseFloat(num);
                }, 0);
                if (offset_1 !== 100 && offset_1 !== 0) {
                    // add difference to the biggest grouped meter
                    _.each(changes.groupedMeters.currentValue, function (groupedMeter) {
                        if (_.isEqual(maxGroupedMeter_1, groupedMeter)) {
                            groupedMeter.value = parseFloat(maxGroupedMeter_1.value) + offset_1;
                        }
                    });
                }
            }
        };
        ObjectUtilizationMeterGroupController.prototype.getMinValue = function (maxValue) {
            var minValue = "";
            if (maxValue.length > 0) {
                minValue = "0 " + maxValue.split(" ")[1];
            }
            return minValue;
        };
        return ObjectUtilizationMeterGroupController;
    }());
    var ObjectUtilizationMeterGroup = (function () {
        function ObjectUtilizationMeterGroup() {
            this.controller = ObjectUtilizationMeterGroupController;
            this.templateUrl =
                "common-module-ui/resources/common-module/views/utilization/objectUtilizationMeterGroup.html";
            this.bindings = {
                groupedMeters: "<",
                meters: "<",
                maxValue: "<",
                pointers: "<"
            };
        }
        return ObjectUtilizationMeterGroup;
    }());
    angular.module("com.vmware.vsphere.client.commonModule").component("objectUtilizationMeterGroup", new ObjectUtilizationMeterGroup());
})(common_module_ui || (common_module_ui = {}));



var common_module_ui;
(function (common_module_ui) {
    var VCServerSettingConstants = (function () {
        function VCServerSettingConstants() {
        }
        /*
         * Properties
         */
        VCServerSettingConstants.PROP_SERVER_SETTINGS = "vcServerSettings";
        VCServerSettingConstants.PROP_DATABASE_STATISTICS = "estimatedDastabaseSize";
        /*
         * Keys for settings in array
         */
        VCServerSettingConstants.KEY_DATABASE = "databaseSettings";
        VCServerSettingConstants.KEY_RUNTIME = "runtimeSettings";
        VCServerSettingConstants.KEY_USER_DIRECTORY = "activeDirectorySettings";
        VCServerSettingConstants.KEY_MAIL = "mailSettings";
        VCServerSettingConstants.KEY_SNMP_RECEIVER = "snmpSettings";
        VCServerSettingConstants.KEY_PORTS = "portsSettings";
        VCServerSettingConstants.KEY_TIMEOUT = "timeoutSettings";
        VCServerSettingConstants.KEY_LOGGING = "logSettings";
        VCServerSettingConstants.KEY_SSL = "sslSettings";
        /*
         * Default inventory details
         */
        VCServerSettingConstants.DEFAULT_HOST_COUNT = 50;
        VCServerSettingConstants.DEFAULT_VM_COUNT = 2000;
        return VCServerSettingConstants;
    }());
    common_module_ui.VCServerSettingConstants = VCServerSettingConstants;
})(common_module_ui || (common_module_ui = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var VCServerSettingController = (function () {
            function VCServerSettingController($scope, vcServerSettingService) {
                var _this = this;
                this.$scope = $scope;
                this.vcServerSettingService = vcServerSettingService;
                var objectId = this.$scope._route.objectId ||
                    this.$scope._vxViewNodeData.node.contentSpec.metadata.objectId;
                this.vcServerSettingService.getServerSettings(objectId).then(function (vcServerSettings) {
                    _this.vcServerSettings = vcServerSettings;
                });
            }
            VCServerSettingController.$inject = [
                "$scope",
                "vcServerSettingService"
            ];
            return VCServerSettingController;
        }());
        common_module_ui.VCServerSettingController = VCServerSettingController;
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("VCServerSettingController", VCServerSettingController);
    })(common_module_ui || (common_module_ui = {}));
})(h5_client || (h5_client = {}));



var common_module_ui;
(function (common_module_ui) {
    var VCServerSettingConstants = common_module_ui.VCServerSettingConstants;
    var VCServerSettingService = (function () {
        function VCServerSettingService(dataService, i18nService, numberFormatterService) {
            var _this = this;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.numberFormatterService = numberFormatterService;
            this.i18n = function (key, value) { return _this.i18nService.getString("FolderUi", key, value); };
        }
        /**
         * Return the vC server settings using the data service
         *
         * @param {string} objectId
         *      ObjectId of the entity/object whose data is to be fetched.
         *
         * @returns {PromiseLike<TResult>}
         */
        VCServerSettingService.prototype.getServerSettings = function (objectId) {
            var _this = this;
            var propertyParamSpecs = [{
                    propertyName: VCServerSettingConstants.PROP_DATABASE_STATISTICS,
                    parameterType: "com.vmware.vim.binding.vim.ResourcePlanningManager$DatabaseSizeParam",
                    parameter: {
                        _type: "com.vmware.vim.binding.vim.ResourcePlanningManager$DatabaseSizeParam",
                        inventoryDesc: {
                            _type: "com.vmware.vim.binding.vim.ResourcePlanningManager$InventoryDescription",
                            numHosts: VCServerSettingConstants.DEFAULT_HOST_COUNT,
                            numVirtualMachines: VCServerSettingConstants.DEFAULT_VM_COUNT
                        }
                    }
                }];
            return this.dataService.getProperties(objectId, [VCServerSettingConstants.PROP_SERVER_SETTINGS, VCServerSettingConstants.PROP_DATABASE_STATISTICS], { propertyParams: propertyParamSpecs }).then(function (settings) {
                var estimatedDatabaseSize = _this.numberFormatterService.formatStorage(settings.estimatedDastabaseSize, StorageUnit.MB, StorageUnit.GB, 2);
                var settingProperties = settings.vcServerSettings.properties;
                _this.parseServerSettings(settingProperties, estimatedDatabaseSize);
                return settingProperties;
            });
        };
        /**
         * Add more information to the provided settings
         *
         * @param settingProperties
         * @param estimatedDatabaseSize
         */
        VCServerSettingService.prototype.parseServerSettings = function (settingProperties, estimatedDatabaseSize) {
            this.parseStatisticsSettings(settingProperties, estimatedDatabaseSize);
            this.parseDatabaseSettings(settingProperties);
            this.parseRuntimeSettings(settingProperties);
            this.parseUserDirectorySettings(settingProperties);
            this.parseMailSettings(settingProperties);
            this.parseSNMPSettings(settingProperties);
            this.parsePortsSettings(settingProperties);
            this.parseTimeoutSettings(settingProperties);
            this.parseLoggingSettings(settingProperties);
            this.parseSSLSettings(settingProperties);
        };
        VCServerSettingService.prototype.parseStatisticsSettings = function (settingProperties, estimatedDatabaseSize) {
            settingProperties.unshift({
                titleLabel: this.i18n("vcStatisticsConfigPage.title"),
                titleLabelContent: this.i18n("vcStatisticsConfigPage.estimatedDbSizeLabel"),
                estimatedDatabaseSize: estimatedDatabaseSize,
                sizeLabel: this.i18nService.getString("CommonUi", "gigaByte.label")
            });
        };
        VCServerSettingService.prototype.parseDatabaseSettings = function (settingProperties) {
            var databaseIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_DATABASE });
            settingProperties[databaseIndex].titleLabel =
                this.i18n("vcDatabaseConfigPage.title");
            settingProperties[databaseIndex].titleLabelContent = this.i18n("vcConfigView.dbMaxConnectionsHeaderLabel", settingProperties[databaseIndex].value.properties[0].value);
        };
        VCServerSettingService.prototype.parseRuntimeSettings = function (settingProperties) {
            var runtimeIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_RUNTIME });
            settingProperties[runtimeIndex].titleLabel =
                this.i18n("vcRuntimeConfigPage.title");
            settingProperties[runtimeIndex].titleLabelContent = this.i18n("vcConfigView.vcInstanceNameHeaderLabel", settingProperties[runtimeIndex].value.properties[2].value);
        };
        VCServerSettingService.prototype.parseUserDirectorySettings = function (settingProperties) {
            var userDirectoryIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_USER_DIRECTORY });
            settingProperties[userDirectoryIndex].titleLabel =
                this.i18n("vcActiveDirectoryConfigPage.title");
            settingProperties[userDirectoryIndex].titleLabelContent = this.i18n("vcConfigView.adTimeoutHeaderLabel", settingProperties[userDirectoryIndex].value.properties[0].value);
        };
        VCServerSettingService.prototype.parseMailSettings = function (settingProperties) {
            var mailIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_MAIL });
            settingProperties[mailIndex].titleLabel =
                this.i18n("vcMailConfigPage.title");
            settingProperties[mailIndex].titleLabelContent =
                settingProperties[mailIndex].value.properties[0].value;
        };
        VCServerSettingService.prototype.parseSNMPSettings = function (settingProperties) {
            var snmpReceiverIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_SNMP_RECEIVER });
            settingProperties[snmpReceiverIndex].titleLabel =
                this.i18n("vcSnmpConfigPage.title");
        };
        VCServerSettingService.prototype.parsePortsSettings = function (settingProperties) {
            var portIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_PORTS });
            settingProperties[portIndex].titleLabel =
                this.i18n("vcPortsConfigPage.title");
            settingProperties[portIndex].titleLabelContent = this.i18n("vcConfigView.httpPortLabel", settingProperties[portIndex].value.properties[0].value) + "\t\t\t" + this.i18n("vcConfigView.httpsPortLabel", settingProperties[portIndex].value.properties[1].value);
        };
        VCServerSettingService.prototype.parseTimeoutSettings = function (settingProperties) {
            var timeoutIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_TIMEOUT });
            settingProperties[timeoutIndex].titleLabel =
                this.i18n("vcTimeoutConfigPage.title");
            settingProperties[timeoutIndex].titleLabelContent = this.i18n("vcConfigView.normalTimeoutLabel", settingProperties[timeoutIndex].value.properties[0].value) + "\t\t" + this.i18n("vcConfigView.longTimeoutLabel", settingProperties[timeoutIndex].value.properties[1].value);
        };
        VCServerSettingService.prototype.parseLoggingSettings = function (settingProperties) {
            var loggingIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_LOGGING });
            settingProperties[loggingIndex].titleLabel =
                this.i18n("vcLogConfigPage.title");
            settingProperties[loggingIndex].titleLabelContent = this.i18n("vcConfigView.logLevelLabel", settingProperties[loggingIndex].value.properties[0].value);
        };
        VCServerSettingService.prototype.parseSSLSettings = function (settingProperties) {
            var sslIndex = _.findIndex(settingProperties, { name: VCServerSettingConstants.KEY_SSL });
            settingProperties[sslIndex].titleLabel =
                this.i18n("vcSslConfigPage.title");
            settingProperties[sslIndex].titleLabelContent = this.i18n(settingProperties[sslIndex].value.properties[0].value ?
                "vcConfigView.verifySslCertificatesEnabled" :
                "vcConfigView.verifySslCertificatesDisabled");
        };
        VCServerSettingService.$inject = [
            "dataService",
            "i18nService",
            "numberFormatterService"
        ];
        return VCServerSettingService;
    }());
    common_module_ui.VCServerSettingService = VCServerSettingService;
    var StorageUnit;
    (function (StorageUnit) {
        StorageUnit[StorageUnit["B"] = 0] = "B";
        StorageUnit[StorageUnit["KB"] = 1] = "KB";
        StorageUnit[StorageUnit["MB"] = 2] = "MB";
        StorageUnit[StorageUnit["GB"] = 3] = "GB";
        StorageUnit[StorageUnit["TB"] = 4] = "TB";
        StorageUnit[StorageUnit["PB"] = 5] = "PB";
    })(StorageUnit || (StorageUnit = {}));
    angular.module("com.vmware.vsphere.client.commonModule")
        .service("vcServerSettingService", VCServerSettingService);
})(common_module_ui || (common_module_ui = {}));



var h5_client;
(function (h5_client) {
    var common_module_ui;
    (function (common_module_ui) {
        var VersionInformationController = (function () {
            function VersionInformationController($scope, dataService) {
                var _this = this;
                this.$scope = $scope;
                this.dataService = dataService;
                this.ABOUT_INFO_PROP = "aboutInfo";
                var objectId = this.$scope._route.objectId ||
                    this.$scope._vxViewNodeData.node.contentSpec.metadata.objectId;
                this.dataService.getProperties(objectId, [this.ABOUT_INFO_PROP]).then(function (response) {
                    _this.version = response.aboutInfo.version;
                    _this.build = response.aboutInfo.build;
                });
            }
            VersionInformationController.$inject = [
                "$scope",
                "dataService"
            ];
            return VersionInformationController;
        }());
        common_module_ui.VersionInformationController = VersionInformationController;
        angular.module("com.vmware.vsphere.client.commonModule")
            .controller("VersionInformationController", VersionInformationController);
    })(common_module_ui || (common_module_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.commonModule')
      .controller('ViHomeController', ViHomeController);

   ViHomeController.$inject = ['dataService', 'i18nService'];

   function ViHomeController(dataService, i18nService) {
      var self = this;

      self.objectId = "urn:vmomi:Folder:aggregatedData:serverGUID";

      self.getObjSummaryData = function () {
         dataService.getData(self.objectId,
            "com.vmware.vsphere.client.folder.model.AggregatedFolderSummaryData").then(function(data) {
            self.summaryData = data;
         });
      };

      self.getObjSummaryData();

      self.getFreeCapacity = function (resourceMeter) {
         return resourceMeter.progress > 100 ?
            i18nService.getString('Common', 'ResourceAllocationComponent.overusedCapFormat', resourceMeter.free) :
            i18nService.getString('Common', 'ResourceAllocationComponent.freeCapFormat', resourceMeter.free);
      };
   }

})();




/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.storage = {
   angularModule: angular.module('com.vmware.vsphere.client.storage', [
      'com.vmware.platform.ui', 'com.vmware.vsphere.client.networkLibUi', 'ngCookies'])
};

/*
 * Registers datastore-list specific column renderers.
 */
angular.module('com.vmware.vsphere.client.storage')
.run(['columnRenderersRegistry', 'i18nService', 'datastoreConstants',
function(columnRenderersRegistry, i18nService, datastoreConstants) {
   columnRenderersRegistry.registerColumnRenderers({
      /**
       * Localizes datastore Type column (specificType property) and takes care if it
       * is null.
       * @param  {array} props Array of property names, where 1st property is
       *    specificType. Other properties are ignored
       * @param  {object} data  Map of values, contains the specificType.
       */
      'datastore-type': function(props, data) {
         var displayText;
         var dsType = data[props[0]];
         if (!dsType) {
            displayText = '';
         } else {
            var dsTypeLower = dsType.toLowerCase();
            switch (dsTypeLower) {
               case datastoreConstants.datastoreSpecificType.nfs3.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.nfs3");
                  break;
               case datastoreConstants.datastoreSpecificType.nfs41.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.nfs41");
                  break;
               case datastoreConstants.datastoreSpecificType.vsan.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.vsan");
                  break;
               case datastoreConstants.datastoreSpecificType.vvol.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.vvol");
                  break;
               case datastoreConstants.datastoreSpecificType.vmfs3.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.vmfs3");
                  break;
               case datastoreConstants.datastoreSpecificType.vmfs5.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.vmfs5");
                  break;
               case datastoreConstants.datastoreSpecificType.vmfs6.toLowerCase() :
                  displayText = i18nService.getString("StorageUi", "datastore.specificType.vmfs6");
                  break;
               default :
                  displayText = dsType;
               }
         }

         return '<div title="' + displayText + '">' + displayText + '</div>';
      },
      /**
       * Datastore cluster name column - icon-link renderer.
       *
       * @param  {array} props Array of property names, where 1st property is
       *    policy name. Other properties are ignored.
       * @param  {object} data  Map of values, contains the specificType.
       * @param {object} config A dictionary (key/value) to control the renderer behavior.
       */
      'ds-cluster-name': function(props, data, config) {
         var objLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
         return objLinkRenderer(
               [props[0], props[1], 'vsphere-icon-datastore-cluster'], data, config);
      },
      /**
       * Localizes datastore VM Storage Policy column.
       *
       * @param  {array} props Array of property names, where 1st property is
       *    policy name. Other properties are ignored.
       * @param  {object} data  Map of values, contains the specificType.
       */
      'storage-policy-name': function(props, data) {
         var sotragePolicyName = data[props[0]];
         if (!sotragePolicyName) {
            sotragePolicyName = i18nService.getString(
                  'StorageUi', 'datastore.policy.notAvailable');
         }

         return '<div title="' + sotragePolicyName + '">' + sotragePolicyName + '</div>';
      }
   });
}])
.run(['mutationService', 'i18nService', 'clarityModalService','vxValidatorFactory', 'renameFileService', 'deleteFilesService', 'storageValidationService',
   function ( mutationService, i18nService, clarityModalService, vxValidatorFactory, renameFileService, deleteFilesService, storageValidationService) {
      /*
       * Action creating a new folder in a datastore browser.
       */
      h5.actions["vsphere.core.datastore.actions.createFolder"] =

         function(actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context && !context.currentPath) {
               return;
            }

            var datastoreTargetName = context.currentPath.slice(1, context.currentPath.length - 1);

            var name = {
               value: i18nService.getString('StorageUi','datastore.fileManager.defaultFolderName')
            };
            var validator = vxValidatorFactory.create();
            var modalOptions = {
               contentTemplate: 'storage-ui/resources/storage/views/manage/files/CreateNewFolderView.html',
               title: i18nService.getString('StorageUi', 'actionCreateFolderDescription'),
               subTitle: {
                  text: datastoreTargetName
               },
               defaultButton:'submit',
               dialogData: {
                  name: name,
                  prompt: i18nService.getString('StorageUi', 'datastore.fileManager.folderNamePrompt'),
                  validator: validator,
                  isValidFolderName: storageValidationService.validateDatastoreBrowserItemName
                        .bind(storageValidationService)
               },
               alerts: [],
               onSubmit: function() {
                  var errors = validator.validate();
                  if (errors && errors.length) {
                     return false;
                  }

                  var folderName =  name.value.trim();
                  // Root folder names for datastores having supportTopLevelDirectoryCreate capability
                  // should start with datastore name, which is the current path.
                  var folderPath = (context.isRootFolder && !context.topLevelDirectoryCreateSupported)
                     ? folderName
                     : context.currentPath + '/' + folderName;

                 mutationService.apply(
                     availableTargets[0],
                     "com.vmware.vsphere.client.h5.storage.spec.DatastoreCreateFolderSpec",
                     {
                        datacenter: context.datastoreDatacenter,
                        isRootFolder: context.isRootFolder,
                        supportTopLevelDirectoryCreate: context.topLevelDirectoryCreateSupported,
                        folderName: folderPath
                     }).then(function (result) {
                        if (context.callback) {
                           context.callback(result);
                        }
                  });
                  return true;
               }
            };

            clarityModalService.openOkCancelModal(modalOptions);
         };

      /*
       * Action for deleting files or folders on a datastore
       */
      h5.actions["vsphere.core.datastore.actions.deleteFile"] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            deleteFilesService.openDeleteFilesDialog(availableTargets[0], context.targetFileNames,
                  context.spec, context.callback);
         };

      h5.actions["vsphere.core.datastore.actions.renameFile"] =
            function (actionEval, availableTargets, context) {
               if (!availableTargets || !availableTargets.length || !context) {
                  return;
               }

               renameFileService.openRenameFileDialog(availableTargets[0], context.spec, context.callback);
            };
   }])
.run(['fileDownloadService', 'folderDownloadService', 'streamVmdkService', '$q',
      function(fileDownloadService, folderDownloadService, streamVmdkService, $q) {

      h5.actions["vsphere.core.datastore.actions.downloadFromDatastore"] =
            function (actionEval, availableTargets, datastoreBrowserContext) {
               if (!availableTargets || !availableTargets.length || !datastoreBrowserContext) {
                  return;
               }

               downloadFiles(datastoreBrowserContext);
            };

      function downloadFiles(datastoreBrowserContext) {

         var datastoreId = datastoreBrowserContext.datastoreId;

         var filesToDownloadPromise;
         var isFolderDownload = false;
         if (datastoreBrowserContext.selectedFiles &&
               datastoreBrowserContext.selectedFiles.length === 1 &&
               datastoreBrowserContext.selectedFiles[0].type === 'folder') {
            filesToDownloadPromise = folderDownloadService.getFolderChildren(
                  datastoreId, datastoreBrowserContext.selectedFiles[0]);
            isFolderDownload = true;
         } else if (datastoreBrowserContext.isStreamFormat
               && datastoreBrowserContext.selectedFiles
               && datastoreBrowserContext.selectedFiles.length === 1
               && datastoreBrowserContext.selectedFiles[0].diskExtents) {
            // the selected file is vSAN VMDK
            filesToDownloadPromise = streamVmdkService
                  .openStreamVmdkWarningDialog(datastoreBrowserContext.selectedFiles);
         } else {
            filesToDownloadPromise = $q.when(datastoreBrowserContext.selectedFiles);
         }

         filesToDownloadPromise.then( function(filesToDownload) {
               var datastoreDcRef = datastoreBrowserContext.datastoreDcRef;
               var pathsToFilesToDownload = [];
               var zipFileName = "";
               var isStreamFormat = false;

               _.forEach(filesToDownload, function (selectedFile) {

                  isStreamFormat = isStreamFormat
                        || (selectedFile.diskExtents && datastoreBrowserContext.isStreamFormat);
                  // Selected file and paths to VMDK extents if available
                  pathsToFilesToDownload.push(selectedFile.path);
                  if (selectedFile.diskExtents && !isStreamFormat) {
                     // Slice casts the diskExtents to Array
                     pathsToFilesToDownload =
                           pathsToFilesToDownload.concat(selectedFile.diskExtents.slice());
                  }

                  zipFileName = datastoreBrowserContext.zipFileName || (selectedFile.name + ".zip");
               });

               if (pathsToFilesToDownload && pathsToFilesToDownload.length > 0) {
                  if (pathsToFilesToDownload.length === 1 && !isFolderDownload) {
                     // If there is only one file to download start download.
                     fileDownloadService.startFilesDownload(datastoreDcRef, datastoreId,
                           pathsToFilesToDownload, isStreamFormat);
                  } else {
                     // If there is more than one file to download
                     // download them as single zip file.
                     fileDownloadService.startFilesDownloadAsZip(
                           datastoreDcRef, datastoreId, pathsToFilesToDownload, zipFileName,
                           isFolderDownload ? datastoreBrowserContext.selectedFiles[0].path : undefined, isStreamFormat);

                  }
               }

            }
         );
      }
   }])
.run(['fileCopyService', function(fileCopyService) {
   h5.actions['vsphere.core.datastore.actions.copyFile'] =
      function (actionEval, availableTargets, context) {
         if (!availableTargets || !availableTargets.length || !context) {
            return;
         }

         var type = "com.vmware.vsphere.client.storage.DatastoreFileCopySpec";

         fileCopyService.copyFiles(availableTargets[0], context.datastoreDcRef, context.selectedFiles, type, context.callback);
      };
   }])
.run(['fileCopyService', function(fileCopyService) {
      h5.actions['vsphere.core.datastore.actions.moveFile'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            var type = "com.vmware.vsphere.client.storage.DatastoreFileMoveSpec";

            fileCopyService.copyFiles(availableTargets[0], context.datastoreDcRef, context.selectedFiles, type, context.callback);
         };
   }])
.run(['fileUploadService',
   function (fileUploadService) {

      h5.actions['vsphere.core.datastore.actions.uploadToDatastore'] =
            function (actionEval, availableTargets, datastoreBrowserContext) {
               if (!availableTargets || !availableTargets.length || !datastoreBrowserContext) {
                  return;
               }

               fileUploadService.startFilesUpload(
                     datastoreBrowserContext.datastoreDcRef,
                     datastoreBrowserContext.datastoreId,
                     datastoreBrowserContext.path,
                     datastoreBrowserContext.files,
                     datastoreBrowserContext.isDatastoreSelected,
                     datastoreBrowserContext.isStreamFormat
               );
            };
   }])
.run(['mutationService', function(mutationService) {

   h5.actions["vsphere.core.datastore.inflateDiskAction"] =
      function(actionEval, availableTargets, context) {
         if (availableTargets && availableTargets.length === 1 && context && context.spec) {
            mutationService.apply(
               availableTargets[0],
               'com.vmware.vsphere.client.storage.InflateDiskSpec',
               context.spec).then(function (result) {
               if (context.callback) {
                  context.callback(result);
               }
            });
         }
      };

}])
.run(['$window', function($window) {
   h5.actions["vsphere.core.datastore.actions.popupDsBrowser"] =
      function(actionEval, availableTargets, context) {
         if (availableTargets && availableTargets.length === 1) {

            var hashQueryString = $.param({
               "datastoreId": availableTargets[0]
            });

            var urlBuilder = document.createElement("a");
            urlBuilder.href = "datastore-browser";
            urlBuilder.hash = "?" + hashQueryString;

            if (h5.debug) {
               var queryString = $.param({
                  "debug": true
               });
               urlBuilder.search = queryString;
            }

            var url = urlBuilder.href;
            $window.open(url, "_blank",
               "width=980,height=640,toolbar=0,location=0,menubar=0,resizable=1,noopener");
         }
      };
}])
.run(['$rootScope', 'mutationService', 'dataService', 'datastoreConstants',
      'clarityModalService', 'selectVmToRegisterService', 'actionsService',
   function ($rootScope, mutationService, dataService, datastoreConstants,
         clarityModalService, selectVmToRegisterService, actionsService) {

      h5.actions["vsphere.core.datastore.actions.browseFiles"] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               if ($rootScope && $rootScope._navigateToViewAndObject) {
                  $rootScope._navigateToViewAndObject(
                        'vsphere.core.datastore.manage.filesView',
                        availableTargets[0]);
               }
            };

      h5.actions["vsphere.core.datastore.actions.registerVm"] = function(actionEval, availableTargets) {
         if (!availableTargets || !availableTargets.length) {
            return;
         }

         var datastoreId = availableTargets[0];

         var onVmFileSelected = function(selectedVmFileItem) {
            var vmFileName = selectedVmFileItem.name;
            var vmFileExtension =
                  vmFileName.substring(vmFileName.lastIndexOf('.') + 1);
            var context = {
               vmName: vmFileName.substring(0, vmFileName.lastIndexOf('.')),
               vmFilePath: selectedVmFileItem.path,
               isTemplate: vmFileExtension === 'vmtx'
            };
            var registerVmActionId = actionEval.additionalData.registerVmActionId;
            var registerVmEvalStatus = [];
            registerVmEvalStatus[datastoreId] = {
               available: true
            };

            var registerVmActionEval = {
               action: {
                  uid: registerVmActionId
               },
               invoker: registerVmActionId,
               evaluationStatuses: registerVmEvalStatus,
               available: true
            };
            actionsService.invokeAction(registerVmActionEval, context);
         };
         selectVmToRegisterService.browseFile(datastoreId, onVmFileSelected);
      };

      h5.actions["vsphere.core.datastore.actions.rename"] = function(actionEval, availableTargets) {
         if(!availableTargets || !availableTargets.length) {
            return;
         }

         var dsRef = availableTargets[0];
         dataService.getProperties(dsRef, ['summary.type', 'name']).then(
               function(dsTypeResponse) {

                  var dsType = dsTypeResponse && dsTypeResponse['summary.type']
                        ? dsTypeResponse['summary.type'].toLowerCase()
                        : null;

                  var dsMaxNameLength = datastoreConstants.maxNameLengthForNonNfsDatastore;
                  if(dsType === datastoreConstants.nfsVersions.NFS_3 ||
                        dsType === datastoreConstants.nfsVersions.NFS_4_1) {
                     dsMaxNameLength = datastoreConstants.maxNameLengthForNfsDatastore;
                  }

                  clarityModalService.openModal(
                        actionEval,
                        availableTargets,
                        {
                           objectId: dsRef,
                           maxNameLength: dsMaxNameLength,
                           existingObjectName: dsTypeResponse.name
                        },
                        'common-module-ui/resources/common-module/views/rename/renameObject.html'
                  );
               });
      };

      h5.actions["vsphere.core.datastore.actions.refresh"] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               mutationService.applyOnMultiEntity(availableTargets,
                     'com.vmware.vsphere.client.storage.DatastoreRefreshSpec', {
                        _type: 'com.vmware.vsphere.client.storage.DatastoreRefreshSpec'
                     });
            };

      h5.actions["vsphere.core.datastore.actions.deleteVmfs"] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               mutationService.removeOnMultiEntity(availableTargets, 'com.vmware.vsphere.client.storage.DatastoreRemovalSpec', {});
            };

   }])
.run(['$rootScope', 'addDatastoreWizardService', 'increaseDatastoreCapacityWizardService',
   function ($rootScope, addDatastoreWizardService, increaseDatastoreCapacityWizardService) {

      h5.actions['vsphere.core.datastore.actions.add'] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               addDatastoreWizardService.showWizard(availableTargets[0]);
            };

      h5.actions['vsphere.core.datastore.actions.increaseCapacity'] =
         function ShowDatastoreIncreaseCapacityWizard(actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            increaseDatastoreCapacityWizardService.showWizard(availableTargets[0]);
         };
   }])
.run(['upgradeVmfsDatastoreModalService',
   function (upgradeVmfsDatastoreModalService) {
      h5.actions['vsphere.core.datastore.actions.upgradeVmfsDatastore'] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               upgradeVmfsDatastoreModalService.openDialog(availableTargets);
            };
   }])
.run(['mutationService',
   function (mutationService) {

      h5.actions['vsphere.core.host.actions.refreshStorageSystem'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            mutationService.apply(
               availableTargets[0],
               'com.vmware.vsphere.client.storage.StorageSystemRefreshSpec', {
                  _type: 'com.vmware.vsphere.client.storage.StorageSystemRefreshSpec'
               }).then(
                  function (result) {
                     if (context && context.callback) {
                        context.callback(result);
                     }
                  }
               );
         };
   }])
.run(['mutationService',
      function (mutationService) {
         h5.actions['vsphere.core.host.actions.rescanHba'] =
            function (actionEval, availableTargets, context) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               mutationService.apply(
                  availableTargets[0],
                  'com.vmware.vsphere.client.storage.adapters.StorageAdapterRescanSpec', {
                     adapterKey: context.adapterKey
                  }).then(
                  function (result) {
                     if (context && context.callback) {
                        context.callback(result);
                     }
                  }
               );
            };
      }])
.run(['addSoftwareAdapterDialogService',
   function (addSoftwareAdapterDialogService) {
      h5.actions['vsphere.core.host.actions.adapters.addSoftwareAdapter'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }
            addSoftwareAdapterDialogService.show(availableTargets[0], context);
         };
   }])
.run(['AddIscsiTargetDialogService',
   function (AddIscsiTargetDialogService) {

      h5.actions['vsphere.core.host.actions.adapters.addIscsiTarget'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            AddIscsiTargetDialogService.openAddIscsiTargetDialog(
                  context.adapter, availableTargets[0], context.dynamicTarget, context.targets, context);
            };
      }])
.run(['editIscsiAdvancedOptionsService',
   function (editIscsiAdvancedOptionsService) {

      h5.actions['vsphere.core.host.actions.adapters.editAdvancedOptionsForAdapter'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            editIscsiAdvancedOptionsService.showAdvancedOptionsDialogForAdapter(availableTargets[0], context.hba);
         };

      h5.actions['vsphere.core.host.actions.adapters.editAdvancedOptionsForTarget'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            editIscsiAdvancedOptionsService.showAdvancedOptionsDialogForTarget(availableTargets[0], context.hba, context.targetSet);
         };
   }])
.run(['clarityModalService', 'i18nService', 'adapterTargetsService',
   function(clarityModalService, i18nService, adapterTargetsService) {

      h5.actions['vsphere.core.host.actions.adapters.removeIscsiTarget'] =
         function(actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context || !context.adapter) {
               return;
            }

            var dialogProperties = {
               title: i18nService.getString('StorageUi', 'storage.adapters.iscsiTargets.actions.remove.header', context.adapter.device),
               message: i18nService.getString('StorageUi', 'storage.adapters.iscsiTargets.actions.remove.message'),
               submit: function () {
                  adapterTargetsService.removeIscsiAdapterTargets(
                        availableTargets[0],
                        context.dynamicTarget,
                        context.adapter.device,
                        context.target)
                        .then(function (result) {
                           if (result && result.effect && result.effect.affectedEntites
                                 && result.effect.affectedEntites.length) {
                              // Notify that remove is performed
                              if (context && context.callback) {
                                 context.callback(result, context.adapter);
                              }
                           }
                        });
                  return true;
               }
            };

            clarityModalService.openConfirmationModal(dialogProperties);
         };
   }])
.run(['storageAdapterEditAuthenticationService', 'adapterStatusService',
   'hostStorageConstants', 'swIscsiEditSettingsDialogService',
   function(storageAdapterEditAuthenticationService, adapterStatusService,
         hostStorageConstants, swIscsiEditSettingsDialogService) {

      h5.actions['vsphere.core.host.actions.adapters.editAuthSettingsIscsiTarget'] =
         function(actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context || !context.adapter || !context.target) {
               return;
            }

            storageAdapterEditAuthenticationService.editAuthSettingsIscsiTarget(
               availableTargets[0],
               context.adapter,
               context.target,
               context.parentDynamicTargetAuthProperties,
               context.callback
            );
         };

      h5.actions['vsphere.core.host.actions.adapters.editIscsiAuthenticationSettings'] =
            function (actionEval, availableTargets, context) {
               if (!availableTargets || !availableTargets.length || !context || !context.adapter) {
                  return;
               }
               storageAdapterEditAuthenticationService
                     .openModal(availableTargets[0], context.adapter);
            };

      h5.actions['vsphere.core.host.actions.adapters.editIscsiGeneralSettings'] =
            function (actionEval, availableTargets, context) {
               if (availableTargets.length && context && context.adapter) {
                  swIscsiEditSettingsDialogService.openModal(availableTargets[0], context.adapter);
               }
            };

      h5.actions['vsphere.core.host.actions.adapters.disableSoftwareIscsiAdapter'] =
         function(actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context || !context.adapter) {
               return;
            }
            var opts = {
               hostId: availableTargets[0],
               // iSCSI or FCoE
               isIscsiAdapter: context.adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI,
               deviceName: context.adapter.device,
               onSuccessCallback: context.callback
            };

            adapterStatusService.disable(opts);
         };

      h5.actions['vsphere.core.host.actions.adapters.enableSoftwareIscsiAdapter'] =
            function(actionEval, availableTargets, context) {
               if (!availableTargets || !availableTargets.length || !context || !context.adapter) {
                  return;
               }
               var opts = {
                  hostId: availableTargets[0],
                  // iSCSI or FCoE
                  isIscsiAdapter: context.adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI,
                  deviceName: context.adapter.device
               };
               adapterStatusService.enable(opts).then(function (response) {
                  context.callback(response);
               });
            };
   }])
.run(['defaultUriSchemeUtil', 'rescanStorageDialogService',
   function (defaultUriSchemeUtil, rescanStorageDialogService) {
      h5.actions['vsphere.core.host.actions.rescan'] =
            function (actionEval, availableTargets) {
               var targetObjects = defaultUriSchemeUtil.getManagedObjectReferences(availableTargets);
               if (!targetObjects || !targetObjects.length) {
                  return;
               }

               rescanStorageDialogService.open(targetObjects);
            };
   }
])
.run(['modifyDatastoreDialogService', 'mutationService', 'i18nService', 'defaultUriSchemeUtil', 'affectHeartbeatDatastoreService',
   function (modifyDatastoreDialogService, mutationService, i18nService, defaultUriSchemeUtil, affectHeartbeatDatastoreService) {

      h5.actions['vsphere.core.datastore.actions.mountVmfs'] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            modifyDatastoreDialogService.openModifyDatastoreDialog(
               availableTargets[0],
               i18nService.getString('StorageUi', 'vmfsDatastore.mountDialogTitle'),
               'datastoreOperations:availableHostsForMountVmfs',
               function(selectedHosts) {
                  var hostIds = _.map(selectedHosts, function(hostData) {
                     return defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
                  });
                  mutationService.applyOnMultiEntity(
                     hostIds,
                     'com.vmware.vsphere.client.storage.VmfsDatastoreHostsMountSpec',
                     {
                        datastoreToMount: defaultUriSchemeUtil.getManagedObjectReference(availableTargets[0])
                     },
                     i18nService.getString('StorageUi', 'modifyDatastoreForm.mountDatastore'));
                  return true;
               }
            );
         };

      h5.actions['vsphere.core.datastore.actions.mountNfs'] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            modifyDatastoreDialogService.openModifyDatastoreDialog(
               availableTargets[0],
               i18nService.getString('StorageUi', 'nfsDatastore.mountDialogTitle'),
               'datastoreOperations:availableHostsForMountNfs',
               function(selectedHosts) {
                  var hostIds = _.map(selectedHosts, function(hostData) {
                     return hostData.hostRef;
                  });
                  mutationService.applyOnMultiEntity(
                     [availableTargets[0]],
                     'com.vmware.vsphere.client.h5.storage.spec.MountNfsDatastoreSpec',
                     {
                        hostsToMount: hostIds
                     },
                     i18nService.getString('StorageUi', 'modifyDatastoreForm.mountNfsDatastore'));
                  return true;
               }
            );
         };

      h5.actions['vsphere.core.datastore.actions.unmountVmfs'] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            modifyDatastoreDialogService.openModifyDatastoreDialog(
               availableTargets[0],
               i18nService.getString('StorageUi', 'vmfsDatastore.unmountDialogTitle'),
               'datastoreOperations:availableHostsForUnmount',
               function(selectedHosts) {
                  var hostIds = _.map(selectedHosts, function(hostData) {
                     return defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
                  });
                  var hostRefs = _.map(selectedHosts, function (hostData) {
                     return hostData.hostRef;
                  });

                  return affectHeartbeatDatastoreService
                     .checkForAffectedClusters(availableTargets[0], hostRefs)
                     .then(function(isConfirmed) {
                        if (isConfirmed) {
                           mutationService.applyOnMultiEntity(
                              hostIds,
                              'com.vmware.vsphere.client.storage.VmfsDatastoreUnmountSpec',
                              {
                                 datastoreToUnmount: defaultUriSchemeUtil.getManagedObjectReference(availableTargets[0])
                              },
                              i18nService.getString('StorageUi', 'modifyDatastoreForm.unmountDatastore'));
                           return true;
                        }
                        // Do not close the dialog since since the warning has not been confirmed.
                        return false;
                     });
               },
               'storage-ui/resources/storage/views/datastore/UnmountVmfsDatastoreDialogHeader.html'
            );
         };

      h5.actions['vsphere.core.datastore.actions.unmountNfs'] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               if (availableTargets.length > 1) {
                  modifyDatastoreDialogService.openRemoveDatastoreDialog(
                     availableTargets,
                     i18nService.getString('StorageUi', 'actionUnmountDatastoreCaption'),
                     i18nService.getString('StorageUi', 'actionUnmountDatastoreWarning'),
                     function() {
                        mutationService.removeOnMultiEntity(
                           availableTargets,
                           "com.vmware.vsphere.client.storage.DatastoreRemovalSpec",
                           {selectedContextObject:defaultUriSchemeUtil.getManagedObjectReference(availableTargets[0])},
                           i18nService.getString('StorageUi', 'modifyDatastoreForm.removeDatastore')
                        );
                        return true;
                     }
                  );
               } else {
                  modifyDatastoreDialogService.openModifyDatastoreDialog(
                     availableTargets[0],
                     i18nService.getString('StorageUi', 'vmfsDatastore.unmountDialogTitle'),
                     'datastoreOperations:availableHostsForUnmountNfs',
                     function (selectedHosts, allHostsSelected) {
                        var hostIds = _.map(selectedHosts, function (hostData) {
                           return defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
                        });
                        var hostRefs = _.map(selectedHosts, function (hostData) {
                           return hostData.hostRef;
                        });

                        return affectHeartbeatDatastoreService
                           .checkForAffectedClusters(availableTargets[0], hostRefs)
                           .then(function(isConfirmed) {
                              if (isConfirmed) {
                                 var mutationParams = [
                                    hostIds,
                                    'com.vmware.vsphere.client.storage.NfsDatastoreRemovalSpec',
                                    {
                                       datastoreToRemove: defaultUriSchemeUtil.getManagedObjectReference(availableTargets[0])
                                    },
                                    i18nService.getString('StorageUi', 'modifyDatastoreForm.unmountNfsDatastore')];

                                 if (allHostsSelected) {
                                    mutationService.removeOnMultiEntity.apply(mutationService, mutationParams);
                                 } else {
                                    mutationService.applyOnMultiEntity.apply(mutationService, mutationParams);
                                 }
                                 return true;
                              }
                              // Do not close the dialog since since the warning has not been confirmed.
                              return false;
                           });
                     },
                     'storage-ui/resources/storage/views/datastore/UnmountVmfsDatastoreDialogHeader.html'
                  );
               }
            };

      h5.actions['vsphere.core.datastore.actions.unmountVvol'] =
         function(actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }
            modifyDatastoreDialogService.openModifyDatastoreDialog(
               availableTargets[0],
               i18nService.getString('StorageUi', 'vmfsDatastore.unmountDialogTitle'),
               'datastoreOperations:availableHostsForUnmount',
               function(selectedHosts) {
                  var hostIds = _.map(selectedHosts, function(hostData) {
                     return defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
                  });
                  mutationService.removeOnMultiEntity(
                     hostIds,
                     'com.vmware.vsphere.client.storage.vvol.RemoveVvolDatastoreSpec', {
                        datastore: defaultUriSchemeUtil.getManagedObjectReference(availableTargets[0])
                     },
                     i18nService.getString('StorageUi', 'modifyDatastoreForm.unmountVvolDatastore')
                  );
                  return true;
               },
               'storage-ui/resources/storage/views/datastore/UnmountVmfsDatastoreDialogHeader.html'
            );
         };

      h5.actions['vsphere.core.datastore.actions.mountVvol'] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }
               modifyDatastoreDialogService.openModifyDatastoreDialog(
                     availableTargets[0],
                     i18nService.getString('StorageUi', 'actionMountVvolDatastore'),
                     'datastoreOperations:availableHostsForMountVvol',
                     function (selectedHosts) {
                        var hostIds = _.map(selectedHosts, function (hostData) {
                           return hostData.hostRef;
                        });

                        mutationService.apply(
                              availableTargets[0],
                              'com.vmware.vsphere.client.h5.storage.spec.MountVvolDatastoreSpec',
                              {
                                 hostsToMount: hostIds
                              },
                              i18nService.getString('StorageUi', 'modifyDatastoreForm.mountDatastore'));
                        return true;
                     });
            };

   }])
.run(['mutationService', 'i18nService',
   function (mutationService, i18nService) {

      h5.actions['vsphere.core.host.actions.paths.enablePath'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            mutationService.apply(
               availableTargets[0],
               'com.vmware.vsphere.client.storage.adapters.StoragePathEnableSpec',
               {
                  pathName: context.pathName,
                  enable: true
               },
               i18nService.getString('StorageUi', 'storage.paths.actions.enableTask'));
         };

      h5.actions['vsphere.core.host.actions.paths.disablePath'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            mutationService.apply(
               availableTargets[0],
               'com.vmware.vsphere.client.storage.adapters.StoragePathEnableSpec',
               {
                  pathName: context.pathName,
                  enable: false
               },
               i18nService.getString('StorageUi', 'storage.paths.actions.disableTask'));
         };
   }])
.run(['storageDeviceMultipathingPolicyDialogService',
   function (storageDeviceMultipathingPolicyDialogService) {

      h5.actions['vsphere.core.host.actions.storageDevice.editMultipathingPolicy'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            storageDeviceMultipathingPolicyDialogService.show(availableTargets[0], context.deviceId, context.name);
         };

   }])
.run(['mutationService', 'i18nService', 'clarityModalService',
   function (mutationSerivce, i18nService, clarityModalService) {

      h5.actions['vsphere.core.host.actions.storageDevice.unmount'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            var modalOptions = {
               message: i18nService.getString(
                     'StorageUi', 'storage.adapters.devices.action.unmount.text', context.name),
               title: i18nService.getString(
                     'StorageUi', 'storage.adapters.devices.action.unmount.title'),
               saveButtonLabel: i18nService.getString('Common', 'yes.label'),
               cancelButtonLabel: i18nService.getString('Common', 'no.label'),
               preserveNewlines: true,
               defaultButton: 'submit',
               showXIcon: false,
               clarityIcon: { class: 'is-warning', shape: 'warning', size: 48 },
               subTitle: { objectId: availableTargets[0] },
               submit: function () {
                  // dispatch an unmount request
                  // additional context for mount/unmount and lunUUID
                  var spec = {
                     _type: 'com.vmware.vsphere.client.storage.adapters.StorageDeviceMountSpec',
                     lunUuid: context.lunUuid,
                     mount: false
                  };

                  mutationSerivce.apply(
                        availableTargets[0],
                        spec._type,
                        spec,
                        i18nService.getString(
                              'StorageUi', 'storage.adapters.devices.action.unmount.taskName'));
               }
            };

            clarityModalService.openConfirmationModal(modalOptions);
         };

      h5.actions['vsphere.core.host.actions.storageDevice.mount'] =
         function (actionEval, availableTargets, context) {
            if (!availableTargets || !availableTargets.length || !context) {
               return;
            }

            // dispatch a mount request
            // additional context for mount/unmount and lunUUID
            var spec = {
               _type: 'com.vmware.vsphere.client.storage.adapters.StorageDeviceMountSpec',
               lunUuid: context.lunUuid,
               mount: true
            };

            mutationSerivce.apply(
               availableTargets[0],
               spec._type,
               spec,
               i18nService.getString(
                  'StorageUi', 'storage.adapters.devices.action.mount.taskName'));
         };

   }])
.run(['datastoreConfigIOControlDialogService',
   function (datastoreConfigIOControlDialogService) {
      h5.actions['vsphere.core.datastore.actions.configSIOC'] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            datastoreConfigIOControlDialogService.show(availableTargets);
         };
   }])
.run(['datastoreSpaceReclamationPriorityDialogService',
   function (datastoreSpaceReclamationPriorityDialogService) {
      h5.actions['vsphere.core.datastore.actions.spaceReclamationPriorityAction'] =
         function (actionEval, availableTargets) {
            if (!availableTargets || !availableTargets.length) {
               return;
            }

            datastoreSpaceReclamationPriorityDialogService.show(availableTargets);
         };
   }])
.run(['renameStorageDeviceDialogService',
   function (dialogService) {
      h5.actions["vsphere.core.host.actions.storageDevice.rename"] =
         function(actionEval, availableTargets, contextObject) {
            if (!availableTargets || !availableTargets.length || !contextObject) {
               return;
            }

            dialogService.show(availableTargets[0], contextObject.lunUuid, contextObject.name);
         };
   }])
.run(['mutationService', 'i18nService', function(mutationService, i18nService) {

   function changeDeviceTag (host, diskUids, isSsd) {
      mutationService.apply(
         host,
         "com.vmware.vsphere.client.storage.TagDiskAsSsdSpec",
         {
            isSSD: isSsd,
            diskUUID: diskUids
         },
         i18nService.getString('StorageUi',
            isSsd ? 'storage.adapters.devices.action.tagAsSsd.taskName'
                  : 'storage.adapters.devices.action.untagAsSsd.taskName')
      );
      return true;
   }

   h5.actions['vsphere.core.storage.devices.tagAsSSD'] =
      function(actionEval, availableTargets, disks) {
         if (!availableTargets || !availableTargets.length || !disks.length) {
            return true;
         }
         return changeDeviceTag(availableTargets[0],
            _.map(disks, function(disk) {
               return disk.lunUuid;
            }), true);
      };

   h5.actions['vsphere.core.storage.devices.tagAsHDD'] =
      function(actionEval, availableTargets, disks) {
         if (!availableTargets || !availableTargets.length || !disks.length) {
            return true;
         }
         return changeDeviceTag(availableTargets[0],
            _.pluck(disks, 'lunUuid'), false);
      };

}])
.run(['mutationService', 'defaultUriSchemeUtil', 'i18nService',
   function (mutationService, defaultUriSchemeUtil, i18nService) {
      h5.actions["vsphere.core.datastore.actions.mountVmfsSingleHost"] =
         function(actionEval, availableTargets, contextObject) {
            if (!availableTargets || !availableTargets.length || !contextObject) {
               return;
            }


            var spec = {
               _type: 'com.vmware.vsphere.client.storage.VmfsDatastoreHostsMountSpec',
               datastoreToMount: defaultUriSchemeUtil.getManagedObjectReference(contextObject.datastoreId)
            };

            mutationService.apply(
               availableTargets[0],
               spec._type,
               spec,
               i18nService.getString('StorageUi', 'modifyDatastoreForm.mountDatastore'));
         };

      h5.actions["vsphere.core.datastore.actions.unmountVmfsSingleHost"] =
         function(actionEval, availableTargets, contextObject) {
            if (!availableTargets || !availableTargets.length || !contextObject) {
               return;
            }


            var spec = {
               _type: 'com.vmware.vsphere.client.storage.VmfsDatastoreUnmountSpec',
               datastoreToUnmount: defaultUriSchemeUtil.getManagedObjectReference(contextObject.datastoreId)
            };

            mutationService.apply(
               availableTargets[0],
               spec._type,
               spec,
               i18nService.getString('StorageUi', 'modifyDatastoreForm.unmountDatastore'));
         };
   }])
.run(['storageProvidersService', 'storageProviderConstants',
   function (storageProvidersService, storageProviderConstants) {
      h5.actions[storageProviderConstants.actions.RESYNC_INTERNAL_PROVIDER] =
         function (actionEval, availableTargets) {
            if (availableTargets && availableTargets.length === 1) {
               storageProvidersService.resyncInternalVasaProviders(availableTargets[0]);
            }
         };
      h5.actions[storageProviderConstants.actions.REMOVE] =
         function (actionEval, availableTargets, context) {
            if (availableTargets && availableTargets.length === 1) {
               storageProvidersService.removeStorageProvider(availableTargets[0], context);
            }
         };
      h5.actions[storageProviderConstants.actions.SYNC] =
         function (actionEval, availableTargets, context) {
            if (availableTargets && availableTargets.length === 1) {
               storageProvidersService.syncProvider(availableTargets[0], context);
            }
         };

      h5.actions[storageProviderConstants.actions.REFRESH_CERTIFICATE] =
         function (actionEval, availableTargets, context) {
            if (availableTargets && availableTargets.length === 1) {
               storageProvidersService.refreshCertificate(availableTargets[0], context);
            }
         };
   }])
.run(['addStorageProviderDialogService',
   function (addStorageProviderDialogService) {
      h5.actions['vsphere.core.storage.storageProviders.addNew'] =
         function (actionEval, availableTargets, context) {
            if (availableTargets && availableTargets.length === 1) {
               addStorageProviderDialogService.showAddStorageProviderDialog(availableTargets[0], context.providerNames);
            }
         };
   }])
.run(['allocateSpaceDialogService',
   function (allocateSpaceDialogService) {
      h5.actions['vsphere.core.host.actions.vFlash.editCacheConfiguration'] =
         function (actionEval, availableTargets, context) {
            if (availableTargets && availableTargets.length === 1 && context && context.selectedDatastore) {
               allocateSpaceDialogService.openSpaceAllocationDialog(context.selectedDatastore, availableTargets[0]);
            }
         };
   }])
.run(['clarityModalService', 'i18nService', 'moveDatastoreToService',
   function (clarityModalService, i18nService, moveDatastoreToService) {
      h5.actions['vsphere.core.datastore.actions.moveTo'] =
            function (actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               var modalOptions = {
                  title: i18nService.getString('StorageUi', 'datastoreMoveToTitle'),
                  defaultButton: 'submit',
                  dialogData: {
                     objectIds: availableTargets
                  },
                  contentTemplate: 'storage-ui/resources/storage/views/datastore/moveDatastoreToDialog.html'
               };

               clarityModalService.openOkCancelModal(modalOptions);
            };
      h5.actions['vsphere.core.datastore.actions.moveDatastoreToDrag'] =
            function(actionEval, availableTargets, destinationTarget) {
               if (!availableTargets || !availableTargets.length || !destinationTarget) {
                  return;
               }


               moveDatastoreToService.moveDatastoreTo(destinationTarget.dropTarget, availableTargets);
            };
   }])
.run(['mutationService', 'i18nService', function(mutationService, i18nService) {
      function changeLed (host, diskUids, turnOn) {
         mutationService.apply(
            host,
            "com.vmware.vsphere.client.storage.LightDiskLedSpec",
            {
               turnOn : turnOn,
               diskUUID: diskUids
            },
            i18nService.getString('StorageUi',
               turnOn ? 'storage.adapters.devices.action.turnLedOn.taskName'
                  : 'storage.adapters.devices.action.turnLedOff.taskName')
         );
      }

      h5.actions['vsphere.core.host.actions.storageDevice.turnLedOn'] =
         function(actionEval, availableTargets, disks) {
            if (!availableTargets || !availableTargets.length || !disks.length) {
               return;
            }
            changeLed(availableTargets[0],
               _.map(disks, function(disk) {
                  return disk.lunUuid;
               }), true);
         };

      h5.actions['vsphere.core.host.actions.storageDevice.turnLedOff'] =
         function(actionEval, availableTargets, disks) {
            if (!availableTargets || !availableTargets.length || !disks.length) {
               return;
            }
            changeLed(availableTargets[0],
               _.map(disks, function(disk) {
                  return disk.lunUuid;
               }), false);
         };
   }])
.run(['erasePartitionsDialogService',
   function(erasePartitionsDialogService) {
      h5.actions['vsphere.core.host.actions.storageDevice.erasePartitions'] =
            function(actionEval, availableTargets, context) {

               if (!availableTargets || !availableTargets.length
                     || !context || !context.selectedDevices) {
                  return;
               }

               erasePartitionsDialogService.open(
                     availableTargets[0],
                     context.selectedDevices);
            };
   }
])
.run(['hostStorageService',
   function(hostStorageService) {
      h5.actions['vsphere.core.host.actions.storageDevice.tagAsLocal'] =
            function(actionEval, availableTargets, context) {
               changeDiskLocalState(availableTargets, context, true);
            };

      h5.actions['vsphere.core.host.actions.storageDevice.untagAsLocal'] =
            function(actionEval, availableTargets, context) {
               changeDiskLocalState(availableTargets, context, false);
            };

      function changeDiskLocalState(availableTargets, context, tagAsLocal) {
         if (!availableTargets || !availableTargets.length
               || !context || !context.selectedDevices) {
            return;
         }

         hostStorageService.changeDiskLocalState(
               availableTargets[0],
               context.selectedDevices,
               tagAsLocal
         );
      }
   }
]);

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.storage').directive('adapterPathsList', adapterPathsList);

   adapterPathsList.$inject = ['i18nService', 'columnRenderersRegistry', 'vuiConstants',
         'listViewColumnService', 'hostStorageConstants', 'datagridActionBarService', 'listUtil', 'clipboardService'];

   function adapterPathsList(i18nService, columnRenderersRegistry, vuiConstants,
         listViewColumnService, hostStorageConstants, datagridActionBarService, listUtil, clipboardService) {

      var directive = {
         replace: true,
         scope: {
            paths: '=', // Array of storage paths to be shown.
            selectedPath: '=?',  // Optional path to be selected initially.
            columnSet: '=?', // Optional param controlling which columns should be shown
                             // Valid values are:
                             //    - STORAGE_ADAPTERS_PATHS (default)
                             //    - STORAGE_DEVICE_PATHS
                             //    - VMFS_EXTENT_PATHS
                             //    - PROTOCOL_ENDPOINT_PATHS
            viewId: '=', // Needed for persisting visible grid columns in the user session.
            hostId: '=?', // hostId needed to request path actions from the AF, used when showPathActions is true.
            showPathActions: '=?', // controls whether to show enable and disable path actions.
            showRefreshStorageSystemAction: '=?' // Optional param (false by default) to display or not
                                                 // the refresh storage system action.
         },
         templateUrl: 'storage-ui/resources/storage/directives/adapterPathsList/adapterPathsList.html',
         link: link
      };

      return directive;

      function link(scope) {

         var STORAGE_ADAPTERS_PATHS = 'STORAGE_ADAPTERS_PATHS';
         var STORAGE_DEVICE_PATHS = 'STORAGE_DEVICE_PATHS';
         var VMFS_EXTENT_PATHS = 'VMFS_EXTENT_PATHS';
         var PROTOCOL_ENDPOINT_PATHS = 'PROTOCOL_ENDPOINT_PATHS';

         scope.showPathActions = scope.showPathActions || false;
         scope.showRefreshStorageSystemAction = scope.showRefreshStorageSystemAction || false;

         scope.columnSet = scope.columnSet || STORAGE_ADAPTERS_PATHS;

         var NAME_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.paths.list.name'),
            field: 'name',
            width: '150px',
            template: function(dataItem) {
               return dataItem.name;
            }
         };

         var RUNTIME_NAME_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.runtimeName'),
            field: 'runtimeName',
            width: '100px',
            template: function(dataItem) {
               return dataItem.runtimeName;
            }
         };

         var TARGET_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.target'),
            field: 'formattedTarget',
            width: '180px',
            template: function(dataItem) {
               return dataItem.formattedTarget;
            }
         };

         var LUN_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.lun'),
            field: 'lunNumber',
            width: '80px',
            sortable: function(item1, item2) {
               return listUtil.compareNumericValues(item1, item2, 'lunNumber');
            },
            template: lunNumberTemplate
         };

         var LUN_ID_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.lunId'),
            field: 'lunId',
            width: '150px',
            visible: false,
            template: function(dataItem) {
               return dataItem.lunId;
            }
         };

         var STATUS_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.status'),
            field: 'status',
            width: '100px',
            template: function(dataItem) {
               var data = computePathState(dataItem.pathState, dataItem.isWorkingPath);
               return iconTextRenderer(['icon', 'text'], data);
            },
            sortable: function(item1, item2) {
               return computePathState(item1.pathState, item1.isWorkingPath).text
                  .localeCompare(computePathState(item2.pathState, item2.isWorkingPath).text);
            },
         };

         var ADAPTER_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.paths.list.adapter'),
            field: 'adapter',
            width: '100px',
            visible: false,
            template: function(dataItem) {
               return dataItem.adapter;
            }
         };

         var DEVICE_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.adapters.paths.device'),
            field: 'device',
            width: '180px',
            visible: false,
            template: function(dataItem) {
               return dataItem.device;
            }
         };

         var PREFERRED_COLUMN = {
            displayName: i18nService.getString('StorageUi', 'storage.paths.list.preferred'),
            field: 'preferred',
            width: '150px',
            template: function(dataItem) {
               return dataItem.preferred;
            }
         };

         var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('icon-text');

         var self = scope;
         var columnsChangeHandler = listViewColumnService.getColumnChangeHandler(scope.viewId, scope);
         listViewColumnService.applyPersistedState(getColumnDefinitions(scope.columnSet), scope.viewId)
               .then(function(columnDefs) {
                  self.datagridOptions = {
                     height: '100%',
                     columnDefs: columnDefs,
                     sortMode: vuiConstants.grid.sortMode.SINGLE,
                     selectionMode: vuiConstants.grid.selectionMode.SINGLE,
                     data: [],
                     selectedItems: [],
                     resizable: true,
                     vuiFooter: {
                        actions: [{
                           disabled: false,
                           label: i18nService.getString('StorageUi', 'action.copyAll'),
                           tooltip: i18nService.getString('StorageUi', 'action.copyAll'),
                           icon: 'vui-icon-action-copy',
                           action: function() {
                              var kendoGrid = angular.element('#adapterPathsGrid [kendo-grid]').data().kendoGrid;
                              var displayedColumns = kendoGrid.columns.filter(function(column) {
                                 return !column.hidden;
                              });
                              var displayedFields = displayedColumns.map(function(column) {
                                 return column.field;
                              });
                              var columnTitles = displayedColumns.map(function(column) {
                                 return column.title;
                              });

                              var text = columnTitles.join(", ") + "\n";

                              var data = kendoGrid.dataSource.view();
                              if (!data || !data.length) {
                                 clipboardService.copyToClipboard(text);
                                 return;
                              }

                              var totalPages = kendoGrid.dataSource.totalPages();
                              if (totalPages > 1) {
                                 var initialPage = kendoGrid.dataSource.page();
                                 data = [];
                                 for (var i=1; i<=totalPages; i++) {
                                    kendoGrid.dataSource.page(i);
                                    Array.prototype.push.apply(data, kendoGrid.dataSource.view());
                                 }
                                 kendoGrid.dataSource.page(initialPage);
                              }
                              text += data.map(function(dataItem) {
                                 var rowData = displayedFields.map(function(field) {
                                    if (dataItem.hasOwnProperty(field)) {
                                       var fieldValue = getFieldRenderer(field)(dataItem);
                                       if (!fieldValue) {
                                          return '""';
                                       }
                                       return '"' + fieldValue.replace(/"/g, '""') + '"';
                                    }
                                    return '""';
                                 });
                                 return rowData.join(", ");
                              }).join("\n");

                              clipboardService.copyToClipboard(text);
                           }
                        }]
                     },
                     columnMenu: {
                        sortable: false, // this will hide sort menu items
                        messages: {
                           columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
                           filter: i18nService.getString('CommonUi', 'listview.filterMenu')
                        }
                     },
                     columnHide: columnsChangeHandler,
                     columnReorder: columnsChangeHandler,
                     columnResize: columnsChangeHandler,
                     columnShow: columnsChangeHandler,
                     actionBarOptions: {actions: []}
                  };

                  self.$watch(function() {
                        return self.paths;
                     },
                     function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                           self.datagridOptions.data = newValue;
                        }
                     }
                  );

                  self.$watch(function() {
                        return self.datagridOptions.selectedItems;
                     },
                     function(newValue, oldValue) {
                        //the grid fires an empty selection when rendered for the first time
                        if (newValue === oldValue || _.isEqual(newValue, oldValue)) {
                           return;
                        }
                        if (newValue && newValue.length) {
                           self.selectedPath = newValue[0];
                        } else {
                           self.selectedPath = null;
                        }

                        updateActionbar();
                     }
                  );

                  self.datagridOptions.data = self.paths;

                  updateActionbar();
               });

         scope.preselectComparator = function(gridDataItem) {
            if (!scope.selectedPath || !gridDataItem) {
               return false;
            }

            return scope.selectedPath.runtimeName === gridDataItem.runtimeName;
         };

         function updateActionbar() {
            if (!self.showPathActions) {
               return;
            }

            var actions = [];
            if (self.showRefreshStorageSystemAction) {
               actions.push({
                  actionId: 'vsphere.core.host.actions.refreshStorageSystem'
               });
               actions.push(vuiConstants.actions.SEPARATOR);
            }

            actions.push(
               {
                  actionId: 'vsphere.core.host.actions.paths.enablePath',
                  getActionInvocationContext: function() {
                     return {
                        pathName: self.selectedPath.name
                     };
                  },
                  isActionAvailable: function(actionDef) {
                     return self.selectedPath && actionDef.available &&
                        self.selectedPath.pathState === hostStorageConstants.adapterPathState.DISABLED;
                  }
               }
            );

            actions.push(
               {
                  actionId: 'vsphere.core.host.actions.paths.disablePath',
                  getActionInvocationContext: function() {
                     return {
                        pathName: self.selectedPath.name
                     };
                  },
                  isActionAvailable: function(actionDef) {
                     return self.selectedPath && actionDef.available &&
                        (self.selectedPath.pathState === hostStorageConstants.adapterPathState.ACTIVE ||
                        self.selectedPath.pathState === hostStorageConstants.adapterPathState.STANDBY);
                  }
               }
            );

            datagridActionBarService.updateActionBar(self.datagridOptions, [self.hostId], actions);
         }

         function getColumnDefinitions(columnSet) {
            if (columnSet === STORAGE_DEVICE_PATHS) {
               NAME_COLUMN.visible = true;
               return [
                  RUNTIME_NAME_COLUMN, STATUS_COLUMN,
                  TARGET_COLUMN, NAME_COLUMN, PREFERRED_COLUMN
                ];
            }

            if (columnSet === VMFS_EXTENT_PATHS) {
               NAME_COLUMN.visible = false;
               return [
                  RUNTIME_NAME_COLUMN, STATUS_COLUMN, ADAPTER_COLUMN,
                  TARGET_COLUMN, LUN_COLUMN, LUN_ID_COLUMN, NAME_COLUMN, PREFERRED_COLUMN
               ];
            }

            if (columnSet === PROTOCOL_ENDPOINT_PATHS){
               DEVICE_COLUMN.visible = true;
               return [RUNTIME_NAME_COLUMN, STATUS_COLUMN, DEVICE_COLUMN, TARGET_COLUMN,
                  NAME_COLUMN, PREFERRED_COLUMN];
            }

            return [RUNTIME_NAME_COLUMN, TARGET_COLUMN, LUN_COLUMN,
               STATUS_COLUMN, DEVICE_COLUMN, LUN_ID_COLUMN];
         }

         function computePathState(pathState, isWorkingPath) {
            var displayState;
            var iconClassPrefix = 'storage-ui-icon-path-';

            if (!pathState) {
               return {
                  icon: iconClassPrefix + hostStorageConstants.adapterPathState.STANDBY,
                  text: i18nService.getString('StorageUi', 'storage.adapters.paths.state.unknown')
               };
            }

            switch (pathState) {
               case hostStorageConstants.adapterPathState.ACTIVE:
                  displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.active');
                  break;
               case hostStorageConstants.adapterPathState.STANDBY:
                  displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.standby');
                  break;
               case hostStorageConstants.adapterPathState.DISABLED:
                  displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.disabled');
                  break;
               case hostStorageConstants.adapterPathState.DEAD:
                  displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.dead');
                  break;
               default:
                  displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.unknown');
            }

            if (isWorkingPath) {
               displayState = i18nService.getString('StorageUi', 'storage.adapters.paths.state.workingPath', displayState);
            }

            return {
               icon: iconClassPrefix + pathState,
               text: displayState
            };
         }

         function getFieldRenderer(field) {
            if ("lunNumber" === field) {
               return lunNumberTemplate;
            } else if ("status" === field) {
               return function(dataItem) {
                  return computePathState(dataItem.pathState, dataItem.isWorkingPath).text;
               };
            }
            return function(dataItem) {
               return dataItem[field];
            };
         }

         function lunNumberTemplate(dataItem) {
            if (dataItem.lunNumber === -1 || dataItem.lunNumber === '-1') {
               return '';
            }
            return dataItem.lunNumber;
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.storage').directive('adapterTargetsList', adapterTargetsList);

   adapterTargetsList.$inject = ['i18nService', 'vuiConstants', 'datagridActionBarService'];

   function adapterTargetsList(i18nService, vuiConstants, datagridActionBarService) {
      var directive = {
         replace: true,
         scope: {
            targets: '=', // Array of storage targets to be shown.
            selectedTargets: '=?', // Array of storage targets to be selected initially
            showDynamicTargets: '=?', // Param to display dynamic targets.
            loading: '=?',
            hostId: '=',
            adapter: '=',
            hba: '=',
            onTargetAdded: '=onTargetAdded',
            onTargetRemoved: '=onTargetRemoved',
            onTargetEdited: '=onTargetEdited'
         },
         templateUrl: 'storage-ui/resources/storage/directives/adapterTargetsList/adapterTargetsList.html',
         link: link
      };

      return directive;

      function link(scope) {
         var self = scope;

         var showDynamicTargets = !!scope.showDynamicTargets;

         var SERVER_ADDRESS_COLUMN = {
            displayName: i18nService.getString('StorageUi',
               'storage.adapters.iscsiTargets.staticTarget.serverColumnLabel'),
            field: 'address',
            width: '100px',
            template: function(dataItem) {
               return dataItem.address;
            }
         };

         var TARGET_NAME_COLUMN = {
            displayName: i18nService.getString('StorageUi',
               'storage.adapters.iscsiTargets.staticTarget.targetNameLabel'),
            field: 'name',
            width: '150px',
            template: function(dataItem) {
               return dataItem.name;
            }
         };

         self.datagridOptions = {
            height: '100%',
            columnDefs: getColumnDefinitions(showDynamicTargets),
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            data: [],
            selectedItems: [],
            resizable: true,
            columnMenu: {
               sortable: false, // this will hide sort menu items
               messages: {
                  columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
                  filter: i18nService.getString('CommonUi', 'listview.filterMenu')
               }
            },
            actionBarOptions: {actions: []}
         };

         self.$watch(function() {
               return self.targets;
            },
            function(newValue, oldValue) {
               if (newValue !== oldValue) {
                  setTargets();
               }
            }
         );

         self.$watch(
            function() {
               return self.datagridOptions.selectedItems;
            },
            function(newValue, oldValue) {
               if (newValue !== oldValue && !_.isEqual(newValue,oldValue)) {
                  self.selectedTargets = newValue;
                  datagridActionBarService.updateActionBar(self.datagridOptions, [self.hostId], getActions());
               }
            }
         );

         self.comparator = function (value) {
            var itemToSelect = _.find(self.selectedTargets, function(selectedTarget) {
               return selectedTarget.address === value.address;
            });
            return itemToSelect !== undefined;
         };

         function setTargets() {
            self.targetItemsMap = {};
            if (self.targets) {
               for (var i = 0; i < self.targets.length; i++) {
                  self.targetItemsMap[i] = self.targets[i];
                  self.targets[i].targetIndex = i;
               }
            }

            self.datagridOptions.data = self.targets;
         }

         setTargets();

         datagridActionBarService.updateActionBar(self.datagridOptions, [self.hostId], getActions());

         function getActions () {
            return [
               {
                  actionId: 'vsphere.core.host.actions.adapters.addIscsiTarget',
                  getActionInvocationContext: function() {
                     return {
                        adapter: self.adapter,
                        dynamicTarget: self.showDynamicTargets,
                        targets: self.targets,
                        callback: scope.onTargetAdded
                     };
                  }
               },
               {
                  actionId: 'vsphere.core.host.actions.adapters.removeIscsiTarget',

                  isActionAvailable: function(actionDef) {
                     return actionDef.available && self.datagridOptions.selectedItems.length !== 0;
                  },

                  getActionInvocationContext: function() {

                     if (!self.datagridOptions.selectedItems || !self.datagridOptions.selectedItems.length) {
                        return;
                     }

                     var selectedItem = self.targetItemsMap[self.datagridOptions.selectedItems[0].targetIndex];

                     return {
                        adapter: self.adapter,
                        dynamicTarget: self.showDynamicTargets,
                        target: selectedItem.target,
                        callback: scope.onTargetRemoved
                     };
                  }
               },
               {
                  actionId: 'vsphere.core.host.actions.adapters.editAuthSettingsIscsiTarget',

                  isActionAvailable: function(actionDef) {
                     return actionDef.available && self.datagridOptions.selectedItems.length === 1;
                  },

                  getActionInvocationContext: function() {
                     if (!self.datagridOptions.selectedItems || !self.datagridOptions.selectedItems.length) {
                        return;
                     }

                     var selectedItem = self.targetItemsMap[self.datagridOptions.selectedItems[0].targetIndex];
                     return {
                        adapter: self.adapter,
                        target: selectedItem.target,
                        parentDynamicTargetAuthProperties: selectedItem.parentDynamicTargetAuthProperties,
                        callback: scope.onTargetEdited
                     };
                  }
               },
               {
                  actionId: 'vsphere.core.host.actions.adapters.editAdvancedOptionsForTarget',

                  isActionAvailable: function(actionDef) {
                     return actionDef.available && self.datagridOptions.selectedItems.length === 1;
                  },

                  getActionInvocationContext: function() {
                     if (!self.datagridOptions.selectedItems || !self.datagridOptions.selectedItems.length) {
                        return;
                     }

                     var selectedItem = self.targetItemsMap[self.datagridOptions.selectedItems[0].targetIndex];
                     var targetSet = {
                        _type: "com.vmware.vim.binding.vim.host.InternetScsiHba$TargetSet"
                     };

                     if (showDynamicTargets) {
                        targetSet.sendTargets = [selectedItem.target];
                     } else {
                        targetSet.staticTargets = [selectedItem.target];
                     }

                     return {
                        hba: self.hba,
                        targetSet: targetSet
                     };
                  }
               }
            ];
         }

         function getColumnDefinitions (showDynamicTargets) {
            if (showDynamicTargets) {
               return [SERVER_ADDRESS_COLUMN];
            }

            return [SERVER_ADDRESS_COLUMN, TARGET_NAME_COLUMN];
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.storage').directive('configDeviceList', configDeviceList);

   configDeviceList.$inject = ['i18nService', 'storageUtil', 'columnRenderersRegistry',
      'vuiConstants', 'listViewColumnService', 'datagridActionBarService',
      'hostStorageConstants', 'defaultUriSchemeUtil'];

   function configDeviceList (
         i18nService, storageUtil, columnRenderersRegistry,
         vuiConstants, listViewColumnService, datagridActionBarService,
         hostStorageConstants, defaultUriSchemeUtil
   ) {

      var directive = {
         replace: true,
         scope: {
            devices: '=', // Array of storage devices to be shown.
            hasActionBar: '=?', //Optional. If true - an action bar will be shown.
            hostId: '=?', //Optional. Used only if 'hasActionBar' is true.
            selectedDevices: '=?',  // Optional devices to be selected initially.
            showAdapterColumn: '=?', // If true, the Adapter column is shown.
            viewId: '=' // Needed for persisting visible grid columns in the user session.
         },
         templateUrl: 'storage-ui/resources/storage/directives/configDeviceList/configDeviceList.html',
         link: link
      };

      return directive;

      function link (scope) {

         var showAdapterColumn = !!scope.showAdapterColumn;

         var disabledTextRenderer = columnRenderersRegistry.getColumnRenderer('disabled-text');

         var self = scope;
         var columnsChangeHandler = listViewColumnService.getColumnChangeHandler(scope.viewId, scope);
         listViewColumnService.applyPersistedState(getColumnDefinitions(showAdapterColumn), scope.viewId)
               .then(function (columnDefs) {
                  self.datagridOptions = {
                     height: '100%',
                     columnDefs: columnDefs,
                     sortMode: vuiConstants.grid.sortMode.SINGLE,
                     selectionMode: vuiConstants.grid.selectionMode.MULTI,
                     showCheckboxesOnMultiSelection: false,
                     data: [],
                     selectedItems: [],
                     resizable: true,
                     vuiFooter: {
                        showCopy: true
                     },
                     columnMenu: {
                        sortable: false, // this will hide sort menu items
                        messages: {
                           columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
                           filter: i18nService.getString('CommonUi', 'listview.filterMenu')
                        }
                     },
                     columnHide: columnsChangeHandler,
                     columnReorder: columnsChangeHandler,
                     columnResize: columnsChangeHandler,
                     columnShow: columnsChangeHandler,
                     actionBarOptions: {
                        actions: []
                     }
                  };

                  updateActionBar();

                  function isActionAvailable (operationalState) {
                     return scope.datagridOptions.selectedItems.length === 1
                           && scope.datagridOptions.selectedItems[0].operationalState === operationalState;
                  }

                  function updateActionBar () {
                     if (!!scope.hasActionBar) {

                        datagridActionBarService.updateActionBar(
                              scope.datagridOptions,
                              scope.hostId, [{
                                 actionId: 'vsphere.core.host.actions.refreshStorageSystem'
                              }, vuiConstants.actions.SEPARATOR, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.mount',
                                 isActionAvailable: function (actionDef) {
                                    return actionDef.available
                                          && isActionAvailable(hostStorageConstants.operationalState.OFF);
                                 },

                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems[0];
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.unmount',
                                 isActionAvailable: function (actionDef) {
                                    return actionDef.available
                                          && isActionAvailable(hostStorageConstants.operationalState.OK);
                                 },

                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems[0];
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.rename',
                                 isActionAvailable: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length === 1
                                          && scope.datagridOptions.selectedItems[0].isRenameSupported === true;
                                 },

                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems[0];
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.turnLedOn',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (device) {
                                                   return device.type === hostStorageConstants.deviceType.DISK;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems;
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.turnLedOff',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (device) {
                                                   return device.type === hostStorageConstants.deviceType.DISK;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems;
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.erasePartitions',
                                 getActionInvocationContext: function () {
                                    return {
                                       selectedDevices: scope.datagridOptions.selectedItems
                                    };
                                 },
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (device) {
                                                   return device.isScsiDisk;
                                                });
                                 }
                              }, {
                                 actionId: 'vsphere.core.storage.devices.tagAsSSD',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length > 0
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (disk) {
                                                   return disk.isScsiDisk && !disk.isFlash;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems;
                                 }
                              }, {
                                 actionId: 'vsphere.core.storage.devices.tagAsHDD',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length > 0
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (disk) {
                                                   return disk.isFlash;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return scope.datagridOptions.selectedItems;
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.tagAsLocal',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length > 0
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (device) {
                                                   return device.isScsiDisk
                                                         && !device.isLocal;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return {
                                       selectedDevices: scope.datagridOptions.selectedItems
                                    };
                                 }
                              }, {
                                 actionId: 'vsphere.core.host.actions.storageDevice.tagAsRemote',
                                 isActionVisible: function (actionDef) {
                                    return actionDef.available
                                          && scope.datagridOptions.selectedItems.length > 0
                                          && _.every(scope.datagridOptions.selectedItems,
                                                function (device) {
                                                   return device.isScsiDisk
                                                         && device.isLocal;
                                                });
                                 },
                                 getActionInvocationContext: function () {
                                    return {
                                       selectedDevices: scope.datagridOptions.selectedItems
                                    };
                                 }
                              }

                              ]);
                     }
                  }

                  function updateDeviceItems (devices) {
                     _.forEach(devices, function (device) {
                        device.datastoreName = device.datastoreItem ? device.datastoreItem.name : '';
                     });

                     return devices;
                  }

                  self.$watch(
                     function () {
                        return self.devices;
                     },
                     function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                           self.datagridOptions.data = updateDeviceItems(newValue);
                        }
                     });

                  self.datagridOptions.data = updateDeviceItems(self.devices);

                  // Detects selection change in the storage devices list.
                  self.$watch(function () {
                           return self.datagridOptions.selectedItems;
                        },
                        function (selectedItems, oldValue) {
                           if (selectedItems === oldValue || _.isEqual(selectedItems, oldValue)) {
                              return;
                           }
                           updateActionBar();
                           if (selectedItems && selectedItems.length) {
                              scope.selectedDevices = selectedItems;
                           } else {
                              scope.selectedDevices = null;
                           }
                        });
               });

         scope.preselectComparator = function (gridDataItem) {
            if (!scope.selectedDevices || !scope.selectedDevices.length || !gridDataItem) {
               return false;
            }

            return _.find(scope.selectedDevices, function (selectedDevice) {
               return selectedDevice.identifier === gridDataItem.identifier;
            });
         };

         function getColumnDefinitions (showAdapterColumn) {
            var columns = [];

            columns = columns.concat([
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.name'),
                  field: 'name',
                  width: '300px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['name', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.identifier'),
                  field: 'identifier',
                  width: '270px',
                  visible: false,
                  template: function (dataItem) {
                     return disabledTextRenderer(['identifier', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.lun'),
                  field: 'localizedLunNumber',
                  width: '60px',
                  sortable: function (di1, di2) {
                     return storageUtil.compareNumericValues(di1, di2, 'lunNumber');
                  },
                  template: function (dataItem) {
                     return disabledTextRenderer(['localizedLunNumber', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.type'),
                  field: 'type',
                  width: '75px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['type', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.capacity'),
                  field: 'localizedCapacity',
                  width: '90px',
                  sortable: function (di1, di2) {
                     return storageUtil.compareNumericValues(di1, di2, 'capacity');
                  },
                  template: function (dataItem) {
                     var className = 'right-align-cell vertical-align-cell';
                     if (dataItem.disabled === true) {
                        className += ' disabled-text';
                     }
                     return '<span class="' + className + '">' + dataItem.localizedCapacity + '</span>';
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.datastore'),
                  field: 'datastoreName',
                  width: '90px',
                  template: function (dataItem) {
                     if (dataItem.datastoreItem) {
                        var ds = JSON.parse(JSON.stringify(dataItem.datastoreItem));
                        var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
                        var modifiedData = {
                           dsId: defaultUriSchemeUtil.getVsphereObjectId(ds.ref),
                           dsName: ds.name
                        };
                        return objectLinkRenderer(['dsId', 'dsName', 'vsphere-icon-datastore'], modifiedData);
                     }
                     return i18nService.getString('StorageUi', 'storage.adapters.devices.datastore.empty');
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.opState'),
                  field: 'localizedState',
                  width: '120px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['localizedState', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.hardwareAcc'),
                  field: 'hardwareAcceleration',
                  width: '150px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['hardwareAcceleration', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.driveType'),
                  field: 'localizedDriveType',
                  width: '90px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['localizedDriveType', 'disabled'], dataItem);
                  }
               }
            ]);

            if (showAdapterColumn) {
               columns = columns.concat([{
                  displayName: i18nService.getString('StorageUi', 'storage.devices.adapterColumn.header'),
                  field: 'adapter',
                  width: '120px',
                  visible: false,
                  template: function (dataItem) {
                     return disabledTextRenderer(['adapter', 'disabled'], dataItem);
                  }
               }]);
            }

            columns = columns.concat([
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.transport'),
                  field: 'transport',
                  width: '120px',
                  template: function (dataItem) {
                     return disabledTextRenderer(['transport', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.owner'),
                  field: 'ownerPlugin',
                  width: '90px',
                  visible: false,
                  template: function (dataItem) {
                     return disabledTextRenderer(['ownerPlugin', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.physicalLocation'),
                  field: 'physicalLocation',
                  width: '150px',
                  visible: false,
                  template: function (dataItem) {
                     return disabledTextRenderer(['physicalLocation', 'disabled'], dataItem);
                  }
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.sectorFormat'),
                  field: 'sectorFormat',
                  width: '150px',
                  visible: false,
                  template: function (dataItem) {
                     return disabledTextRenderer(['sectorFormat', 'disabled'], dataItem);
                  }
               }
            ]);

            return columns;
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Directive used to show a list of storage devices.
 *
 * Example:
 * <div
 *    device-list
 *    devices="devices"
 *    selectedDevice="deviceToSelect"
 *    show-snapshot-column="true"
 *    on-selected-device-changed="selectedDeviceChanged(selectedDevice)"></div>
 */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.storage').directive('deviceList', deviceList);

   deviceList.$inject = ['i18nService', 'storageUtil', 'columnRenderersRegistry', 'bytesFilter', 'booleanFilter', 'vuiConstants'];

   function deviceList(i18nService, storageUtil, columnRenderersRegistry, bytesFilter, booleanFilter, vuiConstants) {

      var directive = {
         replace: true,
         scope: {
            devices: '=', // Array of storage devices to be shown.
            showPager: '=?',
            selectedDevice: '=?',  // Optional device to be selected initially.
            selectedDeviceChanged: '&onSelectedDeviceChanged',
            showSnapshotColumn: '=?', // Optional flag controlling the visibility of the Snapshot column
            showExpandableColumn: '=?' // Optional flag controlling the visibility of the Expandable column
         },
         templateUrl: 'storage-ui/resources/storage/directives/deviceList/deviceList.html',
         link: link
      };

      return directive;

      function link(scope, element, attrs) {

         var bindOnSelectedDeviceChanged = !!attrs.onSelectedDeviceChanged;
         var showSnapshotColumn = !!attrs.showSnapshotColumn;
         var showExpandableColumn = !!attrs.showExpandableColumn;
         var hidePager = !attrs.showPager;
         scope.$watch(
               function () {
                  return scope.devices;
               }, function (newValue, oldValue) {
                  if (newValue !== oldValue) {
                     updateDeviceItems(scope);
                  }
               });

         scope.datagridOptions = {
            height: '100%',
            pageConfig: {
               hidePager: hidePager
            },
            columnDefs: getColumnDefs(),
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            resizable: true,
            columnMenu: {
               sortable: false, // this will hide sort menu items
               messages: {
                  columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
                  filter: i18nService.getString('CommonUi', 'listview.filterMenu')
               }
            }
         };

         updateDeviceItems(scope);

         // Detects selection change in the storage devices list.
         scope.$watch(function() { return scope.datagridOptions.selectedItems; },
               function(selectedItems) {
                  if (selectedItems && selectedItems.length) {
                     notifySelectionChangeListener(selectedItems[0]);
                  } else {
                     notifySelectionChangeListener(null);
                  }
               });

         scope.preselectComparator = function(gridDataItem) {
            if (!scope.selectedDevice || !gridDataItem) {
               return false;
            }

            return scope.selectedDevice.disk.devicePath === gridDataItem.scsiDiskInfo.disk.devicePath;
         };

         var _selectedItem = null;
         function notifySelectionChangeListener(selectedDataItem) {
            if (bindOnSelectedDeviceChanged) {
               if (_selectedItem !== selectedDataItem) {
                  _selectedItem = selectedDataItem;
                  scope.selectedDeviceChanged({
                     selectedDevice: selectedDataItem ? selectedDataItem.scsiDiskInfo : null
                  });
               }
            }
         }

         function getColumnDefs() {
            var result = [
               {
                  displayName: i18nService.getString('StorageUi', 'deviceList.columns.name'),
                  field: 'name',
                  width: '180px',
                  template: '#:name#'
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.identifier'),
                  field: 'identifier',
                  visible:false,
                  width: '100px',
                  template: '#:identifier#'
               },
               {
                  displayName: i18nService.getString('StorageUi', 'deviceList.columns.lun'),
                  field: 'localizedLunNumber',
                  width: '70px',
                  sortable: function(di1, di2) {
                     return storageUtil.compareNumericValues(di1, di2, 'lun');
                  },
                  template: '#:localizedLunNumber#'
               },
               {
                  displayName: i18nService.getString('StorageUi', 'deviceList.columns.capacity'),
                  field: 'localizedCapacity',
                  width: '100px',
                  sortable: function(di1, di2) {
                     return storageUtil.compareNumericValues(di1, di2, 'capacity');
                  },
                  template: (function (data) {
                     return columnRenderersRegistry.getColumnRenderer('number')
                     (['localizedCapacity'], data);
                  })
               },
               {
                  displayName: i18nService.getString('StorageUi', 'deviceList.columns.vStorage'),
                  field: 'vStrorage',
                  width: '100px',
                  template: '#:vStrorage#'
               },
               {
                  displayName: i18nService.getString('StorageUi', 'deviceList.columns.driveType'),
                  field: 'driveType',
                  width: '90px',
                  template: '#:driveType#'
               },
               {
                  displayName: i18nService.getString('StorageUi', 'storage.adapters.devices.sectorFormat'),
                  field: 'sectorFormat',
                  width: '150px',
                  template: '#:sectorFormat#'
               }];

            if (showSnapshotColumn) {
               result.push(
                  {
                     displayName: i18nService.getString('StorageUi', 'deviceList.columns.snapshot'),
                     field: 'snapshot',
                     width: '80px',
                     template: '#:snapshot#'
                  }
               );
            }

            if (showExpandableColumn) {
               result.push(
                  {
                     displayName: i18nService.getString('StorageUi', 'deviceList.columns.expandable'),
                     field: 'expandable',
                     width: '80px',
                     template: '#:expandable#'
                  }
               );
            }
            return result;
         }
      }

      function updateDeviceItems(scope) {
         var deviceItems = [];
         if (scope.devices) {
            deviceItems = _.map(scope.devices, function (device) {
               var diskCapacity = storageUtil.lbaToBytes(device.disk.capacity);
               return {
                  name: storageUtil.formatDeviceName(device.disk),
                  identifier: device.disk.canonicalName,
                  lun: device.lun,
                  localizedLunNumber: storageUtil.formatLunNumber(device.lun),
                  capacity: diskCapacity,
                  localizedCapacity: bytesFilter(diskCapacity, 'B', 'Auto', 2),
                  vStrorage: storageUtil.formatVStorageSupport(device.disk.vStorageSupport),
                  driveType: storageUtil.formatSSDValue(device.disk.ssd),
                  snapshot: storageUtil.formatVmfsLabel(device),
                  expandable: booleanFilter(device.expandable),
                  scsiDiskInfo: device,
                  sectorFormat: storageUtil.getSectorFormatByScsiDiskType(device.disk.scsiDiskType)
               };
            });
         }

         if (scope.datagridOptions) {
            scope.datagridOptions.data = deviceItems;
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.storage').directive('datastorePartitionConfig', datastorePartitionConfig);

   datastorePartitionConfig.$inject = ['datastoreConstants', 'i18nService'];

   function datastorePartitionConfig (datastoreConstants, i18nService) {
      var directive = {
         replace: true,
         scope: {
            labels: '<',
            selectedOption: '=',
            onSelectedOptionChanged: '&',
            options: '=',
            diskPartitionInfo: '=',
            dsInfo: '<?',
            blockSizeOptions: '<?',
            configurationError: '=',
            manager: '<?'
         },
         templateUrl: 'storage-ui/resources/storage/directives/partitionConfig/datastorePartitionConfig.html',
         link: link
      };
      var slider, bindOnSelectionChanged;
      var cachedValue = new CachedValue();
      return directive;

      function link (scope, element) {
         bindOnSelectionChanged = !!scope.onSelectedOptionChanged;
         slider = element.find('input[type="range"]');
         scope.values = {};
         populateDefaultOption();
         initSelection();
         scope.$watch('selectedOption',
            function(option) {
               setMaxSize(option);
               setSize(option);
            });

         function setMaxSize (option) {
            if (option && !option.isSelectConfigurationOption) {
               var maxSizeInGb = option.maxDatastoreSize / datastoreConstants.BYTES_TO_GB;
               // Round maxSize to two decimal places.
               scope.maxSize = Math.round(maxSizeInGb * 100) / 100;
            } else {
               scope.maxSize = undefined;
            }
         }

         function setSize (option) {
            if (option && option.sizeToAdd){
               scope.size = option.sizeToAdd;
            } else {
               scope.size = scope.maxSize;
            }
            if (cachedValue.isSame(scope.size)) {
               onSizeChanged(scope.size);
            }
         }

         scope.$watch('size', onSizeChanged);

         function onSizeChanged(newValue) {
            // newValue becomes null when the number from the number input field is
            // deleted. In this case we do *not* want to set the size to the max one.
            if (newValue > scope.maxSize || newValue === undefined) {
               scope.size = scope.maxSize;
            }
            scope.selectedOption.sizeToAdd = scope.size;
            if (bindOnSelectionChanged) {
               scope.onSelectedOptionChanged({
                     selectedOption: scope.selectedOption
                  }
               );
            }
         }

         function populateDefaultOption () {
            var items = scope.options.slice();
            items.splice(0, 0, {
               //adding dummy <select configuration> option
               optionTitle: i18nService.getString('StorageUi', 'vmfsDatastore.options.selectConfiguration'),
               isSelectConfigurationOption: true
            });
            scope.options = items;
         }

         /*
          *  If the selection was persisted - restore size value,
          *  otherwise - sets the default one
          */
         function initSelection () {
            //restore previous selection
            if (scope.selectedOption) {
               scope.size = scope.selectedOption.sizeToAdd;
            } else {
               // preselect the "please select" option
               var preselectOptionIndex = 0;
               if (scope.options.length === 2) {
                  // If only one available option is selected - preselect it.
                  preselectOptionIndex = 1;
               }
               scope.selectedOption = scope.options[preselectOptionIndex];
            }
         }
      }

      function CachedValue() {
         var cachedValue;

         return {
            isSame: function(value) {
               var isSame = value && cachedValue === value;
               cachedValue = value;
               return isSame;
            }
         };
      }
   }
})();

var storage_ui;
(function (storage_ui) {
    var DatastorePartitionLayoutController = (function () {
        function DatastorePartitionLayoutController($scope) {
            this.$scope = $scope;
            this.chartApi = {};
            var ctrl = this;
            if (this.datastoreInfo) {
                /**
                 * When datastoreInfo is passed we loop through
                 * diskPartitionInfo.layout.partition partitions and if some of them belong to
                 * datastoreInfo.vmfs.extent we add ["datastoreInfo"],
                 * to flag them as ones from the same datastore. (will have same color/name)
                 **/
                _.forEach(this.diskPartitionInfo.layout.partition, function (item) {
                    if (_.find(ctrl.datastoreInfo.vmfs.extent, function (p) {
                        return p.partition === item.partition;
                    })) {
                        item.datastoreInfo = ctrl.datastoreInfo;
                    }
                });
            }
            // remove re-occuring legend elements
            this.$scope.$watch(function () {
                return ctrl.chartPartitions;
            }, function (items) {
                ctrl.partitions = _.uniq(items, function (item) {
                    return item.name + item.color;
                });
            });
        }
        DatastorePartitionLayoutController.prototype.resizeChart = function () {
            this.chartApi.reflow();
        };
        DatastorePartitionLayoutController.$inject = ["$scope"];
        return DatastorePartitionLayoutController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastorePartitionLayout", {
        templateUrl: "storage-ui/resources/storage/directives/partitionConfig/layout/datastorePartitionLayoutComponent.html",
        bindings: {
            datastoreInfo: "<?",
            diskPartitionInfo: "<",
            selectedOption: "<",
            size: "<"
        },
        controller: DatastorePartitionLayoutController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    angular.module("com.vmware.vsphere.client.storage").constant("layoutAreaChartConstants", (function () {
        var BAR_HEIGHT = 100;
        var LABEL_CONFIG = {
            "color": "#333",
            "cursor": "default",
            "fontSize": "12px",
            "fontFamily": "\"ProximaNova\",\"Avenir Next\",\"Helvetica Neue\",Arial,sans-serif,\"Avenir Next\",\"Helvetica Neue\",Arial,sans-serif",
            "pointerEvents": "none",
            "whiteSpace": "nowrap"
        };
        return {
            FREE_PARTITION_COLOR: "rgb(218, 218, 218)",
            SAME_DATASTORE_PARTITION_COLOR: "rgb(57, 105, 145)",
            BAR_HEIGHT: BAR_HEIGHT,
            HIGHCHARTS_CONFIG: {
                "tooltip": {
                    "headerFormat": "",
                    "style": LABEL_CONFIG
                },
                "chart": {
                    "type": "area",
                    "margin": [10, -10, 10, -10],
                    "spacing": [0, 0, 0, 0]
                },
                "plotOptions": {
                    "series": {
                        "animation": false,
                        "states": {
                            "hover": {
                                "enabled": false
                            }
                        }
                    },
                    "area": {
                        "lineWidth": 0,
                        "fillOpacity": 1
                    }
                },
                "xAxis": { visible: false },
                "yAxis": { visible: false, max: BAR_HEIGHT },
                "title": { text: "" },
                "subTitle": { text: "" },
                "credits": { enabled: false },
                "legend": { enabled: false }
            },
            LABEL_CONFIG: LABEL_CONFIG
        };
    }()));
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    /**
     * layoutAreaChartService is a singleton object that
     *      1. transforms diskPartitionInfo layout into an array of rectangular Highcharts series objects.
     *      2. stores the pre-calculated sizes in MB for partitions
     *
     * Partitions with size too small to be displayed in real proportion
     * will use MIN_WIDTH which is calculated on fly each time new diskPartitionInfo is rendered
     *
     * This service could be implemented in java.
     *
     **/
    var LayoutAreaChartService = (function () {
        function LayoutAreaChartService(i18nService, storageUtil, constants, bytesFilter) {
            this.i18nService = i18nService;
            this.storageUtil = storageUtil;
            this.constants = constants;
            this.bytesFilter = bytesFilter;
        }
        Object.defineProperty(LayoutAreaChartService, "BLOCK_SIZE_DEFAULT", {
            get: function () {
                return 512;
            },
            enumerable: true,
            configurable: true
        });
        ;
        /**
         *  Builds chart
         **/
        LayoutAreaChartService.prototype.buildChart = function (partitionInfo) {
            var self = this;
            return _.extend(this.constants.HIGHCHARTS_CONFIG, {
                "series": this.buildRectangles(partitionInfo),
                "tooltip": {
                    "formatter": function () {
                        var context = this;
                        var size = self.bytesFilter(context.series.options.totalSizeMb, "MB", "Auto", 3);
                        return this.point.dataLabels ? (context.series["name"] + ": " + size) : false;
                    },
                },
                "partitions": this.partitions,
                "totalX": this.totalX
            });
        };
        ;
        /**
         * Calculates total size in MB based on layout.partition
         * */
        LayoutAreaChartService.calcSize = function (partition) {
            return (Number(partition.end.block) - Number(partition.start.block) + 1) *
                Number(partition.start.blockSize || LayoutAreaChartService.BLOCK_SIZE_DEFAULT) / Math.pow(1024, 2);
        };
        LayoutAreaChartService.getExtentOriginalBlockRange = function (diskInfo, vmfsOption) {
            var originalBlockRange = null;
            // Check if the vmfsOption will expand one of the datastore"s extents.
            var expandSpec = vmfsOption.spec;
            if (expandSpec._type !== "com.vmware.vim.binding.vim.host.VmfsDatastoreExpandSpec") {
                return null;
            }
            // Find extent"s BlockRange inside the option"s layout.
            var newBlockRange = _.find(vmfsOption.info.layout.partition, function (blockRange) {
                return blockRange.partition === expandSpec.extent.partition;
            });
            if (newBlockRange) {
                // Then use the BlockRange from the option.layout to find the BlockRange in
                // the diskInfo.layout by matching their start block addresses.
                originalBlockRange = _.find(diskInfo.layout.partition, function (range) {
                    return range.start.block === newBlockRange.start.block;
                });
            }
            return originalBlockRange;
        };
        /**
         * Builds series of rectangular area-charts stacked horizontally.
         **/
        LayoutAreaChartService.prototype.buildRectangles = function (partitionInfo) {
            var _this = this;
            this.totalX = 0.0;
            this.partitions = _.map(partitionInfo.layout.partition, function (partition) {
                var result = _.clone(partition);
                result.totalSize = LayoutAreaChartService.calcSize(partition);
                result.visibleSize = result.totalSize;
                _this.totalX += result.totalSize;
                return result;
            });
            // MIN_WIDTH for smaller partitions is 20% of an average block size
            var MIN_WIDTH = this.totalX / this.partitions.length * 0.20;
            for (var i = 0; i < this.partitions.length; i++) {
                if (this.partitions[i].totalSize < MIN_WIDTH) {
                    this.partitions[i].visibleSize = MIN_WIDTH;
                }
            }
            var allSeries = [];
            var x = 0.0;
            for (var i = 0; i < this.partitions.length; i++) {
                allSeries[i] = this.buildRect(this.partitions[i], x, this.totalX);
                x += this.partitions[i].visibleSize;
            }
            this.totalX = x;
            return allSeries;
        };
        /**
         * Builds a rectangular representation of a partition
         **/
        LayoutAreaChartService.prototype.buildRect = function (partition, x, totalX) {
            var self = this;
            var rectangleConfig = {
                name: this.i18nService.getString("StorageUi", "datastore.partitionType." + partition.type),
                partitionType: partition.type,
                data: [
                    [x, 0], [x, this.constants.BAR_HEIGHT],
                    {
                        x: x + partition.visibleSize / 2.0,
                        y: this.constants.BAR_HEIGHT,
                        width: partition.visibleSize,
                        dataLabels: {
                            style: this.constants.LABEL_CONFIG,
                            enabled: true,
                            y: this.constants.BAR_HEIGHT / 2,
                            // Hiding the labels that overflow their areas
                            // By assuming 1 character is @approxCharWidthPx wide and comparing it to area width
                            formatter: function () {
                                var approxCharWidthPx = 6;
                                var formattedSize = self.bytesFilter(partition.totalSize, "MB", "Auto", 1);
                                var label = this.series.name + ": " + formattedSize;
                                var percentage = this.point.options.width / totalX;
                                var blockWidth = percentage * this.series.chart.plotWidth;
                                var labelApproxWidth = approxCharWidthPx * label.length;
                                return (labelApproxWidth < blockWidth) ? label : null;
                            }
                        }
                    },
                    [x + partition.visibleSize, this.constants.BAR_HEIGHT], [x + partition.visibleSize, 0]
                ],
                totalSizeMb: partition.totalSize
            };
            if (this.storageUtil.isFreePartition(partition.type)) {
                rectangleConfig.color = this.constants.FREE_PARTITION_COLOR;
            }
            // same datastore color
            if (partition["datastoreInfo"]) {
                rectangleConfig.color = this.constants.SAME_DATASTORE_PARTITION_COLOR;
                var datastoreDetailsData = partition.datastoreInfo;
                rectangleConfig.name = datastoreDetailsData.datastoreName + " (" + rectangleConfig.name + ")";
            }
            return rectangleConfig;
        };
        LayoutAreaChartService.$inject = ["i18nService", "storageUtil", "layoutAreaChartConstants", "bytesFilter"];
        return LayoutAreaChartService;
    }());
    storage_ui.LayoutAreaChartService = LayoutAreaChartService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("layoutAreaChartService", LayoutAreaChartService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var LayoutAreaChartService = storage_ui.LayoutAreaChartService;
    /**
     * Draws selection markers (blue~ish rectangles on top of the area chart)
     */
    var LayoutAreaSelectionService = (function () {
        function LayoutAreaSelectionService(i18nService, storageUtil) {
            this.i18nService = i18nService;
            this.storageUtil = storageUtil;
        }
        Object.defineProperty(LayoutAreaSelectionService, "SELECTION_MASK_CLASS", {
            /**
             * "storage-partition-layout-selection-mask" - mask identifier class.
             * all the selection rectangles should have it, in order to be removable
             *
             * the class itself does not have a css definition of any kind
             * **/
            get: function () {
                return "storage-partition-layout-selection-mask";
            },
            enumerable: true,
            configurable: true
        });
        ;
        /***
         * Removes the selection markers from chart
         * @param view - Element containing chart
         */
        LayoutAreaSelectionService.prototype.clearMask = function (view) {
            var maskElement = view.find("." + LayoutAreaSelectionService.SELECTION_MASK_CLASS);
            if (maskElement) {
                maskElement.remove();
            }
        };
        LayoutAreaSelectionService.prototype.highlightSelection = function (chart, view, vmfsExtent, sizeMb) {
            var _this = this;
            var self = this;
            this.clearMask(view);
            if (_.isArray(vmfsExtent)) {
                // 1. calculate overall volume
                var total_1 = 0;
                _.forEach(vmfsExtent, function (item) {
                    item.size = LayoutAreaChartService.calcSize(item);
                    total_1 += item.size;
                });
                // 2. Populate selection rectangles one by one
                var x_1 = 0;
                _.forEach(vmfsExtent, function (item) {
                    var startMb = _this.lbaAddressMb(item.start);
                    var endMb = _this.lbaAddressMb(item.end);
                    var fillRightEdgeMb = 0;
                    if (sizeMb >= x_1 && sizeMb <= x_1 + item.size) {
                        fillRightEdgeMb = sizeMb - x_1;
                    }
                    else if (sizeMb > x_1 + item.size) {
                        fillRightEdgeMb = item.size;
                    }
                    self.maskRect(chart, startMb, endMb, fillRightEdgeMb);
                    x_1 += endMb - startMb;
                });
            }
            else {
                var startMb = this.lbaAddressMb(vmfsExtent.start);
                var endMb = this.lbaAddressMb(vmfsExtent.end);
                this.maskRect(chart, startMb, endMb, sizeMb);
            }
        };
        ;
        /**
         * "masks" the section passed where:
         * @startMb - section start in megabytes
         * @endMb - section end in megabytes
         * @size - the width of the filled portion
         * **/
        LayoutAreaSelectionService.prototype.maskRect = function (chart, startMb, endMb, sizeMb) {
            var totalX = chart.userOptions.totalX;
            var partitions = chart.userOptions.partitions;
            var startPx = chart.chartWidth / totalX * this.mbToUnits(startMb, partitions);
            var endPx = chart.chartWidth / totalX * this.mbToUnits(endMb, partitions);
            var width = (sizeMb / (endMb - startMb)) * (endPx - startPx);
            // outline
            chart.renderer.rect(startPx, 10, endPx - startPx, 80, 0).attr({
                "stroke-width": 6,
                stroke: "rgb(15,172,201)",
                fill: "rgba(255,255,255,0)",
                zIndex: 3,
                class: LayoutAreaSelectionService.SELECTION_MASK_CLASS
            }).add();
            // fill
            chart.renderer.rect(startPx, 10, width, 80, 0).attr({
                "stroke-width": 0,
                stroke: "rgb(15,172,201)",
                fill: "rgba(15,172,201, 0.6)",
                zIndex: 3,
                class: LayoutAreaSelectionService.SELECTION_MASK_CLASS
            }).add();
        };
        /**
         * While the API operates "real" megabytes, since we have to show tiny partitions there"s a MIN_WIDTH,
         * and a partition with MIN_WIDTH affects all the partitions after it, shifting REAL layout.
         *
         * This methods accepts "real" layout position in megabytes and returns the "shifted" value for it
         **/
        LayoutAreaSelectionService.prototype.mbToUnits = function (realMB, partitions) {
            var offsetMb = 0;
            for (var i = 0; i < partitions.length; i++) {
                var startMB = this.lbaAddressMb(partitions[i].start);
                var endMB = this.lbaAddressMb(partitions[i].end);
                if (realMB <= endMB && realMB >= startMB) {
                    offsetMb += realMB - startMB;
                    break;
                }
                else {
                    offsetMb += partitions[i].visibleSize;
                }
            }
            return offsetMb;
        };
        LayoutAreaSelectionService.prototype.lbaAddressMb = function (lba) {
            return this.storageUtil.lbaToBytes(lba) / Math.pow(1024, 2);
        };
        LayoutAreaSelectionService.$inject = ["i18nService", "storageUtil", "layoutAreaChartService"];
        return LayoutAreaSelectionService;
    }());
    storage_ui.LayoutAreaSelectionService = LayoutAreaSelectionService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("layoutAreaSelectionService", LayoutAreaSelectionService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var LayoutAreaChartService = storage_ui.LayoutAreaChartService;
    var PartitionLayoutChartController = (function () {
        function PartitionLayoutChartController(chartService, selectionService, storageUtil, i18nService, $scope, element) {
            var _this = this;
            this.chartService = chartService;
            this.selectionService = selectionService;
            this.storageUtil = storageUtil;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.element = element;
            this.chart = null;
            /**
             * Drawing the selection rectangles on the chart
             **/
            this.onSizeChange = function () {
                if (!_this.chart || !_this.selectedOption || !_this.selectedOption.vmfsDatastoreOption) {
                    _this.selectionService.clearMask(_this.element);
                    return;
                }
                var option = _this.selectedOption.vmfsDatastoreOption;
                var vmfsExtent = option.info.vmfsExtent;
                // Highlight the whole area completely
                // Single extent and single partition => formatting the disk.
                // (fixes the issue with really small blocks being not highlighted)
                if ((option.info._type === "com.vmware.vim.binding.vim.host.VmfsDatastoreOption$SingleExtentInfo"
                    || option.info._type === "com.vmware.vim.binding.vim.host.VmfsDatastoreOption$AllExtentInfo")
                    && option.info.layout.partition.length === 1
                    && option.spec._type !== "com.vmware.vim.binding.vim.host.VmfsDatastoreExpandSpec") {
                    var fillAll = {
                        start: {
                            block: 0,
                            blockSize: _this.diskPartitionInfo.layout.total.blockSize
                        },
                        end: {
                            block: _this.diskPartitionInfo.layout.total.block,
                            blockSize: _this.diskPartitionInfo.layout.total.blockSize
                        }
                    };
                    _this.selectionService.highlightSelection(_this.chart, _this.element, fillAll, _this.size * 1024); // GB to MB
                }
                else if (option.spec._type === "com.vmware.vim.binding.vim.host.VmfsDatastoreExpandSpec") {
                    // When expanding we need to find the start address of the
                    // block range which will be appended, not the whole partition
                    // (1) Find the block range which is expanded.
                    var originalPartition = LayoutAreaChartService.getExtentOriginalBlockRange(_this.diskPartitionInfo, option);
                    // (2) To find the start address of the next block we
                    // need to add 1 to the end address of the current block range.
                    var expandableExtent = {
                        start: {
                            block: originalPartition.end.block + 1,
                            blockSize: vmfsExtent.start.blockSize
                        },
                        end: {
                            block: vmfsExtent.end.block,
                            blockSize: vmfsExtent.end.blockSize
                        }
                    };
                    _this.selectionService.highlightSelection(_this.chart, _this.element, expandableExtent, _this.size * 1024); // GB to MB
                }
                else {
                    _this.selectionService.highlightSelection(_this.chart, _this.element, vmfsExtent, _this.size * 1024);
                }
            };
            /**
             * Draws Disk Partition layout chart using Highcharts
             **/
            this.drawChart = function (partitionInfo) {
                var ctrl = _this;
                if (partitionInfo) {
                    _this.element.highcharts(_this.chartService.buildChart(partitionInfo), function (c) {
                        // preserve Highcharts chart object
                        ctrl.chart = c;
                        // generate legend
                        ctrl.chartPartitions = _.map(ctrl.chart.series, function (item) {
                            return !ctrl.storageUtil.isFreePartition(item.options.partitionType) ? {
                                name: item.name,
                                color: item.color
                            } : false;
                        }).filter(function (item) {
                            return !!item;
                        });
                    });
                }
            };
        }
        PartitionLayoutChartController.prototype.$onInit = function () {
            var _this = this;
            var ctrl = this;
            this.chartApi = this.chartApi || {};
            this.chartApi.reflow = _.throttle(function () {
                ctrl.chart.reflow();
                ctrl.onSizeChange();
            }, 300); // _.throttle here ensures that this function will be called not more than ONCE in 300ms
            this.drawChart(ctrl.diskPartitionInfo);
            this.$scope.$watchGroup([
                function () {
                    return ctrl.size;
                },
                function () {
                    return ctrl.selectedOption;
                }
            ], this.onSizeChange);
            this.$scope.$on("$destroy", function () {
                if (_this.element.highcharts()) {
                    _this.element.highcharts().destroy();
                }
            });
        };
        PartitionLayoutChartController.$inject = ["layoutAreaChartService", "layoutAreaSelectionService", "storageUtil",
            "i18nService", "$scope", "$element"];
        return PartitionLayoutChartController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("partitionLayoutChart", {
        controller: PartitionLayoutChartController,
        bindings: {
            selectedOption: "<",
            size: "<",
            diskPartitionInfo: "<",
            chartPartitions: "=",
            chartApi: "="
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var VmfsBlockSizeSelectedOptions = (function () {
        function VmfsBlockSizeSelectedOptions() {
        }
        return VmfsBlockSizeSelectedOptions;
    }());
    storage_ui.VmfsBlockSizeSelectedOptions = VmfsBlockSizeSelectedOptions;
    var VmfsBlockSizeOptionsController = (function () {
        function VmfsBlockSizeOptionsController(i18n) {
            this.i18n = i18n;
            if (!this.selectedSettings) {
                this.selectedSettings = new VmfsBlockSizeSelectedOptions();
                this.selectedSettings.blockSize = this.blockSizeOptions[0];
                this.selectedSettings.granularity = this.getGranularityOptionsPerBlockSize()[0];
                this.selectedSettings.reclamationPriority = { unmapPriority: "low" };
            }
        }
        VmfsBlockSizeOptionsController.prototype.populateDefaultGranularity = function () {
            if (!_.contains(this.getGranularityOptionsPerBlockSize(), this.selectedSettings.granularity)) {
                this.selectedSettings.granularity = this.getGranularityOptionsPerBlockSize()[0];
            }
        };
        VmfsBlockSizeOptionsController.prototype.getGranularityOptionsPerBlockSize = function () {
            return this.selectedSettings.blockSize.granularityOptions;
        };
        VmfsBlockSizeOptionsController.prototype.updateSettings = function () {
            this.updateSettingsState(this.selectedSettings);
        };
        VmfsBlockSizeOptionsController.prototype.$onChanges = function () {
            this.updateSettings();
        };
        VmfsBlockSizeOptionsController.$inject = ["i18nService"];
        return VmfsBlockSizeOptionsController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("vmfsBlockSizeOptions", {
        templateUrl: "storage-ui/resources/storage/directives/vmfsBlockSize/VmfsBlockSizeOptionsComponent.html",
        bindings: {
            blockSizeOptions: "<",
            updateSettingsState: "<",
            selectedSettings: "<"
        },
        controller: VmfsBlockSizeOptionsController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    //These are used instead of @Dto's to add |null for sone fields
    var InternetScsiHba$IPProperties = (function () {
        function InternetScsiHba$IPProperties() {
        }
        return InternetScsiHba$IPProperties;
    }());
    storage_ui.InternetScsiHba$IPProperties = InternetScsiHba$IPProperties;
    var InternetScsiHba$IscsiIpv6Address = (function () {
        function InternetScsiHba$IscsiIpv6Address() {
            this._type = "com.vmware.vim.binding.vim.host.InternetScsiHba$IscsiIpv6Address";
        }
        return InternetScsiHba$IscsiIpv6Address;
    }());
    storage_ui.InternetScsiHba$IscsiIpv6Address = InternetScsiHba$IscsiIpv6Address;
    var InternetScsiHba$IPv6Properties = (function () {
        function InternetScsiHba$IPv6Properties() {
        }
        return InternetScsiHba$IPv6Properties;
    }());
    storage_ui.InternetScsiHba$IPv6Properties = InternetScsiHba$IPv6Properties;
    var InternetScsiStorageAdapterIpConfigurationUpdateSpec = (function () {
        function InternetScsiStorageAdapterIpConfigurationUpdateSpec() {
            this._type = "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterIpConfigurationUpdateSpec";
        }
        return InternetScsiStorageAdapterIpConfigurationUpdateSpec;
    }());
    storage_ui.InternetScsiStorageAdapterIpConfigurationUpdateSpec = InternetScsiStorageAdapterIpConfigurationUpdateSpec;
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var SelectVmToRegisterService = (function () {
        function SelectVmToRegisterService(vuiDialogService, $rootScope, i18nService, datastoreBrowserConstants, vuiConstants) {
            this.vuiDialogService = vuiDialogService;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
            this.vuiConstants = vuiConstants;
        }
        SelectVmToRegisterService.prototype.browseFile = function (datastoreId, onFileSelectedCallback) {
            var initialFileQueryType = this.datastoreBrowserConstants.fileQueryType.FOLDERS |
                this.datastoreBrowserConstants.fileQueryType.VM_CONFIG_FILES;
            var filterFileQueryTypes = [{
                    label: this.i18nService.getString('Common', 'dsBrowser.vmConfigFile'),
                    value: this.datastoreBrowserConstants.fileQueryType.VM_CONFIG_FILES
                }];
            var selectedVmConfigFile;
            var dialogScope = this.$rootScope.$new();
            dialogScope.dsFileBrowserData = {
                datastoreId: datastoreId,
                initialFileQueryType: initialFileQueryType,
                filterFileQueryTypes: filterFileQueryTypes,
                showVmImagesFolder: false,
                selectedFileChanged: function (selectedFile) {
                    selectedVmConfigFile = selectedFile;
                    dialogScope.dialogOptions.confirmOptions.disabled = !selectedVmConfigFile;
                }
            };
            dialogScope.dialogOptions = {
                title: this.i18nService.getString('Common', 'dsBrowser.defaultTitle'),
                contentUrl: 'storage-ui/resources/storage/register-vm/select-vm-to-register.view.html',
                show: true,
                width: '1000px',
                selectedObject: {},
                confirmOptions: {
                    disabled: true,
                    onClick: function () {
                        if (onFileSelectedCallback) {
                            onFileSelectedCallback(selectedVmConfigFile);
                        }
                        return true;
                    }
                }
            };
            var config = {
                scope: dialogScope,
                configObjectName: 'dialogOptions'
            };
            this.vuiDialogService(config);
        };
        SelectVmToRegisterService.$inject = ['vuiDialogService', '$rootScope', 'i18nService',
            'datastoreBrowserConstants', 'vuiConstants'];
        return SelectVmToRegisterService;
    }());
    storage_ui.SelectVmToRegisterService = SelectVmToRegisterService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("selectVmToRegisterService", SelectVmToRegisterService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').factory('adapterTargetsService',
      ['dataService', 'hostStorageConstants', 'defaultUriSchemeUtil', 'logService', 'mutationService',
         function (dataService, hostStorageConstants, defaultUriSchemeUtil, logService, mutationService) {
            var log = logService('adapterTargetsService');

            var targets = {
               adapterKey: undefined,
               dynamicTargets: [],
               staticTargets: []
            };

            return {
               retrieveIscsiAdapterTargets: retrieveIscsiAdapterTargets,
               addIscsiAdapterTargets: addIscsiAdapterTargets,
               removeIscsiAdapterTargets: removeIscsiAdapterTargets
            };

            function retrieveIscsiAdapterTargets(hostId, storageAdapterKey) {
               var STORAGE_BUS_ADAPTER_PROPERTY = "hostBusAdapter";

               var params;
               if (storageAdapterKey) {
                  params =
                     constructStringParamForProperty(STORAGE_BUS_ADAPTER_PROPERTY, storageAdapterKey);
               }

              return dataService.getProperties(hostId, [STORAGE_BUS_ADAPTER_PROPERTY], params).then(function(response) {
                 var result = response[STORAGE_BUS_ADAPTER_PROPERTY] || {};

                 targets.adapterKey = storageAdapterKey;
                 targets.dynamicTargets = [];
                 targets.staticTargets = [];
                 targets.hba = result;

                 var dynamicTargetsByNameMap = {};

                 // Populates dynamic targets
                 if (result.configuredSendTarget) {
                    var dynamicTargets = [];
                    result.configuredSendTarget.forEach(function(target) {
                       var formattedServerAddress = getFormattedServerAddress(target);
                       dynamicTargets.push(
                          {
                             address: formattedServerAddress,
                             target: target
                          }
                       );
                       dynamicTargetsByNameMap[formattedServerAddress] = target;
                    });
                    targets.dynamicTargets = dynamicTargets;
                 }

                 // Populates static targets
                 if (result.configuredStaticTarget) {
                    var staticTargets = [];
                    result.configuredStaticTarget.forEach(function(target) {
                       var parentAuthProperties = null;
                       if (dynamicTargetsByNameMap.hasOwnProperty(target.parent)) {
                          parentAuthProperties = dynamicTargetsByNameMap[target.parent].authenticationProperties;
                       }

                       staticTargets.push(
                          {
                             address: getFormattedServerAddress(target),
                             name: target.iScsiName,
                             target: target,
                             parentDynamicTargetAuthProperties: parentAuthProperties
                          }
                       );
                    });
                    targets.staticTargets = staticTargets;
                 }
                 return targets;
              });
            }

            function addIscsiAdapterTargets (hostId, isDynamicTarget, device, port, address, iscsiName, authenticationProperties) {
               var target = createTarget(isDynamicTarget, device, port, address, iscsiName, authenticationProperties);
               var spec = createSpec(true, hostId, isDynamicTarget, device, target);
               return mutationService.apply(hostId, spec._type, spec);
            }

            function removeIscsiAdapterTargets (hostId, isDynamicTarget, device, target) {
               var spec = createSpec(false, hostId, isDynamicTarget, device, target);
               return mutationService.apply(hostId, spec._type, spec);
            }

            function createTarget(isDynamicTarget, device, port, address, iscsiName, authenticationProperties) {
               if (!device || !port || !address) {
                  log.error('Some of mandatory parameters were null or undefined');
               }
               if (!isDynamicTarget && !iscsiName) {
                  log.error('iscsiName is mandatory for static targets');
               }

               if (isDynamicTarget) {
                  return {
                     _type: 'com.vmware.vim.binding.vim.host.InternetScsiHba$SendTarget',
                     address: address,
                     port: port,
                     parent: device,
                     authenticationProperties: authenticationProperties
                  };
               } else {
                  return {
                     _type: 'com.vmware.vim.binding.vim.host.InternetScsiHba$StaticTarget',
                     address: address,
                     port: port,
                     iScsiName: iscsiName,
                     parent: device,
                     authenticationProperties: authenticationProperties
                  };
               }
            }

            function createSpec (isAdd, hostId, isDynamicTarget, device, target) {
               if (!hostId || !device || !target) {
                  log.error('Some of mandatory parameters were null or undefined');
               }

               if (isDynamicTarget) {
                  return {
                     _type: 'com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterSendTargetsSpec',
                     isAdditionOperation: isAdd,
                     device: device,
                     hostRef: defaultUriSchemeUtil.getManagedObjectReference(hostId),
                     sendTargets: [target]
                  };
               } else {
                  return {
                     _type: 'com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterStaticTargetsSpec',
                     isAdditionOperation: isAdd,
                     device: device,
                     hostRef: defaultUriSchemeUtil.getManagedObjectReference(hostId),
                     staticTargets: [target]
                  };
               }
            }

            function getFormattedServerAddress(dynamicTarget) {
               var formattedAddress = "";
               if (!dynamicTarget) {
                  return formattedAddress;
               }

               var port = dynamicTarget.port || hostStorageConstants.DEFAULT_PORT_VALUE;
               formattedAddress = formattedAddress.concat(dynamicTarget.address, ":", port);

               return formattedAddress;
            }

            function constructStringParamForProperty (propertyName, paramValue) {
               return {
                  propertyParams: [{
                     propertyName: propertyName,
                     parameterType: 'java.lang.String',
                     parameter: paramValue
                  }]
               };
            }
         }]);
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * @ngdoc service
 * @name com.vmware.vsphere.client.storage:datastoreConstants
 * @module com.vmware.vsphere.client.storage
 *
 * @description
 *    The `datastoreConstants` service holds datastores related constants.
 *
 *    List of available `datastoreConstants`:
 *
 *    - nfsVersions
 *       - **`NFS_3`** : NFS 3 version datastore.
 *       - **`NFS_4_1`** : NFS 4.1 version datastore.
 *    - maximum length of datastore names
 */
angular.module('com.vmware.vsphere.client.storage').constant('datastoreConstants', {
   datastoreTypes: {
      VMFS: "VMFS",
      NFS: "NFS",
      NFS3: "NFS3",
      VVOL: "VVOL",
      VSAN: "VSAN"
   },

   nfsVersions: {
      NFS_3: 'nfs',
      NFS_4_1: 'nfs41'
   },

   datastoreSpecificType: {
      nfs3: "NFS",
      nfs41: "NFS41",
      vsan: "vsan",
      vvol: "VVol",
      vmfs3: "VMFS 3",
      vmfs5: "VMFS 5",
      vmfs6: "VMFS 6"
   },

   vmfsVersions: {
      VMFS_3: 3,
      VMFS_5: 5,
      VMFS_6: 6
   },

   accessModes: {
      readOnly: 'readOnly',
      readWrite: 'readWrite'
   },

   maxNameLengthForNfsDatastore: 42,
   maxNameLengthForNonNfsDatastore: 80,

   BYTES_TO_GB: 1024 * 1024 * 1024,
   MB_TO_GB: 1024,
   vmfsSize: {
      DATASTORE_SIZE_STEP_IN_BYTES: 10737418.24,
      MIN_DATASTORE_SIZE_GB: 1.3,
      MIN_DATASTORE_V6_SIZE_GB: 2,
   },

   reclamationPriority: {
      NONE: 'none',
      LOW: 'low'
   },

   protocolEndpoint: {
      type: {
         block: "block",
         nas: "nas"
      }
   },

   scsiDiskType: {
      EMULATED_512: "emulated512",
      NATIVE_4K: "native4k",
      SOFTWARE_EMULATED_4K: "SoftwareEmulated4k",
      NATIVE_512: "native512",
      UNKNOWN: "unknown"
   },

   kerberosSecurityTypes: {
      AUTH_SYS: "AUTH_SYS",
      SEC_KRB5: "SEC_KRB5",
      SEC_KRB5I: "SEC_KRB5I"
   }
});

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   /**
    * By a given datacenter reference and datastore path provides
    * the URL from which a file located on a datastore can be downloaded.
    *
    * The datastore path is in the form:
    * [datastore] Virtual Machine/Virtual Machine.vmdk
    */
   angular.module('com.vmware.vsphere.client.storage').factory('datastoreFileService',
         ['userSessionService', 'dataService', '$q', 'defaultUriSchemeUtil', '$window',
            function (userSessionService, dataService, $q, defaultUriSchemeUtil, $window) {

               function getFileUrls(datacenterRef, datastorePaths) {
                  var serverGuid = datacenterRef.serverGuid;
                  var datacenterId = defaultUriSchemeUtil.getVsphereObjectId(datacenterRef);

                  return $q.all([
                     userSessionService.getServerInfo(serverGuid),
                     dataService.getProperties(datacenterId, ['name'])
                  ]).then(function (result) {
                     var serverInfo = result[0];
                     var datastoreData = result[1];

                     var fileUrls = datastorePaths.map(function (datastorePath) {
                        var pathParts = datastorePath.match(/^\[(.*?)\]\s{1}(.*)$/);
                        var datastoreName = pathParts[1];
                        var filePath = pathParts[2];
                        var fileUrl = createFileUrl(
                              serverInfo.serviceUrl,
                              filePath,
                              datastoreName,
                              datastoreData.name);

                        return fileUrl;
                     });

                     return fileUrls;
                  });
               }

               function createFileUrl(serviceUrl, filePath, datastoreName, datacenterName) {
                  var parser = document.createElement("a");
                  parser.href = serviceUrl;

                  var fileUrl = parser.protocol
                        .concat('//')
                        .concat(parser.host)
                        .concat('/folder/')
                        .concat(filePath)
                        .concat('?dcPath=')
                        .concat(datacenterName)
                        .concat('&dsName=')
                        .concat(datastoreName);

                  return fileUrl;
               }

               function startFileDownload(fileUrl) {
                  $window.open(fileUrl, '_blank');
               }

               return {
                  getFileUrls: getFileUrls,
                  startFileDownload: startFileDownload
               };
            }
         ]);
})();
/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var FileCopyService = (function () {
        function FileCopyService(clarityModalService, i18nService, mutationService, defaultUriSchemeUtil, clarityConstants, dataService, datastoreConstants) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityConstants = clarityConstants;
            this.dataService = dataService;
            this.datastoreConstants = datastoreConstants;
        }
        FileCopyService.prototype.copyFiles = function (datastoreId, dcRef, filesToCopy, type, callback) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "pathPicker.defaultTitle"),
                contentTemplate: "storage-ui/resources/storage/views/manage/files/CopyFilesDialog.html",
                size: "lg",
                dialogData: {
                    i18n: this.i18nService.getString.bind(this, "StorageUi"),
                    datastores: [],
                    selectedDestination: {
                        path: null,
                        name: null
                    },
                    hasSelectedDatastore: false,
                    selectedDatastore: {
                        id: datastoreId,
                        type: null,
                        name: null
                    },
                    overwriteFiles: false
                },
                onSubmit: function () {
                    var alerts = _this.validateDialogData(modalOptions.dialogData);
                    if (alerts.length) {
                        modalOptions.alerts = alerts;
                        return false;
                    }
                    var datastoreFileCopySpec = {
                        _type: type,
                        sourceDatacenter: dcRef,
                        destinationPath: modalOptions.dialogData.selectedDestination.path,
                        destinationDatastore: _this.defaultUriSchemeUtil.getManagedObjectReference(modalOptions.dialogData.selectedDatastore.id),
                        sourcePaths: [],
                        sourceFileTypes: [],
                        overwrite: modalOptions.dialogData.overwriteFiles,
                        waitTasksToComplete: true
                    };
                    _.forEach(filesToCopy, function (fileToCopy) {
                        datastoreFileCopySpec.sourcePaths.push(fileToCopy.path);
                        datastoreFileCopySpec.sourceFileTypes.push(fileToCopy.fileType);
                    });
                    _this.mutationService.apply(datastoreId, type, datastoreFileCopySpec).then(function () {
                        if (callback) {
                            callback(modalOptions.dialogData.selectedDatastore.id, modalOptions.dialogData.selectedDestination.path);
                        }
                    });
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            this.loadData(datastoreId).then(function (response) {
                modalOptions.dialogData.datastores = response["storage:datastoresInVc"];
            });
        };
        FileCopyService.prototype.loadData = function (datastoreId) {
            var rootFolder = this.defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(datastoreId);
            return this.dataService.getProperties(rootFolder, ["storage:datastoresInVc"]);
        };
        FileCopyService.prototype.validateDialogData = function (dialogData) {
            var result = [];
            var alert = {
                type: this.clarityConstants.notifications.type.ERROR,
                text: null
            };
            if (!dialogData.hasSelectedDatastore) {
                alert.text = this.i18nService.getString("StorageUi", "pathPicker.noDatastoreSelected");
            }
            else if (!dialogData.selectedDestination.path) {
                alert.text = this.i18nService.getString("StorageUi", "pathPicker.noLocationSelected");
            }
            else if (dialogData.selectedDatastore.type.toUpperCase() === this.datastoreConstants.datastoreTypes.VSAN
                && dialogData.selectedDestination.name === dialogData.selectedDatastore.name) {
                alert.text = this.i18nService.getString("StorageUi", "pathPicker.vsanRootSelected");
            }
            else if (dialogData.selectedDatastore.type.toUpperCase() === this.datastoreConstants.datastoreTypes.VVOL
                && dialogData.selectedDestination.name === dialogData.selectedDatastore.name) {
                alert.text = this.i18nService.getString("StorageUi", "pathPicker.vvolRootSelected");
            }
            if (alert.text) {
                result.push(alert);
            }
            return result;
        };
        FileCopyService.$inject = [
            "clarityModalService",
            "i18nService",
            "mutationService",
            "defaultUriSchemeUtil",
            "clarityConstants",
            "dataService",
            "datastoreConstants"];
        return FileCopyService;
    }());
    storage_ui.FileCopyService = FileCopyService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("fileCopyService", FileCopyService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   /**
    * Service for initiating download of files from a datastore.
    */
   angular.module('com.vmware.vsphere.client.storage').factory('fileDownloadService',
         ['$timeout', '$window', 'fileUrlResolverService', 'browserService',
            '$http', '$httpParamSerializer', 'defaultUriSchemeUtil', 'i18nService',
            'storageUtil', 'dataService', '$cookies', 'clarityModalService',
            function ($timeout, $window, fileUrlResolverService, browserService,
               $http, $httpParamSerializer, defaultUriSchemeUtil, i18nService,
               storageUtil, dataService, $cookies, clarityModalService) {

               var IE_URL_LIMIT = 2047;
               var BROWSER_URL_LIMIT = 30000;

               var DOWNLOAD_FILES_AS_ZIP_URL = "filedownload";
               var REQUEST_TOKEN_PARAM = "requestToken";
               var TOKEN_PARAM = "token";

               var publicApi = {
                  startFilesDownload: function (dc, ds, paths, isStreamFormat) {
                     var is_safari = browserService.isSafari;
                     // initializes the method based on browser on first call
                     publicApi.startFilesDownload = (is_safari) ? startSafariFileDownload : startFilesDownload;
                     return publicApi.startFilesDownload(dc, ds, paths, isStreamFormat);
                  },
                  startFilesDownloadAsZip: startFilesDownloadAsZip
               };

               return publicApi;

               function startFilesDownloadAsZip (datacenterRef, datastoreId,
                     datastorePaths, fileName, baseDatastorePath, isStreamFormat) {

                  var isMultipleFilesDownloadSupported = 'datastore:isMultipleFilesDownloadSupported';
                  dataService.getProperties(datastoreId, isMultipleFilesDownloadSupported).then(function(resp) {
                     if (resp[isMultipleFilesDownloadSupported]) {
                        checkBlockingPopUp();
                        var downloadSpec = {
                           vcServerGuid: datacenterRef.serverGuid,
                           resultFileName: fileName,
                           datacenterId: defaultUriSchemeUtil.getVsphereObjectId(datacenterRef),
                           datastoreId: datastoreId,
                           datastorePath: datastorePaths,
                           baseDatastorePath: baseDatastorePath
                        };

                        if (isStreamFormat) {
                           downloadSpec.diskFormat = 'StreamVmdk';
                        }

                        var downloadParams = $httpParamSerializer(downloadSpec);

                        openDownloadTab(downloadParams);
                     } else {
                        storageUtil.showErrorDialog(i18nService.getString("StorageUi", "fileDownload.error.noEndpointsError"));
                     }
                  });
               }

               function startFilesDownload (datacenterRef, datastoreId, datastorePaths,
                     isStreamFormat) {
                  fileUrlResolverService.resolveFileUrls(datacenterRef, datastoreId,
                        datastorePaths, isStreamFormat).then(function (data) {
                     if(!data || !data.fileTransferEndpoints){
                        storageUtil.showErrorDialog(i18nService.getString("StorageUi", "fileDownload.error.noEndpointsError"));
                     } else {
                        data.fileTransferEndpoints.forEach(function (endpoint) {
                           checkBlockingPopUp();
                           if (endpoint.ticket) {
                              _downloadFile(endpoint);
                           } else {
                              var downloadParams = buildDownloadParams(datacenterRef, datastoreId, datastorePaths);
                              openDownloadTab(downloadParams);
                           }
                        });
                     }
                  });
               }

               function _downloadFile (endpoint) {
                  // create a form with the vmware_cgi_ticket field and target='_blank'
                  var form = createFileDownloadForm($window, endpoint);
                  try {
                     form.submit();
                  } finally {
                     // IE does not support element.remove(). Wrap it in angular element
                     angular.element(form).remove();
                  }
               }

               function createFileDownloadForm (window, endpoint, target) {
                  var form = window.document.createElement("form");
                  form.action = endpoint.url;
                  form.target = target || "_blank";
                  form.method = "get";

                  if (endpoint.ticket) {
                     // Post the vmware_cgi_ticket
                     form.method = "post";
                     var ticketInput = window.document.createElement("input");
                     ticketInput.type = "hidden";
                     ticketInput.name = "vmware_cgi_ticket";
                     ticketInput.value = endpoint.ticket;
                     form.appendChild(ticketInput);
                  }

                  window.document.body.appendChild(form);
                  return form;
               }

               function startSafariFileDownload (datacenterRef, datastoreId,
                     datastorePaths, isStreamFormat) {
                  // Safari's built in popup blocker blocks window open
                  // if it was called in an async operation callback.
                  //
                  // It allows opening window only in the context of an
                  // user click action.
                  // So we open the window upfront, resolve the file download URL and
                  // change the location of the window or create and submit a form in the
                  // new window with the vmware_cgi_ticket ticket.
                  var windowHandle = [];
                  datastorePaths.forEach(function () {
                     windowHandle.push($window.open('about:blank', '_blank'));
                  });

                  fileUrlResolverService.resolveFileUrls(datacenterRef, datastoreId,
                        datastorePaths, isStreamFormat)
                        .then(function (data) {
                           // Open the file URL in a new window to trigger download.
                           data.fileTransferEndpoints.forEach(function (endpoint, index) {
                              if (endpoint.ticket) {
                                 // Create a form with the vmware_cgi_ticket field
                                 // Use target self for safari otherwise the popup blocker wont open it.
                                 var form = createFileDownloadForm(windowHandle[index], endpoint, "_self");
                                 form.submit();
                              } else {
                                 var downloadParams = buildDownloadParams(datacenterRef, datastoreId, datastorePaths);
                                 windowHandle[index].location.href = DOWNLOAD_FILES_AS_ZIP_URL + "?" + downloadParams;
                              }
                           });
                        });
               }

               function requestFileDownloadToken(downloadParams) {
                  var headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
                  headers[h5.xsrfCookieName] = $cookies.get(h5.xsrfCookieName);
                  downloadParams += "&" + REQUEST_TOKEN_PARAM + "=true";
                  return $http({
                     method: "POST",
                     url: DOWNLOAD_FILES_AS_ZIP_URL,
                     data: downloadParams,
                     headers: headers
                  }).then(function(response) {
                     return response.data;
                  });
               }

               function isUrlLengthTooBig(url) {
                  return !browserService.isIe && url.length > BROWSER_URL_LIMIT
                     || browserService.isIe && url.length > IE_URL_LIMIT;
               }

               function appendSlashIfNeeded(string) {
                  var stringWithSlash = string;
                  if (string.lastIndexOf("/") !== string.length - 1) {
                     stringWithSlash += "/";
                  }
                  return stringWithSlash;
               }

               function checkBlockingPopUp () {
                  browserService.areBlockingPopupsAllowed().then(function(status) {
                     if (!status) {
                        var modalOptions = {
                           title: i18nService.getString('StorageUi', 'fileDownload.blockingPopup.title'),
                           hideCancelButton: true,
                           message: i18nService.getString('StorageUi', 'fileDownload.blockingPopup.message'),
                           icon: 'icon-warning-32',
                           submit: function () {
                              return true;
                           },
                           preserveNewlines: true
                        };
                        clarityModalService.openConfirmationModal(modalOptions);
                     }
                  });
               }

               function buildDownloadParams(datacenterRef, datastoreId, datastorePaths) {
                  return $httpParamSerializer({
                     vcServerGuid: datacenterRef.serverGuid,
                     datacenterId: defaultUriSchemeUtil.getVsphereObjectId(datacenterRef),
                     datastoreId: datastoreId,
                     datastorePath: datastorePaths
                  });
               }

               function openDownloadTab(downloadParams) {
                  var url = appendSlashIfNeeded($window.location.href) +
                        DOWNLOAD_FILES_AS_ZIP_URL + "?" + downloadParams;
                  if (isUrlLengthTooBig(url)) {
                     // Pass the parameters via POST instead of GET, get
                     // the token from the response and use it to download
                     // the zip produced with the parameters.
                     requestFileDownloadToken(downloadParams)
                           .then(function(token) {
                              var tokenMap = {};
                              tokenMap[TOKEN_PARAM] = token;
                              var tokenParams = $httpParamSerializer(tokenMap);
                              $window.open(DOWNLOAD_FILES_AS_ZIP_URL + "?" + tokenParams, "_blank");
                           });
                     return;
                  }

                  $window.open(DOWNLOAD_FILES_AS_ZIP_URL + "?" + downloadParams, "_blank");
               }
            }
         ]);
})();

var storage_ui;
(function (storage_ui) {
    var FileReaderService = (function () {
        function FileReaderService($q) {
            this.$q = $q;
        }
        FileReaderService.prototype.readFileContentAsBase64 = function (file) {
            if (!file) {
                return this.$q.when(null);
            }
            var deferredResult = this.$q.defer();
            var fileReader = new FileReader();
            fileReader.onload = function () {
                var dataUrl = fileReader.result;
                if (dataUrl && dataUrl.indexOf(",") >= 0) {
                    deferredResult.resolve(dataUrl.substring(dataUrl.indexOf(",") + 1));
                }
                else {
                    deferredResult.resolve(null);
                }
            };
            fileReader.addEventListener("error", function () {
                deferredResult.resolve(null);
            });
            fileReader.readAsDataURL(file);
            return deferredResult.promise;
        };
        FileReaderService.$inject = ["$q"];
        return FileReaderService;
    }());
    storage_ui.FileReaderService = FileReaderService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("fileReaderService", FileReaderService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    /**
     * File upload event and task state constants.
     */
    angular.module("com.vmware.vsphere.client.storage").constant("fileUploadConstants", {
        event: {
            UPDATED: "FILE_UPLOAD_UPDATED",
            COMPLETE: "FILE_UPLOAD_COMPLETE"
        },
        state: {
            RUNNING: "RUNNING",
            SUCCESS: "SUCCESS",
            ERROR: "ERROR",
            CANCELED: "CANCELED"
        }
    });
    var PendingCancelRequestsRegistry = (function () {
        function PendingCancelRequestsRegistry() {
            this.datastoresWithCancelledUploads = {};
        }
        PendingCancelRequestsRegistry.prototype.contructor = function () { };
        PendingCancelRequestsRegistry.prototype.add = function (datastoreId) {
            this.datastoresWithCancelledUploads[datastoreId] = true;
        };
        PendingCancelRequestsRegistry.prototype.remove = function (datastoreId) {
            this.datastoresWithCancelledUploads[datastoreId] = false;
        };
        PendingCancelRequestsRegistry.prototype.isPresent = function (datastoreId) {
            return this.datastoresWithCancelledUploads[datastoreId];
        };
        return PendingCancelRequestsRegistry;
    }());
    /**
     * Service for uploading files to a datastore and tracking the transfer
     * progress.
     */
    var FileUploadService = (function () {
        function FileUploadService($rootScope, fileUploadConstants, fileUrlResolverService, $cookies, defaultUriSchemeUtil, i18nService, storageUtil, $interval, clarityModalService, $q) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.fileUploadConstants = fileUploadConstants;
            this.fileUrlResolverService = fileUrlResolverService;
            this.$cookies = $cookies;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18nService = i18nService;
            this.storageUtil = storageUtil;
            this.$interval = $interval;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
            this.MAX_UPLOADS_AT_TIME = 10;
            this.POLL_INTERVAL_MS = 3 * 1000;
            this.xhrRequestBySessionId = {};
            this.currentUploadSessionId = 0;
            this.pendingCancelRequestsRegistry = new PendingCancelRequestsRegistry();
            /**
             * Handles session expiration events.
             * If there is upload still in progress prevents
             * session expiration.
             */
            this.onSessionExpiration = function (event) {
                if (_this.isUploadInProgress()) {
                    event.preventDefault();
                }
            };
            /**
             * Handles user logout events.
             * If there is upload still in progress shows confirmation message for the logout operation.
             */
            this.onUserLogout = function (event, options) {
                if (_this.isUploadInProgress()) {
                    var logoutConfirmationResult_1 = _this.$q.defer();
                    _this.clarityModalService.openConfirmationModal({
                        message: _this.i18nService.getString("StorageUi", "upload.logout.warning.message"),
                        title: _this.i18nService.getString("StorageUi", "upload.logout.warning.title"),
                        clarityIcon: {
                            class: "is-warning",
                            shape: "warning-standard",
                            size: "32"
                        },
                        preserveNewlines: true,
                        saveButtonLabel: _this.i18nService.getString("Common", "yes.label"),
                        cancelButtonLabel: _this.i18nService.getString("Common", "no.label"),
                        submit: function () {
                            // allow logout
                            logoutConfirmationResult_1.resolve(false);
                        },
                        onCancel: function () {
                            // prevent logout
                            logoutConfirmationResult_1.resolve(true);
                        }
                    });
                    options.preventLogout = logoutConfirmationResult_1.promise;
                    event.preventDefault();
                }
            };
            this.uploadSessions = [];
            $rootScope.$on('sessionExpired', this.onSessionExpiration);
            $rootScope.$on('onUserLogout', this.onUserLogout);
        }
        /**
         * Returns Boolean value indicating if there is running upload
         * task.
         * NOTE: The upload session array is traversed starting from
         * the last element because sessions are added at the
         * back of the array so it is more likely for a running
         * session to be closer to the end of the array.
         */
        FileUploadService.prototype.isUploadInProgress = function () {
            var lastRunningSessionIndex = _.findLastIndex(this.uploadSessions, {
                status: this.fileUploadConstants.state.RUNNING
            });
            return (lastRunningSessionIndex !== -1);
        };
        /**
         * Returns copy of the upload sessions array.
         *
         * @param datastoreId Optional parameter to get upload sessions associated with
         * a particular datastore. If not provided upload sessions for all datastores are
         * returned
         */
        FileUploadService.prototype.getUploadSessions = function (datastoreId) {
            return this.uploadSessions.filter(function (uploadSession) {
                return !datastoreId || uploadSession.datastoreId === datastoreId;
            });
        };
        FileUploadService.prototype.getRunningUploadSessions = function (datastoreId) {
            var _this = this;
            return this.uploadSessions.filter(function (uploadSession) {
                return (!datastoreId || uploadSession.datastoreId === datastoreId)
                    && uploadSession.status === _this.fileUploadConstants.state.RUNNING;
            });
        };
        FileUploadService.prototype.startFilesUpload = function (datastoreDcRef, datastoreId, datastorePath, files, isDatastoreSelected, isStreamFormat) {
            var _this = this;
            var delimiter = isDatastoreSelected ? " " : "/";
            this.slotsAvailable = this.MAX_UPLOADS_AT_TIME;
            var stop = null;
            var existingFolders = {};
            var uploadNextBatch = function () {
                if (files.length === 0 || _this.pendingCancelRequestsRegistry.isPresent(datastoreId)) {
                    _this.$interval.cancel(stop);
                    _this.pendingCancelRequestsRegistry.remove(datastoreId);
                    return;
                }
                var batchToUpload = [];
                while (_this.slotsAvailable && files.length !== 0) {
                    var args = files.pop();
                    var isRelativePathAvailableOnDatastore = true;
                    if (args.webkitRelativePath) {
                        // In case of folder upload we should check whether
                        // the file path exists on the datastore
                        var lastFolderDelimiterIndex = args.webkitRelativePath.lastIndexOf("/");
                        if (lastFolderDelimiterIndex > 0) {
                            var relativePath = args.webkitRelativePath.substring(0, lastFolderDelimiterIndex);
                            if (!existingFolders.hasOwnProperty(relativePath)) {
                                isRelativePathAvailableOnDatastore = false;
                                // the path doesn't exist, we should add it and its
                                // parent folders to the existingFolders map as they will
                                // be created when the file is uploaded.
                                var subFolders = relativePath.split("/");
                                var currentPath = "";
                                for (var i = 0; i < subFolders.length; i++) {
                                    if (currentPath) {
                                        currentPath += "/";
                                    }
                                    currentPath += subFolders[i];
                                    existingFolders[currentPath] = true;
                                }
                            }
                        }
                    }
                    batchToUpload.push(args);
                    _this.slotsAvailable--;
                    if (!isRelativePathAvailableOnDatastore) {
                        // the path doesn't exist, we shouldn't upload more items
                        // in the current batch
                        break;
                    }
                }
                if (batchToUpload.length) {
                    _this.uploadBatch(batchToUpload, datastoreDcRef, datastoreId, datastorePath, delimiter, isStreamFormat).then(function (uploadStarted) {
                        if (!uploadStarted) {
                            _this.$interval.cancel(stop);
                        }
                    });
                }
            };
            // Prevent a stale registry.
            this.pendingCancelRequestsRegistry.remove(datastoreId);
            stop = this.$interval(function () { return uploadNextBatch(); }, this.POLL_INTERVAL_MS);
            // avoid initial delay
            uploadNextBatch();
        };
        FileUploadService.prototype.cancelFilesUpload = function (datastoreId) {
            var _this = this;
            // Make batch upload stop (uploads enqueued but not yet started).
            this.pendingCancelRequestsRegistry.add(datastoreId);
            // Stop any currently running uploads.
            var uploading = this.getUploadSessions(datastoreId);
            uploading.forEach(function (uploadSession) {
                if (uploadSession.status === _this.fileUploadConstants.state.RUNNING) {
                    _this.cancelUpload(uploadSession);
                }
            });
        };
        FileUploadService.prototype.uploadBatch = function (batchToUpload, datastoreDcRef, datastoreId, datastorePath, delimiter, isStreamFormat) {
            var _this = this;
            var uploadTargetPaths = _.map(batchToUpload, function (file) { return datastorePath + delimiter + (file.webkitRelativePath || file.name); });
            return this.fileUrlResolverService.resolveFileUrls(datastoreDcRef, datastoreId, uploadTargetPaths, isStreamFormat)
                .then(function (response) {
                if (!response || !response.fileTransferEndpoints || !response.fileTransferEndpoints.length) {
                    _this.storageUtil.showErrorDialog(_this.i18nService.getString("StorageUi", "fileUpload.error.noEndpointsError"));
                    return false;
                }
                else {
                    for (var i = 0; i < response.fileTransferEndpoints.length; i++) {
                        var uploadTarget = undefined;
                        if (response.fileTransferEndpoints && response.fileTransferEndpoints.length
                            && response.fileTransferEndpoints[i].ticket) {
                            uploadTarget = response.fileTransferEndpoints[i];
                        }
                        else {
                            uploadTarget = { url: _this.getLocalProxyUploadUrl(datastoreDcRef, datastoreId, uploadTargetPaths[i], isStreamFormat) };
                        }
                        _this.startXhrUpload(batchToUpload[i], datastorePath, uploadTargetPaths[i], uploadTarget.url, uploadTarget.ticket, datastoreId);
                    }
                    return true;
                }
            });
        };
        ;
        FileUploadService.prototype.showError = function (uploadSession) {
            this.storageUtil.showErrorDialog(uploadSession.error, uploadSession.trustErrorMessageAsHtml);
        };
        FileUploadService.prototype.finishUploadSession = function (uploadSession) {
            this.xhrRequestBySessionId[uploadSession.id] = null;
            uploadSession.isCancelable = false;
            uploadSession.cancel = null;
        };
        FileUploadService.prototype.startXhrUpload = function (file, datastorePath, uploadTargetPath, uploadUrl, uploadTicket, datastoreId) {
            var _this = this;
            var xhr = new XMLHttpRequest();
            var now = new Date();
            var uploadSession = {
                id: this.currentUploadSessionId++,
                name: uploadTargetPath,
                datastorePath: datastorePath,
                datastoreId: datastoreId,
                progress: 0,
                uploadedSizeInB: 0,
                sizeInB: file.size,
                status: this.fileUploadConstants.state.RUNNING,
                startTime: now,
                lastUpdated: now,
                isCancelable: true,
                uploadUrl: uploadUrl,
                isGeneralError: false,
                error: "",
                // indicates whether the error message should be sanitized or not:
                // true = do not sanitize; false = sanitize
                trustErrorMessageAsHtml: false
            };
            this.xhrRequestBySessionId[uploadSession.id] = xhr;
            uploadSession.showError = this.showError.bind(this, uploadSession);
            uploadSession.cancel = this.cancelUpload.bind(this, uploadSession);
            this.uploadSessions.splice(0, 0, uploadSession);
            this.broadcastEvent(this.fileUploadConstants.event.UPDATED, uploadSession);
            xhr.addEventListener("load", function () {
                _this.slotsAvailable++;
                _this.uploadComplete(uploadSession, xhr);
                removeOnProgressEventListener();
            }, false);
            xhr.addEventListener("error", function () {
                _this.slotsAvailable++;
                _this.uploadComplete(uploadSession, xhr);
                removeOnProgressEventListener();
            }, false);
            var onProgress = _.throttle(function (e) {
                _this.reportProgress(uploadSession, e);
            }, 2000);
            function removeOnProgressEventListener() {
                if (xhr.upload) {
                    xhr.upload.removeEventListener("progress", onProgress);
                }
            }
            if (xhr.upload) {
                xhr.upload.addEventListener("progress", onProgress);
            }
            xhr.open("PUT", uploadUrl);
            xhr.setRequestHeader("Content-type", "application/octet-stream");
            if (uploadTicket) {
                // There is an upload ticket, so trying upload directly to the given URL
                xhr.setRequestHeader("vmware-cgi-ticket", uploadTicket);
            }
            else {
                var xsrfCookie = this.$cookies.get(h5.xsrfCookieName);
                if (xsrfCookie) {
                    xhr.setRequestHeader(h5.xsrfHeaderName, xsrfCookie);
                }
            }
            xhr.send(file);
        };
        /**
         * Gets the file transfer proxy URL.
         */
        FileUploadService.prototype.getLocalProxyUploadUrl = function (datastoreDcRef, datastoreId, uploadTargetPath, isStreamFormat) {
            var uploadSpec = {
                vcServerGuid: datastoreDcRef.serverGuid,
                datacenterId: this.defaultUriSchemeUtil.getVsphereObjectId(datastoreDcRef),
                datastoreId: datastoreId,
                datastorePath: uploadTargetPath
            };
            if (isStreamFormat) {
                uploadSpec.diskFormat = "StreamVmdk";
            }
            var queryString = $.param(uploadSpec);
            var uploadUrlBuilder = document.createElement("a");
            uploadUrlBuilder.href = "fileupload";
            uploadUrlBuilder.search = queryString;
            return uploadUrlBuilder.href;
        };
        /**
         * Cancels the upload session and removes it from the
         * list of sessions.
         */
        FileUploadService.prototype.cancelUpload = function (uploadSession) {
            var xhr = this.xhrRequestBySessionId[uploadSession.id];
            if (xhr && uploadSession.isCancelable) {
                xhr.abort();
                this.finishUploadSession(uploadSession);
                uploadSession.status = this.fileUploadConstants.state.CANCELED;
                this.broadcastEvent(this.fileUploadConstants.event.UPDATED, uploadSession);
            }
        };
        /**
         * Updates the upload session progress based on the
         * xhr progress.
         */
        FileUploadService.prototype.reportProgress = function (uploadSession, e) {
            if (e.lengthComputable) {
                var percentComplete = Math.floor((e.loaded / e.total) * 100);
                if (percentComplete !== uploadSession.progress) {
                    uploadSession.progress = percentComplete;
                    uploadSession.uploadedSizeInB = e.loaded;
                    uploadSession.lastUpdated = new Date();
                    this.broadcastEvent(this.fileUploadConstants.event.UPDATED, uploadSession);
                }
            }
        };
        /**
         * Event handler for upload completion.
         * Regardless of the state of the operation it broadcasts
         * complete event.
         */
        FileUploadService.prototype.uploadComplete = function (uploadSession, xhr) {
            this.finishUploadSession(uploadSession);
            if (xhr.status === 200 || xhr.status === 201) {
                uploadSession.status = this.fileUploadConstants.state.SUCCESS;
                uploadSession.uploadedSizeInB = uploadSession.sizeInB;
            }
            else {
                uploadSession.status = this.fileUploadConstants.state.ERROR;
                var errorText = xhr.responseText;
                if (!errorText) {
                    var l = document.createElement("a");
                    l.href = uploadSession.uploadUrl;
                    // removing everything except the protocol + server for the error message
                    var serverUrl = l.protocol + "//" + l.hostname;
                    var kbArticleAnchor = "<a href='http://kb.vmware.com/kb/2147256' target='_blank'>http://kb.vmware.com/kb/2147256</a>";
                    var serverUrlAnchor = "<a href=\"" + serverUrl + "\" target=\"_blank\">" + serverUrl + "</a>";
                    errorText = this.i18nService.getString("StorageUi", "fileUpload.error.withUrl", serverUrlAnchor, kbArticleAnchor);
                    uploadSession.isGeneralError = true;
                    uploadSession.trustErrorMessageAsHtml = true;
                }
                uploadSession.error = errorText;
            }
            this.broadcastEvent(this.fileUploadConstants.event.UPDATED, uploadSession);
            this.broadcastEvent(this.fileUploadConstants.event.COMPLETE, uploadSession);
        };
        /**
         * Broadcasts and event and passes a copy of the upload
         * session as argument.
         */
        FileUploadService.prototype.broadcastEvent = function (name, uploadSession) {
            this.$rootScope.$broadcast(name, angular.copy(uploadSession));
        };
        return FileUploadService;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .factory("fileUploadService", ["$rootScope", "fileUploadConstants", "fileUrlResolverService",
        "$cookies", "defaultUriSchemeUtil", "i18nService", "storageUtil", "$interval",
        "clarityModalService", "$q",
        function ($rootScope, fileUploadConstants, fileUrlResolverService, $cookies, defaultUriSchemeUtil, i18nService, storageUtil, $interval, clarityModalService, $q) {
            return new FileUploadService($rootScope, fileUploadConstants, fileUrlResolverService, $cookies, defaultUriSchemeUtil, i18nService, storageUtil, $interval, clarityModalService, $q);
        }]);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   /**
    * Resolves a file location on a datastore to a URL that
    * can be used to download or upload a file.
    *
    * The datastore path is in the form:
    *    [datastore] Virtual Machine/Virtual Machine.vmdk
    *
    * The file URL is in the form:
    *    https://<hostname>/folder/Virtual%20Machine/Virtual%20Machine.vmdk?dcPath=datacenter&dsName=datastore
    */
   angular.module("com.vmware.vsphere.client.storage").factory("fileUrlResolverService",
         ["dataService", "browserService",
            function (dataService, browserService) {

               return {
                  resolveFileUrls: resolveFileUrls
               };

               function resolveFileUrls(datacenterRef, datastoreId, datastorePaths,
                     isStreamFormat) {
                  var param = [{
                     "propertyName": "fileTransferEndpoints",
                     "parameterType": "com.vmware.vsphere.client.storage.DatastoreFilePathsSpecEx",
                     "parameter": {
                        "datacenter": datacenterRef,
                        "datastorePaths": datastorePaths,
                        "isStreamFormat": isStreamFormat,
                        // Always use VC for IE file uploads due to IE CORS issue:
                        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/1282036/
                        "alwaysTransferThroughVc": browserService.isIe
                     }
                  }];

                  return dataService.getProperties(datastoreId, 'fileTransferEndpoints', {
                     propertyParams: param
                  });
               }
            }
         ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * @ngdoc service
 * @name com.vmware.vsphere.client.storage:hostStorageConstants
 * @module com.vmware.vsphere.client.storage
 *
 * @description
 *    The `hostStorageConstants` service holds host storage related constants.
 */
angular.module('com.vmware.vsphere.client.storage').constant('hostStorageConstants', {
   hostAdapterTypes: {
      ISCSI: 'ISCSI',
      FCOE: 'FCOE',
      FIBRECHANNEL: 'FIBRECHANNEL'
   },
   adapterDetailsAction: {
      ENABLE_SW_ISCSI_ADAPTER: "vsphere.core.host.actions.adapters.enableSoftwareIscsiAdapter",
      DISABLE_SW_ISCSI_ADAPTER: "vsphere.core.host.actions.adapters.disableSoftwareIscsiAdapter",
      EDIT_AUTH_SETTINGS: "vsphere.core.host.actions.adapters.editIscsiAuthenticationSettings",
      EDIT_GENERAL_SETTINGS: "vsphere.core.host.actions.adapters.editIscsiGeneralSettings"
   },
   adapterPathState: {
      ACTIVE: 'active',
      STANDBY: 'standby',
      DISABLED: 'disabled',
      DEAD: 'dead',
      UNKNOWN: 'unknown'
   },
   operationalState: {
      OK: 'ok',
      OFF: 'off',
      LOST_COMMUNICATION: 'lostCommunication',
      ERROR: 'error',
      UNKNOWN_STATE: 'unknownState'
   },
   DEFAULT_PORT_VALUE: 3260,
   PATH_SELECTION_POLICY_OPTIONS_PROP: 'pathSelectionPolicyOptions',
   STORAGE_ARRAY_TYPE_POLICY_OPTIONS_PROP: 'storageArrayTypePolicyOptions',
   EXTENTS_MULTIPATHING_INFO_PROP: 'datastore:vmfsExtentsMultipathingInfo',
   STORAGE_DEVICE_MULTIPATHING_INFO_PROP: 'storagedevice:hostStorageDeviceMultipathingInfo',
   STORAGE_DEVICE_MULTIPATHING_INFO_WITH_PATHS_PROP: 'storagedevice:hostStorageDeviceMultipathingInfoWithPaths',

   storagePolicies: {
      /**
       *  The key of the Fixed path policy.
       */
      FIXED_PATH: "VMW_PSP_FIXED",
      LEGACY_FIXED_PATH: "fixed",

      /**
       * The key of the Most Recently Used policy.
       */
      MOST_RECENTLY_USED_PATH: "VMW_PSP_MRU",
      LEGACY_MOST_RECENTLY_USED_PATH: "mru",

      /**
       * The key of the Round Robin policy.
       */
      ROUND_ROBIN: "VMW_PSP_RR",
      LEGACY_ROUND_ROBIN: "rr",

      /**
       * The key of the Unknown policy.
       */
      UNKNOWN: "VMW_PSP_UNKN"
   },

   protocolEndpoints: {
      BLOCK: "block",
      NAS: "nas"
   },

   connectionState: {
      CONNECTED: "connected",
      DISCONNECTED: "disconnected",
      NOT_RESPONDING: "notResponding"
   },

   deviceType: {
      CDROM: "cdrom",
      DISK: "disk"
   }
});

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';


   angular.module('com.vmware.vsphere.client.storage').factory('hostStorageService',
         ['dataService', 'i18nService', 'bytesFilter', '$q', 'defaultUriSchemeUtil',
            'mutationService', 'hostStorageConstants', '$rootScope',
         function (dataService, i18nService, bytesFilter, $q, defaultUriSchemeUtil,
               mutationService, hostStorageConstants, $rootScope) {

            var FORMAT_DISK_SPEC_TYPE = 'com.vmware.vsphere.client.storage.FormatHostDiskSpec';
            var MARK_AS_LOCAL_SPEC_TYPE = 'com.vmware.vsphere.client.storage.TagDiskAsLocalSpec';

            return {
               retrieveStorageDevicesData: retrieveStorageDevicesData,
               retrieveStorageDevicePartitionData: retrieveStorageDevicePartitionData,
               retrieveHostStorageAdapterPathsData: retrieveHostStorageAdapterPathsData,
               retrieveHostProtocolEndpointsPathsData: retrieveHostProtocolEndpointsPathsData,
               retrieveHostStorageDevicePathsData: retrieveHostStorageDevicePathsData,
               retrieveDatastoreStorageDevices: retrieveDatastoreStorageDevices,
               retrieveDatastoreIncreaseOptions: retrieveDatastoreIncreaseOptions,
               retrieveVmfsDatastoreMultipathingData: retrieveVmfsDatastoreMultipathingData,
               rescanStorageAdapters: rescanStorageAdapters,
               erasePartitions: erasePartitions,
               changeDiskLocalState: changeDiskLocalState
            };

            function retrieveStorageDevicesData(hostId, storageAdapterKey) {
               var STORAGE_DEVICE_PROPERTY= "storagedevice:hostStorageDevices";

               var params;
               if (storageAdapterKey) {
                  params = constructStringParamForProperty(STORAGE_DEVICE_PROPERTY, storageAdapterKey);
               }

               return dataService.getProperties(hostId, [STORAGE_DEVICE_PROPERTY], params)
                  .then(function(response) {
                     var storageDevices = response[STORAGE_DEVICE_PROPERTY] || [];

                     storageDevices.forEach(function(item) {
                        item.localizedState = i18nService.getString('StorageUi',
                              'storage.adapters.devices.deviceState.' + item.operationalState);

                        item.localizedDriveType = i18nService.getString('StorageUi',
                              item.isFlash ? 'disk.ssd' : 'disk.nonSSD');

                        item.localizedLunNumber = item.lunNumber >= 0 ? item.lunNumber : '';

                        item.localizedCapacity = item.isScsiDisk
                              ? bytesFilter(item.capacity, 'B', 'Auto', 2)
                              : '';

                        item.disabled = item.operationalState !== 'ok';
                     });

                     return storageDevices;
                  });
            }

            function retrieveStorageDevicePartitionData (hostId, storageDeviceKey) {
               var STORAGE_DEVICE_PARTITION_DATA_PROPERTY = "storagedevice:partitionDetails";

               if (!storageDeviceKey) {
                  return $q.when({"partitionFormat": "", "partitions": []});
               }

               var params = constructStringParamForProperty(STORAGE_DEVICE_PARTITION_DATA_PROPERTY, storageDeviceKey);

               return dataService.getProperties(hostId, [STORAGE_DEVICE_PARTITION_DATA_PROPERTY], params)
                  .then(function(response) {
                     var storageDevicePartitions = response[STORAGE_DEVICE_PARTITION_DATA_PROPERTY] || [];
                     return storageDevicePartitions;
                  });
            }

            function retrieveDatastoreStorageDevices (datastoreRef) {
               var STORAGE_DEVICE_PROPERTY = 'storagedevice:datastoreStorageDevices';

               return dataService.getProperties(datastoreRef, [STORAGE_DEVICE_PROPERTY]).then(function(response) {
                  return response[STORAGE_DEVICE_PROPERTY];
               });
            }

            function retrieveDatastoreIncreaseOptions (datastoreRef, hostRef, scsiDiskInfo) {
               var DATASTORE_INCREASE_OPTIONS = 'datastore:datastoreIncreaseOptions';
               var options = {
                  propertyParams: [{
                     propertyName: DATASTORE_INCREASE_OPTIONS,
                     parameterType: 'com.vmware.vsphere.client.storage.DatastoreIncreaseOptionsQuerySpec',
                     parameter: {
                        host: hostRef,
                        scsiDiskInfo: scsiDiskInfo
                     }
                  }]
               };
               return dataService.getProperties(datastoreRef, [DATASTORE_INCREASE_OPTIONS], options).then(function(response) {
                  return response[DATASTORE_INCREASE_OPTIONS];
               });
            }

            function retrieveHostStorageAdapterPathsData (hostId, storageAdapterKey) {
               return getPaths(hostId, storageAdapterKey, "storageadapter:hostStorageAdapterPaths");
            }

            function retrieveHostStorageDevicePathsData(hostId, storageDeviceName) {
               return getPaths(hostId, storageDeviceName, "storagedevice:hostStorageDevicePaths");
            }

            function retrieveHostProtocolEndpointsPathsData (hostId, identifier) {
               return getPaths(hostId, identifier, "storagedevice:hostStoragePEPaths");
            }

            function getPaths (hostId, stringParam, property) {
               var params;
               if (stringParam) {
                  params = constructStringParamForProperty(property, stringParam);
               }

               return dataService.getProperties(hostId, [property], params).then(function(response) {
                  var paths = response[property] || [];

                  return paths;
               });
            }

            function retrieveVmfsDatastoreMultipathingData (hostId, datastoreId) {

               var options = constructMorParamForProperty(
                     hostStorageConstants.EXTENTS_MULTIPATHING_INFO_PROP, datastoreId);

               return dataService.getProperties(
                     hostId,
                     [hostStorageConstants.EXTENTS_MULTIPATHING_INFO_PROP,
                        hostStorageConstants.PATH_SELECTION_POLICY_OPTIONS_PROP,
                        hostStorageConstants.STORAGE_ARRAY_TYPE_POLICY_OPTIONS_PROP],
                        options);
            }

            function rescanStorageAdapters (moRefs, spec) {
               var result = { affectedHosts: [], targetName: null };

               if (!moRefs || !moRefs.length) {
                  return $q.when(result);
               }

               if (moRefs[0].type === 'HostSystem') {
                  applyMutationOperation(moRefs, spec);
                  result.affectedHosts = moRefs;
                  return $q.when(result);
               } else {
                  var applicableHostsProperty = 'storageadapter:getHostsApplicableForRescan';
                  var nameProperty = 'name';

                  // Get all child hosts of a host folder, datacenter or cluster
                  // which are connected and for which the appropriate privilege is granted.
                  var objId = defaultUriSchemeUtil.getVsphereObjectId(moRefs[0]);
                  return dataService.getProperties(objId, [applicableHostsProperty, nameProperty])
                        .then(function (resp) {
                           var childHosts = resp[applicableHostsProperty];
                           if (childHosts && childHosts.length) {
                              applyMutationOperation(childHosts, spec);
                           }
                           result.affectedHosts = childHosts;
                           result.targetName = resp[nameProperty];
                           return result;
                        });
               }
            }

            function constructStringParamForProperty (propertyName, paramValue) {
               return {
                  propertyParams: [{
                     propertyName: propertyName,
                     parameterType: 'java.lang.String',
                     parameter: paramValue
                  }]
               };
            }

            function constructMorParamForProperty (propertyName, objectId) {
               return {
                  propertyParams: [{
                     propertyName: propertyName,
                     parameterType: 'com.vmware.vim.binding.vmodl.ManagedObjectReference',
                     parameter: defaultUriSchemeUtil.getManagedObjectReference(objectId)
                  }]
               };
            }

            function applyMutationOperation (hostRefs, spec) {
               var specType = 'com.vmware.vsphere.client.storage.adapters.StorageAdapterRescanSpec';
               var objIds = hostRefs.map(defaultUriSchemeUtil.getVsphereObjectId.bind(defaultUriSchemeUtil));
               return mutationService.applyOnMultiEntity(
                     objIds,
                     specType,
                     spec)
                     .then(function () {
                        $rootScope.$broadcast('vsphere.core.host.actions.rescan.completed', {
                           affectedHosts: hostRefs,
                           rescanSpec: spec
                        });
                     });
            }

            function erasePartitions(hostDevicesInfos) {
               var specs = [];
               _.forEach(hostDevicesInfos, function(hostDevicesInfo) {
                  var formatHostDiskSpecs =
                        _.map(hostDevicesInfo.devices, function(device) {
                              return {
                                 entity: hostDevicesInfo.hostId,
                                 spec: {
                                    _type: FORMAT_DISK_SPEC_TYPE,
                                    devicePath: device.devicePath
                                 }
                              };
                  });
                  specs = specs.concat(formatHostDiskSpecs);
               });

               mutationService.applyMulti(FORMAT_DISK_SPEC_TYPE, specs);
            }

            function changeDiskLocalState(hostId, disks, tagAsLocal) {
               var diskUuids = _.pluck(disks, 'lunUuid');
               var spec = {
                  _type: MARK_AS_LOCAL_SPEC_TYPE,
                  isLocal: tagAsLocal,
                  diskUUID: diskUuids
               };

               mutationService.apply(hostId, MARK_AS_LOCAL_SPEC_TYPE, spec);
            }

         }]);
})();

var storage_ui;
(function (storage_ui) {
    var IscsiAuthenticationSettings = (function () {
        function IscsiAuthenticationSettings() {
        }
        return IscsiAuthenticationSettings;
    }());
    storage_ui.IscsiAuthenticationSettings = IscsiAuthenticationSettings;
    var IscsiAuthenticationSettingsService = (function () {
        function IscsiAuthenticationSettingsService(constants) {
            this.constants = constants;
        }
        IscsiAuthenticationSettingsService.prototype.buildIscsiAuthenticationSettings = function (authenticationProperties, iscsiHbaName) {
            var authentication = new IscsiAuthenticationSettings();
            authentication.authenticationMethod = this.getAuthenticationMethod(authenticationProperties);
            authentication.useInitiatorNameForOutgoing = iscsiHbaName === authenticationProperties.chapName;
            authentication.outgoingName = authenticationProperties.chapName;
            authentication.outgoingSecret =
                authenticationProperties.chapAuthenticationType !== this.constants.authentication.PROHIBITED
                    ? authenticationProperties.chapSecret
                    : null;
            authentication.useInitiatorNameForIncoming = iscsiHbaName === authenticationProperties.mutualChapName;
            authentication.incomingName = authenticationProperties.mutualChapName;
            authentication.incomingSecret =
                authenticationProperties.mutualChapAuthenticationType !== this.constants.authentication.PROHIBITED
                    ? authenticationProperties.mutualChapSecret
                    : null;
            authentication.inheritSettingsFromParent = authenticationProperties.chapInherited;
            return authentication;
        };
        IscsiAuthenticationSettingsService.prototype.getAuthenticationMethod = function (authenticationProperties) {
            if (!authenticationProperties.chapAuthEnabled) {
                return this.constants.authentication.PROHIBITED;
            }
            switch (authenticationProperties.chapAuthenticationType) {
                case this.constants.authentication.DISCOURAGED:
                case this.constants.authentication.PREFERRED:
                    return authenticationProperties.chapAuthenticationType;
                case this.constants.authentication.REQUIRED:
                    if (authenticationProperties.mutualChapAuthenticationType === this.constants.authentication.PROHIBITED) {
                        return this.constants.authentication.REQUIRED;
                    }
                    return this.constants.authentication.MUTUAL;
            }
            return this.constants.authentication.PROHIBITED;
        };
        IscsiAuthenticationSettingsService.$inject = ["storageAdapterConstants"];
        return IscsiAuthenticationSettingsService;
    }());
    storage_ui.IscsiAuthenticationSettingsService = IscsiAuthenticationSettingsService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("iscsiAuthenticationSettingsService", IscsiAuthenticationSettingsService);
})(storage_ui || (storage_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').service('moveDatastoreToService',
         MoveDatastoreToService);

   MoveDatastoreToService.$inject = ['i18nService', 'mutationService',
         'clarityModalService', 'dataService', '$q', 'defaultUriSchemeUtil',
         'authorizationService'];

   function MoveDatastoreToService(i18nService,
         mutationService,
         clarityModalService,
         dataService,
         $q,
         defaultUriSchemeUtil,
         authorizationService) {

      function displayMaintenanceModeErrorDialog(clusterName) {
         var modalOptions = {
            message: i18nService.getString('HostUi', 'hostNotInMaintenanceModeError',
                  clusterName),
            title: i18nService.getString('HostUi', 'common.util.error'),
            icon: "vx-icon-warning-32x32",
            hideCancelButton: true,
            preserveNewlines: true,
            submit: function() {
            }
         };

         clarityModalService.openConfirmationModal(modalOptions);
      }

      function showWarningDialog(clusterName, hostMor, entityToMoveHostTo) {
         var modalOptions = {
            message: i18nService.getString('HostUi', 'cluster.moveInto.noDRS.singleHost',
                  clusterName),
            title: i18nService.getString('HostUi', 'common.util.warning'),
            icon: "vx-icon-warning-32x32",
            preserveNewlines: true,
            submit: function() {
               var moveSpec = {
                  entities: [hostMor],
                  attributes: null,
                  allowLoosingNestedRps: true
               };
               mutationService.apply(
                     entityToMoveHostTo,
                     'com.vmware.vsphere.client.h5.host.moveHost.MoveHostSpec',
                     moveSpec);
            }
         };

         clarityModalService.openConfirmationModal(modalOptions);
      }

      function showMoveVmsAndRpsDialog(hostMor,
            hostId,
            hostName,
            entityToMoveHostTo,
            dpmTurnedOn) {
         var modalOptions = {
            title: i18nService.getString('HostUi',
                  'warning.hostNotConnectedToAllDsClusterDatastores.single.dialogTitle'),
            subTitle: {
               objectId: hostId
            },
            contentTemplate: 'host-ui/resources/host/views/settings/moveto/moveHostVmsAndRpsDialog.html',
            defaultButton: 'submit',
            dialogData: {
               hostMor: hostMor,
               hostId: hostId,
               hostName: hostName,
               dpmTurnedOn: dpmTurnedOn,
               entityToMoveHostTo: entityToMoveHostTo
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      }

      function getMoveRpSpec(hostMor, moveToRoot) {
         return {
            entities: [hostMor],
            attributes: null,
            allowLoosingNestedRps: true,
            moveVmsAndRpsConfigSpec: {
               moveEnabled: true,
               moveToRoot: moveToRoot,
               moveToCustomRp: !moveToRoot
            }
         };
      }

      function showRpmWarningCondition(hostId, dpmTurnedOn) {
         var deferred = $q.defer();
         if (dpmTurnedOn) {
            var showDpmWarning = false;
            dataService.getData(
                  hostId,
                  'com.vmware.vsphere.client.h5.host.moveHost.HostConfigInformation').then(function(data) {
               if (data && !data.lastExitSucceeded) {
                  showDpmWarning = true;
               }
               deferred.resolve(showDpmWarning);
            });
         }

         return deferred.promise;
      }

      function moveDatastoreTo(entityToMoveDatastoreTo, datastoreIds) {
         var datastoreMors = _.map(datastoreIds, function(datastoreId) {
            return defaultUriSchemeUtil.getManagedObjectReference(datastoreId);
         });
         var moveSpec = {
            entities: datastoreMors
         };

         mutationService.apply(
               entityToMoveDatastoreTo,
               'com.vmware.vsphere.client.h5.storage.spec.MoveDatastoreSpec',
               moveSpec);
      }

      function checkPrivileges(itemToCheckIds) {
         return authorizationService
               .checkPrivilegesForMultipleObjects(itemToCheckIds, ['Datastore.Move'])
               .then(function(result) {
                  var objectsWithNoPrivilegeIds = [];
                  _.each(result, function(privileges, id){
                           if (!privileges['Datastore.Move']) {
                              objectsWithNoPrivilegeIds.push(id);
                           }
                  });
                  return objectsWithNoPrivilegeIds;
               });
      }

      return {
         moveDatastoreTo: moveDatastoreTo,
         checkPrivileges: checkPrivileges
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * @ngdoc service
    * @name com.vmware.vsphere.client.storage:storageUtil
    * @module com.vmware.vsphere.client.storage
    *
    * @description
    *    The `storageUtil` service holds storage related utility functions.
    *
    */
   angular.module('com.vmware.vsphere.client.storage')
         .factory('storageUtil', [
            'i18nService',
            'managedEntityConstants',
            'hostStorageConstants',
            'datastoreConstants',
            'clarityModalService',
            '$sce',
            function (i18nService, managedEntityConstants, hostStorageConstants, datastoreConstants, clarityModalService, $sce) {

            var BLOCK_SIZE_DEFAULT = 512;
            var VSTORAGE_SUPPORTED = "vstoragesupported";
            var VSTORAGE_UNSUPPORTED = "vstorageunsupported";

            return {
               compareNumericValues: compareNumericValues,
               formatDeviceName: formatDeviceName,
               formatLunNumber: formatLunNumber,
               lbaToBytes: lbaToBytes,
               formatVStorageSupport: formatVStorageSupport,
               formatSSDValue: formatSSDValue,
               formatVmfsLabel: formatVmfsLabel,
               formatDiskPartitionType: formatDiskPartitionType,
               getMaxDatastoreSizeForVmfsOption: getMaxDatastoreSizeForVmfsOption,
               getRescanWarning: getRescanWarning,
               getStorageArrayTypePolicyName: getStorageArrayTypePolicyName,
               formatPathSelectionPolicyLabel: formatPathSelectionPolicyLabel,
               getPathSelectionPolicyNameByKey: getPathSelectionPolicyNameByKey,
               isFixedPolicy: isFixedPolicy,
               isFreePartition: isFreePartition,
               formatPathSelectionPolicyName: formatPathSelectionPolicyName,
               is4kDevice: is4kDevice,
               getScsiPeTransport: getScsiPeTransport,
               getPEOperationalStateString: getPEOperationalStateString,
               showErrorDialog: showErrorDialog,
               getSectorFormatByScsiDiskType: getSectorFormatByScsiDiskType
            };

            function compareNumericValues (item1, item2, field) {
               var firstValue = Number(item1[field]);
               var secondValue = Number(item2[field]);

               if (isNaN(firstValue) && isNaN(secondValue)) {
                  return 0;
               }
               if (isNaN(firstValue)) {
                  return -1;
               }
               if (isNaN(secondValue)) {
                  return 1;
               }

               if (firstValue < secondValue) {
                  return -1;
               }
               if (firstValue > secondValue) {
                  return 1;
               }
               return 0;
            }

            /**
             * Given a ScsiDisk returns its display name if it's available, otherwise
             * returns it's canonical name.
             *
             * @param disk
             *       The ScsiDisk.
             *
             * @return
             *       The name of the device.
             */
            function formatDeviceName (disk) {
               if (disk.displayName) {
                  return disk.displayName;
               }

               return disk.canonicalName;
            }

            function formatLunNumber (lunNumber) {
               if (lunNumber === null || lunNumber === undefined || lunNumber === -1) {
                  return '';
               }
               return lunNumber;
            }

            function lbaToBytes (lba) {
               var blockSize = lba.blockSize || BLOCK_SIZE_DEFAULT;
               return lba.block * blockSize;
            }

            function formatVStorageSupport (vStorageSupport) {
               // The VStorageSupport is optional, so for legacy versions Not Supported
               // status is shown.
               if (!vStorageSupport || vStorageSupport.toLowerCase() === VSTORAGE_UNSUPPORTED) {
                  return i18nService.getString('StorageUi', 'datastore.vStorage.notSupported');
               }
               if (vStorageSupport.toLowerCase() === VSTORAGE_SUPPORTED) {
                  return i18nService.getString('StorageUi', 'datastore.vStorage.supported');
               }
               return i18nService.getString('StorageUi', 'datastore.vStorage.unknown');
            }

            function formatSSDValue (ssd) {
               if (ssd === true) {
                  return i18nService.getString('StorageUi', 'disk.ssd');
               }
               return i18nService.getString('StorageUi', 'disk.nonSSD');
            }

            /**
             * Extracts the VMFS label property of a given ScsiDiskInfo.
             *
             * @param scsiDiskInfo
             *       The ScsiDiskInfo which VMFS label will be extracted.
             *
             * @return
             *       The VMFS label property of the ScsiDiskInfo.
             */
            function formatVmfsLabel (scsiDiskInfo) {
               if (scsiDiskInfo.vmfsLabel && scsiDiskInfo.vmfsLabel !== '' &&
                     scsiDiskInfo.unresolvedExtent) {

                  if (scsiDiskInfo.unresolvedExtent.isHeadExtent === true) {
                     // If this is a head extent we should append '(head)' postfix
                     // to the VMFS label.
                     return i18nService.getString('StorageUi', 'headVmfsLabel.format', scsiDiskInfo.vmfsLabel);
                  } else {
                     return scsiDiskInfo.vmfsLabel;
                  }
               }
               return '';
            }

            /**
             * Given a disk partition type, returns
             * its corresponding localized string.
             *
             * @param type
             *          The disk partition type.
             *
             * @return
             *          Localized string representing the disk partition type.
             */
            function formatDiskPartitionType (partitionType) {
               var result = i18nService.getString('StorageUi', 'partitionFormat.unknown');
               if (partitionType === 'gpt') {
                  result = i18nService.getString('StorageUi', 'partitionFormat.gpt');
               } else if (partitionType === 'mbr') {
                  result = i18nService.getString('StorageUi', 'partitionFormat.mbr');
               }

               return result;
            }

            /**
             * Calculates number of disk blocks in a given block range.
             *
             * @param blockRange - The DiskPartitionInfo_BlockRange.
             * @return The number of blocks in the block range.
             */
            function getNumberOfBlocksForBlockRange (blockRange) {
               return blockRange.end.block - blockRange.start.block + 1;
            }

            /**
             * Calculates the size of a given block range.
             * @param range - The DiskPartitionInfo_BlockRange.
             * @return The size of the block range in bytes.
             */
            function getSizeOfBlockRange (range) {
               var blockSize = BLOCK_SIZE_DEFAULT;
               if (range.start.blockSize) {
                  blockSize = range.start.blockSize;
               }
               var numberOfBlocks = getNumberOfBlocksForBlockRange(range);
               return numberOfBlocks * blockSize;
            }

            /**
             * Computes the total capacity of all partitions in a given VmfsDatastoreOption.
             * This is the actual maximum size of the datastore.
             *
             * @param option
             *        The VmfsDatastoreOption.
             *
             * @return
             *        The sum of all partition sizes, or -1 if the option is invalid.
             */
            function getMaxDatastoreSizeForVmfsOption (option) {
               var result = 0;
               if (option && option.info) {
                  if (option.info._type === 'com.vmware.vim.binding.vim.host.VmfsDatastoreOption$SingleExtentInfo'
                        || option.info._type === 'com.vmware.vim.binding.vim.host.VmfsDatastoreOption$AllExtentInfo') {
                     // We have a single extent - compute its size.
                     result = getSizeOfBlockRange(option.info.vmfsExtent);
                  } else if (option.info._type === 'com.vmware.vim.binding.vim.host.VmfsDatastoreOption$MultipleExtentInfo') {
                     // We have multiple extents, so we need to compute their sum.
                     angular.forEach(option.info.vmfsExtent.length, function (value) {
                        result += getSizeOfBlockRange(value);
                     });
                  } else {
                     // Invalid vmfs option.
                     result = -1;
                  }
               }

               return result;
            }

            /**
             * Given array of storage array type policy descriptions and a policy key
             * extract the name of the policy.
             *
             * @param storageArrayTypePolicy
             *       LogicalUnitStorageArrayTypePolicy instance holding the storage array
             *       type policy key.
             *
             * @param storageArrayTypePolicies
             *       Array of StorageArrayTypePolicyOption.
             *
             * @return
             *       The localized policy name.
             */
            function getStorageArrayTypePolicyName(
                  storageArrayTypePolicy, storageArrayTypePolicies) {

               if (!storageArrayTypePolicy || !storageArrayTypePolicy.policy) {
                  return i18nService.getString('StorageUi', 'informationNotAccessible');
               }
               var policyKey = storageArrayTypePolicy.policy;

               var storageArrayTypePolicyOption = _.find(storageArrayTypePolicies,
                  function(policy) {
                     return policy.policy && policy.policy.key === policyKey;
                  });

               if (storageArrayTypePolicyOption) {
                  return storageArrayTypePolicyOption.policy.label || policyKey;
               }
               return policyKey;
            }

            /**
             * Given array of path selection policy descriptions and a LogicalUnitPolicy
             * instance returns the formatted name of the policy.
             *
             * If this is a fixed storage policy, the preferred path name will be included
             * in the policy name.
             *
             * @param logicalUnitPolicy
             *       LogicalUnitPolicy instance.
             * @param pathSelectionPoliciesOptions
             *       Array of PathSelectionPolicyOption.
             * @return
             *       The localized policy name.
             */
            function formatPathSelectionPolicyName(
                  logicalUnitPolicy, pathSelectionPoliciesOptions) {

               if (!logicalUnitPolicy || !logicalUnitPolicy.policy) {
                  return i18nService.getString('StorageUi', 'informationNotAccessible');
               }

               var policyName = getPathSelectionPolicyNameByKey(
                     logicalUnitPolicy.policy, pathSelectionPoliciesOptions);

               if (isFixedPolicy(logicalUnitPolicy.policy) && logicalUnitPolicy.prefer) {
                  return i18nService.getString(
                        'StorageUi', 'connectivity.policyWithpreferredPath',
                        policyName, logicalUnitPolicy.prefer);
               } else {
                  return policyName;
               }
            }

            /**
            * Checks if the givens ScsiDisk is of type SoftwareEmulated4k.
            *
            * @param scsiDisk
            *       ScsiDisk instance.
            * @return
            *       true if the given scsiDisk type is of
             *      type SoftwareEmulated4k and false otherwise.
            */
            function is4kDevice(scsiDisk) {
               return scsiDisk.scsiDiskType === datastoreConstants.scsiDiskType.SOFTWARE_EMULATED_4K;
            }

            /**
             * Given array of path selection policy descriptions and a policy key
             * extract the name of the policy.
             * @param policyKey
             *       Path selection policy key.
             * @param pathSelectionPOlicies
             *       Array of PathSelectionPolicyOption.
             * @return
             *       The localized policy name.
             */
            function getPathSelectionPolicyNameByKey(policyKey, pathSelectionPoliciesOptions) {

               if (!pathSelectionPoliciesOptions || !pathSelectionPoliciesOptions.length) {
                  return formatPathSelectionPolicyLabel(policyKey);
               }

               var policyOption = _.find(pathSelectionPoliciesOptions,
                  function(option) {
                     return option.policy.key === policyKey;
                  });

               if (policyOption) {
                  return policyOption.policy.label || formatPathSelectionPolicyLabel(policyKey);
               }

               return policyKey;
            }

            /**
             * Return the display name for a given path selection policy key.
             *
             * @param key
             *    The path selection policy key.
             *
             * @return
             *    Display name of the path selection policy.
             */
            function formatPathSelectionPolicyLabel(key) {
               switch (key) {
                  case hostStorageConstants.storagePolicies.FIXED_PATH:
                  case hostStorageConstants.storagePolicies.LEGACY_FIXED_PATH:
                     return i18nService.getString(
                           "StorageUi", "multipathing.policy.VMW_PSP_FIXED");
                  case hostStorageConstants.storagePolicies.ROUND_ROBIN:
                  case hostStorageConstants.storagePolicies.LEGACY_ROUND_ROBIN:
                     return i18nService.getString(
                           "StorageUi", "multipathing.policy.VMW_PSP_RR");
                  case hostStorageConstants.storagePolicies.MOST_RECENTLY_USED_PATH:
                  case hostStorageConstants.storagePolicies.LEGACY_MOST_RECENTLY_USED_PATH:
                     return i18nService.getString(
                           "StorageUi", "multipathing.policy.VMW_PSP_MRU");
                  case hostStorageConstants.storagePolicies.UNKNOWN:
                     return i18nService.getString(
                           "StorageUi", "multipathing.policy.VMW_PSP_UNKN");
               }
               return key;
            }

            /**
             * Checks if a given path selection policy is fixed.
             *
             * @param policyKey
             *    Then policy's key.
             * @return
             *    True if the path selection policy is fixed.
             *
             */
            function isFixedPolicy(policyKey) {
               return policyKey === hostStorageConstants.storagePolicies.FIXED_PATH ||
                  policyKey === hostStorageConstants.storagePolicies.LEGACY_FIXED_PATH;
            }


            /**
             * Checks is the partition.partitionType passed is a free partition that can be used
             * to create/increase vmfs datastore
             **/
            function isFreePartition (partitionType) {
               return partitionType === '0x00' || partitionType === 'none';
            }

            function getRescanWarning (entityType) {
               var rescanWarningsToEntityTypeMap = {};
               rescanWarningsToEntityTypeMap[managedEntityConstants.CLUSTER] = 'storage.adapters.rescanForm.warningCluster';
               rescanWarningsToEntityTypeMap[managedEntityConstants.FOLDER] = 'storage.adapters.rescanForm.warningFolder';
               rescanWarningsToEntityTypeMap[managedEntityConstants.DATACENTER] = 'storage.adapters.rescanForm.warningDatacenter';
               rescanWarningsToEntityTypeMap[managedEntityConstants.HOST] = 'storage.adapters.rescanForm.warningHosts';

               if (rescanWarningsToEntityTypeMap.hasOwnProperty(entityType)) {
                  return i18nService.getString('StorageUi', rescanWarningsToEntityTypeMap[entityType]);
               }
            }

            /**
             * Get the transport for a SCSI Protocol Endpoint
             */
            function getScsiPeTransport(protocolEndpoint){
                  var transportString = "";
                  if (protocolEndpoint && protocolEndpoint.transport) {
                     var transportArray = protocolEndpoint.transport;
                     _.forEach(transportArray, function(transport, transportIndex) {
                        var transportKey = "storage.adapters.devices.transport." + transport;
                        var transportValue = i18nService.getString("StorageUi", transportKey);
                        // Since the i18nService returns the key if no value is found
                        // this check is made in order not to add a transport value
                        // if such is not found
                        if (transportValue !== transportKey) {
                           if (transportString) {
                              transportString += ", ";
                           }
                           transportString += transportValue;
                        }
                     });
                  }
                  // Set default value if transport could not be determined.
                  if (!transportString) {
                     transportString = i18nService.getString("StorageUi",
                        "storage.adapters.devices.transport.UnknownTransport");
                  }
                  return transportString;
               }

               function getSectorFormatByScsiDiskType(scsiDiskType){
                  switch (scsiDiskType) {
                     case datastoreConstants.scsiDiskType.NATIVE_512:
                        return i18nService.getString(
                              "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.native512");
                     case datastoreConstants.scsiDiskType.EMULATED_512:
                        return i18nService.getString(
                              "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.emulated512");
                     case datastoreConstants.scsiDiskType.NATIVE_4K:
                        return i18nService.getString(
                              "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.native4k");
                     case datastoreConstants.scsiDiskType.SOFTWARE_EMULATED_4K:
                        return i18nService.getString(
                              "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.softwareEmulated4k");
                     case datastoreConstants.scsiDiskType.UNKNOWN:
                        return i18nService.getString(
                              "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.unknown");
                  }
                  return i18nService.getString(
                        "StorageUi", "vmfsProperties.scsiDisk.scsiDiskType.unknown");
               }

               function getPEOperationalStateString(data) {
                  if (deviceStateMatches(data, "OK")) {
                     return i18nService.getString("StorageUi", "storage.pe.opState.accessible");
                  }
                  return i18nService.getString("StorageUi", "storage.pe.opState.notAccessible");
               }


               function deviceStateMatches(data, state) {
                  if (!data || !data.underlyingLun || !data.underlyingLun.operationalState) {
                     return false;
                  }
                  if (data.underlyingLun.operationalState.indexOf(state) === -1) {
                     return false;
                  }
                  return true;
               }

               /**
                * Shows a clarity error confirmation dialog with the provided message as
                * content. The message could contain html elements. By default all html will be sanitized.
                * If you trust the html set the trustHtml function parameter to true.
                *
                * @param errorMessage
                * @param trustHtml
                */
               function showErrorDialog(errorMessage, trustHtml) {
                  var modalOptions = {
                     title: i18nService.getString("StorageUi", "fileOperation.error.title"),
                     hideCancelButton: true,
                     icon: "icon-warning-32",
                     submit: function() {
                        return true;
                     },
                     preserveNewlines: true
                  };

                  if (trustHtml) {
                     modalOptions.contentTemplate = "storage-ui/resources/storage/views/manage/files/FileUploadErrorView.html";
                     modalOptions.contentTemplateContext = {
                        errorMessage: $sce.trustAsHtml(errorMessage)
                     };
                  } else {
                     modalOptions.message = errorMessage;
                  }

                  clarityModalService.openConfirmationModal(modalOptions);
               }
            }]);
})();

var storage_ui;
(function (storage_ui) {
    var StorageValidationService = (function () {
        function StorageValidationService(i18nService) {
            this.i18nService = i18nService;
            /**
             * DNS-related: accepts only alphanumeric characters, -(dash), _(underscore) and . (dot)
             */
            this.VALID_DNS_NAME_REG_EX = new RegExp("^[\\w.-]+$");
            this.PORT_MAX_NUMBER = 65535;
            /**
             * File/Folder-related: invalid characters.
             */
            this.FORWARD_SLASH = '/';
            this.BACK_SLASH = '\\';
        }
        /**
         * Validates if the given name is a valid DNS name.
         * @param name
         * @returns {boolean}
         */
        StorageValidationService.prototype.isValidDnsName = function (name) {
            return this.VALID_DNS_NAME_REG_EX.test(name);
        };
        /**
         * Validates the given port
         * @param por
         * @returns {boolean}
         */
        StorageValidationService.prototype.isValidPort = function (port) {
            return port > 0 && port <= this.PORT_MAX_NUMBER;
        };
        /**
         * Validates a name of a file/folder.
         * @param value the file/folder name to validate
         * @returns string[]
         *    array of localized error messages
         *    or an empty array if there are none
         */
        StorageValidationService.prototype.validateDatastoreBrowserItemName = function (value) {
            if (value.indexOf(this.FORWARD_SLASH) !== -1) {
                return [this.i18nService.getString('StorageUi', 'renameFile.invalidCharsWarning', this.FORWARD_SLASH)];
            }
            if (value.indexOf(this.BACK_SLASH) !== -1) {
                return [this.i18nService.getString('StorageUi', 'renameFile.invalidCharsWarning', this.BACK_SLASH)];
            }
            return [];
        };
        StorageValidationService.$inject = ['i18nService'];
        return StorageValidationService;
    }());
    storage_ui.StorageValidationService = StorageValidationService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageValidationService", StorageValidationService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ClusterStorageAdaptersOverview = (function () {
        function ClusterStorageAdaptersOverview(i18nService, vuiConstants, dataService, columnRenderersRegistry, storageUtil, navigation, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.storageUtil = storageUtil;
            this.navigation = navigation;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18n = i18nService.getString;
            this.liveRefreshProperties = [
                'datastore',
                'summary',
                'host'
            ];
        }
        ClusterStorageAdaptersOverview.prototype.$onInit = function () {
            this.datagridOptions = {
                height: '100%',
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                data: [],
                resizable: true
            };
            this.refresh();
        };
        ClusterStorageAdaptersOverview.prototype.refresh = function () {
            var _this = this;
            this.deviceInfoLoading = true;
            this.loading = true;
            this.clusterId = this.navigation.getRoute().objectId;
            this.dataService
                .getProperties(this.clusterId, ['clusterStorageAdaptersOverview'])
                .then(function (response) {
                var hostData = response && response['clusterStorageAdaptersOverview'] &&
                    response['clusterStorageAdaptersOverview']['hostStorageAdaptersData'];
                if (_this.deviceInfoLoading) {
                    var dataItems_1 = [];
                    _.forEach(hostData, function (item) {
                        var dataItem = {};
                        _this.assignOverviewData(dataItem, item);
                        dataItems_1.push(dataItem);
                    });
                    _this.datagridOptions.data = dataItems_1;
                }
                else {
                    _this.overrideOverviewData(hostData);
                }
            }).finally(function () {
                _this.loading = false;
            });
            // Async-request details that are fetched slower.
            this.dataService
                .getProperties(this.clusterId, ['clusterStorageAdaptersDeviceInfo'])
                .then(function (response) {
                var hostData = response && response['clusterStorageAdaptersDeviceInfo'] &&
                    response['clusterStorageAdaptersDeviceInfo']['hostStorageAdaptersData'];
                if (!hostData) {
                    _this.handleMissingDeviceInfo();
                    return;
                }
                if (_this.loading) {
                    var dataItems_2 = [];
                    _.forEach(hostData, function (item) {
                        var dataItem = {};
                        _this.assignDeviceInfoData(dataItem, item);
                        dataItems_2.push(dataItem);
                    });
                    _this.datagridOptions.data = dataItems_2;
                }
                else {
                    _this.overrideDeviceInfoData(hostData);
                }
            }, function () {
                _this.handleMissingDeviceInfo();
            }).finally(function () {
                _this.deviceInfoLoading = false;
            });
        };
        ClusterStorageAdaptersOverview.prototype.getCountDetailsSignPostConfig = function (title, hostItem, countDataPropertyName) {
            var _this = this;
            if (!hostItem) {
                return;
            }
            var countDetails = '';
            if (hostItem[countDataPropertyName]) {
                _.forEach(hostItem[countDataPropertyName], function (item) {
                    if (countDetails) {
                        countDetails += '<br>';
                    }
                    countDetails += _this.i18n('StorageUi', 'cluster.adapters.list.countDetailsFormat', item.statusName, item.count);
                });
            }
            return {
                title: title,
                message: countDetails
            };
        };
        ClusterStorageAdaptersOverview.prototype.getColumnDefinitions = function () {
            var _this = this;
            var objectNameRenderer = this.columnRenderersRegistry.getColumnRenderer('object-name');
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer('text');
            var compareNumericValues = this.storageUtil.compareNumericValues;
            var renderAggregatedValue = function (count, totalCount, item, countDetailsProp) {
                if (_this.deviceInfoLoading) {
                    return '<span class="spinner spinner-sm"></span>';
                }
                if (count === undefined && totalCount === undefined) {
                    item[countDetailsProp] = _this.i18nService.getString('StorageUi', 'cluster.adapters.list.noValue');
                    return textRenderer([countDetailsProp], item);
                }
                var result = textRenderer(['countData'], {
                    countData: _this.i18n('StorageUi', 'cluster.adapters.list.aggregatedCountFormat', count, totalCount)
                });
                if (!item[countDetailsProp]) {
                    return result;
                }
                var infoIcon = '<span class="vx-icon-info_normal" ' +
                    'vui-sign-post="dataItem.' + countDetailsProp + '" ' +
                    '</span>';
                return result + infoIcon;
            };
            var renderDeviceInfo = function (item, field) {
                if (_this.deviceInfoLoading) {
                    return '<span class="spinner spinner-sm"></span>';
                }
                item[field] = item[field] !== undefined
                    ? item[field] : _this.i18nService.getString('StorageUi', 'cluster.adapters.list.noValue');
                return textRenderer([field], item);
            };
            return [
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.nameColumn'),
                    field: 'name',
                    width: "200px",
                    template: function (item) {
                        return objectNameRenderer(['hostId', 'iconId', 'name', 'labelIds'], {
                            hostId: _this.defaultUriSchemeUtil.getVsphereObjectId(item.hostRef),
                            iconId: item.iconId,
                            name: item.name,
                            labelIds: item.labelIds
                        }, {
                            navigatable: true
                        });
                    }
                },
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.adaptersColumn'),
                    field: 'numberOfStorageAdapters',
                    width: "100px",
                    template: function (item) {
                        return renderDeviceInfo(item, 'numberOfStorageAdapters');
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, 'numberOfStorageAdapters');
                    }
                },
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.targetsColumn'),
                    field: 'numberOfTargets',
                    width: "100px",
                    template: function (item) {
                        return renderDeviceInfo(item, 'numberOfTargets');
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, 'numberOfTargets');
                    }
                },
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.devicesColumn'),
                    field: 'numberOfAttachedDevices',
                    width: "150px",
                    template: function (item) {
                        return renderAggregatedValue(item.numberOfAttachedDevices, item.totalNumberOfDevices, item, 'devicesCountDetails');
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, 'numberOfAttachedDevices');
                    }
                },
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.pathsColumn'),
                    field: 'numberOfActivePaths',
                    width: "150px",
                    template: function (item) {
                        return renderAggregatedValue(item.numberOfActivePaths, item.totalNumberOfPaths, item, 'pathsCountDetails');
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, 'numberOfActivePaths');
                    }
                },
                {
                    displayName: this.i18nService.getString('StorageUi', 'cluster.adapters.list.datastoresColumn'),
                    field: 'numberOfDatastores',
                    width: "100px",
                    template: function (item) {
                        return textRenderer(['numberOfDatastores'], item);
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, 'numberOfDatastores');
                    }
                }
            ];
        };
        ClusterStorageAdaptersOverview.prototype.overrideDeviceInfoData = function (receivedHostDataItems) {
            var _this = this;
            var mergedHostItems = [];
            this.datagridOptions.data.forEach(function (hostDataItem) {
                var hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(hostDataItem.hostRef);
                var receivedHost = _.find(receivedHostDataItems, function (receivedHostDataItem) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(receivedHostDataItem.hostRef) === hostId;
                });
                if (receivedHost) {
                    _this.assignDeviceInfoData(hostDataItem, receivedHost);
                }
                mergedHostItems.push(Object.assign({}, hostDataItem));
            });
            this.datagridOptions.data = mergedHostItems;
        };
        ClusterStorageAdaptersOverview.prototype.overrideOverviewData = function (receivedHostDataItems) {
            var _this = this;
            var mergedHostItems = [];
            this.datagridOptions.data.forEach(function (hostDataItem) {
                var hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(hostDataItem.hostRef);
                var receivedHost = _.find(receivedHostDataItems, function (receivedHostDataItem) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(receivedHostDataItem.hostRef) === hostId;
                });
                if (receivedHost) {
                    _this.assignOverviewData(hostDataItem, receivedHost);
                }
                mergedHostItems.push(Object.assign({}, hostDataItem));
            });
            this.datagridOptions.data = mergedHostItems;
        };
        ClusterStorageAdaptersOverview.prototype.assignDeviceInfoData = function (target, source) {
            if (!source) {
                target.numberOfActivePaths = undefined;
                target.numberOfAttachedDevices = undefined;
                target.numberOfStorageAdapters = undefined;
                target.numberOfTargets = undefined;
                target.pathsCountByStatus = undefined;
                target.totalNumberOfDevices = undefined;
                target.totalNumberOfPaths = undefined;
                target.pathsCountDetails = undefined;
                target.devicesCountDetails = undefined;
                return;
            }
            target.hostRef = source.hostRef;
            target.numberOfActivePaths = source.numberOfActivePaths;
            target.numberOfAttachedDevices = source.numberOfAttachedDevices;
            target.numberOfStorageAdapters = source.numberOfStorageAdapters;
            target.numberOfTargets = source.numberOfTargets;
            target.pathsCountByStatus = source.pathsCountByStatus;
            target.totalNumberOfDevices = source.totalNumberOfDevices;
            target.totalNumberOfPaths = source.totalNumberOfPaths;
            target.pathsCountDetails = undefined;
            if (source.numberOfActivePaths !== source.totalNumberOfPaths) {
                target.pathsCountDetails = this.getCountDetailsSignPostConfig(this.i18n('StorageUi', 'cluster.adapters.list.pathDetails'), source, 'pathsCountByStatus');
            }
            target.devicesCountDetails = undefined;
            if (source.numberOfAttachedDevices !== source.totalNumberOfDevices) {
                target.devicesCountDetails = this.getCountDetailsSignPostConfig(this.i18n('StorageUi', 'cluster.adapters.list.deviceDetails'), source, 'devicesCountByStatus');
            }
        };
        ClusterStorageAdaptersOverview.prototype.assignOverviewData = function (target, source) {
            target.hostRef = source.hostRef;
            target.iconId = source.iconId;
            target.labelIds = source.labelIds;
            target.name = source.name;
            target.numberOfDatastores = source.numberOfDatastores;
        };
        ClusterStorageAdaptersOverview.prototype.getNoValueString = function () {
            return this.i18n("StorageUi", "cluster.adapters.list.noValue");
        };
        ClusterStorageAdaptersOverview.prototype.handleMissingDeviceInfo = function () {
            var _this = this;
            if (this.datagridOptions.data && this.datagridOptions.data.length) {
                _.forEach(this.datagridOptions.data, function (dataItem) {
                    _this.assignDeviceInfoData(dataItem);
                });
                this.datagridOptions.data = [].concat(this.datagridOptions.data);
            }
        };
        ClusterStorageAdaptersOverview.$inject = ['i18nService', 'vuiConstants', 'dataService',
            'columnRenderersRegistry', 'storageUtil', 'navigation', 'defaultUriSchemeUtil'];
        return ClusterStorageAdaptersOverview;
    }());
    storage_ui.ClusterStorageAdaptersOverview = ClusterStorageAdaptersOverview;
    angular.module('com.vmware.vsphere.client.storage')
        .component('clusterStorageAdaptersOverview', {
        templateUrl: 'storage-ui/resources/storage/views/cluster/adapters/ClusterStorageAdaptersOverview.html',
        controller: ClusterStorageAdaptersOverview
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AffectHeartbeatDatastoreService = (function () {
        function AffectHeartbeatDatastoreService(i18nService, clarityModalService, clarityConstants, dataService, $q, columnRenderersRegistry, vuiConstants) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.dataService = dataService;
            this.$q = $q;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.vuiConstants = vuiConstants;
            this.haAffectedClustersProperty = "datastore:haHeartbeatAffectedClusters";
        }
        // Initiates a dataservice call and shows a warning dialog if any clusters are affected.
        // A promise is returned to the client.
        // Upon acknowledging the warning the control flow is returned to the client by resolving the promise.
        AffectHeartbeatDatastoreService.prototype.checkForAffectedClusters = function (dsId, selectedHosts) {
            var _this = this;
            var deferred = this.$q.defer();
            return this.dataService.getProperties(dsId, [this.haAffectedClustersProperty], {
                propertyParams: [{
                        propertyName: this.haAffectedClustersProperty,
                        parameterType: "com.vmware.vsphere.client.h5.storage.spec.HeartbeatDatastoreSpec",
                        parameter: {
                            hostsToRemove: selectedHosts
                        }
                    }]
            }).then(function (result) {
                var affectedClusters = result && result[_this.haAffectedClustersProperty]
                    ? result[_this.haAffectedClustersProperty]
                    : [];
                if (affectedClusters.length) {
                    var iconRenderer_1 = _this.columnRenderersRegistry.getColumnRenderer('icon-text');
                    var modalOptions = {
                        title: _this.i18nService.getString("StorageUi", "unmountDatastoreHaWarning"),
                        contentTemplate: "storage-ui/resources/storage/views/datastore/affectedHeartbearClusterDialog.html",
                        dialogData: {
                            i18n: _this.i18nService.getString,
                            gridOptions: {
                                selectionMode: _this.vuiConstants.grid.selectionMode.SINGLE,
                                height: '100%',
                                resizable: true,
                                columnDefs: [{
                                        displayName: _this.i18nService.getString("StorageUi", "unmountDatastoreHaGridNameColumn"),
                                        field: "name",
                                        template: function (dataItem) {
                                            var rendererData = {
                                                icon: "vsphere-icon-cluster",
                                                text: dataItem.name
                                            };
                                            return iconRenderer_1(["icon", "text"], rendererData);
                                        }
                                    }],
                                data: affectedClusters
                            }
                        },
                        onSubmit: function () {
                            // Warning is acknowledged.
                            deferred.resolve(true);
                            // Close the warning dialog.
                            return true;
                        },
                        onCancel: function () {
                            // Warning is cancelled.
                            deferred.resolve(false);
                        }
                    };
                    _this.clarityModalService.openOkCancelModal(modalOptions);
                }
                else {
                    // If no clusters will be affected, do not show the dialog at all and
                    // return the execution to client.
                    deferred.resolve(true);
                }
                return deferred.promise;
            }, function () {
                // If an error occurred while fetching property, do not show the dialog
                // at all and return the execution to client.
                deferred.resolve(true);
                return deferred.promise;
            });
        };
        AffectHeartbeatDatastoreService.$inject = ["i18nService",
            "clarityModalService",
            "clarityConstants",
            "dataService",
            "$q",
            "columnRenderersRegistry",
            "vuiConstants"];
        return AffectHeartbeatDatastoreService;
    }());
    storage_ui.AffectHeartbeatDatastoreService = AffectHeartbeatDatastoreService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("affectHeartbeatDatastoreService", AffectHeartbeatDatastoreService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreConfigIoControl = (function () {
        function DatastoreConfigIoControl() {
            this.bindings = {
                modalOptions: "<"
            };
            this.controller = DatastoreConfigIoControlController;
            this.templateUrl = "storage-ui/resources/storage/views/datastore/DatastoreConfigIOControl.html";
        }
        return DatastoreConfigIoControl;
    }());
    storage_ui.DatastoreConfigIoControl = DatastoreConfigIoControl;
    var DatastoreConfigIoControlController = (function () {
        function DatastoreConfigIoControlController(i18nService, dialogService, clarityConstants) {
            this.i18nService = i18nService;
            this.dialogService = dialogService;
            this.clarityConstants = clarityConstants;
            this.loading = false;
            this.hasError = false;
            this.i18n = this.i18nService.getString.bind(null, "StorageUi");
            this.i18nCommon = this.i18nService.getString.bind(null, "Common");
        }
        DatastoreConfigIoControlController.prototype.$onInit = function () {
            var self = this;
            self.loading = true;
            self.percentageThresholdLabel = self.i18n('datastore.editCapabilitiesForm.percentPeakThroughputThreshold');
            self.manualThresholdLabel = self.i18n('datastore.editCapabilitiesForm.manualThreshold');
            self.modalOptions.dialogData.datastoreConfigIOControlDialogDataPromise.then(function (dialogData) {
                self.dialogData = dialogData;
                self.modalOptions.dialogData.datastoreConfigIOControlDialogData = dialogData;
                self.percentageThresholdRecommendedValues = [
                    self.nameValuePair("datastore.editCapabilitiesForm.percentPeakThroughput.values.minimum", self.dialogService.CONGESTION_THRESHOLD_PERCENT_MIN),
                    self.nameValuePair("datastore.editCapabilitiesForm.percentPeakThroughput.values.recommended", self.dialogService.CONGESTION_THRESHOLD_DEFAULT_PERCENT_PEAK_VALUE),
                    self.nameValuePair("datastore.editCapabilitiesForm.percentPeakThroughput.values.maximum", self.dialogService.CONGESTION_THRESHOLD_PERCENT_MAX),
                ];
                self.percentageThresholdErrorMessages = {
                    min: self.dialogService.percentThresholdValidationError(),
                    max: self.dialogService.percentThresholdValidationError()
                };
                self.manualThresholdErrorMessages = {
                    max: self.dialogService.manualThresholdValidationError(dialogData.minManualCongestionThreshold),
                    min: self.dialogService.manualThresholdValidationError(dialogData.minManualCongestionThreshold)
                };
                self.manualThresholdRecommendedValues = [
                    self.nameValuePair("datastore.editCapabilitiesForm.customThreshold.values.minimum", dialogData.minManualCongestionThreshold),
                    self.nameValuePair("datastore.editCapabilitiesForm.customThreshold.values.recommended", self.dialogService.CONGESTION_THRESHOLD_DEFAULT_MANUAL_VALUE),
                    self.nameValuePair("datastore.editCapabilitiesForm.customThreshold.values.maximum", self.dialogService.CONGESTION_THRESHOLD_MANUAL_MAX),
                ];
                self.showCongestionAlert();
            }, function (error) {
                var errorMsg = self.i18nService.getString("StorageUi", "storage.failedToRetrieveDataError");
                if (error && error.data && error.data.message) {
                    errorMsg += " " + error.data.message;
                }
                self.modalOptions.alerts = [{
                        text: errorMsg,
                        type: self.clarityConstants.notifications.type.ERROR
                    }];
                self.dialogData = self.dialogService.getDefaultDialogData();
                self.hasError = true;
            })
                .finally(function () {
                self.loading = false;
            });
        };
        DatastoreConfigIoControlController.prototype.showCongestionAlert = function () {
            if (this.dialogData.selectedCongestionThresholdOption === this.dialogService.congestionThresholdOptions.MANUAL &&
                this.dialogData.selectedSiocOption === this.dialogService.siocOptions.ENABLE_SOIC_ENABLED_STATISTIC) {
                this.modalOptions.alerts = [{
                        text: this.i18n("datastore.editCapabilitiesForm.warning"),
                        type: this.clarityConstants.notifications.type.WARNING
                    }];
            }
            else {
                this.modalOptions.alerts = [];
            }
        };
        ;
        DatastoreConfigIoControlController.prototype.resetDefaults = function () {
            this.dialogService.resetCongestionThresholdValues(this.dialogData);
            this.showCongestionAlert();
        };
        DatastoreConfigIoControlController.prototype.nameValuePair = function (labelKey, value) {
            return {
                name: this.i18n(labelKey),
                value: value
            };
        };
        DatastoreConfigIoControlController.$inject = ["i18nService", "datastoreConfigIOControlDialogService", "clarityConstants"];
        return DatastoreConfigIoControlController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastoreConfigIoControl", new DatastoreConfigIoControl());
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreConfigIOControlDialogData = (function () {
        function DatastoreConfigIOControlDialogData() {
        }
        return DatastoreConfigIOControlDialogData;
    }());
    storage_ui.DatastoreConfigIOControlDialogData = DatastoreConfigIOControlDialogData;
    var DatastoreConfigIOControlDialogService = (function () {
        function DatastoreConfigIOControlDialogService($q, dataService, clarityModalService, mutationService, i18nService, clarityConstants) {
            this.$q = $q;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.clarityConstants = clarityConstants;
            this.CONGESTION_THRESHOLD_DEFAULT_PERCENT_PEAK_VALUE = 90;
            this.CONGESTION_THRESHOLD_PERCENT_MIN = 50;
            this.CONGESTION_THRESHOLD_PERCENT_MAX = 100;
            this.CONGESTION_THRESHOLD_DEFAULT_MANUAL_VALUE = 30;
            this.CONGESTION_THRESHOLD_MANUAL_MIN = 5;
            this.CONGESTION_THRESHOLD_MANUAL_MAX = 100;
            this.siocOptions = {
                ENABLE_SOIC_ENABLED_STATISTIC: "ENABLE_SOIC_ENABLED_STATISTIC",
                DISABLE_SOIC_ENABLE_STATISTIC: "DISABLE_SOIC_ENABLE_STATISTIC",
                DISABLE_SOIC_DISABLE_STATISTICS: "DISABLE_SOIC_DISABLE_STATISTICS"
            };
            this.congestionThresholdOptions = {
                PERCENT: "CONGESTION_THRESHOLD_PERCENT",
                MANUAL: "CONGESTION_THRESHOLD_MANUAL"
            };
            this.PROP_MINIMUM_CONGESTION_THRESHOLD = "capability/minimumCongestionThresholdInMs";
        }
        DatastoreConfigIOControlDialogService.prototype.getDialogData = function (datastoreIds) {
            var _this = this;
            if (datastoreIds && datastoreIds.length) {
                var propertiesToRequest = [this.PROP_MINIMUM_CONGESTION_THRESHOLD];
                var multipleDatastores_1 = datastoreIds.length > 1;
                if (!multipleDatastores_1) {
                    propertiesToRequest.push("iormConfiguration");
                }
                return this.dataService.getPropertiesForObjects(datastoreIds, propertiesToRequest)
                    .then(function (response) {
                    var iormConfig = _this.getDefaultDialogData();
                    var thresholdManualMin = -1;
                    _.each(response, function (data) {
                        if (!multipleDatastores_1 && data.iormConfiguration) {
                            iormConfig = data.iormConfiguration;
                        }
                        if (data[_this.PROP_MINIMUM_CONGESTION_THRESHOLD]
                            && data[_this.PROP_MINIMUM_CONGESTION_THRESHOLD] > thresholdManualMin) {
                            thresholdManualMin = data[_this.PROP_MINIMUM_CONGESTION_THRESHOLD];
                        }
                    });
                    if (thresholdManualMin > -1) {
                        iormConfig.minManualCongestionThreshold = thresholdManualMin;
                    }
                    if (multipleDatastores_1) {
                        return iormConfig;
                    }
                    var dialogData = new DatastoreConfigIOControlDialogData();
                    if (iormConfig.enabled) {
                        dialogData.selectedSiocOption = _this.siocOptions.ENABLE_SOIC_ENABLED_STATISTIC;
                    }
                    else {
                        if (iormConfig.statsCollectionEnabled) {
                            dialogData.selectedSiocOption = _this.siocOptions.DISABLE_SOIC_ENABLE_STATISTIC;
                        }
                        else {
                            dialogData.selectedSiocOption = _this.siocOptions.DISABLE_SOIC_DISABLE_STATISTICS;
                        }
                    }
                    dialogData.enabledSdrsStatisticsForEnabledIoC = !iormConfig.statsAggregationDisabled;
                    dialogData.enabledSdrsStatisticsForDisabledIoC = !iormConfig.statsAggregationDisabled;
                    dialogData.manualCongestionThreshold = iormConfig.congestionThreshold;
                    dialogData.percentageCongestionThreshold = iormConfig.percentOfPeakThroughput;
                    if (thresholdManualMin > -1) {
                        dialogData.minManualCongestionThreshold = thresholdManualMin;
                    }
                    else {
                        dialogData.minManualCongestionThreshold = _this.CONGESTION_THRESHOLD_MANUAL_MIN;
                    }
                    if (iormConfig.congestionThresholdMode === "manual") {
                        dialogData.selectedCongestionThresholdOption = _this.congestionThresholdOptions.MANUAL;
                    }
                    else {
                        dialogData.selectedCongestionThresholdOption = _this.congestionThresholdOptions.PERCENT;
                    }
                    return dialogData;
                });
            }
            else {
                return this.$q.when(this.getDefaultDialogData());
            }
        };
        DatastoreConfigIOControlDialogService.prototype.resetCongestionThresholdValues = function (dialogData) {
            dialogData.selectedCongestionThresholdOption = this.congestionThresholdOptions.PERCENT;
            dialogData.manualCongestionThreshold = this.CONGESTION_THRESHOLD_DEFAULT_MANUAL_VALUE;
            dialogData.percentageCongestionThreshold = this.CONGESTION_THRESHOLD_DEFAULT_PERCENT_PEAK_VALUE;
        };
        DatastoreConfigIOControlDialogService.prototype.getDefaultDialogData = function () {
            var dialogData = new DatastoreConfigIOControlDialogData();
            dialogData.selectedSiocOption = this.siocOptions.DISABLE_SOIC_DISABLE_STATISTICS;
            dialogData.selectedCongestionThresholdOption = this.congestionThresholdOptions.PERCENT;
            dialogData.enabledSdrsStatisticsForEnabledIoC = true;
            dialogData.enabledSdrsStatisticsForDisabledIoC = true;
            dialogData.manualCongestionThreshold = this.CONGESTION_THRESHOLD_DEFAULT_MANUAL_VALUE;
            dialogData.percentageCongestionThreshold = this.CONGESTION_THRESHOLD_DEFAULT_PERCENT_PEAK_VALUE;
            dialogData.minManualCongestionThreshold = this.CONGESTION_THRESHOLD_MANUAL_MIN;
            return dialogData;
        };
        ;
        DatastoreConfigIOControlDialogService.prototype.buildIORMConfigSpec = function (dialogData) {
            var spec = {
                _type: "com.vmware.vim.binding.vim.StorageResourceManager$IORMConfigSpec"
            };
            switch (dialogData.selectedSiocOption) {
                case this.siocOptions.ENABLE_SOIC_ENABLED_STATISTIC:
                    spec.enabled = true;
                    spec.statsCollectionEnabled = true;
                    if (dialogData.selectedCongestionThresholdOption === this.congestionThresholdOptions.PERCENT) {
                        spec.percentOfPeakThroughput = dialogData.percentageCongestionThreshold;
                        spec.congestionThresholdMode = "automatic";
                        spec.congestionThreshold = this.CONGESTION_THRESHOLD_DEFAULT_MANUAL_VALUE;
                    }
                    else {
                        spec.congestionThresholdMode = "manual";
                        spec.congestionThreshold = dialogData.manualCongestionThreshold;
                    }
                    spec.statsAggregationDisabled = !dialogData.enabledSdrsStatisticsForEnabledIoC;
                    break;
                case this.siocOptions.DISABLE_SOIC_ENABLE_STATISTIC:
                    spec.enabled = false;
                    spec.statsCollectionEnabled = true;
                    spec.statsAggregationDisabled = !dialogData.enabledSdrsStatisticsForDisabledIoC;
                    break;
                case this.siocOptions.DISABLE_SOIC_DISABLE_STATISTICS:
                    spec.enabled = false;
                    spec.statsCollectionEnabled = false;
                    spec.statsAggregationDisabled = true;
                    break;
                default:
                    return null;
            }
            return spec;
        };
        DatastoreConfigIOControlDialogService.prototype.validateDatastoreConfigIOControlDialogData = function (dialogData, modalOptions) {
            var _this = this;
            var warnings = _.filter(modalOptions.alerts, function (item) {
                return item.type === _this.clarityConstants.notifications.type.WARNING;
            });
            if (dialogData.selectedSiocOption === this.siocOptions.ENABLE_SOIC_ENABLED_STATISTIC) {
                if (dialogData.selectedCongestionThresholdOption === this.congestionThresholdOptions.PERCENT) {
                    if (!this.numberInRange(dialogData.percentageCongestionThreshold, this.CONGESTION_THRESHOLD_PERCENT_MIN, this.CONGESTION_THRESHOLD_PERCENT_MAX)) {
                        modalOptions.alerts = [{
                                text: this.percentThresholdValidationError(),
                                type: this.clarityConstants.notifications.type.ERROR
                            }].concat(warnings);
                        return false;
                    }
                }
                else {
                    if (!this.numberInRange(dialogData.manualCongestionThreshold, dialogData.minManualCongestionThreshold, this.CONGESTION_THRESHOLD_MANUAL_MAX)) {
                        modalOptions.alerts = [{
                                text: this.manualThresholdValidationError(dialogData.minManualCongestionThreshold),
                                type: this.clarityConstants.notifications.type.ERROR
                            }].concat(warnings);
                        return false;
                    }
                }
            }
            modalOptions.alerts = warnings;
            return true;
        };
        DatastoreConfigIOControlDialogService.prototype.numberInRange = function (value, min, max) {
            return value >= min && value <= max;
        };
        DatastoreConfigIOControlDialogService.prototype.show = function (datastoreIds) {
            var self = this;
            var modalOptions = {
                contentTemplate: "storage-ui/resources/storage/views/datastore/DatastoreConfigIOControlDialog.html",
                title: this.i18nService.getString("StorageUi", "datastore.editCapabilitiesForm.title"),
                defaultButton: "submit",
                size: "lg",
                onSubmit: function () {
                    if (!modalOptions.dialogData.datastoreConfigIOControlDialogData) {
                        return false;
                    }
                    if (!self.validateDatastoreConfigIOControlDialogData(modalOptions.dialogData.datastoreConfigIOControlDialogData, modalOptions)) {
                        return false;
                    }
                    var spec = self.buildIORMConfigSpec(modalOptions.dialogData.datastoreConfigIOControlDialogData);
                    if (!spec) {
                        return false;
                    }
                    self.mutationService.applyOnMultiEntity(datastoreIds, spec._type, spec);
                    return true;
                },
                dialogData: {
                    datastoreConfigIOControlDialogDataPromise: this.getDialogData(datastoreIds)
                }
            };
            if (datastoreIds.length === 1) {
                modalOptions.subTitle = {
                    objectId: datastoreIds[0]
                };
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DatastoreConfigIOControlDialogService.prototype.manualThresholdValidationError = function (minThreshold) {
            return this.i18nService.getString("StorageUi", "datastore.editCapabilitiesForm.customThreshold.errorInvalidValue", minThreshold, this.CONGESTION_THRESHOLD_MANUAL_MAX);
        };
        DatastoreConfigIOControlDialogService.prototype.percentThresholdValidationError = function () {
            return this.i18nService.getString("StorageUi", "datastore.editCapabilitiesForm.percentPeakThroughput.errorInvalidValue", this.CONGESTION_THRESHOLD_PERCENT_MIN, this.CONGESTION_THRESHOLD_PERCENT_MAX);
        };
        DatastoreConfigIOControlDialogService.$inject = ["$q", "dataService", "clarityModalService",
            "mutationService", "i18nService", "clarityConstants"];
        return DatastoreConfigIOControlDialogService;
    }());
    storage_ui.DatastoreConfigIOControlDialogService = DatastoreConfigIOControlDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("datastoreConfigIOControlDialogService", DatastoreConfigIOControlDialogService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'ModifyDatastoreDialogController', ModifyDatastoreDialogController);

   ModifyDatastoreDialogController.$inject = [
      '$scope',
      'dataService',
      'vuiConstants',
      'i18nService',
      '$timeout',
      '$element'
   ];

   function ModifyDatastoreDialogController(
         $scope, dataService, vuiConstants, i18nService, $timeout, $element) {

      var self = this;

      self.datastoreId = $scope.modalOptions.dialogData.datastoreId;
      self.availableHostPropertyName = $scope.modalOptions.dialogData.availableHostPropertyName;
      self.headerHtmlUrl = $scope.modalOptions.dialogData.headerHtmlUrl;

      self.loading = true;

      self.datagridOptions = {
         resizable: true,
         height: '100%',
         selectionMode: vuiConstants.grid.selectionMode.MULTI,
         selectedItems: [],
         pageConfig: {
            displayMode: vuiConstants.grid.displayMode.VIRTUAL_SCROLLING
         },
         columnDefs: [
            {
               displayName: i18nService.getString('StorageUi', 'modifyDatastoreForm.hostColumnHeader'),
               field: 'formattedName',
               template: function (item) {
                  return '<div><span class="vsphere-icon-host"></span>' +
                     renderText(item.formattedName, item.isOperationAllowed) + '</div>';
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'modifyDatastoreForm.clusterColumnHeader'),
               field: 'clusterName',
               template: function (item) {
                  if (!item.clusterName) {
                     return '';
                  }

                  return '<div><span class="vsphere-icon-cluster"></span>' +
                     renderText(item.clusterName, item.isOperationAllowed) + '</div>';
               }
            }
         ],
         data: [],
         isItemDisabledCallback: function(item) {
            return !item.isOperationAllowed;
         }
      };

      // Detects selection changes in the host list.
      $scope.$watch(
         function() {
            return self.datagridOptions.selectedItems;
         },
         function(newSelection, oldSelection) {
            if (newSelection !== oldSelection) {
               $scope.modalOptions.dialogData.selectedHosts = newSelection;
            }
         });

      dataService.getProperties(self.datastoreId, [self.availableHostPropertyName]).then(
         function (result) {
            var dsOperationData = result ? result[self.availableHostPropertyName] || {} : {};
            var hostDataItems = dsOperationData.availableHosts || [];
            self.datagridOptions.data = hostDataItems;
            $scope.modalOptions.dialogData.allHosts = hostDataItems;
         },
         function (error) {
            $scope.modalOptions.dialogData.errorApi.showError(error);
         }
      ).finally(function() {
         self.loading = false;
         $timeout(function() {
            var inputElements = $element.find("input");
            if (inputElements && inputElements[0]) {
               inputElements[0].focus();
            }
         }, 1);
      });

      function renderText(text, enabled) {
         var span = $('<span/>')
            .addClass('vertical-align-cell')
            .text(text);

         if (!enabled) {
            span.addClass('disabled-text');
         }

         return span[0].outerHTML;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    *  Helper for opening the Modify Datastore dialog.
    */
   angular
      .module('com.vmware.vsphere.client.storage')
      .service('modifyDatastoreDialogService', modifyDatastoreDialogService);

   modifyDatastoreDialogService.$inject = [
      'clarityModalService',
      'dataService',
      'i18nService',
      'clarityConstants'];

   function modifyDatastoreDialogService(
         clarityModalService, dataService, i18nService, clarityConstants) {

      // ======================= Public API ==========================

      return {
         openModifyDatastoreDialog: openModifyDatastoreDialog,
         openRemoveDatastoreDialog: openRemoveDatastoreDialog
      };

      //======================= Public Functions ==========================

      /**
       * Opens an OK/Cancel modal dialog in the application.
       */
      function openModifyDatastoreDialog(
            datastoreId, dialogTitle, availableHostPropertyName, submitCallback, headerHtmlUrl) {

         dataService.getProperties(datastoreId, ['name']).then(
            function (result) {
               var dsName = result ? result.name : null;
               openDialog(dsName);
            },
            function () {
               openDialog(null);
            });

         function openDialog(dsName) {
            var modalOptions = {
               title: dialogTitle,
               subTitle: {
                  text: dsName
               },
               defaultButton: 'submit',
               size: 'lg',
               alerts: [],
               contentTemplate: 'storage-ui/resources/storage/views/datastore/ModifyDatastoreDialog.html',
               onSubmit: onSubmit
            };

            modalOptions.dialogData = {
               datastoreId: datastoreId,
               selectedHosts: [],
               availableHostPropertyName: availableHostPropertyName,
               headerHtmlUrl: headerHtmlUrl,
               errorApi: {
                  showError: showError,
                  clearErrors: clearErrors
               }
            };

            clarityModalService.openOkCancelModal(modalOptions);

            function onSubmit () {
               if (modalOptions.dialogData.selectedHosts && modalOptions.dialogData.selectedHosts.length) {
                  return submitCallback(modalOptions.dialogData.selectedHosts,
                     modalOptions.dialogData.allHosts.length ===
                     modalOptions.dialogData.selectedHosts.length);
               }

               showError(i18nService.getString('StorageUi', 'modifyDatastoreForm.noSelection'));
               return false;
            }

            function showError(errorMessage) {
               modalOptions.alerts = [{
                  text: errorMessage,
                  type: clarityConstants.notifications.type.ERROR
               }];
            }

            function clearErrors() {
               modalOptions.alerts = [];
            }
         }
      }

      function openRemoveDatastoreDialog (datastoreIds, dialogTitle, dialogMsg, submitCallback) {

         var modalOptions = {
            title: dialogTitle,
            message: dialogMsg,
            defaultButton: 'submit',
            alerts: [],
            preserveNewlines: true,
            submit: function (){
               return submitCallback();
            }
         };

         modalOptions.dialogData = {
            datastoreIds: datastoreIds
         };

         clarityModalService.openConfirmationModal(modalOptions);
      }
   }
})();

var storage_ui;
(function (storage_ui) {
    var MoveDatastoreToDialogController = (function () {
        function MoveDatastoreToDialogController($scope, moveDatastoreToService, defaultUriSchemeUtil, dataService, vuiConstants, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.moveDatastoreToService = moveDatastoreToService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.loading = true;
            this.datastoreIds = $scope.modalOptions.dialogData.objectIds;
            if (!_.isEmpty(this.datastoreIds)) {
                this.rootObjId = this.datastoreIds[0];
            }
            $scope.modalOptions.onSubmit = function () {
                $scope.modalOptions.alerts = [];
                $scope.modalOptions.isAlertClosed = true;
                _this.sourcesAndTargetIds.push(_this.entityToMoveDatastoreTo);
                _this.moveDatastoreToService.checkPrivileges(_this.sourcesAndTargetIds)
                    .then(function (noPrivilegesIds) {
                    if (!noPrivilegesIds || noPrivilegesIds.length === 0) {
                        moveDatastoreToService.moveDatastoreTo(_this.entityToMoveDatastoreTo, _this.datastoreIds);
                        $scope.closeModal();
                    }
                    else {
                        var message = void 0;
                        if (_.contains(noPrivilegesIds, _this.entityToMoveDatastoreTo)) {
                            if (noPrivilegesIds.length === 1) {
                                message = _this.i18nService
                                    .getString('StorageUi', 'moveTo.noPermissionsOnTarget');
                            }
                            else {
                                message = _this.i18nService
                                    .getString('StorageUi', 'moveTo.noPermissions');
                            }
                        }
                        else {
                            message = _this.i18nService
                                .getString('StorageUi', 'moveTo.noPermissionsOnSource');
                        }
                        _this.$scope.modalOptions.alerts = [{
                                type: _this.vuiConstants.validationBanner.type.ERROR,
                                text: message
                            }];
                        _this.$scope.modalOptions.isAlertClosed = false;
                    }
                });
            };
            this.onLocationSelected = function (objectReference) {
                _this.entityToMoveDatastoreTo = objectReference;
            };
            this.getData();
        }
        MoveDatastoreToDialogController.prototype.getData = function () {
            var _this = this;
            this.dataService.getPropertiesForObjects(this.datastoreIds, ['parent'])
                .then(function (data) {
                if (data) {
                    _this.sourcesAndTargetIds = _.map(_this.datastoreIds, function (datastoreId) {
                        return _this.defaultUriSchemeUtil.getVsphereObjectId(data[datastoreId].parent);
                    });
                    (_a = _this.sourcesAndTargetIds).push.apply(_a, _this.datastoreIds);
                }
                _this.loading = false;
                var _a;
            });
        };
        MoveDatastoreToDialogController.$inject = ["$scope",
            "moveDatastoreToService",
            "defaultUriSchemeUtil",
            "dataService",
            "vuiConstants",
            "i18nService"];
        return MoveDatastoreToDialogController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .controller("moveDatastoreToDialogController", MoveDatastoreToDialogController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreProtocolEndpointsMasterDetailsViewController = (function () {
        function DatastoreProtocolEndpointsMasterDetailsViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("StorageUi", "storage.pe.propertiesTab.header"),
                        templateUrl: "storage-ui/resources/storage/views/datastore/protocolEndpoints/properties/ProtocolEndpointsGeneral.html",
                        uid: "datastore.pe.generalTab"
                    },
                    {
                        name: this.i18nService.getString("StorageUi", "storage.pe.hostsTab.header"),
                        templateUrl: "storage-ui/resources/storage/views/datastore/protocolEndpoints/hostMountData/ProtocolEndpointsHostMountData.html",
                        uid: "datastore.pe.hostTab",
                        metadata: {
                            relevantFor: "isScsiPE"
                        }
                    }
                ])
            };
        }
        DatastoreProtocolEndpointsMasterDetailsViewController.$inject = ["i18nService", "$q"];
        return DatastoreProtocolEndpointsMasterDetailsViewController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .controller("DatastoreProtocolEndpointsMasterDetailsViewController", DatastoreProtocolEndpointsMasterDetailsViewController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreProtocolEndpointHostsListItem = (function () {
        function DatastoreProtocolEndpointHostsListItem(storageUtil, host, hostData) {
            this.hostUrl = host || "";
            if (hostData) {
                // Extract the SCSI LUN for this PE
                var scsiLUN = hostData.underlyingLun;
                // Get the identifier for the procol endpoint based on the LUN
                this.identifier = scsiLUN.canonicalName || "";
                // Get the location for the procol endpoint based on the LUN
                this.location = scsiLUN.deviceName || "";
                // Get the LUN for the SCSI protocol endpoint
                this.lun = String(hostData.lunNumber);
                // Get the operational state of the protocol endpoint
                this.operationalState = storageUtil.getPEOperationalStateString(hostData);
                // Get the transport for the protocol endpoint
                this.transport = storageUtil.getScsiPeTransport(hostData);
                // Get the owner plugin name for the protocol endpoint
                this.owner = hostData.ownerPlugin || "";
            }
        }
        return DatastoreProtocolEndpointHostsListItem;
    }());
    storage_ui.DatastoreProtocolEndpointHostsListItem = DatastoreProtocolEndpointHostsListItem;
    var ProtocolEndpointsHostMountComponentController = (function () {
        function ProtocolEndpointsHostMountComponentController(vuiConstants, i18nService, dataService, navigation, storageUtil) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.storageUtil = storageUtil;
            this.DATASTORE_ENDPOINTS_HOST_DATA = "datastoreProtocolEndpointHostData";
            this.initDatagrid();
        }
        ProtocolEndpointsHostMountComponentController.prototype.$onChanges = function () {
            var _this = this;
            if (this.selectedItems && this.selectedItems.length) {
                var params = [{
                        propertyName: this.DATASTORE_ENDPOINTS_HOST_DATA,
                        parameterType: "java.lang.String",
                        parameter: this.selectedItems[0].identifier
                    }];
                this.dataService.getProperties(this.navigation.getRoute().objectId, this.DATASTORE_ENDPOINTS_HOST_DATA, {
                    propertyParams: params
                }).then(function (response) {
                    _this.datagridOptions.data = _.map(response[_this.DATASTORE_ENDPOINTS_HOST_DATA], function (endpointData) {
                        return new DatastoreProtocolEndpointHostsListItem(_this.storageUtil, endpointData.hostURL, endpointData.peData);
                    });
                });
            }
        };
        ProtocolEndpointsHostMountComponentController.prototype.initDatagrid = function () {
            this.datagridOptions = {
                resizable: true,
                height: "100%",
                columnDefs: this.getColumnDefs(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: []
            };
        };
        ProtocolEndpointsHostMountComponentController.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.datastores.hostUrl"),
                    field: "name",
                    width: "120",
                    template: "#:hostUrl#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.identifier"),
                    field: "identifier",
                    width: "180px",
                    template: "#:identifier#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.location"),
                    field: "location",
                    width: "220px",
                    template: "#:location#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.lun"),
                    field: "lun",
                    width: "60px",
                    template: "#:lun#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.opState"),
                    field: "operationalState",
                    width: "120px",
                    template: "#:operationalState#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.transport"),
                    field: "transport",
                    width: "80px",
                    template: "#:transport#"
                }, {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.owner"),
                    field: "owner",
                    width: "80px",
                    template: "#:owner#"
                }
            ];
        };
        ProtocolEndpointsHostMountComponentController.$inject = ["vuiConstants", "i18nService", "dataService", "navigation", "storageUtil"];
        return ProtocolEndpointsHostMountComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("protocolEndpointsHostMountData", {
        controller: ProtocolEndpointsHostMountComponentController,
        templateUrl: "storage-ui/resources/storage/views/datastore/protocolEndpoints/hostMountData/ProtocolEndpointsHostMountComponent.html",
        bindings: {
            selectedItems: "<"
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointsGeneralComponent = (function () {
        function ProtocolEndpointsGeneralComponent(i18nService, dataService, vxPropertyViewService, vuiConstants, datastoreConstants) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.vuiConstants = vuiConstants;
            this.datastoreConstants = datastoreConstants;
            this.propertyViewData = {};
            this.buildPropertyView();
        }
        ProtocolEndpointsGeneralComponent.prototype.$onChanges = function () {
            this.updatePropertyView();
        };
        ProtocolEndpointsGeneralComponent.prototype.buildPropertyView = function () {
            if (!this.selectedItemData || !this.selectedItemData.length) {
                return;
            }
            var data = this.selectedItemData[0];
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var categoryBuilder = builder.category(this.i18nService.getString("StorageUi", "storage.pe.properties.generalHeader"));
            var generalSection = categoryBuilder.section('generalSection');
            generalSection
                .title(this.i18nService.getString("StorageUi", "storage.pe.properties.generalHeader"))
                .property(this.i18nService.getString("StorageUi", "storage.pe.runtimeName"), data.name)
                .property(this.i18nService.getString("StorageUi", "storage.pe.type"), data.type)
                .property(this.i18nService.getString("StorageUi", "storage.pe.identifier"), data.identifier);
            if (data.type === this.datastoreConstants.datastoreTypes.NFS) {
                generalSection
                    .property(this.i18nService.getString("StorageUi", "storage.pe.server"), data.server)
                    .property(this.i18nService.getString("StorageUi", "storage.pe.folder"), data.folder);
            }
            generalSection.property(this.i18nService.getString("StorageUi", "storage.pe.array"), data.storageArray);
            this.propertyViewData = builder.build();
        };
        ProtocolEndpointsGeneralComponent.prototype.updatePropertyView = function () {
            if (!this.selectedItemData || !this.selectedItemData.length) {
                this.propertyViewData = {};
            }
            else {
                this.buildPropertyView();
            }
        };
        ProtocolEndpointsGeneralComponent.$inject = ["i18nService", "dataService", "vxPropertyViewService", "vuiConstants", "datastoreConstants"];
        return ProtocolEndpointsGeneralComponent;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("protocolEndpointsGeneral", {
        controller: ProtocolEndpointsGeneralComponent,
        templateUrl: "storage-ui/resources/storage/views/datastore/protocolEndpoints/" +
            "properties/ProtocolEndpointsGeneralComponentView.html",
        bindings: {
            selectedItemData: "<"
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ProtocolEndpoints = (function () {
        function ProtocolEndpoints(i18nService, dataService, datastoreConstants, vuiConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.datastoreConstants = datastoreConstants;
            this.vuiConstants = vuiConstants;
            this.PROPERTY_NAME = "datastoreProtocolEndpointsData";
            this.formatRawData = function (rawData) {
                var result = {};
                result.storageArray = rawData.storageArray || "";
                result.identifier = rawData.uuid || "";
                result.isScsiPE = _this.datastoreConstants.protocolEndpoint.type.block === rawData.peType;
                switch (rawData.peType) {
                    case _this.datastoreConstants.protocolEndpoint.type.block:
                        result.name = rawData.deviceId || "";
                        result.type = _this.i18nService.getString("StorageUi", "storage.pe.type.block");
                        break;
                    case _this.datastoreConstants.protocolEndpoint.type.nas:
                        result.name = _this.i18nService.getString("StorageUi", "storage.pe.nas.format", rawData.nfsServer || "", rawData.nfsDir || "");
                        result.type = _this.i18nService.getString("StorageUi", "storage.pe.type.nas");
                        result.folder = rawData.nfsDir;
                        result.server = rawData.nfsServer;
                        break;
                    default:
                        break;
                }
                return result;
            };
            this.initDatagrid();
        }
        ProtocolEndpoints.prototype.$onInit = function () {
            var _this = this;
            this.dataService.getProperties(this.datastoreRef, this.PROPERTY_NAME).then(function (response) {
                _this.datagridOptions.data = _.map(response[_this.PROPERTY_NAME], _this.formatRawData);
            });
        };
        ProtocolEndpoints.prototype.initDatagrid = function () {
            var _this = this;
            this.datagridOptions = {
                resizable: true,
                height: "100%",
                columnDefs: this.getColumnDefs(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                onChange: function () {
                    var selection = _this.datagridOptions.selectedItems;
                    if (!selection || !selection.length) {
                        _this.selectedItem = [];
                    }
                    else {
                        _this.selectedItem = selection;
                    }
                },
                selectedItems: []
            };
        };
        ProtocolEndpoints.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.name"),
                    field: "name",
                    width: "300px",
                    template: "#:name#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.type"),
                    field: "type",
                    width: "80px",
                    template: "#:type#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.array"),
                    field: "array",
                    template: "#:storageArray#"
                }
            ];
        };
        ProtocolEndpoints.$inject = ["i18nService", "dataService", "datastoreConstants", "vuiConstants"];
        return ProtocolEndpoints;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("protocolEndpoints", {
        controller: ProtocolEndpoints,
        templateUrl: "storage-ui/resources/storage/views/datastore/protocolEndpoints/ProtocolEndpointsComponent.html",
        bindings: {
            datastoreRef: "<",
            selectedItem: '='
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointsController = (function () {
        function ProtocolEndpointsController(navigation) {
            this.navigation = navigation;
        }
        ProtocolEndpointsController.prototype.getContextObject = function () {
            return this.navigation.getRoute().objectId;
        };
        ProtocolEndpointsController.$inject = ["navigation"];
        return ProtocolEndpointsController;
    }());
    angular.module("com.vmware.vsphere.client.storage").controller("ProtocolEndpointsController", ProtocolEndpointsController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreSpaceReclamationBandwidthControl = (function () {
        function DatastoreSpaceReclamationBandwidthControl() {
            this.bindings = {
                showDynamicUnmapOption: "<",
                vmfsConfigOption: "<",
                unmapBandwidthSpec: "<"
            };
            this.controller = DatastoreSpaceReclamationBandwidthControlController;
            this.templateUrl =
                "storage-ui/resources/storage/views/datastore/spacereclamation/" +
                    "DatastoreSpaceReclamationBandwidthControl.html";
        }
        return DatastoreSpaceReclamationBandwidthControl;
    }());
    storage_ui.DatastoreSpaceReclamationBandwidthControl = DatastoreSpaceReclamationBandwidthControl;
    var DatastoreSpaceReclamationBandwidthControlController = (function () {
        function DatastoreSpaceReclamationBandwidthControlController(i18nService, reclamationBandwidthService) {
            this.i18nService = i18nService;
            this.reclamationBandwidthService = reclamationBandwidthService;
            this.selectedFixedUnmapRateItem = null;
            this.selectedDynamicMinRateItem = null;
            this.selectedDynamicMaxRateItem = null;
            this.FIXED_UNMAP_OPTION = "fixed";
            this.DYNAMIC_UNMAP_OPTION = "dynamic";
            this.DISABLED_UNMAP_OPTION = "disabled";
            this.i18n = this.i18nService.getString;
        }
        DatastoreSpaceReclamationBandwidthControlController.prototype.updateSpec = function () {
            this.unmapBandwidthSpec.policy = this.selectedUnmapOption;
            if (this.selectedFixedUnmapRateItem) {
                this.unmapBandwidthSpec.fixedValue = this.selectedFixedUnmapRateItem.rate;
            }
            if (this.showDynamicUnmapOption) {
                // don't update dynamic options if they
                // are not supported.
                if (this.selectedDynamicMinRateItem) {
                    this.unmapBandwidthSpec.dynamicMin = this.selectedDynamicMinRateItem.rate;
                }
                if (this.selectedDynamicMaxRateItem) {
                    this.unmapBandwidthSpec.dynamicMax = this.selectedDynamicMaxRateItem.rate;
                }
            }
        };
        DatastoreSpaceReclamationBandwidthControlController.prototype.$onChanges = function () {
            this.initData();
        };
        DatastoreSpaceReclamationBandwidthControlController.prototype.initData = function () {
            this.fixedRateItems = this.reclamationBandwidthService.generateRateItems(this.vmfsConfigOption.unmapBandwidthFixedValue, this.vmfsConfigOption.unmapBandwidthIncrement);
            this.selectedFixedUnmapRateItem = this.reclamationBandwidthService.findRateItem(this.fixedRateItems, this.unmapBandwidthSpec.fixedValue, true);
            if (this.showDynamicUnmapOption) {
                this.dynamicMinRateItems = this.reclamationBandwidthService.generateRateItems(this.vmfsConfigOption.unmapBandwidthDynamicMin, this.vmfsConfigOption.unmapBandwidthIncrement);
                this.selectedDynamicMinRateItem = this.reclamationBandwidthService.findRateItem(this.dynamicMinRateItems, this.unmapBandwidthSpec.dynamicMin, true);
                this.dynamicMaxRateItems = this.reclamationBandwidthService.generateRateItems(this.vmfsConfigOption.unmapBandwidthDynamicMax, this.vmfsConfigOption.unmapBandwidthIncrement);
                this.selectedDynamicMaxRateItem = this.reclamationBandwidthService.findRateItem(this.dynamicMaxRateItems, this.unmapBandwidthSpec.dynamicMax, true);
            }
            if (this.unmapBandwidthSpec.policy === this.FIXED_UNMAP_OPTION) {
                this.selectedUnmapOption = this.FIXED_UNMAP_OPTION;
            }
            else if (this.unmapBandwidthSpec.policy === this.DYNAMIC_UNMAP_OPTION &&
                this.showDynamicUnmapOption) {
                this.selectedUnmapOption = this.DYNAMIC_UNMAP_OPTION;
            }
            else {
                this.selectedUnmapOption = this.DISABLED_UNMAP_OPTION;
            }
        };
        DatastoreSpaceReclamationBandwidthControlController.$inject = ["i18nService", "datastoreSpaceReclamationBandwidthService"];
        return DatastoreSpaceReclamationBandwidthControlController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastoreSpaceReclamationBandwidthControl", new DatastoreSpaceReclamationBandwidthControl());
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreSpaceReclamationBandwidthService = (function () {
        function DatastoreSpaceReclamationBandwidthService(i18nService) {
            this.i18nService = i18nService;
        }
        DatastoreSpaceReclamationBandwidthService.prototype.validateUnmapBandwidthSpec = function (spec) {
            if (spec.policy === DatastoreSpaceReclamationBandwidthService.DYNAMIC_METHOD) {
                if (!_.isNumber(spec.dynamicMin)) {
                    return this.i18nService.getString("StorageUi", "datastore.manage.general.spaceReclamation.dynamic.invalidMinBandwidth");
                }
                if (!_.isNumber(spec.dynamicMax)) {
                    return this.i18nService.getString("StorageUi", "datastore.manage.general.spaceReclamation.dynamic.invalidMaxBandwidth");
                }
                if (spec.dynamicMin > spec.dynamicMax) {
                    return this.i18nService.getString("StorageUi", "datastore.manage.general.spaceReclamation.dynamic.minBandwidthBiggerThanMax");
                }
            }
            else if (spec.policy === DatastoreSpaceReclamationBandwidthService.FIXED_METHOD) {
                if (!_.isNumber(spec.fixedValue)) {
                    return this.i18nService.getString("StorageUi", "datastore.manage.general.spaceReclamation.fixed.invalidRate");
                }
            }
            // no error
            return null;
        };
        DatastoreSpaceReclamationBandwidthService.prototype.setDefaultRatesIfMissing = function (spec, vmfsConfigOption, dynamicReclamationSupported) {
            spec.fixedValue = this.getRateValue(spec.fixedValue, vmfsConfigOption.unmapBandwidthFixedValue);
            if (dynamicReclamationSupported) {
                spec.dynamicMin = this.getRateValue(spec.dynamicMin, vmfsConfigOption.unmapBandwidthDynamicMin);
                spec.dynamicMax = this.getRateValue(spec.dynamicMax, vmfsConfigOption.unmapBandwidthDynamicMax);
            }
        };
        DatastoreSpaceReclamationBandwidthService.prototype.generateRateItems = function (longOption, increment) {
            var result = [];
            // avoid infinite loops
            increment = increment || 1;
            for (var rate = longOption.min; rate <= longOption.max; rate += increment) {
                result.push({
                    label: this.i18nService.getString("StorageUi", "datastore.manage.general.spaceReclamation.rateItemFormat", rate),
                    rate: rate
                });
            }
            return result;
        };
        DatastoreSpaceReclamationBandwidthService.prototype.findRateItem = function (rateItems, rate, returnFirstAsDefault) {
            var result = _.find(rateItems, function (rateItem) { return rateItem.rate === rate; });
            if (!result && returnFirstAsDefault && rateItems && rateItems.length) {
                result = rateItems[0];
            }
            return result;
        };
        DatastoreSpaceReclamationBandwidthService.prototype.getRateValue = function (value, longOption) {
            if (value || value === 0) {
                return value;
            }
            return longOption && longOption.defaultValue;
        };
        DatastoreSpaceReclamationBandwidthService.$inject = ["i18nService"];
        DatastoreSpaceReclamationBandwidthService.FIXED_METHOD = "fixed";
        DatastoreSpaceReclamationBandwidthService.DYNAMIC_METHOD = "dynamic";
        return DatastoreSpaceReclamationBandwidthService;
    }());
    storage_ui.DatastoreSpaceReclamationBandwidthService = DatastoreSpaceReclamationBandwidthService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("datastoreSpaceReclamationBandwidthService", DatastoreSpaceReclamationBandwidthService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreSpaceReclamationControl = (function () {
        function DatastoreSpaceReclamationControl() {
            this.bindings = {
                spaceReclamationData: "<"
            };
            this.controller = DatastoreSpaceReclamationControlController;
            this.templateUrl = "storage-ui/resources/storage/views/datastore/spacereclamation/DatastoreSpaceReclamationControl.html";
        }
        return DatastoreSpaceReclamationControl;
    }());
    storage_ui.DatastoreSpaceReclamationControl = DatastoreSpaceReclamationControl;
    var DatastoreSpaceReclamationControlController = (function () {
        function DatastoreSpaceReclamationControlController(i18nService) {
            this.i18nService = i18nService;
            this.availableUnmapPriorities = [{
                    api: "none",
                    displayValue: this.i18nService.getString("StorageUi", "vmfs.unmapPriority.none"),
                    description: this.i18nService.getString("StorageUi", "datastore.configure.general.spaceReclamation.spaceReclamationPriorityNoneDescription")
                }, {
                    api: "low",
                    displayValue: this.i18nService.getString("StorageUi", "vmfs.unmapPriority.low"),
                    description: this.i18nService.getString("StorageUi", "datastore.configure.general.spaceReclamation.spaceReclamationPriorityDescription", this.i18nService.getString("StorageUi", "vmfs.unmapPriority.low"), this.i18nService.getString("StorageUi", "vmfs.unmapPriority.low"))
                }];
        }
        DatastoreSpaceReclamationControlController.prototype.onUnmapPriorityChanged = function (index) {
            this.spaceReclamationData.unmapPriority = this.availableUnmapPriorities[index].api;
        };
        DatastoreSpaceReclamationControlController.prototype.$onChanges = function (changes) {
            if (changes["spaceReclamationData"]
                && changes["spaceReclamationData"].currentValue) {
                this.findSelectedIndex(changes["spaceReclamationData"].currentValue.unmapPriority);
            }
        };
        DatastoreSpaceReclamationControlController.prototype.findSelectedIndex = function (newValue) {
            for (var i = 0; i < this.availableUnmapPriorities.length; i++) {
                if (this.availableUnmapPriorities[i].api === newValue) {
                    this.selectedIndex = i;
                    return;
                }
            }
            // The unmap priority is not found - fallback to default
            this.findSelectedIndex(DatastoreSpaceReclamationControlController.DEFAULT_UNMAP_PRIORITY);
        };
        DatastoreSpaceReclamationControlController.$inject = ["i18nService"];
        DatastoreSpaceReclamationControlController.DEFAULT_UNMAP_PRIORITY = "low";
        return DatastoreSpaceReclamationControlController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastoreSpaceReclamationControl", new DatastoreSpaceReclamationControl());
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var QueryReclamationOptionsSpec = com.vmware.vsphere.client.h5.storage.spec.QueryReclamationOptionsSpec;
    var VmfsVolume$UnmapBandwidthSpec = com.vmware.vim.binding.vim.host.VmfsVolume$UnmapBandwidthSpec;
    var UpdateVmfsUnmapBandwidthSpec = com.vmware.vsphere.client.h5.storage.spec.UpdateVmfsUnmapBandwidthSpec;
    var DatastoreSpaceReclamationBandwidthService = storage_ui.DatastoreSpaceReclamationBandwidthService;
    var UnmapPriorityMutationSpec = (function () {
        function UnmapPriorityMutationSpec() {
            this._type = "com.vmware.vsphere.client.storage.VmfsDatastoreUnmapPrioritySpec";
        }
        return UnmapPriorityMutationSpec;
    }());
    storage_ui.UnmapPriorityMutationSpec = UnmapPriorityMutationSpec;
    var EntitySpecPair = (function () {
        function EntitySpecPair() {
        }
        return EntitySpecPair;
    }());
    storage_ui.EntitySpecPair = EntitySpecPair;
    var DatastoreSpaceReclamationPriorityDialogService = (function () {
        function DatastoreSpaceReclamationPriorityDialogService($q, dataService, clarityModalService, mutationService, i18nService, clarityConstants, defaultUriSchemeUtil, reclamationBandwidthService) {
            this.$q = $q;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.clarityConstants = clarityConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.reclamationBandwidthService = reclamationBandwidthService;
            this.DEFAULT_PRIORITY = "low";
            this.NONE_PRIORITY = "none";
        }
        DatastoreSpaceReclamationPriorityDialogService.prototype.show = function (datastoreIds) {
            var _this = this;
            var dialogData = {
                datastoreIds: datastoreIds,
                spaceReclamationData: null,
                spec: null,
                isLoading: true,
                i18n: this.i18nService.getString,
                entitySpecs: []
            };
            var modalOptions = {
                contentTemplate: "storage-ui/resources/storage/views/datastore/spacereclamation/DatastoreSpaceReclamationDialog.html",
                title: this.i18nService.getString("StorageUi", "datastore.editSpaceReclamationForm.title"),
                defaultButton: "submit",
                dialogData: dialogData
            };
            modalOptions.onSubmit = this.onSpaceReclamationSubmitted.bind(this, dialogData, modalOptions);
            dialogData.spaceReclamationData = { unmapPriority: this.DEFAULT_PRIORITY };
            if (datastoreIds.length === 1) {
                modalOptions.subTitle = {
                    objectId: datastoreIds[0]
                };
            }
            this.queryReclamationOptionsData(datastoreIds)
                .then(function (reclamationOptionsData) {
                _this.initializeDialogState(reclamationOptionsData, dialogData);
            }, function () {
                _this.setModalErrors(modalOptions, [_this.i18nService.getString("StorageUi", "datastore.configure.general.spaceReclamation.responseError")]);
            })
                .finally(function () {
                dialogData.isLoading = false;
            });
            modalOptions.signPostParams = {
                message: this.i18nService.getString("StorageUi", "datastore.editSpaceReclamationForm.title")
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.setModalErrors = function (modalOptions, errors, disableSubmit) {
            var _this = this;
            if (disableSubmit === void 0) { disableSubmit = true; }
            var errorObjects = _.map(errors, function (err) {
                return {
                    text: err,
                    type: _this.clarityConstants.notifications.type.ERROR
                };
            });
            modalOptions.alerts = errorObjects;
            if (disableSubmit) {
                modalOptions.submitDisabled = true;
            }
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.queryReclamationOptionsData = function (datastoreIds) {
            var _this = this;
            var querySpec = new QueryReclamationOptionsSpec();
            querySpec.datastores = this.defaultUriSchemeUtil.getManagedObjectReferences(datastoreIds);
            var params = [{
                    propertyName: DatastoreSpaceReclamationPriorityDialogService.RECLAMATION_OPTIONS_PROPERTY,
                    parameterType: querySpec._type,
                    parameter: querySpec
                }];
            return this.dataService.getProperties(datastoreIds[0], DatastoreSpaceReclamationPriorityDialogService.RECLAMATION_OPTIONS_PROPERTY, {
                propertyParams: params
            }).then(function (response) {
                var reclamationOptions = response && response[DatastoreSpaceReclamationPriorityDialogService.RECLAMATION_OPTIONS_PROPERTY];
                if (!reclamationOptions) {
                    return _this.$q.reject(null);
                }
                if (!reclamationOptions.datastoresData ||
                    _.some(reclamationOptions.datastoresData, function (datastoreData) {
                        return !datastoreData.connectedHost ||
                            !datastoreData.datastoreUuid;
                    })) {
                    // There is a datastore for which there is no connected host
                    // or the datastore uuid is missing.
                    return _this.$q.reject(null);
                }
                return reclamationOptions;
            });
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.initializeDialogState = function (reclamationOptions, dialogData) {
            dialogData.reclamationOptions = reclamationOptions;
            if (!reclamationOptions.fixedReclamationSupported) {
                // legacy datastore, show priority reclamation options
                dialogData.showBandwidthControls = false;
                dialogData.spaceReclamationData = {
                    unmapPriority: reclamationOptions.reclamationPriority
                };
            }
            else {
                // show bandwidth reclamation options
                dialogData.showBandwidthControls = true;
                dialogData.vmfsConfigOption = reclamationOptions.vmfsConfigOption;
                this.populateUnmapBandwidthSpec(reclamationOptions);
                dialogData.unmapBandwidthSpec = reclamationOptions.unmapBandwidthSpec;
                dialogData.showDynamicUnmapOption = reclamationOptions.dynamicReclamationSupported;
            }
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.populateUnmapBandwidthSpec = function (reclamationOptions) {
            if (!reclamationOptions.unmapBandwidthSpec) {
                var disabledSpec = new VmfsVolume$UnmapBandwidthSpec();
                disabledSpec.policy = "disabled";
                reclamationOptions.unmapBandwidthSpec = disabledSpec;
            }
            this.reclamationBandwidthService.setDefaultRatesIfMissing(reclamationOptions.unmapBandwidthSpec, reclamationOptions.vmfsConfigOption, reclamationOptions.dynamicReclamationSupported);
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.onSpaceReclamationSubmitted = function (dialogData, modalOptions) {
            if (!dialogData.showBandwidthControls) {
                this.setReclamationPriority(dialogData, dialogData.spaceReclamationData.unmapPriority);
            }
            else {
                var bandwidthSpec = dialogData.unmapBandwidthSpec;
                var validationError = this.reclamationBandwidthService.validateUnmapBandwidthSpec(bandwidthSpec);
                if (validationError) {
                    this.setModalErrors(modalOptions, [validationError], false);
                    return false;
                }
                if (bandwidthSpec.policy === DatastoreSpaceReclamationBandwidthService.FIXED_METHOD ||
                    bandwidthSpec.policy === DatastoreSpaceReclamationBandwidthService.DYNAMIC_METHOD) {
                    this.updateReclamationBandwidth(dialogData, bandwidthSpec);
                }
                else {
                    // disable automatic unmap
                    this.setReclamationPriority(dialogData, this.NONE_PRIORITY);
                }
            }
            // Close the modal
            return true;
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.setReclamationPriority = function (dialogData, priority) {
            var _this = this;
            var entitySpecs = _.map(dialogData.reclamationOptions.datastoresData, function (datastoreData) {
                var spec = new UnmapPriorityMutationSpec();
                spec.unmapPriority = priority;
                spec.hostRef = datastoreData.connectedHost;
                spec.vmfsUuid = datastoreData.datastoreUuid;
                var entitySpec = new EntitySpecPair();
                entitySpec.spec = spec;
                entitySpec.entity = _this.defaultUriSchemeUtil.getVsphereObjectId(datastoreData.datastore);
                return entitySpec;
            });
            this.mutationService.applyMulti(entitySpecs[0].spec._type, entitySpecs);
        };
        DatastoreSpaceReclamationPriorityDialogService.prototype.updateReclamationBandwidth = function (dialogData, bandwidthSpec) {
            var _this = this;
            var entitySpecs = _.map(dialogData.reclamationOptions.datastoresData, function (datastoreData) {
                var spec = new UpdateVmfsUnmapBandwidthSpec();
                spec.datastore = datastoreData.datastore;
                spec.unmapBandwidthSpec = bandwidthSpec;
                spec.vmfsUuid = datastoreData.datastoreUuid;
                var entitySpec = new EntitySpecPair();
                entitySpec.spec = spec;
                entitySpec.entity = _this.defaultUriSchemeUtil.getVsphereObjectId(datastoreData.connectedHost);
                return entitySpec;
            });
            this.mutationService.applyMulti(entitySpecs[0].spec._type, entitySpecs);
        };
        DatastoreSpaceReclamationPriorityDialogService.$inject = ["$q", "dataService", "clarityModalService",
            "mutationService", "i18nService", "clarityConstants",
            "defaultUriSchemeUtil", "datastoreSpaceReclamationBandwidthService"];
        DatastoreSpaceReclamationPriorityDialogService.RECLAMATION_OPTIONS_PROPERTY = "datastore:reclamationOptionsData";
        return DatastoreSpaceReclamationPriorityDialogService;
    }());
    storage_ui.DatastoreSpaceReclamationPriorityDialogService = DatastoreSpaceReclamationPriorityDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("datastoreSpaceReclamationPriorityDialogService", DatastoreSpaceReclamationPriorityDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    /**
     * AngularJS service for upgrade VMFS datastore modal
     */
    var UpgradeVmfsDatastoreModalService = (function () {
        function UpgradeVmfsDatastoreModalService(i18nService, clarityModalService, mutationService, clarityConstants) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.clarityConstants = clarityConstants;
        }
        /**
         *  Open the upgrade VMFS datastore dialog
         **/
        UpgradeVmfsDatastoreModalService.prototype.openDialog = function (datastoreRefs) {
            var self = this;
            var dialogProperties = {
                title: this.i18nService.getString("StorageUi", "datastore.upgradeVmfsDatastoreForm.title"),
                contentTemplate: "storage-ui/resources/storage/views/datastore/upgradeVmfsDatastoreDialog.html",
                dialogData: {
                    i18n: this.i18nService.getString
                },
                onSubmit: function () {
                    var upgradeSpec = {
                        _type: "com.vmware.vsphere.client.h5.storage.spec.H5VmfsDatastoreUpgradeSpec"
                    };
                    return self.mutationService.validate(datastoreRefs, upgradeSpec._type, upgradeSpec).then(function (validationResult) {
                        if (validationResult.result) {
                            dialogProperties.alerts = [{
                                    text: validationResult.result,
                                    type: self.clarityConstants.notifications.type.ERROR
                                }];
                            return false;
                        }
                        self.mutationService.apply(datastoreRefs[0], upgradeSpec._type, upgradeSpec, self.i18nService.getString("StorageUi", "datastore.action.upgradeVmfsDatastore.taskName"));
                        return true;
                    });
                }
            };
            if (datastoreRefs.length === 1) {
                dialogProperties.subTitle = {
                    objectId: datastoreRefs[0]
                };
            }
            this.clarityModalService.openOkCancelModal(dialogProperties);
        };
        UpgradeVmfsDatastoreModalService.$inject = ["i18nService",
            "clarityModalService",
            "mutationService",
            "clarityConstants"];
        return UpgradeVmfsDatastoreModalService;
    }());
    storage_ui.UpgradeVmfsDatastoreModalService = UpgradeVmfsDatastoreModalService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("upgradeVmfsDatastoreModalService", UpgradeVmfsDatastoreModalService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var VvolDsStorageProvidersComponent = (function () {
        function VvolDsStorageProvidersComponent(vuiConstants, i18nService, dataService, navigation, storageUtil) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.storageUtil = storageUtil;
            this.VVOL_STORAGE_PROVIDERS_VIEW_DATA = "vvolStorageProvidersViewData";
        }
        VvolDsStorageProvidersComponent.prototype.$onInit = function () {
            this.initDatagrid();
            this.headerOptions = {
                title: this.i18nService.getString("StorageUi", "storage.storageProvidersView.title")
            };
            this.loadingTitle = this.i18nService.getString("Common", "loadingTitle");
        };
        VvolDsStorageProvidersComponent.prototype.$onChanges = function () {
            this.datastoreId = this.navigation.getRoute().objectId;
            this.refresh();
        };
        VvolDsStorageProvidersComponent.prototype.refresh = function () {
            var _this = this;
            this.isLoading = true;
            this.dataService.getProperties(this.datastoreId, this.VVOL_STORAGE_PROVIDERS_VIEW_DATA)
                .then(function (response) {
                var items = response && response[_this.VVOL_STORAGE_PROVIDERS_VIEW_DATA]
                    && response[_this.VVOL_STORAGE_PROVIDERS_VIEW_DATA].storageProviderItems;
                _this.datagridOptions.data = items || [];
            })
                .finally(function () {
                _this.isLoading = false;
            });
        };
        VvolDsStorageProvidersComponent.prototype.initDatagrid = function () {
            this.datagridOptions = {
                resizable: true,
                height: "100%",
                columnDefs: this.getColumnDefs(),
                selectionMode: this.vuiConstants.grid.selectionMode.NONE
            };
        };
        VvolDsStorageProvidersComponent.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "datastore.monitor.storageProvidersView.priority"),
                    field: "formattedPriority",
                    width: "60px",
                    template: "#:formattedPriority#",
                    sortable: function (item1, item2) {
                        return _this.storageUtil.compareNumericValues(item1, item2, "priority");
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "datastore.monitor.storageProvidersView.name"),
                    field: "formattedName",
                    width: "120px",
                    template: "#:formattedName#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "datastore.monitor.storageProvidersView.state"),
                    field: "state",
                    width: "60px",
                    template: "#:state#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "datastore.monitor.storageProvidersView.url"),
                    field: "url",
                    width: "220px",
                    template: "#:url#"
                }
            ];
        };
        VvolDsStorageProvidersComponent.$inject = ["vuiConstants", "i18nService", "dataService", "navigation", "storageUtil"];
        return VvolDsStorageProvidersComponent;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("vvolDsStorageProviders", {
        controller: VvolDsStorageProvidersComponent,
        template: "<div class=\"fill-parent flex-column\" vx-refreshable watch-objects=\"{{$ctrl.datastoreId}}\" refresh=\"$ctrl.refresh()\">\n                  <vx-activity-indicator is-visible=\"$ctrl.isLoading\" title=\"{{::$ctrl.loadingTitle}}\"></vx-activity-indicator>\n                  <div vx-settings-block-header=\"$ctrl.headerOptions\"></div>\n                  <div class=\"flex-grow-auto flex-grid\" vui-datagrid=\"$ctrl.datagridOptions\"></div>\n               </div>"
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AddSoftwareAdapterControl = (function () {
        function AddSoftwareAdapterControl() {
            this.bindings = {
                hostId: "<",
                apiObj: "="
            };
            this.controller = AddSoftwareAdapterControlController;
            this.templateUrl = "storage-ui/resources/storage/views/host/adapters/add/AddSoftwareAdapterControl.html";
        }
        return AddSoftwareAdapterControl;
    }());
    storage_ui.AddSoftwareAdapterControl = AddSoftwareAdapterControl;
    var MutationOperationSpec = (function () {
        function MutationOperationSpec() {
        }
        return MutationOperationSpec;
    }());
    storage_ui.MutationOperationSpec = MutationOperationSpec;
    var AddSoftwareAdapterControlApi = (function () {
        function AddSoftwareAdapterControlApi() {
        }
        return AddSoftwareAdapterControlApi;
    }());
    storage_ui.AddSoftwareAdapterControlApi = AddSoftwareAdapterControlApi;
    var AddSoftwareAdapterControlController = (function () {
        function AddSoftwareAdapterControlController(i18nService, clarityConstants, dataService, vxValidatorFactory, $timeout) {
            var _this = this;
            this.i18nService = i18nService;
            this.clarityConstants = clarityConstants;
            this.dataService = dataService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.$timeout = $timeout;
            // Const
            this.ISCSI_ADAPTER_TYPE = "ISCSI_ADAPTER_TYPE";
            this.FCOE_ADAPTER_TYPE = "FCOE_ADAPTER_TYPE";
            this.VLAN_ID_MIN = 0;
            this.VLAN_ID_MAX = 4094;
            this.PRIORITY_CLASS_MIN = 0;
            this.PRIORITY_CLASS_MAX = 7;
            this.SOFTWARE_INTERNET_SCSI_ENABLED = "config.storageDevice.softwareInternetScsiEnabled";
            this.FCOE_CAPABLE_PNICS_PROP = "fcoeCapablePnics";
            this.validateVlanId = function (value) {
                if (!_this.vlanIdEnabled) {
                    return [];
                }
                return _this.isValidValue(value, _this.VLAN_ID_MIN, _this.VLAN_ID_MAX);
            };
            this.validatePriorityClass = function (value) {
                if (!_this.priorityClassEnabled) {
                    return [];
                }
                return _this.isValidValue(value, _this.PRIORITY_CLASS_MIN, _this.PRIORITY_CLASS_MAX);
            };
            this.validateMacAddressText = function (value) {
                if (_this.macAddressTextEnabled && !value) {
                    return [_this.i18n("Common", "vxValidation.emptyFieldError")];
                }
                return [];
            };
            this.i18n = this.i18nService.getString;
            this.fcoeSettingsValidator = this.vxValidatorFactory.create();
        }
        AddSoftwareAdapterControlController.prototype.$onInit = function () {
            if (this.apiObj) {
                this.apiObj.validate = this.validate.bind(this);
                this.apiObj.createSpec = this.createSpec.bind(this);
                this.apiObj.isSwBasedIscsiAdapter = this.isSwBasedIscsiAdapter.bind(this);
            }
            this.requestPageData();
        };
        AddSoftwareAdapterControlController.prototype.onPnicDeviceChange = function () {
            if (!this.selectedPnic || !this.selectedPnic.fcoeConfiguration) {
                this.vlanIdEnabled = false;
                this.priorityClassEnabled = false;
                this.macAddressTextEnabled = false;
                this.vlanId = undefined;
                this.priorityClass = undefined;
                this.macAddressText = undefined;
                return;
            }
            var fcoeConf = this.selectedPnic.fcoeConfiguration;
            if (fcoeConf.vlanRange && fcoeConf.vlanRange.length) {
                this.vlanId = this.selectedPnic.fcoeConfiguration.vlanRange[0].vlanLow;
            }
            else {
                this.vlanId = undefined;
            }
            this.priorityClass = fcoeConf.priorityClass;
            this.macAddressText = fcoeConf.sourceMac;
            this.vlanIdEnabled = fcoeConf.capabilities && fcoeConf.capabilities.vlanRange;
            this.priorityClassEnabled = fcoeConf.capabilities && fcoeConf.capabilities.priorityClass;
            this.macAddressTextEnabled = fcoeConf.capabilities && fcoeConf.capabilities.sourceMacAddress;
        };
        AddSoftwareAdapterControlController.prototype.requestPageData = function () {
            var _this = this;
            this.loading = true;
            this.canAddFcoeAdapter = false;
            this.canAddIscsiAdapter = false;
            this.dataService.getProperties(this.hostId, [this.SOFTWARE_INTERNET_SCSI_ENABLED, this.FCOE_CAPABLE_PNICS_PROP]).then(function (response) {
                if (!response) {
                    return;
                }
                if (response[_this.SOFTWARE_INTERNET_SCSI_ENABLED] === false) {
                    _this.canAddIscsiAdapter = true;
                    _this.selectedAdapterType = _this.ISCSI_ADAPTER_TYPE;
                }
                _this.pnicDevices = response[_this.FCOE_CAPABLE_PNICS_PROP];
                if (_this.pnicDevices && _this.pnicDevices.length) {
                    _this.canAddFcoeAdapter = true;
                    _this.selectedAdapterType = _this.selectedAdapterType || _this.FCOE_ADAPTER_TYPE;
                    _this.selectedPnic = _this.pnicDevices[0];
                    _this.onPnicDeviceChange();
                }
                _this.focusRadio();
            }).finally(function () {
                _this.loading = false;
            });
        };
        AddSoftwareAdapterControlController.prototype.createSpec = function () {
            var operationSpec = new MutationOperationSpec();
            if (this.selectedAdapterType === this.ISCSI_ADAPTER_TYPE) {
                operationSpec.spec = {
                    _type: "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterActivationSpec",
                    activate: true
                };
            }
            else if (this.selectedAdapterType === this.FCOE_ADAPTER_TYPE) {
                operationSpec.spec = this.createFCoESpec();
                operationSpec.operationName = this.i18n("StorageUi", "storage.adapters.actions.addAdapter.fcoe.taskName");
            }
            return operationSpec;
        };
        AddSoftwareAdapterControlController.prototype.isSwBasedIscsiAdapter = function () {
            return this.selectedAdapterType === this.ISCSI_ADAPTER_TYPE;
        };
        AddSoftwareAdapterControlController.prototype.createFCoESpec = function () {
            var fcoeSpec = {
                _type: "com.vmware.vim.binding.vim.host.FcoeConfig$FcoeSpecification"
            };
            fcoeSpec.underlyingPnic = this.selectedPnic.device;
            if (this.vlanIdEnabled) {
                fcoeSpec.vlanRange = [{
                        _type: "com.vmware.vim.binding.vim.host.FcoeConfig$VlanRange",
                        vlanHigh: this.vlanId,
                        vlanLow: this.vlanId
                    }];
            }
            if (this.priorityClassEnabled) {
                fcoeSpec.priorityClass = this.priorityClass;
            }
            if (this.macAddressTextEnabled) {
                fcoeSpec.sourceMac = this.macAddressText;
            }
            return {
                _type: "com.vmware.vsphere.client.storage.adapters.FcoeStorageAdapterCreationSpec",
                fcoeSpec: fcoeSpec
            };
        };
        AddSoftwareAdapterControlController.prototype.isFloatValue = function (value) {
            return !!(value % 1);
        };
        AddSoftwareAdapterControlController.prototype.isValidValue = function (value, minValue, maxValue) {
            var numericValue = Number(value);
            if (!value || isNaN(numericValue)
                || numericValue < minValue || numericValue > maxValue
                || this.isFloatValue(numericValue)) {
                return [this.i18n("StorageUi", "invalidIntegerValue.outOfRange", minValue, maxValue)];
            }
            return [];
        };
        AddSoftwareAdapterControlController.prototype.focusRadio = function () {
            var adapterTypeRadios = angular.element("input[type='radio'][name='adapterType']");
            if (adapterTypeRadios && adapterTypeRadios[0]
                && this.selectedAdapterType === this.ISCSI_ADAPTER_TYPE) {
                // Resolve all bindings (enable radios first) and then focus.
                this.$timeout(function () {
                    adapterTypeRadios[0].focus();
                }, 0);
            }
            else if (adapterTypeRadios && adapterTypeRadios[1]
                && this.selectedAdapterType === this.ISCSI_ADAPTER_TYPE) {
                // Resolve all bindings (enable radios first) and then focus.
                this.$timeout(function () {
                    adapterTypeRadios[1].focus();
                }, 0);
            }
        };
        AddSoftwareAdapterControlController.prototype.validate = function () {
            if (!this.selectedAdapterType) {
                return false;
            }
            if (this.selectedAdapterType === this.ISCSI_ADAPTER_TYPE) {
                return true;
            }
            return !this.fcoeSettingsValidator.validate().length;
        };
        AddSoftwareAdapterControlController.$inject = ["i18nService", "clarityConstants", "dataService", "vxValidatorFactory", "$timeout"];
        return AddSoftwareAdapterControlController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("addSoftwareAdapterControl", new AddSoftwareAdapterControl());
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AddSoftwareAdapterControlApi = storage_ui.AddSoftwareAdapterControlApi;
    var AddSoftwareAdapterDialogService = (function () {
        function AddSoftwareAdapterDialogService(clarityModalService, mutationService, i18nService) {
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
        }
        AddSoftwareAdapterDialogService.prototype.show = function (hostId, context) {
            var adapterControlApi = new AddSoftwareAdapterControlApi();
            var dialogData = {
                hostId: hostId,
                apiObj: adapterControlApi
            };
            var modalOptions = {
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/add/AddSoftwareAdapterDialog.html",
                title: this.i18nService.getString("StorageUi", "storage.adapters.actions.addAdapter.addSoftwareAdapter"),
                subTitle: {
                    objectId: hostId
                },
                size: "lg",
                defaultButton: "submit",
                onSubmit: onSubmit.bind(this),
                dialogData: dialogData
            };
            function onSubmit() {
                if (!adapterControlApi.validate()) {
                    return false;
                }
                var mutationOperation = adapterControlApi.createSpec();
                if (mutationOperation && mutationOperation.spec) {
                    this.mutationService.apply(hostId, mutationOperation.spec._type, mutationOperation.spec, mutationOperation.operationName)
                        .then(function (result) {
                        if (result && !result.error && context.callback) {
                            context.callback(adapterControlApi.isSwBasedIscsiAdapter());
                        }
                    });
                }
                return true;
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        AddSoftwareAdapterDialogService.$inject = ["clarityModalService", "mutationService", "i18nService"];
        return AddSoftwareAdapterDialogService;
    }());
    storage_ui.AddSoftwareAdapterDialogService = AddSoftwareAdapterDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("addSoftwareAdapterDialogService", AddSoftwareAdapterDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    angular.module("com.vmware.vsphere.client.storage").constant("advancedOptionConstants", {
        optionProperties: {
            OPTION_PROPERTY_NAME: "option",
            DESCRIPTION_PROPERTY_NAME: "description",
            VALUE_PROPERTY_NAME: "value",
            INHERITED_PROPERTY_NAME: "inherited"
        },
        optionTypes: {
            STRING_OPTION_TYPE: "StringOption",
            BOOLEAN_OPTION_TYPE: "BoolOption",
            LONG_OPTION_TYPE: "LongOption",
            INT_OPTION_TYPE: "IntOption"
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AdvancedOptionsList = (function () {
        function AdvancedOptionsList(vuiConstants, i18nService, $scope, datagridActionBarService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.datagridActionBarService = datagridActionBarService;
            this.initializeDataGridOptions();
        }
        AdvancedOptionsList.prototype.initializeDataGridOptions = function () {
            var _this = this;
            this.datagridOptions = {
                columnDefs: this.getColumnDefs(),
                data: this.options,
                height: "100%",
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                searchable: false,
                resizable: true,
                selectedItems: [],
                pageConfig: {
                    hidePager: true
                },
                actionBarOptions: {
                    actions: []
                }
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                if (newSelection === oldSelection || _.isEqual(newSelection, oldSelection)) {
                    return;
                }
                _this.selectedOptions = newSelection;
            });
            this.$scope.comparator = function (value) {
                var itemToSelect = _.find(_this.selectedOptions, function (cachedItem) {
                    return cachedItem.option === value.option;
                });
                return itemToSelect !== undefined;
            };
        };
        AdvancedOptionsList.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.option"),
                    field: "option",
                    width: "300",
                    template: "#:option#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.description"),
                    field: "description",
                    width: "400",
                    template: "#:description#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.value"),
                    field: "value",
                    width: "300",
                    template: "#:value#"
                }
            ];
        };
        AdvancedOptionsList.prototype.$onChanges = function () {
            this.datagridOptions.data = this.options;
            var self = this;
            this.datagridActionBarService.updateActionBar(self.datagridOptions, [self.hostId], [
                {
                    actionId: 'vsphere.core.host.actions.adapters.editAdvancedOptionsForAdapter',
                    getActionInvocationContext: function () {
                        return {
                            hba: self.hba
                        };
                    }
                }
            ]);
        };
        AdvancedOptionsList.$inject = ["vuiConstants", "i18nService", "$scope", "datagridActionBarService"];
        return AdvancedOptionsList;
    }());
    storage_ui.AdvancedOptionsList = AdvancedOptionsList;
    angular.module("com.vmware.vsphere.client.storage")
        .component("advancedOptionsList", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/advanced/AdvancedOptionsList.html",
        bindings: {
            options: "<",
            selectedOptions: "<?",
            hostId: "<",
            hba: "<"
        },
        controller: AdvancedOptionsList
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var EditIscsiAdvancedOptionsControl = (function () {
        function EditIscsiAdvancedOptionsControl(dataService, navigation, i18nService, editIscsiAdvancedOptionsService, vuiConstants, advancedOptionConstants, columnRenderersRegistry, vxValidatorFactory, $timeout, $element) {
            this.dataService = dataService;
            this.navigation = navigation;
            this.i18nService = i18nService;
            this.editIscsiAdvancedOptionsService = editIscsiAdvancedOptionsService;
            this.vuiConstants = vuiConstants;
            this.advancedOptionConstants = advancedOptionConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.vxValidatorFactory = vxValidatorFactory;
            this.$timeout = $timeout;
            this.$element = $element;
            this.ADVANCED_SETTINGS_PROPERTY = ".internetScsiAdvancedSettings";
            this.ADVANCED_SETTINGS_INFO_PROPERTY = ".internetScsiAdvancedSettings.@info";
            this.ADVANCED_SETTINGS_TARGET_PROPERTY = "HostSystem/localizedInternetScsiTargetAdvancedSettings";
            this.ADVANCED_SETTINGS_TARGET_INFO_PROPERTY = "HostSystem/internetScsiTargetAdvancedSettings.@info";
            this.vxValidator = this.vxValidatorFactory.create();
            this.i18n = this.i18nService.getString;
        }
        EditIscsiAdvancedOptionsControl.prototype.$onInit = function () {
            var _this = this;
            if (this.apiObj) {
                this.apiObj.validate = function () {
                    var validationErrors = _this.vxValidator.validate();
                    _.forEach(_this.datagridOptions.data, function (dataItem) {
                        var validationErrors = dataItem._rawItem.validate();
                        var validationError = validationErrors && validationErrors.length && validationErrors[0];
                        dataItem.validationError.errorMessage = validationError;
                    });
                    return !validationErrors || !validationErrors.length;
                };
                this.apiObj.getModifiedOptions = function () {
                    var modifiedOptions = [];
                    _.forEach(_this.originalOptionValues, function (originalOptionItem) {
                        var optionItem = _this.getOptionItemByKey(originalOptionItem.optionKey);
                        if (optionItem && !_this.editIscsiAdvancedOptionsService.equalOptionItems(optionItem, originalOptionItem)) {
                            modifiedOptions.push(optionItem);
                        }
                    });
                    return modifiedOptions;
                };
            }
        };
        EditIscsiAdvancedOptionsControl.prototype.getOptionItemByKey = function (key) {
            var dataItem = _.find(this.datagridOptions.data, function (dataItem) {
                return dataItem._rawItem.optionKey === key;
            });
            return dataItem && dataItem._rawItem;
        };
        EditIscsiAdvancedOptionsControl.prototype.$onChanges = function () {
            this.requestData();
        };
        EditIscsiAdvancedOptionsControl.prototype.requestData = function () {
            var _this = this;
            if (!this.hostId || !this.hba) {
                return;
            }
            this.loading = true;
            var dataPromise;
            if (this.targetSet) {
                dataPromise = this.requestDataForTarget();
            }
            else {
                dataPromise = this.requestDataForAdapter();
            }
            dataPromise
                .then(function (optionItems) {
                _this.originalOptionValues = angular.copy(optionItems);
                var dataItems = _.map(optionItems, function (optionItem) {
                    return angular.merge({
                        _rawItem: optionItem
                    }, optionItem);
                });
                _.forEach(dataItems, function (dataItem) {
                    dataItem.validationError = {
                        errorMessage: "",
                        message: function () {
                            return dataItem.validationError.errorMessage;
                        },
                        isVisible: function () {
                            return !!dataItem.validationError.errorMessage;
                        }
                    };
                });
                _this.datagridOptions = {
                    columnDefs: _this.getColumnDefs(),
                    data: dataItems,
                    height: "100%",
                    selectionMode: _this.vuiConstants.grid.selectionMode.SINGLE,
                    searchable: false,
                    resizable: true
                };
                _this.focusGrid();
            })
                .finally(function () {
                _this.loading = false;
            });
        };
        EditIscsiAdvancedOptionsControl.prototype.requestDataForAdapter = function () {
            var _this = this;
            var advSettingsProp = this.hba.key + this.ADVANCED_SETTINGS_PROPERTY;
            var advSettingsInfoProp = this.hba.key + this.ADVANCED_SETTINGS_INFO_PROPERTY;
            return this.dataService.getProperties(this.hostId, [advSettingsProp, advSettingsInfoProp])
                .then(function (response) {
                return _this.editIscsiAdvancedOptionsService.parseOptionItems(response[advSettingsProp], response[advSettingsInfoProp]);
            });
        };
        EditIscsiAdvancedOptionsControl.prototype.requestDataForTarget = function () {
            var _this = this;
            var retrievalSpec = this.editIscsiAdvancedOptionsService.buildIscsiTargetsAdvancedSettingsRetrievalSpec(this.hba, this.targetSet);
            return this.dataService.getProperties(this.hostId, [this.ADVANCED_SETTINGS_TARGET_PROPERTY, this.ADVANCED_SETTINGS_TARGET_INFO_PROPERTY], {
                propertyParams: [
                    {
                        propertyName: this.ADVANCED_SETTINGS_TARGET_PROPERTY,
                        parameterType: retrievalSpec._type,
                        parameter: retrievalSpec
                    },
                    {
                        propertyName: this.ADVANCED_SETTINGS_TARGET_INFO_PROPERTY,
                        parameterType: retrievalSpec._type,
                        parameter: retrievalSpec
                    }
                ]
            })
                .then(function (response) {
                response = response || {};
                return _this.editIscsiAdvancedOptionsService.parseOptionItems(response[_this.ADVANCED_SETTINGS_TARGET_PROPERTY], response[_this.ADVANCED_SETTINGS_TARGET_INFO_PROPERTY]);
            });
        };
        EditIscsiAdvancedOptionsControl.prototype.getColumnDefs = function () {
            var _this = this;
            var textRender = this.columnRenderersRegistry.getColumnRenderer('text');
            var columns = [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.option"),
                    field: "name",
                    width: "300",
                    template: function (item) {
                        return textRender(["name"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.description"),
                    field: "description",
                    width: "400",
                    template: function (item) {
                        return textRender(["description"], item);
                    }
                }];
            if (this.targetSet) {
                columns.push({
                    displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.inherited"),
                    width: "300",
                    template: function (dataItem) {
                        return '' +
                            '<label>' +
                            '  <input type="checkbox" ' +
                            '     ng-model="dataItem.inherited" ' +
                            '     ng-change="dataItem._rawItem.inherited = dataItem.inherited" ' +
                            '     ng-disabled="dataItem.readOnly">' +
                            _this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.inheritedEnabled") +
                            '</label>';
                    }
                });
            }
            columns.push({
                displayName: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.column.value"),
                width: "300",
                template: function (dataItem) {
                    dataItem.validator = _this.vxValidator;
                    if (dataItem.valueType === _this.advancedOptionConstants.optionTypes.STRING_OPTION_TYPE &&
                        dataItem.allowedValues && dataItem.allowedValues.length) {
                        return "<div class=\"select value-cell\" >\n                             <select ng-model=\"dataItem.value\"\n                                     ng-options=\"option.value as option.name for option in dataItem.allowedValues\"\n                                     ng-change=\"dataItem._rawItem.value = dataItem.value\"\n                                     ng-disabled=\"dataItem.readOnly || dataItem.inherited\"\n                                     aria-label=\"{{dataItem.name}}\">\n                              </div>";
                    }
                    else if (dataItem.valueType === _this.advancedOptionConstants.optionTypes.BOOLEAN_OPTION_TYPE) {
                        return "<label>\n                             <input type=\"checkbox\"\n                                ng-model=\"dataItem.value\"\n                                ng-change=\"dataItem._rawItem.value = dataItem.value\"\n                                ng-disabled=\"dataItem.readOnly || dataItem.inherited\"\n                                aria-label=\"{{dataItem.name}}\">\n                           " + _this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.booleanValue") + "\n                           </label>";
                    }
                    var tooltips = [];
                    if (dataItem.minValue !== null && dataItem.minValue !== undefined) {
                        tooltips.push(_this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.minValue", dataItem.minValue));
                    }
                    if (dataItem.maxValue !== null && dataItem.maxValue !== undefined) {
                        tooltips.push(_this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.maxValue", dataItem.maxValue));
                    }
                    var title = tooltips.length ? 'title="' + tooltips.join(' ') + '"' : '';
                    var inputElement = "<input type=\"text\" ng-model=\"dataItem.value\"\n                        ng-disabled=\"dataItem.readOnly || dataItem.inherited\"\n                        ng-change=\"dataItem._rawItem.value = dataItem.value\"\n                        vx-error=\"dataItem.validationError\"\n                        class=\"iscsi-advanced-options-input\"\n                        aria-label=\"{{dataItem.name}}\"\n                        " + title + " >";
                    return "<div class=\"value-cell\"><vsc-validate [validator]=\"dataItem.validator\"\n                        [required]=\"false\"\n                        [custom-validation-function]=\"dataItem.validate\"> " + inputElement + " </vsc-validate></div>";
                }
            });
            return columns;
        };
        EditIscsiAdvancedOptionsControl.prototype.focusGrid = function () {
            var _this = this;
            this.$timeout(function () {
                var gridElement = _this.$element.find("div[vui-datagrid] div[kendo-grid]");
                if (gridElement && gridElement[0]) {
                    gridElement[0].setAttribute("tabindex", "-1");
                    gridElement[0].focus();
                }
            }, 0);
        };
        EditIscsiAdvancedOptionsControl.$inject = ["dataService", "navigation", "i18nService",
            "editIscsiAdvancedOptionsService", "vuiConstants", "advancedOptionConstants",
            "columnRenderersRegistry", "vxValidatorFactory", "$timeout", "$element"];
        return EditIscsiAdvancedOptionsControl;
    }());
    storage_ui.EditIscsiAdvancedOptionsControl = EditIscsiAdvancedOptionsControl;
    angular.module("com.vmware.vsphere.client.storage")
        .component("editIscsiAdvancedOptionsControl", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/advanced/edit/EditIscsiAdvancedOptionsControl.html",
        bindings: {
            hba: "<",
            hostId: "<",
            targetSet: "<",
            apiObj: '<'
        },
        controller: EditIscsiAdvancedOptionsControl
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var OptionItem = (function () {
        function OptionItem() {
        }
        return OptionItem;
    }());
    storage_ui.OptionItem = OptionItem;
    var EditIscsiAdvancedOptionsService = (function () {
        function EditIscsiAdvancedOptionsService(i18nService, clarityModalService, clarityConstants, mutationService, advancedOptionConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.mutationService = mutationService;
            this.advancedOptionConstants = advancedOptionConstants;
            this.validateOptionValue = function (optionItem) {
                if (!optionItem) {
                    return [];
                }
                if (optionItem.valueType === _this.advancedOptionConstants.optionTypes.LONG_OPTION_TYPE ||
                    optionItem.valueType === _this.advancedOptionConstants.optionTypes.INT_OPTION_TYPE) {
                    var numValue = parseInt(optionItem.value);
                    if (isNaN(numValue) || !_this.isSafeInteger(numValue) || (('' + numValue) !== ('' + optionItem.value))) {
                        return [_this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.invalidNumber")];
                    }
                    if (optionItem.minValue !== null && optionItem.minValue !== undefined &&
                        numValue < optionItem.minValue) {
                        return [_this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.lowerThenMinError", optionItem.minValue)];
                    }
                    if (optionItem.maxValue !== null && optionItem.maxValue !== undefined &&
                        numValue > optionItem.maxValue) {
                        return [_this.i18nService.getString("StorageUi", "storage.adapters.iscsi.advancedOptions.exceedsMaxError", optionItem.maxValue)];
                    }
                }
                return [];
            };
        }
        EditIscsiAdvancedOptionsService.prototype.showAdvancedOptionsDialogForAdapter = function (hostId, hba) {
            this.showAdvancedOptionsDialogForTarget(hostId, hba, null);
        };
        EditIscsiAdvancedOptionsService.prototype.showAdvancedOptionsDialogForTarget = function (hostId, hba, targetSet) {
            var _this = this;
            var dialogData = {
                hostId: hostId,
                hba: hba,
                targetSet: targetSet,
                apiObj: {}
            };
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.adapters.tabs.advancedOptions.header"),
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/advanced/edit/EditIscsiAdvancedOptionsDialog.html",
                defaultButton: "submit",
                dialogData: dialogData,
                size: "lg",
                alerts: [],
                onSubmit: function () {
                    if (!dialogData.apiObj.validate()) {
                        modalOptions.alerts = [{
                                text: _this.i18nService.getString("StorageUi", "form.validationError"),
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    var modifiedOptions = dialogData.apiObj.getModifiedOptions();
                    if (!modifiedOptions.length) {
                        return true;
                    }
                    var spec;
                    if (targetSet) {
                        spec = {
                            _type: "com.vmware.vsphere.client.storage.adapters.impl.ApplyTargetAdvancedSettingsSpec",
                            spec: _this.buildIscsiTargetsAdvancedSettingsRetrievalSpec(hba, targetSet),
                            changeSet: _this.buildChangeSet(modifiedOptions)
                        };
                    }
                    else {
                        spec = {
                            _type: "com.vmware.vsphere.client.storage.adapters.impl.ApplyInternetScsiAdvancedSettingsSpec",
                            adapterKey: hba.key,
                            changeSet: _this.buildChangeSet(modifiedOptions)
                        };
                    }
                    _this.mutationService.apply(hostId, spec._type, spec);
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        EditIscsiAdvancedOptionsService.prototype.buildChangeSet = function (modifiedOptions) {
            var _this = this;
            return _.map(modifiedOptions, function (option) {
                return {
                    _type: "com.vmware.vsphere.client.storage.adapters.impl.AdvancedOptionChangeSpec",
                    value: {
                        _type: "com.vmware.vim.binding.vim.option.OptionValue",
                        key: option.optionKey,
                        value: [_this.optionValueTypeToJavaType(option.valueType), option.value]
                    },
                    inherited: option.inherited
                };
            });
        };
        EditIscsiAdvancedOptionsService.prototype.optionValueTypeToJavaType = function (optionType) {
            if (optionType === this.advancedOptionConstants.optionTypes.INT_OPTION_TYPE) {
                return 'java.lang.Integer';
            }
            if (optionType === this.advancedOptionConstants.optionTypes.LONG_OPTION_TYPE) {
                return 'java.lang.Long';
            }
            if (optionType === this.advancedOptionConstants.optionTypes.BOOLEAN_OPTION_TYPE) {
                return 'java.lang.Boolean';
            }
            return 'java.lang.String';
        };
        EditIscsiAdvancedOptionsService.prototype.buildIscsiTargetsAdvancedSettingsRetrievalSpec = function (hba, targetSet) {
            return {
                _type: "com.vmware.vsphere.client.storage.adapters.LocalizedInternetScsiTargetsAdvancedSettingsRetrievalSpec",
                digestCapabilities: hba.digestCapabilities,
                targetSet: targetSet,
                device: hba.device,
                isSoftwareIScsi: hba.isSoftwareBased,
                addapterKey: hba.key
            };
        };
        EditIscsiAdvancedOptionsService.prototype.isSafeInteger = function (value) {
            return -(Math.pow(2, 53) - 1) < value && value < (Math.pow(2, 53) - 1);
        };
        EditIscsiAdvancedOptionsService.prototype.parseOptionItems = function (options, optionInfo) {
            var _this = this;
            if (!options || !optionInfo) {
                return [];
            }
            var result = [];
            var propertyInfos = optionInfo.properties;
            if (options.length !== propertyInfos.length) {
                return [];
            }
            var _loop_1 = function(i) {
                var optionItem = new OptionItem();
                result.push(optionItem);
                optionItem.readOnly = false;
                optionItem.validate = this_1.validateOptionValue.bind(this_1, optionItem);
                optionItem.name = this_1.fetchProperyValue(this_1.advancedOptionConstants.optionProperties.OPTION_PROPERTY_NAME, options[i].properties);
                optionItem.description = this_1.fetchProperyValue(this_1.advancedOptionConstants.optionProperties.DESCRIPTION_PROPERTY_NAME, options[i].properties);
                optionItem.optionKey = options[i].tag.optionKey;
                optionItem.valueType = options[i].tag.optionValueType;
                optionItem.inherited = this_1.fetchProperyValue(this_1.advancedOptionConstants.optionProperties.INHERITED_PROPERTY_NAME, options[i].properties);
                optionItem.value = this_1.fetchProperyValue(this_1.advancedOptionConstants.optionProperties.VALUE_PROPERTY_NAME, options[i].properties);
                if (optionItem.valueType === this_1.advancedOptionConstants.optionTypes.STRING_OPTION_TYPE) {
                    if (optionItem.value && optionItem.value.hasOwnProperty("value")) {
                        optionItem.value = optionItem.value.value;
                    }
                }
                if (!propertyInfos[i].valueType || !propertyInfos[i].valueType.properties) {
                    return "continue";
                }
                var valueTypeProps = propertyInfos[i].valueType.properties;
                var valueProp = _.find(valueTypeProps, function (prop) {
                    return prop.name === _this.advancedOptionConstants.optionProperties.VALUE_PROPERTY_NAME;
                });
                if (valueProp) {
                    optionItem.readOnly = valueProp.immutable;
                    _.each(valueProp.staticValueSpace, function (valueSpace) {
                        if (valueSpace.type === "MININCLUSIVE") {
                            optionItem.minValue = valueSpace.value;
                        }
                        if (valueSpace.type === "MAXINCLUSIVE") {
                            optionItem.maxValue = valueSpace.value;
                        }
                        if (valueSpace.type === "ENUMERATION") {
                            optionItem.allowedValues = optionItem.allowedValues || [];
                            optionItem.allowedValues.push(valueSpace.value);
                        }
                    });
                }
            };
            var this_1 = this;
            for (var i = 0; i < options.length; i++) {
                _loop_1(i);
            }
            return result;
        };
        EditIscsiAdvancedOptionsService.prototype.equalOptionItems = function (a, b) {
            if (a.inherited !== b.inherited) {
                return false;
            }
            return ('' + a.value) === ('' + b.value);
        };
        EditIscsiAdvancedOptionsService.prototype.fetchProperyValue = function (propertyName, properties) {
            var prop = _.find(properties, function (prop) {
                return prop.name === propertyName;
            });
            return prop && prop.value;
        };
        EditIscsiAdvancedOptionsService.$inject = ["i18nService", "clarityModalService", "clarityConstants",
            "mutationService", "advancedOptionConstants"];
        return EditIscsiAdvancedOptionsService;
    }());
    storage_ui.EditIscsiAdvancedOptionsService = EditIscsiAdvancedOptionsService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("editIscsiAdvancedOptionsService", EditIscsiAdvancedOptionsService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var IscsiAdvancedOptions = (function () {
        function IscsiAdvancedOptions(dataService, navigation, i18nService, advancedOptionConstants) {
            this.dataService = dataService;
            this.navigation = navigation;
            this.i18nService = i18nService;
            this.advancedOptionConstants = advancedOptionConstants;
            this.STORAGE_BUS_ADAPTER_PROPERTY = "hostBusAdapter";
            this.ADVANCED_SETTINGS_PROPERTY = ".internetScsiAdvancedSettings";
        }
        IscsiAdvancedOptions.prototype.$onChanges = function () {
            this.adapterKey = this.adapterItem.key;
            if (this.adapterKey) {
                this.requestData();
            }
        };
        IscsiAdvancedOptions.prototype.requestData = function () {
            var _this = this;
            this.loading = true;
            this.hostId = this.navigation.getRoute().objectId;
            var propertyName = this.adapterKey + this.ADVANCED_SETTINGS_PROPERTY;
            this.dataService.getProperties(this.hostId, [propertyName, this.STORAGE_BUS_ADAPTER_PROPERTY], {
                propertyParams: [
                    {
                        propertyName: this.STORAGE_BUS_ADAPTER_PROPERTY,
                        parameterType: "java.lang.String",
                        parameter: this.adapterKey
                    }
                ]
            })
                .then(function (response) {
                if (response) {
                    _this.data = response[propertyName] ? _this.parseResponse(response[propertyName]) : [];
                    _this.hba = response[_this.STORAGE_BUS_ADAPTER_PROPERTY];
                }
                else {
                    _this.data = [];
                }
            }).finally(function () {
                _this.loading = false;
            });
        };
        IscsiAdvancedOptions.prototype.parseResponse = function (responseData) {
            var _this = this;
            return _.map(responseData, function (item) {
                var optionProperty = _this.fetchPropery(_this.advancedOptionConstants.optionProperties.OPTION_PROPERTY_NAME, item.properties);
                var descriptionProperty = _this.fetchPropery(_this.advancedOptionConstants.optionProperties.DESCRIPTION_PROPERTY_NAME, item.properties);
                var valueProperty = _this.fetchPropery(_this.advancedOptionConstants.optionProperties.VALUE_PROPERTY_NAME, item.properties);
                var value = "";
                if (valueProperty && item.tag && item.tag.optionValueType) {
                    value = _this.getValueOfType(valueProperty.value, item.tag.optionValueType);
                }
                return {
                    option: (optionProperty && optionProperty.value) || "",
                    description: (descriptionProperty && descriptionProperty.value) || "",
                    value: value
                };
            });
        };
        IscsiAdvancedOptions.prototype.fetchPropery = function (propertyName, properties) {
            return _.select(properties, function (prop) {
                return prop.name === propertyName;
            })[0];
        };
        IscsiAdvancedOptions.prototype.getValueOfType = function (value, type) {
            if (type === this.advancedOptionConstants.optionTypes.STRING_OPTION_TYPE) {
                return value.name;
            }
            return value;
        };
        IscsiAdvancedOptions.$inject = ["dataService", "navigation", "i18nService", "advancedOptionConstants"];
        return IscsiAdvancedOptions;
    }());
    storage_ui.IscsiAdvancedOptions = IscsiAdvancedOptions;
    angular.module("com.vmware.vsphere.client.storage")
        .component("iscsiAdvancedOptions", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/advanced/IscsiAdvancedOptions.html",
        bindings: {
            adapterItem: "<"
        },
        controller: IscsiAdvancedOptions
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ValidationResult = (function () {
        function ValidationResult() {
        }
        return ValidationResult;
    }());
    storage_ui.ValidationResult = ValidationResult;
    var AuthenticationSettings = (function () {
        function AuthenticationSettings() {
        }
        return AuthenticationSettings;
    }());
    storage_ui.AuthenticationSettings = AuthenticationSettings;
    var StorageAdapterAuthenticationSettingsApi = (function () {
        function StorageAdapterAuthenticationSettingsApi() {
        }
        return StorageAdapterAuthenticationSettingsApi;
    }());
    storage_ui.StorageAdapterAuthenticationSettingsApi = StorageAdapterAuthenticationSettingsApi;
    var StorageAdapterAuthenticationSettings = (function () {
        function StorageAdapterAuthenticationSettings(i18nService, storageAdapterConstants, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.storageAdapterConstants = storageAdapterConstants;
            this.i18n = i18nService.getString;
            this.outgoingValidator = vxValidatorFactory.create();
            this.incomingValidator = vxValidatorFactory.create();
        }
        StorageAdapterAuthenticationSettings.prototype.replaceDummyPassword = function (password) {
            if (password) {
                return this.storageAdapterConstants.EXISTING_PASSWORD_PLACEHOLDER;
            }
            return password;
        };
        StorageAdapterAuthenticationSettings.prototype.$onInit = function () {
            if (this.componentApi) {
                this.componentApi.validate = this.validate.bind(this);
                this.componentApi.isDirty = this.isDirty.bind(this);
                this.componentApi.getSettings = this.getSettings.bind(this);
            }
        };
        StorageAdapterAuthenticationSettings.prototype.$onChanges = function () {
            this.buildAuthenticationMethodOptions();
            this.incoming = {
                name: this.authentication.incomingName,
                secret: this.authentication.authenticationMethod !== this.storageAdapterConstants.authentication.MUTUAL
                    ? ""
                    : this.replaceDummyPassword(this.authentication.incomingSecret),
                useInitiatorName: this.authentication.useInitiatorNameForIncoming
            };
            this.outgoing = {
                name: this.authentication.outgoingName,
                secret: this.authentication.authenticationMethod === this.storageAdapterConstants.authentication.PROHIBITED
                    ? ""
                    : this.replaceDummyPassword(this.authentication.outgoingSecret),
                useInitiatorName: this.authentication.useInitiatorNameForOutgoing
            };
            this.authMethodSelected = { id: this.authentication.authenticationMethod };
        };
        StorageAdapterAuthenticationSettings.prototype.getSettings = function () {
            var settings = new AuthenticationSettings();
            settings.authMethodSelected = this.authMethodSelected.id;
            settings.outgoing = this.outgoing;
            settings.incoming = this.incoming;
            return settings;
        };
        StorageAdapterAuthenticationSettings.prototype.buildAuthenticationMethodOptions = function () {
            if (!this.isSoftwareBased) {
                this.authenticationMethods = [{
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapProhibitedchapProhibited"),
                        id: this.storageAdapterConstants.authentication.PROHIBITED
                    }, {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapPreferredchapProhibited"),
                        id: this.storageAdapterConstants.authentication.PREFERRED
                    }];
            }
            else {
                this.authenticationMethods = [
                    {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapProhibitedchapProhibited"),
                        id: this.storageAdapterConstants.authentication.PROHIBITED
                    },
                    {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapDiscouragedchapProhibited"),
                        id: this.storageAdapterConstants.authentication.DISCOURAGED
                    },
                    {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapPreferredchapProhibited"),
                        id: this.storageAdapterConstants.authentication.PREFERRED
                    },
                    {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapRequiredchapProhibited"),
                        id: this.storageAdapterConstants.authentication.REQUIRED
                    },
                    {
                        name: this.i18n("StorageUi", "storage.adapters.iscsi.chapRequiredchapRequired"),
                        id: this.storageAdapterConstants.authentication.MUTUAL
                    }
                ];
            }
        };
        /**
         * Checks if user changed the values returned from server
         **/
        StorageAdapterAuthenticationSettings.prototype.isDirty = function () {
            return this.authentication.outgoingName !== this.outgoing.name
                || this.outgoing.secret && this.outgoing.secret !== this.storageAdapterConstants.EXISTING_PASSWORD_PLACEHOLDER
                || this.authentication.incomingName !== this.incoming.name
                || this.incoming.secret && this.incoming.secret !== this.storageAdapterConstants.EXISTING_PASSWORD_PLACEHOLDER
                || this.authentication.authenticationMethod !== this.authMethodSelected.id;
        };
        StorageAdapterAuthenticationSettings.prototype.validate = function () {
            var validationResult = new ValidationResult();
            var errors = [];
            var isOutgoingEnabled = this.authMethodSelected.id !== this.storageAdapterConstants.authentication.PROHIBITED;
            var isIncomingEnabled = this.authMethodSelected.id === this.storageAdapterConstants.authentication.MUTUAL;
            // outgoing
            if (isOutgoingEnabled) {
                errors = errors.concat(this.outgoingValidator.validate());
            }
            // incoming
            if (isIncomingEnabled) {
                errors = errors.concat(this.incomingValidator.validate());
            }
            if (isIncomingEnabled && errors.length === 0) {
                if (this.incoming.secret === this.outgoing.secret &&
                    this.incoming.secret !== this.storageAdapterConstants.EXISTING_PASSWORD_PLACEHOLDER) {
                    validationResult.errors = [
                        this.i18nService.getString("StorageUi", "storage.adapters.edit.authentication.form.secretsMatch")
                    ];
                    validationResult.isValid = false;
                    return validationResult;
                }
            }
            validationResult.isValid = !errors.length;
            return validationResult;
        };
        StorageAdapterAuthenticationSettings.$inject = ["i18nService", "storageAdapterConstants", "vxValidatorFactory"];
        return StorageAdapterAuthenticationSettings;
    }());
    storage_ui.StorageAdapterAuthenticationSettings = StorageAdapterAuthenticationSettings;
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageAdapterAuthenticationSettings", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/authentication/StorageAdapterAuthenticationSettings.html",
        bindings: {
            isSoftwareBased: "<",
            adapterName: "<",
            authentication: "<",
            isDisabled: "<",
            componentApi: "="
        },
        controller: StorageAdapterAuthenticationSettings
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterEditAuthenticationChapSection = (function () {
        function StorageAdapterEditAuthenticationChapSection(i18nService, constants, validatorService) {
            var _this = this;
            this.constants = constants;
            this.validatorService = validatorService;
            this.isValidSecret = function () {
                return _this.validatorService.isValidSecret(_this.secret, _this.isSoftwareBased);
            };
            this.isValidName = function () {
                return _this.validatorService.isValidName(_this.name, _this.isSoftwareBased);
            };
            this.i18n = i18nService.getString;
        }
        StorageAdapterEditAuthenticationChapSection.prototype.onCheckboxChange = function () {
            if (!this.useInitiatorName) {
                this.name = "";
            }
            else {
                this.name = this.iscsiName;
            }
        };
        StorageAdapterEditAuthenticationChapSection.prototype.getMaxSecretInputLength = function () {
            return this.isSoftwareBased
                ? this.constants.constraints.SW_CHAP_SECRET_MAX
                : this.constants.constraints.HW_CHAP_SECRET_MAX;
        };
        StorageAdapterEditAuthenticationChapSection.prototype.getMaxNameInputLength = function () {
            return this.isSoftwareBased
                ? this.constants.constraints.SW_CHAP_NAME_MAX
                : this.constants.constraints.HW_CHAP_NAME_MAX;
        };
        StorageAdapterEditAuthenticationChapSection.$inject = [
            "i18nService",
            "storageAdapterConstants",
            "storageAdapterEditAuthenticationValidationService"];
        return StorageAdapterEditAuthenticationChapSection;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageAdapterEditAuthenticationChapSection", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/authentication/StorageAdapterEditAuthenticationChapSection.html",
        bindings: {
            disabled: "=ngDisabled",
            header: "<",
            iscsiName: "<",
            name: "=",
            secret: "=",
            useInitiatorName: "=",
            isSoftwareBased: "<",
            validator: "<"
        },
        controller: StorageAdapterEditAuthenticationChapSection
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterAuthenticationSettingsApi = storage_ui.StorageAdapterAuthenticationSettingsApi;
    var StorageAdapterEditAuthenticationService = (function () {
        function StorageAdapterEditAuthenticationService(i18nService, clarityModalService, clarityConstants, mutationService, specBuilder, iscsiAuthenticationSettingsService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.mutationService = mutationService;
            this.specBuilder = specBuilder;
            this.iscsiAuthenticationSettingsService = iscsiAuthenticationSettingsService;
        }
        StorageAdapterEditAuthenticationService.prototype.editAuthSettingsIscsiTarget = function (hostId, adapter, target, parentDynamicTargetAuthProperties, callback) {
            var ctrl = this;
            var settingsComponentApi = new StorageAdapterAuthenticationSettingsApi();
            var targetAuthSettings = this.iscsiAuthenticationSettingsService.buildIscsiAuthenticationSettings(target.authenticationProperties, adapter.iScsiName);
            var parentAuthSettings;
            if (target.parent === adapter.iScsiName || !parentDynamicTargetAuthProperties) {
                parentAuthSettings = this.iscsiAuthenticationSettingsService.buildIscsiAuthenticationSettings(adapter.authenticationProperties, adapter.iScsiName);
            }
            else {
                parentAuthSettings = this.iscsiAuthenticationSettingsService.buildIscsiAuthenticationSettings(parentDynamicTargetAuthProperties, adapter.iScsiName);
            }
            var dialogData = {
                adapter: adapter,
                i18n: this.i18nService.getString,
                targetAuthSettings: targetAuthSettings,
                parentAuthSettings: parentAuthSettings,
                inheritAuthSettings: targetAuthSettings.inheritSettingsFromParent,
                inheritAuthSettingsLabel: target.parent
                    ? this.i18nService.getString("StorageUi", "storage.adapters.iscsiTargets.actions.authentication.form.parentInheritLabel", target.parent)
                    : this.i18nService.getString("StorageUi", "storage.adapters.iscsiTargets.actions.authentication.form.noParentInheritLabel"),
                settingsComponentApi: settingsComponentApi
            };
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.adapters.properties.authentication.edit.header", adapter.device),
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/authentication/StorageAdapterEditTargetAuthentication.html",
                defaultButton: "submit",
                onSubmit: onCommit,
                dialogData: dialogData,
                alerts: []
            };
            function isDirty() {
                return (dialogData.inheritAuthSettings !== targetAuthSettings.inheritSettingsFromParent) ||
                    (!dialogData.inheritAuthSettings && settingsComponentApi.isDirty());
            }
            function onCommit() {
                if (!isDirty()) {
                    return true; // if the user did not change anything - just close
                }
                var originalSecretValue = targetAuthSettings.outgoingSecret;
                if (!dialogData.inheritAuthSettings) {
                    var validationResult = settingsComponentApi.validate();
                    if (!validationResult.isValid) {
                        if (validationResult.errors && validationResult.errors.length) {
                            modalOptions.alerts = _.map(validationResult.errors, function (errorMsg) {
                                return {
                                    type: ctrl.clarityConstants.notifications.type.ERROR,
                                    text: errorMsg
                                };
                            });
                        }
                        return false;
                    }
                }
                var settings = settingsComponentApi.getSettings();
                var authenticationProperties = ctrl.specBuilder.buildAuthenticationPropertiesForTarget(dialogData.inheritAuthSettings, settings.authMethodSelected, settings.outgoing, settings.incoming, originalSecretValue);
                var targetSet = {
                    _type: "com.vmware.vim.binding.vim.host.InternetScsiHba$TargetSet"
                };
                if (target._type === "com.vmware.vim.binding.vim.host.InternetScsiHba$SendTarget") {
                    targetSet.sendTargets = [target];
                }
                else {
                    targetSet.staticTargets = [target];
                }
                var spec = {
                    _type: "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterAuthenticationUpdateSpec",
                    device: adapter.device,
                    properties: authenticationProperties,
                    targetSet: targetSet
                };
                ctrl.mutationService.apply(hostId, spec._type, spec, ctrl.i18nService.getString("StorageUi", "storage.adapters.properties.authentication.edit.taskName"))
                    .then(function (result) {
                    if (result && !result.error) {
                        // Notify that edit is performed
                        if (callback) {
                            callback(adapter);
                        }
                    }
                });
                return true;
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        StorageAdapterEditAuthenticationService.prototype.openModal = function (hostId, adapter) {
            var ctrl = this;
            var settingsComponentApi = new StorageAdapterAuthenticationSettingsApi();
            var dialogData = {
                adapter: adapter,
                authenticationProperties: this.iscsiAuthenticationSettingsService.buildIscsiAuthenticationSettings(adapter.authenticationProperties, adapter.iScsiName),
                i18n: this.i18nService.getString,
                settingsComponentApi: settingsComponentApi
            };
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.adapters.properties.authentication.edit.header", adapter.device),
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/authentication/StorageAdapterEditAuthentication.html",
                defaultButton: "submit",
                onSubmit: onCommit,
                dialogData: dialogData,
                alerts: []
            };
            function onCommit() {
                var originalSecretValue = adapter.authenticationProperties.chapSecret;
                if (!settingsComponentApi.isDirty()) {
                    return true; // if the user did not change anything - just close
                }
                var validationResult = settingsComponentApi.validate();
                if (!validationResult.isValid) {
                    if (validationResult.errors && validationResult.errors.length) {
                        modalOptions.alerts = _.map(validationResult.errors, function (errorMsg) {
                            return {
                                type: ctrl.clarityConstants.notifications.type.ERROR,
                                text: errorMsg
                            };
                        });
                    }
                    return false;
                }
                var settings = settingsComponentApi.getSettings();
                var spec = ctrl.specBuilder.buildSpecForAdapter(settings.authMethodSelected, settings.outgoing, settings.incoming, originalSecretValue, adapter.device);
                ctrl.mutationService.apply(hostId, spec._type, spec, ctrl.i18nService.getString("StorageUi", "storage.adapters.properties.authentication.edit.taskName"));
                return true;
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        StorageAdapterEditAuthenticationService.$inject = ["i18nService", "clarityModalService",
            "clarityConstants", "mutationService",
            "storageAdapterEditAuthenticationSpecBuilderService",
            "iscsiAuthenticationSettingsService"];
        return StorageAdapterEditAuthenticationService;
    }());
    storage_ui.StorageAdapterEditAuthenticationService = StorageAdapterEditAuthenticationService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageAdapterEditAuthenticationService", StorageAdapterEditAuthenticationService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var InternetScsiHba$AuthenticationProperties = com.vmware.vim.binding.vim.host.InternetScsiHba$AuthenticationProperties;
    var StorageAdapterEditAuthenticationSpecBuilderService = (function () {
        function StorageAdapterEditAuthenticationSpecBuilderService(constants) {
            this.constants = constants;
            this.AUTH_PROP_CLASS_TYPE = "com.vmware.vim.binding.vim.host.InternetScsiHba$AuthenticationProperties";
        }
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.buildSpecForAdapter = function (authMethod, outgoing, incoming, originalSecretValue, device) {
            if (authMethod === this.constants.authentication.PROHIBITED) {
                return this.createSpec(this.createNoAuthenticationProperties(), device);
            }
            else if (authMethod !== this.constants.authentication.MUTUAL) {
                return this.createSpec(this.createUniChapAuthenticationProperties(authMethod, outgoing, originalSecretValue), device);
            }
            else {
                return this.createSpec(this.createBiChapAuthentication(outgoing, incoming, originalSecretValue), device);
            }
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.buildAuthenticationPropertiesForTarget = function (inheritFromParent, authMethod, outgoing, incoming, originalSecretValue) {
            if (inheritFromParent) {
                return this.createAuthPropsForInheritFromParent();
            }
            if (authMethod === this.constants.authentication.PROHIBITED) {
                return this.createNoAuthenticationProperties();
            }
            else if (authMethod !== this.constants.authentication.MUTUAL) {
                return this.createUniChapAuthenticationProperties(authMethod, outgoing, originalSecretValue);
            }
            else {
                return this.createBiChapAuthentication(outgoing, incoming, originalSecretValue);
            }
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.createSpec = function (properties, device) {
            var spec = { _type: "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterAuthenticationUpdateSpec" };
            spec.device = device;
            spec.properties = properties;
            return spec;
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.createAuthPropsForInheritFromParent = function () {
            var spec = new InternetScsiHba$AuthenticationProperties();
            spec._type = this.AUTH_PROP_CLASS_TYPE;
            spec.chapInherited = true;
            spec.mutualChapInherited = true;
            spec.chapAuthEnabled = false;
            // disable both outgoing and incoming CHA
            spec.chapAuthenticationType = "chapProhibited";
            spec.mutualChapAuthenticationType = "chapProhibited";
            return spec;
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.createNoAuthenticationProperties = function () {
            var spec = new InternetScsiHba$AuthenticationProperties();
            spec._type = this.AUTH_PROP_CLASS_TYPE;
            spec.chapAuthEnabled = false;
            spec.chapAuthenticationType = this.constants.authentication.PROHIBITED;
            spec.mutualChapAuthenticationType = this.constants.authentication.PROHIBITED;
            spec.chapInherited = false;
            return spec;
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.createUniChapAuthenticationProperties = function (authMethod, outgoing, originalSecretValue) {
            var spec = new InternetScsiHba$AuthenticationProperties();
            spec._type = this.AUTH_PROP_CLASS_TYPE;
            spec.chapAuthEnabled = true;
            spec.chapAuthenticationType = authMethod;
            spec.chapName = outgoing.name.trim();
            spec.chapSecret = this.getSecret(outgoing.secret, originalSecretValue);
            spec.mutualChapAuthenticationType = this.constants.authentication.PROHIBITED;
            spec.chapInherited = false;
            return spec;
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.createBiChapAuthentication = function (outgoing, incoming, originalSecretValue) {
            var spec = new InternetScsiHba$AuthenticationProperties();
            spec._type = this.AUTH_PROP_CLASS_TYPE;
            spec.chapAuthEnabled = true;
            spec.chapAuthenticationType = this.constants.authentication.REQUIRED;
            spec.chapName = outgoing.name.trim();
            spec.chapSecret = this.getSecret(outgoing.secret, originalSecretValue);
            spec.mutualChapAuthenticationType = this.constants.authentication.REQUIRED;
            spec.mutualChapName = incoming.name.trim();
            spec.mutualChapSecret = this.getSecret(incoming.secret, originalSecretValue);
            spec.chapInherited = false;
            return spec;
        };
        StorageAdapterEditAuthenticationSpecBuilderService.prototype.getSecret = function (secret, originalSecret) {
            if (secret === this.constants.EXISTING_PASSWORD_PLACEHOLDER) {
                return originalSecret;
            }
            return secret.trim();
        };
        StorageAdapterEditAuthenticationSpecBuilderService.$inject = ["storageAdapterConstants"];
        return StorageAdapterEditAuthenticationSpecBuilderService;
    }());
    storage_ui.StorageAdapterEditAuthenticationSpecBuilderService = StorageAdapterEditAuthenticationSpecBuilderService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageAdapterEditAuthenticationSpecBuilderService", StorageAdapterEditAuthenticationSpecBuilderService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterEditAuthenticationValidationService = (function () {
        function StorageAdapterEditAuthenticationValidationService(i18nService, constants) {
            this.i18nService = i18nService;
            this.constants = constants;
        }
        StorageAdapterEditAuthenticationValidationService.prototype.isValidName = function (name, isSoftwareIscsi) {
            var errors = [];
            var maxLength = isSoftwareIscsi ? this.constants.constraints.SW_CHAP_NAME_MAX : this.constants.constraints.HW_CHAP_NAME_MAX;
            if (!name || !name.trim().length) {
                errors.push(this.i18nService.getString("StorageUi", "storage.adapters.edit.authentication.form.errorMessage"));
            }
            else if (name.trim().length > maxLength) {
                errors.push(this.i18nService.getString("StorageUi", "storage.adapters.edit.authentication.form.fieldLengthError", maxLength));
            }
            return errors;
        };
        StorageAdapterEditAuthenticationValidationService.prototype.isValidSecret = function (secret, isSoftwareIscsi) {
            var errors = [];
            var maxLength = isSoftwareIscsi ? this.constants.constraints.SW_CHAP_SECRET_MAX : this.constants.constraints.HW_CHAP_SECRET_MAX;
            if (!secret || !secret.trim().length) {
                errors.push(this.i18nService.getString("StorageUi", "storage.adapters.edit.authentication.form.errorMessage"));
            }
            else if (secret.trim().length > maxLength) {
                errors.push(this.i18nService.getString("StorageUi", "storage.adapters.edit.authentication.form.fieldLengthError", maxLength));
            }
            return errors;
        };
        StorageAdapterEditAuthenticationValidationService.$inject = ["i18nService", "storageAdapterConstants"];
        return StorageAdapterEditAuthenticationValidationService;
    }());
    storage_ui.StorageAdapterEditAuthenticationValidationService = StorageAdapterEditAuthenticationValidationService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageAdapterEditAuthenticationValidationService", StorageAdapterEditAuthenticationValidationService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AdapterStatusService = (function () {
        function AdapterStatusService(i18nService, mutationService, clarityModalService, clarityConstants, $q) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.$q = $q;
        }
        AdapterStatusService.prototype.disable = function (options) {
            var _this = this;
            var specData = this.getMutationData(false, options.isIscsiAdapter, options.deviceName);
            this.clarityModalService.openConfirmationModal({
                title: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.popup.disable.header"),
                message: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.disablePopup.text"),
                preserveNewlines: true,
                defaultButton: "submit",
                subTitle: {
                    objectId: options.hostId
                },
                submit: function () {
                    _this.mutationService.apply(options.hostId, specData.type, specData.spec).then(function (response) {
                        options.onSuccessCallback(response);
                    });
                    return true;
                }
            });
        };
        AdapterStatusService.prototype.enable = function (options) {
            var specData = this.getMutationData(true, options.isIscsiAdapter, options.deviceName);
            return this.mutationService.apply(options.hostId, specData.type, specData.spec);
        };
        AdapterStatusService.prototype.getMutationData = function (activate, isIscsiAdapter, deviceName) {
            return isIscsiAdapter
                ? {
                    type: "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterActivationSpec",
                    spec: { activate: activate }
                }
                : {
                    type: "com.vmware.vsphere.client.storage.adapters.FcoeStorageAdapterRemovalSpec",
                    spec: { mark: !activate, hbaName: deviceName }
                };
        };
        AdapterStatusService.$inject = [
            "i18nService",
            "mutationService",
            "clarityModalService",
            "clarityConstants",
            "$q"];
        return AdapterStatusService;
    }());
    storage_ui.AdapterStatusService = AdapterStatusService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("adapterStatusService", AdapterStatusService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var SwIscsiEditSettingsSpec = (function () {
        function SwIscsiEditSettingsSpec() {
            this._type = "com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterSettingsUpdateSpec";
        }
        return SwIscsiEditSettingsSpec;
    }());
    storage_ui.SwIscsiEditSettingsSpec = SwIscsiEditSettingsSpec;
    var SwIscsiEditSettingsDialogService = (function () {
        function SwIscsiEditSettingsDialogService(i18nService, mutationService, clarityModalService, clarityConstants, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.vxValidatorFactory = vxValidatorFactory;
        }
        SwIscsiEditSettingsDialogService.prototype.openModal = function (hostId, adapter) {
            var modalOptions, dialogData;
            var editSpec = new SwIscsiEditSettingsSpec();
            var maxAliasLength = adapter.isSoftwareBased
                ? SwIscsiEditSettingsDialogService.MAX_ALIAS_LENGTH_SWISCSI
                : SwIscsiEditSettingsDialogService.MAX_ALIAS_LENGTH_HWISCSI;
            editSpec.device = adapter.device;
            editSpec.name = adapter.iScsiName;
            editSpec.alias = adapter.iScsiAlias;
            dialogData = {
                hostId: hostId,
                editSpec: editSpec,
                i18n: this.i18nService.getString.bind(this, "StorageUi"),
                errors: {
                    name: "",
                    alias: ""
                },
                validator: this.vxValidatorFactory.create(),
                isValidName: function () {
                    var errors = [];
                    var nameValue = modalOptions.dialogData.editSpec.name.trim();
                    ;
                    // Adapter name should follow specific rules.
                    if (!SwIscsiEditSettingsDialogService.ISCSI_EUI_NAME_REGEX.test(nameValue)
                        && !SwIscsiEditSettingsDialogService.ISCSI_IQN_NAME_REGEX.test(nameValue)) {
                        errors = [modalOptions.dialogData.i18n("storage.adapters.properties.general.iSCSINameError")];
                    }
                    // Adapter name should not be empty or too long.
                    if (!nameValue || nameValue.length > SwIscsiEditSettingsDialogService.MAX_NAME_LENGTH) {
                        errors = [modalOptions.dialogData.i18n("storage.adapters.properties.general.fieldLengthError", SwIscsiEditSettingsDialogService.MAX_NAME_LENGTH)];
                    }
                    return errors;
                },
                isValidAlias: function () {
                    var errors = [];
                    var aliasValue = modalOptions.dialogData.editSpec.alias.trim();
                    // Adapter alias should not be too long.
                    if (aliasValue && aliasValue.length > maxAliasLength) {
                        errors.push(modalOptions.dialogData.i18n("storage.adapters.properties.general.fieldLengthError", maxAliasLength));
                    }
                    return errors;
                }
            };
            modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.general.edit.header"),
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/iscsihba/SwIscsiEditSettingsDialog.html",
                defaultButton: "submit",
                dialogData: dialogData,
                alerts: []
            };
            modalOptions.onSubmit = this.onCommit.bind(this, modalOptions, adapter);
            if (adapter.device) {
                modalOptions.subTitle = adapter.device;
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        SwIscsiEditSettingsDialogService.prototype.onCommit = function (modalOptions, adapter) {
            if (this.validate(modalOptions.dialogData)) {
                var nameChanged = modalOptions.dialogData.editSpec.name !== adapter.iScsiName;
                var aliasChanged = modalOptions.dialogData.editSpec.alias !== adapter.iScsiAlias;
                var spec = new SwIscsiEditSettingsSpec();
                spec.device = modalOptions.dialogData.editSpec.device;
                // Do not send a mutation request if nothing has changed.
                if (!nameChanged && !aliasChanged) {
                    return true;
                }
                // Only send real changes in the spec.
                if (nameChanged) {
                    spec.name = modalOptions.dialogData.editSpec.name;
                }
                if (aliasChanged) {
                    spec.alias = modalOptions.dialogData.editSpec.alias;
                }
                this.mutationService.apply(modalOptions.dialogData.hostId, spec._type, spec);
                return true;
            }
            else {
                modalOptions.alerts = [{
                        text: modalOptions.dialogData.i18n("form.validationError"),
                        type: this.clarityConstants.notifications.type.ERROR
                    }];
                return false;
            }
        };
        SwIscsiEditSettingsDialogService.prototype.validate = function (dialogData) {
            var errors = dialogData.validator.validate();
            return !(errors && errors.length);
        };
        SwIscsiEditSettingsDialogService.$inject = ["i18nService", "mutationService", "clarityModalService", "clarityConstants", "vxValidatorFactory"];
        // iSCSI name validators, see rfc3720.
        SwIscsiEditSettingsDialogService.ISCSI_IQN_NAME_REGEX = new RegExp("^iqn\.[0-9]{4}-[0-9]{2}(?:\.[A-Za-z](?:[A-Za-z0-9\-]*[A-Za-z0-9])?)+(?::[A-Za-z0-9\-\._:]*)?$");
        SwIscsiEditSettingsDialogService.ISCSI_EUI_NAME_REGEX = new RegExp("^eui\.[0-9A-Fa-f]{16}$");
        SwIscsiEditSettingsDialogService.MAX_NAME_LENGTH = 223;
        SwIscsiEditSettingsDialogService.MAX_ALIAS_LENGTH_SWISCSI = 255;
        SwIscsiEditSettingsDialogService.MAX_ALIAS_LENGTH_HWISCSI = 31;
        return SwIscsiEditSettingsDialogService;
    }());
    storage_ui.SwIscsiEditSettingsDialogService = SwIscsiEditSettingsDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("swIscsiEditSettingsDialogService", SwIscsiEditSettingsDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AddIpAddressModalComponentController = (function () {
        function AddIpAddressModalComponentController(i18nService) {
            this.i18nService = i18nService;
        }
        AddIpAddressModalComponentController.$inject = ["i18nService"];
        return AddIpAddressModalComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("addIpAddressComponent", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/network/AddIpAddressModalComponent.html",
        bindings: {
            ipInput: "=",
            validateManually: "="
        },
        controller: AddIpAddressModalComponentController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var InternetScsiHba$IscsiIpv6Address = storage_ui.InternetScsiHba$IscsiIpv6Address;
    var HbaNetworkingUtil = (function () {
        function HbaNetworkingUtil(constants) {
            this.constants = constants;
            this.IPV6_LINK_LOCAL_PREFIX_LENGTH = 64;
        }
        HbaNetworkingUtil.prototype.createIpv6 = function (addr) {
            var address = new InternetScsiHba$IscsiIpv6Address();
            address.address = addr;
            address.prefixLength = this.IPV6_LINK_LOCAL_PREFIX_LENGTH;
            address.origin = this.constants.AddressConfigurationType.Static;
            address.operation = this.constants.IPv6Settings.OPERATION.ADD;
            return address;
        };
        HbaNetworkingUtil.prototype.getLinkLocalIPv6Address = function (ipProperties) {
            var address = this.getLinkLocalIPv6(ipProperties);
            return address && address.address ? address.address : "";
        };
        HbaNetworkingUtil.prototype.getLinkLocalIPv6 = function (ipProperties) {
            var _this = this;
            if (!ipProperties || !ipProperties.ipv6properties) {
                return null;
            }
            else {
                var address = _.find(ipProperties.ipv6properties.iscsiIpv6Address, function (address) {
                    return (address.origin !== _this.constants.AddressConfigurationType.Other
                        && _this.isLinkLocalIpv6Address(address.address, address.prefixLength));
                });
                return address || null;
            }
        };
        /**
         * Checks if IPv6 address is a link local address i.e. of the type fe80::/10
         * (fe80:: through febf::)
         *
         * @param address
         *    IPv6 address
         * @param prefixLength
         *    IPv6 prefix length - link-local addresses have a prefix length of 64
         * @return
         *    Returns true if the address is a link local one
         */
        HbaNetworkingUtil.prototype.isLinkLocalIpv6Address = function (address, prefixLength) {
            if (prefixLength === void 0) { prefixLength = 64; }
            if (!address ||
                prefixLength !== this.IPV6_LINK_LOCAL_PREFIX_LENGTH ||
                address.length < 4) {
                return false;
            }
            var addressBegining = parseInt(address.substr(0, 4), 16);
            return (addressBegining & 0xffc0) === 0xfe80;
        };
        /**
         * Gets the IPv6 addresses of certain type
         *
         * @param hba
         *    The HBA config
         *
         * @param addressType
         *    The address type to filter
         *
         * @param skipLinkLocal
         *    Indicates, whether to skip linl-local addresses. Default is false.
         *
         * @return
         *    The filtered IPv6 addresses
         */
        HbaNetworkingUtil.prototype.getIPv6AddressesOfType = function (ipProperties, addressType, skipLinkLocal) {
            var _this = this;
            var addressesList = [];
            if (!ipProperties || !ipProperties.ipv6properties || !ipProperties.ipv6properties.iscsiIpv6Address.length) {
                return addressesList;
            }
            return _.filter(ipProperties.ipv6properties.iscsiIpv6Address, function (address) {
                return address.origin === addressType
                    && !(skipLinkLocal && _this.isLinkLocalIpv6Address(address.address, address.prefixLength));
            });
        };
        HbaNetworkingUtil.$inject = ["StorageAdapterNetworkSettingsConstants"];
        return HbaNetworkingUtil;
    }());
    storage_ui.HbaNetworkingUtil = HbaNetworkingUtil;
    angular.module("com.vmware.vsphere.client.storage")
        .service("hbaNetworkingUtil", HbaNetworkingUtil);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var IpAddressGridComponentController = (function () {
        function IpAddressGridComponentController(i18nService, vuiConstants, clarityModalService, hbaNetworkingUtil, clarityConstants) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.clarityModalService = clarityModalService;
            this.hbaNetworkingUtil = hbaNetworkingUtil;
            this.clarityConstants = clarityConstants;
            this.initDatagrid();
        }
        IpAddressGridComponentController.prototype.initDatagrid = function () {
            var _this = this;
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: false
                },
                columnDefs: this.getColumnDefs(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                resizable: true,
                actionBarOptions: { actions: this.getActions() },
                columnMenu: {
                    sortable: false,
                    messages: {
                        columns: this.i18nService.getString("CommonUi", "listview.showColumnsMenu"),
                        filter: this.i18nService.getString("CommonUi", "listview.filterMenu")
                    }
                },
                onChange: function () {
                    _this.datagridOptions.actionBarOptions.actions[1].enabled = !!_this.datagridOptions.selectedItems.length;
                }
            };
        };
        IpAddressGridComponentController.prototype.$onInit = function () {
            this.datagridOptions.data = this.staticAddress;
        };
        IpAddressGridComponentController.prototype.getActions = function () {
            var _this = this;
            var self = this;
            return [{
                    tooltipText: this.i18nService.getString("StorageUi", "IScsiIpv6SettingsPage.addButtonTooltip"),
                    label: this.i18nService.getString("StorageUi", "IScsiIpv6SettingsPage.addButtonLabel"),
                    iconClass: "vx-icon-addIcon",
                    enabled: true,
                    onClick: function () {
                        var modalOptions = {
                            title: _this.i18nService.getString("StorageUi", "IScsiIpv6SettingsPage.addButtonTooltip"),
                            contentTemplate: "storage-ui/resources/storage/views/host/adapters/network/AddIpAddress.html",
                            defaultButton: "submit",
                            dialogData: {
                                ipInput: "",
                                validateManually: null
                            },
                            onSubmit: function () {
                                var address = this.dialogData.ipInput;
                                if (this.dialogData.validateManually().length) {
                                    return false;
                                }
                                var message = "";
                                if (self.hbaNetworkingUtil.isLinkLocalIpv6Address(address)) {
                                    message = self.i18nService.getString("StorageUi", "Ipv6AddressPage.linkLocalForbiddenError");
                                }
                                else if (!!_.find(self.datagridOptions.data, function (item) {
                                    return item.address === address;
                                })) {
                                    message = self.i18nService.getString("StorageUi", "Ipv6AddressPage.duplicateIpv6AddressNewVnicError", this.dialogData.ipInput);
                                }
                                if (message) {
                                    this.alerts = [{
                                            type: self.clarityConstants.notifications.type.ERROR,
                                            text: message
                                        }];
                                    return false;
                                }
                                self.datagridOptions.data = self.datagridOptions.data.concat(self.hbaNetworkingUtil.createIpv6(this.dialogData.ipInput));
                                self.staticAddress = self.datagridOptions.data;
                                return true;
                            },
                            alerts: []
                        };
                        _this.clarityModalService.openOkCancelModal(modalOptions);
                    }
                }, {
                    tooltipText: this.i18nService.getString("StorageUi", "IScsiIpv6SettingsPage.removeButtonTooltip"),
                    label: this.i18nService.getString("StorageUi", "IScsiIpv6SettingsPage.removeButtonLabel"),
                    iconClass: "vx-icon-removeIcon",
                    enabled: true,
                    onClick: function () {
                        if (self.datagridOptions.selectedItems.length) {
                            self.datagridOptions.data = _.filter(self.datagridOptions.data, function (item) {
                                return item.address !== self.datagridOptions.selectedItems[0].address;
                            });
                            self.staticAddress = self.datagridOptions.data;
                        }
                    }
                }];
        };
        IpAddressGridComponentController.prototype.getColumnDefs = function () {
            return [{
                    displayName: this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSettingsPage.serverColumn"),
                    field: "serverName",
                    template: "#:address#/64"
                }];
        };
        IpAddressGridComponentController.$inject = ["i18nService", "vuiConstants", "clarityModalService", "hbaNetworkingUtil",
            "clarityConstants"];
        return IpAddressGridComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("ipAddressGrid", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/network/IpAddressGridComponent.html",
        bindings: {
            staticAddress: "="
        },
        controller: IpAddressGridComponentController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterDnsSettingsComponent = (function () {
        function StorageAdapterDnsSettingsComponent(i18nService) {
            this.i18nService = i18nService;
            this.dnsStackBlockExpanded = false;
            this.i18n = function (key) { return i18nService.getString("StorageUi", key); };
            if (!this.model.isPreferedDnsSupported) {
                this.model.properties.primaryDnsServerAddress = this.i18n("storage.adapters.properties.notSupportedLabel");
            }
            if (!this.model.isAlternateDnsSupported) {
                this.model.properties.alternateDnsServerAddress = this.i18n("storage.adapters.properties.notSupportedLabel");
            }
        }
        StorageAdapterDnsSettingsComponent.$inject = ["i18nService"];
        return StorageAdapterDnsSettingsComponent;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageAdapterDnsSettingsComponent", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/network/StorageAdapterDnsSettingsComponent.html",
        bindings: {
            model: "="
        },
        controller: StorageAdapterDnsSettingsComponent
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var InternetScsiStorageAdapterIpConfigurationUpdateSpec = storage_ui.InternetScsiStorageAdapterIpConfigurationUpdateSpec;
    var StorageAdapterEditNetworkSettingsDialogService = (function () {
        function StorageAdapterEditNetworkSettingsDialogService(i18nService, clarityModalService, constants, vxValidatorFactory, mutationService, hbaNetworkingUtil, clarityConstants) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.constants = constants;
            this.vxValidatorFactory = vxValidatorFactory;
            this.mutationService = mutationService;
            this.hbaNetworkingUtil = hbaNetworkingUtil;
            this.clarityConstants = clarityConstants;
        }
        StorageAdapterEditNetworkSettingsDialogService.prototype.open = function (hostId, adapter, networkSettings) {
            var _this = this;
            var spec = new InternetScsiStorageAdapterIpConfigurationUpdateSpec();
            spec.device = adapter.device;
            spec.properties = _.clone(networkSettings.properties);
            this.dialogData = {
                constants: this.constants,
                model: this.clone(networkSettings),
                validator: this.vxValidatorFactory.create(),
                spec: spec,
                ipv4StackBlockExpanded: true,
                ipv6StackBlockExpanded: false,
                dnsStackBlockExpanded: false,
                i18n: this.i18nService.getString,
                ipv6options: [{
                        name: this.i18nService.getString("Common", "enabled"),
                        value: true
                    }, {
                        name: this.i18nService.getString("Common", "disabled"),
                        value: false
                    }],
                ipv6LinkLocalAddress: null
            };
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.adapters.properties.ipDnsConfig.edit.h5header"),
                subTitle: {
                    text: adapter.device
                },
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                dialogData: this.dialogData,
                contentTemplate: "storage-ui/resources/storage/views/host/adapters/network/StorageAdapterEditNetworkSettingsDialog.html",
                onSubmit: function () {
                    var errors = _this.dialogData.validator.validate();
                    if (errors.length) {
                        modalOptions.alerts = _.map(errors, function (error) { return ({
                            text: error,
                            type: _this.clarityConstants.notifications.type.ERROR
                        }); });
                        return false;
                    }
                    var isIpv6Dirty = _this.updateIpv6PageData();
                    if (_this.updateDnsPageData() || _this.updateIpv4PageData() || isIpv6Dirty) {
                        var spec_1 = _this.dialogData.spec;
                        if (!isIpv6Dirty) {
                            spec_1.properties.ipv6properties = null;
                        }
                        _this.mutationService.apply(hostId, spec_1._type, spec_1);
                    }
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        /****
         * Returns a ~deep clone of passed networkSettingsItem,
         * Used to not change/store local version of Network Settings,
         * while update is still running
         *
         * @param networkSettings instance you wish to clone
         */
        StorageAdapterEditNetworkSettingsDialogService.prototype.clone = function (networkSettings) {
            var clone = _.clone(networkSettings);
            clone.properties = _.clone(networkSettings.properties);
            clone.properties.ipv6properties = _.clone(networkSettings.properties.ipv6properties);
            return clone;
        };
        StorageAdapterEditNetworkSettingsDialogService.prototype.updateIpv4PageData = function () {
            var isDirty = false;
            var model = this.dialogData.model;
            var properties = model.properties;
            var capabilities = model.capabilities;
            var spec = this.dialogData.spec.properties;
            if (!capabilities.ipv4EnableSettable && !properties.ipv4Enabled) {
                // The IPv4 is not enabled and cannot be enabled.
                return false;
            }
            if (!capabilities.ipConfigurationMethodSettable && properties.dhcpConfigurationEnabled) {
                // The IPv4 DHCP is enabled and cannot be disabled.
                return false;
            }
            // Enable or disable the IPV4 configuration
            isDirty = isDirty || spec.ipv4Enabled !== properties.ipv4Enabled;
            spec.ipv4Enabled = properties.ipv4Enabled;
            if (properties.ipv4Enabled) {
                // Enable disable DHCP
                isDirty = isDirty || spec.dhcpConfigurationEnabled !== properties.dhcpConfigurationEnabled;
                spec.dhcpConfigurationEnabled = properties.dhcpConfigurationEnabled;
                if (!properties.dhcpConfigurationEnabled) {
                    // Update the static ip configuration (when DHCP is false)
                    isDirty = isDirty || spec.address !== properties.address
                        || spec.subnetMask !== properties.subnetMask
                        || spec.defaultGateway !== properties.defaultGateway;
                    spec.address = properties.address;
                    spec.subnetMask = properties.subnetMask;
                    spec.defaultGateway = properties.defaultGateway;
                }
                else {
                    spec.address = null;
                    spec.subnetMask = null;
                    spec.defaultGateway = null;
                }
            }
            return isDirty;
        };
        StorageAdapterEditNetworkSettingsDialogService.prototype.updateIpv6PageData = function () {
            var _this = this;
            var isDirty = false;
            var spec = this.dialogData.spec.properties;
            var model = this.dialogData.model;
            var isOnlyLinkLocal = this.dialogData.selectedOption === this.constants.IPv6Settings.LINK_LOCAL;
            var properties = model.properties;
            var capabilities = model.capabilities;
            if (!capabilities.ipv6Supported) {
                return false;
            }
            if (!capabilities.ipv6EnableSettable && !properties.ipv6Enabled) {
                // The IPv6 is not enabled and cannot be enabled.
                return false;
            }
            //IPv6 has been disabled/enabled through UI
            if (capabilities.ipv6EnableSettable) {
                isDirty = spec.ipv6Enabled !== properties.ipv6Enabled;
                spec.ipv6Enabled = properties.ipv6Enabled;
                if (!spec.ipv6Enabled) {
                    return isDirty;
                }
            }
            var linkLocalOverrideAddress = null;
            // Link-local override
            if (capabilities.ipv6LinkLocalAutoConfigurationSettable) {
                isDirty = isDirty || properties.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled !== spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled;
                spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled = properties.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled;
                var isLinkLocalOverrideDirty = this.dialogData.ipv6LinkLocalAddress !== this.hbaNetworkingUtil.getLinkLocalIPv6Address(spec);
                if (!spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled && isLinkLocalOverrideDirty) {
                    //if overriden - save address here
                    linkLocalOverrideAddress = this.hbaNetworkingUtil.createIpv6(this.dialogData.ipv6LinkLocalAddress);
                    spec.ipv6properties.iscsiIpv6Address.push(linkLocalOverrideAddress);
                }
            }
            //DHCP
            if (capabilities.ipv6DhcpConfigurationSettable) {
                isDirty = isDirty || spec.ipv6properties.ipv6DhcpConfigurationEnabled !== properties.ipv6properties.ipv6DhcpConfigurationEnabled;
                spec.ipv6properties.ipv6DhcpConfigurationEnabled = properties.ipv6properties.ipv6DhcpConfigurationEnabled;
                if (isDirty && spec.ipv6properties.ipv6DhcpConfigurationEnabled) {
                    spec.ipv6properties.iscsiIpv6Address = [];
                    spec.ipv6properties.ipv6DefaultGateway = null;
                    spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled =
                        capabilities.ipv6RouterAdvertisementConfigurationSettable ? false : null;
                    return isDirty;
                }
            }
            else {
                //If dhcp is not settable, setting it to ANY value (i.e. true a false) causes a backend exception
                spec.ipv6properties.ipv6DhcpConfigurationEnabled = null;
            }
            // Router advertisement
            if (capabilities.ipv6RouterAdvertisementConfigurationSettable) {
                isDirty = isDirty || spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled !== properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
                spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled = properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
                if (isDirty && spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled) {
                    spec.ipv6properties.iscsiIpv6Address = [];
                    spec.ipv6properties.ipv6DefaultGateway = null;
                    return isDirty;
                }
            }
            else {
                spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled = null;
            }
            // Static addresses
            var automaticOptionSelected = properties.ipv6properties.ipv6DhcpConfigurationEnabled ||
                properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
            var origStaticAddresses = this.getIPv6StaticAddressesList(spec);
            if (!automaticOptionSelected) {
                var isStaticAddressDirty = this.isStaticIpv6Dirty(properties.ipv6properties.iscsiIpv6Address, origStaticAddresses);
                isDirty = isDirty || isStaticAddressDirty;
                if (isStaticAddressDirty || isOnlyLinkLocal) {
                    spec.ipv6properties.iscsiIpv6Address = [];
                    if (linkLocalOverrideAddress) {
                        spec.ipv6properties.iscsiIpv6Address.push(linkLocalOverrideAddress);
                    }
                    if (!isOnlyLinkLocal) {
                        spec.ipv6properties.iscsiIpv6Address = spec.ipv6properties.iscsiIpv6Address.concat(properties.ipv6properties.iscsiIpv6Address);
                    }
                    // mark old ones for removal
                    _.each(origStaticAddresses, function (address) {
                        if (!_.find(properties.ipv6properties.iscsiIpv6Address, function (newAddress) { return address.address === newAddress.address; })) {
                            address.operation = _this.constants.IPv6Settings.OPERATION.REMOVE;
                            spec.ipv6properties.iscsiIpv6Address.push(address);
                        }
                    });
                }
            }
            // IPv6 Gateway
            if (capabilities.ipv6DefaultGatewaySettable) {
                var defaultGatewayIsDirty = spec.ipv6properties.ipv6DefaultGateway !== properties.ipv6properties.ipv6DefaultGateway;
                isDirty = isDirty || defaultGatewayIsDirty;
                if (!defaultGatewayIsDirty && isDirty) {
                    spec.ipv6properties.ipv6DefaultGateway = null;
                }
                else {
                    spec.ipv6properties.ipv6DefaultGateway = properties.ipv6properties.ipv6DefaultGateway;
                }
            }
            return isDirty;
        };
        StorageAdapterEditNetworkSettingsDialogService.prototype.isStaticIpv6Dirty = function (current, old) {
            //current array may have operations defined - we want to neglect them for this check
            current = _.pluck(_.sortBy(current, function (address) { return address.address; }), "address");
            old = _.pluck(_.sortBy(old, function (address) { return address.address; }), "address");
            return !_.isEqual(current, old);
        };
        StorageAdapterEditNetworkSettingsDialogService.prototype.getIPv6StaticAddressesList = function (ipProperties) {
            var addressesList = [];
            if (!ipProperties || !ipProperties.ipv6properties || !ipProperties.ipv6properties.iscsiIpv6Address.length) {
                return addressesList;
            }
            // Add all static non link-local addresses.
            _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties, this.constants.AddressConfigurationType.Static, true), function (address) {
                addressesList.push(address);
            });
            // Add all auto configured non link-local addresses, if routerAdv is enabled.
            if (ipProperties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled) {
                _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties, this.constants.AddressConfigurationType.AutoConfigured, true), function (address) {
                    addressesList.push(address);
                });
            }
            // Add all dhcp non link-local addresses, if dhcp is enabled.
            if (ipProperties.ipv6properties.ipv6DhcpConfigurationEnabled) {
                _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties, this.constants.AddressConfigurationType.DHCP, true), function (address) {
                    addressesList.push(address);
                });
            }
            return addressesList;
        };
        StorageAdapterEditNetworkSettingsDialogService.prototype.updateDnsPageData = function () {
            var isDirty = false;
            var spec = this.dialogData.spec.properties;
            var model = this.dialogData.model.properties;
            var capabilities = this.dialogData.model.capabilities;
            if (capabilities.primaryDnsServerAddressSettable || capabilities.alternateDnsServerAddressSettable) {
                isDirty = (model.primaryDnsServerAddress !== spec.primaryDnsServerAddress
                    || model.alternateDnsServerAddress !== spec.alternateDnsServerAddress);
                spec.primaryDnsServerAddress = model.primaryDnsServerAddress;
                spec.alternateDnsServerAddress = model.alternateDnsServerAddress;
            }
            return isDirty;
        };
        StorageAdapterEditNetworkSettingsDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "StorageAdapterNetworkSettingsConstants",
            "vxValidatorFactory",
            "mutationService",
            "hbaNetworkingUtil",
            "clarityConstants"
        ];
        return StorageAdapterEditNetworkSettingsDialogService;
    }());
    storage_ui.StorageAdapterEditNetworkSettingsDialogService = StorageAdapterEditNetworkSettingsDialogService;
    angular
        .module("com.vmware.vsphere.client.storage")
        .service("storageAdapterEditNetworkSettingsDialogService", StorageAdapterEditNetworkSettingsDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterIPv4SettingsComponent = (function () {
        function StorageAdapterIPv4SettingsComponent(i18nService, constants, ipParserService, vxValidatorFactory) {
            var _this = this;
            this.i18nService = i18nService;
            this.constants = constants;
            this.ipParserService = ipParserService;
            this.validateIpv4Address = function (value) {
                if (!_this.isStatic() || (value && _this.ipParserService.isIpv4AddressValid(value))) {
                    return [];
                }
                return [_this.i18nService.getString("StorageUi", "storage.adapters.properties.ipDnsConfig.invalidV4")];
            };
            this.validateIpv4Mask = function (value) {
                if (!_this.isStatic() || (value && _this.ipParserService.isSubnetMaskValid(value))) {
                    return [];
                }
                return [_this.i18nService.getString("StorageUi", "storage.adapters.properties.ipDnsConfig.invalidSubnetMask")];
            };
            this.i18n = function (key) { return i18nService.getString("StorageUi", key); };
            var props = this.model.properties;
            // populate radio selection
            if (!props.ipv4Enabled) {
                this.selectedOption = this.constants.IPv4Settings.NONE;
            }
            else if (props.ipv4Enabled && props.dhcpConfigurationEnabled) {
                this.selectedOption = this.constants.IPv4Settings.DHCP;
            }
            else if (props.ipv4Enabled && !props.dhcpConfigurationEnabled) {
                this.selectedOption = this.constants.IPv4Settings.STATIC;
            }
            this.validator = vxValidatorFactory.create();
        }
        StorageAdapterIPv4SettingsComponent.prototype.isStatic = function () {
            return this.selectedOption === this.constants.IPv4Settings.STATIC;
        };
        /**
         * Modifies spec flags based on radio button selected
         **/
        StorageAdapterIPv4SettingsComponent.prototype.onChange = function (option) {
            if (option) {
                switch (option) {
                    case this.constants.IPv4Settings.NONE:
                        this.model.properties.ipv4Enabled = false;
                        break;
                    case this.constants.IPv4Settings.DHCP:
                        this.model.properties.dhcpConfigurationEnabled = true;
                        this.model.properties.ipv4Enabled = true;
                        break;
                    case this.constants.IPv4Settings.STATIC:
                        this.model.properties.ipv4Enabled = true;
                        this.model.properties.dhcpConfigurationEnabled = false;
                        break;
                }
            }
        };
        StorageAdapterIPv4SettingsComponent.$inject = ["i18nService", "StorageAdapterNetworkSettingsConstants", "ipParserService", "vxValidatorFactory"];
        return StorageAdapterIPv4SettingsComponent;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageAdapterIpV4SettingsComponent", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/network/StorageAdapterIPv4SettingsComponent.html",
        bindings: {
            model: "=",
            validator: "="
        },
        controller: StorageAdapterIPv4SettingsComponent
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterIPv6SettingsComponent = (function () {
        function StorageAdapterIPv6SettingsComponent(i18nService, constants, ipParserService, vxValidatorFactory, hbaNetworkingUtil) {
            this.i18nService = i18nService;
            this.constants = constants;
            this.ipParserService = ipParserService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.hbaNetworkingUtil = hbaNetworkingUtil;
            this.validateManually = {};
        }
        StorageAdapterIPv6SettingsComponent.prototype.$onInit = function () {
            var _this = this;
            this.linkLocalAddress = this.getLinkLocalAddress();
            this.model.properties.ipv6properties.iscsiIpv6Address = _.filter(this.model.properties.ipv6properties.iscsiIpv6Address, function (address) {
                return address.address !== _this.linkLocalAddress;
            }) || [];
            this.staticIpv6Address = this.model.properties.ipv6properties.iscsiIpv6Address || [];
            this.populateSelection();
            //Here we wrap "global" validation to trigger Ipv6 validations/grid values check
            this.validator.validate = _.wrap(this.validator.validate, function (validatorValidate) {
                var errors = validatorValidate.call(_this.validator);
                _.each(_this.validateManually, function (validate) {
                    errors = errors.concat(validate());
                });
                if (_this.selectedOption === _this.constants.IPv6Settings.STATIC) {
                    if (!_this.model.properties.ipv6properties.iscsiIpv6Address.length) {
                        errors.push(_this.i18nService.getString("StorageUi", "storage.adapters.properties.ipDnsConfig.emptyStaticV6Addresses"));
                    }
                }
                return errors;
            });
        };
        StorageAdapterIPv6SettingsComponent.prototype.isStatic = function () {
            return this.selectedOption === this.constants.IPv6Settings.STATIC;
        };
        StorageAdapterIPv6SettingsComponent.prototype.isLinkLocal = function () {
            return this.selectedOption === this.constants.IPv6Settings.LINK_LOCAL;
        };
        StorageAdapterIPv6SettingsComponent.prototype.getLinkLocalAddress = function () {
            return this.hbaNetworkingUtil.getLinkLocalIPv6Address(this.model.properties);
        };
        StorageAdapterIPv6SettingsComponent.prototype.populateSelection = function () {
            var props = this.model.properties;
            var types = this.constants.IPv6Settings;
            if (props.ipv6properties.ipv6DhcpConfigurationEnabled) {
                this.selectedOption = types.DHCP;
            }
            else if (props.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled) {
                this.selectedOption = types.ROUTER;
            }
            else if (this.linkLocalAddress && !this.staticIpv6Address.length) {
                this.selectedOption = types.LINK_LOCAL;
            }
            else {
                this.selectedOption = types.STATIC;
            }
        };
        StorageAdapterIPv6SettingsComponent.prototype.changeStaticAddress = function (ipv6) {
            this.model.properties.ipv6properties.iscsiIpv6Address = [this.hbaNetworkingUtil.createIpv6(ipv6)];
        };
        StorageAdapterIPv6SettingsComponent.prototype.onSelectionChange = function (radioSelection) {
            var ipv6 = this.model.properties.ipv6properties;
            switch (radioSelection) {
                case this.constants.IPv6Settings.DHCP:
                    ipv6.ipv6DhcpConfigurationEnabled = true;
                    ipv6.ipv6RouterAdvertisementConfigurationEnabled = false;
                    break;
                case this.constants.IPv6Settings.ROUTER:
                    ipv6.ipv6DhcpConfigurationEnabled = false;
                    ipv6.ipv6RouterAdvertisementConfigurationEnabled = true;
                    break;
                case this.constants.IPv6Settings.LINK_LOCAL:
                    var newLinkLocal = this.hbaNetworkingUtil.getLinkLocalIPv6(this.model.properties);
                    ipv6.iscsiIpv6Address = newLinkLocal ? [newLinkLocal] : [];
                    ipv6.ipv6DhcpConfigurationEnabled = false;
                    ipv6.ipv6RouterAdvertisementConfigurationEnabled = false;
                    break;
                case this.constants.IPv6Settings.STATIC:
                    ipv6.ipv6DhcpConfigurationEnabled = false;
                    ipv6.ipv6RouterAdvertisementConfigurationEnabled = false;
                    break;
            }
        };
        StorageAdapterIPv6SettingsComponent.$inject = ["i18nService", "StorageAdapterNetworkSettingsConstants",
            "ipParserService", "vxValidatorFactory", "hbaNetworkingUtil"];
        return StorageAdapterIPv6SettingsComponent;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageAdapterIpV6SettingsComponent", {
        templateUrl: "storage-ui/resources/storage/views/host/adapters/network/StorageAdapterIPv6SettingsComponent.html",
        bindings: {
            model: "=",
            validator: "=",
            linkLocalAddress: "=",
            selectedOption: "="
        },
        controller: StorageAdapterIPv6SettingsComponent
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    angular.module("com.vmware.vsphere.client.storage")
        .constant("StorageAdapterNetworkSettingsConstants", {
        IPv4Settings: {
            NONE: "none",
            DHCP: "dhcp",
            STATIC: "static"
        },
        IPv6Settings: {
            DHCP: "dhcp",
            ROUTER: "router",
            STATIC: "static",
            LINK_LOCAL: "linkLocal",
            OPERATION: {
                ADD: "add",
                REMOVE: "remove"
            }
        },
        AddressConfigurationType: {
            DHCP: "DHCP",
            AutoConfigured: "AutoConfigured",
            Static: "Static",
            Other: "Other"
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdaptersMasterViewController = (function () {
        function StorageAdaptersMasterViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.tabs = [{
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.properties.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/StorageAdaptersGeneralDetailsView.html",
                    uid: "storage.adapters.generalTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.devices.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/StorageAdaptersDevicesDetailsView.html",
                    uid: "storage.adapters.devicesTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.paths.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/StorageAdaptersPathsDetailsView.html",
                    uid: "storage.adapters.pathsTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.iscsiDynamicTargets.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/targets/IscsiDynamicTargetsDetailsView.html",
                    uid: "storage.adapters.dynamicTargetsTab",
                    metadata: {
                        relevantFor: "isIscsiAdapter"
                    }
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.iscsiStaticTargets.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/targets/IscsiStaticTargetsDetailsView.html",
                    uid: "storage.adapters.staticTargetsTab",
                    metadata: {
                        relevantFor: "isIscsiAdapter"
                    }
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.networkSettings.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/StorageAdaptersNetworkSettingsView.html",
                    uid: "storage.adapters.networkSettingsTab",
                    metadata: {
                        relevantFor: "isIscsiAdapter, !isSoftwareBased"
                    }
                }, {
                    name: this.i18nService.getString("NetworkUi", "storage.adapters.tabs.networkPortBinding.header"),
                    templateUrl: "network-ui/resources/network/views/host/iscsi/IscsiPortBindingView.html",
                    uid: "storage.adapters.networkPortBindingsTab",
                    metadata: {
                        relevantFor: "portBindableIScsi"
                    }
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.adapters.tabs.advancedOptions.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/adapters/advanced/IscsiAdvancedOptionsDetailsView.html",
                    uid: "storage.adapters.iscsiAdvancedOptions",
                    metadata: {
                        relevantFor: "isIscsiAdapter"
                    }
                }];
            this.detailsViewData = {
                tabsPromise: this.$q.when(this.tabs)
            };
        }
        StorageAdaptersMasterViewController.$inject = ["i18nService", "$q"];
        return StorageAdaptersMasterViewController;
    }());
    storage_ui.StorageAdaptersMasterViewController = StorageAdaptersMasterViewController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("StorageAdaptersMasterViewController", StorageAdaptersMasterViewController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageAdapterActionsService = (function () {
        function StorageAdapterActionsService(i18nService, actionsService, $q, hostStorageConstants, mutationService) {
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.$q = $q;
            this.hostStorageConstants = hostStorageConstants;
            this.mutationService = mutationService;
        }
        StorageAdapterActionsService.prototype.isIscsiAdapterConfigurable = function (hostId, adapter) {
            var isIscsiAdapterConfigurablePromise = this.$q.defer();
            if (adapter.isSoftwareBased && (_.isUndefined(adapter.canBeDisabled) || adapter.canBeDisabled)) {
                // If the chosen adapter is software-based and can be disabled,
                // validate its activation and then decide upon Edit button availability.
                this.mutationService.validate(hostId, 'com.vmware.vsphere.client.storage.adapters.InternetScsiStorageAdapterActivationSpec', { activate: true }).then(function (validationResult) {
                    if (!!validationResult && (!!validationResult.result || !!validationResult.error)) {
                        isIscsiAdapterConfigurablePromise.resolve(true);
                    }
                    else {
                        isIscsiAdapterConfigurablePromise.resolve(false);
                    }
                }).catch(function () {
                    isIscsiAdapterConfigurablePromise.resolve(false);
                });
            }
            else {
                isIscsiAdapterConfigurablePromise.resolve(true);
            }
            return isIscsiAdapterConfigurablePromise.promise;
        };
        StorageAdapterActionsService.prototype.getBuilder = function (hostId, adapter) {
            if (adapter.type === this.hostStorageConstants.hostAdapterTypes.ISCSI) {
                var isIscsiAdapterConfigurable = this.isIscsiAdapterConfigurable(hostId, adapter);
                return new AdapterActionsBuilder(hostId, adapter, this.i18nService, this.actionsService, this.$q, this.hostStorageConstants, isIscsiAdapterConfigurable);
            }
            return new AdapterActionsBuilder(hostId, adapter, this.i18nService, this.actionsService, this.$q, this.hostStorageConstants, this.$q.when(false));
        };
        StorageAdapterActionsService.$inject = [
            "i18nService", "actionsService", "$q", "hostStorageConstants", "mutationService"
        ];
        return StorageAdapterActionsService;
    }());
    var AdapterActionsBuilder = (function () {
        function AdapterActionsBuilder(hostId, adapter, i18nService, actionsService, $q, hostStorageConstants, isIscsiAdapterConfigurable) {
            var _this = this;
            this.hostId = hostId;
            this.adapter = adapter;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.$q = $q;
            this.hostStorageConstants = hostStorageConstants;
            this.isIscsiAdapterConfigurable = isIscsiAdapterConfigurable;
            this.actionEvaluations = {};
            this.ACTIONS = this.initActions(this.hostStorageConstants.adapterDetailsAction);
            for (var _i = 0, _a = this.ACTIONS; _i < _a.length; _i++) {
                var action = _a[_i];
                this.actionEvaluations[action.uid] = this.$q.defer();
            }
            actionsService.getActions([hostId], _.map(this.ACTIONS, function (value) { return value.uid; })).then(function (response) {
                var _loop_1 = function(actionResponse) {
                    var action = _this.findAction(actionResponse.action.uid);
                    isIscsiAdapterConfigurable.then(function (isConfigurable) {
                        action.isEnabled = _this.isActionEnabled(actionResponse, isConfigurable);
                    });
                    _this.actionEvaluations[actionResponse.action.uid].resolve(actionResponse);
                };
                for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
                    var actionResponse = response_1[_i];
                    _loop_1(actionResponse);
                }
            });
        }
        AdapterActionsBuilder.prototype.initActions = function (actionsConst) {
            return [{
                    uid: actionsConst.ENABLE_SW_ISCSI_ADAPTER,
                    propertyViewActionDef: {
                        title: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.button.labelEnable"),
                        isEnabled: true,
                        clickHandler: this.getInvokeActionFunction(actionsConst.ENABLE_SW_ISCSI_ADAPTER)
                    }
                }, {
                    uid: actionsConst.DISABLE_SW_ISCSI_ADAPTER,
                    propertyViewActionDef: {
                        title: this.i18nService.getString("StorageUi", "storage.adapters.iscsi.button.labelDisable"),
                        isEnabled: true,
                        clickHandler: this.getInvokeActionFunction(actionsConst.DISABLE_SW_ISCSI_ADAPTER)
                    }
                }, {
                    uid: actionsConst.EDIT_AUTH_SETTINGS,
                    propertyViewActionDef: {
                        title: this.i18nService.getString('StorageUi', 'generalEditAction.label'),
                        isEnabled: true,
                        clickHandler: this.getInvokeActionFunction(actionsConst.EDIT_AUTH_SETTINGS)
                    }
                }, {
                    uid: actionsConst.EDIT_GENERAL_SETTINGS,
                    propertyViewActionDef: {
                        title: this.i18nService.getString('StorageUi', 'generalEditAction.label'),
                        isEnabled: true,
                        clickHandler: this.getInvokeActionFunction(actionsConst.EDIT_GENERAL_SETTINGS)
                    }
                }];
        };
        AdapterActionsBuilder.prototype.isActionEnabled = function (actionResponse, isIscsiAdapterConfigurable) {
            if (actionResponse.action.uid === this.hostStorageConstants.adapterDetailsAction.EDIT_GENERAL_SETTINGS) {
                return actionResponse.available && isIscsiAdapterConfigurable;
            }
            return actionResponse.available;
        };
        AdapterActionsBuilder.prototype.getInvokeActionFunction = function (actionUid) {
            var _this = this;
            return function () {
                if (_this.actionEvaluations[actionUid]) {
                    var defferedResponse_1 = _this.$q.defer();
                    _this.actionEvaluations[actionUid].promise.then(function (actionEval) {
                        _this.actionsService.invokeAction(actionEval, {
                            adapter: _this.adapter,
                            callback: function (response) { return defferedResponse_1.resolve(response); }
                        });
                    });
                    return defferedResponse_1.promise;
                }
                return _this.$q.reject();
            };
        };
        AdapterActionsBuilder.prototype.findAction = function (actionUid) {
            return _.find(this.ACTIONS, function (item) { return item.uid === actionUid; }).propertyViewActionDef;
        };
        AdapterActionsBuilder.prototype.setEnableActionSuccess = function (callback) {
            this.setActionClickHandler(this.hostStorageConstants.adapterDetailsAction.ENABLE_SW_ISCSI_ADAPTER, callback);
            return this;
        };
        AdapterActionsBuilder.prototype.setDisableActionSuccess = function (callback) {
            this.setActionClickHandler(this.hostStorageConstants.adapterDetailsAction.DISABLE_SW_ISCSI_ADAPTER, callback);
            return this;
        };
        AdapterActionsBuilder.prototype.setActionClickHandler = function (actionUid, callback) {
            var _this = this;
            var action = this.findAction(actionUid);
            action.clickHandler = function () {
                _this.getInvokeActionFunction(actionUid)().then(function (response) {
                    if (response && !response.error) {
                        callback();
                    }
                });
            };
        };
        return AdapterActionsBuilder;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageAdapterActionsService", StorageAdapterActionsService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    angular.module("com.vmware.vsphere.client.storage").constant("storageAdapterConstants", {
        constraints: {
            HW_CHAP_NAME_MAX: 255,
            SW_CHAP_NAME_MAX: 511,
            HW_CHAP_SECRET_MAX: 100,
            SW_CHAP_SECRET_MAX: 255
        },
        authentication: {
            PROHIBITED: "chapProhibited",
            DISCOURAGED: "chapDiscouraged",
            PREFERRED: "chapPreferred",
            REQUIRED: "chapRequired",
            MUTUAL: "MUTUAL"
        },
        // Use unicode character for bullet so that we display characters in password fields.
        EXISTING_PASSWORD_PLACEHOLDER: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageAdaptersDevicesDetailsViewController', StorageAdaptersDevicesDetailsViewController);

   StorageAdaptersDevicesDetailsViewController.$inject = [
      '$scope',
      'hostStorageService',
      'navigation'
   ];

   function StorageAdaptersDevicesDetailsViewController($scope, hostStorageService, navigationService) {
      var self = this;
      self.storageDevicesLoading = false;
      self.hostId = navigationService.getRoute().objectId;
      // View id for persisting column definitions state.
      self.viewId = navigationService.getRoute().extensionId + '_devices';

      self.cache = {};

      $scope.$watch(function() { return $scope.masterDetailsViewContext.selectedItem; },
         function(newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
               self.refresh();
            }
         });

      function getSelectedAdapterKey() {
         if (!$scope.masterDetailsViewContext.selectedItem) {
            return null;
         }

         return $scope.masterDetailsViewContext.selectedItem.key;
      }

      self.refresh = function() {
         var adapterKey = getSelectedAdapterKey();
         if (!adapterKey) {
            return;
         }

         var hostId = self.hostId;
         var cacheId = hostId + '-' + adapterKey;

         if (self.cache.hasOwnProperty(cacheId)) {
            self.devices = self.cache[cacheId];
         } else {
            self.storageDevicesLoading = true;
         }

         hostStorageService.retrieveStorageDevicesData(hostId, adapterKey).then(
            function(devices) {
               self.cache[cacheId] = devices;
               if (hostId !== self.hostId || adapterKey !== getSelectedAdapterKey()) {
                  return;
               }
               self.devices = devices;
            })
            .finally(function () {
               if (hostId !== self.hostId || adapterKey !== getSelectedAdapterKey()) {
                  return;
               }
               self.storageDevicesLoading = false;
            });
      };

      // Request storage devices after the grid is initialized.
      self.refresh();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'StorageAdaptersGeneralDetailsViewController', StorageAdaptersGeneralDetailsViewController);

   StorageAdaptersGeneralDetailsViewController.$inject = [
      'i18nService',
      '$scope',
      'vxPropertyViewService',
      'dataService',
      'hostStorageConstants',
      'navigation',
      'storageAdapterActionsService'
   ];

   function StorageAdaptersGeneralDetailsViewController (
         i18nService, $scope, vxPropertyViewService, dataService, hostStorageConstants,
         navigation, storageAdapterActionsService
   ) {
      var FCOE_CONFIG_PROPERTY = 'storageadapter:fcoeConfig';
      var self = this;
      var hostId = navigation.getRoute().objectId;

      $scope.$watch(function () {
         return $scope.masterDetailsViewContext.selectedItem;
      }, function (newValue, oldValue) {
         if (newValue !== oldValue) {
            reloadAdapterProperties();
         }
      });

      reloadAdapterProperties();

      function getSelectedItem () {
         return $scope.masterDetailsViewContext && $scope.masterDetailsViewContext.selectedItem;
      }

      function reloadAdapterProperties () {
         var adapter = getSelectedItem();
         if (!adapter) {
            return;
         }

         // Request additional properties for FCOE.
         if (adapter.type === hostStorageConstants.hostAdapterTypes.FCOE) {
            self.loading = true;
            var fcoeNicNameProperty = {
               propertyParams: [{
                  propertyName: FCOE_CONFIG_PROPERTY,
                  parameterType: 'java.lang.String',
                  parameter: adapter.underlyingNic
               }]
            };

            dataService.getProperties(hostId, [FCOE_CONFIG_PROPERTY], fcoeNicNameProperty).then(
                  function (resp) {
                     buildPropertyView({
                        adapter: adapter,
                        fcoeConfig: resp[FCOE_CONFIG_PROPERTY]
                     });
                  }, function () {
                     buildPropertyView({ adapter: adapter });
                  }).finally(function () {
               self.loading = false;
            });

         } else if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI) {
            buildPropertyView({
               adapter: adapter,
               hostId: hostId
            });
         } else {
            buildPropertyView({ adapter: adapter });
         }
      }

      function disableStorageAdapterClickHandler () {
         var warningMessagesManager = $scope.masterDetailsViewContext.alertMessenger;
         warningMessagesManager.addRestartMessage(getSelectedItem().key);
      }

      function enableStorageAdapterClickHandler () {
         var warningMessagesManager = $scope.masterDetailsViewContext.alertMessenger;
         warningMessagesManager.removeRestartMessage(getSelectedItem().key);
      }

      function buildPropertyView (options) {
         var adapter = options.adapter;
         if (!adapter) {
            return;
         }

         var adapterStatus;
         var isAdapterEnabled = true;
         if (adapter.type === hostStorageConstants.hostAdapterTypes.FCOE) {
            isAdapterEnabled = !adapter.isMarkedForRemoval;
            adapterStatus = isAdapterEnabled
                  ? i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.enabled')
                  : i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.disabled');
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI
               && adapter.isSoftwareBased && adapter.canBeDisabled) {
            isAdapterEnabled = $scope.masterDetailsViewContext.hostAdaptersData.isIScsiEnabledOnHost === true;
            adapterStatus = isAdapterEnabled
                  ? i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.enabled')
                  : i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.disabled');
         }

         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var categoryBuilder = builder.category(
               i18nService.getString('StorageUi', 'storage.devices.properties.generalHeader'), 0);

         var adapterActionDefinitions = storageAdapterActionsService
               .getBuilder(hostId, adapter)
               .setEnableActionSuccess(enableStorageAdapterClickHandler)
               .setDisableActionSuccess(disableStorageAdapterClickHandler);

         var enableDisableAdapterActionDef = adapterActionDefinitions.findAction(isAdapterEnabled
               ? "vsphere.core.host.actions.adapters.disableSoftwareIscsiAdapter"
               : "vsphere.core.host.actions.adapters.enableSoftwareIscsiAdapter");

         if (adapterStatus) {
            categoryBuilder.section('adapterStatus')
                  .title(i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.sectionHeader'))
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.iscsi.status.label'),
                        adapterStatus)
                  .action(enableDisableAdapterActionDef);
         }

         var generalSectionBuilder = categoryBuilder.section('generalSection')
               .title(i18nService.getString(
                     'StorageUi', 'storage.devices.properties.generalHeader'))
               .property(
                     i18nService.getString('StorageUi', 'storage.adapters.deviceName'),
                     adapter.device)
               .property(
                     i18nService.getString('StorageUi', 'storage.adapters.deviceModel'),
                     adapter.model);


         if (adapter.type === hostStorageConstants.hostAdapterTypes.FIBRECHANNEL ||
               adapter.type === hostStorageConstants.hostAdapterTypes.FCOE) {
            generalSectionBuilder
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.general.wwnn'),
                        adapter.formattedNodeWorldWideName)
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.general.wwpn'),
                        adapter.formattedPortWorldWideName);
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI) {
            var generalEditActionDefinition = adapterActionDefinitions.findAction("vsphere.core.host.actions.adapters.editIscsiGeneralSettings");
            generalSectionBuilder
                  .action(generalEditActionDefinition);
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.FCOE) {
            categoryBuilder.section('fcoeNetworkProperties')
                  .title(i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.sectionHeader'))
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.networkAdapter'),
                        adapter.underlyingNic)
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.vlanId'),
                        adapter.linkInfo ? adapter.linkInfo.vlanId : '')
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.priorityClass'),
                        options.fcoeConfig ? options.fcoeConfig.priorityClass : '')
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.vnPortMac'),
                        adapter.linkInfo ? adapter.linkInfo.vnportMac : '')
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netProps.fcfMac'),
                        adapter.linkInfo ? adapter.linkInfo.fcfMac : '');
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI) {
            generalSectionBuilder
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.general.iscsiName'),
                        adapter.iScsiName)
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.general.iscsiAlias'),
                        adapter.iScsiAlias)
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.general.iscsiTargets'),
                        adapter.formattedDiscoveryProperties);
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI
               && adapter.isSoftwareBased === false) {
            categoryBuilder.section('networkInterface')
                  .title(i18nService.getString('StorageUi', 'storage.adapters.properties.netInt.sectionHeader'))
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netInt.currentMaximumSpeed'),
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netInt.currentMaximumSpeedValueString',
                              adapter.currentSpeedInMbit, adapter.maxSpeedInMbit))
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.netInt.macAddress'),
                        adapter.macAddress);
         }

         if (adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI) {
            categoryBuilder.section('authenticationSection')
                  .title(i18nService.getString(
                        'StorageUi', 'storage.adapters.properties.authentication.sectionHeader'))
                  .property(
                        i18nService.getString('StorageUi', 'storage.adapters.properties.authentication.method'),
                        adapter.localizedAuthenticationMethod)
                  .action(adapterActionDefinitions.findAction("vsphere.core.host.actions.adapters.editIscsiAuthenticationSettings"));
         }

         self.propertyViewData = builder.build();
      }
   }
})();

var storage_ui;
(function (storage_ui) {
    var StorageAdaptersNetworkSettingsController = (function () {
        function StorageAdaptersNetworkSettingsController(dataService, i18nService, navigation, $scope, propertyViewService, hostStorageConstants, hostConnectionState, modalService) {
            var _this = this;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.navigation = navigation;
            this.$scope = $scope;
            this.propertyViewService = propertyViewService;
            this.hostStorageConstants = hostStorageConstants;
            this.hostConnectionState = hostConnectionState;
            this.modalService = modalService;
            this.NETWORK_SETTINGS_PROPERTY = "storageadapter:networkSettings";
            this.isHostAvailable = function () {
                var hostId = _this.navigation.getRoute().objectId;
                var hostConnectionState = _this.hostConnectionState;
                return _this.dataService.getProperties(hostId, ["runtime"]).then(function (data) {
                    var runtime = data.runtime;
                    return runtime.connectionState === hostConnectionState.CONNECTED && !runtime.inMaintenanceMode;
                });
            };
            this.loadData = function () {
                var self = _this;
                var hostId = _this.navigation.getRoute().objectId;
                var adapterKey = _this.$scope.masterDetailsViewContext.selectedItem.key;
                _this.dataService.getProperties(hostId, [_this.NETWORK_SETTINGS_PROPERTY], {
                    propertyParams: [{
                            propertyName: _this.NETWORK_SETTINGS_PROPERTY,
                            parameterType: "java.lang.String",
                            parameter: adapterKey
                        }]
                })
                    .then(function (response) {
                    if (response[_this.NETWORK_SETTINGS_PROPERTY]) {
                        self.buildPropertyView(response[_this.NETWORK_SETTINGS_PROPERTY]);
                    }
                })
                    .finally(function () {
                    self.loading = false;
                });
            };
            this.i18n = i18nService;
            var release = $scope.$watch(function () { return _this.$scope.masterDetailsViewContext.selectedItem; }, this.loadData);
            $scope.$on("$destroy", function () {
                release();
            });
        }
        StorageAdaptersNetworkSettingsController.prototype.buildPropertyView = function (model) {
            var _this = this;
            var self = this;
            var adapter = this.$scope.masterDetailsViewContext.selectedItem;
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var i18n = function (key) { return _this.i18nService.getString("StorageUi", key); };
            var notSupported = i18n("storage.adapters.properties.notSupportedLabel");
            var notEnabled = i18n("storage.adapters.properties.notEnabledLabel");
            var section = builder.category("category").section("general")
                .title(i18n("storage.adapters.properties.ipDnsConfig.sectionHeader"));
            if (adapter.type === this.hostStorageConstants.hostAdapterTypes.ISCSI) {
                this.isHostAvailable().then(function (isHostAvailable) {
                    section
                        .action({
                        title: _this.i18nService.getString("StorageUi", "generalEditAction.label"),
                        isEnabled: isHostAvailable,
                        clickHandler: function () {
                            var hostId = self.navigation.getRoute().objectId;
                            self.modalService.open(hostId, adapter, model);
                        }
                    });
                });
            }
            // IPv4
            if (!model.isIpv4Supported) {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipAddress"), notSupported);
            }
            else if (!model.isIpv4Enabled) {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipAddress"), notEnabled);
            }
            else {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipAddress"), model.ipv4Address)
                    .property(i18n("storage.adapters.properties.ipDnsConfig.subnetMask"), model.ipv4SubnetMask)
                    .property(i18n("storage.adapters.properties.ipDnsConfig.defaultGateway"), model.ipv4DefaultGateway);
            }
            // IPv6
            if (!model.isIpv6Supported) {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipV6Address"), notSupported);
            }
            else if (!model.isIpv6Enabled) {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipV6Address"), notEnabled);
            }
            else {
                section.property(i18n("storage.adapters.properties.ipDnsConfig.ipV6Address"), model.ipv6Address);
                section.property(i18n("storage.adapters.properties.ipDnsConfig.defaultGatewayV6"), model.ipv6DefaultGateway);
            }
            // DNS
            section.property(i18n("storage.adapters.properties.ipDnsConfig.preferredDns"), model.isPreferedDnsSupported ? model.preferedDns : notSupported).property(i18n("storage.adapters.properties.ipDnsConfig.alternateDns"), model.isAlternateDnsSupported ? model.alternateDns : notSupported);
            this.networkSettings = builder.build();
        };
        StorageAdaptersNetworkSettingsController.$inject = [
            "dataService",
            "i18nService",
            "navigation",
            "$scope",
            "vxPropertyViewService",
            "hostStorageConstants",
            "hostConnectionState",
            "storageAdapterEditNetworkSettingsDialogService"
        ];
        return StorageAdaptersNetworkSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.storage").controller("StorageAdaptersNetworkSettingsController", StorageAdaptersNetworkSettingsController);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageAdaptersPathsDetailsViewController', StorageAdaptersPathsDetailsViewController);

   StorageAdaptersPathsDetailsViewController.$inject = [
      '$scope',
      'hostStorageService',
      'navigation'
   ];

   function StorageAdaptersPathsDetailsViewController($scope, hostStorageService, navigation) {
      var self = this;
      self.loading = false;
      self.hostId = navigation.getRoute().objectId;
      // View id for persisting column definitions state.
      self.viewId = navigation.getRoute().extensionId + '_paths';

      self.cache = {};

      $scope.$watch(function() { return $scope.masterDetailsViewContext.selectedItem; },
         function(newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
               self.refresh();
            }
         });

      function getSelectedAdapterKey() {
         if (!$scope.masterDetailsViewContext.selectedItem) {
            return null;
         }

         return $scope.masterDetailsViewContext.selectedItem.key;
      }

      self.refresh = function() {
         var adapterKey = getSelectedAdapterKey();
         if (!adapterKey) {
            return;
         }

         var hostId = self.hostId;
         var cacheId = hostId + '-' + adapterKey;

         if (self.cache.hasOwnProperty(cacheId)) {
            self.paths = self.cache[cacheId];
         } else {
            self.loading = true;
         }

         hostStorageService.retrieveHostStorageAdapterPathsData(hostId, adapterKey)
            .then(function(adapterPaths) {
               self.cache[cacheId] = adapterPaths;
               if (self.hostId !== hostId || getSelectedAdapterKey() !== adapterKey) {
                  return;
               }
               self.paths = adapterPaths;
            })
            .finally(function() {
               if (self.hostId !== hostId || getSelectedAdapterKey() !== adapterKey) {
                  return;
               }
               self.loading = false;
            });
      };

      self.refresh();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageAdaptersViewController', StorageAdaptersViewController);

   StorageAdaptersViewController.$inject = ['i18nService',
      '$scope',
      'vuiConstants',
      'dataService',
      'columnRenderersRegistry',
      'storageUtil',
      'defaultUriSchemeUtil',
      'datagridActionBarService',
      'navigation',
      'hostStorageConstants'];

   function StorageAdaptersViewController(i18nService, $scope, vuiConstants, dataService,
         columnRenderersRegistry, storageUtil, defaultUriSchemeUtil,
         datagridActionBarService, navigation, hostStorageConstants) {

      var ISCSI_ADAPTER_TYPE = i18nService.getString('StorageUi', 'storage.adapters.type.ISCSI');
      var ACTIONS = {
         REFRESH_STORAGE_SYSTEM : 'vsphere.core.host.actions.refreshStorageSystem',
         RESCAN_HBA : 'vsphere.core.host.actions.rescanHba',
         ADD_ADAPTER: 'vsphere.core.host.actions.adapters.addSoftwareAdapter',
         RESCAN_ADAPTERS: 'vsphere.core.host.actions.rescanHost'
      };

      var storageAdaptersProperty = "storageadapter:hostStorageAdapters";
      var isHostConnectedProperty = "isHostConnectedAndPoweredOn";

      var self = this;
      self.hostId = navigation.getRoute().objectId;
      self.headerOptions = {
            title: i18nService.getString('StorageUi', 'storage.adapters.header'),
            objectId: self.hostId,
            actions: []
      };
      self.storageAdaptersLoading = false;

      self.liveRefreshProperties = [
         'config.storageDevice.hostBusAdapter',
         'config.storageDevice.softwareInternetScsiEnabled',
         'config.storageDevice.scsiTopology.adapter',
         'config.storageDevice.plugStoreTopology.adapter',
         'config.firewall.ruleset',
         'config.storageDevice.scsiLun',
         'config.storageDevice',
         'config.storageDevice.plugStoreTopology.device',
         'config.storageDevice.multipathInfo.lun',
         'config.storageDevice.plugStoreTopology.target',
         'config.fileSystemVolume.mountInfo',
         'config.multipathState.path'
      ];

      $scope.preselectComparator = function(gridDataItem) {
         if($scope.masterDetailsViewContext && $scope.masterDetailsViewContext.selectedItems &&
            $scope.masterDetailsViewContext.selectedItems.length === 1) {
            return $scope.masterDetailsViewContext.selectedItems[0].key === gridDataItem.key;
         }
         return false;
      };

      self.rescanWarningMessages = [];

      $scope.masterDetailsViewContext.alertMessenger =
            $scope.masterDetailsViewContext.alertMessenger || new AlertMessenger(i18nService.getString);

      var unregisterRescanCompletedHandler = $scope.$on('vsphere.core.host.actions.rescan.completed', function (event, args) {
         if (args && args.rescanSpec && args.rescanSpec.rescanHbas) {
            // If the user did rescan all the HBA on host/cluster/dc/folder
            if (args.affectedHosts && args.affectedHosts.length) {
               for (var i = 0; i < args.affectedHosts.length; i++) {
                  // And the current hosts HBA are rescanned as result
                  if (defaultUriSchemeUtil.compareIds(args.affectedHosts[i], self.hostId)) {
                     // Clear all the warnings.
                     $scope.masterDetailsViewContext.alertMessenger.removeRescanMessages();
                     break;
                  }
               }
            }

         }
      });

      $scope.$on('$destroy', function () {
         unregisterRescanCompletedHandler();
      });

      self.clearWarning = function () {
         $scope.masterDetailsViewContext.alertMessenger.removeMessages();
      };

      $scope.$watch(function () {
         return $scope.masterDetailsViewContext.alertMessenger.getMessages();
      }, function () {
         // Re-render the datagrid so that it will resize and update the warning icons
         self.datagridOptions.data = self.datagridOptions.data.slice(0);

         if ($scope.masterDetailsViewContext.alertMessenger) {
            self.rescanWarningMessages = $scope.masterDetailsViewContext.alertMessenger.getMessages();
         }
      }, true);

      self.refresh = function() {
         self.storageAdaptersLoading = true;
         dataService.getProperties(self.hostId, [storageAdaptersProperty, isHostConnectedProperty])
               .then(function(storageAdaptersResponse) {
                  var storageAdapters =
                        (storageAdaptersResponse[storageAdaptersProperty] &&
                              storageAdaptersResponse[storageAdaptersProperty].adapters)
                                    ? storageAdaptersResponse[storageAdaptersProperty].adapters
                                    : [];

                  storageAdapters.forEach(function (item) {
                     if (item.type) {
                        item.localizedType = i18nService.getString('StorageUi', 'storage.adapters.type.' + item.type);
                        item.isIscsiAdapter = (item.localizedType === ISCSI_ADAPTER_TYPE);
                        if (item.isIscsiAdapter) {
                           item.portBindableIScsi = item.isSoftwareBased;
                        }
                     }
                     if (item.status) {
                        item.localizedStatus = i18nService.getString('StorageUi', 'storage.adapters.status.' + item.status);
                     }

                  });
                  self.datagridOptions.data = storageAdapters;
                  $scope.masterDetailsViewContext.hostAdaptersData = storageAdaptersResponse[storageAdaptersProperty];
                  $scope.masterDetailsViewContext.isHostConnected = storageAdaptersResponse[isHostConnectedProperty];

                  updateActionBar();

               })
               .finally(function() {
                  self.storageAdaptersLoading = false;
               });
      };

      self.datagridOptions = {
         height: '100%',
         columnDefs: getColumnDefinitions(),
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         groupOrder: [{
            field: 'model'
         }],
         data: [],
         vuiFooter: {
            showCopy : true
         },
         selectedItems: [],
         resizable: true,
         actionBarOptions: {actions: []}
      };

      $scope.$watch(function() {
         return self.datagridOptions.selectedItems;
      }, function(newValue, oldValue) {
         if (!newValue || !newValue.length || !oldValue || !oldValue.length) {
            $scope.masterDetailsViewContext.selectedItems = newValue;
         }
         if (newValue[0] !== oldValue[0]) {
            $scope.masterDetailsViewContext.selectedItems = newValue;
            updateActionBar();
         }
      });

      function updateActionBar() {
         return datagridActionBarService.updateActionBar(self.datagridOptions, [self.hostId], [
            {
               actionId: ACTIONS.ADD_ADAPTER,
               getActionInvocationContext: function() {
                  return {
                     callback: function(isSwBasedIscsiAdapter) {
                        var adapter = findAdapter(isSwBasedIscsiAdapter);
                        if (adapter) {
                           $scope.masterDetailsViewContext.alertMessenger.removeRestartMessage(adapter.key);
                        }
                     }
                  };
               }
            },
            {
               actionId: ACTIONS.REFRESH_STORAGE_SYSTEM,
               getActionInvocationContext: function() {
                  return {
                     callback: function() {
                        self.refresh();
                     }
                  };
               }
            },
            {
               actionId: ACTIONS.RESCAN_ADAPTERS
            },
            vuiConstants.actions.SEPARATOR,
            {
               actionId: ACTIONS.RESCAN_HBA,
               isActionAvailable: function(actionDef) {
                  return actionDef.available && self.datagridOptions.selectedItems.length > 0;
               },
               getActionInvocationContext: function() {
                  if (self.datagridOptions.selectedItems.length > 0) {
                     var adapterKey = self.datagridOptions.selectedItems[0].key;
                     return {
                        adapterKey: adapterKey,
                        callback: function () {
                           $scope.masterDetailsViewContext.alertMessenger.removeRescanMessage(adapterKey);
                        }
                     };
                  }
                  return {};
               }
            }
         ]);
      }

      function findAdapter(isSwBasedIscsiAdapter) {
         return _.find(self.datagridOptions.data, function(adapter) {
            var iscsi = isSwBasedIscsiAdapter && adapter.type === hostStorageConstants.hostAdapterTypes.ISCSI && adapter.isSoftwareBased;
            var fcoe = !isSwBasedIscsiAdapter && adapter.type === hostStorageConstants.hostAdapterTypes.FIBRECHANNEL;
            return iscsi || fcoe;
         });
      }

      function getColumnDefinitions() {
         return [
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.adapter'),
               field: 'device',
               width: '150px',
               template: deviceRenderer()
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.deviceModel'),
               field: 'model',
               width: '250px',
               visible: false,
               template: '#:model#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.type'),
               field: 'localizedType',
               width: '80px',
               template: '#:localizedType#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.status'),
               field: 'localizedStatus',
               width: '80px',
               template: '#:localizedStatus#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.wwn'),
               field: 'identifier',
               width: '210px',
               template: '#:identifier#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.numberTargets'),
               field: 'numberOfTargets',
               type: 'number',
               width: '70px',
               sortable: function(cti1, cti2) {
                  return storageUtil.compareNumericValues(cti1, cti2, 'numberOfTargets');
               },
               template: '#:numberOfTargets#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.numberDevices'),
               field: 'numberOfDevices',
               type: 'number',
               width: '70px',
               sortable: function(cti1, cti2) {
                  return storageUtil.compareNumericValues(cti1, cti2, 'numberOfDevices');
               },
               template: '#:numberOfDevices#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'storage.adapters.numberPaths'),
               field: 'numberOfPaths',
               type: 'number',
               width: '65px',
               sortable: function(cti1, cti2) {
                  return storageUtil.compareNumericValues(cti1, cti2, 'numberOfPaths');
               },
               template: '#:numberOfPaths#'
            }
         ];
      }

      function deviceRenderer() {
         return (function (data) {
            var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('icon-text-ex');
            var rendererConfig = { icon: [ 'vsphere-icon-scsi-adapter'] };
            if ($scope.masterDetailsViewContext.alertMessenger.isMessageAvailable(data.key)) {
               rendererConfig.icon = 'vsphere-icon-scsi-adapter-warning';
            }
            return objectLinkRenderer(['device'], data, rendererConfig);
         });
      }

      function AlertMessenger(stringFn) {
         var getString = stringFn;

         var RESCAN_TYPE = 'rescan';
         var RESTART_TYPE = 'restart';

         var messageStrings = {};
         messageStrings[RESCAN_TYPE] = {
            single: 'storage.adapters.warning.rescanNeeded',
            multiple: 'storage.adapters.warning.rescanNeededMulti'
         };
         messageStrings[RESTART_TYPE] = 'storage.adapters.iscsi.warning';

         var messages = [];

         return {
            addRescanMessage: function(key, adapterName) {
               return addMessage(
                     getString('StorageUi', messageStrings[RESCAN_TYPE].single, adapterName),
                     key,
                     RESCAN_TYPE);
            },
            addRestartMessage: function(key) {
               return addMessage(
                     getString('StorageUi', messageStrings[RESTART_TYPE]),
                     key,
                     RESTART_TYPE);
            },
            removeMessages: function() {
               messages = [];
            },
            removeRescanMessages: function() {
               messages = _.filter(messages, function(msg) {
                  return msg.type !== RESCAN_TYPE;
               });
            },
            removeRescanMessage: function(key) {
               removeMessage(key, RESCAN_TYPE);
            },
            removeRestartMessage: function(key) {
               removeMessage(key, RESTART_TYPE);
            },
            getMessages: function() {
               var rescanMessages = computeRescanMessages();
               var restartMessages = computeRestartMessages();
               return [].concat(rescanMessages, restartMessages);
            },
            isMessageAvailable: function(key) {
               return !_.isUndefined(
                     _.find(messages, function(m) {
                        return key === m.key;
                     })
               );
            }
         };

         function getTextMessages(msgs) {
            return _.map(msgs, function(msg) {
               return msg.text;
            });
         }

         function computeRescanMessages() {
            var rescanMessages = _.filter(messages, function(msg) {
               return msg.type === RESCAN_TYPE;
            });
            if (rescanMessages.length > 1) {
               return [getString('StorageUi',
                  messageStrings[RESCAN_TYPE].multiple)];
            } else if (rescanMessages.length === 1) {
               return getTextMessages(rescanMessages);
            }
            return [];
         }

         function computeRestartMessages() {
            var restartMessages = _.filter(messages, function(msg) {
               return msg.type === RESTART_TYPE;
            });
            if (restartMessages.length >= 1) {
               return [getString('StorageUi',
                  messageStrings[RESTART_TYPE])];
            }
            return [];
         }

         function addMessage(msg, key, type) {
            var isTypedMessageForKeyAvailable = _.find(messages, function(msg) {
               return msg.type === type && msg.key === key;
            });
            if (!isTypedMessageForKeyAvailable) {
               messages.push({
                  text: msg,
                  type: type,
                  key: key
               });
               return true;
            }
            return false;
         }

         function removeMessage(key, type) {
            var index = _.findIndex(messages, function(m) {
               return key === m.key && m.type === type;
            });
            if (index > -1) {
               messages.splice(index, 1);
            }
         }
      }

      self.refresh();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    *  Helper for opening the "Add ISCSI target dialog".
    */
   angular
         .module('com.vmware.vsphere.client.storage')
         .service('AddIscsiTargetDialogService', AddIscsiTargetDialogService);

   AddIscsiTargetDialogService.$inject = [
      'clarityModalService',
      'clarityConstants',
      'i18nService',
      'adapterTargetsService',
      'storageValidationService',
      'ipParserService',
      'storageAdapterConstants',
      'storageAdapterEditAuthenticationSpecBuilderService',
      'vxValidatorFactory'];

   function AddIscsiTargetDialogService (
      clarityModalService,
      clarityConstants,
      i18nService,
      adapterTargetsService,
      storageValidationService,
      ipParserService,
      storageAdapterConstants,
      authSpecBuilderService,
      vxValidatorFactory
   ) {
      // ======================= Public API ==========================

      return {
         openAddIscsiTargetDialog: openAddIscsiTargetDialog
      };

      //======================= Public Functions ==========================

      /**
       * Opens an OK/Cancel modal dialog in the application.
       */
      function openAddIscsiTargetDialog(adapter, hostId, dynamicTarget, existingTargets, invocationContext) {

         var title = i18nService.getString(
               'StorageUi',
               dynamicTarget
                     ? 'storage.adapters.iscsiTargets.actions.addSend.h5header'
                     : 'storage.adapters.iscsiTargets.actions.addStatic.h5header');
         var DEFAULT_TARGET_PORT = 3260;
         var authSettingsComponentApi = {};

         var modalOptions = {
            title: title,
            subTitle: {
               text: adapter.device
            },
            defaultButton: 'submit',
            alerts: [],
            dialogData: {
               adapter: adapter,
               target: {
                  server: '',
                  port: DEFAULT_TARGET_PORT,
                  targetName: !dynamicTarget ? '' : null
               },
               options: {
                  dynamicTarget: dynamicTarget,
                  PORT_MAX_VALUE: 65535,
                  PORT_MIN_VALUE: 1
               },
               authSettingsComponentApi: authSettingsComponentApi,
               inheritAuthSettings: true,
               initialAuthenticationProperties: {
                  authenticationMethod: storageAdapterConstants.authentication.PROHIBITED
               },
               validator: vxValidatorFactory.create(),
               isValidServer: function() {
                  var errors = [];
                  var serverName = modalOptions.dialogData.target.server;
                  if (!ipParserService.isIpv6AddressValid(serverName)
                           && !storageValidationService.isValidDnsName(serverName)) {
                     errors.push(i18nService.getString('StorageUi','storage.adapters.edit.authentication.form.invalidSendAddress'));
                  }

                  return errors;
               },
               isValidPort: function() {
                  var errors = [];
                  if (!storageValidationService.isValidPort(modalOptions.dialogData.target.port)) {
                        errors.push(i18nService.getString(
                           'StorageUi','storage.adapters.iscsiTargets.add.form.error.invalidPort.text',
                           modalOptions.dialogData.options.PORT_MIN_VALUE,
                           modalOptions.dialogData.options.PORT_MAX_VALUE));
                     }

                  return errors;
               }
            },
            contentTemplate: 'storage-ui/resources/storage/views/host/adapters/targets/AddIscsiTargetDialog.html',
            onSubmit: onSubmit
         };

         clarityModalService.openOkCancelModal(modalOptions);

         function onSubmit () {
            if (!validate()){
               return false;
            }
            if (modalOptions.dialogData.target.server && !isNaN(modalOptions.dialogData.target.port) &&
               (dynamicTarget || modalOptions.dialogData.target.targetName)) {

               var authSettings = authSettingsComponentApi.getSettings();

               var authenticationProperties =
                  authSpecBuilderService.buildAuthenticationPropertiesForTarget(
                     modalOptions.dialogData.inheritAuthSettings,
                     authSettings.authMethodSelected,
                     authSettings.outgoing,
                     authSettings.incoming,
                     '');

               var addResult = adapterTargetsService.addIscsiAdapterTargets(hostId, dynamicTarget,
                  adapter.device, modalOptions.dialogData.target.port,
                  modalOptions.dialogData.target.server, modalOptions.dialogData.target.targetName, authenticationProperties);

               addResult.then(function (result) {
                  if (result && result.effect && result.effect.affectedEntites
                        && result.effect.affectedEntites.length) {
                     // Notify that add is performed
                     if (invocationContext && invocationContext.callback) {
                        invocationContext.callback(result, adapter);
                     }
                  }
               });

               return true;
            }

            return false;
         }

         function validate () {
            var isValid = true;

            var errors = modalOptions.dialogData.validator.validate();
            if (errors && errors.length) {
               displayErrorMessage('form.validationError');
               isValid = false;
            }

            if (targetAlreadyExists()) {
               displayErrorMessage('storage.adapters.edit.authentication.form.targetExists');
               isValid = false;
            }

            if(!modalOptions.dialogData.inheritAuthSettings) {
               var authValidationResult = modalOptions.dialogData.authSettingsComponentApi.validate();
               if (!authValidationResult.isValid) {
                  if (isValid) {
                     if (authValidationResult.errors && authValidationResult.errors.length) {
                        displayAuthenticationErrorMessage(authValidationResult.errors);
                     } else {
                        displayErrorMessage('form.validationError');
                     }
                  }

                  isValid = false;
               }
            }

            return isValid;
         }

         function targetAlreadyExists () {
            var targetToAdd = modalOptions.dialogData.target;
            return _.some(existingTargets, function(target) {
               var attrs = target.address.split(':');
               return targetToAdd.server === attrs[0]
                  && targetToAdd.port === Number(attrs[1])
                  && (dynamicTarget || target.name === targetToAdd.targetName);
            });
         }

         function displayAuthenticationErrorMessage(errors) {
            modalOptions.alerts = _.map(errors, function(error) {
               return {
                  text: error,
                  type: clarityConstants.notifications.type.ERROR
               };
            });
         }

         function displayErrorMessage (msgKey) {
            var alertMessage = {
               text: i18nService.getString('StorageUi', msgKey),
               type: clarityConstants.notifications.type.ERROR
            };
            if (modalOptions.alerts.length > 0) {
               modalOptions.alerts = [];
            }
            modalOptions.alerts = [alertMessage];
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'IscsiTargetsDetailsViewController', IscsiTargetsDetailsViewController);

   IscsiTargetsDetailsViewController.$inject = [
      '$scope',
      'adapterTargetsService',
      'i18nService',
      'navigation'
   ];

   function IscsiTargetsDetailsViewController(
      $scope, adapterTargetsService, i18nService, navigation) {
      var self = this;
      self.loading = false;

      self.hostId = navigation.getRoute().objectId;

      $scope.$watch(function() { return $scope.masterDetailsViewContext.selectedItem; },
         function(newValue, oldValue) {
            if (newValue !== oldValue && newValue && newValue.isIscsiAdapter) {
               self.refresh();
            }
         });

      self.targetsUpdatedCallback = function (result, adapter) {
         if (result && !result.error && adapter) {
            $scope.masterDetailsViewContext.alertMessenger.addRescanMessage(
                  adapter.key,
                  adapter.device
            );
         }
      };

      self.refresh = function() {
         if (!$scope.masterDetailsViewContext.selectedItem) {
            return;
         }

         self.loading = true;
         self.adapter = $scope.masterDetailsViewContext.selectedItem;

         var adapterKey = $scope.masterDetailsViewContext.selectedItem.key;
         adapterTargetsService.retrieveIscsiAdapterTargets(self.hostId, adapterKey)
            .then(function(targets) {
               if (targets) {
                  self.staticTargets = targets.staticTargets ? targets.staticTargets : [];
                  self.dynamicTargets = targets.dynamicTargets ? targets.dynamicTargets : [];
                  self.hba = targets.hba;
               } else {
                  self.staticTargets = [];
                  self.dynamicTargets = [];
               }
            })
            .finally(function() {
               self.loading = false;
            });
      };

      self.refresh();
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var MultipathingPoliciesService = (function () {
        function MultipathingPoliciesService(vxPropertyViewService, dataService, hostStorageConstants, storageUtil, actionsService, $q, i18nService) {
            this.vxPropertyViewService = vxPropertyViewService;
            this.dataService = dataService;
            this.hostStorageConstants = hostStorageConstants;
            this.storageUtil = storageUtil;
            this.actionsService = actionsService;
            this.$q = $q;
            this.i18nService = i18nService;
            this.i18n = i18nService.getString.bind(this, "StorageUi");
        }
        MultipathingPoliciesService.prototype.requestPolicies = function (hostId, deviceId, requestHostPolicies, onEditInvocation) {
            var _this = this;
            var policiesPromises = {};
            policiesPromises[this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP] = this.dataService.getProperties(hostId, [
                this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP
            ], {
                propertyParams: [{
                        propertyName: this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP,
                        parameterType: "java.lang.String",
                        parameter: deviceId
                    }]
            })
                .then(function (response) {
                response = response || {};
                var multipathingInfo = response[_this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP] || {};
                return {
                    pathSelectionPolicy: multipathingInfo.pathSelectionPolicy,
                    storageArrayTypePolicy: multipathingInfo.storageArrayTypePolicy
                };
            });
            policiesPromises["editAction"] = this.actionsService.getActions([hostId], ["vsphere.core.host.actions.storageDevice.editMultipathingPolicy"])
                .then(function (actionDefs) {
                if (actionDefs && actionDefs.length && actionDefs[0].action) {
                    return {
                        title: actionDefs[0].action.label,
                        isEnabled: actionDefs[0].available,
                        clickHandler: function () {
                            return onEditInvocation(actionDefs[0]);
                        }
                    };
                }
                return null;
            });
            if (requestHostPolicies) {
                policiesPromises["hostPolicyOptions"] = this.dataService.getProperties(hostId, [
                    this.hostStorageConstants.PATH_SELECTION_POLICY_OPTIONS_PROP,
                    this.hostStorageConstants.STORAGE_ARRAY_TYPE_POLICY_OPTIONS_PROP]);
            }
            return this.$q.all(policiesPromises).then(function (response) {
                var result = {};
                if (response[_this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP]) {
                    response[_this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP].editAction = response.editAction;
                    result.multipathingInfo = response[_this.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_PROP];
                }
                if (response.hostPolicyOptions) {
                    result.hostPolicyOptions = response.hostPolicyOptions;
                }
                return result;
            });
        };
        MultipathingPoliciesService.prototype.buildMulthipathingSection = function (categoryBuilder, title, multhipathingProperties, hostPolicies, editAction) {
            // We have to populate the multipathing properties only for
            // connected hosts.
            if (multhipathingProperties && hostPolicies) {
                categoryBuilder.section("multipathingPolicies")
                    .title(title)
                    .property(this.i18n("datastore.manage.connectivity.pathSelectionPolicy"), this.storageUtil.formatPathSelectionPolicyName(multhipathingProperties.pathSelectionPolicy, hostPolicies.pathSelectionPolicyOptions))
                    .property(this.i18n("datastore.manage.connectivity.satp"), this.storageUtil.getStorageArrayTypePolicyName(multhipathingProperties.storageArrayTypePolicy, hostPolicies.storageArrayTypePolicyOptions)).action(editAction);
            }
        };
        MultipathingPoliciesService.$inject = [
            "vxPropertyViewService", "dataService", "hostStorageConstants",
            "storageUtil", "actionsService", "$q", "i18nService"];
        return MultipathingPoliciesService;
    }());
    storage_ui.MultipathingPoliciesService = MultipathingPoliciesService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("multipathingPoliciesService", MultipathingPoliciesService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ErasePartitionsDialogService = (function () {
        function ErasePartitionsDialogService(clarityModalService, i18nService, mutationService, hostStorageService) {
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.hostStorageService = hostStorageService;
            this.i18n = i18nService.getString.bind(this, "StorageUi");
        }
        ;
        ErasePartitionsDialogService.prototype.open = function (hostId, devices) {
            var title = devices.length === 1
                ? this.i18n("storage.adapters.devices.action.format.formTitle")
                : this.i18n("storage.adapters.devices.action.format.formTitleMulti");
            var modalOptions = {
                title: title,
                size: "lg",
                defaultButton: "submit",
                alerts: [],
                contentTemplate: "storage-ui/resources/storage/views/host/devices/"
                    + "erasePartitions/erasePartitionsDialog.html",
                onSubmit: this.onSubmit.bind(this, hostId, devices)
            };
            if (devices.length === 1) {
                modalOptions.subTitle = devices[0].name;
            }
            modalOptions.dialogData = {
                hostId: hostId,
                devices: devices,
                infoHeader: devices.length === 1
                    ? this.i18n("storage.adapters.devices.action.format.infoHeaderSingle")
                    : this.i18n("storage.adapters.devices.action.format.infoHeaderMulti"),
                confirmationText: devices.length === 1
                    ? this.i18n("storage.adapters.devices.action.format.confirmationSingle")
                    : this.i18n("storage.adapters.devices.action.format.confirmationMulti"),
                partitions: []
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            if (devices.length && devices.length === 1) {
                modalOptions.dialogData.isLoading = true;
                this.hostStorageService.retrieveStorageDevicePartitionData(hostId, devices[0].devicePath).then(function (result) {
                    modalOptions.dialogData.partitions = result.partitions;
                }).finally(function () {
                    modalOptions.dialogData.isLoading = false;
                });
            }
        };
        ErasePartitionsDialogService.prototype.onSubmit = function (hostId, devices) {
            this.hostStorageService.erasePartitions([{
                    hostId: hostId,
                    devices: devices
                }]);
            return true;
        };
        ErasePartitionsDialogService.$inject = ["clarityModalService", "i18nService", "mutationService",
            "hostStorageService"];
        return ErasePartitionsDialogService;
    }());
    storage_ui.ErasePartitionsDialogService = ErasePartitionsDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("erasePartitionsDialogService", ErasePartitionsDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var PartitionsListController = (function () {
        function PartitionsListController(i18nService, hostStorageService, vuiConstants, bytesFilter, storageUtil) {
            var _this = this;
            this.hostStorageService = hostStorageService;
            this.i18n = i18nService.getString.bind(this, "StorageUi");
            this.datagridOptions = {
                data: this.partitions,
                pageConfig: {
                    hidePager: false
                },
                columnDefs: [{
                        displayName: this.i18n("storage.devices.column.name"),
                        field: 'name',
                        template: function (dataItem) {
                            return _this.i18n("datastore.partitionType." + dataItem.name);
                        }
                    }, {
                        displayName: this.i18n("storage.devices.column.capacity"),
                        field: "partitionCapacity",
                        template: function (dataItem) {
                            return bytesFilter(dataItem.partitionCapacity, "B", "Auto");
                        },
                        sortable: function (item1, item2) {
                            return storageUtil.compareNumericValues(item1, item2, "partitionCapacity");
                        }
                    }, {
                        displayName: this.i18n("storage.devices.column.partitionType"),
                        field: "isLogical",
                        type: "boolean",
                        template: function (dataItem) {
                            return (dataItem.isLogical)
                                ? _this.i18n("storage.devices.partitionType.logical")
                                : _this.i18n("storage.devices.partitionType.primary");
                        }
                    }],
                sortMode: vuiConstants.grid.sortMode.SINGLE,
                selectionMode: vuiConstants.grid.selectionMode.NONE,
                selectedItems: [],
                resizable: false,
                columnMenu: {
                    sortable: false,
                    messages: {
                        columns: i18nService.getString("CommonUi", "listview.showColumnsMenu"),
                        filter: i18nService.getString("CommonUi", "listview.filterMenu")
                    }
                }
            };
        }
        PartitionsListController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.partitions;
        };
        PartitionsListController.$inject = ["i18nService", "hostStorageService",
            "vuiConstants", "bytesFilter", "storageUtil"];
        return PartitionsListController;
    }());
    storage_ui.PartitionsListController = PartitionsListController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("partitionsList", {
        template: "<div class='flex-grid' vui-datagrid='$ctrl.datagridOptions'><div>",
        bindings: {
            partitions: "<"
        },
        controller: PartitionsListController
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'GeneralStorageDeviceDetailsViewController', GeneralStorageDeviceDetailsViewController);

   GeneralStorageDeviceDetailsViewController.$inject = [
      'i18nService', '$scope', 'vxPropertyViewService', 'actionsService',
      '$q', 'navigation', 'multipathingPoliciesService'];

   function GeneralStorageDeviceDetailsViewController (
         i18nService, $scope, vxPropertyViewService, actionsService, $q, navigation, multipathingPoliciesService) {

      var self = this;

      var i18n = i18nService.getString.bind(null, 'StorageUi');

      self.hostId = navigation.getRoute().objectId;
      self.cache = {};
      self.hostPolicyOptions = {};

      $scope.$watch(function() {
         return $scope.masterDetailsViewContext.selectedItem;
      }, function(newValue, oldValue) {
         if (newValue !== oldValue && newValue) {
            requestMultipathingInfo();
         }
      });

      requestMultipathingInfo();

      function getSelectedItem () {
         return $scope.masterDetailsViewContext.selectedItem;
      }

      function getSelectedDeviceIdentifier() {
         var selectedItem = getSelectedItem();
         return selectedItem && selectedItem.identifier;
      }

      function requestMultipathingInfo() {
         var deviceId = getSelectedDeviceIdentifier();
         if (!deviceId) {
            return;
         }

         // We should hide edit multipathing section when:
         // - the context host is disconnected
         // - for devices owned by the HPP plugin (see PR 2222384 for more details).
         if (!$scope.masterDetailsViewContext.isHostConnected ||
               getSelectedItem().ownerPlugin === "HPP") {
            buildPropertyView(null);
            return;
         }

         var hostId = self.hostId;
         var cacheId = hostId + '-' + deviceId;

         if (self.cache.hasOwnProperty(cacheId)) {
            buildPropertyView(self.cache[cacheId]);
         } else {
            self.loading = true;
            self.propertyViewData = null;
         }

         // Request host policy options only once
         var requestHostPolicies = false;
         if (!self.hostPolicyOptions.hasOwnProperty(self.hostId)) {
            requestHostPolicies = true;
         }

         var onEditInvocation = function(actionDef) {
            var selectedDevice = getSelectedItem();
            if (selectedDevice) {
               actionsService.invokeAction(actionDef, {
                  deviceId: selectedDevice.identifier,
                  name: selectedDevice.identifier
               });
            }
         };

         multipathingPoliciesService.requestPolicies(
            self.hostId, getSelectedDeviceIdentifier(),
            requestHostPolicies, onEditInvocation.bind(self))
            .then(
               function(responses) {
                  self.cache[cacheId] = responses.multipathingInfo;
                  if (requestHostPolicies && responses.hostPolicyOptions) {
                     self.hostPolicyOptions[self.hostId] = responses.hostPolicyOptions;
                  }
                  if (hostId === self.hostId && deviceId === getSelectedDeviceIdentifier()) {
                     buildPropertyView(responses.multipathingInfo);
                  }
               },
               function () {
                  if (hostId === self.hostId && deviceId === getSelectedDeviceIdentifier()) {
                     buildPropertyView(null);
                  }
               })
            .finally(function() {
               if (hostId === self.hostId && deviceId === getSelectedDeviceIdentifier()) {
                  self.loading = false;
               }
            });
      }

      function buildPropertyView (deviceMultipathingProps) {
         var gridItem = getSelectedItem();
         if (!gridItem) {
            return;
         }

         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var categoryBuilder = builder.category(
            i18n('storage.devices.properties.generalHeader'), 0);
         categoryBuilder.section('generalSection')
            .title(i18n('storage.devices.properties.generalHeader'))
            .property(
               i18n('storage.adapters.devices.name'),
               gridItem.name)
            .property(
               i18n('storage.adapters.devices.identifier'),
               gridItem.identifier)
            .property(
               i18n('storage.adapters.devices.type'),
               gridItem.type)
            .property(
               i18n('storage.devices.properties.location'),
               gridItem.devicePath)
            .property(
               i18n('storage.adapters.devices.capacity'),
               gridItem.localizedCapacity)
            .property(
               i18n('storage.adapters.devices.driveType'),
               gridItem.localizedDriveType)
            .property(
               i18n('storage.adapters.devices.hardwareAcc'),
               gridItem.hardwareAcceleration)
            .property(
               i18n('storage.adapters.devices.transport'),
               gridItem.transport)
            .property(
               i18n('storage.adapters.devices.owner'),
               gridItem.ownerPlugin)
            .property(
               i18n('storage.adapters.devices.sectorFormat'),
               gridItem.sectorFormat);
         if (deviceMultipathingProps) {
            multipathingPoliciesService.buildMulthipathingSection(
              categoryBuilder,
               i18n('storage.devices.properties.multipathingPoliciesHeader'),
               deviceMultipathingProps,
               self.hostPolicyOptions[self.hostId],
               deviceMultipathingProps.editAction);
         }

         self.propertyViewData = builder.build();
      }
   }
})();

var storage_ui;
(function (storage_ui) {
    var ScsiLunDisplayNameUpdateSpec = (function () {
        function ScsiLunDisplayNameUpdateSpec() {
            this._type = "com.vmware.vsphere.client.storage.adapters.ScsiLunDisplayNameUpdateSpec";
        }
        return ScsiLunDisplayNameUpdateSpec;
    }());
    storage_ui.ScsiLunDisplayNameUpdateSpec = ScsiLunDisplayNameUpdateSpec;
    var RenameStorageDeviceDialogService = (function () {
        function RenameStorageDeviceDialogService(i18nService, clarityModalService, clarityConstants, vxValidatorFactory, mutationService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.vxValidatorFactory = vxValidatorFactory;
            this.mutationService = mutationService;
        }
        /**
         * Displays the StorageDeviceMultipathingPolicyDialog
         */
        RenameStorageDeviceDialogService.prototype.show = function (hostId, lunUuid, deviceName) {
            var _this = this;
            var self = this;
            var modalOptions = {
                title: self.i18nService.getString("StorageUi", "storage.devices.action.rename.dialogTitle"),
                subTitle: {
                    text: deviceName
                },
                defaultButton: "submit",
                alerts: [],
                contentTemplate: "storage-ui/resources/storage/views/host/devices/RenameStorageDeviceDialog.html",
                onSubmit: function () {
                    if (modalOptions.dialogData.renameDeviceFormValidator.validate().length) {
                        return false;
                    }
                    var spec = new ScsiLunDisplayNameUpdateSpec();
                    spec.uuid = lunUuid;
                    spec.text = modalOptions.dialogData.name;
                    if (spec.text) {
                        _this.mutationService.apply(hostId, spec._type, spec);
                    }
                    return !!spec.text;
                }
            };
            modalOptions.dialogData = {
                hostId: hostId,
                lunUuid: lunUuid,
                name: deviceName,
                i18n: this.i18nService,
                renameDeviceFormValidator: this.vxValidatorFactory.create()
            };
            self.clarityModalService.openOkCancelModal(modalOptions);
        };
        RenameStorageDeviceDialogService.$inject = ["i18nService",
            "clarityModalService", "clarityConstants", "vxValidatorFactory", "mutationService"];
        return RenameStorageDeviceDialogService;
    }());
    storage_ui.RenameStorageDeviceDialogService = RenameStorageDeviceDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("renameStorageDeviceDialogService", RenameStorageDeviceDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageDeviceMultipathingPolicyDialogController = (function () {
        function StorageDeviceMultipathingPolicyDialogController($scope, i18nService, dataService, hostStorageConstants, storageUtil, $timeout) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.hostStorageConstants = hostStorageConstants;
            this.storageUtil = storageUtil;
            this.$timeout = $timeout;
            this.hostId = $scope.modalOptions.dialogData.hostId;
            this.deviceId = $scope.modalOptions.dialogData.deviceId;
            this.dialogData = $scope.modalOptions.dialogData;
            this.requestData();
        }
        StorageDeviceMultipathingPolicyDialogController.prototype.requestData = function () {
            var self = this;
            self.isDisabled = function () {
                return !(self.dialogData.selectedPolicy &&
                    self.storageUtil.isFixedPolicy(self.dialogData.selectedPolicy.id));
            };
            self.loading = true;
            self.dataService.getProperties(self.hostId, [
                self.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_WITH_PATHS_PROP,
                self.hostStorageConstants.PATH_SELECTION_POLICY_OPTIONS_PROP
            ], {
                propertyParams: [{
                        propertyName: self.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_WITH_PATHS_PROP,
                        parameterType: "java.lang.String",
                        parameter: self.deviceId
                    }]
            }).then(function (response) {
                var policyOptions = response &&
                    response[self.hostStorageConstants.PATH_SELECTION_POLICY_OPTIONS_PROP];
                if (policyOptions && policyOptions.length) {
                    self.policyOptions = _.map(policyOptions, function (policyOption) {
                        return {
                            id: policyOption.policy.key,
                            label: self.storageUtil.getPathSelectionPolicyNameByKey(policyOption.policy.key, policyOptions)
                        };
                    });
                }
                else {
                    self.policyOptions = _.map([
                        self.hostStorageConstants.storagePolicies.FIXED_PATH,
                        self.hostStorageConstants.storagePolicies.MOST_RECENTLY_USED_PATH,
                        self.hostStorageConstants.storagePolicies.ROUND_ROBIN
                    ], function (policyKey) {
                        return {
                            id: policyKey,
                            label: self.storageUtil.formatPathSelectionPolicyLabel(policyKey)
                        };
                    });
                }
                var deviceMultipathingInfo = response &&
                    response[self.hostStorageConstants.STORAGE_DEVICE_MULTIPATHING_INFO_WITH_PATHS_PROP];
                self.dialogData.logicalUnitId =
                    deviceMultipathingInfo && deviceMultipathingInfo.logicalUnitId;
                if (deviceMultipathingInfo &&
                    deviceMultipathingInfo.pathSelectionPolicy &&
                    self.storageUtil.isFixedPolicy(deviceMultipathingInfo.pathSelectionPolicy.policy)) {
                    self.dialogData.selectedPath = _.find(deviceMultipathingInfo.paths, function (path) {
                        return path.name === deviceMultipathingInfo.pathSelectionPolicy.prefer;
                    });
                }
                var selectedPolicyKey = deviceMultipathingInfo
                    && deviceMultipathingInfo.pathSelectionPolicy
                    && deviceMultipathingInfo.pathSelectionPolicy.policy;
                self.dialogData.selectedPolicy = _.find(self.policyOptions, function (policyOption) {
                    return policyOption.id === selectedPolicyKey;
                }) || self.policyOptions[0];
                self.paths = deviceMultipathingInfo && deviceMultipathingInfo.paths;
                self.focusPathSelectionPolicySelect();
            }, function (error) {
                var errorMsg = self.i18nService.getString("StorageUi", "storage.failedToRetrieveDataError");
                if (error && error.data && error.data.message) {
                    errorMsg += " " + error.data.message;
                }
                self.dialogData.errorApi.showError(errorMsg);
            }).finally(function () {
                self.loading = false;
            });
        };
        StorageDeviceMultipathingPolicyDialogController.prototype.focusPathSelectionPolicySelect = function () {
            var pathSelectionPolicySelect = angular.element("#storage-device-multipathing-policy-select");
            if (pathSelectionPolicySelect && pathSelectionPolicySelect[0]) {
                this.$timeout(function () {
                    pathSelectionPolicySelect[0].focus();
                }, 0);
            }
        };
        StorageDeviceMultipathingPolicyDialogController.$inject = ["$scope", "i18nService", "dataService",
            "hostStorageConstants", "storageUtil", "$timeout"];
        return StorageDeviceMultipathingPolicyDialogController;
    }());
    storage_ui.StorageDeviceMultipathingPolicyDialogController = StorageDeviceMultipathingPolicyDialogController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("StorageDeviceMultipathingPolicyDialogController", StorageDeviceMultipathingPolicyDialogController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageDeviceMultipathingPolicyDialogService = (function () {
        function StorageDeviceMultipathingPolicyDialogService($rootScope, i18nService, clarityModalService, clarityConstants, storageUtil, mutationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.storageUtil = storageUtil;
            this.mutationService = mutationService;
        }
        /**
         * Displays the StorageDeviceMultipathingPolicyDialog
         */
        StorageDeviceMultipathingPolicyDialogService.prototype.show = function (hostId, deviceId, name) {
            var self = this;
            var modalOptions = {
                title: self.i18nService.getString("StorageUi", "device.editMultipathingPolicyFormH5.title"),
                subTitle: {
                    text: name
                },
                defaultButton: "submit",
                size: "lg",
                alerts: [],
                contentTemplate: "storage-ui/resources/storage/views/host/devices/StorageDeviceMultipathingPolicyDialog.html",
                onSubmit: onSubmit
            };
            modalOptions.dialogData = {
                hostId: hostId,
                deviceId: deviceId,
                errorApi: {
                    showError: showError,
                    clearErrors: clearErrors
                }
            };
            self.clarityModalService.openOkCancelModal(modalOptions);
            function onSubmit() {
                var selectedPolicyKey = modalOptions.dialogData.selectedPolicy &&
                    modalOptions.dialogData.selectedPolicy.id;
                var logicalUnitId = modalOptions.dialogData.logicalUnitId;
                var selectedPath = modalOptions.dialogData.selectedPath;
                if (selectedPolicyKey && logicalUnitId) {
                    var multipathLunPolicySpec = {
                        _type: "com.vmware.vsphere.client.storage.MultipathLunPolicySpec",
                        logicalUnitId: logicalUnitId
                    };
                    if (self.storageUtil.isFixedPolicy(selectedPolicyKey)) {
                        if (!selectedPath) {
                            showError(self.i18nService.getString("StorageUi", "device.editMultipathingPolicy.noPreferredPath"));
                            return false;
                        }
                        multipathLunPolicySpec.policy = {
                            _type: "com.vmware.vim.binding.vim.host.MultipathInfo$FixedLogicalUnitPolicy",
                            policy: selectedPolicyKey,
                            prefer: selectedPath.name
                        };
                    }
                    else {
                        multipathLunPolicySpec.policy = {
                            _type: "com.vmware.vim.binding.vim.host.MultipathInfo$LogicalUnitPolicy",
                            policy: selectedPolicyKey
                        };
                    }
                    self.mutationService.apply(hostId, multipathLunPolicySpec._type, multipathLunPolicySpec, self.i18nService.getString("StorageUi", "device.editMultipathingPolicy.taskTitle"));
                }
                return true;
            }
            function showError(errorMessage) {
                modalOptions.alerts = [{
                        text: errorMessage,
                        type: self.clarityConstants.notifications.type.ERROR
                    }];
            }
            function clearErrors() {
                modalOptions.alerts = [];
            }
        };
        StorageDeviceMultipathingPolicyDialogService.$inject = ["$rootScope", "i18nService",
            "clarityModalService", "clarityConstants", "storageUtil", "mutationService"];
        return StorageDeviceMultipathingPolicyDialogService;
    }());
    storage_ui.StorageDeviceMultipathingPolicyDialogService = StorageDeviceMultipathingPolicyDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageDeviceMultipathingPolicyDialogService", StorageDeviceMultipathingPolicyDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageDevicesMasterViewController = (function () {
        function StorageDevicesMasterViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.tabs = [{
                    name: this.i18nService.getString("StorageUi", "storage.devices.propertiesTab.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/devices/GeneralStorageDeviceDetailsView.html",
                    uid: "storage.devices.propertiesTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.devices.pathsTab.header"),
                    templateUrl: "storage-ui/resources/storage/views/host/devices/StorageDevicesPathsDetailsView.html",
                    uid: "storage.devices.pathsTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.devices.properties.partitionDetailsHeader"),
                    templateUrl: "storage-ui/resources/storage/views/host/devices/StorageDevicesPartitionDetailsView.html",
                    uid: "storage.devices.partitionDetails",
                    metadata: {
                        relevantFor: "isScsiDisk"
                    }
                }];
            this.detailsViewData = {
                tabsPromise: this.$q.when(this.tabs)
            };
        }
        StorageDevicesMasterViewController.$inject = ["i18nService", "$q"];
        return StorageDevicesMasterViewController;
    }());
    storage_ui.StorageDevicesMasterViewController = StorageDevicesMasterViewController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("StorageDevicesMasterViewController", StorageDevicesMasterViewController);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageDevicesPartitionDetailsViewController', StorageDevicesPartitionDetailsViewController);

   StorageDevicesPartitionDetailsViewController.$inject = [
      '$scope',
      'hostStorageService',
      'i18nService',
      'navigation'
   ];

   function StorageDevicesPartitionDetailsViewController ($scope, hostStorageService, 
         i18nService, navigation) {

      var self = this;
      self.loading = false;
      self.cachedItems = {};
      self.partitions = [];
      self.hostId = navigation.getRoute().objectId;
      // View id for persisting column definitions state.
      self.viewId =  navigation.getRoute().extensionId+ '_paths';
      self.i18n = function(key) {
         return i18nService.getString('StorageUi', key);
      };

      $scope.$watch(
            function() {
               return $scope.masterDetailsViewContext.selectedItem;
            },
            function(newValue, oldValue) {
               if (newValue !== oldValue && newValue) {
                  self.refresh();
               }
            }
      );

      function setModel (obj) {
         self.partitionFormat = i18nService.getString('StorageUi', 'partitionFormat.' + (obj.partitionFormat || 'unknown'));
         self.partitions = obj.partitions;
      }

      self.refresh = function partitionDetailRefresh() {
         if (!$scope.masterDetailsViewContext.selectedItem) {
            return;
         }
         var devicePath = $scope.masterDetailsViewContext.selectedItem.devicePath;
         if (self.cachedItems.hasOwnProperty(devicePath)) {
            setModel(self.cachedItems[devicePath]);
         } else {
            self.loading = true;
         }
         hostStorageService.retrieveStorageDevicePartitionData(self.hostId, devicePath)
               .then(function(result) {
                  self.cachedItems[devicePath] = result;
                  if ($scope.masterDetailsViewContext.selectedItem
                     && $scope.masterDetailsViewContext.selectedItem.devicePath === devicePath) {
                     setModel(result);
                  }
               })
               .finally(function() {
                  self.loading = false;
               });
      };

      self.refresh();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageDevicesPathsDetailsViewController', StorageDevicesPathsDetailsViewController);

   StorageDevicesPathsDetailsViewController.$inject = [
      '$scope',
      'hostStorageService',
      'navigation'
   ];

   function StorageDevicesPathsDetailsViewController($scope, hostStorageService, navigation) {
      var self = this;
      self.loading = false;
      self.hostId = navigation.getRoute().objectId;
      // View id for persisting column definitions state.
      self.viewId = navigation.getRoute().extensionId + '_paths';

      self.cache = {};

      $scope.$watch(function() { return $scope.masterDetailsViewContext.selectedItem; },
         function(newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
               self.refresh();
            }
         });

      function getSelectedDeviceIdentifier() {
         if (!$scope.masterDetailsViewContext.selectedItem) {
            return null;
         }

         return $scope.masterDetailsViewContext.selectedItem.identifier;
      }

      self.refresh = function() {

         var deviceIdentifier = getSelectedDeviceIdentifier();
         if (!deviceIdentifier) {
            return;
         }

         var hostId = self.hostId;
         var cacheId = hostId + '-' + deviceIdentifier;

         if (self.cache.hasOwnProperty(cacheId)) {
            self.paths = self.cache[cacheId];
         } else {
            self.loading = true;
            self.paths = [];
         }

         hostStorageService.retrieveHostStorageDevicePathsData(hostId, deviceIdentifier)
            .then(function(devicePaths) {
               self.cache[cacheId] = devicePaths;
               if (hostId === self.hostId && deviceIdentifier === getSelectedDeviceIdentifier()) {
                  self.paths = devicePaths;
               }
            })
            .finally(function() {
               if (hostId === self.hostId && deviceIdentifier === getSelectedDeviceIdentifier()) {
                  self.loading = false;
               }
            });
      };

      self.refresh();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'StorageDevicesViewController', StorageDevicesViewController);

   StorageDevicesViewController.$inject = [
      'i18nService',
      '$scope',
      'hostStorageService',
      'dataService',
      '$q',
      'navigation'
   ];

   function StorageDevicesViewController(i18nService, $scope, hostStorageService, dataService, $q, navigation) {
      var self = this;
      self.storageDevicesLoading = false;
      self.hostId = navigation.getRoute().objectId;
      self.headerOptions = {
            title: i18nService.getString('StorageUi', 'storage.devices.listView.header'),
            objectId: self.hostId,
            actions: []
      };
      self.viewId = navigation.getRoute().extensionId;

      self.liveRefreshProperties = [
         'config.storageDevice',
         'config.storageDevice.scsiLun',
         'config.storageDevice.plugStoreTopology.device',
         'config.storageDevice.multipathInfo.lun',
         'config.storageDevice.plugStoreTopology.target',
         'config.fileSystemVolume.mountInfo',
         'config.multipathState.path',
         'datastore'
      ];

      self.refresh = function() {
         self.storageDevicesLoading = true;

         var requests = {
            storageDevices: hostStorageService.retrieveStorageDevicesData(self.hostId),
            isHostConnected: dataService.getProperties(self.hostId, ['runtime.connectionState'])
               .then(function (response) {
                  return response && response['runtime.connectionState'] === 'connected';
               })
         };

         self.lastRefreshRequest = requests;

         $q.all(requests).then(
            function(result) {
               // If the current result is made by the last refresh request.
               if (self.lastRefreshRequest === requests) {
                  self.storageDevicesLoading = false;
                  self.devices = result.storageDevices;
                  self.isHostConnected = result.isHostConnected;
               }
            });
      };

      $scope.$watch(function() {
         return self.selectedDevices;
      }, function(newValue, oldValue) {
         if (newValue === oldValue) {
            return;
         }

         if (self.selectedDevices) {
            $scope.masterDetailsViewContext.selectedItems = self.selectedDevices;
            $scope.masterDetailsViewContext.isHostConnected = self.isHostConnected;
         } else {
            // Propagate empty array to details view if there is no selection.
            $scope.masterDetailsViewContext.selectedItems = [];
         }
      });

      // Request storage devices after the grid is initialized.
      self.refresh();
   }
})();

var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointsPathsComponentController = (function () {
        function ProtocolEndpointsPathsComponentController(vuiConstants, i18nService, dataService, navigation, hostStorageService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.hostStorageService = hostStorageService;
            this.viewId = "datastore.pe.pathsTab";
        }
        ProtocolEndpointsPathsComponentController.prototype.$onChanges = function () {
            var _this = this;
            this.hostId = this.navigation.getRoute().objectId;
            if (this.hostId && this.selectedItems && this.selectedItems.length) {
                this.hostStorageService
                    .retrieveHostProtocolEndpointsPathsData(this.hostId, this.selectedItems[0].identifier)
                    .then(function (response) {
                    _this.paths = response;
                });
            }
        };
        ProtocolEndpointsPathsComponentController.$inject = ["vuiConstants", "i18nService", "dataService", "navigation",
            "hostStorageService"];
        return ProtocolEndpointsPathsComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("protocolEndpointsPathsComponentController", {
        controller: ProtocolEndpointsPathsComponentController,
        templateUrl: "storage-ui/resources/storage/views/host/protocolEndpoints/paths/ProtocolEndpointsPathsComponent.html",
        bindings: {
            selectedItems: "<"
        }
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var HostProtocolEndpointsPropertiesComponent = (function () {
        function HostProtocolEndpointsPropertiesComponent(i18nService, vxPropertyViewService, hostStorageConstants, navigation, dataService, multipathingPoliciesService, actionsService, $q) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.hostStorageConstants = hostStorageConstants;
            this.navigation = navigation;
            this.dataService = dataService;
            this.multipathingPoliciesService = multipathingPoliciesService;
            this.actionsService = actionsService;
            this.$q = $q;
            this.hostPolicyOptions = {};
            this.multhipathingCache = {};
            this.i18n = i18nService.getString;
        }
        HostProtocolEndpointsPropertiesComponent.prototype.$onChanges = function () {
            this.hostId = this.navigation.getRoute().objectId;
            if (this.selectedItem) {
                if (this.selectedItem.peType === this.hostStorageConstants.protocolEndpoints.BLOCK && this.isHostConnected()) {
                    this.buildPropertyViewWithMulthipathingData();
                }
                else {
                    this.buildPropertyView(this.selectedItem, null);
                }
            }
        };
        HostProtocolEndpointsPropertiesComponent.prototype.isHostConnected = function () {
            return this.hostConnectionState === this.hostStorageConstants.connectionState.CONNECTED;
        };
        HostProtocolEndpointsPropertiesComponent.prototype.buildPropertyViewWithMulthipathingData = function () {
            var _this = this;
            var deviceId = this.selectedItem.identifier;
            if (!deviceId) {
                return;
            }
            if (!this.isHostConnected()) {
                this.buildPropertyView(this.selectedItem, null);
                return;
            }
            var hostId = this.hostId;
            var cacheId = hostId + '-' + deviceId;
            if (this.multhipathingCache.hasOwnProperty(cacheId)) {
                this.buildPropertyView(this.selectedItem, this.multhipathingCache[cacheId]);
            }
            else {
                this.loading = true;
                this.propertyViewData = null;
            }
            var requestHostPolicies = false;
            if (!this.hostPolicyOptions.hasOwnProperty(this.hostId)) {
                requestHostPolicies = true;
            }
            var onEditInvocation = function (actionDef) {
                if (_this.selectedItem) {
                    _this.actionsService.invokeAction(actionDef, {
                        deviceId: _this.selectedItem.identifier,
                        name: _this.selectedItem.identifier
                    });
                }
            };
            this.multipathingPoliciesService.requestPolicies(this.hostId, this.selectedItem.identifier, requestHostPolicies, onEditInvocation.bind(this))
                .then(function (responses) {
                _this.multhipathingCache[cacheId] = responses.multipathingInfo;
                if (requestHostPolicies && responses.hostPolicyOptions) {
                    _this.hostPolicyOptions[_this.hostId] = responses.hostPolicyOptions;
                }
                if (hostId === _this.hostId && deviceId === _this.selectedItem.identifier) {
                    _this.buildPropertyView(_this.selectedItem, responses.multipathingInfo);
                }
            }, function () {
                if (hostId === _this.hostId && deviceId === _this.selectedItem.identifier) {
                    _this.buildPropertyView(_this.selectedItem, null);
                }
            })
                .finally(function () {
                if (hostId === _this.hostId && deviceId === _this.selectedItem.identifier) {
                    _this.loading = false;
                }
            });
        };
        HostProtocolEndpointsPropertiesComponent.prototype.buildPropertyView = function (item, multipathingProperties) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var categoryBuilder = builder.category(this.i18n("StorageUi", "storage.pe.properties.generalHeader"), 0);
            var generalCategoryBuilder = categoryBuilder.section("generalSection")
                .title(this.i18n("StorageUi", "storage.pe.properties.generalHeader"))
                .property(this.i18n("StorageUi", "storage.pe.runtimeName"), item.name)
                .property(this.i18n("StorageUi", "storage.pe.type"), item.type)
                .property(this.i18n("StorageUi", "storage.pe.identifier"), item.identifier);
            switch (item.peType) {
                case this.hostStorageConstants.protocolEndpoints.BLOCK: {
                    generalCategoryBuilder
                        .property(this.i18n("StorageUi", "storage.pe.location"), item.location)
                        .property(this.i18n("StorageUi", "storage.pe.lun"), item.lun)
                        .property(this.i18n("StorageUi", "storage.pe.opState"), item.operationalState)
                        .property(this.i18n("StorageUi", "storage.pe.transport"), item.transport)
                        .property(this.i18n("StorageUi", "storage.pe.owner"), item.owner);
                    break;
                }
                case this.hostStorageConstants.protocolEndpoints.NAS: {
                    generalCategoryBuilder
                        .property(this.i18n("StorageUi", "storage.pe.server"), item.server)
                        .property(this.i18n("StorageUi", "storage.pe.folder"), item.folder)
                        .property(this.i18n("StorageUi", "storage.pe.opState"), item.operationalState);
                    break;
                }
            }
            generalCategoryBuilder
                .property(this.i18n("StorageUi", "storage.pe.array"), item.storageArray);
            if (multipathingProperties) {
                this.multipathingPoliciesService.buildMulthipathingSection(categoryBuilder, this.i18n("StorageUi", "storage.pe.properties.multipathingPoliciesHeader"), multipathingProperties, this.hostPolicyOptions[this.hostId], multipathingProperties.editAction);
            }
            this.propertyViewData = builder.build();
        };
        HostProtocolEndpointsPropertiesComponent.$inject = ["i18nService", "vxPropertyViewService", "hostStorageConstants", "navigation", "dataService", "multipathingPoliciesService", "actionsService", "$q"];
        return HostProtocolEndpointsPropertiesComponent;
    }());
    storage_ui.HostProtocolEndpointsPropertiesComponent = HostProtocolEndpointsPropertiesComponent;
    angular.module("com.vmware.vsphere.client.storage")
        .component("hostProtocolEndpointProperties", {
        templateUrl: "storage-ui/resources/storage/views/host/protocolEndpoints/propertiesDetailsTab/HostProtocolEndpointsPropertiesView.html",
        bindings: {
            selectedItem: "<",
            hostConnectionState: "<"
        },
        controller: HostProtocolEndpointsPropertiesComponent
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointList = (function () {
        function ProtocolEndpointList(i18nService, $scope, vuiConstants, columnRenderersRegistry, storageUtil, navigation, dataService, hostStorageConstants) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.storageUtil = storageUtil;
            this.navigation = navigation;
            this.dataService = dataService;
            this.hostStorageConstants = hostStorageConstants;
            this.PROTOCOL_ENDPOINT_DATA_PROP = "hostProtocolEndpointsData";
            this.CONNECTION_STATE_PROP = "runtime.connectionState";
            this.i18n = i18nService.getString;
            this.liveRefreshProperties = [
                'config.fileSystemVolume.mountInfo',
                'config.storageDevice.scsiLun'
            ];
        }
        ProtocolEndpointList.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                data: [],
                resizable: true,
                vuiFooter: {
                    showCopy: true
                },
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
            this.headerOptions = {
                title: this.i18n("StorageUi", "storage.pe.listView.header"),
                actions: []
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && !_.isEqual(newValue, oldValue)) {
                    _this.masterDetailsViewContext.selectedItems = newValue;
                }
            });
            this.$scope.preselectComparator = function (gridDataItem) {
                if (!_this.masterDetailsViewContext.selectedItems || !_this.masterDetailsViewContext.selectedItems.length || !gridDataItem) {
                    return false;
                }
                var preselectedItem = _.find(_this.masterDetailsViewContext.selectedItems, function (selectedDevice) {
                    return selectedDevice.identifier === gridDataItem.identifier;
                });
                return preselectedItem ? true : false;
            };
            this.refresh();
        };
        ProtocolEndpointList.prototype.refresh = function () {
            var _this = this;
            this.loading = true;
            this.hostId = this.navigation.getRoute().objectId;
            var requestedProperties = [this.PROTOCOL_ENDPOINT_DATA_PROP,
                this.CONNECTION_STATE_PROP];
            this.dataService.getProperties(this.hostId, requestedProperties).then(function (result) {
                _this.datagridOptions.data = _.map(result[_this.PROTOCOL_ENDPOINT_DATA_PROP], function (item) { return _this.formatProtocolEndpointItem(item); });
                _this.masterDetailsViewContext.hostConnectionState = result[_this.CONNECTION_STATE_PROP];
            }).finally(function () {
                _this.loading = false;
            });
        };
        ProtocolEndpointList.prototype.getColumnDefinitions = function () {
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            var compareNumericValues = this.storageUtil.compareNumericValues;
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.name"),
                    field: "name",
                    template: function (item) {
                        return textRenderer(["name"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.type"),
                    field: "type",
                    template: function (item) {
                        return textRenderer(["type"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.array"),
                    field: "storageArray",
                    template: function (item) {
                        return textRenderer(["storageArray"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.location"),
                    field: "location",
                    template: function (item) {
                        return textRenderer(["location"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.lun"),
                    field: "lun",
                    template: function (item) {
                        return textRenderer(["lun"], item);
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "lunNumber");
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.pe.opState"),
                    field: "operationalState",
                    template: function (item) {
                        return textRenderer(["operationalState"], item);
                    }
                },
            ];
        };
        ProtocolEndpointList.prototype.formatProtocolEndpointItem = function (item) {
            var result = {};
            var protocolEndpoint = item.protocolEndpoint;
            var peType = protocolEndpoint.peType;
            switch (peType) {
                case this.hostStorageConstants.protocolEndpoints.BLOCK:
                    var lun = item.underlyingLun;
                    result.name = this.getStringValue(lun.displayName);
                    result.storageArray = this.getStringValue(protocolEndpoint.storageArray);
                    result.identifier = this.getStringValue(lun.canonicalName);
                    result.location = this.getStringValue(lun.deviceName);
                    result.lun = item.lunNumber.toString();
                    result.type = this.i18n("StorageUi", "storage.pe.type.block");
                    result.operationalState =
                        this.deviceStateMatches(item, ProtocolEndpointList.OPERATIONAL_STATE_OK)
                            ? this.i18n("StorageUi", "storage.pe.opState.accessible")
                            : this.i18n("StorageUi", "storage.pe.opState.notAccessible");
                    result.transport = this.storageUtil.getScsiPeTransport(item);
                    result.owner = this.getStringValue(item.ownerPlugin);
                    result.isScsiPE = true;
                    break;
                case this.hostStorageConstants.protocolEndpoints.NAS:
                    result.name = this.i18n("StorageUi", "storage.pe.runtimeName.nfs", this.getStringValue(protocolEndpoint.nfsServer));
                    result.storageArray = this.getStringValue(protocolEndpoint.storageArray);
                    result.identifier = this.getStringValue(protocolEndpoint.uuid);
                    result.location = this.getStringValue(protocolEndpoint.nfsServer)
                        + this.getStringValue(protocolEndpoint.nfsDir);
                    result.server = this.getStringValue(protocolEndpoint.nfsServer);
                    result.folder = this.getStringValue(protocolEndpoint.nfsDir);
                    result.lun = this.i18n("StorageUi", "informationNotAccessible");
                    result.type = this.i18n("StorageUi", "storage.pe.type.nas");
                    result.operationalState = item.accessible
                        ? this.i18n("StorageUi", "storage.pe.opState.accessible")
                        : this.i18n("StorageUi", "storage.pe.opState.notAccessible");
                    break;
            }
            result.uuid = protocolEndpoint.uuid;
            result.lunNumber = item.lunNumber;
            result.peType = peType;
            return result;
        };
        ProtocolEndpointList.prototype.deviceStateMatches = function (data, state) {
            if (!data || !data.underlyingLun ||
                !data.underlyingLun.operationalState) {
                return false;
            }
            if (data.underlyingLun.operationalState.indexOf(state) < 0) {
                return false;
            }
            return true;
        };
        ProtocolEndpointList.prototype.getStringValue = function (value) {
            return value ? value : "";
        };
        ProtocolEndpointList.OPERATIONAL_STATE_OK = "ok";
        ProtocolEndpointList.$inject = ["i18nService", "$scope", "vuiConstants", "columnRenderersRegistry",
            "storageUtil", "navigation", "dataService", "hostStorageConstants"];
        return ProtocolEndpointList;
    }());
    storage_ui.ProtocolEndpointList = ProtocolEndpointList;
    angular.module("com.vmware.vsphere.client.storage")
        .component("protocolEndpointList", {
        templateUrl: "storage-ui/resources/storage/views/host/protocolEndpoints/ProtocolEndpointListView.html",
        bindings: {
            masterDetailsViewContext: "="
        },
        controller: ProtocolEndpointList
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointsDatastoreListController = (function () {
        function ProtocolEndpointsDatastoreListController(navigation, vuiConstants, $timeout) {
            this.vuiConstants = vuiConstants;
            this.$timeout = $timeout;
            this.filterParams = [];
            this.hostId = navigation.getRoute().objectId;
        }
        ProtocolEndpointsDatastoreListController.prototype.$onChanges = function () {
            var _this = this;
            this.filterParams = [];
            if (this.selectedProtocolEndpoints
                && this.selectedProtocolEndpoints.length === 1) {
                // Needed because nothing watches the filterParams array in the list-view.
                // That's why we first destroy the whole list view with
                // "this.filterParams = []" and then trigger the re-rendering of the
                // whole list-view by assigning an array to filterParams in the
                // next browser cycle.
                this.$timeout(function () {
                    _this.filterParams = [_this.selectedProtocolEndpoints[0].uuid];
                }, 0);
            }
        };
        ProtocolEndpointsDatastoreListController.$inject = ["navigation", "vuiConstants", "$timeout"];
        return ProtocolEndpointsDatastoreListController;
    }());
    storage_ui.ProtocolEndpointsDatastoreListController = ProtocolEndpointsDatastoreListController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("protocolEndpointsDatastoresList", {
        templateUrl: "storage-ui/resources/storage/views/host/protocolEndpoints/ProtocolEndpointsDatastoresListComponent.html",
        bindings: {
            selectedProtocolEndpoints: "<"
        },
        controller: ProtocolEndpointsDatastoreListController
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var ProtocolEndpointsMasterDetailsViewController = (function () {
        function ProtocolEndpointsMasterDetailsViewController($q, i18nService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.detailsViewData = {
                tabsPromise: this.$q.when([{
                        name: this.i18nService.getString("StorageUi", "storage.pe.propertiesTab.header"),
                        templateUrl: "storage-ui/resources/storage/views/host/protocolEndpoints/" +
                            "propertiesDetailsTab/HostProtocolEndpointProperties.html",
                        uid: "storage.hostProtocolEndpoints.propertiesTab"
                    }, {
                        name: i18nService.getString("StorageUi", "storage.pe.pathsTab.header"),
                        templateUrl: "storage-ui/resources/storage/views/host/" +
                            "protocolEndpoints/paths/ProtocolEndpointsPaths.html",
                        uid: "datastore.pe.pathsTab",
                        metadata: {
                            relevantFor: "isScsiPE"
                        }
                    }, {
                        name: this.i18nService.getString("StorageUi", "storage.pe.datastoresTab.header"),
                        templateUrl: "storage-ui/resources/storage/views/host/" +
                            "protocolEndpoints/ProtocolEndpointsDatastores.html",
                        uid: "storage.protocolEndpoints.datastoresTab"
                    }])
            };
        }
        ProtocolEndpointsMasterDetailsViewController.$inject = ["$q", "i18nService"];
        return ProtocolEndpointsMasterDetailsViewController;
    }());
    storage_ui.ProtocolEndpointsMasterDetailsViewController = ProtocolEndpointsMasterDetailsViewController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("ProtocolEndpointsMasterDetailsViewController", ProtocolEndpointsMasterDetailsViewController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var RescanStorageDialogService = (function () {
        function RescanStorageDialogService(i18nService, defaultUriSchemeUtil, storageUtil, managedEntityConstants, clarityConstants, hostStorageService, clarityModalService) {
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageUtil = storageUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.clarityConstants = clarityConstants;
            this.hostStorageService = hostStorageService;
            this.clarityModalService = clarityModalService;
        }
        RescanStorageDialogService.prototype.open = function (targetObjects) {
            var modalOptions = {
                contentTemplate: 'storage-ui/resources/storage/views/host/adapters/StorageAdaptersRescanDialog.html',
                title: this.i18nService.getString('StorageUi', 'storage.adapters.rescanForm.titleH5'),
                defaultButton: 'submit',
                alerts: [],
                dialogData: {
                    i18n: this.i18nService.getString,
                    spec: {
                        rescanHbas: true,
                        rescanVmfs: true
                    }
                }
            };
            if (targetObjects.length === 1) {
                modalOptions.subTitle = {
                    objectId: this.defaultUriSchemeUtil.getVsphereObjectId(targetObjects[0])
                };
            }
            // Warn the user that the action will be invoked on multiple hosts or
            // cluster/dc etc.
            if (targetObjects[0].type !== this.managedEntityConstants.HOST
                || targetObjects.length > 1) {
                var warning = this.storageUtil.getRescanWarning(targetObjects[0].type);
                if (warning) {
                    this.addModalWarning(modalOptions, warning);
                }
            }
            modalOptions.onSubmit = this.onSubmit.bind(this, modalOptions, targetObjects);
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        RescanStorageDialogService.prototype.addModalWarning = function (modalOptions, text) {
            modalOptions._warnings = modalOptions._warnings || [];
            modalOptions._warnings.push({
                type: this.clarityConstants.notifications.type.WARNING,
                text: text
            });
            modalOptions.alerts = modalOptions._warnings;
        };
        RescanStorageDialogService.prototype.onSubmit = function (modalOptions, targetObjects) {
            var _this = this;
            // Check if any of the rescan options are selected
            var rescanSpec = modalOptions.dialogData.spec;
            if (!rescanSpec.rescanHbas && !rescanSpec.rescanVmfs) {
                this.setModalError(modalOptions, this.i18nService.getString('StorageUi', 'storage.adapters.rescanForm.noTagretSelected'));
                // Do not close the dialog.
                return false;
            }
            // Try to trigger rescan
            modalOptions.dialogData.loading = true;
            var rescanPromise = this.hostStorageService.rescanStorageAdapters(targetObjects, modalOptions.dialogData.spec);
            // Check if we triggered rescan for any host
            rescanPromise = rescanPromise.then(function (rescanResult) {
                if (!rescanResult.affectedHosts || rescanResult.affectedHosts.length === 0) {
                    _this.setModalError(modalOptions, _this.i18nService.getString('StorageUi', 'storage.adapters.rescanForm.noAvailableHosts', rescanResult.targetName));
                    // Do not close the dialog.
                    return false;
                }
                return true;
            }).finally(function () {
                modalOptions.dialogData.loading = false;
            });
            return rescanPromise;
        };
        RescanStorageDialogService.prototype.setModalError = function (modalOptions, text) {
            var alerts = angular.copy(modalOptions._warnings || []);
            alerts.splice(0, 0, {
                type: this.clarityConstants.notifications.type.ERROR,
                text: text
            });
            modalOptions.alerts = alerts;
        };
        RescanStorageDialogService.$inject = ["i18nService", "defaultUriSchemeUtil",
            "storageUtil", "managedEntityConstants", "clarityConstants",
            "hostStorageService", "clarityModalService"];
        return RescanStorageDialogService;
    }());
    storage_ui.RescanStorageDialogService = RescanStorageDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("rescanStorageDialogService", RescanStorageDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AllocateSpaceController = (function () {
        function AllocateSpaceController(i18nService, $scope) {
            this.i18nService = i18nService;
            this.$scope = $scope;
        }
        AllocateSpaceController.prototype.$onInit = function () {
            var _this = this;
            this.$scope.$watch(function () {
                return _this.size.allocatedSpace;
            }, function (newValue) {
                if (newValue === undefined || newValue > _this.size.maxSize) {
                    _this.size.allocatedSpace = _this.size.maxSize;
                }
            });
        };
        AllocateSpaceController.$inject = ["i18nService", "$scope"];
        return AllocateSpaceController;
    }());
    storage_ui.AllocateSpaceController = AllocateSpaceController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("allocateSpace", {
        templateUrl: "storage-ui/resources/storage/views/host/swapToSsd/AllocateSpaceViewComponent.html",
        bindings: {
            size: "<"
        },
        controller: AllocateSpaceController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AllocateSpaceDialogService = (function () {
        function AllocateSpaceDialogService(i18nService, mutationService, datastoreConstants, defaultUriSchemeUtil, clarityModalService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.datastoreConstants = datastoreConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityModalService = clarityModalService;
        }
        AllocateSpaceDialogService.prototype.openSpaceAllocationDialog = function (datastore, hostId) {
            var _this = this;
            var maxSize = datastore.cacheSpace / this.datastoreConstants.MB_TO_GB + datastore.freeSpace / this.datastoreConstants.BYTES_TO_GB;
            var capacityInGb = datastore.capacity / this.datastoreConstants.BYTES_TO_GB;
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.swapToSsd.editCacheConfiguration.title"),
                contentTemplate: "storage-ui/resources/storage/views/host/swapToSsd/AllocateSpaceDialog.html",
                dialogData: {
                    i18n: this.i18nService.getString,
                    cacheConfig: {
                        allocatedSpace: datastore.cacheSpace / this.datastoreConstants.MB_TO_GB,
                        // This logic is added, because the backend returns incorrect data once
                        // you allocate space for cache and some cases may occur where the maxSize
                        // exceeds the capacity of the datastore. Should be removed once the bug is resolved.
                        maxSize: maxSize > capacityInGb ? capacityInGb : maxSize
                    }
                },
                onSubmit: function () {
                    var allocatedSpace = modalOptions.dialogData.cacheConfig.allocatedSpace < modalOptions.dialogData.cacheConfig.maxSize ?
                        modalOptions.dialogData.cacheConfig.allocatedSpace :
                        modalOptions.dialogData.cacheConfig.maxSize;
                    _this.updateCacheConfiguration(datastore, hostId, allocatedSpace * _this.datastoreConstants.MB_TO_GB);
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        AllocateSpaceDialogService.prototype.updateCacheConfiguration = function (datastore, hostId, allocatedSpace) {
            var spec = {
                _type: "com.vmware.vim.binding.vim.host.CacheConfigurationManager$CacheConfigurationSpec",
                datastore: this.defaultUriSchemeUtil.getManagedObjectReference(datastore.datastoreId),
                swapSize: allocatedSpace
            };
            this.mutationService.apply(hostId, spec._type, spec, this.i18nService.getString("StorageUi", "storage.swapToSsd.editCacheConfiguration.title"));
        };
        AllocateSpaceDialogService.$inject = ["i18nService", "mutationService", "datastoreConstants", "defaultUriSchemeUtil", "clarityModalService"];
        return AllocateSpaceDialogService;
    }());
    storage_ui.AllocateSpaceDialogService = AllocateSpaceDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("allocateSpaceDialogService", AllocateSpaceDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var SwapToSsdDatastoresList = (function () {
        function SwapToSsdDatastoresList(i18nService, $scope, vuiConstants, swapToSsdService, columnRenderersRegistry, storageUtil, navigation, datagridActionBarService) {
            var _this = this;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.swapToSsdService = swapToSsdService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.storageUtil = storageUtil;
            this.navigation = navigation;
            this.datagridActionBarService = datagridActionBarService;
            this.hasAdvancedConfigPrivilege = true;
            this.updateActionBar = function () {
                return _this.datagridActionBarService.updateActionBar(_this.datagridOptions, [_this.hostId], [
                    {
                        actionId: _this.ACTIONS.EDIT_CACHE_CONFIGURATION,
                        isActionAvailable: function (actionDef) {
                            return actionDef.available && _this.selectedItem && _this.selectedItem.canBeUsedForCache;
                        },
                        getActionInvocationContext: function () {
                            return {
                                selectedDatastore: _this.selectedItem
                            };
                        }
                    },
                    {
                        actionId: _this.ACTIONS.REFRESH_STORAGE_SYSTEM
                    },
                    {
                        actionId: _this.ACTIONS.RESCAN_ADAPTERS
                    },
                ]);
            };
            this.i18n = i18nService.getString;
            this.ACTIONS = {
                EDIT_CACHE_CONFIGURATION: 'vsphere.core.host.actions.vFlash.editCacheConfiguration',
                REFRESH_STORAGE_SYSTEM: 'vsphere.core.host.actions.refreshStorageSystem',
                RESCAN_ADAPTERS: 'vsphere.core.host.actions.rescanHost'
            };
            this.liveRefreshProperties = [
                'config.cacheConfigurationInfo',
                'config.fileSystemVolume.mountInfo',
                'datastore'
            ];
        }
        SwapToSsdDatastoresList.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                resizable: true,
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
            this.headerOptions = {
                title: this.i18n("StorageUi", "storage.swapToSsd.title"),
                actions: []
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue[0] !== oldValue[0]) {
                    _this.selectedItem = newValue[0];
                    _this.updateActionBar();
                }
            });
            this.refresh();
        };
        SwapToSsdDatastoresList.prototype.refresh = function () {
            var _this = this;
            this.loading = true;
            this.hostId = this.navigation.getRoute().objectId;
            this.swapToSsdService.getHostSwapToSsdData(this.hostId).then(function (hostData) {
                _this.hasAdvancedConfigPrivilege = hostData.hasAdvancedConfigPrivilege;
                _this.datagridOptions.data = hostData.ssdDatastores;
                _this.updateActionBar();
            }).finally(function () {
                _this.loading = false;
            });
        };
        SwapToSsdDatastoresList.prototype.getColumnDefinitions = function () {
            var objectLinkRenderer = this.columnRenderersRegistry.getColumnRenderer("object-link");
            var compareNumericValues = this.storageUtil.compareNumericValues;
            function renderDisabledNumber(formattedNumber, isDisabled) {
                var className = "vertical-aligned-text";
                if (isDisabled === true) {
                    className += " disabled-text";
                }
                return "<span class=\"" + className + "\">" + formattedNumber + "</span>";
            }
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.swapToSsd.list.nameColumn"),
                    field: "datastoreName",
                    template: function (item) {
                        return objectLinkRenderer(["datastoreId", "datastoreName", "vsphere-icon-datastore", null, item.canBeUsedForCache], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.swapToSsd.list.capacityColumn"),
                    field: "formattedCapacity",
                    template: function (item) {
                        return renderDisabledNumber(item.formattedCapacity, !item.canBeUsedForCache);
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "capacity");
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.swapToSsd.list.hostCacheSpaceColumn"),
                    field: "formattedCacheSpace",
                    template: function (item) {
                        return renderDisabledNumber(item.formattedCacheSpace, !item.canBeUsedForCache);
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "cacheSpace");
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.swapToSsd.list.freeSpaceColumn"),
                    field: "formattedFreeSpace",
                    template: function (item) {
                        return renderDisabledNumber(item.formattedFreeSpace, !item.canBeUsedForCache);
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "freeSpace");
                    }
                }
            ];
        };
        SwapToSsdDatastoresList.$inject = ["i18nService", "$scope", "vuiConstants", "swapToSsdService",
            "columnRenderersRegistry", "storageUtil", "navigation", "datagridActionBarService"];
        return SwapToSsdDatastoresList;
    }());
    storage_ui.SwapToSsdDatastoresList = SwapToSsdDatastoresList;
    angular.module("com.vmware.vsphere.client.storage")
        .component("swapToSsdDatastoresList", {
        templateUrl: "storage-ui/resources/storage/views/host/swapToSsd/SwapToSsdDatastoresList.html",
        controller: SwapToSsdDatastoresList
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var SwapToSsdDatastoreItem = (function () {
        function SwapToSsdDatastoreItem() {
        }
        return SwapToSsdDatastoreItem;
    }());
    storage_ui.SwapToSsdDatastoreItem = SwapToSsdDatastoreItem;
    var HostSwapToSsdData = (function () {
        function HostSwapToSsdData() {
        }
        return HostSwapToSsdData;
    }());
    storage_ui.HostSwapToSsdData = HostSwapToSsdData;
    var SwapToSsdService = (function () {
        function SwapToSsdService(i18nService, dataService, bytesFilter, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.bytesFilter = bytesFilter;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.HOST_SWAP_TO_SSD_PROP = "storage:hostSwapToSsdData";
        }
        SwapToSsdService.prototype.getHostSwapToSsdData = function (hostId) {
            var _this = this;
            return this.dataService.getProperties(hostId, [this.HOST_SWAP_TO_SSD_PROP]).then(function (response) {
                var result = new HostSwapToSsdData();
                var swapToSsdData = response && response[_this.HOST_SWAP_TO_SSD_PROP];
                if (swapToSsdData) {
                    result.hasAdvancedConfigPrivilege = swapToSsdData.hasAdvancedConfigPrivilege;
                    result.ssdDatastores = _.map(swapToSsdData.ssdDatastores, function (rawItem) {
                        var item = new SwapToSsdDatastoreItem();
                        item.datastoreName = rawItem.formattedName;
                        item.datastoreId = _this.defaultUriSchemeUtil.getVsphereObjectId(rawItem.dsRef);
                        item.canBeUsedForCache = rawItem.canBeUsedForCache;
                        item.capacity = rawItem.capacity;
                        item.formattedCapacity = _this.bytesFilter(rawItem.capacity, "B", "Auto", 2);
                        item.freeSpace = rawItem.freeSpace;
                        item.formattedFreeSpace = _this.bytesFilter(rawItem.freeSpace, "B", "Auto", 2);
                        if (rawItem.hostCacheSpaceInMb || rawItem.hostCacheSpaceInMb === 0) {
                            item.cacheSpace = rawItem.hostCacheSpaceInMb;
                            item.formattedCacheSpace = _this.bytesFilter(rawItem.hostCacheSpaceInMb * 1024 * 1024, "B", "Auto", 2);
                        }
                        else {
                            item.formattedCacheSpace = "";
                            item.cacheSpace = 0;
                        }
                        return item;
                    });
                }
                else {
                    result.hasAdvancedConfigPrivilege = true;
                    result.ssdDatastores = [];
                }
                return result;
            });
        };
        SwapToSsdService.$inject = ["i18nService", "dataService", "bytesFilter", "defaultUriSchemeUtil"];
        return SwapToSsdService;
    }());
    storage_ui.SwapToSsdService = SwapToSsdService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("swapToSsdService", SwapToSsdService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var HostIoFilterViewController = (function () {
        function HostIoFilterViewController(navigation) {
            this.navigation = navigation;
        }
        Object.defineProperty(HostIoFilterViewController.prototype, "hostId", {
            get: function () {
                return this.navigation.getRoute().objectId;
            },
            enumerable: true,
            configurable: true
        });
        HostIoFilterViewController.$inject = ["navigation"];
        return HostIoFilterViewController;
    }());
    storage_ui.HostIoFilterViewController = HostIoFilterViewController;
    angular.module("com.vmware.vsphere.client.storage").controller("HostIoFilterViewController", HostIoFilterViewController);
})(storage_ui || (storage_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
      'DeviceBackingDetailsViewController', DeviceBackingDetailsViewController);

   DeviceBackingDetailsViewController.$inject = [
      '$scope',
      'i18nService',
      'vxPropertyViewService',
      'bytesFilter',
      'vuiConstants'
   ];

   function DeviceBackingDetailsViewController ($scope, i18nService, propertyViewService, bytesFilter, vuiConstants) {
      var self = this;
      function buildPropertyViewData () {
         var builder = propertyViewService.createPropertyViewBuilder();
         var category = builder.category('category');
         var model = $scope.masterDetailsViewContext.selectedItem;
         //General
         category.section('general')
            .title('')
            .property(
               i18nService.getString('StorageUi', 'datastore.manage.deviceBacking.device'),
               model.deviceName)
            .property(
               i18nService.getString('StorageUi', 'datastore.manage.deviceBacking.partitionCapacity'),
               model.formattedDeviceCapacity || i18nService.getString('Common', 'unknown'))
            .property(
               i18nService.getString('StorageUi', 'datastore.manage.deviceBacking.devicePartitionFormat'),
               i18nService.getString('StorageUi', 'partitionFormat.' + (model.devicePartitionFormat || 'unknown') )
            )
            .property(
               i18nService.getString('StorageUi', 'deviceList.columns.driveType'),
               i18nService.getString('StorageUi', model.isSsd ? 'disk.ssd' : 'disk.nonSSD')
            )
            .property(
               i18nService.getString('StorageUi', 'deviceList.columns.sectorFormat'),
               model.sectorFormat
            );
         return builder.build();
      }

      this.datagridOptions = {
         pageConfig: {
            hidePager: false
         },
         columnDefs: getColumnDefs(),
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         resizable: true,
         columnMenu: {
            sortable: false,
            messages: {
               columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
               filter: i18nService.getString('CommonUi', 'listview.filterMenu')
            }
         }
      };

      function getColumnDefs () {
         return [{
            displayName: i18nService.getString('StorageUi', 'storage.devices.column.name'),
            field: 'name',
            template: function(dataItem) {
               return i18nService.getString('StorageUi', 'datastore.partitionType.' + dataItem.name);
            }
         }, {
            displayName: i18nService.getString('StorageUi', 'storage.devices.column.capacity'),
            field: 'partitionCapacity',
            template: function(dataItem) {
               return bytesFilter(dataItem.partitionCapacity, 'B', 'Auto');
            }
         }, {
            displayName: i18nService.getString('StorageUi', 'storage.devices.column.partitionType'),
            field: 'isLogical',
            template: function(dataItem) {
               return (dataItem.isLogical)
                  ? i18nService.getString('StorageUi', 'storage.devices.partitionType.logical')
                  : i18nService.getString('StorageUi', 'storage.devices.partitionType.primary');
            }
         }];
      }

      function refresh() {
         self.summaryData = buildPropertyViewData();
         //Array.isArray(selectedItem.partitions) returns false, which confuses vui-grid
         var dataArray = $scope.masterDetailsViewContext.selectedItem.partitions.slice(0);
         self.datagridOptions.data = dataArray;
      }

      $scope.$watch(function() {
         return $scope.masterDetailsViewContext.selectedItem;
      }, function(newValue, oldValue) {
         if (newValue !== oldValue && newValue){
            refresh();
         }
      });

      refresh();
   }
})();

var storage_ui;
(function (storage_ui) {
    var DeviceBackingMasterViewController = (function () {
        function DeviceBackingMasterViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.tabs = [{
                    name: this.i18nService.getString("StorageUi", "storage.devices.detailsView.header"),
                    templateUrl: "storage-ui/resources/storage/views/manage/backing/DeviceBackingDetailsView.html",
                    uid: "storage.deviceBacking.detailsTab"
                }];
            this.detailsViewData = {
                tabsPromise: this.$q.when(this.tabs)
            };
        }
        DeviceBackingMasterViewController.$inject = ["i18nService", "$q"];
        return DeviceBackingMasterViewController;
    }());
    storage_ui.DeviceBackingMasterViewController = DeviceBackingMasterViewController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("DeviceBackingMasterViewController", DeviceBackingMasterViewController);
})(storage_ui || (storage_ui = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'DeviceBackingViewController', DeviceBackingViewController);

   DeviceBackingViewController.$inject = [
      '$scope',
      'vuiConstants',
      'i18nService',
      'dataService',
      'navigation'
   ];

   function DeviceBackingViewController($scope, vuiConstants, i18nService, dataService, navigation) {
      var dataModelClass = 'com.vmware.vsphere.client.h5.storage.data.datastore.VmfsDatastoreExtentData';
      var datastoreExtentItemsProperty = 'datastoreExtentItems';

      var self = this;
      self.datastoreId = navigation.getRoute().objectId;
      self.headerOptions = {
         title: i18nService.getString('StorageUi', 'datastore.manage.deviceBacking')
      };
      self.deviceBackingLoading = false;

      self.liveRefreshProperties = [
         'host',
         'summary.capacity'
      ];

      self.datagridOptions = {
         height: '100%',
         pageConfig: {
            hidePager: true
         },
         columnDefs: getColumnDefinitions(),
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         data: [],
         selectedItems: [],
         resizable: false
      };

      self.refresh = refresh;

      self.refresh();

      $scope.$watch(function() {
         return self.datagridOptions.selectedItems;
      }, function(newValue, oldValue) {
         if (!newValue || !newValue.length || !oldValue || !oldValue.length) {
            $scope.masterDetailsViewContext.selectedItems = newValue;
         }
         if (newValue[0] !== oldValue[0]) {
            $scope.masterDetailsViewContext.selectedItems = newValue;
         }
      });

      function refresh () {
         if (self.datastoreId) {
            self.deviceBackingLoading = true;
            dataService.getData(self.datastoreId, dataModelClass)
                  .then(function (vmfsDatastoreExtentData) {
                     if (vmfsDatastoreExtentData && vmfsDatastoreExtentData[datastoreExtentItemsProperty]) {
                        self.datagridOptions.data = vmfsDatastoreExtentData[datastoreExtentItemsProperty];
                     }
                  })
                  .finally(function () {
                     self.deviceBackingLoading = false;
                  });
         }
      }

      function getColumnDefinitions() {
         return [
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.deviceBacking.extentColumn'),
               field: 'formattedName',
               template: '#:formattedName#'
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.deviceBacking.capacityColumn'),
               field: 'capacityInB',
               template: function(item){
                  var formatted = item.formattedCapacity
                     ? item.formattedCapacity
                     : i18nService.getString('Common', 'unknown');
                  return '<span class="vertical-aligned-text">' + formatted +'</span>';
               },
               sortable: true
            }
         ];
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'ConnectivityAndMultipathingViewController', ConnectivityAndMultipathingViewController);

   ConnectivityAndMultipathingViewController.$inject = [
      '$scope',
      'vuiConstants',
      'i18nService',
      'dataService',
      'columnRenderersRegistry',
      'defaultUriSchemeUtil',
      'navigation',
      'datagridActionBarService'
   ];

   function ConnectivityAndMultipathingViewController($scope, vuiConstants,
         i18nService, dataService, columnRenderersRegistry, defaultUriSchemeUtil, navigation, datagridActionBarService) {

      var datastoreConnectivityProperty = 'connectivityWithHost:vmfsDatastoreConnectivity';
      var isForceMountedVmfsDatastoreProperty = 'datastore:isForceMountedVmfsDatastore';

      var self = this;
      self.datastoreId = navigation.getRoute().objectId;
      self.isForceMountedVmfsDatastore = false;
      self.headerOptions = {
         title: i18nService.getString('StorageUi', 'datastore.manage.connectivity.connectivityAndMultipathing')
      };
      self.hostConnectivityLoading = false;

      self.liveRefreshProperties = [
         'host'
      ];

      self.datagridOptions = {
         height: '100%',
         columnDefs: getColumnDefinitions(),
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         data: [],
         selectedItems: [],
         resizable: true,
         actionBarOptions: {actions: []}
      };

      function updateActionBar() {

         var actionBarHostContext = getActionBarHostContext();

         if (!actionBarHostContext) {
            self.datagridOptions.actionBarOptions = { actions: []};
            return;
         }

         datagridActionBarService.updateActionBar(
            self.datagridOptions,
            [actionBarHostContext],
            [
               {
                  actionId: 'vsphere.core.datastore.actions.mountVmfsSingleHost',
                  getActionInvocationContext: function() {
                     return {
                        datastoreId: self.datastoreId
                     };
                  },
                  isActionAvailable: function(actionDef) {
                     var hostData = getSelectedHostData();
                     return !self.isForceMountedVmfsDatastore && actionDef.available && hostData &&
                        !hostData.isMounted && hostData.isHostConnected;
                  }
               },
               {
                  actionId: 'vsphere.core.datastore.actions.unmountVmfsSingleHost',
                  getActionInvocationContext: function() {
                     return {
                        datastoreId: self.datastoreId
                     };
                  },
                  isActionAvailable: function(actionDef) {
                     var hostData = getSelectedHostData();
                     return !self.isForceMountedVmfsDatastore && actionDef.available && hostData &&
                           hostData.isMounted && hostData.isHostConnected && hostData.isAccessible;
                  }
               }
            ]);
      }

      function getActionBarHostContext() {
         return getSelectedHostId() || getFirstHostId();
      }

      function getFirstHostId() {
         if (self.datagridOptions.data && self.datagridOptions.data.length > 0) {
            return defaultUriSchemeUtil.getVsphereObjectId(self.datagridOptions.data[0].hostRef);
         }
         return null;
      }

      function getSelectedHostId() {
         var selectedHostData = getSelectedHostData();
         if (selectedHostData) {
            return defaultUriSchemeUtil.getVsphereObjectId(selectedHostData.hostRef);
         }
         return null;
      }

      function getSelectedHostData() {
         if (self.datagridOptions.selectedItems && self.datagridOptions.selectedItems.length === 1) {
            return self.datagridOptions.selectedItems[0];
         }
         return null;
      }

      $scope.$watch(function() {
         return self.datagridOptions.selectedItems;
      }, function(newValue, oldValue) {
         if (newValue !== oldValue) {
            if (!newValue || !newValue.length) {
               $scope.masterDetailsViewContext.selectedItems = null;
            } else {
               var selectedHostId = defaultUriSchemeUtil.getVsphereObjectId(newValue[0].hostRef);
               $scope.masterDetailsViewContext.selectedItems = [selectedHostId];
               $scope.masterDetailsViewContext.isSelectedHostConnected = newValue[0].isHostConnected;
               $scope.masterDetailsViewContext.isDatastoreAccessible = newValue[0].isAccessible;
            }

            updateActionBar();
         }
      });

      $scope.preselectComparator = function(gridDataItem) {
         if (!$scope.masterDetailsViewContext.selectedItems ||
               !$scope.masterDetailsViewContext.selectedItems.length || !gridDataItem) {
            return false;
         }

         return defaultUriSchemeUtil.getVsphereObjectId(gridDataItem.hostRef) ===
               $scope.masterDetailsViewContext.selectedItems[0];
      };

      self.refresh = function () {
         self.hostConnectivityLoading = true;
         dataService.getProperties(self.datastoreId, [datastoreConnectivityProperty, isForceMountedVmfsDatastoreProperty])
               .then(function (response) {
                  if (response && response[datastoreConnectivityProperty]) {
                     self.datagridOptions.data = response[datastoreConnectivityProperty];
                  }
                  self.isForceMountedVmfsDatastore = response && response[isForceMountedVmfsDatastoreProperty];
                  updateActionBar();
               })
               .finally(function () {
                  self.hostConnectivityLoading = false;
               });
      };

      self.refresh();

      function getColumnDefinitions() {
         return [
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.name'),
               field: 'hostFormattedName',
               width: '150px',
               template: function (dataItem) {
                  var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
                  var modifiedData = {
                     hostName: dataItem.hostFormattedName,
                     hostId: defaultUriSchemeUtil.getVsphereObjectId(dataItem.hostRef)
                  };
                  return objectLinkRenderer(['hostId', 'hostName', 'vsphere-icon-host'], modifiedData);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.mounted'),
               field: 'isMounted',
               width: '150px',
               type: 'boolean',
               template: function (dataItem) {
                  var localizationKey = dataItem.isMounted === true ? 'datastore.mounted' : 'datastore.unmounted';
                  return i18nService.getString('StorageUi', localizationKey);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.datastoreConnectivity'),
               field: 'isAccessible',
               width: '150px',
               type: 'boolean',
               template: function (dataItem) {
                  var localizationKey = dataItem.isAccessible === true ? 'datastore.connected' : 'datastore.notConnected';
                  return i18nService.getString('StorageUi', localizationKey);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.mountPoint'),
               field: 'mountPoint',
               width: '150px',
               template: "#:mountPoint#"
            }
         ];
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'DatastoreConnectivityViewController', DatastoreConnectivityViewController);

   DatastoreConnectivityViewController.$inject = [
      'vuiConstants',
      'i18nService',
      'dataService',
      'columnRenderersRegistry',
      'defaultUriSchemeUtil',
      'navigation'
   ];

   function DatastoreConnectivityViewController(vuiConstants, i18nService, dataService,
         columnRenderersRegistry, defaultUriSchemeUtil, navigation) {

      var datastoreConnectivityProperty = 'connectivityWithHost:nfsVvolDatastoreConnectivity';

      var self = this;
      self.datastoreId = navigation.getRoute().objectId;
      self.headerOptions = {
         title: i18nService.getString('StorageUi', 'datastore.manage.connectivity.connectivityWithHosts')
      };
      self.hostConnectivityLoading = false;

      self.liveRefreshProperties = [
         'host'
      ];

      self.refresh = function () {
         self.hostConnectivityLoading = true;
         dataService.getProperties(self.datastoreId, [datastoreConnectivityProperty])
               .then(function (response) {
                  if (response && response[datastoreConnectivityProperty]) {

                     self.datagridOptions = {
                        height: '100%',
                        columnDefs: getColumnDefinitions(response[datastoreConnectivityProperty]),
                        sortMode: vuiConstants.grid.sortMode.SINGLE,
                        selectionMode: vuiConstants.grid.selectionMode.SINGLE,
                        data: response[datastoreConnectivityProperty],
                        selectedItems: [],
                        resizable: true
                     };

                  }
               })
               .finally(function () {
                  self.hostConnectivityLoading = false;
               });

      };

      self.refresh();

      function getColumnDefinitions(data) {
         var textWithTooltipRenderer = columnRenderersRegistry.getColumnRenderer('text-with-custom-tooltip');
         var columnDefinitions = [
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.name'),
               field: 'hostFormattedName',
               width: '150px',
               template: function (dataItem) {
                  var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
                  var modifiedData = {
                     hostName: dataItem.hostFormattedName,
                     hostId: defaultUriSchemeUtil.getVsphereObjectId(dataItem.hostRef)
                  };
                  return objectLinkRenderer(['hostId', 'hostName', 'vsphere-icon-host'], modifiedData);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.datastoreConnectivity'),
               field: 'isAccessible',
               width: '150px',
               type: 'boolean',
               template: function (dataItem) {
                  var localizationKey = dataItem.isAccessible === true ? 'datastore.connected' : 'datastore.notConnected';
                  var title = i18nService.getString('StorageUi', localizationKey);
                  return textWithTooltipRenderer(["text", "title" ], {
                     text: title,
                     title: title
                  });
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.accessMode'),
               field: 'accessMode',
               width: '150px',
               template: function(dataItem) {
                  return textWithTooltipRenderer(["accessMode", "accessMode"], dataItem);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.mountPoint'),
               field: 'mountPoint',
               width: '150px',
               template: function(dataItem) {
                  return textWithTooltipRenderer(["mountPoint", "mountPoint"], dataItem);
               }
            }
         ];

         if (data && data.length && data[0].kerberosAuthentication){
            var kerberosAuthenticationColumn = {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.connectivity.hostList.kerberosAuthentication'),
               field: 'accessMode',
               width: '150px',
               template: function(dataItem) {
                  return textWithTooltipRenderer(["kerberosAuthentication", "kerberosAuthentication"], dataItem);
               }
            };
            columnDefinitions.splice(3, 0, kerberosAuthenticationColumn);
         }
         return columnDefinitions;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'MultipathingDetailsViewController', MultipathingDetailsViewController);

   MultipathingDetailsViewController.$inject = [
      '$scope',
      'hostStorageService',
      'vxPropertyViewService',
      'i18nService',
      'hostStorageConstants',
      'storageUtil',
      'actionsService',
      '$q',
      'navigation'
   ];

   function MultipathingDetailsViewController($scope, hostStorageService,
         vxPropertyViewService, i18nService, hostStorageConstants, storageUtil,
         actionsService, $q, navigation) {

      var self = this;

      self.datastoreId = navigation.getRoute().objectId;
      self.viewId = navigation.getRoute().extensionId + '_paths';
      self.loading = false;
      self.cachedItems = {};
      self.cachedActions = {};
      self.i18n = i18nService.getString.bind(null, 'StorageUi');

      self.selectedDeviceCanonicalName = null;

      self.liveRefreshProperties = [
         'config.storageDevice',
         'config.storageDevice.scsiLun',
         'config.storageDevice.plugStoreTopology.device',
         'config.storageDevice.multipathInfo.lun',
         'config.storageDevice.plugStoreTopology.target',
         'config.fileSystemVolume.mountInfo',
         'config.multipathState.path',
         'datastore'
      ];

      saveMasterDetailsViewContext();

      function saveMasterDetailsViewContext() {
         self.isDatastoreAccessible = $scope.masterDetailsViewContext.isDatastoreAccessible;
         self.hostId = getHostId();
      }

      function isMasterDetailsViewContextChanged() {
         return self.isDatastoreAccessible !== $scope.masterDetailsViewContext.isDatastoreAccessible ||
               self.hostId !== getHostId();
      }

      $scope.$watch(function() {
            return $scope.masterDetailsViewContext.selectedItems;
         },
         function(newValue, oldValue) {
            if (newValue !== oldValue) {
               if (isMasterDetailsViewContextChanged()) {
                  saveMasterDetailsViewContext();
                  self.refresh();
               }
            }
         });

      $scope.$watch(function() {
            return $scope.masterDetailsViewContext.isDatastoreAccessible;
         },
         function(newValue, oldValue) {
            if (newValue !== oldValue) {
               if (isMasterDetailsViewContextChanged()) {
                  saveMasterDetailsViewContext();
                  self.refresh();
               }
            }
         });

      $scope.$watch(function() {
            return self.selectedDeviceMultipathingInfo;
         },
         function(newValue, oldValue) {
            if (newValue !== oldValue) {
               selectDevice();
            }
         });

      function setModel(vmfsDatastoreMultipathingData) {
         var deviceMultipathingInfos = vmfsDatastoreMultipathingData ?
               vmfsDatastoreMultipathingData[
                     hostStorageConstants.EXTENTS_MULTIPATHING_INFO_PROP] : null;

         if (!deviceMultipathingInfos || !deviceMultipathingInfos.length) {
            self.showNoDetailsAvailableMsg = true;
            return;
         }

         self.showNoDetailsAvailableMsg = false;
         self.deviceMultipathingInfos = deviceMultipathingInfos;

         if (self.selectedDeviceCanonicalName) {
            self.selectedDeviceMultipathingInfo =
               deviceMultipathingInfos.find(function(info) {
                  return info.canonicalName === self.selectedDeviceCanonicalName;
               })
               || deviceMultipathingInfos[0];

         } else {
            self.selectedDeviceMultipathingInfo = deviceMultipathingInfos[0];
         }

         self.pathSelectionPolicyOptions = vmfsDatastoreMultipathingData[
               hostStorageConstants.PATH_SELECTION_POLICY_OPTIONS_PROP];
         self.storageArrayTypePolicyOptions = vmfsDatastoreMultipathingData[
               hostStorageConstants.STORAGE_ARRAY_TYPE_POLICY_OPTIONS_PROP];

         selectDevice();
      }

      function selectDevice() {

         if (!self.selectedDeviceMultipathingInfo) {
            return;
         }

         var editMultipathingPropertiesAction;
         var actionCacheId = getHostId() + "-" + self.datastoreId;
         var editMultipathingActionDef = self.cachedActions[actionCacheId];
         if (editMultipathingActionDef) {
            editMultipathingPropertiesAction = {
               title: editMultipathingActionDef.action.label,
               isEnabled: editMultipathingActionDef.available,
               clickHandler: function () {
                  var selectedDeviceId = self.selectedDeviceMultipathingInfo.canonicalName;
                  if (selectedDeviceId) {
                     actionsService.invokeAction(editMultipathingActionDef, {
                        deviceId: selectedDeviceId,
                        name: self.selectedDeviceMultipathingInfo.deviceName
                     });
                  }
               }
            };
         }

         var pathSelectionPolicy = storageUtil.formatPathSelectionPolicyName(
            self.selectedDeviceMultipathingInfo.pathSelectionPolicy,
            self.pathSelectionPolicyOptions);

         var storageArrayTypePolicy = storageUtil.getStorageArrayTypePolicyName(
            self.selectedDeviceMultipathingInfo.storageArrayTypePolicy,
            self.storageArrayTypePolicyOptions);

         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var categoryBuilder = builder.category(
            self.i18n('datastore.manage.connectivity.multipathingDetails'), 0);
         var generalSection = categoryBuilder.section('generalSection')
            .title(self.i18n('datastore.manage.connectivity.multipathingPolicies'));

         if (self.selectedDeviceMultipathingInfo.ownerPlugin === "HPP") {
            generalSection.property(
                  self.i18n('datastore.manage.connectivity.owner'),
                  self.selectedDeviceMultipathingInfo.ownerPlugin);
         } else {
            generalSection.property(
               self.i18n('datastore.manage.connectivity.pathSelectionPolicy'),
               pathSelectionPolicy)
               .property(
                  self.i18n('datastore.manage.connectivity.satp'),
                  storageArrayTypePolicy)
               .property(
                  self.i18n('datastore.manage.connectivity.owner'),
                  self.selectedDeviceMultipathingInfo.ownerPlugin)
               .action(editMultipathingPropertiesAction);
         }

         self.propertyViewData = builder.build();

         self.paths = self.selectedDeviceMultipathingInfo.paths;
         self.hostId = getHostId();
      }

      function getHostId() {
         if ($scope.masterDetailsViewContext.selectedItems && $scope.masterDetailsViewContext.selectedItems.length) {
            return $scope.masterDetailsViewContext.selectedItems[0];
         }
         return null;
      }

      self.refresh = function () {

         if (!$scope.masterDetailsViewContext.isSelectedHostConnected ||
               !$scope.masterDetailsViewContext.isDatastoreAccessible) {
            self.showNoDetailsAvailableMsg = true;
            self.loading = false;
            self.currentPromise = null;
            return;
         }
         self.showNoDetailsAvailableMsg = false;

         var hostId = getHostId();
         if (!hostId) {
            return;
         }

         var datastoreId = self.datastoreId;
         var cacheId = hostId + "-" + datastoreId;

         self.selectedDeviceCanonicalName = self.selectedDeviceMultipathingInfo
               ? self.selectedDeviceMultipathingInfo.canonicalName
               : self.selectedDeviceCanonicalName;

         if (self.cachedItems.hasOwnProperty(cacheId)) {
            setModel(self.cachedItems[cacheId]);
         } else {
            self.deviceMultipathingInfos = null;
            self.loading = true;
         }

         var actionPromise = actionsService.getActions([hostId],
               ['vsphere.core.host.actions.storageDevice.editMultipathingPolicy']);

         var multipathingDataPromise = hostStorageService.retrieveVmfsDatastoreMultipathingData(
               hostId, self.datastoreId);

         var currentPromise = $q.all([multipathingDataPromise, actionPromise])
            .then(function(responses) {
               var multipathingData = responses[0];
               var multipathingActionData = responses[1];

               self.cachedItems[cacheId] = multipathingData;
               if (multipathingActionData && multipathingActionData.length) {
                  self.cachedActions[cacheId] = multipathingActionData[0];
               }
               if (currentPromise === self.currentPromise) {
                  setModel(multipathingData);
               }
            }, function() {
               if (currentPromise === self.currentPromise) {
                  self.showNoDetailsAvailableMsg = true;
               }
            })
            .finally(function() {
               if (self.currentPromise === currentPromise) {
                  self.loading = false;
               }
            });

         self.currentPromise = currentPromise;
      };

      self.refresh();
   }
})();

var storage_ui;
(function (storage_ui) {
    var DatastoreFileBrowserGridColumnConfigService = (function () {
        function DatastoreFileBrowserGridColumnConfigService(i18nService, storageUtil, columnRenderersRegistry, fileUploadConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.storageUtil = storageUtil;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.fileUploadConstants = fileUploadConstants;
            this.renderText = function (plainText, cssClasses, title) {
                var span = $("<span ng-non-bindable></span>")
                    .addClass("vertical-align-cell")
                    .text(plainText);
                if (cssClasses) {
                    _.forEach(cssClasses, function (className) {
                        span.addClass(className);
                    });
                }
                if (title) {
                    span.attr("title", title);
                }
                return span[0].outerHTML;
            };
            this.formatStatusColumn = function (item) {
                if (item.status === _this.fileUploadConstants.state.SUCCESS) {
                    return _this.renderIconWithText('vsphere-icon-status-ok', _this.i18nService.getString('Common', 'success'));
                }
                else if (item.status === _this.fileUploadConstants.state.ERROR) {
                    if (item.isGeneralError) {
                        var iconSpan = '<span class="vsphere-icon-status-error"></span>';
                        var textSpan = _this.renderText(_this.i18nService.getString('StorageUi', 'fileUpload.error.generalError'));
                        var detailsSpan = _this.renderText(_this.i18nService.getString('StorageUi', 'fileUpload.error.details'));
                        var detailsLink = "<a class=\"datastore-upload-error-details-link\" ng-click=\"dataItem.showError()\">" + detailsSpan + "</a>";
                        return '<div>' +
                            iconSpan +
                            textSpan +
                            detailsLink +
                            '</div>';
                    }
                    else {
                        return _this.renderIconWithText('vsphere-icon-status-error', item.error);
                    }
                }
                else if (item.status === _this.fileUploadConstants.state.CANCELED) {
                    return _this.renderIconWithText('vsphere-icon-status-error', _this.i18nService.getString('StorageUi', 'fileUpload.status.canceled'));
                }
                else if (item.status === _this.fileUploadConstants.state.RUNNING) {
                    var progressBarRenderer = _this.columnRenderersRegistry.getColumnRenderer('progress-bar-cancel-link');
                    return progressBarRenderer(item.progress, item.isCancelable, false, 'dataItem.cancel()');
                }
                return undefined;
            };
            this.renderIconWithText = function (icon, text) {
                var iconSpan = "<span class=\"" + icon + "\"></span>";
                var textSpan = _this.renderText(text, null, text);
                return '<div>' +
                    iconSpan +
                    textSpan +
                    '</div>';
            };
        }
        DatastoreFileBrowserGridColumnConfigService.prototype.getDatastoreBrowserColumnConfig = function (hasFriendlyName) {
            var self = this;
            var columns = [
                {
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colName'),
                    field: 'formattedName',
                    sortable: function (cti1, cti2) {
                        return self.storageUtil.compareNumericValues(cti1, cti2, 'nameSortOrder');
                    },
                    template: function (item) {
                        return '<div><span class="' + item.spriteCssClass + '"></span>' +
                            self.renderText(item.formattedName) + '</div>';
                    }
                },
                {
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colSize'),
                    field: 'formattedSize',
                    sortable: function (cti1, cti2) {
                        return self.storageUtil.compareNumericValues(cti1, cti2, 'size');
                    },
                    template: function (item) {
                        return self.renderText(item.formattedSize, ['right-align-cell']);
                    }
                },
                {
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colModified'),
                    field: 'lastModifiedFormatted',
                    sortable: function (cti1, cti2) {
                        return self.storageUtil.compareNumericValues(cti1, cti2, 'lastModified');
                    },
                    template: function (item) {
                        return self.renderText(item.lastModifiedFormatted);
                    }
                },
                {
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colType'),
                    field: 'localizedType',
                    template: function (item) {
                        return self.renderText(item.localizedType);
                    }
                },
                {
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colPath'),
                    field: 'path',
                    template: function (item) {
                        return self.renderText(item.path);
                    }
                }
            ];
            if (hasFriendlyName) {
                columns.push({
                    displayName: self.i18nService.getString('StorageUi', 'dsExplorer.colUuid'),
                    field: 'name',
                    template: function (item) {
                        var displayText = item.friendlyName ? item.name : "";
                        return self.renderText(displayText);
                    }
                });
            }
            return columns;
        };
        DatastoreFileBrowserGridColumnConfigService.prototype.getUploadSessionsGridColumnDefs = function () {
            var self = this;
            return [
                {
                    displayName: this.i18nService.getString('StorageUi', 'dsFileTransferView.colName'),
                    field: 'name',
                    template: function (item) {
                        return "<div><span class=\"vx-icon-dsUpload\"></span>\n                        " + self.renderText(item.name) + "</div>";
                    }
                }, {
                    displayName: this.i18nService.getString('StorageUi', 'dsFileTransferView.colStatus'),
                    field: 'progress',
                    template: this.formatStatusColumn
                }, {
                    displayName: this.i18nService.getString('StorageUi', 'dsFileTransferView.startTime'),
                    field: 'startTimeFormatted',
                    template: '#:startTimeFormatted#'
                }, {
                    displayName: this.i18nService.getString('StorageUi', 'dsFileTransferView.lastUpdated'),
                    field: 'lastUpdatedFormatted',
                    template: '#:lastUpdatedFormatted#'
                }
            ];
        };
        DatastoreFileBrowserGridColumnConfigService.$inject = ["i18nService", "storageUtil", "columnRenderersRegistry", "fileUploadConstants"];
        return DatastoreFileBrowserGridColumnConfigService;
    }());
    storage_ui.DatastoreFileBrowserGridColumnConfigService = DatastoreFileBrowserGridColumnConfigService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("datastoreFileBrowserGridColumnConfigService", DatastoreFileBrowserGridColumnConfigService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var CopyFileDatastoreListController = (function () {
        function CopyFileDatastoreListController(i18nService, $scope, vuiConstants, columnRenderersRegistry, listUtil, bytesFilter, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.listUtil = listUtil;
            this.bytesFilter = bytesFilter;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                resizable: true,
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
        }
        CopyFileDatastoreListController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (changes.datastores) {
                this.selectedTargets = _.filter(this.datastores, function (datastore) {
                    var dsUrn = _this.defaultUriSchemeUtil.createVmomiUri(datastore.ref.type, datastore.ref.value, datastore.ref.serverGuid);
                    if (dsUrn === _this.selectedDatastore.id) {
                        _this.selectedDatastore.name = datastore.name;
                        _this.selectedDatastore.type = datastore.type;
                        return true;
                    }
                    return false;
                });
                this.datagridOptions.data = this.datastores;
            }
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue[0]) {
                    if (newValue[0] !== oldValue[0] && !_.isEqual(newValue, oldValue)) {
                        var dsRef = newValue[0].ref;
                        _this.selectedDatastore.id = _this.defaultUriSchemeUtil.createVmomiUri(dsRef.type, dsRef.value, dsRef.serverGuid);
                        _this.selectedDatastore.name = newValue[0].name;
                        _this.selectedDatastore.type = newValue[0].type;
                        _this.hasSelectedDatastore = true;
                    }
                }
                else {
                    _this.selectedDatastore.name = null;
                    _this.selectedDatastore.type = null;
                    _this.hasSelectedDatastore = false;
                }
            });
            // Once we match the datastore on which we invoke the copy action on,
            // we empty the selected targets since we don't want to preselect under
            // any circumstances.
            this.$scope.comparator = function (value) {
                var itemToSelect = _.find(_this.selectedTargets, function (selectedTarget) {
                    return selectedTarget.name === value.name;
                });
                if (itemToSelect) {
                    _this.selectedTargets = [];
                    return true;
                }
                return false;
            };
        };
        CopyFileDatastoreListController.prototype.getColumnDefinitions = function () {
            var _this = this;
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var compareNumericValues = this.listUtil.compareNumericValues;
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "pathPicker.nameColumnTitle"),
                    field: "name",
                    template: function (item) {
                        var datastoreItem = {
                            name: item.name,
                            icon: "vsphere-icon-datastore"
                        };
                        return iconTextRenderer(["icon", "name"], datastoreItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "pathPicker.spaceColumnTitle"),
                    field: "freeSpace",
                    template: function (item) {
                        return _this.bytesFilter(item.freeSpace, "B", "Auto");
                    },
                    sortable: function (item1, item2) {
                        return compareNumericValues(item1, item2, "freeSpace");
                    }
                }
            ];
        };
        CopyFileDatastoreListController.$inject = [
            "i18nService",
            "$scope",
            "vuiConstants",
            "columnRenderersRegistry",
            "listUtil",
            "bytesFilter",
            "defaultUriSchemeUtil"];
        return CopyFileDatastoreListController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("copyFileDatastoreList", {
        templateUrl: "storage-ui/resources/storage/views/manage/files/copyFileComponents/copyFileDatastoreList.html",
        controller: CopyFileDatastoreListController,
        bindings: {
            datastores: "<",
            selectedDatastore: "=",
            hasSelectedDatastore: "="
        }
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var CopyFilePathPickerController = (function () {
        function CopyFilePathPickerController(i18nService) {
            this.i18nService = i18nService;
            this.accessor = {};
        }
        CopyFilePathPickerController.prototype.$onChanges = function (changes) {
            if (changes.rootId
                && changes.rootId.currentValue
                && changes.rootId.currentValue !== changes.rootId.previousValue
                && this.accessor.reloadData) {
                this.accessor.reloadData();
            }
        };
        CopyFilePathPickerController.prototype.onSelectionChange = function (selectedItem) {
            if (selectedItem) {
                this.selectedDestination.path = selectedItem.path;
                this.selectedDestination.name = selectedItem.name;
            }
        };
        CopyFilePathPickerController.$inject = ["i18nService"];
        return CopyFilePathPickerController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("copyFilePathPicker", {
        templateUrl: "storage-ui/resources/storage/views/manage/files/copyFileComponents/copyFilePathPickerView.html",
        controller: CopyFilePathPickerController,
        bindings: {
            rootId: "<",
            selectedDestination: "="
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreFileBrowserActionBarBuilder = (function () {
        function DatastoreFileBrowserActionBarBuilder(actionDefinitions, actionsService, vuiConstants, isActionAvailable) {
            var _this = this;
            this.actionDefinitions = actionDefinitions;
            this.actionsService = actionsService;
            this.vuiConstants = vuiConstants;
            this.isActionAvailable = isActionAvailable;
            this.actionBarItems = [];
            this.contextGetters = {};
            this.onClickHandler = function (e, actionDef) {
                var actionId = actionDef.actionId;
                var action = _this.actionDefinitions[actionId];
                //evaluate context getter function
                var context = _this.contextGetters[actionId]();
                _this.actionsService.invokeAction(action, context);
            };
        }
        DatastoreFileBrowserActionBarBuilder.prototype.addAction = function (actionId, getContext, clickHandler) {
            if (clickHandler === void 0) { clickHandler = null; }
            var actionDef = this.actionDefinitions[actionId];
            this.contextGetters[actionId] = getContext;
            var actionButton = {
                actionId: actionDef.action.uid,
                tooltipText: actionDef.action.description,
                label: actionDef.action.label,
                enabled: this.isActionAvailable(actionId, actionDef),
                iconClass: actionDef.action.icon,
                onClick: clickHandler || this.onClickHandler
            };
            this.actionBarItems.push(actionButton);
            return this;
        };
        DatastoreFileBrowserActionBarBuilder.prototype.addSeparator = function () {
            this.actionBarItems.push(this.vuiConstants.actions.SEPARATOR);
            return this;
        };
        DatastoreFileBrowserActionBarBuilder.prototype.build = function () {
            return this.actionBarItems;
        };
        ;
        return DatastoreFileBrowserActionBarBuilder;
    }());
    storage_ui.DatastoreFileBrowserActionBarBuilder = DatastoreFileBrowserActionBarBuilder;
    var DatastoreFileBrowserActionsService = (function () {
        function DatastoreFileBrowserActionsService(actionsService, vuiConstants) {
            this.actionsService = actionsService;
            this.vuiConstants = vuiConstants;
            this.ACTIONS = {
                CREATE_FOLDER: "vsphere.core.datastore.actions.createFolder",
                UPLOAD_FILE: "vsphere.core.datastore.actions.uploadToDatastore",
                UPLOAD_FOLDER: "vsphere.core.datastore.actions.uploadFolderToDatastore",
                DOWNLOAD_FILE: "vsphere.core.datastore.actions.downloadFromDatastore",
                DELETE_FILE: "vsphere.core.datastore.actions.deleteFile",
                REGISTER_VM: "vsphere.core.datastore.file.actions.registerVm",
                RENAME_FILE: "vsphere.core.datastore.actions.renameFile",
                INFLATE_THIN_DISK: "vsphere.core.datastore.inflateDiskAction",
                COPY_FILE: "vsphere.core.datastore.actions.copyFile",
                MOVE_FILE: "vsphere.core.datastore.actions.moveFile"
            };
        }
        DatastoreFileBrowserActionsService.prototype.requestActions = function (datastoreId, actionsToLoad) {
            if (actionsToLoad === void 0) { actionsToLoad = null; }
            var dsBrowserActions = _.values(this.ACTIONS);
            return this.actionsService.getActions([datastoreId], actionsToLoad || dsBrowserActions)
                .then(function (actionDefs) {
                var actionDefsById = {};
                actionDefs.forEach(function (actionDef) {
                    actionDefsById[actionDef.action.uid] = actionDef;
                });
                return actionDefsById;
            });
        };
        DatastoreFileBrowserActionsService.prototype.buildActionBarItems = function (datastoreId, isActionAvailable) {
            var _this = this;
            return this.requestActions(datastoreId).then(function (actionDefsById) {
                return new DatastoreFileBrowserActionBarBuilder(actionDefsById, _this.actionsService, _this.vuiConstants, isActionAvailable);
            });
        };
        DatastoreFileBrowserActionsService.prototype.updateActionBar = function (datastoreId, actions, isActionAvailable) {
            var _this = this;
            this.requestActions(datastoreId).then(function (actionDefsById) {
                actions.forEach(function (actionButton) {
                    if (actionButton === _this.vuiConstants.actions.SEPARATOR) {
                        return;
                    }
                    var actionId = actionButton.actionId;
                    var actionDef = actionDefsById[actionId];
                    if (actionDef) {
                        actionButton.enabled = isActionAvailable(actionId, actionDef);
                    }
                });
            });
        };
        DatastoreFileBrowserActionsService.prototype.disableAll = function (actions) {
            var _this = this;
            actions.forEach(function (action) {
                if (action === _this.vuiConstants.actions.SEPARATOR) {
                    return;
                }
                action.enabled = false;
            });
        };
        DatastoreFileBrowserActionsService.$inject = [
            "actionsService", "vuiConstants"
        ];
        return DatastoreFileBrowserActionsService;
    }());
    storage_ui.DatastoreFileBrowserActionsService = DatastoreFileBrowserActionsService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("datastoreFileBrowserActionsService", DatastoreFileBrowserActionsService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {

   angular.module('com.vmware.vsphere.client.storage')
      .controller('DatastoreFileBrowserController', DatastoreFileBrowserController);

   DatastoreFileBrowserController.$inject = [
      '$scope', '$rootScope', 'timeFormatterService', '$element', '$timeout', 'i18nService',
      'datastoreBrowserConstants', 'vuiConstants', 'vuiUtils',
      'actionsService', 'dataService', 'bytesFilter',
      'datastoreBrowserTreeService', 'fileUploadService', 'fileUploadConstants',
      'vuiActionsMenuService',
      'actionConfirmationService',
      'alertService',
      'authorizationService',
      'browserService',
      'vcService',
      '$q', 'datastoreFileBrowserActionsService',
      'datastoreFileBrowserGridColumnConfigService',
      'datastoreTypeConstants',
      'commonActionBarService',
      'streamVmdkService',
      '$location'];

   function DatastoreFileBrowserController (
      $scope, $rootScope, timeFormatterService, $element, $timeout, i18nService,
      datastoreBrowserConstants, vuiConstants, vuiUtils,
      actionsService, dataService, bytesFilter,
      datastoreBrowserTreeService, fileUploadService, fileUploadConstants,
      vuiActionsMenuService, actionConfirmationService, alertService,
      authorizationService, browserService, vcService, $q,
      datastoreFileBrowserActionsService,
      datastoreFileBrowserGridColumnConfigService,
      datastoreTypeConstants,
      commonActionBarService,
      streamVmdkService,
      $location
   ) {

      var FILE_TYPE = 'file';
      var FOLDER_TYPE = 'folder';
      var VM_CONFIG_INFO_CLASS_NAME = 'VmConfigInfo';
      var TEMPLATE_VM_CONFIG_INFO_CLASS_NAME = 'TemplateVmConfigInfo';
      var VM_TEMPLATE_FILE_EXT = 'vmtx';
      var REFRESH_EVENT = 'dataRefreshInvocationEvent';

      var DS_ACCESSIBLE_PROP = "summary/accessible";
      var DS_FREESPACE_PROP = "info/freeSpace";
      var DS_TYPE_PROP = "summary/type";

      var IE_UPLOAD_FILE_SIZE_LIMIT = 4 * 1024 * 1024 * 1024; // 4 GB

      var self = this;

      var cachedItems = [];
      var cachedSearchedItems = [];

      var datastoreFreeSpace;

      self.searchFilesLoading = false;
      self.isFileSetLoading = false;
      self.isSearchResultsDirty = false;
      self.curretSearchRequestCanceller = null;

      self.uploadBatch = new UploadBatch();

      self.popupActionBarOptions = {
         actions: []
      };

      if (h5.isDatastoreBrowserPopUpWindow) {
         var queryStringParams = $location.search();
         $scope.datastoreId = queryStringParams["datastoreId"];
      } else {
         $scope.datastoreId = $scope._route.objectId;

         commonActionBarService.updateActionBar(
            self.popupActionBarOptions,
            "actions",
            [$scope.datastoreId],
            [{actionId: "vsphere.core.datastore.actions.popupDsBrowser"}]);
      }

      $scope.i18nService = i18nService;
      $scope.fileQuery = datastoreBrowserConstants.fileQueryType.ALL_FILES;
      $scope.dsBrowserTreeAccessor = {};
      $scope.isInSearchState = false;
      $scope.isSearchTriggered = false;

      $scope.comparator = function(value) {
         var itemToSelect = _.find(cachedItems, function(cachedItem) {
            return cachedItem.path === value.path;
         });
         return itemToSelect !== undefined;
      };
      $scope.searchComparator = function(value) {
         var itemToSelect = _.find(cachedSearchedItems, function(cachedItem) {
            return cachedItem.path === value.path;
         });
         return itemToSelect !== undefined;
      };

      $scope.$on('$destroy', function() {
         cancelActiveSearchRequest();
      });

      function initController () {
         var ACTIONS = datastoreFileBrowserActionsService.ACTIONS;
         self.splitterOptions = {
            orientation: vuiConstants.splitter.orientation.HORIZONTAL,
            panes: [{ min: '250px', size: '25%' }, { min: '250px', size: '100%' }]
         };

         self.progressSplitterOptions = {
            orientation: vuiConstants.splitter.orientation.VERTICAL,
            panes: [{ min: '250px', size: '75%' }, {
               min: '100px',
               size: '25%',
               collapsible: true,
               collapsed: true
            }]
         };

         self.isViewAvailabilityResolved = false;
         var viewAvailabilityPromises = {
            privilegeCheck: authorizationService.checkPrivileges($scope.datastoreId, ["Datastore.Browse", "Datastore.Config"]),
            datastoreProperties: dataService.getProperties($scope.datastoreId, [DS_ACCESSIBLE_PROP, DS_FREESPACE_PROP])
         };

         $q.all(viewAvailabilityPromises).then(function(responses) {
            if (responses.privilegeCheck[0] !== true) {
               self.viewUnavailableReason = i18nService.getString("StorageUi",
                  "datastore.fileManager.noDatastoreBrowsePermision");
               self.isViewAvailable = false;
            } else if (responses.datastoreProperties[DS_ACCESSIBLE_PROP] !== true) {
               self.viewUnavailableReason = i18nService.getString("StorageUi",
                  "datastore.fileManager.datastoreInaccessible");
               self.isViewAvailable = false;
               self.uploadProgressExpand = fileUploadService.getRunningUploadSessions().length > 0;
            } else {
               self.hasDsCongidPrivilege = responses.privilegeCheck[1];
               self.isViewAvailable = true;
            }

            datastoreFreeSpace = responses.datastoreProperties[DS_FREESPACE_PROP];

         }, function() {
            // In case of error show empty datastore browser view
            self.isViewAvailable = true;
         }).finally(function() {
            self.isViewAvailabilityResolved = true;
         });

         self.showUploadMenu = showUploadMenu;

         self.uploadSessionsDatagridOptions = {
            resizable: true,
            height: '100%',
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            columnDefs: datastoreFileBrowserGridColumnConfigService.getUploadSessionsGridColumnDefs(),
            data: fileUploadService.getUploadSessions($scope.datastoreId),
            pageConfig: {
               hidePager: true
            }
         };
         var runningUploadSessions = fileUploadService.getRunningUploadSessions($scope.datastoreId);
         if (runningUploadSessions.length > 0) {
            // Show the upload grid footer,
            // as there is currently an upload running.
            self.uploadBatch.init(runningUploadSessions);
         }
         self.uploadProgressExpand = false;

         $scope.$on(fileUploadConstants.event.UPDATED, refreshUploadedItems);

         $scope.$on(fileUploadConstants.event.COMPLETE,
            function(event, uploadSession) {
               self.uploadBatch.updateItem(uploadSession);
               refreshDsBrowserTreeNode(uploadSession.datastorePath);
               updateSearchResults();
            });

         $scope.$on(REFRESH_EVENT, function (event, uploadSession) {
            if (self.uploadProgressExpand && !uploadSession) {
               // Do not refresh if the event is triggered by
               // fileUploadConstants.event.COMPLETE
               refreshUploadedItems();
            }
         });

         self.datagridOptions = {
            resizable: true,
            height: '100%',
            selectionMode: vuiConstants.grid.selectionMode.MULTI,
            showCheckboxesOnMultiSelection: false,
            selectedItems: [],
            pageConfig: {
               displayMode: vuiConstants.grid.displayMode.VIRTUAL_SCROLLING
            },
            columnDefs: getFileBrowserColumns(self.isVsanDatastore && self.is65VcOrLater),
            actionBarOptions: { actions: [] },
            data: []
         };

         self.searchDatagridOptions = angular.copy(self.datagridOptions);

         // dsFilesGrid specific initialization
         self.datagridOptions.dataBound = function() {
            if (self.datagridOptions.data && self.datagridOptions.data.length > 0) {
               $('#dsFilesGrid tbody tr').on("dblclick", function() {
                  if (self.datagridOptions.selectedItems &&
                     self.datagridOptions.selectedItems.length === 1 &&
                     self.datagridOptions.selectedItems[0].type === FOLDER_TYPE) {
                     var selectedItemId = self.datagridOptions.selectedItems[0].path;
                     $scope.dsBrowserTreeAccessor.selectChildItem(selectedItemId);
                  }
               });
            }
         };

         self.refreshView = function() {
            updateSearchResults();
            if (!self.isFileSetLoading) {
               refreshDsBrowserTree();
            }
         };

         // Detects selection change in dsFilesGrid.
         $scope.$watch(function() {
               return self.datagridOptions.selectedItems;
            },
            function(selectedItems) {
               if (selectedItems && selectedItems.length) {
                  cachedItems = selectedItems;
               }
               updateActionBar(self.datagridOptions);
            });

         // Detects selection change in searchFilesGrid.
         $scope.$watch(function() {
               return self.searchDatagridOptions.selectedItems;
            },
            function(selectedItems) {
               if (selectedItems && selectedItems.length) {
                  cachedSearchedItems = selectedItems;
               }
               updateActionBar(self.searchDatagridOptions);
            });

         self.keyPress = function(event) {
            if (event.keyCode === 13) {
               // In IE Enter would activates the focused item so we prevent this default behavior.
               event.preventDefault();

               self.doSearch();
            }
         };

         self.toggleSearchState = function() {
            self.isInSearchState = !self.isInSearchState;
            if (self.isInSearchState && self.isSearchResultsDirty) {
               search();
            }
         };

         function updateSearchResults() {
            if (self.isInSearchState) {
               search();
            } else {
               // trigger a new search next time when switching to search results.
               self.isSearchResultsDirty = true;
            }
         }

         self.doSearch = function() {
            if (self.searchTerm && self.searchTerm !== "" && self.rootItem) {
               self.currentSearchTerm = self.searchTerm;
               self.isSearchTriggered = true;
               self.isInSearchState = true;
               search();
            } else if (!self.searchTerm && self.rootItem) {
               self.isSearchTriggered = false;
               self.isInSearchState = false;
            }
            cachedSearchedItems = [];
         };

         self.currentSearchTerm = null;

         datastoreFileBrowserActionsService.buildActionBarItems(
            $scope.datastoreId, calculateActionEnabled).then(function(builder) {

            builder
               .addAction(ACTIONS.CREATE_FOLDER, function() {
                  var currentPath = self.selectedItem.path;
                  return {
                     currentPath: currentPath,
                     topLevelDirectoryCreateSupported: $scope.topLevelDirectoryCreateSupported,
                     isRootFolder: isRootItemSelected(),
                     datastoreDatacenter: $scope.dc,
                     callback: function() {
                        updateSearchResults();
                        refreshDsBrowserTreeNode(currentPath);
                     }
                  };
               })
               .addAction(ACTIONS.UPLOAD_FILE, {}, onFileUploadClick);

            if (browserService.isWebkitDirectorySupported()) {
               builder.addAction(ACTIONS.UPLOAD_FOLDER, {}, onFolderUploadClick);
            }

            var actions = builder.addSeparator()
               .addAction(ACTIONS.REGISTER_VM, function() {
                  var dsFileItem = getSelectedFileItem(self.datagridOptions);
                  var vmFileName = dsFileItem.name;
                  var vmFileExtension =
                     vmFileName.substring(vmFileName.lastIndexOf('.') + 1);
                  return {
                     vmName: vmFileName.substring(0, vmFileName.lastIndexOf('.')),
                     vmFilePath: dsFileItem.path,
                     isTemplate: vmFileExtension === VM_TEMPLATE_FILE_EXT
                  };
               })
               .addAction(ACTIONS.DOWNLOAD_FILE, getDownloadFileActionContext.bind(self, self.datagridOptions))
               .addAction(ACTIONS.COPY_FILE, getCopyFileActionContext.bind(self, self.datagridOptions, ACTIONS.COPY_FILE))
               .addAction(ACTIONS.MOVE_FILE, getCopyFileActionContext.bind(self, self.datagridOptions, ACTIONS.MOVE_FILE))
               .addAction(ACTIONS.RENAME_FILE, getRenameFileActionContext.bind(self, self.datagridOptions))
               .addAction(ACTIONS.DELETE_FILE, getDeleteFileActionContext.bind(self, self.datagridOptions));

            if (!self.isVsanDatastore) {
               actions.addAction(ACTIONS.INFLATE_THIN_DISK, function () {
                  var currentPath = self.selectedItem.path;
                  return {
                     spec: createInflateFileSpec(self.datagridOptions.selectedItems[0]),
                     callback: function () {
                        updateSearchResults();
                        reloadFileList(currentPath);
                     }
                  };
               });
            }

            self.datagridOptions.actionBarOptions.actions = builder.build();
            initUploadHandlers();

         });

         dataService.getProperties(
            $scope.datastoreId,
            ['capability.topLevelDirectoryCreateSupported', 'dc'])
            .then(function(datastoreData) {
               $scope.topLevelDirectoryCreateSupported =
                  datastoreData['capability.topLevelDirectoryCreateSupported'] !== false;
               $scope.dc = datastoreData.dc;
            });

         self.selectedTreeItemChanged = function(selectedItem) {
            if (selectedItem) {
               self.isFileSetLoading = true;

               if (self.selectedItem
                  && selectedItem.id !== self.selectedItem.id) {

                  cachedItems = [];
               }
            }

            self.selectedItem = selectedItem;
            self.datagridOptions.data = [];

            updateActionBar(self.datagridOptions);
         };

         self.selectedTreeItemFilesLoaded = function(selectedTreeItemContentFiles) {
            formatFileItems(selectedTreeItemContentFiles);
            self.datagridOptions.data = selectedTreeItemContentFiles;

            updateActionBar(self.datagridOptions);
            self.isFileSetLoading = false;
         };

         self.onDsTreeInitialized = function(rootItems) {
            if (rootItems && rootItems.length > 0) {
               var oldRootItemPath = self.rootItem ? self.rootItem.path : null;
               self.rootItem = rootItems[0];
               if (oldRootItemPath && self.rootItem && oldRootItemPath !== self.rootItem.path && self.isInSearchState) {
                  search();
               }
            }
         };

         function showUploadMenu (event) {
            var uploadSession = event.data[0];

            // New scope object for the vuiActionsMenu two way binding
            var localScope = $scope.$new();
            localScope.menuDescriptor = {
               label: i18nService.getString('StorageUi', 'actionMenuFileTransfer'),
               iconClass: 'vx-icon-dsUpload',
               items: [{
                  id: 'cancel_upload_id',
                  label: i18nService.getString('StorageUi', 'actionCancelFileTransfer'),
                  iconClass: 'vx-icon-removeIcon',
                  enabled: uploadSession.isCancelable,
                  onClick: function() {
                     var uploadSession = event.data[0];
                     uploadSession.cancel();
                  }
               }]
            };
            var target = event.currentTarget;
            if (!target && event) {
               target = event.target;
            }

            var menuOptions = {
               scope: localScope,
               configObjectName: 'menuDescriptor',
               target: target,
               coordinates: { x: event.clientX, y: event.clientY },
               menuContainerId: 'applicationMenuContainer'
            };

            vuiActionsMenuService.showMenu(menuOptions);
         }

         function getFileBrowserColumns (hasFrinedlyNameColumn) {
            return datastoreFileBrowserGridColumnConfigService.getDatastoreBrowserColumnConfig(hasFrinedlyNameColumn);
         }

         function onFileUploadClick () {
            var fileUploadInput = $element.find('.datastoreUploadFileInput')[0];
            if (self.isVsanDatastore) {
               openStreamVmdkDialog(fileUploadInput);
            } else {
               activateUploadInput(fileUploadInput);
            }
         }

         function onFolderUploadClick () {
            var folderUploadInput = $element.find('.datastoreUploadFolderInput')[0];
            if (self.isVsanDatastore) {
               openStreamVmdkDialog(folderUploadInput);
            } else {
               activateUploadInput(folderUploadInput);
            }
         }

         function openStreamVmdkDialog(inputElement) {
            streamVmdkService.openStreamVmdkWarningDialog().then(function (response) {
               if (response !== null) {
                  activateUploadInput(inputElement);
               }
            });
         }

         function activateUploadInput(inputElement) {
            $timeout(function() {
               // Open file browser.
               inputElement.click();
            }, 0);
         }

         function refreshUploadedItems() {
            vuiUtils.safeApply($scope, function() {
               self.uploadProgressExpand = true;
               var uploadSessionItems = fileUploadService.getUploadSessions($scope.datastoreId) || [];
               uploadSessionItems.forEach(function(item) {

                  self.uploadBatch.updateItem(item);

                  timeFormatterService.formatDate(item.lastUpdated).then(function(formattedDate) {
                     item.lastUpdatedFormatted = formattedDate;
                  });

                  timeFormatterService.formatDate(item.startTime).then(function(formattedDate) {
                     item.startTimeFormatted = formattedDate;
                  });

               });
               self.uploadSessionsDatagridOptions.data = uploadSessionItems;
            });
         }

         function getDeleteFileActionContext (datagridOptions, isInvokedFromSearchState) {
            var currentPath = self.selectedItem.path;
            var deleteFileSpec = createDatastoreDeleteFileSpec(datagridOptions.selectedItems);
            var deleteFilesOnly = _.every(datagridOptions.selectedItems, function(item) {
               return item.type === FILE_TYPE;
            });

            return {
               targetFileNames: _.pluck(datagridOptions.selectedItems, 'name'),
               spec: deleteFileSpec,
               callback: function() {

                  updateSearchResults();
                  if (deleteFilesOnly) {
                     reloadFileList(currentPath);
                     return;
                  }

                  if (isInvokedFromSearchState) {
                     // trigger full refresh in case the action was invoked
                     // from the search state.
                     refreshDsBrowserTree();
                     return;
                  }

                  var selectedItemPath = self.selectedItem.path;
                  if (_.some(deleteFileSpec.targetFiles, function (deletedPath) {
                        return selectedItemPath === deletedPath ||
                           (selectedItemPath.length > deletedPath.length &&
                           deletedPath + "/" === selectedItemPath.substring(0, deletedPath.length + 1));
                     })) {
                     // if current folder (or any of its parent folders) has been deleted,
                     // trigger full tree refresh
                     refreshDsBrowserTree();
                  } else {
                     // else refresh only the current tree node
                     refreshDsBrowserTreeNode(currentPath);
                  }
               }
            };
         }

         function getRenameFileActionContext (datagridOptions, isTriggeredFromSearchState) {
            var currentPath = self.selectedItem.path;
            var fileItem = datagridOptions.selectedItems[0];
            return {
               spec: createDatastoreRenameFileSpec(fileItem),
               callback: function() {
                  updateSearchResults();
                  if (fileItem.type === FOLDER_TYPE) {
                     if (isTriggeredFromSearchState) {
                        // trigger full refresh in case the action was invoked from the
                        // search state
                        refreshDsBrowserTree();
                     } else {
                        // refresh both ds folder tree and file list.
                        refreshDsBrowserTreeNode(currentPath);
                     }
                  } else {
                     // update only the file list when renaming files.
                     reloadFileList(currentPath);
                  }
               }
            };
         }

         function getCopyFileActionContext (datagridOptions, actionId) {

            var currentPath = self.selectedItem.path;
            var filesOnly = _.every(datagridOptions.selectedItems, function(item) {
               return item.type === FILE_TYPE;
            });

            return {
               datastoreId: $scope.datastoreId,
               datastoreDcRef: $scope.dc,
               selectedFiles: datagridOptions.selectedItems,
               callback: function(destinationDatastoreId, destinationPath) {

                  if (actionId === ACTIONS.COPY_FILE) {
                     // don't refresh anything if the files are copied to
                     // another datastore.
                     if (destinationDatastoreId === $scope.datastoreId) {
                        updateSearchResults();
                        if (filesOnly) {
                           // update only the file list.
                           reloadFileList(currentPath);
                        } else {
                           // trigger full refresh in case we are copying folders.
                           refreshDsBrowserTree();
                        }
                     }
                  } else {
                     updateSearchResults();
                     if (filesOnly) {
                        reloadFileList(currentPath);
                        if (destinationDatastoreId === $scope.datastoreId) {
                           reloadFileList(destinationPath);
                        }
                     } else {
                        // trigger full refresh in case we are moving folders.
                        refreshDsBrowserTree();
                     }
                  }
               }
            };
         }

         function getDownloadFileActionContext (datagridOptions) {
            return {
               datastoreId: $scope.datastoreId,
               datastoreDcRef: $scope.dc,
               selectedFiles: datagridOptions.selectedItems,
               zipFileName: getDownloadZipFileName(datagridOptions),
               isStreamFormat: self.isVsanDatastore
            };
         }

         function getDownloadZipFileName (datagridOptions) {
            if (datagridOptions.selectedItems.length > 1) {
               if ($scope.isInSearchState) {
                  return self.rootItem.name + "_files.zip";
               } else {
                  return self.selectedItem.name + "_files.zip";
               }
            } else if (datagridOptions.selectedItems.length === 1 &&
                  datagridOptions.selectedItems[0].type === FOLDER_TYPE) {
               return datagridOptions.selectedItems[0].formattedName + ".zip";
            }
            return null;
         }

         function formatFileItems (items) {
            items.forEach(function(fileItem) {
               if (fileItem.size === null || fileItem.size === undefined) {
                  fileItem.formattedSize = '';
               } else {
                  fileItem.formattedSize = bytesFilter(fileItem.size, 'B', 'KB');
               }

               if (fileItem.lastModified) {
                  timeFormatterService.formatDate(fileItem.lastModified).then(function(formattedDate) {
                     fileItem.lastModifiedFormatted = formattedDate;
                  });
               }

               fileItem.formattedName = fileItem.friendlyName
                  ? fileItem.friendlyName : fileItem.name;
            });
         }

         function initUploadHandlers () {
            var datastoreUploadFileInput = $element.find('.datastoreUploadFileInput');
            datastoreUploadFileInput.on('change', function() {
               uploadFiles(this.files, false);
               // Reset so selecting the same file will
               // trigger onchange event.
               this.value = null;
            });
            var datastoreUploadFolderInput = $element.find('.datastoreUploadFolderInput');
            datastoreUploadFolderInput.on('change', function() {
               uploadFiles(this.files, true);
               // Reset so selecting the same folder will
               // trigger onchange event.
               this.value = null;
            });
         }

         function uploadFiles (fileList, isFolder) {
            var filesToUpload = _.map(fileList, function(file) {
               return file;
            });

            var totalFileSize = 0;
            var maxFileSize = 0;
            _.forEach(filesToUpload, function(file) {
               if (file.size) {
                  totalFileSize += file.size;
                  maxFileSize = Math.max(maxFileSize, file.size);
               }
            });

            if (totalFileSize > datastoreFreeSpace) {
               alertService.error(
                     i18nService.getString("StorageUi", "upload.errorTitle"),
                     i18nService.getString("StorageUi", "upload.errorFileSizeExceedsFreeSpace"));
               return;
            }

            if (browserService.isIe && (maxFileSize > IE_UPLOAD_FILE_SIZE_LIMIT)) {
               alertService.error(
                     i18nService.getString("StorageUi", "upload.errorTitle"),
                     i18nService.getString("StorageUi", "upload.errorFileSizeExceedsIeLimit"));
               return;
            }

            var existingFileFlag = false;
            var existingFileNames = [];
            var existingFolderName;
            _.forEach(filesToUpload, function(file) {
               var relativeRootFolder = null;
               if (file.webkitRelativePath) {
                  var firstFolderDelimiterIndex = file.webkitRelativePath.indexOf('/');
                  if (firstFolderDelimiterIndex > 0) {
                     relativeRootFolder = file.webkitRelativePath.substring(0, firstFolderDelimiterIndex);
                  }
               }
               var fileNameToCheck = relativeRootFolder || file.name;
               var existingFile = getFileItemByName(self.datagridOptions.data, fileNameToCheck);
               if (existingFile) {
                  if (existingFile.type === FILE_TYPE) {
                     existingFileFlag = true;
                     existingFileNames.push(existingFile.name);
                  } else {
                     existingFolderName = existingFile.name;
                  }
               }
            });
            var getString = _.partial(i18nService.getString, 'StorageUi');
            if (existingFolderName) {
               alertService.error(
                  getString(isFolder
                     ? 'uploadFolderAction.confirmation.title'
                     : 'uploadAction.confirmation.title'),
                  getString(isFolder
                     ? 'uploadFolderAction.confirmation.directorylreadyExistsError'
                     : 'uploadAction.confirmation.directorylreadyExistsError', existingFolderName)
               );
            } else if (existingFileFlag) {
               if (isFolder) {
                  alertService.error(
                     getString('uploadFolderAction.confirmation.title'),
                     getString('uploadFolderAction.confirmation.fileAlreadyExistsError')
                  );
               } else {
                  actionConfirmationService.showConfirmationDialog({
                     title: getString('uploadAction.confirmation.title'),
                     message: getString('uploadAction.confirmation.fileAlreadyExists',
                        _.map(existingFileNames, function(name) {
                           return "\u2022 " + name;
                        }).join('\n')),
                     yesHandler: upload
                  });
               }
            } else {
               upload();
            }

            function upload () {
               datastoreFileBrowserActionsService.requestActions(
                     $scope.datastoreId, [ACTIONS.UPLOAD_FILE])
                  .then(function(actionsById) {
                     if(self.selectedItem && self.selectedItem.path) {

                        self.uploadBatch.init(filesToUpload);
                        actionsService.invokeAction(
                              actionsById[ACTIONS.UPLOAD_FILE],
                              {
                                 datastoreId: $scope.datastoreId,
                                 datastoreDcRef: $scope.dc,
                                 path: self.selectedItem.path,
                                 files: filesToUpload,
                                 isDatastoreSelected: self.selectedItem.type === 'datastore',
                                 isStreamFormat: self.isVsanDatastore
                                 && _.some(filesToUpload,
                                       function (file) {
                                          return file && file.name
                                                && file.name.toLocaleLowerCase().indexOf(".vmdk") === file.name.length - 5;
                                       })
                              });
                     }
                  });
            }
         }

         function getSelectedFileItem (datagridOptions) {
            if (!datagridOptions || !datagridOptions.selectedItems ||
               datagridOptions.selectedItems.length === 0 ||
               datagridOptions.selectedItems[0].type === FOLDER_TYPE) {
               return null;
            }

            return datagridOptions.selectedItems[0];
         }


         function updateActionBar (gridOptions) {
            if (self.selectedItem) {
               datastoreFileBrowserActionsService.updateActionBar(
                  $scope.datastoreId,
                  gridOptions.actionBarOptions.actions,
                  calculateActionEnabled.bind({ gridOptions: gridOptions })
               );
            } else {
               datastoreFileBrowserActionsService.disableAll(gridOptions.actionBarOptions.actions);
            }
         }

         function calculateActionEnabled (actionId, actionDef) {
            var gridOptions = this.gridOptions;
            if (!actionDef || !gridOptions) {
               return false;
            }

            var actionAvailable = actionDef.available && !!self.selectedItem && !self.isFileSetLoading;
            if (!actionAvailable) {
               return false;
            }

            switch (actionId) {
               case ACTIONS.CREATE_FOLDER:
                  return checkCreateAvailability();
               case ACTIONS.INFLATE_THIN_DISK:
                  return gridOptions.selectedItems.length === 1 && !!gridOptions.selectedItems[0].isInflatable;
               case ACTIONS.DELETE_FILE:
                  return gridOptions.selectedItems && gridOptions.selectedItems.length;
               case ACTIONS.COPY_FILE:
               case ACTIONS.MOVE_FILE:
                  if (isRootItemSelected() && isOsfsDatastore()) {
                     return false;
                  }
                  return gridOptions.selectedItems && gridOptions.selectedItems.length;
               case ACTIONS.DOWNLOAD_FILE:
                  return isDownloadActionEnabledForSelection(gridOptions);
               case ACTIONS.REGISTER_VM:
                  return isRegisterVmEnabledForSelection(gridOptions);
               case ACTIONS.RENAME_FILE:
                  if (isRootItemSelected() && isOsfsDatastore()) {
                     return false;
                  }
                  return gridOptions.selectedItems
                     && gridOptions.selectedItems.length === 1;
               case ACTIONS.UPLOAD_FILE:
                  return !(isRootItemSelected() && isOsfsDatastore());
               case ACTIONS.UPLOAD_FOLDER:
                  return !(self.isVsanDatastore && isRootItemSelected());
               default:
                  return false;
            }

         }

         function isOsfsDatastore() {
            return self.isVsanDatastore || self.isVvolDatastore;
         }

         function checkCreateAvailability () {
            if (isRootItemSelected()) {
               // If top level create flag is false,
               // then create is possible if you have Datastore.Config privilege
               return $scope.topLevelDirectoryCreateSupported || self.hasDsCongidPrivilege;
            }

            return true;
         }

         function isDownloadActionEnabledForSelection (gridOptions) {
            if (gridOptions.selectedItems.length === 1 &&
               gridOptions.selectedItems[0].type === FOLDER_TYPE) {
               // return true in case of single folder item is selected.
               return true;
            }

            if (gridOptions.selectedItems.length > 0) {
               // Return false if there is at least one non-file item in the selection.
               if (_.find(gridOptions.selectedItems,
                     function(item) {
                        return item.type !== FILE_TYPE;
                     })) {
                  return false;
               }
               // all selected items are files.
               return true;
            }
            return false;
         }

         function isRegisterVmEnabledForSelection (gridOptions) {
            var selectedFiles = gridOptions.selectedItems;
            var regVmAllowedClasses =
               [VM_CONFIG_INFO_CLASS_NAME, TEMPLATE_VM_CONFIG_INFO_CLASS_NAME];
            var isAvailable = selectedFiles.length === 1 &&
               selectedFiles[0].type === FILE_TYPE &&
               _.includes(regVmAllowedClasses, selectedFiles[0].className);
            return isAvailable;
         }

         function isRootItemSelected () {
            if (!self.selectedItem || !self.selectedItem.path) {
               return false;
            }

            var selectedItemPath = self.selectedItem.path.trim();
            return selectedItemPath.length &&
               selectedItemPath[selectedItemPath.length - 1] === ']';
         }

         function search () {

            // Cancel last search request as we don't need it anymore.
            cancelActiveSearchRequest();
            self.curretSearchRequestCanceller = $q.defer();

            self.isSearchResultsDirty = false;
            self.searchDatagridOptions.data = [];
            createSearchActionBar();
            self.searchFilesLoading = true;
            datastoreBrowserTreeService.searchResults($scope.datastoreId, self.rootItem.path,
                  self.currentSearchTerm, self.curretSearchRequestCanceller.promise)
               .then(function(searchResults) {
                  formatFileItems(searchResults);
                  self.searchDatagridOptions.data = searchResults;
                  updateActionBar(self.searchDatagridOptions);
               }).finally(function() {
               self.searchFilesLoading = false;
            });
         }

         function createSearchActionBar () {
            var actions = self.searchDatagridOptions.actionBarOptions.actions;
            if (actions) {
               datastoreFileBrowserActionsService
                  .buildActionBarItems($scope.datastoreId, calculateActionEnabled).then(
                  function(builder) {
                     builder
                        .addAction(ACTIONS.DOWNLOAD_FILE, getDownloadFileActionContext.bind(self, self.searchDatagridOptions))
                        .addAction(ACTIONS.COPY_FILE, getCopyFileActionContext.bind(
                              self, self.searchDatagridOptions, ACTIONS.COPY_FILE))
                        .addAction(ACTIONS.MOVE_FILE, getCopyFileActionContext.bind(
                              self, self.searchDatagridOptions, ACTIONS.MOVE_FILE))
                        .addAction(ACTIONS.DELETE_FILE, getDeleteFileActionContext.bind(self, self.searchDatagridOptions, true))
                        .addAction(ACTIONS.RENAME_FILE, getRenameFileActionContext.bind(self, self.searchDatagridOptions, true));
                     self.searchDatagridOptions.actionBarOptions.actions = builder.build();
                  }
               );
            }
         }

         function reloadFileList(folderPath) {
            // reload file list only when folderPath is the same as the currently
            // selected folder.
            if (folderPath === self.selectedItem.path &&
                  $scope.dsBrowserTreeAccessor.reloadContentFiles) {
               $scope.dsBrowserTreeAccessor.reloadContentFiles();
            }
         }

         function refreshDsBrowserTree () {
            if ($scope.dsBrowserTreeAccessor.refreshTree) {
               $scope.dsBrowserTreeAccessor.refreshTree();
            }
         }

         function refreshDsBrowserTreeNode (path) {
            if ($scope.dsBrowserTreeAccessor.refreshTreeNode) {
               $scope.dsBrowserTreeAccessor.refreshTreeNode(path);
            }
         }

         function createDatastoreRenameFileSpec (item) {
            return {
               sourcePath: item.path,
               destinationName: item.name
            };
         }

         function createDatastoreDeleteFileSpec (items) {
            return {
               sourceDatacenter: $scope.dc,
               targetFiles: _.pluck(items, 'path'),
               fileTypes: _.pluck(items, 'fileType')
            };
         }

         function createInflateFileSpec (file) {
            return {
               sourceDatacenter: $scope.dc,
               targetFile: file.path,
               waitTaskToComplete: true
            };
         }

         function getFileItemByName (items, fileName) {
            if (!items) {
               return undefined;
            }

            return _.find(items, function(fileItem) {
               return fileItem.name === fileName;
            });
         }

      }

      function UploadBatch() {
         // Finished are considered all the upload sessions that are not running.
         var finishedUploadSessionsCount = 0;
         var finishedUploadSessionsCountSizeInB = 0;
         var filesToUploadCount = 0;
         var filesToUploadSizeInB = 0;
         // id -> item
         var runningUploadSessions = {};
         var uploadedSizeInB = 0;
         var showUploads = false;
         var isUploadRunning = false;

         var getMapLength = function(obj) {
            return _.keys(obj).length;
         };

         var getTotalSizeInB = function(obj) {
            return _.values(obj)
                  .map(function(item) { return item.uploadedSizeInB; })
                  .reduce(function(sum, value) { return sum + value; }, 0);
         };

         var init = function(allEnqueuedFilesForUpload) {
            if (getMapLength(runningUploadSessions) === 0) {
               // No running upload sessions,
               // so a new uploadBatch is started.
               showUploads = true;
               isUploadRunning = true;
               finishedUploadSessionsCount = 0;
               filesToUploadCount = allEnqueuedFilesForUpload.length;

               filesToUploadSizeInB = allEnqueuedFilesForUpload
                  .map(function(item) {
                     // The upload session items over which we iterate
                     // have different data models so we read sizeInB if existing
                     // and size otherwise.
                     return item.sizeInB || item.size;
                  })
                  .reduce(function(sum, value) { return sum + value; }, 0);
               uploadedSizeInB = 0;
               finishedUploadSessionsCountSizeInB = 0;
            } else {
               // There are already running upload sessions,
               // so add the new ones to the running uploadBatch.
               filesToUploadCount += allEnqueuedFilesForUpload.length;
               filesToUploadSizeInB += allEnqueuedFilesForUpload
                  .map(function(item) { return item.size; })
                  .reduce(function(sum, value) { return sum + value; }, 0);
            }
         };

         var cancel = function(datagridId) {
            fileUploadService.cancelFilesUpload(datagridId);
            runningUploadSessions = {};
            isUploadRunning = false;
            finishedUploadSessionsCount = filesToUploadCount;
         };

         // Notify when an item has been updated.
         var updateItem = function(uploadSessionItem) {
            if (uploadSessionItem.status === fileUploadConstants.state.CANCELED
                  || uploadSessionItem.status === fileUploadConstants.state.SUCCESS
                  || uploadSessionItem.status === fileUploadConstants.state.ERROR) {

               if (runningUploadSessions[uploadSessionItem.id]) {
                  finishedUploadSessionsCount++;
                  finishedUploadSessionsCountSizeInB += uploadSessionItem.uploadedSizeInB;
                  delete runningUploadSessions[uploadSessionItem.id];
               }
               if (getMapLength(runningUploadSessions) === 0
                  && finishedUploadSessionsCount === filesToUploadCount) {
                  runningUploadSessions = {};
                  isUploadRunning = false;
               }
            } else if (uploadSessionItem.status === fileUploadConstants.state.RUNNING) {
               runningUploadSessions[uploadSessionItem.id] = uploadSessionItem;
            }
         };

         return {
            getShowUploads: function() { return showUploads; },
            isUploadRunning: function() { return isUploadRunning; },
            getTotalUploadSessionsCount: function() { return filesToUploadCount; },
            getRunningUploadSessionsSizeInB: function() { return finishedUploadSessionsCountSizeInB + getTotalSizeInB(runningUploadSessions); },
            getFinishedUploadSessionsCount: function() { return finishedUploadSessionsCount; },
            getUploadSessionsSizeInB: function() { return filesToUploadSizeInB; },
            init: init,
            cancel: cancel,
            updateItem: updateItem
         };
      }

      function cancelActiveSearchRequest() {
         if (self.curretSearchRequestCanceller) {
            self.curretSearchRequestCanceller.resolve();
         }
      }

      function initDatastoreBrowser () {
         var datastoreTypePromise = dataService.getProperties($scope.datastoreId, [DS_TYPE_PROP]);
         var vcVersionPromise = vcService.is65VcOrLater($scope.datastoreId);
         $q.all([datastoreTypePromise, vcVersionPromise]).then(function(result) {
            self.isVsanDatastore = result[0][DS_TYPE_PROP] === datastoreTypeConstants.VSAN;
            self.isVvolDatastore = result[0][DS_TYPE_PROP] === datastoreTypeConstants.VVOL;
            self.is65VcOrLater = result[1];
            initController();
         });
      }

      initDatastoreBrowser();
   }
})();

var storage_ui;
(function (storage_ui) {
    var DeleteFilesService = (function () {
        function DeleteFilesService(i18nService, mutationService, clarityModalService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.clarityModalService = clarityModalService;
        }
        DeleteFilesService.prototype.openDeleteFilesDialog = function (dsRef, targetFileNames, spec, callback) {
            var _this = this;
            var confirmationMessage = this.i18nService.getString('StorageUi', 'actionDeleteFilesConfirmationText');
            if (targetFileNames.length === 1) {
                confirmationMessage = this.i18nService.getString('StorageUi', 'actionDeleteFileConfirmationText', targetFileNames[0]);
            }
            var modalOptions = {
                title: this.i18nService.getString('StorageUi', 'actionDeleteFileConfirmationTitle'),
                subTitle: {
                    objectId: dsRef
                },
                defaultButton: 'close',
                message: confirmationMessage,
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                },
                saveButtonLabel: this.i18nService.getString("Common", "yes.label"),
                cancelButtonLabel: this.i18nService.getString("Common", "no.label"),
                submit: function () {
                    _this.mutationService.apply(dsRef, "com.vmware.vsphere.client.h5.storage.spec.DatastoreDeleteFileSpec", spec).then(function (result) {
                        if (callback) {
                            callback(result);
                        }
                    });
                    return true;
                }
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        DeleteFilesService.$inject = ["i18nService", "mutationService", "clarityModalService"];
        return DeleteFilesService;
    }());
    storage_ui.DeleteFilesService = DeleteFilesService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("deleteFilesService", DeleteFilesService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var FolderDownloadService = (function () {
        function FolderDownloadService(i18nService, clarityModalService, clarityConstants, $q, datastoreBrowserTreeService, bytesFilter) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.$q = $q;
            this.datastoreBrowserTreeService = datastoreBrowserTreeService;
            this.bytesFilter = bytesFilter;
        }
        /**
         * Displays DownloadFolderDialog while retrieving folder's children.
         */
        FolderDownloadService.prototype.getFolderChildren = function (datastoreId, folderItem) {
            var _this = this;
            var deferred = this.$q.defer();
            var childFileItems = [];
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "downloadFolderDialog.title"),
                subTitle: folderItem.formattedName,
                defaultButton: "submit",
                submitButtonTitle: this.i18nService.getString("StorageUi", "downloadFolderDialog.downloadButton"),
                submitDisabled: true,
                contentTemplate: "storage-ui/resources/storage/views/manage/files/DownloadFolderDialog.html",
                onSubmit: function () {
                    deferred.resolve(childFileItems);
                    return true;
                },
                onCancel: function () {
                    deferred.resolve(null);
                    return true;
                }
            };
            modalOptions.dialogData = {
                loading: true,
                loadingText: this.i18nService.getString("StorageUi", "downloadFolderDialog.calculating"),
                confirmationText: ""
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            var totalFileSize = 0;
            var numberOfFolders = 0;
            this.datastoreBrowserTreeService.searchResults(datastoreId, folderItem.path, "")
                .then(function (searchResults) {
                _.forEach(searchResults, function (fileItem) {
                    if (fileItem.type !== FolderDownloadService.FOLDER_TYPE) {
                        childFileItems.push(fileItem);
                        if (fileItem.size) {
                            totalFileSize += fileItem.size;
                        }
                    }
                    else {
                        numberOfFolders++;
                    }
                });
            })
                .finally(function () {
                modalOptions.dialogData.loading = false;
                if (!childFileItems.length) {
                    modalOptions.dialogData.confirmationText = _this.i18nService.getString("StorageUi", "downloadFolderDialog.emptyFolderMsg");
                    modalOptions.dialogData.icon = "error-standard";
                    modalOptions.dialogData.iconClass = "is-error";
                }
                else {
                    modalOptions.dialogData.confirmationText = _this.i18nService.getString("StorageUi", "downloadFolderDialog.folderInfo", childFileItems.length.toString(), numberOfFolders.toString(), _this.bytesFilter(totalFileSize, "B"));
                    modalOptions.dialogData.icon = "info-standard";
                    modalOptions.dialogData.iconClass = "is-info";
                    modalOptions.submitDisabled = false;
                }
            });
            return deferred.promise;
        };
        FolderDownloadService.FOLDER_TYPE = "folder";
        FolderDownloadService.$inject = ["i18nService", "clarityModalService",
            "clarityConstants", "$q", "datastoreBrowserTreeService", "bytesFilter"];
        return FolderDownloadService;
    }());
    storage_ui.FolderDownloadService = FolderDownloadService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("folderDownloadService", FolderDownloadService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreFileBrowserFooterController = (function () {
        function DatastoreFileBrowserFooterController(i18nService, bytesFilter) {
            this.i18nService = i18nService;
        }
        DatastoreFileBrowserFooterController.prototype.$onInit = function () { };
        DatastoreFileBrowserFooterController.$inject = ["i18nService", "bytesFilter"];
        return DatastoreFileBrowserFooterController;
    }());
    storage_ui.DatastoreFileBrowserFooterController = DatastoreFileBrowserFooterController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastoreFileBrowserFooter", {
        controller: DatastoreFileBrowserFooterController,
        bindings: {
            showUploads: "<",
            isUploadRunning: "<",
            uploadedItems: "<",
            enqueuedItems: "<",
            uploadedItemsSizeInB: "<",
            enqueuedItemsSizeInB: "<",
            onCancelUploadClicked: "&"
        },
        templateUrl: "storage-ui/resources/storage/views/manage/files/footer/DatastoreFileBrowserFooterComponent.html"
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var DatastoreBrowserPopUpController = (function () {
        function DatastoreBrowserPopUpController($document, $location, i18nService, dataService) {
            this.$document = $document;
            this.$location = $location;
            this.i18nService = i18nService;
            this.dataService = dataService;
        }
        DatastoreBrowserPopUpController.prototype.$onInit = function () {
            var _this = this;
            // Indicate that datastore browser is in pop up mode
            h5.isDatastoreBrowserPopUpWindow = true;
            // Set document title
            var queryStringParams = this.$location.search();
            var objectId = queryStringParams["datastoreId"];
            this.dataService.getProperties(objectId, ["name"]).then(function (response) {
                if (response) {
                    _this.$document[0].title = _this.i18nService.getString("StorageUi", "popupDatastoreBrowser.title", response.name);
                }
            });
        };
        DatastoreBrowserPopUpController.prototype.$onDestroy = function () {
            delete h5.isDatastoreBrowserPopUpWindow;
        };
        DatastoreBrowserPopUpController.$inject = [
            "$document", "$location", "i18nService", "dataService"];
        return DatastoreBrowserPopUpController;
    }());
    var datastoreBrowserPopUp = {
        controller: DatastoreBrowserPopUpController,
        templateUrl: "storage-ui/resources/storage/views/manage/files/popup/datastoreBrowserPopUp.html"
    };
    angular.module("com.vmware.vsphere.client.storage")
        .component("datastoreBrowserPopUp", datastoreBrowserPopUp);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var RenameFileService = (function () {
        function RenameFileService(i18nService, mutationService, datastoreConstants, defaultUriSchemeUtil, clarityModalService, vxValidatorFactory, storageValidationService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.datastoreConstants = datastoreConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityModalService = clarityModalService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.storageValidationService = storageValidationService;
        }
        RenameFileService.prototype.openRenameFileDialog = function (dsRef, spec, callback) {
            var _this = this;
            var validator = this.vxValidatorFactory.create();
            var modalOptions = {
                contentTemplate: 'storage-ui/resources/storage/views/manage/files/RenameFileView.html',
                title: this.i18nService.getString('StorageUi', 'renameFile.title'),
                subTitle: {
                    objectId: dsRef
                },
                defaultButton: 'submit',
                dialogData: {
                    spec: spec,
                    getStorageString: this.i18nService.getString.bind(this, 'StorageUi'),
                    validator: validator,
                    isValidName: this.storageValidationService.validateDatastoreBrowserItemName
                        .bind(this.storageValidationService)
                },
                alerts: [],
                onSubmit: function () {
                    var errors = validator.validate();
                    if (errors && errors.length) {
                        return false;
                    }
                    _this.mutationService.apply(dsRef, "com.vmware.vsphere.client.storage.DatastoreFileRenameSpec", spec).then(function () {
                        if (callback) {
                            callback();
                        }
                    });
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        RenameFileService.$inject = ["i18nService", "mutationService", "datastoreConstants",
            "defaultUriSchemeUtil", "clarityModalService", "vxValidatorFactory", "storageValidationService"];
        return RenameFileService;
    }());
    storage_ui.RenameFileService = RenameFileService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("renameFileService", RenameFileService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var StreamVmdkService = (function () {
        function StreamVmdkService(i18nService, clarityModalService, $q) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
        }
        /**
         * Displays Download/Upload VMDK Dialog
         */
        StreamVmdkService.prototype.openStreamVmdkWarningDialog = function (selectedFile) {
            var deferred = this.$q.defer();
            var modalOptions = {
                contentTemplate: "storage-ui/resources/storage/views/manage/files/StreamVmdkWarningDialog.html",
                defaultButton: "submit",
                dialogData: {},
                onSubmit: function () {
                    deferred.resolve(selectedFile);
                    return true;
                },
                onCancel: function () {
                    deferred.resolve(null);
                    return false;
                }
            };
            if (selectedFile) {
                // download specific
                modalOptions.title = this.i18nService.getString("StorageUi", "vsanVmdkDownloadWarningDialog.title");
                modalOptions.dialogData.warningDialogText = this.i18nService.getString("StorageUi", "vsanVmdkDownloadWarningDialog.text");
                modalOptions.submitButtonTitle = this.i18nService.getString("StorageUi", "vsanVmdkDownloadWarningDialog.submitButtonTitle");
            }
            else {
                // upload specific
                modalOptions.title = this.i18nService.getString("StorageUi", "vsanVmdkUploadWarningDialog.title");
                modalOptions.dialogData.warningDialogText = this.i18nService.getString("StorageUi", "vsanVmdkUploadWarningDialog.text");
                modalOptions.submitButtonTitle = this.i18nService.getString("StorageUi", "vsanVmdkUploadWarningDialog.submitButtonTitle");
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
            return deferred.promise;
        };
        StreamVmdkService.$inject = ["i18nService", "clarityModalService", "$q"];
        return StreamVmdkService;
    }());
    storage_ui.StreamVmdkService = StreamVmdkService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("streamVmdkService", StreamVmdkService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').controller(
         'HardwareAccelerationViewController', HardwareAccelerationViewController);

   HardwareAccelerationViewController.$inject = [
      '$scope',
      'vuiConstants',
      'i18nService',
      'dataService',
      'columnRenderersRegistry',
      'defaultUriSchemeUtil'
   ];

   function HardwareAccelerationViewController($scope, vuiConstants, i18nService, dataService, columnRenderersRegistry, defaultUriSchemeUtil) {
      var hostHardwareAccelerationProperty = 'storage:hostHardwareAccelerationForDatastore';
      var vStorageSupportLocalizationKeyMap = {
         'vStorageSupported': 'datastore.vStorage.supported',
         'vStorageUnsupported': 'datastore.vStorage.notSupported',
         'vStorageUnknown': 'datastore.vStorage.unknown',
         'SUPPORTED_ON_ALL_HOSTS': 'datastore.manage.hardwareAcceleration.vStorageSupportedOnAll',
         'SUPPORTED_ON_SOME_HOSTS': 'datastore.manage.hardwareAcceleration.vStorageSupportedOnSome',
         'NOT_SUPPORTED_ON_ANY_HOST': 'datastore.manage.hardwareAcceleration.vStorageSupportedNotSupported'
      };
      var self = this;
      self.datastoreId = $scope._route.objectId;
      self.hostConnectivityLoading = false;

      self.liveRefreshProperties = [
         'host'
      ];

      self.datagridOptions = {
         height: '100%',
         columnDefs: getColumnDefinitions(),
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         data: [],
         selectedItems: [],
         resizable: false
      };

      self.headerOptions = {title: ''};

      self.refresh = function () {
         self.hostConnectivityLoading = true;
         dataService.getProperties(self.datastoreId, [hostHardwareAccelerationProperty])
               .then(function (response) {
                  if (response && response[hostHardwareAccelerationProperty]) {
                     self.datagridOptions.data = response[hostHardwareAccelerationProperty].hostHardwareAccelerationItems;
                     var localizationKey = vStorageSupportLocalizationKeyMap[response[hostHardwareAccelerationProperty].summary];
                     self.headerOptions.title = i18nService.getString('StorageUi', localizationKey);
                  }
               })
               .finally(function () {
                  self.hostConnectivityLoading = false;
               });
      };

      self.refresh();

      function getColumnDefinitions() {
         return [
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.hardwareAcceleration.list.columnHeader.hostName'),
               field: 'hostName',
               width: '150px',
               template: function (dataItem) {
                  var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
                  var modifiedData = {
                     hostName: dataItem.hostName,
                     hostId: defaultUriSchemeUtil.getVsphereObjectId(dataItem.hostRef)
                  };
                  return objectLinkRenderer(['hostId', 'hostName', 'vsphere-icon-host'], modifiedData);
               }
            },
            {
               displayName: i18nService.getString('StorageUi', 'datastore.manage.hardwareAcceleration.list.columnHeader.hardwareAcceleration'),
               field: 'hardwareAccelerationSupport',
               width: '150px',
               template: function (dataItem) {
                  var localizationKey = vStorageSupportLocalizationKeyMap[dataItem.hardwareAccelerationSupport];
                  return i18nService.getString('StorageUi', localizationKey);
               }
            }
         ];
      }
   }
})();
var storage_ui;
(function (storage_ui) {
    var AddStorageProviderSettingsApi = (function () {
        function AddStorageProviderSettingsApi() {
        }
        return AddStorageProviderSettingsApi;
    }());
    storage_ui.AddStorageProviderSettingsApi = AddStorageProviderSettingsApi;
    var StorageProviderSettings = (function () {
        function StorageProviderSettings() {
        }
        return StorageProviderSettings;
    }());
    storage_ui.StorageProviderSettings = StorageProviderSettings;
    var AddStorageProviderDialogService = (function () {
        function AddStorageProviderDialogService(i18nService, clarityModalService, clarityConstants, mutationService, vuiConstants, timeFormatterService, $q, fileReaderService, $rootScope) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.mutationService = mutationService;
            this.vuiConstants = vuiConstants;
            this.timeFormatterService = timeFormatterService;
            this.$q = $q;
            this.fileReaderService = fileReaderService;
            this.$rootScope = $rootScope;
        }
        AddStorageProviderDialogService.prototype.showAddStorageProviderDialog = function (vcId, providerNames) {
            var self = this;
            var providerSettings = new StorageProviderSettings();
            var addStorageProviderSettingsApi = new AddStorageProviderSettingsApi();
            var dialogData = {
                providerSettings: providerSettings,
                providerNames: providerNames,
                addStorageProviderSettingsApi: addStorageProviderSettingsApi
            };
            var modalOptions = {
                title: this.i18nService.getString("StorageUi", "storage.storageProviders.newStorageProviderForm.title"),
                subTitle: {
                    objectId: vcId
                },
                contentTemplate: "storage-ui/resources/storage/views/storageProviders/actions/AddStorageProviderDialog.html",
                defaultButton: "submit",
                onSubmit: onSubmit,
                dialogData: dialogData,
                alerts: []
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            function onSubmit() {
                if (modalOptions.dialogData.loading) {
                    return false;
                }
                // Clear previous validation messages
                modalOptions.alerts = [];
                var validationRes = null;
                if (typeof dialogData.addStorageProviderSettingsApi.validate === "function") {
                    validationRes = dialogData.addStorageProviderSettingsApi.validate();
                }
                if (validationRes && !validationRes.result) {
                    return false;
                }
                var spec = {
                    _type: "com.vmware.vsphere.client.sms.StorageProviderRegisterSpec",
                    providerName: providerSettings.name,
                    username: providerSettings.username,
                    providerUrl: providerSettings.providerUrl,
                    password: providerSettings.password
                };
                modalOptions.dialogData.loading = true;
                modalOptions.dialogData.loadingMsg = self.i18nService.getString("StorageUi", "storage.storageProviders.newStorageProviderForm.registering");
                if (providerSettings.customCertificateFile) {
                    return self.fileReaderService.readFileContentAsBase64(providerSettings.customCertificateFile).then(function (fileContent) {
                        if (!fileContent) {
                            modalOptions.alerts = [{
                                    text: self.i18nService.getString("StorageUi", "storage.storageProviders.newStorageProviderForm.invalidFile"),
                                    type: self.vuiConstants.notifications.type.ERROR
                                }];
                            modalOptions.dialogData.loading = false;
                            return false;
                        }
                        spec.certificate = fileContent;
                        return triggerMutationCall(spec).finally(function () {
                            modalOptions.dialogData.loading = false;
                        });
                    }).finally(function () {
                        modalOptions.dialogData.loading = false;
                        return false;
                    });
                }
                else {
                    return triggerMutationCall(spec).finally(function () {
                        modalOptions.dialogData.loading = false;
                    });
                }
            }
            function triggerMutationCall(spec) {
                return self.mutationService.apply(vcId, spec._type, spec).then(function (response) {
                    if (!response) {
                        return false;
                    }
                    if (response && response.error && response.result && response.result.certificate && response.result.sslThumbprint) {
                        return showCertificateWarning(response.result).then(function (acceptCertificate) {
                            if (acceptCertificate) {
                                spec.certificate = response.result.certificate;
                                return triggerMutationCall(spec);
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if (response.error && response.error.localizedMessage) {
                        modalOptions.alerts = [{
                                text: response.error.localizedMessage,
                                type: self.vuiConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    self.$rootScope.$broadcast('vsphere.core.storage.storageProviders.providersList.refreshProvidersList');
                    return true;
                });
            }
            function showCertificateWarning(certInfo) {
                var warningMessagePromise;
                if (!certInfo.details) {
                    warningMessagePromise = self.$q.when(self.i18nService.getString("StorageUi", "h5.storage.storageProviders.newStorageProviderForm.sslVerifyWarningMsgFormat", certInfo.sslThumbprint));
                }
                else {
                    var timePromises = {
                        validFrom: self.timeFormatterService.formatDate(certInfo.details.validFrom),
                        validTo: self.timeFormatterService.formatDate(certInfo.details.validTo),
                    };
                    warningMessagePromise = self.$q.all(timePromises).then(function (timePromisesResponse) {
                        return self.i18nService.getString("StorageUi", "h5.storage.storageProviders.newStorageProviderForm.sslWithDetailsVerifyWarningMsgFormat", certInfo.sslThumbprint, certInfo.details.issuerName, certInfo.details.subjectName, timePromisesResponse.validFrom, timePromisesResponse.validTo);
                    });
                }
                var deferredConfirmationResponse = self.$q.defer();
                warningMessagePromise.then(function (warningMessage) {
                    var confirmationModalOptions = {
                        title: self.i18nService.getString("StorageUi", "storage.storageProviders.newStorageProviderForm.sslVerifyWarningTitle"),
                        message: warningMessage,
                        icon: "vx-icon-warning-32x32",
                        size: "lg",
                        saveButtonLabel: self.i18nService.getString("Common", "yes.label"),
                        cancelButtonLabel: self.i18nService.getString("Common", "no.label"),
                        preserveNewlines: true,
                        submit: function () {
                            deferredConfirmationResponse.resolve(true);
                            return true;
                        },
                        onCancel: function () {
                            deferredConfirmationResponse.resolve(false);
                        }
                    };
                    self.clarityModalService.openConfirmationModal(confirmationModalOptions);
                });
                return deferredConfirmationResponse.promise;
            }
        };
        AddStorageProviderDialogService.$inject = ["i18nService", "clarityModalService",
            "clarityConstants", "mutationService", "vuiConstants", "timeFormatterService", "$q", "fileReaderService", "$rootScope"];
        return AddStorageProviderDialogService;
    }());
    storage_ui.AddStorageProviderDialogService = AddStorageProviderDialogService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("addStorageProviderDialogService", AddStorageProviderDialogService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var AddStorageProviderSettings = (function () {
        function AddStorageProviderSettings(i18nService, $element, $timeout, vxValidatorFactory, idGeneratorService) {
            var _this = this;
            this.i18nService = i18nService;
            this.$element = $element;
            this.$timeout = $timeout;
            this.vxValidatorFactory = vxValidatorFactory;
            this.idGeneratorService = idGeneratorService;
            this.PROVIDER_NAME_MAX_CHARS = 80;
            this.USERNAME_MAX_CHARS = 255;
            this.PASSWORD_MAX_CHARS = 255;
            this.useCustomCertificate = false;
            this.INVALID_CHARACTERS = /!|@|#|%|\^|\&|\*/;
            this.validateName = function (inputValue) {
                var errors = [];
                if (!_this.validateInvalidCharacters(inputValue)) {
                    errors.push(_this.i18n("StorageUi", "storage.storageProviders.newStorageProviderForm.invalidChars"));
                }
                else if (!_this.validateIsProviderNameUnique(inputValue)) {
                    errors.push(_this.i18n("StorageUi", "storage.storageProviders.newStorageProviderForm.providerNameExists"));
                }
                return errors;
            };
            this.validateUsername = function (inputValue) {
                var errors = [];
                if (!_this.validateInvalidCharacters(inputValue)) {
                    errors.push(_this.i18n("StorageUi", "storage.storageProviders.newStorageProviderForm.invalidChars"));
                }
                return errors;
            };
            this.i18n = i18nService.getString;
            this.validator = this.vxValidatorFactory.create();
        }
        AddStorageProviderSettings.prototype.$onInit = function () {
            if (this.componentApi) {
                this.componentApi.validate = this.validate.bind(this);
            }
            var ctrl = this;
            var certificateFileInput = this.$element.find(".storage-provider-certificate-upload-file-input");
            certificateFileInput.on("change", function (event) {
                if (event.target.files && event.target.files.length) {
                    ctrl.setCertificateFile(event.target.files[0]);
                }
                this.value = null;
            });
            this.nameInputId = this.idGeneratorService.nextId();
            this.urlInputId = this.idGeneratorService.nextId();
            this.usernameInputId = this.idGeneratorService.nextId();
            this.passwordInputId = this.idGeneratorService.nextId();
            this.certificateLocationLabelId = this.idGeneratorService.nextId();
        };
        AddStorageProviderSettings.prototype.setCertificateFile = function (file) {
            this.customCertificateFile = file;
            this.certificateFileLocation = file.name;
            this.updateCertificateFile();
        };
        AddStorageProviderSettings.prototype.unsetCertificateFile = function () {
            if (this.certificateFileLocation) {
                this.customCertificateFile = null;
                this.certificateFileLocation = '';
                this.updateCertificateFile();
            }
        };
        AddStorageProviderSettings.prototype.updateCertificateFile = function () {
            if (this.useCustomCertificate) {
                this.providerSettings.customCertificateFile = this.customCertificateFile;
            }
            else {
                this.providerSettings.customCertificateFile = null;
            }
        };
        AddStorageProviderSettings.prototype.onBrowseCertificate = function () {
            var certificateFileInput = this.$element.find(".storage-provider-certificate-upload-file-input");
            this.$timeout(function () {
                certificateFileInput.click();
            });
        };
        AddStorageProviderSettings.prototype.validate = function () {
            var validationErrors = this.validator.validate();
            return {
                result: !(validationErrors && validationErrors.length),
                errors: validationErrors
            };
        };
        AddStorageProviderSettings.prototype.validateInvalidCharacters = function (inputValue) {
            return !(inputValue && this.INVALID_CHARACTERS.test(inputValue));
        };
        AddStorageProviderSettings.prototype.validateIsProviderNameUnique = function (inputValue) {
            return !(this.providerNames && this.providerNames.indexOf(inputValue) >= 0);
        };
        AddStorageProviderSettings.$inject = ["i18nService", "$element", "$timeout", "vxValidatorFactory", "idGeneratorService"];
        return AddStorageProviderSettings;
    }());
    storage_ui.AddStorageProviderSettings = AddStorageProviderSettings;
    angular.module("com.vmware.vsphere.client.storage")
        .component("addStorageProviderSettings", {
        templateUrl: "storage-ui/resources/storage/views/storageProviders/actions/AddStorageProviderSettings.html",
        bindings: {
            providerSettings: "=",
            providerNames: "<",
            componentApi: "="
        },
        controller: AddStorageProviderSettings
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProviderCertificateDetails = (function () {
        function StorageProviderCertificateDetails(storageProvidersItemBuilderService) {
            this.storageProvidersItemBuilderService = storageProvidersItemBuilderService;
        }
        StorageProviderCertificateDetails.prototype.$onChanges = function () {
            this.refresh();
        };
        StorageProviderCertificateDetails.prototype.refresh = function () {
            var _this = this;
            if (!this.storageProviderListItem) {
                return;
            }
            this.propertyViewData = null;
            this.storageProvidersItemBuilderService.getStorageProviderCertificateDetails(this.storageProviderListItem).then(function (certificateProperties) {
                _this.propertyViewData = certificateProperties;
            });
        };
        StorageProviderCertificateDetails.$inject = ["storageProvidersItemBuilderService"];
        return StorageProviderCertificateDetails;
    }());
    storage_ui.StorageProviderCertificateDetails = StorageProviderCertificateDetails;
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageProviderCertificateDetails", {
        template: "<vx-property-view data=\"$ctrl.propertyViewData\"></vx-property-view>",
        bindings: {
            storageProviderListItem: "<"
        },
        controller: StorageProviderCertificateDetails
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProviderItemGeneralDetails = (function () {
        function StorageProviderItemGeneralDetails(storageProvidersItemBuilderService) {
            this.storageProvidersItemBuilderService = storageProvidersItemBuilderService;
        }
        StorageProviderItemGeneralDetails.prototype.$onChanges = function () {
            this.refresh();
        };
        StorageProviderItemGeneralDetails.prototype.refresh = function () {
            if (!this.storageProviderListItem) {
                return;
            }
            if (this.storageProviderListItem._isStorageProviderItem) {
                this.propertyViewData = this.storageProvidersItemBuilderService.getStorageProviderGeneralDetails(this.storageProviderListItem);
            }
            else if (this.storageProviderListItem._isStorageArrayItem) {
                this.propertyViewData = this.storageProvidersItemBuilderService.getStorageArrayGeneralDetails(this.storageProviderListItem);
            }
        };
        StorageProviderItemGeneralDetails.$inject = ["storageProvidersItemBuilderService"];
        return StorageProviderItemGeneralDetails;
    }());
    storage_ui.StorageProviderItemGeneralDetails = StorageProviderItemGeneralDetails;
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageProviderItemGeneralDetails", {
        template: "<vx-property-view data=\"$ctrl.propertyViewData\"></vx-property-view>",
        bindings: {
            storageProviderListItem: "<"
        },
        controller: StorageProviderItemGeneralDetails
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProviderSupportedVendorIds = (function () {
        function StorageProviderSupportedVendorIds(storageProvidersItemBuilderService, vuiConstants, i18nService) {
            this.storageProvidersItemBuilderService = storageProvidersItemBuilderService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
        }
        StorageProviderSupportedVendorIds.prototype.$onChanges = function () {
            this.refresh();
        };
        StorageProviderSupportedVendorIds.prototype.getColumnDefinitions = function () {
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.storageProviders.supportedVendorIdsView.vendorIdsColumn"),
                    field: "vendorId",
                    template: "#:vendorId#"
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "storage.storageProviders.supportedVendorIdsView.modelIdsColumn"),
                    field: "modelId",
                    template: "#:modelId#"
                }
            ];
        };
        StorageProviderSupportedVendorIds.prototype.refresh = function () {
            var vendorIdItems = [];
            if (this.storageProviderListItem) {
                vendorIdItems = this.storageProvidersItemBuilderService.getSupportedVendorIdItems(this.storageProviderListItem);
            }
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                data: vendorIdItems,
                resizable: true
            };
        };
        StorageProviderSupportedVendorIds.$inject = ["storageProvidersItemBuilderService", "vuiConstants", "i18nService"];
        return StorageProviderSupportedVendorIds;
    }());
    storage_ui.StorageProviderSupportedVendorIds = StorageProviderSupportedVendorIds;
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageProviderSupportedVendorIds", {
        template: "<div vui-datagrid=\"$ctrl.datagridOptions\" class=\"fill-parent vui-grid-cell-ellipsis\"></div>",
        bindings: {
            storageProviderListItem: "<"
        },
        controller: StorageProviderSupportedVendorIds
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    angular.module("com.vmware.vsphere.client.storage").constant("storageProviderConstants", {
        vasaProviderStatus: {
            offline: "offline",
            online: "online",
            syncError: "syncError",
            connected: "connected",
            disconnected: "disconnected"
        },
        certificateStatus: {
            expired: "expired",
            expirySoftLimitReached: "expirySoftLimitReached",
            expiryHardLimitReached: "expiryHardLimitReached",
            valid: "valid"
        },
        vasaProviderInfoType: {
            PERSISTENCE: "PERSISTENCE"
        },
        vasaProviderInfoCategory: {
            internal: "internal"
        },
        actions: {
            ADD: "vsphere.core.storage.storageProviders.addNew",
            RESYNC_INTERNAL_PROVIDER: "vsphere.core.storage.storageProviders.resyncInternalVasaProvider",
            REMOVE: "vsphere.core.storage.storageProviders.remove",
            SYNC: "vsphere.core.storage.storageProviders.sync",
            REFRESH_CERTIFICATE: "vsphere.core.storage.storageProviders.refreshCertificate"
        }
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProvidersActionService = (function () {
        function StorageProvidersActionService(storageProvidersItemBuilderService, storageProviderConstants) {
            this.storageProvidersItemBuilderService = storageProvidersItemBuilderService;
            this.storageProviderConstants = storageProviderConstants;
            this.VASA_API_VERSION_1_0 = "1.0";
            this.VASA_API_VERSION_1_5 = "1.5";
        }
        StorageProvidersActionService.prototype.isVasaProviderItem = function (item) {
            return item && item._isStorageProviderItem && item._data &&
                this.storageProvidersItemBuilderService.isVasaProviderInfo(item._data.providerInfo);
        };
        StorageProvidersActionService.prototype.isRemoveProviderActionAvailable = function (item) {
            if (!this.isVasaProviderItem(item)) {
                return false;
            }
            return item._data.providerInfo.category !== this.storageProviderConstants.vasaProviderInfoCategory.internal;
        };
        StorageProvidersActionService.prototype.isSyncProviderActionAvailable = function (item) {
            if (!this.isVasaProviderItem(item)) {
                return false;
            }
            var providerInfo = item._data.providerInfo;
            var isArrayIndependentProvider = providerInfo.arrayIndependentProvider;
            if (isArrayIndependentProvider || providerInfo.vasaVersion === this.VASA_API_VERSION_1_0) {
                // Sync button should always be enabled for legacy or array independent providers
                return true;
            }
            // Iterate through the related storage array and allow sync if the
            // provider is active for at least one array
            var activeArray = _.find(providerInfo.relatedStorageArray, function (relatedArray) {
                return relatedArray && relatedArray.active;
            });
            return !!activeArray;
        };
        StorageProvidersActionService.prototype.isRefreshCertificateActionAvailable = function (item) {
            if (!this.isVasaProviderItem(item)) {
                return false;
            }
            var providerInfo = item._data.providerInfo;
            // Refresh certificate action should not be available for providers with version 1.0
            // or 1.5 (VSAN providers).
            if (providerInfo.vasaVersion === this.VASA_API_VERSION_1_0 ||
                providerInfo.vasaVersion === this.VASA_API_VERSION_1_5) {
                return false;
            }
            // Refresh action should be disabled if the retainVasaProviderCertificate flag is true.
            if (providerInfo.retainVasaProviderCertificate === true) {
                return false;
            }
            // Refresh action should be disabled if the vasaProviderInfoCategory is internal.
            if (providerInfo.category === this.storageProviderConstants.vasaProviderInfoCategory.internal) {
                return false;
            }
            return true;
        };
        StorageProvidersActionService.$inject = ["storageProvidersItemBuilderService", "storageProviderConstants"];
        return StorageProvidersActionService;
    }());
    storage_ui.StorageProvidersActionService = StorageProvidersActionService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageProvidersActionService", StorageProvidersActionService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProviderListItem = (function () {
        function StorageProviderListItem() {
            this._isStorageProviderItem = false;
            this._isStorageArrayItem = false;
        }
        return StorageProviderListItem;
    }());
    storage_ui.StorageProviderListItem = StorageProviderListItem;
    var StorageProvidersItemBuilderService = (function () {
        function StorageProvidersItemBuilderService(i18nService, defaultUriSchemeUtil, storageProviderConstants, timeFormatterService, vxPropertyViewService, $q) {
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageProviderConstants = storageProviderConstants;
            this.timeFormatterService = timeFormatterService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$q = $q;
            this.STORAGE_SUPPORTED_PROFILES_PREFIX = "storage.storageProviders.storageArrayView.supportedProfile.";
            this.NA_STRING = i18nService.getString("StorageUi", "informationNotAccessible");
        }
        StorageProvidersItemBuilderService.prototype.getProviderCentricData = function (storageProviderSystemInfoEx) {
            var self = this;
            var listItemIndex = 0;
            function generateId() {
                return "itemId_" + listItemIndex++;
            }
            var resultItems = [];
            var storageProviderItemsById = {};
            var timeFormatPromises = [];
            _.forEach(storageProviderSystemInfoEx, function (infoItem) {
                _.forEach(infoItem.storageProviderInfoList, function (storageProviderInfo) {
                    var providerItemId = storageProviderInfo.provider.value;
                    if (!storageProviderItemsById.hasOwnProperty(providerItemId)) {
                        var providerItem = self.createStorageProviderItem(storageProviderInfo, providerItemId, timeFormatPromises);
                        storageProviderItemsById[providerItemId] = providerItem;
                        resultItems.push(providerItem);
                    }
                    var storageArrayItem = self.createStorageArrayItem(infoItem, storageProviderInfo, generateId(), providerItemId);
                    resultItems.push(storageArrayItem);
                });
            });
            return this.$q.all(timeFormatPromises).then(function () {
                return resultItems;
            });
        };
        StorageProvidersItemBuilderService.prototype.createStorageArrayItem = function (storageProviderSystemInfoEx, storageProviderInfo, id, parentId) {
            var item = new StorageProviderListItem();
            item.id = this.generateStorageArrayItemId(storageProviderSystemInfoEx, parentId, id);
            item.parentId = parentId;
            item.nameFormatted = this.formatStorageArrayName(storageProviderSystemInfoEx, storageProviderInfo);
            item.providerStatusFormatted = "";
            item.activeStandbyFormatted = this.formatStorageArrayActiveStandby(storageProviderInfo);
            item.priorityFormatted = this.formatStorageArrayPriority(storageProviderSystemInfoEx, storageProviderInfo);
            item.urlFormatted = "";
            item.lastSyncTime = 0;
            item.lastSyncTimeFormatted = "";
            item.certificateExpiryTime = 0;
            item.certificateExpiryTimeFormatted = "";
            item.vasaApiVersionFormatted = "";
            item._data = storageProviderSystemInfoEx;
            item._isStorageArrayItem = true;
            return item;
        };
        StorageProvidersItemBuilderService.prototype.formatStorageArrayPriority = function (storageProviderSystemInfoEx, storageProviderInfo) {
            if (!storageProviderSystemInfoEx.storageArray || !storageProviderSystemInfoEx.storageArray.uuid || !this.isVasaProviderInfo(storageProviderInfo.providerInfo)) {
                return this.NA_STRING;
            }
            var relatedArray = _.find(storageProviderInfo.providerInfo.relatedStorageArray, function (relatedStorageArray) {
                return relatedStorageArray && relatedStorageArray.arrayId ===
                    storageProviderSystemInfoEx.storageArray.uuid;
            });
            if (relatedArray) {
                return "" + relatedArray.priority;
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.formatStorageArrayActiveStandby = function (storageProviderInfo) {
            if (!storageProviderInfo) {
                return this.NA_STRING;
            }
            if (storageProviderInfo.isActive === true) {
                return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.activeColumn.activeValue");
            }
            else if (storageProviderInfo.isActive === false) {
                return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.activeColumn.standbyValue");
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.generateStorageArrayItemId = function (storageProviderSystemInfoEx, parentId, defaultId) {
            if (!storageProviderSystemInfoEx.storageArray) {
                return defaultId;
            }
            return storageProviderSystemInfoEx.storageArray.uuid + "_" + parentId;
        };
        StorageProvidersItemBuilderService.prototype.formatStorageArrayName = function (storageProviderSystemInfoEx, storageProviderInfo) {
            var numberOfProviders = storageProviderSystemInfoEx.storageProviderInfoList ?
                storageProviderSystemInfoEx.storageProviderInfoList.length : 0;
            var onlineProviders = storageProviderSystemInfoEx.numOnlineStorageProviders;
            if (!storageProviderSystemInfoEx.storageArray) {
                if (this.isIndependentPersistentProvider(storageProviderInfo)) {
                    // Show label for undefined storage arrays associated with
                    // arrayIndependent persistent internal provider.
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.nameColumn.internallyManagedStorageArray");
                }
                else {
                    // Show label for undefined storage arrays
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.nameColumn.undefinedStorageArrayTitleFormat", onlineProviders, numberOfProviders);
                }
            }
            else {
                var dsName = storageProviderSystemInfoEx.storageArrayFriendlyName
                    || storageProviderSystemInfoEx.storageArray.name;
                return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.nameColumn.storageArrayTitleFormat", dsName, onlineProviders, numberOfProviders);
            }
        };
        StorageProvidersItemBuilderService.prototype.isIndependentPersistentProvider = function (storageProvider) {
            if (!storageProvider || !this.isVasaProviderInfo(storageProvider.providerInfo)) {
                return false;
            }
            var providerInfo = storageProvider.providerInfo;
            var isArrayIndependent = !!providerInfo.arrayIndependentProvider;
            var isPersistent = providerInfo.type === this.storageProviderConstants.vasaProviderInfoType.PERSISTENCE;
            var isInternal = providerInfo.category === this.storageProviderConstants.vasaProviderInfoCategory.internal;
            return isArrayIndependent && isPersistent && isInternal;
        };
        StorageProvidersItemBuilderService.prototype.isVasaProviderInfo = function (providerInfo) {
            return providerInfo && providerInfo._type === "com.vmware.vim.binding.sms.provider.VasaProviderInfo";
        };
        StorageProvidersItemBuilderService.prototype.formatActivationMode = function (providerInfo) {
            if (this.isVasaProviderInfo(providerInfo)) {
                if (providerInfo.needsExplicitActivation === true) {
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.activation.manual");
                }
                else {
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.activation.auto");
                }
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.formatNamespace = function (providerInfo) {
            if (this.isVasaProviderInfo(providerInfo)) {
                return providerInfo.namespace || this.NA_STRING;
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.formatProviderId = function (providerInfo) {
            if (this.isVasaProviderInfo(providerInfo)) {
                return providerInfo.providerId || this.NA_STRING;
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.formatSupportedProfiles = function (supportedProviderProfile) {
            var _this = this;
            if (supportedProviderProfile) {
                var profileNames_1 = [];
                _.forEach(supportedProviderProfile, function (profile) {
                    if (profile) {
                        var formattedProfileName = _this.i18nService.getString("StorageUi", _this.STORAGE_SUPPORTED_PROFILES_PREFIX + profile);
                        // Check if the provided storage profile has localization.
                        // If not use the provided value from backend.
                        if (formattedProfileName.indexOf(_this.STORAGE_SUPPORTED_PROFILES_PREFIX) === 0) {
                            formattedProfileName = profile;
                        }
                        if (formattedProfileName) {
                            profileNames_1.push(formattedProfileName);
                        }
                    }
                });
                if (profileNames_1.length) {
                    return profileNames_1;
                }
            }
            return [this.NA_STRING];
        };
        StorageProvidersItemBuilderService.prototype.formatArrayProperty = function (property) {
            if (!property || property.length === 0) {
                return this.NA_STRING;
            }
            if (property.join(" ").trim()) {
                return property;
            }
            return this.NA_STRING;
        };
        StorageProvidersItemBuilderService.prototype.getStorageArrayGeneralDetails = function (storageProviderListItem) {
            var storageArray = storageProviderListItem && storageProviderListItem._data && storageProviderListItem._data.storageArray;
            if (!storageArray) {
                return null;
            }
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.arrayName"), storageProviderListItem._data.storageArrayFriendlyName || storageArray.name || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.uuid"), storageArray.uuid || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.vendorId"), storageArray.vendorId || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.modelId"), storageArray.modelId || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.firmware"), storageArray.firmware || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.alternateName"), this.formatArrayProperty(storageArray.alternateName));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.supportedBlockInterface"), this.formatArrayProperty(storageArray.supportedBlockInterface));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.supportedFileSystemInterface"), this.formatArrayProperty(storageArray.supportedFileSystemInterface));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.supportedProfile"), this.formatSupportedProfiles(storageArray.supportedProfile));
            return builder.build();
        };
        StorageProvidersItemBuilderService.prototype.getStorageProviderGeneralDetails = function (storageProviderListItem) {
            var providerInfo = storageProviderListItem &&
                storageProviderListItem._data &&
                storageProviderListItem._data.providerInfo;
            if (!providerInfo) {
                return null;
            }
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.providerName"), providerInfo.name || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.providerStatus"), storageProviderListItem.providerStatusFormatted);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.activeStandbyStatus"), storageProviderListItem.activeStandbyFormatted);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.needsExplicitActivation"), this.formatActivationMode(providerInfo));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.url"), storageProviderListItem.urlFormatted);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.providerVersion"), providerInfo.version || this.NA_STRING);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.apiVersion"), storageProviderListItem.vasaApiVersionFormatted);
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.defaultNamespace"), this.formatNamespace(providerInfo));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.providerId"), this.formatProviderId(providerInfo));
            generalSection.property(this.i18nService.getString("StorageUi", "storage.storageProviders.storageArrayView.supportedProfile"), this.isVasaProviderInfo(providerInfo)
                ? this.formatSupportedProfiles(providerInfo.supportedProviderProfile)
                : this.NA_STRING);
            return builder.build();
        };
        StorageProvidersItemBuilderService.prototype.getStorageProviderCertificateDetails = function (storageProviderListItem) {
            var _this = this;
            if (!storageProviderListItem || !storageProviderListItem._data) {
                return this.$q.when(null);
            }
            var certificateDetailsInfo = storageProviderListItem._data.certificateDetailsInfo || {};
            var timePromises = {
                validFrom: this.timeFormatterService.formatDate(certificateDetailsInfo.validFrom),
                validTo: this.timeFormatterService.formatDate(certificateDetailsInfo.validTo),
            };
            return this.$q.all(timePromises).then(function (timePromisesResponse) {
                var builder = _this.vxPropertyViewService.createPropertyViewBuilder();
                var generalCategory = builder.category("general");
                var generalSection = generalCategory.section("generalSection");
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.subject"), certificateDetailsInfo.subjectName || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.issuer"), certificateDetailsInfo.issuerName || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.version"), certificateDetailsInfo.version || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.kind"), certificateDetailsInfo.kind || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.validFrom"), timePromisesResponse.validFrom || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.validTo"), timePromisesResponse.validTo || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.algorithm"), certificateDetailsInfo.algorithmName || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.publicKeyAlgorithm"), certificateDetailsInfo.publicKeyAlgorithmName || _this.NA_STRING);
                return builder.build();
            });
        };
        StorageProvidersItemBuilderService.prototype.getSupportedVendorIdItems = function (storageProviderListItem) {
            var providerInfo = storageProviderListItem &&
                storageProviderListItem._data &&
                storageProviderListItem._data.providerInfo;
            if (!providerInfo || !this.isVasaProviderInfo(providerInfo)) {
                return [];
            }
            return _.map(providerInfo.supportedVendorModelMapping, function (mapping) {
                return {
                    vendorId: mapping.vendorId,
                    modelId: mapping.modelId
                };
            });
        };
        StorageProvidersItemBuilderService.prototype.createStorageProviderItem = function (storageProviderInfo, id, timeFormatPromises) {
            var item = new StorageProviderListItem();
            item.id = id;
            item.parentId = null;
            item.nameFormatted = storageProviderInfo.providerInfo.name;
            item._data = storageProviderInfo;
            item._isStorageProviderItem = true;
            if (this.isVasaProviderInfo(storageProviderInfo.providerInfo)) {
                item.urlFormatted = storageProviderInfo.providerInfo.url || this.NA_STRING;
                item.vasaApiVersionFormatted = storageProviderInfo.providerInfo.vasaVersion || this.NA_STRING;
                item.providerStatusFormatted = this.formatProviderStatus(storageProviderInfo.providerInfo.status);
                item.statusFault = storageProviderInfo.providerInfo.statusFault;
                item.lastSyncTime = moment(storageProviderInfo.providerInfo.lastSyncTime).valueOf();
                item.lastSyncTimeFormatted = this.NA_STRING;
                if (storageProviderInfo.providerInfo.lastSyncTime && !isNaN(item.lastSyncTime)) {
                    timeFormatPromises.push(this.timeFormatterService.formatDate(item.lastSyncTime).then(function (formattedDate) {
                        item.lastSyncTimeFormatted = formattedDate;
                    }));
                }
                item.certificateExpiryTime = moment(storageProviderInfo.providerInfo.certificateExpiryDate).valueOf();
                item.certificateExpiryTimeFormatted =
                    this.formatCertificateExpiryTime(storageProviderInfo.providerInfo.certificateStatus, storageProviderInfo.providerInfo.certificateExpiryDate);
                item.certificateExpiryTimeIcon =
                    this.getCertificateExpiryTimeIcon(storageProviderInfo.providerInfo.certificateStatus);
                item.activeStandbyFormatted = this.NA_STRING;
                item.priorityFormatted = this.NA_STRING;
            }
            return item;
        };
        StorageProvidersItemBuilderService.prototype.getCertificateExpiryTimeIcon = function (certificateStatus) {
            switch (certificateStatus) {
                case this.storageProviderConstants.certificateStatus.expired:
                case this.storageProviderConstants.certificateStatus.expiryHardLimitReached:
                    return "vsphere-icon-status-error";
                case this.storageProviderConstants.certificateStatus.expirySoftLimitReached:
                    return "vsphere-icon-status-warning";
            }
            return null;
        };
        StorageProvidersItemBuilderService.prototype.formatCertificateExpiryTime = function (certificateStatus, expiryDateStr) {
            if (certificateStatus === this.storageProviderConstants.certificateStatus.expired) {
                return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.certificateExpiryColumn.certificateExpired");
            }
            if (!expiryDateStr) {
                return this.NA_STRING;
            }
            var expiryDate = moment(expiryDateStr);
            if (isNaN(expiryDate.valueOf())) {
                return this.NA_STRING;
            }
            var currentDate = moment();
            var totalDays = expiryDate.diff(currentDate, "days");
            return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.certificateExpiryColumn.daysRemaining", totalDays);
        };
        StorageProvidersItemBuilderService.prototype.formatProviderStatus = function (status) {
            switch (status) {
                case this.storageProviderConstants.vasaProviderStatus.offline:
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.statusColumn.offlineValue");
                case this.storageProviderConstants.vasaProviderStatus.online:
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.statusColumn.onlineValue");
                case this.storageProviderConstants.vasaProviderStatus.syncError:
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.statusColumn.syncErrorValue");
                case this.storageProviderConstants.vasaProviderStatus.connected:
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.statusColumn.connectedValue");
                case this.storageProviderConstants.vasaProviderStatus.disconnected:
                    return this.i18nService.getString("StorageUi", "storage.storageProviders.providersList.statusColumn.disconnectedValue");
                default:
                    return this.NA_STRING;
            }
        };
        StorageProvidersItemBuilderService.$inject = ["i18nService", "defaultUriSchemeUtil", "storageProviderConstants",
            "timeFormatterService", "vxPropertyViewService", "$q"];
        return StorageProvidersItemBuilderService;
    }());
    storage_ui.StorageProvidersItemBuilderService = StorageProvidersItemBuilderService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageProvidersItemBuilderService", StorageProvidersItemBuilderService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProvidersList = (function () {
        function StorageProvidersList(i18nService, $scope, storageUtil, storageProvidersService, storageProvidersItemBuilderService, columnRenderersRegistry, $timeout, commonActionBarService, storageProviderConstants, vuiConstants, storageProvidersActionService, defaultUriSchemeUtil, vcService) {
            var _this = this;
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.storageUtil = storageUtil;
            this.storageProvidersService = storageProvidersService;
            this.storageProvidersItemBuilderService = storageProvidersItemBuilderService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.$timeout = $timeout;
            this.commonActionBarService = commonActionBarService;
            this.storageProviderConstants = storageProviderConstants;
            this.vuiConstants = vuiConstants;
            this.storageProvidersActionService = storageProvidersActionService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vcService = vcService;
            this.i18n = i18nService.getString;
            this.providerStatusDetailsMap = {};
            this.treeListWidget = null;
            this.providerListColumns = this.treeListColumns();
            this.vcService.is65VcOrLater(this.vcId)
                .then(function (is65VcOrLater) {
                if (!is65VcOrLater) {
                    _this.$scope.$on('vsphere.core.storage.storageProviders.providersList.refreshProvidersList', function () {
                        _this.refresh();
                    });
                }
            });
            this.providerListMessages = {
                noRows: ""
            };
            this.actionBarOptions = {
                actions: []
            };
        }
        StorageProvidersList.prototype.$onChanges = function () {
            this.refresh();
        };
        StorageProvidersList.prototype.$onDestroy = function () {
            kendo.destroy($("#storage-providers-list-tree"));
        };
        StorageProvidersList.prototype.setTreeListOptions = function (items) {
            this.providerListDataSource = new kendo.data.TreeListDataSource({
                data: items,
                schema: {
                    model: {
                        id: "id",
                        expanded: true
                    }
                }
            });
            this.updateActionBar();
        };
        StorageProvidersList.prototype.findTreeListItem = function (itemToFind) {
            if (!itemToFind || !this.providerListDataSource) {
                return null;
            }
            var dataSource = this.providerListDataSource;
            if (itemToFind._isStorageProviderItem) {
                return _.find(dataSource.rootNodes(), function (item) {
                    return item.id === itemToFind.id;
                });
            }
            if (itemToFind._isStorageArrayItem) {
                // For storage arrays, we need to find the parent provider item first
                var parentProviderItem = _.find(dataSource.rootNodes(), function (item) {
                    return item.id === itemToFind.parentId;
                });
                // and then check its children
                if (parentProviderItem) {
                    return _.find(dataSource.childNodes(parentProviderItem), function (item) {
                        return item.id === itemToFind.id;
                    });
                }
            }
            return null;
        };
        StorageProvidersList.prototype.onTreeListDataBound = function () {
            var _this = this;
            if (!this.itemToSelect) {
                return;
            }
            this.$timeout(function () {
                if (!_this.treeListWidget) {
                    return;
                }
                var itemToSelect = _this.findTreeListItem(_this.itemToSelect);
                if (itemToSelect) {
                    var item = _this.treeListWidget.itemFor(itemToSelect);
                    if (item) {
                        _this.treeListWidget.select(item);
                    }
                }
            }, 0);
        };
        StorageProvidersList.prototype.onSelectionChanged = function () {
            if (this.treeListWidget) {
                var dataItem = this.treeListWidget.dataItem(this.treeListWidget.select());
                if (dataItem) {
                    this.masterDetailsViewContext.selectedItems = [dataItem];
                    this.updateActionBar();
                    return;
                }
            }
            this.masterDetailsViewContext.selectedItems = [];
            this.updateActionBar();
        };
        StorageProvidersList.prototype.refresh = function () {
            if (!this.vcId || !this.defaultUriSchemeUtil.isRootFolder(this.vcId)) {
                return;
            }
            if (!this.loading) {
                this.itemToSelect =
                    this.masterDetailsViewContext.selectedItems &&
                        this.masterDetailsViewContext.selectedItems.length &&
                        this.masterDetailsViewContext.selectedItems[0];
            }
            this.loading = true;
            this.actionsCache = null;
            if (!this.providerListDataSource) {
                this.setTreeListOptions([]);
            }
            this.masterDetailsViewContext.selectedItems = [];
            var self = this;
            this.lastDataRequestPromise = this.storageProvidersService.getStorageProviderSystemInfoEx(this.vcId);
            var currentDataRequestPromise = this.lastDataRequestPromise;
            currentDataRequestPromise.then(function (items) {
                if (currentDataRequestPromise !== self.lastDataRequestPromise) {
                    return;
                }
                self.storageProvidersItemBuilderService.getProviderCentricData(items).then(function (listItems) {
                    self.setTreeListOptions(listItems);
                    // Build provider names
                    self.providerNames = _.map(_.filter(listItems, function (item) {
                        return item._isStorageProviderItem;
                    }), function (item) {
                        return item._data && item._data.providerInfo && item._data.providerInfo.name;
                    });
                    // Build providerStatusDetailsMap
                    _.each(listItems, function (item) {
                        if (item.statusFault && item.statusFault.message) {
                            self.providerStatusDetailsMap[item.id] = {
                                title: self.i18n("StorageUi", "storage.storageProviders.providersList.detailsDialog.title"),
                                message: item.statusFault.message
                            };
                        }
                    });
                });
            }).finally(function () {
                if (currentDataRequestPromise !== self.lastDataRequestPromise) {
                    return;
                }
                self.loading = false;
            });
        };
        StorageProvidersList.prototype.getStatusDetailsSignPostConfig = function (id) {
            return this.providerStatusDetailsMap[id];
        };
        StorageProvidersList.prototype.updateActionBar = function () {
            var _this = this;
            this.commonActionBarService.updateActionBar(this.actionBarOptions, "actions", [this.vcId], this.getActions(), this.actionsCache).then(function (actionDefs) {
                _this.actionsCache = actionDefs;
            });
        };
        StorageProvidersList.prototype.getSelectedItem = function () {
            if (!this.masterDetailsViewContext || !this.masterDetailsViewContext.selectedItems ||
                this.masterDetailsViewContext.selectedItems.length !== 1) {
                return null;
            }
            return this.masterDetailsViewContext.selectedItems[0];
        };
        StorageProvidersList.prototype.getActions = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: this.storageProviderConstants.actions.ADD,
                getActionInvocationContext: function () {
                    return {
                        providerNames: _this.providerNames
                    };
                }
            });
            actionDefs.push({
                actionId: this.storageProviderConstants.actions.RESYNC_INTERNAL_PROVIDER
            });
            actionDefs.push(this.vuiConstants.actions.SEPARATOR);
            actionDefs.push({
                actionId: this.storageProviderConstants.actions.SYNC,
                getActionInvocationContext: function () {
                    var selectedItem = _this.getSelectedItem();
                    return selectedItem && selectedItem._data;
                },
                isActionAvailable: function (actionDef) {
                    var selectedItem = _this.getSelectedItem();
                    if (!selectedItem || !actionDef.available) {
                        return false;
                    }
                    return _this.storageProvidersActionService.isSyncProviderActionAvailable(selectedItem);
                }
            });
            actionDefs.push({
                actionId: this.storageProviderConstants.actions.REMOVE,
                getActionInvocationContext: function () {
                    var selectedItem = _this.getSelectedItem();
                    return selectedItem && selectedItem._data;
                },
                isActionAvailable: function (actionDef) {
                    var selectedItem = _this.getSelectedItem();
                    if (!selectedItem || !actionDef.available) {
                        return false;
                    }
                    return _this.storageProvidersActionService.isRemoveProviderActionAvailable(selectedItem);
                }
            });
            actionDefs.push({
                actionId: this.storageProviderConstants.actions.REFRESH_CERTIFICATE,
                getActionInvocationContext: function () {
                    var selectedItem = _this.getSelectedItem();
                    return selectedItem && selectedItem._data;
                },
                isActionAvailable: function (actionDef) {
                    var selectedItem = _this.getSelectedItem();
                    if (!selectedItem || !actionDef.available) {
                        return false;
                    }
                    return _this.storageProvidersActionService.isRefreshCertificateActionAvailable(selectedItem);
                }
            });
            return actionDefs;
        };
        StorageProvidersList.prototype.treeListColumns = function () {
            var self = this;
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            return [
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.nameColumn.groupTitleProviderSystem"),
                    field: "nameFormatted",
                    template: "#:nameFormatted#",
                    width: "220px"
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.statusColumn"),
                    field: "providerStatusFormatted",
                    template: function (item) {
                        if (item.statusFault && item.statusFault.message) {
                            var moreDetailsText = self.i18n("StorageUi", "storage.storageProviders.providersList.statusColumn.details");
                            var moreDetailsLinkHtml = "<a " +
                                "class=\"storage-providers-mode-details-link\" " +
                                "vui-sign-post=\"$ctrl.getStatusDetailsSignPostConfig('" + item.id + "')\" " +
                                ">" + moreDetailsText + "</a>";
                            return textRenderer(["providerStatusFormatted"], item) + moreDetailsLinkHtml;
                        }
                        else {
                            return textRenderer(["providerStatusFormatted"], item);
                        }
                    }
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.activeColumn"),
                    field: "activeStandbyFormatted",
                    template: "#:activeStandbyFormatted#"
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.priorityColumn"),
                    field: "priorityFormatted",
                    template: "#:priorityFormatted#"
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.urlColumn"),
                    field: "urlFormatted",
                    template: "#:urlFormatted#"
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.lastSyncTimeColumn"),
                    field: "lastSyncTimeFormatted",
                    template: "#:lastSyncTimeFormatted#",
                    sortable: {
                        compare: function (a, b) {
                            return self.storageUtil.compareNumericValues(a, b, "lastSyncTime");
                        }
                    }
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.apiVersionColumn"),
                    field: "vasaApiVersionFormatted",
                    template: "#:vasaApiVersionFormatted#"
                },
                {
                    title: this.i18n("StorageUi", "storage.storageProviders.providersList.certificateExpiryColumn"),
                    field: "certificateExpiryTimeFormatted",
                    template: function (item) {
                        if (item.certificateExpiryTimeIcon) {
                            return iconTextRenderer(["certificateExpiryTimeIcon", "certificateExpiryTimeFormatted"], item);
                        }
                        return textRenderer(["certificateExpiryTimeFormatted"], item);
                    },
                    sortable: {
                        compare: function (a, b) {
                            return self.storageUtil.compareNumericValues(a, b, "certificateExpiryTime");
                        }
                    }
                }
            ];
        };
        StorageProvidersList.$inject = ["i18nService", "$scope", "storageUtil", "storageProvidersService",
            "storageProvidersItemBuilderService", "columnRenderersRegistry", "$timeout", "commonActionBarService",
            "storageProviderConstants", "vuiConstants", "storageProvidersActionService", "defaultUriSchemeUtil", "vcService"];
        return StorageProvidersList;
    }());
    storage_ui.StorageProvidersList = StorageProvidersList;
    angular.module("com.vmware.vsphere.client.storage")
        .component("storageProvidersList", {
        templateUrl: "storage-ui/resources/storage/views/storageProviders/StorageProvidersList.html",
        bindings: {
            vcId: "<",
            masterDetailsViewContext: "<"
        },
        controller: StorageProvidersList
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProvidersMasterViewController = (function () {
        function StorageProvidersMasterViewController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.tabs = [{
                    name: this.i18nService.getString("StorageUi", "storage.storageProviders.generalSettingsView.label"),
                    templateUrl: "storage-ui/resources/storage/views/storageProviders/details/StorageProviderItemGeneralDetailsView.html",
                    uid: "storage.providers.generalTab"
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.storageProviders.supportedVendorIdsView.label"),
                    templateUrl: "storage-ui/resources/storage/views/storageProviders/details/StorageProviderSupportedVendorIdsView.html",
                    uid: "storage.providers.supportedVendorIdsTab",
                    metadata: {
                        relevantFor: "_isStorageProviderItem"
                    }
                }, {
                    name: this.i18nService.getString("StorageUi", "storage.storageProviders.certificateDetailsView.label"),
                    templateUrl: "storage-ui/resources/storage/views/storageProviders/details/StorageProviderCertificateDetailsView.html",
                    uid: "storage.providers.certificateDetailsTab",
                    metadata: {
                        relevantFor: "_isStorageProviderItem"
                    }
                }];
            this.detailsViewData = {
                tabsPromise: this.$q.when(this.tabs)
            };
        }
        StorageProvidersMasterViewController.$inject = ["i18nService", "$q"];
        return StorageProvidersMasterViewController;
    }());
    storage_ui.StorageProvidersMasterViewController = StorageProvidersMasterViewController;
    angular.module("com.vmware.vsphere.client.storage")
        .controller("StorageProvidersMasterViewController", StorageProvidersMasterViewController);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageProvidersService = (function () {
        function StorageProvidersService(i18nService, dataService, mutationService, storageProviderConstants, clarityModalService, $rootScope) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.storageProviderConstants = storageProviderConstants;
            this.clarityModalService = clarityModalService;
            this.$rootScope = $rootScope;
        }
        StorageProvidersService.prototype.getStorageProviderSystemInfoEx = function (vcId) {
            return this.dataService.getProperties(vcId, [StorageProvidersService.STORAGE_PROVIDER_SYSTEM_PROPERTY])
                .then(function (response) {
                return response && response[StorageProvidersService.STORAGE_PROVIDER_SYSTEM_PROPERTY];
            });
        };
        StorageProvidersService.prototype.resyncInternalVasaProviders = function (vcId) {
            var _this = this;
            var spec = {
                _type: "com.vmware.vsphere.client.sms.ResyncVsanProvidersSpec"
            };
            this.mutationService.apply(vcId, spec._type, spec).then(function () {
                _this.$rootScope.$broadcast('vsphere.core.storage.storageProviders.providersList.refreshProvidersList');
            });
        };
        StorageProvidersService.prototype.refreshCertificate = function (vcId, storageProvider) {
            var _this = this;
            if (!vcId || !storageProvider || !storageProvider.providerInfo) {
                return;
            }
            if (storageProvider.providerInfo.certificateStatus === this.storageProviderConstants.certificateStatus.expired) {
                var modalOptions = {
                    title: this.i18nService.getString("StorageUi", "storage.storageProviders.actions.refresh.certificateExpiredTitle"),
                    hideCancelButton: true,
                    message: this.i18nService.getString("StorageUi", "storage.storageProviders.actions.refresh.certificateExpiredWarning"),
                    icon: "icon-warning-32",
                    submit: function () {
                        return true;
                    },
                    preserveNewlines: true
                };
                this.clarityModalService.openConfirmationModal(modalOptions);
                return;
            }
            var spec = {
                vasaStorageProvider: storageProvider.provider
            };
            if (storageProvider.providerInfo.status === this.storageProviderConstants.vasaProviderStatus.disconnected) {
                spec._type = "com.vmware.vsphere.client.sms.ReconnectStorageProviderSpec";
            }
            else {
                spec._type = "com.vmware.vsphere.client.sms.RefreshStorageProviderCertificateSpec";
            }
            this.mutationService.apply(vcId, spec._type, spec).then(function () {
                _this.$rootScope.$broadcast('vsphere.core.storage.storageProviders.providersList.refreshProvidersList');
            });
        };
        StorageProvidersService.prototype.syncProvider = function (vcId, storageProvider) {
            var _this = this;
            if (!storageProvider || !storageProvider.provider) {
                return;
            }
            var spec = {
                _type: "com.vmware.vsphere.client.sms.StorageProviderSyncSpec",
                vasaStorageProvider: storageProvider.provider
            };
            this.mutationService.apply(vcId, spec._type, spec).then(function () {
                _this.$rootScope.$broadcast('vsphere.core.storage.storageProviders.providersList.refreshProvidersList');
            });
        };
        StorageProvidersService.prototype.removeStorageProvider = function (vcId, storageProvider) {
            var _this = this;
            if (!storageProvider || !storageProvider.providerInfo || !storageProvider.providerInfo.uid) {
                return;
            }
            var spec = {
                _type: "com.vmware.vsphere.client.sms.StorageProviderUnregisterSpec",
                uid: storageProvider.providerInfo.uid
            };
            this.mutationService.apply(vcId, spec._type, spec, this.i18nService.getString("StorageUi", "storage.storageProviders.actions.remove.taskName")).then(function () {
                _this.$rootScope.$broadcast('vsphere.core.storage.storageProviders.providersList.refreshProvidersList');
            });
        };
        StorageProvidersService.$inject = ["i18nService", "dataService", "mutationService",
            "storageProviderConstants", "clarityModalService", "$rootScope"];
        StorageProvidersService.STORAGE_PROVIDER_SYSTEM_PROPERTY = "vasa:storageProviderSystemInfoEx";
        return StorageProvidersService;
    }());
    storage_ui.StorageProvidersService = StorageProvidersService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("storageProvidersService", StorageProvidersService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service which handles the wizard showing and wiring the Add datastore wizard steps.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .service('addDatastoreWizardService', addDatastoreWizardService);

   addDatastoreWizardService.$inject = ['vuiWizardService',
      'i18nService',
      '$rootScope',
      'wizardPageService',
      'datastoreConstants',
      'CommonWizardManager',
      'VmfsWizardManager',
      'NfsWizardManager',
      'vvolWizardManagerFactory',
      'datastoreTypePageService',
      'vmfsNameAndDevicePageService',
      'addDatastoreReadyToCompletePageService',
      'vmfsVersionPageService',
      'vmfsPartitionConfigurationPageService',
      'vmfsMountOptionsPageService',
      'nfsNameAndConfigurationPageService',
      'nfsVersionPageService',
      'nfsSelectHostsPageService',
      'defaultUriSchemeUtil',
      'managedEntityConstants',
      'vvolNameAndContainerSelectionPageService',
      'vvolSelectHostsPageService',
      'nfsKerberosAuthenticationPageService'];

   function addDatastoreWizardService(vuiWizardService,
         i18nService,
         $rootScope,
         wizardPageService,
         datastoreConstants,
         CommonWizardManager,
         VmfsWizardManager,
         NfsWizardManager,
         vvolWizardManagerFactory,
         datastoreTypePageService,
         vmfsNameAndDevicePageService,
         addDatastoreReadyToCompletePageService,
         vmfsVersionPageService,
         vmfsPartitionConfigurationPageService,
         vmfsMountOptionsPageService,
         nfsNameAndConfigurationPageService,
         nfsVersionPageService,
         nfsSelectHostsPageService,
         defaultUriSchemeUtil,
         managedEntityConstants,
         vvolNameAndContainerSelectionPageService,
         vvolSelectHostsPageService,
         nfsKerberosAuthenticationPageService) {

      return {
         showWizard: function (contextObjectId) {
            var wizardScope = $rootScope.$new();

            var flowsId = [
               datastoreConstants.datastoreTypes.VMFS,
               datastoreConstants.datastoreTypes.NFS,
               datastoreConstants.datastoreTypes.NFS3,
               datastoreConstants.datastoreTypes.VVOL
            ];

            var selectDatastoreTypePage = datastoreTypePageService.build(wizardScope, flowsId);
            var readyToCompletePage = addDatastoreReadyToCompletePageService.build(wizardScope);

            function buildVmfsPages() {
               var vmfsNameAndDevicePage = vmfsNameAndDevicePageService.build(wizardScope);
               var vmfsMountOptionsPage = vmfsMountOptionsPageService.build(wizardScope);
               var vmfsPartitionConfigurationPage = vmfsPartitionConfigurationPageService.build(wizardScope);
               var vmfsVersionPage = vmfsVersionPageService.build(wizardScope);
               return [vmfsNameAndDevicePage, vmfsMountOptionsPage, vmfsVersionPage,
                  vmfsPartitionConfigurationPage, readyToCompletePage];
            }

            function buildNfsPages(isHostContextObject, isVersion41) {
               var nfsNameAndConfigurationPage = nfsNameAndConfigurationPageService.build(wizardScope);
               var pages;

               if (isHostContextObject) {
                  pages = [nfsNameAndConfigurationPage, readyToCompletePage];
               }
               else {
                  var nfsSelectHostsPage = nfsSelectHostsPageService.build(wizardScope);
                  pages =[nfsNameAndConfigurationPage, nfsSelectHostsPage, readyToCompletePage];

               }

               if(isVersion41){
                  var nfsVersionPage = nfsVersionPageService.build(wizardScope);
                  var nfsKerberosAuthenticationPage = nfsKerberosAuthenticationPageService.build(wizardScope);
                  pages.unshift(nfsVersionPage);
                  pages.splice(2, 0, nfsKerberosAuthenticationPage);
               }

               return pages;
            }

            function buildVvolPages(isHostContextObject) {
               var vvolNameAndContainerSelectionPage = vvolNameAndContainerSelectionPageService.build(wizardScope);

               if (isHostContextObject) {
                  return [vvolNameAndContainerSelectionPage, readyToCompletePage];
               }
               else {
                  var vvolSelectHostsPage = vvolSelectHostsPageService.build(wizardScope);
                  return [vvolNameAndContainerSelectionPage, vvolSelectHostsPage, readyToCompletePage];
               }
            }

            var isHostContextObject =
               (defaultUriSchemeUtil.getEntityType(contextObjectId) === managedEntityConstants.HOST);

            var flows = [
               {
                  id: datastoreConstants.datastoreTypes.VMFS,
                  pages: buildVmfsPages()
               },
               {
                  id: datastoreConstants.datastoreTypes.NFS,
                  pages: buildNfsPages(isHostContextObject, true)
               },
               {
                  id: datastoreConstants.datastoreTypes.NFS3,
                  pages: buildNfsPages(isHostContextObject, false)
               },
               {
                  id: datastoreConstants.datastoreTypes.VVOL,
                  pages: buildVvolPages(isHostContextObject)
               }
            ];

            var pages = [selectDatastoreTypePage];

            wizardScope.wizardConfig = {
               pages: wizardPageService.initializePageStates(pages),
               flows: wizardPageService.initializeFlowStates(flows)
            };

            wizardScope.wizardConfig.iconClass = 'storage-ui-icon-create-datastore';
            wizardScope.wizardConfig.title =
               i18nService.getString('StorageUi', 'addDatastoreWizard.title');
            wizardScope.wizardConfig.cssClass = 'new-datastore-wizard';

            wizardScope.commonWizardManager =
                  new CommonWizardManager(contextObjectId, wizardScope.wizardConfig);
            wizardScope.vmfsWizardManager =
                  new VmfsWizardManager(wizardScope.commonWizardManager);
            wizardScope.nfsWizardManager =
               new NfsWizardManager(wizardScope.commonWizardManager);
            wizardScope.vvolWizardManager =
               vvolWizardManagerFactory.build(wizardScope.commonWizardManager);

            wizardScope.activeWizardManager = wizardScope.vmfsWizardManager;

            wizardScope.removeLoadingAndShowError = function (error) {
               wizardScope.wizardConfig.loading = false;
               if (error && error.data && error.data.message) {
                  wizardPageService.markPageIncompleteWithError(
                        wizardScope.wizardConfig,
                        error.data.message);
               }
            };

            // show the wizard
            vuiWizardService({
               scope: wizardScope,
               configObjectName: 'wizardConfig'
            }).show();

            wizardScope.commonWizardManager.prepareUniqueDatastoreName();
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').factory('CommonWizardManager', [
      'i18nService',
      'dataService',
      '$q',
      'defaultUriSchemeUtil',
      'managedEntityConstants',
      'datastoreConstants',
      function (i18nService,
                dataService,
                $q,
                defaultUriSchemeUtil,
                managedEntityConstants,
                datastoreConstants) {
         return function CommonWizardManager(contextObject, wizardConfig) {

            var UNIQUE_DATASTORE_NAME = 'newUniqueDatastoreName';
            var AVAILABLE_HOSTS_PROPERTY = 'storage:availableHostsForCreateDatastore';

            var state = {
               datastoreName: null,
               datastoreType: null
            };

            var cache = {
               uniqueNamePromise: null,
               availableHosts: null
            };

            var manager = {
               getUniqueDatastoreName: function () {
                  if (!cache.uniqueNamePromise) {
                     cache.uniqueNamePromise = dataService.getProperties(contextObject, [UNIQUE_DATASTORE_NAME]).then(function (result) {
                        return result[UNIQUE_DATASTORE_NAME];
                     });
                  }

                  return cache.uniqueNamePromise;
               },
               prepareUniqueDatastoreName: function() {
                  this.getUniqueDatastoreName();
               },
               setDatastoreType: function (datastoreType) {
                  state.datastoreType = datastoreType;
               },
               getDatastoreType: function () {
                  return state.datastoreType?
                     state.datastoreType: datastoreConstants.datastoreTypes.VMFS;
               },
               setDatastoreName: function (datastoreName) {
                  state.datastoreName = datastoreName;
               },
               getDatastoreName: function () {
                  return state.datastoreName;
               },
               getContextObject: function() {
                  return contextObject;
               },
               isHostContextObject: function() {
                  return defaultUriSchemeUtil.getEntityType(contextObject) === managedEntityConstants.HOST;
               },
               getStorageFolder: function() {
                  if (defaultUriSchemeUtil.getEntityType(contextObject) === managedEntityConstants.FOLDER) {
                     return defaultUriSchemeUtil.getManagedObjectReference(contextObject);
                  }
                  return null;
               },
               getWizardConfig: function() {
                  return wizardConfig;
               },
               getAvailableHosts: function () {
                  if (cache.availableHosts) {
                     return $q.when(cache.availableHosts);
                  }

                  return dataService.getProperties(contextObject, [AVAILABLE_HOSTS_PROPERTY])
                        .then(function(result) {
                           var availableHosts = result
                                 ? result[AVAILABLE_HOSTS_PROPERTY] || []
                                 : [];
                           _.forEach(availableHosts, function(hostData) {
                              hostData.hostId =
                                    defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
                           });
                           cache.availableHosts = availableHosts;
                           return availableHosts;
                        });
               }
            };

            return manager;
         };
      }
   ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').factory('NfsWizardManager', [
         'i18nService', 'vxPropertyViewService', 'defaultUriSchemeUtil', 'mutationService',
         'datastoreConstants', 'storageValidationService', 'ipParserService', 'dataService', '$q',
      function (i18nService, vxPropertyViewService, defaultUriSchemeUtil,
            mutationService, datastoreConstants, storageValidationService, ipParserService,
            dataService, $q) {

         return function NfsWizardManager(commonWizardManager) {
            var state = {};

            var cache = {
               existingDsHostsPromise: null,
               existingDsId: null
            };

            var manager = {
               getNfsVersion: getNfsVersion,
               setNfsVersion: setNfsVersion,
               isNfsVersion41: isNfsVersion41,
               getFolderName: getFolderName,
               setFolderName: setFolderName,
               getServerName: getServerName,
               setSelectedAccessMode: setSelectedAccessMode,
               getSelectedAccessMode: getSelectedAccessMode,
               getServerNamesArray: getServerNamesArray,
               setServerNamesArray: setServerNamesArray,
               hasIpV6Servers: hasIpV6Servers,
               splitServerNames: splitServerNames,
               validateServerNames: validateServerNames,
               addServerNamesAction: addServerNamesAction,
               setServerName: setServerName,
               getExistingDatastoreId: getExistingDatastoreId,
               setExistingDatastoreId: setExistingDatastoreId,
               requestExistingDatastoreHosts: requestExistingDatastoreHosts,
               getSelectedHosts: getSelectedHosts,
               setSelectedHosts: setSelectedHosts,
               getKerberosAuthenticationType: getKerberosAuthenticationType,
               setKerberosAuthenticationType: setKerberosAuthenticationType,
               getReadyToCompletePageData: getReadyToCompletePageData,
               submit: submit
            };

            function getFolderName() {
               return state.folderName;
            }

            function setFolderName(name) {
               state.folderName = name;
            }

            function getServerName() {
               return state.serverName;
            }

            function setServerNamesArray (array) {
               state.nfs41ServerNames = array;
            }

            function getServerNamesArray () {
               return state.nfs41ServerNames || [];
            }

            function hasIpV6Servers () {
               if (getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1) {
                  var ipV6Server = _.find(getServerNamesArray(), function(item) {
                     return ipParserService.isIpv6AddressValid(item);
                  });
                  return !!ipV6Server;
               } else {
                  return ipParserService.isIpv6AddressValid(getServerName());
               }
            }

            function splitServerNames(namesString) {
               //trying to split
               return _.map(namesString.split(/[\s,;]+/), function(name) {
                  return name.trim();
               }).filter(function(name) {
                     return !/\s/.test(name) && name.length > 0;
               });
            }

            function addServerNamesAction() {
               var serverName = getServerName();
               if (isServerNameNullOrEmpty(serverName)) {
                  return;
               }

               var servers = splitServerNames(serverName);
               if (!servers || servers.length === 0) {
                  return;
               }

               // Add only those servers which haven't been already added.
               var serversToAdd = [];
               servers.forEach(function(server) {
                  if (!serverNameExists(server)) {
                     serversToAdd.push(server);
                  }
               });

               if (serversToAdd.length > 0) {
                  var currentServers = getServerNamesArray().concat(serversToAdd);
                  setServerNamesArray(currentServers);
               }
            }

            function validateServerNames() {
               var MAX_SERVER_NAME_LENGTH = 253;
               var inputFiledServerName = getServerName();
               var isEmptyInputFieldServerName = isServerNameNullOrEmpty(inputFiledServerName);
               var enteredServerNames = [];

               switch (getNfsVersion()) {
                  case datastoreConstants.nfsVersions.NFS_3: {
                     // Get the server name from the input field
                     if (!isEmptyInputFieldServerName) {
                        enteredServerNames = [inputFiledServerName];
                     }
                     break;
                  }
                  case datastoreConstants.nfsVersions.NFS_4_1: {
                     // Get server names from the servers grid.
                     enteredServerNames = getServerNamesArray();
                     if (!isEmptyInputFieldServerName) {
                        // Add the server names from the input field.
                        enteredServerNames = enteredServerNames.concat(
                              splitServerNames(inputFiledServerName));
                     }
                     break;
                  }
               }

               if (!enteredServerNames || enteredServerNames.length === 0) {
                  return i18nService.getString(
                        'StorageUi', 'addDatastoreWizard.nfsSettingsPage.serverListEmptyString');
               }

               var invalidServerNames = _.filter(enteredServerNames, function(name) {
                  var isInvalidName = !storageValidationService.isValidDnsName(name)
                        && !ipParserService.isIpv6AddressValid(name);
                  return name.length > MAX_SERVER_NAME_LENGTH || isInvalidName;
               });

               if (invalidServerNames && invalidServerNames.length > 0) {
                  return i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.nfsServerName.invalid', invalidServerNames[0]);
               }

               return null;
            }

            function serverNameExists(name) {
               var existingServerNames = getServerNamesArray();
                if (existingServerNames) {
                   var serverItem = _.find(existingServerNames, function(item) {
                      return item === name;
                   });

                   return serverItem !== undefined;
                }
               return false;
            }

            function isServerNameNullOrEmpty(serverName) {
               return !serverName || serverName.trim() === '';
            }

            function setServerName(name) {
               state.serverName = name;
            }

            function getExistingDatastoreId() {
               return state.existingDatastoreId;
            }

            function setExistingDatastoreId(datastoreId) {
               state.existingDatastoreId = datastoreId;
            }

            function requestExistingDatastoreHosts() {
               if (!state.existingDatastoreId) {
                  return $q.when({});
               }

               if (!cache.existingDsHostsPromise || cache.existingDsId !== state.existingDatastoreId) {
                  cache.existingDsId = state.existingDatastoreId;
                  cache.existingDsHostsPromise = dataService.getProperties(
                     state.existingDatastoreId, ['hostKey']).then(function (response) {
                        var result = {};
                        if (response && response['hostKey']) {
                           _.forEach(response['hostKey'], function(hostRef) {
                              if (hostRef) {
                                 var hostId = defaultUriSchemeUtil.getVsphereObjectId(hostRef);
                                 if (hostId) {
                                    result[hostId] = true;
                                 }
                              }
                           });
                        }
                        return result;
                     });
               }

               return cache.existingDsHostsPromise;
            }

            function getReadyToCompletePageData() {
               var getString = _.partial(i18nService.getString, 'StorageUi');

               var builder = vxPropertyViewService.createPropertyViewBuilder();
               var category = builder.category('category');

               var generalSection = category.section('general').title(
                  getString('addDatastoreWizard.vmfsReadyToCompletePage.general'));

               generalSection.property(
                  getString('addDatastoreWizard.vmfsReadyToCompletePage.name'),
                  commonWizardManager.getDatastoreName());

               generalSection.property(
                  getString('addDatastoreWizard.vmfsReadyToCompletePage.type'),
                  getFormattedSelectedNfsVersion());

               var nfsSection = category.section('nfsSettings').title(
                  getString('addDatastoreWizard.nfsReadyToCompletePage.nfsSettings'));
               nfsSection.property(
                  getString('addDatastoreWizard.nfsSettingsPage.server'), formatServerName());
               nfsSection.property(
                  getString('addDatastoreWizard.nfsSettingsPage.folder'), getFolderName());
               nfsSection.property(
                  getString('addDatastoreWizard.nfsReadyToCompletePage.accessMode'),
                  getString('datastore.accessMode.' + getSelectedAccessMode()));
               if (isNfsVersion41()) {
                  nfsSection.property(
                     getString('addDatastoreWizard.nfsReadyToCompletePage.kerberos'),
                     getKerberosStatus());
               }

               if(!commonWizardManager.isHostContextObject()) {
                  var nfsHostsSection =  category.section('nfsHostsSettings').title(
                     getString('addDatastoreWizard.nfsReadyToCompletePage.hostsTitle'));

                  var propertyBuilder = nfsHostsSection.propertyBuilder();
                  propertyBuilder.keyBuilder()
                        .text(getString('addDatastoreWizard.nfsReadyToCompletePage.hosts'))
                        .exit();

                  getSelectedHosts().forEach(function(hostItem) {
                     propertyBuilder.valueBuilder()
                        .text(hostItem.formattedName)
                        .icon('vsphere-icon-host');
                  });
               }

               return builder.build();
            }

            function getKerberosStatus() {
               var securityType = getKerberosAuthenticationType();
               if (securityType === datastoreConstants.kerberosSecurityTypes.AUTH_SYS) {
                  return i18nService.getString("StorageUi", "addDatastoreWizard.nfsReadyToCompletePage.kerbDisabled");
               }
               if (securityType === datastoreConstants.kerberosSecurityTypes.SEC_KRB5){
                  return i18nService.getString("StorageUi", "datastore.manage.connectivity.hostList.kerberosAuthentication.enabledKrb5");
               }
               if (securityType === datastoreConstants.kerberosSecurityTypes.SEC_KRB5I){
                  return i18nService.getString("StorageUi", "datastore.manage.connectivity.hostList.kerberosAuthentication.enabledKrb5i");
               }
            }

            function getNfsVersion() {
               return state.nfsVersion? state.nfsVersion :
                  datastoreConstants.nfsVersions.NFS_3;
            }

            function isNfsVersion41() {
               return getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1;
            }

            function setNfsVersion(version) {
               state.nfsVersion = version;
            }

            function getSelectedHosts() {
               return state.selectedHosts;
            }

            function setSelectedHosts(selectedHosts) {
               state.selectedHosts = selectedHosts;
            }

            function getKerberosAuthenticationType() {
               return state.kerbereosAuthentication;
            }

            function setKerberosAuthenticationType(authType) {
               state.kerbereosAuthentication = authType;
            }

            function setSelectedAccessMode(mode) {
               state.accessMode = mode;
            }

            function getSelectedAccessMode() {
                return state.accessMode || datastoreConstants.accessModes.readWrite;
            }

            function getFormattedSelectedNfsVersion() {
               if (getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1) {
                  return i18nService.getString('StorageUi', 'datastore.nfs.nfs41');
               }
               return i18nService.getString('StorageUi', 'datastore.nfs.nfs');
            }

            function formatServerName () {
               if (getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1) {
                  return getServerNamesArray().join(', ');
               } else {
                  return getServerName();
               }
            }

            function submit() {
               var specs = [];

               if (commonWizardManager.isHostContextObject()) {
                  var hostRef = defaultUriSchemeUtil.getManagedObjectReference(
                     commonWizardManager.getContextObject());
                  specs.push(buildNfsDatastoreCreateSpec(hostRef));
               } else {
                  getSelectedHosts().forEach(function(hostItem) {
                     specs.push(buildNfsDatastoreCreateSpec(hostItem.hostRef));
                  });
               }

               if (specs.length > 0) {
                  mutationService.addMulti(
                     'com.vmware.vsphere.client.storage.NfsDatastoreCreateSpec', specs);
                  return true;
               }

               return false;
            }

            function buildNfsDatastoreCreateSpec(hostRef) {
               var createSpec = {
                  _type: 'com.vmware.vsphere.client.storage.NfsDatastoreCreateSpec',
                  host: hostRef,
                  storageFolder: commonWizardManager.getStorageFolder(),
                  nfsDatastoreCreateSpec: {
                     _type: "com.vmware.vim.binding.vim.host.NasVolume$Specification",
                     type: getNfsVersion().toUpperCase(),
                     remoteHost: getServerName(),
                     remotePath: getFolderName(),
                     localPath: commonWizardManager.getDatastoreName(),
                     accessMode: getSelectedAccessMode()
                  }
               };

               if (getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1) {
                  var serverNames = getServerNamesArray();
                  createSpec.nfsDatastoreCreateSpec.remoteHostNames = serverNames;
                  createSpec.nfsDatastoreCreateSpec.remoteHost = serverNames[serverNames.length - 1];
                  createSpec.nfsDatastoreCreateSpec.securityType = getKerberosAuthenticationType();
               }

               return createSpec;
            }

            return manager;
         };
      }
   ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').factory('VmfsWizardManager', [
      'i18nService',
      'defaultUriSchemeUtil',
      'dataService',
      '$q',
      'bytesFilter',
      'storageUtil',
      'datastoreConstants',
      'mutationService',
      'wizardPageService',
      'vxPropertyViewService',
      function (i18nService,
                defaultUriSchemeUtil,
                dataService,
                $q,
                bytesFilter,
                storageUtil,
                datastoreConstants,
                mutationService,
                wizardPageService,
                propertyViewService) {
         return function VmfsWizardManager(commonWizardManager) {

            var AVAILABLE_DISK_FOR_VMFS = 'availableDisksForVmfs';
            var VMFS_CREATE_OPTION_ITEMS = 'datastore:vmfsDatastoreCreateOptionsData';

            var DEFAULT_SPACE_RECLAMATION_PRIORITY = datastoreConstants.reclamationPriority.LOW;

            var mountOptions = {
               KEEP_SIGNATURE: 'keepSignature',
               ASSIGN_NEW_SIGNATURE: 'assignNewSignature',
               FORMAT_DISK: 'formatDisk'
            };

            var vmfsVersions = [
               {
                  title: i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.vmfsSelectVersionPage.vmfs6'),
                  description: i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.vmfsSelectVersionPage.vmfs6Description'),
                  value: datastoreConstants.vmfsVersions.VMFS_6
               },
               {
                  title: i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.vmfsSelectVersionPage.vmfs5'),
                  description: i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.vmfsSelectVersionPage.vmfs5Description'),
                  value: datastoreConstants.vmfsVersions.VMFS_5
               }
            ];

            var getString = _.partial(i18nService.getString, 'StorageUi');

            var vmfsMountOptionsPageTitle =
                  getString('addDatastoreWizard.vmfsMountOptionsPage.title');
            var vmfsPartitionConfigurationPageTitle =
                  getString('addDatastoreWizard.vmfsPartitionConfigPage.title');

            var state = {
               isVmfs6Supported: true,
               selectedHostId: null,
               selectedDiskInfo: null,
               selectedVmfsDatastoreOptionItem: null,
               datastoreSizeInGB: null,
               selectedMountOption: null,
               selectedVmfsVersion: null,
               selectedVmfsBlockSizeOptions: null
            };

            var cache = {
               hostRefForDiskInfos: null,
               diskInfos: null,
               devicePathForDatastoreOptions: null,
               vmfsMajorVersionForDatastoreOptions: null,
               vmfsDatastoreOptionItems: null,
               blockSizeOptions: null,
               reclamationPriority: null
            };

            var manager = {
               submit: submit,
               getReadyToCompletePageData:getReadyToCompletePageData,

               mountOptions: mountOptions,
               vmfsVersions: vmfsVersions,

               getSelectedHostId: getSelectedHostId,
               setSelectedHostId: setSelectedHostId,

               getIsVmfs6Supported: getIsVmfs6Supported,
               setIsVmfs6Supported: setIsVmfs6Supported,

               setSelectedScsiDiskInfo: setSelectedScsiDiskInfo,
               getSelectedScsiDiskInfo: getSelectedScsiDiskInfo,

               getDatastoreSizeInGb: getDatastoreSizeInGb,
               setDatastoreSizeInGb: setDatastoreSizeInGb,

               getSelectedVmfsVersion: getSelectedVmfsVersion,
               setSelectedVmfsVersion: setSelectedVmfsVersion,

               getSelectedMountOption: getSelectedMountOption,
               setSelectedMountOption: setSelectedMountOption,

               setSelectedVmfsDatastoreOptionItem: setSelectedVmfsDatastoreOptionItem,
               getSelectedVmfsDatastoreOptionItem: getSelectedVmfsDatastoreOptionItem,

               getSelectedVmfsBlockSizeOptions: getSelectedVmfsBlockSizeOptions,
               setSelectedVmfsBlockSizeOptions: setSelectedVmfsBlockSizeOptions,

               requestAvailableScsiDiskInfos: requestAvailableScsiDiskInfos,
               requestVmfsCreateOptionItems: requestVmfsCreateOptionItems,

               updateVmfsVersionPageVisibility: updateVmfsVersionPageVisibility,
               skipVmfsVersionPage: skipVmfsVersionPage
            };

            return manager;

            function getIsVmfs6Supported () {
               return state.isVmfs6Supported;
            }

            function setIsVmfs6Supported (isSupported) {
               state.isVmfs6Supported = isSupported;
            }

            function getSelectedScsiDiskInfo() {
               return state.selectedDiskInfo;
            }

            function setSelectedScsiDiskInfo(selectedDiskInfo) {
               if (equalDiskInfos(selectedDiskInfo, state.selectedDiskInfo)) {
                  return;
               }

               state.selectedDiskInfo = selectedDiskInfo;

               // Reset vmfs datastore and mount option as
               // they are invalid for the newly selected disk.
               setSelectedVmfsDatastoreOptionItem(null);
               setSelectedMountOption(null);

               updateMountOptionVisibility();
            }

            function getSelectedHostId () {
               if (commonWizardManager.isHostContextObject()) {
                  return commonWizardManager.getContextObject();
               }
               return state.selectedHostId;
            }

            function setSelectedHostId(hostId) {
               state.selectedHostId = hostId;
            }

            function getDatastoreSizeInGb () {
               return state.datastoreSizeInGB;
            }

            function setDatastoreSizeInGb(dsSizeInGb) {
               state.datastoreSizeInGB = dsSizeInGb;
            }

            function getDatastoreSizeInBytes() {
               var selectedOption = getSelectedVmfsDatastoreOptionItem();
               var maxDsSizeInBytes = 0;
               if (selectedOption) {
                  maxDsSizeInBytes = selectedOption.maxDatastoreSize;
               }
               var dsSizeInBytes = state.datastoreSizeInGB * datastoreConstants.BYTES_TO_GB;
               if (dsSizeInBytes > maxDsSizeInBytes) {
                  // Selected datastore sized is bigger than the max datastore size
                  // for the selected option. Return max datastore size.
                  dsSizeInBytes = maxDsSizeInBytes;
               }

               if (maxDsSizeInBytes - dsSizeInBytes <
                     datastoreConstants.vmfsSize.DATASTORE_SIZE_STEP_IN_BYTES) {
                  // Difference between the selected datastore size and the max datastore
                  // size is less than datastore size step (0.01 GB). This might happen
                  // after rounding during the bytes to GB conversion. We need to return
                  // the max datastore size otherwise we will lose space on the disk.
                  dsSizeInBytes = maxDsSizeInBytes;
               }
               return dsSizeInBytes;
            }

            function getSelectedMountOption() {
               return state.selectedMountOption;
            }

            function setSelectedMountOption(mountOption) {
               if (state.selectedMountOption !== mountOption) {
                  state.selectedMountOption = mountOption;
                  updatePartitionConfigurationVisibility();
               }
            }

            function getSelectedVmfsVersion() {
               return state.selectedVmfsVersion;
            }

            function setSelectedVmfsVersion(version) {
               state.selectedVmfsVersion = version;
            }

            function setSelectedVmfsDatastoreOptionItem(optionItem) {
               state.selectedVmfsDatastoreOptionItem = optionItem;
            }

            function getSelectedVmfsDatastoreOptionItem() {
               return state.selectedVmfsDatastoreOptionItem;
            }

            function getSelectedVmfsBlockSizeOptions() {
               return state.selectedVmfsBlockSizeOptions;
            }

            function setSelectedVmfsBlockSizeOptions(blockSizeOtions) {
               state.selectedVmfsBlockSizeOptions = blockSizeOtions;
            }

            function requestAvailableScsiDiskInfos() {

               var hostRef = getSelectedHostId();

               if (cache.hostRefForDiskInfos === hostRef &&
                  cache.diskInfos) {
                  return $q.when(cache.diskInfos);
               }

               return dataService.getProperties(hostRef,
                     [AVAILABLE_DISK_FOR_VMFS]).then(function (result) {
                  var disks = result ? result[AVAILABLE_DISK_FOR_VMFS] || [] : [];

                  // Cache the response
                  cache.hostRefForDiskInfos = hostRef;
                  cache.diskInfos = disks;

                  return disks;
               });
            }

            function requestVmfsCreateOptionItems() {

               var devicePath = getSelectedScsiDiskInfo().disk.devicePath;
               var vmfsMajorVersion = getSelectedVmfsVersion();

               if (cache.devicePathForDatastoreOptions === devicePath &&
                     cache.vmfsMajorVersionForDatastoreOptions === vmfsMajorVersion &&
                     cache.vmfsDatastoreOptionItems) {
                  return $q.when({
                     optionItems: cache.vmfsDatastoreOptionItems,
                     diskPartitionInfo: cache.diskPartitionInfo,
                     blockSizeOptions: cache.blockSizeOptions,
                     reclamationPriority: cache.reclamationPriority
                  });
               }

               return dataService.getProperties(getSelectedHostId(),
                     [VMFS_CREATE_OPTION_ITEMS],
                     {
                        propertyParams: [{
                           propertyName: VMFS_CREATE_OPTION_ITEMS,
                           parameterType: 'com.vmware.vsphere.client.h5.storage.spec.VmfsDatastoreCreateOptionQuerySpec',
                           parameter: {
                              _type: 'com.vmware.vsphere.client.h5.storage.spec.VmfsDatastoreCreateOptionQuerySpec',
                              devicePath: devicePath,
                              vmfsMajorVersion: vmfsMajorVersion
                           }
                        }]
                     }).then(function (result) {
                        var vmfsDatastoreOptionData = result ? result[VMFS_CREATE_OPTION_ITEMS] || {} : {};
                        var optionItems = vmfsDatastoreOptionData.optionItems || [];
                        var diskPartitionInfo = vmfsDatastoreOptionData.partitionInfo || {};
                        var blockSizeOptions = vmfsDatastoreOptionData.blockSizeOptions;
                        var reclamationPriority = { unmapPriority: DEFAULT_SPACE_RECLAMATION_PRIORITY};

                        // Cache datastore option items
                        cache.vmfsDatastoreOptionItems = optionItems;
                        cache.diskPartitionInfo = diskPartitionInfo;
                        cache.vmfsMajorVersionForDatastoreOptions = vmfsMajorVersion;
                        cache.devicePathForDatastoreOptions = devicePath;
                        cache.blockSizeOptions = blockSizeOptions;
                        cache.reclamationPriority = reclamationPriority;

                       return {
                          optionItems: optionItems,
                          diskPartitionInfo: diskPartitionInfo,
                          blockSizeOptions: blockSizeOptions,
                          reclamationPriority: reclamationPriority
                       };
                     });
            }

            function skipVmfsVersionPage(skipped) {
               skipPage(i18nService.getString(
                  'StorageUi', 'addDatastoreWizard.vmfsSelectVersionPage.title'), skipped);
            }

            function updateVmfsVersionPageVisibility(host) {
               var isVMFS6Supported = host.isVMFS6Supported;

               skipVmfsVersionPage(!isVMFS6Supported);

               var vmfsVersion = isVMFS6Supported?
                  datastoreConstants.vmfsVersions.VMFS_6 :
                  datastoreConstants.vmfsVersions.VMFS_5;
               setSelectedVmfsVersion(vmfsVersion);
            }

            function submit() {
               if (isVmfsMountOptionSelected()) {
                  if ( getSelectedMountOption() === mountOptions.ASSIGN_NEW_SIGNATURE) {
                     return resignatureVmfsDatastore();
                  } else {
                     return forceMountVmfsDatastore();
                  }

               } else {
                  return createNewDatastore();
               }
            }

            function getReadyToCompletePageData() {

               var builder = propertyViewService.createPropertyViewBuilder();
               var category = builder.category('category');

               if (isVmfsMountOptionSelected()) {
                  var headlessSection = category.section('headless');
                  appendVmfsTypeProp(headlessSection);
                  appendDiskNameProp(headlessSection);
                  headlessSection.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.mountOption'),
                        getSelectedMountOption() === mountOptions.ASSIGN_NEW_SIGNATURE
                              ? getString('vmfsMountOptions.newSignature')
                              : getString("vmfsMountOptions.keepSignature"));
               } else {

                  var generalSection = category.section('general').title(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.general'));

                  generalSection.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.name'),
                        commonWizardManager.getDatastoreName());

                  appendVmfsTypeProp(generalSection);

                  generalSection.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.size'),
                        bytesFilter(getDatastoreSizeInBytes(), 'B', 'Auto', 2));

                  var deviceAndFormattingSection = category
                        .section('deviceAndFormatting')
                        .title(getString('addDatastoreWizard.vmfsReadyToCompletePage.deviceAndFormatting'));

                  appendDiskNameProp(deviceAndFormattingSection);

                  deviceAndFormattingSection.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.partitionFormat'),
                        storageUtil.formatDiskPartitionType(getDiskPartitionType()));

                  deviceAndFormattingSection.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.vmfsVersion'),
                        getString('vmfsDatastore.version.format', getSelectedVmfsVersion()));

                  if (getSelectedVmfsVersion() === datastoreConstants.vmfsVersions.VMFS_6) {
                     appendBlockSizeOptionsProp(deviceAndFormattingSection);
                  }
               }

               function appendVmfsTypeProp(section) {
                  section.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.type'),
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.typeVmfs'));
               }

               function appendDiskNameProp(section) {
                  section.property(
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.diskLun'),
                        storageUtil.formatDeviceName(getSelectedScsiDiskInfo().disk));
               }

               function appendBlockSizeOptionsProp(section) {
                  var selectedBlockSizeOptions = getSelectedVmfsBlockSizeOptions();

                  section.property(
                     getString('addDatastoreWizard.vmfsReadyToCompletePage.blockSize'),
                     selectedBlockSizeOptions.blockSize.formattedValue);
                  section.property(
                     getString('addDatastoreWizard.vmfsReadyToCompletePage.spaceReclamationGranularity'),
                     selectedBlockSizeOptions.granularity.formattedValue);

                  var reclamationPriority = selectedBlockSizeOptions.reclamationPriority.unmapPriority;
                  var reclamationPriorityDescription = getString("informationNotAccessible");
                  if (reclamationPriority === datastoreConstants.reclamationPriority.NONE) {
                     reclamationPriorityDescription =
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.spaceReclamationPriorityNoneDescription');
                  } else if (reclamationPriority === datastoreConstants.reclamationPriority.LOW) {
                     var lowPriority = getString('vmfs.unmapPriority.low');
                     reclamationPriorityDescription =
                        getString('addDatastoreWizard.vmfsReadyToCompletePage.spaceReclamationPriorityDescription',
                           lowPriority, lowPriority.toLowerCase());
                  }

                  section.property(
                     getString('addDatastoreWizard.vmfsReadyToCompletePage.spaceReclamationPriority'), reclamationPriorityDescription);
               }

               return builder.build();
            }

            function createNewDatastore() {
               var createOptionItem = getSelectedVmfsDatastoreOptionItem();
               var createOption = createOptionItem.vmfsDatastoreOption;
               var vmfsDatastoreCreateSpec = createOption.spec;

               // Set the datastore name.
               vmfsDatastoreCreateSpec.vmfs.volumeName = commonWizardManager.getDatastoreName();

               if (getSelectedVmfsVersion() === datastoreConstants.vmfsVersions.VMFS_6) {
                  var selectedVmfsBlockSizeOptions = getSelectedVmfsBlockSizeOptions();
                  vmfsDatastoreCreateSpec.vmfs.blockSize = selectedVmfsBlockSizeOptions.blockSize.value;
                  vmfsDatastoreCreateSpec.vmfs.unmapGranularity = selectedVmfsBlockSizeOptions.granularity.value;
                  vmfsDatastoreCreateSpec.vmfs.unmapPriority = selectedVmfsBlockSizeOptions.reclamationPriority.unmapPriority;
               }

               // Creates the spec for datastore creation:
               var spec = {
                  _type: 'com.vmware.vsphere.client.storage.VmfsDatastoreCreateSpec',
                  host: defaultUriSchemeUtil.getManagedObjectReference(getSelectedHostId()),
                  storageFolder: commonWizardManager.getStorageFolder(),
                  vmfsDatastoreCreateSpec: vmfsDatastoreCreateSpec,
                  datastoreSize: getDatastoreSizeInBytes(),
                  disk: getSelectedScsiDiskInfo(),
                  createOption: createOption
               };

               mutationService.add('com.vmware.vsphere.client.storage.VmfsDatastoreCreateSpec', spec);
               return true;
            }

            /**
             * Resignature an existing VMFS datastore.
             */
            function resignatureVmfsDatastore() {
               var unresolvedVmfsResignatureSpec = {
                  _type: 'com.vmware.vim.binding.vim.host.UnresolvedVmfsResignatureSpec',
                  extentDevicePath: [ getSelectedScsiDiskInfo().unresolvedExtent.devicePath]
               };

               var spec = {
                  _type: 'com.vmware.vsphere.client.storage.VmfsDatastoreResignatureSpec',
                  host: defaultUriSchemeUtil.getManagedObjectReference(getSelectedHostId()),
                  storageFolder: commonWizardManager.getStorageFolder(),
                  vmfsDatastoreResignatureSpec: unresolvedVmfsResignatureSpec
               };

               mutationService.add('com.vmware.vsphere.client.storage.VmfsDatastoreResignatureSpec', spec);
               return true;
            }

            /**
             * Force mount an existing VMFS datastore to the selected host.
             */
            function forceMountVmfsDatastore() {

               var unresolvedVmfsResoltionSpec = {
                  _type: 'com.vmware.vim.binding.vim.host.UnresolvedVmfsResolutionSpec',
                  extentDevicePath: [ getSelectedScsiDiskInfo().unresolvedExtent.devicePath],
                  uuidResolution: 'forceMount'
               };

               var spec = {
                  _type: 'com.vmware.vsphere.client.storage.VmfsForceMountSpec',
                  host: defaultUriSchemeUtil.getManagedObjectReference(getSelectedHostId()),
                  storageFolder: commonWizardManager.getStorageFolder(),
                  vmfsDatastoreForceMountSpec: unresolvedVmfsResoltionSpec
               };

               mutationService.add('com.vmware.vsphere.client.storage.VmfsForceMountSpec', spec);
               return true;
            }

            function getDiskPartitionType() {
               if (!getSelectedVmfsDatastoreOptionItem()) {
                  return null;
               }
               return getSelectedVmfsDatastoreOptionItem()
                     .vmfsDatastoreOption.spec.partition.partitionFormat;
            }

            function equalDiskInfos(diskInfo1, diskInfo2) {
               if (diskInfo1 === diskInfo2) {
                  return true;
               }
               if (!diskInfo1 && !diskInfo2) {
                  return true;
               }
               if (!diskInfo1 || !diskInfo2) {
                  return false;
               }
               return diskInfo1.disk.devicePath === diskInfo2.disk.devicePath;
            }

            function updateMountOptionVisibility() {
               var selectedDisk = getSelectedScsiDiskInfo();

               var hasUnresolvedVmfsVolume = selectedDisk && selectedDisk.vmfsLabel;

               skipPage(vmfsMountOptionsPageTitle, !hasUnresolvedVmfsVolume);
            }

            function isVmfsMountOptionSelected() {
               var selectedMountOption = getSelectedMountOption();
               return selectedMountOption === mountOptions.ASSIGN_NEW_SIGNATURE ||
                     selectedMountOption === mountOptions.KEEP_SIGNATURE;
            }

            function updatePartitionConfigurationVisibility() {
               var skipParitionConfigurationPage = isVmfsMountOptionSelected();
               skipPage(vmfsPartitionConfigurationPageTitle, skipParitionConfigurationPage);
            }

            function skipPage(title, isSkipped) {
               var flows = commonWizardManager.getWizardConfig().flows;
               var currentFlow = _.find(flows, function (flow) {
                  return flow.id === commonWizardManager.getDatastoreType();
               });

               var pages = currentFlow.pages;
               if (isSkipped) {
                  wizardPageService.markPageSkipped(pages, title, isSkipped);
               } else {
                  wizardPageService.markPageDisabled(pages, title, isSkipped);
               }
               wizardPageService.invalidateNextPages(commonWizardManager.getWizardConfig(),
                  commonWizardManager.getDatastoreType(), title);
            }
         };
      }
   ]);
})();

var storage_ui;
(function (storage_ui) {
    var CreateVvolDatastoreSpec = com.vmware.vsphere.client.storage.vvol.CreateVvolDatastoreSpec;
    var DatastoreSystem$VvolDatastoreSpec = com.vmware.vim.binding.vim.host.DatastoreSystem$VvolDatastoreSpec;
    var VvolWizardManager = (function () {
        function VvolWizardManager(commonWizardManager, i18nService, vxPropertyViewService, defaultUriSchemeUtil, mutationService, $log) {
            this.commonWizardManager = commonWizardManager;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.$log = $log;
            this.availableContainers = [];
        }
        VvolWizardManager.prototype.getContainerInUse = function () {
            var _this = this;
            return _.find(this.availableContainers, function (container) { return container.info.datastoreInfo
                && container.info.datastoreInfo.name === _this.commonWizardManager.getDatastoreName(); });
        };
        VvolWizardManager.prototype.isNameInUse = function () {
            var datastoreName = this.commonWizardManager.getDatastoreName();
            return !!_.find(this.availableContainers, function (container) { return container.info.datastoreInfo && container.info.datastoreInfo.name === datastoreName; });
        };
        VvolWizardManager.prototype.getReadyToCompletePageData = function () {
            var _this = this;
            if (!this.container) {
                return;
            }
            var getString = function (key) { return _this.i18nService.getString("StorageUi", key); };
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var category = builder.category("category");
            var generalSection = category.section("general").title(getString("addDatastoreWizard.vvolReadyToComplete.general"));
            generalSection.property(getString("addDatastoreWizard.vvolReadyToComplete.name"), this.commonWizardManager.getDatastoreName());
            generalSection.property(getString("addDatastoreWizard.vvolReadyToComplete.type"), getString("addDatastoreWizard.vvolReadyToComplete.typeVvol"));
            var vvolSection = category.section('vvolSettings').title(getString('addDatastoreWizard.vvolReadyToComplete.storageContainer.details'));
            vvolSection.property(getString('addDatastoreWizard.vvolReadyToComplete.storageContainer.name'), this.container.name);
            vvolSection.property(getString('addDatastoreWizard.vvolReadyToComplete.storageContainer.uuid'), this.container.identifier);
            vvolSection.property(getString('addDatastoreWizard.vvolReadyToComplete.storageContainer.storageArray'), this.container.storageArrays);
            vvolSection.property(getString('addDatastoreWizard.vvolReadyToComplete.storageContainer.storageProvider'), this.container.storageProviders);
            if (!this.commonWizardManager.isHostContextObject()) {
                var hostsSection = category.section('hostsSettings').title(getString('addDatastoreWizard.vvolReadyToComplete.hostConnectivity'));
                var propertyBuilder_1 = hostsSection.propertyBuilder();
                propertyBuilder_1.keyBuilder()
                    .text(getString('addDatastoreWizard.vvolReadyToCompletePage.hosts'))
                    .exit();
                this.selectedHosts.forEach(function (hostItem) {
                    propertyBuilder_1.valueBuilder()
                        .text(hostItem.formattedName)
                        .icon('vsphere-icon-host');
                });
            }
            return builder.build();
        };
        VvolWizardManager.prototype.submit = function () {
            var _this = this;
            var specs = [];
            if (this.commonWizardManager.isHostContextObject()) {
                var hostRef = this.defaultUriSchemeUtil.getManagedObjectReference(this.commonWizardManager.getContextObject());
                specs.push(this.buildVvolDatastoreCreateSpec(hostRef));
            }
            else {
                this.selectedHosts.forEach(function (hostItem) {
                    specs.push(_this.buildVvolDatastoreCreateSpec(hostItem.hostRef));
                });
            }
            if (specs.length > 0) {
                this.mutationService.addMulti("com.vmware.vsphere.client.storage.vvol.CreateVvolDatastoreSpec", specs);
                return true;
            }
            return false;
        };
        VvolWizardManager.prototype.buildVvolDatastoreCreateSpec = function (hostRef) {
            if (!this.container) {
                this.$log.warn("VvolWizardManager.container can't be undefined");
                return;
            }
            var vvolCreateSpec = new CreateVvolDatastoreSpec();
            vvolCreateSpec.host = hostRef;
            vvolCreateSpec.storageFolder = this.commonWizardManager.getStorageFolder();
            var vvolDatastoreSpec = new DatastoreSystem$VvolDatastoreSpec();
            vvolDatastoreSpec.name = this.commonWizardManager.getDatastoreName();
            vvolDatastoreSpec.scId = this.container.identifier;
            vvolCreateSpec.vvolDatastoreSpec = vvolDatastoreSpec;
            return vvolCreateSpec;
        };
        return VvolWizardManager;
    }());
    storage_ui.VvolWizardManager = VvolWizardManager;
    angular.module("com.vmware.vsphere.client.storage")
        .factory("vvolWizardManagerFactory", ["i18nService", "vxPropertyViewService", "defaultUriSchemeUtil",
        "mutationService", "$log",
        function (i18nService, vxPropertyViewService, defaultUriSchemeUtil, mutationService, $log) {
            return {
                build: function (commonWizardManager) {
                    return new VvolWizardManager(commonWizardManager, i18nService, vxPropertyViewService, defaultUriSchemeUtil, mutationService, $log);
                }
            };
        }]);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .controller('AddDatastoreReadyToCompletePageController', [
            '$scope',
            'i18nService',
            function ($scope, i18nService) {
               var self = this;
               self.summaryData = $scope.activeWizardManager.getReadyToCompletePageData();
               self.summaryTitle = i18nService.getString('StorageUi', 'addDatastoreWizard.readyToComplete.summaryTitle');
            }
         ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('DatastoreTypePageController', [
         '$scope', 'i18nService', 'datastoreConstants', 'wizardPageService',
         function ($scope, i18nService, datastoreConstants, wizardPageService) {
            $scope.wizardConfig.loading = true;

            var self = this;

            self.vmfsType = datastoreConstants.datastoreTypes.VMFS;
            self.vvolType = datastoreConstants.datastoreTypes.VVOL;
            self.isVvolSupported = true;
            showNfsV3RadioButton();

            $scope.commonWizardManager.getAvailableHosts().then(function(availableHosts) {
               if (atLeastOneHostSupportsNfsV41(availableHosts)) {
                  showNfsRadioButton();
               }
               if ($scope.commonWizardManager.isHostContextObject() && availableHosts.length === 1) {
                  self.isVvolSupported = availableHosts[0].isVvolSupported;
               }
            }).finally(function() {
               $scope.wizardConfig.loading = false;
            });

            self.selectDatastoreType = $scope.commonWizardManager.getDatastoreType();

            $scope.$watch('ctrl.selectDatastoreType', function(newType, oldType) {
               if (newType !== oldType) {
                  $scope.wizardConfig.currentPage.decisionOptions.selectedFlowId = newType;
                  $scope.commonWizardManager.setDatastoreType(newType);

                  wizardPageService.initializeFlowStates($scope.wizardConfig.flows);
               }
            });

            function showNfsV3RadioButton() {
               self.nfsType = datastoreConstants.datastoreTypes.NFS3;
               self.nfsTypeLabel = i18nService.getString('StorageUi','datastore.nfs.nfs');
            }

            function showNfsRadioButton() {
               self.nfsType = datastoreConstants.datastoreTypes.NFS;
               self.nfsTypeLabel = i18nService.getString('StorageUi','datastore.nfs');
            }

            function atLeastOneHostSupportsNfsV41(hostsList) {
               var hostsSupportedNfsV41 = hostsList.filter(function(item) {
                  return (item.isNfs4Supported !== undefined && item.isNfs4Supported === true);
               });

               return (hostsSupportedNfsV41.length > 0);
            }
         }
      ]);
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var NfsKerberosAuthenticationPageController = (function () {
        function NfsKerberosAuthenticationPageController(i18nService, datastoreConstants) {
            this.i18nService = i18nService;
            this.datastoreConstants = datastoreConstants;
            this.noKerberos = this.datastoreConstants.kerberosSecurityTypes.AUTH_SYS;
            this.authenticaionOnly = this.datastoreConstants.kerberosSecurityTypes.SEC_KRB5;
            this.authenticationAndIntegrity = this.datastoreConstants.kerberosSecurityTypes.SEC_KRB5I;
            this.i18n = this.i18nService.getString.bind(this, "StorageUi");
        }
        NfsKerberosAuthenticationPageController.prototype.$onInit = function () {
            var _this = this;
            this.isHostContextObject = this.commonWizardManager.isHostContextObject();
            this.commonWizardManager.getAvailableHosts().then(function (result) {
                var hosts = result;
                if (_this.isHostContextObject && hosts.length === 1) {
                    _this.isKrb5iOptionEnabled = hosts[0].isKerberos5iSupported;
                    _this.isKrbOptionEnabled = hosts[0].isInDomain && hosts[0].areKerberosCredentialsSet;
                }
                else {
                    _this.isKrb5iOptionEnabled = true;
                    _this.isKrbOptionEnabled = true;
                }
                _this.selectedOption = _this.selectedOption || _this.noKerberos;
                _this.onSelectionChanged(_this.selectedOption);
                _this.isKrbOption = _this.isHostContextObject && !_this.isKrbOptionEnabled;
                _this.isKrb5iOption = _this.isHostContextObject && (!_this.isKrbOptionEnabled || !_this.isKrb5iOptionEnabled);
            });
        };
        NfsKerberosAuthenticationPageController.$inject = ["i18nService", "datastoreConstants"];
        return NfsKerberosAuthenticationPageController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("nfsKerberosAuthenticationPage", {
        controller: NfsKerberosAuthenticationPageController,
        bindings: {
            commonWizardManager: "<",
            onSelectionChanged: "<",
            selectedOption: "<"
        },
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsKerberosAuthenticationPage.html"
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('NfsNameAndConfigurationPageController', [
         '$scope', 'datastoreConstants', 'vuiConstants', 'i18nService', '$timeout',
         function($scope, datastoreConstants, vuiConstants, i18nService, $timeout) {
            var self = this;

            self.datastoreNameMaxLength = datastoreConstants.maxNameLengthForNfsDatastore;

            self.serverNameTooltipError = '';
            self.serverNameTooltipValidity = 'valid';

            self.isNfs4_1 = function() {
               return $scope.nfsWizardManager.getNfsVersion() === datastoreConstants.nfsVersions.NFS_4_1;
            };

            if ($scope.commonWizardManager.getDatastoreName()) {
               self.datastoreName = $scope.commonWizardManager.getDatastoreName();
            } else {
               // Show loading indicator while retrieving data
               $scope.wizardConfig.loading = true;

               $scope.commonWizardManager.getUniqueDatastoreName().then(function (uniqueName) {
                  self.datastoreName = uniqueName;
                  $scope.commonWizardManager.setDatastoreName(uniqueName);
               }).finally(function() {
                  $scope.wizardConfig.loading = false;
               });
            }

            initializePageData();

            // Workaround which resizes the datagrid after the action bar creation
            $timeout(function () {
               var gridElement = $("div.nfs-servers-grid .k-grid");
               if (gridElement) {
                  var kendoGrid = gridElement.data("kendoGrid");
                  if (kendoGrid) {
                     kendoGrid.resize();
                  }
               }
            }, 0);

            function initializePageData() {
               self.isReadOnly =
                  $scope.nfsWizardManager.getSelectedAccessMode() === datastoreConstants.accessModes.readOnly;
               self.folderName = $scope.nfsWizardManager.getFolderName();
               self.serverName = $scope.nfsWizardManager.getServerName();
               populateServerNamesGrid();
            }

            function populateServerNamesGrid() {
               self.datagridOptions = {
                  height: '100%',
                  pageConfig: {
                     hidePager: false
                  },
                  columnDefs: getColumnDefs(),
                  sortMode: vuiConstants.grid.sortMode.SINGLE,
                  selectionMode: vuiConstants.grid.selectionMode.SINGLE,
                  selectedItems: [],
                  resizable: true,
                  data: _.map($scope.nfsWizardManager.getServerNamesArray(), wrap),
                  actionBarOptions: { actions: [getDeleteAction()] },
                  columnMenu: {
                     sortable: false, // this will hide sort menu items
                     messages: {
                        columns: i18nService.getString('CommonUi', 'listview.showColumnsMenu'),
                        filter: i18nService.getString('CommonUi', 'listview.filterMenu')
                     }
                  }
               };
            }

            self.addServer = function() {
               var errorMessage = $scope.nfsWizardManager.validateServerNames();
               if (!errorMessage) {
                  $scope.nfsWizardManager.addServerNamesAction();

                  self.serverName = ''; //clear the input
                  $("input#serverField").focus(); // focus the field

                  self.datagridOptions.data = _.map($scope.nfsWizardManager.getServerNamesArray(), wrap);
               }

               updateServerNameTooltipError(errorMessage);
            };

            self.addServerIfSpace = function(event) {
               if (event.keyCode === 32) {
                  self.addServer();
               }
            };

            function updateServerNameTooltipError(errorMessage) {
               if (errorMessage) {
                  self.serverNameTooltipError = errorMessage;
                  self.serverNameTooltipValidity = 'invalid';
               } else {
                  self.serverNameTooltipError = '';
                  self.serverNameTooltipValidity = 'valid';
               }
            }

            function wrap(serverName) {
               return { 'serverName': serverName };
            }

            function unwrap(serverNameGridRow) {
               return serverNameGridRow.serverName;
            }

            function getColumnDefs() {
               return [{
                  displayName: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSettingsPage.serverColumn'),
                  field: 'serverName',
                  template: '#:serverName#'
               }];
            }

            function getDeleteAction() {
               return {
                  tooltipText: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSettingsPage.server.remove'),
                  label: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSettingsPage.server.remove'),
                  iconClass: 'vx-icon-removeIcon',
                  enabled: true,
                  onClick: function(){
                     self.datagridOptions.data = _.filter(self.datagridOptions.data, function(item){
                        return item.serverName !== self.datagridOptions.selectedItems[0].serverName;
                     });
                     $scope.nfsWizardManager.setServerNamesArray(_.map(self.datagridOptions.data, unwrap));
                  }
               };
            }

            $scope.$watch(
               function (){
                  return self.datastoreName;
               },
               function (name) {
                  $scope.commonWizardManager.setDatastoreName(name);
               });

            $scope.$watch(
               function(){
                  return self.folderName;
               },
               function(name) {
                  $scope.nfsWizardManager.setFolderName(name);
               });

            $scope.$watch(
               function(){
                  return self.serverName;
               },
               function(newName, oldName) {
                  if (newName !== oldName) {
                     $scope.nfsWizardManager.setServerName(newName);
                     updateServerNameTooltipError(null);
                  }
               });

            $scope.$watch(
               function() {
                  return self.datagridOptions.selectedItems;
               },
               function(items) {
                  var newState = items.length > 0;
                  self.datagridOptions.actionBarOptions.actions[0].enabled = newState;
               });

            $scope.$watch(function(){
               return self.isReadOnly;
            }, function(newValue){
               var accessMode = newValue ? datastoreConstants.accessModes.readOnly : datastoreConstants.accessModes.readWrite;
               $scope.nfsWizardManager.setSelectedAccessMode(accessMode);
            });

            if ($scope.nfsWizardManager.isNfsVersion41()) {
               $scope.$watch(function() {
                  return $scope.nfsWizardManager.getServerNamesArray().join(',');
               }, function(newValue, oldValue) {
                  if (newValue !== oldValue && newValue) {
                     self.datagridOptions.data = _.map($scope.nfsWizardManager.getServerNamesArray(), wrap);
                  }
               });

            }
         }
      ]);
})();

var storage_ui;
(function (storage_ui) {
    var NfsSelectHostsPageController = (function () {
        function NfsSelectHostsPageController(i18nService, vuiConstants, columnRenderersRegistry, datastoreConstants, defaultUriSchemeUtil, $q) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.datastoreConstants = datastoreConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
            this.onSelectionChanged = function (selectedItems) {
                _this.nfsWizardManager.setSelectedHosts(selectedItems);
            };
            this.preselectComparator = function (gridDataItem) {
                var oldSelectedItems = _this.nfsWizardManager.getSelectedHosts();
                if (!oldSelectedItems || !gridDataItem) {
                    return false;
                }
                return !!oldSelectedItems.find(function (item) {
                    return item.formattedName === gridDataItem.formattedName;
                });
            };
            this.isHostValidForSelection = function (hostItem) {
                return hostItem.isHostConnected && hostItem.hasConfigStoragePrivilege
                    && !_this.hasNfs4_1SupportIssue(hostItem)
                    && !_this.hasIpV6SupportIssue(hostItem)
                    && !_this.isHostAlreadyMounted(hostItem)
                    && !_this.hasActiveDirectoryIssue(hostItem)
                    && !_this.hasAuthenticationCredentialsIssue(hostItem)
                    && !_this.hasKrb5iSupportIssue(hostItem);
            };
            this.formatHostName = function (item) {
                var formattedName = item.formattedName;
                if (item.isHostConnected) {
                    if (_this.hasIpV6SupportIssue(item)) {
                        formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.hostDoesNotSupportIpv6Nfs", item.formattedName);
                    }
                    /*In case of multiple host issues show the most important one */
                    if (_this.hasNfs4_1SupportIssue(item)) {
                        formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.nfsv41NotSupported", item.formattedName);
                    }
                    if (_this.nfsWizardManager.getNfsVersion() === _this.datastoreConstants.nfsVersions.NFS_4_1
                        && _this.isKerberosEnabled()) {
                        if (_this.hasKrb5iSupportIssue(item)) {
                            formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.krb5iNotSupported", item.formattedName);
                        }
                        if (_this.hasAuthenticationCredentialsIssue(item)) {
                            formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.noCredentials", item.formattedName);
                        }
                        if (_this.hasActiveDirectoryIssue(item)) {
                            formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.hostNotInDomain", item.formattedName);
                        }
                    }
                    /*In case of multiple host issues show the most important one */
                    if (_this.isHostAlreadyMounted(item)) {
                        formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsSelectHostsPage.hostAlreadyMounted", item.formattedName);
                    }
                    if (!item.hasConfigStoragePrivilege) {
                        formattedName = _this.i18nService.getString("StorageUi", "addDatastoreWizard.notEnoughPrivileges", item.formattedName);
                    }
                }
                return formattedName;
            };
        }
        NfsSelectHostsPageController.prototype.$onInit = function () {
            var _this = this;
            this.wizardConfig.loading = true;
            this.mountedHosts = {};
            var pagePromises = {
                availableHosts: this.commonWizardManager.getAvailableHosts(),
                mountedHosts: this.nfsWizardManager.requestExistingDatastoreHosts()
            };
            this.$q.all(pagePromises).then(function (response) {
                if (!response) {
                    return;
                }
                _this.mountedHosts = response.mountedHosts;
                _this.hostsData = response.availableHosts;
            }).finally(function () {
                _this.wizardConfig.loading = false;
            });
        };
        NfsSelectHostsPageController.prototype.hasNfs4_1SupportIssue = function (item) {
            return this.nfsWizardManager.getNfsVersion() === this.datastoreConstants.nfsVersions.NFS_4_1 && !item.isNfs4Supported;
        };
        NfsSelectHostsPageController.prototype.hasIpV6SupportIssue = function (item) {
            return this.nfsWizardManager.hasIpV6Servers() && !item.isIpV6NfsSupported;
        };
        NfsSelectHostsPageController.prototype.hasActiveDirectoryIssue = function (item) {
            return this.isKerberosEnabled() && !item.isInDomain;
        };
        NfsSelectHostsPageController.prototype.hasAuthenticationCredentialsIssue = function (item) {
            return this.isKerberosEnabled() && !item.areKerberosCredentialsSet;
        };
        NfsSelectHostsPageController.prototype.hasKrb5iSupportIssue = function (item) {
            var authenticationType = this.nfsWizardManager.getKerberosAuthenticationType();
            return authenticationType === this.datastoreConstants.kerberosSecurityTypes.SEC_KRB5I
                && !item.isKerberos5iSupported;
        };
        NfsSelectHostsPageController.prototype.isHostAlreadyMounted = function (item) {
            var hostId = this.defaultUriSchemeUtil.getVsphereObjectId(item.hostRef);
            if (this.mountedHosts) {
                return this.mountedHosts.hasOwnProperty(hostId);
            }
            return false;
        };
        NfsSelectHostsPageController.prototype.isKerberosEnabled = function () {
            var authenticationType = this.nfsWizardManager.getKerberosAuthenticationType();
            return authenticationType === this.datastoreConstants.kerberosSecurityTypes.SEC_KRB5
                || authenticationType === this.datastoreConstants.kerberosSecurityTypes.SEC_KRB5I;
        };
        NfsSelectHostsPageController.$inject = ["i18nService", "vuiConstants",
            "columnRenderersRegistry", "datastoreConstants", "defaultUriSchemeUtil", "$q"];
        return NfsSelectHostsPageController;
    }());
    storage_ui.NfsSelectHostsPageController = NfsSelectHostsPageController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("nfsSelectHostsPage", {
        controller: NfsSelectHostsPageController,
        bindings: {
            wizardConfig: "<",
            nfsWizardManager: "<",
            commonWizardManager: "<"
        },
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsSelectHostsPageComponent.html"
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('NfsVersionPageController', [
         '$scope', 'i18nService', 'datastoreConstants', 'wizardPageService',
         function ($scope, i18nService, datastoreConstants, wizardPageService) {
            var self = this;

            self.nfsV3 = datastoreConstants.nfsVersions.NFS_3;
            self.nfsV41 = datastoreConstants.nfsVersions.NFS_4_1;
            self.selectNfsVersion = $scope.nfsWizardManager.getNfsVersion();

            $scope.$watch('ctrl.selectNfsVersion', function(newType, oldType) {
               if (newType !== oldType) {
                  $scope.nfsWizardManager.setNfsVersion(newType);

                  var flows = $scope.wizardConfig.flows;
                  var currentFlow = _.find(flows, function (flow) {
                     return flow.id === $scope.commonWizardManager.getDatastoreType();
                  });

                  var pages = currentFlow ? currentFlow.pages : [];

                  if (newType === self.nfsV41) {
                     wizardPageService.markPageDisabled(
                        pages,
                        i18nService.getString("StorageUi", "addDatastoreWizard.nfsKerberosPage.title"));
                  } else {
                     wizardPageService.markPageSkipped(
                        pages,
                        i18nService.getString("StorageUi", "addDatastoreWizard.nfsKerberosPage.title"));
                  }

                  wizardPageService.invalidateNextPages($scope.wizardConfig,
                     $scope.commonWizardManager.getDatastoreType(), $scope.wizardConfig.currentPage.title);
               }
            });
         }
      ]);
})();

var storage_ui;
(function (storage_ui) {
    var SelectHostsPageComponentController = (function () {
        function SelectHostsPageComponentController(i18nService, vuiConstants, columnRenderersRegistry) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.onPreSelect = function (item) {
                return _this.preSelectComparator ? _this.preSelectComparator(item) : false;
            };
            this.initDatagridOptions();
        }
        SelectHostsPageComponentController.prototype.initDatagridOptions = function () {
            var _this = this;
            var self = this;
            this.datagridOptions = {
                resizable: true,
                height: "100%",
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                selectedItems: [],
                pageConfig: {
                    displayMode: this.vuiConstants.grid.displayMode.VIRTUAL_SCROLLING
                },
                columnDefs: this.getColumnDefs(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                data: this.hosts,
                isItemDisabledCallback: function (item) { return !_this.isHostValidForSelection(item); },
                columnMenu: {
                    sortable: false,
                    messages: {
                        columns: this.i18nService.getString("CommonUi", "listview.showColumnsMenu"),
                        filter: this.i18nService.getString("CommonUi", "listview.filterMenu")
                    }
                }
            };
            //each time grid is displayed empty ([]) selection is fired
            //since we use onChange, and it's fired BEFORE preselection comparator callback
            // - we have to introduce this workaround
            var isInitialEmptySelection = true;
            if (this.onSelectionChange) {
                this.datagridOptions["onChange"] = function () {
                    self.onSelectionChange(_this.datagridOptions.selectedItems, isInitialEmptySelection);
                    isInitialEmptySelection = false;
                };
            }
        };
        SelectHostsPageComponentController.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("StorageUi", "addDatastoreWizard.selectHostsPage.hostColumnTitle"),
                    field: "formattedName",
                    width: "150px",
                    template: function (item) { return _this.getTemplate("vsphere-icon-host", item.formattedName, item); }
                },
                {
                    displayName: this.i18nService.getString("StorageUi", "addDatastoreWizard.selectHostsPage.clusterColumnTitle"),
                    field: "clusterName",
                    width: "150px",
                    template: function (item) {
                        if (item.clusterName) {
                            return _this.renderIconText("vsphere-icon-cluster", item.clusterName, _this.isHostValidForSelection(item));
                        }
                        return "";
                    }
                }];
        };
        SelectHostsPageComponentController.prototype.isHostValidForSelection = function (host) {
            var isValid = host.isHostConnected;
            if (this.isHostValidForSelectionCustom) {
                return isValid && this.isHostValidForSelectionCustom(host);
            }
            return isValid;
        };
        ;
        SelectHostsPageComponentController.prototype.getTemplate = function (icon, name, item) {
            var formattedName = name;
            if (this.formatName) {
                formattedName = this.formatName(item);
            }
            return this.renderIconText(icon, formattedName, this.isHostValidForSelection(item));
        };
        SelectHostsPageComponentController.prototype.renderIconText = function (icon, text, enabled) {
            return "<div><span class=\"" + icon + "\"></span>" + this.getDisabledTextRenderer(text, enabled) + "</div>";
        };
        SelectHostsPageComponentController.prototype.getDisabledTextRenderer = function (text, enabled) {
            var disabledTextRenderer = this.columnRenderersRegistry.getColumnRenderer("disabled-text");
            return disabledTextRenderer(["text", "disabled"], {
                text: text,
                disabled: !enabled
            });
        };
        SelectHostsPageComponentController.$inject = ["i18nService", "vuiConstants", "columnRenderersRegistry"];
        return SelectHostsPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage").component("selectHostsPageComponent", {
        controller: SelectHostsPageComponentController,
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/SelectHostsPageComponent.html",
        bindings: {
            isHostValidForSelectionCustom: "<?",
            preSelectComparator: "<?",
            hosts: "<",
            onSelectionChange: "<?",
            formatName: "<?"
        }
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .controller('VmfsMountOptionsPageController', [
            '$scope',
            'i18nService',
            function ($scope, i18nService) {
               var self = this;

               self.getString = _.partial(i18nService.getString, 'StorageUi');

               self.mountOptions = $scope.vmfsWizardManager.mountOptions;

               var selectedDiskInfo = $scope.vmfsWizardManager.getSelectedScsiDiskInfo();

               self.isVmfsVolumeResolvable =
                     selectedDiskInfo &&
                     selectedDiskInfo.unresolvedExtent &&
                     selectedDiskInfo.unresolvedExtent.isHeadExtent === true &&
                     selectedDiskInfo.resolveStatus &&
                     selectedDiskInfo.resolveStatus.resolvable === true;

               self.mountOptionItems = [
                  {
                     label: self.getString('addDatastoreWizard.vmfsMountOptionsPage.newSignature'),
                     description: self.getString('addDatastoreWizard.vmfsMountOptionsPage.newSignatureDescription'),
                     value: self.mountOptions.ASSIGN_NEW_SIGNATURE,
                     isEnabled: self.isVmfsVolumeResolvable
                  },
                  {
                     label: self.getString('addDatastoreWizard.vmfsMountOptionsPage.keepSignature'),
                     description: self.getString('addDatastoreWizard.vmfsMountOptionsPage.keepSignatureDescription'),
                     value: self.mountOptions.KEEP_SIGNATURE,
                     isEnabled: self.isVmfsVolumeResolvable
                  },
                  {
                     label: self.getString('addDatastoreWizard.vmfsMountOptionsPage.formatDisk'),
                     description: self.getString('addDatastoreWizard.vmfsMountOptionsPage.formatDiskDescription'),
                     value: self.mountOptions.FORMAT_DISK,
                     isEnabled: true
                  }
               ];

               var signature =
                     $scope.vmfsWizardManager.getSelectedScsiDiskInfo().volumeSignature;
               self.signatureInfoText = self.getString(
                     'addDatastoreWizard.vmfsMountOptionsPage.signatureInfo', signature);

               self.selectedMountOption = null;
               if (!self.isVmfsVolumeResolvable) {
                  self.selectedMountOption = self.mountOptions.FORMAT_DISK;
               } else {
                  self.selectedMountOption = $scope.vmfsWizardManager.getSelectedMountOption()
                        || self.mountOptions.KEEP_SIGNATURE /*Default value*/;
               }
               $scope.$watch(
                     function () {
                        return self.selectedMountOption;
                     },
                     function (selectedMountOption) {
                        $scope.vmfsWizardManager.setSelectedMountOption(selectedMountOption);
                     });
            }
         ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .controller('VmfsNameAndDevicePageController', [
            '$scope',
            'i18nService',
            '$q',
            'datastoreConstants',
            'wizardPageService',
            'storageUtil',
            function ($scope, i18nService, $q, datastoreConstants, wizardPageService, storageUtil) {
               var self = this;

               self.getString = i18nService.getString;
               self.datastoreName = '';
               self.showHostSelector = !$scope.commonWizardManager.isHostContextObject();

               var selectHostPlaceHolder = {
                  formattedName: self.getString('StorageUi',
                        'addDatastoreWizard.vmfsSelectDevicePage.selectHostItem'),
                  isPlaceholderOptionItem: true
               };

               self.selectedHost = selectHostPlaceHolder;

               var pagePromises = [];

               if ($scope.commonWizardManager.getDatastoreName()) {
                  self.datastoreName = $scope.commonWizardManager.getDatastoreName();
               } else {
                  pagePromises.push(
                        $scope.commonWizardManager.getUniqueDatastoreName().then(function (uniqueName) {
                           self.datastoreName = uniqueName;
                           $scope.commonWizardManager.setDatastoreName(uniqueName);
                        }));
               }

               if (self.showHostSelector) {
                  pagePromises.push(
                        $scope.commonWizardManager.getAvailableHosts().then(function(availableHosts) {
                           var availableHostItems = availableHosts.slice();
                           availableHostItems.splice(0, 0, selectHostPlaceHolder);
                           self.availableHosts = availableHostItems;

                           if ($scope.vmfsWizardManager.getSelectedHostId()) {
                              self.selectedHost = _.find(availableHostItems,
                                    function (hostItem) {
                                       return hostItem.hostId ===
                                             $scope.vmfsWizardManager.getSelectedHostId();
                                    });
                              requestDiskInfos(self.selectedHost);
                           }
                        })
                  );
               } else {
                  pagePromises.push(
                        $scope.vmfsWizardManager.requestAvailableScsiDiskInfos().then(function (diskInfos) {
                           self.availableDiskInfos = diskInfos;
                        })
                  );

                  pagePromises.push(
                     $scope.commonWizardManager.getAvailableHosts().then(function(availableHosts) {
                        if (availableHosts && availableHosts.length) {
                           $scope.vmfsWizardManager.updateVmfsVersionPageVisibility(availableHosts[0]);
                           $scope.vmfsWizardManager.setIsVmfs6Supported(availableHosts[0].isVMFS6Supported);
                        }
                     })
                  );
               }

               self.selectedDiskInfo = $scope.vmfsWizardManager.getSelectedScsiDiskInfo();

               // Show loading indicator while retrieving data
               $scope.wizardConfig.loading = true;
               $q.all(pagePromises).then(function () {
                  $scope.wizardConfig.loading = false;
               }, $scope.removeLoadingAndShowError);

               self.onSelectedDeviceChanged = function(selectedDevice) {
                  if ($scope.vmfsWizardManager.getSelectedScsiDiskInfo() !== selectedDevice) {
                     $scope.vmfsWizardManager.setSelectedScsiDiskInfo(selectedDevice);
                     self.selectedDiskInfo = $scope.vmfsWizardManager.getSelectedScsiDiskInfo();

                     wizardPageService.clearErrors($scope.wizardConfig);

                     if (self.selectedDiskInfo && storageUtil.is4kDevice(self.selectedDiskInfo.disk)) {
                        if(!$scope.vmfsWizardManager.getIsVmfs6Supported()) {
                           wizardPageService.markPageIncompleteWithError($scope.wizardConfig,
                              i18nService.getString('StorageUi', "datastoreWizards.selectDevicePage.incompatibleSelection"));
                        } else {
                           $scope.vmfsWizardManager.skipVmfsVersionPage(true);
                           $scope.vmfsWizardManager.setSelectedVmfsVersion(datastoreConstants.vmfsVersions.VMFS_6);
                        }
                     } else {
                        $scope.vmfsWizardManager.updateVmfsVersionPageVisibility({isVMFS6Supported: $scope.vmfsWizardManager.getIsVmfs6Supported()});
                     }
                  }
               };

               self.getFormattedNameWithPrivilege = function(hostObj) {
                  if (hostObj.isHostConnected && !hostObj.hasConfigStoragePrivilege && !hostObj.isPlaceholderOptionItem) {
                     return i18nService.getString('StorageUi', 'addDatastoreWizard.notEnoughPrivileges', hostObj.formattedName);
                  }
                  return hostObj.formattedName;
               };

               $scope.$watch(
                     function () {
                        return self.datastoreName;
                     },
                     function (datastoreName) {
                        $scope.commonWizardManager.setDatastoreName(datastoreName);
                     }
               );

               $scope.$watch(
                     function() {
                        return self.selectedHost;
                     }, function(newHostDataItem, oldHostDataItem) {
                        if (newHostDataItem !== oldHostDataItem) {

                           $scope.vmfsWizardManager.setSelectedScsiDiskInfo(null);
                           $scope.vmfsWizardManager.updateVmfsVersionPageVisibility(newHostDataItem);
                           self.availableDiskInfos = [];

                           if (!newHostDataItem || newHostDataItem.isPlaceholderOptionItem) {
                              $scope.vmfsWizardManager.setSelectedHostId(null);
                              $scope.vmfsWizardManager.setIsVmfs6Supported(false);
                           } else {
                              $scope.vmfsWizardManager.setSelectedHostId(
                                    newHostDataItem.hostId);
                              $scope.vmfsWizardManager.setIsVmfs6Supported(newHostDataItem.isVMFS6Supported);
                              requestDiskInfos(newHostDataItem);
                           }
                     }
                  });

               function requestDiskInfos(hostDataItem) {
                  if (hostDataItem && hostDataItem.isHostConnected && hostDataItem.hasConfigStoragePrivilege) {
                     self.availableDiskInfos = [];
                     $scope.wizardConfig.loading = true;
                     $scope.vmfsWizardManager.requestAvailableScsiDiskInfos().then(
                        function (diskInfos) {
                           $scope.wizardConfig.loading = false;
                           self.availableDiskInfos = diskInfos;
                        }, $scope.removeLoadingAndShowError);
                  }
               }
            }
         ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .controller('VmfsPartitionConfigurationPageController', [
            '$scope',
            'i18nService',
            '$q',
            function ($scope, i18nService) {
               var self = this;

               self.getString = i18nService.getString;

               self.configurationItems = [];

               self.selectedConfigurationItem =
                     $scope.vmfsWizardManager.getSelectedVmfsDatastoreOptionItem();

               self.labels = {
                  comboBox: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.partitionConfiguration'),
                  slider: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsPartitionConfigPage.datastoreSize'),
                  gb: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.gb')
               };

               self.isDataLoaded = false;
               self.configurationError = null;

               $scope.wizardConfig.loading = true;
               $scope.vmfsWizardManager.requestVmfsCreateOptionItems().then(
                     function (result) {
                        // Note that the directive is modifying its 'options' field,
                        // passed by its clients, adding the default option in its linking phase.
                        // This means that once the directive is initialized with a given set
                        // of options, it adds the default one. If, however, this set is changed
                        // afterwards, the default one is not added. This is why we have
                        // ng-if="ctrl.isDataLoaded" for the directive in our view.
                        // This way we only initialize the directive once we have the data.
                        self.configurationItems = result.optionItems;
                        self.diskPartitionInfo = result.diskPartitionInfo;
                        self.vmfsBlockSizeOptions = result.blockSizeOptions;
                        self.isDataLoaded = true;
                        if (!self.configurationItems.length) {
                           self.configurationError = i18nService.getString('StorageUi', 'storage.wizards.vmfsDiskError');
                        }
                        if (self.selectedConfigurationItem) {
                           self.selectedConfigurationItem = self.configurationItems.find(function(data) {
                              return data.id && _.isEqual(data.id, self.selectedConfigurationItem.id);
                           });
                        }
                        $scope.wizardConfig.loading = false;
                     }, $scope.removeLoadingAndShowError);

               self.onSelectedOptionChanged = function(configurationItem) {
                  if (configurationItem ===
                        $scope.vmfsWizardManager.getSelectedVmfsDatastoreOptionItem()
                        && configurationItem
                        && configurationItem.sizeToAdd === $scope.vmfsWizardManager.getDatastoreSizeInGb()) {
                     return;
                  }

                  if (!configurationItem ||
                        configurationItem.isSelectConfigurationOption === true) {
                     $scope.vmfsWizardManager.setSelectedVmfsDatastoreOptionItem(null);
                  } else {
                     $scope.vmfsWizardManager.setSelectedVmfsDatastoreOptionItem(configurationItem);
                     // Current function gets fired by the directive when either
                     // (1) partition configuration option item or
                     // (2) datastore size get changed.
                     // Note that the updated datastore size is passed in as configurationItem.sizeToAdd.
                     $scope.vmfsWizardManager.setDatastoreSizeInGb(configurationItem.sizeToAdd);
                  }
               };

            }
         ]);
})();

var storage_ui;
(function (storage_ui) {
    var VmfsVersionPageController = (function () {
        function VmfsVersionPageController() {
            this.selectedOption =
                this.selectedOption || this.options[0].value;
            this.onSelectionChanged(this.selectedOption);
        }
        return VmfsVersionPageController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("vmfsVersionWizardPage", {
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vmfs/VmfsVersionPageComponent.html",
        bindings: {
            options: "<",
            selectedOption: "<",
            onSelectionChanged: "<"
        },
        controller: VmfsVersionPageController
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var StorageContainerInfoItem = com.vmware.vsphere.client.h5.storage.data.datastore.StorageContainerInfoItem;
    var VvolNameAndContainerSelectionPageComponentController = (function () {
        function VvolNameAndContainerSelectionPageComponentController(i18nService, vuiConstants, dataService, columnRenderersRegistry, vxPropertyViewService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.vxPropertyViewService = vxPropertyViewService;
            this.NO_SELECTION_DETAILS = new StorageContainerInfoItem();
            this.STORAGE_CONTAINERS_INFO = "datastore:filteredStorageContainerInfos";
            this.preselectComparator = function (gridDataItem) {
                if (_this.datagridOptions.selectedItems.length || !_this.datagridOptions.data) {
                    return false;
                }
                if (_this.vvolWizardManager.container) {
                    return _this.vvolWizardManager.container.identifier === gridDataItem.identifier;
                }
                return _this.datagridOptions.data[0].identifier === gridDataItem.identifier;
            };
        }
        VvolNameAndContainerSelectionPageComponentController.prototype.$onInit = function () {
            var _this = this;
            if (!this.commonWizardManager.getDatastoreName()) {
                this.commonWizardManager.getUniqueDatastoreName()
                    .then(function (uniqueName) {
                    _this.datastoreName = uniqueName;
                    _this.onDatastoreNameChange();
                });
            }
            else {
                this.datastoreName = this.commonWizardManager.getDatastoreName();
            }
            this.initDatagridOptions();
            this.dataService.getProperties(this.commonWizardManager.getContextObject(), [this.STORAGE_CONTAINERS_INFO])
                .then(function (response) {
                _this.datagridOptions.data = response[_this.STORAGE_CONTAINERS_INFO];
                //used for validation
                _this.vvolWizardManager.availableContainers = _this.datagridOptions.data;
            });
        };
        VvolNameAndContainerSelectionPageComponentController.prototype.onDatastoreNameChange = function () {
            this.commonWizardManager.setDatastoreName(this.datastoreName);
        };
        VvolNameAndContainerSelectionPageComponentController.prototype.initDatagridOptions = function () {
            var _this = this;
            var isInitial = true;
            this.datagridOptions = {
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                selectedItems: [],
                resizable: true,
                onChange: function () {
                    if (isInitial) {
                        isInitial = false;
                        return;
                    }
                    if (_this.datagridOptions.selectedItems.length && _this.datagridOptions.selectedItems[0]) {
                        var selectedItem = _this.datagridOptions.selectedItems[0];
                        _this.populateDetailsView(selectedItem);
                        _this.vvolWizardManager.container = selectedItem;
                    }
                    else {
                        _this.populateDetailsView(_this.NO_SELECTION_DETAILS);
                        _this.vvolWizardManager.container = null;
                    }
                }
            };
        };
        VvolNameAndContainerSelectionPageComponentController.prototype.populateDetailsView = function (selection) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var category = builder.category('category');
            category.section('general')
                .property(this.i18nService.getString('StorageUi', 'datastore.manage.general.backing.storageArray'), selection.storageArrays || this.i18nService.getString('StorageUi', 'informationNotAccessible'))
                .property(this.i18nService.getString('StorageUi', 'datastore.manage.general.backing.storageProvider'), selection.storageProviders || this.i18nService.getString('StorageUi', 'informationNotAccessible'));
            this.detailsViewConfig = builder.build();
        };
        VvolNameAndContainerSelectionPageComponentController.prototype.deviceRenderer = function () {
            var _this = this;
            return (function (data) {
                if (data.existingDatastoreName === _this.i18nService.getString('StorageUi', 'informationNotAccessible')) {
                    return _this.columnRenderersRegistry.getColumnRenderer("text")(["existingDatastoreName"], data);
                }
                else {
                    var objectLinkRenderer = _this.columnRenderersRegistry.getColumnRenderer("icon-text-ex");
                    var rendererConfig = { icon: ["vsphere-icon-datastore"] };
                    return objectLinkRenderer(["existingDatastoreName"], data, rendererConfig);
                }
            });
        };
        VvolNameAndContainerSelectionPageComponentController.prototype.getColumnDefinitions = function () {
            return [{
                    displayName: this.i18nService.getString("StorageUi", "storageContainerList.columns.name"),
                    field: "name",
                    width: "200px",
                    template: function (item) { return item.name; }
                }, {
                    displayName: this.i18nService.getString("StorageUi", "storageContainerList.columns.identifier"),
                    field: "identifier",
                    template: function (item) { return item.identifier; }
                }, {
                    displayName: this.i18nService.getString("StorageUi", "storageContainerList.columns.maxDiskSize"),
                    field: "capacity",
                    width: "80px",
                    sortable: false,
                    template: function (item) { return item.capacity; }
                }, {
                    displayName: this.i18nService.getString("StorageUi", "storageContainerList.columns.datastore"),
                    field: "dsColumn",
                    sortable: function (item1, item2) {
                        return item1.existingDatastoreName > item2.existingDatastoreName;
                    },
                    template: this.deviceRenderer()
                }
            ];
        };
        VvolNameAndContainerSelectionPageComponentController.$inject = ["i18nService", "vuiConstants", "dataService",
            "columnRenderersRegistry", "vxPropertyViewService"];
        return VvolNameAndContainerSelectionPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.storage")
        .component("vvolNameAndContainerSelectionPage", {
        controller: VvolNameAndContainerSelectionPageComponentController,
        bindings: {
            commonWizardManager: "<",
            vvolWizardManager: "<"
        },
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vvol/VvolNameAndContainerSelectionComponent.html"
    });
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var VvolSelectHostsPageComponentController = (function () {
        function VvolSelectHostsPageComponentController(i18nService, defaultUriSchemeUtil) {
            var _this = this;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.onSelectionChanged = function (selection, isInitialEmptySelection) {
                if (!isInitialEmptySelection) {
                    _this.vvolWizardManager.selectedHosts = selection;
                }
            };
            this.preSelectComparator = function (item) {
                var selection = _this.vvolWizardManager.selectedHosts;
                if (!selection || !selection.length) {
                    return false;
                }
                return !!_.find(selection, function (selectionItem) { return item.hostId === selectionItem.hostId; });
            };
        }
        VvolSelectHostsPageComponentController.prototype.$onInit = function () {
            var _this = this;
            this.commonWizardManager
                .getAvailableHosts()
                .then(function (hosts) {
                _this.hostsData = _this.updateAvailableHosts(hosts);
            });
        };
        /**
         * Based on storage container selection change the availableHosts to be displayed in
         * the HostsPage
         */
        VvolSelectHostsPageComponentController.prototype.updateAvailableHosts = function (hosts) {
            var _this = this;
            if (!this.vvolWizardManager.container) {
                return [];
            }
            var item = this.vvolWizardManager.container;
            if (!item.info.hosts) {
                // The container is not mounted to any host yet. Make them all available.
                return hosts;
            }
            //Filters out hosts that have container mounted onto them
            return _.filter(hosts, function (availableHost) {
                return !_.find(item.info.hosts, function (hostMount) {
                    var hostMountId = _this.defaultUriSchemeUtil.getVsphereObjectId(hostMount);
                    return hostMountId === availableHost.hostId;
                });
            });
        };
        VvolSelectHostsPageComponentController.prototype.formatHostName = function (item) {
            var formattedName = item.formattedName;
            if (item.isHostConnected) {
                if (!item.isVvolSupported) {
                    formattedName = this.i18nService.getString("StorageUi", "addDatastoreWizard.vvolSelectHostsPage.vvolNotSupported", formattedName);
                }
                if (!item.hasConfigStoragePrivilege) {
                    formattedName = this.i18nService.getString("StorageUi", "addDatastoreWizard.notEnoughPrivileges", formattedName);
                }
            }
            return formattedName;
        };
        VvolSelectHostsPageComponentController.prototype.isHostSupported = function (item) {
            return !!(item.isVvolSupported && item.hasConfigStoragePrivilege);
        };
        VvolSelectHostsPageComponentController.$inject = ["i18nService", "defaultUriSchemeUtil"];
        return VvolSelectHostsPageComponentController;
    }());
    storage_ui.VvolSelectHostsPageComponentController = VvolSelectHostsPageComponentController;
    angular.module("com.vmware.vsphere.client.storage")
        .component("vvolSelectHostPageComponent", {
        controller: VvolSelectHostsPageComponentController,
        bindings: {
            commonWizardManager: "<",
            vvolWizardManager: "<"
        },
        templateUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vvol/VvolSelectHostsPageComponent.html"
    });
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .service('addDatastoreNameValidatorService', addDatastoreNameValidatorService);

   addDatastoreNameValidatorService.$inject = ['dataService', 'i18nService', '$q'];

   function addDatastoreNameValidatorService(dataService, i18nService, $q) {

      var DATASTORE_INFO_BY_NAME_PROP = 'datastore:datastoreInfoByDatastoreName';
      var VALIDATE_NFS_NAME_CONFIGURATION = 'datastore:validateNfsNameAndConfiguration';

      return {
         /**
          * Validates a datastore name's length and uniqueness in the datacenter of
          * the contextObject.
          *
          * @param contextObject
          *    Valid types are host, cluster, datacenter and storage folder.
          *
          * @param datastoreName
          *    Datastore name to be validated.
          *
          * @param maxLengthName
          *    Maximum allowed length of the datastore name.
          *
          * @param datastoreInfoValidationCallback
          *    Optional callback fired when there is datastore with the same name.
          *    It can be used to provide a custom error message. It takes one argument -
          *    the Datastore.Info of the datastore with the matching name and should
          *    return a String value:
          *        a) Null if the datastore name is valid
          *        b) Error text if not.
          *
          * @returns
          *    String value:
          *        a) Null if the datastore name is valid
          *        b) Error text if not.
          */
         validate: function (
               contextObject, datastoreName, maxLengthName, datastoreInfoValidationCallback) {

            if (!datastoreName) {
               return $q.when(i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.nameValidator.noDatastoreName'));
            }

            if (datastoreName.length > maxLengthName) {
               return $q.when(i18nService.getString(
                     'StorageUi', 'addDatastoreWizard.nameValidator.nameTooLong',
                     maxLengthName));
            }

            return dataService.getProperties(
                  contextObject,
                  [DATASTORE_INFO_BY_NAME_PROP],
                  {
                     propertyParams: [{
                        propertyName: DATASTORE_INFO_BY_NAME_PROP,
                        parameterType: 'java.lang.String',
                        parameter: datastoreName
                     }]
                  }).then(function (response) {

               var datastoreInfos =
                     response ? response[DATASTORE_INFO_BY_NAME_PROP] || []
                              : [];

               var matchingDatastoreInfo = _.find(datastoreInfos, function(item) {
                  return datastoreName === item.name;
               });

               if (!matchingDatastoreInfo) {
                  // No matching datastores - valid name
                  return null;
               }

               if (datastoreInfoValidationCallback) {
                  // Call the validation callback for custom error message.
                  return datastoreInfoValidationCallback(matchingDatastoreInfo);
               } else {
                  return i18nService.getString(
                        'StorageUi', 'addDatastoreWizard.nameValidator.default.duplicateName');
               }
            });
         },

         validateNfsNameAndConfiguration: function(contextObject, datastoreName, folderName, serverNames, datastoreType) {
            return dataService.getProperties(
               contextObject,
               [VALIDATE_NFS_NAME_CONFIGURATION],
               {
                  propertyParams: [
                     {
                        propertyName: VALIDATE_NFS_NAME_CONFIGURATION,
                        parameterType: 'com.vmware.vsphere.client.h5.storage.spec.NfsDatastoreConfigurationSpec',
                        parameter: {
                           _type: 'com.vmware.vsphere.client.h5.storage.spec.NfsDatastoreConfigurationSpec',
                           datastoreName: datastoreName,
                           folderName: folderName,
                           serverNames: serverNames,
                           type: datastoreType
                        }
                     }]
               }).then(function(response) {
                  return response[VALIDATE_NFS_NAME_CONFIGURATION] || "";
            });
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
         .service('addDatastoreReadyToCompletePageService', addDatastoreReadyToCompletePageService);

   addDatastoreReadyToCompletePageService.$inject = ['i18nService', 'vuiConstants'];

   function addDatastoreReadyToCompletePageService(i18nService, vuiConstants) {
      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('CommonUi', 'SummaryPage.title'),
               description: i18nService.getString('CommonUi', 'SummaryPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/AddDatastoreReadyToCompletePage.html',
               state: undefined,
               onCommit: function () {
                  wizardScope.wizardConfig.currentPage.state = vuiConstants.wizard.pageState.COMPLETED;
                  return wizardScope.activeWizardManager.submit();
               }
            };
         }
      };
   }
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('datastoreTypePageService', datastoreTypePageService);

   datastoreTypePageService.$inject = [
      'i18nService',
      'vuiConstants',
      'datastoreConstants',
      'wizardPageService',
      '$log'];

   function datastoreTypePageService(i18nService, vuiConstants, datastoreConstants, wizardPageService, $log) {
      return {
         build: function (wizardScope, flowIds) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.datastoreTypePage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.datastoreTypePage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/DatastoreTypePage.html',
               decisionOptions: {
                  flowIds: flowIds,
                  selectedFlowId: datastoreConstants.datastoreTypes.VMFS
               },
               defaultState: vuiConstants.wizard.pageState.SKIPPED,
               onCommit: function() {
                  var selectedType = wizardScope.commonWizardManager.getDatastoreType();
                  switch (selectedType){
                     case datastoreConstants.datastoreTypes.VMFS:
                        wizardScope.activeWizardManager = wizardScope.vmfsWizardManager;
                        break;
                     case datastoreConstants.datastoreTypes.NFS:
                     case datastoreConstants.datastoreTypes.NFS3:
                        wizardScope.activeWizardManager = wizardScope.nfsWizardManager;
                        break;
                     case datastoreConstants.datastoreTypes.VVOL:
                        wizardScope.activeWizardManager = wizardScope.vvolWizardManager;
                        break;
                     default:
                        $log.warn('No activeWizardManager was found for ' + selectedType);
                  }

                  wizardPageService.markPageComplete(wizardScope.wizardConfig, selectedType);
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var storage_ui;
(function (storage_ui) {
    var NfsKerberosAuthenticationPageService = (function () {
        function NfsKerberosAuthenticationPageService(wizardPageService, i18nService, vuiConstants) {
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
        }
        NfsKerberosAuthenticationPageService.prototype.validate = function (wizardScope) {
            this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType());
            return true;
        };
        NfsKerberosAuthenticationPageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsKerberosPage.title"),
                description: this.i18nService.getString("StorageUi", "addDatastoreWizard.nfsKerberosPage.description"),
                contentUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsKerberousAuthenticationComponentPage.html",
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
                onCommit: function () {
                    return _this.validate(wizardScope);
                }
            };
        };
        NfsKerberosAuthenticationPageService.$inject = ["wizardPageService", "i18nService", "vuiConstants"];
        return NfsKerberosAuthenticationPageService;
    }());
    storage_ui.NfsKerberosAuthenticationPageService = NfsKerberosAuthenticationPageService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("nfsKerberosAuthenticationPageService", NfsKerberosAuthenticationPageService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('nfsNameAndConfigurationPageService', nfsNameAndConfigurationPageService);

   nfsNameAndConfigurationPageService.$inject = [
      'i18nService',
      'wizardPageService',
      'addDatastoreNameValidatorService', '$q', 'defaultUriSchemeUtil'];

   function nfsNameAndConfigurationPageService (
      i18nService, wizardPageService, addDatastoreNameValidatorService, $q, defaultUriSchemeUtil) {
      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSettingsPage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSettingsPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsNameAndConfigurationPage.html',
               state: undefined,
               onCommit: function() {
                  return validate(wizardScope).then(function(errors) {
                     if (errors && errors.length > 0) {
                        wizardPageService.markPageIncompleteWithErrors(
                           wizardScope.wizardConfig,
                           errors);
                        return false;
                     }

                     wizardScope.wizardConfig.validationBanner.messages = [];
                     wizardPageService.markPageComplete(wizardScope.wizardConfig,
                        wizardScope.commonWizardManager.getDatastoreType());
                     return true;
                  });
               }
            };
         }
      };

      function validate(wizardScope) {
         var errors = [];

         wizardScope.nfsWizardManager.setExistingDatastoreId(null);

         // Validate datastore name
         if (!wizardScope.commonWizardManager.getDatastoreName()) {
            errors.push(i18nService.getString(
               'StorageUi', 'addDatastoreWizard.nameValidator.noDatastoreName'));
         }

         // Validate folder name
         if (!wizardScope.nfsWizardManager.getFolderName()) {
            errors.push(i18nService.getString(
               'StorageUi', 'addDatastoreWizard.nfsSettingsPage.folderNameEmpty'));
         }

         // Validate server names
         var serverNamesInvalidError = wizardScope.nfsWizardManager.validateServerNames();
         if (serverNamesInvalidError) {
            errors.push(serverNamesInvalidError);
         }

         if (errors.length) {
            return $q.when(errors);
         }

         return validateDatastoreNameAndConfiguration(wizardScope);
      }

      function validateDatastoreNameAndConfiguration(wizardScope) {
         if (wizardScope.nfsWizardManager.isNfsVersion41()) {
            wizardScope.nfsWizardManager.addServerNamesAction();
            wizardScope.nfsWizardManager.setServerName('');
         }

         // Validate name and configuration uniqueness
         var promise = addDatastoreNameValidatorService.validateNfsNameAndConfiguration(
            wizardScope.commonWizardManager.getContextObject(),
            wizardScope.commonWizardManager.getDatastoreName(),
            wizardScope.nfsWizardManager.getFolderName(),
            wizardScope.nfsWizardManager.isNfsVersion41()
               ? wizardScope.nfsWizardManager.getServerNamesArray()
               : [wizardScope.nfsWizardManager.getServerName()],
            wizardScope.nfsWizardManager.getNfsVersion());

         return promise.then(function(configurationValidationResult) {
            if (configurationValidationResult && configurationValidationResult.validationError) {
               return [configurationValidationResult.validationError];
            }
            if (configurationValidationResult && configurationValidationResult.existingDatastore) {
               wizardScope.nfsWizardManager.setExistingDatastoreId(
                  defaultUriSchemeUtil.getVsphereObjectId(configurationValidationResult.existingDatastore));
            }
            return [];
         });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('nfsSelectHostsPageService', nfsSelectHostsPageService);

   nfsSelectHostsPageService.$inject = [
      'i18nService',
      'wizardPageService'];

   function nfsSelectHostsPageService(
      i18nService, wizardPageService) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSelectHostsPage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsSelectHostsPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsSelectHostsPage.html',
               state: undefined,
               onCommit: function() {
                  var selectedHosts = wizardScope.nfsWizardManager.getSelectedHosts();
                  if (!selectedHosts || selectedHosts.length === 0) {
                     wizardPageService.markPageIncompleteWithErrors(
                        wizardScope.wizardConfig,
                        [i18nService.getString('StorageUi', 'addDatastoreWizard.selectHostsPage.noSelection')]);
                     return false;
                  }

                  wizardScope.wizardConfig.validationBanner.messages = [];
                  wizardPageService.markPageComplete(wizardScope.wizardConfig,
                     wizardScope.commonWizardManager.getDatastoreType());
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('nfsVersionPageService', nfsVersionPageService);

   nfsVersionPageService.$inject = [
      'i18nService',
      'wizardPageService'
   ];

   function nfsVersionPageService(
      i18nService, wizardPageService) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsVersionPage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.nfsVersionPage.nfsVersionLabel'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/nfs/NfsVersionPage.html',
               state: undefined,
               onCommit: function() {
                  wizardPageService.markPageComplete(wizardScope.wizardConfig,
                     wizardScope.commonWizardManager.getDatastoreType());
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to create VmfsPartitionConfigurationPage.
 * Validates the partition configuration.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('vmfsMountOptionsPageService', vmfsMountOptionsPageService);

   vmfsMountOptionsPageService.$inject = [
         'i18nService',
         'wizardPageService',
         'vuiConstants'];

   function vmfsMountOptionsPageService(
         i18nService, wizardPageService, vuiConstants) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsMountOptionsPage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsMountOptionsPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/vmfs/VmfsMountOptionsPage.html',
               defaultState: vuiConstants.wizard.pageState.SKIPPED,
               onCommit: function() {
                  wizardPageService.markPageComplete(wizardScope.wizardConfig, 
                     wizardScope.commonWizardManager.getDatastoreType());
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to create VmfsNameAndDevicePage. Validates the datastore name and selected storage device.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('vmfsNameAndDevicePageService', vmfsNameAndDevicePageService);

   vmfsNameAndDevicePageService.$inject = [
         'i18nService',
         'wizardPageService',
         'addDatastoreNameValidatorService',
         'datastoreConstants',
         '$q',
         'storageUtil'];

   function vmfsNameAndDevicePageService(
         i18nService, wizardPageService,
         addDatastoreNameValidatorService, datastoreConstants, $q, storageUtil) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsSelectDevicePage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsSelectDevicePage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/vmfs/VmfsNameAndDevicePage.html',
               state: undefined,
               onCommit: function() {
                  wizardScope.wizardConfig.loading = true;
                  return validate(wizardScope).then(function (isPageValid) {
                     wizardScope.wizardConfig.loading = false;
                     return isPageValid;
                  }, function (error) {
                     wizardScope.removeLoadingAndShowError(error);
                     return false;
                  });
               }
            };
         }
      };

      function validate(wizardScope) {
         var selectedDevice = wizardScope.vmfsWizardManager.getSelectedScsiDiskInfo();

         // Check for empty selection in device list
         if (!selectedDevice) {
            wizardPageService.markPageIncompleteWithError(
                  wizardScope.wizardConfig,
                  i18nService.getString('StorageUi', 'datastoreWizards.selectDevicePage.noSelection')
            );
            return $q.when(false);
         }

         if (storageUtil.is4kDevice(selectedDevice.disk) &&
               !wizardScope.vmfsWizardManager.getIsVmfs6Supported()) {
            wizardPageService.markPageIncompleteWithError(
               wizardScope.wizardConfig,
               i18nService.getString('StorageUi', 'datastoreWizards.selectDevicePage.incompatibleSelection')
            );
            return $q.when(false);
         }

         // Validate datastore name
         return addDatastoreNameValidatorService.validate(
               wizardScope.commonWizardManager.getContextObject(),
               wizardScope.commonWizardManager.getDatastoreName(),
               datastoreConstants.maxNameLengthForNonNfsDatastore)
               .then(function (datastoreNameValidationError) {
                  if (datastoreNameValidationError) {
                     wizardPageService.markPageIncompleteWithError(
                           wizardScope.wizardConfig,
                           datastoreNameValidationError);
                     return false;
                  }

                  wizardScope.wizardConfig.validationBanner.messages = [];
                  wizardPageService.markPageComplete(wizardScope.wizardConfig,
                     wizardScope.commonWizardManager.getDatastoreType());
                  return true;
               });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to create VmfsPartitionConfigurationPage.
 * Validates the partition configuration.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('vmfsPartitionConfigurationPageService', vmfsPartitionConfigurationPageService);

   vmfsPartitionConfigurationPageService.$inject = [
         'i18nService',
         'wizardPageService',
         'datastoreConstants',
         'bytesFilter'];

   function vmfsPartitionConfigurationPageService(
         i18nService, wizardPageService, datastoreConstants, bytesFilter) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsPartitionConfigPage.title'),
               description: i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsPartitionConfigPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/createDatastore/pages/vmfs/VmfsPartitionConfigurationPage.html',
               state: undefined,
               onCommit: function() {
                  return validate(wizardScope);
               }
            };
         }
      };

      function validate(wizardScope) {
         // Check for empty selection in device option combo
         if (!wizardScope.vmfsWizardManager.getSelectedVmfsDatastoreOptionItem()) {
            wizardPageService.markPageIncompleteWithError(
                  wizardScope.wizardConfig,
                  i18nService.getString('StorageUi', 'addDatastoreWizard.vmfsPartitionConfigPage.noSelection')
            );
            return false;
         }

         // Check datastore size
         var dsSize = wizardScope.vmfsWizardManager.getDatastoreSizeInGb();
         var minSize = datastoreConstants.vmfsSize.MIN_DATASTORE_SIZE_GB;
         if (wizardScope.vmfsWizardManager.getSelectedVmfsVersion() >= datastoreConstants.vmfsVersions.VMFS_6) {
            minSize = datastoreConstants.vmfsSize.MIN_DATASTORE_V6_SIZE_GB;
         }
         if (dsSize < minSize) {
            wizardPageService.markPageIncompleteWithError(
                  wizardScope.wizardConfig,
                  i18nService.getString('StorageUi',
                        'addDatastoreWizard.vmfsPartitionConfigPage.invalidSizeError',
                        bytesFilter(minSize, 'GB', 'GB', 2))
            );
            return false;
         }

         wizardScope.wizardConfig.validationBanner.messages = [];
         wizardPageService.markPageComplete(wizardScope.wizardConfig,
            wizardScope.commonWizardManager.getDatastoreType());
         return true;
      }
   }
})();

var storage_ui;
(function (storage_ui) {
    var VmfsVersionPageService = (function () {
        function VmfsVersionPageService(wizardPageService, i18nService) {
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
        }
        VmfsVersionPageService.prototype.build = function (wizardScope) {
            var self = this;
            return {
                title: this.i18nService.getString("StorageUi", "addDatastoreWizard.vmfsSelectVersionPage.title"),
                description: this.i18nService.getString("StorageUi", "addDatastoreWizard.vmfsSelectVersionPage.description"),
                contentUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vmfs/VmfsVersionPage.html",
                state: undefined,
                onCommit: function () {
                    self.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType());
                    return true;
                }
            };
        };
        VmfsVersionPageService.$inject = ["wizardPageService", "i18nService"];
        return VmfsVersionPageService;
    }());
    storage_ui.VmfsVersionPageService = VmfsVersionPageService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("vmfsVersionPageService", VmfsVersionPageService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var VvolNameAndContainerSelectionPageService = (function () {
        function VvolNameAndContainerSelectionPageService(wizardPageService, i18nService, addDatastoreNameValidatorService, datastoreConstants, $q) {
            var _this = this;
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
            this.addDatastoreNameValidatorService = addDatastoreNameValidatorService;
            this.datastoreConstants = datastoreConstants;
            this.$q = $q;
            this.vvolDatastoreNameAndContainerValidation = function (vvolWizardManager, datastoreName) {
                if (!vvolWizardManager.container) {
                    return null;
                }
                var nameInUse = vvolWizardManager.isNameInUse();
                var containerInUse = vvolWizardManager.getContainerInUse();
                if (!nameInUse && vvolWizardManager.container.info.datastoreInfo) {
                    return _this.i18nService.getString("StorageUi", "addDatastoreWizard.nameValidator.vvol.differentNameSameContainer", vvolWizardManager.container.info.datastoreInfo.name);
                }
                if (nameInUse && containerInUse
                    && (!vvolWizardManager.container.info.datastoreInfo
                        || vvolWizardManager.container.info.datastoreInfo.name !== datastoreName)) {
                    return _this.i18nService.getString("StorageUi", "addDatastoreWizard.nameValidator.vvol.duplicateNameDifferentContainer", containerInUse.name);
                }
                return null;
            };
        }
        VvolNameAndContainerSelectionPageService.prototype.validate = function (wizardScope) {
            var _this = this;
            var hasSelection = !!wizardScope.vvolWizardManager.container;
            var nameAndContainerError = this.vvolDatastoreNameAndContainerValidation(wizardScope.vvolWizardManager, wizardScope.commonWizardManager.getDatastoreName());
            var isValid = hasSelection && !nameAndContainerError;
            if (!isValid) {
                var errorMessage = nameAndContainerError || this.i18nService.getString('StorageUi', 'addDatastoreWizard.vvolNameAndContainerPage.noSelection');
                this.invalidateWizard(wizardScope, errorMessage);
                return this.$q.when(false);
            }
            var self = this;
            var vvolDuplicateNameValidationCallback = function (datastoreInfo) {
                if (datastoreInfo._type !== "com.vmware.vim.binding.vim.host.VvolDatastoreInfo") {
                    return self.i18nService.getString("StorageUi", "addDatastoreWizard.nameValidator.default.duplicateNameDifferentType");
                }
                else {
                    return wizardScope.vvolWizardManager.isNameInUse() ? null : self.i18nService.getString("StorageUi", "addDatastoreWizard.nameValidator.default.duplicateName");
                }
            };
            return this.addDatastoreNameValidatorService.validate(wizardScope.commonWizardManager.getContextObject(), wizardScope.commonWizardManager.getDatastoreName(), this.datastoreConstants.maxNameLengthForNonNfsDatastore, vvolDuplicateNameValidationCallback)
                .then(function (datastoreNameValidationError) {
                if (datastoreNameValidationError) {
                    _this.invalidateWizard(wizardScope, datastoreNameValidationError);
                    return false;
                }
                wizardScope.wizardConfig.validationBanner.messages = [];
                _this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType());
                return true;
            });
        };
        VvolNameAndContainerSelectionPageService.prototype.invalidateWizard = function (wizardScope, errorMessage) {
            this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, errorMessage);
            this.wizardPageService.invalidateNextPages(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType(), wizardScope.wizardConfig.currentPage.title);
        };
        VvolNameAndContainerSelectionPageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("StorageUi", "addDatastoreWizard.vvolNameAndContainerPage.title"),
                description: this.i18nService.getString("StorageUi", "addDatastoreWizard.vvolNameAndContainerPage.description"),
                contentUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vvol/VvolNameAndContainerSelectionPage.html",
                state: undefined,
                onCommit: function () {
                    wizardScope.wizardConfig.loading = true;
                    return _this.validate(wizardScope).then(function (isPageValid) {
                        wizardScope.wizardConfig.loading = false;
                        return isPageValid;
                    }, function (error) {
                        wizardScope.removeLoadingAndShowError(error);
                        return false;
                    });
                }
            };
        };
        VvolNameAndContainerSelectionPageService.$inject = ["wizardPageService", "i18nService", "addDatastoreNameValidatorService", "datastoreConstants", "$q"];
        return VvolNameAndContainerSelectionPageService;
    }());
    storage_ui.VvolNameAndContainerSelectionPageService = VvolNameAndContainerSelectionPageService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("vvolNameAndContainerSelectionPageService", VvolNameAndContainerSelectionPageService);
})(storage_ui || (storage_ui = {}));



var storage_ui;
(function (storage_ui) {
    var VvolSelectHostsPageService = (function () {
        function VvolSelectHostsPageService(wizardPageService, i18nService) {
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
        }
        VvolSelectHostsPageService.prototype.validate = function (wizardScope) {
            var isValid = !!(wizardScope.vvolWizardManager.selectedHosts && wizardScope.vvolWizardManager.selectedHosts.length);
            if (isValid) {
                this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType());
            }
            else {
                this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, this.i18nService.getString('StorageUi', 'addDatastoreWizard.selectHostsPage.noSelection'));
                this.wizardPageService.invalidateNextPages(wizardScope.wizardConfig, wizardScope.commonWizardManager.getDatastoreType(), wizardScope.wizardConfig.currentPage.title);
            }
            return isValid;
        };
        VvolSelectHostsPageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("StorageUi", "addDatastoreWizard.vvolSelectHostsPage.title"),
                description: this.i18nService.getString("StorageUi", "addDatastoreWizard.vvolSelectHostsPage.description"),
                contentUrl: "storage-ui/resources/storage/views/wizard/createDatastore/pages/vvol/VvolSelectHostsPage.html",
                state: undefined,
                onCommit: function () {
                    return _this.validate(wizardScope);
                }
            };
        };
        VvolSelectHostsPageService.$inject = ["wizardPageService", "i18nService"];
        return VvolSelectHostsPageService;
    }());
    storage_ui.VvolSelectHostsPageService = VvolSelectHostsPageService;
    angular.module("com.vmware.vsphere.client.storage")
        .service("vvolSelectHostsPageService", VvolSelectHostsPageService);
})(storage_ui || (storage_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service which handles the wizard for datastore capacity increase.
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('increaseDatastoreCapacityWizardService', increaseDatastoreCapacityWizardService);

   increaseDatastoreCapacityWizardService.$inject = ['vuiWizardService',
      'i18nService',
      '$rootScope',
      'wizardPageService',
      'selectDevicePageService',
      'specifyConfigurationPageService',
      'readyToCompletePageService',
      'IncreaseDatastoreCapacityWizardManager'];

   function increaseDatastoreCapacityWizardService (
      vuiWizardService,
      i18nService,
      $rootScope,
      wizardPageService,
      selectDevicePageService,
      specifyConfigurationPageService,
      readyToCompletePageService,
      IncreaseDatastoreCapacityWizardManager
   ) {

      return {
         showWizard: function(contextObjectId) {
            var wizardScope = $rootScope.$new();
            wizardScope.manager = new IncreaseDatastoreCapacityWizardManager();
            wizardScope.manager.setDatastoreRef(contextObjectId);

            var pages = [
               selectDevicePageService.build(wizardScope),
               specifyConfigurationPageService.build(wizardScope),
               readyToCompletePageService.build(wizardScope)
            ];

            wizardScope.wizardConfig = {
               pages: wizardPageService.initializePageStates(pages),
               title: i18nService.getString('StorageUi', 'increaseDatastoreWizard.title'),
               iconClass: 'storage-ui-icon-increase_datastore'
            };
            
            // show the wizard
            vuiWizardService({
               scope: wizardScope,
               configObjectName: 'wizardConfig'
            }).show();
         }
      };
   }
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage').factory('IncreaseDatastoreCapacityWizardManager', [
      'i18nService', 'dataService', 'bytesFilter', 'hostStorageService', 'storageUtil', '$q',
      function(i18nService, dataService, bytesFilter, hostStorageService, storageUtil, $q) {
         return function IncreaseDatastoreCapacityWizardManager () {
            var DETAILS_DATA_PROP = 'datastore:increaseDatastoreDetailsData';
            var state = {
               options: {},
               diskPartitionInfos: {}
            };
            var manager = {
               fetchVmfsDatastoreOptions: fetchVmfsDatastoreOptions,
               getReadyToCompleteModel: getReadyToCompleteModel,
               getDatastoreInfo: getDatastoreInfo,
               getDatastoreRef: getDatastoreRef,
               getDevices: getDevices,
               getOptionsForSelectedDevice: getOptionsForSelectedDevice,
               getDiskPartitionInfoForSelectedDevice: getDiskPartitionInfoForSelectedDevice,
               getSelectedOption: getSelectedOption,
               setSelectedOption: setSelectedOption,
               getSelectedDevice: getSelectedDevice,
               loadDatastoreInfo: loadDatastoreInfo,
               loadDevices: loadDevices,
               setDatastoreRef: setDatastoreRef,
               setSelectedDevice: setSelectedDevice,
               buildSpec: buildSpec
            };

            function loadDatastoreInfo () {
               return dataService.getProperties(state.datastoreRef, [DETAILS_DATA_PROP]).then(
                  function(result) {
                     state = _.extend(state, {
                        datastoreInfo: result[DETAILS_DATA_PROP]
                     });
                     return true;
                  }
               );
            }

            function getReadyToCompleteModel () {
               var vmfsDatastoreOption = state.selectedOption.vmfsDatastoreOption;

               return {
                  datastoreName: state.datastoreInfo.datastoreName,
                  capacityIncrease: getCapacityIncrease(state.selectedOption),
                  futureSize: calculateFutureSize(state.datastoreInfo, state.selectedOption.sizeToAdd),
                  formattedDeviceName: storageUtil.formatDeviceName(state.selectedDevice.disk),
                  partitionFormat: storageUtil.formatDiskPartitionType(
                     vmfsDatastoreOption.spec.partition.partitionFormat
                  ),
                  maximumFileSize: bytesFilter(state.datastoreInfo.maxFileSizeInB, 'B', 'Auto', 2),
                  vmfsVersion: state.datastoreInfo.vmfs.version,
                  blockSize: i18nService.getString(
                     'StorageUi',
                     'vmfsDatastore.blockSize.format', state.datastoreInfo.vmfs.blockSizeMb
                  )
               };
            }

            function setDatastoreRef (ref) {
               state.datastoreRef = ref;
            }

            function getDatastoreInfo(){
               return state.datastoreInfo;
            }

            function getDatastoreRef () {
               return state.datastoreRef;
            }

            function loadDevices () {
               return hostStorageService.retrieveDatastoreStorageDevices(state.datastoreRef).then(
                  function(result) {
                     state.connectedHost = result.connectedHost;
                     state.devices = result.scsiDiskInfos;
                  });
            }

            function getDevices () {
               return state.devices;
            }

            function getSelectedDevice () {
               return state.selectedDevice;
            }

            function setSelectedDevice (selectedDevice) {
               state.selectedDevice = selectedDevice;
            }

            function buildSpec () {
               return {
                  _type: 'com.vmware.vsphere.client.storage.DatastoreIncreaseSpec',
                  host: state.connectedHost,
                  disk: state.selectedDevice,
                  sizeToAdd: state.selectedOption.sizeToAdd * Math.pow(1024, 3),
                  increaseOption: state.selectedOption.vmfsDatastoreOption
               };
            }

            /**
             * Fetches VmfsDatastoreOptions before revealing the ReadyToCompletePage.
             */
            function fetchVmfsDatastoreOptions () {
               return hostStorageService.retrieveDatastoreIncreaseOptions(state.datastoreRef, state.connectedHost, state.selectedDevice).then(
                  function(result) {
                     state.options = state.options || {};
                     var vmfsDatastoreOptions = result['optionItems'];
                     // Each time the user chooses a device at "Select Device" page,
                     // and navigates to "Specify configuration" page, the capacity increase options
                     // are getting cached in state.options[selectedDevice.uuid]
                     //
                     // This way options for each device will be loaded only once
                     state.options[state.selectedDevice.disk.uuid] = vmfsDatastoreOptions;
                     state.diskPartitionInfos[state.selectedDevice.disk.uuid] = result['partitionInfo'];
                     return true;
                  }
               );
            }

            function getDiskPartitionInfoForSelectedDevice () {
               return state.selectedDevice ? state.diskPartitionInfos[state.selectedDevice.disk.uuid] : undefined;
            }

            function getOptionsForSelectedDevice () {
               return state.selectedDevice ? state.options[state.selectedDevice.disk.uuid] : undefined;
            }

            function getCapacityIncrease (selectedVmfsDatastoreOption) {
               var capacity = selectedVmfsDatastoreOption.sizeToAdd;
               return bytesFilter(capacity, 'GB', 'Auto', 2);

            }

            function getSelectedOption () {
               return state.selectedOption;
            }

            function setSelectedOption (selected) {
               state.selectedOption = selected;
            }

            function calculateFutureSize (datastoreInfo, sizeToAddGB) {
               var initialCapacityBytes = datastoreInfo.vmfs.capacity;
               var increaseBytes = sizeToAddGB * Math.pow(1024, 3);
               return bytesFilter(initialCapacityBytes + increaseBytes, 'B', 'Auto', 2);
            }

            return manager;
         };
      }]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('IncreaseDatastoreCapacityReadyToCompletePageController', [
         '$scope', 'hostStorageService', 'vxPropertyViewService', 'i18nService',
         function(
            $scope, hostStorageService, propertyViewService, i18nService
         ) {
            var self = this;
            self.summaryData = buildPropertyViewData();
            self.i18n = i18n;
            /**
             * Prepares data for summary page's vx-property-view
             */
            function buildPropertyViewData () {
               var manager = $scope.manager;
               var model = manager.getReadyToCompleteModel();
               var builder = propertyViewService.createPropertyViewBuilder();
               var category = builder.category('category');

               //General
               category.section('general')
                  .title(
                     i18n('increaseDatastoreWizard.readyToCompletePage.general'))
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.name'),
                     model.datastoreName)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.increaseSizeBy'),
                     model.capacityIncrease)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.totalSize'),
                     model.futureSize
                  );

               //Device and formatting
               category.section('device')
                  .title(
                     i18n('increaseDatastoreWizard.readyToCompletePage.deviceAndFormatting'))
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.diskLun'),
                     model.formattedDeviceName)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.partitionFormat'),
                     model.partitionFormat)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.vmfsVersion'),
                     model.vmfsVersion)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.maximumFileSize'),
                     model.maximumFileSize)
                  .property(
                     i18n('increaseDatastoreWizard.readyToCompletePage.blockSize'),
                     model.blockSize);
               return builder.build();
            }

            function i18n (key, value) {
               return i18nService.getString('StorageUi', key, value);
            }

         }
      ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('SelectDevicePageController', [
         '$scope',
         'i18nService',
         'hostStorageService',
         'wizardPageService',
         function($scope, i18nService, hostStorageService, wizardPageService) {
            var self = this;
            var manager = $scope.manager;
            wizardPageService.showLoadingIndicator($scope.wizardConfig);

            self.selectedDevice = manager.getSelectedDevice();
            self.onSelectedDeviceChanged = function onSelectedDeviceChanged (selected) {
               if (!selected //row is deselected - set selectedDevice and selectedOption to undefined
                  || (manager.getSelectedDevice() && selected.disk.uuid !== manager.getSelectedDevice().disk.uuid)) {
                  /**
                   * When the user changes selection to a different device,
                   * we'd better invalidate Pages 2 and 3,
                   * and set selectedOption to undefined
                   **/
                  manager.setSelectedOption(undefined);
                  resetSizeToAdd(manager.getOptionsForSelectedDevice());
                  wizardPageService.invalidateNextPages(
                     $scope.wizardConfig,
                     null,
                     $scope.wizardConfig.currentPage.title
                  );
               }
               manager.setSelectedDevice(selected);
            };

            self.devices = manager.getDevices();
            if (!self.devices) {
               $scope.manager.loadDevices().then(function() {
                  self.devices = manager.getDevices();
               }).finally(function() {
                  wizardPageService.hideLoadingIndicator($scope.wizardConfig);
               });
            } else {
               wizardPageService.hideLoadingIndicator($scope.wizardConfig);
            }

            function resetSizeToAdd (options) {
               angular.forEach(options, function(o) {
                  o.sizeToAdd = undefined;
               });
            }

         }
      ]);
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .controller('SpecifyConfigurationPageController', [
         '$scope',
         'i18nService',
         function($scope, i18nService) {
            this.labels = {
               comboBox: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.partitionConfiguration'),
               slider: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.increaseSize'),
               gb: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.gb')
            };
            this.selectedOption = $scope.manager.getSelectedOption();
            this.options = $scope.manager.getOptionsForSelectedDevice();
            this.diskPartitionInfo = $scope.manager.getDiskPartitionInfoForSelectedDevice();
            this.dsInfo = $scope.manager.getDatastoreInfo();
            if ($scope.manager.getSelectedDevice().expandable) {
               this.deviceDetails = i18nService.getString('StorageUi', "increaseDatastoreWizard.partitionConfigurationPage.expandableTip");
            } else {
               this.deviceDetails = i18nService.getString('StorageUi', "increaseDatastoreWizard.partitionConfigurationPage.nonExpandableTip");
            }

            this.onSelectedOptionChanged = function(selectedOption) {
               if (selectedOption && !selectedOption.isSelectConfigurationOption) {
                  $scope.manager.setSelectedOption(selectedOption);
               } else {
                  $scope.manager.setSelectedOption(undefined);
               }
            };
         }
      ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to complete the wizard for Datastore capacity increase
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('readyToCompletePageService', readyToCompletePageService);

   readyToCompletePageService.$inject = [
      'i18nService', 'mutationService'
   ];

   function readyToCompletePageService(
      i18nService, mutationService) {

      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'increaseDatastoreWizard.readyToCompletePage.title'),
               description: i18nService.getString('StorageUi', 'increaseDatastoreWizard.readyToCompletePage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/increaseDatastoreCapacity/pages/ReadyToCompletePage.html',
               state: undefined,
               onCommit: function() {
                  var manager = wizardScope.manager;
                  mutationService.apply(
                     manager.getDatastoreRef(),
                     'com.vmware.vsphere.client.storage.DatastoreIncreaseSpec',
                     manager.buildSpec()
                  );
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to select a device for increasing Datastore capacity
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('selectDevicePageService', selectDevicePageService);

   selectDevicePageService.$inject = [
      'i18nService',
      'wizardPageService'
   ];

   function selectDevicePageService (
      i18nService, wizardPageService
   ) {

      return {
         build: function(wizardScope) {

            return {
               title: i18nService.getString('StorageUi', 'increaseDatastoreWizard.selectDevicePage.title'),
               description: i18nService.getString('StorageUi', 'increaseDatastoreWizard.selectDevicePage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/increaseDatastoreCapacity/pages/SelectDevicePage.html',
               state: undefined,
               onCommit: function() {
                  var manager = wizardScope.manager;
                  if (manager.getSelectedDevice()) {
                     if (!manager.getOptionsForSelectedDevice()) {
                        wizardPageService.showLoadingIndicator(wizardScope.wizardConfig);
                        return manager.loadDatastoreInfo().then(manager.fetchVmfsDatastoreOptions).then(function() {
                           wizardPageService.markPageComplete(wizardScope.wizardConfig);
                           wizardPageService.hideLoadingIndicator(wizardScope.wizardConfig);
                           return true;
                        });
                     } else {
                        wizardPageService.markPageComplete(wizardScope.wizardConfig);
                        return true;
                     }

                  } else {
                     wizardPageService.markPageIncompleteWithError(
                        wizardScope.wizardConfig,
                        i18nService.getString('StorageUi', 'datastoreWizards.selectDevicePage.noSelection')
                     );
                     return false;
                  }
               }
            };
         }
      };


   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.storage')
      .service('specifyConfigurationPageService', specifyConfigurationPageService);

   specifyConfigurationPageService.$inject = [
      'i18nService', 'wizardPageService'
   ];

   function specifyConfigurationPageService (i18nService, wizardPageService) {

      return {
         build: function(wizardScope) {
            return {
               title: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.title'),
               description: i18nService.getString('StorageUi', 'increaseDatastoreWizard.partitionConfigurationPage.description'),
               contentUrl: 'storage-ui/resources/storage/views/wizard/increaseDatastoreCapacity/pages/SpecifyConfigurationPage.html',
               state: undefined,
               onCommit: function() {
                  var manager = wizardScope.manager;
                  var selection = manager.getSelectedOption();
                  if (selection && selection.sizeToAdd) {
                     wizardPageService.markPageComplete(wizardScope.wizardConfig);
                     return true;
                  } else {
                     wizardPageService.markPageIncompleteWithError(
                        wizardScope.wizardConfig,
                        i18nService.getString('StorageUi', 'form.validationError')
                     );
                     return false;
                  }
               }
            };
         }
      };
   }
})();


/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.network = {
   angularModule: angular.module('com.vmware.vsphere.client.network',
         ['com.vmware.platform.ui', 'com.vmware.vsphere.client.networkLibUi'])
};

/*
 * Registers network-ui actions.
 */
angular.module('com.vmware.vsphere.client.network')
      .run([
         'mutationService',
         'addHostNetworkingWizardService',
         'i18nService',
         'editPortGroupDialogService',
         'clarityModalService',
         'clarityConstants',
         'networkUiConstants',
         'editVmkernelAdapterDialogService',
         'manageVssPnicsDialogService',
         'iscsiPortBindingService',
         'logService',
         'iscsiPortBindingDetailsDialogService',
         'netStackEditDialogService',
         'editVirtualSwitchDialogService',
         'vmMigrateWizardService',
         'editPnicDialogService',
         'manageProxySwitchPnicsDialogService',
         'migrateVmkToVssWizardService',
         'ghostDvsProxySwitchDetailsService',
         'moveNetworkToService',
         'removeVnicService',
         '$injector',
         'proxySwitchDetailsDialogService',

         function (mutationService,
               addHostNetworkingWizardService,
               i18nService,
               editPortGroupDialogService,
               clarityModalService,
               clarityConstants,
               networkUiConstants,
               editVmkernelAdapterDialogService,
               manageVssPnicsDialogService,
               iscsiPortBindingService,
               logService,
               iscsiPortBindingDetailsDialogService,
               netStackEditDialogService,
               editVirtualSwitchDialogService,
               vmMigrateWizardService,
               editPnicDialogService,
               manageProxySwitchPnicsDialogService,
               migrateVmkToVssWizardService,
               ghostDvsProxySwitchDetailsService,
               moveNetworkToService,
               removeVnicService,
               $injector,
               proxySwitchDetailsDialogService) {

            h5.actions[networkUiConstants.actions.EDIT_DVS_NOTES] = function (actionEval, availableTargets) {
               var onUpdateDvsNotes = function (objectId, notesValue, operationName, loadedConfigVersion) {
                  var reconfigSpec = {
                     _type: 'com.vmware.vim.binding.vim.dvs.VmwareDistributedVirtualSwitch$ConfigSpec',
                     description: notesValue,
                     configVersion: loadedConfigVersion
                  };
                  var specType = 'com.vmware.vsphere.client.dvs.api.spec.DvsConfigSpec';
                  var propSpec = {
                     configSpec: reconfigSpec
                  };
                  mutationService.apply(objectId, specType, propSpec, operationName);
                  return true;
               };

               var dialogData = {
                  notesPropName: 'config.description',
                  additionalPropForEdit: 'config.configVersion',
                  onUpdateNotesCallback: onUpdateDvsNotes
               };

               clarityModalService.openModal(actionEval, availableTargets, dialogData,
                     'common-module-ui/resources/common-module/views/notes/NotesDialog.html');
            };

            h5.actions[networkUiConstants.actions.EDIT_DVPG_NOTES] = function (actionEval, availableTargets) {
               var onUpdateDvpgNotes = function (objectId, notesValue, operationName, loadedConfigVersion) {
                  var type = 'com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroup$ConfigSpec';
                  var reconfigSpec = {
                     _type: type,
                     description: notesValue,
                     configVersion: loadedConfigVersion
                  };

                  mutationService.apply(objectId, type, reconfigSpec);
                  return true;
               };

               var dialogData = {
                  notesPropName: 'config.description',
                  additionalPropForEdit: 'config.configVersion',
                  onUpdateNotesCallback: onUpdateDvpgNotes
               };

               clarityModalService.openModal(actionEval, availableTargets, dialogData,
                     'common-module-ui/resources/common-module/views/notes/NotesDialog.html');
            };

            h5.actions[networkUiConstants.actions.ADD_NETWORKING] =
                  function (actionEval, availableTargets, context) {
                     context = context || {};
                     addHostNetworkingWizardService
                           .showWizard(availableTargets[0], context.selectedSwitch,
                                 context.connectionType);
                  };

            h5.actions[networkUiConstants.actions.EDIT_VSWITCH] =
                  function (actionEval, availableTargets, context) {
                     context = context || {};
                     editVirtualSwitchDialogService.show(availableTargets[0], context.selectedSwitch, actionEval);
                  };

            h5.actions[networkUiConstants.actions.REMOVE_VSWITCH] =
               function(actionEval, availableTargets, context) {
                  var REMOVE_SPEC_TYPE = 'com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.RemoveVirtualSwitchSpec';
                  var removeSpec = {
                     _type: REMOVE_SPEC_TYPE,
                     vSwitchName: context.selectedSwitch.name
                  };
                  var modalOptions = {
                     preserveNewlines: true,
                     submitDisabled: true,
                     title: i18nService.getString('NetworkUi',
                        'removeVirtualSwitch.dialogCaption')
                  };

                  clarityModalService.openConfirmationModal(modalOptions);
                  mutationService.validate(availableTargets[0],
                     REMOVE_SPEC_TYPE,
                     removeSpec).then(function(validationResult) {
                     modalOptions.submitDisabled = false;
                     if (!validationResult.result) {
                        _.extend(modalOptions, {
                           message: i18nService.getString('NetworkUi',
                                 'removeVirtualSwitch.confirmWarning',
                                 context.selectedSwitch.name),
                           saveButtonLabel: i18nService.getString('NetworkUi',
                                 'NetworkUtil.labelYes'),
                           cancelButtonLabel: i18nService.getString('NetworkUi',
                                 'NetworkUtil.labelNo'),
                           clarityIcon: {
                              class: "is-warning",
                              shape: "warning-standard",
                              size: "32"
                           },
                           submit: function() {
                              mutationService.apply(
                                    availableTargets[0],
                                    REMOVE_SPEC_TYPE,
                                    removeSpec);
                           }
                        });
                     } else {
                        _.extend(modalOptions, {
                           title: i18nService.getString('NetworkUi',
                                 'removeVirtualSwitch.messageDialogCaption'),
                           message: validationResult.result,
                           clarityIcon: {
                              class: "is-error",
                              shape: "error-standard",
                              size: "32"
                           },
                           hideCancelButton: true,
                           submit: function() {
                              return true;
                           }
                        });
                     }
                  });
               };

            h5.actions[networkUiConstants.actions.EDIT_VNIC] =
                  function (actionEval, availableTargets, context) {
                     editVmkernelAdapterDialogService
                           .show(actionEval, availableTargets[0], context.vnic);
                  };

            h5.actions[networkUiConstants.actions.MANAGE_PNICS] =
                  function (actionEval, availableTargets, context) {

                     if(context.selectedSwitch.type === networkUiConstants.switchType.STANDARD) {
                        manageVssPnicsDialogService
                           .show(availableTargets[0], context.selectedSwitch.name);
                     } else {
                           manageProxySwitchPnicsDialogService
                           .show(availableTargets[0],
                              context.selectedSwitch.dvsRef,
                              context.selectedSwitch.key,
                              context.selectedSwitch.name);
                     }

                  };

            h5.actions[networkUiConstants.actions.MIGRATE_VMK_TO_VSWITCH] =
                  function (actionEval, availableTargets, context) {
                     context = context || {};
                     migrateVmkToVssWizardService
                           .show(availableTargets[0], context.selectedSwitch.name);
                  };

            h5.actions[networkUiConstants.actions.REFRESH_NETWORK] =
               refreshNetwork;

            function refreshNetwork(actionEval, availableTargets) {
               if (availableTargets && availableTargets.length === 1) {
                  var REFRESH_SPEC_TYPE =
                     'com.vmware.vsphere.client.network.NetworkSystemRefreshSpec';
                  var refreshSpec = {
                     _type: REFRESH_SPEC_TYPE
                  };

                  mutationService.apply(
                     availableTargets[0],
                     REFRESH_SPEC_TYPE,
                     refreshSpec,
                     i18nService.getString('NetworkUi',
                        'removeVirtualSwitch.refreshNetworkSystem.operationName'));
               }
            }

            h5.actions[networkUiConstants.actions.REMOVE_VNIC] =
                  function(actionEval, availableTargets, context) {
                     removeVnicService.openConfirmationDialog(
                           availableTargets[0], context.vnic);
                  };

            h5.actions[networkUiConstants.actions.EDIT_PORTGROUP] =
                  function (actionEval, availableTargets, context) {
                     editPortGroupDialogService.show(context.hostId, actionEval,
                           context.portgroupKey, context.portgroupName);
                  };

            h5.actions[networkUiConstants.actions.REMOVE_PORTGROUP] =
                  function (actionEval, availableTargets, context) {
                     var modalOptions = {
                        title: i18nService.getString('NetworkUi',
                           'removePortgroup.dialogCaption'),
                        submitDisabled: true,
                        preserveNewlines: true
                     };

                     clarityModalService.openConfirmationModal(modalOptions);
                     mutationService.validate(availableTargets[0],
                           'com.vmware.vsphere.client.h5.network.host.portgroup.model.PortGroupRemoveSpec',
                           context.spec).then(function (validationResult) {
                        modalOptions.submitDisabled = false;
                        if (!validationResult.result) {
                           _.extend(modalOptions, {
                              message: i18nService.getString('NetworkUi',
                                    'removePortgroup.confirmWarning', context.spec.portgroupName),
                              saveButtonLabel: i18nService.getString('NetworkUi',
                                    'NetworkUtil.labelYes'),
                              cancelButtonLabel: i18nService.getString('NetworkUi',
                                    'NetworkUtil.labelNo'),
                              clarityIcon: {
                                 class: "is-warning",
                                 shape: "warning-standard",
                                 size: "32"
                              },
                              submit: function() {
                                 mutationService.apply(
                                       availableTargets[0],
                                       'com.vmware.vsphere.client.h5.network.host.portgroup.model.PortGroupRemoveSpec',
                                       context.spec);
                              }
                           });
                        } else {
                           _.extend(modalOptions, {
                              title: i18nService.getString(
                                    'NetworkUi', 'removePortgroup.messageDialogCaption'),
                              message: validationResult.result,
                              clarityIcon: {
                                 class: "is-error",
                                 shape: "error-standard",
                                 size: "32"
                              },
                              hideCancelButton: true,
                              submit: function() {
                                 return true;
                              }
                           });
                        }
                     });
                  };

            h5.actions[networkUiConstants.actions.SHOW_ISCSI_PORT_BINDING_DETAILS] =
                  function(actionEval, availableTargets, context) {
                     iscsiPortBindingDetailsDialogService.show(availableTargets[0], context.iscsiPortInfoItem);
                  };

            h5.actions[networkUiConstants.actions.ADD_PORT_BINDING_FOR_ISCSI] =
                  function(actionEval, availableTargets, context) {

                     var log = logService('addPortBindingForIscsi');
                     if (!context.iscsiHbaName) {
                        log.error('No iSCSI adapter selected.');
                     }
                     var onSubmitWrapper = {};
                     var modalOptions = {
                        contentTemplate: 'network-ui/resources/network/views/host/iscsi/add/IscsiPortBindingDialog.html',
                        title: i18nService.getString('H5NetworkUi', 'portbinding.addDialog.title', context.iscsiHbaName),
                        defaultButton: 'submit',
                        alerts: [],
                        size: 'lg',
                        dialogData: {
                           portBindingData: {
                              hostId: availableTargets[0],
                              iscsiHbaName: context.iscsiHbaName,
                              onSubmitWrapper: onSubmitWrapper
                           }
                        },
                        subTitle: {
                           objectId: availableTargets[0]
                        },
                        // The onSubmitWrapper's submit function is bound to the object in the component,
                        // used in the dialog, in order for the the mutation call to be implemented
                        // in the component's controller.
                        // In other words, the component exposes its public API via this wrapper.
                        onSubmit: function() {
                           return onSubmitWrapper.submit(context.onSuccessCallback).then(function(result) {
                              if (result.errors && result.errors.length) {
                                 modalOptions.alerts = _.map(result.errors, function(err) {
                                    return {
                                       type: clarityConstants.notifications.type.ERROR,
                                       text: err
                                    };
                                 });
                              }
                              return result.isSuccessful;
                           });
                        }
                     };
                     clarityModalService.openOkCancelModal(modalOptions);
                  };

            h5.actions[networkUiConstants.actions.REMOVE_PORT_BINDING_FROM_ISCSI] =
                  function(actionEval, availableTargets, context) {

                     var log = logService('removePortBindingFromIscsi');
                     if (!context.iscsiHbaName) {
                        log.error('No iSCSI adapter selected.');
                     }

                     var removeMessage = iscsiPortBindingService
                           .getPortBindingRemovalUserMessages(context.selectedAdapters, context.adapters);

                     var modalOptions = {
                       title: removeMessage.title,
                       message: removeMessage.description,
                       submit: function() {
                          iscsiPortBindingService.removeIscsiPortInfos(
                              availableTargets[0],
                              context.iscsiHbaName,
                              context.selectedAdapters)
                                    .then(function(result) {
                                       if (context.onSuccessCallback) {
                                          context.onSuccessCallback(result);
                                       }
                                    });

                          return true;
                       }
                     };

                     clarityModalService.openConfirmationModal(modalOptions);
                  };

            h5.actions[networkUiConstants.actions.EDIT_DNS_AND_ROUTING] =
                  function(actionEval, availableTargets, context) {
                     netStackEditDialogService.show(availableTargets[0],
                           context.selectedNetStack.key,
                           context.selectedNetStack.name,
                           context.multipleNetworkStackInstanceSupported);
                  };

            h5.actions[networkUiConstants.actions.EDIT_IPV6_SUPPORT] =
               function(actionEval, availableTargets, context) {

                  var onSubmitWrapper = {};
                  var modalOptions = {
                     contentTemplate: 'network-ui/resources/network/views/host/editIpv6SupportView.html',
                     title: i18nService.getString('NetworkUi',
                        'IPv6SupportView.ipv6SupportedDialogTitle'),
                     defaultButton: 'submit',
                     alerts: [],
                     size: 'md',
                     dialogData: {
                        hostId: availableTargets[0],
                        onSubmitWrapper: onSubmitWrapper
                     },
                     subTitle: {
                        objectId: availableTargets[0]
                     },
                     onSubmit: function() {
                        return onSubmitWrapper.submit(context.onSuccessCallback);
                     }
                  };
                  clarityModalService.openOkCancelModal(modalOptions);
               };

            h5.actions[networkUiConstants.actions.VM_MIGRATE] =
                  function (actionEval, availableTargets, context) {
                     vmMigrateWizardService.show(availableTargets[0]);
                  };

            h5.actions[networkUiConstants.actions.EDIT_PNIC] =
                  function (actionEval, availableTargets, context) {
                     editPnicDialogService.show(availableTargets[0], context.pnic);
                  };

            h5.actions[networkUiConstants.actions.GHOST_DVS_PROXY_SWITCH_DETACHED] =
                  function (actionEval, availableTargets, context) {
                     if(!availableTargets || !availableTargets.length
                        || !context || !context.details) {
                        return;
                     }

                     ghostDvsProxySwitchDetailsService
                        .show(availableTargets[0],
                           context.details.switchUuid);
                  };

            h5.actions[networkUiConstants.actions.NETWORK_MOVE_TO_ACTION] =
               function (actionEval, availableTargets, context) {
                  moveNetworkToService.openMoveToDialog(availableTargets);
               };

            h5.actions[networkUiConstants.actions.NETWORK_MOVE_TO_DRAG_AND_DROP_ACTION] =
               function (actionEval, availableTargets, destinationTarget) {
                  if (!availableTargets || !availableTargets.length || !destinationTarget) {
                     return;
                  }

                  moveNetworkToService.moveNetworkTo(availableTargets, destinationTarget.dropTarget);
               };

            h5.actions[networkUiConstants.actions.VSS_VIEW_SETTINGS] =
               function (actionEval, availableTargets, context) {
                  $injector.get("virtualSwitchDetailsDialogService").showVssDetailsDialog(
                     context.selectedSwitch, availableTargets[0]);
               };

            h5.actions[networkUiConstants.actions.PROXY_SWITCH_VIEW_SETTINGS] =
               function (actionEval, availableTargets, context) {
                  $injector.get("virtualSwitchDetailsDialogService").showProxySwitchDetailsDialog(
                     context.selectedSwitch, availableTargets[0]);
               };
         }]);

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var MoveNetworkToComponent = (function () {
        function MoveNetworkToComponent() {
            this.bindings = {
                pageModel: "="
            };
            this.controller = MoveNetworkToComponentController;
            this.templateUrl =
                "network-ui/resources/network/views/moveTo/moveNetworkToComponentTemplate.html";
        }
        return MoveNetworkToComponent;
    }());
    network_ui.MoveNetworkToComponent = MoveNetworkToComponent;
    var MoveNetworkToComponentController = (function () {
        function MoveNetworkToComponentController() {
            var _this = this;
            this.networkIds = this.pageModel.objectIds;
            this.onLocationSelected = function (objectReference) {
                _this.pageModel.entityToMoveNetworkTo = objectReference;
            };
        }
        MoveNetworkToComponentController.$inject = [];
        return MoveNetworkToComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("moveNetworkToComponent", new MoveNetworkToComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var PreloadSpriteComponent = (function () {
        function PreloadSpriteComponent() {
            this.bindings = {
                onLoad: "&"
            };
            this.controller = PreloadSpriteComponentController;
            this.template = "<div ng-if=\"$ctrl.isInternetExplorer\" style=\"display: none\"\n                               ng-include=\"'/ui/resources/img/svg-sprite.svg'\"\n                               onload=\"$ctrl.onLoad()\">\n                          </div>";
        }
        return PreloadSpriteComponent;
    }());
    network_ui.PreloadSpriteComponent = PreloadSpriteComponent;
    var PreloadSpriteComponentController = (function () {
        function PreloadSpriteComponentController() {
        }
        PreloadSpriteComponentController.prototype.$onInit = function () {
            // sprite will not be loaded. signal ready.
            if (!this.isInternetExplorer) {
                this.onLoad();
            }
        };
        Object.defineProperty(PreloadSpriteComponentController.prototype, "isInternetExplorer", {
            get: function () {
                return typeof SVGForeignObjectElement === "undefined";
            },
            enumerable: true,
            configurable: true
        });
        return PreloadSpriteComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("preloadSpriteComponent", new PreloadSpriteComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var ConfigProxySwitchPnicsComponent = (function () {
        function ConfigProxySwitchPnicsComponent() {
            this.bindings = {
                hostId: "<",
                dvsRef: "<",
                proxySwitchKey: "<",
                onUplinkMappingCreated: "&"
            };
            this.controller = ConfigProxySwitchPnicsController;
            this.templateUrl = "network-ui/resources/network/components/proxyswitch/configProxySwitchPnicsTemplate.html";
        }
        return ConfigProxySwitchPnicsComponent;
    }());
    network_ui.ConfigProxySwitchPnicsComponent = ConfigProxySwitchPnicsComponent;
    var ConfigProxySwitchPnicsController = (function () {
        function ConfigProxySwitchPnicsController(physicalAdaptersListService) {
            this.physicalAdaptersListService = physicalAdaptersListService;
        }
        ConfigProxySwitchPnicsController.prototype.$onInit = function () {
            var _this = this;
            this.loading = true;
            this.physicalAdaptersListService.getProxySwitchUplinkData(this.hostId, this.dvsRef, this.proxySwitchKey)
                .then(function (proxySwitchUplinkData) {
                _this.portMapping = proxySwitchUplinkData;
                _this.portMapping.addedMappings = {};
                _this.onUplinkMappingCreated({ uplinkData: _this.portMapping });
                _this.loading = false;
            });
        };
        ConfigProxySwitchPnicsController.$inject = ["physicalAdaptersListService"];
        return ConfigProxySwitchPnicsController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("configProxySwitchPnics", new ConfigProxySwitchPnicsComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Custom grid for displaying bindings between host physical network adapters
 * and DVS uplinks
 */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .directive('uplinkPortMapping', uplinkPortMapping);

   uplinkPortMapping.$inject = [
      '$timeout',
      'vuiConstants',
      'i18nService',
      'pnicSelectorDialogService',
      'clarityModalService',
      'networkUiConstants'];

   function uplinkPortMapping ($timeout,
                               vuiConstants,
                               i18nService,
                               pnicSelectorDialogService,
                               clarityModalService,
                               networkUiConstants) {
      return {
         restrict: 'E',
         template: '<div class="fill-parent uplink-port-mapping"' +
         'vx-stretch-grid vui-datagrid="datagridOptions"'+
         'vx-datagrid-preselect-item="true" reselect-on-change="true" ' +
         'preselect-comparator="preselectComparator"></div>',
         scope: {
            portMapping: '=',
            unclaimedPnics: '=',
            pnicDetails: '=',
            onSelectionChange: '=',
            allowOldMappingsRemoval: '=?' // defaults to false
         },
         replace: false,
         link: {
            pre: function ($scope) {
               if($scope.allowOldMappingsRemoval === undefined){
                  $scope.allowOldMappingsRemoval = false;
               }
               var addAction = {
                  id: networkUiConstants.failoverOrderActions.ADD,
                  iconClass: 'vsphere-icon-add',
                  tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.add"),
                  onClick: showPnicSelectorDialog
               };

               var removeAction = {
                  id: networkUiConstants.failoverOrderActions.REMOVE,
                  iconClass: 'vsphere-icon-remove',
                  tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.remove"),
                  onClick: removePnic
               };

               var actionDefinitions = [addAction, removeAction];

               $scope.datagridOptions = {
                  columnDefs: _getColumnDefinitions($scope.portMapping.lagMapping, $scope.portMapping.uplinkPortgroups),
                  data: _createData(),
                  pageConfig: {
                     hidePager: true
                  },
                  selectedItems: [],
                  resizable: true,
                  height: '100%',
                  sortMode: vuiConstants.grid.sortMode.NONE,
                  searchable: false,
                  selectionMode: vuiConstants.grid.selectionMode.MULTI,
                  showCheckboxesOnMultiSelection: false,
                  actionBarOptions: {
                     actions: actionDefinitions
                  }
               };

               $scope.preselectComparator = _preselectComparator;

               var selectedUplinks;
               var selectedUplinksBeforeUpdate;

               $scope.$watch(function () {
                  return $scope.datagridOptions.selectedItems;
               }, function (selectedItems) {
                  if ($scope.onSelectionChange) {
                     $scope.onSelectionChange(selectedItems);
                  }
                  if(selectedItems){
                     selectedUplinks = _.pluck(selectedItems, "uplink");
                  } else {
                     selectedUplinks = [];
                  }
                  recalculateActionsState();
               });

               // Workaround which resizes datagrid after the action bar creation
               $timeout(function () {
                  var gridElement = $("div.uplink-port-mapping .k-grid");
                  if (gridElement) {
                     var kendoGrid = gridElement.data("kendoGrid");
                     if (kendoGrid) {
                        kendoGrid.resize();
                     }
                  }
               }, 0);

               function recalculateActionsState () {
                  addAction.enabled = _hasFreeUplink($scope.portMapping.uplinkPortMapping);

                  var isRemoveActionEnabled = false;
                  if(selectedUplinks && selectedUplinks.length > 0) {
                     if ($scope.allowOldMappingsRemoval) {
                        isRemoveActionEnabled = _.some(selectedUplinks, isUplinkAssigned);
                     } else {
                        isRemoveActionEnabled = getSelectedUplinksWithAddedPnic().length > 0;
                     }
                  }

                  removeAction.enabled = isRemoveActionEnabled;
               }

               function _preselectComparator (datagridItem) {
                  return _.contains(selectedUplinksBeforeUpdate, datagridItem.uplink);
               }

               function showPnicSelectorDialog(){
                   if($scope.portMapping.unclaimedPnics.length > 0) {

                     var dropdownOptions = [{
                        id: 'uplink',
                        title: i18nService.getString('NetworkUi', 'UplinkPortMappingAssignDialog.uplinkPort'),
                        items: _createUplinkItems($scope.portMapping.uplinkPortMapping, $scope.portMapping.lagMapping),
                        selectedItem: _getOnlySelectedOrFirstFreeUplinkMapping(selectedUplinks, $scope.portMapping.uplinkPortMapping).uplinkPort.name
                     }];
                      if($scope.portMapping.uplinkPortgroups.length > 1) {
                         var uplinkPortgroupItems = _createPortgroupItems($scope.portMapping.uplinkPortgroups);
                         dropdownOptions.push({
                            id: 'portgroup',
                            title: i18nService.getString('NetworkUi', 'UplinkPortMappingAssignDialog.uplinkPortGroup'),
                            items: uplinkPortgroupItems,
                            selectedItem: uplinkPortgroupItems[0].key
                         });
                      }

                     pnicSelectorDialogService.createPnicSelectorDialog($scope.portMapping.unclaimedPnics, $scope.portMapping.pnicDetails, vuiConstants.grid.selectionMode.SINGLE, dropdownOptions, onPnicAdded);
                  } else {
                      var modalOptions = {
                         message: i18nService.getString('NetworkUi', 'FailoverOrderEditor.noFreeNics'),
                         title: i18nService.getString('H5NetworkUi', 'failoverOrder.notification.warning'),
                         icon: "vx-icon-warning-32x32",
                         hideCancelButton: true,
                         preserveNewlines: true,
                         submit: function() {}
                      };

                      clarityModalService.openConfirmationModal(modalOptions);
                  }
               }

               function removePnic() {
                  var uplinksToUnassign;
                  if($scope.allowOldMappingsRemoval){
                     uplinksToUnassign = _.filter(selectedUplinks, isUplinkAssigned);
                  } else {
                     uplinksToUnassign = getSelectedUplinksWithAddedPnic();
                  }

                  var pnicNames = _.map(uplinksToUnassign, _getPnicByUplinkName);

                  $scope.portMapping.unclaimedPnics = $scope.portMapping.unclaimedPnics.concat(pnicNames);
                  $scope.portMapping.addedMappings = _.omit($scope.portMapping.addedMappings, uplinksToUnassign);

                  _.each(uplinksToUnassign, function(uplink) {
                     var mapping = _getUplinkPortMappingByUplinkName(uplink);
                     mapping.pnicName = null;
                     mapping.uplinkPortgroup = null;
                  });
                  $scope.datagridOptions.data = _updateData();
               }

               function onPnicAdded(pnics, dropdownSelection) {
                  var addedUplink = dropdownSelection['uplink'];
                  selectedUplinks = [addedUplink];

                  if (pnics && pnics.length === 1) {
                     var pnicName = pnics[0];

                     //remove the added pnic from unclaimedPnics
                     var index = _.indexOf($scope.portMapping.unclaimedPnics, pnicName);
                     $scope.portMapping.unclaimedPnics.splice(index, 1);

                     //mark it as newly added
                     $scope.portMapping.addedMappings[addedUplink] = pnicName;

                     //update the displayed mappings
                     var uplinkPortMapping = _getUplinkPortMappingByUplinkName(addedUplink);
                     uplinkPortMapping.pnicName = pnicName;

                     //update the portgroup in the mapping
                     var selectedPortgroupKey = dropdownSelection['portgroup'];
                     var uplinkPortgroup =
                           selectedPortgroupKey ?
                                 _getUplinkPortgroupByKey($scope.portMapping.uplinkPortgroups, selectedPortgroupKey) :
                                 $scope.portMapping.uplinkPortgroups[0];

                     uplinkPortMapping.uplinkPortgroup = uplinkPortgroup;

                     //update the grid
                     $scope.datagridOptions.data =  _updateData();
                  }
               }

               function _updateData() {
                  selectedUplinksBeforeUpdate = selectedUplinks;
                  return _createData();
               }

               function _createData() {
                  var data = [];

                  _.forEach($scope.portMapping.uplinkPortMapping, function (portMapping) {
                     data.push({
                        uplink: portMapping.uplinkPort.name,
                        pnic: portMapping.pnicName,
                        isNew: !!$scope.portMapping.addedMappings[portMapping.uplinkPort.name],
                        uplinkPortgroup: _getPortgroupName(portMapping.uplinkPortgroup)
                     });
                  });

                  return _.sortBy(data, 'uplink');
               }

               /**
                * Return the selected item if it's free or the first free uplink (sorted by name)
                */
               function _getOnlySelectedOrFirstFreeUplinkMapping(selectedUplinks, uplinkPortMapping) {
                  var mapping;
                  if(selectedUplinks.length === 1 && isUplinkFree(selectedUplinks[0])){
                     mapping = _getUplinkPortMappingByUplinkName(selectedUplinks[0]);
                  } else {
                     //the first in the lexicographic order as we display them everywhere this way
                     var sortedMappings = _.sortBy(uplinkPortMapping, function (portMapping) {
                        return portMapping.uplinkPort.name;
                     });
                     mapping = _.find(sortedMappings, function (portMapping) {
                        return portMapping.pnicName === null;
                     });
                  }
                  return mapping;
               }

               function _getUplinkPortMappingByUplinkName (uplinkName) {
                  return _.find($scope.portMapping.uplinkPortMapping, function(portMapping) {
                     return portMapping.uplinkPort.name === uplinkName;
                  });
               }

               function getSelectedUplinksWithAddedPnic(){
                  return _.intersection(_.keys($scope.portMapping.addedMappings), selectedUplinks);
               }

               function _getPnicByUplinkName (uplinkName) {
                  return _getUplinkPortMappingByUplinkName(uplinkName).pnicName;
               }

               function isUplinkFree (selectedUplink) {
                  return _getPnicByUplinkName(selectedUplink) === null;
               }

               function isUplinkAssigned (selectedUplink) {
                  return _getPnicByUplinkName(selectedUplink) !== null;
               }
            }
         }
      };

      function _getColumnDefinitions(lagMapping, uplinkPortgroups) {
         var columnDefs = [];

         var uplinkColumnDef = {
            field: 'uplinkPort',
            displayName: i18nService.getString('NetworkUi', 'UplinkPortMappingEditor.column.nic'),
            width: "150px",
            template: function (dataItem) {
               var uplinkElement = '<span ng-non-bindable class="uplink-name">' +
                     _formatUplinkName(dataItem.uplink, lagMapping) + '</span> </br>';

               var pnicElement;
               if (dataItem.pnic) {
                  pnicElement = '<span class="network-lib-ui-icon-physicalAdapter"></span>' +  // icon
                        '<span ng-non-bindable>' + _formatName(dataItem) + '</span>';                      // name
               } else {
                  pnicElement = '<span ng-non-bindable>' + i18nService.getString('NetworkUi', 'UplinkPortMappingEditor.noNic') + '</span>';
               }

               return uplinkElement + pnicElement;
            }
         };

         var portgroupColumnDef = {
            field: 'uplinkPortgroup',
            displayName: i18nService.getString('NetworkUi', 'UplinkPortMappingEditor.column.portGroup'),
            width: "150px"
         };

         columnDefs.push(uplinkColumnDef);

         if(uplinkPortgroups.length > 1) {
            columnDefs.push(portgroupColumnDef);
         }

         return columnDefs;
      }

      /**
       * Adds (New) at the beginning of the name if needed.
       */
      function _formatName(dataItem) {
         return (dataItem.isNew)
            ? i18nService.getString("NetworkUi", "UplinkPortMappingEditor.newNicFormat", dataItem.pnic)
            : dataItem.pnic;
      }

      /**
       * Format the uplink if it is associated with lag
       */
      function _formatUplinkName(uplink, lagMapping) {
         var lagName = _getUplinkLag(uplink, lagMapping);

         return lagName ? i18nService.getString('NetworkUi',
               'UplinkPortMappingEditor.lagPortFormat', uplink, lagName) : uplink;

      }

      function _getUplinkLag(uplink, lagMapping) {
         var lagName = null;

         for (var lag in lagMapping) {
            if (lagMapping.hasOwnProperty(lag) && _.indexOf(lagMapping[lag], uplink) !== -1) {
               lagName = lag;
            }
         }
         return lagName;
      }

      function _hasFreeUplink(uplinkPortMapping) {
         return _.some(uplinkPortMapping, function (portMapping) {
            return portMapping.pnicName === null;
         });
      }

      /**
       * Return array of objects containing uplinks as key and uplink name for value.
       * (Uplinks associated with lags has special formated name)
       */
      function _createUplinkItems(uplinkPortMapping, lagMapping) {
         var uplinkItems = [];
         _.each(uplinkPortMapping, function (portMapping) {
            if(portMapping.pnicName === null) {
               var uplinkName = _formatUplinkName(portMapping.uplinkPort.name, lagMapping);
               uplinkItems.push({
                  key: portMapping.uplinkPort.name,
                  value: uplinkName
               });
            }
         });
         return _.sortBy(uplinkItems, 'value');
      }

      function _createPortgroupItems(uplinkPortgroups) {
         var uplinkPortgroupItems = [];
         _.each(uplinkPortgroups, function (uplinkPortgroup) {
            uplinkPortgroupItems.push({
               key: uplinkPortgroup.key,
               value: uplinkPortgroup.name
            });
         });

         return _.sortBy(uplinkPortgroupItems, 'value');
      }

      function _getPortgroupName(portgroup) {
         if(portgroup) {
            return portgroup.name;
         }
         return null;
      }

      function _getUplinkPortgroupByKey(uplinkPortgroups, uplinkPortgroupKey) {
         return _.find(uplinkPortgroups, function (uplinkPortgroup) {
            return uplinkPortgroup.key === uplinkPortgroupKey;
         });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .directive('uplinkPortMappingWithDetails', uplinkPortMappingWithDetails);

   uplinkPortMappingWithDetails.$inject = [
      'physicalAdapterDetailsViewService',
      'i18nService'
   ];

   function uplinkPortMappingWithDetails(physicalAdapterDetailsViewService, i18nService) {
      var directive = {
         restrict: 'E',
         templateUrl: 'network-ui/resources/network/components/' +
         'uplinkPortMapping/uplinkPortMappingWithDetails.html',
         scope: {
            portMapping: '=',
            allowOldMappingsRemoval: '=?'
         },
         replace: true,
         link: {
            pre: function ($scope) {
               $scope.noItemsSelectedMessage = i18nService.getString('NetworkUi',
                     'UplinkPortMappingEditor.detailsPrompt');

               $scope.showPnicDetails = function (selectedItems) {
                  if (selectedItems && selectedItems.length === 1 && selectedItems[0].pnic) {
                     var selectedPnicDetaisData
                           = $scope.portMapping.pnicDetails[selectedItems[0].pnic];

                     $scope.selectedPnicDetails = physicalAdapterDetailsViewService.build(
                           selectedPnicDetaisData);
                  } else {
                     $scope.selectedPnicDetails = null;
                  }
               };
               $scope.splitterOptions = {
                  resizable: true,
                  panes: [
                     {
                        size: '210px'
                     }, {
                     }]
               };
            }
         }
      };
      return directive;
   }
}());

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditPortgroupService = (function () {
        function EditPortgroupService() {
        }
        /**
         * Compares two sets of general portgroup properties
         * @param initial - the initial data
         * @param current - the current state of the data
         * @returns {boolean}
         */
        EditPortgroupService.prototype.havePortgroupPropertiesChanged = function (initial, current) {
            return initial.portgroupName !== current.portgroupName ||
                initial.portgroupVlanId !== current.portgroupVlanId;
        };
        /**
         * Compares two sets of general portgroup properties
         * @param initial - the initial data
         * @param current - the current state of the data
         * @returns {boolean}
         */
        EditPortgroupService.prototype.haveVirtualSwitchPropertiesChanged = function (initial, current) {
            return initial.mtu !== current.mtu ||
                initial.numPorts !== current.numPorts;
        };
        /**
         * Compares two trafficShaping policies
         * @param initial - the initial state of the policy
         * @param current - the current state of the policy
         * @param overrideSupport
         */
        EditPortgroupService.prototype.hasTrafficShapingPolicyChanged = function (initial, current, overrideSupport) {
            // When override is supported and both policies are NOT overridden - no neet to compare anything
            if (overrideSupport &&
                initial.overridden === false && current.overridden === false) {
                return false;
            }
            return initial.overridden !== current.overridden ||
                initial.enabled !== current.enabled ||
                (initial.enabled && current.enabled &&
                    (initial.averageBandwidth !== current.averageBandwidth ||
                        initial.peakBandwidth !== current.peakBandwidth ||
                        initial.burstSize !== current.burstSize));
        };
        /**
         * Compares two securityPolicy stets whether they are identical or not.
         * @param initial - the initial configuration to compare against.
         * @param current - the actual configuration to compare.
         * @param overrideSupport - whether the configuration supports override flag or not.
         * @returns {boolean}
         */
        EditPortgroupService.prototype.hasSecurityPolicyChanged = function (initial, current, overrideSupport) {
            if (overrideSupport) {
                return this.diffOverridablePolicy(initial.isPromiscuousModeOverriden, initial.allowPromiscuousMode, current.isPromiscuousModeOverriden, current.allowPromiscuousMode) ||
                    this.diffOverridablePolicy(initial.isMacChangesOverriden, initial.macChanges, current.isMacChangesOverriden, current.macChanges) ||
                    this.diffOverridablePolicy(initial.isForgedTransmitsOverriden, initial.forgedTransmits, current.isForgedTransmitsOverriden, current.forgedTransmits);
            }
            else {
                return initial.allowPromiscuousMode !== current.allowPromiscuousMode ||
                    initial.macChanges !== current.macChanges ||
                    initial.forgedTransmits !== current.forgedTransmits;
            }
        };
        /**
         * Compares two failoverPolicies stets whether they are identical or not.
         * @param initial - the initial configuration to compare against.
         * @param current - the actual configuration to compare.
         * @param overrideSupport - whether the configuration supports override flag or not.
         * @returns {boolean}
         */
        EditPortgroupService.prototype.hasFailoverPolicyChanged = function (initial, current, overrideSupport) {
            if (overrideSupport) {
                return this.diffOverridablePolicy(initial.loadBalancingOverridden, initial.loadBalancing, current.loadBalancingOverridden, current.loadBalancing) ||
                    this.diffOverridablePolicy(initial.failureDetectionOverridden, initial.checkBeacon, current.failureDetectionOverridden, current.checkBeacon) ||
                    this.diffOverridablePolicy(initial.notifySwitchesOverridden, initial.notifySwitches, current.notifySwitchesOverridden, current.notifySwitches) ||
                    this.diffOverridablePolicy(initial.failbackOverridden, initial.rollingOrder, current.failbackOverridden, current.rollingOrder);
            }
            else {
                return initial.loadBalancing !== current.loadBalancing ||
                    initial.checkBeacon !== current.checkBeacon ||
                    initial.notifySwitches !== current.notifySwitches ||
                    initial.rollingOrder !== current.rollingOrder;
            }
        };
        /**
         * Compares two sets of failoverOrder elements. Mainly used for comparing whether
         * some page that contains the failoverOrder directive has been changed
         * @param initial configuration
         * @param current configuration
         * @returns {boolean}
         */
        EditPortgroupService.prototype.hasFailoverOrderChanged = function (initial, current, overrideSupported) {
            // If override is supported, but both policies are NOT overridden - no need to compare values
            if (overrideSupported &&
                initial.failoverOrderOverridden === false &&
                current.failoverOrderOverridden === false) {
                return false;
            }
            // if override flag has changed
            if (!!initial.failoverOrderOverridden !== !!current.failoverOrderOverridden) {
                return true;
            }
            // if both not defined
            if (!initial.pnics && !current.pnics) {
                return false;
            }
            // if only some of them not defined - consider it a change
            if (!!initial.pnics && !current.pnics || !initial.pnics && !!current.pnics) {
                return true;
            }
            return this.diffArrays(initial.pnics.active, current.pnics.active) ||
                this.diffArrays(initial.pnics.standby, current.pnics.standby);
        };
        // Compare string arrays element by element
        EditPortgroupService.prototype.diffArrays = function (leftArr, rightArr) {
            if (!leftArr && !rightArr) {
                return false;
            }
            if (!leftArr || !rightArr || leftArr.length !== rightArr.length) {
                return true;
            }
            for (var i = 0; i < leftArr.length; i++) {
                if (leftArr[i] !== rightArr[i]) {
                    return true;
                }
            }
            return false;
        };
        // Returns true only when both override flags are different, or when both policies
        // are overridden with different values
        EditPortgroupService.prototype.diffOverridablePolicy = function (leftPolicyOverridden, leftPolicy, rightPolicyOverridden, rightPolicy) {
            if (leftPolicyOverridden && rightPolicyOverridden) {
                return leftPolicy !== rightPolicy;
            }
            return !!leftPolicyOverridden !== !!rightPolicyOverridden;
        };
        return EditPortgroupService;
    }());
    network_ui.EditPortgroupService = EditPortgroupService;
    angular.module("com.vmware.vsphere.client.network")
        .service("editPortgroupService", EditPortgroupService);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    angular.module("com.vmware.vsphere.client.network").constant("iscsiPortBindingConstants", {
        backingType: {
            STANDARD_VNIC_BACKING_TYPE: "standard",
            DISTRIBUTED_VNIC_BACKING_TYPE: "distributed",
            OPAQUE_VNIC_BACKING_TYPE: "opaque"
        }
    });
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingDetailsViewData = (function () {
        function IscsiPortBindingDetailsViewData() {
        }
        return IscsiPortBindingDetailsViewData;
    }());
    network_ui.IscsiPortBindingDetailsViewData = IscsiPortBindingDetailsViewData;
    var IscsiPortBindingDetailsViewDataRetriever = (function () {
        function IscsiPortBindingDetailsViewDataRetriever(retrieveData) {
            this.retrieveData = retrieveData;
        }
        return IscsiPortBindingDetailsViewDataRetriever;
    }());
    network_ui.IscsiPortBindingDetailsViewDataRetriever = IscsiPortBindingDetailsViewDataRetriever;
    var IscsiPortBindingDetailsService = (function () {
        function IscsiPortBindingDetailsService(dataService, i18nService, $q, networkDetailsViewService, physicalAdaptersListService, physicalAdapterDetailsViewService, vmKernelAdapterService, dvPortgroupPropertiesService, vxPropertyViewService, distributedPortgroupPoliciesViewService, iscsiPortBindingConstants, standardSwitchPropertiesViewService, standardSwitchPoliciesViewService, dvsDetailsViewService) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.networkDetailsViewService = networkDetailsViewService;
            this.physicalAdaptersListService = physicalAdaptersListService;
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
            this.vmKernelAdapterService = vmKernelAdapterService;
            this.dvPortgroupPropertiesService = dvPortgroupPropertiesService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.distributedPortgroupPoliciesViewService = distributedPortgroupPoliciesViewService;
            this.iscsiPortBindingConstants = iscsiPortBindingConstants;
            this.standardSwitchPropertiesViewService = standardSwitchPropertiesViewService;
            this.standardSwitchPoliciesViewService = standardSwitchPoliciesViewService;
            this.dvsDetailsViewService = dvsDetailsViewService;
        }
        IscsiPortBindingDetailsService.prototype.requestPortgroupDetailsViewData = function (hostId, item) {
            if (hostId && item) {
                switch (item.vnicBackingType) {
                    case this.iscsiPortBindingConstants.backingType.STANDARD_VNIC_BACKING_TYPE:
                        return this.requestPortgroupDetailsViewDataForStandardPg(hostId, item);
                    case this.iscsiPortBindingConstants.backingType.DISTRIBUTED_VNIC_BACKING_TYPE:
                        return this.requestPortgroupDetailsViewDataForDvpg(hostId, item);
                }
            }
            return this.$q.when(null);
        };
        IscsiPortBindingDetailsService.prototype.requestSwitchDetailsViewData = function (hostId, item) {
            if (hostId && item) {
                switch (item.vnicBackingType) {
                    case this.iscsiPortBindingConstants.backingType.STANDARD_VNIC_BACKING_TYPE:
                        return this.requestSwitchDetailsViewDataForStandardSwitch(hostId, item);
                    case this.iscsiPortBindingConstants.backingType.DISTRIBUTED_VNIC_BACKING_TYPE:
                        return this.requestSwitchDetailsViewDataForDvs(hostId, item);
                }
            }
            return this.$q.when(null);
        };
        IscsiPortBindingDetailsService.prototype.requestSwitchDetailsViewDataForStandardSwitch = function (hostId, item) {
            var self = this;
            if (!item.switchName) {
                return this.$q.when(null);
            }
            var requests = {
                switchProperties: this.standardSwitchPropertiesViewService.getDataByName(hostId, item.switchName),
                switchPolicies: this.standardSwitchPoliciesViewService.getDataByName(hostId, item.switchName)
            };
            return this.$q.all(requests).then(function (response) {
                if (!response || !response.switchProperties) {
                    return null;
                }
                var builder = self.vxPropertyViewService.createPropertyViewBuilder();
                var propertiesCategory = builder
                    .category("properties")
                    .title(self.i18nService.getString("NetworkUi", "VSwitchSettingsView.properties"));
                self.standardSwitchPropertiesViewService.addPropertiesToCategory(response.switchProperties, propertiesCategory);
                if (response.switchPolicies) {
                    var policiesCategory = builder
                        .category("policies")
                        .title(self.i18nService.getString("NetworkUi", "VSwitchSettingsView.policy"));
                    self.standardSwitchPoliciesViewService.addPropertiesToCategory(response.switchPolicies, policiesCategory);
                    builder.generateAllCategory();
                }
                var result = new IscsiPortBindingDetailsViewData();
                result.propertiesData = builder.build();
                result.viewTitle = self.i18nService.getString("NetworkUi", "VSwitchSettingsView.title", item.switchName);
                return result;
            });
        };
        IscsiPortBindingDetailsService.prototype.requestSwitchDetailsViewDataForDvs = function (hostId, item) {
            var self = this;
            if (!item.dvSwitchUuid) {
                return this.$q.when(null);
            }
            var dvsConfigDataByUuidProperty = "dvswitchproperties:configDataByUuid";
            return this.dataService.getProperties(hostId, [dvsConfigDataByUuidProperty], {
                propertyParams: [{
                        propertyName: dvsConfigDataByUuidProperty,
                        parameterType: "java.lang.String",
                        parameter: item.dvSwitchUuid
                    }]
            }).then(function (response) {
                var dvsConfigData = response && response[dvsConfigDataByUuidProperty];
                if (!dvsConfigData) {
                    return null;
                }
                var result = new IscsiPortBindingDetailsViewData();
                result.propertiesData = self.dvsDetailsViewService.build(dvsConfigData, true);
                result.viewTitle = self.i18nService.getString("NetworkUi", "HostProxySwitchDetailsView.titleFormat", item.switchName);
                return result;
            });
        };
        IscsiPortBindingDetailsService.prototype.requestPortgroupDetailsViewDataForStandardPg = function (hostId, item) {
            var self = this;
            return self.dataService.getProperties(hostId, [IscsiPortBindingDetailsService.STANDARD_PORT_GROUP_DETAILS], {
                propertyParams: [{
                        propertyName: IscsiPortBindingDetailsService.STANDARD_PORT_GROUP_DETAILS,
                        parameterType: "java.lang.String",
                        parameter: item.vnicSpec.portgroup
                    }]
            }).then(function (response) {
                var networkData = response && response[IscsiPortBindingDetailsService.STANDARD_PORT_GROUP_DETAILS];
                if (!networkData) {
                    return null;
                }
                var result = new IscsiPortBindingDetailsViewData();
                result.propertiesData = self.networkDetailsViewService.build(networkData);
                result.viewTitle = self.i18nService.getString("NetworkUi", "PortgroupSettingsView.title", networkData.networkLabel);
                return result;
            });
        };
        IscsiPortBindingDetailsService.prototype.requestPortgroupDetailsViewDataForDvpg = function (hostId, item) {
            if (!item.vnicSpec || !item.vnicSpec.distributedVirtualPort || !item.vnicSpec.distributedVirtualPort.portgroupKey) {
                return this.$q.when(null);
            }
            var self = this;
            return this.dvPortgroupPropertiesService.requestDvPortgroupPropertiesAndPolicy(hostId, item.vnicSpec.distributedVirtualPort.portgroupKey).then(function (dvpgPropertiesAndPolicyData) {
                if (!dvpgPropertiesAndPolicyData || !dvpgPropertiesAndPolicyData.properties) {
                    return null;
                }
                var builder = self.vxPropertyViewService.createPropertyViewBuilder();
                var propertiesCategory = builder
                    .category("properties")
                    .title(self.i18nService.getString("NetworkUi", "dvpg.manage.settings.propertiesHeader"));
                self.dvPortgroupPropertiesService.addPropertiesToSection(dvpgPropertiesAndPolicyData.properties, propertiesCategory);
                if (dvpgPropertiesAndPolicyData.policy) {
                    self.distributedPortgroupPoliciesViewService.build(dvpgPropertiesAndPolicyData.policy, builder);
                }
                var result = new IscsiPortBindingDetailsViewData();
                builder.generateAllCategory();
                result.propertiesData = builder.build();
                if (dvpgPropertiesAndPolicyData.isUplink) {
                    result.viewTitle = self.i18nService.getString("NetworkUi", "DvPortgroupProperties.uplinkTitleFormat", dvpgPropertiesAndPolicyData.properties.name);
                }
                else {
                    result.viewTitle = self.i18nService.getString("NetworkUi", "DvPortgroupProperties.titleFormat", dvpgPropertiesAndPolicyData.properties.name);
                }
                return result;
            });
        };
        IscsiPortBindingDetailsService.prototype.requestPnicDetailsViewData = function (hostId, item) {
            var self = this;
            if (item && item.pnicDevice) {
                return this.physicalAdaptersListService
                    .getPhysicalAdapterDetailsItem(hostId, item.pnicDevice)
                    .then(function (pnicDetailsItem) {
                    if (!pnicDetailsItem) {
                        return null;
                    }
                    var result = new IscsiPortBindingDetailsViewData();
                    result.propertiesData = self.physicalAdapterDetailsViewService.build(pnicDetailsItem);
                    result.viewTitle = self.i18nService.getString("NetworkUi", "PnicPropertiesView.title", item.pnicDevice);
                    return result;
                });
            }
            return this.$q.when(null);
        };
        IscsiPortBindingDetailsService.prototype.requestVnicDetailsViewData = function (hostId, item) {
            var self = this;
            if (item && item.vnicDevice) {
                return this.vmKernelAdapterService.getVnicDetailsData(hostId, item.vnicDevice)
                    .then(function (detailsData) {
                    if (!detailsData) {
                        return null;
                    }
                    var result = new IscsiPortBindingDetailsViewData();
                    result.propertiesData = self.networkDetailsViewService.build(detailsData);
                    result.viewTitle = self.i18nService.getString("NetworkUi", "VnicDetailsView.title", item.vnicDevice);
                    return result;
                });
            }
            return this.$q.when(null);
        };
        IscsiPortBindingDetailsService.STANDARD_PORT_GROUP_DETAILS = "virtualswitch:portGroupPropertyViewDataByName";
        IscsiPortBindingDetailsService.$inject = ["dataService", "i18nService", "$q",
            "networkDetailsViewService", "physicalAdaptersListService",
            "physicalAdapterDetailsViewService", "vmKernelAdapterService",
            "dvPortgroupPropertiesService", "vxPropertyViewService", "distributedPortgroupPoliciesViewService",
            "iscsiPortBindingConstants",
            "standardSwitchPropertiesViewService",
            "standardSwitchPoliciesViewService",
            "dvsDetailsViewService"];
        return IscsiPortBindingDetailsService;
    }());
    network_ui.IscsiPortBindingDetailsService = IscsiPortBindingDetailsService;
    angular.module("com.vmware.vsphere.client.network")
        .service("iscsiPortBindingDetailsService", IscsiPortBindingDetailsService);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var ImageLabel = (function () {
        function ImageLabel() {
        }
        return ImageLabel;
    }());
    network_ui.ImageLabel = ImageLabel;
    var IscsiPortInfoItem = (function () {
        function IscsiPortInfoItem() {
        }
        return IscsiPortInfoItem;
    }());
    network_ui.IscsiPortInfoItem = IscsiPortInfoItem;
    var IscsiPortInfoData = (function () {
        function IscsiPortInfoData() {
        }
        return IscsiPortInfoData;
    }());
    network_ui.IscsiPortInfoData = IscsiPortInfoData;
    var CandidateIscsiPortInfoData = (function () {
        function CandidateIscsiPortInfoData() {
        }
        return CandidateIscsiPortInfoData;
    }());
    network_ui.CandidateIscsiPortInfoData = CandidateIscsiPortInfoData;
    var IscsiPortBindingService = (function () {
        function IscsiPortBindingService(dataService, mutationService, i18nService, logService, $q, iscsiPortBindingConstants) {
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.logService = logService;
            this.$q = $q;
            this.iscsiPortBindingConstants = iscsiPortBindingConstants;
            this.log = logService("iscsiPortBindingService");
        }
        /**
         * Request BoundIscsiPortInfoData for a given storage adapter.
         *
         * @param hostId
         * @param iscsiHbaName
         *
         * @returns {IPromise<network_ui.IscsiPortInfoData>}
         */
        IscsiPortBindingService.prototype.getBoundIscsiPortInfoData = function (hostId, iscsiHbaName) {
            var self = this;
            return this.dataService.getProperties(hostId, [IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA], {
                propertyParams: [{
                        propertyName: IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA,
                        parameterType: "java.lang.String",
                        parameter: iscsiHbaName
                    }]
            }).then(function (response) {
                var result = new IscsiPortInfoData();
                if (response && response[IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA]) {
                    result.hasPrivileges = response[IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA].hasPrivileges;
                    if (response[IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA].portInfoItems) {
                        result.items = _.map(response[IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA].portInfoItems, function (item) {
                            return self.createIscsiPortInfoItem(item);
                        });
                    }
                }
                return result;
            });
        };
        /**
         * Request CandidateIscsiPortInfoData for a given storage adapter.
         *
         * @param hostId
         * @param iscsiHbaName
         *
         * @returns {IPromise<network_ui.CandidateIscsiPortInfoData>}
         */
        IscsiPortBindingService.prototype.getCandidateIscsiPortInfoData = function (hostId, iscsiHbaName) {
            var self = this;
            return this.dataService.getProperties(hostId, [IscsiPortBindingService.CANDIDATE_ISCSI_PORT_INFO_DATA], {
                propertyParams: [{
                        propertyName: IscsiPortBindingService.CANDIDATE_ISCSI_PORT_INFO_DATA,
                        parameterType: "java.lang.String",
                        parameter: iscsiHbaName
                    }]
            }).then(function (response) {
                var result = new CandidateIscsiPortInfoData();
                if (response && response[IscsiPortBindingService.CANDIDATE_ISCSI_PORT_INFO_DATA]) {
                    result.items = _.map(response[IscsiPortBindingService.CANDIDATE_ISCSI_PORT_INFO_DATA].candidatePortInfoItems, function (item) {
                        return self.createIscsiPortInfoItem(item);
                    });
                }
                return result;
            });
        };
        /**
         * Initiates mutation call to associate the given post bindings to the iSCSI adapter of a host.
         *
         * @param hostId
         * @param iscsiHbaName
         * @param candidatePortInfos
         * @returns {any} promise with the mutation call result
         */
        IscsiPortBindingService.prototype.addCandidateIscsiPortInfo = function (hostId, iscsiHbaName, candidatePortInfos) {
            var type = "com.vmware.vsphere.client.network.host.iscsi.specs.IscsiPortBindingAddSpec";
            var spec = {
                _type: type,
                params: _.map(candidatePortInfos, function (candidatePortInfo) {
                    return {
                        iscsiHbaName: iscsiHbaName,
                        vnicDevice: candidatePortInfo.vmKernelAdapter.label
                    };
                })
            };
            return this.mutationService.apply(hostId, type, spec);
        };
        /**
         * Initiates mutation call to disassociate the given port bindings from the iSCSI adapter of a host.
         *
         * @param hostId
         * @param iscsiHbaName
         * @param portInfos
         * @returns {any} promise with the mutation call result
         */
        IscsiPortBindingService.prototype.removeIscsiPortInfos = function (hostId, iscsiHbaName, portInfos) {
            var type = "com.vmware.vsphere.client.network.host.iscsi.specs.IscsiPortBindingRemoveSpec";
            var spec = {
                _type: type,
                params: _.map(portInfos, function (portInfo) {
                    return {
                        iscsiHbaName: iscsiHbaName,
                        vnicDevice: portInfo.vmKernelAdapter.label,
                        forceRemoval: true
                    };
                })
            };
            return this.mutationService.apply(hostId, type, spec);
        };
        /**
         * Produces the messages for the port binding removal prompt, shown
         * when deleting port binding(s) from the list of bound port bindings
         * for an iSCSI adapter.
         *
         * @param selectedPortInfos
         * @param allPortInfos
         * @returns {RemoveIscsiPortBindingMessage}
         */
        IscsiPortBindingService.prototype.getPortBindingRemovalUserMessages = function (selectedPortInfos, allPortInfos) {
            if (!selectedPortInfos || !selectedPortInfos.length) {
                this.log.error("No selected port infos provided");
            }
            if (!allPortInfos || !allPortInfos.length) {
                this.log.error("No port infos provided");
            }
            var removeMessage = {
                title: this.i18nService.getString("NetworkUi", "portbinding.list.remove.confirmationTitle"),
                description: this.i18nService.getString("NetworkUi", "portbinding.list.remove.confirmationTextFormat", selectedPortInfos[0].vmKernelAdapter.label)
            };
            if (selectedPortInfos.length === 1) {
                if (selectedPortInfos[0].pathStatus.label === IscsiPortBindingService.LAST_ACTIVE_STATUS) {
                    removeMessage.title = this.i18nService.getString("NetworkUi", "portbinding.list.confirmRemoveLastActivePathTitle");
                    removeMessage.description = this.i18nService.getString("NetworkUi", "portbinding.list.confirmRemoveLastActivePath", selectedPortInfos[0].vmKernelAdapter.label);
                }
            }
            else {
                var remainingActive = _.find(allPortInfos, function (info) {
                    return selectedPortInfos.indexOf(info) === -1
                        && (info.pathStatus.label === IscsiPortBindingService.LAST_ACTIVE_STATUS
                            || info.pathStatus.label === IscsiPortBindingService.ACTIVE_STATUS);
                });
                if (!remainingActive) {
                    removeMessage.title = this.i18nService.getString("NetworkUi", "portbinding.list.confirmRemoveAllActivePathsTitle");
                    removeMessage.description = this.i18nService.getString("NetworkUi", "portbinding.list.confirmRemoveAllActivePaths");
                }
                else {
                    removeMessage.title = this.i18nService.getString("NetworkUi", "portbinding.list.remove.multiple.confirmationTitle");
                    removeMessage.description = this.i18nService.getString("NetworkUi", "portbinding.list.remove.multiple.confirmationText");
                }
            }
            return removeMessage;
        };
        /**
         * Creates a new IscsiPortInfoItem instance from a given
         * com.vmware.vsphere.client.h5.network.host.iscsi.model.IscsiPortInfoItem.
         */
        IscsiPortBindingService.prototype.createIscsiPortInfoItem = function (item) {
            var result = new IscsiPortInfoItem();
            result.portgroupName = this.formatPortGroupName(item.portGroupName, item.vnicBackingType);
            result.vmKernelAdapter = this.formatVmKernelAdapter(item.vmKernelAdapter);
            result.policyComplianceStatus = this.formatComplianceStatus(item.isCompliant);
            result.pathStatus = this.formatPathStatus(item.pathStatus);
            result.physicalNetworkAdapterInfo = this.formatPhysicalNetworkAdapterInfo(item.physicalNetworkAdapterInfo);
            result.pnicDevice = item.pnicDevice;
            result.vnicDevice = item.vmKernelAdapter;
            result.complianceErrors = item.complianceErrors;
            result.isCompliant = item.isCompliant;
            result.vnicSpec = item.vnicSpec;
            result.vnicBackingType = item.vnicBackingType;
            result.switchName = item.switchName;
            result.dvSwitchUuid = item.dvSwitchUuid;
            return result;
        };
        IscsiPortBindingService.prototype.formatPathStatus = function (pathStatus) {
            var result = new ImageLabel();
            switch (pathStatus) {
                case IscsiPortBindingService.ACTIVE_STATUS:
                    result.label = this.i18nService.getString("NetworkUi", "portbinding.activeStatusHeader");
                    result.icon = "network-lib-ui-icon-path-active";
                    break;
                case IscsiPortBindingService.STAND_BY_STATUS:
                    result.label = this.i18nService.getString("NetworkUi", "portbinding.standbyHeader");
                    result.icon = "network-lib-ui-icon-path-standby";
                    break;
                case IscsiPortBindingService.NOT_USED_STATUS:
                    result.label = this.i18nService.getString("NetworkUi", "portbinding.notUsedHeader");
                    result.icon = "network-lib-ui-icon-path-dead";
                    break;
                case IscsiPortBindingService.LAST_ACTIVE_STATUS:
                    result.label = this.i18nService.getString("NetworkUi", "portbinding.lastActiveHeader");
                    result.icon = "network-lib-ui-icon-path-disabled";
                    break;
                default:
                    result.label = this.i18nService.getString("NetworkUi", "portbinding.defaultString");
                    break;
            }
            return result;
        };
        IscsiPortBindingService.prototype.formatComplianceStatus = function (isCompliant) {
            var complianceStatus = new ImageLabel();
            if (isCompliant) {
                complianceStatus.label = this.i18nService.getString("NetworkUi", "portbinding.compliantLabel");
                complianceStatus.icon = "network-lib-ui-icon-statusGreen";
            }
            else {
                complianceStatus.label = this.i18nService.getString("NetworkUi", "portbinding.notCompliantLabel");
                complianceStatus.icon = "vsphere-icon-status-warning";
            }
            return complianceStatus;
        };
        IscsiPortBindingService.prototype.formatPortGroupName = function (portGroupName, vnicBackingType) {
            var result = new ImageLabel();
            if (portGroupName) {
                result.label = portGroupName;
                switch (vnicBackingType) {
                    case this.iscsiPortBindingConstants.backingType.STANDARD_VNIC_BACKING_TYPE:
                        result.icon = "vsphere-icon-network";
                        break;
                    case this.iscsiPortBindingConstants.backingType.OPAQUE_VNIC_BACKING_TYPE:
                        result.icon = "vsphere-icon-cloud-network";
                        break;
                    case this.iscsiPortBindingConstants.backingType.DISTRIBUTED_VNIC_BACKING_TYPE:
                        result.icon = "vsphere-icon-virtual-port-group";
                        break;
                }
            }
            else {
                result.label = this.i18nService.getString("NetworkUi", "portbinding.defaultString");
            }
            return result;
        };
        IscsiPortBindingService.prototype.formatVmKernelAdapter = function (vmKernelAdapter) {
            var result = new ImageLabel();
            if (!vmKernelAdapter) {
                result.label = this.i18nService.getString("NetworkUi", "portbinding.defaultString");
            }
            else {
                result.label = vmKernelAdapter;
                result.icon = "network-lib-ui-icon-virtualAdapter";
            }
            return result;
        };
        IscsiPortBindingService.prototype.formatPhysicalNetworkAdapterInfo = function (physicalNetworkAdapterInfo) {
            var result = new ImageLabel();
            if (!physicalNetworkAdapterInfo) {
                result.label = this.i18nService.getString("NetworkUi", "portbinding.defaultString");
            }
            else {
                result.label = physicalNetworkAdapterInfo;
                result.icon = "network-lib-ui-icon-physicalAdapter";
            }
            return result;
        };
        IscsiPortBindingService.BOUND_ISCSI_PORT_INFO_DATA = "iscsiPortBinding:boundIscsiPortInfoData";
        IscsiPortBindingService.CANDIDATE_ISCSI_PORT_INFO_DATA = "iscsiPortBinding:candidateIscsiPortInfoData";
        IscsiPortBindingService.ACTIVE_STATUS = "active";
        IscsiPortBindingService.STAND_BY_STATUS = "standBy";
        IscsiPortBindingService.NOT_USED_STATUS = "notUsed";
        IscsiPortBindingService.LAST_ACTIVE_STATUS = "lastActive";
        IscsiPortBindingService.$inject = ["dataService", "mutationService", "i18nService", "logService", "$q",
            "iscsiPortBindingConstants"];
        return IscsiPortBindingService;
    }());
    network_ui.IscsiPortBindingService = IscsiPortBindingService;
    angular.module("com.vmware.vsphere.client.network")
        .service("iscsiPortBindingService", IscsiPortBindingService);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackDetailsViewService = (function () {
        function NetStackDetailsViewService(dataService, i18nService, propertyViewService) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
        }
        NetStackDetailsViewService.prototype.getNetStackDetails = function (hostUrn, netStackKey) {
            var netStackConfigSpec = {};
            netStackConfigSpec.netStackInstanceKey = netStackKey;
            var params = {
                propertyParams: [{
                        propertyName: NetStackDetailsViewService.DATA_PROPERTY,
                        parameterType: "com.vmware.vsphere.client.h5.network.host.netstack.model.NetStackConfigSpec",
                        parameter: netStackConfigSpec
                    }]
            };
            return this.dataService.getProperties(hostUrn, [NetStackDetailsViewService.DATA_PROPERTY], params)
                .then(function (response) {
                return response[NetStackDetailsViewService.DATA_PROPERTY];
            });
        };
        NetStackDetailsViewService.prototype.buildDnsPropertiesView = function (netStackDetails, isDefaultNetStack) {
            if (netStackDetails) {
                var builder = this.propertyViewService.createPropertyViewBuilder();
                this.buildDnsCategory(builder, netStackDetails, isDefaultNetStack);
                return builder.build();
            }
        };
        NetStackDetailsViewService.prototype.buildRoutingPropertiesView = function (netStackDetails) {
            if (netStackDetails) {
                var builder = this.propertyViewService.createPropertyViewBuilder();
                this.buildRoutingCategory(builder, netStackDetails);
                return builder.build();
            }
        };
        NetStackDetailsViewService.prototype.buildAdvancedPropertiesView = function (netStackDetails) {
            if (netStackDetails) {
                var builder = this.propertyViewService.createPropertyViewBuilder();
                this.buildAdvancedCategory(builder, netStackDetails);
                return builder.build();
            }
        };
        NetStackDetailsViewService.prototype.buildDnsCategory = function (builder, netStackDetails, isDefaultNetStack) {
            // Add "DNS" tab
            var dnsCategory = builder.category("dns");
            var methodType = netStackDetails.isDhcpEnabled ?
                this.i18nService.getString("H5NetworkUi", "DnsAndRoutingView.dhcp", netStackDetails.selectedVnic) :
                this.i18nService.getString("H5NetworkUi", "DnsAndRoutingView.static");
            var noData = this.i18nService
                .getString("H5NetworkUi", "NetStackInstanceList.noData");
            var dnsMethodLabel = this.i18nService
                .getString("H5NetworkUi", "DnsAndRoutingView.dnsMethod");
            dnsCategory.section("general").property(dnsMethodLabel, methodType);
            if (isDefaultNetStack) {
                var hostNameLabel = this.i18nService
                    .getString("H5NetworkUi", "DnsAndRoutingView.hostNameLabel");
                var domainNameLabel = this.i18nService
                    .getString("H5NetworkUi", "DnsAndRoutingView.hostDomainLabel");
                dnsCategory.section("general")
                    .property(hostNameLabel, netStackDetails.hostName)
                    .property(domainNameLabel, netStackDetails.domainName);
            }
            var preferredDnsLabel = this.i18nService
                .getString("H5NetworkUi", "DnsAndRoutingView.preferredDnsServerLabel");
            var alternateDnsLabel = this.i18nService
                .getString("H5NetworkUi", "DnsAndRoutingView.alternateDnsServerLabel");
            var searchDomainsLabel = this.i18nService
                .getString("H5NetworkUi", "DnsAndRoutingView.searchDomain");
            dnsCategory.section("general")
                .property(preferredDnsLabel, netStackDetails.preferredDns || noData)
                .property(alternateDnsLabel, netStackDetails.alternateDns || noData)
                .property(searchDomainsLabel, netStackDetails.searchDomains || noData);
        };
        NetStackDetailsViewService.prototype.buildRoutingCategory = function (builder, netStackDetails) {
            // Add "Routing" tab
            var routingCategory = builder.category("routing");
            var noData = this.i18nService
                .getString("H5NetworkUi", "NetStackInstanceList.noData");
            var ipv4GatewayLabel = this.i18nService
                .getString("H5NetworkUi", "DnsAndRoutingView.ipv4VmkernelGateway");
            routingCategory.section("general")
                .property(ipv4GatewayLabel, netStackDetails.defaultGateway || noData);
            if (netStackDetails.isIpv6Enabled) {
                var ipv6GatewayLabel = this.i18nService
                    .getString("H5NetworkUi", "DnsAndRoutingView.ipv6VmkernelGateway");
                routingCategory.section("general")
                    .property(ipv6GatewayLabel, netStackDetails.ipV6DefaultGateway || noData);
            }
        };
        NetStackDetailsViewService.prototype.buildAdvancedCategory = function (builder, netStackDetails) {
            // Add "Advanced" tab
            var advancedCategory = builder.category("advanced");
            var section = advancedCategory.section("general");
            var noData = this.i18nService
                .getString("H5NetworkUi", "NetStackInstanceList.noData");
            var congestionControlAlgorithmLabel = this.i18nService
                .getString("NetworkUi", "AdvancedNetStackSettingsView.congestionControl");
            var congestionControlAlgorithmValue = "";
            if (netStackDetails.congestionControlAlgorithm === "newreno") {
                congestionControlAlgorithmValue = this.i18nService
                    .getString("NetworkUi", "AdvancedNetStackPage.newReno");
            }
            if (netStackDetails.congestionControlAlgorithm === "cubic") {
                congestionControlAlgorithmValue = this.i18nService
                    .getString("NetworkUi", "AdvancedNetStackPage.cubic");
            }
            section.property(congestionControlAlgorithmLabel, congestionControlAlgorithmValue || noData);
            var maxNumberOfConnectionsLabel = this.i18nService.getString("NetworkUi", "AdvancedNetStackSettingsView.maxNumberOfConnections");
            section.property(maxNumberOfConnectionsLabel, netStackDetails.maxNumberOfConnections || noData);
            if (netStackDetails.runtimeMaxNumberOfConnections !==
                netStackDetails.maxNumberOfConnections &&
                netStackDetails.isRuntimeInfoActive) {
                section.message(this.i18nService.getString("NetworkUi", "AdvancedNetStackPage.restartWarning"), 'network-lib-ui-icon-restartWarning');
            }
        };
        NetStackDetailsViewService.$inject = [
            "dataService",
            "i18nService",
            "vxPropertyViewService"];
        NetStackDetailsViewService.DATA_PROPERTY = "netstack:netStackConfig";
        return NetStackDetailsViewService;
    }());
    network_ui.NetStackDetailsViewService = NetStackDetailsViewService;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackDetailsViewService", NetStackDetailsViewService);
})(network_ui || (network_ui = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.network').service(
         'netStackListService', netStackListService);

   netStackListService.$inject = [
      'vuiConstants',
      'i18nService',
      'networkUtil'
   ];

   function netStackListService (vuiConstants, i18nService, networkUtil) {

      return {
         createDatagridOptions: createDatagridOptions
      };

      function createDatagridOptions(data, actionBarOptions, ipv6Enabled, onSelectionChange) {
         return {
            columnDefs: createNetStackColumnDefs(ipv6Enabled),
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            data: data,
            resizable: true,
            height: '100%',
            pageConfig: {
               hidePager: true
            },
            actionBarOptions: actionBarOptions,
            onChange: onSelectionChange
         };
      }

      function createNetStackColumnDefs(isIpv6Enabled) {
         var defs = [{
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.tcpIpInstance'),
               field: 'name',
               width: '120px'
            },
            {
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.type'),
               field: 'type',
               width: '100px'
            },
            {
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.assignedAdapters'),
               field: 'virtualNicCount',
               width: '100px',
               template: function (item) {
                  return '<span class="right-align-cell">' + item.virtualNicCount + '</span>';
               },
               sortable: function (item1, item2) {
                  return networkUtil.compareNumericValues(item1, item2, 'virtualNicCount');
               }
            },
            {
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.ipv4GatewayAddress'),
               field: 'ipv4GatewayAddress',
               width: '100px'
            }];

         if (isIpv6Enabled) {
            defs.push({
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.ipv6GatewayAddress'),
               field: 'ipv6GatewayAddress',
               width: '180px'
            });
         }

         defs.push({
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.preferredDnsServer'),
               field: 'preferredDnsServer',
               width: '150px'
            },
            {
               displayName: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.alternateDnsServer'),
               field: 'alternateDnsServer',
               width: '150px'
            });

         return defs;
      }
   }
})();

(function () {
    'use strict';
    angular.module('com.vmware.vsphere.client.network').factory('physicalAdaptersListColumns', physicalAdaptersListColumns);

    physicalAdaptersListColumns.$inject = ['i18nService', 'columnRenderersRegistry', 'networkUtil'];

    function physicalAdaptersListColumns(i18nService, columnRenderersRegistry, networkUtil) {

        return [
            {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicDeviceColumnHeader'),
                field: 'device',
                width: '150px',
                sortable: function(vmnic1, vmnic2) {
                   return networkUtil.compareNumericValues(vmnic1, vmnic2, 'pnicIndex');
                },
                template: (function (data) {
                    return columnRenderersRegistry.getColumnRenderer('object-link')(
                        [undefined, 'device', 'network-lib-ui-icon-physicalAdapter'], data);
                })
            }, {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicActualSpeedColumnHeader'),
                field: 'actualSpeedLabel',
                sortable: function(cti1, cti2) {
                    return networkUtil.compareNumericValues(cti1, cti2, 'actualSpeed');
                },
                width: '150px'
            }, {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicConfigSpeedColumnHeader'),
                field: 'configuredSpeedLabel',
                sortable: function(cti1, cti2) {
                    return networkUtil.compareNumericValues(cti1, cti2, 'configuredSpeed');
                },
                width: '150px'
            },  {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicSwitchColumnHeader'),
                field: 'virtualSwitch.switchName',
                width: '150px',
                template: (function (data) {
                    var switchItem = data.virtualSwitch;

                    return columnRenderersRegistry.getColumnRenderer('icon-text')(
                         ['iconId', 'switchName'], switchItem);
                })
            }, {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicMacColumnHeader'),
                field: 'mac',
                width: '150px'
            }, {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicNetworksColumnHeader'),
                field: 'networkHint',
                width: '150px',
                template: (function (data) {
                    return columnRenderersRegistry.getColumnRenderer('text')(['networkHint'], data);
                })
            }, {
                displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.pnicWakeOnLanColumnHeader'),
                field: 'wakeOnLanSupportedLabel',
                width: '150px'
            }, {
              displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.SriovStatusColumnHeader'),
              field: 'sriovStatusLabel',
              width: '150px'
           }, {
              displayName: i18nService.getString('NetworkUi', 'PnicDataGridView.SriovNumVfsColumnHeader'),
              field: 'sriovNumVirtuanFunctionsLabel',
              width: '150px'
           }
        ];
    }
})();

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var ProxySwitchDetailsDialogService = (function () {
        function ProxySwitchDetailsDialogService(i18nService, dataService, dvsDetailsViewService) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.dvsDetailsViewService = dvsDetailsViewService;
        }
        ProxySwitchDetailsDialogService.prototype.getData = function (dvsId) {
            var _this = this;
            return this.dataService.getProperties(dvsId, [ProxySwitchDetailsDialogService.CONFIG_DATA_PROPERTY_NAME])
                .then(function (response) {
                var rawData = response && response[ProxySwitchDetailsDialogService.CONFIG_DATA_PROPERTY_NAME];
                if (rawData && rawData.name) {
                    var trimmedName = rawData.name.trim();
                    var escapedName = trimmedName.replace(/%25/g, "%")
                        .replace(/%2f/g, "\/").replace(/%5c/g, "\\");
                    rawData.name = escapedName;
                }
                return _this.dvsDetailsViewService.build(rawData, true);
            });
        };
        ProxySwitchDetailsDialogService.$inject = [
            "i18nService",
            "dataService",
            "dvsDetailsViewService"
        ];
        ProxySwitchDetailsDialogService.CONFIG_DATA_PROPERTY_NAME = "dvswitchproperties:configdata";
        return ProxySwitchDetailsDialogService;
    }());
    network_ui.ProxySwitchDetailsDialogService = ProxySwitchDetailsDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("proxySwitchDetailsDialogService", ProxySwitchDetailsDialogService);
})(network_ui || (network_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var RemoveVnicService = (function () {
        function RemoveVnicService(i18nService, clarityModalService, mutationService) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
        }
        RemoveVnicService.prototype.openConfirmationDialog = function (hostId, vnic) {
            var _this = this;
            var REMOVE_VNIC_SPEC_TYPE = "com.vmware.vsphere.client.modules.api.network.VirtualNicRemoveSpec";
            var standardPortgroup = vnic.connectedTo === 'standardNetwork'
                ? vnic.networkLabel : null;
            var removeVnicSpec = {
                virtualNicName: vnic.device,
                portgroupName: standardPortgroup,
                isServiceConsoleVirtualNic: false
            };
            var modalOptions = {
                title: this.i18nService.getString('H5NetworkUi', 'removeVnicDialog.confirmRemoveTitle'),
                submitDisabled: true,
                preserveNewlines: true,
                saveButtonLabel: this.i18nService.getString('H5NetworkUi', 'removeButtonLabel')
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
            this.mutationService
                .validate(hostId, REMOVE_VNIC_SPEC_TYPE, removeVnicSpec)
                .then(function (validationResult) {
                if (!!validationResult.error) {
                    _.extend(modalOptions, {
                        message: _this.i18nService.getString('H5NetworkUi', 'removeVnicDialog.validationError'),
                        clarityIcon: {
                            class: "is-error",
                            shape: "error-standard",
                            size: "32"
                        }
                    });
                }
                else {
                    modalOptions.submitDisabled = false;
                    if (validationResult.result.messageType === "error") {
                        _.extend(modalOptions, {
                            message: validationResult.result.message,
                            saveButtonLabel: _this.i18nService.getString('Common', 'saveButtonLabel'),
                            clarityIcon: {
                                class: "is-error",
                                shape: "error-standard",
                                size: "32"
                            },
                            submit: function () {
                                return true;
                            },
                            hideCancelButton: true
                        });
                    }
                    else {
                        var warning = !!validationResult.result.message
                            ? validationResult.result.message
                            : _this.i18nService.getString('H5NetworkUi', 'removeVnicDialog.confirmRemoveMessage', removeVnicSpec.virtualNicName);
                        _.extend(modalOptions, {
                            message: warning,
                            clarityIcon: {
                                class: "is-warning",
                                shape: "warning-standard",
                                size: "32"
                            },
                            submit: function () {
                                _this.mutationService.apply(hostId, REMOVE_VNIC_SPEC_TYPE, removeVnicSpec);
                            }
                        });
                    }
                }
            });
        };
        RemoveVnicService.$inject = [
            "i18nService",
            "clarityModalService",
            "mutationService"
        ];
        return RemoveVnicService;
    }());
    network_ui.RemoveVnicService = RemoveVnicService;
    angular.module("com.vmware.vsphere.client.network")
        .service("removeVnicService", RemoveVnicService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('standardSwitchPoliciesViewService', standardSwitchPoliciesViewService);

   standardSwitchPoliciesViewService.$inject = [
      'dataService',
      'vxPropertyViewService',
      'networkUtil'
   ];

   function standardSwitchPoliciesViewService(
         dataService, propertyViewService, networkUtil) {

      var property = "virtualswitch:policiesViewData";

      return {
         getData: getData,
         getDataByName: getDataByName,
         addPropertiesToCategory: addPropertiesToCategory
      };

      function getData(hostId, selectedSwitchKey) {
         var switchIdSpec = {
            _type: 'com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.VirtualSwitchIdSpec',
            key: selectedSwitchKey
         };
         return getDataInternal(hostId, switchIdSpec, true);
      }

      function getDataByName(hostId, switchName) {
         var switchIdSpec = {
            _type: 'com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.VirtualSwitchIdSpec',
            name: switchName
         };
         return getDataInternal(hostId, switchIdSpec, false);
      }

      function getDataInternal(hostId, switchIdSpec, buildPropertyViewData) {
         var params = {
            propertyParams: [{
               propertyName: property,
               parameterType: switchIdSpec._type,
               parameter: switchIdSpec
            }]
         };

         var propertiesPromise = dataService.getProperties(
            hostId,
            [property],
            params
         );

         return propertiesPromise.then(function(result) {
            var policyData = result && result[property];
            if (buildPropertyViewData) {
               return build(policyData);
            } else {
               return policyData;
            }
         });
      }

      function build(policiesViewData) {
         var builder = propertyViewService.createPropertyViewBuilder();
         var generalCategory = builder.category("general");

         addPropertiesToCategory(policiesViewData, generalCategory);

         return builder.build();
      }

      function addPropertiesToCategory(policiesViewData, category) {
         if (policiesViewData) {
            networkUtil.fillPoliciesCategory(category, policiesViewData);
         }
      }
   }
}());

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('standardSwitchPropertiesViewService', standardSwitchPropertiesViewService);

   standardSwitchPropertiesViewService.$inject = [
      'dataService',
      'vxPropertyViewService',
      'i18nService'
   ];

   function standardSwitchPropertiesViewService(
         dataService, propertyViewService, i18nService) {

      return {
         getData: getData,
         getDataByName: getDataByName,
         addPropertiesToCategory: addPropertiesToCategory
      };

      function getData(hostId, selectedSwitchKey) {
         var switchIdSpec = {
            _type: 'com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.VirtualSwitchIdSpec',
            key: selectedSwitchKey
         };
         return getDataInternal(hostId, switchIdSpec, true);
      }

      function getDataByName(hostId, switchName) {
         var switchIdSpec = {
            _type: 'com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.VirtualSwitchIdSpec',
            name: switchName
         };
         return getDataInternal(hostId, switchIdSpec, false);
      }

      function getDataInternal(hostId, switchIdSpec, buildPropertyViewData) {
         var property = "virtualswitch:propertiesViewData";

         var params = {
            propertyParams: [{
               propertyName: property,
               parameterType: switchIdSpec._type,
               parameter: switchIdSpec
            }]
         };

         var propertiesPromise = dataService.getProperties(
            hostId,
            [property],
            params
         );

         return propertiesPromise.then(function (result) {
            var switchData = result && result[property];
            if (buildPropertyViewData) {
               return build(switchData);
            } else {
               return switchData;
            }
         });
      }

      function build(switchData) {
         var builder = propertyViewService.createPropertyViewBuilder();

         var generalCategory = builder.category("general");
         addPropertiesToCategory(switchData, generalCategory);

         return builder.build();
      }

      function addPropertiesToCategory(switchData, category) {
         var propertiesSection = category.section("generalSection");

         propertiesSection.title(i18nService.getString(
               "H5NetworkUi", "standardSwitchDetailsView.properties.section"));

         if (switchData) {

            // Name
            if (switchData.name) {
               propertiesSection.property(
                  i18nService.getString('NetworkUi', 'VSwitchPropertiesView.standardSwitch'),
                  switchData.name);
            }

            // Number of ports
            if (switchData.numberOfPorts) {
               propertiesSection.property(
                  i18nService.getString('NetworkUi', 'VSwitchPropertiesView.numPorts'),
                  switchData.numberOfPorts);

               if (switchData.showRestartWarning) {
                  propertiesSection.message(
                     i18nService.getString('NetworkUi', 'VSwitchPropertiesView.numPortDesc'),
                     'vx-icon-restartWarning');
               }
            }

            // MTU
            if (switchData.mtu) {
               propertiesSection.property(
                  i18nService.getString('NetworkUi', 'VSwitchPropertiesView.mtu'),
                  switchData.mtu);
            }
         }
      }
   }
}());

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.network').service(
         'virtualSwitchListService', virtualSwitchListService);

   virtualSwitchListService.$inject = [
         'vuiConstants',
         'columnRenderersRegistry',
         'i18nService',
         'networkUtil'];

   function virtualSwitchListService(
         vuiConstants,
         columnRenderersRegistry,
         i18nService,
         networkUtil) {

      return {
         createDatagridOptions: createDatagridOptions
      };

      function createDatagridOptions(
            virtualSwitchItems, showsIssuesColumn, onSelectionChange) {

         return {
            columnDefs: virtualSwitchColumnDefs(showsIssuesColumn),
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            data: virtualSwitchItems,
            resizable: true,
            height: '100%',
            pageConfig: {
               hidePager: true
            },
            onChange: onSelectionChange
         };
      }

      function virtualSwitchColumnDefs(showsIssuesColumn) {
         return [{
            displayName: i18nService.getString(
                  'NetworkUi', 'HostSwitchList.column.switch'),
            field: 'name',
            width: '150px',
            template: objectNameRendererFactory('name',
                  {
                     distributedSwitch: 'vsphere-icon-dv-switch',
                     standardSwitch: 'network-lib-ui-icon-vswitch'
                  })
         }, {
            displayName: i18nService.getString(
                  'NetworkUi', 'HostSwitchList.column.discoveredIssues'),
            field: 'issueType',
            width: '150px',
            visible: showsIssuesColumn,
            template: issueTypeRendererFactory('issueType',
                  {
                     alert: 'vsphere-icon-status-error',
                     warning: 'vsphere-icon-status-warning',
                     none: null
                  }, {
                     alert: i18nService.getString(
                           'NetworkUi', 'HostSwitchList.column.status.alert'),
                     warning: i18nService.getString(
                           'NetworkUi', 'HostSwitchList.column.status.warning'),
                     none: i18nService.getString(
                           'NetworkUi', 'HostSwitchList.column.status.noIssues')
                  })
         }];
      }

      function objectNameRendererFactory(field, iconMapping) {
         return (function (data) {
            var iconName = iconMapping[data['type']] || null;
            var objectLinkRenderer =
                  columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([null, field, iconName], data);
         });
      }

      function issueTypeRendererFactory(field, iconMapping, labelMapping) {
         return (function (data) {
            var issueIcon = iconMapping[data[field]] || null;
            var issueLabel = labelMapping[data[field]] || null;
            var objectLinkRenderer =
                  columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([null, 'text', issueIcon], {'text': issueLabel});
         });
      }
   }
})();
/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var MoveNetworkSpec = com.vmware.vsphere.client.h5.network.MoveNetworkSpec;
    var MoveNetworkToService = (function () {
        function MoveNetworkToService(clarityModalService, i18nService, mutationService, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        MoveNetworkToService.prototype.openMoveToDialog = function (availableTargets) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("NetworkUi", "moveto.dialog.title"),
                subTitle: {
                    objectId: availableTargets[0]
                },
                defaultButton: 'submit',
                dialogData: {
                    objectIds: availableTargets
                },
                contentTemplate: "network-ui/resources/network/views/moveTo/moveNetworkToDialog.html"
            };
            modalOptions.onSubmit = function () {
                _this.moveNetworkTo(modalOptions.dialogData.objectIds, modalOptions.dialogData.entityToMoveNetworkTo);
                return true;
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        MoveNetworkToService.prototype.moveNetworkTo = function (networkIds, entityToMoveNetworkTo) {
            var _this = this;
            var networkMors = networkIds.map(function (networkId) {
                return _this.defaultUriSchemeUtil.getManagedObjectReference(networkId);
            });
            var moveSpec = new MoveNetworkSpec();
            moveSpec.entities = networkMors;
            this.mutationService.apply(entityToMoveNetworkTo, moveSpec._type, moveSpec).then(function () {
            });
            return true;
        };
        MoveNetworkToService.$inject = [
            "clarityModalService",
            "i18nService",
            "mutationService",
            "defaultUriSchemeUtil"
        ];
        return MoveNetworkToService;
    }());
    network_ui.MoveNetworkToService = MoveNetworkToService;
    angular.module("com.vmware.vsphere.client.network")
        .service("moveNetworkToService", MoveNetworkToService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('networkLabelValidator',
               networkLabelValidator);

   networkLabelValidator.$inject = [
      'i18nService',
      'mutationService',
      'networkUtil'];

   function networkLabelValidator(i18nService,
                                  mutationService,
                                  networkUtil) {

      function getNetworkLabelClientSideValidationErrors(networkLabel) {
         var errors = [];

         if (!networkLabel || networkLabel.trim().length === 0) {
            errors.push(i18nService.getString('NetworkUi', 'VnicData.emptyNetworkLabel'));
         } else if (networkLabel.trim().length > networkUtil.NETWORK_LABEL_MAX_LENGTH) {
            errors.push(i18nService.getString('NetworkUi', 'VnicData.networkLabelTooLong'));
         } else if (networkLabel.indexOf('"') >= 0) {
            errors.push(i18nService.getString('H5NetworkUi', 'VnicData.networkLabelInvalidCharacter'));
         }

         return errors;
      }

      function getNetworkLabelServerSideValidationErrors(hostId, networkLabel) {
         return mutationService.validate(hostId,
               'com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.StandardNetworkLabelValidateSpec', {
                  _type: 'com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.StandardNetworkLabelValidateSpec',
                  label: networkLabel.trim()
               }).then(function (validationResult) {
            var serverErrors = [];
            if (validationResult.result) {
               serverErrors.push(validationResult.result);
            }
            return serverErrors;
         });
      }

      return {
         getNetworkLabelClientSideValidationErrors: getNetworkLabelClientSideValidationErrors,
         getNetworkLabelServerSideValidationErrors: getNetworkLabelServerSideValidationErrors
      };
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('tcpIpStackServicesValidator',
               tcpIpStackServicesValidator);

   tcpIpStackServicesValidator.$inject = [
      'dataService'
   ];

   var IS_SYSTEM_TRAFFIC_ENABLED_PROPERTY = "vnic:isSystemTrafficEnabled";

   function tcpIpStackServicesValidator(dataService) {

      function isSystemTrafficEnabledOnDefaultStack(netStackInstanceKey, hostId) {

         var systemTraffic = netStackInstanceKey;

         return dataService.getProperties(hostId,
               [IS_SYSTEM_TRAFFIC_ENABLED_PROPERTY], {
                  propertyParams: [
                     {
                        propertyName: IS_SYSTEM_TRAFFIC_ENABLED_PROPERTY,
                        parameterType: 'java.lang.String',
                        parameter: systemTraffic
                     }
                  ]
               });
      }

      return {
         isSystemTrafficEnabledOnDefaultStack: isSystemTrafficEnabledOnDefaultStack
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service which handles the wizard showing and wiring the Add networking wizard steps.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('addHostNetworkingWizardService', addHostNetworkingWizardService);

   addHostNetworkingWizardService.$inject = [
      '$q',
      'vuiWizardService',
      'i18nService',
      'dataService',
      '$rootScope',
      'mutationService',
      'addNetworkingWizardConstants',
      'addNetworkingSpecificationFactory',
      'addNetworkingPages',
      'addNetworkingFlowManager',
      'networkUiConstants',
      'wizardValidationService'];

   function addHostNetworkingWizardService($q,
                                           vuiWizardService,
                                           i18nService,
                                           dataService,
                                           $rootScope,
                                           mutationService,
                                           addNetworkingWizardConstants,
                                           addNetworkingSpecificationFactory,
                                           addNetworkingPages,
                                           addNetworkingFlowManager,
                                           networkUiConstants,
                                           wizardValidationService) {

      return {
         showWizard: function (hostId, selectedSwitch, connectionType) {
            var STANDARD_SWITCH_HOST =
                  "com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.HostStandardSwitchData";
            var wizardScope = $rootScope.$new();
            wizardScope.addNetworkingWizardConstants = addNetworkingWizardConstants;

            wizardScope.hostId = hostId;
            wizardScope.preselectedSwitch = selectedSwitch;

            wizardScope.hostCapability = {};
            // different flags for ipv4 and ipv6 so that both pages can be refreshed
            // when changing netstack property
            wizardScope.hostVnicIpRoutingInfo = {
               isIpv4Set: false,
               isIpv6Set: false,
               value: null
            };

            //default value which is assigned only on Add networking wizard
            //initialization and its not part of reseting defaults
            wizardScope.selectConnectionTypePageModel = {};
            wizardScope.selectConnectionTypePageModel.connectionType =
                  connectionType ? connectionType : addNetworkingWizardConstants.connectionType.VMKERNEL;


            wizardScope.wizardConfig = {
               cssClass: 'add-networking-wizard',
               loading: true,
               updateLoadingState: function(loading) {
                  this.loading = loading;
               }
            };
            wizardScope.wizardConfig.title =
                  i18nService.getString('NetworkUi', 'AddNetworkingWizard.title');
            wizardScope.wizardConfig.onFinish = onAddHostNetworkingComplete;

            wizardScope.wizardConfig.pages = addNetworkingPages.createWizardPages(wizardScope);
            wizardValidationService.initWizardValidation(wizardScope);

            addNetworkingFlowManager.initFlowManager(wizardScope);

            // Show the wizard
            vuiWizardService({
               scope: wizardScope,
               configObjectName: 'wizardConfig'
            }).show();

            wizardScope.$watch(function () {
               return wizardScope.selectConnectionTypePageModel.connectionType;
            }, function () {
               assignDefaults(wizardScope);
               wizardScope.selectTargetNetworkPageModel.retrieveAllSwitches =
                     wizardScope.selectConnectionTypePageModel.connectionType
                     === addNetworkingWizardConstants.connectionType.PNIC;
            });

            wizardScope.$watch(function () {
               return wizardScope.selectTargetNetworkPageModel.targetType;
            }, function (newValue, oldValue) {
               if (newValue !== oldValue) {
                  assignVSwitchSpecDefaults(wizardScope);
               }
            });

            wizardScope.$watch(function () {
               return wizardScope.addNetworkingSpec.selectedStandardSwitch;
            }, function () {
               assignVSwitchSpecDefaults(wizardScope);
            });

            dataService.getData(hostId, STANDARD_SWITCH_HOST).then(function (properties) {
               wizardScope.wizardConfig.iconClass = 'host-ui-icon-default';
               wizardScope.wizardConfig.title = i18nService.getString(
                     'NetworkUi', 'AddNetworkingWizard.updatedTitle', properties.name);
               wizardScope.hostCapability.switchAutoScaleSupported = properties.switchAutoScaleSupported;
               wizardScope.hostCapability.availablePortsNumber = properties.availablePortsNumber;
               wizardScope.wizardConfig.loading = false;
            });

            function onAddHostNetworkingComplete() {

               var specPromise;
               switch (wizardScope.selectConnectionTypePageModel.connectionType) {
                  case addNetworkingWizardConstants.connectionType.VMKERNEL:
                     specPromise = addNetworkingSpecificationFactory
                           .createNewVnicSpec(wizardScope.addNetworkingSpec,
                                 wizardScope.vSwitchSpec,
                                 wizardScope.portPropertiesPageModel.ipSettingsType,
                                 wizardScope.selectTargetNetworkPageModel.targetType,
                                 wizardScope.bindPnicPageModel);
                     break;

                  case addNetworkingWizardConstants.connectionType.VM_PORTGROUP:
                     specPromise = addNetworkingSpecificationFactory.createNewPortgroupSpec(
                           wizardScope.addNetworkingSpec,
                           wizardScope.vSwitchSpec,
                           wizardScope.selectTargetNetworkPageModel.targetType);
                     break;
                  case addNetworkingWizardConstants.connectionType.PNIC:
                     if (wizardScope.selectTargetNetworkPageModel.targetType
                           === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
                        specPromise = addNetworkingSpecificationFactory.createNewPnicToNewStandardSwitchSpec(wizardScope.vSwitchSpec);
                     } else {
                        if (wizardScope.addNetworkingSpec.selectedStandardSwitch.type
                              === networkUiConstants.switchType.DISTRIBUTED) {
                           specPromise = addNetworkingSpecificationFactory.createNewPnicToDistributedSwitchSpec(
                                 wizardScope.addPnicToDvsPageModel.portMapping.uplinkPortMapping,
                                 wizardScope.addNetworkingSpec.selectedStandardSwitch);
                        } else {
                           specPromise = addNetworkingSpecificationFactory.createNewPnicToExistingStandardSwitchSpec(
                                 wizardScope.addNetworkingSpec,
                                 wizardScope.vSwitchSpec);
                        }
                     }
                     break;
               }

               $q.when(specPromise).then(function (spec) {
                  mutationService.apply(wizardScope.hostId, spec._type, spec);
               });
               return true;
            }
         }
      };

      function assignDefaults(wizardScope) {
         wizardScope.vSwitchSpec = {};

         wizardScope.addNetworkingSpec = {};
         // IPv4 Defaults
         // DHCP is enabled by default

         wizardScope.addNetworkingSpec.dhcpEnabled = true;
         wizardScope.addNetworkingSpec.ipv4Address = "";
         wizardScope.addNetworkingSpec.subnetMask = "";
         wizardScope.addNetworkingSpec.overrideGateway = false;
         wizardScope.addNetworkingSpec.ipv4DefaultGateway = "";

         // IPv6 Defaults
         wizardScope.addNetworkingSpec.ipv6DhcpEnabled = false;
         wizardScope.addNetworkingSpec.routerAdvertisementEnabled = false;
         wizardScope.addNetworkingSpec.ipv6Addresses = [];
         wizardScope.addNetworkingSpec.overrideIpv6Gateway = false;
         wizardScope.addNetworkingSpec.ipv6DefaultGateway = "";

         // common flag for IPv4 and IPv6 default gateway
         wizardScope.addNetworkingSpec.isGatewayFeatureSupported = false;

         //init page models
         wizardScope.selectTargetNetworkPageModel = {};

         wizardScope.selectTargetNetworkPageModel.isOpaqueNetworkSelected = false;

         wizardScope.selectTargetNetworkPageModel.targetType =
               (wizardScope.selectConnectionTypePageModel.connectionType
               === addNetworkingWizardConstants.connectionType.VMKERNEL)
                     ? addNetworkingWizardConstants.targetType.EXISTING_NETWORK
                     : addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH;

         wizardScope.addPnicPageModel = {};
         wizardScope.addPnicPageModel.isInitialized = false;

         wizardScope.addPnicToDvsPageModel = {};
         wizardScope.addPnicToDvsPageModel.isInitialized = false;

         wizardScope.connectionSettingsPageModel = {};
         wizardScope.connectionSettingsPageModel.vlanIds = null;
         wizardScope.connectionSettingsPageModel.isInitialized = false;

         wizardScope.ipv4SettingsPageModel = {};
         wizardScope.ipv4SettingsPageModel.validateIpAddress = {};
         wizardScope.ipv4SettingsPageModel.validateSubnetMask = {};
         wizardScope.ipv4SettingsPageModel.validateIpv4DefaultGateway = {};
         wizardScope.ipv6SettingsPageModel = {};
         wizardScope.ipv6SettingsPageModel.validateIpv6DefaultGateway = {};

         wizardScope.portPropertiesPageModel = {
            ipSettingsType: addNetworkingWizardConstants.ipSettingsMode.IP_V4
         };

         wizardScope.bindPnicPageModel = {
            bindToPnic: false,
            selectedPnic: null,
            availablePnicsData: null,
            onPnicSelectionChange : function(selectedPnic) {
               this.selectedPnic = selectedPnic;
            },
            onBindToPnicChange: function(bindToPnic) {
               this.bindToPnic = bindToPnic;
            },
            onAvailablePnicsDataChange: function(availablePnicsData) {
               this.availablePnicsData = availablePnicsData;
            }
         };
      }

      function assignVSwitchSpecDefaults(wizardScope) {
         if (wizardScope.vSwitchSpec.pnics) {
            wizardScope.vSwitchSpec.pnics = null;
         }
         if (wizardScope.vSwitchSpec.pnicsDetails) {
            wizardScope.vSwitchSpec.pnicsDetails = null;
         }

         wizardScope.addPnicPageModel.isInitialized = false;
         wizardScope.addPnicToDvsPageModel.isInitialized = false;
      }

   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Manages the state of the pages in addNetworkingWizard i.e. when they are added/removed to/from the toc.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('addNetworkingFlowManager', AddNetworkingFlowManager);

   AddNetworkingFlowManager.$inject = [
      'vuiConstants',
      'addNetworkingWizardConstants',
      'networkUiConstants',
      'pageStateManagementService',
      'featureFlagsService'];

   function AddNetworkingFlowManager(vuiConstants,
                                     addNetworkingWizardConstants,
                                     networkUiConstants,
                                     pageStateManagementService,
                                     featureFlagsService) {
      var pages;

      this.initFlowManager = function (wizardScope) {
         pages = wizardScope.wizardConfig.pages;

         pageStateManagementService.registerWizardForDefaultStateManagementStrategy(wizardScope);

         wizardScope.$watchGroup([
                  'selectConnectionTypePageModel.connectionType',
                  'selectTargetNetworkPageModel.targetType',
                  'portPropertiesPageModel.ipSettingsType',
                  'addNetworkingSpec.selectedStandardSwitch',
                  'selectTargetNetworkPageModel.isOpaqueNetworkSelected'],
               function (newValues) {
                  updatePagesVisibility.apply(null, newValues);
               });
      };

      function updatePagesVisibility(
            connectionType,
            targetType,
            ipSettingsType,
            selectedStandardSwitch,
            isOpaqueNetworkSelected) {
         var pages = addNetworkingWizardConstants.pages;

         var isNewStandardSwitchSelected = targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH;

         togglePageVisibility(pages.CREATE_STANDARD_SWITCH, isNewStandardSwitchSelected);

         //VM Kernel adapter workflow
         var isVmkernelType = connectionType ===
               addNetworkingWizardConstants.connectionType.VMKERNEL;

         var isIpv4PageVisible = isVmkernelType &&
               ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V6;

         var isIpv6PageVisible = isVmkernelType &&
               ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V4;

         var isBindToPnicPageVisible = isOpaqueNetworkSelected &&
               targetType === addNetworkingWizardConstants.targetType.EXISTING_NETWORK;

         togglePageVisibility(pages.IPV4_SETTINGS, isIpv4PageVisible);
         togglePageVisibility(pages.IPV6_SETTINGS, isIpv6PageVisible);
         togglePageVisibility(pages.PORT_PROPERTIES, isVmkernelType);
         togglePageVisibility(pages.BIND_TO_PNIC, isBindToPnicPageVisible);

         //VM Portgroup workflow
         var isPortgroupType = connectionType ===
               addNetworkingWizardConstants.connectionType.VM_PORTGROUP;

         togglePageVisibility(pages.CONNECTION_SETTINGS, isPortgroupType);

         //Pnic workflow
         var isPnicType =
               connectionType === addNetworkingWizardConstants.connectionType.PNIC;

         var isStandardSwitchSelected =
               isStandardSwitch(selectedStandardSwitch);

         var isExistingStandardSwitchOnPnicSelected =
               isPnicType && !isNewStandardSwitchSelected && isStandardSwitchSelected;

         var isDVSOnPnicSelected =
               isPnicType && !isNewStandardSwitchSelected && !isStandardSwitchSelected;

         togglePageVisibility(pages.ADD_PNIC, isExistingStandardSwitchOnPnicSelected);
         togglePageVisibility(pages.ADD_PNIC_DVS, isDVSOnPnicSelected);
      }

      function isStandardSwitch(selectedStandardSwitch) {
         //assume it's standard if selectedStandardSwitch is still not initialized.
         var isStandardSwitchSelected = true;
         if (selectedStandardSwitch) {
            isStandardSwitchSelected = selectedStandardSwitch.type
                  === networkUiConstants.switchType.STANDARD;
         }
         return isStandardSwitchSelected;
      }

      function togglePageVisibility(pageId, isVisible) {
         var page = _.findWhere(pages, { id: pageId });
         if (isVisible) {
            // change the state to DISABLED only if the page is currently invisible.
            if (page.state === vuiConstants.wizard.pageState.SKIPPED) {
               page.state = vuiConstants.wizard.pageState.DISABLED;
            }
         } else {
            page.state = vuiConstants.wizard.pageState.SKIPPED;
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Defines the pages used in addNetworkingWizard
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('addNetworkingPages', AddNetworkingPages);

   AddNetworkingPages.$inject = [
      'addNetworkingWizardConstants',
      'selectTargetNetworkPageValidator',
      'addHostNetworkingAddPnicPageValidator',
      'addPnicToDvsPageValidator',
      'portPropertiesPageValidator',
      'addHostNetworkingCreateStandardSwitchPageValidator',
      'connectionSettingsPageValidator',
      'ipv4SettingsPageValidator',
      'ipv6SettingsPageValidator',
      'i18nService',
      'vuiConstants',
      'bindToPnicPageValidator',
      'featureFlagsService',
      '$q'
   ];

   function AddNetworkingPages(addNetworkingWizardConstants,
                               selectTargetNetworkPageValidator,
                               addHostNetworkingAddPnicPageValidator,
                               addPnicToDvsPageValidator,
                               portPropertiesPageValidator,
                               addHostNetworkingCreateStandardSwitchPageValidator,
                               connectionSettingsPageValidator,
                               ipv4SettingsPageValidator,
                               ipv6SettingsPageValidator,
                               i18nService,
                               vuiConstants,
                               bindToPnicPageValidator,
                               featureFlagsService,
                               $q) {

      /**
       * Creates an array with page definitions for all pages in add networking wizard.
       */
      this.createWizardPages = function (wizardScope) {
         var selectConnectionTypePage = {
            id: addNetworkingWizardConstants.pages.SELECT_CONNECTION_TYPE,
            title: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.conTypePage.title'),
            description: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.conTypePage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/' +
            'pages/selectConnectionTypePage.html',
            validationParams: [
               'selectConnectionTypePageModel.connectionType'
            ],
            onCommit: function () {
               wizardScope.wizardConfig.currentPage.state =
                     vuiConstants.wizard.pageState.COMPLETED;
               return true;
            }
         };

         var selectTargetNetworkPage = {
            id: addNetworkingWizardConstants.pages.SELECT_TARGET_TYPE,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.conTargetPage.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.conTargetPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/SelectTargetNetworkPage.html',
            validationParams: [
               'hostCapability',
               'selectTargetNetworkPageModel.targetType',
               'addNetworkingSpec.selectedStandardSwitch',
               'addNetworkingSpec.selectedNetwork',
               'vSwitchSpec.mtu',
               'vSwitchSpec.numPorts'
            ],
            validationFunction: function () {
               return selectTargetNetworkPageValidator.getValidationErrors(wizardScope);
            }
         };

         var addPnicPage = {
            id: addNetworkingWizardConstants.pages.ADD_PNIC,
            title: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.physicalNicPage.title'),
            description: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.physicalNicPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/' +
            'pages/addPnicPage.html',
            validationParams: ['vSwitchSpec.pnics.active',
               'vSwitchSpec.pnics.standby',
               'vSwitchSpec.pnics.unused'],
            validationFunction: function () {
               return addHostNetworkingAddPnicPageValidator
                     .getValidationErrorsAndWarnings(
                           wizardScope.vSwitchSpec.pnics,
                           wizardScope.vSwitchSpec.pnicsDetails);
            }
         };

         var addPnicToDvsPage = {
            id: addNetworkingWizardConstants.pages.ADD_PNIC_DVS,
            title: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.physicalNicPage.title'),
            description: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.physicalNicPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/' +
            'pages/addPnicToDvsPage.html',
            validationParams: [
               'addPnicToDvsPageModel.portMapping.addedMappings'
            ],
            validationFunction: addPnicToDvsPageValidator.getValidationErrors
         };

         var createStandardSwitchPage = {
            id: addNetworkingWizardConstants.pages.CREATE_STANDARD_SWITCH,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.newSwitchPage.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.newSwitchPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/CreateStandardSwitchPage.html',
            defaultState: vuiConstants.wizard.pageState.SKIPPED,
            validationParams: ['vSwitchSpec.pnics.active.length',
               'vSwitchSpec.pnics.standby.length',
               'vSwitchSpec.pnics.unused.length'],
            validationFunction: function () {
               return addHostNetworkingCreateStandardSwitchPageValidator
                     .getValidationErrorsAndWarnings(
                           wizardScope.vSwitchSpec.pnics,
                           wizardScope.vSwitchSpec.pnicsDetails);
            }
         };

         var connectionSettingsPage = {
            id: addNetworkingWizardConstants.pages.CONNECTION_SETTINGS,
            title: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.vmNetworkingPage.title'),
            description: i18nService.getString(
                  'NetworkUi', 'AddNetworkingWizard.vmNetworkingPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/' +
            'pages/connectionSettingsPage.html',
            validationParams: [
               'hostId',
               'addNetworkingSpec.networkLabel',
               'addNetworkingSpec.vlanId'
            ],
            validationFunction: connectionSettingsPageValidator.getValidationErrors
         };

         var portPropertiesPage = {
            id: addNetworkingWizardConstants.pages.PORT_PROPERTIES,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.portPropPage.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.portPropPage.descVmkernel'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/PortPropertiesPage.html',
            validationParams: [
               'hostId',
               'addNetworkingSpec.networkLabel',
               'selectTargetNetworkPageModel.targetType',
               'addNetworkingSpec.vlanId',
               'addNetworkingSpec.mtuSelectedType',
               'addNetworkingSpec.mtu',
               'addNetworkingSpec.netStackName.stackName'
            ],
            validationFunction: function () {
               var netStackInstanceKey;
               if (wizardScope.addNetworkingSpec.isTcpIpStackSupported) {
                  netStackInstanceKey =
                        wizardScope.addNetworkingSpec.netStackName.netStackInstanceKey;
               }

               return $q.when(portPropertiesPageValidator.getValidationErrorsAndWarnings(
                     wizardScope.hostId,
                     wizardScope.addNetworkingSpec.networkLabel,
                     wizardScope.selectTargetNetworkPageModel.targetType,
                     wizardScope.addNetworkingSpec.vlanId,
                     wizardScope.addNetworkingSpec.mtuSelectedType,
                     wizardScope.addNetworkingSpec.mtu,
                     netStackInstanceKey))
                     .then(function (result) {
                        return result;
                     });
            }
         };

         var ipv4SettingsPage = {
            id: addNetworkingWizardConstants.pages.IPV4_SETTINGS,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.ipv4Settings.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.ipv4Settings.descVmkernel'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/Ipv4SettingsPage.html',
            validationParams: [
               'hostId',
               'addNetworkingSpec.dhcpEnabled',
               'addNetworkingSpec.ipv4Address',
               'addNetworkingSpec.subnetMask',
               'addNetworkingSpec.overrideGateway',
               'addNetworkingSpec.ipv4DefaultGateway'
            ],
            validationFunction: function () {
               // Trigger ipv4Page's inputs inline validations
               wizardScope.ipv4SettingsPageModel.validateIpAddress();
               wizardScope.ipv4SettingsPageModel.validateSubnetMask();

               if (wizardScope.addNetworkingSpec.isGatewayFeatureSupported
                     && wizardScope.addNetworkingSpec.overrideGateway) {
                  wizardScope.ipv4SettingsPageModel.validateIpv4DefaultGateway();
               }

               var validationData = {
                  hostId: wizardScope.hostId,
                  dhcpEnabled: wizardScope.addNetworkingSpec.dhcpEnabled,
                  ipv4Address: wizardScope.addNetworkingSpec.ipv4Address,
                  subnetMask: wizardScope.addNetworkingSpec.subnetMask,
                  isGatewayFeatureSupported: wizardScope.addNetworkingSpec.isGatewayFeatureSupported,
                  overrideGateway: wizardScope.addNetworkingSpec.overrideGateway,
                  ipv4DefaultGateway: wizardScope.addNetworkingSpec.ipv4DefaultGateway
               };

               return ipv4SettingsPageValidator.getValidationErrors(validationData);
            }
         };

         var ipv6SettingsPage = {
            id: addNetworkingWizardConstants.pages.IPV6_SETTINGS,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.ipv6Settings.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.ipv6Settings.descVmkernel'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/Ipv6SettingsPage.html',
            validationParams: [
               'addNetworkingSpec.ipv6DhcpEnabled',
               'addNetworkingSpec.routerAdvertisementEnabled',
               'addNetworkingSpec.staticAddressesEnabled',
               'addNetworkingSpec.ipv6Addresses.length',
               'addNetworkingSpec.overrideIpv6Gateway',
               'addNetworkingSpec.ipv6DefaultGateway',
               function (wizardScope) {
                  if (wizardScope.addNetworkingSpec && wizardScope.addNetworkingSpec.ipv6Addresses) {
                     var ipv6AddressesMap = _.map(wizardScope.addNetworkingSpec.ipv6Addresses, function (ipv6Address) {
                        return ipv6Address.address + ipv6Address.prefixLength;
                     });
                     return ipv6AddressesMap.toString();
                  }
               }
            ],
            validationFunction: function () {
               // Trigger ipv6Page's inputs inline validation
               if (wizardScope.addNetworkingSpec.isGatewayFeatureSupported
                     && wizardScope.addNetworkingSpec.overrideIpv6Gateway) {
                  wizardScope.ipv6SettingsPageModel.validateIpv6DefaultGateway();
               }

               return ipv6SettingsPageValidator.getValidationErrors(
                     wizardScope.addNetworkingSpec.ipv6DhcpEnabled,
                     wizardScope.addNetworkingSpec.routerAdvertisementEnabled,
                     wizardScope.addNetworkingSpec.staticAddressesEnabled,
                     wizardScope.addNetworkingSpec.ipv6Addresses.length,
                     wizardScope.addNetworkingSpec.overrideIpv6Gateway,
                     wizardScope.addNetworkingSpec.ipv6DefaultGateway);
            }
         };

         var bindToPnicPage = {
            id: addNetworkingWizardConstants.pages.BIND_TO_PNIC,
            title: i18nService.getString('NetworkUi', 'AddNetworkingWizard.physicalNicBindingPage.title'),
            description: i18nService.getString('NetworkUi', 'AddNetworkingWizard.physicalNicBindingPage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/BindToPhysicalAdapterPage.html',
            validationParams: [
               'bindPnicPageModel.bindToPnic',
               'bindPnicPageModel.selectedPnic'],
            validationFunction: bindToPnicPageValidator.getValidationErrors
         };

         var readyToCompletePage = {
            id: addNetworkingWizardConstants.pages.RTC,
            title: i18nService.getString(
                  'H5NetworkUi', 'AddNetworkingWizard.readyToCompletePage.title'),
            description: i18nService.getString(
                  'H5NetworkUi', 'AddNetworkingWizard.readyToCompletePage.description'),
            contentUrl: 'network-ui/resources/network/views/host/addnetworking/pages/ReadyToCompletePage.html'
         };

         var pages = [
            selectConnectionTypePage,
            selectTargetNetworkPage,
            addPnicPage,
            addPnicToDvsPage,
            createStandardSwitchPage,
            connectionSettingsPage,
            portPropertiesPage,
            ipv4SettingsPage,
            ipv6SettingsPage,
            bindToPnicPage,
            readyToCompletePage
         ];

         return pages;
      };
   }
})();
(function () {
   'use strict';

   /**
    * Provides methods for creating mutation spcifications that can be sent
    * by Add Networking wizard.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .factory('addNetworkingSpecificationFactory',
               addNetworkingSpecificationFactory);

   addNetworkingSpecificationFactory.$inject = [
      '$q',
      'addNetworkingWizardConstants',
      'dataService',
      'defaultUriSchemeUtil',
      'networkUiConstants'];

   function addNetworkingSpecificationFactory($q,
                                              addNetworkingWizardConstants,
                                              dataService,
                                              defaultUriSchemeUtil) {
      return {
         createNewPortgroupSpec: createNewPortgroupSpec,
         createNewPnicToExistingStandardSwitchSpec: createNewPnicToExistingStandardSwitchSpec,
         createNewPnicToNewStandardSwitchSpec: createNewPnicToNewStandardSwitchSpec,
         createNewPnicToDistributedSwitchSpec: createNewPnicToDistributedSwitchSpec,
         createNewVnicSpec: createNewVnicSpec
      };

      function createNewPnicToExistingStandardSwitchSpec(addNetworkingSpec, vSwitchSpec) {
         var pnicSpec = new HostPnicAddSpec();

         var nicOrder = getNicOrder(vSwitchSpec.pnics);
         pnicSpec.activeNic = nicOrder.activeNic;
         pnicSpec.standbyNic = nicOrder.standbyNic;
         pnicSpec.bridge = nicOrder.bridge;

         pnicSpec.vSwitchName = addNetworkingSpec.selectedStandardSwitch.name;

         return pnicSpec;
      }
      function createNewPnicToNewStandardSwitchSpec(vSwitchSpec) {
         var vSwitchConfig = buildVswitchConfig(vSwitchSpec);
         var networkConfig = new NetworkConfig();
         networkConfig.vswitch.push(vSwitchConfig);
         return new HostNetworkingAddSpec(networkConfig);
      }

      function createNewPnicToDistributedSwitchSpec(uplinkMappings, selectedStandardSwitch) {
         return new UpdateProxySwitchUplinkMappingSpec(uplinkMappings, selectedStandardSwitch.key);
      }

      /**
       * @param addNetworkingSpec
       *    User generated networking spec created via Add Networking wizard.
       * @param vSwitchSpec
       *    User generated spec for new standard switch
       * @param targetType
       *    Selected target type
       */
      function createNewPortgroupSpec(addNetworkingSpec, vSwitchSpec, targetType) {
         var networkConfig = buildNetworkConfig(addNetworkingSpec, vSwitchSpec, targetType);

         return new HostNetworkingAddSpec(networkConfig);
      }

      function createNewVnicSpec(addNetworkingSpec, vSwitchSpec, ipSettingsType, targetType, pinnedPnicData) {
         var virtualNicConfig = new VirtualNicConfig(addNetworkingSpec.mtu,
               addNetworkingSpec.netStackInstanceKey);

         virtualNicConfig.spec.ip = buildIpConfig(ipSettingsType, addNetworkingSpec);
         virtualNicConfig.spec.ipRouteSpec = buildIpRouteSpec(ipSettingsType,
               addNetworkingSpec);

         if (targetType === addNetworkingWizardConstants.targetType.EXISTING_NETWORK) {
            return buildVirtualNicAddSpec(virtualNicConfig, addNetworkingSpec, addNetworkingSpec.selectedNetwork, pinnedPnicData);

         } else if (targetType === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH ||
               targetType === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {

            virtualNicConfig.portgroup = addNetworkingSpec.networkLabel;

            var networkConfig = buildNetworkConfig(addNetworkingSpec, vSwitchSpec, targetType);
            networkConfig.vnic.push(virtualNicConfig);

            var hostNetworkingAddSpec = new HostNetworkingAddSpec(networkConfig);

            disableServicesForNonDefaultStack(addNetworkingSpec);

            hostNetworkingAddSpec.vmkernelSettingsSpec = addNetworkingSpec.vmkernelSettingsSpec;

            return $q.when(hostNetworkingAddSpec);
         }
      }

      function buildNetworkConfig(addNetworkingSpec, vSwitchSpec, targetType) {
         var networkConfig = new NetworkConfig();
         var portgroupConfig;

         if (targetType === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {
            portgroupConfig = new PortGroupConfig(addNetworkingSpec.networkLabel,
                  addNetworkingSpec.selectedStandardSwitch.name,
                  addNetworkingSpec.vlanId);
         } else if (targetType === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
            var vSwitchConfig = buildVswitchConfig(vSwitchSpec);
            networkConfig.vswitch.push(vSwitchConfig);

            portgroupConfig = new PortGroupConfig(addNetworkingSpec.networkLabel, vSwitchSpec.name, addNetworkingSpec.vlanId);
         }

         networkConfig.portgroup.push(portgroupConfig);
         return networkConfig;
      }

      function buildVirtualNicAddSpec(virtualNicConfig, addNetworkingSpec, selectedNetwork, pinnedPnicData) {

         disableServicesForNonDefaultStack(addNetworkingSpec);

         var virtualNicAddSpec = new VirtualNicAddSpec(virtualNicConfig,
               addNetworkingSpec.vmkernelSettingsSpec);
         if (selectedNetwork.isDistributedPortgroup) {
            return dataService.getData(
                  defaultUriSchemeUtil.getVsphereObjectId(selectedNetwork.networkRef),
                  'com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupTargetData'
            ).then(function (dvPortGroupData) {

               virtualNicConfig.spec.distributedVirtualPort =
                     new DistributedVirtualPort(dvPortGroupData.key, dvPortGroupData.dvSwitchUuid);

               return virtualNicAddSpec;
            });
         } else if (selectedNetwork.isOpaqueNetwork) {
            return dataService.getData(
                  defaultUriSchemeUtil.getVsphereObjectId(selectedNetwork.networkRef),
                  'com.vmware.vsphere.client.h5.network.opaquenetwork.model.OpaqueNetworkTargetData'
            ).then(function (opaqueNetworkData) {
               // The vnic will connect to an opaque network
               virtualNicConfig.spec.opaqueNetwork =
                     new OpaqueNetworkSpec(opaqueNetworkData.opaqueNetworkId, opaqueNetworkData.opaqueNetworkType);

               if (pinnedPnicData && pinnedPnicData.bindToPnic && pinnedPnicData.selectedPnic) {
                  virtualNicConfig.spec.pinnedPnic = pinnedPnicData.selectedPnic;
               }

               return virtualNicAddSpec;
            });
         }
      }

      function buildIpv6AddressesConfig(ipv6Addresses) {
         var ipv6AddressesConfig = [];

         _.forEach(ipv6Addresses, function (ipv6) {
            var ipv6Address = new IpV6Address(ipv6.address, ipv6.prefixLength);
            ipv6AddressesConfig.push(ipv6Address);
         });

         return ipv6AddressesConfig;
      }

      function buildIpConfig(ipSettingsType, addNetworkingSpec) {
         var ipConfig = new IpConfig();

         var isIpv4Enabled =
               ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V6;
         var isIpv6Enabled =
               ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V4;

         if (isIpv4Enabled) {
            ipConfig.dhcp = addNetworkingSpec.dhcpEnabled;
            if (!addNetworkingSpec.dhcpEnabled) {
               ipConfig.ipAddress = addNetworkingSpec.ipv4Address;
               ipConfig.subnetMask = addNetworkingSpec.subnetMask;
            }
         }

         if (isIpv6Enabled) {
            ipConfig.ipV6Config = new IpV6AddressConfiguration(addNetworkingSpec.ipv6DhcpEnabled,
                        addNetworkingSpec.routerAdvertisementEnabled);
            if (addNetworkingSpec.staticAddressesEnabled) {
               ipConfig.ipV6Config.ipV6Address =
                     buildIpv6AddressesConfig(addNetworkingSpec.ipv6Addresses);
            }
         }

         return ipConfig;
      }

      function buildIpRouteSpec(ipSettingsType, addNetworkingSpec) {
         if (!addNetworkingSpec.isGatewayFeatureSupported) {
            return null;
         }

         var ipRouteSpec = new IpRouteSpec();

         var isIpv4GatewaySet = !addNetworkingSpec.dhcpEnabled
               && addNetworkingSpec.overrideGateway;
         var isIpv6GatewaySet = addNetworkingSpec.staticAddressesEnabled
               && addNetworkingSpec.overrideIpv6Gateway;

         // default gateway is set only if the property is set by the user
         if (ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V6
               && isIpv4GatewaySet) {
            ipRouteSpec.ipRouteConfig.defaultGateway = addNetworkingSpec.ipv4DefaultGateway;
         }

         if (ipSettingsType !== addNetworkingWizardConstants.ipSettingsMode.IP_V4
               && isIpv6GatewaySet) {
            ipRouteSpec.ipRouteConfig.ipV6DefaultGateway = addNetworkingSpec.ipv6DefaultGateway;
         }

         return ipRouteSpec;
      }

      function buildVswitchConfig(vSwitchSpec) {
         var vSwitchConfig = new VirtualSwitchConfig(vSwitchSpec.name, vSwitchSpec.mtu, vSwitchSpec.numPorts);

         var nicOrder = getNicOrder(vSwitchSpec.pnics);

         vSwitchConfig.spec.policy.nicTeaming.nicOrder.activeNic = nicOrder.activeNic;
         vSwitchConfig.spec.policy.nicTeaming.nicOrder.standbyNic = nicOrder.standbyNic;

         if (nicOrder.bridge) {
            vSwitchConfig.spec.bridge = nicOrder.bridge;
         }

         return vSwitchConfig;
      }

      function disableServicesForNonDefaultStack(addNetworkingSpec) {
         if (!!addNetworkingSpec.netStackInstanceKey &&
               addNetworkingSpec.netStackInstanceKey !==
               addNetworkingWizardConstants.defaultNetStackKey) {
            addNetworkingSpec.vmkernelSettingsSpec
                  .isVmotionEnabled = false;
            addNetworkingSpec.vmkernelSettingsSpec
                  .isProvisioningNfcTrafficEnabled = false;
         }
      }

      function getNicOrder(pnics) {
         var nicOrder = {};

         var activeNic = pnics.active;
         nicOrder.activeNic = activeNic;

         var standbyNic = pnics.standby;
         nicOrder.standbyNic = standbyNic;

         var unusedNics = pnics.unused;

         var allNics = [];
         allNics = allNics.concat(activeNic, standbyNic, unusedNics);

         if (allNics.length > 0) {
            nicOrder.bridge = new BondBridge(allNics);
         }

         return nicOrder;
      }

      function VirtualSwitchConfig(vSwitchName, mtu, numPorts) {
         this._type = 'com.vmware.vim.binding.vim.host.VirtualSwitch$Config';
         this.name = vSwitchName;
         this.changeOperation = 'add';
         this.spec = {};
         this.spec._type = 'com.vmware.vim.binding.vim.host.VirtualSwitch$Specification';
         this.spec.mtu = mtu;
         this.spec.numPorts = numPorts;
         this.spec.bridge = null;

         this.spec.policy = {};
         this.spec.policy._type = 'com.vmware.vim.binding.vim.host.NetworkPolicy';

         this.spec.policy.nicTeaming = {};
         this.spec.policy.nicTeaming._type = 'com.vmware.vim.binding.vim.host.NetworkPolicy$NicTeamingPolicy';

         this.spec.policy.nicTeaming.nicOrder = {};
         this.spec.policy.nicTeaming.nicOrder._type = 'com.vmware.vim.binding.vim.host.NetworkPolicy$NicOrderPolicy';
         this.spec.policy.nicTeaming.nicOrder.activeNic = [];
         this.spec.policy.nicTeaming.nicOrder.standbyNic = [];
      }

      function HostNetworkingAddSpec(networkConfig) {
         this._type = 'com.vmware.vsphere.client.network.HostNetworkingAddSpec';
         this.networkConfig = networkConfig;
      }

      function NetworkConfig() {
         this._type = 'com.vmware.vim.binding.vim.host.NetworkConfig';
         this.vnic = [];
         this.portgroup = [];
         this.vswitch = [];
      }

      function PortGroupConfig(networkLabel, vSwitchName, vlanId) {
         this._type = 'com.vmware.vim.binding.vim.host.PortGroup$Config';
         this.changeOperation = 'add';

         this.spec = {};
         this.spec._type = 'com.vmware.vim.binding.vim.host.PortGroup$Specification';
         this.spec.name = networkLabel.trim();
         this.spec.vlanId = vlanId;
         this.spec.vswitchName = vSwitchName;

         this.spec.policy = {};
         this.spec.policy._type = 'com.vmware.vim.binding.vim.host.NetworkPolicy';

      }

      function BondBridge(nics) {
         this._type = 'com.vmware.vim.binding.vim.host.VirtualSwitch$BondBridge';
         this.nicDevice = nics;
      }

      function VirtualNicConfig(mtu, netStackInstanceKey) {
         this._type = 'com.vmware.vim.binding.vim.host.VirtualNic$Config';
         this.portgroup = null;
         this.spec = {};
         this.spec._type = 'com.vmware.vim.binding.vim.host.VirtualNic$Specification';
         this.spec.ip = null; //buildVnicIpConfig(wizardScope),
         this.spec.ipRouteSpec = null;
         this.spec.mtu = mtu; //wizardScope.addNetworkingSpec.mtu
         this.spec.netStackInstanceKey = netStackInstanceKey; //wizardScope.addNetworkingSpec.netStackName
         this.changeOperation = 'add';
      }

      function VirtualNicAddSpec(virtualNicConfig, vmkernelSettingsSpec) {
         this._type = 'com.vmware.vsphere.client.network.VirtualNicAddSpec';
         this.vnicConfig = virtualNicConfig;
         this.vmkernelSettingsSpec = vmkernelSettingsSpec;
         this.isServiceConsoleVnic = false;
      }

      function IpConfig() {
         this._type = 'com.vmware.vim.binding.vim.host.IpConfig';
         this.dhcp = false;
         this.ipAddress = '';
         this.subnetMask = '';
         this.ipV6Config = null;
      }

      function IpRouteSpec() {
         this._type = 'com.vmware.vim.binding.vim.host.VirtualNic$IpRouteSpec';
         this.ipRouteConfig = {};
         this.ipRouteConfig._type = 'com.vmware.vim.binding.vim.host.IpRouteConfig';
      }

      function IpV6AddressConfiguration(ipv6DhcpEnabled, routerAdvertisementEnabled) {
         this._type = 'com.vmware.vim.binding.vim.host.IpConfig$IpV6AddressConfiguration';
         this.dhcpV6Enabled = ipv6DhcpEnabled;
         this.autoConfigurationEnabled = routerAdvertisementEnabled;
         this.ipV6Address = [];
      }

      function IpV6Address(address, prefixLength) {
         this._type = 'com.vmware.vim.binding.vim.host.IpConfig$IpV6Address';
         this.ipAddress = address;
         this.prefixLength = prefixLength;
         this.operation = 'add';
      }

      function DistributedVirtualPort(key, dvSwitchUuid) {
         this._type = 'com.vmware.vim.binding.vim.dvs.PortConnection';
         this.portgroupKey = key;
         this.switchUuid = dvSwitchUuid;
      }

      function OpaqueNetworkSpec(opaqueNetworkId, opaqueNetworkType) {
         this._type = 'com.vmware.vim.binding.vim.host.VirtualNic$OpaqueNetworkSpec';
         this.opaqueNetworkId = opaqueNetworkId;
         this.opaqueNetworkType = opaqueNetworkType;
      }

      function HostPnicAddSpec() {
         this._type = "com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.HostPnicAddSpec";
      }
      function UpdateProxySwitchUplinkMappingSpec(uplinkPortMappings, proxySwitchKey) {
         this._type = "com.vmware.vsphere.client.h5.network.host.proxyswitch.spec.UpdateProxySwitchUplinkMappingSpec";
         this.uplinkPortMappings = uplinkPortMappings;
         this.proxySwitchKey = proxySwitchKey;
      }
   }
})();

(function () {
   'use strict';

   /**
    * Constants used in Add Networking wizard.
    */
   angular.module('com.vmware.vsphere.client.network')
         .constant('addNetworkingWizardConstants', {
                  connectionType: {
                     VMKERNEL: '0',
                     VM_PORTGROUP: '1',
                     PNIC: '2'
                  },
                  targetType: {
                     EXISTING_NETWORK: 'existingNetwork',
                     EXISTING_STANDARD_SWITCH: 'existingStandardSwitch',
                     NEW_STANDARD_SWITCH: 'newStandardSwitch'
                  },
                  ipSettingsMode: {
                     IP_V4: 'ipv4',
                     IP_V6: 'ipv6',
                     MIXED: 'mixed'
                  },
                  switchType: {
                     STANDARD: 'standardSwitch',
                     DISTRIBUTED: 'distributedSwitch'
                  },
                  pages: {
                     SELECT_CONNECTION_TYPE: "selectConnectionTypePage",
                     SELECT_TARGET_TYPE: "selectTargetNetworkPage",
                     ADD_PNIC: "addPnicPage",
                     ADD_PNIC_DVS: "addPnicToDvsPage",
                     CREATE_STANDARD_SWITCH: "createStandardSwitchPage",
                     CONNECTION_SETTINGS: "addHostNetworkingConnectionSettingsPag",
                     PORT_PROPERTIES: "portPropertiesPag",
                     IPV4_SETTINGS: "addHostNetworkingIpv4SettingsPag",
                     IPV6_SETTINGS: "addHostNetworkingIpv6SettingsPag",
                     BIND_TO_PNIC: "bindToPhysicalAdapterPage",
                     RTC: "addVnicReadyToCompletePage"
                  },
                  defaultNetStackKey: 'defaultTcpipStack',
                  provisioningNetStackKey: 'vSphereProvisioning',
                  vmotionNetStackKey: 'vmotion'
               }
         );
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.network')
         .controller('AddHostNetworkingReadyToCompletePageController',
               AddHostNetworkingReadyToCompletePageController);

   AddHostNetworkingReadyToCompletePageController.$inject = [
         '$scope',
         'addNetworkingWizardConstants',
         'i18nService',
         'vxPropertyViewService',
         'networkUtil',
         'hostVnicServiceFactory',
         'networkUiConstants'];

   function AddHostNetworkingReadyToCompletePageController(
         $scope,
         addNetworkingWizardConstants,
         i18nService,
         propertyViewService,
         networkUtil,
         hostVnicServiceFactory,
         networkUiConstants) {

      switch ($scope.selectConnectionTypePageModel.connectionType) {
         case addNetworkingWizardConstants.connectionType.VMKERNEL :
            buildSummaryForVmkernelConnectionType();
            break;

         case addNetworkingWizardConstants.connectionType.VM_PORTGROUP :
            buildSummaryForVmPortgroupConnectionType();
            break;

         case addNetworkingWizardConstants.connectionType.PNIC :
            buildSummaryForPnicConnectionType();
            break;
      }

      function buildSummaryForVmPortgroupConnectionType() {
         var builder = propertyViewService.createPropertyViewBuilder();
         var generalCategory = builder.category("general");
         var generalSection = generalCategory.section("generalSection");


         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.vmNetworking'),
                  $scope.addNetworkingSpec.networkLabel);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.virtualSwitch'),
                  $scope.addNetworkingSpec.selectedStandardSwitch.name);
         }

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.newVirtualSwitch'),
                  $scope.vSwitchSpec.name);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.vmNetworking'),
                  $scope.addNetworkingSpec.networkLabel);
            generalSection.property(
                  i18nService.getString('NetworkUi',
                        'AddNetworkingWizard.summary.assignedAdapters'),
                  formatPnics($scope.vSwitchSpec.pnics));

            if ($scope.hostCapability.switchAutoScaleSupported === false) {
               generalSection.property(
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.summary.newVirtualSwitch.numPorts'),
                     $scope.vSwitchSpec.numPorts);
            }

            generalSection.property(
                  i18nService.getString(
                        'H5NetworkUi', 'AddNetworkingWizard.summary.switchMtu'),
                  $scope.vSwitchSpec.mtu);

         }
               generalSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.vlanId'),
                     networkUtil.formatVlanId($scope.addNetworkingSpec.vlanId));

         $scope.summaryData = builder.build();
      }

      function buildSummaryForVmkernelConnectionType() {
         var builder = propertyViewService.createPropertyViewBuilder();
         var generalCategory = builder.category("general");
         var generalSection = generalCategory.section("generalSection");

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_NETWORK) {
            if ($scope.addNetworkingSpec.selectedNetwork.isDistributedPortgroup) {
               generalSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.dvPortGroup'),
                     $scope.addNetworkingSpec.selectedNetwork.name);

               generalSection.property(
                     i18nService.getString('NetworkUi', 'AddNetworkingWizard.summary.dvs'),
                     $scope.addNetworkingSpec.selectedNetwork.dvsName);
            }
            if ($scope.addNetworkingSpec.selectedNetwork.isOpaqueNetwork) {
               if ($scope.addNetworkingSpec.selectedNetwork.isNsxNetwork) {
                  generalSection.property(
                     i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.nsxOpaqueNetworkName'),
                     $scope.addNetworkingSpec.selectedNetwork.name);
               } else {
                  generalSection.property(
                     i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.opaqueNetworkName'),
                     $scope.addNetworkingSpec.selectedNetwork.name);
               }
            }
         }

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {
            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.newPortgroup'),
                  $scope.addNetworkingSpec.networkLabel);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.virtualSwitch'),
                  $scope.addNetworkingSpec.selectedStandardSwitch.name);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.vlanId'),
                  networkUtil.formatVlanId($scope.addNetworkingSpec.vlanId));
         }

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.newVirtualSwitch'),
                  $scope.vSwitchSpec.name);

            generalSection.property(
                  i18nService.getString('NetworkUi',
                        'AddNetworkingWizard.summary.assignedAdapters'),
                  formatPnics($scope.vSwitchSpec.pnics));

            if ($scope.hostCapability.switchAutoScaleSupported === false) {
               generalSection.property(
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.summary.newVirtualSwitch.numPorts'),
                     $scope.vSwitchSpec.numPorts);
            }

            generalSection.property(
                  i18nService.getString(
                        'H5NetworkUi', 'AddNetworkingWizard.summary.switchMtu'),
                  $scope.vSwitchSpec.mtu);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.newPortgroup'),
                  $scope.addNetworkingSpec.networkLabel);

            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.vlanId'),
                  networkUtil.formatVlanId($scope.addNetworkingSpec.vlanId));

         }

         var serviceSettings = hostVnicServiceFactory
               .pickServiceSettings($scope.addNetworkingSpec.vmkernelSettingsSpec);
         var serviceDescriptions = hostVnicServiceFactory
               .getServiceDescriptions($scope.portPropertiesPageModel.hostVnicFeatures);

         _.forEach(serviceSettings, function(value, key) {
            var serviceData = serviceDescriptions[key];
            generalSection.property(serviceData.summaryLabel, formatEnabledValue(value));
         });

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_NETWORK
               && $scope.addNetworkingSpec.selectedNetwork.isOpaqueNetwork
               && $scope.bindPnicPageModel.bindToPnic
               && $scope.bindPnicPageModel.selectedPnic) {
            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.boundPnic'),
                  $scope.bindPnicPageModel.selectedPnic);

         }

         var nicSettingsSection =
               generalCategory
                     .section('nicSettings')
                     .title(i18nService.getString(
                           'H5NetworkUi', 'AddNetworkingWizard.summary.nicSettings'));

         nicSettingsSection.property(
               i18nService.getString('H5NetworkUi', 'AddNetworkingWizard.summary.mtu'),
               $scope.addNetworkingSpec.mtu
         );

         if ($scope.addNetworkingSpec.netStackName
               && $scope.addNetworkingSpec.netStackName.stackName) {
            nicSettingsSection.property(
                  i18nService.getString('H5NetworkUi', 'AddNetworkingWizard.summary.netStack'),
                  $scope.addNetworkingSpec.netStackName.stackName
            );
         }

         // IPv4 Section
         if ($scope.portPropertiesPageModel.ipSettingsType
               === addNetworkingWizardConstants.ipSettingsMode.IP_V4
               || $scope.portPropertiesPageModel.ipSettingsType
               === addNetworkingWizardConstants.ipSettingsMode.MIXED) {
            var ipSettingsSection =
                  generalCategory
                        .section('ipv4Settings')
                        .title(i18nService.getString(
                              'NetworkUi', 'AddNetworkingWizard.summary.ipv4Settings'));

            if ($scope.addNetworkingSpec.dhcpEnabled) {
               ipSettingsSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.ipv4Dhcp'),
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.enabled'));
            } else {
               ipSettingsSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.ipv4Address'),
                     i18nService.getString(
                           'H5NetworkUi',
                           'AddNetworkingWizard.readyToCompletePage.staticIpAddressFormat',
                           $scope.addNetworkingSpec.ipv4Address));

               ipSettingsSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.subnetMask'),
                     $scope.addNetworkingSpec.subnetMask);

               if ($scope.addNetworkingSpec.overrideGateway) {
                  ipSettingsSection.property(
                        i18nService.getString(
                              'NetworkUi', 'AddNetworkingWizard.summary.ipv4Gateway'),
                        $scope.addNetworkingSpec.ipv4DefaultGateway);
               }
            }
         }

         // IPv6 Section
         if ($scope.portPropertiesPageModel.ipSettingsType
               === addNetworkingWizardConstants.ipSettingsMode.IP_V6
               || $scope.portPropertiesPageModel.ipSettingsType
               === addNetworkingWizardConstants.ipSettingsMode.MIXED) {
            var ipv6SettingsSection =
                  generalCategory
                        .section('ipv6Settings')
                        .title(i18nService.getString(
                              'NetworkUi', 'AddNetworkingWizard.summary.ipv6Settings'));

            ipv6SettingsSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.ipv6Dhcp'),
                  formatEnabledValue($scope.addNetworkingSpec.ipv6DhcpEnabled));

            ipv6SettingsSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.routerAdv'),
                  formatEnabledValue($scope.addNetworkingSpec.routerAdvertisementEnabled));

            if($scope.addNetworkingSpec.staticAddressesEnabled
                  && $scope.addNetworkingSpec.ipv6Addresses.length > 0) {

               ipv6SettingsSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.ipv6Addresses'),
                     formatIpv6Addresses($scope.addNetworkingSpec.ipv6Addresses));

               if ($scope.addNetworkingSpec.overrideIpv6Gateway) {
                  ipv6SettingsSection.property(
                        i18nService.getString(
                              'NetworkUi', 'AddNetworkingWizard.summary.ipv6Gateway'),
                        $scope.addNetworkingSpec.ipv6DefaultGateway);
               }
            }
         }

         $scope.summaryData = builder.build();
      }

      function buildSummaryForPnicConnectionType() {
         var builder = propertyViewService.createPropertyViewBuilder();
         var generalCategory = builder.category("general");
         var generalSection = generalCategory.section("generalSection");

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
            generalSection.property(
                  i18nService.getString(
                        'NetworkUi', 'AddNetworkingWizard.summary.newVirtualSwitch'),
                  $scope.vSwitchSpec.name);

            generalSection.property(
                  i18nService.getString('NetworkUi',
                        'AddNetworkingWizard.summary.assignedAdapters'),
                  formatPnics($scope.vSwitchSpec.pnics));

            if ($scope.hostCapability.switchAutoScaleSupported === false) {
               generalSection.property(
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.summary.newVirtualSwitch.numPorts'),
                     $scope.vSwitchSpec.numPorts);
            }

            generalSection.property(
                  i18nService.getString(
                        'H5NetworkUi', 'AddNetworkingWizard.summary.switchMtu'),
                  $scope.vSwitchSpec.mtu);
         } else if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {
            if ($scope.addNetworkingSpec.selectedStandardSwitch.type
                  === networkUiConstants.switchType.STANDARD) {

               generalSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.virtualSwitch'),
                     $scope.addNetworkingSpec.selectedStandardSwitch.name);

               generalSection.property(
                     i18nService.getString('NetworkUi',
                           'AddNetworkingWizard.summary.assignedAdapters'),
                     formatNewPnics(getNewPnics($scope.vSwitchSpec.pnics)));
            } else if ($scope.addNetworkingSpec.selectedStandardSwitch.type
                  === networkUiConstants.switchType.DISTRIBUTED) {

               generalSection.property(
                     i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.summary.dvs'),
                     $scope.addNetworkingSpec.selectedStandardSwitch.name);

               generalSection.property(
                     i18nService.getString('NetworkUi',
                           'AddNetworkingWizard.summary.assignedAdapters'),
                     formatNewPnics(_.values($scope.addPnicToDvsPageModel.portMapping.addedMappings)));
            }
         }
         $scope.summaryData = builder.build();
      }

      function formatEnabledValue(isEnabled) {
         return i18nService.getString('NetworkUi',
               isEnabled ? 'AddNetworkingWizard.summary.enabled'
                     : 'AddNetworkingWizard.summary.disabled');
      }

      function formatIpv6Addresses(ipv6Addresses) {
         return _.map(ipv6Addresses, function (ipv6) {
            return ipv6.address + '/' + ipv6.prefixLength + ' ' +
                  i18nService.getString('NetworkUi', 'VnicView.ipAddrStaticTypeFormat');
         });
      }

      function formatPnics(pnics) {
         var result = [];

         if (pnics) {
            if (pnics.active && pnics.active.length > 0) {
               result = result.concat(pnics.active);
            }
            if (pnics.standby && pnics.standby.length > 0) {
               result = result.concat(pnics.standby);
            }
            if (pnics.unused && pnics.unused.length > 0) {
               result = result.concat(pnics.unused);
            }
         }

         return result.length > 0
            ? result.join(', ')
            : i18nService.getString('NetworkUi', 'AddNetworkingWizard.summary.noData');
      }

      function formatNewPnics(pnics) {
         return pnics.join(', ');
      }

      function getNewPnics(pnics) {
         var newPnics = [];
         newPnics.push.apply(newPnics, _.filter(pnics.active, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         }));

         newPnics.push.apply(newPnics, _.filter(pnics.standby, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         }));

         newPnics.push.apply(newPnics, _.filter(pnics.unused, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         }));
         return newPnics;
      }
      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .controller('AddPnicPageController', AddPnicPageController);

   AddPnicPageController.$inject = [
      '$scope',
      'i18nService',
      'physicalAdaptersListService'];

   function AddPnicPageController($scope, i18nService, physicalAdaptersListService) {

      $scope.noItemsSelectedMessage = i18nService.getString('NetworkUi',
            'FailoverOrderEditor.detailsPrompt');

      $scope.headerOptions = {
         title: i18nService.getString('NetworkUi', 'FailoverOrderEditor.failoverOrder')
      };

      if (!$scope.addPnicPageModel.isInitialized) {
         initFailoverOrderSettings();
      } else {
         $scope.failoverOrder = createFailoverOrderSettings(
               $scope.vSwitchSpec.pnics,
               $scope.vSwitchSpec.pnicsDetails);
      }

      function createFailoverOrderSettings(connectees, contecteesDetails) {
         return {
            connectees: connectees,
            connecteesDetails: contecteesDetails,
            labels: {
               active: i18nService.getString('NetworkUi', 'FailoverOrderEditor.active'),
               standby: i18nService.getString('NetworkUi', 'FailoverOrderEditor.standby'),
               unused: i18nService.getString('NetworkUi', 'FailoverOrderEditor.unused')
            }
         };
      }

      function initFailoverOrderSettings() {
         $scope.wizardConfig.loading = true;
         $scope.vSwitchSpec.pnics = {
            active: [],
            standby: [],
            unused: [],
            unclaimed: []
         };

         physicalAdaptersListService.getPhysicalAdaptersWithDetails($scope.hostId,
               $scope.addNetworkingSpec.selectedStandardSwitch.name)
               .then(function (data) {
                  $scope.vSwitchSpec.pnics.active = data.active || [];
                  $scope.vSwitchSpec.pnics.standby = data.standby || [];
                  $scope.vSwitchSpec.pnics.unused = data.unused || [];
                  $scope.vSwitchSpec.pnics.unclaimed = data.unclaimed;
                  $scope.vSwitchSpec.pnicsDetails = data.pnicDetails;

                  $scope.failoverOrder = createFailoverOrderSettings(
                        $scope.vSwitchSpec.pnics,
                        $scope.vSwitchSpec.pnicsDetails);
                  $scope.addPnicPageModel.isInitialized = true;
                  $scope.wizardConfig.loading = false;
               });
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .controller('AddPnicToDvsPageController', AddPnicToDvsPageController);

   AddPnicToDvsPageController.$inject = [
      '$scope',
      'i18nService',
      'physicalAdaptersListService'];

   function AddPnicToDvsPageController($scope, i18nService, physicalAdaptersListService) {

      if (!$scope.addPnicToDvsPageModel.isInitialized) {
         initUplinkPortMapping();
      }

      function initUplinkPortMapping() {
         $scope.wizardConfig.loading = true;
         physicalAdaptersListService.getProxySwitchUplinkData($scope.hostId,
               $scope.addNetworkingSpec.selectedStandardSwitch.dvsRef,
               $scope.addNetworkingSpec.selectedStandardSwitch.key)
               .then(function (proxySwitchUplinkData) {

                  $scope.addPnicToDvsPageModel.portMapping = proxySwitchUplinkData;
                  $scope.addPnicToDvsPageModel.portMapping.addedMappings = {};

                  $scope.addPnicToDvsPageModel.isInitialized = true;
                  $scope.wizardConfig.loading = false;
               });
      }

      return this;
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var BindToPhysicalAdapterComponent = (function () {
        function BindToPhysicalAdapterComponent() {
            this.bindings = {
                hostId: "<",
                opaqueNetworkRef: "<?",
                opaqueNetworkId: "<?",
                opaqueNetworkType: "<?",
                bindToPnicEnabled: "<",
                selectedPnicForBinding: "<",
                availablePnicsData: "<",
                onPnicSelectionChange: "&",
                onBindToPnicChange: "&",
                onAvailablePnicsDataChange: "&",
                onLoadingStateUpdate: "&"
            };
            this.controller = BindToPhysicalAdapterController;
            this.templateUrl = "network-ui/resources/network/views/host/addnetworking/pages/BindToPhysicalAdapterComponent.html";
        }
        return BindToPhysicalAdapterComponent;
    }());
    network_ui.BindToPhysicalAdapterComponent = BindToPhysicalAdapterComponent;
    var BindToPhysicalAdapterController = (function () {
        function BindToPhysicalAdapterController(i18nService, vuiConstants, columnRenderersRegistry, dataService, physicalAdaptersListService, physicalAdapterDetailsViewService, $element, bindToPhysicalAdapterService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dataService = dataService;
            this.physicalAdaptersListService = physicalAdaptersListService;
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
            this.$element = $element;
            this.bindToPhysicalAdapterService = bindToPhysicalAdapterService;
            // Private fields
            this.pnicsDetailsData = {};
            this.i18n = this.i18nService.getString;
        }
        BindToPhysicalAdapterController.prototype.$onInit = function () {
            var _this = this;
            this.noItemsSelectedMessage = this.i18nService
                .getString("NetworkUi", "PhysicalNicBindingEditor.detailsPrompt");
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                resizable: true,
                selectedItems: [],
                onChange: this.onSelectionChange.bind(this),
                selectedPnic: null,
                onBindedPnicChange: function () {
                    _this.selectPnicRow();
                }
            };
            this.bindToPnic = this.bindToPnicEnabled;
            this.datagridOptions.selectedPnic = this.selectedPnicForBinding;
            if (this.availablePnicsData) {
                this.datagridOptions.data = this.availablePnicsData;
            }
            this.initPnicSelection = true;
        };
        BindToPhysicalAdapterController.prototype.selectPnic = function (pnicDevice) {
            this.datagridOptions.selectedPnic = pnicDevice;
            this.onPnicSelectionChange({
                selectedPnic: pnicDevice
            });
        };
        BindToPhysicalAdapterController.prototype.selectPnicRow = function () {
            var _this = this;
            if (!this.datagridOptions.selectedPnic) {
                return;
            }
            var grid = this.$element.find('[kendo-grid]').data("kendoGrid");
            if (!grid || !grid.items) {
                return;
            }
            grid.items().each(function (index, row) {
                if (grid.dataItem(row).device === _this.datagridOptions.selectedPnic) {
                    grid.select(row);
                }
            });
        };
        BindToPhysicalAdapterController.prototype.$onChanges = function (changes) {
            if (this.bindToPnic
                && changes.availablePnicsData
                && changes.availablePnicsData.currentValue
                && !changes.availablePnicsData.isFirstChange()) {
                this.datagridOptions.data = changes.availablePnicsData.currentValue;
                this.updatePnicSelection();
            }
        };
        BindToPhysicalAdapterController.prototype.bindToPnicChangeHandler = function () {
            var _this = this;
            this.onBindToPnicChange({
                bindToPnic: this.bindToPnic
            });
            if (this.bindToPnic) {
                if (this.availablePnicsData) {
                    // Make the selected pnic to be the first one by default
                    // or the already chosen one.
                    // Also trigger the callback to update the selected Pnic on wizard's scope.
                    this.updatePnicSelection();
                }
                else {
                    this.onLoadingStateUpdate({
                        loading: true
                    });
                    if (this.opaqueNetworkRef) {
                        this.bindToPhysicalAdapterService.getDataByOpaqueNetworkRef(this.hostId, this.opaqueNetworkRef)
                            .then(function (data) {
                            _this.updateAvailablePnicsData(data);
                        }).finally(function () {
                            _this.onLoadingStateUpdate({
                                loading: false
                            });
                        });
                    }
                    else if (this.opaqueNetworkId && this.opaqueNetworkType) {
                        this.bindToPhysicalAdapterService.getDataByOpaqueNetworkSpec(this.hostId, this.opaqueNetworkId, this.opaqueNetworkType)
                            .then(function (data) {
                            _this.updateAvailablePnicsData(data);
                        }).finally(function () {
                            _this.onLoadingStateUpdate({
                                loading: false
                            });
                        });
                    }
                }
            }
        };
        BindToPhysicalAdapterController.prototype.onSelectionChange = function (selectedItems) {
            var _this = this;
            var selectedPnic = (selectedItems && selectedItems.length > 0) ?
                selectedItems[0].device : null;
            if (selectedPnic === null) {
                this.detailsData = null;
            }
            else {
                this.selectPnic(selectedPnic);
                if (this.pnicsDetailsData[selectedPnic]) {
                    this.detailsData = this.physicalAdapterDetailsViewService.build(this.pnicsDetailsData[selectedPnic]);
                }
                else {
                    this.physicalAdaptersListService
                        .getPhysicalAdapterDetailsItem(this.hostId, selectedPnic)
                        .then(function (result) {
                        _this.pnicsDetailsData[selectedPnic] = result;
                        _this.detailsData = _this.physicalAdapterDetailsViewService.build(_this.pnicsDetailsData[selectedPnic]);
                    });
                }
            }
            if (this.initPnicSelection) {
                this.initPnicSelection = false;
                this.selectPnicRow();
            }
        };
        BindToPhysicalAdapterController.prototype.updatePnicSelection = function () {
            var pnicDevice = null;
            if (this.selectedPnicForBinding) {
                pnicDevice = this.selectedPnicForBinding;
            }
            else if (this.availablePnicsData && this.availablePnicsData.length > 0) {
                pnicDevice = this.availablePnicsData[0].device;
            }
            this.selectPnic(pnicDevice);
            this.selectPnicRow();
        };
        BindToPhysicalAdapterController.prototype.updateAvailablePnicsData = function (data) {
            this.onAvailablePnicsDataChange({
                availablePnicsData: data
            });
            this.datagridOptions.data = data;
            if (data && data.length) {
                this.selectPnic(data[0].device);
                this.selectPnicRow();
            }
        };
        BindToPhysicalAdapterController.prototype.getColumnDefinitions = function () {
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            return [
                {
                    width: "35px",
                    template: function (pnic) {
                        return "<input type=\"radio\" ng-model=\"datagridOptions.selectedPnic\" \n                                 ng-change=\"datagridOptions.onBindedPnicChange()\" \n                                 name=\"bindPnic\" value=\"" + pnic.device + "\">";
                    }
                },
                {
                    displayName: this.i18nService.getString("NetworkUi", "PhysicalNicBindingEditor.pnicColumnHeader"),
                    field: "device",
                    template: function (pnic) {
                        var pnicItem = {
                            name: pnic.device,
                            icon: "network-lib-ui-icon-physicalAdapter"
                        };
                        return iconTextRenderer(["icon", "name"], pnicItem);
                    }
                }
            ];
        };
        BindToPhysicalAdapterController.$inject = [
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry",
            "dataService",
            "physicalAdaptersListService",
            "physicalAdapterDetailsViewService",
            "$element",
            "bindToPhysicalAdapterService"];
        return BindToPhysicalAdapterController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("bindToPhysicalAdapterComponent", new BindToPhysicalAdapterComponent());
})(network_ui || (network_ui = {}));



(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.network')
         .controller('ConnectionSettingsPageController',
               ConnectionSettingsPageController);

   ConnectionSettingsPageController.$inject = [
      '$scope',
      'dataService',
      'i18nService'];

   function ConnectionSettingsPageController($scope,
                                             dataService,
                                             i18nService) {
      var hostStandardPortgroupInfoProperty = "portgroup:hostStandardPortgroupInfo";

      if (!$scope.connectionSettingsPageModel.isInitialized) {
         $scope.wizardConfig.loading = true;
         dataService.getProperties(
               $scope.hostId,
               [hostStandardPortgroupInfoProperty],
               {
                  propertyParams: [{
                     propertyName: hostStandardPortgroupInfoProperty,
                     parameterType: 'java.lang.String',
                     parameter: i18nService.getString(
                           'NetworkUi', 'AddNetworkingWizard.vmNetwork')
                  }]
               })
               .then(function (response) {
                  $scope.wizardConfig.loading = false;
                  if (response) {
                     if (response[hostStandardPortgroupInfoProperty]) {
                        $scope.addNetworkingSpec.networkLabel =
                              response[hostStandardPortgroupInfoProperty].uniquePortGroupName;
                        $scope.connectionSettingsPageModel.vlanIds = response[hostStandardPortgroupInfoProperty].vlanIds;
                     }
                  }
                  $scope.connectionSettingsPageModel.isInitialized = true;
               });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
      .controller('CreateStandardSwitchPageController', CreateStandardSwitchPageController);

   CreateStandardSwitchPageController.$inject = [
      '$scope',
      'i18nService',
      'physicalAdaptersListService'];

   function CreateStandardSwitchPageController (
         $scope, i18nService, physicalAdaptersListService) {

      this.noItemsSelectedMessage = i18nService.getString('NetworkUi',
            'FailoverOrderEditor.detailsPrompt');

      this.headerOptions = {
         title: i18nService.getString("NetworkUi", "FailoverOrderEditor.failoverOrder")
      };

      if (typeof $scope.vSwitchSpec.pnics === 'undefined'
            || $scope.vSwitchSpec.pnics === null) {
         $scope.vSwitchSpec.pnics = {
            active: [],
            standby: [],
            unused: [],
            unclaimed: []
         };
         physicalAdaptersListService.getUnclaimedPhysicalAdapters($scope.hostId)
               .then(function (data) {
                  $scope.vSwitchSpec.pnics.unclaimed = data.unclaimed;
                  $scope.vSwitchSpec.pnicsDetails = data.pnicDetails;
                  // Initialize the failoverOrder's directive's data so that
                  // the ng-if in the template triggers the directive's rendering.
                  this.failoverOrder = _buildFailoverOptions();
               }.bind(this));
      } else {
         this.failoverOrder = _buildFailoverOptions();
      }

      function _buildFailoverOptions() {
         return {
            connectees: $scope.vSwitchSpec.pnics,
            connecteesDetails: $scope.vSwitchSpec.pnicsDetails,
            labels: {
               active: i18nService.getString("NetworkUi", "FailoverOrderEditor.active"),
               standby: i18nService.getString("NetworkUi", "FailoverOrderEditor.standby"),
               unused: i18nService.getString("NetworkUi", "FailoverOrderEditor.unused")
            }
         };
      }
      return this;
   }
}) ();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .controller('Ipv4SettingsPageController', Ipv4SettingsPageController);

   Ipv4SettingsPageController.$inject = [
      '$scope',
      'i18nService',
      'dataService',
      'ipParserService',
      'staticIpInputTypes',
      'addNetworkingWizardConstants'];

   function Ipv4SettingsPageController(
         $scope,
         i18nService,
         dataService,
         ipParserService,
         staticIpInputTypes,
         addNetworkingWizardConstants) {
      var vnicIpRouting = 'vnic:virtualAdapterIpRouting';

      this.ipv4PropertyType = staticIpInputTypes.IPV4.IP_ADDRESS;
      this.subnetMaskPropertyType = staticIpInputTypes.IPV4.SUBNET_MASK;
      this.defaultIpv4GatewayPropertyType = staticIpInputTypes.IPV4.DEFAULT_GATEWAY;

      this.ipv4ValidationMessage = i18nService.getString(
            'H5NetworkUi', 'AddNetworkingWizard.ipv4SettingsPage.invalidIpAddress');
      this.subnetMaskValidationMessage = i18nService.getString(
            'H5NetworkUi', 'AddNetworkingWizard.ipv4SettingsPage.invalidSubnetMask');
      this.defaultGatewayValidationMessage = i18nService.getString(
            'H5NetworkUi', 'AddNetworkingWizard.ipv4SettingsPage.invalidDefaultGatewayAddress');

      $scope.wizardConfig.loading = true;

      if($scope.hostVnicIpRoutingInfo.isIpv4Set) {
         initPage($scope.hostVnicIpRoutingInfo.value);
      } else {
         requestData();
      }

      function requestData() {
         var netStackKey = "";
         if ($scope.addNetworkingSpec.isTcpIpStackSupported) {
            netStackKey =
                  $scope.addNetworkingSpec.netStackName.netStackInstanceKey;
         }
         dataService.getProperties($scope.hostId, [vnicIpRouting], {
            propertyParams: [{
               propertyName: vnicIpRouting,
               parameterType: 'java.lang.String',
               parameter: netStackKey
            }]
         }).then(function (data) {
                  $scope.hostVnicIpRoutingInfo.value = data[vnicIpRouting];
                  initPage($scope.hostVnicIpRoutingInfo.value);
               })
               .finally(function() {
                  $scope.wizardConfig.loading = false;
         });
      }

      function initPage(ipConfigInfo) {

         $scope.defaultGateway = (ipConfigInfo && ipConfigInfo.ipv4DefaultGateway)
               ? ipConfigInfo.ipv4DefaultGateway
               : i18nService.getString('NetworkUi', 'NetworkUtil.noData');

         if (!$scope.hostVnicIpRoutingInfo.isIpv4Set) {
            $scope.addNetworkingSpec.overrideGateway = false;
            $scope.addNetworkingSpec.ipv4DefaultGateway = ipConfigInfo.ipv4DefaultGateway;

            $scope.hostVnicIpRoutingInfo.isIpv4Set = true;
         }

         if (!$scope.addNetworkingSpec.isTcpIpStackSupported) {
            $scope.showDnsAddresses = true;
         } else {
            $scope.showDnsAddresses =
                  $scope.addNetworkingSpec.netStackName.netStackInstanceKey
                  === addNetworkingWizardConstants.defaultNetStackKey;
         }

         $scope.addNetworkingSpec.isGatewayFeatureSupported =
               ipConfigInfo.isGatewayFeatureSupported;

         $scope.dnsAddresses = [];

         if (ipConfigInfo && ipConfigInfo.dnsAddresses && $scope.showDnsAddresses) {
            $scope.dnsAddresses =
                  _.filter(ipConfigInfo.dnsAddresses, function (dnsAddress) {
                     return ipParserService.isIpv4AddressValid(dnsAddress);
                  });
         }

         if ($scope.dnsAddresses.length < 1) {
            $scope.dnsAddresses =
                  [i18nService.getString('NetworkUi', 'NetworkUtil.noData')];
         }

         $scope.wizardConfig.loading = false;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .controller('Ipv6SettingsPageController', Ipv6SettingsPageController);

   Ipv6SettingsPageController.$inject = [
      '$scope',
      'dataService',
      'staticIpInputTypes',
      'i18nService'];

   function Ipv6SettingsPageController (
         $scope,
         dataService,
         staticIpInputTypes,
         i18nService) {

      this.defaultIpv6GatewayPropertyType = staticIpInputTypes.IPV6.DEFAULT_GATEWAY;

      this.initPage = function () {
         var ipv6RetrievedData = $scope.hostVnicIpRoutingInfo.value;

         $scope.defaultGateway = (ipv6RetrievedData && ipv6RetrievedData.ipv6DefaultGateway)
               ? ipv6RetrievedData.ipv6DefaultGateway
               : i18nService.getString('NetworkUi', 'NetworkUtil.noData');

         if (!$scope.hostVnicIpRoutingInfo.isIpv6Set) {
            $scope.addNetworkingSpec.overrideIpv6Gateway = false;
            $scope.addNetworkingSpec.ipv6DefaultGateway = ipv6RetrievedData.ipv6DefaultGateway;

            $scope.hostVnicIpRoutingInfo.isIpv6Set = true;
         }

         $scope.addNetworkingSpec.isGatewayFeatureSupported =
               ipv6RetrievedData.isGatewayFeatureSupported;

         this.listData = {};
         this.listData.ipv6List = $scope.addNetworkingSpec.ipv6Addresses;
         // needed for passing the default gateway to the 'Add IPv6 Address dialog'.
         this.listData.defaultGateway = ipv6RetrievedData.ipv6DefaultGateway;
         this.listData.hostIpv6Addresses = ipv6RetrievedData.hostIpv6Addresses;
      }.bind(this);

      if ($scope.hostVnicIpRoutingInfo.isIpv6Set) {
         this.initPage();
      } else {
         requestData().then(function() {
            this.initPage();
         }.bind(this));
      }

      function requestData () {
         var netStackKey = "";
         if ($scope.addNetworkingSpec.isTcpIpStackSupported) {
            netStackKey =
                  $scope.addNetworkingSpec.netStackName.netStackInstanceKey;
         }
         var vnicIpRouting = 'vnic:virtualAdapterIpRouting';

         return dataService.getProperties($scope.hostId, [vnicIpRouting], {
            propertyParams: [{
               propertyName: vnicIpRouting,
               parameterType: 'java.lang.String',
               parameter: netStackKey
            }]
         }).then(
               function (ipConfigInfo) {
                  $scope.hostVnicIpRoutingInfo.value = ipConfigInfo[vnicIpRouting];
               });
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .controller('PortPropertiesPageController', PortPropertiesPageController);

   PortPropertiesPageController.$inject = [
            '$scope',
            '$q',
            'i18nService',
            'dataService',
            'defaultUriSchemeUtil',
            'addNetworkingWizardConstants',
            'networkUtil',
            'hostVnicServiceConstants',
            'hostVnicServiceFactory'];

   function PortPropertiesPageController($scope,
                                         $q,
                                         i18nService,
                                         dataService,
                                         defaultUriSchemeUtil,
                                         addNetworkingWizardConstants,
                                         networkUtil,
                                         hostVnicServiceConstants,
                                         hostVnicServiceFactory) {

      var ipv6EnabledProperty = "config.network.ipV6Enabled";
      var portgroupMtuProperty = 'vnic:portgroupMtuData';
      var hostStandardPortgroupInfoProperty = 'portgroup:hostStandardPortgroupInfo';
      var isTcpIpStackSupported = "capability.multipleNetworkStackInstanceSupported";
      var hostNetStackData = "netstack:netStackData";

      $scope.addNetworkingWizardConstants = addNetworkingWizardConstants;

      $scope.portPropertiesPageModel.ipSettingsType =
            $scope.portPropertiesPageModel.ipSettingsType
            || addNetworkingWizardConstants.ipSettingsMode.IP_V4;

      $scope.wizardConfig.loading = true;

      if ($scope.selectTargetNetworkPageModel.targetType
            === addNetworkingWizardConstants.targetType.EXISTING_NETWORK) {
         var dataRequestPromises = [];
         if ($scope.addNetworkingSpec.selectedNetwork.isDistributedPortgroup) {
            if ($scope.addNetworkingSpec.selectedNetwork.dvsName) {
               $scope.addNetworkingSpec.networkLabel = i18nService.getString('H5NetworkUi',
                     "VnicPortPropertiesPage.dvPortgroupFormat",
                     $scope.addNetworkingSpec.selectedNetwork.name,
                     $scope.addNetworkingSpec.selectedNetwork.dvsName);
            } else {
               $scope.addNetworkingSpec.networkLabel =
                     $scope.addNetworkingSpec.selectedNetwork.name;
            }
            //persist the generated name for next visits of the page so that we know
            //whether the value is entered by the user, thus we can determine whether to
            //generate new value or not
            $scope.portPropertiesPageModel.existingNetworkGeneratedNetworkLabel =
                  $scope.addNetworkingSpec.networkLabel;

            var networkId = defaultUriSchemeUtil.getVsphereObjectId(
                  $scope.addNetworkingSpec.selectedNetwork.networkRef);

            var networkMtuPromise = dataService
                  .getProperties(networkId, [portgroupMtuProperty]).then(
                        function (response) {
                           initMtuInputsData(response[portgroupMtuProperty]);
                        });

            dataRequestPromises.push(networkMtuPromise);

         } else {
            // opaque network
            $scope.addNetworkingSpec.networkLabel =
                  $scope.addNetworkingSpec.selectedNetwork.name;
            $scope.portPropertiesPageModel.existingNetworkGeneratedNetworkLabel =
                  $scope.addNetworkingSpec.networkLabel;
            initMtuInputsData();
         }

         var networkIpv6Promise = dataService.getProperties($scope.hostId, [ipv6EnabledProperty])
               .then(function (response) {
                  if (response) {
                     $scope.addNetworkingSpec.isIpv6Enabled = response[ipv6EnabledProperty];
                  }
               });

         if (!$scope.portPropertiesPageModel.netStackName) {
            var netStackPromises = dataService.getProperties($scope.hostId, [
               isTcpIpStackSupported,
               hostNetStackData
            ]).then(function (response) {
               if (response) {
                  $scope.addNetworkingSpec.isTcpIpStackSupported =
                        response[isTcpIpStackSupported];

                  initTcpIpStackDropDown(response[hostNetStackData]);
               }
            });

            dataRequestPromises.push(netStackPromises);
         }

         dataRequestPromises.push(networkIpv6Promise);

         // promise for the isTcpIpStackSupported property
         var isTcpIpStackSupportedPromise =
               dataService.getProperties($scope.hostId, [isTcpIpStackSupported])
               .then(function (response) {
                  if (response) {
                     $scope.addNetworkingSpec.isTcpIpStackSupported =
                           response[isTcpIpStackSupported];
                  }
               });
         dataRequestPromises.push(isTcpIpStackSupportedPromise);

         $q.all(dataRequestPromises).then(function () {
            $scope.wizardConfig.loading = false;
         });

      } else if ($scope.selectTargetNetworkPageModel.targetType) {
         var isNetworkLabelUserModified =
            $scope.portPropertiesPageModel.existingNetworkGeneratedNetworkLabel
            !== $scope.addNetworkingSpec.networkLabel && $scope.addNetworkingSpec.networkLabel !== null;
         if (isNetworkLabelUserModified) {
            $scope.wizardConfig.loading = false;
         } else {
            initPortSettings();
         }

         if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {
            initMtuInputsData($scope.addNetworkingSpec.selectedStandardSwitch.mtu);
         } else if ($scope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
            initMtuInputsData($scope.vSwitchSpec.mtu);
         }
      }

      if (!$scope.portPropertiesPageModel.hostVnicFeatures) {
         $scope.addNetworkingSpec.vmkernelSettingsSpec = {
            _type: "com.vmware.vsphere.client.modules.api.network.VmkernelSettingsSpec"
         };

         dataService.getData($scope.hostId,
               "com.vmware.vsphere.client.h5.network.host.vnic.model.HostVnicServicesData")
               .then(function (result) {

                  $scope.portPropertiesPageModel.hostVnicFeatures = {};

                  $scope.portPropertiesPageModel.hostVnicFeatures = _.pick(
                        result.hostVnicFeatures,
                        hostVnicServiceConstants.featureFlags.TCP_IP_STACK,
                        hostVnicServiceConstants.featureFlags.PROVISIONING,
                        hostVnicServiceConstants.featureFlags.VR,
                        hostVnicServiceConstants.featureFlags.VR_NFC,
                        hostVnicServiceConstants.featureFlags.VSAN);

                  var additional = {};
                  additional[hostVnicServiceConstants.featureFlags.VMOTION_CONFIGURABLE] =
                        result[hostVnicServiceConstants.options.VMOTION_ENABLED];
                  additional[hostVnicServiceConstants.featureFlags.PROVISIONING_CONFIGURABLE] =
                        result[hostVnicServiceConstants.options.PROVISIONING_ENABLED];

                  // Add networking wizard supports only default net stack.
                  additional[hostVnicServiceConstants.featureFlags.TCP_IP_STACK_DEFAULT] =
                        true;

                  _.extend($scope.portPropertiesPageModel.hostVnicFeatures, additional);

                  var serviceSettings = hostVnicServiceFactory
                        .getServiceSettings($scope.portPropertiesPageModel.hostVnicFeatures);

                  _.extend(
                        $scope.addNetworkingSpec.vmkernelSettingsSpec, serviceSettings);
               });
      }

      function initMtuInputsData(mtu) {
         $scope.addNetworkingSpec.mtuSelectTypes = [];
         if (mtu) {
            $scope.addNetworkingSpec.mtuSelectTypes.push({
               id: 'getMtuFromSwitch',
               name: i18nService.getString('H5NetworkUi',
                     'AddNetworkingWizard.conPropPage.mtuSelectTypes.getMtuFromSwitch')
            });
            $scope.addNetworkingSpec.defaultMtu = mtu;
         } else {
            $scope.addNetworkingSpec.defaultMtu = 1500;
         }
         $scope.addNetworkingSpec.mtuSelectTypes.push({
            id: 'custom',
            name: i18nService.getString('H5NetworkUi',
                  'AddNetworkingWizard.conPropPage.mtuSelectTypes.custom')
         });

         // Init mtuType as custom in case no mtyType is specified
         if (!$scope.addNetworkingSpec.mtuSelectedType) {
            $scope.addNetworkingSpec.mtuSelectedType = $scope.addNetworkingSpec.mtuSelectTypes[0];
         }

         // No MTU selection or non-custom MTU selection - apply the default MTU
         if (!$scope.addNetworkingSpec.mtu
               || $scope.addNetworkingSpec.mtuSelectedType.id !== 'custom') {
            $scope.addNetworkingSpec.mtu = $scope.addNetworkingSpec.defaultMtu;
         }
      }

      function initPortSettings() {
         dataService.getProperties($scope.hostId, [
            hostStandardPortgroupInfoProperty,
            ipv6EnabledProperty,
            isTcpIpStackSupported,
            hostNetStackData
         ], {
            propertyParams: [{
               propertyName: hostStandardPortgroupInfoProperty,
               parameterType: 'java.lang.String',
               parameter: i18nService.getString(
                     'NetworkUi', 'AddNetworkingWizard.vmkernel')
            }]
         }).then(function (response) {
            if (response) {
               if (response[hostStandardPortgroupInfoProperty]) {
                  $scope.addNetworkingSpec.networkLabel =
                        response[hostStandardPortgroupInfoProperty].uniquePortGroupName;
                  $scope.addNetworkingSpec.vlanIds =
                        response[hostStandardPortgroupInfoProperty].vlanIds;
               }

               $scope.addNetworkingSpec.isIpv6Enabled = response[ipv6EnabledProperty];
               $scope.addNetworkingSpec.isTcpIpStackSupported = response[isTcpIpStackSupported];

               if (!$scope.portPropertiesPageModel.netStackName) {
                  // if the net stack is already set, don't reload the data
                  initTcpIpStackDropDown(response[hostNetStackData]);
               }
               $scope.wizardConfig.loading = false;
            }
         });
      }

      function initTcpIpStackDropDown(hostNetStackData) {

         if ($scope.addNetworkingSpec.isTcpIpStackSupported && hostNetStackData) {
            $scope.addNetworkingSpec.netStackName = {};
            if (hostNetStackData.netStackItems && hostNetStackData.netStackItems.length > 0) {
               $scope.addNetworkingSpec.netStackItems = [];
               hostNetStackData.netStackItems.forEach(function (value) {
                  var netStackObj = {
                     stackName: value.name,
                     netStackInstanceKey: value.key
                  };
                  // Initialize the default selected item - the default net stack
                  $scope.addNetworkingSpec.netStackItems.push(netStackObj);
                  if (value.key === addNetworkingWizardConstants.defaultNetStackKey) {
                     $scope.addNetworkingSpec.netStackName = netStackObj;
                     $scope.portPropertiesPageModel.netStackName = netStackObj;
                  }
               });
            }
         }
      }

      $scope.mtuValidator = {
         message: i18nService.getString('H5NetworkUi',
               'AddNetworkingWizard.conPropPage.mtu.inputErrorMessage'),
         isVisible: false
      };

      $scope.validateMtu = function () {
         $scope.mtuValidator.isVisible = !networkUtil.isMtuValid($scope.addNetworkingSpec.mtu);
      };

      $scope.resetMtu = function () {
         $scope.addNetworkingSpec.mtu = $scope.addNetworkingSpec.defaultMtu;
         $scope.mtuValidator.isVisible = !networkUtil.isMtuValid($scope.addNetworkingSpec.mtu);
      };

      $scope.setNetStackInstanceKey = function () {
         $scope.addNetworkingSpec.netStackItems.forEach(function (value) {
               if (value.stackName === $scope.addNetworkingSpec.netStackName.stackName) {
                  $scope.addNetworkingSpec.netStackInstanceKey =
                        value.netStackInstanceKey;
               }
            });

         $scope.portPropertiesPageModel.netStackName = $scope.addNetworkingSpec.netStackName;
         var additional = {};
         additional[hostVnicServiceConstants.featureFlags.TCP_IP_STACK_DEFAULT] =
               $scope.addNetworkingSpec.netStackName.netStackInstanceKey ===
               addNetworkingWizardConstants.defaultNetStackKey;

         additional[hostVnicServiceConstants.featureFlags.TCP_IP_STACK_PROVISIONING] =
               $scope.addNetworkingSpec.netStackName.netStackInstanceKey ===
               addNetworkingWizardConstants.provisioningNetStackKey;

         additional[hostVnicServiceConstants.featureFlags.TCP_IP_STACK_VMOTION] =
               $scope.addNetworkingSpec.netStackName.netStackInstanceKey ===
               addNetworkingWizardConstants.vmotionNetStackKey;

         _.extend($scope.portPropertiesPageModel.hostVnicFeatures, additional);

         $scope.portPropertiesPageModel.hostVnicFeatures =
               _.clone($scope.portPropertiesPageModel.hostVnicFeatures);

         var serviceSettings = hostVnicServiceFactory
               .getServiceSettings($scope.portPropertiesPageModel.hostVnicFeatures);

         _.extend(
               $scope.addNetworkingSpec.vmkernelSettingsSpec, serviceSettings);

         // for resetting the default gateway settings
         $scope.hostVnicIpRoutingInfo.isIpv4Set = false;
         $scope.hostVnicIpRoutingInfo.isIpv6Set = false;
      };

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .controller('SelectTargetNetworkPageController', SelectTargetNetworkPageController);

   SelectTargetNetworkPageController.$inject = [
      '$scope',
      'i18nService',
      'networkUiConstants',
      'NetworkSelectorMode',
      'networkSelectorDialogService',
      'addNetworkingWizardConstants',
      'switchSelectorDialogService',
      'networkUtil'];

   function SelectTargetNetworkPageController(
         $scope,
         i18nService,
         networkUiConstants,
         NetworkSelectorMode,
         networkSelectorDialogService,
         addNetworkingWizardConstants,
         switchSelectorDialogService,
         networkUtil) {

      var self = this;

      $scope.addNetworkingWizardConstants = addNetworkingWizardConstants;
      initNetworkSelector();
      initSwitchSelector();
      $scope.portsNumbers = _getPortNumbers();

      if (typeof $scope.vSwitchSpec.numPorts === 'undefined') {
         $scope.vSwitchSpec.numPorts = networkUiConstants.NumPorts.DEFAULT;
      }

      if (typeof $scope.vSwitchSpec.mtu === 'undefined') {
         $scope.vSwitchSpec.mtu = networkUiConstants.Mtu.DEFAULT;
      }

      if ($scope.selectConnectionTypePageModel.connectionType === addNetworkingWizardConstants.connectionType.PNIC) {
         $scope.existingSwitchLabel = i18nService.getString('NetworkUi', 'AddNetworkingWizard.conTargetPage.existingSwitchWithDvs');
      } else {
         $scope.existingSwitchLabel = i18nService.getString('NetworkUi', 'AddNetworkingWizard.conTargetPage.existingSwitch');
      }

      if (shouldGetPreselectedSwitch($scope.preselectedSwitch,
                  $scope.addNetworkingSpec.selectedStandardSwitch,
                  $scope.selectConnectionTypePageModel.connectionType)) {
         $scope.addNetworkingSpec.selectedStandardSwitch =
               $scope.preselectedSwitch;
         $scope.selectTargetNetworkPageModel.targetType =
               addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH;
      }

      self.mtuValidator = {
         message: i18nService.getString('H5NetworkUi', 'AddNetworkingWizard.conPropPage.mtu.inputErrorMessage'),
         isVisible: false
      };

      self.validateMtu = function () {
         self.mtuValidator.isVisible = !networkUtil.isMtuValid($scope.vSwitchSpec.mtu);
      };

      self.showExistingNetwork = $scope.selectConnectionTypePageModel.connectionType ===
            addNetworkingWizardConstants.connectionType.VMKERNEL;

      function initNetworkSelector() {
         $scope.networkSelectorMode = NetworkSelectorMode.SINGLE_SELECTION_BROWSE_INPUT;


         $scope.networkSelectorFilterSpec =
               networkSelectorDialogService.createNetworkSelectorFilterSpec(
                     false/*includeStandardNetworks*/,
                     true/*includeOpaqueNetworks*/,
                     true/*includeDistributedPortGroups*/,
                     false/*includeUplinkPortGroups*/,
                     true/*includeOpaqueNetworkTypes*/);

         $scope.networkSelectorDialogSpec =
               networkSelectorDialogService.createNetworkSelectorDialogSpec(
                     ['Network.Assign'],
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.conTargetPage.noDvpgPrivilegeMessage')
               );


         self.onSelectNetworks = function (selectedNetworks) {
            var network = selectedNetworks[0];
            $scope.addNetworkingSpec.selectedNetwork = network;
            $scope.addNetworkingSpec.selectedNetwork.isDistributedPortgroup =
                  !network.isStandardNetwork && !network.isOpaqueNetwork && !network.isUplink;
            $scope.selectTargetNetworkPageModel.isOpaqueNetworkSelected =
                  network.isOpaqueNetwork;

            self.resetPortPropertiesValues();
         };
      }

      function initSwitchSelector() {
         self.onSelectSwitch = function () {
            switchSelectorDialogService.openSwitchSelectorDialog(
                  $scope.hostId,
                  $scope.selectConnectionTypePageModel.connectionType,
                  null,
                  $scope.selectTargetNetworkPageModel.retrieveAllSwitches,
                  function (selectedItems) {
                     $scope.addNetworkingSpec.selectedStandardSwitch = selectedItems[0];
                  });
         };
      }

      function _getPortNumbers() {
         var portNumbers = [networkUiConstants.NumPorts.MIN];
         while (_.last(portNumbers) < networkUiConstants.NumPorts.MAX) {
            portNumbers.push(_.last(portNumbers) * 2);
         }
         return portNumbers;
      }

      function shouldGetPreselectedSwitch(preselectedSwitch, selectedStandardSwitch, connectionType) {
         return preselectedSwitch && !selectedStandardSwitch &&
               (preselectedSwitch.type === addNetworkingWizardConstants.switchType.STANDARD ||
               connectionType === addNetworkingWizardConstants.connectionType.PNIC);
      }

      self.resetPortPropertiesValues = function () {
         // if the target type has changed, we need to reset all the properties
         // except IP settings
         if($scope.addNetworkingSpec) {
            if($scope.addNetworkingSpec.vlanId) {
               $scope.addNetworkingSpec.vlanId = null;
            }

            if ($scope.addNetworkingSpec.networkLabel) {
               $scope.addNetworkingSpec.networkLabel = null;
            }

            if ($scope.portPropertiesPageModel.existingNetworkGeneratedNetworkLabel) {
               $scope.portPropertiesPageModel.existingNetworkGeneratedNetworkLabel = null;
            }

            if ($scope.portPropertiesPageModel.netStackName) {
               $scope.portPropertiesPageModel.netStackName = null;
            }

            if ($scope.addNetworkingSpec.netStackName) {
               $scope.addNetworkingSpec.netStackName = null;
            }

            if ($scope.addNetworkingSpec.mtuSelectedType) {
               $scope.addNetworkingSpec.mtuSelectedType = null;
            }

            if ($scope.addNetworkingSpec.mtu) {
               $scope.addNetworkingSpec.mtu = null;
            }

            if ($scope.portPropertiesPageModel.hostVnicFeatures) {
               $scope.portPropertiesPageModel.hostVnicFeatures = null;
            }

            if ($scope.portPropertiesPageModel.hostVnicSettings) {
               $scope.portPropertiesPageModel.hostVnicSettings = null;
            }
         }
      };

      return this;
   }
})();

var PnicBindingDataItem = com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.PnicBindingDataItem;
var network_ui;
(function (network_ui) {
    var BindToPhysicalAdapterService = (function () {
        function BindToPhysicalAdapterService(dataService) {
            this.dataService = dataService;
            this.availablePnicsPropertyByRef = "vnic:availablePnicsForBinding";
            this.availablePnicsPropertyBySpec = "vnic:availablePnicsForBindingBySummary";
        }
        BindToPhysicalAdapterService.prototype.getDataByOpaqueNetworkRef = function (hostId, opaqueNetworkRef) {
            var propertyParams = [];
            propertyParams.push({
                propertyName: this.availablePnicsPropertyByRef,
                parameterType: "com.vmware.vim.binding.vmodl.ManagedObjectReference",
                parameter: opaqueNetworkRef
            });
            return this.getData(hostId, this.availablePnicsPropertyByRef, propertyParams);
        };
        ;
        BindToPhysicalAdapterService.prototype.getDataByOpaqueNetworkSpec = function (hostId, opaqueNetworkId, opaqueNetworkType) {
            var propertyParams = [];
            propertyParams.push({
                propertyName: this.availablePnicsPropertyBySpec,
                parameterType: "java.util.Map",
                parameter: {
                    opaqueNetworkId: opaqueNetworkId,
                    opaqueNetworkType: opaqueNetworkType
                }
            });
            return this.getData(hostId, this.availablePnicsPropertyBySpec, propertyParams);
        };
        ;
        BindToPhysicalAdapterService.prototype.getData = function (hostId, availablePnicsProperty, propertyParams) {
            return this.dataService.getProperties(hostId, [availablePnicsProperty], { propertyParams: propertyParams })
                .then(function (result) {
                return result[availablePnicsProperty];
            });
        };
        ;
        BindToPhysicalAdapterService.$inject = [
            "dataService"];
        return BindToPhysicalAdapterService;
    }());
    network_ui.BindToPhysicalAdapterService = BindToPhysicalAdapterService;
    angular.module("com.vmware.vsphere.client.network")
        .service("bindToPhysicalAdapterService", BindToPhysicalAdapterService);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('addHostNetworkingAddPnicPageValidator',
               AddHostNetworkingAddPnicPageValidator);

   AddHostNetworkingAddPnicPageValidator.$inject = [
      'i18nService',
      'clarityModalService'
   ];

   function AddHostNetworkingAddPnicPageValidator(i18nService,
                                                  clarityModalService) {

      this.getValidationErrorsAndWarnings = function (pnics, pnicsDetails) {

         var errors = getValidationErrors(pnics);
         var warning = getWarning(pnics, pnicsDetails);

         if (errors && errors.length > 0) {
            return errors;
         } else if (warning) {

            var modalOptions = {
               title: warning.dialogTitle,
               message: warning.warningMessage,
               clarityIcon: {
                  class: "is-warning",
                  shape: "warning-standard",
                  size: "32"
               },
               preserveNewlines: true
            };

            return clarityModalService.openConfirmationModal(modalOptions);
         } else {
            return true;
         }
      };

      function getValidationErrors(pnics) {
         var errors = [];

         if (!hasNewPnics(pnics)) {
            if (typeof pnics.unclaimed === 'undefined'
                  || pnics.unclaimed.length === 0) {
               errors.push(i18nService.getString('NetworkUi',
                     'PhysicalNicFailoverOrderPage.error.noUnclaimedNics'));
            } else if (pnics.unclaimed.length > 0) {
               errors.push(i18nService.getString('NetworkUi',
                     'PhysicalNicFailoverOrderPage.error.noNics'));
            }
         }

         return errors;
      }

      function getWarning(pnics, pnicsDetails) {
         var warning;

         var activePnics = pnics.active;
         if (!hasActivePnics(pnics.active)) {
            warning = {};
            warning.dialogTitle = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.noActiveNics.title');
            warning.warningMessage = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.noActiveNics.text');
         } else if (areAllPnicsDisconnected(activePnics, pnicsDetails)) {
            warning = {};
            warning.dialogTitle = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.allActiveNicsDisconnected.title');
            warning.warningMessage = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.allActiveNicsDisconnected.text');
         }

         return warning;
      }

      function hasNewPnics(pnics) {
         // unclaimedInitial is an array created by the failoverOrder directive,
         // which is a copy of the initially unclaimed pnics and is used to compare
         // against newly added pnics.
         if (!pnics.unclaimedInitial || pnics.unclaimedInitial.length === 0) {
            return false;
         }
         var hasNewActivePnics = _.some(pnics.active, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         });

         var hasNewStandbyPnics = _.some(pnics.standby, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         });

         var hasNewUnusedPnics = _.some(pnics.unused, function (pnic) {
            return _.indexOf(pnics.unclaimedInitial, pnic) !== -1;
         });

         return hasNewActivePnics || hasNewStandbyPnics || hasNewUnusedPnics;
      }

      function areAllPnicsDisconnected(activePnics, pnicsDetails) {
         return !_.some(activePnics, function (pnic) {
            if (pnic !== null && pnicsDetails[pnic] && pnicsDetails[pnic].isConnected) {
               return true;
            }
         });
      }

      function hasActivePnics(activePnics) {
         return activePnics && activePnics.length > 0;
      }
   }
})();
/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('addHostNetworkingCreateStandardSwitchPageValidator',
               AddHostNetworkingCreateStandardSwitchPageValidator);

   AddHostNetworkingCreateStandardSwitchPageValidator.$inject = [
      'i18nService',
      'clarityModalService'
   ];

   function AddHostNetworkingCreateStandardSwitchPageValidator(i18nService,
                                                               clarityModalService) {

      this.getValidationErrorsAndWarnings = function (pnics, pnicsDetails) {

         var dialogTitle = null;
         var warningMessage = null;
         var hasToShowWarning = false;

         var activePnics = pnics.active;
         if (!activePnics || activePnics.length === 0) {
            dialogTitle = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.noActiveNics.title');
            warningMessage = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.noActiveNics.text');
            hasToShowWarning = true;
         } else if (areAllPnicsDisconnected(activePnics, pnicsDetails)) {
            dialogTitle = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.allActiveNicsDisconnected.title');
            warningMessage = i18nService.getString('NetworkUi',
                  'PhysicalNicFailoverOrderPage.warn.allActiveNicsDisconnected.text');
            hasToShowWarning = true;
         }

         if(hasToShowWarning) {

            var modalOptions = {
               title: dialogTitle,
               message: warningMessage,
               clarityIcon: {
                  class: "is-warning",
                  shape: "warning-standard",
                  size: "32"
               },
               preserveNewlines: true
            };

            return clarityModalService.openConfirmationModal(modalOptions);
         } else {
            return true;
         }
      };

      function areAllPnicsDisconnected(activePnics, pnicsDetails) {
         return !_.some(activePnics, function (pnic) {
            if (pnic && pnicsDetails[pnic] && pnicsDetails[pnic].isConnected) {
               return true;
            }
         });
      }
   }
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('addPnicToDvsPageValidator',
               AddPnicToDvsPageValidator);

   AddPnicToDvsPageValidator.$inject = ['i18nService'];

   function AddPnicToDvsPageValidator(i18nService) {

      this.getValidationErrors = function (addedMappings) {
         var errors = [];

         if (!Object.keys(addedMappings).length) {
            errors.push(i18nService.getString('NetworkUi',
                  'AddNetworkingWizard.physicalNicPage.error.noNics'));
         }
         return errors;
      };
   }
})();
var network_ui;
(function (network_ui) {
    var BindToPnicPageValidator = (function () {
        function BindToPnicPageValidator(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.getValidationErrors = function (bindToPnic, selectedPnic) {
                var errors = [];
                if (bindToPnic && !selectedPnic) {
                    errors.push(_this.i18nService.getString("NetworkUi", "VnicToPnicBindingPage.error.noNic"));
                }
                return errors;
            };
        }
        BindToPnicPageValidator.$inject = [
            "i18nService"
        ];
        return BindToPnicPageValidator;
    }());
    network_ui.BindToPnicPageValidator = BindToPnicPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("bindToPnicPageValidator", BindToPnicPageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('connectionSettingsPageValidator',
               ConnectionSettingsPageValidator);

   ConnectionSettingsPageValidator.$inject = [
      'i18nService',
      'networkUtil',
      'networkLabelValidator'];

   function ConnectionSettingsPageValidator(i18nService,
                                            networkUtil,
                                            networkLabelValidator) {
      this.getValidationErrors = function (hostId, networkLabel, vlanId) {
         var errors = [];

         if (!networkUtil.isVlanIdValid(vlanId)) {
            errors.push(i18nService.getString('NetworkUi', 'VnicData.invalidVlanId'));
         }
         errors = errors.concat(networkLabelValidator
               .getNetworkLabelClientSideValidationErrors(networkLabel));

         //in case there are no client side validation errors a server validation is done.
         if (errors.length === 0) {
            return networkLabelValidator
                  .getNetworkLabelServerSideValidationErrors(hostId, networkLabel);
         }
         return errors;
      };
   }
})();


/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('ipv4SettingsPageValidator',
               Ipv4SettingsPageValidator);

   Ipv4SettingsPageValidator.$inject = [
      'i18nService',
      'ipParserService',
      'mutationService'];

   function Ipv4SettingsPageValidator(i18nService,
                                      ipParserService,
                                      mutationService) {

      this.getValidationErrors = function (validationData) {
         var validationErrors = [];
         if (!validationData.dhcpEnabled) {
            var ipv4AddressTrimmed = validationData.ipv4Address
                  && validationData.ipv4Address.trim();

            // Client validation
            if (!ipv4AddressTrimmed) {
               validationErrors.push(i18nService.getString('H5NetworkUi',
                     'AddNetworkingWizard.ipv4SettingsPage.emptyIpAddress'));
            } else if (!ipParserService.isIpv4AddressValid(ipv4AddressTrimmed)) {
               validationErrors.push(i18nService.getString(
                     'NetworkUi', 'VnicData.invalidIPAddress'));
            }

            var subnetMaskTrimmed = validationData.subnetMask
                  && validationData.subnetMask.trim();

            if (!subnetMaskTrimmed) {
               validationErrors.push(i18nService.getString('H5NetworkUi',
                     'AddNetworkingWizard.ipv4SettingsPage.emptySubnetMask'));
            } else if (!ipParserService.isSubnetMaskValid(subnetMaskTrimmed)) {
               validationErrors.push(i18nService.getString(
                     'NetworkUi', 'VnicData.invalidSubnet'));
            }

            validationErrors = validationErrors.concat(
                  getDefaultGatewaysErrors(validationData, validationErrors.length));

            // Server validation if client validation has passed
            if (validationErrors.length === 0) {
               return serverSideValidation(validationData.hostId,
                     ipv4AddressTrimmed, validationData.vnicName);
            }
         }
         return validationErrors;
      };

      /**
       * A backend call to validate the uniqueness of a given IP address.
       * Supports validation in the context of a new, or an already existing vnic.
       *
       * @param hostId - The ID of the host.
       * @param ipv4Address - The IP address to validate against.
       * @param vnicName(optional) - The name of the vnic, whose IP must be validated, or
       *                             null when a new vnic is being created.
       */
      function serverSideValidation(hostId, ipv4Address, vnicName) {
         var vnicSpec = { ipv4Address: ipv4Address };

         if (vnicName) {
            vnicSpec.vnicName = vnicName;
         }

         return mutationService.validate(
               hostId,
               'com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.HostVnicIpv4SettingsSpec',
               vnicSpec
         ).then(function (validationResult) {
            var serverErrors = [];
            if (validationResult && validationResult.result) {
               serverErrors.push(validationResult.result);
            }
            return serverErrors;
         });

      }

      function getDefaultGatewaysErrors(validationData, validationErrorsLength) {
         var defaultGatewayErrors = [];
         if (!validationData.isGatewayFeatureSupported || !validationData.overrideGateway) {
            return defaultGatewayErrors;
         }

         // validate default gateway valid input
         // then validate same subnet mask of default gateway and ipv4 address
         // only if there are no other errors
         if (!validationData.ipv4DefaultGateway) {
            defaultGatewayErrors.push(i18nService.getString('H5NetworkUi',
                  'AddNetworkingWizard.ipv4SettingsPage.emptyDefaultGateway'));
         } else if (!ipParserService.isIpv4AddressValid(
                     validationData.ipv4DefaultGateway.trim())) {
            defaultGatewayErrors.push(i18nService.getString(
                  'NetworkUi', 'VnicData.invalidGateway'));
         } else if (validationErrorsLength === 0 && !ipParserService.isSameIpv4Subnet(
                     validationData.ipv4DefaultGateway,
                     validationData.ipv4Address,
                     validationData.subnetMask)) {
            defaultGatewayErrors.push(i18nService.getString('H5NetworkUi',
                  'AddNetworkingWizard.ipv4SettingsPage.invalidDefaultGateway'));
         }

         return defaultGatewayErrors;
      }
   }


})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network')
         .service('ipv6SettingsPageValidator',
               Ipv6SettingsPageValidator);

   Ipv6SettingsPageValidator.$inject = ['i18nService', 'ipParserService'];

   function Ipv6SettingsPageValidator(i18nService, ipParserService) {

      this.getValidationErrors = function (ipv6DhcpEnabled,
                                           routerAdvertisementEnabled,
                                           staticAddressesEnabled,
                                           ipv6AddressesArrLength,
                                           overrideIpv6Gateway,
                                           ipv6DefaultGateway) {
         var validationErrors = [];
         if (staticAddressesEnabled) {
            if (!ipv6AddressesArrLength) {
               validationErrors.push(i18nService.getString('NetworkUi',
                     'AddNetworkingWizard.ipv6Settings.noIpv6ManualAddressError'));
            }

            if (overrideIpv6Gateway) {
               // check if the configured default gateway is empty or invalid ipv6 address
               if (!ipParserService.isIpv6AddressValid(ipv6DefaultGateway)) {
                  validationErrors.push(i18nService.getString(
                        'NetworkUi', 'Ipv6GatewayDialog.defaultGateway.error'));
               }
               if (ipv6DhcpEnabled || routerAdvertisementEnabled) {
                  validationErrors.push(i18nService.getString('H5NetworkUi',
                        'VnicIpv6SettingsPage.invalidIpConfiguration'));
               }
            }
         } else if (!ipv6DhcpEnabled && !routerAdvertisementEnabled) {
            validationErrors.push(i18nService.getString('NetworkUi',
                  'AddNetworkingWizard.ipv6Settings.noIpv6SettingsError'));
         }
         return validationErrors;
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('portPropertiesPageValidator',
               PortPropertiesPageValidator);

   PortPropertiesPageValidator.$inject = [
      'i18nService',
      'networkLabelValidator',
      'addNetworkingWizardConstants',
      'networkUtil',
      '$q',
      'clarityModalService',
      'tcpIpStackServicesValidator'
   ];

   function PortPropertiesPageValidator(i18nService,
                                        networkLabelValidator,
                                        addNetworkingWizardConstants,
                                        networkUtil, $q,
                                        clarityModalService,
                                        tcpIpStackServicesValidator) {

      var IS_SYSTEM_TRAFFIC_ENABLED_PROPERTY = "vnic:isSystemTrafficEnabled";

      this.getValidationErrorsAndWarnings = function (hostId, networkLabel,
                                                      targetType, vlanId,
                                                      mtuSelectedType, mtu,
                                                      netStackInstanceKey) {

         var errors = getValidationErrors(targetType, mtu, vlanId,
               networkLabel, hostId);

         var warningPromise = getWarningPromise(netStackInstanceKey, hostId);

         if (errors) {
            // Handle the error. If no such exist check also the warnings
            return handleErrors(netStackInstanceKey, errors, warningPromise);
         } else {
            return true;
         }
      };

      function getValidationErrors(targetType, mtu, vlanId, networkLabel, hostId) {
         var errors = [];
         if (!networkUtil.isMtuValid(mtu)) {
            errors.push(i18nService.getString('H5NetworkUi',
                  'AddNetworkingWizard.conPropPage.mtu.validationErrorMessage'));
         }

         if (targetType ===
               addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH
               || targetType ===
               addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
            if (!networkUtil.isVlanIdValid(vlanId)) {
               errors.push(i18nService.getString('NetworkUi', 'VnicData.invalidVlanId'));
            }
            errors = errors.concat(networkLabelValidator
                  .getNetworkLabelClientSideValidationErrors(networkLabel));

            //in case there are no client side validation errors a server validation is done.
            if (errors.length === 0) {
               return networkLabelValidator
                     .getNetworkLabelServerSideValidationErrors(hostId, networkLabel);
            }
         }

         return errors;
      }

      function getWarningPromise(netStackInstanceKey, hostId) {

         var netStackKey = netStackInstanceKey;

         if (netStackKey ===
               addNetworkingWizardConstants.vmotionNetStackKey ||
               netStackKey ===
               addNetworkingWizardConstants.provisioningNetStackKey) {

            var warningPromise = tcpIpStackServicesValidator
                  .isSystemTrafficEnabledOnDefaultStack(netStackInstanceKey, hostId);

            return warningPromise;
         }
      }

      function getWarning(netStackInstanceKey) {

         var warningTitle;
         var warningMsg;

         if (netStackInstanceKey === addNetworkingWizardConstants
                     .vmotionNetStackKey) {

            warningTitle = i18nService.getString('NetworkUi',
                  'NetStackInstanceSelector.vmotion.title');
            warningMsg = i18nService.getString('NetworkUi',
                  'NetStackInstanceSelector.vmotion.warning');
         }

         if (netStackInstanceKey === addNetworkingWizardConstants
                     .provisioningNetStackKey) {

            warningTitle = i18nService.getString('NetworkUi',
                  'NetStackInstanceSelector.provisioning.title');
            warningMsg = i18nService.getString('NetworkUi',
                  'NetStackInstanceSelector.provisioning.warning');
         }

         return {
            warningTitle: warningTitle,
            warningMsg: warningMsg
         };

      }

      function handleWarning(netStackInstanceKey, warningPromise) {
         var confirmationDefered = $q.defer();

         warningPromise.then(function (response) {
            if (response && response[IS_SYSTEM_TRAFFIC_ENABLED_PROPERTY]) {

               var netStackKey = netStackInstanceKey;
               var warning = getWarning(netStackKey);

               var modalOptions = {
                  title: warning.warningTitle,
                  message: warning.warningMsg,
                  clarityIcon: {
                     class: "is-warning",
                     shape: "warning-standard",
                     size: "32"
                  },
                  preserveNewlines: true,
                  submit: function () {
                     confirmationDefered.resolve(true);
                  },
                  onCancel: function () {
                     confirmationDefered.resolve(false);
                  }
               };
               clarityModalService.openConfirmationModal(modalOptions);
            } else {
               confirmationDefered.resolve(true);
            }
         });
         return confirmationDefered.promise;
      }

      function handleErrors(netStackInstanceKey, errors, warningPromise) {
         if (_.isArray(errors) && errors.length > 0) {
            return errors;
         } else {
            return $q.when(errors).then(function (resultServerErrors) {
               if (resultServerErrors && resultServerErrors.length > 0) {
                  return errors;
               } else {
                  if (warningPromise) {
                     return handleWarning(netStackInstanceKey, warningPromise);
                  } else {
                     return true;
                  }
               }
            });
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('selectTargetNetworkPageValidator',
               SelectTargetNetworkPageValidator);

   SelectTargetNetworkPageValidator.$inject = [
      'i18nService',
      'dataService',
      'networkUtil',
      'addNetworkingWizardConstants'];

   function SelectTargetNetworkPageValidator(i18nService,
                                             dataService,
                                             networkUtil,
                                             addNetworkingWizardConstants) {
      var standardSwitchProperty = "host:uniqueStandardSwitchName";

      this.getValidationErrors = function (wizardScope) {
         var errors = [];
         if (wizardScope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_NETWORK) {
            if (!wizardScope.addNetworkingSpec.selectedNetwork) {
               errors.push(
                     i18nService.getString('H5NetworkUi',
                           'AddNetworkingWizard.conTargetPage.noSelectedTargetError'));
            }
         } else if (wizardScope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.EXISTING_STANDARD_SWITCH) {
            if (!wizardScope.addNetworkingSpec.selectedStandardSwitch) {
               errors.push(
                     i18nService.getString('NetworkUi',
                           'AddNetworkingWizard.conTargetPage.noSwitchTargetError'));
            }
         } else if (wizardScope.selectTargetNetworkPageModel.targetType
               === addNetworkingWizardConstants.targetType.NEW_STANDARD_SWITCH) {
            if (!networkUtil.isMtuValid(wizardScope.vSwitchSpec.mtu)) {
               errors.push(i18nService.getString('H5NetworkUi',
                     'AddNetworkingWizard.conPropPage.mtu.validationErrorMessage'));
            }
            if (wizardScope.hostCapability.switchAutoScaleSupported === false && !_isValidNumPorts(
                        wizardScope.hostCapability,
                        wizardScope.vSwitchSpec.numPorts)) {

               errors.push(i18nService.getString('NetworkUi',
                     'AddNetworkingWizard.conTargetPage.availablePortsExceeded',
                     wizardScope.hostCapability.availablePortsNumber));
            }
            if (errors.length !== 0) {
               return errors;
            } else {
               //this isn't validation we just have to get an unique name for the
               //new standard switch and pass it to the next pages
               return dataService.getProperties(wizardScope.hostId,
                     [standardSwitchProperty])
                     .then(function (result) {
                        wizardScope.vSwitchSpec.name = result[standardSwitchProperty];
                        return [];
                     });
            }
         }
         return errors;
      };
   }

   function _isValidNumPorts(hostCapability, numPorts) {
      return typeof numPorts !== 'undefined' && hostCapability.availablePortsNumber > numPorts;
   }
})();
(function() {
   'use strict';

   /**
    * Constants related to host services enabled on vnics.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .constant('hostVnicServiceConstants', {

            /**
             * Host vnic service keys used in the VirtualNicAddSpec mutation spec.
             *
             * Enabled services are described with array of {key:boolean} objects, where
             * the key is one of these keys.
             */
            keys: {
               VMOTION: 'isVmotionEnabled',
               PROVISIONING: 'isProvisioningNfcTrafficEnabled',
               FT_LOGGING: 'isFtEnabled',
               MANAGEMENT: 'isHaEnabled',
               VR: 'isVRTrafficEnabled',
               VR_NFC: 'isVrNfcTrafficEnabled',
               VSAN: 'isVsanEnabled'
            },

            /**
             * Host vnic service features used in the EditPortPropertiesPageModel model.
             * The same values are intentionally used in HostVnicServicesFactory.
             *
             * Feature flags are used either to show or hide as well as
             * either to enable or disable service UI controls.
             */
            featureFlags: {
               VMOTION_CONFIGURABLE: 'isVmotionConfigurable',
               PROVISIONING_CONFIGURABLE: 'isProvisioningConfigurable',
               PROVISIONING: 'isProvisioningNfcTrafficSupported',
               VR: 'isVrTrafficSupported',
               VR_NFC: 'isVrNfcTrafficSupported',
               VSAN: 'isVsanSupported',
               TCP_IP_STACK: 'isTcpIpStackSupported',
               TCP_IP_STACK_DEFAULT: 'isTcpIpStackTheDefaultOne',
               TCP_IP_STACK_PROVISIONING: 'isTcpIpStackTheProvisioningOne',
               TCP_IP_STACK_VMOTION: 'isTcpIpStackTheVmotionOne'
            },

            /**
             * The names of host options provided by HostVnicServicesData. Their meaning
             * is if Vmotion or Provisiong service traffics are supported via vnics on
             * a given host.
             */
            options: {
               VMOTION_ENABLED: 'isVmotionTrafficEnabledForDefaultStack',
               PROVISIONING_ENABLED: 'isProvisioningTrafficEnabledForDefaultStack'
            }
         });
})();
(function() {
   "use strict";

   /**
    * Factory to create objects needed to either render or update host services that
    * can be enabled on VMkernel adapters.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .factory('hostVnicServiceFactory', hostVnicServiceFactory);

   hostVnicServiceFactory.$inject = ['i18nService', 'hostVnicServiceConstants'];

   function hostVnicServiceFactory(i18nService, hostVnicServiceConstants) {

      return {
         getServiceDescriptions: getServiceDescriptions,
         getServiceSettings: getServiceSettings,
         pickServiceFeatures: pickServiceFeatures,
         pickServiceSettings: pickServiceSettings
      };

      /**
       * Returns array of objects that represent host vnic service.
       *
       * @param hostVnicFeatures
       *    Feature flags describing host services that can be enabled on vnics.
       *    Object with hostVnicServiceConstants.featureFlags keys and boolean values.
       *
       *    Example:
       *    ```js
       *       var hostVnicFeatures = {
       *          isVmotionConfigurable: true,
       *          isProvisioningConfigurable: true
       *          // ...
       *       }
       *    ```
       * @param hostVnicSettings
       *    Object with key:value pairs like <serviceKey: boolean>.
       *    Service keys are described in hostVnicServiceConstants.keys.
       *    The boolean value of the pair describes if the service is enabled on a vnic.
       *
       *    Example:
       *    ```js
       *       var hostVnicSettings = {
       *          isVmotionEnabled: true,
       *          isProvisioningNfcTrafficEnabled: true
       *          // ...
       *       }
       *    ```
       * @return
       *
       *    Example:
       *
       *    result[0] = {
       *       includeInLayout: true, // See hostVnicServiceConstants.featureFlags.
       *       isEnabled: false,      // See hostVnicServiceConstants.featureFlags.
       *       label: 'vMotion',
       *       summaryLabel: 'vMotion summary',
       *       tooltip: 'vMotion description'
       *    }
       *
       * @see hostVnicServiceConstants.keys
       * @see hostVnicServiceConstants.featureFlags
       */
      function getServiceDescriptions(hostVnicFeatures, hostVnicSettings) {
         var keys = hostVnicServiceConstants.keys;
         var flags = hostVnicServiceConstants.featureFlags;
         var features = hostVnicFeatures || {};
         var settings = hostVnicSettings || {};
         var isDefaultStack = !features[flags.TCP_IP_STACK] || !!features[flags.TCP_IP_STACK_DEFAULT];
         var isVmotionEnabled = isDefaultStack && !!features[flags.VMOTION_CONFIGURABLE];
         var isProvisioningEnabled = isDefaultStack && !!features[flags.PROVISIONING_CONFIGURABLE];

         var services = {};
         services[keys.VMOTION] = {
            includeInLayout: true,
            isEnabled: isVmotionEnabled,
            label: getString('VnicPortPropertiesPage.vMotion'),
            summaryLabel: getString('AddNetworkingWizard.summary.vmotion'),
            tooltip: getServiceTooltipPerStack(isVmotionEnabled,
                  !!settings[keys.VMOTION], isDefaultStack)
         };
         services[keys.PROVISIONING] = {
            includeInLayout: !!features[flags.PROVISIONING],
            isEnabled: isProvisioningEnabled,
            label: getString('VnicPortPropertiesPage.provisioningNfcTraffic'),
            summaryLabel: getString('AddNetworkingWizard.summary.provisioningNfcTraffic'),
            tooltip:  getServiceTooltipPerStack(isProvisioningEnabled,
                  !!settings[keys.PROVISIONING], isDefaultStack)
         };
         services[keys.FT_LOGGING] = {
            includeInLayout: true,
            isEnabled: isDefaultStack,
            label: getString('VnicPortPropertiesPage.ftLogging'),
            summaryLabel: getString('AddNetworkingWizard.summary.ftLogging'),
            tooltip: getServiceTooltip(isDefaultStack, !!settings[keys.FT_LOGGING])
         };
         services[keys.MANAGEMENT] = {
            includeInLayout: true,
            isEnabled: isDefaultStack,
            label: getString('VnicPortPropertiesPage.mngTraffic'),
            summaryLabel: getString('AddNetworkingWizard.summary.managementTraffic'),
            tooltip: getServiceTooltip(isDefaultStack, !!settings[keys.MANAGEMENT])
         };
         services[keys.VR] = {
            includeInLayout: !!features[flags.VR],
            isEnabled: isDefaultStack,
            label: getString('VnicPortPropertiesPage.vRTraffic'),
            summaryLabel: getString('AddNetworkingWizard.summary.vRTraffic'),
            tooltip: getServiceTooltip(isDefaultStack, !!settings[keys.VR])
         };
         services[keys.VR_NFC] = {
            includeInLayout: !!features[flags.VR_NFC],
            isEnabled: isDefaultStack,
            label: getString('VnicPortPropertiesPage.vrNfcTraffic'),
            summaryLabel: getString('AddNetworkingWizard.summary.vrNfcTraffic'),
            tooltip: getServiceTooltip(isDefaultStack, !!settings[keys.VR_NFC])
         };
         services[keys.VSAN] =  {
            includeInLayout: !!features[flags.VSAN],
            isEnabled: isDefaultStack,
            label: getString('VnicPortPropertiesPage.vsan'),
            summaryLabel: getString('AddNetworkingWizard.summary.vsan'),
            tooltip: getServiceTooltip(isDefaultStack, !!settings[keys.VSAN])
         };

         return services;
      }

      /**
       * Returns flags that describe services are enabled on host vnic.
       * Only settings for the supported services are included in the result.
       *
       * @param hostVnicFeatures
       *    Feature flags describing host services that can be enabled on vnics.
       *    Object with hostVnicServiceConstants.featureFlags keys and boolean values.
       *
       *    Example:
       *    ```js
       *       var hostVnicFeatures = {
       *          isProvisioningNfcTrafficSupported: true,
       *          isVrTrafficSupported: true,
       *          isVsanSupported: true
       *          // ...
       *       }
       *    ```
       * @return
       *    Example:
       *    ```js
       *       var result = {
       *          isVmotionEnabled: false,  // default, always available
       *          isProvisioningNfcTrafficEnabled: false,
       *          isVRTrafficEnabled: false,
       *          isVsanEnabled: false
       *          // ...
       *       }
       *    ```
       *
       * @see hostVnicServiceConstants.keys
       * @see hostVnicServiceConstants.featureFlags
       */
      function getServiceSettings(hostVnicFeatures) {
         var keys = hostVnicServiceConstants.keys;
         var flags = hostVnicServiceConstants.featureFlags;

         var settings = {};
         settings[keys.FT_LOGGING] = false;
         settings[keys.MANAGEMENT] = false;

         // defaults
         if (!!!hostVnicFeatures) {
            return settings;
         }

         // conditional
         if (!!hostVnicFeatures[flags.PROVISIONING] &&
               !!hostVnicFeatures[flags.TCP_IP_STACK_PROVISIONING]) {
            settings[keys.PROVISIONING] = true;
         } else if (!!hostVnicFeatures[flags.PROVISIONING]) {
            settings[keys.PROVISIONING] = false;
         }

         if (!!hostVnicFeatures[flags.TCP_IP_STACK_VMOTION]) {
            settings[keys.VMOTION] = true;
         } else {
            settings[keys.VMOTION] = false;
         }

         if (!!hostVnicFeatures[flags.VR]) {
            settings[keys.VR] = false;
         }

         if (!!hostVnicFeatures[flags.VR_NFC]) {
            settings[keys.VR_NFC] = false;
         }

         if (!!hostVnicFeatures[flags.VSAN]) {
            settings[keys.VSAN] = false;
         }

         return settings;
      }

      /**
       * Returns an object with service settings picked from the provided data.
       *
       * @see hostVnicServiceConstants.keys
       */
      function pickServiceSettings(vmkernelSettingsSpec) {
         var keys = hostVnicServiceConstants.keys;

         return _.pick(
               vmkernelSettingsSpec,
               keys.VMOTION,
               keys.PROVISIONING,
               keys.FT_LOGGING,
               keys.MANAGEMENT,
               keys.VR,
               keys.VR_NFC,
               keys.VSAN);
      }

      /**
       * Returns an object with service features picked from the provided data.
       *
       * @see hostVnicServiceConstants.featureFlags
       */
      function pickServiceFeatures(data) {
         var flags = hostVnicServiceConstants.featureFlags;

         return _.pick(
               data,
               flags.VMOTION_CONFIGURABLE,
               flags.PROVISIONING_CONFIGURABLE,
               flags.PROVISIONING,
               flags.FT_LOGGING,
               flags.VR,
               flags.VR_NFC,
               flags.VSAN,
               flags.TCP_IP_STACK,
               flags.TCP_IP_STACK_DEFAULT,
               flags.TCP_IP_STACK_PROVISIONING,
               flags.TCP_IP_STACK_VMOTION);
      }

      function getServiceTooltip(isConfigurable, isOn) {
         var isDefaultStackSelected = false;
         return getServiceTooltipPerStack(isConfigurable, isOn, isDefaultStackSelected);
      }

      function getServiceTooltipPerStack(isConfigurable, isOn, isDefaultStackSelected) {
         if (isConfigurable === false) {
            var uncheckedServiceTooltip = (isDefaultStackSelected)
                  ? getString('VnicPortPropertiesPage.cannotBeEnabledOnDefaultStackServiceTooltip')
                  : getString('VnicPortPropertiesPage.disabledUnCheckedServiceTooltip');

            return (!!isOn)
                  ? getString('VnicPortPropertiesPage.disabledCheckedServiceTooltip')
                  : uncheckedServiceTooltip;
         }

         return '';
      }

      function getString(key) {
         return i18nService.getString('NetworkUi', key);
      }
   }
})();
(function () {
   'use strict';

   /**
    * Shows list of host services that can be enabled on a VMkernel adapter.
    * The services are rendered as list of checkbox label pairs.
    *
    * Example:
    *    [] vMotion
    *    [] Provisioning
    *    [] Fault Tolerance loging
    *
    * @param hostVnicFeatures (input, optional)
    *    Features describing the services the directive will render.
    *
    *    Example:
    *    ```js
    *       var hostVnicFeatures = {
    *          isVmotionConfigurable: true,
    *          isProvisioningConfigurable: true,
    *          isVsanSupported: true
    *          // ...
    *       }
    *    ```
    *
    * @param hostVnicSettings (input, output, optional)
    *
    *    Example:
    *    ```js
    *       var hostVnicSettings = {
    *          isVmotionEnabled: true,
    *          isProvisioningNfcTrafficEnabled: false,
    *          isVsanEnabled: false
    *          // ...
    *       }
    *    ```
    *
    *    Usage:
    *       <host-vnic-services
    *          host-vnic-features="hostVnicFeatures"
    *          host-vnic-settings="vmkernelSettingsSpec">
    *       </host-vnic-services>
    *
    * @see hostVnicServiceConstants.keys
    * @see hostVnicServiceConstants.featureFlags
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .directive('hostVnicServices', hostVnicServices);

   hostVnicServices.$inject = [];

   function hostVnicServices() {
      var directive = {
         restrict: 'E',
         scope: {
            hostVnicFeatures: '=?', // show/hide or enable/disable UI components
            hostVnicSettings: '=?'  // on/off service traffic
         },
         templateUrl: 'network-ui/resources/network/views/host/common/' +
               'hostVnicServices/hostVnicServices.html',
         controller: HostVnicServicesController
      };

      return directive;
   }

   // Note: i18n service is not available for templates of directive's with isolated
   // scope. Hence it is injected explicitly.
   HostVnicServicesController.$inject = [
         '$scope',
         'i18nService',
         'hostVnicServiceFactory'];

   function HostVnicServicesController(
         $scope,
         i18nService,
         hostVnicServiceFactory) {

      $scope.getString = getString;

      $scope.hostVnicSettings = $scope.hostVnicSettings
            || hostVnicServiceFactory
                  .getServiceSettings($scope.hostVnicFeatures);

      $scope.$watch('hostVnicFeatures', function (value) {
         $scope.services = hostVnicServiceFactory
               .getServiceDescriptions(value, $scope.hostVnicSettings);
      });

      function getString(key) {
         return i18nService.getString('NetworkUi', key);
      }
   }
})();
var network_ui;
(function (network_ui) {
    /**
     * List to show IPv6 address, prefix length and default gateway.
     * It supports add, edit and remove operations.
     *
     * @param {Ipv6ListData} listData
     *    The list config argument.
     *
     * @param {boolean} isEnabled
     *    Enables the component if set to true.
     */
    var Ipv6ListComponent = (function () {
        function Ipv6ListComponent() {
            this.bindings = {
                listData: "<",
                isEnabled: "<"
            };
            this.controller = Ipv6ListComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/common/" +
                "ipv6List/ipv6List.html";
        }
        return Ipv6ListComponent;
    }());
    network_ui.Ipv6ListComponent = Ipv6ListComponent;
    /**
     * Ipv6List component configuration data.
     */
    var Ipv6ListData = (function () {
        function Ipv6ListData() {
        }
        return Ipv6ListData;
    }());
    network_ui.Ipv6ListData = Ipv6ListData;
    /**
     * Represents a single IPv6 list item.
     */
    var Ipv6ListItem = (function () {
        function Ipv6ListItem() {
        }
        return Ipv6ListItem;
    }());
    network_ui.Ipv6ListItem = Ipv6ListItem;
    var Ipv6ListComponentController = (function () {
        function Ipv6ListComponentController($scope, vuiConstants, i18nService, networkUiConstants, ipv6DialogService) {
            var _this = this;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.ipv6DialogService = ipv6DialogService;
            this.datagridOptions = this.createDatagridOptions();
            //watch selected items in order to update action bar
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (selectedItems) {
                _this.updateActionBar(selectedItems.length);
            });
        }
        Ipv6ListComponentController.prototype.$onChanges = function () {
            if (this.datagridOptions && this.listData) {
                this.datagridOptions.data = this.listData.ipv6List || [];
                this.updateActionBar(this.datagridOptions.selectedItems.length);
            }
        };
        Ipv6ListComponentController.prototype.createDatagridOptions = function () {
            return {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.initializeColumnDefs(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: [],
                selectedItems: [],
                actionBarOptions: {
                    actions: this.initializeActions()
                }
            };
        };
        Ipv6ListComponentController.prototype.initializeColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("NetworkUi", "VnicIpv6SettingsPage.ipv6Address"),
                    field: "address",
                    template: "#:address#"
                },
                {
                    displayName: this.i18nService.getString("NetworkUi", "VnicIpv6SettingsPage.prefixLength"),
                    field: "prefixLength",
                    template: "#:prefixLength#"
                }];
        };
        Ipv6ListComponentController.prototype.initializeActions = function () {
            return [
                {
                    actionId: this.networkUiConstants.DatagridActions.ADD,
                    enabled: this.isEnabled,
                    visible: true,
                    iconClass: "vsphere-icon-add",
                    onClick: this.openAddIpv6Dialog.bind(this)
                },
                this.vuiConstants.actions.SEPARATOR,
                {
                    actionId: this.networkUiConstants.DatagridActions.EDIT,
                    enabled: false,
                    visible: true,
                    iconClass: "vsphere-icon-toolbar-edit",
                    onClick: this.openEditIpv6Dialog.bind(this)
                },
                {
                    actionId: this.networkUiConstants.DatagridActions.DELETE,
                    enabled: false,
                    visible: true,
                    iconClass: "vsphere-icon-toolbar-remove",
                    onClick: this.removeSelectedItem.bind(this)
                }
            ];
        };
        Ipv6ListComponentController.prototype.updateActionBar = function (selectedItemsLength) {
            var _this = this;
            _.each(this.datagridOptions.actionBarOptions.actions, function (action) {
                if (action.actionId === _this.networkUiConstants.DatagridActions.EDIT ||
                    action.actionId === _this.networkUiConstants.DatagridActions.DELETE) {
                    action.enabled = !!_this.isEnabled && selectedItemsLength > 0;
                }
                else if (action.actionId === _this.networkUiConstants.DatagridActions.ADD) {
                    action.enabled = !!_this.isEnabled;
                }
            });
        };
        Ipv6ListComponentController.prototype.removeSelectedItem = function () {
            var selectedItemIndex = this.indexOfSelectedAddress();
            this.listData.ipv6List.splice(selectedItemIndex, 1);
            this.datagridOptions.data = this.listData.ipv6List.slice();
        };
        Ipv6ListComponentController.prototype.openAddIpv6Dialog = function () {
            var ipv6Details = {};
            ipv6Details.defaultGateway = this.listData.defaultGateway;
            this.ipv6DialogService.openIpv6AddressesDialog(this.i18nService.getString("NetworkUi", "Ipv6AddressPage.addTitle"), ipv6Details, this.createUsedAddressInfo(), this.addOkHandler.bind(this));
        };
        Ipv6ListComponentController.prototype.openEditIpv6Dialog = function () {
            var ipv6Details = {};
            ipv6Details.address = this.datagridOptions.selectedItems[0].address;
            ipv6Details.prefixLength = this.datagridOptions.selectedItems[0].prefixLength;
            ipv6Details.defaultGateway = this.listData.defaultGateway;
            this.ipv6DialogService.openIpv6AddressesDialog(this.i18nService.getString("NetworkUi", "Ipv6AddressPage.editTitle"), ipv6Details, this.createUsedAddressInfo(), this.editOkHandler.bind(this));
        };
        Ipv6ListComponentController.prototype.addOkHandler = function (ipv6Address) {
            var newAddress = new Ipv6ListItem();
            newAddress.address = ipv6Address.address;
            newAddress.prefixLength = ipv6Address.prefixLength;
            this.listData.ipv6List.push(newAddress);
            // Clone the array in order to trigger grid refresh
            this.datagridOptions.data = this.listData.ipv6List.slice();
        };
        Ipv6ListComponentController.prototype.editOkHandler = function (ipv6Address) {
            var selectedItemIndex = this.indexOfSelectedAddress();
            this.listData.ipv6List[selectedItemIndex].address = ipv6Address.address;
            this.listData.ipv6List[selectedItemIndex].prefixLength = ipv6Address.prefixLength;
            this.datagridOptions.data = this.listData.ipv6List.slice();
        };
        Ipv6ListComponentController.prototype.indexOfSelectedAddress = function () {
            var index = -1;
            if (this.datagridOptions.selectedItems &&
                this.datagridOptions.selectedItems.length === 1) {
                var selectedAddress_1 = this.datagridOptions.selectedItems[0];
                _.forEach(this.listData.ipv6List, function (address, addressIndex) {
                    if (address.address === selectedAddress_1.address) {
                        index = addressIndex;
                    }
                });
            }
            return index;
        };
        Ipv6ListComponentController.prototype.createUsedAddressInfo = function () {
            var usedAddressInfo = {};
            usedAddressInfo.hostAddresses = this.listData.hostIpv6Addresses;
            usedAddressInfo.vmknicAddresses = this.getVmnicAddressesInUse();
            return usedAddressInfo;
        };
        Ipv6ListComponentController.prototype.getVmnicAddressesInUse = function () {
            return _.map(this.listData.ipv6List, function (ipv6Address) {
                return ipv6Address.address;
            });
        };
        Ipv6ListComponentController.$inject = [
            "$scope",
            "vuiConstants",
            "i18nService",
            "networkUiConstants",
            "ipv6DialogService"];
        return Ipv6ListComponentController;
    }());
    angular
        .module("com.vmware.vsphere.client.network")
        .component("ipv6List", new Ipv6ListComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditIpv6SupportComponent = (function () {
        function EditIpv6SupportComponent() {
            this.bindings = {
                hostId: "<",
                onSubmitWrapper: "="
            };
            this.controller = EditIpv6SupportController;
            this.templateUrl =
                "network-ui/resources/network/views/host/editIpv6SupportTemplate.html";
        }
        return EditIpv6SupportComponent;
    }());
    network_ui.EditIpv6SupportComponent = EditIpv6SupportComponent;
    var EditIpv6SupportController = (function () {
        function EditIpv6SupportController(i18nService, dataService, $scope, $q, mutationService) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.$scope = $scope;
            this.$q = $q;
            this.mutationService = mutationService;
            this.atBootIpV6EnabledProperty = "config.network.atBootIpV6Enabled";
            this.ipv6EnabledProperty = "config.network.ipV6Enabled";
            this.supportStateLabel = i18nService.getString("NetworkUi", "IPv6SupportView.ipv6SupportedDialogTitle");
            this.buttonLabel = i18nService.getString("NetworkUi", "IPv6SupportView.enableIPv6SupportButtonLabel");
            this.changeLabel =
                i18nService.getString("NetworkUi", "IPv6SupportView.changeLabel");
            if (this.onSubmitWrapper) {
                this.onSubmitWrapper.submit = this.submit.bind(this);
            }
        }
        EditIpv6SupportController.prototype.$onInit = function () {
            var _this = this;
            this.dataService.getProperties(this.hostId, [this.atBootIpV6EnabledProperty, this.ipv6EnabledProperty])
                .then(function (response) {
                _this.savedSupportState = response[_this.atBootIpV6EnabledProperty];
                var statusChanged = response[_this.ipv6EnabledProperty] !== _this.savedSupportState;
                var enabledLabel = _this.i18nService.getString("NetworkUi", "IPv6SupportView.enabled");
                var disabledLabel = _this.i18nService.getString("NetworkUi", "IPv6SupportView.disabled");
                _this.supportStateValueLabel = statusChanged ?
                    _this.savedSupportState ? disabledLabel : enabledLabel :
                    _this.savedSupportState ? enabledLabel : disabledLabel;
                _this.supportButtonState = _this.savedSupportState;
            });
        };
        EditIpv6SupportController.prototype.submit = function () {
            if (this.savedSupportState !== this.supportButtonState) {
                var spec = {
                    _type: "com.vmware.vsphere.client.network.NetworkConfigSpec",
                    config: {
                        _type: 'com.vmware.vim.binding.vim.host.NetworkConfig',
                        ipV6Enabled: this.supportButtonState
                    }
                };
                this.mutationService.apply(this.hostId, spec._type, spec);
            }
            return true;
        };
        EditIpv6SupportController.$inject = [
            "i18nService",
            "dataService",
            "$scope",
            "$q",
            "mutationService"
        ];
        return EditIpv6SupportController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editIpv6Support", new EditIpv6SupportComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    *  Helper for opening an IPv6 address modal dialog.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .service('ipv6DialogService', ipv6DialogService);

   ipv6DialogService.$inject = [
         '$rootScope',
         'clarityModalService',
         'clarityConstants',
         'i18nService',
         'networkUiConstants',
         'ipParserService'];

   function ipv6DialogService($rootScope,
         clarityModalService,
         clarityConstants,
         i18nService,
         networkUiConstants,
         ipParserService) {

      // ======================= Public API ==========================

      return {
         openIpv6AddressesDialog: openIpv6AddressesDialog
      };

      //======================= Public Functions ==========================

      /**
       * Opens an OK/Cancel modal dialog in the application.
       */
      function openIpv6AddressesDialog(title, ipv6Details, usedAddressesInfo, okHandler) {
         var ipv6Address = {
            address: (ipv6Details && ipv6Details.address)
                  ? ipv6Details.address
                  : '',
            prefixLength: (ipv6Details && ipv6Details.prefixLength)
                  ? ipv6Details.prefixLength
                  : networkUiConstants.Ipv6PrefixLength.DEFAULT,
            defaultGateway: (ipv6Details && ipv6Details.defaultGateway)
                  ? ipv6Details.defaultGateway
                  : i18nService.getString('NetworkUi', 'NetworkUtil.noData')
         };

         var modalOptions = {
            title: title,
            defaultButton: 'submit',
            size: 'lg',
            alerts: [],
            dialogData: {
               newIpv6Address: ipv6Address
            },
            contentTemplate: 'network-ui/resources/network/views/host/ipv6Address/' +
                  'ipv6Dialog.html',
            onSubmit: onSubmit
         };

         clarityModalService.openOkCancelModal(modalOptions);

         function onSubmit() {
            var error;
            var hasIpAddressChanged = ipv6Details &&
                  ipv6Details.address !== modalOptions.dialogData.newIpv6Address.address;

            if (hasIpAddressChanged) {
               error = getIpv6ValidationError(
                     modalOptions.dialogData.newIpv6Address.address, usedAddressesInfo);
            }

            if (!error) {
               error = getPrefixLengthValidationError(
                     modalOptions.dialogData.newIpv6Address.prefixLength);
            }

            if (error) {
               showError(error, modalOptions);
               return false;
            }

            if (okHandler) {
               okHandler(modalOptions.dialogData.newIpv6Address);
            }

            return true;
         }
      }

      function getIpv6ValidationError(ipAddress, usedAddressesInfo) {
         var DEFAULT_UNICAST_ROUTE_ADDRESS = "::";
         var LOOPBACK_ADDRESS = "::1";

         if (!ipParserService.isIpv6AddressValid(ipAddress)
               || ipParserService.equalIpv6Addresses(ipAddress,
                     DEFAULT_UNICAST_ROUTE_ADDRESS)
               || ipParserService.equalIpv6Addresses(ipAddress,
                     LOOPBACK_ADDRESS)) {
            return i18nService.getString(
                  'NetworkUi',
                  'Ipv6AddressPage.invalidIpAddressError');
         } else if (someIpv6(ipAddress, usedAddressesInfo.vmknicAddresses)) {
            return i18nService.getString(
                  'NetworkUi',
                  'Ipv6AddressPage.duplicateIpv6AddressNewVnicError',
                  ipAddress);
         } else {
            var vmknicWithSameIpv6 = getHostVmknicWithDuplicateIpv6(ipAddress,
                  usedAddressesInfo.hostAddresses);
            // There is nic with the same IPv6 on the same host
            if (vmknicWithSameIpv6 !== null) {
               return i18nService.getString(
                     'NetworkUi',
                     'Ipv6AddressPage.duplicateIpv6AddressDvsError',
                     ipAddress,
                     vmknicWithSameIpv6);
            }
         }
      }

      function getPrefixLengthValidationError (prefixLength) {
         if (!ipParserService.isSubnetPrefixValid(prefixLength)) {
            return i18nService.getString(
                  'NetworkUi',
                  'Ipv6AddressPage.invalidPrefixError');
         }
      }

      function showError(errorMessage, modalOptions) {
         modalOptions.alerts = [{
            text: errorMessage,
            type: clarityConstants.notifications.type.ERROR
         }];
      }

      function getHostVmknicWithDuplicateIpv6(ipv6Address, hostAddresses) {
         var vmknicWithSameIp = null;
         _.forEach(hostAddresses, function (vmknicAddresses, vmknic) {
            if (someIpv6(ipv6Address, vmknicAddresses)) {
               vmknicWithSameIp = vmknic;
            }
         });

         return vmknicWithSameIp;
      }

      function someIpv6(ipv6Address, vmknicAddresses) {
         return _.some(vmknicAddresses, function (address) {
            return ipParserService.equalIpv6Addresses(address, ipv6Address);
         });
      }
   }
})();

var network_ui;
(function (network_ui) {
    var IscsiAddPortBinding = (function () {
        function IscsiAddPortBinding() {
            this.bindings = {
                hostId: "<",
                iscsiHbaName: "<",
                onSubmitWrapper: "="
            };
            this.controller = IscsiPortBindingDialogController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/add/IscsiAddPortBinding.html";
        }
        return IscsiAddPortBinding;
    }());
    network_ui.IscsiAddPortBinding = IscsiAddPortBinding;
    var IscsiPortBindingDialogController = (function () {
        function IscsiPortBindingDialogController(i18nService, iscsiPortBindingService, $q, vuiConstants) {
            this.i18nService = i18nService;
            this.iscsiPortBindingService = iscsiPortBindingService;
            this.$q = $q;
            this.vuiConstants = vuiConstants;
            this._iscsiPortBindingCandidatesData = {
                items: []
            };
            this.selectedPortGroups = [];
            this.loading = false;
            if (this.onSubmitWrapper) {
                this.onSubmitWrapper.submit = this.submit.bind(this);
            }
        }
        IscsiPortBindingDialogController.prototype.$onInit = function () {
            var self = this;
            self.splitterOptions = {
                orientation: self.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "150px",
                        size: "50%"
                    }, {
                        min: "150px",
                        size: "50%"
                    }
                ]
            };
            this.loading = true;
            this.iscsiPortBindingService.getCandidateIscsiPortInfoData(this.hostId, this.iscsiHbaName)
                .then(function (iscsiPortInfoData) {
                if (!iscsiPortInfoData) {
                    return;
                }
                self._iscsiPortBindingCandidatesData = iscsiPortInfoData;
            }).finally(function () {
                self.loading = false;
            });
        };
        Object.defineProperty(IscsiPortBindingDialogController.prototype, "candidateIscsiPortBindingItem", {
            get: function () {
                if (this.selectedPortGroups && this.selectedPortGroups.length === 1) {
                    return this.selectedPortGroups[0];
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IscsiPortBindingDialogController.prototype, "noDetailsMessage", {
            get: function () {
                if (this.selectedPortGroups && this.selectedPortGroups.length > 1) {
                    return this.i18nService.getString("Common", "ListPreviewSplitView.multipleItemsSelected");
                }
                else {
                    return this.i18nService.getString("Common", "ListPreviewSplitView.noItemsSelected");
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Performs the port addition operation after validating the grid selection.
         *
         * @param onSuccessCallback (optional)
         *      function to be called upon successful completion of the mutation operation
         *
         * @returns {IPromise<AddPortBindingResult>}
         *      result of the immediate validation - e.g.
         *      {isSuccessful: false, errors: ["..."]} if no adapters have been selected
         */
        IscsiPortBindingDialogController.prototype.submit = function (onSuccessCallback) {
            var operationResult = { isSuccessful: true, errors: [] };
            if (!this.selectedPortGroups || !this.selectedPortGroups.length) {
                operationResult.isSuccessful = false;
                operationResult.errors.push(this.i18nService.getString("NetworkUi", "portbinding.addForm.notSelected"));
                return this.$q.when(operationResult);
            }
            var addCandidatePromise = this.iscsiPortBindingService.addCandidateIscsiPortInfo(this.hostId, this.iscsiHbaName, this.selectedPortGroups);
            if (onSuccessCallback) {
                addCandidatePromise.then(onSuccessCallback);
            }
            return this.$q.when(operationResult);
        };
        Object.defineProperty(IscsiPortBindingDialogController.prototype, "iscsiPortBindingCandidatesData", {
            get: function () {
                return this._iscsiPortBindingCandidatesData;
            },
            enumerable: true,
            configurable: true
        });
        IscsiPortBindingDialogController.$inject = ["i18nService", "iscsiPortBindingService", "$q", "vuiConstants"];
        return IscsiPortBindingDialogController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiAddPortBinding", new IscsiAddPortBinding());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiAddPortBindingCandidatesList = (function () {
        function IscsiAddPortBindingCandidatesList() {
            this.bindings = {
                candidatePortGroupsData: "<",
                selectedPortGroups: "=?"
            };
            this.controller = IscsiAddPortBindingCandidatesListController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/add/IscsiAddPortBindingCandidatesList.html";
        }
        return IscsiAddPortBindingCandidatesList;
    }());
    network_ui.IscsiAddPortBindingCandidatesList = IscsiAddPortBindingCandidatesList;
    var IscsiAddPortBindingCandidatesListController = (function () {
        function IscsiAddPortBindingCandidatesListController($scope, i18nService, iscsiPortBindingService, vuiConstants, columnRenderersRegistry) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.iscsiPortBindingService = iscsiPortBindingService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
        }
        IscsiAddPortBindingCandidatesListController.prototype.$onInit = function () {
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: false
                },
                columnDefs: this.getColumnDefs(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                selectedItems: [],
                resizable: true,
                actionBarOptions: { actions: [] },
                isItemDisabledCallback: function (item) {
                    return !item.isCompliant;
                }
            };
            if (this.candidatePortGroupsData) {
                this.initGridData();
            }
            var self = this;
            this.$scope.$watch(function () {
                return self.datagridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                if (newSelection === oldSelection || _.isEqual(newSelection, oldSelection)) {
                    return;
                }
                self.selectedPortGroups = newSelection;
            });
        };
        IscsiAddPortBindingCandidatesListController.prototype.$onChanges = function (changes) {
            if (this.datagridOptions && changes.candidatePortGroupsData) {
                this.initGridData();
            }
        };
        IscsiAddPortBindingCandidatesListController.prototype.getColumnDefs = function () {
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            var renderImageLabel = function (imageLabel) {
                if (imageLabel.icon) {
                    return iconTextRenderer(["icon", "label"], imageLabel);
                }
                return textRenderer(["label"], imageLabel);
            };
            return [
                {
                    displayName: this.i18nService.getString("NetworkUi", "portbinding.list.portgroup.label"),
                    field: "portgroupName.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.portgroupName);
                    }
                },
                {
                    displayName: this.i18nService.getString("NetworkUi", "portbinding.list.vMKernel.label"),
                    field: "vmKernelAdapter.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.vmKernelAdapter);
                    }
                },
                {
                    displayName: this.i18nService.getString("NetworkUi", "portbinding.list.physicalNetworkAdapter.label"),
                    field: "physicalNetworkAdapterInfo.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.physicalNetworkAdapterInfo);
                    }
                }
            ];
        };
        IscsiAddPortBindingCandidatesListController.prototype.initGridData = function () {
            this.datagridOptions.data = this.candidatePortGroupsData.items;
        };
        IscsiAddPortBindingCandidatesListController.$inject = ["$scope", "i18nService", "iscsiPortBindingService", "vuiConstants", "columnRenderersRegistry"];
        return IscsiAddPortBindingCandidatesListController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiAddPortBindingCandidatesList", new IscsiAddPortBindingCandidatesList());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingDetailsDialogService = (function () {
        function IscsiPortBindingDetailsDialogService($rootScope, clarityModalService, i18nService) {
            this.$rootScope = $rootScope;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
        }
        IscsiPortBindingDetailsDialogService.prototype.show = function (hostId, infoItem) {
            if (!hostId || !infoItem) {
                return;
            }
            var modalScope = this.$rootScope.$new();
            modalScope.modalOptions = {
                contentUrl: "network-ui/resources/network/views/host/iscsi/details/IscsiPortBindingDetailsDialog.html",
                title: this.i18nService.getString("H5NetworkUi", "portbinding.detailsDialog.title", infoItem.vnicDevice),
                size: "lg",
                dialogData: {
                    hostId: hostId,
                    iscsiPortBindingItem: infoItem
                }
            };
            this.clarityModalService.openPopUp(modalScope);
        };
        IscsiPortBindingDetailsDialogService.$inject = ["$rootScope", "clarityModalService", "i18nService"];
        return IscsiPortBindingDetailsDialogService;
    }());
    network_ui.IscsiPortBindingDetailsDialogService = IscsiPortBindingDetailsDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("iscsiPortBindingDetailsDialogService", IscsiPortBindingDetailsDialogService);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingDetailsTab = (function () {
        function IscsiPortBindingDetailsTab() {
            this.bindings = {
                hostId: "<",
                iscsiPortBindingItem: "<",
                isBoundPortBinding: "<",
                detailsRetriever: "<"
            };
            this.controller = IscsiPortBindingDetailsTabController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/details/IscsiPortBindingDetailsTab.html";
        }
        return IscsiPortBindingDetailsTab;
    }());
    network_ui.IscsiPortBindingDetailsTab = IscsiPortBindingDetailsTab;
    var IscsiPortBindingDetailsTabController = (function () {
        function IscsiPortBindingDetailsTabController(i18nService) {
            this.i18nService = i18nService;
            this.loading = false;
            this.i18n = i18nService.getString;
        }
        IscsiPortBindingDetailsTabController.prototype.$onChanges = function () {
            this.populatePropertyData();
        };
        IscsiPortBindingDetailsTabController.prototype.populatePropertyData = function () {
            var self = this;
            if (!self.hostId || !self.iscsiPortBindingItem || !self.detailsRetriever) {
                self.loading = false;
                self.noDetailsAvailable = true;
                return;
            }
            self.loading = true;
            self.noDetailsAvailable = true;
            var viewDataPromise = self.detailsRetriever.retrieveData(self.hostId, self.iscsiPortBindingItem, self.isBoundPortBinding);
            self._lastDataRequest = viewDataPromise;
            viewDataPromise.then(function (viewData) {
                if (viewDataPromise === self._lastDataRequest) {
                    if (viewData && viewData.propertiesData) {
                        self.propertiesData = viewData.propertiesData;
                        self.header = viewData.viewTitle;
                        self.noDetailsAvailable = false;
                    }
                }
            }).finally(function () {
                if (viewDataPromise === self._lastDataRequest) {
                    self.loading = false;
                }
            });
        };
        IscsiPortBindingDetailsTabController.$inject = ["i18nService", "physicalAdaptersListService", "physicalAdapterDetailsViewService"];
        return IscsiPortBindingDetailsTabController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiPortBindingDetailsTab", new IscsiPortBindingDetailsTab());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingDetailsViewDataRetriever = network_ui.IscsiPortBindingDetailsViewDataRetriever;
    var IscsiPortBindingDetailsView = (function () {
        function IscsiPortBindingDetailsView() {
            this.bindings = {
                hostId: "<",
                iscsiPortBindingItem: "<",
                isBoundPortBinding: "<"
            };
            this.controller = IscsiPortBindingDetailsViewController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/details/IscsiPortBindingDetailsView.html";
        }
        return IscsiPortBindingDetailsView;
    }());
    network_ui.IscsiPortBindingDetailsView = IscsiPortBindingDetailsView;
    var IscsiPortBindingDetailsViewController = (function () {
        function IscsiPortBindingDetailsViewController(i18nService, iscsiPortBindingDetailsService) {
            this.i18nService = i18nService;
            this.iscsiPortBindingDetailsService = iscsiPortBindingDetailsService;
            this.i18n = i18nService.getString;
            this.portGroupDetailsRetriever = new IscsiPortBindingDetailsViewDataRetriever(iscsiPortBindingDetailsService.requestPortgroupDetailsViewData.bind(iscsiPortBindingDetailsService));
            this.pnicDetailsRetriever = new IscsiPortBindingDetailsViewDataRetriever(iscsiPortBindingDetailsService.requestPnicDetailsViewData.bind(iscsiPortBindingDetailsService));
            this.vnicDetailsRetriever = new IscsiPortBindingDetailsViewDataRetriever(iscsiPortBindingDetailsService.requestVnicDetailsViewData.bind(iscsiPortBindingDetailsService));
            this.switchDetailsRetriever = new IscsiPortBindingDetailsViewDataRetriever(iscsiPortBindingDetailsService.requestSwitchDetailsViewData.bind(iscsiPortBindingDetailsService));
        }
        IscsiPortBindingDetailsViewController.$inject = ["i18nService", "iscsiPortBindingDetailsService"];
        return IscsiPortBindingDetailsViewController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiPortBindingDetailsView", new IscsiPortBindingDetailsView());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingStatusDetailsView = (function () {
        function IscsiPortBindingStatusDetailsView() {
            this.bindings = {
                hostId: "<",
                iscsiPortBindingItem: "<",
                isBoundPortBinding: "<"
            };
            this.controller = IscsiPortBindingStatusDetailsViewController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/details/IscsiPortBindingDetailsTab.html";
        }
        return IscsiPortBindingStatusDetailsView;
    }());
    network_ui.IscsiPortBindingStatusDetailsView = IscsiPortBindingStatusDetailsView;
    var IscsiPortBindingStatusDetailsViewController = (function () {
        function IscsiPortBindingStatusDetailsViewController(i18nService, vxPropertyViewService) {
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.loading = false;
            this.i18n = i18nService.getString;
        }
        IscsiPortBindingStatusDetailsViewController.prototype.$onChanges = function () {
            this.populatePropertyData();
        };
        IscsiPortBindingStatusDetailsViewController.prototype.populatePropertyData = function () {
            if (!this.iscsiPortBindingItem) {
                this.noDetailsAvailable = true;
                return;
            }
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            this.addPropertyValue(generalSection, this.i18nService.getString("NetworkUi", "portbinding.portGroupPolicyCompliance"), this.iscsiPortBindingItem.policyComplianceStatus);
            this.addComplianceErrors(generalSection);
            if (this.isBoundPortBinding) {
                this.addPropertyValue(generalSection, this.i18nService.getString("NetworkUi", "portbinding.pathStatus"), this.iscsiPortBindingItem.pathStatus);
            }
            this.propertiesData = builder.build();
            this.noDetailsAvailable = false;
        };
        IscsiPortBindingStatusDetailsViewController.prototype.addComplianceErrors = function (section) {
            if (!this.iscsiPortBindingItem.isCompliant) {
                if (!this.isBoundPortBinding &&
                    (!this.iscsiPortBindingItem.vnicDevice || !this.iscsiPortBindingItem.pnicDevice)) {
                    section.messageBuilder()
                        .text(this.i18nService.getString("NetworkUi", "portbinding.pnicNotAssociatedToVnicMessage"))
                        .icon("vsphere-icon-status-warning")
                        .renderAsHtml(true);
                }
                else {
                    _.forEach(this.iscsiPortBindingItem.complianceErrors, function (error) {
                        section.warning(error.localizedMessage || error.message);
                    });
                }
            }
        };
        IscsiPortBindingStatusDetailsViewController.prototype.addPropertyValue = function (section, propertyName, propValue) {
            return section.propertyBuilder()
                .keyBuilder().text(propertyName)
                .exit()
                .valueBuilder()
                .icon(propValue.icon)
                .text(propValue.label)
                .exit()
                .exit();
        };
        IscsiPortBindingStatusDetailsViewController.$inject = ["i18nService", "vxPropertyViewService"];
        return IscsiPortBindingStatusDetailsViewController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiPortBindingStatusDetailsView", new IscsiPortBindingStatusDetailsView());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var IscsiPortBindingList = (function () {
        function IscsiPortBindingList() {
            this.bindings = {
                hostId: "<",
                iscsiHba: "<",
                adapterWarnings: "<"
            };
            this.controller = IscsiPortBindingListController;
            this.templateUrl = "network-ui/resources/network/views/host/iscsi/IscsiPortBindingList.html";
        }
        return IscsiPortBindingList;
    }());
    network_ui.IscsiPortBindingList = IscsiPortBindingList;
    var IscsiPortBindingListController = (function () {
        function IscsiPortBindingListController(i18nService, iscsiPortBindingService, vuiConstants, columnRenderersRegistry, datagridActionBarService, $scope, networkUiConstants) {
            this.iscsiPortBindingService = iscsiPortBindingService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.datagridActionBarService = datagridActionBarService;
            this.$scope = $scope;
            this.networkUiConstants = networkUiConstants;
            this.i18n = i18nService.getString;
            this.loading = false;
            this.noPermissions = false;
        }
        IscsiPortBindingListController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: this.getColumnDefs(),
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                selectedItems: [],
                resizable: true,
                actionBarOptions: { actions: [] }
            };
            this.updateActionBar();
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                if (newSelection === oldSelection || _.isEqual(newSelection, oldSelection)) {
                    return;
                }
                _this.$scope.cachedItems = newSelection;
                _this.updateActionBar();
            });
            this.$scope.comparator = function (value) {
                var itemToSelect = _.find(_this.$scope.cachedItems, function (cachedItem) {
                    return cachedItem.pnicDevice === value.pnicDevice
                        && cachedItem.vnicDevice === value.vnicDevice
                        && cachedItem.switchName === value.switchName;
                });
                return itemToSelect !== undefined;
            };
        };
        IscsiPortBindingListController.prototype.$onChanges = function () {
            this.requestData();
        };
        IscsiPortBindingListController.prototype.requestData = function () {
            var self = this;
            if (!self.hostId || !self.iscsiHba || !self.iscsiHba.device) {
                return;
            }
            self.loading = true;
            self.iscsiPortBindingService.getBoundIscsiPortInfoData(self.hostId, self.iscsiHba.device)
                .then(function (response) {
                if (!response) {
                    return;
                }
                self.noPermissions = !response.hasPrivileges;
                self.datagridOptions.data = response.items;
            })
                .finally(function () {
                self.loading = false;
            });
        };
        IscsiPortBindingListController.prototype.getColumnDefs = function () {
            var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer("text");
            var renderImageLabel = function (imageLabel) {
                if (imageLabel.icon) {
                    return iconTextRenderer(["icon", "label"], imageLabel);
                }
                return textRenderer(["label"], imageLabel);
            };
            return [
                {
                    displayName: this.i18n("NetworkUi", "portbinding.list.portgroup.label"),
                    field: "portgroupName.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.portgroupName);
                    }
                },
                {
                    displayName: this.i18n("NetworkUi", "portbinding.list.vMKernel.label"),
                    field: "vmKernelAdapter.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.vmKernelAdapter);
                    }
                },
                {
                    displayName: this.i18n("NetworkUi", "portbinding.list.portgroupPolicy.label"),
                    field: "policyComplianceStatus.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.policyComplianceStatus);
                    }
                },
                {
                    displayName: this.i18n("NetworkUi", "portbinding.list.pathStatus.label"),
                    field: "pathStatus.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.pathStatus);
                    }
                },
                {
                    displayName: this.i18n("NetworkUi", "portbinding.list.physicalNetworkAdapter.label"),
                    field: "physicalNetworkAdapterInfo.label",
                    width: "180px",
                    template: function (item) {
                        return renderImageLabel(item.physicalNetworkAdapterInfo);
                    }
                }
            ];
        };
        IscsiPortBindingListController.prototype.getActionDefs = function () {
            var _this = this;
            var self = this;
            return [
                {
                    actionId: self.networkUiConstants.actions.ADD_PORT_BINDING_FOR_ISCSI,
                    getActionInvocationContext: function () {
                        return {
                            iscsiHbaName: self.iscsiHba.device,
                            onSuccessCallback: _this.onOperationCompleted.bind(self, self.iscsiHba.key, self.iscsiHba.device)
                        };
                    }
                },
                {
                    actionId: self.networkUiConstants.actions.REMOVE_PORT_BINDING_FROM_ISCSI,
                    getActionInvocationContext: function () {
                        return {
                            iscsiHbaName: self.iscsiHba.device,
                            adapters: self.datagridOptions.data,
                            selectedAdapters: self.datagridOptions.selectedItems,
                            onSuccessCallback: _this.onOperationCompleted.bind(self, self.iscsiHba.key, self.iscsiHba.device)
                        };
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available && self.datagridOptions.selectedItems.length !== 0;
                    }
                },
                {
                    actionId: self.networkUiConstants.actions.SHOW_ISCSI_PORT_BINDING_DETAILS,
                    isActionAvailable: function (actionDef) {
                        return actionDef.available && self.datagridOptions.selectedItems
                            && self.datagridOptions.selectedItems.length === 1;
                    },
                    getActionInvocationContext: function () {
                        return {
                            iscsiPortInfoItem: self.datagridOptions.selectedItems[0]
                        };
                    }
                }
            ];
        };
        IscsiPortBindingListController.prototype.updateActionBar = function () {
            this.datagridActionBarService.updateActionBar(this.datagridOptions, [this.hostId], this.getActionDefs());
        };
        IscsiPortBindingListController.prototype.onOperationCompleted = function (deviceKey, deviceName, result) {
            if (result && !result.error) {
                this.adapterWarnings.addRescanMessage(deviceKey, deviceName);
            }
            this.requestData();
        };
        IscsiPortBindingListController.$inject = ["i18nService", "iscsiPortBindingService", "vuiConstants", "columnRenderersRegistry",
            "datagridActionBarService", "$scope", "networkUiConstants"];
        return IscsiPortBindingListController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("iscsiPortBindingList", new IscsiPortBindingList());
})(network_ui || (network_ui = {}));



(function () {
   "use strict";
   angular.module("com.vmware.vsphere.client.network").controller(
         "IscsiPortBindingViewController", IscsiPortBindingViewController);

   IscsiPortBindingViewController.$inject = ["i18nService", "navigation"];

   function IscsiPortBindingViewController (i18nService, navigation) {
      this.i18n = i18nService.getString;
      this.hostId = navigation.getRoute().objectId;
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var DestinationStandardPortGroupInitialInfo = com.vmware.vsphere.client.h5.network.host.migratevmkadapter.model.DestinationStandardPortGroupInitialInfo;
    var ConfigureSettingsComponent = (function () {
        function ConfigureSettingsComponent() {
            this.bindings = {
                model: "<"
            };
            this.templateUrl = "network-ui/resources/network/views/host/migratevmkadapter/" +
                "components/configureSettingsPageTemplate.html";
            this.controller = ConfigureSettingsController;
        }
        return ConfigureSettingsComponent;
    }());
    network_ui.ConfigureSettingsComponent = ConfigureSettingsComponent;
    var ConfigureSettingsController = (function () {
        function ConfigureSettingsController(dataService, i18nService, vxValidatorFactory, networkLabelValidator) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.networkLabelValidator = networkLabelValidator;
            this.i18n = this.i18nService.getString;
            this.validator = vxValidatorFactory.create();
            this.validateNetworkLabel = this.newNetworkLabelValidator.bind(this);
            if (!this.model.newNetworkName || !this.model.vlanId || !this.model.vlanIds) {
                this.initSettingsFields();
            }
        }
        ConfigureSettingsController.prototype.initSettingsFields = function () {
            var _this = this;
            this.configSettingsLoading = true;
            var portGroupInfo = {};
            portGroupInfo.portGroupUniquePreffix = this.i18nService.getString("NetworkUi", "AddNetworkingWizard.vmkernel");
            portGroupInfo.vmkDevice = this.model.selectedVmkAdapter;
            var destPortGroupInitialInfo = new DestinationStandardPortGroupInitialInfo();
            var stanmdardPortGroupInfoPromise = this.dataService.getProperties(this.model.hostId, [ConfigureSettingsController.HOST_STANDARD_PORT_GROUP_INFO_PROPERTY], {
                propertyParams: [
                    {
                        propertyName: ConfigureSettingsController.HOST_STANDARD_PORT_GROUP_INFO_PROPERTY,
                        parameterType: destPortGroupInitialInfo._type,
                        parameter: portGroupInfo
                    }
                ]
            });
            stanmdardPortGroupInfoPromise
                .then(function (result) {
                if (result) {
                    if (!_this.model.newNetworkName) {
                        _this.model.newNetworkName = result[ConfigureSettingsController
                            .HOST_STANDARD_PORT_GROUP_INFO_PROPERTY].networkLabel;
                    }
                    if (!_this.model.vlanIds) {
                        _this.model.vlanIds = result[ConfigureSettingsController
                            .HOST_STANDARD_PORT_GROUP_INFO_PROPERTY].vlanIds;
                    }
                    if (!_this.model.vlanId) {
                        _this.model.vlanId = result[ConfigureSettingsController
                            .HOST_STANDARD_PORT_GROUP_INFO_PROPERTY].sourcePortGroupVlanId;
                    }
                }
                _this.configSettingsLoading = false;
            });
        };
        ConfigureSettingsController.prototype.newNetworkLabelValidator = function () {
            var errorMessage = this.networkLabelValidator
                .getNetworkLabelClientSideValidationErrors(this.model.newNetworkName);
            if (errorMessage.length === 0) {
                errorMessage = this.networkLabelValidator
                    .getNetworkLabelServerSideValidationErrors(this.model.newNetworkName, this.model.hostId);
            }
            return errorMessage;
        };
        ConfigureSettingsController.HOST_STANDARD_PORT_GROUP_INFO_PROPERTY = "vmkmigratewizard:standardPortGroupInfo";
        ConfigureSettingsController.$inject = [
            "dataService",
            "i18nService",
            "vxValidatorFactory",
            "networkLabelValidator"
        ];
        return ConfigureSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("configureSettingsPage", new ConfigureSettingsComponent());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var ReadyToCompleteMigarteVmkPageComponent = (function () {
        function ReadyToCompleteMigarteVmkPageComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = ReadyToCompleteMigarteVmkPageController;
            this.templateUrl = "network-ui/resources/network/views/host/migratevmkadapter/" +
                "components/readyToCompletePageTemplate.html";
        }
        return ReadyToCompleteMigarteVmkPageComponent;
    }());
    network_ui.ReadyToCompleteMigarteVmkPageComponent = ReadyToCompleteMigarteVmkPageComponent;
    var ReadyToCompleteMigarteVmkPageController = (function () {
        function ReadyToCompleteMigarteVmkPageController(i18nService, propertyViewService, networkUtil) {
            this.i18nService = i18nService;
            this.propertyViewService = propertyViewService;
            this.networkUtil = networkUtil;
            this.buildProperties();
        }
        ReadyToCompleteMigarteVmkPageController.prototype.buildProperties = function () {
            var builder = this.propertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            generalSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.nic.vmkernel"), this.model.selectedVmkAdapter);
            var currentSettingsSection = generalCategory.section("currentSettings");
            currentSettingsSection
                .title(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.currentDetails"));
            currentSettingsSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.currentSwitch"), this.model.sourceSwitchName);
            currentSettingsSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.currentPortGroup"), this.model.sourceNetworkName);
            var targetSettingsSection = generalCategory.section("targetSettings");
            targetSettingsSection
                .title(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.newDetails"));
            targetSettingsSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.newSwitch"), this.model.targetStandardSwitch);
            targetSettingsSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.newPortGroup"), this.model.newNetworkName);
            targetSettingsSection.property(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.newVlan"), this.networkUtil.formatVlanId(this.model.vlanId));
            this.summaryData = builder.build();
        };
        ReadyToCompleteMigarteVmkPageController.$inject = [
            "i18nService",
            "vxPropertyViewService",
            "networkUtil"
        ];
        return ReadyToCompleteMigarteVmkPageController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("readyToCompleteMigarteVmkPage", new ReadyToCompleteMigarteVmkPageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var SelectVmkAdaptersToMigratePageComponent = (function () {
        function SelectVmkAdaptersToMigratePageComponent() {
            this.bindings = {
                model: "<"
            };
            this.controller = SelectVmkAdaptersToMigratePageController;
            this.templateUrl =
                "network-ui/resources/network/views/host/migratevmkadapter/" +
                    "components/selectVmkAdaptersToMigratePageTemplate.html";
        }
        return SelectVmkAdaptersToMigratePageComponent;
    }());
    network_ui.SelectVmkAdaptersToMigratePageComponent = SelectVmkAdaptersToMigratePageComponent;
    var SelectVmkAdaptersToMigratePageController = (function () {
        function SelectVmkAdaptersToMigratePageController($scope, $rootScope, vuiConstants, vmKernelAdapterService, migrateVmkWizardConstants) {
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.vuiConstants = vuiConstants;
            this.vmKernelAdapterService = vmKernelAdapterService;
            this.migrateVmkWizardConstants = migrateVmkWizardConstants;
            this.virtualAdaptersDataProperty = "vnic:virtualAdaptersData";
            this.preselectComparator = function (item) {
                if (!_this.model.selectedVmkAdapter) {
                    return false;
                }
                return _this.model.selectedVmkAdapter === item.device;
            };
            this.$scope.hostUri = this.$rootScope._route.objectId;
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "125px",
                        size: "60%"
                    }, {
                        min: "225px",
                        size: "40%"
                    }
                ]
            };
            this.getVnicsData = this.getVnicsDataGridData.bind(this);
            this.getVnicsData();
        }
        SelectVmkAdaptersToMigratePageController.prototype.getVnicsDataGridData = function () {
            var _this = this;
            this.vmkernelAdaptersLoading = true;
            var showServiceColumns = false;
            var gridLoadedPromise = this.vmKernelAdapterService.getVnics(this.$scope.hostUri, showServiceColumns);
            gridLoadedPromise.then(function (vnicsResponse) {
                var vnicItems = vnicsResponse[_this.virtualAdaptersDataProperty]
                    ? vnicsResponse[_this.virtualAdaptersDataProperty].items
                    : [];
                var filteredVnics = _.filter(vnicItems, function (vnicItem) {
                    return vnicItem.virtualSwitch !== _this.model.targetStandardSwitch;
                });
                if (!_this.datagridOptions) {
                    _this.datagridOptions =
                        _this.createDatagridOptions(filteredVnics, vnicsResponse.vnicColumnDefs);
                }
                else {
                    _this.datagridOptions.data = vnicItems;
                }
                // When the datagridOptions.data is refreshed, the watch for the
                // selectedItems is called with an empty array. This happens before
                // the grid preselection directive tries to preselect the last
                // selected item. This flag is used to skip the first trigger of the
                // watch when the data is refreshed.
                _this.ingnoreVmkDeviceItemSelection = true;
                _this.vmkernelAdaptersLoading = false;
            });
        };
        SelectVmkAdaptersToMigratePageController.prototype.createDatagridOptions = function (vnicItems, vnicColumnDefs) {
            var options = {
                height: "100%",
                pageConfig: {
                    hidePager: true
                },
                columnDefs: vnicColumnDefs,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                data: vnicItems,
                selectedItems: [],
                resizable: true,
                filterable: false,
                searchable: false,
                actionBarOptions: { actions: [] },
                onChange: this.onSelectionChange.bind(this)
            };
            return options;
        };
        SelectVmkAdaptersToMigratePageController.prototype.onSelectionChange = function (selectedItems) {
            if (this.model.selectedVmkAdapter && this.ingnoreVmkDeviceItemSelection) {
                this.ingnoreVmkDeviceItemSelection = false;
                return;
            }
            if (selectedItems && selectedItems.length > 0) {
                this.$scope.selectedVmkDevice = selectedItems[0].device;
                if (this.model.selectedVmkAdapter !== selectedItems[0].device) {
                    this.model.sourceNetworkName = selectedItems[0].networkLabel;
                    this.model.sourceSwitchName = selectedItems[0].virtualSwitch;
                    if (selectedItems[0].dvPortGroupVlanId) {
                        this.model.vlanId = selectedItems[0].dvPortGroupVlanId;
                    }
                    else {
                        this.model.vlanId = "0";
                    }
                    if (selectedItems[0].connectedTo ===
                        this.migrateVmkWizardConstants.connectedToStandardSwitch) {
                        this.model.networkNameToRemove = selectedItems[0].networkLabel;
                    }
                }
            }
            else {
                this.$scope.selectedVmkDevice = null;
            }
            this.model.selectedVmkAdapter = this.$scope.selectedVmkDevice;
        };
        SelectVmkAdaptersToMigratePageController.$inject = [
            "$scope",
            "$rootScope",
            "vuiConstants",
            "vmKernelAdapterService",
            "migrateVmkWizardConstants"];
        return SelectVmkAdaptersToMigratePageController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("selectVmkAdapterToMigratePage", new SelectVmkAdaptersToMigratePageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var MigrateVmkToVssWizardModel = (function () {
        function MigrateVmkToVssWizardModel() {
        }
        return MigrateVmkToVssWizardModel;
    }());
    network_ui.MigrateVmkToVssWizardModel = MigrateVmkToVssWizardModel;
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var MigrateVmkToVssSpec = com.vmware.vsphere.client.h5.network.host.migratevmkadapter.model.MigrateVmkToVssSpec;
    var MigrateVmkToVssWizardService = (function () {
        function MigrateVmkToVssWizardService($rootScope, i18nService, migrateVmkWizardPages, wizardValidationService, pageStateManagementService, defaultUriSchemeUtil, vuiWizardService, dataService, mutationService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.migrateVmkWizardPages = migrateVmkWizardPages;
            this.wizardValidationService = wizardValidationService;
            this.pageStateManagementService = pageStateManagementService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vuiWizardService = vuiWizardService;
            this.dataService = dataService;
            this.mutationService = mutationService;
        }
        MigrateVmkToVssWizardService.prototype.show = function (contextObj, switchName) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = new network_ui.MigrateVmkToVssWizardModel();
            wizardScope.model.hostId = contextObj;
            this.dataService.getProperties(contextObj, MigrateVmkToVssWizardService.VMK_MIGRATE_HOST_NAME_PROPERTY)
                .then(function (hostNameResult) {
                var hostName = hostNameResult[MigrateVmkToVssWizardService.VMK_MIGRATE_HOST_NAME_PROPERTY];
                wizardScope.wizardConfig = {
                    title: _this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.titleFormat", hostName, switchName),
                    loadingMessage: _this.i18nService.getString("CommonUi", "wizard.loading"),
                    cssClass: "migrate-vmk-to-vss-wizard",
                    onFinish: function () {
                        var spec = _this.buildSpec(wizardScope.model);
                        _this.mutationService.apply(wizardScope.model.hostId, spec._type, spec);
                        return true;
                    }
                };
                wizardScope.model.targetStandardSwitch = switchName;
                wizardScope.wizardConfig.pages =
                    _this.migrateVmkWizardPages.createPages(wizardScope.model);
                _this.wizardValidationService.initWizardValidation(wizardScope);
                _this.pageStateManagementService
                    .registerWizardForDefaultStateManagementStrategy(wizardScope);
                _this.invokeWizard(wizardScope);
            });
        };
        MigrateVmkToVssWizardService.prototype.invokeWizard = function (wizardScope) {
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        MigrateVmkToVssWizardService.prototype.buildSpec = function (model) {
            var migrateSpec = new MigrateVmkToVssSpec();
            migrateSpec.vmkDevice = model.selectedVmkAdapter;
            migrateSpec.networkName = model.newNetworkName;
            migrateSpec.strandardSwitchName = model.targetStandardSwitch;
            migrateSpec.vlanId = parseInt(model.vlanId);
            migrateSpec.networkToRemoveName = model.networkNameToRemove;
            return migrateSpec;
        };
        MigrateVmkToVssWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "migrateVmkWizardPages",
            "wizardValidationService",
            "pageStateManagementService",
            "defaultUriSchemeUtil",
            "vuiWizardService",
            "dataService",
            "mutationService"
        ];
        MigrateVmkToVssWizardService.VMK_MIGRATE_HOST_NAME_PROPERTY = "vmkmigratewizard:hostName";
        return MigrateVmkToVssWizardService;
    }());
    network_ui.MigrateVmkToVssWizardService = MigrateVmkToVssWizardService;
    angular.module("com.vmware.vsphere.client.network")
        .service("migrateVmkToVssWizardService", MigrateVmkToVssWizardService);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    angular.module("com.vmware.vsphere.client.network").constant("migrateVmkWizardConstants", {
        pages: {
            SELECT_VMK_NETWORK_ADAPTER: "selectVmkToMigrate",
            CONFIGURE_SETTINGS: "configureSettings",
            READY_TO_COMPLETE: "readyToComplete"
        },
        connectedToStandardSwitch: "standardNetwork"
    });
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var MigrateVmkWizardPages = (function () {
        function MigrateVmkWizardPages(i18nService, migrateVmkWizardConstants, selectVmkAdapterToMigratePageValidator, configureSettingsPageValidator) {
            this.i18nService = i18nService;
            this.migrateVmkWizardConstants = migrateVmkWizardConstants;
            this.selectVmkAdapterToMigratePageValidator = selectVmkAdapterToMigratePageValidator;
            this.configureSettingsPageValidator = configureSettingsPageValidator;
        }
        MigrateVmkWizardPages.prototype.createPages = function (model) {
            var _this = this;
            var selectNetworksPage = {
                id: this.migrateVmkWizardConstants.pages.SELECT_VMK_NETWORK_ADAPTER,
                title: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.list.title"),
                description: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.list.description"),
                contentUrl: "network-ui/resources/network/views/" +
                    "host/migratevmkadapter/views/selectVmkAdaptersToMigratePage.html",
                validationParams: ["model.selectedVmkAdapter"],
                validationFunction: function () {
                    return _this.selectVmkAdapterToMigratePageValidator
                        .getValidationError(model.selectedVmkAdapter);
                }
            };
            var configureSettingsPage = {
                id: this.migrateVmkWizardConstants.pages.CONFIGURE_SETTINGS,
                title: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.config.title"),
                description: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.config.description"),
                contentUrl: "network-ui/resources/network/views/" +
                    "host/migratevmkadapter/views/configureSettingsPage.html",
                validationParams: ["model.newNetworkName", "model.vlanId"],
                validationFunction: function () {
                    return _this.configureSettingsPageValidator.getValidationError(model.newNetworkName, model.vlanId, model.hostId);
                }
            };
            var readyToCompletePage = {
                id: this.migrateVmkWizardConstants.pages.READY_TO_COMPLETE,
                title: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.title"),
                description: this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.summary.description"),
                contentUrl: "network-ui/resources/network/views/" +
                    "host/migratevmkadapter/views/readyToCompletePage.html",
                validationParams: [],
                validationFunction: function () {
                    return true;
                }
            };
            return [selectNetworksPage, configureSettingsPage, readyToCompletePage];
        };
        MigrateVmkWizardPages.$inject = [
            "i18nService",
            "migrateVmkWizardConstants",
            "selectVmkAdapterToMigratePageValidator",
            "configureSettingsPageValidator"
        ];
        return MigrateVmkWizardPages;
    }());
    network_ui.MigrateVmkWizardPages = MigrateVmkWizardPages;
    angular.module("com.vmware.vsphere.client.network")
        .service("migrateVmkWizardPages", MigrateVmkWizardPages);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var ConfigureSettingsPageValidator = (function () {
        function ConfigureSettingsPageValidator(i18nService, networkUtil, networkLabelValidator) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this.networkLabelValidator = networkLabelValidator;
        }
        ConfigureSettingsPageValidator.prototype.getValidationError = function (networkLabel, vlanId, hostId) {
            var errors = [];
            if (!this.networkUtil.isVlanIdValid(vlanId)) {
                errors.push(this.i18nService.getString("NetworkUi", "VnicData.invalidVlanId"));
            }
            errors = errors.concat(this.networkLabelValidator
                .getNetworkLabelClientSideValidationErrors(networkLabel));
            //in case there are no client side validation errors a
            // server validation is done.
            if (errors.length === 0) {
                return this.networkLabelValidator
                    .getNetworkLabelServerSideValidationErrors(hostId, networkLabel);
            }
            return errors;
        };
        ConfigureSettingsPageValidator.$inject = [
            "i18nService",
            "networkUtil",
            "networkLabelValidator"
        ];
        return ConfigureSettingsPageValidator;
    }());
    network_ui.ConfigureSettingsPageValidator = ConfigureSettingsPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("configureSettingsPageValidator", ConfigureSettingsPageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var SelectVmkAdapterToMigratePageValidator = (function () {
        function SelectVmkAdapterToMigratePageValidator(i18nService) {
            this.i18nService = i18nService;
        }
        SelectVmkAdapterToMigratePageValidator.prototype.getValidationError = function (selectedVmkAdapter) {
            var errors = [];
            if (!selectedVmkAdapter) {
                errors.push(this.i18nService.getString("NetworkUi", "VssVirtualNicMigrateWizard.error.selectNic"));
            }
            return errors;
        };
        SelectVmkAdapterToMigratePageValidator.$inject = ["i18nService"];
        return SelectVmkAdapterToMigratePageValidator;
    }());
    network_ui.SelectVmkAdapterToMigratePageValidator = SelectVmkAdapterToMigratePageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("selectVmkAdapterToMigratePageValidator", SelectVmkAdapterToMigratePageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var SelectedVmkDetailsViewController = (function () {
        function SelectedVmkDetailsViewController($scope) {
            var _this = this;
            this.$scope = $scope;
            this.customizedSettings = {
                noPoliciesIncluded: true,
                addAllTab: false
            };
            this.hostUri = this.$scope.hostUri;
            this.registerRefreshCallback = function (refresh) {
                _this.refresh = refresh;
            };
        }
        SelectedVmkDetailsViewController.$inject = ['$scope'];
        return SelectedVmkDetailsViewController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .controller("SelectedVmkDetailsViewController", SelectedVmkDetailsViewController);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackEditAdvancedPageModel = (function () {
        function NetStackEditAdvancedPageModel(data) {
            this.congestionControlAlgorithm = data.congestionControlAlgorithm;
            this.maxNumberOfConnections = data.maxNumberOfConnections;
            this.runtimeMaxNumberOfConnections = data.runtimeMaxNumberOfConnections;
            this.isRuntimeInfoActive = data.isRuntimeInfoActive;
        }
        NetStackEditAdvancedPageModel.prototype.buildSpec = function (originalData) {
            var spec = {};
            spec.maxNumberOfConnections = this.maxNumberOfConnections;
            spec.congestionControlAlgorithm = this.congestionControlAlgorithm;
            return spec;
        };
        return NetStackEditAdvancedPageModel;
    }());
    network_ui.NetStackEditAdvancedPageModel = NetStackEditAdvancedPageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackReconfigureSpec$DnsReconfigureSpec = com.vmware.vsphere.client.h5.network.host.netstack.model.NetStackReconfigureSpec$DnsReconfigureSpec;
    var NetStackEditDnsConfigPageModel = (function () {
        function NetStackEditDnsConfigPageModel(data) {
            this.isDhcpEnabled = data.isDhcpEnabled;
            this.vnicsWithDhcpEnabled = data.vnicsWithDhcpEnabled;
            this.selectedVnic = data.selectedVnic;
            this.hostName = data.hostName;
            this.domainName = data.domainName;
            this.preferredDns = data.preferredDns;
            this.alternateDns = data.alternateDns;
            this.searchDomains = data.searchDomains;
            this.isIpv6Enabled = data.isIpv6Enabled;
            this.isDefaultNetStack = data.isDefaultNetStack;
        }
        NetStackEditDnsConfigPageModel.prototype.buildSpec = function (originalData) {
            var spec = new NetStackReconfigureSpec$DnsReconfigureSpec();
            if (originalData.isDhcpEnabled !== this.isDhcpEnabled) {
                spec.isDhcpEnabled = this.isDhcpEnabled;
            }
            if (this.isDhcpEnabled) {
                if (originalData.selectedVnic !== this.selectedVnic) {
                    spec.selectedVnic = this.selectedVnic;
                }
            }
            else {
                if (originalData.hostName !== this.hostName) {
                    spec.hostName = this.hostName;
                }
                if (originalData.domainName !== this.domainName) {
                    spec.domainName = this.domainName;
                }
                if (originalData.preferredDns !== this.preferredDns) {
                    spec.preferredDns = this.preferredDns;
                }
                if (originalData.alternateDns !== this.alternateDns) {
                    spec.alternateDns = this.alternateDns;
                }
                if (originalData.searchDomains !== this.searchDomains) {
                    spec.searchDomains = this.searchDomains;
                }
            }
            return this.hasChanges(spec) ? spec : null;
        };
        NetStackEditDnsConfigPageModel.prototype.hasChanges = function (spec) {
            var keys = Object.keys(spec);
            // true if the object has any keys other than _type
            return keys.length > 1;
        };
        return NetStackEditDnsConfigPageModel;
    }());
    network_ui.NetStackEditDnsConfigPageModel = NetStackEditDnsConfigPageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackEditNamePageModel = (function () {
        function NetStackEditNamePageModel(data) {
            this.isSystemNetStack = data.isSystemNetStack;
            this.name = data.name;
        }
        NetStackEditNamePageModel.prototype.buildSpec = function (originalData) {
            if (originalData && originalData.name === this.name) {
                return null;
            }
            return this.name;
        };
        return NetStackEditNamePageModel;
    }());
    network_ui.NetStackEditNamePageModel = NetStackEditNamePageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var IpRouteConfig = com.vmware.vim.binding.vim.host.IpRouteConfig;
    var NetStackEditRoutingPageModel = (function () {
        function NetStackEditRoutingPageModel(data) {
            this.defaultGateway = data.defaultGateway;
            this.ipV6DefaultGateway = data.ipV6DefaultGateway;
            this.hasVnicWithIpv4Settings = data.hasVnicWithIpv4Settings;
            this.hasVnicWithIpv6Settings = data.hasVnicWithIpv6Settings;
            this.isIpv6Enabled = data.isIpv6Enabled;
            this.vnicsWithDhcpEnabled = data.vnicsWithDhcpEnabled;
            this.isDefaultNetStack = data.isDefaultNetStack;
            this.isDefaultGatewaySet = !!data.defaultGateway;
            this.isIpV6DefaultGatewaySet = !!data.ipV6DefaultGateway;
        }
        NetStackEditRoutingPageModel.prototype.buildSpec = function (originalData) {
            var spec = new IpRouteConfig();
            if (!this.isEmptyValue(this.defaultGateway)
                && originalData.defaultGateway !== this.defaultGateway) {
                spec.defaultGateway = this.defaultGateway;
            }
            if (!this.isEmptyValue(this.ipV6DefaultGateway)
                && originalData.ipV6DefaultGateway !== this.ipV6DefaultGateway) {
                spec.ipV6DefaultGateway = this.ipV6DefaultGateway;
            }
            return spec.defaultGateway || spec.ipV6DefaultGateway ? spec : null;
        };
        NetStackEditRoutingPageModel.prototype.isEmptyValue = function (value) {
            return value === "";
        };
        return NetStackEditRoutingPageModel;
    }());
    network_ui.NetStackEditRoutingPageModel = NetStackEditRoutingPageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackReconfigureSpec = com.vmware.vsphere.client.h5.network.host.netstack.model.NetStackReconfigureSpec;
    var NetStackEditDialogManager = (function () {
        function NetStackEditDialogManager(dialogScope, mutationService) {
            this.dialogScope = dialogScope;
            this.mutationService = mutationService;
        }
        NetStackEditDialogManager.prototype.submitDialog = function () {
            var dnsPageSpec = this.dialogScope.dnsConfigPageModel ? this.dialogScope.dnsConfigPageModel
                .buildSpec(this.dialogScope.initialDnsConfigPageModel) : null;
            var routingPageSpec = this.dialogScope.routingPageModel
                .buildSpec(this.dialogScope.initialRoutingPageModel);
            var namePageSpec = this.dialogScope.namePageModel
                .buildSpec(this.dialogScope.initialNamePageModel);
            var advancedPageSpec = this.dialogScope.advancedPageModel
                .buildSpec(this.dialogScope.initialAdvancedPageModel);
            if (dnsPageSpec || routingPageSpec || namePageSpec || advancedPageSpec) {
                var netStackReconfigureSpec = new NetStackReconfigureSpec();
                netStackReconfigureSpec.netStackInstanceKey = this.dialogScope.netStackKey;
                if (dnsPageSpec) {
                    netStackReconfigureSpec.dnsConfig = dnsPageSpec;
                }
                if (routingPageSpec) {
                    netStackReconfigureSpec.ipRouteConfig = routingPageSpec;
                }
                if (namePageSpec) {
                    netStackReconfigureSpec.name = namePageSpec;
                }
                if (advancedPageSpec) {
                    if (advancedPageSpec.maxNumberOfConnections) {
                        netStackReconfigureSpec.requestedMaxNumberOfConnections =
                            advancedPageSpec.maxNumberOfConnections;
                    }
                    if (advancedPageSpec.congestionControlAlgorithm) {
                        netStackReconfigureSpec.congestionControlAlgorithm =
                            advancedPageSpec.congestionControlAlgorithm;
                    }
                }
                this.mutationService.apply(this.dialogScope.hostId, netStackReconfigureSpec._type, netStackReconfigureSpec);
            }
            return true;
        };
        return NetStackEditDialogManager;
    }());
    network_ui.NetStackEditDialogManager = NetStackEditDialogManager;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackEditDialogManagerFactory = (function () {
        function NetStackEditDialogManagerFactory(mutationService) {
            this.mutationService = mutationService;
        }
        NetStackEditDialogManagerFactory.prototype.createManager = function (dialogScope) {
            return new network_ui.NetStackEditDialogManager(dialogScope, this.mutationService);
        };
        NetStackEditDialogManagerFactory.$inject = [
            "mutationService"
        ];
        return NetStackEditDialogManagerFactory;
    }());
    network_ui.NetStackEditDialogManagerFactory = NetStackEditDialogManagerFactory;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditDialogManagerFactory", NetStackEditDialogManagerFactory);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var NetStackEditDialogPages = (function () {
        function NetStackEditDialogPages(i18nService, vuiConstants, networkUiConstants, dnsConfigPageValidator, routingPageValidator, advancedPageValidator) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.networkUiConstants = networkUiConstants;
            this.dnsConfigPageValidator = dnsConfigPageValidator;
            this.routingPageValidator = routingPageValidator;
            this.advancedPageValidator = advancedPageValidator;
        }
        NetStackEditDialogPages.prototype.createPages = function (dialogScope) {
            var pages = [];
            if (dialogScope.netStackKey === this.networkUiConstants.TcpIpStack.DEFAULT_NET_STACK_KEY) {
                pages.push({
                    title: this.i18nService.getString("NetworkUi", "EditDnsAndRoutingView.dnsSettingsView"),
                    contentUrl: "network-ui/resources/network/views/host/netstack/edit/pages/netStackEditDnsConfigPage.html",
                    onCommit: this.buildDnsConfigPageOnCommit(dialogScope)
                });
            }
            pages.push({
                title: this.i18nService.getString("NetworkUi", "EditDnsAndRoutingView.routingSettingsView"),
                contentUrl: "network-ui/resources/network/views/host/netstack/edit/pages/netStackEditRoutingPage.html",
                onCommit: this.buildRoutingPageOnCommit(dialogScope)
            }, {
                title: this.i18nService.getString("NetworkUi", "EditDnsAndRoutingView.name"),
                contentUrl: "network-ui/resources/network/views/host/netstack/edit/pages/netStackEditNamePage.html"
            });
            if (dialogScope.multipleNetworkStackInstanceSupported) {
                pages.push({
                    title: this.i18nService.getString("NetworkUi", "EditDnsAndRoutingView.advancedProperties"),
                    contentUrl: "network-ui/resources/network/views/host/netstack/edit/pages/netStackEditAdvancedPage.html",
                    onCommit: this.buildAdvancedPageOnCommit(dialogScope)
                });
            }
            return pages;
        };
        NetStackEditDialogPages.prototype.buildDnsConfigPageOnCommit = function (dialogScope) {
            var _this = this;
            return function () {
                var dialogOptions = dialogScope.dialogOptions;
                var dnsConfigPageModel = dialogScope.dnsConfigPageModel;
                dialogOptions.validationBanner.messages = [];
                if (dnsConfigPageModel.isDhcpEnabled) {
                    // No available virtual adapters validation message
                    var noVnicsValidationMessage = _this.dnsConfigPageValidator
                        .getNoVirtualNicsValidationMessage(dnsConfigPageModel.vnicsWithDhcpEnabled);
                    _this.updateValidationBanner(noVnicsValidationMessage, dialogOptions.validationBanner.messages);
                    // No selected virtual adapter validation message
                    var noSelectedVnicErrorMessage = _this.dnsConfigPageValidator
                        .getNoVnicSelectedValidationMessage(dnsConfigPageModel.vnicsWithDhcpEnabled, dnsConfigPageModel.selectedVnic);
                    _this.updateValidationBanner(noSelectedVnicErrorMessage, dialogOptions.validationBanner.messages);
                }
                else {
                    // Host name and domain name validation only for the default netStack
                    if (dnsConfigPageModel.isDefaultNetStack) {
                        // Host name validation
                        var hostNameErrorMessage = _this.dnsConfigPageValidator
                            .getHostNameValidationMessage(dnsConfigPageModel.hostName);
                        _this.updateValidationBanner(hostNameErrorMessage, dialogOptions.validationBanner.messages);
                        // Domain name validation
                        var domainNameErrorMessage = _this.dnsConfigPageValidator
                            .getDomainNameValidationMessage(dnsConfigPageModel.domainName);
                        _this.updateValidationBanner(domainNameErrorMessage, dialogOptions.validationBanner.messages);
                    }
                    // Search domains validation
                    var searchDomainsErrorMessage = _this.dnsConfigPageValidator
                        .getSearchDomainsValidationMessage(dnsConfigPageModel.searchDomains);
                    _this.updateValidationBanner(searchDomainsErrorMessage, dialogOptions.validationBanner.messages);
                    // Preferred DNS validation
                    var preferredDnsErrorMessage = _this.dnsConfigPageValidator
                        .getPreferredDnsValidationMessage(dnsConfigPageModel.preferredDns, dnsConfigPageModel.isIpv6Enabled);
                    _this.updateValidationBanner(preferredDnsErrorMessage, dialogOptions.validationBanner.messages);
                    // Alternate DNS validation
                    var alternateDnsErrorMessage = _this.dnsConfigPageValidator
                        .getAlternateDnsValidationMessage(dnsConfigPageModel.alternateDns, dnsConfigPageModel.isIpv6Enabled);
                    _this.updateValidationBanner(alternateDnsErrorMessage, dialogOptions.validationBanner.messages);
                }
                return dialogOptions.validationBanner.messages.length === 0;
            };
        };
        NetStackEditDialogPages.prototype.buildRoutingPageOnCommit = function (dialogScope) {
            var _this = this;
            return function () {
                var dialogOptions = dialogScope.dialogOptions;
                var routingPageModel = dialogScope.routingPageModel;
                dialogOptions.validationBanner.messages = [];
                // IPv4 default gateway validation
                var defaultGatewayValidationMessage = _this.routingPageValidator.getIpv4GatewayValidationMessage(routingPageModel.defaultGateway);
                if (defaultGatewayValidationMessage) {
                    _this.updateValidationBanner(defaultGatewayValidationMessage, dialogOptions.validationBanner.messages);
                }
                // IPv6 default gateway validation
                var ipv6DefaultGatewayValidationMessage = _this.routingPageValidator.getIpv6GatewayValidationMessage(routingPageModel.ipV6DefaultGateway);
                if (ipv6DefaultGatewayValidationMessage) {
                    var error = _this.i18nService
                        .getString("NetworkUi", "DnsAndRoutingPage.ipv4VmkernelGateway.error");
                    _this.updateValidationBanner(ipv6DefaultGatewayValidationMessage, dialogOptions.validationBanner.messages);
                }
                return dialogOptions.validationBanner.messages.length === 0;
            };
        };
        NetStackEditDialogPages.prototype.buildAdvancedPageOnCommit = function (dialogScope) {
            var _this = this;
            return function () {
                var dialogOptions = dialogScope.dialogOptions;
                var advancedPageModel = dialogScope.advancedPageModel;
                dialogOptions.validationBanner.messages = [];
                // max number of connections validation
                var maxNumberOfConnectionsValidationMessage = _this.advancedPageValidator.getMaxNumberOfConnectionsValidationMessage(advancedPageModel.maxNumberOfConnections);
                if (maxNumberOfConnectionsValidationMessage) {
                    _this.updateValidationBanner(maxNumberOfConnectionsValidationMessage, dialogOptions.validationBanner.messages);
                }
                return dialogOptions.validationBanner.messages.length === 0;
            };
        };
        NetStackEditDialogPages.prototype.updateValidationBanner = function (message, messages) {
            if (message) {
                messages.push({
                    type: this.vuiConstants.validationBanner.type.ERROR,
                    text: message
                });
            }
        };
        NetStackEditDialogPages.$inject = [
            "i18nService",
            "vuiConstants",
            "networkUiConstants",
            "netStackEditDnsConfigPageValidator",
            "netStackEditRoutingPageValidator",
            "netStackEditAdvancedPageValidator"
        ];
        return NetStackEditDialogPages;
    }());
    network_ui.NetStackEditDialogPages = NetStackEditDialogPages;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditDialogPages", NetStackEditDialogPages);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackConfigSpec = com.vmware.vsphere.client.h5.network.host.netstack.model.NetStackConfigSpec;
    var NetStackEditDialogService = (function () {
        function NetStackEditDialogService($rootScope, vxMultiPageDialogService, i18nService, dataService, managerFactory, netStackEditDialogPages) {
            this.$rootScope = $rootScope;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.managerFactory = managerFactory;
            this.netStackEditDialogPages = netStackEditDialogPages;
        }
        NetStackEditDialogService.prototype.show = function (hostId, netStackKey, netStackName, multipleNetworkStackInstanceSupported) {
            var dialogScope = this.$rootScope.$new();
            dialogScope.hostId = hostId;
            dialogScope.netStackKey = netStackKey;
            dialogScope.multipleNetworkStackInstanceSupported =
                multipleNetworkStackInstanceSupported;
            var dialogManager = this.managerFactory.createManager(dialogScope);
            dialogScope.dialogOptions = this.createDialogOptions(netStackName);
            dialogScope.dialogOptions.pages =
                this.netStackEditDialogPages.createPages(dialogScope);
            dialogScope.dialogOptions.confirmOptions = {
                onClick: function () {
                    return dialogManager.submitDialog();
                }
            };
            var options = {
                scope: dialogScope,
                configObjectName: "dialogOptions"
            };
            this.requestData(dialogScope);
            this.vxMultiPageDialogService(options);
        };
        NetStackEditDialogService.prototype.requestData = function (dialogScope) {
            var netStackConfigSpec = new NetStackConfigSpec();
            netStackConfigSpec.netStackInstanceKey = dialogScope.netStackKey;
            var params = [{
                    propertyName: NetStackEditDialogService.DATA_PROPERTY,
                    parameterType: netStackConfigSpec._type,
                    parameter: netStackConfigSpec
                }];
            this.dataService.getProperties(dialogScope.hostId, [NetStackEditDialogService.DATA_PROPERTY], {
                propertyParams: params
            })
                .then(function (result) {
                if (result && result[NetStackEditDialogService.DATA_PROPERTY]) {
                    var data = result[NetStackEditDialogService.DATA_PROPERTY];
                    if (data.isDefaultNetStack) {
                        dialogScope.dnsConfigPageModel =
                            new network_ui.NetStackEditDnsConfigPageModel(data);
                        dialogScope.initialDnsConfigPageModel =
                            angular.copy(dialogScope.dnsConfigPageModel);
                    }
                    dialogScope.routingPageModel =
                        new network_ui.NetStackEditRoutingPageModel(data);
                    dialogScope.namePageModel =
                        new network_ui.NetStackEditNamePageModel(data);
                    dialogScope.advancedPageModel =
                        new network_ui.NetStackEditAdvancedPageModel(data);
                    // deep clone
                    dialogScope.initialRoutingPageModel =
                        angular.copy(dialogScope.routingPageModel);
                    dialogScope.initialNamePageModel =
                        angular.copy(dialogScope.namePageModel);
                    dialogScope.initialAdvancedPageModel =
                        angular.copy(dialogScope.advancedPageModel);
                    dialogScope.dialogOptions.loading = false;
                }
            });
        };
        NetStackEditDialogService.prototype.createDialogOptions = function (netStackName) {
            return {
                title: this.i18nService.getString("NetworkUi", "EditDnsAndRoutingView.updatedTitle", netStackName),
                show: true,
                loading: true,
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                validationBanner: {},
                rejectOptions: {
                    rejectOnEsc: true
                },
                resizable: true,
                draggable: true,
                maximizable: true
            };
        };
        NetStackEditDialogService.$inject = ["$rootScope",
            "vxMultiPageDialogService",
            "i18nService",
            "dataService",
            "netStackEditDialogManagerFactory",
            "netStackEditDialogPages"];
        NetStackEditDialogService.DATA_PROPERTY = "netstack:netStackConfig";
        return NetStackEditDialogService;
    }());
    network_ui.NetStackEditDialogService = NetStackEditDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditDialogService", NetStackEditDialogService);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditAdvancedPageComponent = (function () {
        function NetStackEditAdvancedPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = NetStackEditAdvancedPageComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/netstack/" +
                "edit/pages/netStackEditAdvancedPageComponentTemplate.html";
        }
        return NetStackEditAdvancedPageComponent;
    }());
    network_ui.NetStackEditAdvancedPageComponent = NetStackEditAdvancedPageComponent;
    var NetStackEditAdvancedPageComponentController = (function () {
        function NetStackEditAdvancedPageComponentController(i18nService, netStackEditAdvancedPageValidator, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.netStackEditAdvancedPageValidator = netStackEditAdvancedPageValidator;
            this.vxValidatorFactory = vxValidatorFactory;
            this.algTypes = [];
            this.validator = vxValidatorFactory.create();
            this.initValidationCallbacks();
        }
        NetStackEditAdvancedPageComponentController.prototype.$onInit = function () {
            var newRenoValue = "newreno";
            var cubicValue = "cubic";
            this.algTypes = [
                {
                    key: newRenoValue,
                    label: this.i18nService.getString("NetworkUi", "AdvancedNetStackPage.newReno")
                }, {
                    key: cubicValue,
                    label: this.i18nService.getString("NetworkUi", "AdvancedNetStackPage.cubic")
                }
            ];
        };
        NetStackEditAdvancedPageComponentController.prototype.initValidationCallbacks = function () {
            var _this = this;
            this.validateMaxNumOfConnections = function () {
                var maxNumOfConnectionsErrorMessage = _this.netStackEditAdvancedPageValidator
                    .getMaxNumberOfConnectionsValidationMessage(_this.pageModel.maxNumberOfConnections);
                return maxNumOfConnectionsErrorMessage ?
                    [maxNumOfConnectionsErrorMessage] : [];
            };
        };
        NetStackEditAdvancedPageComponentController.$inject = [
            "i18nService",
            "netStackEditAdvancedPageValidator",
            "vxValidatorFactory"
        ];
        return NetStackEditAdvancedPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackEditAdvancedPage", new NetStackEditAdvancedPageComponent());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditDnsConfigPageComponent = (function () {
        function NetStackEditDnsConfigPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = NetStackEditDnsConfigPageComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/netstack/" +
                "edit/pages/netStackEditDnsConfigPageComponentTemplate.html";
        }
        return NetStackEditDnsConfigPageComponent;
    }());
    network_ui.NetStackEditDnsConfigPageComponent = NetStackEditDnsConfigPageComponent;
    var NetStackEditDnsConfigPageComponentController = (function () {
        function NetStackEditDnsConfigPageComponentController(i18nService, vuiConstants, netStackEditDnsConfigPageValidator, vxValidatorFactory) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.netStackEditDnsConfigPageValidator = netStackEditDnsConfigPageValidator;
            this.vxValidatorFactory = vxValidatorFactory;
            this.validator = vxValidatorFactory.create();
            this.updateNoVnicsValidationMessage();
            this.initValidationCallbacks();
        }
        NetStackEditDnsConfigPageComponentController.prototype.$onInit = function () {
            var hasVnics = this.pageModel.vnicsWithDhcpEnabled
                && this.pageModel.vnicsWithDhcpEnabled.length > 0;
            var isSelectedVnicInTheVnicsList = _.contains(this.pageModel.vnicsWithDhcpEnabled, this.pageModel.selectedVnic);
            if (!this.pageModel.isDhcpEnabled && hasVnics && !isSelectedVnicInTheVnicsList) {
                this.pageModel.selectedVnic = this.pageModel.vnicsWithDhcpEnabled[0];
            }
        };
        NetStackEditDnsConfigPageComponentController.prototype.initValidationCallbacks = function () {
            var _this = this;
            this.validateHostName = function () {
                var hostNameErrorMessage = _this.netStackEditDnsConfigPageValidator
                    .getHostNameValidationMessage(_this.pageModel.hostName);
                return (!_this.pageModel.isDhcpEnabled && hostNameErrorMessage) ?
                    [hostNameErrorMessage] : [];
            };
            this.validateDomainName = function () {
                var domainNameErrorMessage = _this.netStackEditDnsConfigPageValidator
                    .getDomainNameValidationMessage(_this.pageModel.domainName);
                return (!_this.pageModel.isDhcpEnabled && domainNameErrorMessage) ?
                    [domainNameErrorMessage] : [];
            };
            this.validateSearchDomains = function () {
                var searchDomainsErrorMessage = _this.netStackEditDnsConfigPageValidator
                    .getSearchDomainsValidationMessage(_this.pageModel.searchDomains);
                return (!_this.pageModel.isDhcpEnabled && searchDomainsErrorMessage) ?
                    [searchDomainsErrorMessage] : [];
            };
            this.validatePreferredDns = function () {
                var preferredDnsErrorMessage = _this.netStackEditDnsConfigPageValidator
                    .getPreferredDnsValidationMessage(_this.pageModel.preferredDns, _this.pageModel.isIpv6Enabled);
                return (!_this.pageModel.isDhcpEnabled && preferredDnsErrorMessage) ?
                    [preferredDnsErrorMessage] : [];
            };
            this.validateAlternateDns = function () {
                var alternateDnsErrorMessage = _this.netStackEditDnsConfigPageValidator
                    .getAlternateDnsValidationMessage(_this.pageModel.alternateDns, _this.pageModel.isIpv6Enabled);
                return (!_this.pageModel.isDhcpEnabled && alternateDnsErrorMessage)
                    ? [alternateDnsErrorMessage] : [];
            };
        };
        NetStackEditDnsConfigPageComponentController.prototype.onDhcpChange = function () {
            this.updateNoVnicsValidationMessage();
            this.validator.validate();
        };
        NetStackEditDnsConfigPageComponentController.prototype.updateNoVnicsValidationMessage = function () {
            this.noVnicsValidationMessage = this.pageModel.isDhcpEnabled
                ? this.netStackEditDnsConfigPageValidator
                    .getNoVirtualNicsValidationMessage(this.pageModel.vnicsWithDhcpEnabled)
                : null;
        };
        NetStackEditDnsConfigPageComponentController.$inject = [
            "i18nService",
            "vuiConstants",
            "netStackEditDnsConfigPageValidator",
            "vxValidatorFactory"
        ];
        return NetStackEditDnsConfigPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackEditDnsConfigPage", new NetStackEditDnsConfigPageComponent());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditNamePageComponent = (function () {
        function NetStackEditNamePageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = NetStackEditNamePageComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/netstack/" +
                "edit/pages/netStackEditNamePageComponentTemplate.html";
        }
        return NetStackEditNamePageComponent;
    }());
    network_ui.NetStackEditNamePageComponent = NetStackEditNamePageComponent;
    var NetStackEditNamePageComponentController = (function () {
        function NetStackEditNamePageComponentController(i18nService) {
            this.i18nService = i18nService;
        }
        NetStackEditNamePageComponentController.$inject = ["i18nService"];
        return NetStackEditNamePageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackEditNamePage", new NetStackEditNamePageComponent());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditRoutingPageComponent = (function () {
        function NetStackEditRoutingPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = NetStackEditRoutingPageComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/netstack/" +
                "edit/pages/netStackEditRoutingPageComponentTemplate.html";
        }
        return NetStackEditRoutingPageComponent;
    }());
    network_ui.NetStackEditRoutingPageComponent = NetStackEditRoutingPageComponent;
    var NetStackEditRoutingPageComponentController = (function () {
        function NetStackEditRoutingPageComponentController(vxValidatorFactory, netStackEditRoutingPageValidator, i18nService) {
            this.vxValidatorFactory = vxValidatorFactory;
            this.netStackEditRoutingPageValidator = netStackEditRoutingPageValidator;
            this.i18nService = i18nService;
            this.validator = vxValidatorFactory.create();
            this.initValidationCallbacks();
        }
        NetStackEditRoutingPageComponentController.prototype.initValidationCallbacks = function () {
            var _this = this;
            this.ivp4ValidationCallback = function () {
                var message = _this.netStackEditRoutingPageValidator
                    .getIpv4GatewayValidationMessage(_this.pageModel.defaultGateway);
                return message ? [message] : [];
            };
            this.ivp6ValidationCallback = function () {
                var message = _this.netStackEditRoutingPageValidator
                    .getIpv6GatewayValidationMessage(_this.pageModel.ipV6DefaultGateway);
                return message ? [message] : [];
            };
        };
        NetStackEditRoutingPageComponentController.$inject = ["vxValidatorFactory", "netStackEditRoutingPageValidator", "i18nService"];
        return NetStackEditRoutingPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackEditRoutingPage", new NetStackEditRoutingPageComponent());
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditAdvancedPageValidator = (function () {
        function NetStackEditAdvancedPageValidator(i18nService, networkUiConstants) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
        }
        NetStackEditAdvancedPageValidator.prototype.getMaxNumberOfConnectionsValidationMessage = function (maxNumentOfConnections) {
            var isValid = !this.isEmptyValue(maxNumentOfConnections);
            if (maxNumentOfConnections > this.networkUiConstants.HOST_MAX_NUMBER_OT_CONNECTIONS_MAX ||
                maxNumentOfConnections < this.networkUiConstants.HOST_MAX_NUMBER_OT_CONNECTIONS_MIN) {
                isValid = false;
            }
            return isValid ? null : this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidMaxNumberOfConnectionsLength");
        };
        NetStackEditAdvancedPageValidator.prototype.isEmptyValue = function (value) {
            return value === undefined || value === null || value === "";
        };
        NetStackEditAdvancedPageValidator.$inject = [
            "i18nService",
            "networkUiConstants"
        ];
        return NetStackEditAdvancedPageValidator;
    }());
    network_ui.NetStackEditAdvancedPageValidator = NetStackEditAdvancedPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditAdvancedPageValidator", NetStackEditAdvancedPageValidator);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditDnsConfigPageValidator = (function () {
        function NetStackEditDnsConfigPageValidator(i18nService, networkUtil, networkUiConstants, ipParserService) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this.networkUiConstants = networkUiConstants;
            this.ipParserService = ipParserService;
        }
        NetStackEditDnsConfigPageValidator.prototype.getNoVirtualNicsValidationMessage = function (vnics) {
            if (!vnics || vnics.length === 0) {
                return this.i18nService.getString('NetworkUi', 'DnsAndRoutingData.noDhcpVmkernelAdapters');
            }
            return null;
        };
        NetStackEditDnsConfigPageValidator.prototype.getNoVnicSelectedValidationMessage = function (vnics, selectedVnic) {
            if ((vnics && vnics.length > 0) &&
                (!selectedVnic || vnics.indexOf(selectedVnic) === -1)) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.invalidDhcpVmkernelAdapter");
            }
            return null;
        };
        NetStackEditDnsConfigPageValidator.prototype.getHostNameValidationMessage = function (hostName) {
            if (!hostName) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.hostNameNotSpecified");
            }
            // The host name should be up to 63 characters long
            if (hostName.length > this.networkUiConstants.MAX_HOST_NAME_LENGTH) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.invalidHostNameLength");
            }
            // Check for an invalid host name
            if (!this.networkUtil.isHostNameValid(hostName)) {
                // get the correct message
                return hostName.indexOf(".") === -1 ?
                    this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidHostNameFormat") :
                    this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidHostNameWithPeriod");
            }
            return null;
        };
        NetStackEditDnsConfigPageValidator.prototype.getDomainNameValidationMessage = function (domainName) {
            if (!domainName) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.domainNameNotSpecified");
            }
            // Check for too long domain name
            if (domainName.length > this.networkUiConstants.FQDN_MAX_LENGTH) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.invalidFqdnLength");
            }
            // Check for too long labels in the domain name
            var labels = domainName.split(".");
            if (!this.areDomainLabelsLengthsValid(labels)) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.invalidDomainLabelLength");
            }
            // Check for invalid domain names
            if (!this.networkUtil.isDomainNameValid(domainName)) {
                return this.i18nService
                    .getString("NetworkUi", "DnsAndRoutingData.invalidDomainNameFormat");
            }
            return null;
        };
        NetStackEditDnsConfigPageValidator.prototype.getSearchDomainsValidationMessage = function (searchDomains) {
            if (!searchDomains || !searchDomains.trim()) {
                return null;
            }
            var searchDomainsArray = NetStackEditDnsConfigPageValidator.splitSearchDomains(searchDomains);
            if (searchDomainsArray.length > this.networkUiConstants.MAX_NUMBER_SEARCH_DOMAINS) {
                return this.i18nService.getString("NetworkUi", "DnsAndRoutingData.searchDomainsMaxNumber", this.networkUiConstants.MAX_NUMBER_SEARCH_DOMAINS);
            }
            for (var _i = 0, searchDomainsArray_1 = searchDomainsArray; _i < searchDomainsArray_1.length; _i++) {
                var searchDomain = searchDomainsArray_1[_i];
                // Check for too long domain name
                if (searchDomain.length > this.networkUiConstants.FQDN_MAX_LENGTH) {
                    return this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidSearchDomainsNameLength");
                }
                // Check for too long labels in the domain name
                var labels = searchDomain.split(".");
                if (!this.areDomainLabelsLengthsValid(labels)) {
                    return this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidSearchDomainsLabelLength");
                }
                // Check for invalid domain names
                if (!this.networkUtil.isDomainNameValid(searchDomain)) {
                    return this.i18nService.getString("NetworkUi", "DnsAndRoutingData.invalidSearchDomainsFormat");
                }
            }
            return null;
        };
        NetStackEditDnsConfigPageValidator.prototype.getPreferredDnsValidationMessage = function (preferredDns, isIpv6Enabled) {
            return this.isDnsValid(preferredDns, isIpv6Enabled) ? null :
                this.i18nService.getString("NetworkUi", "DnsAndRoutingData.preferredDnsError");
        };
        NetStackEditDnsConfigPageValidator.prototype.getAlternateDnsValidationMessage = function (alternateDns, isIpv6Enabled) {
            return this.isDnsValid(alternateDns, isIpv6Enabled) ? null :
                this.i18nService.getString("NetworkUi", "DnsAndRoutingData.alternateDnsError");
        };
        NetStackEditDnsConfigPageValidator.prototype.isDnsValid = function (dsn, isIpv6Enabled) {
            if (!dsn) {
                return true;
            }
            var isDnsValid = this.ipParserService.isIpv4AddressValid(dsn);
            // If the DNS is not in a valid IPv4 format AND IPv6 is enabled - validate
            // against IPv6 format
            if (!isDnsValid && isIpv6Enabled) {
                isDnsValid = this.ipParserService.isIpv6AddressValid(dsn);
            }
            return isDnsValid;
        };
        NetStackEditDnsConfigPageValidator.prototype.areDomainLabelsLengthsValid = function (labels) {
            var _this = this;
            if (!labels || labels.length === 0) {
                return false;
            }
            return !_.any(labels, function (label) {
                return label.length > _this.networkUiConstants.MAX_DOMAIN_NAME_LENGTH;
            });
        };
        NetStackEditDnsConfigPageValidator.splitSearchDomains = function (searchDomains) {
            return searchDomains.trim().split(/\s+/);
        };
        NetStackEditDnsConfigPageValidator.$inject = [
            "i18nService",
            "networkUtil",
            "networkUiConstants",
            "ipParserService"
        ];
        return NetStackEditDnsConfigPageValidator;
    }());
    network_ui.NetStackEditDnsConfigPageValidator = NetStackEditDnsConfigPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditDnsConfigPageValidator", NetStackEditDnsConfigPageValidator);
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var NetStackEditRoutingPageValidator = (function () {
        function NetStackEditRoutingPageValidator(i18nService, ipParserService) {
            this.i18nService = i18nService;
            this.ipParserService = ipParserService;
        }
        NetStackEditRoutingPageValidator.prototype.getIpv4GatewayValidationMessage = function (ipv4Gateway) {
            var isValid = this.isEmptyValue(ipv4Gateway)
                || this.ipParserService.isIpv4AddressValid(ipv4Gateway);
            return isValid ? null : this.i18nService.getString("NetworkUi", "DnsAndRoutingPage.ipv4VmkernelGateway.error");
        };
        NetStackEditRoutingPageValidator.prototype.getIpv6GatewayValidationMessage = function (ipv6Gateway) {
            var isValid = this.isEmptyValue(ipv6Gateway)
                || this.ipParserService.isIpv6AddressValid(ipv6Gateway, true);
            return isValid ? null : this.i18nService.getString("NetworkUi", "DnsAndRoutingPage.ipv6VmkernelGateway.error");
        };
        NetStackEditRoutingPageValidator.prototype.isEmptyValue = function (value) {
            return value === undefined || value === null || value === "";
        };
        NetStackEditRoutingPageValidator.$inject = [
            "i18nService",
            "ipParserService"
        ];
        return NetStackEditRoutingPageValidator;
    }());
    network_ui.NetStackEditRoutingPageValidator = NetStackEditRoutingPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("netStackEditRoutingPageValidator", NetStackEditRoutingPageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.network').controller(
      'NetStackDetailsViewController', NetStackDetailsViewController);

   NetStackDetailsViewController.$inject = ['$scope', 'netStackDetailsViewService'];

   function NetStackDetailsViewController (
      $scope,
      netStackDetailsViewService
   ) {

      var self = this;
      var isInitialRefresh = true;

      self.hostId = $scope._route.objectId;
      self.liveRefreshProperties = [
         "config.network.netStackInstance",
         "config.network.dnsConfig.dhcp",
         "config.network.dnsConfig.address",
         "config.network.dnsConfig.searchDomain",
         "config.network.dnsConfig.domainName",
         "config.network.dnsConfig.hostName",
         "config.network.dnsConfig.virtualNicDevice",
         "config.network.ipRouteConfig.ipV6GatewayDevice",
         "config.network.ipRouteConfig.ipV6DefaultGateway",
         "config.network.ipRouteConfig.defaultGateway",
         "config.network.routeTableInfo.ipv6Route",
         "config.network.routeTableInfo.ipRoute"
      ];
      $scope.loadingData = false;

      var DEFAULT_NET_STACK = 'defaultTcpipStack';

      self.refresh = function(selectedNetStackKey) {
         $scope.isDefaultNetStack = selectedNetStackKey === DEFAULT_NET_STACK;
         $scope.loadingData = true;

         if (isInitialRefresh) {
            $scope.isDnsTabSelected = $scope.isDefaultNetStack;
            $scope.isRoutingTabSelected = !$scope.isDefaultNetStack;
            $scope.isAdvancedTabSelected = false;
         } else if (!$scope.isDefaultNetStack && $scope.isDnsTabSelected) {
            $scope.isDnsTabSelected = false;
            $scope.isRoutingTabSelected = true;
            $scope.isAdvancedTabSelected = false;
         } else if ($scope.isAdvancedTabSelected) {
            $scope.isDnsTabSelected = false;
            $scope.isRoutingTabSelected = false;
            $scope.isAdvancedTabSelected = true;
         }

         var requestPromise = netStackDetailsViewService
            .getNetStackDetails(self.hostId, selectedNetStackKey);
         self.lastRequestPromise = requestPromise;

         requestPromise.then(function(detailsData) {
            if (requestPromise === self.lastRequestPromise) {
               $scope.netStackDnsData = $scope.isDefaultNetStack ?
                  netStackDetailsViewService.buildDnsPropertiesView(
                     detailsData, $scope.isDefaultNetStack) : null;
               $scope.netStackRoutingData = netStackDetailsViewService
                  .buildRoutingPropertiesView(detailsData);
               $scope.netStackAdvancedData = netStackDetailsViewService
                  .buildAdvancedPropertiesView(detailsData);

               if (detailsData) {
                  $scope.ipv4RoutingTableData = detailsData.ipv4RouteTableEntries;
                  $scope.ipv6RoutingTableData = detailsData.ipv6RouteTableEntries;
               }
            }
         }).finally(function() {
            if (requestPromise === self.lastRequestPromise) {
               $scope.loadingData = false;
            }
         });

         isInitialRefresh = false;
      };

      $scope.onTabIndexChanged = function(currentTabIndex) {
         $scope.isDnsTabSelected = currentTabIndex === 0;
         $scope.isRoutingTabSelected = currentTabIndex === 1;
         $scope.isAdvancedTabSelected = currentTabIndex === 4;
      };

      $scope.$watch('lastSelectedNetStackKey',
         function(lastSelectedNetStackKey) {
            self.refresh(lastSelectedNetStackKey);
         });
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    var NetStackIpv4RoutingTableViewComponent = (function () {
        function NetStackIpv4RoutingTableViewComponent() {
            this.bindings = {
                tableEntries: "<"
            };
            this.controller = NetStackIpv4RoutingTableViewController;
            this.templateUrl = "network-ui/resources/network/views/host/" +
                "netStackRoutingTableViewTemplate.html";
        }
        return NetStackIpv4RoutingTableViewComponent;
    }());
    network_lib_ui.NetStackIpv4RoutingTableViewComponent = NetStackIpv4RoutingTableViewComponent;
    var NetStackIpv4RoutingTableViewController = (function () {
        function NetStackIpv4RoutingTableViewController(i18nService, vuiConstants, columnRenderersRegistry, $scope) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.$scope = $scope;
            this.createDatagridOptions();
        }
        NetStackIpv4RoutingTableViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        NetStackIpv4RoutingTableViewController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.tableEntries;
        };
        NetStackIpv4RoutingTableViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.NONE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: '100%',
                pageConfig: {
                    hidePager: true
                }
            };
        };
        NetStackIpv4RoutingTableViewController.prototype.createColumnDefinitions = function () {
            return [{
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.networkHeader'),
                    field: 'network',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.subnetMask'),
                    field: 'subnetMask',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.gatewayHeader'),
                    field: 'gateway',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.deviceHeader'),
                    field: 'deviceName',
                    width: '150px'
                }];
        };
        NetStackIpv4RoutingTableViewController.$inject = [
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry"
        ];
        return NetStackIpv4RoutingTableViewController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackIpv4RoutingTableView", new NetStackIpv4RoutingTableViewComponent());
})(network_lib_ui || (network_lib_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    var NetStackIpv6RoutingTableViewComponent = (function () {
        function NetStackIpv6RoutingTableViewComponent() {
            this.bindings = {
                tableEntries: "<"
            };
            this.controller = NetStackIpv6RoutingTableViewController;
            this.templateUrl = "network-ui/resources/network/views/host/" +
                "netStackRoutingTableViewTemplate.html";
        }
        return NetStackIpv6RoutingTableViewComponent;
    }());
    network_lib_ui.NetStackIpv6RoutingTableViewComponent = NetStackIpv6RoutingTableViewComponent;
    var NetStackIpv6RoutingTableViewController = (function () {
        function NetStackIpv6RoutingTableViewController(i18nService, vuiConstants, columnRenderersRegistry, $scope) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.$scope = $scope;
            this.createDatagridOptions();
        }
        NetStackIpv6RoutingTableViewController.prototype.$onInit = function () {
            this.datagridOptions.data = this.tableEntries;
            this.createDatagridOptions();
        };
        NetStackIpv6RoutingTableViewController.prototype.$onChanges = function () {
            this.datagridOptions.data = this.tableEntries;
        };
        NetStackIpv6RoutingTableViewController.prototype.createDatagridOptions = function () {
            this.datagridOptions = {
                columnDefs: this.createColumnDefinitions(),
                sortMode: this.vuiConstants.grid.sortMode.NONE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.tableEntries,
                resizable: true,
                height: '100%',
                pageConfig: {
                    hidePager: true
                }
            };
        };
        NetStackIpv6RoutingTableViewController.prototype.createColumnDefinitions = function () {
            return [{
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.networkHeader'),
                    field: 'network',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.prefixHeader'),
                    field: 'prefixLength',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.gatewayHeader'),
                    field: 'gateway',
                    width: '150px'
                },
                {
                    displayName: this.i18nService.getString('NetworkUi', 'routingtableview.deviceHeader'),
                    field: 'deviceName',
                    width: '150px'
                }];
        };
        NetStackIpv6RoutingTableViewController.$inject = [
            "i18nService",
            "vuiConstants",
            "columnRenderersRegistry"
        ];
        return NetStackIpv6RoutingTableViewController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("netStackIpv6RoutingTableView", new NetStackIpv6RoutingTableViewComponent());
})(network_lib_ui || (network_lib_ui = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.network').controller(
         'NetStackViewController', NetStackViewController);

   NetStackViewController.$inject = [
         '$q',
         '$scope',
         'i18nService',
         'vuiConstants',
         'dataService',
         'networkUiConstants',
         'actionToolbarFactory',
         'netStackListService'];

   function NetStackViewController(
         $q,
         $scope,
         i18nService,
         vuiConstants,
         dataService,
         networkUiConstants,
         actionToolbarFactory,
         netStackListService) {

      var self = this;
      var netStackDataProperty = 'netstack:netStackData';

      var netstackActions = [networkUiConstants.actions.EDIT_DNS_AND_ROUTING];
      var editActionEnabled = false;

      self.liveRefreshProperties = [
         "config.network.ipRouteConfig.ipV6GatewayDevice",
         "config.network.ipRouteConfig.ipV6DefaultGateway",
         "config.network.ipRouteConfig.defaultGateway",
         "config.network.dnsConfig.address",
         "config.network.vnic",
         "config.network.netStackInstance"
      ];
      self.netstacksLoading = false;
      self.showNoItemSelected = true;
      self.netstackDetailsHeader = null;
      self.hostId = $scope._route.objectId;

      self.headerOptions = {
         title: i18nService.getString('H5NetworkUi', 'NetStackInstanceList.tcpIpTitleLabel'),
         objectId: self.hostId,
         actions: [{
            actionUid: "vsphere.core.host.network.editIpv6SupportAction",
            customLabel: i18nService.getString(
               'H5NetworkUi', 'NetStackInstanceList.editLabel')
         }]
      };

      self.watchForObjects = [self.hostId];
      self.evaluationContext = {};

      self.splitterOptions = {
         orientation: vuiConstants.splitter.orientation.VERTICAL,
         panes: [
            {
               min: '150px',
               size: '45%'
            }, {
               min: '250px',
               size: '55%'
            }
         ]
      };

      $scope.multipleNetworkStackInstanceSupported = false;
      $scope.preselectComparator = function (gridDataItem) {
         return gridDataItem.key === $scope.lastSelectedNetStackKey;
      };

      function getNetStackInstances() {
         return dataService.getProperties(self.hostId, [netStackDataProperty]);
      }

      // init function
      self.refresh = function() {
         var netStackInstancesPromise = getNetStackInstances();

         var createActionbarOptionsPromise = actionToolbarFactory
               .createActionbarOptions([self.hostId], netstackActions, self.evaluationContext);

         self.netstacksLoading = true;
         $q.all([netStackInstancesPromise, createActionbarOptionsPromise]).then(function(responses) {
            var netStackResponse = responses[0];
            var actionbarOptions = responses[1];

            if (actionbarOptions && actionbarOptions.actions
                  && actionbarOptions.actions.length > 0) {
               // actionToolbarFactory ensures ordering of actions in the response
               editActionEnabled = actionbarOptions.actions[0].enabled;
            }

            var hostNetStackData = netStackResponse ? netStackResponse[netStackDataProperty] : {};
            var netStackItems = hostNetStackData.netStackItems || [];
            setNetStacksType(netStackItems);
            if(netStackResponse && netStackResponse[netStackDataProperty]) {
               $scope.multipleNetworkStackInstanceSupported = netStackResponse[
                  netStackDataProperty].multipleNetworkStackInstanceSupported;
            }

            if (!self.datagridOptions) {
               // init
               self.datagridOptions = netStackListService.createDatagridOptions(
                     netStackItems, actionbarOptions, hostNetStackData.ipv6Enabled, onSelectionChange);
            } else {
               // refresh

               // When the datagridOptions.data is refreshed, the watch for the selectedItems
               // is called with an empty array before the grid preselection directive tries
               // to preselect the last selected item. This flag is used to skip the first
               // trigger of the watch when the data is refreshed.
               self.ingnoreNextItemSelection = true;
               self.datagridOptions.data = netStackItems;
            }

            self.netstacksLoading = false;
         });
      };

      self.refresh();

      function setNetStacksType(netStacks) {
         netStacks.forEach(function (item) {
            item.type = item.isSystemStack
                  ? i18nService.getString('H5NetworkUi', 'NetStackInstanceList.systemSingle')
                  : i18nService.getString('H5NetworkUi', 'NetStackInstanceList.customSingle');
         });
      }

      function onSelectionChange(selectedItems) {
         if (self.datagridOptions.actionBarOptions.actions &&
               self.datagridOptions.actionBarOptions.actions.length > 0) {
            self.datagridOptions.actionBarOptions.actions[0].enabled =
                  selectedItems && selectedItems.length > 0 && editActionEnabled;
         }

         if (self.ingnoreNextItemSelection) {
            self.ingnoreNextItemSelection = false;
            return;
         }

         if (selectedItems && selectedItems.length > 0) {
            $scope.lastSelectedNetStackKey = selectedItems[0].key;

            self.evaluationContext.selectedNetStack = selectedItems[0];
            self.evaluationContext.multipleNetworkStackInstanceSupported =
               $scope.multipleNetworkStackInstanceSupported;

            self.netstackDetailsHeader = i18nService.getString('NetworkUi',
                  'DnsAndRoutingView.tcpIpInstance',
                  selectedItems[0].name);
         } else {
            self.evaluationContext.selectedNetStack = null;
            $scope.lastSelectedNetStackKey = null;
            self.evaluationContext.multipleNetworkStackInstanceSupported = false;
         }

         self.showNoItemSelected = $scope.lastSelectedNetStackKey === null;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network').controller(
      'PhysicalAdapterDetailsViewController', PhysicalAdapterDetailsViewController);

   PhysicalAdapterDetailsViewController.$inject = ['$scope'];

   function PhysicalAdapterDetailsViewController($scope) {

      var self = this;

      self.liveRefreshProperties = [
         "config.network.pnic",
         "config.sriovDevicePool",
         "config.pciPassthruInfo"
      ];

      self.hostId = $scope._route.objectId;

      self.registerRefreshCallback = function (refresh) {
         self.refresh = refresh;
      };
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network').controller(
         'PhysicalAdaptersViewController', PhysicalAdaptersViewController);

   PhysicalAdaptersViewController.$inject = ['i18nService',
      '$scope',
      'vuiConstants',
      'physicalAdaptersListColumns',
      'physicalAdaptersListService',
      'networkUiConstants',
      'actionToolbarFactory',
      '$q',
      'addNetworkingWizardConstants'];

   function PhysicalAdaptersViewController(i18nService,
                                           $scope,
                                           vuiConstants,
                                           physicalAdaptersListColumns,
                                           physicalAdaptersListService,
                                           networkUiConstants,
                                           actionToolbarFactory,
                                           $q,
                                           addNetworkingWizardConstants) {

      var self = this;
      self.liveRefreshProperties = [
         "config.network.pnic",
         "config.network.vswitch",
         "config.network.proxySwitch",
         "config.network.opaqueSwitch",
         "config.sriovDevicePool",
         "config.pciPassthruInfo"
      ];
      self.physicalAdaptersLoading = false;
      self.showNoItemSelected = true;
      self.hostId = $scope._route.objectId;
      self.headerOptions = {
         title: i18nService.getString('NetworkUi', 'host.manage.pnicHeader'),
         objectId: self.hostId,
         actions: []
      };

      self.splitterOptions = {
         orientation: vuiConstants.splitter.orientation.VERTICAL,
         panes: [
            {
               min: '150px',
               size: '45%'
            }, {
               min: '250px',
               size: '55%'
            }
         ]
      };

      var evaluationContext = { pnic: null };
      var actionAvailabilityById = {};
      evaluationContext.connectionType = addNetworkingWizardConstants.connectionType.PNIC;
      self.refresh = function () {
         self.errorRetrievingData = null;
         var pnicActions = [
            networkUiConstants.actions.ADD_NETWORKING,
            networkUiConstants.actions.REFRESH_NETWORK,
            vuiConstants.actions.SEPARATOR,
            networkUiConstants.actions.EDIT_PNIC];

         var physicalAdaptersPromise =
               physicalAdaptersListService.getPhysicalAdapterItems(self.hostId);

         var createActionbarOptionsPromise = actionToolbarFactory
               .createActionbarOptions([self.hostId], pnicActions, evaluationContext);

         self.physicalAdaptersLoading = true;
         $q.all([physicalAdaptersPromise, createActionbarOptionsPromise]).then(function (responses) {
            var physicalAdapterItems = responses[0];
            var actionbarOptions = responses[1];

            // When the datagridOptions.data is refreshed, the watch for the selectedItems
            // is called with an empty array before the grid preselection directive tries
            // to preselect the last selected item. This flag is used to skip the first
            // trigger of the watch when the data is refreshed.
            self.ingnoreNextItemSelection = true;

            if (!self.datagridOptions) {
               self.datagridOptions = createDatagridOptions(actionbarOptions);
            }

            self.datagridOptions.data = physicalAdapterItems;

            _.forEach(actionbarOptions.actions, function (action) {
               if (action !== vuiConstants.actions.SEPARATOR) {
                  actionAvailabilityById[action.actionId] = action.enabled;
               }
            });

            self.physicalAdaptersLoading = false;
         }, function (error) {
            self.physicalAdaptersLoading = false;
            var errorStr = error && error.data && error.data.message
                  ? error.data.message : '';

            self.errorRetrievingData = i18nService.getString(
                  'NetworkUi', 'PnicView.error', errorStr);
         });
      };

      self.refresh();

      $scope.preselectComparator = function (item) {
         return !!$scope.selectedPhysicalAdapterDevice
               && $scope.selectedPhysicalAdapterDevice === item.device;
      };

      function onPnicSelectionChange (selectedItems) {
         if (self.ingnoreNextItemSelection) {
            toggleActionsAvailability();
            self.ingnoreNextItemSelection = false;
            return;
         }

          self.showNoItemSelected =
               !selectedItems || selectedItems.length === 0;

         if (!self.showNoItemSelected) {
            $scope.selectedPhysicalAdapterDevice = selectedItems[0].device;
            evaluationContext.pnic = selectedItems[0].device;
            self.adapterDetailsHeader = i18nService.getString('NetworkUi',
                  'PnicPropertiesView.title', $scope.selectedPhysicalAdapterDevice);
         } else {
            $scope.selectedPhysicalAdapterDevice = null;
            evaluationContext.pnic = null;
         }
         toggleActionsAvailability();
      }

      function createDatagridOptions (actionBarOptions) {
         return {
            height: '100%',
            pageConfig: {
               hidePager: true
            },
            columnDefs: physicalAdaptersListColumns,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            data: [],
            selectedItems: [],
            resizable: true,
            actionBarOptions: actionBarOptions,
            onChange: onPnicSelectionChange
         };
      }

      // Toggles the enabled/disabled flag of Edit action that depend on some item's
      // selection
      function toggleActionsAvailability() {
         self.datagridOptions.actionBarOptions.actions.forEach(function(action) {
            if (action !== vuiConstants.actions.SEPARATOR) {
               action.enabled = actionAvailabilityById[action.actionId] &&
                     (self.datagridOptions.selectedItems.length > 0 ||
                     action.actionId !== networkUiConstants.actions.EDIT_PNIC);
            }
         });
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditPnicDialogComponent = (function () {
        function EditPnicDialogComponent() {
            this.bindings = {
                pageModel: "<",
                validator: "<"
            };
            this.controller = EditPnicDialogController;
            this.templateUrl = "network-ui/resources/network/views/host/pnic/edit/editPnicDialogTemplate.html";
        }
        return EditPnicDialogComponent;
    }());
    network_ui.EditPnicDialogComponent = EditPnicDialogComponent;
    var EditPnicDialogController = (function () {
        function EditPnicDialogController(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.validateNumberOfVirtualFunctions = function () {
                var errors = [];
                if (!_this.pageModel.sriovEnabled) {
                    return [];
                }
                if (_this.pageModel.numVirtualFunctionsRequested < 1
                    || _this.pageModel.numVirtualFunctionsRequested >
                        _this.pageModel.maxVirtualFunctionSupported) {
                    errors.push(_this.i18n("H5NetworkUi", "EditPnicView.sriov.errorMessage", _this.pageModel.maxVirtualFunctionSupported));
                }
                return errors;
            };
            this.i18n = i18nService.getString;
            this.linkSpecificationOptions = this.buildLinkSpecificationOptions();
            this.sriovOptions = this.buildSriovOptions();
        }
        EditPnicDialogController.prototype.onSriovStatusChanged = function () {
            if (this.pageModel.sriovEnabled && !this.pageModel.numVirtualFunctionsRequested) {
                this.pageModel.numVirtualFunctionsRequested = 1;
            }
        };
        EditPnicDialogController.prototype.buildLinkSpecificationOptions = function () {
            var _this = this;
            var options = [];
            if (this.pageModel.linkSpecification) {
                this.pageModel.linkSpecification.forEach(function (linkSpeed) {
                    options.push({
                        label: _this.buildLinkSpeedLabel(linkSpeed),
                        value: linkSpeed
                    });
                });
            }
            return options;
        };
        EditPnicDialogController.prototype.buildSriovOptions = function () {
            var options = [];
            if (this.pageModel.sriovCapable) {
                options.push({
                    label: this.i18n("H5NetworkUi", "EditPnicView.sriov.status.enabled"),
                    value: true
                });
                options.push({
                    label: this.i18n("H5NetworkUi", "EditPnicView.sriov.status.disabled"),
                    value: false
                });
            }
            return options;
        };
        EditPnicDialogController.prototype.buildLinkSpeedLabel = function (linkSpeed) {
            // full duplex
            if (linkSpeed.duplex) {
                return this.i18n("NetworkUi", "PnicView.mbFullDuplex", linkSpeed.speedMb);
            }
            // half duplex
            if (!linkSpeed.duplex && linkSpeed.speedMb > 0) {
                return this.i18n("NetworkUi", "PnicView.mbHalfDuplex", linkSpeed.speedMb);
            }
            return this.i18n("NetworkUi", "PnicView.autonegotiate");
        };
        EditPnicDialogController.$inject = ["i18nService"];
        return EditPnicDialogController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editPnicDialog", new EditPnicDialogComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var PhysicalNicEditSpec = com.vmware.vsphere.client.network.PhysicalNicEditSpec;
    var LinkSpeedDuplex = com.vmware.vim.binding.vim.host.PhysicalNic$LinkSpeedDuplex;
    var SriovConfig = com.vmware.vim.binding.vim.host.SriovConfig;
    var EditPnicDialogModel = (function () {
        function EditPnicDialogModel(data) {
            var _this = this;
            if (data) {
                this.name = data.name;
                if (data.linkSpeed) {
                    this.linkSpeed = new LinkSpeedDuplex();
                    this.linkSpeed.duplex = data.linkSpeed.duplex;
                    this.linkSpeed.speedMb = data.linkSpeed.speedMb;
                }
                if (data.linkSpecification) {
                    this.linkSpecification = [];
                    data.linkSpecification.forEach(function (currentLinkSpeed) {
                        // We need to store the same reference as 'this.linkSpeed' for the
                        // ng-option directive to be able to match the current model's value to
                        // one of the select's options
                        if (_this.equals(currentLinkSpeed, _this.linkSpeed)) {
                            _this.linkSpecification.push(_this.linkSpeed);
                        }
                        else {
                            _this.linkSpecification.push(currentLinkSpeed);
                        }
                    });
                }
                if (data.sriovInfoItem && data.sriovInfoItem.sriovCapable) {
                    this.sriovCapable = data.sriovInfoItem.sriovCapable;
                    this.sriovActive = data.sriovInfoItem.sriovActive;
                    this.sriovEnabled = data.sriovInfoItem.sriovEnabled;
                    this.numVirtualFunction = data.sriovInfoItem.numVirtualFunction;
                    this.numVirtualFunctionsRequested =
                        data.sriovInfoItem.numVirtualFunctionsRequested;
                    this.maxVirtualFunctionSupported =
                        data.sriovInfoItem.maxVirtualFunctionSupported;
                    this.pnicPci = data.pci;
                }
            }
        }
        EditPnicDialogModel.prototype.buildSpec = function (initialSpec) {
            var spec = new PhysicalNicEditSpec();
            spec.device = this.name;
            var linkSpeedChanged = !this.equals(this.linkSpeed, initialSpec.linkSpeed);
            var changedSRIOV = initialSpec.sriovEnabled !== this.sriovEnabled
                || (this.sriovEnabled
                    && initialSpec.numVirtualFunctionsRequested !== this.numVirtualFunctionsRequested);
            if (linkSpeedChanged && !this.isAutoNegotiate(this.linkSpeed)) {
                spec.linkSpeed = this.linkSpeed;
            }
            if (changedSRIOV) {
                var sriovConfig = new SriovConfig();
                sriovConfig.sriovEnabled = this.sriovEnabled;
                sriovConfig.numVirtualFunction = this.sriovEnabled
                    ? this.numVirtualFunctionsRequested
                    : 0;
                sriovConfig.id = this.pnicPci;
                spec.sriovConfig = sriovConfig;
            }
            return changedSRIOV || linkSpeedChanged ? spec : null;
        };
        EditPnicDialogModel.prototype.isAutoNegotiate = function (linkSpeed) {
            return linkSpeed.speedMb === 0 && linkSpeed.duplex === false;
        };
        EditPnicDialogModel.prototype.equals = function (src, dest) {
            if (!src || !dest) {
                return false;
            }
            return src.speedMb === dest.speedMb &&
                src.duplex === dest.duplex;
        };
        return EditPnicDialogModel;
    }());
    network_ui.EditPnicDialogModel = EditPnicDialogModel;
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditPnicDialogService = (function () {
        function EditPnicDialogService(dataService, i18nService, clarityModalService, mutationService, vxValidatorFactory, vuiConstants) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.vxValidatorFactory = vxValidatorFactory;
            this.vuiConstants = vuiConstants;
            this.i18n = this.i18nService.getString;
        }
        EditPnicDialogService.prototype.show = function (hostId, pnicName) {
            var modalOptions = {
                title: this.i18nService.getString("H5NetworkUi", "PnicView.editTitle"),
                defaultButton: "submit",
                alerts: [],
                dialogData: {
                    validator: this.vxValidatorFactory.create()
                },
                contentTemplate: "network-ui/resources/network/views/host/pnic/edit/editPnicDialog.html",
                onSubmit: onSubmit.bind(this)
            };
            var pnicPromise = this.getEditPnicDialogData(hostId, pnicName);
            var initialModel = null;
            pnicPromise.then(function (dataServiceResponse) {
                var data = dataServiceResponse[EditPnicDialogService.EDIT_PNIC_DATA_MODEL];
                if (data) {
                    modalOptions.subTitle = data.name;
                    // Store the initial model in order the generate the diff onSubmit.
                    initialModel = new network_ui.EditPnicDialogModel(data);
                }
                modalOptions.dialogData.pageModel =
                    new network_ui.EditPnicDialogModel(data);
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
            function onSubmit() {
                if (initialModel) {
                    if (modalOptions.dialogData.validator.validate().length) {
                        modalOptions.alerts = [{
                                text: this.i18n("H5NetworkUi", "EditPnicView.sriov.errorMessage", modalOptions.dialogData.pageModel.maxVirtualFunctionSupported),
                                type: this.vuiConstants.validationBanner.type.ERROR
                            }];
                        return false;
                    }
                    var spec = modalOptions.dialogData.pageModel.buildSpec(initialModel);
                    if (spec) {
                        this.mutationService.apply(hostId, spec._type, spec);
                    }
                }
                return true;
            }
        };
        EditPnicDialogService.prototype.getEditPnicDialogData = function (hostId, pnicName) {
            var params = [{
                    propertyName: EditPnicDialogService.EDIT_PNIC_DATA_MODEL,
                    parameterType: 'java.lang.String',
                    parameter: pnicName
                }];
            var pnicPromise = this.dataService.getProperties(hostId, [EditPnicDialogService.EDIT_PNIC_DATA_MODEL], {
                propertyParams: params
            });
            return pnicPromise;
        };
        EditPnicDialogService.$inject = [
            "dataService",
            "i18nService",
            "clarityModalService",
            "mutationService",
            "vxValidatorFactory",
            "vuiConstants"];
        EditPnicDialogService.EDIT_PNIC_DATA_MODEL = "pnic:editPhysicalAdapterModel";
        return EditPnicDialogService;
    }());
    network_ui.EditPnicDialogService = EditPnicDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("editPnicDialogService", EditPnicDialogService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * Opens Edit port group dialog as a multi page dialog.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .service('editPortGroupDialogService', editPortGroupDialogService);

   editPortGroupDialogService.$inject = [
         'dataService',
         '$rootScope',
         'i18nService',
         'vxMultiPageDialogService',
         'PortGroupDialogManager'];

   function editPortGroupDialogService(
         dataService,
         $rootScope,
         i18nService,
         vxMultiPageDialogService,
         PortGroupDialogManager) {

      return {
         show: show
      };

      function show(hostId, actionEval, portgroupKey, portgroupName) {
         var portgroupDialogDataProperty = "portgroup:portgroupDialogData";
         var portgroupDialogDataParams = {
            propertyParams: [{
               propertyName: portgroupDialogDataProperty,
               parameterType: 'java.lang.String',
               parameter: portgroupKey
            }]
         };

         var portGroupData = {
            properties: {},
            securityPolicies: {},
            trafficShapingPolicies: {},
            teamingAndFailover: {}
         };
         var dialogScope = $rootScope.$new();
         dialogScope.dialogOptions = {};

         var portGroupDialogManager = new PortGroupDialogManager(portGroupData,
               dialogScope.dialogOptions);
         dialogScope.manager = portGroupDialogManager;

         _.extend(dialogScope.dialogOptions, {
            title: i18nService.getString(
                  'NetworkUi', 'EditPortgroupSettingsView.title', ''),
            iconClass: actionEval.action.icon,
            //reduced height due to overridden margins and padding in nw-edit-pg-page
            height: '676px',
            width: '1000px',
            actionDetails: {
               actionEval: actionEval,
               availableTargets: [hostId]
            },
            pages: portGroupDialogManager.getPageDefinitions(),
            show: true,
            loading: true, // this prevents the dialog from being initialized
                           // until port group data is loaded
            loadingMessage: i18nService.getString('CommonUi', 'wizard.loading'),
            confirmOptions: {
               onClick: portGroupDialogManager.submit
            },
            validationBanner: {},
            rejectOptions: {
               rejectOnEsc: true
            },
            resizable: true,
            draggable: true,
            maximizable: true
         });

         var options = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vxMultiPageDialogService(options);

         dataService.getProperties(
               hostId, [portgroupDialogDataProperty], portgroupDialogDataParams)
               .then(function (response) {
                  _.extend(portGroupData, response[portgroupDialogDataProperty]);
                  portGroupData.hostId = response.id;
                  dialogScope.dialogOptions.title =
                        i18nService.getString('NetworkUi',
                              'EditPortgroupSettingsView.title', portgroupName);
                  dialogScope.dialogOptions.loading = false;
                  dialogScope.initialData =
                        angular.copy(dialogScope.manager.portgroupData);
               });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.network')
      .controller('PortFailoverPolicyPageController',
         PortFailoverPolicyPageController);

   PortFailoverPolicyPageController.$inject = [
      '$scope',
      'portFailoverPolicyPageService',
      'networkUtil',
      'networkUiConstants',
      'editPortgroupService'];

   function PortFailoverPolicyPageController($scope, portFailoverPolicyPageService,
      networkUtil, networkUiConstants, editPortgroupService) {

      var initialData = $scope.initialData.teamingAndFailover;
      this.signPostConfig = {
         message: null,
         title: networkUtil.getString(
            "PortFailoverPolicyPage.lb.loadbalance_ip.popup.title"),
         class: "edit-standard-pg-signpost"
      };

      this.loadBalancingOptions = networkUtil.createNicTeamingPolicyOptions(
            $scope.manager.portgroupData.teamingAndFailover.nicTeamingPolicy);

      this.failureDetectionValidator = {
         message: null,
         isVisible: true
      };

      this.failureDetectionOptions = [{
         val: false,
         label: networkUtil.getString("PortFailoverPolicyPage.linkStatus")
      }, {
         val: true,
         label: networkUtil.getString("PortFailoverPolicyPage.beaconProbing")
      }];

      this.notifySwitchesOptions = [{
         val: false,
         label: networkUtil.getString("PortFailoverPolicyPage.notifyOff")
      }, {
         val: true,
         label: networkUtil.getString("PortFailoverPolicyPage.notifyOn")
      }];

      this.failbackOptions = [{
         val: true,
         label: networkUtil.getString("PortFailoverPolicyPage.failbackOff")
      }, {
         val: false,
         label: networkUtil.getString("PortFailoverPolicyPage.failbackOn")
      }];

      this.notifySwitches = "notifySwitches";
      this.failback = "failback";

      this.failoverOrderHeaderTitle =
            networkUtil.getString("PortFailoverPolicyPage.orderLabel");

      this.failoverOrderActions = [
         networkUiConstants.failoverOrderActions.MOVE_UP,
         networkUiConstants.failoverOrderActions.MOVE_DOWN
      ];

      this.failoverOrder = {
         connectees: $scope.manager.portgroupData.teamingAndFailover.pnics,
         connecteesDetails: $scope.manager.portgroupData.teamingAndFailover.pnics ?
            $scope.manager.portgroupData.teamingAndFailover.pnics.pnicDetails : null,
         labels: {
            active: networkUtil.getString("FailoverOrderEditor.active"),
            standby: networkUtil.getString("FailoverOrderEditor.standby"),
            unused: networkUtil.getString("FailoverOrderEditor.unused")
         }
      };

      this.noItemsSelectedMessage = networkUtil.getString(
         'FailoverOrderEditor.detailsPrompt');

      $scope.$watchCollection(function () {
         var objectsToWatch = [
            $scope.manager.portgroupData.teamingAndFailover.loadBalancingOverridden,
            $scope.manager.portgroupData.teamingAndFailover.loadBalancing,
            $scope.manager.portgroupData.teamingAndFailover.failureDetectionOverridden,
            $scope.manager.portgroupData.teamingAndFailover.checkBeacon,
            $scope.manager.portgroupData.teamingAndFailover.notifySwitchesOverridden,
            $scope.manager.portgroupData.teamingAndFailover.notifySwitches,
            $scope.manager.portgroupData.teamingAndFailover.failbackOverridden,
            $scope.manager.portgroupData.teamingAndFailover.rollingOrder,
            $scope.manager.portgroupData.teamingAndFailover.failoverOrderOverridden
         ];
         // If there are no nics assigned `teamingAndFailover.pnics` is null.
         if ($scope.manager.portgroupData.teamingAndFailover.pnics) {
            objectsToWatch.push(
               $scope.manager.portgroupData.teamingAndFailover.pnics.active.length);
            objectsToWatch.push(
               $scope.manager.portgroupData.teamingAndFailover.pnics.standby.length);
            objectsToWatch.push(
               $scope.manager.portgroupData.teamingAndFailover.pnics.unused.length);
         }
         return objectsToWatch;
      }, function () {
         // a flag indicating whether this digest cycle is the first one,
         // or it has been triggered by a change in any of the watched elements
         this.hasBeenTouched = (this.hasBeenTouched === undefined ? false : true);

         this.loadBalancingMessages = portFailoverPolicyPageService
            .getLoadBalancingMessages($scope.manager.portgroupData.teamingAndFailover);

         this.signPostConfig.message = this.loadBalancingMessages ?
            portFailoverPolicyPageService.formatMessages(this.loadBalancingMessages) :
            null;

         if (this.signPostConfig.message) {
            this.signPostIcon = this.loadBalancingMessages.length === 3 ?
               'exclamation-triangle' : 'info-circle';
         }

         var failureDetectionWarmMessage =
            portFailoverPolicyPageService.getFailureDetectionValidationMessage(
               $scope.manager.portgroupData.teamingAndFailover);

         this.failureDetectionValidator.message = failureDetectionWarmMessage;
         // true if there is a message; false otherwise
         // if we don`t set this manually, we may see an empty signpost
         this.failureDetectionValidator.isVisible = !!failureDetectionWarmMessage;

         if ($scope.failoverPolicies.checkBeacon) {
            this.failureDetectionValidator.isVisible =
                  this.failureDetectionValidator.message !== null;
         }
      }.bind(this));

      $scope.manager.commitPageCallbacks.commitPortFailoverPolicyPage = onCommit.bind(this);

      function onCommit() {
         /*jshint validthis:true */
         var config = $scope.manager.portgroupData.teamingAndFailover;
         $scope.manager.pageDirtyFlags.isFailoverPolicyPageDirty =
               editPortgroupService.hasFailoverPolicyChanged(initialData, config, true) ||
               editPortgroupService.hasFailoverOrderChanged(initialData, config, true);

         // Perform validation ONLY if the page state has been changed
         if($scope.manager.pageDirtyFlags.isFailoverPolicyPageDirty) {
            if (this.failureDetectionValidator.message) {
               $scope.manager.showDialogErrors([this.failureDetectionValidator.message]);
               return false;
            }

            if (this.hasBeenTouched) {
               var failoverOrderWarnMessage =
                     portFailoverPolicyPageService.getFailoverOrderWarnMessage(
                           config.failoverOrderOverridden, config.pnics);
               var loadBalancingWarnMessage = _.find(
                     this.loadBalancingMessages, function(message) {
                        return message.iconClass === 'vsphere-icon-status-warning';
                     });

               if (loadBalancingWarnMessage || failoverOrderWarnMessage) {
                  var messages = [];

                  if (loadBalancingWarnMessage) {
                     messages.push(loadBalancingWarnMessage);
                  }

                  if (failoverOrderWarnMessage) {
                     messages.push(failoverOrderWarnMessage);
                  }
                  return portFailoverPolicyPageService.confirmWarningModal(messages);
               }
            }
         }
         return true;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.network')
      .service('portFailoverPolicyPageService', portFailoverPolicyPageService);

   portFailoverPolicyPageService.$inject = [
      'clarityModalService',
      '$q',
      'networkUtil',
      'networkUiConstants'
   ];

   function portFailoverPolicyPageService(clarityModalService, $q,
      networkUtil, networkUiConstants) {

      return {
         getFailureDetectionValidationMessage: getFailureDetectionValidationMessage,
         getLoadBalancingMessages: getLoadBalancingMessages,
         getFailoverOrderWarnMessage: getFailoverOrderWarnMessage,
         formatMessages: formatMessages,
         confirmWarningModal: confirmWarningModal
      };

      function getFailureDetectionValidationMessage(config) {
         if (config.failureDetectionOverridden) {
            var numberOfNicsAssigned = 0;

            if (config.pnics) {
               if (config.pnics.active) {
                  numberOfNicsAssigned += config.pnics.active.length;
               }
               if (config.pnics.standby) {
                  numberOfNicsAssigned += config.pnics.standby.length;
               }
               if (config.pnics.unused) {
                  numberOfNicsAssigned += config.pnics.unused.length;
               }
            }

            if (config.checkBeacon && numberOfNicsAssigned < 2) {
               return networkUtil.getString(
                  'PortPolicyData.failover.error.beaconProbingSingleNic');
            }
         }
         return null;
      }

      // formats the given messages into a html with the corresponding icon classes
      // if the messages == 3 - the first is a warning and the rest - info messages
      // if the messages != 3 - all of them are info messages
      function formatMessages(messages) {
         if (!messages || messages.length === 0) {
            return null;
         }

         var result = [];
         _.each(messages, function(message) {
            result.push(formatMessage(message));
         });

         return result.length > 0 ? result.join("<br>") : null;
      }

      function formatMessage(message) {
         return "<div class='row'>" +
                   "<span class='col-md-1'>" +
                     "<span class='" + message.iconClass + " failover-icon'></span>" +
                   "</span>" +
                   "<span class='col-md-11 info-msg-color'>" + message.text + "</span>" +
                "</div>";
      }

      function confirmWarningModal(messages) {
         var deferred = $q.defer();
         var modalOptions = {
            title: networkUtil.getString(
                  'PortPolicyData.failover.lb.loadbalance_ip.confirmation.title'),
            size: 'md',
            defaultButton: 'submit',
            alerts: [],
            dialogData : {
               messages: [],
               dialogInfo: networkUtil.getString("IssuesConfirmationDialog.tip")
            },
            contentTemplate: 'network-lib-ui/resources/network-lib/dvpg/' +
                  'edit/portgroupFailoverErrorWarningDialog.html',
            onSubmit : function () {
               deferred.resolve(true);
               return true;
            }
         };

         _.forEach(messages, function (message) {
            modalOptions.dialogData.messages.push(buildWarnMessage(message.text, true));
         });

         // open modal
         clarityModalService.openOkCancelModal(modalOptions);
         return deferred.promise.then(function (value) {
            return value;
         });
      }

      function getLoadBalancingMessages(config) {
         if (!config.loadBalancingOverridden ||
            config.loadBalancing !== networkUiConstants.LoadBalancingPolicy.IP) {
            return null;
         }

         var messages = getLoadBalancingInfoMessages();
         var checkBeacon = config.failureDetectionOverridden ? config.checkBeacon : null;

         var standbyAdapters = config.failoverOrderOverridden && config.pnics ?
            config.pnics.standby : [];

         var warningMessage = getLoadBalancingWarningMessage(standbyAdapters, checkBeacon);

         if (warningMessage) {
            messages = [warningMessage].concat(messages);
         }
         return messages;
      }

      function getFailoverOrderWarnMessage(isFailoverOrderOverridden, pnics) {
         if (isFailoverOrderOverridden &&
               pnics && pnics.active && pnics.active.length === 0) {
            return buildWarnMessage(networkUtil.getString(
                  'PortPolicyData.failover.error.noActiveAdapters'));
         }
         return null;
      }

      function getLoadBalancingWarningMessage(standby, checkBeacon) {
         if (standby && standby.length > 0) {
            var stringToLocalize = checkBeacon ?
               "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbingAndStandbyUplinks" :
               "PortPolicyData.failover.lb.loadbalance_ip.warn.standbyUplinks";
            return buildWarnMessage(networkUtil.getString(stringToLocalize));
         } else if (checkBeacon) {
            return buildWarnMessage(networkUtil.getString(
               "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbing"));
         }
         return null;
      }

      function getLoadBalancingInfoMessages() {
         var messages = [
            buildInfoMessage(networkUtil.getString(
               "PortPolicyData.failover.lb.loadbalance_ip.info.etherChannel")),
            buildInfoMessage(networkUtil.getString(
               "PortPolicyData.failover.lb.loadbalance_ip.info.portGroupPolicies"))
         ];
         return messages;
      }

      function buildInfoMessage(infoMessage) {
         return {
            text: infoMessage,
            iconClass: 'vsphere-icon-info'
         };
      }

      function buildWarnMessage(warnMessage, isDialogMessage) {
         return {
            text: warnMessage,
            iconClass: isDialogMessage ? 'warning' : 'vsphere-icon-status-warning'
         };
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .controller('PortGroupPropertiesPageController',
               PortGroupPropertiesPageController);

   PortGroupPropertiesPageController.$inject = [
      '$scope',
      '$q',
      'networkUtil',
      'i18nService',
      'portGroupPropertiesPageService',
      'editPortgroupService'];

   function PortGroupPropertiesPageController(
         $scope,
         $q,
         networkUtil,
         i18nService,
         portGroupPropertiesPageService,
         editPortgroupService) {

      $scope.nameValidator = {
         message: null,
         isVisible: false
      };

      $scope.onNameChange = function () {
         var message = portGroupPropertiesPageService.getInvalidNameError(
               $scope.manager.portgroupData.properties.portgroupName);
         setErrorTooltip(message);
      };

      $scope.manager.commitPageCallbacks.commitPortgroupPage = onCommit;

      var initialData = $scope.initialData.properties;

      function onCommit() {
         $scope.manager.pageDirtyFlags.isPorpertiesPageDirty =
               editPortgroupService.havePortgroupPropertiesChanged(initialData,
                     $scope.manager.portgroupData.properties);
         if (!$scope.manager.pageDirtyFlags.isPorpertiesPageDirty) {
            return true;
         }

         return validateName().then(function (error) {
            var errors = [];

            if (error) {
               errors.push(error);
               setErrorTooltip(error);
            }

            if (!networkUtil.isVlanIdValid($scope.manager.portgroupData.properties.portgroupVlanId)) {
               error = i18nService.getString('NetworkUi', 'VnicData.invalidVlanId');
               errors.push(error);
            }

            if (errors.length > 0) {
               $scope.manager.showDialogErrors(errors);

            }

            return errors.length === 0;
         });
      }

      function validateName() {
         var error = portGroupPropertiesPageService.getInvalidNameError(
               $scope.manager.portgroupData.properties.portgroupName);

         if (error) {
            return $q.resolve(error);
         }

         var props = $scope.manager.portgroupData.properties;

         if (props.oldPortgroupName === props.portgroupName) {
            return $q.resolve(null);
         }

         return portGroupPropertiesPageService.getDuplicateNameError(
               $scope.manager.portgroupData.hostId,
               $scope.manager.portgroupData.properties.portgroupName);
      }

      function setErrorTooltip(message) {
         $scope.nameValidator = {
            message: message,
            isVisible: message !== null
         };
      }

      return this;
   }
})();

(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .service('portGroupPropertiesPageService', portGroupPropertiesPageService);

   /**
    * Service dedicated to portGroupPropertiesPage template.
    */
   portGroupPropertiesPageService.$inject = [
         'i18nService',
         'mutationService'];

   function portGroupPropertiesPageService(
         i18nService,
         mutationService) {

      return {
         getInvalidNameError: getInvalidNameError,
         getDuplicateNameError: getDuplicateNameError
      };

      /**
       * Returns localized error message if the name is a text with no more than 127
       * characters and it doesn't include `"` one.
       */
      function getInvalidNameError(name) {
         if (name.trim().length === 0) {
            return i18nService.getString('NetworkUi', 'VnicData.emptyNetworkLabel');
         } else if (name.length > 127) {
            return i18nService.getString('NetworkUi', 'VnicData.networkLabelTooLong');
         } else if (name.indexOf('"') !== -1) {
            return i18nService.getString('H5NetworkUi',
                  'VnicData.networkLabelInvalidCharacter');
         }
         return null;
      }

      /**
       * Returns localized error text if the given host has a portgroup with the
       * provided name. Otherwise it returns null.
       */
      function getDuplicateNameError(hostId, name) {
         return mutationService.validate(hostId,
               'com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.StandardNetworkLabelValidateSpec',
               {
                  _type: 'com.vmware.vsphere.client.h5.network.host.wizard.addnetworking.model.StandardNetworkLabelValidateSpec',
                  label: name.trim()
               })
               .then(function (validationResult) {

                  if (validationResult.error) {
                     if (validationResult.error.localizedMessage) {
                        return validationResult.error.localizedMessage;
                     }
                  }

                  if (validationResult.result) {
                     return validationResult.result;
                  }

                  return null;
               }, function () {
                  return null;
               });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.network')
         .controller('PortSecurityPolicyPageController',
               PortSecurityPolicyPageController);

   PortSecurityPolicyPageController.$inject = [
      '$scope',
      'networkUtil',
      'editPortgroupService'];

   function PortSecurityPolicyPageController($scope, networkUtil, editPortgroupService) {
      $scope.options = [{
         label: networkUtil.getString('PortSecurityPolicyPage.accept'),
         val: true
      }, {
         label: networkUtil.getString('PortSecurityPolicyPage.reject'),
         val: false
      }];

      var initialData = $scope.initialData.securityPolicies;

      $scope.manager.commitPageCallbacks.commitSecurityPage = onCommit;

      function onCommit() {
         $scope.manager.pageDirtyFlags.isSecurityPageDirty = editPortgroupService
               .hasSecurityPolicyChanged(initialData,
                     $scope.manager.portgroupData.securityPolicies, true);
         return true;
      }

      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .controller('PortTrafficShapingPolicyPageController',
               PortTrafficShapingPolicyPageController);

   PortTrafficShapingPolicyPageController.$inject = [
      '$scope',
      'networkUtil',
      'networkUiConstants',
      'trafficShapingPolicyValidator',
      'editPortgroupService',
      'vuiConstants'];

   function PortTrafficShapingPolicyPageController($scope,
         networkUtil,
         networkUiConstants,
         trafficShapingPolicyValidator,
         editPortgroupService,
         vuiConstants) {

      var attributeNames = [
         networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH,
         networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH,
         networkUiConstants.TrafficShapingSetting.BURST_SIZE
      ];

      var initialData = $scope.initialData.trafficShapingPolicies;

      this.options = [{
         label: networkUtil.getString('PortTrafficShapingPolicyPage.statusOn'),
         val: true
      }, {
         label: networkUtil.getString('PortTrafficShapingPolicyPage.statusOff'),
         val: false
      }];

      this.validators = {
         averageBandwidth: {
            message: null,
            isVisible: false
         },
         peakBandwidth: {
            message: null,
            isVisible: false
         },
         burstSize: {
            message: null,
            isVisible: false
         }
      };

      $scope.manager.commitPageCallbacks.commitTrafficShapingPolicyPage = onCommit;

      $scope.$watchCollection(function() {
         return [
            $scope.manager.portgroupData.trafficShapingPolicies.enabled,
            $scope.manager.portgroupData.trafficShapingPolicies.overridden
         ];
      }, function() {
         _.forEach(attributeNames, function(attributeName) {
            this.onTrafficShapingChange(attributeName);
         }.bind(this));
      }.bind(this));

      this.onTrafficShapingChange = function (attributeName) {
         var value = $scope.manager.portgroupData.trafficShapingPolicies[attributeName];

         var message =
            trafficShapingPolicyValidator.getTrafficShapingErrorMessage(value, attributeName);

         this.validators[attributeName].message = message;
         this.validators[attributeName].isVisible =
            $scope.manager.portgroupData.trafficShapingPolicies.overridden &&
            $scope.manager.portgroupData.trafficShapingPolicies.enabled && message !== null;
      };

      function onCommit () {
         var errors = [];
         $scope.manager.pageDirtyFlags.isTrafficShapingPageDirty = editPortgroupService
               .hasTrafficShapingPolicyChanged(initialData,
                     $scope.manager.portgroupData.trafficShapingPolicies, true);

         if ($scope.manager.pageDirtyFlags.isTrafficShapingPageDirty &&
               $scope.manager.portgroupData.trafficShapingPolicies.overridden &&
               $scope.manager.portgroupData.trafficShapingPolicies.enabled) {
            _.forEach(attributeNames, function(attributeName) {
               var value =
                     $scope.manager.portgroupData.trafficShapingPolicies[attributeName];
               var errorMessage = trafficShapingPolicyValidator
                     .getTrafficShapingErrorMessage(value, attributeName);
               if (errorMessage !== null) {
                  errors.push(createError(errorMessage));
               }
            });

            if (errors.length === 0 &&
                  $scope.manager.portgroupData.trafficShapingPolicies.averageBandwidth >
                  $scope.manager.portgroupData.trafficShapingPolicies.peakBandwidth) {
               var msg = networkUtil.getString(
                     'PortPolicyData.shaping.error.avgBwGreaterThanPeakBw');
               errors.push(createError(msg));
            }
         }

         return errors;
      }

      function createError(errorMessage) {
         return {
            type: vuiConstants.validationBanner.type.ERROR,
            text: errorMessage
         };
      }
      return this;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * Factory that handles port groups edit related operations.
    * Builds all the edit port groups dialog page models and submits the edited
    * port group data to the server.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .factory('PortGroupDialogManager', PortGroupDialogManager);

   PortGroupDialogManager.$inject = [
      'i18nService',
      'mutationService',
      'vuiConstants'];

   function PortGroupDialogManager(
         i18nService,
         mutationService,
         vuiConstants) {

      return function (portgroupData, dialogOptions) {
         var EDIT_PORT_GROUP_SPEC =
               'com.vmware.vsphere.client.h5.network.host.portgroup.model.EditPortgroupDialogData';
         var propertiesPageDef;

         var portSecurityPageDef;

         var portTrafficShapingPolicyPageDef;

         var portFailoverPolicyPageDef;

         /**
          * Contains onCommit page callbacks.
          */
         var commitPageCallbacks = {
            commitPortgroupPage: function () { return true; },
            commitSecurityPage: function () { return true; },
            commitTrafficShapingPolicyPage: function () { return true; },
            commitPortFailoverPolicyPage: function () { return true; }
         };
         /**
          * Contains the flags indicating whether a page's state has been changed.
          */
         var pageDirtyFlags = {
            isPorpertiesPageDirty: false,
            isSecurityPageDirty: false,
            isTrafficShapingPageDirty: false,
            isFailoverPolicyPageDirty: false
         };

         createPages();

         return {
            portgroupData: portgroupData,
            commitPageCallbacks: commitPageCallbacks,
            pageDirtyFlags: pageDirtyFlags,
            getPageDefinitions: getPageDefinitions,
            showDialogErrors: showDialogErrors,
            submit: submit
         };

         function createPages() {
            propertiesPageDef = {
               page: {
                  title: i18nService.getString(
                        'NetworkUi', 'PortgroupSettingsView.properties'),
                  contentUrl: 'network-ui/resources/network/views/host/portgroup/' +
                        'pages/portGroupPropertiesPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitPortgroupPage);
                  }
               }
            };

            portSecurityPageDef = {
               page: {
                  title: i18nService.getString('NetworkUi',
                        'PortSecurityPolicyView.title'),
                  contentUrl: 'network-ui/resources/network/views/host/portgroup/' +
                        'pages/portSecurityPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitSecurityPage);
                  }
               }
            };

            portTrafficShapingPolicyPageDef = {
               page: {
                  title: i18nService.getString('NetworkUi',
                        'PortTrafficShapingPolicyView.title'),
                  contentUrl: 'network-ui/resources/network/views/host/portgroup/' +
                  'pages/portTrafficShapingPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitTrafficShapingPolicyPage);
                  }
               }
            };

            portFailoverPolicyPageDef = {
               page: {
                  title: i18nService.getString('NetworkUi',
                        'PortFailoverPolicyView.title'),
                  contentUrl: 'network-ui/resources/network/views/host/portgroup/' +
                  'pages/portFailoverPolicyPage.html',
                  onCommit: function () {
                     return execute(commitPageCallbacks.commitPortFailoverPolicyPage);
                  }
               }
            };
         }

         function getPageDefinitions() {
            var pages = [];

            pages.push(propertiesPageDef.page);
            pages.push(portSecurityPageDef.page);
            pages.push(portTrafficShapingPolicyPageDef.page);
            pages.push(portFailoverPolicyPageDef.page);

            return pages;
         }

         function submit() {
            // trigger mutation operation only if something has changed
            if (pageDirtyFlags.isPorpertiesPageDirty ||
                  pageDirtyFlags.isSecurityPageDirty ||
                  pageDirtyFlags.isTrafficShapingPageDirty ||
                  pageDirtyFlags.isFailoverPolicyPageDirty ) {
               //In order to not send any non validated values, when the value is
               // too big the serializer throws error
               if (!portgroupData.trafficShapingPolicies.overridden ||
                     !portgroupData.trafficShapingPolicies.enabled) {

                  portgroupData.trafficShapingPolicies.averageBandwidth = null;
                  portgroupData.trafficShapingPolicies.peakBandwidth = null;
                  portgroupData.trafficShapingPolicies.burstSize = null;
               }

               mutationService.apply(
                     portgroupData.hostId, EDIT_PORT_GROUP_SPEC,
                     portgroupData);
            }

            return true;
         }

         /**
          * Shows provided error messages in dialog overlay banner.
          */
         function showDialogErrors(errors /* String[] */) {
            if (!errors || errors.length < 1) {
               return;
            }

            clearValidationMessages();
            dialogOptions.validationBanner.messages = _.map(
                  errors,
                  function(message) {
                     return {
                        type: vuiConstants.validationBanner.type.ERROR,
                        text: message
                     };
                  });
         }

         function clearValidationMessages() {
            dialogOptions.validationBanner.messages = [];
         }

      };
   }

   function execute(func) {
      if (typeof func === 'function') {
         return func();
      }
   }
})();

var network_ui;
(function (network_ui) {
    var UpdateProxySwitchUplinkMappingSpec = com.vmware.vsphere.client.h5.network.host.proxyswitch.spec.UpdateProxySwitchUplinkMappingSpec;
    var ManageProxySwitchPnicsDialogService = (function () {
        function ManageProxySwitchPnicsDialogService(i18nService, clarityModalService, mutationService, clarityConstants, $q) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.clarityConstants = clarityConstants;
            this.$q = $q;
        }
        ManageProxySwitchPnicsDialogService.prototype.show = function (hostId, dvsRef, proxySwitchKey, dvsName) {
            var _this = this;
            var uplinkData;
            var modalOptions = {
                title: this.i18nService.getString("H5NetworkUi", "manageVssPnicsDialog.title"),
                subTitle: {
                    text: dvsName
                },
                contentTemplate: "network-ui/resources/network/views/host/proxyswitch/manageProxySwitchPnicsDialogTemplate.html",
                defaultButton: "submit",
                dialogData: {
                    hostId: hostId,
                    dvsRef: dvsRef,
                    proxySwitchKey: proxySwitchKey,
                    onUplinkMappingCreated: function (newValue) {
                        uplinkData = newValue;
                    }
                },
                alerts: [],
                size: "lg",
                modalClass: "manage-pnic-modal",
                onSubmit: function () {
                    var spec = new UpdateProxySwitchUplinkMappingSpec();
                    spec.uplinkPortMappings = uplinkData.uplinkPortMapping;
                    spec.proxySwitchKey = proxySwitchKey;
                    var resultPromise;
                    if (_this.areAllUplinksFreeOrDisconnected(uplinkData)) {
                        resultPromise = _this.mutationService.validate(hostId, spec._type, spec)
                            .then(function (validationResult) {
                            var validationPromise;
                            if (validationResult.result) {
                                modalOptions.alerts = [{
                                        type: _this.clarityConstants.notifications.type.ERROR,
                                        text: validationResult.result
                                    }];
                                validationPromise = _this.$q.when(false);
                            }
                            else {
                                validationPromise =
                                    _this.clarityModalService.openConfirmationModal({
                                        title: _this.i18nService.getString("DvsUi", "HpsPhysicalNicEditor.warn.noActiveNics.title"),
                                        message: _this.i18nService.getString("DvsUi", "HpsPhysicalNicEditor.warn.noActiveNics.text"),
                                        clarityIcon: {
                                            class: "is-warning",
                                            shape: "warning-standard",
                                            size: "32"
                                        },
                                        preserveNewlines: true
                                    });
                            }
                            return validationPromise;
                        });
                    }
                    else {
                        resultPromise = _this.$q.when(true);
                    }
                    resultPromise.then(function (isOperationConfirmed) {
                        if (isOperationConfirmed) {
                            _this.mutationService.apply(hostId, spec._type, spec);
                        }
                    });
                    return resultPromise;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        ManageProxySwitchPnicsDialogService.prototype.areAllUplinksFreeOrDisconnected = function (uplinkData) {
            return _.all(uplinkData.uplinkPortMapping, function (mapping) { return mapping.pnicName === null || !uplinkData.pnicDetails[mapping.pnicName].actualSpeed; });
        };
        ManageProxySwitchPnicsDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "mutationService",
            "clarityConstants",
            "$q"
        ];
        return ManageProxySwitchPnicsDialogService;
    }());
    network_ui.ManageProxySwitchPnicsDialogService = ManageProxySwitchPnicsDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("manageProxySwitchPnicsDialogService", ManageProxySwitchPnicsDialogService);
})(network_ui || (network_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var ProxySwitchDetailsDialogContent = (function () {
        function ProxySwitchDetailsDialogContent() {
            this.bindings = {
                dvsId: "<"
            };
            this.controller = ProxySwitchDetailsDialogContentController;
            this.template = "\n               <vx-activity-indicator is-visible=\"$ctrl.loading\"\n                             title=\"{{i18n('Common', 'loadingTitle')}}\"></vx-activity-indicator>\n               <vx-property-view data=\"$ctrl.data\"\n                                 class=\"network-ui-fixed-size-vx-property-view\"\n                                 ng-if=\"!$ctrl.loading\"/>\n               ";
        }
        return ProxySwitchDetailsDialogContent;
    }());
    network_ui.ProxySwitchDetailsDialogContent = ProxySwitchDetailsDialogContent;
    var ProxySwitchDetailsDialogContentController = (function () {
        function ProxySwitchDetailsDialogContentController(i18nService, proxySwitchDetailsDialogService) {
            this.i18nService = i18nService;
            this.proxySwitchDetailsDialogService = proxySwitchDetailsDialogService;
            this.i18n = i18nService.getString;
        }
        ProxySwitchDetailsDialogContentController.prototype.$onInit = function () {
            var _this = this;
            this.proxySwitchDetailsDialogService.getData(this.dvsId)
                .then(function (data) {
                _this.data = data;
            });
        };
        Object.defineProperty(ProxySwitchDetailsDialogContentController.prototype, "loading", {
            get: function () {
                return !this.data;
            },
            enumerable: true,
            configurable: true
        });
        ProxySwitchDetailsDialogContentController.$inject = [
            "i18nService",
            "proxySwitchDetailsDialogService"
        ];
        return ProxySwitchDetailsDialogContentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("proxySwitchDetailsDialogContent", new ProxySwitchDetailsDialogContent());
})(network_ui || (network_ui = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var StandardSwitchDetailsDialogContent = (function () {
        function StandardSwitchDetailsDialogContent() {
            this.bindings = {
                hostId: "<",
                switchKey: "<"
            };
            this.controller = StandardSwitchDetailsDialogContentController;
            this.template = "\n               <vx-activity-indicator is-visible=\"$ctrl.loading\"\n                             title=\"{{i18n('Common', 'loadingTitle')}}\"></vx-activity-indicator>\n               <clr-tabs ng-if=\"!$ctrl.loading\">\n\n                  <clr-tab-link>{{$ctrl.i18n(\"H5NetworkUi\", \"standardSwitchDetailsView.tabs.all\")}}</clr-tab-link>\n                  <clr-tab-link>{{$ctrl.i18n(\"H5NetworkUi\", \"standardSwitchDetailsView.tabs.properties\")}}</clr-tab-link>\n                  <clr-tab-link>{{$ctrl.i18n(\"H5NetworkUi\", \"standardSwitchDetailsView.tabs.policies\")}}</clr-tab-link>\n\n                  <clr-tab-content>\n                     <div class=\"standard-switch-details-dialog-tab\">\n                        <vx-property-view\n                           data=\"$ctrl.propertiesData\"\n                           class=\"vx-property-view-standard-fixed-label-column\">\n                        </vx-property-view>\n                        <vx-property-view\n                           data=\"$ctrl.policiesData\"\n                           class=\"vx-property-view-standard-fixed-label-column\">\n                        </vx-property-view>\n                     </div>\n                  </clr-tab-content>\n\n                  <clr-tab-content>\n                     <div class=\"standard-switch-details-dialog-tab\">\n                        <vx-property-view\n                           data=\"$ctrl.propertiesData\"\n                           class=\"vx-property-view-standard-fixed-label-column\">\n                        </vx-property-view>\n                     </div>\n                  </clr-tab-content>\n\n                  <clr-tab-content>\n                     <div class=\"standard-switch-details-dialog-tab\">\n                        <vx-property-view\n                           data=\"$ctrl.policiesData\"\n                           class=\"vx-property-view-standard-fixed-label-column\">\n                        </vx-property-view>\n                     </div>\n                  </clr-tab-content>\n               </clr-tabs>\n               ";
        }
        return StandardSwitchDetailsDialogContent;
    }());
    network_ui.StandardSwitchDetailsDialogContent = StandardSwitchDetailsDialogContent;
    var StandardSwitchDetailsDialogContentController = (function () {
        function StandardSwitchDetailsDialogContentController(i18nService, standardSwitchPropertiesViewService, standardSwitchPoliciesViewService) {
            this.i18nService = i18nService;
            this.standardSwitchPropertiesViewService = standardSwitchPropertiesViewService;
            this.standardSwitchPoliciesViewService = standardSwitchPoliciesViewService;
            this.i18n = i18nService.getString;
        }
        StandardSwitchDetailsDialogContentController.prototype.$onInit = function () {
            var _this = this;
            this.standardSwitchPropertiesViewService.getData(this.hostId, this.switchKey)
                .then(function (propertiesData) {
                _this.propertiesData = propertiesData;
            });
            this.standardSwitchPoliciesViewService.getData(this.hostId, this.switchKey)
                .then(function (policiesData) {
                _this.policiesData = policiesData;
            });
        };
        Object.defineProperty(StandardSwitchDetailsDialogContentController.prototype, "loading", {
            get: function () {
                return !this.propertiesData || !this.policiesData;
            },
            enumerable: true,
            configurable: true
        });
        StandardSwitchDetailsDialogContentController.$inject = [
            "i18nService",
            "standardSwitchPropertiesViewService",
            "standardSwitchPoliciesViewService"
        ];
        return StandardSwitchDetailsDialogContentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("standardSwitchDetailsDialogContent", new StandardSwitchDetailsDialogContent());
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var GhostDvsProxySwitchDetailsController = (function () {
        function GhostDvsProxySwitchDetailsController($scope) {
            this.$scope = $scope;
            this.dialogData = $scope.modalOptions.dialogData;
            var onRouteChangeEventHandler = $scope.$on("vxRouteChangeSuccess", function () {
                $scope.modalOptions.modalOpen = false;
            });
            $scope.$on("$destroy", function () {
                onRouteChangeEventHandler();
            });
        }
        GhostDvsProxySwitchDetailsController.$inject = ["$scope"];
        return GhostDvsProxySwitchDetailsController;
    }());
    network_ui.GhostDvsProxySwitchDetailsController = GhostDvsProxySwitchDetailsController;
    angular.module('com.vmware.vsphere.client.network')
        .controller('GhostDvsProxySwitchDetailsController', GhostDvsProxySwitchDetailsController);
})(network_ui || (network_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var GhostDvsProxySwitchDetailsService = (function () {
        function GhostDvsProxySwitchDetailsService(clarityModalService, i18nService, dataService, columnRenderersRegistry, defaultUriSchemeUtil) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.SEPARATOR = ", ";
            this.DVS_UUID_SEPARATOR = "; ";
            this.DOUBLE_QUOTE = "\"";
        }
        GhostDvsProxySwitchDetailsService.prototype.show = function (hostId, switchUuids) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("NetworkUi", "ghostDvsProxySwitchDetectedEvent.dialog.title"),
                subTitle: {
                    objectId: hostId
                },
                size: "lg",
                defaultButton: "close",
                hideSubmitButton: true,
                closeButtonTitle: this.i18nService.getString("NetworkUi", "ghostDvsProxySwitchDetectedEvent.dialog.okButton"),
                alerts: [],
                dialogData: {
                    loading: true,
                    issueDesc: this.buildIssueDesc(switchUuids),
                    generalContent: this.i18nService.getString("NetworkUi", "ghostDvsProxySwitchDetectedEvent.generalWarning")
                },
                contentTemplate: "network-ui/resources/network/views/host/summary/GhostDvsProxySwitchDetailsDialog.html"
            };
            var params = {
                propertyParams: [
                    {
                        propertyName: GhostDvsProxySwitchDetailsService.GHOST_DVS_PROXY_SWITCH_DETAILS_PROP,
                        parameterType: "java.util.List",
                        parameter: switchUuids
                    }
                ]
            };
            this.dataService.getProperties(hostId, [GhostDvsProxySwitchDetailsService.GHOST_DVS_PROXY_SWITCH_DETAILS_PROP], params)
                .then(function (result) {
                var ghostDvsData = result[GhostDvsProxySwitchDetailsService.GHOST_DVS_PROXY_SWITCH_DETAILS_PROP];
                modalOptions.dialogData.rejoinDesc = _this.buildRejoinDesc(ghostDvsData);
            }).finally(function () {
                modalOptions.dialogData.loading = false;
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        GhostDvsProxySwitchDetailsService.prototype.buildIssueDesc = function (switchUuids) {
            var _this = this;
            var issueDesc = "";
            _.forEach(switchUuids, function (switchUuid, index) {
                issueDesc = issueDesc.concat(_this.DOUBLE_QUOTE + switchUuid + _this.DOUBLE_QUOTE);
                if (index !== switchUuids.length - 1) {
                    issueDesc = issueDesc.concat(_this.DVS_UUID_SEPARATOR);
                }
            });
            return this.i18nService.getString("NetworkUi", "ghostDvsProxySwitchDetectedEvent.info", issueDesc);
        };
        GhostDvsProxySwitchDetailsService.prototype.buildRejoinDesc = function (ghostDvsData) {
            var _this = this;
            if (!ghostDvsData || !ghostDvsData.length) {
                return null;
            }
            var linkAndTextRenderer = this.columnRenderersRegistry.getColumnRenderer("link-and-text");
            var rejoinDesc = "";
            _.forEach(ghostDvsData, function (ghostDvsDetails, index) {
                rejoinDesc = rejoinDesc.concat(linkAndTextRenderer(_this.defaultUriSchemeUtil.getVsphereObjectId(ghostDvsDetails.dvsRef), ghostDvsDetails.name, null, "", true, "ghost-dvs-proxy-switch-link"));
                if (index !== ghostDvsData.length - 1) {
                    rejoinDesc = rejoinDesc.concat(_this.SEPARATOR);
                }
            });
            return this.i18nService.getString("NetworkUi", "ghostDvsProxySwitchDetectedEvent.rejoinWarning", rejoinDesc);
        };
        GhostDvsProxySwitchDetailsService.GHOST_DVS_PROXY_SWITCH_DETAILS_PROP = "hostNetworkingIssue:ghostDvsProxySwitchDetails";
        GhostDvsProxySwitchDetailsService.$inject = [
            "clarityModalService",
            "i18nService",
            "dataService",
            "columnRenderersRegistry",
            "defaultUriSchemeUtil"
        ];
        return GhostDvsProxySwitchDetailsService;
    }());
    network_ui.GhostDvsProxySwitchDetailsService = GhostDvsProxySwitchDetailsService;
    angular.module("com.vmware.vsphere.client.network")
        .service("ghostDvsProxySwitchDetailsService", GhostDvsProxySwitchDetailsService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
angular.module('com.vmware.vsphere.client.network')
   .factory('switchSelectorDialogService',
      ['i18nService',
         'virtualSwitchListService',
         'clarityModalService',
         'clarityConstants',
         'addNetworkingWizardConstants',
         'dataService',
      function (i18nService,
                virtualSwitchListService,
                clarityModalService,
                clarityConstants,
                addNetworkingWizardConstants,
                dataService) {

         // ======================= Public API ==========================

         return {
            openSwitchSelectorDialog: openSwitchSelectorDialog
         };

         //======================= Public Functions ==========================
         /**
          * Opens an OK/Cancel modal dialog in the application.
          */
         function openSwitchSelectorDialog(hostId, connectionType, title, retrieveAllSwitches, okHandler) {
            var dialogData = {};

            var virtualSwitchesProperty = retrieveAllSwitches
                  ? 'virtualswitch:proxyAndStandardSwitches'
                  : 'virtualswitch:virtualStandardSwitches';

            var virtualSwitchesPromise =
                  dataService.getProperties(hostId, [virtualSwitchesProperty]);

            virtualSwitchesPromise.then(function (virtualSwitchesResponse) {
               var virtualSwitches = [];

               var isResponseValid = virtualSwitchesResponse &&
                     virtualSwitchesResponse[virtualSwitchesProperty];
               if (isResponseValid) {
                  virtualSwitches =
                        virtualSwitchesResponse[virtualSwitchesProperty].switchItems || [];
               }
               var showPortsColumn = isResponseValid &&
                     virtualSwitchesResponse[virtualSwitchesProperty].showNumberOfPortsColumn;

               var showIssuesColumn = connectionType === addNetworkingWizardConstants.connectionType.PNIC;

               dialogData.datagridOptions = virtualSwitchListService.createDatagridOptions(
                     virtualSwitches, showIssuesColumn);
            });


            function onClick() {
               var selectedItems = dialogData.datagridOptions.selectedItems;
               if (selectedItems.length === 0) {
                  showError(i18nService.getString('H5NetworkUi',
                        'HostSwitchSelectorDialog.noNetworksSelected'),
                        modalOptions);
                  return false;
               }
               if (okHandler) {
                  okHandler(selectedItems);
               }
               return true;
            }

            var modalOptions = {
               title: title || i18nService
                     .getString("NetworkUi", "HostSwitchSelectorDialog.title"),
               contentTemplate: 'network-ui/resources/network/views/host/switchselector/switchSelectorDialog.html',
               defaultButton: 'submit',
               dialogData: dialogData,
               alerts: [],
               onSubmit: onClick
            };

            clarityModalService.openOkCancelModal(modalOptions);
         }

         function showError(errorMessage, modalOptions) {
            modalOptions.alerts = [{
               text: errorMessage,
               type: clarityConstants.notifications.type.ERROR
            }];
         }
   }]);

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VirtualSwitchesViewComponent = (function () {
        function VirtualSwitchesViewComponent() {
            this.bindings = {};
            this.controller = VirtualSwitchesController;
            this.templateUrl = "network-ui/resources/network/views/host/virtualswitches/" +
                "VirtualSwitchesViewTemplate.html";
        }
        return VirtualSwitchesViewComponent;
    }());
    network_ui.VirtualSwitchesViewComponent = VirtualSwitchesViewComponent;
    var VirtualSwitchesController = (function () {
        function VirtualSwitchesController(navigation, i18nService) {
            this.navigation = navigation;
            this.i18nService = i18nService;
            this.headerOptions = {
                objectId: this.navigation.getRoute().objectId,
                actions: [{
                        actionUid: "vsphere.core.network.actions.addNetworking"
                    }, {
                        actionUid: "vsphere.core.host.network.refreshNetworkAction"
                    }],
                title: this.i18nService.getString('NetworkUi', 'host.manage.vswitchHeader')
            };
        }
        VirtualSwitchesController.$inject = ["navigation", "i18nService"];
        return VirtualSwitchesController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("virtualSwitchesView", new VirtualSwitchesViewComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.network').controller(
      'VmKernelAdapterDetailsViewController', VmKernelAdapterDetailsViewController);

   VmKernelAdapterDetailsViewController.$inject = [
      '$scope'
   ];

   function VmKernelAdapterDetailsViewController ($scope) {

      var self = this;

      self.hostId = $scope._route.objectId;
      self.liveRefreshProperties = [
         "config.network.vnic",
         "config.virtualNicManagerInfo.netConfig",
         "config.network.vswitch",
         "config.network.proxySwitch",
         "config.network.opaqueSwitch",
         "config.network.netStackInstance",
         "config.network.portgroup",
         "config.network.dnsConfig.address"
      ];
      self.registerRefreshCallback = function(refresh) {
         self.refresh = refresh;
      };

      self.customizedSettings = {
         noPoliciesIncluded: false,
         addAllTab: true
      };
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.network').controller(
         'VmKernelAdaptersViewController', VmKernelAdaptersViewController);

   VmKernelAdaptersViewController.$inject = ['i18nService',
      '$scope',
      'vuiConstants',
      'vmKernelAdapterService',
      '$q',
      'networkUiConstants',
      'actionToolbarFactory'];

   function VmKernelAdaptersViewController(i18nService, $scope, vuiConstants,
         vmKernelAdapterService, $q, networkUiConstants,
         actionToolbarFactory) {
      var virtualAdaptersDataProperty = "vnic:virtualAdaptersData";
      var self = this;
      self.liveRefreshProperties = [
         "config.network.vnic",
         "config.virtualNicManagerInfo.netConfig",
         "config.network.vswitch",
         "config.network.proxySwitch",
         "config.network.opaqueSwitch",
         "config.network.netStackInstance",
         "config.network.portgroup"
      ];
      var evaluationContext = { vnic: null };
      var actionAvailabilityById = {};

      self.hostId = $scope._route.objectId;
      self.headerOptions = {
         title: i18nService.getString('NetworkUi', 'host.manage.vnicHeader'),
         objectId: self.hostId,
         actions: []
      };
      self.splitterOptions = {
         orientation: vuiConstants.splitter.orientation.VERTICAL,
         panes: [
            {
               min: '150px',
               size: '45%'
            }, {
               min: '250px',
               size: '55%'
            }
         ]
      };
      self.vmkernelAdaptersLoading = false;
      self.ingnoreNextItemSelection = false;

      $scope.preselectComparator = function (gridDataItem) {
         return gridDataItem.device === $scope.lastSelectedVmKernelAdapterDevice;
      };

      self.refresh = function () {
         self.vmkernelAdaptersLoading = true;

         var showServiceColumns = true;
         var gridLoadedPromise = vmKernelAdapterService.getVnics(self.hostId,
               showServiceColumns);

         var requestActionsPromise = requestActions();

         $q.all([gridLoadedPromise, requestActionsPromise]).then(function (results) {
            var vnicsResponse = results[0];

            var vnicItems = vnicsResponse[virtualAdaptersDataProperty]
                  ? vnicsResponse[virtualAdaptersDataProperty].items
                  : [];
            if (!self.datagridOptions) {
               self.datagridOptions =
                     createDatagridOptions(vnicItems, vnicsResponse.vnicColumnDefs);
            } else {
               self.datagridOptions.data = vnicItems;
            }

            // actions response
            self.datagridOptions.actionBarOptions = results[1];

            _.forEach(self.datagridOptions.actionBarOptions.actions, function (action) {
               if (action !== vuiConstants.actions.SEPARATOR) {
                  actionAvailabilityById[action.actionId] = action.enabled;
               }
            });

            // When the last selected adapter was deleted (not present in refreshed
            // data), the details view should be removed.
            if (wasLastSelectedVnicRemoved(vnicItems)) {
               $scope.lastSelectedVmKernelAdapterDevice = null;
            }

            // When the datagridOptions.data is refreshed, the watch for the selectedItems
            // is called with an empty array before the grid preselection directive tries
            // to preselect the last selected item. This flag is used to skip the first
            // trigger of the watch when the data is refreshed.
            self.ingnoreNextItemSelection = true;

            self.vmkernelAdaptersLoading = false;

         }, function () {
            if (self.datagridOptions) {
               self.datagridOptions.data = [];
            }
            self.vmkernelAdaptersLoading = false;
         });
      };

      self.refresh();

      function requestActions() {
         var vnicActions = [
            networkUiConstants.actions.ADD_NETWORKING,
            networkUiConstants.actions.REFRESH_NETWORK,
            vuiConstants.actions.SEPARATOR,
            networkUiConstants.actions.EDIT_VNIC,
            networkUiConstants.actions.REMOVE_VNIC];

         return actionToolbarFactory.createActionbarOptions([$scope._route.objectId],
               vnicActions, evaluationContext);
      }

      // Toggles the enabled/disabled flag of those actions that depend on some item's
      // selection (e.g. Edit, Remove, etc..)
      function toggleActionsAvailability() {
         self.datagridOptions.actionBarOptions.actions.forEach(function(action) {
            if (action !== vuiConstants.actions.SEPARATOR) {
               action.enabled = actionAvailabilityById[action.actionId] &&
                     (self.datagridOptions.selectedItems.length > 0 ||
                     !isSelectionDependingAction(action));
            }
         });
      }

      function isSelectionDependingAction(action) {
         return action.actionId === networkUiConstants.actions.EDIT_VNIC ||
               action.actionId === networkUiConstants.actions.REMOVE_VNIC;
      }

      function wasLastSelectedVnicRemoved(vnicItems) {
         return !_.some(vnicItems, function (vnicItem) {
            return vnicItem.device === $scope.lastSelectedVmKernelAdapterDevice;
         });
      }

      function onSelectionChange(selectedItems) {
         toggleActionsAvailability();
         if (self.ingnoreNextItemSelection) {
            self.ingnoreNextItemSelection = false;
            return;
         }

         if (selectedItems && selectedItems.length > 0) {
            // User selection or data grid pre-selection.
            self.adapterDetailsHeader = i18nService.getString(
                  'NetworkUi',
                  'VnicDetailsView.title',
                  selectedItems[0].device);
            $scope.lastSelectedVmKernelAdapterDevice =
                  selectedItems[0].device;
            evaluationContext.vnic = selectedItems[0];
         } else {
            evaluationContext.vnic = null;
            $scope.lastSelectedVmKernelAdapterDevice = null;
         }
      }

      function createDatagridOptions(data, columnDefs) {
         return {
            height: '100%',
            pageConfig: {
               hidePager: true
            },
            columnDefs: columnDefs,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            data: data,
            selectedItems: [],
            resizable: true,
            actionBarOptions: {actions: []},
            onChange: onSelectionChange
         };
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * `vnic adapter - Edit Settings` dialog manager.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .factory('editVmkernelAdapterDialogManager', editVmkernelAdapterDialogManager);

   editVmkernelAdapterDialogManager.$inject = [
         'i18nService',
         'hostVnicServiceConstants',
         'vnicConstants',
         'vuiConstants',
         'clarityModalService',
         '$q',
         'mutationService'];

   /**
    * Factory injection constructor.
    */
   function editVmkernelAdapterDialogManager(
         i18nService,
         hostVnicServiceConstants,
         vnicConstants,
         vuiConstants,
         clarityModalService,
         $q,
         mutationService) {

      /**
       * Factory instantiation constructor.
       */
      return function (vnicData, dialogOptions) {
         /**
          * Factory interface.
          */
         return {
            vnicData: vnicData,
            getPageDefinitions: getPageDefinitions,
            loadIpv6Page: loadIpv6Page,
            loadBindToPnicPage: loadBindToPnicPage,
            submit: submit
         };

         // region interface impl

         function getPageDefinitions() {
            var portPropertiesPage = {
               title: i18nService.getString('NetworkUi', 'VnicView.properties'),
               contentUrl: 'network-ui/resources/network/views/host/vnic/' +
                           'pages/editVnicPortPropertiesPage.html',
               onCommit: function () {
                  return vnicData.portPropertiesPageModel.onCommit();
               }
            };

            var ipv4Page = {
               title: i18nService.getString('NetworkUi', 'VnicView.ipv4Settings'),
               contentUrl: 'network-ui/resources/network/views/host/vnic/' +
                           'pages/editVnicIpv4Page.html',
               onCommit: function () {
                  return vnicData.ipv4PageModel.onCommit();
               }
            };

            return [portPropertiesPage, ipv4Page];
         }

         function loadIpv6Page () {
               var ipv6Page = {
                  title: i18nService.getString('NetworkUi', 'VnicView.ipv6Settings'),
                  contentUrl: 'network-ui/resources/network/views/host/vnic/' +
                  'pages/editVnicIpv6Page.html',
                  onCommit: function() {
                     return vnicData.ipv6PageModel.onCommit();
                  }
               };
               dialogOptions.pages.push(ipv6Page);
         }

         function loadBindToPnicPage() {
               var bindToPnicPage = {
                  title: i18nService.getString('NetworkUi',
                        'AddNetworkingWizard.physicalNicBindingPage.title'),
                  contentUrl: 'network-ui/resources/network/views/host/vnic/' +
                  'pages/editBindToPhysicalAdapterPage.html',
                  onCommit: function() {
                     return vnicData.bindToPnicPageModel.onCommit();
                  }
               };
               dialogOptions.pages.push(bindToPnicPage);
         }

         function submit() {
            if (!ipSettingsEnabled()) {
               dialogOptions.validationBanner.messages = [];

               dialogOptions.validationBanner.messages.push({
                  text: i18nService.getString('NetworkUi', 'EditVnicView.noIpSettingsError'),
                  type: vuiConstants.validationBanner.type.ERROR
               });
               return false;
            }

            var vnicEditSpec = createEditVnicSpec();
            var ipConfig = createIpConfig();
            var ipRouteSpec = createIpRouteSpec();

            if (ipConfig !== null) {
               _.extend(vnicEditSpec.spec, {
                  ip: ipConfig
               });
            }

            if (vnicData.ipv6PageModel.dirty) {
               var ipv6Config = createIpv6Config(true);

               if (vnicEditSpec.spec.ip === null) {
                  vnicEditSpec.spec.ip = createEmptyIpConfig();
               }

               _.extend(vnicEditSpec.spec.ip, { ipV6Config: ipv6Config });
            }

            if (ipRouteSpec !== null) {
               _.extend(vnicEditSpec.spec, {
                  ipRouteSpec: ipRouteSpec
               });
            }

            var portsDirty = vnicData.portPropertiesPageModel.dirty
                  || vnicEditSpec.changedVmkSettings.length > 0;

            var ipv4Dirty = vnicData.ipv4PageModel.dirty;
            var ipv6Dirty = vnicData.ipv6PageModel.dirty;

            var bindToPnicDirty = vnicData.bindToPnicPageModel.dirty;

            if (portsDirty || ipv4Dirty || ipv6Dirty || bindToPnicDirty) {
               return validateVnic(vnicEditSpec)
                  .then(function (validationResult) {
                     if (validationResult) {
                        mutationService.apply(
                           vnicData.hostId,
                           vnicEditSpec._type,
                           vnicEditSpec);
                     }
                     return validationResult;
                  });
            } else {
               return true;
            }
         }

         // endregion

         // region private helpers

         function createEditVnicSpec() {
            var keys = hostVnicServiceConstants.keys;
            var keyToNicTypeMap = vnicConstants.serviceKeyToNicTypeMap;

            var vnicEditSpec = _.pick(
                  vnicData.portPropertiesPageModel.hostVnicSettings,
                  keys.VMOTION,
                  keys.PROVISIONING,
                  keys.FT_LOGGING,
                  keys.MANAGEMENT,
                  keys.VR,
                  keys.VR_NFC,
                  keys.VSAN
            );

            vnicEditSpec._type = 'com.vmware.vsphere.client.modules.api.network.VirtualNicEditSpec';
            vnicEditSpec.spec = {
               _type: 'com.vmware.vim.binding.vim.host.VirtualNic$Specification'
            };

            if (vnicData.portPropertiesPageModel.dirty) {
               vnicEditSpec.spec.mtu = vnicData.portPropertiesPageModel.mtuInBytes;
            }

            if (vnicData.bindToPnicPageModel.dirty) {
               if (vnicData.bindToPnicPageModel.componentData.bindToPnicEnabled) {
                  vnicEditSpec.spec.pinnedPnic =
                        vnicData.bindToPnicPageModel.componentData.selectedPnicForBinding;
               } else {
                  // Set the pinnedPnic to empty string
                  // in order to remove the pinned physical adapter
                  vnicEditSpec.spec.pinnedPnic = "";
               }
            }

            // The name is required even though it is read-only
            vnicEditSpec.virtualNicName = vnicData.vnicDevice;

            vnicEditSpec.changedVmkSettings = [];
            _.forEach(vnicData.portPropertiesPageModel.hostVnicSettings,
                  function(setting, key) {
                     if (setting !== vnicData.portPropertiesPageModel
                           .initialHostVnicSettings[key]) {
                        vnicEditSpec.changedVmkSettings.push(keyToNicTypeMap[key]);
                     }
                  });

            return vnicEditSpec;

         }

         /**
          * Create part of vnic edit spec based on IPv4 settings page.
          */
         function createIpConfig() {
            if (!vnicData.ipv4PageModel.dirty && !vnicData.ipv6PageModel.dirty) {
               return null;
            }

            var ipOption = vnicConstants.ipSettingsOption;

            var ipConfig = createEmptyIpConfig();
            ipConfig.dhcp = vnicData.ipv4PageModel.ipSettingsOption === ipOption.dhcp;

            if (vnicData.ipv4PageModel.ipSettingsOption === ipOption.unset) {
               ipConfig.ipAddress = '';
               ipConfig.subnetMask = '';
               // IPv6 Config should be set because it is required by the updateVnic API.
               ipConfig.ipV6Config = createIpv6Config(true /* isIpv6ConfigSet */);
            } else if (vnicData.ipv4PageModel.ipSettingsOption === ipOption.staticIp) {
               ipConfig.ipAddress = vnicData.ipv4PageModel.ipAddress;
               ipConfig.subnetMask = vnicData.ipv4PageModel.subnetMask;
            }

            // IPv6 Config should be set when Ipv6 is enabled on host.
            if (vnicData.ipv4PageModel.ipv6Enabled) {
               ipConfig.ipV6Config = createIpv6Config();
            }

            return ipConfig;
         }

         /**
          * Create part of vnic edit spec that assigns
          * ipv4 and ipv6 default gateways
          */
         function createIpRouteSpec() {
            if (!vnicData.ipv4PageModel.isGatewayFeatureSupported
                  || (!vnicData.ipv4PageModel.dirty && !vnicData.ipv6PageModel.dirty)) {
               return null;
            }

            var ipRouteSpec = createEmptyIpRouteSpec();

            if (vnicData.ipv4PageModel.ipSettingsOption
                  === vnicConstants.ipSettingsOption.staticIp
                  && vnicData.ipv4PageModel.isGatewayOverriden) {
               ipRouteSpec.ipRouteConfig.defaultGateway =
                     vnicData.ipv4PageModel.defaultGateway;
            } else {
               ipRouteSpec.ipRouteConfig.defaultGateway = null;
            }

            // in order to preserve the ipv6 default gateway value from the vnic
            if (vnicData.ipv4PageModel.ipv6Enabled
                  && vnicData.ipv6PageModel.staticIpEnabled
                  && vnicData.ipv6PageModel.isGatewayOverridden) {
               ipRouteSpec.ipRouteConfig.ipV6DefaultGateway =
                     vnicData.ipv6PageModel.defaultGateway;
            } else {
               ipRouteSpec.ipRouteConfig.ipV6DefaultGateway = null;
            }

            return ipRouteSpec;
         }

         function createIpv6Config(isIpv6ConfigSet) {
            return {
               _type: 'com.vmware.vim.binding.vim.host.IpConfig$IpV6AddressConfiguration',
               autoConfigurationEnabled: vnicData.ipv6PageModel.autoConfigEnabled,
               dhcpV6Enabled: vnicData.ipv6PageModel.dhcpEnabled,
               ipV6Address: isIpv6ConfigSet ? createIpv6Addresses() : []
            };
         }

         function createIpv6Addresses() {
            var ipAddresses = vnicData.ipv6PageModel.staticIpv6Addresses;
            var isStaticIpEnabled = vnicData.ipv6PageModel.staticIpEnabled;

            return _.map(ipAddresses, function(ipAddress) {
               return {
                  _type: 'com.vmware.vim.binding.vim.host.IpConfig$IpV6Address',
                  ipAddress: ipAddress.address,
                  prefixLength: ipAddress.prefixLength,
                  operation: (isStaticIpEnabled)
                        ? ipAddress.operation
                        : vnicConstants.changeOperation.remove
               };
            });
         }

         function createEmptyIpConfig() {
            return {
               _type: 'com.vmware.vim.binding.vim.host.IpConfig'
            };
         }

         function ipSettingsEnabled () {
            var staticIp = vnicConstants.ipSettingsOption.staticIp;
            var dhcp = vnicConstants.ipSettingsOption.dhcp;

            return vnicData.ipv4PageModel.ipSettingsOption === staticIp ||
                   vnicData.ipv4PageModel.ipSettingsOption === dhcp ||
                   vnicData.ipv6PageModel.autoConfigEnabled ||
                   vnicData.ipv6PageModel.dhcpEnabled ||
                   vnicData.ipv6PageModel.staticIpEnabled;
         }

         function createEmptyIpRouteSpec() {
            return {
               _type: 'com.vmware.vim.binding.vim.host.VirtualNic$IpRouteSpec',
               ipRouteConfig: {
                  _type: 'com.vmware.vim.binding.vim.host.IpRouteConfig'
               }
            };
         }

         function validateVnic(vnicEditSpec) {
            //display a progress bar while validating the vmknic settings
            dialogOptions.loading = true;
            dialogOptions.loadingMessage =
               i18nService.getString('CommonUi', 'wizard.validating');

            var deferred = $q.defer();

            mutationService
               .validate(vnicData.hostId, vnicEditSpec._type, vnicEditSpec)
               .then(function (validationResult) {
                  if (!!validationResult.result) {
                     var modalOptions = {
                        title: i18nService.getString(
                           'H5NetworkUi', 'EditVMkernel.confirmEditTitle'),
                        message: validationResult.result,
                        clarityIcon: {
                           class: "is-warning",
                           shape: "warning-standard",
                           size: "32"
                        },
                        preserveNewlines: true,
                        submit: function () {
                           deferred.resolve(true);
                        },
                        onCancel: function() {
                           deferred.resolve(false);
                        }
                     };
                     clarityModalService.openConfirmationModal(modalOptions);
                  } else {
                     deferred.resolve(true);
                  }
               })
               .finally(function() {
                  dialogOptions.loading = false;
               });
            return deferred.promise;
         }

         // endregion
      };
   }
})();
(function() {
   'use strict';

   /**
    * Service that opens `vmkernel adapter - Edit settings` dialog.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .service('editVmkernelAdapterDialogService', editVmkernelAdapterDialogService);

   editVmkernelAdapterDialogService.$inject = [
      '$rootScope',
      'i18nService',
      'dataService',
      'vxMultiPageDialogService',
      'editVmkernelAdapterDialogManager',
      'hostVnicServiceFactory'];

   function editVmkernelAdapterDialogService (
         $rootScope,
         i18nService,
         dataService,
         vxMultiPageDialogService,
         editVmkernelAdapterDialogManager,
         hostVnicServiceFactory) {

      return {
         show: show
      };

      /**
       * Shows `vmkernel adapter - Edit settings` dialog.
       */
      function show(actionEval, hostId, vnic) {
         var EDIT_HOST_VNIC_DATA = 'vnic:editHostVnicModel';

         var propertyParams = [{
            propertyName: EDIT_HOST_VNIC_DATA,
            parameterType: 'java.lang.String',
            parameter: vnic.device
         }];

         var vnicData = {};
         vnicData.hostId = hostId;
         vnicData.vnicDevice = vnic.device;

         var dialogOptions = {};
         var dialogScope = $rootScope.$new();

         var dialogManager = new editVmkernelAdapterDialogManager(
               vnicData, dialogOptions);

         _.extend(dialogOptions, {
            title: i18nService.getString(
                  'NetworkUi', 'EditVnicView.title', vnic.device),
            iconClass: actionEval.action.icon,
            actionDetails: {
               actionEval: actionEval,
               availableTargets: []
            },
            pages: dialogManager.getPageDefinitions(),
            show: true,
            loading: true, // wait for data to load before start initialization
            loadingMessage: i18nService.getString('CommonUi', 'wizard.loading'),
            confirmOptions: {
               onClick: dialogManager.submit
            },
            rejectOptions: {
               rejectOnEsc: true
            },
            resizable: true,
            draggable: true,
            maximizable: true
         });

         dialogScope.dialogOptions = dialogOptions;
         dialogScope.manager = dialogManager;
         dialogScope.dialogOptions.loading = true;

         var config = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vxMultiPageDialogService(config);

         dataService
               .getProperties(
                     hostId,
                     [EDIT_HOST_VNIC_DATA],
                     { propertyParams: propertyParams })
               .then(function(result) {
                  var pageModel =
                        result[EDIT_HOST_VNIC_DATA].editPortPropertiesPageModel;

                  vnicData.portPropertiesPageModel = {};
                  vnicData.ipv4PageModel = result[EDIT_HOST_VNIC_DATA].editIpv4PageModel;
                  vnicData.ipv6PageModel = result[EDIT_HOST_VNIC_DATA].editIpv6PageModel;
                  vnicData.bindToPnicPageModel = result[EDIT_HOST_VNIC_DATA].editBindToPnicPageModel;

                  vnicData.portPropertiesPageModel.tcpIpStackName =
                        pageModel.tcpIpStackName;

                  vnicData.portPropertiesPageModel.mtuInBytes = pageModel.mtuInBytes;

                  vnicData.portPropertiesPageModel.hostVnicFeatures =
                        hostVnicServiceFactory.pickServiceFeatures(pageModel);
                  vnicData.portPropertiesPageModel.hostVnicSettings =
                        hostVnicServiceFactory.pickServiceSettings(pageModel);
                  // keep a copy of the initial settings state
                  vnicData.portPropertiesPageModel.initialHostVnicSettings =
                        hostVnicServiceFactory.pickServiceSettings(pageModel);

               }).finally(function() {
                  if (vnicData.ipv4PageModel.ipv6Enabled) {
                     dialogManager.loadIpv6Page();
                  }
                  if (vnicData.bindToPnicPageModel.opaqueNetworkSpec) {
                     dialogManager.loadBindToPnicPage();
                  }
                  dialogScope.dialogOptions.loading = false;
               });
      }
   }
})();

(function () {
   'use strict';

   /**
    * Service that opens `Manage physical network adapters` dialog.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .service('manageVssPnicsDialogService', ManageVssPnicsDialogService);

   ManageVssPnicsDialogService.$inject = [
      'i18nService',
      'physicalAdaptersListService',
      'clarityModalService',
      'mutationService',
      '$q'
   ];

   function ManageVssPnicsDialogService(i18nService,
                                        physicalAdaptersListService,
                                        clarityModalService,
                                        mutationService,
                                        $q) {

      this.show = function (hostId, vSwitchName) {

         var dialogData = {};
         dialogData.noItemsSelectedMessage = i18nService.getString('NetworkUi',
               'FailoverOrderEditor.detailsPrompt');
         dialogData.headerOptions = {
            title: i18nService.getString("NetworkUi", "FailoverOrderEditor.failoverOrder")
         };
         dialogData.loading = true;

         var modalOptions = {
            title: i18nService.getString("H5NetworkUi", "manageVssPnicsDialog.title"),
            subTitle: {
               text: vSwitchName
            },
            contentTemplate: 'network-ui/resources/network/views/host/vnic/manageVssPnicsDialog.html',
            defaultButton: 'submit',
            dialogData: dialogData,
            alerts: [],
            size: 'lg',
            modalClass: 'manage-pnic-modal',
            onSubmit: submit
         };
         clarityModalService.openOkCancelModal(modalOptions);

         physicalAdaptersListService.getPhysicalAdaptersWithDetails(hostId, vSwitchName).then(function (data) {
            var connectees = {};
            connectees.active = data.active || [];
            connectees.standby = data.standby || [];
            connectees.unused = data.unused || [];
            connectees.unclaimed = data.unclaimed;
            modalOptions.dialogData.failoverOrderOptions = {};
            modalOptions.dialogData.failoverOrderOptions.connectees = connectees;
            modalOptions.dialogData.failoverOrderOptions.connecteesDetails = data.pnicDetails;
            modalOptions.dialogData.failoverOrderOptions.labels = {
               active: i18nService.getString("NetworkUi", "FailoverOrderEditor.active"),
               standby: i18nService.getString("NetworkUi", "FailoverOrderEditor.standby"),
               unused: i18nService.getString("NetworkUi", "FailoverOrderEditor.unused")
            };
            modalOptions.dialogData.editAllItems = true;
            modalOptions.dialogData.loading = false;
         });

         function submit() {
            var deferred = $q.defer();

            getValidationErrors(hostId, vSwitchName,
                  modalOptions.dialogData.failoverOrderOptions.connectees,
                  modalOptions.dialogData.failoverOrderOptions.connecteesDetails
            ).then(function (validationError) {
               if(validationError && validationError.result) {
                  var modalOptions = {
                     title: i18nService.getString("NetworkUi",
                           'PhysicalNicFailoverOrderPage.warn.noActiveNics.title'),
                     message: validationError.result,
                     clarityIcon: {
                        class: "is-warning",
                        shape: "warning-standard",
                        size: "32"
                     },
                     preserveNewlines: true,
                     submit: function () {
                        confirmManagePnics();
                        deferred.resolve(true);
                     },
                     onCancel: function() {
                        deferred.resolve(false);
                     }
                  };
                  clarityModalService.openConfirmationModal(modalOptions);
               } else {
                  confirmManagePnics();
                  deferred.resolve(true);
               }
            });

            return deferred.promise.then(function (value) {
               return value;
            });
         }

         function confirmManagePnics(){
            var vssPnicReconfigureSpec =
                  new VssPnicReconfigureSpec(vSwitchName,
                        modalOptions.dialogData.failoverOrderOptions.connectees.active,
                        modalOptions.dialogData.failoverOrderOptions.connectees.standby,
                        modalOptions.dialogData.failoverOrderOptions.connectees.unused);

            mutationService.apply(hostId, vssPnicReconfigureSpec._type, vssPnicReconfigureSpec);
         }
      };

      function getValidationErrors(hostId, vSwitchName, connectees, pnicDetails) {
         return $q(function (resolve) {
            var validationResult = {};

            if(areAllPnicsDisconnected(connectees.active, pnicDetails)) {
               if(connectees.standby.length + connectees.unused.length > 0) {
                  validationResult.result =
                        i18nService.getString('NetworkUi', 'VssPhysicalNicEditor.warn.noActiveNics.text');
                  resolve(validationResult);
               } else {

                  var managePnicValidateSpec = {};
                  managePnicValidateSpec.vSwitchName = vSwitchName;

                  var validationPromise = mutationService.validate(hostId,
                        'com.vmware.vsphere.client.h5.network.host.managepnic.model.ManagePnicValidateSpec',
                        managePnicValidateSpec);
                  resolve(validationPromise);
               }
            } else {
               resolve(validationResult);
            }
         });
      }

      function areAllPnicsDisconnected(activePnics, pnicsDetails) {
         return !_.some(activePnics, function (pnic) {
            if (pnic !== null && pnicsDetails[pnic] && pnicsDetails[pnic].isConnected) {
               return true;
            }
         });
      }

      function VssPnicReconfigureSpec(vSwitchName, active, standby, unused) {
         this._type = "com.vmware.vsphere.client.h5.network.host.managepnic.model.VssPnicReconfigureSpec";
         this.vSwitchName = vSwitchName;
         this.activeNic = active;
         this.standbyNic = standby;
         this.unusedNic = unused;
      }
   }
})();

var network_ui;
(function (network_ui) {
    var EditBindToPhysicalAdapterController = (function () {
        function EditBindToPhysicalAdapterController($scope, i18nService, bindToPhysicalAdapterService, vuiConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.bindToPhysicalAdapterService = bindToPhysicalAdapterService;
            this.vuiConstants = vuiConstants;
            this.i18n = this.i18nService.getString.bind(this.i18nService, "NetworkUi");
            this.$scope.manager.vnicData.bindToPnicPageModel.onCommit = function () {
                var pinnedPhysicalAdapter = _this.$scope.manager.vnicData.bindToPnicPageModel.pinnedPnic;
                var pageModelData = _this.$scope.manager.vnicData.bindToPnicPageModel.componentData;
                if (pageModelData.bindToPnicEnabled && !pageModelData.selectedPnicForBinding) {
                    return [{
                            type: _this.vuiConstants.validationBanner.type.ERROR,
                            text: _this.i18n("VnicToPnicBindingPage.error.noNic")
                        }];
                }
                if (pageModelData.bindToPnicEnabled) {
                    if (pageModelData.selectedPnicForBinding !== pinnedPhysicalAdapter) {
                        _this.$scope.manager.vnicData.bindToPnicPageModel.dirty = true;
                    }
                }
                else {
                    if (pinnedPhysicalAdapter) {
                        _this.$scope.manager.vnicData.bindToPnicPageModel.dirty = true;
                    }
                }
                return [];
            };
            if (!this.$scope.manager.vnicData.bindToPnicPageModel.componentData) {
                var opaqueNetwork = this.$scope.manager.vnicData.bindToPnicPageModel.opaqueNetworkSpec;
                var pinnedPnic = this.$scope.manager.vnicData.bindToPnicPageModel.pinnedPnic;
                var pageModel_1 = {
                    hostId: this.$scope.manager.vnicData.hostId,
                    opaqueNetworkId: opaqueNetwork.opaqueNetworkId,
                    opaqueNetworkType: opaqueNetwork.opaqueNetworkType,
                    bindToPnicEnabled: pinnedPnic !== null,
                    selectedPnicForBinding: pinnedPnic,
                    availablePnicsData: null,
                    onPnicSelectionChange: function (selectedPnic) {
                        pageModel_1.selectedPnicForBinding = selectedPnic;
                    },
                    onBindToPnicChange: function (bindToPnic) {
                        pageModel_1.bindToPnicEnabled = bindToPnic;
                    },
                    onAvailablePnicsDataChange: function (availablePnicsData) {
                        pageModel_1.availablePnicsData = availablePnicsData;
                    },
                    onLoadingStateUpdate: function (loading) {
                        _this.$scope.dialogOptions.loading = loading;
                    }
                };
                this.$scope.manager.vnicData.bindToPnicPageModel.componentData = pageModel_1;
                if (this.$scope.manager.vnicData.bindToPnicPageModel
                    .componentData.selectedPnicForBinding !== null) {
                    this.$scope.dialogOptions.loading = true;
                    this.bindToPhysicalAdapterService.getDataByOpaqueNetworkSpec(this.$scope.manager.vnicData.hostId, opaqueNetwork.opaqueNetworkId, opaqueNetwork.opaqueNetworkType).then(function (data) {
                        _this.$scope.manager.vnicData.bindToPnicPageModel.componentData.availablePnicsData = data;
                    }).finally(function () {
                        _this.$scope.dialogOptions.loading = false;
                    });
                }
            }
            this.bindToPnicModel = this.$scope.manager.vnicData.bindToPnicPageModel.componentData;
        }
        EditBindToPhysicalAdapterController.$inject = [
            "$scope",
            "i18nService",
            "bindToPhysicalAdapterService",
            "vuiConstants"];
        return EditBindToPhysicalAdapterController;
    }());
    network_ui.EditBindToPhysicalAdapterController = EditBindToPhysicalAdapterController;
    angular.module('com.vmware.vsphere.client.network')
        .controller('EditBindToPhysicalAdapterController', EditBindToPhysicalAdapterController);
})(network_ui || (network_ui = {}));



(function() {
   'use strict';

   /**
    * Controller for the IPv4 settings page in Edit VMkernel adapter settings dialog.
    */

   angular
         .module('com.vmware.vsphere.client.network')
         .controller('EditVnicIpv4PageController', EditVnicIpv4PageController);

   EditVnicIpv4PageController.$inject = [
         '$scope',
         'ipv4SettingsPageValidator',
         'vuiConstants',
         'vnicConstants',
         'staticIpInputTypes',
         'i18nService'];

   function EditVnicIpv4PageController(scope, ipv4SettingsPageValidator, vuiConstants,
         vnicConstants, staticIpInputTypes, i18nService) {
      scope.manager.vnicData.ipv4PageModel.onCommit = onCommit;
      scope.manager.vnicData.ipv4PageModel.validateIpv4DefaultGateway = {};

      this.pageModel = scope.manager.vnicData.ipv4PageModel;

      this.pageModel.isGatewayFeatureSupported = this.pageModel.isGatewayFeatureSupported;

      if (this.pageModel.dnsServers && this.pageModel.dnsServers.length === 0) {
         this.pageModel.dnsServers =
               [i18nService.getString('NetworkUi', 'NetworkUtil.noData')];
      }

      scope.defaultGateway = (this.pageModel && this.pageModel.defaultGateway)
            ? this.pageModel.defaultGateway
            : i18nService.getString('NetworkUi', 'NetworkUtil.noData');

      this.ipv4PropertyType = staticIpInputTypes.IPV4.IP_ADDRESS;
      this.subnetMaskPropertyType = staticIpInputTypes.IPV4.SUBNET_MASK;
      this.defaultIpv4GatewayPropertyType = staticIpInputTypes.IPV4.DEFAULT_GATEWAY;
      this.defaultGatewayValidationMessage = i18nService.getString(
            'H5NetworkUi', 'AddNetworkingWizard.ipv4SettingsPage.invalidDefaultGatewayAddress');

      function onCommit() {
         scope.manager.vnicData.ipv4PageModel.dirty =
               scope.manager.vnicData.ipv4PageModel.dirty ||
               scope.nwEditVnicIpv4PageForm.$dirty;
         var staticIpAddress = scope.manager.vnicData.ipv4PageModel.ipSettingsOption ===
               vnicConstants.ipSettingsOption.staticIp;

         if (scope.manager.vnicData.ipv4PageModel.dirty && staticIpAddress) {
            // Invoke both input's inline validations
            scope.validateIpAddress();
            scope.validateSubnetMask();

            if (scope.manager.vnicData.ipv4PageModel.isGatewayFeatureSupported
                  && scope.manager.vnicData.ipv4PageModel.isGatewayOverriden) {
               scope.manager.vnicData.ipv4PageModel.validateIpv4DefaultGateway();
            }

            var dhcpEnabled = scope.manager.vnicData.ipv4PageModel.ipSettingsOption ===
                  vnicConstants.ipSettingsOption.dhcp;

            var validationData = {
               hostId: scope.manager.vnicData.hostId,
               dhcpEnabled: dhcpEnabled,
               ipv4Address: scope.manager.vnicData.ipv4PageModel.ipAddress,
               subnetMask: scope.manager.vnicData.ipv4PageModel.subnetMask,
               isGatewayFeatureSupported:
                     scope.manager.vnicData.ipv4PageModel.isGatewayFeatureSupported,
               overrideGateway: scope.manager.vnicData.ipv4PageModel.isGatewayOverriden,
               ipv4DefaultGateway: scope.manager.vnicData.ipv4PageModel.defaultGateway,
               vnicName: scope.manager.vnicData.vnicDevice
            };

            var result = ipv4SettingsPageValidator.getValidationErrors(validationData);

            if (result instanceof Array) {
               return buildValidationMessages(result);
            } else {
               return result.then(function(errorMessage) {
                  return buildValidationMessages(errorMessage);
               });
            }
         }

         return true;
      }

      //region private helpers
      function buildValidationMessages(messages) {
         return _.map(messages, function (message) {
            return {
               type: vuiConstants.validationBanner.type.ERROR,
               text: message
            };
         });
      }

      function isStaticIpEnabled() {
         return scope.manager.vnicData.ipv4PageModel.ipSettingsOption ===
               vnicConstants.ipSettingsOption.staticIp;
      }
      //endregion

      return this;
   }
})();
/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .controller('EditVnicIpv6PageController', EditVnicIpv6PageController);

   EditVnicIpv6PageController.$inject = [
         '$scope',
         'vuiConstants',
         'vnicConstants',
         'ipParserService',
         'i18nService',
         'staticIpInputTypes'];

   function EditVnicIpv6PageController(
         scope,
         vuiConstants,
         vnicConstants,
         ipParserService,
         i18nService,
         staticIpInputTypes) {

      this.defaultIpv6GatewayPropertyType = staticIpInputTypes.IPV6.DEFAULT_GATEWAY;

      this.pageModel = scope.manager.vnicData.ipv6PageModel;
      scope.defaultGateway = (this.pageModel && this.pageModel.defaultGateway)
            ? this.pageModel.defaultGateway
            : i18nService.getString('NetworkUi', 'NetworkUtil.noData');
      this.pageModel.isGatewayFeatureSupported =
            scope.manager.vnicData.ipv4PageModel
            && scope.manager.vnicData.ipv4PageModel.isGatewayFeatureSupported;
      this.listData = {};
      this.listData.defaultGateway = this.pageModel.defaultGateway;
      this.listData.hostIpv6Addresses = this.pageModel.hostIpAddresses;
      // Do not show ip addresses marked for removal in the grid
      this.listData.ipv6List = this.pageModel.staticIpv6Addresses
            ? getIpAddressesNotMarkedForRemoval(this.pageModel.staticIpv6Addresses)
            : [];

      this.onCommit = function () {
         var removed = diffIpv6Arrays(
               this.pageModel.staticIpv6Addresses, this.listData.ipv6List);
         var added = diffIpv6Arrays(
               this.listData.ipv6List, this.pageModel.staticIpv6Addresses);
         var untouched = intersectIpv6Arrays(
               this.pageModel.staticIpv6Addresses, this.listData.ipv6List);

         _.forEach(removed, function(ipAddress) {
            ipAddress.operation = vnicConstants.changeOperation.remove;
         });

         _.forEach(added, function(ipAddress) {
            ipAddress.operation = vnicConstants.changeOperation.add;
         });

         if (scope.manager.vnicData.ipv6PageModel.isGatewayFeatureSupported
               && scope.manager.vnicData.ipv6PageModel.isGatewayOverridden) {
            scope.manager.vnicData.ipv6PageModel.validateIpv6DefaultGateway();
         }

         scope.manager.vnicData.ipv6PageModel.dirty =
               !!scope.manager.vnicData.ipv6PageModel.dirty ||
               scope.nwEditVnicIpv6PageForm.$dirty ||
               added.length > 0 ||
               removed.length > 0;

         this.pageModel.staticIpv6Addresses = untouched.concat(added, removed);

         return getValidationMessages(this.listData.ipv6List);
      };

      scope.manager.vnicData.ipv6PageModel.onCommit = this.onCommit.bind(this);

      /**
       * Returns a deep copy of all IP addresses that were not marked for removal.
       * I.e. ip.operation is not set to `remove` in a previous visit of the page.
       */
      function getIpAddressesNotMarkedForRemoval(addresses) {
         return $.extend(
               true,
               [],
               _.filter(addresses, function (address) {
                  return address.operation !== vnicConstants.changeOperation.remove;
               }));
      }

      /**
       * Returns IP addresses that exist in both `a` and `b` arrays.
       */
      function intersectIpv6Arrays(a, b) {
         var result = [];
         _.forEach(a, function (current) {
            if (containsIpv6Address(b, current)) {
               result.push(current);
            }
         });

         return result;
      }

      /**
       * Returns IP addresses that exist in `b` but not in `a`.
       */
      function diffIpv6Arrays(a, b) {
         var result = [];
         _.forEach(a, function (current) {
            if (!containsIpv6Address(b, current)) {
               result.push(current);
            }
         });

         return result;
      }

      /**
       * @param ips
       *    Array to be traversed.
       * @param ip
       *    Item to be looked for.
       * @returns {boolean}
       *    True if `ip` with the same address and prefixLength exists
       *    in the `ips` array.
       */
      function containsIpv6Address(ips, ip) {
         return _.some(ips, function(current) {
            return equalIpv6Addresses(current, ip);
         });
      }

      function equalIpv6Addresses(a, b) {
         return ipParserService.equalIpv6Addresses(a.address, b.address) &&
               a.prefixLength === b.prefixLength;
      }

      /**
       * @param ipv6List
       *    current representation of the ipv6 list items
       * @returns
       *    empty array if the data is correct
       *    array of errors used in the validationBanner
       */
      function getValidationMessages(ipv6List) {
         var validationErrors = [];
         if (scope.manager.vnicData.ipv6PageModel.staticIpEnabled) {
            if (_.isEmpty(ipv6List)) {
               validationErrors.push(i18nService.getString(
                     'NetworkUi', 'EditVnicView.noIpv6ManualAddressError'));
            }

            if (scope.manager.vnicData.ipv6PageModel.isGatewayOverridden) {
               // check if the configured default gateway is empty or invalid ipv6 address
               if (!ipParserService.isIpv6AddressValid(
                           scope.manager.vnicData.ipv6PageModel.defaultGateway)) {
                  validationErrors.push(i18nService.getString(
                        'NetworkUi', 'Ipv6GatewayDialog.defaultGateway.error'));
               }
               if (scope.manager.vnicData.ipv6PageModel.dhcpEnabled
                     || scope.manager.vnicData.ipv6PageModel.autoConfigEnabled) {
                  validationErrors.push(i18nService.getString('H5NetworkUi',
                        'VnicIpv6SettingsPage.invalidIpConfiguration'));
               }
            }
         }

         return validationErrors.length ? buildValidationMessages(validationErrors) : [];
      }

      /**
       * @param messages
       *    localized strings returned from the validator
       * @returns {TResult[]}
       *    converted array of messages in the form used by validationBanner
       */
      function buildValidationMessages(messages) {
         return _.map(messages, function (message) {
            return {
               type: vuiConstants.validationBanner.type.ERROR,
               text: message
            };
         });
      }

      return this;
   }
})();
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.network')
         .controller(
               'EditVnicPortPropertiesPageController',
               EditVnicPortPropertiesPageController);

   EditVnicPortPropertiesPageController.$inject = [
         '$scope',
         'networkUtil',
         'i18nService',
         'vuiConstants'];

   function EditVnicPortPropertiesPageController(
         $scope,
         networkUtil,
         i18nService,
         vuiConstants) {

      var self = this;
      var MTU_ERROR = i18nService.getString(
            'NetworkUi',
            'AddNetworkingWizard.conPropPage.mtu.inputErrorMessage');

      $scope.manager.vnicData.portPropertiesPageModel.onCommit = onCommit;

      self.pageModel = $scope.manager.vnicData.portPropertiesPageModel;
      self.isTcpIpStackSupported = self.pageModel.hostVnicFeatures.isTcpIpStackSupported;
      self.errorTooltip = {
         message: MTU_ERROR,
         isVisible: !networkUtil.isMtuValid(self.pageModel.mtuInBytes)
      };

      self.validateMtu = validateMtu;

      function validateMtu() {
         self.errorTooltip.isVisible =
               !networkUtil.isMtuValid(self.pageModel.mtuInBytes);
      }

      function onCommit() {
         var isMtuDirty = $scope.nwEditVnicPortPropertiesPageForm.mtu.$dirty;
         $scope.manager.vnicData.portPropertiesPageModel.dirty =
               !!$scope.manager.vnicData.portPropertiesPageModel.dirty || isMtuDirty;

         if (isMtuDirty && !networkUtil.isMtuValid(self.pageModel.mtuInBytes)) {
            return [{
               type: vuiConstants.validationBanner.type.ERROR,
               text: MTU_ERROR
            }];
         }

         return [];
      }

      return self;
   }
})();
(function() {
   'use strict';

   /**
    * Vnic related constants.
    */
   angular
         .module('com.vmware.vsphere.client.network')
         .constant('vnicConstants', {

            /**
             * Map <hostVnicServiceConstants.keys, VirtualNicManager.NicType>.
             *
             * @see hostVnicServiceConstants.keys
             */
            serviceKeyToNicTypeMap: {
               isVmotionEnabled: 'vmotion',
               isProvisioningNfcTrafficEnabled: 'vSphereProvisioning',
               isFtEnabled: 'faultToleranceLogging',
               isHaEnabled: 'management',
               isVRTrafficEnabled: 'vSphereReplication',
               isVrNfcTrafficEnabled: 'vSphereReplicationNFC',
               isVsanEnabled: 'vsan'
            },
            /**
             * Values of the IPv4 options shown on Edit vnic setting dialog.
             *
             * @see com.vmware.vsphere.client.h5.network.host.vnic.model.edit.IpSettingsOption
             */
            ipSettingsOption: {
               unset: 'unset',
               dhcp: 'dhcp',
               staticIp: 'staticIp'
            },
            /**
             * Values used in vnic ipv6 edit operations.
             */
            changeOperation: {
               add: 'add',
               remove: 'remove'
            }
         });
})();

var network_ui;
(function (network_ui) {
    var PropertiesPageModel = (function () {
        function PropertiesPageModel() {
            this.dirty = false;
        }
        return PropertiesPageModel;
    }());
    network_ui.PropertiesPageModel = PropertiesPageModel;
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var SecurityPageModel = (function () {
        function SecurityPageModel() {
            this.dirty = false;
        }
        return SecurityPageModel;
    }());
    network_ui.SecurityPageModel = SecurityPageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var TeamingAndFailoverPageModel = (function () {
        function TeamingAndFailoverPageModel() {
            this.dirty = false;
        }
        TeamingAndFailoverPageModel.prototype.setPnics = function (pnics) {
            if (pnics) {
                this.pnics = new Object();
                this.pnics.active = pnics.active;
                this.pnics.standby = pnics.standby;
                this.pnics.unused = pnics.unused;
            }
        };
        return TeamingAndFailoverPageModel;
    }());
    network_ui.TeamingAndFailoverPageModel = TeamingAndFailoverPageModel;
})(network_ui || (network_ui = {}));



var network_ui;
(function (network_ui) {
    var TrafficShapingPageModel = (function () {
        function TrafficShapingPageModel() {
            this.dirty = false;
        }
        return TrafficShapingPageModel;
    }());
    network_ui.TrafficShapingPageModel = TrafficShapingPageModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchDialogManager = (function () {
        function EditVirtualSwitchDialogManager(dialogScope, i18nService, mutationService, editVirtualSwitchDialogValidator, portFailoverPolicyPageService, editPortgroupService) {
            this.dialogScope = dialogScope;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.editVirtualSwitchDialogValidator = editVirtualSwitchDialogValidator;
            this.portFailoverPolicyPageService = portFailoverPolicyPageService;
            this.editPortgroupService = editPortgroupService;
            this.propertiesPageModel = dialogScope.propertiesPageModel;
            this.securityPageModel = dialogScope.securityPageModel;
            this.trafficShapingPageModel = dialogScope.trafficShapingPageModel;
            this.teamingAndFailoverPageModel = dialogScope.teamingAndFailoverPageModel;
        }
        EditVirtualSwitchDialogManager.prototype.getPageDefinitions = function () {
            this.initDialogPages();
            var pages = [
                this.propertiesPage,
                this.securityPage,
                this.trafficShapingPage,
                this.teamingAndFailoverPage];
            return pages;
        };
        EditVirtualSwitchDialogManager.prototype.submit = function () {
            // Perform mutation only if some page state has been changed
            if (this.propertiesPageModel.dirty ||
                this.securityPageModel.dirty ||
                this.trafficShapingPageModel.dirty ||
                this.teamingAndFailoverPageModel.dirty) {
                this.mutationService.apply(this.dialogScope.hostId, EditVirtualSwitchDialogManager.EDIT_STANDARD_SWITCH_DIALOG_SPEC, this.buildSpec());
            }
            return true;
        };
        EditVirtualSwitchDialogManager.prototype.buildSpec = function () {
            var editVirtualSwitchSpec = {
                propertiesData: {
                    name: this.propertiesPageModel.name,
                    mtu: this.propertiesPageModel.mtu,
                    numberOfPorts: this.propertiesPageModel.numPorts,
                    availableNumberOfPorts: this.propertiesPageModel.availableNumPorts,
                    showRestartWarning: this.propertiesPageModel.showRestartWarning
                },
                securityPolicies: {
                    allowPromiscuousMode: this.securityPageModel.allowPromiscuousMode,
                    macChanges: this.securityPageModel.macChanges,
                    forgedTransmits: this.securityPageModel.forgedTransmits
                },
                trafficShapingPolicies: {
                    enabled: this.trafficShapingPageModel.enabled,
                    averageBandwidth: null,
                    peakBandwidth: null,
                    burstSize: null
                },
                teamingAndFailover: {
                    loadBalancing: this.teamingAndFailoverPageModel.loadBalancing,
                    checkBeacon: this.teamingAndFailoverPageModel.checkBeacon,
                    notifySwitches: this.teamingAndFailoverPageModel.notifySwitches,
                    rollingOrder: this.teamingAndFailoverPageModel.rollingOrder,
                    pnics: this.teamingAndFailoverPageModel.pnics
                }
            };
            if (this.trafficShapingPageModel.enabled) {
                editVirtualSwitchSpec.trafficShapingPolicies.averageBandwidth =
                    this.trafficShapingPageModel.averageBandwidth;
                editVirtualSwitchSpec.trafficShapingPolicies.peakBandwidth =
                    this.trafficShapingPageModel.peakBandwidth;
                editVirtualSwitchSpec.trafficShapingPolicies.burstSize =
                    this.trafficShapingPageModel.burstSize;
            }
            return editVirtualSwitchSpec;
        };
        EditVirtualSwitchDialogManager.prototype.initDialogPages = function () {
            var _this = this;
            this.propertiesPage = {
                title: this.i18nService.getString("NetworkUi", "VSwitchPropertiesView.title"),
                contentUrl: "network-ui/resources/network/views/host/vswitch/edit/" +
                    "views/editVirtualSwitchPropertiesPage.html",
                onCommit: function () {
                    _this.propertiesPageModel.dirty = _this.editPortgroupService
                        .haveVirtualSwitchPropertiesChanged(_this.propertiesPageModel.initialState, _this.propertiesPageModel);
                    if (_this.propertiesPageModel.dirty) {
                        var numPortsError = _this.editVirtualSwitchDialogValidator
                            .getNumPortsError(_this.dialogScope);
                        var mtuError = _this.editVirtualSwitchDialogValidator
                            .getMtuError(_this.dialogScope);
                        return numPortsError.concat(mtuError);
                    }
                    return [];
                }
            };
            this.securityPage = {
                title: this.i18nService.getString("NetworkUi", "PortSecurityPolicyView.title"),
                contentUrl: "network-ui/resources/network/views/host/vswitch/edit/" +
                    "views/editVirtualSwitchSecurityPage.html",
                onCommit: function () {
                    _this.securityPageModel.dirty = _this.editPortgroupService
                        .hasSecurityPolicyChanged(_this.securityPageModel.initialState, _this.securityPageModel, false);
                    return [];
                }
            };
            this.trafficShapingPage = {
                title: this.i18nService.getString("NetworkUi", "PortTrafficShapingPolicyView.title"),
                contentUrl: "network-ui/resources/network/views/host/vswitch/edit/" +
                    "views/editVirtualSwitchTrafficShapingPage.html",
                onCommit: function () {
                    _this.trafficShapingPageModel.dirty = _this.editPortgroupService
                        .hasTrafficShapingPolicyChanged(_this.trafficShapingPageModel.initialState, _this.trafficShapingPageModel, false);
                    if (_this.trafficShapingPageModel.dirty) {
                        return _this.editVirtualSwitchDialogValidator
                            .getTrafficShapingInputsError(_this.dialogScope);
                    }
                    return [];
                }
            };
            this.teamingAndFailoverPage = {
                title: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.title"),
                contentUrl: "network-ui/resources/network/views/host/vswitch/edit/" +
                    "views/editVirtualSwitchTeamingAndFailoverPage.html",
                onCommit: function () {
                    _this.teamingAndFailoverPageModel.dirty =
                        _this.editPortgroupService
                            .hasFailoverPolicyChanged(_this.teamingAndFailoverPageModel.initialState, _this.teamingAndFailoverPageModel, false) ||
                            _this.editPortgroupService
                                .hasFailoverOrderChanged(_this.teamingAndFailoverPageModel.initialState, _this.teamingAndFailoverPageModel, false);
                    if (_this.teamingAndFailoverPageModel.dirty) {
                        var errors = _this.editVirtualSwitchDialogValidator
                            .getTeamingAndFailureInputsError(_this.dialogScope.teamingAndFailoverPageModel);
                        var warnings = _this.editVirtualSwitchDialogValidator
                            .getTeamingAndFailoverWarnings(_this.dialogScope.teamingAndFailoverPageModel);
                        if (errors.length > 0) {
                            return errors;
                        }
                        else if (warnings.length > 0) {
                            return _this.portFailoverPolicyPageService.confirmWarningModal(warnings);
                        }
                    }
                    return true;
                }
            };
        };
        EditVirtualSwitchDialogManager.EDIT_STANDARD_SWITCH_DIALOG_SPEC = "com.vmware.vsphere.client.h5.network.host.virtualswitch.model.EditStandardSwitchDialogData";
        return EditVirtualSwitchDialogManager;
    }());
    network_ui.EditVirtualSwitchDialogManager = EditVirtualSwitchDialogManager;
    angular.module("com.vmware.vsphere.client.network")
        .service("editVirtualSwitchDialogManager", EditVirtualSwitchDialogManager);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchDialogManager = network_ui.EditVirtualSwitchDialogManager;
    var EditVirtualSwitchDialogManagerFactory = (function () {
        function EditVirtualSwitchDialogManagerFactory(i18nService, mutationService, editVirtualSwitchDialogValidator, portFailoverPolicyPageService, editPortgroupService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.editVirtualSwitchDialogValidator = editVirtualSwitchDialogValidator;
            this.portFailoverPolicyPageService = portFailoverPolicyPageService;
            this.editPortgroupService = editPortgroupService;
        }
        EditVirtualSwitchDialogManagerFactory.prototype.createManager = function (dialogScope) {
            return new EditVirtualSwitchDialogManager(dialogScope, this.i18nService, this.mutationService, this.editVirtualSwitchDialogValidator, this.portFailoverPolicyPageService, this.editPortgroupService);
        };
        EditVirtualSwitchDialogManagerFactory.$inject = [
            "i18nService",
            "mutationService",
            "editVirtualSwitchDialogValidator",
            "portFailoverPolicyPageService",
            "editPortgroupService"];
        return EditVirtualSwitchDialogManagerFactory;
    }());
    network_ui.EditVirtualSwitchDialogManagerFactory = EditVirtualSwitchDialogManagerFactory;
    angular.module("com.vmware.vsphere.client.network")
        .service("editVirtualSwitchDialogManagerFactory", EditVirtualSwitchDialogManagerFactory);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var PropertiesPageModel = network_ui.PropertiesPageModel;
    var SecurityPageModel = network_ui.SecurityPageModel;
    var TrafficShapingPageModel = network_ui.TrafficShapingPageModel;
    var TeamingAndFailoverPageModel = network_ui.TeamingAndFailoverPageModel;
    var EditVirtualSwitchDialogService = (function () {
        function EditVirtualSwitchDialogService($rootScope, i18nService, dataService, editVirtualSwitchDialogManagerFactory, vxMultiPageDialogService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.editVirtualSwitchDialogManagerFactory = editVirtualSwitchDialogManagerFactory;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.vSwitchProp = "virtualswitch:editDialogData";
            this.i18n = i18nService;
        }
        EditVirtualSwitchDialogService.prototype.show = function (hostId, selectedSwitch) {
            var _this = this;
            var dialogScope = this.$rootScope.$new();
            var dialogManager;
            dialogScope.dialogOptions = {};
            dialogScope.propertiesPageModel = new PropertiesPageModel();
            dialogScope.securityPageModel = new SecurityPageModel();
            dialogScope.trafficShapingPageModel = new TrafficShapingPageModel();
            dialogScope.teamingAndFailoverPageModel = new TeamingAndFailoverPageModel();
            dialogScope.dialogOptions.confirmOptions = {
                onClick: function () {
                    return dialogManager.submit();
                }
            };
            dialogManager = this.editVirtualSwitchDialogManagerFactory.createManager(dialogScope);
            _.extend(dialogScope.dialogOptions, {
                title: this.i18n.getString("NetworkUi", "EditVSwitchSettingsView.title", selectedSwitch.name),
                pages: dialogManager.getPageDefinitions(),
                show: true,
                loading: true,
                loadingMessage: this.i18n.getString("CommonUi", "wizard.loading"),
                validationBanner: {},
                rejectOptions: {
                    rejectOnEsc: true
                },
                resizable: true,
                draggable: true,
                maximizable: true,
                height: "676px",
                width: "1000px"
            });
            var options = {
                scope: dialogScope,
                configObjectName: "dialogOptions"
            };
            this.vxMultiPageDialogService(options);
            this.getVirtualSwitchDialogDataPromise(hostId, selectedSwitch.key).then(function (result) {
                dialogScope.hostId = hostId;
                _this.buildGeneralPageModel(result[_this.vSwitchProp], dialogScope);
                dialogScope.dialogOptions.loading = false;
            });
        };
        EditVirtualSwitchDialogService.prototype.buildGeneralPageModel = function (data, dialogScope) {
            if (!data) {
                return;
            }
            // Properties page model
            if (data.propertiesData) {
                dialogScope.propertiesPageModel.name = data.propertiesData.name;
                dialogScope.propertiesPageModel.mtu = data.propertiesData.mtu;
                dialogScope.propertiesPageModel.numPorts = data.propertiesData.numberOfPorts;
                dialogScope.propertiesPageModel.availableNumPorts =
                    data.propertiesData.availableNumberOfPorts + data.propertiesData.numberOfPorts;
                dialogScope.propertiesPageModel.showRestartWarning =
                    data.propertiesData.showRestartWarning;
                dialogScope.propertiesPageModel.initialState =
                    angular.copy(dialogScope.propertiesPageModel);
            }
            // Security page model
            if (data.securityPolicies) {
                dialogScope.securityPageModel.allowPromiscuousMode =
                    data.securityPolicies.allowPromiscuousMode;
                dialogScope.securityPageModel.forgedTransmits =
                    data.securityPolicies.forgedTransmits;
                dialogScope.securityPageModel.macChanges =
                    data.securityPolicies.macChanges;
                dialogScope.securityPageModel.initialState =
                    angular.copy(dialogScope.securityPageModel);
            }
            // Traffic Shaping page model
            if (data.trafficShapingPolicies) {
                dialogScope.trafficShapingPageModel.enabled =
                    data.trafficShapingPolicies.enabled;
                dialogScope.trafficShapingPageModel.averageBandwidth =
                    data.trafficShapingPolicies.averageBandwidth;
                dialogScope.trafficShapingPageModel.peakBandwidth =
                    data.trafficShapingPolicies.peakBandwidth;
                dialogScope.trafficShapingPageModel.burstSize =
                    data.trafficShapingPolicies.burstSize;
                dialogScope.trafficShapingPageModel.initialState =
                    angular.copy(dialogScope.trafficShapingPageModel);
            }
            // Teaming and Failover page model
            if (data.teamingAndFailover) {
                dialogScope.teamingAndFailoverPageModel.loadBalancing =
                    data.teamingAndFailover.loadBalancing;
                dialogScope.teamingAndFailoverPageModel.nicTeamingPolicy =
                    data.teamingAndFailover.nicTeamingPolicy;
                dialogScope.teamingAndFailoverPageModel.checkBeacon =
                    data.teamingAndFailover.checkBeacon;
                dialogScope.teamingAndFailoverPageModel.notifySwitches =
                    data.teamingAndFailover.notifySwitches;
                dialogScope.teamingAndFailoverPageModel.rollingOrder =
                    data.teamingAndFailover.rollingOrder;
                dialogScope.teamingAndFailoverPageModel.setPnics(data.teamingAndFailover.pnics);
                dialogScope.teamingAndFailoverPageModel.pnicDetails =
                    data.teamingAndFailover.pnics ?
                        data.teamingAndFailover.pnics.pnicDetails : null;
                dialogScope.teamingAndFailoverPageModel.initialState =
                    angular.copy(dialogScope.teamingAndFailoverPageModel);
            }
        };
        EditVirtualSwitchDialogService.prototype.getVirtualSwitchDialogDataPromise = function (hostId, selectedSwitchKey) {
            var switchIdSpec = {
                _type: "com.vmware.vsphere.client.h5.network.host.virtualswitch.spec.VirtualSwitchIdSpec",
                key: selectedSwitchKey
            };
            var params = {
                propertyParams: [{
                        propertyName: this.vSwitchProp,
                        parameterType: switchIdSpec._type,
                        parameter: switchIdSpec
                    }]
            };
            return this.dataService.getProperties(hostId, [this.vSwitchProp], params);
        };
        EditVirtualSwitchDialogService.$inject = [
            "$rootScope",
            "i18nService",
            "dataService",
            "editVirtualSwitchDialogManagerFactory",
            "vxMultiPageDialogService"];
        return EditVirtualSwitchDialogService;
    }());
    network_ui.EditVirtualSwitchDialogService = EditVirtualSwitchDialogService;
    angular.module("com.vmware.vsphere.client.network")
        .service("editVirtualSwitchDialogService", EditVirtualSwitchDialogService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchDialogValidator = (function () {
        function EditVirtualSwitchDialogValidator(i18nService, networkUiConstants, networkUtil, vuiConstants, portFailoverPolicyPageService, trafficShapingPolicyValidator) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.networkUtil = networkUtil;
            this.vuiConstants = vuiConstants;
            this.portFailoverPolicyPageService = portFailoverPolicyPageService;
            this.trafficShapingPolicyValidator = trafficShapingPolicyValidator;
        }
        EditVirtualSwitchDialogValidator.prototype.getNumPortsError = function (dialogScope) {
            var errors = [];
            if (dialogScope &&
                dialogScope.propertiesPageModel &&
                dialogScope.propertiesPageModel.numPorts &&
                typeof dialogScope.propertiesPageModel.availableNumPorts === "number" &&
                dialogScope.propertiesPageModel.numPorts >
                    dialogScope.propertiesPageModel.availableNumPorts) {
                errors.push(this.createError(this.i18nService.getString("NetworkUi", "VSwitchPropertiesView.availablePortsExceeded", dialogScope.propertiesPageModel.availableNumPorts)));
            }
            return errors;
        };
        EditVirtualSwitchDialogValidator.prototype.getMtuError = function (dialogScope) {
            var errors = [];
            if (dialogScope &&
                dialogScope.propertiesPageModel &&
                !this.networkUtil.isMtuValid(dialogScope.propertiesPageModel.mtu)) {
                errors.push(this.createError(this.i18nService.getString("H5NetworkUi", "VSwitchPropertiesPage.mtu.errorMessage", this.networkUiConstants.Mtu.MIN, this.networkUiConstants.Mtu.MAX)));
            }
            return errors;
        };
        EditVirtualSwitchDialogValidator.prototype.getTrafficShapingInputsError = function (dialogScope) {
            var _this = this;
            var errors = [];
            var trafficShapingPolicies = ["averageBandwidth", "peakBandwidth",
                "burstSize"];
            if (dialogScope &&
                dialogScope.trafficShapingPageModel &&
                dialogScope.trafficShapingPageModel.enabled) {
                // In order not to overpopulate the method with many "IFs" we loop through
                // the trafficShapingPolicies to append the correct validation messages.
                _.forEach(trafficShapingPolicies, function (policy) {
                    var value = dialogScope.trafficShapingPageModel[policy];
                    var message = _this.trafficShapingPolicyValidator.getTrafficShapingErrorMessage(value, policy);
                    if (message !== null) {
                        errors.push(_this.createError(message));
                    }
                });
                if (errors.length === 0 &&
                    dialogScope.trafficShapingPageModel.averageBandwidth >
                        dialogScope.trafficShapingPageModel.peakBandwidth) {
                    errors.push(this.createError(this.i18nService.getString("NetworkUi", "PortPolicyData.shaping.error.avgBwGreaterThanPeakBw")));
                }
            }
            return errors;
        };
        EditVirtualSwitchDialogValidator.prototype.getTeamingAndFailureInputsError = function (teamingAndFailoverPageModel) {
            var errors = [];
            if (teamingAndFailoverPageModel &&
                !this.isFailureDetectionValid(teamingAndFailoverPageModel.checkBeacon, teamingAndFailoverPageModel.pnics)) {
                errors.push(this.createError(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.error.beaconProbingSingleNic")));
            }
            return errors;
        };
        EditVirtualSwitchDialogValidator.prototype.getIpHashWarnings = function (teamingAndFailoverPageModel) {
            var warnings = [];
            var hasStandbyNics = false;
            if (!teamingAndFailoverPageModel) {
                throw new Error("Invalid parameter");
            }
            //Provider returns null when there are no pnics
            if (teamingAndFailoverPageModel.pnics) {
                hasStandbyNics =
                    this.getNicLength(teamingAndFailoverPageModel.pnics.standby) > 0;
            }
            var isIpHashPolicy = teamingAndFailoverPageModel.loadBalancing ===
                this.networkUiConstants.LoadBalancingPolicy.IP;
            if (isIpHashPolicy &&
                hasStandbyNics &&
                teamingAndFailoverPageModel.checkBeacon) {
                warnings.push(this.createWarning(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbingAndStandbyUplinks")));
            }
            else if (isIpHashPolicy &&
                hasStandbyNics) {
                warnings.push(this.createWarning(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.lb.loadbalance_ip.warn.standbyUplinks")));
            }
            else if (isIpHashPolicy &&
                teamingAndFailoverPageModel.checkBeacon) {
                warnings.push(this.createWarning(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbing")));
            }
            return warnings;
        };
        EditVirtualSwitchDialogValidator.prototype.getTeamingAndFailoverWarnings = function (teamingAndFailoverPageModel) {
            var warnings = this.getIpHashWarnings(teamingAndFailoverPageModel);
            var hasActiveNics = false;
            if (!teamingAndFailoverPageModel) {
                throw "Invalid parameter.";
            }
            //Provider returns null when there are no pnics
            if (teamingAndFailoverPageModel.pnics) {
                hasActiveNics =
                    this.getNicLength(teamingAndFailoverPageModel.pnics.active) > 0;
            }
            if (!hasActiveNics) {
                warnings.push(this.createWarning(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.error.noActiveAdapters")));
            }
            return warnings;
        };
        EditVirtualSwitchDialogValidator.prototype.isFailureDetectionValid = function (failureDetection, pnics) {
            var assignedPnics = 0;
            if (pnics) {
                assignedPnics = this.getNicLength(pnics.active) +
                    this.getNicLength(pnics.standby) +
                    this.getNicLength(pnics.unused);
            }
            return !(failureDetection && assignedPnics < 2);
        };
        EditVirtualSwitchDialogValidator.prototype.getLoadBalancingInfoMessages = function () {
            return [
                this.createInfo(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.lb.loadbalance_ip.info.etherChannel")),
                this.createInfo(this.i18nService.getString("NetworkUi", "PortPolicyData.failover.lb.loadbalance_ip.info.portGroupPolicies"))
            ];
        };
        EditVirtualSwitchDialogValidator.prototype.getNicLength = function (nics) {
            var nicsLength = 0;
            if (nics) {
                nicsLength = nics.length;
            }
            return nicsLength;
        };
        EditVirtualSwitchDialogValidator.prototype.createError = function (errorText) {
            return {
                type: this.vuiConstants.validationBanner.type.ERROR,
                text: errorText
            };
        };
        EditVirtualSwitchDialogValidator.prototype.createWarning = function (warningText) {
            return {
                iconClass: "vsphere-icon-status-warning",
                text: warningText
            };
        };
        EditVirtualSwitchDialogValidator.prototype.createInfo = function (infoMessage) {
            return {
                iconClass: "vsphere-icon-info",
                text: infoMessage
            };
        };
        EditVirtualSwitchDialogValidator.$inject = [
            "i18nService",
            "networkUiConstants",
            "networkUtil",
            "vuiConstants",
            "portFailoverPolicyPageService",
            "trafficShapingPolicyValidator"
        ];
        return EditVirtualSwitchDialogValidator;
    }());
    network_ui.EditVirtualSwitchDialogValidator = EditVirtualSwitchDialogValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("editVirtualSwitchDialogValidator", EditVirtualSwitchDialogValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchPropertiesPageComponent = (function () {
        function EditVirtualSwitchPropertiesPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.controller = EditVirtualSwitchPropertiesPageComponentController;
            this.templateUrl = "network-ui/resources/network/views/host/vswitch/edit/" +
                "views/editVirtualSwitchPropertiesPageComponent.html";
        }
        return EditVirtualSwitchPropertiesPageComponent;
    }());
    network_ui.EditVirtualSwitchPropertiesPageComponent = EditVirtualSwitchPropertiesPageComponent;
    var EditVirtualSwitchPropertiesPageComponentController = (function () {
        function EditVirtualSwitchPropertiesPageComponentController(i18nService, $scope, networkUiConstants, networkUtil) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.networkUiConstants = networkUiConstants;
            this.networkUtil = networkUtil;
            this.pageModel.portNumbers = this.getPortNumbers();
            this.mtuValidator = {
                message: i18nService.getString("H5NetworkUi", "VSwitchPropertiesPage.mtu.errorMessage", this.networkUiConstants.Mtu.MIN, this.networkUiConstants.Mtu.MAX),
                isVisible: false
            };
        }
        EditVirtualSwitchPropertiesPageComponentController.prototype.getPortNumbers = function () {
            var portNumbers = [this.networkUiConstants.NumPorts.MIN];
            while (_.last(portNumbers) < this.networkUiConstants.NumPorts.MAX) {
                portNumbers.push(_.last(portNumbers) * 2);
            }
            return portNumbers;
        };
        EditVirtualSwitchPropertiesPageComponentController.prototype.validateMtu = function () {
            this.mtuValidator.isVisible = !this.networkUtil.isMtuValid(this.pageModel.mtu);
        };
        EditVirtualSwitchPropertiesPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "networkUiConstants",
            "networkUtil"
        ];
        return EditVirtualSwitchPropertiesPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editVirtualSwitchPropertiesPage", new EditVirtualSwitchPropertiesPageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchSecurityPageComponent = (function () {
        function EditVirtualSwitchSecurityPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.templateUrl = "network-ui/resources/network/views/host/vswitch/edit/" +
                "views/editVirtualSwitchSecurityPageComponent.html";
            this.controller = EditVirtualSwitchSecurityPageComponentController;
        }
        return EditVirtualSwitchSecurityPageComponent;
    }());
    network_ui.EditVirtualSwitchSecurityPageComponent = EditVirtualSwitchSecurityPageComponent;
    var EditVirtualSwitchSecurityPageComponentController = (function () {
        function EditVirtualSwitchSecurityPageComponentController(i18nService, $scope) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.options = this.getOptions();
        }
        EditVirtualSwitchSecurityPageComponentController.prototype.getOptions = function () {
            var options = [{
                    label: this.i18nService.getString("NetworkUi", "PortSecurityPolicyPage.accept"),
                    val: true
                }, {
                    label: this.i18nService.getString("NetworkUi", "PortSecurityPolicyPage.reject"),
                    val: false
                }];
            return options;
        };
        EditVirtualSwitchSecurityPageComponentController.$inject = [
            "i18nService",
            "$scope"
        ];
        return EditVirtualSwitchSecurityPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editVirtualSwitchSecurityPage", new EditVirtualSwitchSecurityPageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchTeamingAndFailoverPageComponent = (function () {
        function EditVirtualSwitchTeamingAndFailoverPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.templateUrl = "network-ui/resources/network/views/host/vswitch/edit/" +
                "views/editVirtualSwitchTeamingAndFailoverPageComponent.html";
            this.controller = EditVirtualSwitchTeamingAndFailoverPageComponentController;
        }
        return EditVirtualSwitchTeamingAndFailoverPageComponent;
    }());
    network_ui.EditVirtualSwitchTeamingAndFailoverPageComponent = EditVirtualSwitchTeamingAndFailoverPageComponent;
    var EditVirtualSwitchTeamingAndFailoverPageComponentController = (function () {
        function EditVirtualSwitchTeamingAndFailoverPageComponentController($scope, networkUtil, i18nService, networkUiConstants, editVirtualSwitchDialogValidator, portFailoverPolicyPageService) {
            this.$scope = $scope;
            this.networkUtil = networkUtil;
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.editVirtualSwitchDialogValidator = editVirtualSwitchDialogValidator;
            this.portFailoverPolicyPageService = portFailoverPolicyPageService;
            this.loadBalancingOptions = networkUtil.createNicTeamingPolicyOptions(this.pageModel.nicTeamingPolicy);
            this.validators = this.getValidators();
            this.failureDetectionOptions = this.getFailureDetectionOptions();
            this.notifySwitchesOptions = this.getNotifySwitchesOptions();
            this.rollingOrderOptions = this.getRollingOrderOptions();
            this.failoverOrder = {
                connectees: this.pageModel.pnics,
                connecteesDetails: this.pageModel.pnicDetails,
                labels: {
                    active: networkUtil.getString("FailoverOrderEditor.active"),
                    standby: networkUtil.getString("FailoverOrderEditor.standby"),
                    unused: networkUtil.getString("FailoverOrderEditor.unused")
                }
            };
            this.datagridHeaderOptions = {
                title: networkUtil.getString("PortFailoverPolicyPage.orderLabel")
            };
            this.noItemsSelectedMessage = networkUtil.getString("FailoverOrderEditor.detailsPrompt");
            this.failoverOrderActions = [
                this.networkUiConstants.failoverOrderActions.MOVE_UP,
                this.networkUiConstants.failoverOrderActions.MOVE_DOWN
            ];
            this.signPostConfig = {
                message: null,
                title: networkUtil.getString("PortFailoverPolicyPage.lb.loadbalance_ip.popup.title"),
                class: "edit-standard-vswitch-signpost"
            };
            this.initWatch();
        }
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.initWatch = function () {
            var _this = this;
            this.$scope.$watchCollection(function () {
                var objectsToWatch = [
                    _this.pageModel.checkBeacon,
                    _this.pageModel.loadBalancing
                ];
                if (_this.pageModel.pnics) {
                    objectsToWatch.push(_this.pageModel.pnics.active.length);
                    objectsToWatch.push(_this.pageModel.pnics.standby.length);
                    objectsToWatch.push(_this.pageModel.pnics.unused.length);
                }
                return objectsToWatch;
            }, function () {
                _this.updateSignPostConfig();
            });
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.updateSignPostConfig = function () {
            var messsage = [];
            if (this.pageModel.loadBalancing ===
                this.networkUiConstants.LoadBalancingPolicy.IP) {
                var warnings = this.editVirtualSwitchDialogValidator.getIpHashWarnings(this.pageModel);
                var infos = this.editVirtualSwitchDialogValidator.getLoadBalancingInfoMessages();
                messsage = messsage.concat(warnings);
                messsage = messsage.concat(infos);
                this.signPostIcon = warnings.length > 0 ? "exclamation-triangle" : "info-circle";
            }
            this.signPostConfig.message =
                this.portFailoverPolicyPageService.formatMessages(messsage);
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.onFailureDetectionChange = function () {
            this.validators.failureDetection.isVisible = !this.editVirtualSwitchDialogValidator
                .isFailureDetectionValid(this.pageModel.checkBeacon, this.pageModel.pnics);
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.getValidators = function () {
            var validators = new Object();
            validators.failureDetection = {
                message: this.i18nService.getString("NetworkUi", "PortPolicyData.failover.error.beaconProbingSingleNic"),
                isVisible: false
            };
            return validators;
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.getFailureDetectionOptions = function () {
            return [{
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.linkStatus"),
                    val: false
                }, {
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.beaconProbing"),
                    val: true
                }];
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.getNotifySwitchesOptions = function () {
            return [{
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.notifyOff"),
                    val: false
                }, {
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.notifyOn"),
                    val: true
                }];
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.prototype.getRollingOrderOptions = function () {
            return [{
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.failbackOff"),
                    val: true
                }, {
                    label: this.i18nService.getString("NetworkUi", "PortFailoverPolicyView.failbackOn"),
                    val: false
                }];
        };
        EditVirtualSwitchTeamingAndFailoverPageComponentController.$inject = [
            "$scope",
            "networkUtil",
            "i18nService",
            "networkUiConstants",
            "editVirtualSwitchDialogValidator",
            "portFailoverPolicyPageService"
        ];
        return EditVirtualSwitchTeamingAndFailoverPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editVirtualSwitchTeamingAndFailoverPage", new EditVirtualSwitchTeamingAndFailoverPageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var EditVirtualSwitchTrafficShapingPageComponent = (function () {
        function EditVirtualSwitchTrafficShapingPageComponent() {
            this.bindings = {
                pageModel: "<"
            };
            this.templateUrl = "network-ui/resources/network/views/host/vswitch/edit/" +
                "views/editVirtualSwitchTrafficShapingPageComponent.html";
            this.controller = EditVirtualSwitchTrafficShapingPageComponentController;
        }
        return EditVirtualSwitchTrafficShapingPageComponent;
    }());
    network_ui.EditVirtualSwitchTrafficShapingPageComponent = EditVirtualSwitchTrafficShapingPageComponent;
    var EditVirtualSwitchTrafficShapingPageComponentController = (function () {
        function EditVirtualSwitchTrafficShapingPageComponentController(i18nService, $scope, trafficShapingPolicyValidator, networkUtil, networkUiConstants) {
            this.i18nService = i18nService;
            this.$scope = $scope;
            this.trafficShapingPolicyValidator = trafficShapingPolicyValidator;
            this.networkUtil = networkUtil;
            this.networkUiConstants = networkUiConstants;
            this.options = this.getOptions();
            this.minValue = 1;
            this.validators = {
                averageBandwidth: {
                    message: "",
                    isVisible: false
                },
                peakBandwidth: {
                    message: "",
                    isVisible: false
                },
                burstSize: {
                    message: "",
                    isVisible: false
                }
            };
        }
        EditVirtualSwitchTrafficShapingPageComponentController.prototype.getOptions = function () {
            var options = [{
                    label: this.i18nService.getString("NetworkUi", "PortTrafficShapingPolicyView.statusOn"),
                    val: true
                }, {
                    label: this.i18nService.getString("NetworkUi", "PortTrafficShapingPolicyView.statusOff"),
                    val: false
                }];
            return options;
        };
        EditVirtualSwitchTrafficShapingPageComponentController.prototype.onStatusChange = function () {
            this.validateTrafficShaping("averageBandwidth", this.pageModel.averageBandwidth, this.validators.averageBandwidth);
            this.validateTrafficShaping("peakBandwidth", this.pageModel.peakBandwidth, this.validators.peakBandwidth);
            this.validateTrafficShaping("burstSize", this.pageModel.burstSize, this.validators.burstSize);
        };
        EditVirtualSwitchTrafficShapingPageComponentController.prototype.validateTrafficShaping = function (attributeName, value, validator) {
            var message = this.trafficShapingPolicyValidator.getTrafficShapingErrorMessage(value, attributeName);
            validator.message = message;
            validator.isVisible = this.pageModel.enabled && message !== null;
        };
        ;
        EditVirtualSwitchTrafficShapingPageComponentController.prototype.onTrafficShapingChange = function (attributeName) {
            switch (attributeName) {
                case "averageBandwidth": {
                    this.validateTrafficShaping("averageBandwidth", this.pageModel.averageBandwidth, this.validators.averageBandwidth);
                    break;
                }
                case "peakBandwidth": {
                    this.validateTrafficShaping("peakBandwidth", this.pageModel.peakBandwidth, this.validators.peakBandwidth);
                    break;
                }
                case "burstSize": {
                    this.validateTrafficShaping("burstSize", this.pageModel.burstSize, this.validators.burstSize);
                    break;
                }
            }
        };
        ;
        EditVirtualSwitchTrafficShapingPageComponentController.$inject = [
            "i18nService",
            "$scope",
            "trafficShapingPolicyValidator",
            "networkUtil",
            "networkUiConstants"
        ];
        return EditVirtualSwitchTrafficShapingPageComponentController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .component("editVirtualSwitchTrafficShapingPage", new EditVirtualSwitchTrafficShapingPageComponent());
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateWizardFlags = (function () {
        function VmMigrateWizardFlags() {
        }
        return VmMigrateWizardFlags;
    }());
    network_ui.VmMigrateWizardFlags = VmMigrateWizardFlags;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateWizardModel = (function () {
        function VmMigrateWizardModel() {
        }
        return VmMigrateWizardModel;
    }());
    network_ui.VmMigrateWizardModel = VmMigrateWizardModel;
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateSelectVmsPageService = (function () {
        function VmMigrateSelectVmsPageService(i18nService, wizardConstants, clarityModalService) {
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.clarityModalService = clarityModalService;
        }
        VmMigrateSelectVmsPageService.prototype.saveExpandedItem = function (itemId, allExpandedItemIds) {
            var itemIdFound = _.find(allExpandedItemIds, function (id) {
                return id === itemId;
            });
            if (!itemIdFound) {
                allExpandedItemIds.push(itemId);
            }
        };
        VmMigrateSelectVmsPageService.prototype.saveCollapsedItem = function (itemId, allExpandedItemIds) {
            if (itemId === this.wizardConstants.ALL_VMS_ITEM_ID) {
                allExpandedItemIds.splice(0, allExpandedItemIds.length);
            }
            else {
                var itemIndex = allExpandedItemIds.indexOf(itemId);
                if (itemIndex !== -1) {
                    allExpandedItemIds.splice(itemIndex, 1);
                }
            }
        };
        VmMigrateSelectVmsPageService.prototype.restoreExpandedItems = function (allExpandedItemIds, treeListWidget, treeListDataSource) {
            if (!treeListDataSource || !treeListWidget || !allExpandedItemIds) {
                return;
            }
            var allVmsItem = this.findRootTreeListItem(treeListDataSource);
            if (allVmsItem) {
                if (allExpandedItemIds.length !== 0) {
                    // Expand the `All VMs` item
                    var allVmsListRow = treeListWidget.itemFor(allVmsItem);
                    if (allVmsListRow && !allVmsListRow.expanded) {
                        treeListWidget.expand(allVmsListRow);
                    }
                    if (allExpandedItemIds.length > 1) {
                        // Expand the previously expanded VM items
                        this.expandVmItems(allVmsItem, allExpandedItemIds, treeListWidget, treeListDataSource);
                    }
                }
            }
        };
        VmMigrateSelectVmsPageService.prototype.updateTreeListCheckboxState = function (dataSource, dataItem, wizardScope) {
            var _this = this;
            if (dataItem.isAccessible === false) {
                // Inaccessible items should not be checked
                return;
            }
            if (wizardScope.model.treeListItemData && dataItem) {
                if (dataItem.id === this.wizardConstants.ALL_VMS_ITEM_ID) {
                    // The item is 'All VMs' item - check/uncheck all VMs and virtual NICs
                    var hasInaccessibleItems_1 = false;
                    _.each(wizardScope.model.treeListItemData, function (item) {
                        if (item.isAccessible ||
                            item.id === _this.wizardConstants.ALL_VMS_ITEM_ID) {
                            item.isChecked = dataItem.isChecked;
                            dataSource.pushUpdate(item);
                        }
                        else if (item.isAccessible === false) {
                            hasInaccessibleItems_1 = true;
                        }
                    });
                    if (dataItem.isChecked && hasInaccessibleItems_1) {
                        if (!wizardScope.flags.inaccessibilityWarningShown) {
                            this.showWarningDialog(wizardScope);
                        }
                    }
                }
                else if (!dataItem.virtualEthernetCard) {
                    // The item is a VM - check/uncheck the VM item and all its virtual NICs
                    _.each(wizardScope.model.treeListItemData, function (item) {
                        if (item.isAccessible) {
                            if (dataItem.id === item.id &&
                                dataItem.parentId === item.parentId) {
                                // Check/uncheck the VM
                                item.isChecked = dataItem.isChecked;
                                dataSource.pushUpdate(item);
                                // Check/uncheck the root item if needed
                                _this.checkUncheckParentItem(dataSource, item, dataItem.isChecked, wizardScope.model.treeListItemData);
                            }
                            // Check/uncheck the VM virtual NICs
                            if (dataItem.id === item.parentId) {
                                item.isChecked = dataItem.isChecked;
                                dataSource.pushUpdate(item);
                            }
                        }
                    });
                }
                else {
                    // The item is a virtual NIC - check/uncheck the item, its VM item and
                    // the root item (if it is needed)
                    for (var _i = 0, _a = wizardScope.model.treeListItemData; _i < _a.length; _i++) {
                        var item = _a[_i];
                        if (dataItem.id === item.id &&
                            dataItem.parentId === item.parentId) {
                            if (item.isAccessible === false) {
                                // Do not check/uncheck the item
                                break;
                            }
                            // Check/uncheck the virtual NIC
                            item.isChecked = dataItem.isChecked;
                            dataSource.pushUpdate(item);
                            // Check/uncheck the parent VM item if needed
                            this.checkUncheckParentItem(dataSource, item, dataItem.isChecked, wizardScope.model.treeListItemData);
                            for (var _b = 0, _c = wizardScope.model.treeListItemData; _b < _c.length; _b++) {
                                var listItem = _c[_b];
                                // Check/uncheck the root item if needed
                                if (dataItem.parentId === listItem.id) {
                                    this.checkUncheckParentItem(dataSource, listItem, dataItem.isChecked, wizardScope.model.treeListItemData);
                                    break;
                                }
                            }
                            break;
                        }
                    }
                }
            }
        };
        VmMigrateSelectVmsPageService.prototype.showWarningDialog = function (wizardScope) {
            this.clarityModalService.openConfirmationModal({
                title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage" +
                    ".vmsWithInaccessibleDestinationSelected.title"),
                message: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage" +
                    ".vmsWithInaccessibleDestinationSelected.description"),
                submit: function () {
                    wizardScope.flags.inaccessibilityWarningShown = true;
                },
                clarityIcon: {
                    class: "is-warning",
                    shape: "warning-standard",
                    size: "32"
                },
                preserveNewlines: true,
                saveButtonLabel: this.i18nService.getString("Common", "alert.ok"),
                cancelButtonLabel: null,
                hideCancelButton: true
            });
        };
        VmMigrateSelectVmsPageService.prototype.checkUncheckParentItem = function (dataSource, childItem, checkItem, treeListItemData) {
            if (!childItem) {
                return;
            }
            if (checkItem) {
                // The child item is checked - check its parent item
                for (var _i = 0, treeListItemData_1 = treeListItemData; _i < treeListItemData_1.length; _i++) {
                    var item = treeListItemData_1[_i];
                    if (childItem.parentId === item.id) {
                        item.isChecked = true;
                        dataSource.pushUpdate(item);
                        break;
                    }
                }
            }
            else {
                var hasCheckedPeer = false;
                // The item is unchecked - uncheck the parent item of the item
                // if it does not have checked peers
                for (var _a = 0, treeListItemData_2 = treeListItemData; _a < treeListItemData_2.length; _a++) {
                    var item = treeListItemData_2[_a];
                    if (childItem.parentId === item.parentId) {
                        if (item.isChecked) {
                            hasCheckedPeer = true;
                            break;
                        }
                    }
                }
                if (!hasCheckedPeer) {
                    for (var _b = 0, treeListItemData_3 = treeListItemData; _b < treeListItemData_3.length; _b++) {
                        var item = treeListItemData_3[_b];
                        if (childItem.parentId === item.id) {
                            item.isChecked = false;
                            dataSource.pushUpdate(item);
                            break;
                        }
                    }
                }
            }
        };
        VmMigrateSelectVmsPageService.prototype.expandVmItems = function (allVmsItem, allExpandedItemIds, treeListWidget, treeListDataSource) {
            var vmItems = treeListDataSource.childNodes(allVmsItem);
            if (vmItems && vmItems.length > 0) {
                var _loop_1 = function(vmItem) {
                    var itemIdFound = _.find(allExpandedItemIds, function (id) {
                        return id === vmItem.id;
                    });
                    if (itemIdFound) {
                        var vmItemRow = treeListWidget.itemFor(vmItem);
                        if (vmItemRow && !vmItemRow.expanded) {
                            treeListWidget.expand(vmItemRow);
                        }
                    }
                };
                for (var _i = 0, vmItems_1 = vmItems; _i < vmItems_1.length; _i++) {
                    var vmItem = vmItems_1[_i];
                    _loop_1(vmItem);
                }
            }
        };
        VmMigrateSelectVmsPageService.prototype.findRootTreeListItem = function (treeListDataSource) {
            var _this = this;
            if (!treeListDataSource) {
                return null;
            }
            return _.find(treeListDataSource.rootNodes(), function (item) {
                return item.id === _this.wizardConstants.ALL_VMS_ITEM_ID;
            });
        };
        VmMigrateSelectVmsPageService.$inject = [
            "i18nService",
            "vmMigrateWizardConstants",
            "clarityModalService"
        ];
        return VmMigrateSelectVmsPageService;
    }());
    network_ui.VmMigrateSelectVmsPageService = VmMigrateSelectVmsPageService;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateSelectVmsPageService", VmMigrateSelectVmsPageService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateSelectNetworksPageValidator = (function () {
        function VmMigrateSelectNetworksPageValidator(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
        }
        VmMigrateSelectNetworksPageValidator.prototype.getValidationError = function (wizardScope) {
            var errors = [];
            if (!wizardScope.flags.noSourceNetworkSelected &&
                !wizardScope.model.sourceNetwork) {
                errors.push(this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage.noSourceSelected"));
            }
            if (!wizardScope.model.destinationNetwork) {
                errors.push(this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage.noDestinationSelected"));
            }
            if (!wizardScope.flags.noSourceNetworkSelected &&
                this.areNetworksEqual(wizardScope.model.sourceNetwork, wizardScope.model.destinationNetwork)) {
                errors.push(this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage.invalidDestinationError"));
            }
            return this.$q.resolve(errors);
        };
        VmMigrateSelectNetworksPageValidator.prototype.areNetworksEqual = function (sourceNetwork, destinationNetwork) {
            return sourceNetwork &&
                destinationNetwork &&
                sourceNetwork.networkRef &&
                destinationNetwork.networkRef &&
                sourceNetwork.networkRef.type === destinationNetwork.networkRef.type &&
                sourceNetwork.networkRef.value === destinationNetwork.networkRef.value &&
                sourceNetwork.networkRef.serverGuid ===
                    destinationNetwork.networkRef.serverGuid;
        };
        VmMigrateSelectNetworksPageValidator.$inject = [
            "i18nService",
            "$q"];
        return VmMigrateSelectNetworksPageValidator;
    }());
    network_ui.VmMigrateSelectNetworksPageValidator = VmMigrateSelectNetworksPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateSelectNetworksPageValidator", VmMigrateSelectNetworksPageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateSelectVmsPageValidator = (function () {
        function VmMigrateSelectVmsPageValidator(i18nService, $q, wizardConstants) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.wizardConstants = wizardConstants;
        }
        VmMigrateSelectVmsPageValidator.prototype.getValidationError = function (wizardScope) {
            var errors = [];
            if (!this.hasSelectedItem(wizardScope.model.treeListItemData)) {
                errors.push(this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.noAdaptersSelected"));
            }
            return this.$q.resolve(errors);
        };
        VmMigrateSelectVmsPageValidator.prototype.hasSelectedItem = function (treeListItemData) {
            if (!treeListItemData) {
                return false;
            }
            for (var _i = 0, treeListItemData_1 = treeListItemData; _i < treeListItemData_1.length; _i++) {
                var item = treeListItemData_1[_i];
                if (item.isChecked && item.id !== this.wizardConstants.ALL_VMS_ITEM_ID) {
                    return true;
                }
            }
            return false;
        };
        VmMigrateSelectVmsPageValidator.$inject = [
            "i18nService",
            "$q",
            "vmMigrateWizardConstants"];
        return VmMigrateSelectVmsPageValidator;
    }());
    network_ui.VmMigrateSelectVmsPageValidator = VmMigrateSelectVmsPageValidator;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateSelectVmsPageValidator", VmMigrateSelectVmsPageValidator);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateReadyToCompletePageController = (function () {
        function VmMigrateReadyToCompletePageController($wizardScope, i18nService, wizardConstants, vxPropertyViewService) {
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.vxPropertyViewService = vxPropertyViewService;
            var builder = vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            var generalSection = generalCategory.section("generalSection");
            // Source Network
            if (this.$wizardScope.flags.noSourceNetworkSelected) {
                generalSection.property(this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.source"), this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.noNetwork"));
            }
            else {
                generalSection.property(this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.sourceNetwork"), this.$wizardScope.model.sourceNetwork.name);
            }
            // Destination Network
            generalSection.property(this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.destinationNetwork"), this.$wizardScope.model.destinationNetwork.name);
            // The number of VMs to migrate
            generalSection.property(this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.numberOfVmsToMigrate"), this.getNumVms(this.$wizardScope.model.treeListItemData, this.wizardConstants.ALL_VMS_ITEM_ID));
            // The number of virtual NICs to migrate
            generalSection.property(this.i18nService.getString("H5NetworkUi", "VmMigrateWizard.summary.numberOfAdaptersToMigrate"), this.getNumVnics(this.$wizardScope.model.treeListItemData));
            this.$wizardScope.model.summaryData = builder.build();
        }
        VmMigrateReadyToCompletePageController.prototype.getNumVms = function (treeListItems, allVmsItemId) {
            var numVms = 0;
            if (treeListItems) {
                var vmItems = _.filter(treeListItems, function (item) {
                    return item.isChecked &&
                        item.id !== allVmsItemId &&
                        !item.virtualEthernetCard;
                });
                numVms = vmItems.length;
            }
            return numVms.toString();
        };
        VmMigrateReadyToCompletePageController.prototype.getNumVnics = function (treeListItems) {
            var numVnics = 0;
            if (treeListItems) {
                var vmVnicItems = _.filter(treeListItems, function (item) {
                    return item.isChecked && item.virtualEthernetCard;
                });
                numVnics = vmVnicItems.length;
            }
            return numVnics.toString();
        };
        VmMigrateReadyToCompletePageController.$inject = [
            "$scope",
            "i18nService",
            "vmMigrateWizardConstants",
            "vxPropertyViewService"
        ];
        return VmMigrateReadyToCompletePageController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .controller("VmMigrateReadyToCompletePageController", VmMigrateReadyToCompletePageController);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateSelectNetworksPageController = (function () {
        function VmMigrateSelectNetworksPageController($wizardScope, i18nService, selectorMode, networkSelectorDialogService, wizardConstants, defaultUriSchemeUtil, dataService) {
            var _this = this;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.selectorMode = selectorMode;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.wizardConstants = wizardConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            if (!$wizardScope.flags.isSelectNetworksPageInitialized &&
                this.$wizardScope.flags.isSourceNetworkPreselected) {
                this.requestProperties();
            }
            this.networkSelectorMode = this.selectorMode.SINGLE_SELECTION_BROWSE_INPUT;
            this.networkSelectorFilterSpec =
                this.networkSelectorDialogService.createNetworkSelectorFilterSpec(true /*includeStandardNetworks*/, true /*includeOpaqueNetworks*/, true /*includeDistributedPortGroups*/, false /*includeUplinkPortGroups*/, false /*includeOpaqueNetworkTypes*/);
            this.networkSelectorDialogSpec =
                this.networkSelectorDialogService.createNetworkSelectorDialogSpec(["Network.Assign"], this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage." +
                    "noNetworkAssignPrivilegeError"));
            this.onSourceNetworksChanged = function (selectedNetworks) {
                if (_this.$wizardScope.model.sourceNetwork !== selectedNetworks[0]) {
                    _this.$wizardScope.model.sourceNetwork = selectedNetworks[0];
                    _this.clearFlags();
                }
            };
            this.onDestinationNetworksChanged = function (selectedNetworks) {
                if (_this.$wizardScope.model.destinationNetwork !== selectedNetworks[0]) {
                    _this.$wizardScope.model.destinationNetwork = selectedNetworks[0];
                    _this.clearFlags();
                }
            };
            this.$wizardScope.$watch(function () {
                return _this.$wizardScope.flags.noSourceNetworkSelected;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    _this.clearFlags();
                }
            });
        }
        VmMigrateSelectNetworksPageController.prototype.clearFlags = function () {
            this.$wizardScope.flags.isSelectVmsPageInitialized = false;
            this.$wizardScope.flags.inaccessibilityWarningShown = false;
            this.$wizardScope.model.expandedItemIds =
                [this.wizardConstants.ALL_VMS_ITEM_ID];
        };
        VmMigrateSelectNetworksPageController.prototype.requestProperties = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            this.dataService.getProperties(this.$wizardScope.model.contextObjId, [
                this.wizardConstants.properties.NAME_PROPERTY,
                this.wizardConstants.properties.ICON_PROPERTY])
                .then(function (response) {
                _this.$wizardScope.model.sourceNetwork = {
                    name: response[_this.wizardConstants.properties.NAME_PROPERTY],
                    icon: response[_this.wizardConstants.properties.ICON_PROPERTY],
                    networkRef: _this.defaultUriSchemeUtil.getManagedObjectReference(_this.$wizardScope.model.contextObjId)
                };
                _this.$wizardScope.wizardConfig.loading = false;
                _this.$wizardScope.flags.isSelectNetworksPageInitialized = true;
            });
        };
        VmMigrateSelectNetworksPageController.$inject = [
            "$scope",
            "i18nService",
            "NetworkSelectorMode",
            "networkSelectorDialogService",
            "vmMigrateWizardConstants",
            "defaultUriSchemeUtil",
            "dataService"];
        return VmMigrateSelectNetworksPageController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .controller("VmMigrateSelectNetworksPageController", VmMigrateSelectNetworksPageController);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateSelectVmsPageController = (function () {
        function VmMigrateSelectVmsPageController($wizardScope, i18nService, columnRenderersRegistry, wizardConstants, dataService, defaultUriSchemeUtil, clarityModalService, $element, vuiUtils, $q, vmMigrateSelectVmsPageService) {
            var _this = this;
            this.$wizardScope = $wizardScope;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.wizardConstants = wizardConstants;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityModalService = clarityModalService;
            this.$element = $element;
            this.vuiUtils = vuiUtils;
            this.$q = $q;
            this.vmMigrateSelectVmsPageService = vmMigrateSelectVmsPageService;
            this.bindTreeListEvents = true;
            this.restoreExpandedItems = true;
            this.treeListOptions = {
                columns: this.getTreeListColumnDefs(),
                sortable: false,
                resizable: true,
                selectable: true,
                dataBound: this.onTreeListDataBound.bind(this),
                expand: function (event) {
                    vuiUtils.safeApply(_this.$wizardScope, _this.onExpandItem.bind(_this, event));
                },
                collapse: function (event) {
                    vuiUtils.safeApply(_this.$wizardScope, _this.onCollapseItem.bind(_this, event));
                }
            };
            this.selectVmsInfo = this.$wizardScope.flags.noSourceNetworkSelected
                ? this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.selectVmsLabelNoSource", this.$wizardScope.model.destinationNetwork.name)
                : this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.selectVmsLabel", this.$wizardScope.model.sourceNetwork.name, this.$wizardScope.model.destinationNetwork.name);
            if (!this.$wizardScope.flags.isSelectVmsPageInitialized) {
                this.requestProperties();
            }
            else {
                this.initTreeListData();
            }
            $element.on('vmMigrateSelectVm', function (event, dataItemUid) {
                event.stopPropagation();
                var items = _this.treeListOptions.dataSource.rootNodes();
                for (var i = 0; i < items.length; i++) {
                    items = items.concat(_this.treeListOptions.dataSource.childNodes(items[i]));
                }
                var item = _.filter(items, function (item) { return item.uid === dataItemUid; })[0];
                item.isChecked = !item.isChecked;
                _this.onCheckboxClick(item);
            });
        }
        VmMigrateSelectVmsPageController.prototype.requestProperties = function () {
            var _this = this;
            this.$wizardScope.wizardConfig.loading = true;
            var networkId = this.defaultUriSchemeUtil.getVsphereObjectId(this.$wizardScope.model.destinationNetwork.networkRef);
            var spec = {
                sourceNetworkRef: this.$wizardScope.flags.noSourceNetworkSelected
                    ? null
                    : this.$wizardScope.model.sourceNetwork.networkRef,
                datacenterRef: this.defaultUriSchemeUtil.getManagedObjectReference(this.$wizardScope.model.datacenterId)
            };
            this.dataService.getProperties(networkId, [this.wizardConstants.properties.VM_NETWORKS_PROPERTY], {
                propertyParams: [{
                        propertyName: this.wizardConstants.properties.VM_NETWORKS_PROPERTY,
                        parameterType: this.wizardConstants.specs.VM_MIGRATE_PROPERTY_SPEC,
                        parameter: spec
                    }]
            })
                .then(function (response) {
                var vmData = response[_this.wizardConstants.properties.VM_NETWORKS_PROPERTY];
                _this.$wizardScope.model.destinationNetworkData =
                    vmData.destinationNetwork;
                _this.$wizardScope.model.treeListItemData =
                    vmData.vmListItems;
                _this.$wizardScope.wizardConfig.loading = false;
                _this.$wizardScope.flags.isSelectVmsPageInitialized = true;
                _this.initTreeListData();
                _this.restoreExpandedItems = true;
            });
        };
        VmMigrateSelectVmsPageController.prototype.onExpandItem = function (e) {
            this.vmMigrateSelectVmsPageService.saveExpandedItem(e.model.id, this.$wizardScope.model.expandedItemIds);
        };
        VmMigrateSelectVmsPageController.prototype.onCollapseItem = function (e) {
            this.vmMigrateSelectVmsPageService.saveCollapsedItem(e.model.id, this.$wizardScope.model.expandedItemIds);
        };
        VmMigrateSelectVmsPageController.prototype.onTreeListDataBound = function () {
            if (!this.restoreExpandedItems || !this.treeListWidget) {
                return;
            }
            this.vmMigrateSelectVmsPageService.restoreExpandedItems(this.$wizardScope.model.expandedItemIds, this.treeListWidget, this.treeListOptions.dataSource);
            this.restoreExpandedItems = false;
        };
        VmMigrateSelectVmsPageController.prototype.initTreeListData = function () {
            this.treeListOptions.dataSource = new kendo.data.TreeListDataSource({
                data: !this.$wizardScope.model.treeListItemData ?
                    [] : this.$wizardScope.model.treeListItemData,
                schema: {
                    model: {
                        id: "id",
                        expanded: false
                    }
                }
            });
            this.treeListOptions.dataSource.read();
        };
        VmMigrateSelectVmsPageController.prototype.getTreeListColumnDefs = function () {
            var _this = this;
            var columnRenderer = this.columnRenderersRegistry
                .getColumnRenderer('disabled-text-icon-with-tooltip');
            return [
                {
                    field: "name",
                    title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.vmNicColumnHeader"),
                    width: "240px",
                    template: function (dataItem) {
                        var disabledClass = dataItem.isAccessible === false ?
                            "element-disabled" : "";
                        return "<input type=\"checkbox\" " +
                            "    " + (dataItem.isChecked ? "checked" : "") +
                            "    onclick=\"$(this).trigger('vmMigrateSelectVm', '" + dataItem.uid + "')\"" +
                            "    class=\"" + disabledClass + "\"/>" +
                            "<span ng-non-bindable>" +
                            columnRenderer(["icon", "label", "disabled", "tooltip"], {
                                icon: dataItem.iconId,
                                label: dataItem.name,
                                disabled: dataItem.isAccessible === false,
                                tooltip: dataItem.itemTooltip
                            }) +
                            "</span>";
                    }
                },
                {
                    field: "nicCount",
                    width: "100px",
                    title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.nicsCountColumnHeader"),
                    template: function (dataItem) {
                        return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                            icon: null,
                            label: dataItem.nicCount,
                            disabled: dataItem.isAccessible === false,
                            tooltip: dataItem.itemTooltip
                        });
                    }
                },
                {
                    field: "host",
                    title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.hostColumnHeader"),
                    width: "150px",
                    template: function (dataItem) {
                        return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                            icon: dataItem.hostName ? "vsphere-icon-host" : null,
                            label: dataItem.hostName,
                            disabled: dataItem.isAccessible === false,
                            tooltip: dataItem.itemTooltip
                        });
                    }
                },
                {
                    field: "accessibility",
                    title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.destNetworkColumnHeader"),
                    template: function (dataItem) {
                        var accessibility = "";
                        if (dataItem.isAccessible) {
                            accessibility = _this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.accessible");
                        }
                        else if (dataItem.isAccessible === false) {
                            accessibility = _this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.inaccessible");
                        }
                        return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                            icon: null,
                            label: accessibility,
                            disabled: dataItem.isAccessible === false,
                            tooltip: dataItem.itemTooltip
                        });
                    }
                }];
        };
        VmMigrateSelectVmsPageController.prototype.onCheckboxClick = function (dataItem) {
            this.vmMigrateSelectVmsPageService.updateTreeListCheckboxState(this.treeListOptions.dataSource, dataItem, this.$wizardScope);
            this.treeListWidget.refresh();
            this.restoreExpandedItems = true;
        };
        VmMigrateSelectVmsPageController.$inject = [
            "$scope",
            "i18nService",
            "columnRenderersRegistry",
            "vmMigrateWizardConstants",
            "dataService",
            "defaultUriSchemeUtil",
            "clarityModalService",
            "$element",
            "vuiUtils",
            "$q",
            "vmMigrateSelectVmsPageService"];
        return VmMigrateSelectVmsPageController;
    }());
    angular.module("com.vmware.vsphere.client.network")
        .controller("VmMigrateSelectVmsPageController", VmMigrateSelectVmsPageController);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    angular.module("com.vmware.vsphere.client.network").constant("vmMigrateWizardConstants", {
        pages: {
            VM_SELECT_NETWORKS_PAGE: "selectNetworksPage",
            VM_SELECT_VMS_TO_MIGRATE_PAGE: "selectVmsToMigratePage",
            VM_MIGRATE_READY_TO_COMPLETE_PAGE: "readyToCompletePage"
        },
        properties: {
            NAME_PROPERTY: "name",
            ICON_PROPERTY: "primaryIconId",
            DATACENTER_PROPERTY: "dc",
            VM_NETWORKS_PROPERTY: "migratevms:vmsNetworkProperties"
        },
        objectType: {
            DATACENTER_TYPE: "Datacenter"
        },
        specs: {
            VM_MIGRATE_PROPERTY_SPEC: "com.vmware.vsphere.client.h5.network.vm.migrate.specs.MigrateVmPropertySpec",
            VM_MIGRATE_VM_VNICS_SPEC: "com.vmware.vsphere.client.h5.network.vm.migrate.specs.MigrateVmVnicsSpec",
            VM_MIGRATE_NETWORKING_SPEC: "com.vmware.vsphere.client.h5.network.vm.migrate.specs.MigrateVmNetworkingSpec",
            VM_NETWORK_PROPERTIES_SPEC: "com.vmware.vsphere.client.h5.network.vm.migrate.model.VmNetworkProperties"
        },
        ALL_VMS_ITEM_ID: "1"
    });
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateWizardPages = (function () {
        function VmMigrateWizardPages(i18nService, wizardConstants, selectNetworksPageValidator, selectVmsPageValidator, simpleValidationCommit) {
            this.i18nService = i18nService;
            this.wizardConstants = wizardConstants;
            this.selectNetworksPageValidator = selectNetworksPageValidator;
            this.selectVmsPageValidator = selectVmsPageValidator;
            this.simpleValidationCommit = simpleValidationCommit;
        }
        /**
         * Creates an array of page definitions for the Migrate VM networking wizard.
         */
        VmMigrateWizardPages.prototype.createPages = function (wizardScope) {
            var _this = this;
            var selectNetworksPage = {
                id: this.wizardConstants.pages.VM_SELECT_NETWORKS_PAGE,
                title: this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage.title"),
                description: this.i18nService.getString("NetworkUi", "SelectSourceDestinationNetworkPage.description"),
                contentUrl: "network-ui/resources/network/views/vm/migrate/views/" +
                    "vmMigrateSelectNetworksPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.selectNetworksPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: []
            };
            var selectVmsPage = {
                id: this.wizardConstants.pages.VM_SELECT_VMS_TO_MIGRATE_PAGE,
                title: this.i18nService.getString("NetworkUi", "SelectVmsToMigratePage.title"),
                description: "",
                // description: this.i18nService.getString(
                //       "NetworkUi", "SelectVmsToMigratePage.description"),
                contentUrl: "network-ui/resources/network/views/vm/migrate/views/" +
                    "vmMigrateSelectVmsPage.html",
                onCommit: this.simpleValidationCommit(function () {
                    return _this.selectVmsPageValidator.getValidationError(wizardScope);
                }, wizardScope.wizardConfig),
                validationParams: ["flags.isSelectVmsPageInitialized"]
            };
            var readyToCompletePage = {
                id: this.wizardConstants.pages.VM_MIGRATE_READY_TO_COMPLETE_PAGE,
                title: this.i18nService.getString("H5NetworkUi", "vmMigrateWizard.readyToCompletePage.title"),
                description: this.i18nService.getString("H5NetworkUi", "vmMigrateWizard.readyToCompletePage.description"),
                contentUrl: "network-ui/resources/network/views/vm/migrate/views/" +
                    "vmMigrateReadyToCompletePage.html",
                onCommit: function () {
                    return true;
                },
                validationParams: []
            };
            return [selectNetworksPage, selectVmsPage, readyToCompletePage];
        };
        VmMigrateWizardPages.$inject = [
            "i18nService",
            "vmMigrateWizardConstants",
            "vmMigrateSelectNetworksPageValidator",
            "vmMigrateSelectVmsPageValidator",
            "simpleValidationCommit"
        ];
        return VmMigrateWizardPages;
    }());
    network_ui.VmMigrateWizardPages = VmMigrateWizardPages;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateWizardPages", VmMigrateWizardPages);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    var VmMigrateWizardService = (function () {
        function VmMigrateWizardService($rootScope, i18nService, vuiWizardService, pageStateManagementService, mutationService, wizardConstants, vmMigrateWizardPages, dataService, defaultUriSchemeUtil, wizardValidationService, vmMigrateWizardSpecFactory) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.pageStateManagementService = pageStateManagementService;
            this.mutationService = mutationService;
            this.wizardConstants = wizardConstants;
            this.vmMigrateWizardPages = vmMigrateWizardPages;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardValidationService = wizardValidationService;
            this.vmMigrateWizardSpecFactory = vmMigrateWizardSpecFactory;
        }
        /**
         * Shows the Migrate VMs to Another Network... wizard.
         */
        VmMigrateWizardService.prototype.show = function (contextObjId) {
            var _this = this;
            var wizardScope = this.$rootScope.$new();
            wizardScope.model = this.initWizardModel(contextObjId);
            wizardScope.flags = this.initWizardFlags();
            wizardScope.wizardConfig = {
                title: this.i18nService.getString("NetworkUi", "VmMigrateWizard.title"),
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                cssClass: "migrate-vm-networking-wizard",
                onFinish: function () {
                    var spec = _this.vmMigrateWizardSpecFactory.buildVmMigrateSpec(wizardScope.model);
                    _this.mutationService.apply(wizardScope.model.contextObjId, _this.wizardConstants.specs.VM_MIGRATE_NETWORKING_SPEC, spec);
                    return true;
                }
            };
            wizardScope.wizardConfig.pages =
                this.vmMigrateWizardPages.createPages(wizardScope);
            this.wizardValidationService.initWizardValidation(wizardScope);
            this.pageStateManagementService
                .registerWizardForDefaultStateManagementStrategy(wizardScope);
            var contextObjRef = this.defaultUriSchemeUtil.getManagedObjectReference(contextObjId);
            if (contextObjRef &&
                contextObjRef.type !== this.wizardConstants.objectType.DATACENTER_TYPE) {
                wizardScope.flags.isSourceNetworkPreselected = true;
                this.dataService.getProperties(contextObjId, [
                    this.wizardConstants.properties.DATACENTER_PROPERTY])
                    .then(function (response) {
                    var datacenterRef = response[_this.wizardConstants.properties.DATACENTER_PROPERTY];
                    if (datacenterRef) {
                        wizardScope.model.datacenterId =
                            _this.defaultUriSchemeUtil.getVsphereObjectId(datacenterRef);
                    }
                    _this.invokeWizard(wizardScope);
                });
            }
            else {
                wizardScope.model.datacenterId = contextObjId;
                this.invokeWizard(wizardScope);
            }
        };
        VmMigrateWizardService.prototype.invokeWizard = function (wizardScope) {
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        VmMigrateWizardService.prototype.initWizardModel = function (contextObjId) {
            var model = new network_ui.VmMigrateWizardModel();
            model.contextObjId = contextObjId;
            model.expandedItemIds = [this.wizardConstants.ALL_VMS_ITEM_ID];
            return model;
        };
        VmMigrateWizardService.prototype.initWizardFlags = function () {
            var flags = new network_ui.VmMigrateWizardFlags();
            flags.isSelectVmsPageInitialized = false;
            flags.isSelectNetworksPageInitialized = false;
            flags.inaccessibilityWarningShown = false;
            flags.noSourceNetworkSelected = false;
            flags.isSourceNetworkPreselected = false;
            return flags;
        };
        VmMigrateWizardService.$inject = [
            "$rootScope",
            "i18nService",
            "vuiWizardService",
            "pageStateManagementService",
            "mutationService",
            "vmMigrateWizardConstants",
            "vmMigrateWizardPages",
            "dataService",
            "defaultUriSchemeUtil",
            "wizardValidationService",
            "vmMigrateWizardSpecFactory"];
        return VmMigrateWizardService;
    }());
    network_ui.VmMigrateWizardService = VmMigrateWizardService;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateWizardService", VmMigrateWizardService);
})(network_ui || (network_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_ui;
(function (network_ui) {
    /**
     * Provides methods for creating the mutation spec sent to the backend
     * services after the completion of the Migrate VM networks wizard.
     */
    var VmMigrateWizardSpecFactory = (function () {
        function VmMigrateWizardSpecFactory(defaultUriSchemeUtil, wizardConstants) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardConstants = wizardConstants;
        }
        /**
         * Builds the spec for the Migrate VM networks operation.
         *
         * @param model VmMigrateWizardModel
         */
        VmMigrateWizardSpecFactory.prototype.buildVmMigrateSpec = function (model) {
            var listItems = model.treeListItemData;
            var vmVnicSpecs = [];
            var _loop_1 = function(listItem) {
                if (listItem.isChecked &&
                    listItem.id !== this_1.wizardConstants.ALL_VMS_ITEM_ID &&
                    !listItem.virtualEthernetCard) {
                    var vmItem = listItem;
                    var vmVnicItems = _.filter(listItems, function (item) {
                        return item.isChecked &&
                            item.virtualEthernetCard &&
                            item.parentId === listItem.id;
                    });
                    var vmVnics = [];
                    for (var _i = 0, vmVnicItems_1 = vmVnicItems; _i < vmVnicItems_1.length; _i++) {
                        var vmVnicItem = vmVnicItems_1[_i];
                        vmVnics.push(vmVnicItem.virtualEthernetCard);
                    }
                    var vmVnicSpec = {
                        _type: this_1.wizardConstants.specs.VM_MIGRATE_VM_VNICS_SPEC,
                        vmRef: this_1.defaultUriSchemeUtil.getManagedObjectReference(vmItem.id),
                        vmChangeVersion: vmItem.changeVersion,
                        vnics: vmVnics
                    };
                    vmVnicSpecs.push(vmVnicSpec);
                }
            };
            var this_1 = this;
            for (var _a = 0, listItems_1 = listItems; _a < listItems_1.length; _a++) {
                var listItem = listItems_1[_a];
                _loop_1(listItem);
            }
            return {
                vmVnicsSpecs: vmVnicSpecs,
                destinationNetwork: model.destinationNetworkData
            };
        };
        VmMigrateWizardSpecFactory.$inject = ["defaultUriSchemeUtil", "vmMigrateWizardConstants"];
        return VmMigrateWizardSpecFactory;
    }());
    network_ui.VmMigrateWizardSpecFactory = VmMigrateWizardSpecFactory;
    angular.module("com.vmware.vsphere.client.network")
        .service("vmMigrateWizardSpecFactory", VmMigrateWizardSpecFactory);
})(network_ui || (network_ui = {}));





/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.cluster = {
   angularModule: angular.module('com.vmware.vsphere.client.cluster',
         ['com.vmware.platform.ui', 'com.vmware.vsphere.client.commonModule',
               'com.vmware.vsphere.client.licenseLibUi'])
};

/*
 * Registers cluster-ui actions.
 */
angular.module('com.vmware.vsphere.client.cluster')
      .run([
         'mutationService', 'i18nService', '$rootScope',
         'vuiConstants', 'haDialogService', 'clarityModalService', 'clusterGroupsService',
         'clusterRulesService', 'clusterRulesConstants', 'alertService',
         'clusterVmOverridesService', 'clusterConfigVmOverrideService',
         'assignLicenseService', 'editDrsDialogService', 'moveResourcePoolToService', 'featureFlagsService',
         'scheduleDrsWizardService', 'quickstartRefreshService', 'moveClusterToService',
         function(mutationService, i18nService, $rootScope,
                  vuiConstants, haDialogService, clarityModalService, clusterGroupsService,
                  clusterRulesService, clusterRulesConstants, alertService,
                  clusterVmOverridesService, clusterConfigVmOverrideService,
                  assignLicenseService, editDrsDialogService, moveResourcePoolToService, featureFlagsService,
                  scheduleDrsWizardService, quickstartRefreshService, moveClusterToService) {

            var angularZone = window.Zone.current;

            if (h5 && h5.configuration && h5.configuration.featureStates &&
                  h5.configuration.featureStates.HCI === "ENABLED") {
               // Check feature switch using the global variable because
               // featureFlagsService is initialized after the run block
               // completes and will always return that the feature is disabled.
               quickstartRefreshService.init();
            }

            function showCreateClusterDialog(actionEval, availableTargets) {
               var templateUrl = featureFlagsService.HCIEnabled() ?
                     'cluster-ui/resources/cluster/views/create_cluster/CreateNewCluster.html' :
                     'cluster-ui/resources/cluster/views/create_cluster/CreateCluster.html';

               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'createClusterDialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: templateUrl,
                  size: 'md',
                  modalClass: 'create-cluster-dialog',
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  }
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showEditClusterDialog(actionEval, availableTargets) {
               var templateUrl = 'cluster-ui/resources/cluster/views/edit_cluster/EditCluster.html';

               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'editClusterDialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: templateUrl,
                  size: 'md',
                  modalClass: 'create-cluster-dialog',
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  }
               };

               angularZone.run(function () {
                  clarityModalService.openOkCancelModal(modalOptions);
               });
            }

            function showEditDrsDialog(actionEval, availableTargets, context) {
               editDrsDialogService.show(availableTargets[0], context && context.focusTarget);
            }

            function showScheduleDrsWizard(actionEval, availableTargets, context) {
               scheduleDrsWizardService.show(actionEval, availableTargets[0], context && context.focusTarget);
            }

            function showEditHaDialog(actionEval, availableTargets, context) {
               haDialogService.show(availableTargets[0], context && context.focusTarget);
            }

            function showEditProctiveHaDialog(actionEval, availableTargets, context) {
               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'editDialog.proHa.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  submitButtonTitle: i18nService.getString(
                        'ClusterUi',
                        'editDialog.proHa.saveButton.title'),
                  contentTemplate:
                        'cluster-ui/resources/cluster/views/settings/services/proactiveHa/editProactiveHaDialog.html',
                  size: 'lg',
                  modalClass: 'cluster-edit-proactive-ha-dialog-modal',
                  focusTarget: context && context.focusTarget,
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  }
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showEditEvcModeDialog(actionEval, availableTargets) {
               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'evc.config.formTitle'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/configuration/EditEvcDialog.html',
                  size: 'lg',
                  modalClass: 'edit-cluster-evc-dialog',
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  }
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function navigateToClusterSettings(actionEval, availableTargets) {
               $rootScope._navigateToViewAndObject('vsphere.core.cluster.manage', availableTargets[0]);
            }

            function showEditDefaultVmCompatibilityDialog(actionEval, availableTargets, context) {
               var modalOptions = {
                  title: i18nService.getString('HostUi', 'defaultVmCompatibilityDialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: 'host-ui/resources/host/views/settings/EditDefaultVmCompatibility.html',
                  focusTarget: context && context.focusTarget,
                  dialogData: {
                     availableTargets: availableTargets
                  }
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showEditSwapfileLocationDialog(actionEval, availableTargets, context) {
               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'editClusterSettingsDialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/configuration/EditSwapfileLocationDialog.html',
                  focusTarget: context && context.focusTarget,
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  }
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showCreateResourcePoolDialog(actionEval, availableTargets, context) {
               var modalOptions = {
                  title: i18nService.getString('RpUi', 'actionCreateRPDefaultName'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: 'cluster-ui/resources/cluster/views/create_resource_pool/createResourcePool.html',
                  focusTarget: context && context.focusTarget,
                  dialogData: {
                     availableTargets: availableTargets,
                     objectId: availableTargets[0]
                  },
                  modalClass: 'cluster-resource-pool-modal'
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showEditResourcePoolDialog(actionEval, availableTargets) {
               var modalOptions = {
                  title: i18nService.getString('RpUi', 'settings.edit.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  contentTemplate: 'cluster-ui/resources/cluster/views/edit_resource_pool/editResourcePool.html',
                  dialogData: {
                     objectId: availableTargets[0]
                  },
                  modalClass: 'edit-cluster-resource-pool-modal'
               };
               if (actionEval && actionEval.additionalData && actionEval.additionalData.isScheduledTask) {
                  modalOptions.contentTemplate =
                     'cluster-ui/resources/cluster/views/edit_resource_pool_scheduled_task/editResourcePoolScheduledTaskDialog.html';
                  modalOptions.actionEval = actionEval;
                  if ( modalOptions.actionEval.additionalData.schedulingData.scheduleTaskOperationMode === 0) {
                     modalOptions.title =  i18nService.getString('ClusterUi', 'st.new.scheduled.task',
                        i18nService.getString("ScheduledOpsUi", "Wizard.scheduleTask.ResourceConfigForm.title"));
                  } else {
                     modalOptions.title =  i18nService.getString('ClusterUi', 'st.edit.scheduled.task',
                        i18nService.getString("ScheduledOpsUi", "Wizard.scheduleTask.ResourceConfigForm.title"));
                  }
               }
               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showMoveToResourcePoolDialog( actionEval, availableTargets) {
               if (!availableTargets || !availableTargets.length) {
                  return;
               }

               var modalOptions = {
                  title: i18nService.getString('RpUi', 'moveTo.title'),
                  defaultButton: 'submit',
                  dialogData: {
                     objectIds: availableTargets
                  },
                  contentTemplate: 'cluster-ui/resources/cluster/views/move_to_resource_pool/moveResourcePoolToDialog.html'
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showAddGroupDialog(actionEval, availableTargets, context) {
               clarityModalService.openOkCancelModal({
                  title: i18nService.getString('ClusterUi', 'groups.config.title.create'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  modalClass: 'cluster-add-vm-host-group-modal',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/configuration/groups/AddClusterGroup.html',
                  focusTarget: context && context.focusTarget
               });
            }

            function removeGroup(actionEval, availableTargets, context) {
               clusterGroupsService.removeGroup(availableTargets[0], context.selectedGroup);
            }

            function showAddGroupMembersDialog(actionEval, availableTargets, context) {
               var dialogData = {
                  objects: context.memberObjects,
                  objectType: context.memberObjectsType,
                  objectId: availableTargets[0],
                  onSubmit: function() {
                     return context.addMembersCallback(dialogData.selectedItems);
                  }
               };

               clarityModalService.openOkCancelModal({
                  title: i18nService.getString(
                        'ClusterUi', 'groups.members.dialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  dialogData: dialogData,
                  defaultButton: 'submit',
                  size: 'lg',
                  modalClass: 'cluster-add-group-members-selector-dialog',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/configuration/groups/addGroupMembersSelectorDialog.html',
                  focusTarget: context && context.focusTarget
               });
            }

            function removeGroupMembers(actionEval, availableTargets, context) {
               context.removeMembersCallback();
            }

            function showAddRuleDialog(actionEval, availableTargets) {
               clarityModalService.openOkCancelModal({
                  title: i18nService.getString('ClusterUi', 'rules.config.title.create'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  modalClass: 'cluster-add-vm-host-rule-modal',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/rules/addClusterRule.html'
               });
            }

            function removeRule(actionEval, availableTargets, context) {
               clusterRulesService.deleteRule(availableTargets[0], context.selectedRule);
            }

            function showEditRuleDialog(actionEval, availableTargets, context) {
               clarityModalService.openOkCancelModal({
                  title: i18nService.getString('ClusterUi', 'rules.config.title.edit'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  dialogData: {
                     rule: context.selectedRule
                  },
                  defaultButton: 'submit',
                  modalClass: 'cluster-add-vm-host-rule-modal',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/rules/addClusterRule.html'
               });
            }

            function showAddRuleMemberDialog(actionEval, availableTargets, context) {
               var dialogOptions = {
                  title: i18nService.getString(
                        'ClusterUi', 'rules.add.affinity.rule.dialog.title'),
                  subTitle: context.dialogSubTitleObject,
                  size: 'lg',
                  defaultButton: 'submit',
                  modalClass: 'cluster-add-affinity-rule-member-dialog',
                  contentTemplate: 'cluster-ui/resources/cluster/views/settings/rules/addClusterRuleMember.html',
                  dialogData: {
                     selectedVms: context.selectedMembers,
                     objectId: availableTargets[0]
                  },
                  onSubmit: function() {
                     return context.submitCallback(dialogOptions);
                  }
               };

               clarityModalService.openOkCancelModal(dialogOptions);
            }

            function showRemoveRuleMemberConfirmationDialog(actionEval, availableTargets, context) {
               var isExistingRule = context.isExistingRule;
               var ruleInfo = context.rule;
               var membersToRemove = context.membersToRemove;
               var confirmCallback = context.confirmCallback;

               if (isExistingRule && ruleInfo.members.length - membersToRemove.length <
                     clusterRulesConstants.affinityRuleMinimumMembers) {
                  // Cannot leave less than 2 members in rule
                  alertService.error(
                        i18nService.getString('ClusterUi',
                              'rules.members.action.remove.confirmationTitle'),
                        i18nService.getString('ClusterUi',
                              'rules.members.action.remove.error.cannotDeleteAllRuleMembers'));
               } else {
                  var confirmProperties = {
                     title: i18nService.getString('ClusterUi',
                           'rules.members.action.remove.confirmationTitle'),
                     message: i18nService.getString('ClusterUi',
                           'rules.members.action.remove.confirmationTextOne'),
                     submit: function() {
                        return confirmCallback();
                     }
                  };

                  clarityModalService.openConfirmationModal(confirmProperties);
               }
            }

            function showDetailsRuleMembersDialog(actionEval, availableTargets, context) {
               clarityModalService.openModal(
                     angular.merge(
                           {},
                           actionEval,
                           {
                              action: {
                                 label: i18nService.getString('ClusterUi', 'rules.members.detailsPopupTitle')
                              }
                           }),
                     availableTargets,
                     {
                        rule: context.selectedRule,
                        member: context.selectedMember
                     },
                     'cluster-ui/resources/cluster/views/settings/rules/viewDetailsClusterRuleMember.html'
               );
            }

            function showEditHostOptionsDialog(actionEval, availableTargets, context) {
               clarityModalService.openOkCancelModal({
                  title: i18nService.getString(
                        'ClusterUi',
                        'hostOptions.edit.dialogTitle'),
                  subTitle: {
                     objectId: context.selectedHost
                  },
                  dialogData: {
                     selectedHost: context.selectedHost,
                     clusterRef: context.clusterRef
                  },
                  size: 'lg',
                  defaultButton: 'submit',
                  modalClass: 'edit-host-options-dialog',
                  contentTemplate:
                        'cluster-ui/resources/cluster/views/settings/hostOptions/editHostOptions.html'
               });
            }

            function deleteVmOverride(actionEval, availableTargets, context) {
               clusterVmOverridesService.deleteVmOverride(
                     availableTargets[0], context.selectedOverrides,
                     context && context.focusTarget);
            }

            function showAddVmOverrideDialog(actionEval, availableTargets, context) {
               clusterConfigVmOverrideService.openAddVmOverrideWizard(availableTargets[0], context && context.focusTarget);
            }

            function showEditVmOverrideDialog(actionEval, availableTargets, context) {
               var vmName = context.selectedOverrides.length === 1 ?
                     context.selectedOverrides[0].vm.name :
                     i18nService.getString('ClusterUi',
                           'vm.overrides.config.edit.dialog.title.vms',
                           context.selectedOverrides.length);

               clarityModalService.openOkCancelModal({
                  title: i18nService.getString('ClusterUi',
                        'vm.overrides.config.edit.dialog.title', vmName),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  dialogData: {
                     selectedOverrides: context.selectedOverrides,
                     objectId: availableTargets[0]
                  },
                  size: 'lg',
                  defaultButton: 'submit',
                  modalClass: 'cluster-edit-vm-override-modal',
                  contentTemplate:
                        'cluster-ui/resources/cluster/views/settings/configuration/overrides/editVmOverrideDialog.html'
               });
            }

            function openRestoreRpTreeDialog(actionEval, availableTargets, context) {
               var modalOptions = {
                  title: i18nService.getString('ClusterUi', 'restore.rp.tree.dialog.title'),
                  subTitle: {
                     objectId: availableTargets[0]
                  },
                  defaultButton: 'submit',
                  size: 'lg',
                  contentTemplate:
                        'cluster-ui/resources/cluster/views/restore_resource_pool_tree/restoreResourcePoolTreeDialog.html',
                  focusTarget: context && context.focusTarget,
                  objectId: availableTargets[0]
               };

               clarityModalService.openOkCancelModal(modalOptions);
            }

            function showAssignLicenseForm(actionEval, availableTargets) {
               if (_.isEmpty(availableTargets)) {
                  return;
               }

               assignLicenseService.showAssignLicenseForm(availableTargets);
            }

            function showMoveToClusterDialog( actionEval, availableTargets) {
               moveClusterToService.showMoveCluster(availableTargets);
            }

            function deleteClusterAndResourcePool(actionEval, availableTargets) {
               if (availableTargets.length === 1) {
                  mutationService.remove(availableTargets[0]);
               } else if (availableTargets.length > 1) {
                  mutationService.removeOnMultiEntity(availableTargets);
               }
            }

            function moveClusterToDrag (actionEval, availableTargets, destinationTarget) {
               if (!availableTargets || !availableTargets.length || !destinationTarget) {
                  return;
               }

               moveClusterToService.moveCluster(destinationTarget.dropTarget, availableTargets);
            }


            h5.actions['vsphere.core.resourcePool.actions.createResourcePool'] = showCreateResourcePoolDialog;
            h5.actions['vsphere.core.resourcePool.actions.editResourcePool'] = showEditResourcePoolDialog;
            h5.actions['vsphere.core.resourcePool.actions.moveTo'] = showMoveToResourcePoolDialog;
            h5.actions['vsphere.core.cluster.actions.create'] = showCreateClusterDialog;
            h5.actions['vsphere.core.cluster.actions.edit'] = showEditClusterDialog;
            h5.actions['vsphere.core.cluster.actions.editDrs'] = showEditDrsDialog;
            h5.actions['vsphere.core.cluster.actions.scheduleDrs'] = showScheduleDrsWizard;
            h5.actions['vsphere.core.cluster.actions.editHa'] = showEditHaDialog;
            h5.actions['vsphere.core.cluster.actions.editProactiveHa'] = showEditProctiveHaDialog;
            h5.actions['vsphere.core.cluster.actions.editEvcMode'] = showEditEvcModeDialog;
            h5.actions['vsphere.core.cluster.actions.settings'] = navigateToClusterSettings;
            h5.actions['vsphere.core.cluster.actions.editDefaultHwVersionAction'] =
                  showEditDefaultVmCompatibilityDialog;
            h5.actions['vsphere.core.cluster.actions.editSwapfileLocationAction'] = showEditSwapfileLocationDialog;
            h5.actions["vsphere.core.cluster.assignLicenseKeyAction"] = showAssignLicenseForm;

               h5.actions['vsphere.core.cluster.actions.group.add'] = showAddGroupDialog;
            h5.actions['vsphere.core.cluster.actions.group.remove'] = removeGroup;
            h5.actions['vsphere.core.cluster.actions.group.members.add'] = showAddGroupMembersDialog;
            h5.actions['vsphere.core.cluster.actions.group.members.remove'] = removeGroupMembers;

            h5.actions['vsphere.core.cluster.actions.rule.add'] = showAddRuleDialog;
            h5.actions['vsphere.core.cluster.actions.rule.remove'] = removeRule;
            h5.actions['vsphere.core.cluster.actions.rule.edit'] = showEditRuleDialog;
            h5.actions['vsphere.core.cluster.actions.rule.members.add'] = showAddRuleMemberDialog;
            h5.actions['vsphere.core.cluster.actions.rule.members.remove'] = showRemoveRuleMemberConfirmationDialog;
            h5.actions['vsphere.core.cluster.actions.rule.members.details'] = showDetailsRuleMembersDialog;

            h5.actions['vsphere.core.cluster.actions.hostOptions.edit'] = showEditHostOptionsDialog;

            h5.actions['vsphere.core.cluster.actions.vmOverride.delete'] = deleteVmOverride;
            h5.actions['vsphere.core.cluster.actions.vmOverride.add'] = showAddVmOverrideDialog;
            h5.actions['vsphere.core.cluster.actions.vmOverride.edit'] = showEditVmOverrideDialog;

            h5.actions['vsphere.core.cluster.actions.restoreRpTree'] = openRestoreRpTreeDialog;
            h5.actions['vsphere.core.rp.actions.delete'] = deleteClusterAndResourcePool;
            h5.actions['vsphere.core.cluster.actions.delete'] = deleteClusterAndResourcePool;
            h5.actions['vsphere.core.cluster.actions.moveTo'] = showMoveToClusterDialog;
            h5.actions["vsphere.core.cluster.actions.moveClusterToDrag"] = moveClusterToDrag;
         }]);

angular.module('com.vmware.vsphere.client.cluster').directive('deviationMeter', function () {
   'use strict';

   return {
      replace: true,
      scope: {
         getCurrentDeviation: '&currentDeviation', // must be a number in [0, 1]
         getTargetDeviation: '&targetDeviation' // must be a number in [0, 1]
      },
      templateUrl: 'cluster-ui/resources/cluster/components/deviationMeter.html',
      link: function(scope) {
         scope.currentDeviation = 0;
         scope.targetDeviation = 0;

         scope.$watch('getCurrentDeviation()', function() {
            scope.currentDeviation = convertDeviation(scope.getCurrentDeviation());
         });

         scope.$watch('getTargetDeviation()', function() {
            scope.targetDeviation = convertDeviation(scope.getTargetDeviation());
         });

         function convertDeviation(deviation) {
            if (typeof deviation !== 'number' || isNaN(deviation) ||
                  deviation < 0 || 1 < deviation) {
               deviation = 0;
            }
            return deviation * 100;
         }
      }
   };
});

angular.module('com.vmware.vsphere.client.cluster')
.directive('resourceConfigControl',
   ['i18nService', 'resourceTypesConstants', 'bytesFilter', 'cpuClockFilter', 'numberFormatterService',
function (i18nService, resourceTypesConstants, bytesFilter, cpuClockFilter, numberFormatterService) {
   'use strict';

   return {
      scope: {
         resourceType: '@',
         resourceAllocationInfo: '=',
         reservationOptions: '=',
         limitOptions: '=',
         unitOptions: '=',
         reservationValueErrorMessages: '=',
         limitValueErrorMessages: '=',
         defaultUnit: '@?',
         expandableReservation: '=',
         reservationUsed: '=',
         actionType: '@',
         hasAutofocus: '@'
      },
      templateUrl: 'cluster-ui/resources/cluster/components/resourceConfigControl.html',
      controller: ['$scope',
         function($scope) {

            var CPU_BASE_MULTIPLIER = 1000;
            var MEM_BASE_MULTIPLIER = 10 * 1024;
            var CPU_RESPOOL_CPUCOUNT = 4;
            var MEM_RESPOOL_MEMCOUNT = 16;

            $scope.i18n = function(key) {
               return i18nService.getString('RpUi', key);
            };
            $scope.expanded = true;
            $scope.currentReservationUnit = {};
            $scope.currentLimitUnit = {};

            var initialMaxReservation = $scope.reservationOptions.maximum.value;
            var isInitialized = false;

            $scope.$watch('reservationOptions.maximum.value', function(newValue) {
               if (newValue !== -1 && !isInitialized) {
                  initialMaxReservation = newValue;
                  isInitialized = true;
               }
               $scope.printReservationMaxLabel();
            });
            $scope.$watch('limitOptions.maximum.value', function() {
               $scope.printLimitMaxLabel();
            });

            $scope.$watch('currentReservationUnit', function() {
               $scope.printReservationMaxLabel();
            });

            $scope.$watch('currentLimitUnit', function() {
               $scope.printLimitMaxLabel();
            });

            $scope.printReservationMaxLabel = function() {
               if (!$scope.currentReservationUnit.multiplier) {
                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.reservationMaxLabel = cpuClockFilter(
                           $scope.reservationOptions.maximum.value,
                           i18nService.getString('RpUi', 'rpCpu.MHz'));
                  } else {
                     $scope.reservationMaxLabel = bytesFilter(
                           $scope.reservationOptions.maximum.value, 'MB', 'MB');
                  }
               } else {
                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.reservationMaxLabel = numberFormatterService.format(
                           $scope.reservationOptions.maximum.value / $scope.currentReservationUnit.multiplier,
                           { suffix: $scope.currentReservationUnit.label });
                  } else {
                     $scope.reservationMaxLabel = bytesFilter(
                           $scope.reservationOptions.maximum.value,
                           'MB',
                           $scope.currentReservationUnit.label);
                  }
               }
            };

            $scope.printLimitMaxLabel = function() {
               if (!$scope.currentLimitUnit.multiplier) {
                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.limitMaxLabel = cpuClockFilter(
                           $scope.limitOptions.maximum.value,
                           i18nService.getString('RpUi', 'rpCpu.MHz'));
                  } else {
                     $scope.limitMaxLabel = bytesFilter(
                           $scope.limitOptions.maximum.value, 'MB', 'MB');
                  }
               } else {
                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.limitMaxLabel = numberFormatterService.format(
                           $scope.limitOptions.maximum.value / $scope.currentLimitUnit.multiplier,
                           { suffix: $scope.currentLimitUnit.label });
                  } else {
                     $scope.limitMaxLabel = bytesFilter(
                           $scope.limitOptions.maximum.value,
                           'MB',
                           $scope.currentLimitUnit.label);
                  }
               }
            };

            $scope.$watch('resourceAllocationInfo.reservation', function(newValue) {
               if (typeof newValue !== "undefined") {
                  if ($scope.actionType !== 'edit') {
                     $scope.limitOptions.minimum.value = newValue;
                  } else {
                     $scope.limitOptions.minimum.value = Math.max(newValue,
                           $scope.limitOptions.current.value);
                  }
                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.limitOptions.minimum.formattedValue = cpuClockFilter(
                           $scope.limitOptions.minimum.value, i18nService.getString(
                                 'RpUi', 'rpCpu.MHz'));
                  } else {
                     $scope.limitOptions.minimum.formattedValue = bytesFilter(
                           $scope.limitOptions.minimum.value, 'MB');
                  }
               }
            });

            $scope.$watch('resourceAllocationInfo.limit', function(newValue) {
               if (typeof newValue !== "undefined" &&
                     newValue >= $scope.limitOptions.minimum.value) {
                  var initialMaxValue = initialMaxReservation;
                  if (newValue <= initialMaxValue && newValue !== -1) {
                     initialMaxValue = newValue;
                  }

                  $scope.reservationOptions.maximum.value = initialMaxValue;

                  if ($scope.resourceType === resourceTypesConstants.CPU) {
                     $scope.reservationOptions.maximum.formattedValue = cpuClockFilter(
                           initialMaxValue, i18nService.getString('RpUi', 'rpCpu.MHz'));
                  } else {
                     $scope.reservationOptions.maximum.formattedValue = bytesFilter(
                           initialMaxValue, 'MB');
                  }

                  $scope.printReservationMaxLabel();
               }
            });

            $scope.$watchGroup(['expandableReservation', 'reservationUsed'], function () {
               if ($scope.expandableReservation !== undefined &&
                     $scope.reservationUsed !== undefined) {
                  $scope.reservationOptions.minimum.value =
                        $scope.expandableReservation ? 0 : $scope.reservationUsed;

                  var formattedValue;
                  if (!$scope.currentReservationUnit.multiplier) {
                     if ($scope.resourceType === resourceTypesConstants.CPU) {
                        formattedValue = cpuClockFilter($scope.reservationOptions.minimum.value,
                              i18nService.getString('RpUi', 'rpCpu.MHz'));
                     } else {
                        formattedValue = bytesFilter($scope.reservationOptions.minimum.value,
                              'MB', $scope.currentReservationUnit.label);
                     }
                  } else {
                     if ($scope.resourceType === resourceTypesConstants.CPU) {
                        formattedValue = numberFormatterService.format(
                              $scope.reservationOptions.minimum.value / $scope.currentReservationUnit.multiplier,
                              { suffix: $scope.currentReservationUnit.label });
                     } else {
                        formattedValue = bytesFilter($scope.reservationOptions.minimum.value,
                              'MB',
                              $scope.currentReservationUnit.label);
                     }
                  }

                  $scope.reservationOptions.minimum.formattedValue = formattedValue;
               }
            });

            $scope.getMultiplier = function() {
               if ($scope.resourceType === resourceTypesConstants.CPU) {
                  return CPU_RESPOOL_CPUCOUNT;
               } else {
                  return MEM_RESPOOL_MEMCOUNT;
               }
            };

            $scope.getDefaultShares = function() {
               if ($scope.resourceType === resourceTypesConstants.CPU) {
                  return CPU_BASE_MULTIPLIER;
               } else {
                  return MEM_BASE_MULTIPLIER;
               }
            };
         }]
   };
}]);

angular.module('com.vmware.vsphere.client.cluster').directive('thresholdBarChart', function() {
   'use strict';

   return {
      replace: true,
      restrict: 'E',
      scope: {
         /**
          * An array of items each representing usage/reservation of a resource.
          * An item has the following format:
          * {
          *    label: <usually the name of the resource which usage and reservation is displayed>
          *    usage: <number>
          *    reservation: <number>
          * }
          */
         getData: '&data',
         /**
          * An array of marker descriptors. Each representing a vertical line and label that go across the whole
          * chart.
          * A marker descriptor has the following format:
          * {
          *    value: <number representing the relative position of the line in the chart>
          *    label: <description of the marker (e.g. "0%", "50%") that is shown below the line>
          *    labelAlign: <specifies the way the text is horizontally aligned relative to the line.
          *       Supported values are: "left", "center", "right">
          * }
          */
         getMarkers: '&markers',
         /**
          * The maximum value that can be displayed by the chart component.
          */
         getMaxValue: '&maxValue',
         /**
          * Parameters for to the additional info sing post popup.
          */
         signPostParams: '='
      },
      templateUrl: 'cluster-ui/resources/cluster/components/thresholdBarChart.html',
      link: function(scope) {
         scope.data = [];
         scope.markers = [];

         scope.$watchGroup(['getData()', 'getMaxValue()'], function() {
            scope.data = normalizeData(scope.getData());
         });

         scope.$watchGroup(['getMarkers()', 'getMaxValue()'] , function() {
            scope.markers = normalizeMarkers(scope.getMarkers());
         });

         function normalizeData(data) {
            if (!data) {
               return [];
            }

            data = data.map(function(item) {
               var result = angular.merge({}, item, {
                  usage: convertValueToPercentage(item.usage),
                  reservation: convertValueToPercentage(item.reservation)
               });

               return result;
            });

            return data;
         }

         function normalizeMarkers(markers) {
            if (!markers) {
               return [];
            }

            markers = markers.map(function(item) {
               var result = angular.merge({}, item, {
                  value: convertValueToPercentage(item.value)
               });

               return result;
            });

            return markers;
         }

         function convertValueToPercentage(value) {
            if (typeof value !== 'number' || isNaN(value) || !isFinite(value) || value < 0) {
               value = 0;
            }

            var maximum = scope.getMaxValue();
            if (typeof maximum !== 'number' || isNaN(maximum) || !isFinite(maximum) || maximum < 0) {
               maximum = 0;
            }

            if (maximum < value) {
               value = maximum;
            }

            if (maximum !== 0) {
               value = value / maximum;
            } else {
               value = 0;
            }

            return value * 100;
         }
      }
   };
});





var cluster_ui;
(function (cluster_ui) {
    var CapacityFormatterService = (function () {
        function CapacityFormatterService(browserLanguage, i18nService) {
            this.browserLanguage = browserLanguage;
            this.i18nService = i18nService;
        }
        CapacityFormatterService.prototype.format = function (value, capacity, percentage) {
            var percentageFormatted = this.formatPercent(percentage);
            return this.i18nService.getString("ClusterUi", "capacityToolTipFormat", value, capacity, percentageFormatted);
        };
        CapacityFormatterService.prototype.formatPercent = function (value) {
            var valueToFormat = value;
            if (!valueToFormat) {
                valueToFormat = 0;
            }
            var locale = this.browserLanguage.get();
            var options = { maximumFractionDigits: 2 };
            var result = valueToFormat.toLocaleString(locale, options);
            return result;
        };
        CapacityFormatterService.$inject = ["browserLanguage", "i18nService"];
        return CapacityFormatterService;
    }());
    cluster_ui.CapacityFormatterService = CapacityFormatterService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("capacityFormatterService", CapacityFormatterService);
})(cluster_ui || (cluster_ui = {}));



/**
 * @name com.vmware.vsphere.client.cluster:clusterConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `clusterConstants` service holds cluster related constants.
 *
 *    List of available constants:
 *
 *    - vmSwapPlacementType (vim.vm.ConfigInfo.SwapPlacementType enum values)
 *       - **`VM_DIRECTORY`** : Store the swap file in the same directory as
 *             the virtual machine
 *       - **`HOST_DATASTORE`** :  Store the swap file in the datastore
 */
angular.module('com.vmware.vsphere.client.cluster').constant('clusterConstants', {
   vmSwapPlacementType : {
      VM_DIRECTORY : 'vmDirectory',
      HOST_DATASTORE : 'hostLocal'
   },
   editClusterErrorCodes : {
      DRS_OFF_WITH_RESOURCE_POOLS: 'DRS_OFF_WITH_RESOURCE_POOLS',
      DPM_ON_WITH_HOSTS_STANDBY: 'DPM_ON_WITH_HOSTS_STANDBY',
      HA_APD_PDL_WITH_FT_VMS: 'HA_APD_PDL_WITH_FT_VMS'
   },
   MAX_INTEGER: 2147483647,
   proactiveHaAutomationLevel: {
      AUTOMATED: 'Automated',
      MANUAL: 'Manual'
   },
   proactiveHaRemediationLevel: {
      QUARANTINE: 'quarantine',
      BALANCED: 'balanced',
      MAINTENANCE: 'maintenance'
   },
   proactiveHaRemediationMode: {
      QUARANTINE_MODE: 'QuarantineMode',
      MAINTENANCE_MODE: 'MaintenanceMode'
   },
   proactiveHaBlockAtTypes: {
      CLUSTER_LEVEL: 'clusterLevel',
      INDIVIDUAL_HOSTS: 'individualHosts'
   },
   memoryUtilizationTypes: {
      ACTIVE: "active",
      CONSUMED: "consumed"
   }
});

/**
 * @name com.vmware.vsphere.client.cluster:clusterGroupsConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `clusterGroupsConstants` service holds cluster groups related constants.
 */
angular.module('com.vmware.vsphere.client.cluster').constant('clusterGroupsConstants', {
   groupType : {
      VM_GROUP : 'com.vmware.vim.binding.vim.cluster.VmGroup',
      HOST_GROUP : 'com.vmware.vim.binding.vim.cluster.HostGroup'
   },

   operationType: {
      ADD: 'add',
      REMOVE: 'remove',
      EDIT: 'edit'
   }
});

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
      .service('clusterGroupsService', clusterGroupsService);

   clusterGroupsService.$inject = ['i18nService', 'dataService', 'clusterGroupsConstants',
      'defaultUriSchemeUtil', 'logService', 'clusterSpecBuilderService', 'mutationService',
      'clarityModalService', 'clusterRulesConstants', 'alertService'];

   function clusterGroupsService(i18nService, dataService, clusterGroupsConstants,
      defaultUriSchemeUtil, logService, clusterSpecBuilderService, mutationService,
      clarityModalService, clusterRulesConstants, alertService) {

      var log = logService('clusterGroupsService');
      var getString = _.bind(i18nService.getString, i18nService, 'ClusterUi');

      return {
         DEFAULT_GROUP_TYPE: clusterGroupsConstants.groupType.VM_GROUP,
         getGroupsData: getGroupsData,
         getRuleGroupsData: getRuleGroupsData,
         getGroupMembers: getGroupMembers,
         getGroupByName: getGroupByName,
         buildTypesOptions: buildTypesOptions,
         buildGroupSpec: buildGroupSpec,
         buildGroupMembersSpec: buildGroupMembersSpec,
         removeGroup: removeGroup,
         removeGroupMembers: removeGroupMembers,
         getSelectedItemsIds: getSelectedItemsIds
      };

      function getGroupsData(clusterId, filterText) {
         var clusterGroupsProperty;
         var options;

         if (filterText) {
            clusterGroupsProperty = 'groupsData';
            options = {
               propertyParams: [{
                  propertyName: 'groupsData',
                  parameterType: 'java.lang.String',
                  parameter: filterText
               }]
            };
         } else {
            clusterGroupsProperty = 'ClusterComputeResource/configurationEx/group';
         }

         return dataService
            .getProperties(clusterId, [clusterGroupsProperty], options)
            .then(function (data) {
               return data ? getGroups(data[clusterGroupsProperty]) : [];
            });
      }

      function getRuleGroupsData(clusterId, rule) {
         var options = { propertyParams: buildGroupsFilterByNameSpec(rule) };

         return dataService.getProperties(clusterId, ['clusterGroups'], options)
            .then(function(data) {
               return data ? getGroups(data['clusterGroups']) : [];
            });
      }

      function getGroupMembers(group) {
         return dataService.getPropertiesForObjects(group.members,
            ['name', 'primaryIconId'])
            .then(function(propsPerObject) {
               return _.map(propsPerObject, function(memberData, id) {
                  return {
                     id: id,
                     name: memberData.name,
                     icon: memberData.primaryIconId
                  };
               });
            });
      }

      function getGroupByName(groups, groupName) {
         var groupRes = null;
         groups.forEach(function(group) {
            if (group.name === groupName) {
               groupRes = group;
            }
         });

         return groupRes;
      }

      function getGroups(groupsData) {
         return _.map(groupsData, function(group) {
            var groupType;
            var groupIcon;
            var members;
            switch (group._type) {
               case clusterGroupsConstants.groupType.VM_GROUP:
                  groupType = getString('groups.list.type.vm');
                  groupIcon = 'vx-icon-vm-drs-group';
                  members = group.vm;
                  break;
               case clusterGroupsConstants.groupType.HOST_GROUP:
                  groupType = getString('groups.list.type.host');
                  groupIcon = 'vx-icon-host-drs-group';
                  members = group.host;
                  break;
            }

            if (!members) {
               members = [];
            }

            return {
               name: group.name,
               type: groupType,
               icon: groupIcon,
               members: members.map(function(memberRef) {
                  return defaultUriSchemeUtil.getVsphereObjectId(memberRef);
               }),
               rawType: group._type
            };
         });
      }

      function buildTypesOptions() {
         return _.map(clusterGroupsConstants.groupType, function(type) {
            var typeLabel = '';
            switch (type) {
               case clusterGroupsConstants.groupType.VM_GROUP:
                  typeLabel = getString('groups.list.type.vm');
                  break;
               case clusterGroupsConstants.groupType.HOST_GROUP:
                  typeLabel = getString('groups.list.type.host');
                  break;
            }
            return {
               id: type,
               label: typeLabel
            };
         });
      }

      function createGroupInstance(groupType, name, members) {
         var groupInfo = {
            name: name
         };

         switch (groupType) {
            case clusterGroupsConstants.groupType.VM_GROUP:
               groupInfo = _.extend({
                   vm: members,
                  _type: clusterGroupsConstants.groupType.VM_GROUP
               }, groupInfo);
               break;
            case clusterGroupsConstants.groupType.HOST_GROUP:
               groupInfo = _.extend({
                   host: members,
                  _type: clusterGroupsConstants.groupType.HOST_GROUP
               }, groupInfo);
               break;
            default:
               log.warn('Unexpected group type: ' + groupType);
         }

         return groupInfo;
      }

      function createGroupSpec(groupInfo, operation) {
         var groupSpec = {
            _type: 'com.vmware.vim.binding.vim.cluster.GroupSpec',
            operation: operation,
            info: groupInfo
         };

         if (clusterGroupsConstants.operationType.REMOVE === operation) {
            groupSpec.removeKey = groupSpec.info.name;
         }
         return groupSpec;
      }

      function buildGroupSpec(groupType, name, groupMembers, operation) {
         var members = [];
         if (groupMembers) {
            members = groupMembers.source;
         }
         var groupInfo = createGroupInstance(groupType, name.trim(), members);

         return createGroupSpec(groupInfo, operation);
      }

      function buildGroupsFilterByNameSpec(rule) {
         var groupNames = [];

         if (rule.type === clusterRulesConstants.ruleType.VM_DEPENDENCY_RULE_TYPE) {
            if (rule.vmDependencyRuleProperties.vmGroup !== null) {
               groupNames.push(rule.vmDependencyRuleProperties.vmGroup);
            }

            if (rule.vmDependencyRuleProperties.dependsOnVmGroup !== null) {
               groupNames.push(rule.vmDependencyRuleProperties.dependsOnVmGroup);
            }
         } else if (rule.type === clusterRulesConstants.ruleType.VM_HOST_GROUP_RULE) {
            if (rule.vmToHostRuleProperties.vmGroupName !== null) {
               groupNames.push(rule.vmToHostRuleProperties.vmGroupName);
            }

            if (rule.vmToHostRuleProperties.hostGroupName !== null) {
               groupNames.push(rule.vmToHostRuleProperties.hostGroupName);
            }
         }

         var filterSpec = [{
            propertyName: 'clusterGroups',
            parameterType:
               'com.vmware.vsphere.client.cluster.groups.GroupsFilterByNameSpec',
            parameter: { names: groupNames }
         }];

         return filterSpec;
      }

      function buildGroupMembersSpec(members){
         return {
            source: members.map(function(member) {
               return defaultUriSchemeUtil.getManagedObjectReference(member);
            })
         };
      }

      function removeGroup(clusterId, groupInfo) {
         var groupSpec = buildGroupSpec(
               groupInfo.rawType,
               groupInfo.name,
               groupInfo.members,
               clusterGroupsConstants.operationType.REMOVE);

         mutationService
               .validate(clusterId, 'com.vmware.vim.binding.vim.cluster.GroupSpec', groupSpec)
               .then(function(validationResult) {
                  var isGroupInUse = !!validationResult &&
                        (validationResult.result || !!validationResult.error);
                  var confirmationText;

                  if (isGroupInUse) {
                     confirmationText = getString(
                           'groups.action.remove.confirmationGroupInUse',
                           groupInfo.name);
                  } else {
                     confirmationText = getString('groups.action.remove.confirmationTextOne');
                  }

                  var alertProperties = {
                     title: getString('groups.action.remove.confirmationTitle'),
                     message: confirmationText,
                     submit: function() {
                        removeGroupFromCluster(clusterId, groupSpec);
                     }
                  };

                  clarityModalService.openConfirmationModal(alertProperties);
               });
      }

      function removeGroupFromCluster(clusterId, groupSpec) {
         var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     {
                        group: groupSpec
                     },
                     true);

         mutationService.apply(
               clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
         );
      }

      function removeGroupMembers(clusterId, groupInfo, membersToRemove) {
         if (groupInfo && groupInfo.members && membersToRemove &&
               groupInfo.members.length === membersToRemove.length) {
            // Cannot delete all members of a group
            alertService.error(
                  getString('groups.members.action.remove.confirmationTitle'),
                  getString('groups.members.action.remove.error.CannotDeleteAllGroupMembers'));
         } else {
            var confirmProperties = {
               title: getString('groups.members.action.remove.confirmationTitle'),
               message: getString('groups.members.action.remove.confirmationTextOne'),
               submit: function() {
                  removeMemberFromGroup(clusterId, groupInfo, membersToRemove);
               }
            };

            clarityModalService.openConfirmationModal(confirmProperties);
         }
      }

      function removeMemberFromGroup(clusterId, groupInfo, membersToRemove) {
         var memberIdsToRemove = _.map(membersToRemove, 'id');
         var newMembers =  _.difference(groupInfo.members, memberIdsToRemove);
         var newMemberRefs = buildGroupMembersSpec(newMembers);

         var groupSpec = buildGroupSpec(
               groupInfo.rawType,
               groupInfo.name,
               newMemberRefs,
               clusterGroupsConstants.operationType.EDIT);

         var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     {group: groupSpec}, true);

         mutationService.apply(
               clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
         );
      }

      function getSelectedItemsIds(items) {
         return items.map(function(item) {
            return item.id;
         });
      }
   }
})();

angular.module('com.vmware.vsphere.client.cluster')
      .constant('clusterHelpConstants', {
         DRS_FAULT_TROUBLESHOOT_GUIDE_ID: "IDH_TSMAIN"
      });

/**
 * @name com.vmware.vsphere.client.cluster:clusterRulesConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `clusterRulesConstants` service holds cluster rules, options and operations
 *    related constants.
 */
angular.module('com.vmware.vsphere.client.cluster').constant('clusterRulesConstants', {
   ruleType : {
      VM_AFFINITY_RULE: 'VM_AFFINITY_RULE_TYPE',
      VM_ANTIAFFINITY_RULE : 'VM_ANTIAFFINITY_RULE_TYPE',
      VM_HOST_GROUP_RULE : 'VM_HOST_GROUP_RULE_TYPE',
      VM_DEPENDENCY_RULE : 'VM_DEPENDENCY_RULE_TYPE'
   },
   optionType: {
      VM_ANTIAFFINITY_RULES: 'das.respectVmVmAntiAffinityRules',
      VM_HOST_AFFINITY_RULES: 'das.respectVmHostSoftAffinityRules'
   },
   ruleSpec: {
      VM_AFFINITY_RULE : 'com.vmware.vim.binding.vim.cluster.AffinityRuleSpec',
      VM_ANTIAFFINITY_RULE : 'com.vmware.vim.binding.vim.cluster.AntiAffinityRuleSpec',
      VM_HOST_GROUP_RULE : 'com.vmware.vim.binding.vim.cluster.VmHostRuleInfo',
      VM_DEPENDENCY_RULE : 'com.vmware.vim.binding.vim.cluster.DependencyRuleInfo'
   },
   operationType: {
      ADD: 'add',
      REMOVE: 'remove',
      EDIT: 'edit'
   },
   affinityRuleMinimumMembers: 2,

   conflictType: {
      AFFINITY_AFFINITY: 'AFFINITY_AFFINITY',
      AFFINITY_ANTIAFFINITY: 'AFFINITY_ANTIAFFINITY',
      ANTIAFFINITY_ANTIAFFINITY: 'ANTIAFFINITY_ANTIAFFINITY'
   }
});

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('clusterRulesService', clusterRulesService);

   clusterRulesService.$inject = ['i18nService', 'dataService', 'mutationService',
      'clusterRulesConstants', 'defaultUriSchemeUtil', 'clarityModalService',
      'clusterSpecBuilderService', 'logService', 'alertService', '$q', '$rootScope'];


   function clusterRulesService(i18nService, dataService, mutationService,
                                clusterRulesConstants, defaultUriSchemeUtil,
                                clarityModalService, clusterSpecBuilderService,
                                logService, alertService, $q) {
      var log = logService('clusterRulesService');

      return {
         DEFAULT_TYPE: clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE,
         getRulesData: getRulesData,
         getAffinityRulesMembersData: getAffinityRulesMembersData,
         getConflictingRulesData: getConflictingRulesData,
         deleteRule: deleteRule,
         getRuleTypes: getRuleTypes,
         buildRuleSpec: buildRuleSpec,
         removeRuleMembers: removeRuleMembers,
         getSpecTypeByRuleType: getSpecTypeByRuleType,
         addRuleMembers: addRuleMembers,
         getVmNames: getVmNames

      };

      function getRulesData(clusterId) {
         var optionProperty = 'ClusterComputeResource/configurationEx/dasConfig/option';
         var haEnabledProperty = 'ClusterComputeResource/configurationEx/dasConfig/enabled';
         return dataService
               .getProperties(clusterId, ['rulesData', optionProperty, haEnabledProperty])
               .then(function (data) {
                  return {
                     rules: data ? getRules(data.rulesData) : [],
                     options: data ? getOptions(data[optionProperty]) : [],
                     haEnabled: data ? (data[haEnabledProperty] || false) : false
                  };
               });
      }

      function getAffinityRulesMembersData(rule) {
         var objectConflicts = {};
         var objectIds = _.map(rule.members, function(member) {
            var objectId = defaultUriSchemeUtil.getVsphereObjectId(member.entity);
            objectConflicts[objectId] = member.conflicts.length;
            return objectId;
         });

         return dataService.getPropertiesForObjects(objectIds,
            ['name', 'primaryIconId'])
            .then(function(propsPerObject) {
               return _.map(propsPerObject, function(memberData, id) {
                  return {
                     id: id,
                     name: memberData.name,
                     icon: memberData.primaryIconId,
                     conflictsCount: objectConflicts[id]
                  };
               });
            });
      }

      function getConflictingRulesData(conflictingRules) {
        return _.map(conflictingRules, function(item) {
            return {
               name: item.rule.name,
               icon: 'vx-icon-rule-conflict'
            };
         });
      }

      function getRules(rulesData) {
         return _.map(rulesData, function(ruleItem) {
            var ruleType;
            switch (ruleItem.ruleType) {
               case clusterRulesConstants.ruleType.VM_AFFINITY_RULE:
                  ruleType = i18nService.getString('ClusterUi',
                        'rules.list.type.vmAffinity');
                  break;
               case clusterRulesConstants.ruleType.VM_ANTIAFFINITY_RULE:
                  ruleType = i18nService.getString('ClusterUi',
                        'rules.list.type.vmAntiAffinity');
                  break;
               case clusterRulesConstants.ruleType.VM_HOST_GROUP_RULE:
                  ruleType = i18nService.getString('ClusterUi',
                        'rules.list.type.vmHostGroup');
                  break;
               case clusterRulesConstants.ruleType.VM_DEPENDENCY_RULE:
                  ruleType = i18nService.getString('ClusterUi',
                        'rules.list.type.vmDependency');
                  break;
            }

            return {
               name: ruleItem.rule.name,
               icon: getRuleIcon(ruleItem),
               type: ruleItem.ruleType,
               key: ruleItem.rule.key,
               typeText: ruleType,
               enabled: ruleItem.rule.enabled,
               userCreated: ruleItem.rule.userCreated,
               members: ruleItem.members,
               conflictingRules: ruleItem.conflictingRules,
               vmToHostRuleProperties: {
                  vmGroupName: ruleItem.rule.vmGroupName,
                  hostGroupName: getRuleHostGroupName(ruleItem.rule),
                  isAffineHostGroupName: isAffineHostGroupName(ruleItem.rule),
                  isMandatory: ruleItem.rule.mandatory
               },
               vmDependencyRuleProperties: {
                  dependsOnVmGroup: ruleItem.rule.dependsOnVmGroup,
                  vmGroup: ruleItem.rule.vmGroup
               }
            };
         });
      }

      function getOptions(optionsData) {
         return _.map(optionsData, function(option) {
            return {
               key: option.key,
               value: option.value
            };
         });
      }

      function getRuleIcon(ruleItem) {
         return ruleItem.conflictingRules.length === 0 ?
            'vx-icon-rule': 'vx-icon-rule-conflict';
      }

      function getRuleHostGroupName(rule) {
         return rule.affineHostGroupName !== null ?
            rule.affineHostGroupName: rule.antiAffineHostGroupName;
      }

      function isAffineHostGroupName(rule) {
         return rule.affineHostGroupName !== undefined &&
               rule.affineHostGroupName !== null;
      }

      function deleteRule(clusterId, ruleInfo) {
         var confirmProperties = {
            title: i18nService.getString('ClusterUi', 'rules.action.remove.confirmationTitle'),
            message: i18nService.getString('ClusterUi', 'rules.action.remove.confirmationTextOne'),
            submit: function () {
               deleteRuleFromCluster(clusterId, ruleInfo.key);
            }
         };

         clarityModalService.openConfirmationModal(confirmProperties);
      }

      function deleteRuleFromCluster(clusterId, ruleKey) {
         var deleteRuleSpec = {
            _type: 'com.vmware.vim.binding.vim.cluster.RuleSpec',
            operation: clusterRulesConstants.operationType.REMOVE,
            removeKey: ruleKey
         };

         var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     { rule: deleteRuleSpec }, true);

         mutationService.apply(
               clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
         );
      }

      function addRuleMembers(clusterId, ruleInfo, membersToAdd /* [{ id: <vm-id> }, ...] */) {
         var ruleMemberIds = _.map(ruleInfo.members, function(member) {
            return defaultUriSchemeUtil.getVsphereObjectId(member.entity);
         });
         var memberIdsToAdd = _.map(membersToAdd, 'id');

         var newMembers = _.union(ruleMemberIds, memberIdsToAdd);
         var newMemberRefs = buildRuleMembersSpec(newMembers);

         var ruleSpec = buildRuleSpec(
            getSpecTypeByRuleType(ruleInfo.type),
            ruleInfo.name,
            ruleInfo.enabled,
            newMemberRefs,
            null,
            clusterRulesConstants.operationType.EDIT,
            ruleInfo.key
         );

         return mutationService.validate(
            clusterId,
            'com.vmware.vim.binding.vim.cluster.RuleSpec',
            ruleSpec
         ).then(function (validationResult) {
            if (!!validationResult && (!!validationResult.result || !!validationResult.error)) {
               if (validationResult.result === 'RULE_CONFLICT_ERROR') {
                  var confirmationDeferred = $q.defer();

                  alertService.okCancel(
                     i18nService.getString('ClusterUi', 'rules.error.ruleConflictsConfirmationTitle'),
                     i18nService.getString('ClusterUi', 'rules.error.ruleConflicts'),
                     function () {
                        confirmationDeferred.resolve();
                     },
                     function () {
                        confirmationDeferred.reject();
                     }
                  );

                  return confirmationDeferred.promise;
               }

               return undefined;
            }
         }).then(function () {
            var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                  {
                     rule: ruleSpec
                  },
                  true
               );

            mutationService.apply(
               clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
            );

            return undefined;
         });
      }

      function removeRuleMembers(clusterId, ruleInfo, membersToRemove) {
         var memberIdsToRemove = _.map(membersToRemove, 'id');
         var ruleMemberIds = _.map(ruleInfo.members, function(member) {
            return defaultUriSchemeUtil.getVsphereObjectId(member.entity);
         });
         var newMembers =  _.difference(ruleMemberIds, memberIdsToRemove);
         var newMemberRefs = buildRuleMembersSpec(newMembers);

         var ruleSpec = buildRuleSpec(getSpecTypeByRuleType(ruleInfo.type), ruleInfo.name,
               ruleInfo.enabled, newMemberRefs, null,
               clusterRulesConstants.operationType.EDIT, ruleInfo.key);

         var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     {rule: ruleSpec}, true);

         mutationService.apply(
               clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
         );
      }

      function buildRuleMembersSpec(members){
         return members.map(function(member) {
            return defaultUriSchemeUtil.getManagedObjectReference(member);
         });
      }

      function getSpecTypeByRuleType(ruleType) {
         var specType = null;
         switch (ruleType) {
            case clusterRulesConstants.ruleType.VM_AFFINITY_RULE:
               specType = clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE;
               break;
            case clusterRulesConstants.ruleType.VM_ANTIAFFINITY_RULE:
               specType = clusterRulesConstants.ruleSpec.VM_ANTIAFFINITY_RULE;
               break;
            case clusterRulesConstants.ruleType.VM_HOST_GROUP_RULE:
               specType = clusterRulesConstants.ruleSpec.VM_HOST_GROUP_RULE;
               break;
            case clusterRulesConstants.ruleType.VM_DEPENDENCY_RULE:
               specType = clusterRulesConstants.ruleSpec.VM_DEPENDENCY_RULE;
               break;
            default:
               log.warn('Unexpected rule type: ' + ruleType);
               break;
         }

         return specType;
      }

      function getRuleTypes(is65VcOrLater) {
         var ruleTypes = [{
            id: clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE,
            label: i18nService.getString('ClusterUi', 'rules.config.type.vmAffinity.name')
         }, {
            id: clusterRulesConstants.ruleSpec.VM_ANTIAFFINITY_RULE,
            label: i18nService.getString('ClusterUi', 'rules.config.type.vmAntiAffinity.name')
         }, {
            id: clusterRulesConstants.ruleSpec.VM_HOST_GROUP_RULE,
            label: i18nService.getString('ClusterUi', 'rules.config.type.vmToHost.name')
         }];

         if (is65VcOrLater) {
            ruleTypes.push({
               id: clusterRulesConstants.ruleSpec.VM_DEPENDENCY_RULE,
               label: i18nService.getString('ClusterUi', 'rules.config.type.vmToVM.name')
            });
         }

         return ruleTypes;
      }

      function createRuleInstance(ruleType, name, enabled, members, ruleProps, key) {
         var ruleInfo = {
            name: name,
            enabled: enabled,
            userCreated: true,
            key: key
         };

         switch (ruleType) {
            case clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE:
            case clusterRulesConstants.ruleSpec.VM_ANTIAFFINITY_RULE:
               ruleInfo = _.extend({
                  vm: members,
                  _type: ruleType
               }, ruleInfo);
               break;
            case clusterRulesConstants.ruleSpec.VM_HOST_GROUP_RULE:
               ruleInfo = _.extend({
                  vmGroupName: ruleProps.vmGroupName,
                  affineHostGroupName:
                        ruleProps.isAffineHostGroupName ? ruleProps.hostGroupName : null,
                  antiAffineHostGroupName:
                        !ruleProps.isAffineHostGroupName ? ruleProps.hostGroupName : null,
                  mandatory: ruleProps.isMandatory,
                  _type: ruleType
               }, ruleInfo);
               break;
            case clusterRulesConstants.ruleSpec.VM_DEPENDENCY_RULE:
               ruleInfo = _.extend({
                  vmGroup: ruleProps.vmGroup,
                  dependsOnVmGroup: ruleProps.dependsOnVmGroup,
                  _type: ruleType
               }, ruleInfo);
               break;
            default:
               log.warn('Unexpected rule type: ' + ruleType);
               break;
         }

         return ruleInfo;
      }

      function createRuleSpec(ruleInfo, operation) {
         var ruleSpec = {
            _type: 'com.vmware.vim.binding.vim.cluster.RuleSpec',
            operation: operation,
            info: ruleInfo
         };

         return ruleSpec;
      }

      function buildRuleSpec(ruleType, name, enabled, ruleMembers, ruleProps,
            operation, ruleKey) {
         var ruleInfo =
               createRuleInstance(ruleType, name.trim(), !!enabled, ruleMembers,
                     ruleProps, ruleKey);

         return createRuleSpec(ruleInfo, operation);
      }

      function getVmNames(vms) {
         var vmsIds = _.map(vms, function(vm) {
            return defaultUriSchemeUtil.getVsphereObjectId(vm.entity);
         });
         return dataService.getPropertiesForObjects(vmsIds, ['name']);
      }
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('clusterSpecBuilderService', clusterSpecBuilderService);

   clusterSpecBuilderService.$inject = ['drsMigrationThresholdService', 'drsConstants',
         'haConstants', 'dpmThresholdService'];

   function clusterSpecBuilderService(drsMigrationThresholdService, drsConstants,
         haConstants, dpmThresholdService) {

      return {
         buildClusterComputeResourceSpec: buildClusterComputeResourceSpec
      };

      /**
       * Builds a ClusterComputeResourceSpec based on the formData specified.
       *
       * @param formData
       * @param modify If true, the spec will be incrementally built.
       * @param hciEnabled flag indicating if HCI should be enabled.
       * @returns The constructed ClusterComputeResourceSpec object
       */
      function buildClusterComputeResourceSpec(formData, modify, hciEnabled) {
         var spec = {
            configSpecEx: {
               _type: 'com.vmware.vim.binding.vim.cluster.ConfigSpecEx',
               drsConfig: {
                  _type: 'com.vmware.vim.binding.vim.cluster.DrsConfigInfo'
               },
               dpmConfig: {
                  _type: 'com.vmware.vim.binding.vim.cluster.DpmConfigInfo'
               }
            },
            modify: modify
         };

         if (!modify || angular.isDefined(formData.clusterName)) {
            spec.name = formData.clusterName;
         }

         if (!modify || angular.isDefined(formData.parent)) {
            spec.parent = formData.parent;
         }

         if (formData.currentEvcMode && angular.isDefined(formData.currentEvcMode.key)) {
            spec.evcModeKey = formData.currentEvcMode.key;
         }

         if (hciEnabled) {
            spec.configSpecEx.inHciWorkflow = !!hciEnabled;
         }

         if (angular.isDefined(formData.vmSwapPlacement)) {
            spec.configSpecEx.vmSwapPlacement = formData.vmSwapPlacement;
         }

         if (angular.isDefined(formData.drsEnabled)) {
            spec.configSpecEx.drsConfig.enabled = !!formData.drsEnabled;
         }

         if (angular.isDefined(formData.drsAutomation)) {
            if (angular.isDefined(formData.drsAutomation.automationLevel)) {
               spec.configSpecEx.drsConfig.defaultVmBehavior = formData.drsAutomation.automationLevel.id;
            }

            if (angular.isDefined(formData.drsAutomation.migrationThreshold)) {
               spec.configSpecEx.drsConfig.vmotionRate = drsMigrationThresholdService
                  .getDrsMigrationRate(formData.drsAutomation.migrationThreshold);
            }

            if (angular.isDefined(formData.drsAutomation.vmAutomation)) {
               spec.configSpecEx.drsConfig.enableVmBehaviorOverrides = !!formData.drsAutomation.vmAutomation;
            }

            if (formData.drsAutomation.is65VcOrLater &&
                  angular.isDefined(formData.drsAutomation.proactiveDrsEnabled)) {
               spec.configSpecEx.proactiveDrsConfig = {
                  _type: 'com.vmware.vim.binding.vim.cluster.ProactiveDrsConfigInfo',
                  enabled: formData.drsAutomation.proactiveDrsEnabled
               };
            }
         }

         if (angular.isDefined(formData.dpmAutomation)) {
            if (angular.isDefined(formData.dpmAutomation.automationLevel)) {
               if (formData.dpmAutomation.automationLevel.id === drsConstants.dpmAutomationLevel.DISABLED) {
                  spec.configSpecEx.dpmConfig.enabled = false;
               } else {
                  spec.configSpecEx.dpmConfig.enabled = true;
                  spec.configSpecEx.dpmConfig.defaultDpmBehavior = formData.dpmAutomation.automationLevel.id;
               }
            }
            if (angular.isDefined(formData.dpmAutomation.dpmThreshold)) {
               var dpmThreshold = dpmThresholdService.reverseDpmRateAndThreshold(
                     formData.dpmAutomation.dpmThreshold);
               spec.configSpecEx.dpmConfig.hostPowerActionRate = dpmThreshold;
            }
         }

         if (angular.isDefined(formData.advancedOptionsBuilder)) {
            spec.configSpecEx.drsConfig.option =
               formData.advancedOptionsBuilder.buildOptions();
         }

         if (angular.isDefined(formData.drsPolicies)) {
            if (formData.drsAutomation.is65VcOrLater && (formData.drsPolicies.evenDistribution ||
                  angular.isDefined(formData.advancedOptionsBuilder))) {
               var evenDistributionValue = formData.drsPolicies.evenDistribution ?
                     drsConstants.drsPolicies.EVEN_DISTRIBUTION_VALUE : null;
               spec.configSpecEx.drsConfig.option = addAdvancedOption(
                     spec.configSpecEx.drsConfig.option,
                     drsConstants.drsPolicies.EVEN_DISTRIBUTION_OPTION,
                     evenDistributionValue);
            }

            if (formData.drsPolicies.cpuOvercommitment ||
                  angular.isDefined(formData.advancedOptionsBuilder)) {
               var cpuOvercommitmentValue = formData.drsPolicies.cpuOvercommitment ?
                     formData.drsPolicies.cpuOvercommitmentValue.toString() : null;
               spec.configSpecEx.drsConfig.option = addAdvancedOption(
                     spec.configSpecEx.drsConfig.option,
                     drsConstants.drsPolicies.CPU_OVERCOMMITMENT_OPTION,
                     cpuOvercommitmentValue);
            }
         }

         if (angular.isDefined(formData.haEnabled)) {
            spec.configSpecEx.dasConfig = {
               _type: 'com.vmware.vim.binding.vim.cluster.DasConfigInfo',
               enabled: !!formData.haEnabled
            };

            if (angular.isDefined(formData.haConfiguration)) {
               var haConfiguration = formData.haConfiguration;

               if (angular.isDefined(haConfiguration.defaultVmSettings)) {
                  spec.configSpecEx.dasConfig.defaultVmSettings = {
                     _type: 'com.vmware.vim.binding.vim.cluster.DasVmSettings'
                  };

                  if (angular.isDefined(haConfiguration.defaultVmSettings.isolationResponse)) {
                     spec.configSpecEx.dasConfig.defaultVmSettings.isolationResponse =
                        haConfiguration.defaultVmSettings.isolationResponse;
                  }

                  if (angular.isDefined(haConfiguration.defaultVmSettings.restartPriority)) {
                     spec.configSpecEx.dasConfig.defaultVmSettings.restartPriority =
                           haConfiguration.defaultVmSettings.restartPriority;
                  }

                  if (formData.is65VcOrLater &&
                        angular.isDefined(haConfiguration.defaultVmSettings.restartPriorityTimeout)) {
                     spec.configSpecEx.dasConfig.defaultVmSettings.restartPriorityTimeout =
                           haConfiguration.defaultVmSettings.restartPriorityTimeout;
                  }

                  if (angular.isDefined(haConfiguration.
                        defaultVmSettings.vmToolsMonitoringSettings)) {
                     spec.configSpecEx.dasConfig.
                           defaultVmSettings.vmToolsMonitoringSettings = {
                        _type: 'com.vmware.vim.binding.vim.cluster.VmToolsMonitoringSettings'
                     };

                     var vmToolsMonitoringSettings = haConfiguration.
                           defaultVmSettings.vmToolsMonitoringSettings;

                     if (angular.isDefined(
                           vmToolsMonitoringSettings.vmToolsMonitorFailureInt)) {
                        spec.configSpecEx.dasConfig.defaultVmSettings.
                           vmToolsMonitoringSettings.failureInterval =
                           vmToolsMonitoringSettings.vmToolsMonitorFailureInt;
                     }

                     if (angular.isDefined(
                           vmToolsMonitoringSettings.vmToolsMonitorMinUpTime)) {
                        spec.configSpecEx.dasConfig.defaultVmSettings.
                           vmToolsMonitoringSettings.minUpTime =
                           vmToolsMonitoringSettings.vmToolsMonitorMinUpTime;
                     }

                     if (angular.isDefined(
                           vmToolsMonitoringSettings.vmToolsMonitorMaxFailures)) {
                        spec.configSpecEx.dasConfig.defaultVmSettings.
                           vmToolsMonitoringSettings.maxFailures =
                           vmToolsMonitoringSettings.vmToolsMonitorMaxFailures;
                     }

                     if (angular.isDefined(
                        vmToolsMonitoringSettings.vmToolsMonitorMaxFailureWindow)) {
                        if (vmToolsMonitoringSettings.vmToolsMonitorHasFailureWindow) {
                           //convert to seconds
                           spec.configSpecEx.dasConfig.defaultVmSettings.
                              vmToolsMonitoringSettings.maxFailureWindow =
                              vmToolsMonitoringSettings.
                                 vmToolsMonitorMaxFailureWindow * 3600;
                        } else {
                           spec.configSpecEx.dasConfig.defaultVmSettings.
                              vmToolsMonitoringSettings.maxFailureWindow =
                              haConstants.vmMonitoringSensitivity.
                                 NO_FAILURE_WINDOW;
                        }
                     }
                  }
               }

               if (angular.isDefined(haConfiguration.admissionControlEnabled)) {
                  spec.configSpecEx.dasConfig.admissionControlEnabled =
                     !!haConfiguration.admissionControlEnabled;
               }

               if (angular.isDefined(haConfiguration.hostMonitoringEnabled)) {
                  spec.configSpecEx.dasConfig.hostMonitoring =
                     !!haConfiguration.hostMonitoringEnabled ?
                        haConstants.hostMonitoringState.ENABLED :
                        haConstants.hostMonitoringState.DISABLED;
               }

               if (angular.isDefined(haConfiguration.vmMonitoringState)) {
                  spec.configSpecEx.dasConfig.vmMonitoring =
                     haConfiguration.vmMonitoringState;
               }

               if (angular.isDefined(haConfiguration.admissionControl)) {
                  if(haConfiguration.admissionControl.policy._type ===
                        haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE){
                     spec.configSpecEx.dasConfig.admissionControlPolicy = {
                        _type: haConfiguration.admissionControl.policy._type
                     };
                  } else {
                     spec.configSpecEx.dasConfig.admissionControlPolicy = {
                        _type: haConfiguration.admissionControl.policy._type,
                        failoverLevel: haConfiguration.admissionControl.policy.failoverLevel
                     };
                  }
               }

               if (angular.isDefined(haConfiguration.vmcpSettings)) {
                  var dasConfigSpec = spec.configSpecEx.dasConfig;
                  if (!dasConfigSpec.defaultVmSettings) {
                     dasConfigSpec.defaultVmSettings = {
                        _type: 'com.vmware.vim.binding.vim.cluster.DasVmSettings'
                     };
                  }

                  // Do not change the current VMCP behaviour unless needed.
                  var vmcpShouldBeEnabled = haConfiguration.vmcpEnabled;

                  if (angular.isDefined(haConfiguration.vmcpSettings.apdResponse)) {
                     if (haConfiguration.vmcpSettings.apdResponse !== haConstants.storageVmReaction.DISABLED) {
                        vmcpShouldBeEnabled = true;
                     }

                     if (!dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings) {
                        dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings = {
                           _type: 'com.vmware.vim.binding.vim.cluster.VmComponentProtectionSettings'
                        };
                     }
                     dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings.vmStorageProtectionForAPD =
                        haConfiguration.vmcpSettings.apdResponse;
                  }

                  if (angular.isDefined(haConfiguration.vmcpSettings.pdlResponse)) {
                     if (haConfiguration.vmcpSettings.pdlResponse !== haConstants.storageVmReaction.DISABLED) {
                        vmcpShouldBeEnabled = true;
                     }

                     if (!dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings) {
                        dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings = {
                           _type: 'com.vmware.vim.binding.vim.cluster.VmComponentProtectionSettings'
                        };
                     }
                     dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings.vmStorageProtectionForPDL =
                           haConfiguration.vmcpSettings.pdlResponse;
                  }

                  if (vmcpShouldBeEnabled) {
                     dasConfigSpec.vmComponentProtecting = haConstants.serviceState.ENABLED;
                  } else {
                     dasConfigSpec.vmComponentProtecting = haConstants.serviceState.DISABLED;
                  }

                  var vmReactionOnAPDCleared = haConfiguration.vmcpSettings
                     .vmReactionOnAPDCleared;
                  if (angular.isDefined(vmReactionOnAPDCleared)) {
                     if (!dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings) {
                        dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings = {
                           _type: 'com.vmware.vim.binding.vim.cluster.VmComponentProtectionSettings'
                        };
                     }
                     dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings
                        .vmReactionOnAPDCleared = vmReactionOnAPDCleared;
                  }

                  var apdRecoveryDelayMinutes = haConfiguration.vmcpSettings
                     .apdRecoveryDelayMinutes;
                  if (angular.isDefined(apdRecoveryDelayMinutes)) {
                     if (!dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings) {
                        dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings = {
                           _type: 'com.vmware.vim.binding.vim.cluster.VmComponentProtectionSettings'
                        };
                     }
                     dasConfigSpec.defaultVmSettings.vmComponentProtectionSettings
                        .vmTerminateDelayForAPDSec =
                           apdRecoveryDelayMinutes * haConstants.SECONDS_IN_A_MINUTE;
                  }
               }
            }

            if (angular.isDefined(formData.hbDatastoreCandidatePolicy)) {
               var hbDsPolicy =
                     formData.hbDatastoreCandidatePolicy;

               spec.configSpecEx.dasConfig.hBDatastoreCandidatePolicy = hbDsPolicy;

               var preferredHbDatastores = [];
               var isHbDsCandidatesDefined = angular.isDefined(
                     formData.hbDatastoreCandidates);

               if (hbDsPolicy !== haConstants.hbDatastoreCandidatePolicy.AUTO_SELECT &&
                     isHbDsCandidatesDefined) {
                  var hbDsCandidates = formData.hbDatastoreCandidates ?
                        formData.hbDatastoreCandidates : [];
                  for(var i = 0; i < hbDsCandidates.length; i++) {
                     if(hbDsCandidates[i].isPreferred){
                        preferredHbDatastores.push(hbDsCandidates[i].provider);
                     }
                  }

                  spec.configSpecEx.dasConfig.heartbeatDatastore = preferredHbDatastores;
               }
            }

            if (angular.isDefined(formData.haAdvancedOptionsBuilder)) {
               spec.configSpecEx.dasConfig.option =
                     formData.haAdvancedOptionsBuilder.buildOptions();
            }

            if(angular.isDefined(formData.admissionControlPolicy)) {
               spec.configSpecEx.dasConfig.admissionControlEnabled =
                     formData.admissionControlPolicy.type !==
                     haConstants.admissionControlPolicy.DISABLED_TYPE;

               if (spec.configSpecEx.dasConfig.admissionControlEnabled) {
                  switch (formData.admissionControlPolicy.type) {
                     case haConstants.admissionControlPolicy.FAILOVER_LEVEL_TYPE:
                        spec.configSpecEx.dasConfig.admissionControlPolicy = {
                           _type: haConstants.admissionControlPolicy.FAILOVER_LEVEL_TYPE,
                           failoverLevel: formData.failoverLevel
                        };
                        //don't send slotPolicy if cover all vm slot policy is selected
                        if (formData.slotSizePolicy === haConstants.slotSizePolicy.FIXED_SIZE) {
                           spec.configSpecEx.dasConfig.admissionControlPolicy.slotPolicy = {
                              _type: 'com.vmware.vim.binding.vim.cluster.FixedSizeSlotPolicy',
                              cpu: formData.fixedSlotSizeCpu,
                              memory: formData.fixedSlotSizeMemory
                           };
                        }
                        break;
                     case haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE:
                        spec.configSpecEx.dasConfig.admissionControlPolicy = {
                           _type: haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE,
                           cpuFailoverResourcesPercent: formData.cpuFailoverPercent,
                           memoryFailoverResourcesPercent: formData.memoryFailoverPercent
                        };
                        if (formData.is65VcOrLater) {
                           spec.configSpecEx.dasConfig.admissionControlPolicy.autoComputePercentages =
                                 formData.autoComputePercentages;
                        }
                        break;
                     case haConstants.admissionControlPolicy.FAILOVER_HOSTS_TYPE:
                        var failoverHosts = _.map(formData.failoverHosts,
                              function(failoverHost) {
                                 return failoverHost.provider;
                              });

                        spec.configSpecEx.dasConfig.admissionControlPolicy = {
                           _type: haConstants.admissionControlPolicy.FAILOVER_HOSTS_TYPE,
                           failoverHosts: failoverHosts
                        };
                        break;
                  }
                  //add failoverLevel if cluster is in 6.5 or above VC
                  if (formData.is65VcOrLater) {
                     spec.configSpecEx.dasConfig.admissionControlPolicy.failoverLevel =
                           formData.failoverLevel;
                     spec.configSpecEx.dasConfig.admissionControlPolicy
                           .resourceReductionToToleratePercent =
                           formData.resourceReductionToToleratePercent;
                  }
               }
            }
         }

         if (angular.isDefined(formData.vsanEnabled)) {
            spec.configSpecEx.vsanConfig = {
               _type: 'com.vmware.vim.binding.vim.vsan.cluster.ConfigInfo',
               enabled: formData.vsanEnabled
            };
         }

         //add orchestration if cluster is in 6.5 or above VC
         if (formData.is65VcOrLater && angular.isDefined(formData.orchestration)) {
            spec.configSpecEx.orchestration = {
               _type: 'com.vmware.vim.binding.vim.cluster.OrchestrationInfo'
            };

            if (angular.isDefined(formData.orchestration.defaultVmReadiness)) {
               spec.configSpecEx.orchestration.defaultVmReadiness = {
                  _type: 'com.vmware.vim.binding.vim.cluster.VmReadiness'
               };

               spec.configSpecEx.orchestration.defaultVmReadiness.postReadyDelay =
                     formData.orchestration.defaultVmReadiness.postReadyDelay;
               spec.configSpecEx.orchestration.defaultVmReadiness.readyCondition =
                     formData.orchestration.defaultVmReadiness.readyCondition;
            }
         }

         if (angular.isDefined(formData.group) && angular.isDefined(formData.group.info)) {
            spec.configSpecEx.groupSpec = [formData.group];
         }

         if (angular.isDefined(formData.rule)) {
            spec.configSpecEx.rulesSpec = [formData.rule];
         }

         if (angular.isDefined(formData.dasVmOverride)) {
            spec.configSpecEx.dasVmConfigSpec = formData.dasVmOverride;
         }

         if (angular.isDefined(formData.drsVmOverride)) {
            spec.configSpecEx.drsVmConfigSpec = formData.drsVmOverride;
         }

         if (angular.isDefined(formData.orchestrationVmOverride)) {
            spec.configSpecEx.vmOrchestrationSpec = formData.orchestrationVmOverride;
         }

         if (angular.isDefined(formData.infraUpdateHaConfig)) {
            spec.configSpecEx.infraUpdateHaConfig = formData.infraUpdateHaConfig;
            _.extend(spec.configSpecEx.infraUpdateHaConfig, {
               _type: "com.vmware.vim.binding.vim.cluster.InfraUpdateHaConfigInfo"
            });
         }

         return spec;
      }

      function addAdvancedOption(currentOptions, advancedOptionKey, advancedOptionValue) {
         if (currentOptions === undefined) {
            currentOptions = [];
         }

         currentOptions = _.reject(currentOptions, function(advancedOption) {
            return advancedOption.key === advancedOptionKey;
         });

         currentOptions.push({
            _type: "com.vmware.vim.binding.vim.option.OptionValue",
            key: advancedOptionKey,
            value: advancedOptionValue
         });

         return currentOptions;
      }
   }
})();

(function () {
   'use strict';

   /**
    * Service that provides swap file location related information.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('clusterSwapFileLocationService', clusterSwapFileLocationService);

   clusterSwapFileLocationService.$inject = ['clusterConstants', 'i18nService',
      'dataService'];

   function clusterSwapFileLocationService(clusterConstants, i18nService, dataService) {
      return {
         WARNING: getString('general.config.swapPlacementType.hostLocal.warning'),
         getVmDirectoryData: getVmDirectoryData,
         getHostDatastoreData: getHostDatastoreData,
         getSwapFilePlacement: getSwapFilePlacement,
         getVmSwapFileLocation: getVmSwapFileLocation
      };

      /**
       * Retrieves text data pertaining to the Virtual Machine directory ('vmDirectory')
       * placement option.
       *
       * @returns {{id: string, label: *, description: *}}
       */
      function getVmDirectoryData() {
         return {
            id: clusterConstants.vmSwapPlacementType.VM_DIRECTORY,
            label: getString('general.config.swapPlacementType.vmDirectory'),
            description:
               getString('general.config.swapPlacementType.vmDirectory.description')
         };
      }

      /**
       * Returns text data pertaining to the Host Datastore ('hostLocal') placement
       * option.
       *
       * @returns {{id: string, label: *, description: *}}
       */
      function getHostDatastoreData() {
         return {
            id: clusterConstants.vmSwapPlacementType.HOST_DATASTORE,
            label: getString('general.config.swapPlacementType.hostLocal'),
            description:
               getString('general.config.swapPlacementType.hostLocal.description')
         };
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      /**
       * Retrieves the current vm swap placement from the data service wrapped in a
       * promise.
       *
       * @param objectId
       * @returns {*}
       */
      function getSwapFilePlacement(objectId) {
         return dataService.getData(objectId,
            'com.vmware.vsphere.client.clusterui.model.GeneralConfigData')
            .then(function (configData) {
               return configData.vmSwapPlacement;
            });
      }

      /**
       * Retrieves the text label for the specified vm swap placement.
       *
       * @param vmSwapPlacement
       * @returns {*}
       */
      function getVmSwapFileLocation(vmSwapPlacement) {
         if (vmSwapPlacement === clusterConstants.vmSwapPlacementType.VM_DIRECTORY) {
            return i18nService.getString('ClusterUi',
               'general.config.swapPlacementType.vmDirectory');
         } else if (vmSwapPlacement === clusterConstants.vmSwapPlacementType.HOST_DATASTORE) {
            return i18nService.getString('ClusterUi',
               'general.config.swapPlacementType.hostLocal');
         }
         return '';
      }
   }
}());

var cluster_ui;
(function (cluster_ui) {
    var ClusterUtilizationService = (function () {
        function ClusterUtilizationService(vxPropertyViewService, i18nService, capacityFormatterService) {
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18nService = i18nService;
            this.capacityFormatterService = capacityFormatterService;
        }
        ClusterUtilizationService.prototype.buildCpuPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "consumed"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.cpuConsumedFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "active"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-blue")
                .exit()
                .valueBuilder()
                .text(data.cpuActiveFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity"))
                .exit()
                .valueBuilder()
                .text(data.cpuCapacityFormatted);
            return builder.build();
        };
        ClusterUtilizationService.prototype.buildMemoryPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "consumed"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.memoryConsumedFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "overhead"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-desaturated-blue")
                .exit()
                .valueBuilder()
                .text(data.memoryOverheadFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity"))
                .exit()
                .valueBuilder()
                .text(data.memoryCapacityFormatted);
            return builder.build();
        };
        ClusterUtilizationService.prototype.buildGuestMemoryPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "activeGuestMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-green")
                .exit()
                .valueBuilder()
                .text(data.activeGuestMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "privateMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-green")
                .exit()
                .valueBuilder()
                .text(data.privateMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "sharedMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-dark-blue")
                .exit()
                .valueBuilder()
                .text(data.sharedMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "compressedMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-blue")
                .exit()
                .valueBuilder()
                .text(data.compressedMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "swappedMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-orange")
                .exit()
                .valueBuilder()
                .text(data.swappedMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "balloonedMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-yellow")
                .exit()
                .valueBuilder()
                .text(data.balloonedMemoryFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "unaccessedMemory"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-gray")
                .exit()
                .valueBuilder()
                .text(data.unaccessedMemoryFormatted);
            return builder.build();
        };
        ClusterUtilizationService.prototype.buildLimitReservationSection = function (sectionBuilder, data) {
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "reservation"))
                .icon("vx-property-view-key-legend-icon vm-utilization-reservation-arrow-icon")
                .exit()
                .valueBuilder()
                .text(data.reservation);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "limit"))
                .icon("vx-property-view-key-legend-icon vm-utilization-limit-arrow-icon")
                .exit()
                .valueBuilder()
                .text(data.limit);
        };
        ClusterUtilizationService.prototype.buildSharesWorstCaseAllocationSection = function (sectionBuilder, data) {
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "shares"))
                .exit()
                .valueBuilder()
                .text(data.sharesInfo);
            if (data.clusterDrsEnabled) {
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "worstCaseAllocation"))
                    .icon("vx-property-view-key-legend-icon vm-utilization-worst-case-allocation-arrow-icon")
                    .exit()
                    .valueBuilder()
                    .text(data.staticEntitlement);
            }
        };
        ClusterUtilizationService.prototype.buildVmMemoryPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "vmConsumed"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.consummation);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "vmOverheadConsumed"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-desaturated-blue")
                .exit()
                .valueBuilder()
                .text(data.overheadMemory);
            this.buildLimitReservationSection(sectionBuilder, data);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "configuredMemory"))
                .exit()
                .valueBuilder()
                .text(data.resourceSize);
            this.buildSharesWorstCaseAllocationSection(sectionBuilder, data);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "overheadReservation"))
                .exit()
                .valueBuilder()
                .text(data.overheadAllocation);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "vmUsedReservation"))
                .exit()
                .valueBuilder()
                .text(data.usedReservation);
            return builder.build();
        };
        ClusterUtilizationService.prototype.buildResourcePoolMemoryPropertyViewData = function (data) {
            var isResourcePoolObject = data.provider && data.provider.type === "ResourcePool";
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            var consumedLabel = this.i18nService.getString("ClusterUi", "vAppConsumed");
            var overheadLabel = this.i18nService.getString("ClusterUi", "vAppOverheadConsumed");
            if (isResourcePoolObject) {
                consumedLabel = this.i18nService.getString("ClusterUi", "consumed");
                overheadLabel = this.i18nService.getString("ClusterUi", "overhead");
            }
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(consumedLabel)
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.consummation);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(overheadLabel)
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-desaturated-blue")
                .exit()
                .valueBuilder()
                .text(data.overheadMemory);
            this.buildLimitReservationSection(sectionBuilder, data);
            if (isResourcePoolObject) {
                var ownerCapacityLabel = this.i18nService.getString("ClusterUi", "hostCapacity");
                if (data.parentCluster) {
                    ownerCapacityLabel = this.i18nService.getString("ClusterUi", "clusterCapacity");
                }
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(ownerCapacityLabel)
                    .exit()
                    .valueBuilder()
                    .text(data.ownerCapacity);
            }
            this.buildSharesWorstCaseAllocationSection(sectionBuilder, data);
            return builder.build();
        };
        ClusterUtilizationService.prototype.buildResourcePoolCpuPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "consumed"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.consummation);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "active"))
                .icon("vx-property-view-key-legend-icon cluster-utilization-icon-color-normal-blue")
                .exit()
                .valueBuilder()
                .text(data.overallCpuDemand);
            this.buildLimitReservationSection(sectionBuilder, data);
            this.buildSharesWorstCaseAllocationSection(sectionBuilder, data);
            return builder.build();
        };
        ClusterUtilizationService.prototype.getCpuMetersData = function (data) {
            return [{
                    colorClass: "cluster-utilization-light-blue",
                    value: data.cpuConsumedPercentage,
                    label: this.capacityFormatterService.format(data.cpuConsumedFormatted, data.cpuCapacityFormatted, data.cpuConsumedPercentage)
                }, {
                    colorClass: "cluster-utilization-normal-blue",
                    value: data.cpuActivePercentage,
                    label: this.capacityFormatterService.format(data.cpuActiveFormatted, data.cpuCapacityFormatted, data.cpuActivePercentage)
                }];
        };
        ClusterUtilizationService.prototype.getMemoryMetersData = function (data) {
            return [{
                    colorClass: "cluster-utilization-light-blue",
                    value: data.memoryConsumedPercentage,
                    label: this.capacityFormatterService.format(data.memoryConsumedFormatted, data.memoryCapacityFormatted, data.memoryConsumedPercentage)
                }, {
                    colorClass: "cluster-utilization-desaturated-blue",
                    value: data.memoryOverheadPercentage,
                    label: this.capacityFormatterService.format(data.memoryOverheadFormatted, data.memoryCapacityFormatted, data.memoryOverheadPercentage)
                }];
        };
        ClusterUtilizationService.prototype.getGuestMemoryMetersData = function (data) {
            return [{
                    colorClass: "cluster-utilization-light-green",
                    value: data.activeGuestMemoryPercentage,
                    label: this.capacityFormatterService.format(data.activeGuestMemoryFormatted, data.guestMemorySizeFormatted, data.activeGuestMemoryPercentage)
                }];
        };
        ClusterUtilizationService.prototype.getGuestMemoryGroupedMetersData = function (data) {
            return [{
                    colorClass: "cluster-utilization-normal-green",
                    value: data.privateMemoryPercentage,
                    label: ""
                }, {
                    colorClass: "cluster-utilization-dark-blue",
                    value: data.sharedMemoryPercentage,
                    label: ""
                }, {
                    colorClass: "cluster-utilization-normal-blue",
                    value: data.compressedMemoryPercentage,
                    label: ""
                }, {
                    colorClass: "cluster-utilization-normal-orange",
                    value: data.swappedMemoryPercentage,
                    label: ""
                }, {
                    colorClass: "cluster-utilization-normal-yellow",
                    value: data.balloonedMemoryPercentage,
                    label: ""
                }, {
                    colorClass: "cluster-utilization-normal-gray",
                    value: data.unaccessedMemoryPercentage,
                    label: ""
                }];
        };
        ClusterUtilizationService.prototype.getMemoryConsumedMetersData = function (data) {
            return [{
                    colorClass: "cluster-utilization-light-blue",
                    value: data.consumedMemoryPercentage,
                    label: this.capacityFormatterService.format(data.consummation, data.maxValue, data.consumedMemoryPercentage)
                }, {
                    colorClass: "cluster-utilization-desaturated-blue",
                    value: data.overheadConsumedMemoryPercentage,
                    label: this.capacityFormatterService.format(data.overheadMemory, data.maxValue, data.overheadConsumedMemoryPercentage)
                }];
        };
        ClusterUtilizationService.prototype.getUtilizationPointersData = function (data) {
            var pointers = [{
                    colorClass: "cluster-utilization-icon-color-normal-black",
                    value: data.reservationPercentage,
                    icon: "vm-utilization-reservation-arrow-icon"
                }];
            if (data.clusterDrsEnabled) {
                pointers.push({
                    colorClass: "cluster-utilization-icon-color-normal-orange ",
                    value: data.worstCaseAllocationPercentage,
                    icon: "vm-utilization-worst-case-allocation-arrow-icon"
                });
            }
            if (data.limitPercentage !== null) {
                pointers.push({
                    colorClass: "cluster-utilization-icon-color-normal-black",
                    value: data.limitPercentage,
                    icon: "vm-utilization-limit-arrow-icon"
                });
            }
            return pointers;
        };
        ClusterUtilizationService.$inject = ["vxPropertyViewService",
            "i18nService", "capacityFormatterService"];
        return ClusterUtilizationService;
    }());
    cluster_ui.ClusterUtilizationService = ClusterUtilizationService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("clusterUtilizationService", ClusterUtilizationService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var AddClusterVmOverridesManager = (function () {
        function AddClusterVmOverridesManager() {
        }
        AddClusterVmOverridesManager.prototype.setClusterId = function (clusterId) {
            this.clusterId = clusterId;
        };
        AddClusterVmOverridesManager.prototype.getClusterId = function () {
            return this.clusterId;
        };
        AddClusterVmOverridesManager.prototype.setClusterName = function (clusterName) {
            this.clusterName = clusterName;
        };
        AddClusterVmOverridesManager.prototype.getClusterName = function () {
            return this.clusterName;
        };
        AddClusterVmOverridesManager.prototype.setSelectedVms = function (selectedVms) {
            this.selectedVms = selectedVms;
        };
        AddClusterVmOverridesManager.prototype.getSelectedVms = function () {
            return this.selectedVms;
        };
        AddClusterVmOverridesManager.prototype.setVmSettingsSpec = function (vmSettingsSpec) {
            this.vmSettingsSpec = vmSettingsSpec;
        };
        AddClusterVmOverridesManager.prototype.getVmSettingsSpec = function () {
            return this.vmSettingsSpec;
        };
        AddClusterVmOverridesManager.prototype.setSelectedVmsSpec = function (selectedVmsSpec) {
            this.selectedVmsSpec = selectedVmsSpec;
        };
        AddClusterVmOverridesManager.prototype.getSelectedVmsSpec = function () {
            return this.selectedVmsSpec;
        };
        return AddClusterVmOverridesManager;
    }());
    cluster_ui.AddClusterVmOverridesManager = AddClusterVmOverridesManager;
    angular.module("com.vmware.vsphere.client.cluster")
        .factory("AddClusterVmOverridesManager", [
        function () {
            return Function.prototype.bind.apply(AddClusterVmOverridesManager, [undefined]);
        }
    ]);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var AddClusterVmOverridesWizardService = (function () {
        function AddClusterVmOverridesWizardService($rootScope, dataService, vuiClusterAddVmOverridesWizard, clusterVmOverridesPageService) {
            this.$rootScope = $rootScope;
            this.dataService = dataService;
            this.vuiClusterAddVmOverridesWizard = vuiClusterAddVmOverridesWizard;
            this.clusterVmOverridesPageService = clusterVmOverridesPageService;
        }
        AddClusterVmOverridesWizardService.prototype.invokeWizard = function (targetUid, manager, focusTarget) {
            var _this = this;
            manager.setClusterId(targetUid);
            manager.setSelectedVms([]);
            this.wizardScope = this.$rootScope.$new();
            var pages = this.createWizardPages(this.wizardScope);
            this.dataService.getProperties(targetUid, ['name'])
                .then(function (response) {
                if (response && response.name) {
                    var clusterName = response.name;
                    manager.setClusterName(clusterName);
                    _this.vuiClusterAddVmOverridesWizard.show(pages, _this.wizardScope, manager, focusTarget);
                }
            });
        };
        AddClusterVmOverridesWizardService.prototype.createWizardPages = function (wizardScope) {
            var pages = [];
            pages.push(this.clusterVmOverridesPageService.buildSelectVmsPage(wizardScope));
            pages.push(this.clusterVmOverridesPageService.buildAddVmOverridesPage(wizardScope));
            return pages;
        };
        AddClusterVmOverridesWizardService.$inject = ["$rootScope", "dataService", "vuiClusterAddVmOverridesWizard", "clusterVmOverridesPageService"];
        return AddClusterVmOverridesWizardService;
    }());
    cluster_ui.AddClusterVmOverridesWizardService = AddClusterVmOverridesWizardService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("addClusterVmOverridesWizardService", AddClusterVmOverridesWizardService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterConfigVmOverrideService = (function () {
        function ClusterConfigVmOverrideService(i18nService, clusterVmOverridesConstants, drsConstants, drsAutomationLevelService, addClusterVmOverridesWizardService, AddClusterVmOverridesManager) {
            this.i18nService = i18nService;
            this.clusterVmOverridesConstants = clusterVmOverridesConstants;
            this.drsConstants = drsConstants;
            this.drsAutomationLevelService = drsAutomationLevelService;
            this.addClusterVmOverridesWizardService = addClusterVmOverridesWizardService;
            this.AddClusterVmOverridesManager = AddClusterVmOverridesManager;
        }
        ClusterConfigVmOverrideService.prototype.openAddVmOverrideWizard = function (targetUid, focusTarget) {
            var manager = new this.AddClusterVmOverridesManager();
            this.addClusterVmOverridesWizardService.invokeWizard(targetUid, manager, focusTarget);
        };
        ClusterConfigVmOverrideService.prototype.getGridOptions = function () {
            var options = {
                actionBarOptions: {
                    actions: []
                },
                pageConfig: {
                    hidePager: true
                },
                searchable: false,
                resizable: false,
                data: [],
                columnDefs: this.getAllColumnDefs(),
                height: "100%"
            };
            return options;
        };
        ClusterConfigVmOverrideService.prototype.getDrsAutomationLevels = function () {
            return [{
                    id: this.drsConstants.AUTOMATION_LEVEL_DISABLED,
                    label: this.i18nService.getString("ClusterUi", "vm.overrides.DRS.behavior.disabled")
                }].concat(this.drsAutomationLevelService.getLevels());
        };
        ClusterConfigVmOverrideService.prototype.isClusterDefault = function (propertyValue) {
            return propertyValue === this.clusterVmOverridesConstants.CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.OVERRIDE_NA ||
                propertyValue === this.clusterVmOverridesConstants.RESTART_PRIORITY_CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.ISOLATION_RESPONSE_CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.RESPONSE_RECOVERY_CLUSTER_DEFAULT;
        };
        ClusterConfigVmOverrideService.prototype.getTooltipParams = function (vmValues, settingOptions, clusterValue) {
            var _this = this;
            var messages = [];
            _.each(vmValues, function (vmValue) {
                var value;
                if (_this.isClusterDefault(vmValue.value)) {
                    value = _this.i18nService.getString("ClusterUi", "vm.overrides.config.clusterDefault", _this.getOverrideValueLocalizedString(clusterValue, settingOptions));
                }
                else {
                    value = _this.getOverrideValueLocalizedString(vmValue.value, settingOptions);
                }
                messages.push(_this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.tooltip.separator", vmValue.vm.name, value));
            });
            return this.buildTooltipParams(messages);
        };
        ClusterConfigVmOverrideService.prototype.getValuesInSecondsTooltipParams = function (vmValues, clusterValue) {
            var _this = this;
            var messages = [];
            _.each(vmValues, function (vmValue) {
                var value;
                if (_this.isClusterDefault(vmValue.value)) {
                    value = _this.i18nService.getString("ClusterUi", "vm.overrides.config.clusterDefault", clusterValue +
                        " " +
                        _this.i18nService.getString('ClusterUi', 'vm.overrides.HA.restart.orchestration.seconds'));
                }
                else {
                    value = vmValue.value +
                        " " +
                        _this.i18nService.getString('ClusterUi', 'vm.overrides.HA.restart.orchestration.seconds');
                }
                messages.push(_this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.tooltip.separator", vmValue.vm.name, value));
            });
            return this.buildTooltipParams(messages);
        };
        ClusterConfigVmOverrideService.prototype.getApdDelayTooltipParams = function (isApdDelayDefaultValues, vmHaApdDelayValues, clusterValue) {
            var _this = this;
            var messages = [];
            _.each(isApdDelayDefaultValues, function (isApdDelayDefaultValue) {
                var value;
                if (isApdDelayDefaultValue.value) {
                    value = _this.i18nService.getString("ClusterUi", "vm.overrides.config.clusterDefault", _this.i18nService.getString("ClusterUi", "vmOverrides.intervalBeforeVmcpReaction.format", clusterValue));
                }
                else {
                    var vmValue = _.find(vmHaApdDelayValues, function (vmApdDelayValue) {
                        return vmApdDelayValue.vm.name === isApdDelayDefaultValue.vm.name;
                    });
                    value = _this.i18nService.getString("ClusterUi", "vmOverrides.intervalBeforeVmcpReaction.format", vmValue.value);
                }
                messages.push(_this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.tooltip.separator", isApdDelayDefaultValue.vm.name, value));
            });
            return this.buildTooltipParams(messages);
        };
        ClusterConfigVmOverrideService.prototype.hasMultipleValues = function (settingValue) {
            return settingValue === this.clusterVmOverridesConstants.INITIAL_VALUES;
        };
        ClusterConfigVmOverrideService.prototype.getUniqueValue = function (vmValues) {
            var uniqueValues = _.uniq(vmValues, false, function (vmValues) {
                return vmValues.value;
            });
            return (uniqueValues.length === 1) ? uniqueValues[0].value :
                this.clusterVmOverridesConstants.INITIAL_VALUES;
        };
        ClusterConfigVmOverrideService.prototype.addInitialValuesOption = function (options) {
            options.push({
                id: this.clusterVmOverridesConstants.INITIAL_VALUES,
                label: this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues")
            });
        };
        ClusterConfigVmOverrideService.prototype.containsValue = function (vmValues, value) {
            return _.some(vmValues, function (vmValue) {
                return vmValue.value === value;
            });
        };
        ClusterConfigVmOverrideService.prototype.buildTooltipParams = function (messages) {
            var title = this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.signPost.title");
            return {
                title: title,
                message: messages.join("<br>")
            };
        };
        ClusterConfigVmOverrideService.prototype.getOverrideValueLocalizedString = function (value, settingOptions) {
            var settingOption = _.find(settingOptions, function (option) {
                return String(option.id) === String(value);
            });
            return settingOption.label;
        };
        ClusterConfigVmOverrideService.prototype.getAllColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("ClusterUi", "vm.overrides.config.vm.selection.name.column"),
                    field: "name",
                    type: "string",
                    template: "<span class='object' title='#:name#'><i class='#:icon#')></i>#:name#</span>"
                },
            ];
        };
        ClusterConfigVmOverrideService.$inject = ["i18nService", "clusterVmOverridesConstants", "drsConstants",
            "drsAutomationLevelService", "addClusterVmOverridesWizardService", "AddClusterVmOverridesManager"];
        return ClusterConfigVmOverrideService;
    }());
    cluster_ui.ClusterConfigVmOverrideService = ClusterConfigVmOverrideService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("clusterConfigVmOverrideService", ClusterConfigVmOverrideService);
})(cluster_ui || (cluster_ui = {}));



/**
 * @name com.vmware.vsphere.client.cluster:clusterVmOverridesConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `clusterVmOverridesConstants` service holds VM overrides related constants.
 */
var cluster_ui;
(function (cluster_ui) {
    angular.module("com.vmware.vsphere.client.cluster")
        .constant("clusterVmOverridesConstants", {
        overrideSpec: {
            DAS_VM_CONFIG_SPEC: "com.vmware.vim.binding.vim.cluster.DasVmConfigSpec",
            DRS_VM_CONFIG_SPEC: "com.vmware.vim.binding.vim.cluster.DrsVmConfigSpec",
            ORCH_VM_CONFIG_SPEC: "com.vmware.vim.binding.vim.cluster.VmOrchestrationSpec",
            ORCH_VM_INFO_SPEC: "com.vmware.vim.binding.vim.cluster.VmOrchestrationInfo",
            ORCH_VM_READINESS_SPEC: "com.vmware.vim.binding.vim.cluster.VmReadiness"
        },
        operationType: {
            ADD: "add",
            EDIT: "edit",
            REMOVE: "remove"
        },
        CLUSTER_DEFAULT: "clusterDefault",
        RESTART_PRIORITY_CLUSTER_DEFAULT: "clusterRestartPriority",
        ISOLATION_RESPONSE_CLUSTER_DEFAULT: "clusterIsolationResponse",
        RESPONSE_RECOVERY_CLUSTER_DEFAULT: "useClusterDefault",
        OVERRIDE_NA: "VmOverrideNA_S",
        INITIAL_VALUES: "useInitialValues",
        APD_DELAY_CLUSTER_DEFAULT: -1
    });
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterVmOverridesPageService = (function () {
        function ClusterVmOverridesPageService(vuiClusterAddVmOverridesWizard, i18nService, mutationService, defaultUriSchemeUtil, clusterVmOverridesConstants, clusterSpecBuilderService, haVmMonitoringService, drsConstants, haConstants, dataService) {
            this.vuiClusterAddVmOverridesWizard = vuiClusterAddVmOverridesWizard;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clusterVmOverridesConstants = clusterVmOverridesConstants;
            this.clusterSpecBuilderService = clusterSpecBuilderService;
            this.haVmMonitoringService = haVmMonitoringService;
            this.drsConstants = drsConstants;
            this.haConstants = haConstants;
            this.dataService = dataService;
        }
        ClusterVmOverridesPageService.prototype.buildSelectVmsPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("ClusterUi", "vm.overrides.config.vm.selection.title"),
                contentUrl: "cluster-ui/resources/cluster/views/settings/configuration/overrides/selectClusterVmOverrideMemberView.html",
                onCommit: function () {
                    var selectedVms = wizardScope.manager.getSelectedVms();
                    if (selectedVms && selectedVms.length > 0) {
                        _this.vuiClusterAddVmOverridesWizard.markPageComplete();
                        return true;
                    }
                    else {
                        _this.vuiClusterAddVmOverridesWizard.markPageIncompleteWithError(_this.i18nService.getString("ClusterUi", "vm.overrides.selection.error.title"));
                        return false;
                    }
                },
                disableNext: function () {
                    return wizardScope.wizardConfig.loading;
                }
            };
        };
        ClusterVmOverridesPageService.prototype.buildAddVmOverridesPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("ClusterUi", "vm.overrides.config.add.page.title"),
                contentUrl: "cluster-ui/resources/cluster/views/settings/configuration/overrides/selectClusterVmOverridesView.html",
                onCommit: function () {
                    var objectId = wizardScope.manager.getClusterId();
                    var vmsSettingsSpec = wizardScope.manager.getVmSettingsSpec();
                    var selectedVmsSpec = wizardScope.manager.getSelectedVmsSpec();
                    var isValidationSuccessful = false;
                    if (_this.hasOverrides(vmsSettingsSpec)) {
                        var vms = _.map(selectedVmsSpec.vms, function (vmRow) {
                            return {
                                skipFromOrchestrationSpec: vmRow.skipFromOrchestrationSpec,
                                arrayOperation: vmRow.arrayOperation,
                                key: _this.defaultUriSchemeUtil.getManagedObjectReference(vmRow.id),
                                haOverrides: {
                                    overridesHaOptions: false
                                },
                                drsOverrides: {
                                    overridesDrsOptions: false,
                                    drsAutomationLevelEditable: false
                                }
                            };
                        });
                        _this.applyOverrides(objectId, vms, vmsSettingsSpec);
                        _this.vuiClusterAddVmOverridesWizard.markPageComplete();
                        isValidationSuccessful = true;
                    }
                    else {
                        _this.vuiClusterAddVmOverridesWizard.markPageIncompleteWithError(_this.i18nService.getString("ClusterUi", "vm.overrides.config.noChangesValidationError"));
                    }
                    return isValidationSuccessful;
                },
                finishReady: function () {
                    return !wizardScope.wizardConfig.loading;
                }
            };
        };
        ClusterVmOverridesPageService.prototype.applyOverrides = function (objectId, vms, vmSettingsSpec) {
            var _this = this;
            var clusterSpecData = {};
            if (vmSettingsSpec.drsAutomationOverrideEnabled) {
                _.each(vms, function (vm) {
                    var drsVmOverrideSpec = _this.buildDrsVmOverridesSpec(vmSettingsSpec.drsAutomationLevel, vm);
                    if (drsVmOverrideSpec !== null) {
                        if (angular.isUndefined(clusterSpecData.drsVmOverride)) {
                            clusterSpecData.drsVmOverride = [];
                        }
                        clusterSpecData.drsVmOverride.push(drsVmOverrideSpec);
                    }
                });
            }
            else {
                // build spec to remove the DRS override if it previously existed and
                // now we are setting it to cluster default
                _.each(vms, function (vm) {
                    if (vm.drsOverrides.overridesDrsOptions &&
                        vm.drsOverrides.drsAutomationLevelEditable) {
                        if (angular.isUndefined(clusterSpecData.drsVmOverride)) {
                            clusterSpecData.drsVmOverride = [];
                        }
                        clusterSpecData.drsVmOverride.push(_this.buildRemoveDrsVmOverridesSpec(vm));
                    }
                });
            }
            _.each(vms, function (vm) {
                if (vmSettingsSpec.haRestartPriorityEnabled ||
                    vmSettingsSpec.haRestartPriorityTimeoutEnabled ||
                    vmSettingsSpec.haIsolationResponseEnabled ||
                    vmSettingsSpec.haPdlProtectionEnabled ||
                    vmSettingsSpec.haApdProtectionEnabled ||
                    vmSettingsSpec.haApdDelayEnabled ||
                    vmSettingsSpec.haApdVmRecoveryEnabled ||
                    vmSettingsSpec.haVmMonitoringEnabled || (vmSettingsSpec.mode ===
                    _this.clusterVmOverridesConstants.operationType.EDIT &&
                    vm.haOverrides.overridesHaOptions)) {
                    // build spec to submit only if some of the HA settings are overridden
                    // or we are in edit mode and there previously used to have override that
                    // has to be removed (set to clusterDefault)
                    if (angular.isUndefined(clusterSpecData.dasVmOverride)) {
                        clusterSpecData.dasVmOverride = [];
                    }
                    clusterSpecData.dasVmOverride.push(_this.buildDasVmOverridesSpec(vmSettingsSpec, vm));
                }
            });
            // if both ready condition and post ready delay are disabled, then delete
            // this override
            var orchestrationVmOverrideSpec;
            if (!vmSettingsSpec.haRestartOrchestrationEnabled && !vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled) {
                orchestrationVmOverrideSpec = this.buildRemoveVmOrchestrationSpec(vms, clusterSpecData);
            }
            else {
                orchestrationVmOverrideSpec = this.buildAddVmOrchestrationSpec(vms, vmSettingsSpec);
            }
            if (orchestrationVmOverrideSpec && orchestrationVmOverrideSpec.length > 0) {
                if (angular.isUndefined(clusterSpecData.orchestrationVmOverride)) {
                    clusterSpecData.orchestrationVmOverride = [];
                }
                clusterSpecData.orchestrationVmOverride = orchestrationVmOverrideSpec;
            }
            var clusterSpec = this.clusterSpecBuilderService
                .buildClusterComputeResourceSpec(clusterSpecData, true);
            this.mutationService.apply(objectId, "com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec", clusterSpec);
        };
        ClusterVmOverridesPageService.prototype.hasOverrides = function (vmSettingsSpec) {
            return vmSettingsSpec.drsAutomationOverrideEnabled ||
                vmSettingsSpec.haRestartPriorityTimeoutEnabled ||
                vmSettingsSpec.haRestartOrchestrationEnabled ||
                vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled ||
                vmSettingsSpec.haIsolationResponseEnabled ||
                vmSettingsSpec.haPdlProtectionEnabled ||
                vmSettingsSpec.haApdProtectionEnabled ||
                vmSettingsSpec.haApdDelayEnabled ||
                vmSettingsSpec.haApdVmRecoveryEnabled ||
                vmSettingsSpec.haVmMonitoringEnabled;
        };
        ClusterVmOverridesPageService.prototype.populateVmFtRole = function (vms) {
            var objIds = _.pluck(vms, "id");
            return this.dataService.getPropertiesForObjects(objIds, ["ftRole", "isVmcpSupportedForVm"])
                .then(function (result) {
                _.each(vms, function (vmObject) {
                    vmObject.vm = {
                        ftVm: !_.isNull(result[vmObject.id].ftRole),
                        isVmcpSupportedForVm: result[vmObject.id].isVmcpSupportedForVm
                    };
                });
                return vms;
            });
        };
        ClusterVmOverridesPageService.prototype.buildDrsVmOverridesSpec = function (drsAutomationLevel, vm) {
            var drsAutomationEnabled = true;
            if (this.isInitalValue(drsAutomationLevel)) {
                if (this.isClusterDefault(vm.drsOverrides.drsAutomationLevel)) {
                    return null;
                }
                else {
                    drsAutomationLevel = vm.drsOverrides.drsAutomationLevel;
                }
            }
            if (drsAutomationLevel === this.drsConstants.AUTOMATION_LEVEL_DISABLED) {
                drsAutomationEnabled = false;
                drsAutomationLevel = null;
            }
            var vmOverrideInfo = {
                _type: "com.vmware.vim.binding.vim.cluster.DrsVmConfigInfo",
                key: vm.key,
                behavior: drsAutomationLevel,
                enabled: drsAutomationEnabled
            };
            // use either add or edit operation depending if there was an DRS override initially
            var operation = vm.drsOverrides.overridesDrsOptions ?
                this.clusterVmOverridesConstants.operationType.EDIT :
                this.clusterVmOverridesConstants.operationType.ADD;
            return {
                _type: this.clusterVmOverridesConstants.overrideSpec.DRS_VM_CONFIG_SPEC,
                info: vmOverrideInfo,
                operation: operation
            };
        };
        ClusterVmOverridesPageService.prototype.buildRemoveDrsVmOverridesSpec = function (vm) {
            return {
                _type: this.clusterVmOverridesConstants.overrideSpec.DRS_VM_CONFIG_SPEC,
                removeKey: vm.key,
                operation: this.clusterVmOverridesConstants.operationType.REMOVE
            };
        };
        ClusterVmOverridesPageService.prototype.buildDasVmOverridesSpec = function (vmSettingsSpec, vm) {
            var vmOverrideInfo = {
                _type: "com.vmware.vim.binding.vim.cluster.DasVmConfigInfo",
                key: vm.key
            };
            vmOverrideInfo.dasSettings = {
                _type: "com.vmware.vim.binding.vim.cluster.DasVmSettings"
            };
            if (vmSettingsSpec.haRestartPriorityEnabled) {
                if (this.isInitalValue(vmSettingsSpec.haRestartPriority)) {
                    vmOverrideInfo.dasSettings.restartPriority =
                        vm.haOverrides.haRestartPriority;
                }
                else {
                    vmOverrideInfo.dasSettings.restartPriority =
                        vmSettingsSpec.haRestartPriority;
                }
            }
            else {
                vmOverrideInfo.dasSettings.restartPriority =
                    this.clusterVmOverridesConstants.RESTART_PRIORITY_CLUSTER_DEFAULT;
            }
            if (vmSettingsSpec.haRestartPriorityTimeoutEnabled) {
                if (this.isInitalValue(vmSettingsSpec.haRestartPriorityTimeout)) {
                    vmOverrideInfo.dasSettings.restartPriorityTimeout =
                        vm.haOverrides.haRestartPriorityTimeout;
                }
                else {
                    vmOverrideInfo.dasSettings.restartPriorityTimeout =
                        vmSettingsSpec.haRestartPriorityTimeout;
                }
            }
            else {
                vmOverrideInfo.dasSettings.restartPriorityTimeout =
                    this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT;
            }
            if (vmSettingsSpec.haIsolationResponseEnabled) {
                if (this.isInitalValue(vmSettingsSpec.haIsolationResponse)) {
                    vmOverrideInfo.dasSettings.isolationResponse =
                        vm.haOverrides.haIsolationResponse;
                }
                else {
                    vmOverrideInfo.dasSettings.isolationResponse =
                        vmSettingsSpec.haIsolationResponse;
                }
            }
            else {
                vmOverrideInfo.dasSettings.isolationResponse =
                    this.clusterVmOverridesConstants.ISOLATION_RESPONSE_CLUSTER_DEFAULT;
            }
            this.buildVmcpSettingsSpec(vmSettingsSpec, vmOverrideInfo, vm);
            this.buildVmMonitoringSettingsSpec(vmSettingsSpec, vmOverrideInfo, vm);
            // use either add or edit operation depending if there was an HA override initially
            var operation = vm.haOverrides.overridesHaOptions ?
                this.clusterVmOverridesConstants.operationType.EDIT :
                this.clusterVmOverridesConstants.operationType.ADD;
            return {
                _type: this.clusterVmOverridesConstants.overrideSpec.DAS_VM_CONFIG_SPEC,
                info: vmOverrideInfo,
                operation: operation
            };
        };
        ClusterVmOverridesPageService.prototype.isClusterDefault = function (propertyValue) {
            return propertyValue === this.clusterVmOverridesConstants.CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.OVERRIDE_NA ||
                propertyValue === this.clusterVmOverridesConstants.RESTART_PRIORITY_CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.ISOLATION_RESPONSE_CLUSTER_DEFAULT ||
                propertyValue === this.clusterVmOverridesConstants.RESPONSE_RECOVERY_CLUSTER_DEFAULT;
        };
        ClusterVmOverridesPageService.prototype.isInitalValue = function (value) {
            return value === this.clusterVmOverridesConstants.INITIAL_VALUES ||
                value === this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues");
        };
        ClusterVmOverridesPageService.prototype.buildAddVmOrchestrationSpec = function (vms, vmSettingsSpec) {
            var _this = this;
            var result = [];
            _.each(vms, function (vm) {
                var vmOrchestrationSpec = {
                    _type: _this.clusterVmOverridesConstants.overrideSpec.ORCH_VM_CONFIG_SPEC,
                    operation: vm.arrayOperation,
                    info: {
                        _type: _this.clusterVmOverridesConstants.overrideSpec.ORCH_VM_INFO_SPEC,
                        vm: vm.key,
                        vmReadiness: {
                            _type: _this.clusterVmOverridesConstants.overrideSpec.ORCH_VM_READINESS_SPEC
                        }
                    }
                };
                // overwrite value only if not set to useInitialValues
                if (!_this.isInitalValue(vmSettingsSpec.restartOrchestration.readyCondition)) {
                    _.extend(vmOrchestrationSpec.info.vmReadiness, {
                        readyCondition: vmSettingsSpec.haRestartOrchestrationEnabled ?
                            vmSettingsSpec.restartOrchestration.readyCondition :
                            "useClusterDefault"
                    });
                }
                // overwrite value only if not set to useInitialValues
                if (!_this.isInitalValue(vmSettingsSpec.restartOrchestration.postReadyDelay)) {
                    _.extend(vmOrchestrationSpec.info.vmReadiness, {
                        postReadyDelay: vmSettingsSpec.restartOrchestration.postReadyDelay });
                }
                // execute mutation only if either readyCondition or postReadyDelay
                // are changed from useInitialValues
                if (vmOrchestrationSpec.info.vmReadiness.readyCondition ||
                    vmOrchestrationSpec.info.vmReadiness.postReadyDelay) {
                    result.push(vmOrchestrationSpec);
                }
            });
            return result;
        };
        ClusterVmOverridesPageService.prototype.buildRemoveVmOrchestrationSpec = function (vms, clusterSpecData) {
            var _this = this;
            var result = [];
            _.each(vms, function (vm) {
                if (!vm.skipFromOrchestrationSpec &&
                    vm.arrayOperation === _this.clusterVmOverridesConstants.operationType.REMOVE) {
                    result.push({
                        _type: _this.clusterVmOverridesConstants.overrideSpec.ORCH_VM_CONFIG_SPEC,
                        removeKey: vm.key,
                        operation: _this.clusterVmOverridesConstants.operationType.REMOVE
                    });
                }
            });
            return result;
        };
        ClusterVmOverridesPageService.prototype.buildVmcpSettingsSpec = function (vmSettingsSpec, vmOverrideInfo, vm) {
            if (vmSettingsSpec.haPdlProtectionEnabled ||
                vmSettingsSpec.haApdProtectionEnabled ||
                vmSettingsSpec.haApdDelayEnabled ||
                vmSettingsSpec.haApdVmRecoveryEnabled || vmSettingsSpec.mode ===
                this.clusterVmOverridesConstants.operationType.EDIT) {
                vmOverrideInfo.dasSettings.vmComponentProtectionSettings = {
                    _type: "com.vmware.vim.binding.vim.cluster.VmComponentProtectionSettings",
                };
                if (vmSettingsSpec.haPdlProtectionEnabled) {
                    if (this.isInitalValue(vmSettingsSpec.haPdlProtection)) {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmStorageProtectionForPDL =
                            vm.haOverrides.pdlProtectionLevel;
                    }
                    else {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmStorageProtectionForPDL = vmSettingsSpec.haPdlProtection;
                    }
                }
                else {
                    vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                        .vmStorageProtectionForPDL =
                        this.clusterVmOverridesConstants.CLUSTER_DEFAULT;
                }
                if (vmSettingsSpec.haApdProtectionEnabled) {
                    if (this.isInitalValue(vmSettingsSpec.haApdProtection)) {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmStorageProtectionForAPD =
                            vm.haOverrides.apdProtectionLevel;
                    }
                    else {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmStorageProtectionForAPD = vmSettingsSpec.haApdProtection;
                    }
                }
                else {
                    vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                        .vmStorageProtectionForAPD =
                        this.clusterVmOverridesConstants.CLUSTER_DEFAULT;
                }
                if (vmSettingsSpec.haApdDelayEnabled) {
                    if (this.isInitalValue(vmSettingsSpec.haApdDelay)) {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmTerminateDelayForAPDSec =
                            vm.haOverrides.intervalBeforeVmcpReaction *
                                this.haConstants.SECONDS_IN_A_MINUTE;
                    }
                    else {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmTerminateDelayForAPDSec = vmSettingsSpec.haApdDelay *
                            this.haConstants.SECONDS_IN_A_MINUTE;
                    }
                }
                else {
                    vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                        .vmTerminateDelayForAPDSec =
                        this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT;
                }
                if (vmSettingsSpec.haApdVmRecoveryEnabled) {
                    if (this.isInitalValue(vmSettingsSpec.haApdVmRecovery)) {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmReactionOnAPDCleared =
                            vm.haOverrides.vmRemediationOnApdRecover;
                    }
                    else {
                        vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                            .vmReactionOnAPDCleared = vmSettingsSpec.haApdVmRecovery;
                    }
                }
                else {
                    vmOverrideInfo.dasSettings.vmComponentProtectionSettings
                        .vmReactionOnAPDCleared =
                        this.clusterVmOverridesConstants.RESPONSE_RECOVERY_CLUSTER_DEFAULT;
                }
            }
        };
        ClusterVmOverridesPageService.prototype.buildVmMonitoringSettingsSpec = function (vmSettingsSpec, vmOverrideInfo, vm) {
            if (vmSettingsSpec.haVmMonitoringEnabled || vmSettingsSpec.mode ===
                this.clusterVmOverridesConstants.operationType.EDIT) {
                vmOverrideInfo.dasSettings.vmToolsMonitoringSettings = {
                    _type: "com.vmware.vim.binding.vim.cluster.VmToolsMonitoringSettings",
                };
                if (vmSettingsSpec.haVmMonitoringEnabled) {
                    vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.clusterSettings =
                        false;
                    this.setVmMonitoringSettings(vmSettingsSpec, vmOverrideInfo, vm);
                }
                else {
                    vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.clusterSettings =
                        true;
                }
            }
        };
        ClusterVmOverridesPageService.prototype.setVmMonitoringSettings = function (vmSettingsSpec, vmOverrideInfo, vm) {
            if (this.isInitalValue(vmSettingsSpec.haVmMonitoring)) {
                if (this.isClusterDefault(vm.haOverrides.vmMonitoring)) {
                    vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.clusterSettings =
                        true;
                    return;
                }
                else {
                    vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.vmMonitoring =
                        vm.haOverrides.vmMonitoring;
                }
            }
            else {
                vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.vmMonitoring =
                    vmSettingsSpec.haVmMonitoring;
            }
            this.setVmMonitoringSensitivitySettings(vmSettingsSpec, vmOverrideInfo, vm);
        };
        ClusterVmOverridesPageService.prototype.setVmMonitoringSensitivitySettings = function (vmSettingsSpec, vmOverrideInfo, vm) {
            if (this.isInitalValue(vmSettingsSpec.haVmMonitoringSensitivity)) {
                this.setVmMonitoringSettingsValues(vmOverrideInfo, vm.haOverrides.vmFailureIntervalValue, vm.haOverrides.vmMinUptimeValue, vm.haOverrides.vmMaxFailuresValue, vm.haOverrides.vmMaxFailureWindowValue);
            }
            else if (vmSettingsSpec.haVmMonitoringSensitivity ===
                this.haVmMonitoringService.getPresetLevels().CUSTOM) {
                var vmFailureWindow = vmSettingsSpec.vmToolsMonitorHasFailureWindow ?
                    vmSettingsSpec.vmToolsMonitorMaxFailureWindow * 3600 :
                    this.haConstants.vmMonitoringSensitivity.NO_FAILURE_WINDOW;
                this.setVmMonitoringSettingsValues(vmOverrideInfo, vmSettingsSpec.vmToolsMonitorFailureInt, vmSettingsSpec.vmToolsMonitorMinUpTime, vmSettingsSpec.vmToolsMonitorMaxFailures, vmFailureWindow);
            }
            else {
                // get values for failure int, min uptime, max failures and failure window
                // corresponding to sensitivity level
                var sensitivityLevelValues = this.haVmMonitoringService.getSensitivityLevelValues(vmSettingsSpec.haVmMonitoringSensitivity);
                this.setVmMonitoringSettingsValues(vmOverrideInfo, sensitivityLevelValues.failure_interval, sensitivityLevelValues.min_uptime, sensitivityLevelValues.max_failures, sensitivityLevelValues.failure_window * 3600);
            }
        };
        ClusterVmOverridesPageService.prototype.setVmMonitoringSettingsValues = function (vmOverrideInfo, failureInterval, minUpTime, maxFailures, maxFailureWindow) {
            vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.failureInterval =
                failureInterval;
            vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.minUpTime = minUpTime;
            vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.maxFailures = maxFailures;
            vmOverrideInfo.dasSettings.vmToolsMonitoringSettings.maxFailureWindow =
                maxFailureWindow;
        };
        ClusterVmOverridesPageService.$inject = ["vuiClusterAddVmOverridesWizard", "i18nService",
            "mutationService",
            "defaultUriSchemeUtil",
            "clusterVmOverridesConstants",
            "clusterSpecBuilderService",
            "haVmMonitoringService",
            "drsConstants",
            "haConstants",
            "dataService"];
        return ClusterVmOverridesPageService;
    }());
    cluster_ui.ClusterVmOverridesPageService = ClusterVmOverridesPageService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("clusterVmOverridesPageService", ClusterVmOverridesPageService);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('clusterVmOverridesService', clusterVmOverridesService);

   clusterVmOverridesService.$inject = ['dataService', 'i18nService', 'clarityModalService',
      'clusterSpecBuilderService', 'mutationService', 'clusterVmOverridesConstants', 'vxPropertyViewService'];

   function clusterVmOverridesService(dataService, i18nService, clarityModalService,
         clusterSpecBuilderService, mutationService, clusterVmOverridesConstants, vxPropertyViewService) {

      return {
         getVmOverridesData: getVmOverridesData,
         deleteVmOverride: deleteVmOverride,
         buildPropertyView: buildPropertyView
      };

      function getVmOverridesData(clusterId) {
         return dataService
               .getData(clusterId,
                     'com.vmware.vsphere.client.clusterui.model.configuration.VmOverridesData')
               .then(function(data) {
                  return {
                     overrides: data ? data.vmOverrides : []
                  };
               });
      }

      function deleteVmOverride(clusterId, vmOverrideInfos, focusTarget) {
         var vmMors = _.map(vmOverrideInfos, function(item) {
            return angular.merge(
                  { _type: 'com.vmware.vim.binding.vmodl.ManagedObjectReference' },
                  item.vm.provider);
         });

         var confirmProperties = {
            title: i18nService.getString('ClusterUi', 'actionDeleteVmOverrideCaption'),
            message: i18nService.getString('ClusterUi',
                  'actionDeleteVmOverrideConfirmation'),
            focusTarget: focusTarget,
            submit: function() {
               deleteVmOverrideFromCluster(clusterId, vmOverrideInfos, vmMors);
            }
         };

         clarityModalService.openConfirmationModal(confirmProperties);
      }

      function deleteVmOverrideFromCluster(clusterId, vmOverrideInfos, vmKeys) {
         var vmOverridesSpec = {};
         var someOverridesWillNotBeDeleted = false;

         vmOverridesSpec.dasVmOverride = [];
         _.each(vmKeys, function(item, index) {
            if (vmOverrideInfos[index].haOverrides.overridesHaOptions) {
               vmOverridesSpec.dasVmOverride.push({
                  _type: clusterVmOverridesConstants.overrideSpec.DAS_VM_CONFIG_SPEC,
                  operation: clusterVmOverridesConstants.operationType.REMOVE,
                  removeKey: item
               });
            }
         });

         vmOverridesSpec.drsVmOverride = [];
         _.each(vmKeys, function(item, index) {
            if (vmOverrideInfos[index].drsOverrides.overridesDrsOptions) {
               if (vmOverrideInfos[index].drsOverrides.drsAutomationLevelEditable) {
                  vmOverridesSpec.drsVmOverride.push({
                     _type: clusterVmOverridesConstants.overrideSpec.DRS_VM_CONFIG_SPEC,
                     operation: clusterVmOverridesConstants.operationType.REMOVE,
                     removeKey: item
                  });
               } else {
                  someOverridesWillNotBeDeleted = true;
               }
            }
         });

         vmOverridesSpec.orchestrationVmOverride = [];
         _.each(vmKeys, function(item, index) {
            if (vmOverrideInfos[index].haOverrides.overridesResOrchOptions) {
               vmOverridesSpec.orchestrationVmOverride.push({
                  _type: clusterVmOverridesConstants.overrideSpec.ORCH_VM_CONFIG_SPEC,
                  operation: clusterVmOverridesConstants.operationType.REMOVE,
                  removeKey: item
               });
            }
         });


         var clusterComputeResourceSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     vmOverridesSpec, true);

         mutationService.apply(clusterId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterComputeResourceSpec
         );

         if (someOverridesWillNotBeDeleted) {
            clarityModalService.openConfirmationModal({
               title: i18nService.getString(
                     "ClusterUi", "actionDeleteVmOverridesCaption"),
               message: i18nService.getString(
                     "ClusterUi", "actionDeleteVmOverridesSomeOverridesWontBeDeleted"),
               icon: 'vx-icon-warning-32x32',
               saveButtonLabel: i18nService.getString("Common", "alert.ok"),
               hideCancelButton: true,
               submit: function() {
                  return true;
               }
            });
         }
      }

      function buildPropertyView(haOverrides) {
         var propertyViewBuilder = vxPropertyViewService.createPropertyViewBuilder();

         buildRestartConditionPropertyViewCategory(propertyViewBuilder, haOverrides);
         buildPdlProtectionPropertyViewCategory(propertyViewBuilder, haOverrides.pdlProtectionLevelText);
         buildApdProtectionPropertyViewCategory(propertyViewBuilder, haOverrides);
         buildVmMonitoringPropertyViewCategory(propertyViewBuilder, haOverrides);
         return propertyViewBuilder.build();
      }

      function buildRestartConditionPropertyViewCategory(propertyViewBuilder, haOverrides) {
         propertyViewBuilder
               .category("restartCondition")
               .title(i18nService.getString('ClusterUi',
                     'vm.overrides.restart.condition.tab.label'))
               .section("restartConditionSection")
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.restart.condition.label"),
                     haOverrides.haRestartConditionsText)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.restart.condition.delay.label"),
                     haOverrides.haRestartConditionDelay)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.restart.condition.timeout.label"),
                     haOverrides.haRestartPriorityTimeout);
      }

      function buildPdlProtectionPropertyViewCategory(propertyViewBuilder, pdlProtection) {
         propertyViewBuilder
               .category("pdlProtection")
               .title(i18nService.getString("ClusterUi", "vm.overrides.pdl.tab.label"))
               .section("pdlProtectionSection")
               .title(i18nService.getString("ClusterUi",
                     "vm.overrides.pdl.protection.title"))
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.pdlAndAdp.failure.response.protection.label"),
                     pdlProtection);
      }

      function buildApdProtectionPropertyViewCategory(propertyViewBuilder, haOverrides) {
         propertyViewBuilder
               .category("apdProtection")
               .title(i18nService.getString("ClusterUi", "vm.overrides.apd.tab.label"))
               .section("apdProtectionSection")
               .title(i18nService.getString("ClusterUi",
                     "vm.overrides.apd.protection.title"))
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.pdlAndAdp.failure.response.protection.label"),
                     haOverrides.apdProtectionLevelText)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.apd.failover.delay.label"),
                     haOverrides.intervalBeforeVmcpReactionText)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.apd.response.recovery.label"),
                     haOverrides.vmRemediationOnApdRecoverText);
      }

      function buildVmMonitoringPropertyViewCategory(propertyViewBuilder, haOverrides) {
         propertyViewBuilder
               .category("vmMonitoring")
               .title(i18nService.getString("ClusterUi", "vmOverrides.vmMonitoringHeaderText"))
               .section("vmMonitoringSection")
               .property(i18nService.getString("ClusterUi",
                     "vmOverrides.vmMonitoringHeaderText"),
                     haOverrides.vmMonitoringText)
               .property(i18nService.getString("ClusterUi",
                     "vmOverrides.vmMonitoringSensitivityHeaderText"),
                     haOverrides.vmMonitoringSensitivityText)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.failure.interval.label"),
                     haOverrides.vmFailureInterval)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.minimum.uptime.label"),
                     haOverrides.vmMinUptime)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.max.resests.label"),
                     haOverrides.vmMaxFailures)
               .property(i18nService.getString("ClusterUi",
                     "vm.overrides.max.reset.time.window.label"),
                     haOverrides.vmMaxFailureWindow);
      }
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var VuiClusterAddVmOverridesWizardImpl = (function () {
        function VuiClusterAddVmOverridesWizardImpl(wizardPageService, vuiWizardService, $rootScope, i18nService) {
            this.wizardPageService = wizardPageService;
            this.vuiWizardService = vuiWizardService;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
        }
        VuiClusterAddVmOverridesWizardImpl.prototype.show = function (pages, wizardScope, manager, focusTarget) {
            this.wizardConfig = {
                title: this.i18nService.getString("ClusterUi", "vm.overrides.config.add.dialog.title", manager.getClusterName()),
                pages: this.wizardPageService.initializePageStates(pages),
                cssClass: "add-vm-overrides-wizard",
                resizeMinHeight: 500,
                onFinish: function () {
                    return true;
                }
            };
            this.wizardScope = wizardScope;
            this.wizardScope.manager = manager;
            this.wizardScope.wizardConfig = this.wizardConfig;
            wizardScope.modalOptions = {
                focusTarget: focusTarget
            };
            this.vuiWizardService({
                scope: this.wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        VuiClusterAddVmOverridesWizardImpl.prototype.markPageIncompleteWithError = function (message) {
            this.wizardPageService.markPageIncompleteWithError(this.wizardConfig, message);
        };
        VuiClusterAddVmOverridesWizardImpl.prototype.markPageComplete = function (flow) {
            this.wizardPageService.clearErrors(this.wizardConfig);
            this.wizardPageService.markPageComplete(this.wizardConfig, flow);
        };
        VuiClusterAddVmOverridesWizardImpl.$inject = [
            'wizardPageService',
            'vuiWizardService',
            '$rootScope',
            'i18nService'
        ];
        return VuiClusterAddVmOverridesWizardImpl;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .service("vuiClusterAddVmOverridesWizard", VuiClusterAddVmOverridesWizardImpl);
})(cluster_ui || (cluster_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
'use strict';

/**
 * Service for Resource Pool management.
 */
angular.module('com.vmware.vsphere.client.cluster')
      .factory('createResourcePoolService', [function() {
         function createDefaultResourcePoolSpec() {
            var spec = {
               parent: null,
               name: '',
               configSpec: {
                  _type: 'com.vmware.vim.binding.vim.ResourceConfigSpec',
                  cpuAllocation: {
                     _type: 'com.vmware.vim.binding.vim.ResourceAllocationInfo',
                     expandableReservation: true,
                     limit: -1,
                     reservation: 0,
                     shares: {
                        _type: 'com.vmware.vim.binding.vim.SharesInfo',
                        level: 'normal',
                        shares: 4000
                     }
                  },
                  memoryAllocation: {
                     _type: 'com.vmware.vim.binding.vim.ResourceAllocationInfo',
                     expandableReservation: true,
                     limit: -1,
                     reservation: 0,
                     shares: {
                        _type: 'com.vmware.vim.binding.vim.SharesInfo',
                        level: 'normal',
                        shares: 163840
                     }
                  }
               }
            };

            return spec;
         }

         function createCreateResourcePoolNameSpec(name) {
            var spec = {
               name: name
            };

            return spec;
         }

         return {
            createDefaultResourcePoolSpec: createDefaultResourcePoolSpec,
            createCreateResourcePoolNameSpec: createCreateResourcePoolNameSpec
         };
      }]);
})();

var cluster_ui;
(function (cluster_ui) {
    var DatastoresUnderApdPdlService = (function () {
        function DatastoresUnderApdPdlService(i18nService, columnRenderersRegistry, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        DatastoresUnderApdPdlService.prototype.getGridOptions = function () {
            var options = {
                actionBarOptions: {
                    actions: []
                },
                pageConfig: {
                    hidePager: true
                },
                searchable: false,
                resizable: false,
                data: [],
                columnDefs: this.getAllColumnDefs(),
                height: "100%"
            };
            return options;
        };
        DatastoresUnderApdPdlService.prototype.getAllColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.getString("ha.vmcp.monitoring.host.header"),
                    field: "hostName",
                    template: function (data) {
                        return _this.getColumnTemplate("vsphere-icon-host", "hostName", "hostRef", data);
                    }
                },
                {
                    displayName: this.getString("ha.vmcp.monitoring.datastore.header"),
                    field: "datastoreName",
                    template: function (data) {
                        return _this.getColumnTemplate("vsphere-icon-datastore", "datastoreName", "datastoreRef", data);
                    }
                },
                {
                    displayName: this.getString("ha.vmcp.monitoring.dsCluster.header"),
                    field: "dsClusterName",
                    template: function (data) {
                        return _this.getColumnTemplate("vsphere-icon-datastore-cluster", "dsClusterName", "dsClusterRef", data);
                    }
                },
                {
                    displayName: this.getString("ha.vmcp.monitoring.failure.header"),
                    field: "reason",
                    template: function (data) {
                        var reason = "";
                        if (data && data.reason) {
                            reason = _this.getInaccessibleReason(data);
                        }
                        return reason;
                    }
                }
            ];
        };
        DatastoresUnderApdPdlService.prototype.getInaccessibleReason = function (item) {
            var reasons = {
                "APD_DETECTED": this.getString("ha.vmcp.monitoring.reason.APD_DETECTED"),
                "APD_TIMEOUT": this.getString("ha.vmcp.monitoring.reason.APD_TIMEOUT"),
                "PDL": this.getString("ha.vmcp.monitoring.reason.PDL")
            };
            return reasons.hasOwnProperty(item.reason) ? reasons[item.reason] : "";
        };
        DatastoresUnderApdPdlService.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DatastoresUnderApdPdlService.prototype.getColumnRenderer = function (type) {
            return this.columnRenderersRegistry.getColumnRenderer(type);
        };
        DatastoresUnderApdPdlService.prototype.getColumnTemplate = function (icon, property, morProperty, data) {
            var objectLinkRenderer = this.getColumnRenderer("object-link");
            var currentObjectId = this.defaultUriSchemeUtil.getVsphereObjectId(data[morProperty]);
            var dataToRepresent = {
                currentObjectId: currentObjectId,
                name: data[property]
            };
            return data && data[property] && data[morProperty] ?
                objectLinkRenderer(["currentObjectId", "name", icon], dataToRepresent) : "";
        };
        DatastoresUnderApdPdlService.$inject = ["i18nService", "columnRenderersRegistry", "defaultUriSchemeUtil"];
        return DatastoresUnderApdPdlService;
    }());
    cluster_ui.DatastoresUnderApdPdlService = DatastoresUnderApdPdlService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("datastoresUnderApdPdlService", DatastoresUnderApdPdlService);
})(cluster_ui || (cluster_ui = {}));



(function () {
   'use strict';

   /**
    * Service that provides DPM automation level related information.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .service('dpmAutomationLevelService', dpmAutomationLevelService);

   dpmAutomationLevelService.$inject = ['i18nService', 'drsConstants'];

   function dpmAutomationLevelService(i18nService, drsConstants) {

      return {
         getText: getText,
         getDescription: getDescription,
         getAutomationLevels: getAutomationLevels
      };

      function getAutomationLevels() {
         return Object.keys(drsConstants.dpmAutomationLevel).map(function (key){
             return buildAutomationLevel(key);
         });
      }

      function buildAutomationLevel(key) {
         var dpmEnabled = true;
         var automationLevel = drsConstants.dpmAutomationLevel[key];
         if (automationLevel === '') {
            dpmEnabled = false;
         }

         return {
            id: automationLevel,
            label: getText(dpmEnabled, automationLevel),
            description: getDescription(dpmEnabled, automationLevel)
         };
      }

      function getText(dpmEnabled, automationLevelKey) {
         if(!dpmEnabled) {
            return getString('drs.config.dpm.disabled');
         }

         switch (automationLevelKey) {
            case drsConstants.dpmAutomationLevel.MANUAL:
                  return getString('drs.config.dpm.automationLevel.manual');
            case drsConstants.dpmAutomationLevel.AUTOMATED:
               return getString('drs.config.dpm.automationLevel.automated');
            default:
               return '';
         }
      }

      function getDescription(dpmEnabled, automationLevelKey) {
         if(!dpmEnabled) {
            return getString('drs.config.dpm.disabledDescription');
         }

         switch (automationLevelKey) {
            case drsConstants.dpmAutomationLevel.MANUAL:
               return getString('drs.config.dpm.automationLevel.manualDescription');
            case drsConstants.dpmAutomationLevel.AUTOMATED:
               return getString('drs.config.dpm.automationLevel.automatedDescription');
            default:
               return '';
         }
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

(function () {
   'use strict';

   /**
    * Service that provides information about DRS power management threshold.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .service('dpmThresholdService', dpmThresholdService);

   dpmThresholdService.$inject = ['drsConstants', 'logService', 'i18nService'];

   function dpmThresholdService(drsConstants, logService, i18nService) {
      var log = logService('drsMigrationThresholdService');

      return {
         getText: getText,
         reverseDpmRateAndThreshold: reverseDpmRateAndThreshold,
         MIN: drsConstants.dpmThreshold.MIN,
         MAX: drsConstants.dpmThreshold.MAX,
         DEFAULT: (drsConstants.dpmThreshold.MIN + drsConstants.dpmThreshold.MAX) / 2,
         MIN_LABEL: getString('drs.config.threshold.conservative'),
         MAX_LABEL: getString('drs.config.threshold.aggressive')
      };

      /**
       * Returns DPM threshold text based on the provided dpm state and rate.
       */
      function getText(dpmEnabled, dpmThreshold) {
         if (dpmEnabled && !dpmThresholdWithinRange(dpmThreshold)) {
            log.warn('Unexpected DPM threshold: ' + dpmThreshold);
            return '';
         }

         // if the dpm is not enabled, display N/A for dpm threshold
         var key = (dpmEnabled) ?
               i18nService.interpolate(
                     "drs.config.dpmThresholdLabel.priority{0}Description",
                     [dpmThreshold])
               : "drs.config.dpmThresholdLabel.notAvailable";

         return getString(key);
      }

      /**
       * Helper function to calculate the dpm threshold and rate values.
       */
      function reverseDpmRateAndThreshold(value) {
         return drsConstants.dpmThreshold.MAX - value + drsConstants.dpmThreshold.MIN;
      }

      function dpmThresholdWithinRange(value) {
         return drsConstants.dpmThreshold.RANGE.indexOf(value) !== -1;
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

(function () {
   'use strict';

   /**
    * Service that provides DRS automation levels information. Each level info
    * contains id, label and description of DRS behavior.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('drsAutomationLevelService', drsAutomationLevelService);

   drsAutomationLevelService.$inject = ['i18nService', 'drsConstants'];

   function drsAutomationLevelService(i18nService, drsConstants) {
      return {
         DEFAULT_LEVEL: buildLevel(drsConstants.automationLevel.FULLY_AUTOMATED),
         getLevels: getLevels,
         getLevelByKey: getLevelByKey,
         getLabel: getLabel
      };

      function getLevels() {
         var automationLevels = Object.keys(drsConstants.automationLevel).map(function (key) {
            var automationLevelKey = drsConstants.automationLevel[key];
            var automationLevel = buildLevel(automationLevelKey);
            return automationLevel;
         });

         return automationLevels;
      }

      function getLevelByKey(automationLevelKey) {
         var level = buildLevel(automationLevelKey);
         return level;
      }

      function buildLevel(automationLevelKey) {
         return {
            id: automationLevelKey,
            label: getLabel(automationLevelKey),
            description: getDescription(automationLevelKey)
         };
      }

      function getLabel(automationLevelKey) {
         var automationLevelTextKey;
         switch (automationLevelKey) {
            case drsConstants.automationLevel.MANUAL:
               automationLevelTextKey = 'drs.config.automationLevel.manual';
               break;
            case drsConstants.automationLevel.PARTIALLY_AUTOMATED:
               automationLevelTextKey = 'drs.config.automationLevel.partialauto';
               break;
            case drsConstants.automationLevel.FULLY_AUTOMATED:
               automationLevelTextKey = 'drs.config.automationLevel.fullauto';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', automationLevelTextKey);
      }

      function getDescription(automationLevelKey) {
         var automationLevelDescriptionKey;
         switch (automationLevelKey) {
            case drsConstants.automationLevel.MANUAL:
               automationLevelDescriptionKey = 'drs.config.automationLevel.manualDescription';
               break;
            case drsConstants.automationLevel.PARTIALLY_AUTOMATED:
               automationLevelDescriptionKey = 'drs.config.automationLevel.partialautoDescription';
               break;
            case drsConstants.automationLevel.FULLY_AUTOMATED:
               automationLevelDescriptionKey = 'drs.config.automationLevel.fullautoDescription';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', automationLevelDescriptionKey);
      }
   }
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * @name com.vmware.vsphere.client.cluster:drsConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `drsConstants` service holds cluster DRS related constants.
 *
 *    List of available constants:
 *
 *    - automationLevel (DrsConfigInfo.DrsBehavior enum values)
 *       - **`MANUAL`** : VC suggests migration recommendations
 *       - **`PARTIALLY_AUTOMATED`** : VC automatically places VMs but suggests
 *             migration recommendations
 *       - **`FULLY_AUTOMATED`** : VMs are automatically placed and migrated
 *    - migrationThreshold (DrsConfigInfo.vmotionRate inverse values)
 *       - **`MIN`** : minimum value that can be set
 *       - **`MAX`** : maximum value
 *       - **`RANGE`** : Valid range of values for the migration threshold
 *   - dpmAutomationLevel (DpmConfigInfo_DpmBehavior enum values)
 *       - **`DISABLED`**: DPM is disabled
 *       - **`MANUAL`** : VC should generate recommendations for host power operations,
 *                but should not execute the recommendations automatically.
 *       - **`AUTOMATED`** VC should generate recommendations for host power operations,
 *                and should execute the recommendations automatically.
 *   - dpmThreshold (DpmConfigInfo.hostPowerActionRate inverse values)
 *       - **`MIN`** : minimum value that can be set
 *       - **`MAX`** : maximum value
 *       - **`RANGE`** : Valid range of values for the dpm threshold
 *   - faults (ClusterComputeResource.drsFaults)
 *       - **`DRSFAULT_POWERONVM`** : vm placement fault when VM is powered on
 *       - **`DRSFAULT_INCREASECAP`** : fault when trying to power on host to increase capacity
 *       - **`DRSFAULT_ENTERSTANDBY`** : fault when trying to power off host to decrease capacity
 *       - **`DRSFAULT_INSUFFICIENT_RESOURCES`** : fault when trying to reconfigure a VM's resources
 */
angular.module('com.vmware.vsphere.client.cluster').constant('drsConstants', {
   automationLevel: {
      MANUAL: 'manual',
      PARTIALLY_AUTOMATED: 'partiallyAutomated',
      FULLY_AUTOMATED: 'fullyAutomated'
   },
   AUTOMATION_LEVEL_DISABLED: 'disabled',
   migrationThreshold: {
      MIN: 1,
      MAX: 5,
      RANGE: [1, 2, 3, 4, 5]
   },
   dpmAutomationLevel: {
      DISABLED: '',
      MANUAL: 'manual',
      AUTOMATED: 'automated'
   },
   dpmThreshold: {
      MIN: 1,
      MAX: 5,
      RANGE: [1, 2, 3, 4, 5]
   },
   clusterRecommendationSpecOperation: {
      APPLY: 'apply',
      CANCEL: 'cancel',
      REFRESH: 'refresh'
   },
   faults: {
      DRSFAULT_POWERONVM: 'powerOnVm',
      DRSFAULT_INCREASECAP: 'increaseCapacity',
      DRSFAULT_ENTERSTANDBY: 'enterStandby',
      DRSFAULT_INSUFFICIENT_RESOURCES: 'unreservedCapacity'
   },
   drsPolicies: {
      EVEN_DISTRIBUTION_OPTION: 'TryBalanceVmsPerHost',
      EVEN_DISTRIBUTION_VALUE: '1',
      ALL_CONSUMED_MEMORY_METRIC_OPTION: 'PercentIdleMBInMemDemand',
      ALL_CONSUMED_MEMORY_METRIC_VALUE: '100',
      CPU_OVERCOMMITMENT_OPTION: 'MaxVcpusPerCore',
      CPU_OVERCOMMITMENT_MIN: 0,
      CPU_OVERCOMMITMENT_MAX: 500
   }
});

(function () {
   'use strict';

   /**
    * Provides faults text data.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .factory('drsFaultsService', drsFaultsService);

   drsFaultsService.$inject = ['i18nService', 'drsConstants', 'drsFaultsViewConstants',
         'drsFaultsViewService', 'iconService', 'feedbackService'];

   function drsFaultsService(i18nService, drsConstants, drsFaultsViewConstants,
         drsFaultsViewService, iconService, feedbackService) {

      return {
         getFaultMasterData: getFaultMasterData,
         getFaultDetailsData: getFaultDetailsData
      };

      function getDrsMigrationErrorLocalization(reason) {
         return i18nService.getString('Common', 'drs.migration.error.' + reason);
      }

      function getFaultMasterData(fault) {
         var target = {};

         if (fault.target) {
            var interpolationItem = {};

            interpolationItem[drsFaultsViewConstants.ID_KEY] = fault.target.provider;
            interpolationItem[drsFaultsViewConstants.NAME_KEY] = fault.target.name;
            var interpolations = [interpolationItem];

            target[drsFaultsViewConstants.TEXT_KEY] =
                  drsFaultsViewService.interpolateWithLinks('{0}', interpolations);
            target[drsFaultsViewConstants.ICON_KEY] =
                  iconService.getByObjectRef(fault.target.provider);
         }

         var gridItem = {};
         gridItem[drsFaultsViewConstants.LOCALIZED_REASON] =
               getDrsMigrationErrorLocalization(fault.reason);
         gridItem[drsFaultsViewConstants.REASON] = fault.reason;
         gridItem[drsFaultsViewConstants.TARGET_KEY] = fault.target ? target : '';
         gridItem[drsFaultsViewConstants.DETAILS_KEY] = fault.details;
         gridItem[drsFaultsViewConstants.ICON_KEY] = 'vsphere-icon-status-error';

         return gridItem;
      }

      function getFaultDetailsData(reason, details) {
         var gridItem = null;

         switch(reason) {
            case drsConstants.faults.DRSFAULT_POWERONVM: {
               gridItem = buildVmPlacementFaultItem(details);
               break;
            }
            case drsConstants.faults.DRSFAULT_INCREASECAP: {
               gridItem = buildHostPowerOnFaultItem(details);
               break;
            }
            case drsConstants.faults.DRSFAULT_ENTERSTANDBY: {
               gridItem = buldHostPowerOffFaultText(details);
               break;
            }
            case drsConstants.faults.DRSFAULT_INSUFFICIENT_RESOURCES: {
               var preventedRecommendation =
                     i18nService.getString('ClusterUi', 'drs.action.reconfigureHA');
               gridItem = buildGridItem(details, preventedRecommendation);
               break;
            }
            default: {
               if (!details.preventedRecommendation.targetVm) {
                  feedbackService
                        .sendDebugMessage('[DRS Faults] details.' +
                              'preventedRecommendation.targetVm is not defined', {
                           'reason': reason,
                           'details': details
                        });
               } else {
                  gridItem = buildMigrationFaultItem(details);
               }
            }
         }

         return gridItem;
      }

      // Make the "Power off host {0}" localized string with appropriate object
      // substitution.
      function buldHostPowerOffFaultText(details) {
         var preventedRecommendation = i18nService.getString('ClusterUi',
               'drs.faults.preventedRecommendation.powerOffHost');

         if (details.preventedRecommendation.targetHost) {
            preventedRecommendation = drsFaultsViewService.interpolateWithLinks(
                  i18nService.getString('ClusterUi', 'drs.action.powerOffHost'),
                  [getDestinationHostObject(details)]);
         }

         return buildGridItem(details, preventedRecommendation);
      }

      // Make the "Power on host {0}" localized string with appropriate object
      // substitution if a specific host has been recommended; otherwise, emit the
      // "Power on any host" message.
      function buildHostPowerOnFaultItem(details) {
         var preventedRecommendation = i18nService.getString('ClusterUi',
               'drs.action.powerOnAnyHost');

         if (details.preventedRecommendation.targetHost) {
            preventedRecommendation = drsFaultsViewService.interpolateWithLinks(
                  i18nService.getString('ClusterUi', 'drs.action.powerOnHost'),
                  [getDestinationHostObject(details)]);
         }

         return buildGridItem(details, preventedRecommendation);
      }

      // Make the "Place {0} at host {1}" localized string with appropriate object
      // substitution.
      function buildVmPlacementFaultItem(details) {
         var targetObjects = [
            getVmObject(details),
            getDestinationHostObject(details)
         ];

         var preventedRecommendation = drsFaultsViewService.interpolateWithLinks(
               i18nService.getString('ClusterUi', 'drs.action.placeVm'),
                     targetObjects);

         return buildGridItem(details, preventedRecommendation);
      }

      // Make the "Migrate {0} from {1} to {2}" localized string with appropriate object
      // substitution.
      function buildMigrationFaultItem(details) {
         var destinationHostLink = i18nService.getString('ClusterUi', 'anyHost');

         if (details.preventedRecommendation.targetHost) {
            destinationHostLink = getDestinationHostObject(details);
         }

         var targetObjects = [
            getVmObject(details),
            getSourceHostObject(details),
            destinationHostLink
         ];

         var preventedRecommendation =
               drsFaultsViewService.interpolateWithLinks(
                     i18nService.getString('ClusterUi', 'drs.action.migrateVm'),
                     targetObjects);

         return buildGridItem(details, preventedRecommendation);
      }

      function buildGridItem(details, preventedRecommendation) {
         var gridItem = {};
         gridItem[drsFaultsViewConstants.REASON] = buildReasonLink(
               details.faultDetailMessage, details.helpId);
         gridItem[drsFaultsViewConstants.REASON_ICON_CLASS] =
               'vsphere-icon-status-error';
         gridItem[drsFaultsViewConstants.PREVENTED_RECOMMENDATION] =
               preventedRecommendation;
         gridItem[drsFaultsViewConstants.PREVENTED_RECOMMENDATION_ICON_CLASS] =
               details.preventedRecommendationIcon;

         return gridItem;
      }

      function buildReasonLink(reason, helpId) {
         return '<a ng-click="$parent.$parent.openHelpLink(\'' + helpId + '\')">'
               + reason + '</a>';
      }

      function getSourceHostObject(details) {
         var targetVm = details.preventedRecommendation.targetVm;
         var sourceHostObject = {};
         sourceHostObject[drsFaultsViewConstants.ID_KEY] = targetVm.host;
         sourceHostObject[drsFaultsViewConstants.NAME_KEY] = targetVm.hostName;

         return sourceHostObject;
      }

      function getDestinationHostObject(details) {
         var targetHost = details.preventedRecommendation.targetHost;

         var destinationHostLink = {};
         destinationHostLink[drsFaultsViewConstants.ID_KEY] = targetHost.provider;
         destinationHostLink[drsFaultsViewConstants.NAME_KEY] = targetHost.name;

         return destinationHostLink;
      }

      function getVmObject(details) {
         var targetVm = details.preventedRecommendation.targetVm;
         var targetVmObject = {};

         targetVmObject[drsFaultsViewConstants.ID_KEY] = targetVm.provider;
         targetVmObject[drsFaultsViewConstants.NAME_KEY] = targetVm.name;

         return targetVmObject;
      }
   }
})();

(function() {
   'use strict';

   /**
    * Provides migration threshold text and description data, along with the initial
    * slider options.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('drsMigrationThresholdService', drsMigrationThresholdService);

   drsMigrationThresholdService.$inject = ['i18nService', 'drsConstants', 'logService'];

   function drsMigrationThresholdService(i18nService, drsConstants, logService) {
      var log = logService('drsMigrationThresholdService');

      return {
         getText: getText,
         getDescription: getDescription,
         MIN: drsConstants.migrationThreshold.MIN,
         MAX: drsConstants.migrationThreshold.MAX,
         DEFAULT: (drsConstants.migrationThreshold.MIN + drsConstants.migrationThreshold.MAX) / 2,
         MIN_LABEL: getString('drs.config.threshold.conservative'),
         MAX_LABEL: getString('drs.config.threshold.aggressive'),
         getDrsMigrationRate: getDrsMigrationRate
      };

      /**
       *  Retrieves the text associated with the provided migration threshold.
       *
       * @param {String} migrationThreshold
       * @returns {String}
       */
      function getText(migrationThreshold) {
         if (!migrationRateWithinRange(migrationThreshold)) {
            log.warn('Unexpected migration threshold: ' + migrationThreshold);
            return '';
         }
         var migrationThresholdKey = i18nService.interpolate(
            'drs.config.migrationThreshold.priority{0}', [migrationThreshold]);
         return getString(migrationThresholdKey);
      }

      /**
       * Retrieves the description associated with the provided migration threshold.
       *
       * @param {String} migrationThreshold
       * @returns {String}
       */
      function getDescription(migrationThreshold) {
         if (!migrationRateWithinRange(migrationThreshold)) {
            log.warn('Unexpected migration threshold: ' + migrationThreshold);
            return '';
         }
         var migrationThresholdKey = i18nService.interpolate(
            'drs.config.migrationThreshold.priority{0}Description', [migrationThreshold]);
         return getString(migrationThresholdKey);
      }

      function getDrsMigrationRate(drsMigrationThreshold) {
         return reverseRateAndThreshold(drsMigrationThreshold);
      }

      //------------------ Private Implementations ------------------

      function reverseRateAndThreshold(value) {
         if (!migrationRateWithinRange(value)) {
            log.warn('Unexpected migration threshold: ' + value);
            return NaN;
         }
         return drsConstants.migrationThreshold.MAX - value + drsConstants.migrationThreshold.MIN;
      }

      function migrationRateWithinRange(value) {
         return drsConstants.migrationThreshold.RANGE.indexOf(value) !== -1;
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();
var cluster_ui;
(function (cluster_ui) {
    var DrsPoliciesService = (function () {
        function DrsPoliciesService(i18nService) {
            this.i18nService = i18nService;
        }
        DrsPoliciesService.prototype.getEvenDistributionLabel = function (data) {
            return data.evenDistributionEnabled ?
                this.i18nService.getString("ClusterUi", "drs.config.evenDistribution.on") :
                this.i18nService.getString("ClusterUi", "drs.config.evenDistribution.off");
        };
        DrsPoliciesService.prototype.getConsumedOrActiveMemoryLabel = function (data) {
            return data.allConsumedMemoryMetricEnabled ?
                this.i18nService.getString("ClusterUi", "drs.config.consumedOrActiveMemory.consumed") :
                this.i18nService.getString("ClusterUi", "drs.config.consumedOrActiveMemory.active");
        };
        DrsPoliciesService.prototype.getCpuOverCommitmentLabel = function (data) {
            return !data.cpuOverCommitment ?
                this.i18nService.getString("ClusterUi", "drs.config.cpuOverCommitment.notConfigured") :
                this.getCpuOvercommitmentText(data.cpuOverCommitmentPercent);
        };
        DrsPoliciesService.prototype.getCpuOvercommitmentText = function (percent) {
            if (percent === 0) {
                return this.i18nService.getString("ClusterUi", "drs.config.cpuOverCommitment.notAllowed");
            }
            return this.i18nService.getString("ClusterUi", "drs.config.cpuOverCommitment.allowed", percent);
        };
        DrsPoliciesService.$inject = ["i18nService"];
        return DrsPoliciesService;
    }());
    cluster_ui.DrsPoliciesService = DrsPoliciesService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("drsPoliciesService", DrsPoliciesService);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('editProactiveHaService', editProactiveHaService);

   editProactiveHaService.$inject = ['i18nService', 'clusterConstants', 'vuiConstants',
      'dataService', 'columnRenderersRegistry'];

   function editProactiveHaService(i18nService, clusterConstants,
         vuiConstants, dataService, columnRenderersRegistry) {

      var getString = _.bind(i18nService.getString, i18nService, 'ClusterUi');

      return {
         getFormData: getFormData,
         getRemediationLevelDescription: getRemediationLevelDescription,
         getAutomationLevelDescription: getAutomationLevelDescription,
         getFilterForProvider: getFilterForProvider,
         failureConditionsVuiSignPost: failureConditionsVuiSignPost,
         getFailureConditionsHostsDatagridOptions: getFailureConditionsHostsDatagridOptions,
         failureConditionsClusterLevelVuiSignPost: failureConditionsClusterLevelVuiSignPost,
         getFilterModelSpec: getFilterModelSpec,
         getBlockAtValue: getBlockAtValue,
         REMEDIATION_LEVELS: [
            {
               value: clusterConstants.proactiveHaRemediationLevel.BALANCED,
               label: getString('ha.config.failures.responses.partial.failure.remediation.dd.balanced')
            },
            {
               value: clusterConstants.proactiveHaRemediationLevel.QUARANTINE,
               label: getString('ha.config.failures.responses.partial.failure.remediation.dd.quarantinemode')
            },
            {
               value: clusterConstants.proactiveHaRemediationLevel.MAINTENANCE,
               label: getString('ha.config.failures.responses.partial.failure.remediation.dd.maintenancemode')
            }
         ],
         AUTOMATION_LEVELS: [
            {
               value: clusterConstants.proactiveHaAutomationLevel.AUTOMATED,
               label: getString('ha.portlet.host.partial.failure.response.Automated')
            },
            {
               value: clusterConstants.proactiveHaAutomationLevel.MANUAL,
               label: getString('ha.portlet.host.partial.failure.response.Manual')
            }
         ]
      };

      function getFormData(proHaEnabled, automationLevel, remediationLevel, clusterProviders) {
         var formData = {
            infraUpdateHaConfig: {
               enabled: proHaEnabled
            }
         };

         if (proHaEnabled) {
            formData.infraUpdateHaConfig.behavior = automationLevel;
            switch (String(remediationLevel)) {
               case clusterConstants.proactiveHaRemediationLevel.QUARANTINE:
                  formData.infraUpdateHaConfig.moderateRemediation =
                        clusterConstants.proactiveHaRemediationMode.QUARANTINE_MODE;
                  formData.infraUpdateHaConfig.severeRemediation =
                        clusterConstants.proactiveHaRemediationMode.QUARANTINE_MODE;
                  break;
               case clusterConstants.proactiveHaRemediationLevel.BALANCED:
                  formData.infraUpdateHaConfig.moderateRemediation =
                        clusterConstants.proactiveHaRemediationMode.QUARANTINE_MODE;
                  formData.infraUpdateHaConfig.severeRemediation =
                        clusterConstants.proactiveHaRemediationMode.MAINTENANCE_MODE;
                  break;
               default:
                  formData.infraUpdateHaConfig.moderateRemediation =
                        clusterConstants.proactiveHaRemediationMode.MAINTENANCE_MODE;
                  formData.infraUpdateHaConfig.severeRemediation =
                        clusterConstants.proactiveHaRemediationMode.MAINTENANCE_MODE;
            }

            formData.infraUpdateHaConfig.providers = _.filter(clusterProviders, function(clusterProvider) {
               return clusterProvider.isEnabled;
            }).map(function(clusterProvider) {
               return clusterProvider.idProvider;
            });
         }

         return formData;
      }

      function getRemediationLevelDescription(remediationLevel) {
         if (clusterConstants.proactiveHaRemediationLevel.QUARANTINE === remediationLevel) {
            return getString('ha.config.failures.responses.partial.failure.remediation.quarantine.desc');
         } else if (clusterConstants.proactiveHaRemediationLevel.BALANCED === remediationLevel) {
            return getString('ha.config.failures.responses.partial.failure.remediation.balanced.desc');
         } else {
            return getString('ha.config.failures.responses.partial.failure.remediation.maintenance.desc');
         }
      }

      function getAutomationLevelDescription(automationLevel) {
         if (clusterConstants.proactiveHaAutomationLevel.MANUAL === automationLevel) {
            return getString('ha.config.failures.responses.partial.failure.automation.manual.desc');
         } else {
            return getString('ha.config.failures.responses.partial.failure.automation.automated.desc');
         }
      }

      function getFilterForProvider(clusterId, providerId) {
         var params = {
            propertyParams: [{
               propertyName: 'filterForProvider',
               parameterType: 'java.lang.String',
               parameter: providerId
            }]
         };
         return dataService.getProperties(clusterId, ['filterForProvider'], params);
      }

      function failureConditionsVuiSignPost() {
         return {
            message: i18nService.getString('ClusterUi', 'ha.config.failures.responses.partial.filter.desc'),
            title: i18nService.getString('ClusterUi', 'ha.config.failures.responses.partial.filter.label')
         };
      }

      function failureConditionsClusterLevelVuiSignPost() {
         return {
            message: i18nService.getString('ClusterUi', 'ha.config.failures.responses.partial.failure.filters.clusterLevelVuiSignPost.desc'),
            title: i18nService.getString('ClusterUi', 'ha.config.failures.responses.partial.failure.filters.clusterLevelVuiSignPost.title')
         };
      }

      function getFailureConditionsHostsDatagridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.MULTI,
            showCheckboxesOnMultiSelection: true,
            sortMode: vuiConstants.grid.sortMode.NONE,
            searchable: false,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getFailureConditionsHostColumnDefs()
         };
      }

      function getFilterModelSpec(blockAtValue, filterModel, selectedComponents, selectedHosts) {
         var isClusterLevelSet =
               blockAtValue && blockAtValue === clusterConstants.proactiveHaBlockAtTypes.CLUSTER_LEVEL;

         var filterHostInfo;
         if (isClusterLevelSet) {
            filterHostInfo = filterModel.filterHostInfo;
         } else if (blockAtValue === clusterConstants.proactiveHaBlockAtTypes.INDIVIDUAL_HOSTS) {
            filterHostInfo =
                  selectedHosts;
         } else {
            filterHostInfo = [];
         }

         // Remove the unchecked failure conditions
         var filterHealthUpdateInfo = selectedComponents;
         filterHealthUpdateInfo = _.filter(filterHealthUpdateInfo, function(item) {
            return item.isFilterOn;
         });

         return {
            name: filterModel.name,
            id: filterModel.id,
            providerId: filterModel.providerId,
            providerName: filterModel.providerName,
            isClusterLevelSet: isClusterLevelSet,
            filterHealthUpdateInfo: filterHealthUpdateInfo,
            filterHostInfo: filterHostInfo
         };
      }

      function getBlockAtValue(filterHealthUpdateInfo, filterHostInfo) {
         var atLeastOneComponentIsSelected =
               _.some(filterHealthUpdateInfo, function(item) {
                  return item.isFilterOn;
               });

         var atLeastOneHostIsFiltered = _.some(filterHostInfo, function(item) {
            return item.isFilterOn;
         });

         var blockAtValue;
         if (atLeastOneComponentIsSelected) {
            blockAtValue = atLeastOneHostIsFiltered ?
                  clusterConstants.proactiveHaBlockAtTypes.INDIVIDUAL_HOSTS :
                  clusterConstants.proactiveHaBlockAtTypes.CLUSTER_LEVEL;
         }

         return blockAtValue;
      }


      function getFailureConditionsHostColumnDefs() {
         return [
            {
               displayName: i18nService.getString(
                     'ClusterUi',
                     'ha.config.failures.responses.partial.failure.filters.grid.hosts'
               ),
               template: function(data) {
                  return data && data.name ? getIconRenderer(data) : null;
               }
            }
         ];
      }

      function getIconRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');
         return renderer(['icon', 'text'], {
            icon: 'vsphere-icon-cluster',
            text: data.name
         });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   /**
    * Service for Resource Pool management.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .factory('editResourcePoolService', [function() {
         function editDefaultResourcePoolSpec() {
            var spec = {
               configSpec: {
                  _type: 'com.vmware.vim.binding.vim.ResourceConfigSpec',
                  cpuAllocation: {
                     _type: 'com.vmware.vim.binding.vim.ResourceAllocationInfo',
                     expandableReservation: true,
                     limit: -1,
                     reservation: 0,
                     shares: {
                        _type: 'com.vmware.vim.binding.vim.SharesInfo',
                        level: 'normal',
                        shares: 4000
                     }
                  },
                  memoryAllocation: {
                     _type: 'com.vmware.vim.binding.vim.ResourceAllocationInfo',
                     expandableReservation: true,
                     limit: -1,
                     reservation: 0,
                     shares: {
                        _type: 'com.vmware.vim.binding.vim.SharesInfo',
                        level: 'normal',
                        shares: 163840
                     }
                  }
               }
            };

            return spec;
         }

         return {
            editDefaultResourcePoolSpec: editDefaultResourcePoolSpec
         };
      }]);
})();

/**
 * @name com.vmware.vsphere.client.cluster:evcConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `evcConstants` service holds cluster EVC related constants.
 *
 *    List of available constants:
 *
 *    - cpuVendor
 *       - **`UNKNOWN`** : Unknown CPU vendor
 *       - **`AMD`** : AMD CPU vendor
 *       - **`INTEL`** : Intel CPU vendor
 */
angular.module('com.vmware.vsphere.client.cluster').constant('evcConstants', {
   cpuVendor : {
      UNKNOWN : 'unknown',
      AMD : 'amd',
      INTEL : 'intel'
   }
});

(function () {
   'use strict';

   /**
    * Provides admission policy text and description data.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('haAdmissionControlService', haAdmissionControlService);

   haAdmissionControlService.$inject = ['i18nService', 'haConstants', 'logService',
      'defaultUriSchemeUtil'];

   function haAdmissionControlService(i18nService, haConstants, logService,
                                      defaultUriSchemeUtil) {
      var log = logService('haAdmissionControlService');

      var FAILOVER_LEVEL_DEFAULT_VALUE = 1;
      var FIXED_SLOT_SIZE_CPU_DEFAULT = 32;
      var FIXED_SLOT_SIZE_MEMORY_DEFAULT = 100;

      /**
       * Retrieves admission control data.
       */
      function getAdmissionControlModel(haData) {
         var model = {};
         if (!haData || haData.admissionControlEnabled === null ||
               !angular.isDefined(haData.admissionControlEnabled)) {
            log.error("HA data is not set: " + haData);
            return model;
         }

         if (!haData.admissionControlEnabled) {
            model.policyLabel = getString('policy.disabled.label');
            model.policyType = haConstants.admissionControlPolicy.DISABLED_TYPE;
            return model;
         }

         if (!haData.admissionControlPolicy) {
            log.error("Admission control policy is not defined: " + haData);
            return model;
         }

         return createAdmissionControlPolicyViewData(haData);
      }

      /**
       * Retrieves admission policy data.
       */
      function createAdmissionControlPolicyViewData(haData) {
         var model = {};
         model.policyType = haData.admissionControlPolicy._type;
         switch (haData.admissionControlPolicy._type) {
            case haConstants.admissionControlPolicy.FAILOVER_LEVEL_TYPE:
               model.policyLabel = getString('policy.failoverlevel.label');
               model.reservedFailoverCapacity = getNumberOfHostsLabel(
                     haData.failoverHostNum);
               break;
            case haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE:
               model.policyLabel = getString('policy.failoverResources.label');
               model.cpuFailoverInPercent = getString('failoverResources.percent',
                     haData.cpuFailoverPercent);
               model.memoryFailoverInPercent = getString('failoverResources.percent',
                     haData.memoryFailoverPercent);
               break;
            case haConstants.admissionControlPolicy.FAILOVER_HOSTS_TYPE:
               model.policyLabel = getString('policy.failoverHosts.label');
               model.dedicatedHosts = getNumberOfHostsLabel(haData.dedicatedHostNum);
               break;
            default:
               log.warnings("Unknown admission policy: " +
                     haData.admissionControlPolicy._type);
         }
         return model;
      }

      /**
       * Retrieves a label for the number of hosts.
       */
      function getNumberOfHostsLabel(numOfHosts) {
         var label = "";
         if (numOfHosts === 1) {
            label = getString('host', numOfHosts);
         } else if (numOfHosts > 1) {
            label = getString('host.plural', numOfHosts);
         }
         return label;
      }

      /**
       * Retrieves admission control policies
       */
      function getPolicies() {
         var policies =
               Object.keys(haConstants.admissionControlPolicy).map(function(key) {
                  var policyType = haConstants.admissionControlPolicy[key];
                  var policy = buildPolicy(policyType);
                  return policy;
               });

         return policies;
      }

      function buildPolicy(policyType) {
         return {
            type: policyType,
            label: getLabel(policyType)
         };
      }

      /**
       * Retrieves service for admission control failover hosts processing.
       *
       * @param pageModel admission control page model
       */
      function getFailoverHostsService(pageModel) {
         var failoverHostsModel = pageModel;

         /**
          * Retrieves data for failover hosts grid.
          *
          * @returns Array of failover hosts
          */
         function getFailoverHostsGridData() {
            return failoverHostsModel.failoverHosts;
         }

         /**
          * Retrieves object id-s of failover hosts
          * @returns Array of host object id-s
          */
         function getFailoverHostIds() {
            var dedicatedFailoverHostIds = _.map(
                  failoverHostsModel.failoverHosts, function(hostMor) {
                     return defaultUriSchemeUtil.getVsphereObjectId(hostMor.provider);
                  });

            return dedicatedFailoverHostIds;
         }

         /**
          * Adds selected hosts to failover hosts model and grid data.
          *
          * @param failoverHostsGridData
          * @param selectedObjects
          * @returns {boolean}
          */
         function addFailoverHosts(failoverHostsGridData, selectedItems) {
            var newHostItems = _.map(selectedItems, function(selectedItem) {
               return generateHostItem(selectedItem);
            });

            failoverHostsGridData.data =
                  failoverHostsGridData.data.concat(newHostItems);
            failoverHostsModel.failoverHosts = failoverHostsGridData.data;

            return true;
         }

         /**
          * Remove selected host from failover hosts model and grid data.
          *
          * @param failoverHostsGridData
          * @param selectedObjects
          */
         function removeFailoverHost(failoverHostsGridData, itemsToRemove) {
            failoverHostsGridData.data = _.reject(failoverHostsGridData.data,
                  function(hostData) {
                     return !!_.find(itemsToRemove,
                           function(itemToRemove) {
                              return itemToRemove.name === hostData.name;
                           }
                     );
                  });

            failoverHostsModel.failoverHosts = failoverHostsGridData.data;
         }

         function generateHostItem(selectedItem) {
            var hostMor = defaultUriSchemeUtil.getPartsFromVsphereObjectId(
                  selectedItem.rawData.id);
            return {
               iconId: selectedItem.rawData.icon,
               name: selectedItem.rawData.name,
               provider: hostMor
            };
         }

         return {
            getFailoverHostsGridData: getFailoverHostsGridData,
            getFailoverHostIds: getFailoverHostIds,
            addFailoverHosts: addFailoverHosts,
            removeFailoverHost: removeFailoverHost
         };

      }

      function getFailoverLevelDefaultValue() {
         return FAILOVER_LEVEL_DEFAULT_VALUE;
      }

      function getFixedSlotSizeCpuDefaultValue() {
         return FIXED_SLOT_SIZE_CPU_DEFAULT;
      }

      function getFixedSlotSizeMemoryDefaultValue() {
         return FIXED_SLOT_SIZE_MEMORY_DEFAULT;
      }

      function getLabel(policyType) {
         var policyLabel;
         switch (policyType) {
            case haConstants.admissionControlPolicy.FAILOVER_LEVEL_TYPE:
               policyLabel = 
                     'ha.config.admission.control.failover.policy.label.failoverLevel';
               break;
            case haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE:
               policyLabel = 
                     'ha.config.admission.control.failover.policy.label.failoverResources';
               break;
            case haConstants.admissionControlPolicy.FAILOVER_HOSTS_TYPE:
               policyLabel = 
                     'ha.config.admission.control.failover.policy.label.failoverHosts';
               break;
            case haConstants.admissionControlPolicy.DISABLED_TYPE:
               policyLabel = 'ha.config.admission.control.failover.policy.label.disabled';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', policyLabel);
      }

      function getString(key, args) {
         return i18nService.getString('ClusterUi', 'ha.config.admission.control.' + key,
               args);
      }

      return {
         getAdmissionControlModel: getAdmissionControlModel,
         getPolicies: getPolicies,
         getFailoverHostsService: getFailoverHostsService,
         getFailoverLevelDefaultValue: getFailoverLevelDefaultValue,
         getFixedSlotSizeCpuDefaultValue: getFixedSlotSizeCpuDefaultValue,
         getFixedSlotSizeMemoryDefaultValue: getFixedSlotSizeMemoryDefaultValue
      };
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
      .service('haApdResponseService', haApdResponseService);

   haApdResponseService.$inject = ['i18nService', 'haConstants'];

   function haApdResponseService(i18nService, haConstants) {

      var apdResponseLabels = {};
      var apdResponseDescriptions = {};

      apdResponseLabels[haConstants.storageVmReaction.DISABLED] =
         getString('ha.config.failures.responses.ds.dswithapd.disabled');
      apdResponseLabels[haConstants.storageVmReaction.WARNING] =
         getString('ha.config.failures.responses.ds.dswithapd.issue.events');
      apdResponseLabels[haConstants.storageVmReaction.RESTART_CONSERVATIVE] =
         getString('ha.config.failures.responses.ds.dswithapd.conservative');
      apdResponseLabels[haConstants.storageVmReaction.RESTART_AGGRESSIVE] =
         getString('ha.config.failures.responses.ds.dswithapd.aggressive');

      apdResponseDescriptions[haConstants.storageVmReaction.DISABLED] =
         getString('ha.config.failures.responses.ds.dswithapd.disabled.desc');
      apdResponseDescriptions[haConstants.storageVmReaction.WARNING] =
         getString('ha.config.failures.responses.ds.dswithapd.issue.events.desc');
      apdResponseDescriptions[haConstants.storageVmReaction.RESTART_CONSERVATIVE] =
         getString('ha.config.failures.responses.ds.dswithapd.conservative.desc');
      apdResponseDescriptions[haConstants.storageVmReaction.RESTART_AGGRESSIVE] =
         getString('ha.config.failures.responses.ds.dswithapd.aggressive.desc');

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function getResponses() {
         return _.map(haConstants.storageVmReaction, function(reaction) {
            return {
               id: reaction,
               label: apdResponseLabels[reaction],
               description: apdResponseDescriptions[reaction]
            };
         });
      }

      return {
         getResponses: getResponses
      };
   }
})();

/**
 * @description
 *    The `haConfigIssuesConstants` service holds HA configuration issues related constants.
 */
angular.module('com.vmware.vsphere.client.cluster').constant('haConfigIssuesConstants', {
   hostRole : {
      SLAVE : 'slave',
      MASTER : 'master'
   },

   issueCategory: {
      INFO: 'info',
      WARNING: 'warning',
      ERROR: 'error'
   },

   iconClass: {
      NONE: 'vx-icon-issueStatusNone',
      WARNING: 'vx-icon-issueStatusWarning',
      ERROR: 'vx-icon-issueStatusError',
      INFO: 'vx-icon-issueStatusInfo'
   }
});

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('haConfigIssuesService', haConfigIssuesService);

   haConfigIssuesService.$inject = ['i18nService', 'haConfigIssuesConstants'];

   function haConfigIssuesService(i18nService, haConfigIssuesConstants) {

      function getHostRoleFormatted(hostRole) {
         if(hostRole === haConfigIssuesConstants.hostRole.SLAVE){
            return i18nService.getString('ClusterUi', 'ha.config.issues.slave.role');
         }
         return i18nService.getString('ClusterUi', 'ha.config.issues.master.role');
      }

      function getIssueMessageIcon(issueConfig) {
         if(issueConfig.issueCategory === null ||
               issueConfig.issue.fullFormattedMessage === null) {
            return haConfigIssuesConstants.iconClass.NONE;
         }
         if (issueConfig.issueCategory === haConfigIssuesConstants.issueCategory.ERROR) {
            return haConfigIssuesConstants.iconClass.ERROR;
         }
         if (issueConfig.issueCategory ===
               haConfigIssuesConstants.issueCategory.WARNING) {
            return haConfigIssuesConstants.iconClass.WARNING;
         }
         if (issueConfig.issueCategory === haConfigIssuesConstants.issueCategory.INFO) {
            return haConfigIssuesConstants.iconClass.INFO;
         }
         return haConfigIssuesConstants.iconClass.NONE;

      }

      return {
         getIssueMessageIcon: getIssueMessageIcon,
         getHostRoleFormatted: getHostRoleFormatted
      };
   }
})();

/**
 * @name com.vmware.vsphere.client.cluster:haConstants
 * @module com.vmware.vsphere.client.cluster
 *
 * @description
 *    The `haConstants` service holds cluster HA related constants.
 *
 *    List of available constants:
 *
 *    - admissionControlPolicy
 *       - **`FAILOVER_LEVEL_TYPE`** : Failover level admission control policy type
 *       - **`FAILOVER_RESOURCES`** : Failover resource admission control policy type
 *       - **`FAILOVER_HOSTS_TYPE`** : Failover host admission control policy type
 *       - **`DISABLED_TYPE`** : Failover host admission control policy type
 *    - haVmMonitoring (ClusterDasConfigInfo.vmMonitoring enum values)
 *       - **`DISABLED`** : VM monitoring feature is not enabled.
 *       - **`VM_ONLY`** : Only VMs are monitored.
 *       - **`VM_AND_APP`** : Both VMs and Apps are monitored.
 *    - hostMonitoringState (ClusterDasConfigInfo.hostMonitoring)
 *       - **`ENABLED`** : Host monitoring feature is not enabled.
 *       - **`DISABLED`** : Host monitoring feature is not enabled.
 *    - restartPriority (ClusterDasConfigInfo.defaultVmSettings.restartPriority)
 *       - **`DISABLED`** : Restart priority is disabled.
 *       - **`LOW`** : Lower priority when restarting
 *       - **`MEDIUM`** : Medium priority when restarting
 *       - **`HIGH`** : Higher priority when restarting
 *    - hostIsolationResponse (ClusterDasConfigInfo.defaultVmSettings.isolationResponse)
 *       - **`LEAVE_POWERED_ON`** : Do not power off the virtual machine in the event of
 *             a host network isolation.
 *       - **`POWER_OFF_AND_FAILOVER`** : Power off the virtual machine in the event
 *             of a host network isolation.
 *       - **`SHUT_DOWN_AND_FAILOVER`** : Shut down the virtual machine guest operating
 *             system in the event of a host network isolation.
 *    - vmMonitoringSensitivity
 *       - low values for different options for low VM monitoring sensitivity
 *          - ** `FAILURE_INTERVAL` ** : value for failureInterval
 *          - ** `MIN_UPTIME` ** : value for minUpTime
 *          - ** `MAX_FAILURES` ** : value for maxFailures
 *          - ** `FAILURE_WINDOW` ** : value for maxFailureWindow
 *       - medium values for different options for medium VM monitoring sensitivity
 *          - ** `FAILURE_INTERVAL` ** : value for failureInterval
 *          - ** `MIN_UPTIME` ** : value for minUpTime
 *          - ** `MAX_FAILURES` ** : value for maxFailures
 *          - ** `FAILURE_WINDOW` ** : value for maxFailureWindow
 *       - high values for different options for high VM monitoring sensitivity
 *          - ** `FAILURE_INTERVAL` ** : value for failureInterval
 *          - ** `MIN_UPTIME` ** : value for minUpTime
 *          - ** `MAX_FAILURES` ** : value for maxFailures
 *          - ** `FAILURE_WINDOW` ** : value for maxFailureWindow
 *       - ** `NO_FAILURE_WINDOW` ** : value for maxFailureWindow for case when
 *             no failure window is defined
 *    - hbDatastoreCandidatePolicy (ClusterDasConfigInfoHBDatastoreCandidate)
 *       - **`AUTO_SELECT`** : vCenter Server chooses heartbeat datastores from all the
 *             feasible ones.
 *       - **`USER_SELECTED_ONLY`** : vCenter Server chooses heartbeat datastores from
 *             the set specified by the user.
 *       - **`USER_SELECTED_WITH_AUTO_SELECTED`** : vCenter Server chooses heartbeat
 *             datastores from all the feasible ones while giving preference to those
 *             specified by the user.
 */
angular.module('com.vmware.vsphere.client.cluster').constant('haConstants', {
   SECONDS_IN_A_MINUTE: 60,
   MAX_POST_READY_DELAY: 3600,
   MAX_RESTART_PRIORITY_TIMEOUT: 86400,
   MAX_FAILURE_INTERVAL: 100000,
   MAX_MINIMUM_UPTIME: 100000,
   MAX_VM_PER_RESET: 1000,
   MIN_RESETS_WINDOW_HRS: 1,
   MAX_RESETS_WINDOW_HRS: 1000,
   MAX_VM_FAILOVER_DELAY: 35791394,
   MIN_NUMBER_INPUT: 0,
   admissionControlPolicy: {
      DISABLED_TYPE: 'disabled',
      FAILOVER_LEVEL_TYPE: 'com.vmware.vim.binding.vim.cluster.FailoverLevelAdmissionControlPolicy',
      FAILOVER_RESOURCES_TYPE: 'com.vmware.vim.binding.vim.cluster.FailoverResourcesAdmissionControlPolicy',
      FAILOVER_HOSTS_TYPE: 'com.vmware.vim.binding.vim.cluster.FailoverHostAdmissionControlPolicy'
   },
   slotSizePolicy: {
      COVER_ALL_VM: 'coverAllVm',
      FIXED_SIZE: 'fixedSize'
   },
   vmMonitoring: {
      DISABLED: 'vmMonitoringDisabled',
      VM_ONLY: 'vmMonitoringOnly',
      VM_AND_APP: 'vmAndAppMonitoring'
   },
   // TODO remove references to hostMonitoringState and replace with serviceState
   hostMonitoringState: {
      ENABLED: 'enabled',
      DISABLED: 'disabled'
   },
   serviceState: {
      ENABLED: 'enabled',
      DISABLED: 'disabled'
   },
   restartPriority: {
      DISABLED: 'disabled',
      LOWEST: 'lowest',
      LOW: 'low',
      MEDIUM: 'medium',
      HIGH: 'high',
      HIGHEST: 'highest'
   },
   readyCondition: {
      NONE: "none",
      POWERED_ON: "poweredOn",
      APP_HEARTBEAT_DETECTED: "appHbStatusGreen",
      GUEST_HEARTBEAT_DETECTED: "guestHbStatusGreen"
   },
   hostIsolationResponse: {
      LEAVE_POWERED_ON: 'none',
      POWER_OFF_AND_FAILOVER: 'powerOff',
      SHUT_DOWN_AND_FAILOVER: 'shutdown'
   },
   vmMonitoringSensitivity: {
      low: {
         FAILURE_INTERVAL: 120,
         MIN_UPTIME: 480,
         MAX_FAILURES: 3,
         FAILURE_WINDOW: 168,
         HAS_WINDOW: true
      },
      medium: {
         FAILURE_INTERVAL: 60,
         MIN_UPTIME: 240,
         MAX_FAILURES: 3,
         FAILURE_WINDOW: 24,
         HAS_WINDOW: true
      },
      high: {
         FAILURE_INTERVAL: 30,
         MIN_UPTIME: 120,
         MAX_FAILURES: 3,
         FAILURE_WINDOW: 1,
         HAS_WINDOW: true
      },
      NO_FAILURE_WINDOW: -1
   },
   hbDatastoreCandidatePolicy: {
      AUTO_SELECT: 'allFeasibleDs',
      USER_SELECTED_ONLY: 'userSelectedDs',
      USER_SELECTED_WITH_AUTO_SELECTED: 'allFeasibleDsWithUserPreference'
   },
   storageVmReaction: {
      DISABLED: 'disabled',
      WARNING: 'warning',
      RESTART_CONSERVATIVE: 'restartConservative',
      RESTART_AGGRESSIVE: 'restartAggressive'
   },
   vmReactionOnApdCleared: {
      NONE: 'none',
      RESET: 'reset',
      USE_CLUSTER_DEFAULT: 'useClusterDefault'
   }
});

(function() {
   'use strict';

   /**
    * Provides properties for the HA host failure responses and VM restart priority.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .service('haHostFailureResponseService', haHostFailureResponseService);

   haHostFailureResponseService.$inject = ['i18nService', 'haConstants'];

   function haHostFailureResponseService(i18nService, haConstants) {
      return {
         getDisabledOption: getDisabledOption,
         getVmRestartPriorityOptions: getVmRestartPriorityOptions,
         getReadyConditionOptions: getReadyConditionOptions,
         getVmOrchestrationReadyConditions: getVmOrchestrationReadyConditions
      };

      function getDisabledOption() {
         return {
            id: haConstants.restartPriority.DISABLED,
            label: getString('ha.config.failures.responses.host.failure.vm.restart.disabled'),
            description: getString('ha.config.failures.responses.host.failure.vm.restart.disabled.desc')
         };
      }

      function getVmRestartPriorityOptions(is65VcOrLater) {
         var vmRestartPriorityOptions = {};

         if (is65VcOrLater) {
            vmRestartPriorityOptions.lowest = {
               id: haConstants.restartPriority.LOWEST,
               label: getString('ha.config.vm.vmRestartPriority.lowest')
            };
         }

         vmRestartPriorityOptions = angular.extend(vmRestartPriorityOptions, {
            low: {
               id: haConstants.restartPriority.LOW,
               label: getString('ha.config.vm.vmRestartPriority.low')
            },
            medium: {
               id: haConstants.restartPriority.MEDIUM,
               label: getString('ha.config.vm.vmRestartPriority.medium')
            },
            high: {
               id: haConstants.restartPriority.HIGH,
               label: getString('ha.config.vm.vmRestartPriority.high')
            }
         });

         if (is65VcOrLater) {
            vmRestartPriorityOptions.highest = {
               id: haConstants.restartPriority.HIGHEST,
               label: getString('ha.config.vm.vmRestartPriority.highest')
            };
         }

         return vmRestartPriorityOptions;
      }

      function getVmOrchestrationReadyConditions() {
         return {
            none: {
               id: haConstants.readyCondition.NONE,
               label: getString('ha.config.failures.responses.host.failure.restart.readiness.none')
            },
            poweredOn: {
               id: haConstants.readyCondition.POWERED_ON,
               label: getString('ha.config.failures.responses.host.failure.restart.readiness.poweredOn')
            },
            guestHbStatusGreen: {
               id: haConstants.readyCondition.GUEST_HEARTBEAT_DETECTED,
               label: getString('ha.config.failures.responses.host.failure.restart.readiness.guestHbStatusGreen')
            },
            appHbStatusGreen: {
               id: haConstants.readyCondition.APP_HEARTBEAT_DETECTED,
               label: getString('ha.config.failures.responses.host.failure.restart.readiness.appHbStatusGreen')
            }
         };
      }

      function getReadyConditionOptions() {
         return {
            none: {
               id: haConstants.readyCondition.NONE,
               label: getString(
                     'ha.config.failures.responses.host.failure.restart.readiness.none')
            },
            poweredOn: {
               id: haConstants.readyCondition.POWERED_ON,
               label: getString(
                     'ha.config.failures.responses.host.failure.restart.readiness.poweredOn')
            },
            guestHbDetected: {
               id: haConstants.readyCondition.GUEST_HEARTBEAT_DETECTED,
               label: getString(
                     'ha.config.failures.responses.host.failure.restart.readiness.guestHbStatusGreen')
            },
            appHbDetected: {
               id: haConstants.readyCondition.APP_HEARTBEAT_DETECTED,
               label: getString(
                     'ha.config.failures.responses.host.failure.restart.readiness.appHbStatusGreen')
            }
         };
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

(function() {
   'use strict';

   /**
    * Service that provides HA host isolation response related information.
    * Each isolation response info contains id, label and description.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('haHostIsolationResponseService', haHostIsolationResponseService);

   haHostIsolationResponseService.$inject = ['i18nService', 'haConstants'];

   function haHostIsolationResponseService(i18nService, haConstants) {
      return {
         getResponses: getResponses,
         getEnsureFtResponse: getEnsureFtResponse
      };

      function getResponses() {
         var hostIsolationResponses =
            Object.keys(haConstants.hostIsolationResponse).map(function(key) {
               var responseKey = haConstants.hostIsolationResponse[key];
               var isolationResponse = buildIsolationResponse(responseKey);
               return isolationResponse;
            });

         return hostIsolationResponses;
      }

      function getEnsureFtResponse() {
         return [{
            id: "EnsureFT",
            label: i18nService.getString("ClusterUi",
                  "vmOverrides.haHostIsolationResponse.EnsureFT")
         }];
      }

      function buildIsolationResponse(responseKey) {
         return {
            id: responseKey,
            label: getLabel(responseKey),
            description: getDescription(responseKey)
         };
      }

      function getLabel(responseKey) {
         var responseTextKey;
         switch (responseKey) {
            case haConstants.hostIsolationResponse.LEAVE_POWERED_ON:
               responseTextKey = 'ha.config.failures.responses.host.isolation.response.disabled';
               break;
            case haConstants.hostIsolationResponse.SHUT_DOWN_AND_FAILOVER:
               responseTextKey = 'ha.config.failures.responses.host.isolation.response.shutdown';
               break;
            case haConstants.hostIsolationResponse.POWER_OFF_AND_FAILOVER:
               responseTextKey = 'ha.config.failures.responses.host.isolation.response.poweroff';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', responseTextKey);
      }

      function getDescription(responseKey) {
         var responseDescKey;
         switch (responseKey) {
            case haConstants.hostIsolationResponse.LEAVE_POWERED_ON:
               responseDescKey = 'ha.config.failures.responses.host.isolation.response.disabled.desc';
               break;
            case haConstants.hostIsolationResponse.SHUT_DOWN_AND_FAILOVER:
               responseDescKey = 'ha.config.failures.responses.host.isolation.response.shutdown.desc';
               break;
            case haConstants.hostIsolationResponse.POWER_OFF_AND_FAILOVER:
               responseDescKey = 'ha.config.failures.responses.host.isolation.response.poweroff.desc';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', responseDescKey);
      }
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('haPdlResponseService', haPdlResponseService);

   haPdlResponseService.$inject = ['i18nService', 'haConstants'];

   function haPdlResponseService(i18nService, haConstants) {

      var pdlResponseLabels = {};
      var pdlResponseDescriptions = {};
      var possiblePdlResponses = [
         haConstants.storageVmReaction.DISABLED,
         haConstants.storageVmReaction.WARNING,
         haConstants.storageVmReaction.RESTART_AGGRESSIVE
      ];

      pdlResponseLabels[haConstants.storageVmReaction.DISABLED] =
            getString('ha.config.failures.responses.ds.dswithpdl.disabled');
      pdlResponseLabels[haConstants.storageVmReaction.WARNING] =
            getString('ha.config.failures.responses.ds.dswithpdl.issue.events');
      pdlResponseLabels[haConstants.storageVmReaction.RESTART_AGGRESSIVE] =
            getString('ha.config.failures.responses.ds.dswithpdl.power.off');

      pdlResponseDescriptions[haConstants.storageVmReaction.DISABLED] =
            getString('ha.config.failures.responses.ds.dswithpdl.disabled.desc');
      pdlResponseDescriptions[haConstants.storageVmReaction.WARNING] =
            getString('ha.config.failures.responses.ds.dswithpdl.issue.events.desc');
      pdlResponseDescriptions[haConstants.storageVmReaction.RESTART_AGGRESSIVE] =
            getString('ha.config.failures.responses.ds.dswithpdl.power.off.desc');

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function getResponses() {
         return _.map(possiblePdlResponses, function(reaction) {
            return {
               id: reaction,
               label: pdlResponseLabels[reaction],
               description: pdlResponseDescriptions[reaction]
            };
         });
      }

      return {
         getResponses: getResponses
      };
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('haSummaryService', haSummaryService);

   haSummaryService.$inject = ['vxPropertyViewService', 'i18nService'];

   function haSummaryService(vxPropertyViewService, i18nService) {
      function getUnitHostsNumber(data) {
         var hostCount = 0;

         hostCount += data.hostsDisconnectedWithUninitError;
         hostCount += data.hostsInStandByWithUninitError;
         hostCount += data.hostsInMaintenanceWithUninitError;

         return hostCount;
      }

      function getFailoverLevelAdvancedRuntimeData(advancedRuntimeInfo) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = getSectionBuilder(builder);

         var slotInfo = advancedRuntimeInfo.slotInfo || {};

         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.slot.size'),
               [i18nService.getString('ClusterUi',
                     'ha.runtime.info.slot.mhz', slotInfo.cpuMHz),
               i18nService.getString('ClusterUi',
                     'ha.runtime.info.slot.mb', slotInfo.memoryMB)]);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.total.slots'),
               getTotalSlotsInCluster(advancedRuntimeInfo.totalSlots));
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.used.slots'),
               advancedRuntimeInfo.usedSlots);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.unreserved.slots'),
               advancedRuntimeInfo.unreservedSlots);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.failover.slots'),
               getFailoverSlots(advancedRuntimeInfo));
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.total.powered.vms'),
               advancedRuntimeInfo.totalVms);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.total.hosts'),
               advancedRuntimeInfo.totalHosts);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.total.good.hosts'),
               advancedRuntimeInfo.totalGoodHosts);

         return builder.build();
      }

      function getFailoverResourcesAdvancedRuntimeData(failoverResourceData) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = getSectionBuilder(builder);

         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.resources.memory.total.GB'),
               failoverResourceData.totalMemoryText);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.resources.memory.reserved.percentage'),
               failoverResourceData.reservedMemoryPercentText);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.resources.cpu.total.Ghz'),
               failoverResourceData.totalCpuText);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.info.resources.cpu.reserved.percentage'),
               failoverResourceData.reservedCpuPercentText);

         if (failoverResourceData.autoComputeStatus !== null) {
            var autoComputeKey = failoverResourceData.autoComputeStatus ?
                  'ha.runtime.info.resources.autocompute.flag.on':
                  'ha.runtime.info.resources.autocompute.flag.off';
            var autoComputeText = i18nService.getString('ClusterUi', autoComputeKey);
            sectionBuilder.property(i18nService.getString('ClusterUi',
                  'ha.runtime.info.resources.autocompute.flag'),
                  autoComputeText);
         }

         return builder.build();
      }

      function getHostsRuntimeData(hostHaRuntimeInfo) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = getSectionBuilder(builder);

         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.master.host'),
               hostHaRuntimeInfo.masterName);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.connected.to.master'),
               hostHaRuntimeInfo.hostsConnectedCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.not.connected.to.master'),
               hostHaRuntimeInfo.hostsNotConnectedCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.agent.not.reachable'),
               hostHaRuntimeInfo.agentUnreachableCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.config.errors'),
               hostHaRuntimeInfo.configErrorCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.failed'),
               hostHaRuntimeInfo.hostsUnreachableCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.network.isolated'),
               hostHaRuntimeInfo.networkIsolatedCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.network.partitioned'),
               hostHaRuntimeInfo.networkPartitionedCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.agent.initializing'),
               hostHaRuntimeInfo.agentInitializingCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.disconnected.from.vc'),
               hostHaRuntimeInfo.hostsDisconnectedFromVcCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.in.standby'),
               hostHaRuntimeInfo.hostsInStandByCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.in.maintenance'),
               hostHaRuntimeInfo.hostsInMaitenanceModeCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.hosts.uninitializationError'),
               getUnitHostsNumber(hostHaRuntimeInfo));

         return builder.build();
      }

      function getVmsRuntimeData(hostHaRuntimeInfo) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = getSectionBuilder(builder);

         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.protected.vms'),
               hostHaRuntimeInfo.protectedVmsCount);
         sectionBuilder.property(i18nService.getString('ClusterUi',
               'ha.runtime.not.protected.vms'),
               hostHaRuntimeInfo.notProtectedVmCount);

         return builder.build();
      }

      function getTotalSlotsInCluster(value) {
         return (value < 0)
               ? i18nService.getString('ClusterUi', 'ha.runtime.info.total.slots.na')
               : value;
      }

      function getFailoverSlots(advancedRuntimeInfo) {
         var value = advancedRuntimeInfo.totalSlots -
               advancedRuntimeInfo.unreservedSlots -
               advancedRuntimeInfo.usedSlots;

         return (value < 0 ? 0 : value);
      }

      function getSectionBuilder(builder) {
         var sectionBuilder = builder
               .category('')
               .section('');

         return sectionBuilder;
      }

      return {
         getHostsRuntimeData: getHostsRuntimeData,
         getFailoverLevelAdvancedRuntimeData: getFailoverLevelAdvancedRuntimeData,
         getFailoverResourcesAdvancedRuntimeData: getFailoverResourcesAdvancedRuntimeData,
         getVmsRuntimeData: getVmsRuntimeData
      };
   }
})();

(function () {
   'use strict';

   /**
    * Service that provides information pertaining to VM monitoring.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('haVmMonitoringService', haVmMonitoringService);

   haVmMonitoringService.$inject = ['i18nService', 'haConstants'];

   function haVmMonitoringService(i18nService, haConstants) {

      var vmMonitoringStateDescriptions = {};
      vmMonitoringStateDescriptions[haConstants.vmMonitoring.DISABLED] = '';
      vmMonitoringStateDescriptions[haConstants.vmMonitoring.VM_ONLY] =
         i18nService.getString('ClusterUi',
            'ha.config.failures.responses.vm.monitoring.vm.monitoring.check.desc');
      vmMonitoringStateDescriptions[haConstants.vmMonitoring.VM_AND_APP] =
         i18nService.getString('ClusterUi',
            'ha.config.failures.responses.vm.monitoring.app.monitoring.check.desc');

      var sensitivityTypes = {
         PRESET: 0,
         CUSTOM: 1
      };

      var presetLevels = {
         LOW: 0,
         MEDIUM: 1,
         HIGH: 2,
         CUSTOM: 3
      };

      var sensitivityLevelsMap = {};
      sensitivityLevelsMap[presetLevels.LOW] = {
         failure_interval: haConstants.vmMonitoringSensitivity.low.FAILURE_INTERVAL,
         min_uptime: haConstants.vmMonitoringSensitivity.low.MIN_UPTIME,
         max_failures: haConstants.vmMonitoringSensitivity.low.MAX_FAILURES,
         failure_window: haConstants.vmMonitoringSensitivity.low.FAILURE_WINDOW
      };
      sensitivityLevelsMap[presetLevels.MEDIUM] = {
         failure_interval: haConstants.vmMonitoringSensitivity.medium.FAILURE_INTERVAL,
         min_uptime: haConstants.vmMonitoringSensitivity.medium.MIN_UPTIME,
         max_failures: haConstants.vmMonitoringSensitivity.medium.MAX_FAILURES,
         failure_window: haConstants.vmMonitoringSensitivity.medium.FAILURE_WINDOW
      };
      sensitivityLevelsMap[presetLevels.HIGH] = {
         failure_interval: haConstants.vmMonitoringSensitivity.high.FAILURE_INTERVAL,
         min_uptime: haConstants.vmMonitoringSensitivity.high.MIN_UPTIME,
         max_failures: haConstants.vmMonitoringSensitivity.high.MAX_FAILURES,
         failure_window: haConstants.vmMonitoringSensitivity.high.FAILURE_WINDOW
      };

      /**
       * Retrieves objects for all of the available levels.
       *
       * @returns {Array}
       */
      function getMonitoringLevels() {
         return _.map(_.values(haConstants.vmMonitoring), buildLevel);
      }

      /**
       * Retrieves objects for all of the available levels for a VM override that are not
       * above the cluster setting.
       *
       * @returns {Array}
       */
      function getVmOverrideMonitoringLevels(clusterVmMonitoringLevel) {
         var eligibleLevels = [haConstants.vmMonitoring.DISABLED];

         if (clusterVmMonitoringLevel !== haConstants.vmMonitoring.DISABLED) {
            eligibleLevels.push(haConstants.vmMonitoring.VM_ONLY);

            if (clusterVmMonitoringLevel === haConstants.vmMonitoring.VM_AND_APP) {
               eligibleLevels.push(haConstants.vmMonitoring.VM_AND_APP);
            }
         }

         return _.map(eligibleLevels, buildLevel);
      }

      /**
       * Function to compute the VM Monitoring sensitivity level.
       * It is based on specific settings for failure intervals, max failure window,
       * the number of failures and the minimum uptime.
       */
      function getHaMonitoringSensitivityLevel(vmToolsMonSettings) {

         var sensitivityOptions = buildSensitivityOptionsObject(vmToolsMonSettings);

         if (_.isEqual(haConstants.vmMonitoringSensitivity.low,
               sensitivityOptions)) {
            return presetLevels.LOW;
         } else if (_.isEqual(haConstants.vmMonitoringSensitivity.medium,
               sensitivityOptions)) {
            return presetLevels.MEDIUM;
         } else if (_.isEqual(haConstants.vmMonitoringSensitivity.high,
               sensitivityOptions)) {
            return presetLevels.HIGH;
         }

         return presetLevels.CUSTOM;
      }

      function buildSensitivityOptionsObject(vmToolsMonSettings) {
         return {
            FAILURE_INTERVAL: vmToolsMonSettings.vmToolsMonitorFailureInt,
            MIN_UPTIME: vmToolsMonSettings.vmToolsMonitorMinUpTime,
            MAX_FAILURES: vmToolsMonSettings.vmToolsMonitorMaxFailures,
            FAILURE_WINDOW: vmToolsMonSettings.vmToolsMonitorMaxFailureWindow,
            HAS_WINDOW: vmToolsMonSettings.vmToolsMonitorHasFailureWindow
         };
      }

      /**
       * Builds a level object (`id` and `label` mapping) for a given level.
       *
       * @param level
       * @returns {{id: string, label: string}}
       */
      function buildLevel(level) {
         return {
            id: level,
            label: getLabel(level),
            description: getDescription(level)
         };
      }

      /**
       * Builds a level object (`id` and `label` mapping) for a given sensitivity level.
       *
       * @param level
       * @returns {{id: string, label: string}}
       */
      function buildSensitivityLevel(level) {
         return {
            id: level,
            label: getSensitivityLabel(level)
         };
      }

      /**
       * Retrieves the label for the given VM monitoring level.
       *
       * @param {string} vmMonitoring the level to get the label for.
       * @returns {string}
       */
      function getLabel(vmMonitoring) {
         var vmMonitoringLabel;
         switch (vmMonitoring) {
            case haConstants.vmMonitoring.DISABLED:
               vmMonitoringLabel = 'HA.vm.monitoring.disabled';
               break;
            case haConstants.vmMonitoring.VM_ONLY:
               vmMonitoringLabel = 'HA.vm.monitoring.only';
               break;
            case haConstants.vmMonitoring.VM_AND_APP:
               vmMonitoringLabel = 'HA.vm.app.monitoring';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', vmMonitoringLabel);
      }

      /**
       * Retrieves the label for the given VM monitoring sensitivity level.
       *
       * @param {string} vmMonitoringSensitivity the level to get the label for.
       * @returns {string}
       */
      function getSensitivityLabel(vmMonitoringSensitivity) {
         var vmMonitoringSensitivityLabel;
         switch (vmMonitoringSensitivity) {
            case presetLevels.LOW:
               vmMonitoringSensitivityLabel =
                     'ha.config.vmResponse.vmMonitoringSensitivity.preset.low';
               break;
            case presetLevels.MEDIUM:
               vmMonitoringSensitivityLabel =
                     'ha.config.vmResponse.vmMonitoringSensitivity.preset.medium';
               break;
            case presetLevels.HIGH:
               vmMonitoringSensitivityLabel =
                     'ha.config.vmResponse.vmMonitoringSensitivity.preset.high';
               break;
            case presetLevels.CUSTOM:
               vmMonitoringSensitivityLabel =
                     'ha.config.vmResponse.vmMonitoringSensitivity.custom';
               break;
            default:
               return '';
         }

         return i18nService.getString('ClusterUi', vmMonitoringSensitivityLabel);
      }

      /**
       * Retrieves the description of VM monitoring option.
       *
       * @param {string}
       * @returns {string}
       */
      function getDescription(vmMonitoring) {
         return vmMonitoringStateDescriptions[vmMonitoring];
      }

      /**
       * Retrieves the VM monitoring sensitivity types
       *
       * @returns {{PRESET: number, CUSTOM: number}}
       */
      function getSensitivityTypes() {
         return sensitivityTypes;
      }

      /**
       * Returns the VM monitoring sensitivity preset levels
       *
       * @returns {{LOW: number, MEDIUM: number, HIGH: number, CUSTOM: number}}
       */
      function getPresetLevels() {
         return presetLevels;
      }

      /**
       * Retrieves an array with values for failure interval, min uptime, max
       * failures and failure window for a VM monitoring sensitivity preset level
       *
       * @param {number}
       * @returns {Array}
       */
      function getSensitivityLevelValues(presetLevel) {
         return sensitivityLevelsMap[presetLevel];
      }

      /**
       * Retrieves an array with VM monitoring sensitivity levels.
       */
      function getMonitoringSensitivityLevels() {
         return _.map(_.values(presetLevels), buildSensitivityLevel);
      }

      return {
         getMonitoringLevels: getMonitoringLevels,
         getMonitoringSensitivityLevels: getMonitoringSensitivityLevels,
         getSensitivityLevelValues: getSensitivityLevelValues,
         getHaMonitoringSensitivityLevel: getHaMonitoringSensitivityLevel,
         getSensitivityTypes: getSensitivityTypes,
         getPresetLevels: getPresetLevels,
         getVmOverrideMonitoringLevels: getVmOverrideMonitoringLevels,
         getLabel: getLabel,
         DEFAULT_STATE: buildLevel(haConstants.vmMonitoring.DISABLED)
      };
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
      .service('haVmReactionsOnApdClearedService', haVmReactionsOnApdClearedService);

   haVmReactionsOnApdClearedService.$inject = ['i18nService', 'haConstants'];

   function haVmReactionsOnApdClearedService(i18nService, haConstants) {

      var vmReactionLabels = {};
      var possibleVmReactions = [
         haConstants.vmReactionOnApdCleared.NONE,
         haConstants.vmReactionOnApdCleared.RESET
      ];

      vmReactionLabels[haConstants.vmReactionOnApdCleared.NONE] =
         getString('ha.config.vmResponse.vmRemediationIfApdRecovers.doNotResetVm');
      vmReactionLabels[haConstants.vmReactionOnApdCleared.RESET] =
         getString('ha.config.vmResponse.vmRemediationIfApdRecovers.resetVm');

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function getReactions() {
         return _.map(possibleVmReactions, function(reaction) {
            return {
               id: reaction,
               label: vmReactionLabels[reaction]
            };
         });
      }

      return {
         getReactions: getReactions
      };
   }
})();

(function() {
   'use strict';

   /**
    * Service that provides edit HA heartbeat datastores related functionality.
    */
   angular.module('com.vmware.vsphere.client.cluster')
      .service('heartbeatDatastoresService', heartbeatDatastoresService);

   heartbeatDatastoresService.$inject = ['i18nService', 'haConstants', 'vuiConstants',
      'columnRenderersRegistry', 'defaultUriSchemeUtil', 'dataService'];

   function heartbeatDatastoresService(i18nService, haConstants,
         vuiConstants, columnRenderersRegistry, defaultUriSchemeUtil, dataService) {

      var NA_LABEL = i18nService.getString('ClusterUi', 'datastoreClusterNA');

      return {
         getDatastoreGridOptions: getDatastoreGridOptions,
         getHostGridOptions: getHostGridOptions,
         getDatastoreHosts: getDatastoreHosts,
         getCandidatePolicies: getCandidatePolicies,
         isAutoSelectPolicy: isAutoSelectPolicy
      };

      //region Public functions

      function getDatastoreGridOptions(isEditMode) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            sortOrder: [{
               field: 'accessibleAndMountedHosts.length',
               dir: 'desc'
            }],
            searchable: false,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getDatastoreGridColumnDefs(isEditMode),
            height: '249px'
         };
      }

      function getHostGridOptions(isEditMode, dataBoundHandler) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.NONE,
            sortMode: vuiConstants.grid.sortMode.NONE,
            searchable: false,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getHostGridColumnDefs(isEditMode),
            height: '249px',
            dataBound: dataBoundHandler
         };
      }

      function getDatastoreHosts(accessibleAndMountedHosts) {

         var selectedObjectHostIds = _.map(accessibleAndMountedHosts, function(host) {
            return defaultUriSchemeUtil.getVsphereObjectId({
               type: host.type,
               serverGuid: host.serverGuid,
               value: host.value
            });
         });

         return dataService.getPropertiesForObjects(selectedObjectHostIds,['name', 'primaryIconId'])
               .then(function(data) {
                  return _.map(data, function(host, id) {
                     return {
                        provider: defaultUriSchemeUtil.getManagedObjectReference(id),
                        name: host['name'],
                        iconId: host['primaryIconId']
                     };
                  });
               });
      }

      function getCandidatePolicies() {
         var hbDsCandidatePolicies =
            Object.keys(haConstants.hbDatastoreCandidatePolicy).map(function(key) {
               var policyKey = haConstants.hbDatastoreCandidatePolicy[key];
               var policy = buildPolicy(policyKey);
               return policy;
            });

         return hbDsCandidatePolicies;
      }

      function isAutoSelectPolicy(policy) {
         return policy === haConstants.hbDatastoreCandidatePolicy.AUTO_SELECT;
      }

      //endregion

      //region Private functions

      function getDatastoreGridColumnDefs(isEditMode) {
         var dsColumns = [];

         if (isEditMode) {
            dsColumns.push(
               {
                  displayName: ' ',
                  field: 'isPreferred',
                  type: 'boolean',
                  width: '27px',
                  template: checkboxRenderer
               });
         }

         dsColumns.push(
            {
               displayName: i18nService.getString('ClusterUi', 'datastoreNameHeaderText'),
               field: 'name',
               type: 'string',
               template: isEditMode ? iconTextRenderer : iconLinkRenderer
            },
            {
               displayName: i18nService.getString('ClusterUi', 'datastoreClusterNameHeaderText'),
               field: 'dsClusterData',
               type: 'object',
               searchable: false,
               template:  isEditMode ? dsClusterNameTextRenderer : dsClusterNameLinkRenderer
            },
            {
               displayName: i18nService.getString('ClusterUi', 'hostMountsCountHeaderText'),
               field: 'accessibleAndMountedHosts.length',
               type: 'number'
            }
         );

         return dsColumns;
      }
      function getHostGridColumnDefs(isEditMode) {
         return [
            {
               displayName: i18nService.getString('ClusterUi', 'hostNameHeaderText'),
               field: 'name',
               type: 'string',
               template: isEditMode ? iconTextRenderer : iconLinkRenderer
            }
         ];
      }

      function dsClusterNameTextRenderer(data) {
         return iconTextRenderer(data.dsClusterData);
      }

      function dsClusterNameLinkRenderer(data) {
         return iconLinkRenderer(data.dsClusterData);
      }

      function checkboxRenderer(data) {
         var checkedAttr = data.isPreferred ? 'checked' : '';
         return '<input type="checkbox" class="row-checkbox" ' + checkedAttr + '>';
      }

      function iconTextRenderer(data) {
         var objData = data || {
                  name: NA_LABEL
               };
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');
         return renderer(['iconId', 'name'], objData);
      }

      function iconLinkRenderer(data) {
         var objData = data || {};

         objData.uid = defaultUriSchemeUtil.getVsphereObjectId(objData.provider);
         objData.customLabel = NA_LABEL;

         var renderer = columnRenderersRegistry.getColumnRenderer('object-link');
         return renderer(['uid', 'name', objData.iconId, 'customLabel'], objData);
      }

      function buildPolicy(policyKey) {
         return {
            id: policyKey,
            label: getLabel(policyKey)
         };
      }

      function getLabel(policyKey) {
         var policyTextKey;
         switch (policyKey) {
            case haConstants.hbDatastoreCandidatePolicy.AUTO_SELECT:
               policyTextKey = 'ha.config.allFeasibleDs';
               break;
            case haConstants.hbDatastoreCandidatePolicy.USER_SELECTED_ONLY:
               policyTextKey = 'ha.config.userSelectedDs';
               break;
            case haConstants.hbDatastoreCandidatePolicy.USER_SELECTED_WITH_AUTO_SELECTED:
               policyTextKey = 'ha.config.allFeasibleDsWithUserPreference';
               break;
            default:
               return '';
         }
         return i18nService.getString('ClusterUi', policyTextKey);
      }

      //endregion
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var HostOptionsService = (function () {
        function HostOptionsService($q, i18nService, columnRenderersRegistry, timeFormatterService, defaultUriSchemeUtil, datagridActionBarService, vuiConstants, drsConstants, ipParserService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.timeFormatterService = timeFormatterService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datagridActionBarService = datagridActionBarService;
            this.vuiConstants = vuiConstants;
            this.drsConstants = drsConstants;
            this.ipParserService = ipParserService;
            this.getString = _.partial(this.i18nService.getString, "ClusterUi");
        }
        HostOptionsService.prototype.parseHostOptionsData = function (data) {
            var _this = this;
            var hostDpmOverrides = {};
            if (data.dpmHostConfig) {
                _.each(data.dpmHostConfig, function (dpmOverride) {
                    hostDpmOverrides[dpmOverride.key.value] = dpmOverride;
                });
            }
            if (data.hosts && data.hosts.length > 0) {
                var datagridData = _.map(data.hosts, function (host) {
                    var listItem = {
                        hostRef: host.provider,
                        name: host.name,
                        primaryIconId: host.primaryIconId,
                        bmcUsername: host.ipmiInfo ? host.ipmiInfo.login : "",
                        bmcIpAddr: host.ipmiInfo ? host.ipmiInfo.bmcIpAddress : "",
                        bmcMacAddr: host.ipmiInfo ? host.ipmiInfo.bmcMacAddress : ""
                    };
                    _.extend(listItem, {
                        powerManagement: _this.formatPowerManagementProperty(hostDpmOverrides[host.provider.value], data.dpmEnabled, data.dpmBehavior),
                        lteStandbyPromise: _this.formatLastTimeExitProperty(host.hostStandbyInfo)
                    });
                    return listItem;
                });
                // TODO refactor once timeFormatterService asynchronous dateFormat method is fixed.
                return this.getDatagridData(datagridData);
            }
            else {
                return this.$q.when([]);
            }
        };
        // TODO remove complicated and unreadable defer flow when
        // timeFormatterService has working synchronous dateFormat method.
        HostOptionsService.prototype.getDatagridData = function (datagridData) {
            return this.$q
                .all(_.map(datagridData, function (item) { return item.lteStandbyPromise; }))
                .then(function (formattedDates) {
                _.each(datagridData, function (listItem, index) {
                    listItem.lteStandby = formattedDates[index];
                });
                return datagridData;
            });
        };
        // TODO refactor once timeFormatterService asynchronous dateFormat method is fixed.
        HostOptionsService.prototype.formatLastTimeExitProperty = function (hostStandbyInfo) {
            var _this = this;
            if (!hostStandbyInfo) {
                return this.$q.when(this.getString("hostOptions.lastExitStandbyNA"));
            }
            var lastExitSuccededLabel = hostStandbyInfo.lastExitSucceeded ?
                this.getString("hostOptions.lastExitStandbySucceeded") :
                this.getString("hostOptions.lastExitStandbyFailed");
            return this.timeFormatterService.formatDate(hostStandbyInfo.lastTimeExit).then(function (formattedDate) {
                return _this.getString("hostOptions.lastExitStandbyTimeAndResult", formattedDate, lastExitSuccededLabel);
            });
        };
        HostOptionsService.prototype.formatPowerManagementProperty = function (dpmHostConfig, dpmEnabled, dpmBehavior) {
            return dpmHostConfig ?
                this.getDpmBehavior(dpmHostConfig.enabled, dpmHostConfig.behavior) :
                this.getString("hostOptions.dpmClusterDefault", this.getDpmBehavior(dpmEnabled, dpmBehavior));
        };
        HostOptionsService.prototype.getDpmBehavior = function (dpmEnabled, dpmBehavior) {
            return dpmEnabled ? this.getDpmBehaviorLabel(dpmBehavior) : this.getString("hostOptions.dpmDisabled");
        };
        HostOptionsService.prototype.getDpmBehaviorLabel = function (dpmBehavior) {
            return dpmBehavior === "manual" ?
                this.getString("drs.config.dpm.automationLevel.manual") :
                this.getString("drs.config.dpm.automationLevel.automated");
        };
        HostOptionsService.prototype.getHostNameRenderer = function (data) {
            var objectLinkRenderer = this.columnRenderersRegistry.getColumnRenderer("object-link");
            var modifiedData = {
                hostName: data.name,
                hostId: this.getHostRef(data)
            };
            var hostIcon = data.primaryIconId ? data.primaryIconId : "vsphere-icon-host";
            return objectLinkRenderer(["hostId", "hostName", hostIcon], modifiedData);
        };
        HostOptionsService.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.getString("hostOptions.hostNameHeaderText"),
                    field: "name",
                    template: function (item) {
                        return _this.getHostNameRenderer(item);
                    }
                },
                {
                    displayName: this.getString("hostOptions.powerMgmtHeaderText"),
                    field: "powerManagement"
                },
                {
                    displayName: this.getString("hostOptions.LastExitStandbyHeaderText"),
                    field: "lteStandby"
                },
                {
                    displayName: this.getString("hostOptions.ipmiLoginHeaderText"),
                    field: "bmcUsername"
                },
                {
                    displayName: this.getString("hostOptions.ipmiIpAddressHeaderText"),
                    field: "bmcIpAddr"
                },
                {
                    displayName: this.getString("hostOptions.ipmiMacAddressHeaderText"),
                    field: "bmcMacAddr"
                }
            ];
        };
        HostOptionsService.prototype.getDatagridOptions = function () {
            return {
                actionBarOptions: {
                    actions: []
                },
                searchable: false,
                resizable: false,
                selectedItems: [],
                data: [],
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                columnDefs: this.getColumnDefs(),
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        HostOptionsService.prototype.getActionsSpec = function (datagridOptions, clusterId) {
            var _this = this;
            return [{
                    actionId: "vsphere.core.cluster.actions.hostOptions.edit",
                    getActionInvocationContext: function () {
                        return {
                            selectedHost: _this.getHostRef(datagridOptions.selectedItems[0]),
                            clusterRef: clusterId
                        };
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available && datagridOptions.selectedItems && datagridOptions.selectedItems.length > 0;
                    }
                }];
        };
        HostOptionsService.prototype.getHostRef = function (hostData) {
            return this.defaultUriSchemeUtil.getVsphereObjectId(hostData.hostRef);
        };
        HostOptionsService.prototype.createActionBar = function (datagridOptions, targetId) {
            var actionsSpec = this.getActionsSpec(datagridOptions, targetId);
            return this.datagridActionBarService
                .updateActionBar(datagridOptions, [targetId], actionsSpec)
                .then(function (data) {
                return data;
            });
        };
        HostOptionsService.prototype.refreshActionBar = function (datagridOptions, targetId, actionBarCache) {
            var actionsSpec = this.getActionsSpec(datagridOptions, targetId);
            if (!actionBarCache) {
                return;
            }
            this.datagridActionBarService.updateActionBar(datagridOptions, [targetId], actionsSpec, actionBarCache);
        };
        HostOptionsService.prototype.createClusterSpec = function (dpmHostConfigSpecs) {
            return {
                configSpecEx: {
                    _type: "com.vmware.vim.binding.vim.cluster.ConfigSpecEx",
                    dpmHostConfigSpec: dpmHostConfigSpecs
                },
                modify: true
            };
        };
        HostOptionsService.prototype.createDpmHostConfigSpec = function (powerManagementConfig) {
            var dpmHostConfigSpec = {
                _type: "com.vmware.vim.binding.vim.cluster.DpmHostConfigSpec"
            };
            if (!powerManagementConfig.powerManagementOverride) {
                dpmHostConfigSpec = _.extend(dpmHostConfigSpec, {
                    removeKey: this.defaultUriSchemeUtil.getManagedObjectReference(powerManagementConfig.hostId),
                    operation: "remove"
                });
            }
            else {
                dpmHostConfigSpec = _.extend(dpmHostConfigSpec, {
                    info: {
                        _type: "com.vmware.vim.binding.vim.cluster.DpmHostConfigInfo",
                        key: this.defaultUriSchemeUtil.getManagedObjectReference(powerManagementConfig.hostId),
                        behavior: powerManagementConfig.selectedDpmBehavior ? powerManagementConfig.selectedDpmBehavior : null,
                        enabled: powerManagementConfig.selectedDpmBehavior !== this.drsConstants.dpmAutomationLevel.DISABLED
                    },
                    operation: powerManagementConfig.defaultDpmOverride === powerManagementConfig.powerManagementOverride ? "edit" : "add"
                });
            }
            return dpmHostConfigSpec;
        };
        HostOptionsService.prototype.validatePowerConfigSoftwareSpec = function (data) {
            var validationMessages = [];
            if (!data) {
                return validationMessages;
            }
            if (data.login === "" && data.password === "" && data.bmcIpAddress === ""
                && data.bmcMacAddress === "") {
                return validationMessages;
            }
            if (data.login === "" || data.password === "" || data.bmcIpAddress === ""
                || data.bmcMacAddress === "") {
                var allParametersRequiredMessage = this.i18nService.getString("ClusterUi", "hostOptions.edit.ipmi.allParametersRequired");
                validationMessages.push(allParametersRequiredMessage);
            }
            if (data.bmcIpAddress !== "" && !this.ipParserService.isAddressValid(data.bmcIpAddress)) {
                var invalidIpAddress = this.i18nService.getString("ClusterUi", "hostOptions.edit.ipmi.invalidIpAddress");
                validationMessages.push(invalidIpAddress);
            }
            return validationMessages;
        };
        HostOptionsService.prototype.showValidationMessages = function (messages) {
            return _.map(messages, function (message) {
                return {
                    type: "error",
                    text: message
                };
            });
        };
        HostOptionsService.prototype.setSelectedDpmBehavior = function (clusterDpmConfigData, powerManagementConfig) {
            var _this = this;
            if (clusterDpmConfigData.dpmHostConfig) {
                var hostConfig = _.find(clusterDpmConfigData.dpmHostConfig, function (hostConfig) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(hostConfig.key) === powerManagementConfig.hostId;
                });
                if (!hostConfig) {
                    powerManagementConfig.powerManagementOverride = false;
                    powerManagementConfig.defaultDpmOverride = false;
                    this.setDpmBehavior(powerManagementConfig, this.drsConstants.dpmAutomationLevel.DISABLED);
                }
                else {
                    if (hostConfig.enabled) {
                        // save the default dpm configuration of the host.
                        this.setDpmBehavior(powerManagementConfig, this.createPowerManagementOverrideSelection(hostConfig));
                    }
                    else {
                        this.setDpmBehavior(powerManagementConfig, this.drsConstants.dpmAutomationLevel.DISABLED);
                    }
                    powerManagementConfig.powerManagementOverride = true;
                    powerManagementConfig.defaultDpmOverride = true;
                }
            }
            else {
                this.setDpmBehavior(powerManagementConfig, this.drsConstants.dpmAutomationLevel.DISABLED);
            }
        };
        HostOptionsService.prototype.setDpmBehavior = function (powerManagementConfig, powerManagementValue) {
            powerManagementConfig.selectedDpmBehavior = powerManagementValue;
            powerManagementConfig.defaultDpmBehavior = powerManagementValue;
        };
        HostOptionsService.prototype.createPowerManagementOverrideSelection = function (hostConfig) {
            var dpmManual = this.drsConstants.dpmAutomationLevel.MANUAL;
            var dpmAutomated = this.drsConstants.dpmAutomationLevel.AUTOMATED;
            return hostConfig.behavior === dpmManual ? dpmManual : dpmAutomated;
        };
        HostOptionsService.prototype.getDpmBehaviors = function () {
            var _this = this;
            return Object.keys(this.drsConstants.dpmAutomationLevel).map(function (key) {
                return _this.buildDpmBehavior(key);
            });
        };
        HostOptionsService.prototype.buildDpmBehavior = function (key) {
            var dpmEnabled = true;
            var automationLevel = this.drsConstants.dpmAutomationLevel[key];
            if (automationLevel === "") {
                dpmEnabled = false;
            }
            return {
                id: automationLevel,
                label: this.getDpmBehavior(dpmEnabled, automationLevel.toLowerCase())
            };
        };
        HostOptionsService.$inject = [
            "$q",
            "i18nService",
            "columnRenderersRegistry",
            "timeFormatterService",
            "defaultUriSchemeUtil",
            "datagridActionBarService",
            "vuiConstants",
            "drsConstants",
            "ipParserService"
        ];
        return HostOptionsService;
    }());
    cluster_ui.HostOptionsService = HostOptionsService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("hostOptionsService", HostOptionsService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ResourceAllocationService = (function () {
        function ResourceAllocationService(i18nService) {
            this.i18nService = i18nService;
            this.CLUSTER_MODEL_CLASS_MEMORY = "com.vmware.vsphere.client.clusterui.model.monitor.reservation.ClusterMemoryCapacityData";
            this.HOST_MODEL_CLASS_MEMORY = "com.vmware.vsphere.client.clusterui.model.monitor.reservation.HostMemoryCapacityData";
            this.RP_MODEL_CLASS_MEMORY = "com.vmware.vsphere.client.clusterui.model.monitor.reservation.ResourcePoolMemoryCapacityData";
        }
        ResourceAllocationService.prototype.sortReservationUsersLimit = function (a, b) {
            var unlimitedValue = -1;
            var res = 0;
            if (a.limit === unlimitedValue && b.limit !== unlimitedValue) {
                res = 1;
            }
            else if (b.limit === unlimitedValue && a.limit !== unlimitedValue) {
                res = -1;
            }
            else {
                res = a.limit - b.limit;
            }
            return res;
        };
        ResourceAllocationService.prototype.sortSharesLevels = function (a, b) {
            var valuesFactors = {
                "": 0,
                "low": 1,
                "normal": 2,
                "high": 3,
                "custom": 4
            };
            return valuesFactors[a.sharesInfo.level] - valuesFactors[b.sharesInfo.level];
        };
        ResourceAllocationService.prototype.getSharesValueTextByLevel = function (level) {
            var values = {
                "low": this.i18nService.getString("VmUi", "sharesInfoLevel.low"),
                "normal": this.i18nService.getString("VmUi", "sharesInfoLevel.normal"),
                "high": this.i18nService.getString("VmUi", "sharesInfoLevel.high"),
                "custom": this.i18nService.getString("VmUi", "sharesInfoLevel.custom")
            };
            return values[level];
        };
        ResourceAllocationService.prototype.getReservationTypeByModel = function (modelClass) {
            if (modelClass === this.HOST_MODEL_CLASS_MEMORY ||
                modelClass === this.CLUSTER_MODEL_CLASS_MEMORY ||
                modelClass === this.RP_MODEL_CLASS_MEMORY) {
                return "memory";
            }
            return "cpu";
        };
        ResourceAllocationService.prototype.getMaxCapacityValue = function (data) {
            if (data.rpReservationCapacityFormatted !== undefined) {
                return data.rpReservationCapacityFormatted;
            }
            return data.reservationCapacityFormatted;
        };
        ResourceAllocationService.$inject = ["i18nService"];
        return ResourceAllocationService;
    }());
    cluster_ui.ResourceAllocationService = ResourceAllocationService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("resourceAllocationService", ResourceAllocationService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var MoveClusterToService = (function () {
        function MoveClusterToService(mutationService, defaultUriSchemeUtil, clarityModalService, i18nService, dataService, authorizationService, $q) {
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.authorizationService = authorizationService;
            this.$q = $q;
        }
        MoveClusterToService.prototype.showMoveCluster = function (availableTargets) {
            var _this = this;
            if (!availableTargets || !availableTargets.length) {
                return;
            }
            var dcProperty = "dc";
            this.dataService.getPropertiesForObjects(availableTargets, [dcProperty])
                .then(function (properties) {
                var modalOptions = {
                    title: _this.i18nService.getString("ClusterUi", "moveTo.title"),
                    defaultButton: "submit",
                    dialogData: {
                        objectIds: availableTargets,
                        dc: _this.defaultUriSchemeUtil.getVsphereObjectId(properties[availableTargets[0]][dcProperty])
                    },
                    contentTemplate: "cluster-ui/resources/cluster/views/move_to_cluster/moveClusterToDialog.html"
                };
                _this.clarityModalService.openOkCancelModal(modalOptions);
            });
        };
        MoveClusterToService.prototype.validateMoveClusterToTarget = function (entityToMoveClusterTo, clusterIds) {
            var moveSpec = this.getMoveSpec(clusterIds);
            return this.mutationService.validate(entityToMoveClusterTo, "com.vmware.vsphere.client.clusterui.MoveClusterSpec", moveSpec);
        };
        MoveClusterToService.prototype.moveCluster = function (entityToMoveClusterTo, clusterIds) {
            var moveSpec = this.getMoveSpec(clusterIds);
            this.mutationService.apply(entityToMoveClusterTo, "com.vmware.vsphere.client.clusterui.MoveClusterSpec", moveSpec);
        };
        MoveClusterToService.prototype.getMoveSpec = function (clusterIds) {
            var _this = this;
            var clusterMors = _.map(clusterIds, function (clusterId) {
                return _this.defaultUriSchemeUtil.getManagedObjectReference(clusterId);
            });
            var moveSpec = {
                entities: clusterMors
            };
            return moveSpec;
        };
        MoveClusterToService.prototype.checkPrivileges = function (itemToCheckIds, targetToCheckId) {
            var promises = [];
            var allItems = itemToCheckIds.concat([targetToCheckId]);
            promises.push(this.authorizationService
                .checkPrivilegesForMultipleObjects(_.uniq(allItems), ['Host.Inventory.MoveCluster']));
            return this.$q.all(promises).then(function (result) {
                var objectsWithNoPrivilegeIds = [];
                var clusterMovePrivilegeResult;
                if (result.length > 1) {
                    if (!result[0]) {
                        objectsWithNoPrivilegeIds.push(targetToCheckId);
                    }
                    clusterMovePrivilegeResult = result[1];
                }
                else {
                    clusterMovePrivilegeResult = result[0];
                }
                _.each(clusterMovePrivilegeResult, function (privileges, id) {
                    if (!privileges['Host.Inventory.MoveCluster']) {
                        objectsWithNoPrivilegeIds.push(id);
                    }
                });
                return objectsWithNoPrivilegeIds;
            });
        };
        MoveClusterToService.prototype.getPrivilegesErrorMessage = function (noPrivilegesIds, entityToMoveRpTo) {
            var message;
            if (_.contains(noPrivilegesIds, entityToMoveRpTo)) {
                if (noPrivilegesIds.length === 1) {
                    message = this.i18nService.getString('ClusterUi', 'moveTo.noPermissionsOnTarget');
                }
                else {
                    message = this.i18nService.getString('ClusterUi', 'moveTo.noPermissions');
                }
            }
            else {
                message = this.i18nService.getString('ClusterUi', 'moveTo.noPermissionsOnSource');
            }
            return message;
        };
        MoveClusterToService.$inject = ["mutationService", "defaultUriSchemeUtil",
            "clarityModalService", "i18nService", "dataService", "authorizationService", "$q"];
        return MoveClusterToService;
    }());
    cluster_ui.MoveClusterToService = MoveClusterToService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("moveClusterToService", MoveClusterToService);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').service('moveResourcePoolToService',
         MoveResourcePoolToService);

   MoveResourcePoolToService.$inject = [ 'mutationService', 'defaultUriSchemeUtil',
      'authorizationService', '$q', 'managedEntityConstants', 'i18nService',
      'dataService', 'vuiConstants'];

   function MoveResourcePoolToService(
         mutationService,
         defaultUriSchemeUtil,
         authorizationService,
         $q,
         managedEntityConstants,
         i18nService,
         dataService,
         vuiConstants) {

      function moveResourcePoolTo(entityToMoveRpTo, rpIds) {
         var rpMors = _.map(rpIds, function(rpId) {
            return defaultUriSchemeUtil.getManagedObjectReference(rpId);
         });
         var moveSpec = {
            entities: rpMors
         };

         mutationService.apply(
               entityToMoveRpTo,
               'com.vmware.vsphere.client.h5.rp.spec.MoveResourcePoolSpec',
               moveSpec);
      }

      function validateMoveResourcePoolToTarget(entityToMoveRpTo, rpIds) {
         var rpMors = _.map(rpIds, function(rpId) {
            return defaultUriSchemeUtil.getManagedObjectReference(rpId);
         });
         var moveSpec = {
            entities: rpMors
         };

         return mutationService.validate(
               entityToMoveRpTo,
               'com.vmware.vsphere.client.h5.rp.spec.MoveResourcePoolSpec',
               moveSpec);
      }

      function checkPrivileges(itemToCheckIds, targetToCheckId) {
         var targetType = defaultUriSchemeUtil.getEntityType(targetToCheckId);
         var promises = [];

         if (targetType === managedEntityConstants.V_APP) {
            promises.push(authorizationService
                  .checkPrivilege(targetToCheckId, 'VApp.AssignResourcePool'));
         } else {
            itemToCheckIds.push(targetToCheckId);
         }
         promises.push(authorizationService
               .checkPrivilegesForMultipleObjects(_.uniq(itemToCheckIds), ['Resource.MovePool']));

         return $q.all(promises).then(function(result) {
                  var objectsWithNoPrivilegeIds = [];
                  var resourceMovePoolPrivilegeResult;
                  if (result.length > 1) {
                     if (!result[0]) {
                        objectsWithNoPrivilegeIds.push(targetToCheckId);
                     }
                     resourceMovePoolPrivilegeResult = result[1];
                  } else {
                     resourceMovePoolPrivilegeResult = result[0];
                  }
                  _.each(resourceMovePoolPrivilegeResult, function(privileges, id){
                           if (!privileges['Resource.MovePool']) {
                              objectsWithNoPrivilegeIds.push(id);
                           }
                  });
                  return objectsWithNoPrivilegeIds;
               });
      }

      function getPrivilegesErrorMessage(noPrivilegesIds, entityToMoveRpTo) {
         var message;
         if (_.contains(noPrivilegesIds, entityToMoveRpTo)) {
            if (noPrivilegesIds.length === 1) {
               message = i18nService.getString('RpUi', 'moveTo.noPermissionsOnTarget');
            } else {
               message = i18nService.getString('RpUi', 'moveTo.noPermissions');
            }
         } else {
            message = i18nService.getString('RpUi', 'moveTo.noPermissionsOnSource');
         }

         return message;
      }

      function moveRpToRootRp(parent, rpIds, scope) {
         dataService.getProperties(parent, ['resourcePool'])
               .then(function(data) {
                  if (data) {
                     moveRpAndCloseModal(
                           defaultUriSchemeUtil.getVsphereObjectId(data['resourcePool']),
                           rpIds,
                           scope);
                  } else {
                     scope.modalOptions.alerts = [{
                        type: vuiConstants.validationBanner.type.ERROR,
                        text: i18nService.getString('RpUi', 'moveTo.target.error')
                     }];
                     scope.modalOptions.isAlertClosed = false;
                  }
               });
      }

      function moveRpAndCloseModal(entityToMoveToId, entityToMoveIds, scope) {
            moveResourcePoolTo(entityToMoveToId, entityToMoveIds);
            scope.closeModal();
      }
      function isHostOrCluster(entityToMoveRpTo) {
         var targetEntityType = defaultUriSchemeUtil.getEntityType(
               entityToMoveRpTo
         );
        return targetEntityType === managedEntityConstants.HOST
              || targetEntityType === managedEntityConstants.CLUSTER;
   }

      function moveResourcePool(entityToMoveRpTo, rpIds, scope) {
            if (isHostOrCluster(entityToMoveRpTo)) {
               // move to host's or cluster's hidden resource pool
               moveRpToRootRp(
                     entityToMoveRpTo,
                     rpIds,
                     scope
               );
            } else {
               // move to resource pool or vApp
               moveRpAndCloseModal(
                     entityToMoveRpTo,
                     rpIds,
                     scope
               );
            }

         }

      return {
         moveResourcePool: moveResourcePool,
         validateMoveResourcePoolToTarget: validateMoveResourcePoolToTarget,
         checkPrivileges: checkPrivileges,
         getPrivilegesErrorMessage: getPrivilegesErrorMessage
      };
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var QuickstartRefreshService = (function () {
        function QuickstartRefreshService($rootScope, defaultUriSchemeUtil) {
            this.$rootScope = $rootScope;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        QuickstartRefreshService.prototype.init = function () {
            var _this = this;
            var removeFunction = this.$rootScope.$on(QuickstartRefreshService.OBJECT_DETAILS_CHANGED_EVENT, function (event, partialUpdate) {
                _this.onObjectDetailsChanged(event, partialUpdate);
            });
            this.$rootScope.$on("$destroy", function () {
                if (removeFunction) {
                    removeFunction();
                }
            });
        };
        QuickstartRefreshService.prototype.onObjectDetailsChanged = function (event, partialUpdate) {
            var isViewRelevant = QuickstartRefreshService.QUICKSTART_EXTENSION_ID === this.$rootScope._route.extensionId;
            if (isViewRelevant && this.isEventRelevant(event, partialUpdate)) {
                _.debounce(this.notifyQuickstartView, QuickstartRefreshService.REFRESH_DELAY)();
            }
        };
        QuickstartRefreshService.prototype.isEventRelevant = function (event, partialUpdate) {
            var _this = this;
            var objectId = this.$rootScope._route.objectId;
            var isRelevant = partialUpdate &&
                _.some(partialUpdate.updates, function (update) { return _this.isUpdateRelevant(update, objectId); });
            return isRelevant;
        };
        QuickstartRefreshService.prototype.isUpdateRelevant = function (update, objectId) {
            var isRelevant = !!update.data
                && this.defaultUriSchemeUtil.getVsphereObjectId(update.data) === objectId
                && update.deltaProperties
                && _.some(update.deltaProperties, function (prop) {
                    return _.contains(QuickstartRefreshService.RELEVANT_PROPERTIES, prop);
                });
            return isRelevant;
        };
        QuickstartRefreshService.prototype.notifyQuickstartView = function () {
            var quickstartIFrames = $(QuickstartRefreshService.QUICKSTART_IFRAME_SELECTOR);
            if (quickstartIFrames.length > 0) {
                quickstartIFrames[0].contentWindow.postMessage(QuickstartRefreshService.REFRESH_QUICKSTART_MESSAGE, QuickstartRefreshService.TARGET_ORIGIN);
            }
        };
        QuickstartRefreshService.QUICKSTART_EXTENSION_ID = "vsphere.core.cluster.manage.settings.quickstart";
        QuickstartRefreshService.QUICKSTART_IFRAME_SELECTOR = "[vx-extension-view-id='" + QuickstartRefreshService.QUICKSTART_EXTENSION_ID + "'] iframe";
        QuickstartRefreshService.REFRESH_QUICKSTART_MESSAGE = "refreshQuickstart";
        QuickstartRefreshService.TARGET_ORIGIN = "*";
        QuickstartRefreshService.OBJECT_DETAILS_CHANGED_EVENT = "object-details";
        QuickstartRefreshService.REFRESH_DELAY = 200;
        QuickstartRefreshService.RELEVANT_PROPERTIES = [
            "host",
            "hciConfig.workflowState",
            "hciConfig.configuredHosts",
            "configurationEx.drsConfig.enabled",
            "configurationEx.dasConfig.enabled",
            "configurationEx.vsanConfigInfo.enabled"
        ];
        QuickstartRefreshService.$inject = ["$rootScope", "defaultUriSchemeUtil"];
        return QuickstartRefreshService;
    }());
    cluster_ui.QuickstartRefreshService = QuickstartRefreshService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("quickstartRefreshService", QuickstartRefreshService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var RestoreResourcePoolTreeService = (function () {
        function RestoreResourcePoolTreeService(mutationService, i18nService, resourceTypesConstants, $q) {
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.resourceTypesConstants = resourceTypesConstants;
            this.$q = $q;
        }
        RestoreResourcePoolTreeService.prototype.validateSnapshotFile = function (objectId, byteArray) {
            return this.mutationService.validate(objectId, "com.vmware.vsphere.client.cluster.rp.RestoreRpTreeSpec", { rpTreeSnapshot: byteArray });
        };
        RestoreResourcePoolTreeService.prototype.applyMutationOperation = function (objectId, byteArray) {
            this.mutationService.apply(objectId, "com.vmware.vsphere.client.cluster.rp.RestoreRpTreeSpec", { rpTreeSnapshot: byteArray });
        };
        RestoreResourcePoolTreeService.prototype.getValidationResultType = function (resultType) {
            var validationMessage = this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.validation.error");
            switch (resultType) {
                case this.resourceTypesConstants.resultValidationType.DIFFERENT_CLUSTER_ERROR:
                    return this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.different.cluster.validation.error");
                case this.resourceTypesConstants.resultValidationType.DRS_DISABLED_ERROR:
                    return this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.drs.disabled.validation.error");
                case this.resourceTypesConstants.resultValidationType.HAS_CHILD_RP_ERROR:
                    return this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.rp.present.validation.error");
                case this.resourceTypesConstants.resultValidationType.DESERIALIZATION_ERROR:
                    return this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.snapshot.deserialization.error");
                case this.resourceTypesConstants.resultValidationType.VMS_WITH_MISSING_PRIVILEGES_ERROR:
                    return this.i18nService.getString("ClusterUi", "restore.rp.tree.dialog.vm.missing.privileges.error");
                default: return validationMessage;
            }
        };
        RestoreResourcePoolTreeService.prototype.readFileContent = function (file) {
            if (!file) {
                return this.$q.when(null);
            }
            var deferredResult = this.$q.defer();
            var fileReader = new FileReader();
            fileReader.onload = function () {
                var readerResult = fileReader.result;
                deferredResult.resolve(readerResult);
            };
            fileReader.addEventListener("error", function () {
                deferredResult.resolve(null);
            });
            fileReader.readAsArrayBuffer(file);
            return deferredResult.promise;
        };
        RestoreResourcePoolTreeService.$inject = ["mutationService", "i18nService", "resourceTypesConstants",
            "$q"];
        return RestoreResourcePoolTreeService;
    }());
    cluster_ui.RestoreResourcePoolTreeService = RestoreResourcePoolTreeService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("restoreResourcePoolTreeService", RestoreResourcePoolTreeService);
})(cluster_ui || (cluster_ui = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('drsPortletService', drsPortletService);

   drsPortletService.$inject = ['dataService', 'i18nService',
      'drsAutomationLevelService', 'drsMigrationThresholdService',
      'dpmAutomationLevelService', 'numberFormatterService'];

   function drsPortletService(dataService, i18nService, drsAutomationLevelService,
         drsMigrationThresholdService, dpmAutomationLevelService, numberFormatterService) {

      return {
         getViewData: getViewData
      };

      function getViewData(clusterId) {
         return dataService.getData(
               clusterId,
               'com.vmware.vsphere.client.clusterui.model.ClusterDrsPortletData',
               {queryName: 'drsPortletService.' + getViewData.name})
            .then(function (drsData) {
            if (!drsData) {
               return null;
            }

            var drsViewData = {};

            drsViewData.currentDeviation = drsData.currentBalance / 1000;
            drsViewData.targetDeviation = drsData.targetBalance / 1000;

            var currentAutomationLevel =
                  drsAutomationLevelService.getLevelByKey(drsData.defaultVmBehavior);
            drsViewData.currentAutomationLevelText = currentAutomationLevel.label;

            drsViewData.currentMigrationThresholdText =
                  drsMigrationThresholdService.getText(drsData.migrationThreshold);

            drsViewData.currentDpmAutomationLevelText = dpmAutomationLevelService.getText(
                  drsData.dpmEnabled, drsData.defaultDpmBehavior);

            drsViewData.overallDrsBalanceText = getOverallDrsBalanceText(
                  drsViewData.currentDeviation, drsViewData.targetDeviation);
            drsViewData.currentDeviationForTooltip =
                  getCurrentDeviationForTooltip(drsViewData.currentDeviation);
            drsViewData.permittedDeviationForTooltip =
                  getPermittedDeviationForTooltip(drsViewData.targetDeviation);

            return {
               data: drsData,
               viewData: drsViewData
            };
         });
      }

      function getOverallDrsBalanceText(currentDeviation, targetDeviation) {
         if (!isDeviationAvailable(currentDeviation) ||
               !isDeviationAvailable(targetDeviation)) {
            return getString("drs.portlet.naLabel");
         }

         if (currentDeviation === 0) {
            return getString("drs.portlet.perfectlyBalancedLabel");
         }

         if (currentDeviation < targetDeviation) {
            return getString("drs.portlet.balancedLabel");
         }

         if (currentDeviation === targetDeviation) {
            return getString("drs.portlet.barelyBalancedLabel");
         }

         return getString("drs.portlet.imbalancedLabel");
      }

      function getPermittedDeviationForTooltip(targetDeviation) {
         if (!isDeviationAvailable(targetDeviation)) {
            return getString("drs.portlet.tooltip.targetDeviationNA");
         }

         var formattedTargetDeviation =
               numberFormatterService.format(targetDeviation);
         return i18nService.getString('ClusterUi',
               'drs.portlet.tooltip.targetDeviationTextFormat',
               formattedTargetDeviation);
      }

      function getCurrentDeviationForTooltip(currentDeviation) {
         if (!isDeviationAvailable(currentDeviation)) {
            return getString("drs.portlet.tooltip.currentDeviationNA");
         }

         var formattedCurretnDeviation = numberFormatterService.format(currentDeviation);
         return formattedCurretnDeviation.toString();
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function isDeviationAvailable(deviation) {
         if (typeof deviation !== 'number' || isNaN(deviation) ||
               deviation < 0 || 1 < deviation) {
            return false;
         }
         return true;
      }
   }
})();

/** Copyright 2016 VMware, Inc.  All rights reserved. -- VMware Confidential*/

angular.module('com.vmware.vsphere.client.cluster').constant('ftConstants', {
   ftState: {
      DISABLED: 'disabled',
      ENABLED: 'enabled',
      NEED_SECONDARY: 'needSecondary',
      STARTING: 'starting',
      RUNNING: 'running',
      PROTECTED: 'protected',
      ENABLED_POWERED_ON: 'enabledPoweredOn',
      ENABLED_NOT_POWERED_ON: 'enabledNotPoweredOn',
      NOT_RUNNING: 'notRunning',
      NOT_PROTECTED: 'notProtected',
      NOT_CONFIGURED: 'notConfigured'
   },
   powerState: {
      POWERED_OFF: 'poweredOff',
      POWERED_ON: 'poweredOn',
      SUSPENDED: 'suspended'
   },
   moduleName: {
      FT_STATE: 'ftState.',
      FT_STATUS: 'ftStatus.',
      FT_STATUS_TOOLTIP: 'ftStatusTooltip.'
   },
   warnings: {
      INVALID_FT_STATE: 'Unexpected FT state: ',
      UNEXPECTED_FT_STATE: 'Invalid virtual machine fault tolerance state. '
   }
});


/** Copyright 2016 VMware, Inc.  All rights reserved. -- VMware Confidential*/

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.cluster')
         .service('ftPortletService', ftPortletService);

   ftPortletService.$inject = ['dataService'];

   function ftPortletService(dataService) {
      return {
         requestData: requestData
      };

      function requestData(vmId) {
         return dataService.getProperties(vmId, ['ftportlet:ftdata']);
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.cluster')
         .controller('CreateClusterController', CreateClusterController);

   CreateClusterController.$inject = [
      '$rootScope',
      '$scope',
      '$q',
      'mutationService',
      'defaultUriSchemeUtil',
      'dataService',
      'extensionService',
      'vuiConstants',
      'i18nService',
      'clusterSpecBuilderService',
      'drsAutomationLevelService',
      'drsMigrationThresholdService',
      'haVmMonitoringService',
      'iconService',
      'vcService'
   ];

   function CreateClusterController(
         $rootScope,
         $scope,
         $q,
         mutationService,
         defaultUriSchemeUtil,
         dataService,
         extensionService,
         vuiConstants,
         i18nService,
         clusterSpecBuilderService,
         drsAutomationLevelService,
         drsMigrationThresholdService,
         haVmMonitoringService,
         iconService,
         vcService) {
      var self = this;
      var specType = "com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec";
      var quickstartExtensionId = "vsphere.core.cluster.manage.settings.quickstart";
      var contextObjectId = $scope.modalOptions.dialogData.objectId;
      var contextObjectMor =
            defaultUriSchemeUtil.getManagedObjectReference(contextObjectId);

      self.isVc65OrLater = false;
      // Default EVC mode settings.
      var DISABLED_EVC_MODE = {
         key: null,
         label: getString('evc.config.disableText'),
         description: getString('create.blank')
      };

      $scope.modalOptions.onSubmit = onOkClick;

      // The object that contains the new cluster configuration.
      self.formState = {};
      // EVC modes. They will be retrieved from the server.
      self.supportedEvcModes = [];
      // DRS automation levels drop-down options
      self.drsAutomationLevels = drsAutomationLevelService.getLevels();
      // DRS migration threshold slider options
      self.drsMigrationThresholdSliderOptions = getSliderOptions();
      // HA vm monitoring related options
      self.haVmMonitoringStates = haVmMonitoringService.getMonitoringLevels();
      $scope.modalOptions.isAlertClosed = true;

      var drsSignPostMessage =
            '<div class="flex-row">' +
            '<div class="flex-auto flex-column">' +
            '<div>' + getString('create.DRS.signpost.message.automationLevel') + '</div>' +
            '<div>' + getString('create.DRS.signpost.message.migrationThreshold') + '</div>' +
            '</div>' +
            '<div class="flex-auto flex-column">' +
            '<div>' + getString('create.DRS.signpost.message.automationLevelValue') + '</div>' +
            '<div>' + getString('create.DRS.signpost.message.migrationThresholdValue') + '</div>' +
            '</div>' +
            '</div>';

      self.drsSignPostParams = {
         title: getString('create.DRS.signpost.title'),
         message: drsSignPostMessage
      };

      var haSignPostMessage =
            '<div class="flex-row">' +
            '<div class="flex-auto flex-column">' +
            '<div>' + getString('create.HA.signpost.message.hostMonitoring') + '</div>' +
            '<div>' + getString('create.HA.signpost.message.admissionControl') + '</div>' +
            '<div>' + getString('create.HA.signpost.message.vmMonitoring') + '</div>' +
            '</div>' +
            '<div class="flex-auto flex-column">' +
            '<div>' + getString('create.HA.signpost.message.hostMonitoringValue') + '</div>' +
            '<div>' + getString('create.HA.signpost.message.admissionControlValue') + '</div>' +
            '<div>' + getString('create.HA.signpost.message.vmMonitoringValue') + '</div>' +
            '</div>' +
            '</div>';

      self.haSignPostParams = {
         title: getString('create.HA.signpost.title'),
         message: haSignPostMessage
      };

      getViewData();

      function getViewData() {
         setPageBusy(true);

         var dataRequest = dataService.getProperties(
               contextObjectId, ['name', 'createClusterConfig']);

         $q.all([vcService.is65VcOrLater(contextObjectId), dataRequest]).then(
               function (response) {
                  self.isVc65OrLater = response[0];
                  var data = response[1];
                  var supportedEvcModes =
                        data.createClusterConfig.evcModes.slice();
                  // Add fake evc mode to support disabled state
                  supportedEvcModes.unshift(DISABLED_EVC_MODE);
                  self.supportedEvcModes = supportedEvcModes;
                  self.hciEnabled = !!data.createClusterConfig.hciWorkflowSupported;
                  self.formState = createFormState(data);

                  setPageBusy(false);
               });
      }

      // Creates a form state object with initial values/defaults.
      function createFormState(data) {
         var formData = {
            clusterName: data.createClusterConfig.uniqueName,
            currentEvcMode: DISABLED_EVC_MODE,
            drsEnabled: false,
            haEnabled: false,
            parent: contextObjectMor,
            drsAutomation: getDrsSettings(),
            haConfiguration: getHaSettings(),
            locationIcon: getLocationIcon(contextObjectMor),
            locationName: _.escape(data.name)
         };

         if (self.hciEnabled) {
            formData.vsanEnabled = false;
         }

         return formData;
      }

      // Initial HA settings.
      function getHaSettings() {

         var admissionControlPolicy;
         if(self.isVc65OrLater) {
            admissionControlPolicy = {
               _type: 'com.vmware.vim.binding.vim.cluster.FailoverResourcesAdmissionControlPolicy'
            };
         } else {
            admissionControlPolicy = {
               _type: 'com.vmware.vim.binding.vim.cluster.FailoverLevelAdmissionControlPolicy',
               failoverLevel: 1
            };
         }

         return {
            vmMonitoringState: haVmMonitoringService.DEFAULT_STATE.id,
            hostMonitoringEnabled: true,
            admissionControlEnabled: true,
            admissionControl: {
               policy: admissionControlPolicy
            }
         };
      }

      // Init DRS automation settings.
      function getDrsSettings() {
         return {
            automationLevel: drsAutomationLevelService.DEFAULT_LEVEL,
            migrationThreshold: self.drsMigrationThresholdSliderOptions.value
         };
      }

      // Migration threshold vui-slider options.
      function getSliderOptions() {
         return {
            value: drsMigrationThresholdService.DEFAULT,
            min: drsMigrationThresholdService.MIN,
            max: drsMigrationThresholdService.MAX,
            minLabel: drsMigrationThresholdService.MIN_LABEL,
            maxLabel: drsMigrationThresholdService.MAX_LABEL,
            enabled: true,
            width: 'auto',
            dragHandleTitle: getString('create.vm.DRS.migration.threshold')
         };
      }

      function onOkClick() {
         // Update the threshold manually.
         // The spec is not bound to the slider's value.
         self.formState.drsAutomation.migrationThreshold =
               parseInt(self.drsMigrationThresholdSliderOptions.value, 10);

         var spec = clusterSpecBuilderService.buildClusterComputeResourceSpec(
               self.formState, false, self.hciEnabled);

         setPageBusy(true);
         mutationService.validate(contextObjectId, specType, spec)
               .then(function (validationResult) {
                  handleValidationResult(validationResult, spec);
                  setPageBusy(false);
               })
               .catch(function(error) {
                  setPageBusy(false);
                  $q.reject(error);
               });
         return false;
      }

      function handleValidationResult(validationResult, spec) {
         if (!validationResult ||
               validationResult.error || !validationResult.result ||
               validationResult.result.isValid === true) {
            var createClusterPromise = mutationService.add(specType, spec);

            if (self.hciEnabled) {
               var quickstartExtensionPromise =
                     extensionService.getHostedExtensions(quickstartExtensionId);

               $q.all([createClusterPromise, quickstartExtensionPromise])
                     .then(function (response) {
                        navigateToClusterQuickstart(response);
                     });
            }

            $scope.closeModal();
         } else {
            $scope.modalOptions.alerts = [{
               type: vuiConstants.validationBanner.type.ERROR,
               text: validationResult.result.validationMessage
            }];
            $scope.modalOptions.isAlertClosed = false;
         }
      }

      function navigateToClusterQuickstart(response) {
         var operationResult = response[0];
         var extensionResult = response[1];

         if (operationResult && operationResult.result && extensionResult
               && extensionResult.length > 0 && extensionResult[0]
               && extensionResult[0].uid) {
            var newClusterId = defaultUriSchemeUtil.getVsphereObjectId(
                  operationResult.result);

            $rootScope._navigateToViewAndObject(
                  quickstartExtensionId,
                  newClusterId);
         }
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         self.loading = isBusy;
      }

      function getLocationIcon(locationRef) {
         return iconService.getByObjectRef(locationRef);
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('CreateResourcePoolController', [
            '$scope', 'dataService', 'managedEntityMutationService',
            'i18nService', 'vuiConstants', 'mutationService',
            'defaultUriSchemeUtil', 'managedEntityConstants', '$q',
            'createResourcePoolService', 'bytesFilter', 'cpuClockFilter',
            'resourcePoolManagementService',
            function ($scope, dataService, managedEntityMutationService,
                      i18nService, vuiConstants, mutationService,
                      defaultUriSchemeUtil, managedEntityConstants, $q,
                      createResourcePoolService, bytesFilter, cpuClockFilter,
                      resourcePoolManagementService) {

               var self = this;
               var parentObjectId;
               var parentMoRef;
               var defaultNewRpName = i18nService.getString('RpUi',
                     'actionCreateRPDefaultName');
               var unlimitedLabel = i18nService.getString('RpUi', 'labelUnlimited');

               var resourcePoolManagementServiceInstance = resourcePoolManagementService
                     .createInstance();

               self.error = false;

               // CPU reservation defaults.
               self.cpuReservationOptions = resourcePoolManagementServiceInstance
                     .getCpuDropdownOptions();
               self.cpuUnitOptions = resourcePoolManagementServiceInstance
                     .getCpuUnitOptions();

               // CPU limit defaults
               self.cpuLimitOptions = resourcePoolManagementServiceInstance
                     .getCpuLimitOptions();

               // Memory reservation defaults.
               self.memoryReservationOptions = resourcePoolManagementServiceInstance
                     .getMemoryDropdownOptions();
               self.memoryUnitOptions = resourcePoolManagementServiceInstance
                     .getMemoryUnitOptions();

               // Memory limit defaults.
               self.memoryLimitOptions = resourcePoolManagementServiceInstance
                     .getMemoryLimitOptions();

               self.cpuReservationValueErrorMessages = {
                  min: cpuReservationRangeErrorMessage,
                  max: cpuReservationRangeErrorMessage
               };

               self.memoryReservationValueErrorMessages = {
                  min: memoryReservationRangeErrorMessage,
                  max: memoryReservationRangeErrorMessage
               };

               self.cpuLimitValueErrorMessages = {
                  min: cpuLimitRangeErrorMessage,
                  max: cpuLimitRangeErrorMessage
               };

               self.memoryLimitValueErrorMessages = {
                  min: memoryLimitRangeErrorMessage,
                  max: memoryLimitRangeErrorMessage
               };

               // Format limits.
               _.each(self.cpuReservationOptions, cpuFormatter);
               _.each(self.cpuLimitOptions, cpuFormatter);
               _.each(self.memoryReservationOptions, memoryFormatter);
               _.each(self.memoryLimitOptions, memoryFormatter);

               parentObjectId = $scope.modalOptions.dialogData.objectId;
               parentMoRef = defaultUriSchemeUtil.getManagedObjectReference(
                     parentObjectId
               );

               self.spec = createResourcePoolService.createDefaultResourcePoolSpec();
               self.spec.name = defaultNewRpName;

               $scope.modalOptions.onSubmit = onSubmit;

               getViewData();

               function cpuReservationRangeErrorMessage() {
                  return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                        i18nService.getString('RpUi', 'RpCpu.Label.Reservation'),
                        i18nService.getString('RpUi', 'cpuValue', 0),
                        i18nService.getString('RpUi', 'cpuValue',
                              self.cpuReservationOptions.maximum.value)
                  );
               }

               function memoryReservationRangeErrorMessage() {
                  return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                        i18nService.getString('RpUi', 'RpMemory.Label.Reservation'),
                        i18nService.getString('RpUi', 'memValue', 0),
                        i18nService.getString('RpUi', 'memValue',
                              self.memoryReservationOptions.maximum.value)
                  );
               }

               function cpuLimitRangeErrorMessage() {
                  return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                        i18nService.getString('RpUi', 'settings.limit'),
                        i18nService.getString('RpUi', 'cpuValue',
                              self.cpuLimitOptions.minimum.value),
                        i18nService.getString('RpUi', 'cpuValue',
                              self.cpuLimitOptions.maximum.value)
                  );
               }

               function memoryLimitRangeErrorMessage() {
                  return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                        i18nService.getString('RpUi', 'settings.limit'),
                        i18nService.getString('RpUi', 'memValue',
                              self.memoryLimitOptions.minimum.value),
                        i18nService.getString('RpUi', 'memValue',
                              self.memoryLimitOptions.maximum.value)
                  );
               }

               function cpuFormatter(element) {
                  element.formattedValue = cpuClockFilter(element.value,
                        i18nService.getString('RpUi', 'rpCpu.MHz'));
               }

               function memoryFormatter(element) {
                  element.formattedValue = (element.value === -1) ?
                        unlimitedLabel : bytesFilter(element.value, 'MB');
               }

               function setPageBusy(isBusy) {
                  $scope.modalOptions.submitDisabled = isBusy;
                  self.loading = isBusy;
               }

               function showValidationMessages(messages) {
                  var validationErrorMessages = _.map(messages, function (message) {
                     return {
                        type: vuiConstants.validationBanner.type.ERROR,
                        text: message
                     };
                  });
                  $scope.modalOptions.alerts = validationErrorMessages;
               }

               function getViewData() {
                  setPageBusy(true);

                  var realParentMoRefPromise;
                  if (parentMoRef.type === managedEntityConstants.CLUSTER) {
                     realParentMoRefPromise =
                           dataService.getProperties(parentObjectId, ['resourcePool'])
                                 .then(function (data) {
                                    return data.resourcePool;
                                 });
                  } else if (parentMoRef.type === managedEntityConstants.HOST) {
                     realParentMoRefPromise =
                           dataService.getPropertiesByRelation(
                                 parentObjectId,
                                 'host',
                                 managedEntityConstants.COMPUTE_RESOURCE,
                                 ['resourcePool']
                           ).then(function (data) {
                              return _.values(data)[0].resourcePool;
                           });
                  } else if (parentMoRef.type === managedEntityConstants.RESOURCE_POOL ||
                        parentMoRef.type === managedEntityConstants.V_APP) {
                     realParentMoRefPromise = $q.when(parentMoRef);
                  } else {
                     realParentMoRefPromise = $q.reject();
                  }

                  realParentMoRefPromise
                        .then(function (realParentMoRef) {
                           self.spec.parent = realParentMoRef;
                           var resourcePoolConfigDataUri =
                                 defaultUriSchemeUtil.createVmomiUri(
                                       self.spec.parent.type,
                                       self.spec.parent.value,
                                       self.spec.parent.serverGuid);

                           return dataService.getData(
                                 resourcePoolConfigDataUri,
                                 'com.vmware.vsphere.client.clusterui.model.ResourcePoolConfigData'
                           );
                        })
                        .then(function (data) {
                           if (!data) {
                              setPageBusy(false);
                              return null;
                           }

                           // max cpu allowed reservation
                           resourcePoolManagementServiceInstance.setCpuRuntimeInfo(
                                 data.runtimeInfo.cpu);
                           self.cpuReservationOptions = resourcePoolManagementServiceInstance
                                 .getCpuDropdownOptions();

                           // max cpu limit
                           resourcePoolManagementServiceInstance.setCpuLimitInfo(
                                 data.runtimeInfo.cpu);
                           self.cpuLimitOptions = resourcePoolManagementServiceInstance
                                 .getCpuLimitOptions();

                           // max memory allowed reservation
                           resourcePoolManagementServiceInstance.setMemoryRuntimeInfo(
                                 data.runtimeInfo.memory);
                           self.memoryReservationOptions =
                                 resourcePoolManagementServiceInstance
                                       .getMemoryDropdownOptions();

                           // max memory limit
                           resourcePoolManagementServiceInstance.setMemoryLimitInfo(
                                 data.runtimeInfo.memory);
                           self.memoryLimitOptions =
                                 resourcePoolManagementServiceInstance.getMemoryLimitOptions();

                           // format limits
                           _.each(self.cpuReservationOptions, cpuFormatter);
                           _.each(self.cpuLimitOptions, cpuFormatter);
                           _.each(self.memoryReservationOptions, memoryFormatter);
                           _.each(self.memoryLimitOptions, memoryFormatter);
                           setPageBusy(false);
                        })
                        .catch(function () {
                           self.error = true;
                           setPageBusy(false);
                        });
               }

               function validate() {
                  if (!self.spec.name || (/^\s*$/gi).test(self.spec.name)) {
                     showValidationMessages(
                           [i18nService.getString('CommonModuleUi',
                                 'NameValidator.emptyName')]);
                     return $q.reject();
                  }

                  if ($scope.createResourcePoolForm.$invalid || self.error) {
                     return $q.reject();
                  }

                  var createRpNameSpec = createResourcePoolService
                        .createCreateResourcePoolNameSpec(self.spec.name);

                  var validationPromise =
                        mutationService.validate(
                              parentObjectId,
                              'com.vmware.vsphere.client.h5.rp.CreateResourcePoolNameSpec',
                              createRpNameSpec
                        ).then(function (validationResult) {
                           if (validationResult && validationResult.result) {
                              showValidationMessages([validationResult.result]);

                              return $q.reject();
                           } else {
                              return $q.resolve();
                           }
                        });

                  return validationPromise;
               }

               function onSubmit() {
                  if (self.loading) {
                     return false;
                  }

                  $scope.modalOptions.alerts = [];

                  setPageBusy(true);
                  validate()
                        .then(function () {
                           mutationService.add(
                                 'com.vmware.vsphere.client.rp.ResourcePoolSpec',
                                 self.spec,
                                 i18nService.getString('RpUi', "actionCreateRPLabel")
                           );
                           setPageBusy(false);
                           $scope.closeModal();
                        })
                        .catch(function (error) {
                           setPageBusy(false);
                           $q.reject(error);
                        });
                  //manually close the dialog when the validation promise resolves
                  //always return false, so the clarity modal service doesn't close it
                  return false;
               }
            }
         ]);
})();

var cluster_ui;
(function (cluster_ui) {
    var EditClusterController = (function () {
        function EditClusterController($scope, $q, clarityConstants, clarityModalService, clusterConstants, clusterSpecBuilderService, dataService, drsAutomationLevelService, editDrsFileDownloadService, haConstants, haVmMonitoringService, i18nService, iconService, mutationService) {
            this.$scope = $scope;
            this.$q = $q;
            this.clarityConstants = clarityConstants;
            this.clarityModalService = clarityModalService;
            this.clusterConstants = clusterConstants;
            this.clusterSpecBuilderService = clusterSpecBuilderService;
            this.dataService = dataService;
            this.drsAutomationLevelService = drsAutomationLevelService;
            this.editDrsFileDownloadService = editDrsFileDownloadService;
            this.haConstants = haConstants;
            this.haVmMonitoringService = haVmMonitoringService;
            this.i18nService = i18nService;
            this.iconService = iconService;
            this.mutationService = mutationService;
            this.loading = true;
        }
        EditClusterController.prototype.$onInit = function () {
            var _this = this;
            this.clusterId = this.$scope.modalOptions.dialogData.objectId;
            this.$scope.modalOptions.onSubmit = function () {
                return _this.onSubmit();
            };
            this.dataService.getData(this.clusterId, "com.vmware.vsphere.client.clusterui.model.configuration.ClusterConfigData")
                .then(function (clusterConfigData) {
                if (clusterConfigData) {
                    _this.formState = clusterConfigData;
                    _this.formState.locationIcon = _this.getLocationIcon(_this.formState.location),
                        _this.initSignpost(clusterConfigData);
                }
            })
                .finally(function () {
                _this.setPageBusy(false);
            });
        };
        EditClusterController.prototype.initSignpost = function (clusterConfigData) {
            var drsSignPostMessage = "<div class=\"flex-row\">\n            <div class=\"flex-auto flex-column\">\n               <div>" + this.getString("create.DRS.signpost.message.automationLevel") + "</div>\n               <div>" + this.getString("create.DRS.signpost.message.migrationThreshold") + "</div>\n            </div>\n            <div class=\"flex-auto flex-column\">\n               <div>" + this.drsAutomationLevelService.getLabel(clusterConfigData.defaultDrsBehavior) + "</div>\n               <div>" + clusterConfigData.migrationThreshold + "</div>\n            </div>\n         </div>";
            this.drsSignPostParams = {
                title: this.getString("create.DRS.signpost.title"),
                message: drsSignPostMessage
            };
            var haSignPostMessage = "<div class=\"flex-row\">\n            <div class=\"flex-auto flex-column\">\n               <div>" + this.getString("create.HA.signpost.message.hostMonitoring") + "</div>\n               <div>" + this.getString("create.HA.signpost.message.admissionControl") + "</div>\n               <div>" + this.getString("create.HA.signpost.message.vmMonitoring") + "</div>\n            </div>\n            <div class=\"flex-auto flex-column\">\n               <div>" + this.getHostMonitoring(clusterConfigData.hostMonitoring) + "</div>\n               <div>" + this.getAdmissionControl(clusterConfigData.admissionControlEnabled) + "</div>\n               <div>" + this.haVmMonitoringService.getLabel(clusterConfigData.vmMonitoring) + "</div>\n            </div>\n         </div>";
            this.haSignPostParams = {
                title: this.getString("create.HA.signpost.title"),
                message: haSignPostMessage
            };
        };
        EditClusterController.prototype.onSubmit = function () {
            var _this = this;
            var clusterSpec = this.clusterSpecBuilderService.buildClusterComputeResourceSpec(this.formState, true);
            this.setPageBusy(true);
            return this.mutationService.validate(this.clusterId, "com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec", clusterSpec)
                .then(function (validationResult) {
                return _this.onValidation(validationResult);
            })
                .then(function () {
                _this.mutationService.apply(_this.clusterId, "com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec", clusterSpec);
                if (clusterSpec.name) {
                    _this.mutationService.apply(_this.clusterId, "com.vmware.vsphere.client.mixed.ManagedEntityNameInfo", {
                        name: clusterSpec.name
                    });
                }
                return _this.$q.resolve(true);
            }, function () { return _this.$q.resolve(false); })
                .finally(function () {
                _this.setPageBusy(false);
            });
        };
        EditClusterController.prototype.onValidation = function (validationResult) {
            var title;
            if (!validationResult ||
                (!validationResult.error && (!validationResult.result ||
                    validationResult.result.isValid === true))) {
                return this.$q.resolve();
            }
            else if (validationResult.error) {
                var message = validationResult.error.localizedMessage ?
                    validationResult.error.localizedMessage : validationResult.error.message;
                this.showValidationMessages(message);
                return this.$q.reject();
            }
            else {
                if (validationResult.result.errorCode === this.clusterConstants.
                    editClusterErrorCodes.DRS_OFF_WITH_RESOURCE_POOLS) {
                    return this.editDrsFileDownloadService.showYesNoCancelDialog(this.clusterId);
                }
                else if (validationResult.result.errorCode === this.clusterConstants.
                    editClusterErrorCodes.DPM_ON_WITH_HOSTS_STANDBY) {
                    title = this.getString("drs.config.editDrs.dpmTurningOnCaption");
                    return this.showConfirmationDialog(title, validationResult.result.validationMessage, validationResult.result.validationData);
                }
                else {
                    var validationMessages = [validationResult.result.validationMessage];
                    this.showValidationMessages(validationMessages);
                    return this.$q.reject();
                }
            }
        };
        EditClusterController.prototype.showConfirmationDialog = function (title, message, invalidHosts) {
            var deferred = this.$q.defer();
            var titleText = title;
            var messageText = message;
            _.each(invalidHosts, function (host) {
                messageText += "\n" + host;
            });
            var modalOptions = {
                title: titleText,
                message: messageText,
                submit: function () { return deferred.resolve(true); },
                onCancel: function () { return deferred.reject(); },
                preserveNewlines: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
            return deferred.promise;
        };
        EditClusterController.prototype.showValidationMessages = function (messages) {
            var _this = this;
            var validationErrorMessages = _.map(messages, function (message) {
                return {
                    type: _this.clarityConstants.notifications.type.ERROR,
                    text: message
                };
            });
            this.$scope.modalOptions.isAlertClosed = false;
            this.$scope.modalOptions.alerts = validationErrorMessages;
        };
        EditClusterController.prototype.getLocationIcon = function (locationRef) {
            return this.iconService.getByObjectRef(locationRef);
        };
        EditClusterController.prototype.setPageBusy = function (isBusy) {
            this.$scope.modalOptions.submitDisabled = isBusy;
            this.loading = isBusy;
        };
        EditClusterController.prototype.getString = function (key) {
            return this.i18nService.getString("ClusterUi", key);
        };
        EditClusterController.prototype.getHostMonitoring = function (state) {
            return this.getString(state === this.haConstants.hostMonitoringState.ENABLED ?
                "ha.config.hostmonitoring.enabled" :
                "ha.config.hostmonitoring.disabled");
        };
        EditClusterController.prototype.getAdmissionControl = function (admissionControlEnabled) {
            return this.getString(admissionControlEnabled ?
                "ha.config.admission.control.enabled" :
                "ha.config.admission.control.disabled");
        };
        EditClusterController.$inject = ["$scope",
            "$q",
            "clarityConstants",
            "clarityModalService",
            "clusterConstants",
            "clusterSpecBuilderService",
            "dataService",
            "drsAutomationLevelService",
            "editDrsFileDownloadService",
            "haConstants",
            "haVmMonitoringService",
            "i18nService",
            "iconService",
            "mutationService"];
        return EditClusterController;
    }());
    angular.module("com.vmware.vsphere.client.commonModule")
        .controller("EditClusterController", EditClusterController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditResourcePoolScheduledTaskDialogController = (function () {
        function EditResourcePoolScheduledTaskDialogController($scope, i18nService, vscSchedulingHelper, mutationService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vscSchedulingHelper = vscSchedulingHelper;
            this.mutationService = mutationService;
            this.invalidResourcePool = false;
            this.editResourcePool = 'cluster-ui/resources/cluster/views/edit_resource_pool/editResourcePool.html';
            this.SCHEDULE_TASK_SPEC = "com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec";
            this.actionEval = this.$scope.modalOptions.actionEval;
            this.pageModel = this.actionEval.additionalData.schedulingData;
            var callback = this.getResourcePoolSpec.bind(this);
            this.$scope.$on("stDataEvent", callback);
        }
        EditResourcePoolScheduledTaskDialogController.prototype.getPageValidated = function () {
            this.$scope.modalOptions.submitDisabled = true;
            if (this.pageModel.schedulingSpec
                && this.pageModel.schedulingSpec.isFormStatusValid
                && !this.invalidResourcePool) {
                this.$scope.modalOptions.submitDisabled = false;
                return false;
            }
            return true;
        };
        EditResourcePoolScheduledTaskDialogController.prototype.getResourcePoolSpec = function (event, spec) {
            this.invalidResourcePool = spec.invalidResourcePool;
            this.resourcePoolSpec = spec;
        };
        EditResourcePoolScheduledTaskDialogController.prototype.onCommit = function () {
            var mutationSpec = this.pageModel;
            mutationSpec.spec = this.resourcePoolSpec.configSpec;
            mutationSpec.spec._type = this.resourcePoolSpec._type;
            mutationSpec.schedulingSpec.recurrence
                = this.vscSchedulingHelper.formatRecurrenceData(mutationSpec.schedulingSpec.recurrence);
            this.mutationService.apply(this.resourcePoolSpec.objectId, this.SCHEDULE_TASK_SPEC, mutationSpec);
            this.$scope.closeModal();
        };
        EditResourcePoolScheduledTaskDialogController.$inject = ["$scope", "i18nService", "vscSchedulingHelper", "mutationService"];
        return EditResourcePoolScheduledTaskDialogController;
    }());
    cluster_ui.EditResourcePoolScheduledTaskDialogController = EditResourcePoolScheduledTaskDialogController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("EditResourcePoolScheduledTaskDialogController", EditResourcePoolScheduledTaskDialogController);
})(cluster_ui || (cluster_ui = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('EditResourcePoolController', ['$scope', 'dataService', 'i18nService',
         'mutationService', 'defaultUriSchemeUtil', 'editResourcePoolService',
         'bytesFilter', 'cpuClockFilter', 'resourcePoolManagementService',
         'managedEntityConstants', '$q',
         function(
            $scope, dataService, i18nService, mutationService, defaultUriSchemeUtil,
            editResourcePoolService, bytesFilter, cpuClockFilter,
            resourcePoolManagementService, managedEntityConstants, $q
         ) {

            var self = this;
            var CONVERT_MEMORY_CONSTANT = 1024 * 1024;
            var VAPP_POWERED_OFF = 'stopped';

            var objectId;
            var unlimitedLabel = i18nService.getString('RpUi', 'labelUnlimited');

            var resourcePoolManagementServiceInstance = resourcePoolManagementService
                  .createInstance();

            // CPU reservation defaults.
            self.cpuReservationOptions = resourcePoolManagementServiceInstance
               .getCpuDropdownOptions();
            self.cpuUnitOptions = resourcePoolManagementServiceInstance
               .getCpuUnitOptions();

            // CPU limit defaults
            self.cpuLimitOptions = resourcePoolManagementServiceInstance
               .getCpuLimitOptions();

            // Memory reservation defaults.
            self.memoryReservationOptions = resourcePoolManagementServiceInstance
               .getMemoryDropdownOptions();
            self.memoryUnitOptions = resourcePoolManagementServiceInstance
               .getMemoryUnitOptions();

            // Memory limit defaults.
            self.memoryLimitOptions = resourcePoolManagementServiceInstance
               .getMemoryLimitOptions();
            self.cpuReservationValueErrorMessages = {
               min: cpuReservationRangeErrorMessage,
               max: cpuReservationRangeErrorMessage
            };
            self.cpuLimitValueErrorMessages = {
               min: cpuLimitRangeErrorMessage,
               max: cpuLimitRangeErrorMessage
            };
            self.memoryReservationValueErrorMessages = {
               min: memoryReservationRangeErrorMessage,
               max: memoryReservationRangeErrorMessage
            };
            self.memoryLimitValueErrorMessages = {
               min: memoryLimitRangeErrorMessage,
               max: memoryLimitRangeErrorMessage
            };

            // Format limits.
            _.each(self.cpuReservationOptions, cpuFormatter);
            _.each(self.cpuLimitOptions, cpuFormatter);
            _.each(self.memoryReservationOptions, memoryFormatter);
            _.each(self.memoryLimitOptions, memoryFormatter);

            self.spec = editResourcePoolService.editDefaultResourcePoolSpec();

            objectId = $scope.modalOptions.dialogData.objectId;

            $scope.modalOptions.onSubmit = function() {
               return onCommit();
            };

            getViewData();

            function getViewData() {
               self.loading = true;
               $scope.modalOptions.submitDisabled = true;

               dataService.getData(
                  objectId,
                  'com.vmware.vsphere.client.clusterui.model.ResourcePoolData')
                  .then(function(resourcePoolData) {
                     if (!resourcePoolData) {
                        self.loading = false;
                        $scope.modalOptions.submitDisabled = false;
                        return null;
                     }

                     var scopeParent =  $scope.$parent.$parent;
                     var additionalData = scopeParent.ctrl && scopeParent.ctrl.actionEval &&
                        scopeParent.ctrl.actionEval.additionalData;

                     if (scopeParent && additionalData && additionalData.isScheduledTask &&
                        additionalData.schedulingData.scheduleTaskOperationMode === 1) {
                        resourcePoolData.config =
                           additionalData.schedulingData.spec.argument[1].value;
                     }

                     setCpuConfig(resourcePoolData);
                     setMemoryConfig(resourcePoolData);
                     // format limits
                     _.each(self.cpuReservationOptions, cpuFormatter);
                     _.each(self.cpuLimitOptions, cpuFormatter);
                     _.each(self.memoryReservationOptions, memoryFormatter);
                     _.each(self.memoryLimitOptions, memoryFormatter);
                     self.loading = false;
                     $scope.modalOptions.submitDisabled = false;
                  })
                  .catch(function(error) {
                     self.loading = false;
                     $scope.modalOptions.submitDisabled = false;
                     $q.reject(error);
                  });
            }

            function cpuReservationRangeErrorMessage() {
               return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                  i18nService.getString('RpUi', 'RpCpu.Label.Reservation'),
                  i18nService.getString('RpUi', 'cpuValue',
                        self.cpuReservationOptions.minimum.value),
                  i18nService.getString('RpUi', 'cpuValue',
                     self.cpuReservationOptions.maximum.value)
               );
            }

            function cpuLimitRangeErrorMessage() {
               return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                     i18nService.getString('RpUi', 'settings.limit'),
                     i18nService.getString('RpUi', 'cpuValue',
                           self.cpuLimitOptions.minimum.value),
                     i18nService.getString('RpUi', 'cpuValue',
                           self.cpuLimitOptions.maximum.value)
               );
            }

            function memoryReservationRangeErrorMessage() {
               return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                  i18nService.getString('RpUi', 'RpMemory.Label.Reservation'),
                  i18nService.getString('RpUi', 'memValue',
                        self.memoryReservationOptions.minimum.value),
                  i18nService.getString('RpUi', 'memValue',
                     self.memoryReservationOptions.maximum.value)
               );
            }

            function memoryLimitRangeErrorMessage() {
               return i18nService.getString('RpUi', 'Util.Validation.ValidRange',
                     i18nService.getString('RpUi', 'settings.limit'),
                     i18nService.getString('RpUi', 'memValue',
                           self.memoryLimitOptions.minimum.value),
                     i18nService.getString('RpUi', 'memValue',
                           self.memoryLimitOptions.maximum.value)
               );
            }

            function cpuFormatter(element) {
               element.formattedValue = cpuClockFilter(element.value,
                  i18nService.getString('RpUi', 'rpCpu.MHz'));
            }

            function memoryFormatter(element) {
               element.formattedValue = (element.value === -1) ?
                  unlimitedLabel : bytesFilter(element.value, 'MB');
            }

            function setCpuConfig(data) {

               var parentUnreservedForPool =
                  Math.max(0, data.parentRuntime.cpu.unreservedForPool);

               var reservationUsed =
                  Math.max(data.runtimeInfo.cpu.reservationUsed,
                  data.config.cpuAllocation.reservation);
               var maxCpuReservation = reservationUsed + parentUnreservedForPool;
               // For vApps that are powered off and located in a cluster you can set
               // the reservation beyond what is currently available.
               if(data.owner.type === managedEntityConstants.CLUSTER
                     && data.summary.vAppState
                     && data.summary.vAppState === VAPP_POWERED_OFF){

                  maxCpuReservation = Math.max(data.parentRuntime.cpu.maxUsage,
                        reservationUsed);
               }

               var parentMaxUsage = data.parentRuntime.cpu.maxUsage;
               var cpuMaxLimit = Math.max(parentMaxUsage, reservationUsed);
               // It may occur that the current limit is larger than the maximum allowed.
               // This is because the maximum allowed may decrease over time. In that
               // case we set the max limit to the current limit, thus allowing the user
               // to keep or decrease the limit, but not increase it.
               cpuMaxLimit = Math.max(cpuMaxLimit, data.config.cpuAllocation.limit);

               // cpu current shares
               self.spec.configSpec.cpuAllocation.shares.shares =
                  data.config.cpuAllocation.shares.shares;
               self.spec.configSpec.cpuAllocation.shares.level =
                  data.config.cpuAllocation.shares.level;

               // max cpu allowed reservation
               resourcePoolManagementServiceInstance.setCpuMaxReservation(
                  maxCpuReservation);

               // min cpu allowed reservation for non-expandable pools
               self.cpuReservationUsed = data.runtimeInfo.cpu.reservationUsed;
               // current cpu reservation
               resourcePoolManagementServiceInstance.setCpuCurrentReservation(
                  data.config.cpuAllocation.reservation);
               self.spec.configSpec.cpuAllocation.reservation =
                  data.config.cpuAllocation.reservation;
               self.cpuReservationOptions = resourcePoolManagementServiceInstance
                  .getCpuDropdownOptions();

               // max cpu limit
               resourcePoolManagementServiceInstance.setCpuMaxLimit(cpuMaxLimit);
               // min cpu limit
               resourcePoolManagementServiceInstance.setCpuMinLimit(
                     data.config.cpuAllocation.reservation);
               // current cpu limit
               resourcePoolManagementServiceInstance.setCpuCurrentLimit(
                  data.config.cpuAllocation.limit);
               self.spec.configSpec.cpuAllocation.limit =
                  data.config.cpuAllocation.limit;
               self.cpuLimitOptions = resourcePoolManagementServiceInstance
                  .getCpuLimitOptions();

               // cpu reservation type
               self.spec.configSpec.cpuAllocation.expandableReservation =
                  data.config.cpuAllocation.expandableReservation;
            }

            function setMemoryConfig(data) {

               var parentUnreservedForPool = Math.max(0,
                     data.parentRuntime.memory.unreservedForPool / CONVERT_MEMORY_CONSTANT);
               var reservationUsed = Math.max(
                     data.runtimeInfo.memory.reservationUsed / CONVERT_MEMORY_CONSTANT,
                     data.config.memoryAllocation.reservation);
               var maxMemoryReservation = parentUnreservedForPool + reservationUsed;
               // For vApps that are powered off and located in a cluster you can set
               // the reservation beyond what is currently available.
               if(data.owner.type === managedEntityConstants.CLUSTER &&
                     data.summary.vAppState &&
                     data.summary.vAppState === VAPP_POWERED_OFF){

                  maxMemoryReservation = Math.max(
                        data.parentRuntime.memory.maxUsage / CONVERT_MEMORY_CONSTANT,
                        reservationUsed
                  );
               }

               var parentMaxUsage = data.parentRuntime.memory.maxUsage
                     / CONVERT_MEMORY_CONSTANT;
               var memoryMaxLimit = Math.max(parentMaxUsage, reservationUsed);
               // It may occur that the current limit is larger than the maximum allowed.
               // This is because the maximum allowed may decrease over time. In that
               // case we set the max limit to the current limit, thus allowing the user
               // to keep or decrease the limit, but not increase it.
               memoryMaxLimit = Math.max(memoryMaxLimit,
                  data.config.memoryAllocation.limit);

               // current memory shares
               self.spec.configSpec.memoryAllocation.shares.shares =
                  data.config.memoryAllocation.shares.shares;
               self.spec.configSpec.memoryAllocation.shares.level =
                  data.config.memoryAllocation.shares.level;

               // max memory allowed reservation
               resourcePoolManagementServiceInstance.setMemoryMaxReservation(maxMemoryReservation);

               // min memory allowed reservation for non-expandable pools.
               self.memoryReservationUsed =
                     data.runtimeInfo.memory.reservationUsed / CONVERT_MEMORY_CONSTANT;
               // current memory reservation
               resourcePoolManagementServiceInstance.setMemoryCurrentReservation(
                  data.config.memoryAllocation.reservation);
               self.spec.configSpec.memoryAllocation.reservation =
                  data.config.memoryAllocation.reservation;
               self.memoryReservationOptions = resourcePoolManagementServiceInstance
                     .getMemoryDropdownOptions();

               // max memory limit
               resourcePoolManagementServiceInstance.setMemoryMaxLimit(memoryMaxLimit);
               // min memory limit
               resourcePoolManagementServiceInstance.setMemoryMinLimit(
                     data.config.memoryAllocation.reservation);
               // current memory limit
               resourcePoolManagementServiceInstance.setMemoryCurrentLimit(
                  data.config.memoryAllocation.limit);
               self.spec.configSpec.memoryAllocation.limit =
                  data.config.memoryAllocation.limit;
               self.memoryLimitOptions =
                  resourcePoolManagementServiceInstance.getMemoryLimitOptions();

               // memory reservation type
               self.spec.configSpec.memoryAllocation.expandableReservation =
                  data.config.memoryAllocation.expandableReservation;
            }

            function setConfigSpecData() {
               if(self.spec.configSpec.cpuAllocation.limit !== -1 &&
                     self.spec.configSpec.cpuAllocation.limit <
                     resourcePoolManagementServiceInstance.getCpuLimitOptions().minimum.value){
                  self.spec.configSpec.cpuAllocation.limit = resourcePoolManagementServiceInstance
                        .getCpuLimitOptions().minimum.value;
               }

               if(self.spec.configSpec.memoryAllocation.limit !== -1 &&
                     self.spec.configSpec.memoryAllocation.limit <
                     resourcePoolManagementServiceInstance.getMemoryLimitOptions().minimum.value){
                  self.spec.configSpec.memoryAllocation.limit =
                        resourcePoolManagementServiceInstance.getMemoryLimitOptions().minimum.value;
               }
            }

            function onCommit() {
               if ($scope.editResourcePoolForm.$invalid) {
                  return false;
               }
               setConfigSpecData();
               mutationService.apply(objectId,
                  'com.vmware.vsphere.client.rp.ResourcePoolSpec',
                  self.spec
               );
               return true;
            }

            function onResourcePoolScheduleTaskCommit() {
               setConfigSpecData();
               var emitDataObject = {
                     objectId: objectId,
                     _type: 'com.vmware.vsphere.client.rp.ResourcePoolSpec',
                     configSpec: self.spec,
                     invalidResourcePool: $scope.editResourcePoolForm.$invalid
               };
               $scope.$emit('stDataEvent', emitDataObject);
            }

            $scope.$watch(angular.bind(this, function () {
               if ($scope.modalOptions.actionEval
                     && $scope.modalOptions.actionEval.additionalData
                     && $scope.modalOptions.actionEval.additionalData.isScheduledTask) {
                  onResourcePoolScheduleTaskCommit();
               }
            }));
         }
      ]);
})();

var cluster_ui;
(function (cluster_ui) {
    var MonitorResourceAllocationViewController = (function () {
        function MonitorResourceAllocationViewController($scope, dataService, i18nService, vxPropertyViewService, vuiConstants, columnRenderersRegistry, defaultUriSchemeUtil, resourceAllocationService, $q, capacityFormatterService) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.resourceAllocationService = resourceAllocationService;
            this.$q = $q;
            this.capacityFormatterService = capacityFormatterService;
            this.gridOptions = {};
            this.reservationType = "cpu";
            this.objectId = $scope._route ? $scope._route.objectId : null;
            var liveRefreshProperties = this.$scope._view.contentSpec.metadata.liveRefreshProperties;
            if (liveRefreshProperties) {
                this.liveRefreshProperties = liveRefreshProperties
                    .split(',')
                    .map(function (prop) { return prop.trim(); });
            }
            $scope.loadingData = false;
            $scope.meters = [];
            $scope.maxCapacityValue = "";
            $scope.reservationData = {};
            this.reservationType = this.resourceAllocationService.getReservationTypeByModel(this.$scope._view.contentSpec.metadata.modelClass);
            this.reservationTitle = (this.reservationType === "cpu") ?
                this.i18nService.getString("ClusterUi", "resourceReservation.cpuTitle") :
                this.i18nService.getString("ClusterUi", "resourceReservation.memoryTitle");
            this.gridOptions = this.getGridOptions();
            this.getData();
        }
        MonitorResourceAllocationViewController.prototype.getData = function () {
            var _this = this;
            if (this.$scope.loadingData) {
                return;
            }
            this.$scope.loadingData = true;
            this.dataService.getData(this.objectId, this.$scope._view.contentSpec.metadata.modelClass)
                .then(function (data) {
                _this.$scope.meters = _this.getMeters(data);
                _this.$scope.maxCapacityValue =
                    _this.resourceAllocationService.getMaxCapacityValue(data);
                _this.$scope.reservationData = _this.getReservationData(data);
                data.reservationUsers = _.map(data.reservationUsers, function (currentUser) {
                    if (!currentUser.sharesInfo) {
                        currentUser.sharesInfo = {
                            level: "",
                            shares: 0
                        };
                    }
                    return currentUser;
                });
                _this.gridOptions.data = data.reservationUsers;
                if (data && data.resourcePool) {
                    _this.objectsToWatchIds =
                        [_this.objectId,
                            _this.defaultUriSchemeUtil
                                .getVsphereObjectId(data.resourcePool.provider)];
                }
                _this.$scope.loadingData = false;
            })
                .catch(function (error) {
                _this.$scope.loadingData = false;
                _this.$q.reject(error);
            });
        };
        MonitorResourceAllocationViewController.prototype.getReservationData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            if (data.totalCapacityFormatted !== undefined) {
                //available only to cluster
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "capacity.clusterTotalCapacity"))
                    .exit()
                    .valueBuilder()
                    .text(data.totalCapacityFormatted);
            }
            if (data.hostTotalCapacityFormatted !== undefined) {
                //available only to host
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "capacity.hostTotalCapacity"))
                    .exit()
                    .valueBuilder()
                    .text(data.hostTotalCapacityFormatted);
            }
            if (data.reservationCapacityFormatted !== undefined) {
                //available only to cluster and host
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "capacity.Total"))
                    .exit()
                    .valueBuilder()
                    .text(data.reservationCapacityFormatted);
            }
            if (data.rpReservationCapacityFormatted !== undefined) {
                //available only to resource pool and vApp
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "capacity.rpTotalCapacity"))
                    .exit()
                    .valueBuilder()
                    .text(data.rpReservationCapacityFormatted);
            }
            if (data.configuredReservationFormatted !== undefined) {
                //available only to resource pool and vApp
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "reservation.Configured"))
                    .exit()
                    .valueBuilder()
                    .text(data.configuredReservationFormatted);
            }
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity.Reserved"))
                .icon("vx-property-view-key-legend-icon monitor-resource-reservation-grid-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.reservedCapacityFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity.Available"))
                .icon("vx-property-view-key-legend-icon monitor-resource-reservation-grid-icon-color-white")
                .exit()
                .valueBuilder()
                .text(data.availableCapacityFormatted);
            if (data.expandableReservation !== undefined) {
                //available only to resource pool and vApp
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(this.i18nService.getString("ClusterUi", "reservationType"))
                    .exit()
                    .valueBuilder()
                    .text(data.expandableReservation ?
                    this.i18nService.getString("ClusterUi", "reservationType.expandable") :
                    this.i18nService.getString("ClusterUi", "reservationType.fixed"));
            }
            return builder.build();
        };
        MonitorResourceAllocationViewController.prototype.getMeters = function (data) {
            return [{
                    colorClass: "monitor-resource-reservation-icon-color-light-blue",
                    value: data.activePercentage,
                    label: this.capacityFormatterService.format(data.reservedCapacityFormatted, this.resourceAllocationService.getMaxCapacityValue(data), data.activePercentage)
                }];
        };
        MonitorResourceAllocationViewController.prototype.getGridOptions = function () {
            return {
                searchable: false,
                resizable: true,
                sortOrder: [{
                        field: "name",
                        dir: "asc"
                    }],
                data: [],
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                columnDefs: this.getColumnDefs(),
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        MonitorResourceAllocationViewController.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("ClusterUi", "nameColumnHeader"),
                    field: "name",
                    type: "string",
                    template: function (data) {
                        var objData = data || {};
                        var renderer = _this.columnRenderersRegistry.getColumnRenderer("object-name");
                        objData.uid = _this.defaultUriSchemeUtil.getVsphereObjectId(objData.provider);
                        return renderer(["uid", "primaryIconId", "name", "labelIds"], objData);
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "reservationColumnHeader." + this.reservationType),
                    //possible properties reservationColumnHeader.cpu or reservationColumnHeader.memory
                    field: "reservation",
                    type: "number",
                    template: "<span title=\"#:reservation#\">#:reservation#</span>"
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "limitColumnHeader." + this.reservationType),
                    //possible properties limitColumnHeader.cpu or limitColumnHeader.memory
                    field: "limit",
                    type: "number",
                    template: function (data) {
                        var objData = data || {};
                        return objData.limit !== -1 ? objData.limit :
                            _this.i18nService.getString("ClusterUi", "limit.unlimited");
                    },
                    sortable: this.resourceAllocationService.sortReservationUsersLimit
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "reservationTypeColumnHeader"),
                    field: "expandableReservation",
                    type: "boolean",
                    template: function (data) {
                        var objData = data || {};
                        return objData.expandableReservation ?
                            _this.i18nService.getString("ClusterUi", "reservationType.expandable") :
                            _this.i18nService.getString("ClusterUi", "reservationType.fixed");
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.shareLevelColumn"),
                    field: "sharesInfo.level",
                    type: "string",
                    sortable: this.resourceAllocationService.sortSharesLevels,
                    template: function (data) {
                        var result = "";
                        if (data.sharesInfo.level) {
                            var level = data.sharesInfo.level;
                            result = _this.resourceAllocationService.getSharesValueTextByLevel(level);
                        }
                        return result;
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.sharesValueColumn"),
                    field: "sharesInfo.shares",
                    type: "number",
                    sortable: true,
                    template: function (dataItem) {
                        // this is done in order to display the 0 value
                        return dataItem.sharesInfo.shares.toString();
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "cpuMemAllocation.sharesPercentColumn"),
                    field: "sharesInfoValuePercentFormatted",
                    type: "string",
                    sortable: true
                }
            ];
        };
        MonitorResourceAllocationViewController.$inject = ["$scope", "dataService", "i18nService",
            "vxPropertyViewService", "vuiConstants", "columnRenderersRegistry",
            "defaultUriSchemeUtil", "resourceAllocationService", "$q",
            "capacityFormatterService"];
        return MonitorResourceAllocationViewController;
    }());
    cluster_ui.MonitorResourceAllocationViewController = MonitorResourceAllocationViewController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("MonitorResourceAllocationViewController", MonitorResourceAllocationViewController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsCpuUtilizationComponentController = (function () {
        function DrsCpuUtilizationComponentController($rootScope, i18nService, defaultUriSchemeUtil) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.noCpuOnVms = this.getString("drs.utilization.histogram.barNoCpuUsageLabel");
            this.signPostParams = {};
        }
        DrsCpuUtilizationComponentController.prototype.goToSelectedHostLink = function (host) {
            var selectedHostObjectId = this.defaultUriSchemeUtil.getVsphereObjectId(host.provider);
            this.$rootScope._navigateToObject(selectedHostObjectId);
        };
        DrsCpuUtilizationComponentController.prototype.buildSignPostData = function (vm) {
            var templateUrl = "cluster-ui/resources/cluster/views/monitor/drs/cpuVmBarTooltipContent.html";
            this.signPostParams = {
                templateUrl: templateUrl,
                title: vm.name,
                model: vm,
                width: 300
            };
        };
        DrsCpuUtilizationComponentController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsCpuUtilizationComponentController.$inject = ["$rootScope", "i18nService", "defaultUriSchemeUtil"];
        return DrsCpuUtilizationComponentController;
    }());
    var DrsCpuUtilizationComponent = (function () {
        function DrsCpuUtilizationComponent() {
            this.controller = DrsCpuUtilizationComponentController;
            this.templateUrl =
                "cluster-ui/resources/cluster/views/monitor/drs/drsCpuUtilizationComponent.html";
            this.bindings = {
                data: "<"
            };
        }
        return DrsCpuUtilizationComponent;
    }());
    angular.module("com.vmware.vsphere.client.cluster").component("drsCpuUtilizationComponent", new DrsCpuUtilizationComponent());
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsCpuUtilizationController = (function () {
        function DrsCpuUtilizationController($scope, i18nService, dataService, defaultUriSchemeUtil) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.DRS_CLUSTER_UTILIZATION_MODEL = "com.vmware.vsphere.client.clusterui.model.monitor.drs.utilization.DrsCpuClusterUtilizationData";
            this.cpuUtilizationData = {};
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties = ["configStatus",
                "summary.currentBalance"];
            this.objectId = $scope._route.objectId;
            this.getViewData();
        }
        DrsCpuUtilizationController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, this.DRS_CLUSTER_UTILIZATION_MODEL)
                .then(function (data) {
                _this.sortVms(data);
                _this.cpuUtilizationData = data;
            });
        };
        DrsCpuUtilizationController.prototype.sortVms = function (data) {
            if (data !== null && data.hosts !== null) {
                data.hosts.forEach(function (host) {
                    host.poweredOnVms.sort(function (a, b) {
                        return a.cpuBarWidth > b.cpuBarWidth ? -1 : 1;
                    });
                });
            }
        };
        DrsCpuUtilizationController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsCpuUtilizationController.$inject = ["$scope", "i18nService", "dataService",
            "defaultUriSchemeUtil"];
        return DrsCpuUtilizationController;
    }());
    cluster_ui.DrsCpuUtilizationController = DrsCpuUtilizationController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DrsCpuUtilizationController", DrsCpuUtilizationController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsMemoryUtilizationComponentController = (function () {
        function DrsMemoryUtilizationComponentController($rootScope, i18nService, defaultUriSchemeUtil, clusterConstants) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clusterConstants = clusterConstants;
            this.noMemoryOnVms = this.getString("drs.utilization.histogram.barNoMemoryUsageLabel");
            this.signPostParams = {
                templateUrl: "cluster-ui/resources/cluster/views/monitor/drs/memoryVmBarTooltipContent.html",
                width: 300,
                height: 200,
                direction: "up",
                "class": "drs-utilization-info-tooltip"
            };
            this.memoryUtilizationTypes = this.clusterConstants.memoryUtilizationTypes;
        }
        DrsMemoryUtilizationComponentController.prototype.goToSelectedHostLink = function (host) {
            var selectedHostObjectId = this.defaultUriSchemeUtil.getVsphereObjectId(host.provider);
            this.$rootScope._navigateToObject(selectedHostObjectId);
        };
        DrsMemoryUtilizationComponentController.prototype.buildSignPostData = function (vm) {
            this.signPostParams.title = vm.name;
            this.signPostParams.model = vm;
        };
        DrsMemoryUtilizationComponentController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsMemoryUtilizationComponentController.prototype.getBarWidthForVm = function (vm, memoryUtilizationType) {
            return memoryUtilizationType === this.memoryUtilizationTypes.CONSUMED ?
                vm.consumedMemoryBarWidth : vm.activeMemoryBarWidth;
        };
        DrsMemoryUtilizationComponentController.$inject = ["$rootScope", "i18nService", "defaultUriSchemeUtil", "clusterConstants"];
        return DrsMemoryUtilizationComponentController;
    }());
    var DrsMemoryUtilizationComponent = (function () {
        function DrsMemoryUtilizationComponent() {
            this.controller = DrsMemoryUtilizationComponentController;
            this.templateUrl =
                "cluster-ui/resources/cluster/views/monitor/drs/drsMemoryUtilizationComponent.html";
            this.bindings = {
                data: "<"
            };
        }
        return DrsMemoryUtilizationComponent;
    }());
    angular.module("com.vmware.vsphere.client.cluster").component("drsMemoryUtilizationComponent", new DrsMemoryUtilizationComponent());
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsMemoryUtilizationController = (function () {
        function DrsMemoryUtilizationController($scope, i18nService, dataService, defaultUriSchemeUtil, clusterConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clusterConstants = clusterConstants;
            this.DRS_CLUSTER_UTILIZATION_MODEL = "com.vmware.vsphere.client.clusterui.model.monitor.drs.utilization.DrsMemoryClusterUtilizationData";
            this.drsUtilizationData = {};
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties = ["configStatus",
                "summary.currentBalance"];
            this.objectId = $scope._route.objectId;
            this.selectedMemoryUtilizationType = this.clusterConstants.memoryUtilizationTypes.ACTIVE;
            this.title = this.getString("drs.utilization.active.header");
            this.memoryUtilizationTypes = this.getMemoryUtilizationTypes();
            this.showDropdown = false;
            this.getViewData();
            $scope.$watch(function () {
                return _this.selectedMemoryUtilizationType;
            }, function (newValue) {
                if (newValue) {
                    _this.title = _.find(_this.memoryUtilizationTypes, function (item) {
                        return item.value === newValue;
                    }).header;
                    _this.drsUtilizationData.memoryUtilizationType = newValue;
                }
            });
        }
        DrsMemoryUtilizationController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, this.DRS_CLUSTER_UTILIZATION_MODEL)
                .then(function (data) {
                if (data) {
                    _this.drsUtilizationData = _.extend({
                        memoryUtilizationType: _this.selectedMemoryUtilizationType
                    }, data);
                    _this.sortVms();
                }
            });
        };
        DrsMemoryUtilizationController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsMemoryUtilizationController.prototype.showDropdownEvent = function (value) {
            this.showDropdown = !value;
        };
        DrsMemoryUtilizationController.prototype.setMemoryMetric = function (value) {
            this.selectedMemoryUtilizationType = value;
            this.showDropdown = false;
            this.sortVms();
        };
        DrsMemoryUtilizationController.prototype.sortVms = function () {
            var _this = this;
            if (this.drsUtilizationData !== null && this.drsUtilizationData.hosts !== null) {
                this.drsUtilizationData.hosts.forEach(function (host) {
                    host.poweredOnVms.sort(function (a, b) {
                        if (_this.selectedMemoryUtilizationType ===
                            _this.clusterConstants.memoryUtilizationTypes.ACTIVE) {
                            return a.activeMemoryBarWidth > b.activeMemoryBarWidth ? -1 : 1;
                        }
                        return a.consumedMemoryBarWidth > b.consumedMemoryBarWidth ? -1 : 1;
                    });
                });
            }
        };
        DrsMemoryUtilizationController.prototype.getMemoryUtilizationTypes = function () {
            // Remove the ':' symbol from the string, because this string will be used as a value in the dropdown
            var valueActiveLabel = this.getString("drs.utilization.tooltip.active");
            valueActiveLabel = valueActiveLabel.substr(0, valueActiveLabel.length - 1);
            var valueConsumedLabel = this.getString("drs.utilization.tooltip.consumed");
            valueConsumedLabel = valueConsumedLabel.substr(0, valueConsumedLabel.length - 1);
            return [{
                    value: this.clusterConstants.memoryUtilizationTypes.ACTIVE,
                    header: this.getString("drs.utilization.active.header"),
                    selectValueLabel: valueActiveLabel
                }, {
                    value: this.clusterConstants.memoryUtilizationTypes.CONSUMED,
                    header: this.getString("drs.utilization.consumed.header"),
                    selectValueLabel: valueConsumedLabel
                }];
        };
        DrsMemoryUtilizationController.$inject = ["$scope", "i18nService", "dataService",
            "defaultUriSchemeUtil", "clusterConstants"];
        return DrsMemoryUtilizationController;
    }());
    cluster_ui.DrsMemoryUtilizationController = DrsMemoryUtilizationController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DrsMemoryUtilizationController", DrsMemoryUtilizationController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsNetworkUtilizationComponentController = (function () {
        function DrsNetworkUtilizationComponentController($rootScope, i18nService, defaultUriSchemeUtil) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.signPostParams = {};
        }
        DrsNetworkUtilizationComponentController.prototype.getWidth = function (value) {
            return Math.max(value, 0.5);
        };
        DrsNetworkUtilizationComponentController.prototype.goToSelectedHostLink = function (host) {
            var selectedHostObjectId = this.defaultUriSchemeUtil.getVsphereObjectId(host.provider);
            this.$rootScope._navigateToObject(selectedHostObjectId);
        };
        DrsNetworkUtilizationComponentController.prototype.buildSignPostData = function (host, receivedMode) {
            var templateUrl = "cluster-ui/resources/cluster/views/monitor/drs/networkHostBarTooltipContent.html";
            host.receivedMode = receivedMode;
            this.signPostParams = {
                templateUrl: templateUrl,
                title: host.name,
                model: host,
                width: 300
            };
        };
        DrsNetworkUtilizationComponentController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsNetworkUtilizationComponentController.$inject = ["$rootScope", "i18nService", "defaultUriSchemeUtil"];
        return DrsNetworkUtilizationComponentController;
    }());
    var DrsNetworkUtilizationComponent = (function () {
        function DrsNetworkUtilizationComponent() {
            this.controller = DrsNetworkUtilizationComponentController;
            this.templateUrl =
                "cluster-ui/resources/cluster/views/monitor/drs/drsNetworkUtilizationComponent.html";
            this.bindings = {
                data: "<",
                receivedMode: "<"
            };
        }
        return DrsNetworkUtilizationComponent;
    }());
    angular.module("com.vmware.vsphere.client.cluster").component("drsNetworkUtilizationComponent", new DrsNetworkUtilizationComponent());
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsNetworkUtilizationController = (function () {
        function DrsNetworkUtilizationController(i18nService, dataService, contextObjectService) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.contextObjectService = contextObjectService;
            this.DRS_CLUSTER_UTILIZATION_MODEL = "com.vmware.vsphere.client.clusterui.model.monitor.drs.utilization.DrsNetworkClusterUtilizationData";
            this.drsUtilizationData = {};
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties = ["configStatus",
                "summary.currentBalance"];
            this.objectId = this.contextObjectService.getSelection()[0];
            this.getViewData();
        }
        DrsNetworkUtilizationController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, this.DRS_CLUSTER_UTILIZATION_MODEL)
                .then(function (data) { return _this.drsUtilizationData = data; });
        };
        DrsNetworkUtilizationController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("ClusterUi", key, params);
        };
        DrsNetworkUtilizationController.$inject = ["i18nService", "dataService",
            "contextObjectService"];
        return DrsNetworkUtilizationController;
    }());
    cluster_ui.DrsNetworkUtilizationController = DrsNetworkUtilizationController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DrsNetworkUtilizationController", DrsNetworkUtilizationController);
})(cluster_ui || (cluster_ui = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('FaultsDetailsViewController', FaultsDetailsViewController);

   FaultsDetailsViewController.$inject = ['$scope', 'i18nService',
         'drsFaultsViewService', 'drsFaultsService', 'helpService', 'clusterHelpConstants'];

   function FaultsDetailsViewController($scope, i18nService,
         drsFaultsViewService, drsFaultsService, helpService, clusterHelpConstants) {
      var self = this;

      self.detailsViewGridOptions = drsFaultsViewService.getDetailsViewGridOptions();
      self.drsTroubleshootHelpId = clusterHelpConstants.DRS_FAULT_TROUBLESHOOT_GUIDE_ID;

      self.faultDetailsTitle = i18nService.getString(
            'Common', 'drs.faultControl.details.drsState.headerLabel');

      $scope.$watch('masterDetailsViewContext.selectedItems', function(newValue) {
         if (newValue && newValue.length > 0) {
            setDetailsViewGridData(newValue);
         }
      });

      $scope.openHelpLink = function(contextId) {
         helpService.showHelpPage(contextId);
      };

      function setDetailsViewGridData(faultData) {
         var data = [];

         faultData[0].forEach(function(fault) {
            fault.details.forEach(function(detail) {
               var gridItem = drsFaultsService.getFaultDetailsData(fault.reason, detail);

               if (gridItem) {
                  data.push(gridItem);
               }
            });
         });

         self.detailsViewGridOptions.data = data;
      }
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('FaultsMasterViewController', FaultsMasterViewController);

   FaultsMasterViewController.$inject = ['$scope', 'dataService', 'i18nService',
         'drsFaultsService', 'drsFaultsViewService', 'navigation'];

   function FaultsMasterViewController($scope, dataService, i18nService,
         drsFaultsService, drsFaultsViewService, navigation) {
      var self = this;
      var objectId = navigation.getRoute().objectId;

      self.selectedItem = null;
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = ["drsFault", "summary.currentBalance"];
      self.getViewData = getViewData;
      self.masterViewGridOptions = drsFaultsViewService.getMasterViewGridOptions();

      self.faultMasterTitle = i18nService.getString(
            'Common', 'drs.faultControl.drsState.headerLabel');

      getViewData();

      $scope.$watch(function(){ return self.masterViewGridOptions.selectedItems;},
            function(newvalue) {
         if (newvalue && newvalue.length > 0) {
            $scope.masterDetailsViewContext.selectedItems = [newvalue];
            self.selectedItem = newvalue[0];
         }  else if ($scope.masterDetailsViewContext !== undefined){
            $scope.masterDetailsViewContext.selectedItems = [];
         }
      });

      function getViewData() {
         dataService.getProperties(objectId, ['computedDrsFaults'])
               .then(function (faultsData) {
                  setMasterViewGridData(faultsData);
               });
      }

      $scope.preselectComparator = function(dataGridItem) {
         var preselect = false;

         if (self.selectedItem) {
            preselect = dataGridItem.target.text === self.selectedItem.target.text
                  && dataGridItem.reason === self.selectedItem.reason;
         }

         return preselect;
      };

      function setMasterViewGridData(faultsData) {
         var data = [];

         faultsData.computedDrsFaults.forEach(function(fault) {
            data.push(drsFaultsService.getFaultMasterData(fault));
         });

         self.masterViewGridOptions.data = data;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('HistoryController', HistoryController);

   HistoryController.$inject = ['$scope', 'dataService', 'i18nService',
      'vuiConstants', 'columnRenderersRegistry', 'defaultUriSchemeUtil',
      'timeFormatterService', '$q'];

   function HistoryController($scope, dataService, i18nService, vuiConstants,
         columnRenderersRegistry, defaultUriSchemeUtil,
         timeFormatterService, $q) {
      var self = this;
      var objectId = $scope._route.objectId;

      self.watchForObjects = [objectId];
      self.liveRefreshProperties = ["actionHistory", "summary.currentBalance"];
      self.getViewData = getViewData;
      self.gridOptions = getGridOptions();

      self.historyTitle = i18nService.getString('ClusterUi', 'drs.history');

      getViewData();

      function getViewData() {
         dataService.getProperties(objectId, ['computedActionHistory'])
               .then(function (historyData) {
                  if (historyData.computedActionHistory.length > 0) {
                     var formatTimePromises = historyData.computedActionHistory.map(
                           function(item) {
                        return timeFormatterService.formatDate(item.time).then(
                              function(formattedTime) {
                           item.time = formattedTime;
                           return item;
                        });
                     });
                     $q.all(formatTimePromises).then(function(data) {
                        self.gridOptions.data = data;
                     });
                  }

               });
      }

      function getGridOptions() {
         var options  = {
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            searchable: false,
            resizable: true,
            data: [],
            columnDefs: getColumnDefs(),
            height: '100%'
         };

         return options;
      }

      function getColumnDefs() {
         return [
            {
               displayName: i18nService.getString('ClusterUi',
                     'actionHistoryList.timeColumnHeaderLabel'),
               field: 'time',
               type: 'string'
            },
            {
               displayName: i18nService.getString('ClusterUi',
                     'actionHistoryList.drsActionColumnHeaderLabel'),
               field: 'text',
               type: 'string',
               template: textRenderer
            }
         ];
      }

      function textRenderer(data) {
         var objData = data || {};
         var targetLinks = [];

         var renderer = columnRenderersRegistry.getColumnRenderer('object-name');

         //build links for each target object in the action text
         objData.targetObjects.forEach(function(object) {
            object.uid = defaultUriSchemeUtil.getVsphereObjectId(object.provider);

            var targetLink = renderer(['uid', null, 'name', 'labelIds'], object);
            targetLinks.push(targetLink);
         });

         var text = i18nService.interpolate(objData.text, targetLinks);

         if (!!objData.image) {
            text = '<span class="' + objData.image + '"></span>' + text;
         }

         return text;
      }
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var RecommendationsController = (function () {
        function RecommendationsController($scope, dataService, i18nService, vuiConstants, columnRenderersRegistry, defaultUriSchemeUtil, mutationService, drsConstants, clarityModalService, drsRecommendationsService, actionsService) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.drsConstants = drsConstants;
            this.clarityModalService = clarityModalService;
            this.drsRecommendationsService = drsRecommendationsService;
            this.actionsService = actionsService;
            this.actionSpecs = [
                "vsphere.core.cluster.actions.drs.refreshRecommendationsAction",
                "vsphere.core.cluster.actions.drs.applyRecommendationsAction"];
            this.overrideRecommendations = false;
            this.isRefreshButtonDisabled = true;
            this.isApplyButtonDisabled = true;
            this.objectId = $scope._route.objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties = ["recommendation",
                "summary.currentBalance"];
            this.recommendationsTitle = i18nService.getString("ClusterUi", "RecommendationsList.drsRecommendationsLabel");
            this.gridOptions = this.getGridOptions();
            this.getViewData();
            this.isRecommendationChecked = function (key) { return _this.recommendationStore
                .isRecommendationChecked(key); };
            // Request action evaluations from the backend
            this.actionsService.getActions(this.objectId, this.actionSpecs)
                .then(function (actionEvalutaions) {
                _.each(actionEvalutaions, function (actionEvaluation) {
                    if (actionEvaluation.action.uid === _this.actionSpecs[0]
                        && actionEvaluation.available) {
                        _this.isRefreshButtonDisabled = false;
                    }
                    if (actionEvaluation.action.uid === _this.actionSpecs[1]
                        && actionEvaluation.available) {
                        _this.isApplyButtonDisabled = false;
                    }
                });
            });
        }
        RecommendationsController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, "com.vmware.vsphere.client.clusterui.model.monitor.DrsRecommendationsData")
                .then(function (recommendationsData) {
                _this.gridOptions.data = recommendationsData.recommendations;
                var recommendations = _.map(recommendationsData.recommendations, function (recommendation) {
                    return recommendation.recommendationData;
                });
                var newRecommendationStore = _this.drsRecommendationsService
                    .createRecommendationsStore(recommendations);
                var newRecommendationsKeys = newRecommendationStore
                    .getRecommendationKeys();
                if (_this.recommendationStore) {
                    var oldRecommendationKeys = _this.recommendationStore
                        .getRecommendationKeys();
                    var haveRecommendationsChanged = !_this.arrayEq(newRecommendationsKeys.sort(), oldRecommendationKeys.sort());
                    if (haveRecommendationsChanged) {
                        _this.recommendationStore = newRecommendationStore;
                    }
                }
                else {
                    _this.recommendationStore = newRecommendationStore;
                }
            });
        };
        RecommendationsController.prototype.runDrs = function () {
            var refreshClusterRecommendationsSpec = {};
            this.mutationService.apply(this.objectId, "com.vmware.vsphere.client.clusterui.RefreshClusterRecommendationsSpec", refreshClusterRecommendationsSpec);
        };
        RecommendationsController.prototype.applyRecommendations = function () {
            if (!this.recommendationStore) {
                return;
            }
            var keysToApply = this.recommendationStore.getRecommendationsToApply();
            var clusterRecommendationSpec = {
                operation: this.drsConstants.clusterRecommendationSpecOperation.APPLY,
                keys: keysToApply
            };
            this.mutationService.apply(this.objectId, "com.vmware.vsphere.client.cluster.services.recommendations." +
                "ClusterRecommendationSpec", clusterRecommendationSpec);
        };
        RecommendationsController.prototype.onRecommendationCheckboxClick = function (recommendationKey) {
            var isChecked = this.recommendationStore.isRecommendationChecked(recommendationKey);
            if (isChecked) {
                if (this.recommendationStore.uncheckRecommendation(recommendationKey)) {
                    this.$scope.modalOptions = this.getUncheckedDependantRecommendationsModalOptions();
                    this.clarityModalService.openPopUp(this.$scope);
                }
            }
            else {
                if (this.recommendationStore.checkRecommendation(recommendationKey)) {
                    this.$scope.modalOptions = this.getCheckedPrerequisiteRecommendationsModalOptions();
                    this.clarityModalService.openPopUp(this.$scope);
                }
            }
        };
        RecommendationsController.prototype.arrayEq = function (array1, array2) {
            if (array1.length !== array2.length) {
                return false;
            }
            return array1.every(function (array1El, i) {
                return array1El === array2[i];
            });
        };
        RecommendationsController.prototype.getGridOptions = function () {
            return {
                sortMode: this.vuiConstants.grid.sortMode.NONE,
                searchable: false,
                resizable: true,
                data: [],
                columnDefs: this.getColumnDefs(),
                height: "100%"
            };
        };
        RecommendationsController.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("ClusterUi", "RecommendationsList.applyColumnHeaderText"),
                    field: "recommendationsText",
                    type: "string",
                    width: "100px",
                    template: this.checkboxColumnTemplate.bind(this)
                },
                {
                    displayName: this.i18nService.getString("ClusterUi", "RecommendationsList.priorityColumnHeaderText"),
                    field: "recommendationData.priorityRating",
                    type: "string",
                    width: "100px",
                    template: "#:recommendationData.priorityRating#"
                },
                {
                    displayName: this.i18nService.getString("ClusterUi", "RecommendationsList.recommendationColumnHeaderText"),
                    field: "recommendationText",
                    type: "string",
                    template: this.recommendationTextRenderer.bind(this)
                },
                {
                    displayName: this.i18nService.getString("ClusterUi", "RecommendationsList.reasonColumnHeaderText"),
                    field: "recommendationData.parentRecommendation.reasonText",
                    type: "string",
                    template: "<span title=\"#:recommendationData.parentRecommendation.reasonText#\">" +
                        "#:recommendationData.parentRecommendation.reasonText#</span>"
                }
            ];
        };
        RecommendationsController.prototype.recommendationTextRenderer = function (objData) {
            var _this = this;
            var targetLinks = [];
            var renderer = this.columnRenderersRegistry.getColumnRenderer("object-name");
            //build links for each target object in the recommendation action text
            objData.targets.forEach(function (object) {
                object.uid = _this.defaultUriSchemeUtil.getVsphereObjectId(object.provider);
                var targetLink = renderer(["uid", null, "name", "labelIds"], object);
                targetLinks.push(targetLink);
            });
            var recommendationText = this.i18nService.interpolate(objData.recommendationText, targetLinks);
            if (!!objData.image) {
                recommendationText =
                    "<span class=\"" + objData.image + "\"></span>" + recommendationText;
            }
            return recommendationText;
        };
        RecommendationsController.prototype.checkboxColumnTemplate = function (data) {
            if (!data.recommendationData.isFirst) {
                return "";
            }
            var key = data.recommendationData.parentRecommendation.key;
            var checkbox = [
                "<div class='centered-content-container'>",
                "<input type='checkbox' ",
                "ng-disabled='!$parent.$parent.ctrl.overrideRecommendations' ",
                "ng-checked='$parent.$parent.ctrl.isRecommendationChecked(", key, ")' ",
                "ng-click='$parent.$parent.ctrl.onRecommendationCheckboxClick(", key, ")' >",
                "</div>"
            ].join("");
            return checkbox;
        };
        RecommendationsController.prototype.getCheckedPrerequisiteRecommendationsModalOptions = function () {
            return {
                title: this.i18nService.getString("ClusterUi", "prerequisite.recommendations.selected.title"),
                contentUrl: "cluster-ui/resources/cluster/views/monitor/drs/" +
                    "checkedPrerequisiteRecommendationsModal.html"
            };
        };
        RecommendationsController.prototype.getUncheckedDependantRecommendationsModalOptions = function () {
            return {
                title: this.i18nService.getString("ClusterUi", "dependent.recommendations.unselected.title"),
                contentUrl: "cluster-ui/resources/cluster/views/monitor/drs/" +
                    "uncheckedDependantRecommendationsModal.html"
            };
        };
        RecommendationsController.$inject = ["$scope", "dataService", "i18nService",
            "vuiConstants", "columnRenderersRegistry",
            "defaultUriSchemeUtil", "mutationService",
            "drsConstants", "clarityModalService",
            "drsRecommendationsService", "actionsService"];
        return RecommendationsController;
    }());
    cluster_ui.RecommendationsController = RecommendationsController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("RecommendationsController", RecommendationsController);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('ConfigIssuesViewController', ConfigIssuesViewController);

   ConfigIssuesViewController.$inject = ['$scope', 'dataService', 'i18nService',
      'vuiConstants', 'columnRenderersRegistry', 'haConfigIssuesService', 'defaultUriSchemeUtil'];

   function ConfigIssuesViewController($scope, dataService, i18nService, vuiConstants,
         columnRenderersRegistry, haConfigIssuesService, defaultUriSchemeUtil) {

      var self = this;
      var objectId = $scope._route ? $scope._route.objectId : null;
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = ["configIssue", "configStatus", "name"];

      self.datagridOptions = getGridOptions();
      self.getViewData = getViewData;
      getViewData();

      function getViewData() {
         dataService.getProperties(objectId, ['haConfigIssues'])
               .then(function(data) {
                  if (data && data.haConfigIssues) {
                     _.each(data.haConfigIssues, function(issueConfig) {
                        issueConfig.hostRoleFormatted =
                              haConfigIssuesService.getHostRoleFormatted(
                                    issueConfig.hostRole);
                        issueConfig.messageIcon =
                              haConfigIssuesService.getIssueMessageIcon(issueConfig);
                     });
                     self.datagridOptions.data = data.haConfigIssues;
                  }
               });
      }

      function getGridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.MULTI,
            showCheckboxesOnMultiSelection: false,
            searchable: false,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getColumnDefs(),
            height: '100%'
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: i18nService.getString('ClusterUi',
                     'ha.config.issues.grid.entity.header'),
               field: 'entityName',
               type: 'string',
               width: '35%',
               template: entityIconTextRenderer
            },
            {
               displayName: i18nService.getString('ClusterUi',
                     'ha.config.issues.grid.role.header'),
               field: 'hostRoleFormatted',
               type: 'string',
               width: '10%',
               template: '#:hostRoleFormatted#'
            },
            {
               displayName: i18nService.getString('ClusterUi',
                     'ha.config.issues.grid.issue.description.header'),
               field: 'issue.fullFormattedMessage',
               type: 'string',
               width: '55%',
               template: issueMessageIconTextTitleRenderer
            }
         ];
      }

      function entityIconTextRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('object-link');
         if (data){
            _.extend(
                  data,
                  {
                     entityId: defaultUriSchemeUtil.getVsphereObjectId(
                        {
                           _type: 'com.vmware.vim.binding.vmodl.ManagedObjectReference',
                           value: data.entity.value,
                           type: data.entity.type,
                           serverGuid: data.entity.serverGuid
                        }
                  )
               }
            );
         }
         var itemHtml = renderer(['entityId', 'entityName', data['entityIcon']], data || {});

         return itemHtml;
      }

      function issueMessageIconTextTitleRenderer(data) {
         var icon = data && data.messageIcon ? data.messageIcon : '';
         var text = data && data.issue.fullFormattedMessage ?
               data.issue.fullFormattedMessage : '';

         var iconHtmlElement = '<i class=\"' + icon + '\"></i>';
         return '<span title=\"' + text + '\">' + iconHtmlElement + text + '</span>';
      }

   }
})();

var cluster_ui;
(function (cluster_ui) {
    var DatastoresUnderApdPdlController = (function () {
        function DatastoresUnderApdPdlController($scope, dataService, datastoresUnderApdPdlService, navigation) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.datastoresUnderApdPdlService = datastoresUnderApdPdlService;
            this.navigation = navigation;
            this.INACCESSIBLE_DATASTORE_INFO_PROPERTY = "inaccessibleDatastoreInfo";
            this.objectId = this.navigation.getRoute().objectId;
            this.gridOptions =
                this.datastoresUnderApdPdlService.getGridOptions();
            this.getData();
        }
        DatastoresUnderApdPdlController.prototype.getData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, [this.INACCESSIBLE_DATASTORE_INFO_PROPERTY])
                .then(function (data) {
                var inaccessibleDatastoreInfo = data && data.inaccessibleDatastoreInfo ?
                    data.inaccessibleDatastoreInfo : [];
                _this.gridOptions.data = inaccessibleDatastoreInfo;
            });
        };
        DatastoresUnderApdPdlController.$inject = [
            "$scope",
            "dataService",
            "datastoresUnderApdPdlService",
            "navigation"];
        return DatastoresUnderApdPdlController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DatastoresUnderApdPdlController", DatastoresUnderApdPdlController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var HaAdvancedRuntimeInfoController = (function () {
        function HaAdvancedRuntimeInfoController($scope, dataService, haSummaryService, $q) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.haSummaryService = haSummaryService;
            this.$q = $q;
            this.portletData = [];
            this.loadingData = false;
            this.objectId = this.$scope._route.objectId;
            this.portletData = [];
            this.$scope.$on("haSummaryPortletsRefresh", function () {
                _this.getData();
            });
            this.getData();
        }
        HaAdvancedRuntimeInfoController.prototype.getData = function () {
            var _this = this;
            if (this.loadingData) {
                return;
            }
            this.loadingData = true;
            return this.dataService.getProperties(this.objectId, ["dasAdvancedRuntimeInfo"])
                .then(function (data) {
                if (data && data.dasAdvancedRuntimeInfo) {
                    _this.portletData =
                        _this.haSummaryService.getFailoverLevelAdvancedRuntimeData(data.dasAdvancedRuntimeInfo);
                }
                _this.loadingData = false;
            })
                .catch(function (error) {
                _this.loadingData = false;
                _this.$q.reject(error);
            });
        };
        HaAdvancedRuntimeInfoController.$inject = ["$scope", "dataService", "haSummaryService", "$q"];
        return HaAdvancedRuntimeInfoController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("HaAdvancedRuntimeInfoController", HaAdvancedRuntimeInfoController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var HaResourcesAdvancedRuntimeInfoController = (function () {
        function HaResourcesAdvancedRuntimeInfoController($scope, dataService, haSummaryService, $q) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.haSummaryService = haSummaryService;
            this.$q = $q;
            this.loadingData = false;
            this.objectId = this.$scope._route.objectId;
            this.propertyViewData = [];
            this.$scope.$on("haSummaryPortletsRefresh", function () {
                _this.getData();
            });
            this.getData();
        }
        HaResourcesAdvancedRuntimeInfoController.prototype.getData = function () {
            var _this = this;
            if (this.loadingData) {
                return;
            }
            this.loadingData = true;
            return this.dataService.getData(this.objectId, "com.vmware.vsphere.client.clusterui.model.services.HaFailoverResourceRuntimeInfoData")
                .then(function (failoverResourceData) {
                _this.propertyViewData =
                    _this.haSummaryService.getFailoverResourcesAdvancedRuntimeData(failoverResourceData);
                _this.loadingData = false;
            })
                .catch(function (error) {
                _this.loadingData = false;
                _this.$q.reject(error);
            });
        };
        HaResourcesAdvancedRuntimeInfoController.$inject = ["$scope", "dataService", "haSummaryService", "$q"];
        return HaResourcesAdvancedRuntimeInfoController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("HaResourcesAdvancedRuntimeInfoController", HaResourcesAdvancedRuntimeInfoController);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('haSummaryViewController', HaSummaryViewController);

   HaSummaryViewController.$inject = ['$scope', 'vuiConstants', 'extensionService',
         'summaryService'];

   function HaSummaryViewController($scope, vuiConstants, extensionService, summaryService) {

      // This is used in case of plugin's portlets which need the objectId in the iFrame url
      var objectId = $scope._route ? $scope._route.objectId : null;
      this.watchForObjects = [objectId];
      this.liveRefreshProperties = ["configStatus"];

      $scope.refreshPortlets = refreshPortlets;
      $scope.refreshPortletsData = refreshPortletsData;
      $scope.portletOptions = {
         layout: vuiConstants.portlets.layout.TWO_COLUMNS,
         portlets: getSummaryPortletViews()
      };

      function refreshPortlets() {
         //Request portlet data from the server and update if necessary
         requestViewExtensions().then(function(extensions) {
            updateExistingPortlets(extensions);
         });
      }

      function updateExistingPortlets(portletSpecs) {
         var portletViews = summaryService.createPortlets(portletSpecs, objectId);
         $scope.portletOptions.portlets = summaryService.updatePortlets(portletViews,
               $scope.portletOptions.portlets);
      }

      function requestViewExtensions() {
         return extensionService.getHostedExtensions($scope._view.$id, objectId);
      }

      function refreshPortletsData() {
         $scope.$broadcast('haSummaryPortletsRefresh');
      }

      function getSummaryPortletViews() {
         return summaryService.createPortlets($scope._view.children, objectId);
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('HeartbeatViewController', HeartbeatViewController);

   HeartbeatViewController.$inject = ['$scope', 'dataService', 'i18nService'];

   function HeartbeatViewController($scope, dataService, i18nService) {

      var HA_PROPERTIES =
            'com.vmware.vsphere.client.clusterui.model.services.ClusterHaData';

      var self = this;
      var objectId = $scope._route ? $scope._route.objectId : null;
      self.liveRefreshProperties = [
         "configurationEx.dasConfig.heartbeatDatastore",
         "summary.dasData"
      ];
      self.watchForObjects = [objectId];
      self.hbDatastoreCandidates = [];
      self.datastoresGridLabel= i18nService.getString('ClusterUi',
            'ha.runtime.selected.heartbeat.datastores');

      self.getViewData = getViewData;
      getViewData();

      function getViewData() {
         dataService.getData(objectId, HA_PROPERTIES).then(function(data) {
            self.hbDatastoreCandidates = data.heartbeatDatastores;
         });
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('HostRuntimeInfoController', HostRuntimeInfoController);

   HostRuntimeInfoController.$inject = ['$scope', 'dataService', 'haSummaryService', '$q'];

   function HostRuntimeInfoController($scope, dataService, haSummaryService, $q) {
      var objectId = $scope._route ? $scope._route.objectId : null;

      $scope.loadingData = false;
      $scope.$on('haSummaryPortletsRefresh', getPortletData);

      function getPortletData() {
         if ($scope.loadingData) {
            return;
         }

         $scope.loadingData = true;

         return dataService.getProperties(objectId, ['hostHaRuntimeInfo'])
               .then(function(data) {
                  if (data && data.hostHaRuntimeInfo) {
                     $scope.portletData = haSummaryService.getHostsRuntimeData(
                           data.hostHaRuntimeInfo);
                  }
                  $scope.loadingData = false;
               })
               .catch(function(reason) {
                  $scope.loadingData = false;
                  $q.reject(reason);
               });
      }

      getPortletData();
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('VmsRuntimeInfoController', VmsRuntimeInfoController);

   VmsRuntimeInfoController.$inject = ['$scope', 'dataService', 'haSummaryService', '$q'];

   function VmsRuntimeInfoController($scope, dataService, haSummaryService, $q) {
      var objectId = $scope._route ? $scope._route.objectId : null;

      $scope.loadingData = false;
      $scope.$on('haSummaryPortletsRefresh', getPortletData);

      function getPortletData() {
         if ($scope.loadingData) {
            return;
         }

         $scope.loadingData = true;

         return dataService.getProperties(objectId, ['vmHaRuntimeInfo'])
               .then(function (data) {
                  if (data && data.vmHaRuntimeInfo) {
                     $scope.portletData = haSummaryService.getVmsRuntimeData(
                           data.vmHaRuntimeInfo);
                  }
                  $scope.loadingData = false;
               }).catch(function(reason) {
                  $scope.loadingData = false;
                  $q.reject(reason);
               });
      }

      getPortletData();
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var MonitorStorageResourceReservationViewController = (function () {
        function MonitorStorageResourceReservationViewController($scope, dataService, i18nService, vxPropertyViewService, columnRenderersRegistry, vuiConstants, defaultUriSchemeUtil, $q, capacityFormatterService) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.vuiConstants = vuiConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
            this.capacityFormatterService = capacityFormatterService;
            this.objectId = $scope._route ? $scope._route.objectId : null;
            var liveRefreshProperties = this.$scope._view.contentSpec.metadata.liveRefreshProperties;
            if (liveRefreshProperties) {
                this.liveRefreshProperties = liveRefreshProperties
                    .split(',')
                    .map(function (prop) { return prop.trim(); });
            }
            $scope.loadingData = false;
            $scope.meters = [];
            $scope.maxCapacityValue = "";
            $scope.reservationData = {};
            this.gridOptions = this.getGridOptions();
            this.getData();
        }
        MonitorStorageResourceReservationViewController.prototype.getData = function () {
            var _this = this;
            if (this.$scope.loadingData) {
                return;
            }
            this.$scope.loadingData = true;
            this.dataService.getData(this.objectId, this.$scope._view.contentSpec.metadata.modelClass)
                .then(function (data) {
                _this.$scope.meters = _this.getMeters(data);
                _this.$scope.maxCapacityValue = data.totalCapacityFormatted;
                _this.$scope.reservationData = _this.getReservationData(data);
                _this.gridOptions.data = data.virtualDisks;
                _this.$scope.loadingData = false;
            })
                .catch(function (error) {
                _this.$scope.loadingData = false;
                _this.$q.reject(error);
            });
        };
        MonitorStorageResourceReservationViewController.prototype.getReservationData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "storage.totalCapacity"))
                .exit()
                .valueBuilder()
                .text(data.totalCapacityFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity.Reserved"))
                .icon("vx-property-view-key-legend-icon monitor-resource-reservation-grid-icon-color-light-blue")
                .exit()
                .valueBuilder()
                .text(data.usedSpaceFormatted);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("ClusterUi", "capacity.availableCapacity"))
                .icon("vx-property-view-key-legend-icon monitor-resource-reservation-grid-icon-color-white")
                .exit()
                .valueBuilder()
                .text(data.freeSpaceFormatted);
            return builder.build();
        };
        MonitorStorageResourceReservationViewController.prototype.getMeters = function (data) {
            return [{
                    colorClass: "monitor-resource-reservation-icon-color-light-blue",
                    value: data.storagePercentage,
                    label: this.capacityFormatterService.format(data.usedSpaceFormatted, data.totalCapacityFormatted, data.storagePercentage)
                }];
        };
        MonitorStorageResourceReservationViewController.prototype.getGridOptions = function () {
            return {
                searchable: true,
                resizable: false,
                sortOrder: [{
                        field: "name",
                        dir: "asc"
                    }],
                data: [],
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                columnDefs: this.getColumnDefs(),
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        MonitorStorageResourceReservationViewController.prototype.getColumnDefs = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("ClusterUi", "nameColumnHeader"),
                    field: "vmName",
                    type: "string",
                    template: function (data) {
                        var objData = data || {};
                        var renderer = _this.columnRenderersRegistry.getColumnRenderer("object-name");
                        objData.uid = _this.defaultUriSchemeUtil.getVsphereObjectId(objData.vm);
                        return renderer(["uid", "vmPrimaryIcon", "vmName"], objData);
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.diskColumn"),
                    field: "label",
                    type: "string",
                    template: "<span title=\"#:label#\">#:label#</span>"
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.datastoreColumn"),
                    field: "datastoreName",
                    type: "string",
                    template: "<span title=\"#:datastoreName#\">#:datastoreName#</span>"
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.limitColumn"),
                    field: "limit",
                    type: "number",
                    template: function (data) {
                        var objData = data || {};
                        return objData.limit !== -1 ? objData.limit :
                            _this.i18nService.getString("ClusterUi", "limit.unlimited");
                    }
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.shareLevelColumn"),
                    field: "shareLevel",
                    type: "string",
                    template: "<span title=\"#:shareLevel#\">#:shareLevel#</span>"
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.sharesValueColumn"),
                    field: "shares",
                    type: "string",
                    template: "<span title=\"#:shares#\">#:shares#</span>"
                }, {
                    displayName: this.i18nService.getString("ClusterUi", "storage.dsPercentSharesValueColumn"),
                    field: "datastoreSharesPercentage",
                    type: "string",
                    template: "<span title=\"#:datastoreSharesPercentage#\">#:datastoreSharesPercentage#</span>",
                    sortable: function (item1, item2) {
                        return parseInt(item1.datastoreSharesPercentage) - parseInt(item2.datastoreSharesPercentage);
                    }
                }];
        };
        MonitorStorageResourceReservationViewController.$inject = ["$scope", "dataService", "i18nService",
            "vxPropertyViewService", "columnRenderersRegistry", "vuiConstants",
            "defaultUriSchemeUtil", "$q", "capacityFormatterService"];
        return MonitorStorageResourceReservationViewController;
    }());
    cluster_ui.MonitorStorageResourceReservationViewController = MonitorStorageResourceReservationViewController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("MonitorStorageResourceReservationViewController", MonitorStorageResourceReservationViewController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterCpuUtilizationPortletController = (function () {
        function ClusterCpuUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getCpuMetersData(data);
                    _this.maxCapacityValue = data.cpuCapacityFormatted;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildCpuPropertyViewData(data);
                }
            });
        }
        ClusterCpuUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterCpuUtilizationPortletController;
    }());
    cluster_ui.ClusterCpuUtilizationPortletController = ClusterCpuUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterCpuUtilizationPortletController", ClusterCpuUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterGuestMemoryUtilizationPortletController = (function () {
        function ClusterGuestMemoryUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.groupedMeters = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getGuestMemoryMetersData(data);
                    _this.maxCapacityValue = data.guestMemorySizeFormatted;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildGuestMemoryPropertyViewData(data);
                    _this.groupedMeters =
                        _this.clusterUtilizationService.getGuestMemoryGroupedMetersData(data);
                }
            });
        }
        ClusterGuestMemoryUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterGuestMemoryUtilizationPortletController;
    }());
    cluster_ui.ClusterGuestMemoryUtilizationPortletController = ClusterGuestMemoryUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterGuestMemoryUtilizationPortletController", ClusterGuestMemoryUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterMemoryUtilizationPortletController = (function () {
        function ClusterMemoryUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getMemoryMetersData(data);
                    _this.maxCapacityValue = data.memoryCapacityFormatted;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildMemoryPropertyViewData(data);
                }
            });
        }
        ClusterMemoryUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterMemoryUtilizationPortletController;
    }());
    cluster_ui.ClusterMemoryUtilizationPortletController = ClusterMemoryUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterMemoryUtilizationPortletController", ClusterMemoryUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterResourcePoolCpuUtilizationPortletController = (function () {
        function ClusterResourcePoolCpuUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.pointers = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getCpuMetersData(data);
                    _this.maxCapacityValue = data.maxValue;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildResourcePoolCpuPropertyViewData(data);
                    _this.pointers = _this.clusterUtilizationService.getUtilizationPointersData(data);
                }
            });
        }
        ClusterResourcePoolCpuUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterResourcePoolCpuUtilizationPortletController;
    }());
    cluster_ui.ClusterResourcePoolCpuUtilizationPortletController = ClusterResourcePoolCpuUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterResourcePoolCpuUtilizationPortletController", ClusterResourcePoolCpuUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterResourcePoolMemoryUtilizationPortletController = (function () {
        function ClusterResourcePoolMemoryUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.pointers = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getMemoryConsumedMetersData(data);
                    _this.maxCapacityValue = data.maxValue;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildResourcePoolMemoryPropertyViewData(data);
                    _this.pointers = _this.clusterUtilizationService.getUtilizationPointersData(data);
                }
            });
        }
        ClusterResourcePoolMemoryUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterResourcePoolMemoryUtilizationPortletController;
    }());
    cluster_ui.ClusterResourcePoolMemoryUtilizationPortletController = ClusterResourcePoolMemoryUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterResourcePoolMemoryUtilizationPortletController", ClusterResourcePoolMemoryUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterUtilizationViewController = (function () {
        function ClusterUtilizationViewController($scope, vuiConstants, extensionService, summaryService) {
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.extensionService = extensionService;
            this.summaryService = summaryService;
            this.objectId = $scope._route ? $scope._route.objectId : null;
            this.headerOptions = {
                title: "",
                objectId: this.objectId,
                actions: []
            };
            this.watchForObjects = [this.objectId];
            $scope.portletOptions = {
                layout: vuiConstants.portlets.layout.TWO_COLUMNS,
                portlets: this.getSummaryPortletViews()
            };
        }
        /**
         * Update the portlet views optimistically.
         */
        ClusterUtilizationViewController.prototype.refreshPortlets = function () {
            var _this = this;
            //update the UI with already available data
            this.updateExistingPortlets(this.$scope._view.children);
            //Request portlet data from the server and update if necessary
            this.requestViewExtensions().then(function (extensions) {
                _this.updateExistingPortlets(extensions);
            });
        };
        ;
        ClusterUtilizationViewController.prototype.updateExistingPortlets = function (portletSpecs) {
            var portletViews = this.summaryService.createPortlets(portletSpecs, this.objectId);
            this.$scope.portletOptions.portlets = this.summaryService.updatePortlets(portletViews, this.$scope.portletOptions.portlets);
        };
        ClusterUtilizationViewController.prototype.requestViewExtensions = function () {
            return this.extensionService.getHostedExtensions(this.$scope._view.$id, this.objectId);
        };
        ClusterUtilizationViewController.prototype.getSummaryPortletViews = function () {
            return this.summaryService.createPortlets(this.$scope._view.children, this.objectId);
        };
        ClusterUtilizationViewController.$inject = ["$scope", "vuiConstants", "extensionService",
            "summaryService"];
        return ClusterUtilizationViewController;
    }());
    cluster_ui.ClusterUtilizationViewController = ClusterUtilizationViewController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterUtilizationViewController", ClusterUtilizationViewController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ClusterVmMemoryUtilizationPortletController = (function () {
        function ClusterVmMemoryUtilizationPortletController($scope, dataService, clusterUtilizationService, $controller) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.clusterUtilizationService = clusterUtilizationService;
            this.$controller = $controller;
            this.meters = [];
            this.pointers = [];
            this.maxCapacityValue = "";
            this.resourcesData = {};
            angular.extend(this, $controller("GenericPortletController", { $scope: $scope }));
            $scope.$watch("data", function (data) {
                if (data) {
                    _this.meters = _this.clusterUtilizationService.getMemoryConsumedMetersData(data);
                    _this.maxCapacityValue = data.maxValue;
                    _this.resourcesData =
                        _this.clusterUtilizationService.buildVmMemoryPropertyViewData(data);
                    _this.pointers = _this.clusterUtilizationService.getUtilizationPointersData(data);
                }
            });
        }
        ClusterVmMemoryUtilizationPortletController.$inject = ["$scope", "dataService", "clusterUtilizationService",
            "$controller"];
        return ClusterVmMemoryUtilizationPortletController;
    }());
    cluster_ui.ClusterVmMemoryUtilizationPortletController = ClusterVmMemoryUtilizationPortletController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ClusterVmMemoryUtilizationPortletController", ClusterVmMemoryUtilizationPortletController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var MoveClusterToDialogController = (function () {
        function MoveClusterToDialogController($scope, vuiConstants, i18nService, moveClusterToService, dataService, defaultUriSchemeUtil) {
            var _this = this;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.moveClusterToService = moveClusterToService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.loading = false;
            this.clusterIds = $scope.modalOptions.dialogData.objectIds;
            this.dc = $scope.modalOptions.dialogData.dc;
            this.onLocationSelected = function (objectReference) {
                _this.entityToMoveClusterTo = objectReference;
            };
            $scope.modalOptions.onSubmit = function () {
                $scope.modalOptions.alerts = [];
                $scope.modalOptions.isAlertClosed = true;
                _this.moveClusterToService
                    .validateMoveClusterToTarget(_this.entityToMoveClusterTo, _this.clusterIds)
                    .then(function (result) {
                    if (!!result.result) {
                        _this.moveClusterToService.checkPrivileges(_this.clusterIds, _this.entityToMoveClusterTo).then(function (noPrivilegesIds) {
                            if (!noPrivilegesIds || noPrivilegesIds.length === 0) {
                                // if objects have privileges
                                _this.moveClusterToService.moveCluster(_this.entityToMoveClusterTo, _this.clusterIds);
                            }
                            else {
                                // no privileges error
                                _this.$scope.modalOptions.alerts = [{
                                        type: _this.vuiConstants.validationBanner.type.ERROR,
                                        text: _this.moveClusterToService
                                            .getPrivilegesErrorMessage(noPrivilegesIds, _this.entityToMoveClusterTo)
                                    }];
                                _this.$scope.modalOptions.isAlertClosed = false;
                            }
                        });
                        _this.$scope.closeModal();
                    }
                    else {
                        _this.$scope.modalOptions.alerts = [{
                                type: _this.vuiConstants.validationBanner.type.ERROR,
                                text: _this.i18nService.getString("ClusterUi", "moveTo.targetNestedValidationError")
                            }];
                        _this.$scope.modalOptions.isAlertClosed = false;
                    }
                });
            };
        }
        MoveClusterToDialogController.$inject = ["$scope",
            "vuiConstants",
            "i18nService",
            "moveClusterToService", "dataService", "defaultUriSchemeUtil"];
        return MoveClusterToDialogController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("moveClusterToDialogController", MoveClusterToDialogController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var MoveResourcePoolToDialogController = (function () {
        function MoveResourcePoolToDialogController($scope, defaultUriSchemeUtil, dataService, vuiConstants, i18nService, moveResourcePoolToService, managedEntityConstants) {
            var _this = this;
            this.$scope = $scope;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.moveResourcePoolToService = moveResourcePoolToService;
            this.managedEntityConstants = managedEntityConstants;
            this.loading = true;
            this.rpIds = $scope.modalOptions.dialogData.objectIds;
            if (!_.isEmpty(this.rpIds)) {
                this.rootObjId = this.rpIds[0];
            }
            $scope.modalOptions.onSubmit = function () {
                $scope.modalOptions.alerts = [];
                $scope.modalOptions.isAlertClosed = true;
                // if destination is contained in sources, error
                if (_.contains(_this.rpIds, _this.entityToMoveRpTo)) {
                    _this.$scope.modalOptions.alerts = [{
                            type: _this.vuiConstants.validationBanner.type.ERROR,
                            text: _this.i18nService
                                .getString('Common', 'moveTo.targetValidationError')
                        }];
                    _this.$scope.modalOptions.isAlertClosed = false;
                }
                else {
                    // validate destination in hierarchy
                    _this.moveResourcePoolToService
                        .validateMoveResourcePoolToTarget(_this.entityToMoveRpTo, _this.rpIds)
                        .then(function (result) {
                        if (!!result.result) {
                            // check proveleges
                            _this.moveResourcePoolToService.checkPrivileges(_this.sourcesIds, _this.entityToMoveRpTo).then(function (noPrivilegesIds) {
                                if (!noPrivilegesIds || noPrivilegesIds.length === 0) {
                                    // if objects have privileges
                                    _this.moveResourcePoolToService.moveResourcePool(_this.entityToMoveRpTo, _this.rpIds, _this.$scope);
                                }
                                else {
                                    // no privileges error
                                    _this.$scope.modalOptions.alerts = [{
                                            type: _this.vuiConstants.validationBanner.type.ERROR,
                                            text: _this.moveResourcePoolToService
                                                .getPrivilegesErrorMessage(noPrivilegesIds, _this.entityToMoveRpTo)
                                        }];
                                    _this.$scope.modalOptions.isAlertClosed = false;
                                }
                            });
                        }
                        else {
                            // if destination is a child of sources, error
                            _this.$scope.modalOptions.alerts = [{
                                    type: _this.vuiConstants.validationBanner.type.ERROR,
                                    text: _this.i18nService
                                        .getString('Common', 'moveTo.targetNestedValidationError')
                                }];
                            _this.$scope.modalOptions.isAlertClosed = false;
                        }
                    });
                }
            };
            this.onLocationSelected = function (objectReference) {
                _this.entityToMoveRpTo = objectReference;
            };
            this.getData();
        }
        MoveResourcePoolToDialogController.prototype.getData = function () {
            var _this = this;
            this.dataService.getPropertiesForObjects(this.rpIds, ['parent', 'cluster'])
                .then(function (data) {
                if (data) {
                    _this.isMoveActionUnderCluster = !!data[_this.rpIds[0]].cluster;
                    _this.sourcesIds = _.map(_this.rpIds, function (rpId) {
                        return _this.defaultUriSchemeUtil.getVsphereObjectId(data[rpId].parent);
                    });
                    (_a = _this.sourcesIds).push.apply(_a, _this.rpIds);
                }
                _this.loading = false;
                var _a;
            });
        };
        MoveResourcePoolToDialogController.$inject = ["$scope",
            "defaultUriSchemeUtil",
            "dataService",
            "vuiConstants",
            "i18nService",
            "moveResourcePoolToService",
            "managedEntityConstants"];
        return MoveResourcePoolToDialogController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("moveResourcePoolToDialogController", MoveResourcePoolToDialogController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var RestoreResourcePoolTreeController = (function () {
        function RestoreResourcePoolTreeController($scope, $element, mutationService, restoreResourcePoolTreeService, clarityConstants, i18nService, resourceTypesConstants) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.mutationService = mutationService;
            this.restoreResourcePoolTreeService = restoreResourcePoolTreeService;
            this.clarityConstants = clarityConstants;
            this.i18nService = i18nService;
            this.resourceTypesConstants = resourceTypesConstants;
            this.objectId = this.$scope.modalOptions.objectId;
            this.fileInput = $element.find("input[type='file']");
            this.fileInput.on("change", this.onFileInputChange.bind(this));
            this.$scope.modalOptions.alerts = [];
            this.$scope.modalOptions.isAlertClosed = true;
            this.$scope.modalOptions.onSubmit = function () { return _this.onSubmit(); };
        }
        RestoreResourcePoolTreeController.prototype.onFileInputChange = function (event) {
            if (event.target.files && event.target.files.length) {
                this.setFileToUpload(event.target.files[0]);
            }
        };
        RestoreResourcePoolTreeController.prototype.setFileToUpload = function (file) {
            this.file = file;
        };
        RestoreResourcePoolTreeController.prototype.onSubmit = function () {
            var _this = this;
            this.$scope.modalOptions.alerts = [];
            this.$scope.modalOptions.isAlertClosed = true;
            this.restoreResourcePoolTreeService.readFileContent(this.file)
                .then(function (fileContent) {
                var byteArray = new Int8Array(fileContent);
                var normalArray = Array.prototype.slice.call(byteArray);
                _this.restoreResourcePoolTreeService
                    .validateSnapshotFile(_this.objectId, normalArray)
                    .then(function (response) {
                    if (response.result.validationResultType !==
                        _this.resourceTypesConstants.resultValidationType.SUCCESS) {
                        var alert_1 = _this.restoreResourcePoolTreeService
                            .getValidationResultType(response.result.validationResultType);
                        _this.$scope.modalOptions.alerts = [{
                                text: alert_1,
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        _this.$scope.modalOptions.isAlertClosed = false;
                    }
                    else {
                        _this.restoreResourcePoolTreeService
                            .applyMutationOperation(_this.objectId, normalArray);
                        _this.$scope.closeModal();
                    }
                });
            });
        };
        RestoreResourcePoolTreeController.$inject = ["$scope", "$element", "mutationService",
            "restoreResourcePoolTreeService", "clarityConstants", "i18nService",
            "resourceTypesConstants"];
        return RestoreResourcePoolTreeController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("RestoreResourcePoolTreeController", RestoreResourcePoolTreeController);
})(cluster_ui || (cluster_ui = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('EditEvcDialogController', EditEvcDialogController);

   EditEvcDialogController.$inject = ['$scope',
      'dataService',
      'i18nService',
      'mutationService',
      'vuiConstants',
      'logService',
      'evcConstants',
      'iconService'];

   function EditEvcDialogController($scope,
         dataService,
         i18nService,
         mutationService,
         vuiConstants,
         logService,
         evcConstants,
         iconService) {
      var self = this;
      var log = logService('EditEvcDialogController');
      var objectId = $scope.modalOptions.dialogData.objectId;
      // Fake EVC mode
      var DISABLED_EVC_MODE = { key: null, label: getString('evc.config.disableText') };

      var COMPATIBILITY_ITEM_CURRENT_CONFIGURATION = {
         icon: 'vsphere-icon-status-ok',
         message: getString('evc.config.validation.currentConfiguration'),
         contents: []
      };
      var COMPATIBILITY_ITEM_VALIDATION_SUCCEEDED = {
         icon: 'vsphere-icon-status-ok',
         message: getString('evc.config.validation.validationSucceeded'),
         contents: []
      };
      var COMPATIBILITY_ITEM_DISABLING_EVC = {
         icon: 'vsphere-icon-status-warning',
         message: getString('evc.config.validation.warning.disable'),
         contents: []
      };
      var COMPATIBILITY_ITEM_DISABLING_EVC_NO_FT_DRS_CHECK = {
         icon: 'vsphere-icon-status-warning',
         message: getString('evc.config.validation.warning.disable.noFtDrsCheck'),
         contents: []
      };
      var COMPATIBILITY_ITEM_RAISING_EVC_BASELINE = {
         icon: 'vsphere-icon-status-warning',
         message: getString('evc.config.validation.warning.raiseBaseline'),
         contents: []
      };

      /**
       * Map EvcModeKey -> ValidationResult
       * A cache of validation results for each checked EvcMode.
       */
      var validationResultByEvcModeKey = {};

      /**
       * Keeps the names of the hosts in the cluster, mapped by their id.
       * Used to display the names of the problematic hosts, when there are
       * compatibility errors.
       */
      var hostsNamesById = {};

      var currentEvcMode;
      var currentVendor;

      self.vendorHeaderOptions = getHeaderOptions('evc.config.evcModeBlock');
      self.descriptionHeaderOptions = getHeaderOptions('evc.config.descriptionBlock');
      self.compatibilityHeaderOptions = getHeaderOptions('evc.config.compatibilityBlock');
      $scope.modalOptions.isAlertClosed = true;

      activate();
      getViewData();

      function activate() {
         setPageBusy(true);
         $scope.modalOptions.onSubmit = onSubmit;
         $scope.evcConstants = evcConstants;
         $scope.$watch('ctrl.vendor', onVendorChanged);
         $scope.$watch('ctrl.evcMode', onEvcModeChanged);
      }

      function getViewData() {
         dataService
            .getData(objectId,
               'com.vmware.vsphere.client.clusterui.model.configuration.EditEvcConfigData')
            .then(function (data) {
               if (!data || !data.supportedIntelEvcMode || !data.supportedAmdEvcMode) {
                  showDataRetrieveError();
                  return;
               }
               self.supportedIntelEvcMode = data.supportedIntelEvcMode;
               self.supportedAmdEvcMode = data.supportedAmdEvcMode;
               self.ftDrsWithoutEvcSupported = data.ftDrsWithoutEvcSupported;
               hostsNamesById = getHostNamesById(data.hosts);
               if (!data.currentEvcMode) {
                  self.vendor = evcConstants.cpuVendor.UNKNOWN;
                  self.evcMode = DISABLED_EVC_MODE;
               } else {
                  self.vendor = data.currentEvcMode.vendor;
                  self.evcMode = data.currentEvcMode;
               }
               currentVendor = self.vendor;
               currentEvcMode = self.evcMode;
               setPageBusy(false);
            });
      }

      function onVendorChanged(newVendor) {
         self.evcModes = getEvcModes(newVendor);

         if (newVendor) {
            if (newVendor === currentVendor) {
               // Preselect the current EvcMode
               self.evcMode = _.find(self.evcModes, function(evcMode) {
                  return evcMode.key === currentEvcMode.key;
               });
            } else if (self.evcModes) {
               self.evcMode = self.evcModes[0];
            } else {
               self.evcMode = {};
            }
         }
      }

      function onEvcModeChanged(newEvcMode) {
         if (!newEvcMode || !currentEvcMode) {
            return;
         }
         self.compatibilityItems = [];
         $scope.modalOptions.isAlertClosed = true;
         $scope.modalOptions.alerts = [];
         if (newEvcMode.key === currentEvcMode.key) {
            // we are keeping the current configuration
            self.compatibilityItems = [COMPATIBILITY_ITEM_CURRENT_CONFIGURATION];
            return;
         }
         if (newEvcMode.key === null) {
            // we are disabling EVC
            if (self.ftDrsWithoutEvcSupported) {
               self.compatibilityItems = [COMPATIBILITY_ITEM_DISABLING_EVC_NO_FT_DRS_CHECK];
            } else {
               self.compatibilityItems = [COMPATIBILITY_ITEM_DISABLING_EVC];
            }
            return;
         }
         if (validationResultByEvcModeKey[newEvcMode.key]) {
            handleEvcSpecValidationResult(
                  validationResultByEvcModeKey[newEvcMode.key]);
            return;
         }
         setPageBusy(true);
         validateEvcMode(newEvcMode.key).then(function(validationResult) {
            validationResultByEvcModeKey[newEvcMode.key] = validationResult;
            handleEvcSpecValidationResult(validationResult);
            setPageBusy(false);
         });
      }

      function handleEvcSpecValidationResult (validationResult) {
         if (!validationResult) {
            return;
         }
         if (validationResult.error) {
            $scope.modalOptions.alerts = [{
               type: vuiConstants.validationBanner.type.ERROR,
               text: validationResult.error.localizedMessage
            }];
            $scope.modalOptions.isAlertClosed = false;
         } else {
            if (validationResult.result && validationResult.result.length !== 0) {
               self.compatibilityItems = groupCompatibilityItemsByDescription(
                     validationResult.result.map(getCompatibilityItem));
            } else {
               if (raisingEvcBaseline()) {
                  self.compatibilityItems =
                        [COMPATIBILITY_ITEM_RAISING_EVC_BASELINE];
               } else {
                  self.compatibilityItems =
                        [COMPATIBILITY_ITEM_VALIDATION_SUCCEEDED];
               }
            }
         }
      }

      function validateEvcMode(evcModeKey) {
         return mutationService.validate(objectId,
               'com.vmware.vsphere.client.cluster.ClusterEvcSpec',
               getEvcSpecForMode(evcModeKey));
      }

      function raisingEvcBaseline() {
         return self.evcMode.key !== null &&
               currentEvcMode.key !== null &&
               self.evcMode.vendorTier > currentEvcMode.vendorTier;
      }

      function groupCompatibilityItemsByDescription(compatibilityItems) {
         var compatibilityItemsByMessage = _.groupBy(compatibilityItems, 'message');
         return _.map(compatibilityItemsByMessage,
               function (compatibilityItems, message) {
                  var hostNames = _.uniq(_.flatten(_.map(compatibilityItems, 'hostNames')));
                  return {
                     icon: 'vsphere-icon-status-error',
                     message: message,
                     contents: _.map(hostNames, function (name) {
                        return {
                           icon: iconService.getByObjectType('HostSystem'),
                           message: name,
                           contents: []
                        };
                     })
                  };
               });
      }

      function getCompatibilityItem(checkResult) {
         var hostNames = [];
         if (checkResult.host && checkResult.host.length !== 0) {
            checkResult.host.forEach(function(hostRef) {
               var hostName = hostsNamesById[hostRef.value];
               if (hostName) {
                  hostNames.push(hostName);
               } else {
                  log.warn('Could not find a name for host: ', hostRef);
               }
            });
         }
         return {
            message: checkResult.error.localizedMessage,
            hostNames: hostNames
         };
      }

      function getEvcModes(selectedEvcVendor) {
         if (selectedEvcVendor === evcConstants.cpuVendor.INTEL) {
            return self.supportedIntelEvcMode;
         } else if (selectedEvcVendor === evcConstants.cpuVendor.AMD) {
            return self.supportedAmdEvcMode;
         } else {
            return [DISABLED_EVC_MODE];
         }
      }

      function getHostNamesById(hosts) {
         var hostsNamesById = {};
         if (hosts && hosts.length !== 0) {
            hosts.forEach(function (hostNameData) {
               hostsNamesById[hostNameData.provider.value] =
                     hostNameData.name;
            });
         }
         return hostsNamesById;
      }

      function showDataRetrieveError() {
         setPageBusy(false);
         $scope.modalOptions.submitDisabled = true;
         $scope.modalOptions.alerts = [{
            type: vuiConstants.validationBanner.type.ERROR,
            text: getString('evc.config.serverError')
         }];
         $scope.modalOptions.isAlertClosed = false;
         log.error('Server error can not retrieve edit EVC config data.');
      }

      function getHeaderOptions(textKey) {
         return {
            title: getString(textKey)
         };
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function getEvcSpecForMode(evcModeKey) {
         return {
            evcModeKey: evcModeKey
         };
      }

      function onSubmit () {
         var selectedEvcModeKey = (self.evcMode) ?
            self.evcMode.key
            : null;

         mutationService.apply(objectId, 'com.vmware.vsphere.client.cluster.ClusterEvcSpec',
               getEvcSpecForMode(selectedEvcModeKey));

         $scope.closeModal();

         return false;
      }

      function setPageBusy(isBusy) {
         self.loading = isBusy;
         $scope.modalOptions.submitDisabled = isBusy;
      }
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('EditSwapFileLocationController', EditSwapFileLocationController);

   EditSwapFileLocationController.$inject = ['$scope', 'clusterSwapFileLocationService',
      'clusterSpecBuilderService', 'mutationService'];

   function EditSwapFileLocationController($scope, clusterSwapFileLocationService,
                                           clusterSpecBuilderService, mutationService) {
      var vm = this;

      var objectId = $scope.modalOptions.dialogData.objectId;
      vm.warning = clusterSwapFileLocationService.WARNING;
      vm.formData = vm.formData || {};

      vm.vmDirectory = clusterSwapFileLocationService.getVmDirectoryData();
      vm.hostDatastore = clusterSwapFileLocationService.getHostDatastoreData();

      $scope.modalOptions.onSubmit = onSubmit;

      getViewData();

      function getViewData() {
         setPageBusy(true);
         clusterSwapFileLocationService.getSwapFilePlacement(objectId).then(
            function(swapFile) {
               vm.formData.vmSwapPlacement = swapFile;
               setPageBusy(false);
            }
         );
      }

      function onSubmit () {
         if (vm.loading) {
            return false;
         }

         var clusterSpec = clusterSpecBuilderService.buildClusterComputeResourceSpec(
            vm.formData, true);
         mutationService
               .apply(objectId,
                     'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
            clusterSpec);

         return true;
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         vm.loading = isBusy;
      }
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('GeneralConfigController', GeneralConfigController);

   GeneralConfigController.$inject = ['$scope', 'i18nService',
      'clusterSwapFileLocationService'];

   function GeneralConfigController($scope, i18nService, clusterSwapFileLocationService) {
      var self = this;
      var objectId = $scope._route.objectId;

      self.headerOptions = getHeaderOptions();
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         "configurationEx.vmSwapPlacement"
      ];
      self.getViewData = getViewData;

      getViewData();

      function getHeaderOptions() {
         return {
            title: i18nService.getString('ClusterUi', 'manage.settings.general'),
            actions: [{
               actionUid: 'vsphere.core.cluster.actions.editSwapfileLocationAction',
               customLabel: i18nService.getString('Common', 'settingsView.defaultEditActionLabel')
            }]
         };
      }

      function getViewData() {
         clusterSwapFileLocationService.getSwapFilePlacement(objectId).then(
            function (swapPlacement) {
               self.swapFileLocation =
                  clusterSwapFileLocationService.getVmSwapFileLocation(swapPlacement);
            }
         );
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('AddClusterGroupController', AddClusterGroupController);

   AddClusterGroupController.$inject = ['$scope', 'i18nService', '$q',
      'clusterGroupsService', 'vuiConstants', 'mutationService',
      'clusterSpecBuilderService', 'clusterGroupsConstants'];

   function AddClusterGroupController($scope, i18nService, $q, clusterGroupsService,
      vuiConstants, mutationService, clusterSpecBuilderService, clusterGroupsConstants) {
      var self = this;

      var objectId = $scope._route.objectId;

      self.spec = {};
      self.spec.groupType = clusterGroupsService.DEFAULT_GROUP_TYPE;
      self.spec.name = '';
      self.spec.groupMembers = [];
      $scope.modalOptions.isAlertClosed = true;

      getViewData();

      $scope.modalOptions.onSubmit = function() {
         return onCommit();
      };

      function getViewData() {
         self.typeOptions = clusterGroupsService.buildTypesOptions();
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function validate() {
         if (self.spec.name) {
            if ((/^\s*$/gi).test(self.spec.name)) {
               $scope.modalOptions.alerts = [{
                  text: getString('groups.config.error.nameEmpty'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;

               return $q.reject();
            } else if (self.spec.name.length > 80) {
               $scope.modalOptions.alerts = [{
                  text: getString('groups.config.error.nameTooLong'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;

               return $q.reject();
            }
         } else {
            $scope.modalOptions.alerts = [{
               text: getString('groups.config.error.nameEmpty'),
               type: vuiConstants.validationBanner.type.ERROR
            }];
            $scope.modalOptions.isAlertClosed = false;

            return $q.reject();
         }

         if (self.spec.groupMembers && self.spec.groupMembers.length === 0) {
            $scope.modalOptions.alerts = [{
               text: getString('groups.config.error.noMembers'),
               type: vuiConstants.validationBanner.type.ERROR
            }];
            $scope.modalOptions.isAlertClosed = false;

            return $q.reject();
         }

         var groupMemberIds = clusterGroupsService.getSelectedItemsIds(
               self.spec.groupMembers);

         self.groupSpec = clusterGroupsService.buildGroupSpec(self.spec.groupType,
               self.spec.name,
               clusterGroupsService.buildGroupMembersSpec(groupMemberIds),
               clusterGroupsConstants.operationType.ADD);

         var validationPromise =
            mutationService.validate(
               objectId,
               'com.vmware.vim.binding.vim.cluster.GroupSpec',
               self.groupSpec
            ).then(function(validationResult) {
               $scope.modalOptions.isAlertClosed = true;
               $scope.modalOptions.alerts = [];

               if (!!validationResult && (!validationResult.result || !!validationResult.error)) {
                  $scope.modalOptions.alerts.push({
                     text: getString('groups.config.error.nameNotUnique'),
                     type: vuiConstants.validationBanner.type.ERROR
                  });
                  $scope.modalOptions.isAlertClosed = false;

                  return $q.reject();
               } else {
                  return $q.resolve();
               }
            });

         return validationPromise;
      }

      function onCommit() {
         return validate()
            .then(function() {
               if(!self.groupSpec) {
                  var groupMemberIds = clusterGroupsService.getSelectedItemsIds(
                        self.spec.groupMembers);
                  self.groupSpec = clusterGroupsService.buildGroupSpec(
                     self.spec.groupType,
                     self.spec.name,
                     clusterGroupsService.buildGroupMembersSpec(groupMemberIds)
                  );
               }

               var clusterComputeResourceSpec =
                  clusterSpecBuilderService.buildClusterComputeResourceSpec(
                        {
                           group: self.groupSpec
                        },
                        true
                  );

               mutationService.apply(
                  objectId,
                  'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
                  clusterComputeResourceSpec
               );
               return true;
            })
            .catch(function(e) {
               return false;
            });
      }
   }
})();

(function() {
   /**
    * Directive for group members when adding a new VM/Host group.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'addGroupMembers', addGroupMembers);

   addGroupMembers.$inject = ['i18nService'];

   function addGroupMembers(i18nService) {

      return {
         restrict: 'E',
         templateUrl:
               'cluster-ui/resources/cluster/views/settings/configuration/groups/addGroupMembers.html',
         scope: {
            groupType: '=',
            groupMembers: '='
         },
         controller: ['$scope', '$element', function($scope) {
            $scope.removeAction = removeGroupMember;
            $scope.addAction = addGroupMember;
            $scope.gridTitle = i18nService.getString('ClusterUi',
                  'groups.members.list.name');

            $scope.$watch('groupType', function(groupType) {
               if (groupType) {
                  $scope.groupMembers = [];
               }
            });
            
            function removeGroupMember(selectedGroupMembers) {
               $scope.groupMembers = $scope.groupMembers.filter(function(object) {
                  return !selectedGroupMembers.some(function(selected) {
                     return selected.id === object.id;
                  });
               });
            }

            function addGroupMember(selectedItems) {
               $scope.groupMembers = $scope.groupMembers.concat(selectedItems);

               return true;
            }
         }]
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AddGroupMembersSelectorDialog',
               AddGroupMembersSelectorDialog);

   AddGroupMembersSelectorDialog.$inject = ['$scope', 'clusterGroupsConstants',
         'i18nService', 'managedEntityConstants', 'vuiConstants'];

   function AddGroupMembersSelectorDialog($scope, clusterGroupsConstants,
         i18nService, managedEntityConstants, vuiConstants) {
      var self = this;

      self.managedEntityConstants = managedEntityConstants;
      self.clusterGroupsConstants = clusterGroupsConstants;

      var dialogData = $scope.modalOptions.dialogData;
      dialogData.selectedItems = [];

      $scope.modalOptions.onSubmit = function() {
         if (dialogData.selectedItems.length === 0) {
            $scope.modalOptions.alerts = [{
               text: i18nService.getString('CommonUi', 'objectSelectorDialog.noSelection'),
               type: vuiConstants.validationBanner.type.ERROR
            }];
            $scope.modalOptions.isAlertClosed = false;
            return false;
         }

         return $scope.modalOptions.dialogData.onSubmit();
      };

      var clusterId = dialogData.objectId;
      var objects = dialogData.objects;
      var objectType = dialogData.objectType;
      var groupMembers = getSelectedItemsIds(objects);
      var selectorConfig = getGroupTypeSelectorConfiguration(objectType);
      var filter = getObjectsFilter(objectType, groupMembers);

      if (selectorConfig) {
         this.config = {
            contextObject: clusterId,
            multipleSelect: true,
            listTabConfig: {
               listConfig: [{
                  label: selectorConfig.label,
                  listViewId: selectorConfig.listViewId,
                  dataModels: [selectorConfig.objectType],
                  filterId: filter,
                  filterParams: groupMembers
               }]
            },
            onSelectionChanged: function(newSelectedItems) {
               dialogData.selectedItems = newSelectedItems;
            }
         };
      }

      function getGroupTypeSelectorConfiguration(groupType) {
         if (groupType === clusterGroupsConstants.groupType.VM_GROUP) {
            return {
               label: i18nService.getString('Common', 'typeResource.vmPlural'),
               objectType: self.managedEntityConstants.VIRTUAL_MACHINE,
               listViewId: "vsphere.core.vm.list"
            };
         } else if (groupType === clusterGroupsConstants.groupType.HOST_GROUP) {
            return {
               label: i18nService.getString('Common', 'typeResource.hostPlural'),
               objectType: self.managedEntityConstants.HOST,
               listViewId: "vsphere.core.host.list"
            };
         }

         return null;
      }

      function getObjectsFilter(objectType, existingMembers) {
         if (objectType === self.clusterGroupsConstants.groupType.VM_GROUP) {
            if (existingMembers.length === 0) {
               return 'clusterVmsExceptSecondaryVmsFilter';
            } else {
               return 'clusterVmsExceptSecondaryVmsExcludeVmsFilter';
            }
         } else if (objectType === self.clusterGroupsConstants.groupType.HOST_GROUP) {
            if (existingMembers.length === 0) {
               return 'clusterObjectsFilter';
            } else {
               return 'clusterObjectsExcludeObjectsFilter';
            }
         }
      }

      //Make a clean array of group members, because the currently selected group
      //is taken from the datagrid selected row items and the datagrid adds extra unnecessary
      //properties to the row data which break the object selector.
      function buildCleanGroupMembers(members) {
         return members.map(function(memberRef) {
            return memberRef;
         });
      }

      function getSelectedItemsIds(items) {
         return items.map(function(item) {
            return item.id;
         });
      }
   }
})();

(function() {
   /**
    * Directive for VM and host member listing and selection.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'groupMembersManager', groupMembersManager);

   groupMembersManager.$inject = ['$rootScope', 'vuiConstants',
         'datagridActionBarService', '$q'];

   function groupMembersManager($rootScope, vuiConstants, datagridActionBarService, $q) {

      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/configuration/groups/groupMembersManager.html',
         scope: {
            objects: '=',
            objectType: '=',
            addAction: '=',
            removeAction: '=',
            gridTitle: '='
         },
         controller: ['$scope', function($scope) {
            var objectId = $rootScope._route.objectId;
            var selectedObjects = [];
            var actionSpecs = [{
               actionId: 'vsphere.core.cluster.actions.group.members.add',
               getActionInvocationContext: function() {
                  return {
                     memberObjects: $scope.objects,
                     memberObjectsType: $scope.objectType,
                     addMembersCallback: function(members) {
                        return $scope.addAction(members);
                     }
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available && !!$scope.objects;
               }
            }, {
               actionId: 'vsphere.core.cluster.actions.group.members.remove',
               getActionInvocationContext: function() {
                  return {
                     removeMembersCallback: function() {
                        return $scope.removeAction(selectedObjects);
                     }
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available && $scope.gridOptions.selectedItems.length > 0;
               }
            }];
            var datagridActionBarServiceCacheObject = null;

            $scope.gridOptions = getGridOptions();

            $scope.$watch('gridOptions.selectedItems', onSelectionChange);
            $scope.$watchCollection('objects', function(objects) {
               if (objects) {
                  $scope.gridOptions.data = objects;
               } else {
                  $scope.gridOptions.data = [];
               }

               refreshActionBar();
            });

            createActionBar();

            function createActionBar() {
               datagridActionBarService
                     .updateActionBar($scope.gridOptions, [objectId], actionSpecs)
                     .then(function(value) {
                        datagridActionBarServiceCacheObject = value;
                     });
            }

            function refreshActionBar() {
               if (!datagridActionBarServiceCacheObject) {
                  return;
               }

               datagridActionBarService.updateActionBar(
                     $scope.gridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
               );
            }

            function getGridOptions() {
               var options = {
                  actionBarOptions: {
                     actions: []
                  },
                  pageConfig: {
                     hidePager: true
                  },
                  searchable: false,
                  resizable: false,
                  data: [],
                  columnDefs: [
                     {
                        field: 'name',
                        type: 'string',
                        template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
                     }
                  ],
                  selectionMode: vuiConstants.grid.selectionMode.MULTI,
                  showCheckboxesOnMultiSelection: false,
                  selectedItems: [],
                  height: '100%'
               };

               return options;
            }

            function onSelectionChange(newSelectedObjects) {
               if (!newSelectedObjects || newSelectedObjects.length === 0) {
                  selectedObjects = [];
               } else {
                  selectedObjects = newSelectedObjects;
               }

               refreshActionBar();
            }
         }],
         link: function(scope, element) {
            var gridReadyPromise = $q.defer();

            scope.$on('kendoWidgetCreated', function (event, widget) {
               if (widget && widget.constructor === kendo.ui.Grid) {
                  gridReadyPromise.resolve(widget);
               }
            });

            scope.$watch('gridTitle', function (gridTitle) {
               if (gridTitle && gridTitle.trim().length > 0) {
                  gridReadyPromise.promise.then(function (widget) {
                     var options = widget.getOptions();
                     options.columns[0].title = gridTitle;
                     widget.setOptions(options);

                     scope.$evalAsync(function() {
                        kendo.resize(element);
                     });
                  });
               }
            });
         }
      };
   }
})();

(function() {
   /**
    * Directive for VM and host group members datagrids.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
      'vmAndHostGroupMembers', vmAndHostGroupMembers);

   vmAndHostGroupMembers.$inject = ['i18nService', 'clusterGroupsService', '$rootScope',
         'clusterGroupsConstants', 'mutationService', 'clusterSpecBuilderService'];

   function vmAndHostGroupMembers(i18nService, clusterGroupsService, $rootScope,
         clusterGroupsConstants, mutationService, clusterSpecBuilderService) {

      return {
         restrict: 'E',
         templateUrl:
            'cluster-ui/resources/cluster/views/settings/configuration/groups/vmAndHostGroupMembers.html',
         scope: {
            group: '='
         },
         controller: ['$scope', '$element', function($scope) {
            var objectId = $rootScope._route.objectId;

            $scope.removeAction = removeGroupMember;
            $scope.addAction = addGroupMember;

            $scope.$watch('group', function(group) {
               if (group) {
                  clusterGroupsService.getGroupMembers(group)
                     .then(function(membersData) {
                        if ($scope.group &&  $scope.group.name === group.name) {
                           $scope.objects = membersData;
                           $scope.objectType = group.rawType;
                           $scope.gridTitle = i18nService.getString(
                                 'ClusterUi', 'rules.groupMembers.members', _.escape(group.name));
                        }
                     });
               } else {
                  $scope.objects = null;
                  $scope.gridTitle = ' ';
               }
            });

            function removeGroupMember(selectedGroupMembers) {
               clusterGroupsService.removeGroupMembers(objectId, $scope.group, selectedGroupMembers);
            }

            function addGroupMember(selectedItems) {
                  var allGroupMembers = getSelectedItemsIds(
                        $scope.objects.concat(selectedItems));

                  var groupSpec = clusterGroupsService.buildGroupSpec(
                        $scope.group.rawType,
                        $scope.group.name,
                        clusterGroupsService.buildGroupMembersSpec(allGroupMembers),
                        clusterGroupsConstants.operationType.EDIT
                  );

                  var clusterSpec =
                        clusterSpecBuilderService.buildClusterComputeResourceSpec(
                              {group: groupSpec}, true);

                  mutationService.apply(
                        objectId,
                        'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
                        clusterSpec
                  );
                  return true;
               }

            function getSelectedItemsIds(items) {
               return items.map(function(item) {
                  return item.id;
               });
            }
         }]
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('VmAndHostGroupsController', VmAndHostGroupsController);

   VmAndHostGroupsController.$inject = ['$rootScope', '$scope', '$element',
      '$compile', 'i18nService', 'clusterGroupsService', 'vuiConstants',
      'datagridActionBarService'];

   function VmAndHostGroupsController($rootScope, $scope, $element, $compile,
         i18nService, clusterGroupsService, vuiConstants,
         datagridActionBarService) {
      var self = this;
      var objectId = $rootScope._route.objectId;
      var actionSpecs = [{
         actionId: 'vsphere.core.cluster.actions.group.add'
      }, {
         actionId: 'vsphere.core.cluster.actions.group.remove',
         getActionInvocationContext: function() {
            return {
               selectedGroup: self.selectedGroup
            };
         },
         isActionAvailable: function(actionDef) {
            return actionDef.available && self.groupsGridOptions.selectedItems.length > 0;
         }
      }];
      var datagridActionBarServiceCacheObject = null;

      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         "configurationEx.group"
      ];
      self.getViewData = getViewData;
      self.groupsGridOptions = getGroupsGridOptions();
      self.splitterOptions = getSplitterOptions();
      self.groupsTitle = i18nService.getString('ClusterUi', 'manage.settings.groups');
      self.selectedGroup = null;

      var filterPlaceholderText = i18nService.getString('Common', 'filter.label');
      var filterElement = $compile(
            '<div class="filter-input pull-right">' +
            '<span class="nav-icon fa fa-filter" ng-click="doSearch()"/>' +
            '<input type="text" ng-model="searchTerm" ng-trim="true" ng-change="debouncedRefreshCallback()"' +
            ' ng-keypress="keyPress($event)" placeholder="' + filterPlaceholderText + '"/>' +
            '</div>')($scope);
      var isFilterAdded = false;

      $scope.doSearch = function() {
         getViewData();
      };
      $scope.keyPress = function(event) {
         if (event.keyCode === 13) {
            // In IE Enter would activate the focused item so we prevent this default
            // behavior.
            event.preventDefault();
            event.stopPropagation();
            getViewData();
         }
      };
      $scope.groupsPreselectComparator = groupsPreselectComparator;
      $scope.$watch('ctrl.groupsGridOptions.selectedItems', onSelectedGroupChange);
      $scope.$watch(
            function() {
               return self.selectedGroup;
            }, function() {
               refreshActionBar();
            });

      getViewData();
      createActionBar();

      function getViewData() {
         clusterGroupsService.getGroupsData(objectId, $scope.searchTerm).then(
               function (groupsData) {
                  self.groupsGridOptions.data = groupsData;
                  keepSelectionOrPreselectFirst();
               });
      }

      function createActionBar() {
         datagridActionBarService
               .updateActionBar(self.groupsGridOptions, [objectId], actionSpecs)
               .then(function (value) {
                  datagridActionBarServiceCacheObject = value;
               });
      }

      function refreshActionBar() {
         if (!datagridActionBarServiceCacheObject) {
            return;
         }

         datagridActionBarService.updateActionBar(
               self.groupsGridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
         );
      }

      function keepSelectionOrPreselectFirst() {
         if (self.groupsGridOptions.data && self.groupsGridOptions.data.length > 0) {
            var itemToPreselect;

            if (self.selectedGroup) {
               itemToPreselect = _.find(self.groupsGridOptions.data, {
                  name: self.selectedGroup.name
               });
            }
            self.selectedGroup = !!itemToPreselect ?
                  itemToPreselect : self.groupsGridOptions.data[0];
         }
      }

      function getGroupsGridOptions() {
         var options = {
            actionBarOptions: {
               actions: []
            },
            pageConfig: {
               hidePager: true
            },
            searchable: false,
            resizable: true,
            data: [],
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            columnDefs: getGroupsGridColumnDefs(),
            height: '100%',
            dataBound: onDataBound
         };

         return options;
      }

      function onDataBound() {
         if (!isFilterAdded) {
            addToolbarFilter();
         }
      }

      function addToolbarFilter() {
         var grid = getGridElement();
         if (grid) {
            var toolbarElement = grid.find('.k-grid-toolbar');
            if (toolbarElement.length > 0) {
               toolbarElement.append(filterElement);
               isFilterAdded = true;
            }
         }
      }

      function getGridElement() {
         const element = $element.find('.k-grid-content');
         return element && element.parent();
      }

      function getSplitterOptions() {
         return {
            orientation: vuiConstants.splitter.orientation.VERTICAL,
            panes: [
               {
                  min: '150px',
                  size: '40%'
               }, {
                  min: '150px',
                  size: '60%'
               }
            ]
         };
      }

      function getGroupsGridColumnDefs() {
         return [
            {
               displayName: i18nService.getString('ClusterUi', 'groups.list.name'),
               field: 'name',
               type: 'string',
               template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
            },
            {
               displayName: i18nService.getString('ClusterUi', 'groups.list.type'),
               field: 'type',
               type: 'string',
               template: '<span title="#:type#">#:type#</span>'
            }
         ];
      }

      function onSelectedGroupChange(newSelectedGroups) {
         if (!newSelectedGroups || newSelectedGroups.length === 0) {
            self.selectedGroup = null;
            return;
         }

         if (self.selectedGroup && newSelectedGroups[0].name === self.selectedGroup.name) {
            return;
         }

         self.selectedGroup = newSelectedGroups[0];
      }

      function groupsPreselectComparator(groupItem) {
         return self.selectedGroup && groupItem &&
               self.selectedGroup.name === groupItem.name;
      }
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var ConfigClusterVmOverridesController = (function () {
        function ConfigClusterVmOverridesController(dataService, i18nService, clusterConfigVmOverrideService, drsAutomationLevelService, vcService, haConstants, haHostFailureResponseService, haHostIsolationResponseService, haPdlResponseService, haApdResponseService, haVmReactionsOnApdClearedService, clusterVmOverridesConstants, clusterConstants, haVmMonitoringService, defaultUriSchemeUtil, $q) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.clusterConfigVmOverrideService = clusterConfigVmOverrideService;
            this.drsAutomationLevelService = drsAutomationLevelService;
            this.vcService = vcService;
            this.haConstants = haConstants;
            this.haHostFailureResponseService = haHostFailureResponseService;
            this.haHostIsolationResponseService = haHostIsolationResponseService;
            this.haPdlResponseService = haPdlResponseService;
            this.haApdResponseService = haApdResponseService;
            this.haVmReactionsOnApdClearedService = haVmReactionsOnApdClearedService;
            this.clusterVmOverridesConstants = clusterVmOverridesConstants;
            this.clusterConstants = clusterConstants;
            this.haVmMonitoringService = haVmMonitoringService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
            this.tooltipParams = {};
            this.MIN_POST_READY_DELAY = 0;
            this.MIN_RESTART_PRIORITY_TIMEOUT = 0;
            this.i18n = i18nService.getString;
            this.setPageBusy(true);
            this.MAX_POST_READY_DELAY = this.haConstants.MAX_POST_READY_DELAY;
            this.MAX_RESTART_PRIORITY_TIMEOUT = this.haConstants.MAX_RESTART_PRIORITY_TIMEOUT;
            this.POST_READY_DELAY_PLACEHOLDER =
                this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues");
        }
        ConfigClusterVmOverridesController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (!angular.isUndefined(changes.spec)) {
                this.vmSettingsSpec = changes.spec.currentValue;
            }
            // onChanges in Add wizard is called twice, first time only spec is set
            // second time spec is undefined but vms are set , as they are updated by a
            // promise, we want to init it all once
            if (!angular.isUndefined(this.vmSettingsSpec) &&
                !angular.isUndefined(changes.selectedVms) &&
                !angular.isUndefined(changes.selectedVms.currentValue) &&
                changes.selectedVms.currentValue.length > 0) {
                this.selectedVms = changes.selectedVms.currentValue;
                // this data doesn't depend on changes so we want to make the backend
                // call once
                if (!this.clusterOverridesData || !this.is65VcOrLater) {
                    var dataPromise = this.dataService.getData(this.vmSettingsSpec.objectId, "com.vmware.vsphere.client.clusterui.model.configuration.ClusterAddOverrideData");
                    var vcVersionPromise = this.vcService.is65VcOrLater(this.vmSettingsSpec.objectId);
                    this.$q.all([dataPromise, vcVersionPromise]).then(function (result) {
                        _this.clusterOverridesData = result[0];
                        _this.is65VcOrLater = result[1];
                        _this.initSettings();
                    });
                }
                else {
                    this.initSettings();
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.initSettings = function () {
            this.initDrsSettings();
            this.initHaSettings();
            var numberOfTooltips = this.getDifferentSettingsVmsCount();
            if (numberOfTooltips > 0) {
                this.alertText = numberOfTooltips === 1 ?
                    this.i18nService.getString('ClusterUi', 'vm.overrides.config.editMultiple.warningMessage.single') :
                    this.i18nService.getString('ClusterUi', 'vm.overrides.config.editMultiple.warningMessage.multiple', numberOfTooltips);
            }
            this.setPageBusy(false);
        };
        ConfigClusterVmOverridesController.prototype.updateRestartPriorityDependencies = function () {
            if (this.isRestartPriorityDisabled()) {
                this.setDefaultHaIsolationResponse();
                this.setDefaultHaPdlProtection();
                this.setDefaultHaApdProtection();
                this.setDefaultHaApdVmRecovery();
                this.setDefaultHaApdDelay();
            }
        };
        ConfigClusterVmOverridesController.prototype.updateDrsAutomationLevelValue = function () {
            if (!this.vmSettingsSpec.drsAutomationOverrideEnabled) {
                this.vmSettingsSpec.drsAutomationLevel =
                    this.clusterOverridesData.clusterDrsAutomationLevel;
            }
        };
        ConfigClusterVmOverridesController.prototype.updateRestartPriorityValue = function () {
            if (!this.vmSettingsSpec.haRestartPriorityEnabled) {
                this.vmSettingsSpec.haRestartPriority =
                    this.clusterOverridesData.clusterVmRestartPriority;
            }
        };
        ConfigClusterVmOverridesController.prototype.updateRestartOrchestrationValue = function () {
            var _this = this;
            if (!this.vmSettingsSpec.haRestartOrchestrationEnabled) {
                this.vmSettingsSpec.restartOrchestration.readyCondition =
                    this.clusterOverridesData.defaultVmReadiness.readyCondition;
                if (!this.vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled) {
                    // in case both are unchecked existing vmorchestration members should
                    // be removed
                    _.each(this.selectedVms, function (selectedVm) {
                        if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.ADD) {
                            selectedVm.skipFromOrchestrationSpec = true;
                        }
                        if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.EDIT) {
                            selectedVm.arrayOperation = _this.clusterVmOverridesConstants.operationType.REMOVE;
                        }
                    });
                }
            }
            else {
                // in case of uncheck and then check again
                _.each(this.selectedVms, function (selectedVm) {
                    if (!!selectedVm.skipFromOrchestrationSpec) {
                        selectedVm.skipFromOrchestrationSpec = false;
                    }
                    if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.REMOVE) {
                        selectedVm.arrayOperation = _this.clusterVmOverridesConstants.operationType.EDIT;
                    }
                });
            }
        };
        ConfigClusterVmOverridesController.prototype.updateRestartOrchestrationAdditionalDelayValue = function () {
            var _this = this;
            if (!this.vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled) {
                this.vmSettingsSpec.restartOrchestration.postReadyDelay =
                    this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT;
                if (!this.vmSettingsSpec.haRestartOrchestrationEnabled) {
                    // in case both are unchecked existing vmorchestration members should
                    // be removed
                    _.each(this.selectedVms, function (selectedVm) {
                        if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.ADD) {
                            selectedVm.skipFromOrchestrationSpec = true;
                        }
                        if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.EDIT) {
                            selectedVm.arrayOperation = _this.clusterVmOverridesConstants.operationType.REMOVE;
                        }
                    });
                }
            }
            else {
                // this is done so that we don't display -1
                if (this.vmSettingsSpec.restartOrchestration.postReadyDelay ===
                    this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT) {
                    this.vmSettingsSpec.restartOrchestration.postReadyDelay =
                        this.clusterOverridesData.defaultVmReadiness.postReadyDelay;
                }
                // in case of uncheck and then check again
                _.each(this.selectedVms, function (selectedVm) {
                    if (!!selectedVm.skipFromOrchestrationSpec) {
                        selectedVm.skipFromOrchestrationSpec = false;
                    }
                    if (selectedVm.arrayOperation === _this.clusterVmOverridesConstants.operationType.REMOVE) {
                        selectedVm.arrayOperation = _this.clusterVmOverridesConstants.operationType.EDIT;
                    }
                });
            }
        };
        ConfigClusterVmOverridesController.prototype.updateRestartPriorityTimeoutValue = function () {
            if (!this.vmSettingsSpec.haRestartPriorityTimeoutEnabled) {
                this.vmSettingsSpec.haRestartPriorityTimeout =
                    this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT;
            }
            else {
                if (this.vmSettingsSpec.haRestartPriorityTimeout ===
                    this.clusterVmOverridesConstants.APD_DELAY_CLUSTER_DEFAULT) {
                    this.vmSettingsSpec.haRestartPriorityTimeout =
                        this.clusterOverridesData.clusterVmRestartPriorityTimeout;
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.updateIsolationResponseValue = function () {
            if (!this.vmSettingsSpec.haIsolationResponseEnabled) {
                this.vmSettingsSpec.haIsolationResponse =
                    this.clusterOverridesData.clusterIsolationResponse;
            }
        };
        ConfigClusterVmOverridesController.prototype.updatePdlProtectionValue = function () {
            if (!this.vmSettingsSpec.haPdlProtectionEnabled) {
                this.vmSettingsSpec.haPdlProtection =
                    this.clusterOverridesData.vmcpSettings.pdlResponse;
            }
        };
        ConfigClusterVmOverridesController.prototype.updateApdProtectionValue = function () {
            if (!this.vmSettingsSpec.haApdProtectionEnabled) {
                this.vmSettingsSpec.haApdProtection =
                    this.clusterOverridesData.vmcpSettings.apdResponse;
                this.updateApdProtectionDependencies();
            }
        };
        ConfigClusterVmOverridesController.prototype.updateApdProtectionDependencies = function () {
            if (this.isApdProtectionDisabled()) {
                this.setDefaultHaApdDelay();
                this.setDefaultHaApdVmRecovery();
            }
        };
        ConfigClusterVmOverridesController.prototype.updateApdDelayValue = function () {
            if (!this.vmSettingsSpec.haApdDelayEnabled) {
                this.vmSettingsSpec.haApdDelay = this.getApdDelayClusterDefault();
            }
        };
        ConfigClusterVmOverridesController.prototype.updateApdVmRecoveryValue = function () {
            if (!this.vmSettingsSpec.haApdVmRecoveryEnabled) {
                this.vmSettingsSpec.haApdVmRecovery =
                    this.clusterOverridesData.vmcpSettings.vmReactionOnAPDCleared;
            }
        };
        ConfigClusterVmOverridesController.prototype.updateVmMonitoringValue = function () {
            if (!this.vmSettingsSpec.haVmMonitoringEnabled) {
                this.vmSettingsSpec.haVmMonitoring =
                    this.clusterOverridesData.vmMonitoring;
                this.setDefaultHaVmMonitoringSensitivity();
                this.setDefaultHaVmMonitoringFailureInterval();
                this.setDefaultHaVmMonitoringMinUpTime();
                this.setDefaultHaVmMonitoringMaxFailures();
                this.setDefaultHaVmMonitoringMaxFailuresWindow();
            }
            this.updateVmMonitoringSensitivityTooltip();
        };
        ConfigClusterVmOverridesController.prototype.updateVmMonitoringSensitivityTooltip = function () {
            if (this.tooltipParams.haVmMonitoringSensitivityParams) {
                this.tooltipParams.haVmMonitoringSensitivityParams.isSettingVisible =
                    this.isVmMonitoringSensitivityVisible();
                if (this.alertText) {
                    var numOfTooltips = this.getDifferentSettingsVmsCount();
                    this.alertText = numOfTooltips === 1 ?
                        this.i18nService.getString('ClusterUi', 'vm.overrides.config.editMultiple.warningMessage.single') :
                        this.i18nService.getString('ClusterUi', 'vm.overrides.config.editMultiple.warningMessage.multiple', numOfTooltips);
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.normalizeApdDelayValue = function (event) {
            var maxMinutesValue = Math.floor(this.clusterConstants.MAX_INTEGER /
                this.haConstants.SECONDS_IN_A_MINUTE);
            this.normalizeOverrideValue("haApdDelay", event, this.haConstants.MIN_NUMBER_INPUT, maxMinutesValue);
        };
        ConfigClusterVmOverridesController.prototype.normalizeApdDelayMultipleValues = function (value) {
            if (value === this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues")) {
                return;
            }
            var maxMinutesValue = Math.floor(this.clusterConstants.MAX_INTEGER /
                this.haConstants.SECONDS_IN_A_MINUTE);
            var numericValue = parseInt(value, 10);
            if (angular.isUndefined(value) || _.isNull(value) || numericValue < 0 ||
                isNaN(numericValue)) {
                this.vmSettingsSpec.haApdDelay = 0;
            }
            else if (numericValue > maxMinutesValue) {
                this.vmSettingsSpec.haApdDelay = maxMinutesValue;
            }
            else {
                this.vmSettingsSpec.haApdDelay = numericValue;
            }
        };
        ConfigClusterVmOverridesController.prototype.normalizeFailureInt = function (event) {
            this.normalizeOverrideValue("vmToolsMonitorFailureInt", event, this.haConstants.MIN_NUMBER_INPUT, this.haConstants.MAX_FAILURE_INTERVAL);
        };
        ConfigClusterVmOverridesController.prototype.normalizeMinUpTime = function (event) {
            this.normalizeOverrideValue("vmToolsMonitorMinUpTime", event, this.haConstants.MIN_NUMBER_INPUT, this.haConstants.MAX_MINIMUM_UPTIME);
        };
        ConfigClusterVmOverridesController.prototype.normalizeMaxFailures = function (event) {
            this.normalizeOverrideValue("vmToolsMonitorMaxFailures", event, this.haConstants.MIN_NUMBER_INPUT, this.haConstants.MAX_VM_PER_RESET);
        };
        ConfigClusterVmOverridesController.prototype.normalizeMaxFailuresWindow = function (event) {
            this.normalizeOverrideValue("vmToolsMonitorMaxFailureWindow", event, this.haConstants.MIN_RESETS_WINDOW_HRS, this.haConstants.MAX_RESETS_WINDOW_HRS);
        };
        ConfigClusterVmOverridesController.prototype.hasSelectedVm = function () {
            return !_.isEmpty(this.selectedVms);
        };
        ConfigClusterVmOverridesController.prototype.isFtVm = function () {
            return this.hasSelectedVm() && _.some(this.selectedVms, function (selectedVm) {
                return selectedVm.vm.ftVm;
            });
        };
        ConfigClusterVmOverridesController.prototype.isVmcpSupportedForVm = function () {
            return this.hasSelectedVm() && _.all(this.selectedVms, function (selectedVm) {
                return selectedVm.vm.isVmcpSupportedForVm;
            });
        };
        ConfigClusterVmOverridesController.prototype.isDrsAutomationLevelEditable = function () {
            var drsAutomationLevelEditableValues = this.getSelectedVmsDrsProperties("drsAutomationLevelEditable");
            var drsAutomationLevelEditable = this.clusterConfigVmOverrideService
                .getUniqueValue(drsAutomationLevelEditableValues);
            if (this.clusterConfigVmOverrideService.hasMultipleValues(drsAutomationLevelEditable)) {
                drsAutomationLevelEditable = false;
            }
            return !this.isEditMode() || drsAutomationLevelEditable;
        };
        ConfigClusterVmOverridesController.prototype.isCustomMonitoringSensitivity = function () {
            return this.vmSettingsSpec.haVmMonitoringSensitivity ===
                this.haVmMonitoringService.getPresetLevels().CUSTOM;
        };
        ConfigClusterVmOverridesController.prototype.isRestartPriorityDisabled = function () {
            if (this.vmSettingsSpec.haRestartPriority ===
                this.haConstants.restartPriority.DISABLED) {
                return true;
            }
            // check if any of the edited overrides has a disabled value
            if (this.clusterConfigVmOverrideService.hasMultipleValues(this.vmSettingsSpec.haRestartPriority)) {
                var haRestartPriorityValues = this.getSelectedVmsHaProperties("haRestartPriority");
                if (this.clusterConfigVmOverrideService.containsValue(haRestartPriorityValues, this.haConstants.restartPriority.DISABLED)) {
                    return true;
                }
            }
            return false;
        };
        ConfigClusterVmOverridesController.prototype.isApdProtectionDisabled = function () {
            if (this.vmSettingsSpec.haApdProtection ===
                this.haConstants.storageVmReaction.DISABLED ||
                this.vmSettingsSpec.haApdProtection ===
                    this.haConstants.storageVmReaction.WARNING) {
                return true;
            }
            // check if any of the edited overrides has a disabled value
            if (this.clusterConfigVmOverrideService.hasMultipleValues(this.vmSettingsSpec.haApdProtection)) {
                var haApdProtectionValues = this.getSelectedVmsHaProperties("apdProtectionLevel");
                if (this.clusterConfigVmOverrideService.containsValue(haApdProtectionValues, this.haConstants.storageVmReaction.DISABLED) ||
                    this.clusterConfigVmOverrideService.containsValue(haApdProtectionValues, this.haConstants.storageVmReaction.WARNING)) {
                    return true;
                }
            }
            return false;
        };
        ConfigClusterVmOverridesController.prototype.isVmMonitoringSensitivityVisible = function () {
            if (this.vmSettingsSpec.haVmMonitoring ===
                this.haConstants.vmMonitoring.DISABLED) {
                return false;
            }
            // check if any of the edited overrides has a disabled value
            if (this.clusterConfigVmOverrideService.hasMultipleValues(this.vmSettingsSpec.haVmMonitoring)) {
                var haVmMonitoringValues = this.getSelectedVmsHaProperties("vmMonitoring");
                if (this.clusterConfigVmOverrideService.containsValue(haVmMonitoringValues, this.haConstants.vmMonitoring.DISABLED)) {
                    return false;
                }
            }
            return true;
        };
        ConfigClusterVmOverridesController.prototype.getDifferentSettingsVmsCount = function () {
            var numberOfTooltipParams = 0;
            _.each(this.tooltipParams, function (tooltipParam) {
                if (tooltipParam.isSettingVisible) {
                    numberOfTooltipParams++;
                }
            });
            return numberOfTooltipParams;
        };
        ConfigClusterVmOverridesController.prototype.normalizeOverrideValue = function (specKey, event, minValue, maxValue) {
            var value = event.target.value;
            if (!value || value < minValue) {
                this.vmSettingsSpec[specKey] = minValue;
            }
            if (value > maxValue) {
                this.vmSettingsSpec[specKey] = maxValue;
            }
        };
        ConfigClusterVmOverridesController.prototype.initDrsSettings = function () {
            this.drsAutomationLevels =
                this.clusterConfigVmOverrideService.getDrsAutomationLevels();
            var vmAutomationLevels = this.getSelectedVmsDrsProperties("drsAutomationLevel");
            var vmAutomationLevel = this.clusterConfigVmOverrideService.getUniqueValue(vmAutomationLevels);
            if (this.isEditMode() &&
                !this.clusterConfigVmOverrideService.isClusterDefault(vmAutomationLevel)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmAutomationLevel)) {
                    this.clusterConfigVmOverrideService
                        .addInitialValuesOption(this.drsAutomationLevels);
                    this.tooltipParams.drsAutomationLevelParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmAutomationLevels, this.drsAutomationLevels, this.clusterOverridesData.clusterDrsAutomationLevel);
                    this.tooltipParams.drsAutomationLevelParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.drsAutomationLevel = vmAutomationLevel;
                this.vmSettingsSpec.drsAutomationOverrideEnabled =
                    this.isDrsAutomationLevelEditable();
            }
            else {
                this.setDefaultDrsAutomationLevel();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaSettings = function () {
            this.initHaIsolationResponse();
            this.initHaRestartPriority();
            this.initHaRestartOrchestration();
            this.initHaRestartOrchestrationAdditionalDelay();
            this.initHaRestartPriorityTimeout();
            this.initHaPdlProtection();
            this.initHaApdProtection();
            this.initHaApdDelay();
            this.initHaApdVmRecovery();
            this.initHaVmMonitoring();
            this.initHaVmMonitoringSensitivity();
            this.initHaVmMonitoringFailureInterval();
            this.initHaMonitoringMinUpTime();
            this.initHaMonitoringMaxFailures();
            this.initHaMonitoringMaxFailuresWindow();
        };
        ConfigClusterVmOverridesController.prototype.initHaRestartPriority = function () {
            this.restartPriorityOptions = this.haHostFailureResponseService
                .getVmRestartPriorityOptions(this.is65VcOrLater);
            if (!this.isFtVm()) {
                this.restartPriorityOptions.disabled =
                    this.haHostFailureResponseService.getDisabledOption();
            }
            this.vmSettingsSpec.haRestartPriorityDisabled =
                !this.clusterOverridesData.haEnabled ||
                    this.clusterOverridesData.clusterVmRestartPriority ===
                        this.haConstants.restartPriority.DISABLED;
            var vmRestartPriorities = this.getSelectedVmsHaProperties("haRestartPriority");
            var vmRestartPriority = this.clusterConfigVmOverrideService.getUniqueValue(vmRestartPriorities);
            if (this.isEditMode() && !this.clusterConfigVmOverrideService
                .isClusterDefault(vmRestartPriority)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmRestartPriority)) {
                    this.restartPriorityOptions.useInitialValues = {
                        id: this.clusterVmOverridesConstants.INITIAL_VALUES,
                        label: this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues")
                    };
                    this.tooltipParams.haRestartPriorityParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmRestartPriorities, _.values(this.restartPriorityOptions), this.clusterOverridesData.clusterVmRestartPriority);
                    this.tooltipParams.haRestartPriorityParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haRestartPriority = vmRestartPriority;
                this.vmSettingsSpec.haRestartPriorityEnabled = true;
            }
            else {
                this.vmSettingsSpec.haRestartPriority =
                    this.clusterOverridesData.clusterVmRestartPriority;
                this.vmSettingsSpec.haRestartOrchestrationEnabled = false;
            }
        };
        ConfigClusterVmOverridesController.prototype.setOrchestrationArrayOperationsPerVM = function () {
            var _this = this;
            _.each(this.selectedVms, function (vm) {
                var vmOrchestrationInfo = _this.findOrchestrationInfoForVm(vm);
                _.isUndefined(vmOrchestrationInfo) ?
                    vm.arrayOperation = _this.clusterVmOverridesConstants.operationType.ADD :
                    vm.arrayOperation = _this.clusterVmOverridesConstants.operationType.EDIT;
            });
        };
        ConfigClusterVmOverridesController.prototype.findOrchestrationInfoForVm = function (vm) {
            var defaultUriSchemeUtilService = this.defaultUriSchemeUtil;
            return _.find(this.clusterOverridesData.vmOrchestrationCondition, function (vmOrchestrationCondition) {
                var vmId;
                if (vm.vm.provider) {
                    var vmMor = {
                        type: vm.vm.provider.type,
                        value: vm.vm.provider.value,
                        serverGuid: vm.vm.provider.serverGuid
                    };
                    vmId = defaultUriSchemeUtilService.getVsphereObjectId(vmMor);
                }
                else {
                    vmId = vm.id;
                }
                return defaultUriSchemeUtilService
                    .getVsphereObjectId(vmOrchestrationCondition.vm) === vmId;
            });
        };
        ConfigClusterVmOverridesController.prototype.initHaIsolationResponse = function () {
            if (this.isFtVm()) {
                this.isolationResponseOptions =
                    this.haHostIsolationResponseService.getEnsureFtResponse();
                this.vmSettingsSpec.haIsolationResponse = "EnsureFT";
            }
            else {
                this.isolationResponseOptions =
                    this.haHostIsolationResponseService.getResponses();
                this.vmSettingsSpec.haIsolationResponseDisabled =
                    !this.clusterOverridesData.haEnabled ||
                        this.clusterOverridesData.clusterIsolationResponse ===
                            this.haConstants.hostIsolationResponse.LEAVE_POWERED_ON;
                var vmIsolationResponses = this.getSelectedVmsHaProperties("haIsolationResponse");
                var vmIsolationResponse = this.clusterConfigVmOverrideService.getUniqueValue(vmIsolationResponses);
                if (this.isEditMode() && !this.clusterConfigVmOverrideService.isClusterDefault(vmIsolationResponse)) {
                    if (this.clusterConfigVmOverrideService.hasMultipleValues(vmIsolationResponse)) {
                        this.clusterConfigVmOverrideService
                            .addInitialValuesOption(this.isolationResponseOptions);
                        this.tooltipParams.haIsolationResponseParams =
                            this.clusterConfigVmOverrideService.getTooltipParams(vmIsolationResponses, this.isolationResponseOptions, this.clusterOverridesData.clusterIsolationResponse);
                        this.tooltipParams.haIsolationResponseParams.isSettingVisible = true;
                    }
                    this.vmSettingsSpec.haIsolationResponse = vmIsolationResponse;
                    this.vmSettingsSpec.haIsolationResponseEnabled = !this.isFtVm();
                }
                else {
                    this.setDefaultHaIsolationResponse();
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaRestartOrchestration = function () {
            if (this.is65VcOrLater) {
                // restart orchestration dropdown options
                this.restartOrchestrationOptions = this.haHostFailureResponseService.getVmOrchestrationReadyConditions();
                this.vmSettingsSpec.haRestartOrchestrationDisabled =
                    !this.clusterOverridesData.haEnabled ||
                        this.clusterOverridesData.clusterVmRestartPriority ===
                            this.haConstants.restartPriority.DISABLED;
                var vmOrchestrationConditions = this.getSelectedVmsOrchestrationReadyConditions();
                var vmOrchestrationReadyCondition = this.clusterConfigVmOverrideService.getUniqueValue(vmOrchestrationConditions);
                this.setOrchestrationArrayOperationsPerVM();
                if (_.isUndefined(this.vmSettingsSpec.restartOrchestration)) {
                    this.vmSettingsSpec.restartOrchestration = {};
                }
                if (this.isEditMode() && !this.clusterConfigVmOverrideService
                    .isClusterDefault(vmOrchestrationReadyCondition)) {
                    if (this.clusterConfigVmOverrideService.hasMultipleValues(vmOrchestrationReadyCondition)) {
                        this.restartOrchestrationOptions.useInitialValues = {
                            id: this.clusterVmOverridesConstants.INITIAL_VALUES,
                            label: this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues")
                        };
                        this.tooltipParams.haRestartOrchestrationParams =
                            this.clusterConfigVmOverrideService.getTooltipParams(vmOrchestrationConditions, _.values(this.restartOrchestrationOptions), this.clusterOverridesData.defaultVmReadiness.readyCondition);
                        this.tooltipParams.haRestartOrchestrationParams.isSettingVisible = this.is65VcOrLater;
                    }
                    this.vmSettingsSpec.restartOrchestration.readyCondition =
                        vmOrchestrationReadyCondition;
                    this.vmSettingsSpec.haRestartOrchestrationEnabled = true;
                }
                else {
                    this.vmSettingsSpec.restartOrchestration.readyCondition =
                        this.clusterOverridesData.defaultVmReadiness.readyCondition;
                    this.vmSettingsSpec.haRestartOrchestrationEnabled = false;
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaRestartOrchestrationAdditionalDelay = function () {
            if (this.is65VcOrLater) {
                if (_.isUndefined(this.vmSettingsSpec.restartOrchestration)) {
                    this.vmSettingsSpec.restartOrchestration = {};
                }
                // restart orchestration additional delay value
                this.vmSettingsSpec.haRestartOrchestrationAdditionalDelayDisabled =
                    !this.clusterOverridesData.haEnabled ||
                        this.clusterOverridesData.clusterVmRestartPriority ===
                            this.haConstants.restartPriority.DISABLED;
                var vmOrchestrationPostReadyDelays = this.getSelectedVmsOrchestrationPostReadyDelays();
                var vmOrchestrationPostReadyDelay = this.clusterConfigVmOverrideService.getUniqueValue(vmOrchestrationPostReadyDelays);
                this.setOrchestrationArrayOperationsPerVM();
                if (this.isEditMode() &&
                    !this.clusterConfigVmOverrideService
                        .isClusterDefault(vmOrchestrationPostReadyDelay) &&
                    vmOrchestrationPostReadyDelay !== this.clusterOverridesData.
                        defaultVmReadiness.postReadyDelay) {
                    // if in edit mode and not cluster default
                    if (this.clusterConfigVmOverrideService.hasMultipleValues(vmOrchestrationPostReadyDelay)) {
                        vmOrchestrationPostReadyDelay = this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues");
                        this.haAdditionalDelayMultipleOptions = {
                            recommendedValues: [{
                                    value: vmOrchestrationPostReadyDelay
                                }]
                        };
                        this.tooltipParams.haRestartOrchestrationAdditionalDelayParams =
                            this.clusterConfigVmOverrideService
                                .getValuesInSecondsTooltipParams(vmOrchestrationPostReadyDelays, this.clusterOverridesData.defaultVmReadiness.postReadyDelay);
                        this.tooltipParams.haRestartOrchestrationAdditionalDelayParams.isSettingVisible =
                            this.is65VcOrLater;
                    }
                    this.vmSettingsSpec.restartOrchestration.postReadyDelay =
                        vmOrchestrationPostReadyDelay;
                    this.vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled = true;
                }
                else {
                    this.vmSettingsSpec.restartOrchestration.postReadyDelay =
                        this.clusterOverridesData.defaultVmReadiness.postReadyDelay;
                    this.vmSettingsSpec.haRestartOrchestrationAdditionalDelayEnabled = false;
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaRestartPriorityTimeout = function () {
            if (this.is65VcOrLater) {
                this.vmSettingsSpec.haRestartPriorityTimeoutDisabled =
                    !this.clusterOverridesData.haEnabled ||
                        this.clusterOverridesData.clusterVmRestartPriority ===
                            this.haConstants.restartPriority.DISABLED;
                var vmRestartPriorityTimeouts = _.map(this.getSelectedVmsHaProperties("haRestartPriorityTimeout"), function (timeout) {
                    return {
                        vm: timeout.vm,
                        value: timeout.value ?
                            parseInt(timeout.value.split("\s")[0]) :
                            timeout.value
                    };
                });
                var vmRestartPriorityTimeout = this.clusterConfigVmOverrideService.getUniqueValue(vmRestartPriorityTimeouts);
                if (this.isEditMode() &&
                    vmRestartPriorityTimeout !== -1 &&
                    vmRestartPriorityTimeout !== this.clusterOverridesData.clusterVmRestartPriorityTimeout) {
                    // if in edit mode and not cluster default
                    if (this.clusterConfigVmOverrideService.hasMultipleValues(vmRestartPriorityTimeout)) {
                        vmRestartPriorityTimeout = this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues");
                        this.haRestartPriorityMultipleOptions = {
                            recommendedValues: [{
                                    value: vmRestartPriorityTimeout
                                }]
                        };
                        this.tooltipParams.haRestartPriorityTimeoutParams =
                            this.clusterConfigVmOverrideService
                                .getValuesInSecondsTooltipParams(vmRestartPriorityTimeouts, this.clusterOverridesData.clusterVmRestartPriorityTimeout);
                        this.tooltipParams.haRestartPriorityTimeoutParams.isSettingVisible =
                            this.is65VcOrLater;
                    }
                    this.vmSettingsSpec.haRestartPriorityTimeout =
                        vmRestartPriorityTimeout;
                    this.vmSettingsSpec.haRestartPriorityTimeoutEnabled = true;
                }
                else {
                    this.vmSettingsSpec.haRestartPriorityTimeout =
                        this.clusterOverridesData.clusterVmRestartPriorityTimeout;
                    this.vmSettingsSpec.haRestartPriorityTimeoutEnabled = false;
                }
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaPdlProtection = function () {
            this.pdlProtectionOptions =
                this.haPdlResponseService.getResponses();
            this.vmSettingsSpec.haPdlProtectionDisabled =
                !this.clusterOverridesData.haEnabled ||
                    this.clusterOverridesData.vmcpSettings.pdlResponse ===
                        this.haConstants.storageVmReaction.DISABLED;
            this.pdlTooltipParams = {
                message: this.i18nService.getString("ClusterUi", "vm.overrides.HA.pdlProtectionLevel.hint"),
                title: this.i18nService.getString("Common", "help")
            };
            var vmPdlProtectionValues = this.getSelectedVmsHaProperties("pdlProtectionLevel");
            var vmPdlProtection = this.clusterConfigVmOverrideService.getUniqueValue(vmPdlProtectionValues);
            if (this.isEditMode() &&
                !this.clusterConfigVmOverrideService.isClusterDefault(vmPdlProtection)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmPdlProtection)) {
                    this.clusterConfigVmOverrideService
                        .addInitialValuesOption(this.pdlProtectionOptions);
                    this.tooltipParams.haPdlProtectionParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmPdlProtectionValues, this.pdlProtectionOptions, this.clusterOverridesData.vmcpSettings.pdlResponse);
                    this.tooltipParams.haPdlProtectionParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haPdlProtection = vmPdlProtection;
                this.vmSettingsSpec.haPdlProtectionEnabled =
                    this.isVmcpSupportedForVm();
            }
            else {
                this.setDefaultHaPdlProtection();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaApdProtection = function () {
            this.apdProtectionOptions =
                this.haApdResponseService.getResponses();
            this.vmSettingsSpec.haApdProtectionDisabled =
                !this.clusterOverridesData.haEnabled ||
                    this.clusterOverridesData.vmcpSettings.apdResponse ===
                        this.haConstants.storageVmReaction.DISABLED;
            this.apdTooltipParams = {
                message: this.i18nService.getString("ClusterUi", "vm.overrides.HA.apdProtectionLevel.hint"),
                title: this.i18nService.getString("Common", "help")
            };
            var vmApdProtectionValues = this.getSelectedVmsHaProperties("apdProtectionLevel");
            var vmApdProtection = this.clusterConfigVmOverrideService.getUniqueValue(vmApdProtectionValues);
            if (this.isEditMode() &&
                !this.clusterConfigVmOverrideService.isClusterDefault(vmApdProtection)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmApdProtection)) {
                    this.clusterConfigVmOverrideService
                        .addInitialValuesOption(this.apdProtectionOptions);
                    this.tooltipParams.haApdProtectionParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmApdProtectionValues, this.apdProtectionOptions, this.clusterOverridesData.vmcpSettings.apdResponse);
                    this.tooltipParams.haApdProtectionParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haApdProtection = vmApdProtection;
                this.vmSettingsSpec.haApdProtectionEnabled =
                    this.isVmcpSupportedForVm();
            }
            else {
                this.setDefaultHaApdProtection();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaApdVmRecovery = function () {
            this.apdVmRecoveryOptions =
                this.haVmReactionsOnApdClearedService.getReactions();
            var vmRemediationOnApdRecoverValues = this.getSelectedVmsHaProperties("vmRemediationOnApdRecover");
            var vmRemediationOnApdRecover = this.clusterConfigVmOverrideService.getUniqueValue(vmRemediationOnApdRecoverValues);
            if (this.isEditMode() && !this.clusterConfigVmOverrideService.isClusterDefault(vmRemediationOnApdRecover)) {
                if (this.clusterConfigVmOverrideService
                    .hasMultipleValues(vmRemediationOnApdRecover)) {
                    this.clusterConfigVmOverrideService
                        .addInitialValuesOption(this.apdVmRecoveryOptions);
                    this.tooltipParams.haApdVmRecoveryParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmRemediationOnApdRecoverValues, this.apdVmRecoveryOptions, this.clusterOverridesData.vmcpSettings.vmReactionOnAPDCleared);
                    this.tooltipParams.haApdVmRecoveryParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haApdVmRecovery = vmRemediationOnApdRecover;
                this.vmSettingsSpec.haApdVmRecoveryEnabled =
                    this.isVmcpSupportedForVm();
            }
            else {
                this.setDefaultHaApdVmRecovery();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaApdDelay = function () {
            var isApdDelayDefaultValues = this.getSelectedVmsHaProperties("usesDefaultIntervalBeforeVmcpReaction");
            var isApdDelayDefault = this.clusterConfigVmOverrideService.getUniqueValue(isApdDelayDefaultValues);
            if (this.clusterConfigVmOverrideService.hasMultipleValues(isApdDelayDefault)) {
                // consider the override checkbox checked if there is an override for at least one vm
                isApdDelayDefault = false;
            }
            if (this.isEditMode() && !isApdDelayDefault) {
                var vmHaApdDelayValues = this.getSelectedVmsHaProperties("intervalBeforeVmcpReaction");
                var vmHaApdDelay = this.clusterConfigVmOverrideService.getUniqueValue(vmHaApdDelayValues);
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmHaApdDelay)) {
                    vmHaApdDelay = this.i18nService.getString("ClusterUi", "vm.overrides.config.editMultiple.useInitialValues");
                    this.apdDelayMultipleValuesOptions = {
                        recommendedValues: [{
                                value: vmHaApdDelay
                            }]
                    };
                    this.tooltipParams.haApdDelayParams =
                        this.clusterConfigVmOverrideService.getApdDelayTooltipParams(isApdDelayDefaultValues, vmHaApdDelayValues, this.getApdDelayClusterDefault());
                    this.tooltipParams.haApdDelayParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haApdDelay = vmHaApdDelay;
                this.vmSettingsSpec.haApdDelayEnabled = this.isVmcpSupportedForVm();
            }
            else {
                this.setDefaultHaApdDelay();
            }
        };
        ConfigClusterVmOverridesController.prototype.getApdDelayClusterDefault = function () {
            return this.clusterOverridesData.vmcpSettings.vmTerminateDelayForAPDSec /
                this.haConstants.SECONDS_IN_A_MINUTE;
        };
        ConfigClusterVmOverridesController.prototype.initHaVmMonitoring = function () {
            this.vmMonitoringOptions =
                this.haVmMonitoringService.getVmOverrideMonitoringLevels(this.clusterOverridesData.vmMonitoring);
            var vmMonitoringValues = this.getSelectedVmsHaProperties("vmMonitoring");
            var vmMonitoring = this.clusterConfigVmOverrideService.getUniqueValue(vmMonitoringValues);
            if (this.isEditMode() && !this.clusterConfigVmOverrideService.isClusterDefault(vmMonitoring)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(vmMonitoring)) {
                    this.clusterConfigVmOverrideService
                        .addInitialValuesOption(this.vmMonitoringOptions);
                    this.tooltipParams.haVmMonitoringParams =
                        this.clusterConfigVmOverrideService.getTooltipParams(vmMonitoringValues, this.vmMonitoringOptions, this.clusterOverridesData.vmMonitoring);
                    this.tooltipParams.haVmMonitoringParams.isSettingVisible = true;
                }
                this.vmSettingsSpec.haVmMonitoringEnabled = true;
                this.vmSettingsSpec.haVmMonitoring = vmMonitoring;
            }
            else {
                this.setDefaultHaVmMonitoring();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaVmMonitoringSensitivity = function () {
            this.vmMonitoringSensitivityOptions =
                this.haVmMonitoringService.getMonitoringSensitivityLevels();
            var vmMonitoringSensitivityValues = this.getSelectedVmsHaProperties("vmMonitoringSensitivity");
            var vmMonitoringSensitivity = this.clusterConfigVmOverrideService
                .getUniqueValue(vmMonitoringSensitivityValues);
            if (this.isEditMode() && !this.clusterConfigVmOverrideService.isClusterDefault(vmMonitoringSensitivity)) {
                if (this.clusterConfigVmOverrideService
                    .hasMultipleValues(vmMonitoringSensitivity)) {
                    this.setMultipleVmMonitoringSensitivityParams(vmMonitoringSensitivityValues, vmMonitoringSensitivity);
                }
                else {
                    this.vmSettingsSpec.haVmMonitoringSensitivity =
                        parseInt(vmMonitoringSensitivity, 10);
                }
            }
            else {
                this.setDefaultHaVmMonitoringSensitivity();
            }
        };
        ConfigClusterVmOverridesController.prototype.handleMultipleVmMonitoringSensitivityValues = function () {
            if (!this.tooltipParams.haVmMonitoringSensitivityParams) {
                var vmMonitoringSensitivityValues = this.getSelectedVmsHaProperties("vmMonitoringSensitivity");
                var vmMonitoringSensitivity = this.clusterVmOverridesConstants.INITIAL_VALUES;
                this.setMultipleVmMonitoringSensitivityParams(vmMonitoringSensitivityValues, vmMonitoringSensitivity);
            }
        };
        ConfigClusterVmOverridesController.prototype.setMultipleVmMonitoringSensitivityParams = function (vmMonitoringSensitivityValues, vmMonitoringSensitivity) {
            this.clusterConfigVmOverrideService
                .addInitialValuesOption(this.vmMonitoringSensitivityOptions);
            this.tooltipParams.haVmMonitoringSensitivityParams =
                this.clusterConfigVmOverrideService.getTooltipParams(vmMonitoringSensitivityValues, this.vmMonitoringSensitivityOptions, this.getDefaultHaVmMonitoringSensitivity());
            this.tooltipParams.haVmMonitoringSensitivityParams.isSettingVisible =
                this.isVmMonitoringSensitivityVisible();
            this.vmSettingsSpec.haVmMonitoringSensitivity = vmMonitoringSensitivity;
        };
        ConfigClusterVmOverridesController.prototype.initHaVmMonitoringFailureInterval = function () {
            var failureIntervals = this.getSelectedVmsHaProperties("vmFailureIntervalValue");
            var failureInterval = this.clusterConfigVmOverrideService.getUniqueValue(failureIntervals);
            if (this.isEditMode() && !_.isNull(failureInterval)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(failureInterval)) {
                    // set vm monitoring sensitivity to "Initial values"
                    this.handleMultipleVmMonitoringSensitivityValues();
                    this.setDefaultHaVmMonitoringFailureInterval();
                }
                else {
                    this.vmSettingsSpec.vmToolsMonitorFailureInt = failureInterval;
                }
            }
            else {
                this.setDefaultHaVmMonitoringFailureInterval();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaMonitoringMinUpTime = function () {
            var minUpTimeValues = this.getSelectedVmsHaProperties("vmMinUptimeValue");
            var minUpTime = this.clusterConfigVmOverrideService.getUniqueValue(minUpTimeValues);
            if (this.isEditMode() && !_.isNull(minUpTime)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(minUpTime)) {
                    // set vm monitoring sensitivity to "Initial values"
                    this.handleMultipleVmMonitoringSensitivityValues();
                    this.setDefaultHaVmMonitoringMinUpTime();
                }
                else {
                    this.vmSettingsSpec.vmToolsMonitorMinUpTime = minUpTime;
                }
            }
            else {
                this.setDefaultHaVmMonitoringMinUpTime();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaMonitoringMaxFailures = function () {
            var maxFailuresValues = this.getSelectedVmsHaProperties("vmMaxFailuresValue");
            var maxFailures = this.clusterConfigVmOverrideService.getUniqueValue(maxFailuresValues);
            if (this.isEditMode() && !_.isNull(maxFailures)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(maxFailures)) {
                    // set vm monitoring sensitivity to "Initial values"
                    this.handleMultipleVmMonitoringSensitivityValues();
                    this.setDefaultHaVmMonitoringMaxFailures();
                }
                else {
                    this.vmSettingsSpec.vmToolsMonitorMaxFailures = maxFailures;
                }
            }
            else {
                this.setDefaultHaVmMonitoringMaxFailures();
            }
        };
        ConfigClusterVmOverridesController.prototype.initHaMonitoringMaxFailuresWindow = function () {
            var maxFailureWindowValues = this.getSelectedVmsHaProperties("vmMaxFailureWindowValue");
            var maxFailureWindow = this.clusterConfigVmOverrideService.getUniqueValue(maxFailureWindowValues);
            if (this.isEditMode() && !_.isNull(maxFailureWindow)) {
                if (this.clusterConfigVmOverrideService.hasMultipleValues(maxFailureWindow)) {
                    // set vm monitoring sensitivity to "Initial values"
                    this.handleMultipleVmMonitoringSensitivityValues();
                    this.setDefaultHaVmMonitoringMaxFailuresWindow();
                }
                else {
                    if (maxFailureWindow !==
                        this.haConstants.vmMonitoringSensitivity.NO_FAILURE_WINDOW) {
                        this.vmSettingsSpec.vmToolsMonitorHasFailureWindow = true;
                        this.vmSettingsSpec.vmToolsMonitorMaxFailureWindow =
                            maxFailureWindow / 3600;
                    }
                    else {
                        this.vmSettingsSpec.vmToolsMonitorHasFailureWindow = false;
                        this.vmSettingsSpec.vmToolsMonitorMaxFailureWindow = 1;
                    }
                }
            }
            else {
                this.setDefaultHaVmMonitoringMaxFailuresWindow();
            }
        };
        ConfigClusterVmOverridesController.prototype.setDefaultDrsAutomationLevel = function () {
            this.vmSettingsSpec.drsAutomationLevel =
                this.clusterOverridesData.clusterDrsAutomationLevel;
            this.vmSettingsSpec.drsAutomationOverrideEnabled = false;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaIsolationResponse = function () {
            this.vmSettingsSpec.haIsolationResponseEnabled = false;
            this.vmSettingsSpec.haIsolationResponse =
                this.clusterOverridesData.clusterIsolationResponse;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaPdlProtection = function () {
            this.vmSettingsSpec.haPdlProtectionEnabled = false;
            this.vmSettingsSpec.haPdlProtection =
                this.clusterOverridesData.vmcpSettings.pdlResponse;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaApdProtection = function () {
            this.vmSettingsSpec.haApdProtectionEnabled = false;
            this.vmSettingsSpec.haApdProtection =
                this.clusterOverridesData.vmcpSettings.apdResponse;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaApdDelay = function () {
            this.vmSettingsSpec.haApdDelayEnabled = false;
            this.updateApdDelayValue();
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaApdVmRecovery = function () {
            this.vmSettingsSpec.haApdVmRecoveryEnabled = false;
            this.updateApdVmRecoveryValue();
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoring = function () {
            this.vmSettingsSpec.haVmMonitoringEnabled = false;
            this.vmSettingsSpec.haVmMonitoring =
                this.clusterOverridesData.vmMonitoring;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoringSensitivity = function () {
            this.vmSettingsSpec.haVmMonitoringSensitivity =
                this.getDefaultHaVmMonitoringSensitivity();
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoringFailureInterval = function () {
            this.vmSettingsSpec.vmToolsMonitorFailureInt =
                this.clusterOverridesData.vmToolsMonitorFailureInt;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoringMinUpTime = function () {
            this.vmSettingsSpec.vmToolsMonitorMinUpTime =
                this.clusterOverridesData.vmToolsMonitorMinUpTime;
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoringMaxFailures = function () {
            this.vmSettingsSpec.vmToolsMonitorMaxFailures =
                this.clusterOverridesData.vmToolsMonitorMaxFailures;
        };
        ConfigClusterVmOverridesController.prototype.getDefaultHaVmMonitoringSensitivity = function () {
            var hasFailureWindow = this.clusterOverridesData.vmToolsMonitorMaxFailureWindow !==
                this.haConstants.vmMonitoringSensitivity.NO_FAILURE_WINDOW;
            var vmMonitoringSettings = angular.merge({}, this.clusterOverridesData, {
                vmToolsMonitorHasFailureWindow: hasFailureWindow,
                vmToolsMonitorMaxFailureWindow: this.clusterOverridesData.vmToolsMonitorMaxFailureWindow / 3600
            });
            return this.haVmMonitoringService.getHaMonitoringSensitivityLevel(vmMonitoringSettings);
        };
        ConfigClusterVmOverridesController.prototype.setDefaultHaVmMonitoringMaxFailuresWindow = function () {
            var clusterMaxFailuresWindow = this.clusterOverridesData.vmToolsMonitorMaxFailureWindow;
            if (clusterMaxFailuresWindow !==
                this.haConstants.vmMonitoringSensitivity.NO_FAILURE_WINDOW) {
                this.vmSettingsSpec.vmToolsMonitorHasFailureWindow = true;
                this.vmSettingsSpec.vmToolsMonitorMaxFailureWindow =
                    this.clusterOverridesData.vmToolsMonitorMaxFailureWindow / 3600;
            }
            else {
                this.vmSettingsSpec.vmToolsMonitorHasFailureWindow = false;
                this.vmSettingsSpec.vmToolsMonitorMaxFailureWindow = 1;
            }
        };
        ConfigClusterVmOverridesController.prototype.getSelectedVmsHaProperties = function (propertyName) {
            return this.getSelectedVmsProperties("haOverrides", propertyName);
        };
        ConfigClusterVmOverridesController.prototype.getSelectedVmsDrsProperties = function (propertyName) {
            return this.getSelectedVmsProperties("drsOverrides", propertyName);
        };
        ConfigClusterVmOverridesController.prototype.getSelectedVmsProperties = function (propertyType, propertyName) {
            if (this.hasSelectedVm() &&
                angular.isDefined(this.selectedVms[0][propertyType])) {
                return _.map(this.selectedVms, function (vm) {
                    return {
                        vm: vm.vm,
                        value: vm[propertyType][propertyName]
                    };
                });
            }
            return null;
        };
        ConfigClusterVmOverridesController.prototype.isEditMode = function () {
            return this.vmSettingsSpec.mode ===
                this.clusterVmOverridesConstants.operationType.EDIT;
        };
        ConfigClusterVmOverridesController.prototype.setPageBusy = function (isBusy) {
            this.loading = isBusy;
        };
        ConfigClusterVmOverridesController.prototype.getSelectedVmsOrchestrationReadyConditions = function () {
            var _this = this;
            if (this.hasSelectedVm()) {
                var result = _.map(this.selectedVms, function (vm) {
                    var vmOrchestrationInfo = _this.findOrchestrationInfoForVm(vm);
                    return {
                        vm: {
                            name: vm.vm.name
                        },
                        value: (_.isUndefined(vmOrchestrationInfo) ||
                            vmOrchestrationInfo.vmReadiness.readyCondition === "useClusterDefault") ?
                            _this.clusterVmOverridesConstants.CLUSTER_DEFAULT :
                            vmOrchestrationInfo.vmReadiness.readyCondition
                    };
                });
                return result;
            }
            return [];
        };
        ConfigClusterVmOverridesController.prototype.getSelectedVmsOrchestrationPostReadyDelays = function () {
            var _this = this;
            if (this.hasSelectedVm()) {
                var result = _.map(this.selectedVms, function (vm) {
                    var vmOrchestrationInfo = _this.findOrchestrationInfoForVm(vm);
                    return {
                        vm: {
                            name: vm.vm.name
                        },
                        value: (_.isUndefined(vmOrchestrationInfo) ||
                            vmOrchestrationInfo.vmReadiness.postReadyDelay === -1 ||
                            _.isUndefined(vmOrchestrationInfo.vmReadiness.postReadyDelay)) ?
                            _this.clusterVmOverridesConstants.CLUSTER_DEFAULT :
                            vmOrchestrationInfo.vmReadiness.postReadyDelay
                    };
                });
                return result;
            }
            return [];
        };
        ConfigClusterVmOverridesController.$inject = ["dataService", "i18nService", "clusterConfigVmOverrideService",
            "drsAutomationLevelService", "vcService", "haConstants",
            "haHostFailureResponseService", "haHostIsolationResponseService",
            "haPdlResponseService", "haApdResponseService",
            "haVmReactionsOnApdClearedService", "clusterVmOverridesConstants",
            "clusterConstants", "haVmMonitoringService", "defaultUriSchemeUtil", "$q"];
        return ConfigClusterVmOverridesController;
    }());
    var ConfigClusterVmOverridesComponent = (function () {
        function ConfigClusterVmOverridesComponent() {
            this.controller = ConfigClusterVmOverridesController;
            this.templateUrl =
                "cluster-ui/resources/cluster/views/settings/configuration/overrides/" +
                    "configClusterVmOverridesComponent.html";
            this.bindings = {
                spec: "<",
                selectedVms: "<"
            };
        }
        return ConfigClusterVmOverridesComponent;
    }());
    angular.module("com.vmware.vsphere.client.cluster").component("configClusterVmOverridesComponent", new ConfigClusterVmOverridesComponent());
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ConfigVmOverrideDialogController = (function () {
        function ConfigVmOverrideDialogController($scope, i18nService, vuiConstants, clusterVmOverridesPageService, clusterVmOverridesConstants, defaultUriSchemeUtil) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.clusterVmOverridesPageService = clusterVmOverridesPageService;
            this.clusterVmOverridesConstants = clusterVmOverridesConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.objectId = $scope.modalOptions.dialogData.objectId;
            var editedOverrides = $scope.modalOptions.dialogData.selectedOverrides;
            var mode = clusterVmOverridesConstants.operationType.EDIT;
            this.selectedVmsSpec = {
                objectId: this.objectId,
                vms: []
            };
            this.selectedVmsSpec.vms = editedOverrides;
            this.vmSettingsSpec = {
                objectId: this.objectId,
                mode: mode
            };
            $scope.modalOptions.onSubmit = function () { return _this.onCommit(); };
        }
        ConfigVmOverrideDialogController.prototype.onCommit = function () {
            if (this.validate()) {
                var vms = _.map(this.selectedVmsSpec.vms, function (vmRow) {
                    var vmKey = angular.extend({}, vmRow.vm.provider, {
                        _type: "com.vmware.vim.binding.vmodl.ManagedObjectReference"
                    });
                    return {
                        skipFromOrchestrationSpec: vmRow.skipFromOrchestrationSpec,
                        arrayOperation: vmRow.arrayOperation,
                        key: vmKey,
                        haOverrides: vmRow.haOverrides,
                        drsOverrides: vmRow.drsOverrides
                    };
                });
                this.clusterVmOverridesPageService.applyOverrides(this.objectId, vms, this.vmSettingsSpec);
                return true;
            }
            return false;
        };
        ConfigVmOverrideDialogController.prototype.validate = function () {
            this.$scope.modalOptions.alerts = [];
            this.$scope.modalOptions.isAlertClosed = true;
            if (!this.clusterVmOverridesPageService.hasOverrides(this.vmSettingsSpec) &&
                this.vmSettingsSpec.mode !== this.clusterVmOverridesConstants.operationType.EDIT) {
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("ClusterUi", "vm.overrides.config.noChangesValidationError"),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
                return false;
            }
            return true;
        };
        ConfigVmOverrideDialogController.$inject = ["$scope", "i18nService", "vuiConstants",
            "clusterVmOverridesPageService", "clusterVmOverridesConstants",
            "defaultUriSchemeUtil"];
        return ConfigVmOverrideDialogController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ConfigVmOverrideDialogController", ConfigVmOverrideDialogController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var OverrideOptionsComboboxController = (function () {
        function OverrideOptionsComboboxController($scope, $element, $document, vxValueInUnitsService) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.$document = $document;
            this.vxValueInUnitsService = vxValueInUnitsService;
            $scope.$watch("$ctrl.recommendedValues", function () {
                _this.highlightValue();
            });
        }
        OverrideOptionsComboboxController.prototype.$onInit = function () {
            this.ngModelController.$render = this.modelValueChanged.bind(this);
        };
        OverrideOptionsComboboxController.prototype.$postLink = function () {
            this.installDocumentClickEvent();
        };
        OverrideOptionsComboboxController.prototype.updateModelFromField = function () {
            this.ngModelController.$setViewValue(this.value);
        };
        OverrideOptionsComboboxController.prototype.onBlurValueChanged = function () {
            if (this.valueChangedCallback &&
                (typeof this.valueChangedCallback === "function")) {
                this.valueChangedCallback({ value: this.value });
            }
        };
        OverrideOptionsComboboxController.prototype.setModelValue = function (value) {
            this.ngModelController.$setViewValue(value);
            this.modelValueChanged();
            this.highlightValue();
        };
        OverrideOptionsComboboxController.prototype.clickDropdownButton = function () {
            this.recommendedValuesExpanded = !this.recommendedValuesExpanded;
            this.vxValueInUnitsService.onRecommendedValuesExpandedChange(this.$element);
        };
        OverrideOptionsComboboxController.prototype.modelValueChanged = function () {
            this.value = this.ngModelController.$viewValue;
        };
        OverrideOptionsComboboxController.prototype.installDocumentClickEvent = function () {
            var _this = this;
            var dismissDropdown = function (e) {
                // close recommended values dropdown when clicking outside the current element
                if ((_this.$element !== e.target && !_this.$element[0].contains(e.target))) {
                    _this.$scope.$apply(function () {
                        _this.recommendedValuesExpanded = false;
                    });
                }
            };
            this.$document.on("click", dismissDropdown);
            this.$scope.$on("$destroy", function () {
                _this.$document.off("click", dismissDropdown);
            });
        };
        OverrideOptionsComboboxController.prototype.highlightValue = function () {
            var _this = this;
            var itemHighlighted = false;
            _.each(this.recommendedValues, function (recommendation) {
                if (recommendation.value === _this.ngModelController.$viewValue
                    && !itemHighlighted) {
                    recommendation.isHighlighted = true;
                    itemHighlighted = true;
                }
                else {
                    recommendation.isHighlighted = false;
                }
            });
        };
        OverrideOptionsComboboxController.$inject = ["$scope", "$element", "$document", "vxValueInUnitsService"];
        return OverrideOptionsComboboxController;
    }());
    var OverrideOptionsComboboxComponent = (function () {
        function OverrideOptionsComboboxComponent() {
            this.controller = OverrideOptionsComboboxController;
            this.templateUrl =
                "cluster-ui/resources/cluster/views/settings/configuration/overrides/" +
                    "overrideOptionsCombobox.html";
            this.bindings = {
                valueChangedCallback: "&",
                isDisabled: "<",
                recommendedValues: "<"
            };
            this.require = {
                ngModelController: "ngModel"
            };
        }
        return OverrideOptionsComboboxComponent;
    }());
    angular.module("com.vmware.vsphere.client.cluster").component("overrideOptionsCombobox", new OverrideOptionsComboboxComponent());
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var SelectClusterVmOverrideMemberController = (function () {
        function SelectClusterVmOverrideMemberController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            var clusterId = $scope.manager.getClusterId();
            var selectedVms = $scope.manager.getSelectedVms();
            var selectorConfig = {
                objectType: "VirtualMachine",
                listViewId: "vsphere.core.vm.list"
            };
            var filter = "clusterVmsExceptOverriddenVmsFilter";
            this.config = {
                contextObject: clusterId,
                multipleSelect: true,
                listTabConfig: {
                    listConfig: [{
                            label: i18nService.getString("Common", "typeResource.vmPlural"),
                            listViewId: selectorConfig.listViewId,
                            dataModels: [selectorConfig.objectType],
                            filterId: filter
                        }]
                },
                selectedObjects: _.map(selectedVms, function (vm) {
                    return vm.id;
                }),
                onSelectionChanged: function (newSelectedItems) {
                    $scope.manager.setSelectedVms(newSelectedItems);
                }
            };
        }
        SelectClusterVmOverrideMemberController.prototype.$onInit = function () {
            setTimeout(function () {
                $("div.cluster-add-vm-override-member-container [vx-object-selector] div.filter-input input").focus();
            }, 200);
        };
        SelectClusterVmOverrideMemberController.$inject = ["$scope", "i18nService"];
        return SelectClusterVmOverrideMemberController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("SelectClusterVmOverrideMemberController", SelectClusterVmOverrideMemberController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var SelectClusterVmOverridesController = (function () {
        function SelectClusterVmOverridesController($scope, i18nService, vuiConstants, clusterVmOverridesPageService, clusterVmOverridesConstants, defaultUriSchemeUtil) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.clusterVmOverridesPageService = clusterVmOverridesPageService;
            this.clusterVmOverridesConstants = clusterVmOverridesConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.objectId = $scope.manager.getClusterId();
            this.vmSettingsSpec = {
                objectId: this.objectId,
                mode: clusterVmOverridesConstants.operationType.ADD
            };
            this.selectedVmsSpec = {
                objectId: this.objectId,
                vms: []
            };
            $scope.manager.setSelectedVmsSpec(this.selectedVmsSpec);
            $scope.manager.setVmSettingsSpec(this.vmSettingsSpec);
            this.populateVms();
        }
        SelectClusterVmOverridesController.prototype.populateVms = function () {
            var _this = this;
            this.clusterVmOverridesPageService.populateVmFtRole(this.$scope.manager.getSelectedVms())
                .then(function (selectedVms) {
                _this.selectedVmsSpec.vms = selectedVms;
            });
        };
        SelectClusterVmOverridesController.$inject = ["$scope", "i18nService", "vuiConstants",
            "clusterVmOverridesPageService", "clusterVmOverridesConstants",
            "defaultUriSchemeUtil"];
        return SelectClusterVmOverridesController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("SelectClusterVmOverridesController", SelectClusterVmOverridesController);
})(cluster_ui || (cluster_ui = {}));



(function () {
    /**
     * Directive for auto focusing first enabled cluster vm overrides checkbox.
     */
    'use strict';
    angular.module('com.vmware.vsphere.client.cluster').directive('vmOverridesAutofocus', vmOverridesAutofocus);
    function vmOverridesAutofocus() {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                setTimeout(function () {
                    $element.find("input[type='checkbox']:enabled").first().focus();
                }, 200);
            }
        };
    }
})();



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('VmOverridesController', VmOverridesController);

   VmOverridesController.$inject = ['$rootScope', '$scope', 'i18nService',
      'defaultUriSchemeUtil', 'clusterVmOverridesService', 'vuiConstants',
      'linksUtil', 'vcService', 'datagridActionBarService'];

   function VmOverridesController($rootScope, $scope, i18nService, defaultUriSchemeUtil,
         clusterVmOverridesService, vuiConstants, linksUtil, vcService,
         datagridActionBarService) {
      var self = this;
      var objectId = $rootScope._route.objectId;
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         'configurationEx.drsConfig.enabled',
         'configurationEx.drsConfig.defaultVmBehavior',
         'configurationEx.drsConfig.enableVmBehaviorOverrides',
         'configurationEx.dasConfig.enabled',
         'configurationEx.dasConfig.vmComponentProtecting',
         'configurationEx.dasConfig.vmMonitoring',
         'configurationEx.dasConfig.defaultVmSettings.isolationResponse',
         'configurationEx.dasConfig.defaultVmSettings.vmComponentProtectionSettings.vmTerminateDelayForAPDSec',
         'configurationEx.dasConfig.defaultVmSettings.vmComponentProtectionSettings.vmReactionOnAPDCleared',
         'configurationEx.dasConfig.defaultVmSettings.vmComponentProtectionSettings.vmStorageProtectionForPDL',
         'configurationEx.dasConfig.defaultVmSettings.vmComponentProtectionSettings.vmStorageProtectionForAPD',
         'configurationEx.dasConfig.defaultVmSettings.restartPriority',
         'configurationEx.dasConfig.defaultVmSettings.restartPriorityTimeout',
         'configurationEx.dasConfig.defaultVmSettings.vmToolsMonitoringSettings.failureInterval',
         'configurationEx.dasConfig.defaultVmSettings.vmToolsMonitoringSettings.maxFailureWindow',
         'configurationEx.dasConfig.defaultVmSettings.vmToolsMonitoringSettings.maxFailures',
         'configurationEx.dasConfig.defaultVmSettings.vmToolsMonitoringSettings.minUpTime',
         'configurationEx.orchestration.defaultVmReadiness.postReadyDelay',
         'configurationEx.orchestration.defaultVmReadiness.readyCondition',
         'configurationEx.drsVmConfig',
         'configurationEx.dasVmConfig',
         'configurationEx.vmOrchestration',
         'summary.currentEVCModeKey'
      ];

      self.gridTitle = i18nService.getString('ClusterUi', 'manage.settings.vmOverrides');
      self.selectedOverrides = null;
      self.vmMonitoringWarningMessage = null;
      var actionSpecs = [
         {
            actionId: 'vsphere.core.cluster.actions.vmOverride.add'
         }, {
            actionId: 'vsphere.core.cluster.actions.vmOverride.edit',
            getActionInvocationContext: function() {
               return {
                  selectedOverrides: self.selectedOverrides
               };
            },
            isActionAvailable: function(actionDef) {
               return actionDef.available && !_.isEmpty(self.gridOptions.selectedItems)
                     && (self.gridOptions.selectedItems.length === 1 ||
                     !_.some(self.gridOptions.selectedItems, function(selectedItem) {
                        return selectedItem.vm && selectedItem.vm.ftVm;
                     }));
            }
         }, {
            actionId: 'vsphere.core.cluster.actions.vmOverride.delete',
            getActionInvocationContext: function() {
               return {
                  selectedOverrides: self.selectedOverrides
               };
            },
            isActionAvailable: function(actionDef) {
               return actionDef.available && !_.isEmpty(self.gridOptions.selectedItems) &&
                     _.every(self.gridOptions.selectedItems, function(selectedItem){
                        return selectedItem.vm.ftVm === false;
                     });
            }
         }];
      var datagridActionBarServiceCacheObject = null;

      self.getViewData = function() {
         clusterVmOverridesService.getVmOverridesData(objectId)
               .then(function(data) {
                  self.gridOptions.data = data.overrides;

                  self.vmMonitoringWarningMessage =
                        getVmMonitoringWarningMessage(data.overrides);
               });
      };

      vcService.is65VcOrLater(objectId).then(function(is65vcOrLater) {
         self.gridOptions = getGridOptions(is65vcOrLater);

         self.getViewData();
         createActionBar();

         $scope.$watch('ctrl.gridOptions.selectedItems', onSelectedVmOverrideChange);
      });

      $scope.overridesPreselectComparator = overridesPreselectComparator;

      $scope.$watch(function() {
         return self.selectedOverrides;
      }, function() {
         refreshActionBar();

         if (self.selectedOverrides && self.selectedOverrides.length === 1 && self.selectedOverrides[0].haOverrides) {
            self.propertyGrid = clusterVmOverridesService.buildPropertyView(
                  self.selectedOverrides[0].haOverrides);
         } else {
            self.propertyGrid = null;
         }
      });

      function createActionBar() {
         datagridActionBarService
               .updateActionBar(self.gridOptions, [objectId], actionSpecs)
               .then(function(value) {
                  datagridActionBarServiceCacheObject = value;
               });
      }

      function refreshActionBar() {
         if (!datagridActionBarServiceCacheObject) {
            return;
         }

         datagridActionBarService.updateActionBar(
               self.gridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
         );
      }

      function getGridOptions(is65vcOrLater) {
         var options = {
            actionBarOptions: {
               actions: []
            },
            pageConfig: {
               hidePager: true
            },
            resizable: true,
            data: [],
            selectionMode: vuiConstants.grid.selectionMode.MULTI,
            selectedItems: [],
            columnDefs: getAllColumnDefs(is65vcOrLater),
            height: '100%',
            showCheckboxesOnMultiSelection: false
         };

         return options;
      }

      function getVmMonitoringWarningMessage(vmOverridesData) {
         var vmOverrideWarning = _.find(vmOverridesData, function(vmOverride) {
            return vmOverride.haOverrides.vmMonitoringWarningText !== null;
         });

         if (vmOverrideWarning) {
            return vmOverrideWarning.haOverrides.vmMonitoringWarningText;
         } else {
            return null;
         }
      }

      function getAllColumnDefs(is65vcOrLater) {
         var columnDefs = [{
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.vmNameHeaderText'),
               field: 'vm.name',
               type: 'string',
               template: '<span class="object" title="#:vm.name#"><i class="#:vm.primaryIconId#")></i>#:vm.name#</span>'
            }, {
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.drsAutomationLevelHeaderText'),
               field: 'drsOverrides.drsAutomationLevelText',
               type: 'string',
               template: '<span title="#:drsOverrides.drsAutomationLevelText#">#:drsOverrides.drsAutomationLevelText#</span>'
            }, {
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.haRestartPriorityHeaderText'),
               field: 'haOverrides.haRestartPriorityText',
               type: 'string',
               template: '<span title="#:haOverrides.haRestartPriorityText#">#:haOverrides.haRestartPriorityText#</span>'
            }
         ];

         if (is65vcOrLater) {
            columnDefs.push({
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.haRestartConditionHeaderText'),
               field: 'haOverrides.haRestartConditionsText',
               type: 'string',
               template: '<span title="#:haOverrides.haRestartConditionsText#">#:haOverrides.haRestartConditionsText#</span>'
            });
         }

         columnDefs = columnDefs.concat([{
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.haHostIsolationResponseHeaderText'),
               field: 'haOverrides.haIsolationResponseText',
               type: 'string',
               template: '<span title="#:haOverrides.haIsolationResponseText#">#:haOverrides.haIsolationResponseText#</span>'
            }, {
               displayName: i18nService.getString('ClusterUi',
                     'vmOverrides.vmHostHeaderText'),
               field: 'vm.host',
               type: 'string',
               template: hostTextRenderer
            }
         ]);

         return columnDefs;
      }

      function hostTextRenderer(data) {
         if (_.isNull(data.vm.host)) {
            return '';
         }

         var icon = '<span class="' + data.vm.host.primaryIconId + '"></span>';
         var hostLink = linksUtil.generateObjectLink(
               defaultUriSchemeUtil.getVsphereObjectId(data.vm.host.provider),
               data.vm.host.name);

         return icon + hostLink;
      }

      function onSelectedVmOverrideChange(newSelectedOverrides) {
         if (!newSelectedOverrides || newSelectedOverrides.length === 0) {
            self.selectedOverrides = null;
            return;
         }

         self.selectedOverrides = newSelectedOverrides;

      }

      function overridesPreselectComparator(override) {
         var result = false;
         if (self.selectedOverrides && override) {
            result = _.some(self.selectedOverrides, function(selected) {
               return selected.vm.name === override.vm.name
                     && ((selected.vm.host && override.vm.host &&
                     selected.vm.host.name === override.vm.host.name) ||
                     (!selected.vm.host && !override.vm.host));
            });
         }
         return result;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('DrsController', DrsController);

   DrsController.$inject = ['$scope', 'dataService', 'i18nService',
      'drsAutomationLevelService', 'drsMigrationThresholdService',
      'dpmAutomationLevelService', 'dpmThresholdService', 'vcService',
      'drsPoliciesService'];

   function DrsController($scope, dataService, i18nService,
         drsAutomationLevelService, drsMigrationThresholdService,
         dpmAutomationLevelService, dpmThresholdService, vcService, drsPoliciesService) {
      var self = this;
      var objectId = $scope._route.objectId;

      self.headerOptions = {
         title: i18nService.getString('ClusterUi', 'services.drs'),
         objectId: objectId,
         actions: [{
            actionUid: 'vsphere.core.cluster.actions.scheduleDrs',
            customLabel: i18nService.getString('ClusterUi', 'drs.config.scheduleDrs.button.label')
         }, {
            actionUid: 'vsphere.core.cluster.actions.restoreRpTree',
            customLabel: i18nService.getString('ClusterUi', 'drs.config.restore.rp.tree.action.label')
         }, {
            actionUid: 'vsphere.core.cluster.actions.editDrs',
            customLabel: i18nService.getString('ClusterUi', 'general.config.button.edit')
         }]
      };
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         "configurationEx.drsConfig.enabled",
         "configurationEx.drsConfig.enableVmBehaviorOverrides",
         "configurationEx.drsConfig.defaultVmBehavior",
         "configurationEx.drsConfig.option",
         "configurationEx.drsConfig.vmotionRate",
         "configurationEx.dpmConfigInfo.defaultDpmBehavior",
         "configurationEx.dpmConfigInfo.enabled",
         "configurationEx.dpmConfigInfo.hostPowerActionRate",
         "configurationEx.proactiveDrsConfig.enabled"
      ];
      self.getViewData = getViewData;
      self.getString = getString;
      self.refreshUi = refreshUi;

      self.advancedOptionsLabel = getString('drs.config.advancedOptionsLabel');
      self.configParametersLabel =
            getString('drs.config.advancedOptions.configParametersLabel');
      self.is65VcOrLater = false;
      self.drsConfigAccessor = {};

      getViewData();

      getVcVersion();

      function refreshUi() {
         self.getViewData();
         if (self.drsConfigAccessor && self.drsConfigAccessor.refresh) {
            self.drsConfigAccessor.refresh();
         }
      }

      function getViewData() {
         dataService.getData(objectId,
               'com.vmware.vsphere.client.clusterui.model.services.DrsConfigData',
               { queryName: 'DrsController.' + getViewData.name })
               .then(function(drsData) {
                  self.drsData = drsData ? parseDrsData(drsData) : {};
                  self.dpm = drsData ? getDpmSettings(drsData) : {};
                  self.policies = drsData ? getPolicies(drsData) : {};
                  if (drsData) {
                     self.headerOptions.title = getTitle(drsData.drsEnabled);
                  }

                  var hasAdvancedOptions =
                        !!self.drsData.advancedOptions &&
                        self.drsData.advancedOptions.length > 0;
                  self.advancedOptionsText =
                        hasAdvancedOptions ?
                              getString('drs.config.advancedOptionsCollapsedText.show')
                              : getString('drs.config.advancedOptionsCollapsedText.none');
               });
      }

      function getVcVersion() {
         vcService.is65VcOrLater(objectId)
               .then(function(is65VcOrLater) {
                  self.is65VcOrLater = is65VcOrLater;
               });
      }

      function getTitle(drsEnabled) {
         return (drsEnabled) ?
               getString('drs.config.drsEnabled')
               : getString('drs.config.drsDisabled');
      }

      function parseDrsData(drsData) {
         var currentAutomationLevel =
               drsAutomationLevelService.getLevelByKey(drsData.defaultDrsBehavior);
         drsData.drsAutomationLevelText = currentAutomationLevel.label;
         drsData.drsAutomationLevelDescription = currentAutomationLevel.description;

         drsData.migrationThresholdText =
               drsMigrationThresholdService.getText(drsData.migrationThreshold);
         drsData.migrationThresholdDescription =
               drsMigrationThresholdService.getDescription(drsData.migrationThreshold);

         drsData.predictiveDrsText = getPredictiveDrsText(drsData);

         drsData.vmAutomationText = getString(drsData.vmAutomationEnabled ?
               'drs.config.vmAutomation.enabled' :
               'drs.config.vmAutomation.disabled');
         return drsData;
      }

      function getDpmSettings(data) {
         var automationLevel = dpmAutomationLevelService.getText(
               data.dpmEnabled, data.defaultDpmBehavior);
         var automationLevelDescription = dpmAutomationLevelService.getDescription(
               data.dpmEnabled, data.defaultDpmBehavior);
         var dpmThreshold = dpmThresholdService.reverseDpmRateAndThreshold(data.dpmRate);
         var threshold = dpmThresholdService.getText(data.dpmEnabled, dpmThreshold);

         return {
            automationLevel: automationLevel,
            automationLevelDescription: automationLevelDescription,
            threshold: threshold
         };
      }

      function getPredictiveDrsText(drsData) {
         if (drsData.proactiveDrsEnabled) {
            return getString('drs.portlet.migration.forecastedMetrics.enabled');
         } else {
            return getString('drs.portlet.migration.forecastedMetrics.disabled');
         }
      }

      function getPolicies(data) {
         var evenDistributionLabel = drsPoliciesService.getEvenDistributionLabel(data);
         var consumedOrActiveMemoryLabel = drsPoliciesService.getConsumedOrActiveMemoryLabel(
               data);
         var cpuOverCommitmentLabel = drsPoliciesService.getCpuOverCommitmentLabel(data);
         return {
            evenDistributionLabel: evenDistributionLabel,
            consumedOrActiveMemoryLabel: consumedOrActiveMemoryLabel,
            cpuOverCommitmentLabel: cpuOverCommitmentLabel
         };
      }

      function getString() {
         var args = Array.prototype.slice.call(arguments);
         return i18nService.getString.apply(i18nService, ['ClusterUi'].concat(args));
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('EvcController', EvcController);

   EvcController.$inject = ['$scope', 'dataService', 'i18nService', '$element'];

   function EvcController($scope, dataService, i18nService, $element) {
      var self = this;
      var objectId = $scope._route.objectId;

      self.headerOptions = getHeaderOptions();
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         "summary.currentEVCModeKey",
         "supportedEvcMode"
      ];
      self.getViewData = getViewData;

      getViewData();

      function getHeaderOptions() {
         return {
            title: i18nService.getString('ClusterUi', 'manage.settings.evc.description'),
            objectId: objectId,
            actions: [{
               actionUid: 'vsphere.core.cluster.actions.editEvcMode',
               customLabel: i18nService.getString('ClusterUi', 'general.config.button.edit')
            }]
         };
      }

      function getViewData() {
         dataService
            .getData(objectId,
               'com.vmware.vsphere.client.clusterui.model.configuration.EvcConfigData')
            .then(function (evcData) {
               parseEvcConfigData(evcData);
               self.evcData = evcData;
               self.headerOptions.title = getTitle(evcData.evcModeKey);
            });
      }

      function getTitle(evcEnabled) {
         return (evcEnabled) ?
            i18nService.getString('ClusterUi', 'evc.config.evcEnabledLabel')
            : i18nService.getString('ClusterUi', 'evc.config.evcDisabledLabel');
      }

      function parseEvcConfigData(evcData) {
         if (!evcData.evcModeKey || !evcData.currentEvcMode) {
            return;
         }
         self.datagridOptions = {
            columnDefs: [
               {
                  field: 'register',
                  displayName: i18nService.getString('ClusterUi', 'evc.config.registerColumnName'),
                  sortable: false,
                  template: function(cpuidFeatureListItem) {
                     var textElement = $('<span></span>').text(cpuidFeatureListItem.register);
                     if (cpuidFeatureListItem.isLeaf) {
                        textElement.addClass('cpuid-leaf');
                     }
                     return textElement[0].outerHTML;
                  }
               },
               {
                  field: 'value',
                  displayName: i18nService.getString('ClusterUi', 'evc.config.valueColumnName'),
                  sortable: false
               }
            ],
            pageConfig: {
               hidePager: true
            },
            searchable: false,
            selectedItems: [],
            data: generateCpuidFeaturesListData(evcData.currentEvcMode.guaranteedCPUFeatures),
            dataBound: function() {
               $element.find('[vui-datagrid] .k-grid-content').css('height', '');
            }
         };
      }

      function generateCpuidFeaturesListData(guaranteedCPUFeatures) {
         var cpuidFeaturesList = [];

         guaranteedCPUFeatures.forEach(function(cpuFeature) {

            // The leaf information.
            var cpuFeatureLevel = cpuFeature.level;

            // Represent 32-bit number as unsigned int
            // http://stackoverflow.com/questions/57803/how-to-convert-decimal-to-hex-in-javascript
            if (cpuFeatureLevel < 0) {
               cpuFeatureLevel = 0xFFFFFFFF + cpuFeatureLevel + 1;
            }
            var leafCpuidListItem = {
               register: i18nService.getString('ClusterUi', 'evc.config.cpuidFeaturesFlagLeafLabel',
                  cpuFeatureLevel.toString(16)),
               value: '',
               isLeaf: true
            };
            cpuidFeaturesList.push(leafCpuidListItem);

            // The information for eax register.
            var eaxCpuidListItem = {
               register: 'eax',
               value: cpuFeature.eax
            };
            cpuidFeaturesList.push(eaxCpuidListItem);

            // The information for ebx register.
            var ebxCpuidListItem = {
               register: 'ebx',
               value: cpuFeature.ebx
            };
            cpuidFeaturesList.push(ebxCpuidListItem);

            // The information for ecx register.
            var ecxCpuidListItem = {
               register: 'ecx',
               value: cpuFeature.ecx
            };
            cpuidFeaturesList.push(ecxCpuidListItem);

            // The information for edx register.
            var edxCpuidListItem = {
               register: 'edx',
               value: cpuFeature.edx
            };
            cpuidFeaturesList.push(edxCpuidListItem);
         });
         return cpuidFeaturesList;
      }
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var EditHostOptionsController = (function () {
        function EditHostOptionsController($scope, i18nService, dataService, hostOptionsService, defaultUriSchemeUtil, dpmAutomationLevelService, mutationService, $q) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.hostOptionsService = hostOptionsService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dpmAutomationLevelService = dpmAutomationLevelService;
            this.mutationService = mutationService;
            this.$q = $q;
            this.isAlertClosed = true;
            this.hostId = $scope.modalOptions.dialogData.selectedHost;
            this.clusterId = $scope.modalOptions.dialogData.clusterRef;
            this.dpmBehaviors = hostOptionsService.getDpmBehaviors();
            this.loading = true;
            $scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.getViewData();
        }
        EditHostOptionsController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.hostId, "com.vmware.vsphere.client.clusterui.model." +
                "services.HostOptionsConfigInfoData")
                .then(function (data) {
                if (data) {
                    _this.bmcConfigData = data.ipmiInfo;
                    _this.defaultIpmiSettings = angular.merge({}, data.ipmiInfo);
                    _this.powerManagementConfig = {
                        hostId: _this.hostId
                    };
                    _this.hostOptionsService.setSelectedDpmBehavior(data.clusterDpmConfigData, _this.powerManagementConfig);
                }
                _this.loading = false;
            })
                .catch(function (error) {
                _this.loading = false;
                _this.$q.reject(error);
            });
        };
        EditHostOptionsController.prototype.onSubmit = function () {
            if (this.bmcConfigData && !_.isEqual(this.bmcConfigData, this.defaultIpmiSettings)) {
                if (!this.bmcConfigData.password) {
                    this.bmcConfigData.password = "";
                }
                var validationMessages = this.hostOptionsService
                    .validatePowerConfigSoftwareSpec(this.bmcConfigData);
                if (validationMessages.length === 0) {
                    this.mutationService.apply(this.hostId, "com.vmware.vsphere.client.h5." +
                        "host.config.spec.PowerConfigSoftwareSpec", this.bmcConfigData);
                }
                else {
                    this.$scope.modalOptions.alerts = this.hostOptionsService
                        .showValidationMessages(validationMessages);
                    this.isAlertClosed = false;
                    return false;
                }
            }
            if (this.powerManagementConfig.defaultDpmOverride !==
                this.powerManagementConfig.powerManagementOverride ||
                this.powerManagementConfig.defaultDpmBehavior !==
                    this.powerManagementConfig.selectedDpmBehavior) {
                var dpmHostConfigSpec = this.hostOptionsService.createDpmHostConfigSpec(this.powerManagementConfig);
                var clusterSpec = this.hostOptionsService.createClusterSpec([dpmHostConfigSpec]);
                this.mutationService.apply(this.clusterId, "com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec", clusterSpec);
            }
            return true;
        };
        EditHostOptionsController.prototype.updatePowerManagementlValue = function () {
            if (!this.powerManagementConfig.powerManagementOverride) {
                this.powerManagementConfig.selectedDpmBehavior =
                    this.powerManagementConfig.defaultDpmBehavior;
            }
        };
        EditHostOptionsController.$inject = ["$scope",
            "i18nService",
            "dataService",
            "hostOptionsService",
            "defaultUriSchemeUtil",
            "dpmAutomationLevelService",
            "mutationService",
            "$q"];
        return EditHostOptionsController;
    }());
    cluster_ui.EditHostOptionsController = EditHostOptionsController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("EditHostOptionsController", EditHostOptionsController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var HostOptionsController = (function () {
        function HostOptionsController($scope, i18nService, dataService, hostOptionsService, $q) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.hostOptionsService = hostOptionsService;
            this.$q = $q;
            this.hostOptionsPreselectComparator = function (hostOption) {
                return _this.selectedItem && hostOption &&
                    _this.selectedItem.name === hostOption.name;
            };
            this.objectId = $scope._route.objectId;
            this.liveRefreshProperties = [
                "configurationEx.dpmConfigInfo.enabled",
                "configurationEx.dpmConfigInfo.defaultDpmBehavior",
                "configurationEx.dpmHostConfig"
            ];
            this.headerOptions = {
                title: i18nService.getString("ClusterUi", "manage.settings.hostOptions"),
                actions: [],
                objectIds: [this.objectId]
            };
            this.datagridOptions = hostOptionsService.getDatagridOptions();
            this.getData();
            hostOptionsService.createActionBar(this.datagridOptions, this.objectId).then(function (data) {
                _this.actionBarCacheObject = data;
            });
            this.preselectDatagridItem();
            this.refreshActionBarOnSelect();
        }
        HostOptionsController.prototype.getData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, "com.vmware.vsphere.client.clusterui.model.services.ClusterHostOptionsConfigData").then(function (data) {
                if (data) {
                    _this.$q.when(_this.hostOptionsService.parseHostOptionsData(data)).then(function (parsedData) {
                        if (parsedData) {
                            _this.datagridOptions.data = parsedData;
                            _this.keepPreselection();
                        }
                    });
                }
            });
        };
        HostOptionsController.prototype.refreshActionBarOnSelect = function () {
            var _this = this;
            this.$scope.$watch(function () {
                return _this.selectedItem;
            }, function () {
                _this.hostOptionsService.refreshActionBar(_this.datagridOptions, _this.objectId, _this.actionBarCacheObject);
            });
        };
        HostOptionsController.prototype.preselectDatagridItem = function () {
            var _this = this;
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (selectedItems) {
                if (!selectedItems || selectedItems.length === 0) {
                    _this.selectedItem = null;
                    return;
                }
                if (_this.selectedItem && _this.selectedItem.name === selectedItems[0].name) {
                    return;
                }
                _this.selectedItem = selectedItems[0];
            });
        };
        HostOptionsController.prototype.keepPreselection = function () {
            var _this = this;
            if (this.selectedItem && this.datagridOptions.data.length > 0) {
                this.datagridOptions.selectedItems[0] = _.find(this.datagridOptions.data, function (item) {
                    return _this.selectedItem.name === item.name;
                });
            }
        };
        HostOptionsController.$inject = ["$scope", "i18nService", "dataService", "hostOptionsService", "$q"];
        return HostOptionsController;
    }());
    cluster_ui.HostOptionsController = HostOptionsController;
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("HostOptionsController", HostOptionsController);
})(cluster_ui || (cluster_ui = {}));



(function() {
   /**
    * Directive for adding Affinity and Antiaffinity rule.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'addAffinityRule', addAffinityRule);

   addAffinityRule.$inject = ['$rootScope', 'i18nService', 'vuiConstants',
         'datagridActionBarService', 'clusterRulesService',
         'clusterRulesConstants'];

   function addAffinityRule($rootScope, i18nService, vuiConstants,
         datagridActionBarService, clusterRulesService, clusterRulesConstants) {

      return {
         restrict: 'AE',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/rules/addAffinityRule.html',
         scope: {
            spec: '='
         },
         controller: ['$scope', function($scope) {

            var objectId = $rootScope._route.objectId;

            $scope.descriptionTitle = i18nService.getString('Common', 'rules.config.description');
            $scope.gridTitle = i18nService.getString('ClusterUi', 'rules.members.list.name');
            $scope.spec.vmAffinityData = [];

            if ($scope.spec.members && $scope.spec.members.length > 0) {
               clusterRulesService.getAffinityRulesMembersData($scope.spec).then(function(membersData) {
                  $scope.spec.vmAffinityData = membersData;
                  $scope.vmAffinityGridOptions.data = membersData;
               });
            }

            $scope.vmAffinityGridOptions = getVmAffinityGridOptions();

            var actionSpecs = [{
               actionId: 'vsphere.core.cluster.actions.rule.members.add',
               getActionInvocationContext: function() {
                  return {
                     selectedMembers: $scope.spec.vmAffinityData,
                     dialogSubTitleObject: {
                        objectId: objectId
                     },
                     submitCallback: function(dialogOptions) {
                        if (dialogOptions.dialogData.selectedItems !== undefined) {
                           $scope.vmAffinityGridOptions.data = $scope.vmAffinityGridOptions
                                 .data.concat(dialogOptions.dialogData.selectedItems);
                           $scope.spec.vmAffinityData = $scope.vmAffinityGridOptions.data;
                        }
                        return true;
                     }
                  };
               }
            }, {
               actionId: 'vsphere.core.cluster.actions.rule.members.remove',
               getActionInvocationContext: function() {
                  return {
                     isExistingRule: false,
                     rule: null,
                     membersToRemove: $scope.vmAffinityGridOptions.selectedItems,
                     confirmCallback: function() {
                        $scope.vmAffinityGridOptions.data = $scope.spec.vmAffinityData =
                              _.filter(
                                    $scope.vmAffinityGridOptions.data,
                                    function(gridItem) {
                                       return _.every(
                                             $scope.vmAffinityGridOptions.selectedItems,
                                             function(selectedItem) {
                                                return gridItem.id !== selectedItem.id;
                                             });
                                    });
                        return true;
                     }
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available && $scope.vmAffinityGridOptions.selectedItems.length > 0;
               }
            }];
            var datagridActionBarServiceCacheObject = null;

            $scope.$watch('vmAffinityGridOptions.selectedItems', function() {
               refreshActionBar();
            });

            $scope.$watch('spec.ruleType', function() {
               $scope.descriptionLabel = getRuleDescription();
            });

            createActionBar();

            function createActionBar() {
               datagridActionBarService
                     .updateActionBar($scope.vmAffinityGridOptions, [objectId], actionSpecs)
                     .then(function(value) {
                        datagridActionBarServiceCacheObject = value;
                     });
            }

            function refreshActionBar() {
               if (!datagridActionBarServiceCacheObject) {
                  return;
               }

               datagridActionBarService.updateActionBar(
                     $scope.vmAffinityGridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
               );
            }

            function getVmAffinityGridOptions() {
               var options = {
                  actionBarOptions: {
                     actions: []
                  },
                  searchable: false,
                  resizable: false,
                  data: $scope.spec.vmAffinityData,
                  selectionMode: vuiConstants.grid.selectionMode.MULTI,
                  showCheckboxesOnMultiSelection: false,
                  selectedItems: [],
                  columnDefs: [{
                     displayName: i18nService.getString('ClusterUi', 'rules.members.list.name'),
                     field: 'name',
                     type: 'string',
                     template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
                  }],
                  height: '100%',
                  pageConfig: {
                     hidePager: true
                  }
               };

               return options;
            }

            function getRuleDescription() {
               if ($scope.spec.ruleType === clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE) {
                  return i18nService.getString('ClusterUi',
                        'rules.config.type.vmAffinity.desc');
               } else {
                  return i18nService.getString('ClusterUi',
                        'rules.config.type.vmAntiAffinity.desc');
               }
            }
         }]
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AddClusterRuleController', AddClusterRuleController);

   AddClusterRuleController.$inject = ['$scope', 'i18nService', '$q',
         'vuiConstants', 'mutationService', 'clusterRulesService',
         'clusterSpecBuilderService', 'clusterRulesConstants',
         'defaultUriSchemeUtil', 'vcService'];

   function AddClusterRuleController($scope, i18nService, $q, vuiConstants,
                                     mutationService, clusterRulesService,
                                     clusterSpecBuilderService, clusterRulesConstants,
                                     defaultUriSchemeUtil, vcService) {
      var self = this;
      var objectId = $scope._route.objectId;
      self.isRuleTypeSelectDisabled = false;
      $scope.modalOptions.isAlertClosed = true;

      if(!$scope.modalOptions.dialogData || !$scope.modalOptions.dialogData.rule) {
         self.spec = {};
         self.spec.ruleType = clusterRulesService.DEFAULT_TYPE;
         self.spec.name = '';
         self.spec.enabled = true;
         self.spec.operation = clusterRulesConstants.operationType.ADD;
      } else {
         self.spec = $scope.modalOptions.dialogData.rule;
         self.spec.ruleType = clusterRulesService.getSpecTypeByRuleType(
               $scope.modalOptions.dialogData.rule.type);
         self.spec.operation = clusterRulesConstants.operationType.EDIT;
         self.isRuleTypeSelectDisabled = true;
      }
      getViewData();

      function getViewData() {
         vcService.is65VcOrLater(objectId)
               .then(function(is65VcOrLater) {
                  self.typeOptions = clusterRulesService.getRuleTypes(is65VcOrLater);
               });
      }

      $scope.modalOptions.onSubmit = function() {
         return onCommit();
      };

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function validate() {
         if (self.spec.name) {
            if ((/^\s*$/gi).test(self.spec.name)) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.error.nameEmpty'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;

               return $q.reject();
            } else if (self.spec.name.length > 80) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.error.nameTooLong'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;

               return $q.reject();
            }
         } else {
            $scope.modalOptions.alerts = [{
               text: getString('rules.config.error.nameEmpty'),
               type: vuiConstants.validationBanner.type.ERROR
            }];
            $scope.modalOptions.isAlertClosed = false;

            return $q.reject();
         }

         if (self.spec.ruleType === clusterRulesConstants.ruleSpec.VM_AFFINITY_RULE
               || self.spec.ruleType === clusterRulesConstants.ruleSpec.VM_ANTIAFFINITY_RULE) {
            if (self.spec.vmAffinityData.length < 2) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.members.error.noMembers'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            }
         }

         var ruleProps = null;

         if (self.spec.ruleType === clusterRulesConstants.ruleSpec.VM_HOST_GROUP_RULE) {
            if (!self.spec.selectedVmGroup) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.error.noSelectedVmGroup'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            } else if (self.spec.invalidVmGroup) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.relationTypes.selectVmGroup'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            } else if (!self.spec.selectedHostGroup) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.error.noSelectedHostGroup'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            } else if (self.spec.invalidHostGroup) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.relationTypes.selectHostGroup'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            } else {
               ruleProps = {
                  vmGroupName: self.spec.selectedVmGroup,
                  hostGroupName: self.spec.selectedHostGroup,
                  isMandatory: self.spec.selectedVmToHostRuleType.isMandatory,
                  isAffineHostGroupName: self.spec.selectedVmToHostRuleType.isAffineHostGroupName
               };
            }
         }

         if (self.spec.ruleType === clusterRulesConstants.ruleSpec.VM_DEPENDENCY_RULE) {
            if (!self.spec.selectedVmGroup || !self.spec.selectedDependsOnVmGroup) {
               $scope.modalOptions.alerts = [{
                  text: getString('rules.config.error.noSelectableVmGroup'),
                  type: vuiConstants.validationBanner.type.ERROR
               }];
               $scope.modalOptions.isAlertClosed = false;
               return $q.reject();
            } else {
               ruleProps = {
                  vmGroup: self.spec.selectedVmGroup,
                  dependsOnVmGroup: self.spec.selectedDependsOnVmGroup
               };
            }
         }

         var key = null;
         if(self.spec.operation === clusterRulesConstants.operationType.EDIT) {
            key = self.spec.key;
         }

         self.ruleSpec = clusterRulesService.buildRuleSpec(
               self.spec.ruleType,
               self.spec.name,
               self.spec.enabled,
               _.map(self.spec.vmAffinityData, function(vm) {
                  return defaultUriSchemeUtil.getManagedObjectReference(vm.id);
               }),
               ruleProps,
               self.spec.operation,
               key);

         var validationPromise =
               mutationService.validate(
                     objectId,
                     'com.vmware.vim.binding.vim.cluster.RuleSpec',
                     self.ruleSpec
               ).then(function(validationResult) {
                  $scope.modalOptions.alerts = [];
                  $scope.modalOptions.isAlertClosed = true;

                  if (!!validationResult && (!validationResult.result || !!validationResult.error)) {
                     if (validationResult.result === 'NAME_ERROR') {
                        $scope.modalOptions.alerts.push({
                           text: getString('rules.error.nameNotUnique'),
                           type: vuiConstants.validationBanner.type.ERROR
                        });
                        $scope.modalOptions.isAlertClosed = false;
                        return $q.reject();
                     }

                     if (validationResult.result === 'RULE_CONFLICT_ERROR') {
                        if (self.spec.enabled) {
                           $scope.modalOptions.alerts.push({
                              text: getString('rules.error.ruleConflicts'),
                              type: vuiConstants.validationBanner.type.ERROR
                           });
                           $scope.modalOptions.isAlertClosed = false;
                           self.spec.enabled = false;
                           return $q.reject();
                        } else {
                           return $q.resolve();
                        }
                     }

                  } else {
                     return $q.resolve();
                  }
               });

         return validationPromise;
      }

      function onCommit() {
         return validate()
               .then(function() {
                  var clusterComputeResourceSpec =
                        clusterSpecBuilderService.buildClusterComputeResourceSpec(
                              {
                                 rule: self.ruleSpec
                              },
                              true
                        );

                  mutationService.apply(
                        objectId,
                        'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
                        clusterComputeResourceSpec
                  );
                  return true;
               })
               .catch(function(e) {
                  return false;
               });
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AddClusterRuleMemberController', AddClusterRuleMemberController);

   AddClusterRuleMemberController.$inject = ['$scope', 'i18nService'];

   function AddClusterRuleMemberController($scope, i18nService) {

      var clusterId = $scope.modalOptions.dialogData.objectId;
      var dialogData = $scope.modalOptions.dialogData;
      var selectedVms = getSelectedVmsManagedObjectRefs(dialogData.selectedVms);
      var selectorConfig = {
         objectType: "VirtualMachine",
         listViewId: "vsphere.core.vm.list"
      };

      var filter = 'clusterVmsExceptSecondaryVmsExcludeVmsFilter';

      // use different filter if there are no members to be excluded because
      // clusterVmsExceptSecondaryVmsFilter cannot be instantiated with an empty param
      if (selectedVms.length === 0) {
         filter = 'clusterVmsExceptSecondaryVmsFilter';
      }

      this.config = {
         contextObject: clusterId,
         multipleSelect: true,
         listTabConfig: {
            listConfig: [{
               label: i18nService.getString('Common', 'typeResource.vmPlural'),
               listViewId: selectorConfig.listViewId,
               dataModels: [selectorConfig.objectType],
               filterId: filter,
               filterParams: selectedVms
            }]
         },
         onSelectionChanged: function(newSelectedItems) {
            dialogData.selectedItems = newSelectedItems;
         }
      };
   }

   function getSelectedVmsManagedObjectRefs(selectedVms){
      return _.map(selectedVms, function(selectedVm) {
         return selectedVm.id;
      });
   }
})();

(function() {
   /**
    * Directive for adding VM to VM rule.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'addVmDependencyRule', addVmDependencyRule);

   addVmDependencyRule.$inject = ['$rootScope', 'i18nService', 'clusterGroupsService',
      'clusterGroupsConstants'];

   function addVmDependencyRule($rootScope, i18nService, clusterGroupsService,
         clusterGroupsConstants) {
      return {
         restrict: 'A',
         templateUrl:
               'cluster-ui/resources/cluster/views/settings/rules/addVmDependencyRule.html',
         scope: {
            spec: '='
         },
         controller: ['$scope', function($scope) {
            var objectId = $rootScope._route.objectId;
            $scope.dependsOnVmGroups = [];
            $scope.vmGroups = [];
            $scope.spec.selectedDependsOnVmGroup = null;
            $scope.spec.selectedVmGroup = null;

            getGroupsOptions();

            $scope.$watch('spec.selectedDependsOnVmGroup',
                  function(selectedDependsOnVmGroup) {
                     if (selectedDependsOnVmGroup) {
                        //update available vm groups to exclude selected depends-on group
                        //when it changes
                        $scope.vmGroups = $scope.dependsOnVmGroups.filter(function(group) {
                           return group.name !== selectedDependsOnVmGroup;
                        });

                        if ($scope.vmGroups.length > 0) {
                           if($scope.spec.operation === "edit" && !$scope.spec.selectedVmGroup) {
                              $scope.spec.selectedVmGroup =
                                 $scope.spec.vmDependencyRuleProperties &&
                                 $scope.spec.vmDependencyRuleProperties.vmGroup ?
                                    $scope.spec.vmDependencyRuleProperties.vmGroup : null;
                           } else {
                              $scope.spec.selectedVmGroup = $scope.vmGroups[0].name;
                           }
                        }
                     }
                  });

            $scope.$watch('spec.selectedVmGroup', function() {
               updateRuleDescription();
            });

            $scope.ruleDescriptionTitle = i18nService.getString(
                  'Common', 'rules.config.description');
            $scope.dependsOnVmGroupTitle = i18nService.getString(
                  'ClusterUi', 'rules.config.vmGroup2.text');
            $scope.vmGroupTitle = i18nService.getString(
                  'ClusterUi', 'rules.config.vmGroup1.label');

            function updateRuleDescription() {
               if ($scope.spec.selectedDependsOnVmGroup === null ||
                     $scope.spec.selectedVmGroup === null) {
                  $scope.ruleDescription =
                        i18nService.getString(
                              'ClusterUi', 'rules.config.relationTypes.selectVmGroup');
               } else {
                  $scope.ruleDescription =
                        i18nService.getString('ClusterUi',
                              'rules.config.type.vmToVM.desc',
                              $scope.spec.selectedDependsOnVmGroup,
                              $scope.spec.selectedVmGroup);
               }
            }

            function getGroupsOptions() {
               var dependsOnVmGroups = [];
               return clusterGroupsService.getGroupsData(objectId)
                     .then(function(groupsData) {
                        groupsData.forEach(function(group) {
                           if (group.rawType === clusterGroupsConstants.groupType.VM_GROUP) {
                              dependsOnVmGroups.push(group);
                           }
                        });
                        $scope.dependsOnVmGroups = dependsOnVmGroups;

                        if(dependsOnVmGroups.length > 0) {
                           if($scope.spec.operation === "edit") {
                              $scope.spec.selectedDependsOnVmGroup =
                                 $scope.spec.vmDependencyRuleProperties &&
                                 $scope.spec.vmDependencyRuleProperties.dependsOnVmGroup ?
                                    $scope.spec.vmDependencyRuleProperties.dependsOnVmGroup : null;
                           } else {
                              $scope.spec.selectedDependsOnVmGroup = dependsOnVmGroups[0].name;
                           }
                        }

                     });
            }
         }]
      };
   }
})();

(function() {
   /**
    * Directive for adding VM to hosts rule.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'addVmToHostsRule', addVmToHostsRule);

   addVmToHostsRule.$inject = ['$rootScope', 'i18nService', 'clusterGroupsService',
      'clusterGroupsConstants', 'clusterRulesConstants'];

   function addVmToHostsRule($rootScope, i18nService, clusterGroupsService, clusterGroupsConstants,
                             clusterRulesConstants) {

      return {
         restrict: 'AE',
         templateUrl:
               'cluster-ui/resources/cluster/views/settings/rules/addVmToHostsRule.html',
         scope: {
            spec: '='
         },
         controller: ['$scope', function($scope) {

            var objectId = $rootScope._route.objectId;
            $scope.ruleDescriptionTitle = i18nService.getString('Common', 'rules.config.description');
            $scope.vmGroupTitle = getString('rules.config.vmGroup.label');
            $scope.hostGroupTitle = getString('rules.config.hostGroup.label');
            $scope.vmGroups = [];
            $scope.hostGroups = [];
            $scope.spec.selectedVmGroup = null;
            $scope.spec.selectedHostGroup = null;
            $scope.vmToHostRuleTypeOptions = getVmToHostRuleTypes();

            if($scope.spec.operation === clusterRulesConstants.operationType.EDIT){
               $scope.spec.selectedVmGroup = $scope.spec.vmToHostRuleProperties.vmGroupName;
               $scope.spec.selectedHostGroup = $scope.spec.vmToHostRuleProperties.hostGroupName;
            }

            getGroupsOptions().then(function() {
               $scope.$watchGroup(
                     ['spec.selectedVmGroup', 'spec.selectedHostGroup', 'spec.selectedVmToHostRuleType'],
                     function(data){

                        if (data[0] === null) {
                           $scope.ruleDescription =
                                 getString('rules.config.relationTypes.selectVmGroup');
                           return;
                        }

                        $scope.spec.invalidVmGroup = !_.some($scope.vmGroups, function(vmGroup) {
                           return vmGroup.name === data[0];
                        });

                        if (data[1] === null) {
                           $scope.ruleDescription =
                                 getString('rules.config.relationTypes.selectHostGroup');
                           return;
                        }

                        $scope.spec.invalidHostGroup = !_.some($scope.hostGroups, function(hostGroup) {
                           return hostGroup.name === data[1];
                        });

                        var ruleType = data[2];
                        switch (ruleType.id) {
                           case 'hardAffinity':
                              $scope.ruleDescription = i18nService.getString('ClusterUi',
                                    'rules.config.relationTypes.hardAffinity.desc', data[0], data[1]);
                              break;
                           case 'softAffinity':
                              $scope.ruleDescription = i18nService.getString('ClusterUi',
                                    'rules.config.relationTypes.softAffinity.desc', data[0], data[1]);
                              break;
                           case 'hardAntiAffinity':
                              $scope.ruleDescription = i18nService.getString('ClusterUi',
                                    'rules.config.relationTypes.hardAntiAffinity.desc', data[0],
                                    data[1]);
                              break;
                           case 'softAntiAffinity':
                              $scope.ruleDescription = i18nService.getString('ClusterUi',
                                    'rules.config.relationTypes.softAntiAffinity.desc', data[0],
                                    data[1]);
                              break;
                        }
               });
            });

            function getGroupsOptions() {
               var vmGroups = [];
               var hostGroups = [];
               return clusterGroupsService.getGroupsData(objectId)
                     .then(function(groupsData) {

                        groupsData.forEach(function(group) {
                           if(group.rawType === clusterGroupsConstants.groupType.VM_GROUP) {
                              vmGroups.push(group);
                           }
                           else if(group.rawType === clusterGroupsConstants.groupType.HOST_GROUP) {
                              hostGroups.push(group);
                           }
                        });
                        $scope.vmGroups = vmGroups;
                        if(vmGroups.length > 0 && !$scope.spec.selectedVmGroup) {
                           $scope.spec.selectedVmGroup = vmGroups[0].name;
                        }
                        $scope.hostGroups = hostGroups;
                        if(hostGroups.length > 0 && !$scope.spec.selectedHostGroup) {
                           $scope.spec.selectedHostGroup = hostGroups[0].name;
                        }
                     });
            }

            function getVmToHostRuleTypes() {
              var typesArray = [
                 {
                    id: 'hardAffinity',
                    label: getString('rules.config.relationTypes.hardAffinity.label'),
                    isAffineHostGroupName: true,
                    isMandatory: true
                 },
                 {
                    id: 'softAffinity',
                    label: getString('rules.config.relationTypes.softAffinity.label'),
                    isAffineHostGroupName: true,
                    isMandatory: false
                 },
                 {
                    id: 'hardAntiAffinity',
                    label: getString('rules.config.relationTypes.hardAntiAffinity.label'),
                    isAffineHostGroupName: false,
                    isMandatory: true
                 },
                 {
                    id: 'softAntiAffinity',
                    label: getString('rules.config.relationTypes.softAntiAffinity.label'),
                    isAffineHostGroupName: false,
                    isMandatory: false
                 }
              ];

               $scope.spec.selectedVmToHostRuleType = typesArray[0];

               if($scope.spec.operation === clusterRulesConstants.operationType.EDIT) {
                  _.each(typesArray, function(type) {
                     if (type.isMandatory === $scope.spec.vmToHostRuleProperties.isMandatory &&
                           type.isAffineHostGroupName === $scope.spec.vmToHostRuleProperties.isAffineHostGroupName) {
                        $scope.spec.selectedVmToHostRuleType = type;
                     }
                  });
               }
               return typesArray;
            }

            function getString(key) {
               return i18nService.getString('ClusterUi', key);
            }
         }]
      };
   }
})();

/*
 *  Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential
 */

(function() {
   /**
    * Directive for affinity and anti-affinity rule details.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'affinityRuleDetails', affinityRuleDetails);

   affinityRuleDetails.$inject = ['i18nService', 'clusterRulesService',
         'clusterRulesConstants', 'vuiConstants', 'defaultUriSchemeUtil',
         'datagridActionBarService'];

   function affinityRuleDetails(i18nService, clusterRulesService, clusterRulesConstants,
         vuiConstants, defaultUriSchemeUtil, datagridActionBarService) {

      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/rules/affinityRuleDetails.html',
         scope: {
            rule: '='
         },
         controller: ['$scope', '$rootScope', function($scope, $rootScope) {
            var objectId = $rootScope._route.objectId;

            $scope.ruleMembersGridOptions = getRuleMembersGridOptions();
            $scope.conflictingRulesGridOptions = getConflictingRulesGridOptions();
            $scope.ruleDetailsTitle = i18nService.getString(
                  'ClusterUi', 'manage.settings.ruleDetails');
            $scope.$watch('rule', onRuleChange);

            var actionSpecs = [{
               actionId: 'vsphere.core.cluster.actions.rule.members.add',
               getActionInvocationContext: function() {
                  return {
                     selectedMembers: $scope.ruleMembersGridOptions.data,
                     dialogSubTitleObject: {
                        text: $scope.rule.name
                     },
                     submitCallback: function(dialogOptions) {
                        dialogOptions.isAlertClosed = true;
                        dialogOptions.alerts = [];

                        if (_.isEmpty(dialogOptions.dialogData.selectedItems)) {
                           dialogOptions.alerts = [{
                              text: i18nService.getString(
                                    'CommonUi', 'objectSelectorDialog.noSelection'),
                              type: vuiConstants.validationBanner.type.ERROR
                           }];
                           dialogOptions.isAlertClosed = false;

                           return false;
                        }

                        return clusterRulesService
                              .addRuleMembers(objectId, $scope.rule, dialogOptions.dialogData.selectedItems)
                              .then(function() {
                                 return true;
                              })
                              .catch(function() {
                                 return false;
                              });
                     }
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available && !!$scope.rule;
               }
            }, {
               actionId: 'vsphere.core.cluster.actions.rule.members.details',
               getActionInvocationContext: function() {
                  return {
                     selectedRule: $scope.rule,
                     selectedMember: _.first(_.filter(
                           $scope.rule.members,
                           function(member) {
                              return defaultUriSchemeUtil.getVsphereObjectId(member.entity) ===
                                    $scope.ruleMembersGridOptions.selectedItems[0].id;

                           }))
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available &&
                        $scope.ruleMembersGridOptions.selectedItems.length === 1 &&
                        $scope.ruleMembersGridOptions.selectedItems[0].conflictsCount > 0;
               }
            }, {
               actionId: 'vsphere.core.cluster.actions.rule.members.remove',
               getActionInvocationContext: function() {
                  return {
                     isExistingRule: true,
                     rule: $scope.rule,
                     membersToRemove: $scope.ruleMembersGridOptions.selectedItems,
                     confirmCallback: function() {
                        clusterRulesService.removeRuleMembers(objectId, $scope.rule, $scope.ruleMembersGridOptions.selectedItems);
                        return true;
                     }
                  };
               },
               isActionAvailable: function(actionDef) {
                  return actionDef.available && $scope.ruleMembersGridOptions.selectedItems.length > 0;
               }
            }];
            var datagridActionBarServiceCacheObject = null;

            $scope.$watch('ruleMembersGridOptions.selectedItems', function() {
               refreshActionBar();
            });

            createActionBar();

            function createActionBar() {
               datagridActionBarService
                     .updateActionBar($scope.ruleMembersGridOptions, [objectId], actionSpecs)
                     .then(function(value) {
                        datagridActionBarServiceCacheObject = value;
                     });
            }

            function refreshActionBar() {
               if (!datagridActionBarServiceCacheObject) {
                  return;
               }

               datagridActionBarService.updateActionBar(
                     $scope.ruleMembersGridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
               );
            }

            function getRuleMembersGridOptions() {
               var options = {
                  actionBarOptions: {
                     actions: []
                  },
                  searchable: false,
                  resizable: true,
                  data: [],
                  columnDefs: getRuleMembersGridColumnDefs(),
                  selectionMode: vuiConstants.grid.selectionMode.MULTI,
                  showCheckboxesOnMultiSelection: false,
                  selectedItems: [],
                  height: '100%',
                  pageConfig: {
                     hidePager: true
                  }
               };

               return options;
            }

            function getConflictingRulesGridOptions() {
               var options = {
                  searchable: false,
                  resizable: false,
                  data: [],
                  columnDefs: getConflictingRulesGridColumnDefs(),
                  height: '100%',
                  pageConfig: {
                     hidePager: true
                  }
               };

               return options;
            }

            function getRuleMembersGridColumnDefs() {
               return [{
                  displayName: i18nService.getString(
                        'ClusterUi', 'rules.vmRuleDetails.ruleMembers'),
                  field: 'name',
                  type: 'string',
                  template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
               }, {
                  displayName: i18nService.getString(
                        'ClusterUi', 'rules.vmRuleDetails.conflicts'),
                  field: 'conflictsCount',
                  type: 'string',
                  template: '<span title="#:conflictsCount#">#:conflictsCount#</span>'
               }];
            }

            function getConflictingRulesGridColumnDefs() {
               return [
                  {
                     displayName: i18nService.getString(
                           'ClusterUi', 'rules.vmRuleDetails.conflicts'),
                     field: 'name',
                     type: 'string',
                     template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
                  }
               ];
            }

            function getAffinityRuleDetailsLabel() {
               var ruleDetailsLabel = '';

               if ($scope.rule) {
                  if ($scope.rule.type === clusterRulesConstants.ruleType.VM_AFFINITY_RULE) {
                     ruleDetailsLabel = i18nService.getString(
                           'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmAffinity',
                           $scope.rule.members.length
                     );
                  }

                  if ($scope.rule.type === clusterRulesConstants.ruleType.VM_ANTIAFFINITY_RULE) {
                     ruleDetailsLabel = i18nService.getString(
                           'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmAntiAffinity',
                           $scope.rule.members.length
                     );
                  }
               }

               return ruleDetailsLabel;
            }

            function onRuleChange() {
               $scope.ruleMembersGridOptions.data = [];
               $scope.conflictingRulesGridOptions.data = [];

               if ($scope.rule) {
                  clusterRulesService.getAffinityRulesMembersData($scope.rule)
                        .then(function(membersData) {
                           $scope.ruleMembersGridOptions.data = membersData;
                        });
                  $scope.conflictingRulesGridOptions.data =
                        clusterRulesService.getConflictingRulesData($scope.rule.conflictingRules);
               }

               $scope.ruleDetailsLabel = getAffinityRuleDetailsLabel();
            }
         }]
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('ViewDetailsClusterRuleMemberController',
               ViewDetailsClusterRuleMemberController);

   ViewDetailsClusterRuleMemberController.$inject = ['$scope', 'i18nService',
         'clusterRulesService', 'vuiConstants', 'clusterRulesConstants',
         'defaultUriSchemeUtil'];

   function ViewDetailsClusterRuleMemberController($scope, i18nService,
        clusterRulesService, vuiConstants, clusterRulesConstants, defaultUriSchemeUtil) {

      var self = this;
      self.conflictsGridData = getGridData(getConflictsDescColumnDefs(),
            vuiConstants.grid.selectionMode.MULTI);
      self.membersRulesGridData = getGridData(getConflictingRulesColumnDefs(),
            vuiConstants.grid.selectionMode.SINGLE);

      getViewData();

      function getViewData() {
         getConflictsMessages(
               $scope.modalOptions.dialogData.member.conflicts,
               $scope.modalOptions.dialogData.rule.name);
      }

      function getGridData(columnDefs, selection) {
         var options = {
            pageConfig: {
               hidePager: true
            },
            searchable: false,
            resizable: false,
            data: [],
            selectionMode: selection,
            showCheckboxesOnMultiSelection: false,
            selectedItems: [],
            columnDefs: columnDefs,
            height: '100%'
         };
         return options;
      }

      function getConflictingRulesColumnDefs() {
         return [{
            displayName: i18nService.getString('ClusterUi', 'rules.vmRuleMemberDetails.ruleName'),
            field: 'name',
            type: 'string',
            template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
         }];
      }

      function getConflictsDescColumnDefs() {
         return [{
            displayName: i18nService.getString('ClusterUi', 'rules.vmRuleMemberDetails.issue'),
            field: 'issue',
            type: 'string',
            template: '<span class="object" title="#:issue#"><i class="#:icon#")></i>#:issue#</span>'
         }];
      }

      function getRulesGridData(rules) {
         var ruleNames = [];
         _.each(rules, function(item) {
            if(item.rule.name !== $scope.modalOptions.dialogData.rule.name) {
               ruleNames.push({
                  name: item.rule.name,
                  icon: item.conflictingRules.length > 0 ?
                        'vx-icon-rule-conflict' : 'vx-icon-rule'
               });
            }
         });

        self.membersRulesGridData.data = ruleNames;
      }

      function getDescriptionByConflictType(conflict, vmNamesLabel, otherRuleType, otherRuleName) {
         var issue;
         switch (conflict.conflictType) {
            case clusterRulesConstants.conflictType.ANTIAFFINITY_ANTIAFFINITY:
            case clusterRulesConstants.conflictType.AFFINITY_AFFINITY:
               issue = i18nService.getString('ClusterUi',
                     "rules.vmRuleMemberDetails.affinityAffinityConflictDescription",
                     vmNamesLabel, otherRuleType, otherRuleName);
               break;

            case clusterRulesConstants.conflictType.AFFINITY_ANTIAFFINITY :
               issue = i18nService.getString('ClusterUi',
                     "rules.vmRuleMemberDetails.affinityAntiaffinityConflictDescription",
                     vmNamesLabel, otherRuleType, otherRuleName);
               break;
            default :
               issue = i18nService.getString('ClusterUi', "rules.vmRuleMemberDetails.unknownConflictDescription");
         }
         return issue;
      }

      function getVmNamesLabel(vmsNames){
         var index = 0;
         var vmNamesLabel = '';

         _.each(vmsNames, function(vmName) {
            if (index === 0) {
               vmNamesLabel = vmName;
            } else {
               if (index === vmsNames.length - 1) {
                  vmNamesLabel += ' ' + i18nService.getString('ClusterUi',
                              'rules.vmRuleMemberDetails.and') + ' ' + vmName;
               } else {
                  vmNamesLabel += ', ' + vmName;
               }
            }
            index++;
         });

         return vmNamesLabel;
      }

      function getAllConflictsMembers(conflicts) {
         var vms = [];
         _.each(conflicts, function(conflict) {
            vms = [].concat(conflict.members, vms);
         });

         return vms;
      }

      function getConflictsMessages(conflicts, parentRuleName) {
         var vms = getAllConflictsMembers(conflicts);
         var issueDescLabels = [];
         clusterRulesService.getVmNames(vms).then(function(vmsData){
            _.each(conflicts, function(conflict) {
               var vmNames = [];
               var otherRule = parentRuleName === conflict.rule1.rule.name ?
                     conflict.rule2 : conflict.rule1;
               var otherRuleName = otherRule.rule.name;
               var otherRuleType =
                     clusterRulesConstants.ruleType.VM_AFFINITY_RULE === otherRule.ruleType ?
                           i18nService.getString('ClusterUi', 'rules.vmRuleMemberDetails.affinity') :
                           i18nService.getString('ClusterUi', 'rules.vmRuleMemberDetails.antiAffinity');

               _.each(conflict.members, function(member) {
                  var vmId = defaultUriSchemeUtil.getVsphereObjectId(member.entity);
                  vmNames.push(vmsData[vmId].name);
               });

               var vmNamesLabel = getVmNamesLabel(vmNames);
               issueDescLabels.push(
                     {
                        issue: getDescriptionByConflictType(conflict, vmNamesLabel,
                              otherRuleType, otherRuleName),
                        icon: 'vx-icon-error'
                     });
            });
            self.conflictsGridData.data = issueDescLabels;

            // setting the data here is needed in order to properly size the second grid
            // otherwise the grid doesn't refresh its data and its scroller doesn't exist
            getRulesGridData($scope.modalOptions.dialogData.member.rules);

         });
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('VmAndHostRulesController', VmAndHostRulesController);

   VmAndHostRulesController.$inject = ['$scope', 'i18nService', 'clusterRulesService',
         'vuiConstants', 'clusterRulesConstants', 'datagridActionBarService'];

   function VmAndHostRulesController($scope, i18nService, clusterRulesService,
          vuiConstants, clusterRulesConstants, datagridActionBarService) {

      var self = this;
      var simpleTextWithTitleKendoRendererFunction = kendo.template('<span title="#:data#">#:data#</span>');
      var objectId = $scope._route.objectId;
      var actionSpecs = [{
         actionId: 'vsphere.core.cluster.actions.rule.add'
      }, {
         actionId: 'vsphere.core.cluster.actions.rule.edit',
         getActionInvocationContext: function() {
            return {
               selectedRule: self.selectedRule
            };
         },
         isActionAvailable: function(actionDef) {
            return actionDef.available && self.gridOptions.selectedItems.length > 0;
         }
      }, {
         actionId: 'vsphere.core.cluster.actions.rule.remove',
         getActionInvocationContext: function() {
            return {
               selectedRule: self.selectedRule
            };
         },
         isActionAvailable: function(actionDef) {
            return actionDef.available && self.gridOptions.selectedItems.length > 0;
         }
      }];
      var datagridActionBarServiceCacheObject = null;

      self.VM_AFFINITY_RULE_TYPE = clusterRulesConstants.ruleType.VM_AFFINITY_RULE;
      self.VM_ANTIAFFINITY_RULE_TYPE = clusterRulesConstants.ruleType.VM_ANTIAFFINITY_RULE;
      self.VM_HOST_GROUP_RULE_TYPE = clusterRulesConstants.ruleType.VM_HOST_GROUP_RULE;
      self.VM_DEPENDENCY_RULE_TYPE = clusterRulesConstants.ruleType.VM_DEPENDENCY_RULE;

      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
            "configurationEx.dasConfig.option",
            "configurationEx.dasConfig.enabled",
            "configurationEx.rule"
      ];
      self.getViewData = getViewData;
      self.gridOptions = getGridOptions();
      self.selectedRule = null;

      $scope.rulesPreselectComparator = rulesPreselectComparator;

      self.rulesTitle = i18nService.getString('ClusterUi', 'manage.settings.rules');

      self.noSelectedItems = i18nService.getString('ClusterUi',
            'rules.view.noRuleSelected');

      $scope.$watch('ctrl.gridOptions.selectedItems', onSelectedRuleChange);
      $scope.$watch(
            function() {
               return self.selectedRule;
            }, function() {
               refreshActionBar();
            });

      getViewData();
      createActionBar();

      function getViewData() {
         clusterRulesService.getRulesData(objectId).then(function(data) {
            self.gridOptions.data = _.map(data.rules, function(rule) {
               return angular.merge({
                  _original: rule
               }, rule);
            });
            keepSelectionOrPreselectFirst();
         });
      }

      function createActionBar() {
         datagridActionBarService
               .updateActionBar(self.gridOptions, [objectId], actionSpecs)
               .then(function(value) {
                  datagridActionBarServiceCacheObject = value;
               });
      }

      function refreshActionBar() {
         if (!datagridActionBarServiceCacheObject) {
            return;
         }

         datagridActionBarService.updateActionBar(
               self.gridOptions, [objectId], actionSpecs, datagridActionBarServiceCacheObject
         );
      }

      function keepSelectionOrPreselectFirst() {
         if (self.gridOptions.data && self.gridOptions.data.length > 0) {
            var itemToPreselect;

            if (self.selectedRule) {
               itemToPreselect = _.find(self.gridOptions.data, {
                  name: self.selectedRule.name
               });
            }

            self.selectedRule = !!itemToPreselect ?
                  itemToPreselect._original : self.gridOptions.data[0]._original;
         }
      }

      function onSelectedRuleChange(newSelectedItems) {
         if (!newSelectedItems || newSelectedItems.length === 0) {
            self.selectedRule = null;
            return;
         }
         //compare new selected item name with current selected rule name
         //instead of with old selected item name from grid to prevent changing the
         //selecting rule twice on preselect and triggering its watcher twice
         if (self.selectedRule && newSelectedItems[0].name === self.selectedRule.name) {
            return;
         }

         self.selectedRule = newSelectedItems[0]._original;
      }

      function getGridOptions() {
         return {
            actionBarOptions: {
               actions: []
            },
            searchable: false,
            resizable: true,
            data: [],
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            columnDefs: getColumnDefs(),
            height: '100%',
            pageConfig: {
               hidePager: true
            }
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: i18nService.getString('ClusterUi', 'rules.list.name'),
               field: 'name',
               type: 'string',
               template: '<span class="object" title="#:name#"><i class="#:icon#")></i>#:name#</span>'
            },
            {
               displayName: i18nService.getString('ClusterUi', 'rules.list.type'),
               field: 'typeText',
               type: 'string',
               template: '<span title="#:typeText#">#:typeText#</span>'
            },
            {
               displayName: i18nService.getString('ClusterUi', 'rules.list.enabled'),
               field: 'enabled',
               type: 'boolean',
               template: enabledTextRenderer
            },
            {
               displayName: i18nService.getString('ClusterUi', 'rules.list.conflicts'),
               field: 'conflictingRules.length',
               type: 'string',
               template: '<span title="#:conflictingRules.length#">#:conflictingRules.length#</span>'
            },
            {
               displayName: i18nService.getString('ClusterUi', 'rules.list.definedBy'),
               field: 'userCreated',
               type: 'boolean',
               template: definedByTextRenderer
            }
         ];
      }

      function enabledTextRenderer(data) {
         var text = (data.enabled) ?
               i18nService.getString('ClusterUi', 'rules.list.enabled.yes') :
               i18nService.getString('ClusterUi', 'rules.list.enabled.no');
         return simpleTextWithTitleKendoRendererFunction(text);
      }

      function definedByTextRenderer(data) {
         var text = (data.userCreated) ?
               i18nService.getString('ClusterUi', 'rules.list.definedBy.user') :
               i18nService.getString('ClusterUi', 'rules.list.definedBy.system');
         return simpleTextWithTitleKendoRendererFunction(text);
      }

      function rulesPreselectComparator(ruleItem) {
         return self.selectedRule && ruleItem &&
               self.selectedRule.name === ruleItem.name;
      }
   }
})();

/*
 *  Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential
 */

(function() {
   /**
    * Directive for VM to VM rule details.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
      'vmDependencyRuleDetails', vmDependencyRuleDetails);

   vmDependencyRuleDetails.$inject = ['$rootScope', 'i18nService', 'clusterGroupsService'];

   function vmDependencyRuleDetails($rootScope, i18nService, clusterGroupsService) {

      return {
         restrict: 'E',
         templateUrl:
            'cluster-ui/resources/cluster/views/settings/rules/vmDependencyRuleDetails.html',
         scope: {
            rule: '='
         },
         controller: ['$scope', function($scope) {
            var objectId = $rootScope._route.objectId;

            $scope.ruleDetailsTitle = i18nService.getString(
               'ClusterUi', 'manage.settings.ruleDetails');
            $scope.dependsOnVmGroup = null;
            $scope.vmGroup = null;

            $scope.$watch('rule', function(rule) {
               if (rule) {
                  clusterGroupsService.getRuleGroupsData(objectId, rule)
                        .then(function(ruleGroups) {
                           $scope.dependsOnVmGroup =
                                 clusterGroupsService.getGroupByName(ruleGroups,
                                       rule.vmDependencyRuleProperties.dependsOnVmGroup);
                           $scope.vmGroup = clusterGroupsService.getGroupByName(
                                 ruleGroups, rule.vmDependencyRuleProperties.vmGroup);
                        });
                  $scope.ruleDetailsLabel = getVmDependencyRuleLabel(rule);
               }
            });

            function getVmDependencyRuleLabel(rule) {
               return i18nService.getString('ClusterUi',
                     'rules.vmRuleDetails.typeDescription.vmDependency',
                     rule.vmDependencyRuleProperties.vmGroup,
                     rule.vmDependencyRuleProperties.dependsOnVmGroup);
            }
         }]
      };
   }
})();

/*
 *  Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential
 */

(function() {
   /**
    * Directive for VM to host rule details.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster').directive(
      'vmToHostRuleDetails', vmToHostRuleDetails);

   vmToHostRuleDetails.$inject = ['$rootScope', 'i18nService', 'clusterGroupsService'];

   function vmToHostRuleDetails($rootScope, i18nService, clusterGroupsService) {

      return {
         restrict: 'E',
         templateUrl:
            'cluster-ui/resources/cluster/views/settings/rules/vmToHostRuleDetails.html',
         scope: {
            rule: '='
         },
         controller: ['$scope', function($scope) {
            var objectId = $rootScope._route.objectId;

            $scope.ruleDetailsTitle = i18nService.getString(
               'ClusterUi', 'manage.settings.ruleDetails');
            $scope.vmGroup = null;
            $scope.hostGroup = null;

            $scope.$watch('rule', function(rule) {
               if (rule) {
                  if (hasVmGroup(rule) || hasHostGroup(rule)) {
                     clusterGroupsService.getRuleGroupsData(objectId, rule)
                        .then(function(ruleGroups) {
                           $scope.vmGroup = clusterGroupsService.getGroupByName(
                              ruleGroups, rule.vmToHostRuleProperties.vmGroupName);
                           $scope.hostGroup = clusterGroupsService.getGroupByName(
                              ruleGroups, rule.vmToHostRuleProperties.hostGroupName);
                        });
                  }
                  $scope.ruleDetailsLabel = getVmToHostRuleLabel(
                        rule.vmToHostRuleProperties);
               }
            });

            function getVmToHostRuleLabel(rule) {
               var ruleDetailsLabel = '';

               if(rule.isAffineHostGroupName === true && rule.isMandatory === true) {
                  ruleDetailsLabel = i18nService.getString(
                     'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmHostGroup.hard');
               }

               if(rule.isAffineHostGroupName === true && rule.isMandatory === false) {
                  ruleDetailsLabel = i18nService.getString(
                     'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmHostGroup.soft');
               }

               if(rule.isAffineHostGroupName === false && rule.isMandatory === true) {
                  ruleDetailsLabel = i18nService.getString(
                     'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmHostSeparate.hard');
               }

               if(rule.isAffineHostGroupName === false && rule.isMandatory === false) {
                  ruleDetailsLabel = i18nService.getString(
                     'ClusterUi', 'rules.vmRuleDetails.typeDescription.vmHostSeparate.soft');
               }

               return ruleDetailsLabel;
            }

            function hasVmGroup(rule) {
               return rule.vmToHostRuleProperties.vmGroupName !== null &&
                     rule.vmToHostRuleProperties.vmGroupName !== undefined;
            }

            function hasHostGroup(rule) {
               return rule.vmToHostRuleProperties.hostGroupName !== null &&
                     rule.vmToHostRuleProperties.hostGroupName !== undefined;
            }
         }]
      };
   }
})();

var cluster_ui;
(function (cluster_ui) {
    var EditDrsDialogController = (function () {
        function EditDrsDialogController($scope, dataService, vcService, $q, drsConstants) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.vcService = vcService;
            this.$q = $q;
            this.drsConstants = drsConstants;
            this.objectId = $scope.modalOptions.dialogData.objectId;
            this.$scope.modalOptions.dialogData.manager.setObjectId(this.objectId);
            this.$scope.modalOptions.dialogData.manager.setDrsDialogOptions(this.$scope.modalOptions);
            this.$scope.modalOptions.isAlertClosed = true;
            this.getViewData();
        }
        EditDrsDialogController.prototype.getSelectedPageUrl = function () {
            var _this = this;
            var selectedPage = _.find(this.$scope.pages.categories, function (page) {
                return page.id === _this.$scope.selectedCategoryId;
            });
            if (selectedPage) {
                return selectedPage.contentUrl;
            }
            return "";
        };
        EditDrsDialogController.prototype.getViewData = function () {
            var _this = this;
            this.setPageBusy(true);
            var promises = [];
            var vcVersionPromise = this.vcService.is65VcOrLater(this.objectId)
                .then(function (is65VcOrLater) {
                _this.is65VcOrLater = is65VcOrLater;
                _this.$scope.pages = {
                    categories: _this.$scope.modalOptions.dialogData.manager.getPageDefinitions(false)
                };
                _this.$scope.selectedCategoryId = _this.$scope.pages.categories[0].id;
                _this.$scope.selectCategory = function (categoryId) {
                    _this.$scope.selectedCategoryId = categoryId;
                };
            });
            var requestDataPromise = this.dataService
                .getData(this.objectId, 'com.vmware.vsphere.client.clusterui.model.services.DrsConfigData')
                .then(function (drsData) {
                _.extend(_this.$scope.modalOptions.dialogData.editDrsData, drsData);
                _this.setPageBusy(false);
            });
            promises.push(vcVersionPromise);
            promises.push(requestDataPromise);
            this.$q.all(promises).then(function () {
                var drsData = _this.$scope.modalOptions.dialogData.editDrsData;
                _this.$scope.modalOptions.dialogData.manager.setFormData(drsData, _this.is65VcOrLater, false);
                _this.formData = _this.$scope.modalOptions.dialogData.manager.getFormData();
                _this.addWatchers();
            });
        };
        EditDrsDialogController.prototype.addWatchers = function () {
            var _this = this;
            this.$scope.$watch('ctrl.formData.drsPolicies.allConsumedMemoryMetric', this.allConsumedMemoryMetricChanged.bind(this));
            this.$scope.$watch(function () {
                var allConsumedMemoryMetricOption = _this.formData
                    .advancedOptionsBuilder.getOptionByKey(_this.drsConstants.drsPolicies
                    .ALL_CONSUMED_MEMORY_METRIC_OPTION);
                return allConsumedMemoryMetricOption &&
                    allConsumedMemoryMetricOption.value;
            }, function (optionValue) {
                _this.formData.drsPolicies.allConsumedMemoryMetric =
                    !!optionValue && parseInt(optionValue) > 0;
            });
        };
        EditDrsDialogController.prototype.allConsumedMemoryMetricChanged = function (allConsumedMemoryMetric) {
            var allConsumedMemoryMetricOption = this.formData.advancedOptionsBuilder.getOptionByKey(this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_OPTION);
            if (!allConsumedMemoryMetric) {
                if (allConsumedMemoryMetricOption) {
                    this.formData.advancedOptionsBuilder
                        .removeOption(allConsumedMemoryMetricOption.id);
                }
            }
            else if (!allConsumedMemoryMetricOption) {
                this.formData.advancedOptionsBuilder.addOption({
                    key: this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_OPTION,
                    value: this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_VALUE
                });
            }
        };
        EditDrsDialogController.prototype.setPageBusy = function (busy) {
            this.loading = busy;
            this.$scope.modalOptions.submitDisabled = busy;
        };
        EditDrsDialogController.$inject = ["$scope", "dataService", "vcService", "$q",
            "drsConstants"];
        return EditDrsDialogController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("EditDrsDialogController", EditDrsDialogController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditDrsDialogManager = (function () {
        function EditDrsDialogManager(i18nService, drsConstants, dpmThresholdService, advancedOptionsBuilderFactory, clusterSpecBuilderService, mutationService, $q, editDrsFileDownloadService, clusterConstants, clarityModalService, clarityConstants) {
            this.i18nService = i18nService;
            this.drsConstants = drsConstants;
            this.dpmThresholdService = dpmThresholdService;
            this.advancedOptionsBuilderFactory = advancedOptionsBuilderFactory;
            this.clusterSpecBuilderService = clusterSpecBuilderService;
            this.mutationService = mutationService;
            this.$q = $q;
            this.editDrsFileDownloadService = editDrsFileDownloadService;
            this.clusterConstants = clusterConstants;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
        }
        EditDrsDialogManager.prototype.setDrsDialogOptions = function (drsDialogOptions) {
            this.drsDialogOptions = drsDialogOptions;
        };
        EditDrsDialogManager.prototype.submit = function () {
            var _this = this;
            this.formData.drsPolicies.cpuOvercommitmentValue =
                Math.round(parseFloat(this.formData.drsPolicies.cpuOvercommitmentValue));
            var clusterSpec = this.clusterSpecBuilderService.buildClusterComputeResourceSpec(this.formData, true);
            return this.mutationService.validate(this.objectId, 'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec', clusterSpec)
                .then(this.handleValidationResult.bind(this))
                .then(function () {
                _this.mutationService.apply(_this.objectId, 'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec', clusterSpec);
                return true;
            }, function () { return _this.$q.resolve(false); })
                .catch(function (error) {
                _this.$q.reject(error);
            });
        };
        EditDrsDialogManager.prototype.getPageDefinitions = function (isScheduledTask) {
            var pages = [];
            var pageDefinitions = this.getPageDefs();
            if (isScheduledTask) {
                pages.push(pageDefinitions.drsAutomationLevelDef.page);
                pages.push(pageDefinitions.additionalOptionsDef.page);
                pages.push(pageDefinitions.dpmAutomationDef.page);
            }
            else {
                pages.push(pageDefinitions.drsAutomationLevelDef.page);
                pages.push(pageDefinitions.additionalOptionsDef.page);
                pages.push(pageDefinitions.dpmAutomationDef.page);
                pages.push(pageDefinitions.advancedOptionsDef.page);
            }
            return pages;
        };
        EditDrsDialogManager.prototype.setObjectId = function (objectId) {
            this.objectId = objectId;
        };
        EditDrsDialogManager.prototype.getObjectId = function () {
            return this.objectId;
        };
        EditDrsDialogManager.prototype.setFormData = function (drsData, is65VcOrLater) {
            var drsPolicies = {
                allConsumedMemoryMetric: drsData.allConsumedMemoryMetricEnabled,
                cpuOvercommitment: drsData.cpuOverCommitment,
                cpuOvercommitmentValue: drsData.cpuOverCommitmentPercent
            };
            if (is65VcOrLater) {
                drsPolicies.evenDistribution = drsData.evenDistributionEnabled;
            }
            this.formData = {
                is65VcOrLater: is65VcOrLater,
                drsEnabled: drsData.drsEnabled,
                drsAutomation: {
                    automationLevel: {
                        id: drsData.defaultDrsBehavior
                    },
                    migrationThreshold: drsData.migrationThreshold,
                    vmAutomation: drsData.vmAutomationEnabled,
                    proactiveDrsEnabled: drsData.proactiveDrsEnabled
                },
                drsPolicies: drsPolicies,
                dpmAutomation: {
                    automationLevel: {
                        id: this.getDpmAutomationLevel(drsData)
                    },
                    dpmThreshold: this.dpmThresholdService
                        .reverseDpmRateAndThreshold(drsData.dpmRate)
                },
                scheduledTasksCount: drsData.scheduledTasksCount
            };
            this.formData.advancedOptionsBuilder =
                this.advancedOptionsBuilderFactory.getBuilder(drsData.advancedOptions, true);
        };
        EditDrsDialogManager.prototype.getFormData = function () {
            return this.formData;
        };
        EditDrsDialogManager.prototype.getDpmPageModel = function () {
            return {
                dpmAutomation: this.formData.dpmAutomation
            };
        };
        EditDrsDialogManager.prototype.getAdditionalOptionsPageModel = function () {
            return {
                drsPolicies: this.formData.drsPolicies,
                is65VcOrLater: this.formData.is65VcOrLater
            };
        };
        EditDrsDialogManager.prototype.getDrsAutomationLevelPageModel = function () {
            return {
                is65VcOrLater: this.formData.is65VcOrLater,
                drsAutomation: this.formData.drsAutomation
            };
        };
        EditDrsDialogManager.prototype.getAdvancedOptionsPageModel = function () {
            return {
                advancedOptionsBuilder: this.formData.advancedOptionsBuilder
            };
        };
        EditDrsDialogManager.prototype.getPageDefs = function () {
            // page definitions
            var drsAutomationLevelDef = {
                page: {
                    id: 'drsAutomationLevel',
                    title: this.i18nService.getString('ClusterUi', 'drs.config.dialog.automationLabel'),
                    contentUrl: 'cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/drsAutomationLevelPage.html'
                }
            };
            var additionalOptionsDef = {
                page: {
                    id: 'additionalOptions',
                    title: this.i18nService.getString('ClusterUi', 'drs.config.drsPoliciesLabel'),
                    contentUrl: 'cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/additionalOptionsPage.html'
                }
            };
            var dpmAutomationDef = {
                page: {
                    id: 'dpmAutomation',
                    title: this.i18nService.getString('ClusterUi', 'drs.config.dpmLabel'),
                    contentUrl: 'cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/dpmAutomationPage.html'
                }
            };
            var advancedOptionsDef = {
                page: {
                    id: 'advancedOptions',
                    title: this.i18nService.getString('ClusterUi', 'drs.config.advancedOptionsLabel'),
                    contentUrl: 'cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/drsAdvancedOptionsPage.html'
                }
            };
            return {
                drsAutomationLevelDef: drsAutomationLevelDef,
                additionalOptionsDef: additionalOptionsDef,
                dpmAutomationDef: dpmAutomationDef,
                advancedOptionsDef: advancedOptionsDef
            };
        };
        EditDrsDialogManager.prototype.getDpmAutomationLevel = function (drsData) {
            return drsData.dpmEnabled ?
                drsData.defaultDpmBehavior : this.drsConstants.dpmAutomationLevel.DISABLED;
        };
        EditDrsDialogManager.prototype.handleValidationResult = function (validationResult) {
            var title;
            if (!validationResult ||
                (!validationResult.error && (!validationResult.result ||
                    validationResult.result.isValid === true))) {
                return this.$q.resolve();
            }
            else if (validationResult.error) {
                var message = validationResult.error.localizedMessage ?
                    validationResult.error.localizedMessage : validationResult.error.message;
                this.showValidationMessages(message);
                return this.$q.reject();
            }
            else {
                if (validationResult.result.errorCode === this.clusterConstants.
                    editClusterErrorCodes.DRS_OFF_WITH_RESOURCE_POOLS) {
                    return this.editDrsFileDownloadService.showYesNoCancelDialog(this.objectId);
                }
                else if (validationResult.result.errorCode === this.clusterConstants.
                    editClusterErrorCodes.DPM_ON_WITH_HOSTS_STANDBY) {
                    title = this.i18nService.getString("ClusterUi", "drs.config.editDrs.dpmTurningOnCaption");
                    return this.showConfirmationDialog(title, validationResult.result.validationMessage, validationResult.result.validationData);
                }
                else {
                    var validationMessages = [validationResult.result.validationMessage];
                    this.showValidationMessages(validationMessages);
                    return this.$q.reject();
                }
            }
        };
        EditDrsDialogManager.prototype.showConfirmationDialog = function (title, message, invalidHosts) {
            var deferred = this.$q.defer();
            var titleText = title;
            var messageText = message;
            _.each(invalidHosts, function (host) {
                messageText += "\n" + host;
            });
            var modalOptions = {
                title: titleText,
                message: messageText,
                submit: function () { return deferred.resolve(true); },
                onCancel: function () { return deferred.reject(); },
                preserveNewlines: true,
                modalClass: "turn-on-dpm-confirmation-modal"
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
            return deferred.promise;
        };
        EditDrsDialogManager.prototype.showValidationMessages = function (messages) {
            var _this = this;
            var validationErrorMessages = _.map(messages, function (message) {
                return {
                    type: _this.clarityConstants.notifications.type.ERROR,
                    text: message
                };
            });
            this.drsDialogOptions.isAlertClosed = false;
            this.drsDialogOptions.alerts = validationErrorMessages;
        };
        EditDrsDialogManager.$inject = ["i18nService", "drsConstants", "dpmThresholdService",
            "advancedOptionsBuilderFactory", "clusterSpecBuilderService",
            "mutationService", "$q", "editDrsFileDownloadService",
            "clusterConstants", "clarityModalService", "clarityConstants"];
        return EditDrsDialogManager;
    }());
    cluster_ui.EditDrsDialogManager = EditDrsDialogManager;
    angular.module("com.vmware.vsphere.client.cluster")
        .factory("EditDrsDialogManager", ["i18nService",
        "drsConstants",
        "dpmThresholdService",
        "advancedOptionsBuilderFactory",
        "clusterSpecBuilderService",
        "mutationService",
        "$q",
        "editDrsFileDownloadService",
        "clusterConstants",
        "clarityModalService",
        "clarityConstants",
        function () {
            return Function.prototype.bind.apply(EditDrsDialogManager, [undefined,
                arguments[0],
                arguments[1],
                arguments[2],
                arguments[3],
                arguments[4],
                arguments[5],
                arguments[6],
                arguments[7],
                arguments[8],
                arguments[9],
                arguments[10]
            ]);
        }
    ]);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditDrsDialogService = (function () {
        function EditDrsDialogService($q, i18nService, clarityModalService, dataService, EditDrsDialogManager) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.dataService = dataService;
            this.EditDrsDialogManager = EditDrsDialogManager;
        }
        EditDrsDialogService.prototype.show = function (clusterId, focusTarget) {
            var editDrsData = {};
            var modalOptions = {};
            var editDrsDialogManager = new this.EditDrsDialogManager();
            _.extend(modalOptions, {
                title: this.i18nService.getString('ClusterUi', 'editClusterSettingsDialog.title'),
                subTitle: {
                    objectId: clusterId
                },
                defaultButton: 'submit',
                contentTemplate: 'cluster-ui/resources/cluster/views/settings/services/drs/edit/EditDrsDialog.html',
                size: 'lg',
                onSubmit: editDrsDialogManager.submit.bind(editDrsDialogManager),
                modalClass: 'edit-cluster-drs-dialog',
                focusTarget: focusTarget,
                dialogData: {
                    editDrsData: editDrsData,
                    manager: editDrsDialogManager,
                    objectId: clusterId,
                    pageModel: null
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        EditDrsDialogService.$inject = ["$q", "i18nService", "clarityModalService", "dataService", "EditDrsDialogManager"];
        return EditDrsDialogService;
    }());
    cluster_ui.EditDrsDialogService = EditDrsDialogService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("editDrsDialogService", EditDrsDialogService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditDrsFileDownloadController = (function () {
        function EditDrsFileDownloadController($scope, $element, editDrsFileDownloadService) {
            this.$scope = $scope;
            this.$element = $element;
            this.editDrsFileDownloadService = editDrsFileDownloadService;
            this.DOWNLOAD_LINK_SELECTOR = ".edit-cluster-drs-dialog-confirmation-modal-download-section a";
            this.objectId = this.$scope.modalOptions.dialogData.objectId;
            this.getViewData();
        }
        EditDrsFileDownloadController.prototype.getViewData = function () {
            var _this = this;
            this.editDrsFileDownloadService.getSnapshotTreeData(this.objectId)
                .then(function (response) {
                if (response && response.rpTreeSnapshot && response.name) {
                    _this.rpTreeSnapshotData = response.rpTreeSnapshot;
                    _this.clusterName = response.name;
                }
            });
        };
        EditDrsFileDownloadController.prototype.saveSnapshot = function () {
            if (this.rpTreeSnapshotData && this.clusterName && this.clusterName !== "") {
                var fileData = this.editDrsFileDownloadService.createFileFromData(this.rpTreeSnapshotData, this.clusterName);
                // Handle IE saving file
                if (window.navigator && window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(fileData.fileAsBlob, fileData.fileName);
                }
                else {
                    var downloadLinkElement = this.$element.find(this.DOWNLOAD_LINK_SELECTOR)[0];
                    downloadLinkElement.href = fileData.fileUrl;
                    downloadLinkElement.download = fileData.fileName;
                    downloadLinkElement.click();
                }
            }
        };
        EditDrsFileDownloadController.prototype.saveRpTreeAsSnapshotFile = function () {
            this.saveSnapshot();
            this.$scope.modalOptions.dialogData.deferred.resolve();
            this.$scope.closeModal();
        };
        EditDrsFileDownloadController.prototype.turnOffDrsWithoutSavingRpTree = function () {
            this.$scope.modalOptions.dialogData.deferred.resolve();
            this.$scope.closeModal();
        };
        EditDrsFileDownloadController.prototype.closeConfirmationModal = function () {
            this.$scope.modalOptions.dialogData.deferred.reject();
            this.$scope.closeModal();
        };
        EditDrsFileDownloadController.$inject = [
            "$scope",
            "$element",
            "editDrsFileDownloadService"];
        return EditDrsFileDownloadController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("EditDrsFileDownloadController", EditDrsFileDownloadController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditDrsFileDownloadService = (function () {
        function EditDrsFileDownloadService($q, i18nService, clarityModalService, dataService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.dataService = dataService;
            this.FILE_EXTENSION = ".snapshot";
            this.FILE_FORMAT = "application/octet-stream";
        }
        EditDrsFileDownloadService.prototype.getSnapshotTreeData = function (objectId) {
            return this.dataService.getProperties(objectId, ["rpTreeSnapshot", "name"]);
        };
        EditDrsFileDownloadService.prototype.showYesNoCancelDialog = function (objectId) {
            var deferred = this.$q.defer();
            var context = {
                title: this.i18nService.getString("ClusterUi", "drs.config.editDrs.drsTurningOffCaption"),
                deferred: deferred,
                objectId: objectId
            };
            this.clarityModalService.openModal({}, {}, context, "cluster-ui/resources/cluster/views/settings/services/drs/edit/EditDrsFileDownloadDialog.html");
            return deferred.promise;
        };
        EditDrsFileDownloadService.prototype.createFileFromData = function (rpSnapshotTreeData, clusterName) {
            var byteArray = this.convertBase64DataToByteArray(rpSnapshotTreeData);
            var file = new Blob([byteArray], { type: this.FILE_FORMAT });
            var fileUrl = URL.createObjectURL(file);
            var fileName = clusterName + this.FILE_EXTENSION;
            return {
                fileAsBlob: file,
                fileUrl: fileUrl,
                fileName: fileName
            };
        };
        EditDrsFileDownloadService.prototype.convertBase64DataToByteArray = function (rpSnapshotTreeData) {
            var snapshotTreeData = atob(rpSnapshotTreeData);
            var byteArray = new Int8Array(new ArrayBuffer(snapshotTreeData.length * 2));
            _.each(snapshotTreeData, function (item, index) {
                byteArray[index] = item.charCodeAt(0);
            });
            return byteArray;
        };
        EditDrsFileDownloadService.$inject = ["$q", "i18nService", "clarityModalService", "dataService"];
        return EditDrsFileDownloadService;
    }());
    cluster_ui.EditDrsFileDownloadService = EditDrsFileDownloadService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("editDrsFileDownloadService", EditDrsFileDownloadService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var AdditionalOptionsPageController = (function () {
        function AdditionalOptionsPageController($scope, drsConstants, i18nService, additionalOptionsPageService) {
            this.$scope = $scope;
            this.drsConstants = drsConstants;
            this.i18nService = i18nService;
            this.additionalOptionsPageService = additionalOptionsPageService;
            this.CPU_OVERCOMMITMENT_MIN =
                this.drsConstants.drsPolicies.CPU_OVERCOMMITMENT_MIN;
            this.CPU_OVERCOMMITMENT_MAX =
                this.drsConstants.drsPolicies.CPU_OVERCOMMITMENT_MAX;
            this.pageModel =
                $scope.modalOptions.dialogData.manager.getAdditionalOptionsPageModel();
            this.drsPolicies = this.pageModel.drsPolicies;
            this.cpuOverCommitmentSignPostParams =
                this.additionalOptionsPageService.getCpuOverCommitmentSignPostParams();
            this.advancedOptionsBuilder =
                $scope.modalOptions.dialogData.manager.getFormData().advancedOptionsBuilder;
        }
        AdditionalOptionsPageController.prototype.normalizeCpuOvercommitment = function (event) {
            if (event.target.value === "" ||
                event.target.value < this.CPU_OVERCOMMITMENT_MIN) {
                this.drsPolicies.cpuOvercommitmentValue =
                    this.CPU_OVERCOMMITMENT_MIN;
            }
            if (event.target.value > this.CPU_OVERCOMMITMENT_MAX) {
                this.drsPolicies.cpuOvercommitmentValue =
                    this.CPU_OVERCOMMITMENT_MAX;
            }
        };
        AdditionalOptionsPageController.prototype.getString = function (key) {
            return this.i18nService.getString("ClusterUi", key);
        };
        AdditionalOptionsPageController.$inject = ["$scope", "drsConstants",
            "i18nService", "additionalOptionsPageService"];
        return AdditionalOptionsPageController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("AdditionalOptionsPageController", AdditionalOptionsPageController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var AdditionalOptionsPageService = (function () {
        function AdditionalOptionsPageService(i18nService) {
            this.i18nService = i18nService;
        }
        AdditionalOptionsPageService.prototype.getCpuOverCommitmentSignPostParams = function () {
            return {
                title: this.getString("help", "Common"),
                message: this.getString("drs.config.overcommitment.label")
            };
        };
        AdditionalOptionsPageService.prototype.getString = function (key, bundle) {
            return bundle ? this.i18nService.getString(bundle, key) :
                this.i18nService.getString("ClusterUi", key);
        };
        AdditionalOptionsPageService.$inject = ["i18nService"];
        return AdditionalOptionsPageService;
    }());
    cluster_ui.AdditionalOptionsPageService = AdditionalOptionsPageService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("additionalOptionsPageService", AdditionalOptionsPageService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DpmAutomationPageController = (function () {
        function DpmAutomationPageController($scope, dpmThresholdService, drsConstants, dpmAutomationLevelService, i18nService, dpmAutomationPageService) {
            var _this = this;
            this.$scope = $scope;
            this.dpmThresholdService = dpmThresholdService;
            this.drsConstants = drsConstants;
            this.dpmAutomationLevelService = dpmAutomationLevelService;
            this.i18nService = i18nService;
            this.dpmAutomationPageService = dpmAutomationPageService;
            this.pageModel = $scope.modalOptions.dialogData.manager.getDpmPageModel();
            this.dpmAutomation = this.pageModel.dpmAutomation;
            this.DPM_AUTOMATION_LEVEL_DISABLED = this.drsConstants.dpmAutomationLevel.DISABLED;
            this.automationLevels = this.dpmAutomationLevelService.getAutomationLevels();
            this.dpmAutomationLevelEnabled = this.dpmAutomation.automationLevel.id !==
                this.DPM_AUTOMATION_LEVEL_DISABLED;
            // Default value in the dropdown if the automation level is off
            this.dpmAutomationLevelValue =
                this.dpmAutomationLevelEnabled ?
                    this.dpmAutomation.automationLevel.id :
                    this.drsConstants.dpmAutomationLevel.MANUAL;
            this.dpmSliderOptions = this.dpmAutomationPageService.getSliderOptions(this.i18nService.getString('ClusterUi', 'drs.config.dpmThresholdLabel'));
            this.dpmAutomationLevelSignPostParams =
                this.dpmAutomationPageService.getDpmAutomationLevelSignPostParams();
            this.dpmThresholdInformationMessage =
                this.dpmAutomationPageService.getDpmThresholdDescription(this.dpmAutomation.dpmThreshold);
            this.dpmAutomationLevelValuesSignPostParams =
                this.dpmAutomationPageService.getDpmAutomationLevelValuesSignPostParams(this.dpmAutomationLevelEnabled, this.dpmAutomation.automationLevel.id);
            $scope.$watch(function () {
                return _this.dpmAutomation;
            }, function (newValue) {
                if (newValue) {
                    // Pre-select the DPM threshold value.
                    _this.dpmSliderOptions.value = _this.dpmAutomation.dpmThreshold;
                    _this.dpmThresholdInformationMessage =
                        _this.dpmAutomationPageService.getDpmThresholdDescription(_this.dpmAutomation.dpmThreshold);
                }
            });
            $scope.$watch(function () {
                return _this.dpmSliderOptions.value;
            }, function (newValue) {
                if (newValue && _this.dpmAutomation) {
                    var dpmThreshold = parseInt(newValue, 10);
                    _this.dpmAutomation.dpmThreshold = dpmThreshold;
                    _this.dpmThresholdInformationMessage =
                        _this.dpmAutomationPageService.getDpmThresholdDescription(dpmThreshold);
                }
            });
            $scope.$watch(function () {
                return _this.dpmAutomationLevelEnabled;
            }, function (newValue) {
                if (newValue) {
                    _this.dpmAutomation.automationLevel.id = _this.dpmAutomationLevelValue;
                    _this.dpmAutomationLevelValuesSignPostParams.message =
                        _this.dpmAutomationPageService.getAutomationLevelValueDescriptions(_this.dpmAutomation.automationLevel.id);
                }
                else {
                    _this.dpmAutomation.automationLevel.id = _this.DPM_AUTOMATION_LEVEL_DISABLED;
                    _this.dpmAutomationLevelValuesSignPostParams.message =
                        _this.i18nService.getString("ClusterUi", "drs.config.dpm.disabledDescription");
                }
            });
            $scope.$watch(function () {
                return _this.dpmAutomationLevelValue;
            }, function (newValue) {
                if (newValue && _this.dpmAutomationLevelEnabled) {
                    _this.dpmAutomation.automationLevel.id = _this.dpmAutomationLevelValue;
                }
            });
            $scope.$watch(function () {
                return _this.dpmAutomation.automationLevel.id;
            }, function (newValue) {
                if (newValue) {
                    _this.dpmAutomationLevelValuesSignPostParams.message =
                        _this.dpmAutomationPageService.getAutomationLevelValueDescriptions(newValue);
                }
            });
        }
        DpmAutomationPageController.$inject = ["$scope", "dpmThresholdService", "drsConstants",
            "dpmAutomationLevelService", "i18nService", "dpmAutomationPageService"];
        return DpmAutomationPageController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DpmAutomationPageController", DpmAutomationPageController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DpmAutomationPageService = (function () {
        function DpmAutomationPageService(i18nService, dpmThresholdService) {
            this.i18nService = i18nService;
            this.dpmThresholdService = dpmThresholdService;
        }
        DpmAutomationPageService.prototype.getDpmAutomationLevelSignPostParams = function () {
            var description = this.getString("drs.config.dpm.description");
            var overridesLabel = this.getString("drs.config.dpm.overridesLabel");
            var message = description + " " + overridesLabel;
            return {
                title: this.getString("help", "Common"),
                message: message
            };
        };
        DpmAutomationPageService.prototype.getDpmAutomationLevelValuesSignPostParams = function (dpmAutomationLevelEnabled, automationLevelId) {
            var automationLevelValueDescriptions = this.getAutomationLevelValueDescriptions(automationLevelId);
            var message = dpmAutomationLevelEnabled ? automationLevelValueDescriptions :
                this.getString("drs.config.dpm.disabledDescription");
            return {
                title: this.getString("help", "Common"),
                message: message
            };
        };
        DpmAutomationPageService.prototype.getAutomationLevelValueDescriptions = function (automationLevelId) {
            var automationLevelValues = {
                "manual": this.getString("drs.config.dpm.automationLevel.manualDescription"),
                "automated": this.getString("drs.config.dpm.automationLevel.automatedDescription"),
            };
            return automationLevelValues[automationLevelId];
        };
        DpmAutomationPageService.prototype.getDpmThresholdDescription = function (dpmThreshold) {
            return this.dpmThresholdService.getText(true, dpmThreshold);
        };
        DpmAutomationPageService.prototype.getSliderOptions = function (dragHandleTitle) {
            return {
                value: this.dpmThresholdService.DEFAULT,
                min: this.dpmThresholdService.MIN,
                max: this.dpmThresholdService.MAX,
                minLabel: this.dpmThresholdService.MIN_LABEL,
                maxLabel: this.dpmThresholdService.MAX_LABEL,
                enabled: true,
                width: 'auto',
                dragHandleTitle: dragHandleTitle
            };
        };
        DpmAutomationPageService.prototype.getString = function (key, bundle) {
            return bundle ? this.i18nService.getString(bundle, key) :
                this.i18nService.getString("ClusterUi", key);
        };
        DpmAutomationPageService.$inject = ["i18nService", "dpmThresholdService"];
        return DpmAutomationPageService;
    }());
    cluster_ui.DpmAutomationPageService = DpmAutomationPageService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("dpmAutomationPageService", DpmAutomationPageService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsAdvancedOptionsPageController = (function () {
        function DrsAdvancedOptionsPageController($scope, drsConstants) {
            this.$scope = $scope;
            this.drsConstants = drsConstants;
            this.pageModel =
                $scope.modalOptions.dialogData.manager.getAdvancedOptionsPageModel();
            this.formData = $scope.modalOptions.dialogData.manager.getFormData();
            this.advancedOptionsBuilder = this.pageModel.advancedOptionsBuilder;
        }
        DrsAdvancedOptionsPageController.$inject = ["$scope", "drsConstants"];
        return DrsAdvancedOptionsPageController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DrsAdvancedOptionsPageController", DrsAdvancedOptionsPageController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsAutomationLevelController = (function () {
        function DrsAutomationLevelController($scope, drsAutomationLevelService, i18nService, drsMigrationThresholdService, drsConstants, drsAutomationLevelPageService) {
            var _this = this;
            this.$scope = $scope;
            this.drsAutomationLevelService = drsAutomationLevelService;
            this.i18nService = i18nService;
            this.drsMigrationThresholdService = drsMigrationThresholdService;
            this.drsConstants = drsConstants;
            this.drsAutomationLevelPageService = drsAutomationLevelPageService;
            this.scheduleDrsWizardManager = $scope.manager;
            this.pageModel =
                $scope.modalOptions.dialogData.manager.getDrsAutomationLevelPageModel();
            this.drsAutomation = this.pageModel.drsAutomation;
            this.automationLevels = this.drsAutomationLevelService.getLevels();
            this.signPostParams = this.drsAutomationLevelPageService.getSignPostParams();
            this.automationLevelInformationMessage =
                this.drsAutomationLevelPageService.getAutomationLevelInformationMessage(this.drsAutomation.automationLevel.id);
            this.predictiveDrsSignPostParams = this.drsAutomationLevelPageService.getPredictiveDrsSignPostParams();
            this.vmAutomationSignPostParams = this.drsAutomationLevelPageService.getVmAutomationSignPostParams();
            this.migrationThresholdInformationMessage =
                this.drsAutomationLevelPageService.getMigrationThresholdDescription(this.drsAutomation.migrationThreshold);
            this.mtSliderOptions =
                this.drsAutomationLevelPageService.getSliderOptions(this.i18nService.getString('ClusterUi', 'drs.config.migrationThresholdLabel'));
            $scope.$watch(function () {
                return _this.drsAutomation;
            }, function (newValue) {
                if (newValue) {
                    _this.mtSliderOptions.value = _this.drsAutomation.migrationThreshold;
                    _this.migrationThresholdInformationMessage =
                        _this.drsAutomationLevelPageService.getMigrationThresholdDescription(_this.drsAutomation.migrationThreshold);
                    _this.drsAutomation.is65VcOrLater = _this.pageModel.is65VcOrLater;
                }
            });
            $scope.$watch(function () {
                return _this.mtSliderOptions.value;
            }, function (newValue) {
                if (newValue && _this.drsAutomation) {
                    var migrationThreshold = parseInt(newValue, 10);
                    _this.drsAutomation.migrationThreshold = migrationThreshold;
                    _this.migrationThresholdInformationMessage =
                        _this.drsAutomationLevelPageService.getMigrationThresholdDescription(migrationThreshold);
                }
            });
            $scope.$watch("ctrl.drsAutomation.automationLevel.id", function (newValue) {
                if (newValue && _this.drsAutomation) {
                    _this.automationLevelInformationMessage =
                        _this.drsAutomationLevelPageService.getAutomationLevelInformationMessage(newValue);
                }
            });
        }
        DrsAutomationLevelController.prototype.$onInit = function () {
            if (this.scheduleDrsWizardManager) {
                $("select[data-test-id='drsAutomationLevelDropdown']").focus();
            }
        };
        DrsAutomationLevelController.$inject = ["$scope", "drsAutomationLevelService",
            "i18nService", "drsMigrationThresholdService", "drsConstants", "drsAutomationLevelPageService"];
        return DrsAutomationLevelController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("DrsAutomationLevelController", DrsAutomationLevelController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var DrsAutomationLevelPageService = (function () {
        function DrsAutomationLevelPageService(i18nService, drsMigrationThresholdService) {
            this.i18nService = i18nService;
            this.drsMigrationThresholdService = drsMigrationThresholdService;
        }
        DrsAutomationLevelPageService.prototype.getSliderOptions = function (dragHandleTitle) {
            return {
                value: this.drsMigrationThresholdService.DEFAULT,
                min: this.drsMigrationThresholdService.MIN,
                max: this.drsMigrationThresholdService.MAX,
                minLabel: this.drsMigrationThresholdService.MIN_LABEL,
                maxLabel: this.drsMigrationThresholdService.MAX_LABEL,
                enabled: true,
                width: 'auto',
                dragHandleTitle: dragHandleTitle
            };
        };
        DrsAutomationLevelPageService.prototype.getSignPostParams = function () {
            return {
                title: this.getString("help", "Common"),
                message: this.getString("drs.config.migrationThreshold.signpostMessage")
            };
        };
        DrsAutomationLevelPageService.prototype.getMigrationThresholdDescription = function (migrationThreshold) {
            var description = this.drsMigrationThresholdService.getDescription(migrationThreshold);
            return description;
        };
        DrsAutomationLevelPageService.prototype.getVmAutomationSignPostParams = function () {
            return {
                title: this.getString("help", "Common"),
                message: this.getString("drs.config.vmAutomation.enableOverridesDescription")
            };
        };
        DrsAutomationLevelPageService.prototype.getPredictiveDrsSignPostParams = function () {
            return {
                title: this.getString("help", "Common"),
                message: this.getString("drs.config.migration.forecastedMetrics.desc")
            };
        };
        DrsAutomationLevelPageService.prototype.getAutomationLevelInformationMessage = function (automationLevelId) {
            var automationLevelMessages = {
                "manual": this.getString("drs.config.automationLevel.manualDescription"),
                "partiallyAutomated": this.getString("drs.config.automationLevel.partialautoDescription"),
                "fullyAutomated": this.getString("drs.config.automationLevel.fullautoDescription")
            };
            return automationLevelMessages[automationLevelId];
        };
        DrsAutomationLevelPageService.prototype.getString = function (key, bundle) {
            return bundle ? this.i18nService.getString(bundle, key) :
                this.i18nService.getString("ClusterUi", key);
        };
        DrsAutomationLevelPageService.$inject = ["i18nService", "drsMigrationThresholdService"];
        return DrsAutomationLevelPageService;
    }());
    cluster_ui.DrsAutomationLevelPageService = DrsAutomationLevelPageService;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("drsAutomationLevelPageService", DrsAutomationLevelPageService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ScheduleDrsDrsSettingsPageController = (function () {
        function ScheduleDrsDrsSettingsPageController($scope, dataService, vcService, $q, drsConstants) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.vcService = vcService;
            this.$q = $q;
            this.drsConstants = drsConstants;
            this.objectId = $scope.modalOptions.dialogData.objectId;
            this.$scope.modalOptions.dialogData.manager.setObjectId(this.objectId);
            this.$scope.modalOptions.dialogData.manager.setDrsDialogOptions(this.$scope.modalOptions);
            this.$scope.modalOptions.isAlertClosed = true;
            this.getViewData();
        }
        ScheduleDrsDrsSettingsPageController.prototype.getSelectedPageUrl = function () {
            var _this = this;
            var selectedPage = _.find(this.$scope.pages.categories, function (page) {
                return page.id === _this.$scope.selectedCategoryId;
            });
            return selectedPage ? selectedPage.contentUrl : "";
        };
        ScheduleDrsDrsSettingsPageController.prototype.getViewData = function () {
            var _this = this;
            this.loading = true;
            var vcVersionPromise = this.vcService.is65VcOrLater(this.objectId)
                .then(function (is65VcOrLater) {
                _this.is65VcOrLater = is65VcOrLater;
                _this.$scope.pages = {
                    categories: _this.$scope.modalOptions.dialogData.manager.getPageDefinitions(true)
                };
                _this.$scope.selectedCategoryId = _this.$scope.pages.categories[0].id;
                _this.$scope.selectCategory = function (categoryId) {
                    _this.$scope.selectedCategoryId = categoryId;
                };
            });
            if (this.$scope.modalOptions.dialogData.isEditScheduledTaskMode) {
                vcVersionPromise.then(function () {
                    _this.loadFormData();
                    _this.loading = false;
                });
            }
            else {
                var promises = [];
                var requestDataPromise = this.dataService
                    .getData(this.objectId, 'com.vmware.vsphere.client.clusterui.model.services.DrsConfigData')
                    .then(function (drsData) {
                    _.extend(_this.$scope.modalOptions.dialogData.editDrsData, drsData);
                    _this.loading = false;
                });
                promises.push(vcVersionPromise);
                promises.push(requestDataPromise);
                this.$q.all(promises).then(function () {
                    _this.loadFormData();
                });
            }
        };
        ScheduleDrsDrsSettingsPageController.prototype.addWatchers = function () {
            var _this = this;
            this.$scope.$watch('ctrl.formData', function () {
                _this.$scope.manager.setFormData(_this.$scope.modalOptions.dialogData.manager.getFormData());
            });
            this.$scope.$watch('ctrl.formData.drsPolicies.allConsumedMemoryMetric', this.allConsumedMemoryMetricChanged.bind(this));
        };
        ScheduleDrsDrsSettingsPageController.prototype.allConsumedMemoryMetricChanged = function (allConsumedMemoryMetric) {
            var allConsumedMemoryMetricOption = this.formData.advancedOptionsBuilder.getOptionByKey(this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_OPTION);
            if (!allConsumedMemoryMetric) {
                if (allConsumedMemoryMetricOption) {
                    this.formData.advancedOptionsBuilder
                        .removeOption(allConsumedMemoryMetricOption.id);
                }
            }
            else if (!allConsumedMemoryMetricOption) {
                this.formData.advancedOptionsBuilder.addOption({
                    key: this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_OPTION,
                    value: this.drsConstants.drsPolicies.ALL_CONSUMED_MEMORY_METRIC_VALUE
                });
            }
        };
        ScheduleDrsDrsSettingsPageController.prototype.loadFormData = function () {
            var drsData = this.$scope.modalOptions.dialogData.editDrsData;
            this.$scope.modalOptions.dialogData.manager.setFormData(drsData, this.is65VcOrLater);
            this.formData = this.$scope.modalOptions.dialogData.manager.getFormData();
            this.addWatchers();
        };
        ScheduleDrsDrsSettingsPageController.$inject = ["$scope", "dataService", "vcService", "$q",
            "drsConstants"];
        return ScheduleDrsDrsSettingsPageController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("ScheduleDrsDrsSettingsPageController", ScheduleDrsDrsSettingsPageController);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ScheduleDrsWizardManager = (function () {
        function ScheduleDrsWizardManager(i18nService, vuiConstants, mutationService, defaultUriSchemeUtil, $rootScope, wizardPageService, clusterSpecBuilderService, vscSchedulingHelper) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$rootScope = $rootScope;
            this.wizardPageService = wizardPageService;
            this.clusterSpecBuilderService = clusterSpecBuilderService;
            this.vscSchedulingHelper = vscSchedulingHelper;
            this.scheduleModel = {};
            this.buildPages();
        }
        /**
         * Retrieves page definitions.
         *
         * @returns {WizardPage[]}
         */
        ScheduleDrsWizardManager.prototype.getPageDefinitions = function () {
            return [this.scheduleSettingsPageDef,
                this.drsSettingsPageDef];
        };
        ScheduleDrsWizardManager.prototype.getObjectId = function () {
            return this.objectId;
        };
        /**
         * Retrieves wizard model.
         *
         * @returns {DsClusterModel}
         */
        ScheduleDrsWizardManager.prototype.getModel = function () {
            return this.scheduleModel;
        };
        ScheduleDrsWizardManager.prototype.setModel = function (model) {
            this.scheduleModel = model;
        };
        ScheduleDrsWizardManager.prototype.setFormData = function (formData) {
            this.formData = formData;
        };
        ScheduleDrsWizardManager.prototype.submit = function () {
            this.scheduleModel.scheduleTaskSpec.spec =
                this.clusterSpecBuilderService.buildClusterComputeResourceSpec(this.formData, true);
            this.scheduleModel.scheduleTaskSpec.spec._type =
                'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec';
            this.scheduleModel.scheduleTaskSpec.schedulingSpec.recurrence =
                this.vscSchedulingHelper.formatRecurrenceData(this.scheduleModel.scheduleTaskSpec.schedulingSpec.recurrence);
            this.mutationService.apply(this.objectId, 'com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec', this.scheduleModel.scheduleTaskSpec);
            return true;
        };
        ScheduleDrsWizardManager.prototype.getWizardConfig = function (additionalData) {
            var _this = this;
            var title;
            var editClusterSettingsTitle = this.i18nService.getString("ClusterUi", "editClusterSettingsDialog.title");
            if (additionalData && additionalData.isScheduledTask
                && additionalData.schedulingData.scheduleTaskOperationMode === 1) {
                title = this.i18nService.getString("ScheduledOpsUi", "scheduledTask.ScheduleTasksEdit", editClusterSettingsTitle);
            }
            else {
                title = this.i18nService.getString("ScheduledOpsUi", "scheduledTask.ScheduleNewTasks.label")
                    + " (" + editClusterSettingsTitle + ")";
            }
            if (!this.wizardConfig) {
                this.wizardConfig = {
                    title: title,
                    pages: this.getPageDefinitions(),
                    show: true,
                    loading: false,
                    loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                    onFinish: function () { return _this.submit(); },
                    cssClass: "schedule-cluster-drs-page"
                };
            }
            else {
                this.wizardConfig.title = title;
            }
            return this.wizardConfig;
        };
        /**
         * Initializes wizard model with default values.
         */
        ScheduleDrsWizardManager.prototype.init = function (objectId, additionalData) {
            this.objectId = objectId;
            if (additionalData && additionalData.isScheduledTask
                && additionalData.schedulingData.scheduleTaskOperationMode === 1) {
                // edit scheduled task
                this.scheduleModel = {
                    scheduleTaskSpec: additionalData.schedulingData
                };
            }
            else {
                this.scheduleModel = {
                    scheduleTaskSpec: {
                        spec: {},
                        // 0 is for add
                        operation: 0,
                        entity: this.defaultUriSchemeUtil.getManagedObjectReference(objectId),
                        schedulingSpec: {
                            _type: "com.vmware.vise.core.model.scheduling.ScheduledTaskSpec",
                            scheduledTask: null,
                            recurrence: null,
                            name: "Reconfigure Cluster",
                            taskKey: "ReconfigureComputeResource_Task",
                            description: "",
                            source: "Cluster",
                            enabled: true,
                            notification: ""
                        },
                        // 0 is for addDeferred
                        deferredOperation: 0,
                        // 0 is for add
                        scheduleTaskOperationMode: 0
                    }
                };
            }
        };
        ScheduleDrsWizardManager.prototype.buildPages = function () {
            var _this = this;
            this.scheduleSettingsPageDef = {
                title: this.i18nService.getString("ScheduledOpsUi", "scheduledTask.snapshot.options"),
                contentUrl: "cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/scheduleDrsScheduleOptionsPage.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    var recurrence = _this.getModel().scheduleTaskSpec.schedulingSpec.recurrence;
                    var isFormStatusValid = _this.getModel().scheduleTaskSpec.schedulingSpec.isFormStatusValid;
                    if (recurrence && isFormStatusValid) {
                        _this.setModel(_this.getModel());
                        _this.wizardPageService.markPageComplete(_this.wizardConfig);
                        return true;
                    }
                    else {
                        if (!recurrence) {
                            _this.wizardPageService.markPageIncompleteWithError(_this.wizardConfig, _this.i18nService.getString("SchedulingUi", "scheduledTask.emptyScheduler"));
                        }
                        return false;
                    }
                }
            };
            this.drsSettingsPageDef = {
                title: this.i18nService.getString("ClusterUi", "drs.schedule.config.pageTitle"),
                contentUrl: "cluster-ui/resources/cluster/views/settings/services/drs/edit/pages/scheduleDrsDrsSettingsPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED
            };
        };
        ScheduleDrsWizardManager.$inject = ["i18nService", "vuiConstants", "mutationService",
            "defaultUriSchemeUtil", "$rootScope", "wizardPageService", "clusterSpecBuilderService",
            "vscSchedulingHelper"];
        return ScheduleDrsWizardManager;
    }());
    cluster_ui.ScheduleDrsWizardManager = ScheduleDrsWizardManager;
    angular.module("com.vmware.vsphere.client.cluster")
        .service("scheduleDrsWizardManager", ScheduleDrsWizardManager);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var ScheduleDrsWizardService = (function () {
        function ScheduleDrsWizardService($rootScope, i18nService, vuiWizardService, wizardManager, pageStateManagementService, EditDrsDialogManager) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.wizardManager = wizardManager;
            this.pageStateManagementService = pageStateManagementService;
            this.EditDrsDialogManager = EditDrsDialogManager;
        }
        /**
         * Displays schedule drs wizard.
         */
        ScheduleDrsWizardService.prototype.show = function (actionEval, objectId, focusTarget) {
            var wizardScope = this.$rootScope.$new();
            this.wizardManager.init(objectId, actionEval.additionalData);
            var isEditScheduledTaskMode = actionEval.additionalData
                && actionEval.additionalData.isScheduledTask
                && actionEval.additionalData.schedulingData.scheduleTaskOperationMode === 1;
            wizardScope.wizardConfig =
                this.wizardManager.getWizardConfig(actionEval.additionalData);
            wizardScope.manager = this.wizardManager;
            wizardScope.modalOptions = {
                focusTarget: focusTarget,
                dialogData: {
                    manager: new this.EditDrsDialogManager(),
                    editDrsData: isEditScheduledTaskMode ?
                        actionEval.additionalData.schedulingData.spec : {},
                    objectId: objectId,
                    pageModel: null,
                    isEditScheduledTaskMode: isEditScheduledTaskMode
                }
            };
            this.pageStateManagementService.registerWizardForDefaultStateManagementStrategy(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: 'wizardConfig'
            }).show();
        };
        ScheduleDrsWizardService.$inject = ['$rootScope', 'i18nService', 'vuiWizardService',
            'scheduleDrsWizardManager', 'pageStateManagementService', 'EditDrsDialogManager'];
        return ScheduleDrsWizardService;
    }());
    cluster_ui.ScheduleDrsWizardService = ScheduleDrsWizardService;
    angular.module('com.vmware.vsphere.client.cluster')
        .service('scheduleDrsWizardService', ScheduleDrsWizardService);
})(cluster_ui || (cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditHaDialogController = (function () {
        function EditHaDialogController($scope, dataService) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            $scope.pages = {
                categories: $scope.modalOptions.dialogData.manager.getPageDefinitions()
            };
            $scope.selectedCategoryId = $scope.pages.categories[0].id;
            $scope.selectCategory = function (categoryId) {
                if ($scope.modalOptions.dialogData.manager.validate()) {
                    _this.$scope.selectedCategoryId = categoryId;
                }
            };
            this.getViewData();
        }
        EditHaDialogController.prototype.getSelectedPageUrl = function () {
            var _this = this;
            var selectedPage = _.find(this.$scope.pages.categories, function (page) {
                return page.id === _this.$scope.selectedCategoryId;
            });
            if (selectedPage) {
                return selectedPage.contentUrl;
            }
            return "";
        };
        EditHaDialogController.prototype.getViewData = function () {
            var _this = this;
            this.setPageBusy(true);
            this.dataService.getData(this.$scope.modalOptions.dialogData.objectId, "com.vmware.vsphere.client.clusterui.model.services.ClusterEditHaData")
                .then(function (data) {
                _.extend(_this.$scope.modalOptions.dialogData.haData, data);
                _this.pageModel = _this.$scope.modalOptions.dialogData.manager
                    .getFailuresAndResponsesModel();
                _this.setPageBusy(false);
            });
        };
        EditHaDialogController.prototype.setPageBusy = function (busy) {
            this.loading = busy;
            this.$scope.modalOptions.submitDisabled = busy;
        };
        EditHaDialogController.$inject = ["$scope", "dataService"];
        return EditHaDialogController;
    }());
    angular.module("com.vmware.vsphere.client.cluster")
        .controller("EditHaDialogController", EditHaDialogController);
})(cluster_ui || (cluster_ui = {}));



(function() {
   'use strict';

   /**
    * Factory that handles HA edit related operations.
    * Builds all the edit HA dialog page models and submits the edited HA data to the
    * server.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .factory('HaDialogManager', HaDialogManager);

   HaDialogManager.$inject = ['vuiConstants', 'haConstants', 'i18nService',
      'clusterSpecBuilderService', 'mutationService', 'advancedOptionsBuilderFactory',
      'haAdmissionControlService', '$q', 'clarityModalService', 'clusterConstants'];

   function HaDialogManager(vuiConstants, haConstants, i18nService,
         clusterSpecBuilderService, mutationService, advancedOptionsBuilderFactory,
         haAdmissionControlService, $q, clarityModalService, clusterConstants) {

      return function(haData, haDialogOptions) {
         var EDIT_CLUSTER_SPEC =
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec';

         var failuresAndResponsesDef, heartbeatDatastoresDef, advancedOptionsDef,
               admissionControlDef;
         createPages();

         return {
            getPageDefinitions: getPageDefinitions,
            getFailuresAndResponsesModel: getFailuresAndResponsesModel,
            getHeartbeatDatastoresModel: getHeartbeatDatastoresModel,
            getAdvancedOptionsModel: getAdvancedOptionsModel,
            getAdmissionControlModel: getAdmissionControlModel,
            submit: submit,
            getClusterReconfigureSpec: getClusterReconfigureSpec,
            validate: validate
         };

         function createPages() {
            // page definitions have properties like page, model, etc.
            failuresAndResponsesDef = {
               page: {
                  id: 'failuresAndResponses',
                  title: i18nService.getString('ClusterUi', 'ha.config.edit.vmResponse.ToCItem'),
                  contentUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/edit/pages/failuresAndResponsesPage.html'
               }
            };
            heartbeatDatastoresDef = {
               page: {
                  id: 'heartbeatDatastores',
                  title: i18nService.getString('ClusterUi', 'ha.config.dsForHeartbeating.ToCItem'),
                  contentUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/edit/pages/heartbeatDatastoresPage.html'
               }
            };
            advancedOptionsDef = {
               page: {
                  id: 'advancedOptions',
                  title: i18nService.getString('ClusterUi', 'ha.config.advancedOptions'),
                  contentUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/edit/pages/advancedOptionsPage.html'
               }
            };
            admissionControlDef = {
               page: {
                  id: 'admissionControl',
                  title: i18nService.getString('ClusterUi', 'ha.config.admissionControl'),
                  contentUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/edit/pages/admissionControlPage.html'
               }
            };
         }

         function getPageDefinitions() {
            var pages = [];

            pages.push(failuresAndResponsesDef.page);
            pages.push(admissionControlDef.page);
            pages.push(heartbeatDatastoresDef.page);
            pages.push(advancedOptionsDef.page);

            return pages;
         }

         function submit() {
            var clusterId = haDialogOptions.dialogData.objectId;
            var clusterSpec = getClusterReconfigureSpec();

            return validateAndConfirm(clusterId, clusterSpec)
                  .then(function() {
                     mutationService.apply(clusterId, EDIT_CLUSTER_SPEC, clusterSpec);
                     return true;
                  }, function() {
                     return false;
                  });
         }

         function getClusterReconfigureSpec() {
            var haFormModel = _.extend({},
                  failuresAndResponsesDef.model || {},
                  getHeartbeatDatastoresModel(),
                  advancedOptionsDef.model || {},
                  admissionControlDef.model || {}
            );

            if (failuresAndResponsesDef && failuresAndResponsesDef.model &&
                  failuresAndResponsesDef.model.haConfiguration &&
                  failuresAndResponsesDef.model.haConfiguration.defaultVmSettings) {
               var haConfiguration = failuresAndResponsesDef.model.haConfiguration;
               var defaultVmSettings = haConfiguration.defaultVmSettings;
               var vmToolsMonitoringSettings = defaultVmSettings.vmToolsMonitoringSettings;
               var roundedVmMonitoringSettings = roundVmToolsMonitoringSettingsValues(vmToolsMonitoringSettings);
               var originalVmToolsMonitoringSettings =
                     failuresAndResponsesDef.model.haConfiguration.defaultVmSettings.vmToolsMonitoringSettings;
               _.extend(originalVmToolsMonitoringSettings, roundedVmMonitoringSettings);
            }

            return clusterSpecBuilderService.buildClusterComputeResourceSpec(
                  haFormModel, true);
         }

         function validateAndConfirm(clusterId, clusterSpec) {
            if (!validate()) {
               return $q.reject();
            }

            var hasApdOrPdlOn = checkApdOrPdlOn();

            //show confirmation message if turning on APD or PDL and there are
            //FT VMs in the cluster
            if (hasApdOrPdlOn) {
               return mutationService.validate(clusterId, EDIT_CLUSTER_SPEC, clusterSpec)
                     .then(handleValidationResult);
            }

            return $q.resolve();
         }

         function validate() {
            haDialogOptions.alerts = [];
            haDialogOptions.isAlertClosed = true;

            //validate submit ha admission control failover hosts policy
            //with no failover hosts selected
            if (admissionControlDef.model &&
                  admissionControlDef.model.admissionControlPolicy.type ===
                  haConstants.admissionControlPolicy.FAILOVER_HOSTS_TYPE &&
                  admissionControlDef.model.failoverHosts.length === 0) {

               haDialogOptions.alerts = [{
                  type: vuiConstants.validationBanner.type.ERROR,
                  text: i18nService.getString('ClusterUi',
                        'ha.config.admission.control.policy.failover.host.error')
               }];
               haDialogOptions.isAlertClosed = false;

               return false;
            }

            return true;
         }


         function checkApdOrPdlOn() {
            var hasApdOrPdlOn = false;
            if (failuresAndResponsesDef.model && (failuresAndResponsesDef.model
                        .haConfiguration.vmcpSettings.pdlResponse !==
                  haConstants.storageVmReaction.DISABLED || failuresAndResponsesDef.model
                        .haConfiguration.vmcpSettings.apdResponse !==
                  haConstants.storageVmReaction.DISABLED)) {
               hasApdOrPdlOn = true;
            }

            return hasApdOrPdlOn;
         }

         function handleValidationResult(validationResult) {
            if (validationResult && !validationResult.error && validationResult.result &&
                  validationResult.result.isValid !== true) {
               if (validationResult.result.errorCode === clusterConstants.editClusterErrorCodes.HA_APD_PDL_WITH_FT_VMS) {
                  var title = i18nService.getString('ClusterUi',
                        'ha.config.enable.storageProtection.with.ftVms.warning.title');
                  return showConfirmationDialog(title,
                        validationResult.result.validationMessage);
               }
            }

            return $q.resolve();
         }

         function showConfirmationDialog(title, message) {
            var deferred = $q.defer();

            var dialogOptions = {
               title: title,
               message: message,
               submit: function() {
                  deferred.resolve();
                  return true;
               },
               onCancel: function() {
                  deferred.reject();
                  return true;
               }
            };

            clarityModalService.openConfirmationModal(dialogOptions);
            return deferred.promise;
         }

         //region Failures and Responses page

         function getFailuresAndResponsesModel() {
            if (!failuresAndResponsesDef.model) {
               buildFailuresAndResponsesModel();
            }
            return failuresAndResponsesDef.model;
         }

         function buildFailuresAndResponsesModel() {
            var hostMonitoring = haData.hostMonitoring ===
                  haConstants.hostMonitoringState.ENABLED;
            var vmToolsMonitorHasFailureWindow = true;
            //default failure window value
            var vmToolsMonitorMaxFailureWindow =
                  haConstants.vmMonitoringSensitivity.high.FAILURE_WINDOW;
            if (haData.vmToolsMonitorMaxFailureWindow ===
                  haConstants.vmMonitoringSensitivity.NO_FAILURE_WINDOW) {
               vmToolsMonitorHasFailureWindow = false;
            } else {
               //convert seconds to hours
               vmToolsMonitorMaxFailureWindow =
                     haData.vmToolsMonitorMaxFailureWindow / 3600;
            }

            failuresAndResponsesDef.model = {
               haEnabled: haData.haEnabled,
               haConfiguration: {
                  defaultVmSettings: {
                     isolationResponse: haData.isolationResponse,
                     restartPriority: haData.restartPriority,
                     restartPriorityTimeout: haData.restartPriorityTimeout,
                     vmToolsMonitoringSettings: {
                        vmToolsMonitorFailureInt: haData.vmToolsMonitorFailureInt,
                        vmToolsMonitorMinUpTime: haData.vmToolsMonitorMinUpTime,
                        vmToolsMonitorMaxFailures: haData.vmToolsMonitorMaxFailures,
                        vmToolsMonitorMaxFailureWindow: vmToolsMonitorMaxFailureWindow,
                        vmToolsMonitorHasFailureWindow: vmToolsMonitorHasFailureWindow
                     }
                  },
                  hostMonitoringEnabled: hostMonitoring,
                  vmMonitoringState: haData.vmMonitoring,
                  vmcpSettings: {
                     pdlResponse: haData.vmcpSettings.pdlResponse,
                     apdResponse: haData.vmcpSettings.apdResponse,
                     vmReactionOnAPDCleared: haData.vmcpSettings.vmReactionOnAPDCleared,
                     apdRecoveryDelayMinutes: (haData.vmcpSettings.vmTerminateDelayForAPDSec /
                     haConstants.SECONDS_IN_A_MINUTE)
                  }
               },
               storagePDLSupported: haData.storagePDLSupported,
               storageAPDSupported: haData.storageAPDSupported,
               orchestration: {
                  defaultVmReadiness: {
                     readyCondition: haData.readyCondition,
                     postReadyDelay: haData.postReadyDelay
                  }
               }
            };
         }

         //endregion

         //region Heartbeat datastores page

         function getHeartbeatDatastoresModel() {
            if (!heartbeatDatastoresDef.model) {
               buildHeartbeatDatastoresModel();
            }
            return heartbeatDatastoresDef.model;
         }

         function buildHeartbeatDatastoresModel() {
            heartbeatDatastoresDef.model = {
               hbDatastoreCandidatePolicy: haData.heartbeatDatastoreCandidatePolicy,
               hbDatastoreCandidates: haData.heartbeatDatastoreCandidates,
               hbDatastoresPerHost: haData.requiredDatastoreMounts
            };
         }

         //endregion

         //region Advanced options page

         function getAdvancedOptionsModel() {
            if (!advancedOptionsDef.model) {
               advancedOptionsDef.model = {
                  haAdvancedOptionsBuilder: advancedOptionsBuilderFactory
                        .getBuilder(haData.advancedOptions, true)
               };
            }
            return advancedOptionsDef.model;
         }

         //endregion

         //region Admission Control page

         function getAdmissionControlModel() {
            if (!admissionControlDef.model) {
               buildAdmissionControlModel();
            }
            return admissionControlDef.model;
         }

         function buildAdmissionControlModel() {
            var admissionControlPolicyType;

            if (!haData.admissionControlEnabled) {
               admissionControlPolicyType = haConstants.admissionControlPolicy.DISABLED_TYPE;
            } else {
               admissionControlPolicyType = haData.admissionControlPolicy._type;
            }

            var failoverHostNum = haData.failoverHostNum;
            var failoverHostNumDefault =
                  haAdmissionControlService.getFailoverLevelDefaultValue();

            if (failoverHostNum < failoverHostNumDefault) {
               failoverHostNum = failoverHostNumDefault;
            }

            var slotSizePolicy = haConstants.slotSizePolicy.COVER_ALL_VM;
            var fixedSlotSizeCpu = haAdmissionControlService.getFixedSlotSizeCpuDefaultValue();
            var fixedSlotSizeMemory = haAdmissionControlService.getFixedSlotSizeMemoryDefaultValue();
            var slotSize = haData.admissionControlPolicy.slotPolicy;

            if (slotSize) {
               slotSizePolicy = haConstants.slotSizePolicy.FIXED_SIZE;
               fixedSlotSizeCpu = slotSize.cpu;
               fixedSlotSizeMemory = slotSize.memory;
            }
            var hostData = haData.hostData;

            if (hostData === null) {
               hostData = [];
            }

            var autoComputePercentages = haData.autoComputePercentages;

            if (autoComputePercentages === null || admissionControlPolicyType !==
                  haConstants.admissionControlPolicy.FAILOVER_RESOURCES_TYPE) {
               autoComputePercentages = true;
            }

            admissionControlDef.model = {
               admissionControlPolicy: {
                  type: admissionControlPolicyType
               },
               failoverLevel: failoverHostNum,
               failoverHosts: hostData,
               cpuFailoverPercent: haData.cpuFailoverPercent,
               memoryFailoverPercent: haData.memoryFailoverPercent,
               slotSizePolicy: slotSizePolicy,
               fixedSlotSizeCpu: fixedSlotSizeCpu,
               fixedSlotSizeMemory: fixedSlotSizeMemory,
               autoComputePercentages: autoComputePercentages,
               resourceReductionToToleratePercent: haData.resourceReductionToToleratePercent,
               hostsInCluster: haData.hostsInCluster
            };
         }

         function roundVmToolsMonitoringSettingsValues(vmToolsMonitoringSettings) {

            return {
               vmToolsMonitorFailureInt: Math.round(vmToolsMonitoringSettings.vmToolsMonitorFailureInt),
               vmToolsMonitorMaxFailureWindow: Math.round(vmToolsMonitoringSettings.vmToolsMonitorMaxFailureWindow),
               vmToolsMonitorMaxFailures: Math.round(vmToolsMonitoringSettings.vmToolsMonitorMaxFailures),
               vmToolsMonitorMinUpTime: Math.round(vmToolsMonitoringSettings.vmToolsMonitorMinUpTime)
            };
         }

         //endregion
      };
   }
})();

(function() {
   'use strict';

   /**
    * Opens Edit HA dialog as a multi page dialog.
    */
   angular.module('com.vmware.vsphere.client.cluster')
         .service('haDialogService', haDialogService);

   haDialogService.$inject = ['i18nService', 'HaDialogManager', 'clarityModalService'];

   function haDialogService(i18nService, HaDialogManager, clarityModalService) {

      return {
         show: show
      };

      function show(clusterId, focusTarget) {
         var haData = {};
         var modalOptions = {};
         var haDialogManager = new HaDialogManager(haData, modalOptions);

         _.extend(modalOptions, {
            title: i18nService.getString('ClusterUi', 'editClusterSettingsDialog.title'),
            subTitle: {
               objectId: clusterId
            },
            defaultButton: 'submit',
            contentTemplate:
                  'cluster-ui/resources/cluster/views/settings/services/ha/edit/editHaDialog.html',
            size: 'lg',
            onSubmit: haDialogManager.submit,
            modalClass: 'cluster-edit-ha-dialog-modal',
            focusTarget: focusTarget,
            dialogData: {
               haData: haData,
               manager: haDialogManager,
               objectId: clusterId
            }
         });

         clarityModalService.openOkCancelModal(modalOptions);
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AdmissionControlFailoverHostsSelectorDialogController',
               AdmissionControlFailoverHostsSelectorDialogController);

   AdmissionControlFailoverHostsSelectorDialogController.$inject = ['$scope',
         'i18nService'];

   function AdmissionControlFailoverHostsSelectorDialogController($scope, i18nService) {

      var dialogData = $scope.modalOptions.dialogData;
      dialogData.selectedItems = [];

      var filter = "clusterObjectsExcludeObjectsFilter";

      //use different filter if there are no hosts to be excluded because
      //clusterObjectsExcludeObjectsFilter cannot be instantiated with an empty param
      if (dialogData.dedicatedFailoverHostIds.length === 0) {
         filter = "clusterObjectsFilter";
      }

      dialogData.objectSelectorConfig = this.config = {
         contextObject: dialogData.clusterId,
         multipleSelect: true,
         listTabConfig: {
            listConfig: [{
               label: i18nService.getString('Common', 'typeResource.hostPlural'),
               listViewId: "vsphere.core.host.list",
               dataModels: ["HostSystem"],
               filterId: filter,
               filterParams: dialogData.dedicatedFailoverHostIds
            }]
         },
         onSelectionChanged: function(selectedItems) {
            dialogData.selectedItems = selectedItems;
         }
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AdmissionControlPageController', AdmissionControlPageController);

   AdmissionControlPageController.$inject = ['$scope', 'i18nService',
      'haAdmissionControlService', 'haConstants', 'vuiConstants',
      'actionDialogService', 'columnRenderersRegistry', 'dataService',
      'vcService', 'clarityModalService', 'clusterConstants'];

   function AdmissionControlPageController($scope, i18nService, haAdmissionControlService,
         haConstants, vuiConstants, actionDialogService, columnRenderersRegistry,
         dataService, vcService, clarityModalService, clusterConstants) {

      var self = this;

      var getString = _.bind(i18nService.getString, i18nService, 'ClusterUi');
      var objectId = $scope.modalOptions.dialogData.objectId;

      self.pageModel = $scope.modalOptions.dialogData.manager.getAdmissionControlModel();
      self.slotSizeRequirements = {
         numberOfVmsRequiringMultipleSlots: 0,
         totalPoweredOnVms: 0,
         vmsRequiringMultipleSlots: null,
         vmsRequiringMultipleSlotsRatioLabel: ''
      };

      self.admissionControlTypes = haConstants.admissionControlPolicy;
      self.slotSizePolicyTypes = haConstants.slotSizePolicy;
      self.haDialogManager = $scope.modalOptions.dialogData.manager;
      self.pageModel.is65VcOrLater = false;
      self.oldFailoverValue = self.pageModel.failoverLevel;
      self.showWarningLabel = false;
      vcService.is65VcOrLater(objectId)
            .then(function(is65VcOrLater) {
               self.pageModel.is65VcOrLater = is65VcOrLater;
      });

      initFailoverHostsDialogData();

      //enable or disable grid delete button based on selection
      $scope.$watch(function () {
            return self.failoverHostsGridOptions.selectedItems;
         }, function (selectedItems) {
         var areItemsSelected =
               !!selectedItems && selectedItems.length > 0;
         self.failoverHostsGridOptions.actionBarOptions.actions[1].enabled =
               areItemsSelected;
      });

      $scope.$watch(function () {
         return self.pageModel.admissionControlPolicy.type;
      }, function () {
         if (self.pageModel.admissionControlPolicy.type ===
               self.admissionControlTypes.FAILOVER_HOSTS_TYPE) {
            self.failoverHostsService =
                  haAdmissionControlService.getFailoverHostsService(self.pageModel);
            self.failoverHostsGridOptions.data =
                  self.failoverHostsService.getFailoverHostsGridData();
         }
      });

      // region validation functions
      $scope.$watch('ctrl.pageModel.failoverLevel', function () {
         if (self.oldFailoverValue === self.pageModel.failoverLevel) {
            self.showWarningLabel = false;
         } else {
            self.showWarningLabel = true;
         }
      });

      function validateFailoverLevel() {
         if (typeof self.pageModel.failoverLevel !== "undefined" &&
               self.pageModel.hostsInCluster <= self.pageModel.failoverLevel) {
            self.pageModel.failoverLevel = self.pageModel.hostsInCluster - 1;
         }
         if (typeof self.pageModel.failoverLevel === "undefined" ||
               self.pageModel.failoverLevel <= 1) {
            self.pageModel.failoverLevel = 1;
         }
      }

      function validateFailoverCpu(event) {
         validatePercent(event.target.value, 'cpuFailoverPercent');
      }

      function validateFailoverMemory(event) {
         validatePercent(event.target.value, 'memoryFailoverPercent');
      }

      function validateResourceReductionThreshold(event) {
         validatePercent(event.target.value, 'resourceReductionToToleratePercent');
      }

      function normalizeSlotSizeCpu(event) {
         if (event.target.value === "" || event.target.value < 1) {
            self.pageModel.fixedSlotSizeCpu = 1;
         }

         if (event.target.value > clusterConstants.MAX_INTEGER) {
            self.pageModel.fixedSlotSizeCpu = clusterConstants.MAX_INTEGER;
         }
      }

      function normalizeSlotSizeMemory(event) {
         if (event.target.value === "" || event.target.value < 1) {
            self.pageModel.fixedSlotSizeMemory = 1;
         }

         if (event.target.value > clusterConstants.MAX_INTEGER) {
            self.pageModel.fixedSlotSizeMemory = clusterConstants.MAX_INTEGER;
         }
      }

      function validatePercent(value, modelProperty) {
         if (value === "" || value < 0) {
            self.pageModel[modelProperty] = 0;
         } else if (value > 100) {
            self.pageModel[modelProperty] = 100;
         }
      }

      function removeFailoverHost() {
         var itemsToRemove = self.failoverHostsGridOptions.selectedItems;
         self.failoverHostsService.removeFailoverHost(self.failoverHostsGridOptions,
               itemsToRemove);
      }

      function initFailoverHostsDialogData() {
         var addAction = {
            actionId: 'vsphere.core.cluster.actions.addFailoverHost',
            enabled: true,
            visible: true,
            iconClass: 'vui-icon-action-add',
            label: getString('ha.config.admission.control.policy.failover.add.host.button.label'),
            tooltipText: getString('ha.config.admission.control.policy.failover.add.host.button.tooltip'),
            onClick: openDialog
         };

         var removeAction = {
            actionId: 'vsphere.core.cluster.actions.removeFailoverHost',
            enabled: false,
            visible: true,
            iconClass: 'vui-icon-action-delete',
            label: getString('ha.config.admission.control.policy.failover.remove.hosts.button.label'),
            tooltipText: getString('ha.config.admission.control.policy.failover.remove.hosts.button.tooltip'),
            onClick: removeFailoverHost
         };

         self.failoverHostsGridOptions = {
            columnDefs: [
               {
                  displayName: getString('ha.config.admission.control.policy.failover.host.header'),
                  field: 'name',
                  template: iconNameRendererFactory('name', 'iconId'),
                  sortable: true,
                  searchable: false
               }
            ],
            height: '285px',
            resizable: false,
            reorderable: false,
            data: [],
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            actionBarOptions: {
               actions: [
                  addAction,
                  removeAction
               ]
            }
         };
      }

      function getNumberOfVmsRequiringMultipleSlots() {
         var dasConfigInfo =
               self.haDialogManager.getClusterReconfigureSpec().configSpecEx.dasConfig;
         var dataServiceCallParams = {
            propertyParams: [{
               _type: 'com.vmware.vise.mvc.model.data.ParamSpec',
               propertyName: 'reconfigureHaFailoverLevelPrecheckResult',
               parameterType: 'com.vmware.vim.binding.vim.cluster.DasConfigInfo',
               parameter: dasConfigInfo
            }]
         };

         dataService.getProperties($scope.modalOptions.dialogData.objectId,
               ['reconfigureHaFailoverLevelPrecheckResult'],
               dataServiceCallParams
         ).then(function(data) {
            if (data && data['reconfigureHaFailoverLevelPrecheckResult']) {
               var result = data['reconfigureHaFailoverLevelPrecheckResult'];
               self.slotSizeRequirements.numberOfVmsRequiringMultipleSlots =
                     result.vmsRequiringMultipleSlots
                           ? result.vmsRequiringMultipleSlots.length : 0;
               self.slotSizeRequirements.totalPoweredOnVms =
                     result.totalVms;
               self.slotSizeRequirements.vmsRequiringMultipleSlots =
                     result.vmsRequiringMultipleSlots;
               self.slotSizeRequirements.vmsRequiringMultipleSlotsRatioLabel =
                     self.slotSizeRequirements.numberOfVmsRequiringMultipleSlots +
                     '/' + self.slotSizeRequirements.totalPoweredOnVms;
            }
         });
      }

      function openDialogForVmsRequiringMultipleSlots() {
         if (!self.slotSizeRequirements) {
            getNumberOfVmsRequiringMultipleSlots();
         }
         var dialogData = {
            slotSizeRequirements: self.slotSizeRequirements
         };

         actionDialogService.openActionDialog(
               { action: {} },
               [],
               dialogData,
               'cluster-ui/resources/cluster/views/settings/services/ha/edit/pages/' +
               'admissionControlVmsRequiringMultiSlotsDialog.html',
               {
                  title: getString('ha.config.admission.control.policy.failover.' +
                        'level.excluded.vms.title'),
                  resizable: false,
                  draggable: true,
                  maximizable: false,
                  width: '550px',
                  height: '400px',
                  confirmOptions: {
                     label: getString('ha.config.admission.control.policy.failover.' +
                           'level.excluded.vms.close.button')
                  },
                  rejectOptions: {
                     visible: false
                  }
               });
      }

      function openDialog() {
         var dialogData = {
            dedicatedFailoverHostIds: self.failoverHostsService.getFailoverHostIds(),
            clusterId: $scope.modalOptions.dialogData.objectId
         };

         clarityModalService.openOkCancelModal({
            title: i18nService.getString('ClusterUi',
                  'ha.config.admission.control.policy.failover.host.selection.title'),
            subTitle: {
               objectId: $scope.modalOptions.dialogData.objectId
            },
            dialogData: dialogData,
            defaultButton: 'submit',
            size: 'lg',
            modalClass: 'cluster-admission-control-failover-host-selector-dialog',
            contentTemplate: 'cluster-ui/resources/cluster/views/settings/services/ha/' +
                  'edit/pages/admissionControlFailoverHostsSelectorDialog.html',
            onSubmit: function() {
               $scope.modalOptions.alerts = [];
               $scope.modalOptions.isAlertClosed = true;
               return self.failoverHostsService.addFailoverHosts(
                     self.failoverHostsGridOptions,
                     dialogData.selectedItems);
            }
         });
      }

      function iconNameRendererFactory(nameField, iconField) {
         return (function (data) {
            var iconName = data[iconField];
            var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([undefined, nameField, iconName], data);
         });
      }

      function show65VcOrLaterFeatures() {
         return self.pageModel.is65VcOrLater &&
               (self.pageModel.admissionControlPolicy.type !==
               self.admissionControlTypes.DISABLED_TYPE);
      }

      self.validateFailoverLevel = validateFailoverLevel;
      self.validateFailoverCpu = validateFailoverCpu;
      self.validateFailoverMemory = validateFailoverMemory;
      self.normalizeSlotSizeCpu = normalizeSlotSizeCpu;
      self.normalizeSlotSizeMemory = normalizeSlotSizeMemory;
      self.calculateNumberOfVmsRequiringMultipleSlots =
            getNumberOfVmsRequiringMultipleSlots;
      self.openDialogForVmsRequiringMultipleSlots =
            openDialogForVmsRequiringMultipleSlots;
      self.show65VcOrLaterFeatures = show65VcOrLaterFeatures;
      self.validateResourceReductionThreshold = validateResourceReductionThreshold;
      // end region

      self.admissionControlDesc = getString('ha.config.admission.control.description');
      self.definedHostFailoverCapacityLabel = getString('ha.config.admission.control.propertygrid.failover.capacity.label');
      self.admissionControlPolicies = haAdmissionControlService.getPolicies();
      self.failoverLevelLabel = getString('ha.config.admission.control.policy.failover.level.num.hosts');
      self.hostFailuresToleratesLabel = getString('ha.config.admission.control.propertygrid.num.hosts.label');
      self.failoverLevelHostsLabel = getString('ha.config.admission.control.policy.failover.level.hosts');
      self.hostFailuresToleratesMaxLabel = getString('ha.config.admission.control.failover.level.desc');
      self.autoComputePercentagesLabel = getString('ha.config.admission.control.newpage.policy.failover.resources.override.label');
      self.failoverCpuCapacityLabel = getString('ha.config.admission.control.policy.failover.reserved.cpu');
      self.failoverMemoryCapacityLabel = getString('ha.config.admission.control.policy.failover.reserved.memory');
      self.percentLabel = getString('ha.config.percent');
      self.cpuLabel = getString('ha.config.admission.control.policy.cpu');
      self.memoryLabel = getString('ha.config.admission.control.policy.mem');
      self.slotSizePolicyLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy');
      self.coverAllVmLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.auto');
      self.coverAllVmHint = getString('ha.config.admission.control.policy.failover.level.slot.policy.auto.hint');
      self.fixedSlotSizeLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.fixed');
      self.fixedSlotSizeHint = getString('ha.config.admission.control.policy.failover.level.slot.policy.fixed.hint');
      self.cpuSlotSizeLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.cpu.size');
      self.MhzLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.cpu.mhz');
      self.memorySlotSizeLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.memory.size');
      self.MbLabel = getString('ha.config.admission.control.policy.failover.level.slot.policy.memory.mb');
      self.vmRequiringMultipleSlotsTitle =
            getString('ha.config.admission.control.policy.failover.level.slot.policy.' +
                  'vms.requiring.multiple.slots.label');
      self.slotPolicyViewButtonLabel = getString('ha.config.admission.control.' +
            'policy.failover.level.slot.policy.view.excluded.label');
      self.slotPolicyCalculateButtonLabel = getString('ha.config.admission.control.' +
            'policy.failover.level.slot.policy.calculate.label');
      self.resourceReductionThresholdLabel = getString(
            'ha.config.admission.control.propertygrid.resource.reduction.label');
      self.resourceReductionThresholdDesc = getString(
            'ha.config.admission.control.newpage.resource.reduction.desc');
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AdmissionControlVmsRequiringMultipleSlotsDialogController',
               AdmissionControlVmsRequiringMultipleSlotsDialogController);

   AdmissionControlVmsRequiringMultipleSlotsDialogController.$inject =
         ['$scope', 'i18nService', 'vuiConstants', 'columnRenderersRegistry'];

   function AdmissionControlVmsRequiringMultipleSlotsDialogController(
         $scope,
         i18nService,
         vuiConstants,
         columnRenderersRegistry
   ) {
      var self = this;
      self.header = i18nService.getString(
            'ClusterUi',
            'ha.config.admission.control.policy.failover.level.excluded.vms.header'
      );
      self.slotSizeRequirements =
            $scope.dialogOptions.actionDetails.dialogData.slotSizeRequirements;

      var vmSlotRequirementsGridData = [];
      var vmSlotRequirements = self.slotSizeRequirements.vmsRequiringMultipleSlots;

      if (vmSlotRequirements) {
         vmSlotRequirements.forEach(function(slot) {
            vmSlotRequirementsGridData.push({
               vmName: slot.vmName,
               requiredSlots: slot.requiredSlots
            });
         });
      }

      function getIconRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');
         return renderer(['icon', 'text'], {
            icon: 'vsphere-icon-vm-on',
            text: data.vmName
         });
      }

      var slotSizeColumnDefs = [
         {
            displayName: i18nService.getString('ClusterUi',
                  'ha.config.admission.control.policy.failover.level.excluded.vms.' +
                  'grid.name.header'),
            field: 'vmName',
            template: function (item) {
               return getIconRenderer(item);
            }
         },
         {
            displayName: i18nService.getString('ClusterUi',
                  'ha.config.admission.control.policy.failover.level.excluded.vms.grid' +
                  '.slots.header'),
            field: 'requiredSlots'
         }
      ];

      self.datagridOptions = {
         columnDefs: slotSizeColumnDefs,
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         data: vmSlotRequirementsGridData,
         resizable: true,
         height: '100%',
         pageConfig: {
            hidePager: true
         }
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('AdvancedOptionsPageController', AdvancedOptionsPageController);

   AdvancedOptionsPageController.$inject = ['$scope', 'i18nService'];

   function AdvancedOptionsPageController($scope, i18nService) {
      var self = this;
      var haManager = $scope.modalOptions.dialogData.manager;
      var getString = _.partial(i18nService.getString, 'ClusterUi');

      self.advancedOptionsDesc = getString('ha.config.advancedOptions.description');
      self.advancedOptionsBuilder = haManager.getAdvancedOptionsModel().haAdvancedOptionsBuilder;
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('FailuresAndResponsesPageController', FailuresAndResponsesPageController);

   FailuresAndResponsesPageController.$inject = ['$scope', 'i18nService'];

   function FailuresAndResponsesPageController($scope, i18nService) {
      var self = this;
      var haManager = $scope.modalOptions.dialogData.manager;

      self.pageModel = haManager.getFailuresAndResponsesModel();
      self.enableHostMonitoringLabel = getString('ha.config.hostmonitoring.enablefeature');
      self.hostMonitoringPopupParams = {
         title: i18nService.getString('Common', 'help'),
         message: getString('ha.config.hostmonitoring.description')
      };
      self.supportedFailureConditionsText = getSupportedFailureConditionsText();

      function getSupportedFailureConditionsText() {
         var supportedConditionsText;
         if (self.pageModel.storagePDLSupported) {
            if (self.pageModel.storageAPDSupported) {
               supportedConditionsText = getString(
                     'ha.config.failures.responses.host.failure.all.desc');
            } else {
               supportedConditionsText = getString(
                     'ha.config.failures.responses.host.failure.pdl.desc');
            }
         } else {
            if (self.pageModel.storageAPDSupported) {
               supportedConditionsText = getString(
                     'ha.config.failures.responses.host.failure.apd.desc');
            } else {
               supportedConditionsText = getString(
                     'ha.config.failures.responses.host.failure.none.desc');
            }
         }
         return supportedConditionsText;
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('HeartbeatDatastoresPageController', HeartbeatDatastoresPageController);

   HeartbeatDatastoresPageController.$inject = ['$scope', 'i18nService',
      'heartbeatDatastoresService'];

   function HeartbeatDatastoresPageController($scope, i18nService,
         heartbeatDatastoresService) {
      var isAutoSelectPolicy = false;
      var self = this;

      self.datastoresGridLabel =
            getString('ha.config.ds.preferred.heartbeat.datastores');

      var haManager = $scope.modalOptions.dialogData.manager;
      self.pageModel = haManager.getHeartbeatDatastoresModel();

      self.hbDatastoreDescLabel = self.pageModel.hbDatastoresPerHost === 1 ?
            i18nService.getString(
                  'ClusterUi',
                  'ha.config.ds.heartbeat.hint.single',
                  self.pageModel.hbDatastoresPerHost) :
            i18nService.getString(
                  'ClusterUi',
                  'ha.config.ds.heartbeat.hint.multiple',
                  self.pageModel.hbDatastoresPerHost);
      self.hbDatestoreCandidatePolicyLabel = getString('ha.config.ds.heartbeat.buttons.header');
      self.hbDatastoreCandidatePolicies =
            heartbeatDatastoresService.getCandidatePolicies();
      self.isHbDatastoresSelectionAllowed = isHbDatastoresSelectionAllowed;

      $scope.$watch('ctrl.pageModel.hbDatastoreCandidatePolicy',
            function(hbDsCandidatePolicy) {
               isAutoSelectPolicy =
                     !heartbeatDatastoresService.isAutoSelectPolicy(hbDsCandidatePolicy);
            });

      function isHbDatastoresSelectionAllowed() {
         return isAutoSelectPolicy;
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();

(function () {
   /**
    * Directive for edit HA VM monitoring.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .directive('editHaVmMonitoring', editHaVmMonitoring);

   editHaVmMonitoring.$inject = ['i18nService', 'haVmMonitoringService', 'haConstants'];

   function editHaVmMonitoring(i18nService, haVmMonitoringService, haConstants) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/editHaVmMonitoring.html',
         scope: {
            haConfiguration: '='
         },
         controller: ['$scope', function ($scope) {
            $scope.monitoringLevels = haVmMonitoringService.getMonitoringLevels();
            $scope.vmMonitoringSensitivitySliderOptions = getSliderOptions();
            $scope.VM_MON_SENSITIVITY_TYPE_PRESET =
               haVmMonitoringService.getSensitivityTypes().PRESET;
            $scope.VM_MON_SENSITIVITY_TYPE_CUSTOM =
               haVmMonitoringService.getSensitivityTypes().CUSTOM;

            $scope.blockOptions = {
               expanded: false
            };

            $scope.vmToolsMonSettings =
               $scope.haConfiguration.defaultVmSettings.vmToolsMonitoringSettings;
            $scope.normalizeMaxFailureWindow = normalizeMaxFailureWindow;
            $scope.normalizeMinUpTime = normalizeMinUpTime;
            $scope.normalizeMaxFailures = normalizeMaxFailures;
            $scope.normalizeFailureInt = normalizeFailureInt;

            initSensitivityLevel();

            //watchers region

            // Watch for changes on the slider value and propagate it to the model.
            $scope.$watch('vmMonitoringSensitivitySliderOptions.value',
               function (sliderValue) {
                  if ($scope.vmToolsMonSettings.vmMonitoringSensitivityType ===
                        haVmMonitoringService.getSensitivityTypes().PRESET) {
                     sliderValue = parseInt(sliderValue, 10);
                     updateCustomValues(sliderValue);
                  }
               });

            // Watch for changes on sensitivity type radio buttons
            // to update custom values if set to preset
            $scope.$watch('vmToolsMonSettings.vmMonitoringSensitivityType',
               function (sensitivityType) {
                  if (sensitivityType ===
                        haVmMonitoringService.getSensitivityTypes().PRESET) {
                     updateCustomValues(
                        $scope.vmMonitoringSensitivitySliderOptions.value);
                  }
               });

            // texts region

            $scope.haVmMonitoringLabel =
               getString(
                  'ha.config.failures.responses.vm.monitoring.vm.monitoring.check');
            $scope.heartbeatMonitoringLabel =
               getString(
                  'ha.config.failures.responses.vm.monitoring.enable.heartbeat.monitoring.label');
            $scope.heartbeatMonitoringDescriptionLabel =
               getString('ha.config.failures.responses.vm.monitoring.desc');
            $scope.vmMonitoringSensitivityLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity');
            $scope.vmMonitoringSensitivityPresetLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.preset');
            $scope.vmMonitoringSensitivityCustomLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.custom');
            $scope.vmMonitoringSensitivityFailureIntervalLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.failureInterval');
            $scope.vmMonitoringSensitivityMinUptimeLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.minUptime');
            $scope.vmMonitoringSensitivityMaxResetsLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.maxResets');
            $scope.vmMonitoringSensitivityMaxResetsWindowLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.maxResetsWindow');
            $scope.vmMonitoringSensitivityNoWindowLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.noWindow');
            $scope.vmMonitoringSensitivityMaxResetsWithinLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.maxResetsWithin');
            $scope.vmMonitoringSensitivityHoursLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.hours');
            $scope.vmMonitoringSensitivitySecondsLabel =
               getString('ha.config.vmResponse.vmMonitoringSensitivity.seconds');

            //helper functions region

            /**
             * Returns an object that represents the initial options of the
             * VM monitoring sensitivity preset slider.
             */
            function getSliderOptions() {
               return {
                  min: haVmMonitoringService.getPresetLevels().LOW,
                  max: haVmMonitoringService.getPresetLevels().HIGH,
                  value: haVmMonitoringService.getPresetLevels().HIGH,
                  minLabel: getString(
                     'ha.config.vmResponse.vmMonitoringSensitivity.preset.low'),
                  maxLabel: getString(
                     'ha.config.vmResponse.vmMonitoringSensitivity.preset.high'),
                  enabled: true,
                  width: 'auto',
                  dragHandleTitle: getString('ha.config.vmResponse.vmMonitoringSensitivity') +
                      " " + getString('ha.config.vmResponse.vmMonitoringSensitivity.preset')
               };
            }

            $scope.isVmMonitoringDisabled = function() {
               return $scope.haConfiguration.vmMonitoringState ===
                  haVmMonitoringService.DEFAULT_STATE.id;
            };

            $scope.isVmMonitoringSensitivityCustom = function() {
               return $scope.vmToolsMonSettings.vmMonitoringSensitivityType ===
                  haVmMonitoringService.getSensitivityTypes().CUSTOM;
            };

            $scope.isVmMonitoringSensitivityPreset = function() {
               return $scope.vmToolsMonSettings.vmMonitoringSensitivityType ===
                  haVmMonitoringService.getSensitivityTypes().PRESET;
            };

            $scope.hasFailureWindow = function() {
               return $scope.vmToolsMonSettings.vmToolsMonitorHasFailureWindow ===
                  true;
            };

            /**
             * Determine and init VM monitoring sensitivity type (if custom or
             * preset) and preset level based on different VM monitoring
             * sensitivity options
             */
            function initSensitivityLevel() {
               //initially determine and set set slider level based on server values
               var vmMonitoringSensitivityLevel = haVmMonitoringService.
               getHaMonitoringSensitivityLevel($scope.vmToolsMonSettings);

               //set value (preset or custom) to radio button for sensitivity type
               //and sensitivity level to slider if type is preset
               if (vmMonitoringSensitivityLevel !==
                  haVmMonitoringService.getPresetLevels().CUSTOM) {
                  $scope.vmToolsMonSettings.vmMonitoringSensitivityType =
                     haVmMonitoringService.getSensitivityTypes().PRESET;
                  $scope.vmMonitoringSensitivitySliderOptions.value =
                     vmMonitoringSensitivityLevel;
               } else {
                  $scope.vmToolsMonSettings.vmMonitoringSensitivityType =
                     haVmMonitoringService.getSensitivityTypes().CUSTOM;
               }
            }

            /**
             * Updates the values of failure interval, min uptime, max failures
             * and failure window based on selected preset level
             *
             * @param presetLevel VM monitoring sensitivity preset level
             */
            function updateCustomValues(presetLevel) {
               var sensitivityLevelValues = haVmMonitoringService.
                  getSensitivityLevelValues(presetLevel);

               $scope.vmToolsMonSettings.vmToolsMonitorFailureInt =
                  sensitivityLevelValues.failure_interval;
               $scope.vmToolsMonSettings.vmToolsMonitorMinUpTime =
                  sensitivityLevelValues.min_uptime;
               $scope.vmToolsMonSettings.vmToolsMonitorMaxFailures =
                  sensitivityLevelValues.max_failures;
               $scope.vmToolsMonSettings.vmToolsMonitorMaxFailureWindow =
                  sensitivityLevelValues.failure_window;
               $scope.vmToolsMonSettings.vmToolsMonitorHasFailureWindow = true;
            }

            function normalizeFailureInt() {
               var positiveValue = $scope.vmToolsMonSettings.vmToolsMonitorFailureInt;
               if (angular.isUndefined(positiveValue) || positiveValue < 0) {
                  $scope.vmToolsMonSettings.vmToolsMonitorFailureInt = 0;
               }

               if (positiveValue > haConstants.MAX_FAILURE_INTERVAL) {
                  $scope.vmToolsMonSettings.vmToolsMonitorFailureInt =
                        haConstants.MAX_FAILURE_INTERVAL;
               }
            }

            function normalizeMinUpTime() {
               var positiveValue = $scope.vmToolsMonSettings.vmToolsMonitorMinUpTime;
               if (angular.isUndefined(positiveValue) || positiveValue < 0) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMinUpTime = 0;
               }

               if (positiveValue > haConstants.MAX_MINIMUM_UPTIME) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMinUpTime =
                        haConstants.MAX_MINIMUM_UPTIME;
               }
            }

            function normalizeMaxFailures() {
               var positiveValue = $scope.vmToolsMonSettings.vmToolsMonitorMaxFailures;
               if (angular.isUndefined(positiveValue) || positiveValue < 0) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMaxFailures = 0;
               }

               if (positiveValue > haConstants.MAX_VM_PER_RESET) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMaxFailures =
                        haConstants.MAX_VM_PER_RESET;
               }
            }

            function normalizeMaxFailureWindow() {
               var positiveValue = $scope.vmToolsMonSettings.vmToolsMonitorMaxFailureWindow;
               if (angular.isUndefined(positiveValue) || positiveValue < 1) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMaxFailureWindow = 1;
               }
               if (positiveValue > haConstants.MAX_RESETS_WINDOW_HRS) {
                  $scope.vmToolsMonSettings.vmToolsMonitorMaxFailureWindow =
                        haConstants.MAX_RESETS_WINDOW_HRS;
               }
            }

            function getString(key) {
               return i18nService.getString('ClusterUi', key);
            }
         }]
      };
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.cluster').directive(
      'haApdResponse', haApdResponse);

   haApdResponse.$inject = ['i18nService', 'haApdResponseService',
      'haConstants', 'haVmReactionsOnApdClearedService', 'clusterConstants'];

   function haApdResponse(i18nService, haApdResponseService,
         haConstants, haVmReactionsOnApdClearedService, clusterConstants) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/haApdResponse.html',
         scope: {
            haConfiguration: '=',
            storageApdSupported: '='
         },
         controller: ['$scope', function($scope) {
            $scope.isViewDisabled = function () {
               return !$scope.storageApdSupported ||
                  !$scope.haConfiguration.hostMonitoringEnabled ||
                  $scope.haConfiguration.defaultVmSettings.restartPriority ===
                  haConstants.restartPriority.DISABLED;
            };
            $scope.isApdRecoveryDelayDisabled = function() {
               return $scope.haConfiguration.vmcpSettings.apdResponse ===
                     haConstants.storageVmReaction.DISABLED ||
                     $scope.haConfiguration.vmcpSettings.apdResponse ===
                     haConstants.storageVmReaction.WARNING;
            };

            $scope.normalizeRecoveryDelay = function(event) {
               if (angular.isUndefined(event.target.value) ||
                     event.target.value < $scope.MIN_APD_RECOVERY_DELAY) {
                  $scope.haConfiguration.vmcpSettings.apdRecoveryDelayMinutes =
                        $scope.MIN_APD_RECOVERY_DELAY;
               }

               if (event.target.value > $scope.MAX_APD_RECOVERY_DELAY) {
                  $scope.haConfiguration.vmcpSettings.apdRecoveryDelayMinutes =
                        $scope.MAX_APD_RECOVERY_DELAY;
               }
            };

            $scope.apdResponses = haApdResponseService.getResponses();
            $scope.reactionsOnApdCleared = haVmReactionsOnApdClearedService.getReactions();
            $scope.responseForApdLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.label');
            $scope.responseForApdSubmenuLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.submenu.label');
            $scope.responseForApdDescription = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.desc');
            $scope.responseRecoveryLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.recovery.submenu');
            $scope.responseDelayLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.recovery.delay');
            $scope.minutesLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.ds.dswithapd.minutes');
            $scope.MIN_APD_RECOVERY_DELAY = 0;
            $scope.MAX_APD_RECOVERY_DELAY = Math.floor(clusterConstants.MAX_INTEGER /
                  haConstants.SECONDS_IN_A_MINUTE);
         }]
      };
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'haHostFailureResponse', haHostFailureResponse);

   haHostFailureResponse.$inject = ['$rootScope', 'i18nService',
         'haHostFailureResponseService', 'vcService', 'haConstants'];

   function haHostFailureResponse($rootScope, i18nService, haHostFailureResponseService,
         vcService, haConstants) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/haHostFailureResponse.html',
         scope: {
            haData: '='
         },
         controllerAs: 'vm',
         bindToController: true,
         controller: ['$scope', function($scope) {
            var vm = this;
            // Used to persist the restart priority dropdown value.
            var selectedRestartPriority = null;
            var objectId = $rootScope._route.objectId;
            vm.is65VcOrLater = false;

            vm.hostFailureResponses = {
               label: getString('ha.config.hostfailure.label'),
               vmRestart: getString('ha.config.failures.responses.host.failure.vm.restart.restartvms'),
               vmRestartLabel: getString('ha.config.failures.responses.host.failure.vm.restart.label'),
               vmRestartDescription: getString('ha.config.failures.responses.host.failure.vm.restart.restartvms.desc'),
               subMenuLabel: getString('ha.config.failures.responses.host.failure.response.submenu.label'),
               responseLabel: getString('ha.config.failures.responses.host.failure.response.label')
            };

            vm.hostFailureOptions = {
               disabled: haHostFailureResponseService.getDisabledOption(),
               vmRestart: getVmRestartOption()
            };

            vcService.is65VcOrLater(objectId)
                  .then(function(is65VcOrLater) {
                     vm.restartPriorityOptions = haHostFailureResponseService
                           .getVmRestartPriorityOptions(is65VcOrLater);
                     // Default values.
                     vm.data = {
                        hostFailure: vm.hostFailureOptions.disabled.id,
                        restartPriority: vm.restartPriorityOptions.medium.id
                     };

                     vm.haData.is65VcOrLater = is65VcOrLater;
                     vm.is65VcOrLater = is65VcOrLater;

                     if (is65VcOrLater) {
                        vm.readyConditionOptions =
                              haHostFailureResponseService.getReadyConditionOptions();

                        vm.vmDependencyRestartLabels = getVmDependencyRestartLabels();

                        vm.postReadyDelayPostParams = {
                           message: getVmDependencyRestartLabels().postReadyPostDelayDesc,
                           title: i18nService.getString('Common', 'help')
                        };

                        vm.restartPriorityTimeoutPostParams = {
                           message: getVmDependencyRestartLabels().restartPriorityTimeoutDesc,
                           title: i18nService.getString('Common', 'help')
                        };
                     }
                  }).then(function () {

               // This watcher sets the dropdown value for Host Failure when the restart
               // priority gets changed externally (e.g. after data is retrieved from the
               // backend.
               $scope.$watch('vm.haData.haConfiguration.defaultVmSettings.restartPriority',
                     function (newValue) {
                        if (newValue) {
                           var hostFailureDropDownValue = vm.hostFailureOptions.disabled.id;

                           // If the new value is not `disabled` it gets set to a made up
                           // value (that doesn't have a VMODL equivalent) in order to enable
                           // selection of a restart priority.
                           if (newValue !== vm.hostFailureOptions.disabled.id) {
                              hostFailureDropDownValue = vm.hostFailureOptions.vmRestart.id;
                              vm.data.restartPriority = newValue;
                           }
                           vm.data.hostFailure = hostFailureDropDownValue;
                        }
                     });

               $scope.$watch('vm.data.hostFailure', function (newValue) {
                  if (newValue) {
                     if (newValue !== vm.hostFailureOptions.vmRestart.id) {
                        vm.haData.haConfiguration.defaultVmSettings.restartPriority =
                              newValue;
                     } else {
                        if (!selectedRestartPriority) {
                           vm.haData.haConfiguration.defaultVmSettings.restartPriority =
                                 vm.restartPriorityOptions.medium.id;
                        } else {
                           vm.haData.haConfiguration.defaultVmSettings.restartPriority =
                                 selectedRestartPriority;
                        }
                     }
                  }
               });

               $scope.$watch('vm.data.restartPriority', function (newValue) {
                  // restartPriority dropdown should only be enabled and the corresponding
                  // model value be set only when the host failure is set to `vmRestart`.
                  if (newValue && vm.data.hostFailure ===
                        vm.hostFailureOptions.vmRestart.id) {
                     selectedRestartPriority = newValue;
                     vm.haData.haConfiguration.defaultVmSettings.restartPriority =
                           newValue;
                  }
               });
            });

            vm.MIN_RESTART_PRIORITY_TIMEOUT = 0;
            vm.MAX_RESTART_PRIORITY_TIMEOUT = haConstants.MAX_RESTART_PRIORITY_TIMEOUT;
            vm.MIN_POST_READY_DELAY = 0;
            vm.MAX_POST_READY_DELAY = haConstants.MAX_POST_READY_DELAY;

            vm.normalizePostReadyDelay = normalizePostReadyDelay;
            vm.normalizeRestartPriorityTimeout = normalizeRestartPriorityTimeout;

            function getString(key) {
               return i18nService.getString('ClusterUi', key);
            }

            function getVmRestartOption() {
               return {
                  id: "vmRestart",
                  label: vm.hostFailureResponses.vmRestart,
                  description: vm.hostFailureResponses.vmRestartDescription
               };
            }

            function getVmDependencyRestartLabels() {
               var vmDependencyRestartLabels = {
                  readyConditionLabel : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.label"),
                  readyConditionDescLabel : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.condition"),
                  postReadyDelay : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.delay.enable"),
                  postReadyPostDelayDesc : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.delay.desc"),
                  restartPriorityTimeout : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.timeout"),
                  restartPriorityTimeoutDesc : getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.timeout.desc"),
                  seconds: getString(
                        "ha.config.failures.responses.host.failure.restart.criteria.delay.seconds")
               };

               return vmDependencyRestartLabels;
            }

            // region validation
            function normalizePostReadyDelay(event) {
               if (angular.isUndefined(event.target.value) ||
                     event.target.value < vm.MIN_POST_READY_DELAY) {
                  vm.haData.orchestration.defaultVmReadiness.postReadyDelay =
                        vm.MIN_POST_READY_DELAY;
               }

               if (event.target.value > haConstants.MAX_POST_READY_DELAY) {
                  vm.haData.orchestration.defaultVmReadiness.postReadyDelay =
                        haConstants.MAX_POST_READY_DELAY;
               }
            }

            function normalizeRestartPriorityTimeout(event) {
               if (angular.isUndefined(event.target.value) || event.target.value <
                     vm.MIN_RESTART_PRIORITY_TIMEOUT ) {
                  vm.haData.haConfiguration.defaultVmSettings.restartPriorityTimeout =
                        vm.MIN_RESTART_PRIORITY_TIMEOUT;
               }

               if (event.target.value > haConstants.MAX_RESTART_PRIORITY_TIMEOUT) {
                  vm.haData.haConfiguration.defaultVmSettings.restartPriorityTimeout =
                        haConstants.MAX_RESTART_PRIORITY_TIMEOUT;
               }
            }
         }]
      };
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.cluster').directive(
      'haHostIsolationResponse', haHostIsolationResponse);

   haHostIsolationResponse.$inject = ['i18nService', 'haHostIsolationResponseService',
         'haConstants'];

   function haHostIsolationResponse(i18nService, haHostIsolationResponseService,
         haConstants) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/haHostIsolationResponse.html',
         scope: {
            haConfiguration: '='
         },
         controller: ['$scope', function($scope) {
            $scope.isViewDisabled = function () {
               return !$scope.haConfiguration.hostMonitoringEnabled ||
                     $scope.haConfiguration.defaultVmSettings.restartPriority ===
                           haConstants.restartPriority.DISABLED;
            };
            $scope.responseForHostIsolationLabel = i18nService.getString('ClusterUi',
               'ha.config.vm.hostIsolationResponse.label');
            $scope.hostIsolationResponseLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.host.isolation.label');
            $scope.hostIsolationResponseDescLabel = i18nService.getString('ClusterUi',
               'ha.config.failures.responses.host.isolation.desc');
            $scope.hostIsolationResponses = haHostIsolationResponseService.getResponses();
         }]
      };
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.cluster').directive(
         'haPdlResponse', haPdlResponse);

   haPdlResponse.$inject = ['i18nService', 'haPdlResponseService',
      'haConstants'];

   function haPdlResponse(i18nService, haPdlResponseService,
         haConstants) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/haPdlResponse.html',
         scope: {
            haConfiguration: '=',
            storagePdlSupported: '='
         },
         controller: ['$scope', function($scope) {
            $scope.isViewDisabled = function () {
               return !$scope.storagePdlSupported ||
                     !$scope.haConfiguration.hostMonitoringEnabled ||
                     $scope.haConfiguration.defaultVmSettings.restartPriority ===
                           haConstants.restartPriority.DISABLED;
            };
            $scope.pdlResponses = haPdlResponseService.getResponses();
            $scope.responseForPdlLabel = i18nService.getString('ClusterUi',
                  'ha.config.failures.responses.ds.dswithpdl.label');
            $scope.responseForPdlSubmenuLabel = i18nService.getString('ClusterUi',
                  'ha.config.failures.responses.ds.dswithpdl.submenu.label');
            $scope.responseForPdlDescription = i18nService.getString('ClusterUi',
                  'ha.config.failures.responses.ds.dswithpdl.desc');
         }]
      };
   }
})();

(function() {
   /**
    * Directive for HA heartbeat datastores.
    */
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .directive('heartbeatDatastores', heartbeatDatastores);

   heartbeatDatastores.$inject = ['i18nService', 'heartbeatDatastoresService',
      'defaultUriSchemeUtil'];

   function heartbeatDatastores(i18nService, heartbeatDatastoresService,
         defaultUriSchemeUtil) {
      return {
         restrict: 'E',
         templateUrl: 'cluster-ui/resources/cluster/views/settings/services/ha/heartbeatDatastores.html',
         scope: {
            data: '=',
            isEditMode: '=',
            datastoresGridLabel: '='
         },
         controller: ['$scope', '$element', function($scope, $element) {
            var DS_KENDO_GRID_SELECTOR = 'div.heartbeat-datastores div[kendo-grid]';
            var dsKendoGrid;

            $scope.hostsGridLabel = getString('ha.config.ds.host.mounting.datastores');

            $scope.datastoresGridOptions =
               heartbeatDatastoresService.getDatastoreGridOptions($scope.isEditMode);
            $scope.hostsGridOptions = heartbeatDatastoresService.getHostGridOptions(
                  $scope.isEditMode, hostsGridDataBound);

            //region Event handlers

            // listener for scope.data changed event in order to bind the
            // heartbeat datastores to the ds gird
            $scope.$watch('data', function(data) {
               var dsData = !!data ? data : [];
               $scope.datastoresGridOptions.data = dsData;

               if ($scope.isEditMode) {
                  // add checkbox click handler
                  dsKendoGrid = $element.find(DS_KENDO_GRID_SELECTOR);
                  dsKendoGrid.on('click', '.row-checkbox', checkboxClickHandler);
               }
            });

            // listener for datastore selection changed event in order to get the hosts
            // attached to that datastore
            $scope.$watch(
               function() {
                  return $scope.datastoresGridOptions.selectedItems;
               },
               selectedDatastoreChangeHandler);

            $scope.$on('$destroy', function(){
               if ($scope.isEditMode) {
                  dsKendoGrid.off('click', '.row-checkbox', checkboxClickHandler);
               }
            });

            function checkboxClickHandler(event) {
               var checkedRow = $(event.target).closest('tr');
               var kendoDataItem = dsKendoGrid.data('kendoGrid').dataItem(checkedRow);

               var selectedDsUid =
                     defaultUriSchemeUtil.getVsphereObjectId(kendoDataItem.provider);

               for (var i = 0; i < $scope.data.length; i++) {
                  var candidateDsData = $scope.data[i];
                  var candidateDsUid =
                        defaultUriSchemeUtil.getVsphereObjectId(candidateDsData.provider);
                  if (_.isEqual(candidateDsUid, selectedDsUid)) {
                     candidateDsData.isPreferred = event.target.checked;
                     break;
                  }
               }
            }

            function hostsGridDataBound() {
               $element.find('[vui-datagrid] .k-grid-content').css('height', '');
               kendo.resize($element);
            }

            //endregion

            function getString(key) {
               return i18nService.getString('ClusterUi', key);
            }

            //region Hosts grid functions


            function selectedDatastoreChangeHandler(selectedDsItems) {
               if (selectedDsItems.length === 0) {
                  $scope.hostsGridOptions.data = [];
                  return;
               }

               var selectedDsItem = selectedDsItems[0];
               heartbeatDatastoresService
                     .getDatastoreHosts(selectedDsItem.accessibleAndMountedHosts)
                     .then(function(hostsData) {
                        $scope.hostsGridOptions.data = hostsData;
                     });
            }
            //endregion
         }]
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('EditProactiveHaDialogController', EditProactiveHaDialogController);

   EditProactiveHaDialogController.$inject = ['$scope', 'dataService', 'mutationService',
      'clusterSpecBuilderService', 'vuiConstants', 'i18nService', 'editProactiveHaService',
      '$element', 'clusterConstants'];

   function EditProactiveHaDialogController($scope, dataService, mutationService,
         clusterSpecBuilderService, vuiConstants, i18nService, editProactiveHaService,
         $element, clusterConstants) {

      var self = this;
      var objectId = $scope.modalOptions.dialogData.availableTargets[0];

      $scope.modalOptions.alerts = [];
      $scope.modalOptions.onSubmit = onSubmit;
      $scope.$on('kendoWidgetCreated', function(event, widget) {
         if (!widget || widget.constructor !== kendo.ui.Grid) {
            return;
         }
         var enableProvidersKendoGridSelector =
               ".enable-providers-container [kendo-grid]";
         self.gridWidget = getKendoGrid(enableProvidersKendoGridSelector);
      });

      self.loading = true;
      self.signPostConfig = {
         message: i18nService.getString(
               'ClusterUi', 'ha.config.failures.responses.partial.failure.remediation.dd.help'),
         title: i18nService.getString('Common', 'help')
      };
      self.automationLevels = editProactiveHaService.AUTOMATION_LEVELS;
      self.remediationLevels = editProactiveHaService.REMEDIATION_LEVELS;

      self.getRemediationLevelDesc = function() {
         self.remediationLevelDesc = editProactiveHaService
               .getRemediationLevelDescription(self.remediationLevel.value);
      }.bind(this);

      self.getAutomationLevelDesc = function() {
         self.automationLevelDesc = editProactiveHaService
               .getAutomationLevelDescription(self.automationLevel.value);
      }.bind(this);

      self.datagridOptions = {
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         sortMode: vuiConstants.grid.sortMode.NONE,
         searchable: false,
         resizable: true,
         selectedItems: [],
         data: [],
         columnDefs: getColumnDefs(),
         onMasterCheckboxClick: function(event) {
            var enabledState =
                  event.currentTarget.checked;
            _.each(self.clusterProviders, function(item) {
               item.isEnabled = enabledState;
               return self.datagridOptions.data;
            });

            _.each(self.gridWidget._data, function(item) {
               item.isEnabled = enabledState;
               return self.gridWidget._data;
            });

            if (self.gridWidget) {
               self.gridWidget.refresh();
            }
         },
         onProviderCheckboxClick: function(dataItem) {
            var enabledState = !dataItem.isEnabled;

            dataItem.isEnabled = enabledState;
            _.find(self.clusterProviders, function(clusterProvider) {
               return clusterProvider.nameProvider === dataItem.nameProvider;
            }).isEnabled = enabledState;

            if (self.gridWidget) {
               // setOptions recompiles header, i.e. mastercheckbox works fine then,
               // refresh doesn't refresh headers.
               self.gridWidget.setOptions(self.datagridOptions);
            }
         }
      };

      self.failureConditionsSignPostParams =
            editProactiveHaService.failureConditionsVuiSignPost();

      self.datagridOptionsFailureConditions = getFailureConditionsDatagridOptions();

      self.failureConditionsClusterLevelVuiSignPost =
            editProactiveHaService.failureConditionsClusterLevelVuiSignPost();

      self.datagridOptionsFailureConditionsHosts =
            editProactiveHaService.getFailureConditionsHostsDatagridOptions();

      self.proactiveHaBlockAtTypes = clusterConstants.proactiveHaBlockAtTypes;
      self.blockAtOldValue = null;

      self.filterModel = {};
      self.filterHealthUpdateInfo = [];
      self.filterHostInfo = [];

      self.preselectComparator = function(gridDataItem) {
         return gridDataItem.isFilterOn;
      };

      getViewData();

      function getViewData() {
         dataService.getData(
               objectId,
               'com.vmware.vsphere.client.clusterui.model.services.ClusterProactiveHaConfigData')
               .then(function(proHaData) {
                  if (proHaData) {
                     self._originalData = {
                        proHaEnabled: proHaData.infraUpdateHaEnabled,
                        automationLevel: proHaData.behaviorInfraUpdate,
                        remediationLevel: proHaData.proactiveHaRemediationLevel,
                        clusterProviders: _.map(proHaData.clusterProviders, _.clone)
                     };

                     self.proHaEnabled = proHaData.infraUpdateHaEnabled;
                     self.automationLevel = {
                        value: proHaData.behaviorInfraUpdate
                     };
                     self.remediationLevel = {
                        value: proHaData.proactiveHaRemediationLevel
                     };

                     self.getAutomationLevelDesc();
                     self.getRemediationLevelDesc();

                     self.clusterProviders = proHaData.clusterProviders;
                     self.datagridOptions.data = proHaData.clusterProviders;
                  }

                  self.loading = false;
               });
      }

      function isDataChanged() {
         var isProvidersStateChanged = _.find(self.clusterProviders, function(clusterProvider, index) {
            return clusterProvider.isEnabled !== self._originalData.clusterProviders[index].isEnabled;
         });

         return self._originalData &&
               (self._originalData.proHaEnabled !== self.proHaEnabled ||
               self._originalData.automationLevel !== self.automationLevel.value ||
               self._originalData.remediationLevel !== self.remediationLevel.value ||
               isProvidersStateChanged ||
               self.blockAtValue);
      }

      function onSubmit() {
         $scope.modalOptions.alerts = [];

         if (self.loading) {
            return false;
         }

         if (!isDataChanged()) {
            // do not make a call when nothing changed
            return true;
         }

         var formData = editProactiveHaService.getFormData(
               self.proHaEnabled,
               self.automationLevel.value,
               self.remediationLevel.value,
               self.clusterProviders
         );
         var clusterSpec =
               clusterSpecBuilderService.buildClusterComputeResourceSpec(
                     formData, true);

         return mutationService.validate(
               objectId,
               'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
               clusterSpec).then(function(validationResult) {
            if (validationResult && !validationResult.error &&
                  validationResult.result &&
                  validationResult.result.isValid !== true) {
               $scope.modalOptions.alerts.push({
                  type: vuiConstants.validationBanner.type.ERROR,
                  text: validationResult.result.validationMessage
               });
               return false;
            } else {
               mutationService.apply(
                     objectId,
                     'com.vmware.vsphere.client.cluster.ClusterComputeResourceSpec',
                     clusterSpec)
                     .then(function(response) {
                        var selectedItem = self.datagridOptions.selectedItems[0];
                        if (!response.error &&
                              selectedItem &&
                              selectedItem.isEnabled &&
                              self.blockAtValue) {

                           var datagridFailureConditionsHosts =
                                 self.datagridOptionsFailureConditionsHosts;
                           var filterModelSpec =
                                 editProactiveHaService.getFilterModelSpec(
                                       self.blockAtValue,
                                       self.filterModel,
                                       self.filterHealthUpdateInfo,
                                       datagridFailureConditionsHosts.selectedItems);
                           mutationService.apply(
                                 objectId,
                                 'com.vmware.vsphere.client.cluster.ha.proactive.FilterModel',
                                 filterModelSpec
                           );
                        }
                     });

               return true;
            }
         });
      }

      function getColumnDefs() {
         return [{
            filterable: false,
            sortable: false,
            groupable: false,
            searchable: false,
            width: '39px',
            headerTemplate: function() {
               var isNotChecked;
               var isDisabled = false;
               if (!self.clusterProviders || self.clusterProviders.length === 0) {
                  isNotChecked = true;
                  isDisabled = true;
               } else {
                  isNotChecked = _.find(self.clusterProviders, function(clusterProvider) {
                     return !clusterProvider.isEnabled;
                  });
               }
               return '<input type="checkbox"' +
                     ' ng-checked="' + !isNotChecked +
                     '" ng-disabled="' + isDisabled +
                     '" ng-click="datagridOptions.onMasterCheckboxClick($event)"' +
                     ' data-test-id="master-check-box"/>';
            },
            field: 'isEnabled',
            type: 'boolean',
            template: function(dataItem) {
               return '<input type="checkbox" class="row-checkbox" ng-checked="' +
                     dataItem.isEnabled +
                     '" ng-click="datagridOptions.onProviderCheckboxClick(dataItem)">';
            }
         }, {
            displayName: i18nService.getString(
                  'ClusterUi',
                  'ha.config.failures.responses.partial.failure.providers.grid.provider'),
            field: 'nameProvider',
            type: 'string'
         }, {
            displayName: i18nService.getString(
                  'ClusterUi',
                  'ha.config.failures.responses.partial.failure.providers.grid.status'),
            field: 'isEnabled',
            type: 'boolean',
            template: function(dataItem) {
               var isEnabledLabel = dataItem.isEnabled ?
                     i18nService.getString('ClusterUi', 'ha.config.proHa.provider.enabled') :
                     i18nService.getString('ClusterUi', 'ha.config.proHa.provider.disabled');
               return '<span>' + isEnabledLabel + '</span>';
            }
         }, {
            displayName: i18nService.getString(
                  'ClusterUi',
                  'ha.config.failures.responses.partial.failure.providers.grid.isBlocked'),
            field: 'isBlocked',
            type: 'boolean',
            template: function(dataItem) {
               var isBlockedLabel = dataItem.isFiltered ?
                     i18nService.getString('ClusterUi', 'ha.config.constants.yes') :
                     i18nService.getString('ClusterUi', 'ha.config.constants.no');
               return '<span>' + isBlockedLabel + '</span>';
            }
         }];
      }

      $scope.$watch(function() {
         if (self.datagridOptions.selectedItems) {
            return self.datagridOptions.selectedItems;
         }
      }, function(newValue, oldValue) {
         if (newValue && newValue.length === 1) {
            var selectedItem = newValue[0];
            var previousSelectedItemIdProvider =
                  oldValue && oldValue.length > 0 ? oldValue[0].idProvider : null;
            if (selectedItem.idProvider !== previousSelectedItemIdProvider) {
               getFailureConditions(selectedItem);
            }
         }
      }, true);

      $scope.$watch(function() {
         if (self.filterHealthUpdateInfo) {
            return self.filterHealthUpdateInfo;
         }
      }, function(newValue) {
         if (newValue) {
            self.isBlockAtAvailable = _.some(self.filterHealthUpdateInfo, function(item) {
               return item.isFilterOn;
            });
         }
      }, true);

      $scope.$watch(function() {
         if (self.blockAtValue) {
            return self.blockAtValue;
         }
      }, function(newValue, oldValue) {
         self.blockAtOldValue = oldValue;
         if (newValue) {
            fillDatagrid(self.filterHealthUpdateInfo, self.datagridOptionsFailureConditions);

         }

      });

      $scope.$watchCollection(function() {
         if (self.datagridOptionsFailureConditionsHosts.selectedItems) {
            return self.datagridOptionsFailureConditionsHosts.selectedItems;
         }
      }, function(newValue) {
         if (newValue && self.filterHealthUpdateInfo.length > 0) {
            fillDatagrid(self.filterHealthUpdateInfo, self.datagridOptionsFailureConditions);
         }
      });


      function getFailureConditions(selectedItem) {
         var providerId = selectedItem.idProvider;
         editProactiveHaService.getFilterForProvider(objectId, providerId)
               .then(function(data) {
                  if (data) {
                     self.filterModel = data.filterForProvider;

                     self.filterHealthUpdateInfo =
                           self.filterModel && self.filterModel.filterHealthUpdateInfo ?
                                 self.filterModel.filterHealthUpdateInfo : [];

                     self.filterHostInfo = self.filterModel && self.filterModel.filterHostInfo ?
                           self.filterModel.filterHostInfo : [];

                     fillDatagrid(self.filterHealthUpdateInfo, self.datagridOptionsFailureConditions);

                     fillDatagrid(self.filterHostInfo, self.datagridOptionsFailureConditionsHosts);

                     self.blockAtValue =
                           editProactiveHaService.getBlockAtValue(self.filterHealthUpdateInfo, self.filterHostInfo);

                  }
               });
      }

      function getKendoGrid(gridSelector) {
         return $element.find(gridSelector).data('kendoGrid');
      }

      function fillDatagrid(data, datagridOptions) {
         datagridOptions.data = data;
      }

      function getFailureConditionsDatagridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.NONE,
            sortMode: vuiConstants.grid.sortMode.NONE,
            searchable: false,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getFailureConditionsColumnDefs(),
            onFailureComponentMasterCheckboxClick: function(event) {
               var checkedState = event.currentTarget.checked;

               _.each(self.filterHealthUpdateInfo, function(item) {
                  item.isFilterOn = checkedState;
               });

               fillDatagrid(self.filterHealthUpdateInfo, self.datagridOptionsFailureConditions);
            },
            onFailureComponentSelected: function(currentItem) {
               if (self.filterModel && self.filterHealthUpdateInfo) {
                  currentItem.isFilterOn = !currentItem.isFilterOn;

                  _.each(self.filterHealthUpdateInfo, function(item) {
                     if (currentItem.id === item.id) {
                        item.isFilterOn = currentItem.isFilterOn;
                     }
                  });

                  var hasAtLeastOneFailureComponentSelected =
                        _.some(self.filterHealthUpdateInfo, function(item) {
                           return item.isFilterOn;
                        });
                  if(hasAtLeastOneFailureComponentSelected && !self.blockAtValue) {
                     self.blockAtValue = clusterConstants.proactiveHaBlockAtTypes.CLUSTER_LEVEL;
                  }


                  fillDatagrid(self.filterHealthUpdateInfo, self.datagridOptionsFailureConditions);
               }
            }
         };
      }

      function getFailureConditionsColumnDefs() {
         return [
            {
               width: '39px',
               headerTemplate: function() {
                  var isNotChecked;
                  if (!self.filterHealthUpdateInfo || self.filterHealthUpdateInfo.length === 0) {
                     isNotChecked = true;
                  } else {
                     isNotChecked = _.find(self.filterHealthUpdateInfo, function(filterHealthUpdateInfo) {
                        return !filterHealthUpdateInfo.isFilterOn;
                     });
                  }
                  return '<input type="checkbox"' +
                        ' ng-checked="' + !isNotChecked +
                        '" ng-click="datagridOptions.onFailureComponentMasterCheckboxClick($event)"' +
                        ' data-test-id="failure-master-check-box"/>';
               },
               field: 'isFilterOn',
               type: 'boolean',
               template: function(dataItem) {
                  return '<input type="checkbox" class="row-checkbox" ng-checked="' +
                        dataItem.isFilterOn +
                        '"' +
                        ' ng-click="datagridOptions.onFailureComponentSelected(dataItem)">';
               }
            },
            {
               displayName: i18nService.getString(
                     'ClusterUi',
                     'ha.config.failures.responses.partial.failure.filters.grid.component'
               ),
               field: 'component'
            },
            {
               displayName: i18nService.getString(
                     'ClusterUi',
                     'ha.config.failures.responses.partial.failure.filters.grid.id'
               ),
               field: 'id'
            },
            {
               displayName: i18nService.getString(
                     'ClusterUi',
                     'ha.config.failures.responses.partial.failure.filters.grid.desc'
               ),
               field: 'description',
               template: function(dataItem) {
                  return dataItem && dataItem.description ?
                  '<span title="' + dataItem.description + '">' + dataItem.description + '</span>' : '';
               }
            },
            {
               displayName: i18nService.getString(
                     'ClusterUi',
                     'ha.config.failures.responses.partial.failure.filters.grid.blocked'),
               field: 'isFilterOn',
               type: 'boolean',
               template: function(dataItem) {

                  var isBlockAtValueIndividualHosts =
                        self.blockAtValue === clusterConstants.proactiveHaBlockAtTypes.INDIVIDUAL_HOSTS;
                  var noHostsAreSelectedFromDatagrid =
                        self.datagridOptionsFailureConditionsHosts.selectedItems &&
                        self.datagridOptionsFailureConditionsHosts.selectedItems.length === 0;

                  var areHostsSelected = !(isBlockAtValueIndividualHosts && noHostsAreSelectedFromDatagrid);

                  var isBlockedLabel = dataItem.isFilterOn && areHostsSelected ?
                        i18nService.getString('ClusterUi', 'ha.config.constants.yes') :
                        i18nService.getString('ClusterUi', 'ha.config.constants.no');
                  return '<span>' + isBlockedLabel + '</span>';
               }
            }
         ];
      }
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('VSphereHaController', VSphereHaController);

   VSphereHaController.$inject = ['$scope', 'dataService', 'i18nService', 'vuiConstants',
         'columnRenderersRegistry', 'haConstants', 'haAdmissionControlService',
         'heartbeatDatastoresService', '$element', 'vcService'];

   function VSphereHaController($scope, dataService, i18nService, vuiConstants,
         columnRenderersRegistry, haConstants, haAdmissionControlService,
         heartbeatDatastoresService, $element, vcService) {
      var self = this;
      var objectId = $scope._route.objectId;
      var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
      var wrappedTextRenderer =
            columnRenderersRegistry.getColumnRenderer('wrapped-text');

      self.haStatusHeaderOptions = getViewHeaderOptions();
      self.headerFailureConditionsOptions = getFailureConditionsOptions();
      self.expandForDetailsLabel = getString('ha.config.expandForDetails');
      self.dsForHeartbeatingLabel = getString('ha.config.dsForHeartbeating');

      self.datagridOptions = getDatagridOptions();
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         "configurationEx.dasConfig.heartbeatDatastore",
         "configurationEx.dasConfig.enabled",
         "configurationEx.dasConfig.defaultVmSettings.isolationResponse",
         "configurationEx.dasConfig.defaultVmSettings.restartPriority",
         "configurationEx.dasConfig.hBDatastoreCandidatePolicy",
         "configurationEx.dasConfig.admissionControlPolicy",
         "configurationEx.dasConfig.admissionControlEnabled",
         "configurationEx.dasConfig.admissionControlPolicy.cpuFailoverResourcesPercent",
         "configurationEx.dasConfig.admissionControlPolicy.memoryFailoverResourcesPercent",
         "configurationEx.dasConfig.admissionControlPolicy.failoverLevel",
         "configurationEx.dasConfig.admissionControlPolicy.failoverHosts",
         "configurationEx.dasConfig.option",
         "configurationEx.dasConfig.hostMonitoring",
         "configurationEx.dasConfig.vmMonitoring",
         "dasAdvancedRuntimeInfo"
      ];
      self.data = {};
      self.admissionControlData = {};
      self.getViewData = getViewData;
      self.admissionControlPolicy = haConstants.admissionControlPolicy;

      self.advOptionsBlock = {
         expanded: false
      };
      self.advancedOptionsLabel = getString('ha.config.advancedOptionsLabel');
      self.configParametersLabel =
         getString('ha.config.advancedOptions.configParametersLabel');
      self.proactiveHaActions = [{
         actionUid: 'vsphere.core.cluster.actions.editProactiveHa',
         customLabel: getString('general.config.button.edit'),
      }];

      getViewData();

      getVcVersion();

      //
      // Controller functions
      //

      function getViewHeaderOptions() {
         return {
            title: getString('ha.config.HA'),
            actions: [{
               actionUid: 'vsphere.core.cluster.actions.editHa',
               customLabel: getString('general.config.button.edit')
            }]
         };
      }

      function getFailureConditionsOptions() {
         return {
            title: getString('ha.config.responseTable.header'),
            objectId: objectId,
            actions: []
         };
      }

      function getViewData() {
         dataService
            .getData(objectId,
               'com.vmware.vsphere.client.clusterui.model.services.ClusterHaData')
            .then(function (data) {
               self.data = data;
               self.haStatusHeaderOptions.title = getTitle(data.haEnabled);
               self.proactiveHaTitle =
                     getProactiveHaTitle(data.infraUpdateHaEnabled, data.drsEnabled);
               self.isProactiveHaAvailable = data.drsEnabled;
               self.datagridOptions.data = data.failureConditionData.items;

               // this object is passed to vui stack block in order to access its
               // expanded property later in order to decide whether the
               // heartbeat-datastores directive will be instantiated or not
               self.heartbeatDatastoreBlock = {
                  expanded: false
               };

               self.isHeartbeatDatastorePolicyAllFeasible = true;
               self.heartbeatDatastoresPolicyLabel = '';
               var hbDsPolicy = data.heartbeatDatastoreCandidatePolicy;
               if (!!hbDsPolicy) {
                  self.isHeartbeatDatastorePolicyAllFeasible =
                        heartbeatDatastoresService.isAutoSelectPolicy(hbDsPolicy);

                  var dsForHeartbeatingPolicyKey = 'ha.config.'.concat(hbDsPolicy);
                  self.heartbeatDatastoresPolicyLabel =
                        getString(dsForHeartbeatingPolicyKey);
               }
               self.admissionControlData =
                     haAdmissionControlService.getAdmissionControlModel(data);

               var hasAdvancedOptions =
                  !!self.data.advancedOptions &&
                  self.data.advancedOptions.length > 0;
               self.advancedOptionsText =
                  hasAdvancedOptions ?
                     getString('ha.config.advancedOptionsCollapsedText.show')
                     : getString('ha.config.advancedOptionsCollapsedText.none');
            });
      }

      function getVcVersion() {
         vcService.is65VcOrLater(objectId)
               .then(function(is65VcOrLater) {
                  self.is65VcOrLater = is65VcOrLater;
               });
      }

      function getTitle(haEnabled) {
         return haEnabled ?
            getString('ha.config.haEnabled')
            : getString('ha.config.haDisabled');
      }

      function getProactiveHaTitle(proHaEnabled, drsEnabled) {
         return drsEnabled ? (proHaEnabled ?
               getString('ha.config.prohaEnabled')
               : getString('ha.config.prohaDisabled')) : getString('ha.config.prohaNa');
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function getDatagridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.NONE,
            sortMode: vuiConstants.grid.sortMode.NONE,
            searchable: false,
            resizable: false,
            selectedItems: [],
            data: [],
            pageConfig: {
               hidePager: true
            },
            columnDefs: getColumnDefs(),
            dataBound: function() {
               $element.find('[vui-datagrid] .k-grid-content').css('height', '');
            },
            height: '100%'
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: getString('ha.config.vmResponse.failure.column'),
               field: 'failure'
            },
            {
               displayName: getString('ha.config.vmResponse.failureResponse.column'),
               field: 'failureResponse',
               template: function(dataItem) {
                  var cellData = {
                     text: dataItem.failureResponse
                  };
                  var icon = getIconClass(dataItem.failureResponseType);
                  return iconTextRenderer([undefined, 'text', icon], cellData);
               }
            },
            {
               displayName: getString('ha.config.vmResponse.details.column'),
               field: 'details',
               template: function(dataItem) {
                  return wrappedTextRenderer(['details'], dataItem);
               }
            }
         ];
      }

      function getIconClass(failureType) {
         if (failureType === 'responseDisabled') {
            return 'vsphere-icon-status-error';
         } else if (failureType === 'responseProtected') {
            return 'vsphere-icon-status-ok';
         } else if (failureType === 'responseWarnOnly') {
            return 'vsphere-icon-status-warning';
         }
         return '';
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('ClusterConsumersController', ClusterConsumersController);

   ClusterConsumersController.$inject = ['$scope', '$controller', 'i18nService'];

   function ClusterConsumersController($scope, $controller, i18nService) {
      var self = this;
      angular.extend(self, $controller('GenericPortletController', { $scope: $scope }));

      self.max = _.max;
      self.liveRefreshProperties = ["summary.currentBalance"];
      self.getString = getString;

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('ClusterResourcesController', ClusterResourcesController);

   ClusterResourcesController.$inject = ['$scope', '$controller', 'i18nService',
         'featureFlagsService'];

   function ClusterResourcesController($scope, $controller, i18nService,
         featureFlagsService) {
      var self = this;
      angular.extend(self, $controller('GenericPortletController', { $scope: $scope }));

      self.liveRefreshProperties = ["summary.currentEVCModeKey", "host"];
      self.getString = getString;
      self.isPmemEnabled = isPmemEnabled();

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }

      function isPmemEnabled() {
         return (typeof featureFlagsService.PMemEnabled === "function") ?
               featureFlagsService.PMemEnabled() : false;
      }
   }
})();
   /* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('DrsPortletController', DrsPortletController);

   DrsPortletController.$inject = ['$scope', 'drsPortletService', 'i18nService'];

   function DrsPortletController($scope, drsPortletService, i18nService) {
      var self = this;
      var clusterId = $scope._route.objectId;

      $scope.clusterId = [clusterId];
      self.liveRefreshProperties = [
         "configurationEx.drsConfig.enabled",
         "configurationEx.drsConfig.defaultVmBehavior",
         "configurationEx.drsConfig.vmotionRate",
         "configurationEx.dpmConfigInfo.enabled",
         "configurationEx.dpmConfigInfo.defaultDpmBehavior",
         "summary.currentBalance",
         "summary.targetBalance",
         "recommendation",
         "drsFault"
      ];

      self.getViewData = getViewData;

      function getViewData() {
         drsPortletService.getViewData(clusterId).then(function (drsViewData) {
            self.signPostParams.model = $scope.drsModel = drsViewData;
         });
      }

      var title = i18nService.getString(
            'ClusterUi', 'drs.portlet.tooltip.hostLoadDeviationLabel');

      self.signPostParams = {
         templateUrl: 'cluster-ui/resources/cluster/views/summary/drsDeviationInfoTooltipContent.html',
         title: title,
         model: null,
         width: 440
      };

      getViewData();
   }
})();

/** Copyright 2016 VMware, Inc.  All rights reserved. -- VMware Confidential*/
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('FtPortletController', FtPortletController);

   FtPortletController.$inject = ['$scope', 'ftPortletService', 'defaultUriSchemeUtil',
      'i18nService'];

   function FtPortletController($scope, ftPortletService, defaultUriSchemeUtil,
                                i18nService) {
      var self = this;
      var vmId = $scope._route.objectId;

      self.vmId = [vmId];
      self.liveRefreshProperties = [
         "runtime.faultToleranceState",
         "runtime.powerState",
         "runtime.dasVmProtection",
         "config.ftInfo",
         "config.files.ftMetadataDirectory",
         "config.flags.faultToleranceType"
      ];

      self.getData = function () {
         var promise = ftPortletService.requestData(vmId);
         promise.then(function (ftData) {
            self.ftData = ftData['ftportlet:ftdata'];
            var logBandwidth = parseInt(self.ftData.logBandwidth) || 0;

            if (logBandwidth > 0) {
               self.logBandwidth = i18nService.getString('VmUi',
                     'vmFTView.logBandwidthFormat', logBandwidth);
            } else {
               self.logBandwidth = i18nService.getString('VmUi',
                     'vmFTView.notAvailable');
            }

            if (self.ftData.secondaryHost) {
               self.hostRef = defaultUriSchemeUtil.getVsphereObjectId(self.ftData.secondaryHost);
            }
         });
      };
      self.getData();
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
      .controller('HaPortletController', HaPortletController);

   HaPortletController.$inject = ['$scope', 'dataService', 'i18nService', '$filter',
         'columnRenderersRegistry', 'defaultUriSchemeUtil'];

   function HaPortletController($scope, dataService, i18nService, $filter,
            columnRenderersRegistry, defaultUriSchemeUtil) {
      var self = this;
      var clusterId = $scope._route.objectId;
      var linkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');

      self.clusterId = [clusterId];
      self.liveRefreshProperties = [
            "configurationEx.dasConfig.enabled",
            "configurationEx.dasConfig.admissionControlPolicy",
            "configurationEx.dasConfig.admissionControlEnabled",
            "configurationEx.dasConfig.hostMonitoring",
            "configurationEx.dasConfig.vmMonitoring",
            "configurationEx.dasConfig.admissionControlPolicy.cpuFailoverResourcesPercent",
            "configurationEx.dasConfig.admissionControlPolicy.memoryFailoverResourcesPercent",
            "configurationEx.dasConfig.admissionControlPolicy.failoverHosts",
            "configurationEx.dasConfig.admissionControlPolicy.failoverLevel",
            "configurationEx.infraUpdateHaConfig.enabled",
            "configurationEx.infraUpdateHaConfig.behavior",
            "summary.admissionControlInfo.currentCpuFailoverResourcesPercent",
            "summary.admissionControlInfo.currentMemoryFailoverResourcesPercent",
            "summary.admissionControlInfo.currentFailoverLevel",
            "summary.numHosts"
         ];
      self.getViewData = getViewData;
      self.getHostMonitoringText = getHostMonitoringText;
      self.getHostPartialResponse = getHostPartialResponse;
      self.admissionControlPolicyTypes = {
         FAILOVER_LEVEL: 'com.vmware.vim.binding.vim.cluster.FailoverLevelAdmissionControlPolicy',
         FAILOVER_RESOURCES: 'com.vmware.vim.binding.vim.cluster.FailoverResourcesAdmissionControlPolicy',
         FAILOVER_HOST: 'com.vmware.vim.binding.vim.cluster.FailoverHostAdmissionControlPolicy'
      };

      getViewData();

      function getViewData() {
         dataService
            .getData(clusterId,
               'com.vmware.vsphere.client.clusterui.model.ClusterHaSummaryData',
             {
                 queryName: 'HaPortletController.' + getViewData.name
             }
            )
            .then(function (haData) {
               self.haData = haData;
               buildSignPostData();
               if (haData.admissionControlPolicy._type === self.admissionControlPolicyTypes.FAILOVER_LEVEL) {
                  var chartMaxValue;
                  if (haData.numHosts !== 0) {
                     chartMaxValue = haData.numHosts;
                  } else if (haData.numFailoverHosts !== 0) {
                     chartMaxValue = haData.numFailoverHosts;
                  } else {
                     chartMaxValue = 1;
                  }

                  self.chartMaxValue = chartMaxValue;

                  self.chartData = [{
                     label: i18nService.getString('ClusterUi', 'ha.portlet.hosts.chart.label'),
                     usage: (haData.numHosts - haData.currentNumFailoverHosts),
                     reservation: haData.numFailoverHosts
                  }];

                  self.chartMarkers = [{
                     value: 0,
                     label: '0',
                     labelAlign: 'right'
                  }, {
                     value: chartMaxValue,
                     label: haData.numHosts.toString(),
                     labelAlign: 'left'
                  }];
               } else if (haData.admissionControlPolicy._type === self.admissionControlPolicyTypes.FAILOVER_RESOURCES) {
                  self.chartMaxValue = 100;

                  self.chartData = [{
                     label: i18nService.getString('ClusterUi', 'ha.portlet.cpu.chart.label'),
                     usage: (100 - haData.currentCpuFailoverPercent),
                     reservation: haData.cpuFailoverPercent
                  }, {
                     label: i18nService.getString('ClusterUi', 'ha.portlet.memory.chart.label'),
                     usage: (100 - haData.currentMemoryFailoverPercent),
                     reservation: haData.memoryFailoverPercent
                  }];

                  self.chartMarkers = [{
                     value: 0,
                     label: '0%',
                     labelAlign: 'right'
                  }, {
                     value: 50,
                     label: '50%',
                     labelAlign: 'center'
                  }, {
                     value: 100,
                     label: '100%',
                     labelAlign: 'left'
                  }];
               } else if (haData.admissionControlPolicy._type === self.admissionControlPolicyTypes.FAILOVER_HOST) {
                  self.datagridOptions = {
                     columnDefs: [
                        {
                           field: 'name',
                           displayName: i18nService.getString('ClusterUi', 'ha.portlet.grid.host.header'),
                           template: function(hostResourceData) {
                              return linkRenderer(
                                 ['entityUid', 'name', hostResourceData.iconId],
                                 hostResourceData);
                           }
                        },
                        {
                           field: 'cpuCapacityText',
                           displayName: i18nService.getString('ClusterUi', 'ha.portlet.grid.host.cpu'),
                           sortable: function(host1, host2) {
                              return host1.cpuCapacity - host2.cpuCapacity;
                           }
                        },
                        {
                           field: 'memorySizeText',
                           displayName: i18nService.getString('ClusterUi', 'ha.portlet.grid.host.memory'),
                           sortable: function(host1, host2) {
                              return host1.memorySize - host2.memorySize;
                           }
                        }
                     ],
                     searchable: false,
                     selectedItems: []
                  };
                  // TODO add proper localization
                  haData.hostData = haData.hostData || [];
                  haData.hostData.forEach(function(hostResourceData) {
                     hostResourceData.entityUid = defaultUriSchemeUtil.getVsphereObjectId(hostResourceData.provider);
                     hostResourceData.memorySizeText = $filter('bytes')(hostResourceData.memorySize, 'B', 'GB');
                  });
                  self.datagridOptions.data = haData.hostData;
               }
            });
      }

      function buildSignPostData() {
         var templateUrl = '';
         var title = '';
         var width = 0;

         if (self.haData.admissionControlPolicy._type ===
               self.admissionControlPolicyTypes.FAILOVER_LEVEL) {
            templateUrl = 'cluster-ui/resources/cluster/views/summary/failoverLevelInfoTooltipContent.html';
            title = i18nService.getString('ClusterUi', 'ha.portlet.failover.level.policy');
            width = 400;
         } else if (self.haData.admissionControlPolicy._type ===
               self.admissionControlPolicyTypes.FAILOVER_RESOURCES) {
            templateUrl = 'cluster-ui/resources/cluster/views/summary/failoverResourceInfoTooltipContent.html';
            title = i18nService.getString(
                  'ClusterUi', 'ha.portlet.failover.resources.policy');
            width = 440;
         }

         self.signPostParams = {
            templateUrl: templateUrl,
            title: title,
            model: self.haData,
            width: width
         };
      }

      function getHostMonitoringText(hostMonitoring) {
         if (hostMonitoring === 'enabled') {
            return i18nService.getString('ClusterUi', 'ha.portlet.hostmonitoring.enabled');
         }
         return i18nService.getString('ClusterUi', 'ha.portlet.hostmonitoring.disabled');
      }

      function getHostPartialResponse(enabled, behavior) {
         if (enabled) {
            return i18nService.getString('ClusterUi', 'ha.portlet.host.partial.failure.response.' + behavior);
         }
         return i18nService.getString('ClusterUi', 'ha.portlet.host.partial.failure.response.disabled');
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('RpSettingsPortletController', RpSettingsPortletController);

   RpSettingsPortletController.$inject = ['$scope', 'dataService', 'i18nService',
      'vxPropertyViewService', 'sharesLevelsConstants'];

   function RpSettingsPortletController($scope, dataService, i18nService,
          vxPropertyViewService, sharesLevelsConstants) {

      var self = this;
      var rpId = $scope._route.objectId;

      self.rpId = [rpId];
      self.getViewData = getViewData;
      self.liveRefreshProperties = ["config",
            "summary.quickStats.staticCpuEntitlement",
            "summary.quickStats.staticCpuEntitlement"
      ];

      getViewData();

      function getViewData() {
         dataService.getData(rpId,
               'com.vmware.vsphere.client.clusterui.model.ResourcePoolSummaryData',
               {queryName: 'RpSettingsPortletController.' + getViewData.name})
               .then(function(rpData) {
                  self.resourcePoolData = rpData;

                  buildPropertyGridData(rpData);
               });
      }

      function buildPropertyGridData (resourcePoolData) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();

         createCpuSectionBuilder(builder, resourcePoolData);
         createMemorySectionBuilder(builder, resourcePoolData);

         self.resourcePoolData = builder.build();

      }

      function createCpuSectionBuilder(builder, rpData) {
         if(rpData) {
            var sectionBuilder = builder
                  .category('')
                  .section('cpu')
                  .title(getString('settings.cpu'));

            sectionBuilder.property(getString('settings.shares'),
                  getShares(rpData.configSpec.cpuAllocation.shares));
            sectionBuilder.property(getString('settings.reservation'),
                  rpData.cpuReservationFormatted);
            sectionBuilder.property(getString('settings.limit'),
                  rpData.cpuLimitFormatted);
            sectionBuilder.property(getString('settings.worstcase'),
                  rpData.cpuWorstCaseAllocationFormatted);
         }
      }

      function createMemorySectionBuilder(builder, resourcePoolData) {
         if(resourcePoolData) {
            var memorySettingsBuilder = builder
                  .category('')
                  .section('memory')
                  .title(getString('settings.memory'));

            memorySettingsBuilder.property(getString('settings.shares'),
                  getShares(resourcePoolData.configSpec.memoryAllocation.shares));
            memorySettingsBuilder.property(getString('settings.reservation'),
                  resourcePoolData.memoryReservationFormatted);
            memorySettingsBuilder.property(getString('settings.limit'),
                  resourcePoolData.memoryLimitFormatted);
            memorySettingsBuilder.property(getString('settings.worstcase'),
                  resourcePoolData.memoryWorstCaseAllocationFormatted);
         }
      }

      function getShares(shares) {
         return i18nService.getString('RpUi', 'resourceAllocationInfoControl.shares',
               formatSharesLevel(shares.level), shares.shares);
      }

      function formatSharesLevel(level) {
         switch(level){
            case sharesLevelsConstants.sharesLevel.LOW:
               return getString('rpList.lowSharesLabel');
            case sharesLevelsConstants.sharesLevel.HIGH:
               return getString('rpList.highSharesLabel');
            case sharesLevelsConstants.sharesLevel.NORMAL:
               return getString('rpList.normalSharesLabel');
            case sharesLevelsConstants.sharesLevel.CUSTOM:
               return getString('rpList.customSharesLabel');
         }
      }

      function getString(key) {
         return i18nService.getString('RpUi', key);
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.cluster')
         .controller('VmHaPortletController', VmHaPortletController);

   VmHaPortletController.$inject = ['$scope', 'dataService', 'i18nService',
         'vuiConstants', 'columnRenderersRegistry', '$element'];

   function VmHaPortletController($scope, dataService, i18nService, vuiConstants,
         columnRenderersRegistry, $element) {
      var self = this;
      var vmId = $scope._route.objectId;
      var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('object-link');

      self.vmId = [vmId];
      self.getViewData = getViewData;
      self.liveRefreshProperties = ["runtime.dasVmProtection",
         "cluster",
         "dasVmSettings"];
      self.haProtectionLabel = getString('failureResponseView.haProtection.label');
      self.gridOptions = getGridOptions();

      getViewData();

      function getViewData() {
         dataService.getData(vmId,
               'com.vmware.vsphere.client.clusterui.model.services.VmFailureResponsesData',
               {queryName: 'VmHaPortletController.' + getViewData.name})
               .then(function(haData) {
                  self.haProtection = getHaProtectionInfo(haData.dasVmProtection);
                  self.gridOptions.data = haData.mergedItems;
                  self.signPostParams = buildSignPostData(haData);
               });
      }

      function getHaProtectionInfo(dasVmProtection) {
         var result = {};

         if (dasVmProtection === null) {
            result.icon = 'vsphere-icon-status-unknown';
            result.label = getString('failureResponseView.naStatus');
            result.description = getString('failureResponseView.tooltip.naStatus.descr');
         } else if (dasVmProtection.dasProtected) {
            result.icon = 'vsphere-icon-status-ok';
            result.label = getString('failureResponseView.protectedStatus');
            result.description = getString('failureResponseView.tooltip.protectedStatus.descr');
         } else {
            result.icon = 'vsphere-icon-status-error';
            result.label = getString('failureResponseView.unprotectedStatus');
            result.description = getString('failureResponseView.tooltip.unprotectedStatus.descr');
         }

         result.description = '<span class="cluster-tooltip-content-wrapper">' +
               result.description + '</span>';

         return result;
      }

      function getGridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.NONE,
            sortMode: vuiConstants.grid.sortMode.NONE,
            searchable: false,
            resizable: false,
            selectedItems: [],
            data: [],
            pageConfig: {
               hidePager: true
            },
            columnDefs: getColumnDefs(),
            dataBound: function() {
               $element.find('[vui-datagrid] .k-grid-content').css('height', '');
            },
            height: '100%'
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: getString('ha.config.vmResponse.failure.column'),
               field: 'failure'
            },
            {
               displayName: getString('ha.config.vmResponse.failureResponse.column'),
               field: 'failureResponse',
               template: function(dataItem) {
                  var cellData = {
                     text: dataItem.failureResponse,
                     title: dataItem.details
                  };
                  var icon = getIconClass(dataItem.failureResponseType);
                  return iconTextRenderer(
                        [undefined, 'text', icon, undefined, undefined, 'title'], cellData);
               }
            }
         ];
      }

      function getIconClass(failureType) {
         if (failureType === 'responseDisabled') {
            return 'vsphere-icon-status-error';
         } else if (failureType === 'responseProtected') {
            return 'vsphere-icon-status-ok';
         } else if (failureType === 'responseWarnOnly') {
            return 'vsphere-icon-status-warning';
         }
         return '';
      }

      function buildSignPostData(haData) {
         var haProtection = getHaProtectionInfo(haData.dasVmProtection);

         return {
            title: haProtection.label,
            message: haProtection.description
         };
      }

      function getString(key) {
         return i18nService.getString('ClusterUi', key);
      }
   }
})();



h5 = h5 || {};
h5.dsCluster = {
    angularModule: angular.module("com.vmware.vsphere.client.dsCluster", [])
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    /**
     * Registers ds-cluster-ui actions.
     */
    angular.module("com.vmware.vsphere.client.dsCluster")
        .run(["columnRenderersRegistry", "i18nService",
        function (columnRenderersRegistry, i18nService) {
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * Datastore name column - object-name renderer.
                 *
                 * @param  {array} props Array of property names.
                 * @param  {object} data Map of values, contains the specificType.
                 * @param {object} config A dictionary (key/value) to control the renderer behavior.
                 */
                "datastore-name": function (props, data, config) {
                    var objLinkRenderer = columnRenderersRegistry.getColumnRenderer("object-name");
                    data.datastoreName = "";
                    if (data.datastoreNames) {
                        data.datastoreTitle = data.datastoreNames.join(", ");
                        if (data.datastoreNames.length === 1) {
                            data.datastoreIcon = "vsphere-icon-datastore";
                            data.datastoreName = data.datastoreNames[0];
                        }
                        else if (data.datastoreNames.length > 1) {
                            data.datastoreName = i18nService.getString("DsClusterUi", "sdrs.rules.config.multipleDatastores");
                        }
                    }
                    return objLinkRenderer([null, "datastoreIcon", "datastoreName", null,
                        "datastoreTitle"], data, config);
                }
            });
        }])
        .run([
        "createDsClusterWizardService", "sdrsDialogService", "sdrsRulesService",
        "clarityModalService", "i18nService", "mutationService",
        "dsClusterConstants", "storageVmOverridesService", "addSdrsVmOverridesService",
        "datastoreMaintenanceModeService", "scheduleSdrsWizardService",
        function (createDsClusterDialogService, sdrsDialogService, sdrsRulesService, clarityModalService, i18nService, mutationService, dsClusterConstants, storageVmOverridesService, addSdrsVmOverridesService, datastoreMaintenanceModeService, scheduleSdrsWizardService) {
            function showCreateDsClusterDialog(actionEval, availableTargets) {
                createDsClusterDialogService.show(availableTargets[0]);
            }
            function showEditSdrsDialog(actionEval, availableTargets) {
                sdrsDialogService.show(availableTargets[0]);
            }
            function showAddStorageVmOverrideView(actionEval, availableTargets, context) {
                addSdrsVmOverridesService.openAddVmOverridesWizard(availableTargets[0]);
            }
            function showRuleDialog(actionEval, availableTargets, mode, context) {
                var modalTitle;
                if (mode === dsClusterConstants.operationType.ADD) {
                    modalTitle = i18nService.getString("DsClusterUi", "sdrs.rules.rules.config.title.add");
                }
                else {
                    modalTitle = i18nService.getString("DsClusterUi", "sdrs.rules.rules.config.title.edit");
                }
                clarityModalService.openOkCancelModal({
                    title: modalTitle,
                    subTitle: {
                        objectId: availableTargets[0]
                    },
                    defaultButton: "submit",
                    modalClass: "ds-cluster-add-sdrs-rule-modal",
                    dialogData: {
                        operationType: mode,
                        context: context
                    },
                    contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/addSdrsRule.html"
                });
            }
            function showAddVmRuleMemberDialog(actionEval, availableTargets, context) {
                var dialogOptions = {
                    title: i18nService.getString("DsClusterUi", "rules.config.members.dialog.title"),
                    subTitle: context.dialogSubTitleObject,
                    size: "lg",
                    defaultButton: "submit",
                    modalClass: "ds-cluster-add-sdrs-rule-member-dialog",
                    contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/addSdrsVmRuleMember.html",
                    dialogData: {
                        selectedVms: context.selectedMembers,
                        objectId: availableTargets[0]
                    },
                    onSubmit: function () {
                        return context.submitCallback(dialogOptions);
                    }
                };
                clarityModalService.openOkCancelModal(dialogOptions);
            }
            function showAddVmdkRuleMemberDialog(actionEval, availableTargets, context) {
                var dialogOptions = {
                    title: i18nService.getString("DsClusterUi", "vms.per.dscluster.single.selection.title"),
                    subTitle: context.dialogSubTitleObject,
                    size: "lg",
                    defaultButton: "submit",
                    modalClass: "ds-cluster-add-sdrs-rule-member-dialog",
                    contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/addSdrsVmdkRuleMember.html",
                    dialogData: {
                        selectedVms: context.selectedMembers,
                        objectId: availableTargets[0]
                    },
                    onSubmit: function () {
                        return context.submitCallback(dialogOptions);
                    }
                };
                clarityModalService.openOkCancelModal(dialogOptions);
            }
            function showRemoveRuleMemberConfirmationDialog(actionEval, availableTargets, context) {
                var confirmCallback = context.confirmCallback;
                var confirmProperties = {
                    title: i18nService.getString("Common", "sdrs.rules.config.remove.vmmember.question.title"),
                    message: i18nService.getString("Common", "sdrs.rules.config.remove.vmmember.question.text"),
                    submit: function () {
                        return confirmCallback();
                    }
                };
                clarityModalService.openConfirmationModal(confirmProperties);
            }
            function removeRule(actionEval, availableTargets, context) {
                sdrsRulesService.deleteRule(availableTargets[0], context.selectedRule);
            }
            function showRemoveSdrsVmOverrideConfirmationDialog(availableTargets, context) {
                var dialogOptions = {
                    title: i18nService.getString("DsClusterUi", "vmOverrides.actionDelete.caption"),
                    defaultButton: "submit",
                    contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/" +
                        "configuration/sdrsVmOverrides/removeSdrsVmOverridesView.html",
                    dialogData: {
                        context: context,
                        objectId: availableTargets[0]
                    },
                };
                clarityModalService.openOkCancelModal(dialogOptions);
            }
            function showEditOverridesDialog(availableTargets, context) {
                var editOperationType = dsClusterConstants.vmOverridesOperationType.EDIT;
                var title = storageVmOverridesService.getEditVmOverridesDialogTitle(context);
                var dialogOptions = {
                    title: title,
                    defaultButton: "submit",
                    size: "lg",
                    contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/" +
                        "configuration/sdrsVmOverrides/editSdrsVmOverridesView.html",
                    dialogData: {
                        context: context,
                        objectId: availableTargets,
                        mode: editOperationType
                    },
                    modalClass: "ds-cluster-add-sdrs-override-dialog"
                };
                clarityModalService.openOkCancelModal(dialogOptions);
            }
            function datastoreEnterMaintenanceMode(actionEval, availableTargets, context) {
                datastoreMaintenanceModeService.initiateEnterMaintenanceMode(availableTargets[0]);
            }
            function datastoreExitMaintenanceMode(actionEval, availableTargets, context) {
                datastoreMaintenanceModeService.exitMaintenanceMode(availableTargets[0]);
            }
            function showScheduleSdrsWizard(actionEval, availableTargets, context) {
                scheduleSdrsWizardService.show(availableTargets[0], context && context.focusTarget);
            }
            function deleteDsCluster(actionEval, availableTargets) {
                if (availableTargets.length === 1) {
                    mutationService.remove(availableTargets[0]);
                }
                else if (availableTargets.length > 1) {
                    mutationService.removeOnMultiEntity(availableTargets);
                }
            }
            h5.actions["vsphere.core.dsCluster.actions.add"] =
                showCreateDsClusterDialog;
            h5.actions["vsphere.core.dsCluster.actions.editSdrs"] =
                showEditSdrsDialog;
            h5.actions["vsphere.core.dscluster.actions.rule.add"] =
                function (actionEval, availableTargets, context) {
                    return showRuleDialog(actionEval, availableTargets, dsClusterConstants.operationType.ADD, context);
                };
            h5.actions["vsphere.core.dscluster.actions.rule.members.add"] =
                showAddVmRuleMemberDialog;
            h5.actions['vsphere.core.dscluster.actions.rule.edit'] =
                function (actionEval, availableTargets, context) {
                    return showRuleDialog(actionEval, availableTargets, dsClusterConstants.operationType.EDIT, context);
                };
            h5.actions["vsphere.core.dscluster.actions.rule.members.remove"] =
                showRemoveRuleMemberConfirmationDialog;
            h5.actions["vsphere.core.dscluster.actions.rule.remove"] = removeRule;
            h5.actions["vsphere.core.dscluster.actions.rule.vmdk.members.add"] =
                showAddVmdkRuleMemberDialog;
            h5.actions['vsphere.core.dscluster.actions.vmoverrides.remove'] =
                function (actionEval, availableTargets, context) {
                    showRemoveSdrsVmOverrideConfirmationDialog(availableTargets, context);
                };
            h5.actions["vsphere.core.dscluster.actions.vmOverrides.add"] =
                showAddStorageVmOverrideView;
            h5.actions["vsphere.core.dscluster.actions.vmOverrides.edit"] =
                function (actionEval, availableTargets, context) {
                    showEditOverridesDialog(availableTargets, context);
                };
            h5.actions["vsphere.core.datastore.actions.enterMaintenanceMode"] =
                datastoreEnterMaintenanceMode;
            h5.actions["vsphere.core.datastore.actions.exitMaintenanceMode"] =
                datastoreExitMaintenanceMode;
            h5.actions["vsphere.core.dsCluster.actions.scheduleSdrs"] =
                showScheduleSdrsWizard;
            h5.actions["vsphere.core.dscluster.actions.delete"] =
                deleteDsCluster;
        }]);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsAutomationComponent = (function () {
        function DsAutomationComponent() {
            this.bindings = {
                model: "=",
                isAutofocusDisabled: "="
            };
            this.controller = DsAutomationComponentController;
            this.templateUrl = "ds-cluster-ui/resources/ds-cluster/components/dsAutomation.html";
        }
        return DsAutomationComponent;
    }());
    ds_cluster_ui.DsAutomationComponent = DsAutomationComponent;
    var DsAutomationComponentController = (function () {
        function DsAutomationComponentController(vuiConstants, i18nService, columnRenderersRegistry, storageDrsAutomationService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.storageDrsAutomationService = storageDrsAutomationService;
            this.i18n = this.i18nService.getString;
            this.buildSignPostParams();
            this.automationLevels = storageDrsAutomationService.getSdrsAutomationLevels(i18nService.getString("DsClusterUi", "sdrs.config.automationLevelLabel"));
            this.automationOverridesOptions =
                storageDrsAutomationService.getSdrsAutomationOverridesOptions();
        }
        DsAutomationComponentController.prototype.buildSignPostParams = function () {
            this.signPostParams = {
                spaceLoadBalanceAutomationMode: {
                    message: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLevel.spaceBalanceDescriptionLabel"),
                    title: this.i18nService.getString("Common", "help")
                },
                ioLoadBalanceAutomationMode: {
                    message: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLevel.ioBalanceDescriptionLabel"),
                    title: this.i18nService.getString("Common", "help")
                },
                ruleEnforcementAutomationMode: {
                    message: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLevel.ruleEnforcementDescriptionLabel"),
                    title: this.i18nService.getString("Common", "help")
                },
                policyEnforcementAutomationMode: {
                    message: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLevel.policyEnforcementDesciprionLabel"),
                    title: this.i18nService.getString("Common", "help")
                },
                vmEvacuationAutomationMode: {
                    message: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLevel.vmEvacuationDescriptionLabel"),
                    title: this.i18nService.getString("Common", "help")
                }
            };
        };
        DsAutomationComponentController.$inject = ["vuiConstants", "i18nService",
            "columnRenderersRegistry", "storageDrsAutomationService"];
        return DsAutomationComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("dsAutomation", new DsAutomationComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var RuntimeSettingsComponent = (function () {
        function RuntimeSettingsComponent() {
            this.bindings = {
                model: "="
            };
            this.controller = RuntimeSettingsComponentController;
            this.templateUrl = "ds-cluster-ui/resources/ds-cluster/components/runtimeSettings.html";
        }
        return RuntimeSettingsComponent;
    }());
    ds_cluster_ui.RuntimeSettingsComponent = RuntimeSettingsComponent;
    var RuntimeSettingsComponentController = (function () {
        function RuntimeSettingsComponentController(vuiConstants, i18nService, dsClusterConstants) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            this.i18n = this.i18nService.getString;
            this.ioMetricsInclusionLegend = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.ioMetricsInclusion.legend');
            this.ioMetricsInclusionCheck = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.ioMetricsInclusion.check');
            this.ioLatencyThresholdLegend = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.ioLatencyThreshold.legend');
            this.ioLatencyThresholdDesc = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.ioLatencyThreshold.desc');
            this.spaceThresholdLegend = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.spaceThreshold.legend');
            this.spaceThresholdDesc = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.sdrsThreshold.desc');
            this.utilizedSpaceLabel = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.spaceThreshold.utilizedSpace.label');
            this.utilizedSpaceUnit = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.spaceThreshold.utilizedSpace.unit');
            this.utilizedSpaceDesc = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.spaceThreshold.utilizedSpace.desc');
            this.minFreeSpaceLabel = this.i18n('DsClusterUi', 'createDsClusterWizard.runtimeSettingsPage.spaceThreshold.minFreeSpace.label');
            this.minFreeSpaceMetricLabel = this.i18n("DsClusterUi", "sdrs.config.minFreeSpaceThreshold.metricLabel");
            this.minFreeSpaceDesc = this.i18n("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.spaceThreshold.minFreeSpace.desc");
            this.buildSignPostParams();
            this.initMinMaxThresholdValues();
        }
        RuntimeSettingsComponentController.prototype.initMinMaxThresholdValues = function () {
            this.minUtilizationThreshold = this.dsClusterConstants.spaceUtilizationThreshold.MIN;
            this.maxUtilizationThreshold = this.dsClusterConstants.spaceUtilizationThreshold.MAX;
            this.minLatencyThreshold = this.dsClusterConstants.ioLatencyThreshold.MIN;
            this.maxLatencyThreshold = this.dsClusterConstants.ioLatencyThreshold.MAX;
        };
        RuntimeSettingsComponentController.prototype.normalizeFreeSpaceThreshold = function () {
            if (this.model !== undefined && this.model.spaceLoadBalanceConfig !== undefined) {
                this.model.spaceLoadBalanceConfig.freeSpaceThresholdGB = this.normalize(this.model.spaceLoadBalanceConfig.freeSpaceThresholdGB, this.dsClusterConstants.freeSpaceThresholdGB.MIN, this.dsClusterConstants.MAX_INTEGER);
            }
        };
        RuntimeSettingsComponentController.prototype.normalizeIOLatencyThreshold = function () {
            if (this.model !== undefined && this.model.ioLatencyThreshold !== undefined
                && this.minLatencyThreshold !== undefined && this.maxLatencyThreshold !== undefined) {
                this.model.ioLatencyThreshold = this.normalize(this.model.ioLatencyThreshold, this.minLatencyThreshold, this.maxLatencyThreshold);
            }
        };
        RuntimeSettingsComponentController.prototype.normalizeUtilizationThreshold = function () {
            if (this.model !== undefined && this.model.spaceLoadBalanceConfig !== undefined
                && this.model.spaceLoadBalanceConfig.spaceUtilizationThreshold !== undefined
                && this.minUtilizationThreshold !== undefined
                && this.maxUtilizationThreshold !== undefined) {
                this.model.spaceLoadBalanceConfig.spaceUtilizationThreshold = this.normalize(this.model.spaceLoadBalanceConfig.spaceUtilizationThreshold, this.minUtilizationThreshold, this.maxUtilizationThreshold);
            }
        };
        RuntimeSettingsComponentController.prototype.normalize = function (val, min, max) {
            return Math.max(Math.min(val, max), min);
        };
        RuntimeSettingsComponentController.prototype.buildSignPostParams = function () {
            this.signPostParams = {
                message: this.i18nService.getString("DsClusterUi", "sdrs.config.ioMetrics.info"),
                title: this.i18nService.getString("Common", "help")
            };
        };
        RuntimeSettingsComponentController.$inject = ["vuiConstants", "i18nService", "dsClusterConstants"];
        return RuntimeSettingsComponentController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("runtimeSettings", new RuntimeSettingsComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SdrsRecommendationsListComponent = (function () {
        function SdrsRecommendationsListComponent() {
            this.bindings = {
                computedSdrsRecommendations: "<",
                alwaysOverrideRecommendations: "<",
                noLinks: "<",
                skipApplyButton: "<",
                recommendationStore: "=",
                gridTitle: "<"
            };
            this.controller = SdrsRecommendationsListController;
            this.templateUrl = "ds-cluster-ui/resources/ds-cluster/components/sdrsRecommendationsList/sdrsRecommendationsList.html";
        }
        return SdrsRecommendationsListComponent;
    }());
    ds_cluster_ui.SdrsRecommendationsListComponent = SdrsRecommendationsListComponent;
    var SdrsRecommendationsListController = (function () {
        function SdrsRecommendationsListController(i18nService, vuiConstants, drsRecommendationsService, $rootScope, columnRenderersRegistry, clarityModalService, defaultUriSchemeUtil, mutationService, numberFormatterService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.drsRecommendationsService = drsRecommendationsService;
            this.$rootScope = $rootScope;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.clarityModalService = clarityModalService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.numberFormatterService = numberFormatterService;
            this.overrideRecommendations = false;
            this.gridOptions = this.getRecommenadtionsGridOptions();
        }
        SdrsRecommendationsListController.prototype.$onInit = function () {
            var _this = this;
            this.isRecommendationChecked =
                function (key) { return _this.recommendationStore.isRecommendationChecked(key); };
            this.applyRecommendationsActionLabel =
                this.getString("applyRecomendationsActionLabel");
            this.overrideSdrsRecommendationsLabel =
                this.getString("sdrs.recommendations.overrideSdrsRecommendationsLabel");
        };
        SdrsRecommendationsListController.prototype.$onChanges = function (changesObj) {
            if (changesObj && changesObj.computedSdrsRecommendations.currentValue) {
                this.objectId = changesObj.computedSdrsRecommendations.currentValue.id;
                var currentRecommendations = changesObj.computedSdrsRecommendations.currentValue.computedSdrsRecommendations;
                if (this.gridOptions && currentRecommendations) {
                    this.gridOptions.data = this.formatGridColumnValues(currentRecommendations);
                }
                var recommendations = _.map(currentRecommendations, function (recommendation) {
                    return recommendation.recommendationData;
                });
                var newRecommendationStore = this.drsRecommendationsService
                    .createRecommendationsStore(recommendations);
                var newRecommendationsKeys = newRecommendationStore
                    .getRecommendationKeys();
                if (this.recommendationStore) {
                    var oldRecommendationKeys = this.recommendationStore
                        .getRecommendationKeys();
                    var haveRecommendationsChanged = !this.arrayEq(newRecommendationsKeys.sort(), oldRecommendationKeys.sort());
                    if (haveRecommendationsChanged) {
                        this.recommendationStore = newRecommendationStore;
                    }
                }
                else {
                    this.recommendationStore = newRecommendationStore;
                }
                if (this.alwaysOverrideRecommendations) {
                    this.overrideRecommendations = currentRecommendations &&
                        currentRecommendations.length > 0;
                    this.checkRecommendations();
                }
            }
        };
        //Remove when vui datagrid is updated to support sub columns
        SdrsRecommendationsListController.prototype.formatGridColumnValues = function (sdrsRecommendationsData) {
            var _this = this;
            var beforeLabel = this.getString("sdrs.recommendations.columns.before.label") + " ";
            var afterLabel = this.getString("sdrs.recommendations.columns.after.label") + " ";
            var sourceLabel = this.getString("sdrs.recommendations.columns.source.label") + " ";
            var destinationLabel = this.getString("sdrs.recommendations.columns.destination.label") + " ";
            _.each(sdrsRecommendationsData, function (recommendation) {
                recommendation.utilizationSource =
                    beforeLabel + _this.roundToOneDecimal(recommendation.spaceUtilSrcBefore) + "\n" +
                        afterLabel + _this.roundToOneDecimal(recommendation.spaceUtilSrcAfter);
                recommendation.utilizationDestination =
                    beforeLabel + _this.roundToOneDecimal(recommendation.spaceUtilDstBefore) + "\n" +
                        afterLabel + _this.roundToOneDecimal(recommendation.spaceUtilDstAfter);
                recommendation.ioLatencyBefore =
                    sourceLabel + _this.roundToOneDecimal(recommendation.ioLatencySrcBefore) + "\n" +
                        destinationLabel + _this.roundToOneDecimal(recommendation.ioLatencyDstBefore);
            });
            return sdrsRecommendationsData;
        };
        SdrsRecommendationsListController.prototype.arrayEq = function (array1, array2) {
            if (array1.length !== array2.length) {
                return false;
            }
            return array1.every(function (array1El, i) {
                return array1El === array2[i];
            });
        };
        SdrsRecommendationsListController.prototype.roundToOneDecimal = function (num) {
            return this.numberFormatterService.format(+(Math.round(parseFloat(num + "e+1")) + "e-1"));
        };
        SdrsRecommendationsListController.prototype.getRecommenadtionsGridOptions = function () {
            return {
                searchable: false,
                resizable: true,
                selectable: false,
                scrollable: true,
                data: [],
                columnDefs: this.getColumnDefs(),
                pageConfig: {
                    hidePager: true
                },
                height: "100%"
            };
        };
        SdrsRecommendationsListController.prototype.getColumnDefs = function () {
            return [{
                    displayName: this.getString("sdrs.recommendations.columns.apply"),
                    field: "recommendationText",
                    type: "string",
                    width: "10%",
                    template: this.checkboxColumnTemplate
                }, {
                    displayName: this.getString("sdrs.recommendations.columns.recommendation"),
                    field: "recommendationText",
                    type: "string",
                    width: "21%",
                    template: this.recommendationTextRenderer.bind(this)
                }, {
                    displayName: this.getString("sdrs.recommendations.columns.reason"),
                    field: "recommendationData.parentRecommendation.reasonText",
                    type: "string",
                    width: "21%"
                }, {
                    displayName: this.getString("sdrs.recommendations.columns.utilization.source"),
                    field: "utilizationSource",
                    type: "string",
                    template: function (data) {
                        return "<span class='column-value-pre-wrap'>" + data.utilizationSource + "</span>";
                    }
                }, {
                    displayName: this.getString("sdrs.recommendations.columns.utilization.destination"),
                    field: "utilizationDestination",
                    type: "string",
                    template: function (data) {
                        return "<span class='column-value-pre-wrap'>" + data.utilizationDestination + "</span>";
                    }
                }, {
                    displayName: this.getString("sdrs.recommendations.columns.latency"),
                    field: "ioLatencyBefore",
                    type: "string",
                    template: function (data) {
                        return "<span class='column-value-pre-wrap'>" + data.ioLatencyBefore + "</span>";
                    }
                }];
        };
        SdrsRecommendationsListController.prototype.applyRecommendations = function () {
            if (!this.recommendationStore) {
                return;
            }
            var keysToApply = this.recommendationStore.getRecommendationsToApply();
            var dsclusterRecommendationSpec = {
                operation: "apply",
                keys: keysToApply
            };
            this.mutationService.apply(this.objectId, "com.vmware.vsphere.client.dscluster.services.sdrs." +
                "DatastoreClusterRecommendationSpec", dsclusterRecommendationSpec);
        };
        SdrsRecommendationsListController.prototype.checkboxColumnTemplate = function (data) {
            if (!data.recommendationData.isFirst) {
                return "";
            }
            var key = data.recommendationData.parentRecommendation.key;
            var checkbox = "<div class=\"centered-content-container\">\n               <input type=\"checkbox\"\n                  ng-disabled=\"!$parent.$parent.$ctrl.overrideRecommendations\"\n                  ng-checked=\"$parent.$parent.$ctrl.isRecommendationChecked('" + key + "')\n                  || !$parent.$parent.$ctrl.overrideRecommendations\"\n                  ng-click=\"$parent.$parent.$ctrl.onRecommendationCheckboxClick('" + key + "')\"/>\n            </div>";
            return checkbox;
        };
        SdrsRecommendationsListController.prototype.checkRecommendations = function () {
            var _this = this;
            var recommendationKeys = this.recommendationStore.getRecommendationKeys();
            _.each(recommendationKeys, function (recommendationKey) {
                if (!_this.recommendationStore.isRecommendationChecked(recommendationKey)) {
                    _this.recommendationStore.checkRecommendation(recommendationKey);
                }
            });
        };
        SdrsRecommendationsListController.prototype.onOverrideRecommendationsClick = function () {
            this.checkRecommendations();
        };
        SdrsRecommendationsListController.prototype.onRecommendationCheckboxClick = function (recommendationKey) {
            var isChecked = this.recommendationStore.isRecommendationChecked(recommendationKey);
            if (isChecked) {
                if (this.recommendationStore.uncheckRecommendation(recommendationKey)) {
                    var popUpScope = this.$rootScope.$new();
                    popUpScope.modalOptions = this.getUncheckedDependantRecommendationsModalOptions();
                    this.clarityModalService.openPopUp(popUpScope);
                }
            }
            else {
                if (this.recommendationStore.checkRecommendation(recommendationKey)) {
                    var popUpScope = this.$rootScope.$new();
                    popUpScope.modalOptions = this.getCheckedPrerequisiteRecommendationsModalOptions();
                    this.clarityModalService.openPopUp(popUpScope);
                }
            }
        };
        SdrsRecommendationsListController.prototype.recommendationTextRenderer = function (objData) {
            var _this = this;
            var renderer = this.columnRenderersRegistry.getColumnRenderer("object-name");
            //build links for each target object in the recommendation action text
            var targetLinks = objData.targets.map(function (object) {
                object.uid = _this.defaultUriSchemeUtil.getVsphereObjectId(object.provider);
                var targetText;
                if (_this.noLinks) {
                    targetText = "\"" + object.name + "\"";
                }
                else {
                    targetText = renderer(["uid", null, "name", "labelIds"], object);
                }
                return targetText;
            });
            var recommendationText = this.i18nService.interpolate(objData.recommendationText, targetLinks);
            if (!!objData.image) {
                recommendationText = "<span class=\"" + objData.image + "\"></span>" + recommendationText;
            }
            return recommendationText;
        };
        SdrsRecommendationsListController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        SdrsRecommendationsListController.prototype.getCheckedPrerequisiteRecommendationsModalOptions = function () {
            return {
                title: this.i18nService.getString("ClusterUi", "prerequisite.recommendations.selected.title"),
                contentUrl: "cluster-ui/resources/cluster/views/monitor/drs/checkedPrerequisiteRecommendationsModal.html"
            };
        };
        SdrsRecommendationsListController.prototype.getUncheckedDependantRecommendationsModalOptions = function () {
            return {
                title: this.i18nService.getString("ClusterUi", "dependent.recommendations.unselected.title"),
                contentUrl: "cluster-ui/resources/cluster/views/monitor/drs/uncheckedDependantRecommendationsModal.html"
            };
        };
        SdrsRecommendationsListController.$inject = ["i18nService", "vuiConstants", "drsRecommendationsService",
            "$rootScope", "columnRenderersRegistry", "clarityModalService",
            "defaultUriSchemeUtil", "mutationService", "numberFormatterService"];
        return SdrsRecommendationsListController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("sdrsRecommendationsList", new SdrsRecommendationsListComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));







var ds_cluster_ui;
(function (ds_cluster_ui) {
    angular.module('com.vmware.vsphere.client.dsCluster')
        .constant('createDsClusterPageConstants', {
        NAME_AND_LOCATION_INDEX: 0,
        AUTOMATION_INDEX: 1,
        RUNTIME_INDEX: 2,
        HOSTS_AND_CLUSTERS_INDEX: 3,
        DATASTORES_INDEX: 4,
        READY_TO_COMPLETE_INDEX: 5
    });
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var CreateDsClusterWizardDatastoresService = (function () {
        function CreateDsClusterWizardDatastoresService(i18nService) {
            this.i18nService = i18nService;
            this.datastoreOptions = [{
                    label: this.i18nService.getString('DsClusterUi', 'createDsClusterWizard.selectDatastoresPage.showDatastores.connectedToAll'),
                    filterId: 'datastoresWithoutPMemDatastoresFilter'
                }, {
                    label: this.i18nService.getString('DsClusterUi', 'createDsClusterWizard.selectDatastoresPage.showDatastores.showAll'),
                    filterId: 'allDatastoresWithoutPMemDatastoresFilter'
                }];
        }
        CreateDsClusterWizardDatastoresService.prototype.getOptions = function () {
            return this.datastoreOptions;
        };
        CreateDsClusterWizardDatastoresService.$inject = ['i18nService'];
        return CreateDsClusterWizardDatastoresService;
    }());
    ds_cluster_ui.CreateDsClusterWizardDatastoresService = CreateDsClusterWizardDatastoresService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('createDsClusterWizardDatastoresService', CreateDsClusterWizardDatastoresService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var CreateDsClusterWizardHostsAndClustersService = (function () {
        function CreateDsClusterWizardHostsAndClustersService(mutationService, i18nService, dsClusterConstants) {
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
        }
        CreateDsClusterWizardHostsAndClustersService.prototype.getHostsAndClusters = function (selectedDatastore, selectedHostsAndClusters) {
            var spec = this.getValidationSpec(selectedDatastore, selectedHostsAndClusters);
            return this.mutationService.validateSpec(this.dsClusterConstants.HOSTS_AND_CLUSTERS_VALIDATE_SPEC, spec)
                .then(function (validationResult) {
                return validationResult.result;
            });
        };
        CreateDsClusterWizardHostsAndClustersService.prototype.getValidationSpec = function (selectedDatastore, selectedHostsAndClusters) {
            var spec = {
                _type: this.dsClusterConstants.HOSTS_AND_CLUSTERS_VALIDATE_SPEC,
                datastores: selectedDatastore,
                hostsAndClustersIds: selectedHostsAndClusters
            };
            return spec;
        };
        CreateDsClusterWizardHostsAndClustersService.$inject = ['mutationService', 'i18nService', 'dsClusterConstants'];
        return CreateDsClusterWizardHostsAndClustersService;
    }());
    ds_cluster_ui.CreateDsClusterWizardHostsAndClustersService = CreateDsClusterWizardHostsAndClustersService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('createDsClusterWizardHostsAndClustersService', CreateDsClusterWizardHostsAndClustersService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var CreateDsClusterWizardManager = (function () {
        function CreateDsClusterWizardManager(i18nService, vuiConstants, mutationService, dsClusterSpecBuilderService, dsClusterConstants, defaultUriSchemeUtil, $rootScope, sdrsDialogManager) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
            this.dsClusterSpecBuilderService = dsClusterSpecBuilderService;
            this.dsClusterConstants = dsClusterConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$rootScope = $rootScope;
            this.sdrsDialogManager = sdrsDialogManager;
            this.createPages();
        }
        /**
         * Retrieves page definitions.
         *
         * @returns {WizardPage[]}
         */
        CreateDsClusterWizardManager.prototype.getPageDefinitions = function () {
            return [this.nameAndLocationPageDef,
                this.automationPageDef,
                this.runtimeSettingsPageDef,
                this.hostsAndClustersPageDef,
                this.datastoresPageDef,
                this.readyToCompletePageDef];
        };
        /**
         * Submits wizard.
         */
        CreateDsClusterWizardManager.prototype.submit = function () {
            var model = this.getModel();
            var spec = this.dsClusterSpecBuilderService.buildDsClusterSpec(model, true);
            this.mutationService.add(this.dsClusterConstants.DS_CLUSTER_SPEC_TYPE, spec);
            return true;
        };
        CreateDsClusterWizardManager.prototype.setModelDatastoreRefs = function () {
            var model = this.getModel();
            var self = this;
            model.datastoreRefs = [];
            model.datastores.forEach(function (dsId) {
                model.datastoreRefs.push(self.defaultUriSchemeUtil.getManagedObjectReference(dsId));
            });
        };
        /**
         * Retrieves wizard model.
         *
         * @returns {DsClusterModel}
         */
        CreateDsClusterWizardManager.prototype.getModel = function () {
            return this.model;
        };
        CreateDsClusterWizardManager.prototype.getWizardConfig = function () {
            var _this = this;
            if (!this.wizardConfig) {
                this.wizardConfig = {
                    title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.title"),
                    pages: this.getPageDefinitions(),
                    show: true,
                    loading: false,
                    loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                    onFinish: function () { return _this.submit(); },
                    cssClass: "create-ds-cluster-wizard"
                };
            }
            return this.wizardConfig;
        };
        /**
         * Initializes wizard model with default values.
         */
        CreateDsClusterWizardManager.prototype.initModel = function (objectId) {
            this.model = {
                objectId: objectId,
                name: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.defaultName"),
                hostsAndClusters: [],
                datastores: [],
                datastoreRefs: [],
                datastoreDetails: [],
                parent: this.defaultUriSchemeUtil.getManagedObjectReference(objectId),
                dsFilter: {
                    filterId: "datastoresWithoutPMemDatastoresFilter"
                },
                sdrsEnabled: true,
                defaultVmBehavior: this.dsClusterConstants.SDRS_FULLAUTO,
                automationOverrides: this.sdrsDialogManager.getAutomationOverridesModel(null),
                ioLoadBalanceEnabled: true,
                ioLatencyThreshold: this.dsClusterConstants.ioLatencyThreshold.DEFAULT,
                spaceLoadBalanceConfig: this.sdrsDialogManager.getSpaceLoadBalanceConfigModel()
            };
        };
        CreateDsClusterWizardManager.prototype.createPages = function () {
            this.nameAndLocationPageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.nameAndLocationPage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/nameAndLocationPage.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                }
            };
            this.automationPageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.automationLevelPage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/dsAutomationPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED,
                onCommit: function () {
                }
            };
            this.runtimeSettingsPageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/runtimeSettingsPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED,
                onCommit: function () {
                }
            };
            this.hostsAndClustersPageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.hostsAndClustersPage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/hostsAndClustersPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED,
                onCommit: function () {
                }
            };
            this.datastoresPageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.selectDatastoresPage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/datastoresPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED,
                onCommit: function () {
                }
            };
            this.readyToCompletePageDef = {
                title: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/create/readyToCompletePage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED,
                onCommit: function () {
                }
            };
        };
        CreateDsClusterWizardManager.prototype.changeSdrsPagesVisibility = function (visible) {
            if (visible) {
                this.automationPageDef.state = this.vuiConstants.wizard.pageState.DISABLED;
                this.runtimeSettingsPageDef.state = this.vuiConstants.wizard.pageState.DISABLED;
            }
            else {
                this.automationPageDef.state = this.vuiConstants.wizard.pageState.SKIPPED;
                this.runtimeSettingsPageDef.state = this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        CreateDsClusterWizardManager.$inject = ["i18nService", "vuiConstants", "mutationService",
            "dsClusterSpecBuilderService", "dsClusterConstants", "defaultUriSchemeUtil",
            "$rootScope", "sdrsDialogManager"];
        return CreateDsClusterWizardManager;
    }());
    ds_cluster_ui.CreateDsClusterWizardManager = CreateDsClusterWizardManager;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("createDsClusterWizardManager", CreateDsClusterWizardManager);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var CreateDsClusterWizardService = (function () {
        function CreateDsClusterWizardService($rootScope, i18nService, vuiWizardService, dialogManager, pageStateManagementService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.dialogManager = dialogManager;
            this.pageStateManagementService = pageStateManagementService;
        }
        /**
         * Displays create ds cluster wizard.
         */
        CreateDsClusterWizardService.prototype.show = function (objectId) {
            var dialogScope = this.$rootScope.$new();
            this.dialogManager.initModel(objectId);
            dialogScope.wizardConfig = this.dialogManager.getWizardConfig();
            this.pageStateManagementService.registerWizardForDefaultStateManagementStrategy(dialogScope);
            this.vuiWizardService({
                scope: dialogScope,
                configObjectName: 'wizardConfig'
            }).show();
        };
        CreateDsClusterWizardService.$inject = ['$rootScope', 'i18nService', 'vuiWizardService',
            'createDsClusterWizardManager', 'pageStateManagementService'];
        return CreateDsClusterWizardService;
    }());
    ds_cluster_ui.CreateDsClusterWizardService = CreateDsClusterWizardService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('createDsClusterWizardService', CreateDsClusterWizardService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DatastoreMaintenanceModeService = (function () {
        function DatastoreMaintenanceModeService(mutationService, dsClusterConstants, dataService, clarityModalService, i18nService, sdrsFaultsService, defaultUriSchemeUtil, clarityConstants, actionsService, $q, drsRecommendationsService, drsFaultsViewConstants, columnRenderersRegistry, vuiConstants) {
            this.mutationService = mutationService;
            this.dsClusterConstants = dsClusterConstants;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.sdrsFaultsService = sdrsFaultsService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.clarityConstants = clarityConstants;
            this.actionsService = actionsService;
            this.$q = $q;
            this.drsRecommendationsService = drsRecommendationsService;
            this.drsFaultsViewConstants = drsFaultsViewConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.vuiConstants = vuiConstants;
        }
        // ----------------------- interface ----------------------- //
        DatastoreMaintenanceModeService.prototype.enterMaintenanceMode = function (datastoreId, parentPodId) {
            var _this = this;
            this.requestMaintenanceModeOperation(datastoreId, this.dsClusterConstants.maintenanceMode.enter).then(function (requestedData) {
                _this.analyzeOperationResult(requestedData, datastoreId, parentPodId);
            });
        };
        DatastoreMaintenanceModeService.prototype.exitMaintenanceMode = function (datastoreId) {
            this.requestMaintenanceModeOperation(datastoreId, this.dsClusterConstants.maintenanceMode.exit);
        };
        DatastoreMaintenanceModeService.prototype.initiateEnterMaintenanceMode = function (datastoreId) {
            var _this = this;
            var shouldDisplayWarningsPromise = this.displayWarningCheck(datastoreId);
            shouldDisplayWarningsPromise.then(function (response) {
                if (response.shouldWarn) {
                    _this.displayWarning(datastoreId, response);
                }
                else {
                    _this.enterMaintenanceMode(datastoreId, _this.defaultUriSchemeUtil.getVsphereObjectId(response.parentPod));
                }
            });
        };
        DatastoreMaintenanceModeService.prototype.getFaultDetailsGridOptions = function (faults) {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                scrollable: true,
                data: faults,
                selectedItems: [],
                columnDefs: this.getFaultsColumnDefs(),
                pageConfig: {
                    hidePager: true
                },
                height: "100%"
            };
        };
        // ----------------------- implementation details ----------------------- //
        DatastoreMaintenanceModeService.prototype.getFaultsColumnDefs = function () {
            var _this = this;
            var iconRenderer = this.columnRenderersRegistry.getColumnRenderer('icon-text');
            return [
                {
                    displayName: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.faults.datagrid.vmHeader"),
                    field: this.drsFaultsViewConstants.VM_NAME_KEY,
                    type: "string",
                    template: function (dataItem) {
                        var rendererData = {
                            icon: dataItem[_this.drsFaultsViewConstants.VM_ICON_KEY],
                            text: dataItem[_this.drsFaultsViewConstants.VM_NAME_KEY]
                        };
                        return iconRenderer(["icon", "text"], rendererData);
                    }
                },
                {
                    displayName: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.faults.datagrid.vmDisksHeader"),
                    field: this.drsFaultsViewConstants.DISK_NAME_KEY,
                    type: "string",
                    template: "#:" + this.drsFaultsViewConstants.DISK_NAME_KEY + "#"
                },
                {
                    displayName: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.faults.datagrid.hostHeader"),
                    field: this.drsFaultsViewConstants.HOST_NAME_KEY,
                    type: "string",
                    template: function (dataItem) {
                        var rendererData = {
                            icon: dataItem[_this.drsFaultsViewConstants.HOST_ICON_KEY],
                            text: dataItem[_this.drsFaultsViewConstants.HOST_NAME_KEY]
                        };
                        return iconRenderer(["icon", "text"], rendererData);
                    }
                },
                {
                    displayName: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.faults.datagrid.descriptionHeader"),
                    field: this.drsFaultsViewConstants.DESCRIPTION_KEY,
                    type: "string",
                    template: "#:" + this.drsFaultsViewConstants.DESCRIPTION_KEY + "#"
                },
            ];
        };
        DatastoreMaintenanceModeService.prototype.analyzeOperationResult = function (data, datastoreId, parentPodId) {
            var _this = this;
            var faults = [];
            if (data.result.faults) {
                data.result.faults.forEach(function (faultData) {
                    faults = faults.concat(_this.sdrsFaultsService.getMaintenaceModeFaultDetailsData(faultData));
                });
            }
            if (data.result.faults || data.result.recommendations) {
                var recommendations = {
                    computedSdrsRecommendations: data.result.recommendations,
                    id: this.defaultUriSchemeUtil.getVsphereObjectId(data.entity)
                };
                this.displayFaultsAndRecommendations(data.taskUid, faults, recommendations, datastoreId, parentPodId);
            }
        };
        DatastoreMaintenanceModeService.prototype.displayFaultsAndRecommendations = function (taskUid, faults, recommendations, datastoreId, parentPodId) {
            var _this = this;
            var dialogData = {};
            var modalOptions = {
                title: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.title"),
                subTitle: {
                    objectId: datastoreId
                },
                modalClass: "ds-enter-maintenance-mode-hide-close-button",
                dialogData: dialogData,
                size: "xl",
                submitButtonTitle: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.button.continue"),
                defaultButton: "submit",
                onCancel: function () {
                    // Cancel the task.
                    _this.mutationService.apply(taskUid, "com.vmware.vise.core.model.monitor.TaskStateSpec", { cancel: 'true' });
                }
            };
            if (recommendations.computedSdrsRecommendations) {
                // recommendations only are displayed
                var recommendationStore = this.drsRecommendationsService.createRecommendationsStore(new Array(0));
                dialogData = {
                    recommendations: recommendations,
                    parentPodId: parentPodId,
                    recommendationStore: recommendationStore
                };
                modalOptions.contentTemplate =
                    "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/" +
                        "enterMaintenanceModeRecommendationsWarning.html";
                modalOptions.onSubmit = function () {
                    var specType = "com.vmware.vsphere.client.dscluster.maintenancemode.DatastoreMaintenanceSpec";
                    var propSpec = {
                        maintenanceOpType: _this.dsClusterConstants.maintenanceMode.applyRecommendations,
                        keys: modalOptions.dialogData.recommendationStore.getRecommendationsToApply()
                    };
                    _this.mutationService.apply(datastoreId, specType, propSpec);
                    return true;
                };
                // in this case both recommendations and faults are displayed
                if (faults && faults.length > 0) {
                    dialogData.faults = faults;
                    modalOptions.contentTemplate =
                        "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/" +
                            "faultsAndRecommendations.html";
                }
            }
            else if (faults && faults.length > 0) {
                // only faults are displayed
                dialogData = {
                    faults: faults
                };
                modalOptions.contentTemplate =
                    "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/" +
                        "enterMaintenanceModeFaultsWarning.html";
                modalOptions.onSubmit = function () {
                    return true;
                };
            }
            modalOptions.dialogData = dialogData;
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DatastoreMaintenanceModeService.prototype.displayWarningCheck = function (datastoreId) {
            return this.dataService.getData(datastoreId, 'com.vmware.vsphere.client.dscluster.model.DatastoreEnterMaintenanceModeWarningData')
                .then(function (response) {
                return response;
            });
        };
        DatastoreMaintenanceModeService.prototype.displayWarning = function (datastoreId, response) {
            var _this = this;
            var vmIds = _.map(response.vms, function (vm) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(vm);
            });
            var promises = [
                this.mutationService.validateSpec("com.vmware.vsphere.client.h5.vm.model.migration.VmMigrationFlowValidationSpec", { vms: vmIds }),
                this.actionsService.getAction("vsphere.core.vm.actions.migrate", vmIds, false)
            ];
            var modalOptions = {
                title: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.title"),
                subTitle: {
                    objectId: datastoreId
                },
                modalClass: "ds-enter-maintenance-mode-hide-close-button",
                contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/enterMaintenanceModeWarning.html",
                defaultButton: 'submit',
                submitButtonTitle: this.i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.button.continue"),
                dialogData: {
                    shouldStartMigrateWizard: false,
                    parentPod: response.parentPod,
                    vmIds: vmIds,
                    actionEval: {
                        invoker: "vsphere.core.vm.actions.vmMigrate",
                        action: {
                            uid: "vsphere.core.vm.actions.migrate",
                            confirmationTextAll: "CUSTOM",
                            confirmationTextSome: "CUSTOM",
                            label: this.i18nService.getString("VmUi", "actionLabelMigrate")
                        }
                    },
                    promise: this.$q.all(promises)
                },
                onSubmit: function () {
                    _this.enterMaintenanceMode(datastoreId, response.parentPod);
                    // call migrate wizard with the vms
                    if (modalOptions.dialogData.shouldStartMigrateWizard) {
                        _this.actionsService.invokeAction(modalOptions.dialogData.actionEval);
                    }
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        DatastoreMaintenanceModeService.prototype.requestMaintenanceModeOperation = function (datastoreId, operation) {
            var specType = "com.vmware.vsphere.client.dscluster.maintenancemode.DatastoreMaintenanceSpec";
            var propSpec = {
                maintenanceOpType: operation
            };
            return this.mutationService.apply(datastoreId, specType, propSpec);
        };
        DatastoreMaintenanceModeService.$inject = ["mutationService", "dsClusterConstants",
            "dataService", "clarityModalService", "i18nService", "sdrsFaultsService",
            "defaultUriSchemeUtil", "clarityConstants", "actionsService", "$q",
            "drsRecommendationsService", "drsFaultsViewConstants", "columnRenderersRegistry",
            "vuiConstants"];
        return DatastoreMaintenanceModeService;
    }());
    ds_cluster_ui.DatastoreMaintenanceModeService = DatastoreMaintenanceModeService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("datastoreMaintenanceModeService", DatastoreMaintenanceModeService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    angular.module("com.vmware.vsphere.client.dsCluster").constant("dsClusterConstants", {
        DS_CLUSTER_SPEC_TYPE: "com.vmware.vsphere.client.storagedrs.DatastoreClusterSpec",
        HOSTS_AND_CLUSTERS_VALIDATE_SPEC: "com.vmware.vsphere.client.dsclusterui.impl.CreateDsClusterSpec",
        NAME_AND_LOCATION_VALIDATE_SPEC: "com.vmware.vsphere.client.dscluster.DatastoreClusterNameValidationSpec",
        DS_CLUSTER_VM_AFFINITY_VALIDATION_SPEC: "com.vmware.vsphere.client.dscluster.DefaultVmAffinityValidationSpec",
        SDRS_RULE_INFO_SPEC: "com.vmware.vsphere.client.storagedrs.rules.SdrsRuleInfo",
        SDRS_RULE_SPEC: "com.vmware.vsphere.client.dscluster.SdrsRuleSpec",
        SDRS_VM_OVERRIDE_SPEC: "com.vmware.vsphere.client.dscluster.VmOverridesReconfigureSpec",
        SDRS_MANUAL: "manual",
        SDRS_FULLAUTO: "automated",
        SDRS_SPACE_THRESHOLD_FREE_SPACE: "freeSpace",
        SDRS_SPACE_THRESHOLD_UTILIZATION: "utilization",
        loadBalanceInterval: {
            HOUR_MINUTES: 60,
            DAY_MINUTES: 60 * 24,
            MIN_HOURS: 1,
            MAX_DAYS: 29
        },
        loadBalanceIoThreshold: {
            DEFAULT: 5,
            MIN: 1,
            MAX: 100
        },
        minSpaceUtilizationDifference: {
            MIN: 1,
            MAX: 50
        },
        ioLatencyThreshold: {
            DEFAULT: 15,
            MIN: 5,
            MAX: 100
        },
        spaceUtilizationThreshold: {
            DEFAULT: 80,
            MIN: 50,
            MAX: 100
        },
        freeSpaceThresholdGB: {
            MIN: 1
        },
        ruleTypes: {
            VM_ANTI_AFFINITY_TYPE: "VM_ANTIAFFINITY_RULE_TYPE",
            VMDK_ANTI_AFFINITY_TYPE: "VIRTUAL_DISK_ANTI_AFFINITY_RULE_TYPE"
        },
        ruleSpec: {
            VM_ANTI_AFFINITY_TYPE: "com.vmware.vim.binding.vim.cluster.AntiAffinityRuleSpec",
            VMDK_ANTI_AFFINITY_TYPE: "com.vmware.vim.binding.vim.storageDrs.VirtualDiskAntiAffinityRuleSpec"
        },
        operationType: {
            ADD: "add",
            REMOVE: "remove",
            EDIT: "edit"
        },
        vmOverridesOperationType: {
            ADD: "Add",
            REMOVE: "Remove",
            EDIT: "Edit"
        },
        affinityRuleMinimumMembers: 2,
        sdrsVmOverridesAutomationLevels: {
            automated: "Automated",
            manual: "Manual",
            disabled: "Disabled",
            clusterDefault: "ClusterDefault",
            useInitialValues: "useInitialValues"
        },
        keepVmdksValues: {
            clusterDefault: "ClusterDefault",
            useInitialValues: "useInitialValues"
        },
        MAX_INTEGER: 2147483647,
        liveRefreshProperties: {
            RECOMMENDATION: "podStorageDrsEntry.recommendation",
            FAULT: "podStorageDrsEntry.drsFault",
            STORAGE_DRS_CONFIG: "podStorageDrsEntry.storageDrsConfig",
            SUMMARY: "summary"
        },
        maintenanceMode: {
            enter: "enter",
            exit: "exit",
            applyRecommendations: "applyRecommendations"
        }
    });
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterConsumersService = (function () {
        function DsClusterConsumersService(vxPropertyViewService, dataService, i18nService) {
            this.vxPropertyViewService = vxPropertyViewService;
            this.dataService = dataService;
            this.i18nService = i18nService;
        }
        DsClusterConsumersService.prototype.getPropertyViewData = function (objectId) {
            var _this = this;
            return this.dataService.getData(objectId, 'com.vmware.vsphere.client.dsclusterui.model.DsClusterConsumersData')
                .then(function (data) {
                var builder = _this.vxPropertyViewService.createPropertyViewBuilder();
                var sectionBuilder = builder
                    .category('')
                    .section('');
                sectionBuilder.property(_this.i18nService.getString('DsClusterUi', 'dscluster.consumers.vms'), data.vmCount);
                sectionBuilder.property(_this.i18nService.getString('DsClusterUi', 'dscluster.consumers.vm.templates'), data.vmTemplateCount);
                return builder.build();
            });
        };
        DsClusterConsumersService.$inject = ['vxPropertyViewService', 'dataService', 'i18nService'];
        return DsClusterConsumersService;
    }());
    ds_cluster_ui.DsClusterConsumersService = DsClusterConsumersService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('dsClusterConsumersService', DsClusterConsumersService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    angular.module("com.vmware.vsphere.client.dsCluster")
        .constant("dsClusterHelpConstants", {
        SDRS_FAULT_TROUBLESHOOT_GUIDE_ID: "vc_304"
    });
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterServicesAndResourcesService = (function () {
        function DsClusterServicesAndResourcesService(vxPropertyViewService, i18nService) {
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18nService = i18nService;
        }
        DsClusterServicesAndResourcesService.prototype.buildResourcesPropertyViewData = function (data) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("DsClusterUi", "dscluster.resources.used"))
                .icon("ds-cluster-used-resources-legend vx-property-view-key-legend-icon")
                .exit()
                .valueBuilder()
                .text(data.formattedUsedSpace);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("DsClusterUi", "dscluster.resources.freeSpace"))
                .icon("ds-cluster-free-resources-legend vx-property-view-key-legend-icon")
                .exit()
                .valueBuilder()
                .text(data.formattedFreeSpace);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.resources.capacity"), data.formattedCapacity);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.resources.datastores"), data.datastoreCount);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.resources.largestFreeSpace"), data.formattedDsLargestFreeSpace);
            return builder.build();
        };
        DsClusterServicesAndResourcesService.prototype.getMinCapacityLabel = function (formattedCapacity) {
            return DsClusterServicesAndResourcesService.MIN_CAPACITY_VALUE +
                this.getCapacityUnit(formattedCapacity);
        };
        DsClusterServicesAndResourcesService.prototype.getCapacityUnit = function (formattedCapacity) {
            var capacityParts = formattedCapacity.split(" ");
            return capacityParts[1];
        };
        DsClusterServicesAndResourcesService.prototype.buildServicesPropertyViewData = function (data, objId, navigator) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var recommendationlinkObj = {
                extensionId: "vsphere.core.dsCluster.monitor.sdrs.recommendations",
                objectId: objId,
                navigator: navigator
            };
            var faultslinkObj = {
                extensionId: "vsphere.core.dscluster.monitor.sdrs.faults.masterDetailsView",
                objectId: objId,
                navigator: navigator
            };
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "sdrs.config.automationLabel"), data.automationLevelText);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.services.iometrics"), data.ioMetricInclusion);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.services.spaceThreshold"), data.spaceThreshold);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "dscluster.services.ioThreshold"), data.ioLatencyThreshold);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("DsClusterUi", "dscluster.services.recommendationsLabel"))
                .exit()
                .valueBuilder()
                .text(data.recommendationsCount)
                .link(recommendationlinkObj);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("DsClusterUi", "dscluster.services.drsFaultsLabel"))
                .exit()
                .valueBuilder()
                .text(data.faultsCount)
                .link(faultslinkObj);
            return builder.build();
        };
        DsClusterServicesAndResourcesService.$inject = ["vxPropertyViewService", "i18nService"];
        DsClusterServicesAndResourcesService.MIN_CAPACITY_VALUE = "0 ";
        return DsClusterServicesAndResourcesService;
    }());
    ds_cluster_ui.DsClusterServicesAndResourcesService = DsClusterServicesAndResourcesService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("dsClusterServicesAndResourcesService", DsClusterServicesAndResourcesService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterSpecBuilderService = (function () {
        function DsClusterSpecBuilderService(dsClusterConstants) {
            this.dsClusterConstants = dsClusterConstants;
        }
        /**
         * Builds ds cluster spec.
         *
         * @param formData DsClusterModel
         * @param modify boolean
         * @returns {Object}
         */
        DsClusterSpecBuilderService.prototype.buildDsClusterSpec = function (formData, modify) {
            var spec = {
                configSpec: {
                    _type: "com.vmware.vim.binding.vim.storageDrs.ConfigSpec",
                    podConfigSpec: {
                        _type: "com.vmware.vim.binding.vim.storageDrs.PodConfigSpec",
                        ioLoadBalanceConfig: {
                            _type: "com.vmware.vim.binding.vim.storageDrs.IoLoadBalanceConfig"
                        }
                    }
                },
                modify: modify
            };
            if (!modify || angular.isDefined(formData.name)) {
                spec.name = formData.name;
            }
            if (angular.isDefined(formData.parent)) {
                spec.parent = formData.parent;
            }
            if (angular.isDefined(formData.datastoreRefs)) {
                spec.datastores = formData.datastoreRefs;
            }
            if (angular.isDefined(formData.sdrsEnabled)) {
                spec.configSpec.podConfigSpec.enabled = formData.sdrsEnabled;
            }
            else {
                // sdrs disabled by default
                spec.configSpec.podConfigSpec.enabled = false;
            }
            if (angular.isDefined(formData.defaultVmBehavior)) {
                spec.configSpec.podConfigSpec.defaultVmBehavior = formData.defaultVmBehavior;
            }
            if (angular.isDefined(formData.ioLoadBalanceEnabled)) {
                spec.configSpec.podConfigSpec.ioLoadBalanceEnabled = formData.ioLoadBalanceEnabled;
            }
            if (formData.ioLatencyThreshold !== undefined) {
                spec.configSpec.podConfigSpec.ioLoadBalanceConfig.ioLatencyThreshold =
                    Math.round(formData.ioLatencyThreshold);
            }
            if (angular.isDefined(formData.defaultIntraVmAffinity)) {
                spec.configSpec.podConfigSpec.defaultIntraVmAffinity = formData.defaultIntraVmAffinity;
            }
            if (angular.isDefined(formData.loadBalanceInterval)) {
                spec.configSpec.podConfigSpec.loadBalanceInterval = formData.loadBalanceInterval;
            }
            if (angular.isDefined(formData.ioLoadImbalanceThreshold)) {
                spec.configSpec.podConfigSpec.ioLoadBalanceConfig.ioLoadImbalanceThreshold =
                    formData.ioLoadImbalanceThreshold;
            }
            if (formData.spaceLoadBalanceConfig !== undefined) {
                spec.configSpec.podConfigSpec.spaceLoadBalanceConfig = {
                    _type: "com.vmware.vim.binding.vim.storageDrs.SpaceLoadBalanceConfig"
                };
                if (angular.isDefined(formData.spaceLoadBalanceConfig.spaceThresholdMode)) {
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.spaceThresholdMode =
                        formData.spaceLoadBalanceConfig.spaceThresholdMode;
                }
                else {
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.spaceThresholdMode =
                        this.dsClusterConstants.SDRS_SPACE_THRESHOLD_UTILIZATION;
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.spaceUtilizationThreshold =
                        this.dsClusterConstants.spaceUtilizationThreshold.DEFAULT;
                }
                if (formData.spaceLoadBalanceConfig.spaceUtilizationThreshold !== undefined) {
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.spaceUtilizationThreshold =
                        Math.round(formData.spaceLoadBalanceConfig.spaceUtilizationThreshold);
                }
                if (formData.spaceLoadBalanceConfig.freeSpaceThresholdGB !== undefined) {
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.freeSpaceThresholdGB =
                        Math.round(formData.spaceLoadBalanceConfig.freeSpaceThresholdGB);
                }
                if (angular.isDefined(formData.spaceLoadBalanceConfig.minSpaceUtilizationDifference)) {
                    spec.configSpec.podConfigSpec.spaceLoadBalanceConfig.minSpaceUtilizationDifference =
                        formData.spaceLoadBalanceConfig.minSpaceUtilizationDifference;
                }
            }
            if (formData.advancedOptions !== undefined) {
                spec.configSpec.podConfigSpec.option = {
                    _type: "com.vmware.vim.binding.vim.storageDrs.OptionSpec"
                };
                if (angular.isDefined(formData.advancedOptions)) {
                    spec.configSpec.podConfigSpec.option =
                        formData.advancedOptions.buildOptions();
                }
            }
            if (angular.isDefined(formData.automationOverrides)) {
                var automationOverridesObject = _.mapObject(formData.automationOverrides, function (automationOverride) {
                    if (automationOverride !== null) {
                        return automationOverride.id;
                    }
                });
                spec.configSpec.podConfigSpec.automationOverrides =
                    angular.merge({
                        _type: "com.vmware.vim.binding.vim.storageDrs.AutomationConfig" }, automationOverridesObject);
            }
            return spec;
        };
        DsClusterSpecBuilderService.$inject = ["dsClusterConstants"];
        return DsClusterSpecBuilderService;
    }());
    ds_cluster_ui.DsClusterSpecBuilderService = DsClusterSpecBuilderService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("dsClusterSpecBuilderService", DsClusterSpecBuilderService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterConectivityService = (function () {
        function DsClusterConectivityService(i18nService, vuiConstants, columnRenderersRegistry, defaultUriSchemeUtil, resourceUtil, entityStatusService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.resourceUtil = resourceUtil;
            this.entityStatusService = entityStatusService;
        }
        DsClusterConectivityService.prototype.getMasterViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getMasterColumnDefs(),
                height: "100%"
            };
        };
        DsClusterConectivityService.prototype.getDetailsViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getDetailsColumnDefs(),
                height: "100%"
            };
        };
        DsClusterConectivityService.prototype.getDetailsColumnDefs = function () {
            return [{
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceDetailsView.nameColumn"),
                    field: "name",
                    type: "string",
                    template: this.getObjNameIconRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceDetailsView.datastoresConnectedColumn"),
                    field: "datastoresConnected",
                    type: "string"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceDetailsView.detailsColumn"),
                    field: "details",
                    type: "string"
                }];
        };
        DsClusterConectivityService.prototype.getMasterColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.nameColumn"),
                    field: "name",
                    type: "string",
                    template: this.getObjNameIconRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.dsConnectionStatusColumn"),
                    field: "isConnected",
                    type: "boolean",
                    template: this.getConnectivityIconRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.allocatedSpace"),
                    field: "allocatedSpaceFormatted",
                    type: "string"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.usedSpace"),
                    field: "usedSpaceFormatted",
                    type: "string"
                }
            ];
        };
        DsClusterConectivityService.prototype.getVmConnectivityMasterViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: true,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getVmConnectivityMasterColumnDefs(),
                height: "100%"
            };
        };
        DsClusterConectivityService.prototype.getVmConnectivityDetailsViewGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getVmConnectivityDetailsColumnDefs(),
                height: "100%"
            };
        };
        DsClusterConectivityService.prototype.getVmConnectivityDetailsColumnDefs = function () {
            return [{
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.fileName"),
                    field: "fileName",
                    type: "string",
                    template: this.getVdNameIconRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.deviceName"),
                    field: "deviceName",
                    type: "string"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.type"),
                    field: "diskType",
                    type: "string"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.datastoreName"),
                    field: "datastoreName",
                    type: "string"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.capacity"),
                    field: "capacityValue",
                    type: "string"
                }];
        };
        DsClusterConectivityService.prototype.getVmConnectivityMasterColumnDefs = function () {
            var _this = this;
            return [{
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.nameColumn"),
                    field: "vmName",
                    type: "string",
                    template: this.getVmNameRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.state"),
                    field: "state",
                    type: "string",
                    template: this.getPowerState.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.status"),
                    field: "status",
                    type: "string",
                    template: this.getStatusIconRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.datastore"),
                    field: "datastoreName",
                    type: "string",
                    template: this.getDatastoreNameIconLinkRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.managedBy"),
                    field: "managedByLabel",
                    type: "string",
                    template: this.getManagedByNameIconRenderer
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.host"),
                    field: "host.name",
                    type: "string",
                    template: this.getHostObjectLinkRenderer.bind(this)
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsCluster.connectivity.vm.columns.provisionedSpace"),
                    field: "totalProvisionedSpace",
                    type: "string",
                    sortable: function (dataItem1, dataItem2) {
                        return _this.compareNumericValues(dataItem1, dataItem2, 'provisionedSpace');
                    }
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.usedSpace"),
                    field: "totalUsedSpace",
                    type: "string",
                    sortable: function (dataItem1, dataItem2) {
                        return _this.compareNumericValues(dataItem1, dataItem2, 'usedSpace');
                    }
                }];
        };
        DsClusterConectivityService.prototype.compareNumericValues = function (dataItem1, dataItem2, property) {
            if (dataItem1[property] < dataItem2[property]) {
                return -1;
            }
            if (dataItem1[property] > dataItem2[property]) {
                return 1;
            }
            return 0;
        };
        DsClusterConectivityService.prototype.getObjNameIconRenderer = function (data) {
            return this.getNameIconRenderer(data.icon, data.name);
        };
        DsClusterConectivityService.prototype.getVmNameRenderer = function (data) {
            data.vmName = data.name + this.resourceUtil
                .getTaggingLabelString(data.label);
            return this.getObjectLinkRenderer(data.provider, data.vmName, data.icon);
        };
        DsClusterConectivityService.prototype.getPowerState = function (data) {
            return this.i18nService.getString("Common", "powerState." + data.state);
        };
        DsClusterConectivityService.prototype.getStatusIconRenderer = function (data) {
            var status = this.entityStatusService.statusProperties(data.status);
            return this.getNameIconRenderer(status.iconClass, status.label);
        };
        DsClusterConectivityService.prototype.getDatastoreNameIconLinkRenderer = function (data) {
            var datastoreArray = data.datastoreArray;
            if (datastoreArray.length === 1) {
                data.datastoreName = datastoreArray[0].name;
                return this.getObjectLinkRenderer(datastoreArray[0].provider, data.datastoreName, datastoreArray[0].icon);
            }
            else if (datastoreArray.length > 1) {
                var title = void 0;
                var datastoreNames_1 = [];
                var objTextRenderer = this.columnRenderersRegistry
                    .getColumnRenderer("text-with-custom-tooltip");
                _.map(datastoreArray, function (datastore) {
                    datastoreNames_1.push(datastore.name);
                });
                title = datastoreNames_1.join(", ");
                data.datastoreName = this.i18nService.getString("DsClusterUi", "sdrs.rules.config.multipleDatastores");
                return objTextRenderer(["text", "title"], {
                    text: data.datastoreName,
                    title: title
                });
            }
            return "";
        };
        DsClusterConectivityService.prototype.getManagedByNameIconRenderer = function (data) {
            if (data.managedByIcon !== null && data.managedByLabel !== null) {
                return "<span><img src=\"data:image/png;base64,\n                " + data.managedByIcon.imageData + "\"/>\n                " + data.managedByLabel + "</span>";
            }
            else if (data.managedByLabel !== null) {
                return data.managedByLabel;
            }
            return "";
        };
        DsClusterConectivityService.prototype.getHostObjectLinkRenderer = function (data) {
            return this.getObjectLinkRenderer(data.host.provider, data.host.name, data.host.icon);
        };
        DsClusterConectivityService.prototype.getVdNameIconRenderer = function (data) {
            return this.getNameIconRenderer("vx-icon-vmDisk", data.fileName);
        };
        DsClusterConectivityService.prototype.getConnectivityIconRenderer = function (data) {
            return this.getNameIconRenderer(data.isConnectedIcon, data.connectionLabel);
        };
        DsClusterConectivityService.prototype.setHostFromCluster = function (connectivityData) {
            this.clusterConectivityData = connectivityData;
        };
        DsClusterConectivityService.prototype.getHostFromCluster = function (cluster) {
            var connectivityObj = null;
            _.each(this.clusterConectivityData, function (connectivity) {
                if (connectivity.name === cluster.name) {
                    connectivityObj = cluster;
                }
            });
            if (connectivityObj !== null) {
                return _.map(connectivityObj.hosts, function (host) {
                    return {
                        name: host.name,
                        icon: host.icon,
                        datastoresConnected: host.connectedDatastoresCount,
                        details: host.datastoresConnectionStatus
                    };
                });
            }
            return [];
        };
        DsClusterConectivityService.prototype.getNameIconRenderer = function (icon, name) {
            var renderer = this.columnRenderersRegistry
                .getColumnRenderer("icon-text");
            return renderer(["icon", "text"], {
                icon: icon,
                text: name
            });
        };
        DsClusterConectivityService.prototype.getObjectLinkRenderer = function (provider, name, icon) {
            var objectLinkRenderer = this.columnRenderersRegistry
                .getColumnRenderer("object-link");
            var ref = this.defaultUriSchemeUtil
                .getVsphereObjectId(provider);
            return objectLinkRenderer(["ref", "name", icon], {
                ref: ref,
                name: name
            });
        };
        DsClusterConectivityService.$inject = ["i18nService", "vuiConstants",
            "columnRenderersRegistry", "defaultUriSchemeUtil", "resourceUtil",
            "entityStatusService"];
        return DsClusterConectivityService;
    }());
    ds_cluster_ui.DsClusterConectivityService = DsClusterConectivityService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("dsClusterConectivityService", DsClusterConectivityService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SdrsFaultsService = (function () {
        function SdrsFaultsService(i18nService, drsFaultsViewConstants, drsFaultsViewService, iconService, feedbackService, resourceUtil) {
            this.i18nService = i18nService;
            this.drsFaultsViewConstants = drsFaultsViewConstants;
            this.drsFaultsViewService = drsFaultsViewService;
            this.iconService = iconService;
            this.feedbackService = feedbackService;
            this.resourceUtil = resourceUtil;
        }
        SdrsFaultsService.prototype.getFaultMasterData = function (fault) {
            var target = {};
            if (fault.target) {
                if (fault.target.name !== null || fault.target.name !== "") {
                    var interpolationItem = {};
                    interpolationItem[this.drsFaultsViewConstants.ID_KEY] = fault.target.provider;
                    interpolationItem[this.drsFaultsViewConstants.NAME_KEY] = fault.target.name;
                    var interpolations = [interpolationItem];
                    target[this.drsFaultsViewConstants.TEXT_KEY] =
                        this.drsFaultsViewService.interpolateWithLinks("{0}", interpolations);
                    target[this.drsFaultsViewConstants.ICON_KEY] =
                        this.iconService.getByObjectRef(fault.target.provider);
                }
                else {
                    target[this.drsFaultsViewConstants.TEXT_KEY] =
                        this.i18nService.getString("DsClusterUi", "sdrs.faults.missingObjectNameLabel");
                }
            }
            var gridItem = {};
            gridItem[this.drsFaultsViewConstants.LOCALIZED_REASON] =
                this.getDrsMigrationErrorLocalization(fault.reason);
            gridItem[this.drsFaultsViewConstants.REASON] = fault.reason;
            gridItem[this.drsFaultsViewConstants.TARGET_KEY] =
                target[this.drsFaultsViewConstants.TEXT_KEY] ? target : "";
            gridItem[this.drsFaultsViewConstants.DETAILS_KEY] = fault.details;
            gridItem[this.drsFaultsViewConstants.ICON_KEY] = "vsphere-icon-status-error";
            return gridItem;
        };
        SdrsFaultsService.prototype.getMaintenaceModeFaultDetailsData = function (data) {
            var gridItems = [];
            for (var _i = 0, _a = data.description; _i < _a.length; _i++) {
                var description = _a[_i];
                var gridItem = {};
                gridItem[this.drsFaultsViewConstants.DESCRIPTION_KEY] = description;
                gridItem[this.drsFaultsViewConstants.HOST_NAME_KEY] =
                    data.hostName + this.resourceUtil.getTaggingLabelString(data.hostLabelIds);
                gridItem[this.drsFaultsViewConstants.HOST_ICON_KEY] = data.hostIcon;
                gridItem[this.drsFaultsViewConstants.VM_NAME_KEY] =
                    data.vmName + this.resourceUtil.getTaggingLabelString(data.vmLabelIds);
                gridItem[this.drsFaultsViewConstants.VM_ICON_KEY] = data.vmIcon;
                gridItem[this.drsFaultsViewConstants.DISK_NAME_KEY] = data.diskName;
                gridItems.push(gridItem);
            }
            return gridItems;
        };
        SdrsFaultsService.prototype.getFaultDetailsData = function (details) {
            var gridItem = null;
            if (details.preventedRecommendation.targetVmdk !== null) {
                gridItem = this.buildMigrateVmdkFaultItem(details);
            }
            else {
                gridItem = this.buildMigrateVmFaultItem(details);
            }
            return gridItem;
        };
        SdrsFaultsService.prototype.getDrsMigrationErrorLocalization = function (reason) {
            return this.i18nService.getString("Common", "drs.migration.error." + reason);
        };
        SdrsFaultsService.prototype.buildMigrateVmdkFaultItem = function (details) {
            var preventedRecommendation = this.drsFaultsViewService.interpolateWithLinks(this.i18nService.getString("DsClusterUi", "sdrs.faults.migrateVmdk"), [this.getVmdkObject(details), this.getVmObject(details),
                this.getVmdsObject(details)]);
            return this.buildGridItem(details, preventedRecommendation);
        };
        SdrsFaultsService.prototype.buildMigrateVmFaultItem = function (details) {
            var preventedRecommendation = "";
            if (details.preventedRecommendation.targetVm !== null) {
                preventedRecommendation = this.drsFaultsViewService.interpolateWithLinks(this.i18nService.getString("DsClusterUi", "sdrs.faults.migrateVm"), [this.getVmObject(details)]);
            }
            return this.buildGridItem(details, preventedRecommendation);
        };
        SdrsFaultsService.prototype.buildGridItem = function (details, preventedRecommendation) {
            var gridItem = {};
            gridItem[this.drsFaultsViewConstants.REASON] = this.buildReasonLink("vsphere-icon-status-error", details.faultDetailMessage, details.helpId);
            gridItem[this.drsFaultsViewConstants.PREVENTED_RECOMMENDATION] =
                preventedRecommendation;
            gridItem[this.drsFaultsViewConstants.PREVENTED_RECOMMENDATION_ICON_CLASS] =
                details.preventedRecommendationIcon;
            return gridItem;
        };
        SdrsFaultsService.prototype.buildReasonLink = function (icon, reason, helpId) {
            return '<a ng-click="$parent.$parent.openHelpLink(\'' + helpId + '\')">' +
                '<span class="' + icon + '"></span>' + reason + '</a>';
        };
        SdrsFaultsService.prototype.getVmdkObject = function (details) {
            var targetVmdkName = details.preventedRecommendation.targetVmdk;
            if (targetVmdkName === null) {
                return this.i18nService.getString("DsClusterUi", "sdrs.faults.missingObjectNameLabel");
            }
            else {
                return targetVmdkName;
            }
        };
        SdrsFaultsService.prototype.getVmdsObject = function (details) {
            var targetVmds = details.preventedRecommendation.targetVmds;
            var targetVmObject = {};
            if (targetVmds.name === null) {
                return this.i18nService.getString("DsClusterUi", "sdrs.faults.missingObjectNameLabel");
            }
            else {
                targetVmObject[this.drsFaultsViewConstants.ID_KEY] = targetVmds.provider;
                targetVmObject[this.drsFaultsViewConstants.NAME_KEY] = targetVmds.name;
                return targetVmObject;
            }
        };
        SdrsFaultsService.prototype.getVmObject = function (details) {
            var targetVm = details.preventedRecommendation.targetVm;
            var targetVmObject = {};
            if (targetVm.name === null) {
                return this.i18nService.getString("DsClusterUi", "sdrs.faults.missingObjectNameLabel");
            }
            else {
                targetVmObject[this.drsFaultsViewConstants.ID_KEY] = targetVm.provider;
                targetVmObject[this.drsFaultsViewConstants.NAME_KEY] = targetVm.name;
                return targetVmObject;
            }
        };
        SdrsFaultsService.$inject = ["i18nService", "drsFaultsViewConstants",
            "drsFaultsViewService", "iconService", "feedbackService", "resourceUtil"];
        return SdrsFaultsService;
    }());
    ds_cluster_ui.SdrsFaultsService = SdrsFaultsService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("sdrsFaultsService", SdrsFaultsService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddSdrsVmOverridesService = (function () {
        function AddSdrsVmOverridesService(i18nService, vuiConstants, columnRenderersRegistry, dsClusterConstants, defaultUriSchemeUtil, AddVmToVmOverridesManager, addVmOverridesWizardService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dsClusterConstants = dsClusterConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.AddVmToVmOverridesManager = AddVmToVmOverridesManager;
            this.addVmOverridesWizardService = addVmOverridesWizardService;
        }
        AddSdrsVmOverridesService.prototype.openAddVmOverridesWizard = function (targetUid) {
            var manager = new this.AddVmToVmOverridesManager();
            this.addVmOverridesWizardService.invokeWizard(targetUid, manager);
        };
        AddSdrsVmOverridesService.prototype.buildVuiSignPostSdrsAutomationLevel = function (selectedVms) {
            var title = this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.signPost.title");
            var messages = [];
            _.each(selectedVms, function (selectedVm) {
                messages.push(selectedVm.vm.name + " - " + selectedVm.sdrsAutomationLevelText);
            });
            return {
                title: title,
                message: messages.join("<br>")
            };
        };
        AddSdrsVmOverridesService.prototype.buildVuiSignPostIntraVmAffinityLevel = function (selectedVms) {
            var title = this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.signPost.title");
            var messages = [];
            _.each(selectedVms, function (selectedVm) {
                messages.push(selectedVm.vm.name + " - " + selectedVm.intraVmAffinityText);
            });
            return {
                title: title,
                message: messages.join("<br>")
            };
        };
        AddSdrsVmOverridesService.prototype.getEditMultipleVmOverridesIdentityResults = function (vms) {
            var uniqueIntraVmAffinityValues = _.uniq(vms, false, function (item) {
                return item.rawData.intraVmAffinity;
            });
            var uniqueSdrsAutomationLevels = _.uniq(vms, false, function (item) {
                return [item.rawData.vmAutomationLevel,
                    item.rawData.vmAutomationLevelEnabled,
                    item.rawData.defaultAutomationLevel].join();
            });
            var vmsAreWithEqualIntraVmAffinity = uniqueIntraVmAffinityValues.length === 1;
            var vmsAreWithEqualSdrsAutomationLevel = uniqueSdrsAutomationLevels.length === 1;
            return {
                vmsAreWithEqualIntraVmAffinity: vmsAreWithEqualIntraVmAffinity,
                vmsAreWithEqualSdrsAutomationLevel: vmsAreWithEqualSdrsAutomationLevel
            };
        };
        AddSdrsVmOverridesService.prototype.getSdrsVmOverridesGridOptions = function (data) {
            return {
                actionBarOptions: {
                    actions: []
                },
                searchable: false,
                resizable: true,
                data: data,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                columnDefs: [{
                        displayName: this.i18nService.getString("DsClusterUi", "vmOverrides.vmNameHeaderText"),
                        field: "rawData.vmName",
                        template: this.vmNameRenderer.bind(this)
                    }],
                pageConfig: {
                    hidePager: true
                }
            };
        };
        AddSdrsVmOverridesService.prototype.getSplitterOptions = function () {
            return {
                panes: [
                    {
                        min: '150px',
                        size: '25%'
                    }, {
                        min: '150px',
                        size: '75%'
                    }
                ],
                orientation: this.vuiConstants.splitter.orientation.HORIZONTAL
            };
        };
        AddSdrsVmOverridesService.prototype.vmNameRenderer = function (data) {
            var renderer = this.columnRenderersRegistry.getColumnRenderer('icon-text');
            var renderedColumnValue = renderer(['icon', 'name'], data);
            return renderedColumnValue;
        };
        AddSdrsVmOverridesService.$inject = ["i18nService", "vuiConstants",
            "columnRenderersRegistry", "dsClusterConstants", "defaultUriSchemeUtil",
            "AddVmToVmOverridesManager", "addVmOverridesWizardService"];
        return AddSdrsVmOverridesService;
    }());
    ds_cluster_ui.AddSdrsVmOverridesService = AddSdrsVmOverridesService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("addSdrsVmOverridesService", AddSdrsVmOverridesService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmToVmOverridesManager = (function () {
        function AddVmToVmOverridesManager() {
        }
        AddVmToVmOverridesManager.prototype.setSpec = function (spec) {
            this.spec = spec;
        };
        AddVmToVmOverridesManager.prototype.getSpec = function () {
            return this.spec;
        };
        AddVmToVmOverridesManager.prototype.setClusterName = function (clusterName) {
            this.clusterName = clusterName;
        };
        AddVmToVmOverridesManager.prototype.getClusterName = function () {
            return this.clusterName;
        };
        AddVmToVmOverridesManager.prototype.setTargetUid = function (targetUid) {
            this.targetUid = targetUid;
        };
        AddVmToVmOverridesManager.prototype.getTargetUid = function () {
            return this.targetUid;
        };
        AddVmToVmOverridesManager.prototype.setSelectedVms = function (selectedVms) {
            this.selectedVms = selectedVms;
        };
        AddVmToVmOverridesManager.prototype.getSelectedVms = function () {
            return this.selectedVms;
        };
        AddVmToVmOverridesManager.prototype.setSdrsAutomationLevel = function (sdrsAutomationLevel) {
            this.sdrsAutomationLevel = sdrsAutomationLevel;
        };
        AddVmToVmOverridesManager.prototype.getSdrdsAutomationLevel = function () {
            return this.sdrsAutomationLevel;
        };
        AddVmToVmOverridesManager.prototype.setDefaultSdrsAutomationLevel = function (defaultSdrsAutomationLevel) {
            this.defaultSdrsAutomationLevel = defaultSdrsAutomationLevel;
        };
        AddVmToVmOverridesManager.prototype.isDefaultSdrsAutomationLevelSelected = function () {
            return this.defaultSdrsAutomationLevel;
        };
        AddVmToVmOverridesManager.prototype.setKeepVmdkTogether = function (keepVmdkTogether) {
            this.keepVmdkTogether = keepVmdkTogether;
        };
        AddVmToVmOverridesManager.prototype.getKeepVmdkTogether = function () {
            return this.keepVmdkTogether;
        };
        AddVmToVmOverridesManager.$inject = [];
        return AddVmToVmOverridesManager;
    }());
    ds_cluster_ui.AddVmToVmOverridesManager = AddVmToVmOverridesManager;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .factory("AddVmToVmOverridesManager", [
        function () {
            return Function.prototype.bind.apply(AddVmToVmOverridesManager, [undefined]);
        }
    ]);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SdrsRulesService = (function () {
        function SdrsRulesService(i18nService, dataService, vuiConstants, defaultUriSchemeUtil, columnRenderersRegistry, dsClusterConstants, dsClusterSpecBuilderService, mutationService, clarityModalService) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dsClusterConstants = dsClusterConstants;
            this.dsClusterSpecBuilderService = dsClusterSpecBuilderService;
            this.mutationService = mutationService;
            this.clarityModalService = clarityModalService;
            this.PROPERTY_SDRS_RULES = "computedSdrsRules";
            this.PROPERTY_VM_VIRTUAL_DISKS = "virtualDisks";
            this.PROPERTY_VM_RULE_DETAILS = "computedSdrsRuleVmDetails";
        }
        SdrsRulesService.prototype.getMasterViewData = function (objectId, filterText) {
            var options;
            if (filterText && filterText !== "") {
                options = {
                    propertyParams: [{
                            propertyName: this.PROPERTY_SDRS_RULES,
                            parameterType: 'java.lang.String',
                            parameter: filterText
                        }]
                };
            }
            return this.dataService
                .getProperties(objectId, [this.PROPERTY_SDRS_RULES], options)
                .then(function (data) { return data.computedSdrsRules; });
        };
        SdrsRulesService.prototype.getMasterGridOptions = function (onDataBound) {
            var options = {
                actionBarOptions: {
                    actions: []
                },
                pageConfig: {
                    hidePager: true
                },
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getMasterColumnDefs(),
                height: "100%",
                dataBound: onDataBound
            };
            return options;
        };
        SdrsRulesService.prototype.getVmdkDetailsViewData = function (rule) {
            var vmRef = this.defaultUriSchemeUtil.getVsphereObjectId(rule.vm.provider);
            return this.dataService.getProperties(vmRef, [this.PROPERTY_VM_VIRTUAL_DISKS])
                .then(function (data) {
                var virtualDisksInRule = _.filter(data.virtualDisks, function (virtualDisk) {
                    return _.contains(rule.rule.diskId, virtualDisk.key);
                });
                return _.map(virtualDisksInRule, function (virtualDisk) {
                    return {
                        name: virtualDisk.deviceInfo.label,
                        key: virtualDisk.key,
                        deviceInfo: {
                            label: virtualDisk.deviceInfo.label
                        }
                    };
                });
            });
        };
        SdrsRulesService.prototype.getVmDetailsViewData = function (rule) {
            var _this = this;
            var vms = _.map(rule.rule.vm, function (vm) { return _this.defaultUriSchemeUtil.getVsphereObjectId(vm); });
            return this.dataService.getPropertiesForObjects(vms, [this.PROPERTY_VM_RULE_DETAILS])
                .then(function (data) { return _.map(data, function (member, id) {
                return _.extend(member.computedSdrsRuleVmDetails, { "id": id });
            }); });
        };
        SdrsRulesService.prototype.deleteRule = function (dsClusterId, rule) {
            var _this = this;
            var confirmProperties = {
                title: this.i18nService.getString('DsClusterUi', 'sdrs.rules.action.remove.confirmation.title'),
                message: this.i18nService.getString('DsClusterUi', 'sdrs.rules.action.remove.confirmation.text'),
                submit: function () {
                    _this.deleteRuleFromDsCluster(dsClusterId, rule);
                }
            };
            this.clarityModalService.openConfirmationModal(confirmProperties);
        };
        SdrsRulesService.prototype.deleteRuleFromDsCluster = function (dsClusterId, dsClusterRule) {
            var ruleType = this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE;
            var vm = null;
            if (dsClusterRule.ruleType ===
                this.dsClusterConstants.ruleTypes.VMDK_ANTI_AFFINITY_TYPE) {
                ruleType = this.dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE;
                vm = dsClusterRule.vm.provider;
            }
            var deleteRuleSpec = {
                operation: this.dsClusterConstants.operationType.REMOVE,
                ruleInfo: {
                    _type: this.dsClusterConstants.SDRS_RULE_INFO_SPEC,
                    rule: {
                        _type: ruleType,
                        key: dsClusterRule.rule.key,
                    },
                    vm: vm
                }
            };
            this.mutationService.apply(dsClusterId, this.dsClusterConstants.SDRS_RULE_SPEC, deleteRuleSpec);
        };
        SdrsRulesService.prototype.getMasterColumnDefs = function () {
            return [
                {
                    displayName: this.getString("rules.view.name"),
                    field: "rule.name",
                    type: "string",
                    template: "<span class=\"object\" title=\"#:rule.name#\">" +
                        "<i class=\"vx-icon-rule\")></i>#:rule.name#</span>"
                },
                {
                    displayName: this.getString("rules.view.description"),
                    field: "ruleType",
                    type: "string",
                    template: this.renderRuleType.bind(this)
                },
                {
                    displayName: this.getString("rules.view.enabled"),
                    field: "rule.enabled",
                    type: "boolean",
                    template: this.renderEnabled.bind(this)
                },
                {
                    displayName: this.getString("rules.view.vmName"),
                    field: "vm",
                    type: "object",
                    searchable: false,
                    template: this.renderVmName.bind(this)
                }
            ];
        };
        SdrsRulesService.prototype.renderRuleType = function (data) {
            if (data.ruleType === this.dsClusterConstants.ruleTypes.VM_ANTI_AFFINITY_TYPE) {
                return this.getString("rules.view.type.vmAntiAffinity");
            }
            else {
                return this.getString("rules.view.type.vmdkAntiAffinity");
            }
        };
        SdrsRulesService.prototype.renderEnabled = function (data) {
            if (data.rule.enabled) {
                return this.getString("rules.view.enabled.yes");
            }
            else {
                return this.getString("rules.view.enabled.no");
            }
        };
        SdrsRulesService.prototype.renderVmName = function (data) {
            if (data.vm === null) {
                return this.getString("rules.view.multipleVms");
            }
            else {
                var iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
                return iconTextRenderer(["primaryIconId", "name"], data.vm);
            }
        };
        SdrsRulesService.prototype.getString = function (key) {
            return this.i18nService.getString("Common", key);
        };
        SdrsRulesService.prototype.getVmdkDetailsGridOptions = function () {
            var options = {
                pageConfig: {
                    hidePager: true
                },
                searchable: false,
                resizable: false,
                data: [],
                selectedItems: [],
                columnDefs: this.getVmdkDetailsColumnDefs(),
                height: "100%"
            };
            return options;
        };
        SdrsRulesService.prototype.getVmdkDetailsColumnDefs = function () {
            return [
                {
                    displayName: this.getString("rules.view.name"),
                    field: "name",
                    type: "string",
                    template: "<span class=\"object\" title=\"#:name#\">#:name#</span>"
                }
            ];
        };
        SdrsRulesService.prototype.getVmDetailsGridOptions = function () {
            var options = {
                pageConfig: {
                    hidePager: true
                },
                searchable: false,
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getVmDetailsColumnDefs(),
                height: "100%"
            };
            return options;
        };
        SdrsRulesService.prototype.getVmDetailsColumnDefs = function () {
            return [
                {
                    displayName: this.getString("rules.view.vmName"),
                    field: "name",
                    type: "string",
                    template: "<span class=\"object\" title=\"#:name#\">" +
                        "<i class=\"#:primaryIconId#\")></i>#:name#</span>"
                },
                {
                    displayName: this.i18nService.getString("DsClusterUi", "sdrs.rules.config.vmDatastoreHeaderText"),
                    field: "datastoreName",
                    type: "string",
                    template: this.renderDatastoreData.bind(this)
                }
            ];
        };
        SdrsRulesService.prototype.renderDatastoreData = function (data) {
            var objData = data || {};
            objData.primaryIconId = "vsphere-icon-datastore";
            var renderer = this.columnRenderersRegistry.getColumnRenderer("object-name");
            return renderer([null, "primaryIconId", "datastoreName", null, "datastoreHint"], objData);
        };
        SdrsRulesService.prototype.getSdrsRuleTypes = function () {
            return [{
                    id: this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE,
                    label: this.getString("sdrs.rules.config.label.VM_ANTIAFFINITY_RULE_TYPE")
                }, {
                    id: this.dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE,
                    label: this.getString("sdrs.rules.config.label.VIRTUAL_DISK_ANTI_AFFINITY_RULE_TYPE")
                }];
        };
        SdrsRulesService.prototype.createRuleInstance = function (ruleSpec, name, enabled, members, key) {
            var ruleInfo = {
                name: name,
                enabled: enabled,
                userCreated: true,
                key: key
            };
            switch (ruleSpec) {
                case this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE:
                    ruleInfo = _.extend({
                        vm: members,
                        _type: ruleSpec
                    }, ruleInfo);
                    break;
                case this.dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE:
                    ruleInfo = _.extend({
                        diskId: members,
                        _type: ruleSpec
                    }, ruleInfo);
                    break;
                default:
                    break;
            }
            return ruleInfo;
        };
        SdrsRulesService.prototype.createSdrsRuleInfo = function (ruleInfo, ruleType, operation, vmdkVm) {
            var sdrsRuleInfo = {
                _type: this.dsClusterConstants.SDRS_RULE_INFO_SPEC,
                rule: ruleInfo,
                ruleType: ruleType,
                operation: operation
            };
            if (ruleType === this.dsClusterConstants.ruleTypes.VMDK_ANTI_AFFINITY_TYPE) {
                sdrsRuleInfo = _.extend({
                    vm: vmdkVm
                }, sdrsRuleInfo);
            }
            return sdrsRuleInfo;
        };
        SdrsRulesService.prototype.getRuleTypeByRuleSpec = function (ruleSpec) {
            switch (ruleSpec) {
                case this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE:
                    return this.dsClusterConstants.ruleTypes.VM_ANTI_AFFINITY_TYPE;
                case this.dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE:
                    return this.dsClusterConstants.ruleTypes.VMDK_ANTI_AFFINITY_TYPE;
            }
            return "";
        };
        SdrsRulesService.prototype.buildSdrsRuleInfo = function (ruleSpec, name, enabled, ruleMembers, operation, ruleKey, vmdkVm) {
            var ruleInfo = this.createRuleInstance(ruleSpec, name.trim(), enabled, ruleMembers, ruleKey);
            var ruleType = this.getRuleTypeByRuleSpec(ruleSpec);
            return this.createSdrsRuleInfo(ruleInfo, ruleType, operation, vmdkVm);
        };
        SdrsRulesService.prototype.buildSdrsRuleSpec = function (ruleInfo, operation) {
            return {
                _type: this.dsClusterConstants.SDRS_RULE_SPEC,
                ruleInfo: ruleInfo,
                operation: operation
            };
        };
        SdrsRulesService.prototype.getVmVirtualDisks = function (vmId) {
            return this.dataService.getProperties(vmId, [this.PROPERTY_VM_VIRTUAL_DISKS])
                .then(function (data) {
                return _.map(data.virtualDisks, function (virtualDisk) {
                    return {
                        key: virtualDisk.key,
                        deviceInfo: virtualDisk.deviceInfo
                    };
                });
            });
        };
        SdrsRulesService.prototype.getRuleMemberRefs = function (spec) {
            var _this = this;
            var ruleMemberRefs;
            if (spec.ruleType.id ===
                this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE) {
                ruleMemberRefs = _.map(spec.ruleMembersData, function (vm) {
                    return _this.defaultUriSchemeUtil.getManagedObjectReference(vm.id);
                });
            }
            else {
                ruleMemberRefs = _.pluck(spec.ruleMembersData, "key");
            }
            return ruleMemberRefs;
        };
        SdrsRulesService.$inject = ["i18nService", "dataService", "vuiConstants",
            "defaultUriSchemeUtil", "columnRenderersRegistry", "dsClusterConstants",
            "dsClusterSpecBuilderService", "mutationService", "clarityModalService"];
        return SdrsRulesService;
    }());
    ds_cluster_ui.SdrsRulesService = SdrsRulesService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("sdrsRulesService", SdrsRulesService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageVmOverridesService = (function () {
        function StorageVmOverridesService(i18nService, dataService, vuiConstants, defaultUriSchemeUtil, columnRenderersRegistry, mutationService, dsClusterConstants) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.mutationService = mutationService;
            this.dsClusterConstants = dsClusterConstants;
        }
        StorageVmOverridesService.prototype.getViewData = function (objectId) {
            return this.dataService
                .getData(objectId, "com.vmware.vsphere.client.dsclusterui.model.configuration.DsClusterVmOverrideData")
                .then(function (data) { return data.vmOverrides; });
        };
        ;
        StorageVmOverridesService.prototype.getGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                pageConfig: {
                    hidePager: true
                },
                resizable: true,
                data: [],
                selectedItems: [],
                columnDefs: this.getAllColumnDefs(),
                height: "100%",
                actionBarOptions: {
                    actions: []
                },
                showCheckboxesOnMultiSelection: false
            };
        };
        StorageVmOverridesService.prototype.getAllColumnDefs = function () {
            return [
                {
                    displayName: this.getString("vmOverrides.vmNameHeaderText"),
                    field: "vm.name",
                    type: "string",
                    template: this.renderVmLink.bind(this)
                },
                {
                    displayName: this.getString("vmOverrides.sdrsAutomationLevelHeaderText"),
                    field: "drsAutomationLevelText",
                    type: "string",
                    template: "<span title='#:sdrsAutomationLevelText#'>#:sdrsAutomationLevelText#</span>"
                },
                {
                    displayName: this.getString("vmOverrides.intraVmAffinityHeaderText"),
                    field: "intraVmAffinityText",
                    type: "string",
                    template: "<span title='#:intraVmAffinityText#'>#:intraVmAffinityText#</span>"
                }
            ];
        };
        StorageVmOverridesService.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        StorageVmOverridesService.prototype.renderVmLink = function (dataItem) {
            var objectLinkRenderer = this.columnRenderersRegistry.getColumnRenderer("object-link");
            var vmRef = this.defaultUriSchemeUtil.getVsphereObjectId(dataItem.vm.provider);
            var icon = dataItem.vm.iconId;
            return objectLinkRenderer(["vmRef", "name", icon], {
                vmRef: vmRef,
                name: dataItem.vm.name,
                iconId: icon
            });
        };
        StorageVmOverridesService.prototype.removeVmOverride = function (dsClusterId, removeSpec) {
            var operation = this.dsClusterConstants.vmOverridesOperationType.REMOVE;
            this.changeVmOverride(dsClusterId, removeSpec, operation);
        };
        StorageVmOverridesService.prototype.validateVmOverride = function (dsClusterId, spec) {
            return this.mutationService.validate(dsClusterId, 'com.vmware.vsphere.client.dscluster.VmOverridesReconfigureSpec', spec);
        };
        StorageVmOverridesService.prototype.getVmOverrideErrorMessages = function (errorMessages) {
            var errorMessagesAsString = this.buildErrorMessages(errorMessages);
            var alert = {
                text: this.i18nService.getString("DsClusterUi", "vmOverrides.conflicting.vms.rule.description", errorMessagesAsString),
                type: this.vuiConstants.validationBanner.type.ERROR
            };
            return alert;
        };
        StorageVmOverridesService.prototype.getEditVmOverridesDialogTitle = function (selectedVms) {
            var numberOfSelectedVms = selectedVms.length;
            var title = numberOfSelectedVms > 1 ?
                this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.titleLabel", numberOfSelectedVms) :
                this.i18nService.getString("DsClusterUi", "vmOverrides.config.edit.titleLabel");
            return title;
        };
        StorageVmOverridesService.prototype.buildErrorMessages = function (errorMessages) {
            var _this = this;
            var errorMessage = "";
            if (!_.isEmpty(errorMessages)) {
                _.each(errorMessages, function (item) {
                    var singleError = _this.i18nService.getString("DsClusterUi", "vmOverrides.conflicting.vms.rule.item", item.name);
                    errorMessage = errorMessage.concat(singleError);
                });
                var indexOfFirstComma = errorMessage.indexOf(",");
                // it is index +2 because the error string now begins with comma and space as
                // ", ".
                errorMessage = errorMessage.substring(indexOfFirstComma + 2);
            }
            return errorMessage;
        };
        StorageVmOverridesService.prototype.changeVmOverride = function (dsClusterId, spec, operation) {
            this.mutationService.apply(dsClusterId, 'com.vmware.vsphere.client.dscluster.VmOverridesReconfigureSpec', spec, operation);
        };
        StorageVmOverridesService.$inject = ["i18nService", "dataService", "vuiConstants",
            "defaultUriSchemeUtil", "columnRenderersRegistry", "mutationService",
            "dsClusterConstants"];
        return StorageVmOverridesService;
    }());
    ds_cluster_ui.StorageVmOverridesService = StorageVmOverridesService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("storageVmOverridesService", StorageVmOverridesService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    /**
     * Builds all the edit SDRS dialog page models and submits the edited SDRS data to the
     * server.
     */
    var SdrsDialogManager = (function () {
        function SdrsDialogManager(i18nService, mutationService, vuiConstants, $q, dsClusterSpecBuilderService, dsClusterConstants, advancedOptionsBuilderFactory) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.vuiConstants = vuiConstants;
            this.$q = $q;
            this.dsClusterSpecBuilderService = dsClusterSpecBuilderService;
            this.dsClusterConstants = dsClusterConstants;
            this.advancedOptionsBuilderFactory = advancedOptionsBuilderFactory;
            this.isFormValid = true;
        }
        SdrsDialogManager.prototype.initManager = function (sdrsData, sdrsDialogOptions) {
            this.sdrsDialogOptions = sdrsDialogOptions;
            this.sdrsData = sdrsData;
            this.createPages();
        };
        SdrsDialogManager.prototype.getPageDefinitions = function () {
            return [this.storageDrsAutomationPageDef, this.storageDrsRuntimeSettingsPageDef,
                this.storageDrsAdvancedOptionsPageDef];
        };
        SdrsDialogManager.prototype.submit = function () {
            var _this = this;
            var dsClusterId = this.sdrsDialogOptions.dialogData.objectId;
            var dsClusterSpec = this.getDsClusterReconfigureSpec();
            return this.validate(dsClusterId)
                .then(function () {
                _this.mutationService.apply(dsClusterId, _this.dsClusterConstants.DS_CLUSTER_SPEC_TYPE, dsClusterSpec).then(function () {
                    return true;
                });
                return true;
            });
        };
        SdrsDialogManager.prototype.setFormValidationResult = function (isValid) {
            this.isFormValid = isValid;
        };
        SdrsDialogManager.prototype.getSheduleModel = function () {
            return {
                storageDrsAutomationMode: this.getStorageDrsAutomationModel(),
                storageDrsRuntimeSettingsModel: this.getStorageDrsRuntimeSettingsModel(),
                storageDrsAdvancedOptionsModel: this.getStorageDrsAdvancedOptionsModel()
            };
        };
        SdrsDialogManager.prototype.validate = function (dsClusterId) {
            this.sdrsDialogOptions.alerts = [];
            this.sdrsDialogOptions.isAlertClosed = false;
            if (!this.isFormValid) {
                return this.$q.reject();
            }
            var dsClusterVmAffinityValidationSpec = {
                defaultIntraVmAffinity: this.getStorageDrsAdvancedOptionsModel()
                    .defaultIntraVmAffinity
            };
            return this.mutationService.validate(dsClusterId, this.dsClusterConstants.DS_CLUSTER_VM_AFFINITY_VALIDATION_SPEC, dsClusterVmAffinityValidationSpec)
                .then(this.handleValidationResult.bind(this));
        };
        SdrsDialogManager.prototype.handleValidationResult = function (validationResult) {
            if (validationResult) {
                if (validationResult.result.conflictingVmdkAARules.length !== 0) {
                    this.setValidationError(this.i18nService.getString("DsClusterUi", "sdrs.config.defaultVmAff.disable.conflictingVmdkAARule.descFormat", validationResult.result.conflictingVmdkAARules[0]));
                    return this.$q.reject();
                }
                if (validationResult.result.conflictingVmAARules.length !== 0) {
                    this.setValidationError(this.i18nService.getString("DsClusterUi", "sdrs.config.defaultVmAff.disable.conflictingVmAARule.descFormat", validationResult.result.conflictingVmAARules[0]));
                    return this.$q.reject();
                }
            }
            return this.$q.resolve();
        };
        SdrsDialogManager.prototype.setValidationError = function (validationErrorText) {
            this.sdrsDialogOptions.alerts = [{
                    type: this.vuiConstants.validationBanner.type.ERROR,
                    text: validationErrorText
                }];
            this.sdrsDialogOptions.isAlertClosed = false;
        };
        SdrsDialogManager.prototype.getStorageDrsAutomationModel = function () {
            if (!this.storageDrsAutomationPageDef.model) {
                this.buildStorageDrsAutomationModel();
            }
            return this.storageDrsAutomationPageDef.model;
        };
        SdrsDialogManager.prototype.getStorageDrsRuntimeSettingsModel = function () {
            if (!this.storageDrsRuntimeSettingsPageDef.model) {
                this.buildStorageDrsRuntimeSettingsModel();
            }
            return this.storageDrsRuntimeSettingsPageDef.model;
        };
        SdrsDialogManager.prototype.getStorageDrsAdvancedOptionsModel = function () {
            if (!this.storageDrsAdvancedOptionsPageDef.model) {
                this.buildStorageDrsAdvancedOptionsModel();
            }
            return this.storageDrsAdvancedOptionsPageDef.model;
        };
        SdrsDialogManager.prototype.getFormData = function () {
            return this.getDsClusterReconfigureModel();
        };
        SdrsDialogManager.prototype.createPages = function () {
            this.storageDrsAutomationPageDef = {
                id: "storageDrsAutomation",
                title: this.i18nService.getString("DsClusterUi", "sdrs.config.automationLabel"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/services/editSdrs/storageDrsAutomationPageView.html"
            };
            this.storageDrsRuntimeSettingsPageDef = {
                id: "storageDrsRuntimeSettings",
                title: this.i18nService.getString("DsClusterUi", "sdrs.config.runtimeSettingsLabel"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/services/editSdrs/storageDrsRuntimeSettingsPageView.html"
            };
            this.storageDrsAdvancedOptionsPageDef = {
                id: "storageDrsAdvancedOptions",
                title: this.i18nService.getString("DsClusterUi", "sdrs.config.advancedOptions"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/services/editSdrs/storageDrsAdvancedOptionsPageView.html"
            };
        };
        SdrsDialogManager.prototype.buildStorageDrsAutomationModel = function () {
            this.storageDrsAutomationPageDef.model = {
                sdrsEnabled: this.sdrsData.enabled,
                defaultVmBehavior: this.sdrsData.defaultVmBehavior,
                automationOverrides: this.getAutomationOverridesModel(this.sdrsData.automationOverrides)
            };
        };
        SdrsDialogManager.prototype.buildStorageDrsRuntimeSettingsModel = function () {
            this.storageDrsRuntimeSettingsPageDef.model = {
                ioLoadBalanceEnabled: this.sdrsData.ioLoadBalanceEnabled,
                ioLatencyThreshold: this.sdrsData.ioLatencyThreshold,
                spaceLoadBalanceConfig: {
                    spaceUtilizationThreshold: this.sdrsData.spaceUtilizationThreshold,
                    freeSpaceThresholdGB: this.sdrsData.freeSpaceThresholdGB,
                    spaceThresholdMode: this.sdrsData.spaceThresholdMode
                },
                minDatastoreCapacityGB: this.sdrsData.minDatastoreCapacityGB
            };
        };
        SdrsDialogManager.prototype.getAutomationOverridesModel = function (automationOverrides) {
            var automationOverridesData = automationOverrides || {
                ioLoadBalanceAutomationMode: null,
                policyEnforcementAutomationMode: null,
                ruleEnforcementAutomationMode: null,
                spaceLoadBalanceAutomationMode: null,
                vmEvacuationAutomationMode: null
            };
            return _.mapObject(automationOverridesData, function (automationOverride) {
                return { id: automationOverride };
            });
        };
        SdrsDialogManager.prototype.getSpaceLoadBalanceConfigModel = function () {
            var spaceLoadBalanceConfigData = {
                spaceThresholdMode: this.dsClusterConstants.SDRS_SPACE_THRESHOLD_UTILIZATION,
                spaceUtilizationThreshold: this.dsClusterConstants.spaceUtilizationThreshold.DEFAULT,
                freeSpaceThresholdGB: this.dsClusterConstants.freeSpaceThresholdGB.MIN
            };
            return spaceLoadBalanceConfigData;
        };
        SdrsDialogManager.prototype.buildStorageDrsAdvancedOptionsModel = function () {
            var ioLoadImbalanceThreshold = this.sdrsData.ioLoadImbalanceThreshold;
            if (ioLoadImbalanceThreshold === 0) {
                ioLoadImbalanceThreshold = this.dsClusterConstants.loadBalanceIoThreshold.DEFAULT;
            }
            this.storageDrsAdvancedOptionsPageDef.model = {
                defaultIntraVmAffinity: this.sdrsData.defaultIntraVmAffinity,
                convertedLoadBalanceInterval: this.sdrsData.convertedLoadBalanceInterval,
                loadBalanceInterval: this.sdrsData.loadBalanceInterval,
                ioLoadImbalanceThreshold: ioLoadImbalanceThreshold,
                spaceLoadBalanceConfig: {
                    minSpaceUtilizationDifference: this.sdrsData.minSpaceUtilizationDifference
                },
                advancedOptions: this.advancedOptionsBuilderFactory
                    .getBuilder(this.sdrsData.advancedOptions, false)
            };
        };
        SdrsDialogManager.prototype.getDsClusterReconfigureModel = function () {
            // build spaceLoadBalanceConfig part of model separately because runtime settings
            // and advanced options pages both use spaceLoadBalanceConfig
            var spaceLoadBalanceConfig = _.extend({}, this.getStorageDrsRuntimeSettingsModel().spaceLoadBalanceConfig, this.getStorageDrsAdvancedOptionsModel().spaceLoadBalanceConfig);
            var sdrsFormModel = _.extend({}, this.storageDrsAutomationPageDef.model || {}, this.storageDrsRuntimeSettingsPageDef.model || {}, this.storageDrsAdvancedOptionsPageDef.model || {});
            sdrsFormModel.spaceLoadBalanceConfig = spaceLoadBalanceConfig;
            return sdrsFormModel;
        };
        SdrsDialogManager.prototype.getDsClusterReconfigureSpec = function () {
            return this.dsClusterSpecBuilderService.buildDsClusterSpec(this.getDsClusterReconfigureModel(), true);
        };
        SdrsDialogManager.$inject = ["i18nService", "mutationService", "vuiConstants", "$q",
            "dsClusterSpecBuilderService", "dsClusterConstants",
            "advancedOptionsBuilderFactory"];
        return SdrsDialogManager;
    }());
    ds_cluster_ui.SdrsDialogManager = SdrsDialogManager;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("sdrsDialogManager", SdrsDialogManager);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    /**
     * Opens Edit SDRS dialog as a multi page dialog.
     */
    var SdrsDialogService = (function () {
        function SdrsDialogService(sdrsDialogManager, i18nService, clarityModalService) {
            this.sdrsDialogManager = sdrsDialogManager;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        SdrsDialogService.prototype.show = function (dsClusterId) {
            var _this = this;
            var sdrsData = {};
            var modalOptions = {};
            this.sdrsDialogManager.initManager(sdrsData, modalOptions);
            _.extend(modalOptions, {
                title: this.i18nService.getString("DsClusterUi", "sdrs.dialog.edit.title"),
                subTitle: {
                    objectId: dsClusterId
                },
                defaultButton: "submit",
                contentTemplate: "ds-cluster-ui/resources/ds-cluster/views/settings/services/editSdrs/editSdrsDialog.html",
                size: "lg",
                onSubmit: function () {
                    return _this.sdrsDialogManager.submit();
                },
                modalClass: "ds-cluster-edit-sdrs-dialog-modal",
                dialogData: {
                    sdrsData: sdrsData,
                    manager: this.sdrsDialogManager,
                    objectId: dsClusterId
                }
            });
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        SdrsDialogService.$inject = ["sdrsDialogManager", "i18nService", "clarityModalService"];
        return SdrsDialogService;
    }());
    ds_cluster_ui.SdrsDialogService = SdrsDialogService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("sdrsDialogService", SdrsDialogService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsAdvancedOptionsService = (function () {
        function StorageDrsAdvancedOptionsService(i18nService, dsClusterConstants) {
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
        }
        StorageDrsAdvancedOptionsService.prototype.getUnitOptions = function () {
            return [
                {
                    label: this.i18nService.getString("DsClusterUi", "TIME_MINUTES"),
                    multiplier: 1
                }, {
                    label: this.i18nService.getString("DsClusterUi", "TIME_HOURS"),
                    multiplier: this.dsClusterConstants.loadBalanceInterval.HOUR_MINUTES
                }, {
                    label: this.i18nService.getString("DsClusterUi", "TIME_DAYS"),
                    multiplier: this.dsClusterConstants.loadBalanceInterval.DAY_MINUTES
                }
            ];
        };
        StorageDrsAdvancedOptionsService.prototype.getIntervalOptions = function (pageModel) {
            // TODO cpournaris: get PO feedback on the current value selection.
            var loadBalanceInterval = pageModel.loadBalanceInterval;
            return {
                "current": {
                    name: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.loadBalanceInterval.Current"),
                    value: loadBalanceInterval,
                    formattedValue: pageModel.convertedLoadBalanceInterval.value +
                        " " + this.i18nService.getString("DsClusterUi", pageModel.convertedLoadBalanceInterval.unitKey).toLocaleLowerCase(),
                    unit: pageModel.convertedLoadBalanceInterval.unit
                },
                "minimum": {
                    name: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.loadBalanceInterval.Minimum"),
                    value: this.dsClusterConstants.loadBalanceInterval.MIN_HOURS *
                        this.dsClusterConstants.loadBalanceInterval.HOUR_MINUTES,
                    formattedValue: this.i18nService.getString("Common", "hour", this.dsClusterConstants.loadBalanceInterval.MIN_HOURS, 1),
                    unit: this.i18nService.getString("DsClusterUi", "TIME_HOURS")
                },
                "maximum": {
                    name: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.loadBalanceInterval.Maximum"),
                    value: this.dsClusterConstants.loadBalanceInterval.DAY_MINUTES *
                        this.dsClusterConstants.loadBalanceInterval.MAX_DAYS,
                    formattedValue: this.i18nService.getString("Common", "days", this.dsClusterConstants.loadBalanceInterval.MAX_DAYS),
                    unit: this.i18nService.getString("DsClusterUi", "TIME_DAYS")
                }
            };
        };
        StorageDrsAdvancedOptionsService.prototype.getErrorMessages = function () {
            var errorMessage = this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.loadBalanceInterval.errorRange", this.dsClusterConstants.loadBalanceInterval.MIN_HOURS, this.dsClusterConstants.loadBalanceInterval.MAX_DAYS);
            return {
                min: errorMessage,
                max: errorMessage
            };
        };
        StorageDrsAdvancedOptionsService.prototype.getIoImbalanceThresholdSliderOptions = function (value, dragHandleTitle) {
            return {
                value: value,
                min: this.dsClusterConstants.loadBalanceIoThreshold.MIN,
                max: this.dsClusterConstants.loadBalanceIoThreshold.MAX,
                minLabel: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.ioLoadImbalance.minUnit"),
                maxLabel: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.advancedOptions.ioLoadImbalance.maxUnit"),
                enabled: true,
                width: "auto",
                dragHandleTitle: dragHandleTitle
            };
        };
        StorageDrsAdvancedOptionsService.$inject = ["i18nService", "dsClusterConstants"];
        return StorageDrsAdvancedOptionsService;
    }());
    ds_cluster_ui.StorageDrsAdvancedOptionsService = StorageDrsAdvancedOptionsService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("storageDrsAdvancedOptionsService", StorageDrsAdvancedOptionsService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsAutomationService = (function () {
        function StorageDrsAutomationService(dsClusterConstants, storageDrsLocalizationService) {
            this.dsClusterConstants = dsClusterConstants;
            this.storageDrsLocalizationService = storageDrsLocalizationService;
        }
        StorageDrsAutomationService.prototype.getSdrsAutomationLevels = function (sectionLabel) {
            return [{
                    id: this.dsClusterConstants.SDRS_MANUAL,
                    label: this.storageDrsLocalizationService
                        .getAutomationLevelTextLocalization(this.dsClusterConstants.SDRS_MANUAL),
                    description: this.storageDrsLocalizationService
                        .getAutomationLevelDescriptionLocalization(this.dsClusterConstants.SDRS_MANUAL),
                    sectionLabel: sectionLabel
                }, {
                    id: this.dsClusterConstants.SDRS_FULLAUTO,
                    label: this.storageDrsLocalizationService
                        .getAutomationLevelTextLocalization(this.dsClusterConstants.SDRS_FULLAUTO),
                    description: this.storageDrsLocalizationService
                        .getAutomationLevelDescriptionLocalization(this.dsClusterConstants.SDRS_FULLAUTO),
                    sectionLabel: sectionLabel
                }];
        };
        StorageDrsAutomationService.prototype.getSdrsAutomationOverridesOptions = function () {
            return [{
                    id: null,
                    label: this.storageDrsLocalizationService
                        .getAutomationLevelTextLocalization(null)
                }, {
                    id: this.dsClusterConstants.SDRS_MANUAL,
                    label: this.storageDrsLocalizationService
                        .getAutomationLevelTextLocalization(this.dsClusterConstants.SDRS_MANUAL)
                }, {
                    id: this.dsClusterConstants.SDRS_FULLAUTO,
                    label: this.storageDrsLocalizationService
                        .getAutomationLevelTextLocalization(this.dsClusterConstants.SDRS_FULLAUTO)
                }];
        };
        StorageDrsAutomationService.$inject = ["dsClusterConstants", "storageDrsLocalizationService"];
        return StorageDrsAutomationService;
    }());
    ds_cluster_ui.StorageDrsAutomationService = StorageDrsAutomationService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("storageDrsAutomationService", StorageDrsAutomationService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsDataRetrieval = (function () {
        function StorageDrsDataRetrieval(storageDrsLocalizationService, dataService, dsClusterConstants) {
            this.storageDrsLocalizationService = storageDrsLocalizationService;
            this.dataService = dataService;
            this.dsClusterConstants = dsClusterConstants;
        }
        /**
         * Fetches the SDRS settings for the given datastore cluster.
         *
         * @param objectId
         * @returns {any}
         */
        StorageDrsDataRetrieval.prototype.retrieveData = function (objectId) {
            var _this = this;
            return this.dataService.getData(objectId, "com.vmware.vsphere.client.dsclusterui.model.ClusterStorageDrsConfiguration")
                .then(function (sdrsData) {
                if (sdrsData) {
                    sdrsData.automationOverrides = sdrsData.automationOverrides || {};
                    return {
                        enabled: sdrsData.enabled,
                        automationLevelText: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.defaultVmBehavior),
                        automationLevelDescription: _this.storageDrsLocalizationService
                            .getAutomationLevelDescriptionLocalization(sdrsData.defaultVmBehavior),
                        spaceLoadBalanceAutomationMode: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.automationOverrides
                            .spaceLoadBalanceAutomationMode),
                        ioLoadBalanceAutomationMode: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.automationOverrides
                            .ioLoadBalanceAutomationMode),
                        ruleEnforcementAutomationMode: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.automationOverrides
                            .ruleEnforcementAutomationMode),
                        policyEnforcementAutomationMode: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.automationOverrides
                            .policyEnforcementAutomationMode),
                        vmEvacuationAutomationMode: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.automationOverrides
                            .vmEvacuationAutomationMode),
                        spaceThreshold: _this.storageDrsLocalizationService
                            .getSpaceThresholdText(sdrsData.spaceThresholdMode, sdrsData.freeSpaceThresholdGB, sdrsData.spaceUtilizationThreshold),
                        ioMetricInclusion: _this.storageDrsLocalizationService
                            .getIoMetricInclusionText(sdrsData.ioLoadBalanceEnabled),
                        ioMetricInclusionDescription: _this.storageDrsLocalizationService
                            .getIoMetricInclusionDescription(sdrsData.ioLoadBalanceEnabled),
                        ioLatencyThreshold: _this.storageDrsLocalizationService
                            .getIoLatencyThresholdText(sdrsData.ioLatencyThreshold),
                        defaultIntraVmAffinity: _this.storageDrsLocalizationService
                            .getDefaultIntraVmAffinityText(sdrsData.defaultIntraVmAffinity),
                        ioLoadImbalanceThreshold: sdrsData.ioLoadImbalanceThreshold ?
                            sdrsData.ioLoadImbalanceThreshold :
                            _this.dsClusterConstants.loadBalanceIoThreshold.DEFAULT,
                        minSpaceUtilizationDifference: _this.storageDrsLocalizationService
                            .getMinSpaceUtilizationDifferenceText(sdrsData
                            .minSpaceUtilizationDifference),
                        loadBalanceInterval: sdrsData.loadBalanceInterval,
                        advancedOptions: _this.storageDrsLocalizationService
                            .getAdvancedOptions(sdrsData.advancedOptions)
                    };
                }
                return {};
            });
        };
        /**
         * Fetches the SDRS portlet settings for the given datastore cluster.
         *
         * @param objectId
         * @returns {any}
         */
        StorageDrsDataRetrieval.prototype.retrievePortletData = function (objectId) {
            var _this = this;
            return this.dataService.getData(objectId, "com.vmware.vsphere.client.dsclusterui.model.ClusterStorageDrsPortletData")
                .then(function (sdrsData) {
                if (sdrsData) {
                    return {
                        enabled: sdrsData.enabled,
                        automationLevelText: _this.storageDrsLocalizationService
                            .getAutomationLevelTextLocalization(sdrsData.defaultVmBehavior),
                        ioMetricInclusion: _this.storageDrsLocalizationService
                            .getIoMetricInclusion(sdrsData.ioLoadBalanceEnabled),
                        spaceThreshold: _this.storageDrsLocalizationService
                            .getPortletSpaceThresholdText(sdrsData.spaceLoadBalanceConfig),
                        ioLatencyThreshold: _this.storageDrsLocalizationService
                            .getIoLatencyThresholdText(sdrsData.ioLatencyThreshold),
                        recommendationsCount: sdrsData.recommendationsCount,
                        faultsCount: sdrsData.faultsCount
                    };
                }
                return {};
            });
        };
        StorageDrsDataRetrieval.$inject = ["storageDrsLocalizationService", "dataService",
            "dsClusterConstants"];
        return StorageDrsDataRetrieval;
    }());
    ds_cluster_ui.StorageDrsDataRetrieval = StorageDrsDataRetrieval;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("storageDrsDataRetrieval", StorageDrsDataRetrieval);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsLocalizationService = (function () {
        function StorageDrsLocalizationService(i18nService, dsClusterConstants) {
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
        }
        /**
         * Retrieves the localized description text based on the automation level passed.
         *
         * @param automationLevel
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getAutomationLevelDescriptionLocalization = function (automationLevel) {
            var localizedAutomationLevelDescription = "";
            switch (automationLevel) {
                case this.dsClusterConstants.SDRS_MANUAL:
                    localizedAutomationLevelDescription =
                        this.getString("sdrs.config.automationLevel.manualDescription");
                    break;
                case this.dsClusterConstants.SDRS_FULLAUTO:
                    localizedAutomationLevelDescription =
                        this.getString("sdrs.config.automationLevel.fullautoDescription");
                    break;
            }
            return localizedAutomationLevelDescription;
        };
        /**
         * Retrieves the localized text based on the automation level passed.
         *
         * @param automationLevel
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getAutomationLevelTextLocalization = function (automationLevel) {
            var localizedAutomationLevelText = "";
            switch (automationLevel) {
                case this.dsClusterConstants.SDRS_MANUAL:
                    localizedAutomationLevelText =
                        this.getString("sdrs.config.automationLevel.manual");
                    break;
                case this.dsClusterConstants.SDRS_FULLAUTO:
                    localizedAutomationLevelText =
                        this.getString("sdrs.config.automationLevel.fullauto");
                    break;
                case null:
                    localizedAutomationLevelText =
                        this.getString("sdrs.config.automationLevel.useClusterAutomationLabel");
                    break;
            }
            return localizedAutomationLevelText;
        };
        /**
         * Retrieves the localized text based on the space load balance configuration
         * passed.
         *
         * @param spaceLoadBalanceConfig
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getSpaceThresholdText = function (spaceThresholdMode, freeSpaceThresholdGB, spaceUtilizationThreshold) {
            var spaceThresholdText = "";
            switch (spaceThresholdMode) {
                case this.dsClusterConstants.SDRS_SPACE_THRESHOLD_FREE_SPACE:
                    spaceThresholdText = this.getString("sdrs.config.spaceThreshold.minFreeSpaceFormat", freeSpaceThresholdGB);
                    break;
                case this.dsClusterConstants.SDRS_SPACE_THRESHOLD_UTILIZATION:
                    spaceThresholdText = this.getString("sdrs.config.spaceThreshold.utlizedSpaceFormat", spaceUtilizationThreshold);
                    break;
            }
            return spaceThresholdText;
        };
        /**
         * Retrieves the localized text based on the IO load balance configuration
         * passed.
         *
         * @param ioLoadBalanceEnabled
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getIoMetricInclusionText = function (ioLoadBalanceEnabled) {
            if (ioLoadBalanceEnabled) {
                return this.getString("sdrs.config.ioLoadBalanceEnabled");
            }
            else {
                return this.getString("sdrs.config.ioLoadBalanceDisabled");
            }
        };
        /**
         * Retrieves the localized description based on the IO balance configuration
         * passed.
         *
         * @param ioLoadBalanceEnabled
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getIoMetricInclusionDescription = function (ioLoadBalanceEnabled) {
            if (ioLoadBalanceEnabled) {
                return this.getString("sdrs.config.ioLoadBalanceEnabled.description");
            }
            else {
                return this.getString("sdrs.config.ioLoadBalanceDisabled.description");
            }
        };
        /**
         * Retrieves the localized description based on the IO latency threshold
         * configuration passed.
         *
         * @param ioLatencyThreshold
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getIoLatencyThresholdText = function (ioLatencyThreshold) {
            return this.getString("sdrs.config.ioLatencyThresholdText.format", ioLatencyThreshold);
        };
        /**
         * Retrieves the localized text based on the min space utilization difference
         * passed.
         *
         * @param minSpaceUtilizationDifference
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getMinSpaceUtilizationDifferenceText = function (minSpaceUtilizationDifference) {
            return this.getString("sdrs.config.minSpaceUtilizationDifference.format", minSpaceUtilizationDifference);
        };
        /**
         * Retrieves the localized text based on the default intra vm affinity
         * configuration passed.
         *
         * @param defaultIntraVmAffinity
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getDefaultIntraVmAffinityText = function (defaultIntraVmAffinity) {
            if (defaultIntraVmAffinity) {
                return this.getString("sdrs.config.advancedOptions.keepVmdskTogether.yes.label");
            }
            else {
                return this.getString("sdrs.config.advancedOptions.keepVmdskTogether.no.label");
            }
        };
        /**
         * Retrieves mapping for advanced options.
         *
         * @param advancedOptions
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getAdvancedOptions = function (advancedOptions) {
            return _.map(advancedOptions, function (advancedOption) {
                return {
                    _type: "com.vmware.vim.binding.vim.option.OptionValue",
                    key: advancedOption.key,
                    value: advancedOption.value
                };
            });
        };
        /**
         * Retrieves the localized summary portlet metric text based on the IO balance
         * configuration passed.
         *
         * @param ioLoadBalanceEnabled
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getIoMetricInclusion = function (ioLoadBalanceEnabled) {
            if (ioLoadBalanceEnabled) {
                return this.getString("dscluster.services.iometrics.true");
            }
            else {
                return this.getString("dscluster.services.iometrics.false");
            }
        };
        /**
         * Retrieves the localized summary portlet text based on the space load balance
         * configuration passed.
         *
         * @param ioLoadBalanceEnabled
         * @returns {string}
         */
        StorageDrsLocalizationService.prototype.getPortletSpaceThresholdText = function (spaceLoadBalanceConfig) {
            spaceLoadBalanceConfig = spaceLoadBalanceConfig || {};
            switch (spaceLoadBalanceConfig.spaceThresholdMode) {
                case this.dsClusterConstants.SDRS_SPACE_THRESHOLD_FREE_SPACE:
                    return this.getString("dscluster.services.spaceThreshold.minFreeSpaceFormat", spaceLoadBalanceConfig.freeSpaceThresholdGB);
                case this.dsClusterConstants.SDRS_SPACE_THRESHOLD_UTILIZATION:
                    return this.getString("dscluster.services.spaceThreshold.utlizedSpaceFormat", spaceLoadBalanceConfig.spaceUtilizationThreshold);
            }
        };
        StorageDrsLocalizationService.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        StorageDrsLocalizationService.$inject = ["i18nService", "dsClusterConstants"];
        return StorageDrsLocalizationService;
    }());
    ds_cluster_ui.StorageDrsLocalizationService = StorageDrsLocalizationService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("storageDrsLocalizationService", StorageDrsLocalizationService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    //TODO move to a common module
    var WizardPageControllerAbstract = (function () {
        function WizardPageControllerAbstract(createDsClusterWizardManager, simpleValidationCommit) {
            this.createDsClusterWizardManager = createDsClusterWizardManager;
            this.simpleValidationCommit = simpleValidationCommit;
            this.wizardConfig = this.createDsClusterWizardManager.getWizardConfig();
        }
        /**
         * Initializes the onCommit function of a specific page.
         */
        WizardPageControllerAbstract.prototype.initPageSubmit = function () {
            var self = this;
            this.createDsClusterWizardManager.getPageDefinitions()[self.getCurrentPageIndex()].onCommit =
                self.simpleValidationCommit(function () {
                    return self.getValidationErrors();
                }, self.wizardConfig);
        };
        /**
         * Updates the state of a specific page of the wizard.
         *
         * @param pageState
         */
        WizardPageControllerAbstract.prototype.setWizardPageState = function (pageState) {
            this.wizardConfig.pages[this.getCurrentPageIndex()].state = pageState;
        };
        return WizardPageControllerAbstract;
    }());
    ds_cluster_ui.WizardPageControllerAbstract = WizardPageControllerAbstract;
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var DatastoresPageController = (function (_super) {
        __extends(DatastoresPageController, _super);
        function DatastoresPageController($scope, createDsClusterWizardManager, simpleValidationCommit, vuiConstants, i18nService, $q, createDsClusterWizardDatastoresService, $compile, createDsClusterPageConstants, defaultUriSchemeUtil) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.$q = $q;
            this.createDsClusterWizardDatastoresService = createDsClusterWizardDatastoresService;
            this.$compile = $compile;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.initPageSubmit();
            this.initModel();
        }
        DatastoresPageController.prototype.getValidationErrors = function () {
            var _this = this;
            if (this.$scope.model.datastores.length <= 0) {
                return this.$q.resolve([this.i18nService.getString("DsClusterUi", "createDsClusterWizard.selectDatastoresPage.noDatastoreSelectedErrorMessage")]);
            }
            var invalidType = _.some(this.$scope.model.datastoreDetails, function (datastore) { return _this.$scope.model.datastoreDetails[0].type !== datastore.type; });
            if (invalidType) {
                return this.$q.resolve([this.i18nService.getString("DsClusterUi", "createDsClusterWizard.selectDatastoresPage.mixedTypeDatastoresErroroMessage")]);
            }
            return this.$q.reject();
        };
        DatastoresPageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.DATASTORES_INDEX;
        };
        DatastoresPageController.prototype.initModel = function () {
            var self = this;
            this.$scope.model = this.createDsClusterWizardManager.getModel();
            var datacenterId = this.$scope.model.objectId;
            this.dsFilterOptions = this.createDsClusterWizardDatastoresService.getOptions();
            this.config = self.getObjectSelectorConfig(datacenterId);
            // update the object selector filter config
            this.$scope.$watch("model.dsFilter.filterId", function () {
                self.config.listTabConfig.listConfig[0].filterId =
                    self.$scope.model.dsFilter.filterId;
            });
            self.$scope.$watch("model.datastores", function () {
                self.getValidationErrors().then(function () {
                    self.setWizardPageState(self.vuiConstants.wizard.pageState.INCOMPLETE);
                }, function () {
                    self.setWizardPageState(self.vuiConstants.wizard.pageState.COMPLETED);
                });
            });
        };
        DatastoresPageController.prototype.getObjectSelectorConfig = function (datacenterId) {
            var _this = this;
            return {
                contextObject: datacenterId,
                multipleSelect: true,
                listTabConfig: {
                    listConfig: [{
                            label: this.i18nService.getString("Common", "typeResource.datastorePlural"),
                            listViewId: "vsphere.core.datastore.simplified.list",
                            dataModels: ["Datastore"],
                            filterId: this.$scope.model.dsFilter.filterId,
                            filterParams: this.$scope.model.hostsAndClusters,
                            propertyParams: [{
                                    _type: "com.vmware.vise.mvc.model.data.ParamSpec",
                                    propertyName: "hostConnectionStatus",
                                    parameterType: "com.vmware.vsphere.client.dsclusterui.model.DsHostsConnectionStatusSpec",
                                    parameter: {
                                        _type: "com.vmware.vsphere.client.dsclusterui.model.DsHostsConnectionStatusSpec",
                                        hostsAndClusters: _.map(this.$scope.model.hostsAndClusters, function (objectId) { return _this.defaultUriSchemeUtil
                                            .getManagedObjectReference(objectId); })
                                    }
                                }]
                        }]
                },
                selectedObjects: this.$scope.model.datastores,
                onSelectionChanged: function (newSelectedItems) {
                    _this.$scope.model.datastores = _.pluck(newSelectedItems, "id");
                    _this.createDsClusterWizardManager.setModelDatastoreRefs();
                    _this.$scope.model.datastoreDetails = _.map(newSelectedItems, function (object) {
                        return {
                            name: object.name,
                            icon: object.icon,
                            type: object.rawData.specificType,
                            capacity: object.rawData["summary.capacity.@formatted"],
                            freeSpace: object.rawData["info.freeSpace.@formatted"]
                        };
                    });
                }
            };
        };
        DatastoresPageController.$inject = ["$scope", "createDsClusterWizardManager",
            "simpleValidationCommit", "vuiConstants", "i18nService", "$q",
            "createDsClusterWizardDatastoresService", "$compile",
            "createDsClusterPageConstants", "defaultUriSchemeUtil"];
        return DatastoresPageController;
    }(WizardPageControllerAbstract));
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DatastoresPageController", DatastoresPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var DsAutomationPageController = (function (_super) {
        __extends(DsAutomationPageController, _super);
        function DsAutomationPageController(createDsClusterWizardManager, vuiConstants, simpleValidationCommit, createDsClusterPageConstants, $q) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.vuiConstants = vuiConstants;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.$q = $q;
            this.initPageSubmit();
            this.initModel();
            this.setWizardPageState(this.vuiConstants.wizard.pageState.COMPLETED);
        }
        DsAutomationPageController.prototype.getValidationErrors = function () {
            return this.$q.reject();
        };
        DsAutomationPageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.AUTOMATION_INDEX;
        };
        DsAutomationPageController.prototype.initModel = function () {
            this.model = this.createDsClusterWizardManager.getModel();
        };
        DsAutomationPageController.$inject = ["createDsClusterWizardManager", "vuiConstants",
            "simpleValidationCommit", "createDsClusterPageConstants", "$q"];
        return DsAutomationPageController;
    }(WizardPageControllerAbstract));
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsAutomationPageController", DsAutomationPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var HostsAndClustersPageController = (function (_super) {
        __extends(HostsAndClustersPageController, _super);
        function HostsAndClustersPageController($scope, createDsClusterWizardManager, simpleValidationCommit, vuiConstants, i18nService, $q, createDsClusterPageConstants) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.$q = $q;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.listLabel = this.i18nService.getString("DsClusterUi", "createDsClusterWizard.hostsAndClustersPage.title");
            this.initModel();
            this.initPageSubmit();
        }
        HostsAndClustersPageController.prototype.getValidationErrors = function () {
            if (this.$scope.model.hostsAndClusters.length <= 0) {
                return this.$q.resolve([this.i18nService.getString('DsClusterUi', 'createDsClusterWizard.hostsAndClustersPage.noHostOrClusterSelectedErrorMessage')]);
            }
            return this.$q.reject();
        };
        HostsAndClustersPageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.HOSTS_AND_CLUSTERS_INDEX;
        };
        HostsAndClustersPageController.prototype.initModel = function () {
            var _this = this;
            var self = this;
            this.$scope.model = this.createDsClusterWizardManager.getModel();
            var parentId = this.$scope.model.objectId;
            this.config = {
                contextObject: parentId,
                multipleSelect: true,
                listTabConfig: {
                    listConfig: [{
                            label: this.i18nService.getString('DsClusterUi', 'createDsClusterWizard.hostsAndClustersPage.clusters'),
                            listViewId: "vsphere.core.cluster.list",
                            dataModels: ['ClusterComputeResource'],
                            filterId: "datacenterObjectsFilter",
                            filterParams: []
                        }, {
                            label: this.i18nService.getString('DsClusterUi', 'createDsClusterWizard.hostsAndClustersPage.hosts'),
                            listViewId: "vsphere.core.host.list",
                            dataModels: ['HostSystem'],
                            filterId: "standaloneHostsFilter",
                            filterParams: []
                        }]
                },
                selectedObjects: self.$scope.model.hostsAndClusters,
                onSelectionChanged: function (newSelectedItems) {
                    self.$scope.model.hostsAndClusters = _.map(newSelectedItems, function (object) {
                        return object.id;
                    });
                }
            };
            this.$scope.$watch('model.hostsAndClusters', function () {
                _this.getValidationErrors().then(function () {
                    _this.setWizardPageState(_this.vuiConstants.wizard.pageState.INCOMPLETE);
                }, function () {
                    _this.setWizardPageState(_this.vuiConstants.wizard.pageState.COMPLETED);
                });
            });
        };
        HostsAndClustersPageController.$inject = ['$scope', 'createDsClusterWizardManager',
            'simpleValidationCommit', 'vuiConstants', 'i18nService', '$q',
            'createDsClusterPageConstants'];
        return HostsAndClustersPageController;
    }(WizardPageControllerAbstract));
    angular.module('com.vmware.vsphere.client.dsCluster')
        .controller('HostsAndClustersPageController', HostsAndClustersPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var NameAndLocationPageController = (function (_super) {
        __extends(NameAndLocationPageController, _super);
        function NameAndLocationPageController($scope, createDsClusterWizardManager, vuiConstants, dataService, simpleValidationCommit, i18nService, mutationService, $q, createDsClusterPageConstants, dsClusterConstants) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.$q = $q;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.dsClusterConstants = dsClusterConstants;
            this.initModel();
            this.initPageSubmit();
        }
        NameAndLocationPageController.prototype.getValidationErrors = function () {
            var _this = this;
            // name length check
            if (this.$scope.model.name.length <= 0) {
                return this.$q.resolve([this.i18nService.getString("DsClusterUi", "createDsClusterWizard.nameAndLocationPage.validation.nameRequired")]);
            }
            var dcName = (this.location !== undefined) ? this.location.name : "";
            var duplicateNameError = this.i18nService.getString("DsClusterUi", "createDsClusterWizard.nameAndLocationPage.validation.duplicateDsClusterName", dcName);
            var datastoreNameSpec = {
                datastoreClusterName: this.$scope.model.name
            };
            var validationPromise = this.mutationService.validate(this.dcId, this.dsClusterConstants.NAME_AND_LOCATION_VALIDATE_SPEC, datastoreNameSpec).then(function (validationResult) {
                if (!!validationResult && (!validationResult.result
                    || !!validationResult.error)) {
                    return _this.$q.resolve([duplicateNameError]);
                }
                else {
                    return _this.$q.reject();
                }
            }, function () { return _this.$q.reject(); });
            return validationPromise;
        };
        NameAndLocationPageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.NAME_AND_LOCATION_INDEX;
        };
        NameAndLocationPageController.prototype.initModel = function () {
            var _this = this;
            this.$scope.model = this.createDsClusterWizardManager.getModel();
            this.dcId = this.$scope.model.objectId;
            this.dataService.getProperties(this.dcId, ["name", "primaryIconId"])
                .then(function (data) {
                _this.location = data;
            });
            this.$scope.$watch("model.name", function () {
                _this.getValidationErrors().then(function () {
                    _this.setWizardPageState(_this.vuiConstants.wizard.pageState.INCOMPLETE);
                }, function () {
                    _this.setWizardPageState(_this.vuiConstants.wizard.pageState.COMPLETED);
                });
            });
            this.$scope.$watch("model.sdrsEnabled", function () {
                if (_this.$scope.model.sdrsEnabled !== undefined) {
                    _this.createDsClusterWizardManager.changeSdrsPagesVisibility(_this.$scope.model.sdrsEnabled);
                }
            });
        };
        NameAndLocationPageController.$inject = ["$scope", "createDsClusterWizardManager", "vuiConstants",
            "dataService", "simpleValidationCommit", "i18nService", "mutationService", "$q",
            "createDsClusterPageConstants", "dsClusterConstants"];
        return NameAndLocationPageController;
    }(WizardPageControllerAbstract));
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("NameAndLocationPageController", NameAndLocationPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var ReadyToCompletePageController = (function (_super) {
        __extends(ReadyToCompletePageController, _super);
        function ReadyToCompletePageController(createDsClusterWizardManager, vuiConstants, simpleValidationCommit, i18nService, vxPropertyViewService, columnRenderersRegistry, $q, createDsClusterWizardHostsAndClustersService, createDsClusterPageConstants, storageDrsLocalizationService, dsClusterConstants) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.$q = $q;
            this.createDsClusterWizardHostsAndClustersService = createDsClusterWizardHostsAndClustersService;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.storageDrsLocalizationService = storageDrsLocalizationService;
            this.dsClusterConstants = dsClusterConstants;
            this.initPageSubmit();
            this.initModel();
        }
        ReadyToCompletePageController.prototype.getValidationErrors = function () {
            return this.$q.reject();
        };
        ReadyToCompletePageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.READY_TO_COMPLETE_INDEX;
        };
        ReadyToCompletePageController.prototype.initModel = function () {
            var self = this;
            this.model = this.createDsClusterWizardManager.getModel();
            this.buildNameAndLocationData();
            this.buildAutomationOverridesData();
            this.buildRuntimeSettingsData();
            this.datastoresGridOptions = this.getDatastoresGridOptions();
            this.clustersAndHostsGridOptions = this.getClustersAndHostsGridOptions();
            this.createDsClusterWizardHostsAndClustersService.getHostsAndClusters(this.model.datastoreRefs, this.model.hostsAndClusters)
                .then(function (hostsAndClusters) {
                self.clustersAndHostsGridOptions.data = hostsAndClusters;
            });
        };
        ReadyToCompletePageController.prototype.buildNameAndLocationData = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("")
                .title(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.nameAndLocationPage.title"));
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.nameAndLocationPage.dsClusterNameLabel"), this.model.name);
            var sdrsLocalizedStatus = this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage."
                + (this.model.sdrsEnabled ? "sdrsEnabled" : "sdrsDisabled"));
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.sdrsLabel"), sdrsLocalizedStatus);
            this.nameAndLocationData = builder.build();
        };
        ReadyToCompletePageController.prototype.buildAutomationOverridesData = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("")
                .title(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.automationLevelPage.title"));
            var automationOverrides = this.model.automationOverrides;
            if (automationOverrides) {
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.automationLevelLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(this.model.defaultVmBehavior));
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.spaceBalanceLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(automationOverrides.spaceLoadBalanceAutomationMode.id));
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.ioBalanceLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(automationOverrides.ioLoadBalanceAutomationMode.id));
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.ruleEnforcementLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(automationOverrides.ruleEnforcementAutomationMode.id));
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.policyEnforcementLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(automationOverrides.policyEnforcementAutomationMode.id));
                sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.vmEvacuationLabel"), this.storageDrsLocalizationService
                    .getAutomationLevelTextLocalization(automationOverrides.vmEvacuationAutomationMode.id));
            }
            this.automationOverrides = builder.build();
        };
        ReadyToCompletePageController.prototype.buildRuntimeSettingsData = function () {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("")
                .title(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.title"));
            var ioLoadBalanceLocalizedStatus = this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage."
                + (this.model.ioLoadBalanceEnabled ? "ioLoadBalancingEnabled" : "ioLoadBalancingDisabled"));
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.ioLoadBalancingLabel"), ioLoadBalanceLocalizedStatus);
            var spaceThreshold = "";
            if (this.model !== undefined && this.model.spaceLoadBalanceConfig !== undefined
                && this.model.spaceLoadBalanceConfig.spaceThresholdMode ===
                    this.dsClusterConstants.SDRS_SPACE_THRESHOLD_UTILIZATION) {
                spaceThreshold = this.i18nService.getString("DsClusterUi", "sdrs.config.spaceThreshold.utlizedSpaceFormat", this.model.spaceLoadBalanceConfig.spaceUtilizationThreshold);
            }
            else if (this.model !== undefined && this.model.spaceLoadBalanceConfig !== undefined
                && this.model.spaceLoadBalanceConfig.spaceThresholdMode ===
                    this.dsClusterConstants.SDRS_SPACE_THRESHOLD_FREE_SPACE) {
                spaceThreshold = this.i18nService.getString("DsClusterUi", "sdrs.config.spaceThreshold.minFreeSpaceFormat", this.model.spaceLoadBalanceConfig.freeSpaceThresholdGB);
            }
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.spaceThreshold.label"), spaceThreshold);
            sectionBuilder.property(this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.ioLatencyThreshold.label"), this.i18nService.getString("DsClusterUi", "createDsClusterWizard.runtimeSettingsPage.ioLatencyThreshold.format", this.model.ioLatencyThreshold));
            this.runtimeSettings = builder.build();
        };
        ReadyToCompletePageController.prototype.getDatastoresGridOptions = function () {
            return {
                searchable: false,
                resizable: false,
                selectable: false,
                data: this.model.datastoreDetails,
                columnDefs: this.getDatastoresGridColumnDefs(),
                height: "153px",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        ReadyToCompletePageController.prototype.getDatastoresGridColumnDefs = function () {
            var self = this;
            return [{
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.datastoresNameHeaderLabel"),
                    field: "name",
                    type: "string",
                    template: function (dataItem) {
                        var iconTextRenderer = self.columnRenderersRegistry.getColumnRenderer("icon-text");
                        return iconTextRenderer(["icon", "name"], dataItem);
                    }
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.datastoresCapacityHeaderLabel"),
                    field: "capacity",
                    type: "string",
                    template: "#:capacity#"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.datastoresFreeSpaceHeaderLabel"),
                    field: "freeSpace",
                    type: "string",
                    template: "#:freeSpace#"
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.datastoresTypeHeaderLabel"),
                    field: "type",
                    type: "string",
                    template: "#:type#"
                }];
        };
        ReadyToCompletePageController.prototype.getClustersAndHostsGridOptions = function () {
            return {
                searchable: false,
                resizable: false,
                selectable: false,
                data: [],
                columnDefs: this.getClustersAndHostsGridColumnDefs(),
                height: "153px",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        ReadyToCompletePageController.prototype.getClustersAndHostsGridColumnDefs = function () {
            var self = this;
            return [{
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHostNameHeaderLabel"),
                    field: "name",
                    type: "string",
                    template: function (dataItem) {
                        var iconTextRenderer = self.columnRenderersRegistry.getColumnRenderer("icon-text");
                        return iconTextRenderer(["icon", "name"], dataItem);
                    }
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHostDatastoreConnectionStatusHeaderLabel"),
                    field: "isFullyConnected",
                    type: "boolean",
                    template: function (dataItem) {
                        var iconTextRenderer = self.columnRenderersRegistry.getColumnRenderer("icon-text");
                        if (dataItem.isFullyConnected) {
                            dataItem.isFullyConnectedIcon = "vx-icon-compliant";
                            dataItem.isFullyConnectedText = self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.allDatastoresConnected");
                        }
                        else {
                            dataItem.isFullyConnectedIcon = "vx-icon-warn";
                            dataItem.isFullyConnectedText = self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.datastoreConnectionMissing");
                        }
                        return iconTextRenderer(["isFullyConnectedIcon", "isFullyConnectedText"], dataItem);
                    }
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHostSelectedHeaderLabel"),
                    field: "isSelected",
                    type: "boolean",
                    template: function (dataItem) {
                        return dataItem.isSelected ? self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.selected") :
                            self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.notSelected");
                    }
                }, {
                    displayName: this.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHostIOCapableHeaderLabel"),
                    field: "isIOLoadBalanceCapable",
                    type: "boolean",
                    template: function (dataItem) {
                        var iconTextRenderer = self.columnRenderersRegistry.getColumnRenderer("icon-text");
                        if (dataItem.isIOLoadBalanceCapable) {
                            dataItem.isIOLoadBalanceCapableIcon = "vx-icon-compliant";
                            dataItem.isIOLoadBalanceCapableText = self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.ioLoadBalanceCapable");
                        }
                        else {
                            dataItem.isIOLoadBalanceCapableIcon = "vx-icon-warn";
                            dataItem.isIOLoadBalanceCapableText = self.i18nService.getString("DsClusterUi", "createDsClusterWizard.readyToCompletePage.clustersAndHosts.ioLoadBalanceNotCapable");
                        }
                        return iconTextRenderer(["isIOLoadBalanceCapableIcon", "isIOLoadBalanceCapableText"], dataItem);
                    }
                }];
        };
        ReadyToCompletePageController.$inject = ["createDsClusterWizardManager", "vuiConstants",
            "simpleValidationCommit", "i18nService", "vxPropertyViewService",
            "columnRenderersRegistry", "$q", "createDsClusterWizardHostsAndClustersService",
            "createDsClusterPageConstants", "storageDrsLocalizationService",
            "dsClusterConstants"];
        return ReadyToCompletePageController;
    }(WizardPageControllerAbstract));
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("ReadyToCompletePageController", ReadyToCompletePageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ds_cluster_ui;
(function (ds_cluster_ui) {
    var WizardPageControllerAbstract = ds_cluster_ui.WizardPageControllerAbstract;
    var RuntimeSettingsPageController = (function (_super) {
        __extends(RuntimeSettingsPageController, _super);
        function RuntimeSettingsPageController(createDsClusterWizardManager, vuiConstants, simpleValidationCommit, createDsClusterPageConstants, $q) {
            _super.call(this, createDsClusterWizardManager, simpleValidationCommit);
            this.vuiConstants = vuiConstants;
            this.createDsClusterPageConstants = createDsClusterPageConstants;
            this.$q = $q;
            this.initPageSubmit();
            this.initModel();
            this.setWizardPageState(this.vuiConstants.wizard.pageState.COMPLETED);
        }
        RuntimeSettingsPageController.prototype.getValidationErrors = function () {
            return this.$q.reject();
        };
        RuntimeSettingsPageController.prototype.getCurrentPageIndex = function () {
            return this.createDsClusterPageConstants.RUNTIME_INDEX;
        };
        RuntimeSettingsPageController.prototype.initModel = function () {
            this.model = this.createDsClusterWizardManager.getModel();
        };
        RuntimeSettingsPageController.$inject = ["createDsClusterWizardManager", "vuiConstants",
            "simpleValidationCommit", "createDsClusterPageConstants", "$q"];
        return RuntimeSettingsPageController;
    }(WizardPageControllerAbstract));
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("RuntimeSettingsPageController", RuntimeSettingsPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var EnterMaintenanceModeFaultsWarningComponent = (function () {
        function EnterMaintenanceModeFaultsWarningComponent() {
            this.bindings = {
                faults: "<"
            };
            this.controller = EnterMaintenanceModeFaultsWarningController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/" +
                    "enterMaintenanceModeFaultsWarningView.html";
        }
        return EnterMaintenanceModeFaultsWarningComponent;
    }());
    ds_cluster_ui.EnterMaintenanceModeFaultsWarningComponent = EnterMaintenanceModeFaultsWarningComponent;
    var EnterMaintenanceModeFaultsWarningController = (function () {
        function EnterMaintenanceModeFaultsWarningController($scope, vuiConstants, drsFaultsViewConstants, i18nService, datastoreMaintenanceModeService) {
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.drsFaultsViewConstants = drsFaultsViewConstants;
            this.i18nService = i18nService;
            this.datastoreMaintenanceModeService = datastoreMaintenanceModeService;
            this.i18n = this.i18nService.getString;
            this.faultDetailsGridOptions =
                this.datastoreMaintenanceModeService.getFaultDetailsGridOptions(this.faults);
        }
        EnterMaintenanceModeFaultsWarningController.$inject = [
            "$scope",
            "vuiConstants",
            "drsFaultsViewConstants",
            "i18nService",
            "datastoreMaintenanceModeService"];
        return EnterMaintenanceModeFaultsWarningController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("enterMaintenanceModeFaultsWarning", new EnterMaintenanceModeFaultsWarningComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var EnterMaintenanceModeRecommendationsWarningComponent = (function () {
        function EnterMaintenanceModeRecommendationsWarningComponent() {
            this.bindings = {
                recommendations: "<",
                recommendationStore: "="
            };
            this.controller = EnterMaintenanceModeRecommendationsWarningController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/" +
                    "enterMaintenanceModeRecommendationsWarningView.html";
        }
        return EnterMaintenanceModeRecommendationsWarningComponent;
    }());
    ds_cluster_ui.EnterMaintenanceModeRecommendationsWarningComponent = EnterMaintenanceModeRecommendationsWarningComponent;
    var EnterMaintenanceModeRecommendationsWarningController = (function () {
        function EnterMaintenanceModeRecommendationsWarningController(i18nService) {
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
        }
        EnterMaintenanceModeRecommendationsWarningController.$inject = ["i18nService"];
        return EnterMaintenanceModeRecommendationsWarningController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("enterMaintenanceModeRecommendationsWarning", new EnterMaintenanceModeRecommendationsWarningComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var EnterMaintenanceModeWarningComponent = (function () {
        function EnterMaintenanceModeWarningComponent() {
            this.bindings = {
                parentPod: "<",
                vmIds: "<",
                actionEval: "=",
                promise: "<",
                shouldStartMigrateWizard: "="
            };
            this.controller = EnterMaintenanceModeWarningController;
            this.templateUrl = "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/enterMaintenanceModeWarningView.html";
        }
        ;
        return EnterMaintenanceModeWarningComponent;
    }());
    ds_cluster_ui.EnterMaintenanceModeWarningComponent = EnterMaintenanceModeWarningComponent;
    var EnterMaintenanceModeWarningController = (function () {
        function EnterMaintenanceModeWarningController($scope, defaultUriSchemeUtil, actionsService, datastoreMaintenanceModeService, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.actionsService = actionsService;
            this.datastoreMaintenanceModeService = datastoreMaintenanceModeService;
            this.i18nService = i18nService;
            this.canMigrate = true;
            this.loading = true;
            this.i18n = this.i18nService.getString;
            this.promise.then(function (promisesResult) {
                // The below check covers mixed power state vms and ft vms. Check java
                // code for further details on the exact validation logic. This is the
                // same validation Migrate VM wizard uses, so through it we prevent
                // calling the migrate wizard with incompatible VMs
                var areVmsInSameState = promisesResult[0].result.warnings.length === 0 &&
                    promisesResult[0].result.errors.length === 0;
                // Checks user privileges,, disabled methods and availability properties
                // for migrate vm wizard
                var isMigrateActionAvailable = false;
                if (promisesResult[1].evaluationStatuses) {
                    var availabilityStatuses = _.map(promisesResult[1].evaluationStatuses, function (evaluationStatus) { return evaluationStatus.available; });
                    isMigrateActionAvailable = availabilityStatuses ?
                        _.find(availabilityStatuses, function (available) { return !available; }) === undefined : false;
                }
                _this.actionEval.evaluationStatuses =
                    promisesResult[1].evaluationStatuses;
                _this.actionEval.available = isMigrateActionAvailable;
                _this.canMigrate = areVmsInSameState && isMigrateActionAvailable;
                _this.loading = false;
            });
            this.signpostParams = {
                title: this.i18nService.getString('DsClusterUi', 'enterDsMaintenanceMode.warning.signpost.help'),
                message: this.i18nService.getString('DsClusterUi', 'enterDsMaintenanceMode.warning.signpost')
            };
            var numberOfVms = this.vmIds.length;
            this.warningMessage = numberOfVms > 1 ?
                i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.datastore.multiple", numberOfVms) :
                i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.datastore.single");
            if (this.parentPod) {
                this.warningMessage += i18nService.getString("DsClusterUi", "enterDsMaintenanceMode.warning.datastore.sdrsOff");
            }
        }
        EnterMaintenanceModeWarningController.$inject = ["$scope",
            "defaultUriSchemeUtil",
            "actionsService",
            "datastoreMaintenanceModeService",
            "i18nService"];
        return EnterMaintenanceModeWarningController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("enterMaintenanceModeWarning", new EnterMaintenanceModeWarningComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var FaultsAndRecommendationsComponent = (function () {
        function FaultsAndRecommendationsComponent() {
            this.bindings = {
                faults: "<",
                recommendations: "<",
                recommendationStore: "=",
            };
            this.controller = FaultsAndRecommendationsController;
            this.templateUrl = "ds-cluster-ui/resources/ds-cluster/views/maintenanceMode/faultsAndRecommendationsView.html";
        }
        return FaultsAndRecommendationsComponent;
    }());
    ds_cluster_ui.FaultsAndRecommendationsComponent = FaultsAndRecommendationsComponent;
    var FaultsAndRecommendationsController = (function () {
        function FaultsAndRecommendationsController(i18nService, vuiConstants, clarityConstants, drsFaultsViewConstants, $timeout, datastoreMaintenanceModeService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.clarityConstants = clarityConstants;
            this.drsFaultsViewConstants = drsFaultsViewConstants;
            this.$timeout = $timeout;
            this.datastoreMaintenanceModeService = datastoreMaintenanceModeService;
            this.i18n = this.i18nService.getString;
            this.faultDetailsGridOptions =
                this.datastoreMaintenanceModeService.getFaultDetailsGridOptions(this.faults);
        }
        FaultsAndRecommendationsController.$inject = ["i18nService", "vuiConstants", "clarityConstants",
            "drsFaultsViewConstants", "$timeout", "datastoreMaintenanceModeService"];
        return FaultsAndRecommendationsController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .component("faultsAndRecommendations", new FaultsAndRecommendationsComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterConnectivityDetailsController = (function () {
        function DsClusterConnectivityDetailsController($scope, i18nService, helpService, vuiConstants, dsClusterConectivityService) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.helpService = helpService;
            this.vuiConstants = vuiConstants;
            this.dsClusterConectivityService = dsClusterConectivityService;
            this.detailsViewGridOptions = this.dsClusterConectivityService
                .getDetailsViewGridOptions();
            $scope.$watch("masterDetailsViewContext.selectedItems", function (newValue) {
                if (newValue && newValue.length > 0) {
                    _this.setDetailsViewGridData(newValue);
                }
            });
        }
        DsClusterConnectivityDetailsController.prototype.setDetailsViewGridData = function (cluster) {
            this.detailsViewGridOptions.data = this.dsClusterConectivityService
                .getHostFromCluster(cluster[0][0]);
        };
        DsClusterConnectivityDetailsController.$inject = ["$scope", "i18nService", "helpService", "vuiConstants",
            "dsClusterConectivityService"];
        return DsClusterConnectivityDetailsController;
    }());
    ds_cluster_ui.DsClusterConnectivityDetailsController = DsClusterConnectivityDetailsController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterConnectivityDetailsController", DsClusterConnectivityDetailsController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterConnectivityMasterController = (function () {
        function DsClusterConnectivityMasterController($scope, i18nService, dataService, navigation, vuiConstants, columnRenderersRegistry, dsClusterConectivityService) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dsClusterConectivityService = dsClusterConectivityService;
            this.selectedItem = null;
            this.objectId = navigation.getRoute().objectId;
            this.watchForObjects = [this.objectId];
            this.masterViewGridOptions = this.dsClusterConectivityService
                .getMasterViewGridOptions();
            $scope.$watch(function () {
                return _this.masterViewGridOptions.selectedItems;
            }, function (newvalue) {
                if (newvalue && newvalue.length > 0) {
                    $scope.masterDetailsViewContext.selectedItems = [newvalue];
                    _this.selectedItem = newvalue[0];
                }
                else if ($scope.masterDetailsViewContext !== undefined) {
                    $scope.masterDetailsViewContext.selectedItems = [];
                }
            });
            this.getViewData();
        }
        DsClusterConnectivityMasterController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, ["computedDsClusterConnectivity"])
                .then(function (connectivityData) {
                var masterGridData = _.map(connectivityData.computedDsClusterConnectivity, function (clusterData) {
                    return {
                        name: clusterData.name,
                        icon: clusterData.icon,
                        connectionLabel: clusterData.isConnected ?
                            _this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.allDatastoresConnected") :
                            _this.i18nService.getString("DsClusterUi", "dsClusterComputeResourceList.datastoreConnectionMissing"),
                        isConnectedIcon: clusterData.isConnected ? "vx-icon-compliant" : "vx-icon-warn",
                        allocatedSpaceFormatted: clusterData.allocatedSpaceFormatted,
                        usedSpaceFormatted: clusterData.usedSpaceFormatted,
                        hosts: clusterData.hosts
                    };
                });
                _this.masterViewGridOptions.data = masterGridData;
                _this.dsClusterConectivityService.setHostFromCluster(connectivityData
                    .computedDsClusterConnectivity);
            });
        };
        DsClusterConnectivityMasterController.$inject = ["$scope", "i18nService", "dataService", "navigation",
            "vuiConstants", "columnRenderersRegistry", "dsClusterConectivityService"];
        return DsClusterConnectivityMasterController;
    }());
    ds_cluster_ui.DsClusterConnectivityMasterController = DsClusterConnectivityMasterController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterConnectivityMasterController", DsClusterConnectivityMasterController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterVmConnectivityDetailsController = (function () {
        function DsClusterVmConnectivityDetailsController($scope, dsClusterConectivityService) {
            var _this = this;
            this.$scope = $scope;
            this.dsClusterConectivityService = dsClusterConectivityService;
            this.detailsViewGridOptions = this.dsClusterConectivityService
                .getVmConnectivityDetailsViewGridOptions();
            $scope.$watch("masterDetailsViewContext.selectedItems", function (newValue) {
                if (newValue && newValue.length > 0) {
                    _this.setVmDetailsViewGridData(newValue[0]);
                }
            });
        }
        DsClusterVmConnectivityDetailsController.prototype.setVmDetailsViewGridData = function (vm) {
            this.detailsViewGridOptions.data = vm.vmDisks.slice(0);
        };
        DsClusterVmConnectivityDetailsController.$inject = ["$scope", "dsClusterConectivityService"];
        return DsClusterVmConnectivityDetailsController;
    }());
    ds_cluster_ui.DsClusterVmConnectivityDetailsController = DsClusterVmConnectivityDetailsController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterVmConnectivityDetailsController", DsClusterVmConnectivityDetailsController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterVmConnectivityMasterController = (function () {
        function DsClusterVmConnectivityMasterController($scope, i18nService, dataService, navigation, dsClusterConectivityService, dsClusterConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.navigation = navigation;
            this.dsClusterConectivityService = dsClusterConectivityService;
            this.dsClusterConstants = dsClusterConstants;
            this.selectedItem = null;
            this.objectId = navigation.getRoute().objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties = [
                this.dsClusterConstants.liveRefreshProperties.SUMMARY,
                this.dsClusterConstants.liveRefreshProperties.STORAGE_DRS_CONFIG
            ];
            this.masterViewGridOptions = this.dsClusterConectivityService
                .getVmConnectivityMasterViewGridOptions();
            $scope.$watch("ctrl.masterViewGridOptions.selectedItems", function (newValue) {
                if (newValue && newValue.length > 0) {
                    $scope.masterDetailsViewContext.selectedItems = newValue;
                    _this.selectedItem = newValue[0];
                }
                else if ($scope.masterDetailsViewContext !== undefined) {
                    $scope.masterDetailsViewContext.selectedItems = [];
                }
            });
            this.getViewData();
        }
        DsClusterVmConnectivityMasterController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, "com.vmware.vsphere.client.dsclusterui.model.DsClusterConnectivityVmData")
                .then(function (connectivityData) {
                _this.masterViewGridOptions.data = connectivityData.vms;
            });
        };
        DsClusterVmConnectivityMasterController.$inject = ["$scope", "i18nService", "dataService", "navigation",
            "dsClusterConectivityService", "dsClusterConstants"];
        return DsClusterVmConnectivityMasterController;
    }());
    ds_cluster_ui.DsClusterVmConnectivityMasterController = DsClusterVmConnectivityMasterController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterVmConnectivityMasterController", DsClusterVmConnectivityMasterController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterFaultsDetailsViewController = (function () {
        function DsClusterFaultsDetailsViewController($scope, i18nService, drsFaultsViewService, dsClusterHelpConstants, helpService, sdrsFaultsService) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.drsFaultsViewService = drsFaultsViewService;
            this.dsClusterHelpConstants = dsClusterHelpConstants;
            this.helpService = helpService;
            this.sdrsFaultsService = sdrsFaultsService;
            this.detailsViewGridOptions =
                this.drsFaultsViewService.getDetailsViewGridOptions();
            this.faultDetailsTitle = i18nService.getString("Common", "drs.faultControl.details.sdrsState.headerLabel");
            this.drsTroubleshootHelpId =
                this.dsClusterHelpConstants.SDRS_FAULT_TROUBLESHOOT_GUIDE_ID;
            $scope.$watch("masterDetailsViewContext.selectedItems", function (newValue) {
                if (newValue && newValue.length > 0) {
                    _this.setDetailsViewGridData(newValue);
                }
            });
            $scope.openHelpLink = function (contextId) {
                _this.helpService.showHelpPage(contextId);
            };
        }
        DsClusterFaultsDetailsViewController.prototype.setDetailsViewGridData = function (faultData) {
            var _this = this;
            var data = [];
            faultData[0].forEach(function (fault) {
                fault.details.forEach(function (detail) {
                    var gridItem = _this.sdrsFaultsService.getFaultDetailsData(detail);
                    if (gridItem) {
                        data.push(gridItem);
                    }
                });
            });
            this.detailsViewGridOptions.data = data;
        };
        DsClusterFaultsDetailsViewController.$inject = ["$scope", "i18nService", "drsFaultsViewService",
            "dsClusterHelpConstants", "helpService", "sdrsFaultsService"];
        return DsClusterFaultsDetailsViewController;
    }());
    ds_cluster_ui.DsClusterFaultsDetailsViewController = DsClusterFaultsDetailsViewController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterFaultsDetailsViewController", DsClusterFaultsDetailsViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterFaultsMasterViewController = (function () {
        function DsClusterFaultsMasterViewController($scope, i18nService, dataService, drsFaultsViewService, sdrsFaultsService, navigation, dsClusterConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.drsFaultsViewService = drsFaultsViewService;
            this.sdrsFaultsService = sdrsFaultsService;
            this.navigation = navigation;
            this.dsClusterConstants = dsClusterConstants;
            this.selectedItem = null;
            this.objectId = navigation.getRoute().objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.FAULT];
            this.masterViewGridOptions =
                this.drsFaultsViewService.getMasterViewGridOptions();
            this.faultMasterTitle =
                i18nService.getString("Common", "drs.faultControl.sdrsState.headerLabel");
            $scope.$watch(function () {
                return _this.masterViewGridOptions.selectedItems;
            }, function (newvalue) {
                if (newvalue && newvalue.length > 0) {
                    $scope.masterDetailsViewContext.selectedItems = [newvalue];
                    _this.selectedItem = newvalue[0];
                }
                else if ($scope.masterDetailsViewContext !== undefined) {
                    $scope.masterDetailsViewContext.selectedItems = [];
                }
            });
            $scope.preselectComparator = function (dataGridItem) {
                var preselect = false;
                if (_this.selectedItem) {
                    preselect = dataGridItem.target.text === _this.selectedItem.target.text
                        && dataGridItem.reason === _this.selectedItem.reason;
                }
                return preselect;
            };
            this.getViewData();
        }
        DsClusterFaultsMasterViewController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, ["computedSdrsFaults"])
                .then(function (faultsData) {
                _this.setMasterViewGridData(faultsData);
            });
        };
        DsClusterFaultsMasterViewController.prototype.setMasterViewGridData = function (faultsData) {
            var _this = this;
            if (!faultsData.computedSdrsFaults) {
                return;
            }
            var data = [];
            faultsData.computedSdrsFaults.forEach(function (fault) {
                data.push(_this.sdrsFaultsService.getFaultMasterData(fault));
            });
            this.masterViewGridOptions.data = data;
        };
        DsClusterFaultsMasterViewController.$inject = ["$scope", "i18nService", "dataService",
            "drsFaultsViewService", "sdrsFaultsService", "navigation",
            "dsClusterConstants"];
        return DsClusterFaultsMasterViewController;
    }());
    ds_cluster_ui.DsClusterFaultsMasterViewController = DsClusterFaultsMasterViewController;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterFaultsMasterViewController", DsClusterFaultsMasterViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterHistoryViewController = (function () {
        function DsClusterHistoryViewController($scope, dataService, i18nService, vuiConstants, columnRenderersRegistry, defaultUriSchemeUtil, timeFormatterService, $q, dsClusterConstants) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.timeFormatterService = timeFormatterService;
            this.$q = $q;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = $scope._route.objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.SUMMARY];
            this.historyTitle = this.getString("dscluster.services.drsHistoryLabel");
            this.gridOptions = this.getGridOptions();
            this.getViewData();
        }
        DsClusterHistoryViewController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, ["computedActionHistory"])
                .then(function (historyData) {
                if (historyData
                    && historyData.computedActionHistory
                    && historyData.computedActionHistory.length > 0) {
                    var formatTimePromises = historyData.computedActionHistory.map(function (item) { return _this.timeFormatterService.formatDate(item.time).then(function (formattedTime) {
                        item.time = formattedTime;
                        return item;
                    }); });
                    _this.$q.all(formatTimePromises).then(function (data) {
                        _this.gridOptions.data = data;
                    });
                }
            });
        };
        DsClusterHistoryViewController.prototype.getGridOptions = function () {
            var options = {
                selectionMode: this.vuiConstants.grid.selectionMode.NONE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                data: [],
                columnDefs: this.getColumnDefs(),
                height: "100%"
            };
            return options;
        };
        DsClusterHistoryViewController.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("Common", "actionHistoryList.timeColumnHeaderLabel"),
                    field: "time",
                    type: "string"
                },
                {
                    displayName: this.i18nService.getString("Common", "actionHistoryList.sdrsActionColumnHeaderLabel"),
                    field: "text",
                    type: "string",
                    template: this.textRenderer.bind(this)
                }
            ];
        };
        DsClusterHistoryViewController.prototype.textRenderer = function (data) {
            var _this = this;
            var objData = data || {};
            var renderer = this.columnRenderersRegistry.getColumnRenderer("object-name");
            //build links for each target object in the action text
            var targetLinks = objData.targetObjects.map(function (object) {
                if (object && object.name) {
                    object.uid = _this.defaultUriSchemeUtil.getVsphereObjectId(object.provider);
                    return renderer(["uid", null, "name", "labelIds"], object);
                }
                else {
                    return _this.getString("sdrs.history.missingObjectNameLabel");
                }
            });
            var text = this.i18nService.interpolate(objData.text, targetLinks);
            if (!!objData.image) {
                text = "<span class=\"" + objData.image + "\"></span>" + text;
            }
            return text;
        };
        DsClusterHistoryViewController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        DsClusterHistoryViewController.$inject = ["$scope", "dataService", "i18nService", "vuiConstants",
            "columnRenderersRegistry", "defaultUriSchemeUtil", "timeFormatterService",
            "$q", "dsClusterConstants"];
        return DsClusterHistoryViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterHistoryViewController", DsClusterHistoryViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SdrsRecommendationsController = (function () {
        function SdrsRecommendationsController($scope, dataService, i18nService, columnRenderersRegistry, defaultUriSchemeUtil, drsRecommendationsService, clarityModalService, mutationService, dsClusterSpecBuilderService, $rootScope, dsClusterConstants) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.drsRecommendationsService = drsRecommendationsService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.dsClusterSpecBuilderService = dsClusterSpecBuilderService;
            this.$rootScope = $rootScope;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = $scope._route.objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.RECOMMENDATION];
            this.recommendationsTitle = this.getString("dscluster.services.recommendationsLabel");
            this.recommendationStore =
                this.drsRecommendationsService.createRecommendationsStore(new Array(0));
            this.getViewData();
        }
        SdrsRecommendationsController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, ["computedSdrsRecommendations"])
                .then(function (sdrsRecommendationsData) {
                _this.sdrsRecommendationsData = sdrsRecommendationsData;
            });
        };
        SdrsRecommendationsController.prototype.runDrs = function () {
            var refreshDsClusterRecommendationsSpec = {
                operation: "refresh"
            };
            this.mutationService.apply(this.objectId, "com.vmware.vsphere.client.dscluster.services.sdrs.DatastoreClusterRecommendationSpec", refreshDsClusterRecommendationsSpec);
        };
        SdrsRecommendationsController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        SdrsRecommendationsController.$inject = ["$scope", "dataService", "i18nService",
            "columnRenderersRegistry", "defaultUriSchemeUtil", "drsRecommendationsService",
            "clarityModalService", "mutationService", "dsClusterSpecBuilderService",
            "$rootScope", "dsClusterConstants"];
        return SdrsRecommendationsController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("SdrsRecommendationsController", SdrsRecommendationsController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddSdrsRuleController = (function () {
        function AddSdrsRuleController(sdrsRulesService, dsClusterConstants, $scope, vuiConstants, $q, i18nService, defaultUriSchemeUtil, mutationService, $rootScope) {
            var _this = this;
            this.sdrsRulesService = sdrsRulesService;
            this.dsClusterConstants = dsClusterConstants;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.$q = $q;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.spec = {};
            this.typeOptions = {};
            this.ruleInfo = null;
            this.mode = $scope.modalOptions.dialogData.operationType;
            this.objectId = $rootScope._route.objectId;
            this.editMode = dsClusterConstants.operationType.EDIT;
            this.typeOptions = this.sdrsRulesService.getSdrsRuleTypes();
            this.initSpecValues();
            $scope.$watch(function () {
                return _this.spec.ruleType;
            }, function (ruleType) {
                if (_this.mode === dsClusterConstants.operationType.ADD) {
                    _this.spec.ruleMembersData = [];
                }
                if (ruleType && ruleType.id === dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE) {
                    _this.ruleDescription = _this.i18nService.getString("Common", "sdrs.rules.config.description.VM_ANTIAFFINITY_RULE_TYPE");
                }
                else if (ruleType && ruleType.id ===
                    dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE) {
                    _this.ruleDescription = _this.i18nService.getString("Common", "sdrs.rules.config.description.VIRTUAL_DISK_ANTI_AFFINITY_RULE_TYPE");
                }
                else {
                    _this.ruleDescription = "";
                }
            });
            $scope.modalOptions.onSubmit = function () { return _this.onCommit(); };
        }
        AddSdrsRuleController.prototype.initSpecValues = function () {
            this.spec = {
                name: "",
                ruleType: {
                    id: this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE
                },
                enabled: true,
                ruleMembersData: []
            };
            if (this.mode === this.dsClusterConstants.operationType.EDIT) {
                var selectedRule_1 = this.$scope.modalOptions.dialogData.context.selectedRule;
                this.spec.key = selectedRule_1.rule.key;
                this.spec.name = selectedRule_1.rule.name;
                this.spec.enabled = selectedRule_1.rule.enabled;
                this.spec.ruleType = _.find(this.typeOptions, function (elem) { return elem.id === selectedRule_1.rule._type; });
                this.spec.ruleMembersData =
                    this.$scope.modalOptions.dialogData.context.selectedRuleDetails.data;
                this.spec.selectedRuleDetails = this.$scope.modalOptions.dialogData.context
                    .selectedRuleDetails.formattedData();
                if (selectedRule_1.vm !== null) {
                    this.spec.selectedVm = selectedRule_1.vm;
                    this.spec.selectedVm.id =
                        this.defaultUriSchemeUtil.getVsphereObjectId(selectedRule_1.vm.provider);
                }
            }
        };
        AddSdrsRuleController.prototype.validate = function () {
            var _this = this;
            if (this.spec.name) {
                if ((/^\s*$/gi).test(this.spec.name)) {
                    this.$scope.modalOptions.alerts = [{
                            text: this.i18nService.getString("Common", "sdrs.rules.config.error.nameEmpty"),
                            type: this.vuiConstants.validationBanner.type.ERROR
                        }];
                    this.$scope.modalOptions.isAlertClosed = false;
                    return this.$q.reject();
                }
                else if (this.spec.name.length > 80) {
                    this.$scope.modalOptions.alerts = [{
                            text: this.i18nService.getString("Common", "sdrs.rules.config.error.nameTooLong", "80"),
                            type: this.vuiConstants.validationBanner.type.ERROR
                        }];
                    this.$scope.modalOptions.isAlertClosed = false;
                    return this.$q.reject();
                }
            }
            else {
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("Common", "sdrs.rules.config.error.nameEmpty"),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
                return this.$q.reject();
            }
            if (this.spec.ruleType.id ===
                this.dsClusterConstants.ruleSpec.VMDK_ANTI_AFFINITY_TYPE &&
                !this.spec.selectedVm) {
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("Common", "sdrs.rules.config.error.vmNameEmpty"),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
                return this.$q.reject();
            }
            if (this.spec.ruleMembersData.length <
                this.dsClusterConstants.affinityRuleMinimumMembers) {
                var ruleMembersValidationKey = void 0;
                if (this.spec.ruleType.id ===
                    this.dsClusterConstants.ruleSpec.VM_ANTI_AFFINITY_TYPE) {
                    ruleMembersValidationKey =
                        "sdrs.rules.config.error.lessThenMinVmRuleMembers";
                }
                else {
                    ruleMembersValidationKey =
                        "sdrs.rules.config.error.lessThenMinVmdkRuleMembers";
                }
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("Common", ruleMembersValidationKey, this.dsClusterConstants.affinityRuleMinimumMembers),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
                return this.$q.reject();
            }
            var selectedVmRef = this.spec.selectedVm ?
                this.defaultUriSchemeUtil.getManagedObjectReference(this.spec.selectedVm.id) :
                null;
            var key = (this.mode === this.dsClusterConstants.operationType.ADD) ?
                null : this.spec.key;
            var ruleMembers = this.sdrsRulesService.getRuleMemberRefs(this.spec);
            this.ruleInfo = this.sdrsRulesService.buildSdrsRuleInfo(this.spec.ruleType.id, this.spec.name, this.spec.enabled, ruleMembers, this.spec.operation, key, selectedVmRef);
            var validationPromise = this.mutationService.validate(this.objectId, this.dsClusterConstants.SDRS_RULE_INFO_SPEC, this.ruleInfo).then(function (validationResult) {
                if (!!validationResult && validationResult.result) {
                    if (!_this.handleNameValidation(validationResult)) {
                        return _this.$q.reject();
                    }
                    if (!_this.handleConflictingRulesValidation(validationResult)) {
                        return _this.$q.reject();
                    }
                    if (!_this.handleConflictingOverridesValidation(validationResult)) {
                        return _this.$q.reject();
                    }
                    if (!_this.handleConflictingDscDefVmAffVmsValidation(validationResult)) {
                        return _this.$q.reject();
                    }
                }
                return _this.$q.resolve();
            });
            return validationPromise;
        };
        AddSdrsRuleController.prototype.handleNameValidation = function (validationResult) {
            if (validationResult.result.nameIsDuplicated) {
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("Common", "sdrs.rules.config.duplicated.name.error.message.format", this.spec.name),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
                return false;
            }
            return true;
        };
        AddSdrsRuleController.prototype.handleConflictingRulesValidation = function (validationResult) {
            var _this = this;
            if (validationResult.result.conflictingRules.length > 0) {
                if (this.spec.enabled) {
                    var alerts_1 = [];
                    _.each(validationResult.result.conflictingRules, function (conflictingRule) {
                        alerts_1.push({
                            text: _this.i18nService.getString("Common", "sdrs.rules.config.rule.conflict.error.message.format", conflictingRule.name),
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        });
                    });
                    this.$scope.modalOptions.alerts = alerts_1;
                    this.$scope.modalOptions.isAlertClosed = false;
                    this.spec.enabled = false;
                    return false;
                }
            }
            return true;
        };
        AddSdrsRuleController.prototype.handleConflictingOverridesValidation = function (validationResult) {
            var _this = this;
            if (validationResult.result.conflictingVmsOverrides.length > 0) {
                var alerts_2 = [];
                _.each(validationResult.result.conflictingVmsOverrides, function (conflictingVm) {
                    var vmName = conflictingVm ?
                        conflictingVm.vmName : "";
                    var ruleType = _this.ruleInfo.ruleType;
                    if (_this.dsClusterConstants.ruleTypes.VMDK_ANTI_AFFINITY_TYPE ===
                        ruleType) {
                        alerts_2.push({
                            text: _this.i18nService.getString("Common", "sdrs.rules.config.keep.vmdk.together.conflict.error.message.format", vmName),
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        });
                    }
                    else if (_this.dsClusterConstants.ruleTypes.VM_ANTI_AFFINITY_TYPE ===
                        ruleType) {
                        alerts_2.push({
                            text: _this.i18nService.getString("Common", "sdrs.rules.config.do.not.keep.vmdk.together.conflict.error.message.format", vmName),
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        });
                    }
                });
                this.$scope.modalOptions.alerts = alerts_2;
                this.$scope.modalOptions.isAlertClosed = false;
                this.spec.enabled = false;
                return false;
            }
            return true;
        };
        AddSdrsRuleController.prototype.handleConflictingDscDefVmAffVmsValidation = function (validationResult) {
            var _this = this;
            if (validationResult.result.conflictingDscDefVmAffVms.length > 0) {
                var ruleType = this.ruleInfo.ruleType;
                if (this.dsClusterConstants.ruleTypes.VM_ANTI_AFFINITY_TYPE ===
                    ruleType) {
                    if (validationResult.result.conflictingDscDefVmAffVms.length ===
                        this.spec.ruleMembersData.length) {
                        this.$scope.modalOptions.alerts = [{
                                text: this.i18nService.getString("Common", "sdrs.rules.config.conficts.dsClusterDefVmAff.allVms"),
                                type: this.vuiConstants.validationBanner.type.ERROR
                            }];
                    }
                    else {
                        var alerts_3 = [];
                        var ruleVmsMapByRef_1 = {};
                        _.each(this.spec.ruleMembersData, function (vmData) {
                            ruleVmsMapByRef_1[vmData.id] = vmData.name;
                        });
                        _.each(validationResult.result.conflictingDscDefVmAffVms, function (conflictVm) {
                            alerts_3.push({
                                text: _this.i18nService.getString("Common", "sdrs.rules.config.conficts.dsClusterDefVmAff.perVm.format", ruleVmsMapByRef_1[_this.defaultUriSchemeUtil
                                    .getVsphereObjectId(conflictVm)]),
                                type: _this.vuiConstants.validationBanner.type.ERROR
                            });
                        });
                        this.$scope.modalOptions.alerts = alerts_3;
                    }
                }
                this.$scope.modalOptions.isAlertClosed = false;
                this.spec.enabled = false;
                return false;
            }
            return true;
        };
        AddSdrsRuleController.prototype.onCommit = function () {
            var _this = this;
            this.$scope.modalOptions.alerts = [];
            this.$scope.modalOptions.isAlertClosed = true;
            return this.validate()
                .then(function () {
                var mode = (_this.mode === _this.dsClusterConstants.operationType.ADD) ?
                    "create" : "apply";
                var ruleSpec = _this.sdrsRulesService.buildSdrsRuleSpec(_this.ruleInfo, mode);
                _this.mutationService.apply(_this.objectId, _this.dsClusterConstants.SDRS_RULE_SPEC, ruleSpec);
                return true;
            })
                .catch(function () {
                return false;
            });
        };
        AddSdrsRuleController.$inject = ["sdrsRulesService", "dsClusterConstants", "$scope",
            "vuiConstants", "$q", "i18nService", "defaultUriSchemeUtil", "mutationService",
            "$rootScope"];
        return AddSdrsRuleController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("AddSdrsRuleController", AddSdrsRuleController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddSdrsVmdkRuleMemberController = (function () {
        function AddSdrsVmdkRuleMemberController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            var dsClusterId = $scope.modalOptions.dialogData.objectId;
            var dialogData = $scope.modalOptions.dialogData;
            var selectedVms = dialogData.selectedVms ? dialogData.selectedVms : [];
            var selectorConfig = {
                objectType: "VirtualMachine",
                listViewId: "vsphere.core.vm.members.list"
            };
            var filter = "dsClusterVmdkRuleVmsExceptSecondaryVmsExcludeVmsFilter";
            // use different filter if there are no members to be excluded because
            // dsClusterVmsExceptSecondaryVmsExcludeVmsFilter cannot be instantiated with an empty param
            if (selectedVms.length === 0) {
                filter = "dsClusterVmdkRuleVmsExceptSecondaryVmsFilter";
            }
            this.config = {
                contextObject: dsClusterId,
                multipleSelect: false,
                listTabConfig: {
                    listConfig: [{
                            label: i18nService.getString("Common", "typeResource.vmPlural"),
                            listViewId: selectorConfig.listViewId,
                            dataModels: [selectorConfig.objectType],
                            filterId: filter,
                            filterParams: selectedVms
                        }]
                },
                onSelectionChanged: function (newSelectedItems) {
                    dialogData.selectedItems = newSelectedItems;
                }
            };
        }
        AddSdrsVmdkRuleMemberController.$inject = ["$scope", "i18nService"];
        return AddSdrsVmdkRuleMemberController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("AddSdrsVmdkRuleMemberController", AddSdrsVmdkRuleMemberController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddSdrsVmRuleMemberController = (function () {
        function AddSdrsVmRuleMemberController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            var dsClusterId = $scope.modalOptions.dialogData.objectId;
            var dialogData = $scope.modalOptions.dialogData;
            var selectedVms = this.getSelectedVmsManagedObjectRefs(dialogData.selectedVms);
            var selectorConfig = {
                objectType: "VirtualMachine",
                listViewId: "vsphere.core.vm.members.list"
            };
            var filter = "dsClusterVmsExceptSecondaryVmsExcludeVmsFilter";
            // use different filter if there are no members to be excluded because
            // dsClusterVmsExceptSecondaryVmsExcludeVmsFilter cannot be instantiated with an empty param
            if (selectedVms.length === 0) {
                filter = "dsClusterVmsExceptSecondaryVmsFilter";
            }
            this.config = {
                contextObject: dsClusterId,
                multipleSelect: true,
                listTabConfig: {
                    listConfig: [{
                            label: i18nService.getString("Common", "typeResource.vmPlural"),
                            listViewId: selectorConfig.listViewId,
                            dataModels: [selectorConfig.objectType],
                            filterId: filter,
                            filterParams: selectedVms
                        }]
                },
                onSelectionChanged: function (newSelectedItems) {
                    dialogData.selectedItems = newSelectedItems;
                }
            };
        }
        AddSdrsVmRuleMemberController.prototype.getSelectedVmsManagedObjectRefs = function (selectedVms) {
            return _.map(selectedVms, function (selectedVm) { return selectedVm.id; });
        };
        AddSdrsVmRuleMemberController.$inject = ["$scope", "i18nService"];
        return AddSdrsVmRuleMemberController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("AddSdrsVmRuleMemberController", AddSdrsVmRuleMemberController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmAntiAffinityRuleController = (function () {
        function AddVmAntiAffinityRuleController($rootScope, $scope, i18nService, datagridActionBarService, vuiConstants, columnRenderersRegistry) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.datagridActionBarService = datagridActionBarService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.datagridActionBarServiceCacheObject = null;
            this.objectId = $rootScope._route.objectId;
            $scope.$watch("$ctrl.vmAffinityGridOptions.selectedItems", function () {
                _this.refreshActionBar();
            });
        }
        AddVmAntiAffinityRuleController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (typeof changes.spec !== "undefined") {
                this.vmAffinityGridOptions =
                    this.getVmAffinityGridOptions(changes.spec.currentValue);
                this.actionSpecs = [{
                        actionId: "vsphere.core.dscluster.actions.rule.members.add",
                        getActionInvocationContext: function () {
                            return {
                                selectedMembers: changes.spec.currentValue.ruleMembersData,
                                dialogSubTitleObject: {
                                    objectId: _this.objectId
                                },
                                submitCallback: function (dialogOptions) {
                                    if (dialogOptions.dialogData.selectedItems !== undefined) {
                                        _this.vmAffinityGridOptions.data = _this.vmAffinityGridOptions
                                            .data.concat(dialogOptions.dialogData.selectedItems);
                                        changes.spec.currentValue.ruleMembersData =
                                            _this.vmAffinityGridOptions.data;
                                    }
                                    return true;
                                }
                            };
                        }
                    }, {
                        actionId: "vsphere.core.dscluster.actions.rule.members.remove",
                        getActionInvocationContext: function () {
                            return {
                                membersToRemove: _this.vmAffinityGridOptions.selectedItems,
                                confirmCallback: function () {
                                    _this.vmAffinityGridOptions.data =
                                        changes.spec.currentValue.ruleMembersData =
                                            _.filter(_this.vmAffinityGridOptions.data, function (gridItem) {
                                                return _.every(_this.vmAffinityGridOptions.selectedItems, function (selectedItem) {
                                                    return gridItem.id !== selectedItem.id;
                                                });
                                            });
                                    return true;
                                }
                            };
                        },
                        isActionAvailable: function (actionDef) {
                            return actionDef.available &&
                                _this.vmAffinityGridOptions.selectedItems.length > 0;
                        }
                    }];
                this.createActionBar();
            }
        };
        AddVmAntiAffinityRuleController.prototype.createActionBar = function () {
            var _this = this;
            this.datagridActionBarService
                .updateActionBar(this.vmAffinityGridOptions, [this.objectId], this.actionSpecs)
                .then(function (value) {
                _this.datagridActionBarServiceCacheObject = value;
            });
        };
        AddVmAntiAffinityRuleController.prototype.refreshActionBar = function () {
            if (!this.datagridActionBarServiceCacheObject) {
                return;
            }
            this.datagridActionBarService.updateActionBar(this.vmAffinityGridOptions, [this.objectId], this.actionSpecs, this.datagridActionBarServiceCacheObject);
        };
        AddVmAntiAffinityRuleController.prototype.getVmAffinityGridOptions = function (spec) {
            return {
                actionBarOptions: {
                    actions: []
                },
                searchable: false,
                resizable: true,
                data: spec.selectedRuleDetails,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedItems: [],
                columnDefs: [{
                        displayName: this.i18nService.getString("Common", "sdrs.rules.config.vmNameHeaderText"),
                        field: "name",
                        type: "string",
                        template: "<span class=\"object\" title=\"#:name#\"><i class=\"#:icon#\")></i>#:name#</span>"
                    }, {
                        displayName: this.i18nService.getString("DsClusterUi", "sdrs.rules.config.vmDatastoreHeaderText"),
                        field: "rawData.datastoreName",
                        template: this.datastoreNameRenderer.bind(this)
                    }],
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        AddVmAntiAffinityRuleController.prototype.datastoreNameRenderer = function (data) {
            var objectLinkRenderer = this.columnRenderersRegistry.getColumnRenderer("datastore-name");
            return objectLinkRenderer([], data.rawData);
        };
        AddVmAntiAffinityRuleController.$inject = ["$rootScope", "$scope", "i18nService",
            "datagridActionBarService", "vuiConstants", "columnRenderersRegistry"];
        return AddVmAntiAffinityRuleController;
    }());
    var AddVmAntiAffinityRuleComponent = (function () {
        function AddVmAntiAffinityRuleComponent() {
            this.controller = AddVmAntiAffinityRuleController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/" +
                    "addVmAntiAffinityRuleComponent.html";
            this.bindings = {
                spec: "<"
            };
        }
        return AddVmAntiAffinityRuleComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("addVmAntiAffinityRuleComponent", new AddVmAntiAffinityRuleComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmdkAntiAffinityRuleController = (function () {
        function AddVmdkAntiAffinityRuleController($rootScope, $scope, i18nService, datagridActionBarService, vuiConstants, columnRenderersRegistry, actionsService, sdrsRulesService, dsClusterConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.datagridActionBarService = datagridActionBarService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.actionsService = actionsService;
            this.sdrsRulesService = sdrsRulesService;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = $rootScope._route.objectId;
            this.editMode = dsClusterConstants.operationType.EDIT;
            $scope.$watch("$ctrl.vmdkGridOptions.selectedItems", function () {
                _this.spec.ruleMembersData = _this.vmdkGridOptions.selectedItems;
            });
            $scope.vmdkPreselectComparator = this.vmdkPreselectComparator.bind(this);
        }
        AddVmdkAntiAffinityRuleController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (typeof changes.spec !== "undefined") {
                this.spec = changes.spec.currentValue;
                this.vmdkGridOptions =
                    this.getVmdkGridOptions(changes.spec.currentValue);
                // Request action evaluations from the backend
                this.actionsService.getAction("vsphere.core.dscluster.actions.rule.vmdk.members.add", [this.objectId])
                    .then(function (actionEvalutaions) {
                    _this.addVmAction = actionEvalutaions;
                });
            }
            else if (typeof changes.mode !== "undefined") {
                this.mode = changes.mode.currentValue;
            }
        };
        AddVmdkAntiAffinityRuleController.prototype.invokeAction = function (action) {
            var _this = this;
            this.actionsService.invokeAction(action, {
                submitCallback: function (dialogOptions) {
                    if (dialogOptions.dialogData.selectedItems !== undefined) {
                        var selectedVm = dialogOptions.dialogData.selectedItems[0];
                        _this.spec.selectedVm = selectedVm;
                        _this.sdrsRulesService.getVmVirtualDisks(selectedVm.id)
                            .then(function (virtualDisks) {
                            _this.vmdkGridOptions.data = virtualDisks;
                        });
                    }
                    return true;
                },
                selectedMembers: this.spec.selectedVm ? [this.spec.selectedVm.id] : [],
                dialogSubTitleObject: {
                    objectId: this.objectId
                } });
        };
        AddVmdkAntiAffinityRuleController.prototype.vmdkPreselectComparator = function (member) {
            return this.mode === this.editMode;
        };
        AddVmdkAntiAffinityRuleController.prototype.getVmdkGridOptions = function (spec) {
            return {
                actionBarOptions: {
                    actions: []
                },
                searchable: false,
                resizable: true,
                data: spec.ruleMembersData,
                selectionMode: this.vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: true,
                selectedItems: [],
                columnDefs: [{
                        displayName: this.i18nService.getString("Common", "sdrs.rules.config.vmdkNameHeaderText"),
                        field: "deviceInfo.label",
                        type: "string",
                        template: "<span class=\"object\" title=\"#:deviceInfo.label#\">#:deviceInfo.label#</span>"
                    }],
                height: "186px",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        AddVmdkAntiAffinityRuleController.$inject = ["$rootScope", "$scope", "i18nService",
            "datagridActionBarService", "vuiConstants", "columnRenderersRegistry",
            "actionsService", "sdrsRulesService", "dsClusterConstants"];
        return AddVmdkAntiAffinityRuleController;
    }());
    var AddVmdkAntiAffinityRuleComponent = (function () {
        function AddVmdkAntiAffinityRuleComponent() {
            this.controller = AddVmdkAntiAffinityRuleController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/" +
                    "addVmdkAntiAffinityRuleComponent.html";
            this.bindings = {
                spec: "<",
                mode: "<"
            };
        }
        return AddVmdkAntiAffinityRuleComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("addVmdkAntiAffinityRuleComponent", new AddVmdkAntiAffinityRuleComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SdrsRulesViewController = (function () {
        function SdrsRulesViewController($scope, $compile, $element, sdrsRulesService, dsClusterConstants, datagridActionBarService, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.$compile = $compile;
            this.$element = $element;
            this.sdrsRulesService = sdrsRulesService;
            this.dsClusterConstants = dsClusterConstants;
            this.datagridActionBarService = datagridActionBarService;
            this.i18nService = i18nService;
            this.selectedRule = null;
            this.selectedRuleDetails = null;
            this.isFilterAdded = false;
            this.objectId = $scope._route.objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.STORAGE_DRS_CONFIG];
            $scope.rulesPreselectComparator = this.rulesPreselectComparator.bind(this);
            this.actionSpecs = [{
                    actionId: "vsphere.core.dscluster.actions.rule.add"
                }, {
                    actionId: "vsphere.core.dscluster.actions.rule.edit",
                    getActionInvocationContext: function () {
                        return {
                            selectedRule: _this.selectedRule,
                            selectedRuleDetails: _this.selectedRuleDetails
                        };
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available && _this.gridOptions.selectedItems.length > 0;
                    }
                }, {
                    actionId: 'vsphere.core.dscluster.actions.rule.remove',
                    getActionInvocationContext: function () {
                        return {
                            selectedRule: _this.selectedRule
                        };
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available && _this.gridOptions.selectedItems.length > 0;
                    }
                }];
            this.datagridActionBarServiceCacheObject = null;
            this.gridOptions = sdrsRulesService.getMasterGridOptions(function () {
                _this.onDataBound();
            });
            $scope.$watch("ctrl.gridOptions.selectedItems", this.onSelectedRuleChange.bind(this));
            $scope.$watch(function () {
                return _this.selectedRule;
            }, function () {
                _this.refreshActionBar();
            });
            var filterPlaceholderText = this.i18nService.getString('Common', 'filter.label');
            var filterButtonText = i18nService.getString('Common', 'applyFilter.label');
            this.filterElement = $compile("<div class=\"filter-input pull-right\">\n                <button class=\"nav-icon fa fa-filter filter-button\" ng-click=\"doSearch()\"\n                      aria-label=\"" + filterButtonText + "\" /></button>\n                <input type=\"text\" ng-model=\"searchTerm\" ng-trim=\"true\"\n                ng-change=\"debouncedRefreshCallback()\"\n                ng-keypress=\"keyPress($event)\"\n                placeholder=\"" + filterPlaceholderText + "\"/></div>")($scope);
            $scope.doSearch = function () {
                _this.doSearch();
            };
            $scope.keyPress = function (event) {
                _this.handleKeyPress(event);
            };
            this.getViewData();
            this.createActionBar();
        }
        SdrsRulesViewController.prototype.doSearch = function () {
            this.getViewData();
        };
        SdrsRulesViewController.prototype.handleKeyPress = function (event) {
            if (event.keyCode === 13) {
                // In IE Enter would activate the focused item so
                // we prevent this default behavior.
                event.preventDefault();
                event.stopPropagation();
                this.getViewData();
            }
        };
        SdrsRulesViewController.prototype.getViewData = function () {
            var _this = this;
            this.sdrsRulesService.getMasterViewData(this.objectId, this.$scope.searchTerm).then(function (data) {
                _this.gridOptions.data = _.map(data, function (rule) {
                    return angular.merge({
                        _original: rule
                    }, rule);
                });
                _this.keepSelectionOrPreselectFirst();
                _this.refreshActionBar();
            });
        };
        SdrsRulesViewController.prototype.createActionBar = function () {
            var _this = this;
            this.datagridActionBarService
                .updateActionBar(this.gridOptions, [this.objectId], this.actionSpecs)
                .then(function (value) {
                _this.datagridActionBarServiceCacheObject = value;
            });
        };
        SdrsRulesViewController.prototype.refreshActionBar = function () {
            if (!this.datagridActionBarServiceCacheObject) {
                return;
            }
            this.datagridActionBarService.updateActionBar(this.gridOptions, [this.objectId], this.actionSpecs, this.datagridActionBarServiceCacheObject);
        };
        ;
        SdrsRulesViewController.prototype.rulesPreselectComparator = function (ruleItem) {
            return this.selectedRule && ruleItem &&
                this.selectedRule.rule.name === ruleItem.rule.name;
        };
        SdrsRulesViewController.prototype.onSelectedRuleChange = function (newSelectedItems) {
            if (!newSelectedItems || newSelectedItems.length === 0) {
                this.selectedRule = null;
                return;
            }
            //compare new selected item name with current selected rule name
            //instead of with old selected item name from grid to prevent changing the
            //selecting rule twice on preselect and triggering its watcher twice
            if (this.selectedRule && newSelectedItems[0].rule.name ===
                this.selectedRule.rule.name) {
                return;
            }
            this.selectedRule = newSelectedItems[0]._original;
        };
        SdrsRulesViewController.prototype.keepSelectionOrPreselectFirst = function () {
            var _this = this;
            if (this.gridOptions.data && this.gridOptions.data.length > 0) {
                var itemToPreselect = void 0;
                if (this.selectedRule) {
                    itemToPreselect = _.find(this.gridOptions.data, function (ruleRow) {
                        return ruleRow.rule.name === _this.selectedRule.rule.name;
                    });
                }
                this.selectedRule = !!itemToPreselect ?
                    itemToPreselect._original : this.gridOptions.data[0]._original;
            }
        };
        SdrsRulesViewController.prototype.onDataBound = function () {
            if (!this.isFilterAdded) {
                this.addToolbarFilter();
            }
        };
        SdrsRulesViewController.prototype.addToolbarFilter = function () {
            var grid = this.getGridElement();
            if (grid) {
                var toolbarElement = grid.find('.k-grid-toolbar');
                if (toolbarElement.length > 0) {
                    toolbarElement.append(this.filterElement);
                    this.isFilterAdded = true;
                }
            }
        };
        SdrsRulesViewController.prototype.getGridElement = function () {
            var element = this.$element.find('.k-grid-content');
            return element && element.parent();
        };
        SdrsRulesViewController.$inject = ["$scope", "$compile", "$element",
            "sdrsRulesService", "dsClusterConstants",
            "datagridActionBarService", "i18nService"];
        return SdrsRulesViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("SdrsRulesViewController", SdrsRulesViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var VmAntiAffinityRuleDetailsController = (function () {
        function VmAntiAffinityRuleDetailsController($rootScope, i18nService, sdrsRulesService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.sdrsRulesService = sdrsRulesService;
            this.ruleDetailsTitle = i18nService.getString("DsClusterUi", "manage.settings.sdrsRuleDetails");
            this.ruleDetailsDescription = i18nService.getString("DsClusterUi", "sdrs.rules.view.vm.details.hint");
        }
        VmAntiAffinityRuleDetailsController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (typeof changes.rule !== "undefined") {
                this.gridOptions = this.sdrsRulesService.getVmDetailsGridOptions();
                this.sdrsRulesService.getVmDetailsViewData(changes.rule.currentValue)
                    .then(function (data) {
                    _this.selectedRuleDetails = {
                        "data": data,
                        "formattedData": function () {
                            return _.map(data, function (member) {
                                return {
                                    "id": member.id,
                                    "icon": member.primaryIconId,
                                    "name": member.name,
                                    "rawData": {
                                        datastoreNames: [member.datastoreName],
                                        datastoreHint: member.datastoreHint
                                    }
                                };
                            });
                        }
                    };
                    _this.gridOptions.data = data;
                });
            }
        };
        VmAntiAffinityRuleDetailsController.$inject = ["$rootScope", "i18nService", "sdrsRulesService"];
        return VmAntiAffinityRuleDetailsController;
    }());
    var VmAntiAffinityRuleDetailsComponent = (function () {
        function VmAntiAffinityRuleDetailsComponent() {
            this.controller = VmAntiAffinityRuleDetailsController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/" +
                    "vmAndVmdkAntiAffinityRuleDetailsComponent.html";
            this.bindings = {
                rule: "<",
                selectedRuleDetails: "="
            };
        }
        return VmAntiAffinityRuleDetailsComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("vmAntiAffinityRuleDetailsComponent", new VmAntiAffinityRuleDetailsComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var VmdkAntiAffinityRuleDetailsController = (function () {
        function VmdkAntiAffinityRuleDetailsController($rootScope, i18nService, sdrsRulesService) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.sdrsRulesService = sdrsRulesService;
            this.ruleDetailsTitle = i18nService.getString("DsClusterUi", "manage.settings.sdrsRuleDetails");
            this.ruleDetailsDescription = i18nService.getString("DsClusterUi", "sdrs.rules.view.vmdk.details.hint");
        }
        VmdkAntiAffinityRuleDetailsController.prototype.$onChanges = function (changes) {
            var _this = this;
            if (typeof changes.rule !== "undefined") {
                this.gridOptions = this.sdrsRulesService.getVmdkDetailsGridOptions();
                this.sdrsRulesService.getVmdkDetailsViewData(changes.rule.currentValue)
                    .then(function (data) {
                    _this.selectedRuleDetails = {
                        "data": data,
                        "formattedData": function () {
                            return _.map(data, function (member) {
                                return {
                                    "name": member.name,
                                    "rawData": {
                                        deviceInfo: {
                                            label: member.deviceInfo.label
                                        }
                                    }
                                };
                            });
                        }
                    };
                    _this.gridOptions.data = data;
                });
            }
        };
        VmdkAntiAffinityRuleDetailsController.$inject = ["$rootScope", "i18nService", "sdrsRulesService"];
        return VmdkAntiAffinityRuleDetailsController;
    }());
    var VmdkAntiAffinityRuleDetailsComponent = (function () {
        function VmdkAntiAffinityRuleDetailsComponent() {
            this.controller = VmdkAntiAffinityRuleDetailsController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/" +
                    "vmAndVmdkAntiAffinityRuleDetailsComponent.html";
            this.bindings = {
                rule: "<",
                selectedRuleDetails: "="
            };
        }
        return VmdkAntiAffinityRuleDetailsComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("vmdkAntiAffinityRuleDetailsComponent", new VmdkAntiAffinityRuleDetailsComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddSdrsVmOverridesController = (function () {
        function AddSdrsVmOverridesController($scope, datagridActionBarService, dataService, i18nService, dsClusterConstants, mutationService, addSdrsVmOverridesService, addVmOverridesPageService, storageVmOverridesService, vuiConstants) {
            var _this = this;
            this.$scope = $scope;
            this.datagridActionBarService = datagridActionBarService;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            this.mutationService = mutationService;
            this.addSdrsVmOverridesService = addSdrsVmOverridesService;
            this.addVmOverridesPageService = addVmOverridesPageService;
            this.storageVmOverridesService = storageVmOverridesService;
            this.vuiConstants = vuiConstants;
            this.objectId = $scope._route.objectId;
            this.splitterOptions = this.addSdrsVmOverridesService.getSplitterOptions();
            this.spec = {};
            this.selectedVms = [];
            if ($scope.modalOptions.dialogData.mode ===
                this.dsClusterConstants.vmOverridesOperationType.EDIT) {
                this.selectedVms = $scope.modalOptions.dialogData.context;
                this.spec.mode = this.dsClusterConstants.vmOverridesOperationType.EDIT;
            }
            else {
                this.spec.mode = this.dsClusterConstants.vmOverridesOperationType.ADD;
            }
            $scope.modalOptions.onSubmit = function () {
                _this.$scope.modalOptions.isAlertClosed = true;
                _this.$scope.modalOptions.alerts = [];
                if (_this.spec.keepVmdksChecked || _this.spec.sdrsAutomationLevel
                    || _this.spec.mode === _this.dsClusterConstants.vmOverridesOperationType.EDIT) {
                    var keepVmdksValue = _this.spec.keepVmdksChecked ?
                        _this.spec.keepVmdksValue :
                        _this.dsClusterConstants.keepVmdksValues.clusterDefault;
                    var sdrsAutomationLevelValue = _this.spec.sdrsAutomationLevel ?
                        _this.spec.sdrsAutomationLevelValue :
                        _this.dsClusterConstants.sdrsVmOverridesAutomationLevels.clusterDefault;
                    var addOverrideSpec_1 = _this.addVmOverridesPageService
                        .getOverrideSpec(_this.selectedVms, sdrsAutomationLevelValue, keepVmdksValue, _this.spec.mode);
                    _this.mutationService.validate(_this.objectId, _this.dsClusterConstants.SDRS_VM_OVERRIDE_SPEC, addOverrideSpec_1).then(function (response) {
                        if (response && response.result && response.result.length > 0) {
                            var alert_1 = _this.storageVmOverridesService
                                .getVmOverrideErrorMessages(response.result);
                            _this.$scope.modalOptions.alerts = [alert_1];
                            _this.$scope.modalOptions.isAlertClosed = false;
                        }
                        else {
                            _this.mutationService.apply(_this.objectId, _this.dsClusterConstants.SDRS_VM_OVERRIDE_SPEC, addOverrideSpec_1);
                            _this.$scope.closeModal();
                        }
                    });
                }
                else {
                    _this.$scope.modalOptions.alerts = [{
                            text: _this.i18nService.getString("DsClusterUi", "vm.overrides.config.noChangesValidationError"),
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        }];
                    _this.$scope.modalOptions.isAlertClosed = false;
                }
                return false;
            };
        }
        AddSdrsVmOverridesController.$inject = ["$scope",
            "datagridActionBarService", "dataService",
            "i18nService", "dsClusterConstants", "mutationService",
            "addSdrsVmOverridesService", "addVmOverridesPageService",
            "storageVmOverridesService", "vuiConstants"];
        return AddSdrsVmOverridesController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("AddSdrsVmOverridesController", AddSdrsVmOverridesController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmOverridesController = (function () {
        function AddVmOverridesController($scope) {
            this.$scope = $scope;
            this.selectedVms = $scope.manager.getSelectedVms();
            this.spec = $scope.manager.getSpec();
        }
        AddVmOverridesController.$inject = ["$scope"];
        return AddVmOverridesController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("AddVmOverridesController", AddVmOverridesController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var RemoveSdrsVmOverridesController = (function () {
        function RemoveSdrsVmOverridesController($scope, storageVmOverridesService, dsClusterConstants) {
            var _this = this;
            this.$scope = $scope;
            this.storageVmOverridesService = storageVmOverridesService;
            this.dsClusterConstants = dsClusterConstants;
            this.INTRA_VM_AFFINITY_CLUSTER_DEFAULT = "ClusterDefault";
            this.objectId = $scope._route.objectId;
            this.selectedVms = $scope.modalOptions.dialogData.context;
            this.$scope.modalOptions.alerts = [];
            $scope.modalOptions.onSubmit = function () {
                _this.$scope.modalOptions.isAlertClosed = true;
                _this.$scope.modalOptions.alerts = [];
                var spec = _this.getRemoveSpec();
                _this.storageVmOverridesService.validateVmOverride(_this.objectId, spec)
                    .then(function (response) {
                    if (response) {
                        var errors = response.result;
                        if (errors && errors.length > 0) {
                            var alert_1 = _this.storageVmOverridesService
                                .getVmOverrideErrorMessages(errors);
                            _this.$scope.modalOptions.isAlertClosed = false;
                            _this.$scope.modalOptions.alerts = [alert_1];
                        }
                        else {
                            _this.storageVmOverridesService.removeVmOverride(_this.objectId, spec);
                            _this.$scope.closeModal();
                        }
                    }
                });
            };
        }
        RemoveSdrsVmOverridesController.prototype.getRemoveSpec = function () {
            var _this = this;
            var operation = this.dsClusterConstants.vmOverridesOperationType.REMOVE;
            return {
                vmOverrides: _.map(this.selectedVms, function (selectedVm) {
                    return {
                        vmSor: selectedVm.vm.provider,
                        intraVmAffinity: _this.INTRA_VM_AFFINITY_CLUSTER_DEFAULT
                    };
                }),
                operation: operation
            };
        };
        RemoveSdrsVmOverridesController.$inject = ["$scope", "storageVmOverridesService",
            "dsClusterConstants"];
        return RemoveSdrsVmOverridesController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("RemoveSdrsVmOverridesController", RemoveSdrsVmOverridesController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SelectVmsToOverrideController = (function () {
        function SelectVmsToOverrideController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            var dsClusterId = $scope.manager.getTargetUid();
            var selectedVms = $scope.manager.getSelectedVms();
            var selectorConfig = {
                objectType: "VirtualMachine",
                listViewId: "vsphere.core.vm.members.list"
            };
            var filter = "dsClusterVmOverridesExceptSecondaryVmsAndOverridedVmsFilter";
            this.config = {
                contextObject: dsClusterId,
                multipleSelect: true,
                listTabConfig: {
                    listConfig: [{
                            label: i18nService.getString("Common", "typeResource.vmPlural"),
                            listViewId: selectorConfig.listViewId,
                            dataModels: [selectorConfig.objectType],
                            filterId: filter
                        }]
                },
                selectedObjects: _.map(selectedVms, function (vm) {
                    return vm.id;
                }),
                onSelectionChanged: function (newSelectedItems) {
                    $scope.manager.setSelectedVms(newSelectedItems);
                }
            };
        }
        SelectVmsToOverrideController.$inject = ["$scope", "i18nService"];
        return SelectVmsToOverrideController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("SelectVmsToOverrideController", SelectVmsToOverrideController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var SelectVmToVmOverrideComponentController = (function () {
        function SelectVmToVmOverrideComponentController($rootScope, $scope, addSdrsVmOverridesService, datagridActionBarService) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.addSdrsVmOverridesService = addSdrsVmOverridesService;
            this.datagridActionBarService = datagridActionBarService;
            this.objectId = $rootScope._route.objectId;
            this.gridOptions =
                this.addSdrsVmOverridesService.getSdrsVmOverridesGridOptions(this.selectedVms);
            this.watchForObjects = [this.objectId];
        }
        SelectVmToVmOverrideComponentController.$inject = ["$rootScope", "$scope",
            "addSdrsVmOverridesService", "datagridActionBarService"];
        return SelectVmToVmOverrideComponentController;
    }());
    var SelectVmToVmOverrideComponent = (function () {
        function SelectVmToVmOverrideComponent() {
            this.controller = SelectVmToVmOverrideComponentController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration" +
                    "/sdrsVmOverrides/selectVmToVmOverrideComponent.html";
            this.bindings = {
                selectedVms: "="
            };
        }
        return SelectVmToVmOverrideComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("selectVmToVmOverrideComponent", new SelectVmToVmOverrideComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var VmOverridesServicesComponentController = (function () {
        function VmOverridesServicesComponentController($rootScope, $scope, addVmOverridesPageService, addSdrsVmOverridesService, dataService, i18nService, dsClusterConstants) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.addVmOverridesPageService = addVmOverridesPageService;
            this.addSdrsVmOverridesService = addSdrsVmOverridesService;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            this.STORAGE_POD_AUTOMATION_LEVEL_PROPERTY = "podStorageDrsEntry/storageDrsConfig/podConfig/defaultVmBehavior";
            this.DEFAULT_INTRA_VM_AFFINITY_PROPERTY = "podStorageDrsEntry/storageDrsConfig/podConfig/defaultIntraVmAffinity";
            this.i18n = i18nService.getString;
            this.objectId = $rootScope._route.objectId;
            this.sdrsAutomationSectionTitle = this.i18nService.getString("DsClusterUi", "vmOverrides.services.sdrs");
            this.sdrsAutomationLabel = this.i18nService.getString("DsClusterUi", "vmOverrides.sdrsAutomationLevelHeaderText");
            this.sdrsAutomationLevel = false;
            this.storagePodSdrsAutomationText = "";
            this.sdrsAutomationLevels =
                this.addVmOverridesPageService.createAutomationLevelsMap();
            this.keepVdmkTogetherValuesMap =
                this.addVmOverridesPageService.createKeepVdmkTogetherValuesMap();
            this.keepVdmkTogetherLabel = this.i18nService.getString("DsClusterUi", "vmOverrides.intraVmAffinityHeaderText");
            this.areVmsWithEqualIntraVmAffinityValues = true;
            this.areVmsWithEqualSdrsAutomationValues = true;
            this.multipleEditWarningMessage = '';
            this.getViewData();
        }
        VmOverridesServicesComponentController.prototype.updateSdrsAutomationLevelValue = function () {
            if (!this.spec.sdrsAutomationLevel) {
                this.spec.sdrsAutomationLevelValue = this.sdrsDefaultValue;
            }
        };
        VmOverridesServicesComponentController.prototype.updateVdmkTogetherlValue = function () {
            if (!this.spec.keepVmdksChecked) {
                this.spec.keepVmdksValue = this.keepVmdkTogetherDefaultValue;
            }
        };
        VmOverridesServicesComponentController.prototype.editPreselectionOfUiElements = function () {
            if (this.selectedVms && this.selectedVms.length > 0 && this.selectedVms[0].rawData) {
                this.setIntraVmAffinity();
                this.setSdrsAutomationLevel();
            }
        };
        VmOverridesServicesComponentController.prototype.setSdrsAutomationLevel = function () {
            if (!this.areVmsWithEqualSdrsAutomationValues) {
                this.sdrsAutomationLevels = _.extend({
                    useInitialValues: {
                        id: "useInitialValues",
                        label: this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.useInitialValues"),
                        value: this.dsClusterConstants.sdrsVmOverridesAutomationLevels.useInitialValues
                    }
                }, this.sdrsAutomationLevels);
                this.spec.sdrsAutomationLevelValue =
                    this.dsClusterConstants.sdrsVmOverridesAutomationLevels.useInitialValues;
                this.spec.sdrsAutomationLevel = true;
            }
            else {
                var sdrsAutomationLevelForVm = this.addVmOverridesPageService.getSdrsAutomationLevelForVm(this.selectedVms[0]);
                this.spec.sdrsAutomationLevel = sdrsAutomationLevelForVm.sdrsAutomationLevel;
                this.spec.sdrsAutomationLevelValue =
                    sdrsAutomationLevelForVm.sdrsAutomationLevelValue;
            }
        };
        VmOverridesServicesComponentController.prototype.setIntraVmAffinity = function () {
            if (this.areVmsWithEqualIntraVmAffinityValues) {
                var intraVmAffinityForVm = this.addVmOverridesPageService.getIntraVmAffinityValueForAVm(this.selectedVms[0]);
                this.spec.keepVmdksChecked = intraVmAffinityForVm.keepVmdksChecked;
                this.spec.keepVmdksValue = intraVmAffinityForVm.keepVmdksValue;
            }
            else {
                this.keepVdmkTogetherValuesMap = _.extend({
                    useInitialValues: {
                        id: "useInitialValues",
                        label: this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.useInitialValues"),
                        value: this.dsClusterConstants.keepVmdksValues.useInitialValues
                    }
                }, this.keepVdmkTogetherValuesMap);
                this.spec.keepVmdksValue =
                    this.dsClusterConstants.keepVmdksValues.useInitialValues;
            }
        };
        VmOverridesServicesComponentController.prototype.initAddSdrsVmOverridesData = function (response) {
            var automationLevelKey = response[this.STORAGE_POD_AUTOMATION_LEVEL_PROPERTY];
            var automationLevel = this.sdrsAutomationLevels[automationLevelKey].label;
            this.sdrsDefaultValue = this.sdrsAutomationLevels[automationLevelKey].id;
            this.spec.sdrsAutomationLevelValue = this.sdrsDefaultValue;
            this.spec.sdrsAutomationLevelDefaultValue = this.sdrsDefaultValue;
            this.keepVmdkTogetherDefaultValue = response[this.DEFAULT_INTRA_VM_AFFINITY_PROPERTY] ?
                this.keepVdmkTogetherValuesMap.keepVmdksTogether.value :
                this.keepVdmkTogetherValuesMap.doNotKeepVmdksTogether.value;
            this.spec.keepVmdksValue = this.keepVmdkTogetherDefaultValue;
            this.spec.keepVmdksDefaultValue = this.keepVmdkTogetherDefaultValue;
            this.keepVdmkTogetherText =
                response[this.DEFAULT_INTRA_VM_AFFINITY_PROPERTY] ?
                    this.i18nService.getString("Common", "yes.label") :
                    this.i18nService.getString("Common", "no.label");
            this.storagePodSdrsAutomationText = automationLevel;
        };
        VmOverridesServicesComponentController.prototype.initValidationResultsForEditMultipleVms = function () {
            var identityResults = this.addSdrsVmOverridesService.getEditMultipleVmOverridesIdentityResults(this.selectedVms);
            this.areVmsWithEqualIntraVmAffinityValues =
                identityResults.vmsAreWithEqualIntraVmAffinity;
            this.areVmsWithEqualSdrsAutomationValues =
                identityResults.vmsAreWithEqualSdrsAutomationLevel;
            var differentVmOverridesCount = 0;
            if (!this.areVmsWithEqualIntraVmAffinityValues) {
                this.spec.keepVmdksChecked = true;
                this.intraVmAffinityLevelSignPostParams =
                    this.addSdrsVmOverridesService.buildVuiSignPostIntraVmAffinityLevel(this.selectedVms);
                differentVmOverridesCount++;
            }
            if (!this.areVmsWithEqualSdrsAutomationValues) {
                this.sdrsAutomationLevelSignPostParams =
                    this.addSdrsVmOverridesService.buildVuiSignPostSdrsAutomationLevel(this.selectedVms);
                differentVmOverridesCount++;
            }
            if (differentVmOverridesCount > 0) {
                var countAsString = differentVmOverridesCount === 1 ?
                    this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.warningMessage.one") :
                    this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.warningMessage.two");
                this.multipleEditWarningMessage =
                    this.i18nService.getString("DsClusterUi", "vmOverrides.config.editMultiple.warningMessage", countAsString);
            }
        };
        VmOverridesServicesComponentController.prototype.getViewData = function () {
            var _this = this;
            this.dataService.getProperties(this.objectId, [this.STORAGE_POD_AUTOMATION_LEVEL_PROPERTY,
                this.DEFAULT_INTRA_VM_AFFINITY_PROPERTY])
                .then(function (response) {
                _this.initAddSdrsVmOverridesData(response);
                if (_this.spec.mode === _this.dsClusterConstants.vmOverridesOperationType.EDIT) {
                    _this.initValidationResultsForEditMultipleVms();
                    _this.editPreselectionOfUiElements();
                }
            });
        };
        VmOverridesServicesComponentController.$inject = ["$rootScope", "$scope", "addVmOverridesPageService",
            "addSdrsVmOverridesService", "dataService", "i18nService", "dsClusterConstants"];
        return VmOverridesServicesComponentController;
    }());
    var VmOverridesServicesComponent = (function () {
        function VmOverridesServicesComponent() {
            this.controller = VmOverridesServicesComponentController;
            this.templateUrl =
                "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/" +
                    "sdrsVmOverrides/vmOverridesServicesComponent.html";
            this.bindings = {
                spec: "=",
                selectedVms: "="
            };
        }
        return VmOverridesServicesComponent;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster").component("vmOverridesServicesComponent", new VmOverridesServicesComponent());
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageVmOverridesController = (function () {
        function StorageVmOverridesController($scope, storageVmOverridesService, datagridActionBarService, dsClusterConstants) {
            var _this = this;
            this.storageVmOverridesService = storageVmOverridesService;
            this.datagridActionBarService = datagridActionBarService;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = $scope._route.objectId;
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.STORAGE_DRS_CONFIG];
            this.gridOptions = storageVmOverridesService.getGridOptions();
            this.getViewData();
            this.actions = [{
                    actionId: "vsphere.core.dscluster.actions.vmOverrides.add"
                }, {
                    actionId: "vsphere.core.dscluster.actions.vmOverrides.edit",
                    getActionInvocationContext: function () {
                        return _this.gridOptions.selectedItems;
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available &&
                            _this.gridOptions.selectedItems.length >= 1;
                    }
                }, {
                    actionId: "vsphere.core.dscluster.actions.vmoverrides.remove",
                    getActionInvocationContext: function () {
                        return _this.gridOptions.selectedItems;
                    },
                    isActionAvailable: function (actionDef) {
                        return actionDef.available &&
                            _this.gridOptions.selectedItems.length > 0;
                    }
                }];
            this.createActionBar();
            $scope.$watch(function () {
                return _this.gridOptions.selectedItems;
            }, this.onSelectedVmOverrideChange.bind(this));
            $scope.overridesPreselectComparator =
                this.overridesPreselectComparator.bind(this);
        }
        StorageVmOverridesController.prototype.overridesPreselectComparator = function (override) {
            return this.selectedOverrides && override &&
                _.some(this.selectedOverrides, function (selected) {
                    return selected.vm.name === override.vm.name;
                });
        };
        StorageVmOverridesController.prototype.getViewData = function () {
            var _this = this;
            this.storageVmOverridesService.getViewData(this.objectId).then(function (data) {
                _this.gridOptions.data = data;
            });
        };
        StorageVmOverridesController.prototype.onSelectedVmOverrideChange = function (newSelectedOverrides) {
            if (!newSelectedOverrides || newSelectedOverrides.length === 0) {
                this.selectedOverrides = null;
            }
            else {
                this.selectedOverrides = newSelectedOverrides;
            }
            this.refreshActionBar();
        };
        StorageVmOverridesController.prototype.refreshActionBar = function () {
            if (!this.datagridActionBarServiceCacheObject) {
                return;
            }
            this.datagridActionBarService.updateActionBar(this.gridOptions, [this.objectId], this.actions, this.datagridActionBarServiceCacheObject);
        };
        StorageVmOverridesController.prototype.createActionBar = function () {
            var _this = this;
            this.datagridActionBarService
                .updateActionBar(this.gridOptions, [this.objectId], this.actions)
                .then(function (value) {
                _this.datagridActionBarServiceCacheObject = value;
            });
        };
        StorageVmOverridesController.$inject = ["$scope", "storageVmOverridesService",
            "datagridActionBarService", "dsClusterConstants"];
        return StorageVmOverridesController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("StorageVmOverridesController", StorageVmOverridesController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var cluster_ui;
(function (cluster_ui) {
    var EditSdrsDialogController = (function () {
        function EditSdrsDialogController($scope, dataService, $timeout) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.$timeout = $timeout;
            $scope.pages = {
                categories: $scope.modalOptions.dialogData.manager.getPageDefinitions()
            };
            $scope.selectedCategoryId = $scope.pages.categories[0].id;
            $scope.selectCategory = function (categoryId) {
                _this.$scope.selectedCategoryId = categoryId;
            };
            $scope.enableButtonAutofocus = true;
            this.getViewData();
            this.onTabsClick = function () {
                if ($scope.enableButtonAutofocus) {
                    $scope.enableButtonAutofocus = false;
                }
            };
        }
        EditSdrsDialogController.prototype.getSelectedPageUrl = function () {
            var _this = this;
            var selectedPage = _.find(this.$scope.pages.categories, function (page) {
                return page.id === _this.$scope.selectedCategoryId;
            });
            if (selectedPage) {
                return selectedPage.contentUrl;
            }
            return "";
        };
        EditSdrsDialogController.prototype.getViewData = function () {
            var _this = this;
            this.setPageBusy(true);
            this.dataService.getData(this.$scope.modalOptions.dialogData.objectId, "com.vmware.vsphere.client.dsclusterui.model.DsClusterEditSdrsData")
                .then(function (data) {
                _.extend(_this.$scope.modalOptions.dialogData.sdrsData, data);
                _this.pageModel = _this.$scope.modalOptions.dialogData.manager
                    .getStorageDrsAutomationModel();
                _this.setPageBusy(false);
                _this.$timeout(function () {
                    $("#dsClusterEditSdrsEnabledCheckbox").focus();
                }, 1);
            });
        };
        EditSdrsDialogController.prototype.setPageBusy = function (busy) {
            this.loading = busy;
            this.$scope.modalOptions.submitDisabled = busy;
        };
        EditSdrsDialogController.$inject = ["$scope", "dataService", "$timeout"];
        return EditSdrsDialogController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("EditSdrsDialogController", EditSdrsDialogController);
})(cluster_ui || (cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsAdvancedOptionsPageViewController = (function () {
        function StorageDrsAdvancedOptionsPageViewController($scope, storageDrsAdvancedOptionsService, dsClusterConstants, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.storageDrsAdvancedOptionsService = storageDrsAdvancedOptionsService;
            this.dsClusterConstants = dsClusterConstants;
            this.i18nService = i18nService;
            var sdrsManager = $scope.modalOptions.dialogData.manager;
            this.pageModel = sdrsManager.getStorageDrsAdvancedOptionsModel();
            var unitKey = this.pageModel.convertedLoadBalanceInterval.unitKey;
            this.pageModel.convertedLoadBalanceInterval.unit =
                this.i18nService.getString("DsClusterUi", this.pageModel.convertedLoadBalanceInterval.value === 1 ? unitKey + "S" : unitKey);
            $scope.$watch("sdrsAdvancedOptionsForm.$invalid", function (isInvalid) {
                sdrsManager.setFormValidationResult(!isInvalid);
            });
            this.initLoadBalanceInterval();
            this.initMinUtilizationDifference();
            this.ioImbalanceThresholdSliderOptions = this.storageDrsAdvancedOptionsService
                .getIoImbalanceThresholdSliderOptions(this.pageModel.ioLoadImbalanceThreshold, this.i18nService.getString("DsClusterUi", "sdrs.config.ioImbalanceThresholdLabel"));
            // Watch for changes on the slider value and propagate it to the model.
            $scope.$watch(function () { return _this.ioImbalanceThresholdSliderOptions.value; }, function (ioImbalanceThreshold) {
                _this.pageModel.ioLoadImbalanceThreshold = parseInt(ioImbalanceThreshold, 10);
            });
        }
        StorageDrsAdvancedOptionsPageViewController.prototype.initMinUtilizationDifference = function () {
            var _this = this;
            this.minUtilizationDifferenceMin =
                this.dsClusterConstants.minSpaceUtilizationDifference.MIN;
            this.minUtilizationDifferenceMax =
                this.dsClusterConstants.minSpaceUtilizationDifference.MAX;
            this.$scope.$watch("ctrl.pageModel.spaceLoadBalanceConfig.minSpaceUtilizationDifference", function (value) {
                if (value > _this.minUtilizationDifferenceMax) {
                    _this.pageModel.spaceLoadBalanceConfig.minSpaceUtilizationDifference =
                        _this.minUtilizationDifferenceMax;
                }
                if (value < _this.minUtilizationDifferenceMin) {
                    _this.pageModel.spaceLoadBalanceConfig.minSpaceUtilizationDifference =
                        _this.minUtilizationDifferenceMin;
                }
            });
        };
        StorageDrsAdvancedOptionsPageViewController.prototype.initLoadBalanceInterval = function () {
            this.loadBalanceUnitOptions =
                this.storageDrsAdvancedOptionsService.getUnitOptions();
            this.loadBalanceIntervalOptions =
                this.storageDrsAdvancedOptionsService.getIntervalOptions(this.pageModel);
            this.loadBalanceIntervalErrorMessages =
                this.storageDrsAdvancedOptionsService.getErrorMessages();
        };
        StorageDrsAdvancedOptionsPageViewController.$inject = ["$scope", "storageDrsAdvancedOptionsService",
            "dsClusterConstants", "i18nService"];
        return StorageDrsAdvancedOptionsPageViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("StorageDrsAdvancedOptionsPageViewController", StorageDrsAdvancedOptionsPageViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsAutomationPageViewController = (function () {
        function StorageDrsAutomationPageViewController($scope, storageDrsAutomationService) {
            this.$scope = $scope;
            this.storageDrsAutomationService = storageDrsAutomationService;
            this.sdrsManager = $scope.modalOptions.dialogData.manager;
            this.pageModel = this.sdrsManager.getStorageDrsAutomationModel();
            this.enableButtonAutofocus = $scope.enableButtonAutofocus;
        }
        StorageDrsAutomationPageViewController.$inject = ["$scope", "storageDrsAutomationService"];
        return StorageDrsAutomationPageViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("StorageDrsAutomationPageViewController", StorageDrsAutomationPageViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsRuntimeSettingsPageViewController = (function () {
        function StorageDrsRuntimeSettingsPageViewController($scope, i18nService, dsClusterConstants) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            var sdrsManager = $scope.modalOptions.dialogData.manager;
            this.pageModel = sdrsManager.getStorageDrsRuntimeSettingsModel();
            this.pageModel.isInEditMode = true;
        }
        StorageDrsRuntimeSettingsPageViewController.$inject = ["$scope", "i18nService", "dsClusterConstants"];
        return StorageDrsRuntimeSettingsPageViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("StorageDrsRuntimeSettingsPageViewController", StorageDrsRuntimeSettingsPageViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var ScheduleSdrsSdrsSettingsPageController = (function () {
        function ScheduleSdrsSdrsSettingsPageController($scope, dataService, vcService, $q, $timeout) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.vcService = vcService;
            this.$q = $q;
            this.$timeout = $timeout;
            this.objectId = $scope.modalOptions.dialogData.objectId;
            this.$scope.modalOptions.dialogData.manager.initManager({}, this.$scope.modalOptions);
            this.$scope.modalOptions.isAlertClosed = true;
            $scope.enableButtonAutofocus = true;
            this.onTabsClick = function () {
                if ($scope.enableButtonAutofocus) {
                    $scope.enableButtonAutofocus = false;
                }
            };
            this.getViewData();
        }
        ScheduleSdrsSdrsSettingsPageController.prototype.getSelectedPageUrl = function () {
            var _this = this;
            var selectedPage = _.find(this.$scope.pages.categories, function (page) {
                return page.id === _this.$scope.selectedCategoryId;
            });
            return selectedPage ? selectedPage.contentUrl : "";
        };
        ScheduleSdrsSdrsSettingsPageController.prototype.getViewData = function () {
            var _this = this;
            this.setPageBusy(true);
            this.$scope.pages = {
                categories: this.$scope.modalOptions.dialogData.manager.getPageDefinitions()
            };
            this.$scope.selectedCategoryId = this.$scope.pages.categories[0].id;
            this.$scope.selectCategory = function (categoryId) {
                _this.$scope.selectedCategoryId = categoryId;
            };
            this.dataService.getData(this.$scope.modalOptions.dialogData.objectId, "com.vmware.vsphere.client.dsclusterui.model.DsClusterEditSdrsData")
                .then(function (data) {
                _.extend(_this.$scope.modalOptions.dialogData.manager.sdrsData, data);
                _this.formData = _this.$scope.modalOptions.dialogData.manager.getSheduleModel();
                _this.setPageBusy(false);
                _this.addWatchers();
                _this.$timeout(function () {
                    $("#dsClusterEditSdrsEnabledCheckbox").focus();
                }, 1);
            });
        };
        ScheduleSdrsSdrsSettingsPageController.prototype.setPageBusy = function (busy) {
            this.loading = busy;
            this.$scope.modalOptions.submitDisabled = busy;
        };
        ScheduleSdrsSdrsSettingsPageController.prototype.addWatchers = function () {
            var _this = this;
            this.$scope.$watch('ctrl.formData', function () {
                _this.$scope.manager.setFormData(_this.$scope.modalOptions.dialogData.manager.getFormData());
            }, true);
        };
        ScheduleSdrsSdrsSettingsPageController.$inject = ["$scope", "dataService", "vcService", "$q", "$timeout"];
        return ScheduleSdrsSdrsSettingsPageController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("ScheduleSdrsSdrsSettingsPageController", ScheduleSdrsSdrsSettingsPageController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var ScheduleSdrsWizardManager = (function () {
        function ScheduleSdrsWizardManager(i18nService, vuiConstants, mutationService, defaultUriSchemeUtil, $rootScope, wizardPageService, vscSchedulingHelper, $q, dsClusterConstants, dsClusterSpecBuilderService) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$rootScope = $rootScope;
            this.wizardPageService = wizardPageService;
            this.vscSchedulingHelper = vscSchedulingHelper;
            this.$q = $q;
            this.dsClusterConstants = dsClusterConstants;
            this.dsClusterSpecBuilderService = dsClusterSpecBuilderService;
            this.scheduleModel = {};
            this.formData = {};
            this.buildPages();
        }
        /**
         * Retrieves page definitions.
         *
         * @returns {WizardPage[]}
         */
        ScheduleSdrsWizardManager.prototype.getPageDefinitions = function () {
            return [this.scheduleSettingsPageDef,
                this.sdrsSettingsPageDef];
        };
        ScheduleSdrsWizardManager.prototype.getObjectId = function () {
            return this.objectId;
        };
        /**
         * Retrieves wizard model.
         *
         * @returns {DsClusterModel}
         */
        ScheduleSdrsWizardManager.prototype.getModel = function () {
            return this.scheduleModel;
        };
        ScheduleSdrsWizardManager.prototype.setModel = function (model) {
            this.scheduleModel = model;
        };
        ScheduleSdrsWizardManager.prototype.setFormData = function (formData) {
            _.extend(this.formData, formData);
        };
        ScheduleSdrsWizardManager.prototype.submit = function () {
            this.scheduleModel.scheduleTaskSpec.spec =
                this.dsClusterSpecBuilderService.buildDsClusterSpec(this.formData, true);
            this.scheduleModel.scheduleTaskSpec.spec._type = this.dsClusterConstants.DS_CLUSTER_SPEC_TYPE;
            this.scheduleModel.scheduleTaskSpec.schedulingSpec.recurrence =
                this.vscSchedulingHelper.formatRecurrenceData(this.scheduleModel.scheduleTaskSpec.schedulingSpec.recurrence);
            this.mutationService.apply(this.objectId, 'com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec', this.scheduleModel.scheduleTaskSpec);
            return true;
        };
        ScheduleSdrsWizardManager.prototype.getWizardConfig = function () {
            var _this = this;
            if (!this.wizardConfig) {
                this.wizardConfig = {
                    title: this.i18nService.getString("ScheduledOpsUi", "scheduledTask.ScheduleNewTasks.label")
                        + " (" + this.i18nService.getString("DsClusterUi", "sdrs.dialog.edit.title") + ")",
                    pages: this.getPageDefinitions(),
                    show: true,
                    loading: false,
                    loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                    onFinish: function () { return _this.submit(); },
                    cssClass: "schedule-sdrs-wizard",
                };
            }
            return this.wizardConfig;
        };
        /**
         * Initializes wizard model with default values.
         */
        ScheduleSdrsWizardManager.prototype.init = function (objectId) {
            this.objectId = objectId;
            // add new task
            this.scheduleModel = {
                scheduleTaskSpec: {
                    spec: {},
                    operation: 0,
                    entity: this.defaultUriSchemeUtil.getManagedObjectReference(objectId),
                    schedulingSpec: {
                        _type: "com.vmware.vise.core.model.scheduling.ScheduledTaskSpec",
                        scheduledTask: null,
                        recurrence: null,
                        name: "Configure Storage DRS",
                        description: "",
                        source: "StoragePod",
                        enabled: true,
                        notification: ""
                    },
                    deferredOperation: 0,
                    scheduleTaskOperationMode: 0 // add
                }
            };
        };
        ScheduleSdrsWizardManager.prototype.buildPages = function () {
            var _this = this;
            this.scheduleSettingsPageDef = {
                title: this.i18nService.getString("ScheduledOpsUi", "scheduledTask.snapshot.options"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/services/scheduleTask/scheduleSdrsScheduleOptionsPage.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    var recurrence = _this.getModel().scheduleTaskSpec.schedulingSpec.recurrence;
                    var isFormStatusValid = _this.getModel().scheduleTaskSpec.schedulingSpec.isFormStatusValid;
                    if (recurrence && isFormStatusValid) {
                        _this.setModel(_this.getModel());
                        _this.wizardPageService.markPageComplete(_this.wizardConfig);
                        return true;
                    }
                    else {
                        if (!recurrence) {
                            _this.wizardPageService.markPageIncompleteWithError(_this.wizardConfig, _this.i18nService.getString("SchedulingUi", "scheduledTask.emptyScheduler"));
                        }
                        return false;
                    }
                }
            };
            this.sdrsSettingsPageDef = {
                title: this.i18nService.getString("DsClusterUi", "sdrs.schedule.config.pageTitle"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/services/scheduleTask/scheduleSdrsSdrsSettingsPage.html",
                state: this.vuiConstants.wizard.pageState.DISABLED
            };
        };
        ScheduleSdrsWizardManager.$inject = ["i18nService", "vuiConstants", "mutationService",
            "defaultUriSchemeUtil", "$rootScope", "wizardPageService",
            "vscSchedulingHelper", "$q", "dsClusterConstants", "dsClusterSpecBuilderService"];
        return ScheduleSdrsWizardManager;
    }());
    ds_cluster_ui.ScheduleSdrsWizardManager = ScheduleSdrsWizardManager;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("scheduleSdrsWizardManager", ScheduleSdrsWizardManager);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var ScheduleSdrsWizardService = (function () {
        function ScheduleSdrsWizardService($rootScope, i18nService, vuiWizardService, wizardManager, pageStateManagementService, sdrsDialogManager) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiWizardService = vuiWizardService;
            this.wizardManager = wizardManager;
            this.pageStateManagementService = pageStateManagementService;
            this.sdrsDialogManager = sdrsDialogManager;
        }
        /**
         * Displays schedule sdrs wizard.
         */
        ScheduleSdrsWizardService.prototype.show = function (objectId, focusTarget) {
            var wizardScope = this.$rootScope.$new();
            this.wizardManager.init(objectId);
            wizardScope.wizardConfig = this.wizardManager.getWizardConfig();
            wizardScope.manager = this.wizardManager;
            wizardScope.modalOptions = {
                focusTarget: focusTarget,
                dialogData: {
                    manager: this.sdrsDialogManager,
                    objectId: objectId
                }
            };
            this.pageStateManagementService.registerWizardForDefaultStateManagementStrategy(wizardScope);
            this.vuiWizardService({
                scope: wizardScope,
                configObjectName: 'wizardConfig'
            }).show();
        };
        ScheduleSdrsWizardService.$inject = ['$rootScope', 'i18nService', 'vuiWizardService',
            'scheduleSdrsWizardManager', 'pageStateManagementService', 'sdrsDialogManager'];
        return ScheduleSdrsWizardService;
    }());
    ds_cluster_ui.ScheduleSdrsWizardService = ScheduleSdrsWizardService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('scheduleSdrsWizardService', ScheduleSdrsWizardService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var StorageDrsViewController = (function () {
        function StorageDrsViewController($scope, i18nService, storageDrsDataRetrieval, dsClusterConstants) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.storageDrsDataRetrieval = storageDrsDataRetrieval;
            this.dsClusterConstants = dsClusterConstants;
            this.$scope = $scope;
            this.objectId = $scope._route.objectId;
            this.headerOptions = {
                title: this.getString("dscluster.services.drs"),
                objectId: this.objectId,
                actions: [{
                        actionUid: "vsphere.core.dsCluster.actions.scheduleSdrs",
                        customLabel: i18nService.getString("DsClusterUi", "sdrs.config.scheduleSdrs.button.label")
                    }, {
                        actionUid: "vsphere.core.dsCluster.actions.editSdrs",
                        customLabel: i18nService.getString("Common", "settingsView.defaultEditActionLabel")
                    }]
            };
            this.watchForObjects = [this.objectId];
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.STORAGE_DRS_CONFIG];
            this.getViewData();
        }
        StorageDrsViewController.prototype.getViewData = function () {
            var _this = this;
            this.storageDrsDataRetrieval.retrieveData(this.objectId).then(function (sdrsViewModelData) {
                _this.sdrsViewModelData = sdrsViewModelData;
                _this.headerOptions.title = _this.getTitle(sdrsViewModelData.enabled);
            });
        };
        StorageDrsViewController.prototype.getTitle = function (sdrsEnabled) {
            return (sdrsEnabled) ?
                this.getString("sdrs.config.sdrsEnabled")
                : this.getString("sdrs.config.sdrsDisabled");
        };
        StorageDrsViewController.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("DsClusterUi", key, params);
        };
        StorageDrsViewController.$inject = ["$scope", "i18nService", "storageDrsDataRetrieval",
            "dsClusterConstants"];
        return StorageDrsViewController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("StorageDrsViewController", StorageDrsViewController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmOverridesPageService = (function () {
        function AddVmOverridesPageService(vuiAddVmOverridesWizard, i18nService, dsClusterConstants, mutationService, storageVmOverridesService, defaultUriSchemeUtil, $q) {
            this.vuiAddVmOverridesWizard = vuiAddVmOverridesWizard;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            this.mutationService = mutationService;
            this.storageVmOverridesService = storageVmOverridesService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
        }
        AddVmOverridesPageService.prototype.buildSelectVmsPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("DsClusterUi", "vmOverrides.selection.title"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/sdrsVmOverrides/selectVmsToOverrideView.html",
                onCommit: function () {
                    var selectedVms = wizardScope.manager.getSelectedVms();
                    if (selectedVms && selectedVms.length > 0) {
                        _this.vuiAddVmOverridesWizard.markPageComplete();
                        return true;
                    }
                    else {
                        _this.vuiAddVmOverridesWizard.markPageIncompleteWithError(_this.i18nService.getString("DsClusterUi", "sdrs.vmOverrides.noVmIsSelected"));
                        return false;
                    }
                },
                disableNext: function () {
                    return wizardScope.wizardConfig.loading;
                }
            };
        };
        AddVmOverridesPageService.prototype.buildAddVmOverridesPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("DsClusterUi", "vmOverrides.services.sdrs"),
                contentUrl: "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/sdrsVmOverrides/addVmOverridesView.html",
                onCommit: function () {
                    var spec = wizardScope.manager.getSpec();
                    var selectedVms = wizardScope.manager.getSelectedVms();
                    var objectId = wizardScope.manager.getTargetUid();
                    var validationPassed = _this.$q.defer();
                    if (spec.keepVmdksChecked || spec.sdrsAutomationLevel) {
                        var keepVmdksValue = spec.keepVmdksChecked ?
                            spec.keepVmdksValue :
                            _this.dsClusterConstants.keepVmdksValues.clusterDefault;
                        var sdrsAutomationLevelValue = spec.sdrsAutomationLevel ?
                            spec.sdrsAutomationLevelValue :
                            _this.dsClusterConstants.sdrsVmOverridesAutomationLevels.clusterDefault;
                        var addOverrideSpec_1 = _this.getOverrideSpec(selectedVms, sdrsAutomationLevelValue, keepVmdksValue, "Add");
                        wizardScope.wizardConfig.loading = true;
                        _this.mutationService.validate(objectId, _this.dsClusterConstants.SDRS_VM_OVERRIDE_SPEC, addOverrideSpec_1).then(function (response) {
                            wizardScope.wizardConfig.loading = false;
                            if (response && response.result && response.result.length > 0) {
                                var alert_1 = _this.storageVmOverridesService
                                    .getVmOverrideErrorMessages(response.result);
                                _this.vuiAddVmOverridesWizard.markPageIncompleteWithError(alert_1.text);
                                validationPassed.reject();
                            }
                            else {
                                _this.mutationService.apply(objectId, _this.dsClusterConstants.SDRS_VM_OVERRIDE_SPEC, addOverrideSpec_1);
                                validationPassed.resolve(true);
                            }
                        });
                    }
                    else {
                        var error = _this.i18nService.getString("DsClusterUi", "vm.overrides.config.noChangesValidationError");
                        _this.vuiAddVmOverridesWizard.markPageIncompleteWithError(error);
                        validationPassed.reject();
                    }
                    return validationPassed.promise;
                },
                finishReady: function () {
                    return !wizardScope.wizardConfig.loading;
                }
            };
        };
        AddVmOverridesPageService.prototype.createKeepVdmkTogetherValuesMap = function () {
            return {
                keepVmdksTogether: {
                    id: "keepVmdksTogether",
                    label: this.i18nService.getString("Common", "yes.label"),
                    value: "KeepVmdksTogether"
                },
                doNotKeepVmdksTogether: {
                    id: "DoNotKeepVmdksTogether",
                    label: this.i18nService.getString("Common", "no.label"),
                    value: "DoNotKeepVmdksTogether"
                }
            };
        };
        AddVmOverridesPageService.prototype.createAutomationLevelsMap = function () {
            return {
                automated: {
                    id: "Automated",
                    label: this.i18nService.getString("DsClusterUi", "vmOverrides.vmSdrsAutomationLevelFullyAutomated")
                },
                manual: {
                    id: "Manual",
                    label: this.i18nService.getString("DsClusterUi", "vmOverrides.vmSdrsAutomationLevelManual")
                },
                disabled: {
                    id: "Disabled",
                    label: this.i18nService.getString("DsClusterUi", "vmOverrides.vmSdrsAutomationLevelDisabled")
                }
            };
        };
        AddVmOverridesPageService.prototype.getIntraVmAffinityValueForAVm = function (vm) {
            var keepVmdkTogetherValuesMap = this.createKeepVdmkTogetherValuesMap();
            var keepVmdksChecked = true;
            var keepVmdksValue = '';
            if (vm.rawData.intraVmAffinity === null) {
                keepVmdksChecked = false;
                keepVmdksValue =
                    vm.rawData.defaultIntraVmAffinity ?
                        keepVmdkTogetherValuesMap.keepVmdksTogether.value :
                        keepVmdkTogetherValuesMap.doNotKeepVmdksTogether.value;
            }
            else {
                keepVmdksChecked = true;
                keepVmdksValue = vm.rawData.intraVmAffinity ?
                    keepVmdkTogetherValuesMap.keepVmdksTogether.value :
                    keepVmdkTogetherValuesMap.doNotKeepVmdksTogether.value;
            }
            return {
                keepVmdksChecked: keepVmdksChecked,
                keepVmdksValue: keepVmdksValue
            };
        };
        AddVmOverridesPageService.prototype.getSdrsAutomationLevelForVm = function (vm) {
            var sdrsAutomationLevels = this.createAutomationLevelsMap();
            var sdrsAutomationLevel = true;
            var sdrsAutomationLevelValue = '';
            var vmAutomationLevel = vm.rawData.vmAutomationLevel;
            var vmAutomationLevelEnabled = vm.rawData.vmAutomationLevelEnabled;
            var defaultAutomationLevel = vm.rawData.defaultVmAutomationLevel;
            if (vmAutomationLevel === this.dsClusterConstants.SDRS_FULLAUTO) {
                sdrsAutomationLevel = true;
                sdrsAutomationLevelValue = sdrsAutomationLevels[vmAutomationLevel].id;
            }
            else if (vmAutomationLevel === this.dsClusterConstants.SDRS_MANUAL) {
                sdrsAutomationLevel = true;
                sdrsAutomationLevelValue = sdrsAutomationLevels[vmAutomationLevel].id;
            }
            else if (vmAutomationLevel === null) {
                if (vmAutomationLevelEnabled === null) {
                    if (defaultAutomationLevel === this.dsClusterConstants.SDRS_FULLAUTO) {
                        sdrsAutomationLevel = false;
                        sdrsAutomationLevelValue =
                            sdrsAutomationLevels[defaultAutomationLevel].id;
                    }
                    else if (defaultAutomationLevel === this.dsClusterConstants.SDRS_MANUAL) {
                        sdrsAutomationLevel = false;
                        sdrsAutomationLevelValue = sdrsAutomationLevels[defaultAutomationLevel].id;
                    }
                }
                else {
                    sdrsAutomationLevel = true;
                    sdrsAutomationLevelValue = sdrsAutomationLevels.disabled.id;
                }
            }
            return {
                sdrsAutomationLevel: sdrsAutomationLevel,
                sdrsAutomationLevelValue: sdrsAutomationLevelValue
            };
        };
        AddVmOverridesPageService.prototype.getOverrideSpec = function (vms, sdrsAutomationLevel, keepVmdksTogheter, operation) {
            var _this = this;
            return {
                operation: operation,
                vmOverrides: _.map(vms, function (vm) {
                    var vmOverrides = {};
                    if (operation === _this.dsClusterConstants.vmOverridesOperationType.ADD) {
                        vmOverrides = {
                            vmSor: _this.defaultUriSchemeUtil.getManagedObjectReference(vm.id),
                            vmName: vm.name,
                            sdrsAutomationLevel: sdrsAutomationLevel,
                            intraVmAffinity: keepVmdksTogheter
                        };
                    }
                    else {
                        var intraVmAffinity = _this.getIntraVmAffinityByKeepVmdksValue(keepVmdksTogheter, vm);
                        var sdrsAutomationLevelSpecValue = _this.getSdrsValueBySdrsAutomationLevel(sdrsAutomationLevel, vm);
                        vmOverrides = {
                            vmSor: vm.vm.provider,
                            vmName: vm.name,
                            sdrsAutomationLevel: sdrsAutomationLevelSpecValue,
                            intraVmAffinity: intraVmAffinity
                        };
                    }
                    return vmOverrides;
                })
            };
        };
        AddVmOverridesPageService.prototype.getIntraVmAffinityByKeepVmdksValue = function (keepVmdksTogheter, vm) {
            var intraVmAffinity = "";
            if (keepVmdksTogheter ===
                this.dsClusterConstants.keepVmdksValues.useInitialValues) {
                var intraVmAffinityForCurrentVm = this.getIntraVmAffinityValueForAVm(vm);
                intraVmAffinity = intraVmAffinityForCurrentVm.keepVmdksChecked ?
                    intraVmAffinityForCurrentVm.keepVmdksValue :
                    this.dsClusterConstants.sdrsVmOverridesAutomationLevels.clusterDefault;
            }
            else {
                intraVmAffinity = keepVmdksTogheter;
            }
            return intraVmAffinity;
        };
        AddVmOverridesPageService.prototype.getSdrsValueBySdrsAutomationLevel = function (sdrsAutomationLevel, vm) {
            var sdrsAutomationLevelSpecValue = "";
            var clusterDefault = this.dsClusterConstants.sdrsVmOverridesAutomationLevels.clusterDefault;
            var useInitialValues = this.dsClusterConstants.sdrsVmOverridesAutomationLevels.useInitialValues;
            if (sdrsAutomationLevel === useInitialValues) {
                var sdrsAutomationLevelForVm = this.getSdrsAutomationLevelForVm(vm);
                sdrsAutomationLevelSpecValue =
                    sdrsAutomationLevelForVm.sdrsAutomationLevel ?
                        sdrsAutomationLevelForVm.sdrsAutomationLevelValue :
                        clusterDefault;
            }
            else {
                sdrsAutomationLevelSpecValue = sdrsAutomationLevel;
            }
            return sdrsAutomationLevelSpecValue;
        };
        AddVmOverridesPageService.$inject = ["vuiAddVmOverridesWizard",
            "i18nService", "dsClusterConstants",
            "mutationService",
            "storageVmOverridesService",
            "defaultUriSchemeUtil",
            "$q"];
        return AddVmOverridesPageService;
    }());
    ds_cluster_ui.AddVmOverridesPageService = AddVmOverridesPageService;
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("addVmOverridesPageService", AddVmOverridesPageService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var AddVmOverridesWizardService = (function () {
        function AddVmOverridesWizardService($rootScope, dataService, vuiAddVmOverridesWizard, addVmOverridesPageService) {
            this.$rootScope = $rootScope;
            this.dataService = dataService;
            this.vuiAddVmOverridesWizard = vuiAddVmOverridesWizard;
            this.addVmOverridesPageService = addVmOverridesPageService;
        }
        AddVmOverridesWizardService.prototype.invokeWizard = function (targetUid, manager) {
            var _this = this;
            manager.setTargetUid(targetUid);
            manager.setSelectedVms([]);
            manager.setSpec({});
            this.wizardScope = this.$rootScope.$new();
            this.wizardScope.manager = manager;
            var pages = this.createWizardPages(this.wizardScope);
            this.dataService
                .getProperties(targetUid, ['name'])
                .then(function (response) {
                if (response && response.name) {
                    var clusterName = response.name;
                    manager.setClusterName(clusterName);
                    _this.vuiAddVmOverridesWizard.show(pages, _this.wizardScope);
                }
            });
        };
        AddVmOverridesWizardService.prototype.createWizardPages = function (wizardScope) {
            var pages = [];
            pages.push(this.addVmOverridesPageService.buildSelectVmsPage(wizardScope));
            pages.push(this.addVmOverridesPageService.buildAddVmOverridesPage(wizardScope));
            return pages;
        };
        AddVmOverridesWizardService.$inject = ["$rootScope", "dataService", "vuiAddVmOverridesWizard", "addVmOverridesPageService"];
        return AddVmOverridesWizardService;
    }());
    ds_cluster_ui.AddVmOverridesWizardService = AddVmOverridesWizardService;
    angular.module('com.vmware.vsphere.client.dsCluster')
        .service('addVmOverridesWizardService', AddVmOverridesWizardService);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var VuiAddVmOverridesWizardImpl = (function () {
        function VuiAddVmOverridesWizardImpl(wizardPageService, vuiWizardService, $rootScope, i18nService) {
            this.wizardPageService = wizardPageService;
            this.vuiWizardService = vuiWizardService;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
        }
        VuiAddVmOverridesWizardImpl.prototype.show = function (pages, wizardScope) {
            this.wizardConfig = _.extend(wizardScope.wizardConfig ? wizardScope.wizardConfig : {}, {
                title: this.i18nService.getString("DsClusterUi", "vmOverrides.config.add.title", wizardScope.manager.getClusterName()),
                pages: this.wizardPageService.initializePageStates(pages),
                resizeMinHeight: 500,
                onFinish: function () {
                    return true;
                }
            });
            this.wizardScope = wizardScope;
            this.wizardScope.wizardConfig = this.wizardConfig;
            this.vuiWizardService({
                scope: this.wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        VuiAddVmOverridesWizardImpl.prototype.markPageIncompleteWithError = function (message) {
            this.wizardPageService.markPageIncompleteWithError(this.wizardConfig, message);
        };
        VuiAddVmOverridesWizardImpl.prototype.markPageComplete = function (flow) {
            this.wizardPageService.clearErrors(this.wizardConfig);
            this.wizardPageService.markPageComplete(this.wizardConfig, flow);
        };
        VuiAddVmOverridesWizardImpl.$inject = [
            'wizardPageService',
            'vuiWizardService',
            '$rootScope',
            'i18nService'
        ];
        return VuiAddVmOverridesWizardImpl;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .service("vuiAddVmOverridesWizard", VuiAddVmOverridesWizardImpl);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterConsumersPortletController = (function () {
        function DsClusterConsumersPortletController($rootScope, i18nService, dsClusterConsumersService, dsClusterConstants) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.dsClusterConsumersService = dsClusterConsumersService;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = this.$rootScope._route.objectId;
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.SUMMARY];
            this.getData();
        }
        DsClusterConsumersPortletController.prototype.getData = function () {
            var _this = this;
            this.dsClusterConsumersService.getPropertyViewData(this.objectId)
                .then(function (data) {
                _this.consumersData = data;
            });
        };
        DsClusterConsumersPortletController.$inject = ["$rootScope", "i18nService", "dsClusterConsumersService",
            "dsClusterConstants"];
        return DsClusterConsumersPortletController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterConsumersPortletController", DsClusterConsumersPortletController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterResourcesPortletController = (function () {
        function DsClusterResourcesPortletController(dataService, $rootScope, dsClusterServicesAndResourcesService, i18nService, dsClusterConstants, numberFormatterService) {
            this.dataService = dataService;
            this.$rootScope = $rootScope;
            this.dsClusterServicesAndResourcesService = dsClusterServicesAndResourcesService;
            this.i18nService = i18nService;
            this.dsClusterConstants = dsClusterConstants;
            this.numberFormatterService = numberFormatterService;
            this.objectId = this.$rootScope._route.objectId;
            this.liveRefreshProperties =
                [this.dsClusterConstants.liveRefreshProperties.SUMMARY];
            this.getData();
        }
        DsClusterResourcesPortletController.prototype.getData = function () {
            var _this = this;
            this.dataService.getData(this.objectId, "com.vmware.vsphere.client.dsclusterui.model.DsClusterResourcesData")
                .then(function (data) {
                _this.resourcesData = _this.dsClusterServicesAndResourcesService
                    .buildResourcesPropertyViewData(data);
                _this.usedPercentage = data.usedSpacePercentage;
                var formattedUserPercentage = _this.numberFormatterService.format(data.usedSpacePercentage);
                _this.usedPercentageLabel = _this.i18nService.getString("DsClusterUi", "sdrs.config.utilizedSpaceThreshold.format", formattedUserPercentage);
                _this.minResourcesLabel = _this.dsClusterServicesAndResourcesService
                    .getMinCapacityLabel(data.formattedCapacity);
                _this.totalResourcesLabel = data.formattedCapacity;
            });
        };
        DsClusterResourcesPortletController.$inject = ["dataService", "$rootScope", "dsClusterServicesAndResourcesService",
            "i18nService", "dsClusterConstants", "numberFormatterService"];
        return DsClusterResourcesPortletController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterResourcesPortletController", DsClusterResourcesPortletController);
})(ds_cluster_ui || (ds_cluster_ui = {}));



var ds_cluster_ui;
(function (ds_cluster_ui) {
    var DsClusterServicesPortletController = (function () {
        function DsClusterServicesPortletController(dataService, $rootScope, dsClusterServicesAndResourcesService, i18nService, storageDrsDataRetrieval, vxPropertyViewService, $scope, dsClusterConstants) {
            this.dataService = dataService;
            this.$rootScope = $rootScope;
            this.dsClusterServicesAndResourcesService = dsClusterServicesAndResourcesService;
            this.i18nService = i18nService;
            this.storageDrsDataRetrieval = storageDrsDataRetrieval;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$scope = $scope;
            this.dsClusterConstants = dsClusterConstants;
            this.objectId = this.$rootScope._route.objectId;
            this.liveRefreshProperties = [
                this.dsClusterConstants.liveRefreshProperties.STORAGE_DRS_CONFIG,
                this.dsClusterConstants.liveRefreshProperties.FAULT,
                this.dsClusterConstants.liveRefreshProperties.RECOMMENDATION
            ];
            this.getData();
        }
        DsClusterServicesPortletController.prototype.getData = function () {
            var _this = this;
            this.storageDrsDataRetrieval.retrievePortletData(this.objectId).then(function (sdrsViewModelData) {
                _this.sdrsEnabled = sdrsViewModelData.enabled;
                _this.resourcesData = _this.dsClusterServicesAndResourcesService
                    .buildServicesPropertyViewData(sdrsViewModelData, _this.objectId, _this.$scope._route.navigator);
            });
        };
        DsClusterServicesPortletController.$inject = ["dataService", "$rootScope", "dsClusterServicesAndResourcesService",
            "i18nService", "storageDrsDataRetrieval", "vxPropertyViewService", "$scope",
            "dsClusterConstants"];
        return DsClusterServicesPortletController;
    }());
    angular.module("com.vmware.vsphere.client.dsCluster")
        .controller("DsClusterServicesPortletController", DsClusterServicesPortletController);
})(ds_cluster_ui || (ds_cluster_ui = {}));





/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.tagging = {
   angularModule: angular.module('com.vmware.vsphere.client.tagging', [
      'com.vmware.platform.ui'])
};

/*
 * Tagging module
 */
angular.module('com.vmware.vsphere.client.tagging')
.run([
function() {}]);



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.networkLibUi = {
   angularModule: angular.module('com.vmware.vsphere.client.networkLibUi', [
      'com.vmware.platform.ui'])
};

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').service(
         'dvsDetailsViewService', dvsDetailsViewService);

   dvsDetailsViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUtil',
      'networkUiConstants'
   ];

   function dvsDetailsViewService (
         i18nService, propertyViewService, networkUtil, networkUiConstants
   ) {

      return {
         build: build
      };

      function build (dvsConfigDetailsData, isHostProxySwitchContext) {

         if (dvsConfigDetailsData) {
            var builder = propertyViewService.createPropertyViewBuilder();

            var generalCategoryBuilder = builder
                  .category("general")
                  .title(i18nService.getString(
                        'NetworkUi', 'DvsConfigPage.general.title'));

            buildGeneralSection(dvsConfigDetailsData, isHostProxySwitchContext,
                  generalCategoryBuilder);
            buildAdvancedSection(dvsConfigDetailsData, generalCategoryBuilder);
            buildDiscoveryProtocolSection(dvsConfigDetailsData,
                  generalCategoryBuilder);
            buildAdminContactSection(dvsConfigDetailsData,
                  generalCategoryBuilder);

            return builder.build();

         }

         return {};

      }

      function buildGeneralSection (
            dvsConfigDetailsData,
            isHostProxySwitchContext,
            generalCategoryBuilder
      ) {
         // Create the general section
         var generalSectionTitle = i18nService.getString('NetworkUi',
               'DvsConfigPage.general.title');

         var generalSection = generalCategoryBuilder
               .section("generalSection").title(generalSectionTitle);

         if (dvsConfigDetailsData.name){
            generalSection.property(
               networkUtil.getString('DvsConfigPage.general.body.name.label'),
               dvsConfigDetailsData.name);
         }

         if (dvsConfigDetailsData.description) {
            generalSection
                  .property(i18nService.getString(
                        'NetworkUi', 'DvsConfigPage.general.body.notes.label'),
                        dvsConfigDetailsData.description);
         }

         if (dvsConfigDetailsData.productVendor) {
            generalSection
                  .property(networkUtil.getString(
                        'HostProxySwitchDetailsView.manufacturer'),
                        dvsConfigDetailsData.productVendor);
         }

         if (dvsConfigDetailsData.productVersion) {
            generalSection
                  .property(networkUtil.getString(
                        'HostProxySwitchDetailsView.version'),
                        networkUtil.getString('SwitchDiagram.dvsVersionStringFormat',
                              dvsConfigDetailsData.productVersion,
                              dvsConfigDetailsData.productBuildNumber ?
                                    dvsConfigDetailsData.productBuildNumber : ""));
         }

         if (dvsConfigDetailsData.productBuildNumber) {
            generalSection
                  .property(networkUtil.getString(
                        'HostProxySwitchDetailsView.version'),
                        dvsConfigDetailsData.productVersion);
         }

         if (dvsConfigDetailsData.uplinkPorts) {
            generalSection
                  .property(networkUtil.getString(
                        'DvsConfigPage.general.body.numberOfUplinks.label'),
                        dvsConfigDetailsData.uplinkPorts);
         }

         if (!isHostProxySwitchContext && dvsConfigDetailsData.numberOfPorts) {
            generalSection
                  .property(networkUtil.getString(
                        'DvsConfigPage.general.body.numberOfPorts.label'),
                        dvsConfigDetailsData.numberOfPorts);
         }

         if (dvsConfigDetailsData.networkResourceManagementSupported) {
            generalSection
                  .property(networkUtil.getString(
                        'DvsConfigPage.resmgmt.label'),
                        getNiocStatus(
                              dvsConfigDetailsData.networkResourceManagementEnabled));
         }

      }

      function getNiocStatus (networkResourceManagementEnabled) {
         return networkResourceManagementEnabled ?
               networkUtil.getString('DvsConfigPage.resmgmt.enabled') :
               networkUtil.getString('DvsConfigPage.resmgmt.disabled');
      }


      function buildAdvancedSection (
            dvsConfigDetailsData,
            generalCategoryBuilder
      ) {

         // Create the advanced section
         var advancedSectionTitle = i18nService.getString('NetworkUi',
               'DvsConfigPage.advanced.title');

         var advancedSection = generalCategoryBuilder
               .section("advancedSection").title(advancedSectionTitle);

         if (dvsConfigDetailsData.maxMtu) {

            advancedSection
                  .property(
                        networkUtil.getString('DvsConfigPage.advanced.maxMtu.label'),
                        networkUtil.getString('DvsConfigPage.advanced.maxMtu.format',
                              dvsConfigDetailsData.maxMtu));
         }

         if (dvsConfigDetailsData.multicastSnoopingSupported && dvsConfigDetailsData.multicastFilteringMode) {
            advancedSection
                  .property(
                        networkUtil.getString(
                              'DvsConfigPage.advanced.multicastFiltering.label'),
                        getMulticastLabel(dvsConfigDetailsData.multicastFilteringMode));
         }

         if (dvsConfigDetailsData.dvsCapabilities && dvsConfigDetailsData.dvsCapabilities.defaultMaxNumPortsSupported &&
               dvsConfigDetailsData.defaultProxySwitchMaxNumPorts) {

            advancedSection
                  .property(
                        networkUtil.getString(
                              'DvsConfigPage.advanced.defaultMaxNumPorts.label'),
                        dvsConfigDetailsData.defaultProxySwitchMaxNumPorts);

         }
      }

      function getMulticastLabel (multicastFilteringMode) {
         if (multicastFilteringMode ===
               networkUiConstants.MulticastFiltering.BASIC) {
            return networkUtil.getString(
                  'DvsConfigPage.advanced.multicastMode.basic');
         } else if (multicastFilteringMode ===
               networkUiConstants.MulticastFiltering.SNOOPING) {
            return networkUtil.getString(
                  'DvsConfigPage.advanced.multicastMode.snooping');
         }
      }

      function buildDiscoveryProtocolSection (
            dvsConfigDetailsData,
            generalCategoryBuilder
      ) {

         // Create the link discovery protocol section
         var ldpSectionTitle = i18nService.getString('NetworkUi',
               'DvsConfigPage.advanced.dp.title');

         var ldpSection = generalCategoryBuilder
               .section("ldpSection").title(ldpSectionTitle);

         if (dvsConfigDetailsData.linkDiscoveryProtocolOperation !==
               networkUiConstants.LinkDiscoveryOperation.DISABLED) {

            ldpSection
                  .property(
                        networkUtil.getString('DvsConfigPage.advanced.dp.type.label'),
                        getDiscoveryProtocolType(dvsConfigDetailsData
                              .linkDiscoveryProtocolType));

            ldpSection
                  .property(
                        networkUtil.getString('DvsConfigPage.advanced.dp.operation.label'),
                        getDiscoveryOperation(dvsConfigDetailsData
                              .linkDiscoveryProtocolOperation));

         } else {
            ldpSection
                  .property(
                        networkUtil.getString('DvsConfigPage.advanced.dp.type.label'),
                        networkUtil.getString('DvsConfigPage.advanced.dp.type.disabled'));

            ldpSection
                  .property(
                        networkUtil.getString('DvsConfigPage.advanced.dp.operation.label'),
                        '');
         }

      }

      function getDiscoveryProtocolType (linkDiscoveryProtocolType) {
         if (linkDiscoveryProtocolType === networkUiConstants
                     .LinkDiscoveryProtocol.CDP) {
            return networkUtil.getString('DvsConfigPage.advanced.dp.type.cdp');
         } else if (linkDiscoveryProtocolType === networkUiConstants
                     .LinkDiscoveryProtocol.LLDP) {
            return networkUtil.getString('DvsConfigPage.advanced.dp.type.lldp');
         }
      }

      function getDiscoveryOperation (linkDiscoveryProtocolOperation) {

         switch (linkDiscoveryProtocolOperation) {
            case networkUiConstants.LinkDiscoveryOperation.ADVERTISE:
               return networkUtil.getString(
                     'DvsConfigPage.advanced.dp.operation.advertise');
            case networkUiConstants.LinkDiscoveryOperation.LISTEN:
               return networkUtil.getString(
                     'DvsConfigPage.advanced.dp.operation.listen');
            case networkUiConstants.LinkDiscoveryOperation.BOTH:
               return networkUtil.getString(
                     'DvsConfigPage.advanced.dp.operation.both');
            default :
               return "";
         }

      }

      function buildAdminContactSection (
            dvsConfigDetailsData,
            generalCategoryBuilder
      ) {

         // Create the admin contact section
         var adminContactSectionTitle = i18nService.getString('NetworkUi',
               'DvsConfigPage.advanced.contact.title');

         var adminContactSection = generalCategoryBuilder
               .section("adminContactSection").title(adminContactSectionTitle);

         adminContactSection
               .property(
                     networkUtil.getString('DvsConfigPage.advanced.contact.name.label'),
                     dvsConfigDetailsData.contactName);

         adminContactSection
               .property(
                     networkUtil.getString('DvsConfigPage.advanced.contact.contact.label'),
                     dvsConfigDetailsData.contact);
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    var DvsPropertiesViewComponent = (function () {
        function DvsPropertiesViewComponent() {
            this.bindings = {
                dvsUri: "<"
            };
            this.controller = DvsPropertiesViewController;
            this.templateUrl = "network-lib-ui/resources/network-lib/components/dvsProperties/dvsPropertiesView.html";
        }
        return DvsPropertiesViewComponent;
    }());
    network_lib_ui.DvsPropertiesViewComponent = DvsPropertiesViewComponent;
    var DvsPropertiesViewController = (function () {
        function DvsPropertiesViewController(dataService, dvsDetailsViewService) {
            this.dataService = dataService;
            this.dvsDetailsViewService = dvsDetailsViewService;
            this.liveRefreshProperties = [
                "name",
                "config.productInfo.version",
                "config.contact.name",
                "config.contact.contact",
                "config.linkDiscoveryProtocolConfig.protocol",
                "config.linkDiscoveryProtocolConfig.operation",
                "config.name",
                "config.description",
                "config.multicastFilteringMode",
                "config.maxMtu",
                "config.defaultProxySwitchMaxNumPorts",
                "config.numPorts",
                "config.uplinkPortPolicy.uplinkPortName",
                "config.networkResourceManagementEnabled"
            ];
        }
        DvsPropertiesViewController.prototype.$onChanges = function () {
            this.refresh();
        };
        DvsPropertiesViewController.prototype.refresh = function () {
            var _this = this;
            if (!this.dvsUri) {
                return;
            }
            this.loadingData = true;
            this.dataService.getProperties(this.dvsUri, [DvsPropertiesViewController.CONFIG_DATA_PROPERTY_NAME])
                .then(function (dataServiceResponse) {
                var dvsConfigDetailsData = dataServiceResponse
                    ? dataServiceResponse[DvsPropertiesViewController.CONFIG_DATA_PROPERTY_NAME]
                    : null;
                if (dvsConfigDetailsData && dvsConfigDetailsData.name) {
                    var trimmedName = dvsConfigDetailsData.name.trim();
                    var escapedName = trimmedName.replace(/%25/g, "%")
                        .replace(/%2f/g, "\/").replace(/%5c/g, "\\");
                    dvsConfigDetailsData.name = escapedName;
                }
                _this.dvsDetailsData = _this.dvsDetailsViewService
                    .build(dvsConfigDetailsData, false);
                _this.loadingData = false;
            });
        };
        DvsPropertiesViewController.$inject = [
            "dataService",
            "dvsDetailsViewService"
        ];
        DvsPropertiesViewController.CONFIG_DATA_PROPERTY_NAME = "dvswitchproperties:configdata";
        return DvsPropertiesViewController;
    }());
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .component("dvsPropertiesView", new DvsPropertiesViewComponent());
})(network_lib_ui || (network_lib_ui = {}));



(function() {
   'use strict';

   /**
    * @description
    *
    * Directive to show an error tooltip on an element.
    *
    * |---------|  /-----------------------|
    * | Element | <  Error message         |
    * |---------|  \-----------------------|
    *
    * In order to function correctly this directive needs the `error-tooltip-data`
    * attribute.
    *
    * ******
    * Usage:
    * ******
    *
    *  <input type="text" error-tooltip error-tooltip-data="tooltipData"></input>
    *  <div error-tooltip error-tooltip-data="tooltipData"></input>
    *
    *  <script>
    *     $scope.tooltipData = {
    *        message: 'Some error message',
    *        showMessage: function() { return true/false }
    *     };
    *  </script>
    */
   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .directive('errorTooltip', errorTooltip);

   errorTooltip.$inject = [
         '$compile',
         '$window',
         'positionService'];

   function errorTooltip(
         $compile,
         $window,
         positionService) {

      return {
         restrict: 'A',
         scope: false,
         link: function(scope, element, attributes) {
            if (!attributes.errorTooltipData) {
               throw new Error('error-tooltip-data attribute is not found.');
            }

            var tooltipScope = scope.$new(true);
            scope.$watch(attributes.errorTooltipData, function(errorData) {
               tooltipScope.errorData = errorData;
            });

            // Show error tooltip on hover
            element.bind('mouseenter', show);
            element.bind('mouseleave', hide);

            var bodyElement = angular.element($window.document.body);
            var templateElement;
            // Template element for tooltip
            var template = '<div ng-show="errorData.showMessage()" ' +
                     'class="vx-error-tooltip tooltip right in">' +
                  '<div class="tooltip-arrow"></div>' +
                  '<div class="tooltip-inner">{{errorData.message}}</div>' +
                  '</div>';

            // Position the tooltip element.
            var positionTooltip = function() {
               var ttPosition = positionService
                     .positionElements(element, templateElement, 'right', true);
               ttPosition.top += 'px';
               ttPosition.left += 'px';

               // Now set the calculated positioning.
               templateElement.css(ttPosition);
            };

            function show() {
               if (!tooltipScope.errorData || !tooltipScope.errorData.showMessage()) {
                  return;
               }

               // Compile template on new inner scope with the values.
               templateElement = $compile(template)(tooltipScope);
               tooltipScope.$apply();
               bodyElement.append(templateElement);
               positionTooltip();
            }

            function hide() {
               // Remove the element.
               if (templateElement) {
                  templateElement.remove();
               }
            }

            scope.$on('$destroy', function() {
               if(templateElement) {
                  templateElement.remove();
               }
            });
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    /**
     * A component that performs validation of IPv4 specific inputs.
     * The component currently supports validation of either IPv4 Address, or Subnet mask.
     *
     * As validation mechanism the component integrates with the <vx-validate> directive.
     *
     * Require:
     *    ngModel: a ng-model directive is required to be able to bind the input to a
     *             form in a case the user depends on some ngForm functionality
     *             such as the $dirty flag.
     *
     * Input params:
     *    type: a constant that represents the input type the component should handle.
     *          Currently the supported types are either IPv4, or Subner mask
     *          (see class StaticIpInputTypes)
     *
     *    enabled: a boolean value indicating whether the inputs are enabled, or disabled
     *             thus whether the validation should be performed, or not.
     *
     *    name: a string value used as a custom input's name. If not provided, a default
     *          one is set.
     *
     *    message: a string value used as a custom validation message. If not provided, a
     *             default one is set.
     *
     *    validate: an optional callback function being invoked from outside in case the
     *              consumer wants to trigger the input validation skipping
     *              the empty-val-check.
     */
    var IpAddressInputComponent = (function () {
        function IpAddressInputComponent() {
            this.require = {
                model: "ngModel"
            };
            this.bindings = {
                type: "<",
                enabled: "<",
                name: "@",
                message: "<",
                validate: "=?",
                onValidationComplete: "&",
                directionClass: "<?",
                inputId: "<?",
                labelledby: '@?'
            };
            this.controller = IpAddressInputController;
            this.templateUrl = "network-lib-ui/resources/network-lib/components/ipv4Address/ipAddressInput.html";
        }
        return IpAddressInputComponent;
    }());
    network_lib_ui.IpAddressInputComponent = IpAddressInputComponent;
    var StaticIpInputTypes = (function () {
        function StaticIpInputTypes() {
            this.IPV4 = new StaticIpv4InputTypes();
            this.IPV6 = new StaticIpv6InputTypes();
        }
        return StaticIpInputTypes;
    }());
    network_lib_ui.StaticIpInputTypes = StaticIpInputTypes;
    var IpAddressInputController = (function () {
        function IpAddressInputController(vxValidatorFactory, ipParserService, i18nService, staticIpInputTypes, $log) {
            this.vxValidatorFactory = vxValidatorFactory;
            this.ipParserService = ipParserService;
            this.i18nService = i18nService;
            this.staticIpInputTypes = staticIpInputTypes;
            this.$log = $log;
            this.validator = vxValidatorFactory.create();
            this.name = this.name || "ipv4AddressInput";
            this.validateEmptyValue = false;
            this.setValidateFunctionBasedOnType();
        }
        IpAddressInputController.prototype.$onInit = function () {
            var _this = this;
            this.model.$render = function () {
                _this.value = _this.model.$viewValue;
            };
            this.validate = function () {
                _this.validateEmptyValue = true;
                return _this.validator.validate.call(_this.validator);
            };
        };
        ;
        IpAddressInputController.prototype.$onChanges = function (changedObj) {
            if (changedObj.enabled) {
                this.validateInput();
            }
            else if (changedObj.type) {
                this.setValidateFunctionBasedOnType();
            }
        };
        IpAddressInputController.prototype.onChange = function () {
            this.model.$setViewValue(this.value);
        };
        IpAddressInputController.prototype.onBlur = function () {
            this.validateInput();
        };
        IpAddressInputController.prototype.setValidateFunctionBasedOnType = function () {
            if (this.type === this.staticIpInputTypes.IPV4.IP_ADDRESS) {
                this.validateFunction = this.validateIPv4Address.bind(this);
                this.message = this.message || this.i18nService.getString("NetworkLibUi", "invalidIpAddress");
            }
            else if (this.type === this.staticIpInputTypes.IPV4.SUBNET_MASK) {
                this.validateFunction = this.validateSubnetMask.bind(this);
                this.message = this.message ||
                    this.i18nService.getString("NetworkLibUi", "invalidSubnetMask");
            }
            else if (this.type === this.staticIpInputTypes.IPV4.DEFAULT_GATEWAY) {
                this.validateFunction = this.validateIPv4Address.bind(this);
                this.message = this.message ||
                    this.i18nService.getString("NetworkLibUi", "invalidIpv4DefaultGateway");
            }
            else if (this.type === this.staticIpInputTypes.IPV6.IPV6_ADDRESS) {
                this.validateFunction = this.validateIPv6Address.bind(this);
                this.message = this.message ||
                    this.i18nService.getString("NetworkLibUi", "invalidIpv6Address");
            }
            else if (this.type === this.staticIpInputTypes.IPV6.IPV6_ADDRESS_LINK_LOCAL) {
                this.validateFunction = this.validateLinkLocalIPv6Address.bind(this);
                this.message = this.message ||
                    this.i18nService.getString("NetworkLibUi", "invalidIpv6LinkLocalAddress");
            }
            else if (this.type === this.staticIpInputTypes.IPV6.DEFAULT_GATEWAY) {
                this.validateFunction = this.validateIPv6Address.bind(this);
                this.message = this.message ||
                    this.i18nService.getString("NetworkLibUi", "invalidIpv6DefaultGateway");
            }
            else {
                this.$log.warn("IpAddressInputController#type " + this.type + " has no validations defined");
            }
        };
        IpAddressInputController.prototype.validateInput = function () {
            var errors = this.validator.validate();
            this.onValidationComplete({ errors: errors });
        };
        IpAddressInputController.prototype.validateIPv4Address = function () {
            if (this.triggerValidation()
                && !this.ipParserService.isIpv4AddressValid(this.value)) {
                return [this.message];
            }
            this.validateEmptyValue = false;
            return [];
        };
        IpAddressInputController.prototype.validateIPv6Address = function () {
            if (this.triggerValidation()
                && !this.ipParserService.isIpv6AddressValid(this.value)) {
                return [this.message];
            }
            this.validateEmptyValue = false;
            return [];
        };
        IpAddressInputController.prototype.validateLinkLocalIPv6Address = function () {
            if (this.triggerValidation()
                && (!this.ipParserService.isIpv6AddressValid(this.value) || !this.isLinkLocalIPv6Address(this.value))) {
                return [this.message];
            }
            this.validateEmptyValue = false;
            return [];
        };
        IpAddressInputController.prototype.isLinkLocalIPv6Address = function (address) {
            if (!address || address.length < 4) {
                return false;
            }
            var addressBegining = parseInt(address.substr(0, 4), 16);
            return (addressBegining & 0xffc0) === 0xfe80;
        };
        IpAddressInputController.prototype.validateSubnetMask = function () {
            if (this.triggerValidation() && !this.ipParserService.isSubnetMaskValid(this.value)) {
                return [this.message];
            }
            this.validateEmptyValue = false;
            return [];
        };
        // Decide whether the value is empty or not.
        IpAddressInputController.prototype.triggerValidation = function () {
            return this.enabled && (this.validateEmptyValue || !!this.value);
        };
        IpAddressInputController.$inject = [
            "vxValidatorFactory", "ipParserService", "i18nService",
            "staticIpInputTypes", "$log"
        ];
        return IpAddressInputController;
    }());
    var StaticIpv4InputTypes = (function () {
        function StaticIpv4InputTypes() {
            this.IP_ADDRESS = "ipv4Address";
            this.SUBNET_MASK = "subnetMask";
            this.DEFAULT_GATEWAY = "defaultGateway";
        }
        return StaticIpv4InputTypes;
    }());
    var StaticIpv6InputTypes = (function () {
        function StaticIpv6InputTypes() {
            this.IPV6_ADDRESS = "ipv6Address";
            this.IPV6_ADDRESS_LINK_LOCAL = "ipv6AddressLinkLocal";
            this.DEFAULT_GATEWAY = "defaultIpv6Gateway";
        }
        return StaticIpv6InputTypes;
    }());
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .constant("staticIpInputTypes", new StaticIpInputTypes());
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .component("ipAddressInput", new IpAddressInputComponent());
})(network_lib_ui || (network_lib_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   var module = angular.module('com.vmware.vsphere.client.networkLibUi');
   module.directive('ipv4AddressInput', ipv4AddressInput);

   function ipv4AddressInput() {

      var directive = {
         restrict: 'A',
         replace: true,
         scope: {
            value: '=' // IPv4 value
         },
         template: '<input class="ip-address-input" type="text" ng-model="value"/>'
      };

      return directive;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   var module = angular.module('com.vmware.vsphere.client.networkLibUi');
   module.directive('networkSelector', networkSelector);

   module.constant('NetworkSelectorMode', {
         SINGLE_SELECTION_BROWSE_INPUT: "singleSelectionBrowseInput",
         SINGLE_SELECTION_BUTTON: "singleSelectionButton",
         MULTIPLE_SELECTION: "multipleSelection",
         SINGLE_SELECTION_DROPDOWN: "singleSelectionDropdown"
   });

   function networkSelector() {

      var directive = {
         restrict: 'A',
         replace: true,
         scope: {
            networkSelectorName: '<?', // Optional name parameter.
            // Could be used when using the network selector in a form.
            objectRef: '=', // The context object of the network selector
            mode: '=', // The network selector display mode
            filterSpec: '=', // A spec for filtering the requested networks
            dialogSpec: '=?', // A spec for specifying network's privileges and errors
            preselectedNetwork: '=?', // The pre-selected network if any
            onSelectedNetworks: '&onSelectedNetworks', // A callback function for retrieving the selected networks
            onPreloadNetworks: '&onPreloadNetworks', // A callback function to retrieve the preloaded networks when the browse button is clicked
            prefetchedNetworks: '=?', //Array with all the prefetched networks
            errorConfig: '<?',  // vxError object used to display error associated with the network selector
            sortParams: '<?', // parameters for sorting the grid of the network selector dialog (ex: [{field:"name", dir:"asc"}] )
            isDisabled: '<?', // disable the selector
            preloadNetworks: '<?' // An optional parameter, used when the networks will be pre-loaded and the selector should not retrieve them
         },
         templateUrl: 'network-lib-ui/resources/network-lib/components/networkselector/networkSelector.html',
         controller: 'NetworkSelectorController',
         controllerAs: 'ctrl'
      };

      return directive;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .controller('NetworkSelectorController', NetworkSelectorController);


   NetworkSelectorController.$inject = [
         '$scope',
         'i18nService',
         'NetworkSelectorMode',
         'defaultUriSchemeUtil',
         'networkSelectorDialogService',
         'managedEntityConstants'
   ];

   function NetworkSelectorController (
         $scope,
         i18nService,
         NetworkSelectorMode,
         defaultUriSchemeUtil,
         networkSelectorDialogService,
         managedEntityConstants) {

      var self = this;
      initController();
      var BROWSE_OPTION_ID = 'browse-networks-option-id';

      self.browseButtonLabel =
            i18nService.getString('Common', 'NetworkSelectorDropDown.browseEntry');
      var recentNetworks = [];

      self.selectedNetwork = self.preselectedNetwork;

      if(self.mode === NetworkSelectorMode.SINGLE_SELECTION_DROPDOWN) {
         self.networkDropdownOptions = [{
            name: self.browseButtonLabel,
            id: BROWSE_OPTION_ID
         }];

         populatePrefetchedNetworks();
         $scope.$on('onPrefetchNetworksCompleted', function () {
            populatePrefetchedNetworks();
         });
      }

      function populatePrefetchedNetworks() {
         recentNetworks = angular.copy(self.prefetchedNetworks);
         addStandardNetworkFromMatch(self.preselectedNetwork);
         if (self.preselectedNetwork) {
            buildDropdownData(self.preselectedNetwork.id);
         }

         self.selectedNetwork = self.preselectedNetwork;
      }

      self.onSelectorBrowseButtonClicked = function() {
         networkSelectorDialogService.openNetworkSelectorDialog(self.objectRef,
               self.filterSpec, self.dialogSpec, onNetworkSelection);
      };

      function initController() {
         self.networkSelectorName = $scope.networkSelectorName ?
               $scope.networkSelectorName : 'selectNetwork';
         self.objectRef = $scope.objectRef;
         self.mode = $scope.mode;
         self.filterSpec = $scope.filterSpec;
         self.dialogSpec = $scope.dialogSpec;
         self.preselectedNetwork = $scope.preselectedNetwork;
         self.onSelectedNetworks = $scope.onSelectedNetworks;
         self.onPreloadNetworks = $scope.onPreloadNetworks;
         self.preloadNetworks = $scope.preloadNetworks;
         self.prefetchedNetworks = $scope.prefetchedNetworks;
         self.sortParams = $scope.sortParams;
         $scope.isDisabled = !!$scope.isDisabled;

         if ($scope.errorConfig === undefined) {
            $scope.errorConfig = {
               message: "",
               isVisible: false
            };
         }

         self.errorConfig = $scope.errorConfig;
      }

      self.onSelectNetwork = onSelectorDropdownOptionChanged;
      function onSelectorDropdownOptionChanged(newSelectionValue , oldSelectionValue) {
         var newSelection = self.selectedNetwork;
         if (newSelection.id === BROWSE_OPTION_ID) {

            self.selectedNetwork = oldSelectionValue;

            if (self.preloadNetworks) {
               self.onPreloadNetworks().then(function(retrievedNetworks) {
                  self.retrievedNetworks = retrievedNetworks;

                  networkSelectorDialogService.openNetworkSelectorDialog(self.objectRef,
                        self.filterSpec, self.dialogSpec, onNetworkSelection,
                        self.sortParams, self.retrievedNetworks);
               });
            } else {
               networkSelectorDialogService.openNetworkSelectorDialog(self.objectRef,
                     self.filterSpec, self.dialogSpec, onNetworkSelection,
                     self.sortParams, self.retrievedNetworks);
            }

         } else {
            var selectedNetwork = {
               name: newSelection.name,
               networkRef: defaultUriSchemeUtil.getManagedObjectReference(newSelection.id),
               dvsUuid: newSelection.dvsUuid,
               opaqueNetworkType: newSelection.opaqueNetworkType,
               portgroupKey: newSelection.portgroupKey
            };
            if (self.onSelectedNetworks) {
               self.onSelectedNetworks({ selectedNetworks: [selectedNetwork] });
            }
            buildDropdownData(defaultUriSchemeUtil.getVsphereObjectId(selectedNetwork.networkRef));
         }
      }

      function onNetworkSelection(selectedNetworks) {
         var network = selectedNetworks[0];
         var selectedNetwork = {
            name: network.name,
            id: defaultUriSchemeUtil.getVsphereObjectId(network.networkRef),
            dvsUuid: network.dvsUuid,
            portgroupKey: network.portgroupKey
         };

         if (self.mode === NetworkSelectorMode.SINGLE_SELECTION_DROPDOWN) {
            pushRecentNetwork(selectedNetwork);
            if (selectedNetwork.id) {
               buildDropdownData(selectedNetwork.id);
            }
         }

         self.selectedNetwork = selectedNetwork;
         if (self.onSelectedNetworks) {
            self.onSelectedNetworks({ selectedNetworks: selectedNetworks });
         }
      }

      function addStandardNetworkFromMatch(network) {
         if (!network || !network.id) {
            return;
         }
         var networkRef = defaultUriSchemeUtil.getManagedObjectReference(network.id);
         if (networkRef.type !== managedEntityConstants.NETWORK &&
               networkRef.type !== managedEntityConstants.OPAQUE_NETWORK){
            return;
         }

         var selectedNetwork = {
            name: network.name,
            id: network.id,
            networkRef: networkRef,
            dvsUuid: null,
            opaqueNetworkType: network.opaqueNetworkType
         };

         pushRecentNetwork(selectedNetwork);
      }

      function buildDropdownData(selectedNetworkId) {
         var selectedNetwork =  _.filter(recentNetworks, function(network) {
            return network.id === selectedNetworkId;
         });
         var filteredNetworks = _.filter(recentNetworks, function(network) {
            return network.id !== selectedNetworkId;
         });
         var sortedNetworks = _.sortBy(filteredNetworks, function(network) {
            return network.name;
         });
         if (selectedNetwork.length) {
            sortedNetworks = selectedNetwork.concat(sortedNetworks);
         }

         self.networkDropdownOptions =
               sortedNetworks.concat([{
                  name: self.browseButtonLabel,
                  id: BROWSE_OPTION_ID
               }]);
      }

      function pushRecentNetwork(network) {
         //TODO: zzhelyazkov - add here conditional propagation of the pushed network to the self.prefetchedNetworks
         if (_.findIndex(recentNetworks, function(value) {
                  return value.id === network.id;
               }) < 0) {
            recentNetworks.push(network);
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * A Service for opening the Network Selector Dialog.
 */
(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.networkLibUi')
      .factory('networkSelectorDialogService', networkSelectorDialogService);

   networkSelectorDialogService.$inject = ['$q',
      'i18nService',
      'authorizationService',
      'defaultUriSchemeUtil',
      'userSessionService',
      'clarityModalService',
      'clarityConstants'];

   function networkSelectorDialogService (
      $q,
      i18nService,
      authorizationService,
      defaultUriSchemeUtil,
      userSessionService,
      clarityModalService,
      clarityConstants) {

      // ======================= Public API ==========================
      return {
         openNetworkSelectorDialog: openNetworkSelectorDialog,
         createNetworkSelectorFilterSpec: createNetworkSelectorFilterSpec,
         createNetworkSelectorDialogSpec: createNetworkSelectorDialogSpec
      };

      //======================= Public Functions ==========================
      /**
       * Opens an OK/Cancel modal dialog in the application.
       */
      function openNetworkSelectorDialog(contextObjectId,
                                          networkSelectorFilterSpec,
                                          networkSelectorDialogSpec,
                                          okHandler,
                                          sortParams,
                                          retrievedNetworks) {
         var modalOptions = {
            title: i18nService.getString("Common", "NetworkSelectorDialog.titleSingular"),
            contentTemplate: 'network-lib-ui/resources/network-lib/components/networkselector/networkSelectorDialog.html',
            alerts: [],
            defaultButton: 'submit'
         };

         userSessionService.getUserSession().then(function(userSession) {

            var dialogData = {};
            dialogData.contextObjectId = contextObjectId;
            dialogData.networkSelectorFilterSpec = networkSelectorFilterSpec;
            dialogData.userSessionClientId = userSession.clientId;
            dialogData.sortParams = sortParams;
            dialogData.retrievedNetworks = retrievedNetworks;
            dialogData.applyToAll = false;

            dialogData.isBatchAssignmentRelevant = false;

            if (networkSelectorDialogSpec.isBatchAssignmentRelevant !== undefined) {
               dialogData.isBatchAssignmentRelevant = networkSelectorDialogSpec.isBatchAssignmentRelevant;
            }
            dialogData.isBatchAssignmentEnabled = networkSelectorDialogSpec.isBatchAssignmentEnabled;
            dialogData.applyToAllLabel = i18nService.getString("Common", "NetworkSelectorDialog.applyToAll.label");
            dialogData.applyToAllDisabledTitle = i18nService.getString("Common", "NetworkSelectorDialog.applyToAll.signPostTitle");
            dialogData.applyToAllSingPostMessage = networkSelectorDialogSpec.applyToAllSingPostMessage;
            dialogData.applyToAllSignPostIcon = dialogData.isBatchAssignmentEnabled ? "info-circle" : "exclamation-triangle";

            modalOptions.dialogData = dialogData;
            modalOptions.onSubmit = function() {
               var selectedItems = dialogData.selectedItems;
               if (selectedItems.length === 0) {

                  showError(i18nService.getString('Common', 'NetworkSelectorDialog.noNetworksSelectedSingular'),
                     modalOptions);

                  return false;
               }

               return checkPrivileges(networkSelectorDialogSpec, selectedItems)
                  .then(function(networkItemsWithoutPrivileges) {

                     if (networkItemsWithoutPrivileges && networkItemsWithoutPrivileges.length > 0) {
                        showPrivilegeValidationError(networkItemsWithoutPrivileges, modalOptions,
                           networkSelectorDialogSpec.networkSelectorErrorMessages);
                        return false;
                     } else if (okHandler) {
                        okHandler(selectedItems, dialogData.applyToAll);
                     }
                     return true;
                  });
            };
         });

         clarityModalService.openOkCancelModal(modalOptions);
      }

      function createNetworkSelectorFilterSpec (
         includeStandardNetworks, includeOpaqueNetworks,
         includeDistributedPortGroups, includeUplinkPortGroups,
         includeOpaqueNetworkTypes) {

         return {
            _type: 'com.vmware.vsphere.client.networkselector.NetworkSelectorFilterSpec',
            includeStandardNetworks: includeStandardNetworks,
            includeOpaqueNetworks: includeOpaqueNetworks,
            includeDistributedPortGroups: includeDistributedPortGroups,
            includeUplinkPortGroups: includeUplinkPortGroups,
            includeOpaqueNetworkTypes: includeOpaqueNetworkTypes
         };
      }

      function createNetworkSelectorDialogSpec (
         privilegesToCheck,
         noPrivilegesOnFewNetworksMsg, noPrivilegesOnManyNetworksMsg) {
         return {
            privilegesToCheck: privilegesToCheck,
            networkSelectorErrorMessages: {
               noPrivilegesOnFewNetworksMsg: noPrivilegesOnFewNetworksMsg,
               noPrivilegesOnManyNetworksMsg: noPrivilegesOnManyNetworksMsg
            }
         };
      }

      function checkPrivileges (networkSelectorDialogSpec, networkItemsToCheck) {
         if (!networkSelectorDialogSpec || !networkSelectorDialogSpec.privilegesToCheck ||
            networkSelectorDialogSpec.privilegesToCheck.length === 0) {
            return $q.when(true);
         }

         var networkItemsById = {};
         _.each(networkItemsToCheck, function(networkItem) {
            var networkId = defaultUriSchemeUtil.getVsphereObjectId(networkItem.networkRef);
            networkItemsById[networkId] = networkItem;
         });

         var networkIds = _.keys(networkItemsById);
         var privileges = networkSelectorDialogSpec.privilegesToCheck;
         return authorizationService.checkPrivilegesForMultipleObjects(networkIds, privileges)
            .then(function(result) {
               var networksWithoutAllRequiredPrivileges = [];
               _.each(result, function(privileges, networkId) {

                  var allRequiredPrivilegesGranted = _.values(privileges).reduce(function(memo, isPrivilegeGranted) {
                     return memo && isPrivilegeGranted;
                  }, true);

                  if (!allRequiredPrivilegesGranted) {
                     networksWithoutAllRequiredPrivileges.push(networkItemsById[networkId]);
                  }

               });

               return networksWithoutAllRequiredPrivileges;
            });
      }

      function showPrivilegeValidationError (networkItemsWithoutPrivileges, modalOptions, customErrorMessages) {

         var networkItemsNameWithoutPrivileges = _.pluck(networkItemsWithoutPrivileges, "name");
         var networkNames, errorMessageKey;

         if (networkItemsNameWithoutPrivileges.length < 4) {
            networkNames = networkItemsNameWithoutPrivileges.join(', ');
            // Show a default error message if there is no custom error message specified
            errorMessageKey = i18nService.getString('Common', 'NetworkSelectorDialog.noPrivileges');
            if (customErrorMessages && customErrorMessages.noPrivilegesOnFewNetworksMsg) {
               errorMessageKey = customErrorMessages.noPrivilegesOnFewNetworksMsg;
            }
         } else {
            networkNames = networkItemsNameWithoutPrivileges.slice(0, 4).join(', ');
            // Show a default privilege error message if there is no custom error message specified
            errorMessageKey = i18nService.getString('Common', 'NetworkSelectorDialog.noPrivilegesAndMore');
            if (customErrorMessages && customErrorMessages.noPrivilegesOnManyNetworksMsg) {
               errorMessageKey = customErrorMessages.noPrivilegesOnManyNetworksMsg;
            }
         }
         showError(i18nService.interpolate(errorMessageKey, [networkNames]), modalOptions);
      }

      function showError (errorMessage, modalOptions) {
         modalOptions.alerts = [{
            text: errorMessage,
            type: clarityConstants.notifications.type.ERROR
         }];
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').directive('networkSelectorList', networkSelectorList);

   networkSelectorList.$inject = ['i18nService', 'vuiConstants', 'columnRenderersRegistry', '$compile'];

   function networkSelectorList(i18nService, vuiConstants, columnRenderersRegistry, $compile) {

      var directive = {
         scope: {
            contextObjectId: '=', // The context object for which the network selector list will be invoked
            networkSelectorFilterSpec: '=', // Network filter spec which will be used to retrieve the networks
            userSessionClientId: '=', // The current web client's session ID
            selectedItems: '=', // The currently selected items
            sortParams: '<?', // Parameters for sorting the grid (ex: [{field:"name", dir:"asc"}] )
            retrievedNetworks: '<?' // Pre-retrieved networks, no need to retrieve them remotely
         },
         templateUrl: 'network-lib-ui/resources/network-lib/components/networkselector/NetworkSelectorList.html',
         replace: true,
         link: {
            pre: preLink,
            post: postLink
         }
      };

      var lastSearchTerm = '';

      function preLink(scope) {

         var filterSet = false;

         var dataUrl = 'network-lib-ui/ctrl/networkSelector/list/';

         var lastSortParams;

         // To json string then encode in base64
         var encodedFilterSpec = angular.toJson(scope.networkSelectorFilterSpec);

         var params = {
            targetObjectId: scope.contextObjectId,
            filterSpec: encodedFilterSpec,
            webClientSessionId: scope.userSessionClientId,
            sort: scope.sortParams || [{field:"name", dir:"asc"}]
         };

         var listData;

         if (scope.retrievedNetworks) {
            scope.retrievedNetworks = _.sortBy(
                  scope.retrievedNetworks, function (network) {
               return network.name.toLowerCase();
            });
            listData = scope.retrievedNetworks;
         } else {
            listData = {
               url: dataUrl,
               params: params,
               dataType: vuiConstants.grid.dataType.JSON,
               method: vuiConstants.grid.dataMethod.POST,
               data: 'networks',
               total: 'totalMatchedObjectCount'
            };
         }

         scope.searchTerm = '';
         lastSearchTerm = '';

         scope.doSearch = function() {
            params.filterSpec = getFilterSpec(scope);
            scope.selectedItems = [];
            refreshGrid(scope);
         };

         scope.debouncedRefreshCallback = _.debounce(function() {
            if (scope.searchTerm !== lastSearchTerm) {

               // filter networks
               if (scope.retrievedNetworks) {
                  // client side filtering for already retrieved networks
                  scope.networkSelectorDatagridOptions.data =
                        filterRetrievedNetworks(scope);
               } else {
                  // server side filtering
                  params.filterSpec = getFilterSpec(scope);
                  refreshGrid(scope);
               }

               scope.selectedItems = [];
            }
         }, 500);

         scope.networkSelectorDatagridOptions = {
            actionBarOptions: {
               actions: []
            },
            height: '100%',
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            resizable: true,
            pageConfig: {
               displayMode: vuiConstants.grid.displayMode.VIRTUAL_SCROLLING
            },
            columnDefs: [
               {
                  displayName: i18nService.getString('Common', 'NetworkSelectorDialog.nameColumnHeader'),
                  field: 'name',
                  searchable: false,
                  template: networkNameRendererFactory()
               },
               {
                  displayName: i18nService.getString('Common', 'NetworkSelectorDialog.dvsNameColumnHeader'),
                  field: 'dvsName',
                  sortable: false,
                  searchable: false,
                  template: dvsNameRendererFactory()
               }
            ],
            data: listData,
            selectedItems: [],
            dataBound: function(data) {

               // add filter toolbar
               if(!filterSet) {
                  var filterPlaceholderText = i18nService.getString('Common', 'filter.label');
                  var filterButtonText = i18nService.getString('Common', 'applyFilter.label');
                  var FILTER_INPUT_TEMPLATE =
                     '<div class="filter-input pull-right">' +
                     '<button class="nav-icon fa fa-filter filter-button" ng-click="doSearch()" ' +
                           'aria-label="' + filterButtonText + '" /></button>' +
                     '<input type="text" ng-model="searchTerm" ng-trim="true" ng-change="debouncedRefreshCallback()"' +
                     'placeholder="' + filterPlaceholderText + '"/>' +
                     '</div>';

                  var filterElement = $compile(FILTER_INPUT_TEMPLATE)(scope);

                  var grid = getGridElement();
                  if (grid) {
                     var toolbarElement = grid.find('.k-grid-toolbar');
                     if (toolbarElement.length > 0) {
                        toolbarElement.append(filterElement);
                        filterSet = true;
                     }
                  }

                  scope.searchTerm = '';
                  lastSearchTerm = '';

                  if (scope.retrievedNetworks) {
                     // client side filtering
                     data.sender.dataSource.data = filterRetrievedNetworks(scope);
                  } else {
                     // server side filtering
                     params.filterSpec = getFilterSpec(scope);
                     refreshGrid(scope);
                  }

                  scope.selectedItems = [];
               }
               //TODO: Subscribe to the 'sort' event once Kendo version is updated to 2016.Q3 version. In previous versions there is no such event.

               // In order to detect the sort event, we subscribe to the 'dataBound' event
               // which is triggered when paging event occurs. This happens when
               // sorting/filtering AND when scrolling the virtual list. As we don't want
               // to lose selection when scrolling down the list, we have to determine
               // when the sort event has occurred. This is achieved here by comparing
               // the current and last sorting params and if there is some diff we assume
               // that sort event has occurred.

               // skip when initializing the grid
               if (!data.sender.dataSource.sort()) {
                  return;
               }

               var sortParams = data.sender.dataSource.sort()[0];
               if (lastSortParams && !sortParams
                     || !lastSortParams && sortParams
                     || lastSortParams && sortParams && lastSortParams.dir !== sortParams.dir) {
                  scope.selectedItems = [];
               }

               lastSortParams = sortParams;
            }
         };
      }

      function refreshGrid (scope) {
         scope.isRefreshInProgress = true;

         var dataSource = getDataSource();
         if (!dataSource) {
            return;
         }
         var progressHandlers = null;

         try {
            progressHandlers = dataSource._events["progress"];
            delete dataSource._events["progress"];
         } catch (error) {
            progressHandlers = null;
         }

         dataSource.read().then(function() {
            scope.isRefreshInProgress = false;
            if (progressHandlers !== null) {
               dataSource._events["progress"] = progressHandlers;
            }
         });
      }

      function getFilterSpec (scope) {
         if (scope.searchTerm) {
            scope.networkSelectorFilterSpec.filterText = scope.searchTerm;
            scope.networkSelectorFilterSpec.filteredFields = ["name", "dvsName"];
         } else {
            scope.networkSelectorFilterSpec.filterText = undefined;
            scope.networkSelectorFilterSpec.filteredFields = [];
         }
         lastSearchTerm = scope.searchTerm;


         return angular.toJson(scope.networkSelectorFilterSpec);
      }

      function filterRetrievedNetworks(scope) {
         lastSearchTerm = scope.searchTerm;

         if (!scope.retrievedNetworks) {
            return [];
         }

         if (scope.searchTerm) {
            return _.filter(scope.retrievedNetworks, function(network) {
               return network.name.toLowerCase().indexOf(
                     scope.searchTerm.toLowerCase()) !== -1 ||
                     (network.dvsName &&
                           network.dvsName.toLowerCase().indexOf(
                                 scope.searchTerm.toLowerCase()) !== -1);
            });
         }

         return scope.retrievedNetworks;
      }

      function getDataSource() {
         var grid = getGrid();
         return grid && grid.dataSource;
      }

      function getGrid() {
         var gridElement = getGridElement();
         return gridElement && gridElement.data('kendoGrid');
      }

      function getGridElement() {
         var element = angular.element('.network-select-list .k-grid-content');
         return element && element.parent();
      }

      function dvsNameRendererFactory() {
         return (function(data) {
            if (!data.dvsName) {
               return i18nService.getString('Common', 'NetworkSelectorItem.noData');
            }

            return columnRenderersRegistry
                  .getColumnRenderer('text')(['dvsName'], data, true);
         });
      }

      function networkNameRendererFactory() {
         return (function (data) {

            var icon = 'vsphere-icon-virtual-port-group';
            if (data.isStandardNetwork) {
               icon = 'vsphere-icon-network';
            } else if (data.isOpaqueNetwork) {
               icon = 'vsphere-icon-cloud-network';
            } else if (data.isUplink) {
               icon = 'network-lib-ui-icon-uplink';
            }

            var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([null, 'name', icon], data);
         });
      }

      function postLink(scope) {
         /*
          * Detects click events of the vui-datagrid.
          */
         scope.$watch(function() {
            return scope.networkSelectorDatagridOptions.selectedItems;
         }, function(items) {
            scope.selectedItems = items;
         });
      }

      return directive;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service which handles the prefetching of the networks for networkSelectorController.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.networkLibUi')
         .service('networkSelectorPrefetchingService', networkSelectorPrefetchingService);

   networkSelectorPrefetchingService.$inject = ['dataService', 'defaultUriSchemeUtil'];

   function networkSelectorPrefetchingService(dataService, defaultUriSchemeUtil) {

      return {
         prefetchNetworks: prefetchNetworks
      };

      function prefetchNetworks(objectRef, filterSpec, availableNetworks, prefetchedNetworksCount,
                                additionalParams) {
         var recentNetworks = [];

         var networkSelectorFilteredNetworksProp = "networkSelectorFilteredNetworks";
         var param = {
            includeDistributedPortGroups: filterSpec.includeDistributedPortGroups,
            includeStandardNetworks: filterSpec.includeStandardNetworks,
            includeUplinkPortGroups: filterSpec.includeUplinkPortGroups,
            includeOpaqueNetworks: filterSpec.includeOpaqueNetworks,
            includeOpaqueNetworkTypes: filterSpec.includeOpaqueNetworkTypes,
            networks: availableNetworks,
            networksCount: prefetchedNetworksCount
         };

         var options = {
            propertyParams: [{
               propertyName: networkSelectorFilteredNetworksProp,
               parameterType: "com.vmware.vsphere.client.modules.api.networkselector.NetworkSelectorFilterSpec",
               parameter: param
            }]
         };

         if (!!additionalParams && additionalParams.skipLoadingNotification) {
            options.skipLoadingNotification = additionalParams.skipLoadingNotification;
         }

         return dataService.getProperties(objectRef, [networkSelectorFilteredNetworksProp], options).then(function(result) {
            var networkInfo = result[networkSelectorFilteredNetworksProp];

            _.forEach(networkInfo.networks, function(nw) {
               pushRecentNetwork({
                  name: nw.name,
                  id: defaultUriSchemeUtil.getVsphereObjectId(nw.networkRef),
                  dvsUuid: nw.dvsUuid,
                  portgroupKey: nw.portgroupKey,
                  opaqueNetworkType: nw.opaqueNetworkType
               });
            });

            var res = {
               recentNetworks: recentNetworks,
               networkMatchesCount: result[networkSelectorFilteredNetworksProp].totalMatchedObjectCount
            };
            return res;
         });

         function pushRecentNetwork(network) {
            if (_.findIndex(recentNetworks, function(value) {
                     return value.id === network.id;
                  }) < 0) {
               recentNetworks.push(network);
            }
         }
      }
   }
})();

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   /**
    * Wrapper component designed specifically to upgrade network-selector directive and
    * allow network selector usage in angular.next components.
    * This component is not intended to be used by angular 1.5 components. For this
    * purpose the network-selector directive should continue to be used.
    */
   var upgradableNetworkSelector = {
      bindings: {
         networkSelectorName: '<?', // Optional name parameter.
         // Could be used when using the network selector in a form.
         objectRef: '=', // The context object of the network selector
         mode: '=', // The network selector display mode
         filterSpec: '=', // A spec for filtering the requested networks
         dialogSpec: '=?', // A spec for specifying network's privileges and errors
         preselectedNetwork: '=?', // The pre-selected network if any
         onSelectedNetworks: '&onSelectedNetworks', // A callback function for retrieving the selected networks
         prefetchedNetworks: '=?', //Array with all the prefetched networks
         errorConfig: '<?',  // vxError object used to display error associated with the network selector
         sortParams: '<?', // parameters for sorting the grid of the network selector dialog (ex: [{field:"name", dir:"asc"}] )
         isDisabled: '<?' // disable the selector
      },
      controller: function() {
      },
      template: '<div network-selector ' +
      '               network-selector-name="$ctrl.networkSelectorName"\n' +
      '               object-ref="$ctrl.objectRef"\n' +
      '               mode="$ctrl.mode"\n' +
      '               filter-spec="$ctrl.filterSpec"\n' +
      '               dialog-spec="$ctrl.dialogSpec"\n' +
      '               preselected-network="$ctrl.preselectedNetwork"\n' +
      '               on-selected-networks="$ctrl.onSelectedNetworks(selectedNetworks)"\n' +
      '               prefetched-networks="$ctrl.prefetchedNetworks"\n' +
      '               error-config="$ctrl.errorConfig"\n' +
      '               sort-params="$ctrl.sortParams"\n' +
      '               is-disabled="$ctrl.isDisabled">'
   };

   angular.module('com.vmware.vsphere.client.networkLibUi')
         .component("upgradableNetworkSelector", upgradableNetworkSelector);

})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Directive for enabled/disabled dropdown controlled by checkbox.
 * Dropdown's validation is supported.
 *
 * @param options(required) -
 *    key - value pair for population the dropdown
 * @param selectedValue(required) -
 *    the value that the dropdown manipulates
 * @param isOverridden(required) -
 *    flag that indicates whether the value is overridden by the user or not
 * @param validator(optional) -
 *    a validator object containing validation message and visibility flag
 *    to be passed to the vx-error directive
 * @param selectName(optional) -
 *    the name of the select box. Needed in case of validation, because the directive's
 *    consumer has the control to define whether the selected option is valid or not
 *    based on the surrounding context's configuration.
 */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .directive('overridableDropdown', overridableDropdown);

   overridableDropdown.$inject = ['i18nService'];

   function overridableDropdown(i18nService) {
      var directive = {
         restrict: 'E',
         templateUrl: 'network-lib-ui/resources/network-lib/components/' +
               'overridableDropdown/overridableDropdown.html',
         scope: {
            options: '=',
            selectedValue: '=',
            isOverridden: '=',
            validator: '=?',
            isAutofocused: '=?',
            labelledby: '@?',
            selectName: '@?'
         },
         link: {
            pre: function($scope) {
               $scope.selectName = $scope.selectName || "selectName";
               $scope.validator = $scope.validator || {message: null, visible: false};
               $scope.i18nService = i18nService;
            },
            post: function($scope, element, attrs) {
               if ($scope.isAutofocused) {
                  element[0].querySelector("input").focus();
               }
            }
         }
      };
      return directive;
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var PhysicalAdapterSettingsComponent = (function () {
        function PhysicalAdapterSettingsComponent() {
            this.bindings = {
                hostId: "<",
                pnicDevice: "<",
                registerRefreshCallback: "<"
            };
            this.controller = VirtualAdapterSettingsController;
            this.templateUrl = "network-lib-ui/resources/network-lib/components/pnicSettings/physicalAdapterSettingsTemplate.html";
        }
        return PhysicalAdapterSettingsComponent;
    }());
    dvs_ui.PhysicalAdapterSettingsComponent = PhysicalAdapterSettingsComponent;
    var VirtualAdapterSettingsController = (function () {
        function VirtualAdapterSettingsController(i18nService, physicalAdaptersListService, physicalAdapterDetailsViewService) {
            this.i18nService = i18nService;
            this.physicalAdaptersListService = physicalAdaptersListService;
            this.physicalAdapterDetailsViewService = physicalAdapterDetailsViewService;
            this.loadingData = false;
        }
        VirtualAdapterSettingsController.prototype.$onInit = function () {
            var _this = this;
            if (this.registerRefreshCallback !== undefined) {
                this.registerRefreshCallback(function () { return _this.requestData(); });
            }
        };
        VirtualAdapterSettingsController.prototype.$onChanges = function () {
            if (this.hostId !== undefined && this.pnicDevice !== undefined) {
                this.requestData();
            }
        };
        VirtualAdapterSettingsController.prototype.requestData = function () {
            var _this = this;
            this.loadingData = true;
            var physicalAdapterPromise = this.physicalAdaptersListService
                .getPhysicalAdapterDetailsItem(this.hostId, this.pnicDevice);
            this.lastPhysicalAdapterPromise = physicalAdapterPromise;
            physicalAdapterPromise.then(function (pnicDetailsItem) {
                if (_this.isResponseForLastRequest(physicalAdapterPromise)) {
                    _this.adapterDetailsData = _this.physicalAdapterDetailsViewService.build(pnicDetailsItem);
                }
            }).finally(function () {
                if (_this.isResponseForLastRequest(physicalAdapterPromise)) {
                    _this.loadingData = false;
                }
            });
        };
        VirtualAdapterSettingsController.prototype.isResponseForLastRequest = function (physicalAdapterPromise) {
            return physicalAdapterPromise === this.lastPhysicalAdapterPromise;
        };
        VirtualAdapterSettingsController.$inject = [
            "i18nService",
            "physicalAdaptersListService",
            "physicalAdapterDetailsViewService"
        ];
        return VirtualAdapterSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .component("pnicSettings", new PhysicalAdapterSettingsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var dvs_ui;
(function (dvs_ui) {
    var VirtualAdapterSettingsComponent = (function () {
        function VirtualAdapterSettingsComponent() {
            this.bindings = {
                hostId: "<",
                vnicDevice: "<",
                registerRefreshCallback: "<",
                customizedSettings: "<"
            };
            this.controller = VirtualAdapterSettingsController;
            this.templateUrl = "network-lib-ui/resources/network-lib/components/vnicSettings/virtualAdapterSettingsTemplate.html";
        }
        return VirtualAdapterSettingsComponent;
    }());
    dvs_ui.VirtualAdapterSettingsComponent = VirtualAdapterSettingsComponent;
    var VirtualAdapterSettingsController = (function () {
        function VirtualAdapterSettingsController(i18nService, networkDetailsViewService, vmKernelAdapterService) {
            this.i18nService = i18nService;
            this.networkDetailsViewService = networkDetailsViewService;
            this.vmKernelAdapterService = vmKernelAdapterService;
            this.loadingData = false;
        }
        VirtualAdapterSettingsController.prototype.$onInit = function () {
            var _this = this;
            if (this.registerRefreshCallback !== undefined) {
                this.registerRefreshCallback(function () { return _this.requestData(); });
            }
        };
        VirtualAdapterSettingsController.prototype.$onChanges = function () {
            if (this.hostId !== undefined && this.vnicDevice !== undefined) {
                this.requestData();
            }
        };
        VirtualAdapterSettingsController.prototype.requestData = function () {
            var _this = this;
            this.loadingData = true;
            var vmKernelAdapterPromise = this.vmKernelAdapterService.getVnicDetailsData(this.hostId, this.vnicDevice);
            this.lastVmKernelAdapterPromise = vmKernelAdapterPromise;
            vmKernelAdapterPromise
                .then(function (hostVnicDetailsData) {
                if (_this.lastVmKernelAdapterPromise === vmKernelAdapterPromise) {
                    _this.propertyViewData = _this.networkDetailsViewService
                        .build(hostVnicDetailsData, _this.customizedSettings);
                }
            })
                .finally(function () {
                if (_this.lastVmKernelAdapterPromise === vmKernelAdapterPromise) {
                    _this.loadingData = false;
                }
            });
        };
        VirtualAdapterSettingsController.$inject = [
            "i18nService",
            "networkDetailsViewService",
            "vmKernelAdapterService"
        ];
        return VirtualAdapterSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .component("vnicSettings", new VirtualAdapterSettingsComponent());
})(dvs_ui || (dvs_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    var TrafficShapingPolicyValidator = (function () {
        function TrafficShapingPolicyValidator(i18nService, networkUtil, networkUiConstants) {
            this.i18nService = i18nService;
            this.networkUtil = networkUtil;
            this.networkUiConstants = networkUiConstants;
        }
        /**
         * Returns error message when the given value is invalid traffic shaping input or null.
         * @param value
         *         The value to be validated
         * @param setting {networkUiConstants.TrafficShapingSetting}
         *
         * @returns {null | string}
         */
        TrafficShapingPolicyValidator.prototype.getTrafficShapingErrorMessage = function (value, setting) {
            this.validateAttributeName(setting);
            var maxValue = this.networkUiConstants.MAX_SAFE_INTEGER;
            var isValuePositiveInteger = this.networkUtil.isPositiveInteger(value) && value > 0;
            var isValueSafeInteger = value <= maxValue;
            // Define the correct message:
            var message = null;
            if (isValueSafeInteger === false) {
                switch (setting) {
                    case this.networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.averageBandwidth.errorMessage.exceeding", maxValue);
                        break;
                    case this.networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.peakBandwidth.errorMessage.exceeding", maxValue);
                        break;
                    case this.networkUiConstants.TrafficShapingSetting.BURST_SIZE:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.burstSize.errorMessage.exceeding", maxValue);
                        break;
                }
            }
            else if (isValuePositiveInteger === false) {
                switch (setting) {
                    case this.networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.averageBandwidth.errorMessage");
                        break;
                    case this.networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.peakBandwidth.errorMessage");
                        break;
                    case this.networkUiConstants.TrafficShapingSetting.BURST_SIZE:
                        message = this.i18nService.getString("H5NetworkUi", "VSwitchTrafficShapingPage.burstSize.errorMessage");
                        break;
                }
            }
            return message;
        };
        TrafficShapingPolicyValidator.prototype.validateAttributeName = function (attributeName) {
            if (attributeName !== this.networkUiConstants.TrafficShapingSetting.AVERAGE_BANDWIDTH &&
                attributeName !== this.networkUiConstants.TrafficShapingSetting.PEAK_BANDWIDTH &&
                attributeName !== this.networkUiConstants.TrafficShapingSetting.BURST_SIZE) {
                throw new Error("Attribute name must be networkUiConstants.TrafficShapingSetting");
            }
        };
        TrafficShapingPolicyValidator.$inject = [
            "i18nService",
            "networkUtil",
            "networkUiConstants"
        ];
        return TrafficShapingPolicyValidator;
    }());
    network_lib_ui.TrafficShapingPolicyValidator = TrafficShapingPolicyValidator;
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .service("trafficShapingPolicyValidator", TrafficShapingPolicyValidator);
})(network_lib_ui || (network_lib_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .service('distributedPortgroupPoliciesViewService', distributedPortgroupPoliciesViewService);

   distributedPortgroupPoliciesViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUiConstants'
   ];

   var loadBalancingIpHash = "loadbalance_ip";

   function distributedPortgroupPoliciesViewService (
         i18nService,
         vxPropertyViewService,
         networkUiConstants) {

      return {
         build: build,
         buildDistributedPortPoliciesView: buildDistributedPortPoliciesView
      };

      function buildDistributedPortPoliciesView(portPolicy, builder) {
         return _buildInternal(portPolicy, builder, true);
      }

      function build(portPolicy, builder) {
         return _buildInternal(portPolicy, builder);
      }

      function _buildInternal(portPolicy, builder, isSinglePortContext) {
         if (!portPolicy) {
            return {};
         }

         var policiesBuilder = builder || vxPropertyViewService.createPropertyViewBuilder();
         var policiesCategory = policiesBuilder
               .category('policies')
               .title(i18nService.getString('NetworkUi', 'dvpg.manage.settings.policiesHeader'));

         // Security
         if (portPolicy.security) {
            var securitySection = policiesCategory
                  .section('security')
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.security.title'));

            var acceptValue = i18nService.getString('NetworkUi', 'dvpg.policy.security.accept');
            var rejectValue = i18nService.getString('NetworkUi', 'dvpg.policy.security.reject');

            securitySection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.security.promiscuousMode'),
                  portPolicy.security.allowPromiscuous ? acceptValue : rejectValue);

            securitySection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.security.macAddressChanges'),
                  portPolicy.security.macChanges ? acceptValue : rejectValue);

            securitySection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.security.forgedTransmits'),
                  portPolicy.security.forgedTransmits ? acceptValue : rejectValue);
         }

         // Ingress traffic shaping
         if (portPolicy.inTrafficShaping) {
            var ingressTrafficShapingSection = policiesCategory
                  .section("ingressTrafficShaping")
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.shaping.ingress'));

            ingressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status'),
                  portPolicy.inTrafficShaping.enabled
                        ? i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.on')
                        : i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.off')
            );

            ingressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.avgBW'),
                  replaceEmptyString(portPolicy.inTrafficShaping.averageBandwidthSummary));

            ingressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.peakBW'),
                  replaceEmptyString(portPolicy.inTrafficShaping.peakBandwidthSummary));

            ingressTrafficShapingSection.property(
                  i18nService.getString(
                        'NetworkUi', 'dvpg.policy.shaping.burstSize'),
                  replaceEmptyString(portPolicy.inTrafficShaping.burstSizeSummary));
         }

         // Egress traffic shaping
         if (portPolicy.outTrafficShaping) {
            var egressTrafficShapingSection = policiesCategory
                  .section("egressTrafficShaping")
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.shaping.egress'));

            egressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status'),
                  portPolicy.outTrafficShaping.enabled
                        ? i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.on')
                        : i18nService.getString('NetworkUi', 'dvpg.policy.shaping.status.off')
            );

            egressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.avgBW'),
                  replaceEmptyString(portPolicy.outTrafficShaping.averageBandwidthSummary));

            egressTrafficShapingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.shaping.peakBW'),
                  replaceEmptyString(portPolicy.outTrafficShaping.peakBandwidthSummary));

            egressTrafficShapingSection.property(
                  i18nService.getString(
                        'NetworkUi', 'dvpg.policy.shaping.burstSize'),
                  replaceEmptyString(portPolicy.outTrafficShaping.burstSizeSummary));
         }

         // Vlan
         if (portPolicy.vlan) {
            var vlanSection = policiesCategory
                  .section("vlan")
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.vlan.title'));

            switch (portPolicy.vlan.type) {
               case networkUiConstants.Vlan.Type.NONE:
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.label'),
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.none'));
                  break;
               case networkUiConstants.Vlan.Type.VLAN:
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.label'),
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.vlan'));
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.id.label'),
                        portPolicy.vlan.value);
                  break;
               case networkUiConstants.Vlan.Type.TRUNK:
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.label'),
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.trunk'));
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.trunk.label'),
                        portPolicy.vlan.value);
                  break;
               case networkUiConstants.Vlan.Type.PRIVATE:
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.label'),
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.type.private'));
                  vlanSection.property(
                        i18nService.getString('NetworkUi', 'dvpg.policy.vlan.private.label'),
                        portPolicy.vlan.value);
                  break;
            }
         }

         // LACP
         if (portPolicy.basicLacpAvailable) {
            var lacpSection = policiesCategory
                  .section("lacp")
                  .title(i18nService.getString(
                        'NetworkUi', 'dvpg.policy.lacp.title'));

            if (portPolicy.lacp.enable) {
               lacpSection.property(
                     i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.label'),
                     i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.enabled'));

               lacpSection.property(
                     i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.mode'),
                     portPolicy.lacp.mode === networkUiConstants.LacpMode.ACTIVE
                           ? i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.active')
                           : i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.passive'));
            } else {
               lacpSection.property(
                     i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.label'),
                     i18nService.getString('NetworkUi', 'dvpg.policy.lacp.status.disabled'));
            }
         }

         // Teaming and failover
         if (portPolicy.teamingAndFailover) {
            var teamingAndFailover = portPolicy.teamingAndFailover;
            var teamingSection = policiesCategory
                  .section("teaming")
                  .title(i18nService.getString(
                        'NetworkUi', 'dvpg.policy.failover.title'));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.lb.label'),
                  getLoadBalancingPolicyValue(teamingAndFailover.loadBalancing));

            if (teamingAndFailover.loadBalancing === loadBalancingIpHash) {
               var warningMessage = getLoadBalancingWarningMessage(teamingAndFailover);
               if (warningMessage) {
                  teamingSection.warning(warningMessage);
               }
               getLoadBalancingInfoMessages().forEach(function(message) {
                  teamingSection.info(message);
               });
            }

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.detection.label'),
                  teamingAndFailover.failureDetection ?
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.detection.beaconProbing') :
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.detection.linkStatus'));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.notify.label'),
                  teamingAndFailover.notifySwitches ?
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.notify.on') :
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.notify.off'));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.failback.label'),
                  teamingAndFailover.failback ?
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.failback.on') :
                        i18nService.getString('NetworkUi', 'dvpg.policy.failover.failback.off'));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.order.active.label'),
                  replaceEmptyString(teamingAndFailover.activeAdapters.join(", ")));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.order.standby.label'),
                  replaceEmptyString(teamingAndFailover.standByAdapters.join(", ")));

            teamingSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.failover.order.unused.label'),
                  replaceEmptyString(teamingAndFailover.unusedAdapters.join(", ")));
         }

         // Monitoring
         if (portPolicy.monitoring !== null && typeof portPolicy.monitoring !== 'undefined') {
            var monitoringSection = policiesCategory
                  .section("monitoring")
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.monitoring.title'));

            monitoringSection.property(
                  i18nService.getString('NetworkUi', 'dvpg.policy.monitoring.status.label'),
                  portPolicy.monitoring
                        ? i18nService.getString('NetworkUi', 'dvpg.policy.monitoring.status.on')
                        : i18nService.getString('NetworkUi', 'dvpg.policy.monitoring.status.off')
            );
         }

         // Miscellaneous
         if (portPolicy.blocked !== null && typeof portPolicy.blocked !== 'undefined') {
            var miscSection = policiesCategory
                  .section("miscellaneous")
                  .title(i18nService.getString('NetworkUi', 'dvpg.policy.misc.title'));

            miscSection.property(
                  isSinglePortContext
                        ? i18nService.getString('NetworkUi', 'port.policy.misc.block.label')
                        : i18nService.getString('NetworkUi', 'dvpg.policy.misc.block.label'),
                  portPolicy.blocked
                        ? i18nService.getString('NetworkUi', 'dvpg.policy.misc.block.on')
                        : i18nService.getString('NetworkUi', 'dvpg.policy.misc.block.off'));
         }

         if (!builder) {
            return policiesBuilder.build();
         }
      }

      function replaceEmptyString(value) {
         return value
               ? value
               : i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData');
      }

      function getLoadBalancingInfoMessages() {
         return [
            i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.info.etherChannel"),
            i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.info.portGroupPolicies")
         ];
      }

      function getLoadBalancingWarningMessage(teamingAndFailover) {
         if (teamingAndFailover.standByAdapters.length !== 0 && teamingAndFailover.failureDetection) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbingAndStandbyUplinks");
         } else if (teamingAndFailover.standByAdapters.length !== 0) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.standbyUplinks");
         } else if (teamingAndFailover.failureDetection) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbing");
         } else {
            return null;
         }
      }

      function getLoadBalancingPolicyValue(policy) {
         switch (policy) {
            case networkUiConstants.LoadBalancingPolicy.SRCID:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcid');
            case networkUiConstants.LoadBalancingPolicy.IP:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_ip');
            case networkUiConstants.LoadBalancingPolicy.SRCMAC:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcmac');
            case networkUiConstants.LoadBalancingPolicy.EXPLICIT:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.failover_explicit');
            case networkUiConstants.LoadBalancingPolicy.LOADBASED:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_loadbased');
            default:
               return i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData');
         }
      }
   }
})();

var network_lib_ui;
(function (network_lib_ui) {
    var DvPortgroupPropertiesService = (function () {
        function DvPortgroupPropertiesService(dataService, i18nService, $q, networkUiConstants, vxPropertyViewService) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.networkUiConstants = networkUiConstants;
            this.vxPropertyViewService = vxPropertyViewService;
            this.i18n = this.i18nService.getString;
        }
        DvPortgroupPropertiesService.prototype.requestDvPortgroupPropertiesAndPolicy = function (hostId, portgroupKey) {
            if (!hostId || !portgroupKey) {
                return this.$q.when(null);
            }
            return this.dataService.getProperties(hostId, [DvPortgroupPropertiesService.DVPG_PROPERTIES_AND_POLICY], {
                propertyParams: [{
                        propertyName: DvPortgroupPropertiesService.DVPG_PROPERTIES_AND_POLICY,
                        parameterType: "java.lang.String",
                        parameter: portgroupKey
                    }]
            }).then(function (response) {
                return response &&
                    response[DvPortgroupPropertiesService.DVPG_PROPERTIES_AND_POLICY];
            });
        };
        DvPortgroupPropertiesService.prototype.buildProperties = function (properties) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var generalCategory = builder.category("general");
            this.addPropertiesToSection(properties, generalCategory);
            return builder.build();
        };
        DvPortgroupPropertiesService.prototype.addPropertiesToSection = function (properties, category) {
            // General section
            var generalSection = category.section("generalSection")
                .title(this.i18n("NetworkUi", "dvpg.properties.general"));
            generalSection.property(this.i18n("NetworkUi", "dvpg.properties.name.label"), properties.name);
            if (properties.description) {
                generalSection.property(this.i18n("NetworkUi", "dvpg.properties.description.label"), properties.description);
            }
            generalSection.property(this.i18n("NetworkUi", "dvpg.properties.portBinding.label"), this.getPortBindingText(properties.portBinding));
            if (properties.portAllocation !== null
                && typeof properties.portAllocation !== "undefined") {
                generalSection.property(this.i18n("NetworkUi", "dvpg.properties.portAllocation.label"), properties.portAllocation
                    ? this.i18n("NetworkUi", "dvpg.properties.portAllocation.autoExpand.true")
                    : this.i18n("NetworkUi", "dvpg.properties.portAllocation.autoExpand.false"));
            }
            generalSection.property(this.i18n("NetworkUi", "dvpg.properties.numberOfPorts.label"), properties.numberOfPorts);
            if (properties.vmVnicResourcePoolName) {
                generalSection.property(this.i18n("NetworkUi", "dvpg.properties.vmVnicResPool.label"), properties.vmVnicResourcePoolName);
            }
            // Advanced section
            var advancedSection = category.section("advancedSection")
                .title(this.i18n("NetworkUi", "dvpg.properties.advanced"));
            advancedSection.property(this.i18n("NetworkUi", "dvpg.properties.resetAtDisconnect.label"), properties.portConfigResetAtDisconnect
                ? this.i18n("NetworkUi", "dvpg.properties.resetAtDisconnect.on")
                : this.i18n("NetworkUi", "dvpg.properties.resetAtDisconnect.off"));
            // Override port policies section
            var overridePortPoliciesSection = category.section("overridePortPoliciesSection")
                .title(this.i18n("NetworkUi", "dvpg.policy.override.label"));
            var overridePolicyEnabledLabel = this.i18n("NetworkUi", "dvpg.policy.override.on");
            var overridePolicyDisabledLabel = this.i18n("NetworkUi", "dvpg.policy.override.off");
            overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.blockPorts"), properties.blockOverrideAllowed
                ? overridePolicyEnabledLabel
                : overridePolicyDisabledLabel);
            if (properties.shapingOverrideAllowed !== null
                && typeof properties.shapingOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.trafficShaping"), properties.shapingOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.vendorConfig"), properties.vendorConfigOverrideAllowed
                ? overridePolicyEnabledLabel
                : overridePolicyDisabledLabel);
            if (properties.vlanOverrideAllowed !== null
                && typeof properties.vlanOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.vlan"), properties.vlanOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            if (properties.uplinkTeamingOverrideAllowed !== null
                && typeof properties.uplinkTeamingOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.teaming"), properties.uplinkTeamingOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            if (properties.networkResourcePoolOverrideAllowed !== null
                && typeof properties.networkResourcePoolOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.iorm"), properties.networkResourcePoolOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            if (properties.securityPolicyOverrideAllowed !== null
                && typeof properties.securityPolicyOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.security"), properties.securityPolicyOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            if (properties.ipfixOverrideAllowed !== null
                && typeof properties.ipfixOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.monitoring"), properties.ipfixOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
            if (properties.trafficFilterOverrideAllowed !== null
                && typeof properties.trafficFilterOverrideAllowed !== "undefined") {
                overridePortPoliciesSection.property(this.i18n("NetworkUi", "dvpg.policy.override.trafficFilteringConfig"), properties.trafficFilterOverrideAllowed
                    ? overridePolicyEnabledLabel
                    : overridePolicyDisabledLabel);
            }
        };
        DvPortgroupPropertiesService.prototype.getPortBindingText = function (portBinding) {
            switch (portBinding) {
                case this.networkUiConstants.PortgroupType.EARLY_BINDING:
                    return this.i18n("NetworkUi", "dvpg.properties.portBinding.earlyBinding");
                case this.networkUiConstants.PortgroupType.LATE_BINDING:
                    return this.i18n("NetworkUi", "dvpg.properties.portBinding.lateBinding");
                case this.networkUiConstants.PortgroupType.EPHEMERAL:
                    return this.i18n("NetworkUi", "dvpg.properties.portBinding.ephemeral");
                default:
                    return portBinding;
            }
        };
        DvPortgroupPropertiesService.DVPG_PROPERTIES_AND_POLICY = "dvpg:dvPortgroupPropertiesAndPolicy";
        DvPortgroupPropertiesService.$inject = [
            "dataService",
            "i18nService",
            "$q",
            "networkUiConstants",
            "vxPropertyViewService"];
        return DvPortgroupPropertiesService;
    }());
    network_lib_ui.DvPortgroupPropertiesService = DvPortgroupPropertiesService;
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .service("dvPortgroupPropertiesService", DvPortgroupPropertiesService);
})(network_lib_ui || (network_lib_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Shows failover order of connectees grouped in categories and provides the ability to add new ones.
 */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.networkLibUi')
      .directive('failoverOrder', failoverOrder);

   failoverOrder.$inject = [
         '$timeout',
         'FailoverOrderDatagridManager'
   ];

   function failoverOrder(
         $timeout,
         FailoverOrderDatagridManager) {
      var directive = {
         restrict: 'E',
         template: '<div class="fill-parent no-column-header' +
                   ' assigned-adapters-datagrid failover-order" ' +
                   'vx-stretch-grid vui-datagrid="datagridOptions" ' +
                   'vx-datagrid-preselect-item="true" reselect-on-change="true" ' +
                   'preselect-comparator="preselectComparator"></div>',
         scope: {
            failoverOrder: '=',
            onSelectionChange: '=?',
            actions: "=?",
            actionsDisabled: '=?',
            selectionMode: '=?',
            editAllItems: '=?'
         },
         replace: false,
         link: {
            pre: function ($scope) {

               var failoverOrderDatagridManager = new FailoverOrderDatagridManager(
                     $scope.failoverOrder, $scope.actions,
                     $scope.selectionMode, $scope.editAllItems,
                     $scope.actionsDisabled);

               $scope.datagridOptions = failoverOrderDatagridManager.datagridOptions;
               $scope.preselectComparator = failoverOrderDatagridManager.preselectComparator;
               $scope.$watch(function () {
                  return $scope.datagridOptions.selectedItems;
               }, function (selectedItems) {
                  var selectionChanged = failoverOrderDatagridManager
                        .selectionChanged(selectedItems);
                  if (selectionChanged && $scope.onSelectionChange) {
                     $scope.onSelectionChange(selectedItems);
                  }
               });

               $scope.$watch('actionsDisabled', function () {
                  failoverOrderDatagridManager.enableDisableAllActions(
                        $scope.datagridOptions.selectedItems,
                        $scope.actionsDisabled);
               });

               // Workaround which resizes datagrid after the action bar creation
               $timeout(function () {
                  var gridElement = $("div.assigned-adapters-datagrid .k-grid");
                  if (gridElement) {
                     var kendoGrid = gridElement.data("kendoGrid");
                     if (kendoGrid) {
                        kendoGrid.resize();
                     }
                  }
               }, 0);
            }
         }
      };
      return directive;
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.networkLibUi')
      .factory('FailoverOrderDatagridManager', FailoverOrderDatagridManager);

   FailoverOrderDatagridManager.$inject = ['vuiConstants', 'i18nService',
         'clarityModalService', 'pnicSelectorDialogService', 'networkUiConstants'];

   function FailoverOrderDatagridManager(vuiConstants, i18nService,
         clarityModalService, pnicSelectorDialogService, networkUiConstants) {

      // Helper array for looping through connectee categories
      var categories = ['active', 'standby', 'unused'];

      var ADD = networkUiConstants.failoverOrderActions.ADD;
      var REMOVE = networkUiConstants.failoverOrderActions.REMOVE;
      var MOVE_UP = networkUiConstants.failoverOrderActions.MOVE_UP;
      var MOVE_DOWN = networkUiConstants.failoverOrderActions.MOVE_DOWN;

      /**
       *
       * @param failoverOrder
       *       Info about the connectees and the categories.
       * @param {vuiConstants.grid.selectionMode} selectionMode
       *
       * @param {boolean} areAllItemsEditable
       *       Default false
       */
      return function (failoverOrder, visibleActions,
                       selectionMode, editAllItems, actionsDisabled) {

         //Default value of editAllItems is false
         editAllItems = editAllItems || false;

         var disableAllActions = actionsDisabled;
         var connectees = failoverOrder.connectees;

         /*
            Store the initially unclaimed physical adapters.
            The array 'unclaimed' should stay unchanged if some nics are moved
            from unclaimed to active and the directive is invoked once again
            afterwards.
            (for example - you are in a wizard, add a nic to the active category,
            go back to the previous page and then invoke the directive again).
          */
         if (failoverOrder.connectees) {
            if (!failoverOrder.connectees.unclaimedInitial) {
               failoverOrder.connectees.unclaimedInitial =
                  _.extend([], failoverOrder.connectees.unclaimed);
            }
         }

         var selectedItemsBeforeDatagridUpdate = [];

         var allActionDefinitions = [
            {
               id: ADD,
               enabled: !actionsDisabled,
               iconClass: 'network-lib-ui-icon-add',
               tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.add"),
               onClick: _addCallback
            },
            vuiConstants.actions.SEPARATOR,
            {
               id: REMOVE,
               enabled: false,
               iconClass: 'vx-icon-removeIcon',
               tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.remove"),
               onClick: _removeCallback
            },
            {
               id: MOVE_UP,
               enabled: false,
               iconClass: 'vx-icon-moveUp',
               tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.moveUp"),
               onClick: _moveUpCallback
            },
            {
               id: MOVE_DOWN,
               enabled: false,
               iconClass: 'vx-icon-moveDown',
               tooltipText: i18nService.getString("NetworkUi", "FailoverOrder.moveDown"),
               onClick: _moveDownCallback
            }
         ];

         var datagridOptions = _createDatagridOptions(selectionMode);

         return {
            datagridOptions: datagridOptions,
            selectionChanged: _selectionChanged,
            preselectComparator: _preselectComparator,
            enableDisableAllActions: _enableDisableAllActions
         };

         /**
          * Checks whether the selection really changed or the call was due to moving
          * elements up or down. Updates the action bar of the grid with the available
          * actions based on the new selection.
          * @param selectedItems
          *       list of the selected parameters
          * @returns
          *       true if the selection actually changed.
          */
         function _selectionChanged(selectedItems) {
            // vxDatagridPreselectItem iterates over the grid items and calls preselectComparator for
            // each of them. For each item where the preselectComparator returns true the
            // vxDatagridPreselectItem directive selects it and triggers this watch,
            // but  we are interested only in the last update of selectedItems.
            // This happens when the number of selectedItems reaches the number of the
            // selected items before the datagrid update a.k.a selectedItemsBeforeDatagridUpdate
            if(selectedItemsBeforeDatagridUpdate.length !== 0
                  && selectedItemsBeforeDatagridUpdate.length !== selectedItems.length) {
               return false;
            }
            //once the number of selected items reaches the number before making an
            //action we are no longer interesting in selectedItemsBeforeDatagridUpdate and
            //have to reset it because next time _selectionChanged is called it could be
            //not because of an action but an usual user interaction.
            selectedItemsBeforeDatagridUpdate = [];

            return _updateActions(selectedItems);
         }

         /**
          * Updates the enabled/disabled state of the grid actions.
          * @param selectedItems
          *       list of the selected parameters
          * @param actionsDisabled
          *       True if all actions need to be disabled
          * @returns
          *       true if the selection actually changed.
          */
         function _enableDisableAllActions(selectedItems, actionsDisabled) {
            disableAllActions = actionsDisabled;
            _updateActions(selectedItems);
         }

         /**
          * Updates the enabled/disabled state of the grid actions.
          * @param selectedItems
          *       list of the selected parameters
          * @returns
          *       true if the selection actually changed.
          */
         function _updateActions(selectedItems) {

            _.forEach(datagridOptions.actionBarOptions.actions, function (action) {
               if (action === vuiConstants.actions.SEPARATOR) {
                  return;
               }

               if (disableAllActions) {
                  action.enabled = false;
                  return;
               }

               if (!selectedItems || selectedItems.length === 0) {
                  action.enabled = action.id === ADD;
                  return;
               }

               switch (action.id) {
                  case ADD :
                     action.enabled = true;
                     break;
                  case REMOVE :
                     action.enabled = _isRemoveButtonEnabled(selectedItems);
                     break;
                  case MOVE_UP :
                     action.enabled =
                           connectees && !_isFirstItemSelected(selectedItems, connectees.active) &&
                           _isPnicSelected(selectedItems);
                     break;
                  case MOVE_DOWN :
                     action.enabled =
                           connectees && !_isLastItemSelected(selectedItems, connectees.unused) &&
                           _isPnicSelected(selectedItems);
                     break;
               }
            });
            return true;
         }

         /**
          * Returns true if the item has to be selected on grid's data source reset.
          */
         function _preselectComparator(datagridItem) {
            return _.some(selectedItemsBeforeDatagridUpdate, function(item) {
               if (item.value === datagridItem.value) {
                  return true;
               }
            });
         }

         /**
          * Check if there is pnic in the selectedItems
          */
         function _isPnicSelected(selectedItems) {
            return _.some(selectedItems, function (item) {
               return !item.categoryItem;
            });
         }

         /**
          * Checks if one of the selected items is in first position in the given array.
          */
         function _isFirstItemSelected(selectedItems, items) {
            var isFirstItemSelected = _.some(selectedItems, function (item) {
               return item.value === items[0];
            });

            return selectedItems
               && selectedItems.length > 0
               && items
               && items.length > 0
               && isFirstItemSelected;
         }

         /**
          * Checks if one of the selected items is in last position in the given array.
          */
         function _isLastItemSelected(selectedItems, items) {
            var isLastItemSelected = _.some(selectedItems, function (item) {
               return item.value === items[items.length - 1];
            });
            return selectedItems
               && selectedItems.length > 0
               && items
               && items.length > 0
               && isLastItemSelected;
         }

         /**
          * Check are there new pnics and there are no old pnics in the selected items.
          */
         function _isRemoveButtonEnabled(selectedItems) {
            var isRemoveButtonEnabled;

            if(editAllItems) {
               var isPnicSelected = _.some(selectedItems, function (item) {
                  return !item.categoryItem;
               });

               isRemoveButtonEnabled = !!selectedItems && isPnicSelected;

            } else {
               var isNewPnicSelected = _.some(selectedItems, function (item) {
                  return _isNewPnic(item.value);
               });

               var areAllElementsCategoriesOrNewPnics = _.every(selectedItems, function (item) {
                  return item.categoryItem || _isNewPnic(item.value);
               });

               isRemoveButtonEnabled = !!selectedItems && isNewPnicSelected && areAllElementsCategoriesOrNewPnics;
            }

            return isRemoveButtonEnabled;
         }

         /**
          * Returns options for failover order data grid.
          * @param failoverOrder
          *       Data to initialize the grid with.
          *       Flag if the datagrid should only show unclaimed pnics.
          * @param {vuiConstants.grid.selectionMode} selectionMode
          *
          */
         function _createDatagridOptions(selectionMode) {
            var datagridOptions = {
               columnDefs: _getColumnDefinitions(),
               data: _createDatagridData(),
               pageConfig: {
                  hidePager: true
               },
               selectedItems: [],
               resizable: true,
               height: '100%',
               sortMode: vuiConstants.grid.sortMode.NONE,
               selectionMode: vuiConstants.grid.selectionMode.MULTI,
               showCheckboxesOnMultiSelection: false,
               actionBarOptions: {
                  actions: _getActionDefinitions()
               }
            };
            if(selectionMode) {
               datagridOptions.selectionMode = selectionMode;
            }

            return datagridOptions;
         }

         /**
          * Loops through the given labels and creates the corresponding category items.
          *
          * @param labels
          *       The label names.
          */
         function _createCategories(labels) {
            var categories = {};
            _.forEach(labels, function (value, key) {
               categories[key] = {
                  categoryItem: true,
                  value: value
               };
            });
            return categories;
         }

         /**
          * Maps array of connectees' names to array of objects,
          * cointaining the connectees' names.
          */
         function _mapConnectees(connectees) {
            return _.map(connectees, function (connecteeName) {
               return {
                  value: connecteeName
               };
            });
         }

         /**
          * Categorizes the given data.
          */
         function _createDatagridData() {
            var datagridData = [];
            var categories = _createCategories(failoverOrder.labels);
            _.forEach(categories, function (value, key) {
               datagridData.push(categories[key]);
               if (connectees && connectees[key]) {
                  datagridData = datagridData.concat(_mapConnectees(connectees[key]));
               }
            });
            return datagridData;
         }

         /**
          * Changes the datagrid's datasource and preserves the previously selected items.
          * @param itemsToBeSelected
          *             Array containing objects with property value.
          *             When new pnics are added we are selecting them,
          *             in other cases we use last selected items from the grid.
          */
         function _updateDataGrid (itemsToBeSelected) {
            var selectedItems =
               _.filter(datagridOptions.selectedItems, function(datagridItem) {
                  return !datagridItem.categoryItem;
               });

            selectedItemsBeforeDatagridUpdate = itemsToBeSelected ?
               itemsToBeSelected : selectedItems;

            datagridOptions.data = _createDatagridData();
         }

         /**
          * Creates the action bar items for the datagrid.
          * The unclaimed pnics datagrid does not show actions at all.
          *
          * If there are visibleActions defined, the allActionDefinitions
          * array is filtered according to the directive's definition.
          *
          * @returns
          *       The array of actions.
          */
         function _getActionDefinitions() {
            if (visibleActions) {
               return _.filter(allActionDefinitions, function (action) {
                  return _.indexOf(visibleActions, action.id) !== -1;
               });
            } else {
               return allActionDefinitions;
            }
         }

         /**
          * Add button handler.
          */
         function _addCallback() {
            if (connectees.unclaimed && connectees.unclaimed.length > 0) {
               pnicSelectorDialogService.createPnicSelectorDialog(
                     connectees.unclaimed, failoverOrder.connecteesDetails,
                     vuiConstants.grid.selectionMode.MULTI, null, _add);
            } else {
               var modalOptions = {
                  message: i18nService.getString('NetworkUi', 'FailoverOrderEditor.noFreeNics'),
                  title: i18nService.getString('H5NetworkUi', 'failoverOrder.notification.warning'),
                  icon: "vx-icon-warning-32x32",
                  hideCancelButton: true,
                  preserveNewlines: true,
                  submit: function() {}
               };

               clarityModalService.openConfirmationModal(modalOptions);
            }
         }

         /**
          * Adds selected unclaimed connectees to the list with active ones.
          */
         function _add(selectedConnectees) {
            var itemsToBeSelected = [];
            _.forEach(selectedConnectees, function (connectee) {
               var index = _.indexOf(connectees.unclaimed, connectee);
               connectees.unclaimed.splice(index, 1);
               connectees.active.push(connectee);

               itemsToBeSelected.push({value:connectee});
            });
            _updateDataGrid(itemsToBeSelected);
         }

         /**
          * Remove button handler.
          */
         function _removeCallback() {
            _.each(datagridOptions.selectedItems, function (item) {
               _.some(categories, function (categoryName) {
                  return _seekAndDestroy(categoryName, item);
               });
            });
            datagridOptions.selectedItems.splice(0);

            _updateDataGrid();
         }

         /**
          * Searches for selected connectee and moves it to the unclaimed connectees.
          */
         function _seekAndDestroy(categoryKey, selectedConnectee) {
            var category = connectees[categoryKey];
            var index = _.indexOf(category, selectedConnectee.value);

            if (index !== -1) {
               category.splice(index, 1);
               connectees.unclaimed.push(selectedConnectee.value);
               connectees.unclaimed.sort();
            }
            return index !== -1;
         }

         /**
          * Moveup button callback.
          */
         function _moveUpCallback() {
            _.forEach(datagridOptions.selectedItems, function (selectedConnectee) {
               if(!selectedConnectee.categoryItem){
                  var pnicCategoryName = _getConecteeCategory(categories, selectedConnectee);
                  var pnicCategoryIndex =
                        _getPnicCategoryIndex(connectees[pnicCategoryName], selectedConnectee);

                  _moveUp(selectedConnectee, pnicCategoryIndex, pnicCategoryName);
               }
            });

            _updateDataGrid();
         }

         /**
          * Moves the selected item to the previous category if it is in first position
          * or swaps it with the previous item.
          *
          * @param connectee
          *       The selected item.
          * @param index
          *       The index of the selected item.
          * @param categoryName
          *       The name of the item's category.
          */
         function _moveUp(connectee, index, categoryName) {
            if (index === 0) {
               var previousCategoryName = categories[_.indexOf(categories, categoryName) - 1];
               connectees[previousCategoryName].push(connectee.value);
               connectees[categoryName] = connectees[categoryName].slice(1, connectees[categoryName].length);
            } else {
               _swap(categoryName, index, index - 1);
            }
         }

         /**
          * Movedown button callback.
          */
         function _moveDownCallback() {

            for (var index = datagridOptions.selectedItems.length - 1; index >= 0; index--) {
               var selectedConnectee = datagridOptions.selectedItems[index];

               var pnicCategoryName = _getConecteeCategory(categories, selectedConnectee);
               var pnicCategoryIndex =
                     _getPnicCategoryIndex(connectees[pnicCategoryName], selectedConnectee);

               if(pnicCategoryIndex !== -1) {
                  _moveDown(selectedConnectee, pnicCategoryIndex, pnicCategoryName);
               }
            }
            _updateDataGrid();
         }

         /**
          * Moves the selected item to the next category if it is in last position
          * or swaps it with the next item.
          *
          * @param connectee
          *       The selected item.
          * @param index
          *       The index of the selected item.
          * @param categoryName
          *       The name of the item's category.
          */
         function _moveDown(connectee, index, categoryName) {
            var unusedConnectees = connectees.unused;

            if(unusedConnectees && unusedConnectees.length > 0
               && connectee.value === unusedConnectees[unusedConnectees.length - 1]) {
               return;
            }

            if (index === connectees[categoryName].length - 1) {
               var nextCategoryName = categories[_.indexOf(categories, categoryName) + 1];
               connectees[nextCategoryName].unshift(connectee.value);
               connectees[categoryName] = connectees[categoryName].slice(0, connectees[categoryName].length - 1);
            } else {
               _swap(categoryName, index, index + 1);
            }
         }

         function _getConecteeCategory(categories, conectee) {
            var categoryName;
            _.each(categories, function (category) {
               var index = _.findIndex(connectees[category], function (element) {
                  return element === conectee.value;
               });
               if(index !== -1) {
                  categoryName = category;
               }
            });
            return categoryName;
         }

         function _getPnicCategoryIndex(pnicCategory, selectedConnectee) {
            return _.findIndex(pnicCategory, function (element) {
               return element === selectedConnectee.value;
            });
         }

         /**
          * Swaps two elements in an array.
          *
          * @param categoryName
          *       The name of the item's category.
          * @param indexFrom
          *       The index of the first element to swap.
          * @param indexTo
          *       The index of the second element to swap.
          */
         function _swap(categoryName, indexFrom, indexTo) {
            var tempElement = connectees[categoryName][indexFrom];

            connectees[categoryName][indexFrom] = connectees[categoryName][indexTo];
            connectees[categoryName][indexTo] = tempElement;
         }

         /**
          * Depending on the definition describes either category cell or a general one.
          */
         function _getColumnDefinitions() {
            return [
               {
                  field: 'value',
                  width: '150px',
                  template: function (dataItem) {
                     if(dataItem.categoryItem) {
                        return '<span class="assigned-pnic-sections">' +
                              dataItem.value + '</span>';
                     } else {
                        if (connectees.lagNames && connectees.lagNames.length > 0) {

                           if (_.indexOf(connectees.lagNames, dataItem.value) === -1) {
                              return '<span class="network-lib-ui-icon-physicalAdapter"></span>' +
                                    '<span ng-non-bindable>' + _formatName(dataItem) + '</span>';
                           } else {// is Lag
                              return '<span class="network-lib-ui-icon-portChannel"></span>' +  // icon
                                    '<span ng-non-bindable>' + _formatName(dataItem) + '</span>';
                           }
                        }
                        return '<span class="network-lib-ui-icon-physicalAdapter"></span>' +  // icon
                               '<span ng-non-bindable>' + _formatName(dataItem) + '</span>'; // name
                     }
                  }
               }
            ];
         }

         /**
          * Adds (New) at the beginning of the name if needed.
          */
         function _formatName(dataItem) {
            return (!editAllItems && _isNewPnic(dataItem.value))
                  ? i18nService.getString("NetworkUi", "FailoverOrder.newNicFormat", dataItem.value)
                  : dataItem.value;
         }

         function _isNewPnic(pnic){
               return _.contains(connectees.unclaimedInitial, pnic);
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Shows a datagrid which supports a details view of its selected item.
 *
 * @param failoverOrderWithDetails (required):
 *    array of items for failoverOrder directive or datagridOptions for simple datagrid
 *
 * @param datagridHeaderOptions (optional):
 *    the header of the grid
 *
 * @param simple (optional):
 *    a boolean parameter which determines two different type of grids:
 *          simple=true: renders a 'simple' datagrid with no actionbar and no data division into sections.
 *          simple=false(or missing): renders a datagrid whose data is divided into failover order sections
 *                                    and supports actionbar to interact with the data.
 *
 */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .directive('failoverOrderWithDetails', failoverOrderWithDetails);

   failoverOrderWithDetails.$inject = [
      'physicalAdapterDetailsViewService'
   ];

   function failoverOrderWithDetails (physicalAdapterDetailsViewService) {
      var directive = {
         restrict: 'E',
         templateUrl: 'network-lib-ui/resources/network-lib/host/pnic/' +
               'failoverOrder/failoverOrderWithDetails.html',
         scope: {
            failoverOrder: '=',
            noItemsSelectedMessage: '=',
            datagridHeaderOptions: '=?',
            actions: "=?",
            actionsDisabled: '=?',
            onSelectionChange: '=?',
            selectionMode:  '=?',
            editAllItems: '=?'
         },
         replace: true,
         link: {
            pre: function ($scope) {
               $scope.showDetailsAndNotify = function (selectedItems) {
                  if (selectedItems && selectedItems.length === 1
                        && !selectedItems[0].categoryItem) {
                     $scope.selectedConnecteeDetails = physicalAdapterDetailsViewService.build(
                           $scope.failoverOrder.connecteesDetails[selectedItems[0].value]);
                  } else {
                     $scope.selectedConnecteeDetails = null;
                  }
                  if ($scope.onSelectionChange) {
                     $scope.onSelectionChange(selectedItems);
                  }
               };
            }
         }
      };
      return directive;
   }
}());

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').
      service('physicalAdapterDetailsViewService', physicalAdapterDetailsViewService);

   physicalAdapterDetailsViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUtil'
   ];

   function physicalAdapterDetailsViewService (i18nService, propertyViewService, networkUtil) {
      return {
         build: build,
         buildOnlyProperties: buildOnlyProperties,
         buildOnlyCdp: buildOnlyCdp,
         buildOnlyLldp: buildOnlyLldp
      };

      function build (pnicDetailsItem) {
         if (pnicDetailsItem !== null) {
            var builder = propertyViewService.createPropertyViewBuilder();
            buildPropertiesCategoryInternal(builder, pnicDetailsItem);
            buildCdpCategoryInternal(builder, pnicDetailsItem);
            buildLldpCategoryInternal(builder, pnicDetailsItem);

            // Add 'All' tab
            builder
               .category('all', 0)
               .title(i18nService.getString(
                  'H5NetworkUi', 'PhysicalAdapterDetailsView.allTabTitle'))
               .cloneAndAddBuilder(builder.getSection('properties', 'general'))
               .cloneAndAddBuilder(builder.getSection('properties', 'status'))
               .cloneAndAddBuilder(builder.getSection('properties', 'networkIoControl'))
               .cloneAndAddBuilder(builder.getSection('properties', 'sriov'))
               .cloneAndAddBuilder(builder.getSection('cdp', 'cdpSection'))
               .cloneAndAddBuilder(builder.getSection('cdp', 'cdpCapabilitySection'))
               .cloneAndAddBuilder(builder.getSection('lldp', 'lldpSection'))
               .cloneAndAddBuilder(builder.getSection('lldp', 'lldpCapabilitySection'));

            return builder.build();
         }
         return {};
      }

      function buildOnlyProperties(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildPropertiesCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("properties").title(null);

         return builder.build();
      }

      function buildOnlyCdp(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildCdpCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("cdp").title(null);

         return builder.build();
      }

      function buildOnlyLldp(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildLldpCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("lldp").title(null);

         return builder.build();
      }

      function buildPropertiesCategoryInternal(builder, pnicDetailsItem) {
         var categoryBuilder = builder
            .category("properties")
            .title(networkUtil.getString('PnicView.adapterDetails'));

         buildGeneralSection(categoryBuilder, pnicDetailsItem);
         buildStatusSection(categoryBuilder, pnicDetailsItem);
         buildSriovSection(categoryBuilder, pnicDetailsItem);
      }

      function buildGeneralSection(categoryBuilder, pnicDetailsItem) {
         categoryBuilder
            .section("general")
            .property(
               networkUtil.getString('PnicView.adapter'),
               pnicDetailsItem.adapterName)
            .property(
               networkUtil.getString('PnicView.name'),
               pnicDetailsItem.deviceName)
            .property(
               networkUtil.getString('PnicView.location'),
               pnicDetailsItem.location)
            .property(
               networkUtil.getString('PnicView.driver'),
               pnicDetailsItem.driverName);
      }

      function buildStatusSection(categoryBuilder, pnicDetailsItem) {
         function getPnicActualSpeedValue() {
            var actualSpeedValue;
            if (!pnicDetailsItem.actualSpeed) {
               actualSpeedValue = networkUtil.getString('PnicView.down');
            } else if (pnicDetailsItem.isActualSpeedFullDuplex) {
               actualSpeedValue = networkUtil.getString(
                  'PnicView.mbFullDuplex', pnicDetailsItem.actualSpeed);
            } else {
               actualSpeedValue = networkUtil.getString(
                  'PnicView.mbHalfDuplex', pnicDetailsItem.actualSpeed);
            }
            return actualSpeedValue;
         }

         function getConfiguredSpeedValue() {
            var configuredSpeedValue;
            if (!pnicDetailsItem.configuredSpeed) {
               configuredSpeedValue = networkUtil.getString('PnicView.autonegotiate');
            } else if (pnicDetailsItem.isConfiguredSpeedFullDuplex) {
               configuredSpeedValue = networkUtil.getString('PnicView.mbFullDuplex', pnicDetailsItem.configuredSpeed);
            } else {
               configuredSpeedValue = networkUtil.getString('PnicView.mbHalfDuplex', pnicDetailsItem.configuredSpeed);
            }
            return configuredSpeedValue;
         }

         function getNetworks() {
            return (pnicDetailsItem.networkHints && pnicDetailsItem.networkHints.length) ?
               pnicDetailsItem.networkHints : networkUtil.getString('NetworkUtil.NoNetworks');
         }

         categoryBuilder
            .section("status")
            .title(networkUtil.getString('PnicView.status'))

            .property(
               networkUtil.getString('PnicView.statusLabel'),
               pnicDetailsItem.isConnected
                  ? networkUtil.getString('PnicView.connected')
                  : networkUtil.getString('PnicView.disconnected'))
            .property(
               networkUtil.getString('PnicView.actualSpeed'),
               getPnicActualSpeedValue())
            .property(
               networkUtil.getString('PnicView.configSpeed'),
               getConfiguredSpeedValue())
            .property(
               networkUtil.getString('PnicView.networks'),
               getNetworks());

         if (pnicDetailsItem.resourcePoolSchedulerAllowed !== null) {
            var sectionBuilder =
               categoryBuilder
                  .section("networkIoControl")
                  .title(networkUtil.getString('PnicView.netIorm'));
            sectionBuilder
               .property(
                  networkUtil.getString('PnicView.status'),
                  pnicDetailsItem.resourcePoolSchedulerAllowed
                     ? networkUtil.getString('PnicView.netIorm.allowed')
                     : networkUtil.getString('PnicView.netIorm.notAllowed')
               );

            _.forEach(pnicDetailsItem.resourcePoolSchedulerDisallowedReasons,
               function (reason) {
                  sectionBuilder.info(reason);
               });
         }
      }

      function buildSriovSection(categoryBuilder, pnicDetailsItem) {
         function getVirtualFunctions() {
            if (pnicDetailsItem.sriovInfo.numVirtualFunctionsRequested ===
                  pnicDetailsItem.sriovInfo.numVirtualFunction) {
               return pnicDetailsItem.sriovInfo.numVirtualFunction;
            }

            return networkUtil.getString('Sriov.vf.mixedFormat',
                        pnicDetailsItem.sriovInfo.numVirtualFunctionsRequested,
                        pnicDetailsItem.sriovInfo.numVirtualFunction);
         }

         if (pnicDetailsItem.sriovInfo && pnicDetailsItem.sriovInfo.sriovCapable) {
            if (pnicDetailsItem.sriovInfo.sriovEnabled) {
               categoryBuilder
                     .section("sriov")
                     .title(networkUtil.getString('Sriov.title'))
                     .property(networkUtil.getString('Sriov.status'),
                           networkUtil.getString('Sriov.status.enabled'))
                     .property(networkUtil.getString('Sriov.virtualFunctionsCount'),
                           getVirtualFunctions());
            } else {
               categoryBuilder
                     .section("sriov")
                     .title(networkUtil.getString('Sriov.title'))
                     .property(networkUtil.getString('Sriov.status'),
                           networkUtil.getString('Sriov.status.disabled'));
            }
         } else {
            categoryBuilder
                  .section("sriov")
                  .title(networkUtil.getString('Sriov.title'))
                  .property(networkUtil.getString('Sriov.status'),
                        networkUtil.getString('Sriov.status.notSupported'));
         }
      }

      function buildCdpCategoryInternal(builder, pnicDetailsItem) {
         var categoryBuilder = builder
            .category("cdp")
            .title(networkUtil.getString('CdpDetailsView.category'));

         var cdpSectionBuilder = categoryBuilder
            .section("cdpSection")
            .title(networkUtil.getString('CdpDetailsView.title'));

         if (!pnicDetailsItem.areNetworkHintsRetrieved) {
            cdpSectionBuilder.info(networkUtil.getString('CdpDetailsView.notAccessible'));

         } else {

            if (pnicDetailsItem.cdpInfo === null) {

               cdpSectionBuilder.info(networkUtil.getString('CdpDetailsView.notAvailable'));
            } else {
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.version'),
                  pnicDetailsItem.cdpInfo.version);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.timeout'),
                  pnicDetailsItem.cdpInfo.timeout);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ttl'),
                  pnicDetailsItem.cdpInfo.ttl);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.samples'),
                  pnicDetailsItem.cdpInfo.samples);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.deviceId'),
                  pnicDetailsItem.cdpInfo.devId);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipAddress'),
                  pnicDetailsItem.cdpInfo.address);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.portId'),
                  pnicDetailsItem.cdpInfo.portId);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.softwareVersion'),
                  pnicDetailsItem.cdpInfo.softwareVersion);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.hardwarePlatform'),
                  pnicDetailsItem.cdpInfo.hardwarePlatform);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipPrefix'),
                  pnicDetailsItem.cdpInfo.ipPrefix);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipPrefixLength'),
                  pnicDetailsItem.cdpInfo.ipPrefixLen);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.vlan'),
                  pnicDetailsItem.cdpInfo.vlan);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.fullDuplex'),
                  pnicDetailsItem.cdpInfo.fullDuplex);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.mtu'),
                  pnicDetailsItem.cdpInfo.mtu);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.systemName'),
                  pnicDetailsItem.cdpInfo.systemName);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.systemOid'),
                  pnicDetailsItem.cdpInfo.systemOID);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.managementAddress'),
                  pnicDetailsItem.cdpInfo.mgmtAddr);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.location'),
                  pnicDetailsItem.cdpInfo.location);

               var cdpCapabilitySectionBuilder =
                  categoryBuilder
                     .section("cdpCapabilitySection")
                     .title(networkUtil.getString('CdpDetailsView.deviceCapability'));

               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.router'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.router);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.transBridge'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.transparentBridge);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.srcRouteBridge'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.sourceRouteBridge);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.networkSwitch'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.networkSwitch);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.host'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.host);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.igmp'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.igmpEnabled);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.repeater'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.repeater);
            }
         }
      }

      function buildLldpCategoryInternal(builder, pnicDetailsItem) {

         var categoryBuilder = builder
            .category("lldp")
            .title(networkUtil.getString('LldpDetailsView.category'));

         var lldpSectionBuilder = categoryBuilder
            .section("lldpSection")
            .title(networkUtil.getString('LldpDetailsView.title'));

         if (!pnicDetailsItem.areNetworkHintsRetrieved) {
            lldpSectionBuilder.info(
               networkUtil.getString('LldpDetailsView.notAccessible'));
         } else {
            if (pnicDetailsItem.lldpInfo === null) {
               lldpSectionBuilder.info(
                  networkUtil.getString('LldpDetailsView.notAvailable'));
            } else {

               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.chassisId'),
                  pnicDetailsItem.lldpInfo.chassisId);
               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.portId'),
                  pnicDetailsItem.lldpInfo.portId);
               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.ttl'),
                  pnicDetailsItem.lldpInfo.ttl);

               _.forEach(pnicDetailsItem.lldpInfo.parameter, function (param) {
                  lldpSectionBuilder.property(param.key,
                     param.value);
               });

               var lldpCapabilitySectionBuilder =
                  categoryBuilder
                     .section("lldpCapabilitySection")
                     .title(networkUtil.getString(
                        'LldpDetailsView.deviceCapability'));

               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.router'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.router);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.transBridge'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.transparentBridge);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.srcRouteBridge'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.sourceRouteBridge);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.networkSwitch'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.networkSwitch);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.host'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.host);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.igmp'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.igmpEnabled);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.repeater'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.repeater);
            }
         }
      }
   }
}());

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .service('physicalAdaptersListService', physicalAdaptersListService);

   physicalAdaptersListService.$inject = ['dataService', 'i18nService'];

   var physicalAdapterItemsProperty = "pnic:physicalAdapterItems";
   var physicalAdapterDetailsItemProperty = "pnic:physicalAdapterItemDetails";
   var unclaimedPhysicalAdaptersProperty = "pnic:unclaimedPhysicalAdapters";
   var physicalAdaptersWithDetails = "pnic:physicalAdaptersWithDetails";
   var proxySwitchUplinkData = "proxyswitch:getProxySwitchUplinkData";

   function physicalAdaptersListService(dataService, i18nService) {

      return {
         getPhysicalAdapterItems: function(hostId) {
            return dataService.getProperties(hostId, [physicalAdapterItemsProperty], {
                  skipErrorInterceptor: true
               }).then(function(dataServiceResponse) {
                  var physicalAdapterItems = dataServiceResponse
                        ? dataServiceResponse[physicalAdapterItemsProperty]
                        : [];

                  physicalAdapterItems = physicalAdapterItems || [];
                  var currentPnicIndex = 0;

                  physicalAdapterItems.forEach(function(pnicItem) {
                     if (!pnicItem.virtualSwitch) {
                        pnicItem.virtualSwitch = {
                           switchName: i18nService
                                 .getString('NetworkUi', 'NetworkUtil.noData')
                        };
                     }

                     pnicItem.wakeOnLanSupportedLabel = pnicItem.wakeOnLanSupported
                           ? i18nService.getString('NetworkUi', 'PnicView.labelYes')
                           : i18nService.getString('NetworkUi', 'PnicView.labelNo');
                     pnicItem.actualSpeedLabel = pnicItem.actualSpeed
                           ? i18nService.getString('NetworkUi', 'PnicView.speedMb', pnicItem.actualSpeed)
                           : i18nService.getString('NetworkUi', 'PnicView.down');
                     pnicItem.configuredSpeedLabel = !pnicItem.configuredSpeed || pnicItem.configuredSpeed === 0
                           ? i18nService.getString('NetworkUi', 'PnicView.autonegotiate')
                           : i18nService.getString('NetworkUi', 'PnicView.speedMb', pnicItem.configuredSpeed);

                     if(pnicItem.sriovInfo && pnicItem.sriovInfo.sriovCapable) {
                        if (pnicItem.sriovInfo.sriovEnabled) {
                           pnicItem.sriovStatusLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.status.enabled');
                           pnicItem.sriovNumVirtuanFunctionsLabel =
                                 pnicItem.sriovInfo.numVirtualFunctionsRequested ===
                                 pnicItem.sriovInfo.numVirtualFunction
                                       ? pnicItem.sriovInfo.numVirtualFunction
                                       : i18nService.getString('NetworkUi', 'Sriov.vf.mixedFormat',
                                             pnicItem.sriovInfo.numVirtualFunctionsRequested,
                                             pnicItem.sriovInfo.numVirtualFunction);
                        } else {
                           pnicItem.sriovStatusLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.status.disabled');
                           pnicItem.sriovNumVirtuanFunctionsLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.vf.na');
                        }
                     } else {
                        pnicItem.sriovStatusLabel = i18nService.getString(
                              'NetworkUi', 'Sriov.status.notSupported');
                        pnicItem.sriovNumVirtuanFunctionsLabel = i18nService.getString(
                              'NetworkUi', 'Sriov.vf.na');
                     }

                     pnicItem.pnicIndex = currentPnicIndex++;
               });

               return physicalAdapterItems;
            });
         },

         getPhysicalAdapterDetailsItem: function(hostId, pnicName) {
            var params = [{
               propertyName: physicalAdapterDetailsItemProperty,
               parameterType: 'java.lang.String',
               parameter: pnicName
            }];
            return dataService
                  .getProperties(hostId, [physicalAdapterDetailsItemProperty], {
                     propertyParams: params
                  })
                  .then(function (response) {
                     if (response && response[physicalAdapterDetailsItemProperty]) {
                        return response[physicalAdapterDetailsItemProperty];
                     }
                     return null;
                  });
         },

         getUnclaimedPhysicalAdapters: function (hostId) {
            return dataService.getProperties(hostId, [unclaimedPhysicalAdaptersProperty])
               .then(function (response) {
                  if (response && response[unclaimedPhysicalAdaptersProperty]) {
                     return response[unclaimedPhysicalAdaptersProperty];
                  }
                  return null;
               });
         },

         getPhysicalAdaptersWithDetails: function (hostId, vSwitchName) {
            var params = [{
               propertyName: physicalAdaptersWithDetails,
               parameterType: 'java.lang.String',
               parameter: vSwitchName
            }];
            return dataService.
               getProperties(hostId, [physicalAdaptersWithDetails], {
                     propertyParams: params
               })
               .then(function (response) {
                  if (response && response[physicalAdaptersWithDetails]) {
                     return response[physicalAdaptersWithDetails];
                  }
                  return null;
               });
         },

         getProxySwitchUplinkData: function (hostId, dvsRef, proxySwitchKey) {
            var hostSwitchSpec = {
               dvsRef: dvsRef,
               proxySwitchKey: proxySwitchKey
            };

            var params = [{
               propertyName: proxySwitchUplinkData,
               parameterType: 'com.vmware.vsphere.client.h5.network.host.proxyswitch.spec.ProxySwitchInfoSpec',
               parameter: hostSwitchSpec
            }];
            return dataService.
                  getProperties(hostId, [proxySwitchUplinkData], {
                     propertyParams: params
                  })
                  .then(function (response) {
                     if (response && response[proxySwitchUplinkData]) {
                        return response[proxySwitchUplinkData];
                     }
                     return null;
                  });
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi')
      .service('pnicSelectorDialogService', PnicSelectorDialogService);

   PnicSelectorDialogService.$inject = [
         'i18nService',
         'vuiConstants',
         'clarityModalService',
         'clarityConstants'];

   function PnicSelectorDialogService (i18nService, vuiConstants, clarityModalService, clarityConstants) {

      // ======================= Public API ==========================

      return {
         createPnicSelectorDialog: createPnicSelectorDialog
      };

      // ======================= Public Functions ==========================
      /**
       * Opens an OK/Cancel modal dialog in the application.
       *
       * @param unclaimedPnics Array of strings with pnicNames
       * @param pnicDetails Object containing properties pnicName and values pnicDetail
       * @param {vuiConstants.grid.selectionMode} selectionMode
       * @param dropdownOptions array of object with
       *          id: unique for the array used to be mapped to selected item in okHandler
       *          title: title label for the dropdown
       *          items: array of object with key/value properties for populating the dropdown
       *          selectedItem: one of the keys of the items array used for default dropdown option
       * @param okHandler callback to be invoked on Dialog confirmation
       *
       */
      function createPnicSelectorDialog(unclaimedPnics, pnicDetails, selectionMode, dropdownOptions, okHandler) {

         var dialogData = {};
         dialogData.hasDropdownOptions = dropdownOptions && dropdownOptions.length > 0;
         dialogData.dropdownOptions = dropdownOptions;
         dialogData.selectedPnics = [];
         dialogData.pnicSelectorOptions = {};

         dialogData.pnicSelectorOptions.datagridHeaderOptions = {
            title: i18nService.getString("NetworkUi", "FailoverOrderAddDialog.networkAdapters")
         };
         dialogData.pnicSelectorOptions.selectionMode =
               selectionMode ? selectionMode : vuiConstants.grid.selectionMode.MULTI;
         dialogData.pnicSelectorOptions.unclaimedPnics = unclaimedPnics;
         dialogData.pnicSelectorOptions.pnicDetails = pnicDetails;

         dialogData.pnicSelectorOptions.updateSelectedPnics = function (selectedItems) {
            dialogData.selectedPnics = selectedItems;
         };

         dialogData.noItemsSelectedMessage =
               i18nService.getString('NetworkUi', 'FailoverOrderAddDialog.detailsPrompt');



         var onClick = function () {
            if (dialogData.selectedPnics.length === 0) {
               showError(i18nService
                     .getString('H5NetworkUi', 'AddNetworkingWizard.pnicSelector.noPnicSelected'),
                     modalOptions);

               return false;
            }
            if (okHandler) {
               var dropdownSelections = {};
               _.each(dialogData.dropdownOptions, function (dropdown) {
                  dropdownSelections[dropdown.id] = dropdown.selectedItem;
               });
               okHandler(dialogData.selectedPnics, dropdownSelections);
            }
            return true;
         };

         var modalOptions = {
            title: i18nService.getString('NetworkUi', 'FailoverOrderAddDialog.title'),
            contentTemplate: 'network-lib-ui/resources/network-lib/host/pnic/' +
                  'pnicSelector/pnicSelectorDialog.html',
            defaultButton: 'submit',
            dialogData: dialogData,
            alerts: [],
            size: 'lg',
            modalClass: 'pnic-selector-dialog',
            onSubmit: onClick
         };


         clarityModalService.openOkCancelModal(modalOptions);
      }

      function showError(errorMessage, modalOptions) {
         modalOptions.alerts = [{
            text: errorMessage,
            type: clarityConstants.notifications.type.ERROR
         }];
      }
   }
}());
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .directive('pnicSelectorWithDetails', pnicSelectorWithDetails);

   pnicSelectorWithDetails.$inject = [
      'vuiConstants',
      'physicalAdapterDetailsViewService'
   ];

   function pnicSelectorWithDetails(vuiConstants,physicalAdapterDetailsViewService) {
      return {
         restrict: 'E',
         templateUrl: 'network-lib-ui/resources/network-lib/host/pnic/' +
               'pnicSelector/pnicSelectorWithDetails.html',
         scope: {
            pnicSelectorOptions: '=?'
         },
         replace: false,
         link: {
            pre: function ($scope) {
               $scope.datagridHeaderOptions = $scope.pnicSelectorOptions.datagridHeaderOptions;
               $scope.datagridOptions =
                     _createDatagridOptions($scope.pnicSelectorOptions.unclaimedPnics,
                           $scope.pnicSelectorOptions.selectionMode);

               $scope.$watch(function() {
                  return $scope.datagridOptions.selectedItems;
               },
                     function(selectedItems) {
                        if (selectedItems && selectedItems.length === 1) {
                           var selectedPnicDetaisData
                                 = $scope.pnicSelectorOptions.pnicDetails[selectedItems[0]];
                           $scope.selectedPnicDetails = physicalAdapterDetailsViewService.build(
                                 selectedPnicDetaisData);
                        } else {
                           $scope.selectedPnicDetails = null;
                        }

                        if($scope.pnicSelectorOptions.updateSelectedPnics) {
                           $scope.pnicSelectorOptions.updateSelectedPnics(selectedItems);
                        }
                     });

            }
         }
      };

      function _createDatagridOptions(unclaimedPnics, selectionMode) {
         var datagridOptions = {
            columnDefs: _getColumnDefinitions(),
            data: unclaimedPnics,
            pageConfig: {
               hidePager: true
            },
            selectedItems: [],
            resizable: true,
            height: '100%',
            sortMode: vuiConstants.grid.sortMode.NONE,
            selectionMode: selectionMode,
            showCheckboxesOnMultiSelection: false,
            sortOrder: [{
               field: 'pnic',
               dir: 'asc'
            }]

         };

         return datagridOptions;
      }
      function _getColumnDefinitions() {
         return [
            {
               field: 'pnic',
               width: '150px',
               template: function (dataItem) {
                  return '<span class="network-lib-ui-icon-physicalAdapter"></span>' +  // icon
                        '<span>' + dataItem + '</span>';                            // name

               }
            }
         ];
      }
   }
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .service('standardPortgroupPoliciesViewService', standardPortgroupPoliciesViewService);

   standardPortgroupPoliciesViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUtil'
   ];

   function standardPortgroupPoliciesViewService (
         i18nService,
         vxPropertyViewService,
         networkUtil) {

      return {
         build: build
      };

      function build(portPolicy, builder) {
         if (!portPolicy) {
            return {};

         }

         var policiesBuilder = builder || vxPropertyViewService.createPropertyViewBuilder();
         var policiesCategory = policiesBuilder
               .category('policies')
               .title(i18nService.getString('NetworkUi', 'PortgroupSettingsView.policy'));

         networkUtil.fillPoliciesCategory(policiesCategory, portPolicy);

         if (!builder) {
            return policiesBuilder.build();
         }
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   var module = angular.module('com.vmware.vsphere.client.networkLibUi');
   module.constant('networkUiConstants', {
      POSITIVE_INTEGER_REG_EXP: new RegExp('^[0-9]+$'),
      MAX_SAFE_INTEGER: 9007199254740991,
      MAX_HOST_NAME_LENGTH: 63,
      MAX_DOMAIN_NAME_LENGTH: 63,
      HOST_MAX_NUMBER_OT_CONNECTIONS_MAX: 20000,
      HOST_MAX_NUMBER_OT_CONNECTIONS_MIN: 2000,
      FQDN_MAX_LENGTH: 255,
      MAX_NUMBER_SEARCH_DOMAINS: 6,
      Mtu: {
         DEFAULT: 1500,
         MIN: 1280,
         MAX: 9000
      },
      NumPorts: {
         DEFAULT: 128,
         MIN: 16,
         MAX: 4096
      },
      DvPortgroupNumPorts: {
         MIN: 0,
         MAX: 8192
      },
      Ipv6PrefixLength: {
         DEFAULT: 64
      },
      DatagridActions: {
         ADD: 'vsphere.core.network.wizard.actions.addIpV6',
         EDIT: 'vsphere.core.network.wizard.actions.editIpV6',
         DELETE: 'vsphere.core.network.wizard.actions.deleteIpV6'
      },
      LoadBalancingPolicy: {
         SRCID: 'loadbalance_srcid',
         IP: 'loadbalance_ip',
         SRCMAC: 'loadbalance_srcmac',
         EXPLICIT: 'failover_explicit',
         LOADBASED: 'loadbalance_loadbased'
      },
      TrafficShapingSetting: {
         AVERAGE_BANDWIDTH: "averageBandwidth",
         PEAK_BANDWIDTH: "peakBandwidth",
         BURST_SIZE: "burstSize"
      },
      Vlan: {
         Type: {
            NONE: 'none',
            VLAN: 'vlan',
            TRUNK: 'trunk',
            PRIVATE: 'private'
         },
         Id : {
            NONE: 0,
            MIN: 1,
            MAX: 4094,
            ALL: 4095
         },
         PvlanType: {
            PROMISCUOUS: 'promiscuous',
            COMMUNITY: 'community',
            ISOLATED: 'isolated'
         },
         DEFAULT_VLAN_TRUNK_RANGE: "0-4094"
      },
      PortgroupType: {
         EARLY_BINDING: 'earlyBinding',
         LATE_BINDING: 'lateBinding',
         EPHEMERAL: 'ephemeral'
      },
      actions: {
         EDIT_DVS_NOTES: 'vsphere.core.dvs.actions.editNotes',
         ADD_NETWORKING: 'vsphere.core.network.actions.addNetworking',
         EDIT_VNIC: 'vsphere.core.host.network.actions.editVnicAction',
         REMOVE_VNIC: 'vsphere.core.host.network.actions.removeVnicAction',
         EDIT_PORTGROUP: 'vsphere.core.host.network.editPortgroupSettingsAction',
         EDIT_DVPG: 'vsphere.core.dvPortgroup.editSettingsAction',
         EXPORT_DVPG: 'vsphere.core.dvPortgroup.exportConfiguration',
         IMPORT_DVPG: 'vsphere.core.dvPortgroup.importConfiguration',
         RESTORE_DVPG: 'vsphere.core.dvPortgroup.restoreConfiguration',
         EDIT_DVPG_NOTES: 'vsphere.core.dvPortgroup.actions.editNotes',
         REMOVE_PORTGROUP: 'vsphere.core.host.network.removePortgroupAction',
         EDIT_VSWITCH: 'vsphere.core.host.network.editVSwitchSettingsAction',
         REMOVE_VSWITCH: 'vsphere.core.host.network.removeVirtualSwitchAction',
         MANAGE_PNICS: 'vsphere.core.host.network.managePhysicalNicsAction',
         MIGRATE_HOST_NETWORKING: 'vsphere.core.dvs.migrateHostNetworkingAction',
         ADD_PORT_BINDING_FOR_ISCSI: 'vsphere.core.network.addIscsiPortBindingAction',
         REMOVE_PORT_BINDING_FROM_ISCSI: 'vsphere.core.network.removeIscsiPortBindingAction',
         SHOW_ISCSI_PORT_BINDING_DETAILS: 'vsphere.core.network.showIscsiPortBindingDetailsAction',
         EDIT_DNS_AND_ROUTING: 'vsphere.core.host.network.editDnsAndRoutingAction',
         EDIT_IPV6_SUPPORT: 'vsphere.core.host.network.editIpv6SupportAction',
         VM_MIGRATE: 'vsphere.core.network.vmMigrateAction',
         RENAME_DV_PORTGROUP: 'vsphere.core.dvPortgroup.renameAction',
         REFRESH_NETWORK: 'vsphere.core.host.network.refreshNetworkAction',
         EDIT_PNIC: 'vsphere.core.host.network.actions.editPnicAction',
         REMOVE_SPAN_SESSION: 'vsphere.core.dvs.spanSession.removeAction',
         ADD_SPAN_SESSION: 'vsphere.core.dvs.spanSession.addAction',
         HOST_OF_SYNC_DVS_HOST: "vsphere.core.dvs.configissues.HostOutOfSyncIssue",
         REMOVE_DVS: "vsphere.core.dvs.removeHostFromDvsAction",
         RECTIFY_HOSTS_OUT_OF_SYNC_DVS: "vsphere.core.dvs.configissues.RectifyHostOutOfSync",
         MIGRATE_VMK_TO_VSWITCH: "vsphere.core.host.network.migrateVmkAction",
         GHOST_DVS_PROXY_SWITCH_DETACHED: "vsphere.core.network.configissues.GhostDvsProxySwitchDetectedIssue",
         NETWORK_MOVE_TO_ACTION: "vsphere.core.network.actions.moveTo",
         DVS_MOVE_TO_ACTION: "vsphere.core.dvs.actions.moveTo",
         NETWORK_MOVE_TO_DRAG_AND_DROP_ACTION: "vsphere.core.network.actions.moveNetworkToDrag",
         DVS_MOVE_TO_DRAG_AND_DROP_ACTION: "vsphere.core.dvs.actions.moveDvsToDrag",
         EDIT_DVPORT: "vsphere.core.dvs.editPortAction",
         VSS_VIEW_SETTINGS: "vsphere.core.host.network.vss.viewSettings",
         PROXY_SWITCH_VIEW_SETTINGS: "vsphere.core.host.network.proxySwitch.viewSettings"
      },
      failoverOrderActions: {
         ADD: 'add-action',
         REMOVE: 'remove-action',
         MOVE_UP: 'moveup-action',
         MOVE_DOWN: 'movedown-action'
      },
      switchType: {
         STANDARD: 'standardSwitch',
         DISTRIBUTED: 'distributedSwitch'
      },
      UnitFormat: {
         KBPS: 1000,
         KB: 1024
	   },
      MulticastFiltering: {
          BASIC: 'legacyFiltering',
          SNOOPING: 'snooping'
      },
      LinkDiscoveryOperation: {
          LISTEN: 'listen',
          ADVERTISE:'advertise',
          BOTH: 'both',
          DISABLED: 'none'
      },
      LinkDiscoveryProtocol: {
          CDP: 'cdp',
          LLDP: 'lldp'
      },
      LacpSupport: {
         BASIC: 'singleLag',
         ENHANCED: 'multipleLag'
      },
      LacpMode: {
         ACTIVE: 'active',
         PASSIVE: 'passive'
      },
      ManageDvpgWizard: {
         DVPG_CONFIG_VERSION_PROP: 'config.configVersion'
      },
      TcpIpStack: {
         DEFAULT_NET_STACK_KEY: 'defaultTcpipStack',
         VMOTION_NET_STACK_KEY: 'vmotion'
      }
   });
} ());

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi')
         .factory('networkUtil', networkUtil);

   networkUtil.$inject = ['i18nService', 'networkUiConstants', 'defaultUriSchemeUtil'];

   function networkUtil(i18nService, networkUiConstants, defaultUriSchemeUtil) {
      var VLAN_NUM_NONE = 0;
      var VLAN_NUM_ALL = 4095;
      var HOST_NAME_REGEX = /^[A-Z0-9]([A-Z0-9\-]*[A-Z0-9])*$/i;

      return {
         compareNumericValues: compareNumericValues,
         compareNumericAndNonNumericValues: compareNumericAndNonNumericValues,
         formatVlanId: formatVlanId,
         isVlanIdValid: isVlanIdValid,
         isMtuValid:isMtuValid,
         getString: getString,
         fillPoliciesCategory: fillPoliciesCategory,
         formatTextMessagesWithIcon: formatTextMessagesWithIcon,
         isDistributedSwitch: isDistributedSwitch,
         isPositiveInteger: isPositiveInteger,
         createNicTeamingPolicyOptions: createNicTeamingPolicyOptions,
         isHostNameValid: isHostNameValid,
         isDomainNameValid: isDomainNameValid,
         getStringLengthInUtf8Bytes: getStringLengthInUtf8Bytes,
         NETWORK_LABEL_MAX_LENGTH: 127
      };

      function compareNumericValues(item1, item2, field) {
         var firstValue = Number(item1[field]);
         var secondValue = Number(item2[field]);

         if (isNaN(firstValue) && isNaN(secondValue)) {
            return 0;
         }
         if (isNaN(firstValue)) {
            return -1;
         }
         if (isNaN(secondValue)) {
            return 1;
         }

         if (firstValue < secondValue) {
            return -1;
         }
         if (firstValue > secondValue) {
            return 1;
         }
         return 0;
      }

      /**
       * Sorts numeric and non-numeric entries and puts the numeric ones before
       * the non-numeric ones
       * @param item1
       * @param item2
       * @param field
       * @returns {*}
       */
      function compareNumericAndNonNumericValues(item1, item2, field) {
         var firstValue = Number(item1[field]);
         var secondValue = Number(item2[field]);

         if (!isNaN(firstValue) && !isNaN(secondValue)) {
            return compareNumericValues(item1, item2, field);
         } else if (isNaN(firstValue) && !isNaN(secondValue)) {
            return 1;
         } else if (isNaN(secondValue) && !isNaN(firstValue)) {
            return -1;
         } else {
            return item1[field].localeCompare(item2[field]);
         }
      }

      function formatVlanId(vlanId) {
         if (vlanId === VLAN_NUM_NONE) {
            return i18nService.getString('NetworkUi', 'NetworkUtil.vlanNone');
         } else if (vlanId === VLAN_NUM_ALL) {
            return i18nService.getString('NetworkUi', 'NetworkUtil.vlanAll', VLAN_NUM_ALL);
         } else {
            if (vlanId) {
               return '' + vlanId;
            }
         }
         return '';
      }

      function isVlanIdValid(vlanId) {
         var isVlanIdInteger = isPositiveInteger(vlanId);
         return isVlanIdInteger && vlanId >= 0 && vlanId <= VLAN_NUM_ALL;
      }

      function isMtuValid(mtu) {
         var isMtuPositiveInteger = isPositiveInteger(mtu);
         return typeof mtu !== 'undefined'
               && isMtuPositiveInteger
               && mtu >= networkUiConstants.Mtu.MIN
               && mtu <= networkUiConstants.Mtu.MAX;
      }

      /**
       * Validates whether the given number is a positive integer (1,2,3...).
       * If min- and maxValue are provided, the method validates if the
       * positive integer number is withing the given range
       *
       * @param number
       * @param minValue(optional)
       * @param maxValue(optional)
       */
      function isPositiveInteger(number, minValue, maxValue) {
         minValue = minValue || 0;
         maxValue = maxValue && maxValue <= networkUiConstants.MAX_SAFE_INTEGER ?
               maxValue : networkUiConstants.MAX_SAFE_INTEGER;
         return networkUiConstants.POSITIVE_INTEGER_REG_EXP.test(number)
               && minValue <= number
               && number <= maxValue;
      }

      /**
       * Creates an array of objects with value and label attributes ready to be used
       * as select box options.
       * @param nicTeamingPolicy array of strings containing all nicTeaming policies.
       */
      function createNicTeamingPolicyOptions(nicTeamingPolicy) {
         return _.map(nicTeamingPolicy, function (policy) {
            return {
               val: policy,
               label: i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.' + policy)
            };
         });
      }

      /**
       * Checks if the specified host name is valid.
       * Host names can only contain alphanumeric characters and hyphens
       * and can not start or end with a hyphen.
       *
       * @param hostName
       *    The specified host name
       */
      function isHostNameValid(hostName) {
         return !!hostName && HOST_NAME_REGEX.test(hostName);
      }

      /**
       * Checks if the specified domain name is valid.
       * matches: FQDN name valid characters
       * Each domain label can contain letters, digits, hyphens '(-)', or period '(.)',
       * but cannot start or end with a hyphen '(-)'.
       * @param domainName
       * @returns {boolean}
       */
      function isDomainNameValid(domainName) {
         if (!domainName) {
            return false;
         }

         var labels = domainName.split('.');

         if (labels[labels.length - 1] === '') {
            // the last label is an empty string
            // which means that the domain name ends with a '.'
            // remove it and validate the rest
            labels.pop();
         }

         return labels.every(function (label) {
            return label && HOST_NAME_REGEX.test(label);
         });
      }

      function getString() {
         var args = Array.prototype.slice.call(arguments);
         return i18nService.getString.apply(null, ['NetworkUi'].concat(args));
      }

      /**
       * Fills given <code>policiesCategory<code/> with sections wit hproperties
       * depending on the values of given <code>portPolicy<code/>.
       *
       * The sections created are:
       * <code>security<code/>, <code>trafficShaping<code/> and <code>teaming<code/>.
       *
       * @param policiesCategory the category that will be filled
       * @param portPolicy the policy properties are used for filling the categories
       */
      function fillPoliciesCategory(policiesCategory, portPolicy) {
         // Security
         if (portPolicy.security) {
            var securitySection = policiesCategory
                  .section('security')
                  .title(i18nService.getString('NetworkUi', 'PortgroupSettingsView.security'));

            securitySection.property(
               i18nService.getString('NetworkUi', 'PortSecurityPolicyView.promiscuousMode'),
               portPolicy.security.allowPromiscuous
                     ? i18nService.getString('NetworkUi', 'PortSecurityPolicyView.accept')
                     : i18nService.getString('NetworkUi', 'PortSecurityPolicyView.reject'));

            securitySection.property(
               i18nService.getString('NetworkUi', 'PortSecurityPolicyView.mac'),
               portPolicy.security.macChanges
                     ? i18nService.getString('NetworkUi', 'PortSecurityPolicyView.accept')
                     : i18nService.getString('NetworkUi', 'PortSecurityPolicyView.reject'));

            securitySection.property(
               i18nService.getString('NetworkUi', 'PortSecurityPolicyView.forgedTransmits'),
               portPolicy.security.forgedTransmits
                     ? i18nService.getString('NetworkUi', 'PortSecurityPolicyView.accept')
                     : i18nService.getString('NetworkUi', 'PortSecurityPolicyView.reject'));
         }

         // Traffic shaping
         if (portPolicy.trafficShaping) {
            var trafficShapingSection = policiesCategory
                  .section('trafficShaping')
                  .title(i18nService.getString('NetworkUi', 'PortgroupSettingsView.trafficShaping'));

            trafficShapingSection.property(
               i18nService.getString('NetworkUi', 'PortTrafficShapingPolicyView.avgBW'),
               replaceEmptyString(portPolicy.trafficShaping.averageBandwidthSummary));

            trafficShapingSection.property(
               i18nService.getString('NetworkUi', 'PortTrafficShapingPolicyView.peakBW'),
               replaceEmptyString(portPolicy.trafficShaping.peakBandwidthSummary));

            trafficShapingSection.property(
               i18nService.getString('NetworkUi', 'PortTrafficShapingPolicyView.burstSize'),
               replaceEmptyString(portPolicy.trafficShaping.burstSizeSummary));
         }

         // Teaming and failover
         if (portPolicy.teamingAndFailover) {
            var teamingAndFailover = portPolicy.teamingAndFailover;
            var teamingSection = policiesCategory
                  .section('teaming')
                  .title(i18nService.getString('NetworkUi', 'PortgroupSettingsView.failover'));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.lbLabel'),
               getLoadBalancingPolicyValue(teamingAndFailover.loadBalancing));

            if (teamingAndFailover.loadBalancing === networkUiConstants.LoadBalancingPolicy.IP) {
               var warningMessage = getLoadBalancingWarningMessage(teamingAndFailover);
               if (warningMessage) {
                  teamingSection.warning(warningMessage);
               }
               getLoadBalancingInfoMessages().forEach(function(message) {
                  teamingSection.info(message);
               });
            }

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.detectionLabel'),
               teamingAndFailover.failureDetection
                     ? i18nService.getString('NetworkUi', 'PortFailoverPolicyView.beaconProbing')
                     : i18nService.getString('NetworkUi', 'PortFailoverPolicyView.linkStatus'));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.notifyLabel'),
               teamingAndFailover.notifySwitches
                     ? i18nService.getString('NetworkUi', 'PortFailoverPolicyView.notifyOn')
                     : i18nService.getString('NetworkUi', 'PortFailoverPolicyView.notifyOff'));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.failbackLabel'),
               teamingAndFailover.failback
                     ? i18nService.getString('NetworkUi', 'PortFailoverPolicyView.failbackOn')
                     : i18nService.getString('NetworkUi', 'PortFailoverPolicyView.failbackOff'));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.active'),
               replaceEmptyString(teamingAndFailover.activeAdapters.join(", ")));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.standby'),
               replaceEmptyString(teamingAndFailover.standByAdapters.join(", ")));

            teamingSection.property(
               i18nService.getString('NetworkUi', 'PortFailoverPolicyView.inactive'),
               replaceEmptyString(teamingAndFailover.unusedAdapters.join(", ")));
         }
      }

      function replaceEmptyString(value) {
         return value
               ? value
               : i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData');
      }

      function getLoadBalancingInfoMessages() {
         return [
            i18nService.getString(
               'NetworkUi',
               "PortPolicyData.failover.lb.loadbalance_ip.info.etherChannel"),
            i18nService.getString(
               'NetworkUi',
               "PortPolicyData.failover.lb.loadbalance_ip.info.portGroupPolicies")
         ];
      }

      function getLoadBalancingWarningMessage(teamingAndFailover) {
         if (teamingAndFailover.standByAdapters.length !== 0 && teamingAndFailover.failureDetection) {
            return i18nService.getString(
               'NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbingAndStandbyUplinks");
         } else if (teamingAndFailover.standByAdapters.length !== 0) {
            return i18nService.getString(
               'NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.standbyUplinks");
         } else if (teamingAndFailover.failureDetection) {
            return i18nService.getString(
               'NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbing");
         } else {
            return null;
         }
      }

      function getLoadBalancingPolicyValue(policy) {
         switch (policy) {
            case networkUiConstants.LoadBalancingPolicy.SRCID:
               return i18nService.getString(
                  'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcid');
            case networkUiConstants.LoadBalancingPolicy.IP:
               return i18nService.getString(
                  'NetworkUi', 'PortFailoverPolicyView.loadbalance_ip');
            case networkUiConstants.LoadBalancingPolicy.SRCMAC:
               return i18nService.getString(
                  'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcmac');
            case networkUiConstants.LoadBalancingPolicy.EXPLICIT:
               return i18nService.getString(
                  'NetworkUi', 'PortFailoverPolicyView.failover_explicit');
            default:
               return i18nService.getString(
                  'NetworkUi', 'VnicPortPropertiesView.noData');
         }
      }

      function formatTextMessagesWithIcon(messages, iconClass) {
         if (!messages || messages.length === 0) {
            return null;
         }
         var result = [];
         var template = "<div class='row'>" +
               "<span class='col-md-1'>" +
               "<span class='" + iconClass + " failover-icon'></span>" +
               "</span>" +
               "<span class='col-md-11 info-msg-color'>{{msg}}</span>" +
               "</div>";
         _.each(messages, function (message) {
            result.push(template.replace("{{msg}}", message));
         });
         return result;
      }

      function isDistributedSwitch(objectId){
         var type = defaultUriSchemeUtil.getEntityType(objectId);
         return type === "DistributedVirtualSwitch" ||
                type === "VmwareDistributedVirtualSwitch";
      }

      /**
       * Helper function used to count bytes in a given input string.
       * The string is firstly converted to UTF-8 encoding via encodeURIComponent.
       * Then each special character (matching '%[A-F\d]{2}' pattern)
       * is replaced and counted as a single character to get accurate byte count.
       *
       * @param inputString the string passed
       * @returns {number}
       *    - 0 if the passed string is incorrect
       *    - number of bytes in the given inputString when converted to UTF-8
       */
      function getStringLengthInUtf8Bytes(inputString) {
         if (!inputString || typeof inputString !== 'string') {
            return 0;
         }

         return encodeURIComponent(inputString).replace(/%[A-F\d]{2}/g, 'U').length;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   // TODO: track improvements here: https://www.pivotaltracker.com/story/show/131618679

   /**
    * Creates data grid action definitions.
    */
   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .factory('actionToolbarFactory', actionToolbarFactory);

   actionToolbarFactory.$inject = ['$q', 'vuiConstants', 'actionsService'];

   function actionToolbarFactory($q, vuiConstants, actionsService) {

      return {
         createActionbarOptions: createActionbarOptions
      };

      /**
       * @param targetIds
       *       Object ids the actions will be requested for.
       *
       * @param actionIds
       *       The ids of the actions to be requested.
       *
       * @param evaluationContext
       *       Additional context that is passed to actions' invokers.
       *
       * @return Data-grid ActionBarOptions.
       */
      function createActionbarOptions(targetIds, actionIds, evaluationContext) {
         var actionIdsWithoutSeparators = _.filter(actionIds, function(id) {
            return id !== vuiConstants.actions.SEPARATOR;
         });

         if (actionIdsWithoutSeparators.length === 0) {
            // Only separators or nothing was requested
            var result = actionIds && actionIds.length > 0 ? actionIds: null;
            return $q.resolve(result);
         }

         return actionsService.getActions(targetIds, actionIdsWithoutSeparators).then(

               function (actionsEvaluations) {
                  var actionBarOptions = { actions: [] };

                  // Manually order action definitions as per requested action ids
                  // TODO: remove it once actionService is able to return actions ordered
                  _.forEach(actionIds, function(actionId) {
                     var action;

                     if (actionId === vuiConstants.actions.SEPARATOR) {
                        actionBarOptions.actions.push(vuiConstants.actions.SEPARATOR);
                     } else {
                        var actionEvaluation = _.find(actionsEvaluations,
                              function(value) {
                                 return value.action.uid === actionId;
                              });
                        //if action
                        if(actionEvaluation) {
                           action = createAction(actionEvaluation, evaluationContext);
                           actionBarOptions.actions.push(action);
                        }
                     }
                  });

                  return actionBarOptions;
               });
      }

      function createAction(actionEvaluation, evaluationContext) {
         return {
            actionId: actionEvaluation.action.uid,
            tooltipText: actionEvaluation.action.description,
            label: actionEvaluation.action.label,
            enabled: actionEvaluation.available,
            iconClass: actionEvaluation.action.icon,
            onClick: function () {
               actionsService.invokeAction(actionEvaluation, evaluationContext);
            }
         };
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var network_lib_ui;
(function (network_lib_ui) {
    var DvpgPropertiesService = (function () {
        function DvpgPropertiesService(i18nService, networkUiConstants, mutationService) {
            this.i18nService = i18nService;
            this.networkUiConstants = networkUiConstants;
            this.mutationService = mutationService;
        }
        /**
         * Validates the name of a distributed port group and return an appropriate
         * localized error message or empty string if there is no error.
         */
        DvpgPropertiesService.prototype.getInvalidNameError = function (name) {
            var trimmedName = name.trim();
            var escapedName = trimmedName.replace(/%/g, "%25")
                .replace(/\//g, "%2f").replace(/\\/g, "%5c");
            if (escapedName.length === 0) {
                return this.i18nService.getString("NetworkLibUi", "dvpg.properties.name.required");
            }
            else if (escapedName.length > DvpgPropertiesService.MAX_ALLOWED_NAME_LENGTH) {
                return this.i18nService.getString("NetworkLibUi", "dvpg.properties.name.tooLong");
            }
            return null;
        };
        /**
         * Returns localized error text if the given host has a distributed portgroup with
         * the provided name or the name is more than 214 bytes.
         * Otherwise it returns null.
         */
        DvpgPropertiesService.prototype.getDuplicateOrTooLongNameError = function (parentEntityUrn, name) {
            return this.mutationService.validate(parentEntityUrn, "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupNameSpec", {
                _type: "com.vmware.vsphere.client.h5.network.dvportgroup.model.DvPortgroupNameSpec",
                name: name.trim()
            })
                .then(function (validationResult) {
                if (validationResult.error && validationResult.error.localizedMessage) {
                    return [validationResult.error.localizedMessage];
                }
                if (validationResult.result) {
                    return [validationResult.result];
                }
                return [];
            }, function () {
                return [];
            });
        };
        DvpgPropertiesService.prototype.getVlanIdError = function (value) {
            if (!this.isNumValueValid(value, this.networkUiConstants.Vlan.Id.MIN, this.networkUiConstants.Vlan.Id.MAX)) {
                return this.i18nService.getString("NetworkLibUi", "dvpg.properties.vlan.type.error");
            }
            return null;
        };
        DvpgPropertiesService.prototype.getNumPortsError = function (value, maxValue) {
            if (maxValue === void 0) { maxValue = this.networkUiConstants.DvPortgroupNumPorts.MAX; }
            if (!this.isNumValueValid(value, this.networkUiConstants.DvPortgroupNumPorts.MIN, maxValue)) {
                return this.i18nService.getString("NetworkLibUi", "dvpg.properties.numPorts.error", maxValue);
            }
            return null;
        };
        DvpgPropertiesService.prototype.isNumValueValid = function (value, minValue, maxValue) {
            return value !== null &&
                !isNaN(value) &&
                this.isValidInteger(value.toString()) &&
                value >= minValue &&
                value <= maxValue;
        };
        DvpgPropertiesService.prototype.isValidInteger = function (value) {
            var pattern = new RegExp("^[0-9]+$");
            return pattern.test(value);
        };
        DvpgPropertiesService.$inject = ["i18nService", "networkUiConstants", "mutationService"];
        DvpgPropertiesService.MAX_ALLOWED_NAME_LENGTH = 80;
        return DvpgPropertiesService;
    }());
    network_lib_ui.DvpgPropertiesService = DvpgPropertiesService;
    angular.module("com.vmware.vsphere.client.networkLibUi")
        .service("dvpgPropertiesService", DvpgPropertiesService);
})(network_lib_ui || (network_lib_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').service(
         'networkDetailsViewService', networkDetailsViewService);

   networkDetailsViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUtil',
      'networkUiConstants',
      'ipParserService',
      'standardPortgroupPoliciesViewService',
      'distributedPortgroupPoliciesViewService'
   ];

   function networkDetailsViewService(
         i18nService,
         propertyViewService,
         networkUtil,
         networkUiConstants,
         ipParserService,
         standardPortgroupPoliciesViewService,
         distributedPortgroupPoliciesViewService) {

      return {
         build: build,
         buildOnlyProperties: buildOnlyProperties,
         buildOnlyIpSettings: buildOnlyIpSettings,
         buildOnlyPolicies: buildOnlyPolicies,
         buildOnlyNicSettings: buildOnlyNicSettings
      };

      function build(networkDetailsData, customizedSettings) {
         if (networkDetailsData) {

            var builder = propertyViewService.createPropertyViewBuilder();

            buildPortPropertiesSection(builder, networkDetailsData);

            buildIpSettingsTab(builder, networkDetailsData.ipProperties);

            buildVnicSettingsSection(builder, networkDetailsData);

            if (!customizedSettings || !customizedSettings.noPoliciesIncluded) {
               if (networkDetailsData.dvPortgroup) {
                  distributedPortgroupPoliciesViewService.build(
                        networkDetailsData.portPolicy, builder);
               } else {
                  standardPortgroupPoliciesViewService.build(
                        networkDetailsData.portPolicy, builder);
               }
            }

            if (customizedSettings && customizedSettings.addAllTab) {
               // Add 'All' tab
               var propertiesCategory = builder.category('all', 0);
               propertiesCategory
                     .title(i18nService.getString(
                           'H5NetworkUi',
                           'VmkernelAdapterDetailsView.allTabTitle'))
                     .cloneAndAddBuilder(
                           builder.getSection('properties', 'propertiesSection'))
                     .cloneAndAddBuilder(
                           builder.getSection('ipCategory', 'ipv4Section'))
                     .cloneAndAddBuilder(
                           builder.getSection('ipCategory', 'ipv6Section'))
                     .cloneAndAddBuilder(
                           builder.getSection('properties', 'nicSettings'));

               if (!customizedSettings.noPoliciesIncluded) {
                  propertiesCategory
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'security'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'trafficShaping'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'ingressTrafficShaping'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'egressTrafficShaping'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'teaming'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'vlan'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'monitoring'))
                        .cloneAndAddBuilder(builder
                              .getSection('policies', 'miscellaneous'));
               }
            }

            return builder.build();
         }
         return {};
      }

      function buildOnlyNicSettings(networkDetailsData) {
         var builder = propertyViewService.createPropertyViewBuilder();
         builder.category("properties");

         buildVnicSettingsSection(builder, networkDetailsData);

         builder.getCategory("properties").title(null);

         return builder.build();
      }

      function buildOnlyProperties(networkDetailsData) {
         var builder = propertyViewService.createPropertyViewBuilder();

         buildPortPropertiesSection(builder, networkDetailsData);

         builder.getCategory("properties").title(null);

         return builder.build();
      }

      function buildOnlyIpSettings(networkDetailsData) {
         var builder = propertyViewService.createPropertyViewBuilder();

         buildIpSettingsTab(builder, networkDetailsData);

         builder.getCategory("ipCategory").title(null);

         return builder.build();
      }

      function buildOnlyPolicies(networkDetailsData) {
         var builder = propertyViewService.createPropertyViewBuilder();

         if (networkDetailsData.dvPortgroup) {
            distributedPortgroupPoliciesViewService.build(
                  networkDetailsData.portPolicy, builder);
         } else {
            standardPortgroupPoliciesViewService.build(
                  networkDetailsData.portPolicy, builder);
         }

         return builder.build();
      }

      function buildPortPropertiesSection(builder, networkDetailsData) {
         var propertiesCategoryBuilder = builder
               .category("properties")
               .title(i18nService.getString(
                     'NetworkUi', 'VnicView.nicCategory.title'));

         // when we don't have mtu and mac, the view is about a port group and the
         // title is different
         var propertiesSectionTitle = (networkDetailsData.mtu && networkDetailsData.mac)
               ? i18nService.getString('NetworkUi', 'VnicView.properties')
               : i18nService.getString('NetworkUi', 'PortgroupPropertiesView.title');

         var propertiesSection = propertiesCategoryBuilder
               .section("propertiesSection").title(propertiesSectionTitle);

         // Port properties
         propertiesSection.property(
               i18nService.getString(
                     'NetworkUi', 'VnicPortPropertiesView.networkLabel'),
               replaceEmptyString(networkDetailsData.networkLabel));

         if (networkDetailsData.showVlanId === true) {
            propertiesSection.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.vlanID'),
                  networkUtil.formatVlanId(networkDetailsData.vlanId));
         }

         if (networkDetailsData.showNetworkStack === true) {
            propertiesSection.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.networkStack'),
                  replaceEmptyString(networkDetailsData.networkStack));
         }

         // Array with strings of all enabled services
         if (networkDetailsData.enabledServices) {
            var enabledServices = getEnabledServices(networkDetailsData.enabledServices);

            propertiesSection.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.servicesEnabled'),
                  replaceEmptyString(enabledServices));
         }

         if (networkDetailsData.pinnedPnic) {
            propertiesSection.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.pinnedPnic'),
                  replaceEmptyString(networkDetailsData.pinnedPnic));
         }
      }

      function buildVnicSettingsSection(builder, networkDetailsData) {
         // NIC properties
         if (networkDetailsData.mac && networkDetailsData.mtu) {
            var propertiesCategoryBuilder = builder
                  .getCategory("properties");

            var nicPropertiesSection = propertiesCategoryBuilder
                  .section("nicSettings")
                  .title(i18nService.getString('NetworkUi', 'VnicView.nicSettings'));

            nicPropertiesSection.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicSettingsView.macAddress'),
                  replaceEmptyString(networkDetailsData.mac));

            nicPropertiesSection.property(
                  i18nService.getString('NetworkUi', 'VnicSettingsView.mtu'),
                  replaceEmptyString(networkDetailsData.mtu));
         }
      }

      function buildIpSettingsTab(builder, ipProperties) {

         if (ipProperties && ipProperties.hasIpv4Settings) {

            // IPv4 settings

            var ipCategoryBuilder = builder
                  .category("ipCategory")
                  .title(i18nService.getString('NetworkUi', 'VnicView.ipCategory.title'));

            var ipv4Section = ipCategoryBuilder
                  .section("ipv4Section")
                  .title(i18nService.getString('NetworkUi', 'VnicView.ipv4Settings'));

            // DHCP
            ipv4Section.property(
                  i18nService.getString('NetworkUi',
                        'VnicSettingsView.dhcp.label'),
                  getEnabledValue(ipProperties.ipv4DhcpEnabled));

            // IP address
            ipv4Section.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicIpv4SettingsView.ipv4Address'),
                  getIpv4AddressFormatted(ipProperties.ipv4DhcpEnabled,
                        ipProperties.ipv4Address));

            // Subnet mask
            ipv4Section.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicIpv4SettingsView.subnetMask'),
                  replaceEmptyString(ipProperties.subnetMask));

            // Gateway
            ipv4Section.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicIpv4SettingsView.ipv4Gateway'),
                  replaceEmptyString(ipProperties.ipv4DefaultGateway));

            // DNS
            if (ipProperties.shouldShowDnsServers) {
               var dnsServers =
                     _.filter(ipProperties.dnsServers, function (dnsServer) {
                        return ipParserService.isIpv4AddressValid(dnsServer);
                     });

               if (dnsServers.length === 0) {
                  ipv4Section.property(
                        i18nService.getString(
                              'NetworkUi', 'VnicIpv4SettingsView.dnsAddresses'),
                        i18nService.getString('NetworkUi',
                              'NetworkUtil.noData'));
               } else {
                  ipv4Section.property(
                        i18nService.getString(
                              'NetworkUi', 'VnicIpv4SettingsView.dnsAddresses'),
                        dnsServers);
               }
            }
         }

         // IPv6 settings
         if (ipProperties && ipProperties.hasIpv6Settings) {

            var ipCategory = builder.getCategory("ipCategory");
            if (ipCategory === null) {
               ipCategory = builder
                     .category("ipCategory")
                     .title(i18nService.getString('NetworkUi', 'VnicView.ipCategory.title'));
            }

            var ipv6Section = ipCategory
                  .section("ipv6Section")
                  .title(i18nService.getString('NetworkUi', 'VnicView.ipv6Settings'));

            // DHCP
            ipv6Section.property(i18nService.getString(
                  'NetworkUi', 'VnicSettingsView.dhcp.label'),
                  getEnabledValue(ipProperties.ipv6DhcpEnabled));

            // Router Advertisement
            ipv6Section.property(i18nService.getString(
                  'NetworkUi', 'VnicSettingsView.routerAdvertisement.label'),
                  getEnabledValue(ipProperties.ipv6AutoConfigEnabled));

            // IP address
            if (!ipProperties.formattedIpv6Addresses ||
                  ipProperties.formattedIpv6Addresses.length === 0) {

               ipv6Section.property(
                     i18nService.getString(
                           'NetworkUi',
                           'VnicIpv6SettingsView.ipv6Addresses'),
                     i18nService.getString('NetworkUi',
                           'NetworkUtil.noData'));
            } else {
               ipv6Section.property(
                     i18nService.getString(
                           'NetworkUi',
                           'VnicIpv6SettingsView.ipv6Addresses'),
                     ipProperties.formattedIpv6Addresses);
            }

            // Gateway
            ipv6Section.property(
                  i18nService.getString(
                        'NetworkUi', 'VnicIpv6SettingsView.ipv6Gateway'),
                  replaceEmptyString(ipProperties.ipv6DefaultGateway));

            // DNS
            if (ipProperties.shouldShowDnsServers) {
               var ipv6DnsServers =
                     _.filter(ipProperties.dnsServers, function (dnsServer) {
                        return !ipParserService.isIpv4AddressValid(dnsServer);
                     });

               if (ipv6DnsServers.length === 0) {
                  ipv6Section.property(
                        i18nService.getString(
                              'H5NetworkUi',
                              'VnicIpv6SettingsView.dnsAddresses'),
                        i18nService.getString('NetworkUi',
                              'NetworkUtil.noData'));
               } else {
                  ipv6Section.property(
                        i18nService.getString(
                              'H5NetworkUi',
                              'VnicIpv6SettingsView.dnsAddresses'),
                        ipv6DnsServers);
               }
            }
         }
      }

      function replaceEmptyString(value) {
         if (!value) {
            return i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData');
         }
         return value;
      }

      function replaceEmptyArray(array) {
         return array.length === 0
               ? [i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData')]
               : array;
      }

      function getEnabledValue(isEnabled) {
         return isEnabled ?
               i18nService.getString('NetworkUi',
                     'VnicSettingsView.autoConfig.enabled') :
               i18nService.getString('NetworkUi',
                     'VnicSettingsView.autoConfig.disabled');
      }

      function getIpv4AddressFormatted(isDhcpEnabled, ipv4Address) {
         if (!ipv4Address) {
            return i18nService.getString('NetworkUi', "VnicIpv4SettingsView.noData");
         }

         var type = isDhcpEnabled
               ? i18nService.getString('NetworkUi', 'VnicView.ipAddrDhcpTypeFormat')
               : i18nService.getString('NetworkUi', 'VnicView.ipAddrStaticTypeFormat');

         return i18nService.getString('NetworkUi', 'VnicView.ipAddressTypeFormat',
               ipv4Address, type);
      }

      function getEnabledServices(enabledServicesData) {
         var enabledServices = [];
         // vMotion
         if (enabledServicesData.isVmotionEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.vMotion'));
         }

         // Fault tolerance
         if (enabledServicesData.isFtEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.ftLogging'));
         }

         // Management traffic
         if (enabledServicesData.isManagementTrafficEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.mngTraffic'));
         }

         // Replication traffic
         if (enabledServicesData.isVrTrafficEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.vRTraffic'));
         }

         // Replication NFC traffic
         if (enabledServicesData.isVrNfcTrafficEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.vrNfcTraffic'));
         }

         // Provisioning NFC traffic
         if (enabledServicesData.isProvisioningNfcTrafficEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesView.provisioningNfcTraffic'));
         }

         // VSAN
         if (enabledServicesData.isVsanEnabled === true) {
            enabledServices.push(
                  i18nService.getString(
                        'NetworkUi', 'VnicPortPropertiesPage.vsan'));
         }

         // vSAN Witness Traffic
         if (enabledServicesData.isVsanWitnessTrafficEnabled) {
            enabledServices.push(
                  i18nService.getString(
                        'H5NetworkUi', 'VnicPortPropertiesPage.vsanWitnessTraffic'));
         }

         return replaceEmptyArray(enabledServices);
      }

      function getLoadBalancingInfoMessages() {
         return [
            i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.info.etherChannel"),
            i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.info.portGroupPolicies")
         ];
      }

      function getLoadBalancingWarningMessage(teamingAndFailover) {
         if (teamingAndFailover.standByAdapters.length !== 0 && teamingAndFailover.failureDetection) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbingAndStandbyUplinks");
         } else if (teamingAndFailover.standByAdapters.length !== 0) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.standbyUplinks");
         } else if (teamingAndFailover.failureDetection) {
            return i18nService.getString('NetworkUi', "PortPolicyData.failover.lb.loadbalance_ip.warn.beaconProbing");
         } else {
            return null;
         }
      }

      function getLoadBalancingPolicyValue(policy) {
         switch (policy) {
            case networkUiConstants.LoadBalancingPolicy.SRCID:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcid');
            case networkUiConstants.LoadBalancingPolicy.IP:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_ip');
            case networkUiConstants.LoadBalancingPolicy.SRCMAC:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_srcmac');
            case networkUiConstants.LoadBalancingPolicy.EXPLICIT:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.failover_explicit');
            case networkUiConstants.LoadBalancingPolicy.LOADBASED:
               return i18nService.getString(
                     'NetworkUi', 'PortFailoverPolicyView.loadbalance_loadbased');
            default:
               return i18nService.getString('NetworkUi', 'VnicPortPropertiesView.noData');
         }
      }
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').service('vmKernelAdapterService', vmKernelAdapterService);

   vmKernelAdapterService.$inject = ['dataService', 'i18nService', 'columnRenderersRegistry'];

   function vmKernelAdapterService(dataService, i18nService, columnRenderersRegistry) {

      var virtualAdaptersDataProperty = "vnic:virtualAdaptersData";
      var vnicStringLength = 'vmk'.length;

      function buildColumnDefinitions(showServiceColumns) {
         return {
            device: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.deviceColumnHeader'),
               field: 'device',
               width: '150px',
               template: objectLinkRendererFactory('device', {default: 'network-lib-ui-icon-virtualAdapter'}),
               sortable: function(item1, item2) {
                  return sortVnics(item1.device, item2.device);
               }
            },
            networkLabel: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.networkLabelColumnHeader'),
               field: 'networkLabel',
               width: '150px',
               template: objectLinkRendererFactory('networkLabel', {
                  dvs: 'vsphere-icon-virtual-port-group',
                  opaqueNetwork: 'vsphere-icon-cloud-network',
                  default: 'vsphere-icon-network'
               })
            },
            virtualSwitch: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.switchColumnHeader'),
               field: 'virtualSwitch',
               width: '150px',
               template: objectLinkRendererFactory('virtualSwitch', {
                  dvs: 'vsphere-icon-dv-switch',
                  opaqueNetwork: 'network-lib-ui-icon-opaqueSwitch',
                  default: 'network-lib-ui-icon-vswitch'
               })
            },
            firstIpAddress: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.ipAddressColumnHeader'),
               field: 'firstIpAddress',
               width: '150px'
            },
            networkStackName: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.networkStack'),
               field: 'networkStackName',
               width: '150px'
            },
            isVmotionEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.vMotionColumnHeader'),
               field: 'localizedVmotionEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isProvisioningNfcTrafficEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.provisioningNfcTrafficColumnHeader'),
               field: 'localizedProvisioningNfcTrafficEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isFtEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.ftColumnHeader'),
               field: 'localizedFtEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isManagementTrafficEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.managementTrafficColumnHeader'),
               field: 'localizedManagementTrafficEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isVrTrafficEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.vRTrafficColumnHeader'),
               field: 'localizedVrTrafficEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isVrNfcTrafficEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.vRNfcTrafficColumnHeader'),
               field: 'localizedVrNfcTrafficEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isVsanEnabled: {
               displayName: i18nService.getString('NetworkUi', 'VnicDataGridView.vsanColumnHeader'),
               field: 'localizedVsanEnabled',
               width: '150px',
               visible: showServiceColumns
            },
            isVsanWitnessTrafficEnabled: {
               displayName: i18nService.getString('H5NetworkUi', 'VnicPortPropertiesPage.vsanWitnessTraffic'),
               field: 'localizedVsanWitnessTrafficEnabled',
               width: '150px',
               visible: showServiceColumns
            }
         };
      }

      return {
         getVnics: function (hostId, showServiceColumns) {
            return dataService.getProperties(hostId, [virtualAdaptersDataProperty]).then(function (dataServiceResponse) {
               return formatResponse(dataServiceResponse, showServiceColumns);
            });
         },
         getVnicDetailsData: function (hostId, vnicDevice) {
            var virtualAdapterDetailsDataProperty = "vnic:virtualAdapterDetailsData";

            var params = [{
               propertyName: virtualAdapterDetailsDataProperty,
               parameterType: 'java.lang.String',
               parameter: vnicDevice
            }];

            return dataService.getProperties(
                  hostId,
                  [virtualAdapterDetailsDataProperty],
                  {
                     propertyParams: params
                  }).then(function(response) {

               return response && response[virtualAdapterDetailsDataProperty];
            });
         }
      };

      function formatResponse(dataServiceResponse, showServiceColumns) {
         var vnics = dataServiceResponse ? dataServiceResponse[virtualAdaptersDataProperty] : undefined;

         if (vnics && vnics.items) {
            vnics.items.forEach(function (vnic) {
               vnic.localizedVmotionEnabled = getEnabledDisabledLocalizedText(vnic.isVmotionEnabled);
               vnic.localizedProvisioningNfcTrafficEnabled =
                     getEnabledDisabledLocalizedText(vnic.isProvisioningNfcTrafficEnabled);
               vnic.localizedFtEnabled = getEnabledDisabledLocalizedText(vnic.isFtEnabled);
               vnic.localizedManagementTrafficEnabled = getEnabledDisabledLocalizedText(vnic.isManagementTrafficEnabled);
               vnic.localizedVrTrafficEnabled = getEnabledDisabledLocalizedText(vnic.isVrTrafficEnabled);
               vnic.localizedVrNfcTrafficEnabled = getEnabledDisabledLocalizedText(vnic.isVrNfcTrafficEnabled);
               vnic.localizedVsanEnabled = getEnabledDisabledLocalizedText(vnic.isVsanEnabled);
               vnic.localizedVsanWitnessTrafficEnabled = getEnabledDisabledLocalizedText(vnic.isVsanWitnessTraficEnabled);
            });
         }

         var hostFeatures = vnics ? vnics.hostFeatures : undefined;
         var isVsanWitnessTrafficSupported = vnics ? vnics.isVsanWitnessTrafficSupported : false;
         var columns = buildColumns(hostFeatures, isVsanWitnessTrafficSupported, showServiceColumns);
         return {
            'vnic:virtualAdaptersData': vnics,
            vnicColumnDefs: columns
         };
      }

      function buildColumns(hostFeatures, isVsanWitnessTrafficSupported, showServiceColumns) {
         var columns = [];

         var columnDefinitions = buildColumnDefinitions(showServiceColumns);

         columns.push(columnDefinitions.device);
         columns.push(columnDefinitions.networkLabel);
         columns.push(columnDefinitions.virtualSwitch);
         columns.push(columnDefinitions.firstIpAddress);

         if (hostFeatures && hostFeatures.isTcpIpStackSupported) {
            columns.push(columnDefinitions.networkStackName);
         }

         columns.push(columnDefinitions.isVmotionEnabled);

         if (hostFeatures && hostFeatures.isProvisioningNfcTrafficSupported) {
            columns.push(columnDefinitions.isProvisioningNfcTrafficEnabled);
         }

         columns.push(columnDefinitions.isFtEnabled);
         columns.push(columnDefinitions.isManagementTrafficEnabled);

         if (hostFeatures && hostFeatures.isVrTrafficSupported) {
            columns.push(columnDefinitions.isVrTrafficEnabled);
         }

         if (hostFeatures && hostFeatures.isVrNfcTrafficSupported) {
            columns.push(columnDefinitions.isVrNfcTrafficEnabled);
         }

         if (hostFeatures && hostFeatures.isVsanSupported) {
            columns.push(columnDefinitions.isVsanEnabled);
         }

         if (isVsanWitnessTrafficSupported) {
            columns.push(columnDefinitions.isVsanWitnessTrafficEnabled);
         }

         return columns;
      }

      function objectLinkRendererFactory(field, iconMapping) {
         return (function (data) {

            if (!data[field]) {
               return "<span class='network-list-empty-cell'>" +
                         i18nService.getString('NetworkUi', 'NetworkUtil.noData') +
                      "</span>";
            }

            var iconName = iconMapping[data['connectedTo']] || iconMapping['default'];
            var objectLinkRenderer = columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([undefined, field, iconName], data);
         });
      }

      function getEnabledDisabledLocalizedText(enabled) {
         return enabled ?
               i18nService.getString('NetworkUi', 'NetworkUtil.enabled') :
               i18nService.getString('NetworkUi', 'NetworkUtil.disabled');
      }

      function sortVnics(firstVnic, secondVnic) {
         if (!firstVnic && !secondVnic) {
            return 0;
         } else if (!firstVnic && secondVnic) {
            return 1;
         } else if(firstVnic && !secondVnic) {
            return -1;
         }


         var firstVnicIndex = parseInt(firstVnic.substring(vnicStringLength));
         var secondVnicIndex = parseInt(secondVnic.substring(vnicStringLength));

         if (isNaN(firstVnicIndex) && isNaN(secondVnicIndex)) {
            return 0;
         } else if (isNaN(firstVnicIndex) && !isNaN(secondVnicIndex)) {
            return 1;
         } else if(!isNaN(firstVnicIndex) && isNaN(secondVnicIndex)) {
            return -1;
         }

         return (firstVnicIndex < secondVnicIndex
            ? -1
            : (firstVnicIndex === secondVnicIndex ? 0 : 1));
      }
   }
})();


// /* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
// /*
//  * This js file has to be loaded first.
//  */
h5 = h5 || {};
h5.admin = {
   angularModule: angular.module('com.vmware.vsphere.client.admin', ['com.vmware.platform.ui'])
};

// angular.module('com.vmware.vsphere.client.admin');
var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var PrivilegeService = (function () {
            function PrivilegeService(dataService, $http) {
                this.dataService = dataService;
                this.$http = $http;
                this.privilegesUrl = 'admin-ui/ctrl/privileges';
            }
            PrivilegeService.prototype.getPrivilegeTree = function () {
                return this.$http.get(this.privilegesUrl).then(function (response) {
                    return response.data;
                });
            };
            PrivilegeService.$inject = ['dataService', '$http'];
            return PrivilegeService;
        }());
        admin_ui.PrivilegeService = PrivilegeService;
        angular.module('com.vmware.vsphere.client.admin').service('privilegeService', PrivilegeService);
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.admin').service('rolesService', rolesService);

   rolesService.$inject = ['dataService',
                           'userSessionService',
                           'defaultUriSchemeUtil',
                           'mutationService',
                           'notificationService'];

   var ANONYMOUS_ID = '-3';
   var VIEW_ID = '-4';
   var ROOT_PERMISSION_NODE_URI = 'urn:vri:acl:RootPermissionNode:root';
   var CREATE_ROLE_SPEC = 'com.vmware.vise.vim.security.data.CreateRoleSpec';
   var EDIT_ROLE_SPEC = 'com.vmware.vise.vim.security.data.EditRoleSpec';
   var DELETE_ROLE_SPEC = 'com.vmware.vise.vim.security.data.RemoveRoleSpec';

   function rolesService(dataService,
                         userSessionService,
                         defaultUriSchemeUtil,
                         mutationService,
                         notificationService) {

      return {
         getRoles: getRoles,
         getRoleUsages: getRoleUsages,
         cloneOrCreateRole: cloneOrCreateRole,
         editRole: editRole,
         deleteRole: deleteRole
      };

      function getRoles() {
            return dataService.getProperties(ROOT_PERMISSION_NODE_URI, ['rolesInfo']).then(function(response) {
               return response.rolesInfo.filter(function(data) {
                  return data.id !== ANONYMOUS_ID && data.id !== VIEW_ID;
               });
            }).then(sortRoles);
      }

      function sortRoles(data) {
         if (!data || data.length === 0) {
            return data;
         }

         var adminRoleIndex = data.findIndex(function(x) {
            return x.id === '-1';
         });
         var adminRole = data.splice(adminRoleIndex, 1);
         var readOnlyIndex = data.findIndex(function(x) {
            return x.id === '-2';
         });
         var readOnly = data.splice(readOnlyIndex, 1);
         var noAccessIndex = data.findIndex(function(x) {
            return x.id === '-5';
         });
         var noAccess = data.splice(noAccessIndex, 1);

         data.sort(function(data1, data2) {
            if(data1.label.toLowerCase() < data2.label.toLowerCase()) {
               return -1;
            }
            if(data1.label.toLowerCase() > data2.label.toLowerCase()) {
               return 1;
            }
            return 0;
         }).unshift(adminRole[0], readOnly[0], noAccess[0]);
         return data;
      }

      function getRoleUsages(roleId, vc) {
         var paramSpec = {
            propertyName: 'vsphere:permissionForRole',
            parameterType: 'flex.messaging.io.amf.ASObject',
            parameter: {
               _type: 'flex.messaging.io.amf.ASObject',
               roleId: roleId
            }
         };

         var serverGuid = vc.serviceGuid;
         var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
         var properties = ['vsphere:permissionForRole'];

         return dataService.getProperties(rootFolder, properties, {
            propertyParams: [paramSpec],
            // needed to show a custom error dialog
            skipErrorInterceptor: true
         }).then(formatUsageData).catch(function() {
            // On 6.0 environments it is observed that querying for properties of a role immediately after its
            // creation, throws a vim.fault.NotFound error. Catch the error here and display a user-friendly message.
            notificationService.notifyError("Syncronization error", "Error retrieving usage data on this vCenter.");
         });
      }

      function formatUsageData(usagesResponse) {
         var permissionData = usagesResponse['vsphere:permissionForRole'];
         if (permissionData === undefined || permissionData === null) {
            return [];
         }

         var formattedUsages = [];
         var names = permissionData.names;
         var permissions = permissionData.permissions;

         for (var i = 0; i < names.length; i++) {
            formattedUsages.push({
               definedIn: names[i].name,
               userGroup: permissions[i].principal,
               propagate: permissions[i].propagate
            });
         }
         return formattedUsages;
      }
      function cloneOrCreateRole(name, description, privileges) {
         var createRoleSpec = {
            roleName : name,
            description: description,
            privileges : privileges
         };
         return userSessionService.getAllServersInfo().then(function(response) {
            var serverGuid = response.serversInfo[0].serviceGuid;
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
            return mutationService.apply(rootFolder, CREATE_ROLE_SPEC, createRoleSpec);
         });
      }

      function editRole(id, name, description, privileges) {
         var editRoleSpec = {
            roleId : id,
            roleName : name,
            roleDescription: description,
            privileges : privileges
         };
         return userSessionService.getAllServersInfo().then(function(response) {
            var serverGuid = response.serversInfo[0].serviceGuid;
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
            return mutationService.apply(rootFolder, EDIT_ROLE_SPEC, editRoleSpec);
         });
      }

      function deleteRole(roleId) {
         var deleteRoleSpec = {
            roleId : String(roleId)
         };
         return userSessionService.getAllServersInfo().then(function(response) {
            var serverGuid = response.serversInfo[0].serviceGuid;
            var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
            return mutationService.apply(rootFolder, DELETE_ROLE_SPEC, deleteRoleSpec);
         });
      }
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.admin')
      .controller('cloneRoleController', cloneRoleController);

   cloneRoleController.$inject = ['$scope', 'rolesService', '$rootScope', 'i18nService'];

   function cloneRoleController($scope, rolesService, $rootScope, i18nService) {
      var self = this;
      self.roleName = $scope.modalOptions.dialogData.roleName;
      self.description = $scope.modalOptions.dialogData.description;
      self.selectedPrivilegeIds = $scope.modalOptions.dialogData.selectedPrivilegeIds;
      self.i18n = i18nService.getString;

      self.cloneRole = function() {
         if (validateRoles(self.roleName)) {
            return rolesService.cloneOrCreateRole(self.roleName, self.description, self.selectedPrivilegeIds).then(function() {
               $rootScope.$broadcast('refreshRoles');
               return true;
            });
         }
         else {
            invalidateForm();
            return false;
         }
      };

      function invalidateForm () {
         self.errorMessage = self.i18n('Common', 'error.role.name.unique');
         self.validity = "invalid";
      }

      function validateRoles(newRoleName) {
         return _.filter($scope.modalOptions.dialogData.roles, function(role) {
                return role.label === newRoleName;
             }).length === 0;
      }

      $scope.modalOptions.onSubmit = self.cloneRole;

    $scope.textChanged = function() {
        if ($scope.ctrl.roleName === "") {
            $scope.modalOptions.submitDisabled = true;
        } else {
            $scope.modalOptions.submitDisabled = false;
        }
      };
   }
})();

(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.admin')
      .controller('RolesViewController', RolesViewController);

   RolesViewController.$inject = ['$scope',
                                 'rolesService',
                                 'i18nService',
                                 'vuiConstants',
                                 'clarityModalService',
                                 'createEditRoleWizardService',
                                 'privilegeService',
                                 'userSessionService',
                                 'userPrivilegeService'];

   function RolesViewController ($scope,
                                 rolesService,
                                 i18nService,
                                 vuiConstants,
                                 clarityModalService,
                                 createEditRoleWizardService,
                                 privilegeService,
                                 userSessionService,
                                 userPrivilegeService) {
      var self = this;
      self.hideUsage = true;
      self.hideDescription = false;
      self.hidePrivileges = true;
      self.isAuthorized = false;
      self.selectedDescription = '';
      self.privilegeTreeForRole = [];
      self.originalPrivileges = [];
      self.selectedPriviledgeIds = [];
      self.selectedPriviledge = {};
      self.datagridRolesOptions = {
         actionBarOptions: {
            actions: [
               {
                  id: 'add-role-action',
                  iconClass: 'vsphere-icon-toolbar-add',
                  tooltipText: i18nService.getString('Common', 'rolesAction.create.desc'),
                  enabled: self.isAuthorized,
                  onClick: addRole
               }, {
                  id: 'clone-role-action',
                  iconClass: 'vsphere-icon-roles-clone',
                  tooltipText: i18nService.getString('Common', 'rolesAction.clone.desc'),
                  enabled: false,
                  onClick: cloneRole
               }, {
                  id: 'edit-role-action',
                  iconClass: 'vsphere-icon-toolbar-edit',
                  tooltipText: i18nService.getString('Common', 'rolesAction.edit.desc'),
                  enabled: false,
                  onClick: editRole
               }, {
                  id: 'delete-role-action',
                  iconClass: 'vsphere-icon-toolbar-remove',
                  tooltipText: i18nService.getString('Common', 'rolesAction.remove.desc'),
                  enabled: false,
                  onClick: deleteRole
               }
            ]
         },
         columnDefs: [
            {
               field: 'label'
            }
         ],
         id: 'Test',
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         resizable: true,
         height: '100%'
      };

      self.datagridPermissionsOptions = {
         columnDefs: [
            {
               displayName: i18nService.getString('Common', 'PermissionView.defined'),
               field: 'definedIn',
               attributes: {
                  style: "text-align: right; font-size: 14px"
               }
            },
            {
               displayName: i18nService.getString('Common', 'PermissionView.userGroupName'),
               field: 'userGroup'
            },
            {
               displayName: i18nService.getString('Common', 'usergrid.header.propagate'),
               field: 'propagate'
            }
         ],
         resizable: true,
         reorderable: false,
         height: '100%',
         attributes: {
            class: "table-cell",
            style: "text-align: right; font-size: 14px"
         }
      };

      userSessionService.getAllServersInfo().then(function(data) {
         self.vCenters = _.filter(data.serversInfo, function(server){ return server.errorCode === 'noError'; });
         self.selectedVc = self.vCenters[0];
      });
      self.fetchRolesData = fetchRolesData;

      $scope.$watch(function() {
         return self.datagridRolesOptions.selectedItems;
      }, function(selectedItems) {
         self.datagridRolesOptions.actionBarOptions.actions[1].enabled=false;
         self.datagridRolesOptions.actionBarOptions.actions[2].enabled=false;
         self.datagridRolesOptions.actionBarOptions.actions[3].enabled=false;
         if (selectedItems.length === undefined || selectedItems.length === 0) {
            return;
         }
         self.selectedPriviledgeIds = JSON.parse(JSON.stringify(selectedItems[0].privilegeIds));
         self.datagridRolesOptions.actionBarOptions.actions[1].enabled = self.isAuthorized;
         var selectedId = selectedItems[0].id;
         self.selectedDescription = selectedItems[0].summary;
         if(selectedId !== '-1' && selectedId !== '-2' && selectedId !== '-5') {
            self.datagridRolesOptions.actionBarOptions.actions[2].enabled = self.isAuthorized;
            self.datagridRolesOptions.actionBarOptions.actions[3].enabled = self.isAuthorized;
         }
         if(self.selectedVc){
             rolesService.getRoleUsages(selectedId, self.selectedVc).then(function(usages) {
                 self.datagridPermissionsOptions.data = usages;
             });
         }
         self.privilegeTreeForRole = angular.copy(self.originalPrivileges);
         setSelectedIds(self.privilegeTreeForRole);
      });

      self.showUsage = function() {

         self.hideUsage = false;
         self.hideDescription = true;
         self.hidePrivileges = true;
      };

      self.showDescription = function() {
         self.hideUsage = true;
         self.hideDescription = false;
         self.hidePrivileges = true;
      };

      self.showPrivileges = function() {
         self.hideUsage = true;
         self.hideDescription = true;
         self.hidePrivileges = false;
      };

      function editRole() {
         var selectedRole = self.datagridRolesOptions.selectedItems[0];
         var roles = self.datagridRolesOptions.data;
         createEditRoleWizardService.showWizard(roles, selectedRole);
      }

      function cloneRole() {
         var selectedRole = self.datagridRolesOptions.selectedItems[0];
         var roleName = i18nService.getString('CommonModuleUi', 'cloneOf', selectedRole.label);
         var description = selectedRole.summary;

         var title =  i18nService.getString('CommonModuleUi', 'cloneRole');
         var actionEval = {
            action: { label: title }
         };
         var modalOptions =  {
            title: title,
            actionEval: actionEval,
            size: 'lg',
            contentTemplate: 'admin-ui/resources/admin/views/cloneRole.html',
            dialogData: {
               roleName: roleName,
               description: description,
               selectedPrivilegeIds: selectedRole.privilegeIds,
               roles: self.datagridRolesOptions.data
            }
         };
         clarityModalService.openOkCancelModal(modalOptions);
      }


      function setSelectedIds(nodes) {
         nodes.forEach(function(childNode){
            if(childNode.childNodes.length === 0 && self.selectedPriviledgeIds.indexOf(childNode.id) >= 0) {
               childNode.selected = true;
               return;
            }
            setSelectedIds(childNode.childNodes);
            if (childNode.childNodes.length) {
               toggleParent(childNode);
            }
         });

      }

      function toggleParent(model) {
         var selected = model.childNodes.filter(function(child) {
            return child.selected;
         });

         model.selected = selected.length > 0;
      }

      function addRole() {
         var roles = self.datagridRolesOptions.data;
         createEditRoleWizardService.showWizard(roles);
      }

      function deleteRole() {
         var modalOptions = {
            title: i18nService.getString('Common','rolesAction.remove.dialog.title'),
            message: i18nService.getString('Common','rolesAction.remove.warning'),
            icon: 'icon-warning-32',
             defaultButton: 'close',
            submit: confirmDeleteRole,
            preserveNewlines: true
         };
         clarityModalService.openConfirmationModal(modalOptions);
      }

      function confirmDeleteRole() {
         rolesService.deleteRole(self.datagridRolesOptions.selectedItems[0].id).then(function() {
            fetchRolesData();
         });
      }

      function fetchRolesData() {
         rolesService.getRoles().then(function(roles) {
            self.datagridRolesOptions.data = roles;
         });

         privilegeService.getPrivilegeTree().then(function(data) {
            self.originalPrivileges = data;
            self.privilegeTreeForRole = angular.copy(self.originalPrivileges);
            setSelectedIds(self.privilegeTreeForRole);
         });
      }

      self.checkPrivilege = function () {
         return userPrivilegeService.checkUserPrivilege('urn:vri:acl:RootPermissionNode:root', 'Authorization.ModifyRoles')
            .then(function (isAuthorized) {
               self.isAuthorized = isAuthorized;
               self.datagridRolesOptions.actionBarOptions.actions[0].enabled = isAuthorized;
            });
      };

      $scope.$on('refreshRoles', function() {
         fetchRolesData();
      });

      self.checkPrivilege();
      fetchRolesData();
   }
}());

var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var CreateEditRoleWizardService = (function () {
            function CreateEditRoleWizardService(vuiWizardService, $rootScope, i18nService, rolesService, wizardPageService, createEditRolePageService, roleNamePageService) {
                this.vuiWizardService = vuiWizardService;
                this.$rootScope = $rootScope;
                this.i18nService = i18nService;
                this.rolesService = rolesService;
                this.wizardPageService = wizardPageService;
                this.createEditRolePageService = createEditRolePageService;
                this.roleNamePageService = roleNamePageService;
            }
            CreateEditRoleWizardService.prototype.showWizard = function (roles, roleData) {
                var _this = this;
                var wizardScope = this.$rootScope.$new();
                var createRolePage = this.createEditRolePageService.build();
                var createRoleNamePage = this.roleNamePageService.build();
                var flows = [];
                var edit = false;
                flows.push({
                    id: 'create.role.flowId',
                    pages: [
                        createRolePage,
                        createRoleNamePage
                    ]
                });
                var pages = [createRolePage, createRoleNamePage];
                wizardScope.wizardConfig = {
                    pages: this.wizardPageService.initializePageStates(pages),
                    flows: this.wizardPageService.initializeFlowStates(flows)
                };
                wizardScope.wizardConfig.roles = roles;
                wizardScope.wizardConfig.title = this.i18nService.getString('AdminUi', 'roles.create.new');
                wizardScope.wizardConfig.hideToc = true;
                wizardScope.wizardConfig.hideHeader = true;
                wizardScope.wizardConfig.resizable = false;
                wizardScope.wizardConfig.maximizable = false;
                wizardScope.wizardConfig.resizable = false;
                wizardScope.wizardConfig.resizeMinWidth = 984;
                wizardScope.wizardConfig.cssClass = 'create-role-wizard';
                wizardScope.wizardState = {
                    name: '',
                    selectedPrivilegeIds: []
                };
                if (roleData) {
                    edit = true;
                    wizardScope.wizardState = {
                        name: roleData.label,
                        description: roleData.summary,
                        selectedPrivilegeIds: roleData.privilegeIds,
                        roleId: roleData.id,
                    };
                    wizardScope.wizardConfig.title = this.i18nService.getString('AdminUi', 'roles.create.edit');
                }
                wizardScope.wizardConfig.onFinish = function () {
                    if (edit) {
                        _this.rolesService.editRole(wizardScope.wizardState.roleId, wizardScope.wizardState.name, wizardScope.wizardState.description, wizardScope.wizardState.selectedPrivilegeIds).then(function () {
                            _this.$rootScope.$broadcast('refreshRoles');
                        });
                    }
                    else {
                        _this.rolesService.cloneOrCreateRole(wizardScope.wizardState.name, wizardScope.wizardState.description, wizardScope.wizardState.selectedPrivilegeIds).then(function () {
                            _this.$rootScope.$broadcast('refreshRoles');
                        });
                    }
                    return true;
                };
                this.vuiWizardService({
                    scope: wizardScope,
                    configObjectName: 'wizardConfig',
                    sizeClass: 'vui-large-modal'
                }).show();
            };
            CreateEditRoleWizardService.$inject = ['vuiWizardService',
                '$rootScope',
                'i18nService',
                'rolesService',
                'wizardPageService',
                'createEditRolePageService',
                'roleNamePageService'];
            return CreateEditRoleWizardService;
        }());
        angular.module("com.vmware.vsphere.client.admin")
            .service("createEditRoleWizardService", CreateEditRoleWizardService);
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var CreateEditRolePageService = (function () {
            function CreateEditRolePageService(i18nService, wizardPageService) {
                this.i18nService = i18nService;
                this.wizardPageService = wizardPageService;
            }
            CreateEditRolePageService.prototype.build = function () {
                return {
                    contentUrl: 'admin-ui/resources/admin/views/wizard/pages/createEditRole.html'
                };
            };
            CreateEditRolePageService.$inject = ['i18nService', 'wizardPageService'];
            return CreateEditRolePageService;
        }());
        angular.module("com.vmware.vsphere.client.admin")
            .service("createEditRolePageService", CreateEditRolePageService);
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var CreateEditRoleController = (function () {
            function CreateEditRoleController($scope, $rootScope, privilegeService, rolesService, i18nService, $timeout) {
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.privilegeService = privilegeService;
                this.rolesService = rolesService;
                this.i18nService = i18nService;
                this.$timeout = $timeout;
                this.showAll = true;
                this.showSelected = false;
                this.showUnselected = false;
                this.selectedPrivilege;
                this.privilegeNodes = [];
                this.getPrivileges();
                this.selectedPrivilegeIds = $scope.wizardState.selectedPrivilegeIds;
                this.groupSelected = false;
                this.i18n = i18nService.getString;
                this.init();
            }
            CreateEditRoleController.prototype.focusPane = function () {
                var privilegeList = angular.element("#privilege-list-pane");
                if (privilegeList && privilegeList[0]) {
                    this.$timeout(function () {
                        privilegeList[0].focus();
                    }, 0);
                }
            };
            CreateEditRoleController.prototype.handleKeyUp = function (e) {
                if (e.target.tagName.toUpperCase() === "LI") {
                    var liSelected = e.target;
                    if (e.keyCode === 40) {
                        if (liSelected && liSelected.nextElementSibling) {
                            liSelected.nextElementSibling.focus();
                            this.selectPrivilege(liSelected.nextElementSibling.innerText);
                        }
                    }
                    else if (e.keyCode === 38) {
                        if (liSelected && liSelected.previousElementSibling) {
                            liSelected.previousElementSibling.focus();
                            this.selectPrivilege(liSelected.previousElementSibling.innerText);
                        }
                    }
                }
            };
            CreateEditRoleController.prototype.getPrivileges = function () {
                var _this = this;
                this.privilegeService.getPrivilegeTree().then(function (data) {
                    _this.privilegeNodes = data;
                    _this.privileges = _.pluck(data, 'label').sort();
                    _this.setSelectedIds(_this.privilegeNodes);
                    _this.setNodesVisibleFlag(_this.privilegeNodes, true, false);
                });
            };
            CreateEditRoleController.prototype.setNodesVisibleFlag = function (nodes, flag, selectedOnly) {
                var _this = this;
                nodes.forEach(function (childNode) {
                    if (childNode.childNodes.length === 0) {
                        if ((selectedOnly && childNode.selected) || !selectedOnly) {
                            childNode.visible = flag;
                        }
                        else {
                            childNode.visible = !flag;
                        }
                        return;
                    }
                    _this.setNodesVisibleFlag(childNode.childNodes, flag, selectedOnly);
                    if (selectedOnly) {
                        var notSelected = _.filter(childNode.childNodes, function (child) {
                            return !child.selected;
                        });
                        if (flag === true) {
                            // Show selected
                            if (notSelected.length === childNode.childNodes.length) {
                                childNode.visible = false;
                            }
                            else {
                                childNode.visible = true;
                            }
                        }
                        else {
                            // Show Unselected
                            if (notSelected.length === 0) {
                                childNode.visible = false;
                            }
                            else {
                                childNode.visible = true;
                            }
                        }
                    }
                    else {
                        childNode.visible = flag;
                    }
                });
                this.focusPane();
            };
            CreateEditRoleController.prototype.getSelectedIds = function (nodes, results) {
                var _this = this;
                nodes.forEach(function (childNode) {
                    if (childNode.childNodes.length === 0 && childNode.selected) {
                        results.push(childNode.id);
                        return;
                    }
                    _this.getSelectedIds(childNode.childNodes, results);
                });
                return results;
            };
            CreateEditRoleController.prototype.setSelectedIds = function (nodes) {
                var _this = this;
                nodes.forEach(function (childNode) {
                    if (childNode.childNodes.length === 0 && _this.selectedPrivilegeIds.indexOf(childNode.id) >= 0) {
                        childNode.selected = true;
                        return;
                    }
                    _this.setSelectedIds(childNode.childNodes);
                    if (childNode.childNodes.length) {
                        _this.toggleParent(childNode);
                    }
                });
            };
            CreateEditRoleController.prototype.toggleChild = function (model) {
                _.forEach(model.childNodes, function (child) {
                    child.selected = model.selected;
                });
            };
            ;
            CreateEditRoleController.prototype.toggleParent = function (model) {
                var notSelected = _.filter(model.childNodes, function (child) {
                    return !child.selected;
                });
                model.selected = notSelected.length === 0;
            };
            ;
            CreateEditRoleController.prototype.selectPrivilege = function (name) {
                var data = _.filter(this.privilegeNodes, function (child) {
                    return child.label === name;
                });
                this.selectedPrivilege = data[0];
                var childNodes = this.selectedPrivilege.childNodes;
                if (childNodes.length > 0 && childNodes[0].childNodes.length > 0) {
                    this.isHorizontalMode = true;
                    this.isVerticalMode = false;
                }
                else {
                    this.isHorizontalMode = false;
                    this.isVerticalMode = true;
                }
                this.checkIfAllSelected();
            };
            CreateEditRoleController.prototype.displaySelected = function () {
                this.setNodesVisibleFlag(this.privilegeNodes, true, true);
                this.showSelected = true;
                this.showUnselected = false;
                this.showAll = false;
            };
            CreateEditRoleController.prototype.displayUnselected = function () {
                this.setNodesVisibleFlag(this.privilegeNodes, false, true);
                this.showUnselected = true;
                this.showSelected = false;
                this.showAll = false;
            };
            CreateEditRoleController.prototype.displayAll = function () {
                this.setNodesVisibleFlag(this.privilegeNodes, true, false);
                this.showUnselected = false;
                this.showSelected = false;
                this.showAll = true;
            };
            CreateEditRoleController.prototype.toggleSelectAll = function () {
                var _this = this;
                this.selectedPrivilege.childNodes.forEach(function (childNode) {
                    childNode.selected = _this.groupSelected;
                    _this.toggleChild(childNode);
                });
            };
            CreateEditRoleController.prototype.checkIfAllSelected = function () {
                var notSelectedAll = _.filter(this.selectedPrivilege.childNodes, function (child) {
                    return !child.selected;
                });
                this.groupSelected = notSelectedAll.length === 0;
            };
            CreateEditRoleController.prototype.toggleExpandPrivileges = function (model) {
                model.privilegeExpanded = !model.privilegeExpanded;
            };
            CreateEditRoleController.prototype.init = function () {
                var self = this;
                this.$scope.vuiWizard.currentPage.disableNext = function () {
                    var keys = self.getSelectedIds(self.privilegeNodes, []);
                    return keys.length === 0;
                };
                this.$scope.vuiWizard.currentPage.onCommit = function () {
                    var keys = self.getSelectedIds(self.privilegeNodes, []);
                    self.$scope.wizardState.selectedPrivilegeIds = keys;
                    self.$scope.vuiWizard.currentPage.state = "completed";
                    return true;
                };
            };
            CreateEditRoleController.$inject = ['$scope', '$rootScope', 'privilegeService', 'rolesService', 'i18nService', '$timeout'];
            return CreateEditRoleController;
        }());
        angular.module('com.vmware.vsphere.client.admin')
            .controller('createEditRoleController', CreateEditRoleController);
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var RoleNamePageService = (function () {
            function RoleNamePageService(i18nService, wizardPageService) {
                this.i18nService = i18nService;
                this.wizardPageService = wizardPageService;
            }
            RoleNamePageService.prototype.build = function () {
                return {
                    contentUrl: 'admin-ui/resources/admin/views/wizard/pages/createEditRoleName.html'
                };
            };
            RoleNamePageService.$inject = ['i18nService', 'wizardPageService'];
            return RoleNamePageService;
        }());
        angular.module("com.vmware.vsphere.client.admin")
            .service("roleNamePageService", RoleNamePageService);
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));



var h5_client;
(function (h5_client) {
    var admin_ui;
    (function (admin_ui) {
        var RoleNamePageController = (function () {
            function RoleNamePageController(i18nService) {
                this.i18nService = i18nService;
                this.validity = "valid";
                this.errorMessage = "";
                this.$onInit = this.onInit;
                this.previousName = this._name;
            }
            RoleNamePageController.prototype.i18n = function (key) {
                return this.i18nService.getString('AdminUi', key);
            };
            Object.defineProperty(RoleNamePageController.prototype, "name", {
                get: function () {
                    return this._name;
                },
                set: function (value) {
                    this._name = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RoleNamePageController.prototype, "description", {
                get: function () {
                    return this._description;
                },
                set: function (value) {
                    this._description = value;
                },
                enumerable: true,
                configurable: true
            });
            RoleNamePageController.prototype.onInit = function () {
                var _this = this;
                this.wizard.currentPage.onCommit = function () {
                    return !_this.nameInvalid();
                };
            };
            RoleNamePageController.prototype.nameInvalid = function () {
                if (!this.name || this.name.length === 0) {
                    this.validity = "invalid";
                    this.errorMessage = this.i18nService.getString("Common", "error.role.name.req");
                    return true;
                }
                if (this.isDuplicateRole()) {
                    this.validity = "invalid";
                    this.errorMessage = this.i18nService.getString("Common", "error.role.name.unique");
                    return true;
                }
                return false;
            };
            RoleNamePageController.prototype.isDuplicateRole = function () {
                return this.name !== this.previousName && _.findIndex(this.wizard.roles, { name: this.name }) !== -1;
            };
            RoleNamePageController.$inject = ['i18nService'];
            return RoleNamePageController;
        }());
        admin_ui.RoleNamePageController = RoleNamePageController;
        var RoleNamePage = (function () {
            function RoleNamePage() {
                this.bindings = {
                    name: '=',
                    description: '=',
                    wizard: '='
                };
                this.controller = RoleNamePageController;
                this.templateUrl = 'admin-ui/resources/admin/views/wizard/role-name-page/role-name-page.component.html';
            }
            RoleNamePage.Name = "roleNamePage";
            return RoleNamePage;
        }());
        admin_ui.RoleNamePage = RoleNamePage;
        angular.module('com.vmware.vsphere.client.admin')
            .component(RoleNamePage.Name, new RoleNamePage());
    })(admin_ui = h5_client.admin_ui || (h5_client.admin_ui = {}));
})(h5_client || (h5_client = {}));





h5.hostprofile = {
    angularModule: angular.module("com.vmware.vsphere.client.hostprofile", ["com.vmware.platform.ui", "com.vmware.vsphere.client.commonModule"])
};
var hostprofile_ui;
(function (hostprofile_ui) {
    /**
     * Registers hostprofile-ui actions.
     */
    angular.module("com.vmware.vsphere.client.hostprofile")
        .run([
        "hostProfileService",
        "i18nService",
        "clarityModalService",
        "HostProfileComplianceService",
        "mutationService",
        "attachHostProfileService",
        "dataService",
        "clusterHostProfileSettingsService",
        "managedEntityConstants",
        "defaultUriSchemeUtil",
        "hostCustomizationsService",
        "remediateHostWizardService",
        "createHostProfileService",
        "vscImportHostProfileDialogOpenService",
        "vscHpRemediateDialogService",
        "vscEditHostProfileSettingsModalOpenService",
        "vscAttachHostProfileModalOpenService",
        "vscExtractHostProfileFromHostService",
        "vscEditClusterHostCustomizationsService",
        "vscDeleteHostProfileService",
        "vscChangeRefHostService",
        "vscCopyHostProfileToHostProfilesOpenWizardService",
        function (hostProfileService, i18nService, clarityModalService, hostProfileComplianceService, mutationService, attachHostProfileService, dataService, clusterHostProfileService, managedEntityConstants, defaultUriSchemeUtil, hostCustomizationsService, remediateHostWizardService, createHostProfileService, vscImportHostProfileDialogOpenService, vscHpRemediateDialogService, vscEditHostProfileSettingsModalOpenService, vscAttachHostProfileModalOpenService, vscExtractHostProfileFromHostService, vscEditClusterHostCustomizationsService, vscDeleteHostProfileService, vscChangeRefHostService, vscCopyHostProfileToHostProfilesOpenWizardService) {
            h5.actions["vsphere.core.hostProfile.actions.createProfileFromAHost"] =
                function (actionEval, availableTargets) {
                    createHostProfileService.openCreateHostProfileDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.attachHostProfile"] =
                function (actionEval, availableTargets) {
                    attachHostProfileService.openModal(availableTargets[0], true);
                };
            h5.actions["vsphere.core.hostProfile.actions.changeHostProfile"] =
                function (actionEval, availableTargets) {
                    var typeOfEntity = defaultUriSchemeUtil.getEntityType(availableTargets[0]);
                    if (typeOfEntity === managedEntityConstants.CLUSTER) {
                        attachHostProfileService.openModal(availableTargets[0], false);
                    }
                    else {
                        hostProfileService.changeHostProfile(availableTargets[0]);
                    }
                };
            h5.actions["vsphere.core.hostProfile.actions.cluster.changeHostProfile"] =
                function (actionEval, availableTargets) {
                    attachHostProfileService.openModal(availableTargets[0], false);
                };
            h5.actions["vsphere.core.hostProfile.actions.detachHostProfile"] =
                function (actionEval, availableTargets) {
                    hostProfileService.detachHostProfile(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.editHostCustomizations"] =
                function (actionEval, availableTargets) {
                    var modalOptions = {
                        title: i18nService.getString("HostProfileUi", "editHostCustomizationsWizard.title"),
                        subTitle: {
                            objectId: availableTargets[0]
                        },
                        dialogData: {
                            availableTargets: availableTargets
                        },
                        defaultButton: "submit",
                        contentTemplate: "hostprofile-ui/resources/hostprofile/customizations/editHostCustomizations.html",
                        size: "xl"
                    };
                    clarityModalService.openOkCancelModal(modalOptions);
                };
            h5.actions["vsphere.core.hostProfile.actions.cluster.editHostCustomizations"] =
                function (actionEval, availableTargets) {
                    vscEditClusterHostCustomizationsService.openWizard(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.hostProfile.editHostCustomizations"] =
                function (actionEval, availableTargets) {
                    vscEditClusterHostCustomizationsService.openWizard(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.hostProfile.editHostProfileAction"] =
                function (actionEval, availableTargets) {
                    dataService
                        .getProperties(availableTargets[0], ["validationState"])
                        .then(function (data) {
                        var context = {
                            selectedItemPath: null,
                            editType: "original"
                        };
                        if (data.validationState === 'Failed') {
                            context.editType = "failed";
                        }
                        vscEditHostProfileSettingsModalOpenService.open(availableTargets[0], context);
                    });
                };
            h5.actions["vsphere.core.hostProfile.actions.cluster.checkHostProfileCompliance"] =
                function (actionEval, availableTargets, context) {
                    var hostProfileId = context && context.hostProfileId ? context.hostProfileId : null;
                    mutationService.apply(availableTargets[0], "com.vmware.vsphere.client.hostprofile.cluster.h5.ClusterHostProfileComplianceCheckSpec", { hostProfile: hostProfileId });
                };
            h5.actions["vsphere.core.hostProfile.actions.hostProfile.checkHostProfileCompliance"] =
                function (actionEval, availableTargets, context) {
                    mutationService.apply(availableTargets[0], "com.vmware.vsphere.client.hostprofile.data.h5.HostProfileCheckComplianceSpec", {});
                };
            h5.actions["vsphere.core.hostProfile.actions.checkHostProfileCompliance"] =
                function (actionEval, availableTargets, context) {
                    var hostProfileId = context && context.hostProfileId ? context.hostProfileId : null;
                    hostProfileComplianceService.checkCompliance(availableTargets, hostProfileId);
                };
            h5.actions["vsphere.core.hostProfile.actions.cluster.detachHostProfile"] =
                function (actionEval, availableTargets) {
                    clusterHostProfileService.detachHostProfileFromCluster(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.resetHostCustomizations"] =
                function (actionEval, availableTargets) {
                    hostCustomizationsService.resetHostCustomizations(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.remediateHost"] =
                function (actionEval, availableTargets) {
                    // if a single host is invoking the action
                    // than open single host remediation dialog
                    vscHpRemediateDialogService.openSingleHostRemediateDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.cluster.remediateMultipleHosts"] =
                function (actionEval, availableTargets) {
                    // if a cluster/host profile invoking the action
                    // than open multiple host remediation dialog
                    vscHpRemediateDialogService.openMultipleHostRemediateDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.hostProfile.remediateMultipleHosts"] =
                function (actionEval, availableTargets) {
                    // if a cluster/host profile invoking the action
                    // than open multiple host remediation dialog
                    vscHpRemediateDialogService.openMultipleHostRemediateDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.duplicateProfile"] =
                function (actionEval, availableTargets) {
                    createHostProfileService.openCreateHostProfileDialog(availableTargets[0], false);
                };
            h5.actions["vsphere.core.hostProfile.actions.exportProfile"] =
                function (actionEval, availableTargets) {
                    hostProfileService.openExportHostProfileDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostprofile.attachAction"] =
                function (actionEval, availableTargets) {
                    vscAttachHostProfileModalOpenService.open(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.importProfile"] =
                function (actionEval, availableTargets) {
                    vscImportHostProfileDialogOpenService.open();
                };
            h5.actions["vsphere.core.hostProfile.actions.exportHostCustomizations"] =
                function (actionEval, availableTargets) {
                    hostProfileService.openExportHostCustomizationsDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.editHostProfile"] =
                function (actionEval, availableTargets, context) {
                    vscEditHostProfileSettingsModalOpenService.open(availableTargets[0], context);
                };
            h5.actions["vsphere.core.hostProfile.actions.extractHostProfileFromAHost"] =
                function (actionEval, availableTargets, context) {
                    vscExtractHostProfileFromHostService.openWizard(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.deleteProfile"] =
                function (actionEval, availableTargets, context) {
                    vscDeleteHostProfileService.openDeleteProfileConfirmationModal(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.changeRefHostAction"] =
                function (actionEval, availableTargets, context) {
                    vscChangeRefHostService.openChangeRefDialog(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.copySettingsToHostProfiles"] =
                function (actionEval, availableTargets, context) {
                    vscCopyHostProfileToHostProfilesOpenWizardService.open(availableTargets[0]);
                };
            h5.actions["vsphere.core.hostProfile.actions.copySettingsFromHostProfile"] =
                function (actionEval, availableTargets, context) {
                    vscCopyHostProfileToHostProfilesOpenWizardService.openFromToWizard(availableTargets[0]);
                };
        }]);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var AttachHostProfilePageController = (function () {
        function AttachHostProfilePageController($scope, dataService, attachHostProfileService, i18nService, vuiConstants) {
            var _this = this;
            this.$scope = $scope;
            this.dataService = dataService;
            this.attachHostProfileService = attachHostProfileService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.loading = true;
            this.gridOptions = attachHostProfileService.getGridOptions();
            this.filterPlaceholderText = i18nService.getString('Common', 'filter.label');
            this.searchTerm = "";
            this.objectId = $scope.modalOptions.dialogData.objectId;
            $scope.modalOptions.onSubmit = this.submitProfile.bind(this);
            attachHostProfileService.fetchData(this.objectId).then(function (data) {
                _this.gridOptions.data = data;
                _this.dataGridOriginalData = data;
                _this.loading = false;
            });
        }
        AttachHostProfilePageController.prototype.filterSettings = function () {
            var propertiesToSearchInFor = ["description", "name"];
            this.gridOptions.data = this.attachHostProfileService.filterSettings(this.dataGridOriginalData, this.searchTerm, propertiesToSearchInFor);
        };
        AttachHostProfilePageController.prototype.submitProfile = function () {
            this.$scope.modalOptions.isAlertClosed = true;
            this.$scope.modalOptions.alerts = [];
            if (this.gridOptions.selectedItems[0]) {
                this.attachHostProfileService.attachHostProfile(this.objectId, this.gridOptions.selectedItems[0]);
                return true;
            }
            else {
                this.$scope.modalOptions.alerts = [{
                        text: this.i18nService.getString("HostProfileUi", "attachWizard.hostProfileSelectionPage.errors.selectProfile"),
                        type: this.vuiConstants.validationBanner.type.ERROR
                    }];
                this.$scope.modalOptions.isAlertClosed = false;
            }
            return false;
        };
        AttachHostProfilePageController.$inject = [
            "$scope",
            "dataService",
            "attachHostProfileService",
            "i18nService",
            "vuiConstants"
        ];
        return AttachHostProfilePageController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("AttachHostProfilePageController", AttachHostProfilePageController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfileController = (function () {
        function HostProfileController($scope, $controller, i18nService, timeFormatterService, mutationService, hostProfileComplianceService, portletActionBarService, defaultUriSchemeUtil, dataService, vcService) {
            this.$scope = $scope;
            this.$controller = $controller;
            this.i18nService = i18nService;
            this.timeFormatterService = timeFormatterService;
            this.mutationService = mutationService;
            this.hostProfileComplianceService = hostProfileComplianceService;
            this.portletActionBarService = portletActionBarService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.vcService = vcService;
            this.HP_PORTLET_MODEL_65 = "com.vmware.vsphere.client.hostprofile.data.h5.model.HostProfilePortletData";
            this.HP_PORTLET_MODEL_66 = "com.vmware.vsphere.client.hostprofile.data.h5.model.H5HostProfilePortletData";
            this.hostId = $scope._route.objectId;
            this.liveRefreshProperties = ["configStatus", "complianceStatus", "entity",
                "complianceCheckState", "remediationState"];
            this.statuses = hostProfileComplianceService.getStatuses();
            this.getFormattedDateTime = hostProfileComplianceService.getFormattedDateTime;
            this.$scope.portlet.footerLinks = this.getFormattedLinks();
            this.getPortletData();
            this.updateActionBar();
        }
        HostProfileController.prototype.updateActionBar = function () {
            var _this = this;
            var actionsSpecs = [{
                    actionId: "vsphere.core.hostProfile.actions.checkHostPortletCompliance",
                    getActionInvocationContext: function () {
                        var hostProfileId = null;
                        if (_this.$scope.data && _this.$scope.data.associatedHostProfileData &&
                            _this.$scope.data.associatedHostProfileData.provider) {
                            hostProfileId = _this.$scope.data.associatedHostProfileData.provider;
                        }
                        return {
                            hostProfileId: hostProfileId
                        };
                    }
                }];
            this.portletActionBarService.updateActionBar(this.$scope.portlet, [this.hostId], actionsSpecs, null);
        };
        HostProfileController.prototype.getPortletData = function () {
            var _this = this;
            if (this.loadingData) {
                return;
            }
            this.loadingData = true;
            this.vcService.is66VcOrLater(this.hostId)
                .then(function (is66VcOrLater) {
                var model = is66VcOrLater ?
                    _this.HP_PORTLET_MODEL_66 :
                    _this.HP_PORTLET_MODEL_65;
                _this.dataService.getData(_this.hostId, model).then(function (data) {
                    _this.data = data;
                    if (data && data.associatedHostProfileData && data.associatedHostProfileData.provider) {
                        _this.hostProfileId =
                            _this.defaultUriSchemeUtil.getVsphereObjectId(data.associatedHostProfileData.provider);
                    }
                    _this.loadingData = false;
                });
            });
        };
        HostProfileController.prototype.getFormattedLinks = function () {
            var _this = this;
            return [{
                    label: this.i18nService.getString("HostProfileUi", "hostSummary.details"),
                    ariaLabel: this.i18nService.getString("HostProfileUi", "hostSummary.detailsAriaLabel"),
                    onClick: function () {
                        _this.$scope._navigate("vsphere.core.host.manage.settings.hostProfileView", _this.$scope._route.objectId);
                    },
                    enabled: true
                }];
        };
        HostProfileController.$inject = ["$scope", "$controller", "i18nService",
            "timeFormatterService", "mutationService",
            "HostProfileComplianceService", "portletActionBarService",
            "defaultUriSchemeUtil", "dataService", "vcService"];
        return HostProfileController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("HostProfileController", HostProfileController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfileComplianceServiceImpl = (function () {
        function HostProfileComplianceServiceImpl($controller, i18nService, timeFormatterService, mutationService, dataService, portletActionBarService) {
            this.$controller = $controller;
            this.i18nService = i18nService;
            this.timeFormatterService = timeFormatterService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.portletActionBarService = portletActionBarService;
        }
        HostProfileComplianceServiceImpl.prototype.getFormattedDateTime = function (data) {
            return this.timeFormatterService.timestampToText(data);
        };
        ;
        HostProfileComplianceServiceImpl.prototype.getStatuses = function () {
            return {
                "unknown": {
                    label: this.getString("hostComplianceStatus.unknown"),
                    iconClass: "vsphere-icon-status-unknown"
                },
                "compliant": {
                    label: this.getString("hostComplianceStatus.compliant"),
                    iconClass: "vx-icon-statusCompliant"
                },
                "nonCompliant": {
                    label: this.getString("hostComplianceStatus.notCompliant"),
                    iconClass: "vx-icon-statusNotCompliant"
                },
                "running": {
                    label: this.getString("hostComplianceStatus.running"),
                    iconClass: "spinner spinner-inline"
                },
                "precheckRemediationRunning": {
                    label: this.getString("hostComplianceStatus.precheckRemediationRunning"),
                    iconClass: "spinner spinner-inline"
                },
                "precheckRemediationComplete": {
                    label: this.getString("hostComplianceStatus.precheckRemediationComplete"),
                    iconClass: ""
                },
                "precheckRemediationFailed": {
                    label: this.getString("hostComplianceStatus.precheckRemediationFailed"),
                    iconClass: "vx-icon-statusNotCompliant"
                },
                "remediationRunning": {
                    label: this.getString("hostComplianceStatus.remediationRunning"),
                    iconClass: "spinner spinner-inline"
                },
                "remediationFailed": {
                    label: this.getString("hostComplianceStatus.remediationFailed"),
                    iconClass: "vx-icon-statusNotCompliant"
                }
            };
        };
        HostProfileComplianceServiceImpl.prototype.getString = function (key) {
            return this.i18nService.getString("HostProfileUi", key);
        };
        HostProfileComplianceServiceImpl.prototype.checkCompliance = function (hostIds, hostProfile) {
            this.mutationService.applyOnMultiEntity(hostIds, "com.vmware.vsphere.client.hostprofile.data.HostProfileComplianceCheckSpec", { hostProfile: hostProfile }, this.getString("actionCheckHostProfileCompliance"));
        };
        HostProfileComplianceServiceImpl.$inject = ["$controller", "i18nService",
            "timeFormatterService", "mutationService",
            "dataService", "portletActionBarService"];
        return HostProfileComplianceServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("HostProfileComplianceService", HostProfileComplianceServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var CreateHostProfileController = (function () {
        function CreateHostProfileController($scope, i18nService, vuiConstants, mutationService, $q, createHostProfileService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
            this.$q = $q;
            this.createHostProfileService = createHostProfileService;
            $scope.modalOptions.onSubmit = this.submitProfile.bind(this);
            this.objectId = this.$scope.modalOptions.dialogData.objectId;
            this.isExtract = this.$scope.modalOptions.dialogData.isExtractAction;
            this.profileName = this.isExtract ? this.i18nService.getString("HostProfileUi", "createProfileWizard.defaultProfileName") : "";
        }
        ;
        CreateHostProfileController.prototype.submitProfile = function () {
            var _this = this;
            this.$scope.modalOptions.isAlertClosed = true;
            this.$scope.modalOptions.alerts = [];
            this.pageErrors = null;
            if (this.profileName) {
                var profileNameSpec = {
                    profileName: this.profileName,
                    isNewHostProfile: true
                };
                this.mutationService.validate(this.objectId, "com.vmware.vsphere.client.hostprofile.data.HostProfileNameValidationSpec", profileNameSpec).then(function (validationResult) {
                    if (!validationResult.result) {
                        _this.pageErrors = _this.i18nService.getString("HostProfileUi", "hpRename.validation.uniqueName.error", _this.profileName);
                    }
                    else {
                        var createProfileSpec = _this.isExtract ? _this.createHostProfileService
                            .getCreateProfileFromHostSpec(_this.profileName, _this.profileDescription, _this.objectId) :
                            _this.createHostProfileService.getDuplicateProfileSpec(_this.profileName, _this.profileDescription, _this.objectId);
                        _this.mutationService.add(createProfileSpec._type, createProfileSpec);
                        _this.$scope.closeModal();
                    }
                });
            }
            else {
                this.pageErrors = this.i18nService.getString("HostProfileUi", "importProfile.noProfileName.error");
            }
            return false;
        };
        CreateHostProfileController.$inject = [
            "$scope",
            "i18nService",
            "vuiConstants",
            "mutationService",
            "$q",
            "createHostProfileService"];
        return CreateHostProfileController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("CreateHostProfileController", CreateHostProfileController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var CustomizationTextInput = (function () {
        function CustomizationTextInput() {
            this.require = {
                parentCtrl: "^hostCustomizations"
            };
            this.controllerAs = "ctrl";
            this.bindings = {
                item: "<"
            };
            this.controller = CustomizationTextInputController;
            this.templateUrl = "hostprofile-ui/resources/hostprofile/customizations/customizationTextInputTemplate.html";
        }
        return CustomizationTextInput;
    }());
    hostprofile_ui.CustomizationTextInput = CustomizationTextInput;
    var CustomizationTextInputController = (function () {
        function CustomizationTextInputController($scope, i18nService, hostCustomizationsErrorsService, $element, HostProfileConstants) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.hostCustomizationsErrorsService = hostCustomizationsErrorsService;
            this.$element = $element;
            this.HostProfileConstants = HostProfileConstants;
            this.requiredConfig = {
                message: this.i18nService.getString("HostProfileUi", "hostCustomizations.requiredField.error"),
                isVisible: false
            };
        }
        CustomizationTextInputController.prototype.updateValue = function (newValue) {
            this.item.value = newValue;
            this.requiredConfig.isVisible = this.hostCustomizationsErrorsService
                .isPropertyRequiredAndEmpty(this.item);
            this.parentCtrl.updateHostCustomizationSetting(this.item);
            this.item.error = null;
        };
        CustomizationTextInputController.prototype.getErrorConfig = function () {
            if (!this.requiredConfig.isVisible && this.item.error) {
                return this.item.error;
            }
            return this.requiredConfig;
        };
        CustomizationTextInputController.$inject = [
            "$scope",
            "i18nService",
            "hostCustomizationsErrorsService",
            "$element",
            "HostProfileConstants"
        ];
        return CustomizationTextInputController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .component("customizationTextInput", new CustomizationTextInput());
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var EditHostCustomizationsController = (function () {
        function EditHostCustomizationsController($scope, clarityConstants) {
            this.$scope = $scope;
            this.clarityConstants = clarityConstants;
            this.$scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.objectId = this.$scope.modalOptions.dialogData.availableTargets[0];
            this.showGenericErrors = this.setGenericErrors.bind(this);
        }
        EditHostCustomizationsController.prototype.setGenericErrors = function (errorMessages) {
            var _this = this;
            this.$scope.modalOptions.alerts = _.map(errorMessages, function (message) {
                return {
                    text: message,
                    type: _this.clarityConstants.notifications.type.ERROR
                };
            });
        };
        EditHostCustomizationsController.prototype.onSubmit = function () {
            var _this = this;
            return this.getValidationErrors().then(function (result) {
                if (result === true) {
                    return _this.submit();
                }
                if (_.isArray(result)) {
                    _this.setGenericErrors(result);
                }
                return false;
            }, function () { return false; });
        };
        EditHostCustomizationsController.$inject = ["$scope", "clarityConstants"];
        return EditHostCustomizationsController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("EditHostCustomizationsController", EditHostCustomizationsController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var EditPasswordController = (function () {
        function EditPasswordController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
        }
        ;
        EditPasswordController.prototype.updateValue = function (value) {
            this.$scope.modalOptions.dialogData.matching = !value.isVisible;
            this.$scope.modalOptions.dialogData.value = value.passwordValue;
        };
        EditPasswordController.$inject = [
            "$scope",
            "i18nService"];
        return EditPasswordController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("EditPasswordController", EditPasswordController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var ExportHostCustomizationsController = (function () {
        function ExportHostCustomizationsController($scope, $window, i18nService) {
            this.$scope = $scope;
            this.$window = $window;
            this.i18nService = i18nService;
            this.$scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.objectId = this.$scope.modalOptions.dialogData.objectId;
        }
        ;
        ExportHostCustomizationsController.prototype.onSubmit = function () {
            this.$window.open("data/download/hostcustomizations?objectId=" + this.objectId, "_blank");
            return true;
        };
        ExportHostCustomizationsController.$inject = [
            "$scope",
            "$window",
            "i18nService"
        ];
        return ExportHostCustomizationsController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("ExportHostCustomizationsController", ExportHostCustomizationsController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostsCustomizations = (function () {
        function HostsCustomizations() {
            this.bindings = {
                data: "<",
                errors: "<",
                targetType: "@"
            };
            this.controller = HostsCustomizationsController;
            this.templateUrl = "hostprofile-ui/resources/hostprofile/customizations/hostCustomizationsComponent.html";
        }
        return HostsCustomizations;
    }());
    hostprofile_ui.HostsCustomizations = HostsCustomizations;
    var HostsCustomizationsController = (function () {
        function HostsCustomizationsController(i18nService, managedEntityConstants, hostCustomizationsErrorsService, hostCustomizationsService) {
            this.i18nService = i18nService;
            this.managedEntityConstants = managedEntityConstants;
            this.hostCustomizationsErrorsService = hostCustomizationsErrorsService;
            this.hostCustomizationsService = hostCustomizationsService;
            this.KEY_SPLITTER = "/";
            this.datagridOptions = this.getGridOptions();
            this.filterPlaceholderText = this.i18nService.getString("Common", "filter.label");
            this.hostCustomizationsGridTitle = this.i18nService.getString("HostProfileUi", "host.customizations.datagrid.title");
            this.searchTerm = "";
        }
        HostsCustomizationsController.prototype.$onInit = function () {
            this.paramToErrorMap = this.hostCustomizationsErrorsService.getParamErrorsMap(this.data, this.errors);
            this.datagridOptions.data = this.createGridData(this.data);
        };
        HostsCustomizationsController.prototype.$onChanges = function (changes) {
            if (changes.errors) {
                this.paramToErrorMap = this.hostCustomizationsErrorsService.getParamErrorsMap(this.data, this.errors);
            }
            if (this.datagridOptions && (changes.data || changes.errors)) {
                this.datagridOptions.data = this.createGridData(this.data);
            }
        };
        HostsCustomizationsController.prototype.createGridData = function (hostCustomization) {
            var _this = this;
            return _.map(hostCustomization, function (item, index) {
                return _.extend({ index: index, error: _this.getItemError(item) }, item);
            });
        };
        HostsCustomizationsController.prototype.getGridOptions = function () {
            return {
                selectionMode: "single",
                sortMode: "single",
                searchable: true,
                columnDefs: this.getColumnDefs(),
                data: [],
                height: "100%",
                resizable: true
            };
        };
        HostsCustomizationsController.prototype.getColumnDefs = function () {
            var columnDefs = [];
            if (this.targetType === this.managedEntityConstants.CLUSTER) {
                columnDefs.push({
                    field: "hostName",
                    sortable: true,
                    searchable: false,
                    displayName: this.i18nService.getString("HostProfileUi", "hostCustomizations.column.host")
                });
            }
            columnDefs.push({
                field: "requiredValue",
                sortable: true,
                searchable: false,
                displayName: this.i18nService.getString("HostProfileUi", "hostCustomizations.column.required")
            });
            columnDefs.push({
                field: "name",
                sortable: true,
                searchable: false,
                displayName: this.i18nService.getString("HostProfileUi", "hostCustomizations.column.propertyName"),
                template: "<span title='#:name#'>#:name#</span>"
            });
            columnDefs.push({
                field: "description",
                sortable: true,
                searchable: false,
                displayName: this.i18nService.getString("HostProfileUi", "hostCustomizations.column.path"),
                template: "<span title='#:description#'>#:description#</span>"
            });
            columnDefs.push({
                field: "value",
                sortable: true,
                searchable: false,
                displayName: this.i18nService.getString("HostProfileUi", "hostCustomizations.column.value"),
                template: function (dataItem) {
                    if (dataItem.valueType === "password") {
                        return "<password-text-input" +
                            " item='dataItem'></password-text-input>";
                    }
                    return "<customization-text-input" +
                        " item='dataItem'></customization-text-input>";
                }
            });
            return columnDefs;
        };
        HostsCustomizationsController.prototype.updateHostCustomizationSetting = function (dataItem) {
            var hostCustomizationSetting = this.data[dataItem.index];
            if (hostCustomizationSetting) {
                hostCustomizationSetting.value = dataItem.value;
            }
        };
        HostsCustomizationsController.prototype.getItemError = function (item) {
            var key = item.hostName + this.KEY_SPLITTER + item.inputPath.profilePath +
                this.KEY_SPLITTER + item.inputPath.policyId +
                this.KEY_SPLITTER + item.inputPath.parameterId;
            var errorMessage = this.paramToErrorMap[key];
            if (errorMessage) {
                return {
                    message: errorMessage,
                    isVisible: true
                };
            }
            return null;
        };
        HostsCustomizationsController.prototype.filterSettings = function () {
            this.datagridOptions.data = this.hostCustomizationsService.filterCustomizations(this.searchTerm, this.data);
        };
        HostsCustomizationsController.$inject = [
            "i18nService",
            "managedEntityConstants",
            "hostCustomizationsErrorsService",
            "hostCustomizationsService"
        ];
        return HostsCustomizationsController;
    }());
    hostprofile_ui.HostsCustomizationsController = HostsCustomizationsController;
    angular.module("com.vmware.vsphere.client.hostprofile")
        .component("hostCustomizations", new HostsCustomizations());
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostCustomizationsErrorsServiceImpl = (function () {
        function HostCustomizationsErrorsServiceImpl(defaultUriSchemeUtil, mutationService, $q, i18nService, hostProfileConstants, clarityModalService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.$q = $q;
            this.i18nService = i18nService;
            this.hostProfileConstants = hostProfileConstants;
            this.clarityModalService = clarityModalService;
            this.KEY_SPLITTER = "/";
        }
        HostCustomizationsErrorsServiceImpl.prototype.isPropertyRequiredAndEmpty = function (hostCustomizationItem) {
            return hostCustomizationItem.isRequired && hostCustomizationItem.value === "";
        };
        HostCustomizationsErrorsServiceImpl.prototype.getValidationErrors = function (validationData) {
            var emptyRequiredPropertiesErrors = this.getEmptyRequiredPropertiesErrors(validationData.deferredHostSettingsSpec.currentHostCustomizations);
            if (emptyRequiredPropertiesErrors.length > 0) {
                return this.$q.reject({
                    paramErrors: emptyRequiredPropertiesErrors,
                    genericErrors: [this.i18nService.getString("HostProfileUi", "hostCustomizationPage.validation.error")],
                    invalidHosts: []
                });
            }
            else {
                return this.serverValidateHostCustomizations(validationData);
            }
        };
        HostCustomizationsErrorsServiceImpl.prototype.getClientValidationErrors = function (validationData) {
            var emptyRequiredPropertiesErrors = this.getEmptyRequiredPropertiesErrors(validationData.deferredHostSettingsSpec.currentHostCustomizations);
            var result = [];
            if (emptyRequiredPropertiesErrors.length > 0) {
                result = [this.i18nService.getString("HostProfileUi", "hostCustomizationPage.validation.error")];
            }
            return result;
        };
        HostCustomizationsErrorsServiceImpl.prototype.getParamErrorsMap = function (hostCustomizations, errors) {
            var _this = this;
            var errorsPerCustomizationMap = {};
            _.each(errors, function (error) {
                errorsPerCustomizationMap[_this.buildErrorMapKey(error)] = error.message;
            });
            return errorsPerCustomizationMap;
        };
        HostCustomizationsErrorsServiceImpl.prototype.buildErrorMapKey = function (error) {
            var key = "";
            if (error.hostName) {
                key += error.hostName + this.KEY_SPLITTER;
            }
            if (error.propertyPath) {
                key += error.propertyPath.profilePath + this.KEY_SPLITTER +
                    error.propertyPath.policyId + this.KEY_SPLITTER +
                    error.propertyPath.parameterId;
            }
            return key;
        };
        HostCustomizationsErrorsServiceImpl.prototype.getEmptyRequiredPropertiesErrors = function (hostCustomizations) {
            var _this = this;
            return _.map(_.filter(hostCustomizations, function (item) {
                return _this.isPropertyRequiredAndEmpty(item);
            }), function (item) {
                return {
                    hostName: item.hostName,
                    propertyPath: item.inputPath,
                    message: _this.i18nService.getString("HostProfileUi", "hostCustomizations.requiredFieldName.error", item.name)
                };
            });
        };
        HostCustomizationsErrorsServiceImpl.prototype.getCustomizationsErrorMessages = function (error) {
            var errors = this.flatErrorsList([error]);
            var messages = this.getCommonCustomizationErrorMessages(errors);
            return messages;
        };
        HostCustomizationsErrorsServiceImpl.prototype.getCustomizationsImportErrorAndWarningMessages = function (error) {
            var errors = this.flatErrorsList([error]);
            var hostCustomizationImportException = _.find(errors, function (error) {
                return error && (_.has(error, "errorMessages") || _.has(error, "warningMessages"));
            });
            if (!hostCustomizationImportException) {
                return {
                    errorMessages: [],
                    warningMessages: []
                };
            }
            return {
                errorMessages: _.map(hostCustomizationImportException.errorMessages, function (errorMessage) { return errorMessage.message; }),
                warningMessages: _.map(hostCustomizationImportException.warningMessages, function (warningMessage) { return warningMessage.message; })
            };
        };
        HostCustomizationsErrorsServiceImpl.prototype.serverValidateHostCustomizations = function (validationData) {
            if (!validationData.deferredHostSettingsSpec ||
                _.isEmpty(validationData.deferredHostSettingsSpec.forceValidationOnHosts)) {
                return this.$q.resolve({});
            }
            var selectedHostProfileMor = validationData.hostProfileId;
            var hostProfileUid = this.defaultUriSchemeUtil.createVmomiUri(selectedHostProfileMor.type, selectedHostProfileMor.value, selectedHostProfileMor.serverGuid);
            return this.mutationService.validate(hostProfileUid, "com.vmware.vsphere.client.hostprofile.data.h5.ValidateHostCustomizationsSpec", validationData.deferredHostSettingsSpec, validationData.deferredHostSettingsSpec.currentHostCustomizations).then(this.handleValidationResult.bind(this));
        };
        HostCustomizationsErrorsServiceImpl.prototype.extractGenericErrors = function (allErrors) {
            return _.filter(allErrors, function (error) {
                return !error.path;
            });
        };
        HostCustomizationsErrorsServiceImpl.prototype.extractParameterRelatedErrors = function (allErrors) {
            return _.filter(allErrors, function (error) {
                return !_.isUndefined(error.path) && !_.isNull(error.path);
            });
        };
        HostCustomizationsErrorsServiceImpl.prototype.handleValidationResult = function (validationResult) {
            var _this = this;
            if (validationResult && (validationResult.error ||
                this.hasValidationResultMessage(validationResult))) {
                var genericErrors_1 = [];
                var invalidHosts = [];
                if (validationResult.error) {
                    var error = validationResult.error;
                    invalidHosts = _.filter(error.exceptions, function (exception) {
                        return exception["faultCause"] ?
                            exception["faultCause"]._type === _this.hostProfileConstants.INVALID_PROFILE_REFERENCE_HOST : false;
                    }).map(function (exception) {
                        return _this.defaultUriSchemeUtil.getVsphereObjectId(exception["faultCause"].host);
                    });
                    genericErrors_1 = this.getCustomizationsErrorMessages(error);
                }
                var paramErrors_1 = [];
                _.each(_.keys(validationResult.result), function (hostKey) {
                    var errors = validationResult.result[hostKey].errors;
                    if (errors) {
                        var extractedParamErrors = _this.extractParameterRelatedErrors(errors);
                        paramErrors_1 =
                            paramErrors_1.concat(_.map(extractedParamErrors, function (error) {
                                return {
                                    hostName: hostKey,
                                    propertyPath: error.path,
                                    message: error.message.message
                                };
                            }));
                        genericErrors_1 = genericErrors_1.concat(_this.extractGenericErrors(errors));
                    }
                });
                if (paramErrors_1.length > 0) {
                    genericErrors_1.push(this.i18nService.getString("HostProfileUi", "hostCustomizationPage.validation.error"));
                }
                return this.$q.reject({
                    genericErrors: genericErrors_1,
                    paramErrors: paramErrors_1,
                    invalidHosts: invalidHosts
                });
            }
            else {
                return this.$q.resolve({});
            }
        };
        HostCustomizationsErrorsServiceImpl.prototype.hasValidationResultMessage = function (validationResult) {
            if (validationResult && validationResult.result) {
                return _.some(_.keys(validationResult.result), function (key) { return validationResult.result[key].status === "error"; });
            }
            return false;
        };
        HostCustomizationsErrorsServiceImpl.prototype.showSkipValidationDialog = function (validationData, invalidHosts) {
            var _this = this;
            var invalidHostsModified = _.map(invalidHosts, function (invalidHost) {
                var hostCustomizationForInvalidHost = _.filter(validationData.deferredHostSettingsSpec.currentHostCustomizations, function (customization) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(customization["hostMor"]) === invalidHost;
                });
                var name = "";
                if (hostCustomizationForInvalidHost && hostCustomizationForInvalidHost.length > 0) {
                    name = hostCustomizationForInvalidHost[0].hostName;
                }
                return {
                    id: invalidHost,
                    name: name,
                    checked: true
                };
            });
            var skipValidationDeferred = this.$q.defer();
            var modalOptions = {
                title: this.i18nService.getString("HostProfileUi", "skipHostValidation.title"),
                contentTemplate: "hostprofile-ui/resources/hostprofile/attach/hostCustomizationSkipValidationDialog.html",
                dialogData: {
                    validationData: {
                        invalidHosts: invalidHostsModified,
                        deferredHostSettingsSpec: validationData.deferredHostSettingsSpec
                    }
                },
                onSubmit: function () {
                    skipValidationDeferred.resolve(_this.serverValidateHostCustomizations(validationData));
                    return true;
                },
                onCancel: function () {
                    //remove any changes made while dialog was open
                    var invalidHostsMor = _.map(invalidHosts, function (invalidHost) {
                        return _this.defaultUriSchemeUtil.getManagedObjectReference(invalidHost);
                    });
                    if (validationData.deferredHostSettingsSpec.forceValidationOnHosts) {
                        validationData.deferredHostSettingsSpec.forceValidationOnHosts =
                            _.uniq(_.union(validationData.deferredHostSettingsSpec.forceValidationOnHosts, invalidHostsMor), false, function (host) {
                                return host.value;
                            });
                    }
                    else {
                        validationData.deferredHostSettingsSpec.forceValidationOnHosts = invalidHostsMor;
                    }
                    validationData.deferredHostSettingsSpec.skipValidationOnHosts = [];
                    skipValidationDeferred.reject({
                        genericErrors: [],
                        paramErrors: [],
                        invalidHosts: []
                    });
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            return skipValidationDeferred.promise;
        };
        // Traverse the errors in the tree using DFS (the tree consists of non-leaf nodes
        // of type CompositeException and leaf nodes of type != CompositeException) and
        // return only the leaf nodes - the actual exceptions
        HostCustomizationsErrorsServiceImpl.prototype.flatErrorsList = function (errors) {
            errors = errors.concat();
            var result = [];
            while (errors.length > 0) {
                var error = errors.shift();
                if (!error) {
                    continue;
                }
                if (error._type === this.hostProfileConstants.COMPOSITE_EXCEPTION) {
                    Array.prototype.unshift.apply(errors, error.exceptions);
                }
                else {
                    result.push(error);
                }
            }
            return result;
        };
        HostCustomizationsErrorsServiceImpl.prototype.getCommonCustomizationErrorMessages = function (errors) {
            var _this = this;
            return _.chain(errors)
                .filter(function (exception) {
                var message = exception.message;
                if (!message) {
                    message = exception.localizedMessage;
                }
                return message &&
                    !(exception._type === _this.hostProfileConstants.HOST_CUSTOMIZATION_IMPORT_EXCEPTION) &&
                    !message.startsWith(_this.hostProfileConstants.BAD_REQUEST_EXCEPTION);
            })
                .map(function (exception) { return exception.message ? exception.message : exception.localizedMessage; })
                .value();
        };
        HostCustomizationsErrorsServiceImpl.$inject = [
            "defaultUriSchemeUtil",
            "mutationService",
            "$q",
            "i18nService",
            "HostProfileConstants",
            "clarityModalService"
        ];
        return HostCustomizationsErrorsServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("hostCustomizationsErrorsService", HostCustomizationsErrorsServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var ReadHostCustomizationsSpec = com.vmware.vsphere.client.hostprofile.data.h5.ReadHostCustomizationsSpec;
    var HostCustomizationsPageComponentController = (function () {
        function HostCustomizationsPageComponentController($scope, hostCustomizationsService, hostCustomizationsErrorsService, $element, $q, i18nService, vcService) {
            var _this = this;
            this.$scope = $scope;
            this.hostCustomizationsService = hostCustomizationsService;
            this.hostCustomizationsErrorsService = hostCustomizationsErrorsService;
            this.$element = $element;
            this.$q = $q;
            this.i18nService = i18nService;
            this.hasGenericErrors = false;
            this.hostCustomizationsErrors = [];
            this.isLastReadOperationImport = false;
            this.hostCustomizationsImportWarningMessages = [];
            this.hostCustomizationsImportErrorMessages = [];
            this.validationData = {};
            this.hasErrors = false;
            this.i18n = i18nService.getString;
            this.hostCustomizationsFileInput = $element.find(".import-host-customizations-file-input");
            this.hostCustomizationsFileReader = new FileReader();
            this.submitCallback = this.onSubmit.bind(this);
            this.getValidationErrorsCallback = this.getValidationErrors.bind(this);
            this.getClientValidationErrorsCallback = this.getClientValidationErrors.bind(this);
            this.importOverrideSignPostOptions = {
                title: null,
                message: this.i18nService.getString("HostProfileUi", "editHostCustomizationsWizard.importPropertyOverrideInfo")
            };
            // listen for fileInput changes
            this.hostCustomizationsFileInput.on("change", function (event) { return _this.$scope.$evalAsync(function () { return _this.onHostCustomizationsFileSelected(event.target.files[0]); }); });
            $(this.hostCustomizationsFileReader).on("load", function (event) { return _this.$scope.$evalAsync(function () { return _this.onHostCustomizationsFileLoad(event.target.result); }); });
            // $scope $destroy
            $scope.$on("$destroy", function () {
                $.cleanData($(_this.hostCustomizationsFileReader));
            });
            vcService.is65VcOrLater(this.objectId).then(function (is65VcOrLater) {
                _this.is65VcOrLater = is65VcOrLater;
            });
            this.initValidationData();
            this.getData();
        }
        HostCustomizationsPageComponentController.prototype.initValidationData = function () {
            this.validationData.objectId = this.objectId;
            this.validationData.loading = true;
            this.validationData.deferredHostSettingsSpec = {
                _type: "com.vmware.vsphere.client.hostprofile.data.h5.ValidateHostCustomizationsSpec",
                forceValidationOnHosts: [],
                skipValidationOnHosts: [],
                isNewlyAssociatedProfile: true,
                currentHostCustomizations: [],
                executeProfile: false,
                formattedCustomizations: ""
            };
        };
        HostCustomizationsPageComponentController.prototype.onImportHostCustomizationsButtonClick = function () {
            this.hostCustomizationsFileInput.click();
        };
        HostCustomizationsPageComponentController.prototype.onHostCustomizationsFileSelected = function (file) {
            this.validationData.loading = true;
            this.hostCustomizationsFileInput.prop("value", "");
            // after this method finishes the onload is called internally
            this.hostCustomizationsFileReader.readAsText(file);
        };
        HostCustomizationsPageComponentController.prototype.onHostCustomizationsFileLoad = function (formattedHostCustomizations) {
            if (!formattedHostCustomizations) {
                this.validationData.loading = false;
                return;
            }
            this.getCustomizations(formattedHostCustomizations);
        };
        HostCustomizationsPageComponentController.prototype.onSubmit = function () {
            return this.hostCustomizationsService.updateHostCustomizations(this.validationData.objectId, this.validationData.hostProfileId, this.validationData.deferredHostSettingsSpec.currentHostCustomizations)
                .then(function () { return true; });
        };
        HostCustomizationsPageComponentController.prototype.getValidationErrors = function () {
            var _this = this;
            if (this.validationData.loading) {
                return this.$q.resolve(false);
            }
            if (this.validationData.hostProfileId && this.validationData.objectId
                && this.hostCustomizations && !this.hasErrors) {
                this.validationData.loading = true;
                return this.hostCustomizationsErrorsService.getValidationErrors(this.validationData)
                    .then(function () { return _this.$q.resolve(true); }, this.handleValidationErrors.bind(this));
            }
            this.validationData.loading = false;
            return this.$q.resolve(false);
        };
        HostCustomizationsPageComponentController.prototype.getClientValidationErrors = function () {
            if (this.validationData.hostProfileId && this.validationData.objectId
                && this.hostCustomizations && !this.hasErrors) {
                return this.hostCustomizationsErrorsService.getClientValidationErrors(this.validationData);
            }
            return [];
        };
        HostCustomizationsPageComponentController.prototype.handleValidationErrors = function (validationResult) {
            var _this = this;
            this.validationData.loading = false;
            this.hostCustomizationsErrors = validationResult.paramErrors;
            if (validationResult.invalidHosts.length > 0) {
                return this.hostCustomizationsErrorsService.showSkipValidationDialog(this.validationData, validationResult.invalidHosts).then(function () { return _this.$q.resolve(true); }, this.handleValidationErrors.bind(this));
            }
            if (validationResult.genericErrors.length > 0) {
                return this.$q.resolve(validationResult.genericErrors);
            }
            return this.$q.resolve(false);
        };
        HostCustomizationsPageComponentController.prototype.populateHostCustomizations = function (data, isImportHostCustomizationsRead) {
            this.validationData.loading = false;
            if (data && data.length > 0) {
                var result = data[0].result;
                if (result && result.length > 0) {
                    this.hostCustomizations = data[0].result;
                    this.validationData.deferredHostSettingsSpec.currentHostCustomizations =
                        this.hostCustomizations;
                    this.validationData.
                        deferredHostSettingsSpec.forceValidationOnHosts =
                        this.hostCustomizationsService.getCustomizationsHosts(this.hostCustomizations);
                }
                this.isLastReadOperationImport = isImportHostCustomizationsRead;
                this.hostCustomizationsImportResultDetailsSignPostOptions = undefined;
                this.hostCustomizationsImportStatus = undefined;
                this.hostCustomizationsImportErrorMessages = [];
                this.hostCustomizationsImportWarningMessages = [];
                this.hasErrors = false;
                this.showGenericErrors([]);
                var error = data[0].error;
                if (error) {
                    var commonCustomizationErrorMessages = this.hostCustomizationsErrorsService.getCustomizationsErrorMessages(error);
                    this.showGenericErrors(commonCustomizationErrorMessages);
                    this.hasGenericErrors = commonCustomizationErrorMessages && commonCustomizationErrorMessages.length > 0;
                    if (isImportHostCustomizationsRead) {
                        var hostCustomizationsImportErrorAndWarningMessages = this.hostCustomizationsErrorsService
                            .getCustomizationsImportErrorAndWarningMessages(error);
                        this.hostCustomizationsImportErrorMessages =
                            hostCustomizationsImportErrorAndWarningMessages.errorMessages;
                        this.hostCustomizationsImportWarningMessages =
                            hostCustomizationsImportErrorAndWarningMessages.warningMessages;
                        // todo: developer must convert markup style to correct component approach
                        // using raw markup is wrong due to encapsulation violations
                        // Therefore, use component style and ensure template injection will process
                        /*
                        <clr-alert bs1 [clr-alert-type]="'danger'" [clr-alert-closable]="false" [clr-alert-size-small]="true">
                           <clr-alert-item>
                              <span class="alert-text" ng-bind="message"></span>
                           </clr-alert-item>
                        </clr-alert>
                        */
                        var signPostHtmlMessage = "";
                        signPostHtmlMessage = _.reduce(_.map(
                        /**
                         * unacceptable markup violation
                         */
                        this.hostCustomizationsImportErrorMessages, function (message) {
                            return ("\n                                    <div class=\"alert alert-danger alert-sm\">\n                                       <div class=\"alert-items\">\n                                       <div class=\"alert-item static\">\n                                          <span class=\"alert-text\">" + message + "</span>\n                                       </div>\n                                       </div>\n                                    </div>\n                                    ");
                        }), function (memo, message) { return memo + message; }, signPostHtmlMessage);
                        signPostHtmlMessage = _.reduce(_.map(
                        /**
                         * unacceptable markup violation
                         */
                        this.hostCustomizationsImportWarningMessages, function (message) {
                            return ("\n                                    <div class=\"alert alert-warning alert-sm\">\n                                       <div class=\"alert-items\">\n                                       <div class=\"alert-item static\">\n                                          <span class=\"alert-text\">" + message + "</span>\n                                       </div>\n                                       </div>\n                                    </div>\n                                    ");
                        }), function (memo, message) { return memo + message; }, signPostHtmlMessage);
                        this.hostCustomizationsImportResultDetailsSignPostOptions = {
                            title: this.i18nService.getString("HostProfileUi", "editHostCustomizationsWizard.importDetailsDialogTitle"),
                            message: signPostHtmlMessage
                        };
                    }
                    this.hasErrors = !_.isEmpty(commonCustomizationErrorMessages);
                }
                else {
                    this.hasGenericErrors = false;
                }
                if (isImportHostCustomizationsRead) {
                    if (!_.isEmpty(this.hostCustomizationsImportErrorMessages)) {
                        this.hostCustomizationsImportStatus = "error";
                    }
                    else if (!_.isEmpty(this.hostCustomizationsImportWarningMessages)) {
                        this.hostCustomizationsImportStatus = "warning";
                    }
                    else {
                        this.hostCustomizationsImportStatus = "success";
                    }
                }
            }
        };
        HostCustomizationsPageComponentController.prototype.getCustomizations = function (formattedHostCustomizations) {
            var _this = this;
            if (this.validationData.hostProfileId) {
                var spec = new ReadHostCustomizationsSpec();
                spec.hostProfile = this.validationData.hostProfileId;
                spec.isNewlyAssociatedProfile = false;
                spec.formattedHostCustomizations = formattedHostCustomizations;
                spec.currentHostCustomizations = this.hostCustomizations;
                var isImportHostCustomizationsRead_1 = !!formattedHostCustomizations;
                this.hostCustomizationsService
                    .getHostCustomizations(this.validationData.objectId, spec)
                    .then(function (hostCustomizations) { return _this.populateHostCustomizations(hostCustomizations, isImportHostCustomizationsRead_1); });
            }
            else {
                this.validationData.loading = false;
            }
        };
        HostCustomizationsPageComponentController.prototype.getData = function () {
            var _this = this;
            this.hostCustomizationsService.getAssociatedHostProfile(this.validationData.objectId)
                .then(function (data) {
                _this.validationData.hostProfileId
                    = data.associatedHostProfile;
                _this.getCustomizations();
            });
        };
        HostCustomizationsPageComponentController.$inject = [
            "$scope",
            "hostCustomizationsService",
            "hostCustomizationsErrorsService",
            "$element",
            "$q",
            "i18nService",
            "vcService"
        ];
        return HostCustomizationsPageComponentController;
    }());
    var HostCustomizationsPageComponent = (function () {
        function HostCustomizationsPageComponent() {
            this.controller = HostCustomizationsPageComponentController;
            this.templateUrl =
                "hostprofile-ui/resources/hostprofile/customizations/hostCustomizationsPage.html";
            this.bindings = {
                objectId: "<",
                targetType: "<",
                showGenericErrors: "<",
                getValidationErrorsCallback: "=",
                getClientValidationErrorsCallback: "=",
                submitCallback: "="
            };
        }
        return HostCustomizationsPageComponent;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile").component("hostCustomizationsPage", new HostCustomizationsPageComponent());
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostCustomizationsServiceImpl = (function () {
        function HostCustomizationsServiceImpl(mutationService, dataService) {
            this.mutationService = mutationService;
            this.dataService = dataService;
        }
        HostCustomizationsServiceImpl.prototype.getAssociatedHostProfile = function (targetId) {
            return this.dataService.getProperties(targetId, ["associatedHostProfile"]);
        };
        HostCustomizationsServiceImpl.prototype.getHostCustomizations = function (targetId, spec) {
            return this.mutationService.applyOnMultiEntity([targetId], "com.vmware.vsphere.client.hostprofile.data.h5.ReadHostCustomizationsSpec", spec, "OP_IGNORE_ERROR");
        };
        HostCustomizationsServiceImpl.prototype.updateHostCustomizations = function (targetId, hostProfileMoRef, hostCustomizations) {
            return this.mutationService.applyOnMultiEntity([targetId], "com.vmware.vsphere.client.hostprofile.data.h5.UpdateHostCustomizationsSpec", {
                hostProfile: hostProfileMoRef,
                currentHostCustomizations: hostCustomizations
            });
        };
        HostCustomizationsServiceImpl.prototype.resetHostCustomizations = function (hostId) {
            return this.mutationService.applyOnMultiEntity([hostId], "com.vmware.vsphere.client.hostprofile.data.ResetHostCustomizationsSpec", {});
        };
        HostCustomizationsServiceImpl.prototype.getCustomizationsHosts = function (hostCustomizations) {
            var sortedHosts = _.pluck(hostCustomizations, "hostMor")
                .sort(function (a, b) {
                return a.value.localeCompare(b.value);
            });
            return _.uniq(sortedHosts, true, function (item) {
                return item.value;
            });
        };
        HostCustomizationsServiceImpl.prototype.filterCustomizations = function (searchTerm, data) {
            var search = searchTerm.toLowerCase();
            return data.filter(function (item) {
                var requiredValue = item.requiredValue.toLowerCase();
                var propertyName = item.name.toLowerCase();
                var path = item.description.toLowerCase();
                var value = item.value.toLowerCase();
                return requiredValue.indexOf(search) !== -1 ||
                    propertyName.indexOf(search) !== -1 ||
                    path.indexOf(search) !== -1 ||
                    value.indexOf(search) !== -1;
            });
        };
        HostCustomizationsServiceImpl.$inject = ["mutationService", "dataService"];
        return HostCustomizationsServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile").service("hostCustomizationsService", HostCustomizationsServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var PasswordTextInput = (function () {
        function PasswordTextInput() {
            this.require = {
                parentCtrl: "^hostCustomizations"
            };
            this.controllerAs = "ctrl";
            this.bindings = {
                item: "<"
            };
            this.controller = PasswordTextInputController;
            this.templateUrl = "hostprofile-ui/resources/hostprofile/customizations/passwordTextInputTemplate.html";
        }
        return PasswordTextInput;
    }());
    hostprofile_ui.PasswordTextInput = PasswordTextInput;
    var PasswordTextInputController = (function () {
        function PasswordTextInputController(i18nService, hostCustomizationsErrorsService, $element, HostProfileConstants, clarityModalService) {
            this.i18nService = i18nService;
            this.hostCustomizationsErrorsService = hostCustomizationsErrorsService;
            this.$element = $element;
            this.HostProfileConstants = HostProfileConstants;
            this.clarityModalService = clarityModalService;
            this.value = this.i18nService
                .getString("HostProfileUi", "hostCustomizations.maskedPassword");
            this.requiredConfig = {
                message: this.i18nService.getString("HostProfileUi", "hostCustomizations.requiredField.error"),
                isVisible: false
            };
        }
        PasswordTextInputController.prototype.getErrorConfig = function () {
            if (!this.requiredConfig.isVisible && this.item.error) {
                return this.item.error;
            }
            return this.requiredConfig;
        };
        PasswordTextInputController.prototype.openPasswordModal = function () {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("HostProfileUi", "editHostCustomizations.editPassword.title"),
                defaultButton: "submit",
                contentTemplate: "hostprofile-ui/resources/hostprofile/customizations/editPassword.html",
                dialogData: {
                    value: "",
                    matching: true
                },
                onSubmit: function () {
                    if (modalOptions.dialogData.matching) {
                        _this.item.value = modalOptions.dialogData.value;
                        _this.requiredConfig.isVisible = _this.hostCustomizationsErrorsService
                            .isPropertyRequiredAndEmpty(_this.item);
                        _this.parentCtrl.updateHostCustomizationSetting(_this.item);
                        return true;
                    }
                    return false;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        PasswordTextInputController.$inject = [
            "i18nService",
            "hostCustomizationsErrorsService",
            "$element",
            "HostProfileConstants",
            "clarityModalService"
        ];
        return PasswordTextInputController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .component("passwordTextInput", new PasswordTextInput());
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var ExportHostProfileController = (function () {
        function ExportHostProfileController($scope, $window, i18nService) {
            this.$scope = $scope;
            this.$window = $window;
            this.i18nService = i18nService;
            this.$scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.objectId = this.$scope.modalOptions.dialogData.objectId;
        }
        ;
        ExportHostProfileController.prototype.onSubmit = function () {
            this.$window.open("data/download/hostProfileExportData?objectId=" + encodeURIComponent(this.objectId), "_blank");
            return true;
        };
        ExportHostProfileController.$inject = [
            "$scope",
            "$window",
            "i18nService"
        ];
        return ExportHostProfileController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("ExportHostProfileController", ExportHostProfileController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    angular.module("com.vmware.vsphere.client.hostprofile")
        .constant("HostProfileConstants", {
        complianceStatus: {
            nonCompliant: "nonCompliant",
            unknown: "unknown",
            compliant: "compliant"
        },
        COMPOSITE_EXCEPTION: "com.vmware.vise.core.model.CompositeException",
        HOST_CUSTOMIZATION_IMPORT_EXCEPTION: "com.vmware.vsphere.client.hostprofile.data.HostCustomizationImportException",
        INVALID_PROFILE_REFERENCE_HOST: "com.vmware.vim.binding.vim.fault.InvalidProfileReferenceHost",
        BAD_REQUEST_EXCEPTION: "com.vmware.vise.search.transport.BadRequestException"
    });
})(hostprofile_ui || (hostprofile_ui = {}));







/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfileComplianceController = (function () {
        function HostProfileComplianceController($scope, $element, i18nService, clusterHostProfileSettingsService, vcService, defaultUriSchemeUtil, dataService, localStorageService) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.i18nService = i18nService;
            this.clusterHostProfileSettingsService = clusterHostProfileSettingsService;
            this.vcService = vcService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.localStorageService = localStorageService;
            this.REMEDIATION_RESULT_KEY = "remediationTaskErrorResult_";
            this.isComplianceExpanded = false;
            this.objectsToWatch = [];
            this.attachDetachViewHeaderAccessor = {};
            this.splitterOptions = this.clusterHostProfileSettingsService.getSplitterOptions();
            this.objectId = this.$scope._route.objectId;
            this.focusedItem = null;
            this.objectsToWatch = [this.objectId];
            this.liveRefreshProperties = ["configStatus", "complianceCheckState",
                "remediationState", "answerFileValidationState", "entity", "complianceStatus"];
            this.headerOptions = {
                objectId: this.objectId,
                title: this.i18nService.getString("HostProfileUi", "cluster.monitor.compliance.host"),
                actions: [{
                        actionUid: "vsphere.core.hostProfile.actions.hostProfile.checkHostProfileCompliance",
                        customLabel: this.i18nService.getString("HostProfileUi", "hostProfile.action.checkCompliance")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.hostProfile.remediateMultipleHosts",
                        customLabel: this.i18nService.getString("HostProfileUi", "actionRemediateHostLabel")
                    }]
            };
            vcService.is66VcOrLater(this.objectId).then(function (is66VcOrLater) {
                _this.is66VcOrLater = is66VcOrLater;
            });
            // show or hide remediation error banner based on the remediation task result
            this.$scope.$on("hostProfileRemediationErrorsEvent", function (event, showBanner) {
                _this.remediationErrorBannerVisible = showBanner;
            });
        }
        // Used to force refresh of the data in the child component (changing the reference triggers ngOnChanges in
        // host-profile-host-settings-details)
        HostProfileComplianceController.prototype.refresh65ComplianceFailures = function () {
            this.selectedItemId = new String(this.selectedItemId);
        };
        HostProfileComplianceController.prototype.onDataReceived = function (data) {
            this.gridData = data;
            this.removeRemediationErrorsBanner(data);
        };
        HostProfileComplianceController.prototype.onFocusGridRow = function (focusedItem) {
            this.focusedItem = focusedItem;
            if (focusedItem) {
                this.selectedItemId = this.defaultUriSchemeUtil.getVsphereObjectId(focusedItem.provider);
            }
        };
        HostProfileComplianceController.prototype.onRefreshActionInvoked = function (event) {
            this.refreshContent();
        };
        // show the remediation error banner if the remediation task finish fails
        HostProfileComplianceController.prototype.showRemediationErrorBanner = function (event) {
            if (event === true && !this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        // hide the remediation error banner if the remediation task finish successfully
        HostProfileComplianceController.prototype.hideRemediationErrorBanner = function (event) {
            if (event === false && this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        HostProfileComplianceController.prototype.onComplianceExpanded = function () {
            this.isComplianceExpanded = true;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "400px");
            if (compliancePanel.height() < 400) {
                splitter.size(compliancePanel, "400px");
            }
        };
        HostProfileComplianceController.prototype.onComplianceCollapsed = function () {
            this.isComplianceExpanded = false;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "240px");
        };
        HostProfileComplianceController.prototype.getSplitterHolderClass = function () {
            return this.isComplianceExpanded ?
                "splitter-holder-compliance-expanded" :
                "splitter-holder-compliance-collapsed";
        };
        HostProfileComplianceController.prototype.getCompliancePanel = function () {
            return this.$element.find(".profile-compliance-failure-section");
        };
        HostProfileComplianceController.prototype.getSplitter = function () {
            return this.$element.find("[kendo-splitter]")
                .data("kendoSplitter");
        };
        HostProfileComplianceController.prototype.getComplianceTitle = function () {
            var placeholder = "";
            if (this.focusedItem) {
                placeholder = this.focusedItem.hostName;
            }
            return this.i18nService.getString("HostProfileUi", "compliance.status.labelWithPlaceholder", placeholder);
        };
        HostProfileComplianceController.prototype.refreshContent = function () {
            if (this.attachDetachViewHeaderAccessor &&
                this.attachDetachViewHeaderAccessor.refresh) {
                this.attachDetachViewHeaderAccessor.refresh();
                // Used to force refresh of the data in the child component (changing the reference triggers ngOnChanges in
                // host-profile-hosts-compliance)
                this.objectId = new String(this.objectId);
            }
        };
        // if no hosts are attached to the host profile the remediation errors banner should be hidden
        // and related local storage data removed
        HostProfileComplianceController.prototype.removeRemediationErrorsBanner = function (data) {
            if (!data || (data && data.length === 0)) {
                this.remediationErrorBannerVisible = false;
                this.clearRemediationErrorsLocalStorage();
            }
        };
        HostProfileComplianceController.prototype.clearRemediationErrorsLocalStorage = function () {
            var _this = this;
            var key = this.REMEDIATION_RESULT_KEY + this.objectId;
            this.localStorageService.getUserData(key)
                .then(function (remediationErrors) {
                if (remediationErrors) {
                    _this.localStorageService.removeUserData(key);
                }
            });
        };
        HostProfileComplianceController.prototype.getHostComplianceCount = function (data) {
            if (data) {
                this.hostsCompliance = {
                    numberOfCompliantHosts: data.compliantHostCount,
                    numberOfNonCompliantHosts: data.nonCompliantHostCount,
                    numberOfUnknownHosts: data.unknownCompliantHostCount
                };
            }
            else {
                this.hostsCompliance = null;
            }
        };
        HostProfileComplianceController.$inject = [
            "$scope",
            "$element",
            "i18nService",
            "clusterHostProfileSettingsService",
            "vcService",
            "defaultUriSchemeUtil",
            "dataService",
            "localStorageService"];
        return HostProfileComplianceController;
    }());
    angular
        .module("com.vmware.vsphere.client.hostprofile")
        .controller("HostProfileComplianceController", HostProfileComplianceController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var ReadHostCustomizationsSpec = com.vmware.vsphere.client.hostprofile.data.h5.ReadHostCustomizationsSpec;
    var RemediateHostManager = (function () {
        function RemediateHostManager(dataService, hostCustomizationsService) {
            this.dataService = dataService;
            this.hostCustomizationsService = hostCustomizationsService;
        }
        RemediateHostManager.prototype.setTargetUid = function (targetUid) {
            this.targetUid = targetUid;
        };
        RemediateHostManager.prototype.getTargetUid = function () {
            return this.targetUid;
        };
        RemediateHostManager.prototype.getAssociatedHostProfile = function () {
            return this.dataService.getProperties(this.targetUid, ["associatedHostProfile"]);
        };
        RemediateHostManager.prototype.getHostCustomizations = function (associatedHostProfile) {
            var spec = new ReadHostCustomizationsSpec();
            spec.hostProfile = associatedHostProfile;
            spec.isNewlyAssociatedProfile = false;
            return this.hostCustomizationsService.getHostCustomizations(this.targetUid, spec);
        };
        RemediateHostManager.prototype.setRemediationSpec = function (remediationSpec) {
            this.remediationSpec = remediationSpec;
        };
        RemediateHostManager.prototype.getRemediationSpec = function () {
            return this.remediationSpec;
        };
        RemediateHostManager.prototype.setRebootHosts = function (rebootHosts) {
            this.rebootHosts = rebootHosts;
        };
        RemediateHostManager.prototype.getRebootHosts = function () {
            return this.rebootHosts;
        };
        RemediateHostManager.$inject = ["dataService", "hostCustomizationsService"];
        return RemediateHostManager;
    }());
    hostprofile_ui.RemediateHostManager = RemediateHostManager;
    angular.module("com.vmware.vsphere.client.hostprofile")
        .factory("RemediateHostManager", [
        "dataService",
        "hostCustomizationsService",
        function () {
            return Function.prototype.bind.apply(RemediateHostManager, [undefined, arguments[0], arguments[1]]);
        }
    ]);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var RemediateHostPageController = (function () {
        function RemediateHostPageController($scope, remediateHostPageService, dataService, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.remediateHostPageService = remediateHostPageService;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.hidePrecheckButton = false;
            this.remediationSpec = {};
            this.loading = false;
            this.rebootHosts = true;
            this.manager = this.$scope.manager;
            this.manager.setRebootHosts(this.rebootHosts);
            this.wizardConfig = this.$scope.wizardConfig;
            this.wizardConfig.loading = false;
            this.signPostConfig = {
                message: this.buildSignPostMessage(),
                title: this.i18nService.getString("HostProfileUi", "remediateHostWizard.readyToCompletePage.infoDialogTitle"),
            };
            $scope.$watch(function () {
                if (_this.rebootHosts) {
                    return _this.rebootHosts;
                }
                return undefined;
            }, function (newState, oldState) {
                if (oldState !== newState) {
                    _this.manager.setRebootHosts(_this.rebootHosts);
                }
            });
        }
        RemediateHostPageController.prototype.precheckRemediation = function () {
            var _this = this;
            this.hidePrecheckButton = true;
            var hostId = this.$scope.manager.getTargetUid();
            this.wizardConfig.loading = true;
            this.dataService
                .getProperties(hostId, ["remediatePreCheckedData"])
                .then(function (response) {
                var tree = response.remediatePreCheckedData.remediateTree;
                _this.treeListOptions = _this.remediateHostPageService.getTreeListOptions(tree);
                _this.remediationSpec = response.remediatePreCheckedData.remediationSpec;
                _this.manager.setRemediationSpec(_this.remediationSpec);
                _this.wizardConfig.loading = false;
            });
        };
        RemediateHostPageController.prototype.buildSignPostMessage = function () {
            var rebootRequiredInfo = this.i18nService.getString("HostProfileUi", "remediateHostWizard.readyToCompletePage.infoDialogMessageRequireReboot");
            var infoDialogMessage = this.i18nService.getString("HostProfileUi", "remediateHostWizard.readyToCompletePage.infoDialogMessageCheckBox");
            return rebootRequiredInfo + "<br>" + infoDialogMessage;
        };
        RemediateHostPageController.$inject = [
            "$scope",
            "remediateHostPageService",
            "dataService",
            "i18nService"
        ];
        return RemediateHostPageController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("RemediateHostPageController", RemediateHostPageController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var RemediateHostPageServiceImpl = (function () {
        function RemediateHostPageServiceImpl(i18nService, vuiRemediateHostWizard, defaultUriSchemeUtil, mutationService, vuiConstants, columnRenderersRegistry, dataService) {
            this.i18nService = i18nService;
            this.vuiRemediateHostWizard = vuiRemediateHostWizard;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.dataService = dataService;
            this.iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("icon-text");
        }
        RemediateHostPageServiceImpl.prototype.build = function (wizardScope, manager) {
            var _this = this;
            return {
                title: this.getString("remediateHostWizard.reviewRemediateTasksList.title"),
                description: this.getString("remediateHostWizard.reviewRemediateTasksList.description"),
                contentUrl: "hostprofile-ui/resources/hostprofile/remediate/remediateHostPage.html",
                onCommit: function () {
                    var remediateSpec = manager.getRemediationSpec();
                    if (remediateSpec) {
                        remediateSpec.rebootHosts = manager.getRebootHosts();
                        _this.mutationService.applyOnMultiEntity([manager.getTargetUid()], "com.vmware.vsphere.client.hostprofile.data.RemediationSpec", remediateSpec);
                    }
                    else {
                        _this.dataService
                            .getProperties(manager.getTargetUid(), ["remediatePreCheckedData"])
                            .then(function (response) {
                            var remediateSpec = response.remediatePreCheckedData.remediationSpec;
                            remediateSpec.rebootHosts = manager.getRebootHosts();
                            _this.mutationService.applyOnMultiEntity([manager.getTargetUid()], "com.vmware.vsphere.client.hostprofile.data.RemediationSpec", remediateSpec);
                        });
                    }
                    return true;
                },
                finishReady: function () {
                    return !wizardScope.wizardConfig.loading;
                }
            };
        };
        RemediateHostPageServiceImpl.prototype.precheckRemediation = function (hostId, hostCustomizations) {
            return this.mutationService.validate([hostId], "com.vmware.vsphere.client.hostprofile.data.PreRemediationSpec", {
                hosts: [this.defaultUriSchemeUtil.getManagedObjectReference(hostId)],
                hostCustomizations: hostCustomizations
            });
        };
        ;
        RemediateHostPageServiceImpl.prototype.getTreeListOptions = function (data) {
            return {
                dataSource: this.createRemediateTreeDataSource(data),
                sortable: true,
                resizable: false,
                columns: this.getColumnDefs(),
                height: "252px",
                selectable: "row"
            };
        };
        RemediateHostPageServiceImpl.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    title: this.getString("remediateHostWizard.readyToCompletePage.entityNameColumn"),
                    template: function (dataItem) {
                        return _this.iconTextRenderer(["hostIcon", "hostName"], dataItem);
                    }
                },
                {
                    title: this.getString("remediateHostWizard.readyToCompletePage.stateColumn"),
                    template: function (dataItem) {
                        return _this.iconTextRenderer(["descriptionIcon", "description"], dataItem);
                    }
                }
            ];
        };
        RemediateHostPageServiceImpl.prototype.createRemediateTreeDataSource = function (data) {
            var dataSource = new kendo.data.TreeListDataSource({
                data: data,
                schema: {
                    model: {
                        id: "id",
                        expanded: false
                    }
                }
            });
            dataSource.read();
            return dataSource;
        };
        RemediateHostPageServiceImpl.prototype.getString = function (key) {
            return this.i18nService.getString("HostProfileUi", key);
        };
        RemediateHostPageServiceImpl.$inject = [
            "i18nService",
            "vuiRemediateHostWizard",
            "defaultUriSchemeUtil",
            "mutationService",
            "vuiConstants",
            "columnRenderersRegistry",
            "dataService"
        ];
        return RemediateHostPageServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("remediateHostPageService", RemediateHostPageServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var AttachHostProfileServiceImpl = (function () {
        function AttachHostProfileServiceImpl(defaultUriSchemeUtil, mutationService, dataService, clarityModalService, i18nService, columnRenderersRegistry, managedEntityConstants, vuiConstants) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.managedEntityConstants = managedEntityConstants;
            this.vuiConstants = vuiConstants;
            this.iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer("object-link");
        }
        AttachHostProfileServiceImpl.prototype.attachHostProfile = function (hostId, selectedItem) {
            return this.mutationService.apply(this.defaultUriSchemeUtil.getVsphereObjectId(selectedItem.provider), "com.vmware.vsphere.client.hostprofile.data.AttachEntitiesSpec", { entitiesToAttach: [this.defaultUriSchemeUtil.getManagedObjectReference(hostId)] });
        };
        AttachHostProfileServiceImpl.prototype.openModal = function (targetUid, attachHostProfile) {
            var _this = this;
            this.dataService.getProperties(targetUid, ["name"]).then(function (data) {
                var title = _this.getTitle(attachHostProfile, data.name);
                var modalOptions = {
                    title: title,
                    dialogData: {
                        objectId: targetUid
                    },
                    defaultButton: "submit",
                    contentTemplate: "hostprofile-ui/resources/hostprofile/attach/attachHostProfilePage.html",
                    size: "lg"
                };
                _this.clarityModalService.openOkCancelModal(modalOptions);
            });
        };
        AttachHostProfileServiceImpl.prototype.filterSettings = function (originalData, searchTerm, propertiesToSearchInFor) {
            var _this = this;
            var searchValue = searchTerm.toLowerCase();
            return _.filter(originalData, function (item) {
                return _this.isSearchValuePresentedInProperties(item, searchValue, propertiesToSearchInFor);
            });
        };
        AttachHostProfileServiceImpl.prototype.isSearchValuePresentedInProperties = function (item, searchItem, properties) {
            return _.some(properties, function (property) {
                var currentPropertyValue = item[property];
                return !_.isNull(currentPropertyValue) && currentPropertyValue.toLowerCase().indexOf(searchItem) >= 0;
            });
        };
        AttachHostProfileServiceImpl.prototype.getTitle = function (attachHostProfile, hostName) {
            return attachHostProfile ? this.i18nService.getString("HostProfileUi", "attachWizard.title.attachProfile", hostName) : this.i18nService.getString("HostProfileUi", "attachWizard.title.changeProfile", hostName);
        };
        AttachHostProfileServiceImpl.prototype.fetchData = function (targetUid) {
            var _this = this;
            // The default value of spec is for Host System; it can only be HostSystem or ClusterComputeResource
            var spec = "com.vmware.vsphere.client.h5.host.model.hostprofile.HostAttachHostProfileData";
            if (this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(targetUid).type === this.managedEntityConstants.CLUSTER) {
                spec = "com.vmware.vsphere.client.hostprofile.data.h5.ClusterAttachHostProfileHostData";
            }
            return this.dataService.getData(targetUid, spec)
                .then(function (data) { return _this.filterHostProfileData(data); });
        };
        AttachHostProfileServiceImpl.prototype.filterHostProfileData = function (data) {
            var _this = this;
            var filteredData = [];
            if (!data || (!data.associatedHostProfile && !data.compatibleHostProfileData)) {
                return filteredData;
            }
            if (data.associatedHostProfile) {
                var associatedHostProfileId_1 = this.defaultUriSchemeUtil.getVsphereObjectId(data.associatedHostProfile);
                filteredData = _.filter(data.compatibleHostProfileData, function (hostProfileItem) {
                    var hostProfileId = _this.defaultUriSchemeUtil.getVsphereObjectId(hostProfileItem.provider);
                    return hostProfileId !== associatedHostProfileId_1;
                });
            }
            else {
                filteredData = data.compatibleHostProfileData;
            }
            return filteredData;
        };
        AttachHostProfileServiceImpl.prototype.getGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                selectedItems: [],
                data: [],
                columnDefs: this.getColumnDefs(),
                height: "auto"
            };
        };
        AttachHostProfileServiceImpl.prototype.getColumnDefs = function () {
            var _this = this;
            return [
                {
                    displayName: this.i18nService.getString("HostProfileUi", "HostProfileSelection.column.profile"),
                    type: "string",
                    field: "name",
                    template: function (dataItem) {
                        return _this.iconTextRenderer([undefined, "name", "vsphere-icon-Host_Policy"], dataItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("HostProfileUi", "HostProfileSelection.column.description"),
                    field: "description",
                    type: "string"
                }
            ];
        };
        AttachHostProfileServiceImpl.$inject = ["defaultUriSchemeUtil",
            "mutationService",
            "dataService",
            "clarityModalService",
            "i18nService",
            "columnRenderersRegistry",
            "managedEntityConstants",
            "vuiConstants"];
        return AttachHostProfileServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("attachHostProfileService", AttachHostProfileServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var CreateHostProfileService = (function () {
        function CreateHostProfileService(i18nService, clarityModalService, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        CreateHostProfileService.prototype.openCreateHostProfileDialog = function (objectId, isExtractAction) {
            if (isExtractAction === void 0) { isExtractAction = true; }
            var dialogTitle = isExtractAction ? this.i18nService.getString("HostProfileUi", "createProfileTask.name") : this.i18nService.getString("HostProfileUi", "duplicateProfileTask.name");
            var modalOptions = {
                title: dialogTitle,
                subTitle: isExtractAction ? "" : {
                    objectId: objectId
                },
                dialogData: {
                    objectId: objectId,
                    isExtractAction: isExtractAction
                },
                defaultButton: "submit",
                contentTemplate: "hostprofile-ui/resources/hostprofile/create/createHostProfile.html",
                size: "lg"
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        CreateHostProfileService.prototype.getCreateProfileFromHostSpec = function (profileName, profileDescription, objectId) {
            return {
                _type: "com.vmware.vim.binding.vim.profile.host.HostProfile$HostBasedConfigSpec",
                name: profileName,
                annotation: profileDescription,
                enabled: true,
                useHostProfileEngine: true,
                host: this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(objectId)
            };
        };
        CreateHostProfileService.prototype.getDuplicateProfileSpec = function (profileName, profileDescription, objectId) {
            return {
                _type: "com.vmware.vsphere.client.hostprofile.data.h5.DuplicateHostProfileSpec",
                profileName: profileName,
                profileDescription: profileDescription,
                profileRef: this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(objectId)
            };
        };
        CreateHostProfileService.$inject = ["i18nService", "clarityModalService", "defaultUriSchemeUtil"];
        return CreateHostProfileService;
    }());
    hostprofile_ui.CreateHostProfileService = CreateHostProfileService;
    angular.module("com.vmware.vsphere.client.hostprofile").service("createHostProfileService", CreateHostProfileService);
})(hostprofile_ui || (hostprofile_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfileService = (function () {
        function HostProfileService(defaultUriSchemeUtil, i18nService, mutationService, dataService, clarityModalService, attachHostProfileService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.attachHostProfileService = attachHostProfileService;
        }
        HostProfileService.prototype.openDetachChangeHostProfileErrorDialog = function (hostName, detachHostProfile) {
            var title = detachHostProfile ?
                this.i18nService.getString("HostProfileUi", "detachProfile.title") :
                this.i18nService.getString("HostProfileUi", "attachWizard.title.changeProfile", hostName);
            var message = detachHostProfile ?
                this.i18nService.getString("HostProfileUi", "detachProfile.error", hostName) :
                this.i18nService.getString("HostProfileUi", "actionChangeHostPrifle.error", hostName);
            var modalOptions = {
                title: title,
                subTitle: {
                    text: hostName
                },
                message: message,
                icon: "icon-warning-32",
                submit: function () {
                },
                hideCancelButton: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        HostProfileService.prototype.openDetachHostProfileDialog = function (hostId, hostName) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("HostProfileUi", "detachProfile.title"),
                subTitle: {
                    text: hostName
                },
                message: this.i18nService.getString("HostProfileUi", "detachProfile.text"),
                icon: "icon-warning-32",
                submit: function () {
                    _this.detachHostProfileAction(hostId);
                },
                defaultButton: "close",
                saveButtonLabel: this.i18nService.getString("Common", "yes.label"),
                cancelButtonLabel: this.i18nService.getString("Common", "no.label")
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        HostProfileService.prototype.detachHostProfileAction = function (hostId) {
            var _this = this;
            this.dataService.getData(hostId, "com.vmware.vsphere.client.h5.host.model.hostprofile.HostAttachHostProfileData")
                .then(function (data) {
                if (data.associatedHostProfile && data.associatedHostProfile !== undefined) {
                    var associatedHostProfileId = _this.defaultUriSchemeUtil.getVsphereObjectId(data.associatedHostProfile);
                    _this.mutationService.apply(associatedHostProfileId, "com.vmware.vsphere.client.hostprofile.data.AttachEntitiesSpec", { entitiesToDetach: [_this.defaultUriSchemeUtil.getManagedObjectReference(hostId)] });
                }
            });
        };
        /**
         * Checks if a host is under cluster with associated host profile
         * and opens an error dialog or a dialog/wizard for detach/change host profile
         * @param hostId The id of the host
         * @param detachHostProfile if the function is called for detach
         * @param callback A callback which will be executed to open a dialog/wizard for
         * detaching/changing host profile for a host
         */
        HostProfileService.prototype.openDialog = function (hostId, callback, detachHostProfile) {
            var _this = this;
            this.dataService.getData(hostId, "com.vmware.vsphere.client.h5.host.model.hostprofile.HostAttachHostProfileData")
                .then(function (data) {
                if (data && data.associatedHostProfileForCluster) {
                    _this.openDetachChangeHostProfileErrorDialog(data.hostName, detachHostProfile);
                }
                else {
                    if (detachHostProfile) {
                        callback(hostId, data.hostName);
                    }
                    else {
                        callback(hostId, false);
                    }
                }
            });
        };
        HostProfileService.prototype.changeHostProfile = function (hostId) {
            this.openDialog(hostId, this.attachHostProfileService.openModal.bind(this.attachHostProfileService), false);
        };
        HostProfileService.prototype.detachHostProfile = function (hostId) {
            this.openDialog(hostId, this.openDetachHostProfileDialog.bind(this), true);
        };
        HostProfileService.prototype.openExportHostCustomizationsDialog = function (objectId) {
            var modalOptions = {
                title: this.i18nService.getString("HostProfileUi", "exportCustomizationsDialog.title"),
                subTitle: {
                    objectId: objectId
                },
                dialogData: {
                    objectId: objectId
                },
                defaultButton: "submit",
                submitButtonTitle: this.i18nService.getString("HostProfileUi", "saveButton.label"),
                contentTemplate: "hostprofile-ui/resources/hostprofile/customizations/exportHostCustomizations.html"
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        HostProfileService.prototype.openExportHostProfileDialog = function (objectId) {
            var modalOptions = {
                title: this.i18nService.getString("HostProfileUi", "exportProfile.warning.title"),
                subTitle: {
                    objectId: objectId
                },
                dialogData: {
                    objectId: objectId
                },
                defaultButton: "submit",
                submitButtonTitle: this.i18nService.getString("HostProfileUi", "saveButton.label"),
                contentTemplate: "hostprofile-ui/resources/hostprofile/export/exportHostProfile.html"
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        HostProfileService.$inject = [
            "defaultUriSchemeUtil",
            "i18nService",
            "mutationService",
            "dataService",
            "clarityModalService",
            "attachHostProfileService"
        ];
        return HostProfileService;
    }());
    hostprofile_ui.HostProfileService = HostProfileService;
    angular.module("com.vmware.vsphere.client.hostprofile").service("hostProfileService", HostProfileService);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var RemediateHostWizardServiceImpl = (function () {
        function RemediateHostWizardServiceImpl(remediateHostPageService, vuiRemediateHostWizard, RemediateHostManager, dataService, $rootScope) {
            this.remediateHostPageService = remediateHostPageService;
            this.vuiRemediateHostWizard = vuiRemediateHostWizard;
            this.RemediateHostManager = RemediateHostManager;
            this.dataService = dataService;
            this.$rootScope = $rootScope;
        }
        RemediateHostWizardServiceImpl.prototype.invokeWizard = function (targetUid) {
            var _this = this;
            var manager = new this.RemediateHostManager();
            manager.setTargetUid(targetUid);
            var wizardScope = this.$rootScope.$new();
            var pages = this.createWizardPages(wizardScope, manager);
            this.dataService
                .getProperties(targetUid, ["name"])
                .then(function (response) {
                if (response && response.name) {
                    var hostName = response.name;
                    _this.vuiRemediateHostWizard.show(pages, wizardScope, manager, hostName);
                }
            });
        };
        RemediateHostWizardServiceImpl.prototype.createWizardPages = function (wizardScope, manager) {
            var pages = [];
            pages.push(this.remediateHostPageService.build(wizardScope, manager));
            return pages;
        };
        RemediateHostWizardServiceImpl.$inject = [
            "remediateHostPageService",
            "vuiRemediateHostWizard",
            "RemediateHostManager",
            "dataService",
            "$rootScope"
        ];
        return RemediateHostWizardServiceImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("remediateHostWizardService", RemediateHostWizardServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var VuiRemediateHostWizardImpl = (function () {
        function VuiRemediateHostWizardImpl(wizardPageService, vuiWizardService, $rootScope, i18nService, mutationService) {
            this.wizardPageService = wizardPageService;
            this.vuiWizardService = vuiWizardService;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
        }
        VuiRemediateHostWizardImpl.prototype.show = function (pages, wizardScope, manager, hostName) {
            this.wizardConfig = {
                title: this.i18nService.getString("HostProfileUi", "remediateHostWizard.title", hostName),
                pages: this.wizardPageService.initializePageStates(pages),
                resizeMinHeight: 500,
                onFinish: function () {
                    return true;
                }
            };
            this.wizardScope = wizardScope;
            this.wizardScope.manager = manager;
            this.wizardScope.wizardConfig = this.wizardConfig;
            this.vuiWizardService({
                scope: this.wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        VuiRemediateHostWizardImpl.$inject = [
            "wizardPageService",
            "vuiWizardService",
            "$rootScope",
            "i18nService",
            "mutationService"
        ];
        return VuiRemediateHostWizardImpl;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .service("vuiRemediateHostWizard", VuiRemediateHostWizardImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var hostprofile_ui;
(function (hostprofile_ui) {
    var ClusterHostProfileSettingsController = (function () {
        function ClusterHostProfileSettingsController($scope, $element, i18nService, clusterHostProfileSettingsService, vcService, defaultUriSchemeUtil) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.i18nService = i18nService;
            this.clusterHostProfileSettingsService = clusterHostProfileSettingsService;
            this.vcService = vcService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.isComplianceExpanded = false;
            this.objectsToWatch = [];
            this.attachDetachViewHeaderAccessor = {};
            this.remediationErrorBannerVisible = false;
            this.splitterOptions = this.clusterHostProfileSettingsService.getSplitterOptions();
            this.objectId = this.$scope._route.objectId;
            this.focusedItem = null;
            this.objectsToWatch = [this.objectId];
            this.headerOptions = this.clusterHostProfileSettingsService.getHeaderOptions(this.objectId);
            this.liveRefreshProperties = ["configStatus", "complianceCheckState",
                "remediationState", "answerFileValidationState"];
            vcService.is66VcOrLater(this.objectId).then(function (is66VcOrLater) {
                _this.is66VcOrLater = is66VcOrLater;
            });
            this.$scope.$on("hostProfileRemediationErrorsEvent", function (event, showBanner) {
                _this.remediationErrorBannerVisible = showBanner;
            });
        }
        ClusterHostProfileSettingsController.prototype.onDataReceived = function (data) {
            this.gridData = data;
        };
        // Used to force refresh of the data in the child component (changing the reference triggers ngOnChanges in
        // host-profile-host-settings-details)
        ClusterHostProfileSettingsController.prototype.refresh65ComplianceFailures = function () {
            this.selectedItemId = new String(this.selectedItemId);
        };
        ClusterHostProfileSettingsController.prototype.onFocusGridRow = function (focusedItem) {
            this.focusedItem = focusedItem;
            if (focusedItem) {
                this.selectedItemId = this.defaultUriSchemeUtil.getVsphereObjectId(focusedItem.provider);
            }
        };
        ClusterHostProfileSettingsController.prototype.onComplianceExpanded = function () {
            this.isComplianceExpanded = true;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "400px");
            if (compliancePanel.height() < 400) {
                splitter.size(compliancePanel, "400px");
            }
        };
        ClusterHostProfileSettingsController.prototype.onComplianceCollapsed = function () {
            this.isComplianceExpanded = false;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "240px");
        };
        ClusterHostProfileSettingsController.prototype.getSplitterHolderClass = function () {
            return this.isComplianceExpanded ?
                "splitter-holder-compliance-expanded" :
                "splitter-holder-compliance-collapsed";
        };
        // show the remediation error banner if there are remediation errors persisted in the local storage
        ClusterHostProfileSettingsController.prototype.showRemediationErrorBanner = function (event) {
            if (event === true && !this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        // hide the remediation error banner if there are no remediation errors persisted in the local storage
        ClusterHostProfileSettingsController.prototype.hideRemediationErrorBanner = function (event) {
            if (event === false && this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        ClusterHostProfileSettingsController.prototype.getCompliancePanel = function () {
            return this.$element.find(".profile-compliance-failure-section");
        };
        ClusterHostProfileSettingsController.prototype.getSplitter = function () {
            return this.$element.find("[kendo-splitter]")
                .data("kendoSplitter");
        };
        ClusterHostProfileSettingsController.prototype.getComplianceTitle = function () {
            var placeholder = "";
            if (this.focusedItem) {
                placeholder = this.focusedItem.hostName;
            }
            return this.i18nService.getString("HostProfileUi", "compliance.status.labelWithPlaceholder", placeholder);
        };
        ClusterHostProfileSettingsController.prototype.refreshContent = function () {
            if (this.attachDetachViewHeaderAccessor &&
                this.attachDetachViewHeaderAccessor.refresh) {
                this.attachDetachViewHeaderAccessor.refresh();
            }
        };
        ClusterHostProfileSettingsController.$inject = [
            "$scope",
            "$element",
            "i18nService",
            "clusterHostProfileSettingsService",
            "vcService",
            "defaultUriSchemeUtil"];
        return ClusterHostProfileSettingsController;
    }());
    angular
        .module("com.vmware.vsphere.client.hostprofile")
        .controller("ClusterHostProfileSettingsController", ClusterHostProfileSettingsController);
})(hostprofile_ui || (hostprofile_ui = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var hostprofile_ui;
(function (hostprofile_ui) {
    var ClusterHostProfileSettingsServiceImpl = (function () {
        function ClusterHostProfileSettingsServiceImpl(vuiConstants, i18nService, timeFormatterService, columnRenderersRegistry, defaultUriSchemeUtil, dataService, hostProfileConstants, mutationService) {
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.timeFormatterService = timeFormatterService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.hostProfileConstants = hostProfileConstants;
            this.mutationService = mutationService;
        }
        ClusterHostProfileSettingsServiceImpl.prototype.getGridOptions = function () {
            return {
                searchable: false,
                resizable: false,
                data: [],
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                columnDefs: this.getColumnDefs(),
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        ClusterHostProfileSettingsServiceImpl.prototype.processHostsCompliance = function (hosts) {
            var hostsCompliance = {
                numberOfCompliantHosts: 0,
                numberOfNonCompliantHosts: 0,
                numberOfUnknownHosts: 0
            };
            var compliance = this.hostProfileConstants.complianceStatus;
            _.each(hosts, function (host) {
                switch (host.complianceResult.complianceStatus) {
                    case compliance.compliant:
                        hostsCompliance.numberOfCompliantHosts += 1;
                        break;
                    case compliance.nonCompliant:
                        hostsCompliance.numberOfNonCompliantHosts += 1;
                        break;
                    case compliance.unknown:
                        hostsCompliance.numberOfUnknownHosts += 1;
                        break;
                }
            });
            return hostsCompliance;
        };
        ClusterHostProfileSettingsServiceImpl.prototype.getSplitterOptions = function () {
            return {
                panes: [{
                        min: "240px",
                        size: "50%"
                    }, {
                        min: "240px",
                        size: "50%"
                    }],
                orientation: this.vuiConstants.splitter.orientation.VERTICAL
            };
        };
        ClusterHostProfileSettingsServiceImpl.prototype.getHeaderOptions = function (headerObjectId) {
            return {
                objectId: headerObjectId,
                title: this.getString("cluster.monitor.compliance.host"),
                actions: [{
                        actionUid: "vsphere.core.hostProfile.actions.attachHostProfile",
                        customLabel: this.getString("attachHostProfileButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.cluster.detachHostProfile",
                        customLabel: this.getString("detachHostProfileClusterButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.changeHostProfile",
                        customLabel: this.getString("changeHostProfileButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.cluster.checkHostProfileCompliance",
                        customLabel: this.getString("hostProfile.action.checkCompliance")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.cluster.remediateMultipleHosts",
                        customLabel: this.getString("actionRemediateHostLabel")
                    }]
            };
        };
        ClusterHostProfileSettingsServiceImpl.prototype.getColumnDefs = function () {
            var _this = this;
            return [{
                    displayName: this.getString("HostCompliance.column.hostLabel"),
                    field: "hostName",
                    template: function (dataItem) {
                        var hostRef = _this.defaultUriSchemeUtil
                            .getVsphereObjectId(dataItem.provider);
                        var objectLinkRenderer = _this.columnRenderersRegistry
                            .getColumnRenderer("object-link");
                        return objectLinkRenderer(["hostRef", "hostName", "vsphere-icon-host"], {
                            hostRef: hostRef,
                            hostName: dataItem.hostName
                        });
                    }
                }, {
                    displayName: this.getString("HostCompliance.column.hostProfileComplianceLabel"),
                    field: "complianceResult.complianceStatus",
                    template: function (dataItem) {
                        var compliance = _this.hostProfileConstants.complianceStatus;
                        var icon = "vsphere-icon-status-unknown";
                        var text = _this.getString("hpCompliance.unknown");
                        if (dataItem.complianceResult.complianceStatus === compliance.compliant) {
                            icon = "vx-icon-statusCompliant";
                            text = _this.getString("hpCompliance.compliant");
                        }
                        else if (dataItem.complianceResult.complianceStatus === compliance.nonCompliant) {
                            icon = "vx-icon-statusNotCompliant";
                            text = _this.getString("hpCompliance.notCompliant");
                        }
                        var iconTextRenderer = _this.columnRenderersRegistry
                            .getColumnRenderer("icon-text");
                        return iconTextRenderer(["icon", "text"], { icon: icon, text: text });
                    }
                }, {
                    displayName: this.getString("HostCompliance.column.lastChecked"),
                    field: "complianceResult.checkTime",
                    template: function (dataItem) {
                        var text = _this.timeFormatterService
                            .timestampToText(dataItem.complianceResult.checkTime);
                        var textRenderer = _this.columnRenderersRegistry
                            .getColumnRenderer("text");
                        return textRenderer(['text'], { text: text });
                    }
                }];
        };
        ClusterHostProfileSettingsServiceImpl.prototype.requestHostComplianceData = function (host) {
            return this.dataService
                .getData(host, "com.vmware.vsphere.client.hostprofile.data.h5.HostProfileComplianceFailuresData");
        };
        ClusterHostProfileSettingsServiceImpl.prototype.requestHostProfileSummary = function (objectId) {
            return this.dataService.getProperties(objectId, ["associatedHostProfileSummary"]);
        };
        ClusterHostProfileSettingsServiceImpl.prototype.requestClusterHostProfileComplianceDetails = function (objectId) {
            return this.dataService.getData(objectId, "com.vmware.vsphere.client.hostprofile.data.h5.ClusterHostProfileComplianceDetails");
        };
        ClusterHostProfileSettingsServiceImpl.prototype.getString = function (key) {
            return this.i18nService.getString("HostProfileUi", key);
        };
        ClusterHostProfileSettingsServiceImpl.prototype.detachHostProfileFromCluster = function (clusterId) {
            this.mutationService.applyOnMultiEntity([clusterId], "com.vmware.vsphere.client.hostprofile.data.DetachEntitiesSpec", {});
        };
        ClusterHostProfileSettingsServiceImpl.$inject = [
            "vuiConstants",
            "i18nService",
            "timeFormatterService",
            "columnRenderersRegistry",
            "defaultUriSchemeUtil",
            "dataService",
            "HostProfileConstants",
            "mutationService",
        ];
        return ClusterHostProfileSettingsServiceImpl;
    }());
    angular
        .module("com.vmware.vsphere.client.hostprofile")
        .service("clusterHostProfileSettingsService", ClusterHostProfileSettingsServiceImpl);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var ReadHostCustomizationsSpec = com.vmware.vsphere.client.hostprofile.data.h5.ReadHostCustomizationsSpec;
    var HostHostProfileSettingsController = (function () {
        function HostHostProfileSettingsController($scope, hostProfileSettingsService, i18nService, $q, $element, dataService, hostCustomizationsService, defaultUriSchemeUtil, vcService, timeFormatterService, vuiConstants, localStorageService) {
            var _this = this;
            this.$scope = $scope;
            this.hostProfileSettingsService = hostProfileSettingsService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.$element = $element;
            this.dataService = dataService;
            this.hostCustomizationsService = hostCustomizationsService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vcService = vcService;
            this.timeFormatterService = timeFormatterService;
            this.vuiConstants = vuiConstants;
            this.localStorageService = localStorageService;
            this.REMEDIATION_RESULT_KEY = "remediationTaskErrorResult_";
            this.isComplianceExpanded = false;
            this.complianceStatus = {};
            this.attachDetachViewHeaderAccessor = {};
            this.remediationErrorBannerVisible = false;
            this.splitterOptions = {
                panes: [{
                        min: "200px",
                        size: "50%"
                    }, {
                        min: "200px",
                        size: "50%"
                    }],
                orientation: this.vuiConstants.splitter.orientation.VERTICAL
            };
            this.loadingCustomizationsData = false;
            this.objectId = this.$scope._route.objectId;
            this.objectsToWatch = [this.objectId];
            this.liveRefreshProperties = ["configStatus", "complianceStatus",
                "entity", "remediationState", "complianceCheckState",
                "answerFileValidationResult", "answerFileValidationState"];
            this.headerOptions = this.hostProfileSettingsService.getHeaderOptions(this.objectId);
            this.customizationsHeaderOptions = this.hostProfileSettingsService.getCustomizationHeaderOptions(this.objectId);
            this.hostProfileNameHeaderText = this.i18nService.getString("HostUi", "hostProfileNameHeaderText");
            this.datagridOptions = this.hostProfileSettingsService.getDatagridOptions();
            this.hostCustomizationsTitle = this.i18nService.getString("HostProfileUi", "host.manage.settings.hostProfile.hostCustomization");
            this.complianceFailureTitle = this.i18nService.getString("HostProfileUi", "HostCompliance.treeView.title");
            vcService.is65VcOrLater(this.objectId).then(function (is65VcOrLater) {
                _this.is65VcOrLater = is65VcOrLater;
            });
            vcService.is66VcOrLater(this.objectId).then(function (is66VcOrLater) {
                _this.is66VcOrLater = is66VcOrLater;
                _this.getUserTimeFormatAndSetData();
            });
            this.$scope.$on("hostProfileRemediationErrorsEvent", function (event, showBanner) {
                _this.remediationErrorBannerVisible = showBanner;
            });
        }
        ;
        HostHostProfileSettingsController.prototype.onComplianceExpanded = function () {
            this.isComplianceExpanded = true;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "400px");
            if (compliancePanel.height() < 400) {
                splitter.size(compliancePanel, "400px");
            }
        };
        HostHostProfileSettingsController.prototype.onComplianceCollapsed = function (subractHeight) {
            this.isComplianceExpanded = false;
            var compliancePanel = this.getCompliancePanel();
            var splitter = this.getSplitter();
            splitter.min(compliancePanel, "200px");
            var complianceGrid = compliancePanel.find("host-profile-host-settings-details");
            var compliancePanelSize = Math.max(200, compliancePanel.height() - complianceGrid.height());
            splitter.size(compliancePanel, compliancePanelSize + "px");
        };
        HostHostProfileSettingsController.prototype.getSplitterHolderClass = function () {
            return this.isComplianceExpanded ?
                "splitter-holder-compliance-expanded" :
                "splitter-holder-compliance-collapsed";
        };
        // show the remediation error banner if there are remediation errors persisted in the local storage
        HostHostProfileSettingsController.prototype.showRemediationErrorBanner = function (event) {
            if (event === true && !this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        // hide the remediation error banner if there are no remediation errors persisted in the local storage
        HostHostProfileSettingsController.prototype.hideRemediationErrorBanner = function (event) {
            if (event === false && this.remediationErrorBannerVisible) {
                this.remediationErrorBannerVisible = event;
            }
        };
        HostHostProfileSettingsController.prototype.getCompliancePanel = function () {
            return this.$element.find(".host-profile-host-settings-section");
        };
        HostHostProfileSettingsController.prototype.getSplitter = function () {
            return this.$element.find("[kendo-splitter]")
                .data("kendoSplitter");
        };
        HostHostProfileSettingsController.prototype.getData = function () {
            var _this = this;
            this.hostProfileSettingsService
                .getHostProfileSummary(this.objectId, this.is66VcOrLater)
                .then(function (profileSummary) { return _this.setSummaryData(profileSummary); })
                .then(function (hostProfileSummary) { return _this.hostProfileSettingsService.formatHostProfile(hostProfileSummary); })
                .then(function (hostProfile) { return _this.setHostProfile(hostProfile); })
                .then(function (hostProfile) {
                _this.objectsToWatch = [_this.objectId];
                var hostProfileId = _this.hostProfile ? _this.defaultUriSchemeUtil.getVsphereObjectId(_this.hostProfile.profile) : null;
                _this.hostProfileId = hostProfileId;
                // added hostProfileId in objectsToWatch for 6.0 VCs because we don't get updates on the host when profile is detached
                // for VCs 6.5 and later that would lead to constant live refreshes thus the version check
                if (_this.hostProfile && !_this.is65VcOrLater) {
                    _this.objectsToWatch.push(hostProfileId);
                }
                _this.getHostCustomizationsData(hostProfile);
            });
        };
        HostHostProfileSettingsController.prototype.setSummaryData = function (profileSummary) {
            var associatedHostProfileSummaryPromise;
            if (profileSummary && profileSummary.associatedHostProfileSummary) {
                var complianceData = this.hostProfileSettingsService.extractComplianceDataFromProfileSummary(profileSummary, this.userTimeFormat);
                this.complianceStatus = complianceData.complianceStatus;
                this.complianceStatusFormatted = complianceData.complianceStatusCheckTimeFormatted;
                this.showComplianceFailures = complianceData.showComplianceFailures;
                this.showLastCheckedTime = complianceData.showLastCheckedTime;
                associatedHostProfileSummaryPromise = this.$q.when(profileSummary.associatedHostProfileSummary);
                return associatedHostProfileSummaryPromise;
            }
        };
        HostHostProfileSettingsController.prototype.setHostProfile = function (hostProfile) {
            if (!_.isUndefined(this.hostProfile) && !_.isEqual(this.hostProfile, hostProfile)) {
                this.remediationErrorBannerVisible = false;
                this.clearRemediationErrorsLocalStorage();
            }
            this.hostProfile = hostProfile;
            return this.$q.when(hostProfile);
        };
        HostHostProfileSettingsController.prototype.clearRemediationErrorsLocalStorage = function () {
            var _this = this;
            var key = this.REMEDIATION_RESULT_KEY + this.objectId;
            this.localStorageService.getUserData(key)
                .then(function (remediationErrors) {
                if (remediationErrors) {
                    _this.localStorageService.removeUserData(key);
                }
            });
        };
        HostHostProfileSettingsController.prototype.populateDatagird = function (hostCustomizations) {
            this.datagridOptions.data = hostCustomizations;
        };
        HostHostProfileSettingsController.prototype.getHostCustomizationsData = function (hostProfile) {
            var _this = this;
            if (hostProfile && hostProfile.profile) {
                this.loadingCustomizationsData = true;
                var spec = new ReadHostCustomizationsSpec();
                spec.hostProfile = hostProfile.profile;
                spec.isNewlyAssociatedProfile = false;
                this.hostCustomizationsService
                    .getHostCustomizations(this.objectId, spec)
                    .then(function (hostCustomizationsData) {
                    if (hostCustomizationsData && hostCustomizationsData.length > 0) {
                        var hostCustomizations = hostCustomizationsData[0].result;
                        if (!hostCustomizations) {
                            hostCustomizations = [];
                        }
                        _this.populateDatagird(hostCustomizations);
                    }
                    _this.loadingCustomizationsData = false;
                });
            }
        };
        HostHostProfileSettingsController.prototype.refreshContent = function () {
            this.getUserTimeFormatAndSetData();
            if (this.attachDetachViewHeaderAccessor &&
                this.attachDetachViewHeaderAccessor.refresh) {
                this.attachDetachViewHeaderAccessor.refresh();
            }
        };
        HostHostProfileSettingsController.prototype.getUserTimeFormatAndSetData = function () {
            var _this = this;
            this.timeFormatterService.getUserTimeFormatPreference()
                .then(function (response) {
                _this.userTimeFormat = response;
                _this.getData();
            });
        };
        HostHostProfileSettingsController.$inject = [
            "$scope",
            "hostHostProfileSettingsService",
            "i18nService",
            "$q",
            "$element",
            "dataService",
            "hostCustomizationsService",
            "defaultUriSchemeUtil",
            "vcService",
            "timeFormatterService",
            "vuiConstants",
            "localStorageService"];
        return HostHostProfileSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("HostHostProfileSettingsController", HostHostProfileSettingsController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostHostProfileSettingsService = (function () {
        function HostHostProfileSettingsService(i18nService, $q, dataService, timeFormatterService, defaultUriSchemeUtil, mutationService, $rootScope, columnRenderersRegistry, constants, hostProfileComplianceService, hostProfileConstants) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.dataService = dataService;
            this.timeFormatterService = timeFormatterService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.$rootScope = $rootScope;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.constants = constants;
            this.hostProfileComplianceService = hostProfileComplianceService;
            this.hostProfileConstants = hostProfileConstants;
        }
        HostHostProfileSettingsService.prototype.getHeaderOptions = function (objectId) {
            return {
                title: this.i18nService.getString("HostUi", "hostProfileNameHeaderText"),
                objectId: objectId,
                actions: [{
                        actionUid: "vsphere.core.hostProfile.actions.attachHostProfile",
                        customLabel: this.i18nService.getString("HostProfileUi", "attachHostProfileButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.detachHostProfile",
                        customLabel: this.i18nService.getString("HostProfileUi", "detachHostProfileButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.changeHostProfile",
                        customLabel: this.i18nService.getString("HostProfileUi", "changeHostProfileButton.label")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.checkHostProfileCompliance",
                        customLabel: this.i18nService.getString("HostProfileUi", "hostProfile.action.checkCompliance")
                    }, {
                        actionUid: "vsphere.core.hostProfile.actions.remediateHost",
                        customLabel: this.i18nService.getString("HostProfileUi", "actionRemediateHostLabel")
                    }]
            };
        };
        HostHostProfileSettingsService.prototype.getCustomizationHeaderOptions = function (objectId) {
            return {
                title: this.i18nService.getString("HostProfileUi", "host.manage.settings.hostProfile.hostCustomization"),
                objectId: objectId,
                actions: [{
                        actionUid: "vsphere.core.hostProfile.actions.editHostCustomizations",
                        customLabel: this.i18nService.getString("HostProfileUi", "actionEditHostCustomizationsLabel")
                    }]
            };
        };
        HostHostProfileSettingsService.prototype.getHostProfileSummary = function (objectId, isVc66OrLater) {
            var _this = this;
            var hostProfileSummaryDataPromise = null;
            if (!isVc66OrLater) {
                hostProfileSummaryDataPromise = this.dataService
                    .getProperties(objectId, ["associatedHostProfileSummary", "hostProfileCompliance"])
                    .then(function (data) { return _this.$q.when(data); });
            }
            else {
                hostProfileSummaryDataPromise = this.dataService
                    .getData(objectId, "com.vmware.vsphere.client.hostprofile.data.h5.model.H5HostProfileSettingsData")
                    .then(function (data) { return _this.$q.when(data); });
            }
            return hostProfileSummaryDataPromise;
        };
        HostHostProfileSettingsService.prototype.formatHostProfile = function (hostProfileSummary) {
            var defer = this.$q.defer();
            if (!hostProfileSummary) {
                defer.resolve("");
            }
            else {
                this.$q.all([
                    this.timeFormatterService.formatDate(hostProfileSummary.creationTime),
                    this.timeFormatterService.formatDate(hostProfileSummary.lastUpdateTime)
                ]).then(function (result) {
                    var createdAt = result[0];
                    var editedAt = result[1];
                    defer.resolve({
                        name: hostProfileSummary.name,
                        createdAt: createdAt,
                        editedAt: editedAt,
                        profile: hostProfileSummary.profile
                    });
                });
            }
            return defer.promise;
        };
        HostHostProfileSettingsService.prototype.getDatagridOptions = function () {
            var _this = this;
            var textRenderer = this.columnRenderersRegistry
                .getColumnRenderer("text");
            return {
                selectionMode: "single",
                sortMode: "single",
                searchable: true,
                resizable: true,
                columnDefs: [{
                        field: "name",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService.getString("HostUi", "hostCustomizations.column.propertyName"),
                        template: function (dataItem) {
                            return textRenderer(["name"], dataItem);
                        }
                    }, {
                        field: "description",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService.getString("HostUi", "hostCustomizations.column.path"),
                        template: function (dataItem) {
                            return textRenderer(["description"], dataItem);
                        }
                    }, {
                        field: "value",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService.getString("HostUi", "hostCustomizations.column.value"),
                        template: function (dataItem) {
                            var text;
                            if (dataItem.valueType === "password") {
                                text = _this.i18nService.getString("HostProfileUi", "hostCustomizations.maskedPassword");
                            }
                            else if (dataItem.value) {
                                text = dataItem.value;
                            }
                            else {
                                text = _this.i18nService.getString("HostUi", "settings.graphics.type.na");
                            }
                            return textRenderer(["text"], { "text": text });
                        }
                    }],
                data: [],
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        HostHostProfileSettingsService.prototype.isCompliant = function (hostCompliance) {
            var compliantValue = this.constants.complianceStatus.compliant;
            return hostCompliance &&
                hostCompliance.complianceStatus === compliantValue;
        };
        HostHostProfileSettingsService.prototype.isUnknown = function (hostCompliance) {
            var unknownValue = this.constants.complianceStatus.unknown;
            return hostCompliance &&
                (hostCompliance.complianceStatus === unknownValue ||
                    hostCompliance.complianceStatus === null);
        };
        HostHostProfileSettingsService.prototype.extractComplianceDataFromProfileSummary = function (profileSummary, userTimeFormat) {
            var hostCompliance = profileSummary.hostProfileCompliance;
            var complianceStatuses = this.hostProfileComplianceService.getStatuses();
            var complianceStatusKey = hostCompliance.complianceStatus;
            var complianceStatus = _.has(complianceStatuses, complianceStatusKey) ?
                complianceStatuses[complianceStatusKey] :
                complianceStatuses[this.hostProfileConstants.complianceStatus.unknown];
            var complianceStatusCheckTimeFormatted = this.timeFormatterService.timestampToText(hostCompliance.checkTime, userTimeFormat);
            var showComplianceFailures = !this.isCompliant(hostCompliance) &&
                !this.isUnknown(hostCompliance);
            var showLastCheckedTime = !!complianceStatusKey &&
                (this.hostProfileConstants.complianceStatus.unknown !== complianceStatusKey);
            return {
                complianceStatus: complianceStatus,
                complianceStatusCheckTimeFormatted: complianceStatusCheckTimeFormatted,
                showComplianceFailures: showComplianceFailures,
                showLastCheckedTime: showLastCheckedTime
            };
        };
        HostHostProfileSettingsService.$inject = [
            "i18nService",
            "$q",
            "dataService",
            "timeFormatterService",
            "defaultUriSchemeUtil",
            "mutationService",
            "$rootScope",
            "columnRenderersRegistry",
            "HostProfileConstants",
            "HostProfileComplianceService",
            "HostProfileConstants"
        ];
        return HostHostProfileSettingsService;
    }());
    hostprofile_ui.HostHostProfileSettingsService = HostHostProfileSettingsService;
    angular
        .module("com.vmware.vsphere.client.hostprofile")
        .service("hostHostProfileSettingsService", HostHostProfileSettingsService);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfileSettingsController = (function () {
        function HostProfileSettingsController($rootScope, $scope, $timeout, dataService, vuiConstants, i18nService, actionsService, $log, vcService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.dataService = dataService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.$log = $log;
            this.vcService = vcService;
            this.EDIT_PROFILE = "vsphere.core.hostProfile.actions.editHostProfile";
            this.CHANGE_HOST_PROFILE_REF = "vsphere.core.hostProfile.actions.changeRefHostAction";
            this.COPY_HOST_PROFILE_SETTINGS_FROM_HOST_PROFILE = "vsphere.core.hostProfile.actions.copySettingsFromHostProfile";
            this.profileDataLoading = false;
            this.profileValidating = false;
            this.showDropDown = false;
            this.showCopyDropDown = false;
            this.hostProfileId = this.$rootScope._route.objectId;
            this.objectsToWatch = [this.hostProfileId];
            this.liveRefreshProperties = ["config"];
            this.validationStateProperty = "validationState";
            this.actionUids = [this.EDIT_PROFILE, this.CHANGE_HOST_PROFILE_REF, this.COPY_HOST_PROFILE_SETTINGS_FROM_HOST_PROFILE];
            this.splitterOptions = {
                orientation: vuiConstants.splitter.orientation.HORIZONTAL,
                panes: [{
                        min: '200px',
                        size: '30%'
                    }, {
                        min: '400px',
                        size: '70%'
                    }]
            };
            this.vcService.is65VcOrLater(this.hostProfileId)
                .then(function (is65VcOrLater) {
                _this.is65VcOrLater = is65VcOrLater;
            });
            this.getInitialData();
            this.getIsValidating("initialization");
            this.evaluateActions();
            this.invokeActionThrottle =
                _.debounce(this.actionsService.invokeAction.bind(this.actionsService), 5000, true);
            this.$scope.$on("hostProfileEditedEvent", function (event, editedHostProfileId) {
                if (_this.hostProfileId === editedHostProfileId) {
                    _this.$log.debug("Scheduling validation check after receiving 'hostProfileEditedEvent'");
                    _this.profileValidating = true;
                    _this.$timeout(function () { return _this.getIsValidating("timeout"); }, 5000);
                }
            });
        }
        Object.defineProperty(HostProfileSettingsController.prototype, "loadingText", {
            get: function () {
                return this.profileValidating ?
                    this.i18nService.getString("HostProfileUi", "hostProfile.validating") : "";
            },
            enumerable: true,
            configurable: true
        });
        HostProfileSettingsController.prototype.evaluateActions = function () {
            var _this = this;
            this.actionsService.getActions(this.hostProfileId, this.actionUids)
                .then(function (actionEvaluations) {
                _this.actionToRenderMap = {};
                // Build actions to render items
                _.each(actionEvaluations, function (actionEvaluation) {
                    var actionUid = actionEvaluation.action.uid;
                    _this.actionToRenderMap[actionUid] = {
                        label: actionEvaluation.action.label,
                        actionId: actionEvaluation.action.uid,
                        isEnabled: actionEvaluation.available,
                        eval: actionEvaluation
                    };
                });
                var actionsToRender = [];
                _.each(_this.actionUids, function (actionUid) {
                    if (_this.actionToRenderMap[actionUid]) {
                        actionsToRender.push(_this.actionToRenderMap[actionUid]);
                    }
                });
                _this.actionsToRender = actionsToRender;
            });
        };
        HostProfileSettingsController.prototype.invokeAction = function (action) {
            this.invokeActionThrottle(action.eval, { selectedItemPath: this.selectedItemPath });
        };
        HostProfileSettingsController.prototype.invokeEditAction = function (action, type) {
            this.invokeActionThrottle(action.eval, {
                selectedItemPath: this.selectedItemPath,
                editType: type
            });
        };
        HostProfileSettingsController.prototype.getInitialData = function () {
            var _this = this;
            this.profileDataLoading = true;
            this.dataService
                .getProperties(this.hostProfileId, ["hostApplyProfileData", "validationState"])
                .then(function (data) {
                _this.profileWrapper = data.hostApplyProfileData.result;
                _this.validationState = data.validationState;
                _this.profileDataLoading = false;
            });
        };
        HostProfileSettingsController.prototype.getData = function () {
            var _this = this;
            this.profileDataLoading = true;
            this.dataService
                .getProperties(this.hostProfileId, ["hostApplyProfileData"])
                .then(function (data) {
                _this.profileWrapper = data.hostApplyProfileData.result;
                _this.profileDataLoading = false;
            });
        };
        HostProfileSettingsController.prototype.refreshValidation = function () {
            this.getIsValidating("refresh");
            this.getValidationState();
        };
        HostProfileSettingsController.prototype.getIsValidating = function (caller) {
            var _this = this;
            this.dataService
                .getProperties(this.hostProfileId, ["isValidating"])
                .then(function (data) {
                _this.$log.debug("Resolved 'getIsValidating' returned " + data.isValidating + ". Invoked by: " + caller);
                _this.profileValidating = data.isValidating;
            });
        };
        HostProfileSettingsController.prototype.getValidationState = function () {
            var _this = this;
            this.dataService
                .getProperties(this.hostProfileId, ["validationState"])
                .then(function (data) {
                // validatonState is present only for VC 6.7 and later
                // so for earlier VC versions it would be unset and validation banner will not be shown
                _this.validationState = data.validationState;
            });
        };
        HostProfileSettingsController.prototype.invokeActionById = function (actionId) {
            if (this.actionToRenderMap) {
                var actionToInvoke = this.actionToRenderMap[actionId];
                this.actionsService.invokeAction(actionToInvoke.eval, { selectedItemPath: this.selectedItemPath });
            }
        };
        HostProfileSettingsController.prototype.isActionAvailable = function (actionId) {
            return this.actionToRenderMap && this.actionToRenderMap[actionId] && this.actionToRenderMap[actionId].isEnabled;
        };
        HostProfileSettingsController.prototype.isCopyAction = function (action) {
            return action && (this.isChangeHostReferenceAction(action) ||
                this.isCopyHostProfileAction(action));
        };
        HostProfileSettingsController.prototype.isChangeHostReferenceAction = function (action) {
            return this.CHANGE_HOST_PROFILE_REF === action.actionId;
        };
        HostProfileSettingsController.prototype.isCopyHostProfileAction = function (action) {
            return this.COPY_HOST_PROFILE_SETTINGS_FROM_HOST_PROFILE === action.actionId;
        };
        HostProfileSettingsController.$inject = [
            "$rootScope",
            "$scope",
            "$timeout",
            "dataService",
            "vuiConstants",
            "i18nService",
            "actionsService",
            "$log",
            "vcService"
        ];
        return HostProfileSettingsController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("HostProfileSettingsController", HostProfileSettingsController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var HostProfilesSummaryViewController = (function () {
        function HostProfilesSummaryViewController($scope, commonActionBarService, vuiConstants, i18nService) {
            var _this = this;
            this.$scope = $scope;
            this.commonActionBarService = commonActionBarService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.DUPLICATE_PROFILE = "vsphere.core.hostProfile.actions.duplicateProfile";
            this.CHANGE_REF_HOST = "vsphere.core.hostProfile.actions.changeRefHostAction";
            this.COPY_HOST_PROFILE_SETTINGS = "vsphere.core.hostProfile.actions.copySettingsToHostProfiles";
            this.EXPORT_PROFILE = "vsphere.core.hostProfile.actions.exportProfile";
            this.IMPORT_PROFILE = "vsphere.core.hostProfile.actions.importProfile";
            this.EXTRACT_HOST_PROFILE_FROM_A_HOST = "vsphere.core.hostProfile.actions.extractHostProfileFromAHost";
            this.DELETE_PROFILE = "vsphere.core.hostProfile.actions.deleteProfile";
            this.ACTION_BAR_ACTIONS = "actions";
            this.$scope.onSelectionChanged = function (newItems, oldItems) {
                _this.actionBarOptions.actions = [];
                _this.selectedProfiles = newItems;
                _this.createOrUpdateActionBar();
            };
            this.actionBarOptions = {
                actions: []
            };
            this.actionDefs = [
                {
                    actionId: this.EXTRACT_HOST_PROFILE_FROM_A_HOST,
                    customLabel: this.i18nService.getString("HostProfileUi", "action.extractHostProfileFromHost.label"),
                    hideIcon: true
                },
                {
                    actionId: this.IMPORT_PROFILE
                },
                this.vuiConstants.actions.SEPARATOR,
                {
                    actionId: this.DUPLICATE_PROFILE,
                    customLabel: this.i18nService.getString("HostProfileUi", "action.duplicateHostProfile.label"),
                    isActionAvailable: function (actionDef) {
                        return !_.isEmpty(_this.selectedProfiles) && actionDef.available;
                    },
                    hideIcon: true
                },
                {
                    actionId: this.CHANGE_REF_HOST,
                    customLabel: this.i18nService.getString("HostProfileUi", "actionChangeRefHostDescription"),
                    isActionAvailable: function (actionDef) {
                        return !_.isEmpty(_this.selectedProfiles) && actionDef.available;
                    },
                    hideIcon: true
                },
                {
                    actionId: this.COPY_HOST_PROFILE_SETTINGS,
                    customLabel: this.i18nService.getString("HostProfileUi", "actionCopyHostProfileSettingsDescription"),
                    isActionAvailable: function (actionDef) {
                        return !_.isEmpty(_this.selectedProfiles) && actionDef.available;
                    },
                    hideIcon: true
                },
                {
                    actionId: this.EXPORT_PROFILE,
                    isActionAvailable: function (actionDef) {
                        return !_.isEmpty(_this.selectedProfiles) && actionDef.available;
                    },
                    hideIcon: true
                },
                {
                    actionId: this.DELETE_PROFILE,
                    isActionAvailable: function (actionDef) {
                        return !_.isEmpty(_this.selectedProfiles) && actionDef.available;
                    },
                    hideIcon: true
                }
            ];
            this.createOrUpdateActionBar();
        }
        HostProfilesSummaryViewController.prototype.createOrUpdateActionBar = function () {
            this.commonActionBarService
                .updateActionBar(this.actionBarOptions, this.ACTION_BAR_ACTIONS, this.getProfilesIds(), this.actionDefs);
        };
        HostProfilesSummaryViewController.prototype.getProfilesIds = function () {
            return _.pluck(this.selectedProfiles, "id");
        };
        HostProfilesSummaryViewController.$inject = ["$scope", "commonActionBarService", "vuiConstants", "i18nService"];
        return HostProfilesSummaryViewController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("HostProfilesSummaryViewController", HostProfilesSummaryViewController);
})(hostprofile_ui || (hostprofile_ui = {}));



var hostprofile_ui;
(function (hostprofile_ui) {
    var RecentComplianceFailuresController = (function () {
        function RecentComplianceFailuresController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.objectId = this.$scope._route.objectId;
        }
        RecentComplianceFailuresController.$inject = ["$scope", "i18nService"];
        return RecentComplianceFailuresController;
    }());
    angular.module("com.vmware.vsphere.client.hostprofile")
        .controller("RecentComplianceFailuresController", RecentComplianceFailuresController);
})(hostprofile_ui || (hostprofile_ui = {}));





/* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This ts file has to be loaded first.
 */
var h5_vm;
(function (h5_vm) {
    h5 = h5 || {};
    h5.vm = {
        angularModule: angular.module("com.vmware.vsphere.client.vm", [
            "com.vmware.platform.ui", "com.vmware.vsphere.client.commonModule"])
    };
    /*
     * Registers vm-list specific column renderers.
     */
    angular.module("com.vmware.vsphere.client.vm")
        .run(["columnRenderersRegistry", "i18nService",
        function (columnRenderersRegistry, i18nService) {
            columnRenderersRegistry.registerColumnRenderers({
                /**
                 * Host name column - icon-link renderer.
                 *
                 * @param  {array} props Array of property names, where 1st property is
                 *    policy name. Other properties are ignored.
                 * @param  {object} data  Map of values, contains the specificType.
                 * @param {object} config A dictionary (key/value) to control the renderer behavior.
                 */
                "host-name": function (props, data, config) {
                    var objLinkRenderer = columnRenderersRegistry.getColumnRenderer("object-link");
                    var icon = "vsphere-icon-host";
                    if (data.hideHostIcon) {
                        icon = "";
                    }
                    return objLinkRenderer([props[0], props[1], icon], data, config);
                },
                /**
                 * Localizes detailedToolsVersionStatus and takes care if it is null.
                 * The localization consists of splitting the provided value (see
                 * VmListPropertyProvideAdapter#processDetailedToolsRunningStatus for
                 * some additional details) and localization of the resulting parts.
                 * @param  {array} props Array of property names, where 1st property is
                 * detailedToolsVersionStatus. Other properties are ignored
                 * @param  {object} data  Map of values, contains the detailedToolsVersionStatus.
                 */
                "detailed-tools-version-status": function (props, data) {
                    var displayText = "";
                    var value = data[props[0]];
                    if (value) {
                        var toolsVersionData = value.split("|", 2);
                        var toolsVersionStatusKey = toolsVersionData[0];
                        var toolsVersionId = toolsVersionData[1];
                        if (toolsVersionStatusKey === "0") {
                            displayText = i18nService.getString("VmUi", "guestToolsNA");
                        }
                        else {
                            if (!toolsVersionStatusKey) {
                                displayText = toolsVersionId;
                            }
                            else {
                                var toolsVersionStatusLocalized = i18nService.getString("VmUi", "tools." + toolsVersionStatusKey + ".text");
                                if (toolsVersionId === undefined || toolsVersionId === null) {
                                    displayText = toolsVersionStatusLocalized;
                                }
                                else {
                                    displayText = i18nService.getString("VmUi", "detailedToolsVersionStatus", toolsVersionId, toolsVersionStatusLocalized);
                                }
                            }
                        }
                    }
                    return "<div title=\"" + displayText + "\">" + displayText + "</div>";
                },
                /**
                 * Renders ha protection status icon and status label in a cell.
                 * @param  {array} props Array of property names, where 1st property is
                 * haProtected, 2nd is haProtectedLabel.@formatted
                 * @param  {object} data  Map of values, contains the ha protection status.
                 */
                "ha-protection-status": function (props, data) {
                    var haProtected = data[props[0]];
                    var label = data[props[1]] ? data[props[1]] : i18nService.getString("VmUi", "vmListItemData.na");
                    var iconClass = "vui-icon-datagrid-status-unknown";
                    if (haProtected === "true") {
                        iconClass = "vsphere-icon-status-ok";
                    }
                    else if (haProtected === "false") {
                        iconClass = "vsphere-icon-status-error";
                    }
                    return "<div class=\"object\" title=\"" + label +
                        "\"><i class=\"" + iconClass + "\"></i>" + label + "</div>";
                },
                /**
                 * Renders VM Storage Policies Compliance icon and status label in a cell.
                 * @param  {array} props Array of property names, where 1st property is
                 * pbmStorageComplStatusEx, 2nd is pbmStorageComplStatusLabel
                 * @param  {object} data  Map of values, contains the ha protection status.
                 */
                "storage-compliance-status": function (props, data) {
                    var complianceStatus = data[props[0]];
                    var label = data[props[1]] ? data[props[1]] : "";
                    var iconClass = "";
                    switch (complianceStatus) {
                        case "compliant":
                            iconClass = "vsphere-icon-status-ok";
                            break;
                        case "nonCompliant":
                        case "outOfDate":
                            iconClass = "vsphere-icon-status-error";
                            break;
                        case "unknown":
                            iconClass = "vui-icon-datagrid-status-unknown";
                            break;
                        case "notApplicable":
                            // TODO semerdzhievp add the following icon class in vui (col 8, row 3 in the sprite)
                            iconClass = "vui-icon-datagrid-status-notApplicable";
                            break;
                    }
                    return "<div class=\"object\" title=\"" + label +
                        "\"><i class=\"" + iconClass + "\"></i>" + label + "</div>";
                },
                /**
                 * is-present renderer, will display "Present" if data value is "true"
                 * otherwise "Not present"
                 *
                 * @param {array} props Array of property names
                 * @param {object} data  Map of values, contains whether a vm has a vtpm device.
                 */
                "is-present": function (props, data) {
                    var tpmPresent = !!data[props[0]];
                    var displayText = i18nService.getString("VmUi", "VmDeviceManager.TPMNotPresent");
                    if (tpmPresent) {
                        displayText = i18nService.getString("VmUi", "VmDeviceManager.TPMPresent");
                    }
                    return "<div title=\"" + displayText + "\">" + displayText + "</div>";
                },
                /**
                 * Renders the managing solution's icon and name if there is one that is managing the VM
                 * @param props Array of property names, where 1st property is
                 * managedByInfo - string the name of the solution, 2nd is managedByIcon16-
                 * an object that holds the base64 encoded string of the solution's icon
                 * @param data  the actual properties values
                 */
                "managed-by": function (props, data) {
                    var managedByLabel = _.escape(data[props[0]]);
                    var managedByIconData = data[props[1]];
                    if (managedByLabel && !_.isEmpty(managedByIconData) && managedByIconData.imageData) {
                        return '<span><img src="data:image/png;base64, ' +
                            managedByIconData.imageData +
                            '"/>' + managedByLabel + '</span>';
                    }
                    if (managedByLabel) {
                        return managedByLabel;
                    }
                    return "";
                }
            });
        }])
        .run([
        "$rootScope",
        "actionDialogService",
        "mutationService",
        "openConsoleService",
        "createVmWizardService",
        "powerOpsService",
        "creationTypeConstants",
        "migrateVmWizardService",
        "$window",
        "remoteConsoleService",
        "markAsTemplateService",
        "snapshotService",
        "vscExportWizardLauncherService",
        "i18nService",
        "dataService",
        "clarityModalService",
        "contentLibraryService",
        "upgradeVmHardwareService",
        "keyboardShortcutService",
        "vmToolsService",
        "defaultUriSchemeUtil",
        "managedEntityConstants",
        "moveVmService",
        "nameAndFolderValidatorService",
        "vmDragAndDropService",
        "vmRemovalService",
        "vmFtService",
        "createGuestOsCustomizationSpecWizardService",
        "editGuestOsCustomizationSpecDialogService",
        "fileSaverService",
        "deleteGosSpecService",
        "duplicateGosSpecService",
        "importGosSpecService",
        "ftVmService",
        "customizeGosPreCheckSpecsService",
        "customizeGosSelectSpecDialogService",
        "browserService",
        "unlockVmService",
        "$injector",
        function ($rootScope, actionDialogService, mutationService, openConsoleService, createVmWizardService, powerOpsService, creationTypeConstants, migrateVmWizardService, $window, remoteConsoleService, markAsTemplateService, snapshotService, vscExportWizardLauncherService, i18nService, dataService, clarityModalService, contentLibraryService, upgradeVmHardwareService, keyboardShortcutService, vmToolsService, defaultUriSchemeUtil, managedEntityConstants, moveVmService, nameAndFolderValidatorService, vmDragAndDropService, vmRemovalService, vmFtService, createGosSpecService, editGosSpecService, fileSaverService, deleteGosSpecService, duplicateGosSpecService, importGosSpecService, ftVmService, customizeGosPreCheckSpecsService, customizeGosSelectSpecDialogService, browserService, unlockVmService, $injector) {
            /*
             * Register the action invoker function in the h5.actions cache.
             */
            h5.actions["vsphere.core.vm.actions.editNotes"] = function (actionEval, availableTargets, context) {
                var onUpdateVmNotes = function (objectId, notesValue, operationName) {
                    var specType = "com.vmware.vsphere.client.vm.VmNotesSpec";
                    var propSpec = {
                        notes: notesValue
                    };
                    mutationService.apply(objectId, specType, propSpec, operationName);
                    return true;
                };
                var dialogData = {
                    notesPropName: "config.annotation",
                    onUpdateNotesCallback: onUpdateVmNotes,
                    focusTarget: context && context.focusTarget // trigger element
                };
                clarityModalService.openModal(actionEval, availableTargets, dialogData, "common-module-ui/resources/common-module/views/notes/NotesDialog.html");
            };
            keyboardShortcutService.bindAction("ctrl+alt+b", "vsphere.core.vm.powerOnAction");
            h5.actions["vsphere.core.vm.actions.powerOn"] = function (actionEval, availableTargets) {
                powerOpsService.powerOnVm(actionEval, availableTargets);
            };
            keyboardShortcutService.bindAction("ctrl+alt+t", "vsphere.core.vm.resetAction");
            h5.actions["vsphere.core.vm.actions.reset"] = function (actionEval, availableTargets) {
                powerOpsService.resetVMs(availableTargets);
            };
            keyboardShortcutService.bindAction("ctrl+alt+e", "vsphere.core.vm.powerOffAction");
            h5.actions["vsphere.core.vm.actions.powerOff"] = function (actionEval, availableTargets) {
                powerOpsService.powerOffVm(availableTargets);
            };
            keyboardShortcutService.bindAction("ctrl+alt+d", "vsphere.core.vm.shutdownGuestAction");
            h5.actions["vsphere.core.vm.actions.shutdownGuest"] = function (actionEval, availableTargets) {
                powerOpsService.shutdownGuest(availableTargets);
            };
            keyboardShortcutService.bindAction("ctrl+alt+r", "vsphere.core.vm.rebootGuestAction");
            h5.actions["vsphere.core.vm.actions.rebootGuest"] = function (actionEval, availableTargets) {
                powerOpsService.rebootGuest(availableTargets);
            };
            keyboardShortcutService.bindAction("ctrl+alt+z", "vsphere.core.vm.suspendAction");
            h5.actions["vsphere.core.vm.actions.suspend"] = function (actionEval, availableTargets) {
                powerOpsService.suspendVMs(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.installTools"] = function (actionEval, availableTargets) {
                clarityModalService.openModal(actionEval, availableTargets, {
                    objectId: availableTargets[0],
                    title: i18nService.getString("VmUi", "VmToolsPopupForm.singleInstall.title"),
                    defaultButton: "submit"
                }, "vm-ui/resources/vm/vmtools/vmInstallTools.html");
            };
            h5.actions["vsphere.core.vm.actions.upgradeTools"] = function (actionEval, availableTargets) {
                clarityModalService.openModal(actionEval, availableTargets, {
                    objectId: availableTargets[0],
                    title: i18nService.getString("VmUi", "VmToolsPopupForm.singleUpgrade.title"),
                    defaultButton: "submit"
                }, "vm-ui/resources/vm/vmtools/vmUpgradeTools.html");
            };
            h5.actions["vsphere.core.vm.actions.unmountTools"] = function (actionEval, availableTargets) {
                vmToolsService.unmount(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.customizeGuestOs"] = function (actionEval, availableTargets) {
                var vmId = availableTargets[0];
                return customizeGosPreCheckSpecsService.customizeGosLoadData(vmId)
                    .then(function (data) {
                    var dialogContext = {
                        vmId: vmId,
                        vmGuestOsFullName: data.guestFullName,
                        vmGuestOsType: data.guestType,
                        relevantSpecs: data.relevantSpecs
                    };
                    return customizeGosSelectSpecDialogService.open(dialogContext);
                });
            };
            h5.actions["vsphere.core.vm.actions.guestOSUserMapping"] = function (actionEval, availableTargets) {
                if ($rootScope && $rootScope._navigateToViewAndObject) {
                    $rootScope._navigateToViewAndObject('vsphere.core.vm.manage.settings.guestUserMappingsView', availableTargets[0]);
                }
            };
            h5.actions["vsphere.core.vm.installUpgradeToolsAction"] = function (actionEval, availableTargets) {
                vmToolsService.installUpgrade(actionEval, availableTargets);
            };
            h5.actions["vsphere.core.vm.vmQuestionAnswer"] = function (actionEval, availableTargets, vmQuestionInfo) {
                var vmId = availableTargets[0];
                var modalOptions = {
                    title: i18nService.getString("VmUi", "VmQuestionAnswerView.titleNoEntityName"),
                    subTitle: {
                        objectId: vmId
                    },
                    contentTemplate: "vm-ui/resources/vm/views/questions/vmQuestionAnswerDialog.html",
                    size: "lg",
                    defaultButton: "submit",
                    dialogData: {
                        vmId: vmId,
                        vmQuestionIssue: vmQuestionInfo
                    }
                };
                clarityModalService.openOkCancelModal(modalOptions);
            };
            h5.actions["vsphere.core.vm.actions.cryptoUnlock"] = function (actionEval, availableTargets, context) {
                unlockVmService.unlockVm(actionEval, availableTargets, context);
            };
            h5.actions["vsphere.core.vm.actions.takeSnapshot"] = function (actionEval, availableTargets) {
                snapshotService.openTakeSnapshotDialog(availableTargets, actionEval);
            };
            h5.actions["vsphere.core.vm.actions.manageSnapshots"] = function (actionEval, availableTargets) {
                snapshotService.openManageSnapshotDialog(availableTargets, actionEval);
            };
            h5.actions["vsphere.core.vm.actions.revertToLatestSnapshot"] = function (actionEval, availableTargets) {
                var vmId = availableTargets[0];
                snapshotService.getSnapshotsForVM(vmId, true).then(function (data) {
                    snapshotService.onRevertToActionMenuClicked(vmId, data);
                });
            };
            h5.actions["vsphere.core.vm.actions.consolidateSnapshots"] = function (actionEval, availableTargets) {
                snapshotService.openConsolidateSnapshotDialog(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.deleteAllSnapshots"] = function (actionEval, availableTargets) {
                snapshotService.openRemoveAllSnapshotsConfirmationDialog(availableTargets[0]);
            };
            h5.actions["vsphere.core.vm.actions.exportLogs"] = function (actionEval, availableTargets) {
                vscExportWizardLauncherService.showSystemLogExportDialog(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.editSettings"] = function (actionEval, availableTargets) {
                clarityModalService.openModal(actionEval, availableTargets, undefined, "vm-ui/resources/vm/views/settings/vmHardwareModal.html");
            };
            h5.actions["vsphere.core.vm.actions.editEvcMode"] = function (actionEval, availableTargets) {
                var modalOptions = {
                    title: i18nService.getString("VmUi", "vmEvc.edit.dialogTitle"),
                    subTitle: {
                        objectId: availableTargets[0]
                    },
                    defaultButton: "submit",
                    contentTemplate: "vm-ui/resources/vm/evc-mode/edit-vm-evc.view.html",
                    size: "lg",
                    dialogData: {
                        vmId: availableTargets[0]
                    }
                };
                clarityModalService.openOkCancelModal(modalOptions);
            };
            h5.actions["vsphere.core.vm.actions.openConsole"] = function (actionEval, availableTargets) {
                var actionContext = actionEval.context;
                var target = actionContext.targetObjects[0];
                openConsoleService.openConsole(availableTargets[0], target.value, target.serverGuid);
            };
            h5.actions["vsphere.core.vm.actions.launchRemoteConsole"] = function (actionEval, availableTargets) {
                if (availableTargets && availableTargets.length !== 0) {
                    remoteConsoleService.getRemoteConsoleUrl(availableTargets[0]).then(function (remoteConsoleUrl) {
                        if (browserService.isFirefox()) {
                            $window.open(remoteConsoleUrl);
                        }
                        else {
                            $window.location.href = remoteConsoleUrl;
                        }
                    });
                }
            };
            h5.actions["vsphere.core.vm.actions.downloadVMRC"] = function (actionEval, availableTargets) {
                window.open("http://www.vmware.com/go/download-vmrc");
            };
            // Clone Vm actions
            h5.actions["vsphere.core.vm.actions.cloneVmToTemplate"] = function (actionEval, availableTargets) {
                var context = {
                    actionLabel: ""
                };
                if (actionEval && actionEval.action) {
                    context.actionLabel = actionEval.action.label;
                }
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_VM_TO_TEMPLATE, context);
            };
            h5.actions["vsphere.core.vm.actions.cloneVmToVm"] = function (actionEval, availableTargets) {
                var context = {
                    actionLabel: ""
                };
                if (actionEval && actionEval.action) {
                    context.actionLabel = actionEval.action.label;
                }
                if (actionEval && actionEval.additionalData && actionEval.additionalData.isScheduledTask) {
                    context.isScheduledTask = actionEval.additionalData.isScheduledTask;
                    context.schedulingData = actionEval.additionalData.schedulingData;
                }
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_VM_TO_VM, context);
            };
            h5.actions["vsphere.core.vm.actions.cloneVmToLibrary"] = function (actionEval, availableTargets) {
                dataService.getProperties(availableTargets[0], ['parent']).then(function (result) {
                    var folderUid = null;
                    if (result.parent) {
                        folderUid = defaultUriSchemeUtil.getVsphereObjectId(result.parent);
                    }
                    createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_AS_VMTEMPLATE_TO_LIBRARY, {
                        folderUid: folderUid
                    });
                });
            };
            h5.actions["vsphere.core.vm.actions.cloneVappToLibrary"] = function (actionEval, availableTargets) {
                dataService.getProperties(availableTargets[0], ['parent']).then(function (result) {
                    var folderUid = null;
                    if (result.parent) {
                        folderUid = defaultUriSchemeUtil.getVsphereObjectId(result.parent);
                    }
                    createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_VAPP_AS_VMTEMPLATE_TO_LIBRARY, {
                        folderUid: folderUid
                    });
                });
            };
            h5.actions["vsphere.core.vm.actions.deployFromTemplate"] = function (actionEval, availableTargets) {
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_TEMPLATE_TO_VM);
            };
            h5.actions["vsphere.core.vm.actions.convertTemplateToVmAction"] = function (actionEval, availableTargets) {
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CONVERT_TEMPLATE_TO_VM);
            };
            h5.actions["vsphere.core.vm.actions.cloneTemplateToTemplate"] = function (actionEval, availableTargets) {
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE);
            };
            h5.actions["vsphere.core.vm.actions.cloneTemplateToLibrary"] = function (actionEval, availableTargets) {
                var service = $injector.get("vscCloneVmToLibraryProxyService");
                service.openModal(availableTargets[0]);
            };
            // Template actions
            h5.actions["vsphere.core.vm.actions.markAsTemplate"] = function (actionEval, availableTargets) {
                markAsTemplateService.markAsTemplate(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.exportAsOVF"] = function (actionEval, availableTargets) {
                if (availableTargets.length === 0) {
                    return;
                }
                var objectId = availableTargets[0];
                var service = $injector.get("vscExportOvfModalService");
                service.openExportOvfDialog(objectId);
            };
            // Upgrade Vm compatibility actions
            h5.actions["vsphere.core.vm.actions.upgradeVmVirtualHardware"] = function (actionEval, availableTargets) {
                upgradeVmHardwareService.upgradeVmHardware(actionEval, availableTargets);
            };
            // Schedule upgrade hardware action
            h5.actions["vsphere.core.vm.actions.scheduleUpgradeVmVirtualHardware"] = function (actionEval, availableTargets) {
                upgradeVmHardwareService.scheduleUpgradeVmHardware(actionEval, availableTargets);
            };
            // Cancel schedule upgrade hardware action
            h5.actions["vsphere.core.vm.actions.upgradeVirtualHardwareActionCancel"] = function (actionEval, availableTargets) {
                upgradeVmHardwareService.cancelScheduledVmHardwareUpgrade(actionEval, availableTargets);
            };
            h5.actions["vsphere.core.provisioning.actions.deployOVF"] = function (actionEval, availableTargets) {
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.DEPLOY_VM_FROM_OVF);
            };
            h5.actions["vsphere.core.vm.actions.vmMigrate"] = function (actionEval, availableTargets, destinationTarget) {
                if (destinationTarget && destinationTarget.dropTarget) {
                    vmDragAndDropService.retrieveMoveOrMigrateData(destinationTarget.dropTarget, availableTargets)
                        .then(function (moveOrMigrateData) {
                        if (moveOrMigrateData.moveVms.length > 0) {
                            moveVmService.moveVms(moveOrMigrateData.moveVms, { dropTarget: moveOrMigrateData.moveTarget }, actionEval);
                        }
                        if (moveOrMigrateData.migrateVms.length > 0) {
                            migrateVmWizardService.showWizard(moveOrMigrateData.migrateVms, { dropTarget: moveOrMigrateData.migrateTarget }, actionEval);
                        }
                    });
                    return;
                }
                migrateVmWizardService.showWizard(availableTargets, destinationTarget, actionEval);
            };
            h5.actions["vsphere.core.vm.actions.move"] = function (actionEval, availableTargets, destinationTarget) {
                moveVmService.moveVms(availableTargets, destinationTarget, actionEval);
            };
            h5.actions["vsphere.core.vm.actions.dragAndDrop"] = function (actionEval, availableTargets, destinationTarget) {
                vmDragAndDropService.moveOrMigrateVm(availableTargets, destinationTarget);
            };
            h5.actions["vsphere.core.vm.actions.unregisterAction"] = function (actionEval, availableTargets) {
                vmRemovalService.unregisterVms(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.unregisterVmTemplateAction"] = function (actionEval, availableTargets) {
                // This does the same calls as unregistering a VM
                // but let"s handle it as a different invoker for the sake of readability.
                vmRemovalService.unregisterVms(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.turnOffFt"] =
                function (actionEval, availableTargets) {
                    vmFtService.turnOffFt(availableTargets);
                };
            h5.actions["vsphere.core.vm.actions.deleteAction"] = function (actionEval, availableTargets) {
                vmRemovalService.deleteVms(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.deleteTemplateAction"] = function (actionEval, availableTargets) {
                // This does the same calls as deleting a VM
                // but let"s handle it as a different invoker for the sake of readability.
                vmRemovalService.deleteVms(availableTargets);
            };
            h5.actions["vsphere.core.vm.actions.create"] = function (actionEval, availableTargets) {
                if (actionEval.additionalData && actionEval.additionalData.isScheduledTask) {
                    var context = {
                        isScheduledTask: actionEval.additionalData ? actionEval.additionalData.isScheduledTask : false,
                        schedulingData: actionEval.additionalData ? actionEval.additionalData.schedulingData : null
                    };
                    createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CREATE_FROM_SCRATCH, context);
                }
                else {
                    createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.CREATE_FROM_SCRATCH);
                }
            };
            h5.actions["vsphere.core.vm.actions.registerVm"] = function (actionEval, availableTargets, context) {
                createVmWizardService.showWizard(availableTargets[0], creationTypeConstants.REGISTER_VM, context);
            };
            h5.actions["vsphere.core.vm.gos.customization.new"] =
                function (actionEval, availableTargets, context) {
                    var onActionInvoked = context.onActionInvoked;
                    createGosSpecService.open(onActionInvoked, context.gosCustomizationSpecs);
                };
            h5.actions["vsphere.core.vm.gos.customization.edit"] =
                function (actionEval, availableTargets, context) {
                    var editSpecContext = {
                        specInfo: context.gosCustomizationSpecInfo,
                        specDetails: context.gosCustomizationSpecDetails,
                        allSpecs: context.gosCustomizationSpecs,
                        onActionInvoked: context.onActionInvoked,
                        iconClass: actionEval.action.icon
                    };
                    editGosSpecService.open(editSpecContext);
                };
            h5.actions["vsphere.core.vm.gos.customization.export"] =
                function (actionEval, availableTargets, context) {
                    var fileName = context.gosCustomizationSpecInfo.name + ".xml";
                    fileSaverService.save(context.gosCustomizationSpecXmlText, fileName);
                };
            h5.actions["vsphere.core.vm.gos.customization.delete"] =
                function (actionEval, availableTargets, context) {
                    var specInfo = context.gosCustomizationSpecInfo;
                    var onActionInvoked = context.onActionInvoked;
                    var title = actionEval.action.confirmationTitle;
                    var message = actionEval.action.confirmationText;
                    return deleteGosSpecService.confirmDelete(title, message).then(function () {
                        return deleteGosSpecService.delete(specInfo)
                            .then(function (opResult) {
                            if (onActionInvoked) {
                                onActionInvoked("vsphere.core.vm.gos.customization.delete", opResult);
                            }
                        });
                    }, function () {
                        onActionInvoked("vsphere.core.vm.gos.customization.delete");
                    });
                };
            h5.actions["vsphere.core.vm.gos.customization.duplicate"] =
                function (actionEval, availableTargets, context) {
                    var specInfo = context.gosCustomizationSpecInfo;
                    var gosCustomizationSpecs = context.gosCustomizationSpecs;
                    var onActionInvoked = context.onActionInvoked;
                    return duplicateGosSpecService.openDuplicateForm(specInfo, gosCustomizationSpecs)
                        .then(function (result) {
                        if (onActionInvoked) {
                            onActionInvoked("vsphere.core.vm.gos.customization.duplicate", result.result, result.openSpecForEdit);
                        }
                    });
                };
            h5.actions["vsphere.core.vm.gos.customization.import"] =
                function (actionEval, availableTargets, context) {
                    return importGosSpecService.openImportModal(context.gosCustomizationSpecs)
                        .then(function (result) {
                        var onActionInvoked = context.onActionInvoked;
                        if (onActionInvoked) {
                            context.onActionInvoked("vsphere.core.vm.gos.customization.import", result.result, result.invokeEdit);
                        }
                    });
                };
            h5.actions["vsphere.core.vm.actions.vappOptions.edit"] =
                function (actionEval, availableTargets, context) {
                    // Invoke a downgraded Angular2 service that shows the popup
                    $injector.get("vcVappOptionsEditActionService").editVappOptions(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.viewOvfEnvironment"] =
                function (actionEval, availableTargets, context) {
                    // Invoke a downgraded Angular2 service that shows the popup
                    if (actionEval.available &&
                        availableTargets &&
                        availableTargets.length) {
                        $injector.get("vcVappViewOvfEnironmentService")
                            .showOvfEnvironment(availableTargets[0]);
                    }
                };
            h5.actions["vsphere.core.vm.tpm.export"] =
                function (actionEval, availableTargets, context) {
                    if (!context || !context.algorithmName) {
                        return;
                    }
                    // The cert or CRS algorithmName is the most practical filename.
                    var extension = context.issuerName ? ".cer" : ".csr";
                    var fileName = context.algorithmName + extension;
                    fileSaverService.save(context.rawData, fileName);
                };
            h5.actions["vsphere.core.vm.actions.turnOnFt"] =
                function (actionEval, availableTargets) {
                    ftVmService.openVmFaultToleranceWizard(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.resumeFt"] =
                function (actionEval, availableTargets) {
                    ftVmService.resumeFaultTolerance(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.suspendFt"] =
                function (actionEval, availableTargets) {
                    ftVmService.suspendFaultTolerance(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.migrateSecondaryFtVm"] =
                function (actionEval, availableTargets) {
                    ftVmService.migrateSecondaryFtVm(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.testFailover"] =
                function (actionEval, availableTargets) {
                    ftVmService.ftTestFailover(availableTargets[0]);
                };
            h5.actions["vsphere.core.vm.actions.restartSecondary"] =
                function (actionEval, availableTargets) {
                    ftVmService.ftRestartSecondary(availableTargets[0]);
                };
        }]);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').run(['$templateCache', function($templateCache) {$templateCache.put('vm-ui/resources/vm/views/settings/vmEditSettings.html','<div class="flexbox-column" tabindex="0">\n   <vx-activity-indicator size="large" is-visible="loading"></vx-activity-indicator>\n\n   <div ng-if="!!alertOptions && alertOptions.isVisible"\n        class="alert" ng-class="alertOptions.class">\n      <div class="alert-items">\n         <div class="alert-item">\n            <div class="alert-icon-wrapper">\n               <clr-icon class="alert-icon" ng-attr-shape="{{alertOptions.iconShape}}"></clr-icon>\n            </div>\n            <span class="alert-text">{{alertOptions.text}}</span>\n         </div>\n      </div>\n   </div>\n\n   <clr-tabs (clr-tabs-current-tab-link-changed)="onTabSelected($event)"\n             (clr-tabs-current-tab-index-changed)="onTabIndexChanged($event)"\n             (clr-tabs-current-tab-content-changed)="onTabContentActivated($event)"\n             ng-if="hardwareConfigData">\n      <clr-tab-link autofocus>{{::i18n(\'VmUi\', \'VmConfigControl.virtual_hardware\')}}</clr-tab-link>\n      <clr-tab-link ng-if="!deployVmtx">{{::i18n(\'VmUi\', \'VmConfigControl.vm_options\')}}</clr-tab-link>\n\n      <clr-tab-content clr-tab-content-id="content1" clr-tab-content-active="true" class="vm-edit-settings-content">\n         <vm-hardware-settings></vm-hardware-settings>\n      </clr-tab-content>\n      <clr-tab-content clr-tab-content-id="content2" class="vm-edit-settings-content vm-options-content">\n         <vm-options ng-if="showVmOptions"></vm-options>\n      </clr-tab-content>\n   </clr-tabs>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmEditVappOptionsPage.html','<!--Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential-->\n<!-- this is how we must pass the value to the NG2 component,\n        otherwise we get the string `_route.objectId` as value of the vmId input-->\n<legacy-vapp-options-view\n      vm-id="_route.objectId">\n   </legacy-vapp-options-view>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareEdit.html','<div vm-edit-settings></div>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareModal.html','<clr-modal\n   [clr-modal-static-backdrop]="true"\n   [(clr-modal-open)]="modalOptions.modalOpen"\n   [clr-modal-size]="\'lg\'"\n   [clr-modal-closable]="true"\n   class="VmHardwareModal body-overflow-hidden"\n   has-modal-button-group>\n   <h3 class="modal-title" modal-title\n       primary-title="modalOptions.title"\n       secondary-title="modalOptions.secondaryTitle"></h3>\n   <div class="modal-body edit-modal">\n      <vm-edit-settings></vm-edit-settings>\n   </div>\n\n   <div class="modal-footer" ng-hide="config.loading">\n      <button type="button" class="btn btn-outline" ng-click="closeModal()">\n         {{::i18n(\'Common\',\'cancelButtonLabel\')}}\n      </button>\n      <button type="button" class="btn btn-primary" ng-disabled="!isInputStateValid()" ng-click="save()">\n         {{::i18n(\'Common\',\'saveButtonLabel\')}}\n      </button>\n   </div>\n</clr-modal>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmSdrsRulesPage.html','<vsc-vm-sdrs-rules></vsc-vm-sdrs-rules>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSettings.html','<div class="vertical-flex-container flex-1 vm-edit-hardware" ng-form name="hardwareForm">\n\n      <div id="vmEditHardwareAddDevices" class="flex-row vm-edit-add-devices modal-button-group flex-shrink-0"\n            ng-hide="config.loading" style="height:24px;">\n         <button type="button" class="btn btn-sm btn-outline"\n               ng-disabled="!ctrl.isAddDeviceMenuEnabled()"\n               ng-click="ctrl.toggleAddDevicesMenu()">\n            {{i18n(\'VmUi\', \'VmDeviceManager.AddNewDevice\')}}\n         </button>\n         <div vx-menu="ctrl.addDevicesMenuConfig"></div>\n      </div>\n      <div vui-validation-banner="ctrl.banner" class="flex-shrink-0"></div>\n\n\n\n         <clr-stack-view class="clr-component vm-stack-view"\n               ng-if="!config.loading"\n               vx-refreshable watch-objects=\'{{ctrl.vmId}}\'\n               refresh=\'ctrl.getVmHardwareData()\'>\n\n            <!--Loads network selector html (from network-ui module) ahead of pages of VM options tab -->\n            <div network-selector/>\n\n            <!-- Encryption -->\n            <clr-stack-block ng-if="ctrl.isVmHomeEncrypted()">\n               <clr-stack-label>\n                  <span>{{::i18n(\'VmUi\', \'VmCryptConfig.encryptionLabel\')}}</span>\n               </clr-stack-label>\n\n               <clr-stack-content>\n                  <span\n                        aria-label="{{i18n(\'VmUi\', \'VmCryptConfig.encryptionLabel\') + \' - \'\n                        + i18n(\'VmUi\', \'VmCryptConfig.vmHomeEncrypted\') }}">\n                     {{::i18n(\'VmUi\', \'VmCryptConfig.vmHomeEncrypted\')}}\n                  </span>\n                  <vsc-sign-post\n                        [sign-post-content]="::i18n(\'VmUi\', \'VmCryptConfig.VmHomeEncryptTip\')"\n                        [sign-post-position]="\'bottom-left\'">\n                  </vsc-sign-post>\n               </clr-stack-content>\n            </clr-stack-block>\n\n            <vm-hardware-cpu\n               vm-workflow-mode="ctrl.vmWorkflowMode"\n               create-mode="ctrl.createMode"\n               deploy-vmtx-mode="ctrl.deployVmtxMode"\n               original-config="ctrl.originalConfig"\n               vm="ctrl.vmConfig"\n               vm-config-context="ctrl.vmConfigContext"\n               vbs-enabled="ctrl.vmConfigContext.config.flags.vbsEnabled"\n               expanded="ctrl.stackBlocksExpandedState.cpu">\n            </vm-hardware-cpu>\n\n            <vm-hardware-memory\n                  vm="ctrl.vmConfig"\n                  vm-config-context="ctrl.vmConfigContext"\n                  original-config="ctrl.originalConfig"\n                  selected-guest-os="ctrl.selectedGuestOs"\n                  create-mode="ctrl.createMode"\n                  deploy-vmtx-mode="ctrl.deployVmtxMode"\n                  expanded="ctrl.stackBlocksExpandedState.memory">\n            </vm-hardware-memory>\n\n            <vm-hardware-virtual-nvdimm\n                  ng-repeat="virtualNvdimm in ctrl.virtualMachineDevices\n                        .existingDevicesOfType(\'VirtualNVDIMM\')\n                        track by virtualNvdimm.getKey()"\n                  vm-workflow-mode="ctrl.vmWorkflowMode"\n                  nvdimm-device="virtualNvdimm"\n                  remove-callback="ctrl.removeDevice"\n                  vm-config-context="ctrl.vmConfigContext"\n                  ng-if="!ctrl.deployVmtxMode"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  selected-guest-os="ctrl.selectedGuestOs">\n            </vm-hardware-virtual-nvdimm>\n\n            <vm-hardware-virtual-nvdimm\n                  ng-repeat="virtualNvdimm in ctrl.virtualMachineDevices\n                     .newDevicesOfType(\'VirtualNVDIMM\')\n                     track by virtualNvdimm.getKey()"\n                  vm-workflow-mode="ctrl.vmWorkflowMode"\n                  nvdimm-device="virtualNvdimm"\n                  remove-callback="ctrl.removeDevice"\n                  vm-config-context="ctrl.vmConfigContext"\n                  ng-if="!ctrl.deployVmtxMode"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  selected-guest-os="ctrl.selectedGuestOs">\n            </vm-hardware-virtual-nvdimm>\n\n            <vm-hardware-nvdimm-controller\n                  ng-repeat="virtualNvdimmController in ctrl.virtualMachineDevices\n                     .devicesOfType(\'VirtualNVDIMMController\')\n                     track by virtualNvdimmController.getKey()"\n                  vm-workflow-mode="ctrl.vmWorkflowMode"\n                  nvdimm-controller-device="virtualNvdimmController"\n                  remove-callback="ctrl.removeDevice"\n                  vm-config-context="ctrl.vmConfigContext"\n                  ng-if="!ctrl.deployVmtxMode"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  selected-guest-os="ctrl.selectedGuestOs">\n            </vm-hardware-nvdimm-controller>\n\n            <!-- HDD grouping -->\n            <div class="stack-view"\n                  style="height: auto"\n                  ng-if="ctrl.isDiskGroupingRequired()">\n               <div class="stack-block stack-block-expandable vm-hardware-grouped-disks-block"\n                        ng-class="{\'stack-block-expanded\': ctrl.hardDisksStackExpanded}">\n                  <dt class="stack-block-label" ng-click="ctrl.hardDisksStackClicked()">{{i18n(\'VmUi\', \'DiskPage.groupedMode.label\')}}</dt>\n                  <dd class="stack-block-content" ng-click="ctrl.hardDisksStackClicked()">{{ctrl.totalHardDiskSizeText}}</dd>\n                  <div class="stack-children" ng-if="ctrl.hardDisksStackExpanded">\n                     <div class="stack-block"\n                           ng-repeat="virtualDiskDeviceEmbedded in ctrl.getSortedVirtualDisks()\n                                        track by virtualDiskDeviceEmbedded.getKey()">\n\n                        <div ng-if="ctrl.isNotRDMDisk(virtualDiskDeviceEmbedded)">\n                           <vm-hardware-virtual-disk class="virtual-disk-embedded"\n                                 inflated-device="virtualDiskDeviceEmbedded"\n                                 create-mode="ctrl.createMode"\n                                 clone-mode="ctrl.cloneMode"\n\t\t\t\t\t\t\t\t deploy-vmtx-mode="ctrl.deployVmtxMode"\n                                 vm-config-context="ctrl.vmConfigContext"\n                                 vm-storage-id="{{::ctrl.vmStorageId}}"\n                                 vm-assignments-properties="ctrl.vmAssignmentsProperties"\n                                 compute-resource-id="ctrl.computeResourceId"\n                                 vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n                                 selected-storage-profile="ctrl.selectedStorageProfile"\n                                 selected-disk-format="ctrl.selectedDiskFormat"\n                                 storage-baseline-id="ctrl.storageBaselineId"\n                                 get-advanced-configuration-for-disk="ctrl.getAdvancedConfigurationForDisk(virtualDiskDeviceEmbedded)"\n                                 storage-profiles="ctrl.storageProfiles"\n                                 is-vm-encrypted="ctrl.isVmEncrypted"\n                                 virtual-machine-devices="ctrl.virtualMachineDevices"\n                                 can-choose-disk-location="ctrl.canChooseDiskLocation"\n                                 storage-locator-items-data="ctrl.storageLocatorItemsData"\n                                 remove-callback="ctrl.removeDevice"\n                                 vm-id="ctrl.vmId"\n                                 show-storage-pods="!ctrl.isXVc"\n                                 expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDeviceEmbedded.getKey()]"\n                                 keep-existing-profile-assignments="ctrl.keepExistingProfileAssignments"\n                                 is-grouping-hard-disks="true"\n                           ></vm-hardware-virtual-disk>\n                        </div>\n                        <div ng-if="!ctrl.isNotRDMDisk(virtualDiskDeviceEmbedded)">\n                           <vm-hardware-rdm-virtual-disk class="virtual-disk-embedded"\n                                 vm-workflow-mode="ctrl.vmWorkflowMode"\n                                 display-mode="3"\n                                 inflated-device="virtualDiskDeviceEmbedded"\n                                 vm-storage-id="{{::ctrl.vmStorageId}}"\n                                 vm-config-context="ctrl.vmConfigContext"\n                                 virtual-machine-devices="ctrl.virtualMachineDevices"\n                                 get-storage-for-disk="ctrl.getStorageForDisk(diskKey)"\n                                 storage-profiles="ctrl.storageProfiles"\n                                 selected-storage-profile="ctrl.selectedStorageProfile"\n                                 storage-locator-items-data="ctrl.storageLocatorItemsData"\n                                 vm-assignments-properties="ctrl.vmAssignmentsProperties"\n                                 compute-resource-id="ctrl.computeResourceId"\n                                 vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n                                 remove-callback="ctrl.removeDevice"\n                                 vm-id="ctrl.vmId"\n                                 show-storage-pods="!ctrl.isXVc"\n                                 expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDeviceEmbedded.getKey()]"\n                                 is-grouping-hard-disks="true"\n                           ></vm-hardware-rdm-virtual-disk>\n                        </div>\n                     </div>\n                  </div>\n               </div>\n            </div>\n\n             <vm-hardware-virtual-disk ng-if="!ctrl.isDiskGroupingRequired()"\n                        ng-repeat="virtualDiskDevice in ctrl.virtualMachineDevices\n                            .existingDevicesOfType(\'VirtualDisk\')\n                            | filter: ctrl.isNotRDMDisk\n                            track by virtualDiskDevice.getKey()"\n                     inflated-device="virtualDiskDevice"\n                     create-mode="ctrl.createMode"\n                     clone-mode="ctrl.cloneMode"\n                     vm-config-context="ctrl.vmConfigContext"\n                     vm-storage-id="{{::ctrl.vmStorageId}}"\n                     vm-assignments-properties="ctrl.vmAssignmentsProperties"\n                     compute-resource-id="ctrl.computeResourceId"\n                     vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n                     selected-storage-profile="ctrl.selectedStorageProfile"\n                     selected-disk-format="ctrl.selectedDiskFormat"\n                     storage-baseline-id="ctrl.storageBaselineId"\n                     get-advanced-configuration-for-disk="ctrl.getAdvancedConfigurationForDisk(virtualDiskDevice)"\n                     storage-profiles="ctrl.storageProfiles"\n                     is-vm-encrypted="ctrl.isVmEncrypted"\n                     virtual-machine-devices="ctrl.virtualMachineDevices"\n                     can-choose-disk-location="ctrl.canChooseDiskLocation"\n                     storage-locator-items-data="ctrl.storageLocatorItemsData"\n                     remove-callback="ctrl.removeDevice"\n                     vm-id="ctrl.vmId"\n                     show-storage-pods="!ctrl.isXVc"\n                     expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDevice.getKey()]"\n                     keep-existing-profile-assignments="ctrl.keepExistingProfileAssignments"\n                     is-grouping-hard-disks="false"\n             ></vm-hardware-virtual-disk>\n\n            <!-- TODO refactor vmHardwareController.js to\n            Typescript and use the vm-display-mode.ts instead of the\n            hardcoded value\n            https://www.pivotaltracker.com/story/show/139341171\n               -->\n            <vm-hardware-rdm-virtual-disk ng-if="!ctrl.isDiskGroupingRequired()"\n                  ng-repeat="virtualDiskDevice in ctrl\n                  .virtualMachineDevices\n                  .existingDevicesOfType(\'VirtualDisk\')\n                  | filter: ctrl.isRDMDisk\n                  track by virtualDiskDevice.getKey()"\n               vm-workflow-mode="ctrl.vmWorkflowMode"\n               display-mode="3"\n               inflated-device="virtualDiskDevice"\n               vm-storage-id="{{::ctrl.vmStorageId}}"\n               vm-config-context="ctrl.vmConfigContext"\n               virtual-machine-devices="ctrl.virtualMachineDevices"\n               get-storage-for-disk="ctrl.getStorageForDisk(diskKey)"\n               storage-profiles="ctrl.storageProfiles"\n               selected-storage-profile="ctrl.selectedStorageProfile"\n               storage-locator-items-data="ctrl.storageLocatorItemsData"\n               vm-assignments-properties="ctrl.vmAssignmentsProperties"\n               compute-resource-id="ctrl.computeResourceId"\n               vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n               remove-callback="ctrl.removeDevice"\n               vm-id="ctrl.vmId"\n               show-storage-pods="!ctrl.isXVc"\n               expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDevice.getKey()]"\n               ng-if="!ctrl.deployVmtxMode"\n            ></vm-hardware-rdm-virtual-disk>\n\n            <vm-hardware-virtual-disk\n                  ng-repeat="virtualDiskDevice in ctrl\n                  .virtualMachineDevices\n                  .newDevicesOfType(\'VirtualDisk\')\n                  | filter: ctrl.isNotRDMDisk\n                   track by virtualDiskDevice.getKey()"\n               inflated-device="virtualDiskDevice"\n               create-mode="ctrl.createMode"\n               clone-mode="ctrl.cloneMode"\n               vm-config-context="ctrl.vmConfigContext"\n               vm-storage-id="{{::ctrl.vmStorageId}}"\n               selected-storage-profile="ctrl.selectedStorageProfile"\n               storage-baseline-id="ctrl.storageBaselineId"\n               get-advanced-configuration-for-disk="ctrl.getAdvancedConfigurationForDisk(virtualDiskDevice)"\n               vm-assignments-properties="ctrl.vmAssignmentsProperties"\n               compute-resource-id="ctrl.computeResourceId"\n               vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n               get-storage-for-disk="ctrl.getStorageForDisk(diskKey)"\n               storage-profiles="ctrl.storageProfiles"\n               is-vm-encrypted="ctrl.isVmEncrypted"\n               virtual-machine-devices="ctrl.virtualMachineDevices"\n               set-storage-for-disk="ctrl.setStorageForDisk(storageInfo, device)"\n               can-choose-disk-location="ctrl.canChooseDiskLocation"\n               storage-locator-items-data="ctrl.storageLocatorItemsData"\n               remove-callback="ctrl.removeDevice"\n               vm-id="ctrl.vmId"\n               show-storage-pods="!ctrl.isXVc"\n               expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDevice.getKey()]"\n               keep-existing-profile-assignments="ctrl.keepExistingProfileAssignments"\n               autoscrollintoview="clr-stack-block"\n            ></vm-hardware-virtual-disk>\n\n            <vm-hardware-rdm-virtual-disk\n                  ng-repeat="virtualDiskDevice in ctrl\n                  .virtualMachineDevices\n                  .newDevicesOfType(\'VirtualDisk\')\n                  | filter: ctrl.isRDMDisk\n                  track by virtualDiskDevice.getKey()"\n               vm-workflow-mode="ctrl.vmWorkflowMode"\n               display-mode="0"\n               inflated-device="virtualDiskDevice"\n               vm-storage-id="{{::ctrl.vmStorageId}}"\n               vm-storage-object="ctrl.vmStorageObject"\n               vm-config-context="ctrl.vmConfigContext"\n               virtual-machine-devices="ctrl.virtualMachineDevices"\n               get-storage-for-disk="ctrl.getStorageForDisk(diskKey)"\n               storage-profiles="ctrl.storageProfiles"\n               selected-storage-profile="ctrl.selectedStorageProfile"\n               storage-locator-items-data="ctrl.storageLocatorItemsData"\n               set-storage-for-disk="ctrl.setStorageForDisk(storageInfo, device)"\n               vm-assignments-properties="ctrl.vmAssignmentsProperties"\n               compute-resource-id="ctrl.computeResourceId"\n               vm-home-replication-group="ctrl.vmHomeReplicationGroup"\n               remove-callback="ctrl.removeDevice"\n               is-vm-encrypted="ctrl.isVmEncrypted"\n               vm-id="ctrl.vmId"\n               show-storage-pods="!ctrl.isXVc"\n               expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualDiskDevice.getKey()]"\n               autoscrollintoview="clr-stack-block"\n\t\t\t   ng-if="!ctrl.deployVmtxMode"\n            ></vm-hardware-rdm-virtual-disk>\n\n            <vm-hardware-scsi-controller\n                  create-mode="ctrl.createMode"\n                  inflated-device="virtualScsiDevice"\n                  vm-config-context="ctrl.vmConfigContext"\n                  selected-guest-os="ctrl.selectedGuestOs"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  remove-callback="ctrl.removeDevice"\n                  expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualScsiDevice.getKey()]"\n                  ng-repeat="virtualScsiDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualSCSIController\') track by virtualScsiDevice.getKey()"\n                  ng-if="!ctrl.deployVmtxMode">\n            </vm-hardware-scsi-controller>\n\n            <vm-hardware-scsi-controller\n                  create-mode="ctrl.createMode"\n                  vm-config-context="ctrl.vmConfigContext"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  selected-guest-os="ctrl.selectedGuestOs"\n                  ng-if="virtualScsiDevice.getKey() < 0"\n                  inflated-device="virtualScsiDevice"\n                  remove-callback="ctrl.removeDevice"\n                  expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualScsiDevice.getKey()]"\n                  ng-repeat="virtualScsiDevice in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualSCSIController\') track by virtualScsiDevice.getKey()"\n                  ng-if="!ctrl.deployVmtxMode">\n            </vm-hardware-scsi-controller>\n\n            <vm-hardware-network\n                  ng-repeat="virtualNetworkDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualEthernetCard\') track by virtualNetworkDevice.getKey()"\n                  virtual-network-device="virtualNetworkDevice"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  network-provider="ctrl.networkProviderId"\n                  available-networks="ctrl.availableNetworks"\n                  network-privilege-map="ctrl.networkPrivilegeMap"\n                  vm-workflow-mode="ctrl.vmWorkflowMode"\n                  selected-guest-os="ctrl.selectedGuestOs"\n                  filter-networks-obj-id="ctrl.filterNetworksObjId"\n                  vm-config-context="ctrl.vmConfigContext"\n                  remove-callback="ctrl.removeDevice"\n                  vm-id="ctrl.vmId"\n                  deploy-vmtx-mode="ctrl.deployVmtxMode"\n                  expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualNetworkDevice.getKey()]"\n            ></vm-hardware-network>\n\n            <vm-hardware-network\n                  ng-repeat="virtualNetworkDevice in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualEthernetCard\') track by virtualNetworkDevice.getKey()"\n                  virtual-network-device="virtualNetworkDevice"\n                  virtual-machine-devices="ctrl.virtualMachineDevices"\n                  network-provider="ctrl.networkProviderId"\n                  available-networks="ctrl.availableNetworks"\n                  network-privilege-map="ctrl.networkPrivilegeMap"\n                  vm-workflow-mode="ctrl.vmWorkflowMode"\n                  selected-guest-os="ctrl.selectedGuestOs"\n                  filter-networks-obj-id="ctrl.filterNetworksObjId"\n                  vm-config-context="ctrl.vmConfigContext"\n                  remove-callback="ctrl.removeDevice"\n                  vm-id="ctrl.vmId"\n                  deploy-vmtx-mode="ctrl.deployVmtxMode"\n                  expanded="ctrl.stackBlocksExpandedState.virtualDevices[virtualNetworkDevice.getKey()]"\n            ></vm-hardware-network>\n\n      <vm-hardware-cdrom\n            ng-repeat="entry in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualCdrom\') track by entry.getKey()"\n\t\t\tng-if="!ctrl.deployVmtxMode"\n            inflated-device="entry"\n            create-mode="ctrl.createMode"\n            vm-config-context="ctrl.vmConfigContext"\n            virtual-machine-devices-needed-for-controller-and-node="ctrl.virtualMachineDevices"\n            privileges="ctrl.privileges"\n            merged-inflated-devices="ctrl.mergedInflatedDevices"\n            remove-callback="ctrl.removeDevice"\n            compute-resource-id="{{ctrl.computeResourceId}}"\n            expanded="ctrl.stackBlocksExpandedState.virtualDevices[entry.getKey()]"\n            vm-id="ctrl.vmId"\n      ></vm-hardware-cdrom>\n\n      <vm-hardware-cdrom\n            ng-repeat="entry in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualCdrom\') track by entry.getKey()"\n            inflated-device="entry"\n            create-mode="ctrl.createMode"\n            vm-config-context="ctrl.vmConfigContext"\n            virtual-machine-devices-needed-for-controller-and-node="ctrl.virtualMachineDevices"\n            merged-inflated-devices="ctrl.mergedInflatedDevices"\n            remove-callback="ctrl.removeDevice"\n            compute-resource-id="{{ctrl.computeResourceId}}"\n            expanded="ctrl.stackBlocksExpandedState.virtualDevices[entry.getKey()]"\n            vm-id="ctrl.vmId"\n\t\t\tng-if="!ctrl.deployVmtxMode"\n      ></vm-hardware-cdrom>\n\n            <vm-hardware-usb-controller ng-repeat="item in ctrl.getUSBControllerList()"\n                 inflated-device="item"\n                 selected-guest-os="ctrl.selectedGuestOs"\n                 remove-callback="ctrl.removeDevice"\n                 vm-config-context="ctrl.vmConfigContext"\n                 virtual-machine-devices="ctrl.virtualMachineDevices"\n                 vm-workflow-mode="ctrl.vmWorkflowMode"\n                 expanded="ctrl.stackBlocksExpandedState.virtualDevices[item.getKey()]"\n                 ng-if="!ctrl.deployVmtxMode"\n            ></vm-hardware-usb-controller>\n\n            <vm-hardware-usb-device ng-repeat="item in ctrl.getUSBDeviceList()"\n                 ng-if="!ctrl.deployVmtxMode"\n                 inflated-device="item"\n                 selected-guest-os="ctrl.selectedGuestOs"\n                 remove-callback="ctrl.removeDevice"\n                 vm-config-context="ctrl.vmConfigContext"\n                 expanded="ctrl.stackBlocksExpandedState.virtualDevices[item.getKey()]"\n            ></vm-hardware-usb-device>\n\n           <vm-hw-pci-shared ng-repeat="item in ctrl.getPciSharedList()" inflated-device="item"></vm-hw-pci-shared>\n           <vm-hw-pci-device ng-repeat="item in ctrl.getPciDeviceList()" inflated-device="item"></vm-hw-pci-device>\n\n            <vm-hardware-video-card\n               ng-if="!ctrl.deployVmtxMode"\n               inflated-device="ctrl.getInflatedVideoCard()"\n            ></vm-hardware-video-card>\n\n      <vsc-vm-hardware-nvme-controller\n            ng-if="!ctrl.deployVmtxMode"\n            ng-repeat="nvmeDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualNVMEController\') track by nvmeDevice.getKey()"\n            [inflated-device]="nvmeDevice"\n            [remove-callback]="ctrl.removeDevice"\n            [power-state]="ctrl.vmConfigContext.environment.powerState"\n            [device-option]="ctrl.nvmeDeviceOption"\n            [workflow-mode]="ctrl.vmWorkflowMode"\n            [privileges]="ctrl.vmConfigContext.privileges"\n            [virtual-machine-devices]="ctrl.virtualMachineDevices"\n      ></vsc-vm-hardware-nvme-controller>\n\n      <vsc-vm-hardware-nvme-controller\n            ng-if="!ctrl.deployVmtxMode"\n            ng-repeat="nvmeDevice in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualNVMEController\') track by nvmeDevice.getKey()"\n            [inflated-device]="nvmeDevice"\n            [remove-callback]="ctrl.removeDevice"\n            [power-state]="ctrl.vmConfigContext.environment.powerState"\n            [device-option]="ctrl.nvmeDeviceOption"\n            [workflow-mode]="ctrl.vmWorkflowMode"\n            [privileges]="ctrl.vmConfigContext.privileges"\n            [virtual-machine-devices]="ctrl.virtualMachineDevices"\n      ></vsc-vm-hardware-nvme-controller>\n\n            <vm-hardware-tpm\n                    ng-if="!ctrl.deployVmtxMode"\n                    ng-repeat="virtualTpmDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualTPM\') track by virtualTpmDevice.getKey()"\n                    tpm-device="virtualTpmDevice"\n                    create-mode="ctrl.createMode"\n                    vm-powered-on="ctrl.isVmPoweredOn"\n                    remove-callback="ctrl.removeDevice"\n                    vm-id="ctrl.vmId"\n            ></vm-hardware-tpm>\n\n            <vm-hardware-tpm\n                    ng-if="!ctrl.deployVmtxMode"\n                    ng-repeat="virtualTpmDevice in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualTPM\') track by virtualTpmDevice.getKey()"\n                    tpm-device="virtualTpmDevice"\n                    create-mode="ctrl.createMode"\n                    remove-callback="ctrl.removeDevice"\n                    vm-id="ctrl.vmId"\n            ></vm-hardware-tpm>\n\n            <clr-stack-block\n                  ng-if="!ctrl.deployVmtxMode"\n                  ng-repeat="virtualVmciDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualVMCIDevice\') track by virtualVmciDevice.getKey()">\n               <clr-stack-label>\n                  <span>{{ ::virtualVmciDevice.getCurrentDevice().deviceInfo.label }}</span>\n               </clr-stack-label>\n               <clr-stack-content aria-label="{{virtualVmciDevice.getCurrentDevice().deviceInfo.label + \' - \'\n                  + virtualVmciDevice.getCurrentDevice().deviceInfo.summary}}"\n               ng-bind="virtualVmciDevice.getCurrentDevice().deviceInfo.summary"/>\n      </clr-stack-block>\n\n      <vsc-vm-hardware-sata-controller\n         ng-if="!ctrl.deployVmtxMode"\n         ng-repeat="sataDevice in ctrl.virtualMachineDevices.existingDevicesOfType(\'VirtualAHCIController\') track by sataDevice.getKey()"\n         [inflated-device]="sataDevice"\n         [remove-callback]="ctrl.removeDevice"\n         [power-state]="ctrl.vmConfigContext.environment.powerState"\n         [device-option]="ctrl.nvmeDeviceOption"\n         [workflow-mode]="ctrl.vmWorkflowMode"\n         [privileges]="ctrl.vmConfigContext.privileges"\n         [virtual-machine-devices]="ctrl.virtualMachineDevices"\n      ></vsc-vm-hardware-sata-controller>\n\n      <vsc-vm-hardware-sata-controller\n         ng-if="!ctrl.deployVmtxMode"\n         ng-repeat="sataDevice in ctrl.virtualMachineDevices.newDevicesOfType(\'VirtualAHCIController\') track by sataDevice.getKey()"\n         [inflated-device]="sataDevice"\n         [remove-callback]="ctrl.removeDevice"\n         [power-state]="ctrl.vmConfigContext.environment.powerState"\n         [device-option]="ctrl.nvmeDeviceOption"\n         [workflow-mode]="ctrl.vmWorkflowMode"\n         [privileges]="ctrl.vmConfigContext.privileges"\n         [virtual-machine-devices]="ctrl.virtualMachineDevices"\n      ></vsc-vm-hardware-sata-controller>\n\n      <vm-hw-serial-port\n         ng-repeat="item in ctrl.getSerialPortDeviceList() track by item.getKey()"\n         port="item"\n         expanded="ctrl.stackBlocksExpandedState.virtualDevices[item.getKey()]"\n      ></vm-hw-serial-port>\n\n            <vm-hardware-other ng-if="!ctrl.deployVmtxMode"></vm-hardware-other>\n         </clr-stack-view>\n\n   <span class="vm-hardware-version flex-shrink-0"\n         ng-show="ctrl.createMode">{{ ctrl.vmVersion }}</span>\n\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/vmOptions.html','<clr-stack-view class="clr-component vm-stack-view"\n                  ng-if="!config.loading"\n                  ng-form name="vmOptionsForm"\n                  vx-refreshable watch-objects=\'{{ctrl.vmId}}\'>\n   <general-options\n      config="hardwareConfigData.vmConfigContext.config"\n      vm-id="ctrl.vmId"\n      vm-config-context="hardwareConfigData.vmConfigContext"\n      guest-os-descriptor="hardwareConfigData.guestOsFamilyKey"\n      vm-params="vmParams"\n      modal-options="modalOptions"\n      expanded="ctrl.stackBlocksExpandedState.generalOptions">\n   </general-options>\n   <vsc-vmrc-options\n      [vm-config-context]="hardwareConfigData.vmConfigContext"\n      [vm-workflow-mode]="vmOptionsController.workflow"\n      [(is-stack-expanded)]="ctrl.stackBlocksExpandedState.vmrcOptions">\n   </vsc-vmrc-options>\n   <encryption-options\n      workflow-mode="vmOptionsController.workflow"\n      vm-storage-profile="vmOptionsController.vmStorageProfile"\n      storage-profiles="vmOptionsController.storageProfiles"\n      vm-storage-profile-assignments="vmOptionsController.vmStorageProfileAssignments"\n      hard-disks="vmOptionsController.hardDisks"\n      vm-config-context="hardwareConfigData.vmConfigContext"\n      datacenter-id="wizardViewData ? wizardViewData.getDatacenterId() : undefined"\n      on-alert="vmOptionsController.onAlert(options)"\n      does-tpm-exist="vmOptionsController.doesTPMExist()"\n      expanded="ctrl.stackBlocksExpandedState.encryptionOptions">\n   </encryption-options>\n   <standby-options\n      vm-workflow-mode="vmOptionsController.workflow"\n      vm-config-context="hardwareConfigData.vmConfigContext"\n      options="hardwareConfigData.vmConfigContext.config.defaultPowerOps"\n      on-change="vmOptionsController.onStandbyOptionsChange(standbyAction)"\n      network-devices="vmOptionsController.networkAdapterDevices"\n      expanded="ctrl.stackBlocksExpandedState.standbyOptions">\n   </standby-options>\n   <vmware-tools\n      vm-workflow-mode="vmOptionsController.workflow"\n      vm-default-power-operations="hardwareConfigData.vmConfigContext.config.defaultPowerOps"\n      vm-tools-options="hardwareConfigData.vmConfigContext.config.tools"\n      vm-power-state="hardwareConfigData.vmConfigContext.environment.powerState"\n      vm-tools-capabilities="hardwareConfigData.vmConfigContext.environment.configOption.capabilities"\n      vm-has-config-settings-privilege="vmOptionsController.hasVmConfigSettingsPrivilege()"\n      on-change="vmOptionsController.onVmwareToolsChange(vmToolsOptions)"\n      expanded="ctrl.stackBlocksExpandedState.vmwareTools">\n   </vmware-tools>\n   <vbs config-flags="hardwareConfigData.vmConfigContext.config.flags"\n         guest-os-descriptor="hardwareConfigData.vmConfigContext.environment.configOption.guestOSDescriptor[0]"\n         on-vbs-update="vmOptionsController.onVbsUpdate(vbsEnabled)"\n         visible="vmOptionsController.vbsVisible()"\n         vm-powered-on="vmOptionsController.isVmPoweredOn()">\n   </vbs>\n   <boot-options\n         vm-workflow-mode="vmOptionsController.workflow"\n         vm="hardwareConfigData.vm"\n         vm-config-context="hardwareConfigData.vmConfigContext"\n         on-bootoptions-update="vmOptionsController.onBootOptionsChanged(updatedModel)"\n         on-firmware-update="vmOptionsController.onFirmwareSelectionChanged(newFirmware)"\n         vbs-enabled="vmOptionsController.vbsEnabled"\n         vbs-properties="vmOptionsController.vbsProperties"\n         does-tpm-exist="vmOptionsController.doesTPMExist()"\n         expanded="ctrl.stackBlocksExpandedState.bootOptions">\n   </boot-options>\n   <vm-advanced-options\n      vm-workflow-mode="vmOptionsController.workflow"\n      advanced-options="hardwareConfigData.vmConfigContext.config.flags"\n      swap-placement-type="hardwareConfigData.vmConfigContext.config.swapPlacement"\n      vm-config-context="hardwareConfigData.vmConfigContext"\n      expanded="ctrl.stackBlocksExpandedState.vmAdvancedOptions">\n   </vm-advanced-options>\n\n   <vsc-vm-hw-npiv\n      [vm-config-context]="hardwareConfigData.vmConfigContext"\n      [vm-workflow-mode]="vmOptionsController.workflow"\n      [(expanded)]="ctrl.stackBlocksExpandedState.vmHwNpiv">\n   </vsc-vm-hw-npiv>\n\n</clr-stack-view>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/common/vmsPowerOpsConfirmation.html','<div>\n   <span class="power-ops-confirmation-text">{{ dialogOptions.actionDetails.dialogData.messageTxt }}</span>\n   <div ng-if(dialogOptions.actionDetails.dialogData.reasonsTxt)>\n      <br />\n      <span class="power-ops-confirmation-continue">{{ dialogOptions.actionDetails.dialogData.reasonsTxt }}</span>\n   </div>\n   <br />\n   <span class="power-ops-confirmation-continue">{{ dialogOptions.actionDetails.dialogData.continueTxt }}</span>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/sharesControl/sharesControl.html','<div class="select">\n   <select name="{{ formSelectFieldName }}"\n           aria-label="{{::sharesAriaLabel}}"\n           ng-disabled="isDisabled"\n           ng-options="shareLevel.label for shareLevel in shareInfoLevels track by shareLevel.data"\n           ng-model="properties.selectedSharesLevel">\n   </select>\n</div>\n<vx-value-in-units name="{{ formInputFieldName }}"\n                quantity-aria-label="quantityAriaLabel"\n                quantity-caret-aria-label="quantityCaretAriaLabel"\n                type="number"\n                recommended-values="shareInfoValues"\n                ng-model="sharesInfo.shares"\n                is-disabled="isDisabled || !isShareLevelCustom"\n                min="{{ shareValueMin }}"\n                max="{{ shareValueMax }}"\n                error-messages="shareValueErrorMessages"\n                show-units="false">\n</vx-value-in-units>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCdrom/vmHardwareCdrom.html','<clr-stack-block\n      class="vm-hardware-cdrom"\n      ng-form\n      name="vmHardwareCdRomForm{{device.key}}"\n      ng-class="{\'vm-ui-stackBlockEdited\': inflatedDevice.hasChanged()}"\n      [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-class="{\'error-child-component\': hasError()}">\n      <span>{{ device.deviceInfo.label }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if="inflatedDevice.isMarkedForRemoval()">\n      {{::i18n(\'VmUi\', \'RemoveDevice.DeviceRemoved\')}}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         aria-label="{{ARIA_LBL_RESTORE}}"\n         ng-click="onRevertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <clr-stack-content ng-if="!inflatedDevice.isMarkedForRemoval()">\n      <div class="select">\n         <select\n            aria-label="{{ARIA_LBL_MEDIA_TYPE}}"\n            name="editCdrom{{device.key}}MediaType"\n            ng-model="properties.mediaType"\n            ng-options="item as item.label for item in availableMediaTypes track by item.id"\n            ng-disabled="isCdRomDisabled()">\n         </select>\n      </div>\n      <div>\n         <label ng-if="!expanded && !isVmPoweredOn"\n                title="{{i18n(\'VmUi\', \'ConnectDevice.ConnectAtPowerOn\')}}"\n                class="normal-weight">\n            <input name="editCdrom{{device.key}}StartConnected"\n                   aria-label="{{ARIA_LBL_START_CONNECTED}}"\n                   type="checkbox"\n                   ng-model=\'properties.startConnected\'\n                   ng-disabled="isCdRomConnectedAtPowerOnDisabled()">\n            <span class="label-text-normal"\n                  ng-class="{\'label-text-disabled\': isCdRomConnectedAtPowerOnDisabled()}"\n                  ng-bind="i18n(\'VmUi\', \'ConnectDevice.ConnectAtPowerOnShort\')"/>\n         </label>\n         <label ng-if="isVmPoweredOn" class="normal-weight">\n            <input name="editCdrom{{device.key}}Connected"\n                   aria-label="{{ARIA_LBL_CONNECTED}}"\n                   type="checkbox"\n                   ng-disabled="isCdRomConnectedDisabled()"\n                   ng-model=\'properties.connected\'>\n            <span class="label-text-normal"\n                  ng-class="{\'label-text-disabled\': isCdRomConnectedDisabled()}"\n                  ng-bind="i18n(\'VmUi\', \'ConnectDevice.Connected\')"/>\n         </label>\n\n         <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n            aria-label="{{ARIA_LBL_REMOVE}}"\n            ng-disabled="shouldRemoveDeviceBeDisabled()"\n            ng-click="onCdRomRemoval()"></a>\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::i18n(\'VmUi\', \'GenericDevicePage.Status\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label class="normal-weight">\n            <input name=\'editCdrom{{device.key}}StartConnected\'\n                   type="checkbox"\n                   aria-label="{{ARIA_LBL_START_CONNECTED}}"\n                   ng-model=\'properties.startConnected\'\n                   ng-disabled="isCdRomConnectedAtPowerOnDisabled()">\n            <span class="label-text-normal"\n                     ng-class="{\'label-text-disabled\': isCdRomConnectedAtPowerOnDisabled()}"\n                     ng-bind="i18n(\'VmUi\', \'ConnectDevice.ConnectAtPowerOn\')"/>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::i18n(\'VmUi\', \'CdromPage.Media\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div ng-if="isDatastoreISOFile()">\n            <label data-test-id="editCdromBackingFileName"\n                   aria-haspopup="true" role="tooltip"\n                   class="tooltip tooltip-validation tooltip-md"\n                   ng-class="{\'invalid\':hasEditCdRomError() && errors.isoError.isVisible}">\n               <input type="text"\n                      aria-label="{{ARIA_LBL_FILE}}"\n                      name="editCdrom{{device.key}}BackingFileName"\n                      ng-model="device.backing.fileName"\n                      ng-required="!inflatedDevice.isMarkedForRemoval()">\n               <span class="tooltip-content"\n                     ng-bind="errors.isoError.message">\n               </span>\n            </label>\n            <button name="editCdrom{{device.key}}BrowseForIso"\n                    aria-label="{{ARIA_LBL_BROWSE}}"\n                    class="button btn btn-default btn-sm"\n                    ng-click="browseForDatastoreIso()"\n                    type="button">\n               {{::i18n(\'VmUi\',\'CdromConfig.Browse\')}}\n            </button>\n         </div>\n         <div ng-if="isContentLibraryISOFile()">\n            <label data-test-id="editCdromCLBackingFileName"\n                   aria-haspopup="true" role="tooltip"\n                   class="tooltip tooltip-validation tooltip-md"\n                   ng-class="{\'invalid\':!inflatedDevice.isMarkedForRemoval() && errors.isoErrorForCL.isVisible}">\n               <input class="content-library-iso-file"\n                      aria-label="{{ARIA_LBL_FILE}}"\n                      type="text"\n                      name="editCdrom{{device.key}}CLBackingFileName"\n                      ng-model="properties.selectedIsoItem.friendlyName"\n                      readonly\n                      ng-required="!inflatedDevice.isMarkedForRemoval()">\n               <span class="tooltip-content"\n                     ng-bind="errors.isoErrorForCL.message">\n               </span>\n            </label>\n            <button name="editCdrom{{device.key}}BrowseForCLIso"\n                    aria-label="{{ARIA_LBL_BROWSE}}"\n                    class="button btn btn-default btn-sm"\n                    ng-click="browseForContentLibraryIso()"\n                    type="button">\n               {{::i18n(\'VmUi\',\'CdromConfig.Browse\')}}\n            </button>\n         </div>\n         <div ng-if="isClientDevice()">\n            {{::i18n(\'VmUi\', \'CdromPage.ConnectClient\')}}\n         </div>\n         <div data-test-id="hostDeviceList" ng-if="isHostDevice()" class="select" ng-class="{\'has-error\': isHostDeviceBackingInvalid()}">\n            <select name="editCdrom{{device.key}}cdromList"\n                    aria-label="{{ARIA_LBL_HOST}}"\n                    ng-model="properties.selectedCdrom"\n                    ng-change="onCdRomChanged(properties.selectedCdrom.name)"\n                    ng-options="getCdRomLabel(cdrom.name) for cdrom in cdromList track by cdrom.id">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::i18n(\'VmUi\', \'CdromPage.DeviceMode\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select">\n            <select\n               aria-label="{{ARIA_LBL_MODE}}"\n               name="editCdrom{{device.key}}DeviceMode"\n               ng-model="properties.deviceMode"\n               ng-options="mode.label for mode in availableDeviceModes track by mode.id"\n               ng-disabled="isDeviceModeDisabled()">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::i18n(\'VmUi\', \'CdromPage.VirtualDeviceNode\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-controller-and-node\n            inflated-device="inflatedDevice"\n            power-state="vmConfigContext.environment.powerState"\n            selector-name="controllerNodeSelectorName"\n            virtual-machine-devices="virtualMachineDevicesNeededForControllerAndNode"\n            controller-selector-name="controllerSelectorName"\n            node="properties.controllerNode"\n            available-controllers="availableControllers"\n            device-controller="properties.controller"\n            privileges="vmConfigContext.privileges"\n            on-controller-change-callback="onControllerNodeChanged(deviceController, node)">\n         </vm-hardware-controller-and-node>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareControllerAndNode/vmHardwareControllerAndNode.html','<div class="select">\n   <select\n      aria-label="{{ARIA_LBL_CTRL}}"\n      name="{{controllerSelectorName}}"\n      ng-disabled="disableSelection()"\n      ng-model="deviceController"\n      ng-options="option.getCurrentDevice().deviceInfo.label for option in availableControllers track by option.getKey()"\n      ng-change="onControllerChange(deviceController)">\n   </select>\n</div>\n\n<div class="select">\n   <select\n      name="{{selectorName}}"\n      aria-label="{{ARIA_LBL_NODE}}"\n      ng-disabled="disableSelection()"\n      ng-model="node"\n      ng-options="option.name for option in nodeOptions track by option.key"\n      ng-change="onControllerNodeChange(node)">\n   </select>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuAffinityHelpText.html','<div>\n   <p>\n      {{affinityText}}\n   </p>\n   <p>\n      {{i18n(\'VmUi\', \'Affinity.Info.Label\')}}\n   </p>\n   <p>\n      {{i18n(\'VmUi\', \'Affinity.Info.Label2\')}}\n   </p>\n   <p>\n      <strong>{{i18n(\'VmUi\', \'Affinity.HtStatus.Label\')}}</strong> {{htStatus}}\n   </p>\n   <p>\n      <strong>{{i18n(\'VmUi\', \'Affinity.NumProcs.Label\')}}</strong> {{numProcs}}\n   </p>\n   <p/>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuGeneralHelpText.html','<div>\n   {{i18n(\'VmUi\', \'signpost.perSocket\')}}\n   <p>{{i18n(\'VmUi\', \'signpost.256CPU1\')}}</p>\n   <p>{{i18n(\'VmUi\', \'signpost.256CPU2\')}}</p>\n</div>\n<div class="pull-right">\n   <p>\n      <a href="{{cpuGeneralHelpUrl}}" target="_blank">{{i18n(\'Common\', \'moreInformation\')}}</a>\n   </p>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuMmuVirtualization6.7HostVm13HelpText.html','<div>\n    <p>\n        {{i18n(\'VmUi\', \'VmCpu.CpuMmuVirt.Description\')}}\n    </p>\n    <p>\n    {{i18n(\'VmUi\', \'VmCpu.CpuMmuVirt.Additional.Description\')}}\n    </p>\n    <p>\n        {{i18n(\'VmUi\', \'VmCpu.CpuMmuVirt.Note\')}}\n    </p>\n    <ul class="list">\n        <li>\n            <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.automatic\')}}</strong></div>\n            {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.automatic\')}}\n        </li>\n        <li>\n            <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.software\')}}</strong></div>\n            {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.software\')}}\n        </li>\n        <li>\n            <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.hardwareCpu\')}}</strong></div>\n            {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.hardwareCpu\')}}\n        </li>\n        <li>\n            <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.hardwareCpuMmu\')}}</strong></div>\n            {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.hardwareCpuMmu\')}}\n        </li>\n    </ul>\n</div>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuMmuVirtualizationHelpText.html','<div>\n   <p>\n      {{i18n(\'VmUi\', \'VmCpu.CpuMmuVirt.Description\')}}\n   </p>\n   <p>\n      {{i18n(\'VmUi\', \'VmCpu.CpuMmuVirt.Note\')}}\n   </p>\n   <ul class="list">\n      <li>\n         <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.automatic\')}}</strong></div>\n         {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.automatic\')}}\n      </li>\n      <li>\n         <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.software\')}}</strong></div>\n         {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.software\')}}\n      </li>\n      <li>\n         <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.hardwareCpu\')}}</strong></div>\n         {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.hardwareCpu\')}}\n      </li>\n      <li>\n         <div><strong>{{i18n(\'VmUi\', \'CpuMmuVirt.Label.hardwareCpuMmu\')}}</strong></div>\n         {{i18n(\'VmUi\', \'CpuMmuVirt.Tooltip.hardwareCpuMmu\')}}\n      </li>\n   </ul>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/nestedHVHelpText.html','<div>\n   <p>\n      {{i18n(\'VmUi\', \'VmCpu.nestedHV.Description\')}}\n   </p>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/vmHardwareCpu.html','<clr-stack-block\n   class="numCpu"\n   [(clr-sb-expanded)]="expanded"\n   ng-class="{\'vm-ui-stackBlockEdited\': hasChanged()}"\n   ng-form\n   name="vmHardwareCpuForm">\n   <clr-stack-label ng-class="{\'error-child-component\': hasError()}">\n         <span>{{i18n(\'VmUi\', \'VmCpu.Title\')}}</span>\n   </clr-stack-label>\n\n   <clr-stack-content class="value">\n      <div class="select" ng-class="{ \'has-error\' : cpuCountError.isVisible }">\n         <select name="editCPU" autofocus\n                 aria-label="{{::i18n(\'VmUi\', \'VmCpu.Title\')}}"\n                 ng-model="vmConfigContext.config.hardware.numCPU"\n                 ng-options="option for option in numCpuOptions"\n                 ng-change="onCpuCountChange()"\n                 ng-disabled ="!isEditNumCpuEnabled()"\n                 vx-error="cpuCountError">\n         </select>\n      </div>\n      <a vui-sign-post=\'cpuGeneralHelpSignPostParams\' class="pull-right"><img ng-src="{{i18n(\'CommonImages\', \'info\')}}"></a>\n   </clr-stack-content>\n\n   <clr-stack-block ng-if="isMultipleCoresPerSocketSupported()" class="CoresPerSocket">\n      <clr-stack-label ng-bind="i18n(\'VmUi\', \'VmCpu.Label.CoresPerSocket\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select name="coresPerSocket"\n                    aria-label="{{::i18n(\'VmUi\', \'VmCpu.Label.CoresPerSocket\')}}"\n                    ng-model="vmConfigContext.config.hardware.numCoresPerSocket"\n                    ng-options="option for option in coresPerSocketOptions"\n                    ng-disabled="!isEditCoresPerSocketEnabled()">\n            </select>\n         </div>\n         <span ng-bind="i18n(\'VmUi\', \'VmCpu.Label.Sockets\')"/>\n         <span> {{vmConfigContext.config.hardware.numCPU / vmConfigContext.config.hardware.numCoresPerSocket}}</span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="CpuHotPlug">\n      <clr-stack-label ng-bind="i18n(\'VmUi\', \'VmCpu.Label.CpuHotPlug\')">\n      </clr-stack-label>\n      <clr-stack-content>\n         <input name="cpuHotPlug"\n                aria-label="{{::i18n(\'VmUi\', \'VmCpu.Label.CpuHotAdd\')}}"\n                type="checkbox"\n                ng-model="cpuHotPlug"\n                ng-model-options="{ getterSetter: true }"\n                ng-disabled="!isCpuHotPlugEnabled()"/>\n         <label>\n            <span ng-class="{\'label-text-disabled\': !isCpuHotPlugEnabled()}"\n                  class="label-text-normal"\n                  ng-bind="i18n(\'VmUi\', \'VmCpu.Label.CpuHotAdd\')"/>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="Reservation">\n      <clr-stack-label ng-bind="fieldLabel(\'Reservation\')"></clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="cpuReservation"\n                            unit-aria-label="RSRV_UNIT_ARIA_LBL"\n                            quantity-caret-aria-label="RSRV_QUANTITY_CARET_ARIA_LBL"\n                            quantity-aria-label="RSRV_QUANTITY_ARIA_LBL"\n                            type="number"\n                            ng-model="vmConfigContext.config.cpuAllocation.reservation"\n                            unit-options="reservationUnitOptions"\n                            recommended-values="reservationRecommendations"\n                            max="{{reservationMax}}"\n                            is-disabled="!isEditReservationEnabled()"\n                            error-messages="reservationErrorMessages">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="Limit">\n      <clr-stack-label ng-bind="fieldLabel(\'Limit\')">\n      </clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="cpuLimit"\n                            unit-aria-label="LIMIT_UNIT_ARIA_LBL"\n                            quantity-caret-aria-label="LIMIT_QUANTITY_CARET_ARIA_LBL"\n                            quantity-aria-label="LIMIT_QUANTITY_ARIA_LBL"\n                            is-disabled="!isEditLimitEnabled()"\n                            recommended-values="limitRecommendations"\n                            ng-model="vmConfigContext.config.cpuAllocation.limit"\n                            unit-options="limitUnitOptions">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="Shares">\n      <clr-stack-label ng-bind="fieldLabel(\'Shares\')">\n      </clr-stack-label>\n      <clr-stack-content>\n         <shares-control\n            shares-aria-label="SHARES_ARIA_LBL"\n            quantity-caret-aria-label="SHARES_CARET_ARIA_LBL"\n            quantity-aria-label="SHARES_QNT_ARIA_LBL"\n            is-disabled="!isEditSharesEnabled()"\n            form-input-field-name="CpuSharesValue"\n            form-select-field-name="CpuSharesLevels"\n            share-value-min="0"\n            share-value-max="1000000"\n            shares-value-map="sharesValueMap"\n            shares-info="sharesInfo">\n         </shares-control>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-show="!deployVmtxMode" class="CpuIdMask">\n      <clr-stack-label ng-bind="fieldLabel(\'CpuIdMask\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="select-cpuid-mask-row">\n            <select class="select-cpuid-mask"\n                    aria-label="{{::fieldLabel(\'CpuIdMask\')}}"\n                    name="cpuIdMask"\n                    ng-disabled="!isEditCpuIdEnabled()"\n                    ng-model="cpuIdMaskSelectedSetting"\n                    ng-options="option for option in cpuIdMaskSettings"\n                    ng-change="onCpuIdMaskChange()">\n            </select>\n            <a\n               class="advanced-cpuid-mask-edit"\n               href="javascript:void(0);"\n               aria-label="{{::i18n(\'VmUi\', \'VmCpu.CpuIdMask.Advanced\')}}"\n               ng-disabled="!isEditCpuIdEnabled()"\n               ng-click="onCpuIdMaskAdvanced()">\n                  {{::i18n(\'VmUi\', \'VmCpu.CpuIdMask.Advanced\')}}\n            </a>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="NestedHV">\n      <clr-stack-label ng-bind="fieldLabel(\'NestedHV\')"></clr-stack-label>\n      <clr-stack-content>\n         <input class="NestedHV" type="checkbox"\n                aria-label="{{::i18n(\'VmUi\', \'VmCpu.ExposeNestedHV\')}}"\n                data-test-id="NestedHV"\n                ng-disabled="isHVDisabled()"\n                ng-model="vmConfigContext.config.nestedHVEnabled"/>\n         <span ng-class="{\'div-disabled\': isHVDisabled()}"\n               class="label-text-normal"\n               ng-bind="i18n(\'VmUi\', \'VmCpu.ExposeNestedHV\')"/>\n         <a ng-if="isHVDisabled()" vui-sign-post=\'nestedHVSignPostParams\' class=\'pull-right\'><img ng-src="{{i18n(\'CommonImages\', \'info\')}}"></a>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="PerfCounters">\n      <clr-stack-label ng-bind="fieldLabel(\'PerfCounters\')"></clr-stack-label>\n      <clr-stack-content >\n         <div>\n            <input name="PerfCounters" type="checkbox"\n                   aria-label="{{::fieldLabel(\'PerfCounters\')}}"\n                   ng-disabled="isEnablePerfCountersIsDisabled()"\n                   ng-model="vmConfigContext.config.vPMCEnabled"/>\n            <span class="label-text-normal"\n                  ng-class="{\'div-disabled\': isEnablePerfCountersIsDisabled()}"\n                  ng-bind="i18n(\'VmUi\', \'VmCpu.EnablePerfCounters\')"/>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="isSchedulingAffinityShown() && !deployVmtxMode" class="CpuAffinity">\n      <clr-stack-label> {{::fieldLabel(\'CpuAffinity\')}}</clr-stack-label>\n      <clr-stack-content>\n         <input name="cpuAffinity"\n                aria-label="{{::fieldLabel(\'CpuAffinity\')}}"\n                type="text"\n                ng-model="fieldValue[\'CpuAffinity\']"\n                ng-change="onAffinityChange()"\n                vx-error="affinityError"\n                ng-disabled="!isSchedulingAffinityEnabled()"\n                ng-class="{\'has-error\': isAffinityInvalid()}"\n                class="edit-setting-input"/>\n         <a vui-sign-post=\'cpuAffinitySignPostParams\' class=\'pull-right\'><img ng-src="{{i18n(\'CommonImages\', \'info\')}}"></a>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="CpuMmuVirtualization" ng-if="!showCpuMmuVirtualization && !deployVmtxMode">\n      <clr-stack-label ng-bind="fieldLabel(\'CpuMmuVirtualization\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <cpu-mmu-view\n               aria-label="fieldLabel(\'CpuMmuVirtualization\')"\n               vm-config-context="vmConfigContext"\n               create-mode="createMode"\n               on-cpu-mmu-change="onCpuMmuChange(selectedOption)">\n            </cpu-mmu-view>\n         </div>\n         <a vui-sign-post=\'cpuMmuVirtSignPostParams\' class=\'pull-right\'><img ng-src="{{i18n(\'CommonImages\', \'info\')}}"></a>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="ioMmuVirtualizationSupported && !deployVmtxMode" class="ioMmuVirtualization">\n      <clr-stack-label ng-bind="fieldLabel(\'ioMmuVirtualization\')"></clr-stack-label>\n      <clr-stack-content>\n         <input type="checkbox" ng-disabled="disableVvtdCheckbox()" ng-model="vm.vvtd" aria-label="{{::IOMMU_ARIA_LBL}}"/>\n         <span ng-class="{\'div-disabled\': disableVvtdCheckbox()}">{{::LBL_VVTD_ENABLED}}</span>\n         <a ng-if="showVvtdInfo()" vui-sign-post=\'vvtdSignPostParams\' class=\'pull-right\'><img ng-src="{{::INFO_PNG}}"></a>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareExistingDisk/select-existing-hard-disk.view.html','<div>\n   <datastore-file-browser\n      object-id="modalOptions.dialogData.datastoreBrowserId"\n      datastore-ids="modalOptions.dialogData.datastoreIds"\n      initial-file-query-type="modalOptions.dialogData.initialFileQueryType"\n      filter-file-query-types="modalOptions.dialogData.filterFileQueryTypes"\n      show-vm-images-folder="modalOptions.dialogData.showVmImagesFolder"\n      selected-file-changed="modalOptions.dialogData.selectedFileChanged(selectedFile)">\n   </datastore-file-browser>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareMemory/vmHardwareMemory.html','<clr-stack-block style="overflow-y: unset"\n      ng-form\n      name="vmHardwareMemoryForm"\n      [(clr-sb-expanded)]="expanded"\n      ng-class="{\'vm-ui-stackBlockEdited\': hasChanged()}"\n      class="memory">\n   <clr-stack-label ng-class="{\'error-child-component\': hasError()}">\n      <span>{{ ::i18n(\'VmUi\', \'VmMemory.Title\') }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content class="memory-heading">\n      <vx-value-in-units name="editMemory"\n                         unit-aria-label="ARIA_LBL_MEMORY"\n                         quantity-caret-aria-label="ARIA_LBL_MEMORY"\n                         quantity-aria-label="ARIA_LBL_MEMORY"\n                         ng-if="memoryOptions"\n                         is-disabled="isMemoryDisabled()"\n                         hot-plug-active="(vmConfigContext.environment.powerState === \'poweredOn\')"\n                         type="number"\n                         ng-model="vmConfigContext.config.hardware.memoryMB"\n                         default-unit="{{vmConfigContext.config.hardware.memoryUnitPreferred ? vmConfigContext.config.hardware.memoryUnitPreferred.label : i18n(\'VmUi\', \'Vm.Units.GB\')}}"\n                         unit-options="memoryOptions"\n                         unit-changed-callback="onUnitChanged"\n                         min="{{minAllowedMemory}}"\n                         max="{{maxAllowedMemory}}"\n                         mod="{{memoryIncrementSize}}"\n                         recommended-values="memoryRecommendations"\n                         custom-validators="memoryValidators"\n                         error-messages="memoryErrorMessages">\n      </vx-value-in-units>\n   </clr-stack-content>\n\n   <clr-stack-block class="memory-reservation" ng-if="!deployVmtxMode">\n      <clr-stack-label >{{ ::fieldLabel(\'Reservation\') }}</clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="memoryReservation"\n                            unit-aria-label="ARIA_LBL_RSRV"\n                            quantity-caret-aria-label="ARIA_LBL_RSRV"\n                            quantity-aria-label="ARIA_LBL_RSRV"\n                            recommended-values="reservationRecommendations"\n                            min="0"\n                            type="number"\n                            max="{{limits.reservationMaxLimit}}"\n                            ng-model="vmConfigContext.config.memoryAllocation.reservation"\n                            default-unit="{{vmConfigContext.config.memoryAllocation.reservationMemoryUnitPreferred.label}}"\n                            unit-options="memoryOptions"\n                            unit-changed-callback="onReservationUnitChanged"\n                            error-messages="reservationErrorMessages"\n                            is-disabled="isReservationDisabled()">\n         </vx-value-in-units>\n         <div class="memory-reservation-locked-max" ng-if="vmConfigContext.environment.configOption.capabilities.memoryReservationLockSupported">\n            <input name="memoryReservationLockedToMax"\n                   aria-label="{{::i18n(\'VmUi\', \'VmMemory.Label.MemoryReservationLockedToMax\')}}"\n                   ng-click="onMemoryReservationLockedToMax()"\n                   ng-disabled="isMaxReservationDisabled()"\n                   ng-model = "vmConfigContext.config.memoryReservationLockedToMax"\n                   type="checkbox"/>\n            <span class="label-text-normal"\n                  ng-class="{\'label-text-disabled\': isMaxReservationDisabled()}"\n                  ng-bind="i18n(\'VmUi\', \'VmMemory.Label.MemoryReservationLockedToMax\')"/>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="Limit">\n      <clr-stack-label >{{ ::fieldLabel(\'Limit\') }}</clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="memoryLimit"\n                            unit-aria-label="ARIA_LBL_LIMIT"\n                            quantity-caret-aria-label="ARIA_LBL_LIMIT"\n                            quantity-aria-label="ARIA_LBL_LIMIT"\n                            recommended-values="limitRecommendations"\n                            min="{{limits.reservation}}"\n                            ng-model="vmConfigContext.config.memoryAllocation.limit"\n                            default-unit="{{vmConfigContext.config.memoryAllocation.limitMemoryUnitPreferred.label}}"\n                            unit-changed-callback="onLimitUnitChanged"\n                            unit-options="memoryOptions"\n                            error-messages="memoryErrorMessages"\n                            is-disabled="isLimitDisabled()">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="Shares">\n      <clr-stack-label>{{ ::fieldLabel(\'Shares\') }}</clr-stack-label>\n      <clr-stack-content>\n         <shares-control\n            shares-aria-label="ARIA_LBL_SHARES"\n            quantity-caret-aria-label="ARIA_LBL_SHARES"\n            quantity-aria-label="ARIA_LBL_SHARES"\n            form-input-field-name="MemorySharesValue"\n            form-select-field-name="MemorySharesLevels"\n            share-value-min="{{MIN_SHARES_VALUE}}"\n            share-value-max="{{MAX_SHARES_VALUE}}"\n            shares-value-map="sharesValueMap"\n            shares-info="sharesInfo"\n            is-disabled="isSharesDisabled()">\n         </shares-control>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!deployVmtxMode" class="memoryHotAdd">\n      <clr-stack-label>{{ ::i18n(\'VmUi\', \'VmMemory.Label.MemoryHotPlug\') }}</clr-stack-label>\n      <clr-stack-content>\n         <label>\n            <input name="memoryHotAdd"\n                   aria-label="{{::i18n(\'VmUi\', \'VmMemory.Label.MemoryHotPlug\')}}"\n                   ng-model="vmConfigContext.config.memoryHotAddEnabled"\n                   type="checkbox"\n                   ng-disabled="isMemoryHotPlugDisabled()"/>\n         <span class="label-text-normal"\n               ng-class="{\'label-text-disabled\': isMemoryHotPlugDisabled()}"\n               ng-bind="i18n(\'VmUi\', \'VmMemory.Label.MemoryHotAdd\')"/>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareNetwork/vm-hardware-network.html','<!---->\n<clr-stack-block\n      class="vm-hardware-network"\n      ng-form\n      deviceLabel={{::$ctrl.device.deviceInfo.label}}\n      name="$ctrl.vmHardwareNetworkForm"\n      [(clr-sb-expanded)]="$ctrl.expanded"\n      ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.virtualNetworkDevice.hasChanged()}">\n   <clr-stack-label ng-class="{\'error-child-component\': $ctrl.hasError()}">\n      <span>{{::$ctrl.device.deviceInfo.label}}</span>\n      <span class="vx-icon-warn" ng-if="$ctrl.showDeviceWarning"></span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if="$ctrl.virtualNetworkDevice.isMarkedForRemoval()">\n      {{::$ctrl.i18n(\'RemoveDevice.DeviceRemoved\')}}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         tabindex="0"\n         aria-label="{{::$ctrl.ARIA_LBL_RESTORE}}"\n         ng-click="$ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n   <clr-stack-content ng-if="!$ctrl.virtualNetworkDevice.isMarkedForRemoval()">\n      <div data-test-id="editNetwork"\n           class="vm-edit-network-selector"  network-selector\n           network-selector-name="\'editNetwork\' + $ctrl.device.key"\n           ng-class="{\'has-error\' : !$ctrl.selectedNetworkValid}"\n           object-ref="$ctrl.networkSelectorModel.objectRef"\n           mode="$ctrl.networkSelectorModel.mode"\n           filter-spec="$ctrl.networkSelectorModel.filterSpec"\n           dialog-spec="$ctrl.networkSelectorModel.dialogSpec"\n           prefetched-networks="$ctrl.networkSelectorModel.prefetchedNetworks"\n           preselected-network="$ctrl.networkSelectorModel.selectedNetwork"\n           on-selected-networks="$ctrl.onNetworkSelectionChanged(selectedNetworks)"\n           on-preload-networks="$ctrl.onPreloadNetworks()"\n           preload-networks="true"\n           error-config="$ctrl.errorConfig"\n           is-disabled="$ctrl.isNetworkSelectDisabled()"\n      ></div>\n\n      <div>\n         <label ng-if="!$ctrl.deployVmtxMode && !$ctrl.expanded && !$ctrl.isVmPoweredOn()"\n                data-test-id="startConnectedInHeader"\n                title="{{::$ctrl.i18n(\'ConnectDevice.ConnectAtPowerOn\')}}"\n                class="normal-weight">\n            <input name="editNetwork{{$ctrl.device.key}}StartConnected"\n                   aria-label="{{::$ctrl.ARIA_LBL_START_CONNECTED}}"\n                   type="checkbox"\n                   test-id = "startConnected"\n                   title="{{::$ctrl.i18n(\'ConnectDevice.ConnectAtPowerOn\')}}"\n                   ng-model=\'$ctrl.properties.connectAtPowerOn\'\n                   ng-change="$ctrl.onConnectAtPowerOnChange()"\n                   ng-disabled="$ctrl.isConnectedAtPowerOnDisabled()">\n            {{::$ctrl.i18n(\'ConnectDevice.ConnectAtPowerOnShort\')}}\n         </label>\n         <label class="normal-weight"\n                data-test-id="Connected"\n                ng-if="!$ctrl.deployVmtxMode && $ctrl.isVmPoweredOn()">\n            <input name="editNetwork{{$ctrl.device.key}}Connected"\n                   aria-label="{{::$ctrl.ARIA_LBL_CONNECTED}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.properties.connected\'\n                   ng-change="$ctrl.onConnectChange()"\n                   ng-disabled="$ctrl.isConnectedDisabled()"\n            />\n            {{::$ctrl.i18n(\'ConnectDevice.Connected\')}}\n         </label>\n         <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n            tabindex="0"\n            aria-label="{{::$ctrl.ARIA_LBL_REMOVE}}"\n            ng-disabled="$ctrl.isRemoveDisabled()"\n            ng-click="$ctrl.onRemoveDevice()"></a>\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'GenericDevicePage.Status\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label data-test-id="startConnectedInBody"\n            ng-if="$ctrl.expanded"\n            class="normal-weight">\n            <input type="checkbox"\n                   aria-label="{{::$ctrl.ARIA_LBL_START_CONNECTED}}"\n                   ng-model="$ctrl.properties.connectAtPowerOn"\n                   ng-change="$ctrl.onConnectAtPowerOnChange()"\n                   ng-disabled="$ctrl.isConnectedAtPowerOnDisabled()"/>\n            {{::$ctrl.i18n(\'ConnectDevice.ConnectAtPowerOn\')}}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmNetView.adapterType\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select">\n            <select\n               data-test-id="editNetworkAdapterType"\n               name="networkAdapterType"\n               aria-label="{{::$ctrl.ARIA_LBL_NIC_TYPE}}"\n               ng-model="$ctrl.properties.selectedAdapterType"\n               ng-options="$ctrl.getEthernetCardLabel(adapterType.type.name) for adapterType in $ctrl.adapterTypes"\n               ng-disabled="$ctrl.isNetworkAdapterDisabled()"\n               ng-change="$ctrl.onNetworkAdapterTypeChange()">\n            </select>\n         </div>\n         <div test-id="hotadd-error" ng-if="$ctrl.showHotAddError">\n            <span class="vx-icon-error"></span>\n            <span>{{::$ctrl.hotAddErrorText}}</span>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode && $ctrl.shouldDisplayPVRDMADeviceProtocol()">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmNetView.deviceProtocol\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select">\n            <select\n               name="deviceProtocol"\n               ng-model="$ctrl.device.deviceProtocol"\n               ng-options="$ctrl.getDeviceProtocolLabel(deviceProtocol) for deviceProtocol in $ctrl.deviceProtocols"\n               ng-disabled="$ctrl.isNetworkAdapterDisabled()">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode && $ctrl.isUptCompatibilityVisible()">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NetworkPage.UptCompatibility\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label>\n            <input data-test-id="direct-io-checkbox"\n                   type="checkbox"\n                   aria-label="{{::$ctrl.ARIA_LBL_UPT}}"\n                   ng-model="$ctrl.uptCompatibility"\n                   ng-model-options="{ getterSetter: true }"\n                   ng-disabled="$ctrl.isEditUptCompatibilityDisabled()"/>\n            {{::$ctrl.i18n(\'NetworkPage.UptCompatibility.Enable\')}}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if=$ctrl.isMemWarnVisible>\n      <clr-stack-label></clr-stack-label>\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="mem-txt">{{$ctrl.memWarnText}}</span>\n         </div>\n      </clr-stack-content>\n\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.isSriovWarningVisible">\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="sriov-note">{{ ::$ctrl.sriovWarningText}}</span></div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n\n\n   <clr-stack-block ng-if="$ctrl.isSriovVisible()">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NetworkPage.PhysicalFunction\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select" ng-if="$ctrl.isSriovSelectVisible()">\n            <select\n               aria-label="{{::$ctrl.ARIA_LBL_SRIOV_PF}}"\n               ng-model="$ctrl.sriovValue"\n               ng-options="item.label for item in $ctrl.sriovList() track by item.pnic">\n            </select>\n         </div>\n         <label ng-if="$ctrl.isSriovLabelVisible()">{{$ctrl.getSriovLabelText()}}</label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode && $ctrl.properties.reservationSupported">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NetworkPage.Shares\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <shares-control name="shares"\n            shares-aria-label="$ctrl.ARIA_LBL_SHARES"\n            quantity-caret-aria-label="$ctrl.ARIA_LBL_SHARES"\n            quantity-aria-label="$ctrl.ARIA_LBL_SHARES"\n            form-input-field-name="sharesValue"\n            form-select-field-name="sharesLevels"\n            share-value-min="1"\n            share-value-max="100"\n            shares-value-map="$ctrl.sharesValueMap"\n            shares-info="$ctrl.resourceAllocation.share">\n         </shares-control>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode && $ctrl.properties.reservationSupported">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NetworkPage.Reservation\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="reservation"\n                            unit-aria-label="$ctrl.ARIA_LBL_RSRV"\n                            quantity-caret-aria-label="$ctrl.ARIA_LBL_RSRV"\n                            quantity-aria-label="$ctrl.ARIA_LBL_RSRV"\n                            type="number"\n                            ng-model="$ctrl.resourceAllocation.reservation"\n                            ng-change="$ctrl.onReservationChanged()"\n                            unit-options="$ctrl.reservationUnitOptions"\n                            recommended-values="$ctrl.reservationRecommendations"\n                            min="0"\n                            max="{{$ctrl.reservationMax}}"\n                            error-messages="$ctrl.reservationErrorMessages">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode && $ctrl.properties.reservationSupported">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NetworkPage.Limit\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <vx-value-in-units name="limit"\n                            unit-aria-label="$ctrl.ARIA_LBL_LIMIT"\n                            quantity-caret-aria-label="$ctrl.ARIA_LBL_LIMIT"\n                            quantity-aria-label="$ctrl.ARIA_LBL_LIMIT"\n                            ng-model="$ctrl.resourceAllocation.limit"\n                            ng-change="$ctrl.onLimitChanged()"\n                            unit-options="$ctrl.reservationUnitOptions"\n                            recommended-values="$ctrl.limitRecommendations"\n                            error-messages="{bug:1867123}"\n                            custom-validators="$ctrl.limitValidators">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n\n   <clr-stack-block ng-if="!$ctrl.deployVmtxMode">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmNetView.macAddress\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <mac-address-control\n            address-type="$ctrl.device.addressType"\n            assigned-mac-address="$ctrl.device.macAddress"\n            ng-disabled="$ctrl.isMacAddressDisabled()"\n         ></mac-address-control>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--SRIOV ONLY: Allow guest OS MTU change true/false -->\n\n   <clr-stack-block ng-if="$ctrl.isMtuChangeVisible">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmNetView.allowGuestOSMtuChange\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select">\n            <select ng-disabled="!$ctrl.isMtuChangeEditable"\n                 aria-label="{{::$ctrl.ARIA_LBL_MTU}}"\n                 test-id="mtu-change"\n                 ng-model="$ctrl.mtuChangeValue"\n                 ng-options="item as item.label for item in $ctrl.mtuChangeList track by item.id">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--END OF "Allow guest OS MTU change" section"-->\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareNvdimmController/vm-hardware-nvdimm-controller.component.html','<clr-stack-block\n      ng-form\n      name="vmHardwareNvdimmControllerForm"\n      [(clr-sb-expanded)]="expanded"\n      ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.nvdimmControllerDevice.hasChanged()}"\n      class="virtual-nvdimm">\n   <clr-stack-label>\n      <span>{{ ::$ctrl.deviceName }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if="$ctrl.nvdimmControllerDevice.isMarkedForRemoval()">\n      {{::$ctrl.i18n(\'RemoveDevice.DeviceRemoved\')}}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n            ng-click="$ctrl.revertNvdimmControllerRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <clr-stack-content ng-if="!$ctrl.nvdimmControllerDevice.isMarkedForRemoval()">\n      <!-- A dummy label in order to push the below button right.\n          For now it is simpler than doing CSS acrobatics.-->\n      <clr-stack-label>\n      </clr-stack-label>\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n            ng-disabled="$ctrl.isRemoveDisabled"\n            ng-click="$ctrl.removeNvdimmController()"></a>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NVDIMM.availableCapacity\')}}\n      </clr-stack-label>\n      <clr-stack-content data-test-id="nvdimm-available-capacity">\n         <span>\n            {{$ctrl.getAvailablePmemCapacity() | bytes:\'MB\'}}\n         </span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'NVDIMM.supportedByGuest\')}}\n      </clr-stack-label>\n      <clr-stack-content data-test-id="nvdimm-supported-by-guest">\n         <span>\n            {{$ctrl.getSupportedPmemByGuestOs() | bytes:\'MB\'}}\n         </span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block data-test-id="nvdimm-total-nvdimm-summary">\n      <clr-stack-label>\n         {{::$ctrl.i18n("VMDIMM.totalNVDIMMs.label")}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <span>\n            {{$ctrl.getNvDimmDeviceSummary()}}\n         </span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareOther/vmHardwareOther.html','<clr-stack-block [(clr-sb-expanded)]="ctrl.stackBlocksExpandedState.other">\n   <clr-stack-label>\n      {{ ::i18n(\'VmUi\', \'VmHardwareView.OtherHardware\') }}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div ng-if="!expanded">\n         {{ i18n(\'VmUi\', \'VmHardwareView.AdditionalHardware\') }}\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block class="controllers">\n      <clr-stack-label ng-bind="::i18n(\'VmUi\', \'VmOtherHardwareView.Controllers\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="controller vm-hardware-generic"\n              ng-repeat="inflatedDevice in ::ctrl.virtualControllers | deviceTypeFilter:\'VirtualSCSIController\' track by inflatedDevice.getKey()"\n              ng-bind="vmHardwareOtherCtrl.getSummaryText(inflatedDevice, \'VirtualController\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="scsi-adapters">\n      <clr-stack-label\n                       ng-bind="i18n(\'VmUi\', \'VmOtherHardwareView.ScsiAdapters\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="scsi-adapter vm-hardware-generic"\n              ng-repeat="inflatedDevice in ::ctrl.virtualScsiControllers track by inflatedDevice.getKey()"\n              ng-bind="vmHardwareOtherCtrl.getSummaryText(inflatedDevice, \'VirtualSCSIController\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="input-devices">\n      <clr-stack-label\n                       ng-bind="::i18n(\'VmUi\', \'VmOtherHardwareView.InputDevices\')"></clr-stack-label>\n\n      <clr-stack-content>\n         <div class="input-device vm-hardware-generic"\n              ng-repeat="inflatedDevice in ::ctrl.inputDevices track by inflatedDevice.getKey()"\n              ng-bind="vmHardwareOtherCtrl.getSummaryText(inflatedDevice, \'InputDevice\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n\n\n\n\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwarePciDevice/vm-hw-pci-device.html','<clr-stack-block\n   class="vm-hardware-usb-controller"\n   deviceLabel="$ctrl.deviceLabel">\n\n   <clr-stack-label test-id="pci-block-label">{{$ctrl.deviceLabel}}\n      <span class="vx-icon-warn" ng-if="$ctrl.showDeviceWarning()"></span>\n   </clr-stack-label>\n\n   <!--Header section - device selector and removal icon -->\n\n   <clr-stack-content ng-if="!$ctrl.isMarkedForRemoval()">\n\n      <div class="select"><select ng-model="$ctrl.deviceValue" test-id="pci-label"\n                                  ng-disabled="$ctrl.isEditDeviceValueDisabled()"\n              ng-options="item as item.label for item in $ctrl.deviceList() track by item.key">\n      </select></div>\n\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n         ng-click="$ctrl.removeDevice()" ng-disabled="$ctrl.isRemoveDisabled()" test-id="remove"></a>\n\n   </clr-stack-content>\n\n   <!--Alternate header when device marked for removal -->\n\n   <clr-stack-content ng-if="$ctrl.isMarkedForRemoval()">\n      {{ $ctrl.i18nService.getString(\'VmUi\', \'RemoveDevice.DeviceRemoved\') }}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.revertRemoval()" test-id="restore"> </a>\n   </clr-stack-content>\n\n   <!--Reserve memory-->\n\n   <clr-stack-block ng-if="$ctrl.showMemorySection()">\n      <clr-stack-label></clr-stack-label>\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="mem-txt">{{$ctrl.i18n(\'Warning\')}}</span>\n         </div>\n      </clr-stack-content>\n\n      <clr-stack-content>\n         <button ng-click="$ctrl.reserveAllMemory()" test-id="mem-btn">\n            {{$ctrl.i18n("Reserve")}}\n         </button>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Note: Some virtual machine operations are unavailable when PCI/PCIe passthrough devices are present. -->\n   <!--You cannot suspend, migrate with vMotion, or take or restore snapshots of such virtual machines.-->\n\n   <clr-stack-block>\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="note">{{$ctrl.i18n(\'Note\')}}</span></div>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwarePciDevice/vm-hw-pci-shared.html','<clr-stack-block class="vm-hardware-usb-controller">\n\n   <!-- Warning icon (when not all memory is reserved) -->\n\n   <clr-stack-label test-id="pci-block-label">{{$ctrl.deviceLabel}}\n      <span class="vx-icon-warn" ng-if="$ctrl.showDeviceWarning()"></span>\n   </clr-stack-label>\n\n   <!--Header section -->\n\n   <clr-stack-content ng-if="!$ctrl.isMarkedForRemoval()">\n      <div class="select"><select ng-model="$ctrl.pluginValue"\n                                  ng-options="item as item for item in $ctrl.pluginList">\n      </select></div>\n      <a test-id="remove"\n         class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n         ng-click="$ctrl.removeDevice()" ng-disabled="$ctrl.isRemoveDisabled()"></a>\n   </clr-stack-content>\n\n   <!--Alternate header when device marked for removal -->\n\n   <clr-stack-content ng-if="$ctrl.isMarkedForRemoval()">\n      {{ $ctrl.i18nService.getString(\'VmUi\', \'RemoveDevice.DeviceRemoved\') }}\n      <a test-id="restore"\n         class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n      <a test-id="restsore"\n         class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <!-- GPU profile selector -->\n\n   <clr-stack-block>\n      <clr-stack-label>{{ ::$ctrl.i18n("GPUProfile")}}</clr-stack-label>\n      <!--Either select dropdown or input text -->\n\n      <clr-stack-content ng-if="$ctrl.isProfileSelectVisible()">\n         <div class="select"><select ng-model="$ctrl.profile" ng-disable="$ctrl=isProfileValueDisabled()"\n                                     ng-options="item as item for item in $ctrl.profileList">\n         </select></div>\n      </clr-stack-content>\n\n      <clr-stack-content ng-if="$ctrl.isProfileInputVisible()">\n         <input type="text" ng-model="$ctrl.profile" ng-disable="$ctrl=isProfileValueDisabled()"/>\n      </clr-stack-content>\n\n   </clr-stack-block>\n\n   <!--Reserve memory-->\n\n   <clr-stack-block ng-if="$ctrl.showMemorySection()">\n      <clr-stack-label></clr-stack-label>\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="mem-txt">{{$ctrl.i18n(\'Warning\')}}</span>\n         </div>\n      </clr-stack-content>\n\n      <clr-stack-content>\n         <button ng-click="$ctrl.reserveAllMemory()" test-id="mem-btn">\n            {{$ctrl.i18n("Reserve")}}\n         </button>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Note: Some virtual machine operations are unavailable when PCI/PCIe passthrough devices are present. -->\n   <!--You cannot suspend, migrate with vMotion, or take or restore snapshots of such virtual machines.-->\n\n   <clr-stack-block>\n      <clr-stack-content>\n         <div><span class="vx-icon-warn"></span><span test-id="note">{{$ctrl.i18n(\'Note\')}}</span>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareRDMVirtualDisk/vm-hardware-rdm-virtual-disk.html','<clr-stack-block\n      class="virtual-disk"\n      ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.hasChanged()}"\n      ng-form\n      name="$ctrl.vmHardwareRdmVirtualDisk{{$ctrl.formKey}}"\n      [(clr-sb-expanded)]="$ctrl.expanded"\n      (clr-sb-expanded-change)="$ctrl.expandedChanged($event)"\n      [(clr-sb-expandable)]="$ctrl.isExpandable()"\n      ng-switch="$ctrl.expanded">\n\n   <clr-stack-label ng-class="{\'error-child-component\': $ctrl.hasError()}">\n      <span>{{::$ctrl.deviceLabel}}</span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if="$ctrl.markedForRemoval()">\n      {{::$ctrl.deviceRemovedLabel}}\n      <label class="normal-weight" ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         <input name="destroyDisk"\n                aria-label="{{::$ctrl.deviceRemovedLabel}}"\n                type="checkbox"\n                ng-model="$ctrl.destroyDisk"\n                ng-change="$ctrl.onDiskDistroyStatusChange()"\n         />\n\n         <span tabindex="0" ng-bind="::$ctrl.deleteFilesLabel"></span>\n      </label>\n      <a tabindex="0" aria-label="{{::$ctrl.revertRemovalLabel}}"\n            class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <clr-stack-content ng-if="!$ctrl.markedForRemoval()">\n      <div tabindex="0" ng-if="$ctrl.isGroupingHardDisks">\n         {{$ctrl.getDiskText()}} | {{$ctrl.getSelectedVirtualNodeText()}}\n\t  </div>\n      <div>\n         <vx-value-in-units name="capacity"\n                            ng-if="$ctrl.capacity.validUnits && !$ctrl.isGroupingHardDisks"\n                            is-disabled="true"\n                            type="number"\n                            ng-model-options = "{allowInvalid: true,\n                                 getterSetter: true}"\n                            ng-model="$ctrl.capacity.valueInMB"\n                            unit-options="$ctrl.capacity.validUnits"\n                            min="{{$ctrl.capacity.minInMB}}"\n                            max="{{$ctrl.capacity.maxInMB}}"\n                            default-unit="{{$ctrl.capacity.memoryUnitPreferred}}"\n                            error-messages="$ctrl.errorMessages"\n                            custom-validators="$ctrl.validators">\n         </vx-value-in-units>\n      </div>\n\n      <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n         ng-disabled="$ctrl.isRemoveDisabled()"\n         tabindex="0"\n         aria-label="{{::$ctrl.removeLabel}}"\n         ng-click="$ctrl.onRemove()"></a>\n   </clr-stack-content>\n\n   <!-- Dummy element to render when not expanded to force label to take space -->\n   <clr-stack-block ng-if="!$ctrl.expanded">\n      <clr-stack-label>\n      </clr-stack-label>\n      <clr-stack-content>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Storage Profile -->\n   <clr-stack-block ng-if="$ctrl.shouldDisplayStorageProfile">\n      <clr-stack-label ng-attr-title="{{ ::$ctrl.storageProfileLabel }}"\n                       ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.storageProfileLabel}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div>\n            <div>\n               <vm-hardware-virtual-disk-storage-profile\n                  name="storage-profile"\n                  aria-label="$ctrl.storageProfileLabel"\n                  display-mode="$ctrl.displayMode"\n                  vm-storage-profile-metadata="$ctrl.vmStorageProfileMetadata"\n                  on-change="$ctrl.onStorageProfileChange(selectedProfile)"\n                  error-config="$ctrl.diskProfileErrorConfig">\n               </vm-hardware-virtual-disk-storage-profile>\n            </div>\n            <div ng-if="$ctrl.isEncryptionProfileApplied()">\n               <clr-icon shape="info-circle" class="is-highlight" size="20"></clr-icon>\n               <span tabindex="0">{{::$ctrl.i18n(\'DiskPage.encryptionPolicyDecription\')}}</span>\n            </div>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Disk Location -->\n   <clr-stack-block class="vm-disk-block" ng-if="$ctrl.isNewDevice()">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.locationLabel}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-location\n            display-mode="$ctrl.displayMode"\n            aria-label="$ctrl.locationLabel"\n            vm-storage-profile-metadata="$ctrl.vmStorageProfileMetadata"\n            vm-storage-browser-metadata="$ctrl.vmStorageBrowserMetadata"\n            on-change="$ctrl.onLocationChange(selectedStorageProfile, selectedStorageItem)"\n            vm-id="$ctrl.vmId"\n            disk-location-error="$ctrl.diskLocationError"\n            datastore="$ctrl.vmConfigContext.environment.configTarget.datastore"\n            selected-storage="$ctrl.selectedStorage"\n            show-storage-pods="$ctrl.showStoragePods">\n         </vm-hardware-virtual-disk-location>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Disk Sharing-->\n   <clr-stack-block ng-switch-when="true">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.sharingLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-sharing\n            aria-label="$ctrl.sharingLabel"\n            display-mode="$ctrl.displayMode"\n            sharing-info="$ctrl.sharingInfo"\n            on-change="$ctrl.onSharingChange(sharing)">\n         </vm-hardware-virtual-disk-sharing>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Physical LUN -->\n   <clr-stack-block ng-if="$ctrl.shouldDisplayPhysicalLun">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.physicalLunLabel}}\n      </clr-stack-label>\n      <clr-stack-content class="wrap-content">\n         <span tabindex="0"\n               aria-label="{{$ctrl.physicalLunLabel + \' - \' + $ctrl.physicalLunInfo.name}}">\n            {{::$ctrl.physicalLunInfo.name}}\n         </span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Disk Compatibility Mode -->\n   <clr-stack-block ng-if="$ctrl.shouldDisplayCompatibilityMode">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.compatibilityModeLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-compatibility-mode\n            aria-label="$ctrl.compatibilityModeLabel"\n            is-disabled="!$ctrl.isCompatibilityModeEditable"\n            compatibility-mode-info="$ctrl.compatibilityModeInfo"\n            on-change="$ctrl.onCompatibilityModeChange(compatibilityMode)">\n         </vm-hardware-virtual-disk-compatibility-mode>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Disk Mode -->\n   <clr-stack-block ng-if="$ctrl.shouldDisplayDiskMode">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.diskModeLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-mode\n            is-disabled="$ctrl.isDiskModeDisabled()"\n            aria-label="$ctrl.diskModeLabel"\n            disk-mode-info="$ctrl.diskModeInfo"\n            on-change="$ctrl.onDiskModeChange(diskMode)">\n         </vm-hardware-virtual-disk-mode>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Disk Provisioning-->\n\n   <!--Disk Page-->\n   <clr-stack-block ng-if="$ctrl.displayDiskFile">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.diskFileLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <span tabindex="0"\n         aria-label="{{$ctrl.diskFileLabel + \' - \' + $ctrl.diskFile}}">\n            {{$ctrl.diskFile}}\n         </span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Disk Shares-->\n   <clr-stack-block ng-switch-when="true">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.sharesLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-shares display-mode="$ctrl.displayMode"\n                                          aria-label="$ctrl.sharesLabel"\n                                          shares-context="$ctrl.sharesContext"\n                                          is-disabled="$ctrl.isSharesDisabled()"\n                                          on-change="$ctrl.onSharesChange(shares)">\n         </vm-hardware-virtual-disk-shares>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Limit IOPS-->\n   <clr-stack-block ng-switch-when="true">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.iopsLimitLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-iops iops-limit="$ctrl.iopsLimit"\n                                        aria-label="$ctrl.iopsLimitLabel"\n                                        on-change="$ctrl.onIopsLimitChange(iopsLimit)"\n                                        is-disabled="$ctrl.isEditIopsLimitDisabled()">\n         </vm-hardware-virtual-disk-iops>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Cache Reservation-->\n   <clr-stack-block ng-if="$ctrl.shouldDisplayFlashCache">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.cacheReservationLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-flash-read-cache flash-cache-reservation-info="$ctrl.flashCacheInfo"\n                                                    aria-label="$ctrl.cacheReservationLabel"\n                                                    is-disabled="$ctrl.isFlashCacheReservationDisabled"\n                                                    on-change="$ctrl.onFlashCacheReservationChange(flashCacheReservation)">\n         </vm-hardware-virtual-disk-flash-read-cache>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Virtual Device Node-->\n   <clr-stack-block ng-switch-when="true">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': $ctrl.isGroupingHardDisks}">\n         {{::$ctrl.deviceNodeLabel}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-controller-and-node\n            inflated-device="$ctrl.deviceNodeInfo.inflatedDevice"\n            virtual-machine-devices="$ctrl.deviceNodeInfo.virtualMachineDevices"\n            selector-name="$ctrl.deviceNodeInfo.controllerNodeSelectorName"\n            controller-selector-name="$ctrl.deviceNodeInfo.controllerSelectorName"\n            available-controllers="$ctrl.deviceNodeInfo.virtualDiskSettingsForm.controllers.options"\n            device-controller="$ctrl.deviceNodeInfo.virtualDiskSettingsForm.controllers.selection"\n            node="$ctrl.deviceNodeInfo.virtualDiskSettingsForm.selectedControllerNode"\n            power-state="$ctrl.deviceNodeInfo.vmConfigContext.environment.powerState"\n            privileges="$ctrl.deviceNodeInfo.vmConfigContext.privileges"\n            on-controller-change-callback="$ctrl.onDiskControllerChange"\n            >\n         </vm-hardware-controller-and-node>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareScsiController/vmHardwareScsiController.html','<clr-stack-block\n      class="vm-hardware-scsi-controller"\n      ng-form\n      name="$ctrl.vmHardwareScsiControllerForm"\n      ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.inflatedDevice.hasChanged()}"\n      [(clr-sb-expanded)]="$ctrl.expanded">\n    <clr-stack-label>\n        {{ $ctrl.device.deviceInfo.label }}\n    </clr-stack-label>\n\n    <clr-stack-content ng-if="$ctrl.inflatedDevice.isMarkedForRemoval()">\n        {{::$ctrl.i18n(\'RemoveDevice.DeviceRemoved\')}}\n        <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n           ng-click="$ctrl.inflatedDevice.revertRemoval()">\n        </a>\n    </clr-stack-content>\n    <clr-stack-content ng-if="!$ctrl.inflatedDevice.isMarkedForRemoval()">\n        <label class="normal-weight" name="deviceType">\n          {{ $ctrl.deviceName }}\n        </label>\n        <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n           ng-disabled="!$ctrl.isRemoveScsiControllerEnabled()"\n           ng-click="$ctrl.onScsiControllerRemove()"></a>\n    </clr-stack-content>\n\n    <clr-stack-block>\n        <clr-stack-label>\n            {{ ::$ctrl.LBL_TYPE }}\n        </clr-stack-label>\n        <clr-stack-content>\n            <div class="select">\n                <select name="editScsiController{{$ctrl.device.key}}TypeList"\n                        aria-label="{{::$ctrl.LBL_TYPE}}"\n                        ng-disabled="$ctrl.isEditScsiControllerDisabled()"\n                        ng-model="$ctrl.properties.selectedScsiType"\n                        ng-options="scsiType.name for scsiType in $ctrl.scsiTypeList track by scsiType.id"\n                        ng-change="$ctrl.onScsiControllerTypeChange()">\n                </select>\n            </div>\n            <div class="unsupported-scsi-type-warning" ng-if="$ctrl.unsupportedWarning">\n                <span class="vx-icon-warn"></span>\n                <span>{{$ctrl.unsupportedWarning}}</span>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block>\n        <clr-stack-label>\n            {{ ::$ctrl.LBL_SHARING }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <div class="select">\n               <select name="editBusSharing{{$ctrl.device.key}}List"\n                       aria-label="{{::$ctrl.LBL_SHARING}}"\n                       ng-disabled="$ctrl.isEditScsiControllerDisabled()"\n                       ng-model="$ctrl.properties.selectedBusSharing"\n                       ng-change="$ctrl.onScsiBusSharingChange()"\n                       ng-options="busSharing.name for busSharing in $ctrl.busSharingList track by busSharing.id">\n               </select>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n\n</clr-stack-block>\n\n\n\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSerialPort/vm-hardware-serial-port-file-browser.html','<div ng-controller="vmHardwareSerialPortFileBrowserController as ctrl">\n   <span>{{ ::ctrl.i18n("SerialPortPage.FileBrowser.Subtitle") }}</span>\n\n   <form name="serialPortFileBrowserForm">\n      <section class="form-block">\n         <div class="form-group">\n            <label for="serial-port-save-as">{{ ::ctrl.i18n("SerialPortPage.FileBrowser.SaveAs") }}</label>\n            <input type="text" id="serial-port-save-as" size="35"\n                  ng-model="ctrl.formData.fileName"\n                  placeholder="{{ ::ctrl.i18n(\'SerialPortPage.FileBrowser.SaveAs.Placeholder\') }}">\n         </div>\n\n         <div class="form-group">\n            <label>{{ ::ctrl.i18n("SerialPortPage.FileBrowser.SaveTo") }}</label>\n            <datastore-file-browser\n                  object-id="ctrl.dsFileBrowserData.vmId"\n                  datastore-ids="ctrl.dsFileBrowserData.datastoreIds"\n                  initial-file-query-type="ctrl.dsFileBrowserData.initialFileQueryType"\n                  show-vm-images-folder="ctrl.dsFileBrowserData.showVmImagesFolder"\n                  disable-preselect="ctrl.dsFileBrowserData.disablePreselect"\n                  selected-tree-item="ctrl.formData.selectedTreeItem">\n            </datastore-file-browser>\n         </div>\n\n         <div class="form-group" ng-if="ctrl.hasValidFileNameAndFolderLocation()">\n            <label>{{ ::ctrl.i18n("vmProvisioningFinishPage.DiskFilePath") }}</label>\n            <span>{{ ctrl.getFilePath() }}</span>\n         </div>\n      </section>\n   </form>\n</div>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSerialPort/vm-hw-serial-port.html','<clr-stack-block\n   ng-form name="$ctrl.form"\n   ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.hasChanged}"\n   [(clr-sb-expanded)]="$ctrl.expanded">\n\n   <!-- Backing type (file, device, pipe, network) and checkbox (either connect or Connect or Connect at power on)-->\n\n   <clr-stack-label test-id="serial-block-label"\n                    ng-class="{\'error-child-component\': !$ctrl.revalidate()}">\n      <span>{{::$ctrl.deviceLabel}}</span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if=$ctrl.NotMarkedForRemoval>\n      <div class="select"><select test-id="backing"\n                                  ng-model=$ctrl.backingValue\n                                  ng-disabled=$ctrl.isEditDisabled\n                                  ng-options="item as $ctrl.getBackingLabel(item) for item in $ctrl.backingList track by $ctrl.getBackingLabel(item)"></select>\n      </div>\n\n      <label ng-if="$ctrl.showStartConnectedInHeader" ng-class={"div-disabled":$ctrl.isConnectDisabled}>\n         <input type="checkbox" test-id="startConnected"\n                ng-model=\'$ctrl.startConnected\'\n                ng-disabled="$ctrl.isConnectDisabled">\n         {{::$ctrl.LABELS.START_CONNECTED_SHORT}}\n      </label>\n\n      <label ng-if="$ctrl.showConnectedInHeader" ng-class={"div-disabled":$ctrl.isConnectDisabled}>\n         <input test-id="connected" type="checkbox" ng-model=\'$ctrl.connected\'\n                ng-disabled="$ctrl.isConnectDisabled"> {{ ::$ctrl.LABELS.CONNECTED}}\n      </label>\n\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n         ng-click="$ctrl.remove()" ng-disabled="$ctrl.isRemoveDisabled"\n         test-id="remove"></a>\n\n   </clr-stack-content>\n\n\n   <!--Alternate header when device marked for removal -->\n\n   <clr-stack-content ng-if="$ctrl.isMarkedForRemoval">\n      {{::$ctrl.LABELS.REMOVING }}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.restore()" test-id="restore"> </a>\n   </clr-stack-content>\n\n   <!--First row - label "Status", checkbox "Connect at power on"-->\n\n   <clr-stack-block>\n      <clr-stack-label>{{ ::$ctrl.LABELS.STATUS}}</clr-stack-label>\n      <clr-stack-content>\n         <label ng-class={"div-disabled":$ctrl.isConnectDisabled}>\n            <input type="checkbox" test-id="startConnected2"\n                  ng-model=\'$ctrl.startConnected\'\n                  ng-disabled="$ctrl.isConnectDisabled">\n            {{::$ctrl.LABELS.START_CONNECTED}}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- FILE BACKING -->\n\n   <clr-stack-block ng-if="$ctrl.showFileBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.OUTPUT_FILE}}</clr-stack-label>\n      <clr-stack-content>\n\n         <label for="file" aria-haspopup="true" role="tooltip"\n               class="tooltip tooltip-validation tooltip-lg tooltip-top-left"\n               ng-class="{\'invalid\': $ctrl.isFileInvalid}">\n            <input id=file test-id="file" type="text" size="30" ng-model="$ctrl.file"\n                  placeholder={{::$ctrl.filePlaceHolder}} disabled>\n            <span class="tooltip-content">{{$ctrl.fileError}}</span>\n         </label>\n\n         <button class="btn btn-sm btn-link" id="browse" test-id="browse"\n               ng-disabled="$ctrl.isEditDisabled"\n               ng-click="$ctrl.browse()">\n            {{ ::$ctrl.LABELS.BROWSE}}\n         </button>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- PHYSICAL SERIAL PORT BACKING (aka device backing) -->\n\n   <clr-stack-block ng-if="$ctrl.showDeviceBacking">\n      <clr-stack-label> {{::$ctrl.LABELS.PHYSICAL}}</clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select test-id="device"\n                    ng-model="$ctrl.deviceValue"\n                    ng-disabled="$ctrl.isEditDisabled"\n                    ng-options="item as item for item in $ctrl.deviceList"></select>\n\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- URI (network) BACKING -->\n\n   <clr-stack-block ng-if="$ctrl.showURIBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.DIRECTION}}</clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select test-id="dir"\n                    ng-model="$ctrl.directionValue"\n                    ng-disabled="$ctrl.isEditDisabled"\n                    ng-options="item as $ctrl.getDirectionLabel(item) for item in $ctrl.directionList">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.showURIBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.PORT_URI}}</clr-stack-label>\n      <clr-stack-content>\n         <label for="service" aria-haspopup="true" role="tooltip"\n                class="tooltip tooltip-validation tooltip-lg tooltip-top-left"\n                ng-class="{\'invalid\': $ctrl.isServiceInvalid}">\n            <input id="service" test-id="service" type="text"\n                   ng-disabled="$ctrl.isEditDisabled"\n                   ng-model="$ctrl.serviceURI"/>\n            <span class="tooltip-content">{{$ctrl.serviceError}}</span>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.showURIBacking">\n      <clr-stack-label></clr-stack-label>\n      <clr-stack-content>\n         <input id="vspc" test-id="vspc" type="checkbox"\n               ng-disabled="$ctrl.isEditDisabled"\n               ng-model="$ctrl.vspc"/>\n         <label for="vspc" ng-class={"div-disabled":$ctrl.isEditDisabled}>\n            {{::$ctrl.LABELS.USE_VSPCURI}}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.showProxy && $ctrl.vspc">\n      <clr-stack-label> {{ ::$ctrl.LABELS.VSPCURI}}</clr-stack-label>\n      <clr-stack-content>\n         <label for="proxy" aria-haspopup="true" role="tooltip"\n                class="tooltip tooltip-validation tooltip-lg tooltip-top-left"\n                ng-class="{\'invalid\': $ctrl.isProxyInvalid}">\n            <input id="proxy" test-id="proxy" type="text" ng-model="$ctrl.proxy"\n                   ng-disabled="$ctrl.isProxyDisabled"/>\n            <span class="tooltip-content">{{$ctrl.proxyError}}</span>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- PIPE BACKING -->\n\n   <clr-stack-block ng-if="$ctrl.showPipeBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.PIPE_NAME}}</clr-stack-label>\n      <clr-stack-content>\n         <label for="pipe" aria-haspopup="true" role="tooltip"\n                class="tooltip tooltip-validation tooltip-lg tooltip-top-left"\n                ng-class="{\'invalid\': $ctrl.isPipeInvalid}">\n            <input test-id="pipe" id="pipe" type="text"\n                   ng-model="$ctrl.pipe"\n                   ng-disabled="$ctrl.isEditDisabled"\n            />\n            <span class="tooltip-content">{{$ctrl.port.getPipeError()}}</span>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.showPipeBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.NEAR_END}}</clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select test-id="near"\n                    ng-model="$ctrl.nearEndValue"\n                    ng-disabled="$ctrl.isEditDisabled"\n                    ng-options="item as $ctrl.getNearEndLabel(item) for item in $ctrl.nearEndList">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.showPipeBacking">\n      <clr-stack-label> {{ ::$ctrl.LABELS.FAR_END}}</clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select\n               test-id="far"\n               ng-model="$ctrl.farEndValue"\n               ng-disabled="$ctrl.isEditDisabled"\n               ng-options="item as $ctrl.getFarEndLabel(item) for item in $ctrl.farEndList">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded">\n      <clr-stack-label>{{::$ctrl.LABELS.IO_MODE }}</clr-stack-label>\n      <clr-stack-content>\n         <div ng-class={"disabled":$ctrl.isEditDisabled}>\n            <input type="checkbox" id="yield{{$ctrl.ID}}" test-id="yield"\n                  ng-model="$ctrl.yield"\n                  ng-disabled="$ctrl.isEditDisabled">\n            <label ng-class={"div-disabled":$ctrl.isEditDisabled}\n                  for="yield{{$ctrl.ID}}">{{::$ctrl.LABELS.YIELD_CPU}}</label>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n   <!--END OF THE PAGE -->\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/tpm-help-text.html','<div>\n    <p class="tpm-help-text">\n        {{actionableText}}\n        {{extraText}}\n        <a target="_blank"\n           href="{{kbArticleLink}}">\n            {{linkLabel}}\n        </a>\n    </p>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/vm-hardware-tpm.component.html','<clr-modal\n        [(clr-modal-open)]="$ctrl.showModal"\n        [clr-modal-closable]="true"\n        class="delete-tpm-modal">\n    <h3 class="modal-title">\n        {{ ::$ctrl.i18n(\'VmDeviceManager.TpmModal.Title\') }}\n    </h3>\n    <div class="modal-body">\n        <p>\n            {{ ::$ctrl.i18n(\'VmDeviceManager.TpmModal.Body\') }}\n        </p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-outline" ng-click="$ctrl.onCancelModalWarning()">\n            {{ ::$ctrl.i18n(\'VmDeviceManager.TpmModal.Footer.CancelButton\') }}\n        </button>\n        <button type="button" class="btn btn-warning" ng-click="$ctrl.onAcceptModalWarning()">\n            {{ ::$ctrl.i18n(\'VmDeviceManager.TpmModal.Footer.DeleteButton\') }}\n        </button>\n    </div>\n</clr-modal>\n\n<clr-stack-block\n        class="vm-hardware-tpm"\n        name="vmHardwareCdRomForm{{$ctrl.tpmDevice.getCurrentDevice().key}}"\n        ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.tpmDevice.hasChanged()}">\n   <clr-stack-label class="tpm_label">\n         {{ ::$ctrl.i18n(\'VmDeviceManager.NewTPM\') }}\n   </clr-stack-label>\n\n    <clr-stack-content ng-if="$ctrl.tpmDevice.isMarkedForRemoval()">\n        <span>\n            {{ ::$ctrl.i18n(\'RemoveDevice.DeviceRemoved\') }}\n        </span>\n        <a aria-label="{{ ::$ctrl.i18n(\'RemoveDevice.RevertRemoval\')}}"\n              class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n           ng-click="$ctrl.tpmDevice.revertRemoval()">\n        </a>\n    </clr-stack-content>\n    <clr-stack-content ng-if="!$ctrl.tpmDevice.isMarkedForRemoval()">\n        <span>\n            <label class="normal-weight">\n                <span ng-if="$ctrl.tpmDevice.state === $ctrl.tpmDevice.CONNECTED">\n                    {{ $ctrl.i18n(\'VmDeviceManager.TPMPresent\') }}\n                </span>\n\n                <span ng-if="$ctrl.tpmDevice.state === $ctrl.tpmDevice.CONNECTING">\n                    {{ $ctrl.i18n(\'VmDeviceManager.TPMConnecting\') }}\n                </span>\n\n                <span class="error-border" ng-if="$ctrl.tpmDevice.state === $ctrl.tpmDevice.NOT_CONNECTED">\n                    {{ $ctrl.i18n(\'VmDeviceManager.TPMInvalid\') }}\n                </span>\n            </label>\n            <a vui-sign-post="$ctrl.tpmSignPostParams" class="pull-right ng-isolate-scope k-state-border-down">\n                <img ng-src="resources/img/info_normal.png" src="resources/img/info_normal.png">\n            </a>\n        </span>\n        <a ng-class="{\'div-disabled\': $ctrl.isTpmRemovalDisabled()}"\n           aria-label="{{ ::$ctrl.i18n(\'VmDeviceManager.TPMRemove\')}}"\n           class="vsphere-icon-action-remove remove-device stack-view-row-action"\n           ng-disabled="$ctrl.isTpmRemovalDisabled()"\n           ng-click="$ctrl.onTpmRemoval()"></a>\n    </clr-stack-content>\n\n   <clr-stack-block ng-repeat="tpmCertificate in $ctrl.tpmCertificates">\n      <clr-stack-label>\n         {{ tpmCertificate.algorithmName }}-{{tpmCertificate.publicKeyAlgorithmName}}\n      </clr-stack-label>\n      <clr-stack-content>\n             <tpm-certificate-selector\n                    tpm-certificate="tpmCertificate"\n                    on-certificate-change="$ctrl.onCertificateUpdate(uploadedCertificate, originalCertificate)"\n             >\n             </tpm-certificate-selector>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareUsbController/vm-hardware-usb-controller.html','<clr-stack-block [(clr-sb-expanded)]="$ctrl.expanded" class="vm-hardware-usb-controller">\n\n   <clr-stack-label>{{$ctrl.getDeviceLabel()}}\n      <span class="vx-icon-warn" ng-if="$ctrl.isUnsupportedByGuest()"/>\n   </clr-stack-label>\n\n   <!--Header section -->\n\n   <clr-stack-content ng-if="!$ctrl.isMarkedForRemoval()">\n\n      <!-- Readonly label 2.0 vs 3.0 for existing USB controller-->\n\n      <label data-test-id="usb-type-label-id" ng-if="!$ctrl.isUsbTypeEditable()">\n         {{$ctrl.getUSBLabel()}}\n      </label>\n\n      <!-- Selectable USB type ( 2.0 vs 3.0) - when adding USB controller -->\n\n      <div class="select" ng-if="$ctrl.isUsbTypeEditable()">\n         <select data-test-id="usb-type-select-id"\n                 aria-label="{{::$ctrl.getDeviceLabel()}}"\n                 ng-model="$ctrl.usbType"\n                 ng-options="item as $ctrl.getUsbTypeLabel(item) for item in $ctrl.getUsbTypeList()">\n         </select>\n      </div>\n\n      <!-- Device removal icon-->\n\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n         ng-disabled="$ctrl.isRemoveDisabled()"\n         ng-click="$ctrl.removeDevice()"></a>\n\n   </clr-stack-content>\n\n   <!--Alternate header when device marked for removal -->\n\n   <clr-stack-content ng-if="$ctrl.isMarkedForRemoval()">\n      {{ ::$ctrl.i18nService.getString(\'VmUi\', \'RemoveDevice.DeviceRemoved\') }}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <!--Body section - guest warning text as needed -->\n\n   <clr-stack-block>\n      <clr-stack-content>\n         <div ng-if="$ctrl.isUnsupportedByGuest()">\n            <span class="vx-icon-warn"/>\n            <span>{{$ctrl.i18n(\'NoGuestDriver\')}}</span>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareUsbDevice/vm-hardware-usb-device.html','<clr-stack-block [(clr-sb-expanded)]="$ctrl.expanded"\n      class="vm-hardware-usb-controller"\n      ng-form name="$ctrl.vmHardwareUsbDevice">\n\n   <clr-stack-label ng-class="{ \'error-child-component\': $ctrl.hasError() }">\n      <span>{{$ctrl.getDeviceLabel()}}</span>\n   </clr-stack-label>\n\n   <!--Header section -->\n\n   <!--Selector to choose host USB device (new device only) -->\n\n   <clr-stack-content ng-if="$ctrl.isNew()">\n\n      <div class="select" ng-if="$ctrl.isNew()" ng-class="{ \'has-error\' : $ctrl.hasError() }">\n         <select name="newDevice"\n                 test-id="usb-select"\n                 ng-model="$ctrl.hostUsb"\n                 ng-change="$ctrl.validateUSBSelection()"\n                 ng-options="item as $ctrl.getHostUsbLabel(item) for item in $ctrl.getHostUsbList() track by item.physicalPath"\n                 vx-error="$ctrl.usbError">\n         </select>\n      </div>\n\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"  ng-if="$ctrl.isNew()"  ng-click="$ctrl.removeDevice()" ></a>\n\n   </clr-stack-content>\n\n   <!--Readonly label showing Host USB device (editing device) -->\n\n   <clr-stack-content ng-if="!$ctrl.isNew()">\n\n      <label test-id="usb-device-label"\n             ng-if="!$ctrl.isMarkedForRemoval()">\n         {{$ctrl.getUsbDeviceLabel()}}\n      </label>\n\n      <!-- Device removal icon-->\n\n      <a class="vsphere-icon-action-remove pull-right remove-device stack-view-row-action"\n         ng-if="!$ctrl.isNew() && !$ctrl.isMarkedForRemoval()"\n         ng-disabled="$ctrl.isRemoveDisabled()"\n         ng-click="$ctrl.removeDevice()"></a>\n\n   </clr-stack-content>\n\n\n   <!--Alternate header when device marked for removal/restore icons -->\n\n   <clr-stack-content ng-if="$ctrl.isMarkedForRemoval()">\n      {{ ::$ctrl.i18nService.getString(\'VmUi\', \'RemoveDevice.DeviceRemoved\') }}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         ng-click="$ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <!--showing existing device-->\n\n   <!-- Row 1 - says: "USB Device ||| This device is currently present/not present on the host  "-->\n\n   <clr-stack-block ng-if="!$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'USBDevice\')}}</clr-stack-label>\n      <clr-stack-content>\n         <label test-id="device-present">\n            {{ ::($ctrl.isDevicePresent()? $ctrl.i18n(\'Present\'):\n            $ctrl.i18n(\'NotPresent\')) }}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Row 2 - says:  USB Unique ID ||| host:bla1 path: bla2 -->\n\n   <clr-stack-block ng-if="!$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'USBUniqueID\')}}</clr-stack-label>\n      <clr-stack-content><label test-id="unique-id">{{ ::$ctrl.USBUniqueID}}</label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Row 3 - says : Status Connected/Disconnected -->\n\n   <clr-stack-block ng-if="!$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'Status\')}}</clr-stack-label>\n      <clr-stack-content><label test-id="connection-status">{{\n         ::$ctrl.getUSBConnectionStatusText()}}</label></clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Row 4 - says: vMotion support |||\n   - Connection to this device will persist through a migration with vMotion\n   OR\n   - Cannot migrate with vMotion while device is connected.\n   -->\n\n   <clr-stack-block ng-if="!$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'VMotionSupport\')}}</clr-stack-label>\n      <clr-stack-content>\n         <label data-test-id="vmotion-support">{{\n            ::$ctrl.getVMotionSupportText()}}</label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--ADDING NEW DEVICE - only visible when adding new USB device -->\n\n   <!--Dumb port from C# - if device configured AND connected to another running VM - show that VM  -->\n\n   <clr-stack-block ng-if="$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'SelectHostDevice\')}}</clr-stack-label>\n      <clr-stack-content><label test-id="device-available">{{\n         $ctrl.getDeviceAvailableText()}}</label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!-- Checkbox for vMotion -->\n\n   <clr-stack-block ng-if="$ctrl.isNew()">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'VMotionSupport\')}}</clr-stack-label>\n\n      <clr-stack-content>\n         <label><input type="checkbox"  name="vMotion" ng-model="$ctrl.vMotion"/>{{ ::$ctrl.i18n(\'VMotionConnected\')}}</label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVideoCard/vm-hw-video-card.html','<clr-stack-block\n   class="video"\n   ng-form name="$ctrl.vmHardwareVideoCardForm"\n   ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.hasChanged()}"\n   [(clr-sb-expanded)]="$ctrl.expanded">\n\n   <clr-stack-label ng-class="{\'error-child-component\': $ctrl.hasError()}">\n      <span>{{ ::$ctrl.i18n(\'Title\') }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div class="select">\n         <select\n            test-id="useAutoDetect"\n            aria-label="{{::$ctrl.ARIA_LBL_VIDEO}}"\n            ng-model="$ctrl.useAutoDetect"\n            ng-disabled="$ctrl.useAutoDetect_isEditDisabled()"\n            ng-options="item as $ctrl.useAutoDetect_Text(item) for item in $ctrl.useAutoDetect_List()"></select>\n      </div>\n      </select>\n   </clr-stack-content>\n\n   <clr-stack-block>\n\n      <clr-stack-label>{{ $ctrl.i18n(\'NumberOfDisplays\') }}</clr-stack-label>\n\n      <clr-stack-content ng-if="$ctrl.expanded">\n         <div class="select">\n            <select test-id="numberOfDisplays"\n                    aria-label="{{::$ctrl.ARIA_LBL_NUM_DISPLAYS}}"\n                    ng-model="$ctrl.numberOfDisplays"\n                    ng-disabled="$ctrl.numberOfDisplays_isEditDisabled()"\n                    ng-options="item as item for item in $ctrl.numberOfDisplays_List() track by item"></select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded">\n      <clr-stack-label>{{ $ctrl.i18n(\'TotalVideoMemory\') }}</clr-stack-label>\n      <clr-stack-content>\n\n         <label aria-haspopup="true" role="tooltip"\n                class="tooltip tooltip-validation  tooltip-lg tooltip-top-left"\n                ng-class="{\'invalid\': $ctrl.videoRamSizeInKB_isInvalid()}">\n\n            <input type="text"\n                   aria-label="{{::$ctrl.ARIA_LBL_VRAM}}"\n                   test-id="videoRamSizeInKB"\n                   name="videoRamSizeInKB"\n                   ng-model="$ctrl.videoRamSizeInKB"\n                   ng-disabled="$ctrl.videoRamSizeInKB_isEditDisabled()"/>\n\n            <span class="tooltip-content">{{ $ctrl.videoRamSizeInKB_getError() }}</span></label>\n         <span>{{::$ctrl.i18n(\'MB\')}}</span>\n\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded && $ctrl.enable3DSupport_isVisible()">\n      <clr-stack-label>\n         {{ ::$ctrl.i18n(\'3DGraphics\') }}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <input type="checkbox"\n                aria-label="{{::$ctrl.ARIA_LBL_3D}}"\n                test-id="enable3DSupport"\n                ng-model="$ctrl.enable3DSupport"\n                ng-disabled="$ctrl.enable3DSupport_isEditDisabled()"/>\n         <span ng-class="{\'div-disabled\': $ctrl.enable3DSupport_isEditDisabled()}">{{::$ctrl.i18n(\'Enable3DSupport\')}}</span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded && $ctrl.getAutoIncreaseVisible()">\n      <span >{{ $ctrl.getAutoIncreaseText() }}</span>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded && $ctrl.use3dRenderer_isVisible()">\n      <clr-stack-label>{{ $ctrl.i18n(\'3DRenderer\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select\n                 test-id="use3dRenderer"\n                 aria-label="{{$ctrl.ARIA_LBL_3DRNDR}}"\n                 ng-model="$ctrl.use3dRenderer"\n                 ng-disabled="$ctrl.use3dRenderer_isEditDisabled()"\n                 ng-options="item as $ctrl.use3dRenderer_Text(item) for item in $ctrl.use3dRenderer_List() track by item">\n         </select></div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.expanded && $ctrl.graphicsMemorySizeInMB_isVisible()">\n      <clr-stack-label>{{ $ctrl.i18n(\'3DMemory\') }}</clr-stack-label>\n      <clr-stack-content>\n         <label ng-class="{\'invalid\': $ctrl.graphicsMemorySizeInMB_isInvalid()}"\n                aria-haspopup="true"\n                role="tooltip"\n                class="tooltip tooltip-validation tooltip-lg tooltip-top-left">\n            <input type="text"\n                   aria-label="{{::$ctrl.ARIA_LBL_3DRAM}}"\n                   name="graphicsMemorySizeInMB"\n                   test-id="graphicsMemorySizeInMB"\n                   ng-model="$ctrl.graphicsMemorySizeInMB"\n                   ng-disabled="$ctrl.graphicsMemorySizeInMB_isEditDisabled()"/>\n\n            <span\n               class="tooltip-content">{{ $ctrl.graphicsMemorySizeInMB_getError() }}</span></label>\n         <span>{{::$ctrl.i18n(\'MB\')}}</span>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/select-iso-file.view.html','<div>\n   <datastore-file-browser\n      object-id="modalOptions.dsFileBrowserData.datastoreBrowserId"\n      datastore-ids="modalOptions.dsFileBrowserData.datastoreIds"\n      initial-file-query-type="modalOptions.dsFileBrowserData.initialFileQueryType"\n      filter-file-query-types="modalOptions.dsFileBrowserData.filterFileQueryTypes"\n      show-vm-images-folder="modalOptions.dsFileBrowserData.showVmImagesFolder"\n      selected-file-changed="modalOptions.dsFileBrowserData.selectedFileChanged(selectedFile)"\n      tabindex="0"\n      autofocus>\n   </datastore-file-browser>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmDatastoreLocationBrowserDialog.html','<div ng-controller="VmDatastoreLocationBrowserController as ctrl"\n     class="flex-column fill-parent">\n    <span>\n        {{ctrl.descriptionText}}\n    </span>\n   <storage-locator\n         class="flex-column flex-auto storage-selector-dialog"\n         storage-locator-items-data="modalOptions.storageData.storageLocatorItemsData"\n         selected-item="modalOptions.storageData.selectedStorageItem"\n         storage-profiles-data="modalOptions.storageProfilesData"\n         pod-display-disabled="modalOptions.disableSdrs"\n         datagrid-preselect="true"\n         on-selection-changed="modalOptions.onSelectionChanged(selectedItem)"\n         tabindex="0"\n         autofocus>\n   </storage-locator>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmHardwareVirtualDisk.html','<clr-stack-block\n   class="virtual-disk"\n   ng-class="{\'vm-ui-stackBlockEdited\': ctrl.inflatedDevice.hasChanged(),\n               \'virtual-disk-grouped\': ctrl.isGroupingHardDisks}"\n   ng-form\n   device-label="{{ctrl.deviceName}}"\n   name="ctrl.vmHardwareVirtualDiskForm{{ctrl.formKey}}"\n   [(clr-sb-expandable)]="ctrl.isExpandable()"\n   [(clr-sb-expanded)]="ctrl.expanded"\n   (clr-sb-expanded-change)="ctrl.expandedChanged($event)"\n   ng-switch="ctrl.expanded">\n\n   <clr-stack-label ng-class="{\'error-child-component\': ctrl.hasError()}">\n      <span>{{ ::ctrl.deviceName }}</span>\n   </clr-stack-label>\n\n\n   <clr-stack-content ng-if="ctrl.inflatedDevice.isMarkedForRemoval()">\n      <span ng-if="!ctrl.isPmemDisk">\n         {{::ctrl.i18n(\'VmUi\', \'RemoveDevice.DeviceRemoved\')}}\n      </span>\n      <span ng-if="ctrl.isPmemDisk">\n         {{::ctrl.i18n(\'VmUi\', \'RemoveDevice.DeviceAndContentsRemoved\')}}\n      </span>\n\n      <label class="normal-weight" ng-if="!ctrl.isPmemDisk">\n         <input name="diskDestroyFileOperation"\n                aria-label="{{::ctrl.ARIA_LBL_DESTROY}}"\n                type="checkbox"\n                ng-model="ctrl.deleteFilesFromDisk"\n                ng-change="ctrl.updateDiskFileOperation()"\n         />\n\n         <span ng-bind="::ctrl.i18n(\'VmUi\', \'DeviceDeletedControl.DeleteFiles\')"></span>\n      </label>\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n         aria-label="{{::ctrl.ARIA_LBL_RESTORE}}"\n         ng-click="ctrl.revertRemoval()">\n      </a>\n   </clr-stack-content>\n\n   <clr-stack-content ng-if="!ctrl.inflatedDevice.isMarkedForRemoval()">\n      <div class="hdd-label">\n         <div ng-if="ctrl.shouldShowDiskSizeLabelOnly()">\n            {{ctrl.getDiskText()}} | {{ctrl.getSelectedVirtualNodeText()}}\n         </div>\n         <vx-value-in-units name="editDisk{{ctrl.formKey}}"\n                            ng-if="!ctrl.shouldShowDiskSizeLabelOnly()"\n                            is-disabled="ctrl.shouldDisableDiskEdit()"\n                            type="number"\n                            ng-model-options = "{allowInvalid: true}"\n                            ng-model="ctrl.virtualDiskSettingsForm.capacity.valueInMB"\n                            unit-options="ctrl.virtualDiskSettingsForm.capacity.validUnits"\n                            unit-changed-callback="ctrl.onUnitChanged"\n                            min="{{ctrl.getMin()}}"\n                            max="{{ctrl.getMax()}}"\n                            default-unit="{{ctrl.virtualDiskSettingsForm.capacity.memoryUnitPreferred.label}}"\n                            error-messages="ctrl.errorMessages"\n                            custom-validators="ctrl.customValidators"\n                            ng-change="ctrl.onValueChanged()"\n                            unit-aria-label="ctrl.ARIA_LBL_CAPACITY"\n                            quantity-caret-aria-label="ctrl.ARIA_LBL_CAPACITY"\n                            quantity-aria-label="ctrl.ARIA_LBL_CAPACITY"\n                            style="flex: 0 0 auto">\n         </vx-value-in-units>\n\n         <div ng-if="ctrl.getDiskEncryptionStatus()">\n            <clr-icon shape="info-circle" class="is-highlight" size="20"></clr-icon>\n            <span>{{ctrl.getDiskEncryptionStatus()}}</span>\n         </div>\n\n         <vsc-sign-post ng-if="ctrl.isPmemDisk"\n               class="pmem-label"\n               [sign-post-position]="\'top-left\'"\n               [sign-post-content]="ctrl.i18n(\'VmUi\', \'DiskPage.pmemDisk\')">\n         </vsc-sign-post>\n      </div>\n\n      <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n         tabIndex="0"\n         aria-label="{{::ctrl.ARIA_LBL_REMOVE}}"\n         ng-disabled="ctrl.isRemoveDisabled()"\n         ng-click="ctrl.onRemoveHardDisk()"></a>\n   </clr-stack-content>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.MaximumSize\')}}\n      </clr-stack-label>\n      <clr-stack-content data-test-id="max-size-container">\n         <span ng-if="ctrl.virtualDiskSettingsForm.capacity.isMaxAvailable && !ctrl.isPmemDisk">\n            <span\n                  aria-label="{{ctrl.i18n(\'VmUi\', \'DiskPage.MaximumSize\') + \' - \'\n                   + (ctrl.virtualDiskSettingsForm.capacity.maxInMB | bytes:\'MB\')}}">\n               {{ctrl.virtualDiskSettingsForm.capacity.maxInMB | bytes:\'MB\' }}\n            </span>\n         </span>\n         <span ng-if="ctrl.isPmemDisk">\n            {{ ctrl.getPmemMax() | bytes:\'MB\' }}\n         </span>\n         <span ng-if="!ctrl.virtualDiskSettingsForm.capacity.isMaxAvailable && !ctrl.isPmemDisk"\n               ng-bind="ctrl.i18n(\'VmUi\', \'DiskPage.SizeNotAvailable\')"></span>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.showVmStoragePolicy(ctrl.expanded)">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.Profile\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div>\n            <div>\n               <storage-profile read-only="ctrl.areStorageProfilesReadOnly()"\n                                name="storage-profile"\n                                selected-storage-profile="ctrl.virtualDiskSettingsForm.storageProfile.selection"\n                                storage-profiles="ctrl.virtualDiskSettingsForm.storageProfile.options"\n                                on-change-callback="ctrl.updateProfileFromUi"\n                                select-aria-label="ctrl.ARIA_LBL_PROFILE"\n                                error-config="ctrl.diskProfileErrorConfig">\n               </storage-profile>\n            </div>\n            <div ng-if="ctrl.isEncryptionProfileApplied">\n               <clr-icon shape="info-circle" class="is-highlight" size="20"></clr-icon>\n               <span>{{::ctrl.i18n(\'VmUi\', \'DiskPage.encryptionPolicyDecription\')}}</span>\n            </div>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.inflatedDevice.isNew() && ctrl.expanded && !ctrl.inflatedDevice.isCreatedFromExistingDisk()" class="vm-disk-block">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.Location\')}}</clr-stack-label>\n      <clr-stack-content>\n         <div class="select" ng-class="{\'has-error\' : ctrl.diskLocationErrorConfig.isVisible, \'div-disabled\': ctrl.isPmemDisk}">\n            <select class="location-select"\n                    aria-label="{{::ctrl.ARIA_LBL_LOCATION}}"\n                    name="disk-location"\n                    ng-options="option.name for option in ctrl.datastores.options track by option.name"\n                    ng-model="ctrl.datastores.selection"\n                    ng-change="ctrl.onDatastoreSelectionChange(ctrl.datastores.selection, {{ctrl.datastores.selection}})"\n                    vx-error="ctrl.diskLocationErrorConfig">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.showReplicationGroup(ctrl.expanded)">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.ProtectionGroup\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div class="select replication-group-container" ng-class="{\'has-error\' : ctrl.replicationGroupErrorConfig.isVisible}">\n            <select class="replication-group-select"\n                    aria-label="{{::ctrl.ARIA_LBL_RGROUP}}"\n                    ng-model="ctrl.selectedReplicationGroupItem"\n                    name="replication-group"\n                    ng-options="rgItem as rgItem.label for rgItem in ctrl.replicationGroupItems"\n                    ng-change="ctrl.onReplicationGroupSelectionChange()"\n                    vx-error="ctrl.replicationGroupErrorConfig">\n\n               <option ng-if="!ctrl.selectedReplicationGroupItem" value="">\n                  {{::ctrl.i18n("VmUi", "DiskPage.ProtectionGroupHint")}}\n               </option>\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && !ctrl.createMode && ctrl.expanded && !ctrl.inflatedDevice.isCreatedFromExistingDisk() && !ctrl.isPmemDisk">\n\n      <clr-stack-label ng-if="ctrl.inflatedDevice.isNew()"\n                       ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.DiskProvisioning\')}}\n      </clr-stack-label>\n      <clr-stack-content ng-if="ctrl.inflatedDevice.isNew()">\n         <div class="select">\n            <select ng-options="option.name for option in ctrl.virtualDiskSettingsForm.diskProvisioningOptions"\n                    ng-model="ctrl.virtualDiskSettingsForm.selectedDiskProvisioningOption"\n                    ng-change="ctrl.updateDiskProvisioningType(ctrl.virtualDiskSettingsForm.selectedDiskProvisioningOption.type)"\n                    aria-label="{{::ctrl.ARIA_LBL_PROVISION}}"\n                    ng-if="!ctrl.isPmemDisk">\n            </select>\n            <select ng-if="ctrl.isPmemDisk" ng-disabled="true">\n               <option>{{::ctrl.i18n(\'VmUi\', \'DiskPage.storedOnPmem\')}}</option>\n            </select>\n         </div>\n      </clr-stack-content>\n\n      <clr-stack-label ng-if="!ctrl.inflatedDevice.isNew()"\n                       ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.Type\')}}\n      </clr-stack-label>\n      <clr-stack-content ng-if="!ctrl.inflatedDevice.isNew()">{{ctrl.virtualDiskSettingsForm.diskProvisioningName}}</clr-stack-content>\n\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.createMode && ctrl.expanded && !ctrl.inflatedDevice.isCreatedFromExistingDisk()">\n\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.DiskProvisioning\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select ng-options="option.name for option in ctrl.virtualDiskSettingsForm.diskProvisioningOptions"\n                    ng-model="ctrl.virtualDiskSettingsForm.selectedDiskProvisioningOption"\n                    ng-change="ctrl.updateDiskProvisioningType(ctrl.virtualDiskSettingsForm.selectedDiskProvisioningOption.type)"\n                    ng-if="!ctrl.isPmemDisk">\n            </select>\n            <select ng-if="ctrl.isPmemDisk" ng-disabled="true">\n               <option>{{::ctrl.i18n(\'VmUi\', \'DiskPage.storedOnPmem\')}}</option>\n            </select>\n         </div>\n      </clr-stack-content>\n\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.expanded">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.Sharing\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select ng-options="option.name for option in ctrl.virtualDiskSettingsForm.sharing.options"\n                    ng-model="ctrl.virtualDiskSettingsForm.sharing.selection"\n                    ng-disabled="ctrl.isDiskSharingDisabled()"\n                    ng-change="ctrl.inflatedDevice.updateSharing(ctrl.virtualDiskSettingsForm.sharing.selection.value)"\n                    aria-label="{{::ctrl.ARIA_LBL_SHARING}}"\n            ></select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.showDiskFile()">\n   <!--<clr-stack-block ng-if="!ctrl.createMode && expanded && ctrl.virtualDiskSettingsForm.diskFile">-->\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.DiskFile\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         {{ctrl.virtualDiskSettingsForm.diskFile}}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.shouldDisplayShares(ctrl.expanded)">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.Shares\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <shares-control\n            shares-aria-label="ctrl.ARIA_LBL_SHARES"\n            quantity-caret-aria-label="ctrl.ARIA_LBL_SHARES"\n            quantity-aria-label="ctrl.ARIA_LBL_SHARES"\n            show-recommendations="false"\n            form-input-field-name="DiskSharesValue{{ctrl.formKey}}"\n            form-select-field-name="DiskSharesLevels{{ctrl.formKey}}"\n            share-value-min="{{ctrl.virtualDiskSettingsForm.shares.min}}"\n            share-value-max="{{ctrl.virtualDiskSettingsForm.shares.max}}"\n            shares-value-map="ctrl.virtualDiskSettingsForm.shares.presetOptions"\n            shares-info="ctrl.virtualDiskSettingsForm.shares.value"\n            is-disabled="ctrl.isEditSharesDisabled()">\n         </shares-control>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.shouldDisplayIOPS(ctrl.expanded)">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.LimitIOPs\')}}\n      </clr-stack-label>\n\n      <clr-stack-content class="iops-control">\n         <div class="select">\n            <select\n               aria-label="{{::ctrl.ARIA_LBL_LIMIT_IOPS}}"\n               name="iopsLimitSelect{{ formKey }}"\n               ng-options="iopsLimitSelect.label for iopsLimitSelect in ctrl.iopsLimitDetails.iopsLimitSelectList track by iopsLimitSelect.data"\n               ng-model="ctrl.iopsLimitDetails.iopsLimitSelection"\n               ng-change="ctrl.iopsLimitDetails.selectChange()"\n               ng-disabled="ctrl.isEditIopsLimitDisabled()">\n            </select>\n         </div>\n         <vx-value-in-units\n            ng-if="ctrl.iopsLimitDetails.iopsLimitSelection.data == \'custom\'"\n            name="IopsLimitValue{{ctrl.formKey}}"\n            recommended-values="ctrl.iopsLimitDetails.iopsRecommendations"\n            is-disabled="ctrl.isEditIopsLimitDisabled()"\n            ng-model="ctrl.virtualDiskSettingsForm.ioLimit"\n            ng-change="ctrl.inflatedDevice.updateStorageIOAllocation(ctrl.virtualDiskSettingsForm.ioLimit)"\n            min="{{ ctrl.iopsLimitDetails.min }}"\n            max="{{ ctrl.iopsLimitDetails.max }}"\n            error-messages="ctrl.iopsLimitDetails.errorMessage"\n            show-units="false"\n            unit-aria-label="ctrl.ARIA_LBL_LIMIT_IOPS"\n            quantity-caret-aria-label="ctrl.ARIA_LBL_LIMIT_IOPS"\n            quantity-aria-label="ctrl.ARIA_LBL_LIMIT_IOPS"\n         ></vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.virtualDiskSettingsForm.isFlashCacheCompatible && ctrl.expanded">\n\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.CacheReservation\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vx-value-in-units name="ctrl.editDiskCacheReservation{{ctrl.formKey}}"\n                            type="number"\n                            is-disabled="ctrl.isEditFlashReadCacheDisabled()"\n                            ng-model="ctrl.virtualDiskSettingsForm.flashCacheReservation.valueInMB"\n                            unit-options="ctrl.virtualDiskSettingsForm.flashCacheReservation.validUnits"\n                            ng-change="ctrl.updateFlashCacheReservation(ctrl.virtualDiskSettingsForm.flashCacheReservation.valueInMB)"\n                            custom-validators="ctrl.virtualDiskSettingsForm.flashCacheReservation.customValidators"\n                            error-messages="ctrl.virtualDiskSettingsForm.flashCacheReservation.errorMessages"\n                            unit-aria-label="ctrl.ARIA_LBL_CACHE"\n                            quantity-caret-aria-label="ctrl.ARIA_LBL_CACHE"\n                            quantity-aria-label="ctrl.ARIA_LBL_CACHE"\n                            default-unit="{{ctrl.virtualDiskSettingsForm.flashCacheReservation.defaultUnit}}">\n         </vx-value-in-units>\n      </clr-stack-content>\n   </clr-stack-block>\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.expanded">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.DiskMode\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <div class="select">\n            <select name="editDiskMode{{ctrl.formKey}}"\n                    aria-label="{{::ctrl.ARIA_LBL_DISK_MODE}}"\n                    ng-disabled="ctrl.isEditDiskModeDisabled()"\n                    ng-options="option.name for option in ctrl.virtualDiskSettingsForm.diskMode.options"\n                    ng-model="ctrl.virtualDiskSettingsForm.diskMode.selection"\n                    ng-change="ctrl.inflatedDevice.updateDiskMode(ctrl.virtualDiskSettingsForm.diskMode.selection.value)">\n            </select>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.deployVmtxMode && ctrl.expanded">\n      <clr-stack-label ng-class="{\'stack-block-is-nested\': ctrl.isGroupingHardDisks}">\n         {{::ctrl.i18n(\'VmUi\', \'DiskPage.VirtualDeviceNode\')}}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vm-hardware-controller-and-node\n            inflated-device="ctrl.inflatedDevice"\n            virtual-machine-devices="ctrl.virtualMachineDevices"\n            selector-name="ctrl.controllerNodeSelectorName"\n            controller-selector-name="ctrl.controllerSelectorName"\n            available-controllers="ctrl.virtualDiskSettingsForm.controllers.options"\n            device-controller="ctrl.virtualDiskSettingsForm.controllers.selection"\n            node="ctrl.virtualDiskSettingsForm.selectedControllerNode"\n            power-state="ctrl.vmConfigContext.environment.powerState"\n            privileges="ctrl.vmConfigContext.privileges"\n            on-controller-change-callback="ctrl.updateDiskController">\n         </vm-hardware-controller-and-node>\n      </clr-stack-content>\n   </clr-stack-block>\n\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskType/vm-hardware-virtual-disk-type.html','<div ng-bind="$ctrl.provisioningTypeLabel"></div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualNvdimm/vm-hardware-virtual-nvdimm.component.html','<clr-stack-block\n      ng-form\n      name="vmHardwareNvdimmForm"\n      [(clr-sb-expanded)]="expanded"\n      ng-class="{\'vm-ui-stackBlockEdited\': $ctrl.nvdimmDevice.hasChanged()}"\n      class="virtual-nvdimm">\n   <clr-stack-label ng-class="{\'error-child-component\': $ctrl.hasError()}">\n      <span>{{ ::$ctrl.deviceName }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content ng-if="$ctrl.nvdimmDevice.isMarkedForRemoval()">\n      {{::$ctrl.i18n(\'RemoveDevice.DeviceAndContentsRemoved\')}}\n      <a class="vx-icon-reset_green pull-right restore-device stack-view-row-action"\n            ng-click="$ctrl.revertNvdimmRemoval()">\n      </a>\n   </clr-stack-content>\n\n\n   <clr-stack-content ng-if="!$ctrl.nvdimmDevice.isMarkedForRemoval()">\n      <vx-value-in-units name="editNVDIMMMemory"\n            ng-if="$ctrl.memoryOptions"\n            is-disabled="!$ctrl.isGrowthEnabled"\n            hot-plug-active="$ctrl.isGrowthEnabled"\n            type="number"\n            ng-model="$ctrl.dummyCapacity"\n            default-unit="{{$ctrl.defaultMemoryUnit}}"\n            unit-options="$ctrl.memoryOptions"\n            min="{{$ctrl.minAllowedCapacity}}"\n            max="{{$ctrl.maxAllowedCapacity}}"\n            mod="{{$ctrl.growthGranularityMB}}"\n            error-messages="$ctrl.capacityErrorMessages"\n            value-changed-callback="$ctrl.onCapacityChange(value)">\n      </vx-value-in-units>\n      <a class="vsphere-icon-action-remove remove-device stack-view-row-action"\n            ng-disabled="$ctrl.isRemoveDisabled"\n            ng-click="$ctrl.removeNvdimm()"></a>\n   </clr-stack-content>\n\n</clr-stack-block>');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/bootOptions/boot-options-firmware-help-text.html','<div>\n   <p>\n      {{i18n(\'VmUi\', \'VmCpu.bootOptions.firmware.Description\')}}\n   </p>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/bootOptions/boot-options-secureBoot-help-text.html','<div>\n   <p>\n      {{i18n(\'VmUi\', \'VmCpu.bootOptions.secureBoot.Description\')}}\n   </p>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/bootOptions/bootOptions.html','<clr-stack-block\n        ng-form\n        name="bootOptions"\n        class="boot-options"\n        [(clr-sb-expanded)] = "$ctrl.expanded">\n    <clr-stack-label>\n        {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.title\') }}\n    </clr-stack-label>\n\n    <clr-stack-content>\n        <div ng-if="!$ctrl.expanded">\n         {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.expand\') }}\n      </div>\n      <div ng-if="$ctrl.expanded">\n      </div>\n    </clr-stack-content>\n\n    <!-- Firmware Selection -->\n    <clr-stack-block>\n        <clr-stack-label>\n            {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.firmware\') }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <div class="select">\n                <select name="firmwareSelect"\n                        aria-label="{{$ctrl.i18n(\'VmUi\', \'BIOSOptions.firmware\')}}"\n                        data-test-id="firmwareSelect"\n                        ng-model="$ctrl.firmware"\n                        ng-options="option.id as option.displayName for option in $ctrl.viewModel.firmwareList"\n                        ng-disabled="$ctrl.isFirmwareDisabled()"></select>\n            </div>\n            <a ng-if="$ctrl.isVbsEnabled()"\n               vui-sign-post=\'$ctrl.signFirmwarePostParams\'\n               class=\'pull-right\'><img\n               ng-src="{{::$ctrl.i18n(\'CommonImages\', \'info\')}}"></a>\n\n           <clr-alert ng-if="$ctrl.viewModel.firmwareWarningFlag"\n                      [clr-alert-closable]="true"\n                      clr-alert-type="warning" [clr-alert-size-small]="true"\n                      data-test-id="firmwareWarning">\n              <clr-alert-item>\n                 <span class="alert-text" ng-bind="::$ctrl.i18n(\'VmUi\', \'BIOSOptions.firmware.warning\')"></span\n              </clr-alert-item>\n           </clr-alert>\n\n           <clr-alert ng-if="$ctrl.showFirmwareCompatibilityWarning()"\n                     [clr-alert-closable]="true"\n                     clr-alert-type="warning" [clr-alert-size-small]="true"\n                     data-test-id="firmwareCompatibilityWarning">\n               <clr-alert-item>\n                  <span class="alert-text"\n                        ng-bind="::$ctrl.getString(\'BIOSOptions.firmware.noncompatible.warning\')"></span>\n               </clr-alert-item>\n           </clr-alert>\n\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <!-- Secure Boot -->\n    <clr-stack-block ng-if="$ctrl.isSecureBootAllowed()">\n        <clr-stack-label>\n            {{ $ctrl.i18n(\'VmUi\', \'BIOSOptions.secureBoot.Title\') }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <input type="checkbox"\n                   name="efiSecureBootEnabledCheckbox"\n                   data-test-id="secureBoot"\n                   ng-model="$ctrl.viewModel.efiSecureBootEnabled"\n                   ng-disabled="$ctrl.isVbsEnabled()"\n                   ng-change="$ctrl.onPropertyChanged()"/>\n            <span ng-class="{\'div-disabled\': $ctrl.isVbsEnabled()}">\n                {{ $ctrl.i18n(\'VmUi\', \'BIOSOptions.secureBoot.Enable\') }}</span>\n            <a ng-if="$ctrl.isVbsEnabled()"\n               vui-sign-post=\'$ctrl.signSecureBootPostParams\'\n               class=\'pull-right\'><img\n                    ng-src="{{::$ctrl.i18n(\'CommonImages\', \'info\')}}"></a>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <!-- Boot Delay -->\n    <clr-stack-block ng-if="$ctrl.viewModel.bootOptionsSupported">\n        <clr-stack-label>\n            {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.delay\') }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <span ng-class="{\'div-disabled\': $ctrl.viewModel.bootDelayEditDisabled}">\n                {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.delay.description\') }}\n            </span>\n            <div>\n                <input type=\'number\'\n                       name="bootDelayNumeric"\n                       min={{$ctrl.viewModel.bootDelayMin}}\n                       max={{$ctrl.viewModel.bootDelayMax}}\n                       step={{$ctrl.viewModel.bootDelayStep}}\n                       ng-model-options="{ updateOn: \'blur\' }"\n                       ng-model="$ctrl.viewModel.bootDelay"\n                       ng-disabled="$ctrl.viewModel.bootDelayEditDisabled"\n                       ng-change="$ctrl.onPropertyChanged()"\n                       aria-label="{{$ctrl.i18n(\'VmUi\', \'BIOSOptions.delay.description\')}}"\n                       required/>\n                <span ng-class="{\'div-disabled\': $ctrl.viewModel.bootDelayEditDisabled}"\n                      class="inline-block">{{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.delay.ms\') }}\n                </span>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <!-- Force BIOS/EFI Options -->\n    <clr-stack-block ng-if="$ctrl.viewModel.bootOptionsSupported">\n        <clr-stack-label>\n            {{ ::$ctrl.getString(\'BIOSOptions.force\', $ctrl.viewModel.firmwareSelection.id) }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <input type="checkbox"\n                   name="forceSetupCheckbox"\n                   ng-model="$ctrl.viewModel.enterBIOSSetup"\n                   ng-disabled="$ctrl.viewModel.isEnterBIOSSetupEditDisabled"\n                   ng-change="$ctrl.onPropertyChanged()"/>\n            <span ng-class="{\'div-disabled\': $ctrl.viewModel.isEnterBIOSSetupEditDisabled}">\n                {{ ::$ctrl.getString(\'BIOSOptions.force.description\', $ctrl.viewModel.firmwareSelection.id) }}\n            </span>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <!-- BOOT Recovery -->\n    <clr-stack-block ng-if="$ctrl.viewModel.bootRetryOptionsSupported">\n        <clr-stack-label ng-attr-title="{{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.recovery\') }}">\n            {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.recovery\') }}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            <input class="inline-block"\n                   type="checkbox"\n                   name="retryDelayCheckbox"\n                   id="chkBxRecovery"\n                   ng-model="$ctrl.viewModel.bootRetryEnabled"\n                   ng-disabled="$ctrl.viewModel.bootRetryEditDisabled"\n                   ng-change="$ctrl.onPropertyChanged()"/>\n            <span ng-class="{\'div-disabled\': $ctrl.viewModel.bootRetryEditDisabled}">\n                {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.recovery.description\') }}\n            </span>\n            <div>\n                <input type="number"\n                       name="retryDelayNumeric"\n                       ng-disabled="$ctrl.isBootRetryDelayEditDisabled()"\n                       min="{{$ctrl.viewModel.retryDelayMin}}"\n                       max="{{$ctrl.viewModel.retryDelayMax}}"\n                       ng-model-options="{ updateOn: \'blur\' }"\n                       ng-model="$ctrl.viewModel.bootRetryDelay"\n                       aria-label="{{$ctrl.i18n(\'VmUi\', \'BIOSOptions.recovery.description\')}}"\n                       ng-change="$ctrl.onPropertyChanged()"/>\n                <span ng-class="{\'div-disabled\': $ctrl.isBootRetryDelayEditDisabled()}">\n                    {{ ::$ctrl.i18n(\'VmUi\', \'BIOSOptions.recovery.seconds\') }}\n                </span>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/encryption/encryption-options.html','<clr-stack-block\n   ng-form\n   name="vm-encryption-options"\n   class="vm-encryption-options"\n   [(clr-sb-expanded)]="$ctrl.expanded"\n   (clr-sb-expanded-change)="$ctrl.expandedChanged($event)"\n>\n\n   <clr-stack-label>\n      {{::$ctrl.i18n(\'VmCryptConfig.encryptionLabel\')}}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      {{::$ctrl.i18n(\'VmCryptConfig.vMotion.Expand\')}}\n   </clr-stack-content>\n\n   <clr-stack-block ng-if="$ctrl.displayEncryptVmBlock()">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmCryptConfig.encryptVM\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div ng-disabled="!!$ctrl.canNotEncryptReason || $ctrl.isVmPoweredOn()"\n              ng-class="{\'div-disabled\': !!$ctrl.canNotEncryptReason || $ctrl.isVmPoweredOn()}">\n            <div ng-if="!$ctrl.canChangeVmHomePolicy">\n               <div ng-if="$ctrl.isVmHomeEncrypted()">\n                  <span>{{$ctrl.vmStorageProfile.label}}</span>\n                  <vsc-sign-post [sign-post-position]="\'bottom-left\'"\n                                 [sign-post-content]="$ctrl.i18n(\'VmCryptConfig.VmHomeEncryptTip\')">\n                  </vsc-sign-post>\n               </div>\n               <div ng-if="!$ctrl.isVmHomeEncrypted()">\n                  <span>{{$ctrl.i18n("VmCryptConfig.vmHomeNoEncrypted")}}</span>\n               </div>\n            </div>\n\n            <div class="flex-row" ng-if="$ctrl.canChangeVmHomePolicy">\n               <storage-profile-menu\n                       class="storage-profile-menu-as-select"\n                       [selected-storage-profile]="$ctrl.selectedEncryptionProfile"\n                       [storage-profiles]="$ctrl.encryptionProfiles"\n                       [group-profiles]="false"\n                       [aria-label]="$ctrl.i18n(\'VmCryptConfig.encryptVM\')"\n                       (on-change)="$ctrl.onStorageProfileChanged($event)">\n               </storage-profile-menu>\n               <div class="can-not-encrypt-reason" ng-if="$ctrl.canNotEncryptReason">\n                  ({{$ctrl.canNotEncryptReason}})\n               </div>\n            </div>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.displayEncryptVmDisksBlock()">\n      <clr-stack-label>\n      </clr-stack-label>\n      <clr-stack-content>\n         <div ng-disabled="!$ctrl.canEncryptHdds || $ctrl.isVmPoweredOn()"\n              ng-class="{\'div-disabled\': !$ctrl.canEncryptHdds || $ctrl.isVmPoweredOn()}">\n            <div ng-repeat="disk in $ctrl.hardDisks track by $index"\n                 class="checkbox"\n                 ng-disabled="disk.isCreatedFromExistingDisk() || $ctrl.isVmPoweredOn() || disk.isRDMDisk()"\n                 ng-class="{\'div-disabled\': disk.isCreatedFromExistingDisk()\n                      || $ctrl.isVmPoweredOn() || disk.isRDMDisk() }">\n               <input type="checkbox" id="encryptHdd{{$index}}"\n                      ng-disabled="!$ctrl.canEncryptHdds || disk.isCreatedFromExistingDisk() || $ctrl.isVmPoweredOn()\n                           || disk.isRDMDisk()"\n                      ng-checked="$ctrl.hardDiskEncryptionStatuses[$index]"\n                      ng-click="$ctrl.toggleEncryptHardDisk(disk)">\n               <label for="encryptHdd{{$index}}">\n                  {{::$ctrl.i18n(\'VmCryptConfig.DiskPrefix\')}} {{$index}}\n               </label>\n            </div>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmCryptConfig.vMotionMode\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <div class="select">\n            <select\n                    ng-options="option as $ctrl.i18n(\'VmCryptConfig.vMotion.\' + option + \'.Text\') for option in $ctrl.encryptedVmotionModes"\n                    ng-model="$ctrl.migrateEncryption"\n                    [attr.aria-label]="$ctrl.i18n(\'VmCryptConfig.vMotionMode\')"\n                    ng-change="$ctrl.onMigrateEncryptionChanged()"\n                    ng-disabled="$ctrl.isVmotionReadOnly()">\n            </select>\n         </div>\n         <vsc-sign-post [sign-post-position]="\'bottom-middle\'"\n                        [sign-post-content-template]="$ctrl.buildSignPostContentVmotion()">\n         </vsc-sign-post>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/generalOptions/general-options.html','<clr-stack-block\n   ng-form\n   name="vmGeneralOptions"\n   (clr-sb-expanded-change)="$ctrl.expandedChanged($event)"\n   [(clr-sb-expanded)]="$ctrl.expanded">\n   <clr-stack-label>\n      {{ ::$ctrl.i18n(\'GeneralOptions.title\') }}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div ng-if="!$ctrl.expanded">\n         {{ ::$ctrl.i18n(\'GeneralOptions.vm_name_header\') }}\n         <span ng-if="!$ctrl.editMode" class="wrap-content">{{ ::$ctrl.vmName }}</span>\n         <span ng-if="$ctrl.editMode" class="wrap-content">{{ ::$ctrl.config.name }}</span>\n      </div>\n      <div ng-if="$ctrl.expanded"></div>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label>{{ ::$ctrl.i18n(\'GeneralOptions.vm_name_body\') }}</clr-stack-label>\n      <clr-stack-content>\n         <span ng-if="!$ctrl.editMode" class="wrap-content">{{ ::$ctrl.vmName }}</span>\n         <input type="text" id= "name"\n                aria-label="{{::$ctrl.ARIA_LBL_NAME}}"\n                ng-model="$ctrl.config.name"\n                ng-if="$ctrl.editMode"\n                ng-disabled="$ctrl.isEditNameDisabled()">\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.editMode">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'GeneralOptions.vm_config_file\') }}</clr-stack-label>\n      <clr-stack-content>\n         {{ ::$ctrl.vmConfigFile }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.editMode">\n      <clr-stack-label>{{ ::$ctrl.i18n(\'GeneralOptions.vm_work_loc\') }}</clr-stack-label>\n      <clr-stack-content>\n         {{ ::$ctrl.vmWorkingLocation }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>{{ ::$ctrl.i18n(\'GeneralOptions.gos_family\') }}</clr-stack-label>\n      <clr-stack-content>\n         <select id="gos-family-select" name="gosFamily"\n                 aria-label="{{::$ctrl.ARIA_LBL_GOS_FML}}"\n                 ng-model="$ctrl.gosFamily" ng-change="$ctrl.familyChanged()"\n                 ng-disabled="$ctrl.isEditGOSDisabled()"\n                 ng-options="option as option.name for option in $ctrl.gosFamilyOptions track by option.id">\n         </select>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>{{ ::$ctrl.i18n(\'GeneralOptions.gos_version\') }}</clr-stack-label>\n      <clr-stack-content>\n         <select id="gos-version-select" name="gosVersion"\n                 ng-model="$ctrl.gosVersion"\n                 aria-label="{{::$ctrl.ARIA_LBL_GOS_VER}}"\n                 data-test-id="gosVersionSelect"\n                 ng-change="$ctrl.versionChanged()"\n                 ng-disabled="$ctrl.isEditGOSDisabled()"\n                 ng-options="option as option.name for option in $ctrl.gosVersionOptions track by\n                          option.id">\n         </select>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/standbyOptions/standby-options.html','<clr-stack-block\n   ng-form\n   name="vm-standby-options"\n   [(clr-sb-expanded)]="$ctrl.expanded">\n\n   <clr-stack-label>\n      {{::$ctrl.i18n(\'VmStandbyPage.title\')}}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div ng-if="!$ctrl.expanded">\n         {{::$ctrl.i18n(\'VmStandbyPage.expand\')}}\n      </div>\n      <div ng-if="$ctrl.expanded">\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmStandbyPage.StandbyResponseLabel\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <span>{{::$ctrl.i18n(\'VmStandbyPage.StandbyResponse\')}}</span>\n         <br/>\n         <label class="normal-weight"\n                ng-class="{\'div-disabled\': $ctrl.isEditSettingsDisabled()}"\n                ng-repeat="option in $ctrl.standbyOptions">\n            <input type="radio"\n                  name="standbyMode"\n                  ng-value="option.value"\n                  aria-label="{{::option.label}}"\n                  ng-model="$ctrl.standbyValue"\n                  ng-disabled="$ctrl.isEditSettingsDisabled()"\n                  ng-change="$ctrl.onStandbyOptionsChange()"\n                  />\n            <span>{{ ::option.label }}</span>\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="$ctrl.isWakeOnLanVisible()">\n      <clr-stack-label>\n         {{::$ctrl.i18n(\'VmStandbyPage.WakeOnLAN\')}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <span>{{::$ctrl.i18n(\'VmStandbyPage.WakeOnTraffic\')}}</span>\n         <br/>\n         <div ng-repeat="(key, device) in $ctrl.expandedDevices" class="inline-label">\n            <label class="normal-weight"\n                   ng-class="{\'div-disabled\': $ctrl.isEditWakeOnLanDisabled(device)}">\n               <input type="checkbox"\n                      aria-label="{{::$ctrl.getDeviceLabel(device)}}"\n                      name="device"\n                      ng-model="$ctrl.wakeOnLanValues[device.key]"\n                      ng-disabled="$ctrl.isEditWakeOnLanDisabled(device)"\n                      ng-change="$ctrl.onWakeOnLanChange(device)"\n               />\n               <span>{{ ::$ctrl.getDeviceLabel(device) }}</span>\n            </label>\n            <span ng-show="!$ctrl.isTypeSupported(device)" class="standby-adapter-label">\n               <span class="standby-adapter-not-supported">\n                     Not supported <!-- do we need a new i18n thing here? -->\n\n                  <!-- using a helper function runs into fun infinite loop digest issues -->\n                  <a vui-sign-post=\'{message: $ctrl.getErrorString(device)}\'>\n                     <img ng-src="{{$ctrl.i18n(\'info\', \'CommonImages\')}}">\n                  </a>\n               </span>\n            </span>\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/vbs/vbs.html','<clr-stack-block\n      ng-if="$ctrl.visible"\n      ng-form\n      name="vbs">\n   <clr-stack-label>\n      {{ $ctrl.i18n(\'VmUi\', \'VBS.title\') }}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div>\n         <label class="normal-weight">\n            <input type="checkbox"\n                   data-test-id="vbsEnabledInput"\n                   ng-model="$ctrl.configFlags.vbsEnabled"\n                   ng-disabled="$ctrl.isDisabled()"\n                   aria-label="{{$ctrl.i18n(\'VmUi\', \'VBS.title\')}}"\n                   ng-change="$ctrl.onPropertyChanged()"/>\n            {{::$ctrl.i18n(\'VmUi\', \'VBS.enable\')}}\n         </label>\n      </div>\n      <div aria-live="polite">\n         <div id="vbsWarningWillTurnOn" class="alert alert-warning alert-sm"\n              ng-if="$ctrl.vbsWillTurnOn">\n            <div class="alert-item">\n               <span class="alert-text">{{$ctrl.i18n(\'VmUi\',\'BIOSOptions.vbs.will.turn.on\')}}</span>\n            </div>\n         </div>\n         <div id="vbsWarningWillTurnOff" class="alert alert-warning alert-sm"\n              ng-if="$ctrl.vbsWillTurnOff">\n            <div class="alert-item">\n               <span class="alert-text">{{$ctrl.i18n(\'VmUi\',\'BIOSOptions.vbs.will.turn.off\')}}</span>\n            </div>\n         </div>\n      </div>\n   </clr-stack-content>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/vmAdvancedOptions/vmAdvancedOptions.html','<clr-stack-block\n        ng-form\n        name="ctrl.vmAdvancedOptions"\n        [(clr-sb-expanded)]="ctrl.expanded">\n    <clr-stack-label>\n        {{ ::ctrl.LBL_TITLE }}\n    </clr-stack-label>\n\n    <clr-stack-content>\n        <div ng-if="!ctrl.expanded">\n            {{ ::ctrl.LBL_EXPAND}}\n        </div>\n        <div ng-if="ctrl.expanded"></div>\n    </clr-stack-content>\n\n    <clr-stack-block>\n        <clr-stack-label>{{ ::ctrl.LBL_SETTINGS }}</clr-stack-label>\n        <clr-stack-content>\n            <label ng-class="{\'div-disabled\': ctrl.isDisableAccelerationDisabled()}"\n                  class="normal-weight"\n                  title="{{::ctrl.LBL_ACCEL}}">\n                <input name="disable-acceleration"\n                       aria-label="{{::ctrl.LBL_ACCEL}}"\n                       ng-disabled="ctrl.isDisableAccelerationDisabled()"\n                       type="checkbox"\n                       ng-model="ctrl.advancedOptions.disableAcceleration">\n                {{::ctrl.LBL_ACCEL}}\n            </label>\n            <br>\n            <label ng-class="{\'div-disabled\': ctrl.isEnableLoggingDisabled()}"\n                  class="normal-weight"\n                  title="{{::ctrl.LBL_LOGGING}}">\n                <input name="logging"\n                       aria-label="{{::ctrl.LBL_LOGGING}}"\n                       type="checkbox"\n                       ng-disabled="ctrl.isEnableLoggingDisabled()"\n                       ng-model="ctrl.advancedOptions.enableLogging">\n                {{::ctrl.LBL_LOGGING}}\n            </label>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block>\n        <clr-stack-label>{{ ::ctrl.LBL_MONITOR }}\n        </clr-stack-label>\n        <clr-stack-content>\n            <div class="select">\n                <select data-test-id="monitor-type-id"\n                   aria-label="{{::ctrl.LBL_MONITOR}}"\n                   ng-disabled="ctrl.isEditMonitorTypeDisabled()"\n                   ng-model="ctrl.advancedOptions.monitorType"\n                   ng-options="item as ctrl.getMonitorTypeLabel(item) for item in ctrl.monitorTypeList">\n                </select>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block>\n        <clr-stack-label>{{ ::ctrl.LBL_SWAP }}</clr-stack-label>\n        <clr-stack-content>\n            <label class="normal-weight" ng-repeat="item in ctrl.swapPlacementTypeOptions" >\n                <input type="radio"\n                       aria-label="{{::item.label}}"\n                       ng-value="item.id"\n                       ng-disabled="ctrl.isEditSwapFileLocationDisabled()"\n                       ng-model="ctrl.swapPlacementType"\n                       name="swap-placement-type"/>\n                <span ng-class="{\'div-disabled\': ctrl.isEditSwapFileLocationDisabled()}">\n                    {{ ::item.label }}\n                </span><br>\n                <span ng-class="{\'div-disabled\': ctrl.isEditSwapFileLocationDisabled()}">\n                    {{ ::item.description }}\n                </span>\n            </label>\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <!--Configuration Parameters section -->\n\n   <clr-stack-block>\n      <clr-stack-label>\n          {{::ctrl.LBL_PARAMS}}\n      </clr-stack-label>\n      <clr-stack-content>\n         <button class="btn btn-link"\n                 aria-label="{{::ctrl.LBL_PARAMS}}"\n                 ng-click="ctrl.openAdvancedEditConfigurationModal()">\n            {{::ctrl.LBL_EDIT_PARAMS}}\n         </button>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <!--Latency sensitivity (Ls for short) section -->\n\n    <clr-stack-block ng-if="ctrl.isEditingLsLevelVisible()">\n        <clr-stack-label>{{ ::ctrl.LBL_LATENCY }}</clr-stack-label>\n        <clr-stack-content>\n            <div class="select">\n            <select data-test-id="latency-sensitivity-level-id"\n                    ng-disabled="ctrl.isEditingLsLevelDisabled()"\n                    ng-model="ctrl.getSetLsLevel" ng-model-options="{ getterSetter: true }"\n                    ng-options="item as ctrl.getLsLevelLabel(item) for item in ctrl.getLsLevelList()">\n                >\n            </select>\n            </div>\n        </clr-stack-content>\n    </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmOptions/vmwareTools/vmware-tools.html','<clr-stack-block\n      ng-form\n      name="vmwareTools"\n      [(clr-sb-expanded)]="$ctrl.expanded">\n\n   <clr-stack-label>\n      {{ ::$ctrl.i18n(\'VMwareTools.title\') }}\n   </clr-stack-label>\n   <clr-stack-content>\n      <div ng-if="!$ctrl.expanded">\n         {{::$ctrl.i18n(\'VMwareTools.expand\')}}\n      </div>\n      <div ng-if="$ctrl.expanded">\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{ ::$ctrl.i18n(\'VMwareTools.operations\') }}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <vsc-vm-power-operations [power-operations]="$ctrl.vmDefaultPowerOperations"\n            [vm-workflow-mode]="$ctrl.vmWorkflowMode"\n            [vm-power-state]="$ctrl.vmPowerState"\n            [vm-has-config-settings-privilege]="$ctrl.vmHasConfigSettingsPrivilege">\n         </vsc-vm-power-operations>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{ ::$ctrl.i18n(\'VMwareTools.upgrade\') }}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label class="normal-weight" ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.upgrade.policy\') }}"\n                ng-class="{\'div-disabled\': !$ctrl.toolsUpgradePolicyEnabled()}">\n            <input name="vmwareToolsUpgrades"\n                   aria-label="{{::$ctrl.ARIA_LBL_UPGRADE}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.toolsUpgradePolicy\' ng-true-value="\'upgradeAtPowerCycle\'" ng-false-value="\'manual\'"\n                   ng-change="$ctrl.onVmwareToolsChange()"\n                   ng-disabled="!$ctrl.toolsUpgradePolicyEnabled()">\n            {{ ::$ctrl.i18n(\'VMwareTools.upgrade.policy\') }}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n   <clr-stack-block>\n      <clr-stack-label>\n         {{ ::$ctrl.i18n(\'VMwareTools.time\') }}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label class="normal-weight" ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.time.synch\') }}"\n                ng-class="{\'div-disabled\': $ctrl.syncTimeWithHostDisabled()}" >\n            <input name="syncTimeWithHost"\n                   aria-label="{{::$ctrl.ARIA_LBL_TIME_SYNC}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.syncTimeWithHost\'\n                   ng-disabled="$ctrl.syncTimeWithHostDisabled()">\n            {{ ::$ctrl.i18n(\'VMwareTools.time.synch\') }}\n         </label>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label>\n         {{ ::$ctrl.i18n(\'VMwareTools.scripts\') }}\n      </clr-stack-label>\n\n      <clr-stack-content>\n         <label class="normal-weight"\n            ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.scripts.after_power_on\') }}"\n            ng-class="{\'div-disabled\': !$ctrl.canChangeScriptOptions}" >\n            <input name="afterPowerOn"\n                   aria-label="{{::$ctrl.ARIA_LBL_AFTER_POWER_ON}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.afterPowerOn\'\n                   ng-change=\'$ctrl.onVmwareToolsChange()\'\n                   ng-disabled=\'!$ctrl.canChangeScriptOptions\' >\n            {{ ::$ctrl.i18n(\'VMwareTools.scripts.after_power_on\') }}\n         </label>\n         <br/>\n         <label class="normal-weight"\n            ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.scripts.after_resuming\') }}"\n            ng-class="{\'div-disabled\': !$ctrl.canChangeScriptOptions}" >\n            <input name="afterResume"\n                   aria-label="{{::$ctrl.ARIA_LBL_AFTER_RESUME}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.afterResume\'\n                   ng-change=\'$ctrl.onVmwareToolsChange()\'\n                   ng-disabled=\'!$ctrl.canChangeScriptOptions\' >\n            {{ ::$ctrl.i18n(\'VMwareTools.scripts.after_resuming\') }}\n         </label>\n         <br/>\n         <label class="normal-weight"\n            ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.scripts.before_suspending\') }}"\n            ng-class="{\'div-disabled\': !$ctrl.canChangeScriptOptions}" >\n            <input name="beforeGuestStandby"\n                   aria-label="{{::$ctrl.ARIA_LBL_BEFORE_SUSPEND}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.beforeGuestStandby\'\n                   ng-change=\'$ctrl.onVmwareToolsChange()\'\n                   ng-disabled=\'!$ctrl.canChangeScriptOptions\' >\n            {{ ::$ctrl.i18n(\'VMwareTools.scripts.before_suspending\') }}\n         </label>\n         <br/>\n         <label class="normal-weight"\n            ng-attr-title="{{ ::$ctrl.i18n(\'VMwareTools.scripts.before_shutting_guest\') }}"\n            ng-class="{\'div-disabled\': !$ctrl.canChangeScriptOptions}" >\n            <input name="beforeGuestShutdown"\n                   aria-label="{{::$ctrl.ARIA_LBL_BEFORE_SHUTDOWN}}"\n                   type="checkbox"\n                   ng-model=\'$ctrl.vmToolsOptions.beforeGuestShutdown\'\n                   ng-change=\'$ctrl.onVmwareToolsChange()\'\n                   ng-disabled=\'!$ctrl.canChangeScriptOptions\' >\n            {{ ::$ctrl.i18n(\'VMwareTools.scripts.before_shutting_guest\') }}\n         </label>\n         <br/>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuMmu/cpu-mmu-view.html','<select name="cpuMmu"\n        area-label="$ctrl.ariaLabel"\n        ng-disabled="$ctrl.isCpuMmuDisabled()"\n        ng-options="option.label for option in $ctrl.cpuMmuOptions"\n        ng-model="$ctrl.selectedOption"\n        ng-change="$ctrl.onChange()">\n</select>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/tpmCertificateSelector/tpm-certificate-selector.component.html','<span>\n    {{$ctrl.selectedCertificate.issuerNameCN}}\n    <button aria-label="{{$ctrl.selectedCertificate.algorithmName\n        + \' / \' + $ctrl.selectedCertificate.publicKeyAlgorithmName\n        + \' - \' + $ctrl.i18n(\'VmDeviceManager.TPMReplaceCertificate\')}}"\n          class="tpm-certificate-replace-btn btn btn-outline btn-sm"\n            ng-click="$ctrl.openFileSelector()">\n        {{$ctrl.i18n(\'VmDeviceManager.TPMReplaceCertificate\')}}\n    </button>\n</span>\n<div class="alert alert-danger alert-sm" ng-show="!$ctrl.invalidCertAlertOptions.isClosed">\n    <div class="alert-item">\n        <span aria-live="polite" class="alert-text">{{$ctrl.invalidCertAlertOptions\n            .text}}</span>\n    </div>\n</div>\n<input id="tpm-certificate-upload-file-input"\n       class="tpm-certificate-upload-file-input"\n       type="file"\n       file-on-change="$ctrl.uploadCertificate(files)"\n       accept=".cer"/>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/vmHardwareVirtualDiskCompatibilityMode/vm-hardware-virtual-disk-compatibility-mode.html','<div class="select">\n   <select ng-disabled="$ctrl.isDisabled"\n           aria-label="{{::$ctrl.ariaLabel}}"\n           ng-options="option as option.name for option in $ctrl.compatibilityModeInfo.options track by option.value"\n           ng-model="$ctrl.compatibilityModeInfo.selection"\n           ng-change="$ctrl.onCompatibilityModeChange($ctrl.compatibilityModeInfo.selection)">\n   </select>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/vmHardwareVirtualDiskFlashReadCache/vm-hardware-virtual-disk-flash-read-cache.html','<vx-value-in-units type="number"\n                   aria-label="{{::$ctrl.ariaLabel}}"\n                   is-disabled="$ctrl.isDisabled"\n                   ng-model="$ctrl.flashCacheReservationInfo.valueInMB"\n                   unit-options="$ctrl.flashCacheReservationInfo.validUnits"\n                   ng-change="$ctrl.onFlashCacheReservationChange()">\n</vx-value-in-units>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/vmHardwareVirtualDiskIops/vm-hardware-virtual-disk-iops.html','\n<div class="iops-control">\n   <div class="select">\n      <select\n         data-test-id="iops-control"\n         aria-label="{{::$ctrl.ariaLabel}}"\n         ng-options="iopsLimitSelect.label for iopsLimitSelect in $ctrl.iopsLimitDetails.iopsLimitSelectList track by iopsLimitSelect.data"\n         ng-model="$ctrl.iopsLimitDetails.iopsLimitSelection"\n         ng-change="$ctrl.onIopsLimitSelectionChange()"\n         ng-disabled="$ctrl.isDisabled">\n      </select>\n   </div>\n   <vx-value-in-units\n      ng-if="$ctrl.isCustom()"\n      recommended-values="$ctrl.iopsLimitDetails.iopsRecommendations"\n      ng-model="$ctrl.iopsLimit"\n      ng-change="$ctrl.onIopsLimitValueChange()"\n      is-disabled="$ctrl.isDisabled"\n      min="{{ $ctrl.iopsLimitDetails.min }}"\n      max="{{ $ctrl.iopsLimitDetails.max }}"\n      error-messages="$ctrl.iopsLimitDetails.errorMessage"\n      show-units="false"\n   ></vx-value-in-units>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/vmHardwareVirtualDiskMode/vm-hardware-virtual-disk-mode-sign-post.html','<div class="disk-mode-sign-post">\n   <ul>\n      <li data-test-id="dependent">\n         <strong>{{i18n(\'VmUi\', \'DiskConfig.persistent\')}}</strong>\n         <div>{{i18n(\'VmUi\', \'DiskConfig.persistentTip\')}}</div>\n      </li>\n      <li data-test-id="independent_persistent">\n         <strong>{{i18n(\'VmUi\', \'DiskConfig.independent_persistent\')}}</strong>\n         <div>{{i18n(\'VmUi\', \'DiskConfig.independent_persistentTip\')}}</div>\n      </li>\n      <li data-test-id="independent_nonpersistent">\n         <strong>{{i18n(\'VmUi\', \'DiskConfig.independent_nonpersistent\')}}</strong>\n         <div>{{i18n(\'VmUi\', \'DiskConfig.independent_nonpersistentTip\')}}</div>\n      </li>\n   </ul>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/vmHardwareVirtualDiskMode/vm-hardware-virtual-disk-mode.html','<div class="select">\n   <select data-test-id="diskMode"\n           aria-label="{{::$ctrl.ariaLabel}}"\n           ng-disabled="$ctrl.isDisabled"\n           ng-options="option as option.name for option in $ctrl.diskModeInfo.options track by option.value"\n           ng-model="$ctrl.diskModeInfo.selection"\n           ng-change="$ctrl.onDiskModeChange($ctrl.diskModeInfo.selection)">\n   </select>\n</div>\n<a vui-sign-post=\'$ctrl.diskModeSignPostParams\' class=\'pull-right\'>\n   <img ng-src="{{$ctrl.i18n(\'CommonImages\', \'info\')}}"/>\n</a>\n');}]);
var h5_vm;
(function (h5_vm) {
    var DeviceOperationConstants = (function () {
        function DeviceOperationConstants() {
        }
        DeviceOperationConstants.ADD = "add";
        DeviceOperationConstants.EDIT = "edit";
        DeviceOperationConstants.REMOVE = "remove";
        return DeviceOperationConstants;
    }());
    h5_vm.DeviceOperationConstants = DeviceOperationConstants;
    angular
        .module("com.vmware.vsphere.client.vm")
        .constant("deviceOperationConstants", DeviceOperationConstants);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var DeviceTypeConstants = (function () {
        function DeviceTypeConstants() {
        }
        DeviceTypeConstants.CDROM = "VirtualCdrom";
        DeviceTypeConstants.ETHERNET = "VirtualEthernetCard";
        DeviceTypeConstants.VIDEO_CARD = "VirtualVideoCard";
        DeviceTypeConstants.VirtualPCIPassthrough = "VirtualPCIPassthrough";
        DeviceTypeConstants.EXISTINGHARDDISK = "ExistingHardDisk";
        DeviceTypeConstants.INPUT_DEVICE = "InputDevice";
        DeviceTypeConstants.RDMDISK = "RDMDisk";
        DeviceTypeConstants.SCSICONTROLLER = "VirtualSCSIController";
        DeviceTypeConstants.PVSCISI = "ParaVirtualSCSIController";
        DeviceTypeConstants.BUS_LOGIC = "VirtualBusLogicController";
        DeviceTypeConstants.LSI_LOGIC = "VirtualLsiLogicController";
        DeviceTypeConstants.LSI_LOGIC_SAS = "VirtualLsiLogicSASController";
        DeviceTypeConstants.IDE = "VirtualIDEController";
        DeviceTypeConstants.VIRTUAL_CONTROLLER = "VirtualController";
        DeviceTypeConstants.VIRTUALDISK = "VirtualDisk";
        DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER = "VirtualSATAController";
        DeviceTypeConstants.VIRTUAL_USB_CONTROLLER = "VirtualUSBController";
        DeviceTypeConstants.VIRTUAL_USB_XHCI_CONRTOLLER = "VirtualUSBXHCIController";
        DeviceTypeConstants.VIRTUAL_USB = "VirtualUSB";
        DeviceTypeConstants.NVME_CONTROLLER = "VirtualNVMEController";
        DeviceTypeConstants.TPM = 'VirtualTPM';
        DeviceTypeConstants.NVDIMM = "VirtualNVDIMM";
        DeviceTypeConstants.VIRTUAL_SIO_CONTROLLER = "VirtualSIOController";
        DeviceTypeConstants.VIRTUAL_SERIAL_PORT = "VirtualSerialPort";
        return DeviceTypeConstants;
    }());
    h5_vm.DeviceTypeConstants = DeviceTypeConstants;
    var DeviceType = (function (_super) {
        __extends(DeviceType, _super);
        function DeviceType() {
            _super.apply(this, arguments);
        }
        return DeviceType;
    }(DeviceTypeConstants));
    h5_vm.DeviceType = DeviceType;
    angular
        .module("com.vmware.vsphere.client.vm")
        .constant("deviceTypeConstants", DeviceTypeConstants);
})(h5_vm || (h5_vm = {}));



'use strict';
angular
    .module('com.vmware.vsphere.client.vm')
    .constant('diskBackingInfoConstants', {
    FLATVER2: 'com.vmware.vim.binding.vim.vm.device.VirtualDisk$FlatVer2BackingInfo',
    RAWDISKMAPPING: 'com.vmware.vim.binding.vim.vm.device.VirtualDisk$RawDiskMappingVer1BackingInfo',
    SESPARSE: "com.vmware.vim.binding.vim.vm.device.VirtualDisk$SeSparseBackingInfo",
    LOCALPMEM: "com.vmware.vim.binding.vim.vm.device.VirtualDisk$LocalPMemBackingInfo"
});



var h5_vm;
(function (h5_vm) {
    var GosFamilyConstants = (function () {
        function GosFamilyConstants() {
        }
        GosFamilyConstants.WINDOWS = "windowsGuest";
        GosFamilyConstants.LINUX = "linuxGuest";
        GosFamilyConstants.OTHER = "otherGuestFamily";
        return GosFamilyConstants;
    }());
    h5_vm.GosFamilyConstants = GosFamilyConstants;
    angular.module("com.vmware.vsphere.client.vm")
        .constant("gosFamilyConstants", GosFamilyConstants);
})(h5_vm || (h5_vm = {}));



'use strict';
angular
    .module('com.vmware.vsphere.client.vm')
    .constant('guestosCustomizationConstants', {
    UNCUSTOMIZABLE: "UNCUSTOMIZABLE_GUEST",
    MISSING_WINDOWS: "MISSING_WINDOWS_CUSTOMIZATION",
    MISSING_LINUX: "MISSING_LINUX_CUSTOMIZATION",
    TYPE_WINDOWS: 'Windows',
    TYPE_LINUX: 'Linux',
    TYPE_OTHER: 'Unknown'
});



var h5_vm;
(function (h5_vm) {
    var NetworkType = (function () {
        function NetworkType() {
        }
        NetworkType.STD_NETWORK = "com.vmware.vim.binding.vim.vm.NetworkInfo";
        NetworkType.NSX_NETWORK = "com.vmware.vim.binding.vim.vm.OpaqueNetworkInfo";
        NetworkType.DVSWITCH = "com.vmware.vim.binding.vim.dvs.DistributedVirtualSwitchInfo";
        NetworkType.DVPORGGROUP = "com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroupInfo";
        return NetworkType;
    }());
    h5_vm.NetworkType = NetworkType;
    var NetBackingType = (function () {
        function NetBackingType() {
        }
        NetBackingType.STD_NETWORK = "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$NetworkBackingInfo";
        NetBackingType.NSX_NETWORK = "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$OpaqueNetworkBackingInfo";
        NetBackingType.DVPORGGROUP = "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$DistributedVirtualPortBackingInfo";
        return NetBackingType;
    }());
    h5_vm.NetBackingType = NetBackingType;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (DeployWorkflowType) {
        DeployWorkflowType[DeployWorkflowType["OVF"] = 0] = "OVF";
        DeployWorkflowType[DeployWorkflowType["OVA"] = 1] = "OVA";
        DeployWorkflowType[DeployWorkflowType["INVALID"] = 2] = "INVALID";
    })(h5_vm.DeployWorkflowType || (h5_vm.DeployWorkflowType = {}));
    var DeployWorkflowType = h5_vm.DeployWorkflowType;
    var OvfDeployConstants = (function () {
        function OvfDeployConstants() {
        }
        OvfDeployConstants.DEPLOYMENT_LOCAL = 'LOCAL';
        OvfDeployConstants.DEPLOYMENT_URL = 'URL';
        OvfDeployConstants.TEMPLATE_TYPE_OVF = 'OVF';
        OvfDeployConstants.TEMPLATE_TYPE_OVA = 'OVA';
        return OvfDeployConstants;
    }());
    h5_vm.OvfDeployConstants = OvfDeployConstants;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var PowerState = (function () {
        function PowerState() {
        }
        PowerState.POWERED_ON = "poweredOn";
        PowerState.POWERED_OFF = "poweredOff";
        PowerState.SUSPENDED = "suspended";
        return PowerState;
    }());
    h5_vm.PowerState = PowerState;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = (function () {
        function Privileges() {
        }
        Privileges.VM_CONFIG_RESOURCE = "VirtualMachine.Config.Resource";
        Privileges.VM_CONFIG_ADVANCEDCONFIG = "VirtualMachine.Config.AdvancedConfig";
        Privileges.VM_CONFIG_MKSCONTROL = "VirtualMachine.Config.MksControl";
        Privileges.VM_HOST_USB_DEVICE = "VirtualMachine.Config.HostUSBDevice";
        Privileges.VM_ADDREMOVEDEVICE = "VirtualMachine.Config.AddRemoveDevice";
        Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE = "VirtualMachine.Config.AddRemoveDevice";
        Privileges.VM_REMOVEDISK_PRIVILEGE = "VirtualMachine.Config.RemoveDisk";
        Privileges.DATASTORE_ALLOCATESPACE_PRIVILEGE = "Datastore.AllocateSpace";
        Privileges.VM_DISKEXTEND_PRIVILEGE = "VirtualMachine.Config.DiskExtend";
        Privileges.VM_EDITDEVICE_PRIVILEGE = "VirtualMachine.Config.EditDevice";
        Privileges.VM_RESOURCE_PRIVILEGE = "VirtualMachine.Config.Resource";
        Privileges.VM_ADDNEWDISK_PRIVILEGE = "VirtualMachine.Config.AddNewDisk";
        Privileges.VM_RAWDEVICE_PRIVILEGE = "VirtualMachine.Config.RawDevice";
        Privileges.VM_ADDEXISTINGDISK_PRIVILEGE = "VirtualMachine.Config.AddExistingDisk";
        Privileges.VM_CONFIG_SWAPFILEPLACEMENT = "VirtualMachine.Config.SwapPlacement";
        Privileges.VM_REMOVE_SNAPSHOT = "VirtualMachine.State.RemoveSnapshot";
        Privileges.VM_REVERT_SNAPSHOT = "VirtualMachine.State.RevertToSnapshot";
        Privileges.VM_RENAME_SNAPSHOT = "VirtualMachine.State.RenameSnapshot";
        Privileges.VM_CONFIG_RENAME = "VirtualMachine.Config.Rename";
        Privileges.VM_CONFIG_SETTINGS = "VirtualMachine.Config.Settings";
        Privileges.VM_CONFIG_CPU_COUNT = "VirtualMachine.Config.CPUCount";
        Privileges.VM_CONFIG_MEMORY = "VirtualMachine.Config.Memory";
        Privileges.NETWORK_ASSIGN = "Network.Assign";
        Privileges.VM_INTERACT_DEVICE_CONNECTION = "VirtualMachine.Interact.DeviceConnection";
        Privileges.VM_INTERACT_SET_CD_MEDIA = "VirtualMachine.Interact.SetCDMedia";
        Privileges.VM_INTERACT_POWER_ON = "VirtualMachine.Interact.PowerOn";
        Privileges.STORAGE_PROFILE_VIEW = "StorageProfile.View";
        Privileges.CRYPTOGRAPHER_MANAGE_KEY_SERVERS = "Cryptographer.ManageKeyServers";
        Privileges.CRYPTOGRAPHER_MANAGE_ENCRYPTION_POLICY = "Cryptographer.ManageEncryptionPolicy";
        Privileges.CRYPTOGRAPHER_ENCRYPT_NEW_VM = "Cryptographer.EncryptNew";
        Privileges.CRYPTOGRAPHER_ENCRYPT = "Cryptographer.Encrypt";
        Privileges.VM_INVENTORY_REGISTER = "VirtualMachine.Inventory.Register";
        Privileges.VM_INVENTORY_CREATE_FROM_EXISTING = "VirtualMachine.Inventory.CreateFromExisting";
        Privileges.VM_INVENTORY_CREATE = "VirtualMachine.Inventory.Create";
        Privileges.ADD_LIBRARY_ITEM = "ContentLibrary.AddLibraryItem";
        Privileges.VAPP_IMPORT = "VApp.Import";
        return Privileges;
    }());
    h5_vm.Privileges = Privileges;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var TemplateType = (function () {
        function TemplateType() {
        }
        TemplateType.VM_TEMPLATE = "VM Template";
        TemplateType.OVF_TEMPLATE = "OVF";
        return TemplateType;
    }());
    h5_vm.TemplateType = TemplateType;
    var CloneType = (function () {
        function CloneType() {
        }
        CloneType.NEW_TEMPLATE = "new";
        CloneType.UPDATE_TEMPLATE = "update";
        return CloneType;
    }());
    h5_vm.CloneType = CloneType;
})(h5_vm || (h5_vm = {}));



'use strict';
angular
    .module('com.vmware.vsphere.client.vm')
    .constant('vmFtConstants', {
    ftState: {
        DISABLED: 'disabled',
        ENABLED: 'enabled',
        NEED_SECONDARY: 'needSecondary',
        STARTING: 'starting',
        RUNNING: 'running',
        PROTECTED: 'protected',
        ENABLED_POWERED_ON: 'enabledPoweredOn',
        ENABLED_NOT_POWERED_ON: 'enabledNotPoweredOn',
        NOT_RUNNING: 'notRunning',
        NOT_PROTECTED: 'notProtected',
        NOT_CONFIGURED: 'notConfigured'
    },
    fileTypes: {
        VIRTUAL_DISK: "itemTypeDisk",
        CONFIGURATION: "itemTypeConfiguration",
        TIE_BREAKER: "itemTypeFtMetainfFile"
    },
    storageSelectionModes: {
        BASIC_MODE: "basicMode",
        ADVANCED_MODE: "advancedMode"
    }
});



var h5_vm;
(function (h5_vm) {
    var GosComputerNameValidationService = (function () {
        function GosComputerNameValidationService(_i18nService) {
            this._i18nService = _i18nService;
        }
        GosComputerNameValidationService.prototype.validateComputerName = function (maxLength, computerName) {
            if (!computerName) {
                return [this.errorMessage("computerNameEmpty")];
            }
            if (computerName.length > maxLength) {
                return [this.errorMessage("computerNameTooLong", [maxLength])];
            }
            // Computer name can contain letters, numbers and hyphens (-),
            // but no spaces or periods (.). The name cannot consists entirely of digits.
            var regExp = new RegExp("^(?![0-9]+$)(\\*$|[a-zA-Z0-9-]+$)");
            if (!regExp.test(computerName)) {
                return [this.errorMessage("invalidComputerNameError")];
            }
            return [];
        };
        GosComputerNameValidationService.prototype.validateDomainName = function (domainName) {
            if (!domainName) {
                return [this.errorMessage("invalidDomainNameEmptyError")];
            }
            var hasInvalidPart = _.some(domainName.split("."), function (label) {
                return label.length > GosComputerNameValidationService.MAX_CHARS_DOMAIN;
            });
            if (hasInvalidPart) {
                return [this.errorMessage("invalidDomainNameLabelLength")];
            }
            if (domainName.length > GosComputerNameValidationService.MAX_CHARS_DOMAIN_WHOLE) {
                return [this.errorMessage("invalidDomainNameLength")];
            }
            return [];
        };
        GosComputerNameValidationService.prototype.errorMessage = function (suffix, args) {
            if (args === void 0) { args = []; }
            return (_a = this._i18nService).getString.apply(_a, ["VmUi", "customizationSpec.computerNamePage." + suffix].concat(args));
            var _a;
        };
        GosComputerNameValidationService.$inject = [
            "i18nService"];
        GosComputerNameValidationService.MAX_CHARS_WIN = 15;
        GosComputerNameValidationService.MAX_CHARS_LIN = 63;
        GosComputerNameValidationService.MAX_CHARS_DOMAIN = 63;
        GosComputerNameValidationService.MAX_CHARS_DOMAIN_WHOLE = 255;
        return GosComputerNameValidationService;
    }());
    h5_vm.GosComputerNameValidationService = GosComputerNameValidationService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosComputerNameValidationService", GosComputerNameValidationService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmWizardScheduleTaskPageModelFactory = (function () {
        function VmWizardScheduleTaskPageModelFactory(i18nService) {
            return function () {
                return new VmWizardScheduleTaskPageModel(i18nService);
            };
        }
        VmWizardScheduleTaskPageModelFactory.$inject = [
            "i18nService"
        ];
        return VmWizardScheduleTaskPageModelFactory;
    }());
    var VmWizardScheduleTaskPageModel = (function () {
        function VmWizardScheduleTaskPageModel(i18nService) {
            this.i18nService = i18nService;
        }
        VmWizardScheduleTaskPageModel.prototype.validatePage = function () {
            var validationError = "";
            if (this.mutationSpec.schedulingSpec.isFormStatusValid === false ||
                this.mutationSpec.schedulingSpec.recurrence === null) {
                validationError = this.i18nService.getString("VmUi", "wizard.scheduleTaskPage.invalidSchedulerError");
                return { error: validationError };
            }
            return {};
        };
        VmWizardScheduleTaskPageModel.prototype.submitPage = function () {
            return {
                invalidateNextPages: false };
        };
        VmWizardScheduleTaskPageModel.prototype.resetForm = function () {
        };
        VmWizardScheduleTaskPageModel.$inject = ["i18nService"];
        return VmWizardScheduleTaskPageModel;
    }());
    h5_vm.VmWizardScheduleTaskPageModel = VmWizardScheduleTaskPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmWizardScheduleTaskPageModel", VmWizardScheduleTaskPageModelFactory);
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var ScheduledMutationOperationSpec = com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec;
var h5_vm;
(function (h5_vm) {
    /**
     * A "builder" for the ScheduleTaskPageService.
     */
    var VmCreateScheduledTaskMutationService = (function () {
        function VmCreateScheduledTaskMutationService(mutationService) {
            this.mutationService = mutationService;
        }
        VmCreateScheduledTaskMutationService.prototype.createScheduledTask = function (scheduledTaskData) {
            return this.mutationService.add("com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec", scheduledTaskData);
        };
        VmCreateScheduledTaskMutationService.$inject = [
            "mutationService",
        ];
        return VmCreateScheduledTaskMutationService;
    }());
    h5_vm.VmCreateScheduledTaskMutationService = VmCreateScheduledTaskMutationService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmCreateScheduledTaskMutationService", VmCreateScheduledTaskMutationService);
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    /**
     * A "builder" for the ScheduleTaskPageService.
     */
    var VmCreateScheduleTaskPageService = (function () {
        function VmCreateScheduleTaskPageService(i18nService, vmVuiWizardPageBuilder, creationTypeConstants, vmWizardScheduleTaskPageModel) {
            this.i18nService = i18nService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.creationTypeConstants = creationTypeConstants;
            this.vmWizardScheduleTaskPageModel = vmWizardScheduleTaskPageModel;
        }
        VmCreateScheduleTaskPageService.prototype.build = function (wizardScope) {
            var vmWizardScheduleTaskPageModel = new this.vmWizardScheduleTaskPageModel();
            vmWizardScheduleTaskPageModel.mutationSpec = wizardScope.scheduleTaskData.schedulingData;
            vmWizardScheduleTaskPageModel.isScheduledTaskFlow =
                wizardScope.scheduleTaskData.isScheduledTask;
            wizardScope.vmWizardScheduleTaskPageModel = vmWizardScheduleTaskPageModel;
            var page = this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ScheduledOpsUi", "Wizard.scheduleTaskPage.title"),
                contentUrl: "vm-ui/resources/vm/common/scheduleTaskWizard/scheduleTaskPage/vmCreateWizardSchedulePage.html",
                model: vmWizardScheduleTaskPageModel
            });
            return page;
        };
        VmCreateScheduleTaskPageService.$inject = [
            "i18nService",
            "vmVuiWizardPageBuilder",
            "creationTypeConstants",
            "vmWizardScheduleTaskPageModel"
        ];
        return VmCreateScheduleTaskPageService;
    }());
    h5_vm.VmCreateScheduleTaskPageService = VmCreateScheduleTaskPageService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmCreateScheduleTaskPageService", VmCreateScheduleTaskPageService);
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    /**
     * A "builder" for the ScheduleTaskPageService.
     */
    var VmMigrationScheduleTaskPageService = (function () {
        function VmMigrationScheduleTaskPageService(i18nService, wizardPageService, vscSchedulingHelper) {
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
            this.vscSchedulingHelper = vscSchedulingHelper;
        }
        VmMigrationScheduleTaskPageService.prototype.build = function (wizardScope, schedulingSpec) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "wizard.scheduleTaskPage.title"),
                contentUrl: "vm-ui/resources/vm/common/scheduleTaskWizard/"
                    + "scheduleTaskPage/vmWizardScheduleTaskPage.html",
                disableNext: function () {
                    return wizardScope.migrationWizardManager
                        .vmWizardScheduleTaskPageModel.isValidating;
                },
                onCommit: function () {
                    return _this.onCommit(wizardScope);
                }
            };
        };
        VmMigrationScheduleTaskPageService.prototype.onCommit = function (wizardScope) {
            if (wizardScope.migrationWizardManager.vmWizardScheduleTaskPageModel
                .mutationSpec.schedulingSpec.isFormStatusValid === false ||
                wizardScope.migrationWizardManager.vmWizardScheduleTaskPageModel
                    .mutationSpec.schedulingSpec.recurrence === null) {
                this.wizardPageService.markPageIncompleteWithErrors(wizardScope.wizardConfig, [this.i18nService.getString("VmUi", "wizard.scheduleTaskPage.invalidSchedulerError")]);
                return false;
            }
            wizardScope.wizardConfig.validationBanner.messages = [];
            this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);
            return true;
        };
        VmMigrationScheduleTaskPageService.$inject = [
            "i18nService",
            "wizardPageService",
            "vscSchedulingHelper"
        ];
        return VmMigrationScheduleTaskPageService;
    }());
    h5_vm.VmMigrationScheduleTaskPageService = VmMigrationScheduleTaskPageService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrationScheduleTaskPageService", VmMigrationScheduleTaskPageService);
})(h5_vm || (h5_vm = {})); // namespace



var h5_vm;
(function (h5_vm) {
    var Unit = (function () {
        function Unit(label, multiplier) {
            this.label = label;
            this.multiplier = multiplier;
        }
        return Unit;
    }());
    h5_vm.Unit = Unit;
    var DiskUnit = (function () {
        function DiskUnit() {
        }
        DiskUnit.MB = new Unit("MB", 1);
        DiskUnit.GB = new Unit("GB", Math.pow(2, 10));
        DiskUnit.TB = new Unit("TB", Math.pow(2, 20));
        return DiskUnit;
    }());
    h5_vm.DiskUnit = DiskUnit;
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * The motivation for this service is a bug in the application
 * https://bugzilla.eng.vmware.com/show_bug.cgi?id=1864459
 * which causes skipping the digest loop trigger when promises
 * are resolved after MutationService calls, so we have to call it manually
 *
 * TODO - vasila This service should be removed when the bug is fixed
 */
angular.module('com.vmware.vsphere.client.vm')
      .service('zoneDigestPatchService', ['$rootScope', function($rootScope){
         this.digest = function () {
            if (!$rootScope.$$phase) {
               $rootScope.$apply();
            }
         };
      }]);
var vm_ui;
(function (vm_ui) {
    var ContentLibraryIsoSelectorModalService = (function () {
        function ContentLibraryIsoSelectorModalService(clarityModalService, i18nService, defaultUriSchemeUtil, datastoreBrowserConstants, contentLibraryService) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
            this.contentLibraryService = contentLibraryService;
        }
        ContentLibraryIsoSelectorModalService.prototype.openContentLibraryIsoSelector = function (computeResourceId, preSelectedIso, okHandler, cancelHandler) {
            var _this = this;
            this.okHandler = okHandler;
            this.cancelHandler = cancelHandler;
            var dialogData = {
                i18nService: this.i18nService,
                computeResourceId: computeResourceId,
                selectedIsoItem: preSelectedIso,
                onSelectedIsoItemChanged: function (item) {
                    _this.modalOptions.dialogData.selectedIsoItem = item;
                    _this.modalOptions.submitDisabled = false;
                    _this.modalOptions.dialogData.errorMessages = [];
                },
                errorMessages: [],
                validating: false
            };
            this.modalOptions = {
                title: this.i18nService.getString("VmUi", "contentLibISO.infoHeader"),
                contentTemplate: 'vm-ui/resources/vm/content-library-iso-selector-modal/content-library-iso-selector-modal.html',
                defaultButton: 'submit',
                size: 'lg',
                dialogData: dialogData,
                hideSubmitButton: false,
                submitDisabled: !dialogData.selectedIsoItem || !dialogData.selectedIsoItem.name,
                onSubmit: function () {
                    if (dialogData.selectedIsoItem === null || _this.modalOptions.dialogData.validating) {
                        return false;
                    }
                    _this.modalOptions.dialogData.validating = true;
                    return _this.contentLibraryService.getContentLibraryItemWithIso(dialogData.selectedIsoItem)
                        .then(function (libraryItemWithIso) {
                        _this.modalOptions.dialogData.validating = false;
                        if (libraryItemWithIso && libraryItemWithIso.contentLibraryItemByItemId) {
                            if (Array.isArray(libraryItemWithIso.contentLibraryItemByItemId.errorMessages)
                                && libraryItemWithIso.contentLibraryItemByItemId.errorMessages.length > 0) {
                                dialogData.errorMessages = libraryItemWithIso.contentLibraryItemByItemId.errorMessages;
                                _this.modalOptions.submitDisabled = true;
                                return false;
                            }
                            else {
                                dialogData.selectedIsoItem.friendlyName = libraryItemWithIso.contentLibraryItemByItemId.friendlyName;
                                dialogData.selectedIsoItem.isoPath = libraryItemWithIso.contentLibraryItemByItemId.isoPath;
                                dialogData.errorMessages = [];
                                if (angular.isFunction(_this.okHandler)) {
                                    _this.okHandler(dialogData.selectedIsoItem);
                                }
                                return true;
                            }
                        }
                        else {
                            dialogData.errorMessages = [_this.i18nService.getString("VmUi", "CdromPage.clTimeOutPopupMessage")];
                            _this.modalOptions.submitDisabled = true;
                            _this.modalOptions.dialogData.validating = false;
                            return false;
                        }
                    }, function () {
                        _this.modalOptions.dialogData.validating = false;
                        return false;
                    });
                },
                onCancel: function () {
                    if (angular.isFunction(_this.cancelHandler)) {
                        _this.cancelHandler();
                    }
                }
            };
            this.clarityModalService.openOkCancelModal(this.modalOptions);
            return this.modalOptions;
        };
        ContentLibraryIsoSelectorModalService.$inject = ['clarityModalService',
            'i18nService',
            'defaultUriSchemeUtil',
            'datastoreBrowserConstants',
            'contentLibraryService'];
        return ContentLibraryIsoSelectorModalService;
    }());
    vm_ui.ContentLibraryIsoSelectorModalService = ContentLibraryIsoSelectorModalService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("contentLibraryIsoSelectorModalService", ContentLibraryIsoSelectorModalService);
})(vm_ui || (vm_ui = {}));



var h5_vm;
(function (h5_vm) {
    var VmCustomizationSpecification = com.vmware.vsphere.client.vm.VmCustomizationSpecification;
    var CustomizeGosApplySpecService = (function () {
        function CustomizeGosApplySpecService(mutationService) {
            this.mutationService = mutationService;
        }
        CustomizeGosApplySpecService.prototype.apply = function (vmId, specification) {
            var spec = new VmCustomizationSpecification();
            spec.spec = specification;
            this.mutationService.apply(vmId, spec._type, spec);
            return true;
        };
        CustomizeGosApplySpecService.$inject = ["mutationService"];
        return CustomizeGosApplySpecService;
    }());
    h5_vm.CustomizeGosApplySpecService = CustomizeGosApplySpecService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("customizeGosApplySpecService", CustomizeGosApplySpecService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosPageModelBase = (function () {
        function CustomizeGosPageModelBase(vmId, vmGuestOsFullName) {
            this._vmId = vmId;
            this._vmGuestOsFullName = vmGuestOsFullName;
        }
        Object.defineProperty(CustomizeGosPageModelBase.prototype, "vmId", {
            get: function () {
                return this._vmId;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CustomizeGosPageModelBase.prototype, "vmGuestOsFullName", {
            get: function () {
                return this._vmGuestOsFullName;
            },
            enumerable: true,
            configurable: true
        });
        return CustomizeGosPageModelBase;
    }());
    h5_vm.CustomizeGosPageModelBase = CustomizeGosPageModelBase;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosPreCheckSpecsService = (function () {
        function CustomizeGosPreCheckSpecsService(dataService, i18nService, clarityModalService, $q) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.$q = $q;
            this.CUSTOMIZE_GOS_SPEC_DATA = "customizeGosSpecData";
            this.i18n = this.i18nService.getString;
        }
        CustomizeGosPreCheckSpecsService.prototype.customizeGosLoadData = function (vmId) {
            var _this = this;
            return this.loadData(vmId).then(function (data) {
                var error = _this.validateData(data);
                if (error) {
                    _this.clarityModalService.openConfirmationModal({
                        title: _this.i18n("VmUi", "customizeGuestOs.title"),
                        message: error,
                        submit: function () {
                        },
                        icon: "vui-icon32-error",
                        preserveNewlines: true,
                        saveButtonLabel: _this.i18n("Common", "close.label"),
                        cancelButtonLabel: null,
                        hideCancelButton: true
                    });
                    return _this.$q.reject(undefined);
                }
                return _this.$q.resolve(data);
            });
        };
        CustomizeGosPreCheckSpecsService.prototype.cloneCustomizeGosLoadData = function (vmId, onlyPrivilegeCheck) {
            var _this = this;
            if (onlyPrivilegeCheck === void 0) { onlyPrivilegeCheck = false; }
            return this.loadData(vmId).then(function (data) {
                var error = _this.validateDataInternal(data, onlyPrivilegeCheck);
                var result = {
                    error: error,
                    data: data
                };
                return _this.$q.resolve(result);
            });
        };
        CustomizeGosPreCheckSpecsService.prototype.validateData = function (data) {
            return this.validateDataInternal(data);
        };
        CustomizeGosPreCheckSpecsService.prototype.loadData = function (vmId) {
            var _this = this;
            return this.dataService.getProperties(vmId, [this.CUSTOMIZE_GOS_SPEC_DATA])
                .then(function (response) {
                var data = response[_this.CUSTOMIZE_GOS_SPEC_DATA];
                return data;
            });
        };
        CustomizeGosPreCheckSpecsService.prototype.validateDataInternal = function (data, onlyPrivilegeCheck) {
            if (onlyPrivilegeCheck === void 0) { onlyPrivilegeCheck = false; }
            var error = "";
            if (!data.vmCustomizePrivGranted) {
                return this.i18n("VmUi", "CustomizeGuestOsProvisioningPage.content.no_permissions_vm");
            }
            if (!data.vcReadSpecPrivGranted) {
                return this.i18n("VmUi", "CustomizeGuestOsProvisioningPage.content.no_read_permissions");
            }
            if (onlyPrivilegeCheck) {
                return error;
            }
            if (data.pendingCustomization) {
                return this.i18n("VmUi", "customizationManager.error.pendingCustomization");
            }
            switch (data.compatibility) {
                case "MISSING_WINDOWS_CUSTOMIZATION":
                    error = this.i18n("VmUi", "CustomizationDataProvider.missing_windows");
                    break;
                case "MISSING_LINUX_CUSTOMIZATION":
                    error = this.i18n("VmUi", "CustomizationDataProvider.missing_linux");
                    break;
                case "UNCUSTOMIZABLE_GUEST":
                    error = this.i18n("VmUi", "CustomizationDataProvider.cannot_customize");
                    break;
                default:
                    break;
            }
            return error;
        };
        CustomizeGosPreCheckSpecsService.$inject = ["dataService", "i18nService", "clarityModalService", "$q"];
        return CustomizeGosPreCheckSpecsService;
    }());
    h5_vm.CustomizeGosPreCheckSpecsService = CustomizeGosPreCheckSpecsService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("customizeGosPreCheckSpecsService", CustomizeGosPreCheckSpecsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosSelectSpecDialogService = (function () {
        function CustomizeGosSelectSpecDialogService($q, i18nService, clarityModalService, vuiConstants, customizeGosApplySpecService, customizeGosUserSettingsDialogService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.vuiConstants = vuiConstants;
            this.customizeGosApplySpecService = customizeGosApplySpecService;
            this.customizeGosUserSettingsDialogService = customizeGosUserSettingsDialogService;
        }
        CustomizeGosSelectSpecDialogService.prototype.open = function (context) {
            this.context = context;
            var dialogOptions = {
                contentTemplate: "vm-ui/resources/vm/customize-guest-os/select-spec/customize-gos-select-spec-page.html",
                title: this.i18nService.getString("VmUi", "customizeGuestOs.title"),
                subTitle: {
                    objectId: this.context.vmId
                },
                size: "lg",
                defaultButton: "submit",
                onSubmit: this.onDialogSubmit.bind(this)
            };
            this.pageModel = new h5_vm.CustomizeGosSelectSpecPageModel(this.context.vmId, this.context.vmGuestOsFullName, this.context.relevantSpecs);
            dialogOptions.dialogData = {
                selectSpecPageModel: this.pageModel
            };
            this.dialogOptions = dialogOptions;
            this.clarityModalService.openOkCancelModal(this.dialogOptions);
        };
        // region private helpers
        CustomizeGosSelectSpecDialogService.prototype.onDialogSubmit = function () {
            var _this = this;
            var pageCommitPromise = this.pageModel.onPageCommit
                ? this.pageModel.onPageCommit()
                : this.$q.resolve([]);
            return pageCommitPromise.then(function (errorMsgs) {
                _this.dialogOptions.alerts = [];
                if (errorMsgs && errorMsgs.length > 0) {
                    _this.dialogOptions.alerts = errorMsgs.map(function (msg) {
                        return {
                            text: msg,
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        };
                    });
                    return _this.$q.resolve(false);
                }
                if (!_this.pageModel.specification) {
                    throw new Error("Invalid specification");
                }
                var selectedSpecification = _this.pageModel.specification;
                if (_this.pageModel.hasUnknownNameGen ||
                    _this.pageModel.hasUnknownIpv4Gen ||
                    _this.pageModel.hasUnknownIpv6Gen) {
                    return _this.promptForUserSettings().then(function (confirmed) {
                        if (confirmed) {
                            var context = {
                                vmId: _this.context.vmId,
                                vmGuestOsFullName: _this.context.vmGuestOsFullName,
                                vmGuestOsType: _this.context.vmGuestOsType,
                                specification: selectedSpecification,
                                hasUnknownNameGen: _this.pageModel.hasUnknownNameGen,
                                hasUnknownIpv4Gen: _this.pageModel.hasUnknownIpv4Gen,
                                hasUnknownIpv6Gen: _this.pageModel.hasUnknownIpv6Gen,
                                focusTarget: _this.dialogOptions.focusTarget
                            };
                            _this.dialogOptions.focusTarget = null;
                            _this.customizeGosUserSettingsDialogService.open(context);
                        }
                        return confirmed;
                    });
                }
                // no additional data needed - apply the spec
                var res = _this.customizeGosApplySpecService.apply(_this.context.vmId, selectedSpecification);
                return _this.$q.resolve(res);
                ;
            });
        };
        CustomizeGosSelectSpecDialogService.prototype.promptForUserSettings = function () {
            var defered = this.$q.defer();
            this.clarityModalService.openConfirmationModal({
                title: this.i18nService.getString("VmUi", "customizeGuestOs.openUserSettingsPrompt.title"),
                message: this.i18nService.getString("VmUi", "customizeGuestOs.openUserSettingsPrompt.text"),
                submit: function () {
                    defered.resolve(true);
                },
                onCancel: function () {
                    defered.resolve(false);
                },
                showXIcon: false,
                clarityIcon: {
                    shape: "warning",
                    class: "is-warning",
                    size: 48
                },
                preserveNewlines: true,
                saveButtonLabel: this.i18nService.getString("Common", "yes.label"),
                cancelButtonLabel: this.i18nService.getString("Common", "no.label")
            });
            return defered.promise;
        };
        CustomizeGosSelectSpecDialogService.$inject = [
            "$q",
            "i18nService",
            "clarityModalService",
            "vuiConstants",
            "customizeGosApplySpecService",
            "customizeGosUserSettingsDialogService"
        ];
        return CustomizeGosSelectSpecDialogService;
    }());
    h5_vm.CustomizeGosSelectSpecDialogService = CustomizeGosSelectSpecDialogService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("customizeGosSelectSpecDialogService", CustomizeGosSelectSpecDialogService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosSelectSpecPageController = (function () {
        function CustomizeGosSelectSpecPageController(pageService, i18nService, vuiConstants, timeFormatterService, $q) {
            this.pageService = pageService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.timeFormatterService = timeFormatterService;
            this.$q = $q;
            this.i18n = this.i18nService.getString;
            this.model.onPageCommit = this.onPageCommit.bind(this);
        }
        CustomizeGosSelectSpecPageController.prototype.$onInit = function () {
            this.specsGridOptions = this.buildGridConfiguration();
            this.specsGridOptions.data = _.sortBy(this.model.relevantSpecs, function (spec) {
                return spec.name.toLowerCase();
            });
        };
        CustomizeGosSelectSpecPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        CustomizeGosSelectSpecPageController.prototype.onPageCommit = function () {
            return this.validateSelection();
        };
        CustomizeGosSelectSpecPageController.prototype.buildGridConfiguration = function () {
            var _this = this;
            return {
                columnDefs: [
                    {
                        field: "name",
                        displayName: this.i18n("VmUi", "CustomizeGuestOsProvisioningPage.content.name")
                    },
                    {
                        field: "type",
                        displayName: this.i18n("VmUi", "CustomizeGuestOsProvisioningPage.content.type"),
                        width: 120
                    },
                    {
                        field: "lastUpdateTime",
                        searchable: false,
                        displayName: this.i18n("VmUi", "customizationManager.customizationSpecList.lastModifiedColumnHeader"),
                        template: function (spec) {
                            return _this.timeFormatterService.timestampToText(parseInt(spec.lastUpdateTime));
                        },
                        width: 200
                    }
                ],
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: false,
                resizable: true,
                height: "100%",
                selectedItems: [],
                data: []
            };
        };
        CustomizeGosSelectSpecPageController.prototype.validateSelection = function () {
            var _this = this;
            this.model.specification = undefined;
            this.model.hasUnknownNameGen = false;
            this.model.hasUnknownIpv4Gen = false;
            this.model.hasUnknownIpv6Gen = false;
            if (!this.specsGridOptions.selectedItems ||
                this.specsGridOptions.selectedItems.length !== 1) {
                return this.$q.resolve([this.i18n("VmUi", "customizeGuestOs.selectSpecPage.no_selection")]);
            }
            var selectedItem = this.specsGridOptions.selectedItems[0];
            return this.pageService.validateSpec(this.model.vmId, selectedItem.name)
                .then(function (valRes) {
                return _this.parseValidationResult(valRes);
            });
        };
        CustomizeGosSelectSpecPageController.prototype.parseValidationResult = function (valRes) {
            if (!valRes) {
                return [this.i18n("VmUi", "customizeGuestOs.selectSpecPage.error_loading_data")];
            }
            var errors = [];
            if (!valRes.isPublicKeyTheSame) {
                errors.push(this.i18n("VmUi", "customizeGuestOs.selectSpecPage.invalid_public_key"));
            }
            if (!valRes.areTypicalNetworkingSettingsUsed &&
                !valRes.isNetworkCardsCountTheSame) {
                errors.push(this.i18n("VmUi", "customizeGuestOs.selectSpecPage.incorrect_nic_count", valRes.specInfoName));
            }
            if (errors.length > 0) {
                return errors;
            }
            var specification = valRes.spec;
            var winOptions = specification.options;
            // Note: we do this to make sure there are no old specs
            if (winOptions && winOptions.deleteAccounts) {
                // this is a deprecated property
                winOptions.deleteAccounts = false;
            }
            this.model.specification = specification;
            this.model.hasUnknownNameGen = valRes.hasUnknownNameTypeGen;
            this.model.hasUnknownIpv4Gen = valRes.hasUnknownIpv4TypeGen;
            this.model.hasUnknownIpv6Gen = valRes.hasUnknownIpv6TypeGen;
            return [];
        };
        CustomizeGosSelectSpecPageController.$inject = ["customizeGosSelectSpecPageService", "i18nService",
            "vuiConstants", "timeFormatterService", "$q"];
        return CustomizeGosSelectSpecPageController;
    }());
    h5_vm.CustomizeGosSelectSpecPageController = CustomizeGosSelectSpecPageController;
    var CustomizeGosSelectSpecPageComponent = (function () {
        function CustomizeGosSelectSpecPageComponent() {
            this.controller = CustomizeGosSelectSpecPageController;
            this.templateUrl =
                "vm-ui/resources/vm/customize-guest-os/select-spec/customize-gos-select-spec-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return CustomizeGosSelectSpecPageComponent;
    }());
    h5_vm.CustomizeGosSelectSpecPageComponent = CustomizeGosSelectSpecPageComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("customizeGosSelectSpecPage", new CustomizeGosSelectSpecPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var CustomizeGosPageModelBase = h5_vm.CustomizeGosPageModelBase;
    var CustomizeGosSelectSpecPageModel = (function (_super) {
        __extends(CustomizeGosSelectSpecPageModel, _super);
        function CustomizeGosSelectSpecPageModel(vmId, vmGuestOsFullName, relevantSpecs) {
            _super.call(this, vmId, vmGuestOsFullName);
            this._relevantSpecs = relevantSpecs;
        }
        Object.defineProperty(CustomizeGosSelectSpecPageModel.prototype, "relevantSpecs", {
            get: function () {
                return this._relevantSpecs;
            },
            enumerable: true,
            configurable: true
        });
        return CustomizeGosSelectSpecPageModel;
    }(CustomizeGosPageModelBase));
    h5_vm.CustomizeGosSelectSpecPageModel = CustomizeGosSelectSpecPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosSelectSpecPageService = (function () {
        function CustomizeGosSelectSpecPageService(mutationService) {
            this.mutationService = mutationService;
        }
        CustomizeGosSelectSpecPageService.prototype.validateSpec = function (vmId, specName) {
            return this.mutationService.validate(vmId, "java.lang.String", angular.toJson(specName))
                .then(function (response) {
                return response.result;
            });
        };
        CustomizeGosSelectSpecPageService.$inject = ["mutationService"];
        return CustomizeGosSelectSpecPageService;
    }());
    h5_vm.CustomizeGosSelectSpecPageService = CustomizeGosSelectSpecPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("customizeGosSelectSpecPageService", CustomizeGosSelectSpecPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CustomizeGosUserSettingsDialogService = (function () {
        function CustomizeGosUserSettingsDialogService(i18nService, clarityModalService, vuiConstants, customizeGosApplySpecService, $q) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.vuiConstants = vuiConstants;
            this.customizeGosApplySpecService = customizeGosApplySpecService;
            this.$q = $q;
        }
        CustomizeGosUserSettingsDialogService.prototype.open = function (context) {
            this.context = context;
            var dialogOptions = {
                contentTemplate: "vm-ui/resources/vm/customize-guest-os/user-settings/customize-gos-user-settings-page.html",
                title: this.i18nService.getString("VmUi", "customizeGuestOs.title"),
                subTitle: {
                    objectId: this.context.vmId
                },
                defaultButton: "submit",
                onSubmit: this.onDialogSubmit.bind(this),
                submitButtonTitle: this.i18nService.getString("VmUi", "customizeGuestOs.dialog.saveButton"),
                focusTarget: context.focusTarget
            };
            this.pageModel = new h5_vm.CustomizeGosUserSettingsPageModel(this.context.vmId, this.context.vmGuestOsFullName, this.context.vmGuestOsType, this.context.specification);
            this.pageModel.hasUnknownNameGen = this.context.hasUnknownNameGen;
            this.pageModel.hasUnknownIpv4Gen = this.context.hasUnknownIpv4Gen;
            this.pageModel.hasUnknownIpv6Gen = this.context.hasUnknownIpv6Gen;
            dialogOptions.dialogData = {
                userSettingsPageModel: this.pageModel
            };
            this.dialogOptions = dialogOptions;
            this.clarityModalService.openOkCancelModal(this.dialogOptions);
        };
        // region private helpers
        CustomizeGosUserSettingsDialogService.prototype.onDialogSubmit = function () {
            var _this = this;
            var pageCommitPromise = this.pageModel.onPageCommit
                ? this.pageModel.onPageCommit()
                : this.$q.resolve([]);
            return pageCommitPromise.then(function (errorMsgs) {
                _this.dialogOptions.alerts = [];
                if (errorMsgs && errorMsgs.length > 0) {
                    _this.dialogOptions.alerts = errorMsgs.map(function (msg) {
                        return {
                            text: msg,
                            type: _this.vuiConstants.validationBanner.type.ERROR
                        };
                    });
                    return false;
                }
                if (!_this.pageModel.specification) {
                    throw new Error("Invalid specification");
                }
                return _this.customizeGosApplySpecService.apply(_this.context.vmId, _this.pageModel.specification);
            });
        };
        CustomizeGosUserSettingsDialogService.$inject = [
            "i18nService",
            "clarityModalService",
            "vuiConstants",
            "customizeGosApplySpecService",
            "$q",
        ];
        return CustomizeGosUserSettingsDialogService;
    }());
    h5_vm.CustomizeGosUserSettingsDialogService = CustomizeGosUserSettingsDialogService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("customizeGosUserSettingsDialogService", CustomizeGosUserSettingsDialogService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var UnknownIpGenerator = com.vmware.vim.binding.vim.vm.customization.UnknownIpGenerator;
    var UnknownIpV6Generator = com.vmware.vim.binding.vim.vm.customization.UnknownIpV6Generator;
    var FixedName = com.vmware.vim.binding.vim.vm.customization.FixedName;
    var FixedIp = com.vmware.vim.binding.vim.vm.customization.FixedIp;
    var FixedIpV6 = com.vmware.vim.binding.vim.vm.customization.FixedIpV6;
    var IPSettings$IpV6AddressSpec = com.vmware.vim.binding.vim.vm.customization.IPSettings$IpV6AddressSpec;
    var IpGenAdapterMapping = (function () {
        function IpGenAdapterMapping() {
        }
        return IpGenAdapterMapping;
    }());
    h5_vm.IpGenAdapterMapping = IpGenAdapterMapping;
    var CustomizeGosUserSettingsPageController = (function () {
        function CustomizeGosUserSettingsPageController(i18nService, $q, computerNameValidationService, ipParserService, $timeout, $element) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.computerNameValidationService = computerNameValidationService;
            this.ipParserService = ipParserService;
            this.$timeout = $timeout;
            this.$element = $element;
            this.UNKNOWN_IP_GEN_TYPE = new UnknownIpGenerator()._type;
            this.UNKNOWN_IPV6_GEN_TYPE = new UnknownIpV6Generator()._type;
            this.GOS_TYPE_WINDOWS = "Windows";
            this.i18n = i18nService.getString;
            this.model.onPageCommit = this.onPageCommit.bind(this);
        }
        CustomizeGosUserSettingsPageController.prototype.$onInit = function () {
            var _this = this;
            this.mainTitle = this.i18n("VmUi", "CustomizationParametersPageBase.nic.mainTitle");
            if (this.model.hasUnknownNameGen) {
                this.initComputerNameModel();
                this.initComputerNameLabels();
            }
            this.initNicLabels();
            this.initNicModels();
            this.$timeout(function () {
                var firstInput = _this.$element[0].querySelector("input,[role='button']");
                if (firstInput) {
                    firstInput.focus();
                }
            }, 0);
        };
        CustomizeGosUserSettingsPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        CustomizeGosUserSettingsPageController.prototype.onPageCommit = function () {
            this.validateComputerName();
            this.validateAllNics();
            var result = (this.isComputerNameValid() && this.areAllNicsValid())
                ? []
                : [this.i18n("VmUi", "CustomizationParametersPageBase.validation_error")];
            if (result.length === 0) {
                this.applyAdapterChanges();
            }
            return this.$q.resolve(result);
        };
        CustomizeGosUserSettingsPageController.prototype.expandedChanged = function (expanded, nic) {
            nic.expanded = expanded;
            nic.alerts = 0;
            if (nic.expanded) {
                return;
            }
            _.each(nic.errors, function (error) {
                if (error) {
                    nic.alerts += 1;
                }
            });
        };
        CustomizeGosUserSettingsPageController.prototype.shouldExpand = function (index) {
            return index === 0 &&
                this.nicSettingsMapWrapper &&
                this.nicSettingsMapWrapper.length === 1;
        };
        CustomizeGosUserSettingsPageController.prototype.applyAdapterChanges = function () {
            if (!this.nicSettingsMapWrapper) {
                return;
            }
            for (var _i = 0, _a = this.nicSettingsMapWrapper; _i < _a.length; _i++) {
                var nic = _a[_i];
                nic.adapterMapping.adapter.gateway = [];
                if (nic.defaultGateway) {
                    nic.adapterMapping.adapter.gateway.push(nic.defaultGateway);
                }
                if (nic.alternateGateway) {
                    nic.adapterMapping.adapter.gateway.push(nic.alternateGateway);
                }
                if (nic.isIpv6Unknown) {
                    nic.adapterMapping.adapter.ipV6Spec.gateway = nic.ipv6Gateways;
                }
            }
        };
        CustomizeGosUserSettingsPageController.prototype.initComputerNameModel = function () {
            var identity = this.model.specification.identity;
            if (this.model.vmGuestOsType === this.GOS_TYPE_WINDOWS) {
                this.nameGenerator = identity.userData.computerName =
                    new FixedName();
                this.nameMaxLength = h5_vm.GosComputerNameValidationService.MAX_CHARS_WIN;
            }
            else {
                this.nameGenerator = identity.hostName =
                    new FixedName();
                this.nameMaxLength = h5_vm.GosComputerNameValidationService.MAX_CHARS_LIN;
            }
            this.nameGenerator.name = "";
        };
        CustomizeGosUserSettingsPageController.prototype.initComputerNameLabels = function () {
            this.computerNameLabel = this.i18n("VmUi", "CustomizationParametersPageBase.name.label");
            this.computerNameLengthWarning = this.i18n("VmUi", "CustomizationParametersPageBase.name.warning", this.nameMaxLength);
        };
        CustomizeGosUserSettingsPageController.prototype.initNicLabels = function () {
            this.ipv4AddressLabel = this.i18n("VmUi", "CustomizationParametersPageBase.nic.ipv4Address");
            this.ipv4SubnetMaskLabel = this.i18n("VmUi", "CustomizationParametersPageBase.nic.ipv4SubnetMask");
            this.ipv6AddressLabel = this.i18n("VmUi", "CustomizationParametersPageBase.nic.ipv6Address");
            this.ipv6PrefixLabel = this.i18n("VmUi", "CustomizationParametersPageBase.nic.ipv6PrefixInput");
        };
        CustomizeGosUserSettingsPageController.prototype.initNicModels = function () {
            this.nicSettingsMapWrapper = [];
            if (!this.model.specification.nicSettingMap) {
                return;
            }
            for (var i = 0; i < this.model.specification.nicSettingMap.length; i++) {
                var adapterMapping = this.model.specification.nicSettingMap[i];
                var ipGenAdapterMapping = new IpGenAdapterMapping();
                ipGenAdapterMapping.adapterMapping = adapterMapping;
                ipGenAdapterMapping.errors = {};
                ipGenAdapterMapping.expanded = false;
                this.nicSettingsMapWrapper.push(ipGenAdapterMapping);
                ipGenAdapterMapping.isIpv4Unknown = this.isIpv4Unknown(adapterMapping);
                ipGenAdapterMapping.errors.isIpv4AddressInvalid = false;
                ipGenAdapterMapping.errors.isIpv4SubnetInvalid = false;
                if (ipGenAdapterMapping.isIpv4Unknown) {
                    adapterMapping.adapter.ip = new FixedIp();
                    if (adapterMapping.adapter.gateway && adapterMapping.adapter.gateway.length > 0) {
                        ipGenAdapterMapping.defaultGateway = adapterMapping.adapter.gateway[0];
                    }
                    if (adapterMapping.adapter.gateway && adapterMapping.adapter.gateway.length > 1) {
                        ipGenAdapterMapping.alternateGateway = adapterMapping.adapter.gateway[1];
                    }
                }
                ipGenAdapterMapping.isIpv6Unknown = this.isIpv6Unknown(adapterMapping);
                ipGenAdapterMapping.errors.isIpv6AddressInvalid = false;
                ipGenAdapterMapping.errors.isIpv6SubnetInvalid = false;
                if (ipGenAdapterMapping.isIpv6Unknown) {
                    ipGenAdapterMapping.ipv6Gateways = [];
                    if (adapterMapping.adapter.ipV6Spec.gateway
                        && adapterMapping.adapter.ipV6Spec.gateway.length > 0) {
                        ipGenAdapterMapping.ipv6Gateways = adapterMapping.adapter.ipV6Spec.gateway;
                    }
                    var newIPv6 = new FixedIpV6();
                    var ipv6Spec = new IPSettings$IpV6AddressSpec();
                    ipv6Spec.ip = [newIPv6];
                    adapterMapping.adapter.ipV6Spec = ipv6Spec;
                }
                this.buildGridOptions(ipGenAdapterMapping);
            }
        };
        CustomizeGosUserSettingsPageController.prototype.getNicHeaderName = function (index) {
            return this.i18n("VmUi", "CustomizationParametersPageBase.nic.title", index);
        };
        CustomizeGosUserSettingsPageController.prototype.isIpv4Unknown = function (mapping) {
            return mapping && mapping.adapter &&
                mapping.adapter.ip && mapping.adapter.ip._type === this.UNKNOWN_IP_GEN_TYPE;
        };
        CustomizeGosUserSettingsPageController.prototype.isIpv6Unknown = function (mapping) {
            return mapping && mapping.adapter && mapping.adapter.ipV6Spec
                && mapping.adapter.ipV6Spec.ip
                && mapping.adapter.ipV6Spec.ip.length > 0
                && mapping.adapter.ipV6Spec.ip[0]._type === this.UNKNOWN_IPV6_GEN_TYPE;
        };
        CustomizeGosUserSettingsPageController.prototype.isComputerNameValid = function () {
            return !this.nameError;
        };
        CustomizeGosUserSettingsPageController.prototype.validateComputerName = function () {
            var errors = this.model.hasUnknownNameGen
                ? this.computerNameValidationService.validateComputerName(this.nameMaxLength, this.nameGenerator.name)
                : [];
            this.nameError = _.isEmpty(errors) ? undefined : errors[0];
        };
        CustomizeGosUserSettingsPageController.prototype.areAllNicsValid = function () {
            return !_.some(this.nicSettingsMapWrapper, function (nic) {
                return _.some(nic.errors, function (error) {
                    return error;
                });
            });
        };
        CustomizeGosUserSettingsPageController.prototype.validateAllNics = function () {
            if (!this.nicSettingsMapWrapper) {
                return;
            }
            for (var _i = 0, _a = this.nicSettingsMapWrapper; _i < _a.length; _i++) {
                var nic = _a[_i];
                this.validateNicIpv4Address(nic);
                this.validateNicIpv4Subnet(nic);
                this.validateDefaultGateway(nic);
                this.validateAlternateGateway(nic);
                this.validateNicIpv6Address(nic);
                this.validateNicIpv6Subnet(nic);
                this.expandedChanged(nic.expanded, nic);
            }
        };
        CustomizeGosUserSettingsPageController.prototype.validateNicIpv4Address = function (nic) {
            if (!nic.isIpv4Unknown) {
                return;
            }
            nic.errors.isIpv4AddressInvalid = !this.ipParserService.isIpv4AddressValid(nic.adapterMapping.adapter.ip.ipAddress);
        };
        CustomizeGosUserSettingsPageController.prototype.validateNicIpv4Subnet = function (nic) {
            if (!nic.isIpv4Unknown) {
                return;
            }
            nic.errors.isIpv4SubnetInvalid = !this.ipParserService.isSubnetMaskValid(nic.adapterMapping.adapter.subnetMask);
        };
        CustomizeGosUserSettingsPageController.prototype.validateNicIpv6Address = function (nic) {
            if (!nic.isIpv6Unknown) {
                return;
            }
            nic.errors.isIpv6AddressInvalid = !this.ipParserService.isIpv6AddressValid(nic.adapterMapping.adapter.ipV6Spec.ip[0].ipAddress);
        };
        CustomizeGosUserSettingsPageController.prototype.validateNicIpv6Subnet = function (nic) {
            if (!nic.isIpv6Unknown) {
                return;
            }
            nic.errors.isIpv6SubnetInvalid = !this.ipParserService.isSubnetPrefixValid(nic.adapterMapping.adapter.ipV6Spec.ip[0].subnetMask);
        };
        CustomizeGosUserSettingsPageController.prototype.validateDefaultGateway = function (nic) {
            if (!nic.isIpv4Unknown) {
                return;
            }
            nic.errors.defaultGatewayInvalid = !!nic.defaultGateway &&
                !this.ipParserService.isIpv4AddressValid(nic.defaultGateway);
        };
        CustomizeGosUserSettingsPageController.prototype.validateAlternateGateway = function (nic) {
            if (!nic.isIpv4Unknown) {
                return;
            }
            nic.errors.alternateGatewayInvalid = !!nic.alternateGateway &&
                !this.ipParserService.isIpv4AddressValid(nic.alternateGateway);
        };
        CustomizeGosUserSettingsPageController.prototype.validateGateway = function (gateway, nic) {
            if (!gateway) {
                nic.ipv6GatewayInvalidMessage = "";
                return;
            }
            var isValid = this.ipParserService.isIpv6AddressValid(gateway);
            var isDuplicate = _.any(nic.ipv6Gateways, function (currentGateway) {
                return currentGateway === gateway;
            });
            if (!isValid) {
                nic.ipv6GatewayInvalidMessage =
                    this.i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.error.ipv6.address");
            }
            if (isDuplicate) {
                nic.ipv6GatewayInvalidMessage =
                    this.i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.error.ipv6.duplicate", gateway);
            }
            if (isValid && !isDuplicate) {
                nic.ipv6GatewayInvalidMessage = "";
            }
        };
        CustomizeGosUserSettingsPageController.prototype.addGateway = function (nic) {
            this.validateGateway(nic.lastGateway, nic);
            if (!nic.lastGateway || nic.ipv6GatewayInvalidMessage) {
                return;
            }
            nic.ipv6Gateways.push(nic.lastGateway);
            nic.ipv6GridGatewaysOptions.data = nic.ipv6Gateways;
            nic.lastGateway = "";
        };
        CustomizeGosUserSettingsPageController.prototype.buildGridOptions = function (nic) {
            var _this = this;
            var gridGatewaysOptions = {};
            gridGatewaysOptions.columnDefinitions = [
                {
                    displayName: this.i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.ipv6.gateway"),
                    type: "string"
                }
            ];
            gridGatewaysOptions.data = nic.ipv6Gateways;
            gridGatewaysOptions.deleteLabel = this.i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.delete.label");
            gridGatewaysOptions.deleteTooltip = this.i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.delete.tooltip");
            gridGatewaysOptions.onDelete = function (gateway) {
                _this.deleteGatewayFromList(gateway, nic);
            };
            gridGatewaysOptions.placeholder = this.i18nService.getString("VmUi", "CustomizationParametersPageBase.noGateways");
            gridGatewaysOptions.gridLabel = this.i18nService.getString("VmUi", "CustomizationParametersPageBase.ipv6GatewaysDescription");
            nic.ipv6GridGatewaysOptions = gridGatewaysOptions;
        };
        CustomizeGosUserSettingsPageController.prototype.deleteGatewayFromList = function (gateway, nic) {
            if (!gateway) {
                return;
            }
            var index = _.findIndex(nic.ipv6Gateways, function (currentGateway) {
                return currentGateway === gateway;
            });
            if (index < 0) {
                return;
            }
            nic.ipv6Gateways.splice(index, 1);
        };
        CustomizeGosUserSettingsPageController.$inject = ["i18nService",
            "$q",
            "gosComputerNameValidationService",
            "ipParserService",
            "$timeout",
            "$element"];
        return CustomizeGosUserSettingsPageController;
    }());
    h5_vm.CustomizeGosUserSettingsPageController = CustomizeGosUserSettingsPageController;
    var CustomizeGosUserSettingsPageComponent = (function () {
        function CustomizeGosUserSettingsPageComponent() {
            this.controller = CustomizeGosUserSettingsPageController;
            this.templateUrl =
                "vm-ui/resources/vm/customize-guest-os/user-settings/customize-gos-user-settings-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return CustomizeGosUserSettingsPageComponent;
    }());
    h5_vm.CustomizeGosUserSettingsPageComponent = CustomizeGosUserSettingsPageComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("customizeGosUserSettingsPage", new CustomizeGosUserSettingsPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var CustomizeGosPageModelBase = h5_vm.CustomizeGosPageModelBase;
    var CustomizeGosUserSettingsPageModel = (function (_super) {
        __extends(CustomizeGosUserSettingsPageModel, _super);
        function CustomizeGosUserSettingsPageModel(vmId, vmGuestOsFullName, vmGuestOsType, specification) {
            _super.call(this, vmId, vmGuestOsFullName);
            this._vmGuestOsType = vmGuestOsType;
            this._specification = specification;
        }
        Object.defineProperty(CustomizeGosUserSettingsPageModel.prototype, "vmGuestOsType", {
            get: function () {
                return this._vmGuestOsType;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CustomizeGosUserSettingsPageModel.prototype, "specification", {
            get: function () {
                return this._specification;
            },
            enumerable: true,
            configurable: true
        });
        return CustomizeGosUserSettingsPageModel;
    }(CustomizeGosPageModelBase));
    h5_vm.CustomizeGosUserSettingsPageModel = CustomizeGosUserSettingsPageModel;
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var EditVmEvcController = (function () {
        function EditVmEvcController(i18nService, vmEvcService, $rootScope) {
            this.i18nService = i18nService;
            this.vmEvcService = vmEvcService;
            this.$rootScope = $rootScope;
            this.onSubmit = this.applyEvcMode.bind(this);
            this.vendorEvcModes = [];
            this.i18n = i18nService.getString;
        }
        EditVmEvcController.prototype.$onInit = function () {
            this.initEvcVendors();
            this.loadVmEvcData();
            this.addVendorChangeListener();
        };
        EditVmEvcController.prototype.$onDestroy = function () {
            this.removeVendorChangeListener();
        };
        EditVmEvcController.prototype.isFakeEvcVendor = function () {
            return this.selectedEvcVendor === this.evcVendors.NONE ||
                this.selectedEvcVendor === this.evcVendors.CUSTOM;
        };
        EditVmEvcController.prototype.applyEvcMode = function () {
            if (this.selectedEvcVendor !== this.evcVendors.CUSTOM) {
                this.vmEvcService.applyEvcMode(this.vmId, this.selectedEvcMode.featureMasks);
            }
            return true;
        };
        EditVmEvcController.prototype.initEvcVendors = function () {
            this.evcVendorsHeader = {
                title: this.i18n("VmUi", "vmEvc.edit.selectEvcMode")
            };
            this.evcModeDescriptionHeader = {
                title: this.i18n("VmUi", "vmEvc.edit.evcModeDescription")
            };
            this.evcVendors = {
                NONE: "NONE",
                AMD: "AMD",
                INTEL: "INTEL",
                CUSTOM: "CUSTOM"
            };
        };
        EditVmEvcController.prototype.loadVmEvcData = function () {
            var _this = this;
            this.setPageBusy(true);
            this.vmEvcService.loadEditEvcData(this.vmId)
                .then(function (evcData) {
                if (!evcData) {
                    return;
                }
                _this.evcModesByVendorMap = evcData.evcModesByVendor;
                _this.selectedEvcVendor = evcData.vendor;
                _this.isCurrentEvcModeCustom =
                    _this.selectedEvcVendor === _this.evcVendors.CUSTOM;
                _this.onVendorChange();
                _this.selectEvcModeByKey(evcData.key);
            })
                .then(function () {
                _this.setPageBusy(false);
            });
        };
        EditVmEvcController.prototype.addVendorChangeListener = function () {
            var _this = this;
            this.unbindEvcVendorWatch = this.$rootScope.$watch(function () {
                return _this.selectedEvcVendor;
            }, function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                _this.onVendorChange();
                _this.selectFirstEvcModeIfNeeded();
            });
        };
        EditVmEvcController.prototype.removeVendorChangeListener = function () {
            if (this.unbindEvcVendorWatch) {
                this.unbindEvcVendorWatch();
            }
        };
        EditVmEvcController.prototype.onVendorChange = function () {
            if (!this.evcModesByVendorMap) {
                this.vendorEvcModes = [];
                return;
            }
            for (var evcVendor in this.evcModesByVendorMap) {
                if (evcVendor === this.selectedEvcVendor) {
                    this.vendorEvcModes = this.evcModesByVendorMap[evcVendor];
                    break;
                }
            }
        };
        EditVmEvcController.prototype.selectEvcModeByKey = function (modeKey) {
            this.selectedEvcMode = _.find(this.vendorEvcModes, function (evcMode) {
                return evcMode.key === modeKey;
            });
        };
        EditVmEvcController.prototype.selectFirstEvcModeIfNeeded = function () {
            if (_.isEmpty(this.vendorEvcModes)) {
                return;
            }
            if (_.contains(this.vendorEvcModes, this.selectedEvcMode)) {
                return;
            }
            this.selectedEvcMode = this.vendorEvcModes[0];
        };
        EditVmEvcController.prototype.setPageBusy = function (isBusy) {
            this.loading = isBusy;
        };
        EditVmEvcController.$inject = ["i18nService", "vmEvcService", "$rootScope"];
        return EditVmEvcController;
    }());
    h5_vm.EditVmEvcController = EditVmEvcController;
    var EditVmEvcComponent = (function () {
        function EditVmEvcComponent() {
            this.controller = EditVmEvcController;
            this.templateUrl =
                "vm-ui/resources/vm/evc-mode/edit-vm-evc.component.html";
            this.bindings = {
                vmId: "<",
                onSubmit: "="
            };
        }
        return EditVmEvcComponent;
    }());
    h5_vm.EditVmEvcComponent = EditVmEvcComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("editVmEvc", new EditVmEvcComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmEvcSpec = com.vmware.vsphere.client.h5.vm.data.VmEvcSpec;
    var VmEvcService = (function () {
        function VmEvcService(dataService, mutationService) {
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.EVC_DATA = "vmEvcData";
            this.EDIT_EVC_DATA = "vmEditEvcData";
        }
        VmEvcService.prototype.loadEvcData = function (vmId) {
            var _this = this;
            return this.dataService.getProperties(vmId, [this.EVC_DATA])
                .then(function (result) {
                return result[_this.EVC_DATA];
            });
        };
        VmEvcService.prototype.loadEditEvcData = function (vmId) {
            var _this = this;
            return this.dataService.getProperties(vmId, [this.EDIT_EVC_DATA])
                .then(function (result) {
                return result[_this.EDIT_EVC_DATA];
            });
        };
        VmEvcService.prototype.applyEvcMode = function (vmId, featureMasks) {
            var spec = new VmEvcSpec();
            spec.featureMasks = featureMasks;
            return this.mutationService.apply(vmId, spec._type, spec);
        };
        VmEvcService.$inject = ["dataService", "mutationService"];
        return VmEvcService;
    }());
    h5_vm.VmEvcService = VmEvcService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmEvcService", VmEvcService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var CpuidFeatureFlag = (function () {
        function CpuidFeatureFlag() {
        }
        return CpuidFeatureFlag;
    }());
    var VmEvcController = (function () {
        function VmEvcController(i18nService, vmEvcService) {
            this.i18nService = i18nService;
            this.vmEvcService = vmEvcService;
            this.EDIT_EVC_ACTION_UID = "vsphere.core.vm.editEvcModeAction";
            this.CONNECTION_STATE_PROP_NAME = "runtime.powerState";
            this.EVC_MODE_KEY_PROP_NAME = "runtime.minRequiredEVCModeKey";
            this.isFakeEvcVendor = true;
            this.settingsViewHeaderAccessor = {};
            this.i18n = i18nService.getString;
        }
        VmEvcController.prototype.$onInit = function () {
            this.watchForObjects = [this.vmId];
            this.evcDataProperties = [this.EVC_MODE_KEY_PROP_NAME];
            this.configureEvcAvailabilityProperties = [this.CONNECTION_STATE_PROP_NAME];
            this.headerOptions = {
                title: this.i18n("VmUi", "vmEvc.view.title"),
                objectId: this.vmId,
                actions: [{
                        actionUid: this.EDIT_EVC_ACTION_UID,
                        customLabel: this.i18n("VmUi", "vmEvc.edit.actionCustomLabel")
                    }]
            };
            this.evcVendors = {
                NONE: "NONE",
                AMD: "AMD",
                INTEL: "INTEL",
                CUSTOM: "CUSTOM"
            };
            this.loadEvcData();
        };
        VmEvcController.prototype.refreshEvcData = function () {
            this.loadEvcData();
        };
        VmEvcController.prototype.refreshConfigureEvcAvailability = function () {
            if (typeof this.settingsViewHeaderAccessor.refresh === 'function') {
                this.settingsViewHeaderAccessor.refresh();
            }
        };
        VmEvcController.prototype.loadEvcData = function () {
            var _this = this;
            this.setPageBusy(true);
            this.vmEvcService.loadEvcData(this.vmId)
                .then(function (evcData) {
                _this.currentEvcMode = evcData;
                if (!_this.currentEvcMode) {
                    return;
                }
                _this.isFakeEvcVendor =
                    _this.currentEvcMode.vendor === _this.evcVendors.NONE
                        ||
                            _this.currentEvcMode.vendor === _this.evcVendors.CUSTOM;
                _this.headerOptions.title = _this.getTitle();
                _this.cpuidFeaturesList = _this.generateCpuidFeaturesListData();
            })
                .then(function () {
                _this.setPageBusy(false);
            });
        };
        VmEvcController.prototype.getTitle = function () {
            if (!this.currentEvcMode.vendor) {
                return this.i18n("VmUi", "vmEvc.view.title");
            }
            if (this.currentEvcMode.vendor === this.evcVendors.NONE) {
                return this.i18n("VmUi", "vmEvc.view.evcDisabledLabel");
            }
            if (this.currentEvcMode.vendor === this.evcVendors.CUSTOM) {
                return this.i18n("VmUi", "vmEvc.view.evcCustomLabel");
            }
            return this.i18n("VmUi", "vmEvc.view.evcEnabledLabel");
        };
        VmEvcController.prototype.setPageBusy = function (isBusy) {
            this.loading = isBusy;
        };
        VmEvcController.prototype.generateCpuidFeaturesListData = function () {
            var _this = this;
            var cpuidFeaturesList = [];
            if (!this.currentEvcMode.guaranteedCPUFeatures) {
                return cpuidFeaturesList;
            }
            this.currentEvcMode.guaranteedCPUFeatures.forEach(function (cpuFeature) {
                // The leaf information.
                var cpuFeatureLevel = cpuFeature.level;
                // Represent 32-bit number as unsigned int
                // http://stackoverflow.com/questions/57803/how-to-convert-decimal-to-hex-in-javascript
                if (cpuFeatureLevel < 0) {
                    cpuFeatureLevel = 0xFFFFFFFF + cpuFeatureLevel + 1;
                }
                var leafCpuidListItem = {
                    register: _this.i18n("VmUi", "vmEvc.view.cpuidFeaturesFlagLeafLabel", cpuFeatureLevel.toString(16)),
                    value: "",
                    isLeaf: true
                };
                cpuidFeaturesList.push(leafCpuidListItem);
                // The information for eax register.
                var eaxCpuidListItem = {
                    register: "eax",
                    value: cpuFeature.eax,
                    isLeaf: false
                };
                cpuidFeaturesList.push(eaxCpuidListItem);
                // The information for ebx register.
                var ebxCpuidListItem = {
                    register: "ebx",
                    value: cpuFeature.ebx,
                    isLeaf: false
                };
                cpuidFeaturesList.push(ebxCpuidListItem);
                // The information for ecx register.
                var ecxCpuidListItem = {
                    register: "ecx",
                    value: cpuFeature.ecx,
                    isLeaf: false
                };
                cpuidFeaturesList.push(ecxCpuidListItem);
                // The information for edx register.
                var edxCpuidListItem = {
                    register: "edx",
                    value: cpuFeature.edx,
                    isLeaf: false
                };
                cpuidFeaturesList.push(edxCpuidListItem);
            });
            return cpuidFeaturesList;
        };
        VmEvcController.$inject = ["i18nService", "vmEvcService"];
        return VmEvcController;
    }());
    h5_vm.VmEvcController = VmEvcController;
    var VmEvcComponent = (function () {
        function VmEvcComponent() {
            this.controller = VmEvcController;
            this.templateUrl =
                "vm-ui/resources/vm/evc-mode/vm-evc.component.html";
            this.bindings = {
                vmId: "<"
            };
        }
        return VmEvcComponent;
    }());
    h5_vm.VmEvcComponent = VmEvcComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmEvc", new VmEvcComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

/*
 * Filter Display Video Card 3D rendering as 'Automatic', 'Hardware', or 'Software'
 */
angular.module('com.vmware.vsphere.client.vm').filter('render3d', ['$filter', 'i18nService',
   function($filter, i18nService) {
      'use strict';

      var RESOURCE_KEY = {
         automatic: 'VideoCardPage.automatic',
         software: 'VideoCardPage.software',
         hardware: 'VideoCardPage.hardware'
      };

      return function(value) {
         var key = RESOURCE_KEY[value];
         key = key || RESOURCE_KEY['automatic']; // default to 'automatic' if specified key doesn't exist
         return i18nService.getString('VmUi', key);
      };
   }]);


var h5_vm;
(function (h5_vm) {
    var CrudGridConfiguration = (function () {
        function CrudGridConfiguration() {
        }
        return CrudGridConfiguration;
    }());
    h5_vm.CrudGridConfiguration = CrudGridConfiguration;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CrudGridController = (function () {
        function CrudGridController($scope, vuiConstants) {
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
        }
        CrudGridController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = this.getGridOptions();
            this.updateActionBar();
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                _this.onSelectionChanged.call(_this, newSelection, oldSelection);
            });
        };
        CrudGridController.prototype.onSelectionChanged = function (newSelection, oldSelection) {
            // old and new selection can be same objects (as in data), but different
            // references
            if (JSON.stringify(newSelection) === JSON.stringify(oldSelection)) {
                return;
            }
            if (!newSelection || newSelection.length === 0 || newSelection.length > 1) {
                this.updateActionBar();
            }
            else {
                this.updateActionBar(newSelection[0]);
            }
        };
        CrudGridController.prototype.updateActionBar = function (selectedObject) {
            var _this = this;
            this.datagridOptions.actionBarOptions =
                this.datagridOptions.actionBarOptions || {};
            this.datagridOptions.actionBarOptions.actions = [
                {
                    enabled: true,
                    onClick: function (event, action) {
                        _this.onAddInternal();
                    },
                    iconClass: "vx-icon-addIcon",
                    label: this.configuration.addLabel,
                    tooltipText: this.configuration.addTooltip
                },
                {
                    enabled: !!selectedObject,
                    onClick: function (event, action) {
                        _this.onEditInternal(selectedObject);
                    },
                    iconClass: "vx-icon-edit16x16",
                    label: this.configuration.editLabel,
                    tooltipText: this.configuration.editTooltip
                },
                {
                    enabled: !!selectedObject,
                    onClick: function (event, action) {
                        _this.onDeleteInternal(selectedObject);
                    },
                    iconClass: "vx-icon-deleteIcon",
                    label: this.configuration.deleteLabel,
                    tooltipText: this.configuration.deleteTooltip
                }
            ];
        };
        CrudGridController.prototype.onAddInternal = function () {
            this.configuration.onAdd();
            this.refreshGrid();
        };
        CrudGridController.prototype.onEditInternal = function (selectedObject) {
            this.configuration.onEdit(selectedObject);
            this.refreshGrid();
        };
        CrudGridController.prototype.onDeleteInternal = function (selectedObject) {
            this.configuration.onDelete(selectedObject);
            this.refreshGrid();
        };
        CrudGridController.prototype.getGridOptions = function () {
            return {
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                searchable: false,
                resizable: false,
                reorderable: false,
                data: this.configuration.data,
                columnDefs: this.configuration.columnDefinitions,
                selectedItems: [],
                height: this.configuration.height
            };
        };
        CrudGridController.prototype.refreshGrid = function () {
            this.datagridOptions.data = this.configuration.data.slice();
        };
        CrudGridController.$inject = ["$scope", "vuiConstants"];
        return CrudGridController;
    }());
    h5_vm.CrudGridController = CrudGridController;
    var CrudGridComponent = (function () {
        function CrudGridComponent() {
            this.controller = CrudGridController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/common/components/crud-grid/crud-grid.component.html";
            this.bindings = {
                configuration: "<"
            };
        }
        return CrudGridComponent;
    }());
    h5_vm.CrudGridComponent = CrudGridComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("crudGrid", new CrudGridComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var EntryListController = (function () {
        function EntryListController($scope, vuiConstants, i18n) {
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18n = i18n;
        }
        EntryListController.prototype.$onInit = function () {
            var _this = this;
            this.gridOptions = this.createDataGridOptions();
            this.refreshGridDataSource();
            this.refreshGridData = function () {
                _this.refreshGridDataSource();
            };
            this.$scope.$watch(function () {
                return _this.gridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                _this.onSelectionChanged.call(_this, newSelection, oldSelection);
            });
        };
        EntryListController.prototype.$onDestroy = function () {
        };
        EntryListController.prototype.onAddClicked = function () {
            if (!this.currentText) {
                return;
            }
            this.model.push(this.currentText);
            this.refreshGridDataSource();
        };
        EntryListController.prototype.onDeleteClicked = function () {
            if (this.currentIndex === undefined) {
                return;
            }
            this.model.splice(this.currentIndex, 1);
            this.refreshGridDataSource();
        };
        EntryListController.prototype.onMoveUpClicked = function () {
            if (this.currentIndex === undefined || this.currentIndex === 0) {
                return;
            }
            var oldIndex = this.currentIndex;
            var newIndex = oldIndex - 1;
            this.swapItems(oldIndex, newIndex);
            this.currentIndex = newIndex;
        };
        EntryListController.prototype.onMoveDownClicked = function () {
            if (this.currentIndex === undefined || this.currentIndex + 1 === this.model.length) {
                return;
            }
            var oldIndex = this.currentIndex;
            var newIndex = oldIndex + 1;
            this.swapItems(oldIndex, newIndex);
            this.currentIndex = newIndex;
        };
        EntryListController.prototype.getCurrentTextPlaceholder = function () {
            return this.i18n.getString('VmUi', this.labelKey || 'customizationManager.customizationSpecDetailsView.dnsSearchPathPlaceholder');
        };
        EntryListController.prototype.getAriaLabel = function () {
            return this.ariaLabelKey
                ? this.i18n.getString('VmUi', this.ariaLabelKey)
                : "";
        };
        EntryListController.prototype.swapItems = function (item1Index, item2Index) {
            // Update the model
            var item1 = this.model[item1Index];
            this.model.splice(item1Index, 1);
            this.model.splice(item2Index, 0, item1);
            // Update the gird without loosing the selection
            var dataItem = this.gridOptions.dataSource.at(item1Index);
            this.gridOptions.dataSource.remove(dataItem);
            this.gridOptions.dataSource.insert(item2Index, dataItem);
        };
        EntryListController.prototype.onSelectionChanged = function (newSelection, oldSelection) {
            if (newSelection === oldSelection || _.isEqual(newSelection, oldSelection)) {
                return;
            }
            if (!newSelection || newSelection.length === 0 || newSelection.length > 1) {
                this.currentIndex = undefined;
                this.currentText = undefined;
            }
            else {
                this.currentIndex = this.gridOptions.dataSource.indexOf(newSelection[0]);
                this.currentText = newSelection[0].name;
            }
        };
        EntryListController.prototype.refreshGridDataSource = function () {
            this.currentIndex = undefined;
            this.currentText = undefined;
            this.gridOptions.data = _.map(this.model, function (itemText, index) {
                return { name: itemText, order: index };
            });
        };
        EntryListController.prototype.createDataGridOptions = function () {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                searchable: false,
                resizable: false,
                reorderable: false,
                selectedItems: [],
                columnDefs: [
                    {
                        field: "name",
                        sortable: false,
                        searchable: false,
                    }
                ],
                data: [],
                height: "100%",
            };
        };
        EntryListController.$inject = ["$scope",
            "vuiConstants",
            "i18nService"];
        return EntryListController;
    }());
    h5_vm.EntryListController = EntryListController;
    var EntryListComponent = (function () {
        function EntryListComponent() {
            this.controller = EntryListController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/common/components/entryList/entry-list.component.html";
            this.bindings = {
                model: "<",
                labelKey: "<?",
                ariaLabelKey: "<?",
                refreshGridData: "=?"
            };
        }
        return EntryListComponent;
    }());
    h5_vm.EntryListComponent = EntryListComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("entryList", new EntryListComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (CustomSysprepFileOption) {
        CustomSysprepFileOption[CustomSysprepFileOption["IMPORT_FILE"] = 1] = "IMPORT_FILE";
        CustomSysprepFileOption[CustomSysprepFileOption["CREATE_FILE"] = 2] = "CREATE_FILE";
    })(h5_vm.CustomSysprepFileOption || (h5_vm.CustomSysprepFileOption = {}));
    var CustomSysprepFileOption = h5_vm.CustomSysprepFileOption;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = (function () {
        function GosBasePageModel() {
        }
        return GosBasePageModel;
    }());
    h5_vm.GosBasePageModel = GosBasePageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Specification = com.vmware.vim.binding.vim.vm.customization.Specification;
    var LinuxPrep = com.vmware.vim.binding.vim.vm.customization.LinuxPrep;
    var LinuxOptions = com.vmware.vim.binding.vim.vm.customization.LinuxOptions;
    var Sysprep = com.vmware.vim.binding.vim.vm.customization.Sysprep;
    var WinOptions = com.vmware.vim.binding.vim.vm.customization.WinOptions;
    var UserData = com.vmware.vim.binding.vim.vm.customization.UserData;
    var SysprepText = com.vmware.vim.binding.vim.vm.customization.SysprepText;
    var FixedName = com.vmware.vim.binding.vim.vm.customization.FixedName;
    var PrefixNameGenerator = com.vmware.vim.binding.vim.vm.customization.PrefixNameGenerator;
    var CustomNameGenerator = com.vmware.vim.binding.vim.vm.customization.CustomNameGenerator;
    var VirtualMachineNameGenerator = com.vmware.vim.binding.vim.vm.customization.VirtualMachineNameGenerator;
    var UnknownNameGenerator = com.vmware.vim.binding.vim.vm.customization.UnknownNameGenerator;
    var GlobalIPSettings = com.vmware.vim.binding.vim.vm.customization.GlobalIPSettings;
    var GuiUnattended = com.vmware.vim.binding.vim.vm.customization.GuiUnattended;
    var LicenseFilePrintData = com.vmware.vim.binding.vim.vm.customization.LicenseFilePrintData;
    var Password = com.vmware.vim.binding.vim.vm.customization.Password;
    var Identification = com.vmware.vim.binding.vim.vm.customization.Identification;
    var GuiRunOnce = com.vmware.vim.binding.vim.vm.customization.GuiRunOnce;
    var GosSpecModelManagerService = (function () {
        function GosSpecModelManagerService($q, gosCustomizationHelperService, i18nService, defaultUriSchemeUtil, gosSpecNetworkService, ipParserService) {
            this.$q = $q;
            this.gosCustomizationHelperService = gosCustomizationHelperService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.gosSpecNetworkService = gosSpecNetworkService;
            this.ipParserService = ipParserService;
            this.DOMAIN_DEFAULT = "DOMAIN";
            this.WORKGROUP_DEFAULT = "WORKGROUP";
        }
        GosSpecModelManagerService.prototype.setModelDefaults = function (scope, defaultFlowId, onWizardFlowChange) {
            // Name and OS
            var nameAndOsPageModel = scope.gosNameAndOsPageModel;
            nameAndOsPageModel.gosType = defaultFlowId;
            nameAndOsPageModel.gosTypeChanged = onWizardFlowChange;
            nameAndOsPageModel.originalSpecName = undefined;
            nameAndOsPageModel.specName = "";
            nameAndOsPageModel.description = "";
            nameAndOsPageModel.isSidGenerated = true;
            // Computer name
            var computerNamePageModel = scope.computerNamePageModel;
            computerNamePageModel.type = nameAndOsPageModel.gosType;
            computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.USE_VM_NAME;
            computerNamePageModel.computerName = "";
            computerNamePageModel.isAppendNumericValue = false;
            computerNamePageModel.generateNameArgument = "";
            computerNamePageModel.domainName = "";
            // Registration information
            var registrationInformationPageModel = scope.registrationInformationPageModel;
            registrationInformationPageModel.ownerName = "";
            registrationInformationPageModel.organizationName = "";
            // Windows license
            var windowsLicensePageModel = scope.windowsLicensePageModel;
            windowsLicensePageModel.productKey = "";
            windowsLicensePageModel.isIncludeServerLicenseInfo = true;
            windowsLicensePageModel.isServerLicenseModePerServer = true;
            windowsLicensePageModel.maxConnections = GosSpecModelManagerService.AUTO_USERS_MIN;
            // Time zone
            var timeZonePageModel = scope.timeZonePageModel;
            timeZonePageModel.timeZoneArea = "";
            timeZonePageModel.timeZoneLocation = "";
            timeZonePageModel.timeZoneWinCode = 0;
            timeZonePageModel.hwClockUTC = true;
            // Network
            var networkPageModel = scope.networkPageModel;
            networkPageModel.networkSettingsType =
                h5_vm.GosNetworkSettingsType.STANDARD;
            networkPageModel.adapterMappingWrappers = this.gosSpecNetworkService
                .getInitialNetworkCards();
            networkPageModel.dnsSuffixList = [];
            // DNS settings
            var dnsSettingsPageModel = scope.dnsSettingsPageModel;
            dnsSettingsPageModel.primaryDns = "";
            dnsSettingsPageModel.secondaryDns = "";
            dnsSettingsPageModel.tertiaryDns = "";
            dnsSettingsPageModel.dnsSearchPath = [];
            // Administrator password
            var administratorPasswordPageModel = scope.administratorPasswordPageModel;
            administratorPasswordPageModel.autoLogon = false;
            administratorPasswordPageModel.password = "";
            administratorPasswordPageModel.confirmedPassword = "";
            administratorPasswordPageModel.isPasswordChanged = false;
            administratorPasswordPageModel.logonTimes = 1;
            // Custom sysprep file
            var customSysprepFilePageModel = scope.customSysprepFilePageModel;
            customSysprepFilePageModel.fileOption = h5_vm.CustomSysprepFileOption.IMPORT_FILE;
            customSysprepFilePageModel.sysprepContent = "";
            customSysprepFilePageModel.sysprepImportFileContent = "";
            customSysprepFilePageModel.sysprepImportFileName = "";
            // Workgroup or domain
            var workgroupDomainPageModel = scope.workgroupDomainPageModel;
            workgroupDomainPageModel.networkOption = h5_vm.WorkgroupDomainTypeOption.WORKGROUP;
            workgroupDomainPageModel.workgroup = this.WORKGROUP_DEFAULT;
            workgroupDomainPageModel.domain = this.DOMAIN_DEFAULT;
            workgroupDomainPageModel.username = "";
            workgroupDomainPageModel.password = "";
            workgroupDomainPageModel.confirmPassword = "";
            workgroupDomainPageModel.isDomainPasswordChanged = false;
            // Run once
            var commandsPageModel = scope.commandsPageModel;
            commandsPageModel.commands = [];
        };
        /**
         *  Populates the initial state taken from the specInfo object into the page models.
         */
        GosSpecModelManagerService.prototype.populatePageModels = function (scope, specInfo, specDetails) {
            // Name and OS
            if (scope.gosNameAndOsPageModel) {
                this.populateNameAndOsModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.gosNameAndOsPageModel);
            }
            // Computer Name
            if (scope.computerNamePageModel) {
                this.populateComputerNameModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.computerNamePageModel);
            }
            // Registration Information
            if (scope.registrationInformationPageModel) {
                this.populateRegistrationInformationModel(scope, specDetails);
                this.updateDependentModels(scope, scope.registrationInformationPageModel);
            }
            // Windows license
            if (scope.windowsLicensePageModel) {
                this.populateWindowsLicenseModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.windowsLicensePageModel);
            }
            // Time Zone
            if (scope.timeZonePageModel) {
                this.populateTimeZoneModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.timeZonePageModel);
            }
            if (scope.networkPageModel) {
                this.populateNetworkPageModel(scope, specDetails);
                this.updateDependentModels(scope, scope.networkPageModel);
            }
            // DNS settings
            if (scope.dnsSettingsPageModel) {
                this.populateDnsSettingsModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.dnsSettingsPageModel);
            }
            if (scope.customSysprepFilePageModel) {
                this.populateCustomSysprepFileModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.customSysprepFilePageModel);
            }
            if (scope.administratorPasswordPageModel) {
                this.populateAdministratorPasswordModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.administratorPasswordPageModel);
            }
            if (scope.commandsPageModel) {
                this.populateCommandsModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.commandsPageModel);
            }
            if (scope.osOptionsPageModel) {
                this.populateOsOptionsModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.osOptionsPageModel);
            }
            if (scope.workgroupDomainPageModel) {
                this.populateWorkgroupDomainModel(scope, specInfo, specDetails);
                this.updateDependentModels(scope, scope.workgroupDomainPageModel);
            }
        };
        GosSpecModelManagerService.prototype.updateDependentModels = function (scope, pageModel) {
            if (!pageModel) {
                return;
            }
            if (pageModel instanceof h5_vm.GosNameAndOsPageModel) {
                this.nameAndOsModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosComputerNamePageModel) {
                this.computerNameModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosRegistrationInformationPageModel) {
                this.registrationInformationModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosWindowsLicensePageModel) {
                this.windowsLicenseModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosTimeZonePageModel) {
                this.timeZoneModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosDnsSettingsPageModel) {
                this.dnsSettingsModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosNetworkPageModel) {
                this.networkPageModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosAdministratorPasswordPageModel) {
                this.administratorPassModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosCommandsPageModel) {
                this.commandsModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosCustomSysprepFilePageModel) {
                this.customSysprepFileModelChanged(scope);
            }
            else if (pageModel instanceof h5_vm.GosWorkgroupDomainPageModel) {
                this.workgroupDomainModelChanged(scope);
            }
            else {
                throw new Error("Unknown page model type");
            }
        };
        GosSpecModelManagerService.prototype.populateNameAndOsModel = function (scope, specInfo, specDetails) {
            var nameAndOsPageModel = scope.gosNameAndOsPageModel;
            nameAndOsPageModel.gosType = this.gosCustomizationHelperService
                .getGosType(specDetails.identity);
            nameAndOsPageModel.specName = specInfo.name;
            nameAndOsPageModel.description = specInfo.description;
            nameAndOsPageModel.vc = specInfo.vcService;
            nameAndOsPageModel.isEditMode = true;
            if (nameAndOsPageModel.gosType !== h5_vm.GosType.LINUX) {
                nameAndOsPageModel.isSidGenerated = specDetails.options.changeSID;
            }
            else {
                nameAndOsPageModel.isSidGenerated = true;
            }
        };
        GosSpecModelManagerService.prototype.populateRegistrationInformationModel = function (scope, specDetails) {
            var registrationInformationModel = scope.registrationInformationPageModel;
            var isSysPrep = this.gosCustomizationHelperService.isSysPrep(specDetails);
            if (!specDetails || !isSysPrep) {
                return;
            }
            var userData = specDetails.identity.userData;
            registrationInformationModel.ownerName = userData.fullName;
            registrationInformationModel.organizationName = userData.orgName;
        };
        GosSpecModelManagerService.prototype.nameAndOsModelChanged = function (scope) {
            var sourceModel = scope.gosNameAndOsPageModel;
            var targetModels = {
                customSysprepFilePageModel: scope.customSysprepFilePageModel,
                computerName: scope.computerNamePageModel,
                timeZone: scope.timeZonePageModel,
                network: scope.networkPageModel,
                finish: scope.finishPageModel
            };
            if (!sourceModel.vc || !sourceModel.vc.serviceGuid) {
                throw new Error("sourceModel.vc.serviceGuid is not set ");
            }
            // Update Custom sysprep file model
            if (!!targetModels.customSysprepFilePageModel) {
                targetModels.customSysprepFilePageModel.vcServerGuid =
                    sourceModel.vc.serviceGuid;
            }
            // Update Computer Name model
            if (!!targetModels.computerName) {
                targetModels.computerName.vcServiceGuid = sourceModel.vc.serviceGuid;
                targetModels.computerName.type = sourceModel.gosType;
            }
            // Update Network page model
            if (!!targetModels.network) {
                targetModels.network.vcServiceGuid = sourceModel.vc.serviceGuid;
                targetModels.network.type = sourceModel.gosType;
            }
            // Update Time Zone model
            if (!!targetModels.timeZone) {
                if (!sourceModel.vc) {
                    throw new Error("VC info is not defined");
                }
                targetModels.timeZone.customizationSpecManagerUrn =
                    this.defaultUriSchemeUtil.getVsphereObjectId(sourceModel.vc.content.customizationSpecManager);
                targetModels.timeZone.type = sourceModel.gosType;
            }
            // Update finish page model
            targetModels.finish.specName = sourceModel.specName;
            targetModels.finish.description = sourceModel.description;
            targetModels.finish.customizationSpecManager = sourceModel.vc.content.customizationSpecManager;
            if (!targetModels.finish.specDetails) {
                targetModels.finish.specDetails = new Specification();
            }
            if (sourceModel.gosType !== h5_vm.GosType.LINUX) {
                targetModels.finish.specDetails.options = new WinOptions();
                targetModels.finish.specDetails.options.changeSID =
                    sourceModel.isSidGenerated;
            }
            if (targetModels.finish.gosType !== sourceModel.gosType) {
                targetModels.finish.gosType = sourceModel.gosType;
                switch (sourceModel.gosType) {
                    case h5_vm.GosType.LINUX:
                        var linuxPrep = new LinuxPrep();
                        targetModels.finish.specDetails.options = new LinuxOptions();
                        targetModels.finish.specDetails.identity = linuxPrep;
                        break;
                    case h5_vm.GosType.WINDOWS:
                        var sysPrep = new Sysprep();
                        sysPrep.userData = new UserData();
                        sysPrep.guiUnattended = new GuiUnattended();
                        targetModels.finish.specDetails.identity = sysPrep;
                        break;
                    case h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP:
                        targetModels.finish.specDetails.identity = new SysprepText();
                        break;
                    default:
                        throw new Error("Invalid GOS type");
                }
            }
        };
        GosSpecModelManagerService.prototype.populateComputerNameModel = function (scope, specInfo, specDetails) {
            var computerNamePageModel = scope.computerNamePageModel;
            var nameGenerator = this.gosCustomizationHelperService.getNameGenerator(specDetails);
            computerNamePageModel.vcServiceGuid = specInfo.vcService.serviceGuid;
            computerNamePageModel.computerName = "";
            computerNamePageModel.isAppendNumericValue = false;
            computerNamePageModel.generateNameArgument = "";
            switch (nameGenerator._type) {
                case h5_vm.GosCustomizationHelperService.COMPUTER_NAME_TYPE_FIXED_NAME:
                    computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.ENTER_NAME;
                    computerNamePageModel.computerName = nameGenerator.name;
                    break;
                case h5_vm.GosCustomizationHelperService.COMPUTER_NAME_TYPE_PREFIX_NAME_GENERATOR:
                    computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.ENTER_NAME;
                    computerNamePageModel.computerName =
                        nameGenerator.base;
                    computerNamePageModel.isAppendNumericValue = true;
                    break;
                case h5_vm.GosCustomizationHelperService.COMPUTER_NAME_TYPE_VIRTUAL_MACHINE_NAME_GENERATOR:
                    computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.USE_VM_NAME;
                    break;
                case h5_vm.GosCustomizationHelperService.COMPUTER_NAME_TYPE_CUSTOM_NAME_GENERATOR:
                    computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.GENERATE_NAME;
                    break;
                case h5_vm.GosCustomizationHelperService.COMPUTER_NAME_TYPE_UNKNOWN_NAME_GENERATOR:
                    computerNamePageModel.setNameOption = h5_vm.ComputerNameOption.DEPLOY_WIZARD;
                    computerNamePageModel.generateNameArgument =
                        nameGenerator.argument;
                    break;
                default:
                    throw new Error("Unknown computer name option");
            }
            computerNamePageModel.domainName = "";
            if (specDetails.identity._type === new LinuxPrep()._type) {
                computerNamePageModel.domainName =
                    specDetails.identity.domain;
            }
        };
        GosSpecModelManagerService.prototype.computerNameModelChanged = function (scope) {
            var sourceModel = scope.computerNamePageModel;
            var targetModels = {
                network: scope.networkPageModel,
                finish: scope.finishPageModel
            };
            if (!!targetModels.network) {
                targetModels.network.isNameIpGeneratorDefined = sourceModel.isNameIpGeneratorDefined;
            }
            var nameGenerator;
            switch (sourceModel.setNameOption) {
                case h5_vm.ComputerNameOption.ENTER_NAME:
                    if (!sourceModel.isAppendNumericValue) {
                        nameGenerator = new FixedName();
                        nameGenerator.name = sourceModel.computerName;
                    }
                    else {
                        nameGenerator = new PrefixNameGenerator();
                        nameGenerator.base = sourceModel.computerName;
                    }
                    break;
                case h5_vm.ComputerNameOption.USE_VM_NAME:
                    nameGenerator = new VirtualMachineNameGenerator();
                    break;
                case h5_vm.ComputerNameOption.GENERATE_NAME:
                    nameGenerator = new CustomNameGenerator();
                    nameGenerator.argument =
                        sourceModel.generateNameArgument;
                    break;
                case h5_vm.ComputerNameOption.DEPLOY_WIZARD:
                    nameGenerator = new UnknownNameGenerator();
                    break;
                default:
                    throw new Error("Unknown computer name option");
            }
            if (targetModels.finish.specDetails.identity instanceof LinuxPrep) {
                targetModels.finish.specDetails.identity.hostName =
                    nameGenerator;
            }
            else if (targetModels.finish.specDetails.identity instanceof Sysprep) {
                targetModels.finish.specDetails.identity.userData.computerName =
                    nameGenerator;
            }
            // Domain
            targetModels.finish.specDetails.identity.domain =
                sourceModel.domainName;
        };
        GosSpecModelManagerService.prototype.registrationInformationModelChanged = function (scope) {
            var sourceModel = scope.registrationInformationPageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            if (targetModels.finish.specDetails.identity instanceof Sysprep) {
                targetModels.finish.specDetails.identity.userData.fullName = sourceModel.ownerName;
                targetModels.finish.specDetails.identity.userData.orgName = sourceModel.organizationName;
            }
        };
        GosSpecModelManagerService.prototype.populateWindowsLicenseModel = function (scope, specInfo, specDetails) {
            var model = scope.windowsLicensePageModel;
            var userData = specDetails.identity.userData;
            model.productKey = !_.isEmpty(userData.productId) ? userData.productId : "";
            model.isIncludeServerLicenseInfo =
                this.gosCustomizationHelperService.isServerLicensingIncluded(specDetails);
            if (model.isIncludeServerLicenseInfo) {
                var licenseData = specDetails.identity.licenseFilePrintData;
                model.isServerLicenseModePerServer =
                    ("perServer" === licenseData.autoMode);
                model.maxConnections = licenseData.autoUsers;
            }
            else {
                model.isServerLicenseModePerServer = true;
                model.maxConnections = GosSpecModelManagerService.AUTO_USERS_MIN;
            }
        };
        GosSpecModelManagerService.prototype.windowsLicenseModelChanged = function (scope) {
            var sourceModel = scope.windowsLicensePageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            var sysPrep = targetModels.finish.specDetails.identity;
            sysPrep.userData.productId = sourceModel.productKey;
            if (sourceModel.isIncludeServerLicenseInfo) {
                var licenseData = new LicenseFilePrintData();
                licenseData.autoMode = sourceModel.isServerLicenseModePerServer ?
                    "perServer" :
                    "perSeat";
                licenseData.autoUsers = sourceModel.maxConnections;
                sysPrep.licenseFilePrintData = licenseData;
            }
            else {
                delete sysPrep.licenseFilePrintData;
            }
        };
        GosSpecModelManagerService.prototype.populateTimeZoneModel = function (scope, specInfo, specDetails) {
            var timeZonePageModel = scope.timeZonePageModel;
            if (specDetails.identity._type === new LinuxPrep()._type) {
                timeZonePageModel.hwClockUTC = specDetails.identity.hwClockUTC;
                var data = specDetails.identity.timeZone
                    .split(h5_vm.GosCustomizationHelperService.AREA_LOCATION_SEPARATOR);
                timeZonePageModel.timeZoneArea = data[0];
                // remove the Area part
                data.shift();
                // join back the location part - /Argentina/Buenos_Aires
                var location_1 = data.join(h5_vm.GosCustomizationHelperService.AREA_LOCATION_SEPARATOR);
                timeZonePageModel.timeZoneLocation = location_1;
            }
            else if (specDetails.identity._type === new Sysprep()._type) {
                timeZonePageModel.timeZoneWinCode = specDetails.identity
                    .guiUnattended.timeZone;
            }
        };
        GosSpecModelManagerService.prototype.timeZoneModelChanged = function (scope) {
            var sourceModel = scope.timeZonePageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            if (targetModels.finish.specDetails.identity instanceof LinuxPrep) {
                var identity = targetModels.finish.specDetails.identity;
                identity.timeZone = sourceModel.timeZoneArea +
                    h5_vm.GosCustomizationHelperService.AREA_LOCATION_SEPARATOR +
                    sourceModel.timeZoneLocation;
                identity.hwClockUTC = sourceModel.hwClockUTC;
            }
            else if (targetModels.finish.specDetails.identity instanceof Sysprep) {
                var identity = targetModels.finish.specDetails.identity;
                identity.guiUnattended.timeZone = sourceModel.timeZoneWinCode;
            }
            else {
                throw new Error("Invalid identity type of GOS customization specification");
            }
        };
        GosSpecModelManagerService.prototype.populateDnsSettingsModel = function (scope, specInfo, specDetails) {
            var model = scope.dnsSettingsPageModel;
            model.primaryDns =
                this.gosCustomizationHelperService.getPrimaryDnsServer(specDetails);
            model.secondaryDns =
                this.gosCustomizationHelperService.getSecondaryDnsServer(specDetails);
            model.tertiaryDns =
                this.gosCustomizationHelperService.getTertiaryDnsServer(specDetails);
            model.dnsSearchPath =
                angular.copy(this.gosCustomizationHelperService.getDnsSuffixList(specDetails));
        };
        GosSpecModelManagerService.prototype.dnsSettingsModelChanged = function (scope) {
            var sourceModel = scope.dnsSettingsPageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            targetModels.finish.specDetails.globalIPSettings = new GlobalIPSettings();
            var dns;
            // DNS servers
            var dnsServers = [];
            if (sourceModel.primaryDns !== "") {
                dns = sourceModel.primaryDns;
                if (this.ipParserService.isIpv4AddressValid(dns)) {
                    dns = ipaddr.parse(dns).toString();
                }
                dnsServers.push(dns);
            }
            if (sourceModel.secondaryDns !== "") {
                dns = sourceModel.secondaryDns;
                if (this.ipParserService.isIpv4AddressValid(dns)) {
                    dns = ipaddr.parse(dns).toString();
                }
                dnsServers.push(dns);
            }
            if (sourceModel.tertiaryDns !== "") {
                dns = sourceModel.tertiaryDns;
                if (this.ipParserService.isIpv4AddressValid(dns)) {
                    dns = ipaddr.parse(dns).toString();
                }
                dnsServers.push(dns);
            }
            targetModels.finish.specDetails.globalIPSettings.dnsServerList = dnsServers;
            // DNS suffixes
            targetModels.finish.specDetails.globalIPSettings.dnsSuffixList = sourceModel.dnsSearchPath;
        };
        GosSpecModelManagerService.prototype.populateNetworkPageModel = function (scope, specDetails) {
            var networkPageModel = scope.networkPageModel;
            if (_.isNull(specDetails.globalIPSettings.dnsSuffixList)) {
                specDetails.globalIPSettings.dnsSuffixList = [];
            }
            networkPageModel.dnsSuffixList = specDetails.globalIPSettings.dnsSuffixList;
            networkPageModel.networkSettingsType =
                this.gosSpecNetworkService.isNetworkTypeStandard(specDetails) ?
                    h5_vm.GosNetworkSettingsType.STANDARD :
                    h5_vm.GosNetworkSettingsType.CUSTOM;
            if (h5_vm.GosNetworkSettingsType.CUSTOM
                === networkPageModel.networkSettingsType) {
                networkPageModel.adapterMappingWrappers = this.gosSpecNetworkService
                    .createAdapterMappingWrappersFromSpecification(specDetails);
            }
            else {
                networkPageModel.adapterMappingWrappers =
                    this.gosSpecNetworkService.getInitialNetworkCards();
            }
        };
        GosSpecModelManagerService.prototype.networkPageModelChanged = function (scope) {
            var sourceModel = scope.networkPageModel;
            var targetModels = {
                computerName: scope.computerNamePageModel,
                finish: scope.finishPageModel
            };
            if (!!targetModels.computerName) {
                targetModels.computerName.isNameIpGeneratorDefined = sourceModel.isNameIpGeneratorDefined;
            }
            if (!targetModels.finish.specDetails) {
                targetModels.finish.specDetails = new Specification();
            }
            if (!targetModels.finish.specDetails.globalIPSettings) {
                targetModels.finish.specDetails.globalIPSettings = new GlobalIPSettings();
            }
            targetModels.finish.specDetails.nicSettingMap = [];
            if (h5_vm.GosNetworkSettingsType.STANDARD
                === sourceModel.networkSettingsType) {
                targetModels.finish.specDetails.nicSettingMap.push(this.gosSpecNetworkService
                    .createNewAdapterMappingWrapper("").adapterMapping);
                return;
            }
            for (var _i = 0, _a = sourceModel.adapterMappingWrappers; _i < _a.length; _i++) {
                var adapterWrapper = _a[_i];
                targetModels.finish.specDetails.nicSettingMap
                    .push(adapterWrapper.adapterMapping);
            }
            targetModels.finish.specDetails.globalIPSettings.dnsSuffixList = sourceModel.dnsSuffixList;
        };
        GosSpecModelManagerService.prototype.populateAdministratorPasswordModel = function (scope, specInfo, specDetails) {
            var model = scope.administratorPasswordPageModel;
            var identity = specDetails.identity;
            model.password = identity.guiUnattended.password ? identity.guiUnattended.password.value : "";
            model.isPreviousPasswordBlank = model.password === "";
            model.confirmedPassword = model.password;
            model.autoLogon = identity.guiUnattended.autoLogon;
            model.logonTimes = identity.guiUnattended.autoLogonCount;
        };
        GosSpecModelManagerService.prototype.populateCustomSysprepFileModel = function (scope, specInfo, specDetails) {
            var model = scope.customSysprepFilePageModel;
            var sysprep = specDetails.identity;
            if (sysprep.value) {
                model.fileOption = h5_vm.CustomSysprepFileOption.CREATE_FILE;
                model.sysprepContent = sysprep.value;
            }
        };
        GosSpecModelManagerService.prototype.populateCommandsModel = function (scope, specInfo, specDetails) {
            var model = scope.commandsPageModel;
            var identity = specDetails.identity;
            if (identity.guiRunOnce && identity.guiRunOnce.commandList) {
                model.commands = angular.copy(identity.guiRunOnce.commandList);
            }
            else {
                model.commands = [];
            }
        };
        GosSpecModelManagerService.prototype.populateOsOptionsModel = function (scope, specInfo, specDetails) {
        };
        GosSpecModelManagerService.prototype.populateWorkgroupDomainModel = function (scope, specInfo, specDetails) {
            var model = scope.workgroupDomainPageModel;
            var identity = specDetails.identity;
            if (!_.isEmpty(identity.identification.joinWorkgroup)) {
                model.networkOption = h5_vm.WorkgroupDomainTypeOption.WORKGROUP;
                model.workgroup = identity.identification.joinWorkgroup;
                model.domain = this.DOMAIN_DEFAULT;
            }
            else {
                model.networkOption = h5_vm.WorkgroupDomainTypeOption.DOMAIN;
                model.workgroup = this.WORKGROUP_DEFAULT;
                model.domain = identity.identification.joinDomain;
                model.username = identity.identification.domainAdmin;
                var domainPassword = identity.identification.domainAdminPassword;
                model.password = _.isEmpty(domainPassword) ? "" : domainPassword.value;
                model.confirmPassword = _.isEmpty(domainPassword) ? "" : domainPassword.value;
            }
        };
        GosSpecModelManagerService.prototype.administratorPassModelChanged = function (scope) {
            var sourceModels = {
                administratorPasswordPageModel: scope.administratorPasswordPageModel,
                nameAndOsPageModel: scope.gosNameAndOsPageModel
            };
            var targetModels = {
                finish: scope.finishPageModel
            };
            if (sourceModels.nameAndOsPageModel.gosType === h5_vm.GosType.WINDOWS) {
                var identity = targetModels.finish.specDetails.identity;
                var newPassword = sourceModels.administratorPasswordPageModel.password;
                if (newPassword && !_.isEmpty(newPassword)) {
                    var specPassword = new Password();
                    specPassword.plainText = false;
                    specPassword.value = newPassword;
                    targetModels.finish.encryptAdminPassword =
                        sourceModels.administratorPasswordPageModel.isPasswordChanged;
                    identity.guiUnattended.password = specPassword;
                }
                else {
                    if (identity.guiUnattended.password) {
                        delete identity.guiUnattended.password;
                    }
                }
                identity.guiUnattended.autoLogon = sourceModels.administratorPasswordPageModel.autoLogon;
                identity.guiUnattended.autoLogonCount = sourceModels.administratorPasswordPageModel.logonTimes;
            }
        };
        GosSpecModelManagerService.prototype.commandsModelChanged = function (scope) {
            var sourceModel = scope.commandsPageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            var identity = targetModels.finish.specDetails.identity;
            if (sourceModel.commands && sourceModel.commands.length) {
                identity.guiRunOnce = new GuiRunOnce();
                identity.guiRunOnce.commandList = sourceModel.commands;
                return;
            }
            if (identity.guiRunOnce) {
                delete identity.guiRunOnce;
            }
        };
        GosSpecModelManagerService.prototype.customSysprepFileModelChanged = function (scope) {
            var sourceModel = scope.customSysprepFilePageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            var sysprep = targetModels.finish.specDetails.identity;
            sysprep.value = sourceModel.fileOption === h5_vm.CustomSysprepFileOption.CREATE_FILE ?
                sourceModel.sysprepContent : sourceModel.sysprepImportFileContent;
        };
        GosSpecModelManagerService.prototype.workgroupDomainModelChanged = function (scope) {
            var sourceModel = scope.workgroupDomainPageModel;
            var targetModels = {
                finish: scope.finishPageModel
            };
            var identity = targetModels.finish.specDetails.identity;
            identity.identification = new Identification();
            if (sourceModel.networkOption === h5_vm.WorkgroupDomainTypeOption.WORKGROUP) {
                identity.identification.joinWorkgroup = sourceModel.workgroup;
            }
            else {
                identity.identification.joinDomain = sourceModel.domain;
                identity.identification.domainAdmin = sourceModel.username;
                if (sourceModel.password) {
                    identity.identification.domainAdminPassword = new Password();
                    identity.identification.domainAdminPassword.value = sourceModel.password;
                    identity.identification.domainAdminPassword.plainText = false;
                    targetModels.finish.encryptDomainPassword = sourceModel.isDomainPasswordChanged;
                }
            }
        };
        GosSpecModelManagerService.$inject = ["$q",
            "gosCustomizationHelperService",
            "i18nService",
            "defaultUriSchemeUtil",
            "gosSpecNetworkService",
            "ipParserService"];
        GosSpecModelManagerService.AUTO_USERS_MIN = 5;
        return GosSpecModelManagerService;
    }());
    h5_vm.GosSpecModelManagerService = GosSpecModelManagerService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosSpecModelManagerService", GosSpecModelManagerService);
})(h5_vm || (h5_vm = {}));



/** Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var GosSpecValidationService = (function () {
        function GosSpecValidationService(i18nService) {
            this.i18nService = i18nService;
        }
        GosSpecValidationService.prototype.validateName = function (specName, useLongErrors, otherSpecs, vcName) {
            if (useLongErrors === void 0) { useLongErrors = false; }
            specName = specName.trim();
            var errorKeys = useLongErrors
                ? GosSpecValidationService.LONG_ERROR_KEYS
                : GosSpecValidationService.SHORT_ERROR_KEYS;
            if (!specName) {
                return this.i18nService.getString("VmUi", errorKeys.emptySpecName);
            }
            if (this.byteCount(specName) > GosSpecValidationService.MAX_NAME_LENGTH) {
                return this.i18nService.getString("VmUi", errorKeys.tooLongSpecName);
            }
            if (!otherSpecs) {
                return "";
            }
            for (var _i = 0, otherSpecs_1 = otherSpecs; _i < otherSpecs_1.length; _i++) {
                var spec = otherSpecs_1[_i];
                if (spec.name === specName && (!vcName || spec.vCenterName === vcName)) {
                    return this.i18nService.getString("VmUi", errorKeys.specNameAlreadyExists);
                }
            }
            return "";
        };
        GosSpecValidationService.prototype.byteCount = function (s) {
            return encodeURI(s).split(/%..|./).length - 1;
        };
        GosSpecValidationService.MAX_NAME_LENGTH = 255;
        /**
         * The error keys used for inline validation
         */
        GosSpecValidationService.SHORT_ERROR_KEYS = {
            emptySpecName: "guestOsCustomization.nameAndTargetOsPage.emptySpecNameError",
            tooLongSpecName: "customizationSpec.nameAndOsPage.tooLongSpecNameError",
            specNameAlreadyExists: "customizationSpec.nameAndOsPage.specNameAlreadyExists"
        };
        /**
         * The error keys used for error messages in the banner upon submission
         */
        GosSpecValidationService.LONG_ERROR_KEYS = {
            emptySpecName: "customizationSpec.nameAndOsPage.emptySpecNameError",
            tooLongSpecName: GosSpecValidationService.SHORT_ERROR_KEYS.tooLongSpecName,
            specNameAlreadyExists: GosSpecValidationService.SHORT_ERROR_KEYS.specNameAlreadyExists
        };
        GosSpecValidationService.$inject = ["i18nService"];
        return GosSpecValidationService;
    }());
    h5_vm.GosSpecValidationService = GosSpecValidationService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosSpecValidationService", GosSpecValidationService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var AdapterMappingWrapper = (function () {
        function AdapterMappingWrapper() {
        }
        return AdapterMappingWrapper;
    }());
    h5_vm.AdapterMappingWrapper = AdapterMappingWrapper;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = (function () {
        function GosType(value) {
            this.value = value;
        }
        GosType.WINDOWS_VALUE = "windows";
        GosType.WINDOWS_CUSTOM_SYSPREP_VALUE = "windowsWithCustomSysPrep";
        GosType.LINUX_VALUE = "linux";
        GosType.WINDOWS = new GosType(GosType.WINDOWS_VALUE);
        GosType.WINDOWS_CUSTOM_SYSPREP = new GosType(GosType.WINDOWS_CUSTOM_SYSPREP_VALUE);
        GosType.LINUX = new GosType(GosType.LINUX_VALUE);
        /**
         * Used as default return value in fromString when invalid input is provided
         * @type {h5_vm.GosType}
         */
        GosType.NONE = new GosType("");
        return GosType;
    }());
    h5_vm.GosType = GosType;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosNetworkSettingsType = (function () {
        function GosNetworkSettingsType(value) {
            this.value = value;
        }
        GosNetworkSettingsType.STANDART_VALUE = "standard";
        GosNetworkSettingsType.CUSTOM_VALUE = "custom";
        GosNetworkSettingsType.STANDARD = new GosNetworkSettingsType(GosNetworkSettingsType.STANDART_VALUE);
        GosNetworkSettingsType.CUSTOM = new GosNetworkSettingsType(GosNetworkSettingsType.CUSTOM_VALUE);
        /**
         * Used as default return value in fromString when invalid input is provided
         * @type {h5_vm.GosNetworkSettingsType}
         */
        GosNetworkSettingsType.NONE = new GosNetworkSettingsType("");
        return GosNetworkSettingsType;
    }());
    h5_vm.GosNetworkSettingsType = GosNetworkSettingsType;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (WorkgroupDomainTypeOption) {
        WorkgroupDomainTypeOption[WorkgroupDomainTypeOption["WORKGROUP"] = 1] = "WORKGROUP";
        WorkgroupDomainTypeOption[WorkgroupDomainTypeOption["DOMAIN"] = 2] = "DOMAIN";
    })(h5_vm.WorkgroupDomainTypeOption || (h5_vm.WorkgroupDomainTypeOption = {}));
    var WorkgroupDomainTypeOption = h5_vm.WorkgroupDomainTypeOption;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = h5_vm.GosType;
    var VmCustomizationSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationSpec;
    var CreateGuestOsCustomizationSpecWizardService = (function () {
        function CreateGuestOsCustomizationSpecWizardService(gosSpecCreatePagesService, gosSpecModelManagerService, wizardPageService, $rootScope, vuiService, i18nService, mutationService, $q) {
            this.gosSpecCreatePagesService = gosSpecCreatePagesService;
            this.gosSpecModelManagerService = gosSpecModelManagerService;
            this.wizardPageService = wizardPageService;
            this.$rootScope = $rootScope;
            this.vuiService = vuiService;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.$q = $q;
            this.defaultFlowId = GosType.WINDOWS;
        }
        CreateGuestOsCustomizationSpecWizardService.prototype.open = function (onActionInvoked, allSpecs) {
            this.onActionInvoked = onActionInvoked;
            this.wizardScope = this.$rootScope.$new();
            this.wizardScope.allSpecs = allSpecs;
            var result = this.buildWizardConfig();
            this.wizardScope.config = {
                title: this.i18nService.getString("VmUi", "customizationSpecWizard.title"),
                cssClass: "provisioning-vm-wizards"
            };
            this.wizardScope.config.pages = result.pages;
            this.wizardScope.config.flows = result.flows;
            this.wizardScope.config.onFinish = result.onFinish;
            this.selectedFlowId = this.defaultFlowId;
            this.gosSpecModelManagerService.setModelDefaults(this.wizardScope, this.defaultFlowId, this.onWizardFlowChange.bind(this));
            this.vuiService.createWizard({
                scope: this.wizardScope,
                configObjectName: "config"
            }).show();
        };
        CreateGuestOsCustomizationSpecWizardService.prototype.buildWizardConfig = function () {
            var flowIds = [
                GosType.WINDOWS,
                GosType.WINDOWS_CUSTOM_SYSPREP,
                GosType.LINUX
            ];
            var nameAndOsPage = this.gosSpecCreatePagesService.createNameAndOsPage(this.wizardScope, this.onPageCommit.bind(this), this.defaultFlowId, flowIds);
            var flows = this.gosSpecCreatePagesService.getWizardFlows(this.wizardScope, this.onPageCommit.bind(this));
            return {
                flows: this.wizardPageService.initializeFlowStates(flows),
                pages: [nameAndOsPage],
                onFinish: this.onWizardComplete.bind(this)
            };
        };
        CreateGuestOsCustomizationSpecWizardService.prototype.onWizardFlowChange = function (selecetedCustomizationType) {
            this.selectedFlowId = selecetedCustomizationType;
            this.wizardScope.config.currentPage.decisionOptions.selectedFlowId =
                this.selectedFlowId;
            this.wizardPageService.initializeFlowStates(this.wizardScope.config.flows);
        };
        CreateGuestOsCustomizationSpecWizardService.prototype.onPageCommit = function (pageModel) {
            var _this = this;
            var pageCommitPromise = pageModel.onPageCommit
                ? pageModel.onPageCommit()
                : this.$q.resolve([]);
            return pageCommitPromise.then(function (res) {
                if (!res) {
                    return false;
                }
                _this.wizardPageService.clearErrors(_this.wizardScope.config);
                if (res && res.length > 0) {
                    _this.wizardPageService.markPageIncompleteWithErrors(_this.wizardScope.config, res);
                    return false;
                }
                _this.gosSpecModelManagerService.updateDependentModels(_this.wizardScope, pageModel);
                _this.wizardPageService.markPageComplete(_this.wizardScope.config, _this.selectedFlowId);
                return true;
            });
        };
        CreateGuestOsCustomizationSpecWizardService.prototype.onWizardComplete = function () {
            var _this = this;
            var finishPageModel = this.wizardScope.finishPageModel;
            var vmCustSpec = new VmCustomizationSpec();
            vmCustSpec.config = finishPageModel.buildSpec();
            finishPageModel.addWindowsParams(vmCustSpec);
            vmCustSpec.customizationSpecManager = finishPageModel.customizationSpecManager;
            var operation = this.i18nService.getString("VmUi", "customizationSpec.createSpecOperationName");
            this.mutationService.add(vmCustSpec._type, vmCustSpec, operation)
                .then(function (opResult) {
                _this.onActionInvoked("vsphere.core.vm.gos.customization.new", opResult);
            });
            return true;
        };
        CreateGuestOsCustomizationSpecWizardService.$inject = ["gosSpecCreatePagesService",
            "gosSpecModelManagerService",
            "wizardPageService",
            "$rootScope",
            "vuiService",
            "i18nService",
            "mutationService",
            "$q"];
        return CreateGuestOsCustomizationSpecWizardService;
    }());
    h5_vm.CreateGuestOsCustomizationSpecWizardService = CreateGuestOsCustomizationSpecWizardService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("createGuestOsCustomizationSpecWizardService", CreateGuestOsCustomizationSpecWizardService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmCustomizationRemovalSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationRemovalSpec;
    var DeleteGosSpecService = (function () {
        function DeleteGosSpecService(defaultUriSchemeUtil, mutationService, actionConfirmationService, $q) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.actionConfirmationService = actionConfirmationService;
            this.$q = $q;
        }
        DeleteGosSpecService.prototype.confirmDelete = function (title, message) {
            var deferred = this.$q.defer();
            var alertProperties = {
                useClarity: true,
                title: title,
                message: message,
                yesHandler: function () {
                    deferred.resolve();
                },
                noHandler: function () {
                    deferred.reject();
                }
            };
            this.actionConfirmationService.showConfirmationDialog(alertProperties);
            return deferred.promise;
        };
        DeleteGosSpecService.prototype.delete = function (specInfo) {
            var spec = new VmCustomizationRemovalSpec();
            spec.specName = specInfo.name;
            var specManagerId = this.defaultUriSchemeUtil.getVsphereObjectId(specInfo.vcService.content.customizationSpecManager);
            return this.mutationService.remove(specManagerId, spec._type, spec);
        };
        DeleteGosSpecService.$inject = ["defaultUriSchemeUtil",
            "mutationService",
            "actionConfirmationService",
            "$q"];
        return DeleteGosSpecService;
    }());
    h5_vm.DeleteGosSpecService = DeleteGosSpecService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("deleteGosSpecService", DeleteGosSpecService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmCustomizationDuplicateSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationDuplicateSpec;
    var DuplicateGosSpecController = (function () {
        function DuplicateGosSpecController($q, i18nService, vuiConstants, userSessionService, gosSpecValidationService, duplicateGosSpecService, idGeneratorService) {
            var _this = this;
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.userSessionService = userSessionService;
            this.gosSpecValidationService = gosSpecValidationService;
            this.duplicateGosSpecService = duplicateGosSpecService;
            this.idGeneratorService = idGeneratorService;
            this.name = "";
            this.description = "";
            this.vcLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.vcLabel");
            this.nameLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.name");
            this.descriptionLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.description");
            this.customizationSectionLabel = this.i18nService.getString("VmUi", "guestOsCustomization.nameAndTargetOsPage.vmCustomizationSection");
            this.sourceSpecManagerRef =
                this.sourceSpecInfo.vcService.content.customizationSpecManager;
            this.retrieveVcenterData();
            this.onSubmit = function () {
                return _this.submitForm();
            };
            this.createAriaIds();
        }
        DuplicateGosSpecController.prototype.createAriaIds = function () {
            this.descriptionId = this.idGeneratorService.nextId("descriptionId");
            this.vcId = this.idGeneratorService.nextId("vcId");
            this.nameId = this.idGeneratorService.nextId("nameId");
            this.customizationSectionLabelId = this.idGeneratorService.nextId("customizationSectionLabelId");
            this.invalidNameMessageId = this.idGeneratorService.nextId("invalidNameMessageId");
        };
        DuplicateGosSpecController.prototype.isNameValid = function () {
            this.invalidNameMessage = this.gosSpecValidationService.validateName(this.name, false, this.allSpecs, this.vCenter.name);
            return !this.invalidNameMessage;
        };
        DuplicateGosSpecController.prototype.retrieveVcenterData = function () {
            var _this = this;
            this.submitDisabled = true;
            this.userSessionService.getAllServersInfo()
                .then(function (session) {
                _this.vCentersData = session.serversInfo;
                if (_this.vCentersData && _this.vCentersData.length > 0) {
                    _this.vCenter = _this.vCentersData[0];
                }
            })
                .then(function () {
                _this.submitDisabled = false;
            });
        };
        DuplicateGosSpecController.prototype.submitForm = function () {
            var _this = this;
            var nameResult = this.gosSpecValidationService
                .validateName(this.name, true, this.allSpecs, this.vCenter.name);
            this.createAlerts(nameResult ? [nameResult] : []);
            if (nameResult) {
                return this.$q.resolve(false);
            }
            this.submitDisabled = true;
            var spec = new VmCustomizationDuplicateSpec();
            spec.sourceSpecName = this.sourceSpecInfo.name;
            spec.sourceSpecManagerRef = this.sourceSpecManagerRef;
            spec.newSpecName = this.name;
            spec.newSpecDesc = this.description;
            spec.targetVcGuid = this.vCenter.serviceGuid;
            return this.duplicateGosSpecService.validateSpec(spec).then(function (valRes) {
                _this.submitDisabled = false;
                if (!valRes.isValid && valRes.errors && valRes.errors.length > 0) {
                    _this.createAlerts(valRes.errors);
                }
                if (!valRes.isValid) {
                    return valRes.isValid;
                }
                // if the VC is changed, close this dialog and open a new confirmation
                if (!valRes.keyValidationSucceeded) {
                    _this.duplicateGosSpecService.confirmKeyChange(spec);
                    return valRes.isValid;
                }
                // if the VC is the same, duplicate the dialog
                return _this.duplicateGosSpecService
                    .duplicateSpec(spec)
                    .then(function (dupRes) {
                    if (!dupRes.isValid && dupRes.errors && dupRes.errors.length > 0) {
                        _this.createAlerts(dupRes.errors);
                    }
                    return dupRes.isValid;
                });
            });
        };
        DuplicateGosSpecController.prototype.createAlerts = function (errors) {
            var _this = this;
            this.alerts = [];
            _.each(errors, function (error) {
                var alert = {
                    type: _this.vuiConstants.validationBanner.type.ERROR,
                    text: error
                };
                _this.alerts.push(alert);
            });
        };
        DuplicateGosSpecController.$inject = [
            "$q",
            "i18nService",
            "vuiConstants",
            "userSessionService",
            "gosSpecValidationService",
            "duplicateGosSpecService",
            "idGeneratorService"
        ];
        return DuplicateGosSpecController;
    }());
    var DuplicateGosSpecComponent = (function () {
        function DuplicateGosSpecComponent() {
            this.bindings = {
                sourceSpecInfo: "<",
                allSpecs: "<",
                alerts: "=",
                onSubmit: "=",
                submitDisabled: "="
            };
            this.controller = DuplicateGosSpecController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/duplicate/duplicate-gos-spec.component.html";
        }
        return DuplicateGosSpecComponent;
    }());
    h5_vm.DuplicateGosSpecComponent = DuplicateGosSpecComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("duplicateGosSpec", new DuplicateGosSpecComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var DuplicateGosSpecService = (function () {
        function DuplicateGosSpecService($q, i18nService, clarityModalService, mutationService, defaultUriSchemeUtil) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.duplicateGosSpecResult = {
                result: undefined,
                openSpecForEdit: false
            };
        }
        DuplicateGosSpecService.prototype.openDuplicateForm = function (specInfo, gosCustomizationSpecs) {
            var _this = this;
            this.duplicateGosSpecDefered = this.$q.defer();
            this.duplicateGosSpecResult = {
                result: undefined,
                openSpecForEdit: false
            };
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.duplicate"),
                contentTemplate: "vm-ui/resources/vm/guest-os-customization/duplicate/duplicate-gos-spec.view.html",
                defaultButton: "submit",
                dialogData: {
                    sourceCustomizationSpecInfo: specInfo,
                    allCustomizationSpecs: gosCustomizationSpecs
                },
                onCancel: function () {
                    _this.duplicateGosSpecDefered.reject();
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            return this.duplicateGosSpecDefered.promise;
        };
        DuplicateGosSpecService.prototype.validateSpec = function (spec) {
            var _this = this;
            this.duplicateGosSpecResult.openSpecForEdit = false;
            var sourceSpecManagerId = this.defaultUriSchemeUtil.getVsphereObjectId(spec.sourceSpecManagerRef);
            return this.mutationService
                .validate(sourceSpecManagerId, spec._type, spec)
                .then(function (valRes) {
                if (!valRes || !valRes.result || valRes.error) {
                    var errorMsg = _this.i18nService.getString("VmUi", "guestOsCustomization.duplicate.error");
                    return _this.$q.resolve({
                        isValid: false,
                        errors: [errorMsg]
                    });
                }
                var duplicateValRes = valRes.result;
                if (!duplicateValRes.hasVcPrivileges) {
                    var noVcPrivErrorMsg = _this.i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.noPrivileges");
                    return _this.$q.resolve({
                        isValid: false,
                        errors: [noVcPrivErrorMsg]
                    });
                }
                return _this.$q.resolve({
                    isValid: true,
                    keyValidationSucceeded: duplicateValRes.keyValidationSucceeded
                });
            });
        };
        DuplicateGosSpecService.prototype.duplicateSpec = function (spec) {
            var _this = this;
            return this.mutationService
                .add(spec._type, spec)
                .then(function (opResult) {
                _this.duplicateGosSpecResult.result = opResult;
                // resolve the defered and return the expected op result
                _this.duplicateGosSpecDefered.resolve(_this.duplicateGosSpecResult);
                // resolve the modal dialog so it is closed
                return {
                    isValid: true
                };
            }, function (error) {
                // in case of an error, reject the defered promise
                _this.duplicateGosSpecDefered.reject();
                // reject the modal dialog and display an error
                var errorMsg = _this.i18nService.getString("VmUi", "guestOsCustomization.duplicate.error");
                return {
                    isValid: false,
                    errors: [errorMsg]
                };
            });
        };
        /**
         * Displays an Ok/Cancel dialog that confirms the after the duplication
         * user should reset admin and domain passwords from the edit dialog
         */
        DuplicateGosSpecService.prototype.confirmKeyChange = function (spec) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "importCustomizationSpec.invalidKey.title"),
                message: this.i18nService.getString("VmUi", "importCustomizationSpec.invalidKey.text"),
                saveButtonLabel: this.i18nService.getString("Common", "alert.continue"),
                icon: null,
                clarityIcon: {
                    shape: "warning",
                    class: "is-warning",
                    size: 48
                },
                submit: function () {
                    _this.duplicateSpec(spec);
                    _this.duplicateGosSpecResult.openSpecForEdit = true;
                },
                onCancel: function () {
                    _this.duplicateGosSpecDefered.reject();
                    _this.duplicateGosSpecResult.openSpecForEdit = false;
                },
                preserveNewlines: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        DuplicateGosSpecService.$inject = ["$q",
            "i18nService",
            "clarityModalService",
            "mutationService",
            "defaultUriSchemeUtil"
        ];
        return DuplicateGosSpecService;
    }());
    h5_vm.DuplicateGosSpecService = DuplicateGosSpecService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("duplicateGosSpecService", DuplicateGosSpecService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = h5_vm.GosType;
    var VmCustomizationEditSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationEditSpec;
    var EditGuestOsCustomizationSpecDialogService = (function () {
        function EditGuestOsCustomizationSpecDialogService(gosCustomizationHelperService, gosSpecCreatePagesService, gosSpecModelManagerService, vxMultiPageDialogService, defaultUriSchemeUtil, $rootScope, i18nService, vuiConstants, mutationService, $q) {
            this.gosCustomizationHelperService = gosCustomizationHelperService;
            this.gosSpecCreatePagesService = gosSpecCreatePagesService;
            this.gosSpecModelManagerService = gosSpecModelManagerService;
            this.vxMultiPageDialogService = vxMultiPageDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.mutationService = mutationService;
            this.$q = $q;
            this.gosType = GosType.NONE;
        }
        EditGuestOsCustomizationSpecDialogService.prototype.open = function (context) {
            this.specInfo = context.specInfo;
            this.specDetails = context.specDetails;
            this.onActionInvoked = context.onActionInvoked;
            this.gosType = this.gosCustomizationHelperService
                .getGosType(context.specDetails.identity);
            this.dialogScope = this.$rootScope.$new();
            this.dialogScope.dialogConfig = {};
            this.dialogScope.allSpecs = context.allSpecs;
            var specName = this.specInfo.name;
            _.extend(this.dialogScope.dialogConfig, {
                title: this.i18nService.getString("VmUi", "editSpecWizard.title", specName),
                iconClass: context.iconClass,
                pages: this.gosSpecCreatePagesService.getDialogPages(this.dialogScope, this.gosType, this.onPageCommit.bind(this)),
                show: true,
                loading: false,
                loadingMessage: this.i18nService.getString("CommonUi", "wizard.loading"),
                confirmOptions: {
                    onClick: this.onDialogComplete.bind(this)
                },
                height: "720px",
                resizable: true,
                draggable: true,
                maximizable: true
            });
            var options = {
                scope: this.dialogScope,
                configObjectName: "dialogConfig"
            };
            this.gosSpecModelManagerService.populatePageModels(this.dialogScope, context.specInfo, context.specDetails);
            this.vxMultiPageDialogService(options);
        };
        EditGuestOsCustomizationSpecDialogService.prototype.onDialogComplete = function () {
            var _this = this;
            var finishPageModel = this.dialogScope.finishPageModel;
            var editSpec = new VmCustomizationEditSpec();
            editSpec.config = finishPageModel.buildSpec();
            finishPageModel.addWindowsParams(editSpec);
            editSpec.customizationSpecManager = finishPageModel.customizationSpecManager;
            editSpec.oldName = this.specInfo.name;
            editSpec.newName = editSpec.config.info.name;
            editSpec.isSpecModified = true;
            var customizationSpecManagerId = this.defaultUriSchemeUtil
                .getVsphereObjectId(editSpec.customizationSpecManager);
            var operation = this.i18nService
                .getString("VmUi", "customizationSpec.editSpecOperationName");
            this.mutationService.apply(customizationSpecManagerId, editSpec._type, editSpec, operation)
                .then(function (opResult) {
                _this.onActionInvoked("vsphere.core.vm.gos.customization.edit", opResult);
            });
            return true;
        };
        EditGuestOsCustomizationSpecDialogService.prototype.onPageCommit = function (pageModel) {
            var _this = this;
            var pageCommitPromise = pageModel.onPageCommit
                ? pageModel.onPageCommit()
                : this.$q.resolve([]);
            return pageCommitPromise.then(function (res) {
                _this.clearValidationMessages();
                if (!res) {
                    return false;
                }
                if (res && res.length > 0) {
                    _this.showValidationErrors(res);
                    return false;
                }
                _this.gosSpecModelManagerService.updateDependentModels(_this.dialogScope, pageModel);
                return true;
            });
        };
        EditGuestOsCustomizationSpecDialogService.prototype.showValidationErrors = function (errors) {
            var _this = this;
            if (!errors) {
                return;
            }
            var validationMessages = errors.map(function (error) {
                return {
                    text: error,
                    type: _this.vuiConstants.validationBanner.type.ERROR
                };
            });
            this.dialogScope.dialogConfig.validationBanner.messages = validationMessages;
        };
        EditGuestOsCustomizationSpecDialogService.prototype.clearValidationMessages = function () {
            this.dialogScope.dialogConfig.validationBanner.messages = [];
        };
        EditGuestOsCustomizationSpecDialogService.$inject = ["gosCustomizationHelperService",
            "gosSpecCreatePagesService",
            "gosSpecModelManagerService",
            "vxMultiPageDialogService",
            "defaultUriSchemeUtil",
            "$rootScope",
            "i18nService",
            "vuiConstants",
            "mutationService",
            "$q"];
        return EditGuestOsCustomizationSpecDialogService;
    }());
    h5_vm.EditGuestOsCustomizationSpecDialogService = EditGuestOsCustomizationSpecDialogService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("editGuestOsCustomizationSpecDialogService", EditGuestOsCustomizationSpecDialogService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var ImportGosSpecController = (function () {
        function ImportGosSpecController($q, $element, $timeout, i18nService, vuiConstants, userSessionService, gosSpecValidationService, importGosSpecService) {
            var _this = this;
            this.$q = $q;
            this.$element = $element;
            this.$timeout = $timeout;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.userSessionService = userSessionService;
            this.gosSpecValidationService = gosSpecValidationService;
            this.importGosSpecService = importGosSpecService;
            this.name = "";
            this.description = "";
            this.vcLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.vcLabel");
            this.nameLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.name");
            this.descriptionLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.description");
            this.sourceLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.sourceFile");
            this.browseButtonLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.browseLabel");
            this.loadingLabel =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.loadingLabel");
            this.fileNameToDisplay =
                this.i18nService.getString("VmUi", "guestOsCustomization.import.sourceFile.noFileSelected");
            this.customizationSectionLabel = this.i18nService.getString("VmUi", "guestOsCustomization.nameAndTargetOsPage.vmCustomizationSection");
            this.sourceFileSectionLabel = this.i18nService.getString("VmUi", "guestOsCustomization.import.sourceFileLabel");
            this.retrieveVcenterData();
            this.importSpecInput = this.$element.find(".gos-spec-file-input");
            // when the file browser is open this event is triggered
            // when `Open` or `Cancel` is pressed
            this.importSpecInput.on("change", function (event) {
                if (!event.target.files || !event.target.files.length) {
                    return;
                }
                _this.alerts = [];
                _this.validateSpecName();
                _this.onFileSelected(event).then(function () {
                    _this.validateSpecName();
                }).catch(function (error) {
                    _this.createAlerts([error]);
                });
            });
            this.onSubmit = function () {
                return _this.submitForm();
            };
        }
        ImportGosSpecController.prototype.onChooseFileClicked = function () {
            var _this = this;
            this.$timeout(function () {
                _this.importSpecInput.click();
            }, 0);
        };
        ImportGosSpecController.prototype.validateSpecName = function () {
            this.invalidNameMessage = this.gosSpecValidationService.validateName(this.name, false, this.allSpecs, this.vCenter.name);
        };
        ImportGosSpecController.prototype.onFileSelected = function (event) {
            var _this = this;
            var deferredValidation = this.$q.defer();
            this.file = event.target.files[0];
            this.fileNameToDisplay = this.file.name;
            this.$element.find(".gos-spec-file-input").val("");
            this.name = "";
            this.description = "";
            var error = this.importGosSpecService.validateFileMetadata(this.file);
            if (!error) {
                this.importGosSpecService.loadFile(this.file)
                    .then(function (xmlContent) {
                    var nameAndDescr = _this.importGosSpecService
                        .retrieveNameAndDescription(xmlContent);
                    _this.name = nameAndDescr.name;
                    _this.description = nameAndDescr.description;
                    deferredValidation.resolve();
                }).catch(function (error) {
                    deferredValidation.reject(error);
                });
            }
            else {
                deferredValidation.reject(error);
            }
            return deferredValidation.promise;
        };
        /**
         * Retrieve all the registered VCs
         * Sets the first one as the selected
         * and sets the customizationSpecMgr for the selected VC
         */
        ImportGosSpecController.prototype.retrieveVcenterData = function () {
            var _this = this;
            this.submitDisabled = true;
            this.userSessionService.getAllServersInfo().then(function (session) {
                _this.vCentersData = session.serversInfo;
                if (_this.vCentersData && _this.vCentersData.length > 0) {
                    _this.vCenter = _this.vCentersData[0];
                }
                _this.submitDisabled = false;
            });
        };
        /**
         * Validates if a name is entered and if it is unique.
         * Validates if a file has been selected
         * Validates permissions to create a spec on the selected VC
         * Sends the file to the backend to be validated
         */
        ImportGosSpecController.prototype.submitForm = function () {
            var _this = this;
            var cusSpecManager = this.vCenter.content.customizationSpecManager;
            this.submitDisabled = true;
            return this.importGosSpecService.validateForm(this.vCenter.serviceGuid, this.file, this.name, this.allSpecs, this.vCenter.name, cusSpecManager)
                .then(function (result) {
                _this.submitDisabled = false;
                if (result.errors.length > 0) {
                    _this.createAlerts(result.errors);
                    return _this.$q.when(false);
                }
                _this.onValidationComplete(result.result);
                return _this.$q.when(true);
            });
        };
        ImportGosSpecController.prototype.createAlerts = function (errors) {
            var _this = this;
            this.alerts = [];
            _.each(errors, function (error) {
                var alert = {
                    type: _this.vuiConstants.validationBanner.type.ERROR,
                    text: error
                };
                _this.alerts.push(alert);
            });
        };
        /**
         * In case the file is not validated show an error, in case it is valid
         * parse the response and add new customization spec
         * @param response
         */
        ImportGosSpecController.prototype.onValidationComplete = function (response) {
            this.importGosSpecService.parseValidationResponse(response, this.vCenter.content.customizationSpecManager, this.name, this.description);
        };
        ImportGosSpecController.$inject = [
            "$q",
            "$element",
            "$timeout",
            "i18nService",
            "vuiConstants",
            "userSessionService",
            "gosSpecValidationService",
            "importGosSpecService"];
        return ImportGosSpecController;
    }());
    var ImportGosSpecComponent = (function () {
        function ImportGosSpecComponent() {
            this.bindings = {
                onSubmit: "=",
                closeModal: "<",
                alerts: "=",
                // an alert will be shown
                allSpecs: "<",
                submitDisabled: "="
            };
            this.controller = ImportGosSpecController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/import/import-gos-spec.component.html";
        }
        return ImportGosSpecComponent;
    }());
    h5_vm.ImportGosSpecComponent = ImportGosSpecComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("importGosSpec", new ImportGosSpecComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmCustomizationImportSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationImportSpec;
    var VmCustomizationImportValidationSpec = com.vmware.vsphere.client.vm.customizations.VmCustomizationImportValidationSpec;
    var ImportGosSpecService = (function () {
        function ImportGosSpecService(i18nService, mutationService, clarityModalService, authorizationService, defaultUriSchemeUtil, gosSpecValidationService, logService, $q) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.clarityModalService = clarityModalService;
            this.authorizationService = authorizationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.gosSpecValidationService = gosSpecValidationService;
            this.logService = logService;
            this.$q = $q;
            this.IMPORT_GUEST_OS_SPEC_PRIVILEGES = [
                "VirtualMachine.Provisioning.ModifyCustSpecs",
                "VirtualMachine.Provisioning.ReadCustSpecs"];
            // Max size of 10 MB
            this.MAX_FILE_SIZE_BYTES = 10485760;
            this.log = logService("importGosSpecService");
        }
        ImportGosSpecService.prototype.openImportModal = function (gosCustomizationSpecs) {
            var _this = this;
            this.deferredSpecImport = this.$q.defer();
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.import"),
                contentTemplate: "vm-ui/resources/vm/guest-os-customization/import/import-gos-spec.view.html",
                defaultButton: "submit",
                dialogData: {
                    allCustomizationSpecs: gosCustomizationSpecs
                },
                onCancel: function () {
                    if (_this.reader) {
                        _this.reader.abort();
                    }
                    _this.deferredSpecImport.reject();
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            return this.deferredSpecImport.promise;
        };
        ImportGosSpecService.prototype.validateForm = function (serviceGuid, file, name, gosCustomizationSpecs, vCenterName, customizationSpecManager) {
            var errors = [];
            var nameErrorMessage = this.gosSpecValidationService
                .validateName(name, true, gosCustomizationSpecs, vCenterName);
            if (nameErrorMessage) {
                errors.push(nameErrorMessage);
            }
            var fileErrorMessage = this.validateFileMetadata(file);
            if (fileErrorMessage) {
                errors.push(fileErrorMessage);
            }
            var validationResult = {
                result: null,
                errors: errors
            };
            if (errors.length > 0) {
                return this.$q.when(validationResult);
            }
            var requests = {
                privilegeCheck: this.checkVCenterPrivileges(serviceGuid),
                fileCheck: this.validateFile(customizationSpecManager)
            };
            return this.$q.all(requests).then(function (responses) {
                var privilegeError = responses.privilegeCheck;
                if (privilegeError) {
                    errors.push(privilegeError);
                }
                if (responses.fileCheck) {
                    var fileErrors = responses.fileCheck.errors;
                    if (fileErrors.length > 0) {
                        validationResult.errors = errors.concat(fileErrors);
                    }
                    if (errors.length === 0) {
                        return responses.fileCheck;
                    }
                }
                return validationResult;
            });
        };
        ImportGosSpecService.prototype.loadFile = function (file) {
            var _this = this;
            var deferredValidation = this.$q.defer();
            this.reader = new FileReader();
            this.reader.readAsText(file);
            this.reader.onload = function () {
                if (!_this.reader) {
                    return;
                }
                _this.xmlContent = _this.reader.result;
                deferredValidation.resolve(_this.xmlContent);
            };
            this.reader.onerror = function () {
                var error = _this.i18nService.getString("VmUi", "importCustomizationSpec.errorImporting");
                deferredValidation.reject(error);
            };
            return deferredValidation.promise;
        };
        ImportGosSpecService.prototype.retrieveNameAndDescription = function (xmlContent) {
            var xmlDoc;
            try {
                xmlDoc = jQuery.parseXML(xmlContent);
            }
            catch (error) {
                this.log.log(error);
            }
            return {
                name: xmlDoc ? $(xmlDoc).find("info name").text() : "",
                description: xmlDoc ? $(xmlDoc).find("info description").text() : ""
            };
        };
        ImportGosSpecService.prototype.validateFile = function (customizationSpecManager) {
            var deferredValidation = this.$q.defer();
            if (this.xmlContent) {
                this.onFileLoaded(customizationSpecManager, deferredValidation);
            }
            else {
                var error = this.i18nService.getString("VmUi", "importCustomizationSpec.errorImporting");
                var validationResult = {
                    result: null,
                    errors: [error]
                };
                deferredValidation.resolve(validationResult);
            }
            return deferredValidation.promise;
        };
        ;
        ImportGosSpecService.prototype.onFileLoaded = function (customizationSpecManager, deferredValidation) {
            var _this = this;
            var validationResult = {
                result: null,
                errors: []
            };
            var specXml = this.xmlContent;
            var validationSpec = new VmCustomizationImportValidationSpec();
            validationSpec.customizationSpecManager = customizationSpecManager;
            validationSpec.customizationSpecText = specXml;
            var custSpecManagerId = this.defaultUriSchemeUtil.getVsphereObjectId(customizationSpecManager);
            var validationPromise = this.mutationService.validate(custSpecManagerId, validationSpec._type, validationSpec);
            validationPromise.then(function (response) {
                if (!response || !response.result || response.error) {
                    var error = _this.i18nService.getString("VmUi", "importCustomizationSpec.errorImporting");
                    validationResult.errors = [error];
                }
                else {
                    validationResult.result = response.result;
                }
                deferredValidation.resolve(validationResult);
            }).catch(function () {
                var error = _this.i18nService.getString("VmUi", "importCustomizationSpec.errorImporting");
                validationResult.errors = [error];
                deferredValidation.resolve(validationResult);
            });
        };
        ;
        ImportGosSpecService.prototype.validateFileMetadata = function (file) {
            if (!file) {
                return this.i18nService.getString("VmUi", "guestOsCustomization.import.noFileSelected");
            }
            if (!file.size || (file.size && file.size === 0)) {
                return this.i18nService.getString("VmUi", "guestOsCustomization.import.emptyFile");
            }
            if (file.size > this.MAX_FILE_SIZE_BYTES) {
                return this.i18nService.getString("VmUi", "guestOsCustomization.import.maxSizeExceededError");
            }
            return "";
        };
        ImportGosSpecService.prototype.checkVCenterPrivileges = function (vcServerGuid) {
            var _this = this;
            var vcRefId = this.defaultUriSchemeUtil.getRootFolder(vcServerGuid);
            return this.authorizationService.checkGrantedPrivileges(vcRefId, this.IMPORT_GUEST_OS_SPEC_PRIVILEGES)
                .then(function (allPrivStatuses) {
                var notValid = _.some(allPrivStatuses, function (privilege) {
                    return !privilege;
                });
                if (notValid) {
                    return _this.i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.noPrivileges");
                }
                return "";
            });
        };
        /**
         * From the response from the server a VmCustomizationImportSpec is created
         * changing it's name and description with the ones provided from the form
         * A mutation add operation is called with the new spec
         *
         * If the result's validationSucceeded flag is false
         */
        ImportGosSpecService.prototype.parseValidationResponse = function (response, customizationSpecManager, name, description) {
            var info = response.customizationSpecItem.info;
            info.name = name;
            info.description = description;
            var importSpec = new VmCustomizationImportSpec();
            importSpec.customizationSpecManager = customizationSpecManager;
            importSpec.customizationSpecItem = response.customizationSpecItem;
            var operation = this.i18nService.getString("VmUi", "importRequest.Operation");
            if (response.validationSucceeded) {
                this.addSpec(importSpec, operation, false);
            }
            else {
                this.confirmChangeKey(importSpec, operation);
            }
        };
        ;
        /**
         * Displays an Ok/Cancel dialog that confirms the import and informs the user that
         * they should reset their password from th edit dialog
         */
        ImportGosSpecService.prototype.confirmChangeKey = function (importSpec, operation) {
            var _this = this;
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "importCustomizationSpec.invalidKey.title"),
                message: this.i18nService.getString("VmUi", "importCustomizationSpec.invalidKey.text"),
                saveButtonLabel: this.i18nService.getString("Common", "alert.continue"),
                icon: null,
                clarityIcon: {
                    shape: "warning",
                    class: "is-warning",
                    size: 48
                },
                submit: function () {
                    _this.addSpec(importSpec, operation, true);
                },
                onCancel: function () {
                    _this.deferredSpecImport.reject();
                },
                preserveNewlines: true
            };
            this.clarityModalService.openConfirmationModal(modalOptions);
        };
        /**
         * Calls the mutation operation that adds the imported spec
         * Refreshes the grid and sets the new item for preselection
         * If invokeEdit is set to true, the edit window will be open for the
         * newly imported spec
         */
        ImportGosSpecService.prototype.addSpec = function (importSpec, operation, invokeEdit) {
            var _this = this;
            this.mutationService.add(importSpec._type, importSpec, operation)
                .then(function (result) {
                var response = {
                    result: result,
                    invokeEdit: invokeEdit
                };
                _this.deferredSpecImport.resolve(response);
            })
                .catch(function () {
                _this.deferredSpecImport.reject();
            });
        };
        ImportGosSpecService.$inject = ["i18nService",
            "mutationService",
            "clarityModalService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "gosSpecValidationService",
            "logService",
            "$q"];
        return ImportGosSpecService;
    }());
    h5_vm.ImportGosSpecService = ImportGosSpecService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("importGosSpecService", ImportGosSpecService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = h5_vm.GosType;
    var GosCustomizationHelperService = (function () {
        function GosCustomizationHelperService(_i18nService, gosSpecNetworkService) {
            this._i18nService = _i18nService;
            this.gosSpecNetworkService = gosSpecNetworkService;
        }
        /**
         * Determines if this is a Linux prep spec.
         */
        GosCustomizationHelperService.prototype.isLinuxPrep = function (specDetails) {
            if (!specDetails) {
                return false;
            }
            return specDetails.identity._type === GosCustomizationHelperService.IDENTITY_TYPE_LINUX_PREP;
        };
        /**
         * Determines if this is a Windows sysprep spec stored in a text file.
         */
        GosCustomizationHelperService.prototype.isSysPrep = function (specDetails) {
            if (!specDetails) {
                return false;
            }
            return specDetails.identity._type === GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP;
        };
        /**
         * Determines if this is a Windows sysprep spec stored in a text file.
         */
        GosCustomizationHelperService.prototype.isSysPrepText = function (specDetails) {
            if (!specDetails) {
                return false;
            }
            return specDetails.identity._type === GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP_TEXT;
        };
        GosCustomizationHelperService.prototype.getGosType = function (identity) {
            switch (identity._type) {
                case GosCustomizationHelperService.IDENTITY_TYPE_LINUX_PREP:
                    return GosType.LINUX;
                case GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP:
                    return GosType.WINDOWS;
                case GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP_TEXT:
                    return GosType.WINDOWS_CUSTOM_SYSPREP;
            }
            return GosType.NONE;
        };
        GosCustomizationHelperService.prototype.getNameGenerator = function (specDetails) {
            var result;
            if (this.isSysPrep(specDetails)) {
                var identitySysPrep = specDetails.identity;
                result = identitySysPrep.userData.computerName;
            }
            else {
                var identityLinuxPrep = specDetails.identity;
                result = identityLinuxPrep.hostName;
            }
            return result;
        };
        GosCustomizationHelperService.prototype.getComputerName = function (specDetails) {
            if (!specDetails || this.isSysPrepText(specDetails)) {
                return "";
            }
            var nameSpec = this.getNameGenerator(specDetails);
            var result = "";
            if (nameSpec._type === GosCustomizationHelperService.COMPUTER_NAME_TYPE_FIXED_NAME) {
                result = nameSpec.name;
            }
            else if (nameSpec._type === GosCustomizationHelperService.COMPUTER_NAME_TYPE_PREFIX_NAME_GENERATOR) {
                result = this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.suffixed", nameSpec.base);
            }
            else if (nameSpec._type === GosCustomizationHelperService.COMPUTER_NAME_TYPE_VIRTUAL_MACHINE_NAME_GENERATOR) {
                result = this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.useVmName");
            }
            else if (nameSpec._type === GosCustomizationHelperService.COMPUTER_NAME_TYPE_CUSTOM_NAME_GENERATOR) {
                result = this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.useCustom");
            }
            else if (nameSpec._type === GosCustomizationHelperService.COMPUTER_NAME_TYPE_UNKNOWN_NAME_GENERATOR) {
                result = this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.askUser");
            }
            return result;
        };
        GosCustomizationHelperService.prototype.getTimeZone = function (specDetails) {
            if (!specDetails) {
                return "";
            }
            if (this.isLinuxPrep(specDetails)) {
                var area = this.getTimeZoneArea(specDetails);
                var location_1 = this.getTimeZoneLocation(specDetails);
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.timezone", area, location_1);
            }
            if (this.isSysPrep(specDetails)) {
                return this._i18nService.getString("CommonTimeZones", "timeZoneWindows." + specDetails.identity.guiUnattended.timeZone);
            }
            return "";
        };
        /**
         * String representation of the Linux time zone area.
         */
        GosCustomizationHelperService.prototype.getTimeZoneArea = function (specDetails) {
            if (!specDetails || !this.isLinuxPrep(specDetails)) {
                return "";
            }
            // Linux timezone format is "<Area>/<Location>", so take the <Area> part.
            var rawTimeZone = specDetails.identity.timeZone;
            var data = rawTimeZone.split(GosCustomizationHelperService.AREA_LOCATION_SEPARATOR);
            if (_.isEmpty(data)) {
                return "";
            }
            return this._i18nService.getString("CommonTimeZones", "timeZoneLinux.Area." + data[0]);
        };
        /**
         * String representation of the Linux time zone location.
         */
        GosCustomizationHelperService.prototype.getTimeZoneLocation = function (specDetails) {
            if (!specDetails || !this.isLinuxPrep(specDetails)) {
                return "";
            }
            // Linux timezone format is "<Area>/<Location>" (America/Argentina/Buenos_Aires,
            // America/Aruba), so take the <Location> part
            var rawTimeZone = specDetails.identity.timeZone;
            var data = rawTimeZone.split(GosCustomizationHelperService.AREA_LOCATION_SEPARATOR);
            if (data.length < 2) {
                return "";
            }
            // remove the Area part
            data.shift();
            // join back the location part - /Argentina/Buenos_Aires
            var location = data.join(GosCustomizationHelperService.AREA_LOCATION_SEPARATOR);
            return this._i18nService.getString("CommonTimeZones", "timeZoneLinux.Location." + location);
        };
        GosCustomizationHelperService.prototype.getHardwareClock = function (specDetails) {
            if (!specDetails || !this.isLinuxPrep(specDetails)) {
                return "";
            }
            if (specDetails.identity.hwClockUTC) {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.hwClockUtc");
            }
            return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.hwClockLocalTime");
        };
        GosCustomizationHelperService.prototype.isNetworkTypical = function (specDetails) {
            // In the Network page story the network is referred to as "Standard", not
            // "Typical".
            return this.gosSpecNetworkService.isNetworkTypeStandard(specDetails);
        };
        GosCustomizationHelperService.prototype.getNetworkTypeString = function (specDetails) {
            if (this.gosSpecNetworkService.isNetworkTypeStandard(specDetails)) {
                return this._i18nService.getString("VmUi", "customizationSpec.summaryPage.networkSettings.standard");
            }
            else {
                return this._i18nService.getString("VmUi", "customizationSpec.summaryPage.networkSettings.custom");
            }
        };
        GosCustomizationHelperService.prototype.getNicIpSettings = function (specDetails) {
            var _this = this;
            var result = [];
            if (specDetails && specDetails.nicSettingMap) {
                _.each(specDetails.nicSettingMap, function (adapter) {
                    var ipv4 = _this.gosSpecNetworkService
                        .getIPv4NicSettingSummary(adapter.adapter.ip);
                    var ipv6 = _this.gosSpecNetworkService
                        .getIPv6NicSettingSummary(adapter.adapter.ipV6Spec);
                    var item = { IPv4: ipv4, IPv6: ipv6 };
                    result.push(item);
                });
            }
            return result;
        };
        GosCustomizationHelperService.prototype.getDnsServers = function (specDetails) {
            if (!specDetails || !this.isLinuxPrep(specDetails)
                || !specDetails.globalIPSettings
                || !specDetails.globalIPSettings.dnsServerList) {
                return [];
            }
            return specDetails.globalIPSettings.dnsServerList;
        };
        GosCustomizationHelperService.prototype.getPrimaryDnsServer = function (specDetails) {
            var dnsServers = this.getDnsServers(specDetails);
            if (dnsServers.length > 0) {
                return dnsServers[0];
            }
            return "";
        };
        GosCustomizationHelperService.prototype.getSecondaryDnsServer = function (specDetails) {
            var dnsServers = this.getDnsServers(specDetails);
            if (dnsServers.length > 1) {
                return dnsServers[1];
            }
            return "";
        };
        GosCustomizationHelperService.prototype.getTertiaryDnsServer = function (specDetails) {
            var dnsServers = this.getDnsServers(specDetails);
            if (dnsServers.length > 2) {
                return dnsServers[2];
            }
            return "";
        };
        GosCustomizationHelperService.prototype.getDnsAndDomain = function (specDetails) {
            if (specDetails && specDetails.globalIPSettings.dnsServerList && !_.isEmpty(specDetails.globalIPSettings.dnsServerList)) {
                return specDetails.globalIPSettings.dnsServerList[0];
            }
            return "";
        };
        GosCustomizationHelperService.prototype.getDnsSuffixList = function (specDetails) {
            if (specDetails && this.isLinuxPrep(specDetails)
                && !!specDetails.globalIPSettings
                && !!specDetails.globalIPSettings.dnsSuffixList) {
                return specDetails.globalIPSettings.dnsSuffixList;
            }
            return [];
        };
        GosCustomizationHelperService.prototype.getRegistrationInfo = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var userData = specDetails.identity.userData;
            return this._i18nService.getString("VmUi", "guestOsCustomization.regInfoFormat", userData.fullName, userData.orgName);
        };
        GosCustomizationHelperService.prototype.getWindowsLicenseKeyHeader = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var userData = specDetails.identity.userData;
            if (!!userData.productId && !_.isEmpty(userData.productId)) {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.licenseKeyHeader", userData.productId);
            }
            return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.noLicenseKey");
        };
        GosCustomizationHelperService.prototype.getWindowsLicenseKey = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var userData = specDetails.identity.userData;
            if (!!userData.productId && !_.isEmpty(userData.productId)) {
                return userData.productId;
            }
            return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.noLicenseKey");
        };
        GosCustomizationHelperService.prototype.isServerLicensingIncluded = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return false;
            }
            var licenseData = specDetails.identity.licenseFilePrintData;
            return !!licenseData;
        };
        GosCustomizationHelperService.prototype.isServerLicensingMpdePerServer = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var licenseData = specDetails.identity.licenseFilePrintData;
            if (!licenseData) {
                return "";
            }
            if ("perServer" === licenseData.autoMode) {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.licenseServerModePerServer", licenseData.autoUsers);
            }
            else {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.licenseServerModePerSeat", licenseData.autoUsers);
            }
        };
        GosCustomizationHelperService.prototype.getServerLicensingInfo = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var licenseData = specDetails.identity.licenseFilePrintData;
            if (!licenseData) {
                return "";
            }
            if ("perServer" === licenseData.autoMode) {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.licenseServerModePerServer", licenseData.autoUsers);
            }
            else {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.licenseServerModePerSeat", licenseData.autoUsers);
            }
        };
        GosCustomizationHelperService.prototype.isAutoLogon = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return false;
            }
            var data = specDetails.identity.guiUnattended;
            if (!data) {
                return false;
            }
            return data.autoLogon;
        };
        GosCustomizationHelperService.prototype.getAutoLogonCount = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return NaN;
            }
            var data = specDetails.identity.guiUnattended;
            if (!data) {
                return NaN;
            }
            return data.autoLogonCount;
        };
        GosCustomizationHelperService.prototype.getWorkgroup = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return "";
            }
            var data = specDetails.identity.identification;
            return data.joinWorkgroup;
        };
        GosCustomizationHelperService.prototype.getDomain = function (specDetails) {
            if (!specDetails) {
                return "";
            }
            if (this.isLinuxPrep(specDetails)) {
                return specDetails.identity.domain;
            }
            if (this.isSysPrep(specDetails)) {
                var data = specDetails.identity.identification;
                return data.joinDomain;
            }
            return "";
        };
        GosCustomizationHelperService.prototype.generateNewSID = function (specDetails) {
            if (!specDetails || this.isLinuxPrep(specDetails)) {
                return false;
            }
            var options = specDetails.options;
            return options.changeSID;
        };
        GosCustomizationHelperService.prototype.gosTypeToString = function (value) {
            switch (value) {
                case GosType.WINDOWS:
                case GosType.WINDOWS_CUSTOM_SYSPREP:
                    return this._i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.specTypeWindows");
                case GosType.LINUX:
                    return this._i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.specTypeLinux");
                default: {
                    return "";
                }
            }
        };
        /**
         * A list of commands to run at first user logon, after guest customization.
         */
        GosCustomizationHelperService.prototype.getRunOnceCommands = function (specDetails) {
            if (!specDetails || !this.isSysPrep(specDetails)) {
                return [];
            }
            var data = specDetails.identity.guiRunOnce;
            if (!data || _.isEmpty(data.commandList)) {
                return [];
            }
            return data.commandList;
        };
        GosCustomizationHelperService.prototype.getLoginType = function (specDetails) {
            if (!specDetails.identity.guiUnattended.autoLogon) {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.doNotloginAsAdmin");
            }
            else {
                return this._i18nService.getString("VmUi", "customizationManager.customizationSpecDetailsView.loginAsAdmin");
            }
        };
        GosCustomizationHelperService.prototype.getAutomaticLogonTimes = function (specDetails) {
            if (!specDetails.identity.guiUnattended.autoLogon) {
                return null;
            }
            return specDetails.identity.guiUnattended.autoLogonCount;
        };
        GosCustomizationHelperService.prototype.getDomainUsername = function (specDetails) {
            if (specDetails.identity.identification) {
                return specDetails.identity.identification.domainAdmin;
            }
            return "";
        };
        GosCustomizationHelperService.prototype.getCommands = function (specDetails) {
            var identity = specDetails.identity;
            if (identity && identity.guiRunOnce && identity.guiRunOnce.commandList) {
                return identity.guiRunOnce.commandList;
            }
            return [];
        };
        GosCustomizationHelperService.$inject = [
            "i18nService",
            "gosSpecNetworkService"];
        GosCustomizationHelperService.IDENTITY_TYPE_LINUX_PREP = "com.vmware.vim.binding.vim.vm.customization.LinuxPrep";
        GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP = "com.vmware.vim.binding.vim.vm.customization.Sysprep";
        GosCustomizationHelperService.IDENTITY_TYPE_SYS_PREP_TEXT = "com.vmware.vim.binding.vim.vm.customization.SysprepText";
        GosCustomizationHelperService.ADAPTER_TYPE_DHCP = "com.vmware.vim.binding.vim.vm.customization.DhcpIpGenerator";
        GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP = "com.vmware.vim.binding.vim.vm.customization.FixedIp";
        GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP = "com.vmware.vim.binding.vim.vm.customization.UnknownIpGenerator";
        GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP = "com.vmware.vim.binding.vim.vm.customization.CustomIpGenerator";
        GosCustomizationHelperService.ADAPTER_TYPE_DHCP_V6 = "com.vmware.vim.binding.vim.vm.customization.DhcpIpV6Generator";
        GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP_V6 = "com.vmware.vim.binding.vim.vm.customization.FixedIpV6";
        GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP_V6 = "com.vmware.vim.binding.vim.vm.customization.UnknownIpV6Generator";
        GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP_V6 = "com.vmware.vim.binding.vim.vm.customization.CustomIpV6Generator";
        GosCustomizationHelperService.IPV6_ADDRESS_SPEC_TYPE = "com.vmware.vim.binding.vim.vm.customization.IPSettings$IpV6AddressSpec";
        GosCustomizationHelperService.COMPUTER_NAME_TYPE_FIXED_NAME = "com.vmware.vim.binding.vim.vm.customization.FixedName";
        GosCustomizationHelperService.COMPUTER_NAME_TYPE_PREFIX_NAME_GENERATOR = "com.vmware.vim.binding.vim.vm.customization.PrefixNameGenerator";
        GosCustomizationHelperService.COMPUTER_NAME_TYPE_VIRTUAL_MACHINE_NAME_GENERATOR = "com.vmware.vim.binding.vim.vm.customization.VirtualMachineNameGenerator";
        GosCustomizationHelperService.COMPUTER_NAME_TYPE_CUSTOM_NAME_GENERATOR = "com.vmware.vim.binding.vim.vm.customization.CustomNameGenerator";
        GosCustomizationHelperService.COMPUTER_NAME_TYPE_UNKNOWN_NAME_GENERATOR = "com.vmware.vim.binding.vim.vm.customization.UnknownNameGenerator";
        GosCustomizationHelperService.DEFAULT_NUMBER_OF_NICS = 1;
        GosCustomizationHelperService.AREA_LOCATION_SEPARATOR = "/";
        return GosCustomizationHelperService;
    }());
    h5_vm.GosCustomizationHelperService = GosCustomizationHelperService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosCustomizationHelperService", GosCustomizationHelperService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GuestOsCustomizationListController = (function () {
        function GuestOsCustomizationListController($scope, i18nService, userSessionService, vuiConstants, listService, columnRenderersRegistry, helperService, vcH5ConstantsService, timeFormatterService) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.userSessionService = userSessionService;
            this.vuiConstants = vuiConstants;
            this.listService = listService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.helperService = helperService;
            this.vcH5ConstantsService = vcH5ConstantsService;
            this.timeFormatterService = timeFormatterService;
            this.invokeEditAction = false;
            this.$scope.i18n = this.i18nService.getString;
            this.displayNoPermissions = false;
            this.displayGrid = false;
            this.isLoadingSpecInfos = false;
            this.isLoadingSpecDetails = false;
            this.loadingLabel = this.i18nService.getString("Common", "loadingTitle");
            this.gridOptions = this.createDataGridOptions();
            this.selectedSpecInfo = undefined;
            this.selectedSpecDetails = undefined;
            this.selectedSpecXmlText = undefined;
            this.selectedSpecDetailsNicIpSettings = [];
            this.selectedSpecDetailsDnsSuffixList = [];
            this.updateActionBar();
            $scope.$on(this.vcH5ConstantsService.DATA_REFRESH_INVOCATION_EVENT, function () {
                _this.retrieveVCentersData();
            });
            this.retrieveVCentersData();
            this.splitterOptions = {
                orientation: this.vuiConstants.splitter.orientation.VERTICAL,
                panes: [
                    {
                        min: "250px",
                        size: "50%"
                    }, {
                        min: "250px",
                        size: "50%"
                    }
                ]
            };
            this.$scope.$watch(function () {
                return _this.gridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                _this.onSpecInfoChanged.call(_this, newSelection, oldSelection);
            });
            this.preselectComparator = function (gridItem) {
                return _this.preselectComparatorInternal(gridItem);
            };
        }
        GuestOsCustomizationListController.prototype.getSelectedSpecName = function () {
            return this.selectedSpecInfo
                ? this.selectedSpecInfo.name
                : "";
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecType = function () {
            return this.selectedSpecInfo
                ? this.selectedSpecInfo.type
                : "";
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDescription = function () {
            return this.selectedSpecInfo
                ? this.selectedSpecInfo.description
                : "";
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsLinuxPrep = function () {
            return this.helperService.isLinuxPrep(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsSysPrep = function () {
            return this.helperService.isSysPrep(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsSysPrepText = function () {
            return this.helperService.isSysPrepText(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsComputerName = function () {
            return this.helperService.getComputerName(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsTimeZone = function () {
            return this.helperService.getTimeZone(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsTimeZoneArea = function () {
            return this.helperService.getTimeZoneArea(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsTimeZoneLocation = function () {
            return this.helperService.getTimeZoneLocation(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsHardwareClock = function () {
            return this.helperService.getHardwareClock(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsNetworkTypical = function () {
            return this.helperService.isNetworkTypical(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsNicIpSettings = function () {
            return this.selectedSpecDetailsNicIpSettings;
        };
        GuestOsCustomizationListController.prototype.hasOsOptions = function () {
            return !!(this.selectedSpecDetails && this.selectedSpecDetails.options);
        };
        GuestOsCustomizationListController.prototype.hasDnsServers = function () {
            return !_.isEmpty(this.helperService.getDnsServers(this.selectedSpecDetails));
        };
        GuestOsCustomizationListController.prototype.getPrimaryDnsServer = function () {
            return this.helperService.getPrimaryDnsServer(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSecondaryDnsServer = function () {
            return this.helperService.getSecondaryDnsServer(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getTertiaryDnsServer = function () {
            return this.helperService.getTertiaryDnsServer(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsDnsAndDomain = function () {
            return this.helperService.getDnsAndDomain(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsDnsSuffixList = function () {
            return this.selectedSpecDetailsDnsSuffixList;
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsRegistrationInfo = function () {
            return this.helperService.getRegistrationInfo(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsWindowsLicenseKeyHeader = function () {
            return this.helperService.getWindowsLicenseKeyHeader(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsWindowsLicenseKey = function () {
            return this.helperService.getWindowsLicenseKey(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsServerLicensingIncluded = function () {
            return this.helperService.isServerLicensingIncluded(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsServerLicensingInfo = function () {
            return this.helperService.getServerLicensingInfo(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsAutoLogon = function () {
            return this.helperService.isAutoLogon(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsAutoLogons = function () {
            return this.helperService.getAutoLogonCount(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsWorkgroup = function () {
            return this.helperService.getWorkgroup(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getSelectedSpecDetailsDomain = function () {
            return this.helperService.getDomain(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.isSelectedSpecDetailsGenerateSID = function () {
            return this.helperService.generateNewSID(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.getRunOnceCommands = function () {
            return this.helperService.getRunOnceCommands(this.selectedSpecDetails);
        };
        GuestOsCustomizationListController.prototype.onSpecInfoChanged = function (newSelection, oldSelection) {
            if (newSelection === oldSelection || _.isEqual(newSelection, oldSelection)) {
                return;
            }
            if (!newSelection || newSelection.length === 0 || newSelection.length > 1) {
                this.selectedSpecInfo = undefined;
                this.selectedSpecDetails = undefined;
                this.selectedSpecXmlText = undefined;
                this.preselectItemName = undefined;
                this.selectedSpecDetailsNicIpSettings = [];
                this.selectedSpecDetailsDnsSuffixList = [];
                this.updateActionBar();
            }
            else {
                this.selectedSpecInfo = newSelection[0];
                this.preselectItemName = newSelection[0].name;
                this.retrieveSpecDetails();
            }
        };
        GuestOsCustomizationListController.prototype.getSysPrepText = function () {
            if (!this.selectedSpecDetails) {
                return "";
            }
            return this.selectedSpecDetails.identity.value;
        };
        GuestOsCustomizationListController.prototype.retrieveVCentersData = function () {
            var _this = this;
            // retrieve the user's preferred time format and use it when displaying the
            // `Last Modified` column
            this.timeFormatterService.getUserTimeFormatPreference().then(function (format) {
                _this.savedDateTimeFormat = format;
            });
            this.userSessionService.getAllServersInfo().then(function (session) {
                // if there are no VCs to begin with disable the actions but do not show
                // missing privileges error
                if (session.serversInfo && session.serversInfo.length === 0) {
                    _this.updateActionBar(true);
                    _this.displayGrid = true;
                    return;
                }
                _this.listService.filterVcs(session.serversInfo).then(function (filteredVcs) {
                    _this.vCentersData = filteredVcs;
                    if (_this.vCentersData && _this.vCentersData.length > 0) {
                        _this.retrieveSpecInfos();
                        _this.displayGrid = true;
                    }
                    else {
                        _this.displayNoPermissions = true;
                    }
                });
            });
        };
        GuestOsCustomizationListController.prototype.retrieveSpecInfos = function () {
            var _this = this;
            this.isLoadingSpecInfos = true;
            return this.listService.retrieveSpecInfos(this.vCentersData)
                .then(function (data) {
                _this.gridOptions.data = data;
            })
                .then(function () {
                _this.isLoadingSpecInfos = false;
                if (_this.contextActionsDisabled) {
                    _this.contextActionsDisabled = false;
                    _this.updateActionBar();
                }
            });
        };
        /**
         * Retrieves the customization spec details for the selected spec
         * and passes it to the details view
         */
        GuestOsCustomizationListController.prototype.retrieveSpecDetails = function () {
            var _this = this;
            if (!this.selectedSpecInfo) {
                return;
            }
            this.isLoadingSpecDetails = true;
            this.listService.retrieveSpecs(this.selectedSpecInfo.vcService, this.selectedSpecInfo.name)
                .then(function (data) {
                _this.selectedSpecDetails = data.customizationSpec.spec;
                _this.selectedSpecXmlText = data.specItemXMLText;
                _this.selectedSpecDetailsNicIpSettings =
                    _this.helperService.getNicIpSettings(_this.selectedSpecDetails);
                _this.selectedSpecDetailsDnsSuffixList =
                    _this.helperService.getDnsSuffixList(_this.selectedSpecDetails);
            })
                .then(function () {
                _this.isLoadingSpecDetails = false;
                return _this.updateActionBar();
            }).then(function () {
                // if the edit action has to be invoked for the preselected item
                // invoke it and clean the flag so that it is not invoked again
                if (_this.invokeEditAction) {
                    _this.listService.invokeEdit(_this.selectedSpecInfo, _this.selectedSpecDetails, _this.gridOptions.data, _this.onActionInvoked.bind(_this));
                    _this.invokeEditAction = false;
                }
            });
        };
        GuestOsCustomizationListController.prototype.createDataGridOptions = function () {
            var _this = this;
            var linkRenderer = this.columnRenderersRegistry.getColumnRenderer("vcenter-name");
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                searchable: true,
                resizable: true,
                reorderable: false,
                selectedItems: [],
                columnDefs: [
                    {
                        field: "name",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService
                            .getString("VmUi", "customizationManager.customizationSpecList.nameColumnHeader")
                    },
                    {
                        field: "type",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService
                            .getString("VmUi", "customizationManager.customizationSpecList.guestOsColumnHeader")
                    },
                    {
                        field: "lastUpdateTime",
                        sortable: true,
                        searchable: false,
                        displayName: this.i18nService
                            .getString("VmUi", "customizationManager.customizationSpecList.lastModifiedColumnHeader"),
                        template: function (spec) {
                            return _this.timeFormatterService.timestampToText(parseInt(spec.lastUpdateTime), _this.savedDateTimeFormat);
                        }
                    },
                    {
                        field: "vCenterName",
                        sortable: true,
                        searchable: true,
                        displayName: this.i18nService.getString("Common", "vcColumnHeader"),
                        template: function (data) {
                            return linkRenderer(["vCenterName"], data, { navigatable: false });
                        }
                    }
                ],
                data: [],
                height: "100%",
                columnMenu: {
                    sortable: false,
                    messages: {
                        columns: this.i18nService.getString("CommonUi", "listview.showColumnsMenu"),
                        filter: this.i18nService.getString("CommonUi", "listview.filterMenu")
                    }
                },
            };
        };
        GuestOsCustomizationListController.prototype.updateActionBar = function (contextActionsDisabled) {
            if (contextActionsDisabled === void 0) { contextActionsDisabled = false; }
            return this.listService.updateActionBar(this.gridOptions, this.selectedSpecInfo, this.selectedSpecDetails, this.selectedSpecXmlText, this.onActionInvoked.bind(this), this.beforeActionInvoked.bind(this), contextActionsDisabled);
        };
        GuestOsCustomizationListController.prototype.preselectComparatorInternal = function (dataGridItem) {
            var preselect = false;
            if (this.preselectItemName) {
                preselect = dataGridItem.name === this.preselectItemName;
            }
            return preselect;
        };
        GuestOsCustomizationListController.prototype.onActionInvoked = function (actionId, opResult, invokeEdit) {
            if (!actionId) {
                return;
            }
            switch (actionId) {
                case "vsphere.core.vm.gos.customization.new":
                case "vsphere.core.vm.gos.customization.edit":
                    this.onSpecCreated(opResult);
                    break;
                case "vsphere.core.vm.gos.customization.duplicate":
                    this.onSpecDuplicated(opResult, invokeEdit);
                    break;
                case "vsphere.core.vm.gos.customization.import":
                    this.onSpecImported(opResult, invokeEdit);
                    break;
                case "vsphere.core.vm.gos.customization.delete":
                    this.onSpecDeleted(opResult);
                    break;
                default:
                    break;
            }
        };
        GuestOsCustomizationListController.prototype.beforeActionInvoked = function () {
            this.contextActionsDisabled = true;
            this.updateActionBar(this.contextActionsDisabled);
        };
        GuestOsCustomizationListController.prototype.onSpecCreated = function (opResult) {
            var _this = this;
            this.retrieveSpecInfos().then(function () {
                _this.preselectItemName = opResult.result;
            });
        };
        GuestOsCustomizationListController.prototype.onSpecDuplicated = function (opResult, invokeEdit) {
            var _this = this;
            this.retrieveSpecInfos().then(function () {
                _this.preselectItemName = opResult.result;
                _this.invokeEditAction = invokeEdit;
            });
        };
        GuestOsCustomizationListController.prototype.onSpecImported = function (opResult, invokeEdit) {
            var _this = this;
            this.retrieveSpecInfos().then(function () {
                _this.preselectItemName = opResult.result.info.name;
                _this.invokeEditAction = invokeEdit;
            });
        };
        GuestOsCustomizationListController.prototype.onSpecDeleted = function (opResult) {
            // User canceled the delete
            if (!opResult) {
                this.contextActionsDisabled = false;
                this.updateActionBar();
                return;
            }
            var deletedSpecName = opResult.result;
            this.setPreselectNameOnDelete(deletedSpecName);
            this.retrieveSpecInfos();
        };
        GuestOsCustomizationListController.prototype.setPreselectNameOnDelete = function (deletedSpecName) {
            // last remaining GOS spec is deleted
            if (this.gridOptions.data.length === 1
                && this.gridOptions.data[0].name === deletedSpecName) {
                this.preselectItemName = undefined;
                return;
            }
            for (var i = 0; i < this.gridOptions.data.length; i++) {
                if (this.gridOptions.data[i].name === deletedSpecName) {
                    if (i + 1 < this.gridOptions.data.length) {
                        this.preselectItemName = this.gridOptions.data[i + 1].name;
                        return;
                    }
                    else {
                        this.preselectItemName = this.gridOptions.data[i - 1].name;
                        return;
                    }
                }
            }
        };
        GuestOsCustomizationListController.$inject = [
            "$scope",
            "i18nService",
            "userSessionService",
            "vuiConstants",
            "gosCustomizationListService",
            "columnRenderersRegistry",
            "gosCustomizationHelperService",
            "vcH5ConstantsService",
            "timeFormatterService"];
        return GuestOsCustomizationListController;
    }());
    var GuestOsCustomizationListComponent = (function () {
        function GuestOsCustomizationListComponent() {
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/list/gos-customization-list.component.html";
            this.controller = GuestOsCustomizationListController;
        }
        return GuestOsCustomizationListComponent;
    }());
    h5_vm.GuestOsCustomizationListComponent = GuestOsCustomizationListComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("gosCustomizationList", new GuestOsCustomizationListComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var CustomizationSpecInfo = com.vmware.vim.binding.vim.CustomizationSpecInfo;
    var ParamSpec = com.vmware.vise.mvc.model.data.ParamSpec;
    var CustomizationSpecInfoCustom = (function (_super) {
        __extends(CustomizationSpecInfoCustom, _super);
        function CustomizationSpecInfoCustom() {
            _super.apply(this, arguments);
        }
        return CustomizationSpecInfoCustom;
    }(CustomizationSpecInfo));
    h5_vm.CustomizationSpecInfoCustom = CustomizationSpecInfoCustom;
    var ActionBarContext = (function () {
        function ActionBarContext() {
        }
        ActionBarContext.prototype.reset = function () {
            this.editActionEval = undefined;
            this.editPrivsGranted = true;
            this.deletePrivsGranted = true;
            this.exportPrivsGranted = true;
            this.contextActionsDisabled = false;
        };
        ActionBarContext.prototype.isEditSpecActionAvailable = function (actionEval) {
            this.editActionEval = actionEval;
            return actionEval.available && this.editPrivsGranted
                && !!this.specInfo && !!this.specDetails;
        };
        ActionBarContext.prototype.isExportSpecActionAvailable = function (actionDef) {
            return actionDef.available && this.exportPrivsGranted
                && !!this.specDetails && !!this.specXmlText
                && !_.isEmpty(this.specXmlText);
        };
        ActionBarContext.prototype.isDeleteSpecActionAvailable = function (actionDef) {
            return actionDef.available && this.deletePrivsGranted
                && !!this.specInfo && !!this.specDetails;
        };
        ActionBarContext.prototype.isDuplicateSpecActionAvailable = function (actionDef) {
            return actionDef.available && !!this.specInfo && !!this.specDetails;
        };
        return ActionBarContext;
    }());
    var GosCustomizationListService = (function () {
        function GosCustomizationListService($q, dataService, defaultUriSchemeUtil, datagridActionBarService, authorizationService, vuiConstants, i18nService, actionsService) {
            this.$q = $q;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datagridActionBarService = datagridActionBarService;
            this.authorizationService = authorizationService;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.actionsService = actionsService;
            this.INFO_PROPERTY = "info";
            this.CUSTOMIZATION_SPEC_PROPERTY = "customizationSpec";
            this.XML_TEXT_PROPERTY = "specItemXMLText";
            this.MODIFY_SPEC_PRIV = "VirtualMachine.Provisioning.ModifyCustSpecs";
            this.READ_SPEC_PRIV = "VirtualMachine.Provisioning.ReadCustSpecs";
            this.ACTIONS = {
                NEW: {
                    uid: "vsphere.core.vm.gos.customization.new",
                    privs: []
                },
                IMPORT: {
                    uid: "vsphere.core.vm.gos.customization.import",
                    privs: []
                },
                EDIT: {
                    uid: "vsphere.core.vm.gos.customization.edit",
                    privs: [this.MODIFY_SPEC_PRIV, this.READ_SPEC_PRIV]
                },
                DUPLICATE: {
                    uid: "vsphere.core.vm.gos.customization.duplicate",
                    privs: []
                },
                EXPORT: {
                    uid: "vsphere.core.vm.gos.customization.export",
                    privs: [this.READ_SPEC_PRIV]
                },
                DELETE: {
                    uid: "vsphere.core.vm.gos.customization.delete",
                    privs: [this.MODIFY_SPEC_PRIV]
                }
            };
            this.ALL_ACTIONS_PRIVS = _.union(this.ACTIONS.NEW.privs, this.ACTIONS.IMPORT.privs, this.ACTIONS.EDIT.privs, this.ACTIONS.DELETE.privs, this.ACTIONS.DUPLICATE.privs, this.ACTIONS.EXPORT.privs);
            this.VC_NO_ERROR = "noError";
            this.actionsContext = new ActionBarContext();
        }
        /**
         * Retrieves the spec info property for the provided vc Services
         * Formats the retrieved timestamp in a user friendly way
         * Adds the VC name to the retrieved data
         * Sorts the data alphabetically
         * @param vcServices
         * @returns {PromiseLike<CustomizationSpecInfoCustom[]>}
         */
        GosCustomizationListService.prototype.retrieveSpecInfos = function (vcServices) {
            var _this = this;
            var customizationSpecMgrs = [];
            var customizationSpecMgrService = {};
            _.each(vcServices, function (vcService) {
                if (vcService && vcService.content && vcService.content.customizationSpecManager) {
                    var customizationSpecManager = _this.defaultUriSchemeUtil.getVsphereObjectId(vcService.content.customizationSpecManager);
                    // add the VC's customization manager to the array of objects
                    // for which the info property will be retrieved
                    customizationSpecMgrs.push(customizationSpecManager);
                    // set the VC name to the customization manager to be added to
                    // the returned info data for each manager
                    customizationSpecMgrService[customizationSpecManager] = vcService;
                }
            });
            if (customizationSpecMgrs.length > 0) {
                return this.dataService.getPropertiesForObjects(customizationSpecMgrs, [this.INFO_PROPERTY])
                    .then(function (properties) {
                    var specs = [];
                    // retrieve the data for each customization manager
                    _.each(properties, function (data, specManagerId) {
                        var vcSpecs = data.info;
                        var vcService = customizationSpecMgrService[specManagerId];
                        // format the data for each spec
                        vcSpecs = _this.formatSpecsData(vcSpecs, vcService);
                        specs = _.union(specs, vcSpecs);
                    });
                    return _.sortBy(specs, function (spec) {
                        return spec.name.toLowerCase();
                    });
                });
            }
            return this.$q.when([]);
        };
        GosCustomizationListService.prototype.filterVcs = function (vcServices) {
            var _this = this;
            var rootFolderIds = [];
            var promises = {};
            var filteredVcs = [];
            _.each(vcServices, function (vcService) {
                if (vcService && vcService.errorCode === _this.VC_NO_ERROR && vcService.serviceGuid) {
                    var rootFolderId = _this.defaultUriSchemeUtil
                        .getRootFolder(vcService.serviceGuid);
                    promises[rootFolderId] = _this.authorizationService
                        .checkGrantedPrivilege(rootFolderId, _this.READ_SPEC_PRIV);
                    rootFolderIds.push(rootFolderId);
                }
            });
            return this.$q.all(promises).then(function (results) {
                _.each(vcServices, function (vcService) {
                    if (vcService && vcService.serviceGuid) {
                        var rootFolderId = _this.defaultUriSchemeUtil
                            .getRootFolder(vcService.serviceGuid);
                        if (results[rootFolderId]) {
                            filteredVcs.push(vcService);
                        }
                    }
                });
                return filteredVcs;
            });
        };
        /**
         * Formats the retrieved timestamp in a user friendly way
         * Adds the VC name to the retrieved data
         *
         * @param vcSpecs
         * @param vCenterName
         * @returns {CustomizationSpecInfoCustom[]}
         */
        GosCustomizationListService.prototype.formatSpecsData = function (vcSpecs, vcService) {
            _.each(vcSpecs, function (spec) {
                spec.vcService = vcService;
                spec.vCenterName = vcService.name;
            });
            return vcSpecs;
        };
        /**
         * Retrieves the spec details for a customization
         * @param vcService
         * @param customizationName
         * @returns {IPromise<Specification>}
         */
        GosCustomizationListService.prototype.retrieveSpecs = function (vcService, customizationName) {
            var customizationSpecMgr = vcService.content.customizationSpecManager;
            var customizationSpecManager = this.defaultUriSchemeUtil.getVsphereObjectId(customizationSpecMgr);
            var paramCustomizationSpec = new ParamSpec();
            paramCustomizationSpec.propertyName = this.CUSTOMIZATION_SPEC_PROPERTY;
            paramCustomizationSpec.parameterType = "java.lang.String";
            paramCustomizationSpec.parameter = customizationName;
            var paramXmlText = new ParamSpec();
            paramXmlText.propertyName = this.XML_TEXT_PROPERTY;
            paramXmlText.parameterType = "java.lang.String";
            paramXmlText.parameter = customizationName;
            return this.dataService.getProperties(customizationSpecManager, [this.CUSTOMIZATION_SPEC_PROPERTY, this.XML_TEXT_PROPERTY], { propertyParams: [paramCustomizationSpec, paramXmlText] });
        };
        GosCustomizationListService.prototype.invokeEdit = function (specInfo, specDetails, allSpecs, onActionInvoked) {
            if (!specInfo || !specDetails || !onActionInvoked) {
                return;
            }
            var actionEval = this.actionsContext.editActionEval;
            if (!actionEval) {
                return;
            }
            var editAvailable = actionEval.available && this.actionsContext.editPrivsGranted;
            if (!editAvailable) {
                return;
            }
            var editActionContext = {
                gosCustomizationSpecInfo: specInfo,
                gosCustomizationSpecDetails: specDetails,
                gosCustomizationSpecs: allSpecs,
                onActionInvoked: onActionInvoked
            };
            this.actionsService.invokeAction(actionEval, editActionContext);
        };
        GosCustomizationListService.prototype.updateActionBar = function (specsGridOptions, specInfo, specDetails, specXmlText, onActionInvoked, beforeActionInvoked, contextActionsDisabled) {
            var _this = this;
            if (contextActionsDisabled === void 0) { contextActionsDisabled = false; }
            this.actionsContext.specInfo = specInfo;
            this.actionsContext.specDetails = specDetails;
            this.actionsContext.specXmlText = specXmlText;
            this.actionsContext.reset();
            this.actionsContext.contextActionsDisabled = contextActionsDisabled;
            var allActionsPrivCheckPromise;
            if (!this.actionsContext.contextActionsDisabled && this.actionsContext.specInfo) {
                var vcServerGuid = this.actionsContext.specInfo.vcService.serviceGuid;
                var vcRefId = this.defaultUriSchemeUtil.getRootFolder(vcServerGuid);
                allActionsPrivCheckPromise =
                    this.authorizationService.checkPrivileges(vcRefId, this.ALL_ACTIONS_PRIVS);
            }
            else {
                allActionsPrivCheckPromise = this.$q.resolve([]);
            }
            return allActionsPrivCheckPromise.then(function (allPrivStatuses) {
                // Go through all the privilege statuses map them to the actions
                if (allPrivStatuses && allPrivStatuses.length > 0) {
                    _.each(allPrivStatuses, function (status, index) {
                        var currPrivilege = _this.ALL_ACTIONS_PRIVS[index];
                        if (_.contains(_this.ACTIONS.EDIT.privs, currPrivilege)) {
                            _this.actionsContext.editPrivsGranted =
                                _this.actionsContext.editPrivsGranted && status;
                        }
                        if (_.contains(_this.ACTIONS.EXPORT.privs, currPrivilege)) {
                            _this.actionsContext.exportPrivsGranted =
                                _this.actionsContext.exportPrivsGranted && status;
                        }
                        if (_.contains(_this.ACTIONS.DELETE.privs, currPrivilege)) {
                            _this.actionsContext.deletePrivsGranted =
                                _this.actionsContext.deletePrivsGranted && status;
                        }
                    });
                }
                var actionSpecs;
                actionSpecs = [
                    {
                        actionId: _this.ACTIONS.NEW.uid,
                        isActionAvailable: function (actionEval) {
                            return actionEval.available;
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecs: specsGridOptions.data,
                                onActionInvoked: onActionInvoked
                            };
                        }
                    },
                    {
                        actionId: _this.ACTIONS.IMPORT.uid,
                        isActionAvailable: function (actionEval) {
                            return actionEval.available;
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecs: specsGridOptions.data,
                                onActionInvoked: onActionInvoked
                            };
                        }
                    },
                    _this.vuiConstants.actions.SEPARATOR,
                    {
                        actionId: _this.ACTIONS.EDIT.uid,
                        isActionAvailable: function (actionEval) {
                            return !_this.actionsContext.contextActionsDisabled &&
                                _this.actionsContext.isEditSpecActionAvailable(actionEval);
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecInfo: _this.actionsContext.specInfo,
                                gosCustomizationSpecDetails: _this.actionsContext.specDetails,
                                gosCustomizationSpecs: specsGridOptions.data,
                                onActionInvoked: onActionInvoked
                            };
                        }
                    },
                    {
                        actionId: _this.ACTIONS.DUPLICATE.uid,
                        isActionAvailable: function (actionEval) {
                            return !_this.actionsContext.contextActionsDisabled &&
                                _this.actionsContext.isDuplicateSpecActionAvailable(actionEval);
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecInfo: _this.actionsContext.specInfo,
                                gosCustomizationSpecs: specsGridOptions.data,
                                onActionInvoked: onActionInvoked
                            };
                        }
                    },
                    {
                        actionId: _this.ACTIONS.EXPORT.uid,
                        isActionAvailable: function (actionDef) {
                            return !_this.actionsContext.contextActionsDisabled &&
                                _this.actionsContext.isExportSpecActionAvailable(actionDef);
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecInfo: specInfo,
                                gosCustomizationSpecXmlText: specXmlText,
                                gosCustomizationSpecDetails: specDetails
                            };
                        }
                    },
                    {
                        actionId: _this.ACTIONS.DELETE.uid,
                        isActionAvailable: function (actionEval) {
                            return !_this.actionsContext.contextActionsDisabled &&
                                _this.actionsContext.isDeleteSpecActionAvailable(actionEval);
                        },
                        onInvokeAction: function (actionEval) {
                            if (beforeActionInvoked) {
                                beforeActionInvoked();
                            }
                            var text = actionEval.action.confirmationText;
                            if (_this.actionsContext.specInfo && text) {
                                var specName = _this.actionsContext.specInfo.name;
                                text = _this.i18nService.interpolate(text, [specName]);
                                actionEval.action.confirmationText = text;
                            }
                        },
                        getActionInvocationContext: function () {
                            return {
                                gosCustomizationSpecInfo: _this.actionsContext.specInfo,
                                onActionInvoked: onActionInvoked
                            };
                        }
                    }];
                specsGridOptions.actionsOptions = specsGridOptions.actionsOptions || {};
                return _this.datagridActionBarService.updateActionBar(specsGridOptions, [], actionSpecs);
            });
        };
        GosCustomizationListService.$inject = [
            "$q",
            "dataService",
            "defaultUriSchemeUtil",
            "datagridActionBarService",
            "authorizationService",
            "vuiConstants",
            "i18nService",
            "actionsService"];
        return GosCustomizationListService;
    }());
    h5_vm.GosCustomizationListService = GosCustomizationListService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosCustomizationListService", GosCustomizationListService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosAdministratorPasswordPageController = (function () {
        function GosAdministratorPasswordPageController(i18n, $q, clarityModalService) {
            this.i18n = i18n;
            this.$q = $q;
            this.clarityModalService = clarityModalService;
            this.passwordMismatch = false;
        }
        GosAdministratorPasswordPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
        };
        GosAdministratorPasswordPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosAdministratorPasswordPageController.prototype.onPasswordChanged = function () {
            this.model.isPasswordChanged = true;
            this.model.isPreviousPasswordBlank = false;
        };
        GosAdministratorPasswordPageController.prototype.validatePassword = function () {
            this.passwordMismatch = this.model.password !== this.model.confirmedPassword;
        };
        ;
        GosAdministratorPasswordPageController.prototype.onCommit = function () {
            var _this = this;
            if (this.model.password !== this.model.confirmedPassword) {
                this.validatePassword();
                var error = this.i18n.getString("VmUi", "customizationSpec.workgroupDomainPage.errorMessage.passwordsMismatch");
                return this.$q.resolve([error]);
            }
            // If there are no errors last thing to check is
            // if warning for blank password is needed
            if (_.isEmpty(this.model.password) && !this.model.isPreviousPasswordBlank) {
                var deferred_1 = this.$q.defer();
                var modalOptions = {
                    title: this.i18n.getString("VmUi", "customizationSpec.adminPasswordPage.blankPwdWarningTitle"),
                    message: this.i18n.getString("VmUi", "customizationSpec.adminPasswordPage.blankPwdWarning"),
                    submit: function () {
                        deferred_1.resolve(true);
                    },
                    onCancel: function () {
                        deferred_1.resolve(false);
                    },
                    preserveNewlines: true,
                    clarityIcon: {
                        shape: "warning",
                        class: "is-warning",
                        size: 48
                    },
                    saveButtonLabel: this.i18n.getString("Common", "yes.label"),
                    cancelButtonLabel: this.i18n.getString("Common", "no.label")
                };
                this.clarityModalService.openConfirmationModal(modalOptions);
                return deferred_1.promise.then(function (result) {
                    if (result) {
                        _this.model.isPreviousPasswordBlank = true;
                        return _this.$q.when([]);
                    }
                    else {
                        return null;
                    }
                });
            }
            return this.$q.resolve([]);
        };
        GosAdministratorPasswordPageController.$inject = [
            "i18nService",
            "$q",
            "clarityModalService"];
        return GosAdministratorPasswordPageController;
    }());
    h5_vm.GosAdministratorPasswordPageController = GosAdministratorPasswordPageController;
    var GosAdministratorPasswordPageComponent = (function () {
        function GosAdministratorPasswordPageComponent() {
            this.controller = GosAdministratorPasswordPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/administrator-password/gos-administrator-password-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosAdministratorPasswordPageComponent;
    }());
    h5_vm.GosAdministratorPasswordPageComponent = GosAdministratorPasswordPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosAdministratorPasswordPage", new GosAdministratorPasswordPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosAdministratorPasswordPageModel = (function (_super) {
        __extends(GosAdministratorPasswordPageModel, _super);
        function GosAdministratorPasswordPageModel() {
            _super.apply(this, arguments);
        }
        return GosAdministratorPasswordPageModel;
    }(GosBasePageModel));
    h5_vm.GosAdministratorPasswordPageModel = GosAdministratorPasswordPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosCommandsPageController = (function () {
        function GosCommandsPageController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
        }
        GosCommandsPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
        };
        GosCommandsPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosCommandsPageController.prototype.onCommit = function () {
            return this.$q.resolve([]);
        };
        GosCommandsPageController.$inject = [
            "i18nService",
            "$q"];
        return GosCommandsPageController;
    }());
    h5_vm.GosCommandsPageController = GosCommandsPageController;
    var GosCommandsPageComponent = (function () {
        function GosCommandsPageComponent() {
            this.controller = GosCommandsPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/commands/gos-commands-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosCommandsPageComponent;
    }());
    h5_vm.GosCommandsPageComponent = GosCommandsPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosCommandsPage", new GosCommandsPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosCommandsPageModel = (function (_super) {
        __extends(GosCommandsPageModel, _super);
        function GosCommandsPageModel() {
            _super.apply(this, arguments);
        }
        return GosCommandsPageModel;
    }(GosBasePageModel));
    h5_vm.GosCommandsPageModel = GosCommandsPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var ComputerNameOption = (function () {
        function ComputerNameOption(value) {
            this.value = value;
        }
        ComputerNameOption.ENTER_NAME_VALUE = "enterName";
        ComputerNameOption.USE_VM_NAME_VALUE = "useVmName";
        ComputerNameOption.DEPLOY_WIZARD_VALUE = "deployWizard";
        ComputerNameOption.GENERATE_NAME_VALUE = "generateName";
        ComputerNameOption.ENTER_NAME = new ComputerNameOption(ComputerNameOption.ENTER_NAME_VALUE);
        ComputerNameOption.USE_VM_NAME = new ComputerNameOption(ComputerNameOption.USE_VM_NAME_VALUE);
        ComputerNameOption.DEPLOY_WIZARD = new ComputerNameOption(ComputerNameOption.DEPLOY_WIZARD_VALUE);
        ComputerNameOption.GENERATE_NAME = new ComputerNameOption(ComputerNameOption.GENERATE_NAME_VALUE);
        return ComputerNameOption;
    }());
    h5_vm.ComputerNameOption = ComputerNameOption;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = h5_vm.GosType;
    var GosComputerNamePageController = (function () {
        function GosComputerNamePageController($q, defaultUriSchemeUtil, dataService, computerNameValidationService, i18nService) {
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.computerNameValidationService = computerNameValidationService;
            this.i18nService = i18nService;
            this.nameOption = h5_vm.ComputerNameOption;
            this.isNameIpGeneratorDefined = false;
            this.model.onPageCommit = this.onCommit.bind(this);
        }
        GosComputerNamePageController.prototype.i18n = function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return this.i18nService.getString("VmUi", key, args);
        };
        GosComputerNamePageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
            this.invalidNameMessage = "";
            this.invalidDomainMessage = "";
            var computerNameMaxChars;
            if (GosType.WINDOWS === this.model.type) {
                computerNameMaxChars = h5_vm.GosComputerNameValidationService.MAX_CHARS_WIN;
            }
            else if (GosType.LINUX === this.model.type) {
                computerNameMaxChars = h5_vm.GosComputerNameValidationService.MAX_CHARS_LIN;
            }
            else {
                throw new Error("Invalid Guest OS selected.");
            }
            this.useVmNameSignPostMessage = this.i18n("customizationSpec.computerNamePage.useVmName.subscription", computerNameMaxChars);
            this.useVmNameSubscriptionParams = {
                title: this.i18nService.getString("Common", "help"),
                message: this.useVmNameSignPostMessage
            };
            this.enterNameIncludeUniqueNumber = this.i18n("customizationSpec.computerNamePage.enterName.includeUniqueNumber");
            this.enterNameIncludeUniqueNumberSignPostMessage = this.i18n("customizationSpec.computerNamePage.enterName.includeUniqueNumber.subscription", computerNameMaxChars);
            this.enterNameIncludeUniqueNumberSubscriptionParams = {
                title: this.i18nService.getString("Common", "help"),
                message: this.enterNameIncludeUniqueNumberSignPostMessage
            };
            this.getCustomNameAvailabilityIfNeeded();
        };
        GosComputerNamePageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosComputerNamePageController.prototype.onCommit = function () {
            var errors = [];
            errors = errors.concat(this.validateComputerName());
            errors = errors.concat(this.validateDomain());
            this.onNameChanged();
            this.onDomainChanged();
            return this.$q.resolve(errors);
        };
        GosComputerNamePageController.prototype.isLinux = function () {
            return GosType.LINUX === this.model.type;
        };
        GosComputerNamePageController.prototype.validateComputerName = function () {
            if (h5_vm.ComputerNameOption.ENTER_NAME !== this.model.setNameOption) {
                return [];
            }
            var maxLength = this.model.type === GosType.WINDOWS ?
                h5_vm.GosComputerNameValidationService.MAX_CHARS_WIN :
                h5_vm.GosComputerNameValidationService.MAX_CHARS_LIN;
            return this.computerNameValidationService.validateComputerName(maxLength, this.model.computerName);
        };
        GosComputerNamePageController.prototype.onNameChanged = function () {
            this.invalidNameMessage = this.validateComputerName()[0];
        };
        GosComputerNamePageController.prototype.validateDomain = function () {
            if (this.isLinux()) {
                return this.computerNameValidationService.validateDomainName(this.model.domainName);
            }
            return [];
        };
        GosComputerNamePageController.prototype.onDomainChanged = function () {
            this.invalidDomainMessage = this.validateDomain()[0];
        };
        GosComputerNamePageController.prototype.getCustomNameAvailabilityIfNeeded = function () {
            var _this = this;
            if (this.model.isNameIpGeneratorDefined !== undefined) {
                this.isNameIpGeneratorDefined = this.model.isNameIpGeneratorDefined;
                return;
            }
            var vcUri = this.defaultUriSchemeUtil.getRootFolder(this.model.vcServiceGuid);
            this.dataService.getProperties(vcUri, ["isNameIpGeneratorDefined"])
                .then(function (data) {
                if (data) {
                    _this.isNameIpGeneratorDefined = data.isNameIpGeneratorDefined;
                    _this.model.isNameIpGeneratorDefined = data.isNameIpGeneratorDefined;
                }
            });
        };
        GosComputerNamePageController.$inject = ["$q",
            "defaultUriSchemeUtil",
            "dataService",
            "gosComputerNameValidationService",
            "i18nService"];
        GosComputerNamePageController.FQDN_LABEL_MAX_LENGTH = 63;
        GosComputerNamePageController.FQDN_MAX_LENGTH = 255;
        return GosComputerNamePageController;
    }());
    h5_vm.GosComputerNamePageController = GosComputerNamePageController;
    var GosComputerNamePageComponent = (function () {
        function GosComputerNamePageComponent() {
            this.controller = GosComputerNamePageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/computer-name/gos-computer-name-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosComputerNamePageComponent;
    }());
    h5_vm.GosComputerNamePageComponent = GosComputerNamePageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosComputerNamePage", new GosComputerNamePageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosComputerNamePageModel = (function (_super) {
        __extends(GosComputerNamePageModel, _super);
        function GosComputerNamePageModel() {
            _super.apply(this, arguments);
        }
        return GosComputerNamePageModel;
    }(GosBasePageModel));
    h5_vm.GosComputerNamePageModel = GosComputerNamePageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosCustomSysprepFilePageController = (function () {
        function GosCustomSysprepFilePageController($q, i18n, $element, vcService) {
            var _this = this;
            this.$q = $q;
            this.i18n = i18n;
            this.$element = $element;
            this.vcService = vcService;
            this.IMPORT_FILE = h5_vm.CustomSysprepFileOption.IMPORT_FILE;
            this.CREATE_FILE = h5_vm.CustomSysprepFileOption.CREATE_FILE;
            var importSysprep = $element.find(".select-sysprep-file-input");
            // when the file browser is open this event is triggered
            // when `Open` or `Cancel` is pressed
            importSysprep.on("change", function (event) {
                _this.onFileChosen(event);
            });
        }
        GosCustomSysprepFilePageController.prototype.$onInit = function () {
            var _this = this;
            this.model.onPageCommit = this.onCommit.bind(this);
            // default values - in case of some failure or something else
            var answerFileDescKey = "customizationSpec.customSysprepFilePage.pageDirections.postVista";
            var answerFileFilter = ".xml";
            this.vcService.is67VcOrLaterByGuid(this.model.vcServerGuid)
                .then(function (isVc67OrLater) {
                if (!isVc67OrLater) {
                    answerFileDescKey =
                        "customizationSpec.customSysprepFilePage.pageDirections.preVista";
                    answerFileFilter = ".inf, .xml";
                }
            })
                .then(function () {
                _this.sysprepAnswerFileDesc = _this.i18n.getString("VmUi", answerFileDescKey);
                _this.sysprepAnswerFileFilter = answerFileFilter;
            });
        };
        GosCustomSysprepFilePageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosCustomSysprepFilePageController.prototype.onCommit = function () {
            if (this.model.fileOption === h5_vm.CustomSysprepFileOption.IMPORT_FILE) {
                if (_.isEmpty(this.model.sysprepImportFileName)) {
                    var error = this.i18n.getString("VmUi", "customizationSpec.customSysprepFilePage.selectSysprepFile");
                    return this.$q.resolve([error]);
                }
                if (_.isEmpty(this.model.sysprepImportFileContent.trim())) {
                    var error = this.i18n.getString("VmUi", "customizationSpec.customSysprepFilePage.emptySysprepFile");
                    return this.$q.resolve([error]);
                }
            }
            else {
                if (_.isEmpty(this.model.sysprepContent.trim())) {
                    var error = this.i18n.getString("VmUi", "customizationSpec.customSysprepFilePage.insertSysprepText");
                    return this.$q.resolve([error]);
                }
            }
            return this.$q.resolve([]);
        };
        GosCustomSysprepFilePageController.prototype.onBrowseFileClicked = function () {
            var browseFileInput = this.$element.find(".select-sysprep-file-input");
            browseFileInput.click();
        };
        GosCustomSysprepFilePageController.prototype.onFileChosen = function (event) {
            var _this = this;
            if (event.target.files && event.target.files.length > 0) {
                this.model.sysprepImportFileName = event.target.files[0].name;
                this.reader = new FileReader();
                this.reader.readAsText(event.target.files[0]);
                this.reader.onload = function () {
                    _this.model.sysprepContent = _this.reader.result.trim();
                    _this.model.sysprepImportFileContent = _this.model.sysprepContent;
                };
            }
        };
        GosCustomSysprepFilePageController.$inject = [
            "$q", "i18nService", "$element", "vcService"];
        return GosCustomSysprepFilePageController;
    }());
    h5_vm.GosCustomSysprepFilePageController = GosCustomSysprepFilePageController;
    var GosCustomSysprepFilePageComponent = (function () {
        function GosCustomSysprepFilePageComponent() {
            this.controller = GosCustomSysprepFilePageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/custom-sysprep-file/gos-custom-sysprep-file-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosCustomSysprepFilePageComponent;
    }());
    h5_vm.GosCustomSysprepFilePageComponent = GosCustomSysprepFilePageComponent;
    angular
        .module('com.vmware.vsphere.client.vm')
        .component('gosCustomSysprepFilePage', new GosCustomSysprepFilePageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosCustomSysprepFilePageModel = (function (_super) {
        __extends(GosCustomSysprepFilePageModel, _super);
        function GosCustomSysprepFilePageModel() {
            _super.apply(this, arguments);
        }
        return GosCustomSysprepFilePageModel;
    }(GosBasePageModel));
    h5_vm.GosCustomSysprepFilePageModel = GosCustomSysprepFilePageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosDnsSettingsPageController = (function () {
        function GosDnsSettingsPageController($q, ipParser, i18n) {
            this.$q = $q;
            this.ipParser = ipParser;
            this.i18n = i18n;
            this.PRIMARY_DNS = "primary";
            this.SECONDARY_DNS = "secondary";
            this.TERTIARY_DNS = "tertiary";
            this.primaryInvalid = false;
            this.secondaryInvalid = false;
            this.tertiaryInvalid = false;
            this.model.onPageCommit = this.onCommit.bind(this);
        }
        GosDnsSettingsPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
        };
        GosDnsSettingsPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosDnsSettingsPageController.prototype.onCommit = function () {
            var errors = [];
            if (!this.isDnsValid(this.model.primaryDns)
                || !this.isDnsValid(this.model.secondaryDns)
                || !this.isDnsValid(this.model.tertiaryDns)) {
                this.validateDNS(this.PRIMARY_DNS);
                this.validateDNS(this.SECONDARY_DNS);
                this.validateDNS(this.TERTIARY_DNS);
                errors.push(this.i18n.getString("VmUi", "guestOsCustomization.dnsSettingsPage.invalidIpAddress"));
            }
            // TODO: Validate DNS search path if we have network settings type to be CUSTOM
            // and we have an adapter that is not DHCP. We'll have those from the network page mogel.
            // More info on the validation: https://goo.gl/u60I3d
            return this.$q.resolve(errors);
        };
        GosDnsSettingsPageController.prototype.validateDNS = function (dnsNumber) {
            switch (dnsNumber) {
                case this.PRIMARY_DNS:
                    this.primaryInvalid = !this.isDnsValid(this.model.primaryDns);
                    break;
                case this.SECONDARY_DNS:
                    this.secondaryInvalid = !this.isDnsValid(this.model.secondaryDns);
                    break;
                case this.TERTIARY_DNS:
                    this.tertiaryInvalid = !this.isDnsValid(this.model.tertiaryDns);
                    break;
            }
        };
        GosDnsSettingsPageController.prototype.isDnsValid = function (dns) {
            if (dns && !_.isEmpty(dns)
                && !this.ipParser.isIpv4AddressValid(dns)
                && !this.ipParser.isIpv6AddressValid(dns)) {
                return false;
            }
            return true;
        };
        GosDnsSettingsPageController.$inject = ["$q",
            "ipParserService",
            "i18nService"];
        return GosDnsSettingsPageController;
    }());
    h5_vm.GosDnsSettingsPageController = GosDnsSettingsPageController;
    var GosDnsSettingsPageComponent = (function () {
        function GosDnsSettingsPageComponent() {
            this.controller = GosDnsSettingsPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/dns-settings/gos-dns-settings-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosDnsSettingsPageComponent;
    }());
    h5_vm.GosDnsSettingsPageComponent = GosDnsSettingsPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosDnsSettingsPage", new GosDnsSettingsPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosDnsSettingsPageModel = (function (_super) {
        __extends(GosDnsSettingsPageModel, _super);
        function GosDnsSettingsPageModel() {
            _super.apply(this, arguments);
        }
        return GosDnsSettingsPageModel;
    }(GosBasePageModel));
    h5_vm.GosDnsSettingsPageModel = GosDnsSettingsPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var LinuxPrep = com.vmware.vim.binding.vim.vm.customization.LinuxPrep;
    var SysprepText = com.vmware.vim.binding.vim.vm.customization.SysprepText;
    var Sysprep = com.vmware.vim.binding.vim.vm.customization.Sysprep;
    var GosFinishPageController = (function () {
        function GosFinishPageController($q, i18nService, helperService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.helperService = helperService;
            this.i18n = this.i18nService.getString;
        }
        GosFinishPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
            this.nics = this.getNics();
        };
        GosFinishPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosFinishPageController.prototype.getSpecTypeString = function (gosSpecType) {
            return this.helperService.gosTypeToString(gosSpecType);
        };
        GosFinishPageController.prototype.onCommit = function () {
            return this.$q.resolve([]);
        };
        GosFinishPageController.prototype.isLinuxPrep = function () {
            return this.model.specDetails.identity instanceof LinuxPrep;
        };
        GosFinishPageController.prototype.isSysPrep = function () {
            return this.model.specDetails.identity instanceof Sysprep;
        };
        GosFinishPageController.prototype.isSysPrepText = function () {
            return this.model.specDetails.identity instanceof SysprepText;
        };
        GosFinishPageController.prototype.getComputerName = function () {
            return this.helperService.getComputerName(this.model.specDetails);
        };
        GosFinishPageController.prototype.getDomainName = function () {
            return this.helperService.getDomain(this.model.specDetails);
        };
        GosFinishPageController.prototype.getProductKey = function () {
            return this.helperService.getWindowsLicenseKey(this.model.specDetails);
        };
        GosFinishPageController.prototype.isServerLicensingIncluded = function () {
            return this.helperService.isServerLicensingIncluded(this.model.specDetails);
        };
        GosFinishPageController.prototype.getServerLicensingInfo = function () {
            return this.helperService.getServerLicensingInfo(this.model.specDetails);
        };
        GosFinishPageController.prototype.getTimeZone = function () {
            return this.helperService.getTimeZone(this.model.specDetails);
        };
        GosFinishPageController.prototype.getHardwareClock = function () {
            return this.helperService.getHardwareClock(this.model.specDetails);
        };
        GosFinishPageController.prototype.getRegInfoName = function () {
            return this.helperService.getRegistrationInfo(this.model.specDetails);
        };
        GosFinishPageController.prototype.getPrimaryDns = function () {
            return this.helperService.getPrimaryDnsServer(this.model.specDetails);
        };
        GosFinishPageController.prototype.getSecondaryDns = function () {
            return this.helperService.getSecondaryDnsServer(this.model.specDetails);
        };
        GosFinishPageController.prototype.getTertiaryDns = function () {
            return this.helperService.getTertiaryDnsServer(this.model.specDetails);
        };
        GosFinishPageController.prototype.getDnsSuffixList = function () {
            return this.helperService.getDnsSuffixList(this.model.specDetails);
        };
        GosFinishPageController.prototype.getNetworkType = function () {
            return this.helperService.getNetworkTypeString(this.model.specDetails);
        };
        GosFinishPageController.prototype.getLogInType = function () {
            return this.helperService.getLoginType(this.model.specDetails);
        };
        GosFinishPageController.prototype.getAutomaticLogonTimes = function () {
            return this.helperService.getAutomaticLogonTimes(this.model.specDetails);
        };
        GosFinishPageController.prototype.getWorkgroup = function () {
            return this.helperService.getWorkgroup(this.model.specDetails);
        };
        GosFinishPageController.prototype.getDomain = function () {
            return this.helperService.getDomain(this.model.specDetails);
        };
        GosFinishPageController.prototype.getDomainUsername = function () {
            return this.helperService.getDomainUsername(this.model.specDetails);
        };
        GosFinishPageController.prototype.getGenerateNewSIDText = function () {
            var generateNewSID = this.helperService.generateNewSID(this.model.specDetails);
            if (generateNewSID) {
                return this.i18n("VmUi", "customizationManager.customizationSpecDetailsView.generateSID");
            }
            return this.i18n("VmUi", "customizationManager.customizationSpecDetailsView.doNotGenerateSID");
        };
        GosFinishPageController.prototype.getNics = function () {
            if (this.helperService.isNetworkTypical(this.model.specDetails)) {
                return [];
            }
            return this.helperService.getNicIpSettings(this.model.specDetails);
        };
        GosFinishPageController.prototype.getCommands = function () {
            return this.helperService.getCommands(this.model.specDetails);
        };
        GosFinishPageController.$inject = ["$q",
            "i18nService",
            "gosCustomizationHelperService"];
        return GosFinishPageController;
    }());
    h5_vm.GosFinishPageController = GosFinishPageController;
    var GosFinishPageComponent = (function () {
        function GosFinishPageComponent() {
            this.controller = GosFinishPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/finish/gos-finish-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosFinishPageComponent;
    }());
    h5_vm.GosFinishPageComponent = GosFinishPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosFinishPage", new GosFinishPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var CustomizationSpecItem = com.vmware.vim.binding.vim.CustomizationSpecItem;
    var CustomizationSpecInfo = com.vmware.vim.binding.vim.CustomizationSpecInfo;
    var Sysprep = com.vmware.vim.binding.vim.vm.customization.Sysprep;
    var GosFinishPageModel = (function (_super) {
        __extends(GosFinishPageModel, _super);
        function GosFinishPageModel() {
            _super.apply(this, arguments);
        }
        /**
         * Builds a spec for creating/editing a vm customization specification.
         * @return VmCustomizationSpec for creating/editing a vm customization specification
         */
        GosFinishPageModel.prototype.buildSpec = function () {
            var configInfo = new CustomizationSpecInfo();
            configInfo.name = this.specName;
            configInfo.description = this.description;
            switch (this.gosType) {
                case h5_vm.GosType.WINDOWS:
                case h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP:
                    configInfo.type = "Windows";
                    break;
                case h5_vm.GosType.LINUX:
                    configInfo.type = "Linux";
                    break;
                default:
                    configInfo.type = "";
            }
            var specItem = new CustomizationSpecItem();
            specItem.spec = this.specDetails;
            specItem.info = configInfo;
            return specItem;
        };
        GosFinishPageModel.prototype.addWindowsParams = function (vmCustSpec) {
            if (this.gosType !== h5_vm.GosType.WINDOWS) {
                return;
            }
            if (vmCustSpec.config.spec.identity instanceof Sysprep
                && !_.isEmpty(vmCustSpec.config.spec.identity.guiUnattended.password)) {
                vmCustSpec.encryptAdminPassword = this.encryptAdminPassword;
            }
            if (vmCustSpec.config.spec.identity instanceof Sysprep
                && !_.isEmpty(vmCustSpec.config.spec.identity.identification.domainAdminPassword)) {
                vmCustSpec.encryptDomainPassword = this.encryptDomainPassword;
            }
        };
        return GosFinishPageModel;
    }(GosBasePageModel));
    h5_vm.GosFinishPageModel = GosFinishPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosSpecCreatePagesService = (function () {
        function GosSpecCreatePagesService(i18nService, $q, vuiConstants) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.vuiConstants = vuiConstants;
        }
        GosSpecCreatePagesService.prototype.createNameAndOsPage = function (scope, onPageCommit, defaultFlowId, allFlowIds) {
            if (allFlowIds === void 0) { allFlowIds = []; }
            if (!scope.gosNameAndOsPageModel) {
                scope.gosNameAndOsPageModel = new h5_vm.GosNameAndOsPageModel();
            }
            scope.gosNameAndOsPageModel.allSpecs =
                scope.allSpecs;
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.nameAndTargetOsPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/name-and-os/gos-name-and-os-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                decisionOptions: { flowIds: allFlowIds, selectedFlowId: defaultFlowId },
                onCommit: function () {
                    return onPageCommit(scope.gosNameAndOsPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.getWizardFlows = function (wizardScope, onPageCommit) {
            var allPages = this.createAllPages(wizardScope, onPageCommit);
            var flows = [
                {
                    id: h5_vm.GosType.WINDOWS,
                    pages: this.getPagesByType(allPages, h5_vm.GosType.WINDOWS)
                }, {
                    id: h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP,
                    pages: this.getPagesByType(allPages, h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP)
                }, {
                    id: h5_vm.GosType.LINUX,
                    pages: this.getPagesByType(allPages, h5_vm.GosType.LINUX)
                }
            ];
            return flows;
        };
        GosSpecCreatePagesService.prototype.getDialogPages = function (dialogScope, gosType, onPageCommit) {
            var _this = this;
            var flowPages = this.createFlowPages(gosType, dialogScope, onPageCommit);
            var namesAndOsPage = this.createNameAndOsPage(dialogScope, onPageCommit, gosType);
            var restOfPages = flowPages;
            var pages = [];
            pages.push(namesAndOsPage);
            pages = pages.concat(restOfPages);
            pages.forEach(function (page) {
                page.state = _this.vuiConstants.wizard.pageState.COMPLETED;
            });
            return pages;
        };
        GosSpecCreatePagesService.prototype.createFlowPages = function (flow, wizardScope, onPageCommit) {
            if (h5_vm.GosType.WINDOWS === flow) {
                return [
                    this.createRegistrationInformationPage(wizardScope, onPageCommit),
                    this.createComputerNamePage(wizardScope, onPageCommit),
                    this.createWindowsLicensePage(wizardScope, onPageCommit),
                    this.createAdministratorPasswordPage(wizardScope, onPageCommit),
                    this.createTimeZonePage(wizardScope, onPageCommit),
                    this.createCommandsPage(wizardScope, onPageCommit),
                    this.createNetworkPage(wizardScope, onPageCommit),
                    this.createWorkgroupDomainPage(wizardScope, onPageCommit),
                    this.createFinishPage(wizardScope)];
            }
            if (h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP === flow) {
                return [
                    this.createCustomSysprepFilePage(wizardScope, onPageCommit),
                    this.createNetworkPage(wizardScope, onPageCommit),
                    this.createFinishPage(wizardScope)];
            }
            if (h5_vm.GosType.LINUX === flow) {
                return [
                    this.createComputerNamePage(wizardScope, onPageCommit),
                    this.createTimeZonePage(wizardScope, onPageCommit),
                    this.createNetworkPage(wizardScope, onPageCommit),
                    this.createDnsSettingsPage(wizardScope, onPageCommit),
                    this.createFinishPage(wizardScope)];
            }
            throw new Error("Unsupported flow");
        };
        GosSpecCreatePagesService.prototype.createAllPages = function (wizardScope, onPageCommit) {
            return {
                customSysprepFilePage: this.createCustomSysprepFilePage(wizardScope, onPageCommit),
                registrationInformationPage: this.createRegistrationInformationPage(wizardScope, onPageCommit),
                computerNamePage: this.createComputerNamePage(wizardScope, onPageCommit),
                windowsLicensePage: this.createWindowsLicensePage(wizardScope, onPageCommit),
                administratorPasswordPage: this.createAdministratorPasswordPage(wizardScope, onPageCommit),
                timeZonePage: this.createTimeZonePage(wizardScope, onPageCommit),
                commandsPage: this.createCommandsPage(wizardScope, onPageCommit),
                networkPage: this.createNetworkPage(wizardScope, onPageCommit),
                workgroupDomainPage: this.createWorkgroupDomainPage(wizardScope, onPageCommit),
                dnsSettingsPage: this.createDnsSettingsPage(wizardScope, onPageCommit),
                finishPage: this.createFinishPage(wizardScope)
            };
        };
        GosSpecCreatePagesService.prototype.getPagesByType = function (allPages, specType) {
            // Plug your pages here.
            if (h5_vm.GosType.WINDOWS === specType) {
                return [
                    allPages.registrationInformationPage,
                    allPages.computerNamePage,
                    allPages.windowsLicensePage,
                    allPages.administratorPasswordPage,
                    allPages.timeZonePage,
                    allPages.commandsPage,
                    allPages.networkPage,
                    allPages.workgroupDomainPage,
                    allPages.finishPage
                ];
            }
            if (h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP === specType) {
                return [
                    allPages.customSysprepFilePage,
                    allPages.networkPage,
                    allPages.finishPage
                ];
            }
            if (h5_vm.GosType.LINUX === specType) {
                return [
                    allPages.computerNamePage,
                    allPages.timeZonePage,
                    allPages.networkPage,
                    allPages.dnsSettingsPage,
                    allPages.finishPage
                ];
            }
            throw new Error("Unsupported flow");
        };
        GosSpecCreatePagesService.prototype.createComputerNamePage = function (scope, onPageCommit) {
            if (!scope.computerNamePageModel) {
                scope.computerNamePageModel = new h5_vm.GosComputerNamePageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.computerNamePage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.computerNamePage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/computer-name/gos-computer-name-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.computerNamePageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createWindowsLicensePage = function (scope, onPageCommit) {
            if (!scope.windowsLicensePageModel) {
                scope.windowsLicensePageModel = new h5_vm.GosWindowsLicensePageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.windowsLicensePage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.windowsLicensePage.pageInfoNew"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/windows-license/gos-windows-license-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.windowsLicensePageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createDnsSettingsPage = function (scope, onPageCommit) {
            if (!scope.dnsSettingsPageModel) {
                scope.dnsSettingsPageModel = new h5_vm.GosDnsSettingsPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.dnsSettingsPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.dnsDomainSettingsPage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/dns-settings/gos-dns-settings-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.dnsSettingsPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createCustomSysprepFilePage = function (scope, onPageCommit) {
            if (!scope.customSysprepFilePageModel) {
                scope.customSysprepFilePageModel = new h5_vm.GosCustomSysprepFilePageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.customSysPrepPagePage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.customSysprepFilePage.pageInfoNew"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/custom-sysprep-file/gos-custom-sysprep-file-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.customSysprepFilePageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createRegistrationInformationPage = function (scope, onPageCommit) {
            if (!scope.registrationInformationPageModel) {
                scope.registrationInformationPageModel = new h5_vm.GosRegistrationInformationPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.registrationInformationPage.title"),
                description: this.i18nService.getString("VmUi", "guestOsCustomization.new.registrationInformationPage.Description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/registration-information/gos-registration-information-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.registrationInformationPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createTimeZonePage = function (scope, onPageCommit) {
            if (!scope.timeZonePageModel) {
                scope.timeZonePageModel = new h5_vm.GosTimeZonePageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.timeZonePage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.timeZonePage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/time-zone/gos-time-zone-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.timeZonePageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createNetworkPage = function (scope, onPageCommit) {
            if (!scope.networkPageModel) {
                scope.networkPageModel = new h5_vm.GosNetworkPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.networkPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.networkPage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/network/gos-network-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.networkPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createFinishPage = function (scope) {
            if (!scope.finishPageModel) {
                scope.finishPageModel = new h5_vm.GosFinishPageModel();
            }
            var page = {
                title: this.i18nService.getString("CommonUi", "SummaryPage.title"),
                description: this.i18nService.getString("CommonUi", "SummaryPage.description"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/finish/gos-finish-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return true;
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createAdministratorPasswordPage = function (scope, onPageCommit) {
            if (!scope.administratorPasswordPageModel) {
                scope.administratorPasswordPageModel = new h5_vm.GosAdministratorPasswordPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.administratorPasswordPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.adminPasswordPage.pageInfoNew"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/administrator-password/gos-administrator-password-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.administratorPasswordPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createCommandsPage = function (scope, onPageCommit) {
            if (!scope.commandsPageModel) {
                scope.commandsPageModel = new h5_vm.GosCommandsPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.runOnceCommandsPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.runOncePage.pageInfoNew"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/commands/gos-commands-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.commandsPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.prototype.createWorkgroupDomainPage = function (scope, onPageCommit) {
            if (!scope.workgroupDomainPageModel) {
                scope.workgroupDomainPageModel = new h5_vm.GosWorkgroupDomainPageModel();
            }
            var page = {
                title: this.i18nService.getString("VmUi", "guestOsCustomization.workGroupOrDomainPage.title"),
                description: this.i18nService.getString("VmUi", "customizationSpec.workgroupDomainPage.pageInfoNew"),
                contentUrl: "vm-ui/resources/vm/guest-os-customization/pages/workgroup-domain/gos-workgroup-domain-page.html",
                state: this.vuiConstants.wizard.pageState.INCOMPLETE,
                onCommit: function () {
                    return onPageCommit(scope.workgroupDomainPageModel);
                }
            };
            return page;
        };
        GosSpecCreatePagesService.$inject = ["i18nService", "$q", "vuiConstants"];
        return GosSpecCreatePagesService;
    }());
    h5_vm.GosSpecCreatePagesService = GosSpecCreatePagesService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosSpecCreatePagesService", GosSpecCreatePagesService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosType = h5_vm.GosType;
    var GosNameAndOsPageController = (function () {
        function GosNameAndOsPageController($q, i18nService, userSessionService, gosSpecValidationService, gosNameAndOsValidationService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.userSessionService = userSessionService;
            this.gosSpecValidationService = gosSpecValidationService;
            this.gosNameAndOsValidationService = gosNameAndOsValidationService;
            this.i18n = i18nService.getString;
        }
        GosNameAndOsPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
            if (this.model.isEditMode && !this.model.originalSpecName) {
                this.model.originalSpecName = this.model.specName;
            }
            this.specTypeOptions = this.initializeSpecTypeOptions();
            this.selectedSpecType = this.getInitialSpecTypeOption();
            this.retrieveVcOptions();
            this.isSysprepTextType =
                GosType.WINDOWS_CUSTOM_SYSPREP.value === this.model.gosType.value;
        };
        GosNameAndOsPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosNameAndOsPageController.prototype.onCommit = function () {
            var nameError = this.gosSpecValidationService.validateName(this.model.specName, true, this.onlyOtherSpecs(), this.selectedVc ? this.selectedVc.name : "");
            if (this.model.isEditMode) {
                return this.$q.resolve(nameError ? [nameError] : []);
            }
            return this.$q.all([
                this.$q.resolve(nameError),
                this.gosNameAndOsValidationService
                    .checkCreateNewGosSpecPrivileges(this.selectedVc)
            ]).then(function (results) { return _.without(_.flatten(results), ""); });
        };
        GosNameAndOsPageController.prototype.onSpecTypeChange = function () {
            var newType;
            if (this.isLinuxprepType()) {
                newType = GosType.LINUX;
            }
            else {
                newType = this.isSysprepTextType
                    ? GosType.WINDOWS_CUSTOM_SYSPREP
                    : GosType.WINDOWS;
            }
            this.model.gosType = newType;
        };
        GosNameAndOsPageController.prototype.isLinuxprepType = function () {
            return this.selectedSpecType
                ? GosType.LINUX.value === this.selectedSpecType.type.value
                : false;
        };
        GosNameAndOsPageController.prototype.onVcChange = function () {
            this.model.vc = this.selectedVc;
        };
        GosNameAndOsPageController.prototype.onSysprepTypeChange = function () {
            var specType = this.isSysprepTextType
                ? GosType.WINDOWS_CUSTOM_SYSPREP
                : GosType.WINDOWS;
            this.model.gosType = specType;
        };
        GosNameAndOsPageController.prototype.isSysprepTextDisabled = function () {
            return this.model.isEditMode || this.isLinuxprepType();
        };
        GosNameAndOsPageController.prototype.validateSpecName = function () {
            this.invalidMessage = this.gosSpecValidationService.validateName(this.model.specName, false, this.onlyOtherSpecs(), this.selectedVc ? this.selectedVc.name : "");
        };
        GosNameAndOsPageController.prototype.onlyOtherSpecs = function () {
            var _this = this;
            if (!this.model.allSpecs) {
                return undefined;
            }
            return this.model.allSpecs
                .filter(function (spec) {
                return spec.name !== _this.model.originalSpecName;
            });
        };
        GosNameAndOsPageController.prototype.initializeSpecTypeOptions = function () {
            return [
                {
                    label: this.i18n("VmUi", "customizationSpec.nameAndOsPage.specTypeWindows"),
                    type: GosType.WINDOWS
                },
                {
                    label: this.i18n("VmUi", "customizationSpec.nameAndOsPage.specTypeLinux"),
                    type: GosType.LINUX
                }
            ];
        };
        /**
         * Retrieve all the registered VCs
         * Sets the first one as the selected.
         */
        GosNameAndOsPageController.prototype.retrieveVcOptions = function () {
            var _this = this;
            this.userSessionService.getAllServersInfo().then(function (info) {
                _this.vcOptions = info.serversInfo;
                if (_this.vcOptions && _this.vcOptions.length > 0) {
                    _this.selectedVc = _this.choosePreselectedVc(_this.vcOptions, _this.model);
                    _this.model.vc = _this.selectedVc;
                }
            });
        };
        GosNameAndOsPageController.prototype.getInitialSpecTypeOption = function () {
            var _this = this;
            return _.find(this.specTypeOptions, function (option) {
                switch (option.type) {
                    case GosType.LINUX:
                        return _this.model.gosType === GosType.LINUX;
                    case GosType.WINDOWS:
                        return _this.model.gosType === GosType.WINDOWS ||
                            _this.model.gosType === GosType.WINDOWS_CUSTOM_SYSPREP;
                    default:
                        return false;
                }
            });
        };
        GosNameAndOsPageController.prototype.choosePreselectedVc = function (vcInfos, model) {
            if (!vcInfos || vcInfos.length < 1) {
                return undefined;
            }
            if (model.vc) {
                return model.vc;
            }
            else {
                return vcInfos[0];
            }
        };
        GosNameAndOsPageController.$inject = ["$q",
            "i18nService",
            "userSessionService",
            "gosSpecValidationService",
            "gosNameAndOsValidationService"];
        return GosNameAndOsPageController;
    }());
    h5_vm.GosNameAndOsPageController = GosNameAndOsPageController;
    var GosNameAndOsPageComponent = (function () {
        function GosNameAndOsPageComponent() {
            this.controller = GosNameAndOsPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/name-and-os/gos-name-and-os-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosNameAndOsPageComponent;
    }());
    h5_vm.GosNameAndOsPageComponent = GosNameAndOsPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosNameAndOsPage", new GosNameAndOsPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosNameAndOsPageModel = (function (_super) {
        __extends(GosNameAndOsPageModel, _super);
        function GosNameAndOsPageModel() {
            _super.apply(this, arguments);
            this.isEditMode = false;
        }
        Object.defineProperty(GosNameAndOsPageModel.prototype, "gosType", {
            get: function () {
                return this.type;
            },
            set: function (value) {
                this.type = value;
                if (this.gosTypeChanged) {
                    this.gosTypeChanged(this.type);
                }
            },
            enumerable: true,
            configurable: true
        });
        return GosNameAndOsPageModel;
    }(GosBasePageModel));
    h5_vm.GosNameAndOsPageModel = GosNameAndOsPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosNameAndOsValidationService = (function () {
        function GosNameAndOsValidationService($q, i18nService, authorizationService, defaultUriSchemeUtil, mutationService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.authorizationService = authorizationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
        }
        /**
         * @param vcInfo - the info of the VC which privileges will be checked
         * @returns a promise that resolves to an array of errors (strings)
         */
        GosNameAndOsValidationService.prototype.checkCreateNewGosSpecPrivileges = function (vcInfo) {
            var _this = this;
            if (!vcInfo || !vcInfo.serviceGuid) {
                return this.$q.resolve(["vcInfo invalid"]);
            }
            var vcUri = this.defaultUriSchemeUtil.getRootFolder(vcInfo.serviceGuid);
            return this.authorizationService.checkPrivileges(vcUri, [
                "VirtualMachine.Provisioning.ModifyCustSpecs",
                "VirtualMachine.Provisioning.ReadCustSpecs"]).then(function (results) {
                var hasModifyPrivilege = results[0];
                var hasReadPrivilege = results[1];
                if (!hasModifyPrivilege || !hasReadPrivilege) {
                    return _this.$q.resolve([
                        _this.i18nService.getString("VmUi", "customizationSpec.nameAndOsPage.noPrivileges")
                    ]);
                }
                return _this.$q.resolve([]);
            });
        };
        GosNameAndOsValidationService.$inject = ["$q",
            "i18nService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "mutationService"];
        return GosNameAndOsValidationService;
    }());
    h5_vm.GosNameAndOsValidationService = GosNameAndOsValidationService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosNameAndOsValidationService", GosNameAndOsValidationService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DhcpIpV6Generator = com.vmware.vim.binding.vim.vm.customization.DhcpIpV6Generator;
    var EditDnsTabController = (function () {
        function EditDnsTabController(i18nService, gosSpecNetworkService, ipParser) {
            var _this = this;
            this.i18nService = i18nService;
            this.gosSpecNetworkService = gosSpecNetworkService;
            this.ipParser = ipParser;
            this.OPTION_TYPE_DHCP = "useDhcp";
            this.OPTION_DNS_MANUAL = "dnsManual";
            this.IPV4_TYPE_DHCP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP;
            this.PREFERRED_DNS = "preferredDns";
            this.ALTERNATE_DNS = "alternateDns";
            this.TITLE_LOCALE = "customizationSpec.networkPage.properties.dns.pageTitle";
            this.validationErrors = {};
            this.populateData = function () {
                var adapter = _this.adapterMapping.adapter;
                // Enable DCHP only if IPv4 or IPv6 uses DCHP
                _this.isDhcpEnabled = (adapter.ip._type === _this.IPV4_TYPE_DHCP);
                if (adapter.ipV6Spec && adapter.ipV6Spec.ip && adapter.ipV6Spec.ip.length
                    && adapter.ipV6Spec.ip[0] instanceof DhcpIpV6Generator) {
                    _this.isDhcpEnabled = true;
                }
                var dnsServerList = adapter.dnsServerList;
                if (dnsServerList && dnsServerList.length) {
                    _this.dnsType = _this.OPTION_DNS_MANUAL;
                    _this.preferredDns = dnsServerList[0];
                    if (dnsServerList.length > 1) {
                        _this.alternateDns = dnsServerList[1];
                    }
                }
                else if (_this.isDhcpEnabled) {
                    _this.dnsType = _this.OPTION_TYPE_DHCP;
                }
                else {
                    _this.dnsType = _this.OPTION_DNS_MANUAL;
                }
            };
            this.i18n = this.i18nService.getString;
            this.adapterMapping = this.adapterWrapper.adapterMapping;
            this.populateData();
            this.updateDnsTab = function () {
                _this.updateData();
                _this.populateData();
            };
            this.editDns = function () {
                _this.updateData();
            };
        }
        EditDnsTabController.prototype.updateData = function () {
            var dnsServers = [];
            if (this.dnsType === this.OPTION_DNS_MANUAL) {
                if (this.preferredDns) {
                    dnsServers.push(this.getNormalizedDnsAddress(this.preferredDns));
                }
                if (this.alternateDns) {
                    dnsServers.push(this.getNormalizedDnsAddress(this.alternateDns));
                }
            }
            this.adapterMapping.adapter.dnsServerList = dnsServers;
        };
        EditDnsTabController.prototype.getNormalizedDnsAddress = function (address) {
            var isValid = this.ipParser.isIpv4AddressValid(address);
            if (!isValid) {
                return address;
            }
            var addr = ipaddr.parse(address);
            return addr.toString();
        };
        EditDnsTabController.prototype.dnsTypeChanged = function () {
            this.validationErrors = {};
            if (this.dnsType === this.OPTION_DNS_MANUAL) {
                this.validateDns(this.PREFERRED_DNS);
                this.validateDns(this.ALTERNATE_DNS);
            }
            else {
                this.setValidationErrors(true);
            }
        };
        EditDnsTabController.prototype.setValidationErrors = function (isValid) {
            var _this = this;
            if (!isValid && !_.contains(this.submitErrors, this.TITLE_LOCALE)) {
                this.submitErrors.push(this.TITLE_LOCALE);
            }
            else if (isValid) {
                var index = _.findIndex(this.submitErrors, function (currentError) {
                    return currentError === _this.TITLE_LOCALE;
                });
                if (index < 0) {
                    return;
                }
                this.submitErrors.splice(index, 1);
            }
        };
        EditDnsTabController.prototype.validateDns = function (dnsType) {
            var address = dnsType === this.PREFERRED_DNS ? this.preferredDns : this.alternateDns;
            var isValid = !address || this.ipParser.isAddressValid(address);
            if (!isValid) {
                this.validationErrors[dnsType] =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.dns.error.address");
            }
            else {
                this.validationErrors[dnsType] = null;
            }
            if (this.validationErrors.preferredDns || this.validationErrors.alternateDns) {
                this.setValidationErrors(false);
            }
            else {
                this.setValidationErrors(true);
            }
        };
        EditDnsTabController.$inject = ["i18nService", "gosSpecNetworkService", "ipParserService"];
        return EditDnsTabController;
    }());
    var EditDnsTabComponent = (function () {
        function EditDnsTabComponent() {
            this.bindings = {
                adapterWrapper: "<",
                dnsSuffixList: "=",
                updateDnsTab: "=",
                submitErrors: "=",
                editDns: "=",
                refreshGridData: "="
            };
            this.controller = EditDnsTabController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/pages/network/edit/dns-tab/edit-dns-tab.component.html";
        }
        return EditDnsTabComponent;
    }());
    h5_vm.EditDnsTabComponent = EditDnsTabComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("editDnsTab", new EditDnsTabComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosNetworkPageEditController = (function () {
        function GosNetworkPageEditController(i18nService, vuiConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.DNS_TITLE = "customizationSpec.networkPage.properties.dns.pageTitle";
            this.IPV4_TITLE = "customizationSpec.networkPage.properties.ipv4.pageTitle";
            this.IPV6_TITLE = "customizationSpec.networkPage.properties.ipv6.pageTitle";
            this.WINS_TITLE = "customizationSpec.networkPage.properties.wins.pageTitle";
            this.refreshGridData = function () { };
            this.i18n = this.i18nService.getString;
            this.validationErrors = [];
            this.onSubmit = function () {
                if (!_this.validateTabs()) {
                    var alert_1 = {
                        type: _this.vuiConstants.validationBanner.type.ERROR,
                        text: _this.i18n("VmUi", "customizationSpecWizard.pageValidationError")
                    };
                    _this.alerts = [alert_1];
                    return false;
                }
                _this.editNic();
                return true;
            };
        }
        GosNetworkPageEditController.prototype.$doCheck = function () {
            this.submitDisabled = this.validationErrors && this.validationErrors.length > 0;
        };
        GosNetworkPageEditController.prototype.isGosWindows = function () {
            return this.customizationSpecType === h5_vm.GosType.WINDOWS
                || this.customizationSpecType === h5_vm.GosType.WINDOWS_CUSTOM_SYSPREP;
        };
        GosNetworkPageEditController.prototype.showTabError = function (tabTitle) {
            return _.some(this.validationErrors, function (tab) {
                return tab === tabTitle;
            });
        };
        GosNetworkPageEditController.prototype.onTabSelected = function (index) {
            if (index === 2) {
                this.refreshGridData();
            }
        };
        GosNetworkPageEditController.prototype.validateTabs = function () {
            var IP_4_IS_VALID = this.editIpv4();
            var IP_6_IS_VALID = this.editIpv6();
            var WINS_IS_VALID = this.isGosWindows() ? this.editWins() : true;
            if (this.isGosWindows()) {
                this.editDns();
            }
            return IP_4_IS_VALID && IP_6_IS_VALID && WINS_IS_VALID;
        };
        GosNetworkPageEditController.$inject = ["i18nService", "vuiConstants"];
        return GosNetworkPageEditController;
    }());
    h5_vm.GosNetworkPageEditController = GosNetworkPageEditController;
    var GosNetworkPageEditComponent = (function () {
        function GosNetworkPageEditComponent() {
            this.bindings = {
                adapterWrapper: "<",
                customizationSpecType: "<",
                isNameIpGeneratorDefined: "<",
                editNic: "<",
                alerts: "=",
                onSubmit: "=",
                validationErrors: "=",
                submitDisabled: "=",
                dnsSuffixList: "="
            };
            this.controller = GosNetworkPageEditController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/pages/network/edit/gos-network-page-edit.component.html";
        }
        return GosNetworkPageEditComponent;
    }());
    h5_vm.GosNetworkPageEditComponent = GosNetworkPageEditComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("gosNetworkPageEdit", new GosNetworkPageEditComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DhcpIpGenerator = com.vmware.vim.binding.vim.vm.customization.DhcpIpGenerator;
    var UnknownIpGenerator = com.vmware.vim.binding.vim.vm.customization.UnknownIpGenerator;
    var CustomIpGenerator = com.vmware.vim.binding.vim.vm.customization.CustomIpGenerator;
    var FixedIp = com.vmware.vim.binding.vim.vm.customization.FixedIp;
    var EditIpv4TabController = (function () {
        function EditIpv4TabController(i18nService, gosSpecNetworkService, ipParser) {
            var _this = this;
            this.i18nService = i18nService;
            this.gosSpecNetworkService = gosSpecNetworkService;
            this.ipParser = ipParser;
            this.ADAPTER_TYPE_DHCP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP;
            this.ADAPTER_TYPE_UNKNOWUN_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP;
            this.ADAPTER_TYPE_CUSTOM_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP;
            this.ADAPTER_TYPE_FIXED_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP;
            this.FIXED_IP_ADDRESS = "fixedIpAddress";
            this.SUBNET_MASK = "subnetMask";
            this.DEFAULT_GATEWAY = "defaultGateway";
            this.ALTERNATE_GATEWAY = "alternateGateway";
            this.TITLE_LOCALE = "customizationSpec.networkPage.properties.ipv4.pageTitle";
            this.validationErrors = {};
            this.i18n = this.i18nService.getString;
            this.adapterMapping = this.adapterWrapper.adapterMapping;
            this.ipv4Type = this.adapterMapping.adapter.ip._type;
            this.populateData();
            this.setSubnetAndGatewayDisabled();
            this.editIpv4 = function () {
                return _this.preSubmit();
            };
        }
        EditIpv4TabController.prototype.setIPv4Generator = function () {
            switch (this.ipv4Type) {
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP:
                    this.adapterMapping.adapter.ip = new DhcpIpGenerator();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP:
                    this.adapterMapping.adapter.ip = new UnknownIpGenerator();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP:
                    var customIpGenerator = new CustomIpGenerator();
                    customIpGenerator.argument = "";
                    this.adapterMapping.adapter.ip = customIpGenerator;
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP:
                    var fixedIp = new FixedIp();
                    fixedIp.ipAddress = "";
                    this.adapterMapping.adapter.ip = fixedIp;
                    break;
            }
            if (this.ipv4Type !== h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP) {
                this.clearFixedValidations();
            }
            if (this.ipv4Type !== h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP
                && this.ipv4Type !== h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP) {
                this.clearGeneralValidations();
            }
            this.setSubnetAndGatewayDisabled();
            this.setValidationErrors(this.preSubmit());
            if (this.updateDnsTab && typeof this.updateDnsTab === "function") {
                this.updateDnsTab();
            }
        };
        EditIpv4TabController.prototype.validateIPv4 = function (ip, type) {
            switch (type) {
                case this.FIXED_IP_ADDRESS:
                    this.validationErrors["ipv4Error"] = this.validateIPv4Internal(ip, true);
                    break;
                case this.SUBNET_MASK:
                    var required = this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP;
                    this.validationErrors["subnetMaskError"] = this.validateIPv4Internal(ip, required, "mask");
                    break;
                case this.DEFAULT_GATEWAY:
                    this.validationErrors["defaultGatewayError"] = this.validateIPv4Internal(ip, false);
                    break;
                case this.ALTERNATE_GATEWAY:
                    this.validationErrors["alternateGatewayError"] = this.validateIPv4Internal(ip, false);
                    break;
            }
            this.setValidationErrors(this.preSubmit());
        };
        EditIpv4TabController.prototype.setValidationErrors = function (isValid) {
            if (!isValid && !_.contains(this.submitErrors, this.TITLE_LOCALE)) {
                this.submitErrors.push(this.TITLE_LOCALE);
            }
            else if (isValid) {
                this.submitErrors = _.without(this.submitErrors, this.TITLE_LOCALE);
            }
        };
        EditIpv4TabController.prototype.clearFixedValidations = function () {
            this.validationErrors["ipv4Error"] = "";
            this.clearGeneralValidations();
        };
        EditIpv4TabController.prototype.clearGeneralValidations = function () {
            this.validationErrors["subnetMaskError"] = "";
            this.validationErrors["defaultGatewayError"] = "";
            this.validationErrors["alternateGatewayError"] = "";
        };
        EditIpv4TabController.prototype.showFixedValidations = function () {
            this.validationErrors["ipv4Error"] = this.validateIPv4Internal(this.ipAddress, true);
            return this.showGeneralValidations() && !this.validationErrors["ipv4Error"];
        };
        EditIpv4TabController.prototype.showGeneralValidations = function () {
            var required = this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP;
            this.validationErrors["subnetMaskError"] = this.validateIPv4Internal(this.subnetMask, required, "mask");
            this.validationErrors["defaultGatewayError"] = this.validateIPv4Internal(this.defaultGateway, false);
            this.validationErrors["alternateGatewayError"] = this.validateIPv4Internal(this.alternateGateway, false);
            var valid = _.all(this.validationErrors, function (validationError) {
                return !validationError;
            });
            return valid;
        };
        EditIpv4TabController.prototype.validateIPv4Internal = function (ip, required, field) {
            var locale = "customizationSpec.networkPage.properties.ipv4.error.";
            locale += (field !== undefined) ? field : "address";
            if (!ip) {
                return required ? this.i18n("VmUi", locale) : "";
            }
            if (!this.ipParser.isIpv4AddressValid(ip)) {
                return this.i18n("VmUi", locale);
            }
            if (field === "mask" && !this.ipParser.isSubnetMaskValid(ip)) {
                return this.i18n("VmUi", locale);
            }
            return "";
        };
        EditIpv4TabController.prototype.preSubmit = function () {
            var isValid = true;
            if (this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP) {
                isValid = this.showFixedValidations();
            }
            if (this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP
                || this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP) {
                isValid = this.showGeneralValidations();
            }
            if (!isValid) {
                return false;
            }
            this.updateData();
            return true;
        };
        /**
         * Set the data from the input fields into the adapter
         */
        EditIpv4TabController.prototype.updateData = function () {
            switch (this.ipv4Type) {
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP:
                    this.adapterMapping.adapter.subnetMask = "";
                    this.adapterMapping.adapter.gateway = [];
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP:
                    this.adapterMapping.adapter.ip.argument = this.argument;
                    this.updateSubnetAndGatewayData();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP:
                    this.updateSubnetAndGatewayData();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP:
                    // convert the ip into readable valid decimal value
                    this.ipAddress = ipaddr.parse(this.ipAddress).toString();
                    this.adapterMapping.adapter.ip.ipAddress = this.ipAddress;
                    this.updateSubnetAndGatewayData();
            }
            this.adapterWrapper.ipV4Address = this.gosSpecNetworkService.getIPv4NicSettingSummary(this.adapterMapping.adapter.ip);
        };
        EditIpv4TabController.prototype.populateData = function () {
            switch (this.ipv4Type) {
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP:
                    this.populateSubnetAndGatewayData();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP:
                    this.argument = this.adapterMapping.adapter.ip.argument;
                    this.populateSubnetAndGatewayData();
                    break;
                case h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP:
                    this.ipAddress = this.adapterMapping.adapter.ip.ipAddress;
                    this.populateSubnetAndGatewayData();
                    break;
            }
        };
        EditIpv4TabController.prototype.updateSubnetAndGatewayData = function () {
            if (this.subnetMask) {
                this.subnetMask = ipaddr.parse(this.subnetMask).toString();
            }
            this.adapterMapping.adapter.subnetMask = this.subnetMask;
            var gateways = [];
            if (this.defaultGateway) {
                this.defaultGateway = ipaddr.parse(this.defaultGateway).toString();
                gateways.push(this.defaultGateway);
            }
            if (this.alternateGateway) {
                this.alternateGateway = ipaddr.parse(this.alternateGateway).toString();
                gateways.push(this.alternateGateway);
            }
            this.adapterMapping.adapter.gateway = gateways;
        };
        EditIpv4TabController.prototype.populateSubnetAndGatewayData = function () {
            if (this.adapterMapping.adapter.subnetMask) {
                this.subnetMask = this.adapterMapping.adapter.subnetMask;
            }
            var gateways = this.adapterMapping.adapter.gateway;
            if (gateways && gateways.length > 0) {
                if (gateways[0]) {
                    this.defaultGateway = gateways[0];
                }
                if (gateways[1]) {
                    this.alternateGateway = gateways[1];
                }
            }
        };
        EditIpv4TabController.prototype.setSubnetAndGatewayDisabled = function () {
            this.subnetAndGatewayDisabled = this.ipv4Type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP;
        };
        EditIpv4TabController.$inject = ["i18nService", "gosSpecNetworkService", "ipParserService"];
        return EditIpv4TabController;
    }());
    var EditIpv4TabComponent = (function () {
        function EditIpv4TabComponent() {
            this.bindings = {
                adapterWrapper: "<",
                isNameIpGeneratorDefined: "<",
                editIpv4: "=",
                updateDnsTab: "=",
                submitErrors: "=",
            };
            this.controller = EditIpv4TabController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/pages/network/edit/ipv4-tab/edit-ipv4-tab.component.html";
        }
        return EditIpv4TabComponent;
    }());
    h5_vm.EditIpv4TabComponent = EditIpv4TabComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("editIpv4Tab", new EditIpv4TabComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DhcpIpV6Generator = com.vmware.vim.binding.vim.vm.customization.DhcpIpV6Generator;
    var IPSettings$IpV6AddressSpec = com.vmware.vim.binding.vim.vm.customization.IPSettings$IpV6AddressSpec;
    var FixedIpV6 = com.vmware.vim.binding.vim.vm.customization.FixedIpV6;
    var UnknownIpV6Generator = com.vmware.vim.binding.vim.vm.customization.UnknownIpV6Generator;
    var CustomIpV6Generator = com.vmware.vim.binding.vim.vm.customization.CustomIpV6Generator;
    var EditIpv6TabController = (function () {
        function EditIpv6TabController(i18nService, gosSpecNetworkService, ipParser) {
            var _this = this;
            this.i18nService = i18nService;
            this.gosSpecNetworkService = gosSpecNetworkService;
            this.ipParser = ipParser;
            this.DO_NOT_USE_IPV6 = "doNotUseIpv6";
            this.ADAPTER_TYPE_DHCP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP_V6;
            this.ADAPTER_TYPE_UNKNOWUN_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP_V6;
            this.ADAPTER_TYPE_CUSTOM_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP_V6;
            this.ADAPTER_TYPE_FIXED_IP = h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP_V6;
            this.TITLE_LOCALE = "customizationSpec.networkPage.properties.ipv6.pageTitle";
            this.gridAddressesOptions = {};
            this.gridGatewaysOptions = {};
            this.gateways = [];
            this.validationErrors = {};
            this.ipAddressesList = [];
            this.i18n = this.i18nService.getString;
            this.adapterMapping = this.adapterWrapper.adapterMapping;
            this.ipv6Type = this.getSpecType();
            this.populateData();
            this.initGrids();
            this.editIpv6 = function () {
                return _this.preSubmit();
            };
        }
        EditIpv6TabController.prototype.initGrids = function () {
            this.gridAddressesOptions.columnDefinitions = this.getAddressesColumnDefs();
            this.gridAddressesOptions.data = this.ipAddressesList;
            this.gridAddressesOptions.deleteLabel = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.label");
            this.gridAddressesOptions.deleteTooltip = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.tooltip");
            this.gridAddressesOptions.onDelete = this.deleteAddressFromList.bind(this);
            this.gridGatewaysOptions.columnDefinitions = this.getGatewaysColumnDefs();
            this.gridGatewaysOptions.data = this.gateways;
            this.gridGatewaysOptions.deleteLabel = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.label");
            this.gridGatewaysOptions.deleteTooltip = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.tooltip");
            this.gridGatewaysOptions.onDelete = this.deleteGatewayFromList.bind(this);
        };
        EditIpv6TabController.prototype.typeChanged = function () {
            if (this.ipv6Type === this.DO_NOT_USE_IPV6 || this.ipv6Type === this.ADAPTER_TYPE_DHCP) {
                this.validationErrors.gateway = null;
            }
            if (this.ipv6Type !== this.ADAPTER_TYPE_FIXED_IP) {
                this.validationErrors.ipAddress = null;
                this.validationErrors.prefixLength = null;
            }
            var isValid = this.validate();
            this.setValidationErrors(isValid);
            this.updateData();
            if (this.updateDnsTab && typeof this.updateDnsTab === "function") {
                this.updateDnsTab();
            }
        };
        EditIpv6TabController.prototype.setValidationErrors = function (isValid) {
            if (!isValid && !_.contains(this.submitErrors, this.TITLE_LOCALE)) {
                this.submitErrors.push(this.TITLE_LOCALE);
            }
            else if (isValid) {
                this.submitErrors = _.without(this.submitErrors, this.TITLE_LOCALE);
            }
        };
        EditIpv6TabController.prototype.addAddress = function () {
            this.validateIPv6(this.ipAddress);
            this.validatePrefixLength(this.prefixLength);
            if (this.validationErrors.ipAddress || this.validationErrors.prefixLength) {
                return;
            }
            var address = new FixedIpV6();
            address.ipAddress = this.ipAddress;
            if (this.prefixLength) {
                address.subnetMask = this.prefixLength;
            }
            this.ipAddressesList.push(address);
            this.gridAddressesOptions.data = this.ipAddressesList;
            this.ipAddress = "";
            this.prefixLength = undefined;
            this.setValidationErrors(true);
        };
        EditIpv6TabController.prototype.addGateway = function () {
            this.validateGateway(this.gateway);
            if (!this.gateway || this.validationErrors.gateway) {
                return;
            }
            this.gateways.push(this.gateway);
            this.gridGatewaysOptions.data = this.gateways;
            this.gateway = "";
        };
        EditIpv6TabController.prototype.validateGateway = function (gateway) {
            if (!gateway) {
                this.validationErrors.gateway = null;
                return;
            }
            var isValid = this.ipParser.isIpv6AddressValid(gateway);
            var isDuplicate = _.any(this.gateways, function (currentGateway) {
                return currentGateway === gateway;
            });
            if (!isValid) {
                this.validationErrors.gateway =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.dialog.error.address");
            }
            if (isDuplicate) {
                this.validationErrors.gateway =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.dialog.error.duplicate", gateway);
            }
            if (isValid && !isDuplicate) {
                this.validationErrors.gateway = null;
            }
        };
        EditIpv6TabController.prototype.validateIPv6 = function (ipAddress) {
            var isValid = this.ipParser.isIpv6AddressValid(ipAddress);
            var isDuplicate = _.any(this.ipAddressesList, function (address) {
                return address.ipAddress === ipAddress;
            });
            if (!isValid) {
                this.validationErrors.ipAddress =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.dialog.error.address");
            }
            if (isDuplicate) {
                this.validationErrors.ipAddress =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.dialog.error.duplicate", ipAddress);
            }
            if (isValid && !isDuplicate) {
                this.validationErrors.ipAddress = null;
            }
        };
        EditIpv6TabController.prototype.validatePrefixLength = function (prefixLength) {
            if (!this.ipParser.isSubnetPrefixValid(prefixLength)) {
                this.validationErrors.prefixLength =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.dialog.error.prefix");
            }
            else {
                this.validationErrors.prefixLength = null;
            }
        };
        EditIpv6TabController.prototype.getSpecType = function () {
            var adapter = this.adapterMapping.adapter;
            if (!adapter.ipV6Spec) {
                return this.DO_NOT_USE_IPV6;
            }
            if (!adapter.ipV6Spec.ip || !adapter.ipV6Spec.ip.length) {
                return this.DO_NOT_USE_IPV6;
            }
            var ipGenerator = adapter.ipV6Spec.ip[0];
            return ipGenerator._type;
        };
        EditIpv6TabController.prototype.populateData = function () {
            if (this.ipv6Type === this.DO_NOT_USE_IPV6) {
                return;
            }
            var adapter = this.adapterMapping.adapter;
            if (adapter.ipV6Spec.gateway && adapter.ipV6Spec.gateway.length) {
                this.gateways = adapter.ipV6Spec.gateway;
            }
            else {
                this.gateways = [];
            }
            if (this.ipv6Type === this.ADAPTER_TYPE_CUSTOM_IP) {
                this.argument = adapter.ipV6Spec.ip[0].argument;
            }
            if (this.ipv6Type === this.ADAPTER_TYPE_FIXED_IP) {
                // There could be more so assign all of them to the ipv6 address list
                this.ipAddressesList = adapter.ipV6Spec.ip;
            }
        };
        EditIpv6TabController.prototype.preSubmit = function () {
            var isValid = this.validate();
            if (!isValid) {
                return false;
            }
            this.updateData();
            return true;
        };
        EditIpv6TabController.prototype.validate = function () {
            var isValid = true;
            if (this.ipv6Type === this.ADAPTER_TYPE_FIXED_IP &&
                (!this.ipAddressesList || !this.ipAddressesList.length)) {
                isValid = false;
                this.validationErrors.ipAddress =
                    this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.error.required");
            }
            return isValid;
        };
        EditIpv6TabController.prototype.updateData = function () {
            var adapter = this.adapterMapping.adapter;
            if (this.ipv6Type === this.DO_NOT_USE_IPV6) {
                delete adapter.ipV6Spec;
                this.adapterWrapper.ipV6Address = this.gosSpecNetworkService.getIPv6NicSettingSummary(adapter.ipV6Spec);
                return;
            }
            adapter.ipV6Spec = new IPSettings$IpV6AddressSpec();
            adapter.ipV6Spec.gateway = this.gateways;
            adapter.ipV6Spec.ip = this.getIpGenerators();
            this.adapterWrapper.ipV6Address = this.gosSpecNetworkService.getIPv6NicSettingSummary(adapter.ipV6Spec);
        };
        EditIpv6TabController.prototype.getIpGenerators = function () {
            switch (this.ipv6Type) {
                case this.ADAPTER_TYPE_UNKNOWUN_IP:
                    return [new UnknownIpV6Generator()];
                case this.ADAPTER_TYPE_CUSTOM_IP:
                    var customIpGenerator = new CustomIpV6Generator();
                    customIpGenerator.argument = this.argument;
                    return [customIpGenerator];
                case this.ADAPTER_TYPE_FIXED_IP:
                    return this.ipAddressesList;
            }
            return [new DhcpIpV6Generator()];
        };
        EditIpv6TabController.prototype.getAddressesColumnDefs = function () {
            return [
                {
                    displayName: this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.address"),
                    field: "ipAddress",
                    type: "string",
                    class: "ipv6-address-col"
                },
                {
                    displayName: this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.prefix"),
                    field: "subnetMask",
                    type: "string",
                }
            ];
        };
        EditIpv6TabController.prototype.getGatewaysColumnDefs = function () {
            return [
                {
                    displayName: this.i18n("VmUi", "customizationSpec.networkPage.properties.ipv6.gateway"),
                    type: "string",
                }
            ];
        };
        EditIpv6TabController.prototype.deleteAddressFromList = function (address) {
            if (!address) {
                return;
            }
            var index = _.findIndex(this.ipAddressesList, function (currentAddress) {
                return currentAddress.ipAddress === address.ipAddress;
            });
            if (index < 0) {
                return;
            }
            this.ipAddressesList.splice(index, 1);
            this.setValidationErrors(this.validate());
        };
        EditIpv6TabController.prototype.deleteGatewayFromList = function (gateway) {
            if (!gateway) {
                return;
            }
            var index = _.findIndex(this.gateways, function (currentGateway) {
                return currentGateway === gateway;
            });
            if (index < 0) {
                return;
            }
            this.gateways.splice(index, 1);
        };
        EditIpv6TabController.$inject = ["i18nService", "gosSpecNetworkService", "ipParserService"];
        return EditIpv6TabController;
    }());
    var EditIpv6TabComponent = (function () {
        function EditIpv6TabComponent() {
            this.bindings = {
                adapterWrapper: "<",
                isNameIpGeneratorDefined: "<",
                editIpv6: "=",
                submitErrors: "=",
                updateDnsTab: "="
            };
            this.controller = EditIpv6TabController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/pages/network/edit/ipv6-tab/edit-ipv6-tab.component.html";
        }
        return EditIpv6TabComponent;
    }());
    h5_vm.EditIpv6TabComponent = EditIpv6TabComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("editIpv6Tab", new EditIpv6TabComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var EditWinsTabController = (function () {
        function EditWinsTabController(i18nService, ipParserService) {
            var _this = this;
            this.i18nService = i18nService;
            this.ipParserService = ipParserService;
            this.TITLE_LOCALE = "customizationSpec.networkPage.properties.wins.pageTitle";
            this.validationErrors = {};
            this.i18nForTab = function (suffix) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return (_a = _this.i18nService).getString.apply(_a, ["VmUi", "customizationSpec.networkPage.properties.wins." + suffix].concat(args));
                var _a;
            };
            this.adapterMapping = this.adapterWrapper.adapterMapping;
            this.populateData();
            this.editWins = function () {
                return _this.preSubmit();
            };
        }
        EditWinsTabController.prototype.validatePrimaryWins = function () {
            this.validationErrors["primaryWins"] =
                this.validateIpInternal(this.primaryWins);
            this.setValidationErrors(this.areAllFieldsValid());
        };
        EditWinsTabController.prototype.validateSecondaryWins = function () {
            this.validationErrors["secondaryWins"] =
                this.validateIpInternal(this.secondaryWins);
            this.setValidationErrors(this.areAllFieldsValid());
        };
        /**
         * Same as NicSettingsWinsPageMediator.as:118 except that it does not return
         * anything.
         */
        EditWinsTabController.prototype.validateAll = function () {
            this.validatePrimaryWins();
            this.validateSecondaryWins();
        };
        EditWinsTabController.prototype.areAllFieldsValid = function () {
            return _.all(this.validationErrors, function (validationError) {
                return !validationError;
            });
        };
        EditWinsTabController.prototype.validateIpInternal = function (ip) {
            if (!ip || this.ipParserService.isIpv4AddressValid(ip)
                || this.ipParserService.isIpv6AddressValid(ip)) {
                return "";
            }
            return this.i18nForTab("error.address");
        };
        EditWinsTabController.prototype.preSubmit = function () {
            this.validateAll();
            if (this.areAllFieldsValid()) {
                this.updateData();
                return true;
            }
            return false;
        };
        EditWinsTabController.prototype.setValidationErrors = function (isValid) {
            if (!isValid && !_.contains(this.submitErrors, this.TITLE_LOCALE)) {
                this.submitErrors.push(this.TITLE_LOCALE);
            }
            else if (isValid) {
                this.submitErrors = _.without(this.submitErrors, this.TITLE_LOCALE);
            }
        };
        /**
         * Set the data from the input fields into the adapter
         */
        EditWinsTabController.prototype.updateData = function () {
            if (this.primaryWins) {
                this.primaryWins = ipaddr.parse(this.primaryWins).toString();
            }
            if (this.secondaryWins) {
                this.secondaryWins = ipaddr.parse(this.secondaryWins).toString();
            }
            this.adapterMapping.adapter.primaryWINS = this.primaryWins;
            this.adapterMapping.adapter.secondaryWINS = this.secondaryWins;
        };
        EditWinsTabController.prototype.populateData = function () {
            this.primaryWins = this.adapterMapping.adapter.primaryWINS || "";
            this.secondaryWins = this.adapterMapping.adapter.secondaryWINS || "";
        };
        EditWinsTabController.$inject = ["i18nService", "ipParserService"];
        return EditWinsTabController;
    }());
    var EditWinsTabComponent = (function () {
        function EditWinsTabComponent() {
            this.bindings = {
                adapterWrapper: "<",
                submitErrors: "=",
                editWins: "="
            };
            this.controller = EditWinsTabController;
            this.templateUrl = "vm-ui/resources/vm/guest-os-customization/pages/network/edit/wins-tab/edit-wins-tab.component.html";
        }
        return EditWinsTabComponent;
    }());
    h5_vm.EditWinsTabComponent = EditWinsTabComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("editWinsTab", new EditWinsTabComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosNetworkPageController = (function () {
        function GosNetworkPageController($q, i18nService, vuiConstants, gosSpecNetworkService, clarityModalService, featureFlagsService, defaultUriSchemeUtil, dataService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.gosSpecNetworkService = gosSpecNetworkService;
            this.clarityModalService = clarityModalService;
            this.featureFlagsService = featureFlagsService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.NETWORK_SETTINGS_STANDARD = h5_vm.GosNetworkSettingsType.STANDARD;
            this.NETWORK_SETTINGS_CUSTOM = h5_vm.GosNetworkSettingsType.CUSTOM;
        }
        GosNetworkPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
            this.gridConfiguration = this.generateGridConfiguration();
            this.i18n = this.i18nService.getString;
        };
        GosNetworkPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosNetworkPageController.prototype.onCommit = function () {
            // This page has no validation. The only validation done here is on the
            // edit action.
            return this.$q.resolve([]);
        };
        GosNetworkPageController.prototype.customSettingsGridDisabled = function () {
            return this.model.networkSettingsType ===
                h5_vm.GosNetworkSettingsType.STANDARD;
        };
        GosNetworkPageController.prototype.generateGridConfiguration = function () {
            var result = new h5_vm.CrudGridConfiguration();
            result.data = this.model.adapterMappingWrappers;
            result.columnDefinitions = this.getColumnDefs();
            result.height = "250";
            result.addLabel = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.add.label");
            result.addTooltip = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.add.tooltip");
            result.onAdd = this.addNewNicMapping.bind(this);
            result.editLabel = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.edit.label");
            result.editTooltip = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.edit.tooltip");
            result.onEdit = this.editNicMapping.bind(this);
            result.deleteLabel = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.label");
            result.deleteTooltip = this.i18nService.getString("VmUi", "customizationSpec.networkPage.actionButton.delete.tooltip");
            result.onDelete = this.deleteNicMapping.bind(this);
            return result;
        };
        GosNetworkPageController.prototype.getColumnDefs = function () {
            return [
                {
                    displayName: this.i18nService.getString("VmUi", "customizationSpec.networkPage.settingsList.description"),
                    field: "description",
                    type: "string",
                    sortable: true
                },
                {
                    displayName: this.i18nService.getString("VmUi", "customizationSpec.networkPage.settingsList.iPv4Address"),
                    field: "ipV4Address",
                    type: "string",
                    sortable: true,
                },
                {
                    displayName: this.i18nService.getString("VmUi", "customizationSpec.networkPage.settingsList.iPv6Address"),
                    field: "ipV6Address",
                    type: "string",
                    sortable: true
                }
            ];
        };
        GosNetworkPageController.prototype.addNewNicMapping = function () {
            this.model.adapterMappingWrappers = this.model.adapterMappingWrappers || [];
            var newAdapterDescription = this.i18nService.getString("VmUi", "customizationManager.customizationSpecViewData.nicNameFormat", this.model.adapterMappingWrappers.length + 1);
            var newAdapterMappingWrapper = this.gosSpecNetworkService.createNewAdapterMappingWrapper(newAdapterDescription);
            this.model.adapterMappingWrappers.push(newAdapterMappingWrapper);
        };
        GosNetworkPageController.prototype.editNicMapping = function (selectedAdapterMapping) {
            var _this = this;
            if (!selectedAdapterMapping) {
                return;
            }
            this.getCustomNameAvailabilityIfNeeded();
            var editedAdapterMappingWrapper = angular.copy(selectedAdapterMapping);
            var dnsSuffixList = angular.copy(this.model.dnsSuffixList);
            var validationErrors = [];
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "customizationSpec.networkPage.editDialog.title"),
                subTitle: {
                    text: editedAdapterMappingWrapper.description
                },
                size: "xl",
                defaultButton: "submit",
                contentTemplate: "vm-ui/resources/vm/guest-os-customization/pages/network/edit/gos-network-page-edit.html",
                dialogData: {
                    adapterWrapper: editedAdapterMappingWrapper,
                    dnsSuffixList: dnsSuffixList,
                    customizationSpecType: this.model.type,
                    isNameIpGeneratorDefined: this.model.isNameIpGeneratorDefined,
                    validationErrors: validationErrors,
                    editNic: function () {
                        _this.editNic(editedAdapterMappingWrapper, dnsSuffixList);
                    }
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        GosNetworkPageController.prototype.editNic = function (editedAdapterMappingWrapper, dnsSuffixList) {
            var adapterWrappers = this.model.adapterMappingWrappers;
            var adapterIndex = _.findIndex(adapterWrappers, function (adapterWrapper) {
                return adapterWrapper.description === editedAdapterMappingWrapper.description;
            });
            if (adapterIndex > -1) {
                // change the original values for the NIC with the customized
                adapterWrappers[adapterIndex] = editedAdapterMappingWrapper;
            }
            this.model.dnsSuffixList = dnsSuffixList;
        };
        GosNetworkPageController.prototype.deleteNicMapping = function (selectedAdapterMapping) {
            if (!selectedAdapterMapping) {
                return;
            }
            var adapterWrappers = this.model.adapterMappingWrappers;
            var index = _.findIndex(adapterWrappers, function (adapterWrapper) {
                return adapterWrapper.description === selectedAdapterMapping.description;
            });
            if (index < 0) {
                return;
            }
            adapterWrappers.splice(index, 1);
            this.gosSpecNetworkService.updateAdapterMappingNames(index, adapterWrappers);
        };
        GosNetworkPageController.prototype.getCustomNameAvailabilityIfNeeded = function () {
            var _this = this;
            if (this.model.isNameIpGeneratorDefined !== undefined) {
                return;
            }
            var vcUri = this.defaultUriSchemeUtil.getRootFolder(this.model.vcServiceGuid);
            this.dataService.getProperties(vcUri, ["isNameIpGeneratorDefined"])
                .then(function (data) {
                _this.model.isNameIpGeneratorDefined = data.isNameIpGeneratorDefined;
            });
        };
        GosNetworkPageController.$inject = [
            "$q",
            "i18nService",
            "vuiConstants",
            "gosSpecNetworkService",
            "clarityModalService",
            "featureFlagsService",
            "defaultUriSchemeUtil",
            "dataService"
        ];
        return GosNetworkPageController;
    }());
    h5_vm.GosNetworkPageController = GosNetworkPageController;
    var GosNetworkPageComponent = (function () {
        function GosNetworkPageComponent() {
            this.controller = GosNetworkPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/network/gos-network-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosNetworkPageComponent;
    }());
    h5_vm.GosNetworkPageComponent = GosNetworkPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosNetworkPage", new GosNetworkPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosNetworkPageModel = (function (_super) {
        __extends(GosNetworkPageModel, _super);
        function GosNetworkPageModel() {
            _super.apply(this, arguments);
        }
        return GosNetworkPageModel;
    }(GosBasePageModel));
    h5_vm.GosNetworkPageModel = GosNetworkPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DhcpIpGenerator = com.vmware.vim.binding.vim.vm.customization.DhcpIpGenerator;
    var AdapterMapping = com.vmware.vim.binding.vim.vm.customization.AdapterMapping;
    var IPSettings = com.vmware.vim.binding.vim.vm.customization.IPSettings;
    var GosSpecNetworkService = (function () {
        function GosSpecNetworkService(i18nService) {
            this.i18nService = i18nService;
        }
        /**
         * Returns a summary of the IPv4 settings of the virtual network adapter
         * possible values are:
         * <ul>
         *    <li>Use DHCP</li>
         *    <li>Prompt user</li>
         *    <li>Custom</li>
         *    <li>Fixed IPv4 (The IP address)</li>
         * </ul>
         */
        GosSpecNetworkService.prototype.getIPv4NicSettingSummary = function (ipGenerator) {
            if (ipGenerator._type === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP) {
                return this.getString("nicSettingsUseDhcp");
            }
            else if (ipGenerator._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP) {
                return this.getString("nicSettingsPromptUser");
            }
            else if (ipGenerator._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP) {
                return this.getString("nicSettingsCustom");
            }
            else if (ipGenerator._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP) {
                return ipGenerator.ipAddress;
            }
            return this.getString("nicSettingsUnknown");
        };
        /**
         * Returns a summary of the IPv6 settings of the virtual network adapter
         * possible values are:
         * <ul>
         *    <li>Not used</li>
         *    <li>Use DHCP</li>
         *    <li>Prompt user</li>
         *    <li>Custom</li>
         *    <li>Fixed IPv6 (The IP address)</li>
         * </ul>
         */
        GosSpecNetworkService.prototype.getIPv6NicSettingSummary = function (ipv6AddressSpec) {
            if (!ipv6AddressSpec || !ipv6AddressSpec.ip || !ipv6AddressSpec.ip.length) {
                return this.getString("nicSettingsNotUsed");
            }
            if (ipv6AddressSpec.ip[0]._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP_V6) {
                return this.getString("nicSettingsUseDhcp");
            }
            else if (ipv6AddressSpec.ip[0]._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_UNKNOWUN_IP_V6) {
                return this.getString("nicSettingsPromptUser");
            }
            else if (ipv6AddressSpec.ip[0]._type ===
                h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_CUSTOM_IP_V6) {
                return this.getString("nicSettingsCustom");
            }
            else if (ipv6AddressSpec.ip[0]._type
                === h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_FIXED_IP_V6) {
                return ipv6AddressSpec.ip[0].ipAddress;
            }
            return this.getString("nicSettingsUnknown");
        };
        GosSpecNetworkService.prototype.getInitialNetworkCards = function () {
            var adapterMappingWrapper = this.createNewAdapterMappingWrapper(this.getString("nicNameFormat", "1"));
            return [adapterMappingWrapper];
        };
        /**
         * Determines if network adapters use typical settings for
         * customization.
         */
        GosSpecNetworkService.prototype.isNetworkTypeStandard = function (specDetails) {
            if (!specDetails) {
                return false;
            }
            // User has customized DNS suffixes - does not hold for Linux
            if (!this.isLinuxPrep(specDetails) && this.hasDnsSuffixList(specDetails)) {
                return false;
            }
            if (this.specificationHasDefaultNumberOfNics(specDetails)) {
                if (this.hasCustomizedAdapter(specDetails)) {
                    return false;
                }
            }
            else {
                // If not equal - it means that user has added/deleted NICs
                return false;
            }
            return true;
        };
        GosSpecNetworkService.prototype.createAdapterMappingWrappersFromSpecification = function (spec) {
            var adapterMappingWrappers = [];
            var adapterMappings = spec.nicSettingMap;
            if (adapterMappings && adapterMappings.length) {
                for (var i = 0; i < adapterMappings.length; i++) {
                    var adapterDescription = this.getString("nicNameFormat", (i + 1));
                    var adapterWrapper = this.createNewAdapterMappingWrapper(adapterDescription, adapterMappings[i]);
                    adapterMappingWrappers.push(adapterWrapper);
                }
            }
            return adapterMappingWrappers;
        };
        GosSpecNetworkService.prototype.createNewAdapterMappingWrapper = function (description, adapterMapping) {
            if (!adapterMapping) {
                adapterMapping = new AdapterMapping();
                var ipSettings = new IPSettings();
                ipSettings.ip = new DhcpIpGenerator();
                adapterMapping.adapter = ipSettings;
            }
            var adapterMappingWrapper = new h5_vm.AdapterMappingWrapper();
            adapterMappingWrapper.adapterMapping = adapterMapping;
            adapterMappingWrapper.description = description;
            adapterMappingWrapper.ipV4Address = this.getIPv4NicSettingSummary(adapterMapping.adapter.ip);
            adapterMappingWrapper.ipV6Address = this.getIPv6NicSettingSummary(adapterMapping.adapter.ipV6Spec);
            return adapterMappingWrapper;
        };
        /**
         * Updates the names of adapters when a previous adapter has been deleted.
         */
        GosSpecNetworkService.prototype.updateAdapterMappingNames = function (index, adapterWrappers) {
            for (var i = index; i < adapterWrappers.length; i++) {
                var adapterWrapper = adapterWrappers[i];
                adapterWrapper.description = this.getString("nicNameFormat", (i + 1));
            }
        };
        GosSpecNetworkService.prototype.getString = function (key, parameter) {
            return this.i18nService.getString("VmUi", "customizationManager.customizationSpecViewData." + key, parameter);
        };
        /**
         * Checks if given netowrk adapter is customized by the user.
         */
        GosSpecNetworkService.isAdapterCustomized = function (adapter) {
            if (adapter.adapter.ip._type
                !== h5_vm.GosCustomizationHelperService.ADAPTER_TYPE_DHCP
                || (adapter.adapter.ipV6Spec && adapter.adapter.ipV6Spec._type
                    === h5_vm.GosCustomizationHelperService.IPV6_ADDRESS_SPEC_TYPE)
                || adapter.adapter.dnsServerList
                || adapter.adapter.gateway
                || adapter.adapter.primaryWINS
                || adapter.adapter.secondaryWINS
                || adapter.adapter.subnetMask) {
                return true;
            }
            return false;
        };
        GosSpecNetworkService.prototype.isLinuxPrep = function (specDetails) {
            return specDetails.identity._type
                === h5_vm.GosCustomizationHelperService.IDENTITY_TYPE_LINUX_PREP;
        };
        GosSpecNetworkService.prototype.hasDnsSuffixList = function (specDetails) {
            return specDetails.globalIPSettings
                && !_.isEmpty(specDetails.globalIPSettings.dnsSuffixList);
        };
        GosSpecNetworkService.prototype.specificationHasDefaultNumberOfNics = function (specDetails) {
            return specDetails.nicSettingMap
                && specDetails.nicSettingMap.length
                    === h5_vm.GosCustomizationHelperService.DEFAULT_NUMBER_OF_NICS;
        };
        GosSpecNetworkService.prototype.hasCustomizedAdapter = function (specDetails) {
            var customizedAdapter = _.find(specDetails.nicSettingMap, function (adapter) {
                return GosSpecNetworkService.isAdapterCustomized(adapter);
            });
            return !!customizedAdapter;
        };
        GosSpecNetworkService.$inject = ["i18nService"];
        return GosSpecNetworkService;
    }());
    h5_vm.GosSpecNetworkService = GosSpecNetworkService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("gosSpecNetworkService", GosSpecNetworkService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosRegistrationInformationPageController = (function () {
        function GosRegistrationInformationPageController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.ownerNameInvalid = false;
            this.organizationNameInvalid = false;
        }
        GosRegistrationInformationPageController.prototype.$onInit = function () {
            var _this = this;
            this.ownerNameLabel = this.i18nService.getString("VmUi", "guestOsCustomization.new.registrationInformationPage.ownerName");
            this.organizationNameLabel = this.i18nService.getString("VmUi", "guestOsCustomization.new.registrationInformationPage.organizationName");
            this.emptyOwnerNameTooltip = this.i18nService.getString("VmUi", "customizationSpec.registrationInfoPage.emptyOwnerNameError");
            this.emptyOrganizationNameTooltip = this.i18nService.getString("VmUi", "customizationSpec.registrationInfoPage.emptyOrgNameError");
            this.model.onPageCommit = function () {
                return _this.onCommit();
            };
        };
        GosRegistrationInformationPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosRegistrationInformationPageController.prototype.validateOwnerName = function () {
            this.ownerNameInvalid = !this.model.ownerName.trim();
        };
        GosRegistrationInformationPageController.prototype.validateOrganizationName = function () {
            this.organizationNameInvalid = !this.model.organizationName.trim();
        };
        GosRegistrationInformationPageController.prototype.onCommit = function () {
            this.validateOwnerName();
            this.validateOrganizationName();
            var errors = [];
            if (this.ownerNameInvalid) {
                errors.push(this.emptyOwnerNameTooltip);
            }
            if (this.organizationNameInvalid) {
                errors.push(this.emptyOrganizationNameTooltip);
            }
            return this.$q.resolve(errors);
        };
        GosRegistrationInformationPageController.$inject = ["i18nService", "$q"];
        return GosRegistrationInformationPageController;
    }());
    var GosRegistrationInformationPageComponent = (function () {
        function GosRegistrationInformationPageComponent() {
            this.controller = GosRegistrationInformationPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/registration-information/gos-registration-information-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosRegistrationInformationPageComponent;
    }());
    h5_vm.GosRegistrationInformationPageComponent = GosRegistrationInformationPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosRegistrationInformationPage", new GosRegistrationInformationPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosRegistrationInformationPageModel = (function (_super) {
        __extends(GosRegistrationInformationPageModel, _super);
        function GosRegistrationInformationPageModel() {
            _super.apply(this, arguments);
        }
        return GosRegistrationInformationPageModel;
    }(GosBasePageModel));
    h5_vm.GosRegistrationInformationPageModel = GosRegistrationInformationPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosTimeZonePageController = (function () {
        function GosTimeZonePageController($scope, $q, i18nService, vuiConstants, dataService, $timeout) {
            this.$scope = $scope;
            this.$q = $q;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.dataService = dataService;
            this.$timeout = $timeout;
            this.UTC_OPTION = h5_vm.LinuxHardwareClockOption.UTC;
            this.LOCAL_TIME_OPTION = h5_vm.LinuxHardwareClockOption.LOCAL_TIME;
            this.selectedHardwareClock = {
                value: this.model.hwClockUTC ? this.UTC_OPTION : this.LOCAL_TIME_OPTION,
            };
        }
        GosTimeZonePageController.prototype.$onInit = function () {
            var _this = this;
            this.model.onPageCommit = this.onCommit.bind(this);
            this.i18n = this.i18nService.getString;
            if (this.model.timeZoneData) {
                this.initialize();
            }
            else {
                this.setLoading(true);
                this.dataService.getProperties(this.model.customizationSpecManagerUrn, ["timeZones"]).then(function (result) {
                    _this.model.timeZoneData = result.timeZones;
                    _this.setLoading(false);
                    _this.initialize();
                });
            }
        };
        GosTimeZonePageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosTimeZonePageController.prototype.onCommit = function () {
            return this.$q.resolve(this.validateIsTimezoneSelected());
        };
        GosTimeZonePageController.prototype.isLinux = function () {
            return this.model.type === h5_vm.GosType.LINUX;
        };
        GosTimeZonePageController.prototype.isWindows = function () {
            return this.model.type === h5_vm.GosType.WINDOWS;
        };
        GosTimeZonePageController.prototype.initialize = function () {
            if (!this.model.timeZoneData) {
                throw new Error("Time zone data is not defined - cannot initialize page");
            }
            if (this.isLinux()) {
                this.initializeForLinux(this.model.timeZoneData.linuxTimeZoneAreas);
            }
            else {
                this.initializeForWindows(this.model.timeZoneData.windowsTimeZones);
            }
        };
        GosTimeZonePageController.prototype.timeZoneAreaChanged = function () {
            this.model.timeZoneArea = this.selectedTimeZoneArea.name;
            this.selectedLinuxTimeZoneLocation = this.selectedTimeZoneArea.locations[0];
            this.model.timeZoneLocation = this.selectedLinuxTimeZoneLocation.name;
        };
        GosTimeZonePageController.prototype.timeZoneLocationChanged = function () {
            this.model.timeZoneLocation = this.selectedLinuxTimeZoneLocation.name;
        };
        GosTimeZonePageController.prototype.hardwareClockChanged = function () {
            this.model.hwClockUTC =
                this.selectedHardwareClock.value === h5_vm.LinuxHardwareClockOption.UTC;
        };
        GosTimeZonePageController.prototype.initializeForLinux = function (areas) {
            var _this = this;
            this.linuxTimeZoneAreas = areas;
            if (this.model.timeZoneArea) {
                this.selectedTimeZoneArea = this.findLinuxTimeZoneArea(this.model.timeZoneArea);
            }
            else {
                this.selectedTimeZoneArea = areas[0];
                this.model.timeZoneArea = this.selectedTimeZoneArea.name;
            }
            if (!this.model.timeZoneLocation) {
                this.model.timeZoneLocation = this.selectedTimeZoneArea.locations[0].name;
            }
            this.selectedLinuxTimeZoneLocation = _.find(this.selectedTimeZoneArea.locations, function (location) {
                return location.name === _this.model.timeZoneLocation;
            });
        };
        GosTimeZonePageController.prototype.linuxAreaLabel = function (areaName) {
            return this.i18n("CommonTimeZones", "timeZoneLinux.Area." + areaName);
        };
        GosTimeZonePageController.prototype.linuxLocationLabel = function (locationName) {
            return this.i18n("CommonTimeZones", "timeZoneLinux.Location." + locationName);
        };
        GosTimeZonePageController.prototype.findLinuxTimeZoneArea = function (name) {
            return _.find(this.linuxTimeZoneAreas, function (area) {
                return (area.name === name);
            });
        };
        GosTimeZonePageController.prototype.initializeForWindows = function (timeZones) {
            var _this = this;
            this.windowsTimeZones = timeZones;
            if (this.model.timeZoneWinCode === undefined) {
                this.model.timeZoneWinCode = timeZones[0].code;
            }
            this.selectedWindowsTimeZone = _.find(timeZones, function (timeZone) {
                return timeZone.code === _this.model.timeZoneWinCode;
            });
        };
        GosTimeZonePageController.prototype.windowsTimeZoneLabel = function (timeZoneCode) {
            return this.i18n("CommonTimeZones", "timeZoneWindows." + timeZoneCode);
        };
        GosTimeZonePageController.prototype.windowsTimeZoneChanged = function () {
            this.model.timeZoneWinCode = this.selectedWindowsTimeZone.code;
        };
        GosTimeZonePageController.prototype.findWindowsTimeZone = function (code) {
            return _.find(this.windowsTimeZones, function (timeZone) {
                return (timeZone.code === code);
            });
        };
        GosTimeZonePageController.prototype.setLoading = function (loading) {
            this.model.isLoading = loading;
        };
        GosTimeZonePageController.prototype.validateIsTimezoneSelected = function () {
            var errorMessages = [];
            if (this.model.isLoading) {
                errorMessages.push(this.i18n("VmUi", "customizationSpec.timeZonePage.selectValidTimezone"));
            }
            return errorMessages;
        };
        GosTimeZonePageController.$inject = [
            "$scope",
            "$q",
            "i18nService",
            "vuiConstants",
            "dataService",
            "$timeout"];
        return GosTimeZonePageController;
    }());
    h5_vm.GosTimeZonePageController = GosTimeZonePageController;
    var GosTimeZonePageComponent = (function () {
        function GosTimeZonePageComponent() {
            this.controller = GosTimeZonePageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/time-zone/gos-time-zone-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosTimeZonePageComponent;
    }());
    h5_vm.GosTimeZonePageComponent = GosTimeZonePageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosTimeZonePage", new GosTimeZonePageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosTimeZonePageModel = (function (_super) {
        __extends(GosTimeZonePageModel, _super);
        function GosTimeZonePageModel() {
            _super.apply(this, arguments);
        }
        return GosTimeZonePageModel;
    }(GosBasePageModel));
    h5_vm.GosTimeZonePageModel = GosTimeZonePageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var LinuxHardwareClockOption = (function () {
        function LinuxHardwareClockOption(value) {
            this.value = value;
        }
        LinuxHardwareClockOption.UTC_VALUE = "UTC";
        LinuxHardwareClockOption.LOCAL_TIME_VALUE = "LocalTime";
        LinuxHardwareClockOption.UTC = new LinuxHardwareClockOption(LinuxHardwareClockOption.UTC_VALUE);
        LinuxHardwareClockOption.LOCAL_TIME = new LinuxHardwareClockOption(LinuxHardwareClockOption.LOCAL_TIME_VALUE);
        return LinuxHardwareClockOption;
    }());
    h5_vm.LinuxHardwareClockOption = LinuxHardwareClockOption;
})(h5_vm || (h5_vm = {}));







var h5_vm;
(function (h5_vm) {
    var GosWindowsLicensePageController = (function () {
        function GosWindowsLicensePageController($q, i18n) {
            this.$q = $q;
            this.i18n = i18n;
            this.AUTO_USERS_MIN = 5;
            this.AUTO_USERS_MAX = 9999;
            this.MAX_CHARS_PRODUCT_KEY = 29;
            this.model.onPageCommit = this.onCommit.bind(this);
        }
        GosWindowsLicensePageController.prototype.$onInit = function () {
            this.invalidProductKeyMessage = "";
            this.model.onPageCommit = this.onCommit.bind(this);
            var maxConnectionsInput = angular.element("input[ng-model='$ctrl.model.maxConnections']");
            maxConnectionsInput
                .on("input", function () {
                if (maxConnectionsInput[0].value.length > 4) {
                    maxConnectionsInput[0].value = maxConnectionsInput[0].value.slice(0, 4);
                }
            });
        };
        GosWindowsLicensePageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosWindowsLicensePageController.prototype.onCommit = function () {
            var errors = [];
            if (this.invalidProductKeyMessage !== "") {
                errors = errors.concat([
                    this.errorMessage("invalidProductKeyLength")
                ]);
            }
            if (this.model.isIncludeServerLicenseInfo && this.model.isServerLicenseModePerServer) {
                if (!this.model.maxConnections ||
                    this.AUTO_USERS_MIN > this.model.maxConnections ||
                    this.AUTO_USERS_MAX < this.model.maxConnections) {
                    errors = errors.concat([
                        this.errorMessage("maxConnectionsInputError")
                    ]);
                }
            }
            return this.$q.resolve(errors);
        };
        GosWindowsLicensePageController.prototype.onProductKeyChanged = function () {
            this.invalidProductKeyMessage = this.validateProductKey(this.model.productKey);
        };
        GosWindowsLicensePageController.prototype.validateProductKey = function (productKey) {
            if (productKey.length > this.MAX_CHARS_PRODUCT_KEY) {
                return this.errorMessage("invalidProductKeyLength");
            }
            return "";
        };
        GosWindowsLicensePageController.prototype.errorMessage = function (suffix, args) {
            if (args === void 0) { args = []; }
            return (_a = this.i18n).getString.apply(_a, ["VmUi", "customizationSpec.windowsLicensePage." + suffix].concat(args));
            var _a;
        };
        GosWindowsLicensePageController.$inject = ["$q",
            "i18nService"];
        return GosWindowsLicensePageController;
    }());
    h5_vm.GosWindowsLicensePageController = GosWindowsLicensePageController;
    var GosWindowsLicensePageComponent = (function () {
        function GosWindowsLicensePageComponent() {
            this.controller = GosWindowsLicensePageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/windows-license/gos-windows-license-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosWindowsLicensePageComponent;
    }());
    h5_vm.GosWindowsLicensePageComponent = GosWindowsLicensePageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosWindowsLicensePage", new GosWindowsLicensePageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosWindowsLicensePageModel = (function (_super) {
        __extends(GosWindowsLicensePageModel, _super);
        function GosWindowsLicensePageModel() {
            _super.apply(this, arguments);
        }
        return GosWindowsLicensePageModel;
    }(GosBasePageModel));
    h5_vm.GosWindowsLicensePageModel = GosWindowsLicensePageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosWorkgroupDomainPageController = (function () {
        function GosWorkgroupDomainPageController(i18n, $q) {
            this.i18n = i18n;
            this.$q = $q;
            this.domainInvalid = false;
            this.workgroupInvalid = false;
            this.usernameInvalid = false;
            this.passwordInvalid = false;
            this.WORKGROUP_OPTION = h5_vm.WorkgroupDomainTypeOption.WORKGROUP;
            this.DOMAIN_OPTION = h5_vm.WorkgroupDomainTypeOption.DOMAIN;
        }
        GosWorkgroupDomainPageController.prototype.$onInit = function () {
            this.model.onPageCommit = this.onCommit.bind(this);
        };
        GosWorkgroupDomainPageController.prototype.$onDestroy = function () {
            this.model.onPageCommit = undefined;
        };
        GosWorkgroupDomainPageController.prototype.onPasswordChanged = function () {
            this.model.isDomainPasswordChanged = true;
        };
        GosWorkgroupDomainPageController.prototype.onCommit = function () {
            var errors = [];
            if (this.validateWorkgroup()) {
                return this.$q.resolve([this.i18n.getString("VmUi", "guestOsCustomization.workGroupOrDomainPage.invalidWorkgroup")]);
            }
            if (this.validateDomain()) {
                errors.push(this.i18n.getString("VmUi", "guestOsCustomization.workGroupOrDomainPage.invalidDomain"));
            }
            if (this.validateUsername()) {
                errors.push(this.i18n.getString("VmUi", "guestOsCustomization.workGroupOrDomainPage.invalidUsername"));
            }
            if (this.validatePassword()) {
                errors.push(this.i18n.getString("VmUi", "customizationSpec.workgroupDomainPage.errorMessage.passwordsMismatch"));
            }
            return this.$q.resolve(errors);
        };
        GosWorkgroupDomainPageController.prototype.validateWorkgroup = function () {
            this.workgroupInvalid = !this.model.workgroup &&
                this.model.networkOption === h5_vm.WorkgroupDomainTypeOption.WORKGROUP;
            return this.workgroupInvalid;
        };
        GosWorkgroupDomainPageController.prototype.validateDomain = function () {
            this.domainInvalid = !this.model.domain &&
                this.model.networkOption === h5_vm.WorkgroupDomainTypeOption.DOMAIN;
            return this.domainInvalid;
        };
        GosWorkgroupDomainPageController.prototype.validateUsername = function () {
            this.usernameInvalid = !this.model.username &&
                this.model.networkOption === h5_vm.WorkgroupDomainTypeOption.DOMAIN;
            return this.usernameInvalid;
        };
        GosWorkgroupDomainPageController.prototype.validatePassword = function () {
            this.passwordInvalid = this.model.password !== this.model.confirmPassword &&
                this.model.networkOption === h5_vm.WorkgroupDomainTypeOption.DOMAIN;
            return this.passwordInvalid;
        };
        GosWorkgroupDomainPageController.prototype.removeValidations = function () {
            if (this.model.networkOption === h5_vm.WorkgroupDomainTypeOption.DOMAIN) {
                this.workgroupInvalid = false;
                return;
            }
            this.domainInvalid = false;
            this.usernameInvalid = false;
            this.passwordInvalid = false;
        };
        GosWorkgroupDomainPageController.$inject = [
            "i18nService",
            "$q"];
        return GosWorkgroupDomainPageController;
    }());
    h5_vm.GosWorkgroupDomainPageController = GosWorkgroupDomainPageController;
    var GosWorkgroupDomainPageComponent = (function () {
        function GosWorkgroupDomainPageComponent() {
            this.controller = GosWorkgroupDomainPageController;
            this.templateUrl =
                "vm-ui/resources/vm/guest-os-customization/pages/workgroup-domain/gos-workgroup-domain-page.component.html";
            this.bindings = {
                model: "<"
            };
        }
        return GosWorkgroupDomainPageComponent;
    }());
    h5_vm.GosWorkgroupDomainPageComponent = GosWorkgroupDomainPageComponent;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("gosWorkgroupDomainPage", new GosWorkgroupDomainPageComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var GosBasePageModel = h5_vm.GosBasePageModel;
    var GosWorkgroupDomainPageModel = (function (_super) {
        __extends(GosWorkgroupDomainPageModel, _super);
        function GosWorkgroupDomainPageModel() {
            _super.apply(this, arguments);
        }
        return GosWorkgroupDomainPageModel;
    }(GosBasePageModel));
    h5_vm.GosWorkgroupDomainPageModel = GosWorkgroupDomainPageModel;
})(h5_vm || (h5_vm = {}));







/**
 * Created by vsphereclient on 12/6/16.
 */
var vm_model;
(function (vm_model) {
    /**
     * The delimiter that is used to separate the part of the URI that contains the
     * type of the resource form the actual resource identification part.
     */
    var TYPE_DELIMITER = ':';
    var TYPE_DELIMITER_CODE = TYPE_DELIMITER.charCodeAt(0);
    /** The default URI scheme for Data Service objects */
    var DEFAULT_PREFIX = 'urn:vri:';
    /** The URI scheme for vSphere objects */
    var VMOMI_PREFIX = 'urn:vmomi:';
    var GLOBAL_PREFIX = 'urn:vri:acl:';
    /**
     * The character that will be used for escaping the special characters
     * in the type and id sections of the URI. Since we're building an URI,
     * we want to choose a character that is allowed in URIs and doesn't
     * have to be escaped itself by the URI. For that reason, using
     * backslash (\) as an escape character is not optimal.
     */
    var ESCAPE_CHAR = "~";
    var ESCAPE_CHAR_CODE = ESCAPE_CHAR.charCodeAt(0);
    /**
     * The character used in an escape sequence for escaping a delimiter.
     * The delimiters are listed in {@link #TYPE_DELIMITER} and
     * {@link #NSS_DELIMITER}. They are escaped using the sequence
     * of {@link ESCAPE_CHAR} followed by this character. In other words,
     * the sequence: <code>~d</code>
     */
    var ESCAPE_CHAR_FOR_DELIMITER = '_';
    var ESCAPE_CHAR_FOR_DELIMITER_CODE = ESCAPE_CHAR_FOR_DELIMITER.charCodeAt(0);
    var MoRef = (function () {
        function MoRef(type, value, serverGuid) {
            this.type = type;
            this.value = value;
            this.serverGuid = serverGuid;
            this._type = 'com.vmware.vim.binding.vmodl.ManagedObjectReference';
        }
        MoRef.prototype.getUri = function () {
            MoRef.check(this.type, this.value, this.serverGuid);
            return VMOMI_PREFIX + [
                this.escape(this.type),
                this.escape(this.value),
                this.escape(this.serverGuid)
            ].join(TYPE_DELIMITER);
        };
        MoRef.prototype.equals = function (other) {
            if (!other) {
                return false;
            }
            return this.getUri() === other.getUri();
        };
        MoRef.fromObject = function (object) {
            return new MoRef(object.type, object.value, object.serverGuid);
        };
        MoRef.fromUri = function (uri) {
            if (!uri) {
                return undefined;
            }
            var parts = MoRef.partsFromUri(uri);
            this.check(parts[0], parts[1], parts[2]);
            return new MoRef(parts[0], parts[1], parts[2]);
        };
        MoRef.check = function (type, value, serverGuid) {
            var parts = _.filter([type, value, serverGuid], function (item) {
                return !!item;
            });
            if (parts.length !== 3) {
                throw new Error('Type, value or serverGuid is empty');
            }
        };
        MoRef.prototype.escape = function (str) {
            if (str.indexOf(ESCAPE_CHAR) < 0 && str.indexOf(TYPE_DELIMITER) < 0) {
                return str;
            }
            var len = str.length;
            var buffer = [];
            for (var i = 0; i < len; i++) {
                var ch = str.charCodeAt(i);
                if (ch === TYPE_DELIMITER_CODE) {
                    buffer.push(ESCAPE_CHAR_CODE);
                    buffer.push(ESCAPE_CHAR_FOR_DELIMITER_CODE);
                }
                else if (ch === ESCAPE_CHAR_CODE) {
                    buffer.push(ESCAPE_CHAR_CODE);
                    buffer.push(ESCAPE_CHAR_CODE);
                }
                else {
                    buffer.push(ch);
                }
            }
            return String.fromCharCode.apply(String, buffer);
        };
        MoRef.partsFromUri = function (uri) {
            var parts = uri.split(TYPE_DELIMITER);
            while (parts.length !== 3) {
                parts.shift();
            }
            return parts;
        };
        return MoRef;
    }());
    vm_model.MoRef = MoRef;
    angular.module('com.vmware.vsphere.client.vm').service('MoRef', function () {
        return MoRef;
    });
})(vm_model || (vm_model = {}));



var h5_vm;
(function (h5_vm) {
    var VirtualNVDIMM$BackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualNVDIMM$BackingInfo;
    var VirtualNVDIMMController = com.vmware.vim.binding.vim.vm.device.VirtualNVDIMMController;
    var VirtualNVDIMM = com.vmware.vim.binding.vim.vm.device.VirtualNVDIMM;
    var NvdimmProvisioningService = (function () {
        function NvdimmProvisioningService(deviceService, i18nService, VirtualNvdimmWrapper, virtualDeviceInflator, pmemUtilService, storageProfileService) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
            this.VirtualNvdimmWrapper = VirtualNvdimmWrapper;
            this.virtualDeviceInflator = virtualDeviceInflator;
            this.pmemUtilService = pmemUtilService;
            this.storageProfileService = storageProfileService;
        }
        NvdimmProvisioningService.prototype.makeDefaultNvdimm = function (vmConfigEnvironment, guestOsDesc, otherInflatedDevices, additionalParameters) {
            this.validateCanAddNvdimm(vmConfigEnvironment, guestOsDesc, additionalParameters, otherInflatedDevices);
            var device = new VirtualNVDIMM();
            device.backing = this.getVirtualNvdimmBacking();
            device.capacityInMB = guestOsDesc.recommendedPersistentMemoryMB;
            device.key = this.deviceService.newKey();
            var controller = this.getNVDIMMController(otherInflatedDevices, vmConfigEnvironment, additionalParameters);
            if (controller !== null) {
                device.controllerKey = controller.getKey();
                if (controller.isMarkedForRemoval()) {
                    controller.revertRemoval();
                }
            }
            var deviceWrapper = this.deviceService.setDeviceInfo(new this.VirtualNvdimmWrapper(device));
            deviceWrapper.setFileOperation(this.getDefaultFileOperation());
            deviceWrapper.setProfile([
                this.getPmemStoragePolicy(additionalParameters.storageProfiles)]);
            return {
                device: deviceWrapper,
                controller: controller
            };
        };
        NvdimmProvisioningService.prototype.canAddNvdimm = function (vmConfigEnvironment, guestOsDesc, otherInflatedDevices, additionalParameters) {
            try {
                this.validateCanAddNvdimm(vmConfigEnvironment, guestOsDesc, additionalParameters, otherInflatedDevices);
            }
            catch (e) {
                return false;
            }
            return true;
        };
        NvdimmProvisioningService.prototype.validateCanAddNvdimm = function (vmConfigEnvironment, guestOsDesc, additionalParameters, otherInflatedDevices) {
            var option = this.pmemUtilService.findOption(vmConfigEnvironment, h5_vm.PmemUtilService.NVDIMM);
            // TODO proynovd: Catch these exceptions and show user-friendly message why NVDIMM
            // cannot be added.
            if (!option) {
                throw new Error(this.text("DeviceNotSupported"));
            }
            if (!guestOsDesc.persistentMemorySupported) {
                throw new Error(this.text("DeviceNotSupportedByGuest"));
            }
            if (additionalParameters.vmWorkflow === h5_vm.VmWorkflowMode.UpdateMode
                && additionalParameters.vm.powerState === "suspended") {
                throw new Error(this.text("NoVmSuspendedAdd"));
            }
            if (additionalParameters.vmWorkflow === h5_vm.VmWorkflowMode.UpdateMode
                && additionalParameters.vm.powerState !== "poweredOff") {
                if (!option.plugAndPlay) {
                    throw new Error(this.text("HotAddNotSupported"));
                }
                if (!guestOsDesc.persistentMemoryHotAddSupported) {
                    throw new Error(this.text("PMEMColdGuest"));
                }
            }
            if (!this.isPmemAvailable(vmConfigEnvironment, additionalParameters.storageProfiles)) {
                throw new Error(this.text("PMEMNewDenied"));
            }
            var max = this.getControllerLimit(vmConfigEnvironment);
            var currentNvdimmCount = this.getCurrentNvdimmCount(otherInflatedDevices);
            if (!isNaN(max) && ((currentNvdimmCount + 1) > max)) {
                throw new Error(this.text("DeviceLimitReached"));
            }
        };
        NvdimmProvisioningService.prototype.getVirtualNvdimmBacking = function () {
            var result = new VirtualNVDIMM$BackingInfo();
            result.fileName = "";
            return result;
        };
        NvdimmProvisioningService.prototype.getDefaultFileOperation = function () {
            var result = "create";
            return result;
        };
        NvdimmProvisioningService.prototype.getPmemStoragePolicy = function (storageProfilesPromise) {
            if (!storageProfilesPromise) {
                return undefined;
            }
            var pmemStorageProfile;
            // XXX
            // TODO PLEASE REVIEW
            // XXX
            // The storageProfiles are encapsulated in a promise, but it's always resolved
            // if when the user adds a new NVDIMM device, thus for the sake of simplicity
            // the code is written in an synchronous way.
            if (storageProfilesPromise.$$state !== 1
                && !storageProfilesPromise.$$state.value) {
                return undefined;
            }
            pmemStorageProfile = this.pmemUtilService.getPmemStorageProfile(storageProfilesPromise.$$state.value);
            if (!pmemStorageProfile) {
                return undefined;
            }
            return this.storageProfileService.makeProfile(pmemStorageProfile.id);
        };
        NvdimmProvisioningService.prototype.getControllerLimit = function (vmConfigEnvironment) {
            var controllerOption = this.pmemUtilService.findOption(vmConfigEnvironment, h5_vm.PmemUtilService.NVDIMM_CONTROLLER);
            if (!controllerOption
                && !controllerOption.devices
                && !controllerOption.devices.max) {
                return NaN;
            }
            return controllerOption.devices.max;
        };
        NvdimmProvisioningService.prototype.getCurrentNvdimmCount = function (otherInflatedDevices) {
            var nvdimms = otherInflatedDevices.devicesOfType(h5_vm.PmemUtilService.NVDIMM);
            return nvdimms.length;
        };
        /** Find or create and return controller  */
        NvdimmProvisioningService.prototype.getNVDIMMController = function (otherInflatedDevices, vmConfigEnvironment, additionalParameters) {
            var nvdimmController = this.pmemUtilService.getNvdimmController(otherInflatedDevices);
            if (nvdimmController) {
                return nvdimmController;
            }
            // Nothing found, create new one
            return this.addNVDIMMController(vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption, additionalParameters.vmWorkflow);
        };
        NvdimmProvisioningService.prototype.addNVDIMMController = function (deviceOptions, vmWorkflow) {
            var device = new VirtualNVDIMMController();
            device.key = this.deviceService.newKey();
            var deviceOptionsByDeviceType = _.indexBy(deviceOptions, function (deviceOption) {
                return deviceOption.type.name;
            });
            var inflatedController = this.virtualDeviceInflator.inflate(device, {
                deviceOptionsByDeviceType: deviceOptionsByDeviceType
            });
            inflatedController = this.deviceService.setDeviceInfo(inflatedController);
            return inflatedController;
        };
        /**
         * To be sure that we have PMEM capability for the VM there are 2 things:
         * - the host must support it
         * - the datastore must have the PMEM storage policy
         *
         * In real life one could not exist without the other but when we are making
         * the checks for PMEM availability there are cases where the storage policies
         * are not loaded
         */
        NvdimmProvisioningService.prototype.isPmemAvailable = function (vmConfigEnvironment, storageProfiles) {
            var hasPmemStoragePolicy = !_.isEmpty(this.getPmemStoragePolicy(storageProfiles));
            var hasPmemCapacity = vmConfigEnvironment && vmConfigEnvironment.configTarget
                && !isNaN(vmConfigEnvironment.configTarget.availablePersistentMemoryReservationMB)
                && vmConfigEnvironment.configTarget.availablePersistentMemoryReservationMB > 0;
            return hasPmemStoragePolicy || hasPmemCapacity;
        };
        NvdimmProvisioningService.prototype.text = function (key) {
            return this.i18nService.getString("VmUi", "VmDeviceManager." + key);
        };
        NvdimmProvisioningService.$inject = [
            "deviceService",
            "i18nService",
            "VirtualNvdimmWrapper",
            "virtualDeviceInflator",
            "pmemUtilService",
            "storageProfileService"];
        return NvdimmProvisioningService;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .service("nvdimmProvisioningService", NvdimmProvisioningService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var PmemCapacityService = (function () {
        function PmemCapacityService(pmemUtilService) {
            this.pmemUtilService = pmemUtilService;
        }
        PmemCapacityService.prototype.getMaxCapacityForNvdimm = function (vmConfigContext, guestOs, device, virtualMachineDevices) {
            var crMax = this.getComputeResourceAvailablePmemCapacity(vmConfigContext, device, virtualMachineDevices);
            var nvdimmOption = this.pmemUtilService.findOption(vmConfigContext.environment, h5_vm.PmemUtilService.NVDIMM);
            var deviceMax = nvdimmOption.capacityInMB.max;
            // RAM + NVM must not exceed RAM maximum
            var vmMax = this.getRemainingOsMemory(vmConfigContext, guestOs, virtualMachineDevices, device);
            var guestOsMax = this.getRemainingPmemCapacitySupportedByGuestOs(guestOs, virtualMachineDevices, device);
            var result = Math.min(crMax, deviceMax, vmMax, guestOsMax);
            // In case any negative number creeps in, return 0 as minimum
            return result > 0 ? result : 0;
        };
        PmemCapacityService.prototype.getMaxCapacityForPmemDisk = function (vmConfigContext, device, virtualMachineDevices) {
            return this.getComputeResourceAvailablePmemCapacity(vmConfigContext, device, virtualMachineDevices);
        };
        PmemCapacityService.prototype.getIsNvmAndRamExceedingGuestOsLimits = function (vmConfigContext, guestOs, virtualMachineDevices) {
            return this.getRemainingOsMemory(vmConfigContext, guestOs, virtualMachineDevices) < 0;
        };
        PmemCapacityService.prototype.getTotalNvdimmMemory = function (virtualMachineDevices, skippedNewDevice) {
            var result = 0;
            var allNvdimmDevices = virtualMachineDevices.devicesOfType(h5_vm.PmemUtilService.NVDIMM);
            for (var _i = 0, allNvdimmDevices_1 = allNvdimmDevices; _i < allNvdimmDevices_1.length; _i++) {
                var nvdimmDevice = allNvdimmDevices_1[_i];
                if (skippedNewDevice
                    && (skippedNewDevice.getKey() === nvdimmDevice.getKey())) {
                    continue;
                }
                if (nvdimmDevice.isMarkedForRemoval()) {
                    continue;
                }
                result += nvdimmDevice.getCapacityInMB();
            }
            return result;
        };
        PmemCapacityService.prototype.getComputeResourceAvailablePmemCapacity = function (vmConfigContext, device, virtualMachineDevices) {
            var crMax = this.pmemUtilService.getAvailablePmemCapacity(vmConfigContext);
            var totalNewNvdimmCapacityUsed = this.getTotalNewPmemCapacity(virtualMachineDevices, device);
            crMax += device.getOriginalCapacityInMB();
            var result = crMax - totalNewNvdimmCapacityUsed;
            // Have 0 as safeguard against negative numbers
            return result > 0 ? result : 0;
        };
        PmemCapacityService.prototype.getRemainingOsMemory = function (vmConfigContext, guestOs, virtualMachineDevices, skippedDevice) {
            var totalNvdimmPlusRam = this.getTotalNvdimmAndRamMemory(vmConfigContext, virtualMachineDevices, skippedDevice);
            return guestOs.supportedMaxMemMB - totalNvdimmPlusRam;
        };
        PmemCapacityService.prototype.getRemainingPmemCapacitySupportedByGuestOs = function (guestOs, virtualMachineDevices, skippedDevice) {
            return this.pmemUtilService.getSupportedPmemByGuestOs(guestOs)
                - this.getTotalNvdimmMemory(virtualMachineDevices, skippedDevice);
        };
        PmemCapacityService.prototype.getTotalNewPmemCapacity = function (virtualMachineDevices, skippedDevice) {
            var result = 0;
            result += this.getNvdimmContributionToPmemCapacity(virtualMachineDevices, skippedDevice);
            result += this.getPmemDiskContributionToPmemCapacity(virtualMachineDevices, skippedDevice);
            return result;
        };
        PmemCapacityService.prototype.getPmemDiskContributionToPmemCapacity = function (virtualMachineDevices, skippedDevice) {
            var result = 0;
            var allDiskDevices = virtualMachineDevices.devicesOfType("VirtualDisk");
            var allNewOrChangedPmemDisks = _.filter(allDiskDevices, function (disk) {
                // Existing Pmem Disks are already factored in by the backend
                if (!disk.isNew() && !disk.hasChanged()) {
                    return false;
                }
                if (!disk.isPmemDisk() || disk.isMarkedForRemoval()) {
                    return false;
                }
                if (skippedDevice
                    && (skippedDevice.getKey() === disk.getKey())) {
                    return false;
                }
                return true;
            });
            for (var _i = 0, allNewOrChangedPmemDisks_1 = allNewOrChangedPmemDisks; _i < allNewOrChangedPmemDisks_1.length; _i++) {
                var pmemDisk = allNewOrChangedPmemDisks_1[_i];
                result += this.getDeviceContributionToPmemCapacity(pmemDisk);
            }
            return result;
        };
        PmemCapacityService.prototype.getNvdimmContributionToPmemCapacity = function (virtualMachineDevices, skippedDevice) {
            var result = 0;
            var allNvdimmDevices = virtualMachineDevices.devicesOfType(h5_vm.PmemUtilService.NVDIMM);
            var filteredNvdimmDevices = _.filter(allNvdimmDevices, function (nvdimm) {
                // Existing Nvdimms are already factored in by the backend
                if (!nvdimm.isNew() && !nvdimm.hasChanged()) {
                    return false;
                }
                if (skippedDevice
                    && (skippedDevice.getKey() === nvdimm.getKey())) {
                    return false;
                }
                if (nvdimm.isMarkedForRemoval()) {
                    return false;
                }
                return true;
            });
            for (var _i = 0, filteredNvdimmDevices_1 = filteredNvdimmDevices; _i < filteredNvdimmDevices_1.length; _i++) {
                var nvdimmDevice = filteredNvdimmDevices_1[_i];
                result += this.getDeviceContributionToPmemCapacity(nvdimmDevice);
            }
            return result;
        };
        PmemCapacityService.prototype.getTotalNvdimmAndRamMemory = function (vmConfigContext, virtualMachineDevices, skippedDevice) {
            return this.getTotalNvdimmMemory(virtualMachineDevices, skippedDevice) +
                vmConfigContext.config.hardware.memoryMB;
        };
        PmemCapacityService.prototype.getDeviceContributionToPmemCapacity = function (device) {
            return device.getCapacityDiff();
        };
        PmemCapacityService.$inject = [
            "pmemUtilService"
        ];
        return PmemCapacityService;
    }());
    h5_vm.PmemCapacityService = PmemCapacityService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("pmemCapacityService", PmemCapacityService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var PmemUtilService = (function () {
        function PmemUtilService(featureFlagsService) {
            this.featureFlagsService = featureFlagsService;
        }
        PmemUtilService.prototype.findOption = function (vmConfigEnvironment, type) {
            var deviceOptions = vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption;
            for (var _i = 0, deviceOptions_1 = deviceOptions; _i < deviceOptions_1.length; _i++) {
                var deviceOption = deviceOptions_1[_i];
                if (deviceOption.type.wsdlName === type) {
                    return deviceOption;
                }
            }
            return undefined;
        };
        PmemUtilService.prototype.getNvdimmController = function (virtualMachineDevices) {
            var nvdimmControllerArray = virtualMachineDevices.devicesOfType(PmemUtilService.NVDIMM_CONTROLLER);
            if (nvdimmControllerArray.length) {
                // Only one NVDIMM controller is allowed
                return nvdimmControllerArray[0];
            }
            return undefined;
        };
        PmemUtilService.prototype.getPmemStorageProfile = function (storagePolicies) {
            for (var _i = 0, storagePolicies_1 = storagePolicies; _i < storagePolicies_1.length; _i++) {
                var storagePolicy = storagePolicies_1[_i];
                if (this.isPMemStoragePolicy(storagePolicy)) {
                    return storagePolicy;
                }
            }
            return undefined;
        };
        /**
         * Finds out whether a given storage policy object is a PMem storage policy.
         *
         * @param storagePolicy The storage policy object that is being tested.
         *
         * @return <code>true</code> if the given storage policy is а PMem storage
         *       policy (which currently means "uses the PMem namespace"),
         *       <code>false</code> otherwise.
         */
        PmemUtilService.prototype.isPMemStoragePolicy = function (storagePolicy) {
            if (!storagePolicy || !storagePolicy.profileObj) {
                return false;
            }
            var capBasedProfile = storagePolicy.profileObj;
            if (capBasedProfile === null) {
                return false;
            }
            var profileConstraints = capBasedProfile.constraints;
            if (!profileConstraints || !profileConstraints.subProfiles) {
                return false;
            }
            for (var _i = 0, _a = profileConstraints.subProfiles; _i < _a.length; _i++) {
                var subProfile = _a[_i];
                if (!subProfile || !subProfile.capability) {
                    continue;
                }
                for (var _b = 0, _c = subProfile.capability; _b < _c.length; _b++) {
                    var capability = _c[_b];
                    if (!capability
                        || !capability.id
                        || !capability.id.namespace) {
                        continue;
                    }
                    if (capability.id.namespace.toLowerCase()
                        === PmemUtilService.PMEM_NAMESPACE_LOWERCASE) {
                        return true;
                    }
                }
            }
            return false;
        };
        PmemUtilService.prototype.getAvailablePmemCapacity = function (vmConfigContext) {
            return vmConfigContext.environment
                .configTarget.availablePersistentMemoryReservationMB;
        };
        PmemUtilService.prototype.getSupportedPmemByGuestOs = function (guestOs) {
            return guestOs.supportedMaxPersistentMemoryMB;
        };
        PmemUtilService.prototype.isPmemDisk = function (device /* VirtualDisk */) {
            if (!device || !device.backing) {
                return false;
            }
            var diskBacking = device.backing;
            return diskBacking._type
                === "com.vmware.vim.binding.vim.vm.device.VirtualDisk$LocalPMemBackingInfo";
        };
        PmemUtilService.prototype.filterOutPmemProfileIfNeeded = function (storageProfiles, vmConfigContext, disk) {
            if (this.shouldFilterOutPmemStoragePolicy(vmConfigContext, disk)) {
                return this.filterOutPmemStoragePolicy(storageProfiles);
            }
            else {
                return storageProfiles;
            }
        };
        PmemUtilService.prototype.filterOutPmemStoragePolicy = function (storageProfiles) {
            var _this = this;
            if (!storageProfiles
                || storageProfiles.length === 0) {
                return storageProfiles;
            }
            return _.filter(storageProfiles, function (profile) {
                return !_this.isPMemStoragePolicy(profile);
            });
        };
        /**
         * Pmem Storage policy should be removed from the list of storage policies
         * when: the VM is poweredOn, because backend doesn't allow hot add of pmem disks.
         * When the disk is RDM, because the disk is real hardware, that cannot be moved
         * to Pmem for obvious reasons.
         * When the disk is not freshly added, but is old (already existing), because the
         * backend doesn't allow migration of an existing disk to Pmem, same goes for
         * existing disk created by a source file.
         *
         * Removing the Pmem Storage Policy doesn't allow the user to submit incorrect
         * tasks to the VC.
         */
        PmemUtilService.prototype.shouldFilterOutPmemStoragePolicy = function (vmConfigContext, disk) {
            var isVmPoweredOn = vmConfigContext.environment.powerState === "poweredOn";
            if (disk.isRDMDisk() || disk.isCreatedFromExistingDisk()) {
                return true;
            }
            if (isVmPoweredOn && disk.isNew()) {
                return true;
            }
            if (!isVmPoweredOn && !disk.isPmemDisk() && !disk.isNew()) {
                return true;
            }
            return false;
        };
        PmemUtilService.$inject = [
            "featureFlagsService"
        ];
        PmemUtilService.NVDIMM = "VirtualNVDIMM";
        PmemUtilService.NVDIMM_CONTROLLER = "VirtualNVDIMMController";
        // The lower case name of the PMem storage policy capability namespace.
        // Lower case is used, so that changes like going from "PMem" to "PMEM"
        // don't affect us.
        PmemUtilService.PMEM_NAMESPACE_LOWERCASE = "pmem";
        return PmemUtilService;
    }());
    h5_vm.PmemUtilService = PmemUtilService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("pmemUtilService", PmemUtilService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VirtualDisk$LocalPMemBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualDisk$LocalPMemBackingInfo;
    var VirtualDisk$FlatVer2BackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualDisk$FlatVer2BackingInfo;
    /**
     * The service encapsulates the operations for placing a Virtual Disk from
     * the regular storage to Pmem storage and from Pmem to regular.
     *
     * For NewVM/Edit Settings, this is expressed by the disk's Backing object.
     * In the Pmem case there is a special VirtualDisk$LocalPMemBackingInfo required by
     * the backend.
     *
     * For Clone VM the disk going on Pmem are represented as deviceChange and must be
     * filtered out from DiskLocator. Disks going on Pmem must be converted into
     * deviceChange.
     */
    var VirtualDiskPmemService = (function () {
        function VirtualDiskPmemService(pmemUtilService, pmemCapacityService, storageSelectorConstants, VirtualDisk, storageProfileService, diskProvisioningService) {
            this.pmemUtilService = pmemUtilService;
            this.pmemCapacityService = pmemCapacityService;
            this.storageSelectorConstants = storageSelectorConstants;
            this.VirtualDisk = VirtualDisk;
            this.storageProfileService = storageProfileService;
            this.diskProvisioningService = diskProvisioningService;
        }
        VirtualDiskPmemService.prototype.getDefaultMinValueForNewPmemDisk = function () {
            return VirtualDiskPmemService.DEFAULT_MIN_VALUE_FOR_NEW_PMEM_DISK;
        };
        /**
         * Changes disk backing acording to applied storage profile.
         * Intended for usage in EditSettings/Customize hardware.
         * @param disk - an inflated VirtualDisk
         * @param storageProfile - applied StorageProfile
         * @returns {boolean} - true if the disk is Pmem after the operation
         */
        VirtualDiskPmemService.prototype.handlePmemIfPmemProfile = function (disk, storageProfile, selectedDiskFormat) {
            var isPmem = disk.isPmemDisk();
            var isNewProfilePmem = this.pmemUtilService.isPMemStoragePolicy(storageProfile);
            if (isPmem && isNewProfilePmem) {
                return true;
            }
            if (!isPmem && isNewProfilePmem) {
                this.setPmemBacking(disk);
                return true;
            }
            if (!isPmem && !isNewProfilePmem) {
                return false;
            }
            if (isPmem && !isNewProfilePmem && disk.isNew()) {
                disk.restoreOriginalBacking();
                return false;
            }
            if (isPmem && !isNewProfilePmem && !disk.isNew()) {
                // The only possible option to get in here is during clone when we choose to
                // customize hardware before finish and the PMEM disk has been downgraded
                // In this case VirtualDeviceSpec.fileOperation must be left unset which
                // according to VMODL doc requires the device.backing.fileName to be set.
                // Here we restore the original file name after resetting the backing.
                var originalFile = disk.getCurrentDevice().backing.fileName;
                this.setFlatDiskBacking(disk);
                disk.getCurrentDevice().backing.fileName = originalFile;
                this.setDiskFormat(disk, selectedDiskFormat);
                return false;
            }
            return false;
        };
        /**
         * Utility method, that encapsulates the logic weather we want to apply any
         * Pmem rules depending on the selected storage baseline and if a disk is already pmem.
         * In Hybrid mode the Pmem profile must be applied only to already Pmem Disks.
         * In Pmem mode every disk, no matter if pmem or not, has to have the Pmem profile applied.
         * @param {string} storageBaselineId
         * @param {VirtualDisk} inflatedDevice
         * @returns false if the storageBaseline is Hybrid and disk isn't Pmem,
         *       false if disk profile was set manually by the user.
         *       always true if storageBaseline is Pmem
         */
        VirtualDiskPmemService.prototype.shouldApplyPmemProfileToDisk = function (inflatedDevice, storageBaselineId) {
            // Do not allow change of storage profile, when user has set it explicitly.
            if (inflatedDevice.isStorageProfileManuallySet()) {
                return false;
            }
            if (inflatedDevice.isPmemDisk()
                && this.storageSelectorConstants.HYBRID_STORAGE_BASELINE.id === storageBaselineId) {
                return true;
            }
            return this.storageSelectorConstants.PMEM_STORAGE_BASELINE.id === storageBaselineId;
        };
        /**
         * Removes some disks from the input array according to Pmem Rules.
         * Any virtual disks that are to be moved to Pmem Storage in Clone Workflow must
         * be represented as deviceChange in RelocateSpec, not as DiskLocator.
         * @param virtualDisks - array of virtual disk devices
         * @param storageBaselineId - id of the storage baseline (Hybrid, Standard, Pmem)
         * @param newDisks - specifies if the filtered disks are original disks or newly
         *       created disks. In CloneVm only the default state of new VirtualDisks is
         *       controlled by the storageBaseline and the user has control over them.
         * @returns an array of virtual disks that have to be converted to DiskLocators
         */
        VirtualDiskPmemService.prototype.filterVirtualDisksToDiskLocatorsForPmem = function (virtualDisks, storageBaselineId, newDisks) {
            if (newDisks === void 0) { newDisks = false; }
            if (storageBaselineId === this.storageSelectorConstants.STANDARD_STORAGE_BASELINE.id) {
                if (newDisks) {
                    return this.filterOutPmemDisks(virtualDisks);
                }
                else {
                    return virtualDisks;
                }
            }
            if (storageBaselineId === this.storageSelectorConstants.HYBRID_STORAGE_BASELINE.id) {
                return this.filterOutPmemDisks(virtualDisks);
            }
            if (storageBaselineId === this.storageSelectorConstants.PMEM_STORAGE_BASELINE.id) {
                if (newDisks) {
                    return this.filterOutPmemDisks(virtualDisks);
                }
                else {
                    return [];
                }
            }
            return virtualDisks;
        };
        /**
         * Removes some disks from the input array according to Pmem Rules.
         * Any virtual disks that are to be moved to Pmem Storage in Clone Workflow must
         * be represented as deviceChange in RelocateSpec, not as DiskLocator.
         * @param virtualDisks - array of virtual disk devices
         * @param storageSelectorDisks - the whole Advanced Configuration for Disks
         * @returns an array of virtual disks that have to be converted to DiskLocators
         */
        VirtualDiskPmemService.prototype.filterVirtualDisksToDiskLocatorsForPmemAdvanced = function (virtualDisks, storageSelectorDisks) {
            var _this = this;
            return _.filter(virtualDisks, function (virtualDisk) {
                var advancedStorageConfigForDisk = _this.findAdvancedConfigurationForDisk(virtualDisk.key, storageSelectorDisks);
                return !advancedStorageConfigForDisk
                    || !_this.pmemUtilService.isPMemStoragePolicy(advancedStorageConfigForDisk.storageProfile);
            });
        };
        /**
         * Builds the backings for disks that must be placed on normal storage.
         * @param backing - backing used for the virtual disk
         * @param storageBaselineId - id of the storage baseline (Hybrid, Standard, Pmem)
         * @returns appropriate backing that is to be used for this virtual disk in a
         *       DiskLocator
         */
        VirtualDiskPmemService.prototype.applyPmemRulesOnVirtualDiskBacking = function (backing, storageBaselineId, diskFormat) {
            if ((storageBaselineId === this.storageSelectorConstants.STANDARD_STORAGE_BASELINE.id
                || storageBaselineId === this.storageSelectorConstants.HYBRID_STORAGE_BASELINE.id)
                && this.pmemUtilService.isPmemDisk({ backing: backing })) {
                return this.diskProvisioningService.getBackingInfo(diskFormat.type);
            }
            else {
                return backing;
            }
        };
        /**
         * Function variant for advanced storage mode.
         * Builds the backings backings for disks that must be placed on normal storage.
         * @param diskKey - key needed to pull the diks config from the whole advanced config.
         * @param backing - backing used for the virtual disk
         * @param storageSelectorDisks - the whole Advanced Configuration for Disks
         * @returns appropriate backing that is to be used for this virtual disk in a
         *       DiskLocator
         */
        VirtualDiskPmemService.prototype.applyPmemRulesOnVirtualDiskBackingAdvanced = function (diskKey, backing, storageSelectorDisks) {
            var advancedStorageConfigForDisk = this.findAdvancedConfigurationForDisk(diskKey, storageSelectorDisks);
            if (advancedStorageConfigForDisk
                && !this.pmemUtilService.isPMemStoragePolicy(advancedStorageConfigForDisk.storageProfile)
                && this.pmemUtilService.isPmemDisk({ backing: backing })) {
                return this.diskProvisioningService.getBackingInfo(advancedStorageConfigForDisk.diskFormat.type);
            }
            else {
                return backing;
            }
        };
        /**
         * Any virtual disks that are to be moved to Pmem Storage must
         * be represented as deviceChange in RelocateSpec.
         * @param virtualDisk - disk Device that is to be moved to Pmem Storage
         * @param storageBaselineId - id of the storage baseline (Hybrid, Standard, Pmem)
         * @param storageProfile - current StorageProfile assigned to the disk Device
         * @returns the device change if any for the virtualDisk
         */
        VirtualDiskPmemService.prototype.convertVirtualDiskToDeviceChangeForPmem = function (virtualDisk, storageBaselineId, storageProfile) {
            if (this.pmemUtilService.isPmemDisk(virtualDisk)
                || !this.pmemUtilService.isPMemStoragePolicy(storageProfile)
                || (storageBaselineId
                    && storageBaselineId !== this.storageSelectorConstants.PMEM_STORAGE_BASELINE.id)) {
                return undefined;
            }
            return this.convetVirtualDiskToDeviceChangeInternal(virtualDisk, storageProfile);
        };
        /**
         * Any virtual disks that are to be moved to Pmem Storage must
         * be represented as deviceChange in RelocateSpec. Looks up the disks advanced
         * configuration for selected profile
         * @param virtualDisk - disk Device that is to be moved to Pmem Storage
         * @param {Array<any>} storageSelectorDisks - advanced configuration for disks
         * @returns the device change if any for the virtualDisk
         */
        VirtualDiskPmemService.prototype.convertVirtualDiskToDeviceChangeForPmemAdvanced = function (virtualDisk, storageSelectorDisks) {
            var advancedStorageConfigForDisk = this.findAdvancedConfigurationForDisk(virtualDisk.key, storageSelectorDisks);
            var userSelectedStorageProfile = advancedStorageConfigForDisk.storageProfile;
            // When the virtualDisk was Pmem, it'll have a Pmem Backing and when it still has
            // Pmem Profile assigned it doesn't need to be represented as device change.
            // When a disk is upgraded to Pmem it will have a non-Pmem Backing and needs
            // to be represented as deviceChange.
            if (this.pmemUtilService.isPmemDisk(virtualDisk)
                || !this.pmemUtilService.isPMemStoragePolicy(userSelectedStorageProfile)) {
                return undefined;
            }
            return this.convetVirtualDiskToDeviceChangeInternal(virtualDisk, userSelectedStorageProfile);
        };
        /**
         * Provides info about what disks the VM uses.
         * Note: the return format is used for consistency with Migrate VM case. Also
         * in the future the exposing of the storageBaselineId may be deprecated and
         * this return format will be more suitable.
         * @returns {hasPmemDisk: true of there is at least one Pmem disk;
         *       hasRegularDisk: ture if there is at least one non-PmemDisk}
         */
        VirtualDiskPmemService.prototype.getPmemDiskInfo = function (storageSelectorState) {
            var storageBaselineId = storageSelectorState
                ? storageSelectorState.storageBaselineId : "";
            switch (storageBaselineId) {
                case this.storageSelectorConstants.PMEM_STORAGE_BASELINE.id:
                    return {
                        hasPmemDisk: true,
                        hasRegularDisk: false,
                        hasDowngradedPmemDisk: false
                    };
                case this.storageSelectorConstants.HYBRID_STORAGE_BASELINE.id:
                    return {
                        hasPmemDisk: true,
                        hasRegularDisk: true,
                        hasDowngradedPmemDisk: false
                    };
                case this.storageSelectorConstants.STANDARD_STORAGE_BASELINE.id:
                    if (storageSelectorState.vmStorageConfigInAdvancedMode
                        && storageSelectorState.vmStorageConfigInAdvancedMode[0]
                        && storageSelectorState.vmStorageConfigInAdvancedMode[0].vmDisks) {
                        var hasDowngradedPmemDisk = !!this.advancedConfigurationForDiskHasPmemDisk(storageSelectorState.vmStorageConfigInAdvancedMode[0].vmDisks);
                        return {
                            hasPmemDisk: false,
                            hasRegularDisk: true,
                            hasDowngradedPmemDisk: hasDowngradedPmemDisk
                        };
                    }
                    else {
                        return {
                            hasPmemDisk: false,
                            hasRegularDisk: true,
                            hasDowngradedPmemDisk: false
                        };
                    }
                default:
                    return {
                        hasPmemDisk: false,
                        hasRegularDisk: false,
                        hasDowngradedPmemDisk: false
                    };
            }
        };
        /**
         * Returns the max allowed capacity for Pmem Disk.
         * @param {com.vmware.vsphere.client.vm.config.VmConfigContext} vmConfigContext -
         *       the config context for the compute resource.
         * @param disk - Pmem disk for which maximum size is to be calculated.
         * @param virtualMachineDevices - the current devices of the vm. Used to include
         *       any new NVDIMMs or PmemDisks in the calculation.
         * @returns {number}
         */
        VirtualDiskPmemService.prototype.getMaxAllowedCapacity = function (vmConfigContext, disk, virtualMachineDevices) {
            return this.pmemCapacityService.getMaxCapacityForPmemDisk(vmConfigContext, disk, virtualMachineDevices);
        };
        VirtualDiskPmemService.prototype.setPmemBacking = function (disk) {
            disk.getCurrentDevice().backing = this.generateDefaultPmemBacking();
        };
        VirtualDiskPmemService.prototype.setFlatDiskBacking = function (disk) {
            disk.getCurrentDevice().backing = this.generateDefaultFlatVer2Backing();
        };
        VirtualDiskPmemService.prototype.filterOutPmemDisks = function (virtualDisks) {
            var _this = this;
            return _.filter(virtualDisks, function (virtualDisk) {
                return !_this.pmemUtilService.isPmemDisk(virtualDisk);
            });
        };
        VirtualDiskPmemService.prototype.findAdvancedConfigurationForDisk = function (virtualDiskKey, storageSelectorDisks) {
            return _.find(storageSelectorDisks, function (advancedConfig) { return advancedConfig.key === virtualDiskKey; });
        };
        VirtualDiskPmemService.prototype.advancedConfigurationForDiskHasPmemDisk = function (storageSelectorDisks) {
            var _this = this;
            if (!storageSelectorDisks.length) {
                return false;
            }
            return _.find(storageSelectorDisks, function (advancedConfig) { return _this.pmemUtilService.isPMemStoragePolicy(advancedConfig.storageProfile); });
        };
        VirtualDiskPmemService.prototype.convetVirtualDiskToDeviceChangeInternal = function (virtualDisk, storageProfile) {
            var wrappedVirtualDisk = new this.VirtualDisk(virtualDisk);
            this.setPmemBacking(wrappedVirtualDisk);
            var deviceChange = wrappedVirtualDisk.getCurrentDeviceSpec();
            deviceChange.fileOperation = "create";
            deviceChange.operation = "add";
            deviceChange.profile = [
                this.storageProfileService.makeProfile(storageProfile.id)];
            return deviceChange;
        };
        VirtualDiskPmemService.prototype.generateDefaultPmemBacking = function () {
            var result = new VirtualDisk$LocalPMemBackingInfo();
            result.diskMode = "persistent";
            result.fileName = "";
            return result;
        };
        VirtualDiskPmemService.prototype.generateDefaultFlatVer2Backing = function () {
            var result = new VirtualDisk$FlatVer2BackingInfo();
            result.diskMode = "persistent";
            result.fileName = "";
            return result;
        };
        /**
         * Adds proper thinProvisioned & eagerlyScrub properties
         * to the backing of the disk based on the provided disk format
         *
         * @param disk
         * @param selectedFormat
         */
        VirtualDiskPmemService.prototype.setDiskFormat = function (disk, selectedFormat) {
            if (!disk.getCurrentDevice().backing || !selectedFormat) {
                return;
            }
            var keys = this.diskProvisioningService.backingInfoKeys(selectedFormat.type);
            angular.extend(disk.getCurrentDevice().backing, keys);
        };
        VirtualDiskPmemService.$inject = [
            "pmemUtilService",
            "pmemCapacityService",
            "storageSelectorConstants",
            "VirtualDisk",
            "storageProfileService",
            "diskProvisioningService"
        ];
        VirtualDiskPmemService.DEFAULT_MIN_VALUE_FOR_NEW_PMEM_DISK = 1;
        return VirtualDiskPmemService;
    }());
    h5_vm.VirtualDiskPmemService = VirtualDiskPmemService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("virtualDiskPmemService", VirtualDiskPmemService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (SizeUnits) {
        SizeUnits[SizeUnits["MB"] = 0] = "MB";
        SizeUnits[SizeUnits["GB"] = 1] = "GB";
        SizeUnits[SizeUnits["TB"] = 2] = "TB";
    })(h5_vm.SizeUnits || (h5_vm.SizeUnits = {}));
    var SizeUnits = h5_vm.SizeUnits;
    var DiskSize = (function () {
        function DiskSize() {
            this.unit = SizeUnits.MB;
        }
        return DiskSize;
    }());
    h5_vm.DiskSize = DiskSize;
    var BasicDiskUtilService = (function () {
        function BasicDiskUtilService(i18nService) {
            this.i18nService = i18nService;
            //MB->GB->TB converter
            this.SIZE_DENOMINATOR = 1024;
            //if more than 1024, must upgrade the unit
            this.SIZE_REQUIRES_CONVERSION = 1024;
        }
        /**
         * given a number, outputs its rounded off value to the precision specified
         * ex: service.toPrecision(10.294, 1) => 10.3
         * @param number
         * @param precision
         * @returns {number}
         */
        BasicDiskUtilService.prototype.roundToPrecision = function (anyNumber, precision) {
            var factor = Math.pow(10, precision);
            return Math.round(anyNumber * factor) / factor;
        };
        /**
         * given a diskSize in Mb, returns a DiskSize type
         * with the size appropriately set for display with the right unit
         * @param valueInMb
         * @returns {DiskSize}
         */
        BasicDiskUtilService.prototype.determineDisplayDiskSize = function (valueInMb) {
            var result = new DiskSize();
            if (valueInMb <= this.SIZE_REQUIRES_CONVERSION) {
                result.size = valueInMb; //stays MB
            }
            else {
                result.size = valueInMb / this.SIZE_DENOMINATOR; //GB
                result.unit = SizeUnits.GB;
                if (result.size > this.SIZE_REQUIRES_CONVERSION) {
                    result.size = result.size / this.SIZE_DENOMINATOR;
                    result.unit = SizeUnits.TB;
                }
            }
            result.unitText = this.i18nService.getString('VmUi', 'Vm.Units.' + SizeUnits[result.unit]);
            return result;
        };
        BasicDiskUtilService.$inject = ['i18nService'];
        return BasicDiskUtilService;
    }());
    h5_vm.BasicDiskUtilService = BasicDiskUtilService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("basicDiskUtilService", BasicDiskUtilService);
})(h5_vm || (h5_vm = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service('contentLibraryService', contentLibraryService);

   contentLibraryService.$inject = ['dataService', 'mutationService', 'defaultUriSchemeUtil', '$q', 'sourceTypeConstants', '$injector'];

   function contentLibraryService(dataService, mutationService, defaultUriSchemeUtil, $q, sourceTypeConstants, $injector) {
      var RESOURCE_POOL_VALIDATION_SPEC_CLASS = 'com.vmware.vsphere.client.provisioning.spec.DeployOnResourcePoolValidationSpec';
      var RESOURCE_POOL_FILEINFO_VALIDATION_SPEC_CLASS = 'com.vmware.vsphere.client.provisioning.spec.FileInfoValidationSpec';
      var NETWORK_VALIDATION_SPEC_CLASS = 'com.vmware.vsphere.client.provisioning.spec.NetworkConfigValidationSpec';
      var DEPLOY_VM_SPEC_CLASS = 'com.vmware.vsphere.client.provisioning.spec.DeployOnResourcePoolSpec';
      var STORAGE_VALIDATIONSPEC_CLASS = 'com.vmware.vsphere.client.provisioning.ovf.spec.StorageValidationSpec';
      var MANAGEDOBJECT_CLASS = 'com.vmware.vim.binding.vmodl.ManagedObjectReference';
      var LIBRARY_ITEM_BY_ITEM_ID = "contentLibraryItemByItemId";
      var LIBRARY_ITEM_BY_DATASTORE = "contentLibraryItemByDatastorePath";
      var LIBARAY_ITEM_DUMMY_ID = "urn:vapi:com.vmware.content.library.Item:6a0aea7f-2222-2222-2222-b7cf1ad937f3:6a0aea7f-2222-2222-2222-b7cf1ad937f3";
      var RESOURCE_POOL_DEPLOY_SESSION = 'com.vmware.vsphere.client.provisioning.ovf.impl.ResourcePoolDeploySession';
      var VM_CUSTOMIZATION_SPECIFICATION = 'com.vmware.vsphere.client.vm.VmCustomizationSpecification';
      return {
         getAllTemplates: getAllTemplates,
         getTemplateData: getTemplateData,
         deployVmFromLibraryTemplate: deployVmFromLibraryTemplate,
         getAndValidateResourcePool: getAndValidateResourcePool,
         validateComputeResourceSelection: validateComputeResourceSelection,
         getResourcePoolForComputeResource: getResourcePoolForComputeResource,
         validateStorageSelection: validateStorageSelection,
         getContentLibraryItemWithIso:getContentLibraryItemWithIso,
         getContentLibraryItemByDatastorePath:getContentLibraryItemByDatastorePath,
         getXmlFormattedCustomizationSpec: getXmlFormattedCustomizationSpec,

         // Constants
         SYSTEM_DISK_GROUP_ID: 'ngcArtificialSystemDiskGroup',
         SYSTEM_DISK_GROUP_LABEL: 'All other disks'
      };

      function getAllTemplates(hostId) {
         var serverGuid = defaultUriSchemeUtil.getPartsFromVsphereObjectId(hostId).serverGuid;
         var rootFolder = defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
         return dataService.getProperties(rootFolder, ['libraryTemplates']);
      }

      function getTemplateData(templateId) {
         return dataService.getProperties(templateId, [
            'com.vmware.content.library.ItemModel/name',
            'com.vmware.content.library.ItemModel/libraryName',
            'com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osType',
            'com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osDescription'
         ]);
      }

      function deployVmFromLibraryTemplate(computeResourceId, vmFolderId, vmName, deploymentContext, inOvfMode, localDeploySession) {
         var computeResource = defaultUriSchemeUtil.getManagedObjectReference(computeResourceId);
         var vmFolder = null;
         if (vmFolderId) {
            vmFolder = defaultUriSchemeUtil.getManagedObjectReference(vmFolderId);
         }


         if (computeResource.type === "ResourcePool" || computeResource.type === "VirtualApp") {
            dataService.getProperties(computeResourceId, ['computeResource'])
               .then(function(result) {
                  return dataService.getProperties(defaultUriSchemeUtil.getVsphereObjectId(result.computeResource), ['network']);
               })
               .then(function() {
                  deployVm(computeResource, vmFolder, computeResource, vmName, deploymentContext, inOvfMode, localDeploySession);
               });
         } else {
            dataService.getProperties(computeResourceId, ['network'])
               .then(function() {
                  return getResourcePoolForComputeResource(computeResourceId);
               })
               .then(function(result) {
                  deployVm(result.resourcePool, vmFolder, computeResource, vmName, deploymentContext, inOvfMode, localDeploySession);
               });
         }
      }

      function getAndValidateResourcePool(computeResourceId, vmFolderId, vmName, templateId, sourceType, localDeploySession) {
         var computeResource = defaultUriSchemeUtil.getManagedObjectReference(computeResourceId);
         var vmFolder = null;
         if (vmFolderId) {
            vmFolder = defaultUriSchemeUtil.getManagedObjectReference(vmFolderId);
         }

         if(computeResource.type === "ResourcePool" || computeResource.type === "VirtualApp"){
            return validateResourcePoolDeployment(computeResource, vmFolder, computeResource, vmName, templateId, sourceType, localDeploySession);
         } else {
            return getResourcePoolForComputeResource(computeResourceId)
               .then(function(response) {
                  return validateResourcePoolDeployment(response.resourcePool, vmFolder, computeResource, vmName, templateId, sourceType, localDeploySession);
               });
         }
      }

      function validateComputeResourceSelection(targetId){
         var deployOnResourcePoolSpec = {
            name: null,
            inOvfMode: false,
            inVmMode: true,
            parameters: null,
            vmFolder: null,
            host: null,
            resourcePool: null
         };
         return mutationService.validate(targetId, DEPLOY_VM_SPEC_CLASS, deployOnResourcePoolSpec);
      }

      function validateResourcePoolDeployment(resourcePool, vmFolder, computeResource, newVmName, templateId, sourceType, localDeploySession) {
         if (_.isEmpty(sourceType)) {
            sourceType = 'CONTENT_LIBRARY_SOURCE';
         }
         var isLocalOvfDeployment = sourceType === sourceTypeConstants.SOURCE_TYPE_PUSH;
         var deployOnResourcePoolValidationSpec = createDeploymentSpec(computeResource, newVmName, templateId, resourcePool, vmFolder, sourceType);

         if(computeResource.type === "HostSystem"){
            deployOnResourcePoolValidationSpec.host = _.extend({_type: MANAGEDOBJECT_CLASS}, computeResource);
         }

         var resourcePoolId = defaultUriSchemeUtil.getVsphereObjectId(resourcePool);
         if (!isLocalOvfDeployment) {
            return mutationService.validate(
               resourcePoolId,
               RESOURCE_POOL_VALIDATION_SPEC_CLASS,
               deployOnResourcePoolValidationSpec
            );
         }
         return validateLocalDeploymentOnResourcePool(localDeploySession, deployOnResourcePoolValidationSpec, resourcePool);
      }

      function validateLocalDeploymentOnResourcePool(localDeploySession, deployOnResourcePoolValidationSpec, resourcePool) {
         var pushContentType = localDeploySession ? sourceTypeConstants.PUSH_TYPE_OVF : undefined;
         var pushOvfOption = localDeploySession ? buildOvfOption(localDeploySession) : undefined;
         deployOnResourcePoolValidationSpec.pushContentType = pushContentType;
         deployOnResourcePoolValidationSpec.pushOvfOption = pushOvfOption;
         var encodedDescriptorName = encodeURIComponent(localDeploySession.descriptor.name);
         deployOnResourcePoolValidationSpec.template = 'file:///' + encodedDescriptorName;
         var fileInfoValidaitionSpec = {
            deploymentSpec: deployOnResourcePoolValidationSpec
         };
         var resourcePoolId = defaultUriSchemeUtil.getVsphereObjectId(resourcePool);
         return mutationService.validate(
               resourcePoolId,
               RESOURCE_POOL_FILEINFO_VALIDATION_SPEC_CLASS,
               fileInfoValidaitionSpec)
            .then(function (response) {
               if (response && response.result) {
                  var workflowManagerService = $injector.get('vscOvfWorkflowProxyService');
                  var sessionId = localDeploySession.sessionId;

                  deployOnResourcePoolValidationSpec.commonContext = response.result.newContext;
                  var descriptorUri = response.result.descriptorURI;
                  workflowManagerService.mapDescriptorUrl(sessionId, descriptorUri);

                  var deployOvfSessionId = _.find(response.result.newContext, function(item) {
                     return item._type === RESOURCE_POOL_DEPLOY_SESSION;
                  });
                  deployOvfSessionId = (deployOvfSessionId && deployOvfSessionId.sessionId) ? deployOvfSessionId.sessionId : '';

                  workflowManagerService.mapDeployOvfSessionId(sessionId, deployOvfSessionId);

                  var manifestUri = response.result.manifestURI;
                  if (manifestUri && manifestUri.length !== 0) {
                     workflowManagerService.mapManifestUrl(sessionId, manifestUri);
                  }

                  var certificateUri = response.result.certificateURI;
                  if (certificateUri && certificateUri.length !== 0) {
                     workflowManagerService.mapCertificateUrl(sessionId, certificateUri);
                  }
                  return workflowManagerService.uploadDescriptorWithAccessories$(sessionId)
                     .then(function () {
                        return mutationService.validate(
                           resourcePoolId,
                           RESOURCE_POOL_VALIDATION_SPEC_CLASS,
                           deployOnResourcePoolValidationSpec);
                     });
               }
               return $q.reject();
            });
      }

      function createDeploymentSpec(computeResource, newVmName, templateId, resourcePool, vmFolder, sourceType) {
         return {
            commonContext: [{
               _type: 'com.vmware.vsphere.client.provisioning.workflow.Workflow',
               id: 'deployVmOnResourcePool',
               contextObject: computeResource
            }],
            name: newVmName,
            template: templateId,
            provisioningTarget: _.extend({_type: MANAGEDOBJECT_CLASS}, resourcePool),
            folder: vmFolder,
            sourceType: sourceType
         };
      }

      function buildOvfOption(localDeploySession) {
         if (!localDeploySession) {
            return sourceTypeConstants.PUSH_OVF_OPTION_NONE;
         }

         if (localDeploySession.certificate && localDeploySession.manifest) {
            return sourceTypeConstants.PUSH_OVF_OPTION_MFCERT;
         }

         if (localDeploySession.manifest) {
            return sourceTypeConstants.PUSH_OVF_OPTION_MF;
         }

         return sourceTypeConstants.PUSH_OVF_OPTION_NONE;
      }

      function validateNetworkConfig(resourcePool, deploymentContext, targetNetwork) {
         var networkConfigValidationSpec = {
            ipAllocationValidationSpec: {
               commonContext: deploymentContext,
               ovfIpAllocationParams: deploymentContext[3]
            },
            networkMappingsValidationSpec: {
               commonContext: deploymentContext,
               mappingSpec: {
                  networkMappings: [{
                     targetNetworkRef: targetNetwork
                  }]
               }
            }
         };

         var resourcePoolId = defaultUriSchemeUtil.getVsphereObjectId(resourcePool);
         return mutationService.validate(resourcePoolId, NETWORK_VALIDATION_SPEC_CLASS, networkConfigValidationSpec);
      }

      function validateStorageSelection(
            resourcePoolId, diskGroups, commonContext) {
         var storageValidationSpec = buildStorageValidationSpec(
               diskGroups, commonContext);
         return mutationService.validate(
               resourcePoolId, STORAGE_VALIDATIONSPEC_CLASS, storageValidationSpec);
      }

      function deployVm(resourcePool, vmFolder, computeResource, newVmName, deploymentContext, inOvfMode, localDeploySession) {
         var deployOnResourcePoolSpec = {
            name: newVmName,
            inOvfMode: _.isUndefined(inOvfMode) ? null : inOvfMode,
            inVmMode: true,
            parameters: deploymentContext,
            vmFolder: vmFolder,
            host: (computeResource.type === 'HostSystem') ? computeResource : null,
            resourcePool: resourcePool
         };

         mutationService.add(DEPLOY_VM_SPEC_CLASS, deployOnResourcePoolSpec).then(function(response) {
             if (localDeploySession) {
                if (response && response.result) {
                   var workflowManagerService = $injector.get('vscOvfWorkflowProxyService');
                   var sessionId = localDeploySession.sessionId;
                   var urls = [];
                   _.each(response.result.fileByUri, function(url, file) {
                      urls.push(url);
                   });

                   if (urls.length > 0) {
                      workflowManagerService.mapOtherUrls(sessionId, urls);
                      workflowManagerService.uploadOtherFiles$(sessionId);
                   }
                }
             }
         });
      }

      function getResourcePoolForComputeResource(computeResourceId) {
         var computeResourceType = defaultUriSchemeUtil.getEntityType(computeResourceId);
         var computeResource = defaultUriSchemeUtil.getManagedObjectReference(computeResourceId);
         if (computeResourceType === "ResourcePool" || computeResourceType === "VirtualApp") {
            return $q.when({resourcePool: computeResource});
         }
         return dataService.getProperties(computeResourceId, ['resourcePool']);
      }

      function buildStorageValidationSpec(diskGroups, commonContext) {
         _.each(diskGroups, function (diskGroup) {
            var newProvisionigType = convertProvisioningTypeForContentLibrary(
                  diskGroup.targetProvisioningType);
            diskGroup.targetProvisioningType = newProvisionigType || 'thick';
         });

         return {
            commonContext: commonContext,
            diskGroups: diskGroups
         };
      }

      function convertProvisioningTypeForContentLibrary(provisioningType){
         if (provisioningType === 'flat') {
            return 'thick';
         } else if (provisioningType === 'thick') {
            return 'eagerZeroedThick';
         }
         return provisioningType;
      }

      function getContentLibraryItemWithIso(contentLibraryIsoItem){
         return dataService.getProperties(contentLibraryIsoItem.id, [LIBRARY_ITEM_BY_ITEM_ID]);
      }

      function getContentLibraryItemByDatastorePath(datastorePath){
         return dataService.getProperties(LIBARAY_ITEM_DUMMY_ID , [LIBRARY_ITEM_BY_DATASTORE], {
            propertyParams: [{
               propertyName: LIBRARY_ITEM_BY_DATASTORE,
               parameterType: "java.lang.String",
               parameter: datastorePath
            }]
         });
      }

      function getXmlFormattedCustomizationSpec(vcenterFolderId, info, spec) {
         return mutationService.validate(
               vcenterFolderId,
               VM_CUSTOMIZATION_SPECIFICATION,
               {
                  info: info,
                  spec: spec
               });
      }
   }
}());

angular.module('com.vmware.vsphere.client.vm').service('deviceDiffService', [
   function() {
      return {
         isUnchanged: isUnchanged
      };

      function isUnchanged(original, modified) {
         if(!_.isObject(original) || !_.isObject(modified)){
            throw new Error("isUnchanged only works with objects");
         }

         var modifiedKeys = _.keys(modified);
         var originalKeys = _.keys(original);
         var difference = _.difference(modifiedKeys, originalKeys);
         if (difference && difference.length > 0) {
            return false;
         }

         var changedField = false;
         _.each(modifiedKeys, function(key) {
            var modifiedValue = modified[key];
            var originalValue = original[key];

            if (areObjects(originalValue, modifiedValue)) {
               if (!isUnchanged(originalValue, modifiedValue)) {
                  changedField = true;
               }
            } else {
               if (modifiedValue !== originalValue) {
                  changedField = true;
               }
            }
         });

         return !changedField;
      }

      function areObjects(original, modified) {
         return _.isObject(modified) && _.isObject(original);
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var VmTurnOffFtSpec = com.vmware.vsphere.client.vm.ft.VmTurnOffFtSpec;
    var VM_FT_COMPATIBILITY_MODEL = "com.vmware.vsphere.client.vm.model.VmFtCompatibilityData";
    var VM_WARNINGS = "managedByVmWarnings";
    var VmFtService = (function () {
        function VmFtService(i18nService, mutationService, actionConfirmationService, dataService) {
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.actionConfirmationService = actionConfirmationService;
            this.dataService = dataService;
        }
        VmFtService.prototype.turnOffFt = function (vmId) {
            var _this = this;
            this.dataService.getData(vmId, VM_FT_COMPATIBILITY_MODEL)
                .then(function (vmFtData) {
                var extensionLabel = _this.getManagedByWarningText(vmFtData.managedByInfo);
                var warning = _this.i18nService.getString("VmUi", "ftTurnOffAction.warning");
                if (vmFtData.clusterData.isDrsEnabled
                    && !vmFtData.clusterData.isEvcEnabled) {
                    warning = _this.i18nService.getString("VmUi", "ftTurnOffAction.drsWarning");
                }
                if (extensionLabel !== "") {
                    warning = extensionLabel + "\n\n" + warning;
                }
                _this.actionConfirmationService.showConfirmationDialog({
                    title: _this.i18nService.getString("VmUi", "ftTurnOffAction.label"),
                    message: warning,
                    yesHandler: function () {
                        var turnOffFtSpec = new VmTurnOffFtSpec();
                        _this.mutationService.apply(vmId, turnOffFtSpec._type, turnOffFtSpec);
                    },
                    useClarity: true
                });
            });
        };
        VmFtService.prototype.getManagedByWarningText = function (managedByData) {
            if (managedByData === null) {
                return "";
            }
            var managedByLabels = _.map(managedByData, function (item) {
                if (item !== null && !item.isUnset) {
                    return item.value;
                }
                if (item !== null) {
                    return item;
                }
            });
            // None of the VMs or vApps were managed, simply return
            if (_.isEmpty(managedByLabels)) {
                return "";
            }
            var text = managedByData.length > 1 ?
                this.i18nService.getString("Common", "multiVmManagedByWarning") :
                this.i18nService.getString("Common", "singleVmManagedByWarning", managedByLabels[0]);
            return text;
        };
        VmFtService.$inject = ["i18nService", "mutationService",
            "actionConfirmationService", "dataService"];
        return VmFtService;
    }());
    h5_vm.VmFtService = VmFtService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmFtService', VmFtService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtVmPageService = (function () {
        function FtVmPageService($rootScope, i18nService, mutationService, defaultUriSchemeUtil, vuiConstants, vuiFtTurnOnWizard, vmFtConstants) {
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vuiConstants = vuiConstants;
            this.vuiFtTurnOnWizard = vuiFtTurnOnWizard;
            this.vmFtConstants = vmFtConstants;
            this.VIRTUAL_DEVICE_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualDisk";
        }
        FtVmPageService.prototype.buildSelectDatastoresPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "turnOnFtWizard.selectDatastoresPage.title"),
                description: this.i18nService.getString("VmUi", "turnOnFtWizard.selectDatastoresPage.description"),
                contentUrl: "vm-ui/resources/vm/views/ft/ftSelectDatastoresView.html",
                onCommit: function () {
                    var noErrors = true;
                    if (!wizardScope.manager.getIsAdvancedMode()) {
                        if (wizardScope.manager.getSelectedDatastore()) {
                            if (wizardScope.manager.getNoHostsCompatible()) {
                                _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.noHostsForDatastoreSelection"));
                                noErrors = false;
                            }
                            else {
                                _this.vuiFtTurnOnWizard.markPageComplete();
                            }
                        }
                        else {
                            _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.incompleteDatastoreSelection"));
                            noErrors = false;
                        }
                    }
                    else {
                        if (wizardScope.manager.validateSelectedDatastores()) {
                            if (wizardScope.manager.getNoHostsCompatible()) {
                                _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.noHostsForDatastoreSelection"));
                                noErrors = false;
                            }
                            else {
                                _this.vuiFtTurnOnWizard.markPageComplete();
                            }
                        }
                        else {
                            _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.incompleteDatastoreSelection"));
                            noErrors = false;
                        }
                    }
                    return noErrors;
                },
                disableNext: function () {
                    return wizardScope.wizardConfig.loading;
                }
            };
        };
        FtVmPageService.prototype.buildSelectHostPage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "turnOnFtWizard.selectHostPage.title"),
                description: this.i18nService.getString("VmUi", "turnOnFtWizard.selectHostPage.description"),
                contentUrl: "vm-ui/resources/vm/views/ft/ftSelectHostView.html",
                onCommit: function () {
                    var selectedHost = wizardScope.manager.getSelectedHost();
                    var hostHasErrors = _this.hasHostAnyErrors(selectedHost);
                    if (selectedHost && !hostHasErrors) {
                        _this.vuiFtTurnOnWizard.markPageComplete();
                        return true;
                    }
                    else {
                        if (!selectedHost) {
                            _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.noHostSelected"));
                        }
                        else if (hostHasErrors) {
                            _this.vuiFtTurnOnWizard.markPageIncompleteWithError(_this.i18nService.getString("VmUi", "turnOnFtWizard.error.invalidHostSelected"));
                        }
                        return false;
                    }
                },
                disableNext: function () {
                    return wizardScope.wizardConfig.loading;
                }
            };
        };
        FtVmPageService.prototype.buildReadyToCompletePage = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "turnOnFtWizard.summaryPage.title"),
                description: this.i18nService.getString("VmUi", "turnOnFtWizard.summaryPage.description"),
                contentUrl: "vm-ui/resources/vm/views/ft/ftReadyToCompleteView.html",
                onCommit: function () {
                    var manager = wizardScope.manager;
                    var objectId = manager.getTargetUid();
                    _this.mutationService.apply(objectId, "com.vmware.vsphere.client.vm.ft.VmCreateSecondarySpec", _this.getVmCreateSecondarySpec(manager));
                    return true;
                },
                finishReady: function () {
                    return !wizardScope.wizardConfig.loading;
                }
            };
        };
        FtVmPageService.prototype.getVmCreateSecondarySpec = function (manager) {
            var _this = this;
            var selectedHostMor = this.defaultUriSchemeUtil.getManagedObjectReference(manager.getSelectedHost().id);
            return {
                host: selectedHostMor,
                configSpec: {
                    _type: "com.vmware.vim.binding.vim.vm.FaultToleranceConfigSpec",
                    metaDataPath: {
                        _type: "com.vmware.vim.binding.vim.vm.FaultToleranceMetaSpec",
                        metaDataDatastore: manager.getSelectedDatastores()[this.vmFtConstants.fileTypes.TIE_BREAKER].provider
                    },
                    secondaryVmSpec: {
                        _type: "com.vmware.vim.binding.vim.vm.FaultToleranceVMConfigSpec",
                        vmConfig: manager.getSelectedDatastores()[this.vmFtConstants.fileTypes.CONFIGURATION].provider,
                        disks: _.map(this.getAvailableDevices(manager.getDevices()), function (item) {
                            return {
                                _type: "com.vmware.vim.binding.vim.vm.FaultToleranceVMConfigSpec$FaultToleranceDiskSpec",
                                disk: item,
                                datastore: manager.getSelectedDatastores()[_this.vmFtConstants.fileTypes.VIRTUAL_DISK
                                    + item.key].provider
                            };
                        })
                    }
                }
            };
        };
        FtVmPageService.prototype.hasHostAnyErrors = function (host) {
            return host && host.errors && host.errors.length > 0;
        };
        FtVmPageService.prototype.getAvailableDevices = function (devices) {
            var _this = this;
            return _.filter(devices, function (device) {
                return device._type === _this.VIRTUAL_DEVICE_TYPE;
            });
        };
        FtVmPageService.$inject = ["$rootScope",
            "i18nService",
            "mutationService",
            "defaultUriSchemeUtil",
            "vuiConstants",
            "vuiFtTurnOnWizard",
            "vmFtConstants"];
        return FtVmPageService;
    }());
    h5_vm.FtVmPageService = FtVmPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("ftVmPageService", FtVmPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmEnableSecondarySpec = com.vmware.vsphere.client.vm.ft.VmEnableSecondarySpec;
    var VmDisableSecondarySpec = com.vmware.vsphere.client.vm.ft.VmDisableSecondarySpec;
    var VmRestartSecondarySpec = com.vmware.vsphere.client.vm.ft.VmRestartSecondarySpec;
    var VmTestFailoverSpec = com.vmware.vsphere.client.vm.ft.VmTestFailoverSpec;
    var FtVmService = (function () {
        function FtVmService($rootScope, $injector, dataService, clarityModalService, i18nService, ftVmWizardService, FtVmTurnOnManager, defaultUriSchemeUtil, vuiConstants, columnRenderersRegistry, mutationService, vmFtConstants, migrateVmWizardService, taskConstants, powerOpsService) {
            this.$rootScope = $rootScope;
            this.$injector = $injector;
            this.dataService = dataService;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.ftVmWizardService = ftVmWizardService;
            this.FtVmTurnOnManager = FtVmTurnOnManager;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vuiConstants = vuiConstants;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.mutationService = mutationService;
            this.vmFtConstants = vmFtConstants;
            this.migrateVmWizardService = migrateVmWizardService;
            this.taskConstants = taskConstants;
            this.powerOpsService = powerOpsService;
            this.ERROR_ICON = "vx-icon-error";
            this.WARNING_ICON = "vx-icon-warn";
            this.HOST_ICON = "vsphere-icon-host";
            this.VM_ICON = "vsphere-icon-vm";
            this.HOST_SYSTEM_TYPE = "HostSystem";
            this.VM_TYPE = "VirtualMachine";
            this.VIRTUAL_DEVICE_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualDisk";
        }
        FtVmService.prototype.getAvailableDevices = function (devices) {
            var _this = this;
            return _.filter(devices, function (device) {
                return device._type === _this.VIRTUAL_DEVICE_TYPE;
            });
        };
        FtVmService.prototype.openVmFaultToleranceWizard = function (objectId) {
            var _this = this;
            var manager = new this.FtVmTurnOnManager();
            this.validateFaultToleranceTurnOn(objectId).then(function (response) {
                if (!response) {
                    return;
                }
                var ftCompability = response.ftCompatibilityResult;
                var ftCompatibleDatastores = response.ftCompatibleDatastores;
                var devices = response.devices;
                manager.setCompatibleDatastores(ftCompatibleDatastores);
                manager.setMetaCompatibleDatastores(response.ftMetaCompatibleDatastores);
                manager.setConfigCompatibleDatastores(response.ftConfigCompatibleDatastores);
                manager.setDevices(devices);
                manager.setDatacenter(response.datacenter);
                if (ftCompability.errors && ftCompability.errors.length > 0) {
                    var allIssues = _this.getAllIssues(ftCompability);
                    var modalOptions = _this.getErrorsWarningModalOptions(objectId, true, allIssues, manager);
                    _this.clarityModalService.openOkCancelModal(modalOptions);
                }
                else if (ftCompability.warnings && ftCompability.warnings.length > 0) {
                    var allIssues = _this.createErrorWarningArray(ftCompability.warnings, false);
                    var modalOptions = _this.getErrorsWarningModalOptions(objectId, false, allIssues, manager);
                    _this.clarityModalService.openOkCancelModal(modalOptions);
                }
                else {
                    _this.ftVmWizardService.invokeWizard(objectId, manager);
                }
            });
        };
        FtVmService.prototype.convertCompatibleHostsIntoMap = function (hosts) {
            var _this = this;
            var compatibleHostsMap = {};
            _.each(hosts, function (item) {
                var hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(item.ftHost);
                compatibleHostsMap[hostId] = {
                    errors: item.errors,
                    warnings: item.warnings
                };
            });
            return compatibleHostsMap;
        };
        FtVmService.prototype.generateValidationMessages = function (selectedHost, compatbileHostsMap) {
            var hostData = compatbileHostsMap[selectedHost.id];
            var errorMessages = _.map(hostData.errors, function (error) {
                return {
                    type: "Error",
                    text: error.localizedMessage
                };
            });
            var warningMessages = _.map(hostData.warnings, function (warning) {
                return {
                    type: "Warning",
                    text: warning.localizedMessage
                };
            });
            var allFaults = errorMessages.concat(warningMessages);
            return allFaults;
        };
        FtVmService.prototype.createSecondaryVmSpecParameter = function (manager, availableDevices) {
            var _this = this;
            return {
                propertyParams: [
                    {
                        propertyName: "ftCompatibleHosts",
                        parameterType: "com.vmware.vim.binding.vim.vm.FaultToleranceConfigSpec",
                        parameter: {
                            _type: 'com.vmware.vim.binding.vim.vm.FaultToleranceConfigSpec',
                            metaDataPath: {
                                _type: 'com.vmware.vim.binding.vim.vm.FaultToleranceMetaSpec',
                                metaDataDatastore: manager.getSelectedDatastores()[this.vmFtConstants.fileTypes.TIE_BREAKER].provider
                            },
                            secondaryVmSpec: {
                                _type: 'com.vmware.vim.binding.vim.vm.FaultToleranceVMConfigSpec',
                                vmConfig: manager.getSelectedDatastores()[this.vmFtConstants.fileTypes.CONFIGURATION].provider,
                                disks: _.map(availableDevices, function (item) {
                                    return {
                                        _type: 'com.vmware.vim.binding.vim.vm.FaultToleranceVMConfigSpec$FaultToleranceDiskSpec',
                                        disk: item,
                                        datastore: manager.getSelectedDatastores()[_this.vmFtConstants.fileTypes.VIRTUAL_DISK
                                            + item.key].provider
                                    };
                                })
                            }
                        }
                    }
                ]
            };
        };
        FtVmService.prototype.getSelectDatastoreGridOptions = function (data) {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                resizable: true,
                selectedItems: [],
                data: data,
                columnDefs: this.getSelectDatastoreColumnDefs(),
                height: "100%",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        FtVmService.prototype.getAdvancedDatastoreGridOptions = function () {
            return {
                height: "100%",
                resizable: true,
                columnDefs: this.getAdvancedColumnDefs(),
                data: [],
                pageConfig: {
                    hidePager: true
                },
                searchable: false,
                selectedItems: []
            };
        };
        FtVmService.prototype.getErrorPageGridOptions = function (data) {
            return {
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                resizable: true,
                selectedItems: [],
                data: data,
                columnDefs: this.getErrorPageColumnDefs(),
                height: "300px",
                pageConfig: {
                    hidePager: true
                }
            };
        };
        FtVmService.prototype.getFtHostsIds = function (compatibleHosts) {
            var _this = this;
            return _.map(compatibleHosts, function (host) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(host.ftHost);
            });
        };
        FtVmService.prototype.getCompatibilityResultMessages = function (compatibleHosts) {
            var _this = this;
            var compatibilityErrorsForHosts = {};
            _.each(compatibleHosts, function (host) {
                var hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(host.ftHost);
                if (host.errors && host.errors.length > 0) {
                    _.each(host.errors, function (error) {
                        if (compatibilityErrorsForHosts.hasOwnProperty(hostId)) {
                            compatibilityErrorsForHosts[hostId].errorMessages.push(error.localizedMessage);
                        }
                        else {
                            compatibilityErrorsForHosts[hostId] = {
                                icon: 'vx-icon-host',
                                errorMessages: [error.localizedMessage]
                            };
                        }
                    });
                }
            });
            return compatibilityErrorsForHosts;
        };
        FtVmService.prototype.migrateSecondaryFtVm = function (vmId) {
            var _this = this;
            var FT_INFO = "config/ftInfo";
            this.dataService.getProperties(vmId, [FT_INFO]).then(function (res) {
                if (res[FT_INFO] && res[FT_INFO].secondaries && res[FT_INFO].secondaries[0]) {
                    var secondaryVmId = _this.defaultUriSchemeUtil.getVsphereObjectId(res[FT_INFO].secondaries[0]);
                    _this.migrateVmWizardService.showWizard([secondaryVmId]);
                }
            });
        };
        FtVmService.prototype.hasFtHostWithoutErrors = function (hosts) {
            return _.some(hosts, function (host) {
                return !host.errors || host.errors.length === 0;
            });
        };
        FtVmService.prototype.ftTestFailover = function (vmId) {
            var spec = new VmTestFailoverSpec();
            this.mutationService.apply(vmId, spec._type, spec);
        };
        FtVmService.prototype.ftRestartSecondary = function (vmId) {
            var spec = new VmRestartSecondarySpec();
            this.mutationService.apply(vmId, spec._type, spec);
        };
        FtVmService.prototype.suspendFaultTolerance = function (vmId) {
            var spec = new VmDisableSecondarySpec();
            this.mutationService.apply(vmId, spec._type, spec);
        };
        FtVmService.prototype.resumeFaultTolerance = function (vmId) {
            var _this = this;
            var spec = new VmEnableSecondarySpec();
            this.mutationService.apply(vmId, spec._type, spec)
                .then(function (operationResult) {
                _this.processFaultToleranceOpResult(operationResult);
            });
        };
        FtVmService.prototype.processFaultToleranceOpResult = function (operationResult) {
            var _this = this;
            if (operationResult && operationResult.taskUid) {
                this.dataService
                    .getProperties(operationResult.taskUid, ["info"])
                    .then(function (taskData) {
                    _this.onTaskInfoRetrieved(taskData);
                });
            }
        };
        FtVmService.prototype.onTaskInfoRetrieved = function (taskData) {
            if (taskData
                && taskData.info
                && taskData.info.result
                && taskData.info.result.vm
                && taskData.info.result.powerOnAttempted
                && taskData.info.result.powerOnResult) {
                var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(taskData.info.result.vm);
                this.powerOpsService.showPowerOnFailuresAndRecommendationsDialog([{ result: taskData.info.result.powerOnResult }], [vmId]);
            }
        };
        FtVmService.prototype.getSelectDatastoreColumnDefs = function () {
            var _this = this;
            var columns = [
                {
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.NameColumnHeader'),
                    width: 200,
                    template: this.iconNameRendererFactory('name', 'vsphere-icon-datastore')
                },
                {
                    field: 'compatibility',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.CompatibilityColumnHeader'),
                    width: 110,
                    visible: false
                },
                {
                    field: 'capacity',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.CapacityColumnHeader'),
                    type: 'number',
                    width: 110,
                    template: "#:capacityFormatted#"
                },
                {
                    field: 'provisionedSpace',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.ProvisionedSpaceColumnHeader'),
                    width: 110,
                    type: 'number',
                    template: "#:provisionedSpaceFormatted#"
                },
                {
                    field: 'freeSpace',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.FreeSpaceColumnHeader'),
                    type: 'number',
                    width: 110,
                    template: "#:freeSpaceFormatted#"
                },
                {
                    field: 'type',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.TypeColumnHeader'),
                    width: 110
                },
                {
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.StoragePodColumnHeader'),
                    width: 200,
                    template: this.iconNameRendererFactory('parentPodName', 'vsphere-icon-datastore-cluster')
                },
                {
                    field: 'storageDRS',
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.StorageDrsColumnHeader'),
                    width: 110,
                    template: function (record) {
                        var storageDrs = '';
                        if (!_.isUndefined(record.storagePodEnabled)) {
                            storageDrs = record.storagePodEnabled ?
                                _this.i18nService.getString('VmUi', 'enabled') :
                                _this.i18nService.getString('VmUi', 'disabled');
                        }
                        return storageDrs;
                    }
                },
                {
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.ThinProvisioningColumnHeader'),
                    width: 110,
                    template: function (record) {
                        return record.isThinProvisioningSupported ?
                            _this.i18nService.getString('VmUi', 'VmDatastore.ThinSupported') :
                            _this.i18nService.getString('VmUi', 'VmDatastore.ThinUnsupported');
                    }
                },
                {
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.AccessColumnHeader'),
                    width: 110,
                    template: function (record) {
                        return record.multipleHostAccess ?
                            _this.i18nService.getString('VmUi', 'datastore.access.multiple') :
                            _this.i18nService.getString('VmUi', 'datastore.access.single');
                    }
                },
                {
                    displayName: this.i18nService.getString('Common', 'StorageLocatorControl.HardwareAccelerationColumnHeader'),
                    width: 110,
                    template: function (record) {
                        var hardwareAccelerationValues = {
                            vStorageSupported: _this.i18nService.getString('VmUi', 'RawDisk.vStorageSupported'),
                            vStorageUnknown: _this.i18nService.getString('VmUi', 'RawDisk.vStorageUnknown'),
                            vStorageUnsupported: _this.i18nService.getString('VmUi', 'RawDisk.vStorageUnsupported')
                        };
                        return hardwareAccelerationValues[record.vStorageSupport];
                    }
                }
            ];
            return columns;
        };
        FtVmService.prototype.getAdvancedColumnDefs = function () {
            var _this = this;
            var browseOptionLabel = this.i18nService.getString("Common", "DiskLocatorControl.Browse");
            return [
                {
                    displayName: this.i18nService.getString("Common", "DiskLocatorControl.Vm"),
                    width: 180,
                    field: "vmName",
                    type: "string",
                    template: this.i18nService.getString("Common", "secondaryVmFormat", "#:vmName#"),
                    sortable: true
                },
                {
                    displayName: this.i18nService.getString("Common", "DiskLocatorControl.File"),
                    width: 180,
                    field: "fileName",
                    type: "string",
                    template: function (dataItem) {
                        if (dataItem.itemType === _this.vmFtConstants.fileTypes.TIE_BREAKER) {
                            return _this.i18nService.getString("Common", "DiskLocatorControl.fileType.ftMetaInf");
                        }
                        else if (dataItem.itemType === _this.vmFtConstants.fileTypes.CONFIGURATION) {
                            return _this.i18nService.getString("Common", "DiskLocatorControl.fileType.configuration");
                        }
                        else {
                            return dataItem.fileName;
                        }
                    },
                    sortable: true
                },
                {
                    displayName: this.i18nService.getString("Common", "DiskLocatorControl.Storage"),
                    width: 180,
                    template: function (dataItem) {
                        return "\n                  <div class=\"select\">\n                    <select ng-model=\"dataItem.storageItemId\"\n                          ng-click=\"dataItem.onDatastoreComboClick($event, dataItem)\"\n                          ng-change=\"dataItem.onDatastoreChange(dataItem)\"\n                          ng-options=\"option.id as option.label for option in dataItem.storageItems\">\n                        <option value=\"\" disabled style=\"display: none\">" + browseOptionLabel + "</option>\n                     </select>\n                  </div>";
                    }
                }];
        };
        FtVmService.prototype.iconNameRendererFactory = function (nameField, iconField) {
            var _this = this;
            return function (data) {
                var objectLinkRenderer = _this.columnRenderersRegistry.getColumnRenderer('object-link');
                return objectLinkRenderer([undefined, nameField, iconField], data);
            };
        };
        FtVmService.prototype.getErrorsWarningModalOptions = function (objectId, hasErrors, data, manager) {
            var closeButtonTitle = hasErrors ?
                this.i18nService.getString("VmUi", "FtFaultDetailsPopUp.okButtonText") :
                this.i18nService.getString("VmUi", "FtFaultDetailsPopUp.noButtonText");
            var errorText = hasErrors ?
                this.i18nService.getString("VmUi", "turnOnFtWizard.error.hasWorkflowBreakingErrors") :
                this.i18nService.getString("VmUi", "turnOnFtWizard.error.hasWorkflowWideWarnings");
            return {
                title: this.i18nService.getString("VmUi", "FtFaultDetailsPopUp.title"),
                contentTemplate: "vm-ui/resources/vm/views/ft/ftErrorsWarningView.html",
                submitButtonTitle: this.i18nService.getString("VmUi", "FtFaultDetailsPopUp.yesButtonText"),
                closeButtonTitle: closeButtonTitle,
                hideSubmitButton: hasErrors,
                size: "lg",
                dialogData: {
                    allIssuesArray: data,
                    errorText: errorText,
                    objectId: objectId,
                    manager: manager
                },
                defaultButton: "close"
            };
        };
        FtVmService.prototype.getAllIssues = function (ftCompability) {
            var errorsArray = this.createErrorWarningArray(ftCompability.errors, true);
            var waringsArray = this.createErrorWarningArray(ftCompability.warnings, false);
            var allIssuesArray = errorsArray.concat(waringsArray);
            return allIssuesArray;
        };
        FtVmService.prototype.createErrorWarningArray = function (array, isErrorArray) {
            var _this = this;
            return _.map(array, function (item) {
                var issueIconClass;
                var faultTypeLocalizedMessage = "";
                if (isErrorArray) {
                    issueIconClass = _this.ERROR_ICON;
                    faultTypeLocalizedMessage =
                        _this.i18nService.getString("VmUi", "FtFaultDetailsList.faultTypeError");
                }
                else {
                    issueIconClass = _this.WARNING_ICON;
                    faultTypeLocalizedMessage =
                        _this.i18nService.getString("VmUi", "FtFaultDetailsList.faultTypeWarning");
                }
                var entityIconClass = "";
                if (item.entity) {
                    if (item.entity.type === _this.HOST_SYSTEM_TYPE) {
                        entityIconClass = _this.HOST_ICON;
                    }
                    else if (item.entity.type === _this.VM_TYPE) {
                        entityIconClass = _this.VM_ICON;
                    }
                }
                return _.extend({
                    issueIconClass: issueIconClass,
                    entityIconClass: entityIconClass,
                    faultTypeLocalizedMessage: faultTypeLocalizedMessage
                }, item);
            });
        };
        FtVmService.prototype.validateFaultToleranceTurnOn = function (objectId) {
            return this.dataService.getData(objectId, 'com.vmware.vsphere.client.vm.impl.FtDatastoresInfo');
        };
        FtVmService.prototype.getErrorPageColumnDefs = function () {
            var iconRenderer = this.columnRenderersRegistry.getColumnRenderer('icon-text');
            return [
                {
                    displayName: this.i18nService.getString("VmUi", "FtFaultDetailsList.faultType"),
                    template: function (dataItem) {
                        return iconRenderer(['issueIconClass', 'faultTypeLocalizedMessage'], dataItem);
                    }
                },
                {
                    displayName: this.i18nService.getString("VmUi", "FtFaultDetailsList.entity"),
                    template: function (dataItem) {
                        return iconRenderer(['entityIconClass', 'entityName'], dataItem);
                    }
                },
                {
                    field: "localizedMessage",
                    displayName: this.i18nService.getString("VmUi", "FtFaultDetailsList.description")
                }
            ];
        };
        FtVmService.$inject = [
            "$rootScope",
            "$injector",
            "dataService",
            "clarityModalService",
            "i18nService",
            "ftVmWizardService",
            "FtVmTurnOnManager",
            "defaultUriSchemeUtil",
            "vuiConstants",
            "columnRenderersRegistry",
            "mutationService",
            "vmFtConstants",
            "migrateVmWizardService",
            "taskConstants",
            "powerOpsService"];
        return FtVmService;
    }());
    h5_vm.FtVmService = FtVmService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('ftVmService', FtVmService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtVmTurnOnManager = (function () {
        function FtVmTurnOnManager() {
        }
        FtVmTurnOnManager.prototype.setTargetUid = function (targetUid) {
            this.targetUid = targetUid;
        };
        FtVmTurnOnManager.prototype.getTargetUid = function () {
            return this.targetUid;
        };
        FtVmTurnOnManager.prototype.setVmName = function (vmName) {
            this.vmName = vmName;
        };
        FtVmTurnOnManager.prototype.getVmName = function () {
            return this.vmName;
        };
        FtVmTurnOnManager.prototype.setMetaCompatibleDatastores = function (compatibleMetaDatastores) {
            this.compatibleMetaDatastores = compatibleMetaDatastores || [];
        };
        FtVmTurnOnManager.prototype.getMetaCompatibleDatastores = function () {
            return this.compatibleMetaDatastores;
        };
        FtVmTurnOnManager.prototype.setConfigCompatibleDatastores = function (compatibleConfigDatastores) {
            this.compatibleConfigDatastores = compatibleConfigDatastores || [];
        };
        FtVmTurnOnManager.prototype.getConfigCompatibleDatastores = function () {
            return this.compatibleConfigDatastores;
        };
        FtVmTurnOnManager.prototype.setCompatibleDatastores = function (compatibleDatastores) {
            this.compatibleDatastores = compatibleDatastores || [];
        };
        FtVmTurnOnManager.prototype.getCompatibleDatastores = function () {
            return this.compatibleDatastores;
        };
        FtVmTurnOnManager.prototype.setSelectedDatastore = function (selectedDatastore) {
            this.selectedDatastore = selectedDatastore;
        };
        FtVmTurnOnManager.prototype.getSelectedDatastore = function () {
            return this.selectedDatastore;
        };
        FtVmTurnOnManager.prototype.setDevices = function (devices) {
            this.devices = devices;
        };
        FtVmTurnOnManager.prototype.getDevices = function () {
            return this.devices;
        };
        FtVmTurnOnManager.prototype.setDatacenter = function (datacenter) {
            this.datacenter = datacenter;
        };
        FtVmTurnOnManager.prototype.getDatacenter = function () {
            return this.datacenter;
        };
        FtVmTurnOnManager.prototype.setSelectedHost = function (selectedHost) {
            this.selectedHost = selectedHost;
        };
        FtVmTurnOnManager.prototype.getSelectedHost = function () {
            return this.selectedHost;
        };
        FtVmTurnOnManager.prototype.setNoHostsCompatible = function (noHostsCompatible) {
            this.noHostsCompatible = noHostsCompatible;
        };
        FtVmTurnOnManager.prototype.getNoHostsCompatible = function () {
            return this.noHostsCompatible;
        };
        FtVmTurnOnManager.prototype.setIsAdvancedMode = function (isAdvancedMode) {
            this.isAdvancedMode = isAdvancedMode;
        };
        FtVmTurnOnManager.prototype.getIsAdvancedMode = function () {
            return this.isAdvancedMode;
        };
        FtVmTurnOnManager.prototype.setSelectedDatastores = function (selectedDatastores) {
            this.selectedDatastores = selectedDatastores;
        };
        FtVmTurnOnManager.prototype.getSelectedDatastores = function () {
            return this.selectedDatastores;
        };
        FtVmTurnOnManager.prototype.validateSelectedDatastores = function () {
            return _.size(this.selectedDatastores) === this.numberOfVmFiles;
        };
        FtVmTurnOnManager.prototype.setNumberOfVmFiles = function (vmFiles) {
            this.numberOfVmFiles = vmFiles;
        };
        FtVmTurnOnManager.$inject = [];
        return FtVmTurnOnManager;
    }());
    h5_vm.FtVmTurnOnManager = FtVmTurnOnManager;
    angular.module('com.vmware.vsphere.client.vm')
        .factory('FtVmTurnOnManager', [
        function () {
            return Function.prototype.bind.apply(FtVmTurnOnManager, [undefined]);
        }
    ]);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtVmWizardService = (function () {
        function FtVmWizardService($rootScope, dataService, vuiFtTurnOnWizard, ftVmPageService) {
            this.$rootScope = $rootScope;
            this.dataService = dataService;
            this.vuiFtTurnOnWizard = vuiFtTurnOnWizard;
            this.ftVmPageService = ftVmPageService;
        }
        FtVmWizardService.prototype.invokeWizard = function (targetUid, manager) {
            var _this = this;
            manager.setTargetUid(targetUid);
            this.wizardScope = this.$rootScope.$new();
            var pages = this.createWizardPages(this.wizardScope, manager);
            this.dataService
                .getProperties(targetUid, ['name'])
                .then(function (response) {
                if (response && response.name) {
                    var vmName = response.name;
                    manager.setVmName(vmName);
                    _this.vuiFtTurnOnWizard.show(pages, _this.wizardScope, manager);
                }
            });
        };
        FtVmWizardService.prototype.createWizardPages = function (wizardScope, manager) {
            var pages = [];
            pages.push(this.ftVmPageService.buildSelectDatastoresPage(wizardScope));
            pages.push(this.ftVmPageService.buildSelectHostPage(wizardScope));
            pages.push(this.ftVmPageService.buildReadyToCompletePage(wizardScope));
            return pages;
        };
        FtVmWizardService.$inject = ["$rootScope", "dataService", "vuiFtTurnOnWizard", "ftVmPageService"];
        return FtVmWizardService;
    }());
    h5_vm.FtVmWizardService = FtVmWizardService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('ftVmWizardService', FtVmWizardService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VuiFtTurnOnWizardImpl = (function () {
        function VuiFtTurnOnWizardImpl(wizardPageService, vuiWizardService, $rootScope, i18nService, mutationService) {
            this.wizardPageService = wizardPageService;
            this.vuiWizardService = vuiWizardService;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.mutationService = mutationService;
        }
        VuiFtTurnOnWizardImpl.prototype.show = function (pages, wizardScope, manager) {
            this.wizardConfig = {
                title: this.i18nService.getString('VmUi', 'turnOnFtWizard.title2', manager.getVmName()),
                pages: this.wizardPageService.initializePageStates(pages),
                resizeMinHeight: 500,
                onFinish: function () {
                    return true;
                }
            };
            this.wizardScope = wizardScope;
            this.wizardScope.manager = manager;
            this.wizardScope.wizardConfig = this.wizardConfig;
            this.vuiWizardService({
                scope: this.wizardScope,
                configObjectName: "wizardConfig"
            }).show();
        };
        VuiFtTurnOnWizardImpl.prototype.markPageIncompleteWithError = function (message) {
            this.wizardPageService.markPageIncompleteWithError(this.wizardConfig, message);
        };
        VuiFtTurnOnWizardImpl.prototype.markPageComplete = function (flow) {
            this.wizardPageService.clearErrors(this.wizardConfig);
            this.wizardPageService.markPageComplete(this.wizardConfig, flow);
        };
        VuiFtTurnOnWizardImpl.$inject = [
            'wizardPageService',
            'vuiWizardService',
            '$rootScope',
            'i18nService',
            'mutationService'
        ];
        return VuiFtTurnOnWizardImpl;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .service("vuiFtTurnOnWizard", VuiFtTurnOnWizardImpl);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CpuIdMaskConstants = (function () {
        function CpuIdMaskConstants() {
        }
        CpuIdMaskConstants.VENDOR_AMD = 'amd';
        CpuIdMaskConstants.VENDOR_OTHER = '';
        CpuIdMaskConstants.CHAR_NX_SHOW = 'H';
        CpuIdMaskConstants.CHAR_NX_HIDE = '0';
        CpuIdMaskConstants.CHAR_NOCHANGE = 'N';
        CpuIdMaskConstants.REG_USE_GOS = "--------------------------------";
        CpuIdMaskConstants.NX_LEVEL = -2147483647;
        CpuIdMaskConstants.NX_CHAR_POS = 11;
        CpuIdMaskConstants.CPUIDINFO_TYPE = 'com.vmware.vim.binding.vim.host.CpuIdInfo';
        CpuIdMaskConstants.OPERATION_ADD = "add";
        CpuIdMaskConstants.OPERATION_EDIT = "edit";
        CpuIdMaskConstants.OPERATION_REMOVE = "remove";
        CpuIdMaskConstants.NXFLAG_NOTFOUND = "notfound";
        CpuIdMaskConstants.NXFLAG_EXPOSED = "exposed";
        CpuIdMaskConstants.NXFLAG_HIDDEN = "hidden";
        CpuIdMaskConstants.NXFLAG_ADVANCED = "advanced";
        CpuIdMaskConstants.NXFLAG_NOTAPPLICABLE = "na";
        return CpuIdMaskConstants;
    }());
    h5_vm.CpuIdMaskConstants = CpuIdMaskConstants;
})(h5_vm || (h5_vm = {}));



/**
 * Created by vmware on 1/13/17.
 */
var h5_vm;
(function (h5_vm) {
    var CpuIdInfo = com.vmware.vim.binding.vim.host.CpuIdInfo;
    var ConfigSpec$CpuIdInfoSpec = com.vmware.vim.binding.vim.vm.ConfigSpec$CpuIdInfoSpec;
    var CpuIdMaskConstants = h5_vm.CpuIdMaskConstants;
    var CpuService = (function () {
        function CpuService(i18nService, $injector) {
            this.i18nService = i18nService;
            this.$injector = $injector;
            this.NX_FLAG_NOTFOUND = "notfound";
            this.EXPOSE_NX_FLAG_TO_GUEST = this.i18nService.getString("VmUi", "CpuIdMask.exposed");
            this.HIDE_NX_FLAG_FROM_GUEST = this.i18nService.getString("VmUi", "CpuIdMask.hidden");
            this.KEEP_NX_FLAG_ADVANCED = this.i18nService.getString("VmUi", "CpuIdMask.advanced");
            this.cpuIdMaskSettings = [this.HIDE_NX_FLAG_FROM_GUEST, this.EXPOSE_NX_FLAG_TO_GUEST];
            this.cpuIdMaskSettingsWithAdvanced = [this.HIDE_NX_FLAG_FROM_GUEST, this.EXPOSE_NX_FLAG_TO_GUEST, this.KEEP_NX_FLAG_ADVANCED];
            this.REG_EXP_ILLEGAL_CHARACTERS = /[^-01TFXHR]/g;
        }
        CpuService.prototype.getCpuIdMaskSettingOptions = function (withAdvanced) {
            if (withAdvanced === void 0) { withAdvanced = false; }
            return !withAdvanced ? this.cpuIdMaskSettings : this.cpuIdMaskSettingsWithAdvanced;
        };
        CpuService.prototype.getCpuIdMaskSettingForVm = function (vmConfigContext) {
            return this.isCpuIdMaskExposed(vmConfigContext) ? this.EXPOSE_NX_FLAG_TO_GUEST : this.HIDE_NX_FLAG_FROM_GUEST;
        };
        CpuService.prototype.getCpuIdMaskFlagSelection = function (flag) {
            switch (flag) {
                case CpuIdMaskConstants.NXFLAG_EXPOSED:
                    return this.EXPOSE_NX_FLAG_TO_GUEST;
                case CpuIdMaskConstants.NXFLAG_HIDDEN:
                    return this.HIDE_NX_FLAG_FROM_GUEST;
                case CpuIdMaskConstants.NXFLAG_ADVANCED:
                    break;
                default:
                    break;
            }
            return this.KEEP_NX_FLAG_ADVANCED;
        };
        CpuService.prototype.determineCpuIdMaskFlag = function (vmConfigContext) {
            var advancedCpuIdMaskService = this.$injector.get('vscAdvancedCpuIdMaskService');
            return advancedCpuIdMaskService.determineNxFlagStateFromConfigContext(vmConfigContext);
        };
        CpuService.prototype.isCpuIdMaskExposed = function (vmConfigContext) {
            var mask, edxRegisterValue;
            if (this.hasCpuFeatureMaskInfo(vmConfigContext)) {
                mask = vmConfigContext.config.cpuFeatureMask[0];
            }
            else {
                mask = vmConfigContext.environment.configOption.guestOSDescriptor[0].cpuFeatureMask[0];
            }
            if (mask.edx) {
                edxRegisterValue = this.stripIllegalCharacters(mask.edx);
                return edxRegisterValue[CpuIdMaskConstants.NX_CHAR_POS] === CpuIdMaskConstants.CHAR_NX_SHOW;
            }
            return false;
        };
        CpuService.prototype.updateCpuIdMaskSetting = function (selectedSetting, vmConfigContext) {
            var flagValue;
            switch (selectedSetting) {
                case this.EXPOSE_NX_FLAG_TO_GUEST:
                    flagValue = CpuIdMaskConstants.CHAR_NX_SHOW;
                    break;
                case this.HIDE_NX_FLAG_FROM_GUEST:
                    flagValue = CpuIdMaskConstants.CHAR_NX_HIDE;
                    break;
                default:
                    flagValue = '-';
            }
            this.updateMaskForVendor(vmConfigContext, flagValue, CpuIdMaskConstants.VENDOR_AMD);
            this.updateMaskForVendor(vmConfigContext, flagValue, CpuIdMaskConstants.VENDOR_OTHER);
        };
        CpuService.prototype.updateMaskForVendor = function (vmConfigContext, flagValue, vendor) {
            var cpuIdInfo;
            if (this.hasCpuFeatureMaskInfo(vmConfigContext)) {
                cpuIdInfo = this.getCpuIdInfoForVendor(vendor, vmConfigContext);
            }
            cpuIdInfo = cpuIdInfo || this.createCpuIdInfoForVendor(vendor, vmConfigContext);
            cpuIdInfo.edx = cpuIdInfo.edx || CpuIdMaskConstants.REG_USE_GOS;
            cpuIdInfo.edx = this.updateRegisterWithFlag(cpuIdInfo.edx, flagValue);
        };
        CpuService.prototype.getKeyForCpuIdInfo = function (cpuIdInfo) {
            var level = cpuIdInfo.level.toString();
            var vendor = cpuIdInfo.vendor || '';
            return level + vendor;
        };
        CpuService.prototype.isItemPresent = function (map, key) {
            if (map[key]) {
                return true;
            }
            return false;
        };
        CpuService.prototype.createCpuIdInfoDelta = function (originalCpuFeatureMaskValues, currentCpuFeatureMaskValues) {
            var _this = this;
            var cpuIdInfoDelta = [];
            var originalItemsMap = {};
            var cpuIdInfoSpec;
            _.each(originalCpuFeatureMaskValues, function (originalItem) {
                originalItemsMap[_this.getKeyForCpuIdInfo(originalItem)] = originalItem;
            });
            var itemsToRemoveOrEdit = this.filterModifiedItems(currentCpuFeatureMaskValues, originalItemsMap);
            _.each(itemsToRemoveOrEdit, function (cpuIdInfo) {
                if (!_this.isCpuIdInfoEmpty(cpuIdInfo)) {
                    cpuIdInfoSpec = _this.createCpuIdInfoSpecForOperation(cpuIdInfo, CpuIdMaskConstants.OPERATION_EDIT);
                }
                else {
                    cpuIdInfoSpec = _this.createCpuIdInfoSpecForOperation(cpuIdInfo, CpuIdMaskConstants.OPERATION_REMOVE);
                }
                cpuIdInfoDelta.push(cpuIdInfoSpec);
            });
            var itemsToAdd = _.difference(currentCpuFeatureMaskValues, itemsToRemoveOrEdit);
            _.each(itemsToAdd, function (cpuIdInfo) {
                if (!_this.isCpuIdInfoEmpty(cpuIdInfo)) {
                    cpuIdInfoSpec = _this.createCpuIdInfoSpecForOperation(cpuIdInfo, CpuIdMaskConstants.OPERATION_ADD);
                    cpuIdInfoDelta.push(cpuIdInfoSpec);
                }
            });
            return cpuIdInfoDelta;
        };
        CpuService.prototype.filterModifiedItems = function (modifiedItems, originalItemsMap) {
            var _this = this;
            if (_.isEmpty(modifiedItems)) {
                return [];
            }
            return modifiedItems.filter(function (modifiedItem) {
                if (!_this.isItemPresent(originalItemsMap, _this.getKeyForCpuIdInfo(modifiedItem))) {
                    return false;
                }
                var originalItem = originalItemsMap[_this.getKeyForCpuIdInfo(modifiedItem)];
                return !_.isEqual(modifiedItem, originalItem);
            });
        };
        CpuService.prototype.createCpuIdInfoSpecForOperation = function (cpuIdInfo, operation) {
            var cpuIdInfoSpec = new ConfigSpec$CpuIdInfoSpec();
            cpuIdInfoSpec.info = new CpuIdInfo();
            cpuIdInfoSpec.info._type = cpuIdInfo._type;
            cpuIdInfoSpec.info.vendor = cpuIdInfo.vendor;
            cpuIdInfoSpec.info.eax = this.padForVmodl(cpuIdInfo.eax);
            cpuIdInfoSpec.info.ebx = this.padForVmodl(cpuIdInfo.ebx);
            cpuIdInfoSpec.info.ecx = this.padForVmodl(cpuIdInfo.ecx);
            cpuIdInfoSpec.info.edx = this.padForVmodl(cpuIdInfo.edx);
            cpuIdInfoSpec.info.level = cpuIdInfo.level;
            cpuIdInfoSpec.operation = operation;
            return cpuIdInfoSpec;
        };
        CpuService.prototype.isCpuIdInfoEmpty = function (cpuIdInfo) {
            if (_.isEmpty(cpuIdInfo.eax) &&
                _.isEmpty(cpuIdInfo.ebx) &&
                _.isEmpty(cpuIdInfo.ecx) &&
                _.isEmpty(cpuIdInfo.edx)) {
                return true;
            }
            return false;
        };
        CpuService.prototype.updateRegisterWithFlag = function (registerValue, flagValue) {
            var strippedValue = this.stripIllegalCharacters(registerValue);
            var leftValue = strippedValue.substring(0, CpuIdMaskConstants.NX_CHAR_POS);
            var rightValue = strippedValue.substring(CpuIdMaskConstants.NX_CHAR_POS + 1, strippedValue.length);
            return this.padForVmodl(leftValue + flagValue + rightValue);
        };
        CpuService.prototype.getCpuIdInfoForVendor = function (vendor, vmConfigContext) {
            var cpuIdInfo = _.find(vmConfigContext.config.cpuFeatureMask, function (cpuIdInfo) {
                if (vendor === CpuIdMaskConstants.VENDOR_AMD) {
                    return cpuIdInfo.vendor === CpuIdMaskConstants.VENDOR_AMD;
                }
                else {
                    return cpuIdInfo.vendor !== CpuIdMaskConstants.VENDOR_AMD;
                }
            });
            return cpuIdInfo;
        };
        CpuService.prototype.hasCpuFeatureMaskInfo = function (vmConfigContext) {
            if (vmConfigContext.config.cpuFeatureMask && vmConfigContext.config.cpuFeatureMask.length > 0) {
                return true;
            }
            return false;
        };
        CpuService.prototype.createCpuIdInfoForVendor = function (vendor, vmConfigContext) {
            var cpuIdInfo = new CpuIdInfo();
            cpuIdInfo.eax = CpuIdMaskConstants.REG_USE_GOS;
            cpuIdInfo.ebx = CpuIdMaskConstants.REG_USE_GOS;
            cpuIdInfo.ecx = CpuIdMaskConstants.REG_USE_GOS;
            cpuIdInfo.edx = CpuIdMaskConstants.REG_USE_GOS;
            cpuIdInfo.level = CpuIdMaskConstants.NX_LEVEL;
            if (vendor === CpuIdMaskConstants.VENDOR_AMD) {
                cpuIdInfo.vendor = vendor;
            }
            cpuIdInfo._type = CpuIdMaskConstants.CPUIDINFO_TYPE;
            vmConfigContext.config.cpuFeatureMask.push(cpuIdInfo);
            return cpuIdInfo;
        };
        CpuService.prototype.stripIllegalCharacters = function (registerValue) {
            if (_.isEmpty(registerValue)) {
                return '';
            }
            var strippedRegisterValue = registerValue.toUpperCase();
            return strippedRegisterValue.replace(this.REG_EXP_ILLEGAL_CHARACTERS, '');
        };
        CpuService.prototype.padForVmodl = function (registerValue) {
            if (_.isEmpty(registerValue)) {
                return '';
            }
            var strippedValue = this.stripIllegalCharacters(registerValue);
            return strippedValue.substr(0, 4) + " " + strippedValue.substr(4, 4) + " " +
                strippedValue.substr(8, 4) + " " + strippedValue.substr(12, 4) + " " +
                strippedValue.substr(16, 4) + " " + strippedValue.substr(20, 4) + " " +
                strippedValue.substr(24, 4) + " " + strippedValue.substr(28, 4);
        };
        CpuService.$inject = ['i18nService', '$injector'];
        CpuService.NX_LEVEL = "-2147483647";
        return CpuService;
    }());
    h5_vm.CpuService = CpuService;
    angular.module('com.vmware.vsphere.client.vm').service('cpuService', CpuService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CpuMmuConstants = (function () {
        function CpuMmuConstants() {
        }
        CpuMmuConstants.AUTOMATIC = "automatic";
        CpuMmuConstants.SOFTWARE = "software";
        CpuMmuConstants.HARDWARE_CPU = "hardwareCpu";
        CpuMmuConstants.HARDWARE_CPU_MMU = "hardwareCpuMmu";
        CpuMmuConstants.HV_AUTO = "hvAuto";
        CpuMmuConstants.HV_OFF = "hvOff";
        CpuMmuConstants.HV_ON = "hvOn";
        CpuMmuConstants.OFF = "off";
        CpuMmuConstants.ON = "on";
        return CpuMmuConstants;
    }());
    h5_vm.CpuMmuConstants = CpuMmuConstants;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CpuMmuConstants = h5_vm.CpuMmuConstants;
    var CpuMmuOptionFactory = (function () {
        function CpuMmuOptionFactory(i18nService) {
            this.i18nService = i18nService;
            this.automatic = new CpuMmuOption(CpuMmuConstants.AUTOMATIC, this.i18nService.getString("VmUi", "CpuMmuVirt.Label.automatic"));
            this.software = new CpuMmuOption(CpuMmuConstants.SOFTWARE, this.i18nService.getString("VmUi", "CpuMmuVirt.Label.software"));
            this.hardwareCpu = new CpuMmuOption(CpuMmuConstants.HARDWARE_CPU, this.i18nService.getString("VmUi", "CpuMmuVirt.Label.hardwareCpu"));
            this.hardwareCpuMmu = new CpuMmuOption(CpuMmuConstants.HARDWARE_CPU_MMU, this.i18nService.getString("VmUi", "CpuMmuVirt.Label.hardwareCpuMmu"));
        }
        CpuMmuOptionFactory.$inject = [
            'i18nService'
        ];
        return CpuMmuOptionFactory;
    }());
    h5_vm.CpuMmuOptionFactory = CpuMmuOptionFactory;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cpuMmuOptionFactory", CpuMmuOptionFactory);
    var CpuMmuOption = (function () {
        function CpuMmuOption(val, label) {
            this._value = val;
            this._label = label;
            switch (this._value) {
                case CpuMmuConstants.AUTOMATIC:
                    this._cpuUsage = "hvAuto";
                    this._mmuUsage = "automatic";
                    break;
                case CpuMmuConstants.SOFTWARE:
                    this._cpuUsage = "hvOff";
                    this._mmuUsage = "off";
                    break;
                case CpuMmuConstants.HARDWARE_CPU:
                    this._cpuUsage = "hvOn";
                    this._mmuUsage = "off";
                    break;
                case CpuMmuConstants.HARDWARE_CPU_MMU:
                    this._cpuUsage = "hvOn";
                    this._mmuUsage = "on";
                    break;
                default:
                    return;
            }
        }
        Object.defineProperty(CpuMmuOption.prototype, "cpuUsage", {
            get: function () {
                return this._cpuUsage;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CpuMmuOption.prototype, "mmuUsage", {
            get: function () {
                return this._mmuUsage;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CpuMmuOption.prototype, "value", {
            get: function () {
                return this._value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CpuMmuOption.prototype, "label", {
            get: function () {
                return this._label;
            },
            enumerable: true,
            configurable: true
        });
        CpuMmuOption.prototype.equals = function (another) {
            if (another instanceof CpuMmuOption) {
                return (_.isEqual(this._cpuUsage, another.cpuUsage) &&
                    _.isEqual(this._mmuUsage, another.mmuUsage));
            }
            else if (_.isEqual(typeof another, "string")) {
                return (_.isEqual(this._value, another));
            }
            return false;
        };
        return CpuMmuOption;
    }());
    h5_vm.CpuMmuOption = CpuMmuOption;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CpuMmuOption = h5_vm.CpuMmuOption;
    var CpuMmuConstants = h5_vm.CpuMmuConstants;
    var CpuMmuOptionService = (function () {
        function CpuMmuOptionService(creationTypeConstants, cpuMmuOptionFactory, vmHardwareUtil) {
            this.creationTypeConstants = creationTypeConstants;
            this.cpuMmuOptionFactory = cpuMmuOptionFactory;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        CpuMmuOptionService.prototype.getCpuMmuConfigOptionForCpuMmu = function (cpuUsage, mmuUsage) {
            var result = new CpuMmuOption("", "");
            if (!_.isEmpty(cpuUsage)) {
                if (_.isEqual(cpuUsage, "hvAuto") && _.isEqual(mmuUsage, "automatic")) {
                    result = this.cpuMmuOptionFactory.automatic;
                }
                else if (_.isEqual(cpuUsage, "hvOff") && _.isEqual(mmuUsage, "off")) {
                    result = this.cpuMmuOptionFactory.software;
                }
                else if (_.isEqual(cpuUsage, "hvOn") && _.isEqual(mmuUsage, "on")) {
                    result = this.cpuMmuOptionFactory.hardwareCpuMmu;
                }
                else if (_.isEqual(cpuUsage, "hvOn") && _.isEqual(mmuUsage, "off")) {
                    result = this.cpuMmuOptionFactory.hardwareCpu;
                }
            }
            else {
                if (_.isEqual(mmuUsage, "automatic")) {
                    result = this.cpuMmuOptionFactory.automatic;
                }
                else if (_.isEqual(mmuUsage, "on")) {
                    result = this.cpuMmuOptionFactory.hardwareCpuMmu;
                }
                else if (_.isEqual(mmuUsage, "off")) {
                    result = this.cpuMmuOptionFactory.software;
                }
            }
            return result;
        };
        CpuMmuOptionService.prototype.getCpuMmuCurrentConfig = function (vmConfigContext) {
            var currentConfig = {};
            if (!vmConfigContext.environment.configOption.capabilities.virtualMmuUsageSupported
                || !vmConfigContext.config.flags) {
                return;
            }
            currentConfig.privileges = !_.isEmpty(vmConfigContext.privileges) ?
                vmConfigContext.privileges : null;
            currentConfig.provisioningType = vmConfigContext.provisioningType;
            currentConfig.fullFeature =
                vmConfigContext.environment.hostCapability.virtualExecUsageSupported;
            currentConfig.virtualCpuMmuUsageSupported =
                vmConfigContext.environment.configOption.capabilities.virtualMmuUsageSupported;
            var flags = vmConfigContext.config.flags;
            if (!flags) {
                currentConfig.virtualCpuMmuUsageSupported = false;
                return currentConfig;
            }
            if (_.isEqual(currentConfig.provisioningType, this.creationTypeConstants.createVmFromScratch) &&
                _.isEmpty(flags.virtualMmuUsage)) {
                flags.virtualMmuUsage = CpuMmuConstants.AUTOMATIC;
            }
            if (currentConfig.fullFeature &&
                _.isEqual(currentConfig.provisioningType, this.creationTypeConstants.createVmFromScratch) &&
                _.isEmpty(flags.virtualExecUsage)) {
                flags.virtualExecUsage = CpuMmuConstants.HV_AUTO;
            }
            currentConfig.virtualMmuUsage = flags.virtualMmuUsage;
            currentConfig.virtualExecUsage = flags.virtualExecUsage;
            return currentConfig;
        };
        CpuMmuOptionService.prototype.isCpuMmuDisabled = function (vmConfigContext, createMode) {
            if (createMode) {
                return false;
            }
            var retVal = !this.vmHardwareUtil.haveVmConfigSettingsPermission(vmConfigContext);
            return retVal;
        };
        CpuMmuOptionService.prototype.checkPrivilege = function (privilege, details) {
            if (_.isEqual(details.provisioningType, this.creationTypeConstants.createVmFromScratch)) {
                return true;
            }
            return (details.privileges.indexOf(privilege) > -1);
        };
        CpuMmuOptionService.prototype.getCpuMmuOptions = function () {
            return [
                this.cpuMmuOptionFactory.automatic,
                this.cpuMmuOptionFactory.software,
                this.cpuMmuOptionFactory.hardwareCpu,
                this.cpuMmuOptionFactory.hardwareCpuMmu,
            ];
        };
        CpuMmuOptionService.prototype.getCpuMmuCurrentSelection = function (cpuMmuCurrentConfig) {
            if (!cpuMmuCurrentConfig || !cpuMmuCurrentConfig.virtualCpuMmuUsageSupported) {
                return this.cpuMmuOptionFactory.automatic;
            }
            if (cpuMmuCurrentConfig.fullFeature) {
                return this.getCpuMmuConfigOptionForCpuMmu(cpuMmuCurrentConfig.virtualExecUsage, cpuMmuCurrentConfig.virtualMmuUsage);
            }
            return this.getCpuMmuConfigOptionForCpuMmu(null, cpuMmuCurrentConfig.virtualMmuUsage);
        };
        CpuMmuOptionService.$inject = [
            "creationTypeConstants",
            "cpuMmuOptionFactory",
            "vmHardwareUtil"
        ];
        return CpuMmuOptionService;
    }());
    h5_vm.CpuMmuOptionService = CpuMmuOptionService;
    angular.module("com.vmware.vsphere.client.vm").service("cpuMmuOptionService", CpuMmuOptionService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').service('datastoreService', [
   'defaultUriSchemeUtil',
   function (defaultUriSchemeUtil) {
      return {
         findDatastoreFromVmxName: findDatastoreFromVmxName,
         findDatastore: findDatastore
      };

      function findDatastoreFromVmxName(configInfo, configTarget) {
         if (!configInfo.files.vmPathName) {
            return null;
         }

         var datastoreName = getDsNameFromFilePath(configInfo.files.vmPathName);
         var datastoreInfo = _.find(configTarget.datastore, function (datastoreInfo) {
            return datastoreName === datastoreInfo.name;
         });
         if (!datastoreInfo) {
            return null;
         }
         return datastoreInfo;
      }

      function findDatastore(dsId, configTarget) {
         var datastore = _.find(configTarget.datastore, function (dsInfo) {
            return dsId === defaultUriSchemeUtil.getVsphereObjectId(dsInfo.datastore.datastore);
         });

         return datastore || null;
      }

      // ------- Private -------

      function getDsNameFromFilePath(filePath) {
         if (!filePath) {
            return "";
         }
         var firstBracket = filePath.indexOf('[');
         var secondBracket = filePath.indexOf(']');
         if (firstBracket === -1 || secondBracket === -1) {
            return '';
         }
         return filePath.substring(firstBracket + 1, secondBracket);
      }
   }]);

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service('deviceOrganizer', deviceOrganizer);

   deviceOrganizer.$inject = ['vmDeviceInfoService'];

   var DEFAULT_DEVICE = 'VirtualDevice';
   var ORDERED_DEVICES_TO_GROUP_BY = [
      'VirtualDisk',
      'VirtualEthernetCard',
      'VirtualCdrom',
      'VirtualFloppy',
      'VirtualVideoCard',
      'VirtualNVDIMM',
      'VirtualSCSIController',
      'VirtualController',
      'InputDevice',
      DEFAULT_DEVICE
   ];

   function deviceOrganizer(vmDeviceInfoService) {
      return {
         groupAndSortDevices: function(rawDevices) {
            var sortedDevices = rawDevices.sort(function(device1, device2) {
               return computeSortId(device1) - computeSortId(device2);
            });
            return mapDevicesByType(sortedDevices, ORDERED_DEVICES_TO_GROUP_BY);
         }
      };

      function mapDevicesByType(rawDevices, superTypesToGroupBy) {
         return _.groupBy(rawDevices, function(rawDevice){
            var matchedSuperType = _.find(superTypesToGroupBy, function(superType){
               return vmDeviceInfoService.isDeviceSubclassOf(rawDevice, superType);
            });

            return matchedSuperType ? matchedSuperType : DEFAULT_DEVICE;
         });
      }

      function computeDeviceNumber(rawDevice) {
         var extractNumberRegex = /[0-9]+$/;
         var numberPostfix = extractNumberRegex.exec(rawDevice.deviceInfo.label);
         return numberPostfix ? parseInt(numberPostfix, 10) : 0;
      }

      //TODO: Fix to support correct sorting of new devices.
      function computeSortId (rawDevice) {
         // magic numbers only used to give relative ordering
         if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualDisk')) {
            return 10000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualSCSIController')) {
            return 15000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualEthernetCard')) {
            return 20000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualCdrom')) {
            return 30000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualFloppy')) {
            return 40000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualUSBController') ||
               vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualUSBXHCIController')) {
            return 55000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualUSB')) {
            return 60000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualVideoCard')) {
            return 70000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualNVDIMM')) {
            return 75000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualSCSIPassthrough')) {
            return 80000 + computeDeviceNumber(rawDevice);
         } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualPCIPassthrough')) {
            return 90000 + computeDeviceNumber(rawDevice);
         } else { // all other VirtualDevices we sort by key instead of label
            return 100000 + rawDevice.key;
         }
      }
   }
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service('deviceService', [
      'vmDeviceInfoService',
      'i18nService',
      'VmController',
      'virtualDeviceInflator',
      deviceService
   ]);
   function deviceService(vmDeviceInfoService, i18nService, VmController, virtualDeviceInflator) {
      var currentKey = -100;
      var keyTable = {};

      addLocalizationKey('VirtualUSB', 'NewVirtualUSB');
      addLocalizationKey('VirtualDisk', 'NewDisk');
      addLocalizationKey('VirtualEthernetCard', 'NewEthernet');
      addLocalizationKey('VirtualSCSIController', 'NewSCSIController');
      addLocalizationKey('VirtualSATAController', 'NewSATAController');
      addLocalizationKey('VirtualTPM', 'NewTPM');
      addLocalizationKey('ParaVirtualSCSIController', 'NewSCSIController');
      addLocalizationKey('VirtualUSBController', 'NewUSBController');
      addLocalizationKey('VirtualUSBXHCIController', 'NewUSBController');
      addLocalizationKey('VirtualNVMEController', 'NewVirtualNVMEController');
      addLocalizationKey('VirtualPCIPassthrough', 'NewPCIPassthrough');
      addLocalizationKey('VirtualNVDIMM', 'NewNVDIMM');
      addLocalizationKey('VirtualNVDIMMController', 'NewNVDIMMController');
      addLocalizationKey('VirtualSerialPort', 'NewSerialPort');

      return {
         setDeviceInfo: setDeviceInfo,
         newKey: newKey,
         calculateKey: calculateKey,
         makeController: makeController,
         findLocalizationKey: findLocalizationKey,
         addLocalizationKey: addLocalizationKey
      };

      function newKey() { return --currentKey; }

      /**
       * Calculates the smallest key, from which to start when adding a new device
       * Needed in case there are already new devices present, like for the case with
       * scheduled tasks
       * @param devices
       */
      function calculateKey(devices) {
         _.each(devices, function(device) {
            if (device.getKey() < currentKey) {
               currentKey = device.getKey();
            }
         });
      }

      function makeController(deviceOptions, controllerType, busNumber) {
         var vmController = VmController.createForType(deviceOptions, controllerType, newKey(), busNumber);
         var deviceOptionsByDeviceType = _.indexBy(deviceOptions, function(deviceOption){
            return deviceOption.type.name;
         });
         var inflatedController = virtualDeviceInflator.inflate(vmController.toJson(), {
            deviceOptionsByDeviceType: deviceOptionsByDeviceType
         });
         inflatedController = setDeviceInfo(inflatedController);
         return inflatedController;
      }

      function setDeviceInfo(inflatedDevice) {
         var device = inflatedDevice.getCurrentDevice();
         var localizationKey = findLocalizationKey(device);
         var deviceLabel = i18nService.getString('VmUi', 'VmDeviceManager.' + localizationKey);

         device.deviceInfo = {
            _type: 'com.vmware.vim.binding.vim.Description',
            label: deviceLabel,
            summary: deviceLabel
         };
         return inflatedDevice;
      }

      function addLocalizationKey(key, value) {
         keyTable[key] = value;
      }

      function findLocalizationKey(device) {
         var localizationKey = _.find(keyTable, function (value, key) {
            return vmDeviceInfoService.isDeviceSubclassOf(device, key);
         });
         if (localizationKey === undefined) {
            throw('no localization lookup for key for ' + device._type);
         }
         return localizationKey;
      }
   }
}());

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('diskProvisioningService', diskProvisioningService);

   diskProvisioningService.$inject = [
      'i18nService',
      'deviceService',
      'diskControllerIndexAdviserService',
      'diskFormatService',
      'VirtualDisk',
      'vmDeviceInfoService',
      'managedEntityConstants',
      'diskBackingInfoConstants',
      'deviceTypeConstants',
      'pmemUtilService'
   ];

   function diskProvisioningService(i18nService,
         deviceService,
         diskControllerIndexAdviserService,
         diskFormatService,
         VirtualDisk,
         vmDeviceInfoService,
         managedEntityConstants,
         diskBackingInfoConstants,
         deviceTypeConstants,
         pmemUtilService) {
      var diskFormats = _.extend({
         sesparse: { name: i18nService.getString('VmUi', 'DiskPage.SeSparse') }
      }, diskFormatService.diskFormats);

      var typeToBackingKeysTable = {
         thin: { thinProvisioned: true, eagerlyScrub: null },
         thick: { thinProvisioned: false, eagerlyScrub: true },
         flat: { thinProvisioned: false, eagerlyScrub: false },
         asDefinedInProfile: { thinProvisioned: true, eagerlyScrub: false },
         nativeThick: { thinProvisioned: false, eagerlyScrub: false }
      };

      return {
         makeDefaultVirtualDisk: makeDefaultVirtualDisk,
         makeDefaultVirtualDiskFromExistingDisk: makeDefaultVirtualDiskFromExistingDisk,
         makeDefaultRDMDisk: makeDefaultRDMDisk,
         backingInfoKeys: backingInfoKeys,
         hasFormat: hasFormat,
         getFormat: getFormat,
         getBackingInfo: getBackingInfo,
         getName: getName,
         getDiskFormats: getDiskFormats,
         setBackingDatastore: setBackingDatastore,
         areDiskFormatsEqual: areDiskFormatsEqual,
         SAME_AS_SOURCE: diskFormats.sameAsSource,
         FLAT: diskFormats.flat,
         THICK: diskFormats.thick,
         THIN: diskFormats.thin
      };

      function getDiskFormats() {
         return [
            diskFormats.sameAsSource,
            diskFormats.flat,
            diskFormats.thick,
            diskFormats.thin
         ];
      }

      function makeDefaultVirtualDiskFromExistingDisk(
            vmConfigEnvironment,
            guestOsDesc,
            otherInflatedDevices,
            additionalParameters,
            selectedDiskFile) {
         return makeDefaultDisk(vmConfigEnvironment,
               guestOsDesc,
               otherInflatedDevices,
               angular.extend(additionalParameters || {}, {
                  diskFile: selectedDiskFile
               }),
               deviceTypeConstants.EXISTINGHARDDISK
         );

      }

      function makeDefaultRDMDisk(vmConfigEnvironment,
            guestOsDesc,
            otherInflatedDevices,
            additionalParameters,
            selectedDevice) {

         if (!selectedDevice) {
            throw new Error("LUN selection cannot be null");
         }

         return makeDefaultDisk(vmConfigEnvironment,
               guestOsDesc,
               otherInflatedDevices,
               angular.extend(additionalParameters || {}, {
                  device: selectedDevice
               }),
               deviceTypeConstants.RDMDISK
         );
      }

      function makeDefaultVirtualDisk(vmConfigEnvironment,
            guestOsDesc,
            otherInflatedDevices,
            additionalParameters) {
         return makeDefaultDisk(vmConfigEnvironment,
               guestOsDesc,
               otherInflatedDevices,
               additionalParameters,
               deviceTypeConstants.VIRTUALDISK);
      }

      function makeDefaultDisk(vmConfigEnvironment,
            guestOsDesc,
            otherInflatedDevices,
            additionalParameters,
            deviceType) {
         var deviceOptions = vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption;
         var defaultInflatedDiskController;
         var unitNumber;
         var disk;
         var recommendedBus;

         var availableController = getRecommendedOrAvailableController(guestOsDesc,
               deviceOptions,
               otherInflatedDevices);
         defaultInflatedDiskController = availableController.recommendedController;
         recommendedBus = availableController.recommendedBusNo;
         unitNumber = availableController.recommendedUnitNo;
         var defaultDiskControllerType = availableController.defaultDiskControllerType;
         if (!defaultInflatedDiskController) {
            if (typeof recommendedBus === 'undefined' || recommendedBus < 0) {
               throw new Error(i18nService.getString('VmUi', 'GenericDevicePage.ControllerMaxLimitReached'));
            }

            var virtualDeviceOptions = vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption;
            defaultInflatedDiskController = deviceService.makeController(virtualDeviceOptions,
                  defaultDiskControllerType,
                  recommendedBus);
         }
         var diskOption = _.find(vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption, function(deviceOption) {
            var controllerTypeClass = deviceOption.controllerType && deviceOption.controllerType.typeClass;
            if (controllerTypeClass && defaultInflatedDiskController.isOfType(controllerTypeClass)) {
               return canUseFlatVer2BackingOption(deviceOption);
            }
            return false;
         });

         var capacity = getCapacity(deviceType, additionalParameters, guestOsDesc.recommendedDiskSizeMB * 1024);
         var rawDevice = {
            _type: diskOption.type.name,
            key: deviceService.newKey(),
            capacityInKB: capacity.valueInKB,
            capacityInBytes: capacity.valueInBytes,
            unitNumber: unitNumber,
            controllerKey: defaultInflatedDiskController.getKey(),
            backing: getBackingForDeviceType(deviceType, additionalParameters),
            storageIOAllocation: getDefaultStorageIOAllocation(),
            createdFromExistingDisk: deviceType === deviceTypeConstants.EXISTINGHARDDISK
         };

         disk = deviceService.setDeviceInfo(new VirtualDisk(rawDevice, null));
         if (additionalParameters && additionalParameters.selectedStorageProfile) {
            disk.updateDiskProfile(additionalParameters.selectedStorageProfile,
                  additionalParameters.selectedReplicationGroupInfo);
         }

         return {
            device: disk,
            controller: disk ? defaultInflatedDiskController : null
         };
      }

      function getRecommendedOrAvailableController(guestOsDesc, deviceOptions,
            otherInflatedDevices) {
         var controllerAdvise = diskControllerIndexAdviserService.getAdviceOnReusableController(guestOsDesc.recommendedDiskController,
               deviceOptions,
               otherInflatedDevices,
               'VirtualDisk');
         controllerAdvise.defaultDiskControllerType = guestOsDesc.recommendedDiskController;
         if (!controllerAdvise.recommendedController && controllerAdvise.recommendedBusNo < 0) {
            return checkForNextAvailableController(guestOsDesc, deviceOptions, otherInflatedDevices);
         }
         return controllerAdvise;
      }

      function checkForNextAvailableController(guestOsDesc, deviceOptions, otherInflatedDevices) {
         var otherSupportedControllerTypes = _.filter(guestOsDesc.supportedDiskControllerList, function(controller) {
            return controller.name !== guestOsDesc.recommendedDiskController.name;
         });
         var i = 0;
         var controllerAdvise = {};
         while (otherSupportedControllerTypes && i < otherSupportedControllerTypes.length) {
            controllerAdvise = diskControllerIndexAdviserService.getAdviceOnReusableController(
                  otherSupportedControllerTypes[i], deviceOptions,
                  otherInflatedDevices, 'VirtualDisk');
            if (!controllerAdvise.recommendedController && controllerAdvise.recommendedBusNo < 0) {
               i++;
               continue;
            } else {
               controllerAdvise.defaultDiskControllerType = otherSupportedControllerTypes[i];
               break;
            }
         }
         return controllerAdvise;
      }

      function getCapacity(deviceType, additionalParameters, recommendedCapacityInKB) {
         var capacityInKB;
         switch (deviceType) {
            case deviceTypeConstants.EXISTINGHARDDISK:
               if (additionalParameters.diskFile &&
                     additionalParameters.diskFile.fileInfo && additionalParameters.diskFile.fileInfo.capacityKb) {
                  capacityInKB = additionalParameters.diskFile.fileInfo.capacityKb;
               }
               break;
            case deviceTypeConstants.RDMDISK:
               if (additionalParameters.device && additionalParameters.device.capacity) {
                  capacityInKB = additionalParameters.device.capacity / 1024;
               }
               break;
            default:
               break;
         }

         capacityInKB = capacityInKB || recommendedCapacityInKB;

         return {
            valueInKB: capacityInKB,
            valueInBytes: capacityInKB * 1024
         };
      }

      function getBackingForDeviceType(deviceType, additionalParameters) {
         switch (deviceType) {
            case deviceTypeConstants.EXISTINGHARDDISK:
               if (additionalParameters.diskFile) {
                  return getBackingInfoForExistingDisk(additionalParameters.diskFile);
               } else {
                  throw new Error("Expected details of the file not present");
               }
               break;
            case deviceTypeConstants.RDMDISK:
               return makeRDMDeviceBacking(additionalParameters.device);
            case deviceTypeConstants.VIRTUALDISK:
               return makeFlatVer2Backing();
            default:
               throw new Error("Unsupported device type");
         }
      }

      function getBackingInfoForExistingDisk(file) {
         var backing = {};
         var fileInfo = file.fileInfo;
         if (fileInfo.diskType && fileInfo.diskType.typeClass) {
            backing._type = fileInfo.diskType.typeClass;
         } else {
            // See bug - 753043
            backing._type = diskBackingInfoConstants.SESPARSE;
         }

         backing.fileName = file.path;
         backing.diskMode = "persistent";

         if (!_.isEmpty(fileInfo.thin)) {
            backing.thinProvisioned = fileInfo.thin;
         }

         if (fileInfo.encryption && fileInfo.encryption.keyId) {
            backing.keyid = fileInfo.encryption.keyId;
         }
         return backing;
      }

      function getDefaultStorageIOAllocation() {
         return {
            _type: "com.vmware.vim.binding.vim.StorageResourceManager$IOAllocationInfo",
            limit: -1,
            shares: {
               _type: "com.vmware.vim.binding.vim.SharesInfo",
               shares: 1000,
               level: "normal"
            }
         };
      }

      function canUseFlatVer2BackingOption(deviceOption) {
         return _.find(deviceOption.backingOption, function(backingOption) {
            return backingOption._type === "com.vmware.vim.binding.vim.vm.device.VirtualDiskOption$FlatVer2BackingOption";
         });
      }

      function makeFlatVer2Backing() {
         return {
            _type: diskBackingInfoConstants.FLATVER2,
            fileName: '',
            diskMode: 'persistent'
         };
      }

      function makeRDMDeviceBacking(device) {
         return {
            _type: diskBackingInfoConstants.RAWDISKMAPPING,
            fileName: '',
            diskMode: 'independent_persistent',
            compatibilityMode: 'physicalMode',
            deviceName: device.deviceName
         };
      }

      function backingInfoKeys(provisioningType) {
         return typeToBackingKeysTable[provisioningType];
      }

      function hasFormat(backingInfo) {
         return backingInfo.thinProvisioned !== undefined;
      }

      function getFormat(backingInfo) {
         var type = _.findKey(typeToBackingKeysTable, function(value) {
            return value.thinProvisioned === backingInfo.thinProvisioned && value.eagerlyScrub === backingInfo.eagerlyScrub;
         });

         return diskFormats[type];
      }

      function getBackingInfo(provisioningType) {
         return _.extend(
               {
                  _type: diskBackingInfoConstants.FLATVER2,
                  fileName: "",
                  diskMode: ''
               },
               backingInfoKeys(provisioningType)
         );
      }

      function getName(backingInfo) {
         if (!backingInfo) {
            return "";
         }
         if (backingInfo._type && backingInfo._type.split('$')[1] === 'SeSparseBackingInfo') {
            return diskFormats.sesparse.name;
         } else if (backingInfo.thinProvisioned) {
            return diskFormats.thin.name;
         } else if (backingInfo.eagerlyScrub) {
            return diskFormats.thick.name;
         } else {
            return diskFormats.flat.name;
         }
      }

      /**
       * @description Sets the backing.fileName property and backing.datastore of each
       *    new disk device in deviceChanges parameter to contain the correct datastore
       *    name if disk is placed on a standalone host or on a specific datastore
       *    in a datastore cluster (SDRS disabled)
       * @param deviceChanges The device changes of the virtual machine containing
       *    the disk device changes.
       * @param vmStorageObject The storage object where the VMX will be placed.
       * @param diskStorageMap Contains the storage information for each disk
       * @returns PodSelectionSpec object containing info on how the vmx and disks will
       *    be placed.
       */
      function setBackingDatastore(deviceChanges, vmStorageObject, diskStorageMap) {
         var allDiskChanges = _.filter(deviceChanges, function(deviceChange) {
            return vmDeviceInfoService.isDeviceSubclassOf(deviceChange.device, "VirtualDisk")
                  && deviceChange.device.key < 0;
         });

         angular.forEach(allDiskChanges, function(diskChange) {
            if (diskChange.device.createdFromExistingDisk) {
               return;
            }
            var storageObject = vmStorageObject;

            var diskDatastoreConfig = diskStorageMap ?
                  diskStorageMap[diskChange.device.key] :
                  undefined;
            if (diskDatastoreConfig) {
               storageObject = diskDatastoreConfig.dsObject;
            }

            // When placing on a datastore cluster the backing.fileName and backing.datastore
            // should be unset, SDRS will decide where the disk would go.
            if (isStoragePod(storageObject)
                  || pmemUtilService.isPmemDisk(diskChange.device)) {
               diskChange.device.backing.fileName = '';
               diskChange.device.backing.datastore = undefined;
            } else {
               diskChange.device.backing.fileName = '[' + storageObject.name + ']';
            }
         });
      }

      function isStoragePod(storageObject) {
         return storageObject.storageRef.type === managedEntityConstants.STORAGE_POD;
      }

      /**
       * @param {com.vmware.vim.binding.vim.vm.device.VirtualDevice$BackingInfo} backingInfoA
       * @param {com.vmware.vim.binding.vim.vm.device.VirtualDevice$BackingInfo} backingInfoB
       *
       * @returns {boolean}
       */
      function areDiskFormatsEqual(backingInfoA, backingInfoB) {
         if (backingInfoA === backingInfoB) {
            return true;
         }

         if (!backingInfoA || !backingInfoB) {
            return false;
         }

         return (backingInfoA.thinProvisioned === backingInfoB.thinProvisioned) &&
               (backingInfoA.eagerlyScrub === backingInfoB.eagerlyScrub);
      }
   }
})();

var h5_vm;
(function (h5_vm) {
    var VmNetworkService = (function () {
        function VmNetworkService(dataService, defaultUriSchemeUtil, managedEntityConstants, networkSelectorPrefetchingService, networkSelectorDialogService, vmHardwareUtil) {
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.networkSelectorPrefetchingService = networkSelectorPrefetchingService;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmNetworkService.prototype.getVmNetworkInfo = function (networkProviderId, virtualNetworkDevices) {
            var _this = this;
            var type = this.defaultUriSchemeUtil.getEntityType(networkProviderId);
            if (type === this.managedEntityConstants.RESOURCE_POOL ||
                type === this.managedEntityConstants.V_APP) {
                return this.dataService.getPropertiesByRelation(networkProviderId, VmNetworkService.RELATION_RESOURCE_POOL, this.managedEntityConstants.ANY_COMPUTE_RESOURCE, [VmNetworkService.HOST])
                    .then(function (result) {
                    networkProviderId = _this.getNetworkProviderForResourcePoolAndVirtualApp(result);
                    return _this.fetchNetworksForProvider(networkProviderId, virtualNetworkDevices);
                });
            }
            else {
                return this.fetchNetworksForProvider(networkProviderId, virtualNetworkDevices);
            }
        };
        VmNetworkService.prototype.getSelectedNetwork = function (networkId, availableNetworks) {
            var network = _.find(availableNetworks, function (nw) {
                return nw.id === networkId;
            });
            if (!network) {
                return availableNetworks[0];
            }
            else {
                return network;
            }
        };
        VmNetworkService.prototype.getSelectedNetworkTypeForDevice = function (device, recommendedAdapterType, adapterTypes, hardwareDeviceOptions) {
            var selectedNetworkType = recommendedAdapterType || adapterTypes[0];
            if (device) {
                _.each(hardwareDeviceOptions, function (hardwareSupportedType) {
                    if (device._type === hardwareSupportedType.type.name) {
                        selectedNetworkType = hardwareSupportedType;
                    }
                });
            }
            return selectedNetworkType;
        };
        VmNetworkService.prototype.isNetworkSelectDisabled = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return false;
            }
            var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, [h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE]);
            return !hasPrivilege;
        };
        VmNetworkService.prototype.isConnectedDisabled = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return false;
            }
            var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.DeviceConnection']);
            return !hasPrivilege;
        };
        VmNetworkService.prototype.isConnectedAtPowerOnDisabled = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return false;
            }
            var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.DeviceConnection']);
            return !hasPrivilege;
        };
        VmNetworkService.prototype.isMacAddressDisabled = function (powerState, isNew, privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                return powerState !== 'poweredOff' && !isNew;
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.EditDevice']);
            return !hasPrivilege || validate();
        };
        VmNetworkService.prototype.isNetworkAdapterDisabled = function (isNew, privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                return !isNew;
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.EditDevice']);
            return !hasPrivilege || validate();
        };
        VmNetworkService.prototype.getNetworkProviderForResourcePoolAndVirtualApp = function (computeResourceData) {
            var networkProvider;
            var networkProviderId;
            var computeResource = _.values(computeResourceData)[0];
            // If the compute resource data contains only one host, this means that the
            // validated resource pool or vApp are under either:
            //    1. A standalone host;
            //    2. A single-host DRS cluster;
            // No matter of the case, this single host will be used as a network context.
            if (computeResource.host && computeResource.host.length === 1) {
                networkProvider = computeResource.host[0];
                networkProviderId = this.defaultUriSchemeUtil.getVsphereObjectId(networkProvider);
            }
            else {
                networkProviderId = _.keys(computeResourceData)[0];
            }
            return networkProviderId;
        };
        VmNetworkService.prototype.fetchNetworksForProvider = function (networkProviderId, virtualNetworkDevices) {
            var vmNetworks = this.getUniqueVmNetworks(virtualNetworkDevices);
            return this.networkSelectorPrefetchingService.prefetchNetworks(networkProviderId, this.getVmNetworkSelectorFilterSpec(), vmNetworks, VmNetworkService.NETWORK_PREFETCH_COUNT).then(function (networkInfo) {
                return {
                    availableNetworks: networkInfo.recentNetworks,
                    networkProviderId: networkProviderId
                };
            });
        };
        VmNetworkService.prototype.getVmNetworkSelectorFilterSpec = function () {
            if (!this._filterSpec) {
                this._filterSpec = this.networkSelectorDialogService.createNetworkSelectorFilterSpec(true /*includeStandardNetworks*/, true /*includeOpaqueNetworks*/, true /*includeDistributedPortGroups*/, false /*includeUplinkPortGroups*/, true /*includeOpaqueNetworkTypes*/);
            }
            return this._filterSpec;
        };
        VmNetworkService.prototype.getUniqueVmNetworks = function (virtualNetworkDevices) {
            var _this = this;
            var vmNetworks = [];
            var networkIds = [];
            _.forEach(virtualNetworkDevices, function (virtualNetworkDevice) {
                var networkId = virtualNetworkDevice.getNetworkId();
                if (networkId && networkIds.indexOf(networkId) < 0) {
                    vmNetworks.push(_this.defaultUriSchemeUtil.getManagedObjectReference(networkId));
                    networkIds.push(networkId);
                }
            });
            return vmNetworks;
        };
        VmNetworkService.prototype.isUptCompatibilityVisible = function (option) {
            if (!option) {
                return true;
            }
            var uptCompatibilityEnabledSupported = false;
            if (option.uptCompatibilityEnabled) {
                uptCompatibilityEnabledSupported = option.uptCompatibilityEnabled.supported;
            }
            var vmDirectPathGen2Supported = option.vmDirectPathGen2Supported;
            var retVal = (uptCompatibilityEnabledSupported && vmDirectPathGen2Supported);
            return retVal;
        };
        VmNetworkService.prototype.getUptCompatibility = function (device, deviceOption) {
            if (!device) {
                return false;
            }
            var value = device.uptCompatibilityEnabled;
            if (angular.isDefined(value)) {
                return value;
            }
            else {
                if (deviceOption) {
                    return deviceOption.uptCompatibilityEnabled.defaultValue;
                }
                else {
                    return false;
                }
            }
        };
        VmNetworkService.prototype.setUptCompatibility = function (device, value) {
            if (device) {
                device.uptCompatibilityEnabled = value;
            }
        };
        VmNetworkService.prototype.isEditUptCompatibilityDisabled = function (vmConfigContext, isNewDevice) {
            if (isNewDevice) {
                return false;
            }
            var hasPrivilege = h5_vm.VmHardwareUtil.userHasModifyDevicePermission(vmConfigContext);
            if (hasPrivilege === false) {
                return true;
            }
            return false;
        };
        VmNetworkService.prototype.isNotConnectable = function (device, vm) {
            var option = this.vmHardwareUtil.getDeviceOption(vm, device._type);
            if (!option) {
                return true;
            }
            var connectOption = option.connectOption;
            if (!connectOption) {
                return true;
            }
            return false;
        };
        VmNetworkService.$inject = [
            'dataService',
            'defaultUriSchemeUtil',
            'managedEntityConstants',
            'networkSelectorPrefetchingService',
            'networkSelectorDialogService',
            'vmHardwareUtil'];
        VmNetworkService.NETWORK_PREFETCH_COUNT = 10;
        VmNetworkService.RELATION_RESOURCE_POOL = 'rp';
        VmNetworkService.HOST = 'host';
        return VmNetworkService;
    }());
    h5_vm.VmNetworkService = VmNetworkService;
    angular
        .module('com.vmware.vsphere.client.vm')
        .service('vmNetworkService', VmNetworkService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').service('networkAdapterService', [
   'deviceService',
   'vmDeviceInfoService',
   'VirtualNetworkDevice',
   function(
      deviceService,
      vmDeviceInfoService,
      VirtualNetworkDevice
   ) {
      return {
         makeDefaultNetworkAdapter: makeDefaultNetworkAdapter
      };

      function makeDefaultNetworkAdapter(vmConfigEnvironment, guestOsDesc) {
         var nicType = guestOsDesc.recommendedEthernetCard.name;
         var nicOption = _.find(vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption, function (deviceOption) {
            return deviceOption.type.name === nicType;
         });

         var availableNetworks = vmDeviceInfoService.buildAvailableNetworkList(vmConfigEnvironment.configTarget);
         var defaultNetwork = _.find(availableNetworks, function(candidateNetwork) {
            return recommendsRegularNetwork(nicOption) && isRegularNetwork(candidateNetwork);
         });

         if (!defaultNetwork && availableNetworks.length > 0) {
            defaultNetwork = availableNetworks[0];
         }

         var rawNetworkDevice = {
            _type: nicOption.type.name,
            key: deviceService.newKey(),
            connectable: {
               _type: "com.vmware.vim.binding.vim.vm.device.VirtualDevice$ConnectInfo",
               startConnected: optionValue(nicOption.connectOption.startConnected),
               allowGuestControl: optionValue(nicOption.connectOption.allowGuestControl),
               connected: true
            }
         };

         if (nicOption.wakeOnLanEnabled.supported &&
               guestOsDesc.supportsWakeOnLan) {
            rawNetworkDevice.wakeOnLanEnabled = nicOption.wakeOnLanEnabled.defaultValue;
         }

         var device = deviceService.setDeviceInfo(new VirtualNetworkDevice(rawNetworkDevice, defaultNetwork));

         return {
            device: device
         };
      }

      function optionValue(opt) {
         return opt.supported && opt.defaultValue;
      }

      function recommendsRegularNetwork(nicOption) {
         return nicOption.backingOption[nicOption.defaultBackingOptionIndex]._type === 'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCardOption$NetworkBackingOption';
      }

      function isRegularNetwork(candidateNetwork) {
         return !!candidateNetwork.network;
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var NvmeControllerService = (function () {
        function NvmeControllerService(deviceService, deviceClassLineageService, i18nService, deviceTypeConstants) {
            this.deviceService = deviceService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.i18nService = i18nService;
            this.deviceTypeConstants = deviceTypeConstants;
        }
        NvmeControllerService.prototype.makeDefaultNVMeController = function (guestOsDescriptor, deviceOptions, virtualMachineDevices, powerState) {
            var supportedDiskControllerList = guestOsDescriptor.supportedDiskControllerList;
            var nvmeSupportIndex = this.getNVMeSupport(supportedDiskControllerList);
            if (nvmeSupportIndex < 0) {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceNotSupported'));
            }
            if (powerState === "poweredOn" && !this.getNVMeSupportOnPowerState(deviceOptions)) {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.HotAddNotSupported'));
            }
            var deviceControllerType = supportedDiskControllerList[nvmeSupportIndex];
            var availableBusNumber = this.findAvailableBusNumber(virtualMachineDevices);
            if (availableBusNumber >= 0) {
                var device = this.deviceService.makeController(deviceOptions, deviceControllerType, availableBusNumber);
                return {
                    device: device
                };
            }
            else {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceLimitReached'));
            }
        };
        NvmeControllerService.prototype.getNVMeSupportOnPowerState = function (deviceOptions) {
            var nvmeDeviceOption = deviceOptions.find(function (deviceOption) {
                return deviceOption.type.name === "com.vmware.vim.binding.vim.vm.device.VirtualNVMEController";
            }, this);
            return nvmeDeviceOption.plugAndPlay;
        };
        NvmeControllerService.prototype.getNVMeSupport = function (supportedDiskControllerList) {
            var _this = this;
            var index = _.findIndex(supportedDiskControllerList, function (current) {
                return _this.deviceClassLineageService.isClassNameSubclassOf(current.typeClass, _this.deviceTypeConstants.NVME_CONTROLLER);
            });
            return index;
        };
        NvmeControllerService.prototype.findAvailableBusNumber = function (virtualMachineDevices) {
            var allNvmeControllers = virtualMachineDevices.existingDevicesOfType(this.deviceTypeConstants.NVME_CONTROLLER);
            allNvmeControllers = allNvmeControllers.concat(virtualMachineDevices.newDevicesOfType(this.deviceTypeConstants.NVME_CONTROLLER));
            for (var busNumber = 0; busNumber <= 3; busNumber++) {
                if (!this.findController(busNumber, allNvmeControllers)) {
                    return busNumber;
                }
            }
            return -1;
        };
        NvmeControllerService.prototype.findController = function (busNumber, allNvmeControllers) {
            return _.find(allNvmeControllers, function (controller) {
                return controller.getCurrentDevice().busNumber === busNumber;
            });
        };
        NvmeControllerService.$inject = ['deviceService', 'deviceClassLineageService', 'i18nService', 'deviceTypeConstants'];
        return NvmeControllerService;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .service('nvmeControllerService', NvmeControllerService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').service('opticalDriveService', [
   'deviceService',
   'diskControllerIndexAdviserService',
   'i18nService',
   'VirtualCdrom',
   function(deviceService,
         diskControllerIndexAdviserService,
         i18nService,
         VirtualCdrom) {

      var CDROM_DEVICE = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom';
      var CDROM_DEVICE_OPTION = 'com.vmware.vim.binding.vim.vm.device.VirtualCdromOption';
      var CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH = CDROM_DEVICE_OPTION + '$RemotePassthroughBackingOption';
      var CDROM_DEVICE_OPTION__PASSTHROUGH = CDROM_DEVICE_OPTION + '$PassthroughBackingOption';
      var CDROM_DEVICE_OPTION__ATAPI = CDROM_DEVICE_OPTION + '$AtapiBackingOption';
      var CDROM_DEVICE__REMOTE_PASSTHROUGH = CDROM_DEVICE + '$RemotePassthroughBackingInfo';
      var CDROM_DEVICE__PASSTHROUGH = CDROM_DEVICE + '$PassthroughBackingInfo';
      var CDROM_DEVICE__ATAPI = CDROM_DEVICE + '$AtapiBackingInfo';
      var OPTION_INFO_MAPPING = {};
      OPTION_INFO_MAPPING[CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH] = CDROM_DEVICE__REMOTE_PASSTHROUGH;
      OPTION_INFO_MAPPING[CDROM_DEVICE_OPTION__PASSTHROUGH] = CDROM_DEVICE__PASSTHROUGH;
      OPTION_INFO_MAPPING[CDROM_DEVICE_OPTION__ATAPI] = CDROM_DEVICE__ATAPI;

      deviceService.addLocalizationKey('VirtualCdrom', 'NewCdrom');

      return {
         makeDefaultOpticalDrive: makeDefaultOpticalDrive,
         CDROM_DEVICE: CDROM_DEVICE,
         CDROM_DEVICE_OPTION: CDROM_DEVICE_OPTION,
         CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH: CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH,
         CDROM_DEVICE_OPTION__PASSTHROUGH: CDROM_DEVICE_OPTION__PASSTHROUGH,
         CDROM_DEVICE_OPTION__ATAPI: CDROM_DEVICE_OPTION__ATAPI,
         CDROM_DEVICE__REMOTE_PASSTHROUGH: CDROM_DEVICE__REMOTE_PASSTHROUGH,
         CDROM_DEVICE__PASSTHROUGH: CDROM_DEVICE__PASSTHROUGH,
         CDROM_DEVICE__ATAPI: CDROM_DEVICE__ATAPI
      };

      function makeDefaultOpticalDrive(vmConfigEnvironment, guestOsDesc, inflatedDevices) {
         var deviceOptions = vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption;
         var opticalDriveOptions = _.select(deviceOptions, function(deviceOption) {
            return deviceOption._type === CDROM_DEVICE_OPTION;
         });

         opticalDriveOptions = sortOpticalDriveOptions(opticalDriveOptions, guestOsDesc);

         var inflatedOpticalDriveDevice, inflatedOpticalDriveController;
         if (!_.isEmpty(opticalDriveOptions)) {
            var option = opticalDriveOptions[0];

            var controllerAdvise = diskControllerIndexAdviserService.getAdviceOnReusableController(
                  option.controllerType,
                  deviceOptions,
                  inflatedDevices,
                  "VirtualCdrom");

            inflatedOpticalDriveController = controllerAdvise.recommendedController;
            var recommendedBusNo = controllerAdvise.recommendedBusNo;
            var recommendedUnitNumber = controllerAdvise.recommendedUnitNo;

            if (!inflatedOpticalDriveController) {
               if (recommendedBusNo < 0) {
                  throw new Error(i18nService.getString('VmUi', 'GenericDevicePage.ControllerMaxLimitReached'));
               }
               inflatedOpticalDriveController = deviceService.makeController(deviceOptions, option.controllerType);
            }

            if (recommendedUnitNumber < 0) {
               return {
                  device: null,
                  controller: inflatedOpticalDriveController.getCurrentDevice()
               };
            } else {
               inflatedOpticalDriveDevice = makeOpticalDriveDevice(option, vmConfigEnvironment,
                     inflatedOpticalDriveController, recommendedUnitNumber);
            }
         }

         if (!inflatedOpticalDriveDevice) {
            throw new Error('no device able to be created');
         }

         deviceService.setDeviceInfo(inflatedOpticalDriveDevice);
         return {
            device: inflatedOpticalDriveDevice,
            controller: inflatedOpticalDriveController
         };
      }

      //------ Private API -----

      function sortOpticalDriveOptions(opticalDriveOptions, guestOsDesc) {
         var guestRecommendedDeviceControllerClass = guestOsDesc.recommendedCdromController && guestOsDesc.recommendedCdromController.typeClass;
         var deviceControllerPriority = [
            guestRecommendedDeviceControllerClass,
            'com.vmware.vim.binding.vim.vm.device.VirtualSATAController',
            'com.vmware.vim.binding.vim.vm.device.VirtualIDEController'
         ];

         function chosenControllerFirstSorter(a, b) {
            var c1 = a.controllerType ? a.controllerType.typeClass : null;
            var c2 = b.controllerType ? b.controllerType.typeClass : null;
            var priority1 = deviceControllerPriority.findIndex(function (deviceController) { return deviceController === c1; });
            if (priority1 === -1) {
               return 1;
            }
            var priority2 = deviceControllerPriority.findIndex(function (deviceController) { return deviceController === c2; });
            if (priority2 === -1) {
               return -1;
            }
            return priority1 - priority2;
         }
         return opticalDriveOptions.sort(chosenControllerFirstSorter);
      }

      function makeOpticalDriveDevice(driveOption, vmConfigEnvironment, inflatedDeviceController, unitNumber) {
         var opticalDriveBackingOptions = driveOption.backingOption;
         var backingInfo = createBackingInfo(opticalDriveBackingOptions, vmConfigEnvironment.configTarget.cdRom);
         if (!backingInfo) {
            return null;
         }
         var device = {
            _type: CDROM_DEVICE,
            key: deviceService.newKey(),
            connectable: createConnectInfo(driveOption.connectOption),
            backing: backingInfo,
            controllerKey: inflatedDeviceController.getKey(),
            unitNumber: unitNumber
         };
         return new VirtualCdrom(device);
      }

      function createConnectInfo(connectOption) {
         return {
            _type: "com.vmware.vim.binding.vim.vm.device.VirtualDevice$ConnectInfo",
            startConnected: false,
            allowGuestControl: connectOption.allowGuestControl.supported && connectOption.allowGuestControl.defaultValue,
            connected: false
         };
      }

      function createBackingInfo(backingOptions, hostCdromList) {
         if (!backingOptions || backingOptions.length === 0) {
            return null;
         }

         var defaultBackingOption = findDefaultBackingOption(backingOptions);

         if (!defaultBackingOption) {
            return null;
         }

         if (defaultBackingOption._type === CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH) {
            return {
               _type: OPTION_INFO_MAPPING[defaultBackingOption._type],
               deviceName: "",
               exclusive: false
            };
         }

         return createHostCdromBackingInfo(hostCdromList, defaultBackingOption);
      }

      function findDefaultBackingOption(backingOptions) {
         var defaultableBackingOptions = _.select(backingOptions, function(backingOption) {
            return _.contains(prioritizedBackingOptions(), backingOption._type);
         });

         if (!defaultableBackingOptions || defaultableBackingOptions.length === 0) {
            return null;
         }

         var firstDefaultableBackingOption = defaultableBackingOptions.sort(defaultOpticalDrivePrioritySorter)[0];
         if (firstDefaultableBackingOption) {
            return firstDefaultableBackingOption;
         }
         return null;
      }

      function createHostCdromBackingInfo(hostCdromList, defaultBackingOption) {
         if (!hostCdromList || hostCdromList.length === 0) {
            return null;
         }

         var backingInfo = {
            _type: OPTION_INFO_MAPPING[defaultBackingOption._type],
            deviceName: hostCdromList[0].name
         };

         if (defaultBackingOption._type === CDROM_DEVICE_OPTION__PASSTHROUGH) {
            backingInfo.exclusive = false;
         }

         return backingInfo;
      }

      function prioritizedBackingOptions() {
         return [
            CDROM_DEVICE_OPTION__REMOTE_PASSTHROUGH,
            CDROM_DEVICE_OPTION__PASSTHROUGH,
            CDROM_DEVICE_OPTION__ATAPI
         ];
      }

      function defaultOpticalDrivePrioritySorter(a, b) {
         var byPriority = prioritizedBackingOptions();
         return byPriority.indexOf(a._type) - byPriority.indexOf(b._type);
      }

   }]);

/**
 * @ngdoc service
 * @name com.vmware.vsphere.client.vm.podSelectionSpecService
 * @module com.vmware.vsphere.client.vm
 *
 * @description
 *    Utility service for creating PodSelectionSpec used to generate recommendations
 *    for SDRS placement.
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('podSelectionSpecService', podSelectionSpecService);

   podSelectionSpecService.$inject = [
      'defaultUriSchemeUtil',
      'managedEntityConstants',
      'diskProvisioningService',
      'storageProfileService'
   ];

   function podSelectionSpecService(defaultUriSchemeUtil,
         managedEntityConstants,
         diskProvisioningService,
         storageProfileService) {
      return {
         createSpec: createSpec,
         createSpecForClone: createSpecForClone
      };

      /**
       * @param newVirtualDisks The newly added virtual disks.
       * @param vmxStorageObject The storage object where the VMX will be placed.
       * @param diskStorageMap Contains the storage information for each disk
       * @returns PodSelectionSpec object containing info on how the vmx and disks will
       *    be placed.
       */
      function createSpec(
            newVirtualDisks,
            vmxStorageObject,
            diskStorageMap) {
         var disksLocatorsByPod = {};
         addDiskLocatorsForNewDisks(newVirtualDisks, diskStorageMap, vmxStorageObject, disksLocatorsByPod);

         var podSelectionSpec = createSpecFromPodMap(vmxStorageObject, disksLocatorsByPod);
         return podSelectionSpec;
      }

      /**
       * @param originalVirtualDisks The original virtual disks, empty when creating
       *    new vm.
       * @param newVirtualDisks The newly added virtual disks.
       * @param vmxStorageObject The storage object where the VMX will be placed.
       * @param provisioningType The provisioning type of the VMX.
       * @param diskStorageMap Contains the storage information for each disk
       * @returns PodSelectionSpec object containing info on how the vmx and disks will
       *    be placed.
       */
      function createSpecForClone(
            originalVirtualDisks,
            newVirtualDisks,
            vmxStorageObject,
            provisioningType,
            diskStorageMap,
            storageVirtualDisks) {
         var disksLocatorsByPod = {};
         addDiskLocatorsForNewDisks(newVirtualDisks, diskStorageMap, vmxStorageObject, disksLocatorsByPod);

         addDiskLocatorsOriginalDisks(originalVirtualDisks, provisioningType, vmxStorageObject,
               disksLocatorsByPod, diskStorageMap, storageVirtualDisks);

         var podSelectionSpec = createSpecFromPodMap(vmxStorageObject, disksLocatorsByPod);
         return podSelectionSpec;
      }

      function createSpecFromPodMap(vmxStorageObject, disksLocatorsByPod) {
         var podSelectionSpec;
         var initialVmConfig = [];
         addVmxConfig(vmxStorageObject, initialVmConfig);
         _.each(disksLocatorsByPod, function (diskConfig, podId) {
            var podRef = defaultUriSchemeUtil.getManagedObjectReference(podId);
            initialVmConfig.push(buildVmPodConfig(
                  diskConfig.diskLocator,
                  podRef,
                  diskConfig.disableSdrs
            ));
         });


         if (initialVmConfig.length > 0) {
            var vmxPodRef = getDiskPod(vmxStorageObject);
            podSelectionSpec = {
               _type: 'com.vmware.vim.binding.vim.storageDrs.PodSelectionSpec',
               storagePod: (vmxPodRef && vmxPodRef.isSdrsEnabled ? vmxPodRef : null),
               initialVmConfig: initialVmConfig
            };
         }
         return podSelectionSpec;
      }

      function addDiskLocatorToPodConfig(diskLocator, diskStorageObject, disksLocatorsByPod) {
         var pod = getDiskPod(diskStorageObject);

         //if not in pod or sdrs disabled we don't have to ask for recommendations
         if (pod && (pod.isSdrsEnabled || pod.drsEnabled)) {

            //if diskDatastoreConfig is defined than it is stored separately
            //else the current disk will be placed together with the vmx
            var podId = defaultUriSchemeUtil.getVsphereObjectId(pod);

            addPodEntryIfNotPresent(disksLocatorsByPod, podId, isSdrsDisabled(diskStorageObject));
            disksLocatorsByPod[podId].diskLocator.push(diskLocator);
         }
      }

      function addDiskLocatorsOriginalDisks(originalVirtualDisks, provisioningType, storageObject,
            disksLocatorsByPod, storageObjPerDisk, storageVirtualDisks) {
         _.each(originalVirtualDisks, function (originalVirtualDisk) {
            var storageSelectorDisk = _.find(storageObjPerDisk, function (disk) {
               return disk.diskKey === originalVirtualDisk.key;
            });
            var backing = storageSelectorDisk && storageSelectorDisk.diskBacking;
            if (!storageSelectorDisk && provisioningType && provisioningType !== diskProvisioningService.SAME_AS_SOURCE) {
               backing = diskProvisioningService.getBackingInfo(provisioningType.type);
            }

            var profile = originalVirtualDisk.profile;

            // use the disks configuration as it was set in the select storage page
            // and use the calculated profile there
            var disk = _.find(storageVirtualDisks, function(disk) {
               return disk.key === originalVirtualDisk.key;
            });
            if (disk) {
               profile = disk.profile;
            }

            var originalVirtualDiskLocator = buildDiskLocator(
                  originalVirtualDisk.key,
                  backing,
                  profile);
            var storageObjToSet = storageSelectorDisk ? storageSelectorDisk.dsObject : storageObject;
            addDiskLocatorToPodConfig(originalVirtualDiskLocator, storageObjToSet, disksLocatorsByPod);
         });
      }

      function addDiskLocatorsForNewDisks(newVirtualDisks, diskStorageMap, vmxStorageObject, disksLocatorsByPod) {

         newVirtualDisks = newVirtualDisks ? newVirtualDisks : [];

         _.each(newVirtualDisks, function (newVirtualDisk) {
            if (newVirtualDisk.createdFromExistingDisk) {
               return;
            }

            var diskStorageObject;
            var diskDatastoreConfig = diskStorageMap ?
                  diskStorageMap[newVirtualDisk.key] : undefined;
            if (diskDatastoreConfig) {
               diskStorageObject = diskDatastoreConfig.dsObject;
            } else {
               diskStorageObject = vmxStorageObject;
            }
            var diskLocator = buildDiskLocator(
                  newVirtualDisk.key,
                  newVirtualDisk.backing,
                  newVirtualDisk.profile);
            addDiskLocatorToPodConfig(diskLocator, diskStorageObject, disksLocatorsByPod);

         });
      }

      function addVmxConfig(vmxStorageObject, initialVmConfig) {
         var vmxPodRef = getDiskPod(vmxStorageObject);
         if (vmxPodRef && vmxPodRef.isSdrsEnabled) {
            initialVmConfig.push(buildVmPodConfig(
                  [],
                  vmxPodRef,
                  isSdrsDisabled(vmxStorageObject)
            ));
         }
         return vmxPodRef;
      }

      function addPodEntryIfNotPresent(disksLocatorsByPod, podId, isSdrsDisabled) {
         if (!disksLocatorsByPod[podId]) {
            disksLocatorsByPod[podId] = {
               disableSdrs: isSdrsDisabled,
               diskLocator: []
            };
         }
      }

      function buildVmPodConfig(diskLocators, storagePod, isSdrsDisabledForVm) {
         var vmPodConfig = {
            _type: "com.vmware.vim.binding.vim.storageDrs.PodSelectionSpec$VmPodConfig",
            disk: diskLocators,
            storagePod: storagePod
         };
         if (isSdrsDisabledForVm) {
            createVmConfigInfoIfNull(vmPodConfig);
            vmPodConfig.vmConfig.enabled = false;
         }

         return vmPodConfig;
      }

      /**
       * Create new instance of the vmConfig if it is <code>null</code>.
       */
      function createVmConfigInfoIfNull(vmPodConfig) {
         if (!vmPodConfig.vmConfig) {
            vmPodConfig.vmConfig = {
               _type: 'com.vmware.vim.binding.vim.storageDrs.VmConfigInfo'
            };
         }
      }

      function buildDiskLocator(diskId, backing, storageProfile) {
         var profileId;
         if (storageProfile) {
            profileId = storageProfile.profileId || storageProfile.id;
         }
         return {
            _type: "com.vmware.vim.binding.vim.storageDrs.PodSelectionSpec$DiskLocator",
            diskId: diskId,
            diskBackingInfo: backing,
            profile: [storageProfileService.makeProfile(profileId)]
         };
      }

      function isSdrsDisabled(storageObject) {
         return storageObject.storageRef.type === managedEntityConstants.DATASTORE
               && storageObject.parentStoragePod
               && storageObject.parentStoragePod.type === managedEntityConstants.STORAGE_POD;
      }

      function getDiskPod(storageObject) {
         return storageObject.storageRef.type === managedEntityConstants.STORAGE_POD ?
               storageObject.storageRef :
               storageObject.parentStoragePod;
      }

   }
}());

var h5_vm;
(function (h5_vm) {
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var SataControllerService = (function () {
        function SataControllerService(deviceService, deviceClassLineageService, i18nService) {
            this.deviceService = deviceService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.i18nService = i18nService;
        }
        SataControllerService.prototype.makeDefaultSataController = function (deviceOptions, virtualMachineDevices) {
            var sataSupportIndex = this.getSATASupport(deviceOptions);
            if (sataSupportIndex < 0) {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceNotSupported'));
            }
            var deviceControllerType = deviceOptions[sataSupportIndex].type;
            var availableBusNumber = this.findAvailableBusNumber(virtualMachineDevices);
            if (availableBusNumber >= 0) {
                var device = this.deviceService.makeController(deviceOptions, deviceControllerType, availableBusNumber);
                return {
                    device: device
                };
            }
            else {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceLimitReached'));
            }
        };
        SataControllerService.prototype.getSATASupport = function (deviceOptions) {
            var _this = this;
            var index = _.findIndex(deviceOptions, function (option) {
                return _this.deviceClassLineageService.isClassNameSubclassOf(option.type.wsdlName, DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER);
            });
            return index;
        };
        SataControllerService.prototype.findAvailableBusNumber = function (virtualMachineDevices) {
            var allSataControllers = virtualMachineDevices.existingDevicesOfType(DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER);
            allSataControllers = allSataControllers.concat(virtualMachineDevices
                .newDevicesOfType(DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER));
            for (var busNumber = 0; busNumber <= 3; busNumber++) {
                if (!this.findController(busNumber, allSataControllers)) {
                    return busNumber;
                }
            }
            return -1;
        };
        SataControllerService.prototype.findController = function (busNumber, allSataControllers) {
            return _.find(allSataControllers, function (controller) {
                return controller.getCurrentDevice().busNumber === busNumber;
            });
        };
        SataControllerService.$inject = ['deviceService', 'deviceClassLineageService', 'i18nService'];
        return SataControllerService;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .service('sataControllerService', SataControllerService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var ScsiControllerService = (function () {
        function ScsiControllerService(deviceService, i18nService) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
        }
        ScsiControllerService.prototype.makeDefaultSCSIController = function (guestOsDescriptor, deviceOptions, virtualMachineDevices) {
            var type = guestOsDescriptor.recommendedSCSIController;
            var busNumber = this.findSCSIControllerBusNumber(virtualMachineDevices);
            if (busNumber >= 0) {
                var device = this.deviceService.makeController(deviceOptions, type, this.findSCSIControllerBusNumber(virtualMachineDevices));
                return {
                    device: device
                };
            }
            else {
                throw new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceLimitReached'));
            }
        };
        ScsiControllerService.prototype.findSCSIControllerBusNumber = function (virtualMachineDevices) {
            var allSCSIControllers = virtualMachineDevices.existingDevicesOfType('VirtualSCSIController');
            allSCSIControllers = allSCSIControllers.concat(virtualMachineDevices.newDevicesOfType('VirtualSCSIController'));
            for (var busNumber = 0; busNumber <= 3; busNumber++) {
                if (!this.findSCSIController(busNumber, allSCSIControllers)) {
                    return busNumber;
                }
            }
            return -1;
        };
        ScsiControllerService.prototype.findSCSIController = function (busNumber, allSCSIControllers) {
            return _.find(allSCSIControllers, function (controller) {
                return controller.getCurrentDevice().busNumber === busNumber;
            });
        };
        ScsiControllerService.$inject = ['deviceService', 'i18nService'];
        return ScsiControllerService;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .service('scsiControllerService', ScsiControllerService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var VirtualSerialPort$FileBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$FileBackingInfo;
    var VirtualDevice$ConnectInfo = com.vmware.vim.binding.vim.vm.device.VirtualDevice$ConnectInfo;
    var VirtualSerialPort = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort;
    var SerialPortService = (function () {
        function SerialPortService(deviceService, deviceClassLineageService, i18nService, VmHwSerialPort) {
            this.deviceService = deviceService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.i18nService = i18nService;
            this.VmHwSerialPort = VmHwSerialPort;
        }
        SerialPortService.prototype.makeDefaultSerialPort = function (env, virtualMachineDevices) {
            var deviceOptions = env.configOption.hardwareOptions.virtualDeviceOption;
            var powerState = env.powerState;
            var serialPortSupportIndex = this.getDeviceSupport(deviceOptions, DeviceTypeConstants.VIRTUAL_SERIAL_PORT);
            var sioControllerSupportIndex = this.getDeviceSupport(deviceOptions, DeviceTypeConstants.VIRTUAL_SIO_CONTROLLER);
            var option = deviceOptions[serialPortSupportIndex];
            var sioOption = deviceOptions[sioControllerSupportIndex];
            if (!option || !sioOption) {
                throw this.newErrorDeviceNotSupported();
            }
            var maxNumberOfSerialPort = sioOption.numSerialPorts.max;
            var numberOfSerialPort = this.getNumberOfSerialPorts(virtualMachineDevices);
            if (numberOfSerialPort === maxNumberOfSerialPort) {
                throw new Error(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceLimitReached"));
            }
            if (powerState === h5_vm.PowerState.POWERED_ON && !option.plugAndPlay) {
                throw this.newErrorHotAddNotSupported();
            }
            var rawDevice = new VirtualSerialPort();
            rawDevice.key = this.deviceService.newKey();
            var fileBacking = new VirtualSerialPort$FileBackingInfo();
            rawDevice.backing = fileBacking;
            fileBacking.fileName = "";
            rawDevice.connectable = new VirtualDevice$ConnectInfo();
            rawDevice.connectable.startConnected = option.connectOption.startConnected.defaultValue;
            rawDevice.connectable.connected = false;
            rawDevice.connectable.allowGuestControl = option.connectOption.allowGuestControl.defaultValue;
            rawDevice.yieldOnPoll = option.yieldOnPoll.defaultValue;
            var inflatedDevice = new this.VmHwSerialPort(rawDevice);
            this.deviceService.setDeviceInfo(inflatedDevice);
            return {
                device: inflatedDevice
            };
        };
        SerialPortService.prototype.getDeviceSupport = function (deviceOptions, deviceType) {
            var _this = this;
            return _.findIndex(deviceOptions, function (option) {
                return _this.deviceClassLineageService.isClassNameSubclassOf(option.type.wsdlName, deviceType);
            });
        };
        SerialPortService.prototype.getNumberOfSerialPorts = function (virtualMachineDevices) {
            var existingSerialPorts = virtualMachineDevices.existingDevicesOfType(DeviceTypeConstants.VIRTUAL_SERIAL_PORT).length;
            var newSerialPorts = virtualMachineDevices.newDevicesOfType(DeviceTypeConstants.VIRTUAL_SERIAL_PORT).length;
            return existingSerialPorts + newSerialPorts;
        };
        SerialPortService.prototype.newErrorHotAddNotSupported = function () {
            return this.newError(this.i18nService.getString, "HotAddNotSupported");
        };
        SerialPortService.prototype.newErrorDeviceNotSupported = function () {
            return this.newError(this.i18nService.getString, "DeviceNotSupported");
        };
        SerialPortService.prototype.newError = function (i18n, key) {
            var msg = i18n("VmUi", "VmDeviceManager." + key);
            var retVal = new Error(msg);
            return retVal;
        };
        SerialPortService.$inject = ["deviceService", "deviceClassLineageService", "i18nService", "VmHwSerialPort"];
        return SerialPortService;
    }());
    h5_vm.SerialPortService = SerialPortService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("serialPortService", SerialPortService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var TpmProvisioningService = (function () {
        function TpmProvisioningService(deviceService, i18nService, VirtualTPM, dataService, defaultUriSchemeUtil) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
            this.VirtualTPM = VirtualTPM;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        TpmProvisioningService.prototype.checkDefaultKmsServer = function (serverGuid) {
            var rootFolder = this.defaultUriSchemeUtil.createVmomiUri('Folder', 'group-d1', serverGuid);
            return this.dataService.getProperties(rootFolder, ['defaultKmsClusterExists']);
        };
        TpmProvisioningService.prototype.makeDefaultTpm = function (serverGuid, callback) {
            var rawTpmDevice = {};
            rawTpmDevice._type = "com.vmware.vim.binding.vim.vm.device.VirtualTPM";
            rawTpmDevice.key = -1;
            var device = this.deviceService.setDeviceInfo(new this.VirtualTPM(rawTpmDevice));
            this.checkDefaultKmsServer(serverGuid).then(function (result) {
                if (result && result.defaultKmsClusterExists) {
                    device.state = device.CONNECTED;
                }
                else {
                    device.state = device.NOT_CONNECTED;
                }
                callback(device);
            });
            return {
                device: device
            };
        };
        TpmProvisioningService.$inject = ['deviceService', 'i18nService', 'VirtualTPM', 'dataService', 'defaultUriSchemeUtil'];
        return TpmProvisioningService;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .service('tpmProvisioningService', TpmProvisioningService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var UsbControllerService = (function () {
        function UsbControllerService(deviceService, i18nService) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
        }
        UsbControllerService.prototype.makeDefaultUSBController = function (guestOsDescriptor, deviceOptions, virtualMachineDevices, additionalParameters) {
            if (!_.isEmpty(additionalParameters) && additionalParameters.isCreateMode) {
                return this.makeDefaultUSBControllerForCreate(guestOsDescriptor, deviceOptions, virtualMachineDevices);
            }
            var usb20type = "VirtualUSBController";
            var usb30type = "VirtualUSBXHCIController";
            var usb2option = _.find(deviceOptions, function (item) {
                return item.type.wsdlName === usb20type;
            });
            var usb3option = _.find(deviceOptions, function (item) {
                return item.type.wsdlName === usb30type;
            });
            if (!usb2option && !usb3option) {
                throw this.newErrorDeviceNotSupported();
            }
            var usb2count = virtualMachineDevices.findDevicesOfType(usb20type).length;
            var usb3count = virtualMachineDevices.findDevicesOfType(usb30type).length;
            var device;
            if (usb2count === 0 && usb2option) {
                device = this.deviceService.makeController(deviceOptions, usb2option.type, 0);
            }
            else if (usb3count === 0 && usb3option) {
                device = this.deviceService.makeController(deviceOptions, usb3option.type, 0);
            }
            if (!device) {
                throw this.newErrorDeviceLimitReached();
            }
            return {
                device: device
            };
        };
        UsbControllerService.prototype.newErrorDeviceLimitReached = function () {
            return new Error(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceLimitReached"));
        };
        UsbControllerService.prototype.newErrorDeviceNotSupported = function () {
            return new Error(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceNotSupported"));
        };
        UsbControllerService.prototype.makeDefaultUSBControllerForCreate = function (guestOsDescriptor, deviceOptions, virtualMachineDevices) {
            var device;
            var result = {
                device: device
            };
            if (!guestOsDescriptor.usbRecommended) {
                return result;
            }
            // Check if there is recommended default USB controller type for this guest
            if (_.isNull(guestOsDescriptor.recommendedUSBController) ||
                _.isNull(guestOsDescriptor.recommendedUSBController.wsdlName)) {
                return result;
            }
            var controllerClass = guestOsDescriptor.recommendedUSBController.wsdlName;
            // Check if the recommended USB controller is already added
            if (virtualMachineDevices.findDevicesOfType(controllerClass).length > 0) {
                return result;
            }
            // Check if the recommended USB controller is supported by the guest
            // This check should always pass otherwise the guestOsDescriptor is damaged
            var supported = false;
            if (!_.isEmpty(guestOsDescriptor.supportedUSBControllerList)) {
                supported = _.some(guestOsDescriptor.supportedUSBControllerList, function (supportedController) {
                    return supportedController.wsdlName === controllerClass;
                });
            }
            if (!supported) {
                return result;
            }
            // Check if the recommended USB controller is supported by the host
            var usbOption = _.find(deviceOptions, function (item) {
                return item.type.wsdlName === controllerClass;
            });
            if (!usbOption) {
                return result;
            }
            result.device = this.deviceService.makeController(deviceOptions, usbOption.type, 0);
            return result;
        };
        UsbControllerService.$inject = ["deviceService", "i18nService"];
        return UsbControllerService;
    }());
    angular.module("com.vmware.vsphere.client.vm").service("usbControllerService", UsbControllerService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').factory('virtualDeviceInflator', [
   'VirtualVideoCard',
   'VirtualDisk',
   'VirtualCdrom',
   'VirtualUSBClass',
   'VirtualTPM',
   'VirtualNvdimmWrapper',
   'EditableVirtualDevice',
   'VirtualController',
   'virtualDiskInflator',
   'vmDeviceInfoService',
   'virtualControllerInflator',
   'virtualNetworkDeviceInflator',
   'virtualSCSIControllerInflator',
   'VmHwSerialPort',
   'VirtualPCITs',
   function(
      VirtualVideoCard,
      VirtualDisk,
      VirtualCdrom,
      VirtualUSBClass,
      VirtualTPM,
      VirtualNvdimmWrapper,
      EditableVirtualDevice,
      VirtualController,
      virtualDiskInflator,
      vmDeviceInfoService,
      virtualControllerInflator,
      virtualNetworkDeviceInflator,
      virtualSCSIControllerInflator,
      VmHwSerialPort,
      VirtualPCITs
   ) {
      return {
         inflate: function(rawDevice, additionalInfo) {
            additionalInfo = additionalInfo || {};

            var virtualDevice;
            if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualDisk')) {
               virtualDevice = virtualDiskInflator.build(
                     rawDevice,
                     additionalInfo.storageProfiles,
                     additionalInfo.storageProfileAssignments
               );
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualVideoCard')) {
               virtualDevice = new VirtualVideoCard(rawDevice, additionalInfo.isScheduledTask);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualSerialPort')) {
               virtualDevice = new VmHwSerialPort(rawDevice);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualPCIPassthrough')) {
               virtualDevice = new VirtualPCITs(rawDevice);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualEthernetCard')) {
               virtualDevice = virtualNetworkDeviceInflator.build(rawDevice, additionalInfo.availableNetworks);
            } else if(vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualNVDIMMController')) {
               virtualDevice = new EditableVirtualDevice(rawDevice);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualSCSIController')) {
               virtualDevice = virtualSCSIControllerInflator.build(rawDevice, additionalInfo.deviceOptionsByDeviceType);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualController')) {
               virtualDevice = virtualControllerInflator.build(rawDevice, additionalInfo.deviceOptionsByDeviceType);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualCdrom')) {
               virtualDevice = new VirtualCdrom(rawDevice);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualUSB')) {
               virtualDevice = new VirtualUSBClass(rawDevice, null);
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualTPM')) {
               virtualDevice = new VirtualTPM(rawDevice);
               virtualDevice.state = virtualDevice.CONNECTED;
            } else if (vmDeviceInfoService.isDeviceSubclassOf(rawDevice, 'VirtualNVDIMM')) {
               virtualDevice = new VirtualNvdimmWrapper(rawDevice);
            } else {
               virtualDevice = new EditableVirtualDevice(rawDevice);
            }
            return virtualDevice;
         },

         inflateDevices: function(devices, additionalInfo) {
            var self = this;
            return _.map(devices, function(device) {
               return self.inflate(device, additionalInfo);
            });
         }
      };
   }
]);


angular.module('com.vmware.vsphere.client.vm').factory('EditableVirtualDevice', [
   'deviceDiffService',
   'vmDeviceInfoService',
   'vmHardwareUtil',
   function(
      deviceDiffService,
      vmDeviceInfoService,
      vmHardwareUtil
   ) {
      var ADD_OPERATION = 'add';
      var REMOVE_OPERATION = 'remove';
      var EDIT_OPERATION = 'edit';

      var EditableVirtualDevice = function(rawDevice) {
         var originalDevice = rawDevice;

         /**
          * Returns information if the device is being newly added to the VM or if it has been already added.
          */
         this.isNew = function() {
            return originalDevice.key < 0;
         };

         var currentDeviceSpec = {
            _type: 'com.vmware.vim.binding.vim.vm.device.VirtualDeviceSpec',
            operation: this.isNew() ? ADD_OPERATION : EDIT_OPERATION,
            device: angular.copy(rawDevice),
            fileOperation: undefined
         };

         this.getFinalDeviceSpec = function() {
            var spec = angular.copy(currentDeviceSpec);
            vmHardwareUtil.clearUnchangedConnectInfo(spec, originalDevice);
            return spec;
         };

         this.getCurrentDeviceSpec = function() {
            return currentDeviceSpec;
         };

         this.setCurrentDeviceSpec = function(deviceSpec) {
            currentDeviceSpec = deviceSpec;
         };

         this.getCurrentDevice = function() {
            return currentDeviceSpec.device;
         };

         this.markForRemoval = function() {
            currentDeviceSpec.operation = REMOVE_OPERATION;
         };

         this.revertRemoval = function() {
            currentDeviceSpec.operation = EDIT_OPERATION;
         };

         this.getKey = function() {
            return currentDeviceSpec.device.key;
         };

         this.hasChanged = function() {
            if(currentDeviceSpec.operation === ADD_OPERATION || this.isMarkedForRemoval()) {
               return true;
            }

            return !deviceDiffService.isUnchanged(originalDevice, currentDeviceSpec.device);
         };

         this.isMarkedForRemoval = function(){
            return currentDeviceSpec.operation === REMOVE_OPERATION;
         };

         this.isOfType = function(deviceType) {
            return vmDeviceInfoService.isDeviceSubclassOf(currentDeviceSpec.device, deviceType);
         };
      };

      return EditableVirtualDevice;
   }
]);

var h5_vm;
(function (h5_vm) {
    var VirtualDeviceSpec = com.vmware.vim.binding.vim.vm.device.VirtualDeviceSpec;
    var EditableVirtualDeviceClass = (function () {
        function EditableVirtualDeviceClass(rawDevice, deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
            this.deviceDiffService = deviceDiffService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.ADD_OPERATION = 'add';
            this.REMOVE_OPERATION = 'remove';
            this.EDIT_OPERATION = 'edit';
            this.currentDeviceSpec = new VirtualDeviceSpec();
            this.originalDevice = rawDevice;
            var operation = this.isNew() ? "add" : "edit";
            this.currentDeviceSpec.operation = operation;
            this.currentDeviceSpec.device = angular.copy(rawDevice);
            delete this.currentDeviceSpec.fileOperation;
        }
        EditableVirtualDeviceClass.prototype.isNew = function () {
            return this.originalDevice.key < 0;
        };
        ;
        EditableVirtualDeviceClass.prototype.getFinalDeviceSpec = function () {
            var spec = angular.copy(this.currentDeviceSpec);
            this.vmHardwareUtil.clearUnchangedConnectInfo(spec, this.originalDevice);
            return spec;
        };
        ;
        EditableVirtualDeviceClass.prototype.getCurrentDeviceSpec = function () {
            return this.currentDeviceSpec;
        };
        ;
        EditableVirtualDeviceClass.prototype.setCurrentDeviceSpec = function (deviceSpec) {
            this.currentDeviceSpec = deviceSpec;
        };
        ;
        EditableVirtualDeviceClass.prototype.getCurrentDevice = function () {
            return this.currentDeviceSpec.device;
        };
        ;
        EditableVirtualDeviceClass.prototype.markForRemoval = function () {
            this.currentDeviceSpec.operation = this.REMOVE_OPERATION;
        };
        ;
        EditableVirtualDeviceClass.prototype.revertRemoval = function () {
            this.currentDeviceSpec.operation = this.EDIT_OPERATION;
        };
        ;
        EditableVirtualDeviceClass.prototype.getKey = function () {
            return this.currentDeviceSpec.device.key;
        };
        ;
        EditableVirtualDeviceClass.prototype.hasChanged = function () {
            if (this.currentDeviceSpec.operation === this.ADD_OPERATION || this.isMarkedForRemoval()) {
                return true;
            }
            return !this.deviceDiffService.isUnchanged(this.originalDevice, this.currentDeviceSpec.device);
        };
        ;
        EditableVirtualDeviceClass.prototype.isMarkedForRemoval = function () {
            return this.currentDeviceSpec.operation === this.REMOVE_OPERATION;
        };
        ;
        EditableVirtualDeviceClass.prototype.isOfType = function (deviceType) {
            return this.vmDeviceInfoService.isDeviceSubclassOf(this.currentDeviceSpec.device, deviceType);
        };
        ;
        Object.defineProperty(EditableVirtualDeviceClass.prototype, "_type", {
            get: function () {
                return this.originalDevice._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(EditableVirtualDeviceClass.prototype, "key", {
            get: function () {
                return this.originalDevice.key;
            },
            enumerable: true,
            configurable: true
        });
        EditableVirtualDeviceClass.prototype.setDeviceInfo = function (info) {
            this.originalDevice.deviceInfo = info;
        };
        // functionality not included in JavaScript version of editable device
        EditableVirtualDeviceClass.prototype.deviceLabel = function () {
            var device = this.getCurrentDevice();
            if (!device) {
                return "";
            }
            var deviceInfo = device.deviceInfo;
            if (!deviceInfo) {
                return "";
            }
            var retVal = deviceInfo.label;
            return retVal;
        };
        EditableVirtualDeviceClass.prototype.removeDevice = function () {
            if (this.removeCallback) {
                this.removeCallback(this);
                if (this.isNew()) {
                    this.removeCallback = null;
                }
            }
            else if (this.vm) {
                this.vm.remove(this);
            }
        };
        EditableVirtualDeviceClass.prototype.cleanup = function () {
            this.removeCallback = null;
            this.vm = null;
        };
        EditableVirtualDeviceClass.prototype.attachVmConfig = function (value) {
            if (this.vm || !value) {
                return;
            }
            this.vm = value;
            this.onVmConfigAttached();
            this.setDeviceInfo(this.getCurrentDevice().deviceInfo);
        };
        EditableVirtualDeviceClass.prototype.onVmConfigAttached = function () {
            return; // implement in derived class
        };
        EditableVirtualDeviceClass.prototype.removeDeviceDisabled = function (option) {
            if (!this.vm) {
                return false;
            }
            if (false === this.vm.canRemoveDevice(option)) {
                return true;
            }
            else {
                return false;
            }
        };
        EditableVirtualDeviceClass.prototype.isEditDeviceDisabled = function () {
            if (!this.vm) {
                return true;
            }
            if (this.isNew()) {
                return false;
            }
            return this.vm.isEditDeviceDisabled(true);
        };
        EditableVirtualDeviceClass.prototype.isConnectDeviceDisabled = function () {
            if (this.isNew()) {
                return false;
            }
            if (!this.vm) {
                return true;
            }
            return this.vm.isConnectDeviceDisabled();
        };
        EditableVirtualDeviceClass.prototype.i18n = function (key) {
            if (!this.vm || !this.vm.getI18nService()) {
                return "";
            }
            return this.vm.getI18nService().getString("VmUi", key);
        };
        EditableVirtualDeviceClass.prototype.debugAsExistingDevice = function () {
            var key = this.originalDevice.key;
            if (key < 0) {
                this.getCurrentDevice().key = -key;
                this.originalDevice.key = -key;
            }
        };
        EditableVirtualDeviceClass.prototype.debugAsNewDevice = function () {
            var key = this.originalDevice.key;
            if (key > 0) {
                this.getCurrentDevice().key = -key;
                this.originalDevice.key = -key;
            }
        };
        return EditableVirtualDeviceClass;
    }());
    h5_vm.EditableVirtualDeviceClass = EditableVirtualDeviceClass;
    function GetEditableVirtualDeviceFactory(deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
        var factoryFn = function (rawDevice) {
            var instance = new EditableVirtualDeviceClass(rawDevice, deviceDiffService, vmDeviceInfoService, vmHardwareUtil);
            return instance;
        };
        return factoryFn;
    }
    angular.module('com.vmware.vsphere.client.vm')
        .factory('EditableVirtualDeviceTs', ['deviceDiffService', 'vmDeviceInfoService', 'vmHardwareUtil', GetEditableVirtualDeviceFactory]);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VirtualUSB$USBBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualUSB$USBBackingInfo;
    var VirtualUSB = com.vmware.vim.binding.vim.vm.device.VirtualUSB;
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var UsbDeviceService = (function () {
        function UsbDeviceService(deviceService, i18nService, EditableVirtualDevice, VirtualUSBClass) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
            this.EditableVirtualDevice = EditableVirtualDevice;
            this.VirtualUSBClass = VirtualUSBClass;
        }
        UsbDeviceService.prototype.makeUSBDevice = function (deviceOptions, hostUsbList, inflatedDevices) {
            if (!hostUsbList || hostUsbList.length < 1) {
                throw this.newErrorNoUSBDevices();
            }
            var rawDevice = new VirtualUSB();
            var usbOption = _.find(deviceOptions, function (item) {
                return item.type.name === UsbDeviceService.USB_TYPE;
            });
            if (!usbOption) {
                throw this.newErrorDeviceNotSupported();
            }
            rawDevice.key = this.deviceService.newKey();
            var info = this.getNextAvailableUsb(hostUsbList, inflatedDevices);
            if (this.countUSBDevices(inflatedDevices) >= this.getMaxUSBDevices(deviceOptions)) {
                throw this.newErrorDeviceLimitReached();
            }
            if (!info) {
                throw this.newErrorNoUSBDevices();
            }
            var backing = new VirtualUSB$USBBackingInfo();
            backing.deviceName = info.physicalPath;
            rawDevice.backing = backing;
            var device = new this.VirtualUSBClass(rawDevice, info);
            this.deviceService.setDeviceInfo(device);
            return {
                device: device
            };
        };
        UsbDeviceService.prototype.countUSBDevices = function (inflatedDevices) {
            var usbDeviceCount = 0;
            // marked for removal devices are skipped over, therefore replacement
            // will still be allowed if max is already reached
            inflatedDevices.forEach(function (device) {
                if (device.isOfType(UsbDeviceService.USB_TYPE)) {
                    usbDeviceCount++;
                }
            });
            return usbDeviceCount;
        };
        UsbDeviceService.prototype.getMaxUSBDevices = function (deviceOptions) {
            var virtualUSBController;
            deviceOptions.forEach(function (option) {
                if (option.type && option.type.wsdlName === DeviceTypeConstants.VIRTUAL_USB_CONTROLLER) {
                    virtualUSBController = option;
                }
            });
            return (virtualUSBController && virtualUSBController.devices) ? virtualUSBController.devices.max : 20;
        };
        UsbDeviceService.prototype.getNextAvailableUsb = function (array, inflatedDevices) {
            if (!array || array.length === 0) {
                return null;
            }
            var usbDeviceNames = inflatedDevices
                .filter(function (device) { return device.isOfType(UsbDeviceService.USB_TYPE); })
                .map(function (device) { return device.getCurrentDevice().backing.deviceName; });
            var takenUsbPaths = {};
            for (var _i = 0, usbDeviceNames_1 = usbDeviceNames; _i < usbDeviceNames_1.length; _i++) {
                var deviceName = usbDeviceNames_1[_i];
                takenUsbPaths[deviceName] = true;
            }
            for (var _a = 0, array_1 = array; _a < array_1.length; _a++) {
                var item = array_1[_a];
                if (!takenUsbPaths[item.physicalPath]) {
                    return item;
                }
            }
            return null;
        };
        UsbDeviceService.prototype.newErrorDeviceLimitReached = function () {
            return new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceLimitReached'));
        };
        UsbDeviceService.prototype.newErrorDeviceNotSupported = function () {
            return new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.DeviceNotSupported'));
        };
        UsbDeviceService.prototype.newErrorNoUSBDevices = function () {
            return new Error(this.i18nService.getString('VmUi', 'VmDeviceManager.NoUSBDevices'));
        };
        UsbDeviceService.$inject = ['deviceService', 'i18nService', 'EditableVirtualDevice', 'VirtualUSBClass'];
        UsbDeviceService.USB_TYPE = new VirtualUSB()._type;
        return UsbDeviceService;
    }());
    h5_vm.UsbDeviceService = UsbDeviceService;
    angular.module('com.vmware.vsphere.client.vm').service('usbDeviceService', UsbDeviceService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */

angular.module('com.vmware.vsphere.client.vm').factory('VirtualNvdimmWrapper', [
   'EditableVirtualDevice',
   function(EditableVirtualDevice) {
      var VirtualNvdimmWrapper = function(device) {
         var originalDevice = device;
         EditableVirtualDevice.call(this, device);

         this.setFileOperation = function(fileOperation) {
            this.getCurrentDeviceSpec().fileOperation = fileOperation;
         };

         this.setProfile = function(profile) {
            this.getCurrentDeviceSpec().profile = profile;
         };

         this.getCapacityDiff = function() {
            var currentCapacity = this.getCurrentDevice().capacityInMB;
            if (this.isNew()) {
               return currentCapacity;
            }
            return currentCapacity - originalDevice.capacityInMB;
         };

         this.getCapacityInMB = function() {
            return this.getCurrentDevice().capacityInMB;
         };

         this.getOriginalCapacityInMB = function() {
            if (this.isNew()) {
               return 0;
            }
            return originalDevice.capacityInMB;
         };
      };

      return VirtualNvdimmWrapper;
   }
]);

angular.module('com.vmware.vsphere.client.vm').factory('VirtualTPM', [
   'EditableVirtualDevice',
   function (EditableVirtualDevice) {
      var VirtualTPM = function (device, state) {
         EditableVirtualDevice.call(this, device);
         this.state = state ? state : VirtualTPM.prototype.CONNECTING;
      };

      VirtualTPM.prototype.CONNECTED = 'CONNECTED';
      VirtualTPM.prototype.CONNECTING = 'CONNECTING';
      VirtualTPM.prototype.NOT_CONNECTED = 'NOT_CONNECTED';
      return VirtualTPM;
   }
]);

angular.module('com.vmware.vsphere.client.vm').factory('VirtualCdrom', [
   'EditableVirtualDevice',
   function(EditableVirtualDevice) {
      var VirtualCdrom = function(device) {
         EditableVirtualDevice.call(this, device);
      };

      return VirtualCdrom;
   }
]);

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').factory('VirtualController', [
      'EditableVirtualDevice',
      function(EditableVirtualDevice) {
         return function(device, attributes){
            EditableVirtualDevice.call(this, device);

            this.getMaxDisks = function() {
               return attributes.maxDisks;
            };

            this.getDiskNodeIndices = function(){
               return _.range(0, this.getMaxDisks());
            };

            this.getMaxCdroms = function() {
               return attributes.maxCdroms;
            };

            this.getCdromNodeIndices = function(){
               return _.range(0, this.getMaxCdroms());
            };
         };
      }
   ]);
})();

angular.module('com.vmware.vsphere.client.vm').factory('VirtualDisk', [
   'EditableVirtualDevice',
   'deviceDiffService',
   'storageProfileService',
   'diskBackingInfoConstants',
   'pmemUtilService',
   'i18nService',
   'vmCryptUtilService',
   function(EditableVirtualDevice, deviceDiffService, storageProfileService,
         diskBackingInfoConstants, pmemUtilService, i18nService, vmCryptUtilService) {
      var UNLIMITED_DISK = i18nService.getString('VmUi', 'DiskConfig.Unlimited');
      var CREATE_FILE_OPERATION = 'create';
      var DESTROY_FILE_OPERATION = "destroy";
      var original_capacityInBytes;
      var original_capacityInKB;


      var VirtualDisk = function(device, storageProfile, replicationGroupInfo) {
         EditableVirtualDevice.call(this, device);

         var originalReplicationGroupInfo;
         var currentReplicationGroupInfo;

         if (replicationGroupInfo) {
            originalReplicationGroupInfo = replicationGroupInfo;
            currentReplicationGroupInfo = replicationGroupInfo;
         }

         original_capacityInBytes = device.capacityInBytes;
         original_capacityInKB = device.capacityInKB;
         var originalBacking = device.backing;
         var originalCapacityInMB = device.capacityInKB / 1024;
         var isStorageProfileManuallySet = false;
         this.storageProfile = storageProfile;


         if (this.isNew() && !this.getCurrentDevice().createdFromExistingDisk) {
            this.getCurrentDeviceSpec().fileOperation = CREATE_FILE_OPERATION;
         }

         var superHasChanged = this.hasChanged;

         this.setDiskFileOperation = function(fileOperation) {
            this.getCurrentDeviceSpec().fileOperation = fileOperation;
         };

         this.getDiskFileOperation = function() {
            return this.getCurrentDeviceSpec().fileOperation;
         };

         this.isCreatedFromExistingDisk = function() {
            return this.getCurrentDevice().createdFromExistingDisk;
         };

         this.isRDMDisk = function() {
            return this.getCurrentDevice().backing._type === diskBackingInfoConstants.RAWDISKMAPPING;
         };

         this.setProfile = function(updatedProfile) {
            this.getCurrentDeviceSpec().profile = updatedProfile
                  ? [updatedProfile]
                  : undefined;
         };

         this.setOriginalProfile = function (storageProfile, replicationGroupInfo) {

            if (!originalProfile) {
               originalProfile = storageProfile;
               this.setProfile(storageProfile);
            }

            if (!originalReplicationGroupInfo && !!replicationGroupInfo) {
               originalReplicationGroupInfo = replicationGroupInfo;
               currentReplicationGroupInfo = replicationGroupInfo;
               // call "setProfile" again to propagate replicaionSpec
               this.setProfile(storageProfile);
            }

         };

         if (storageProfile) {
            var originalProfile;
            this.setOriginalProfile(storageProfile, replicationGroupInfo);
         }

         this.restoreOriginalBacking = function() {
            this.getCurrentDevice().backing = originalBacking;
         };

         this.getProfile = function() {
            return this.getCurrentDeviceSpec().profile && this.getCurrentDeviceSpec().profile[0];
         };

         this.updateCapacity = function(capacityValueInMB) {
            this.getCurrentDevice().capacityInKB = capacityValueInMB * 1024;
            this.getCurrentDevice().capacityInBytes = this.getCurrentDevice().capacityInKB * 1024;

            if (this.getCurrentDevice().capacityInKB === original_capacityInKB) {
               this.getCurrentDevice().capacityInBytes = original_capacityInBytes                                                                                                                  ;
            }
         };

         this.updateDiskMode = function(diskMode) {
            this.getCurrentDevice().backing.diskMode = diskMode;
         };

         this.updateFileName = function(fileName) {
            this.getCurrentDevice().backing.fileName = fileName;
         };

         this.updateDiskProvisioningOption = function(backingType) {
            this.getCurrentDevice().backing = angular.extend(
                  this.getCurrentDevice().backing,
                  backingType);
         };

         this.updateDiskProfile = function(storageProfile, replicationGroupInfo) {
            this.storageProfile = storageProfile;
            var profile;
            if (storageProfile && (storageProfile.id || storageProfile.profileId)) {
               profile = storageProfileService.makeProfile(
                     storageProfile.id || storageProfile.profileId,
                     replicationGroupInfo);
               profile.label = storageProfile.label;
            }
            currentReplicationGroupInfo = replicationGroupInfo;
            this.setProfile(profile);
         };

         this.getCurrentReplicationGroup = function() {
            return currentReplicationGroupInfo;
         };

         this.updateStorageIOAllocation = function(ioLimit) {
            this.getCurrentDevice().storageIOAllocation.limit = (ioLimit === UNLIMITED_DISK ? -1 : ioLimit);
         };

         this.updateSharing = function(sharingRule) {
            this.getCurrentDevice().backing.sharing = sharingRule || null;
         };

         this.updateShares = function(value) {
            const io = this.getCurrentDevice().storageIOAllocation;
            const info = io.shares;
            info.level = value.level;
            info.shares = value.shares;
         };

         this.updateCompatibilityMode = function(compatibilityMode) {
            this.getCurrentDevice().backing.compatibilityMode = compatibilityMode;
         };

         this.updateFlashCacheReservation = function(reservationInMB) {
            this.getCurrentDevice().vFlashCacheConfigInfo = this.getCurrentDevice().vFlashCacheConfigInfo || { _type:"com.vmware.vim.binding.vim.vm.device.VirtualDisk$VFlashCacheConfigInfo"};
            this.getCurrentDevice().vFlashCacheConfigInfo.reservationInMB = reservationInMB;
         };

         this.updateControllerAndNodeKeys = function(controllerKey, controllerNodeKey) {
            this.getCurrentDevice().controllerKey = controllerKey;
            this.getCurrentDevice().unitNumber = controllerNodeKey ? controllerNodeKey : this.getCurrentDevice().unitNumber;
         };

         this.updateDatastoreMor = function(datastoreRef) {
            this.getCurrentDevice().backing.datastore = datastoreRef;
            if (!datastoreRef) {
               //this.getCurrentDevice().backing.fileName;
            }
         };

         this.updateParentStoragePodMor = function(parentStoragePodRef) {
            this.getCurrentDevice().backing.parentStoragePod = parentStoragePodRef;
         };

         this.hasChanged = function() {
            var hasDeviceChanged = superHasChanged.apply(this);
            if (originalProfile && this.getCurrentDeviceSpec().profile) {
               var hasProfileChanged = !_.isEqual(originalProfile.profileId, this.getCurrentDeviceSpec().profile[0].profileId);
               hasDeviceChanged = hasDeviceChanged || hasProfileChanged;
            }

            if (originalReplicationGroupInfo && currentReplicationGroupInfo) {
               var hasReplicationGroupChanged = !_.isEqual(
                     originalReplicationGroupInfo.id, currentReplicationGroupInfo.id);
               hasDeviceChanged = hasDeviceChanged || hasReplicationGroupChanged;
            }

            return hasDeviceChanged;
         };

         this.deviceName = function() {
            return this.getCurrentDevice().deviceInfo.label;
         };

         this.isPmemDisk = function() {
           return pmemUtilService.isPmemDisk(this.getCurrentDevice());
         };

         this.isDiskAlreadyEncrypted = function() {
            return vmCryptUtilService.isExistingDiskEncrytped(this.getCurrentDevice());
         };

         this.isEncryptionProfileApplied = function() {
            return storageProfileService.isEncryptionStorageProfile(this.storageProfile);
         };

         this.isDiskEncrypted = function() {
            return this.isDiskAlreadyEncrypted() || this.isEncryptionProfileApplied();
         };

         this.getOriginalCapacityInMB = function() {
            if (this.isNew()) {
               return 0;
            }
            return originalCapacityInMB;
         };

         this.getCapacityDiff = function() {
            var currentCapacity = this.getCurrentDevice().capacityInKB / 1024;
            if (this.isNew()) {
               return currentCapacity;
            }
            return currentCapacity - originalCapacityInMB;
         };

         this.isStorageProfileManuallySet = function() {
            return isStorageProfileManuallySet;
         };

         this.setStorageProfileManuallySet = function(value) {
            isStorageProfileManuallySet = value;
         };

      };


      VirtualDisk.UNLIMITED_DISK = UNLIMITED_DISK;

      return VirtualDisk;
   }
]);

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').factory('VirtualNetworkDevice', [
      'EditableVirtualDevice',
      'vmDeviceInfoService',
      'defaultUriSchemeUtil',
      function(EditableVirtualDevice, vmDeviceInfoService, defaultUriSchemeUtil) {
         function VirtualNetworkDevice(device, theNetwork) {
            device.backing = vmDeviceInfoService.buildNetworkDeviceBacking(theNetwork);
            EditableVirtualDevice.call(this, device);

            this.network = theNetwork;
         }

         VirtualNetworkDevice.prototype.getNetworkId = function() {
            if (!this.network) {
               return; //undefined
            }
            var networkRef = this.network.portgroup;
            if (!networkRef) {
               networkRef = this.network.network.network;
            }
            return defaultUriSchemeUtil.getVsphereObjectId(networkRef);
         };

         VirtualNetworkDevice.prototype.getNetworkName = function() {
            return this.network ? this.network.displayName : undefined;
         };

         VirtualNetworkDevice.prototype.getNetwork = function() {
            return this.network;
         };

         VirtualNetworkDevice.prototype.setNetwork = function(newNetwork) {
            if(newNetwork) {
               this.network = newNetwork;
               this.getCurrentDevice().backing = vmDeviceInfoService.buildNetworkDeviceBacking(newNetwork);
            }
         };

         return VirtualNetworkDevice;
      }
   ]);
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').factory('VirtualSCSIController', [
      'EditableVirtualDevice',
      function(EditableVirtualDevice) {
         return function(device, attributes){

            EditableVirtualDevice.call(this, device);

            this.getMaxDisks = function () {
               return attributes.maxDisks;
            };

            this.getReservedNode = function(){
              return attributes.reservedNode;
            };

            this.getDiskNodeIndices = function () {
               return _.range(0, attributes.reservedNode).concat(
                  _.range(attributes.reservedNode + 1, this.getMaxDisks() + 1)
               );
            };

            this.getMaxCdroms = function() {
               return attributes.maxCdroms;
            };

            this.getCdromNodeIndices = function(){
               return _.range(0, attributes.reservedNode).concat(
                  _.range(attributes.reservedNode + 1, this.getMaxCdroms() + 1)
               );
            };
         };
      }
   ]);
})();

var h5_vm;
(function (h5_vm) {
    var VirtualUSB$RemoteClientBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualUSB$RemoteClientBackingInfo;
    var VirtualUSB$RemoteHostBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualUSB$RemoteHostBackingInfo;
    var VirtualUSB$USBBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualUSB$USBBackingInfo;
    var VirtualUSBClass = (function () {
        function VirtualUSBClass(virtualUSB, info, i18nService) {
            this.i18nService = i18nService;
            this.clientType = new VirtualUSB$RemoteClientBackingInfo()._type;
            this.remoteType = new VirtualUSB$RemoteHostBackingInfo()._type;
            this.localType = new VirtualUSB$USBBackingInfo()._type;
            this._vMotion = false;
            this.usbInfo = info;
            if (info) {
                info.taken = true;
            }
            this.rawDevice = virtualUSB;
            this.i18n = function (key) {
                var rest = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    rest[_i - 1] = arguments[_i];
                }
                return i18nService.getString('VmUi', 'USBDevicePage.' + key, rest);
            };
        }
        VirtualUSBClass.prototype.onInit = function (vmConfigContext) {
            this.ctx = vmConfigContext;
            this.rawDevice = this.getCurrentDevice();
            if (this.usbInfo === null) {
                this.usbInfo = h5_vm.VmHardwareUsbDeviceUtil.getTargetUsbInfo(this.rawDevice, vmConfigContext);
            }
        };
        VirtualUSBClass.prototype.isNew = function () {
            return this.rawDevice.key < 0;
        };
        VirtualUSBClass.prototype.isRemovalEnabled = function () {
            if (this.isNew()) {
                return true;
            }
            if (this.isClientTypeUSB()) {
                return h5_vm.VmHardwareUtil.userHasAddRemoveDevicePermission(this.ctx);
            }
            return h5_vm.VmHardwareUtil.userHasHostUsbPermission(this.ctx);
        };
        VirtualUSBClass.prototype.getDeviceLabel = function () {
            if (!this.rawDevice || !this.rawDevice.deviceInfo) {
                return "";
            }
            else {
                return this.rawDevice.deviceInfo.label;
            }
        };
        VirtualUSBClass.prototype.getUsbDeviceLabel = function (vmConfigContext) {
            var name = h5_vm.VmHardwareUsbDeviceUtil.getUsbTargetDescription(this.rawDevice, vmConfigContext);
            var typeKey = (this.rawDevice.backing._type === this.clientType) ? 'USBDeviceConfig.ClientDevice' : 'USBDeviceConfig.HostDevice';
            var retVal = this.i18nService.getString('VmUi', typeKey, name);
            return retVal;
        };
        Object.defineProperty(VirtualUSBClass.prototype, "hostUsb", {
            get: function () {
                return this.usbInfo;
            },
            set: function (value) {
                if (!value) {
                    return;
                }
                var backing = this.rawDevice.backing;
                backing.deviceName = value.physicalPath;
                this.usbInfo = value;
            },
            enumerable: true,
            configurable: true
        });
        VirtualUSBClass.prototype.getUSBUniqueID = function () {
            return h5_vm.VmHardwareUsbDeviceUtil.getUSBUniqueID(this.rawDevice);
        };
        VirtualUSBClass.prototype.getUSBConnectionStatusText = function () {
            if (!this.rawDevice) {
                return "";
            }
            if (this.rawDevice.connected) {
                return this.i18n("Connected");
            }
            else {
                return this.i18n("Disconnected");
            }
        };
        VirtualUSBClass.prototype.isClientTypeUSB = function () {
            if (!this.rawDevice || !this.rawDevice.backing) {
                return false;
            }
            return this.rawDevice.backing._type === this.clientType;
        };
        VirtualUSBClass.prototype.getVMotionSupportText = function () {
            if (!this.rawDevice) {
                return "";
            }
            if (this.rawDevice.backing._type === this.clientType) {
                return this.i18n("VMotionCapable");
            }
            if (this.rawDevice.backing._type === this.remoteType) {
                return this.i18n("VMotionCapable");
            }
            return this.i18n("VMotionNotCapable");
        };
        VirtualUSBClass.prototype.isDevicePresent = function () {
            if (!this.usbInfo) {
                return false;
            }
            else {
                return true;
            }
        };
        VirtualUSBClass.prototype.getDeviceAvailableText = function () {
            if (!this.usbInfo) {
                return "";
            }
            var summary = this.usbInfo.summary;
            if (!summary) {
                return this.i18n("USBConnectionAvailable");
            }
            if (summary && summary.config) {
                var vmname = summary.config.name;
                var retVal = this.i18nService.getString('VmUi', 'USBDeviceConfig.Connected', vmname);
                return retVal;
            }
            return "";
        };
        VirtualUSBClass.prototype.isDeviceAvailable = function () {
            return this.usbInfo && !this.usbInfo.summary;
        };
        Object.defineProperty(VirtualUSBClass.prototype, "vMotion", {
            get: function () {
                return this._vMotion;
            },
            set: function (value) {
                this._vMotion = value;
                if (value) {
                    this.rawDevice.backing._type = this.remoteType;
                    var backing = this.rawDevice.backing;
                    backing.hostname = "";
                }
                else {
                    this.rawDevice.backing._type = this.localType;
                }
            },
            enumerable: true,
            configurable: true
        });
        return VirtualUSBClass;
    }());
    h5_vm.VirtualUSBClass = VirtualUSBClass;
    function GetVirtualUSBClass(EditableVirtualDevice, i18nService) {
        var factoryFn = function (rawDevice, info) {
            var instance = new VirtualUSBClass(rawDevice, info, i18nService);
            EditableVirtualDevice.call(instance, rawDevice);
            return instance;
        };
        return factoryFn;
    }
    angular.module('com.vmware.vsphere.client.vm')
        .factory('VirtualUSBClass', ['EditableVirtualDevice', 'i18nService', GetVirtualUSBClass]);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').factory('VmController', [
   'i18nService', 'deviceClassLineageService', function(i18nService, deviceClassLineageService) {
      var CONTROLLER_CREATION_ERROR_MESSAGE = 'Cannot create controller!';
      var ControllerParser = function(deviceOptions, controllerType) {
         this.parse = function() {
            var parsedControllerComponents = {};
            var controllerOption = this.controllerOption(deviceOptions, controllerType);
            if(controllerOption.scsiCtlrUnitNumber){
                parsedControllerComponents.scsiCtlrUnitNumber = controllerOption.scsiCtlrUnitNumber;
            }
            parsedControllerComponents.controllerOptionType = controllerOption.type.typeClass;
            parsedControllerComponents.sharedBus = getSharedBus(parsedControllerComponents.controllerOptionType, controllerOption);
            return parsedControllerComponents;
         };

         this.controllerOption = function () {
            function classFinder(deviceOption) {
               return deviceOption.type.typeClass === controllerType;
            }

            function subclassFinder(deviceOption) {
               return deviceClassLineageService.isClassNameSubclassOf(deviceOption.type.typeClass, controllerType);
            }

            var controllerOption = _.find(deviceOptions, classFinder) || _.find(deviceOptions, subclassFinder);
            if (!controllerOption) {
               throw new Error(CONTROLLER_CREATION_ERROR_MESSAGE);
            }
            return controllerOption;
         };

         function getSharedBus(controllerType, controllerOption) {
            if (deviceClassLineageService.isClassNameSubclassOf(controllerType, 'VirtualSCSIController')) {
               return controllerOption.sharing[controllerOption.defaultSharedIndex];
            }
         }
      };

      var VmController = function(controller, deviceOptions) {
         var parser = new ControllerParser(deviceOptions, controller._type);

         this.toJson = function() {
            return controller;
         };

         this.sharingOptions = function () {
            return parser.controllerOption().sharing;
         };
      };

      VmController.createForType = function (deviceOptions, typeRecommendation, key, busNumber) {
         if (controllerCannotBeCreated(typeRecommendation.typeClass)) {
            throw new Error(CONTROLLER_CREATION_ERROR_MESSAGE);
         }

         var parser = new ControllerParser(deviceOptions, typeRecommendation.typeClass);
         var parsedControllerComponents = parser.parse();

         var device = {
            _type: parsedControllerComponents.controllerOptionType,
            key: key,
            busNumber: busNumber || 0,
            sharedBus: parsedControllerComponents.sharedBus
         };
         if(parsedControllerComponents.scsiCtlrUnitNumber){
             device.scsiCtlrUnitNumber = parsedControllerComponents.scsiCtlrUnitNumber;
         }
         return new VmController(device, deviceOptions);
      };

      function controllerCannotBeCreated(controllerType) {
         var nonCreatableControllerType = 'com.vmware.vim.binding.vim.vm.device.VirtualIDEController';
         return !controllerType || controllerType === nonCreatableControllerType;
      }

      return VmController;
   }]);

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('virtualDiskSettingsFormService', [
      'i18nService',
      'diskBackingInfoConstants',
      'datastoreService',
      'vmDeviceInfoService',
      'defaultUriSchemeUtil',
      'storageProfileService',
      'diskProvisioningService',
      'diskFormatService',
      'pmemUtilService',
      function(
            i18nService,
            diskBackingInfoConstants,
            datastoreService,
            vmDeviceInfoService,
            defaultUriSchemeUtil,
            storageProfileService,
            diskProvisioningService,
            diskFormatService,
            pmemUtilService
      ) {
         return {
            build: buildVirtualDiskSettingsForm,
            buildCapacity: buildCapacity,
            buildControllersDropdown: buildControllersDropdown,
            buildDiskProvisioningTypes: buildDiskProvisioningTypes,
            getCapacityInMB: getCapacityInMB
         };

         function buildVirtualDiskSettingsForm(
               vmStorageProfileAssignments,
               inVmCreateOrCloneMode,
               vmConfigContext,
               inflatedDevice,
               vmStorageId,
               selectedStorageProfile,
               storageProfiles,
               virtualMachineDevices
         ) {
            var deviceSpec = inflatedDevice.getCurrentDeviceSpec();
            var device = deviceSpec.device;
            var datastoreInfo = buildDatastoreInfo(vmConfigContext,
                  device.backing.datastore, vmStorageId, inflatedDevice.isNew());
            var capacity = buildCapacity(inflatedDevice, inVmCreateOrCloneMode, datastoreInfo);
            var diskProvisioningName = determineDiskProvisioningName(datastoreInfo, device);
            var sharing = buildSharing(device);
            var shares = buildShares(device.storageIOAllocation.shares);
            var ioLimit = determineIOLimit(device.storageIOAllocation);
            var allInflatedDevices = virtualMachineDevices.getAllDevicesNotMarkedForRemoval();
            var isFlashCacheCompatible = vmConfigContext.environment.hostCapability.vFlashSupported;
            var flashCacheReservation = buildFlashCacheReservation(device.vFlashCacheConfigInfo);
            var diskMode = buildDiskMode(vmConfigContext, inflatedDevice, allInflatedDevices);

            var availableInflatedControllers = vmDeviceInfoService.availableControllersForDevice(inflatedDevice, allInflatedDevices);

            var controllersDropdown = buildControllersDropdown(inflatedDevice, allInflatedDevices);
            var inflatedController = _.find(availableInflatedControllers, function(inflatedController) {
               return inflatedController.getKey() === device.controllerKey;
            });

            if (!inflatedController) {
               throw new Error('Could not find controller with key ' + device.controllerKey + ' for device ' + inflatedDevice.getKey());
            }
            var defaultUnit = flashCacheReservation.valueInMB < 1024 ? flashCacheReservation.validUnits.MB.label : flashCacheReservation.validUnits.GB.label;

            var virtualDiskSettingsForm = {
               capacity: {
                  valueInMB: capacity.valueInMB,
                  validUnits: capacity.validUnits,
                  minInMB: capacity.minInMB,
                  maxInMB: capacity.maxInMB,
                  maxExceededErrorMessage: capacity.maxExceededErrorMessage,
                  memoryUnitPreferred: capacity.memoryUnitPreferred,
                  isMaxAvailable: capacity.isMaxAvailable
               },
               diskProvisioningName: diskProvisioningName,
               sharing: {
                  options: sharing.options,
                  selection: sharing.selection
               },
               diskFile: device.backing.fileName,
               shares: shares,
               ioLimit: ioLimit,
               isFlashCacheCompatible: isFlashCacheCompatible,
               flashCacheReservation: {
                  valueInMB: flashCacheReservation.valueInMB,
                  validUnits: flashCacheReservation.validUnits,
                  customValidators: [{
                     name: "valid-range",
                     validate: function(value) {
                        return value === 0 || (value >= 4 && value <= 10240);
                     },
                     message: i18nService.getString("VmUi", "vFlashCache.ValidRange", "Reservation", "4MB", "10GB")
                     + " " + i18nService.getString("VmUi", "vFlashCache.ZeroToDisableCahe")
                  }],
                  errorMessages: {},
                  defaultUnit: defaultUnit
               },
               diskMode: {
                  options: diskMode.options,
                  selection: diskMode.selection
               },
               controllers: {
                  options: controllersDropdown.options,
                  selection: controllersDropdown.selection
               },
               selectedControllerNode: null
            };

            if (inVmCreateOrCloneMode || inflatedDevice.isNew()) {
               virtualDiskSettingsForm.diskProvisioningOptions = buildDiskProvisioningTypes(datastoreInfo?datastoreInfo.datastore.type:"",datastoreInfo?datastoreInfo.vStorageSupport:"");


               if (diskProvisioningService.hasFormat(device.backing)) {
                  virtualDiskSettingsForm.selectedDiskProvisioningOption = diskProvisioningService.getFormat(device.backing);
               } else {
                  virtualDiskSettingsForm.selectedDiskProvisioningOption = virtualDiskSettingsForm.diskProvisioningOptions[0];
               }
            }

            var storageProfile;
            storageProfiles = pmemUtilService.filterOutPmemProfileIfNeeded(
                  storageProfiles, vmConfigContext, inflatedDevice);
            if (inVmCreateOrCloneMode) {
               storageProfile = storageProfileService.buildStorageProfileInCreateMode(selectedStorageProfile, storageProfiles);
            } else if (vmStorageProfileAssignments) {
               // 'vmStorageProfileAssignments' is set to null when the user doesn't have the required privileges.
               storageProfile = storageProfileService.buildStorageProfile(vmStorageProfileAssignments, device, storageProfiles, inflatedDevice.isNew());
            }

            if (storageProfile) {
               virtualDiskSettingsForm.storageProfile = {
                  options: storageProfile.options,
                  selection: storageProfile.selection
               };

               if (deviceSpec && deviceSpec.profile) {
                  virtualDiskSettingsForm.storageProfile.selection = storageProfileService.findProfile(
                        virtualDiskSettingsForm.storageProfile.options,
                        deviceSpec.profile[0]
                  );
               }
            }

            return virtualDiskSettingsForm;
         }

         function buildControllersDropdown(inflatedDevice, allInflatedDevices) {
            var availableInflatedControllers = vmDeviceInfoService.availableControllersForDevice(inflatedDevice, allInflatedDevices);

            var selection = _.find(availableInflatedControllers, function(availableInflatedController) {
               return availableInflatedController.getKey() === inflatedDevice.getCurrentDeviceSpec().device.controllerKey;
            });

            return {
               options: availableInflatedControllers,
               selection: selection
            };
         }

         function buildDiskMode(vmConfigContext, inflatedDevice, allInflatedDevices) {

            var optionsForDiskBacking = vmDeviceInfoService.backingOptionForDevice(vmConfigContext, inflatedDevice, allInflatedDevices);

            if (!optionsForDiskBacking && inflatedDevice.getCurrentDevice().backing
               ._type === diskBackingInfoConstants.LOCALPMEM) {
               return {
                  options: []
               };
            }

            var options = _.map(optionsForDiskBacking.diskMode.choiceInfo, function(modeOption) {
               return {
                  name: i18nService.getString('VmUi', 'DiskConfig.' + modeOption.key),
                  value: modeOption.key
               };
            });

            var selection = _.find(options, function(option) {
               return option.value === inflatedDevice.getCurrentDevice().backing.diskMode;
            });

            return {
               options: options,
               selection: selection
            };
         }

         function buildFlashCacheReservation(deviceFlashCacheConfigInfo) {
            return {
               valueInMB: deviceFlashCacheConfigInfo ? deviceFlashCacheConfigInfo.reservationInMB : 0,
               validUnits: {
                  MB: { label: i18nService.getString('VmUi', "Vm.Units.MB"), multiplier: 1 },
                  GB: { label: i18nService.getString('VmUi', "Vm.Units.GB"), multiplier: Math.pow(2, 10) }
               }
            };
         }

         function determineIOLimit(deviceStorageIOAllocation) {
            var limit = deviceStorageIOAllocation.limit;
            return limit === -1 ? i18nService.getString('VmUi', 'DiskConfig.Unlimited') : limit;
         }

         function buildShares(deviceShares) {
            return {
               min: 200,
               max: 4000,
               presetOptions: {
                  low: 500,
                  normal: 1000,
                  high: 2000
               },
               value: deviceShares
            };

         }

         function buildSharing(device) {
            var options = [
               {
                  name: i18nService.getString('VmUi', "DiskPage.sharingNull"),
                  value: undefined
               }, {
                  name: i18nService.getString('VmUi', "DiskPage.sharingNone"),
                  value: 'sharingNone'
               }, {
                  name: i18nService.getString('VmUi', "DiskPage.sharingMultiWriter"),
                  value: 'sharingMultiWriter'
               }
            ];

            var defaultSharingOption = options[0];
            var selection = _.find(options, function(option) {
                     return option.value === device.backing.sharing;
                  }) || defaultSharingOption;

            return {
               options: options,
               selection: selection
            };
         }

         function determineDiskProvisioningName(datastoreInfo, device) {

            if (datastoreInfo && datastoreInfo.datastore.type === 'vsan') {
               return i18nService.getString('VmUi', 'DiskPage.ProfileProvisioned');
            }

            return diskProvisioningService.getName(device.backing);
         }

         function buildDatastoreInfo(vmConfigContext, backingDatastore, vmStorageId, isNew) {
            var datastoreId = backingDatastore ?
                  defaultUriSchemeUtil.getVsphereObjectId(backingDatastore) : null;

            // if the disk is not new always use the datastore data from it's backing
            // if it is not and it is not set use the provided vmStorageId
            // (the selected storage from basic mode in the storage page)

            if (isNew) {
               datastoreId = datastoreId || vmStorageId;
            }

            return datastoreService.findDatastore(
                  datastoreId,
                  vmConfigContext.environment.configTarget
            );
         }

         function buildCapacity(inflatedDevice, inVmCreateOrCloneMode, datastoreInfo) {
            var device = inflatedDevice.getCurrentDevice();

            var maxDiskSizeInBytes;
            var maxInMB;
            var maxExceededErrorMessage;
            var freeSpaceInMB;
            var maxDiskSizeInMB;

            if (!datastoreInfo /* When disk is on an SDRS cluster*/) {
               //Max size of Java Long
               maxDiskSizeInBytes = Math.pow(2, 63);
               maxInMB = maxDiskSizeInBytes / Math.pow(2, 20);
               maxExceededErrorMessage =
                     i18nService.getString('VmUi', 'DiskConfig.ErrorMaxFileSize');
            }

            if (datastoreInfo) {
               var unitFactor = 1024;
               maxDiskSizeInBytes = datastoreInfo.maxVirtualDiskCapacity;

               if (maxDiskSizeInBytes === null || isNaN(maxDiskSizeInBytes) || maxDiskSizeInBytes <= 0) {

                  maxDiskSizeInBytes = datastoreInfo.maxFileSize;

                  var smallestValidMaxFileSize = 256 * unitFactor * unitFactor * unitFactor;
                  if (maxDiskSizeInBytes >= smallestValidMaxFileSize) {
                     maxDiskSizeInMB = maxDiskSizeInBytes / unitFactor / unitFactor;
                  }
               } else {
                  maxDiskSizeInMB = maxDiskSizeInBytes / unitFactor / unitFactor;
               }

               freeSpaceInMB = datastoreInfo.datastore.freeSpace / unitFactor / unitFactor;
               if (!inVmCreateOrCloneMode && !inflatedDevice.isNew()) {
                  freeSpaceInMB += device.capacityInKB / unitFactor;
               }

               if (maxDiskSizeInMB && maxDiskSizeInMB < freeSpaceInMB) {
                  maxInMB = maxDiskSizeInMB;
                  maxExceededErrorMessage = i18nService.getString('VmUi', "DiskConfig.ErrorMaxFileSize");
               } else {
                  maxInMB = freeSpaceInMB;
                  maxExceededErrorMessage = i18nService.getString('VmUi', "DiskConfig.ErrorFreeSpace");
               }
            }

            var valueInMB = getCapacityInMB(device);
            var validUnits = {
               MB: { label: i18nService.getString('VmUi', "Vm.Units.MB"), multiplier: 1 },
               GB: { label: i18nService.getString('VmUi', "Vm.Units.GB"), multiplier: Math.pow(2, 10) },
               TB: { label: i18nService.getString('VmUi', "Vm.Units.TB"), multiplier: Math.pow(2, 20) }
            };
            var memoryUnitPreferred = valueInMB < 1024 ? validUnits.MB : validUnits.GB;

            var deviceSpec = inflatedDevice.getCurrentDeviceSpec();
            if (deviceSpec
                  && deviceSpec.memoryUnitPreferred
                  && deviceSpec.memoryUnitPreferred.label) {
               memoryUnitPreferred = deviceSpec.memoryUnitPreferred;
            }

            //if this is a Raw device, disk and datastore sizes don't matter
            //so set the max to deviceSize, so that the edit control doesn't complain
            if (device.backing._type === diskBackingInfoConstants.RAWDISKMAPPING) {
               maxInMB = valueInMB;
            }

            return {
               valueInMB: valueInMB,
               validUnits: _.values(validUnits),
               minInMB: inflatedDevice.isNew() ? null : device.capacityInBytes / Math.pow(2, 20),
               maxInMB: maxInMB,
               maxExceededErrorMessage: maxExceededErrorMessage,
               memoryUnitPreferred: memoryUnitPreferred,
               isMaxAvailable: isMaxAvailable(maxInMB)
            };
         }

         function getCapacityInMB(device) {
            if (device.capacityInBytes) {
               return (device.capacityInBytes / Math.pow(1024, 2));
            } else {
               return (device.capacityInKB / Math.pow(1024, 1));
            }
         }

         function isMaxAvailable(maxInMB) {
            return maxInMB < (Math.pow(2, 63) / Math.pow(2, 20));
         }

         function buildDiskProvisioningTypes(dsType, vStorage) {
           var vStorageSupport;
           vStorageSupport =(vStorage ==='vStorageSupported');
           if(_.isEmpty(dsType, true)){
                return diskFormatService.getAvailableDiskFormats( "VMFS", vStorageSupport, false, true);
           }
           return diskFormatService.getAvailableDiskFormats( dsType, vStorageSupport, false, true);

          }
      }
   ]);
})();

angular.module('com.vmware.vsphere.client.vm').factory('VirtualMachineDevices', [
   'vmDeviceInfoService',
   'virtualDeviceInflator',
   function (vmDeviceInfoService, virtualDeviceInflator) {
      var VirtualMachineDevices = function VirtualMachineDevices(
         rawDevices,
         profileAssignments,
         profiles,
         availableNetworks,
         deviceOptionsByDeviceType,
         isScheduledTask
      ) {
         var self = this;
         var additionalInfo = {
            storageProfiles: profiles,
            storageProfileAssignments: profileAssignments,
            availableNetworks: availableNetworks,
            deviceOptionsByDeviceType: deviceOptionsByDeviceType,
            isScheduledTask: isScheduledTask
         };
         var deviceList = virtualDeviceInflator.inflateDevices(rawDevices, additionalInfo);
         var inflatedDevices = _.reduce(deviceList, function(memo, virtualDevice) {
            memo[virtualDevice.getKey()] = virtualDevice;
            return memo;
         }, {});

         var rgValidationCallbacks = {};

         this.addRgValidationCallback = function(deviceKey, callback) {
            rgValidationCallbacks[deviceKey] = callback;
         };

         this.notifyRgValidationCallbacks = function() {
            var deviceKeys = Object.keys(rgValidationCallbacks);
            deviceKeys.forEach(function(deviceKey){
               if (rgValidationCallbacks[deviceKey]) {
                  rgValidationCallbacks[deviceKey]();
               }
            });
         };

         this.getDeviceChanges = function() {
            var array = _.chain(this.getInflatedDevices())
               .filter(function(inflatedDevice) {
                  return inflatedDevice.hasChanged();
               })
               .map(function(changedDevice) {
                  return changedDevice.getCurrentDeviceSpec();
               })
               .value();
            return array;
         };

         this.getFinalChanges = function() {
            var array = _.chain(this.getInflatedDevices())
               .filter(function(inflatedDevice) {
                  return inflatedDevice.hasChanged();
               })
               .map(function(changedDevice) {
                  return changedDevice.getFinalDeviceSpec();
               })
               .value();
            return array;
         };

         this.findDeviceSpec = function(deviceKey) {
            var virtualDevice = _.find(inflatedDevices, function(device) {
               return device.getKey() === deviceKey;
            });

            return virtualDevice && virtualDevice.getCurrentDeviceSpec();
         };

         this.getInflatedDevices = function() {
            return _.values(inflatedDevices);
         };

         this.getDeviceSpecForDevice = function(device) {
            var virtualDevice = inflatedDevices[device.key];
            if (!virtualDevice) {
               virtualDevice = virtualDeviceInflator.inflate(device);
               inflatedDevices[device.key] = virtualDevice;
            }

            return virtualDevice.getCurrentDeviceSpec();
         };

         this.devicesOfType = function (deviceType) {
            return _.filter(inflatedDevices, function (virtualDevice) {
               return virtualDevice.isOfType(deviceType);
            });
         };

         this.devicesOfTypeNotMarkedForRemoval = function (deviceType) {
            return _.filter(inflatedDevices, function (virtualDevice) {
               return virtualDevice.isOfType(deviceType)
                     && !virtualDevice.isMarkedForRemoval();
            });
         };

         // Presenter method that could be moved to its own service
         this.existingDevicesOfType = function(deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return !virtualDevice.isNew();
            });
         };

         this.existingSortedDevicesOfType = function(deviceType) {
            var existingDevicesOfType = _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return !virtualDevice.isNew();
            });

            existingDevicesOfType.sort(function(a, b) {
               // match only numbers, then convert to true integers
               var diskNumberA = parseInt(a.deviceName().match(/\d+/g)[0], 10);
               var diskNumberB = parseInt(b.deviceName().match(/\d+/g)[0], 10);

               return diskNumberA - diskNumberB;
            });

            return existingDevicesOfType;
         };

         // Presenter method that could be moved to its own service
         this.newDevicesOfType = function (deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return virtualDevice.isNew();
            });
         };

         // Presenter method that could be moved to its own service
         this.findDevicesOfType = function (deviceType) {
            return this.devicesOfType(deviceType);
         };

         this.changedDevicesOfType = function (deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return virtualDevice.hasChanged();
            });
         };

         this.removeDeviceByKey = function(deviceKey) {
            var virtualDevice = this.getVirtualDevice(deviceKey);
            if(virtualDevice.isNew()) {
               delete inflatedDevices[deviceKey];
               delete rgValidationCallbacks[deviceKey];
            } else {
               virtualDevice.markForRemoval();
            }
         };

         this.getAllDevicesNotMarkedForRemoval = function () {
            return _.filter(self.getInflatedDevices(), function(device) {
               return !device.isMarkedForRemoval();
            });
         };

         this.getDevicesThatHaveBeenAssignedToNodes = function () {
            return _.chain(this.getAllDevicesNotMarkedForRemoval())
               .filter(function(device){
                  return _.isNumber(device.getCurrentDevice().unitNumber);
               })
               .sortBy(function(device) {
                  return device.hasChanged() ? 1 : -1;
               })
               .map(function(device){
                  return device.getCurrentDevice();
               })
               .value();
         };

         this.getDevicesAttachedToControllerKey = function (controllerKey) {
            var assignedDevices = self.getDevicesThatHaveBeenAssignedToNodes();
            return _.filter(assignedDevices, function(device) {
               return device.controllerKey === controllerKey;
            });
         };

         this.getRdmDisksNotMarkedForRemoval = function() {
            return _.chain(this.getAllDevicesNotMarkedForRemoval())
               .filter(function(inflatedDevice) {
                  return _.isFunction(inflatedDevice.isRDMDisk) && inflatedDevice.isRDMDisk();
               })
               .map(function(inflatedDevice) {
                  return inflatedDevice.getCurrentDevice();
               })
               .value();
         };

         this.isNodeInUse = function (controllerKey, nodeUnitNumber) {
            var devicesNotMarkedForRemoval = self.getAllDevicesNotMarkedForRemoval();
            return _.any(devicesNotMarkedForRemoval, function(virtualDevice){
               return virtualDevice.getCurrentDevice().controllerKey === controllerKey
                  && virtualDevice.getCurrentDevice().unitNumber === nodeUnitNumber;
            });
         };

         this.getVirtualDevice = function(deviceKey){
            return inflatedDevices[deviceKey];
         };

         this.addVirtualDevice = function(virtualDevice) {
            var deviceKey = virtualDevice.getKey();
            if(self.getVirtualDevice(deviceKey)) {
               throw(new Error('VirtualDevice already exists for key ' + deviceKey + ":" + _.keys(inflatedDevices)));
            }
            inflatedDevices[deviceKey] = virtualDevice;
         };

         this.devicesMarkedForRemovalOfType = function(deviceType) {
            return _.filter(self.getInflatedDevices(), function(device) {
               return device.isMarkedForRemoval() && device.isOfType(deviceType);
            });
         };

         this.devicesNotMarkedForRemovalOfType = function(deviceType) {
            return _.filter(self.getInflatedDevices(), function(device) {
               return !device.isMarkedForRemoval() && device.isOfType(deviceType);
            });
         };
      };

      return VirtualMachineDevices;
   }
]);

var h5_vm;
(function (h5_vm) {
    var VmHardwareUtil = (function () {
        function VmHardwareUtil(authorizationService, deviceClassLineageService) {
            this.authorizationService = authorizationService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.PCI_CONTROLLER_NAME = "com.vmware.vim.binding.vim.vm.device.VirtualPCIController";
            this.DEVICE_TYPE_ETHERNET_SPEC = "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard";
        }
        VmHardwareUtil.prototype.clearUnchangedConnectInfo = function (spec, originalDevice) {
            if (!spec || !spec.device) {
                return;
            }
            if (spec.operation === "add") {
                return;
            }
            if (!originalDevice) {
                return;
            }
            var newInfo = spec.device.connectable;
            var oldInfo = originalDevice.connectable;
            if (VmHardwareUtil.sameConnectInfo(oldInfo, newInfo)) {
                spec.device.connectable = null;
            }
            return;
        };
        VmHardwareUtil.sameConnectInfo = function (old, neu) {
            if (!neu && !old) {
                return true; // both missing, consider same
            }
            if (!neu || !old) {
                return false; // only one missing, consider different
            }
            // If here consider both parts present and we could safely
            // compare field-by-field (vmodl fields only)
            if (old.connected !== neu.connected) {
                // checkbox "Connect" might be clicked
                return false;
            }
            if (old.startConnected !== neu.startConnected) {
                // checkbox "Connect at power On" might be clicked
                return false;
            }
            if (old.allowGuestControl !== neu.allowGuestControl) {
                // I don't think we change allowGuestControl, but just in case
                return false;
            }
            // no difference if here, return true (same)
            return true;
        };
        VmHardwareUtil.prototype.checkPermissions = function (vmId) {
            return this.authorizationService.checkPrivilege(vmId, "VirtualMachine.Config.AddRemoveDevice");
        };
        VmHardwareUtil.prototype.checkPrivileges = function (vmConfigContextPrivileges, privileges) {
            return _.difference(privileges, vmConfigContextPrivileges).length === 0;
        };
        VmHardwareUtil.hasPrivileges = function (vmConfigContextPrivileges, privileges) {
            var diff = _.difference(privileges, vmConfigContextPrivileges);
            if (diff.length === 0) {
                return true;
            }
            return false;
        };
        VmHardwareUtil.hasRecordReplay = function (vmConfigContext) {
            var rtInfo = vmConfigContext.rtInfo;
            if (!rtInfo) {
                return false;
            }
            ;
            var vmRecordReplayState = rtInfo.recordReplayState;
            if (!vmRecordReplayState) {
                return false;
            }
            if (vmRecordReplayState === "inactive") {
                return false;
            }
            return true;
        };
        VmHardwareUtil.prototype.isPrimaryVm = function (ftRole) {
            return (ftRole === 1);
        };
        VmHardwareUtil.prototype.isSecondaryVm = function (ftRole) {
            return (ftRole > 1);
        };
        VmHardwareUtil.prototype.isPrimaryFtVm = function (ftState, ftInfo) {
            if (!ftInfo) {
                return false;
            }
            return (ftState !== 'notConfigured') && this.isPrimaryVm(ftInfo.role);
        };
        VmHardwareUtil.prototype.isSecondaryFtVm = function (ftState, ftInfo) {
            if (!ftInfo) {
                return false;
            }
            return (ftState !== 'notConfigured') && this.isSecondaryVm(ftInfo.role);
        };
        VmHardwareUtil.prototype.isFtVm = function (ftState, ftInfo) {
            return this.isPrimaryFtVm(ftState, ftInfo) || this.isSecondaryFtVm(ftState, ftInfo);
        };
        VmHardwareUtil.prototype.isVmPoweredOn = function (vmPowerState) {
            return vmPowerState === 'poweredOn';
        };
        VmHardwareUtil.prototype.isVmPoweredOff = function (vmPowerState) {
            return vmPowerState === 'poweredOff';
        };
        VmHardwareUtil.prototype.isVmSuspended = function (vmPowerState) {
            return vmPowerState === 'suspended';
        };
        VmHardwareUtil.prototype.bytesToMB = function (bytes) {
            var MB_FACTOR = 1024 * 1024;
            return bytes / MB_FACTOR;
        };
        VmHardwareUtil.prototype.isFtVmConfigContext = function (ctx) {
            var ftInfo = ctx.config.ftInfo;
            var rtInfo = ctx.rtInfo;
            var ftState = rtInfo ? rtInfo.faultToleranceState : null;
            var retVal = this.isFtVm(ftState, ftInfo);
            return retVal;
        };
        VmHardwareUtil.prototype.haveVmConfigSettingsPermission = function (vmConfigContext) {
            var privileges = vmConfigContext.privileges;
            var retVal = this.checkPrivileges(privileges, [h5_vm.Privileges.VM_CONFIG_SETTINGS]);
            return retVal;
        };
        VmHardwareUtil.userHasVmSettingsPermission = function (vmConfigContext) {
            var privileges = vmConfigContext.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.VM_CONFIG_SETTINGS]);
            return retVal;
        };
        VmHardwareUtil.userHasVmResourcePermission = function (vmConfigContext) {
            var privileges = vmConfigContext.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.VM_RESOURCE_PRIVILEGE]);
            return retVal;
        };
        VmHardwareUtil.noVmSettingsPermission = function (vmConfigContext) {
            return (VmHardwareUtil.userHasVmSettingsPermission(vmConfigContext) === false);
        };
        VmHardwareUtil.noVmResourcePermission = function (vmConfigContext) {
            return (VmHardwareUtil.userHasVmResourcePermission(vmConfigContext) === false);
        };
        VmHardwareUtil.userHasModifyDevicePermission = function (vmConfigContext) {
            var array = [h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE];
            var privileges = vmConfigContext.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, array);
            return retVal;
        };
        VmHardwareUtil.userHasHostUsbPermission = function (ctx) {
            var privileges = ctx.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.VM_HOST_USB_DEVICE]);
            return retVal;
        };
        VmHardwareUtil.userHasAddRemoveDevicePermission = function (ctx) {
            var privileges = ctx.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.VM_ADDREMOVEDEVICE]);
            return retVal;
        };
        VmHardwareUtil.userHasStorageProfileViewPermission = function (ctx) {
            var privileges = ctx.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.STORAGE_PROFILE_VIEW]);
            return retVal;
        };
        VmHardwareUtil.userHasCryptographerManageKeyServersPermission = function (ctx) {
            var privileges = ctx.privileges;
            var retVal = VmHardwareUtil.hasPrivileges(privileges, [h5_vm.Privileges.CRYPTOGRAPHER_MANAGE_KEY_SERVERS]);
            return retVal;
        };
        VmHardwareUtil.getPowerState = function (vmConfigContext) {
            if (!vmConfigContext) {
                return null;
            }
            if (!vmConfigContext.environment) {
                return null;
            }
            return vmConfigContext.environment.powerState;
        };
        VmHardwareUtil.isPoweredOn = function (vmConfigContext) {
            return VmHardwareUtil.getPowerState(vmConfigContext) === 'poweredOn';
        };
        VmHardwareUtil.isPoweredOff = function (vmConfigContext) {
            return VmHardwareUtil.getPowerState(vmConfigContext) === 'poweredOff';
        };
        VmHardwareUtil.isSuspended = function (vmConfigContext) {
            return VmHardwareUtil.getPowerState(vmConfigContext) === 'suspended';
        };
        VmHardwareUtil.getVmCapabilities = function (vmConfigContext) {
            return vmConfigContext.environment.configOption.capabilities;
        };
        VmHardwareUtil.prototype.getDeviceOption = function (vmConfigContext, deviceType) {
            return h5_vm.VmHardwareUtil.getVirtualDeviceOption(vmConfigContext, deviceType);
        };
        VmHardwareUtil.getVirtualDeviceOption = function (vmConfigContext, deviceType) {
            if (vmConfigContext.hasOwnProperty("environment") &&
                vmConfigContext.environment.hasOwnProperty("configOption") &&
                vmConfigContext.environment.configOption.hasOwnProperty("hardwareOptions") &&
                vmConfigContext.environment.configOption.hardwareOptions.hasOwnProperty("virtualDeviceOption")) {
                return vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption.find(function (deviceOption) {
                    return deviceOption.type.name === deviceType;
                }, this);
            }
        };
        VmHardwareUtil.prototype.isEthernetDevice = function (deviceOption) {
            if (deviceOption.hasOwnProperty("device") &&
                deviceOption.device.hasOwnProperty("_type")) {
                return this.deviceClassLineageService.isClassNameSubclassOf(deviceOption.device._type, this.DEVICE_TYPE_ETHERNET_SPEC);
            }
        };
        VmHardwareUtil.$inject = [
            'authorizationService',
            'deviceClassLineageService'
        ];
        return VmHardwareUtil;
    }());
    h5_vm.VmHardwareUtil = VmHardwareUtil;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareUtil', VmHardwareUtil);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var MarkAsTemplateService = (function () {
        function MarkAsTemplateService(mutationService) {
            this.mutationService = mutationService;
            this.CONVERT_TO_TEMPLATE_SPEC_NAME = "com.vmware.vsphere.client.vm.VmTemplateSpec";
        }
        MarkAsTemplateService.prototype.markAsTemplate = function (availableTargets) {
            this.mutationService.applyOnMultiEntity(availableTargets, this.CONVERT_TO_TEMPLATE_SPEC_NAME, {});
        };
        MarkAsTemplateService.$inject = [
            "mutationService"];
        return MarkAsTemplateService;
    }());
    h5_vm.MarkAsTemplateService = MarkAsTemplateService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("markAsTemplateService", MarkAsTemplateService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var ManagedEntityMoveSpec = com.vmware.vsphere.client.mixed.ManagedEntityMoveSpec;
    var ValidateMoveVmSpec = com.vmware.vsphere.client.h5.vm.data.ValidateMoveVmSpec;
    var MoveVmService = (function () {
        function MoveVmService(mutationService, defaultUriSchemeUtil, vuiService, clarityModalService, i18nService, $q, nameAndFolderValidatorService, managedEntityConstants, dataService, migrateVmWizardService, actionConfirmationService, managedByMessageBuilderService) {
            this.PROPERTY_TEMPLATE = "template";
            this.PROPERTY_DATACENTER = "dc";
            this.PROPERTY_MANAGED_BY_INFO = "managedByInfo";
            this._mutationService = mutationService;
            this._defaultUriSchemeUtil = defaultUriSchemeUtil;
            this._vuiService = vuiService;
            this._clarityModalService = clarityModalService;
            this._i18nService = i18nService;
            this._q = $q;
            this._nameAndFolderValidatorService = nameAndFolderValidatorService;
            this._managedEntityConstants = managedEntityConstants;
            this._dataService = dataService;
            this._migrateVmWizardService = migrateVmWizardService;
            this._actionConfirmationService = actionConfirmationService;
            this._managedByMessageBuilderService = managedByMessageBuilderService;
        }
        /**
         * If a drop target is supplied invokes the move action for the provided virtual
         * machines to the target. If the drop target is not supplied
         * then opens a wizard from which the drop target can be selected
         * @param vmIds
         * @param target
         * @param actionEval
         */
        MoveVmService.prototype.moveVms = function (vmIds, target, actionEval) {
            var _this = this;
            if (target && target.dropTarget) {
                this.applyMove(vmIds, target.dropTarget);
                return;
            }
            if (this.allVmsFromSameVc(vmIds)) {
                this.confirmIfRequired(vmIds, actionEval).then(function (properties) {
                    _this.showWizard(vmIds, properties);
                });
            }
            else {
                this.showMultipleVcsErrorDialog();
            }
        };
        /**
         * Builds a ManagedEntityMoveSpec that is used for the apply of the move action
         * @param virtualMachines
         * @returns {ManagedEntityMoveSpec}
         */
        MoveVmService.prototype.buildMoveSpec = function (virtualMachines) {
            var entities = this._defaultUriSchemeUtil.getManagedObjectReferences(virtualMachines);
            var moveSpec = new ManagedEntityMoveSpec();
            moveSpec.entities = entities;
            return moveSpec;
        };
        /**
         * Invokes the mutation service's apply operation to initiate the move entities
         * operation for the supplied virtual machines to the target
         * @param virtualMachineIds
         * @param targetId
         */
        MoveVmService.prototype.applyMove = function (virtualMachineIds, targetId) {
            var moveSpec = this.buildMoveSpec(virtualMachineIds);
            this._mutationService.apply(targetId, moveSpec._type, moveSpec);
        };
        /**
         * Validates if the given virtual machines can be moved to the supplied target.
         * 1. Checks if the targets is of allowed type (Datacenter, VM Folder)
         * 2. Invokes the backend for additional validation
         * @param virtualMachineIds
         * @param targetId
         * @returns {any}
         */
        MoveVmService.prototype.validateMove = function (virtualMachineIds, targetId) {
            var targetType = this._defaultUriSchemeUtil.getEntityType(targetId);
            var isTargetVmFolder = false;
            var isTargetDatacenter = !!(targetType === this._managedEntityConstants.DATACENTER);
            if (targetType === this._managedEntityConstants.FOLDER) {
                isTargetVmFolder = this._nameAndFolderValidatorService.isVmFolder(targetId);
            }
            if (isTargetVmFolder || isTargetDatacenter) {
                return this.retrieveValidationMessage(virtualMachineIds, targetId);
            }
            // if the target is not Datacenter or VM Folder, return error
            return this._q.when(this._i18nService.getString("Common", "moveTo.incorrectTargetTypeError"));
        };
        ;
        /**
         * Ask the backend for validation if the given virtual machines
         * can be moved to the supplied target.
         *
         * @param virtualMachineIds
         * @param targetId
         * @returns {any}
         */
        MoveVmService.prototype.retrieveValidationMessage = function (virtualMachineIds, targetId) {
            var entities = this._defaultUriSchemeUtil.getManagedObjectReferences(virtualMachineIds);
            var moveSpec = new ValidateMoveVmSpec();
            moveSpec.entities = entities;
            return this._mutationService
                .validate(targetId, moveSpec._type, moveSpec)
                .then(function (result) {
                return result.result;
            });
        };
        /**
         * Opens a clarity modal from which a drop target can be selected for the move
         * operation.
         * @param virtualMachineIds
         */
        MoveVmService.prototype.showWizard = function (virtualMachineIds, properties) {
            var subTitleObject = this.buildSubtitle(virtualMachineIds);
            var modalOptions = {
                title: this._i18nService.getString("VmUi", "moveVmToFolderDialogTitle"),
                subTitle: subTitleObject,
                defaultButton: "submit",
                dialogData: {
                    objectIds: virtualMachineIds,
                    // check if the selection is for virtual machines or templates
                    // no need to check for all of the items, since no mixed selection can be made
                    isTemplate: properties[virtualMachineIds[0]][this.PROPERTY_TEMPLATE],
                    datacenter: this._defaultUriSchemeUtil
                        .getVsphereObjectId(properties[virtualMachineIds[0]][this.PROPERTY_DATACENTER]),
                    virtualCenter: this._defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(virtualMachineIds[0])
                },
                contentTemplate: "vm-ui/resources/vm/services/wizards/moveVm/moveVmDialog.html"
            };
            this._clarityModalService.openOkCancelModal(modalOptions);
        };
        /**
         * Builds the subtitle object that is sent to the clarity modal service
         * If the virtual machine is only one, sets the objectId property of the
         * subtitle object, and the clarityModalService will retrieve and display its name
         * If the virtual machines are more than one, builds a text, that is set as a property
         * to the subtitle object and will directly be displayed in the dialog
         * @param virtualMachineIds
         * @returns {any}
         */
        MoveVmService.prototype.buildSubtitle = function (virtualMachineIds) {
            var subTitleObject = {};
            if (virtualMachineIds.length === 1) {
                subTitleObject.objectId = virtualMachineIds[0];
                return subTitleObject;
            }
            subTitleObject.text = this._i18nService.getString("Common", "contextMenu.title.nObjects", virtualMachineIds.length);
            return subTitleObject;
        };
        /**
         * Determines if all Vms are from the same VC.
         * If they are not. The move action is not available.
         * If they are we should open the Move Vms dialog.
         * @param virtualMachineIds {string[]}
         * @returns {boolean}
         */
        MoveVmService.prototype.allVmsFromSameVc = function (virtualMachineIds) {
            var _this = this;
            var result;
            var mor;
            var firstVmServerGuid;
            if (virtualMachineIds && virtualMachineIds[0]) {
                firstVmServerGuid = this._defaultUriSchemeUtil.getManagedObjectReference(virtualMachineIds[0]).serverGuid;
            }
            result = true;
            _.each(virtualMachineIds, function (virtualMachineId) {
                mor = _this._defaultUriSchemeUtil.getManagedObjectReference(virtualMachineId);
                if (mor.serverGuid !== firstVmServerGuid) {
                    result = false;
                }
            });
            return result;
        };
        /**
         * Method that displays an error dialog if the selected Vms are from differentVCs
         * with the corresponding message and error icon.
         */
        MoveVmService.prototype.showMultipleVcsErrorDialog = function () {
            var errorOptions = {
                title: this._i18nService.getString("VmUi", "dialogMoveToVmLabel"),
                message: this._i18nService.getString("VmUi", "MoveToDialog.MultipleVcErrors"),
                icon: "vui-icon32-error",
                submit: function () {
                    return true;
                },
                hideCancelButton: true
            };
            this._clarityModalService.openConfirmationModal(errorOptions);
        };
        MoveVmService.prototype.confirmIfRequired = function (vmIds, actionEval) {
            var _this = this;
            var deferred = this._q.defer();
            this._dataService.getPropertiesForObjects(vmIds, [this.PROPERTY_TEMPLATE, this.PROPERTY_DATACENTER, this.PROPERTY_MANAGED_BY_INFO])
                .then(function (properties) {
                if (!actionEval) {
                    deferred.resolve(properties);
                    return;
                }
                actionEval.action.confirmationTextSome =
                    _this._i18nService.getString("Common", "defaultConfirmation.someOK");
                actionEval.action.confirmationTextAll =
                    _this._i18nService.getString("Common", "defaultConfirmation.allOK");
                actionEval.action.confirmationTitle =
                    _this._i18nService.getString("VmUi", "moveVmToFolderDialogTitle");
                var withProceed = Object.keys(actionEval.evaluationStatuses).length === 1;
                _this._managedByMessageBuilderService.buildWarningMessage(vmIds, withProceed, properties)
                    .then(function (message) {
                    if (message) {
                        actionEval.action.confirmationText = message;
                        actionEval.action.confirmationTextSome = message + "\n\n" +
                            actionEval.action.confirmationTextSome;
                        actionEval.action.confirmationTextAll = message + "\n\n" +
                            actionEval.action.confirmationTextAll;
                    }
                    _this._actionConfirmationService.confirmIfRequired(actionEval, function () {
                        deferred.resolve(properties);
                    }, true);
                });
            });
            return deferred.promise;
        };
        MoveVmService.$inject = [
            "mutationService",
            "defaultUriSchemeUtil",
            "vuiService",
            "clarityModalService",
            "i18nService",
            "$q",
            "nameAndFolderValidatorService",
            "managedEntityConstants",
            "dataService",
            "migrateVmWizardService",
            "actionConfirmationService",
            "managedByMessageBuilderService"];
        return MoveVmService;
    }());
    h5_vm.MoveVmService = MoveVmService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("moveVmService", MoveVmService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Service providing an API for working with IP addresses.
 */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service('nicValidatorService', NicValidatorService);

   NicValidatorService.$inject = ['ipParserService'];

   function NicValidatorService(ipParserService) {
      this.validate = function(nicForm) {
         var validationResult = {
            errors: {
               ipv4: {}, ipv6: {}
            }
         };

         var ipv4Form = nicForm.ipv4;
         if (ipv4Form.required) {
            if (this.isIpAddressInvalid(ipv4Form)) {
               validationResult.errors.ipv4.address = true;
            }
            if (this.isSubnetMaskInvalid(ipv4Form)) {
               validationResult.errors.ipv4.subnetMask = true;
            }

            if (this.isDefaultGatewayInvalid(ipv4Form)) {
               validationResult.errors.ipv4.defaultGateway = true;
            }

            if (this.isAlternateGatewayInvalid(ipv4Form)) {
               validationResult.errors.ipv4.alternateGateway = true;
            }
         }

         var ipv6Form = nicForm.ipv6;
         if (ipv6Form.required) {
            if (this.isIp6AddressInvalid(ipv6Form)) {
               validationResult.errors.ipv6.address = true;
            }
            if (this.isIp6SubnetInvalid(ipv6Form)) {
               validationResult.errors.ipv6.subnetPrefixLength = true;
            }
         }

         return validationResult;
      };

      this.isIpAddressInvalid = function(nic) {
         return !ipParserService.isIpv4AddressValid(nic.address);
      };

      this.isSubnetMaskInvalid = function (nic) {
         return!ipParserService.isSubnetMaskValid(nic.subnetMask);
      };

      this.isDefaultGatewayInvalid = function(nic) {
         return !!nic.defaultGateway &&
               !ipParserService.isIpv4AddressValid(nic.defaultGateway);
      };
      this.isAlternateGatewayInvalid = function(nic) {
         return !!nic.alternateGateway &&
               !ipParserService.isIpv4AddressValid(nic.alternateGateway);
      };

      this.isIp6AddressInvalid = function(nic) {
         return !ipParserService.isIpv6AddressValid(nic.address);
      };
      this.isIp6SubnetInvalid = function(nic) {
         return !ipParserService.isSubnetPrefixValid(nic.subnetPrefixLength);
      };

      return this;
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .factory('powerOpsService', PowerOpsService);
   PowerOpsService.$inject = [
      'dataService',
      'vmRecommendationsService',
      'mutationService',
      'clarityModalService',
      'i18nService',
      'actionConfirmationService',
      'defaultUriSchemeUtil'];

   function PowerOpsService(dataService, vmRecommendationsService,
         mutationService, clarityModalService,
         i18nService, actionConfirmationService, defaultUriSchemeUtil) {
      var VM_POWER_STATE_SPEC = 'com.vmware.vsphere.client.vm.powerops.VmPowerStateSpec';

      var powerOnVm = function(actionEval, availableTargets) {
         var vmPowerSpec = {
            powerState: 'poweredOn'
         };

         var message;
         var onSubmit = function(response) {
            showPowerOnFailuresAndRecommendationsDialog(response, availableTargets);
         };

         dataService.getPropertiesForObjects(
               availableTargets,
               ['parentVApp', 'name', "managedByInfo"]
         ).then(function (properties) {
            if (actionEval.context.targetObjects.length === 1) {
               message = buildSingleMessage(properties[availableTargets[0]]);
               if (message) {
                  showConfirmationDialog(availableTargets, vmPowerSpec,
                        actionEval.action.label, message, true, onSubmit);
                  return;
               }
               submitVmPowerSpec(availableTargets, vmPowerSpec).then(onSubmit);
               return;
            }

            message = buildMultipleVmsMessage(properties, actionEval, availableTargets);
            if (message) {
               showConfirmationDialog(availableTargets, vmPowerSpec,
                     actionEval.action.label, message, true, onSubmit);
               return;
            }
            submitVmPowerSpec(availableTargets, vmPowerSpec).then(onSubmit);
         });
      };

      var powerOffVm = function(availableTargets) {
         var vmPowerSpec = {
            powerOpType: 'hard',
            powerState: 'poweredOff'
         };

         return submitVmPowerSpec(availableTargets, vmPowerSpec);
      };

      var shutdownGuest = function(availableTargets) {
         var vmPowerSpec = {
            powerState: 'poweredOff',
            powerOpType: 'soft'
         };
         return submitVmPowerSpec(availableTargets, vmPowerSpec);
      };

      function suspendVMs(availableTargets) {
         var vmPowerSpec = {
            powerState: 'suspended',
            powerOpType: 'hard'
         };
         return submitVmPowerSpec(availableTargets, vmPowerSpec);
      }

      function resetVMs(availableTargets) {
         var vmPowerSpec = {
            powerOpType: 'hard',
            powerState: 'poweredOn',
            reset: true
         };

         return submitVmPowerSpec(availableTargets, vmPowerSpec);
      }

      function rebootGuest(availableTargets) {
         var vmPowerSpec = {
            powerOpType: 'soft',
            powerState: 'poweredOn',
            reset: true
         };

         return submitVmPowerSpec(availableTargets, vmPowerSpec);
      }

      function showConfirmationDialog(availableTargets, vmPowerSpec, titleText, messageText, hideIcon, onSubmit) {
         var yesHandler = function() {
            if (onSubmit) {
               return submitVmPowerSpec(availableTargets, vmPowerSpec).then(onSubmit);
            } else {
               return submitVmPowerSpec(availableTargets, vmPowerSpec);
            }
         };
         var alertProperties = {
            title: titleText,
            message: messageText,
            yesHandler: yesHandler,
            useClarity: true,
            icon: null,
            clarityIcon: {
               shape: "warning",
               class: "is-warning",
               size: 48
            },
            showXIcon: false
         };

         if (hideIcon) {
            alertProperties.icon = null;
         }
         actionConfirmationService.showConfirmationDialog(alertProperties);
      }

      function submitVmPowerSpec(availableTargets, vmPowerSpec) {
         return mutationService.applyOnMultiEntity(availableTargets,
               VM_POWER_STATE_SPEC, vmPowerSpec);
      }

      function showPowerOnFailuresAndRecommendationsDialog(response, availableTargets) {
         if (!response || !response[0] || !response[0].result) {
            return;
         }
         var notAttempted = response[0].result.notAttempted;
         if (notAttempted && notAttempted.length !== 0) {
            var objectIds = _.map(notAttempted, function(notAttemptedItem) {
               return defaultUriSchemeUtil.getVsphereObjectId(notAttemptedItem.vm);
            });
            openFailuresDialog(objectIds, notAttempted);
            return;
         }
         if (response[0].result.recommendations) {
            openRecommendationsDialog(response, availableTargets);
         }
      }

      function openFailuresDialog(objectIds, notAttempted) {
         dataService.getPropertiesForObjects(objectIds, ['name', 'hostName', 'primaryIconId']).then(
               function(vmsProps) {
                  var dialogData = {
                     notAttempted: notAttempted,
                     vmsProps: vmsProps
                  };
                  var modalOptions = {
                     title: i18nService.getString('VmUi', 'PowerOnVmResultFormMediator.failuresTitle'),
                     contentTemplate: 'vm-ui/resources/vm/views/powerops/vmPowerOnFailures.html',
                     defaultButton: 'close',
                     hideSubmitButton: true,
                     closeButtonTitle: i18nService.getString('Common', 'saveButtonLabel'),
                     size: 'lg',
                     dialogData: dialogData
                  };
                  clarityModalService.openOkCancelModal(modalOptions);
               }
         );
      }

      function openRecommendationsDialog(response, availableTargets) {
         vmRecommendationsService.fetchRecommendations(response).then(function(recommendationsData) {
            if (recommendationsData === null) {
               return;
            }

            var title = availableTargets.length > 1 ?
                  i18nService.getString('VmUi', 'RecommendationsView.descriptionMultiVm') :
                  i18nService.getString('VmUi', 'RecommendationsView.descriptionSingleVm');
            var dialogData = {
               title: title,
               recommendations: recommendationsData,
               rawRecommendations: response[0].result.recommendations
            };

            var modalOptions = {
               title: i18nService.getString('VmUi', 'PowerOnVmResultFormMediator.powerOnRecommendations'),
               dialogData: dialogData,
               contentTemplate: 'vm-ui/resources/vm/views/powerops/vmPowerOnRecommendations.html',
               defaultButton: 'submit',
               size: 'lg'
            };
            clarityModalService.openOkCancelModal(modalOptions);
         });
      }

      function buildSingleMessage(vmProperties) {
         var messages = [];
         if (vmProperties.parentVApp) {
            messages.push(i18nService.getString(
                  'VmUi', 'PowerOnResolver.SingleVappWarning', vmProperties.name));
         }

         if (vmProperties.managedByInfo) {
            messages.push(i18nService.getString(
                  'Common', 'singleVmManagedByWarning', vmProperties.managedByInfo));
         }

         if (messages.length === 0) {
            return "";
         }

            messages.push(i18nService.getString(
                  'VmUi', 'PowerOnResolver.Continue'));
            return messages.join('\n\n');
      }

      function buildMultipleVmsMessage(vmsProperties, actionEval, availableTargets) {
         var vmsInVapp = [];
         var managedVmsExist = false;
         _.each(vmsProperties, function(vmProperties) {
            if (vmProperties.parentVApp) {
               vmsInVapp.push(vmProperties);
            }

            if (vmProperties.managedByInfo) {
               managedVmsExist = true;
            }
         });
         var messages = [];
         if (vmsInVapp.length === 1) {
            messages.push(i18nService.getString(
                  'VmUi', 'PowerOnResolver.SingleVappWarning', vmsInVapp[0].name));
         }

         if (vmsInVapp.length > 1) {
            messages.push(i18nService.getString(
                  'VmUi', 'PowerOnResolver.MultiVappWarning', vmsInVapp.length));
         }

         if (managedVmsExist) {
            messages.push(i18nService.getString('Common', 'multiVmManagedByWarning'));
         }

         var someUnavailableMessage = buildSomeUnavailableMessage(availableTargets.length, actionEval);
         if(someUnavailableMessage) {
            messages.push(someUnavailableMessage);
         }

         if (messages.length === 0) {
            return "";
         }

         messages.push(i18nService.getString(
               'VmUi', 'PowerOnResolver.Continue'));
         return messages.join('\n\n');
      }

      function buildSomeUnavailableMessage(availableTargetsLength, actionEval) {
         var unavailableCount =
               actionEval.context.targetObjects.length - availableTargetsLength;
         if (unavailableCount === 0) {
            return "";
         }
         // Only some of the VMs are in correct state
         var someUnavailableMessage = i18nService.getString(
               'VmUi', 'PowerOnResolver.SomeUnavailable',
               availableTargetsLength, actionEval.context.targetObjects.length);

         var someUnavailableReasonsTxt;
         if (unavailableCount === 1) {
            someUnavailableReasonsTxt = i18nService.getString(
                  'VmUi', 'PowerOnResolver.SingleDisabledOrNoPrivs');
         } else {
            someUnavailableReasonsTxt = i18nService.getString(
                  'VmUi', 'PowerOnResolver.MultiDisabledOrNoPrivs', unavailableCount);
         }

         return [
            someUnavailableMessage,
            someUnavailableReasonsTxt
         ].join('\n\n');
      }

      return {
         powerOnVm: powerOnVm,
         powerOffVm: powerOffVm,
         shutdownGuest: shutdownGuest,
         suspendVMs: suspendVMs,
         resetVMs: resetVMs,
         rebootGuest: rebootGuest,
         showPowerOnFailuresAndRecommendationsDialog: showPowerOnFailuresAndRecommendationsDialog
      };
   }
}());

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var ScheduledTasksDeviceChangesService = (function () {
        function ScheduledTasksDeviceChangesService(virtualDeviceInflator, deviceService, vmDeviceInfoService, defaultUriSchemeUtil, storageProfileService) {
            this.virtualDeviceInflator = virtualDeviceInflator;
            this.deviceService = deviceService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageProfileService = storageProfileService;
        }
        ScheduledTasksDeviceChangesService.prototype.addDevices = function (virtualMachineDevices, deviceChanges, virtualDeviceOptionsByDeviceType, vmParams, availableNetworks, datastoreRefs, vmProfile) {
            var _this = this;
            var additionalInfo = {
                deviceOptionsByDeviceType: virtualDeviceOptionsByDeviceType,
                availableNetworks: availableNetworks
            };
            _.each(deviceChanges, function (deviceChange) {
                var device = virtualMachineDevices.getVirtualDevice(deviceChange.device.key);
                if (!_.isEmpty(device)) {
                    device.setCurrentDeviceSpec(deviceChange);
                }
                else {
                    var inflatedDevice = _this.virtualDeviceInflator.inflate(deviceChange.device, additionalInfo);
                    inflatedDevice.setCurrentDeviceSpec(deviceChange);
                    virtualMachineDevices.addVirtualDevice(inflatedDevice);
                }
                _this.updateVirtualDiskProperties(deviceChange, virtualMachineDevices, vmParams, datastoreRefs, vmProfile);
            });
            var allDevices = virtualMachineDevices.getInflatedDevices();
            this.deviceService.calculateKey(allDevices);
        };
        ScheduledTasksDeviceChangesService.prototype.setStorageForDisk = function (device, vmParams, datastoreRefs) {
            // the disks datastore name is kept in the format [datastore name]
            var match = device.backing.fileName.match(/\[(.*)\]/);
            var datastoreName = match ? match[1] : "";
            var datastoreRef = datastoreRefs[datastoreName];
            var datastoreId = this.defaultUriSchemeUtil.getVsphereObjectId(datastoreRef);
            if (datastoreId) {
                var storageObject = {
                    storageObject: {
                        storageRef: datastoreRef,
                        name: datastoreName
                    },
                    name: datastoreName,
                    id: datastoreId
                };
                vmParams.setStorageForDisk(storageObject, device);
                return;
            }
            if (device.backing.datastore) {
                var storageObject = {
                    storageObject: {
                        storageRef: device.backing.datastore,
                        name: datastoreName
                    },
                    name: datastoreName,
                    id: this.defaultUriSchemeUtil.getVsphereObjectId(device.backing.datastore)
                };
                vmParams.setStorageForDisk(storageObject, device);
            }
        };
        ScheduledTasksDeviceChangesService.prototype.updateVirtualDiskProperties = function (deviceChange, virtualMachineDevices, vmParams, datastoreRefs, vmProfile) {
            if (this.vmDeviceInfoService.isDeviceSubclassOf(deviceChange.device, "VirtualDisk")) {
                var deviceFileName = deviceChange.device.backing.fileName;
                // if the device's file name does not contain only the datastore name
                // but the vmdk info in  the format "[datastore name] file.vmdk"
                // the hard disk is imported from a disk of an existing VM or
                // we are in clone mode and that is the original disk of the VM in
                // which case the datastore is also populated in the backing
                var createdFromExistingDisk = deviceFileName.lastIndexOf("]") !== (deviceFileName.length - 1) &&
                    deviceChange.device.backing.datastore === null;
                deviceChange.device.createdFromExistingDisk = createdFromExistingDisk;
                this.setStorageForDisk(deviceChange.device, vmParams, datastoreRefs);
                var device = virtualMachineDevices.getVirtualDevice(deviceChange.device.key);
                device.setCurrentDeviceSpec(deviceChange);
                if (!createdFromExistingDisk) {
                    var isProfileEqualToHome = this.storageProfileService.areProfileSpecsEqual(deviceChange.device.profile && deviceChange.device.profile[0], vmProfile[0], false);
                    device.setStorageProfileManuallySet(!isProfileEqualToHome);
                }
                if (!_.isEmpty(deviceChange.profile)) {
                    var profile = deviceChange.profile[0];
                    var replicationGroupInfo = void 0;
                    if (profile.replicationSpec) {
                        replicationGroupInfo = {
                            id: profile.replicationSpec.replicationGroupId
                        };
                    }
                    device.updateDiskProfile(profile, replicationGroupInfo);
                }
            }
        };
        ScheduledTasksDeviceChangesService.$inject = ["virtualDeviceInflator", "deviceService", "vmDeviceInfoService",
            "defaultUriSchemeUtil", "storageProfileService"];
        return ScheduledTasksDeviceChangesService;
    }());
    h5_vm.ScheduledTasksDeviceChangesService = ScheduledTasksDeviceChangesService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("scheduledTasksDeviceChangesService", ScheduledTasksDeviceChangesService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmCryptoUnlockSpec = com.vmware.vsphere.client.h5.vm.data.VmCryptoUnlockSpec;
    var UnlockVmService = (function () {
        function UnlockVmService(mutationService, actionConfirmationService, i18nService, defaultUriSchemeUtil) {
            this.mutationService = mutationService;
            this.actionConfirmationService = actionConfirmationService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        UnlockVmService.prototype.unlockVm = function (actionEval, availableTargets, context) {
            var _this = this;
            var entityId = context && context.entityId
                ? context.entityId
                : availableTargets[0];
            if (actionEval && actionEval.action && actionEval.context) {
                actionEval.action.confirmationText = this.i18nService.getString("VmUi", "cryptoUnlockVm.dialog.message");
                actionEval.context.targetObjects = [this.defaultUriSchemeUtil.getManagedObjectReference(entityId)];
            }
            this.actionConfirmationService.confirmIfRequired(actionEval, function () { _this.applyUnlockVM(entityId); });
        };
        UnlockVmService.prototype.applyUnlockVM = function (entityId) {
            var unlockSpec = new VmCryptoUnlockSpec();
            this.mutationService.apply(entityId, unlockSpec._type, unlockSpec);
            return true;
        };
        UnlockVmService.$inject = ["mutationService", "actionConfirmationService",
            "i18nService", "defaultUriSchemeUtil"];
        return UnlockVmService;
    }());
    h5_vm.UnlockVmService = UnlockVmService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("unlockVmService", UnlockVmService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('upgradeVmHardwareService', upgradeVmHardwareService);

   upgradeVmHardwareService.$inject = ['dataService', 'mutationService',
      'actionConfirmationService', 'i18nService', 'clarityModalService', '$timeout',
      'vcService', 'upgradeVmHardwareConstants', 'vmHardwareCompatibilityService',
      '$q', 'managedByMessageBuilderService'];

   function upgradeVmHardwareService(dataService, mutationService,
         actionConfirmationService, i18nService, clarityModalService, $timeout,
         vcService, upgradeVmHardwareConstants, vmHardwareCompatibilityService, $q,
         managedByMessageBuilderService) {

      return {
         upgradeVmHardware: upgradeVmHardware,
         scheduleUpgradeVmHardware: scheduleUpgradeVmHardware,
         cancelScheduledVmHardwareUpgrade: cancelScheduledVmHardwareUpgrade
      };

      function upgradeVmHardware(actionEval, vmIds) {
         upgradeHardwareInternal(vmIds, actionEval, false);
      }

      function scheduleUpgradeVmHardware(actionEval, vmIds) {
         upgradeHardwareInternal(vmIds, actionEval, true);
      }

      function upgradeHardwareInternal(vmIds, actionEval, isSchedule) {
         var promises = buildPromises(vmIds);
         $q.all(promises).then(function(results) {
            var subTitle = '';
            if (actionEval.context.targetObjects.length === 1) {
               subTitle = results['dataServiceProperties'][vmIds[0]]['name'];
            }
            okHandlerInternal(results, actionEval, isSchedule, subTitle);
         });
      }

      function cancelScheduledVmHardwareUpgrade(actionEval, vmIds) {
         // VmConfigSpec is used to cancel upgrade by setting upgradePolicy to "never".
         mutationService.applyOnMultiEntity(vmIds,
               'com.vmware.vsphere.client.vm.VmConfigSpec',
               {
                  config: {
                     _type: "com.vmware.vim.binding.vim.vm.ConfigInfo",
                     scheduledHardwareUpgradeInfo: {
                        _type: "com.vmware.vim.binding.vim.vm.ScheduledHardwareUpgradeInfo",
                        upgradePolicy: upgradeVmHardwareConstants.hardwareUpgradePolicy.never
                     }
                  }
               });
      }

      function buildModalOptions(supportedVersions,
            upgradeDescriptionSingle, allVms, hwVersion, title, scheduleMode, onSubmit, subTitle) {
         var modalOptions = {
            dialogData: {
               supportedVersions: supportedVersions,
               description: upgradeDescriptionSingle,
               allVms: allVms,
               hwVersion: hwVersion,
               scheduleMode: scheduleMode
            },
            contentTemplate: 'vm-ui/resources/vm/views/compatibility/upgradeVmHardwareView.html',
            title: title,
            defaultButton: 'submit',
            alerts: [],
            onSubmit: onSubmit
         };

         if (allVms.length === 1 && subTitle) {
            modalOptions.subTitle = {
               text: subTitle
            };
         }

         return modalOptions;
      }

      function buildPromises(vmIds) {
         var reqProps = ['config.version', 'optionDescriptors', 'managedByInfo', 'name'];
         var promises = {
            'dataServiceProperties': dataService.getPropertiesForObjects(vmIds, reqProps),
            'is65VcOrLater': vcService.is65VcOrLater(vmIds[0])
         };
         return promises;
      }

      function okHandlerInternal(results, actionEval, isSchedule, subTitle) {
         var data = results['dataServiceProperties'];
         var is65VcOrLater = results['is65VcOrLater'];
         var supportedVersions = vmHardwareCompatibilityService
               .buildSupportedVersionsForVms(data, is65VcOrLater);

         var warning = isSchedule
               ? (actionEval.context.targetObjects.length === 1
                     ? i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.singleVm.schedule.warning.nonUpgradable')
                     : i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.schedule.warning.nonUpgradable'))
               : i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.singleVm.warning.nonUpgradable');

         var title = isSchedule ?
               i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.schedule.title') :
               i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.title');

         if (_.isEmpty(supportedVersions)) {
            clarityModalService.openConfirmationModal({
               title: title,
               message: warning,
               submit: function () {},
               preserveNewlines: true,
               saveButtonLabel: i18nService.getString('Common', 'alert.ok'),
               cancelButtonLabel: null,
               hideCancelButton: true,
               clarityIcon: {
                  shape: "error",
                  class: "is-error",
                  size: 48
               },
               showXIcon: false
            });
            return;
         }

         var upgradeDescriptionSingle = isSchedule ?
               i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.schedule.description1') :
               i18nService.getString('VmUi', 'UpgradeVmVirtualHardwareForm.description1');

         var hwVersion = {
            selectedVersion: supportedVersions[supportedVersions.length - 1]
         };

         if (isSchedule) {
            hwVersion.isUpgradeAfterGuestOsShutdown = false;
         }

         var onSubmit = function() {
            if (isSchedule) {
               return submitScheduleUpdateHardwareVersion(
                     hwVersion.selectedVersion,
                     hwVersion.isUpgradeAfterGuestOsShutdown);
            }

            return submitUpdateHardwareVersion(hwVersion.selectedVersion);
         };

         var modalOptions = buildModalOptions(supportedVersions,
               upgradeDescriptionSingle, actionEval.context.targetObjects,
               hwVersion, title, isSchedule, onSubmit, subTitle);
         clarityModalService.openOkCancelModal(modalOptions);
      }

      function submitUpdateHardwareVersion(selectedVersion) {
         var vmHwVersionSpec = {
            version: selectedVersion.id
         };
         mutationService.applyOnMultiEntity(selectedVersion.vms,
               'com.vmware.vsphere.client.vm.version.VmHwVersionSpec', vmHwVersionSpec);
         return true;
      }

      function submitScheduleUpdateHardwareVersion(hardwareVersion, isUpgradeAfterGuestOsShutdown) {
         var vmConfigSpec = {
            _type: 'com.vmware.vsphere.client.vm.VmConfigSpec',
            config: {
               _type: 'com.vmware.vim.binding.vim.vm.ConfigInfo',
               scheduledHardwareUpgradeInfo: {
                  _type: 'com.vmware.vim.binding.vim.vm.ScheduledHardwareUpgradeInfo',
                  versionKey: hardwareVersion.id,
                  upgradePolicy: isUpgradeAfterGuestOsShutdown ?
                        upgradeVmHardwareConstants.hardwareUpgradePolicy.onSoftPowerOff :
                        upgradeVmHardwareConstants.hardwareUpgradePolicy.always
               }
            }
         };
         mutationService.applyOnMultiEntity(hardwareVersion.vms,
               'com.vmware.vsphere.client.vm.VmConfigSpec', vmConfigSpec);
         return true;
      }

      function showConfirmationDialog(title, message, okHandler, subTitleText, vmId) {
         var subTitle = {};
         if (vmId) {
            subTitle.objectId = vmId;
         } else if (subTitleText) {
            subTitle.text = subTitleText;
         }
         var alertProperties = {
            useClarity: true,
            title: title,
            message: message,
            clarityIcon: {
               shape: "warning",
               class: "is-warning",
               size: 48
            },
            showXIcon: false,
            icon: null,
            yesHandler: okHandler
         };

         if (!_.isEmpty(subTitle)) {
            alertProperties.subTitle = subTitle;
         }

         actionConfirmationService.showConfirmationDialog(alertProperties);
      }
   }
})();

angular.module('com.vmware.vsphere.client.vm').service('virtualDiskInflator', [
   'VirtualDisk',
   'storageProfileService',
   function(
      VirtualDisk,
      storageProfileService
   ) {
      return {
         build: function(rawDevice, storageProfiles, storageProfileAssignments) {
            var profile;
            if (storageProfileAssignments && storageProfiles) {
               profile = storageProfileService.makeProfileFromDevice(rawDevice, storageProfiles, storageProfileAssignments);
            }
            return new VirtualDisk(rawDevice, profile);
         }
      };
   }]);

var h5_vm;
(function (h5_vm) {
    var VirtualNetworkDeviceInflator = (function () {
        function VirtualNetworkDeviceInflator(VirtualNetworkDevice) {
            this.VirtualNetworkDevice = VirtualNetworkDevice;
        }
        VirtualNetworkDeviceInflator.prototype.build = function (rawDevice, availableNetworks) {
            var _this = this;
            var backing = rawDevice.backing;
            var correspondingNetwork = _.find(availableNetworks, function (candidateNetwork) {
                return _this.compareBacking(candidateNetwork, backing);
            });
            return new this.VirtualNetworkDevice(rawDevice, correspondingNetwork);
        };
        VirtualNetworkDeviceInflator.prototype.compareBacking = function (candidateNetwork, backing) {
            if (backing._type === h5_vm.NetBackingType.STD_NETWORK &&
                candidateNetwork._type === h5_vm.NetworkType.STD_NETWORK) {
                return backing.deviceName === candidateNetwork.name;
            }
            if (backing._type === h5_vm.NetBackingType.DVPORGGROUP &&
                candidateNetwork._type === h5_vm.NetworkType.DVPORGGROUP) {
                return backing.port.switchUuid === candidateNetwork.switchUuid &&
                    backing.port.portgroupKey === candidateNetwork.portgroupKey;
            }
            if (backing._type === h5_vm.NetBackingType.DVPORGGROUP &&
                candidateNetwork._type === h5_vm.NetworkType.DVSWITCH) {
                return backing.port.switchUuid === candidateNetwork.switchUuid &&
                    (_.isEmpty(backing.port.portgroupKey));
            }
            if (backing._type === h5_vm.NetBackingType.NSX_NETWORK &&
                candidateNetwork._type === h5_vm.NetworkType.NSX_NETWORK) {
                var opaqueNetworkId = candidateNetwork.network.opaqueNetworkId;
                var opaqueNetworkType = candidateNetwork.network.opaqueNetworkType;
                return opaqueNetworkId === backing.opaqueNetworkId &&
                    opaqueNetworkType === backing.opaqueNetworkType;
            }
            return false;
        };
        VirtualNetworkDeviceInflator.$inject = ["VirtualNetworkDevice"];
        return VirtualNetworkDeviceInflator;
    }());
    h5_vm.VirtualNetworkDeviceInflator = VirtualNetworkDeviceInflator;
    angular.module('com.vmware.vsphere.client.vm')
        .service('virtualNetworkDeviceInflator', VirtualNetworkDeviceInflator);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').service('virtualControllerInflator', [
   'VirtualController',
   function(VirtualController) {
      return {
         build: function(rawDevice, deviceOptionsByDeviceType) {
            var deviceOption = deviceOptionsByDeviceType[rawDevice._type];

            return new VirtualController(rawDevice, {
               maxDisks: parseMaxDisks(deviceOption),
               maxCdroms: parseMaxCdroms(deviceOption)
            });
         }
      };

      function parseMaxDisks(deviceOption) {
         var matcher = new RegExp("^num\\w+Disks$");

         var numDiskKey = _.find(_.keys(deviceOption), function (key) {
            return key.match(matcher);
         });

         return numDiskKey ? deviceOption[numDiskKey].max : 0;
      }

      function parseMaxCdroms(deviceOption) {
         var matcher = new RegExp("^num\\w+Cdroms$");

         var numCdromsKey = _.find(_.keys(deviceOption), function (key) {
            return key.match(matcher);
         });

         return numCdromsKey ? deviceOption[numCdromsKey].max : 0;
      }
   }
]);

angular.module('com.vmware.vsphere.client.vm').service('virtualSCSIControllerInflator', [
   'VirtualSCSIController',
   function(VirtualSCSIController) {
      return {
         build: function(rawDevice, deviceOptionsByDeviceType) {
            var deviceOption = deviceOptionsByDeviceType[rawDevice._type];

            return new VirtualSCSIController(rawDevice, {
               maxDisks: deviceOption.numSCSIDisks.max,
               maxCdroms: deviceOption.numSCSICdroms.max,
               reservedNode: deviceOption.scsiCtlrUnitNumber
            });
         }
      };
   }
]);

var h5_vm;
(function (h5_vm) {
    var MigrateOrMoveValidationSpec = com.vmware.vsphere.client.h5.vm.data.MigrateOrMoveValidationSpec;
    /**
     * Implements the action code which is invoked when the user drops a VM over some target
     */
    var VmDragAndDropService = (function () {
        function VmDragAndDropService(actionsService, defaultUriSchemeUtil, managedEntityConstants, i18nService, actionConfirmationService, $q, mutationService) {
            this.MOVE_ACTION_ID = "vsphere.core.vm.actions.moveVmOrTemplateFromDragAndDrop";
            this.MIGRATE_ACTION_ID = "vsphere.core.vm.actions.migrate";
            this.MIGRATE_NETWORKING_BY_DRAG_ACTION_ID = "vsphere.core.dvs.migrateVmNetworkingDragAndDropAction";
            this._actionsService = actionsService;
            this._defaultUriSchemeUtil = defaultUriSchemeUtil;
            this._managedEntityConstants = managedEntityConstants;
            this._i18nService = i18nService;
            this._actionConfirmationService = actionConfirmationService;
            this._q = $q;
            this._mutationService = mutationService;
        }
        /**
         * Decides which action to be invoked depending on the destinationTarget's type
         * and whether or not the action is allowed for multiple objects
         * @param availableTargets
         * @param destinationTarget
         * @param isMulti
         */
        VmDragAndDropService.prototype.moveOrMigrateVm = function (availableTargets, destinationTarget) {
            var _this = this;
            var targetType = this._defaultUriSchemeUtil.getEntityType(destinationTarget.dropTarget);
            var targetIsFolder = !!destinationTarget
                && !!destinationTarget.dropTarget
                && (targetType === this._managedEntityConstants.FOLDER
                    || targetType === this._managedEntityConstants.DATACENTER);
            if (targetIsFolder) {
                this.invokeAction(availableTargets, destinationTarget, this.MOVE_ACTION_ID);
                return;
            }
            if (targetType === this._managedEntityConstants.NETWORK
                || targetType === this._managedEntityConstants.OPAQUE_NETWORK
                || targetType === this._managedEntityConstants.DISTRIBUTED_VIRTUAL_PORTGROUP) {
                this._actionsService.getAction(this.MIGRATE_NETWORKING_BY_DRAG_ACTION_ID, destinationTarget.dropTarget)
                    .then(function (actionEval) {
                    if (actionEval === void 0) { actionEval = {}; }
                    if (actionEval.available) {
                        _this._actionsService.invokeAction(actionEval, availableTargets, destinationTarget);
                    }
                });
                return;
            }
            this.invokeAction(availableTargets, destinationTarget, this.MIGRATE_ACTION_ID);
        };
        /**
         * Evaluates the action with action service for the given targets
         * If the action is available checks if the destination target is valid for
         * the supplied virtual machines(availableTargets)
         * if the action is not available or an error is returned from the validation
         * a warning message is shown
         *
         * @param availableTargets
         * @param destinationTarget
         * @param actionId
         */
        VmDragAndDropService.prototype.invokeAction = function (availableTargets, destinationTarget, actionId) {
            var _this = this;
            this._actionsService.getAction(actionId, availableTargets).then(function (actionEval) {
                if (actionEval === void 0) { actionEval = {}; }
                actionEval.action.label = _this._i18nService.getString("VmUi", "dialogMoveToVmLabel");
                if (actionEval.available === true) {
                    _this.buildConfirmationMessages(actionEval);
                    _this._actionsService.invokeAction(actionEval, destinationTarget);
                }
                else {
                    _this.displayWarning(actionEval.action);
                }
            });
        };
        VmDragAndDropService.prototype.buildConfirmationMessages = function (actionEval) {
            // No longer custom
            // Now when passing a second time through the action confirmation service
            // it will handle the managed vms
            actionEval.action.confirmationText = "";
            actionEval.action.confirmationTextSome =
                this._i18nService.getString("Common", "defaultConfirmation.someOK");
            actionEval.action.confirmationTextAll =
                this._i18nService.getString("Common", "defaultConfirmation.allOK");
        };
        /**
         * Displays a warning message
         * if it is passed as parameter(waning)
         * if no message is passed it is retrieved from the action
         * if no message is found the default warning is shown
         * @param action
         * @param warning
         */
        VmDragAndDropService.prototype.displayWarning = function (action, warning) {
            if (action === void 0) { action = {}; }
            if (warning === void 0) { warning = ""; }
            var confirmationTitle = !!action.confirmationTitle ?
                action.confirmationTitle :
                action.label;
            var confirmationText = warning ||
                action.confirmationTextNone ||
                this._i18nService.getString("Common", "defaultConfirmation.noneOK");
            var alertProperties = {
                title: confirmationTitle,
                message: confirmationText
            };
            this._actionConfirmationService.showWarningDialog(alertProperties);
        };
        /**
         * Separates the provided available targets into two arrays:
         * moveVms - vms for which the move action will be invoked
         * migrateVms - vms for which the migrate wizard will be open
         * For targets of types HOST, CLUSTER, RESOURCE_POOL, VAPP
         * makes a request to the backend for the needed calculations
         * @param destinationTarget
         * @param availableTargets
         * @returns {any}
         */
        VmDragAndDropService.prototype.retrieveMoveOrMigrateData = function (destinationTarget, availableTargets) {
            var _this = this;
            var target = this._defaultUriSchemeUtil.getManagedObjectReference(destinationTarget);
            var result = {
                moveVms: [],
                moveTarget: destinationTarget,
                migrateVms: availableTargets,
                migrateTarget: destinationTarget
            };
            switch (target.type) {
                case this._managedEntityConstants.HOST:
                case this._managedEntityConstants.CLUSTER:
                case this._managedEntityConstants.RESOURCE_POOL:
                case this._managedEntityConstants.V_APP:
                    var spec = new MigrateOrMoveValidationSpec();
                    spec.target = target;
                    spec.entities = this._defaultUriSchemeUtil.getManagedObjectReferences(availableTargets);
                    var operationName = this._i18nService.getString("VmUi", "actionMoveVmLabel");
                    return this._mutationService.validateSpec(spec._type, spec, operationName).then(function (data) {
                        if (!data.result || data.error) {
                            return {
                                moveVms: [],
                                moveTarget: "",
                                migrateVms: [],
                                migrateTarget: ""
                            };
                        }
                        var migrateOrMoveValidationData = data.result;
                        result.moveVms = _this._defaultUriSchemeUtil
                            .getVsphereObjectIds(migrateOrMoveValidationData.moveVms);
                        result.moveTarget = _this._defaultUriSchemeUtil
                            .getVsphereObjectId(migrateOrMoveValidationData.moveTarget);
                        result.migrateVms = _this._defaultUriSchemeUtil
                            .getVsphereObjectIds(migrateOrMoveValidationData.migrateVms);
                        result.migrateTarget = _this._defaultUriSchemeUtil
                            .getVsphereObjectId(migrateOrMoveValidationData.migrateTarget);
                        return result;
                    });
                case this._managedEntityConstants.DATASTORE:
                case this._managedEntityConstants.STORAGE_POD:
                default:
                    return this._q.when(result);
            }
        };
        VmDragAndDropService.$inject = [
            "actionsService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "i18nService",
            "actionConfirmationService",
            "$q",
            "mutationService"
        ];
        return VmDragAndDropService;
    }());
    h5_vm.VmDragAndDropService = VmDragAndDropService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmDragAndDropService", VmDragAndDropService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmRemovalSpec = com.vmware.vsphere.client.vm.VmRemovalSpec;
    var VmRemovalService = (function () {
        function VmRemovalService(mutationService) {
            this.mutationService = mutationService;
        }
        VmRemovalService.prototype.unregisterVms = function (vmIds) {
            var unregisterSpec = VmRemovalService.buildRemovalSpec(false);
            this.mutationService.removeOnMultiEntity(vmIds, unregisterSpec._type, unregisterSpec);
        };
        VmRemovalService.prototype.deleteVms = function (vmIds) {
            var deleteSpec = VmRemovalService.buildRemovalSpec(true);
            this.mutationService.removeOnMultiEntity(vmIds, deleteSpec._type, deleteSpec);
        };
        VmRemovalService.buildRemovalSpec = function (deleteFromDisk) {
            var removalSpec = new VmRemovalSpec();
            removalSpec.deleteFromDisk = deleteFromDisk;
            return removalSpec;
        };
        VmRemovalService.$inject = ["mutationService"];
        return VmRemovalService;
    }());
    h5_vm.VmRemovalService = VmRemovalService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmRemovalService", VmRemovalService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmToolsInstallerSpec = com.vmware.vsphere.client.vm.tools.VmToolsInstallerSpec;
    var VmToolsService = (function () {
        function VmToolsService(mutationService, i18nService, clarityModalService) {
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
        }
        VmToolsService.prototype.mount = function (vmIds) {
            this.spec = new VmToolsInstallerSpec();
            this.spec.operation = "mountInstaller";
            this.mutationService.applyOnMultiEntity(vmIds, this.spec._type, this.spec);
            return true;
        };
        VmToolsService.prototype.unmount = function (vmIds) {
            this.spec = new VmToolsInstallerSpec();
            this.spec.operation = "unmountInstaller";
            this.mutationService.applyOnMultiEntity(vmIds, this.spec._type, this.spec);
            return true;
        };
        VmToolsService.prototype.installUpgrade = function (actionEval, availableTargets) {
            var dialogData = {
                title: this.i18nService.getString("VmUi", "VmToolsPopupForm.multiAction.title"),
                size: "lg",
                availableVmIds: availableTargets,
                totalVmsCount: actionEval.context.targetObjects.length,
                defaultButton: "close"
            };
            var dialogTemplateUrl = "vm-ui/resources/vm/views/tools/installUpgradeVmTools.html";
            this.clarityModalService.openModal(actionEval, availableTargets, dialogData, dialogTemplateUrl);
        };
        VmToolsService.$inject = ["mutationService", "i18nService", "clarityModalService"];
        return VmToolsService;
    }());
    h5_vm.VmToolsService = VmToolsService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmToolsService", VmToolsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVappBasicInformationPageService = (function () {
        function CloneVappBasicInformationPageService(i18nService, vuiConstants, wizardPageService, vmVuiWizardPageBuilder, cloneVmBasicInformationPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.cloneVmBasicInformationPageModel = cloneVmBasicInformationPageModel;
        }
        CloneVappBasicInformationPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var pageModel = new this.cloneVmBasicInformationPageModel(wizardScope.wizardViewData, wizardScope.vmParams, null, wizardScope.config);
            wizardScope.cloneVmBasicInformationPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "BasicInformationPage.title"),
                contentUrl: "vm-ui/resources/vm/views/clone/clone-vapp-basic-information.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.INCOMPLETE,
            });
        };
        CloneVappBasicInformationPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "cloneVmBasicInformationPageModel"
        ];
        return CloneVappBasicInformationPageService;
    }());
    h5_vm.CloneVappBasicInformationPageService = CloneVappBasicInformationPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVappBasicInformationPageService", CloneVappBasicInformationPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var TemplateType = h5_vm.TemplateType;
    var CloneVmBasicInformationPageModelFactory = (function () {
        function CloneVmBasicInformationPageModelFactory(authorizationService, wizardPageService, nameAndFolderValidatorService, $q, i18nService, dataService, defaultUriSchemeUtil, featureFlagsService) {
            return function (wizardViewData, virtualMachineSpecBuilder, basicInformation, wizardConfig) {
                return new CloneVmBasicInformationPageModel(wizardViewData, virtualMachineSpecBuilder, basicInformation, wizardConfig, authorizationService, wizardPageService, nameAndFolderValidatorService, $q, i18nService, dataService, defaultUriSchemeUtil, featureFlagsService);
            };
        }
        CloneVmBasicInformationPageModelFactory.$inject = [
            "authorizationService",
            "wizardPageService",
            "nameAndFolderValidatorService",
            "$q",
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "featureFlagsService"
        ];
        return CloneVmBasicInformationPageModelFactory;
    }());
    var CloneVmBasicInformationPageModel = (function () {
        function CloneVmBasicInformationPageModel(wizardViewData, virtualMachineSpecBuilder, basicInformation, wizardConfig, authorizationService, wizardPageService, nameAndFolderValidatorService, $q, i18nService, dataService, defaultUriSchemeUtil, featureFlagsService) {
            this.wizardViewData = wizardViewData;
            this.virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this.basicInformation = basicInformation;
            this.wizardConfig = wizardConfig;
            this.authorizationService = authorizationService;
            this.wizardPageService = wizardPageService;
            this.nameAndFolderValidatorService = nameAndFolderValidatorService;
            this.$q = $q;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.featureFlagsService = featureFlagsService;
            this.VM_NAME_MAX_LENGTH = 80;
            this.config = wizardConfig;
            this.isVMTXPhase2Enabled = this.featureFlagsService.CL_Native_VMTX_Phase2Enabled();
        }
        CloneVmBasicInformationPageModel.prototype.resetForm = function () {
        };
        CloneVmBasicInformationPageModel.prototype.changePages = function (isVMTX, isUpdateOvf) {
            if (isVMTX) {
                this.wizardPageService.markPageDisabled(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LocationPage.title'));
                this.wizardPageService.markPageDisabled(this.config.pages, this.i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Title'));
                this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LibraryItemPage.title'));
                if (this.isVMTXPhase2Enabled) {
                    this.wizardPageService.markPageDisabled(this.config.pages, this.i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Title'));
                }
                else {
                    this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Title'));
                }
            }
            else {
                this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Title'));
                this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Title'));
                if (isUpdateOvf) {
                    this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LocationPage.title'));
                    this.wizardPageService.markPageDisabled(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LibraryItemPage.title'));
                }
                else {
                    this.wizardPageService.markPageDisabled(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LocationPage.title'));
                    this.wizardPageService.markPageSkipped(this.config.pages, this.i18nService.getString('ProvisioningUiLib', 'LibraryItemPage.title'));
                }
            }
        };
        CloneVmBasicInformationPageModel.prototype.validatePage = function () {
            var nextConfirmationDeferred = this.$q.defer();
            var vmNameErrorMessage = this.checkVmName();
            if (this.basicInformation.isPrivilegeError) {
                nextConfirmationDeferred.resolve({
                    error: this.i18nService.getString('ProvisioningUiLib', 'AddToLibrary.privilege.error')
                });
            }
            else if (vmNameErrorMessage) {
                nextConfirmationDeferred.resolve({
                    error: vmNameErrorMessage
                });
            }
            else if (this.featureFlagsService.CL_Native_VMTX_Phase2Enabled() &&
                this.basicInformation.templateType === TemplateType.VM_TEMPLATE) {
                var requiredPrivileges = ['VirtualMachine.Inventory.CreateFromExisting'];
                var target = this.basicInformation.folderObjectId;
                var self1_1 = this;
                if (target && target.length !== 0) {
                    this.authorizationService.checkGrantedPrivileges(target, requiredPrivileges)
                        .then(function (hasPrivileges) {
                        var hasActionPrivileges = true;
                        for (var i = 0; i < hasPrivileges.length; i++) {
                            if (!hasPrivileges[i]) {
                                hasActionPrivileges = false;
                                nextConfirmationDeferred.resolve({
                                    error: self1_1.i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.NoCreateFromExistingPrivilegeOnFolder')
                                });
                            }
                        }
                        if (hasActionPrivileges) {
                            self1_1.doFolderValidate(nextConfirmationDeferred);
                        }
                    });
                }
                else {
                    nextConfirmationDeferred.resolve({
                        error: this.i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.specifyValidDestination.template')
                    });
                }
            }
            else {
                nextConfirmationDeferred.resolve({
                    error: null
                });
            }
            return nextConfirmationDeferred.promise;
        };
        CloneVmBasicInformationPageModel.prototype.doFolderValidate = function (nextConfirmationDeferred) {
            var self = this;
            var target = {
                uid: this.basicInformation.folderObjectId,
                type: this.basicInformation.folder.nodeTypeId,
                item: this.basicInformation.folder
            };
            this.nameAndFolderValidatorService
                .validateNameAndGetLocationUids(this.basicInformation.name, target)
                .then(function (result) {
                if (!result.validName) {
                    nextConfirmationDeferred.resolve({ error: result.validationMessage });
                }
                else if (!result.isVmFolder) {
                    nextConfirmationDeferred.resolve({
                        error: self.i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.specifyValidDestination.template')
                    });
                }
                else {
                    nextConfirmationDeferred.resolve({
                        error: null,
                        folderUid: result.folderUid,
                        datacenterUid: result.datacenterUid
                    });
                }
            });
        };
        CloneVmBasicInformationPageModel.prototype.submitPage = function (validationResult) {
            var _this = this;
            this.virtualMachineSpecBuilder.setName(this.basicInformation.name);
            if (!(this.featureFlagsService.CL_Native_VMTX_Phase2Enabled() && this.basicInformation.templateType ===
                TemplateType.VM_TEMPLATE)) {
                return {};
            }
            else if (!validationResult.datacenterUid) {
                var self_1 = this;
                this.dataService.getProperties(this.basicInformation.folderObjectId, ["dc"]).then(function (result) {
                    self_1.virtualMachineSpecBuilder.setTargetInformation(_this.basicInformation.folderObjectId, self_1.defaultUriSchemeUtil.getVsphereObjectId(result["dc"]), validationResult.folderUid, _this.basicInformation.folder.text);
                });
            }
            else {
                this.virtualMachineSpecBuilder.setTargetInformation(this.basicInformation.folderObjectId, validationResult.datacenterUid, validationResult.folderUid, this.basicInformation.folder.text);
            }
            return {};
        };
        CloneVmBasicInformationPageModel.prototype.checkVmNameLength = function (name) {
            return this.convertVmName(name).length <= this.VM_NAME_MAX_LENGTH;
        };
        CloneVmBasicInformationPageModel.prototype.convertVmName = function (name) {
            return name.replace(/%/g, '%25').replace(/\//g, '%2f').replace(/\\/g, '%2c');
        };
        CloneVmBasicInformationPageModel.prototype.checkVmName = function () {
            if (!this.basicInformation.name) {
                return this.i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.specifyValidName.template');
            }
            if (!this.checkVmNameLength(this.basicInformation.name)) {
                return this.i18nService.getString('VmUi', 'NameValidator.nameTooLongSpecialChars');
            }
            return '';
        };
        CloneVmBasicInformationPageModel.$inject = ["authorizationService",
            "wizardPageService",
            "nameAndFolderValidatorService",
            "$q",
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "featureFlagsService"];
        return CloneVmBasicInformationPageModel;
    }());
    h5_vm.CloneVmBasicInformationPageModel = CloneVmBasicInformationPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmBasicInformationPageModel", CloneVmBasicInformationPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmBasicInformationPageService = (function () {
        function CloneVmBasicInformationPageService(i18nService, vuiConstants, wizardPageService, vmVuiWizardPageBuilder, cloneVmBasicInformationPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.cloneVmBasicInformationPageModel = cloneVmBasicInformationPageModel;
        }
        CloneVmBasicInformationPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var pageModel = new this.cloneVmBasicInformationPageModel(wizardScope.wizardViewData, wizardScope.vmParams, null, wizardScope.config);
            wizardScope.cloneVmBasicInformationPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "BasicInformationPage.title"),
                contentUrl: "vm-ui/resources/vm/views/clone/clone-vm-basic-information.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.INCOMPLETE,
            });
        };
        CloneVmBasicInformationPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "cloneVmBasicInformationPageModel"
        ];
        return CloneVmBasicInformationPageService;
    }());
    h5_vm.CloneVmBasicInformationPageService = CloneVmBasicInformationPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmBasicInformationPageService", CloneVmBasicInformationPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLibraryItemPageModelFactory = (function () {
        function CloneVmLibraryItemPageModelFactory(i18nService) {
            return function (wizardScope, contentLibraryItem) {
                return new CloneVmLibraryItemPageModel(wizardScope, contentLibraryItem, i18nService);
            };
        }
        CloneVmLibraryItemPageModelFactory.$inject = ["i18nService"];
        return CloneVmLibraryItemPageModelFactory;
    }());
    var CloneVmLibraryItemPageModel = (function () {
        function CloneVmLibraryItemPageModel(wizardScope, contentLibraryItem, i18nService) {
            this.wizardScope = wizardScope;
            this.contentLibraryItem = contentLibraryItem;
            this.i18nService = i18nService;
        }
        CloneVmLibraryItemPageModel.prototype.resetForm = function () { };
        CloneVmLibraryItemPageModel.prototype.validatePage = function () {
            if (!this.wizardScope.cloneVmLibraryItemPageModel.contentLibraryItem) {
                return {
                    error: this.i18nService.getString("ProvisioningUiLib", "LibraryItemPage.error.noLibraryItemSelected")
                };
            }
            return {};
        };
        CloneVmLibraryItemPageModel.prototype.submitPage = function (validationResult) {
            return {};
        };
        CloneVmLibraryItemPageModel.$inject = [];
        return CloneVmLibraryItemPageModel;
    }());
    h5_vm.CloneVmLibraryItemPageModel = CloneVmLibraryItemPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmLibraryItemPageModel", CloneVmLibraryItemPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLibraryItemPageService = (function () {
        function CloneVmLibraryItemPageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, cloneVmLibraryItemPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.cloneVmLibraryItemPageModel = cloneVmLibraryItemPageModel;
        }
        CloneVmLibraryItemPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var pageModel = new this.cloneVmLibraryItemPageModel(wizardScope);
            wizardScope.cloneVmLibraryItemPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "LibraryItemPage.title"),
                description: this.i18nService.getString("ProvisioningUiLib", "LibraryItemPage.description"),
                contentUrl: "vm-ui/resources/vm/views/clone/clone-vm-library-item.html",
                model: pageModel
            });
        };
        ;
        CloneVmLibraryItemPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "cloneVmLibraryItemPageModel"
        ];
        return CloneVmLibraryItemPageService;
    }());
    h5_vm.CloneVmLibraryItemPageService = CloneVmLibraryItemPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmLibraryItemPageService", CloneVmLibraryItemPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLocationPageModelFactory = (function () {
        function CloneVmLocationPageModelFactory(i18nService, authorizationService) {
            return function (wizardViewData, wizardScope) {
                return new CloneVmLocationPageModel(wizardViewData, wizardScope, i18nService, authorizationService);
            };
        }
        CloneVmLocationPageModelFactory.$inject = ["i18nService", "authorizationService"];
        return CloneVmLocationPageModelFactory;
    }());
    var CloneVmLocationPageModel = (function () {
        function CloneVmLocationPageModel(wizardViewData, wizardScope, i18nService, authorizationService) {
            this.wizardViewData = wizardViewData;
            this.wizardScope = wizardScope;
            this.i18nService = i18nService;
            this.authorizationService = authorizationService;
        }
        CloneVmLocationPageModel.prototype.resetForm = function () { };
        CloneVmLocationPageModel.prototype.validatePage = function () {
            var _this = this;
            //No selection
            if (!this.wizardScope.cloneVmLocationPageModel.contentLibrary) {
                return {
                    error: this.i18nService.getString("ProvisioningUiLib", "LocationPage.error.noLibrarySelected")
                };
            }
            else {
                //Check privilege on library
                var libraryId = this.wizardScope.cloneVmLocationPageModel.contentLibrary.id;
                return this.authorizationService
                    .checkGrantedPrivileges(libraryId, [h5_vm.Privileges.ADD_LIBRARY_ITEM])
                    .then(function (hasPrivileges) {
                    var result = {};
                    if (!hasPrivileges[0]) {
                        result['error'] = _this.i18nService.getString("ProvisioningUiLib", "LocationPage.error.noPrivilege");
                    }
                    return result;
                });
            }
        };
        CloneVmLocationPageModel.prototype.submitPage = function (validationResult) {
            return {};
        };
        CloneVmLocationPageModel.$inject = [];
        return CloneVmLocationPageModel;
    }());
    h5_vm.CloneVmLocationPageModel = CloneVmLocationPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmLocationPageModel", CloneVmLocationPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLocationPageService = (function () {
        function CloneVmLocationPageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, cloneVmLocationPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.cloneVmLocationPageModel = cloneVmLocationPageModel;
        }
        CloneVmLocationPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            // todo: why the entire wizardScope and some particular properties are passed to
            // the model? In general model shouldn't need the entire wizard scope, but even
            // so, why we need to pass some wizard scope properties as well?
            var pageModel = new this.cloneVmLocationPageModel(wizardScope.wizardViewData, wizardScope);
            wizardScope.cloneVmLocationPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "LocationPage.title"),
                description: this.i18nService.getString("ProvisioningUiLib", "LocationPage.description"),
                contentUrl: "vm-ui/resources/vm/views/clone/clone-vm-location.html",
                model: pageModel
            });
        };
        ;
        CloneVmLocationPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "cloneVmLocationPageModel"
        ];
        return CloneVmLocationPageService;
    }());
    h5_vm.CloneVmLocationPageService = CloneVmLocationPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmLocationPageService", CloneVmLocationPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmReviewPageModelFactory = (function () {
        function CloneVmReviewPageModelFactory(mutationService, defaultUriSchemeUtil, wizardPageService, i18nService, featureFlagsService) {
            return function (wizardViewData, wizardScope) {
                return new CloneVmReviewPageModel(mutationService, defaultUriSchemeUtil, wizardPageService, i18nService, featureFlagsService, wizardViewData, wizardScope);
            };
        }
        CloneVmReviewPageModelFactory.$inject = [
            "mutationService",
            "defaultUriSchemeUtil",
            "wizardPageService",
            "i18nService",
            "featureFlagsService"
        ];
        return CloneVmReviewPageModelFactory;
    }());
    var CloneVmReviewPageModel = (function () {
        // wizardViewData is already part of the passed wizardScope, so consider removing
        // it as a parameter!
        function CloneVmReviewPageModel(mutationService, defaultUriSchemeUtil, wizardPageService, i18nService, featureFlagsService, wizardViewData, wizardScope) {
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
            this.featureFlagsService = featureFlagsService;
            this.wizardViewData = wizardViewData;
            this.wizardScope = wizardScope;
            this.ADD_VM_TO_LIB_SPEC = "com.vmware.vsphere.client.provisioning.spec.AddToLibrarySpec";
            this.CREATE_VMTX_SPEC = "com.vmware.vsphere.client.h5.vmtx.libraryItem.specs.CreateVmtxLibraryItemSpec";
            this.DEFAULT_STORAGE_ID = "defaultId";
            this.USE_SPECIFIED_STORAGE_POLICY = "USE_SPECIFIED_POLICY";
        }
        CloneVmReviewPageModel.prototype.resetForm = function () {
        };
        ;
        CloneVmReviewPageModel.prototype.validatePage = function () {
            return {};
        };
        ;
        CloneVmReviewPageModel.prototype.submitPage = function (validationResult) {
            if (this.wizardScope.cloneVmBasicInformationPageModel.basicInformation.templateType === h5_vm.TemplateType.VM_TEMPLATE) {
                return this.cloneVmtxTemplate();
            }
            else {
                return this.cloneOvfTemplate();
            }
        };
        ;
        CloneVmReviewPageModel.prototype.cloneOvfTemplate = function () {
            var _this = this;
            var vmId = this.wizardViewData.getSourceObjectId();
            var ovfSpec = this.getOvfSpec();
            this.wizardPageService.showLoadingIndicator(this.wizardScope.config);
            return this.mutationService.apply(vmId, this.ADD_VM_TO_LIB_SPEC, ovfSpec)
                .then(function () {
                _this.wizardPageService.hideLoadingIndicator(_this.wizardScope.config);
                return true;
            });
        };
        CloneVmReviewPageModel.prototype.getOvfSpec = function () {
            var basicInformation = this.wizardScope.cloneVmBasicInformationPageModel.basicInformation;
            var libraryId;
            var libraryItemId;
            if (basicInformation.cloneOvfType === "new") {
                libraryItemId = "";
                libraryId = this.wizardScope.cloneVmLocationPageModel.contentLibrary.id;
            }
            else {
                libraryItemId = this.wizardScope.cloneVmLibraryItemPageModel.contentLibraryItem.id;
                libraryId = this.wizardScope.cloneVmLibraryItemPageModel.contentLibraryItem.libraryId;
            }
            var exportFlags = this.wizardScope.datastorePageModel.form.isAdvancedStorageMode;
            var spec = {
                contentLibrary: libraryId,
                name: basicInformation.name,
                description: basicInformation.notes,
                libraryItem: libraryItemId,
                exportFlags: this.buildOvfExportFlagsList(basicInformation.ovfExportFlags)
            };
            return spec;
        };
        CloneVmReviewPageModel.prototype.buildOvfExportFlagsList = function (ovfExportFlags) {
            var exportFlags = [];
            if (Array.isArray(ovfExportFlags)) {
                ovfExportFlags.forEach(function (ovfExportFlag) {
                    if (ovfExportFlag.selected) {
                        exportFlags.push(ovfExportFlag.option);
                    }
                });
            }
            return exportFlags;
        };
        CloneVmReviewPageModel.prototype.cloneVmtxTemplate = function () {
            var _this = this;
            var vmId = this.wizardViewData.getSourceObjectId();
            var vmtxSpec = this.getVmtxSpec();
            this.wizardPageService.showLoadingIndicator(this.wizardScope.config);
            return this.mutationService.apply(vmId, this.CREATE_VMTX_SPEC, vmtxSpec)
                .then(function () {
                _this.wizardPageService.hideLoadingIndicator(_this.wizardScope.config);
                return true;
            });
        };
        CloneVmReviewPageModel.prototype.getVmtxSpec = function () {
            var basicInformation = this.wizardScope.cloneVmBasicInformationPageModel.basicInformation;
            var libraryId = this.wizardScope.cloneVmLocationPageModel.contentLibrary.id;
            var isAdvancedStorageMode = this.wizardScope.datastorePageModel.form.isAdvancedStorageMode;
            if (!this.wizardScope.cloneVmBasicInformationPageModel.isVMTXPhase2Enabled) {
                return _.extend({
                    contentLibrary: libraryId,
                    name: basicInformation.name,
                    description: basicInformation.notes
                }, isAdvancedStorageMode ? this.getAdvancedStorageSpec() : this.getSimpleStorageSpec());
            }
            var spec = _.extend({
                contentLibrary: libraryId,
                name: basicInformation.name,
                description: basicInformation.notes,
                folder: this.wizardScope.vmParams.getTargetInformation().folderUid
            }, isAdvancedStorageMode ? this.getAdvancedStorageSpec() : this.getSimpleStorageSpec());
            var computeResourceId = this.wizardScope.vmParams.getComputeResourceId();
            var type = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(computeResourceId).type;
            switch (type) {
                case "ClusterComputeResource":
                    return _.extend(spec, {
                        cluster: computeResourceId
                    });
                case "HostSystem":
                    return _.extend(spec, {
                        host: computeResourceId
                    });
                case "ResourcePool":
                    return _.extend(spec, {
                        resourcePool: computeResourceId
                    });
                case "VirtualApp":
                    return _.extend(spec, {
                        resourcePool: computeResourceId
                    });
                default:
                    throw new Error("Unknown compute resouce id: " + computeResourceId);
            }
        };
        CloneVmReviewPageModel.prototype.getComputeResourceInfo = function () {
            var computeResourceId = this.wizardScope.vmParams.getComputeResourceId();
            var computeResourceName = this.wizardScope.vmParams.getComputeResourceName();
            var label = this.labelForType(computeResourceId);
            return {
                name: computeResourceName,
                label: label
            };
        };
        CloneVmReviewPageModel.prototype.labelForType = function (urn) {
            var type = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(urn).type;
            switch (type) {
                case "ClusterComputeResource":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Cluster");
                case "HostSystem":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Host");
                case "ResourcePool":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                case "VirtualApp":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                default:
                    throw new Error("Unknown compute resouce id: " + urn);
            }
        };
        CloneVmReviewPageModel.prototype.getAdvancedStorageSpec = function () {
            var storageConfig = this.wizardScope.datastorePageModel.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
            var vmHomeSpec = this.getStorageSpecFromVmStorageComponent(storageConfig.vmHome);
            var diskStorageOverrideSpec = {};
            for (var index = 0; index < storageConfig.vmDisks.length; index++) {
                var vmDisk = storageConfig.vmDisks[index];
                diskStorageOverrideSpec[vmDisk.key] = this.getStorageSpecFromVmStorageComponent(vmDisk);
            }
            return {
                vmHomeStorage: vmHomeSpec,
                diskStorageOverrides: diskStorageOverrideSpec
            };
        };
        CloneVmReviewPageModel.prototype.fixStorageSpec = function (spec) {
            if (!spec || !spec.storagePolicy) {
                return;
            }
            var policy = spec.storagePolicy.policy;
            if (!policy || policy === '') {
                spec.storagePolicy = null;
            }
            return;
        };
        CloneVmReviewPageModel.prototype.getSimpleStorageSpec = function () {
            var datastorePageModelForm = this.wizardScope.datastorePageModel.form;
            var datastoreRef = datastorePageModelForm.selectedStorage.storageRef;
            var datastoreId = this.defaultUriSchemeUtil.createVmomiUri(datastoreRef.type, datastoreRef.value, datastoreRef.serverGuid);
            var selectedProfileForDisksId = datastorePageModelForm.storageProfilesData._currentVmProfileAssignment.vmHomeProfile.id;
            var hasDefaultStoragePolicy = selectedProfileForDisksId === this.DEFAULT_STORAGE_ID;
            var storageSpec = {
                datastore: datastoreId,
                storagePolicy: hasDefaultStoragePolicy ? null : {
                    type: this.USE_SPECIFIED_STORAGE_POLICY,
                    policy: selectedProfileForDisksId
                }
            };
            this.fixStorageSpec(storageSpec);
            return {
                vmHomeStorage: storageSpec,
                diskStorage: storageSpec
            };
        };
        CloneVmReviewPageModel.prototype.getStorageSpecFromVmStorageComponent = function (storageComponent) {
            var datastoreRef = storageComponent.storageObj.storageRef;
            var datastoreId = this.defaultUriSchemeUtil.createVmomiUri(datastoreRef.type, datastoreRef.value, datastoreRef.serverGuid);
            var selectedProfileId = storageComponent.storageProfile ?
                storageComponent.storageProfile.id : '';
            var hasDefaultStoragePolicy = selectedProfileId === this.DEFAULT_STORAGE_ID;
            var retVal = {
                datastore: datastoreId,
                storagePolicy: hasDefaultStoragePolicy ? null : {
                    type: this.USE_SPECIFIED_STORAGE_POLICY,
                    policy: selectedProfileId
                }
            };
            this.fixStorageSpec(retVal);
            return retVal;
        };
        CloneVmReviewPageModel.$inject = [
            "mutationService",
            "defaultUriSchemeUtil",
            "wizardPageService",
            "i18nService",
            "featureFlagsService"
        ];
        return CloneVmReviewPageModel;
    }());
    h5_vm.CloneVmReviewPageModel = CloneVmReviewPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmReviewPageModel", CloneVmReviewPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmReviewPageService = (function () {
        function CloneVmReviewPageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, cloneVmReviewPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.cloneVmReviewPageModel = cloneVmReviewPageModel;
        }
        CloneVmReviewPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            // todo: why the entire wizardScope and some prticular properties are passed to
            // the model? In general model shouldn't need the entire wizard scope, but even
            // so, why we need to pass some wizard scope properties as well?
            // in the controller of the page the page model shouldn't be accessed by
            // the provided scope, but instead we should set the page model as a property
            // to the scope, and then bind it to the page controller through html page
            // (this is the standard way we pass paramters to the components!)
            var pageModel = new this.cloneVmReviewPageModel(wizardScope.wizardViewData, wizardScope);
            wizardScope.cloneVmReviewPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "ReviewPage.title"),
                contentUrl: "vm-ui/resources/vm/views/clone/clone-vm-review.html",
                model: pageModel
            });
        };
        ;
        CloneVmReviewPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "cloneVmReviewPageModel"
        ];
        return CloneVmReviewPageService;
    }());
    h5_vm.CloneVmReviewPageService = CloneVmReviewPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmReviewPageService", CloneVmReviewPageService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .factory('addVmService', addVmService);

   addVmService.$inject = [
      'creationTypeConstants',
      'defaultUriSchemeUtil',
      'mutationService',
      'datastoreRecommendationService',
      'vscSchedulingHelper',
      'vmCreateScheduledTaskMutationService',
      '$q'
   ];

   function addVmService(
      creationTypeConstants,
      defaultUriSchemeUtil,
      mutationService,
      datastoreRecommendationService,
      vscSchedulingHelper,
      vmCreateScheduledTaskMutationService,
      $q
   ) {

      return {
         createVm: createVm,
         validateSpec: validateSpec,
         createVmScheduledTask: createVmScheduledTask
      };

      function createVm(vmParams) {
         if (!usesSdrs(vmParams)) {
            return buildVmSpec(vmParams, vmParams.getCreationType()).then(function(spec) {
               return mutationService.add(
                  getSpecType(vmParams.getCreationType()),
                  spec
               );
            });
         }
         var topRecomendationKeys = _.map(vmParams.getVmRecommendationsSpec(), function(recommendation){
            return recommendation.key;
         });
         return mutationService.add(
            'com.vmware.vsphere.client.vm.storageDrs.VmRecommendationsSpec',
            {
               recommendations: topRecomendationKeys,
               moRef: vmParams.getStorageObject().storageRef
            }
         );
      }

      function createVmScheduledTask (vmParams, scheduledTaskData) {
         return buildVmSpec(vmParams, vmParams.getCreationType()).then(function(spec) {
            var stData = createDataModelForScheduleTask(spec,
               getSpecType(vmParams.getCreationType()),
               scheduledTaskData.schedulingData);
            return vmCreateScheduledTaskMutationService.createScheduledTask(stData);
         });
      }

      function validateSpec(vmParams) {
         if(usesSdrs(vmParams)) {
            return buildVmSpec(vmParams, vmParams.getCreationType()).then(function(spec) {
               return datastoreRecommendationService.getPlacementRecommendations(
                  spec,
                  getSpecType(vmParams.getCreationType())
               );
            }).then(function(result) {
               if (!result.recommendations) {
                  return {faults: result.faults};
               }

               // Group recommendations by target
               var recommendationsPerPod = {};
               result.recommendations.forEach(function(recommendation) {
                  var targetId = defaultUriSchemeUtil.getVsphereObjectId(recommendation.target);
                  if (!recommendationsPerPod[targetId]) {
                     recommendationsPerPod[targetId] = {
                        target: recommendation.target
                     };
                     recommendationsPerPod[targetId].recommendations = [];
                  }
                  recommendationsPerPod[targetId].recommendations.push(recommendation);
               });

               var topRecommendedDatastoreForVmx = null;
               var topRecommendedDatastoresPerDisk = {};
               angular.forEach(recommendationsPerPod, function(podRecommendationsData) {
                  var topRecommendationInfo =
                        datastoreRecommendationService.findTopRecommendationInfo(
                              podRecommendationsData.recommendations);

                  podRecommendationsData.topRecommendation =
                        topRecommendationInfo.topRecommendation;
                  angular.extend(topRecommendedDatastoresPerDisk,
                        topRecommendationInfo.topRecommendedDatastorePerDisk);

                  if (!topRecommendedDatastoreForVmx) {
                     topRecommendedDatastoreForVmx =
                           topRecommendationInfo.topRecommendedDatastoreForVmx;
                  }

               });

               return {
                  recommendationsPerPod: recommendationsPerPod,
                  topRecommendedDatastoresPerDisk: topRecommendedDatastoresPerDisk,
                  topRecommendedDatastoreForVmx: topRecommendedDatastoreForVmx,
                  faults: false
               };
            });
         } else {
            return $q.when({
               topRecommendedDatastoreForVmx: defaultUriSchemeUtil.getVsphereObjectId(
                     vmParams.getStorageObject().storageRef)
            });
         }

      }

      // ------- Private -------- //

      function getSpecType(creationType) {
         if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
            return 'com.vmware.vsphere.client.vm.VmCreateSpec';
         }
         else if (creationType === creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
            return 'com.vmware.vsphere.client.h5.vmtx.libraryItem.specs.DeployVmtxLibraryItemSpec';
         }
         return 'com.vmware.vsphere.client.vm.VmCloneSpec';
      }

      function buildVmSpec(vmParams, creationType) {
         if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
            return $q.when(vmParams.getVmCreateSpec());
         }
         else if (creationType === creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
            return $q.when(vmParams.getDeployVmtxSpec());
         }
         return vmParams.getVmCloneSpec();
      }

      function usesSdrs(vmParams) {
         if (vmParams.isXvc()) {
            return false;
         }
         if (datastoreRecommendationService.areRecommendationsAvailableForStorageObject(vmParams.getStorageObject())) {
            return true;
         }

         var disks = vmParams.getStorageDiskList();
         var diskUsingSdrs = _.find(disks, function(disk) {
            return datastoreRecommendationService.areRecommendationsAvailableForStorageObject(disk.dsObject);
         });

         return angular.isDefined(diskUsingSdrs);
      }

      function createDataModelForScheduleTask(spec, _type, scheduleTaskData) {
         scheduleTaskData.spec = spec;
         scheduleTaskData.schedulingSpec.recurrence =
            vscSchedulingHelper.formatRecurrenceData(scheduleTaskData.schedulingSpec.recurrence);
         scheduleTaskData.spec._type = _type;
         return scheduleTaskData;
      }
   }

})();

angular.module('com.vmware.vsphere.client.vm').service('compatibilityCheckService', [
   'mutationService',
   'creationTypeConstants',
   'defaultUriSchemeUtil',
   'managedEntityConstants',
   'storageProfileService',
   function(mutationService,
         creationTypeConstants,
         defaultUriSchemeUtil,
         managedEntityConstants,
         storageProfileService) {
      return {
         validate: validate,
         validateComputeResource: validateComputeResource,
         validateVmPlacement: validateVmPlacement,
         validateVmPlacementForMultipleVms: validateVmPlacementForMultipleVms,
         validateVmPlacementForMultipleVmsNoFilter: validateVmPlacementForMultipleVmsNoFilter
      };

      function validate(targetId, folderId, provisioningType, vmName, vmRef,
            storageId, resPoolId, disks) {
         var spec = createCompatibilityCheckSpec(targetId, folderId, provisioningType,
               vmName, storageId, resPoolId);
         var storageRef = defaultUriSchemeUtil.getManagedObjectReference(storageId);
         if (storageRef.type === managedEntityConstants.DATASTORE && disks && disks.length) {
            spec.disks = disks;
         }

         var objectId = getTarget(provisioningType, targetId, vmRef);
         return mutationService.validate(objectId,
               'com.vmware.vsphere.client.vm.util.CompatibilityCheck', spec);
      }

      function validateComputeResource(targetId, folderId, provisioningType, vmName, vmRef, storageRefId) {
         var spec = createCompatibilityCheckSpec(targetId, folderId, provisioningType,
               vmName, storageRefId);

         var objectId = getTarget(provisioningType, targetId, vmRef);
         return mutationService.validate(objectId,
               'com.vmware.vsphere.client.vmui.provisioning.ComputeResourceCompatibilityCheckSpec',
               spec);
      }

      function validateVmPlacement(storageResourceUrn, selectedStorageProfileUniqueId) {
         return validateVmPlacementForMultipleVms([{
            storageId: storageResourceUrn,
            profile: {
               id: selectedStorageProfileUniqueId
            }
         }]);
      }

      function createCompatibilityCheckSpec(targetId, folderId,
            provisioningType, vmName, storageId, resPoolId) {
         var folderRef = null;
         if (folderId) {
            folderRef = defaultUriSchemeUtil.getManagedObjectReference(folderId);
         }

         var spec = {
            targetRef: defaultUriSchemeUtil.getManagedObjectReference(targetId),
            folderRef: folderRef,
            vmProvisioningType: provisioningType,
            vmName: vmName
         };
         if(resPoolId) {
            _.extend(spec, {
               resPoolRef:  defaultUriSchemeUtil.getManagedObjectReference(resPoolId)
            });
         }

         if (storageId) {
            var storageRef = defaultUriSchemeUtil.getManagedObjectReference(storageId);
            if (storageRef.type === managedEntityConstants.STORAGE_POD) {
               spec.podSelectionSpec = {
                  _type: 'com.vmware.vim.binding.vim.storageDrs.PodSelectionSpec',
                  storagePod: storageRef
               };
            } else if (storageRef.type === managedEntityConstants.DATASTORE) {
               spec.datastoreRef = storageRef;
            }
         }

         return spec;
      }

      function getTarget(provisioningType, targetId, vmRef) {
         var objectId;
         if (provisioningType === creationTypeConstants.CREATE_FROM_SCRATCH
               || provisioningType === creationTypeConstants.DEPLOY_VM_FROM_VAPP
               || provisioningType === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE
               || provisioningType === creationTypeConstants.DEPLOY_VM_FROM_OVF) {
            objectId = targetId;
         } else {
            objectId = vmRef;
         }
         return objectId;
      }

      function validateVmPlacementForMultipleVms(assignmentsWithProfiles) {
         var vmPlacementSpecs = [];

         _.each(assignmentsWithProfiles, function(vmStorageAssignment) {
            var dsParts = vmStorageAssignment.storageId ?
                  defaultUriSchemeUtil.getPartsFromVsphereObjectId(vmStorageAssignment.storageId) :
                  undefined;
            var profileId = null;
            if (vmStorageAssignment.profile.id && vmStorageAssignment.profile.id !== storageProfileService.DEFAULT_ID) {
               profileId = {
                  _type: 'com.vmware.vim.binding.pbm.profile.ProfileId',
                  uniqueId: vmStorageAssignment.profile.id
               };
            }
            var vmPlacementSpec = {
               profileId: profileId,
               datastore: dsParts ? {
                  type: dsParts.type,
                  value: dsParts.value,
                  serverGuid: dsParts.serverGuid
               } : undefined
            };

            vmPlacementSpecs.push(vmPlacementSpec);
         });

         var url = 'com.vmware.vsphere.client.spbm.spec.VmPlacementSpec';
         return mutationService.validateMultiSpec(url, vmPlacementSpecs).then(function(res) {
            var errors = [];
            var warnings = [];
            var initErrors = [];
            _.each(res, function(response) {
               if (response.error && !containsError(initErrors, response.error)) {
                  initErrors = initErrors.concat(response.error);
               }
               _.each(response.result, function(result) {
                  if (result.error) {
                     errors = errors.concat(result.error);
                  }
                  if (result.warning) {
                     warnings = warnings.concat(result.warning);
                  }
               });
            });
            errors = initErrors.concat(errors);
            return {
               errors: _.pluck(errors, 'localizedMessage'),
               warnings: warnings
            };
         });
      }

      /**
       * Validates assignments for multiple vms
       * @param assignmentsWithProfiles
       * @returns object containing arrays for errors and warnings.
       * Each outer array contains array with issues for each assignment sent to
       * the function.
       * If there is no issues, the nested array is empty.
       *    {
               errors: [
                  [],  - array with error objects for the first assignment from the assignmentsWithProfiles
                  [],  - array with error objects for the second assignment from the assignmentsWithProfiles
                  ...
               ],
               warnings: [
                  [],  - array with warning objects for the first assignment from the assignmentsWithProfiles
                  [],  - array with warning objects for the second assignment from the assignmentsWithProfiles
                  ...
               ]
            };
       *
       */
      function validateVmPlacementForMultipleVmsNoFilter(assignmentsWithProfiles) {
         var vmPlacementSpecs = _.map(assignmentsWithProfiles, function(vmStorageAssignment) {
            var dsRef = vmStorageAssignment.storageId ?
                  defaultUriSchemeUtil.getManagedObjectReference(vmStorageAssignment.storageId) :
                  undefined;
            var profileId = null;
            if (vmStorageAssignment.profile.id &&
                  vmStorageAssignment.profile.id !== storageProfileService.DEFAULT_ID) {
               profileId = {
                  _type: 'com.vmware.vim.binding.pbm.profile.ProfileId',
                  uniqueId: vmStorageAssignment.profile.id
               };
            }
            return {
               profileId: profileId,
               datastore: dsRef
            };
         });

         var specType = 'com.vmware.vsphere.client.spbm.spec.VmPlacementSpec';
         return mutationService.validateMultiSpec(specType, vmPlacementSpecs).then(function(res) {
            var errors = [];
            var warnings = [];
            _.each(res, function(response) {
               var currentVmErrors = [];
               var currentVmWarnings = [];
               if (response.error && !containsError(currentVmErrors, response.error)) {
                  currentVmErrors = currentVmErrors.concat(response.error);
               }
               _.each(response.result, function(result) {
                  if (result.error) {
                     currentVmErrors = currentVmErrors.concat(result.error);
                  }
                  if (result.warning) {
                     currentVmWarnings = currentVmWarnings.concat(result.warning);
                  }
               });
               errors.push(currentVmErrors);
               warnings.push(currentVmWarnings);
            });
            return {
               errors: errors,
               warnings: warnings
            };
         });
      }

      function containsError(errorList, error) {
         return _.any(errorList, function(element) {
            return element.localizedMessage === error.localizedMessage;
         });
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var CompatibilityResultsPresenter = (function () {
        function CompatibilityResultsPresenter(i18nService, dataService, $q, defaultUriSchemeUtil, managedEntityConstants) {
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.NO_HOST_REF = {
                value: "withoutHost",
                type: "HostSystem",
                serverGuid: "1-2-3-4-5"
            };
            this.NO_HOST_ID = this.defaultUriSchemeUtil.getVsphereObjectId(this.NO_HOST_REF);
            this.NO_HOST_NAME = this.i18nService.getString("VmUi", "MigrationWizard.advancedCompatibilityDialog.noHostName");
            this.NO_HOST_ICON = "vsphere-icon-host";
            this.NO_VM_ID = "withoutVm";
            this.NO_VM_NAME = this.i18nService.getString("VmUi", "MigrationWizard.advancedCompatibilityDialog.noVmName");
            this.NO_VM_ICON = "vsphere-icon-vm";
        }
        /**
         * @param includeSuccessContent
         *    Whether or not to include content corresponding to success case (i.e no
         *    errors or warnings). The default value is 'false' and means that if no
         *    errors or warnings are there to be displayed - empty content array will
         *    be returned. If the value is 'true' - the result will contain one item
         *    that can be visualized and will signify the success of the validation
         *    operation.
         *
         * @returns An array structure of elements to be visualized.
         */
        CompatibilityResultsPresenter.prototype.formatValidationResults = function (validationResultsArray, includeSuccessContent) {
            var _this = this;
            if (includeSuccessContent === void 0) { includeSuccessContent = false; }
            var affectedObjects = this.getHostsWithErrorsAffectedObjects(validationResultsArray);
            var baseProps = {};
            var noHostIdx = affectedObjects.hostIds.indexOf(this.NO_HOST_ID);
            if (noHostIdx > -1) {
                baseProps[this.NO_HOST_ID] = {
                    name: this.NO_HOST_NAME,
                    primaryIconId: this.NO_HOST_ICON
                };
                // removing the no host element before calling the dataservice
                affectedObjects.hostIds.splice(noHostIdx, 1);
            }
            var noVmIdx = affectedObjects.vmIds.indexOf(this.NO_VM_ID);
            if (noVmIdx > -1) {
                baseProps[this.NO_VM_ID] = {
                    name: this.NO_VM_NAME,
                    primaryIconId: this.NO_VM_ICON
                };
                affectedObjects.vmIds.splice(noVmIdx, 1);
            }
            if ((affectedObjects.hostIds.length === 0) &&
                (affectedObjects.vmIds.length === 0)) {
                return this.$q.when(this.formatValidationResultsInternal(validationResultsArray, _.extend({}, baseProps), includeSuccessContent));
            }
            var props = ["primaryIconId", "name"];
            return this.$q.all([
                this.dataService.getPropertiesForObjects(affectedObjects.hostIds, props),
                this.dataService.getPropertiesForObjects(affectedObjects.vmIds, props)
            ]).then(function (values) {
                return _this.formatValidationResultsInternal(validationResultsArray, _.extend({}, values[0], values[1], baseProps), includeSuccessContent);
            });
        };
        CompatibilityResultsPresenter.prototype.getHostsWithErrorsAffectedObjects = function (validationResultsArray) {
            var _this = this;
            var hosts = {};
            var vms = {};
            _.each(validationResultsArray, function (validationResult) {
                if (validationResult.error) {
                    if (validationResult.entity
                        && validationResult.entity.type === _this.managedEntityConstants.VIRTUAL_MACHINE) {
                        vms[_this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity)] = null;
                    }
                    return;
                }
                _.each(validationResult.result, function (singleResult) {
                    if (singleResult.error || singleResult.warning || singleResult.info) {
                        if (singleResult.host) {
                            hosts[_this.defaultUriSchemeUtil.getVsphereObjectId(singleResult.host)] = null;
                        }
                        var vmRef = singleResult.vm;
                        if (!vmRef && validationResult.entity
                            && validationResult.entity.type === _this.managedEntityConstants.VIRTUAL_MACHINE) {
                            vmRef = validationResult.entity;
                        }
                        if (vmRef && _this.defaultUriSchemeUtil.getVsphereObjectId(vmRef)) {
                            vms[_this.defaultUriSchemeUtil.getVsphereObjectId(vmRef)] = null;
                        }
                        else {
                            vms[_this.NO_VM_ID] = null;
                        }
                    }
                });
            });
            return { hostIds: Object.keys(hosts), vmIds: Object.keys(vms) };
        };
        CompatibilityResultsPresenter.prototype.formatValidationResultsInternal = function (validationResultsArray, propertyValuesMap, includeSuccessContent) {
            var _this = this;
            var compatItems = [];
            _.each(validationResultsArray, function (validationResult) {
                var displayItem = _this.formatSingleValidationResult(validationResult, propertyValuesMap);
                if (displayItem !== null) {
                    compatItems.push(displayItem);
                }
            });
            if (_.isEmpty(compatItems) && includeSuccessContent) {
                var successItem = {
                    icon: "vsphere-icon-status-ok",
                    message: this.i18nService.getString("VmUi", "MigrationCompatibilityResultsView.Success"),
                    contents: [],
                    advancedCompatibilityContents: {
                        hostMap: {},
                        vmId: this.NO_VM_ID,
                        vmProps: {
                            icon: this.NO_VM_ICON,
                            name: this.NO_VM_NAME
                        }
                    }
                };
                successItem.advancedCompatibilityContents.hostMap[this.NO_HOST_ID] = {
                    errors: [],
                    warnings: [],
                    infos: [],
                    props: {
                        icon: this.NO_HOST_ICON,
                        name: this.NO_HOST_NAME
                    }
                };
                compatItems.push(successItem);
            }
            return compatItems;
        };
        CompatibilityResultsPresenter.prototype.formatSingleValidationResult = function (validationResult, propertyValuesMap) {
            var compatibilityResults = validationResult.result;
            if (validationResult.error) {
                return this.handleInitErrors(validationResult, propertyValuesMap);
            }
            var resultsWithMessagesToShow = _.filter(compatibilityResults, function (result) {
                return (result.error && result.error.length > 0) ||
                    (result.warning && result.warning.length > 0) ||
                    (result.info && result.info.length > 0);
            });
            if (resultsWithMessagesToShow.length === 0) {
                return null;
            }
            var messageContent = this.buildBasicCompatibilityContents(propertyValuesMap, resultsWithMessagesToShow);
            var vmData = this.buildAdvancedCompatibilityContents(validationResult, propertyValuesMap, resultsWithMessagesToShow);
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity) ?
                this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity) : this.NO_VM_ID;
            var objectProps = propertyValuesMap[vmId];
            return {
                icon: objectProps.primaryIconId,
                message: objectProps.name,
                contents: messageContent,
                advancedCompatibilityContents: vmData
            };
        };
        CompatibilityResultsPresenter.prototype.handleInitErrors = function (validationResult, propertyValuesMap) {
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity) ?
                this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity) : this.NO_VM_ID;
            var vmName = propertyValuesMap[vmId] && propertyValuesMap[vmId].name ?
                propertyValuesMap[vmId].name : this.NO_VM_NAME;
            var vmIcon = propertyValuesMap[vmId] && propertyValuesMap[vmId].primaryIconId ?
                propertyValuesMap[vmId].primaryIconId : this.NO_VM_ICON;
            var response = {
                icon: "vsphere-icon-status-error",
                message: this.extractErrorMessage(validationResult.error),
                contents: [],
                advancedCompatibilityContents: {
                    hostMap: {},
                    vmId: vmId,
                    vmProps: {
                        name: vmName,
                        icon: vmIcon
                    }
                }
            };
            response.advancedCompatibilityContents.hostMap[this.NO_HOST_ID] = {
                errors: [
                    validationResult.error.message || validationResult.error.localizedMessage
                ],
                warnings: [],
                infos: [],
                props: {
                    name: this.NO_HOST_NAME,
                    icon: this.NO_HOST_ICON
                }
            };
            return response;
        };
        CompatibilityResultsPresenter.prototype.buildBasicCompatibilityContents = function (propertyValuesMap, resultsWithMessagesToShow) {
            var _this = this;
            var messageContent = [];
            _.each(resultsWithMessagesToShow, function (compatibilityResult) {
                var hostRef = compatibilityResult.host;
                var errorItems = _.map(compatibilityResult.error, function (msg) {
                    return {
                        icon: "vsphere-icon-status-error",
                        message: msg.message || msg.localizedMessage,
                        contents: []
                    };
                });
                var warningItems = _.map(compatibilityResult.warning, function (msg) {
                    return {
                        icon: "vsphere-icon-status-warning",
                        message: msg.message || msg.localizedMessage,
                        contents: []
                    };
                });
                var infoItems = _.map(compatibilityResult.info, function (msg) {
                    return {
                        icon: "vsphere-icon-help-info-hover",
                        message: msg.message || msg.localizedMessage,
                        contents: []
                    };
                });
                if (hostRef &&
                    _this.defaultUriSchemeUtil.getVsphereObjectId(hostRef) !== _this.NO_HOST_ID) {
                    var hostProps = propertyValuesMap[_this.defaultUriSchemeUtil.getVsphereObjectId(hostRef)];
                    messageContent.push({
                        icon: hostProps.primaryIconId,
                        message: hostProps.name,
                        contents: errorItems.concat(warningItems).concat(infoItems)
                    });
                }
                else {
                    messageContent = messageContent.concat(errorItems).concat(warningItems)
                        .concat(infoItems);
                }
            });
            return messageContent;
        };
        CompatibilityResultsPresenter.prototype.buildAdvancedCompatibilityContents = function (validationResult, propertyValuesMap, resultsWithMessagesToShow) {
            var _this = this;
            var vmMessageContentData = {};
            _.each(resultsWithMessagesToShow, function (compatibilityResult) {
                var hostRef = compatibilityResult.host;
                var errors = _.map(compatibilityResult.error, function (msg) {
                    return msg.message || msg.localizedMessage;
                });
                var warnings = _.map(compatibilityResult.warning, function (msg) {
                    return msg.message || msg.localizedMessage;
                });
                var infos = _.map(compatibilityResult.info, function (msg) {
                    return msg.message || msg.localizedMessage;
                });
                var hostId = _this.NO_HOST_ID;
                var props = {
                    name: _this.NO_HOST_NAME,
                    icon: _this.NO_HOST_ICON
                };
                if (hostRef) {
                    hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(hostRef);
                    props = {
                        name: propertyValuesMap[hostId].name,
                        icon: propertyValuesMap[hostId].primaryIconId
                    };
                }
                if (!vmMessageContentData[hostId]) {
                    vmMessageContentData[hostId] = {
                        errors: [],
                        warnings: [],
                        infos: [],
                        props: props
                    };
                }
                vmMessageContentData[hostId].errors = vmMessageContentData[hostId].errors.concat(errors);
                vmMessageContentData[hostId].warnings = vmMessageContentData[hostId].warnings.concat(warnings);
                vmMessageContentData[hostId].infos = vmMessageContentData[hostId].infos.concat(infos);
            });
            var vmData = {};
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity);
            vmData.hostMap = vmMessageContentData;
            vmData.vmId = vmId;
            if (vmId) {
                vmData.vmProps = {
                    name: propertyValuesMap[vmId].name,
                    icon: propertyValuesMap[vmId].primaryIconId
                };
            }
            else {
                vmData.vmProps = {
                    name: this.NO_VM_NAME,
                    primaryIconId: this.NO_VM_ICON
                };
            }
            return vmData;
        };
        CompatibilityResultsPresenter.prototype.extractErrorMessage = function (error) {
            var errorMessage = error.message || error.localizedMessage;
            if (!errorMessage) {
                errorMessage = error.reason ?
                    this.i18nService.getString("VmUi", "compatibilityCheck.genericError.reason", error.reason) :
                    this.i18nService.getString("VmUi", "compatibilityCheck.genericError");
            }
            return errorMessage || "";
        };
        ;
        CompatibilityResultsPresenter.$inject = [
            "i18nService",
            "dataService",
            "$q",
            "defaultUriSchemeUtil",
            "managedEntityConstants"
        ];
        return CompatibilityResultsPresenter;
    }());
    h5_vm.CompatibilityResultsPresenter = CompatibilityResultsPresenter; // class CompatibilityResultsPresenter
    angular.module("com.vmware.vsphere.client.vm").service("compatibilityResultsPresenter", CompatibilityResultsPresenter);
})(h5_vm || (h5_vm = {})); // namespace



var h5_vm;
(function (h5_vm) {
    var RegisterVmCompatibilityCheckSpec = com.vmware.vsphere.client.h5.vm.data.RegisterVmCompatibilityCheckSpec;
    var RegisterVmCompatibilityCheckService = (function () {
        function RegisterVmCompatibilityCheckService(defaultUriSchemeUtil, mutationService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
        }
        RegisterVmCompatibilityCheckService.prototype.validate = function (targetId, datastoreId, isVmTemplate) {
            this.spec = new RegisterVmCompatibilityCheckSpec();
            this.spec.targetRef = this.defaultUriSchemeUtil.getManagedObjectReference(targetId);
            this.spec.datastoreRef = this.defaultUriSchemeUtil.getManagedObjectReference(datastoreId);
            this.spec.isTemplate = isVmTemplate;
            return this.mutationService.validate(targetId, this.spec._type, this.spec);
        };
        RegisterVmCompatibilityCheckService.$inject = [
            'defaultUriSchemeUtil',
            "mutationService"
        ];
        return RegisterVmCompatibilityCheckService;
    }());
    h5_vm.RegisterVmCompatibilityCheckService = RegisterVmCompatibilityCheckService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('registerVmCompatibilityCheckService', RegisterVmCompatibilityCheckService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmCloneSpec = com.vmware.vsphere.client.vm.VmCloneSpec;
    var CloneSpec = com.vmware.vim.binding.vim.vm.CloneSpec;
    var RelocateSpec = com.vmware.vim.binding.vim.vm.RelocateSpec;
    var RelocateSpec$DiskLocator = com.vmware.vim.binding.vim.vm.RelocateSpec$DiskLocator;
    var CalculateProvisioningCostSpec = com.vmware.vsphere.client.spbm.spec.CalculateProvisioningCostSpec;
    var ProfileId = com.vmware.vim.binding.pbm.profile.ProfileId;
    var VmProvisioningStorageSelectionValidationService = (function () {
        function VmProvisioningStorageSelectionValidationService(authorizationService, compatibilityCheckService, i18nService, compatibilityResultsPresenter, $q, defaultUriSchemeUtil, mutationService, managedEntityConstants, dataService, bytesFilter, diskProvisioningService, storageProfileService) {
            this.authorizationService = authorizationService;
            this.compatibilityCheckService = compatibilityCheckService;
            this.i18nService = i18nService;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.managedEntityConstants = managedEntityConstants;
            this.dataService = dataService;
            this.bytesFilter = bytesFilter;
            this.diskProvisioningService = diskProvisioningService;
            this.storageProfileService = storageProfileService;
            this.DATASTORE_ALLOCATESPACE = "Datastore.AllocateSpace";
        }
        VmProvisioningStorageSelectionValidationService.prototype.validateSelection = function (validationModel, vmCloneSpec, vmId, folderId, vmConf, vmDisks, isVmtxWorkflow) {
            var _this = this;
            return this.$q.all({
                privilegesCheck: this.checkPrivileges(validationModel),
                compatibilityResult: this.checkCompatibility(vmId, vmCloneSpec, isVmtxWorkflow),
                placementCheck: this.checkVmPlacement(validationModel),
                provisioningCostCheck: this.requestProvisioningCost(folderId, vmConf, true, vmDisks)
            }).then(function (promisesResult) {
                var compatibilityHasSuccess = _this.getSuccessForCompatibility(promisesResult.compatibilityResult);
                _this.addToValidationResult(promisesResult.privilegesCheck, promisesResult.compatibilityResult);
                _this.addToValidationResult(promisesResult.placementCheck, promisesResult.compatibilityResult);
                _this.addToValidationResult(promisesResult.provisioningCostCheck, promisesResult.compatibilityResult);
                return _this.compatibilityResultsPresenter.formatValidationResults([promisesResult.compatibilityResult]).then(function (compatibilityMessages) {
                    if (compatibilityMessages.length > 0) {
                        // This is workaround for replacing the name of the vm,
                        // because the VC returns the source vm instead of the new one
                        if (vmCloneSpec.name) {
                            compatibilityMessages[0].message = vmCloneSpec.name;
                            compatibilityMessages[0].advancedCompatibilityContents.vmProps.name
                                = vmCloneSpec.name;
                        }
                        return {
                            compatibilityMessages: compatibilityMessages,
                            hasSuccess: compatibilityHasSuccess &&
                                promisesResult.privilegesCheck.hasSuccess &&
                                promisesResult.placementCheck.hasSuccess &&
                                promisesResult.provisioningCostCheck.hasSuccess
                        };
                    }
                    return {
                        compatibilityMessages: [{
                                icon: "vsphere-icon-status-ok",
                                message: _this.i18nService.getString("VmUi", "ProvisioningWizard.CompatibilityChecksSucceeded"),
                                contents: [],
                                advancedCompatibilityContents: {}
                            }],
                        hasSuccess: true
                    };
                });
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.getSuccessForCompatibility = function (compatibilityResult) {
            if (compatibilityResult.error) {
                return false;
            }
            return _.any(compatibilityResult.result, function (result) {
                return !result.error;
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.addToValidationResult = function (checkResult, validationResult) {
            var currentResult = {
                error: _.map(checkResult.compatibilityData.errors, function (error) {
                    return {
                        message: error,
                        localizedMessage: error
                    };
                }),
                warning: _.map(checkResult.compatibilityData.warnings, function (warning) {
                    return {
                        message: warning,
                        localizedMessage: warning
                    };
                }),
                info: _.map(checkResult.compatibilityData.infos, function (info) {
                    return {
                        message: info,
                        localizedMessage: info
                    };
                }),
                host: this.compatibilityResultsPresenter.NO_HOST_REF,
                vm: validationResult.entity
            };
            if (!currentResult.error.length && !currentResult.warning.length
                && !currentResult.info.length) {
                return;
            }
            if (!validationResult.result) {
                validationResult.result = [];
            }
            validationResult.result.push(currentResult);
        };
        VmProvisioningStorageSelectionValidationService.prototype.checkPrivileges = function (validationModel) {
            var _this = this;
            var storageIds = [];
            var storageIdsSet = {};
            _.each(validationModel.virtualDisksByVm, function (vmDisks) {
                _.each(vmDisks, function (vmDisk) {
                    var storageObj = _this.defaultUriSchemeUtil.getManagedObjectReference(vmDisk.storage);
                    if (vmDisk.storage && !storageIdsSet[vmDisk.storage] &&
                        storageObj.type === _this.managedEntityConstants.DATASTORE) {
                        storageIdsSet[vmDisk.storage] = true;
                    }
                });
            });
            storageIds = _.keys(storageIdsSet);
            return this.authorizationService.checkPrivilegesForMultipleObjects(storageIds, ["Datastore.AllocateSpace"]).then(function (privilegesMap) {
                var isAuthorized = true;
                _.each(storageIds, function (storageId) {
                    if (!privilegesMap[storageId][_this.DATASTORE_ALLOCATESPACE]) {
                        isAuthorized = false;
                    }
                });
                var response = {
                    compatibilityData: {
                        errors: [],
                        warnings: [],
                        infos: []
                    },
                    hasSuccess: true
                };
                if (!isAuthorized) {
                    response.hasSuccess = false;
                    response.compatibilityData.errors = [_this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.NoPermissionOnDatastore")];
                }
                return response;
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.checkCompatibility = function (vmId, vmCloneSpec, isVmtxWorkflow) {
            if (!vmCloneSpec.testsToRun || !vmCloneSpec.testsToRun.length || isVmtxWorkflow) {
                return this.$q.when({
                    "entity": this.defaultUriSchemeUtil.getManagedObjectReference(vmId),
                    "error": null,
                    "propertyName": null,
                    "parameter": null,
                    "result": [{
                            "vm": null,
                            "host": null,
                            "disk": null,
                            "warning": null,
                            "error": null
                        }]
                });
            }
            return this.mutationService.validate(vmId, vmCloneSpec._type, vmCloneSpec);
        };
        VmProvisioningStorageSelectionValidationService.prototype.buildVmCloneSpec = function (folder, name, vm, pool, host, vmStorageConf) {
            var tests = [];
            var vmCloneSpec = new VmCloneSpec();
            vmCloneSpec.folder = folder;
            vmCloneSpec.vm = vm;
            vmCloneSpec.name = name;
            var cloneSpec = new CloneSpec();
            cloneSpec.template = false;
            cloneSpec.powerOn = false;
            var location = new RelocateSpec();
            location.pool = pool;
            if (host.type === this.managedEntityConstants.HOST) {
                location.host = host;
            }
            if (vmStorageConf.vmHome.storageObj &&
                vmStorageConf.vmHome.storageObj.storageRef.type !==
                    this.managedEntityConstants.STORAGE_POD &&
                vm && this.defaultUriSchemeUtil.getVsphereObjectId(vm)) {
                location.datastore = vmStorageConf.vmHome.storageObj.storageRef;
                location.disk = this.buildDiskLocators(vmStorageConf);
                tests.push("datastoreTests");
            }
            vmCloneSpec.testsToRun = tests;
            cloneSpec.location = location;
            vmCloneSpec.cloneSpec = cloneSpec;
            return vmCloneSpec;
        };
        VmProvisioningStorageSelectionValidationService.prototype.buildDiskLocators = function (vmStorageConf) {
            var _this = this;
            var disks = vmStorageConf.vmDisks;
            var filteredDisks = _.filter(disks, function (disk) {
                return !_this.storageProfileService.isPmemStorageProfile(disk.storageProfile);
            });
            var result = _.map(filteredDisks, function (disk) {
                var diskLocator = new RelocateSpec$DiskLocator();
                diskLocator.diskId = disk.key;
                if (disk.storageObj && disk.storageObj.storageRef.type !==
                    _this.managedEntityConstants.STORAGE_POD) {
                    diskLocator.datastore = disk.storageObj.storageRef;
                    diskLocator.diskBackingInfo = (disk.diskFormat.type === 'sameAsSource' ?
                        null :
                        _this.diskProvisioningService.getBackingInfo(disk.diskFormat.type));
                }
                diskLocator.profile = _this.getProfileForDisk(disk);
                return diskLocator;
            });
            return _.filter(result, function (disk) {
                return disk.datastore;
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.getProfileForDisk = function (disk) {
            var diskProfileId = disk.storageProfile ? disk.storageProfile.id : undefined;
            var storageProfile = this.storageProfileService.makeProfile(diskProfileId);
            return [storageProfile];
        };
        VmProvisioningStorageSelectionValidationService.prototype.checkVmPlacement = function (validationModel) {
            var _this = this;
            var assignmentsWithProfiles = [];
            // Inspect them for profile info.
            _.each(validationModel.virtualDisksByVm, function (vmDisks) {
                _.each(vmDisks, function (disk) {
                    if (disk.profile) {
                        assignmentsWithProfiles.push({
                            storageId: disk.storage,
                            profile: disk.profile
                        });
                    }
                });
            });
            if (assignmentsWithProfiles.length === 0 || false) {
                return this.$q.resolve({
                    compatibilityData: {
                        errors: [],
                        warnings: [],
                        infos: []
                    },
                    hasSuccess: true
                });
            }
            return this.compatibilityCheckService.validateVmPlacementForMultipleVms(assignmentsWithProfiles)
                .then(function (result) {
                // In case the server returns a generic message (e.g. VSAN policy message on VC 6.0),
                // we return only that message. In case it returns a more specific message,
                // we return the specific message
                var spbmPolicyWarning = _this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpbmPolicyWarning");
                var spbmPolicyWarningAdded = false;
                var warningMessages = [];
                _.each(result.warnings, function (warning) {
                    if (!_.isEmpty(warning)) {
                        var warningMessage = warning.localizedMessage;
                        if (warningMessage === null &&
                            (warning.faultMessage !== null) &&
                            (warning.faultMessage.length > 0)) {
                            warningMessage = warning.faultMessage[0].message;
                        }
                        if (warningMessage) {
                            warningMessages.push(warningMessage);
                            return;
                        }
                    }
                    if (!spbmPolicyWarningAdded) {
                        spbmPolicyWarningAdded = true;
                        warningMessages.push(spbmPolicyWarning);
                    }
                });
                return {
                    compatibilityData: {
                        errors: result.errors,
                        warnings: warningMessages,
                        infos: []
                    },
                    hasSuccess: !result.errors.length
                };
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.validateDisksSdrsMap = function (vmStorageConf) {
            var _this = this;
            var collisionsChecker = {};
            var disks = vmStorageConf.vmDisks;
            var existCollision = _.any(disks, function (disk) {
                if (_this.isDiskPlacedOnSdrsCluster(disk)) {
                    var isSdrsEnabled_1 = _this.isSdrsEnabledValue(disk.storageObj);
                    var objId_1 = _this.defaultUriSchemeUtil.getVsphereObjectId(disk.storageObj.parentStoragePod || disk.storageObj.storageRef);
                    if (objId_1 in collisionsChecker &&
                        collisionsChecker[objId_1] !== isSdrsEnabled_1) {
                        return true;
                    }
                    collisionsChecker[objId_1] = isSdrsEnabled_1;
                }
                return false;
            });
            if (existCollision) {
                return false;
            }
            var isSdrsEnabled = this.isSdrsEnabledValue(vmStorageConf.vmHome.storageObj);
            var objId = this.defaultUriSchemeUtil.getVsphereObjectId(vmStorageConf.vmHome.storageObj.parentStoragePod || vmStorageConf.vmHome.storageObj.storageRef);
            if (objId in collisionsChecker && collisionsChecker[objId] !== isSdrsEnabled) {
                return false;
            }
            return true;
        };
        VmProvisioningStorageSelectionValidationService.prototype.isDiskPlacedOnSdrsCluster = function (disk) {
            return disk.storageObj
                && (disk.storageObj.storageRef.type === this.managedEntityConstants.STORAGE_POD
                    || disk.storageObj.parentStoragePod);
        };
        VmProvisioningStorageSelectionValidationService.prototype.isSdrsEnabledValue = function (storageObj) {
            if (storageObj.storageRef.type === this.managedEntityConstants.STORAGE_POD) {
                return true;
            }
            else {
                return !storageObj.parentStoragePod || !storageObj.parentStoragePod.isSdrsEnabled;
            }
        };
        VmProvisioningStorageSelectionValidationService.prototype.requestProvisioningCost = function (vcId, vmStorageConf, isAdvancedMode, vmDisks) {
            var _this = this;
            var specs = [];
            var containsVsan = false;
            if (!vmStorageConf) {
                return this.$q.when(this.formatDiskCostSpec([], []));
            }
            if (isAdvancedMode) {
                var disks = vmStorageConf.vmDisks;
                _.each(disks, function (disk) {
                    var diskObj = _this.getDiskObject(vmDisks, disk.key);
                    if (disk.storageObj) {
                        containsVsan = containsVsan || disk.storageObj.type === "vsan";
                        var spec_1 = _this.createCalculateProvisioningCostSpec(disk.storageProfile && disk.storageProfile.id, disk.storageObj, diskObj && diskObj.capacityInBytes ? diskObj.capacityInBytes : 0);
                        specs.push(spec_1);
                    }
                });
                // Add a spec for the VM home. The size here is irrelevant.
                var spec = this.createCalculateProvisioningCostSpec(vmStorageConf.vmHome.storageProfile && vmStorageConf.vmHome.storageProfile.id, vmStorageConf.vmHome.storageObj, 1);
                specs.push(spec);
            }
            else {
                _.each(vmDisks, function (disk) {
                    if (vmStorageConf.vmHome.storageObj) {
                        containsVsan = containsVsan || vmStorageConf.vmHome.storageObj.type === "vsan";
                        var spec = _this.createCalculateProvisioningCostSpec(vmStorageConf.vmHome.storageProfile && vmStorageConf.vmHome.storageProfile.id, vmStorageConf.vmHome.storageObj, disk.capacityInBytes);
                        specs.push(spec);
                    }
                });
            }
            if (!containsVsan) {
                return this.$q.when(this.formatDiskCostSpec([], []));
            }
            return this.dataService.getProperties(vcId, ["spbmCreateCostData"], {
                propertyParams: [{
                        propertyName: "spbmCreateCostData",
                        parameterType: "[Lcom.vmware.vsphere.client.spbm.spec.CalculateProvisioningCostSpec;",
                        parameter: specs
                    }]
            }).then(function (response) {
                return _this.formatDiskCostSpec(response.spbmCreateCostData, vmDisks);
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.getDiskObject = function (vmDisks, diskKey) {
            return _.find(vmDisks, function (disk) {
                return disk.key === diskKey;
            });
        };
        VmProvisioningStorageSelectionValidationService.prototype.createCalculateProvisioningCostSpec = function (profileId, storageObj, capacity) {
            var spec = new CalculateProvisioningCostSpec();
            spec.sizeInBytes = capacity;
            if (profileId && profileId !== "defaultId") {
                spec.profileId = new ProfileId();
                spec.profileId.uniqueId = profileId;
            }
            spec.storageContainer = storageObj.storageRef;
            return spec;
        };
        VmProvisioningStorageSelectionValidationService.prototype.formatDiskCostSpec = function (response, vmDisks) {
            if (!response || !response.length) {
                return {
                    compatibilityData: {
                        errors: [],
                        warnings: [],
                        infos: []
                    },
                    hasSuccess: true
                };
            }
            // var hasErrors:Boolean = false;
            var totalDataUsage = 0;
            var totalSsdUsage = 0;
            var isUsageInfoAvailable = false;
            // Go through each disk and check for vsan policy cost or errors
            _.each(vmDisks, function (disk, idx) {
                var costData = response[idx];
                // Check whether we have policy cost for the disk
                var policySatisfiability = costData.cost;
                if (policySatisfiability && policySatisfiability.isSatisfiable &&
                    policySatisfiability.cost) {
                    var policyCost = policySatisfiability.cost;
                    if (policyCost) {
                        isUsageInfoAvailable = true;
                        // We are interested in the projected capacity of the disk when it
                        // is fully provisioned.
                        totalDataUsage += disk.capacityInBytes *
                            policyCost.diskSpaceToAddressSpaceRatio;
                        totalSsdUsage += policyCost.currentFlashReadCacheSize +
                            policyCost.changeFlashReadCacheSize;
                    }
                }
            });
            // Shows the total VSAN consumption of the VM only when there are no
            // errors.
            var usageMessages = [];
            if (isUsageInfoAvailable) {
                usageMessages.push(this.i18nService.getString("VmUi", "whatIf.vsanConsumption", this.bytesFilter(totalDataUsage), this.bytesFilter(totalSsdUsage)));
            }
            return {
                compatibilityData: {
                    errors: [],
                    warnings: [],
                    infos: usageMessages
                },
                hasSuccess: true
            };
        };
        VmProvisioningStorageSelectionValidationService.$inject = [
            "authorizationService",
            "compatibilityCheckService",
            "i18nService",
            "compatibilityResultsPresenter",
            "$q",
            "defaultUriSchemeUtil",
            "mutationService",
            "managedEntityConstants",
            "dataService",
            "bytesFilter",
            "diskProvisioningService",
            "storageProfileService"
        ];
        return VmProvisioningStorageSelectionValidationService;
    }());
    h5_vm.VmProvisioningStorageSelectionValidationService = VmProvisioningStorageSelectionValidationService;
    angular.module("com.vmware.vsphere.client.vm").service("vmProvisioningStorageSelectionValidationService", VmProvisioningStorageSelectionValidationService);
})(h5_vm || (h5_vm = {})); // module



angular.module('com.vmware.vsphere.client.vm').service('createVmWizardService', [
   '$q',
   '$rootScope',
   '$injector',
   'vuiService',
   'i18nService',
   'dataService',
   'wizardPageService',
   'defaultUriSchemeUtil',
   'creationTypeConstants',
   'VirtualMachineSpecBuilder',
   'ProvisioningWizardViewData',
   'creationTypeServiceFactory',
   'managedEntityConstants',
   'vmCreateEditScheduledTaskService',
   'vmCloneEditScheduledTaskService',
   function (
         $q,
         $rootScope,
         $injector,
         vuiService,
         i18nService,
         dataService,
         wizardPageService,
         defaultUriSchemeUtil,
         creationTypeConstants,
         VirtualMachineSpecBuilder,
         ProvisioningWizardViewData,
         creationTypeServiceFactory,
         managedEntityConstants,
         vmCreateEditScheduledTaskService,
         vmCloneEditScheduledTaskService) {

      var contextObjectId;
      var contextObjectParts;
      var GUEST_ID_PROPERTY = 'config.guestId';
      var NAME_PROPERTY = 'name';
      var DC_PROPERTY = 'dc';
      var SERVER_GUID_PROPERTY = 'serverGuid';
      var PARENT_PROPERTY = 'parent';

      var FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY =
            'firstFolderWithCreateVmPrivilege';
      var FIRST_FOLDER_WITH_CREATE_FROM_EXISTING_VM_PRIVILEGE_PROPERTY =
            'firstFolderWithCreateFromExistingPrivilege';
      var FIRST_TEMPLATE_FOLDER_WITH_CREATE_FROM_EXISTING_PRIVILEGE_PROPERTY =
            'firstTemplateFolderWithCreateFromExistingPrivilege';
      var FIRST_FOLDER_WITH_REGISTER_VM_PRIVILEGE_PROPERTY =
            'firstFolderWithRegisterVmPrivilege';
      var FIRST_TEMPLATE_FOLDER_WITH_REGISTER_VM_PRIVILEGE_PROPERTY =
            'firstTemplateFolderWithRegisterVmPrivilege';

      var FIRST_COMPUTE_WITH_CREATE_VM_PRIVILEGE_PROPERTY =
            'firstComputeWithCreateVmPrivilege';
      var FIRST_COMPUTE_WITH_VAPP_IMPORT_PRIVILEGE_PROPERTY =
            'firstComputeWithVAppImportPrivilege';

      var SCHEDULE_TASK_EDIT_OPERATION_MODE = 1;

      var SCHEDULED_TASK_DATA_REQUEST = "scheduledTaskDataRequest";
      var CONTEXT_OBJECT_PROPERTIES_REQUEST = "contextObjectPropertiesRequest";

      var FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE;
      var FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE;

      return {
         showWizard: showWizard
      };

      function titleString(creationType, name, isTemplate) {
         var titleMap = {
            cloneVmToTemplate: 'ProvisioningTypes.CloneVmToTemplate.WizardTitle',
            cloneVappToLibrary: 'ProvisioningTypes.CloneVappToTemplate.WizardTitle',
            createVmFromScratch: 'ProvisioningTypes.CreateFromScratch.WizardTitle',
            cloneTemplateToVm: 'ProvisioningTypes.DeployFromTemplate.WizardTitle',
            deployVmFromVmtx: 'ProvisioningTypes.DeployFromVmtx.WizardTitle',
            cloneVmToVm: 'ProvisioningTypes.CloneVmToVm.WizardTitle',
            convertTemplateToVm: 'ProvisioningTypes.ConvertTemplateToVm.WizardTitle',
            cloneTemplateToTemplate: 'ProvisioningTypes.CloneTemplateToTemplate.WizardTitle',
            deployVmFromOvf: 'ProvisioningTypes.OvfDeployWizard.WizardTitle',
            registerVm: isTemplate ? 'regVm.template.title' : 'regVmWizard.tiwoDesc',
            deployVmFromTemplate: 'ProvisioningTypes.DeployFromContentLibraryTemplate.WizardTitle',
            deployVmFromVapp: 'ProvisioningTypes.DeployFromContentLibraryVapp.WizardTitle',
            cloneVmToLibrary: 'ProvisioningTypes.CloneVmToTemplate.WizardTitle',
            ScheduledTaskcreateVmFromScratch: 'ProvisioningTypes.ScheduledTask.CreateFromScratch.WizardTitle',
            ScheduledTaskEditcreateVmFromScratch: 'ProvisioningTypes.ScheduledTask.EditCreateFromScratch.WizardTitle',
            ScheduledTaskcloneVmToVm: 'ProvisioningTypes.ScheduledTask.CloneVmToVm.WizardTitle',
            ScheduledTaskEditcloneVmToVm: 'ProvisioningTypes.ScheduledTask.EditCloneVmToVm.WizardTitle'

         };
         return i18nService.getString('VmUi', titleMap[creationType] + '.2', name);
      }

      function showWizard(contextObjId, creationType, context) {
         var requests = {};
         var isScheduledTask = false;
         var scheduledTaskEditData;
         var scheduledTaskService;
         var properties = [NAME_PROPERTY, DC_PROPERTY, SERVER_GUID_PROPERTY];
         if (context && context.isScheduledTask) {
            isScheduledTask = true;
            var scheduleTaskOperationMode = context.schedulingData.scheduleTaskOperationMode;
            if (scheduleTaskOperationMode === SCHEDULE_TASK_EDIT_OPERATION_MODE) {
               if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
                  scheduledTaskService = vmCreateEditScheduledTaskService;
               }

               if (creationType === creationTypeConstants.CLONE_VM_TO_VM) {
                  scheduledTaskService = vmCloneEditScheduledTaskService;
                  properties.push(PARENT_PROPERTY);
               }

               scheduledTaskEditData = scheduledTaskService
                     .buildCreateVmData(context.schedulingData);
               contextObjId = scheduledTaskEditData.contextObjId;
               requests[SCHEDULED_TASK_DATA_REQUEST] =
                     scheduledTaskService.requestScheduledData(
                           contextObjId, scheduledTaskEditData);
            }
         }

         contextObjectId = contextObjId;
         contextObjectParts =
               defaultUriSchemeUtil.getPartsFromVsphereObjectId(contextObjectId);
         FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE = undefined;
         FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE = undefined;

         switch (contextObjectParts.type) {
            case managedEntityConstants.VIRTUAL_MACHINE:
               properties.push(GUEST_ID_PROPERTY);
               break;
            default: break;
         }
         addPropertiesPerCreationType(creationType, properties, isScheduledTask, context);

         requests[CONTEXT_OBJECT_PROPERTIES_REQUEST] = dataService.getProperties(
               contextObjectId, properties);

         $q.all(requests).then(function(responses) {
            if (context && context.hasOwnProperty('libraryItemName')) {
               responses[CONTEXT_OBJECT_PROPERTIES_REQUEST][NAME_PROPERTY] = context['libraryItemName'];
            }
            showWizardInternal(creationType, responses[CONTEXT_OBJECT_PROPERTIES_REQUEST],
                  context, isScheduledTask, scheduledTaskEditData, scheduledTaskService);
         });
      }

      function showWizardInternal(creationType, props, context, isScheduledTask,
            scheduledTaskEditData, scheduledTaskService) {
         if (isScheduledTask && contextObjectParts.type === managedEntityConstants.FOLDER) {
            var parent = props[PARENT_PROPERTY];
            if (parent.type === managedEntityConstants.DATACENTER) {
               contextObjectId = defaultUriSchemeUtil.getVsphereObjectId(parent);
               contextObjectParts =
                     defaultUriSchemeUtil.getPartsFromVsphereObjectId(contextObjectId);
            }
         }
         var wizardScope = $rootScope.$new();
         wizardScope.vmParams = new VirtualMachineSpecBuilder();
         wizardScope.wizardViewData = new ProvisioningWizardViewData();

         wizardScope.vmParams.setCreationType(creationType);
         if(creationType === creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
            wizardScope.vmParams.setLibraryItemId(context.libraryItemId);
            wizardScope.vmParams.setVmtxLibraryItemId(contextObjectId);
         }
         wizardScope.attributes = {creationType: creationType};

         if (contextObjectParts.type === managedEntityConstants.VIRTUAL_MACHINE) {
            wizardScope.vmParams.setVmId(contextObjectId);
            wizardScope.wizardViewData.setSourceObjectName(props[NAME_PROPERTY]);
            wizardScope.vmParams.setGuestOsId(props[GUEST_ID_PROPERTY]);
         }

         var isDeployFromTemplateOrVapp =
               creationTypeConstants.isDeployVmFromTemplate(creationType) ||
               creationTypeConstants.isDeployVmFromVapp(creationType);

         if (isDeployFromTemplateOrVapp) {
            wizardScope.wizardViewData.setTemplateId(contextObjectId);
         }

         var vCenterId = defaultUriSchemeUtil.getRootFolder(props[SERVER_GUID_PROPERTY]);
         wizardScope.wizardViewData.setVCenterId(vCenterId);

         var preselectFolderId = getTargetLocationId(props, creationType);
         wizardScope.wizardViewData.setDatacenterId(preselectFolderId);

         // NOTE: This should be after wizardScope.wizardViewData.setDatacenterId(preselectFolderId)
         var isTemplate = false;
         var isRegisterVm = creationTypeConstants.isRegisterVm(creationType);
         if(isRegisterVm) {
            isTemplate = context.isTemplate;
            wizardScope.vmParams.setRegisterVmData(context);
            wizardScope.vmParams.setName(context.vmName);
            wizardScope.vmParams.setStorageObject(contextObjectId);
            var objDc = props[DC_PROPERTY];
            var datacenterId = defaultUriSchemeUtil.getVsphereObjectId(objDc);
            wizardScope.wizardViewData.setDatacenterId(datacenterId);
         }

         var preselectComputeResourceId = getTargetComputeResId(creationType, props,
               isScheduledTask, scheduledTaskEditData);
         if (preselectComputeResourceId) {
            wizardScope.wizardViewData.setSourceObjectName(props[NAME_PROPERTY]);
            wizardScope.wizardViewData.setSourceObjectId(contextObjectId);
         }

         if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
            setRecommendedPreselections(props, wizardScope.wizardViewData);
         }

         if (creationTypeConstants.isCloningVmToLibrary(creationType)) {
            wizardScope.wizardViewData.setSourceObjectId(contextObjectId);
            wizardScope.vmParams.setName(props[NAME_PROPERTY]);
            //TODO: this code will be removed after clone workflow is going have folder selection page in the wizard
            if(context) {
               wizardScope.vmParams.setTargetInformation(null, null, context.folderUid, null);
            }
         }

         var preselectStorageId = getTargetStorageId();

         var creationTypeTitle = creationType;

         if (isScheduledTask) {
            wizardScope.scheduleTaskData = {
               isScheduledTask: context.isScheduledTask,
               schedulingData: context.schedulingData
            };

            var scheduleTaskOperationMode = context.schedulingData.scheduleTaskOperationMode;
            if (scheduleTaskOperationMode === SCHEDULE_TASK_EDIT_OPERATION_MODE) {
               creationTypeTitle = 'ScheduledTaskEdit' + creationType;
               if (scheduledTaskEditData) {
                  scheduledTaskService.setVmParams(
                        scheduledTaskEditData, wizardScope.vmParams, wizardScope.wizardViewData);
               }
            } else {
               creationTypeTitle = 'ScheduledTask' + creationType;
            }
         }

         wizardScope.config = {
            title: titleString(creationTypeTitle, props[NAME_PROPERTY], isTemplate),
            cssClass: 'provisioning-vm-wizards'
         };

         var provisioningService =
               creationTypeServiceFactory.serviceForCreationType(creationType);
         var result = provisioningService.buildPages(
               wizardScope, preselectFolderId,
               preselectComputeResourceId, preselectStorageId);

         wizardScope.config.pages = wizardPageService.initializePageStates(result.pages);
         wizardScope.config.flows = result.flows;

         var onFinishClicked = false;

         wizardScope.config.onFinish = function () {
            onFinishClicked = true;
            return true;
         };

         wizardScope.config.onClose = function () {
            if (onFinishClicked) {
               return;
            }

            var workflowManagerService = $injector.get('vscOvfWorkflowProxyService');
            var session = wizardScope.wizardViewData.getDeployOvfSession();
            var sessionId = (session && session.deployOvfSessionId) ? session.deployOvfSessionId : '';

            // Check to see if a session exists
            if (sessionId) {
               // Cancel session
               workflowManagerService.cancelSession$(sessionId);
            }
            // Close Wizard (Do not wait for session cancel completion)
            wizardScope.config.show = false;
         };

         wizardScope.wizardViewData.defaultTarget = preselectFolderId;

         vuiService.createWizard({
            scope: wizardScope,
            configObjectName: 'config'
         }).show();
      }

      function getTargetLocationId(props, creationType) {
         // this condition is with highest priority because in Deploy from OVF workflow
         // we have to request and consider firstFolderWithCreateVmPriv even if the
         // context object is DC or folder (because the action does not do this priv check)
         var firstFolderObjWithAppropriatePriv =
               props[FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE];
         if (creationType !== creationTypeConstants.CREATE_FROM_SCRATCH &&
               firstFolderObjWithAppropriatePriv) {
            return defaultUriSchemeUtil.getVsphereObjectId(firstFolderObjWithAppropriatePriv);
         }

         var allowedTypes = [managedEntityConstants.DATACENTER, managedEntityConstants.FOLDER];
         var objType = contextObjectParts.type;
         if (allowedTypes.indexOf(objType) > -1) {
            return contextObjectId;
         }

         // In the case of create new vm from scratch workflow, because of the possibility
         // to change the workflows, we do not know which workflow will be selected
         // and if it will have a recommended preselection or no, so for preselection we
         // use the data saved in wizardViewData object - RecommendedPreselections.
         // In the object there is a property defaultFolderId that is used in case there is no recommendation
         // available for the selected workflow and it now contains the DC of the context object.
         if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
            return undefined;
         }

         var objDc = props[DC_PROPERTY];
         return defaultUriSchemeUtil.getVsphereObjectId(objDc);
      }

      function getTargetComputeResId(creationType, props, isScheduledTask, scheduledTaskEditData) {
         var allowedTypes = [managedEntityConstants.CLUSTER, managedEntityConstants.HOST];

         var isCloneToTemplate = creationTypeConstants.isCloningToATemplate(creationType);
         if (!isCloneToTemplate) {
            allowedTypes.push(managedEntityConstants.RESOURCE_POOL);
            allowedTypes.push(managedEntityConstants.V_APP);
         }

         var objType = contextObjectParts.type;
         if (allowedTypes.indexOf(objType) > -1) {
            return contextObjectId;
         }

         // if we are editing a scheduled task, preselect the resource pool from the tasks data
         if (isScheduledTask && scheduledTaskEditData && scheduledTaskEditData.computeResourceId) {
            var crType = defaultUriSchemeUtil
                  .getEntityType(scheduledTaskEditData.computeResourceId);
            if (allowedTypes.indexOf(crType) > -1) {
               return scheduledTaskEditData.computeResourceId;
            }
         }

         var firstComputeObjWithAppropriatePriv =
               props[FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE];
         if (firstComputeObjWithAppropriatePriv) {
            return defaultUriSchemeUtil.getVsphereObjectId(firstComputeObjWithAppropriatePriv);
         }

         return undefined;
      }

      function getTargetStorageId() {
         var isStorage =
               contextObjectParts.type === managedEntityConstants.STORAGE_POD
               || contextObjectParts.type === managedEntityConstants.DATASTORE;
         return isStorage ? contextObjectId : undefined;
      }

      function addPropertiesPerCreationType(creationType, properties, isScheduledTask, context) {
         switch (creationType) {
            case creationTypeConstants.CREATE_FROM_SCRATCH:
               // in case a scheduled task for create VM is edited
               // the folder on which the device is created might be the default folder of
               // the datacenter, to check if this is the case and preselect the correct datacenter
               // we need to check if the folder's parent is a Datacenter
               if (contextObjectParts.type === managedEntityConstants.FOLDER && isScheduledTask) {
                  properties.push(PARENT_PROPERTY);
               }

               // if context object is not DC and VM Folder then request
               // firstFolderWithCreateVmPrivilege property
               if (contextObjectParts.type !== managedEntityConstants.FOLDER
                     && contextObjectParts.type !== managedEntityConstants.DATACENTER) {
                  FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE =
                        FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY;
                  properties.push(FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE);
                  properties.push(FIRST_FOLDER_WITH_CREATE_FROM_EXISTING_VM_PRIVILEGE_PROPERTY);
                  properties.push(FIRST_TEMPLATE_FOLDER_WITH_CREATE_FROM_EXISTING_PRIVILEGE_PROPERTY);
               }

               // if context object is not Cluster, Host, RP and VApp request
               // firstComputeWithCreateVmPrivilege property
               if (contextObjectParts.type !== managedEntityConstants.CLUSTER
                     && contextObjectParts.type !== managedEntityConstants.HOST
                     && contextObjectParts.type !== managedEntityConstants.RESOURCE_POOL
                     && contextObjectParts.type !== managedEntityConstants.V_APP) {
                  FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE =
                        FIRST_COMPUTE_WITH_CREATE_VM_PRIVILEGE_PROPERTY;
                  properties.push(FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE);
               }
               break;
            case creationTypeConstants.DEPLOY_VM_FROM_OVF:
               // if context object is not VM Folder then request
               // firstFolderWithCreateVmPrivilege property
               if (contextObjectParts.type !== managedEntityConstants.FOLDER) {
                  FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE =
                        FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY;
                  properties.push(FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE);
               }

               // if context object is not Cluster, Host, RP and VApp request
               // firstComputeWithVAppImportPrivilege property
               if (contextObjectParts.type !== managedEntityConstants.CLUSTER
                     && contextObjectParts.type !== managedEntityConstants.HOST
                     && contextObjectParts.type !== managedEntityConstants.RESOURCE_POOL
                     && contextObjectParts.type !== managedEntityConstants.V_APP) {
                  FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE =
                        FIRST_COMPUTE_WITH_VAPP_IMPORT_PRIVILEGE_PROPERTY;
                  properties.push(FIRST_COMPUTE_WITH_APPROPRIATE_PRIVILEGE);
               }

               break;
            default: break;
         }

         // add the properties that will recommend a folder or compute resource
         // to be preselected
         var recommendedVmFolderProperty = getPropertyToRecommendVmFolderByType(creationType, context);
         addPropertyForRecommendedFolderToBeRetrieved(contextObjectParts.type, properties, recommendedVmFolderProperty);
      }

      function addPropertyForRecommendedFolderToBeRetrieved(
            contextObjectType, properties, property) {
         // if context object is not DC and VM Folder then request the property
         // to recommend a VM folder for preselection
         if (property && contextObjectType !== managedEntityConstants.FOLDER
               && contextObjectType !== managedEntityConstants.DATACENTER) {
            FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE = property;
            properties.push(FIRST_FOLDER_WITH_APPROPRIATE_PRIVILEGE);
         }
      }

      function getPropertyToRecommendVmFolderByType(creationType, context) {
         switch (creationType) {
            case creationTypeConstants.CLONE_VM_TO_VM:
            case creationTypeConstants.CLONE_TEMPLATE_TO_VM:
               return FIRST_FOLDER_WITH_CREATE_FROM_EXISTING_VM_PRIVILEGE_PROPERTY;
            case creationTypeConstants.CLONE_VM_TO_TEMPLATE:
            case creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE:
               return FIRST_TEMPLATE_FOLDER_WITH_CREATE_FROM_EXISTING_PRIVILEGE_PROPERTY;
            case creationTypeConstants.DEPLOY_VM_FROM_OVF:
               return FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY;
            case creationTypeConstants.REGISTER_VM:
               if(context.isTemplate) {
                  return FIRST_TEMPLATE_FOLDER_WITH_REGISTER_VM_PRIVILEGE_PROPERTY;
               } else {
                  return FIRST_FOLDER_WITH_REGISTER_VM_PRIVILEGE_PROPERTY;
               }
               break;
            default: break;
         }
      }

      function setRecommendedPreselections(props, wizardViewData) {
         var recommendedPreselections = {
            createWorkflow: {},
            cloneWorkflow: {},
            templateWorkflow: {},
            defaultFolderId: ""
         };

         var objDc = props[DC_PROPERTY];
         var dcId = defaultUriSchemeUtil.getVsphereObjectId(objDc);

         if (props[FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY]) {
            recommendedPreselections.createWorkflow.folderId =
                  defaultUriSchemeUtil.getVsphereObjectId(
                        props[FIRST_FOLDER_WITH_CREATE_VM_PRIVILEGE_PROPERTY]);
         } else {
            recommendedPreselections.createWorkflow.folderId = dcId;
         }

         if (props[FIRST_FOLDER_WITH_CREATE_FROM_EXISTING_VM_PRIVILEGE_PROPERTY]) {
            recommendedPreselections.cloneWorkflow.folderId =
                  defaultUriSchemeUtil.getVsphereObjectId(
                        props[FIRST_FOLDER_WITH_CREATE_FROM_EXISTING_VM_PRIVILEGE_PROPERTY]);
         } else {
            recommendedPreselections.cloneWorkflow.folderId = dcId;
         }

         if (props[FIRST_TEMPLATE_FOLDER_WITH_CREATE_FROM_EXISTING_PRIVILEGE_PROPERTY]) {
            recommendedPreselections.templateWorkflow.folderId =
                  defaultUriSchemeUtil.getVsphereObjectId(
                        props[FIRST_TEMPLATE_FOLDER_WITH_CREATE_FROM_EXISTING_PRIVILEGE_PROPERTY]);
         } else {
            recommendedPreselections.templateWorkflow.folderId = dcId;
         }

         recommendedPreselections.defaultFolderId = dcId;

         wizardViewData
               .setRecommendedFolderAndComputeResource(recommendedPreselections);
      }
   }]);

angular.module('com.vmware.vsphere.client.vm').service('creationTypeConstants', function () {
      var constants = {
         CREATE_FROM_SCRATCH: 'createVmFromScratch',
         CLONE_VM_TO_TEMPLATE: 'cloneVmToTemplate',
         CLONE_VM_TO_VM: 'cloneVmToVm',
         CLONE_TEMPLATE_TO_VM: 'cloneTemplateToVm',
         CLONE_TEMPLATE_TO_TEMPLATE: 'cloneTemplateToTemplate',
         CONVERT_TEMPLATE_TO_VM: 'convertTemplateToVm',
         DEPLOY_VM_FROM_TEMPLATE: 'deployVmFromTemplate',
         DEPLOY_VM_FROM_VAPP: 'deployVmFromVapp',
         DEPLOY_VM_FROM_ANY_TEMPLATE: 'deployVmFromAnyTemplate',
         DEPLOY_VM_FROM_VMTX: 'deployVmFromVmtx',
         DEPLOY_VM_FROM_OVF: 'deployVmFromOvf',
         REGISTER_VM: 'registerVm',
         CLONE_AS_VMTEMPLATE_TO_LIBRARY: 'cloneVmToLibrary',
         CLONE_VAPP_AS_VMTEMPLATE_TO_LIBRARY: 'cloneVappToLibrary',
         CLONE_AS_OVFTEMPLATE_TO_LIBRARY: 'cloneAsOvfToLibrary'
      };
      return _.extend(constants, {
         isCloning: function (creationType) {
            return _.include(
               [
                  constants.CLONE_VM_TO_TEMPLATE,
                  constants.CLONE_VM_TO_VM,
                  constants.CLONE_TEMPLATE_TO_VM,
                  constants.CLONE_TEMPLATE_TO_TEMPLATE
               ],
               creationType);
         },
         isCloningFromATemplate: function (creationType) {
            return _.include([
                  constants.CLONE_TEMPLATE_TO_VM,
                  constants.CLONE_TEMPLATE_TO_TEMPLATE
               ],
               creationType);
         },
         isCloningToATemplate: function (creationType) {
            return _.include([
                  constants.CLONE_VM_TO_TEMPLATE,
                  constants.CLONE_TEMPLATE_TO_TEMPLATE
               ],
               creationType);
         },
         isRegisterVm: function(creationType) {
            return creationType === constants.REGISTER_VM;
         },
         isDeployVmFromTemplate: function (creationType) {
            return creationType === constants.DEPLOY_VM_FROM_TEMPLATE;
         },
         isDeployVmFromVapp: function (creationType) {
            return creationType === constants.DEPLOY_VM_FROM_VAPP;
         },
         isDeployVmFromVmtxTemplate: function (creationType) {
            return creationType === constants.DEPLOY_VM_FROM_VMTX;
         },
         isCloningVmToLibrary: function(creationType) {
            return creationType === constants.CLONE_AS_VMTEMPLATE_TO_LIBRARY;
         }
      });
   }
);

var h5_vm;
(function (h5_vm) {
    var CloneVappToLibraryServiceFactory = (function () {
        function CloneVappToLibraryServiceFactory(cloneVappBasicInformationPageService, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService) {
            return function () {
                return new CloneVappToLibraryService(cloneVappBasicInformationPageService, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService);
            };
        }
        CloneVappToLibraryServiceFactory.$inject = [
            "cloneVappBasicInformationPageService",
            "cloneVmLocationPageService",
            "cloneVmLibraryItemPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningDatastorePageService",
            "cloneVmReviewPageService"
        ];
        return CloneVappToLibraryServiceFactory;
    }());
    var CloneVappToLibraryService = (function () {
        function CloneVappToLibraryService(cloneVappBasicInformationController, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService) {
            this.cloneVappBasicInformationController = cloneVappBasicInformationController;
            this.cloneVmLocationPageService = cloneVmLocationPageService;
            this.cloneVmLibraryItemPageService = cloneVmLibraryItemPageService;
            this.VmProvisioningComputeResourcePageService = VmProvisioningComputeResourcePageService;
            this.vmProvisioningDatastorePageService = vmProvisioningDatastorePageService;
            this.cloneVmReviewPageService = cloneVmReviewPageService;
        }
        CloneVappToLibraryService.prototype.buildPages = function (wizardScope, defaultTargetId, preselectedComputeResourceId, preselectedStorageId) {
            var basicInformationPage = this.cloneVappBasicInformationController
                .build(wizardScope, defaultTargetId);
            var locationPage = this.cloneVmLocationPageService
                .build(wizardScope, defaultTargetId);
            var libraryItemPage = this.cloneVmLibraryItemPageService
                .build(wizardScope, defaultTargetId);
            var computeResourcePage = this.VmProvisioningComputeResourcePageService
                .build(wizardScope, preselectedComputeResourceId);
            var storagePage = this.vmProvisioningDatastorePageService
                .build(wizardScope, preselectedStorageId);
            var reviewPage = this.cloneVmReviewPageService
                .build(wizardScope, defaultTargetId);
            return {
                pages: [
                    basicInformationPage,
                    locationPage,
                    libraryItemPage,
                    computeResourcePage,
                    storagePage,
                    reviewPage
                ]
            };
        };
        CloneVappToLibraryService.$inject = [
            "cloneVappBasicInformationController",
            "cloneVmLocationPageService",
            "cloneVmLibraryItemPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningDatastorePageService",
            "cloneVmReviewPageService"
        ];
        return CloneVappToLibraryService;
    }());
    h5_vm.CloneVappToLibraryService = CloneVappToLibraryService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVappToLibraryService", CloneVappToLibraryServiceFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmToLibraryServiceFactory = (function () {
        function CloneVmToLibraryServiceFactory(cloneVmBasicInformationPageService, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService) {
            return function () {
                return new CloneVmToLibraryService(cloneVmBasicInformationPageService, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService);
            };
        }
        CloneVmToLibraryServiceFactory.$inject = [
            "cloneVmBasicInformationPageService",
            "cloneVmLocationPageService",
            "cloneVmLibraryItemPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningDatastorePageService",
            "cloneVmReviewPageService"
        ];
        return CloneVmToLibraryServiceFactory;
    }());
    var CloneVmToLibraryService = (function () {
        function CloneVmToLibraryService(cloneVmBasicInformationPageService, cloneVmLocationPageService, cloneVmLibraryItemPageService, VmProvisioningComputeResourcePageService, vmProvisioningDatastorePageService, cloneVmReviewPageService) {
            this.cloneVmBasicInformationPageService = cloneVmBasicInformationPageService;
            this.cloneVmLocationPageService = cloneVmLocationPageService;
            this.cloneVmLibraryItemPageService = cloneVmLibraryItemPageService;
            this.VmProvisioningComputeResourcePageService = VmProvisioningComputeResourcePageService;
            this.vmProvisioningDatastorePageService = vmProvisioningDatastorePageService;
            this.cloneVmReviewPageService = cloneVmReviewPageService;
        }
        CloneVmToLibraryService.prototype.buildPages = function (wizardScope, defaultTargetId, preselectedComputeResourceId, preselectedStorageId) {
            var basicInformationPage = this.cloneVmBasicInformationPageService
                .build(wizardScope, defaultTargetId);
            var locationPage = this.cloneVmLocationPageService
                .build(wizardScope, defaultTargetId);
            var libraryItemPage = this.cloneVmLibraryItemPageService
                .build(wizardScope, defaultTargetId);
            var computeResourcePage = this.VmProvisioningComputeResourcePageService
                .build(wizardScope, preselectedComputeResourceId);
            var storagePage = this.vmProvisioningDatastorePageService
                .build(wizardScope, preselectedStorageId);
            var reviewPage = this.cloneVmReviewPageService
                .build(wizardScope, defaultTargetId);
            return {
                pages: [
                    basicInformationPage,
                    locationPage,
                    libraryItemPage,
                    computeResourcePage,
                    storagePage,
                    reviewPage
                ]
            };
        };
        CloneVmToLibraryService.$inject = [
            "cloneVmBasicInformationPageService",
            "cloneVmLocationPageService",
            "cloneVmLibraryItemPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningDatastorePageService",
            "cloneVmReviewPageService"
        ];
        return CloneVmToLibraryService;
    }());
    h5_vm.CloneVmToLibraryService = CloneVmToLibraryService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("cloneVmToLibraryService", CloneVmToLibraryServiceFactory);
})(h5_vm || (h5_vm = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .service('CloneVmToTemplateService', CloneVmToTemplateService);

   CloneVmToTemplateService.$inject = [
      'vmProvisioningDatastorePageService',
      'vmProvisioningNameAndFolderPageService',
      'vmProvisioningFinishCloneVmPageService',
      'VmProvisioningComputeResourcePageService'
   ];

   function CloneVmToTemplateService(vmProvisioningDatastorePageService,
                                       vmProvisioningNameAndFolderPageService,
                                       vmProvisioningFinishCloneVmPageService,
                                       VmProvisioningComputeResourcePageService) {
      return function () {
         this.buildPages = buildPages;

         function buildPages(wizardScope, defaultTarget, preselectedComputeResource) {
            var namePage = vmProvisioningNameAndFolderPageService.build(wizardScope, defaultTarget);
            var computeResourcePage = VmProvisioningComputeResourcePageService.build(wizardScope, preselectedComputeResource);
            var datastorePage = vmProvisioningDatastorePageService.build(wizardScope);
            var finishCloneVmPage = vmProvisioningFinishCloneVmPageService.build(wizardScope);

            return {
               pages: [
                  namePage,
                  computeResourcePage,
                  datastorePage,
                  finishCloneVmPage
               ]
            };
         }
      };
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .service('CloneVmToVmService', CloneVmToVmService);

   CloneVmToVmService.$inject = [
      'vuiConstants',
      'vmProvisioningDatastorePageService',
      'vmProvisioningCloneOptionsPageService',
      'vmProvisioningUserSettingsPageService',
      'vmProvisioningFinishCloneVmPageService',
      'vmProvisioningNameAndFolderPageService',
      'VmProvisioningComputeResourcePageService',
      'vmProvisioningCloneCustomizeGuestOsPageService',
      'vmProvisioningCustomizeHardwarePageService',
      'vmCreateScheduleTaskPageService'
   ];

   function CloneVmToVmService (
      vuiConstants,
      vmProvisioningDatastorePageService,
      vmProvisioningCloneOptionsPageService,
      vmProvisioningUserSettingsPageService,
      vmProvisioningFinishCloneVmPageService,
      vmProvisioningNameAndFolderPageService,
      VmProvisioningComputeResourcePageService,
      vmProvisioningCloneCustomizeGuestOsPageService,
      vmProvisioningCustomizeHardwarePageService,
      vmCreateScheduleTaskPageService
   ) {
      return function() {
         this.buildPages = buildPages;

         function buildPages (wizardScope, defaultTarget, preselectedComputeResource) {
            var namePage = vmProvisioningNameAndFolderPageService.build(wizardScope, defaultTarget);
            var computeResourcePage = VmProvisioningComputeResourcePageService.build(wizardScope, preselectedComputeResource);
            var datastorePage = vmProvisioningDatastorePageService.build(wizardScope);
            var cloneOptionsPage = vmProvisioningCloneOptionsPageService.build(wizardScope);
            var customizeGuestOSPage = vmProvisioningCloneCustomizeGuestOsPageService.build(wizardScope);
            var userSettingsPage = vmProvisioningUserSettingsPageService.build(wizardScope);
            var customizeHardwarePage = vmProvisioningCustomizeHardwarePageService.build(wizardScope);
            customizeHardwarePage.defaultState = vuiConstants.wizard.pageState.SKIPPED;
            var finishCloneVmPage = vmProvisioningFinishCloneVmPageService.build(wizardScope);

            var pages = [
               namePage,
               computeResourcePage,
               datastorePage,
               cloneOptionsPage,
               customizeGuestOSPage,
               userSettingsPage,
               customizeHardwarePage,
               finishCloneVmPage
            ];
            if (wizardScope.scheduleTaskData
               && wizardScope.scheduleTaskData.isScheduledTask) {
               var scheduleTaskPage = vmCreateScheduleTaskPageService.build(wizardScope);
               pages.splice(0, 0, scheduleTaskPage);
               cloneOptionsPage.defaultState = vuiConstants.wizard.pageState.SKIPPED;
            }
            return {
               pages: pages
            };
         }
      };
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('convertTemplateToVmService', convertTemplateToVmService);

   convertTemplateToVmService.$inject = ['VmProvisioningComputeResourcePageService',
      'vmProvisioningFinishConvertToVmPageService'];

   function convertTemplateToVmService(VmProvisioningComputeResourcePageService,
         vmProvisioningFinishConvertToVmPageService) {
      return function() {
         this.buildPages = buildPages;

         function buildPages(wizardScope, defaultTargetId, preselectedComputeResource) {
            var dcId = wizardScope.wizardViewData.getDatacenterId();
            wizardScope.vmParams
                  .setTargetInformation(null, dcId , null, null);

            var computeResourcePage = VmProvisioningComputeResourcePageService.build(
                  wizardScope, preselectedComputeResource);
            var finishPage = vmProvisioningFinishConvertToVmPageService.build(
                  wizardScope);

            return {
               pages: [
                  computeResourcePage,
                  finishPage
               ]
            };
         }
      };
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var CreateVmChangeCreationTypeService = (function () {
        function CreateVmChangeCreationTypeService(i18nService, vuiConstants, wizardPageService, creationTypeConstants) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.creationTypeConstants = creationTypeConstants;
        }
        CreateVmChangeCreationTypeService.prototype.changeCreationType = function (wizardScope, selectedCreationType, previouslySelectedType) {
            // If not specified extract the previously type from wizard state.
            var oldCreationType = previouslySelectedType ?
                previouslySelectedType.creationType :
                wizardScope.vmParams.getCreationType();
            if (wizardScope.config.currentPage.decisionOptions) {
                wizardScope.config.currentPage.decisionOptions.selectedFlowId = selectedCreationType.creationType;
            }
            this.setSkippedPages(wizardScope, selectedCreationType.creationType);
            wizardScope.attributes.creationType = selectedCreationType.creationType;
            wizardScope.vmParams.setCreationType(selectedCreationType.creationType);
            if (selectedCreationType.creationType !== oldCreationType) {
                wizardScope.config.title = selectedCreationType.wizardTitle;
                //set recreateVm to true so that when the creation type is changed
                //and the customize hardware page is visited again the configuration in vmParams
                //will be loaded with the new data
                wizardScope.vmParams.setRecreateVm(true);
                //set customize hardware flag to false, so that when the page has been visited
                //and then a flow is selected, that does not use the customize hardware page,
                //the information set in it will not be used
                wizardScope.vmParams.setCustomizeCloneHardware(false);
                this.wizardPageService.initializeFlowStates(wizardScope.config.flows);
            }
        };
        /**
         * If the flow is `Clone vm to vm` or `Clone template to vm`
         * by default the `Customize hardware` page and `Customize Guest OS` page are skipped
         * If they have been previously enabled on the `Clone options` page (visible only in those two flows)
         * then those pages are marked as disabled
         * In all other flows those pages are disabled
         * @param flows
         * @param creationType
         */
        CreateVmChangeCreationTypeService.prototype.setSkippedPages = function (wizardScope, creationType) {
            var _this = this;
            var flows = wizardScope.config.flows;
            //is the flow `Clone vm to vm` or `Clone template to vm`
            var isCreateVmFlow = (creationType === this.creationTypeConstants.CLONE_VM_TO_VM
                || creationType === this.creationTypeConstants.DEPLOY_VM_FROM_VAPP
                || creationType === this.creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE
                || creationType === this.creationTypeConstants.CLONE_TEMPLATE_TO_VM);
            //find the selected flow
            var selectedFlow = _.find(flows, function (flow) { return flow.id === creationType; });
            if (selectedFlow) {
                //retrieve the options set in the `Clone options` page
                var cloneOptions = wizardScope.vmParams.getCloneOptions() || {};
                var customizeHardwarePage = _.find(selectedFlow.pages, function (page) {
                    return page.title ===
                        _this.i18nService.getString("VmUi", "CustomizeHardwareProvisioningPage.Title");
                });
                if (customizeHardwarePage) {
                    //set `Customize hardware` page as disabled for all flows
                    customizeHardwarePage.defaultState = this.vuiConstants.wizard.pageState.DISABLED;
                    //if the flow is `Clone vm to vm` or `Clone template to vm`
                    //and customize hardware page has not been previou\sly enabled on the `Clone options` page
                    //skip the page
                    if (isCreateVmFlow && !wizardScope.vmParams.getCustomizeCloneHardware()) {
                        customizeHardwarePage.defaultState = this.vuiConstants.wizard.pageState.SKIPPED;
                    }
                }
                var customizeGuestOsPage = _.find(selectedFlow.pages, function (page) {
                    return page.title ===
                        _this.i18nService.getString("VmUi", "CustomizeGuestOsProvisioningPage.Title");
                });
                if (customizeGuestOsPage) {
                    //set `Customize Guest OS` page as disabled for all flows
                    customizeGuestOsPage.defaultState = this.vuiConstants.wizard.pageState.DISABLED;
                    //if the flow is `Clone vm to vm` or `Clone template to vm`
                    //and customize guest os page page has not been previously enabled on the `Clone options` page
                    //skip the page
                    if (isCreateVmFlow && !cloneOptions.customizeOs) {
                        customizeGuestOsPage.defaultState = this.vuiConstants.wizard.pageState.SKIPPED;
                    }
                }
            }
        };
        CreateVmChangeCreationTypeService.$inject = [
            "i18nService",
            "vuiConstants",
            "wizardPageService",
            "creationTypeConstants"
        ];
        return CreateVmChangeCreationTypeService;
    }());
    h5_vm.CreateVmChangeCreationTypeService = CreateVmChangeCreationTypeService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("createVmChangeCreationTypeService", CreateVmChangeCreationTypeService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('CreateVmFromScratchService', CreateVmFromScratchService);

   CreateVmFromScratchService.$inject = [
      'wizardPageService',
      'creationTypeConstants',
      'vmProvisioningGuestOsPageService',
      'vmProvisioningDatastorePageService',
      'vmProvisioningNetworkPageService',
      'vmProvisioningNameAndFolderPageService',
      'vmProvisioningFinishCloneVmPageService',
      'vmProvisioningFinishCreateVmPageService',
      'vmProvisioningSelectAnyTemplatePageService',
      'VmProvisioningComputeResourcePageService',
      'vmProvisioningProductDetailsPageService',
      'vmProvisioningSelectVmVersionPageService',
      'vmProvisioningSelectVmToClonePageService',
      'vmProvisioningSelectTemplatePageService',
      'vmProvisioningSelectTemplateToConvertPageService',
      'vmProvisioningFinishConvertToVmPageService',
      'vmProvisioningCustomizeHardwarePageService',
      'vmProvisioningSelectCreationTypePageService',
      'vmProvisioningFinishDeployTemplatePageService',
      'vmProvisioningCloneOptionsPageService',
      'vmProvisioningCloneCustomizeGuestOsPageService',
      'vmProvisioningUserSettingsPageService',
      'VmProvisioningEulaPageService',
      'VmProvisioningDeploymentOptionsPageService',
      'vmCreateScheduleTaskPageService'
   ];

   function CreateVmFromScratchService(
         wizardPageService,
         creationTypeConstants,
         vmProvisioningGuestOsPageService,
         vmProvisioningDatastorePageService,
         vmProvisioningNetworkPageService,
         vmProvisioningNameAndFolderPageService,
         vmProvisioningFinishCloneVmPageService,
         vmProvisioningFinishCreateVmPageService,
         vmProvisioningSelectAnyTemplatePageService,
         VmProvisioningComputeResourcePageService,
         vmProvisioningProductDetailsPageService,
         vmProvisioningSelectVmVersionPageService,
         vmProvisioningSelectVmToClonePageService,
         vmProvisioningSelectTemplatePageService,
         vmProvisioningSelectTemplateToConvertPageService,
         vmProvisioningFinishConvertToVmPageService,
         vmProvisioningCustomizeHardwarePageService,
         vmProvisioningSelectCreationTypePageService,
         vmProvisioningFinishDeployTemplatePageService,
         vmProvisioningCloneOptionsPageService,
         vmProvisioningCloneCustomizeGuestOsPageService,
         vmProvisioningUserSettingsPageService,
         VmProvisioningEulaPageService,
         VmProvisioningDeploymentOptionsPageService,
         vmCreateScheduleTaskPageService) {
      return function() {
         this.buildPages = buildPages;

         function buildPages(wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var nameAndFolderPage = vmProvisioningNameAndFolderPageService.build(wizardScope, defaultTarget);
            var computeResourcePage = VmProvisioningComputeResourcePageService.build(wizardScope, preselectedComputeResource);
            var productDetails = vmProvisioningProductDetailsPageService.build(wizardScope, preselectedComputeResource);
            var datastorePage = vmProvisioningDatastorePageService.build(wizardScope, preselectedStorage);
            var networkPage = vmProvisioningNetworkPageService.build(wizardScope);
            var selectAnyTemplatePage = vmProvisioningSelectAnyTemplatePageService.build(wizardScope);
            var selectVmVersionPage = vmProvisioningSelectVmVersionPageService.build(wizardScope);
            var guestOSPage = vmProvisioningGuestOsPageService.build(wizardScope);
            var customizeHardwarePage = vmProvisioningCustomizeHardwarePageService.build(wizardScope);
            var finishCreateVmPage = vmProvisioningFinishCreateVmPageService.build(wizardScope);
            var finishCloneVmPage = vmProvisioningFinishCloneVmPageService.build(wizardScope);
            var selectVMToClonePage = vmProvisioningSelectVmToClonePageService.build(wizardScope);
            var selectVcTemplatePage = vmProvisioningSelectTemplatePageService.build(wizardScope);
            var selectVcTemplateToConvertPage = vmProvisioningSelectTemplateToConvertPageService.build(wizardScope);
            var finishTemplatePage = vmProvisioningFinishConvertToVmPageService.build(wizardScope);
            var finishDeployFromTemplatePage = vmProvisioningFinishDeployTemplatePageService.build(wizardScope, preselectedComputeResource);
            var cloneOptionsPage = vmProvisioningCloneOptionsPageService.build(wizardScope);
            var customizeGuestOSPage = vmProvisioningCloneCustomizeGuestOsPageService.build(wizardScope);
            var userSettingsPage = vmProvisioningUserSettingsPageService.build(wizardScope);
            var eulaPage = VmProvisioningEulaPageService.build(wizardScope);
            var deploymentOptions = VmProvisioningDeploymentOptionsPageService.build(wizardScope);

            var flows = [
               {
                  id: creationTypeConstants.CREATE_FROM_SCRATCH,
                  pages: [
                     nameAndFolderPage,
                     computeResourcePage,
                     datastorePage,
                     selectVmVersionPage,
                     guestOSPage,
                     customizeHardwarePage,
                     finishCreateVmPage
                  ]
               },
               {
                  id: creationTypeConstants.DEPLOY_VM_FROM_ANY_TEMPLATE,
                  pages: [selectAnyTemplatePage]
               },{
                  id: creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE,
                  pages: [
                     nameAndFolderPage,
                     customizeGuestOSPage,
                     userSettingsPage,
                     computeResourcePage,
                     productDetails,
                     eulaPage,
                     deploymentOptions,
                     datastorePage,
                     networkPage,
                     finishDeployFromTemplatePage
                  ],
                  parentWorkflow: creationTypeConstants.DEPLOY_VM_FROM_ANY_TEMPLATE
               }, {
                  id: creationTypeConstants.CLONE_TEMPLATE_TO_VM,
                  pages: [
                     nameAndFolderPage,
                     computeResourcePage,
                     datastorePage,
                     cloneOptionsPage,
                     customizeGuestOSPage,
                     userSettingsPage,
                     customizeHardwarePage,
                     finishCloneVmPage
                  ],
                  parentWorkflow: creationTypeConstants.DEPLOY_VM_FROM_ANY_TEMPLATE
               },
               {
                  id: creationTypeConstants.CLONE_VM_TO_VM,
                  pages: [
                     selectVMToClonePage,
                     nameAndFolderPage,
                     computeResourcePage,
                     datastorePage,
                     cloneOptionsPage,
                     customizeGuestOSPage,
                     userSettingsPage,
                     customizeHardwarePage,
                     finishCloneVmPage
                  ]
               },
               {
                  id: creationTypeConstants.CLONE_VM_TO_TEMPLATE,
                  pages: [
                     selectVMToClonePage,
                     nameAndFolderPage,
                     computeResourcePage,
                     datastorePage,
                     finishCloneVmPage
                  ]
               },
               {
                  id: creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE,
                  pages: [
                     selectVcTemplatePage,
                     nameAndFolderPage,
                     computeResourcePage,
                     datastorePage,
                     finishCloneVmPage
                  ]
               },
               {
                  id: creationTypeConstants.CONVERT_TEMPLATE_TO_VM,
                  pages: [
                     selectVcTemplateToConvertPage,
                     computeResourcePage,
                     finishTemplatePage
                  ]
               }
            ];

            if (wizardScope.scheduleTaskData
               && wizardScope.scheduleTaskData.isScheduledTask) {
               flows = flows.splice(0, 1); // only CREATE_FROM_SCRATCH in case of scheduled task
            }

            flows = wizardPageService.initializeFlowStates(flows);

            var pages = [
               vmProvisioningSelectCreationTypePageService.build(wizardScope, _.map(flows, function(flow) {
                  return flow.id;
               }))
            ];

            if (wizardScope.scheduleTaskData  &&
               wizardScope.scheduleTaskData.isScheduledTask) {
               var scheduleTaskPage = vmCreateScheduleTaskPageService.build(wizardScope);
               pages.splice(0, 0, scheduleTaskPage);
            }

            return {
               pages: pages,
               flows: flows
            };
         }
      };
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('creationTypeServiceFactory', creationTypeServiceFactory);

   creationTypeServiceFactory.$inject = [
      'CloneVmToVmService',
      'creationTypeConstants',
      'CloneVmToTemplateService',
      'CreateVmFromScratchService',
      'convertTemplateToVmService',
      'DeployVmFromOvfService',
      'registerVmService',
      'deployVmFromTemplateService',
      'cloneVmToLibraryService',
      'cloneVappToLibraryService'
   ];

   function creationTypeServiceFactory(CloneVmToVmService,
         creationTypeConstants,
         CloneVmToTemplateService,
         CreateVmFromScratchService,
         convertTemplateToVmService,
         DeployVmFromOvfService,
         registerVmService,
         deployVmFromTemplateService,
         cloneVmToLibraryService,
         cloneVappToLibraryService) {
      var service = {};
      service.serviceForCreationType = serviceForCreationType;

      return service;

      function serviceForCreationType(creationType) {
         switch(creationType) {
            case creationTypeConstants.CREATE_FROM_SCRATCH:
               return new CreateVmFromScratchService();
            case creationTypeConstants.DEPLOY_VM_FROM_OVF:
               return new DeployVmFromOvfService();
            case creationTypeConstants.DEPLOY_VM_FROM_VAPP:
            case creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE:
               return deployVmFromTemplateService;
            case creationTypeConstants.CLONE_VM_TO_TEMPLATE:
            case creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE:
               return new CloneVmToTemplateService();
            case creationTypeConstants.CLONE_TEMPLATE_TO_VM:
            case creationTypeConstants.CLONE_VM_TO_VM:
            case creationTypeConstants.DEPLOY_VM_FROM_VMTX:
               return new CloneVmToVmService();
            case creationTypeConstants.CONVERT_TEMPLATE_TO_VM:
               return new convertTemplateToVmService();
            case creationTypeConstants.REGISTER_VM:
               return new registerVmService();
            case creationTypeConstants.CLONE_AS_VMTEMPLATE_TO_LIBRARY:
               return new cloneVmToLibraryService();
            case creationTypeConstants.CLONE_VAPP_AS_VMTEMPLATE_TO_LIBRARY:
               return new cloneVappToLibraryService();
            default:
               var message = "Unknown creation type '" + creationType + "'";
               throw new Error(message);
         }
      }
   }
})();

var h5_vm;
(function (h5_vm) {
    var DeployVmFromTemplateService = (function () {
        function DeployVmFromTemplateService(contentLibraryService, vmProvisioningNameAndFolderPageService, vmProvisioningCloneCustomizeGuestOsPageService, VmProvisioningComputeResourcePageService, vmProvisioningProductDetailsPageService, VmProvisioningEulaPageService, VmProvisioningDeploymentOptionsPageService, vmProvisioningDatastorePageService, vmProvisioningNetworkPageService, vmProvisioningFinishDeployTemplatePageService, vmProvisioningCustomizeTemplatePageService, vmProvisioningScaleoutConfigurationPageService, vmProvisioningVservicePageService, vmProvisioningUserSettingsPageService) {
            this.contentLibraryService = contentLibraryService;
            this.vmProvisioningNameAndFolderPageService = vmProvisioningNameAndFolderPageService;
            this.vmProvisioningCloneCustomizeGuestOsPageService = vmProvisioningCloneCustomizeGuestOsPageService;
            this.VmProvisioningComputeResourcePageService = VmProvisioningComputeResourcePageService;
            this.vmProvisioningProductDetailsPageService = vmProvisioningProductDetailsPageService;
            this.VmProvisioningEulaPageService = VmProvisioningEulaPageService;
            this.VmProvisioningDeploymentOptionsPageService = VmProvisioningDeploymentOptionsPageService;
            this.vmProvisioningDatastorePageService = vmProvisioningDatastorePageService;
            this.vmProvisioningNetworkPageService = vmProvisioningNetworkPageService;
            this.vmProvisioningFinishDeployTemplatePageService = vmProvisioningFinishDeployTemplatePageService;
            this.vmProvisioningCustomizeTemplatePageService = vmProvisioningCustomizeTemplatePageService;
            this.vmProvisioningScaleoutConfigurationPageService = vmProvisioningScaleoutConfigurationPageService;
            this.vmProvisioningVservicePageService = vmProvisioningVservicePageService;
            this.vmProvisioningUserSettingsPageService = vmProvisioningUserSettingsPageService;
            this.TEMPLATE_NAME_PROPERTY = "com.vmware.content.library.ItemModel/name";
            this.LIBRARY_NAME_PROPERTY = "com.vmware.content.library.ItemModel/libraryName";
            this.GOS_TYPE_PROPERTY = "com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osType";
            this.GOS_DESCRIPTION_PROPERTY = "com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osDescription";
        }
        DeployVmFromTemplateService.prototype.buildPages = function (wizardScope, defaultTargetId, preselectedComputeResourceId, preselectedStorageId) {
            this.appendTemplateDetailsToWizardScope(wizardScope);
            var nameAndFolderPage = this.vmProvisioningNameAndFolderPageService
                .build(wizardScope, defaultTargetId);
            var customizeGuestOSPage = this.vmProvisioningCloneCustomizeGuestOsPageService
                .build(wizardScope);
            var userSettingsPage = this.vmProvisioningUserSettingsPageService.build(wizardScope);
            var computeResourcePage = this.VmProvisioningComputeResourcePageService
                .build(wizardScope, preselectedComputeResourceId);
            var productDetailsPage = this.vmProvisioningProductDetailsPageService
                .build(wizardScope, preselectedComputeResourceId);
            var eulaPage = this.VmProvisioningEulaPageService
                .build(wizardScope);
            var deploymentOptionsPage = this.VmProvisioningDeploymentOptionsPageService
                .build(wizardScope);
            var datastorePage = this.vmProvisioningDatastorePageService
                .build(wizardScope, preselectedStorageId);
            var networkPage = this.vmProvisioningNetworkPageService
                .build(wizardScope);
            var finishDeployFromTemplatePage = this.vmProvisioningFinishDeployTemplatePageService
                .build(wizardScope, preselectedComputeResourceId);
            var scaleoutPage = this.vmProvisioningScaleoutConfigurationPageService.build(wizardScope, defaultTargetId, preselectedComputeResourceId);
            var customizeTemplatePage = this.vmProvisioningCustomizeTemplatePageService.build(wizardScope);
            var vservicePage = this.vmProvisioningVservicePageService.build(wizardScope, defaultTargetId, preselectedComputeResourceId);
            return {
                pages: [
                    nameAndFolderPage,
                    customizeGuestOSPage,
                    userSettingsPage,
                    computeResourcePage,
                    productDetailsPage,
                    eulaPage,
                    deploymentOptionsPage,
                    scaleoutPage,
                    datastorePage,
                    networkPage,
                    customizeTemplatePage,
                    vservicePage,
                    finishDeployFromTemplatePage
                ]
            };
        };
        DeployVmFromTemplateService.prototype.appendTemplateDetailsToWizardScope = function (wizardScope) {
            var _this = this;
            var templateId = wizardScope.wizardViewData.getTemplateId();
            this.contentLibraryService.getTemplateData(templateId)
                .then(function (response) {
                var template = {
                    templateName: response[_this.TEMPLATE_NAME_PROPERTY],
                    libraryName: response[_this.LIBRARY_NAME_PROPERTY],
                    templateId: templateId,
                    gosType: response[_this.GOS_TYPE_PROPERTY],
                    gosDescription: response[_this.GOS_DESCRIPTION_PROPERTY]
                };
                wizardScope.wizardViewData.setSelectedTemplate(template);
            });
        };
        DeployVmFromTemplateService.$inject = [
            "contentLibraryService",
            "vmProvisioningNameAndFolderPageService",
            "vmProvisioningCloneCustomizeGuestOsPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningProductDetailsPageService",
            "VmProvisioningEulaPageService",
            "VmProvisioningDeploymentOptionsPageService",
            "vmProvisioningDatastorePageService",
            "vmProvisioningNetworkPageService",
            "vmProvisioningFinishDeployTemplatePageService",
            "vmProvisioningCustomizeTemplatePageService",
            "vmProvisioningScaleoutConfigurationPageService",
            "vmProvisioningVservicePageService",
            "vmProvisioningUserSettingsPageService"
        ];
        return DeployVmFromTemplateService;
    }());
    h5_vm.DeployVmFromTemplateService = DeployVmFromTemplateService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("deployVmFromTemplateService", DeployVmFromTemplateService);
})(h5_vm || (h5_vm = {}));



(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .service('DeployVmFromOvfService', DeployVmFromOvfService);

   DeployVmFromOvfService.$inject = [
      'vmProvisioningSelectOvfPageService',
      'vmProvisioningNameAndFolderPageService',
      'VmProvisioningComputeResourcePageService',
      'vmProvisioningProductDetailsPageService',
      'vmProvisioningScaleoutConfigurationPageService',
      'vmProvisioningDatastorePageService',
      'vmProvisioningNetworkPageService',
      'vmProvisioningFinishDeployTemplatePageService',
      'VmProvisioningEulaPageService',
      'VmProvisioningDeploymentOptionsPageService',
      'vmProvisioningCustomizeTemplatePageService',
      'vmProvisioningVservicePageService'
   ];

   function DeployVmFromOvfService(vmProvisioningSelectOvfPageService,
                                   vmProvisioningNameAndFolderPageService,
                                   VmProvisioningComputeResourcePageService,
                                   vmProvisioningProductDetailsPageService,
                                   vmProvisioningScaleoutConfigurationPageService,
                                   vmProvisioningDatastorePageService,
                                   vmProvisioningNetworkPageService,
                                   vmProvisioningFinishDeployTemplatePageService,
                                   VmProvisioningEulaPageService,
                                   VmProvisioningDeploymentOptionsPageService,
                                   vmProvisioningCustomizeTemplatePageService,
                                   vmProvisioningVservicePageService) {
      return function () {
         this.buildPages = buildPages;

         function buildPages(wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var selectOvfPage = vmProvisioningSelectOvfPageService.build(
               wizardScope,
               defaultTarget,
               preselectedComputeResource);
            var namePage = vmProvisioningNameAndFolderPageService.build(
               wizardScope,
               defaultTarget);
            var computeResourcePage = VmProvisioningComputeResourcePageService.build(
               wizardScope,
               preselectedComputeResource);
            var deploymentOptions = VmProvisioningDeploymentOptionsPageService.build(
               wizardScope);
            var productDetails = vmProvisioningProductDetailsPageService.build(
               wizardScope,
               preselectedComputeResource);
            var eulaPage = VmProvisioningEulaPageService.build(
               wizardScope);
            var scaleoutPage = vmProvisioningScaleoutConfigurationPageService.build(
               wizardScope,
               defaultTarget,
               preselectedComputeResource
            );
            var storagePage = vmProvisioningDatastorePageService.build(
               wizardScope,
               preselectedStorage);
            var networkPage = vmProvisioningNetworkPageService.build(
               wizardScope);
            var customizeTemplatePage = vmProvisioningCustomizeTemplatePageService.build(
               wizardScope);
            var vservicePage = vmProvisioningVservicePageService.build(
                  wizardScope,
                  defaultTarget,
                  preselectedComputeResource);
            var readyToComplete = vmProvisioningFinishDeployTemplatePageService.build(
               wizardScope,
               preselectedComputeResource);
            return {
               pages: [
                  selectOvfPage,
                  namePage,
                  computeResourcePage,
                  productDetails,
                  eulaPage,
                  deploymentOptions,
                  scaleoutPage,
                  storagePage,
                  networkPage,
                  customizeTemplatePage,
                  vservicePage,
                  readyToComplete
               ]
            };
         }
      };
   }
})();


var h5_vm;
(function (h5_vm) {
    var RegisterVmServiceFactory = (function () {
        function RegisterVmServiceFactory(vmProvisioningNameAndFolderPageService, VmProvisioningComputeResourcePageService, vmProvisioningFinishRegisterPageService) {
            return function () {
                return new RegisterVmService(vmProvisioningNameAndFolderPageService, VmProvisioningComputeResourcePageService, vmProvisioningFinishRegisterPageService);
            };
        }
        RegisterVmServiceFactory.$inject = [
            "vmProvisioningNameAndFolderPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningFinishRegisterPageService"
        ];
        return RegisterVmServiceFactory;
    }());
    var RegisterVmService = (function () {
        function RegisterVmService(vmProvisioningNameAndFolderPageService, VmProvisioningComputeResourcePageService, vmProvisioningFinishRegisterPageService) {
            this.vmProvisioningNameAndFolderPageService = vmProvisioningNameAndFolderPageService;
            this.VmProvisioningComputeResourcePageService = VmProvisioningComputeResourcePageService;
            this.vmProvisioningFinishRegisterPageService = vmProvisioningFinishRegisterPageService;
        }
        RegisterVmService.prototype.buildPages = function (wizardScope, defaultTargetId, preselectedComputeResourceId) {
            var dcId = wizardScope.wizardViewData.getDatacenterId();
            wizardScope.vmParams.setTargetInformation(null, dcId, null, null);
            var nameAndLocationPage = this.vmProvisioningNameAndFolderPageService
                .build(wizardScope, defaultTargetId);
            var computeResourcePage = this.VmProvisioningComputeResourcePageService
                .build(wizardScope, preselectedComputeResourceId);
            var finishPage = this.vmProvisioningFinishRegisterPageService
                .build(wizardScope);
            return {
                pages: [
                    nameAndLocationPage,
                    computeResourcePage,
                    finishPage
                ]
            };
        };
        RegisterVmService.$inject = [
            "vmProvisioningNameAndFolderPageService",
            "VmProvisioningComputeResourcePageService",
            "vmProvisioningFinishRegisterPageService"];
        return RegisterVmService;
    }());
    h5_vm.RegisterVmService = RegisterVmService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("registerVmService", RegisterVmServiceFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DiskModeService = (function () {
        function DiskModeService(i18nService) {
            this.i18nService = i18nService;
        }
        DiskModeService.prototype.getModeName = function (diskMode) {
            switch (diskMode) {
                case DiskModeService.PERSISTENT:
                case DiskModeService.NONPERSISTENT:
                    return this.i18nService
                        .getString('VmUi', 'ProvisioningWizardSummaryPage.DiskModeDependent');
                case DiskModeService.UNDOABLE:
                    return this.i18nService
                        .getString('VmUi', 'ProvisioningWizardSummaryPage.DiskModeUndoable');
                case DiskModeService.INDEPENDANT_PERSISTENT:
                    return this.i18nService
                        .getString('VmUi', 'ProvisioningWizardSummaryPage.DiskModeIndependentPersistent');
                case DiskModeService.INDEPENDENT_NONPERSISTENT:
                    return this.i18nService
                        .getString('VmUi', 'ProvisioningWizardSummaryPage.DiskModeIndependentNonpersistent');
                case DiskModeService.APPEND:
                    return this.i18nService
                        .getString('VmUi', 'ProvisioningWizardSummaryPage.DiskModeAppend');
            }
            return '';
        };
        DiskModeService.$inject = ['i18nService'];
        DiskModeService.PERSISTENT = 'persistent';
        DiskModeService.NONPERSISTENT = 'nonpersistent';
        DiskModeService.UNDOABLE = 'undoable';
        DiskModeService.INDEPENDANT_PERSISTENT = 'independent_persistent';
        DiskModeService.INDEPENDENT_NONPERSISTENT = 'independent_nonpersistent';
        DiskModeService.APPEND = 'append';
        return DiskModeService;
    }());
    h5_vm.DiskModeService = DiskModeService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('diskModeService', DiskModeService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('guestOsCustomizationSpecValidator', guestOsCustomizationSpecValidatorService);

   guestOsCustomizationSpecValidatorService.$inject = ['$q', 'i18nService', 'mutationService'];
   function guestOsCustomizationSpecValidatorService($q, i18nService, mutationService) {

      var unknownIPv4GeneratorType = "com.vmware.vim.binding.vim.vm.customization.UnknownIpGenerator";
      var unknownIPv6GeneratorType = "com.vmware.vim.binding.vim.vm.customization.UnknownIpV6Generator";

      return {
         validate: function(vmId, vmName, specName) {
            return mutationService.validate(
                  vmId, 'java.lang.String', angular.toJson(specName)
            ).then(parseValidationResponse);

            function parseValidationResponse(validationResponse) {

               var error = validateResponse(validationResponse, specName, vmName);
               if (error) {
                  return $q.reject({
                     error: error
                  });
               }
               var result = validationResponse.result;
               if (!result) {
                  return {};
               }
               // Note: we do this to make sure there are no old specs.
               if (result.spec && result.spec.options && result.spec.options.deleteAccounts) {
                  result.spec.options.deleteAccounts = false;
               }

               var nicsToCustomize = _.map(result.spec.nicSettingMap, function(nicSettings) {
                  return {
                     ipv4: mapIPv4Input(nicSettings.adapter),
                     ipv6: mapIPv6Input(nicSettings.adapter)
                  };
               });
               return {
                  spec: result.spec,
                  info: result.info,
                  specName: result.specInfoName,

                  nicsToCustomize: nicsToCustomize,

                  needsComputerName: result.hasUnknownNameTypeGen,
                  needsAnyNICSettings: _.any(nicsToCustomize, function(nic) {
                     return nic.ipv4.required || nic.ipv6.required;
                  })
               };
            }
         }
      };

      function mapIPv4Input(adapter) {
         var ipv4Spec = adapter.ip;
         var ipv4 = {
            required: !!ipv4Spec && ipv4Spec._type === unknownIPv4GeneratorType,
            address: '',
            subnetMask: adapter.subnetMask ? adapter.subnetMask : '',
            defaultGateway: (adapter.gateway && adapter.gateway.length > 0) ? adapter.gateway[0] : '',
            alternateGateway: (adapter.gateway && adapter.gateway.length > 1) ? adapter.gateway[1] : ''
         };
         return ipv4;
      }

      function mapIPv6Input(adapter) {
         var ipv6Spec = adapter.ipV6Spec;
         var ipv6 = {
            required: !!ipv6Spec && !!ipv6Spec.ip && ipv6Spec.ip.length > 0
                        && ipv6Spec.ip[0]._type === unknownIPv6GeneratorType,
            address: '',
            subnetPrefixLength: '64',
            gateway: ipv6Spec && ipv6Spec.gateway ? ipv6Spec.gateway : []
         };
         return ipv6;
      }

      function areNicsCorrect(result) {
         return result.areTypicalNetworkingSettingsUsed || result.isNetworkCardsCountTheSame;
      }

      function validateResponse(validationResponse, specName, vmName) {
         if (validationResponse.error) {
            return validationResponse.error.localizedMessage;
         }
         var result = validationResponse.result;

         if (result && !areNicsCorrect(result)) {
            return i18nService.getString('VmUi',
                  'CustomizeGuestOsProvisioningPage.content.incorrectNicCountError',
                  specName,
                  vmName);
         }

         if (result && !result.isPublicKeyTheSame) {
            return i18nService.getString('VmUi',
                  'CustomizeGuestOsProvisioningPage.content.invalidPublicKeyError');
         }

         return "";
      }
   }
}());

var h5_vm;
(function (h5_vm) {
    var ValidateNameSpec = com.vmware.vsphere.client.h5.vm.ValidateNameSpec;
    var NameAndFolderValidatorService = (function () {
        function NameAndFolderValidatorService(defaultUriSchemeUtil, managedEntityConstants, mutationService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.mutationService = mutationService;
            this.VM_FOLDER_VALUE = "group-v";
            this.HOST_FOLDER_VALUE = "group-h";
        }
        NameAndFolderValidatorService.prototype.validateNameAndGetLocationUids = function (newVmName, selectedTarget) {
            var _this = this;
            var vmNameSpec = this.buildValidateNameSpec(newVmName, selectedTarget);
            return this.mutationService.validateSpec(vmNameSpec._type, vmNameSpec)
                .then(function (result) {
                var validationResult = result.result;
                return {
                    folderUid: _this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.vmFolderRef),
                    datacenterUid: _this.getDatacenter(selectedTarget),
                    validName: validationResult.error === null,
                    validationMessage: validationResult.error,
                    isVmFolder: _this.checkVmFolder(selectedTarget)
                };
            });
        };
        NameAndFolderValidatorService.prototype.isVmFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            var folderType = folderRef.type;
            var folderValue = folderRef.value;
            return (folderType === this.managedEntityConstants.FOLDER &&
                folderValue.indexOf(this.VM_FOLDER_VALUE) !== -1);
        };
        NameAndFolderValidatorService.prototype.isHostFolder = function (folderId) {
            var folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(folderId);
            var folderType = folderRef.type;
            var folderValue = folderRef.value;
            return (folderType === this.managedEntityConstants.FOLDER
                && folderValue.indexOf(this.HOST_FOLDER_VALUE) !== -1);
        };
        NameAndFolderValidatorService.prototype.buildValidateNameSpec = function (newVmName, selectedTarget) {
            var targetParts = this.defaultUriSchemeUtil
                .getPartsFromVsphereObjectId(selectedTarget.uid);
            var selectedTargetRef = this.defaultUriSchemeUtil
                .getManagedObjectReference(selectedTarget.uid);
            var nameSpec = new ValidateNameSpec();
            nameSpec.name = newVmName;
            var targetType = targetParts ? targetParts.type : selectedTarget.type;
            if (targetType === this.managedEntityConstants.DATACENTER) {
                nameSpec.datacenterRef = selectedTargetRef;
            }
            else {
                nameSpec.folderRef = selectedTargetRef;
            }
            return nameSpec;
        };
        NameAndFolderValidatorService.prototype.getDatacenter = function (selectedTarget) {
            var targetParts = this.defaultUriSchemeUtil
                .getPartsFromVsphereObjectId(selectedTarget.uid);
            var targetType = targetParts ? targetParts.type : selectedTarget.type;
            if (targetType === this.managedEntityConstants.DATACENTER) {
                return selectedTarget.uid;
            }
            var item = selectedTarget.item;
            while (!_.isEmpty(item) &&
                this.defaultUriSchemeUtil.getEntityType(item.objRef) === this.managedEntityConstants.FOLDER) {
                item = item.parentNode();
                if (!item) {
                    return "";
                }
                if (this.defaultUriSchemeUtil.getEntityType(item.objRef) === this.managedEntityConstants.DATACENTER) {
                    break;
                }
            }
            return item.objRef;
        };
        NameAndFolderValidatorService.prototype.checkVmFolder = function (selectedTarget) {
            var targetParts = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(selectedTarget.uid);
            var targetType = targetParts ? targetParts.type : selectedTarget.type;
            if (targetType === this.managedEntityConstants.DATACENTER) {
                return true;
            }
            return this.isVmFolder(selectedTarget.uid);
        };
        NameAndFolderValidatorService.$inject = ["defaultUriSchemeUtil", "managedEntityConstants", "mutationService"];
        return NameAndFolderValidatorService;
    }());
    h5_vm.NameAndFolderValidatorService = NameAndFolderValidatorService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("nameAndFolderValidatorService", NameAndFolderValidatorService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var ProvisioningWizardViewData = (function () {
        function ProvisioningWizardViewData() {
            this._viewData = {};
            this.SCALEOUT_CONFIGURATION_TYPE = "com.vmware.vcenter.ovf.ScaleOutParams";
            this.NETWORK_MAPPING_PARAMS_TYPE = "com.vmware.vcenter.ovf.NetworkMappingParams";
            this.IP_ALLOCATION_PARAMS_TYPE = "com.vmware.vcenter.ovf.IpAllocationParams";
            this.USER_PROPERTY_PARAM_TYPE = "com.vmware.vcenter.ovf.PropertyParams";
            this.VSERVICE_PROPERTY_PARAM_TYPE = "com.vmware.vcenter.ovf.VServiceParams";
        }
        ProvisioningWizardViewData.prototype.setSourceObjectName = function (name) {
            this._viewData.sourceObjectName = name;
        };
        ProvisioningWizardViewData.prototype.getSourceObjectName = function () {
            return this._viewData.sourceObjectName;
        };
        ProvisioningWizardViewData.prototype.setSourceObjectId = function (id) {
            this._viewData.sourceObjectId = id;
        };
        ProvisioningWizardViewData.prototype.getSourceObjectId = function () {
            return this._viewData.sourceObjectId;
        };
        ProvisioningWizardViewData.prototype.setVmConnectedState = function (state) {
            this._viewData.vmConnectedState = state;
        };
        ProvisioningWizardViewData.prototype.getVmConnectedState = function () {
            return this._viewData.vmConnectedState;
        };
        ProvisioningWizardViewData.prototype.setStorageProfiles = function (profiles) {
            this._viewData.storageProfiles = profiles;
        };
        ProvisioningWizardViewData.prototype.getStorageProfiles = function () {
            return this._viewData.storageProfiles;
        };
        ProvisioningWizardViewData.prototype.setStorageNameMap = function (storageIdToNameMap) {
            this._viewData.storageIdToNameMap = storageIdToNameMap;
        };
        ProvisioningWizardViewData.prototype.getStorageNameMap = function () {
            return this._viewData.storageIdToNameMap;
        };
        ProvisioningWizardViewData.prototype.setDiskFormatLabel = function (diskFormatLabel) {
            this._viewData.diskFormatLabel = diskFormatLabel;
        };
        ProvisioningWizardViewData.prototype.getDiskFormatLabel = function () {
            return this._viewData.diskFormatLabel;
        };
        ProvisioningWizardViewData.prototype.setCustomizationSpecName = function (name) {
            this._viewData.cuztomizationSpecName = name;
        };
        ProvisioningWizardViewData.prototype.getCustomizationSpecName = function () {
            return this._viewData.cuztomizationSpecName;
        };
        ProvisioningWizardViewData.prototype.setDatastoreObjectName = function (name) {
            this._viewData.datastoreObjectName = name;
        };
        ProvisioningWizardViewData.prototype.getDatastoreObjectName = function () {
            return this._viewData.datastoreObjectName;
        };
        ProvisioningWizardViewData.prototype.setGuestOsType = function (type) {
            this._viewData.guestOsType = type;
        };
        ProvisioningWizardViewData.prototype.getGuestOsType = function () {
            return this._viewData.guestOsType;
        };
        ProvisioningWizardViewData.prototype.setStorageLocatorItemsData = function (storage) {
            this._viewData.storageLocatorItemsData = storage;
        };
        ProvisioningWizardViewData.prototype.getStorageLocatorItemsData = function () {
            return this._viewData.storageLocatorItemsData;
        };
        ProvisioningWizardViewData.prototype.setNeedToInputComputerName = function (need) {
            this._viewData.needInputComputerName = need;
        };
        ProvisioningWizardViewData.prototype.getNeedToInputComputerName = function () {
            return !!this._viewData.needInputComputerName;
        };
        ProvisioningWizardViewData.prototype.setNICsToCustomize = function (nicsToCustomize) {
            this._viewData.nicsToCustomize = nicsToCustomize;
        };
        ProvisioningWizardViewData.prototype.getNICsToCustomize = function () {
            return this._viewData.nicsToCustomize;
        };
        ProvisioningWizardViewData.prototype.setDatacenterId = function (id) {
            this._viewData.datacenterId = id;
        };
        ProvisioningWizardViewData.prototype.getDatacenterId = function () {
            return this._viewData.datacenterId;
        };
        ProvisioningWizardViewData.prototype.setVCenterId = function (id) {
            this._viewData.vCenterId = id;
        };
        ProvisioningWizardViewData.prototype.getVCenterId = function () {
            return this._viewData.vCenterId;
        };
        ProvisioningWizardViewData.prototype.setSelectedTemplate = function (template) {
            this._viewData.selectedTemplate = template;
        };
        ProvisioningWizardViewData.prototype.getSelectedTemplate = function () {
            return this._viewData.selectedTemplate;
        };
        ProvisioningWizardViewData.prototype.setUrlTemplate = function (urlTemplate) {
            this._viewData.urlTemplate = urlTemplate;
        };
        ProvisioningWizardViewData.prototype.getUrlTemplate = function () {
            return this._viewData.urlTemplate;
        };
        ProvisioningWizardViewData.prototype.setTemplateSourceType = function (sourceType) {
            this._viewData.sourceType = sourceType;
        };
        ProvisioningWizardViewData.prototype.getTemplateSourceType = function () {
            return this._viewData.sourceType;
        };
        ProvisioningWizardViewData.prototype.setResourcePoolDeploymentResponse = function (response) {
            this._viewData.resourcePoolDeploymentResponse = response;
        };
        ProvisioningWizardViewData.prototype.getResourcePoolDeploymentResponse = function () {
            return this._viewData.resourcePoolDeploymentResponse;
        };
        ProvisioningWizardViewData.prototype.setDeployFromLibraryCommonContext = function (context) {
            this._viewData.commonContext = context;
        };
        ProvisioningWizardViewData.prototype.getDeployFromLibraryCommonContext = function () {
            return this._viewData.commonContext;
        };
        ProvisioningWizardViewData.prototype.getSclaeoutConfigurationFromLibraryCommonContext = function () {
            var _this = this;
            return _.find(this._viewData.commonContext, function (item) {
                return (_.isEqual(item._type, _this.SCALEOUT_CONFIGURATION_TYPE));
            });
        };
        ProvisioningWizardViewData.prototype.getVserviceContextFromLibraryCommonContext = function () {
            var _this = this;
            return _.find(this._viewData.commonContext, function (item) {
                return (_.isEqual(item._type, _this.VSERVICE_PROPERTY_PARAM_TYPE));
            });
        };
        ProvisioningWizardViewData.prototype.getDatastoreMappingParamsFromLibraryCommonContext = function () {
            var datastoreMappingParams = _.find(this._viewData.commonContext, function (item) {
                return item._type === "com.vmware.vcenter.ovf.DatastoreMappingParams";
            });
            return datastoreMappingParams;
        };
        ProvisioningWizardViewData.prototype.getNetworkMappingParamsFromLibraryCommonContext = function () {
            var _this = this;
            var networkMappingParams = _.find(this._viewData.commonContext, function (item) {
                return item._type === _this.NETWORK_MAPPING_PARAMS_TYPE;
            });
            return networkMappingParams;
        };
        ProvisioningWizardViewData.prototype.getIpAllocationParamsFromLibraryCommonContext = function () {
            var _this = this;
            var ipAllocationParams = _.find(this._viewData.commonContext, function (item) {
                return item._type === _this.IP_ALLOCATION_PARAMS_TYPE;
            });
            return ipAllocationParams;
        };
        ProvisioningWizardViewData.prototype.getCustomizeTemplateFromLibraryCommonContext = function () {
            var _this = this;
            var customizeTemplates = _.find(this._viewData.commonContext, function (item) {
                return item._type === _this.USER_PROPERTY_PARAM_TYPE;
            });
            return customizeTemplates;
        };
        ProvisioningWizardViewData.prototype.setCustomizeTemplateCommonContext = function (newCustomizeTemplateData) {
            var _this = this;
            var customizeTemplates = _.find(this._viewData.commonContext, function (item) {
                return item._type === _this.USER_PROPERTY_PARAM_TYPE;
            });
            var index = this._viewData.commonContext.indexOf(customizeTemplates);
            if (index > 1) {
                this._viewData.commonContext.splice(index, 1);
                this._viewData.commonContext.push(newCustomizeTemplateData);
            }
        };
        ProvisioningWizardViewData.prototype.setCustomizeGosSpecData = function (customizeGosSpecData) {
            this._viewData.customizeGosSpecData = customizeGosSpecData;
        };
        ProvisioningWizardViewData.prototype.getCustomizeGosSpecData = function () {
            return this._viewData.customizeGosSpecData;
        };
        ProvisioningWizardViewData.prototype.setDeployOvfSession = function (ovfSession) {
            this._viewData.ovfSession = ovfSession;
        };
        ProvisioningWizardViewData.prototype.getDeployOvfSession = function () {
            return this._viewData.ovfSession;
        };
        ProvisioningWizardViewData.prototype.setTemplateId = function (templateId) {
            this._viewData.templateId = templateId;
        };
        ProvisioningWizardViewData.prototype.getTemplateId = function () {
            return this._viewData.templateId;
        };
        ProvisioningWizardViewData.prototype.getSslThumbprint = function () {
            return this._viewData.sslThumbprint;
        };
        ProvisioningWizardViewData.prototype.setSslThumbprint = function (sslThumbprint) {
            this._viewData.sslThumbprint = sslThumbprint;
        };
        ProvisioningWizardViewData.prototype.setRecommendedFolderAndComputeResource = function (recommendedPreselections) {
            this._viewData.recommendedPreselections = recommendedPreselections;
        };
        ProvisioningWizardViewData.prototype.getRecommendedFolderAndComputeResource = function () {
            return this._viewData.recommendedPreselections;
        };
        return ProvisioningWizardViewData;
    }());
    h5_vm.ProvisioningWizardViewData = ProvisioningWizardViewData;
    angular.module("com.vmware.vsphere.client.vm")
        .factory("ProvisioningWizardViewData", function () { return ProvisioningWizardViewData; });
})(h5_vm || (h5_vm = {}));



/* Copyright 2016-2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   "use strict";
   angular
         .module('com.vmware.vsphere.client.vm')
         .constant('sourceTypeConstants', {
            SOURCE_TYPE_CONTENTLIB: 'CONTENT_LIBRARY_SOURCE',
            SOURCE_TYPE_PULL:       'PULL_SOURCE',
            SOURCE_TYPE_PUSH:       'PUSH_SOURCE',

            PUSH_TYPE_OVF:          'OVF_SOURCE',
            PUSH_TYPE_OVA:          'OVA_SOURCE',

            PUSH_OVF_OPTION_MF:     'MANIFEST',
            PUSH_OVF_OPTION_MFCERT: 'MANIFEST_CERTIFICATE',
            PUSH_OVF_OPTION_NONE:   'NONE'
         });
}());


angular.module('com.vmware.vsphere.client.vm').service('resourcePoolLookupService', [
   'dataService',
   'managedEntityConstants',
   'defaultUriSchemeUtil',
   function (dataService, managedEntityConstants, defaultUriSchemeUtil) {
      return {
         lookupResourcePoolForComputeResource: function (computeResourceId) {
            if (isAResourcePoolOrVapp(computeResourceId)) {
               return dataService.getProperties(computeResourceId, ['runtime']);
            } else if (isCluster(computeResourceId)){
               return dataService.getPropertiesByRelation(computeResourceId,
                     'parent',
                     managedEntityConstants.RESOURCE_POOL,
                     ['runtime']
               ).then(function (computeResourceProperties) {
                  return formatClusterResult(computeResourceProperties);
               });
            } else if (isHostSystem(computeResourceId)) {
               return dataService.getData(computeResourceId,
                     "com.vmware.vsphere.client.h5.vm.model.HostResourcePoolData"
               ).then(function(computeResourceProperties) {
                  return formatHostResult(computeResourceProperties);
               });
            }
         }
      };

      function isAResourcePoolOrVapp(computeResourceId) {
         var computeResourceType =
               defaultUriSchemeUtil.getPartsFromVsphereObjectId(computeResourceId).type;

         var isARpOrVapp = computeResourceType === managedEntityConstants.RESOURCE_POOL
               || computeResourceType === managedEntityConstants.V_APP;
         return isARpOrVapp;
      }

      function isHostSystem(computeResourceId) {
         var computeResourceType =
               defaultUriSchemeUtil.getPartsFromVsphereObjectId(computeResourceId).type;

         return computeResourceType === managedEntityConstants.HOST;
      }

      function isCluster(computeResourceId) {
         var computeResourceType =
               defaultUriSchemeUtil.getPartsFromVsphereObjectId(computeResourceId).type;

         return computeResourceType === managedEntityConstants.CLUSTER;
      }

      /**
       * Formats the dataService result object to what the world expects this
       * service to return.
       * @param resultObject {
       *    "vmomiUri": the name of the field is the uri of the resourcePool
       *     It has a property "runtime", which is the RP's runtime object
       * }
       * @returns {
       *    id: uri of the resourcePool
       *    runtime: Rp's runtime object
       * }
       */
      function formatClusterResult(resultObject) {
         var result = {};
         for (var objectId in resultObject) {
            if (resultObject.hasOwnProperty(objectId)) {
               result.id = objectId;
            }
         }
         if (resultObject[result.id]
               && resultObject[result.id].runtime) {
            result.runtime = resultObject[result.id].runtime;
         }
         return result;
      }

      /**
       * Formats the dataService result object to what the world expects this
       * service to return.
       * @param resultObject {
       *    rpId: MOR of the resource pool
       *    rpRuntime: RP's runtime object
       * }
       * @returns {
       *    id: uri of the resourcePool
       *    runtime: Rp's runtime object
       * }
       */
      function formatHostResult(resultObject) {
         if (!resultObject && !resultObject.rpId && !resultObject.rpRuntime) {
            return {
               id: null,
               runtime: null
            };
         }

         var id = defaultUriSchemeUtil.getVsphereObjectId(resultObject.rpId);

         return {
            id: id,
            runtime: resultObject.rpRuntime
         };
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var CheckResult = (function () {
        function CheckResult() {
        }
        return CheckResult;
    }());
    var SelectionValidationResult = (function () {
        function SelectionValidationResult() {
        }
        return SelectionValidationResult;
    }());
    var StorageLocatorItem = (function () {
        function StorageLocatorItem() {
        }
        return StorageLocatorItem;
    }());
    var StorageResourceSelectionValidationService = (function () {
        function StorageResourceSelectionValidationService(compatibilityCheckService, i18nService, creationTypeConstants, defaultUriSchemeUtil, dataService, managedEntityConstants, vmProvisioningStorageSelectionValidationService, $q, compatibilityResultsPresenter, featureFlagsService) {
            this.compatibilityCheckService = compatibilityCheckService;
            this.i18nService = i18nService;
            this.creationTypeConstants = creationTypeConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.managedEntityConstants = managedEntityConstants;
            this.vmProvisioningStorageSelectionValidationService = vmProvisioningStorageSelectionValidationService;
            this.$q = $q;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.featureFlagsService = featureFlagsService;
        }
        StorageResourceSelectionValidationService.prototype.validateSelection = function (selectedStorage, selectedProfileId, virtualMachineSpecBuilderProperties, treatProfileWarningsAsErrors) {
            var _this = this;
            if (selectedStorage.storageRef.type === this.managedEntityConstants.DATASTORE &&
                !selectedStorage.hasAllocateSpacePrivilege) {
                return this.$q.when(this.getNoPrivilegesCompatibilityResult());
            }
            var selectedStorageResourceUrn = this.defaultUriSchemeUtil.getVsphereObjectId(selectedStorage.storageRef);
            var checkCompatibility = this.getCheckCompatibilityPromise(selectedStorageResourceUrn, virtualMachineSpecBuilderProperties);
            var checkVmPlacement = this.checkVmPlacement(selectedProfileId, virtualMachineSpecBuilderProperties, treatProfileWarningsAsErrors);
            var costCheck = this.checkCosts(virtualMachineSpecBuilderProperties);
            return this.$q.all({
                "compatibilityCheck": checkCompatibility,
                "vmPlacementCheck": checkVmPlacement,
                "costCheck": costCheck
            }).then(function (validationResult) {
                return _this.onValidationCompleted(validationResult, virtualMachineSpecBuilderProperties);
            });
        };
        StorageResourceSelectionValidationService.prototype.getNoPrivilegesCompatibilityResult = function () {
            var advancedCompatibilityContents = this.createAdvancedCompatibilityContentsObj([this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.NoPermissionOnDatastore")], [], [], this.compatibilityResultsPresenter.NO_HOST_ID);
            var compIssue = {
                type: "error",
                icon: "vsphere-icon-status-error",
                message: this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.NoPermissionOnDatastore"),
                contents: [],
                advancedCompatibilityContents: advancedCompatibilityContents
            };
            return {
                isValid: false,
                messages: [compIssue]
            };
        };
        StorageResourceSelectionValidationService.prototype.getCheckCompatibilityPromise = function (selectedStorageResourceUrn, vmSpecBuilderProperties) {
            var creationType = vmSpecBuilderProperties.creationType;
            if (this.creationTypeConstants.isCloning(creationType) ||
                (this.creationTypeConstants.isCloningVmToLibrary(creationType)
                    && this.featureFlagsService.CL_Native_VMTX_Phase2Enabled())) {
                return this.checkCompatibilityOnClone(selectedStorageResourceUrn, vmSpecBuilderProperties);
            }
            var compCheckResult = new CheckResult();
            compCheckResult.isValid = true;
            return this.$q.when(compCheckResult);
        };
        StorageResourceSelectionValidationService.prototype.checkCompatibilityOnClone = function (selectedStorageId, virtualMachineSpecBuilderProperties) {
            var _this = this;
            return this.compatibilityCheckService.validate(virtualMachineSpecBuilderProperties.computeResourceId, virtualMachineSpecBuilderProperties.targetFolderUid, virtualMachineSpecBuilderProperties.creationType, virtualMachineSpecBuilderProperties.name, virtualMachineSpecBuilderProperties.vmId, selectedStorageId, virtualMachineSpecBuilderProperties.resPoolId, virtualMachineSpecBuilderProperties.disks).then(function (response) {
                var cloneCompCheckResult = new CheckResult();
                var allCompResults = response.result;
                if (!_this.hasCompatibilityErrors(allCompResults)) {
                    cloneCompCheckResult.isValid = true;
                    return cloneCompCheckResult;
                }
                var advancedCompatibilityContents = _this.createAdvancedDataFromCompatibilityCheck(response, virtualMachineSpecBuilderProperties);
                var hasSuccess = false;
                var compIssues = _.filter(allCompResults, function (result) {
                    return result.messages !== null && result.messages.length > 0;
                });
                // if number of issues is different than total count of compatibility results
                // OR if there is at least one warning => the overall compatibility check is valid
                hasSuccess = compIssues.length !== allCompResults.length;
                compIssues = _.map(compIssues, function (result) {
                    var hasErrors = false;
                    var compIssue = {
                        hostId: _this.defaultUriSchemeUtil.getVsphereObjectId(result.host),
                        type: "",
                        message: result.hostName,
                        icon: null,
                        contents: _.map(result.messages, function (msg) {
                            hasErrors = hasErrors || msg.type === "error";
                            return {
                                type: msg.type,
                                icon: msg.type === "error"
                                    ? "vsphere-icon-status-error"
                                    : "vsphere-icon-status-warning",
                                message: msg.message,
                                contents: []
                            };
                        })
                    };
                    if (hasErrors) {
                        compIssue.type = "error";
                    }
                    else {
                        hasSuccess = true;
                        compIssue.type = "warning";
                    }
                    return compIssue;
                });
                cloneCompCheckResult.isValid = hasSuccess;
                cloneCompCheckResult.issues = compIssues;
                if (compIssues.length > 0) {
                    compIssues[0].advancedCompatibilityContents = advancedCompatibilityContents;
                }
                // If there is one host with one message, its icon will be displayed
                if (compIssues.length === 1 && compIssues[0].contents.length === 1) {
                    return _this.dataService
                        .getProperties(compIssues[0].hostId, ["primaryIconId"])
                        .then(function (properties) {
                        compIssues[0].icon = properties.primaryIconId;
                        return cloneCompCheckResult;
                    });
                }
                if (cloneCompCheckResult.isValid) {
                    compIssues.push({
                        type: "success"
                    });
                }
                return cloneCompCheckResult;
            });
        };
        StorageResourceSelectionValidationService.prototype.createAdvancedDataFromCompatibilityCheck = function (response, virtualMachineSpecBuilderProperties) {
            var _this = this;
            if (response.error) {
                var res = this.createAdvancedCompatibilityContentsObj([response.error.message], [], [], this.compatibilityResultsPresenter.NO_HOST_ID);
                res.vmProps.name = virtualMachineSpecBuilderProperties.name;
                return res;
            }
            var advancedCompatibilityContents = {
                hostMap: {},
                vmId: this.compatibilityResultsPresenter.NO_VM_ID,
                vmProps: {
                    icon: this.compatibilityResultsPresenter.NO_VM_ICON,
                    name: virtualMachineSpecBuilderProperties.name
                }
            };
            _.each(response.result, function (singleHostResult) {
                var hostId = _this.defaultUriSchemeUtil.getVsphereObjectId(singleHostResult.host);
                if (!advancedCompatibilityContents.hostMap[hostId]) {
                    advancedCompatibilityContents.hostMap[hostId] = {
                        errors: [],
                        warnings: [],
                        infos: [],
                        props: {
                            icon: _this.compatibilityResultsPresenter.NO_HOST_ICON,
                            name: _this.compatibilityResultsPresenter.NO_HOST_NAME
                        }
                    };
                }
                _.each(singleHostResult.messages, function (msg) {
                    if (msg.type === "error") {
                        advancedCompatibilityContents.hostMap[hostId].errors.push(msg.message);
                    }
                    else {
                        advancedCompatibilityContents.hostMap[hostId].warnings.push(msg.message);
                    }
                });
            });
            return advancedCompatibilityContents;
        };
        StorageResourceSelectionValidationService.prototype.checkVmPlacement = function (selectedProfileId, virtualMachineSpecBuilderProperties, treatProfileWarningsAsErrors) {
            var _this = this;
            var placementCheck = new CheckResult();
            if (!selectedProfileId) {
                placementCheck.isValid = true;
                return this.$q.when(placementCheck);
            }
            var vmHomeStorageId = this.defaultUriSchemeUtil.getVsphereObjectId(virtualMachineSpecBuilderProperties.vmStorageConf.vmHome.storageObj.storageRef);
            var vmHomeProfileId = virtualMachineSpecBuilderProperties.vmStorageConf.vmHome.storageProfile.id;
            var assignmentsWithProfiles = [{
                    storageId: vmHomeStorageId,
                    profile: { id: vmHomeProfileId }
                }];
            _.each(virtualMachineSpecBuilderProperties.disks, function (disk) {
                var storageId = _this.defaultUriSchemeUtil.getVsphereObjectId(disk.datastore);
                _.each(disk.profile, function (profile) {
                    assignmentsWithProfiles.push({
                        storageId: storageId,
                        profile: { id: profile.profileId }
                    });
                });
            });
            return this.compatibilityCheckService
                .validateVmPlacementForMultipleVms(assignmentsWithProfiles)
                .then(function (result) {
                // both errors and warnings are displayed as a warning
                var errors = _.map(result.errors, function (error) {
                    return {
                        type: treatProfileWarningsAsErrors ? "error" : "warning",
                        icon: treatProfileWarningsAsErrors ?
                            "vsphere-icon-status-error" : "vsphere-icon-status-warning",
                        message: error,
                        contents: []
                    };
                });
                // In case the server returns a generic message (e.g. VSAN policy message
                // on VC 6.0), we return only that message. In case it returns a more
                // specific message, we return the generic message and the specific
                // message on the next line.
                var spbmPolicyWarning = _this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpbmPolicyWarning");
                var warnings = [];
                _.each(result.warnings, function (warning) {
                    var warningMessage = warning.localizedMessage;
                    if (!warningMessage && !_.isEmpty(warning.faultMessage)) {
                        warningMessage = warning.faultMessage[0].message;
                    }
                    var warningContent = !warningMessage || warningMessage === spbmPolicyWarning ?
                        [] :
                        [{
                                message: "\"" + warningMessage + "\"",
                                contents: []
                            }];
                    var containsWarning = _.any(warnings, function (warn) {
                        return angular.equals(warn.contents, warningContent);
                    });
                    if (containsWarning) {
                        return;
                    }
                    warnings.push({
                        type: treatProfileWarningsAsErrors ? "error" : "warning",
                        icon: treatProfileWarningsAsErrors ?
                            "vsphere-icon-status-error" : "vsphere-icon-status-warning",
                        message: spbmPolicyWarning,
                        contents: warningContent
                    });
                });
                var advancedCompatibilityContents = _this.createAdvancedDataFromPlacementCheck(result);
                var compIssues = errors.concat(warnings);
                if (compIssues.length > 0) {
                    compIssues[0].advancedCompatibilityContents = advancedCompatibilityContents;
                }
                placementCheck.isValid = treatProfileWarningsAsErrors && compIssues.length > 0 ? false : true;
                placementCheck.issues = compIssues;
                return placementCheck;
            });
        };
        StorageResourceSelectionValidationService.prototype.createAdvancedDataFromPlacementCheck = function (response) {
            var spbmPolicyWarning = this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpbmPolicyWarning");
            var warningMessages = [];
            _.each(response.warnings, function (warning) {
                var warningMessage = warning.localizedMessage;
                if (warningMessage === null && !_.isEmpty(warning.faultMessage)) {
                    warningMessage = warning.faultMessage[0].message;
                }
                if (warningMessage) {
                    warningMessages.push(warningMessage);
                }
                else if (warningMessages.indexOf(spbmPolicyWarning) === -1) {
                    warningMessages.push(spbmPolicyWarning);
                }
            });
            return this.createAdvancedCompatibilityContentsObj(response.errors, warningMessages, [], this.compatibilityResultsPresenter.NO_HOST_ID);
        };
        StorageResourceSelectionValidationService.prototype.hasCompatibilityErrors = function (compatibilityResults) {
            return _.any(compatibilityResults, function (result) {
                return _.any(result.messages, function (message) {
                    return message.type === "error";
                });
            });
        };
        StorageResourceSelectionValidationService.prototype.checkCosts = function (virtualMachineSpecBuilderProperties) {
            var _this = this;
            return this.vmProvisioningStorageSelectionValidationService
                .requestProvisioningCost(virtualMachineSpecBuilderProperties.targetFolderUid, virtualMachineSpecBuilderProperties.vmStorageConf, false, virtualMachineSpecBuilderProperties.vmDisks)
                .then(function (costResults) {
                var costCheckResult = new CheckResult();
                costCheckResult.isValid = true;
                if (_.isEmpty(costResults.compatibilityData.infos)) {
                    return costCheckResult;
                }
                var advancedCompatibilityContents = _this.createAdvancedCompatibilityContentsObj([], [], costResults.compatibilityData.infos, _this.compatibilityResultsPresenter.NO_HOST_ID);
                var compIssue = {
                    icon: "vsphere-icon-help-info-hover",
                    message: costResults.compatibilityData.infos[0],
                    contents: [],
                    advancedCompatibilityContents: advancedCompatibilityContents
                };
                costCheckResult.issues = [compIssue];
                return costCheckResult;
            });
        };
        StorageResourceSelectionValidationService.prototype.createAdvancedCompatibilityContentsObj = function (errors, warnings, infos, hostId) {
            var advancedCompatibilityContents = {
                hostMap: {},
                vmId: this.compatibilityResultsPresenter.NO_VM_ID,
                vmProps: {
                    name: this.compatibilityResultsPresenter.NO_VM_NAME,
                    icon: this.compatibilityResultsPresenter.NO_VM_ICON
                }
            };
            advancedCompatibilityContents.hostMap[hostId] = {
                errors: errors,
                warnings: warnings,
                infos: infos,
                props: {
                    icon: this.compatibilityResultsPresenter.NO_HOST_ICON,
                    name: this.compatibilityResultsPresenter.NO_HOST_NAME
                }
            };
            return advancedCompatibilityContents;
        };
        StorageResourceSelectionValidationService.prototype.onValidationCompleted = function (result, virtualMachineSpecBuilderProperties) {
            //  - Having a validation errors in one of the checks does not necessarily mean that
            // the overall validation fails, so we are checking both isValid property of
            // particular validation and its issues count.
            // - At the same time the flow here stops collecting validation issues after the
            // first failed check.
            // - If there are already some issues collected (added to allIssues array) from
            // a check that does not fail the overall validation, these issues are removed
            // and replaced by the issues of check that fails the validation
            // The overall idea is to show only issues of the check that fails the validation
            // or show all the issues collected from different checks that does not fail the
            // overall validation
            var allIssues = [];
            var overallValidationSuccseeded = true;
            if (result.compatibilityCheck && !_.isEmpty(result.compatibilityCheck.issues)) {
                overallValidationSuccseeded = result.compatibilityCheck.isValid;
                allIssues = overallValidationSuccseeded
                    ? allIssues.concat(result.compatibilityCheck.issues)
                    : result.compatibilityCheck.issues;
            }
            if (overallValidationSuccseeded &&
                result.vmPlacementCheck && !_.isEmpty(result.vmPlacementCheck.issues)) {
                overallValidationSuccseeded = result.vmPlacementCheck.isValid;
                allIssues = overallValidationSuccseeded
                    ? allIssues.concat(result.vmPlacementCheck.issues)
                    : result.vmPlacementCheck.issues;
            }
            if (overallValidationSuccseeded &&
                result.costCheck && !_.isEmpty(result.costCheck.issues)) {
                overallValidationSuccseeded = result.costCheck.isValid;
                allIssues = overallValidationSuccseeded
                    ? allIssues.concat(result.costCheck.issues)
                    : result.costCheck.issues;
            }
            if (allIssues.length > 0) {
                return this.createValidationErrorResultObject(overallValidationSuccseeded, allIssues, virtualMachineSpecBuilderProperties);
            }
            return {
                isValid: true,
                messages: [{
                        type: "success",
                        icon: "vsphere-icon-status-ok",
                        message: this.i18nService.getString("VmUi", "ProvisioningWizard.CompatibilityChecksSucceeded"),
                        contents: [],
                        advancedCompatibilityContents: {}
                    }]
            };
        };
        // overall validation result is no more driven by this function, rather it is function
        // of each particular type of validation, e.g. having an error for some particular
        // validation does not mean the overall validation is failed, e.g. in clone operations
        // if there is at least one successful result the validation passes
        StorageResourceSelectionValidationService.prototype.createValidationErrorResultObject = function (overallValidationSuccseeded, errorsArray, virtualMachineSpecBuilderProperties) {
            var _this = this;
            var filteredMessages = _.filter(errorsArray, function (error) {
                return error.type !== "success";
            });
            if (!filteredMessages[0] || !filteredMessages[0].advancedCompatibilityContents) {
                return {
                    isValid: overallValidationSuccseeded,
                    messages: filteredMessages
                };
            }
            var advancedCompatibilityContents = filteredMessages[0].advancedCompatibilityContents;
            if (advancedCompatibilityContents && virtualMachineSpecBuilderProperties
                && virtualMachineSpecBuilderProperties.name) {
                advancedCompatibilityContents.vmProps.name = virtualMachineSpecBuilderProperties.name;
            }
            if (advancedCompatibilityContents && virtualMachineSpecBuilderProperties
                && virtualMachineSpecBuilderProperties.vmId) {
                advancedCompatibilityContents.vmId = virtualMachineSpecBuilderProperties.vmId;
            }
            var affectedHosts = [];
            _.each(advancedCompatibilityContents.hostMap, function (hostInfo, hostId) {
                if (hostId !== _this.compatibilityResultsPresenter.NO_HOST_ID) {
                    affectedHosts.push(hostId);
                }
            });
            if (affectedHosts.length === 0) {
                return {
                    isValid: overallValidationSuccseeded,
                    messages: filteredMessages,
                };
            }
            return this.dataService
                .getPropertiesForObjects(affectedHosts, ["primaryIconId", "name"])
                .then(function (properties) {
                _.each(properties, function (props, hostId) {
                    advancedCompatibilityContents.hostMap[hostId].props.icon =
                        props.primaryIconId;
                    advancedCompatibilityContents.hostMap[hostId].props.name =
                        props.name;
                });
                return {
                    isValid: overallValidationSuccseeded,
                    messages: filteredMessages
                };
            });
        };
        StorageResourceSelectionValidationService.$inject = [
            "compatibilityCheckService",
            "i18nService",
            "creationTypeConstants",
            "defaultUriSchemeUtil",
            "dataService",
            "managedEntityConstants",
            "vmProvisioningStorageSelectionValidationService",
            "$q",
            "compatibilityResultsPresenter",
            "featureFlagsService"
        ];
        return StorageResourceSelectionValidationService;
    }());
    h5_vm.StorageResourceSelectionValidationService = StorageResourceSelectionValidationService; // class
    angular.module("com.vmware.vsphere.client.vm").service("storageResourceSelectionValidationService", StorageResourceSelectionValidationService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').factory('VirtualMachineSpecBuilder', [
   '$q',
   'dataService',
   'vmDeviceInfoService',
   'defaultUriSchemeUtil',
   'creationTypeConstants',
   'cpuService',
   'storageProfileService',
   'managedEntityConstants',
   'diskProvisioningService',
   'podSelectionSpecService',
   'authorizationService',
   'virtualDiskPmemService',
   'pmemUtilService',
   'storageSelectorConstants',
   'deviceOperationConstants',
   'deviceClassLineageService',
   'deviceTypeConstants',
   function ($q,
             dataService,
             vmDeviceInfoService,
             defaultUriSchemeUtil,
             creationTypeConstants,
             cpuService,
             storageProfileService,
             managedEntityConstants,
             diskProvisioningService,
             podSelectionSpecService,
             authorizationService,
             virtualDiskPmemService,
             pmemUtilService,
             storageSelectorConstants,
             deviceOperationConstants,
             deviceClassLineageService,
             deviceTypeConstants) {
      var VirtualMachineSpecBuilder = function () {
         var vmParams = {};
         var _vmConfigEnvironmentPromise;
         // Vm config option promise indexed by vm version, has the following
         // format { vmVersion: , promise: }. This is needed because this promise is not
         // nulled when vm version is changed and we want to make sure that every time
         // when we return the promise it contains the config option for the exact vm
         // version it is requested
         var _vmConfigOptionByVmVersion;
         var _latestGosId;
         var _targetPrivilegesPromise;
         var _vmAdvancedStorageDataPromise;
         var _vmStoragePageDataPromise;

         /**
          * The privileges listed below are retrieved for New vm wizard
          * and are used to disable the `Add new device` menu or to disable some of
          * the properties in the customize hardware page
          *
          * "VirtualMachine.Config.AddRemoveDevice" - for `CD/DVD Drive`, `Network Adapter`,
          * `SCSI Controller`, `USB Controller` and `NVMe Controller`
          * "VirtualMachine.Config.HostUSBDevice" - for `Host USB Device`
          * "VirtualMachine.Config.AddNewDisk" - for `Hard Disk`
          * "VirtualMachine.Config.RawDevice" - for `RDM Disk`
          * "VirtualMachine.Config.AddExistingDisk" - for `Existing Hard Disk`
          *
          * VirtualMachine.Config.SwapPlacement - `Swap file location` in Advanced section in Vm Options tab
          * VirtualMachine.Config.Settings - `Latency Sensitivity` in Advanced section in Vm Options tab
          * VirtualMachine.Config.Resource - `Scheduling Affinity` in CPU section
          * VirtualMachine.Config.AdvancedConfig - VM options advanced config
          */
         var REQUIRED_PRIVILEGES_CREATE = [
            h5_vm.Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE,
            h5_vm.Privileges.VM_ADDNEWDISK_PRIVILEGE,
            h5_vm.Privileges.VM_ADDEXISTINGDISK_PRIVILEGE,
            h5_vm.Privileges.VM_RAWDEVICE_PRIVILEGE,
            h5_vm.Privileges.VM_CONFIG_SWAPFILEPLACEMENT,
            h5_vm.Privileges.VM_RESOURCE_PRIVILEGE,
            h5_vm.Privileges.VM_CONFIG_SETTINGS,
            h5_vm.Privileges.VM_HOST_USB_DEVICE,
            h5_vm.Privileges.STORAGE_PROFILE_VIEW,
            h5_vm.Privileges.VM_CONFIG_ADVANCEDCONFIG,
            h5_vm.Privileges.CRYPTOGRAPHER_ENCRYPT,
            h5_vm.Privileges.CRYPTOGRAPHER_ENCRYPT_NEW_VM,
         ];

         /**
          * The privileges listed below are retrieved for Clone vm wizard
          * and are used to disable the `Add new device` menu or to disable some of
          * the properties in the customize hardware page
          *
          * "VirtualMachine.Config.AddRemoveDevice" - for `CD/DVD Drive`, `Network Adapter`,
          * `SCSI Controller`, `USB Controller` and `NVMe Controller`
          * "VirtualMachine.Config.HostUSBDevice" - for `Host USB Device`
          * "VirtualMachine.Config.AddNewDisk" - for `Hard Disk`
          * "VirtualMachine.Config.RawDevice" - for `RDM Disk`
          * "VirtualMachine.Config.AddExistingDisk" - for `Existing Hard Disk`
          *
          * VirtualMachine.Config.SwapPlacement - `Swap file location` in Advanced section in Vm Options tab
          * VirtualMachine.Config.Settings - `Settings`, `Debugging and statistics`, `Latency Sensitivity`,
          * `Firmware`, `Boot Delay`, `Force BIOS setup`, `Failed Boot Recovery`,
          * `Tools Upgrades`, `Time`, `Run VMware Tools Scripts`, `Standby response`,
          * `CPUID Mask`, `Hardware virtualization`, `Performance Counters`, `CPU/MMU Virtualization`
          * VirtualMachine.Config.Resource - `Reservation`, `Limit`, `Shares`,
          * `Scheduling Affinity`, `Limit - IOPs`
          * VirtualMachine.Config.EditDevice - `select settings type`, `Number of displays`,
          * `Total video memory`, `3D Graphics`, `3D Renderer`, `3D Memory`, `Virtual Device Node`,
          * `Adapter Type`, `DirectPath I/O`, `MAC Address`, `Change Type`, `SCSI Bus Sharing`,
          * `Shares`, `Limit - IOPs`, `Virtual flash read cache`, `Disk Mode`
          * VirtualMachine.Interact.DeviceConnection - `Connect At Power On` for CD/DVD drive or Network
          * VirtualMachine.Interact.SetCDMedia - select type, `Device Mode` for CD/DVD Drive
          * Network.Assign - Select network
          * VirtualMachine.Config.DiskExtend - Hard disk capacity
          * Datastore.AllocateSpace - Hard disk capacity
          * VirtualMachine.Config.Memory - `Memory`, `Memory Hot Plug`
          * VirtualMachine.Config.CPUCount - `CPU count`, `Cores per socket`, `CPU Hot Plug`
          * VirtualMachine.Config.RemoveDisk - remove disk (not RAW)
          * VirtualMachine.Interact.PowerOn - `Power on virtual machine after creation` property in select clone options
          * VirtualMachine.Config.MksControl - for Customize HW > VM Options > VMRC options settings
          * VirtualMachine.Config.AdvancedConfig - VM options advanced config
          */
         var REQUIRED_PRIVILEGES_CLONE = [
            h5_vm.Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE,
            h5_vm.Privileges.VM_ADDNEWDISK_PRIVILEGE,
            h5_vm.Privileges.VM_ADDEXISTINGDISK_PRIVILEGE,
            h5_vm.Privileges.VM_RAWDEVICE_PRIVILEGE,
            h5_vm.Privileges.VM_CONFIG_SWAPFILEPLACEMENT,
            h5_vm.Privileges.VM_RESOURCE_PRIVILEGE,
            h5_vm.Privileges.VM_CONFIG_SETTINGS,
            h5_vm.Privileges.VM_HOST_USB_DEVICE,
            h5_vm.Privileges.VM_CONFIG_CPU_COUNT,
            h5_vm.Privileges.VM_CONFIG_MEMORY,
            h5_vm.Privileges.VM_DISKEXTEND_PRIVILEGE,
            h5_vm.Privileges.DATASTORE_ALLOCATESPACE_PRIVILEGE,
            h5_vm.Privileges.VM_REMOVEDISK_PRIVILEGE,
            h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE,
            h5_vm.Privileges.NETWORK_ASSIGN,
            h5_vm.Privileges.VM_INTERACT_DEVICE_CONNECTION,
            h5_vm.Privileges.VM_INTERACT_SET_CD_MEDIA,
            h5_vm.Privileges.VM_INTERACT_POWER_ON,
            h5_vm.Privileges.VM_CONFIG_MKSCONTROL,
            h5_vm.Privileges.VM_CONFIG_ADVANCEDCONFIG];

         var setCreationType = function (creationType) {
            if (vmParams.creationType !== creationType) {
               _targetPrivilegesPromise = undefined;
            }

            if (vmParams.creationType === creationType) {
               return;
            }

            vmParams.creationType = creationType;
            if (creationType === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE
               || creationType === creationTypeConstants.DEPLOY_VM_FROM_VAPP) {
               resetStorage();
            }
         };

         var getCreationType = function () {
            return vmParams.creationType;
         };

         var setTargetInformation = function (targetUid, datacenterUid, folderUid, locationName) {

            // if the selected folder has changed, retrieve the privileges again
            if (vmParams.targetInformation && vmParams.targetInformation.folderUid !== folderUid) {
               _targetPrivilegesPromise = undefined;
            }

            // if the selected datacenter has changed, retrieve the storageData again
            var previousRootFolder = vmParams.targetInformation ?
                  defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(
                        vmParams.targetInformation.datacenterUid) : undefined;
            var rootFolder = defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(datacenterUid);
            var isVcChanged = previousRootFolder !== rootFolder;

            vmParams.targetInformation = {
               targetUid: targetUid,
               datacenterUid: datacenterUid,
               folderUid: folderUid,
               name: locationName
            };

            if (isVcChanged) {
               _vmStoragePageDataPromise = undefined;
               getStoragePageData();
            }
         };

         var getTargetInformation = function () {
            return vmParams.targetInformation;
         };

         var setVmId = function (id) {
            var isVmIdChanged = id !== vmParams.vmId;
            vmParams.vmId = id;
            if (isVmIdChanged) {
               _vmAdvancedStorageDataPromise = undefined;
               getAdvancedStoragePageData();
            }
         };

         var getVmId = function () {
            return vmParams.vmId;
         };

         var setName = function (name) {
            vmParams.name = name;
         };

         var getName = function () {
            return vmParams.name;
         };

         var setHasEncryptNewVmPrivilege = function (hasEncryptNewVmPrivilege) {
            vmParams.hasEncryptNewVmPrivilege = hasEncryptNewVmPrivilege;
         };

         var getHasEncryptNewVmPrivilege = function () {
            return vmParams.hasEncryptNewVmPrivilege;
         };

         var setHasManageEncryptionPolicyPrivilege = function (hasManageEncryptionPolicyPrivilege) {
            vmParams.hasManageEncryptionPolicyPrivilege = hasManageEncryptionPolicyPrivilege;
         };

         var getHasManageEncryptionPolicyPrivilege = function () {
            return vmParams.hasManageEncryptionPolicyPrivilege;
         };

         var setTemplateName = function(name) {
            vmParams.templateName = name;
         };

         var getTemplateName = function () {
            return vmParams.templateName;
         };

         var setRecreateVm = function (recreateVm) {
            vmParams.recreateVm = recreateVm;
         };

         var getRecreateVm = function () {
            return vmParams.recreateVm;
         };

         var setComputeResourceId = function (newComputeResourceId) {
            if (newComputeResourceId !== vmParams.computeResourceId) {
               if (vmParams.computeResourceId) {
                  vmParams.recreateVm = true;
               }
               _vmConfigEnvironmentPromise = undefined;
               _vmConfigOptionByVmVersion = undefined;
               _targetPrivilegesPromise = undefined;
            }

            vmParams.computeResourceId = newComputeResourceId;
         };

         var getComputeResourceId = function () {
            return vmParams.computeResourceId;
         };

         /**
          * When the #getComputeResourceId returns a ResourcePool or VApp, this
          * method will return the ClusterComputeResource or the ComputeResource where
          * these are located. Otherwise it will have the value of 'undefined'.
          *
          * @returns {string|undefined}
          */
         var getComputeResourceOwnerId = function () {
            return vmParams.computeResourceOwnerId;
         };

         /**
          * @param {string|undefined} ownerId
          */
         var setComputeResourceOwnerId = function (ownerId) {
            vmParams.computeResourceOwnerId = ownerId;
         };

         var setComputeResourceName = function (name) {
            vmParams.computeResourceName = name;
         };

         var getComputeResourceName = function () {
            return vmParams.computeResourceName;
         };

         var setResourcePool = function (resourcePool) {
            vmParams.resourcePool = resourcePool;
         };

         var getResourcePool = function () {
            return vmParams.resourcePool;
         };

         var setVmOriginalConfigSpec = function (spec) {
            vmParams.originalConfigSpec = spec;
         };

         var setIsResourcePoolInVapp = function (isRpInVapp) {
            vmParams.isRpInVapp = isRpInVapp;
         };

         var isResourcePoolInVapp = function () {
            return vmParams.isRpInVapp;
         };

         var getVmOriginalConfigSpec = function () {
            return vmParams.originalConfigSpec;
         };

         var setVmConfigSpec = function (spec) {
            vmParams.configSpec = spec;
         };

         var getSourceVmStorageConfig = function () {
            if (!vmParams.sourceVmStorageConfig) {
               return null;
            }

            return vmParams.sourceVmStorageConfig[0];
         };

         var getSourceVmStorageConfigDisk = function (diskKey) {
            if (!getSourceVmStorageConfig()) {
               return null;
            }

            return _.find(getSourceVmStorageConfig().vmDisks, function(disk) {
               return disk.key === diskKey;
            });
         };

         var setSourceVmStorageConfig = function (sourceVmStorageConfig) {
            vmParams.sourceVmStorageConfig = sourceVmStorageConfig;
         };

         var getVmConfigSpec = function () {
            return vmParams.configSpec;
         };

         var getStorageObject = function () {
            return vmParams.storageObject;
         };

         var getDisableSdrs = function () {
            return vmParams.disableSdrs;
         };

         var setDisableSdrs = function (disableSdrs) {
            vmParams.disableSdrs = disableSdrs;
         };

         var getVmVersion = function () {
            return vmParams.vmVersion;
         };

         var setVmVersion = function (version) {
            if (vmParams.vmVersion !== version) {
               setRecreateVm(true);
               _vmConfigEnvironmentPromise = null;
            }
            vmParams.vmVersion = version;
         };

         var getScheduledVmVersion = function () {
            return vmParams.scheduledVmVersion;
         };

         var setScheduledVmVersion = function (version) {
            vmParams.scheduledVmVersion = version;
         };

         var getScheduledData = function () {
            return vmParams.scheduledData;
         };

         var setScheduledData = function (data) {
            vmParams.scheduledData = data;
         };

         var getGosFamily = function () {
            return vmParams.gosFamily;
         };

         var getGosVersion = function () {
            return vmParams.gosVersion;
         };

         var getGosName = function () {
            return vmParams.gosName;
         };

         var setGuestOsId = function (id) {
            vmParams.guestOsId = id;
         };

         var getGuestOsId = function () {
            return vmParams.guestOsId;
         };

         var setScheduledGuestOsId = function (id) {
            vmParams.scheduledGuestOsId = id;
         };

         var getScheduledGuestOsId = function () {
            return vmParams.scheduledGuestOsId;
         };

         var setScheduledGuestName = function (name) {
            vmParams.scheduledGuestName = name;
         };

         var getScheduledGuestName = function () {
            return vmParams.scheduledGuestName;
         };

         var setGosName = function (gosName) {
            vmParams.gosName = gosName;
         };

         var setGosFamilyAndVersion = function (familyAndVersion) {
            var family = familyAndVersion.family;
            var version = familyAndVersion.version;

            vmParams.gosFamily = family;

            var newVersionId = version ? version.id : undefined;
            var preservedVersionId = vmParams.gosVersion
                  ? vmParams.gosVersion.id
                  : undefined;
            if (newVersionId !== preservedVersionId) {
               setRecreateVm(true);
            }
            vmParams.gosVersion = version;
         };

         var getVbsEnabled = function () {
            return vmParams.vbsEnabled;
         };
         var setVbsEnabled = function (vbsEnabled) {
            vmParams.vbsEnabled = vbsEnabled;
         };

         var getVbsSupported = function () {
            return vmParams.vbsSupported;
         };
         var setVbsSupported = function (vbsSupported) {
            vmParams.vbsSupported = vbsSupported;
         };

         var setVirtualMachineDevices = function (virtualMachineDevices) {
            vmParams.virtualMachineDevices = virtualMachineDevices;
         };

         var getVirtualMachineDevices = function () {
            return vmParams.virtualMachineDevices;
         };

         var setCloneOptions = function (options) {
            vmParams.cloneOptions = options;
         };

         var shouldRetrieveGosDescriptor = function() {
            return vmParams.gosVersion.id !== _latestGosId;
         };

         var retrieveGosDescriptor = function() {
            var hostRef = null;
            var computeResourceRef =
                  defaultUriSchemeUtil.getManagedObjectReference(vmParams.computeResourceId);
            if (computeResourceRef.type === managedEntityConstants.HOST) {
               hostRef = computeResourceRef;
            }

            var envBrowserId = defaultUriSchemeUtil.getVsphereObjectId(vmParams.envBrowserRef);

            var params = [{
               propertyName: 'vmConfigGuestOsDescriptor',
               parameterType: 'com.vmware.vsphere.client.h5.vm.model.provisioning.VmConfigEnvironmentPerPoolParams',
               parameter: {
                  _type: 'com.vmware.vsphere.client.h5.vm.model.provisioning.VmConfigEnvironmentPerPoolParams',
                  key: getVmVersion(),
                  hostRef: hostRef,
                  gosId: getGosVersion() ? getGosVersion().id : getGuestOsId()
               }
            }];
            return dataService.getProperties(
                        envBrowserId,
                        ['vmConfigGuestOsDescriptor'],
                        {
                           propertyParams: params
                        }
                  ).then(function(guestOsDescriptor) {
               _latestGosId = guestOsDescriptor.vmConfigGuestOsDescriptor.id;
               return guestOsDescriptor;
            });

         };

         var setCustomPcName = function (name) {
            var LINUX_PREP = 'com.vmware.vim.binding.vim.vm.customization.LinuxPrep';
            var SYS_PREP = 'com.vmware.vim.binding.vim.vm.customization.Sysprep';
            var customizationSpec = getCustomizationSpec();
            var nameCustomization = {
               _type: 'com.vmware.vim.binding.vim.vm.customization.FixedName',
               name: name
            };
            if (customizationSpec.identity._type === LINUX_PREP) {
               customizationSpec.identity.hostName = nameCustomization;
            } else if (customizationSpec.identity._type === SYS_PREP) {
               customizationSpec.identity.userData.computerName = nameCustomization;
            }
            setCustomizationSpec(customizationSpec);
         };

         var setCustomIpv4ForNIC = function (index, nic) {
            var customizationSpec = getCustomizationSpec();
            customizationSpec.nicSettingMap[index].adapter.gateway = [];
            if (nic.ipv4.defaultGateway) {
               customizationSpec.nicSettingMap[index].adapter.gateway.push(nic.ipv4.defaultGateway);
            }
            if (nic.ipv4.alternateGateway) {
               customizationSpec.nicSettingMap[index].adapter.gateway.push(nic.ipv4.alternateGateway);
            }
            customizationSpec.nicSettingMap[index].adapter.subnetMask = nic.ipv4.subnetMask;
            customizationSpec.nicSettingMap[index].adapter.ip = {
               _type: 'com.vmware.vim.binding.vim.vm.customization.FixedIp',
               ipAddress: nic.ipv4.address
            };

            setCustomizationSpec(customizationSpec);
         };

         var setCustomIpv6ForNIC = function (index, nic) {
            var customizationSpec = getCustomizationSpec();
            customizationSpec.nicSettingMap[index].adapter.ipV6Spec.ip = [{
               _type: 'com.vmware.vim.binding.vim.vm.customization.FixedIpV6',
               ipAddress: nic.ipv6.address,
               subnetMask: nic.ipv6.subnetPrefixLength
            }];

            customizationSpec.nicSettingMap[index].adapter.ipV6Spec.gateway = nic.ipv6.gateway;

            setCustomizationSpec(customizationSpec);
         };

         var setCustomizationSpec = function (spec) {
            vmParams.customizationSpec = spec;
         };

         var getCustomizationSpec = function () {
            return vmParams.customizationSpec;
         };

         var setCustomizationSpecInfo = function (info) {
            vmParams.CustomizationSpecInfo = info;
         };

         var getCustomizationSpecInfo = function () {
            return vmParams.CustomizationSpecInfo;
         };

         var getCloneOptions = function () {
            return vmParams.cloneOptions;
         };

         var setSelectedStorageProfile = function (profile) {
            if (profile && profile.id) {
               profile.profileId = profile.id;
            }
            vmParams.selectedStorageProfile = profile;
         };

         var getSelectedStorageProfile = function () {
            return vmParams.selectedStorageProfile;
         };

         var setSelectedReplicationGroupInfo = function (replicationGroupInfo) {
            vmParams.selectedReplicationGroupInfo = replicationGroupInfo;
         };

         var getSelectedReplicationGroupInfo = function () {
            return vmParams.selectedReplicationGroupInfo;
         };

         var setSelectedStorageProfileForDisks = function (profile) {
            if (profile && profile.id) {
               profile.profileId = profile.id;
            }
            vmParams.selectedStorageProfileForDisks = profile;
         };

         var getSelectedStorageProfileForDisks = function () {
            // If there is a specifically set storage profile for disks, then return it.
            if (vmParams.selectedStorageProfileForDisks) {
               return vmParams.selectedStorageProfileForDisks;
            }

            // else, return the overall storage profile.
            return getSelectedStorageProfile();
         };

         var storageObjectIsPod = function (storageObject) {
            storageObject = storageObject || getStorageObject();
            if (!storageObject) {
               return false;
            }
            return storageObject.storageRef &&
               storageObject.storageRef.type === managedEntityConstants.STORAGE_POD;
         };

         var storageObjectIsStandaloneDs = function (storageObject) {
            storageObject = storageObject || getStorageObject();
            if (!storageObject) {
               return false;
            }
            return !storageObjectIsPod(storageObject)
               || (storageObject.parentStoragePod && vmParams.disableSdrs);
         };

         var setStorageObject = function (storageObject) {
            if (storageObject && getStorageObject()
               && getStorageObject().storageRef.value !== storageObject.storageRef.value) {
               setRecreateVm(true);
            }

            vmParams.storageObject = storageObject;
         };

         var setStorageObjectAndDiskFormat = function (storageObject, diskFormat) {
            setStorageObject(storageObject);
            vmParams.diskFormat = diskFormat;
         };

         var getDiskFormat = function () {
            return vmParams.diskFormat;
         };

         // TODO: proynovd: WHY are the existing disks accessable by referance from "this"
         // queried through the DataService?
         var _cachedVmDevicesPromise;

         function getVirtualDisks() {
            if (!_cachedVmDevicesPromise) {
               _cachedVmDevicesPromise = dataService.getProperties(getVmId(), 'virtualDisks');
            }

            return _cachedVmDevicesPromise;
         }

         /**
          * @param diskDevice - the device spec of the virtualDisk
          * @returns the same object with an additional property 'profile' containing
          *       the selected storage profile for the virtualDisk.
          */
         var appendStorageProfileToDisk = function (diskDevice) {
            var profile = getSelectedStorageProfile();
            if (getVirtualMachineDevices()
                  && getVirtualMachineDevices().getVirtualDevice(diskDevice.key)) {
               profile = getVirtualMachineDevices().getVirtualDevice(diskDevice.key).getProfile();
            }

            diskDevice.profile = profile;
            return diskDevice;
         };

         /**
          * @param diskDevice - the device spec of the virtualDisk
          * @returns array of profile spec
          */
         var makeStorageProfile = function (diskDevice) {
            if (vmParams.containsSpbmIssues) {
               return [];
            }
            var profileId = diskDevice.profile && diskDevice.profile.profileId;
            var replicationGroup;
            // get the disks configuration as it was set in the select storage page
            // and use the calculated profile there
            var storageVirtualDisks = getVmDisksStorage()[getVmId()];
            var disk = _.find(storageVirtualDisks, function(disk) {
               return disk.key === diskDevice.key;
            });
            if (disk) {
               profileId = disk.profile && disk.profile.id;
               replicationGroup = disk.replicationGroup;
            }
            return [storageProfileService.makeProfile(profileId, replicationGroup)];
         };

         /**
          * Updates the profile of virtual disks that already exist like in the clone case
          * with the profiles selected in the storage page
          * @param diskDevices - a list of disk changes for already existing disks
          */
         var appendStorageProfileToExistingDisks = function (diskDevices) {
            _.each(diskDevices, function(diskDevice) {
               var profileId = getSelectedStorageProfile() && getSelectedStorageProfile().id;
               var rgInfo = getSelectedReplicationGroupInfo();
               // get the disks configuration as it was set in the select storage page
               // and use the calculated profile there
               var storageVirtualDisks = getVmDisksStorage()[getVmId()];
               var disk = _.find(storageVirtualDisks, function(disk) {
                  return disk.key === diskDevice.getKey();
               });
               if (disk) {
                  profileId = disk.profile && disk.profile.id;
                  rgInfo = disk.replicationGroup;
               }
               // if the disk is new either use the selected profile on the storage page
               // or the selected for the disk

               diskDevice.setProfile(
                     storageProfileService.makeProfile(profileId, rgInfo));
            });
         };

         var getReplicationGroupForDisk = function (diskDevice) {
            var rgInfo = getSelectedReplicationGroupInfo();
            if (getVirtualMachineDevices() &&
                  getVirtualMachineDevices().getVirtualDevice(diskDevice.key)) {
               rgInfo = getVirtualMachineDevices().getVirtualDevice(
                     diskDevice.key).getCurrentReplicationGroup();
            }
            return rgInfo;
         };

         var getStorageBaselineId = function () {
            if (!getStorageSelectorState()) {
               return;
            } else {
               return getStorageSelectorState().storageBaselineId;
            }
         };

         var filterVirtualDisksBeforeMakingThemDiskLocators = function (virtualDisks, newDisks) {
            if (getIsAdvancedStorageMode()) {
               var storageSelectorDisks =
                  getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
               return virtualDiskPmemService.filterVirtualDisksToDiskLocatorsForPmemAdvanced(
                  virtualDisks, storageSelectorDisks);
            } else {
               var storageBaselineId = getStorageBaselineId();
               return virtualDiskPmemService.filterVirtualDisksToDiskLocatorsForPmem(
                  virtualDisks, storageBaselineId, newDisks);
            }
         };

         var applyPmemRulesOnVirtualDiskBacking = function (backing, diskKey, diskFormat) {
            if (getIsAdvancedStorageMode()) {
               var storageSelectorDisks =
                  getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
               return virtualDiskPmemService.applyPmemRulesOnVirtualDiskBackingAdvanced(
                  diskKey, backing, storageSelectorDisks);
            } else {
               var storageBaselineId = getStorageBaselineId();
               return virtualDiskPmemService.applyPmemRulesOnVirtualDiskBacking(
                  backing, storageBaselineId, diskFormat);
            }
         };

         var applyPmemRulesOnVirtualDiskBackingForSDRS = function (podSelectionSpec, diskFormat) {
            if (!podSelectionSpec || !podSelectionSpec.initialVmConfig) {
               return;
            }
            // There is a separate locator for the VMX file, but the user might have
            // placed only a single disk on SDRS cluster, so find the locator that has
            // non-empty disk array.
            var disksPodLocator = _.find(podSelectionSpec.initialVmConfig, function (diskPodLocator) {
               return (diskPodLocator.disk && diskPodLocator.disk.length);
            });
            if (!disksPodLocator) {
               return;
            }

            if (getIsAdvancedStorageMode()) {
               var storageSelectorDisks =
                  getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
               _.forEach(disksPodLocator.disk, function (disk) {
                  disk.diskBackingInfo = virtualDiskPmemService.applyPmemRulesOnVirtualDiskBackingAdvanced(
                     disk.diskId, disk.diskBackingInfo, storageSelectorDisks);
               });
            } else {
               var storageBaselineId = getStorageBaselineId();
               _.forEach(disksPodLocator.disk, function (disk) {
                  disk.diskBackingInfo = virtualDiskPmemService.applyPmemRulesOnVirtualDiskBacking(
                     disk.diskBackingInfo, storageBaselineId, diskFormat);
               });
            }
         };

         var getPmemDiskDeviceChanges = function (virtualDisks) {
            var result = [];
            var virtualDiskConvertedToDeviceChange;
            if (getIsAdvancedStorageMode()) {
               var storageSelectorDisks =
                  getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
               _.forEach(virtualDisks, function (originalVirtualDisk) {
                  virtualDiskConvertedToDeviceChange =
                     virtualDiskPmemService.convertVirtualDiskToDeviceChangeForPmemAdvanced(
                        originalVirtualDisk, storageSelectorDisks);
                  if (virtualDiskConvertedToDeviceChange) {
                     result.push(virtualDiskConvertedToDeviceChange);
                  }
               });
               return result;
            } else {
               var storageBaselineId = getStorageBaselineId();
               var diskStorageProfile = getSelectedStorageProfileForDisks();
               _.forEach(virtualDisks, function (originalVirtualDisk) {
                  virtualDiskConvertedToDeviceChange =
                     virtualDiskPmemService.convertVirtualDiskToDeviceChangeForPmem(
                        originalVirtualDisk, storageBaselineId, diskStorageProfile);
                  if (virtualDiskConvertedToDeviceChange) {
                     result.push(virtualDiskConvertedToDeviceChange);
                  }
               });
            }

            return result;
         };

         var getBackingInfoForDisk = function (diskDevice, diskFormat) {
            if (!diskFormat || !diskFormat.type || !diskDevice) {
               return;
            }
            if (pmemUtilService.isPmemDisk(diskDevice)) {
               return diskDevice.backing;
           }
           if (diskFormat.type === 'sameAsSource') {
               return null;
           } else {
               return diskProvisioningService.getBackingInfo(diskFormat.type);
            }
         };

         var getRelocationSpecInfoForClone = function (diskFormat) {
            return getVirtualDisks().then(function (properties) {
               var virtualDisks = properties['virtualDisks'];
               var virtualDisksApplicableToDiskLocator =
                  filterVirtualDisksBeforeMakingThemDiskLocators(virtualDisks);
               var keepExistingProfileAssignments = !getIsAdvancedStorageMode()
                  && getStorageSelectorState()
                  && getStorageSelectorState().basicModeState
                  && getStorageSelectorState().basicModeState.profilesData
                  && getStorageSelectorState().basicModeState.profilesData.selectedProfile
                  && getStorageSelectorState().basicModeState.profilesData.selectedProfile
                     .keepExistingProfileAssignments;

               // build disk locators only for the datastores that are not placed on storage pod
               var filteredDisks = _.filter(virtualDisksApplicableToDiskLocator, function (diskDevice) {
                  if (!getIsAdvancedStorageMode()) {
                     return storageObjectIsStandaloneDs();
                  }
                  var storageSelectorDisks =
                        getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
                  var storageSelectorDisk = _.find(storageSelectorDisks, function (disk) {
                     return disk.key === diskDevice.key;
                  });
                  return storageObjectIsStandaloneDs(storageSelectorDisk.storageObj);
               });

               var diskRelocationSpecs = _.map(filteredDisks, function (diskDevice) {
                  return buildDiskLocator(diskDevice, diskFormat);
               });
               // As we don't want to send relocates for the disks placed on storage pods
               diskRelocationSpecs = _.filter(diskRelocationSpecs, function (disk) {
                  return disk.datastore !== null;
               });

               var relocationSpecInfo =  {
                  deviceChange: getPmemDiskDeviceChanges(virtualDisks),
                  disk: diskRelocationSpecs
               };

               // If we are in basic mode and keeping the existing storage profiles,
               // then use the source VM's profile
               var vmHomeProfileId = keepExistingProfileAssignments
                  ? getSourceVmStorageConfig().vmHome.storageProfile.id
                  : getSelectedStorageProfile().profileId;
               var vmHomeProfile = [storageProfileService.makeProfile(
                  vmHomeProfileId,
                  getSelectedReplicationGroupInfo())];
               relocationSpecInfo.profile = vmParams.containsSpbmIssues
                  ? []
                  : vmHomeProfile;
               return relocationSpecInfo;
            });
         };

         var buildDiskLocator = function (diskDevice, diskFormat) {
            diskFormat = diskFormat || vmParams.diskFormat;
            var datastoreRef = storageObjectIsStandaloneDs() ?
                  getStorageObject().storageRef
                  : null;
            if (getIsAdvancedStorageMode()) {
               var storageSelectorDisks =
                     getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
               var storageSelectorDisk = _.find(storageSelectorDisks, function (disk) {
                  return disk.key === diskDevice.key;
               });
               datastoreRef = storageObjectIsStandaloneDs(storageSelectorDisk.storageObj)
                     ? storageSelectorDisk.storageObj.storageRef
                     : null;
               diskFormat = storageSelectorDisk.diskFormat;
            }
            var diskBacking = getBackingInfoForDisk(diskDevice, diskFormat);
            diskBacking = applyPmemRulesOnVirtualDiskBacking(diskBacking, diskDevice.key, diskFormat);
            var diskRelocationSpec = {
               '_type': 'com.vmware.vim.binding.vim.vm.RelocateSpec$DiskLocator',
               'datastore': datastoreRef,
               'diskBackingInfo': diskBacking,
               'diskId': diskDevice.key
            };
            diskRelocationSpec.profile = makeStorageProfile(diskDevice);

            return diskRelocationSpec;
         };

         var setStorageForDisk = function (storageObj, disk) {
            vmParams.storageDiskList = vmParams.storageDiskList || {};

            if (!storageObj) {
               delete vmParams.storageDiskList[disk.key];
               return;
            }

            vmParams.storageDiskList[disk.key] = {
               diskKey: disk.key,
               diskBacking: disk.backing,
               dsId: storageObj.id,
               dsName: storageObj.name,
               dsObject: storageObj.storageObject || storageObj // in case we pass storage pod
            };
         };

         function getStorageDiskList() {
            return vmParams.storageDiskList;
         }

         var getStorageForDisk = function (diskKey) {
            if (vmParams.storageDiskList && vmParams.storageDiskList[diskKey]) {
               return vmParams.storageDiskList[diskKey];
            }
            return null;
         };

         var getStorageNameForDisk = function (diskKey) {
            if (vmParams.storageDiskList && vmParams.storageDiskList[diskKey]) {
               return vmParams.storageDiskList[diskKey].dsName;
            }
            return null;
         };

         var getStorageNameAndIdForDisk = function (diskKey) {
            if (vmParams.storageDiskList && vmParams.storageDiskList[diskKey]) {

               return {
                  name: vmParams.storageDiskList[diskKey].dsName,
                  id: vmParams.storageDiskList[diskKey].dsId
               };
            }
            return null;
         };

         var getVmCreateSpec = function () {
            var resPoolMoRef = defaultUriSchemeUtil.getManagedObjectReference(getResourcePool().id);

            var parentType = 'folder';
            var folderMoRef;
            // The folder should populated only if the parent type is folder.
            // In VApp case the folder must not be set.
            if (resPoolMoRef.type === managedEntityConstants.V_APP || isResourcePoolInVapp()) {
               parentType = 'vapp';
               folderMoRef = null;
            } else {
               folderMoRef = defaultUriSchemeUtil.getManagedObjectReference(
                  getTargetInformation().folderUid);
            }

            // This holds the compute resource selected on the compute resource page,
            // can be cluster, host, resource pool or vapp (or maybe none of these?).
            var computeResMoRef =
               defaultUriSchemeUtil.getManagedObjectReference(getComputeResourceId());
            var hostRef = null;
            if (computeResMoRef.type === managedEntityConstants.HOST) {
               hostRef = computeResMoRef;
            }
            var deviceChanges = getVirtualMachineDevices().getDeviceChanges();

            var vmCreateSpec = {
               parentType: parentType,
               folder: folderMoRef,
               pool: resPoolMoRef,
               host: hostRef,
               spec: {
                  config: angular.merge({
                     _type: "com.vmware.vim.binding.vim.vm.ConfigInfo",
                     name: getName(),
                     guestId: getGosVersion().id,
                     alternateGuestName: getGosName() ? getGosName() : null
                  }, getVmConfigSpec().config),
                  deviceChange: deviceChanges,
                  npivWwnOp: getVmConfigSpec().config.npivWwnOp,
                  cpuFeatureMask: cpuService.createCpuIdInfoDelta(
                     [], getVmConfigSpec().config.cpuFeatureMask)
               }
            };

            var storageProfile = getSelectedStorageProfile();
            if (storageProfile && !vmParams.containsSpbmIssues) {
               vmCreateSpec.spec.profile = [
                  storageProfileService.makeProfile(storageProfile.id, getSelectedReplicationGroupInfo())];
            } else {
               vmCreateSpec.spec.profile = [];
            }

            diskProvisioningService.setBackingDatastore(
               deviceChanges,
               getStorageObject(),
               vmParams.storageDiskList
            );


            vmCreateSpec.podSelectionSpec = podSelectionSpecService.createSpec(
               getNewVirtualDisks(deviceChanges),
               getStorageObject(),
               vmParams.storageDiskList);

            return vmCreateSpec;
         };

         var getDeployVmtxSpec = function () {
            var clusterValueField = null;
            var resourcePoolValueField = null;
            var hostValueField = null;
            var folderValueField = null;
            var folderUri = null;
            var gosCustomizationSpecName = null;

            var computeResMoRef =
                  defaultUriSchemeUtil.getManagedObjectReference(getComputeResourceId());
            switch (computeResMoRef.type) {
               case managedEntityConstants.CLUSTER:
                  clusterValueField = computeResMoRef.value;
                  break;
               case managedEntityConstants.HOST:
                  hostValueField = computeResMoRef.value;
                  break;
               case managedEntityConstants.RESOURCE_POOL:
                  resourcePoolValueField = computeResMoRef.value;
                  break;
               case managedEntityConstants.V_APP:
                  // NOTE: Setting V_APP value as a resource pool.
                  resourcePoolValueField = computeResMoRef.value;
                  break;
               default:
                  break;
            }
            var targetInformation = getTargetInformation();
            if (targetInformation && targetInformation.folderUid) {
               folderUri = targetInformation.folderUid;
            }
            if (folderUri) {
               folderValueField =
                     defaultUriSchemeUtil.getManagedObjectReference(folderUri).value;
            }
            if (getCustomizationSpecName()) {
               gosCustomizationSpecName = getCustomizationSpecName();
            }





            return _.extend({
               name: getName(),
               libraryItemUri: getLibraryItemId(),
               powerOn: getCloneOptions().powerOn,
               guestCustomizationSpec: {name: gosCustomizationSpecName},
               placementSpec: {
                  folder: folderValueField,
                  cluster: clusterValueField,
                  resourcePool: resourcePoolValueField,
                  host: hostValueField
               },
               hardwareCustomization: getHardwareCustomizationSpec()
            }, getVmtxStorageSpecSettings());
         };

         var getHardwareCustomizationSpec = function () {

            var hardwareCustomizationSpec;

            if (getCustomizeCloneHardware() === true) {
               var deviceChanges = getVirtualMachineDevices().getDeviceChanges();
               var cpuUpdate = {
                  numCpus: getVmConfigSpec().hardware.numCPU,
                  numCoresPerSocket:  getVmConfigSpec().hardware.numCoresPerSocket
               };
               var memoryUpdate = {
                  memory: getVmConfigSpec().hardware.memoryMB
               };
               var originalConfig = getVmOriginalConfigSpec();
               var originalVDisks = _.filter(originalConfig.hardware.device, function (deviceChange) {
                  return vmDeviceInfoService.isDeviceSubclassOf(deviceChange, 'VirtualDisk');
               });

               var updatedHarddisk = _.filter(deviceChanges, function(deviceSpec) {
                  if (deviceClassLineageService.isClassNameSubclassOf(
                        deviceSpec.device._type, deviceTypeConstants.VIRTUALDISK) && deviceSpec.operation === deviceOperationConstants.EDIT) {
                     //return true;
                     var orig = _.find(originalVDisks, function(origDevice){ return origDevice.key === deviceSpec.device.key; });
                     if(orig.capacityInBytes !== deviceSpec.device.capacityInBytes){
                        return true;
                     }
                  }
                  return false;
               });

               var deletedHarddisk = _.filter(deviceChanges, function(deviceSpec) {
                  if (deviceClassLineageService.isClassNameSubclassOf(
                        deviceSpec.device._type, deviceTypeConstants.VIRTUALDISK) && deviceSpec.operation === deviceOperationConstants.REMOVE) {
                     return true;
                  }
                  return false;
               });

               var disksToUpdate = {};
               _.each(updatedHarddisk, function (deviceSpec) {
                  disksToUpdate[deviceSpec.device.key] = {
                     capacity: deviceSpec.device.capacityInBytes
                  };
               });

               var disksToRemove = [];
               _.each(deletedHarddisk, function (deviceSpec) {
                  disksToRemove.push(deviceSpec.device.key);
               });

               var nics = {};
               var virtualMachineDevices = getVirtualMachineDevices();
               _.each(getUpdatedNetwork(), function (deviceSpec) {
                  var deviceNetwork =
                     virtualMachineDevices.getVirtualDevice(deviceSpec.device.key).network;
                  nics[deviceSpec.device.key] = {
                     network: defaultUriSchemeUtil
                        .getVsphereObjectId(deviceNetwork.network
                           ? deviceNetwork.network.network
                           : deviceNetwork.portgroup)
                  };
               });

               hardwareCustomizationSpec = {
                  cpuUpdate: cpuUpdate,
                  memoryUpdate: memoryUpdate,
                  disksToUpdate: disksToUpdate,
                  disksToRemove: disksToRemove,
                  nics: nics
               };

            }
            return hardwareCustomizationSpec;
         };

         var getUpdatedNetwork = function () {
            var deviceChanges = getVirtualMachineDevices().getDeviceChanges();
            return _.filter(deviceChanges, function(deviceSpec) {
               if (!deviceClassLineageService.isClassNameSubclassOf(
                     deviceSpec.device._type, deviceTypeConstants.VIRTUALDISK) && deviceSpec.operation === deviceOperationConstants.EDIT) {
                  return true;
               }
               return false;
            });
         };

         var getVmRecommendationsSpec = function () {
            return vmParams.recommendationSpec;
         };

         var setVmRecommendationsSpec = function (recommendationSpec) {
            vmParams.recommendationSpec = recommendationSpec;
         };

         var setCustomizeCloneHardware = function (customizeHardware) {
            vmParams.customizeHardware = customizeHardware;
         };

         var getCustomizeCloneHardware = function () {
            return vmParams.customizeHardware;
         };

         /**
          * If a network adapter is reassigned to a different network, remove it's data
          * from the configSpec's deviceChange property and move it to the relocationSpec's deviceChange
          * @param configSpec - the VmConfigSpec
          * @param relocationSpec
          */
         var moveReassignedNetworkAdapters = function(configSpec, relocationSpec) {
            if (!configSpec || _.isEmpty(configSpec.deviceChange)) {
               return;
            }

            relocationSpec.deviceChange = _.isEmpty(relocationSpec.deviceChange)
                  ? []
                  : relocationSpec.deviceChange;

            configSpec.deviceChange = _.filter(configSpec.deviceChange, function(deviceSpec) {
               if (!deviceClassLineageService.isClassNameSubclassOf(
                     deviceSpec.device._type, deviceTypeConstants.ETHERNET)) {
                  return true;
               }
               if (deviceSpec.operation !== "edit") {
                  return true;
               }
               relocationSpec.deviceChange.push(deviceSpec);
               return false;
            });

         };

         var getVmCloneSpec = function () {
            return getRelocationSpecInfoForClone(vmParams.diskFormat).then(function (relocationSpec) {
               return getVirtualDisks().then(function (properties) {
                  var hostRef = null;
                  var computeResourceRef =
                     defaultUriSchemeUtil.getManagedObjectReference(vmParams.computeResourceId);
                  if (computeResourceRef.type === managedEntityConstants.HOST) {
                     hostRef = computeResourceRef;
                  }

                  var resPoolRef = null;
                  if (vmParams.resourcePool.id) {
                     resPoolRef =
                        defaultUriSchemeUtil.getManagedObjectReference(vmParams.resourcePool.id);
                  }

                  var datastoreRef = !storageObjectIsPod() ?
                     getStorageObject().storageRef :
                     null;

                  var vmDevices = getVirtualMachineDevices();

                  var vmCloneSpec = {
                     vm: defaultUriSchemeUtil.getManagedObjectReference(getVmId()),
                     name: getName(),
                     folder: defaultUriSchemeUtil.getManagedObjectReference(getTargetInformation().folderUid),
                     cloneSpec: {
                        '_type': 'com.vmware.vim.binding.vim.vm.CloneSpec',
                        location: {
                           '_type': 'com.vmware.vim.binding.vim.vm.RelocateSpec',
                           host: hostRef,
                           pool: resPoolRef,
                           datastore: datastoreRef,
                           profile: relocationSpec.profile,
                           deviceChange: relocationSpec.deviceChange
                        },
                        template: isTargetATemplate()
                     }
                  };

                  var deviceChanges = [];
                  if (vmDevices) {
                     appendStorageProfileToExistingDisks(
                           vmDevices.existingDevicesOfType(deviceTypeConstants.VIRTUALDISK));
                     deviceChanges = vmDevices.getDeviceChanges();
                  }
                  if (getCustomizeCloneHardware() === true) {
                     var originalConfig = getVmOriginalConfigSpec();
                     var originalCpuFeatureMask = originalConfig.cpuFeatureMask !== null ?
                           originalConfig.cpuFeatureMask : [];
                     var config = getVmConfigSpec();
                     vmCloneSpec.vmSpec = {
                        _type: 'com.vmware.vsphere.client.vm.VmConfigSpec',
                        originalConfig: originalConfig,
                        config: config,
                        deviceChange: deviceChanges,
                        npivWwnOp: config.npivWwnOp,
                        cpuFeatureMask: cpuService.createCpuIdInfoDelta(
                              originalCpuFeatureMask, config.cpuFeatureMask),
                        profile: []
                     };

                     var storageProfile = getSelectedStorageProfile();
                     if (storageProfile && !vmParams.containsSpbmIssues) {
                        vmCloneSpec.vmSpec.profile.push(
                              storageProfileService.makeProfile(
                                    storageProfile.id, getSelectedReplicationGroupInfo()));
                     }

                     if (deviceChanges) {
                        diskProvisioningService.setBackingDatastore(
                           deviceChanges,
                           getStorageObject(),
                           vmParams.storageDiskList);
                     }
                  }

                  moveReassignedNetworkAdapters(vmCloneSpec.vmSpec, relocationSpec);
                  vmCloneSpec.cloneSpec.location.deviceChange = relocationSpec.deviceChange;

                  var cloneOptions = getCloneOptions();
                  if (cloneOptions) {
                     vmCloneSpec.cloneSpec.powerOn = cloneOptions.powerOn;

                     var customizationSpec = getCustomizationSpec();
                     if (cloneOptions.customizeOs && customizationSpec) {
                        vmCloneSpec.cloneSpec.customization = customizationSpec;
                     }
                  }

                  // Only send out relocate information if we have disks relocated on standalone DSs
                  if (relocationSpec && relocationSpec.disk) {
                     _.extend(vmCloneSpec.cloneSpec.location, relocationSpec);
                  }

                  var originalVirtualDisks = properties['virtualDisks'];
                  var filteredOriginalDisks =
                     filterVirtualDisksBeforeMakingThemDiskLocators(originalVirtualDisks);
                  var newVirtualDisks = getNewVirtualDisks(deviceChanges);
                  var filteredNewVirtualDisks =
                     filterVirtualDisksBeforeMakingThemDiskLocators(newVirtualDisks, true);
                  var storageVirtualDisks = getVmDisksStorage()[getVmId()];
                  vmCloneSpec.podSelectionSpec = podSelectionSpecService.createSpecForClone(
                     filteredOriginalDisks,
                     filteredNewVirtualDisks,
                     getStorageObject(),
                     vmParams.diskFormat,
                     vmParams.storageDiskList,
                     storageVirtualDisks);
                  applyPmemRulesOnVirtualDiskBackingForSDRS(vmCloneSpec.podSelectionSpec, vmParams.diskFormat);
                  return vmCloneSpec;
               });
            });
         };

         var getNewVirtualDisks = function (deviceChanges) {
            if (deviceChanges) {
               var newVirtualDisksChanges = _.filter(deviceChanges, function (deviceChange) {
                  return vmDeviceInfoService.isDeviceSubclassOf(deviceChange.device, "VirtualDisk")
                     && deviceChange.device.key < 0;
               });

               return _.map(newVirtualDisksChanges, function (deviceChange) {
                  return appendStorageProfileToDisk(deviceChange.device);
               });
            }
            return [];
         };

         var isTargetATemplate = function () {
            return _.include([
               creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE,
               creationTypeConstants.CLONE_VM_TO_TEMPLATE
            ], getCreationType());
         };

         function queryConfigOptionByPoolItnernal(vmVersion, useCache) {
            if (useCache && _vmConfigOptionByVmVersion &&
               _vmConfigOptionByVmVersion.vmVersion === vmVersion) {
               return _vmConfigOptionByVmVersion.promise;
            }

            _vmConfigOptionByVmVersion = {
               vmVersion: vmVersion
            };

            var hostRef = null;
            var computeResourceRef =
               defaultUriSchemeUtil.getManagedObjectReference(vmParams.computeResourceId);
            if (computeResourceRef.type === managedEntityConstants.HOST) {
               hostRef = computeResourceRef;
            }

            var params = [{
               propertyName: 'vmConfigOptionByPool',
               parameterType: 'com.vmware.vsphere.client.h5.vm.model.provisioning.GuestOsVersionParams',
               parameter: {
                  _type: 'com.vmware.vsphere.client.h5.vm.model.provisioning.GuestOsVersionParams',
                  key: vmVersion,
                  host: hostRef
               }
            }];

            _vmConfigOptionByVmVersion.promise =
               dataService.getProperties(
                  vmParams.resourcePool.id,
                  ['vmConfigOptionByPool'],
                  {
                     propertyParams: params
                  }
               ).then(function (configOption) {
                  return configOption;
               });
            return _vmConfigOptionByVmVersion.promise;
         }

         var queryConfigOptionByPool = function (vmVersion) {
            // get the vm config option from the server always, this function is called
            // whenever the vm compatibility has changed, so we need to re-request the
            // vm config option for the new vm version
            return queryConfigOptionByPoolItnernal(vmVersion, false/*useCache*/);
         };

         var getConfigOptionByPool = function () {
            // get the vm config option from cache if available
            return queryConfigOptionByPoolItnernal(getVmVersion(), true/*useCache*/);
         };

         var getVmConfigEnvironmentForGos = function(gosVersion) {
            getVmConfigEnvironmentForVmVersion(getVmVersion(), gosVersion.id);
         };

         var getVmConfigEnvironmentForVmVersion = function (vmVersion, gosVersion) {
            if (_vmConfigEnvironmentPromise) {
               return _vmConfigEnvironmentPromise;
            }

            var hostRef = null;
            var computeResourceRef =
               defaultUriSchemeUtil.getManagedObjectReference(vmParams.computeResourceId);
            if (computeResourceRef.type === managedEntityConstants.HOST) {
               hostRef = computeResourceRef;
            }

            var gosId = getCreationType() === creationTypeConstants.CREATE_FROM_SCRATCH ?
                  (getGosVersion() ? getGosVersion().id : null) : getGuestOsId();
            gosId = gosId || gosVersion;
            _latestGosId = gosId;

            var params = [{
               propertyName: 'vmConfigEnvironmentPerPool',
               parameterType: 'com.vmware.vsphere.client.h5.vm.model.provisioning.VmConfigEnvironmentPerPoolParams',
               parameter: {
                  _type: 'com.vmware.vsphere.client.h5.vm.model.provisioning.VmConfigEnvironmentPerPoolParams',
                  key: vmVersion,
                  hostRef: hostRef,
                  gosId: gosId
               }
            }];
            _vmConfigEnvironmentPromise =
                  dataService.getProperties(
                        vmParams.resourcePool.id,
                        ['vmConfigEnvironmentPerPool'],
                        {
                           propertyParams: params
                        }
                  ).then(function(vmConfigEnvironment) {
                     vmParams.envBrowserRef =
                           vmConfigEnvironment.vmConfigEnvironmentPerPool.envBrowserRef;
                     return vmConfigEnvironment;
                  });

            return _vmConfigEnvironmentPromise;
         };

         var getVmConfigEnvironment = function () {
            return getVmConfigEnvironmentForVmVersion(getVmVersion());
         };

         var getDiskChanges = function () {
            return filterChangesByType('VirtualDisk');
         };

         var getTpmChanges = function () {
            return filterChangesByType('VirtualTPM');
         };

         var getScsiControllerChanges = function () {
            return filterChangesByType('VirtualSCSIController');
         };

         var filterChangesByType = function (deviceType) {
            return _.filter(getVirtualMachineDevices().getDeviceChanges(), function (deviceChange) {
               return vmDeviceInfoService.isDeviceSubclassOf(deviceChange.device, deviceType);
            });
         };

         var getFilterNetworksObjectId = function () {
            return vmParams.filterNetworksObjectId;
         };

         var setFilterNetworksObjectId = function (objectId) {
            vmParams.filterNetworksObjectId = objectId;
         };

         var getRegisterVmData = function () {
            return vmParams.registerVmData;
         };

         var setRegisterVmData = function (data) {
            vmParams.registerVmData = data;
         };

         var isXvc = function () {
            var sourceVmId = getVmId();
            var targetInformation = getTargetInformation();
            if (!sourceVmId || !targetInformation || !targetInformation.targetUid) {
               return false;
            }

            var sourceVmSeverGuid = defaultUriSchemeUtil
               .getPartsFromVsphereObjectId(sourceVmId).serverGuid;
            var targetSeverGuid = defaultUriSchemeUtil
               .getPartsFromVsphereObjectId(targetInformation.targetUid).serverGuid;
            return sourceVmSeverGuid !== targetSeverGuid;
         };

         function setIsAdvancedStorageMode(isAdvanced) {
            vmParams.isAdvancedStorageMode = isAdvanced;
         }

         function getIsAdvancedStorageMode() {
            return vmParams.isAdvancedStorageMode;
         }

         function getVmDisksStorage() {
            return vmParams.vmDisksStorage;
         }

         function setVmDisksStorage(storageForDisks) {
            vmParams.vmDisksStorage = storageForDisks;
         }

         function getStorageSelectorState() {
            return vmParams.storageSelectorState;
         }

         function setStorageSelectorState(state) {
            vmParams.storageSelectorState = state;
         }

         function resetStorage () {
            vmParams.storageSelectorState = undefined;
         }

         function getStorageSelectorStatePerDisk(diskKey) {
            var disks = getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
            return _.find(disks, function (disk) {
               return disk.key === diskKey;
            });
         }

         function getProvisioningTypePerDisk(diskKey) {
            var diskFormat;
            if (getIsAdvancedStorageMode()) {
               var disk = getStorageSelectorStatePerDisk(diskKey);
               diskFormat = disk.diskFormat;
            } else {
               diskFormat = getDiskFormat();
            }

            return diskFormat ? diskFormat.name : undefined;
         }

         function containsSpbmIssues(value) {
            vmParams.containsSpbmIssues = value;
         }

         function getLibraryItemId() {
            return vmParams.libraryItemId;
         }

         function setLibraryItemId(value) {
            vmParams.libraryItemId = value;
         }

         function getVmtxLibraryItemId() {
            return vmParams.vmtxLibraryItemId;
         }

         function setVmtxLibraryItemId(value) {
            vmParams.vmtxLibraryItemId = value;
         }

         function setVmtxStorageSpecSettings(settings) {
            vmParams.vmtxStorageSpecSettings = settings;
         }

         function getVmtxStorageSpecSettings() {
            return vmParams.vmtxStorageSpecSettings;
         }

         function getCustomizationSpecName() {
            return vmParams.customizationSpecName;
         }

         function setCustomizationSpecName(specName) {
            vmParams.customizationSpecName = specName;
         }

         function getPrivileges() {
            if(_targetPrivilegesPromise) {
               return _targetPrivilegesPromise;
            }

            var targetId = getTargetInformation().folderUid;
            var requiredPrivileges = REQUIRED_PRIVILEGES_CREATE;

            if (getCreationType() !== creationTypeConstants.CREATE_FROM_SCRATCH) {
               requiredPrivileges = REQUIRED_PRIVILEGES_CLONE;
            } else {
               if (isResourcePoolInVapp()) {
                  targetId = getComputeResourceId();
               }
            }

            _targetPrivilegesPromise = authorizationService.checkGrantedPrivileges(
                  targetId, requiredPrivileges).then(function (privileges) {
               var filteredPrivileges = [];
               _.each(privileges, function (isPrivilegeAvailable, index) {
                  if (isPrivilegeAvailable) {
                     filteredPrivileges.push(requiredPrivileges[index]);
                  }
               });

               return filteredPrivileges;
            });

            return _targetPrivilegesPromise;
         }

         function getAdvancedStoragePageData() {
            if (_vmAdvancedStorageDataPromise) {
               return _vmAdvancedStorageDataPromise;
            }

            var vmId = getVmId();
            if (vmId) {
               _vmAdvancedStorageDataPromise = dataService.getProperties(
                     vmId, ['advancedStoragePageData'], { skipLoadingNotification: true });
            }
            return _vmAdvancedStorageDataPromise;
         }

         function getStoragePageData() {
            if (_vmStoragePageDataPromise) {
               return _vmStoragePageDataPromise;
            }

            var targetInformation = getTargetInformation();
            var rootFolder = defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(
                  targetInformation.datacenterUid);
            if (rootFolder) {
               _vmStoragePageDataPromise = dataService.getProperties(
                     rootFolder, ['vmStoragePageData', 'h5DefaultKmipClusterStatus',
                     'grantedPrivileges']).then(function(response) {
                        return {
                           vmStoragePageData: response.vmStoragePageData ?
                              _.extend(response.vmStoragePageData, {
                                 h5DefaultKmipClusterStatus: response.h5DefaultKmipClusterStatus,
                                 hasProfileViewPrivilege: response.grantedPrivileges ?
                                    _.contains(response.grantedPrivileges, 'StorageProfile.View') :
                                    undefined
                           }) : undefined };
               });
            }
            return _vmStoragePageDataPromise;
         }

         return {
            setCreationType: setCreationType,
            getCreationType: getCreationType,
            setVmId: setVmId,
            getVmId: getVmId,
            setName: setName,
            getName: getName,
            setHasEncryptNewVmPrivilege: setHasEncryptNewVmPrivilege,
            getHasEncryptNewVmPrivilege: getHasEncryptNewVmPrivilege,
            setHasManageEncryptionPolicyPrivilege: setHasManageEncryptionPolicyPrivilege,
            getHasManageEncryptionPolicyPrivilege: getHasManageEncryptionPolicyPrivilege,
            getTemplateName: getTemplateName,
            setTemplateName: setTemplateName,
            setTargetInformation: setTargetInformation,
            getTargetInformation: getTargetInformation,
            setRecreateVm: setRecreateVm,
            getRecreateVm: getRecreateVm,
            setComputeResourceId: setComputeResourceId,
            getComputeResourceId: getComputeResourceId,
            getComputeResourceOwnerId: getComputeResourceOwnerId,
            setComputeResourceOwnerId: setComputeResourceOwnerId,
            setComputeResourceName: setComputeResourceName,
            getComputeResourceName: getComputeResourceName,
            getResourcePool: getResourcePool,
            setResourcePool: setResourcePool,
            isResourcePoolInVapp: isResourcePoolInVapp,
            setIsResourcePoolInVapp: setIsResourcePoolInVapp,
            getVmOriginalConfigSpec: getVmOriginalConfigSpec,
            setVmOriginalConfigSpec: setVmOriginalConfigSpec,
            getSourceVmStorageConfig: getSourceVmStorageConfig,
            setSourceVmStorageConfig: setSourceVmStorageConfig,
            getVmConfigSpec: getVmConfigSpec,
            setVmConfigSpec: setVmConfigSpec,
            getStorageObject: getStorageObject,
            getDisableSdrs: getDisableSdrs,
            setDisableSdrs: setDisableSdrs,
            getVmVersion: getVmVersion,
            setVmVersion: setVmVersion,
            getScheduledVmVersion: getScheduledVmVersion,
            setScheduledVmVersion: setScheduledVmVersion,
            getScheduledData: getScheduledData,
            setScheduledData: setScheduledData,
            getGosFamily: getGosFamily,
            getGosVersion: getGosVersion,
            getGosName: getGosName,
            setGosName: setGosName,
            setGuestOsId: setGuestOsId,
            getGuestOsId: getGuestOsId,
            setScheduledGuestOsId: setScheduledGuestOsId,
            getScheduledGuestOsId: getScheduledGuestOsId,
            setScheduledGuestName: setScheduledGuestName,
            getScheduledGuestName: getScheduledGuestName,
            setGosFamilyAndVersion: setGosFamilyAndVersion,
            setCustomPcName: setCustomPcName,
            setCustomIpv4ForNIC: setCustomIpv4ForNIC,
            setCustomIpv6ForNIC: setCustomIpv6ForNIC,
            setCustomizationSpec: setCustomizationSpec,
            getCustomizationSpec: getCustomizationSpec,
            setCustomizationSpecInfo: setCustomizationSpecInfo,
            getCustomizationSpecInfo: getCustomizationSpecInfo,
            getVirtualMachineDevices: getVirtualMachineDevices,
            setVirtualMachineDevices: setVirtualMachineDevices,
            setCloneOptions: setCloneOptions,
            getCloneOptions: getCloneOptions,
            setSelectedStorageProfile: setSelectedStorageProfile,
            getSelectedStorageProfile: getSelectedStorageProfile,
            getSelectedReplicationGroupInfo: getSelectedReplicationGroupInfo,
            setSelectedReplicationGroupInfo: setSelectedReplicationGroupInfo,
            setSelectedStorageProfileForDisks: setSelectedStorageProfileForDisks,
            getSelectedStorageProfileForDisks: getSelectedStorageProfileForDisks,
            storageObjectIsPod: storageObjectIsPod,
            storageObjectIsStandaloneDs: storageObjectIsStandaloneDs,
            setStorageObjectAndDiskFormat: setStorageObjectAndDiskFormat,
            setStorageObject: setStorageObject,
            getDiskFormat: getDiskFormat,
            getVmCreateSpec: getVmCreateSpec,
            getVmRecommendationsSpec: getVmRecommendationsSpec,
            setVmRecommendationsSpec: setVmRecommendationsSpec,
            getCustomizeCloneHardware: getCustomizeCloneHardware,
            setCustomizeCloneHardware: setCustomizeCloneHardware,
            getVmCloneSpec: getVmCloneSpec,
            getVmConfigEnvironmentForVmVersion: getVmConfigEnvironmentForVmVersion,
            getVmConfigEnvironment: getVmConfigEnvironment,
            getConfigOptionByPool: getConfigOptionByPool,
            queryConfigOptionByPool: queryConfigOptionByPool,
            setStorageForDisk: setStorageForDisk,
            getStorageDiskList: getStorageDiskList,
            getStorageForDisk: getStorageForDisk,
            getStorageNameForDisk: getStorageNameForDisk,
            getDiskChanges: getDiskChanges,
            getScsiControllerChanges: getScsiControllerChanges,
            getTpmChanges: getTpmChanges,
            getStorageNameAndIdForDisk: getStorageNameAndIdForDisk,
            getFilterNetworksObjectId: getFilterNetworksObjectId,
            setFilterNetworksObjectId: setFilterNetworksObjectId,
            getRegisterVmData: getRegisterVmData,
            setRegisterVmData: setRegisterVmData,
            isXvc: isXvc,
            setIsAdvancedStorageMode: setIsAdvancedStorageMode,
            getIsAdvancedStorageMode: getIsAdvancedStorageMode,
            getVmDisksStorage: getVmDisksStorage,
            setVmDisksStorage: setVmDisksStorage,
            getStorageSelectorState: getStorageSelectorState,
            setStorageSelectorState: setStorageSelectorState,
            resetStorage: resetStorage,
            getStorageSelectorStatePerDisk: getStorageSelectorStatePerDisk,
            getProvisioningTypePerDisk: getProvisioningTypePerDisk,
            containsSpbmIssues: containsSpbmIssues,
            shouldRetrieveGosDescriptor: shouldRetrieveGosDescriptor,
            retrieveGosDescriptor: retrieveGosDescriptor,
            getVmConfigEnvironmentForGos: getVmConfigEnvironmentForGos,
            getPrivileges: getPrivileges,
            getAdvancedStoragePageData: getAdvancedStoragePageData,
            getStoragePageData: getStoragePageData,
            setVbsEnabled: setVbsEnabled,
            getVbsEnabled: getVbsEnabled,
            setVbsSupported: setVbsSupported,
            getVbsSupported: getVbsSupported,
            getDeployVmtxSpec: getDeployVmtxSpec,
            getLibraryItemId: getLibraryItemId,
            setLibraryItemId: setLibraryItemId,
            getVmtxLibraryItemId: getVmtxLibraryItemId,
            setVmtxLibraryItemId: setVmtxLibraryItemId,
            setVmtxStorageSpecSettings: setVmtxStorageSpecSettings,
            getVmtxStorageSpecSettings: getVmtxStorageSpecSettings,
            setCustomizationSpecName: setCustomizationSpecName,
            getCustomizationSpecName: getCustomizationSpecName,
            getUpdatedNetwork: getUpdatedNetwork
         };
      };
      return VirtualMachineSpecBuilder;
   }]);

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmCreateScheduledTaskEditDefaultsValidationSpec = com.vmware.vsphere.client.h5.vm.model.provisioning.VmCreateScheduledTaskEditDefaultsValidationSpec;
    var VmCloneEditScheduledTaskService = (function () {
        function VmCloneEditScheduledTaskService(managedEntityConstants, defaultUriSchemeUtil, mutationService, vmDeviceInfoService, initialStorageConfigurationService) {
            this.managedEntityConstants = managedEntityConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.initialStorageConfigurationService = initialStorageConfigurationService;
        }
        VmCloneEditScheduledTaskService.prototype.buildCreateVmData = function (schedulingData) {
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(schedulingData.entity);
            var specArguments = schedulingData.spec.argument;
            var contextObjId = this.defaultUriSchemeUtil.getVsphereObjectId(specArguments[0].value);
            var spec = specArguments[2].value;
            return {
                vmId: vmId,
                contextObjId: contextObjId,
                pool: spec.location.pool,
                host: spec.location.host,
                spec: spec,
                name: specArguments[1].value,
                useScheduledTaskData: true,
            };
        };
        VmCloneEditScheduledTaskService.prototype.setVmParams = function (data, vmParams, wizardViewData) {
            vmParams.setVmId(data.vmId);
            vmParams.setName(data.name);
            wizardViewData.setSourceObjectName(data.originalVmName);
            vmParams.setScheduledData(data);
            vmParams.setGuestOsId(data.guestOsId);
        };
        VmCloneEditScheduledTaskService.prototype.requestScheduledData = function (contextObjectId, data) {
            var _this = this;
            var spec = new VmCreateScheduledTaskEditDefaultsValidationSpec();
            spec.host = data.host;
            spec.pool = data.pool;
            spec.deviceChange = data.spec.location.deviceChange;
            spec.locators = data.spec.location.disk;
            spec.vmProfile = data.spec.location.profile;
            spec.vm = this.defaultUriSchemeUtil.getManagedObjectReference(data.vmId);
            return this.mutationService.validate(contextObjectId, spec._type, spec)
                .then(function (result) {
                var resultData = result.result;
                data.computeResourceId = _this.defaultUriSchemeUtil.getVsphereObjectId(resultData.computeResource);
                data.storageData = _this.prepareStorageState(data.vmId, data.spec.location, resultData.replicationGroupsData);
                data.guestOsId = resultData.guestOsId;
                data.originalVmName = resultData.name;
            });
        };
        VmCloneEditScheduledTaskService.prototype.prepareStorageState = function (vmId, location, replicationGroupsData) {
            var storageData = {
                initialVmStorageConfig: this.initialStorageConfigurationService
                    .computeInitialVmStorageConfig(vmId, location, replicationGroupsData),
                initialViewMode: this.initialStorageConfigurationService.computeStoragePageViewMode(location)
            };
            return storageData;
        };
        VmCloneEditScheduledTaskService.$inject = ["managedEntityConstants", "defaultUriSchemeUtil",
            "mutationService", "vmDeviceInfoService", "initialStorageConfigurationService"];
        return VmCloneEditScheduledTaskService;
    }());
    h5_vm.VmCloneEditScheduledTaskService = VmCloneEditScheduledTaskService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmCloneEditScheduledTaskService", VmCloneEditScheduledTaskService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmCreateScheduledTaskEditDefaultsValidationSpec = com.vmware.vsphere.client.h5.vm.model.provisioning.VmCreateScheduledTaskEditDefaultsValidationSpec;
    var VmCreateEditScheduledTaskService = (function () {
        function VmCreateEditScheduledTaskService(managedEntityConstants, defaultUriSchemeUtil, mutationService, vmDeviceInfoService, initialStorageConfigurationService) {
            this.managedEntityConstants = managedEntityConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.initialStorageConfigurationService = initialStorageConfigurationService;
        }
        VmCreateEditScheduledTaskService.prototype.buildCreateVmData = function (schedulingData) {
            var entity = schedulingData.entity;
            var contextObjId = this.defaultUriSchemeUtil.getVsphereObjectId(entity);
            var pool;
            var host;
            var specArguments = schedulingData.spec.argument;
            var spec = specArguments[0].value;
            if (this.isCreateOnFolder(entity)) {
                pool = specArguments[1].value;
                host = specArguments[2].value;
            }
            else {
                pool = entity;
                host = specArguments[1].value;
            }
            return {
                contextObjId: contextObjId,
                pool: pool,
                host: host,
                spec: spec,
                useScheduledTaskData: true
            };
        };
        VmCreateEditScheduledTaskService.prototype.setVmParams = function (data, vmParams) {
            vmParams.setName(data.spec.name);
            // used for the preselection in the compatibility page
            vmParams.setScheduledVmVersion(data.spec.version);
            // used for the preselection in the select guest os page
            vmParams.setScheduledGuestOsId(data.spec.guestId);
            if (data.spec.alternateGuestName) {
                vmParams.setScheduledGuestName(data.spec.alternateGuestName);
            }
            vmParams.setScheduledData(data);
        };
        VmCreateEditScheduledTaskService.prototype.requestScheduledData = function (contextObjectId, data) {
            var _this = this;
            var spec = new VmCreateScheduledTaskEditDefaultsValidationSpec();
            spec.host = data.host;
            spec.pool = data.pool;
            spec.datastoreNames = this.retrieveDatastoreNames(data.spec);
            spec.vmProfile = data.spec.vmProfile;
            return this.mutationService.validate(contextObjectId, spec._type, spec)
                .then(function (result) {
                var resultData = result.result;
                data.datastoreRefs = resultData.datastoreRefs;
                var datastoreRef = _this.retrieveVmxDatastore(data.spec.files.vmPathName, resultData);
                data.storageData = _this.prepareStorageState(data, datastoreRef, data.datastoreRefs, resultData.replicationGroupsData);
                data.computeResourceId = _this.defaultUriSchemeUtil.getVsphereObjectId(resultData.computeResource);
            });
        };
        VmCreateEditScheduledTaskService.prototype.retrieveVmxDatastore = function (vmxDatastoreName, resultData) {
            var match = vmxDatastoreName.match(/\[(.*)\]/);
            // If regex matched the property type then the regex group matching the
            // comma separated values should be under index 1 in the match
            // (index 0 is always the whole string)
            var datastoreName = match ? match[1] : "";
            var datastoreRef = resultData.datastoreRefs[datastoreName];
            return datastoreRef;
        };
        VmCreateEditScheduledTaskService.prototype.retrieveDatastoreNames = function (spec) {
            var _this = this;
            var datastoreNames = [];
            datastoreNames.push(spec.files.vmPathName);
            _.each(spec.deviceChange, function (device) {
                if (_this.vmDeviceInfoService.isDeviceSubclassOf(device.device, "VirtualDisk")) {
                    datastoreNames.push(device.device.backing.fileName);
                }
            });
            datastoreNames = _.uniq(datastoreNames);
            return datastoreNames;
        };
        VmCreateEditScheduledTaskService.prototype.isCreateOnFolder = function (entity) {
            var isOnFolder = (entity.type === this.managedEntityConstants.FOLDER);
            return isOnFolder;
        };
        VmCreateEditScheduledTaskService.prototype.prepareStorageState = function (data, datastoreRef, datastoreRefs, replicationGroupsData) {
            var storageData = {
                initialVmStorageConfig: this.initialStorageConfigurationService
                    .computeInitialVmStorageConfigForCreateVm(datastoreRef, data.spec.deviceChange, datastoreRefs, data.spec.vmProfile, replicationGroupsData),
                initialViewMode: this.initialStorageConfigurationService.BASIC_MODE
            };
            return storageData;
        };
        VmCreateEditScheduledTaskService.$inject = ["managedEntityConstants", "defaultUriSchemeUtil",
            "mutationService", "vmDeviceInfoService", "initialStorageConfigurationService"];
        return VmCreateEditScheduledTaskService;
    }());
    h5_vm.VmCreateEditScheduledTaskService = VmCreateEditScheduledTaskService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmCreateEditScheduledTaskService", VmCreateEditScheduledTaskService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('vmFactoryService', vmFactoryService);
   vmFactoryService.$inject = [
      'deviceService',
      'guestOsService',
      'VirtualMachineDevices',
      'vmDeviceManagementService',
      'i18nService',
      'deviceTypeConstants',
      'storageProfileService',
      'scheduledTasksDeviceChangesService',
      'vmDeviceInfoService'
   ];

   function vmFactoryService(deviceService,
         guestOsService,
         VirtualMachineDevices,
         vmDeviceManagementService,
         i18nService,
         deviceTypeConstants,
         storageProfileService,
         scheduledTasksDeviceChangesService,
         vmDeviceInfoService
   ) {

      deviceService.addLocalizationKey('VirtualEthernetCard', 'NewEthernet');
      deviceService.addLocalizationKey('VirtualDisk', 'NewDisk');
      deviceService.addLocalizationKey('VirtualSCSIController', 'NewSCSIController');
      deviceService.addLocalizationKey('VirtualSATAController', 'NewSATAController');

      return {
         buildNewVM: buildNewVM,
         buildCloneVM: buildCloneVM,
         applyStorageToVirtualDisks: applyStorageToVirtualDisks,
         buildVirtualDevicesForCreate: buildVirtualDevicesForCreate
      };

      function buildNewVM(vmConfigEnvironment, vmParams, virtualMachineDevices,
            privileges) {
         var id = vmParams.getGosVersion() ? vmParams.getGosVersion().id : vmParams.getGuestOsId();
         var selectedGuestOS = _.find(vmConfigEnvironment.configOption.guestOSDescriptor, function(osDescriptor) {
            return osDescriptor.id === id;
         });
         if (selectedGuestOS === undefined) {
            throw new Error("Could not find Gues OS with ID '" + id + "' among " +
               vmConfigEnvironment.configOption.guestOSDescriptor.length +
               " descriptors.");
         }

         if (!vmParams.getGosVersion()) {
            vmParams.setGosFamilyAndVersion({
               family: selectedGuestOS.family,
               version: selectedGuestOS
            });
         }

         var devices = angular.copy(vmConfigEnvironment.configOption.defaultDevice);

         var scheduledTaskData = vmParams.getScheduledData();
         var useScheduledTask = !_.isEmpty(scheduledTaskData) && scheduledTaskData.useScheduledTaskData;
         var scheduledDataSpec = !_.isEmpty(scheduledTaskData) && scheduledTaskData.spec;
         if (useScheduledTask && scheduledDataSpec) {
            if (scheduledDataSpec.deviceChange) {
               var datastoreRefs = scheduledTaskData.datastoreRefs;
               var virtualDeviceOptionsByDeviceType = buildVirtualDeviceOptionsByDeviceType(vmConfigEnvironment);
               var availableNetworks = vmDeviceInfoService.buildAvailableNetworkList(vmConfigEnvironment.configTarget);
               scheduledTasksDeviceChangesService.addDevices(virtualMachineDevices,
                     scheduledDataSpec.deviceChange, virtualDeviceOptionsByDeviceType,
                     vmParams, availableNetworks, datastoreRefs, scheduledDataSpec.vmProfile);
            }

            return buildDefaultVmConfigForScheduledNewVm(selectedGuestOS,
                  virtualMachineDevices, vmParams, devices, scheduledDataSpec);
         }
         if (_.contains(privileges, h5_vm.Privileges.VM_ADDNEWDISK_PRIVILEGE)) {
            vmDeviceManagementService.createNewDevice(
                  'VirtualDisk',
                  vmConfigEnvironment,
                  selectedGuestOS,
                  virtualMachineDevices,
                  {
                     selectedStorageProfile: vmParams.getSelectedStorageProfileForDisks(),
                     selectedReplicationGroupInfo: vmParams.getSelectedReplicationGroupInfo()
                  });
         }

         vmDeviceManagementService.createNewDevice(
               'VirtualEthernetCard', vmConfigEnvironment, selectedGuestOS, virtualMachineDevices);
         vmDeviceManagementService.createNewDevice(
               'VirtualCdrom', vmConfigEnvironment, selectedGuestOS, virtualMachineDevices);
         var additionalParameters = {
            isCreateMode: true
         };
         vmDeviceManagementService.createNewDevice(
               'VirtualUSBController', vmConfigEnvironment, selectedGuestOS, virtualMachineDevices, additionalParameters);

         return buildDefaultVmConfigForNewVm(selectedGuestOS, virtualMachineDevices, vmParams, devices);
      }

      function buildCloneVM(vmParams, vmConfigContext, virtualMachineDevices, vmOriginalConfig,
            vmStorageProfileAssignments) {
         var guestOs = guestOsService
               .getAppropriateGuestOs(vmConfigContext, { id: vmOriginalConfig.guestId });
         vmParams.setGosFamilyAndVersion({
            family: {
               id: guestOs.family,
               name: i18nService.getString('VmUi',
                     'GeneralOptions.gos_family.' + guestOs.family)
            },
            version: {
               id: guestOs.id,
               name: guestOs.fullName
            }
         });
         vmParams.setVmOriginalConfigSpec(vmOriginalConfig);
         // Unset change version. It should be null when cloning since we are
         // creating a new VM not editing and existing one.
         vmConfigContext.config.changeVersion = null;
         var scheduledTaskData = vmParams.getScheduledData();
         var useScheduledTask = !_.isEmpty(scheduledTaskData) && scheduledTaskData.useScheduledTaskData;
         var scheduledDataSpec = !_.isEmpty(scheduledTaskData) && scheduledTaskData.spec;
         if (useScheduledTask && scheduledDataSpec) {
            var virtualDeviceOptionsByDeviceType = buildVirtualDeviceOptionsByDeviceType(
                  vmConfigContext.environment);
            var availableNetworks = vmDeviceInfoService.buildAvailableNetworkList(
                  vmConfigContext.environment.configTarget);
            if (scheduledDataSpec.location && scheduledDataSpec.location.deviceChange) {
               scheduledTasksDeviceChangesService.addDevices(virtualMachineDevices,
                     scheduledDataSpec.location.deviceChange, virtualDeviceOptionsByDeviceType,
                     vmParams, availableNetworks, {});
            }

            if (scheduledDataSpec.config && scheduledDataSpec.config.deviceChange) {
               scheduledTasksDeviceChangesService.addDevices(virtualMachineDevices,
                     scheduledDataSpec.config.deviceChange, virtualDeviceOptionsByDeviceType,
                     vmParams, availableNetworks, {});
            }

            vmParams.setVmConfigSpec(buildVmConfigForScheduledCloneVm(scheduledDataSpec,
                  vmConfigContext.config));
         } else {
            vmParams.setVmConfigSpec(vmConfigContext.config);
         }
         vmParams.setVirtualMachineDevices(virtualMachineDevices);
         applyStorageToVirtualDisks(
               virtualMachineDevices.existingDevicesOfType(
                     deviceTypeConstants.VIRTUALDISK), vmStorageProfileAssignments, vmParams);
      }

      function applyStorageToVirtualDisks(virtualDisks, vmStorageProfileAssignments, vmParams) {
         var replicationGroupInfo = vmParams.getSelectedReplicationGroupInfo();
         var datastoreDefaultProfile = storageProfileService.getDefaultProfile();

         angular.forEach(virtualDisks, function(virtualDisk) {
            var diskStorageObj = vmParams.getStorageForDisk(virtualDisk.getKey());
            var storageRef;
            if (diskStorageObj && diskStorageObj.dsObject && diskStorageObj.dsObject.storageRef &&
                  vmParams.storageObjectIsStandaloneDs(diskStorageObj.dsObject)) {
               if (virtualDisk.getCurrentDevice()
                     && virtualDisk.getCurrentDevice().backing
                     && virtualDisk.getCurrentDevice().backing.datastore) {
                  storageRef = virtualDisk.getCurrentDevice().backing.datastore;
               } else {
                  storageRef = {};
               }
               storageRef.value = diskStorageObj.dsObject.storageRef.value;
               storageRef.serverGuid = diskStorageObj.dsObject.storageRef.serverGuid;
               storageRef.type = diskStorageObj.dsObject.storageRef.type;
            }

            var diskProfile = datastoreDefaultProfile;

            var diskAssignment = storageProfileService.findDiskAssignment(
                  vmStorageProfileAssignments,
                  virtualDisk.getCurrentDevice());
            if (diskAssignment) {
               diskProfile = {
                  id: diskAssignment.profile.profileId.uniqueId,
                  label: diskAssignment.profile.name
               };
            }
            virtualDisk.updateDatastoreMor(storageRef);
            virtualDisk.updateDiskProfile(diskProfile, replicationGroupInfo);
         });
      }

      function buildVirtualDevicesForCreate(vmConfigEnvironment) {
         var devices = angular.copy(vmConfigEnvironment.configOption.defaultDevice);

         var virtualDeviceOptionsByDeviceType = _.indexBy(
               vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
               function(deviceOption) {
                  return deviceOption.type.name;
               }
         );

         var virtualMachineDevices = new VirtualMachineDevices(
               devices,
               null /* profileAssignments */,
               null /* profiles */,
               null /* availableNetworks */,
               virtualDeviceOptionsByDeviceType);
         return virtualMachineDevices;
      }

      function buildVirtualDeviceOptionsByDeviceType(vmConfigEnvironment) {
         var virtualDeviceOptionsByDeviceType = _.indexBy(
               vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
               function(deviceOption) {
                  return deviceOption.type.name;
               }
         );

         return virtualDeviceOptionsByDeviceType;
      }

      function buildDefaultVmConfigForNewVm(selectedGuestOS, virtualMachineDevices, vmParams, devices) {
         var bootOptions = {
            _type: 'com.vmware.vim.binding.vim.vm.BootOptions'
         };
         if (selectedGuestOS.recommendedFirmware === 'efi'
               && selectedGuestOS.defaultSecureBoot) {
            bootOptions.efiSecureBootEnabled = true;
         }
         var numCoresPerSocket = selectedGuestOS.numRecommendedCoresPerSocket ?
            selectedGuestOS.numRecommendedCoresPerSocket : 1;
         return {
            vmConfigSpec: {
               config: {
                  bootOptions: bootOptions,
                  version: vmParams.getVmVersion(),
                  guestId: selectedGuestOS.id,
                  options: {},
                  firmware: selectedGuestOS.recommendedFirmware,
                  hardware: {
                     _type: "com.vmware.vim.binding.vim.vm.VirtualHardware",
                     numCPU: selectedGuestOS.numRecommendedPhysicalSockets ?
                        selectedGuestOS.numRecommendedPhysicalSockets * numCoresPerSocket
                        : numCoresPerSocket,
                     memoryMB: selectedGuestOS.recommendedMemMB,
                     device: devices,
					 numCoresPerSocket: numCoresPerSocket,
                     virtualICH7MPresent: !!selectedGuestOS.ich7mRecommended,
                     virtualSMCPresent: !!selectedGuestOS.smcRecommended
                  },
                  cpuFeatureMask: [],
                  cpuAllocation: {
                     _type: "com.vmware.vim.binding.vim.ResourceAllocationInfo",
                     reservation: 0,
                     limit: -1,
                     shares: {
                        _type: "com.vmware.vim.binding.vim.SharesInfo",
                        shares: 1000,
                        level: 'normal'
                     }
                  },
                  memoryAllocation: {
                     _type: "com.vmware.vim.binding.vim.ResourceAllocationInfo",
                     reservation: 0,
                     limit: -1,
                     shares: {
                        _type: "com.vmware.vim.binding.vim.SharesInfo",
                        shares: selectedGuestOS.recommendedMemMB * 10,
                        level: 'normal'
                     }
                  },
                  memoryReservationLockedToMax: false,
                  cpuAffinity: {
                     _type: "com.vmware.vim.binding.vim.vm.AffinityInfo",
                     affinitySet: []
                  },
                  files: {
                     _type: "com.vmware.vim.binding.vim.vm.FileInfo",
                     vmPathName: !vmParams.storageObjectIsPod() ? "[" + vmParams.getStorageObject().name + "]" : null
                  },
                  tools: {
                     _type: "com.vmware.vim.binding.vim.vm.ToolsConfigInfo",
                     afterPowerOn: true,
                     afterResume: true,
                     beforeGuestShutdown: true,
                     beforeGuestStandby: true,
                     toolsUpgradePolicy: "manual"
                  },
                  defaultPowerOps: {
                     _type: "com.vmware.vim.binding.vim.vm.DefaultPowerOpInfo",
                     powerOffType: "preset",
                     suspendType: "preset",
                     resetType: "preset",
                     standbyAction: "checkpoint"
                  },
                  flags: {
                     _type: "com.vmware.vim.binding.vim.vm.FlagInfo",
                     virtualMmuUsage: 'automatic',
                     monitorType: 'release'
                  }
               }
            },
            virtualMachineDevices: virtualMachineDevices
         };
      }

      function buildDefaultVmConfigForScheduledNewVm(selectedGuestOS, virtualMachineDevices,
            vmParams, devices, scheduledDataSpec) {
         var bootOptions = {
            _type: 'com.vmware.vim.binding.vim.vm.BootOptions'
         };
         if (selectedGuestOS.recommendedFirmware === 'efi'
               && selectedGuestOS.defaultSecureBoot) {
            bootOptions.efiSecureBootEnabled = true;
         }
         var memoryMB = selectedGuestOS.recommendedMemMB;
         var virtualICH7MPresent = !!selectedGuestOS.ich7mRecommended;
         var virtualSMCPresent = !!selectedGuestOS.smcRecommended;
         var firmware = selectedGuestOS.recommendedFirmware;
         var memoryAllocation = {
            _type: "com.vmware.vim.binding.vim.ResourceAllocationInfo",
                  reservation: 0,
                  limit: -1,
                  shares: {
               _type: "com.vmware.vim.binding.vim.SharesInfo",
                     shares: selectedGuestOS.recommendedMemMB * 10,
                     level: 'normal'
            }
         };
         var cpuAffinity = scheduledDataSpec.cpuAffinity;
         if (!_.isEmpty(cpuAffinity)) {
            cpuAffinity.affinitySet = cpuAffinity.affinitySet ? cpuAffinity.affinitySet : [];
         }

         var files = scheduledDataSpec.files;
         files.vmPathName = !vmParams.storageObjectIsPod() ? "[" + vmParams.getStorageObject().name + "]" : null;
         if (selectedGuestOS.id === scheduledDataSpec.guestId) {
            bootOptions = scheduledDataSpec.bootOptions;
            memoryMB = scheduledDataSpec.memoryMB;
            virtualICH7MPresent = scheduledDataSpec.virtualICH7MPresent;
            virtualSMCPresent = scheduledDataSpec.virtualSMCPresent;
            memoryAllocation = scheduledDataSpec.memoryAllocation;
            firmware = scheduledDataSpec.firmware;
         }
         return {
            vmConfigSpec: {
               config: {
                  bootOptions: bootOptions,
                  version: vmParams.getVmVersion(),
                  guestId: selectedGuestOS.id,
                  options: {},
                  firmware: firmware,
                  hardware: {
                     _type: "com.vmware.vim.binding.vim.vm.VirtualHardware",
                     numCPU: scheduledDataSpec.numCPUs,
                     memoryMB: memoryMB,
                     device: devices,
                     numCoresPerSocket: scheduledDataSpec.numCoresPerSocket,
                     virtualICH7MPresent: virtualICH7MPresent,
                     virtualSMCPresent: virtualSMCPresent
                  },
                  cpuFeatureMask: !_.isEmpty(scheduledDataSpec.cpuFeatureMask) ?
                        buildCpuFeatureMask(scheduledDataSpec.cpuFeatureMask) : [],
                  cpuHotAddEnabled: scheduledDataSpec.cpuHotAddEnabled,
                  nestedHVEnabled: scheduledDataSpec.nestedHVEnabled,
                  vPMCEnabled: scheduledDataSpec.vPMCEnabled,
                  cpuAllocation: scheduledDataSpec.cpuAllocation,
                  memoryAllocation: memoryAllocation,
                  memoryReservationLockedToMax: scheduledDataSpec.memoryReservationLockedToMax,
                  memoryHotAddEnabled: scheduledDataSpec.memoryHotAddEnabled,
                  cpuAffinity: scheduledDataSpec.cpuAffinity,
                  files: files,
                  tools: scheduledDataSpec.tools,
                  defaultPowerOps: scheduledDataSpec.powerOpInfo,
                  flags: scheduledDataSpec.flags,
                  guestAutoLockEnabled: scheduledDataSpec.guestAutoLockEnabled,
                  maxMksConnections: scheduledDataSpec.maxMksConnections,
                  migrateEncryption: scheduledDataSpec.migrateEncryption,
                  swapPlacement: scheduledDataSpec.swapPlacement,
                  latencySensitivity: scheduledDataSpec.latencySensitivity,
                  extraConfig: scheduledDataSpec.extraConfig,
                  npivTemporaryDisabled: scheduledDataSpec.npivTemporaryDisabled,
                  npivWwnOp: scheduledDataSpec.npivWorldWideNameOp,
                  npivDesiredNodeWwns: scheduledDataSpec.npivDesiredNodeWwns,
                  npivDesiredPortWwns: scheduledDataSpec.npivDesiredPortWwns

               }
            },
            virtualMachineDevices: virtualMachineDevices
         };
      }

      function buildVmConfigForScheduledCloneVm(scheduledDataSpec, originalConfig) {
         var originalConfigCopy = angular.copy(originalConfig);
         if (_.isEmpty(scheduledDataSpec.config)) {
            return originalConfigCopy;
         }

         var scheduledSpecKeys = _.keys(scheduledDataSpec.config);
         var cpuAffinity = scheduledDataSpec.config.cpuAffinity;
         if (!_.isEmpty(cpuAffinity)) {
            cpuAffinity.affinitySet = cpuAffinity.affinitySet ? cpuAffinity.affinitySet : [];
         }

         // populate the unset values for cpuAllocation in the scheduled task data, from the original spec
         mapProperties(originalConfigCopy, scheduledDataSpec.config, 'cpuAllocation');
         // populate the unset values for memoryAllocation in the scheduled task data, from the original spec
         mapProperties(originalConfigCopy, scheduledDataSpec.config, 'memoryAllocation');
         // populate the unset values for flags in the scheduled task data, from the original spec
         mapProperties(originalConfigCopy, scheduledDataSpec.config, 'flags');
         // populate the unset values for bootOptions in the scheduled task data, from the original spec
         mapProperties(originalConfigCopy, scheduledDataSpec.config, 'bootOptions');
         // populate the unset values for tools in the scheduled task data, from the original spec
         mapProperties(originalConfigCopy, scheduledDataSpec.config, 'tools');

         // map all properties of the original Vm and the scheduled data that have the same names
         _.each(scheduledSpecKeys, function(key) {
            if (key !== '_type' && scheduledDataSpec.config[key] !== null &&
                  originalConfigCopy.hasOwnProperty(key)) {
               originalConfigCopy[key] = scheduledDataSpec.config[key];
            }
         });

         // the original config cpuFeatureMask, has a different format than the one
         // saved in the spec, so we need to convert the data
         originalConfigCopy.cpuFeatureMask = [];
         if (!_.isEmpty(scheduledDataSpec.config.cpuFeatureMask)) {
            originalConfigCopy.cpuFeatureMask = buildCpuFeatureMask(
                  scheduledDataSpec.config.cpuFeatureMask);
         }

         // since the hardware properties are not separately saved in hardware property,
         // we need to map them separately
         var originalConfigHardwareKeys = _.keys(originalConfigCopy.hardware);
         _.each(originalConfigHardwareKeys, function(key) {
            if (key !== '_type' && scheduledDataSpec.config[key] !== null &&
                  scheduledDataSpec.config.hasOwnProperty(key)) {
               originalConfigCopy.hardware[key] = scheduledDataSpec.config[key];
            }
         });

         // the power operations are saved in different properties
         // in the config and scheduled data an need to be mapped separately
         var originalPowerOps = _.keys(originalConfigCopy.defaultPowerOps);
         _.each(originalPowerOps, function(key) {
            if (key !== '_type' && scheduledDataSpec.config.powerOpInfo !== null &&
                  scheduledDataSpec.config.powerOpInfo[key] !== null &&
                  scheduledDataSpec.config.powerOpInfo.hasOwnProperty(key)) {
               originalConfigCopy.defaultPowerOps[key] = scheduledDataSpec.config.powerOpInfo[key];
            }
         });

         if (scheduledDataSpec.config.numCPUs !== null) {
            originalConfigCopy.hardware.numCPU = scheduledDataSpec.config.numCPUs;
         }

         if (scheduledDataSpec.config.npivWorldWideNameOp !== null) {
            originalConfigCopy.npivWwnOp = scheduledDataSpec.config.npivWorldWideNameOp;
         }
         return originalConfigCopy;
      }

      function buildCpuFeatureMask(scheduledCpuFeatureMask) {
         var cpuFeatureMask = [];
         _.each(scheduledCpuFeatureMask, function (mask) {
            if (!_.isEmpty(mask.info)) {
               cpuFeatureMask.push(mask.info);
            }
         });

         return cpuFeatureMask;
      }

      /**
       * Checks if the original config property has the same key as the one in the original config,
       * if so replaces and the scheduled task value is empty replaces the scheduled task data
       * with the one from the original config.
       * this is done so that later the whole property could be copied in the original config,
       * and the changed values fron the scheduled task will be preserved
       * @param originalConfig
       * @param scheduledDataSpecConfig
       * @param property
       */
      function mapProperties(originalConfig, scheduledDataSpecConfig, property) {
         var originalConfigKeys = _.keys(originalConfig[property]);
         _.each(originalConfigKeys, function(key) {
            var scheduledDataIsNotSet = scheduledDataSpecConfig[property] !== null &&
                  scheduledDataSpecConfig[property][key] === null &&
                  scheduledDataSpecConfig[property].hasOwnProperty(key);
            if (key !== '_type' &&
                  scheduledDataIsNotSet &&
                  originalConfig[property] && originalConfig[property][key] !== null) {
               scheduledDataSpecConfig[property][key] = originalConfig[property][key];
            }
         });
      }
   }

})();

var h5_vm;
(function (h5_vm) {
    // The file name starts with underscore to make the file first in alphabetical order.
    // When the TypeScript files are compiled to JS and later concatenated we want this base
    // class to be defined first. Otherwise the child classes try to access their undefined
    // parent and the client doesn't start up.
    var VmProvisioningFinishPageModel = (function () {
        function VmProvisioningFinishPageModel($q, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.addVmService = addVmService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageProfileService = storageProfileService;
            this.diskModeService = diskModeService;
            this.managedEntityConstants = managedEntityConstants;
            this.datastoreRecommendationService = datastoreRecommendationService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
            this.COMPATIBILITY_MODE_VIRTUAL = "virtualMode";
            this.COMPATIBILITY_MODE_PHYSICAL = "physicalMode";
            this._form = {
                vmStorageRecommendation: {}
            };
            this.noDrsFaults = false;
            this.finishedLoading = false;
            this._virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this._wizardViewData = wizardViewData;
            this._scheduledTaskData = scheduledTaskData;
        }
        Object.defineProperty(VmProvisioningFinishPageModel.prototype, "virtualMachineSpecBuilder", {
            get: function () {
                return this._virtualMachineSpecBuilder;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningFinishPageModel.prototype, "wizardViewData", {
            get: function () {
                return this._wizardViewData;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningFinishPageModel.prototype, "scheduledTaskData", {
            get: function () {
                return this._scheduledTaskData;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningFinishPageModel.prototype, "form", {
            get: function () {
                return this._form;
            },
            set: function (value) {
                this._form = value;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningFinishPageModel.prototype.resetForm = function () {
            this.form.vmStorageRecommendation = {};
        };
        VmProvisioningFinishPageModel.prototype.pageFinishedLoading = function () {
            return this.finishedLoading;
        };
        VmProvisioningFinishPageModel.prototype.validatePage = function () {
            if (this.noDrsFaults) {
                return {};
            }
            else {
                return {
                    error: this.i18nService
                        .getString("VmUi", "ProvisioningWizardSummaryPage.drsFaultsOnPage")
                };
            }
        };
        VmProvisioningFinishPageModel.prototype.setSelectedRecommendation = function (recommendation) {
            var podId = this.defaultUriSchemeUtil.getVsphereObjectId(recommendation.target);
            this.form.vmStorageRecommendation[podId] = recommendation;
        };
        VmProvisioningFinishPageModel.prototype.getSelectedRecommendation = function (podId) {
            if (this.form.vmStorageRecommendation
                && !_.isEmpty(this.form.vmStorageRecommendation[podId])) {
                return this.form.vmStorageRecommendation[podId];
            }
            return null;
        };
        VmProvisioningFinishPageModel.prototype.submitPage = function () {
            this.virtualMachineSpecBuilder
                .setVmRecommendationsSpec(this.form.vmStorageRecommendation);
            if (this.scheduledTaskData && this.scheduledTaskData.isScheduledTask) {
                this.addVmService.createVmScheduledTask(this.virtualMachineSpecBuilder, this.scheduledTaskData);
            }
            else {
                this.addVmService.createVm(this.virtualMachineSpecBuilder);
            }
            return this.$q.resolve(true);
        };
        VmProvisioningFinishPageModel.prototype.getVmName = function () {
            return this.virtualMachineSpecBuilder.getName();
        };
        VmProvisioningFinishPageModel.prototype.getTargetFolderName = function () {
            return this.virtualMachineSpecBuilder.getTargetInformation().name;
        };
        VmProvisioningFinishPageModel.prototype.presentTargetStorageName = function () {
            return this.getDatastore();
        };
        VmProvisioningFinishPageModel.prototype.getComputeResourceInfo = function () {
            var computeResourceId = this.virtualMachineSpecBuilder.getComputeResourceId();
            var computeResourceName = this.virtualMachineSpecBuilder.getComputeResourceName();
            var label = this.labelForType(computeResourceId);
            return {
                name: computeResourceName,
                label: label
            };
        };
        VmProvisioningFinishPageModel.prototype.isStorageProfileSpecified = function () {
            var storageProfile = this.virtualMachineSpecBuilder.getSelectedStorageProfile();
            return !!storageProfile && !!storageProfile.id && (storageProfile.id !== this.storageProfileService.DEFAULT_ID);
        };
        VmProvisioningFinishPageModel.prototype.isVmHomeEncrypted = function () {
            if (!this.isStorageProfileSpecified()) {
                return false;
            }
            var storageProfile = this.virtualMachineSpecBuilder.getSelectedStorageProfile();
            return this.storageProfileService
                .isEncryptionStorageProfile(storageProfile);
        };
        VmProvisioningFinishPageModel.prototype.areAllDisksEncrypted = function () {
            if (!this.isVmHomeEncrypted()) {
                return false;
            }
            if (!this.virtualMachineSpecBuilder.getVirtualMachineDevices()) {
                // The disks are using the VM home profile
                return true;
            }
            var disks = this.virtualMachineSpecBuilder.getVirtualMachineDevices()
                .changedDevicesOfType(h5_vm.DeviceTypeConstants.VIRTUALDISK);
            return !_.find(disks, function (disk) {
                return !disk.isDiskEncrypted();
            });
        };
        VmProvisioningFinishPageModel.prototype.getStorageProfile = function () {
            return this.virtualMachineSpecBuilder.getSelectedStorageProfile()
                && this.virtualMachineSpecBuilder.getSelectedStorageProfile().label;
        };
        VmProvisioningFinishPageModel.prototype.isReplicationGroupSpecified = function () {
            var replicationGroupInfo = this.virtualMachineSpecBuilder.getSelectedReplicationGroupInfo();
            return !!replicationGroupInfo;
        };
        VmProvisioningFinishPageModel.prototype.getReplicationGroup = function () {
            return this.virtualMachineSpecBuilder.getSelectedReplicationGroupInfo() &&
                this.spbmReplicationGroupInfoService.getReplicationGroupName(this.virtualMachineSpecBuilder.getSelectedReplicationGroupInfo());
        };
        VmProvisioningFinishPageModel.prototype.fetchStoragePlacementRecommendations = function () {
            var _this = this;
            return this.addVmService.validateSpec(this.virtualMachineSpecBuilder).then(function (results) {
                if (results.faults) {
                    _this.finishedLoading = true;
                    _this.noDrsFaults = false;
                    return _this.$q.reject(results.faults);
                }
                if (results.recommendationsPerPod) {
                    _this.form.recommendationsPerPod = results.recommendationsPerPod;
                    angular.forEach(results.recommendationsPerPod, function (recommendationInfo) {
                        _this.setSelectedRecommendation(recommendationInfo.topRecommendation);
                    });
                    _this.form.diskDatastoresMap = results.topRecommendedDatastoresPerDisk;
                }
                _this.finishedLoading = true;
                _this.noDrsFaults = true;
                return _this.$q.resolve();
            });
        };
        VmProvisioningFinishPageModel.prototype.labelForType = function (urn) {
            var type = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(urn).type;
            switch (type) {
                case "ClusterComputeResource":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Cluster");
                case "HostSystem":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Host");
                case "ResourcePool":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                case "VirtualApp":
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                default:
                    throw new Error("Unknown compute resouce id: " + urn);
            }
        };
        /**
         * @returns a sorted array (new first) of Nvdimms added to VM.
         */
        VmProvisioningFinishPageModel.prototype.getNvdimmDevicesInfo = function () {
            var _this = this;
            if (!this.virtualMachineSpecBuilder.getVirtualMachineDevices()) {
                return [];
            }
            var unsortedNvdimms = this.virtualMachineSpecBuilder
                .getVirtualMachineDevices().devicesOfTypeNotMarkedForRemoval("VirtualNVDIMM");
            var nvdimmInfos = _.chain(unsortedNvdimms)
                .sortBy(function (nvdimm) {
                return Math.abs(nvdimm.getKey());
            })
                .map(function (nvdimm, index) {
                return {
                    label: _this.getNvdimmLabel(nvdimm, index),
                    capacityInMb: nvdimm.getCapacityInMB()
                };
            })
                .value();
            return nvdimmInfos;
        };
        VmProvisioningFinishPageModel.prototype.getNvdimmLabel = function (nvdimm, index) {
            if (nvdimm.isNew()) {
                return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.createNvdimm", index + 1);
            }
            return nvdimm.getCurrentDevice().deviceInfo.label;
        };
        VmProvisioningFinishPageModel.prototype.getStorageObject = function (diskStorageProps) {
            var storageObject = this.virtualMachineSpecBuilder.getStorageObject();
            if (diskStorageProps) {
                storageObject = diskStorageProps.dsObject;
            }
            return storageObject;
        };
        VmProvisioningFinishPageModel.prototype.getDiskMode = function (disk) {
            if (disk && disk.backing && disk.backing.diskMode) {
                return this.diskModeService.getModeName(disk.backing.diskMode);
            }
            return "";
        };
        VmProvisioningFinishPageModel.prototype.getStorageProfileForDisk = function (disk) {
            var inflatedDevice = this.virtualMachineSpecBuilder
                .getVirtualMachineDevices()
                .getVirtualDevice(disk.key);
            // When using the Advanced Storage mode the advanced configuration is the most
            // accurate and regression safe way to obtain a disks storage profile
            if (!inflatedDevice.isNew()
                && this.virtualMachineSpecBuilder.getIsAdvancedStorageMode()) {
                return this.virtualMachineSpecBuilder
                    .getStorageSelectorStatePerDisk(disk.key).storageProfile;
            }
            return inflatedDevice.getProfile();
        };
        VmProvisioningFinishPageModel.prototype.getReplicationGroupLabelForDisk = function (disk) {
            var replicationGroupInfo = this.getReplicationGroupForDisk(disk);
            if (replicationGroupInfo) {
                return this.spbmReplicationGroupInfoService.getReplicationGroupName(replicationGroupInfo);
            }
            return null;
        };
        VmProvisioningFinishPageModel.prototype.getReplicationGroupForDisk = function (disk) {
            var inflatedDevice = this.virtualMachineSpecBuilder
                .getVirtualMachineDevices()
                .getVirtualDevice(disk.key);
            // When using the Advanced Storage mode the advanced configuration is the most
            // accurate and regression safe way to obtain a disks RG
            if (!inflatedDevice.isNew()
                && this.virtualMachineSpecBuilder.getIsAdvancedStorageMode()) {
                return this.virtualMachineSpecBuilder
                    .getStorageSelectorStatePerDisk(disk.key).replicationGroup;
            }
            return inflatedDevice.getCurrentReplicationGroup();
        };
        VmProvisioningFinishPageModel.prototype.diskHasDefaultStoragePolicy = function (disk) {
            var diskStorageProfile = this.getStorageProfileForDisk(disk);
            return !!diskStorageProfile
                && (diskStorageProfile.profileId === this.storageProfileService.DEFAULT_ID
                    || diskStorageProfile.id === this.storageProfileService.DEFAULT_ID
                    || diskStorageProfile._type ===
                        VmProvisioningFinishPageModel.DEFAULT_PROFILE_CLASS);
        };
        VmProvisioningFinishPageModel.prototype.setDisksDatastoreInfo = function (disks) {
            var _this = this;
            _.each(disks, function (disk) {
                var diskStorageProps = _this.virtualMachineSpecBuilder.getStorageForDisk(disk.diskKey);
                disk.datastoreInfo = _this.getDatastore(diskStorageProps, disk);
            });
        };
        VmProvisioningFinishPageModel.prototype.getDatastore = function (diskStorageProps, disk) {
            var storageObject = this.virtualMachineSpecBuilder.getStorageObject();
            if (diskStorageProps) {
                storageObject = diskStorageProps.dsObject;
            }
            var storageRef = storageObject.storageRef;
            if (storageRef.type !== this.managedEntityConstants.STORAGE_POD
                && storageObject.parentStoragePod) {
                storageRef = storageObject.parentStoragePod;
            }
            var datastoreName = this.getDatastoreNameForPod(storageRef, disk);
            return this.getDatastoreLabel(storageObject, datastoreName);
        };
        VmProvisioningFinishPageModel.prototype.getRDMTargetLUNName = function (disk, environment) {
            var scsiDisks = environment.configTarget.scsiDisk;
            var scsiDisk = _.find(scsiDisks, function (scsiDisk) {
                return scsiDisk.disk.deviceName === disk.backing.deviceName;
            });
            if (!scsiDisk) {
                return "";
            }
            return scsiDisk.disk.displayName;
        };
        VmProvisioningFinishPageModel.prototype.getRDMCompatibility = function (disk) {
            var compatibility = "";
            switch (disk.backing.compatibilityMode) {
                case this.COMPATIBILITY_MODE_VIRTUAL:
                    compatibility = this.i18nService
                        .getString("VmUi", "ProvisioningWizardSummaryPage.DiskCompatibilityModeVirtual");
                    break;
                case this.COMPATIBILITY_MODE_PHYSICAL:
                    compatibility = this.i18nService
                        .getString("VmUi", "ProvisioningWizardSummaryPage.DiskCompatibilityModePhysical");
                    break;
                default:
                    compatibility = "";
            }
            return compatibility;
        };
        VmProvisioningFinishPageModel.prototype.getRDMDatastoreName = function () {
            // TODO civanova: When the chane of location is correctly implemented
            // in edit settings dialog, display the new datastore name instead of the default value
            return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.DiskMappedDatastoreSame");
        };
        VmProvisioningFinishPageModel.prototype.isDiskEncrypted = function (diskKey) {
            var diskDevice = this.virtualMachineSpecBuilder.getVirtualMachineDevices()
                .getVirtualDevice(diskKey);
            return diskDevice.isDiskEncrypted();
        };
        VmProvisioningFinishPageModel.prototype.getDatastoreLabel = function (datastoreObject, dataStoreName) {
            var storageObjectIsStandaloneDS = !this.datastoreRecommendationService
                .areRecommendationsAvailableForStorageObject(datastoreObject);
            var isCrossVc = this.virtualMachineSpecBuilder.isXvc();
            storageObjectIsStandaloneDS = isCrossVc || storageObjectIsStandaloneDS;
            return this.vmDeviceInfoService.getStorageObjectLabel(datastoreObject, dataStoreName, storageObjectIsStandaloneDS, this.wizardViewData.getStorageNameMap());
        };
        VmProvisioningFinishPageModel.prototype.getDatastoreNameForPod = function (storagePodMoRef, disk) {
            var datastoreName = "";
            var podId = this.defaultUriSchemeUtil.getVsphereObjectId(storagePodMoRef);
            var recommendation = this.getSelectedRecommendation(podId);
            if (recommendation) {
                var currentRecommendation = null;
                if (disk) {
                    currentRecommendation = _.find(recommendation.action, function (action) {
                        return action.relocateSpec.disk && action.relocateSpec.disk.length
                            && action.relocateSpec.disk[0].diskId === disk.diskKey;
                    });
                }
                currentRecommendation = currentRecommendation || recommendation.action[0];
                var datastoreMoRef = currentRecommendation.destination;
                var dsId = this.defaultUriSchemeUtil.getVsphereObjectId(datastoreMoRef);
                datastoreName = this.wizardViewData.getStorageNameMap()[dsId];
            }
            return datastoreName;
        };
        VmProvisioningFinishPageModel.DEFAULT_PROFILE_CLASS = "com.vmware.vim.binding.vim.vm.DefaultProfileSpec";
        return VmProvisioningFinishPageModel;
    }());
    h5_vm.VmProvisioningFinishPageModel = VmProvisioningFinishPageModel;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningCloneOptionsPageModelFactory = (function () {
        function VmProvisioningCloneOptionsPageModelFactory(dataService, i18nService, customizeGosPreCheckSpecsService, $q) {
            return function (virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
                return new VmProvisioningCloneOptionsPageModel(dataService, i18nService, customizeGosPreCheckSpecsService, $q, virtualMachineSpecBuilder, wizardViewData, wizardConfig);
            };
        }
        VmProvisioningCloneOptionsPageModelFactory.$inject = [
            "dataService",
            "i18nService",
            "customizeGosPreCheckSpecsService",
            "$q"
        ];
        return VmProvisioningCloneOptionsPageModelFactory;
    }());
    var VmProvisioningCloneOptionsPageModel = (function () {
        function VmProvisioningCloneOptionsPageModel(dataService, i18nService, customizeGosPreCheckSpecsService, $q, virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.customizeGosPreCheckSpecsService = customizeGosPreCheckSpecsService;
            this.$q = $q;
            this.form = {};
            this.CUSTOMIZE_OS_RESPONSE = "customizeOsResponse";
            this.POWER_ON_RESPONSE = "powerOnResponse";
            this._virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this._wizardViewData = wizardViewData;
            this._wizardConfig = wizardConfig;
        }
        Object.defineProperty(VmProvisioningCloneOptionsPageModel.prototype, "virtualMachineSpecBuilder", {
            get: function () {
                return this._virtualMachineSpecBuilder;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningCloneOptionsPageModel.prototype, "wizardViewData", {
            get: function () {
                return this._wizardViewData;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningCloneOptionsPageModel.prototype, "wizardConfig", {
            get: function () {
                return this._wizardConfig;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningCloneOptionsPageModel.prototype.resetForm = function () {
            this.wizardConfig.loadingMessage = this.i18nService
                .getString("CommonUi", "wizard.validating");
            var suggestedCustomizeOs = !_.isNull(this.form.customizeOs) && !_.isUndefined(this.form.customizeOs) ?
                this.form.customizeOs :
                false;
            var suggestedPowerOn = !_.isNull(this.form.powerOn) && !_.isUndefined(this.form.powerOn) ?
                this.form.powerOn :
                false;
            var customizeHw = this.virtualMachineSpecBuilder.getCustomizeCloneHardware() || false;
            var suggestedCustomizeHw = this.form.customizeHw
                ? this.form.customizeHw
                : customizeHw;
            this.form.powerOn = suggestedPowerOn;
            this.form.customizeOs = suggestedCustomizeOs;
            this.form.customizeHw = suggestedCustomizeHw;
            this.originalCustomizeOs = this.form.customizeOs;
            this.originalCustomizeHw = this.form.customizeHw;
        };
        VmProvisioningCloneOptionsPageModel.prototype.validatePage = function () {
            var _this = this;
            var promises = {};
            var vmId = this.virtualMachineSpecBuilder.getVmId();
            if (this.form.customizeOs) {
                this.wizardConfig.loading = true;
                promises[this.CUSTOMIZE_OS_RESPONSE] = this.customizeGosPreCheckSpecsService
                    .cloneCustomizeGosLoadData(vmId, true);
            }
            if (this.form.powerOn) {
                this.wizardConfig.loading = true;
                promises[this.POWER_ON_RESPONSE] = this.virtualMachineSpecBuilder.getPrivileges();
            }
            if (_.isEmpty(promises)) {
                return undefined;
            }
            return this.$q.all(promises)
                .then(function (response) {
                _this.wizardConfig.loading = false;
                var error = "";
                // if the `VirtualMachine.Interact.PowerOn` privilege is missing disable power on option
                if (_this.form.powerOn && _.indexOf(response.powerOnResponse, h5_vm.Privileges.VM_INTERACT_POWER_ON) === -1) {
                    error = _this.i18nService.getString("VmUi", "CustomizeGuestOsProvisioningPage.content.no_permissions_power_on");
                    if (error) {
                        return { error: error };
                    }
                }
                if (_this.form.customizeOs) {
                    var data = response.customizeOsResponse.data;
                    error = response.customizeOsResponse.error;
                    if (error) {
                        return { error: error };
                    }
                    _this.wizardViewData.setCustomizeGosSpecData(data);
                }
                return {};
            });
        };
        VmProvisioningCloneOptionsPageModel.prototype.submitPage = function () {
            this.virtualMachineSpecBuilder.setCustomizeCloneHardware(this.form.customizeHw);
            this.virtualMachineSpecBuilder.setCloneOptions({
                powerOn: this.form.powerOn,
                customizeOs: this.form.customizeOs
            });
            var osToBeCustomized = !this.originalCustomizeOs && this.form.customizeOs;
            var hwToBeCustomized = !this.originalCustomizeHw && this.form.customizeHw;
            var invalidateNextPages = osToBeCustomized || hwToBeCustomized;
            return {
                wizardFlow: this.virtualMachineSpecBuilder.getCreationType(),
                invalidateNextPages: invalidateNextPages
            };
        };
        VmProvisioningCloneOptionsPageModel.$inject = ["dataService", "i18nService", "customizeGosPreCheckSpecsService", "$q"];
        return VmProvisioningCloneOptionsPageModel;
    }());
    h5_vm.VmProvisioningCloneOptionsPageModel = VmProvisioningCloneOptionsPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("VmProvisioningCloneOptionsPageModel", VmProvisioningCloneOptionsPageModelFactory);
})(h5_vm || (h5_vm = {}));











var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectAnyTemplatePageService = (function () {
        function VmProvisioningSelectAnyTemplatePageService(i18nService, vmVuiWizardPageBuilder, creationTypeConstants, vmProvisioningSelectAnyTemplatePageModel) {
            this.i18nService = i18nService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.creationTypeConstants = creationTypeConstants;
            this.vmProvisioningSelectAnyTemplatePageModel = vmProvisioningSelectAnyTemplatePageModel;
        }
        VmProvisioningSelectAnyTemplatePageService.prototype.build = function (wizardScope) {
            var selectAnyTemplatePageModel = new this.vmProvisioningSelectAnyTemplatePageModel(wizardScope);
            wizardScope.selectAnyTemplateModel = selectAnyTemplatePageModel;
            var page = this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Title"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/vmProvisioningSelectAnyTemplate.html",
                model: selectAnyTemplatePageModel
            });
            page.decisionOptions = {
                flowIds: [
                    this.creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE,
                    this.creationTypeConstants.CLONE_TEMPLATE_TO_VM
                ],
                selectedFlowId: this.creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE
            };
            return page;
        };
        VmProvisioningSelectAnyTemplatePageService.$inject = [
            "i18nService",
            "vmVuiWizardPageBuilder",
            "creationTypeConstants",
            "vmProvisioningSelectAnyTemplatePageModel"
        ];
        return VmProvisioningSelectAnyTemplatePageService;
    }());
    h5_vm.VmProvisioningSelectAnyTemplatePageService = VmProvisioningSelectAnyTemplatePageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningSelectAnyTemplatePageService", VmProvisioningSelectAnyTemplatePageService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectTemplatePageModelFactory = (function () {
        function VmProvisioningSelectTemplatePageModelFactory($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService) {
            return function (virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
                return new VmProvisioningSelectTemplatePageModel($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService, virtualMachineSpecBuilder, wizardViewData, wizardConfig);
            };
        }
        VmProvisioningSelectTemplatePageModelFactory.$inject = [
            "$q",
            "i18nService",
            "dataService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "creationTypeConstants",
            "wizardPageService"
        ];
        return VmProvisioningSelectTemplatePageModelFactory;
    }());
    var VmProvisioningSelectTemplatePageModel = (function () {
        function VmProvisioningSelectTemplatePageModel($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService, virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.authorizationService = authorizationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.creationTypeConstants = creationTypeConstants;
            this.wizardPageService = wizardPageService;
            this.RUNTIME_CONNECTION_STATE = "runtime/connectionState";
            this.GUEST_OS_ID = "config/guestId";
            this.INVALID_STATE = this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Provisioning.InvalidState");
            this.INVALID_ENTITY_ERROR = this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.SelectValidEntity");
            this.MARK_AS_VM_PRIVILEGE = "VirtualMachine.Provisioning.MarkAsVM";
            this.CLONE_TEMPLATE_PRIVILEGE = "VirtualMachine.Provisioning.CloneTemplate";
            this.CONNECTED = "connected";
            this.showLoadingIndicator = true;
            this.virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this.wizardViewData = wizardViewData;
            this.config = wizardConfig;
        }
        VmProvisioningSelectTemplatePageModel.prototype.updateSelection = function (item) {
            var SELECTED_TYPE = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(item.id).type;
            this._selectionId = item.id;
            this._selectionIsTemplate =
                SELECTED_TYPE === this.managedEntityConstants.VIRTUAL_MACHINE;
            this.selectedTemplateChanged = this.lastSelectedTemplateId !== this._selectionId;
            if (!this._selectionIsTemplate) {
                return false;
            }
            this.virtualMachineSpecBuilder.setVmId(item.id);
            this.wizardViewData.setSourceObjectName(item.text);
            return true;
        };
        VmProvisioningSelectTemplatePageModel.prototype.clearSelection = function () {
            this._selectionId = undefined;
            this._selectionIsTemplate = false;
        };
        VmProvisioningSelectTemplatePageModel.prototype.getSelectionId = function () {
            return this._selectionId;
        };
        VmProvisioningSelectTemplatePageModel.prototype.getSelectionIsTemplate = function () {
            return !!this._selectionIsTemplate;
        };
        VmProvisioningSelectTemplatePageModel.prototype.getLastSelectedCreationType = function () {
            return this.lastSelectedCreationType;
        };
        VmProvisioningSelectTemplatePageModel.prototype.validateSelection = function () {
            var _this = this;
            this.wizardPageService.clearErrors(this.config);
            this.lastSelectedCreationType = this.virtualMachineSpecBuilder.getCreationType();
            if (this.lastSelectedTemplateId
                && this.lastSelectedTemplateId === this._selectionId
                && !_.isUndefined(this.compatibilityResultsCache)) {
                return this.setPrivilegesAndConnectionState();
            }
            if (this._selectionIsTemplate) {
                return this.$q.all({
                    vmProperties: this.dataService.getProperties(this._selectionId, [this.RUNTIME_CONNECTION_STATE, this.GUEST_OS_ID]),
                    privileges: this.authorizationService.checkGrantedPrivileges(this._selectionId, [this.getRequiredPermission(this.virtualMachineSpecBuilder.getCreationType())])
                }).then(function (result) {
                    _this.compatibilityResultsCache = result;
                    _this.lastSelectedTemplateId = _this._selectionId;
                    return _this.setPrivilegesAndConnectionState();
                });
            }
            return this.$q.when("");
        };
        VmProvisioningSelectTemplatePageModel.prototype.setPrivilegesAndConnectionState = function () {
            if (!this.compatibilityResultsCache) {
                return this.$q.when("");
            }
            var CONNECTION_STATE = this.compatibilityResultsCache.vmProperties[this.RUNTIME_CONNECTION_STATE];
            this.wizardViewData.setVmConnectedState(CONNECTION_STATE);
            this.virtualMachineSpecBuilder.setGuestOsId(this.compatibilityResultsCache.vmProperties[this.GUEST_OS_ID]);
            var compatibilityMessage = this.makeCompatibilityMessage(this.compatibilityResultsCache.privileges, CONNECTION_STATE);
            return this.$q.resolve(compatibilityMessage);
        };
        /**
         * Set model to an initial state (the model is caching just the last selected template
         * so it is preselected the next time when this model's page is opened) but invalidate the
         * connection state and privileges cache.
         */
        VmProvisioningSelectTemplatePageModel.prototype.reset = function () {
            this.compatibilityResultsCache = undefined;
        };
        VmProvisioningSelectTemplatePageModel.prototype.resetForm = function () { };
        VmProvisioningSelectTemplatePageModel.prototype.validatePage = function () {
            if (!this._selectionIsTemplate) {
                return this.$q.resolve({ error: this.INVALID_ENTITY_ERROR });
            }
            if (this.wizardViewData.getVmConnectedState() !== this.CONNECTED) {
                return this.$q.resolve({ error: this.INVALID_STATE });
            }
            if (!this.hasActionPrivileges) {
                return this.$q.resolve({ error: this.createNoPrivilegesErrorString(this.virtualMachineSpecBuilder.getCreationType()) });
            }
            return this.$q.resolve({});
        };
        VmProvisioningSelectTemplatePageModel.prototype.submitPage = function () {
            if (!this._originalWizardTitle || this.config.title.indexOf(this._originalWizardTitle) === -1) {
                this._originalWizardTitle = this.config.title;
            }
            this.config.title = this.wizardViewData.getSourceObjectName() + " - " +
                this._originalWizardTitle;
            return {
                wizardFlow: this.virtualMachineSpecBuilder.getCreationType(),
                invalidateNextPages: this.selectedTemplateChanged
            };
        };
        VmProvisioningSelectTemplatePageModel.prototype.makeCompatibilityMessage = function (privilegeStatuses, connectionState) {
            this.hasActionPrivileges = true;
            if (connectionState !== this.CONNECTED) {
                return this.INVALID_STATE;
            }
            for (var i = 0; i < privilegeStatuses.length; i++) {
                if (!privilegeStatuses[i]) {
                    this.hasActionPrivileges = false;
                    break;
                }
            }
            if (this.hasActionPrivileges) {
                return "";
            }
            return this.createNoPrivilegesErrorString(this.virtualMachineSpecBuilder.getCreationType());
        };
        VmProvisioningSelectTemplatePageModel.prototype.createNoPrivilegesErrorString = function (creationType) {
            var key = "SelectTemplateProvisioningPage.Template.NoPermission." +
                this.getRequiredPermission(creationType);
            return this.i18nService.getString("VmUi", key);
        };
        VmProvisioningSelectTemplatePageModel.prototype.getRequiredPermission = function (creationType) {
            return (creationType === this.creationTypeConstants.CONVERT_TEMPLATE_TO_VM) ? this.MARK_AS_VM_PRIVILEGE :
                (creationType === this.creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE
                    || creationType === this.creationTypeConstants.CLONE_TEMPLATE_TO_VM) ? this.CLONE_TEMPLATE_PRIVILEGE : "";
        };
        VmProvisioningSelectTemplatePageModel.$inject = [
            "$q",
            "i18nService",
            "dataService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "creationTypeConstants",
            "wizardPageService"
        ];
        return VmProvisioningSelectTemplatePageModel;
    }());
    h5_vm.VmProvisioningSelectTemplatePageModel = VmProvisioningSelectTemplatePageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningSelectTemplatePageModel", VmProvisioningSelectTemplatePageModelFactory);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectTemplatePageService = (function () {
        function VmProvisioningSelectTemplatePageService(i18nService, defaultUriSchemeUtil, wizardPageService, vmVuiWizardPageBuilder, vmProvisioningSelectTemplatePageModel) {
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningSelectTemplatePageModel = vmProvisioningSelectTemplatePageModel;
        }
        VmProvisioningSelectTemplatePageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningSelectTemplatePageModel(wizardScope.vmParams, wizardScope.wizardViewData, wizardScope.config);
            wizardScope.selectTemplateModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Title"),
                description: this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/vm-provisioning-select-template-page.html",
                model: pageModel
            });
        };
        VmProvisioningSelectTemplatePageService.$inject = [
            "i18nService",
            "defaultUriSchemeUtil",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "vmProvisioningSelectTemplatePageModel"
        ];
        return VmProvisioningSelectTemplatePageService;
    }());
    h5_vm.VmProvisioningSelectTemplatePageService = VmProvisioningSelectTemplatePageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningSelectTemplatePageService", VmProvisioningSelectTemplatePageService);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectTemplatePageModel = h5_vm.VmProvisioningSelectTemplatePageModel;
    var VmProvisioningSelectTemplateToConvertPageModelFactory = (function () {
        function VmProvisioningSelectTemplateToConvertPageModelFactory($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService) {
            return function (virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
                return new VmProvisioningSelectTemplateToConvertPageModel($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService, virtualMachineSpecBuilder, wizardViewData, wizardConfig);
            };
        }
        VmProvisioningSelectTemplateToConvertPageModelFactory.$inject = [
            "$q",
            "i18nService",
            "dataService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "creationTypeConstants",
            "wizardPageService"
        ];
        return VmProvisioningSelectTemplateToConvertPageModelFactory;
    }());
    var VmProvisioningSelectTemplateToConvertPageModel = (function (_super) {
        __extends(VmProvisioningSelectTemplateToConvertPageModel, _super);
        function VmProvisioningSelectTemplateToConvertPageModel($q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService, virtualMachineSpecBuilder, wizardViewData, wizardConfig) {
            _super.call(this, $q, i18nService, dataService, authorizationService, defaultUriSchemeUtil, managedEntityConstants, creationTypeConstants, wizardPageService, virtualMachineSpecBuilder, wizardViewData, wizardConfig);
        }
        VmProvisioningSelectTemplateToConvertPageModel.prototype.updateSelection = function (item) {
            var selectionUpdated = _super.prototype.updateSelection.call(this, item);
            if (!selectionUpdated) {
                return false;
            }
            var DATACENTER_ITEM = this.getDatacenter(item);
            this.virtualMachineSpecBuilder.setTargetInformation(DATACENTER_ITEM.id, DATACENTER_ITEM.id, null, DATACENTER_ITEM.text);
            return true;
        };
        VmProvisioningSelectTemplateToConvertPageModel.prototype.getDatacenter = function (item) {
            while (this.defaultUriSchemeUtil.getEntityType(item.objRef) !== this.managedEntityConstants.DATACENTER) {
                item = item.parentNode();
            }
            return item;
        };
        VmProvisioningSelectTemplateToConvertPageModel.$inject = [
            "$q",
            "i18nService",
            "dataService",
            "authorizationService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "creationTypeConstants",
            "wizardPageService"
        ];
        return VmProvisioningSelectTemplateToConvertPageModel;
    }(VmProvisioningSelectTemplatePageModel));
    h5_vm.VmProvisioningSelectTemplateToConvertPageModel = VmProvisioningSelectTemplateToConvertPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningSelectTemplateToConvertPageModel", VmProvisioningSelectTemplateToConvertPageModelFactory);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectTemplateToConvertPageService = (function () {
        function VmProvisioningSelectTemplateToConvertPageService(i18nService, defaultUriSchemeUtil, wizardPageService, vmVuiWizardPageBuilder, vmProvisioningSelectTemplateToConvertPageModel) {
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningSelectTemplateToConvertPageModel = vmProvisioningSelectTemplateToConvertPageModel;
        }
        VmProvisioningSelectTemplateToConvertPageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningSelectTemplateToConvertPageModel(wizardScope.vmParams, wizardScope.wizardViewData, wizardScope.config);
            wizardScope.selectTemplateToConvertModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Title"),
                description: this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/vm-provisioning-select-template-to-convert-page.html",
                model: pageModel
            });
        };
        VmProvisioningSelectTemplateToConvertPageService.$inject = [
            "i18nService",
            "defaultUriSchemeUtil",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "vmProvisioningSelectTemplateToConvertPageModel"
        ];
        return VmProvisioningSelectTemplateToConvertPageService;
    }());
    h5_vm.VmProvisioningSelectTemplateToConvertPageService = VmProvisioningSelectTemplateToConvertPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningSelectTemplateToConvertPageService", VmProvisioningSelectTemplateToConvertPageService);
})(h5_vm || (h5_vm = {}));







(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningCloneCustomizeGuestOsPageModel',
               VmProvisioningCloneCustomizeGuestOsPageModel);

   VmProvisioningCloneCustomizeGuestOsPageModel.$inject = [
      '$q',
      'dataService',
      'i18nService',
      'vuiConstants',
      'creationTypeConstants',
      'guestosCustomizationConstants',
      'defaultUriSchemeUtil',
      'timeFormatterService',
      'userSessionService',
      'guestOsCustomizationSpecValidator',
      "customizeGosPreCheckSpecsService"
   ];

   function VmProvisioningCloneCustomizeGuestOsPageModel($q,
         dataService,
         i18nService,
         vuiConstants,
         creationTypeConstants,
         guestosCustomizationConstants,
         defaultUriSchemeUtil,
         timeFormatterService,
         userSessionService,
         guestOsCustomizationSpecValidator,
         customizeGosPreCheckSpecsService) {
      return function(virtualMachineSpecBuilder, wizardViewData) {
         var form = {};
         var savedDateTimeFormat;

         return {
            form: form,
            resetForm: resetForm,
            validatePage: validatePage,
            submitPage: submitPage,
            getForm: getForm,
            pageFinishedLoading: pageFinishedLoading
         };

         function resetForm() {
            form.readyToView = false;
            form.guestOsIsCustomizable = true;
            form.datagridOptions = {
               columnDefs: [
                  {
                     field: 'name',
                     displayName: i18nService.getString(
                           'VmUi', 'CustomizeGuestOsProvisioningPage.content.name')
                  },
                  {
                     field: 'guestOs',
                     displayName: i18nService.getString(
                           'VmUi', 'CustomizeGuestOsProvisioningPage.content.type'),
                     width: 110
                  },
                  {
                     field: 'lastModified',
                     searchable: false,
                     displayName: i18nService.getString('VmUi',
                           'customizationManager.customizationSpecList.lastModifiedColumnHeader'),
                     template: function (spec) {
                        return timeFormatterService.timestampToText(
                              parseInt(spec.lastModified), savedDateTimeFormat);
                     }
                  }

               ],
               sortOrder: [{
                  field: "name",
                  dir: "asc"
               }],
               selectionMode: vuiConstants.grid.selectionMode.SINGLE,
               searchable: false,
               resizable: true,
               height: '100%',
               selectedItems: [],
               data: []
            };

            timeFormatterService.getUserTimeFormatPreference().then(function(format) {
               savedDateTimeFormat = format;
            });

            if (virtualMachineSpecBuilder.getCreationType() ===
                  creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ||
                virtualMachineSpecBuilder.getCreationType() ===
                  creationTypeConstants.DEPLOY_VM_FROM_VAPP) {
               populateGosCustomizationDataForDeployTemplate();
            } else {
               populateGosCustomizationDataForCloneVm();
            }
         }

         function populateGosCustomizationDataForDeployTemplate() {
            var vCenter;
            var customizationManager;
            userSessionService.getAllServersInfo()
               .then(function (info) {
                  var template = wizardViewData.getSelectedTemplate();
                  var guestOsType = getGosType(template.gosType);

                  wizardViewData.setGuestOsType(guestOsType);
                  form.guestOsName = template.gosDescription;
                  var vCentersData = info.serversInfo;

                  if (vCentersData && vCentersData.length > 0) {
                     vCenter = vCentersData[0];
                     customizationManager = vCenter ?
                        defaultUriSchemeUtil.getVsphereObjectId(vCenter.content.customizationSpecManager) :
                        null;
                  }

                  if (!customizationManager) {
                     return $q.reject({});
                  }

                  return dataService.getProperties(customizationManager, ['customizationSpecListData'], {
                     propertyParams: [{
                        _type: 'com.vmware.vise.mvc.model.data.ParamSpec',
                        propertyName: 'customizationSpecListData',
                        parameterType: 'java.lang.String',
                        parameter: template.gosType
                     }]
                  });
               }).then(function (props) {
                  if (!isCustomizationValid(props.customizationSpecListData.compatibility)) {
                     return $q.resolve({});
                  }
                  var customizationSpecs = filterRelevantCustomizationSpecs(props.customizationSpecListData.customizationSpecs);
                  return $q.all(_.map(customizationSpecs, function(spec) {
                     return {
                        name: spec.name,
                        guestOs: spec.type,
                        lastModified: spec.lastUpdateTime
                     };
                  }));
               }).then(function(customizationSpecs) {
                  resetSelectedSpec(customizationSpecs);
                  form.datagridOptions.data = customizationSpecs;
                  form.readyToView = true;
               });
         }

         function populateGosCustomizationDataForCloneVm() {
            var cloneCustomizationSpecDataPromise;
            var customizeGosSpecData = wizardViewData.getCustomizeGosSpecData();
            wizardViewData.setCustomizeGosSpecData();
            if(customizeGosSpecData) {
               var cloneCustomizationSpecData = {
                  error: customizeGosPreCheckSpecsService.validateData(customizeGosSpecData),
                  data: customizeGosSpecData
               };
               cloneCustomizationSpecDataPromise = $q.when(cloneCustomizationSpecData);
            }
            if(!cloneCustomizationSpecDataPromise) {
               var vmId = virtualMachineSpecBuilder.getVmId();
               cloneCustomizationSpecDataPromise = customizeGosPreCheckSpecsService
                     .cloneCustomizeGosLoadData(vmId);
            }

            cloneCustomizationSpecDataPromise.then(function(cloneCustomizationSpecData) {
               form.readyToView = true;
               var warning = cloneCustomizationSpecData.error;

               wizardViewData.setGuestOsType(cloneCustomizationSpecData.data.guestType);
               form.guestOsName = cloneCustomizationSpecData.data.guestFullName;

               if(warning) {
                  form.guestOsIsCustomizable = false;
                  form.uncustomizableMessage = warning;
                  return ;
               }

               var customizationSpecs = _.map(cloneCustomizationSpecData.data.relevantSpecs, function(spec) {
                  return {
                     name: spec.name,
                     guestOs: spec.type,
                     lastModified: spec.lastUpdateTime
                  };
               });

               resetSelectedSpec(customizationSpecs);
               form.datagridOptions.data = customizationSpecs;
               form.readyToView = true;
               return {};
            });
         }

         function filterRelevantCustomizationSpecs(allSpecs) {
            var currentGuestOS = wizardViewData.getGuestOsType();
            var filteredSpecs = _.filter(allSpecs,
               function(spec) {
                  return currentGuestOS === spec.type;
               });
            return filteredSpecs;
         }

         function isCustomizationValid(compatibility) {
            if (compatibility === guestosCustomizationConstants.MISSING_WINDOWS) {
               form.guestOsIsCustomizable = false;
               form.uncustomizableMessage =
                  i18nService.getString('VmUi', 'CustomizationDataProvider.missing_windows');
               return false;
            }
            if (compatibility === guestosCustomizationConstants.MISSING_LINUX) {
               form.guestOsIsCustomizable = false;
               form.uncustomizableMessage =
                  i18nService.getString('VmUi', 'CustomizationDataProvider.missing_linux');
               return false;
            }
            if (compatibility === guestosCustomizationConstants.UNCUSTOMIZABLE) {
               form.guestOsIsCustomizable = false;
               form.uncustomizableMessage =
                  i18nService.getString('VmUi', 'CustomizationDataProvider.cannot_customize');
               return false;
            }
            return true;
         }

         function processCustomizationData(customizationSpecsData) {

         }

         function validatePage() {
            if (!form.guestOsIsCustomizable) {
               unsetSpecData();
               return null;
            }

            // if there are no guest os specs loaded on the page - don't require selection
            if (form.datagridOptions.data.length === 0) {
               unsetSpecData();
               return null;
            }

            if (!form.selectedSpec) {
               return $q.resolve({
                  error: i18nService.getString('VmUi',
                        'CustomizeGuestOsProvisioningPage.content.noSelection')
               });
            }

            var vmId = virtualMachineSpecBuilder.getVmId();

            if (isInDeployFromTemplateMode()) {
               // Constructing a dummy VM ID for deploy OVF templates. OVF templates
               // do not have associated VM IDs. VM ID is necesary to retrieve
               vmId = 'urn:vmomi:VirtualMachine:template:' +
                     defaultUriSchemeUtil
                           .getPartsFromVsphereObjectId(wizardViewData.getVCenterId())
                           .serverGuid;
            }

            form.setPageLoading(true);
            return guestOsCustomizationSpecValidator.validate(
                  vmId,
                  virtualMachineSpecBuilder.getName(),
                  form.selectedSpec.name
            ).then(function(result) {
               wizardViewData.setCustomizationSpecName(result.specName);
               wizardViewData.setNICsToCustomize(result.nicsToCustomize);
               wizardViewData.setNeedToInputComputerName(result.needsComputerName);

               virtualMachineSpecBuilder.setCustomizationSpec(result.spec);
               virtualMachineSpecBuilder.setCustomizationSpecInfo(result.info);
               virtualMachineSpecBuilder.setCustomizationSpecName(result.specName);

               // #2214153 Disable showing user settings page while deploying a VM from VMTX in CL.
               var shouldShowUserSettingsPage = !isInDeployVmFromVmtxMode() &&
                     (result.needsComputerName || result.needsAnyNICSettings);
               form.showUserSettingsPage(shouldShowUserSettingsPage);

               return true;
            }, function(result) {
               return $q.resolve({ error: result.error });
            }).then(function(res) {
               form.setPageLoading(false);
               return res;
            });
         }

         function submitPage() {
            return {
               wizardFlow: virtualMachineSpecBuilder.getCreationType(),
               invalidateNextPages: false
            };
         }

         function getForm() {
            return form;
         }

         function pageFinishedLoading() {
            return form.readyToView;
         }

         function resetSelectedSpec(customizationSpecs) {
            if (form.selectedSpec) {
               var selectedSpec = _.some(customizationSpecs, function(spec) {
                  return form.selectedSpec.name === spec.name;
               });

               if (!selectedSpec) {
                  form.selectedSpec = undefined;
               }
            }
         }

         function unsetSpecData() {
            wizardViewData.setCustomizationSpecName();
            wizardViewData.setNICsToCustomize();
            wizardViewData.setNeedToInputComputerName();
            virtualMachineSpecBuilder.setCustomizationSpec();
            virtualMachineSpecBuilder.setCustomizationSpecInfo();
            form.showUserSettingsPage(false);
         }

         function getGosType(gosType) {
            if (!gosType) {
               return guestosCustomizationConstants.TYPE_OTHER;
            }

            return (gosType.indexOf('win') === 0) ?
               guestosCustomizationConstants.TYPE_WINDOWS : guestosCustomizationConstants.TYPE_LINUX;
         }

         function isInDeployFromTemplateMode() {
            return virtualMachineSpecBuilder.getCreationType() ===
                  creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE;
         }

         function isInDeployVmFromVmtxMode() {
            return virtualMachineSpecBuilder.getCreationType() ===
                  creationTypeConstants.DEPLOY_VM_FROM_VMTX;
         }
      };
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('vmProvisioningCloneCustomizeGuestOsPageService',
               vmProvisioningCloneCustomizeGuestOsPageService);

   vmProvisioningCloneCustomizeGuestOsPageService.$inject = ['i18nService',
      'vuiConstants',
      'vmVuiWizardPageBuilder',
      'VmProvisioningCloneCustomizeGuestOsPageModel'];
   function vmProvisioningCloneCustomizeGuestOsPageService(i18nService,
         vuiConstants,
         vmVuiWizardPageBuilder,
         VmProvisioningCloneCustomizeGuestOsPageModel) {
      return {
         build: function(wizardScope) {
            var virtualMachineSpecBuilder = wizardScope.vmParams;

            var pageModel = new VmProvisioningCloneCustomizeGuestOsPageModel(
                  virtualMachineSpecBuilder,
                  wizardScope.wizardViewData
            );
            wizardScope.vmProvisioningCloneCustomizeGuestOsPageModel = pageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi',
                     'CustomizeGuestOsProvisioningPage.Title'),
               description: i18nService.getString('VmUi',
                     'CustomizeGuestOsProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningCloneGuestOs.html',
               defaultState: vuiConstants.wizard.pageState.SKIPPED,
               model: pageModel
            });
         }
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('vmProvisioningCloneOptionsPageService', vmProvisioningCloneOptionsPageService);
   vmProvisioningCloneOptionsPageService.$inject = [
      'i18nService',
      'vmVuiWizardPageBuilder',
      'VmProvisioningCloneOptionsPageModel',
      'creationTypeConstants'];

   function vmProvisioningCloneOptionsPageService(i18nService, vmVuiWizardPageBuilder,
         VmProvisioningCloneOptionsPageModel, creationTypeConstants) {
      return {
         build: function(wizardScope) {
            var pageModel = new VmProvisioningCloneOptionsPageModel(
                  wizardScope.vmParams,
                  wizardScope.wizardViewData,
                  wizardScope.config);

            var cloneOptionsTitle = i18nService.getString('VmUi', 'SelectCloneOptionsProvisioningPage.Title');
            var cloneOptionsDescription = i18nService.getString('VmUi', 'SelectCloneOptionsProvisioningPage.Description');

            if(creationTypeConstants.isDeployVmFromVmtxTemplate(wizardScope.vmParams.getCreationType())){
               cloneOptionsTitle = i18nService.getString('VmUi', 'SelectCloneOptionsProvisioningPage.DeployTitle');
               cloneOptionsDescription = i18nService.getString('VmUi', 'SelectCloneOptionsProvisioningPage.DeployDescription');
            }

            wizardScope.cloneOptionsPageModel = pageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: cloneOptionsTitle,
               description: cloneOptionsDescription,
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vm-provisioning-clone-options-page.html',
               model: pageModel
            });
         }
      };
   }
}());

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
      .service('VmProvisioningComputeResourcePageModel', VmProvisioningComputeResourcePageModel);

   VmProvisioningComputeResourcePageModel.$inject = [
      '$q',
      'i18nService',
      'sourceTypeConstants',
      'creationTypeConstants',
      'defaultUriSchemeUtil',
      'compatibilityCheckService',
      'registerVmCompatibilityCheckService',
      'resourcePoolLookupService',
      'dataService',
      'contentLibraryService',
      'authorizationService',
      'managedEntityConstants',
      'wizardPageService',
      'vcService',
      'compatibilityResultsPresenter',
      'vuiConstants'];

   function VmProvisioningComputeResourcePageModel(
         $q,
         i18nService,
         sourceTypeConstants,
         creationTypeConstants,
         defaultUriSchemeUtil,
         compatibilityCheckService,
         registerVmCompatibilityCheckService,
         resourcePoolLookupService,
         dataService,
         contentLibraryService,
         authorizationService,
         managedEntityConstants,
         wizardPageService,
         vcService,
         compatibilityResultsPresenter,
         vuiConstants) {

      return function(virtualMachineSpecBuilder, preselectedComputeResource, viewData,
            wizardConfig, scheduleTaskData) {
         var form = {
            compatibilityResultsCache: undefined,
            lastSelectedComputeResourceId: undefined
         };
         var selectionIsValid;
         // _treeRootReference keeps the id of the last
         // datacenter for which the compute resource
         // tree was loaded
         var _treeRootReference = null;
         var _pendingValidationRequests = 0;
         var _lastValidationId = 0;
         var OVF_CONTEXTTYPE_IPALLOCATION = "com.vmware.vcenter.ovf.IpAllocationParams";
         var OVF_CONTEXTTYPE_PROPERTY = "com.vmware.vcenter.ovf.PropertyParams";
         var hasDeviceFaults = false;
         return {
            form: form,

            resetForm: function () {
               var submittedComputeResourceId = virtualMachineSpecBuilder.getComputeResourceId();
               var suggestedComputeResourceId = form.selectedComputeResourceId ||
                     submittedComputeResourceId || preselectedComputeResource;
               form.selectedComputeResourceId = suggestedComputeResourceId;
               var treeRootReference = this.getTreeRootReference();
               if(_treeRootReference !== treeRootReference) {
                  selectionIsValid = false;
                  _treeRootReference = treeRootReference;
               }
            },

            validateSelection: function () {
               if (form.lastSelectedComputeResourceId
                     && form.lastSelectedComputeResourceId === form.selectedComputeResourceId
                     && form.compatibilityResultsCache) {
                  return $q.resolve(form.compatibilityResultsCache);
               }

               var creationType = virtualMachineSpecBuilder.getCreationType();
               _pendingValidationRequests++;

               var validationId = ++_lastValidationId;

               var validationPromise;
               if(creationType === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ||
                  creationType === creationTypeConstants.DEPLOY_VM_FROM_VAPP ||
                  creationType === creationTypeConstants.DEPLOY_VM_FROM_OVF) {
                  validationPromise =
                        validateSelectionForDeployVmFromTemplateFlow(validationId);
               } else if (creationTypeConstants.isRegisterVm(creationType)) {
                  validationPromise = validateSelectionForRegisterVmFlow(validationId);
               } else {
                  validationPromise = validateSelectionForAnyOtherFlow(validationId);
               }

               return validationPromise.then(function(compatibilityResults) {
                  _pendingValidationRequests--;
                  form.lastSelectedComputeResourceId = form.selectedComputeResourceId;
                  form.compatibilityResultsCache = compatibilityResults;
                  return form.compatibilityResultsCache;
               });
            },

            validatePage: function () {
               wizardPageService.clearErrors(wizardConfig);
               if (!selectionIsValid) {
                  return {
                     error: i18nService.getString('VmUi',
                           'SelectResourcePoolProvisioningPage.specifyValidDestination')
                  };
               }
               wizardPageService.showLoadingIndicator(wizardConfig);

               if(virtualMachineSpecBuilder.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ||
                     virtualMachineSpecBuilder.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_VAPP ||
                     virtualMachineSpecBuilder.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_OVF) {

                  var computeResId = form.selectedComputeResourceId;
                  var folderId =
                        virtualMachineSpecBuilder.getTargetInformation().folderUid;
                  var vmName = virtualMachineSpecBuilder.getName();
                  var templateId;
                  var ovfSession;
                  var sourceType = sourceTypeConstants.SOURCE_TYPE_CONTENTLIB;//let it be default
                  if (virtualMachineSpecBuilder.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_OVF) {
                     sourceType = viewData.getTemplateSourceType();
                     if (sourceType === sourceTypeConstants.SOURCE_TYPE_PUSH) {
                        ovfSession = viewData.getDeployOvfSession();
                        vmName = ovfSession.templateName;
                     } else {
                        templateId = viewData.getUrlTemplate();
                     }

                     wizardConfig.validationBanner.isCloseable = false;
                     wizardConfig.currentPage.disableNext = function() {
                        return _.some(wizardConfig.validationBanner.messages, function(message) {
                           return message.type === vuiConstants.validationBanner.type.ERROR;
                        });
                     };

                  } else {
                     templateId = viewData.getSelectedTemplate().templateId;
                  }

                  var promise = contentLibraryService.getAndValidateResourcePool(
                        computeResId, folderId, vmName, templateId, sourceType, ovfSession);
                  return promise.then(function(response) {
                     return handleValidationResponse(response);
                  });
               } else {
                  return null;
               }
            },

            setIsValid: function(isValid) {
               selectionIsValid = isValid;
            },

            submitPage: function () {
               var creationType = virtualMachineSpecBuilder.getCreationType();

               const scheduledTaskData = virtualMachineSpecBuilder.getScheduledData();

               // clone to template workflows does not have customize hw
               if (!creationTypeConstants.isCloningToATemplate(creationType)) {
                  virtualMachineSpecBuilder.setCustomizeCloneHardware(hasDeviceFaults);
               }

               // in case we are in the edit or create scheduled task for clone vm to vm
               // then the customize hardware page is not displayed unless
               // there are any hardware compatibility errors
               if (creationType === creationTypeConstants.CLONE_VM_TO_VM &&
                     scheduleTaskData && scheduleTaskData.isScheduledTask) {
                  var pages = wizardConfig.pages;
                  if (hasDeviceFaults) {
                     wizardPageService.markPageDisabled(
                           pages,
                           i18nService.getString(
                                 'VmUi', 'CustomizeHardwareProvisioningPage.Title'));
                  } else {
                     wizardPageService.markPageSkipped(
                           pages,
                           i18nService.getString(
                                 'VmUi', 'CustomizeHardwareProvisioningPage.Title'));
                  }
               }

               var invalidateNextPages = selectionIsNew();
               var computeResId = form.selectedComputeResourceId;
               var computeResName = form.selectedComputeResourceName;
               virtualMachineSpecBuilder.setComputeResourceId(computeResId);
               virtualMachineSpecBuilder.setComputeResourceName(computeResName);

               // in case the compute resource is changed from the one selected when the
               // scheduled task was created, do not use the data to pre-populate the customize hardware page
               if (!_.isEmpty(scheduledTaskData)) {
                  if (scheduledTaskData.computeResourceId !== computeResId) {
                     scheduledTaskData.useScheduledTaskData = false;
                  }
               }

               if(creationType !== creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE
                  && creationType !== creationTypeConstants.DEPLOY_VM_FROM_VAPP
                  && creationType !== creationTypeConstants.DEPLOY_VM_FROM_OVF
                  && !creationTypeConstants.isRegisterVm(creationType)) {
                  return $q.resolve({
                     wizardFlow: creationType,
                     invalidateNextPages: invalidateNextPages
                  });
               }

               var promisses = {
                  resPool: resourcePoolLookupService.lookupResourcePoolForComputeResource(computeResId),
                  filterNetworks: getFilterNetworksObjectId(computeResId)
               };

               return $q.all(promisses).then(function(result) {
                  virtualMachineSpecBuilder.setResourcePool(result.resPool);
                  virtualMachineSpecBuilder.setFilterNetworksObjectId(result.filterNetworks);

                  return {
                     wizardFlow: creationType,
                     invalidateNextPages: invalidateNextPages
                  };
               }).then(function(result) {
                  wizardPageService.hideLoadingIndicator(wizardConfig);
                  return result;
               });
            },

            getTreeRootReference: function () {
               return virtualMachineSpecBuilder.getTargetInformation().datacenterUid;
            },

            // NOTE alalev: This method returns a Promise<string>, not a string
            getTreeType: function() {
               switch (virtualMachineSpecBuilder.getCreationType()) {
                  case creationTypeConstants.CREATE_FROM_SCRATCH:
                  case creationTypeConstants.CLONE_TEMPLATE_TO_VM:
                  case creationTypeConstants.CLONE_AS_VMTEMPLATE_TO_LIBRARY:
                  case creationTypeConstants.CLONE_VM_TO_VM:
                  case creationTypeConstants.CONVERT_TEMPLATE_TO_VM:
                  case creationTypeConstants.DEPLOY_VM_FROM_VPP:
                  case creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE:
                  case creationTypeConstants.CLONE_VM_TO_TEMPLATE:
                  case creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE:
                  case creationTypeConstants.DEPLOY_VM_FROM_OVF:
                  case creationTypeConstants.DEPLOY_VM_FROM_VMTX:
                     return $q.resolve('DcHostsAndClustersTree');
                  case creationTypeConstants.REGISTER_VM:
                     if (!virtualMachineSpecBuilder.getRegisterVmData().isTemplate) {
                        return $q.resolve('DcHostsAndClustersTree');
                     }
                     var root = virtualMachineSpecBuilder.getTargetInformation().datacenterUid;
                     return vcService.is66VcOrLater(root).then(function (is66VcOrLater) {
                        return is66VcOrLater
                              ? 'DcClusterHostAndRpTree'
                              : 'DcClusterAndHostOnlyTree';
                     });
                  default:
                     return $q.resolve('DcClusterAndHostOnlyTree');
               }
            },

            validationFinishedLoading: function () {
               return (_pendingValidationRequests === 0);
            }
         };

         function handleValidationResponse(response) {
            if(response && response.result && response.result.newContext) {
               var newContext = response.result.newContext;
               var gosCustomizationSpec = virtualMachineSpecBuilder.getCustomizationSpec();
               if (!_.isEmpty(gosCustomizationSpec)) {
                  newContext = processContextForGOSCustomization(newContext);
               }
               viewData.setDeployFromLibraryCommonContext(newContext);
               viewData.setResourcePoolDeploymentResponse(response);
               return response;
            } else {
               wizardPageService.hideLoadingIndicator(wizardConfig);
               var backendErrorStr = readLocalizedBackendErrors(response);
               return {
                  error: (backendErrorStr ? backendErrorStr :
                     i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.fatalError'))
               };
            }
         }
         function processContextForGOSCustomization(contextObjects) {
              var newContext = [];
              _.each (contextObjects, function (ctxObject) {
                 //skip PropertyParam and IpAllocation type objects
                  if (ctxObject._type !== OVF_CONTEXTTYPE_PROPERTY &&
                        ctxObject._type !== OVF_CONTEXTTYPE_IPALLOCATION) {
                     newContext.push(ctxObject);
                  }
              });
              return newContext;
          }

         function validateSelectionForDeployVmFromTemplateFlow (validationId) {
            var objectId = form.selectedComputeResourceId;
            var resourcePoolForComputeResource;
            var compatibilityResults;
            var advancedCompatibilityContents;
            var localizedError;

            if (defaultUriSchemeUtil.getEntityType(objectId) === 'Datacenter') {
               selectionIsValid = false;
               localizedError = i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.SelectRPOnly');
               return $q.when(buildErrorMessageObject([localizedError]));
            }

            return contentLibraryService.validateComputeResourceSelection(objectId)
               .then(function(resourceValidationResponse) {

                  if (!isValidationRelevant(validationId)) {
                     compatibilityResults = null;
                     return compatibilityResults;
                  }

                  advancedCompatibilityContents = parseMessagesToAdvanced(resourceValidationResponse);

                  if (resourceValidationResponse.result) {
                     var parsedTopLevelAndHostMessages = parseMessages(resourceValidationResponse.result);
                     selectionIsValid = resultIsValid(parsedTopLevelAndHostMessages);
                     compatibilityResults = formatAndCombineMessages(parsedTopLevelAndHostMessages);
                  } else {
                     selectionIsValid = false;
                     compatibilityResults = buildErrorMessageObject([resourceValidationResponse.error.localizedMessage]);
                  }

                  if (!selectionIsValid) {
                     return compatibilityResults;
                  } else {
                     return contentLibraryService.getResourcePoolForComputeResource(objectId);
                  }

               })
               .then(function(resourcePoolForComputeResponse) {

                  if (!selectionIsValid || !isValidationRelevant(validationId)) {
                     return compatibilityResults;
                  }

                  if (!resourcePoolForComputeResponse.resourcePool) {
                     appendToAdvancedContents([i18nService.getString('ProvisioningUiLib',
                           'SelectResourcePage.errorNoResourcePool')],
                           [],[],
                           advancedCompatibilityContents,
                           compatibilityResultsPresenter.NO_HOST_ID);
                  }

                  if (resourcePoolForComputeResponse.resourcePool) {
                     resourcePoolForComputeResource = defaultUriSchemeUtil.getVsphereObjectId(resourcePoolForComputeResponse.resourcePool);
                     return resourcePoolPrivilegeValidation(resourcePoolForComputeResource);
                  } else {
                     var localizedError = i18nService.getString('ProvisioningUiLib', 'SelectResourcePage.errorNoResourcePool');
                     selectionIsValid = false;
                     compatibilityResults = buildErrorMessageObject([localizedError]);
                     return compatibilityResults;
                  }

               })
               .then(function(privilegeValidationResponse) {

                  if (!selectionIsValid || !isValidationRelevant(validationId)) {
                     return compatibilityResults;
                  }

                  if (!privilegeValidationResponse[0]) {
                     appendToAdvancedContents([i18nService.getString('ProvisioningUiLib',
                           'SelectResourcePage.errorNoPrivilegeForH5')],
                           [],[],
                           advancedCompatibilityContents,
                           compatibilityResultsPresenter.NO_HOST_ID);
                  }

                  if (privilegeValidationResponse[0]) {
                     return disabledMethodValidation(resourcePoolForComputeResource);
                  } else {
                     var localizedError = i18nService.getString('ProvisioningUiLib', 'SelectResourcePage.errorNoPrivilegeForH5');
                     selectionIsValid = false;
                     compatibilityResults = buildErrorMessageObject([localizedError]);
                     return compatibilityResults;
                  }

               })
               .then(function(disabledMethodValidationResponse) {

                  if (!selectionIsValid || !isValidationRelevant(validationId)) {
                     return compatibilityResults;
                  }

                  if (!disabledMethodValidationResponse) {
                     appendToAdvancedContents([i18nService.getString('ProvisioningUiLib',
                           'SelectResourcePage.errorImportVAppDisabled')],
                           [],[],
                           advancedCompatibilityContents,
                           compatibilityResultsPresenter.NO_HOST_ID);
                  }

                  if (disabledMethodValidationResponse) {
                     return compatibilityResults;
                  } else {
                     var localizedError = i18nService.getString('ProvisioningUiLib', 'SelectResourcePage.errorImportVAppDisabled');
                     selectionIsValid = false;
                     compatibilityResults = buildErrorMessageObject([localizedError]);
                     return compatibilityResults;
                  }

               })
               .then(function(compatibilityResults) {
                  return prettifyAndAppendAdvancedContents(compatibilityResults,
                        advancedCompatibilityContents);
               });
         }

         function validateSelectionForRegisterVmFlow(validationId) {
            selectionIsValid = false;
            var advancedCompatibilityContents = appendToAdvancedContents();

            return registerVmCompatibilityCheckService.validate(
                  form.selectedComputeResourceId,
                  virtualMachineSpecBuilder.getStorageObject(),
                  virtualMachineSpecBuilder.getRegisterVmData().isTemplate
            ).then(function(validationResult) {
               if (!isValidationRelevant(validationId)) {
                  return null;
               }
               var message;
               var errorMessages;
               if (validationResult.error) {
                  var backendErrorStr = readLocalizedBackendErrors(validationResult);

                  message = backendErrorStr || i18nService.getString('VmUi',
                              'SelectResourcePoolProvisioningPage.fatalError');
                  advancedCompatibilityContents = appendToAdvancedContents([message],
                        [],[]);
                  errorMessages = buildErrorMessageObject([message]);
                  return errorMessages;
               }

               var checkResult = validationResult.result;
               // if there is any compatibility issue, build the error message
               if (checkResult && checkResult.localizationKey) {
                  selectionIsValid = false;

                  var args = ['VmUi', checkResult.localizationKey]
                        .concat(checkResult.localizationArgs);
                  message = i18nService.getString.apply(null, args);
                  advancedCompatibilityContents = appendToAdvancedContents([message],
                        [],[]);
                  errorMessages = buildErrorMessageObject([message]);
                  return errorMessages;
               }

               selectionIsValid = true;
               return createCompatibilityCheckSucceededMessage();
            }).then(function(compatibilityResults) {
               return prettifyAndAppendAdvancedContents(compatibilityResults,
                     advancedCompatibilityContents);
            });
         }

         function validateSelectionForAnyOtherFlow(validationId) {
            var advancedCompatibilityContents;
            var vmOrTemplateRef;
            if(virtualMachineSpecBuilder.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
               vmOrTemplateRef = virtualMachineSpecBuilder.getVmtxLibraryItemId();
            } else {
               vmOrTemplateRef = virtualMachineSpecBuilder.getVmId();
            }

            return compatibilityCheckService.validateComputeResource(
               form.selectedComputeResourceId,
               virtualMachineSpecBuilder.getTargetInformation().folderUid,
               virtualMachineSpecBuilder.getCreationType(),
               virtualMachineSpecBuilder.getName(),
               vmOrTemplateRef
            ).then(function(response) {
               if (!isValidationRelevant(validationId)) {
                  return null;
               }

               advancedCompatibilityContents = parseMessagesToAdvanced(response);

               if (_.isEmpty(response.result) && !response.error) {
                  // The response.result (Check::Result) is specifically a *per-host* result.
                  // With no hosts, we have no results
                  var errorMessage = i18nService.getString('VmUi',
                        'SelectResourcePoolProvisioningPage.NoHostsFound');
                  var parsedMessages = {};
                  parsedMessages.topLevelMessages = [{
                     type: 'error',
                     message: errorMessage
                  }];

                  advancedCompatibilityContents.hostMap[compatibilityResultsPresenter.NO_HOST_ID]
                        .errors.push(errorMessage);

                  return formatAndCombineMessages(parsedMessages);
               }

               var parsedTopLevelAndHostMessages = parseMessages(response.result);
               selectionIsValid = resultIsValid(parsedTopLevelAndHostMessages);
               var result = formatAndCombineMessages(parsedTopLevelAndHostMessages);
               if (!selectionIsValid) {
                  return result;
               }

               hasDeviceFaults = checkHasDeviceFaults(response.result);

               var ownerRef = response.result[0].owner;
               var ownerId = ownerRef && defaultUriSchemeUtil.getVsphereObjectId(
                     response.result[0].owner);
               virtualMachineSpecBuilder.setComputeResourceOwnerId(ownerId);
               var resourcePool = defaultUriSchemeUtil.getVsphereObjectId(
                     response.result[0].resourcePool);
               var rpRuntime = response.result[0].rpRuntime;
               var networkFilterObject = defaultUriSchemeUtil.getVsphereObjectId(
                     response.result[0].networkFilterObject);
               virtualMachineSpecBuilder.setResourcePool({
                  id: resourcePool,
                  runtime: rpRuntime
               });
               virtualMachineSpecBuilder.setFilterNetworksObjectId(networkFilterObject);
               var creationType = virtualMachineSpecBuilder.getCreationType();
               if (creationType === creationTypeConstants.CREATE_FROM_SCRATCH) {
                  var objectType = defaultUriSchemeUtil.getEntityType(form.selectedComputeResourceId);
                  if (objectType === managedEntityConstants.V_APP) {
                     virtualMachineSpecBuilder.setIsResourcePoolInVapp(true);
                  }
                  if (objectType === managedEntityConstants.RESOURCE_POOL) {
                     var isRpInVapp = response.result[0].isInVapp;
                     virtualMachineSpecBuilder.setIsResourcePoolInVapp(isRpInVapp);
                  }
               }
               return result;
            }).then(function(compatibilityResults) {
               return prettifyAndAppendAdvancedContents(compatibilityResults,
                     advancedCompatibilityContents);
            });
         }

         function appendToAdvancedContents(errors, warnings, infos,
               advancedCompatibilityContents, hostId) {

            if (!advancedCompatibilityContents) {
               advancedCompatibilityContents = {
                  hostMap: {},
                  vmId: compatibilityResultsPresenter.NO_VM_ID,
                  vmProps: {
                     name: compatibilityResultsPresenter.NO_VM_NAME,
                     icon: compatibilityResultsPresenter.NO_VM_ICON
                  }
               };
            }
            if (!hostId) {
               hostId = compatibilityResultsPresenter.NO_HOST_ID;
            }
            if (!errors) {
               errors = [];
            }
            if (!warnings) {
               warnings = [];
            }
            if (!infos) {
               infos = [];
            }

            if (!advancedCompatibilityContents.hostMap[hostId]) {
               advancedCompatibilityContents.hostMap[hostId] = {
                  errors: [],
                  warnings: [],
                  infos: [],
                  props: {
                     icon: compatibilityResultsPresenter.NO_HOST_ICON,
                     name: compatibilityResultsPresenter.NO_HOST_NAME
                  }
               };
            }

            advancedCompatibilityContents.hostMap[hostId].errors =
                  advancedCompatibilityContents.hostMap[hostId].errors.concat(errors);
            advancedCompatibilityContents.hostMap[hostId].warnings =
                  advancedCompatibilityContents.hostMap[hostId].warnings.concat(warnings);
            advancedCompatibilityContents.hostMap[hostId].infos =
                  advancedCompatibilityContents.hostMap[hostId].infos.concat(infos);

            return advancedCompatibilityContents;
         }

         function getAffectedObjects(advancedCompatibilityContents) {
            var hostIds = Object.keys(advancedCompatibilityContents.hostMap);
            hostIds = _.filter(hostIds, function(hostId) {
               return hostId !== compatibilityResultsPresenter.NO_HOST_ID;
            });

            var vmIds = [];
            if (advancedCompatibilityContents.vmId !== compatibilityResultsPresenter.NO_VM_ID) {
               vmIds.push(advancedCompatibilityContents.vmId);
            }

            return {
               hostIds: hostIds,
               vmIds: vmIds
            };
         }

         function prettifyAndAppendAdvancedContents(basicCompatibilityResults,
               advancedCompatibilityContents) {
            if (!basicCompatibilityResults || !advancedCompatibilityContents) {
               return basicCompatibilityResults;
            }

            advancedCompatibilityContents.vmProps.name =
                  virtualMachineSpecBuilder.getName();

            var affectedObjects = getAffectedObjects(advancedCompatibilityContents);
            if (_.isEmpty(affectedObjects.vmIds) &&_.isEmpty(affectedObjects.hostIds)){
               basicCompatibilityResults[0].advancedCompatibilityContents =
                     advancedCompatibilityContents;
               return basicCompatibilityResults;
            }

            return dataService.getPropertiesForObjects(affectedObjects.hostIds,
                  ["primaryIconId", "name"]).then(function(props) {
               _.each(props, function(singleHostProps, hostId) {
                  advancedCompatibilityContents.hostMap[hostId].props.name =
                        singleHostProps.name;
                  advancedCompatibilityContents.hostMap[hostId].props.icon =
                        singleHostProps.primaryIconId;
               });


               basicCompatibilityResults[0].advancedCompatibilityContents =
                     advancedCompatibilityContents;
               return basicCompatibilityResults;
            });
         }

         function parseMessagesToAdvanced(response) {
            var advancedCompatibilityContents = appendToAdvancedContents();

            if (response.error) {
               var hostId = compatibilityResultsPresenter.NO_HOST_ID;
               if (response.entity &&
                     response.entity.type === managedEntityConstants.HOST) {
                  hostId = defaultUriSchemeUtil.getVsphereObjectId(response.entity);
               }
               appendToAdvancedContents([response.error.localizedMessage],
                     [],[],
                     advancedCompatibilityContents,
                     hostId);
               return advancedCompatibilityContents;
            }

            if (!response.result) {
               return advancedCompatibilityContents;
            }

            _.each(response.result, function(singleResult) {
               var errors = [];
               var warnings = [];
               var infos = [];
               var hostId = compatibilityResultsPresenter.NO_HOST_ID;
               _.each(singleResult.messages, function(message) {
                  if (message.type === "error") {
                     errors.push(message.message);
                  } else if(message.type === "warning") {
                     warnings.push(message.message);
                  } else {
                     infos.push(message.message);
                  }
               });

               if (singleResult.host && singleResult.host.type ===
                     managedEntityConstants.HOST) {
                  hostId = defaultUriSchemeUtil.getVsphereObjectId(singleResult.host);
               }
               appendToAdvancedContents(errors,
                     warnings, infos,
                     advancedCompatibilityContents, hostId);
            });

            return advancedCompatibilityContents;
         }

         function isValidationRelevant(validationId) {
            return validationId === _lastValidationId;
         }

         function selectionIsNew() {
            return virtualMachineSpecBuilder.getComputeResourceId() !== form.selectedComputeResourceId;
         }

         function ifThereAreHostsAtLeastOneHasNoErrors(response) {
            if (_.isEmpty(response.hostSpecificMessagesByHostName)) {
               return true;
            }

            if (response.hostsWithNoMessagesCount > 0) {
               return true;
            }

            return _.any(response.hostSpecificMessagesByHostName, function (messages) {
               return _.all(messages, function (message) {
                  return message.type !== 'error';
               });
            });
         }

         function resultIsValid(result) {
            if (!result) {
               return true;
            }

            var noTopLevelErrors = _.all(result.topLevelMessages, function (message) {
               return message.type !== 'error';
            });

            return noTopLevelErrors && ifThereAreHostsAtLeastOneHasNoErrors(result);
         }

         function parseMessages(response) {
            if (!response || response.length === 0) {
               return null;
            }

            var allHostMessages = _.filter(response, function(result){
               return result.hostName;
            });

            var messagesToDisplay = _.filter(response, function (result) {
               return result.messages && result.messages.length > 0;
            });

            if (messagesToDisplay.length < 1) {
               return null;
            }

            // partitionedResults[0] is for host-specific messages and
            // partitionedResults[1] is for all other messages
            var partitionedResults = _.partition(messagesToDisplay, function (result) {
               return result.hostName;
            });

            var hostSpecificMessagesByHostName = _.chain(partitionedResults[0])
                  .groupBy('hostName')
                  .mapObject(function (results) {
                     return _.flatten(_.pluck(results, 'messages'));
                  }).value();

            var topLevelMessages = _.flatten(_.pluck(partitionedResults[1], 'messages'));

            return {
               topLevelMessages: topLevelMessages,
               hostSpecificMessagesByHostName: hostSpecificMessagesByHostName,
               hostsWithNoMessagesCount: allHostMessages.length - partitionedResults[0].length
            };
         }

         function formatAndCombineMessages(parsedMessages){
            if (parsedMessages){
               var formattedHostMessages = _.map(parsedMessages.hostSpecificMessagesByHostName, function(messages, hostName){
                  return {
                     icon: 'vsphere-icon-host',
                     message: hostName,
                     contents: _.map(messages, formatCompatibilityMessage)
                  };
               });
               var formattedTopLevelMessages = _.map(parsedMessages.topLevelMessages, formatCompatibilityMessage);

               return formattedTopLevelMessages.concat(formattedHostMessages);
            } else {
               return createCompatibilityCheckSucceededMessage();
            }
         }

         function createCompatibilityCheckSucceededMessage() {
            return [
               {
                  icon: 'vsphere-icon-status-ok',
                  message: i18nService.getString('VmUi',
                        'ProvisioningWizard.CompatibilityChecksSucceeded'),
                  contents: []
               }
            ];
         }

         function formatCompatibilityMessage(message) {
            return {
               icon: message.type === 'error' ?
                     'vsphere-icon-status-error' : 'vsphere-icon-status-warning',
               message: message.message,
               contents: []
            };
         }

         function getFilterNetworksObjectId(selectedCrId) {
            // if the selected compute resource is Cluster -> return this cluster
            // otherwise get the ComputeResource instance of the selected host, res pool
            // or vApp, and if it is a ClusterComputeResource, return that cluster,
            // otherwise - return the first host of the parent ComputeResource object
            var selectedCR =
                  defaultUriSchemeUtil.getPartsFromVsphereObjectId(selectedCrId);
            if(selectedCR.type === managedEntityConstants.CLUSTER) {
               return $q.resolve(selectedCrId);
            }

            var relationName;
            switch(selectedCR.type) {
               case managedEntityConstants.HOST:
                  relationName = 'host';
                  break;
               case managedEntityConstants.RESOURCE_POOL:
               case managedEntityConstants.V_APP:
                  relationName = 'rp';
                  break;
               default: break;
            }

            var parentCrPromise = dataService.getPropertiesByRelation(selectedCrId,
                  relationName, managedEntityConstants.ANY_COMPUTE_RESOURCE, ['host', '@type']);
            return parentCrPromise.then(function(res) {
               if(!res || _.values(res).length === 0) {
                  return null;
               }
               var crType = _.values(res)[0]['@type'];
               if(crType === managedEntityConstants.CLUSTER) {
                  var clusterId;
                  _.each(res, function(value, object) {
                     clusterId = object;
                  });
                  return clusterId;
               }

               var host = _.values(res)[0].host[0];
               var hostId = defaultUriSchemeUtil.getVsphereObjectId(host);
               return hostId;
            });
         }

         function buildErrorMessageObject(messages) {
            return _.map(messages, function(message) {
               return {
                  icon: 'vsphere-icon-status-error',
                  message: message,
                  contents: []
               };
            });
         }

         function resourcePoolPrivilegeValidation(resourcePoolId) {
            var reqPrivileges = ['VApp.Import'];
            return authorizationService.checkPrivileges(resourcePoolId, reqPrivileges)
               .then(function(result) {
                  return result;
               });
         }

         function disabledMethodValidation(resourcePoolId) {
            return dataService.getProperties(resourcePoolId, ['disabledMethod'])
               .then(function(result) {
                  return (_.indexOf(result, 'ImportVApp') === -1);
               });
         }

         function readLocalizedBackendErrors (response) {
            if(response && response.error && !_.isEmpty(response.error.localizedMessage)){
               return response.error.localizedMessage;
            }
         }

         function checkHasDeviceFaults(compatCheckResult) {
            if (!compatCheckResult || compatCheckResult.length === 0) {
               return false;
            }

            var hasFaults = _.some(compatCheckResult, function(result){
               return result.hasDeviceFaults;
            });
            return hasFaults;
         }
      };
   }
})();

angular.module('com.vmware.vsphere.client.vm').service('VmProvisioningComputeResourcePageService', [
   'i18nService',
   'VmProvisioningComputeResourcePageModel',
   'vmVuiWizardPageBuilder',
   function (i18nService, VmProvisioningComputeResourcePageModel, vmVuiWizardPageBuilder) {
      return {
         build: function (wizardScope, preselectedComputeResource) {
            var computeResourcePageModel = new VmProvisioningComputeResourcePageModel(
               wizardScope.vmParams,
               preselectedComputeResource,
               wizardScope.wizardViewData,
               wizardScope.config,
               wizardScope.scheduleTaskData
            );
            wizardScope.computeResourcePageModel = computeResourcePageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningComputeResource.html',
               model: computeResourcePageModel
            });
         }
      };
   }
]);


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('VmProvisioningCustomizeHardwarePageModel', [
      'i18nService',
      'deviceTypeConstants',
      function(
         i18nService,
         deviceTypeConstants
      ) {
         return function(virtualMachineSpecBuilder, wizardViewData) {
            var form = {};
            var computeResourceId;
            return {
               getStackBlocksExpandedState: function() {
                  // if the customize hardware page is visited for the first time, or the
                  // compute resource has been changed, collapse all stack blocks
                  // by overwriting their current state with the default one
                  if (computeResourceId !== virtualMachineSpecBuilder.getComputeResourceId()) {
                     computeResourceId = virtualMachineSpecBuilder.getComputeResourceId();
                     // note mibryamov: default behavior - all the stack blocks are collapsed by
                     // default. If in the future we want to customize the default expanded
                     // state of the stack blocks on this page, we will pass this settings as part
                     // of virtualMachineSpecBuilder or as a separate parameter to this model
                     // when we instantiate it in given vm provisioning service. For now the setting
                     // created here in this model will apply for all the workflows - by default
                     // the stack blocks are collapsed
                     form.stackBlocksExpandedState = {
                        cpu: false,
                        memory: false,
                        virtualDevices: [],
                        other: false,
                        // here list all the other stack blocks' state properties
                        // vm options stack block state properties
                        generalOptions: false,
                        vmrcOptions: false,
                        standbyOptions: false,
                        vmwareToolsOptions: false,
                        bootOptions: false,
                        vmAdvancedOptions: false,
                        vmHwNpiv: false,
                        encryptionOptions: false
                     };
                  }
                  return form.stackBlocksExpandedState;
               },
               validatePage: function() {
                  if (!form.isHardwareValid) {
                     return {
                        error: i18nService.getString('VmUi', 'CustomizeHardwareProvisioningPage.PageValidationError')
                     };
                  }

                  if (!!wizardViewData.getNICsToCustomize()) {
                     const networkAdapters = virtualMachineSpecBuilder
                        .getVirtualMachineDevices()
                        .devicesNotMarkedForRemovalOfType(deviceTypeConstants.ETHERNET);
                     if (networkAdapters.length < wizardViewData.getNICsToCustomize().length) {
                        return {
                           error: i18nService.getString('VmUi',
                              'CustomizeHardwareProvisioningPage.PageValidationError.vmNicsLessThanGosSpecNics',
                              wizardViewData.getCustomizationSpecName())
                        };
                     }
                  }

                  return {};
               },
               submitPage: function() {
                  return {
                     wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                     invalidateNextPages: false
                  };
               },

               setFormValidity: function(isValid) {
                  form.isHardwareValid = isValid;
               }
            };
         };
      }]
   );
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningCustomizeHardwarePageService', [
      'i18nService',
      'wizardPageService',
      'vmVuiWizardPageBuilder',
      'VmProvisioningCustomizeHardwarePageModel',
      function(
         i18nService,
         wizardPageService,
         vmVuiWizardPageBuilder,
         VmProvisioningCustomizeHardwarePageModel
      ) {
         return {
            build: function(wizardScope) {
               var virtualMachineSpecBuilder = wizardScope.vmParams;
               var customizeHardwarePageModel =
                  new VmProvisioningCustomizeHardwarePageModel(virtualMachineSpecBuilder, wizardScope.wizardViewData);
               wizardScope.customizeHardwarePageModel = customizeHardwarePageModel;

               return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                  title: i18nService.getString('VmUi', 'CustomizeHardwareProvisioningPage.Title'),
                  description: i18nService.getString('VmUi', 'CustomizeHardwareProvisioningPage.Description'),
                  contentUrl: 'vm-ui/resources/vm/views/settings/vmHardwareEdit.html',
                  model: customizeHardwarePageModel
               });
            }
         };
      }
   ]);
})();

var h5_vm;
(function (h5_vm) {
    var USERDEFINED_PROPERTY_PARAM = "com.vmware.vcenter.ovf.PropertyParams";
    var IPALLOCATION_PROPERTY_PARAM = "com.vmware.vcenter.ovf.IpAllocationParams";
    var VmProvisioningCustomizeTemplatePageModelFactory = (function () {
        function VmProvisioningCustomizeTemplatePageModelFactory($q, i18nService) {
            return function (virtualMachineSpecBuilder, wizardViewData) {
                return new VmProvisioningCustomizeTemplatePageModel($q, i18nService, virtualMachineSpecBuilder, wizardViewData);
            };
        }
        VmProvisioningCustomizeTemplatePageModelFactory.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningCustomizeTemplatePageModelFactory;
    }());
    var VmProvisioningCustomizeTemplatePageModel = (function () {
        function VmProvisioningCustomizeTemplatePageModel($q, i18nService, virtualMachineSpecBuilderObj, wizardViewDataObj) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.virtualMachineSpecBuilderObj = virtualMachineSpecBuilderObj;
            this.wizardViewDataObj = wizardViewDataObj;
            this.formObj = {
                customizeTemplateParams: undefined,
                ipAllocationPolicyParams: undefined,
                valid: false
            };
        }
        Object.defineProperty(VmProvisioningCustomizeTemplatePageModel.prototype, "form", {
            get: function () {
                return this.formObj;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningCustomizeTemplatePageModel.prototype, "customizeTemplateParams", {
            get: function () {
                this.formObj.customizeTemplateParams = this.retrieveUserDefinedPropertyParams();
                return this.formObj.customizeTemplateParams;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningCustomizeTemplatePageModel.prototype, "ipAllocationPolicyParams", {
            get: function () {
                this.formObj.ipAllocationPolicyParams = this.retrieveIpAllocationPolicyParams();
                return this.formObj.ipAllocationPolicyParams;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningCustomizeTemplatePageModel.prototype.validatePage = function () {
            if (this.formObj.valid) {
                return {};
            }
            return {
                error: this.i18nService.getString("ProvisioningUiLib", "UserDefinedPropertiesPage.errorMessage2")
            };
        };
        VmProvisioningCustomizeTemplatePageModel.prototype.submitPage = function () {
            this.wizardViewDataObj.setCustomizeTemplateCommonContext(this.formObj.customizeTemplateParams);
            return {
                wizardFlow: this.virtualMachineSpecBuilderObj.getCreationType(),
                invalidateNextPages: false
            };
        };
        VmProvisioningCustomizeTemplatePageModel.prototype.retrieveUserDefinedPropertyParams = function () {
            return _.find(this.wizardViewDataObj.getDeployFromLibraryCommonContext(), function (item) {
                return (_.isEqual(item._type, USERDEFINED_PROPERTY_PARAM));
            });
        };
        VmProvisioningCustomizeTemplatePageModel.prototype.retrieveIpAllocationPolicyParams = function () {
            return _.find(this.wizardViewDataObj.getDeployFromLibraryCommonContext(), function (item) {
                return (_.isEqual(item._type, IPALLOCATION_PROPERTY_PARAM));
            });
        };
        VmProvisioningCustomizeTemplatePageModel.prototype.resetForm = function () {
            this.formObj.customizeTemplateParams = undefined;
            this.formObj.valid = false;
        };
        VmProvisioningCustomizeTemplatePageModel.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningCustomizeTemplatePageModel;
    }());
    h5_vm.VmProvisioningCustomizeTemplatePageModel = VmProvisioningCustomizeTemplatePageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningCustomizeTemplatePageModel", VmProvisioningCustomizeTemplatePageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningCustomizeTemplatePageService = (function () {
        function VmProvisioningCustomizeTemplatePageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, vmProvisioningCustomizeTemplatePageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningCustomizeTemplatePageModel = vmProvisioningCustomizeTemplatePageModel;
        }
        VmProvisioningCustomizeTemplatePageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningCustomizeTemplatePageModel(wizardScope.vmParams, wizardScope.wizardViewData);
            wizardScope.vmProvisioningCustomizeTemplatePageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("Common", "UserDefinedPropertiesPage.title"),
                description: this.i18nService.getString("Common", "UserDefinedPropertiesPage.description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages" +
                    "/vmProvisioningCustomizeTemplate/vm-provisioning-customize-template.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED
            });
        };
        VmProvisioningCustomizeTemplatePageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "vmProvisioningCustomizeTemplatePageModel"
        ];
        return VmProvisioningCustomizeTemplatePageService;
    }());
    h5_vm.VmProvisioningCustomizeTemplatePageService = VmProvisioningCustomizeTemplatePageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningCustomizeTemplatePageService", VmProvisioningCustomizeTemplatePageService);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var RelocateSpec$DiskLocator = com.vmware.vim.binding.vim.vm.RelocateSpec$DiskLocator;
    var ManagedObjectReference = com.vmware.vim.binding.vmodl.ManagedObjectReference;
    var VmProvisioningDatastorePageModelFactory = (function () {
        function VmProvisioningDatastorePageModelFactory(defaultUriSchemeUtil, dataService, i18nService, $q, creationTypeConstants, storageResourceSelectionValidationService, storageLocatorService, storageProfileService, managedEntityConstants, contentLibraryService, wizardPageService, VirtualMachineDevices, diskFormatService, storageValidationService, diskProvisioningService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService) {
            return function (virtualMachineSpecBuilder, wizardViewData, preselectedStorage, wizardConfig) {
                return new VmProvisioningDatastorePageModel(defaultUriSchemeUtil, dataService, i18nService, $q, creationTypeConstants, storageResourceSelectionValidationService, storageLocatorService, storageProfileService, managedEntityConstants, contentLibraryService, wizardPageService, VirtualMachineDevices, diskFormatService, storageValidationService, diskProvisioningService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService, virtualMachineSpecBuilder, wizardViewData, preselectedStorage, wizardConfig);
            };
        }
        VmProvisioningDatastorePageModelFactory.$inject = [
            "defaultUriSchemeUtil",
            "dataService",
            "i18nService",
            "$q",
            "creationTypeConstants",
            "storageResourceSelectionValidationService",
            "storageLocatorService",
            "storageProfileService",
            "managedEntityConstants",
            "contentLibraryService",
            "wizardPageService",
            "VirtualMachineDevices",
            "diskFormatService",
            "vmProvisioningStorageSelectionValidationService",
            "diskProvisioningService",
            "spbmReplicationGroupInfoService",
            "pmemUtilService",
            "virtualDiskPmemService"
        ];
        return VmProvisioningDatastorePageModelFactory;
    }());
    h5_vm.VmProvisioningDatastorePageModelFactory = VmProvisioningDatastorePageModelFactory;
    var VmProvisioningDatastorePageModel = (function () {
        function VmProvisioningDatastorePageModel(defaultUriSchemeUtil, dataService, i18nService, $q, creationTypeConstants, storageResourceSelectionValidationService, storageLocatorService, storageProfileService, managedEntityConstants, contentLibraryService, wizardPageService, VirtualMachineDevices, diskFormatService, storageValidationService, diskProvisioningService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService, virtualMachineSpecBuilder, wizardViewData, preselectedStorage, wizardConfig) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.$q = $q;
            this.creationTypeConstants = creationTypeConstants;
            this.storageResourceSelectionValidationService = storageResourceSelectionValidationService;
            this.storageLocatorService = storageLocatorService;
            this.storageProfileService = storageProfileService;
            this.managedEntityConstants = managedEntityConstants;
            this.contentLibraryService = contentLibraryService;
            this.wizardPageService = wizardPageService;
            this.VirtualMachineDevices = VirtualMachineDevices;
            this.diskFormatService = diskFormatService;
            this.storageValidationService = storageValidationService;
            this.diskProvisioningService = diskProvisioningService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
            this.pmemUtilService = pmemUtilService;
            this.virtualDiskPmemService = virtualDiskPmemService;
            this._selectionIsValid = false;
            this._pendingValidationRequests = 0;
            this._DATASTORE_MAPPING_PARAMS_TYPE = "com.vmware.vcenter.ovf.DatastoreMappingParams";
            this.DEFAULT_STORAGE_ID = "defaultId";
            this.USE_SPECIFIED_STORAGE_POLICY = "USE_SPECIFIED_POLICY";
            this.form = {
                drsDisabled: false,
                storageLocatorItemsData: {},
                vmDisksData: {},
                vmsHomeDatastore: {},
                diskFormatSettings: {
                    diskFormatSupported: false,
                    selectedDiskFormat: null
                },
                selectedStorage: null,
                storageProfilesData: {
                    storageProfiles: [],
                    selectedProfile: null,
                    selectedProfileForDisks: null,
                },
                selectedReplicationGroupInfo: null,
                storageProfileHasBeenSelected: false,
                isAdvancedStorageMode: false,
                storageSelectorState: null,
                vmDisksStorage: null,
                basicModeLastSelectionIsValid: false,
                basicModeLastSelectedStorageId: undefined,
                basicModeLastSelectedProfileId: undefined,
                basicModeLastVmValidationConfig: undefined,
                basicModeCompatibilityResultsCache: undefined,
                advModeLastSelectionIsValid: false,
                advModeLastFolderId: undefined,
                advModeLastValidationModel: undefined,
                advModeCompatibilityResultsCache: undefined,
                // NOTE speev: Eventually, this shall replace most of the fields above.
                // Array<common_ui.VmStorageConfig>, one item per VM
                _vmStorageConfig: undefined,
                set vmStorageConfig(value) {
                    this._vmStorageConfig = value;
                    var config = this._vmStorageConfig[0];
                    this.storageProfilesData.selectedProfile = config.vmHome.storageProfile;
                    this.storageProfilesData.selectedProfileForDisks = _.isEmpty(config.vmDisks) ? null : config.vmDisks[0].storageProfile;
                    this.selectedStorage = config.vmHome.storageObj;
                    this.selectedReplicationGroupInfo = config.vmHome.replicationGroup;
                },
                get vmStorageConfig() {
                    // NOTE speev: JSLint require to have a getter. But so far we don't have
                    // a use case for it - so throw error do discourage usage.
                    throw Error("You should not access vmStorageConfig directly");
                }
            };
            this._virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this._wizardViewData = wizardViewData;
            this._preselectedStorage = preselectedStorage;
            this._wizardConfig = wizardConfig;
        }
        Object.defineProperty(VmProvisioningDatastorePageModel.prototype, "virtualMachineSpecBuilder", {
            get: function () {
                return this._virtualMachineSpecBuilder;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningDatastorePageModel.prototype.podDisplayDisabled = function () {
            if (this.isCloningVmtxTemplate() || this.isDeployVmFromVmtxTemplate()) {
                return true;
            }
            return this._virtualMachineSpecBuilder.isXvc();
        };
        VmProvisioningDatastorePageModel.prototype.setSelectionIsValid = function (isValid) {
            this._selectionIsValid = isValid;
        };
        VmProvisioningDatastorePageModel.prototype.getStorageLocatorData = function (contextObjectId) {
            var _this = this;
            return this.storageLocatorService.getProvisioningStorageLocatorData(contextObjectId)
                .then(function (storageLocatorItemsData) {
                if (!storageLocatorItemsData) {
                    return false;
                }
                // Populate a storageId to storageName map, used by components
                // shared among the pages of the VmProvisioning wizards
                var storageIdToName = _this.createStorageIdToNameMap(storageLocatorItemsData.datastoreItems, storageLocatorItemsData.storagePodItems);
                _this._wizardViewData.setStorageNameMap(storageIdToName);
                function nameComparator(a, b) {
                    return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1;
                }
                storageLocatorItemsData.datastoreItems.sort(nameComparator);
                storageLocatorItemsData.storagePodItems.sort(nameComparator);
                _this._wizardViewData.setStorageLocatorItemsData(storageLocatorItemsData);
                _this.form.storageLocatorItemsData = storageLocatorItemsData;
                return true;
            });
        };
        VmProvisioningDatastorePageModel.prototype.getStorageSelectorData = function (vmId) {
            var _this = this;
            return this._virtualMachineSpecBuilder.getAdvancedStoragePageData()
                .then(function (response) {
                var result = {};
                if (response.advancedStoragePageData) {
                    var advancedStoragePageData = response.advancedStoragePageData;
                    result = {
                        vmReplicationGroupAssignments: advancedStoragePageData.vmReplicationGroupAssignments,
                        storagePoliciesAssignments: advancedStoragePageData.storagePoliciesAssignments
                    };
                    _this.setVmDisks(vmId, advancedStoragePageData.virtualDisks);
                    _this.setVmHomeDatastore(vmId, advancedStoragePageData.vmHomeDatastore);
                }
                result["virtualDisks"] = _this.form.vmDisksData;
                result["vmHomeDatastore"] = _this.form.vmsHomeDatastore;
                return result;
            });
        };
        VmProvisioningDatastorePageModel.prototype.getVmIds = function () {
            return [this._virtualMachineSpecBuilder.getVmId()];
        };
        VmProvisioningDatastorePageModel.prototype.getVmNames = function () {
            var result = {};
            result[this._virtualMachineSpecBuilder.getVmId()] =
                this._wizardViewData.getSourceObjectName();
            return result;
        };
        VmProvisioningDatastorePageModel.prototype.getProfilesData = function (serverGuid) {
            var _this = this;
            if (this._profilesDataPromise && this._profilesDataPromise.cacheId === serverGuid) {
                return this._profilesDataPromise.promise;
            }
            var options = {};
            if (this._virtualMachineSpecBuilder.getVmId()) {
                options = {
                    vmId: this._virtualMachineSpecBuilder.getVmId()
                };
            }
            if (this.isInCloningMode() && !this._virtualMachineSpecBuilder.isXvc()) {
                options.includeKeepExisting = true;
            }
            this._profilesDataPromise = {
                promise: this.virtualMachineSpecBuilder
                    .getStoragePageData().
                    then(function (result) {
                    if (!result.vmStoragePageData) {
                        return _this.storageProfileService.buildErrorStorageProfilesData(_this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.profilesDataError"));
                    }
                    if (result.vmStoragePageData.profileError) {
                        return _this.storageProfileService
                            .buildErrorStorageProfilesData(result.vmStoragePageData.profileError);
                    }
                    if (result.vmStoragePageData.hasProfileViewPrivilege === false) {
                        return _this.storageProfileService.buildErrorStorageProfilesData(_this.i18nService.getString("Common", "storage.policy.dropdown.no.permissions"));
                    }
                    return _this.storageProfileService.buildStorageProfilesData(result.vmStoragePageData.profileStoragePageData, options);
                })
                    .then(function (profilesData) {
                    var preselectProfile = null;
                    if (_this.form.storageProfilesData && _this.form.storageProfilesData.selectedProfile) {
                        preselectProfile = _this.form.storageProfilesData.selectedProfile;
                    }
                    _this.form.storageProfilesData = profilesData;
                    if (preselectProfile) {
                        _this.form.storageProfilesData.selectedProfile = preselectProfile;
                    }
                    return profilesData;
                }).catch(function () {
                }),
                cacheId: serverGuid
            };
            return this._profilesDataPromise.promise;
        };
        VmProvisioningDatastorePageModel.prototype.setVmDisks = function (sourceId, vmDisks) {
            this.form.vmDisksData = this.form.vmDisksData || {};
            this.form.vmDisksData[sourceId] = vmDisks;
        };
        VmProvisioningDatastorePageModel.prototype.setVmHomeDatastore = function (sourceId, datastore) {
            this.form.vmsHomeDatastore = this.form.vmsHomeDatastore || {};
            this.form.vmsHomeDatastore[sourceId] = datastore ?
                this.defaultUriSchemeUtil.getVsphereObjectId(datastore) : null;
        };
        VmProvisioningDatastorePageModel.prototype.validateSelection = function (selectedStorage, selectedProfileId, diskFormat, replicationGroupValidationError, sourceVmStorageConfig) {
            var _this = this;
            if (this.isInDeployTemplateMode()) {
                if (this.canDeployOvfViaDrs(selectedStorage, selectedProfileId)) {
                    this._selectionIsValid = true;
                    return this.$q.resolve([this.newSuccessfulStorageCheck()]);
                }
            }
            var storageId = selectedStorage
                ? this.defaultUriSchemeUtil.getVsphereObjectId(selectedStorage.storageRef)
                : undefined;
            if (!storageId || replicationGroupValidationError) {
                this._selectionIsValid = false;
                var errorMessage = (!storageId)
                    ? this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpecifyValidLocation")
                    : replicationGroupValidationError;
                return this.$q.resolve([{
                        contents: [],
                        icon: "vsphere-icon-status-error",
                        message: errorMessage,
                        advancedCompatibilityContents: {}
                    }]);
            }
            this.form.selectedStorage = selectedStorage;
            var virtualDisksByVm = this.getVirtualDisksByVmSelections([sourceVmStorageConfig]);
            var vmValdiationConfig = this.getVmStorageValidationConfig();
            if (diskFormat && diskFormat.selectedDiskFormat &&
                this.form.vmDisksData && this.form.vmDisksData[vmValdiationConfig.vmId]) {
                var originalDisks = this.form.vmDisksData[vmValdiationConfig.vmId];
                var filteredDisks = this.virtualDiskPmemService.filterVirtualDisksToDiskLocatorsForPmem(originalDisks, this.form.storageSelectorState.storageBaselineId);
                vmValdiationConfig.disks = this.buildDiskLocators(filteredDisks, virtualDisksByVm, vmValdiationConfig.vmStorageConf.vmHome.storageObj.storageRef, diskFormat, selectedProfileId, this.form.selectedReplicationGroupInfo);
            }
            if (this.form.basicModeLastSelectedStorageId === storageId
                && this.form.basicModeLastSelectedProfileId === selectedProfileId
                && angular.equals(this.form.basicModeLastVmValidationConfig, vmValdiationConfig)
                && this.form.basicModeCompatibilityResultsCache) {
                this._selectionIsValid = this.form.basicModeLastSelectionIsValid;
                return this.$q.resolve(this.form.basicModeCompatibilityResultsCache);
            }
            this._pendingValidationRequests++;
            return this.storageResourceSelectionValidationService.validateSelection(selectedStorage, selectedProfileId, vmValdiationConfig, this.isInDeployTemplateMode()).then(function (result) {
                _this._selectionIsValid = result.isValid;
                if (_this._selectionIsValid) {
                    _this._virtualMachineSpecBuilder.setVmDisksStorage(virtualDisksByVm);
                }
                _this._pendingValidationRequests--;
                _this.form.basicModeLastSelectionIsValid = _this._selectionIsValid;
                _this.form.basicModeLastSelectedStorageId = storageId;
                _this.form.basicModeLastSelectedProfileId = selectedProfileId;
                _this.form.basicModeLastVmValidationConfig = vmValdiationConfig;
                _this.form.basicModeCompatibilityResultsCache = result.messages;
                return _this.form.basicModeCompatibilityResultsCache;
            });
        };
        VmProvisioningDatastorePageModel.prototype.validateAdvancedSelection = function (selectedStorage, sourceVmStorageConfig) {
            var _this = this;
            if (!this.isAdvModeDiskSelectionCompleted()) {
                this._selectionIsValid = false;
                this.form.vmDisksStorage = {};
                return this.$q.resolve([{
                        contents: [],
                        icon: "vsphere-icon-status-error",
                        message: this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpecifyValidLocation"),
                        advancedCompatibilityContents: {}
                    }]);
            }
            this.form.selectedStorage = selectedStorage;
            var targetVmStorageConfig = this.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
            if (!this.storageValidationService.validateDisksSdrsMap(targetVmStorageConfig)) {
                this._selectionIsValid = false;
                this.form.vmDisksStorage = {};
                return this.$q.resolve([{
                        contents: [],
                        icon: "vsphere-icon-status-error",
                        message: this.i18nService.getString("VmUi", "sdrsInconsistentSelectionErrorMsg"),
                        advancedCompatibilityContents: {}
                    }]);
            }
            var rgValidationError = this.spbmReplicationGroupInfoService.validateVmReplicationGroupAssignments(targetVmStorageConfig.getReplicationGroupAssignments());
            if (rgValidationError) {
                this._selectionIsValid = false;
                this.form.vmDisksStorage = {};
                return this.$q.resolve([{
                        contents: [],
                        icon: "vsphere-icon-status-error",
                        message: rgValidationError,
                        advancedCompatibilityContents: {}
                    }]);
            }
            var vmId = this.virtualMachineSpecBuilder.getVmId();
            var poolId = this.virtualMachineSpecBuilder.getResourcePool() &&
                this.virtualMachineSpecBuilder.getResourcePool().id;
            var folderId = this.virtualMachineSpecBuilder.getTargetInformation() &&
                this.virtualMachineSpecBuilder.getTargetInformation().folderUid;
            var crId = this.virtualMachineSpecBuilder.getComputeResourceId();
            var virtualDisksByVm = this.getVirtualDisksByVmSelections([sourceVmStorageConfig]);
            var validationModel = { "vms": [vmId] };
            validationModel.virtualDisksByVm = virtualDisksByVm;
            validationModel.computeResource = crId;
            validationModel.pool = poolId;
            if (this.form.advModeLastFolderId === folderId
                && angular.equals(this.form.advModeLastValidationModel, validationModel)) {
                this._selectionIsValid = this.form.advModeLastSelectionIsValid;
                return this.$q.resolve(this.form.advModeCompatibilityResultsCache);
            }
            var vmCloneSpec = this.storageValidationService.buildVmCloneSpec(this.defaultUriSchemeUtil.getManagedObjectReference(folderId), this.virtualMachineSpecBuilder.getName(), this.defaultUriSchemeUtil.getManagedObjectReference(vmId), this.defaultUriSchemeUtil.getManagedObjectReference(poolId), this.defaultUriSchemeUtil.getManagedObjectReference(crId), sourceVmStorageConfig);
            var vmDisksConfig = this.form.vmDisksData[vmId];
            return this.storageValidationService.validateSelection(validationModel, vmCloneSpec, vmId, folderId, sourceVmStorageConfig, vmDisksConfig, (this.isCloningVmtxTemplate() || this.isDeployVmFromVmtxTemplate())).then(function (result) {
                _this._selectionIsValid = result.hasSuccess;
                _this.form.vmDisksStorage = _this._selectionIsValid ? virtualDisksByVm : {};
                _this.form.advModeLastSelectionIsValid = _this._selectionIsValid;
                _this.form.advModeLastFolderId = folderId;
                _this.form.advModeLastValidationModel = validationModel;
                _this.form.advModeCompatibilityResultsCache = result.compatibilityMessages;
                return _this.form.advModeCompatibilityResultsCache;
            });
        };
        VmProvisioningDatastorePageModel.prototype.getVirtualDisksByVmSelections = function (storageConfigPerVm) {
            var _this = this;
            var virtualDisksByVm = {};
            _.each(storageConfigPerVm, function (vmStorageConfig) {
                var vmId = vmStorageConfig.vmId;
                if (!virtualDisksByVm[vmId]) {
                    virtualDisksByVm[vmId] = [];
                }
                var homeStorageConfig = vmStorageConfig.vmHome;
                if (!homeStorageConfig.storageObj) {
                    // The selection is not here yet?
                    return;
                }
                // Push one record for the vm config file
                virtualDisksByVm[vmId].push({
                    key: "_configFile",
                    label: homeStorageConfig.name,
                    storage: _this.defaultUriSchemeUtil.getVsphereObjectId(homeStorageConfig.storageObj.storageRef),
                    parentStoragePod: _this.defaultUriSchemeUtil.getVsphereObjectId(homeStorageConfig.storageObj.parentStoragePod),
                    profile: homeStorageConfig.storageProfile,
                    diskFormat: homeStorageConfig.diskFormat ? {
                        label: homeStorageConfig.diskFormat.name,
                        value: homeStorageConfig.diskFormat.type
                    } : undefined,
                    replicationGroup: homeStorageConfig.replicationGroup
                });
                // And one record for each VM disk
                _.each(vmStorageConfig.vmDisks, function (diskStorageConfig) {
                    virtualDisksByVm[vmId].push({
                        key: diskStorageConfig.key,
                        label: diskStorageConfig.name,
                        storage: diskStorageConfig.storageObj ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageConfig.storageObj.storageRef)
                            : undefined,
                        parentStoragePod: diskStorageConfig.storageObj ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageConfig.storageObj.parentStoragePod)
                            : undefined,
                        profile: diskStorageConfig.storageProfile,
                        diskFormat: diskStorageConfig.diskFormat ? {
                            label: diskStorageConfig.diskFormat.name,
                            value: diskStorageConfig.diskFormat.type
                        } : undefined,
                        replicationGroup: diskStorageConfig.replicationGroup
                    });
                });
            });
            return virtualDisksByVm;
        };
        VmProvisioningDatastorePageModel.prototype.validatePage = function () {
            this.wizardPageService.showLoadingIndicator(this._wizardConfig);
            if (!this._selectionIsValid) {
                var localizedErrorMsg = this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpecifyValidLocation");
                this.wizardPageService.hideLoadingIndicator(this._wizardConfig);
                return {
                    error: localizedErrorMsg,
                    invalidateNextPages: !this._selectionIsValid,
                    wizardFlow: this.virtualMachineSpecBuilder.getCreationType()
                };
            }
            if (!this.isInDeployFromTemplateMode()) {
                return null;
            }
            return this.validatePageInDeployFromTemplateMode();
        };
        VmProvisioningDatastorePageModel.prototype.getServerGuid = function () {
            return this.defaultUriSchemeUtil.getManagedObjectReference(this._virtualMachineSpecBuilder.getComputeResourceId()).serverGuid;
        };
        VmProvisioningDatastorePageModel.prototype.getComputeResourceId = function () {
            return this._virtualMachineSpecBuilder.getComputeResourceId();
        };
        VmProvisioningDatastorePageModel.prototype.setComputeResourceId = function (resourceId) {
            return this._virtualMachineSpecBuilder.setComputeResourceId(resourceId);
        };
        VmProvisioningDatastorePageModel.prototype.getComputeResourceOwnerId = function () {
            return this._virtualMachineSpecBuilder.getComputeResourceOwnerId();
        };
        VmProvisioningDatastorePageModel.prototype.isCloningVmtxTemplate = function () {
            return this.creationTypeConstants.isCloningVmToLibrary(this._virtualMachineSpecBuilder.getCreationType());
        };
        VmProvisioningDatastorePageModel.prototype.isDeployVmFromVmtxTemplate = function () {
            return this.creationTypeConstants.isDeployVmFromVmtxTemplate(this._virtualMachineSpecBuilder.getCreationType());
        };
        VmProvisioningDatastorePageModel.prototype.pageFinishedLoading = function () {
            return this.form.storageProfilesData.selectedProfile;
        };
        VmProvisioningDatastorePageModel.prototype.isInCloningMode = function () {
            return this.creationTypeConstants
                .isCloning(this._virtualMachineSpecBuilder.getCreationType());
        };
        VmProvisioningDatastorePageModel.prototype.isInDeployFromTemplateMode = function () {
            return this.isInDeployTemplateMode();
        };
        VmProvisioningDatastorePageModel.prototype.isInDeployVmFromOvf = function () {
            return this._virtualMachineSpecBuilder.getCreationType() ===
                this.creationTypeConstants.DEPLOY_VM_FROM_OVF;
        };
        VmProvisioningDatastorePageModel.prototype.submitPage = function () {
            if (this.isCloningVmtxTemplate()) {
                this.wizardPageService.hideLoadingIndicator(this._wizardConfig);
                return {};
            }
            if (this.isDeployVmFromVmtxTemplate()) {
                if (this.form.isAdvancedStorageMode) {
                    this._virtualMachineSpecBuilder.setVmtxStorageSpecSettings(this.getAdvancedStorageSpec());
                }
                else {
                    this._virtualMachineSpecBuilder.setVmtxStorageSpecSettings(this.getSimpleStorageSpec());
                }
            }
            var isPreviousStorageModeAdvanced = this._virtualMachineSpecBuilder.getIsAdvancedStorageMode();
            this._wizardViewData.setStorageProfiles(this.form.storageProfilesData.storageProfiles);
            if (!this.form.isAdvancedStorageMode) {
                return this.submitInBasicStorageMode(isPreviousStorageModeAdvanced);
            }
            else {
                return this.submitInAdvancedStorageMode(isPreviousStorageModeAdvanced);
            }
        };
        VmProvisioningDatastorePageModel.prototype.validationFinishedLoading = function () {
            return (this._pendingValidationRequests === 0);
        };
        VmProvisioningDatastorePageModel.prototype.isInDeployTemplateMode = function () {
            return this._virtualMachineSpecBuilder.getCreationType() ===
                this.creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ||
                this._virtualMachineSpecBuilder.getCreationType() ===
                    this.creationTypeConstants.DEPLOY_VM_FROM_VAPP ||
                this._virtualMachineSpecBuilder.getCreationType() ===
                    this.creationTypeConstants.DEPLOY_VM_FROM_OVF;
        };
        VmProvisioningDatastorePageModel.prototype.createStorageIdToNameMap = function (datastores, storagePods) {
            var _this = this;
            var storageIdToName = {};
            _.forEach(datastores, function (datastore) {
                var currentStorageUrn = _this.defaultUriSchemeUtil
                    .getVsphereObjectId(datastore.storageRef);
                storageIdToName[currentStorageUrn] = datastore.name;
            });
            _.forEach(storagePods, function (storagePod) {
                var currentStorageUrn = _this.defaultUriSchemeUtil
                    .getVsphereObjectId(storagePod.storageRef);
                storageIdToName[currentStorageUrn] = storagePod.name;
            });
            return storageIdToName;
        };
        /**
         * Searches for the item to be selected by default.
         * The preselected (context object) storage (if any) is picked-up.
         * @param datastores
         * @param storagePods
         * @returns The storage chosen for the default one.
         */
        VmProvisioningDatastorePageModel.prototype.getItemToSelect = function (datastores, storagePods) {
            var _this = this;
            // Check if the preselected storage is available for the selected compute resource
            // If the pre-selected storage is not available - don"t preselect anything.
            if (this._preselectedStorage) {
                var storageType = this.defaultUriSchemeUtil.getEntityType(this._preselectedStorage);
                var storageArray = (storageType === this.managedEntityConstants.STORAGE_POD) ?
                    storagePods : datastores;
                return _.find(storageArray, function (element) {
                    var storageId = _this.defaultUriSchemeUtil.getVsphereObjectId(element.storageRef);
                    return storageId === _this._preselectedStorage;
                });
            }
            return null;
        };
        VmProvisioningDatastorePageModel.prototype.getProfileToSelect = function () {
            return this.isInCloningMode()
                ? null /* defaults to the "Keep Existing VM storage policies */
                : this.form.storageProfilesData.selectedProfile;
        };
        VmProvisioningDatastorePageModel.prototype.updateDiskFormatIfVSAN = function () {
            var _this = this;
            if (!this.isInDeployTemplateMode()) {
                return;
            }
            var commonContext = this._wizardViewData.getDeployFromLibraryCommonContext();
            var datastoreMappingParams = _.find(commonContext, function (item) {
                return item._type === _this._DATASTORE_MAPPING_PARAMS_TYPE;
            });
            if (!datastoreMappingParams) {
                return;
            }
            // Fix the disk format for disks not part of any disk group
            var provisioningType = datastoreMappingParams.targetProvisioningType;
            if (provisioningType && (provisioningType.name ===
                this.diskFormatService.diskFormats.asDefinedInProfile.type)) {
                datastoreMappingParams.targetProvisioningType = null;
            }
            // Now fix disk format for each disk group too (if there are any)
            _.each(datastoreMappingParams.diskGroups, function (diskGroup) {
                var provisioningType = diskGroup.targetProvisioningType;
                if (provisioningType && (provisioningType.name ===
                    _this.diskFormatService.diskFormats.asDefinedInProfile.type)) {
                    diskGroup.targetProvisioningType = null;
                }
            });
        };
        VmProvisioningDatastorePageModel.prototype.validatePageInDeployFromTemplateMode = function () {
            var _this = this;
            var promise = this.contentLibraryService.validateStorageSelection(this._virtualMachineSpecBuilder.getComputeResourceId(), this.buildDiskGroups(), this._wizardViewData.getDeployFromLibraryCommonContext());
            return promise.then(function (response) {
                if (response.result && response.result.commonContext) {
                    _this._wizardViewData.setDeployFromLibraryCommonContext(response.result.commonContext);
                    return null;
                }
                _this.wizardPageService.hideLoadingIndicator(_this._wizardConfig);
                return {
                    error: response.error ?
                        response.error.localizedMessage :
                        _this.i18nService.getString("VmUi", "SelectResourcePoolProvisioningPage.fatalError"),
                    invalidateNextPages: !_this._selectionIsValid,
                    wizardFlow: _this._virtualMachineSpecBuilder.getCreationType()
                };
            });
        };
        VmProvisioningDatastorePageModel.prototype.buildDiskGroups = function () {
            var _this = this;
            var selectedDatastore = this.form.selectedStorage ?
                this.form.selectedStorage.storageRef : undefined;
            var diskGroups = _.map(this.form._vmStorageConfig[0].vmDisks, function (storageConfig /*VmComponentStorageConfig*/, index) {
                var diskGroup = {
                    id: storageConfig.key,
                    name: storageConfig.name,
                    // NOTE speev: After API trials it seems '' (empty string) is treated
                    // as no profile while undefined/null is treated as use the
                    // default profile for this group from the OVF file (if there is any)
                    // Weird... indeed, so that is why we use '' here.
                    targetProfile: _this.storageProfileService.isDefaultStorageProfile(storageConfig.storageProfile) ?
                        "" : storageConfig.storageProfile.id,
                    // PMem policy disks do not have storageObj
                    targetDatastore: storageConfig.storageObj ?
                        _this.defaultUriSchemeUtil.getVsphereObjectId(storageConfig.storageObj.storageRef) : undefined,
                    targetProvisioningType: storageConfig.diskFormat ?
                        storageConfig.diskFormat.type : undefined
                };
                // For PMEM storage profile home/system disk would be empty and must be set
                // with the selected storage and profile to be empty.
                if (!diskGroup.targetDatastore &&
                    storageConfig.key === _this.contentLibraryService.SYSTEM_DISK_GROUP_ID) {
                    diskGroup.targetDatastore =
                        _this.defaultUriSchemeUtil.getVsphereObjectId(selectedDatastore);
                    if (_this.pmemUtilService.isPMemStoragePolicy(storageConfig.storageProfile)) {
                        diskGroup.targetProfile = '';
                    }
                }
                return diskGroup;
            });
            return diskGroups;
        };
        VmProvisioningDatastorePageModel.prototype.submitInBasicStorageMode = function (isPreviousStorageModeAdvanced) {
            var _this = this;
            var vmId = this._virtualMachineSpecBuilder.getVmId();
            var previousStorage = this._virtualMachineSpecBuilder.getStorageObject();
            var previousStorageProfile = this._virtualMachineSpecBuilder.getSelectedStorageProfile();
            // if the selected datastore has been changed or the grid"s selection
            // has been removed invalidate next pages
            var invalidatePages = !this._selectionIsValid
                || isPreviousStorageModeAdvanced
                || (previousStorage
                    && previousStorage.storageRef.value !==
                        this.form.selectedStorage.storageRef.value)
                || (previousStorageProfile
                    && previousStorageProfile.id !==
                        this.form.storageProfilesData.selectedProfile.id);
            this._virtualMachineSpecBuilder.setSelectedStorageProfile(this.form.storageProfilesData.selectedProfile);
            this._virtualMachineSpecBuilder.setSelectedStorageProfileForDisks(this.form.storageProfilesData.selectedProfileForDisks);
            this._virtualMachineSpecBuilder.setSelectedReplicationGroupInfo(this.form.selectedReplicationGroupInfo);
            this._virtualMachineSpecBuilder.setIsAdvancedStorageMode(false);
            if (this.form.diskFormatSettings.diskFormatSupported) {
                var format = this.form.diskFormatSettings.selectedDiskFormat;
                this._wizardViewData.setDiskFormatLabel(format ? format.name : "");
                this._virtualMachineSpecBuilder.setStorageObjectAndDiskFormat(this.form.selectedStorage, this.form.diskFormatSettings.selectedDiskFormat);
                this.updateDiskFormatIfVSAN();
            }
            else {
                this._virtualMachineSpecBuilder.setStorageObject(this.form.selectedStorage);
            }
            this._virtualMachineSpecBuilder.setDisableSdrs(this.form.drsDisabled);
            if (!this._virtualMachineSpecBuilder.storageObjectIsPod() && this.form.selectedStorage) {
                this._wizardViewData.setDatastoreObjectName(this.form.selectedStorage.name);
            }
            this.wizardPageService.hideLoadingIndicator(this._wizardConfig);
            _.each(this.form.vmDisksData[vmId], function (disk) {
                _this._virtualMachineSpecBuilder.setStorageForDisk(_this.form.selectedStorage, disk);
            });
            if (isPreviousStorageModeAdvanced) {
                this._virtualMachineSpecBuilder.setVirtualMachineDevices(null);
                this._virtualMachineSpecBuilder.setRecreateVm(true);
            }
            return {
                invalidateNextPages: invalidatePages,
                wizardFlow: this._virtualMachineSpecBuilder.getCreationType()
            };
        };
        VmProvisioningDatastorePageModel.prototype.submitInAdvancedStorageMode = function (isPreviousStorageModeAdvanced) {
            var _this = this;
            var vmId = this._virtualMachineSpecBuilder.getVmId();
            var previousVmDisksStorage = this._virtualMachineSpecBuilder.getVmDisksStorage();
            var invalidatePages = !this._selectionIsValid
                || !isPreviousStorageModeAdvanced
                || !_.isEqual(this.form.vmDisksStorage, previousVmDisksStorage);
            this._virtualMachineSpecBuilder.setIsAdvancedStorageMode(true);
            this._virtualMachineSpecBuilder.setSelectedStorageProfile(this.form.storageProfilesData.selectedProfile);
            this._virtualMachineSpecBuilder.setSelectedStorageProfileForDisks(this.form.storageProfilesData.selectedProfileForDisks);
            this._virtualMachineSpecBuilder.setSelectedReplicationGroupInfo(this.form.selectedReplicationGroupInfo);
            // For the configuration disk
            var diskFormatSettings = this.form.diskFormatSettings;
            if (diskFormatSettings.diskFormatSupported && diskFormatSettings.selectedDiskFormat) {
                this._wizardViewData.setDiskFormatLabel(this.form.diskFormatSettings.selectedDiskFormat.name);
                this._virtualMachineSpecBuilder.setStorageObjectAndDiskFormat(this.form.selectedStorage, this.form.diskFormatSettings.selectedDiskFormat);
                this.updateDiskFormatIfVSAN();
            }
            else {
                this._virtualMachineSpecBuilder.setStorageObject(this.form.selectedStorage);
            }
            this._virtualMachineSpecBuilder.setVmDisksStorage(this.form.vmDisksStorage);
            if (!invalidatePages && this._storageSelectorStateAdvancedModeBackup) {
                var oldVmHomeProfile = this._storageSelectorStateAdvancedModeBackup
                    .vmStorageConfigInAdvancedMode[0].vmHome.storageProfile;
                var newVmHomeProfile = this._virtualMachineSpecBuilder.getStorageSelectorState()
                    .vmStorageConfigInAdvancedMode[0].vmHome.storageProfile;
                invalidatePages = oldVmHomeProfile.id !== newVmHomeProfile.id;
            }
            if (!this._virtualMachineSpecBuilder.getVirtualMachineDevices()) {
                var virtualDevices = new this.VirtualMachineDevices(this.form.vmDisksData[vmId], null /* profileAssignments */, null /* profiles */, null /* availableNetworks */, null);
                this._virtualMachineSpecBuilder.setVirtualMachineDevices(virtualDevices);
            }
            _.each(this.form.vmDisksData[vmId], function (disk, idx) {
                var vmDiskState = _this.form.storageSelectorState.vmStorageConfigInAdvancedMode[0].vmDisks[idx];
                var currentDisk = angular.copy(disk);
                if (!vmDiskState.diskFormat || vmDiskState.diskFormat.type === _this.diskProvisioningService.SAME_AS_SOURCE.type) {
                    currentDisk.backing = null;
                }
                else {
                    currentDisk.backing = _this.diskProvisioningService.getBackingInfo(vmDiskState.diskFormat.type);
                }
                _this._virtualMachineSpecBuilder.setStorageForDisk(_this.form.storageSelectorState.vmStorageConfigInAdvancedMode[0].vmDisks[idx].storageObj, currentDisk);
                if (!invalidatePages && _this._storageSelectorStateAdvancedModeBackup) {
                    var oldDiskProfile = _this._storageSelectorStateAdvancedModeBackup
                        .vmStorageConfigInAdvancedMode[0].vmDisks[idx].storageProfile;
                    var newDiskProfile = _this._virtualMachineSpecBuilder.getStorageSelectorState()
                        .vmStorageConfigInAdvancedMode[0].vmDisks[idx].storageProfile;
                    invalidatePages = oldDiskProfile.id !== newDiskProfile.id;
                }
            });
            this._storageSelectorStateAdvancedModeBackup = this.form.storageSelectorState;
            this.wizardPageService.hideLoadingIndicator(this._wizardConfig);
            return {
                invalidateNextPages: invalidatePages,
                wizardFlow: this._virtualMachineSpecBuilder.getCreationType()
            };
        };
        VmProvisioningDatastorePageModel.prototype.getVmStorageValidationConfig = function () {
            return {
                computeResourceId: this._virtualMachineSpecBuilder.getComputeResourceId(),
                targetFolderUid: this._virtualMachineSpecBuilder.getTargetInformation() &&
                    this._virtualMachineSpecBuilder.getTargetInformation().folderUid,
                creationType: this._virtualMachineSpecBuilder.getCreationType(),
                name: this._virtualMachineSpecBuilder.getName(),
                vmId: this._virtualMachineSpecBuilder.getVmId(),
                resPoolId: this._virtualMachineSpecBuilder.getResourcePool() &&
                    this._virtualMachineSpecBuilder.getResourcePool().id,
                vmDisks: this.form.vmDisksData[this._virtualMachineSpecBuilder.getVmId()],
                vmStorageConf: {
                    vmHome: {
                        storageObj: this.form.selectedStorage,
                        storageProfile: this.form.storageProfilesData.selectedProfile
                    }
                }
            };
        };
        VmProvisioningDatastorePageModel.prototype.isAdvModeDiskSelectionCompleted = function () {
            var _this = this;
            var vmStorageConfig = this.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
            return vmStorageConfig.vmHome.storageObj &&
                !_.any(vmStorageConfig.vmDisks, function (disk) {
                    return !disk.storageObj
                        && !_this.pmemUtilService.isPMemStoragePolicy(disk.storageProfile);
                });
        };
        // NOTE speev: Doesn't really do a request, but the name is analogous to the
        // advanced case where actual request is done, since it has the same purpose.
        VmProvisioningDatastorePageModel.prototype.requestVmDisksInDeployFromTemplateMode = function () {
            var _this = this;
            var datastoreMappingParams = this.getDatastoreMappingParams();
            if (!datastoreMappingParams) {
                return undefined;
            }
            // One dummy disk for each defined disk group.
            var disks = _.map(datastoreMappingParams.diskGroups, function (diskGroup) {
                return {
                    key: diskGroup.id,
                    backing: {
                        datastore: _this.getVsphereDatastoreId(diskGroup.targetDatastore)
                    },
                    deviceInfo: {
                        label: diskGroup.name
                    },
                    capacityInBytes: 0,
                    capacityInKB: 0,
                    $profileId: _.isEmpty(diskGroup.targetProfile) ?
                        undefined : diskGroup.targetProfile // custom, not in the real vdisk
                };
            });
            // And one dummy disk for all disks that are not part of any disk group.
            disks.unshift({
                key: this.contentLibraryService.SYSTEM_DISK_GROUP_ID,
                backing: {
                    datastore: this.getVsphereDatastoreId(datastoreMappingParams.targetDatastore)
                },
                deviceInfo: {
                    label: this.contentLibraryService.SYSTEM_DISK_GROUP_LABEL
                },
                capacityInBytes: 0,
                capacityInKB: 0,
                $profileId: _.isEmpty(datastoreMappingParams.targetProfile) ?
                    undefined : datastoreMappingParams.targetProfile // custom, not in the real vdisk
            });
            return {
                // The vmId is 'undefined' in this case.
                undefined: disks
            };
        };
        // NOTE speev: Doesn't really do a request, but the name is analogous to the
        // advanced case where actual request is done, since it has the same purpose.
        VmProvisioningDatastorePageModel.prototype.requestVmHomeDatastoresInDeployFromTemplateMode = function () {
            var datastoreMappingParams = this.getDatastoreMappingParams();
            if (!datastoreMappingParams) {
                return undefined;
            }
            return {
                // The vmId is 'undefined' in this case.
                undefined: this.getVsphereDatastoreId(datastoreMappingParams.targetDatastore)
            };
        };
        /*
        * Primarily used to check if workflow is deploy OVF template from file or library.
        **/
        VmProvisioningDatastorePageModel.prototype.isDiskGroupsAvailable = function () {
            return this.getDatastoreMappingParams() &&
                this.getDatastoreMappingParams().diskGroups &&
                this.getDatastoreMappingParams().diskGroups.length > 0;
        };
        VmProvisioningDatastorePageModel.prototype.getRecommendedDatastoresForTemplateDeployment = function () {
            var datastoreMappingParams = this.getDatastoreMappingParams();
            if (!datastoreMappingParams || !datastoreMappingParams.availableDatastores) {
                return this.form.storageLocatorItemsData.datastoreItems;
            }
            var availableDatastores = datastoreMappingParams.availableDatastores;
            var input = this.form.storageLocatorItemsData.datastoreItems;
            var retVal = VmProvisioningDatastorePageModel.filterDatastores(input, availableDatastores);
            return retVal;
        };
        VmProvisioningDatastorePageModel.prototype.getRecommendedProfilesForTemplateDeployment = function (profiles) {
            var datastoreMappingParams = this.getDatastoreMappingParams();
            if (!datastoreMappingParams || !datastoreMappingParams.availableStorageProfiles || !profiles) {
                return profiles;
            }
            if (datastoreMappingParams && datastoreMappingParams.availableStorageProfiles &&
                !this.isDefaultStorageProfilePresentInList(datastoreMappingParams.availableStorageProfiles)) {
                datastoreMappingParams.availableStorageProfiles
                    .splice(0, 0, this.storageProfileService.getDefaultProfile());
            }
            //Retain only the profiles present in datastore mapping params provided by content library service.
            return profiles.filter(function (currentProfile) {
                return datastoreMappingParams.availableStorageProfiles
                    .some(function (profile) {
                    return currentProfile.id === profile.id;
                });
            });
        };
        VmProvisioningDatastorePageModel.prototype.isDefaultStorageProfilePresentInList = function (profiles) {
            var _this = this;
            return profiles && (profiles.indexOf(function (profile) {
                return profile.id === _this.storageProfileService.getDefaultProfile().id;
            }) > -1);
        };
        VmProvisioningDatastorePageModel.prototype.getVsphereDatastoreId = function (contentLibaryDatastoreId) {
            if (!contentLibaryDatastoreId) {
                return undefined;
            }
            var parts = contentLibaryDatastoreId.split(":");
            if (parts.length < 2) {
                return undefined;
            }
            return this.defaultUriSchemeUtil.getVsphereObjectId({
                type: "Datastore",
                value: parts[0],
                serverGuid: parts[1]
            });
        };
        VmProvisioningDatastorePageModel.prototype.getDatastoreMappingParams = function () {
            var _this = this;
            var commonContext = this._wizardViewData.getDeployFromLibraryCommonContext();
            return _.find(commonContext, function (item) {
                return item._type === _this._DATASTORE_MAPPING_PARAMS_TYPE;
            });
        };
        VmProvisioningDatastorePageModel.prototype.getAdvancedStorageSpec = function () {
            var storageConfig = this.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
            var vmHomeSpec = this.getStorageSpecFromVmStorageComponent(storageConfig.vmHome);
            var diskStorageOverrideSpec = {};
            for (var index = 0; index < storageConfig.vmDisks.length; index++) {
                var vmDisk = storageConfig.vmDisks[index];
                diskStorageOverrideSpec[vmDisk.key] = this.getStorageSpecFromVmStorageComponent(vmDisk);
            }
            return {
                vmHomeStorage: vmHomeSpec,
                diskStorageOverrides: diskStorageOverrideSpec
            };
        };
        VmProvisioningDatastorePageModel.prototype.getSimpleStorageSpec = function () {
            var datastoreRef = this.form.selectedStorage.storageRef;
            var datastoreId = this.defaultUriSchemeUtil.createVmomiUri(datastoreRef.type, datastoreRef.value, datastoreRef.serverGuid);
            var selectedProfileForDisksId = '';
            if (this.form.storageProfilesData.selectedProfileForDisks) {
                selectedProfileForDisksId =
                    this.form.storageProfilesData.selectedProfileForDisks.id;
            }
            var hasDefaultStoragePolicy = (selectedProfileForDisksId === '' || !selectedProfileForDisksId ||
                selectedProfileForDisksId === this.DEFAULT_STORAGE_ID);
            var storageSpec = {
                datastore: datastoreId,
                storagePolicy: hasDefaultStoragePolicy ? null : {
                    type: this.USE_SPECIFIED_STORAGE_POLICY,
                    policy: selectedProfileForDisksId
                }
            };
            return {
                vmHomeStorage: storageSpec,
                diskStorage: storageSpec
            };
        };
        VmProvisioningDatastorePageModel.prototype.getStorageSpecFromVmStorageComponent = function (storageComponent) {
            var datastoreRef = storageComponent.storageObj.storageRef;
            var datastoreId = this.defaultUriSchemeUtil.createVmomiUri(datastoreRef.type, datastoreRef.value, datastoreRef.serverGuid);
            var storageProfile = storageComponent.storageProfile;
            var selectedProfileId = storageProfile && storageProfile.id;
            var hasDefaultStoragePolicy = selectedProfileId === this.DEFAULT_STORAGE_ID;
            if (!selectedProfileId || selectedProfileId === '') {
                hasDefaultStoragePolicy = true;
            }
            return {
                datastore: datastoreId,
                storagePolicy: hasDefaultStoragePolicy ? null : {
                    type: this.USE_SPECIFIED_STORAGE_POLICY,
                    policy: selectedProfileId
                }
            };
        };
        VmProvisioningDatastorePageModel.prototype.buildDiskLocators = function (filteredDisks, virtualDisksByVm, homeStorageRef, diskFormat, selectedProfileId, replicationGroupInfo) {
            var _this = this;
            var vmId = this.virtualMachineSpecBuilder.getVmId();
            var virtualDisks = virtualDisksByVm[vmId];
            var disks = _.map(filteredDisks, function (disk) {
                var virtualDiskFromStorageSelector = _.find(virtualDisks, function (virtualDiskConfig) {
                    return virtualDiskConfig.key === disk.key;
                });
                var diskLocator = new RelocateSpec$DiskLocator();
                diskLocator.diskId = disk.key;
                if (virtualDiskFromStorageSelector) {
                    diskLocator.datastore = _this.defaultUriSchemeUtil
                        .getManagedObjectReference(virtualDiskFromStorageSelector.storage);
                    diskLocator.diskBackingInfo = (virtualDiskFromStorageSelector.diskFormat.value ===
                        _this.diskProvisioningService.SAME_AS_SOURCE.type ? null :
                        _this.diskProvisioningService.getBackingInfo(diskFormat.selectedDiskFormat.value));
                    var profile = virtualDiskFromStorageSelector.profile;
                    diskLocator.profile = [_this.storageProfileService.makeProfile(profile && profile.id, virtualDiskFromStorageSelector.replicationGroup)];
                    return diskLocator;
                }
                diskLocator.datastore = homeStorageRef;
                diskLocator.diskBackingInfo = (diskFormat.selectedDiskFormat.type ===
                    _this.diskProvisioningService.SAME_AS_SOURCE.type ? null :
                    _this.diskProvisioningService.getBackingInfo(diskFormat.selectedDiskFormat.type));
                diskLocator.profile = [_this.storageProfileService.makeProfile(selectedProfileId, replicationGroupInfo)];
                return diskLocator;
            });
            return disks;
        };
        VmProvisioningDatastorePageModel.filterDatastores = function (input, availableDatastores) {
            var MoRef = (function (_super) {
                __extends(MoRef, _super);
                function MoRef() {
                    _super.apply(this, arguments);
                }
                return MoRef;
            }(ManagedObjectReference));
            var availableStorage = availableDatastores;
            var compareMoRef = function (storage, moRef) {
                var id1 = storage.id;
                var SEPARATOR = ":";
                // ignoring type, only value + guid
                var id2 = moRef.value + SEPARATOR + moRef.serverGuid;
                if (id1 === id2) {
                    return true;
                }
                return false;
            };
            var isPmemDatastore = function (datastoreItem) {
                var PMEM_NAMESPACE_LOWERCASE = "pmem";
                if (!datastoreItem) {
                    return false;
                }
                var type = datastoreItem.type;
                if (!type) {
                    return false;
                }
                if (type.toLowerCase() === PMEM_NAMESPACE_LOWERCASE) {
                    return true;
                }
                return false;
            };
            var isSubsetOf = function (item, array) {
                if (!item) {
                    return false;
                }
                var storageRef = item.storageRef;
                var retVal = array.some(function (item) {
                    return compareMoRef(item, storageRef);
                });
                if (retVal) {
                    return true;
                }
                return false;
            };
            var isParentSubsetOf = function (item, array) {
                if (!item) {
                    return false;
                }
                var pod = item.parentStoragePod;
                if (!pod) {
                    return false;
                }
                var storageRef = pod;
                var retVal = array.some(function (item) {
                    return compareMoRef(item, storageRef);
                });
                if (retVal) {
                    return true;
                }
                return false;
            };
            var filterFn = function (item) {
                if (isPmemDatastore(item)) {
                    return true;
                }
                if (isSubsetOf(item, availableStorage)) {
                    return true;
                }
                if (isParentSubsetOf(item, availableStorage)) {
                    return true;
                }
                return false;
            };
            var output = input.filter(filterFn);
            return output;
        };
        VmProvisioningDatastorePageModel.prototype.load = function () {
            if (!this.isInDeployTemplateMode()) {
                this._drsConfig = null;
                return this.$q.resolve({});
            }
            return this.fetchDrsConfig();
        };
        VmProvisioningDatastorePageModel.prototype.fetchDrsConfig = function () {
            var _this = this;
            var promise = this.getDrsConfigPromise();
            var callback = function (config) {
                _this._drsConfig = config;
                return _this.$q.resolve(config);
            };
            var retVal = promise.then(callback);
            return retVal;
        };
        VmProvisioningDatastorePageModel.prototype.getDrsConfigPromise = function () {
            var crId = this.virtualMachineSpecBuilder.getComputeResourceId();
            var DRS_CONFIG = "configurationEx.drsConfig";
            var promise = this.getProperty(crId, DRS_CONFIG);
            return promise;
        };
        VmProvisioningDatastorePageModel.prototype.getProperty = function (objectId, property) {
            var _this = this;
            var promise = this.dataService.getProperties(objectId, [property]);
            var callback = function (result) {
                var retVal = undefined;
                if (result && property) {
                    retVal = result[property];
                }
                return _this.$q.resolve(retVal);
            };
            var retVal = promise.then(callback);
            return retVal;
        };
        VmProvisioningDatastorePageModel.prototype.newSuccessfulStorageCheck = function () {
            var retVal = this.newStorageCheck(true);
            return retVal;
        };
        VmProvisioningDatastorePageModel.prototype.newStorageCheck = function (success, error) {
            var retVal = new StorageCheck();
            if (success) {
                retVal.icon = "vsphere-icon-status-ok";
                var i18nKey = "ProvisioningWizard.CompatibilityChecksSucceeded";
                var succeeded = this.i18nService.getString("VmUi", i18nKey);
                retVal.message = succeeded;
            }
            else {
                retVal.icon = "vsphere-icon-status-error";
                var prefix = "SelectDatastoreProvisioningPage.";
                var i18nKey = prefix + error || "SpecifyValidLocation";
                var message = this.i18nService.getString("VmUi", i18nKey);
                retVal.message = message;
            }
            retVal.advancedCompatibilityContents = {};
            return retVal;
        };
        VmProvisioningDatastorePageModel.prototype.needsDatastoreSelection = function () {
            if (false === this.isInDeployTemplateMode()) {
                return true;
            }
            if (this.isAutomatedDrsCluster()) {
                return false;
            }
            return true;
        };
        VmProvisioningDatastorePageModel.prototype.canDeployOvfViaDrs = function (selectedStorage, selectedProfileId) {
            if (selectedStorage) {
                // only could place vis DRS if storage NOT selected
                return false;
            }
            if (!selectedProfileId) {
                // but profile should be selected for DRS placement to work
                return false;
            }
            var isDefaultStorageProfile = this.storageProfileService.isDefaultStorageProfile({ id: selectedProfileId });
            if (isDefaultStorageProfile) {
                // DRS placement won't work with default profile
                return false;
            }
            if (this.isAutomatedDrsCluster()) {
                return true;
            }
            return false;
        };
        VmProvisioningDatastorePageModel.prototype.isAutomatedDrsCluster = function () {
            var behavior = this._drsConfig ? this._drsConfig.defaultVmBehavior : undefined;
            if (!behavior) {
                return false; // single host won't do
            }
            // VMODL enums for DRS cluster
            var DRS_FULLY_AUTOMATED = "fullyAutomated";
            var DRS_PARTIALLY_AUTOMATED = "partiallyAutomated";
            if (behavior === DRS_FULLY_AUTOMATED) {
                return true;
            }
            if (behavior === DRS_PARTIALLY_AUTOMATED) {
                return true;
            }
            return false;
        };
        return VmProvisioningDatastorePageModel;
    }());
    h5_vm.VmProvisioningDatastorePageModel = VmProvisioningDatastorePageModel; // class
    var StorageCheck = (function () {
        function StorageCheck() {
        }
        return StorageCheck;
    }());
    angular.module("com.vmware.vsphere.client.vm").factory("VmProvisioningDatastorePageModel", VmProvisioningDatastorePageModelFactory);
})(h5_vm || (h5_vm = {})); // namespace



angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningDatastorePageService', [
   'i18nService',
   'VmProvisioningDatastorePageModel',
   'vmVuiWizardPageBuilder',
   function (i18nService, VmProvisioningDatastorePageModel, vmVuiWizardPageBuilder) {
      return {
         build: function (wizardScope, preselectedStorage, preselectedProfile) {
            wizardScope.datastorePageForm = {};

            var datastorePageModel = new VmProvisioningDatastorePageModel(
                  wizardScope.vmParams, wizardScope.wizardViewData, preselectedStorage, wizardScope.config);
            wizardScope.datastorePageModel = datastorePageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningDatastorePage.html',
               model: datastorePageModel
            });
         }
      };
   }
]);

var h5_vm;
(function (h5_vm) {
    var type = "com.vmware.vcenter.ovf.DeploymentOptionParams";
    var VmProvisioningDeploymentOptionsPageModelFactory = (function () {
        function VmProvisioningDeploymentOptionsPageModelFactory($q, i18nService) {
            return function (virtualMachineSpecBuilder, wizardViewData) {
                return new VmProvisioningDeploymentOptionsPageModel($q, i18nService, virtualMachineSpecBuilder, wizardViewData);
            };
        }
        VmProvisioningDeploymentOptionsPageModelFactory.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningDeploymentOptionsPageModelFactory;
    }());
    var VmProvisioningDeploymentOptionsPageModel = (function () {
        function VmProvisioningDeploymentOptionsPageModel($q, i18nService, virtualMachineSpecBuilder, wizardViewData) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.formObj = {
                deploymentOptionParams: undefined
            };
            this.virtualMachineSpecBuilderObj = virtualMachineSpecBuilder;
            this.wizardViewDataObj = wizardViewData;
        }
        Object.defineProperty(VmProvisioningDeploymentOptionsPageModel.prototype, "form", {
            get: function () {
                this.formObj.deploymentOptionParams = this.retrieveCommonContext();
                return this.formObj;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningDeploymentOptionsPageModel.prototype, "wizardViewData", {
            get: function () {
                return this.wizardViewDataObj;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmProvisioningDeploymentOptionsPageModel.prototype, "virtualMachineSpecBuilder", {
            get: function () {
                return this.virtualMachineSpecBuilderObj;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningDeploymentOptionsPageModel.prototype.validatePage = function () {
            return {};
        };
        VmProvisioningDeploymentOptionsPageModel.prototype.submitPage = function () {
            return {
                wizardFlow: this.virtualMachineSpecBuilderObj.getCreationType(),
                invalidateNextPages: false
            };
        };
        VmProvisioningDeploymentOptionsPageModel.prototype.retrieveCommonContext = function () {
            return _.find(this.wizardViewDataObj.getDeployFromLibraryCommonContext(), function (item) {
                return (_.isEqual(item._type, type));
            });
        };
        VmProvisioningDeploymentOptionsPageModel.prototype.resetForm = function () { };
        VmProvisioningDeploymentOptionsPageModel.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningDeploymentOptionsPageModel;
    }());
    h5_vm.VmProvisioningDeploymentOptionsPageModel = VmProvisioningDeploymentOptionsPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningDeploymentOptionsPageModel", VmProvisioningDeploymentOptionsPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningDeploymentOptionsPageService = (function () {
        function VmProvisioningDeploymentOptionsPageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, vmProvisioningDeploymentOptionsPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningDeploymentOptionsPageModel = vmProvisioningDeploymentOptionsPageModel;
        }
        VmProvisioningDeploymentOptionsPageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningDeploymentOptionsPageModel(wizardScope.vmParams, wizardScope.wizardViewData);
            wizardScope.vmProvisioningDeploymentConfigPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("Common", "DeploymentOptions.title"),
                description: this.i18nService.getString("Common", "DeploymentOptions.description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages" +
                    "/vmProvisioningDeploymentOptions/vm-provisioning-deployment-options.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED
            });
        };
        VmProvisioningDeploymentOptionsPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "vmProvisioningDeploymentOptionsPageModel"
        ];
        return VmProvisioningDeploymentOptionsPageService;
    }());
    h5_vm.VmProvisioningDeploymentOptionsPageService = VmProvisioningDeploymentOptionsPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("VmProvisioningDeploymentOptionsPageService", VmProvisioningDeploymentOptionsPageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var type = "com.vmware.vcenter.ovf.EulaParams";
    var VmProvisioningEulaPageModelFactory = (function () {
        function VmProvisioningEulaPageModelFactory($q, i18nService) {
            return function (virtualMachineSpecBuilder, wizardViewData) {
                return new VmProvisioningEulaPageModel($q, i18nService, virtualMachineSpecBuilder, wizardViewData);
            };
        }
        VmProvisioningEulaPageModelFactory.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningEulaPageModelFactory;
    }());
    var VmProvisioningEulaPageModel = (function () {
        function VmProvisioningEulaPageModel($q, i18nService, virtualMachineSpecBuilder, wizardViewData) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.formObj = {
                eulaInfo: undefined
            };
            this.virtualMachineSpecBuilderObj = virtualMachineSpecBuilder;
            this.wizardViewDataObj = wizardViewData;
        }
        Object.defineProperty(VmProvisioningEulaPageModel.prototype, "form", {
            get: function () {
                this.formObj.eulaInfo = this.retrieveCommonContext();
                return this.formObj;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningEulaPageModel.prototype.resetForm = function () {
            this.formObj.eulaInfo.allEULAAccepted = false;
        };
        VmProvisioningEulaPageModel.prototype.validatePage = function () {
            if (this.formObj.eulaInfo.allEULAAccepted) {
                return {};
            }
            else {
                return {
                    error: this.i18nService.getString("ProvisioningUiLib", "AcceptEulaPage.errorEulaNotAccepted")
                };
            }
        };
        VmProvisioningEulaPageModel.prototype.submitPage = function () {
            return {
                wizardFlow: this.virtualMachineSpecBuilderObj.getCreationType(),
                invalidateNextPages: false
            };
        };
        VmProvisioningEulaPageModel.prototype.retrieveCommonContext = function () {
            return _.find(this.wizardViewDataObj.getDeployFromLibraryCommonContext(), function (item) {
                return (_.isEqual(item._type, type));
            });
        };
        VmProvisioningEulaPageModel.$inject = [
            "$q",
            "i18nService"
        ];
        return VmProvisioningEulaPageModel;
    }());
    h5_vm.VmProvisioningEulaPageModel = VmProvisioningEulaPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningEulaPageModel", VmProvisioningEulaPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningEulaPageService = (function () {
        function VmProvisioningEulaPageService(i18nService, vuiConstants, vmVuiWizardPageBuilder, vmProvisioningEulaPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningEulaPageModel = vmProvisioningEulaPageModel;
        }
        VmProvisioningEulaPageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningEulaPageModel(wizardScope.vmParams, wizardScope.wizardViewData);
            wizardScope.vmProvisioningEulaPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("Common", "EulaControl.title"),
                description: this.i18nService.getString("ProvisioningUiLib", "AcceptEulaPage.errorEulaNotAccepted"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages" +
                    "/vmProvisioningEula/vm-provisioning-eula.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED
            });
        };
        VmProvisioningEulaPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "vmVuiWizardPageBuilder",
            "vmProvisioningEulaPageModel"
        ];
        return VmProvisioningEulaPageService;
    }());
    h5_vm.VmProvisioningEulaPageService = VmProvisioningEulaPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("VmProvisioningEulaPageService", VmProvisioningEulaPageService);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmProvisioningFinishPageModel = h5_vm.VmProvisioningFinishPageModel;
    var DeviceOperationConstants = h5_vm.DeviceOperationConstants;
    var VmProvisioningFinishCloneVmPageModelFactory = (function () {
        function VmProvisioningFinishCloneVmPageModelFactory($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, creationTypeConstants, bytesFilter, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService, scheduledTaskData) {
            return function (virtualMachineSpecBuilder, wizardViewData, scheduledTaskData) {
                return new VmProvisioningFinishCloneVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, creationTypeConstants, bytesFilter, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData);
            };
        }
        VmProvisioningFinishCloneVmPageModelFactory.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "creationTypeConstants",
            "bytesFilter",
            "storageProfileService",
            "diskModeService",
            "managedEntityConstants",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService",
            "pmemUtilService",
            "virtualDiskPmemService"
        ];
        return VmProvisioningFinishCloneVmPageModelFactory;
    }());
    var VmProvisioningFinishCloneVmPageModel = (function (_super) {
        __extends(VmProvisioningFinishCloneVmPageModel, _super);
        function VmProvisioningFinishCloneVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, creationTypeConstants, bytesFilter, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, pmemUtilService, virtualDiskPmemService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData) {
            _super.call(this, $q, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData);
            this.dataService = dataService;
            this.creationTypeConstants = creationTypeConstants;
            this.bytesFilter = bytesFilter;
            this.pmemUtilService = pmemUtilService;
            this.virtualDiskPmemService = virtualDiskPmemService;
        }
        VmProvisioningFinishCloneVmPageModel.prototype.getSchedulingData = function () {
            return this.scheduledTaskData;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.resetForm = function () {
            _super.prototype.resetForm.call(this);
            this.form.selectedDiskFormat = this.wizardViewData.getDiskFormatLabel();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getSourceObjectInfo = function () {
            var label;
            if (this.creationTypeConstants.isCloningFromATemplate(this.virtualMachineSpecBuilder.getCreationType())) {
                label = this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.SourceTemplate");
            }
            else {
                label = this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.SourceVm");
            }
            return {
                name: this.wizardViewData.getSourceObjectName(),
                label: label
            };
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getTargetObjectInfo = function () {
            var label;
            if (this.creationTypeConstants.isCloningToATemplate(this.virtualMachineSpecBuilder.getCreationType())) {
                label = this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.TemplateName");
            }
            else {
                label = this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.VmName");
            }
            return {
                label: label,
                name: this.virtualMachineSpecBuilder.getName()
            };
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getGosCustomizationSpecName = function () {
            return this.wizardViewData.getCustomizationSpecName();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.presentDiskFormat = function () {
            return this.wizardViewData.getDiskFormatLabel();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.presentProvisioningType = function () {
            switch (this.virtualMachineSpecBuilder.getCreationType()) {
                case this.creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.CloneTemplateToTemplate.Title");
                case this.creationTypeConstants.CLONE_TEMPLATE_TO_VM:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.DeployFromTemplate.Title");
                case this.creationTypeConstants.CLONE_VM_TO_TEMPLATE:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.CloneVmToTemplate.Title");
                case this.creationTypeConstants.CLONE_VM_TO_VM:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.CloneVmToVm.Title");
                case this.creationTypeConstants.CONVERT_TEMPLATE_TO_VM:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.ConvertTemplateToVm.Title");
                case this.creationTypeConstants.DEPLOY_VM_FROM_VMTX:
                    return this.i18nService.getString("VmUi", "ProvisioningTypes.DeployFromVmtx.Title");
            }
            return "";
        };
        VmProvisioningFinishCloneVmPageModel.prototype.isGosCustomized = function () {
            return this.virtualMachineSpecBuilder.getCloneOptions()
                && this.virtualMachineSpecBuilder.getCloneOptions().customizeOs;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getNewDisks = function () {
            var _this = this;
            var allNewDisks = this.getNewDevicesOfType(VmProvisioningFinishCloneVmPageModel.VIRTUAL_DISK_TYPE);
            return _.map(allNewDisks, function (newDisk, index) {
                var diskStorageProps = _this.virtualMachineSpecBuilder
                    .getStorageForDisk(newDisk.key);
                var diskSpec = _this.getDevices().findDeviceSpec(newDisk.key);
                var virtualDevice = _this.getDevices().getVirtualDevice(newDisk.key);
                var isRDM = virtualDevice.isRDMDisk();
                var isCreatedFromExistingDisk = virtualDevice.isCreatedFromExistingDisk();
                var diskInfo = _this.buildCommonDiskInfo(newDisk, index + 1, _this.getInflatedDevices(), isRDM, isCreatedFromExistingDisk);
                if (isCreatedFromExistingDisk) {
                    diskInfo = _.extend(diskInfo, _this.buildExistingDiskInfo(diskSpec.device.backing.fileName));
                    return diskInfo;
                }
                if (!isRDM) {
                    diskInfo = _.extend(diskInfo, _this.buildNewDiskInfo(newDisk, diskStorageProps));
                    return diskInfo;
                }
                _this.virtualMachineSpecBuilder.getVmConfigEnvironment().then(function (environment) {
                    diskInfo = _.extend(diskInfo, _this.buildRdmDiskInfo(environment, diskSpec));
                });
                return diskInfo;
            });
        };
        VmProvisioningFinishCloneVmPageModel.prototype.buildCommonDiskInfo = function (newDisk, index, allVirtualDevices, isRDM, isCreatedFromExistingDisk) {
            var diskInfo = {
                diskKey: newDisk.key,
                label: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.CreateDisk", index),
                storageProfile: this.getStorageProfileForDisk(newDisk),
                replicationGroupLabel: this.getReplicationGroupLabelForDisk(newDisk),
                isPmemDisk: this.isDiskGoingToPmem(newDisk),
                nodeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.VdNodeLabel"),
                node: this.getDiskNode(newDisk, allVirtualDevices),
                modeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.DiskModeLabel"),
                mode: this.getDiskMode(newDisk),
                isRDM: isRDM,
                isCreatedFromExistingDisk: isCreatedFromExistingDisk
            };
            return diskInfo;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.buildExistingDiskInfo = function (fileName) {
            var diskInfo = {};
            diskInfo.name = this.i18nService
                .getString("VmUi", "ProvisioningWizardSummaryPage.ExistingDisk");
            diskInfo.filePathLabel = this.i18nService
                .getString("VmUi", "vmProvisioningFinishPage.DiskFilePath");
            diskInfo.filePath = fileName;
            return diskInfo;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.buildNewDiskInfo = function (newDisk, diskStorageProps) {
            var _this = this;
            var diskInfo = {};
            diskInfo.name = this.i18nService
                .getString("VmUi", "ProvisioningWizardSummaryPage.NewDisk");
            diskInfo.capacityLabel = this.i18nService
                .getString("VmUi", "ProvisioningWizardSummaryPage.DiskCapacity");
            diskInfo.capacity = this.bytesFilter(newDisk.capacityInKB, "KB");
            diskInfo.datastoreLabel = this.i18nService
                .getString("VmUi", "ProvisioningWizardSummaryPage.Datastore");
            diskInfo.datastoreInfo = this.getDatastore(diskStorageProps);
            diskInfo.getStorageObject = function () {
                return _this.getStorageObject(diskStorageProps);
            };
            return diskInfo;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.buildRdmDiskInfo = function (environment, diskSpec) {
            var diskInfo = {};
            diskInfo.name = this.i18nService
                .getString("VmUi", "ProvisioningWizardSummaryPage.NewRdmDisk");
            diskInfo.targetLunLabel = this.i18nService
                .getString("VmUi", "vmProvisioningFinishPage.DiskTargetLun");
            diskInfo.targetLun = this.getRDMTargetLUNName(diskSpec.device, environment.vmConfigEnvironmentPerPool);
            diskInfo.compatibilityLabel = this.i18nService
                .getString("VmUi", "vmProvisioningFinishPage.DiskCompatibilityMode");
            diskInfo.compatibility = this.getRDMCompatibility(diskSpec.device);
            diskInfo.datastoreLabel = this.i18nService
                .getString("VmUi", "vmProvisioningFinishPage.DiskMappedDatastore");
            diskInfo.showStorageRecommendations = function () {
                return false;
            };
            diskInfo.datastoreName = this.getRDMDatastoreName();
            return diskInfo;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getExistingDisks = function () {
            var _this = this;
            var allExistingDisks = this.getExistingDevicesOfType(VmProvisioningFinishCloneVmPageModel.VIRTUAL_DISK_TYPE);
            return _.map(allExistingDisks, function (existingDisk) {
                return {
                    diskKey: existingDisk.key,
                    name: existingDisk.deviceInfo.label,
                    capacity: _this.bytesFilter(existingDisk.capacityInKB, "KB"),
                    datastoreInfo: _this.getDatastore(),
                    getStorageObject: function () {
                        var diskStorageProps = _this.virtualMachineSpecBuilder.getStorageForDisk(existingDisk.key);
                        return _this.getStorageObject(diskStorageProps);
                    },
                    provisioningType: _this.virtualMachineSpecBuilder.getProvisioningTypePerDisk(existingDisk.key),
                    storageProfile: _this.getStorageProfileForDisk(existingDisk),
                    replicationGroupLabel: _this.getReplicationGroupLabelForDisk(existingDisk),
                    isPmemDisk: _this.isDiskGoingToPmem(existingDisk)
                };
            });
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getNumberOfCpus = function () {
            return this.virtualMachineSpecBuilder.getVmConfigSpec().hardware.numCPU;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getAllocatedMemory = function () {
            var memoryMB = this.virtualMachineSpecBuilder.getVmConfigSpec().hardware.memoryMB;
            var memoryUnitPreferred = this.virtualMachineSpecBuilder.getVmConfigSpec().hardware.memoryUnitPreferred;
            if (memoryUnitPreferred) {
                return memoryMB / memoryUnitPreferred.multiplier + " " + memoryUnitPreferred.label;
            }
            else {
                return this.bytesFilter(memoryMB, "MB");
            }
        };
        VmProvisioningFinishCloneVmPageModel.prototype.shouldDsiplayHwCustomizedProperties = function () {
            return this.virtualMachineSpecBuilder.getCreationType() === this.creationTypeConstants.DEPLOY_VM_FROM_VMTX &&
                this.virtualMachineSpecBuilder.getCustomizeCloneHardware();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getNetworkInterfaces = function () {
            var virtualNetworkDevices = this.virtualMachineSpecBuilder
                .getUpdatedNetwork();
            return _.map(virtualNetworkDevices, this.buildNetworkInfo.bind(this));
        };
        VmProvisioningFinishCloneVmPageModel.prototype.buildNetworkInfo = function (virtualNetworkDevice, index) {
            var deviceNetwork = this.virtualMachineSpecBuilder.getVirtualMachineDevices()
                .getVirtualDevice(virtualNetworkDevice.device.key).network;
            return {
                networkNameLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NicNetwork", index + 1),
                networkName: deviceNetwork.displayName ||
                    this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.None"),
                networkTypeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NicType", index + 1),
                networkType: this.vmDeviceInfoService
                    .getEthernetCardLabel(virtualNetworkDevice.device._type)
            };
        };
        VmProvisioningFinishCloneVmPageModel.prototype.shouldShowDisks = function () {
            return this.virtualMachineSpecBuilder.getCustomizeCloneHardware()
                || this.virtualMachineSpecBuilder.getIsAdvancedStorageMode();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.isAdvancedStorageMode = function () {
            return this.virtualMachineSpecBuilder.getIsAdvancedStorageMode();
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getPmemDiskInfo = function () {
            return this.virtualDiskPmemService.getPmemDiskInfo(this.virtualMachineSpecBuilder.getStorageSelectorState());
        };
        /**
         * When the customize hardware is turned on, any disks going to pmem will have
         * their backings set to the correct pmem backing.
         * @returns {boolean} when disk is configured as Pmem
         */
        VmProvisioningFinishCloneVmPageModel.prototype.isDiskGoingToPmem = function (disk) {
            if (this.virtualMachineSpecBuilder.getCustomizeCloneHardware()) {
                return this.pmemUtilService.isPmemDisk(disk);
            }
            else {
                return this.pmemUtilService.isPMemStoragePolicy(this.getStorageProfileForDisk(disk));
            }
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getExistingDevicesOfType = function (type) {
            var operations = this.virtualMachineSpecBuilder.getCustomizeCloneHardware()
                ? [DeviceOperationConstants.EDIT]
                : [DeviceOperationConstants.EDIT, DeviceOperationConstants.REMOVE];
            return this.getDevicesOfType(type, operations);
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getNewDevicesOfType = function (type) {
            if (!this.virtualMachineSpecBuilder.getCustomizeCloneHardware()) {
                return [];
            }
            return this.getDevicesOfType(type, [DeviceOperationConstants.ADD]);
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getDevicesOfType = function (deviceType, operations) {
            var allDevices = [];
            _.forEach(this.getInflatedDevices(), function (virtualDevice) {
                var deviceOperation = virtualDevice.getCurrentDeviceSpec().operation;
                var device = virtualDevice.getCurrentDevice();
                if (device._type === deviceType && _.contains(operations, deviceOperation)) {
                    allDevices.push(virtualDevice.getCurrentDevice());
                }
            });
            return allDevices;
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getDiskNode = function (device, allVirtualDevices) {
            var ctrlVirtualDevice = _.find(allVirtualDevices, function (maybeController) {
                return maybeController.getCurrentDevice().key === device.controllerKey;
            });
            var controller = ctrlVirtualDevice.getCurrentDevice();
            return this.vmDeviceInfoService.getControllerAndNodeLabelText(controller._type, controller.busNumber, device.unitNumber);
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getInflatedDevices = function () {
            return this.getDevices() ? this.getDevices().getInflatedDevices() : [];
        };
        VmProvisioningFinishCloneVmPageModel.prototype.getDevices = function () {
            return this.virtualMachineSpecBuilder.getVirtualMachineDevices();
        };
        VmProvisioningFinishCloneVmPageModel.VIRTUAL_DISK_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualDisk";
        VmProvisioningFinishCloneVmPageModel.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "creationTypeConstants",
            "bytesFilter",
            "storageProfileService",
            "diskModeService",
            "managedEntityConstants",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService",
            "pmemUtilService",
            "virtualDiskPmemService"
        ];
        return VmProvisioningFinishCloneVmPageModel;
    }(VmProvisioningFinishPageModel));
    h5_vm.VmProvisioningFinishCloneVmPageModel = VmProvisioningFinishCloneVmPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningFinishCloneVmPageModel", VmProvisioningFinishCloneVmPageModelFactory);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningFinishCloneVmPageService', [
      'i18nService',
      'addVmService',
      'vmProvisioningFinishCloneVmPageModel',
      'vmVuiWizardPageBuilder',
      function(i18nService, addVmService, vmProvisioningFinishCloneVmPageModel, vmVuiWizardPageBuilder) {
         return {
            build: function(wizardScope) {

               var scheduledTaskData = wizardScope.scheduleTaskData &&
                  wizardScope.scheduleTaskData.isScheduledTask ?
                  wizardScope.scheduleTaskData : null;

               var pageModel = new vmProvisioningFinishCloneVmPageModel(
                     wizardScope.vmParams,
                     wizardScope.wizardViewData,
                     scheduledTaskData);

               wizardScope.vmProvisioningFinishCloneVmPageModel = pageModel;

               return vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
                  title: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Title'),
                  description: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Description'),
                  contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinishClone.html',
                  model: pageModel
               });
            }
         };
      }
   ]);
})();

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmProvisioningFinishPageModel = h5_vm.VmProvisioningFinishPageModel;
    var VmProvisioningFinishConvertToVmPageModelFactory = (function () {
        function VmProvisioningFinishConvertToVmPageModelFactory($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, managedEntityConstants, mutationService, storageProfileService, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService) {
            return function (virtualMachineSpecBuilder, wizardViewData, additionalData) {
                return new VmProvisioningFinishConvertToVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, managedEntityConstants, mutationService, storageProfileService, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, additionalData);
            };
        }
        VmProvisioningFinishConvertToVmPageModelFactory.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "mutationService",
            "storageProfileService",
            "diskModeService",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService"
        ];
        return VmProvisioningFinishConvertToVmPageModelFactory;
    }());
    var VmProvisioningFinishConvertToVmPageModel = (function (_super) {
        __extends(VmProvisioningFinishConvertToVmPageModel, _super);
        function VmProvisioningFinishConvertToVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, managedEntityConstants, mutationService, storageProfileService, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, additionalData) {
            _super.call(this, $q, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, additionalData);
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.datastoreRecommendationService = datastoreRecommendationService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
        }
        VmProvisioningFinishConvertToVmPageModel.prototype.getProvisioningType = function () {
            return this.i18nService.getString("VmUi", "ProvisioningTypes.ConvertTemplateToVm.Title");
        };
        VmProvisioningFinishConvertToVmPageModel.prototype.validatePage = function () {
            return {};
        };
        VmProvisioningFinishConvertToVmPageModel.prototype.getTemplateName = function () {
            return this.wizardViewData.getSourceObjectName();
        };
        VmProvisioningFinishConvertToVmPageModel.prototype.submitPage = function () {
            var _this = this;
            var vmTemplateId = this.virtualMachineSpecBuilder.getVmId();
            var selectedResId = this.virtualMachineSpecBuilder.getComputeResourceId();
            var selectedRes = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(selectedResId);
            var resPoolPromise;
            // TODO mibryamov: move this logic to JAVA and when all the properties are
            // resolved call the correct mutation provider by passing VmConvertSpec.
            // In order to do that the VmConvertSpec type first should be moved from
            // vm-service to modules-api.
            switch (selectedRes.type) {
                case this.managedEntityConstants.CLUSTER:
                    resPoolPromise = this.dataService.getProperties(selectedResId, ["resourcePool"])
                        .then(function (result) {
                        return {
                            resourcePoolRef: result.resourcePool,
                            hostRef: null
                        };
                    });
                    break;
                case this.managedEntityConstants.HOST:
                    resPoolPromise = this.dataService.getPropertiesByRelation(selectedResId, "host", this.managedEntityConstants.ANY_COMPUTE_RESOURCE, ["resourcePool"])
                        .then(function (result) {
                        return {
                            resourcePoolRef: _.values(result)[0].resourcePool,
                            hostRef: selectedRes
                        };
                    });
                    break;
                case this.managedEntityConstants.RESOURCE_POOL:
                case this.managedEntityConstants.V_APP:
                    resPoolPromise = this.$q.when({
                        resourcePoolRef: selectedRes,
                        hostRef: null
                    });
                    break;
                default:
                    throw new Error("Invalid compute resource selected");
            }
            if (!resPoolPromise) {
                return this.$q.when(false);
            }
            resPoolPromise.then(function (result) {
                var vmConvertSpec = {
                    pool: result.resourcePoolRef,
                    host: result.hostRef
                };
                _this.mutationService.apply(vmTemplateId, VmProvisioningFinishConvertToVmPageModel.VM_CONVERT_SPEC_TYPE, vmConvertSpec);
            });
            return this.$q.when(true);
        };
        VmProvisioningFinishConvertToVmPageModel.VM_CONVERT_SPEC_TYPE = "com.vmware.vsphere.client.vm.VmConvertSpec";
        VmProvisioningFinishConvertToVmPageModel.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "mutationService",
            "storageProfileService",
            "diskModeService",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService"
        ];
        return VmProvisioningFinishConvertToVmPageModel;
    }(VmProvisioningFinishPageModel));
    h5_vm.VmProvisioningFinishConvertToVmPageModel = VmProvisioningFinishConvertToVmPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningFinishConvertToVmPageModel", VmProvisioningFinishConvertToVmPageModelFactory);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('vmProvisioningFinishConvertToVmPageService', vmProvisioningFinishConvertToVmPageService);

   vmProvisioningFinishConvertToVmPageService.$inject = [
      'i18nService',
      'vmVuiWizardPageBuilder',
      'vmProvisioningFinishConvertToVmPageModel'];

   function vmProvisioningFinishConvertToVmPageService(
         i18nService,
         vmVuiWizardPageBuilder,
         vmProvisioningFinishConvertToVmPageModel) {
      return {
         build: function(wizardScope) {
            var pageModel = new vmProvisioningFinishConvertToVmPageModel(
                  wizardScope.vmParams,
                  wizardScope.wizardViewData);

            wizardScope.vmProvisioningFinishConvertToVmPageModel = pageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Title'),
               description: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinishConvertToVm.html',
               model: pageModel
            });
         }
      };
   }
})();

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmProvisioningFinishPageModel = h5_vm.VmProvisioningFinishPageModel;
    var VmProvisioningFinishCreateVmPageModelFactory = (function () {
        function VmProvisioningFinishCreateVmPageModelFactory($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, bytesFilter, storageProfileService, vmHardwareVersionService, managedEntityConstants, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService) {
            return function (virtualMachineSpecBuilder, wizardViewData, scheduledTaskData) {
                return new VmProvisioningFinishCreateVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, bytesFilter, storageProfileService, vmHardwareVersionService, managedEntityConstants, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData);
            };
        }
        VmProvisioningFinishCreateVmPageModelFactory.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "bytesFilter",
            "storageProfileService",
            "vmHardwareVersionService",
            "managedEntityConstants",
            "diskModeService",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService"
        ];
        return VmProvisioningFinishCreateVmPageModelFactory;
    }());
    var VmProvisioningFinishCreateVmPageModel = (function (_super) {
        __extends(VmProvisioningFinishCreateVmPageModel, _super);
        function VmProvisioningFinishCreateVmPageModel($q, dataService, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, bytesFilter, storageProfileService, vmHardwareVersionService, managedEntityConstants, diskModeService, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData) {
            _super.call(this, $q, i18nService, addVmService, vmDeviceInfoService, defaultUriSchemeUtil, storageProfileService, diskModeService, managedEntityConstants, datastoreRecommendationService, spbmReplicationGroupInfoService, virtualMachineSpecBuilder, wizardViewData, scheduledTaskData);
            this.dataService = dataService;
            this.bytesFilter = bytesFilter;
            this.vmHardwareVersionService = vmHardwareVersionService;
            this.datastoreRecommendationService = datastoreRecommendationService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
        }
        VmProvisioningFinishCreateVmPageModel.prototype.getSchedulingData = function () {
            return this.scheduledTaskData;
        };
        VmProvisioningFinishCreateVmPageModel.prototype.submitPage = function () {
            this.wizardViewData.setDatastoreObjectName(this.form.highestRecommendedDatastoreName);
            return _super.prototype.submitPage.call(this);
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getDisks = function () {
            var createdDisks = _.pluck(this.virtualMachineSpecBuilder.getDiskChanges(), "device");
            return _.map(createdDisks, this.buildDiskInfo.bind(this));
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getGuestOsName = function () {
            return this.virtualMachineSpecBuilder.getGosVersion().name;
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getVbsEnabled = function () {
            return this.virtualMachineSpecBuilder.getVbsEnabled() ?
                this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.enabled") :
                this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.disabled");
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getTpmDevice = function () {
            var tpmDevices = _.pluck(this.virtualMachineSpecBuilder.getTpmChanges(), "device");
            // Only one tpm device can exist at max so always pick index 0
            return tpmDevices.length ? tpmDevices[0] : null;
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getNumberOfCpus = function () {
            return this.virtualMachineSpecBuilder.getVmConfigSpec().config.hardware.numCPU;
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getAllocatedMemory = function () {
            var memoryMB = this.virtualMachineSpecBuilder.getVmConfigSpec().config.hardware.memoryMB;
            var memoryUnitPreferred = this.virtualMachineSpecBuilder.getVmConfigSpec().config.hardware.memoryUnitPreferred;
            if (memoryUnitPreferred) {
                return memoryMB / memoryUnitPreferred.multiplier + " " + memoryUnitPreferred.label;
            }
            else {
                return this.bytesFilter(memoryMB, "MB");
            }
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getScsiControllers = function () {
            var createdScsiControllers = _.pluck(this.virtualMachineSpecBuilder.getScsiControllerChanges(), "device");
            return _.map(createdScsiControllers, this.buildScsiInfo.bind(this));
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getNetworkInterfaces = function () {
            var virtualNetworkDevices = this.virtualMachineSpecBuilder
                .getVirtualMachineDevices()
                .changedDevicesOfType("VirtualEthernetCard");
            return _.map(virtualNetworkDevices, this.buildNetworkInfo.bind(this));
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getVmVersionCompatibility = function () {
            return this.i18nService.getString("VmUi", "VmHardware.HWVersion.vmVersionLabel", this.vmHardwareVersionService.getLongText(this.virtualMachineSpecBuilder.getVmConfigSpec().config.version));
        };
        VmProvisioningFinishCreateVmPageModel.prototype.buildNetworkInfo = function (virtualNetworkDevice, index) {
            return {
                networkNameLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NicNetwork", index + 1),
                networkName: virtualNetworkDevice.getNetworkName() ||
                    this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.None"),
                networkTypeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NicType", index + 1),
                networkType: this.vmDeviceInfoService
                    .getEthernetCardLabel(virtualNetworkDevice.getCurrentDevice()._type)
            };
        };
        VmProvisioningFinishCreateVmPageModel.prototype.buildScsiInfo = function (controller, index) {
            return {
                label: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.ScsiController", index + 1),
                name: this.vmDeviceInfoService.getScsiControllerLabel(controller)
            };
        };
        VmProvisioningFinishCreateVmPageModel.prototype.buildDiskInfo = function (disk, index) {
            var _this = this;
            var diskStorageProps = this.virtualMachineSpecBuilder.getStorageForDisk(disk.key);
            var diskSpec = this.virtualMachineSpecBuilder.getVirtualMachineDevices().findDeviceSpec(disk.key);
            var virtualDevice = this.virtualMachineSpecBuilder.getVirtualMachineDevices()
                .getVirtualDevice(disk.key);
            var isRDM = virtualDevice.isRDMDisk();
            var isCreatedFromExistingDisk = virtualDevice.isCreatedFromExistingDisk();
            var diskInfo = {
                diskKey: disk.key,
                label: this.isDiskEncrypted(disk.key) ?
                    this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.CreateEncryptedDisk", index + 1) :
                    this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.CreateDisk", index + 1),
                storageProfile: this.getStorageProfileForDisk(disk),
                replicationGroupLabel: this.getReplicationGroupLabelForDisk(disk),
                nodeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.VdNodeLabel"),
                node: this.getDiskNode(disk, this.virtualMachineSpecBuilder.getVirtualMachineDevices().getDeviceChanges()),
                modeLabel: this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.DiskModeLabel"),
                mode: this.getDiskMode(disk),
                isPmemDisk: virtualDevice.isPmemDisk(),
                isRDM: isRDM,
                isCreatedFromExistingDisk: isCreatedFromExistingDisk
            };
            if (isCreatedFromExistingDisk) {
                diskInfo.name = this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.ExistingDisk");
                diskInfo.filePathLabel = this.i18nService
                    .getString("VmUi", "vmProvisioningFinishPage.DiskFilePath");
                diskInfo.filePath = diskSpec.device.backing.fileName;
                return diskInfo;
            }
            if (!isRDM) {
                diskInfo.name = this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NewDisk");
                diskInfo.capacityLabel = this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.DiskCapacity");
                diskInfo.capacity = this.buildDiskCapacity(disk, diskSpec);
                diskInfo.datastoreLabel = this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.Datastore");
                diskInfo.datastoreInfo = this.getDatastore(diskStorageProps);
                diskInfo.getStorageObject = function () {
                    return _this.getStorageObject(diskStorageProps);
                };
                diskInfo.showStorageRecommendations = function () {
                    return _this.showStorageRecommendations(diskStorageProps);
                };
                return diskInfo;
            }
            this.virtualMachineSpecBuilder.getVmConfigEnvironment().then(function (environment) {
                diskInfo.name = _this.i18nService
                    .getString("VmUi", "ProvisioningWizardSummaryPage.NewRdmDisk");
                diskInfo.targetLunLabel = _this.i18nService
                    .getString("VmUi", "vmProvisioningFinishPage.DiskTargetLun");
                diskInfo.targetLun = _this.getRDMTargetLUNName(diskSpec.device, environment.vmConfigEnvironmentPerPool);
                diskInfo.compatibilityLabel = _this.i18nService
                    .getString("VmUi", "vmProvisioningFinishPage.DiskCompatibilityMode");
                diskInfo.compatibility = _this.getRDMCompatibility(diskSpec.device);
                diskInfo.datastoreLabel = _this.i18nService
                    .getString("VmUi", "vmProvisioningFinishPage.DiskMappedDatastore");
                diskInfo.showStorageRecommendations = function () {
                    return false;
                };
                diskInfo.datastoreName = _this.getRDMDatastoreName();
            });
            return diskInfo;
        };
        VmProvisioningFinishCreateVmPageModel.prototype.showStorageRecommendations = function (diskStorageProps) {
            var storageObject = this.virtualMachineSpecBuilder.getStorageObject();
            if (diskStorageProps) {
                storageObject = diskStorageProps.dsObject;
            }
            return storageObject.storageRef.type === this.managedEntityConstants.STORAGE_POD ||
                (storageObject.parentStoragePod && storageObject.parentStoragePod.isSdrsEnabled);
        };
        VmProvisioningFinishCreateVmPageModel.prototype.buildDiskCapacity = function (disk, diskSpec) {
            return this.bytesFilter(disk.capacityInKB, "KB");
        };
        VmProvisioningFinishCreateVmPageModel.prototype.getDiskNode = function (device, deviceChanges) {
            var allDevices = this.virtualMachineSpecBuilder.getVmConfigSpec().config.hardware.device.concat(_.pluck(deviceChanges, "device"));
            var controller = _.find(allDevices, function (maybeController) {
                return maybeController.key === device.controllerKey;
            });
            return this.vmDeviceInfoService.getControllerAndNodeLabelText(controller._type, controller.busNumber, device.unitNumber);
        };
        VmProvisioningFinishCreateVmPageModel.$inject = [
            "$q",
            "dataService",
            "i18nService",
            "addVmService",
            "vmDeviceInfoService",
            "defaultUriSchemeUtil",
            "bytesFilter",
            "storageProfileService",
            "vmHardwareVersionService",
            "managedEntityConstants",
            "diskModeService",
            "datastoreRecommendationService",
            "spbmReplicationGroupInfoService"
        ];
        return VmProvisioningFinishCreateVmPageModel;
    }(VmProvisioningFinishPageModel));
    h5_vm.VmProvisioningFinishCreateVmPageModel = VmProvisioningFinishCreateVmPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningFinishCreateVmPageModel", VmProvisioningFinishCreateVmPageModelFactory);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningFinishCreateVmPageService', [
      '$q',
      'i18nService',
      'addVmService',
      'mutationService',
      'wizardPageService',
      'defaultUriSchemeUtil',
      'vmVuiWizardPageBuilder',
      'vmProvisioningFinishCreateVmPageModel',
      function(
         $q,
         i18nService,
         addVmService,
         mutationService,
         wizardPageService,
         defaultUriSchemeUtil,
         vmVuiWizardPageBuilder,
         vmProvisioningFinishCreateVmPageModel
      ) {
         return {
            build: function(wizardScope) {

               var pageModel = new vmProvisioningFinishCreateVmPageModel(
                     wizardScope.vmParams,
                     wizardScope.wizardViewData,
                     wizardScope.scheduleTaskData);

               wizardScope.vmProvisioningFinishCreateVmPageModel = pageModel;

               return vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
                  title: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Title'),
                  description: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Description'),
                  contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinish.html',
                  model: pageModel
               });
            }
         };
      }
   ]);
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningFinishDeployFromTemplateController',
            VmProvisioningFinishDeployFromTemplateController);

   VmProvisioningFinishDeployFromTemplateController.$inject = [
         '$scope',
         'creationTypeConstants'
   ];

   function VmProvisioningFinishDeployFromTemplateController(
         $scope, creationTypeConstants) {
      var model = $scope.vmProvisioningFinishDeployFromTemplatePageModel;
      var self = this;
      self.provisioningTypeName = model.presentProvisioningType();

      if ($scope.vmParams.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ||
          $scope.vmParams.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_VAPP) {
         self.templateName = $scope.wizardViewData.getSelectedTemplate().templateName;
      } else if ($scope.vmParams.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_OVF) {
         self.templateName = $scope.vmParams.getTemplateName();
      }

      self.templateVMName = model.getVmName();
      self.downloadSize = $scope.productDetailsPageModel.dataModel.getDownloadSize();
      var selectedDiskFormat = $scope.datastorePageModel.form.diskFormatSettings.selectedDiskFormat;
      var isThinDeployment = selectedDiskFormat && selectedDiskFormat.type === "thin";
      self.scaleoutConfiguration = $scope.wizardViewData.getSclaeoutConfigurationFromLibraryCommonContext();
      self.sizeOnDisk = $scope.productDetailsPageModel.dataModel.getSizeOnDisk(isThinDeployment);
      self.computeResource = $scope.vmParams.getComputeResourceName();
      self.vmFolder = $scope.vmParams.getTargetInformation().name;
      self.storageMappings = model.getStorageDetails();
      self.networkDevices = model.getNetworkDetails($scope.networkPageModel.getNetworkMappingParams());
      self.ipDetails = model.getIpAllocationDetails($scope.networkPageModel.getIpAllocationParams());
      var spec = model.getCustomizationSpec();
      self.gosCustomizationSpecName = spec ? spec.name : undefined;
      self.isGosCustomizationEnabled = !_.isEmpty(self.gosCustomizationSpecName);

   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningFinishDeployFromTemplatePageModel',
               VmProvisioningFinishDeployFromTemplatePageModel);

   VmProvisioningFinishDeployFromTemplatePageModel.$inject = [
      'i18nService',
      'contentLibraryService',
      'sourceTypeConstants',
      'storageProfileService',
      'defaultUriSchemeUtil'
   ];

   function VmProvisioningFinishDeployFromTemplatePageModel(i18nService,
         contentLibraryService,
         sourceTypeConstants,
         storageProfileService,
         defaultUriSchemeUtil) {
      return function(wizardVmParams, wizardViewData) {
         var VSAN_DATASTORE_TYPE = 'vsan';
         var THIN_TYPE = 'thin';

         return {
            presentProvisioningType: function() {
               if (wizardViewData.getTemplateSourceType() === sourceTypeConstants.SOURCE_TYPE_PULL) {
                  return i18nService.getString('VmUi', 'ProvisioningTypes.DeployFromOvfRemote.Title');
               } else {
                  return i18nService.getString('VmUi', 'ProvisioningTypes.DeployFromTemplate.Title');
               }
            },

            validatePage: function() {
               return {};
            },

            getVmName: function() {
               return wizardVmParams.getName();
            },

            getCustomizationSpec: function() {
               return wizardVmParams.getCustomizationSpec();
            },

            getStorageDetails: function() {
               var datastoreMappingParams =
                     wizardViewData.getDatastoreMappingParamsFromLibraryCommonContext();

               // One mapping info for each disk group.
               var result = _.map(datastoreMappingParams.diskGroups, function(diskGroup) {
                  return {
                     name: diskGroup.name,
                     diskInfo: getDiskInfoLabel(diskGroup, datastoreMappingParams)
                  };
               });

               // And one dummy mapping info for all disks that are not part of any disk group.
               result.push({
                  name: _.size(result) > 0 ?
                        i18nService.getString('ProvisioningUiLib',
                              'SelectStoragePage.summary.allOtherDisks') :
                        i18nService.getString('ProvisioningUiLib',
                              'SelectStoragePage.summary.allDisks'),
                  diskInfo: getDiskInfoLabel(undefined, datastoreMappingParams)
               });

               // Just a single label - return it.
               if (_.size(result) === 1) {
                  return result;
               }

               // If all labels are identical - we want to merge them into 1,
               // cause this means all disk groups are going to the same location
               var someDiffer = _.some(result, function(mapping) {
                  return (mapping.diskInfo !== result[0].diskInfo);
               });

               if (someDiffer) {
                  return result;
               }

               // All disk info labels are identical - so return single unified item.
               return [{
                  name: i18nService.getString('ProvisioningUiLib',
                        'SelectStoragePage.summary.allDisks'),
                  diskInfo: result[0].diskInfo
               }];
            },

            getNetworkDetails: function(networkInfo) {
               if (networkInfo) {
                  return _.map(networkInfo.sourceNetworks, function(network) {
                     var tgt = _.find(networkInfo.targetNetworks, function(tNetwork) {
                        return tNetwork.id === network.target;
                     });
                     network.targetName = tgt.name;
                     return network;
                  });
               }
               return null;

            },

            getIpAllocationDetails: function(ipInfo) {
               if (ipInfo) {
                  ipInfo.ipAllocationPolicy = _.find(ipInfo.supportedIpAllocationPolicy, function(policy) {
                     return _.isEqual(policy.name, ipInfo.ipAllocationPolicy.name);
                  });
                  return ipInfo;
               }
               return null;
            },

            submitPage: function () {
               var gosCustomizationInfo = wizardVmParams.getCustomizationSpecInfo();
               var gosCustomizationSpec = wizardVmParams.getCustomizationSpec();

               // Add GOSC details into common context only when info & spec are available
               if (gosCustomizationInfo && gosCustomizationSpec) {
                  buildGosCustomizationParam(
                        gosCustomizationInfo,
                        gosCustomizationSpec)
                        .then(function (gosCustomizationParam) {
                           var commonContext = wizardViewData.getDeployFromLibraryCommonContext();
                           commonContext.push(gosCustomizationParam);
                           wizardViewData.setDeployFromLibraryCommonContext(commonContext);
                           deployTemplate();
                        });
               } else {
                  deployTemplate();
               }
               return true;
            },

            fetchSelectedStorage: function() {
               return wizardVmParams.getStorageObject();
            }
         };

         /**
          * Content library service does not accept GOSC Spec in plain object format.
          * GOSC Spec must be converted into an XML string with all customizations
          * present in it.
          *
          * @param gosCustomizationInfo
          *          Name, Description of the GOSC.
          * @param gosCustomizationSpec
          *          Object representation of specification with all user input values.
          * @returns
          *    {promised mutation call which results an XML output.}
          */
         function buildGosCustomizationParam(gosCustomizationInfo, gosCustomizationSpec) {

            return contentLibraryService
                  .getXmlFormattedCustomizationSpec(
                        wizardViewData.getVCenterId(),
                        gosCustomizationInfo,
                        gosCustomizationSpec)
                  .then(function (specObject) {
                     var customizationInXml = specObject.result;
                     return {
                        _type: "com.vmware.vcenter.ovf.VcenterGuestCustomizationParams",
                        type: "VcenterGuestCustomizationParams",
                        customizations: {
                           systemId: {
                              type: 'XML',
                              xml: customizationInXml
                           }
                        }
                     };
                  });
         }

         /**
          * Performs the final deploy-template call.
          * Also, modifies targetNetworks and datastore mapping in common context.
          */
         function deployTemplate() {
            var isLocalOvfDeploySession = wizardViewData.getTemplateSourceType() === sourceTypeConstants.SOURCE_TYPE_PUSH;
            var localOvfSession = isLocalOvfDeploySession ? wizardViewData.getDeployOvfSession() : undefined;

            //#2072730
            clearTargetNetworks();
            //#2072730
            clearTargetNetworks();

            //#VUCL-862
            modifyDatastoreMappings();
            //#VUCL-862
            modifyDatastoreMappings();

            contentLibraryService.deployVmFromLibraryTemplate(
                  wizardVmParams.getComputeResourceId(),
                  wizardVmParams.getTargetInformation().folderUid,
                  wizardVmParams.getName(),
                  wizardViewData.getDeployFromLibraryCommonContext(),
                  isLocalOvfDeploySession,
                  localOvfSession);
            return true;
         }

         function getDiskInfoLabel(diskGroup, datastoreMappingParams) {
            // We benefit form the fact that diskGroups and datastoreMappingParams
            // have similar properties when it comes to setting actual data.
            var diskGroupObject = diskGroup || datastoreMappingParams;

            // We use 'undefined' compare because we want to distinguish between not set
            // and set with empty string. The first means - take from parent,
            // the second means - no profile.
            var profile = (diskGroupObject.targetProfile !== undefined) ?
                  findProfile(diskGroupObject.targetProfile) :
                  findProfile(datastoreMappingParams.targetProfile);

            var isPmemProfile = storageProfileService.isPmemStorageProfile(profile);

            var storageName = diskGroupObject.targetDatastore ?
                  findStorageName(diskGroupObject.targetDatastore) :
                  !isPmemProfile && datastoreMappingParams ?
                        findStorageName(datastoreMappingParams.targetDatastore) : "";

            // NOTE: For VSAN datastores targetProvisioningType can be null
            // See VmProvisioningDatastorePageModel.updateDiskFormatIfVSAN
            var diskFormatName = diskGroupObject.targetProvisioningType ?
                  i18nService.getString('ProvisioningUiLib',
                     'DiskProvisioningType.' +
                     diskGroupObject.targetProvisioningType.name +
                     '.label') :
                  i18nService.getString('ProvisioningUiLib',
                     'DiskProvisioningType.asDefinedInProfile.label');

            var diskInfoLbl;
            if (isPmemProfile) {
               diskInfoLbl = i18nService.getString('ProvisioningUiLib',
                     'SelectStoragePage.summary.policyPMemdsFormat',
                     profile.label, diskFormatName);
            } else if (profile) {
               diskInfoLbl = i18nService.getString('ProvisioningUiLib',
                     'SelectStoragePage.summary.policyDsFormat',
                     profile.label, storageName, diskFormatName);
            } else {
               diskInfoLbl = i18nService.getString('ProvisioningUiLib',
                     'SelectStoragePage.summary.dsFormat',
                     storageName, diskFormatName);
            }

            if (!diskInfoLbl) {
               return "N/A";
            }

            return diskInfoLbl;
         }

         // NOTE speev: target datastore in the DatastoreMappingParams stucture have
         // strange format - so we need special method to search in the map.
         function findStorageName(targetDatastore) {
            var storageNamesMap = wizardViewData.getStorageNameMap();
            return _.find(storageNamesMap, function(storageName, storageKey) {
               return (storageKey.indexOf(targetDatastore) >= 0);
            });
         }

         function findProfile(targetProfileId) {
            var storageProfiles = wizardViewData.getStorageProfiles();
            return _.findWhere(storageProfiles, { id: targetProfileId });
         }

         function clearTargetNetworks() {
            var networkParams =
                  wizardViewData.getNetworkMappingParamsFromLibraryCommonContext();
            if (networkParams && networkParams.targetNetworks) {
               networkParams.targetNetworks = null;
            }
         }

         function modifyDatastoreMappings()  {
            var datastoreMappingParams =
                  wizardViewData.getDatastoreMappingParamsFromLibraryCommonContext();

            if(!datastoreMappingParams) {
               return;
            }

            //Set provisioning type to thin for targetDatastore for each diskGroup if present.
            _.each(datastoreMappingParams.diskGroups, function (diskGroup) {
               var datastore = findDatastoreItemFromId(diskGroup.targetDatastore);
               if (datastore && datastore.type === VSAN_DATASTORE_TYPE && datastore.thinProvisioningSupported) {
                  diskGroup.targetProvisioningType =
                        _.find(datastoreMappingParams.availableDiskProvisioningTypes, function (type) {
                           return type.name === THIN_TYPE;
                        });
               }
            });

            //Set provisioning type to thin for targetDatastore in datastoreMappings object.
            var datastore = findDatastoreItemFromId(datastoreMappingParams.targetDatastore);
            if (datastore && datastore.type === VSAN_DATASTORE_TYPE && datastore.thinProvisioningSupported) {
               datastoreMappingParams.targetProvisioningType =
                     _.find(datastoreMappingParams.availableDiskProvisioningTypes, function (type) {
                  return type.name === THIN_TYPE;
               });
            }
         }

         function getVsphereDatastoreId(contentLibaryDatastoreId) {
            if (!contentLibaryDatastoreId) {
               return undefined;
            }
            var parts = contentLibaryDatastoreId.split(":");
            if (parts.length < 2) {
               return undefined;
            }
            return defaultUriSchemeUtil.getVsphereObjectId({
               type: "Datastore",
               value: parts[0],
               serverGuid: parts[1]
            });
         }

         function findDatastoreItemFromId(targetDatastore) {
            if(targetDatastore) {
               var datastoreItems = wizardViewData.getStorageLocatorItemsData().datastoreItems;
               return _.find(datastoreItems, function (datastoreItem) {
                  if (datastoreItem) {
                     var id1 = getVsphereDatastoreId(targetDatastore);
                     var id2 = datastoreItem.storageRef;
                     return defaultUriSchemeUtil.compareIds(id1, id2);
                  } else {
                     return false;
                  }
               });
            }
         }
      };
   }
}());

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningFinishDeployTemplatePageService', [
      '$q',
      'i18nService',
      'addVmService',
      'mutationService',
      'wizardPageService',
      'defaultUriSchemeUtil',
      'vmVuiWizardPageBuilder',
      'VmProvisioningFinishDeployFromTemplatePageModel',
      function(
         $q,
         i18nService,
         addVmService,
         mutationService,
         wizardPageService,
         defaultUriSchemeUtil,
         vmVuiWizardPageBuilder,
         VmProvisioningFinishDeployFromTemplatePageModel
      ) {
         return {
            build: function(wizardScope) {
               var model = new VmProvisioningFinishDeployFromTemplatePageModel(wizardScope.vmParams, wizardScope.wizardViewData);
               wizardScope.vmProvisioningFinishDeployFromTemplatePageModel = model;
               return vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
                  title: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Title'),
                  description: i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Description'),
                  contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinishDeployFromTemplate.html',
                  model: model
               });
            }
         };
      }
   ]);
})();

var h5_vm;
(function (h5_vm) {
    var RegisterVmSpec = com.vmware.vsphere.client.h5.vm.data.RegisterVmSpec;
    var VmProvisioningFinishRegisterPageModelFactory = (function () {
        function VmProvisioningFinishRegisterPageModelFactory(defaultUriSchemeUtil, i18nService, dataService, managedEntityConstants, $q, mutationService) {
            return function (virtualMachineSpecBuilder, wizardViewData) {
                return new VmProvisioningFinishRegisterPageModel(defaultUriSchemeUtil, i18nService, dataService, managedEntityConstants, $q, mutationService, virtualMachineSpecBuilder, wizardViewData);
            };
        }
        VmProvisioningFinishRegisterPageModelFactory.$inject = [
            "defaultUriSchemeUtil",
            "i18nService",
            "dataService",
            "managedEntityConstants",
            "$q",
            "mutationService"
        ];
        return VmProvisioningFinishRegisterPageModelFactory;
    }());
    var VmProvisioningFinishRegisterPageModel = (function () {
        function VmProvisioningFinishRegisterPageModel(defaultUriSchemeUtil, i18nService, dataService, managedEntityConstants, $q, mutationService, virtualMachineSpecBuilder, wizardViewData) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.managedEntityConstants = managedEntityConstants;
            this.$q = $q;
            this.mutationService = mutationService;
            this.virtualMachineSpecBuilder = virtualMachineSpecBuilder;
            this.wizardViewData = wizardViewData;
        }
        VmProvisioningFinishRegisterPageModel.prototype.getVmName = function () {
            return this.virtualMachineSpecBuilder.getName();
        };
        VmProvisioningFinishRegisterPageModel.prototype.getTargetFolderName = function () {
            return this.virtualMachineSpecBuilder.getTargetInformation().name;
        };
        VmProvisioningFinishRegisterPageModel.prototype.getIsTemplate = function () {
            return this.virtualMachineSpecBuilder.getRegisterVmData().isTemplate;
        };
        VmProvisioningFinishRegisterPageModel.prototype.getComputeResourceInfo = function () {
            var crId = this.virtualMachineSpecBuilder.getComputeResourceId();
            var crName = this.virtualMachineSpecBuilder.getComputeResourceName();
            var crType = this.labelForType(crId);
            return {
                name: crName,
                label: crType
            };
        };
        VmProvisioningFinishRegisterPageModel.prototype.validatePage = function () {
            return {};
        };
        VmProvisioningFinishRegisterPageModel.prototype.submitPage = function () {
            var spec = new RegisterVmSpec();
            spec.folderRef = this.defaultUriSchemeUtil.getManagedObjectReference(this.virtualMachineSpecBuilder.getTargetInformation().folderUid);
            spec.targetRef = this.defaultUriSchemeUtil.getManagedObjectReference(this.virtualMachineSpecBuilder.getComputeResourceId());
            spec.vmName = this.virtualMachineSpecBuilder.getName();
            spec.vmPath = this.virtualMachineSpecBuilder.getRegisterVmData().vmFilePath;
            spec.isVmTemplate = this.virtualMachineSpecBuilder.getRegisterVmData().isTemplate;
            this.mutationService.add(spec._type, spec);
            return this.$q.resolve(true);
        };
        VmProvisioningFinishRegisterPageModel.prototype.labelForType = function (urn) {
            var type = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(urn).type;
            switch (type) {
                case this.managedEntityConstants.CLUSTER:
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Cluster");
                case this.managedEntityConstants.HOST:
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Host");
                case this.managedEntityConstants.RESOURCE_POOL:
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                case this.managedEntityConstants.V_APP:
                    return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
                default:
                    throw new Error("Unknown compute resouce id: " + urn);
            }
        };
        VmProvisioningFinishRegisterPageModel.$inject = [
            "defaultUriSchemeUtil",
            "i18nService",
            "dataService",
            "managedEntityConstants",
            "$q",
            "mutationService"];
        return VmProvisioningFinishRegisterPageModel;
    }());
    h5_vm.VmProvisioningFinishRegisterPageModel = VmProvisioningFinishRegisterPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningFinishRegisterPageModel", VmProvisioningFinishRegisterPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningFinishRegisterPageService = (function () {
        function VmProvisioningFinishRegisterPageService(i18nService, vmVuiWizardPageBuilder, vmProvisioningFinishRegisterPageModel) {
            this.i18nService = i18nService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningFinishRegisterPageModel = vmProvisioningFinishRegisterPageModel;
        }
        VmProvisioningFinishRegisterPageService.prototype.build = function (wizardScope) {
            var pageModel = new this.vmProvisioningFinishRegisterPageModel(wizardScope.vmParams, wizardScope.wizardViewData);
            wizardScope.finishRegisterPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardFinishPage(wizardScope.config, {
                title: this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Title"),
                description: this.i18nService.getString("VmUi", "regVm.Summary.pageDesc"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinishRegister.html",
                model: pageModel
            });
        };
        VmProvisioningFinishRegisterPageService.$inject = ["i18nService",
            "vmVuiWizardPageBuilder",
            "vmProvisioningFinishRegisterPageModel"
        ];
        return VmProvisioningFinishRegisterPageService;
    }());
    h5_vm.VmProvisioningFinishRegisterPageService = VmProvisioningFinishRegisterPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningFinishRegisterPageService", VmProvisioningFinishRegisterPageService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningGuestOsPageModel', VmProvisioningGuestOsPageModel);

   VmProvisioningGuestOsPageModel.$inject = [
      '$q',
      '$sce',
      'i18nService',
      'gosFamilyConstants',
      'vmHardwareVersionService',
      'featureFlagsService'
   ];

   function VmProvisioningGuestOsPageModel(
         $q,
         $sce,
         i18nService,
         gosFamilyConstants,
         vmHardwareVersionService,
		 featureFlagsService) {
      return function(virtualMachineSpecBuilder) {
         var form = {
            familyChanged: function() {
               this.gosVersion = null;
               setVersionOptions(this.gosFamily);
            },
            gosFamilyOptions: [
               familyObject(gosFamilyConstants.WINDOWS),
               familyObject(gosFamilyConstants.LINUX),
               familyObject(gosFamilyConstants.OTHER)
            ],
            gosVersionOptions: {},
            isSelectedOtherOs: function() {
               return this.gosVersion && (this.gosVersion.id === 'otherGuest' || this.gosVersion.id === 'otherGuest64');
            },
            vbsEnabled: false,
            isVbsSupported: function(gosVersion) {
               return isVbsFeatureFlagEnabled() &&
                   (!gosVersion.vbsSupported ? false : gosVersion.vbsSupported.supported);
            }
         };

         var gosDescriptor;
         var gosDefault;

         return {
            form: form,

            resetForm: function() {
               var deferred = $q.defer();

               var submittedGosFamily;
               var submittedGosName;
               if (!virtualMachineSpecBuilder.getRecreateVm()) {
                  submittedGosFamily = virtualMachineSpecBuilder.getGosFamily();
                  submittedGosName = virtualMachineSpecBuilder.getGosName();
               }
               var selectedGos = form.gosFamily || submittedGosFamily;
               form.gosFamily = selectedGos || form.gosFamilyOptions[0];

               virtualMachineSpecBuilder.getConfigOptionByPool().then(function(res) {
                  gosDescriptor = res.vmConfigOptionByPool.guestOSDescriptor;
                  var guestOsDefaultIndex = res.vmConfigOptionByPool.guestOSDefaultIndex;
                  // in case we have the gos id set in the vm params, try to preselect that
                  // descriptor, this is the case with scheduled tasks where we only have
                  // the id of the guest os
                  var guestOsIndex = initiateGosFromScheduledTask(gosDescriptor);
                  if (guestOsIndex !== null) {
                     guestOsDefaultIndex = guestOsIndex;
                  }
                  if (guestOsDefaultIndex && guestOsDefaultIndex > -1 && guestOsDefaultIndex < gosDescriptor.length) {
                     gosDefault = gosDescriptor[guestOsDefaultIndex];
                  }
                  setVersionOptions(form.gosFamily);

                  form.vmVersionDescription = getVmVersionDescription();
                  // since the request for vm config environment property (that is required
                  // for customize hardware page) is heavy and slow we are initiating it so
                  // when the navigated to the next page the data hopefully will be retrieved
                  // already
                  virtualMachineSpecBuilder.getVmConfigEnvironmentForGos(form.gosVersion);
                  deferred.resolve();
               });

               form.gosName = form.gosName || submittedGosName || null;
               return deferred.promise;
            },

            pageFinishedLoading: function () {
               return !!form.gosFamily && !!form.gosVersion;
            },

            validatePage: function() {
               return {};
            },

            submitPage: function() {
               virtualMachineSpecBuilder.setGosFamilyAndVersion({
                  family: form.gosFamily,
                  version: form.gosVersion
               });

               // in case the guest os is changed from the one selected when the
               // scheduled task was created, do not use the data to pre-populate the customize hardware page
               const scheduledTaskData = virtualMachineSpecBuilder.getScheduledData();
               if (!_.isEmpty(scheduledTaskData)) {
                  if (scheduledTaskData.spec.guestId !== form.gosVersion.id) {
                     scheduledTaskData.useScheduledTaskData = false;
                  }
               }
               virtualMachineSpecBuilder.setVbsSupported(form.gosVersion.vbsSupported && form.gosVersion.vbsSupported.supported);
               virtualMachineSpecBuilder.setVbsEnabled(form.vbsEnabled);

               if (form.isSelectedOtherOs()) {
                  virtualMachineSpecBuilder.setGosName(form.gosName);
               } else {
                  virtualMachineSpecBuilder.setGosName(null);
               }

               return {
                  wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                  invalidateNextPages: false
               };
            }
         };

         function isVbsFeatureFlagEnabled() {
            return (featureFlagsService.hardwareV14_vbsEnabled && featureFlagsService.hardwareV14_vbsEnabled());
         }

         function setVersionOptions(gosFamily) {
            var gosVersionOptions = [];
            _.each(gosDescriptor, function(gos) {
               if (addNewVersionOptions(gos, gosFamily)) {
                  gosVersionOptions.push({
                     id: gos.id,
                     name: gos.fullName,
                     supportLevelMessage: $sce.trustAsHtml(
                           i18nService.getString(
                                 'VmUi', 'GOSConfigBase.support_level.' + gos.supportLevel)),
                     vbsSupported: gos.vbsSupported
                  });
               }
            });


            // when guest os version is selected and user goes to the next page, and then
            // he goes back to the Guest OS family page and changes the Guest OS family,
            // the submitted (previously selected) guest os version is not valid anymore
            var submittedGosVersion;
            if (!virtualMachineSpecBuilder.getRecreateVm()) {
               submittedGosVersion = virtualMachineSpecBuilder.getGosVersion();
            }

            if (submittedGosVersion) {
               var isSubmittedGosVersionValid = _.some(gosVersionOptions, function(gosVersion) {
                  return gosVersion.id === submittedGosVersion.id;
               });

               if (!isSubmittedGosVersionValid) {
                  submittedGosVersion = null;
               }
            }

            // we should also check if the form.gosVersion option is valid, because it
            // might happen that when user changes the hw version on the previous page to
            // some lower version, that the current guest OS version preserved in
            // form.gosVersion does not support it, hence become invalid
            var formGosVersion = form.gosVersion;
            if (formGosVersion) {
               var gosVersionFromList = _.find(gosVersionOptions, function(gosVersion) {
                  return gosVersion.id === formGosVersion.id;
               });

               if (gosVersionFromList) {
                  formGosVersion = gosVersionFromList;
               } else {
                  formGosVersion = null;
               }
            }

            var selectedGosVersion = formGosVersion || submittedGosVersion;

            var defaultGosVersion = gosDefault ? _.find(gosVersionOptions, function(gos) {
               if (gos.id !== gosDefault.id) {
                  return false;
               }

               if (!gos.vbsSupported && !gosDefault.vbsSupported) {
                  return true;
               }

               return (gos.vbsSupported && gosDefault.vbsSupported) &&
                     (gos.vbsSupported.supported === gosDefault.vbsSupported.supported);
            }) : null;

            form.gosVersionOptions = gosVersionOptions;
            form.gosVersion = selectedGosVersion || defaultGosVersion || form.gosVersionOptions[0];
         }

         function initiateGosFromScheduledTask(gosDescriptor) {
            var guestId = virtualMachineSpecBuilder.getScheduledGuestOsId();
            var descriptorIndex = null;
            if (guestId) {
               _.each(gosDescriptor, function(descriptor, index) {
                  if (descriptor.id === guestId) {
                     descriptorIndex = index;
                     return;
                  }
               });
               virtualMachineSpecBuilder.setScheduledGuestOsId(null);
               if (descriptorIndex !== null) {
                  if (gosDescriptor[descriptorIndex].family === gosFamilyConstants.WINDOWS) {
                     form.gosFamily = form.gosFamilyOptions[0];
                  } else {
                     if (gosDescriptor[descriptorIndex].family === gosFamilyConstants.LINUX) {
                        form.gosFamily = form.gosFamilyOptions[1];
                     } else {
                        form.gosFamily = form.gosFamilyOptions[2];
                     }
                  }

                  if (virtualMachineSpecBuilder.getScheduledGuestName()) {
                     form.gosName = virtualMachineSpecBuilder.getScheduledGuestName();
                  }
               }
            }

            return descriptorIndex;
         }

         function addNewVersionOptions(gos, family) {
            return ((gos.family === gosFamilyConstants.WINDOWS)
                        ? family.id === gosFamilyConstants.WINDOWS
                        : ((gos.family === gosFamilyConstants.LINUX)
                              ? family.id === gosFamilyConstants.LINUX
                              : family.id === gosFamilyConstants.OTHER)) || family.id === gos.family;
         }

         function getVmVersionDescription() {
            var vmVersion = virtualMachineSpecBuilder.getVmVersion();
            var longText = vmHardwareVersionService.getLongText(vmVersion);
            return i18nService.getString('VmUi', 'VmHardware.HWVersion.vmVersionLabel', longText);
         }

         function familyObject(id) {
            return {
               id: id,
               name: i18nService.getString('VmUi', 'GeneralOptions.gos_family.' + id)
            };
         }
      };
   }
})();

angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningGuestOsPageService', [
   'i18nService',
   'vuiConstants',
   'wizardPageService',
   'vmVuiWizardPageBuilder',
   'VmProvisioningGuestOsPageModel',
   function(
      i18nService,
      vuiConstants,
      wizardPageService,
      vmVuiWizardPageBuilder,
      VmProvisioningGuestOsPageModel) {
      return {
         build: function(wizardScope) {
            var guestOsPageModel = VmProvisioningGuestOsPageModel(wizardScope.vmParams);
            wizardScope.guestOsPageModel = guestOsPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectGuestOsProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectGuestOsProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningGuestOs.html',
               model: guestOsPageModel
            });
         }
      };
   }
]);

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service(
         'VmProvisioningNameAndFolderPageModel', VmProvisioningNameAndFolderPageModel);

   VmProvisioningNameAndFolderPageModel.$inject = [
      'nameAndFolderValidatorService',
      'defaultUriSchemeUtil',
      'i18nService',
      '$q',
      'creationTypeConstants',
      'managedEntityConstants',
      'authorizationService',
      'wizardPageService',
      'vmTypeConstants',
      '$http',
      '$templateCache',
      'vcService'
   ];

   function VmProvisioningNameAndFolderPageModel(nameAndFolderValidatorService,
         defaultUriSchemeUtil, i18nService, $q, creationTypeConstants,
         managedEntityConstants, authorizationService, wizardPageService,
         vmTypeConstants, $http, $templateCache, vcService) {

      return function(wizardScope, virtualMachineSpecBuilder, defaultTargetId) {
         var form = {
            selectedTarget: {},
            hasEncryptNewVmPrivilege: false,
            hasManageEncryptionPolicyPrivilege: false
         };
         var hasActionPrivileges;
         var isDeployVmtxAllowed;
         var requiredPrivileges;
         var VM_NAME_MAX_LENGTH = 80;
         var previousCreationType = "";
         return {
            form: form,

            resetForm: function() {
               var submittedName = virtualMachineSpecBuilder.getName();
               var suggestedName = submittedName || form.newVmName;

               if (suggestedName) {
                  form.newVmName = suggestedName;
               } else if (virtualMachineSpecBuilder.getCreationType() ===
                     creationTypeConstants.CREATE_FROM_SCRATCH) {
                  form.newVmName = i18nService.getString(
                        'VmUi', 'SelectNameFolderProvisioningPage.defaultNewVmName');
               } else {
                  form.newVmName = '';
               }
            },

            getTreeType: function() {
               var creationType = virtualMachineSpecBuilder.getCreationType();
               var isRegisterVm = creationTypeConstants.isRegisterVm(creationType);
               var treeType = isRegisterVm ? 'VmFoldersTreeFromDatacenter' : 'VmFoldersTree';
               return treeType;
            },

            getTreeRoot: function() {
               var creationType = virtualMachineSpecBuilder.getCreationType();
               var isRegisterVm = creationTypeConstants.isRegisterVm(creationType);
               var isDeployFromTemplate = creationTypeConstants.isDeployVmFromTemplate(creationType);

               if (isRegisterVm) {
                  // in register keys the defaultTargetId might be a VM folder
                  // and it should not be used as a root for the tree, so in this case use
                  // the datacenter id
                  return wizardScope.wizardViewData.getDatacenterId();
               } else if(isDeployFromTemplate) {
                  return wizardScope.wizardViewData.getVCenterId();
               }

               return null;
            },

            targetIdToPreselect: function() {
               var submittedTarget = virtualMachineSpecBuilder.getTargetInformation();
               var submittedTargetId = submittedTarget ? submittedTarget.targetUid : null;

               var formTarget = form.selectedTarget;
               var formTargetId = formTarget ? formTarget.uid : null;

               // preselect target in the tree by priority
               // first if there is already a selection in the tree use that
               // second use the selection that was last saved when the page was submitted
               var suggestedTargetId = formTargetId || submittedTargetId;

               var creationType = virtualMachineSpecBuilder.getCreationType();
               if (creationType !== previousCreationType) {
                  previousCreationType = creationType;
                  // if the user has changed the workflow, from create new vm wizard
                  // do not consider the submitted or previously selected folder in three for preselection
                  // instead use the one from which the wizard is started or the recommended one
                  suggestedTargetId = undefined;
               }
               var recommendedTarget = getRecommendedFolder(creationType, wizardScope.wizardViewData);

               // preselect target in the tree by priority
               // first if there is already a selection in the tree use that
               // second use the selection that was last saved when the page was submitted
               // third the target provided to the page
               // fourth the recommended target from the backend
               suggestedTargetId = suggestedTargetId || defaultTargetId || recommendedTarget;

               return suggestedTargetId;
            },

            pageInstructions: function() {
               switch (virtualMachineSpecBuilder.getCreationType()) {
                  case creationTypeConstants.CREATE_FROM_SCRATCH:
                  case creationTypeConstants.CLONE_VM_TO_VM:
                  case creationTypeConstants.CLONE_TEMPLATE_TO_VM:
                  case creationTypeConstants.DEPLOY_VM_FROM_VAPP:
                  case creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE:
                  case creationTypeConstants.DEPLOY_VM_FROM_OVF:
                     return {
                        nameCallToAction: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.vmName'),
                        locationCallToAction: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.instructionLocation.vm')
                     };
                  case creationTypeConstants.REGISTER_VM:
                     var isTemplate = virtualMachineSpecBuilder.getRegisterVmData().isTemplate;
                     return {
                        nameCallToAction: isTemplate ?
                              i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.templateName') :
                              i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.vmName'),
                        locationCallToAction: isTemplate ?
                              i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.instructionLocation.template') :
                              i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.instructionLocation.vm')
                     };
                  case creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE:
                  case creationTypeConstants.CLONE_VM_TO_TEMPLATE:
                     return {
                        nameCallToAction: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.templateName'),
                        locationCallToAction: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.instructionLocation.template')
                     };
                  default:
                     break;
               }
            },

            pageFinishedLoading: function() {
               // TODO this should be decoupled from business logic
               // but for now it is a viable way to determine when all of the page has loaded
               return !!(form.selectedTarget && form.selectedTarget.type);
            },

            validateSelection: function() {
               wizardPageService.clearErrors(wizardScope.config);
               var target = form.selectedTarget;
               var compatibilityMessage = null;

               var creationType = virtualMachineSpecBuilder.getCreationType();
               var isXvc = checkIsXvc(virtualMachineSpecBuilder.getVmId(), target.uid);

               if (creationTypeConstants.isCloning(creationType)) {
                  requiredPrivileges = isXvc ? [h5_vm.Privileges.VM_INVENTORY_REGISTER]
                        : [h5_vm.Privileges.VM_INVENTORY_CREATE_FROM_EXISTING];
               } else if (creationTypeConstants.isRegisterVm(creationType)) {
                  requiredPrivileges = [h5_vm.Privileges.VM_INVENTORY_REGISTER];
               } else {
                  requiredPrivileges = [h5_vm.Privileges.VM_INVENTORY_CREATE];
               }
               requiredPrivileges.push(h5_vm.Privileges.CRYPTOGRAPHER_ENCRYPT_NEW_VM);
               requiredPrivileges.push(h5_vm.Privileges.CRYPTOGRAPHER_MANAGE_ENCRYPTION_POLICY);

               if (creationType === creationTypeConstants.DEPLOY_VM_FROM_VAPP) {
                  requiredPrivileges.push(h5_vm.Privileges.VAPP_IMPORT);
               }

               return authorizationService.checkGrantedPrivileges(target.uid, requiredPrivileges)
                     .then(function(hasPrivileges) {
                        form.hasEncryptNewVmPrivilege = hasPrivileges[1];
                        form.hasManageEncryptionPolicyPrivilege = hasPrivileges[2];

                        compatibilityMessage = makeCompatibilityMessage(
                              hasPrivileges[0], target, requiredPrivileges[0]);

                        if (creationType === creationTypeConstants.DEPLOY_VM_FROM_VAPP) {
                           var hasVappImportPrivilege = hasPrivileges[3];

                           if (hasVappImportPrivilege === false) {
                              compatibilityMessage = makeCompatibilityMessage(false, target, h5_vm.Privileges.VAPP_IMPORT);
                           }
                        }

                        if(compatibilityMessage) {
                           return compatibilityMessage;
                        } else {
                           return getIsVmtxFeatureSupportedPromise(
                                 virtualMachineSpecBuilder.getCreationType(), target.uid);
                        }
                     })
                     .then(function (isVmtxFeatureSupportedForDcOrFolder) {
                        //Additional check to avoid deploying vmtx into pre-6.7U1 VCs.
                        if (compatibilityMessage) {
                           return compatibilityMessage;
                        }
                        if (!isVmtxFeatureSupportedForDcOrFolder) {
                           isDeployVmtxAllowed = false;
                           return i18nService.getString('LibraryUi', 'error.vmtx.unsupported.datacenterfolder');
                        }
                        return null;
                     });
            },

            validatePage: function() {
               var vmNameErrorMessage = checkVmName(true);
               if (vmNameErrorMessage) {
                  return $q.resolve({
                     error: vmNameErrorMessage
                  });
               }

               var suffix = getVmOrTemplate();

               if (!form.selectedTarget.uid || isRootFolder(form.selectedTarget.uid) || !hasActionPrivileges || !isDeployVmtxAllowed) {
                  return $q.resolve({
                     error: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.specifyValidDestination.' + suffix)
                  });
               }

               var validationPromise = nameAndFolderValidatorService
                     .validateNameAndGetLocationUids(form.newVmName, form.selectedTarget)
                     .then(function(result) {
                        if (!result.validName) {
                           return { error: result.validationMessage };
                        } else if (!result.isVmFolder) {
                           return {
                              error: i18nService.getString('VmUi',
                                    'SelectNameFolderProvisioningPage.specifyValidDestination.' + suffix)
                           };
                        } else {
                           return {
                              folderUid: result.folderUid,
                              datacenterUid: result.datacenterUid
                           };
                        }
                     });

               $http.get('vm-ui/resources/vm/views/createVmWizard/vmProvisioningComputeResource.html',
                     { cache: $templateCache });
               $http.get('common-module-ui/resources/common-module/views/compatibility/vxCompatibilityView.html',
                     { cache: $templateCache });

               return validationPromise;
            },

            submitPage: function(validationResult) {
               virtualMachineSpecBuilder.setName(form.newVmName);
               virtualMachineSpecBuilder
                  .setHasEncryptNewVmPrivilege(form.hasEncryptNewVmPrivilege);
               virtualMachineSpecBuilder
                  .setHasManageEncryptionPolicyPrivilege(form.hasManageEncryptionPolicyPrivilege);
               var invalidateNextPages = false;

               //if the user has already visited this page
               //get the previously selected datacenter
               //if it is not the same as the current invalidate the next pages
               var previousTargetInformation =
                     virtualMachineSpecBuilder.getTargetInformation();
               if (previousTargetInformation && previousTargetInformation.datacenterUid
                     && previousTargetInformation.datacenterUid !== validationResult.datacenterUid) {
                  invalidateNextPages = true;
               }

               virtualMachineSpecBuilder.setTargetInformation(
                     form.selectedTarget.uid,
                     validationResult.datacenterUid,
                     validationResult.folderUid,
                     form.selectedTarget.name
               );

               return {
                  wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                  invalidateNextPages: invalidateNextPages
               };
            },

            checkVmName: checkVmName
         };

         function checkVmName(isSpecificMessage) {
            if (!form.newVmName) {
               return i18nService.getString('VmUi',
                     'SelectNameFolderProvisioningPage.specifyValidName' +
                     (isSpecificMessage ? ('.' + getVmOrTemplate()) : ''));
            }

            if (!checkVmNameLength(form.newVmName)) {
               return i18nService.getString('VmUi',
                     'NameValidator.nameTooLongSpecialChars');
            }

            return '';
         }

         function getVmOrTemplate() {
            var creationType = virtualMachineSpecBuilder.getCreationType();
            var isCreatingTemplate;

            if (creationTypeConstants.isRegisterVm(creationType)) {
               isCreatingTemplate = virtualMachineSpecBuilder.getRegisterVmData().isTemplate;
            } else {
               isCreatingTemplate = creationTypeConstants.isCloningToATemplate(creationType);
            }
            return isCreatingTemplate
                  ? vmTypeConstants.TEMPLATE
                  : vmTypeConstants.VIRTUAL_MACHINE;
         }

         function isRootFolder(objectId) {
            var location = defaultUriSchemeUtil.getPartsFromVsphereObjectId(objectId);
            return (location.type === 'Folder' && location.value === 'group-d1');
         }

         function makeCompatibilityMessage(privilegeStatus, target, privilege) {
            hasActionPrivileges = privilegeStatus;
            if (privilegeStatus) {
               return null;
            }

            var targetType = defaultUriSchemeUtil.getEntityType(target.uid);
            var messageText = createNoPrivilegesErrorString(targetType, privilege);
            return messageText;
         }

         function createNoPrivilegesErrorString(targetType, privilege) {
            var msg = ['SelectNameFolderProvisioningPage.No'];
            switch (privilege) {
               case h5_vm.Privileges.VM_INVENTORY_CREATE_FROM_EXISTING:
                  msg.push('CreateFromExistingPrivilege');
                  break;
               case h5_vm.Privileges.VM_INVENTORY_REGISTER:
                  msg.push('RegisterVmPrivilege');
                  break;
               case h5_vm.Privileges.VAPP_IMPORT:
                  msg.push('CreateNewVappPrivilege');
                  break;
               default:
                  msg.push('CreateNewPrivilege');
                  break;
            }

            if (targetType === managedEntityConstants.DATACENTER) {
               msg.push('OnDatacenter');
            } else if (targetType === managedEntityConstants.FOLDER) {
               msg.push('OnFolder');
            }

            return i18nService.getString('VmUi', msg.join(''));
         }

         function checkVmNameLength(name) {
            return convertVmName(name).length <= VM_NAME_MAX_LENGTH;
         }

         function convertVmName(name) {
            return name.replace(/%/g, '%25').replace(/\//g, '%2f').replace(/\\/g, '%2c');
         }

         function checkIsXvc(sourceVmId, targetId) {
            if (!sourceVmId || !targetId) {
               return false;
            }

            var sourceVmSeverGuid = defaultUriSchemeUtil
                  .getPartsFromVsphereObjectId(sourceVmId).serverGuid;
            var targetSeverGuid = defaultUriSchemeUtil
                  .getPartsFromVsphereObjectId(targetId).serverGuid;
            return sourceVmSeverGuid !== targetSeverGuid;
         }

         function getRecommendedFolder(creationType, wizardViewData) {
            var recommendedPreselections = wizardViewData.getRecommendedFolderAndComputeResource();
            if (!recommendedPreselections) {
               return;
            }

            if ((creationType === creationTypeConstants.CREATE_FROM_SCRATCH ||
                  creationType === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE ) &&
                  recommendedPreselections.createWorkflow) {
               return recommendedPreselections.createWorkflow.folderId;
            }

            if ((creationType === creationTypeConstants.CLONE_VM_TO_TEMPLATE ||
                  creationType === creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE) &&
                  recommendedPreselections.templateWorkflow) {
               return recommendedPreselections.templateWorkflow.folderId;
            }

            if (creationTypeConstants.isCloning(creationType) && recommendedPreselections.cloneWorkflow) {
               return recommendedPreselections.cloneWorkflow.folderId;
            }

            return recommendedPreselections.defaultFolderId;
         }

         function getIsVmtxFeatureSupportedPromise(creationType, objectId) {
            isDeployVmtxAllowed = true;
            if (creationType !== creationTypeConstants.DEPLOY_VM_FROM_VMTX || !objectId) {
               return $q.when(true);
            }
            var serverGuid = defaultUriSchemeUtil.getPartsFromVsphereObjectId(objectId).serverGuid;
            return vcService.is671VcOrLaterByGuid(serverGuid);
         }
      };
   }
}());

angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningNameAndFolderPageService', [
   'i18nService',
   'dataService',
   '$q',
   'defaultUriSchemeUtil',
   'wizardPageService',
   'VmProvisioningNameAndFolderPageModel',
   'vmVuiWizardPageBuilder',
   function (i18nService,
             dataService,
             $q,
             defaultUriSchemeUtil,
             wizardPageService,
             VmProvisioningNameAndFolderPageModel,
             vmVuiWizardPageBuilder
   ) {
      return {
         build: function (wizardScope, defaultTarget) {
            var nameAndFolderPageModel = new VmProvisioningNameAndFolderPageModel(wizardScope, wizardScope.vmParams, defaultTarget);
            wizardScope.nameAndFolderPageModel = nameAndFolderPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectNameFolderProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningNameAndFolder.html',
               model: nameAndFolderPageModel
            });
         }
      };
   }]);

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
      .service('VmProvisioningNetworkPageModel', VmProvisioningNetworkPageModel);

   VmProvisioningNetworkPageModel.$inject = [
      'mutationService',
      'dataService',
      'defaultUriSchemeUtil',
      'i18nService',
      'wizardPageService'
   ];

   function VmProvisioningNetworkPageModel(
         mutationService,
         dataService,
         defaultUriSchemeUtil,
         i18nService,
         wizardPageService) {

      var NETWORK_VALIDATION_SPEC_NAME = 'com.vmware.vsphere.client.provisioning.spec.NetworkConfigValidationSpec';
      var NETWORK_MAPPINGS_VALIDATION_SPEC_NAME = 'com.vmware.vsphere.client.provisioning.spec.NetworkMappingsValidationSpec';
      var NETWORK_MAPPINGS_SPEC_NAME = 'com.vmware.vsphere.client.provisioning.spec.NetworkMappingsSpec';
      var NETWORK_MAPPING_SPEC_NAME = "com.vmware.vsphere.client.provisioning.spec.NetworkMapping";
      var IP_ALLOCATION_VALIDATION_SPEC_NAME = 'com.vmware.vsphere.client.provisioning.spec.IpAllocationValidationSpec';

      var networkMappingsForNetworkParams;

      return function (wizardViewData, virtualMachineSpecBuilder, wizardConfig) {

         return {
            getNetworkMappingParams: function () {
               var commonContext = wizardViewData.getDeployFromLibraryCommonContext();
               getNetworkMappings(commonContext).then(function (result) {
                  if (result.networkMappingsForNetworkParams) {
                     networkMappingsForNetworkParams = result.networkMappingsForNetworkParams.networkMappings;
                  }
               });
               return getNetworkMappingParams(commonContext);
            },
            getIpAllocationParams: function () {
               var commonContext = wizardViewData.getDeployFromLibraryCommonContext();
               return getIpAllocationParams(commonContext);
            },
            validatePage: function () {
               wizardPageService.clearErrors(wizardConfig);
               wizardPageService.showLoadingIndicator(wizardConfig);
               var commonContext = wizardViewData.getDeployFromLibraryCommonContext();
               var networkConfigValidationSpec = buildNetworkConfigValidationSpec(commonContext);

               return mutationService.validate(virtualMachineSpecBuilder.getComputeResourceId(),
                     NETWORK_VALIDATION_SPEC_NAME,
                     networkConfigValidationSpec).then(function (result) {

                  wizardPageService.hideLoadingIndicator(wizardConfig);
                  if (result.error) {
                     var errorMessage = getIpPoolValidationErrorMessage(commonContext);
                     if (errorMessage) {
                        result.error = errorMessage;
                     }
                     return result;
                  }
               });
            },
            submitPage: function () {
               return {
                  invalidateNextPages: false,
                  wizardFlow: virtualMachineSpecBuilder.getCreationType()
               };
            }
         };

         function getNetworkMappingParams(commonContext) {
            if (commonContext) {
               var networkMappingParams = _.find(commonContext, function (item) {
                  return item._type === 'com.vmware.vcenter.ovf.NetworkMappingParams';
               });
               return networkMappingParams;
            }
         }

         function getIpAllocationParams(commonContext) {
            if (commonContext) {
               var ipAllocationParams = _.find(commonContext, function (item) {
                  return item._type === "com.vmware.vcenter.ovf.IpAllocationParams";
               });
               return ipAllocationParams;
            }
         }

         function buildNetworkConfigValidationSpec(commonContext) {
            return {
               _type: NETWORK_VALIDATION_SPEC_NAME,
               networkMappingsValidationSpec: buildNetworkMappingsValidationSpec(commonContext),
               ipAllocationValidationSpec: buildIpAllocationValidationSpec(commonContext)
            };
         }

         function buildNetworkMappingsValidationSpec(commonContext) {
            return {
               _type: NETWORK_MAPPINGS_VALIDATION_SPEC_NAME,
               commonContext: commonContext,
               mappingSpec: {
                  _type: NETWORK_MAPPINGS_SPEC_NAME,
                  networkMappings: buildNetworkMappingParams(commonContext)
               }
            };
         }

         function buildNetworkMappingParams(commonContext) {
            var sourceNetworks = getNetworkMappingParams(commonContext).sourceNetworks;
            return _.map(sourceNetworks, function (sourceNetwork) {
               var targetNetworkRef;
               var targetNetwork = findTargetNewtorkForUri(sourceNetwork.target);
               if (targetNetwork){
                  targetNetworkRef = targetNetwork.targetNetworkRef;
               }
               return {
                  _type: NETWORK_MAPPING_SPEC_NAME,
                  sourceNetworkName: sourceNetwork.name,
                  sourceNetworkDescription: sourceNetwork.description,
                  targetNetworkUri: sourceNetwork.target,
                  targetNetworkRef: targetNetworkRef
               };
            });
         }

         function buildIpAllocationValidationSpec(commonContext) {
            return {
               _type: IP_ALLOCATION_VALIDATION_SPEC_NAME,
               commonContext: commonContext,
               ovfIpAllocationParams: getIpAllocationParams(commonContext)
            };
         }

         function getNetworkMappings(commonContext) {
            var provisioningUri = defaultUriSchemeUtil.createUri(
                  "com.vmware.vsphere.client.provisioning.Context", "root");
            return dataService.getProperties(provisioningUri, ['networkMappingsForNetworkParams'],
                  {
                     propertyParams: [{
                        propertyName: 'networkMappingsForNetworkParams',
                        parameterType: 'com.vmware.vcenter.ovf.NetworkMappingParams',
                        parameter: getNetworkMappingParams(commonContext)
                     }]
                  });
         }

         function findTargetNewtorkForUri(uri) {
            return _.find(networkMappingsForNetworkParams, function (item) {
               return (item.targetNetworkUri === uri);
            });
         }

         function getIpPoolValidationErrorMessage(commonContext) {
            var ipAllocationParams = getIpAllocationParams(commonContext);
            if(ipAllocationParams) {
               if (ipAllocationParams.ipProtocol.name === 'IPV4') {
                  return i18nService.getString('ProvisioningUiLib', 'IpAllocationControl.noIpv4RangeWarning');
               } else {
                  return i18nService.getString('ProvisioningUiLib', 'IpAllocationControl.noIpv6RangeWarning');
               }
            }
         }
      };
   }
}());

angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningNetworkPageService', [
   'i18nService',
   'vuiConstants',
   'VmProvisioningNetworkPageModel',
   'vmVuiWizardPageBuilder',
   function (i18nService, vuiConstants, VmProvisioningNetworkPageModel, vmVuiWizardPageBuilder) {
      return {
         build: function (wizardScope) {

            var networkPageModel = new VmProvisioningNetworkPageModel(
                  wizardScope.wizardViewData,
                  wizardScope.vmParams,
                  wizardScope.config
            );
            wizardScope.networkPageModel = networkPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('ProvisioningUiLib', 'SelectNetworksPage.title'),
               description: i18nService.getString('ProvisioningUiLib', 'SelectNetworksPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningNetworkPage.html',
               model: networkPageModel,
               defaultState: vuiConstants.wizard.pageState.SKIPPED
            });
         }
      };
   }
]);

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .factory('vmProvisioningProductDetailsDataModel', vmProvisioningProductDetailsDataModel);

   vmProvisioningProductDetailsDataModel.$inject = [
      'i18nService',
      'fileSaverService',
      'browserLanguage'
   ];

   function vmProvisioningProductDetailsDataModel (i18nService, fileSaverService, browserLanguage) {
      /*jshint validthis:true */
      var self = this,
         MB = 1024 * 1024,//GB
         GB = 1024 * MB,
         TB = 1024 * GB;
      return {
         /** Certificate Params */
         initProductDetails: initProductDetails,
         onCertClicked: onCertClicked,
         getPublisher: getPublisher,
         getCertTrust: getCertTrust,
         hasCert: hasCert,
         /** Size Params */
         getDownloadSize: getDownloadSize,
         getSizeOnDiskThick: getSizeOnDiskThick,
         getSizeOnDiskThin: getSizeOnDiskThin,
         getSizeOnDisk: getSizeOnDisk,
         /** Product Details Params */
         getProductName: getProductName,
         getVersion: getVersion,
         hasProduct: hasProduct,
         getProductUri: getProductUri,
         getVendor : getVendor,
         getVendorUri: getVendorUri,
         getDescription: getDescription,
         hasVendor: hasVendor,
         hasVersion: hasVersion,
         hasVendorUri: hasVendorUri,
         hasProductUri: hasProductUri,
         hasDescription: hasDescription,
         updateVmNameToDeploy: updateVmNameToDeploy,
         getExtraConfigs: getExtraConfigs
      };

      /** Cert Params*/
      function onCertClicked() {
         if (!self.isCertPresent ||
               _.isEmpty(self.x509) ||
               _.isEmpty(self.subject)) {
            return;
         }
         //saves the file to the specified location as subject.cer file
         fileSaverService.save(self.x509, self.issuer + ".cer");
      }

      function hasCert() {
         return self.isCertPresent;
      }

      function getPublisher() {
         return self.issuer;
      }

      function getCertTrust() {
         return !self.isCertPresent ?
               i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.publisher.nocert') :
               (!self.isCertValid ?
                  i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.publisher.invalid') :
                  (self.isSelfSigned ?
                     i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.publisher.untrusted'):
                     i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.publisher.trusted')));
      }


      /** Product Details Params*/
      function hasVendorUri() {
         return !_.isEmpty(self.vendorUri);
      }

      function hasProductUri() {
         return !_.isEmpty(self.productUri);
      }

      function hasVersion() {
         return !_.isEmpty(self.version) || !_.isEmpty(self.fullVersion);
      }

      function hasVendor() {
         return !_.isEmpty(getVendor());
      }

      function hasProduct() {
         return !_.isEmpty(getProductName());
      }

      function hasDescription() {
         return !_.isEmpty(getDescription());
      }

      function getProductName() {
         return self.productName;
      }

      function getVendor() {
         return self.vendor;
      }

      function getVersion() {
         return self.version ||  self.fullVersion;
      }

      function getVendorUri() {
         return self.vendorUri;
      }

      function getProductUri() {
         return self.productUri;
      }

      function getDescription() {
         return self.description;
      }

      /** Size Params */
      function getDownloadSize() {
         return getSizeString(self.downloadSize);
      }

      function getSizeString(size) {
         if (!size || size === -1) {
            return i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.unknown');
         }

         if (size < MB) {
            return i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.lessThan1Mb');
         }

         if (size > TB) {
            return (size/TB).toLocaleString(browserLanguage.get(), { minimumFractionDigits:1, maximumFractionDigits:1 }) + ' TB';
         } else if (size > GB) {
            return (size/GB).toLocaleString(browserLanguage.get(), { minimumFractionDigits:1, maximumFractionDigits:1 }) + ' GB';
         } else {
            return (size/MB).toLocaleString(browserLanguage.get(), { minimumFractionDigits:1, maximumFractionDigits:1 }) + ' MB';
         }
      }

      function getSizeOnDiskThick() {
         var thickProvisioned = self.flatDeploymentSize;
         var thickProvString = getSizeString(thickProvisioned) + " " +
            i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.thickProvisionedString');

         return thickProvString;
      }

      function getSizeOnDiskThin() {
         var thinProvisioned = self.sparseDeploymentSize;
         var thinProvString = getSizeString(thinProvisioned) + " " +
            i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.thinProvisionedString');
         return thinProvString;
      }

      function getSizeOnDisk(isThinDeployment) {
         var deploymentSize = isThinDeployment ? self.sparseDeploymentSize : self.flatDeploymentSize;
         return getSizeString(deploymentSize);
      }

      function getExtraConfigs() {
         return self.extraConfigs;
      }

      function initProductDetails(commonContext) {
         resetData();
         _.each(commonContext, function(context) {
            if (context) {
               if (context._type === 'com.vmware.vcenter.ovf.NameAndProductParams') {
                  self.productName = context.productName;
                  self.version = context.version;
                  self.fullVersion = context.fullVersion;
                  self.vendor = context.vendor;
                  self.vApp = context.virtualApp;
                  self.productUri = context.productUrl;
                  self.vendorUri = context.vendorUrl;
                  self.description = context.annotation;
               } else if (context._type === 'com.vmware.vcenter.ovf.SizeParams') {
                  self.downloadSize = context.approximateDownloadSize;
                  self.flatDeploymentSize = context.approximateFlatDeploymentSize;
                  self.sparseDeploymentSize = context.approximateSparseDeploymentSize;
               } else if (context._type === 'com.vmware.vcenter.ovf.CertificateParams') {
                  self.isCertPresent = true;
                  self.isCertValid = context.isValid;
                  self.issuer = parseCertIssuerName(context.issuer);
                  self.isSelfSigned = context.isSelfSigned;
                  self.subject = context.subject;
                  self.x509 = context.x509;
               } else if (context._type === 'com.vmware.vcenter.ovf.ExtraConfigParams') {
                  self.extraConfigs = context.extraConfigs;
               }
            }
         });
      }

      function updateVmNameToDeploy(vmName, commonContext) {
         var contextNameAndProduct = _.find(commonContext, function(context) {
            return context && context._type === 'com.vmware.vcenter.ovf.NameAndProductParams';
         });

         if (contextNameAndProduct) {
            contextNameAndProduct.name = vmName;
         }
      }

      function resetData() {
         self.productName = null;
         self.version = null;
         self.fullVersion = null;
         self.vendor = null;
         self.vApp = null;
         self.vendorUri = null;
         self.productUrl = null;
         self.description = null;
         self.downloadSize = -1;
         self.flatDeploymentSize = -1;
         self.sparseDeploymentSize = -1;
         self.isCertPresent = false;
         self.isCertValid = false;
         self.isSelfSigned = false;
         self.issuer = null;
         self.subject = null;
         self.x509 = null;
      }

      function parseCertIssuerName(strCertIssuer) {
         if (_.isEmpty(strCertIssuer)) {
            return '';
         }
         var cn = null,
            o = null;
         var list = strCertIssuer.split('/');
         _.each (list, function(splitPart) {
            //get the CN or O and return
            if (!_.isEmpty(splitPart)) {
               var part = splitPart;
               if (part.toUpperCase().indexOf('CN=') === 0) {
                  cn = splitPart.substr(3);
               } else if (part.toUpperCase().indexOf('O=') === 0) {
                  o = splitPart.substr(2);
               }
            }
         });
         return cn || o;
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .service('vmProvisioningProductDetailsPageModel', vmProvisioningProductDetailsPageModel);

   vmProvisioningProductDetailsPageModel.$inject = [
      '$q'
   ];

   function vmProvisioningProductDetailsPageModel ($q) {
      return function(virtualMachineSpecBuilder) {
         var form = {
            isReady: false
         };
         var dataModel = {};
         return {
            form: form,
            dataModel: dataModel,
            validatePage: function() {
            },
            submitPage: function() {
               return {
                  invalidateNextPages: false,
                  wizardFlow: virtualMachineSpecBuilder.getCreationType()
               };
            },
            pageFinishedLoading: function() {
               return form.isReady;
            }
         };
      };
   }
})();

angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningProductDetailsPageService', [
   'i18nService',
   'wizardPageService',
   'vmVuiWizardPageBuilder',
   'vmProvisioningProductDetailsPageModel',
   function (i18nService, wizardPageService, vmVuiWizardPageBuilder, vmProvisioningProductDetailsPageModel) {
      return {
         build: function(wizardScope, defaultTarget, preselectedComputeResource) {
            var productDetailsPageModel = new vmProvisioningProductDetailsPageModel(
                  wizardScope.vmParams ,
                  wizardScope.wizardViewData,
                  wizardScope.config,
                  defaultTarget,
                  preselectedComputeResource);

            wizardScope.productDetailsPageModel = productDetailsPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config,  {
               title: i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.title'),
               description: i18nService.getString('ProvisioningUiLib', 'ProductDetailsPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/deployOvfPages/' +
                  'vmProvisioningProductDetails/vm-provisioning-product-details.html',
               model: productDetailsPageModel
            });
         }
      };
   }]);

var h5_vm;
(function (h5_vm) {
    var VmProvisioningScaleoutConfigurationPageModelFactory = (function () {
        function VmProvisioningScaleoutConfigurationPageModelFactory(i18nService) {
            return function (wizardViewData) {
                return new VmProvisioningScaleoutConfigurationPageModel(i18nService, wizardViewData);
            };
        }
        VmProvisioningScaleoutConfigurationPageModelFactory.$inject = [
            "i18nService"
        ];
        return VmProvisioningScaleoutConfigurationPageModelFactory;
    }());
    var VmProvisioningScaleoutConfigurationPageModel = (function () {
        function VmProvisioningScaleoutConfigurationPageModel(i18nService, wizardViewData) {
            this.i18nService = i18nService;
            this.wizardViewDataObj = wizardViewData;
        }
        Object.defineProperty(VmProvisioningScaleoutConfigurationPageModel.prototype, "wizardViewData", {
            get: function () {
                return this.wizardViewDataObj;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningScaleoutConfigurationPageModel.prototype.resetForm = function () {
        };
        ;
        VmProvisioningScaleoutConfigurationPageModel.prototype.validatePage = function () {
            var scaleoutConfiguration = this.wizardViewDataObj.getSclaeoutConfigurationFromLibraryCommonContext();
            var validationError = "";
            for (var _i = 0, _a = scaleoutConfiguration.groups; _i < _a.length; _i++) {
                var group = _a[_i];
                if (_.isUndefined(group.instanceCount) || _.isNull(group.instanceCount)) {
                    validationError = this
                        .i18nService
                        .getString("ProvisioningUiLib", "ScaleoutPage.validator.required");
                }
                else if (!_.isUndefined(group.minimumInstanceCount) && !_.isNull(group.minimumInstanceCount) &&
                    group.instanceCount < group.minimumInstanceCount) {
                    validationError = this
                        .i18nService
                        .getString("ProvisioningUiLib", "ScaleoutPage.validator.lessThanMinError");
                }
                else if (!_.isUndefined(group.maximumInstanceCount) && !_.isNull(group.maximumInstanceCount) &&
                    group.instanceCount > group.maximumInstanceCount) {
                    validationError = this
                        .i18nService
                        .getString("ProvisioningUiLib", "ScaleoutPage.validator.greaterThanMaxError");
                }
                if (validationError.length > 0) {
                    break;
                }
            }
            if (validationError.length > 0) {
                return {
                    error: validationError
                };
            }
            else {
                return {};
            }
        };
        ;
        VmProvisioningScaleoutConfigurationPageModel.prototype.submitPage = function (validationResult) {
            return {};
        };
        ;
        VmProvisioningScaleoutConfigurationPageModel.$inject = ["i18nService"];
        return VmProvisioningScaleoutConfigurationPageModel;
    }());
    h5_vm.VmProvisioningScaleoutConfigurationPageModel = VmProvisioningScaleoutConfigurationPageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningScaleoutConfigurationPageModel", VmProvisioningScaleoutConfigurationPageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningScaleoutConfigurationPageService = (function () {
        function VmProvisioningScaleoutConfigurationPageService(i18nService, vuiConstants, wizardPageService, vmVuiWizardPageBuilder, vmProvisioningScaleoutConfigurationPageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningScaleoutConfigurationPageModel = vmProvisioningScaleoutConfigurationPageModel;
        }
        VmProvisioningScaleoutConfigurationPageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource, preselectedStorage) {
            var pageModel = new this.vmProvisioningScaleoutConfigurationPageModel(wizardScope.wizardViewData);
            wizardScope.vmProvisioningScaleoutConfigurationPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "ScaleoutPage.title"),
                description: this.i18nService.getString("ProvisioningUiLib", "ScaleoutPage.description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages/vmProvisioningScaleoutConfiguration/" +
                    "vm-provisioning-scaleout-configuration-page.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
            });
        };
        ;
        VmProvisioningScaleoutConfigurationPageService.$inject = [
            "i18nService",
            "vuiConstants",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "vmProvisioningScaleoutConfigurationPageModel"
        ];
        return VmProvisioningScaleoutConfigurationPageService;
    }());
    h5_vm.VmProvisioningScaleoutConfigurationPageService = VmProvisioningScaleoutConfigurationPageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningScaleoutConfigurationPageService", VmProvisioningScaleoutConfigurationPageService);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm')
   .service('vmProvisioningSelectCreationTypePageService', ['i18nService','wizardPageService',
      function (i18nService, wizardPageService) {
      return {
         build: function (wizardScope, flowIds) {
            return {
               title: i18nService.getString('VmUi', 'SelectCreationTypeProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectCreationTypeProvisioningPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningSelectCreationType.html',
               decisionOptions: { flowIds: flowIds },
               onCommit: function () {
                  wizardPageService.markPageComplete(wizardScope.config, wizardScope.attributes.creationType);
                  return true;
               }
            };
         }
      };
   }]);

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .service('VmProvisioningSelectOvfPageModel', VmProvisioningSelectOvfPageModel);

   VmProvisioningSelectOvfPageModel.$inject = [
      '$q',
      'i18nService',
      'creationTypeConstants',
      'sourceTypeConstants',
      '$injector'
   ];

   function VmProvisioningSelectOvfPageModel ($q, i18nService, creationTypeConstants,
                                              sourceTypeConstants,
                                              $injector
   ) {
      return function(virtualMachineSpecBuilder, wizardViewData, wizardConfig, defaultTarget, preselectedComputeResource) {
         var form = {
            isValid: false,
            isLocalDeployment: false,
            userSelectedFiles: [],
            ovfUrl: null,
            vmName: null,
            hasAcceptedUntrustedSource: false
         };

         return {
            form: form,

            getContextObjId: function() {
               return wizardViewData.getSourceObjectId();
            },

            validatePage: function() {
               if (_.isEmpty(form.ovfUrl)) {
                  return false;
               }
               return true;
            },

            submitPage: function() {
               if (!form.isLocalDeployment) {
                  var fileName = parseTemplateNameFromUrl(form.ovfUrl);
                  var vmName = parseFileName(fileName);
                  virtualMachineSpecBuilder.setName(vmName);
                  virtualMachineSpecBuilder.setTemplateName(vmName);
                  wizardViewData.setUrlTemplate(form.ovfUrl);
                  wizardViewData.setTemplateSourceType(sourceTypeConstants.SOURCE_TYPE_PULL);
                  wizardViewData.setSslThumbprint(form.sslThumbprint);
               } else {
                  var workflowManager = $injector.get('vscOvfWorkflowProxyService');

                  var ovfWorkflowData = workflowManager.getNewSession(form.userSelectedFiles);

                  virtualMachineSpecBuilder.setName(ovfWorkflowData.templateName);
                  virtualMachineSpecBuilder.setTemplateName(ovfWorkflowData.templateName);

                  wizardViewData.setDeployOvfSession(ovfWorkflowData);
                  wizardViewData.setTemplateSourceType(sourceTypeConstants.SOURCE_TYPE_PUSH);
               }
               virtualMachineSpecBuilder.setCreationType(creationTypeConstants.DEPLOY_VM_FROM_OVF);

               return {
                  invalidateNextPages: false,
                  wizardFlow: virtualMachineSpecBuilder.getCreationType()
               };
            },

            pageFinishedLoading: function() {
               return form.isValid;
            }
         };

         function parseTemplateNameFromUrl(url) {
            if (_.isEmpty(url)) {
               return null;
            }
            var parser = url;
            if (!parser.toLowerCase().endsWith('.ovf') && !parser.toLowerCase().endsWith('.ova')) {
               return null;
            }
            return parser.split("/").pop();
         }

         function parseFileName(fileName) {
            if (!_.isEmpty(fileName)) {
               var ext = fileName.split('.').pop();
               if (ext && ext.length > 0) {
                  return fileName.substr(0, fileName.length - ext.length -1);
               }
            }
            return null;
         }
      };
   }
})();


angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningSelectOvfPageService', [
   'i18nService',
   'wizardPageService',
   'vmVuiWizardPageBuilder',
   'VmProvisioningSelectOvfPageModel',
   function (i18nService, wizardPageService, vmVuiWizardPageBuilder, VmProvisioningSelectOvfPageModel) {
      return {
         build: function(wizardScope, defaultTarget, preselectedComputeResource) {
            var deployOvfSelectPageModel = new VmProvisioningSelectOvfPageModel(
               wizardScope.vmParams,
               wizardScope.wizardViewData,
               wizardScope.config,
               defaultTarget,
               preselectedComputeResource
            );
            wizardScope.deployOvfSelectPageModel = deployOvfSelectPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectOvfProvisioningPage.Title'),
               description: i18nService.getString('VmUi', 'SelectOvfProvisioningPage.Description'),
               contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages/vmProvisioningSelectOvf/vm-provisioning-select-ovf-page.html",
               model: deployOvfSelectPageModel
            });
         }
      };
   }]);

(function(){
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningSelectVmToClonePageModel', VmProvisioningSelectVmToClonePageModel);

   VmProvisioningSelectVmToClonePageModel.$inject = [
      '$q',
      'i18nService',
      'defaultUriSchemeUtil',
      'dataService',
      'authorizationService',
      'creationTypeConstants',
      'managedEntityConstants',
   ];

   function VmProvisioningSelectVmToClonePageModel($q, i18nService, defaultUriSchemeUtil,
         dataService, authorizationService, creationTypeConstants, managedEntityConstants) {

      return function(virtualMachineSpecBuilder, wizardViewData, config) {
         var GUEST_ID_PROPERTY = 'config/guestId';
         var CONNECTION_STATE_PROPERTY = 'runtime/connectionState';

         var form = {};
         var hasActionPrivileges;
         var _wizardTitle;

         return {
            form: form,

            validateSelection: function() {
               var target = virtualMachineSpecBuilder.getVmId();
               var selectedType = defaultUriSchemeUtil.getPartsFromVsphereObjectId(target).type;
               var requiredPrivilege =
                  getRequiredPermission(virtualMachineSpecBuilder.getCreationType());

               if (selectedType === managedEntityConstants.VIRTUAL_MACHINE) {
                  return $q.all({
                     properties: dataService.getProperties(target, [CONNECTION_STATE_PROPERTY, GUEST_ID_PROPERTY]),
                     privileges: authorizationService.checkPrivileges(target,
                        [requiredPrivilege])
                  }).then(function(result) {
                     // Connection state
                     wizardViewData.setVmConnectedState(result.properties[CONNECTION_STATE_PROPERTY]);

                     virtualMachineSpecBuilder.setGuestOsId(result.properties[GUEST_ID_PROPERTY]);

                     if (result.properties[CONNECTION_STATE_PROPERTY] !== 'connected') {
                        return i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.InvalidState');
                     }

                     // Privileges
                     return makeCompatibilityMessage(result.privileges);
                  });
               } else {
                  return $q.resolve(null);
               }
            },

            validatePage: function() {
               if (defaultUriSchemeUtil.getPartsFromVsphereObjectId(virtualMachineSpecBuilder.getVmId()).type !== 'VirtualMachine') {
                  return $q.resolve({ error: i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.SelectValidEntity') });
               }

               if (wizardViewData.getVmConnectedState() !== 'connected') {
                  return $q.resolve({ error: i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.InvalidState') });
               }

               if (!hasActionPrivileges) {
                  return $q.resolve({ error: createNoPrivilegesErrorString(virtualMachineSpecBuilder.getCreationType()) });
               }
            },

            submitPage: function() {
               //change vm title
               if(!_wizardTitle || config.title.indexOf(_wizardTitle) === -1) {
                  _wizardTitle = config.title;
               }
               config.title = wizardViewData.getSourceObjectName() + ' - ' + _wizardTitle;
               return {
                  wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                  invalidateNextPages: false
               };
            }
         };

         function makeCompatibilityMessage(privilegeStatuses) {
            hasActionPrivileges = true;
            for (var i = 0; i < privilegeStatuses.length; i++) {
               if (!privilegeStatuses[i]) {
                  hasActionPrivileges = false;
                  break;
               }
            }

            if (hasActionPrivileges) {
               return null;
            }

            var messageText = createNoPrivilegesErrorString(virtualMachineSpecBuilder.getCreationType());
            return messageText;
         }

         function createNoPrivilegesErrorString(creationType) {
            var key = 'SelectTemplateProvisioningPage.Vm.NoPermission.' +
               getRequiredPermission(creationType);

            return i18nService.getString('VmUi', key);
         }

         function getRequiredPermission(creationType) {
            var suffix;
            if (creationType === creationTypeConstants.CLONE_VM_TO_TEMPLATE) {
               suffix = 'CreateTemplateFromVM';
            } else if (creationType === creationTypeConstants.CLONE_VM_TO_VM) {
               suffix = 'Clone';
            }

            return 'VirtualMachine.Provisioning.' + suffix;
         }
      };
   }
})();


angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningSelectVmToClonePageService',
   ['i18nService',
      'defaultUriSchemeUtil',
      'wizardPageService',
      'vmVuiWizardPageBuilder',
      'VmProvisioningSelectVmToClonePageModel',
      function(i18nService,
               defaultUriSchemeUtil,
               wizardPageService,
               vmVuiWizardPageBuilder,
               VmProvisioningSelectVmToClonePageModel) {
         return {
            build: function(wizardScope) {
               var selectVmToClonePageModel = new VmProvisioningSelectVmToClonePageModel(
                  wizardScope.vmParams,
                  wizardScope.wizardViewData,
                  wizardScope.config
               );
               wizardScope.selectVmToClonePageModel = selectVmToClonePageModel;

               return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                  title: i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.Title'),
                  description: i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.Description'),
                  contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningSelectVmToClone.html',
                  model: selectVmToClonePageModel
               });
            }
         };
      }]);

(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningSelectVmVersionPageModel', VmProvisioningSelectVmVersionPageModel);

   VmProvisioningSelectVmVersionPageModel.$inject =
         ['dataService', '$q', 'vcService', 'vmHardwareCompatibilityService','i18nService'];

   function VmProvisioningSelectVmVersionPageModel(
         dataService, $q, vcService, vmHardwareCompatibilityService,i18nService) {
      return function(virtualMachineSpecBuilder) {
         //this variable keeps the id of the last
         //compute resource for which we have retrieved
         //the optionDescriptorsWithCreateSupported data
         var _computeResourceId = null;

         var form = {
            invalidateNextPages: false,
            compatibility: function(vmVersion) {
               var gosVersion = this.vmParams.getGosVersion();
               if (vmVersion) {
                  form.vmVersion = vmVersion;
               }
               // If we have GOS selected, check to see if it's compatible with
               // the hardware version selected here and if not - invalidate the next wizard pages.
               if (gosVersion) {
                  this.setLoading(true);

                  virtualMachineSpecBuilder.queryConfigOptionByPool(form.vmVersion.id)
                        .then(function(res) {
                           var vmConfigOption = res.vmConfigOptionByPool;

                           var osDescriptor = vmConfigOption.guestOSDescriptor;
                           var selectedGuestOS = _.find(osDescriptor, function(osDescriptor) {
                              return osDescriptor.id === gosVersion.id;
                           });

                           this.invalidateNextPages = false;
                           if (!selectedGuestOS) {
                              this.invalidateNextPages = true;
                           }

                           this.setLoading(false);
                        }.bind(this));
               }
            }
         };

         return {
            form: form,

            resetForm: function() {
               var objectId = virtualMachineSpecBuilder.getComputeResourceId();
               var submittedVmVersion = virtualMachineSpecBuilder.getVmVersion();
               // we want to use the vm version from the scheduled data only once the
               // first time we visit the page, so we reset the data
               var scheduledVmVersion = virtualMachineSpecBuilder.getScheduledVmVersion();
               if (scheduledVmVersion) {
                  virtualMachineSpecBuilder.setScheduledVmVersion(null);
               }

               if (_computeResourceId !== objectId) {
                  submittedVmVersion = form.vmVersion = null;
                  virtualMachineSpecBuilder.setVmVersion(null);
               } else if (!_.isEmpty(form.supportedVersions)) {
                  preselectOption(submittedVmVersion, form.supportedVersions);
                  return $q.when();
               }
               var propName = 'optionDescriptorsWithCreateSupported';

               var targetInformation =
                     virtualMachineSpecBuilder.getTargetInformation();

               var promises = {
                  'optionDescriptorsData': dataService.getProperties(objectId, propName),
                  'is65VcOrLater': vcService.is65VcOrLater(targetInformation.datacenterUid)
               };

               return $q.all(promises).then(function(data) {
                  var optionDescriptorsData = data['optionDescriptorsData'];
                  form.is65VcOrLater = data['is65VcOrLater'];
                  _computeResourceId = objectId;
                  form.supportedVersions =
                        vmHardwareCompatibilityService.buildVmVersions(
                              optionDescriptorsData.optionDescriptorsWithCreateSupported,
                              form.is65VcOrLater
                        );
                  preselectOption(submittedVmVersion || scheduledVmVersion, form.supportedVersions,
                        optionDescriptorsData.optionDescriptorsWithCreateSupported);
                  form.compatibility(form.vmVersion);
               });
            },

            validatePage: function() {
               if (!form.vmVersion) {
                  return {
                     error: i18nService.getString("VmUi", "SelectVmVersionPage.pageValidationError"),
                     invalidateNextPages: false,
                     wizardFlow: virtualMachineSpecBuilder.getCreationType()
                  };
               }
               return null;
            },

            submitPage: function() {
               virtualMachineSpecBuilder.setVmVersion(form.vmVersion.id);

               // in case the vm version is changed from the one selected when the
               // scheduled task was created, do not use the data to pre-populate the customize hardware page
               const scheduledTaskData = virtualMachineSpecBuilder.getScheduledData();
               if (!_.isEmpty(scheduledTaskData)) {
                  if (scheduledTaskData.spec.version !== form.vmVersion.id) {
                     scheduledTaskData.useScheduledTaskData = false;
                  }
               }

               return {
                  wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                  invalidateNextPages: form.invalidateNextPages
               };
            }
         };

         function preselectOption(submittedHwVersion, options, supportedVersions) {
            // form.vmVersion is higher priority and it holds the version when user
            // change it in the page.
            var formVmVersion = form.vmVersion ?
                  form.vmVersion.id :
                  null;
            var suggestedHwVersion = formVmVersion || submittedHwVersion;
            form.vmVersion = null;
            if (suggestedHwVersion) {
               form.vmVersion = _.find(options, function(option) {
                  return option.id === suggestedHwVersion;
               });
            }
            // if this is the first time the page is loaded
            // or the selected version is no longer in the possible options
            // select the default version (defined in host/cluster/datacenter) or,
            // if none has been specified, the highest available version
            if (!form.vmVersion) {
               _.each(supportedVersions, function(version) {
                  if (version.defaultConfigOption) {
                     form.vmVersion = _.find(options, function(option) {
                        return (option.id === version.key);
                     });
                  }
               });
            }

            if (!form.vmVersion) {
               form.vmVersion = options[options.length - 1];
            }
         }
      };
   }
})();

angular
   .module('com.vmware.vsphere.client.vm')
   .service('vmProvisioningSelectVmVersionPageService', [
      'i18nService',
      'wizardPageService',
      'vmVuiWizardPageBuilder',
      'VmProvisioningSelectVmVersionPageModel',
   function (
      i18nService,
      wizardPageService,
      vmVuiWizardPageBuilder,
      VmProvisioningSelectVmVersionPageModel) {
      return {
         build: function (wizardScope) {
            var selectVmVersionPageModel = new VmProvisioningSelectVmVersionPageModel(
               wizardScope.vmParams,
               wizardScope.wizardViewData
            );
            wizardScope.selectVmVersionPageModel = selectVmVersionPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'SelectVmVersionPage.Title'),
               description: i18nService.getString('VmUi', 'SelectVmVersionPage.Description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningVmVersion.html',
               model: selectVmVersionPageModel
            });
         }
      };
   }
]);

(function(){
   'use strict';
   angular
         .module('com.vmware.vsphere.client.vm')
         .service('VmProvisioningUserSettingsPageModel', VmProvisioningUserSettingsPageModel);

   VmProvisioningUserSettingsPageModel.$inject = [
      '$q',
      'i18nService',
      'gosComputerNameValidationService',
      'nicValidatorService',
      'guestOsCustomizationSpecValidator',
      'creationTypeConstants',
      'defaultUriSchemeUtil'
   ];

   function VmProvisioningUserSettingsPageModel($q,
         i18nService,
         computerNameValidationService,
         nicValidatorService,
         guestOsCustomizationSpecValidator,
         creationTypeConstants,
         defaultUriSchemeUtil) {
      return function(virtualMachineSpecBuilder, wizardViewData) {
         var form = { nics: [] };
         var currentSpecName;
         var currentNicsToCustomize = [];

         return {
            form: form,

            resetForm: function() {
               var doResetForm = function () {
                  currentSpecName = wizardViewData.getCustomizationSpecName();
                  form.hasNicsToCustomize = false;

                  currentNicsToCustomize = angular.extend([],
                     wizardViewData.getNICsToCustomize());
                  form.nics = currentNicsToCustomize;
                  _.each(form.nics, function(nic) {
                     nic.expanded = false;
                     nic.ipv4.errors = {};
                     nic.ipv6.errors = {};
                     if (nic.ipv6.required) {
                        buildGridOptions(nic.ipv6);
                        form.hasNicsToCustomize = true;
                     }
                     if(nic.ipv4.required) {
                        form.hasNicsToCustomize = true;
                     }
                  }.bind(this));

                  if (wizardViewData.getNeedToInputComputerName()) {
                     form.computerName = {name: ''};
                  } else {
                     form.computerName = undefined;
                  }

                  var WINDOWS_MAX_NAME_LEN = 15;
                  var LINUX_MAX_NAME_LEN = 63;
                  var guestOsType = wizardViewData.getGuestOsType();

                  if (guestOsType === 'Windows') {
                     form.pcNameMaxLength = WINDOWS_MAX_NAME_LEN;
                  } else {
                     form.pcNameMaxLength = LINUX_MAX_NAME_LEN;
                  }
               };

               // Check if another spec was selected
               var isNewSpecSelected =
                  wizardViewData.getCustomizationSpecName() !== currentSpecName;

               if (isNewSpecSelected) {
                  // Spec is changed - reset the form
                  doResetForm();
                  return;
               }

               var vmId = virtualMachineSpecBuilder.getVmId();
               if (virtualMachineSpecBuilder.getCreationType() ===
                     creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE) {
                  // Constructing a dummy VM ID for deploy OVF templates. OVF templates
                  // do not have associated VM IDs. VM ID is necesary to get GOSC spec.
                  vmId = 'urn:vmomi:VirtualMachine:template:' +
                        defaultUriSchemeUtil
                              .getPartsFromVsphereObjectId(wizardViewData.getVCenterId())
                              .serverGuid;
               }

               // No new spec is selected but the spec properties may have changed
               guestOsCustomizationSpecValidator.validate(
                  vmId,
                  virtualMachineSpecBuilder.getName(),
                  wizardViewData.getCustomizationSpecName()
               ).then(function (result) {
                  wizardViewData.setCustomizationSpecName(result.specName);
                  wizardViewData.setNICsToCustomize(result.nicsToCustomize);
                  wizardViewData.setNeedToInputComputerName(result.needsComputerName);

                  // Check if the current spec's computer name type was changed
                  var isNeedToInputComputerName = !!form.computerName;
                  var isSpecChanged =
                     wizardViewData.getNeedToInputComputerName() !== isNeedToInputComputerName;

                  // Check if the current spec's NICs were changed
                  var nicsChanged = _.any(wizardViewData.getNICsToCustomize(), function(value, index) {
                     return value.ipv4.required !== currentNicsToCustomize[index].ipv4.required
                           || value.ipv6.required !== currentNicsToCustomize[index].ipv6.required;
                  });
                  isSpecChanged = isSpecChanged || nicsChanged;

                  if (isSpecChanged) {
                     doResetForm();
                  }
               });
            },

            validateComputerName: function() {
               var errors =
                  computerNameValidationService
                     .validateComputerName(form.pcNameMaxLength, form.computerName.name);
               form.computerName.invalid = false;
               if (!_.isEmpty(errors)) {
                  form.computerName.invalid = true;
                  form.computerName.error = errors[0];
               }
            },
            hasAlerts: hasAlerts,

            validatePage: function() {
               var needToInputComputerName = wizardViewData.getNeedToInputComputerName();

               var pageHasErrors = false;

               if (needToInputComputerName) {
                  this.validateComputerName();
                  pageHasErrors = form.computerName.invalid;
               }

               _.each(form.nics, function(nicForm) {
                  var validationResult = nicValidatorService.validate(nicForm);
                  nicForm.ipv4.errors.addressInvalid = validationResult.errors.ipv4.address;
                  nicForm.ipv4.errors.subnetMaskInvalid = validationResult.errors.ipv4.subnetMask;
                  nicForm.ipv4.errors.defaultGatewayInvalid = validationResult.errors.ipv4.defaultGateway;
                  nicForm.ipv4.errors.alternateGatewayInvalid = validationResult.errors.ipv4.alternateGateway;
                  nicForm.ipv6.errors.addressInvalid = validationResult.errors.ipv6.address;
                  nicForm.ipv6.errors.subnetPrefixLengthInvalid = validationResult.errors.ipv6.subnetPrefixLength;
                  hasAlerts(nicForm);
                  pageHasErrors = pageHasErrors || _.any(validationResult.errors, _.negate(_.isEmpty));
               });

               if (pageHasErrors) {
                  return $q.resolve({
                     error: i18nService.getString('VmUi', 'UserSettingsPage.validation_error')
                  });
               }

               return $q.resolve(null);
            },

            submitPage: function() {
               var needToInputComputerName = wizardViewData.getNeedToInputComputerName();

               if (needToInputComputerName) {
                  virtualMachineSpecBuilder.setCustomPcName(
                        form.computerName.name
                  );
               }

               _.each(form.nics, function(nic, index) {
                  if (nic.ipv4.required) {
                     virtualMachineSpecBuilder.setCustomIpv4ForNIC(index, nic);
                  }
                  if (nic.ipv6.required) {
                     virtualMachineSpecBuilder.setCustomIpv6ForNIC(index, nic);
                  }
               });

               return {
                  wizardFlow: virtualMachineSpecBuilder.getCreationType(),
                  invalidateNextPages: false
               };
            }
         };
      };

      function hasAlerts(nic) {
         nic.alerts = 0;
         if(!nic.expanded) {
            _.each(nic.ipv4.errors, function(error) {
               if(error) {
                  nic.alerts +=1;
               }
            });

            _.each(nic.ipv6.errors, function(error) {
               if(error) {
                  nic.alerts +=1;
               }
            });
         }

         return nic.alerts;
      }

      function buildGridOptions(nic) {
         var gridGatewaysOptions = {};
         gridGatewaysOptions.columnDefinitions = [
            {
               displayName: i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.ipv6.gateway"),
               type: "string"
            }
         ];
         gridGatewaysOptions.data = nic.gateway;
         gridGatewaysOptions.deleteLabel = i18nService.getString(
               "VmUi", "CustomizationParametersPageBase.nic.delete.label");
         gridGatewaysOptions.deleteTooltip = i18nService.getString(
               "VmUi", "CustomizationParametersPageBase.nic.delete.tooltip");
         gridGatewaysOptions.onDelete = function(gateway) {
            deleteGatewayFromList(gateway, nic);
         };
         gridGatewaysOptions.placeholder = i18nService.getString(
               "VmUi", "CustomizationParametersPageBase.noGateways");
         gridGatewaysOptions.gridLabel = i18nService.getString(
               "VmUi", "CustomizationParametersPageBase.ipv6GatewaysDescription");
         nic.gridGatewaysOptions = gridGatewaysOptions;
      }

      function deleteGatewayFromList(gateway, nic) {
         if (!gateway) {
            return;
         }

         var index = _.findIndex(nic.gateway,
               function(currentGateway) {
                  return currentGateway === gateway;
               });
         if (index < 0) {
            return;
         }

         nic.gateway.splice(index, 1);
      }
   }
})();

angular.module('com.vmware.vsphere.client.vm').service('vmProvisioningUserSettingsPageService', [
   'i18nService',
   'vuiConstants',
   'ipParserService',
   'wizardPageService',
   'vmVuiWizardPageBuilder',
   'VmProvisioningUserSettingsPageModel',
   function(
      i18nService,
      vuiConstants,
      ipParserService,
      wizardPageService,
      vmVuiWizardPageBuilder,
      VmProvisioningUserSettingsPageModel) {
      return {
         build: function(wizardScope) {
            var userSettingsPageModel = VmProvisioningUserSettingsPageModel(
               wizardScope.vmParams, 
               wizardScope.wizardViewData
            );
            wizardScope.userSettingsPageModel = userSettingsPageModel;

            return vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
               title: i18nService.getString('VmUi', 'UserSettingsPage.Title'),
               description: i18nService.getString('VmUi', 'customizeGuestOs.parametersPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningUserSettings.html',
               defaultState: vuiConstants.wizard.pageState.SKIPPED,
               model: userSettingsPageModel
            });
         }
      };
   }
]);
var h5_vm;
(function (h5_vm) {
    var VmProvisioningVservicePageModelFactory = (function () {
        function VmProvisioningVservicePageModelFactory(i18nService) {
            return function (virtualMachineSpecBuilder) {
                return new VmProvisioningVservicePageModel(i18nService, virtualMachineSpecBuilder);
            };
        }
        VmProvisioningVservicePageModelFactory.$inject = [
            "i18nService"
        ];
        return VmProvisioningVservicePageModelFactory;
    }());
    var VmProvisioningVservicePageModel = (function () {
        function VmProvisioningVservicePageModel(i18nService, virtualMachineSpecBuilderObj) {
            this.i18nService = i18nService;
            this.virtualMachineSpecBuilderObj = virtualMachineSpecBuilderObj;
            this.formObj = {};
        }
        Object.defineProperty(VmProvisioningVservicePageModel.prototype, "form", {
            get: function () {
                return this.formObj;
            },
            enumerable: true,
            configurable: true
        });
        VmProvisioningVservicePageModel.prototype.validatePage = function () {
            if (this.validateProviderStatus()) {
                return {};
            }
            return {
                error: this.i18nService.getString("ProvisioningUiLib", "VServicePage.errorInvalidBindings")
            };
        };
        VmProvisioningVservicePageModel.prototype.submitPage = function () {
            return {
                invalidateNextPages: false
            };
        };
        VmProvisioningVservicePageModel.prototype.resetForm = function () {
        };
        VmProvisioningVservicePageModel.prototype.validateProviderStatus = function () {
            var result = true;
            var vServiceContext = this.virtualMachineSpecBuilderObj.getVserviceContextFromLibraryCommonContext();
            if (vServiceContext && vServiceContext.dependencies) {
                vServiceContext.dependencies.forEach(function (dependency) {
                    if (dependency.availableProviders &&
                        dependency.availableProviders.length > 0) {
                        var selectedProviderKey_1 = dependency.selectedProviderKey;
                        if (!selectedProviderKey_1) {
                            result = false;
                            return;
                        }
                        var selectedProviderObj = dependency.availableProviders.find(function (provider) {
                            return provider.key === selectedProviderKey_1;
                        });
                        //Validation
                        if (selectedProviderObj.status.name === 'red') {
                            result = false;
                            return;
                        }
                    }
                    else {
                        result = false;
                        return;
                    }
                });
            }
            return result;
        };
        VmProvisioningVservicePageModel.$inject = [
            "i18nService"
        ];
        return VmProvisioningVservicePageModel;
    }());
    h5_vm.VmProvisioningVservicePageModel = VmProvisioningVservicePageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningVservicePageModel", VmProvisioningVservicePageModelFactory);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningVservicePageService = (function () {
        function VmProvisioningVservicePageService(i18nService, vuiConstants, wizardPageService, vmVuiWizardPageBuilder, vmProvisioningVservicePageModel) {
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.vmVuiWizardPageBuilder = vmVuiWizardPageBuilder;
            this.vmProvisioningVservicePageModel = vmProvisioningVservicePageModel;
        }
        VmProvisioningVservicePageService.prototype.build = function (wizardScope, defaultTarget, preselectedComputeResource) {
            var pageModel = new this.vmProvisioningVservicePageModel(wizardScope.wizardViewData);
            wizardScope.vmProvisioningScaleoutConfigurationPageModel = pageModel;
            return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
                title: this.i18nService.getString("ProvisioningUiLib", "VServicePage.title"),
                description: this.i18nService.getString("ProvisioningUiLib", "VServicePage.description"),
                contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages/" +
                    "vmProvisioningVservice/vm-provisioning-vservice-page.html",
                model: pageModel,
                defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
            });
        };
        ;
        VmProvisioningVservicePageService.$inject = [
            "i18nService",
            "vuiConstants",
            "wizardPageService",
            "vmVuiWizardPageBuilder",
            "vmProvisioningVservicePageModel"
        ];
        return VmProvisioningVservicePageService;
    }());
    h5_vm.VmProvisioningVservicePageService = VmProvisioningVservicePageService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmProvisioningVservicePageService", VmProvisioningVservicePageService);
})(h5_vm || (h5_vm = {}));



(function() {
   angular.module('com.vmware.vsphere.client.vm')
         .constant('vmTypeConstants', {
            VIRTUAL_MACHINE: 'vm',
            TEMPLATE: 'template'
         });
})();

angular.module('com.vmware.vsphere.client.vm').service('vmWizardService', [
   function () {
      return {
         hideErrors: hideErrors
      };

      function hideErrors(wizardConfig) {
         wizardConfig.validationBanner.messages = [];
      }
   }]);

angular.module('com.vmware.vsphere.client.vm').service('datastoreFaultsDialogService', [
   'clarityModalService', 'i18nService', '$rootScope',
   function(clarityModalService, i18nService, $rootScope) {
      return {
         openDialog: openDialog
      };

      function openDialog(scope, faults) {
         var modalOptions = {
            contentTemplate: 'vm-ui/resources/vm/views/createVmWizard/' +
               'datastoreRecommendations/vmProvisioningDatastoreFaults.html',
            title: i18nService.getString('VmUi', 'dsRecommendation.FaultsTitle'),
            size: 'lg',
            hideSubmitButton: true,
            closeButtonTitle: i18nService.getString('Common', 'saveButtonLabel'),
            defaultButton: 'close',
            dialogData: {
               faults: faults
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      }
   }
]);
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .factory('datastoreRecommendationsDatagridOptionsService',
         datastoreRecommendationsDatagridOptionsService
      );

   datastoreRecommendationsDatagridOptionsService.$inject = [
      'i18nService',
      'vuiConstants',
      'defaultUriSchemeUtil',
      'numberFormatterService'
   ];

   function datastoreRecommendationsDatagridOptionsService(
      i18nService,
      vuiConstants,
      defaultUriSchemeUtil,
      numberFormatterService
   ) {

      var i18n = i18nService.getString.bind(i18nService, 'VmUi');

      return {
         getDatagridOptions: getDatagridOptions
      };

      function getDatagridOptions(dialogData, recommendation) {
         return {
            dataBound: recommendation ? selectRowOfSelectedRecommendation(recommendation) : selectFirstRow,
            columnDefs: [
               {
                  displayName: i18n('RecommendationsList.recommendationColumnHeaderText'),
                  template: kendo.template("#:reasonText#" +
                     "<ul class='datastore-recommendation-column'> " +
                     "  # for (var i = 0; i < actions.length; i++) { #" +
                     "     <li ng-non-bindable>" +
                     "         <span class=#:actions[i].icon#></span>" +
                     "         <span>#:actions[i].text#</span>" +
                     "     </li>" +
                     "   # } # " +
                     "</ul>"),
                  field: 'reasonText',
                  width: '80%'
               },
               {
                  displayName: i18n('dsRecommendation.spaceUtilDstBeforeColumnHeaderLabel'),
                  field: 'spaceUtilBefore',
                  width: 125,
                  template: "<ul class='datastore-recommendation-usage-column'> " +
                  "  # for (var i = 0; i < actions.length; i++) { #" +
                  "     <li>#:actions[i].spaceUtilBefore#</li>" +
                  "   # } # " +
                  "</ul>"
               },
               {
                  displayName: i18n('dsRecommendation.spaceUtilDstAfterColumnHeaderLabel'),
                  field: 'spaceUtilAfter',
                  width: 125,
                  template: "<ul class='datastore-recommendation-usage-column'> " +
                  "  # for (var i = 0; i < actions.length; i++) { #" +
                  "     <li>#:actions[i].spaceUtilAfter#</li>" +
                  "   # } # " +
                  "</ul>"
               },
               {
                  displayName: i18n('dsRecommendation.ioLatencyDstBeforeColumnHeaderLabel'),
                  field: 'ioLatencyBefore',
                  width: 125,
                  template: "<ul class='datastore-recommendation-usage-column'> " +
                  "  # for (var i = 0; i < actions.length; i++) { #" +
                  "     <li>#:actions[i].ioLatencyBefore#</li>" +
                  "   # } # " +
                  "</ul>"
               }
            ],
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            data: getFormattedRecommendations(dialogData),
            resizable: true,
            searchable: false,
            height: 350
         };
      }

      /* --- Private --- */

      function formatActions(actions, dialogData) {
         var newVmName = dialogData.newVmName;
         var possibleDatastores = dialogData.possibleDatastores;

         var actionsSortedByAscendingDiskId = _.sortBy(actions, function (action) {
            if (action.relocateSpec.disk) {
               return action.relocateSpec.disk.diskId;
            } else {
               return 0;
            }
         });

         return _.map(actionsSortedByAscendingDiskId, function (action, index) {
            var dsId = action.destination;

            var datastoreName = possibleDatastores[defaultUriSchemeUtil.getVsphereObjectId(dsId)];

            var text, icon;
            if (action.relocateSpec.disk) {
               var diskName = '"' + i18n('VmDeviceManager.NewHardDisk') + ' ' + index + '"';

               text = i18n('dsRecommendation.storagePlacementActionHD',
                  '"' + newVmName + '"',
                  diskName,
                  '"' + datastoreName + '"'
               );
               icon = "vx-icon-vmDisk";
            } else {
               text = i18n('dsRecommendation.storagePlacementActionCF',
                  '"' + newVmName + '"',
                  '"' + datastoreName + '"'
               );
               icon = "vx-icon-vmSecondaryFT";
            }

            var formatCfg = {
               fractionSize: 1,
               trimTrailingZeros: true
            };

            return {
               icon: icon,
               text: text,
               spaceUtilBefore: numberFormatterService.format(action.spaceUtilBefore, formatCfg),
               spaceUtilAfter: numberFormatterService.format(action.spaceUtilAfter, formatCfg),
               ioLatencyBefore: numberFormatterService.format(action.ioLatencyBefore, formatCfg),
               destination: action.destination
            };
         });
      }

      function selectFirstRow() {
         var grid = $("#recommendations > div").data("kendoGrid");
         if (grid) {
            grid.select("tr:first");
         }
      }

      function selectRowOfSelectedRecommendation(recommendation) {
         return function() {
            var selector = "tr:contains('" + recommendation.reasonText + "')";
            var grid = $("#recommendations > div").data("kendoGrid");
            if (grid) {
               grid.select(selector);
            }
         };
      }

      function getFormattedRecommendations(dialogData) {
         var recommendations = dialogData.recommendations;
         return _.map(recommendations, function (rec, index) {
            var actions = formatActions(rec.action, dialogData);
            return {
               reasonText: i18n('dsRecommendation.recommendationText', (index + 1), rec.reasonText),
               actions: actions,
               spec: rec,
               spaceUtilBefore: 2,
               spaceUtilAfter: 2,
               ioLatencyBefore: 2,
               key: rec.key
            };
         });
      }
   }

})();

(function(){
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('datastoreRecommendationsDialogService', datastoreRecommendationsDialogService);
   datastoreRecommendationsDialogService.$inject = [
      'clarityModalService',
      '$q',
      'i18nService'];
   function datastoreRecommendationsDialogService(clarityModalService, $q, i18nService) {
      return {
         openDialog: openDialog
      };

      function openDialog(recommendedPlacements, storageIdToNameMap, preselectRecommendation, vmName) {
         var deferredSelection = $q.defer();

         var modalOptions = {
            contentTemplate: 'vm-ui/resources/vm/views/createVmWizard/' +
            'datastoreRecommendations/vmProvisioningDatastoreRecommendations.html',
            title: i18nService.getString('VmUi', 'dsRecommendation.title'),
            size: 'lg',
            dialogData: {
               selection: preselectRecommendation,
               recommendations: recommendedPlacements,
               newVmName: vmName,
               possibleDatastores: storageIdToNameMap,
               descriptionText: i18nService.getString('VmUi', 'dsRecommendation.header')
            },
            onSubmit: function () {
               if (!this.dialogData.selection) {
                  deferredSelection.reject();
                  return;
               }

               deferredSelection.resolve({
                  recommendationSpec: this.dialogData.selection.recommendationSpec
               });
               return true;
            },
            onCancel: function () {
               deferredSelection.reject();
            },
            defaultButton: 'submit',
            submitButtonTitle: i18nService.getString('VmUi', 'dsRecommendation.apply')
         };
         clarityModalService.openOkCancelModal(modalOptions);

         return deferredSelection.promise;
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('datastoreRecommendationService', datastoreRecommendationService);

   datastoreRecommendationService.$inject = [
      'mutationService',
      'i18nService',
      'defaultUriSchemeUtil',
      'datastoreRecommendationsDialogService',
      'datastoreFaultsDialogService',
      'managedEntityConstants'];

   function datastoreRecommendationService(
         mutationService,
         i18nService,
         defaultUriSchemeUtil,
         datastoreRecommendationsDialogService,
         datastoreFaultsDialogService,
         managedEntityConstants) {
      return {
         getPlacementRecommendations: getPlacementRecommendations,
         findTopRecommendation: findTopRecommendation,
         findTopRecommendationInfo: findTopRecommendationInfo,
         openRecommendationsDialog: openRecommendationsDialog,
         openRecommendationsDialogDirect: openRecommendationsDialogDirect,
         openFaultsDialog: openFaultsDialog,
         areRecommendationsAvailableForStorageObject: areRecommendationsAvailableForStorageObject
      };

      function getPlacementRecommendations(spec, specType) {
         if (!spec || !specType || !spec.podSelectionSpec) {
            return null;
         }

         var isSpecValid = false;
         var targetObjId;

         switch (specType) {
            case 'com.vmware.vsphere.client.vm.VmCloneSpec':
            case 'com.vmware.vsphere.client.vm.VmConfigSpec':
               isSpecValid = !!spec.vm;
               targetObjId = defaultUriSchemeUtil.getVsphereObjectId(spec.vm);
               break;
            case 'com.vmware.vsphere.client.vm.VmCreateSpec':
               isSpecValid = !!spec.pool;
               targetObjId = defaultUriSchemeUtil.getVsphereObjectId(spec.pool);
               break;
            default:
               break;
         }

         if (!isSpecValid) {
            return null;
         }

         return mutationService.validate(targetObjId, specType, spec).then(function(data) {
            if (data.result) {
               return {
                  recommendations: data.result.recommendations,
                  faults: getFaultsList(data.result.drsFault)
               };
            }

            // We should return some generic fault if we can't find a specific one
            var faultMsg = i18nService.getString('VmUi', 'SdrsRecommendations.faults.generic');
            var message = "";
            // Specific faults handled here
            var error = data.error;
            if (error) {
               if (error.message === "vim.fault.NoCompatibleDatastore") {
                  message = i18nService.getString('VmUi', 'SdrsRecommendations.faults.noCompatibleDatastore');
               } else {
                  // the same as in mutation.service#displayErrors
                  message = error.localizedMessage || error.message;
                  if (!message && error.cause) {
                     message = error.cause.localizedMessage || error.cause.message;
                  }
               }
            }

            return {
               faults: [{
                  message: message || faultMsg
               }]
            };
         });
      }

      function findTopRecommendation(recommendations) {
         if (!recommendations || recommendations.length === 0) {
            return null;
         }
         var topPlacementRecommendation = getTopPlacementRecommendation(recommendations);
         if (!topPlacementRecommendation) {
            return null;
         }

         return topPlacementRecommendation;
      }

      function findTopRecommendationInfo(recommendations) {
         var topPlacementRecommendation = findTopRecommendation(recommendations);
         if (!topPlacementRecommendation) {
            return null;
         }

         var topRecommendedDatastorePerDisk =
               findTopRecommendedDatastorePerDisk([topPlacementRecommendation]);

         return {
            topRecommendation: topPlacementRecommendation,
            topRecommendedDatastorePerDisk: topRecommendedDatastorePerDisk,
            topRecommendedDatastoreForVmx: getDatastoreForVmx(topPlacementRecommendation)
         };
      }

      /**
       * Opens up a recommendations dialog.
       * @param diskKey - id the of virtual disk the recommendations are for.
       * @param scope - scope object of the controller
       * @param model - provisioningFinishModel representing the RTC page of the
       *       provisioning wizards
       */
      function openRecommendationsDialog(diskKey, scope, model) {
         var preselectRecommendation = null;
         var diskRecommendationsByKey = getRecommendationsByKey(diskKey, model);
         if(diskRecommendationsByKey.length > 0) {
            var podId = defaultUriSchemeUtil
                  .getVsphereObjectId(diskRecommendationsByKey[0].target);
            preselectRecommendation = model.getSelectedRecommendation(podId);
         }
         return datastoreRecommendationsDialogService.openDialog(
               diskRecommendationsByKey,
               scope.wizardViewData.getStorageNameMap(),
               preselectRecommendation,
               model.getVmName()
         ).then(function(results) {
            model.setSelectedRecommendation(results.recommendationSpec.spec);
         });
      }

      function openRecommendationsDialogDirect(model, recommendation) {
         return datastoreRecommendationsDialogService.openDialog(
            recommendation,
            model.storageNameMap,
            null,
            model.vmName
         );
      }

      /**
       * Opens up a Fault dialog
       * @param scope - scope object of the controller
       * @param recommendationFaults - array with faults to be displayed
       */
      function openFaultsDialog(scope, recommendationFaults) {
         datastoreFaultsDialogService.openDialog(scope, recommendationFaults);
      }

      // ------------------- Private methods ---------------------- //

      function getTopPlacementRecommendation(recommendations) {
         var topRec = _.max(recommendations, function(recommendation) {
            var recHasPlacementAction = hasStoragePlacementAction(recommendation);
            return recHasPlacementAction
                  ? recommendation.rating
                  : -1;
         });
         return topRec;
      }

      function getDatastorePerDisk(recommendation) {
         var datastorePerDisk = {};
         angular.forEach(recommendation.action, function(action) {
            if (isStoragePlacementAction(action) && action.relocateSpec.disk) {
               angular.forEach(action.relocateSpec.disk, function(disk) {
                  datastorePerDisk[disk.diskId] = action.destination;
               });
            }
         });

         return datastorePerDisk;
      }

      function getDatastoreForVmx(recommendation) {
         var action = _.find(recommendation.action, function(action) {
                  return isStoragePlacementAction(action) && !action.relocateSpec.disk;
               }) || {};

         return action.destination;
      }

      function hasStoragePlacementAction(recommendation) {
         var action = _.find(recommendation.action, function(action) {
            return isStoragePlacementAction(action);
         });
         return angular.isDefined(action);
      }

      function isStoragePlacementAction(action) {
         return action._type.indexOf('StoragePlacementAction') > -1;
      }

      function getFaultsList(faultsObj) {
         if (faultsObj) {
            return _.map(faultsObj.faultsByVm[0].fault, function(fault) {
               return { message: fault.localizedMessage };
            });
         }
         return null;
      }

      function findTopRecommendedDatastorePerDisk(recommendations) {
         if (!recommendations || recommendations.length === 0) {
            return null;
         }
         var topPlacementRecommendation = getTopPlacementRecommendation(recommendations);
         if (!topPlacementRecommendation) {
            return null;
         }

         return getDatastorePerDisk(topPlacementRecommendation);
      }

      /**
       * @param diskKey {int} The disk key for which to retrieve recommendations or undefined
       * if retrieving recommendations for vmx.
       * @param model - provisioningFinishModel representing the RTC page of the
       *       provisioning wizards
       * @returns {Array} Array of recommendations for a specific disk. If diskKey is undefined
       * returns the recommendations for vmx placement.
       */
      function getRecommendationsByKey(diskKey, model) {
         var recommendationsForDisk = [];
         angular.forEach(model.form.recommendationsPerPod, function(recommendationsForPod) {
            angular.forEach(recommendationsForPod.recommendations, function(recommendation) {
               if (hasActionForDisk(diskKey, recommendation.action)) {
                  recommendationsForDisk.push(recommendation);
               }
            });
         });
         return recommendationsForDisk;
      }

      /**
       * @returns {boolean} Indicates whether there is a placement action for the specified
       * disk in an array of actions. If disk key is not specified returns a value indicating
       * whether there is a placement action for the vmx
       */
      function hasActionForDisk(diskKey, actions) {
         var action = _.find(actions, function(action) {
            var found = false;

            if (!angular.isDefined(diskKey) && !action.relocateSpec.disk) {
               found = true;
            } else if (action.relocateSpec.disk) {
               found = angular.isDefined(
                     _.find(action.relocateSpec.disk, function(diskLocator) {
                        return diskKey === diskLocator.diskId;
                     })
               );
            }
            return found;
         });
         return angular.isDefined(action);
      }

      /**
       * Determines if storage recommendations/faults can be retrieved.
       *
       * @param storageObject - storage object of vmx/disk
       * @returns true if the storage object is StoragePod or is a part of SDRS enabled
       * StoragePod
       */
      function areRecommendationsAvailableForStorageObject (storageObject) {
         var result;
         if (storageObject) {
            result = storageObject.storageRef.type === managedEntityConstants.STORAGE_POD
                  || (storageObject.parentStoragePod
                  && storageObject.parentStoragePod.isSdrsEnabled);
         }
         //Cast result to boolean
         return !!result;
      }
   }
})();

var h5_vm;
(function (h5_vm) {
    var VmEditSettingsDatastoreRecommendationService = (function () {
        function VmEditSettingsDatastoreRecommendationService($q, dataServiceUtil, defaultUriSchemeUtil, podSelectionSpecService, datastoreRecommendationService, managedEntityConstants, pmemUtilService) {
            this.$q = $q;
            this.dataServiceUtil = dataServiceUtil;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.podSelectionSpecService = podSelectionSpecService;
            this.datastoreRecommendationService = datastoreRecommendationService;
            this.managedEntityConstants = managedEntityConstants;
            this.pmemUtilService = pmemUtilService;
            this.storageInfoMapForDisksWithBacking = {};
            this.newDisksWithEmptyStorage = [];
        }
        VmEditSettingsDatastoreRecommendationService.prototype.shouldCheckRecommendations = function (vmxStorageObject, virtualMachineDevices) {
            var _this = this;
            this.buildStorageInfoMap(virtualMachineDevices);
            var diskNeedRecommendation = _.find(this.newDisks, function (disk) {
                if (_this.storageInfoMapForDisksWithBacking && _this.storageInfoMapForDisksWithBacking[disk.key]) {
                    var dsObject = _this.storageInfoMapForDisksWithBacking[disk.key].dsObject;
                    return _this.datastoreRecommendationService.areRecommendationsAvailableForStorageObject(dsObject);
                }
            });
            if (!_.isUndefined(diskNeedRecommendation)) {
                // At least one disk.backing.datastore is sdrs storage (sdrs cluster or datastore in such cluster)
                return true;
            }
            if (this.newDisksWithEmptyStorage.length > 0) {
                // At least one disk with undefined disk.backing.datastore.
                // Such disk location is "Store with VM"
                if (this.datastoreRecommendationService.areRecommendationsAvailableForStorageObject(vmxStorageObject)) {
                    // VM location is SDRS, then those "Store with VM" disks needs ask for recommendation
                    return true;
                }
            }
            return false;
        };
        VmEditSettingsDatastoreRecommendationService.prototype.getRecommendations = function (vmId, storageObject, virtualMachineDevices, originalConfig, currentConfig, cpuFeatureMask, onApply, onError) {
            var _this = this;
            if (_.isEmpty(this.storageInfoMapForDisksWithBacking)) {
                this.buildStorageInfoMap(virtualMachineDevices);
            }
            var podSelectionSpec = this.podSelectionSpecService.createSpec(this.newDisks, // new disks devices
            storageObject, this.storageInfoMapForDisksWithBacking); // storage info map
            // PodSelectionSpec.storagePod is not to be used in edit vm settings
            podSelectionSpec.storagePod = null;
            var vmConfigSpec = {
                originalConfig: originalConfig,
                config: currentConfig,
                cpuFeatureMask: cpuFeatureMask,
                deviceChange: virtualMachineDevices.getFinalChanges(),
                podSelectionSpec: podSelectionSpec,
                vm: this.defaultUriSchemeUtil.getManagedObjectReference(vmId)
            };
            var model = {
                vmName: currentConfig.name,
                datastoreName: null,
                selectedRecommendation: null,
                storageNameMap: {}
            };
            this.datastoreRecommendationService.getPlacementRecommendations(vmConfigSpec, 'com.vmware.vsphere.client.vm.VmConfigSpec')
                .then(function (result) {
                if (!_.isEmpty(result.faults)) {
                    return _this.$q.reject(result.faults);
                }
                if (result.recommendations && result.recommendations.length > 0) {
                    return _this.buildStorageNameMap(result.recommendations);
                }
                else {
                    //TODO:- Handle the case for faults here
                    return {
                        storageNameMap: null,
                        recommendations: null
                    };
                }
            })
                .then(function (result) {
                if (result.recommendations) {
                    model.storageNameMap = result.storageNameMap;
                    return _this.datastoreRecommendationService.openRecommendationsDialogDirect(model, result.recommendations);
                }
                else {
                    //TODO:- Handle the case for faults here
                    return;
                }
            })
                .then(function (result) {
                onApply(result);
            }, function (error) {
                onError(error);
            });
        };
        VmEditSettingsDatastoreRecommendationService.prototype.buildStorageNameMap = function (recommendations) {
            var _this = this;
            var storageNameMap = {};
            _.forEach(recommendations, function (recommendation) {
                storageNameMap[_this.defaultUriSchemeUtil.getVsphereObjectId(recommendation.target)] = "";
                _.forEach(recommendation.action, function (action) {
                    storageNameMap[_this.defaultUriSchemeUtil.getVsphereObjectId(action.destination)] = "";
                });
            });
            var objectIds = Object.keys(storageNameMap);
            return this.dataServiceUtil.getPropertiesForObjects(objectIds, ["name"], {}).then(function (response) {
                _.forEach(objectIds, function (objId) {
                    storageNameMap[objId] = response[objId].name;
                });
                return {
                    storageNameMap: storageNameMap,
                    recommendations: recommendations
                };
            });
        };
        VmEditSettingsDatastoreRecommendationService.prototype.buildStorageInfoMap = function (virtualMachineDevices) {
            var _this = this;
            this.newDisks = _.map(virtualMachineDevices.newDevicesOfType('VirtualDisk'), function (disk) {
                return disk.getCurrentDevice();
            });
            // Remove PMem disks and disks created from existing ones
            this.newDisks = _.filter(this.newDisks, function (virtualDisk) {
                return !_this.pmemUtilService.isPmemDisk(virtualDisk) && !virtualDisk.createdFromExistingDisk;
            });
            this.storageInfoMapForDisksWithBacking = {};
            this.newDisksWithEmptyStorage = [];
            _.each(this.newDisks, function (disk) {
                if (disk.backing.datastore) {
                    _this.storageInfoMapForDisksWithBacking[disk.key] = {
                        diskKey: disk.key,
                        diskBacking: disk.backing,
                        dsId: disk.backing.datastore.id,
                        dsName: disk.backing.datastore.name,
                        dsObject: {
                            parentStoragePod: disk.backing.parentStoragePod,
                            storageRef: disk.backing.datastore,
                            name: disk.deviceInfo.label,
                            capacity: disk.capacityInBytes,
                            drsEnabled: disk.backing.datastore.isSdrsEnabled
                        }
                    };
                }
                else {
                    if (disk.key < 0) {
                        _this.newDisksWithEmptyStorage.push(disk);
                    }
                }
            });
        };
        VmEditSettingsDatastoreRecommendationService.$inject = [
            '$q',
            'dataServiceUtil',
            'defaultUriSchemeUtil',
            'podSelectionSpecService',
            'datastoreRecommendationService',
            'managedEntityConstants',
            'pmemUtilService'];
        return VmEditSettingsDatastoreRecommendationService;
    }());
    h5_vm.VmEditSettingsDatastoreRecommendationService = VmEditSettingsDatastoreRecommendationService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmEditSettingsDatastoreRecommendationService', VmEditSettingsDatastoreRecommendationService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VirtualDisk$LocalPMemBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualDisk$LocalPMemBackingInfo;
    var LocationSpec = com.vmware.vsphere.client.vm.migration.LocationSpec;
    var RelocateSpec = com.vmware.vim.binding.vim.vm.RelocateSpec;
    var LocationSpecPair = com.vmware.vsphere.client.vm.migration.LocationSpecPair;
    var ComputeResourceTreePageSpec = com.vmware.vsphere.client.h5.vm.model.migration.ComputeResourceTreePageSpec;
    var RelocateSpec$DiskLocator = com.vmware.vim.binding.vim.vm.RelocateSpec$DiskLocator;
    var VirtualDeviceSpec = com.vmware.vim.binding.vim.vm.device.VirtualDeviceSpec;
    var VirtualDisk = com.vmware.vim.binding.vim.vm.device.VirtualDisk;
    var MigrationService = (function () {
        function MigrationService(mutationService, dataService, defaultUriSchemeUtil, $q, managedEntityConstants, logService, storageProfileService, diskFormatService, diskProvisioningService, i18nService, migrationTypeConstants, migrationHelperService, authorizationService, vmMigrateValidateComputeResourceStateBuilderFactory, pmemUtilService, vscSchedulingHelper) {
            this.mutationService = mutationService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$q = $q;
            this.managedEntityConstants = managedEntityConstants;
            this.logService = logService;
            this.storageProfileService = storageProfileService;
            this.diskFormatService = diskFormatService;
            this.diskProvisioningService = diskProvisioningService;
            this.i18nService = i18nService;
            this.migrationTypeConstants = migrationTypeConstants;
            this.migrationHelperService = migrationHelperService;
            this.authorizationService = authorizationService;
            this.vmMigrateValidateComputeResourceStateBuilderFactory = vmMigrateValidateComputeResourceStateBuilderFactory;
            this.pmemUtilService = pmemUtilService;
            this.vscSchedulingHelper = vscSchedulingHelper;
            this._log = logService("migrationService");
        }
        /**
         * Request root RP for cluster or standalone host. If the target is a resource pool,
         * we already have the target resource pool for the migration.
         *
         * @param resourceId the target resource selected by the user.
         */
        MigrationService.prototype.fetchResourcePool = function (resourceId) {
            var resourceRef = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(resourceId);
            switch (resourceRef.type) {
                case this.managedEntityConstants.CLUSTER:
                case this.managedEntityConstants.HOST:
                    return this.dataService.getProperties(resourceId, ["resourcePool"])
                        .then(function (response) {
                        return response.resourcePool;
                    });
                case this.managedEntityConstants.RESOURCE_POOL:
                case this.managedEntityConstants.V_APP:
                    return this.$q.resolve(resourceRef);
                default:
                    this._log.warn("Unexpected resource type: " + resourceRef.type);
                    return this.$q.resolve(null);
            }
        };
        /**
         * Build a location spec for a particular Virtual Machine.
         *
         * This means that if we have multiple VMs, we will have one such spec per VM.
         */
        MigrationService.prototype.buildLocationSpec = function (vmId, dataModel) {
            var _this = this;
            var self = this;
            var locationSpec = {
                relocateSpec: new RelocateSpec()
            };
            if (dataModel.pool) {
                locationSpec.relocateSpec.pool = self.toRef(dataModel.pool);
            }
            if (dataModel.computeResource) {
                var mor = self.toRef(dataModel.computeResource);
                if (mor.type === self.managedEntityConstants.HOST) {
                    locationSpec.relocateSpec.host = mor;
                }
            }
            if (dataModel.destinationFolder) {
                locationSpec.relocateSpec.folder = this.defaultUriSchemeUtil
                    .getManagedObjectReference(dataModel.destinationFolder);
            }
            if (dataModel.networkMatches) {
                self.populateNetworkChanges(locationSpec.relocateSpec, _.filter(dataModel.networkMatches, function (nwMatch) {
                    return vmId === self.toId(nwMatch.sourceVm);
                }));
            }
            if (dataModel.priority) {
                locationSpec.priority = dataModel.priority;
            }
            var vmDisks = dataModel.stretchedStorage ?
                dataModel.stretchedStorage[vmId] : dataModel.virtualDisksByVm[vmId];
            locationSpec.relocateSpec.disk = locationSpec.relocateSpec.disk || [];
            locationSpec.relocateSpec.deviceChange = locationSpec.relocateSpec.deviceChange || [];
            _.each(vmDisks, function (disk) {
                // VMX file processing...
                if (disk.key === "_configFile") {
                    if (disk.storage) {
                        locationSpec.relocateSpec.datastore = self.toRef(disk.storage);
                    }
                    if (disk.profile) {
                        locationSpec.relocateSpec.profile =
                            [self.storageProfileService.makeProfile(disk.profile.id, disk.replicationGroup)];
                    }
                    return;
                }
                // Disk processing...
                if (_this.storageProfileService.isPmemStorageProfile(disk.profile)) {
                    if (_this.pmemUtilService.isPmemDisk(disk.origin)) {
                        // Pmem -> Pmem does not require device change or disk locator spec.
                        return;
                    }
                    // Non Pmem -> Pmem upgrade requires device change record.
                    var deviceChangeSpec = _this.buildDeviceChange(disk);
                    locationSpec.relocateSpec.deviceChange.push(deviceChangeSpec);
                    return;
                }
                var diskLocator = _this.buildDiskLocator(dataModel, disk);
                locationSpec.relocateSpec.disk.push(diskLocator);
            });
            return self.trimEmptyProperties(locationSpec);
        };
        MigrationService.prototype.buildDeviceChange = function (disk) {
            var deviceSpec = new VirtualDeviceSpec();
            var pmemBacking = new VirtualDisk$LocalPMemBackingInfo();
            pmemBacking.diskMode = "persistent";
            pmemBacking.fileName = "";
            deviceSpec.operation = "edit";
            deviceSpec.device = new VirtualDisk();
            deviceSpec.device.key = disk.key;
            deviceSpec.device.backing = pmemBacking;
            deviceSpec.profile = [this.storageProfileService.makeProfile(disk.profile.id, disk.replicationGroup)];
            return deviceSpec;
        };
        MigrationService.prototype.buildDiskLocator = function (dataModel, disk) {
            var diskLocator = new RelocateSpec$DiskLocator();
            diskLocator.diskId = disk.key;
            diskLocator.datastore = this.toRef(disk.storage);
            if (disk.profile) {
                diskLocator.profile = [this.storageProfileService.makeProfile(disk.profile.id, disk.replicationGroup)];
            }
            var diskFormatValue = this.buildDiskFormatValue(disk.diskFormat, dataModel.diskFormat);
            if (diskFormatValue) {
                diskLocator.diskBackingInfo = this.diskProvisioningService.getBackingInfo(diskFormatValue);
            }
            return diskLocator;
        };
        MigrationService.prototype.buildDiskFormatValue = function (perDiskFmt, dataModelFmt) {
            if (perDiskFmt) {
                if (perDiskFmt.value !== "sameAsSource") {
                    return perDiskFmt.value;
                }
                else {
                    return null;
                }
            }
            if (dataModelFmt && (dataModelFmt.type !== "sameAsSource")) {
                return dataModelFmt.type;
            }
            return null;
        };
        MigrationService.prototype.trimEmptyProperties = function (locationSpec) {
            if (locationSpec.relocateSpec.disk.length === 0) {
                delete locationSpec.relocateSpec.disk;
            }
            if (locationSpec.relocateSpec.deviceChange.length === 0) {
                delete locationSpec.relocateSpec.deviceChange;
            }
            return locationSpec;
        };
        MigrationService.prototype.populateNetworkChanges = function (relocateSpec, networkMatches) {
            var self = this;
            var result = [];
            _.forEach(networkMatches, function (match) {
                var sourceNetworkUrn = self.defaultUriSchemeUtil.getVsphereObjectId(match.sourceNetwork);
                var destinationNetworkUrn = self.defaultUriSchemeUtil.getVsphereObjectId(match.destinationNetwork);
                if (!match.destinationNetwork || sourceNetworkUrn === destinationNetworkUrn) {
                    return;
                }
                var networkSpec = {
                    _type: "com.vmware.vim.binding.vim.vm.device.VirtualDeviceSpec",
                    operation: "edit",
                    device: match.sourceAdapter
                };
                result.push(networkSpec);
                // If the destination network is standard network
                if (match.destinationNetwork.type === self.managedEntityConstants.NETWORK) {
                    networkSpec.device.backing = {
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$NetworkBackingInfo",
                        deviceName: match.destinationNetworkName
                    };
                }
                else if (match.destinationNetwork.type === self.managedEntityConstants.DISTRIBUTED_VIRTUAL_PORTGROUP) {
                    networkSpec.device.backing = {
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$DistributedVirtualPortBackingInfo",
                        port: {
                            _type: "com.vmware.vim.binding.vim.dvs.PortConnection",
                            portgroupKey: match.destinationPortgroupKey,
                            switchUuid: match.destinationSwitchUuid
                        }
                    };
                }
                else if (match.destinationNetwork.type === self.managedEntityConstants.OPAQUE_NETWORK) {
                    networkSpec.device.backing = {
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$OpaqueNetworkBackingInfo",
                        opaqueNetworkId: match.destinationOpaqueId,
                        opaqueNetworkType: match.destinationOpaqueType
                    };
                }
            });
            if (!relocateSpec.deviceChange) {
                relocateSpec.deviceChange = result;
            }
            else {
                // Concatenating to the deviceChange array is safe here, as no duplicate
                // records for VM network adapters are possible.
                relocateSpec.deviceChange = relocateSpec.deviceChange.concat(result);
            }
        };
        MigrationService.prototype.getLocationSpecsForTesting = function (validationModel) {
            var self = this;
            var testsToRun = [
                // Source and resource pool tests are mandatory.
                "sourceTests",
                "resourcePoolTests",
                "datastoreTests",
                // Although it"s possible that relocateSpec.host could be unset (in case of
                // selected cluster), we still have to perform host tests, otherwise we can get
                // errors like these described in bug 871584.
                "hostTests"
            ];
            return self.createLocationSpecs(validationModel, testsToRun);
        };
        MigrationService.prototype.getLocationSpecsForRecommendations = function (dataModel) {
            var self = this;
            var testsToRun = ["storagePodTests"];
            return self.createLocationSpecs(dataModel, testsToRun);
        };
        MigrationService.prototype.createLocationSpecs = function (dataModel, testsToRun) {
            var self = this;
            var locationSpecPairs = [];
            _.each(dataModel.vms, function (vmId) {
                var locationSpec = self.buildLocationSpec(vmId, dataModel);
                locationSpec.testsToRun = testsToRun;
                var locationSpecPair = new LocationSpecPair();
                locationSpecPair.entity = self.toRef(vmId);
                locationSpecPair.spec = locationSpec;
                locationSpecPairs.push(locationSpecPair);
            });
            return locationSpecPairs;
        };
        MigrationService.prototype.getNetworkSpecsForTesting = function (vmIds, networkMatches, resPoolId, computeResourceId, workflow) {
            var self = this;
            var testsToRun = [
                "sourceTests",
                "resourcePoolTests",
                "hostTests",
                "networkTests"
            ];
            // as in flex - the datastore tests are executed only if both workflow is
            // migrate both - storage and computation resource.
            if (workflow === self.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                testsToRun.push("datastoreTests");
            }
            return self.createNetworkSpecs(vmIds, networkMatches, resPoolId, computeResourceId, testsToRun);
        };
        MigrationService.prototype.createNetworkSpecs = function (vmIds, networkMatches, resPoolId, computeResourceId, testsToRun) {
            var self = this;
            var locationSpecPairs = [];
            var dataModel = new h5_vm.MigrationWizardDataModel(vmIds, resPoolId);
            dataModel.networkMatches = networkMatches;
            dataModel.computeResource = computeResourceId;
            _.forEach(vmIds, function (vmId) {
                var locationSpec = self.buildLocationSpec(vmId, dataModel);
                locationSpec.testsToRun = testsToRun;
                var locationSpecPair = {
                    entity: self.defaultUriSchemeUtil.getManagedObjectReference(vmId),
                    spec: locationSpec
                };
                locationSpecPairs.push(locationSpecPair);
            });
            return locationSpecPairs;
        };
        MigrationService.prototype.validateComputeResource = function (params) {
            var _this = this;
            var resourceRef = this.defaultUriSchemeUtil.getManagedObjectReference(params.computeResourceId);
            var result = this.validateComputeResourceType(resourceRef);
            if (result) {
                return result;
            }
            var validationSpec = new ComputeResourceTreePageSpec();
            validationSpec.isXvcMigration = this.migrationHelperService
                .isXvcOperation(params.vmIds, params.computeResourceId);
            validationSpec.isHotMigration = params.isHotMigration;
            validationSpec.isBatchMigration = _.size(params.vmIds) > 1;
            validationSpec.migrationType = params.selectedMode;
            validationSpec.vms = _.map(params.vmIds, function (vmId) { return _this.toRef(vmId); });
            validationSpec.computeResource = resourceRef;
            validationSpec.fetchClusterName = _.isEmpty(params.clusterName);
            result = this.mutationService.validateSpec("com.vmware.vsphere.client.h5.vm.model.migration.ComputeResourceTreePageSpec", validationSpec)
                .then(function (validateResourceResult) {
                if (validateResourceResult.error) {
                    return {
                        resourceRef: resourceRef,
                        //  targetResourcePoolRef: validateResourceResult.result.resourcePoolRef,
                        isValid: false,
                        validationResults: [validateResourceResult]
                    };
                }
                var testsToRun = ["sourceTests", "resourcePoolTests", "hostTests"];
                if (!params.isNetworkSelectionRequired) {
                    // NOTE1: The user should receive a warning if VM networks are inaccessible
                    // on the destination compute resource - Problem described in bug 1630300.
                    // NOTE2: The network tests should be added only if there is no network
                    // selection page in the wizard, else they cause problems - The VC reports
                    // errors instead of warnings and the user is stuck on the compute
                    // resource page even though there is a change network page after it.
                    testsToRun.push("networkTests");
                }
                if (params.selectedMode === _this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                    // Include datastore tests to ensure that changing the compute
                    // resource only will not affect current storage requirements
                    testsToRun.push("datastoreTests");
                }
                var dataModel = new h5_vm.MigrationWizardDataModel(params.vmIds, _this.toId(validateResourceResult.result.resourcePoolRef));
                dataModel.computeResource = params.computeResourceId;
                var locationSpecPairs = _this.createLocationSpecs(dataModel, testsToRun);
                return _this.mutationService.validateMultiSpec("com.vmware.vsphere.client.vm.migration.LocationSpecPair", locationSpecPairs).then(function (validationResult) {
                    var validationSuccess = _this.isValidationSuccessful(validationResult);
                    return _this.vmMigrateValidateComputeResourceStateBuilderFactory
                        .create()
                        .setComputeResource(params.computeResourceId)
                        .setData(validateResourceResult)
                        .setParams(params)
                        .setIsValid(validationSuccess)
                        .setValidationResult(validationResult)
                        .build();
                });
            });
            return result;
        };
        MigrationService.prototype.validateComputeResourceType = function (resourceRef) {
            switch (resourceRef.type) {
                case this.managedEntityConstants.CLUSTER:
                case this.managedEntityConstants.HOST:
                case this.managedEntityConstants.RESOURCE_POOL:
                case this.managedEntityConstants.V_APP:
                    // These are allowed types. Do nothing. Let the check continue;
                    return undefined;
                default:
                    return this.$q.resolve({
                        resourceRef: resourceRef,
                        isValid: false,
                        validationResults: [{
                                entity: resourceRef,
                                error: new Error(this.i18nService.getString("VmUi", "MigrationWizard.resourceTreePage.error.no_selection"))
                            }]
                    });
            }
        };
        /**
         * @returns {boolean} true if all validation results are valid, false otherwize.
         * A validation result is considered valid if it contains at least on result that has
         * no error.
         */
        MigrationService.prototype.isValidationSuccessful = function (validationResults) {
            for (var index = 0; index < validationResults.length; index++) {
                var hasInitErrors = validationResults[index].error;
                var hasResultWithoutErrors = _.any(validationResults[index].result, function (result) {
                    return !result.error;
                });
                if (hasInitErrors || !hasResultWithoutErrors) {
                    return false;
                }
            }
            return true;
        };
        MigrationService.prototype.validateStorage = function (validationModel) {
            var locationSpecPairsArray = this.getLocationSpecsForTesting(validationModel);
            var url = new LocationSpecPair()._type;
            return this.mutationService.validateMultiSpec(url, locationSpecPairsArray);
        };
        MigrationService.prototype.validateNetwork = function (vmIds, networkMatches, resPoolId, computeResourceId, workflow) {
            var networkSpecPairsArray = this.getNetworkSpecsForTesting(vmIds, networkMatches, resPoolId, computeResourceId, workflow);
            var url = new LocationSpecPair()._type;
            return this.mutationService.validateMultiSpec(url, networkSpecPairsArray);
        };
        MigrationService.prototype.validateNetworkPrivilege = function (networkMatches) {
            var _this = this;
            if (_.isEmpty(networkMatches)) {
                return this.$q.when([]);
            }
            var networkMatchesByIdMap = _.reduce(networkMatches, function (memo, networkMatch) {
                if (!networkMatch || !networkMatch.destinationNetwork) {
                    return memo;
                }
                // Its not unusual depending on the destination compute resource,
                // the source and destination network to be the same
                // sourceNetwork can be null if the VM has disconnected network adapter
                if (networkMatch.sourceNetwork && _this.defaultUriSchemeUtil.compareIds(networkMatch.sourceNetwork, networkMatch.destinationNetwork)) {
                    return memo;
                }
                // We only pick for validation the changed networks
                var networkId = _this.defaultUriSchemeUtil.getVsphereObjectId(networkMatch.destinationNetwork);
                memo[networkId] = networkMatch;
                return memo;
            }, {});
            if (_.isEmpty(networkMatchesByIdMap)) {
                return this.$q.when([]);
            }
            var networkIds = _.keys(networkMatchesByIdMap);
            return this.authorizationService.checkPrivilegesForMultipleObjects(networkIds, ["Network.Assign"])
                .then(function (results) {
                return _.map(networkIds, function (networkId) {
                    var checkResultPerObj = results[networkId];
                    if (checkResultPerObj && !checkResultPerObj["Network.Assign"]) {
                        return {
                            entity: networkId,
                            error: {
                                message: _this.i18nService.getString("NetworkUi", "AddNetworkingWizard.conTargetPage.noDvpgPrivilegeMessage", networkMatchesByIdMap[networkId].destinationNetworkName)
                            }
                        };
                    }
                    else {
                        return {
                            entity: networkId
                        };
                    }
                });
            });
        };
        MigrationService.prototype.migrate = function (vmIds, operationName, dataModel, xdrsRecommendation, stPageModel) {
            var _this = this;
            var self = this;
            // TODO alalev: this should eventually call mutationService.applyMultiSpec()
            // and pass an array of specs
            _.each(vmIds, function (vmId) {
                var locationSpec = self.buildLocationSpec(vmId, dataModel);
                if (xdrsRecommendation) {
                    _this.applyXdrsRecommendation(xdrsRecommendation, locationSpec);
                }
                if (stPageModel && stPageModel.isScheduledTaskFlow) {
                    stPageModel = _this.createDataModelForScheduleTask(locationSpec, stPageModel);
                    self.mutationService.apply(vmId, "com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec", stPageModel.mutationSpec);
                }
                else {
                    self.mutationService.apply(vmId, new LocationSpec()._type, locationSpec, operationName);
                }
            });
        };
        MigrationService.prototype.applyStorageRecommendations = function (recommendations, storageRef) {
            return this.mutationService.add("com.vmware.vsphere.client.vm.storageDrs.VmRecommendationsSpec", {
                recommendations: _.pluck(recommendations, "key"),
                moRef: storageRef
            });
        };
        MigrationService.prototype.applyXdrsRecommendation = function (recommendation, locationSpec) {
            var _this = this;
            // xDRS placement recommendations should contain only a single PlacementAction,
            // so if it doesn't, just use the first one found (see bug 1030464).
            var action = recommendation.action[0];
            // xDRS API returns a relocateSpec with the recommended action. However, due to API
            // deficiencies not all fields of the relocate spec ar set. We need to apply only
            // the information that was set. See PR 1901738.
            // Update host and datastore with recommended ones
            locationSpec.relocateSpec.host = action.relocateSpec.host;
            locationSpec.relocateSpec.datastore = action.relocateSpec.datastore;
            if (action.relocateSpec.folder) {
                locationSpec.relocateSpec.folder = action.relocateSpec.folder;
            }
            // If a there is a recommended profile update it as well.
            if (action.relocateSpec.profile) {
                locationSpec.relocateSpec.profile = action.relocateSpec.profile;
            }
            // If device changes are set in recommended relocate spec then use it.
            if (!_.isEmpty(action.relocateSpec.deviceChange)) {
                locationSpec.relocateSpec.deviceChange = action.relocateSpec.deviceChange;
            }
            // For disk locators API only sets certain fields per disk. Only values that are
            // set in the recommended action relocateSpec will be applied to the final
            // relocate spec
            if (!_.isEmpty(action.relocateSpec.disk)) {
                _.each(action.relocateSpec.disk, function (recommendedLocator) {
                    var originalLocator = _.find(locationSpec.relocateSpec.disk, function (d) { return d.diskId === recommendedLocator.diskId; });
                    _this.updateDiskLocator(originalLocator, recommendedLocator);
                });
            }
        };
        MigrationService.prototype.updateDiskLocator = function (originalDisk, recommendedDisk) {
            if (!originalDisk) {
                return;
            }
            if (recommendedDisk.datastore) {
                originalDisk.datastore = recommendedDisk.datastore;
            }
            if (recommendedDisk.profile) {
                originalDisk.profile = recommendedDisk.profile;
            }
            if (recommendedDisk.diskMoveType) {
                originalDisk.diskMoveType = recommendedDisk.diskMoveType;
            }
        };
        MigrationService.prototype.toRef = function (id) {
            id = id || "";
            return vm_model.MoRef.fromUri(id);
        };
        MigrationService.prototype.toId = function (ref) {
            return this.defaultUriSchemeUtil.getVsphereObjectId(ref);
        };
        MigrationService.prototype.createDataModelForScheduleTask = function (locationSpec, stPageModel) {
            stPageModel.mutationSpec.schedulingSpec.recurrence =
                this.vscSchedulingHelper.formatRecurrenceData(stPageModel.mutationSpec.schedulingSpec.recurrence);
            locationSpec._type = "com.vmware.vsphere.client.vm.migration.LocationSpec";
            stPageModel.mutationSpec.spec = locationSpec;
            return stPageModel;
        };
        MigrationService.$inject = [
            "mutationService",
            "dataService",
            "defaultUriSchemeUtil",
            "$q",
            "managedEntityConstants",
            "logService",
            "storageProfileService",
            "diskFormatService",
            "diskProvisioningService",
            "i18nService",
            "migrationTypeConstants",
            "migrationHelperService",
            "authorizationService",
            "vmMigrateValidateComputeResourceStateBuilderFactory",
            "pmemUtilService",
            'vscSchedulingHelper'
        ];
        return MigrationService;
    }());
    h5_vm.MigrationService = MigrationService; // class MigrationService
    angular.module("com.vmware.vsphere.client.vm").service("migrationService", MigrationService);
})(h5_vm || (h5_vm = {})); // namespace h5_vm



var h5_vm;
(function (h5_vm) {
    /**
     * This type contains all the data required for the migration/relocate operation.
     *
     * NOTE speev: This one is a mimic of the MigrationWizardDataModel.as data structure.
     */
    var MigrationWizardDataModel = (function () {
        function MigrationWizardDataModel(vms, pool) {
            /** Array of vms to be migrated */
            this.vms = [];
            /**
             * The vmId -> vmName map holding the names of the vms to be migrated.
             */
            this.vmNames = {};
            /**
             * Dictionary, containing the destination for the virtual disks of all the migrated
             * VMs. The array of elements, belonging to each VM may be obtained by the
             * VM UID.
             *
             * NOTE: The VM configuration file is part of the disks array per VM,
             * but uses a 'fake/dummy/special' key: _configKey. This way you can distinguish it
             * from the other disks.
             */
            this.virtualDisksByVm = {};
            this.vms = vms;
            this.pool = pool;
        }
        return MigrationWizardDataModel;
    }());
    h5_vm.MigrationWizardDataModel = MigrationWizardDataModel; // class
})(h5_vm || (h5_vm = {})); // namespace h5_vm



var h5_vm;
(function (h5_vm) {
    var MigrationWizardManager = (function () {
        function MigrationWizardManager(migrationService, i18nService, defaultUriSchemeUtil, dataService, $q, managedEntityConstants, datastoreService, vmMigrateStorageLocatorService, migrationTypeConstants, datastoreRecommendationService, storageProfileService, vmMigrateStorageAdvancedSummaryBuilder, wizardScope, NetworkPageViewModes, vmStorageRecommendationsService, vmXdrsRecommendationService, vmProperties, storageSelectorService, featureFlagsService, migrationHelperService, relatedItemsService, pmemUtilService) {
            var _this = this;
            this.migrationService = migrationService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.$q = $q;
            this.managedEntityConstants = managedEntityConstants;
            this.datastoreService = datastoreService;
            this.vmMigrateStorageLocatorService = vmMigrateStorageLocatorService;
            this.migrationTypeConstants = migrationTypeConstants;
            this.datastoreRecommendationService = datastoreRecommendationService;
            this.storageProfileService = storageProfileService;
            this.vmMigrateStorageAdvancedSummaryBuilder = vmMigrateStorageAdvancedSummaryBuilder;
            this.NetworkPageViewModes = NetworkPageViewModes;
            this.vmStorageRecommendationsService = vmStorageRecommendationsService;
            this.vmXdrsRecommendationService = vmXdrsRecommendationService;
            this.storageSelectorService = storageSelectorService;
            this.featureFlagsService = featureFlagsService;
            this.migrationHelperService = migrationHelperService;
            this.relatedItemsService = relatedItemsService;
            this.pmemUtilService = pmemUtilService;
            // Indicates whether the workflow has completed
            this._isFinished = false;
            // NOTE speev: Do not put anymore data here. Use class private variables!
            this.state = {
                destinationComputeResource: null,
                networkMatches: null,
                selectedPriority: null,
                selectedMode: undefined,
                selectedRecommendation: null,
                isHotMigration: false,
            };
            var vmIds = _.keys(vmProperties);
            var vmNames = _.reduce(vmProperties, function (result, value, key) {
                result[key] = value.name;
                return result;
            }, {});
            // TODO - vaivanov - remove this when all pages support multiple vm migration.
            this.vmId = vmIds[0];
            this.vmName = vmProperties[this.vmId]["name"];
            // All vms should be in the same state, so we only check the first one
            this.state.isHotMigration =
                vmProperties[vmIds[0]]["powerState"] === "poweredOn";
            this.state.isComputeResourceChanged = false;
            this.state.selectedRecommendation = {};
            this._theModel = new h5_vm.MigrationWizardDataModel(vmIds);
            this.vmOrigin = [];
            if (vmIds.length === 1) {
                this.relatedItemsService.getRelatedItems(this.vmId).then(function (relatedItems) {
                    _this.vmOrigin = relatedItems;
                });
            }
            this.advancedStorageDataPromise = this.requestAdvancedStorageData(vmIds);
            this._theModel.vmNames = vmNames;
            this._migrationTypePageModel = new h5_vm.SelectMigrationTypePageModel();
            this._computeResourcePageModel = new h5_vm.SelectComputeResourcePageModel();
            this._computeResourceTreePageModel = new h5_vm.SelectComputeResourceTreePageModel();
            this._folderPageModel = new h5_vm.MigrateSelectFolderPageModel();
            this._storagePageModel = new h5_vm.MigrateSelectStoragePageModel();
            this._finishPageModel = new h5_vm.MigrateFinishPageModel();
            this._priorityPageModel = new h5_vm.SelectPriorityPageModel();
            this._storageRecommendationServiceInstance = new this.vmStorageRecommendationsService();
            this._xdrsRecommendationServiceInstance = new this.vmXdrsRecommendationService();
            this._vmWizardScheduleTaskPageModel = new h5_vm.VmWizardScheduleTaskPageModel(i18nService);
            this._networkPageModel = new h5_vm.MigrateSelectNetworkPageModel();
            wizardScope.$on("$destroy", function () {
                _this._storageRecommendationServiceInstance
                    .cancelRecommendations(_this._isFinished);
            });
            this.declareModelDependencies(wizardScope);
        }
        /**
         * NOTE speev: We don't keep a reference to the scope on purpose. We only use it
         * to provide the automatic binding between model inputs and outputs.
         */
        MigrationWizardManager.prototype.declareModelDependencies = function (scope) {
            // wire the models with the core wizard model.
            this.declareMigrationTypeModelDependencies(scope);
            this.declareComputeResourceModelDependencies(scope);
            this.declareComputeResourceTreeModelDependencies(scope);
            this.declareFolderModelDependencies(scope);
            this.declareStorageModelDependencies(scope);
            this.declareFinishModelDependencies(scope);
            this.declarePriorityModelDependencies(scope);
        };
        MigrationWizardManager.prototype.declareMigrationTypeModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this._theModel.vms; }, function (newValue) { _this._migrationTypePageModel.vms = newValue; });
            // output
            scope.$watch(function () { return _this._migrationTypePageModel.isXvcMigrationPossible; }, function (newValue) { _this._theModel.isXvcMigrationPossible = newValue; });
        };
        MigrationWizardManager.prototype.declareComputeResourceModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this._theModel.vms; }, function (newValue) { _this._computeResourcePageModel.vms = newValue; });
            // output
            scope.$watch(function () { return _this._computeResourcePageModel.stretchedStorage; }, function (newValue) { _this._theModel.stretchedStorage = newValue; });
            scope.$watch(function () { return _this._computeResourcePageModel.datacenter; }, function (newValue) { _this._theModel.datacenter = newValue; });
        };
        MigrationWizardManager.prototype.declareComputeResourceTreeModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this._theModel.vms; }, function (newValue) { _this._computeResourceTreePageModel.vms = newValue; });
            scope.$watch(function () { return _this._theModel.isXvcMigrationPossible; }, function (newValue) { _this._computeResourceTreePageModel.isXvcMigrationPossible = newValue; });
            // output
            scope.$watch(function () { return _this._computeResourceTreePageModel.datacenter; }, function (newValue) { _this._theModel.datacenter = newValue; });
            // NOTE speev: no output from page model for now - assigning something here
            // will be hard to join with the way the other compute resource page handles
            // its user interaction. We use directly the changeComputeResource() method
        };
        MigrationWizardManager.prototype.declareFolderModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this._theModel.vms; }, function (newValue) { _this._folderPageModel.vms = newValue; });
            scope.$watch(function () { return _this._theModel.datacenter; }, function (newValue) { _this._folderPageModel.datacenter = newValue; });
            // output
            scope.$watch(function () { return _this._folderPageModel.destinationFolder; }, function (newValue) { _this._theModel.destinationFolder = newValue; });
        };
        MigrationWizardManager.prototype.declareStorageModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this._theModel.vms; }, function (newValue) { _this._storagePageModel.vms = newValue; });
            scope.$watch(function () { return _this.isXvcMigration(); }, function (newValue) { _this._storagePageModel.isXvcMigration = newValue; });
            scope.$watch(function () { return _this.state.destinationComputeResource; }, function (newValue, oldValue) {
                if (!newValue) {
                    return;
                }
                var newEntityType = newValue.resourceRef ?
                    newValue.resourceRef.type : undefined;
                var newEntityId = _this.defaultUriSchemeUtil.getVsphereObjectId(newValue.resourceRef);
                var oldEntityId = oldValue ?
                    _this.defaultUriSchemeUtil.getVsphereObjectId(oldValue.resourceRef) :
                    "__DEADBEEF__";
                switch (newEntityType) {
                    case "ResourcePool":
                    case "VirtualApp":
                        _this._storagePageModel.computeResource = newValue.clusterRef ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(newValue.clusterRef) :
                            _this.defaultUriSchemeUtil.getVsphereObjectId(newValue.hostRef);
                        _this._storagePageModel.pool = newEntityId;
                        break;
                    case "HostSystem":
                    case "ClusterComputeResorce":
                    default:
                        _this._storagePageModel.computeResource = newEntityId;
                        _this._storagePageModel.pool =
                            _this.defaultUriSchemeUtil.getVsphereObjectId(newValue.targetResourcePoolRef);
                        break;
                }
                _this._storagePageModel.isComputeResourceChanged =
                    (newEntityId !== oldEntityId);
            });
            // output
            scope.$watch(function () { return _this._storagePageModel.isAdvancedStorageMode; }, function (newValue) { _this._theModel.isAdvancedStorageMode = newValue; });
            scope.$watch(function () { return _this._storagePageModel.virtualDisksByVm; }, function (newValue) {
                _this._theModel.virtualDisksByVm = newValue;
                if (_.isEmpty(newValue)) {
                    // During initial binding initialization
                    _this._selectedStorage = undefined;
                    _this._selectedStorageProfile = undefined;
                    _this._theModel.stretchedStorage = undefined;
                    _this._selectedReplicationGroup = undefined;
                    return;
                }
                var disksForVm0 = newValue[_this._theModel.vms[0]];
                _this._selectedStorage = {
                    name: _this.findStorageNameInMap(disksForVm0[0].storage, _this._storageNameMap),
                    storageRef: _this.defaultUriSchemeUtil.getManagedObjectReference(disksForVm0[0].storage),
                    parentStoragePod: _this.defaultUriSchemeUtil.getManagedObjectReference(disksForVm0[0].parentStoragePod)
                };
                _this._selectedStorageProfile = disksForVm0[0].profile;
                _this._selectedReplicationGroup = disksForVm0[0].replicationGroup;
                var diskFormat = _this.findFirstDiskFormat(newValue);
                _this._selectedDiskFormat = diskFormat ? {
                    name: diskFormat.label,
                    type: diskFormat.value
                } : undefined;
            });
            scope.$watch(function () { return _this._storagePageModel.storageNameMap; }, function (newValue) {
                _this._storageNameMap = newValue;
                if (_this._selectedStorage) {
                    var storageId = _this.defaultUriSchemeUtil.getVsphereObjectId(_this._selectedStorage.storageRef);
                    _this._selectedStorage.name = _this.findStorageNameInMap(storageId, _this._storageNameMap);
                }
            });
        };
        MigrationWizardManager.prototype.declareFinishModelDependencies = function (scope) {
            var _this = this;
            // input
            scope.$watch(function () { return _this.state.destinationComputeResource; }, function (newValue, oldValue) {
                if (!newValue) {
                    return;
                }
                var newEntityId = _this.defaultUriSchemeUtil.getVsphereObjectId(newValue.resourceRef);
                var oldEntityId = oldValue ?
                    _this.defaultUriSchemeUtil.getVsphereObjectId(oldValue.resourceRef) :
                    "__DEADBEEF__";
                _this._finishPageModel.isComputeResourceChanged =
                    (newEntityId !== oldEntityId);
            });
            scope.$watch(function () { return _this._folderPageModel.destinationFolder; }, function (newValue, oldValue) {
                if (!newValue) {
                    return;
                }
                var oldFolderId = oldValue ? oldValue : "__DEADBEEF__";
                _this._finishPageModel.isFolderChanged = (newValue !== oldFolderId);
            });
        };
        MigrationWizardManager.prototype.declarePriorityModelDependencies = function (scope) {
            var _this = this;
            // output
            scope.$watch(function () { return _this._priorityPageModel.priority; }, function (newValue) { _this._theModel.priority = newValue; });
        };
        MigrationWizardManager.prototype.submit = function () {
            var _this = this;
            this._isFinished = true;
            var recommendationsByVm = this._storageRecommendationServiceInstance.getSelectedRecommendationsByVm();
            // Holds the VMs which should not be migrated using SDRS api
            var vmsNotUsingSdrs = [];
            _.each(this._theModel.vms, function (vmId) {
                var selectedRecommendations = recommendationsByVm[vmId];
                // Skip vms for which we have SDRS faults
                if (_this._storageRecommendationServiceInstance.hasFaultsForVm(vmId)
                    || _this._xdrsRecommendationServiceInstance.hasFaults()) {
                    return;
                }
                // If SDRS recommendations are generated for the VM then use SDRS API.
                if (!_.isEmpty(selectedRecommendations)
                    && _this.getSelectedMode() !== _this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                    return _this.migrationService.applyStorageRecommendations(selectedRecommendations, _this.assertDefined(_this._selectedStorage).storageRef);
                }
                else {
                    // VM does not use SDRS use regular migrate API.
                    vmsNotUsingSdrs.push(vmId);
                }
            });
            if (vmsNotUsingSdrs.length > 0) {
                var operationName = this.i18nService.getString("VmUi", "MigrationWizard.title.single", this.vmName);
                var targetResourcePoolRef = void 0, resourceRef = void 0;
                var destination = this.state.destinationComputeResource;
                if (destination) {
                    targetResourcePoolRef = destination.targetResourcePoolRef;
                    resourceRef = destination.resourceRef;
                }
                var dataModel = new h5_vm.MigrationWizardDataModel(vmsNotUsingSdrs);
                dataModel.pool = this.defaultUriSchemeUtil.getVsphereObjectId(targetResourcePoolRef);
                dataModel.computeResource = this._finishPageModel.hostForSilentSelection ?
                    this._finishPageModel.hostForSilentSelection :
                    this.defaultUriSchemeUtil.getVsphereObjectId(resourceRef);
                dataModel.priority = this._theModel.priority;
                dataModel.networkMatches = this.getNetworkMatches();
                if (this.getSelectedMode() !== this.migrationTypeConstants.MIGRATE_STORAGE_ONLY
                    && this.migrationHelperService.isXvcOperation(this.model.vms, this.defaultUriSchemeUtil.getVsphereObjectId(resourceRef))) {
                    dataModel.destinationFolder = this.model.destinationFolder;
                }
                if (this.getSelectedMode() === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                    // NOTE speev: Even though we change the compute resource only - behind
                    // the scene the storage may have changed - in case of stretched storage
                    // i.e. user picked compute resource from another DC/VC which sees the same
                    // storage with different MOR value. In that case the new MOR need to be
                    // supplied for the migration operation to succeed.
                    dataModel.stretchedStorage = this._theModel.stretchedStorage;
                }
                else {
                    // NOTE speev: When the storage selector is used - we always populate all
                    // VM disks infos completely - even in the Basic mode. So we don't care
                    // about modes here.
                    dataModel.virtualDisksByVm = this._theModel.virtualDisksByVm;
                }
                this.migrationService.migrate(vmsNotUsingSdrs, operationName, dataModel, this._xdrsRecommendationServiceInstance.getSelectedRecommendation(), this._vmWizardScheduleTaskPageModel);
            }
        };
        Object.defineProperty(MigrationWizardManager.prototype, "migrationTypePageModel", {
            get: function () {
                return this._migrationTypePageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "computeResourcePageModel", {
            get: function () {
                return this._computeResourcePageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "computeResourceTreePageModel", {
            get: function () {
                return this._computeResourceTreePageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "folderPageModel", {
            get: function () {
                return this._folderPageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "isNetworkSelectionRequired", {
            set: function (value) {
                this._theModel.isNetworkSelectionRequired = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "model", {
            /**
             * The one and only, always up-to-date wizard model. The wizard model purpose is
             * to gather all data collected when user is going through the wizard pages.
             *
             * @returns {MigrationWizardDataModel}
             */
            get: function () {
                return this._theModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "priorityPageModel", {
            get: function () {
                return this._priorityPageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "vmWizardScheduleTaskPageModel", {
            get: function () {
                return this._vmWizardScheduleTaskPageModel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MigrationWizardManager.prototype, "networkPageModel", {
            get: function () {
                return this._networkPageModel;
            },
            enumerable: true,
            configurable: true
        });
        MigrationWizardManager.prototype.getFinishPageState = function () {
            var self = this;
            var model = {};
            if (self.getSelectedMode() === self.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                model = {
                    migrationType: "MigrationWizard.readyPage.migrationWorkflowChangeResourceKeepStorage",
                    vmIds: self.getVmIds(),
                    vmNames: self.getVmNames(),
                    clusterName: self.state.destinationComputeResource.clusterName,
                    hostName: self.state.destinationComputeResource.hostName,
                    resourcePoolName: self.state.destinationComputeResource.resPoolName,
                    networksMessage: this._theModel.isNetworkSelectionRequired ?
                        this.createNetworksMessage() : undefined,
                    recommendationService: this._storageRecommendationServiceInstance,
                    xdrsRecommendationService: this.isXdrsRecommendationsNeeded() ?
                        this._xdrsRecommendationServiceInstance : undefined,
                    folderName: self._finishPageModel.folderName,
                    vcName: self._finishPageModel.vcName
                };
            }
            else if (self.getSelectedMode() === self.migrationTypeConstants.MIGRATE_STORAGE_ONLY) {
                model = {
                    migrationType: "MigrationWizard.readyPage.migrationWorkflowChangeStorageKeepResource",
                    vmIds: self.getVmIds(),
                    vmNames: self.getVmNames(),
                    storage: this._selectedStorage,
                    pmemDiskInfo: this.getPmemDiskInfo(),
                    diskFormat: this._selectedDiskFormat ? this._selectedDiskFormat.name : "",
                    profile: this._selectedStorageProfile,
                    replicationGroup: this._selectedReplicationGroup,
                    storageRecommendations: self.state.allStorageRecommendations,
                    // TODO - vaivanov - remove vmId and vmName from model once page supports multiple vms
                    vmName: self.vmName,
                    vmId: self.vmId,
                    storageNameMap: this._storageNameMap,
                    recommendationService: this._storageRecommendationServiceInstance,
                    advancedStorageSummary: this._theModel.isAdvancedStorageMode ?
                        self.vmMigrateStorageAdvancedSummaryBuilder.build(self._theModel, angular.extend({}, self.getVmNames(), this._storageNameMap), this._storageRecommendationServiceInstance) :
                        null
                };
            }
            else if (self.getSelectedMode() === self.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                model = {
                    migrationType: "MigrationWizard.readyPage.migrationWorkflowChangeResourceThenStorage",
                    vmIds: self.getVmIds(),
                    vmNames: self.getVmNames(),
                    clusterName: self.state.destinationComputeResource.clusterName,
                    hostName: self.state.destinationComputeResource.hostName,
                    resourcePoolName: self.state.destinationComputeResource.resPoolName,
                    storage: this._selectedStorage,
                    pmemDiskInfo: this.getPmemDiskInfo(),
                    diskFormat: this._selectedDiskFormat ? this._selectedDiskFormat.name : "",
                    profile: this._selectedStorageProfile,
                    replicationGroup: this._selectedReplicationGroup,
                    storageRecommendations: self.state.allStorageRecommendations,
                    // TODO - vaivanov - remove vmId and vmName from model once page supports multiple vms
                    vmName: self.vmName,
                    vmId: self.vmId,
                    storageNameMap: this._storageNameMap,
                    networksMessage: this._theModel.isNetworkSelectionRequired ?
                        this.createNetworksMessage() : undefined,
                    recommendationService: this._storageRecommendationServiceInstance,
                    xdrsRecommendationService: this.isXdrsRecommendationsNeeded() ?
                        this._xdrsRecommendationServiceInstance : undefined,
                    advancedStorageSummary: this._theModel.isAdvancedStorageMode ?
                        self.vmMigrateStorageAdvancedSummaryBuilder.build(self._theModel, angular.extend({}, self.getVmNames(), this._storageNameMap), this._storageRecommendationServiceInstance) :
                        null,
                    folderName: self._finishPageModel.folderName,
                    vcName: self._finishPageModel.vcName
                };
            }
            if (this.state.isHotMigration &&
                this.getSelectedMode() !== this.migrationTypeConstants.MIGRATE_STORAGE_ONLY) {
                if (this._theModel.priority === "highPriority") {
                    model.priority = self.i18nService.getString("VmUi", "MigrationWizard.readyPage.highPriority");
                }
                else if (this._theModel.priority === "lowPriority") {
                    model.priority = self.i18nService.getString("VmUi", "MigrationWizard.readyPage.lowPriority");
                }
            }
            return model;
        };
        MigrationWizardManager.prototype.setNetworkMatches = function (networkMatches) {
            this.state.networkMatches = networkMatches;
        };
        MigrationWizardManager.prototype.getNetworkMatches = function () {
            return this.state.networkMatches;
        };
        MigrationWizardManager.prototype.hasValidComputeResourceSelected = function () {
            return this.state.destinationComputeResource &&
                this.state.destinationComputeResource.isValid;
        };
        MigrationWizardManager.prototype.hasValidStorage = function () {
            return !_.isEmpty(this._storagePageModel.virtualDisksByVm);
        };
        MigrationWizardManager.prototype.hasValidFolderSelected = function () {
            return !!this._theModel.destinationFolder;
        };
        MigrationWizardManager.prototype.setSelectedMode = function (selectedMode) {
            this.state.selectedMode = selectedMode;
        };
        MigrationWizardManager.prototype.getSelectedMode = function () {
            return this.state.selectedMode;
        };
        Object.defineProperty(MigrationWizardManager.prototype, "storagePageModel", {
            get: function () {
                return this._storagePageModel;
            },
            enumerable: true,
            configurable: true
        });
        MigrationWizardManager.prototype.fetchRecommendationsInternal = function () {
            if (this.isXdrsRecommendationsNeeded()) {
                return this.fetchXdrsRecommendations();
            }
            else {
                return this.fetchStorageRecommendations();
            }
        };
        MigrationWizardManager.prototype.fetchRecommendations = function () {
            var _this = this;
            // Check whether silent host selection is required, and if yes, proceed with
            // retrieving valid destination hosts.
            this._finishPageModel.hostForSilentSelection = undefined;
            if (!this.isHostSelectionRequired()) {
                return this.fetchRecommendationsInternal();
            }
            var dataModel = this.buildDataModel();
            var locationSpecPairs = this.migrationService.getLocationSpecsForTesting(dataModel);
            return this.requestValidDestinationHosts(this.state.destinationComputeResource.resourceRef, locationSpecPairs)
                .then(function (hostRef) {
                if (hostRef) {
                    _this._finishPageModel.hostForSilentSelection =
                        _this.defaultUriSchemeUtil.getVsphereObjectId(hostRef);
                }
                // NOTE: If no valid hosts were found, we STILL PROCEED with further data requests,
                // assuming that the xDRS-Recommendations retrieval will most probably fail due to
                // the lack of a preselected host. This will lead to displayed error message.
                return _this.fetchRecommendationsInternal();
            });
        };
        MigrationWizardManager.prototype.fetchStorageRecommendations = function () {
            var dataModel = new h5_vm.MigrationWizardDataModel(this._theModel.vms);
            var wizardMode = this.getSelectedMode();
            if (wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY ||
                wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                var dst = this.state.destinationComputeResource;
                dataModel.computeResource = dst ?
                    this.defaultUriSchemeUtil.getVsphereObjectId(dst.resourceRef) :
                    undefined;
                dataModel.pool = dst ?
                    this.defaultUriSchemeUtil.getVsphereObjectId(dst.targetResourcePoolRef) :
                    undefined;
            }
            if (wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY ||
                wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                dataModel.networkMatches = this.getNetworkMatches();
            }
            // NOTE speev: When the storage selector is used - we always populate all
            // VM disks infos completely - even in the Basic mode. So we don't care
            // about modes here.
            if (wizardMode === this.migrationTypeConstants.MIGRATE_STORAGE_ONLY ||
                wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                dataModel.virtualDisksByVm = this._theModel.virtualDisksByVm;
            }
            // NOTE: Do a server round-trip only if a StoragePod is in the game
            if (!this.isFetchStorageRecommendationsNeeded(dataModel)) {
                return this._storageRecommendationServiceInstance.load([]);
            }
            var locationSpecPairs = this.migrationService
                .getLocationSpecsForRecommendations(dataModel);
            // NOTE speev: The important thing is that before fetching recommendations,
            // the location specs need to have captured all the operations (i.e compute
            // resource change, storage change, network change).
            return this._storageRecommendationServiceInstance.load(locationSpecPairs);
        };
        /**
         * Server side storage recommendations fetching is needed only if StoragePod
         * is being used as destination storage.
         */
        MigrationWizardManager.prototype.isFetchStorageRecommendationsNeeded = function (dataModel) {
            // In xVC scenarios or if xDRS placement recommendations have been requested,
            // don't request SDRS recommendations, or cancel old ones.
            if (this.isXvcMigration()) {
                return false;
            }
            var podRegex = /StoragePod/;
            var podFound = _.some(dataModel.virtualDisksByVm, function (disks) {
                return _.some(disks, function (disk) {
                    return !!disk.parentStoragePod || podRegex.test(disk.storage || "");
                });
            });
            return podFound;
        };
        MigrationWizardManager.prototype.isXvcMigration = function () {
            if (this.getSelectedMode() !== this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY
                && this.getSelectedMode() !== this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                return false;
            }
            return this.migrationHelperService.isXvcOperationByRef([this.getVmId()], this.getDestinationComputeResourceRef());
        };
        MigrationWizardManager.prototype.requestFolderData = function () {
            var _this = this;
            if (!this.isXvcMigration()) {
                this._finishPageModel.vcName = undefined;
                this._finishPageModel.folderName = undefined;
                return this.$q.when(undefined);
            }
            if (!this._finishPageModel.isComputeResourceChanged
                && !this._finishPageModel.isFolderChanged
                && this._finishPageModel.vcName
                && this._finishPageModel.folderName) {
                return this.$q.when(undefined);
            }
            var folderId = this._theModel.destinationFolder;
            return this.dataService.getProperties(folderId, ["name", "vCenterName"])
                .then(function (result) {
                _this._finishPageModel.isComputeResourceChanged = false;
                _this._finishPageModel.isFolderChanged = false;
                _this._finishPageModel.vcName = result["vCenterName"];
                _this._finishPageModel.folderName = result["name"];
                return _this.$q.when(undefined);
            });
        };
        MigrationWizardManager.prototype.fetchXdrsRecommendations = function () {
            var clusterId = this.defaultUriSchemeUtil.getVsphereObjectId(this.getDestinationClusterRef());
            var dataModel = this.buildDataModel();
            var locationSpecPairs = this.migrationService
                .getLocationSpecsForRecommendations(dataModel);
            // Fetching xDRS recommendations is supported only for a single vm
            return this._xdrsRecommendationServiceInstance.load(clusterId, locationSpecPairs[0]);
        };
        MigrationWizardManager.prototype.buildDataModel = function () {
            var dataModel = new h5_vm.MigrationWizardDataModel(this._theModel.vms);
            // The dataModel.pool and dataModel.computeResource properties should always
            // be set, regardless the workflow.
            dataModel.pool = this.defaultUriSchemeUtil.getVsphereObjectId(this.state.destinationComputeResource.targetResourcePoolRef);
            dataModel.computeResource = this.defaultUriSchemeUtil.getVsphereObjectId(this.state.destinationComputeResource.resourceRef);
            if (this.getSelectedMode() !== this.migrationTypeConstants.MIGRATE_STORAGE_ONLY
                && this.migrationHelperService.isXvcOperation(this.model.vms, dataModel.computeResource)) {
                dataModel.destinationFolder = this.model.destinationFolder;
            }
            var wizardMode = this.getSelectedMode();
            if (wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY ||
                wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                dataModel.networkMatches = this.getNetworkMatches();
                if (this.state.isHotMigration) {
                    dataModel.priority = this._theModel.priority;
                }
            }
            if (this.getSelectedMode() === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                // Set the stretch storage if such is set
                dataModel.stretchedStorage = this._theModel.stretchedStorage;
            }
            if (wizardMode === this.migrationTypeConstants.MIGRATE_STORAGE_ONLY ||
                wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                dataModel.virtualDisksByVm = this._theModel.virtualDisksByVm;
            }
            return dataModel;
        };
        /**
         * Checks if silent host selection is needed. Check PR 1058915.
         */
        MigrationWizardManager.prototype.isHostSelectionRequired = function () {
            // Cold migration. No need of host auto-selection.
            if (!this.state.isHotMigration) {
                return false;
            }
            if (!this.getTargetResourcePoolRef()
                || this.getTargetResourcePoolRef().type !== this.managedEntityConstants.V_APP) {
                return false;
            }
            // Destination compute resource is not under a Cluster. No need of host auto-selection.
            // Destination compute resource is NOT a vApp. No need of host auto-selection.
            if (!this.getDestinationClusterRef()) {
                return false;
            }
            // We have a live migration to vApp, which is under a Cluster.
            return true;
        };
        /**
         * Request all valid destination hosts within a cluster or resource pool.
         *
         * @param computeResource cluster or resource pool.
         * @param locationSpecPairs -  an array of <code>LocationSpecPair</code> objects.
         **/
        MigrationWizardManager.prototype.requestValidDestinationHosts = function (computeResource, locationSpecPairs) {
            var PROPERTY_VALID_HOSTS = "validDestinationHosts";
            var computeResourceId = this.defaultUriSchemeUtil.getVsphereObjectId(computeResource);
            // The destination is the same for all the location spec pairs so we take the first one
            var params = {
                propertyParams: [{
                        propertyName: "validDestinationHosts",
                        parameterType: locationSpecPairs[0]._type,
                        parameter: locationSpecPairs[0]
                    }]
            };
            return this.dataService.getProperties(computeResourceId, [PROPERTY_VALID_HOSTS], params)
                .then(function (result) {
                if (result.validDestinationHosts && result.validDestinationHosts[0]) {
                    return result.validDestinationHosts[0];
                }
                return undefined;
            });
        };
        /**
         * Returns a value indicating whether xDRS API should be used to generate DRS
         * placement recommendations.
         */
        MigrationWizardManager.prototype.isXdrsRecommendationsNeeded = function () {
            // Currently, xDRS Placement API doesn't support getting recommendations for
            // multiple VMs at once and doesn't take already given recommendations into
            // account like SDRS, so it shouldn't be used for batch migration.
            if (this._theModel.vms.length !== 1) {
                return false;
            }
            // Also, the xDRS Placement API should be used solely for xvMotion, which requires
            // the migrated VM to be powered on (xvMotion is a type of hot migration).
            if (!this.state.isHotMigration) {
                return false;
            }
            // If host has been specified, placement recommendations should NOT be retrieved.
            if (this.getDestinationHostRef()) {
                return false;
            }
            // There is host for replacing the destination compute resource, so recommendations
            // are not needed
            if (this._finishPageModel.hostForSilentSelection) {
                return false;
            }
            // In order for one hot migration to be xvMotion, both the compute resource and
            // the storage of the VM should be changed.
            // EITHER one of the "Change compute resource, THEN storage" or "Change storage,
            // THEN compute resource" workflows should be used
            var wizardMode = this.getSelectedMode();
            if (wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE) {
                return true;
            }
            // OR "Change compute resource, KEEP storage" workflow should be used, with
            // stretched storage being auto-populated.
            if (wizardMode === this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY) {
                return !!this._theModel.stretchedStorage;
            }
            return false;
        };
        MigrationWizardManager.prototype.getVmId = function () {
            return this.vmId;
        };
        MigrationWizardManager.prototype.getVmIds = function () {
            return this._theModel.vms;
        };
        MigrationWizardManager.prototype.getVmName = function () {
            return this.vmName;
        };
        MigrationWizardManager.prototype.getVmOrigin = function () {
            return this.vmOrigin;
        };
        MigrationWizardManager.prototype.getAdvancedStoragePageData = function () {
            return this.advancedStorageDataPromise;
        };
        MigrationWizardManager.prototype.getVmNames = function () {
            return this._theModel.vmNames;
        };
        MigrationWizardManager.prototype.getTargetResourcePoolRef = function () {
            return this.state.destinationComputeResource.targetResourcePoolRef;
        };
        MigrationWizardManager.prototype.getDestinationComputeResourceRef = function () {
            if (!this.state.destinationComputeResource) {
                return null;
            }
            return this.state.destinationComputeResource.resourceRef;
        };
        MigrationWizardManager.prototype.getDestinationComputeResourceUid = function () {
            if (!this.state.destinationComputeResource) {
                return null;
            }
            return this.defaultUriSchemeUtil.getVsphereObjectId(this.state.destinationComputeResource.resourceRef);
        };
        /**
         * @returns A ManagedObjectReference to the destination host if user has chosen to
         * migrate to a standalone host or resource pool/vApp under a standalone host.
         */
        MigrationWizardManager.prototype.getDestinationHostRef = function () {
            if (!this.state.destinationComputeResource
                || !this.state.destinationComputeResource.resourceRef) {
                return null;
            }
            var selectedResource = this.state.destinationComputeResource.resourceRef;
            if (selectedResource.type !== this.managedEntityConstants.HOST) {
                selectedResource = this.state.destinationComputeResource.hostRef;
            }
            return selectedResource;
        };
        /**
         * @returns A ManagedObjectReference to the destination cluster if user has chosen to
         * migrate to a cluster or resource pool/vApp under a cluster.
         */
        MigrationWizardManager.prototype.getDestinationClusterRef = function () {
            if (!this.state.destinationComputeResource
                || !this.state.destinationComputeResource.resourceRef) {
                return null;
            }
            var selectedResource = this.state.destinationComputeResource.resourceRef;
            if (selectedResource.type !== this.managedEntityConstants.CLUSTER) {
                selectedResource = this.state.destinationComputeResource.clusterRef;
            }
            return selectedResource;
        };
        MigrationWizardManager.prototype.getPreselectedHostName = function (clusterId) {
            var self = this;
            if (self.state.isHotMigration) {
                // No preselection in hot migration.
                return self.$q.when(null);
            }
            // Preselect first host
            return self.dataService.getPropertiesByRelation(clusterId, "cluster", self.managedEntityConstants.HOST, ["name"]).then(function (result) {
                if (result && Object.keys(result).length === 1) {
                    return result[Object.keys(result)[0]].name;
                }
                return null;
            });
        };
        MigrationWizardManager.prototype.requestAdvancedStorageData = function (vmIds) {
            return this.dataService.getPropertiesForObjects(vmIds, ["migrateAdvancedStoragePageData"], { skipLoadingNotification: true });
        };
        MigrationWizardManager.prototype.getNetworkPageViewModeInternal = function () {
            return this._networkPageModel.getSelectNetworkPageViewMode();
        };
        MigrationWizardManager.prototype.changeComputeResource = function (item) {
            var _this = this;
            var oldUrn;
            if (this.state.destinationComputeResource !== null) {
                oldUrn = this.defaultUriSchemeUtil.getVsphereObjectId(this.state.destinationComputeResource.resourceRef);
            }
            var clusterName = "";
            var hostName = "";
            var resPoolName = "";
            var itemType = this.defaultUriSchemeUtil.getEntityType(item.id);
            if (itemType === this.managedEntityConstants.HOST) {
                clusterName = item.rawData && item.rawData.hostClusterName ? item.rawData.hostClusterName : "";
                hostName = item.name ? item.name : (item.rawData && item.rawData.name ? item.rawData.name : "");
            }
            else if (itemType === this.managedEntityConstants.CLUSTER) {
                clusterName = item.rawData ? item.rawData.name : item.name;
            }
            else if (itemType === this.managedEntityConstants.RESOURCE_POOL ||
                itemType === this.managedEntityConstants.V_APP) {
                resPoolName = item.rawData ? item.rawData.name : item.name;
            }
            return this.migrationService.validateComputeResource({
                vmIds: this.getVmIds(),
                computeResourceId: item.id,
                isHotMigration: this.state.isHotMigration,
                selectedMode: this.getSelectedMode(),
                isNetworkSelectionRequired: this._theModel.isNetworkSelectionRequired,
                clusterName: clusterName,
                resPoolName: resPoolName,
                hostName: hostName
            }).then(function (result) {
                _this.state.destinationComputeResource = result;
                var newUrn = _this.defaultUriSchemeUtil.getVsphereObjectId(_this.state.destinationComputeResource.resourceRef);
                _this.state.isComputeResourceChanged = oldUrn && (newUrn !== oldUrn);
                return result;
            });
        };
        MigrationWizardManager.prototype.clearSelectedComputeResource = function () {
            this.state.destinationComputeResource = {
                resourceRef: null,
                targetResourcePoolRef: null,
                hostName: null,
                clusterName: null,
                isValid: false
            };
        };
        MigrationWizardManager.prototype.createNetworksMessage = function () {
            var _this = this;
            var message = "";
            var changedNetworksMap = {};
            _.each(this.getNetworkMatches(), function (match) {
                var sourceNetworkUrn = _this.defaultUriSchemeUtil
                    .getVsphereObjectId(match.sourceNetwork);
                var destinationNetworkUrn = _this.defaultUriSchemeUtil
                    .getVsphereObjectId(match.destinationNetwork);
                if (sourceNetworkUrn === destinationNetworkUrn) {
                    return;
                }
                var key;
                if (_this.getNetworkPageViewModeInternal() === _this.NetworkPageViewModes.ADVANCED) {
                    key = _this.createUniqueAdapterKey(match.sourceVm, match.sourceAdapter.key);
                }
                else {
                    key = sourceNetworkUrn;
                }
                changedNetworksMap[key] = {
                    sourceNetworkName: match.sourceNetworkName,
                    destinationNetworkName: match.destinationNetworkName
                };
            });
            var changedKeys = Object.keys(changedNetworksMap);
            if (changedKeys.length <= 0) {
                message = this.i18nService
                    .getString("VmUi", "MigrationWizard.readyPage.noNetworkChanges");
            }
            else if (changedKeys.length === 1 &&
                this.getNetworkPageViewModeInternal() === this.NetworkPageViewModes.BASIC) {
                var sourceLabel = changedNetworksMap[changedKeys[0]].sourceNetworkName;
                if (!sourceLabel) {
                    sourceLabel = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.invalidNetworkName");
                }
                var destinationLabel = changedNetworksMap[changedKeys[0]].destinationNetworkName;
                if (!destinationLabel) {
                    destinationLabel = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.invalidNetworkName");
                }
                message = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.singleNetworkChangeBasic", sourceLabel, destinationLabel);
            }
            else if (changedKeys.length === 1 &&
                this.getNetworkPageViewModeInternal() === this.NetworkPageViewModes.ADVANCED) {
                message = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.networkChangesAdvancedSingle", changedKeys.length);
            }
            else if (this.getNetworkPageViewModeInternal() === this.NetworkPageViewModes.BASIC) {
                message = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.networkChangesBasic", changedKeys.length);
            }
            else if (this.getNetworkPageViewModeInternal() === this.NetworkPageViewModes.ADVANCED) {
                message = this.i18nService.getString("VmUi", "MigrationWizard.readyPage.networkChangesAdvanced", changedKeys.length);
            }
            return message;
        };
        // A helper method, that runtime asserts the value supplied as parameter
        // is not undefined.
        MigrationWizardManager.prototype.assertDefined = function (value) {
            if (value === undefined) {
                throw new Error("Unexpected object: " + value);
            }
            return value;
        };
        MigrationWizardManager.prototype.createUniqueAdapterKey = function (vmMoRef, adapterKey) {
            var vmUrn = this.defaultUriSchemeUtil.getVsphereObjectId(vmMoRef);
            return vmUrn + "$" + adapterKey;
        };
        MigrationWizardManager.prototype.getIsComputeResourceChanged = function () {
            return this.state.isComputeResourceChanged;
        };
        MigrationWizardManager.prototype.getStorageRecommendationsServiceInstance = function () {
            return this._storageRecommendationServiceInstance;
        };
        MigrationWizardManager.prototype.findStorageNameInMap = function (storageId, storageNameMap) {
            if (!storageId || _.isEmpty(storageNameMap)) {
                return "__missing__";
            }
            return storageNameMap[storageId];
        };
        MigrationWizardManager.prototype.getPmemDiskInfo = function () {
            var _this = this;
            var hasPmem = false, hasRegular = false;
            var hasDowngradedPmemDisk = false;
            // Loop using any in order to stop processing when we find at least 1 pmem
            // and 1 regular disk.
            _.any(this._theModel.virtualDisksByVm, function (vmDiskRecords) {
                for (var _i = 0, vmDiskRecords_1 = vmDiskRecords; _i < vmDiskRecords_1.length; _i++) {
                    var disk = vmDiskRecords_1[_i];
                    // Skip vmx record
                    if (disk.key === "_configFile") {
                        continue;
                    }
                    if (_this.storageProfileService.isPmemStorageProfile(disk.profile)) {
                        hasPmem = true;
                    }
                    else {
                        hasRegular = true;
                    }
                    if (disk.origin
                        && _this.pmemUtilService.isPmemDisk(disk.origin)
                        && !_this.storageProfileService.isPmemStorageProfile(disk.profile)) {
                        hasDowngradedPmemDisk = true;
                    }
                }
                return false;
            });
            return {
                hasPmemDisk: hasPmem,
                hasRegularDisk: hasRegular,
                hasDowngradedPmemDisk: hasDowngradedPmemDisk
            };
        };
        MigrationWizardManager.prototype.findFirstDiskFormat = function (virtualDisksByVm) {
            var firstFormat;
            var found = _.find(virtualDisksByVm, function (disksPerVm) {
                var firstDisk = _.find(disksPerVm, function (disk) { return !!disk.diskFormat; });
                if (firstDisk) {
                    firstFormat = firstDisk.diskFormat;
                    return true;
                }
                return false;
            });
            return firstFormat;
        };
        MigrationWizardManager.prototype.isXvMotion = function () {
            return this.state.isHotMigration &&
                this.getSelectedMode() === this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE;
        };
        return MigrationWizardManager;
    }());
    h5_vm.MigrationWizardManager = MigrationWizardManager; // class
    angular.module("com.vmware.vsphere.client.vm").factory("MigrationWizardManager", [
        "migrationService",
        "i18nService",
        "defaultUriSchemeUtil",
        "dataService",
        "$q",
        "managedEntityConstants",
        "datastoreService",
        "vmMigrateStorageLocatorService",
        "migrationTypeConstants",
        "datastoreRecommendationService",
        "storageProfileService",
        "NetworkPageViewModes",
        "vmMigrateStorageAdvancedSummaryBuilder",
        "VmStorageRecommendationsService",
        "vmXdrsRecommendationService",
        "storageSelectorService",
        "featureFlagsService",
        "migrationHelperService",
        "relatedItemsService",
        "pmemUtilService",
        function (migrationService, i18nService, defaultUriSchemeUtil, dataService, $q, managedEntityConstants, datastoreService, vmMigrateStorageLocatorService, migrationTypeConstants, datastoreRecommendationService, storageProfileService, NetworkPageViewModes, vmMigrateStorageAdvancedSummaryBuilder, vmStorageRecommendationsService, vmXdrsRecommendationService, storageSelectorService, featureFlagsService, migrationHelperService, relatedItemsService, pmemUtilService) {
            return function (wizardScope, vmProperties) {
                var manager = new MigrationWizardManager(migrationService, i18nService, defaultUriSchemeUtil, dataService, $q, managedEntityConstants, datastoreService, vmMigrateStorageLocatorService, migrationTypeConstants, datastoreRecommendationService, storageProfileService, vmMigrateStorageAdvancedSummaryBuilder, wizardScope, NetworkPageViewModes, vmStorageRecommendationsService, vmXdrsRecommendationService, vmProperties, storageSelectorService, featureFlagsService, migrationHelperService, relatedItemsService, pmemUtilService);
                return manager;
            };
        }
    ]);
})(h5_vm || (h5_vm = {})); // module



var h5_vm;
(function (h5_vm) {
    var VmMigrateStorageAdvancedSummaryBuilder = (function () {
        function VmMigrateStorageAdvancedSummaryBuilder(i18nService, diskFormatService, storageProfileService, defaultUriSchemeUtil, spbmReplicationGroupInfoService) {
            this.i18nService = i18nService;
            this.diskFormatService = diskFormatService;
            this.storageProfileService = storageProfileService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
        }
        VmMigrateStorageAdvancedSummaryBuilder.prototype.build = function (advancedSummaryData, entityNameMap, vmStorageRecommendationsService) {
            var _this = this;
            var result = [];
            this._entityNameMap = entityNameMap;
            this._vmStorageRecommendationsService = vmStorageRecommendationsService;
            this._selectedRecommendationDiskNames = this.buildStorageNameByDiskMap();
            this._topRecommendations = this._vmStorageRecommendationsService.getTopRecommendations();
            _.forEach(_.keys(advancedSummaryData.virtualDisksByVm), function (vmId) {
                var vmSummaryData = {
                    vmId: vmId,
                    vmName: entityNameMap[vmId],
                    diskStorage: []
                };
                _.forEach(advancedSummaryData.virtualDisksByVm[vmId], function (disk) {
                    vmSummaryData.diskStorage.push({
                        diskLabel: disk.label,
                        diskStorage: _this.getStorageLabel(vmId, disk),
                        diskProfile: disk.profile &&
                            (disk.profile.id !== _this.storageProfileService.DEFAULT_ID) ?
                            disk.profile.label : undefined,
                        diskReplicationGroup: disk.replicationGroup
                            ? _this.spbmReplicationGroupInfoService.getReplicationGroupName(disk.replicationGroup)
                            : "",
                        storageUrn: disk.storage,
                        parentStoragePodUrn: disk.parentStoragePod
                    });
                });
                result.push(vmSummaryData);
            });
            return result;
        };
        VmMigrateStorageAdvancedSummaryBuilder.prototype.getStorageLabel = function (vmId, disk) {
            var label;
            if (!this._selectedRecommendationDiskNames[vmId] || !this._selectedRecommendationDiskNames[vmId][disk.key]) {
                // If a recommendation is not available
                label = this.getString("MigrationWizard.readyPage.locationNonSdrs", disk.storage ? this._entityNameMap[disk.storage] : "", this.buildDiskFormatName(disk));
                return label;
            }
            var localizationStr = this.isTopRecommendation(vmId, disk)
                ? "MigrationWizard.readyPage.locationSdrsAuto" : "MigrationWizard.readyPage.locationSdrsManual";
            var podUrn = disk.parentStoragePod || disk.storage;
            label = this.getString(localizationStr, this._entityNameMap[podUrn], this.getString("MigrationWizard.readyPage.datastoreFormatValue", this._selectedRecommendationDiskNames[vmId][disk.key]), this.buildDiskFormatName(disk));
            return label;
        };
        VmMigrateStorageAdvancedSummaryBuilder.prototype.isTopRecommendation = function (vmId, disk) {
            var podUrn = disk.parentStoragePod || disk.storage;
            var topRecommendationKeyForDisk = this._topRecommendations[podUrn][vmId].key;
            var selectedRecommendations = this._vmStorageRecommendationsService.getSelectedRecommendationsByVm();
            var isTopRecommendation = _.some(selectedRecommendations[vmId], function (rec) {
                return rec.key === topRecommendationKeyForDisk;
            });
            return isTopRecommendation;
        };
        VmMigrateStorageAdvancedSummaryBuilder.prototype.buildStorageNameByDiskMap = function () {
            var _this = this;
            var diskNameMap = {};
            _.each(this._vmStorageRecommendationsService.getSelectedRecommendationsByVm(), function (recommendations, vmId) {
                if (!diskNameMap[vmId]) {
                    diskNameMap[vmId] = {};
                }
                _.each(recommendations, function (recommendation) {
                    _.each(recommendation.action, function (action) {
                        if (!action.relocateSpec.disk) {
                            // It is the config file
                            var datastoreId = _this.defaultUriSchemeUtil.getVsphereObjectId(action.relocateSpec.datastore);
                            diskNameMap[vmId]["_configFile"] = _this._entityNameMap[datastoreId];
                            return;
                        }
                        _.each(action.relocateSpec.disk, function (disk) {
                            var datastoreId = _this.defaultUriSchemeUtil.getVsphereObjectId(disk.datastore);
                            diskNameMap[vmId][disk.diskId] = _this._entityNameMap[datastoreId];
                        });
                    });
                });
            });
            return diskNameMap;
        };
        VmMigrateStorageAdvancedSummaryBuilder.prototype.buildDiskFormatName = function (disk) {
            if (disk.diskFormat) {
                return this.getString("MigrationWizard.readyPage.diskFormatValue", disk.diskFormat.label);
            }
            // Lack of specific disk format means "same as source".
            if (disk.key !== "_configFile") {
                return this.getString("MigrationWizard.readyPage.diskFormatValue", this.diskFormatService.diskFormats.sameAsSource.name);
            }
            // For VMX files disk format does not make sense.
            return "";
        };
        VmMigrateStorageAdvancedSummaryBuilder.prototype.getString = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return (_a = this.i18nService).getString.apply(_a, ["VmUi", key].concat(params));
            var _a;
        };
        ;
        VmMigrateStorageAdvancedSummaryBuilder.$inject = [
            'i18nService',
            'diskFormatService',
            'storageProfileService',
            'defaultUriSchemeUtil',
            'spbmReplicationGroupInfoService'
        ];
        return VmMigrateStorageAdvancedSummaryBuilder;
    }());
    h5_vm.VmMigrateStorageAdvancedSummaryBuilder = VmMigrateStorageAdvancedSummaryBuilder; // end of migrateStorageSummaryBuilder
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmMigrateStorageAdvancedSummaryBuilder", VmMigrateStorageAdvancedSummaryBuilder);
})(h5_vm || (h5_vm = {})); // end of h5_vm namespace



var h5_vm;
(function (h5_vm) {
    var VmMigrateStorageLocatorService = (function () {
        function VmMigrateStorageLocatorService(dataService, storageLocatorService, defaultUriSchemeUtil) {
            this.dataService = dataService;
            this.storageLocatorService = storageLocatorService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        VmMigrateStorageLocatorService.prototype.getStorageLocatorData = function (migrationOptions) {
            return this.dataService.getProperties(migrationOptions.vms[0], VmMigrateStorageLocatorService.PROPERTY_STORAGE_LOCATOR_ITEMS_DATA, {
                propertyParams: [{
                        propertyName: VmMigrateStorageLocatorService.PROPERTY_STORAGE_LOCATOR_ITEMS_DATA,
                        parameterType: "com.vmware.vsphere.client.h5.vm.model.migration.VmMigrationStorageLocatorSpec",
                        parameter: {
                            vms: this.defaultUriSchemeUtil
                                .getManagedObjectReferences(migrationOptions.vms),
                            resource: migrationOptions.resource ?
                                this.defaultUriSchemeUtil
                                    .getManagedObjectReference(migrationOptions.resource) :
                                undefined
                        }
                    }]
            })
                .then(function (response) {
                return response ?
                    response[VmMigrateStorageLocatorService.PROPERTY_STORAGE_LOCATOR_ITEMS_DATA] :
                    null;
            });
        };
        VmMigrateStorageLocatorService.prototype.getStorageObjectNameMap = function (storageLocatorItemsData) {
            return this.storageLocatorService
                .getStorageObjectNameMap(storageLocatorItemsData);
        };
        VmMigrateStorageLocatorService.$inject = ["dataService", "storageLocatorService", "defaultUriSchemeUtil"];
        VmMigrateStorageLocatorService.PROPERTY_STORAGE_LOCATOR_ITEMS_DATA = "storageLocator:migrationStorageLocatorItemsData";
        return VmMigrateStorageLocatorService;
    }());
    h5_vm.VmMigrateStorageLocatorService = VmMigrateStorageLocatorService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmMigrateStorageLocatorService", VmMigrateStorageLocatorService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CalculateProvisioningCostSpec = com.vmware.vsphere.client.spbm.spec.CalculateProvisioningCostSpec;
    var ProfileId = com.vmware.vim.binding.pbm.profile.ProfileId;
    var VmMigrateStorageSelectionValidationService = (function () {
        function VmMigrateStorageSelectionValidationService(authorizationService, compatibilityCheckService, i18nService, migrationService, compatibilityResultsPresenter, $q, defaultUriSchemeUtil, managedEntityConstants, dataService, bytesFilter, storageProfileService, spbmReplicationGroupInfoService) {
            this.authorizationService = authorizationService;
            this.compatibilityCheckService = compatibilityCheckService;
            this.i18nService = i18nService;
            this.migrationService = migrationService;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.dataService = dataService;
            this.bytesFilter = bytesFilter;
            this.storageProfileService = storageProfileService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
        }
        VmMigrateStorageSelectionValidationService.prototype.validateSelection = function (validationModel) {
            var _this = this;
            return this.$q.all({
                compatibilityArray: this.checkCompatibility(validationModel),
                privilegesMap: this.checkPrivileges(validationModel),
                placementMap: this.checkVmPlacement(validationModel),
                provisioningCostMap: this.requestProvisioningCost(validationModel)
            }).then(function (result) {
                // Here we iterate the compatibility array
                // on each vm we get the errors and warnings from the other maps
                // finally we call the formatter with the new data
                var compatibilitySuccessMap = _this.getSuccessByVm(result.compatibilityArray);
                var replicationGroupMap = _this.checkReplicationGroupAssignments(validationModel);
                _.each(result.compatibilityArray, function (validationResult) {
                    if (validationResult.result) {
                        _this.addToValidationResult(result.privilegesMap, validationResult);
                        _this.addToValidationResult(result.placementMap, validationResult);
                        _this.addToValidationResult(result.provisioningCostMap, validationResult);
                        _this.addToValidationResult(replicationGroupMap, validationResult);
                    }
                });
                return _this.compatibilityResultsPresenter.formatValidationResults(result.compatibilityArray).then(function (compatibilityMessages) {
                    if (compatibilityMessages.length > 0) {
                        return {
                            compatibilityMessages: compatibilityMessages,
                            hasSuccess: _this.hasSuccess(compatibilitySuccessMap, result.privilegesMap.successMap, result.placementMap.successMap, result.provisioningCostMap.successMap, replicationGroupMap.successMap)
                        };
                    }
                    return {
                        compatibilityMessages: [{
                                icon: "vsphere-icon-status-ok",
                                message: _this.i18nService.getString("VmUi", "ProvisioningWizard.CompatibilityChecksSucceeded"),
                                contents: []
                            }],
                        hasSuccess: true
                    };
                });
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.addToValidationResult = function (resultMap, validationResult) {
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity);
            var currentResult = {
                error: _.map(resultMap.compatibilityData[vmId].errors, function (error) {
                    return {
                        message: error.message,
                        localizedMessage: error.message
                    };
                }),
                warning: _.map(resultMap.compatibilityData[vmId].warnings, function (warning) {
                    return {
                        message: warning.message,
                        localizedMessage: warning.message
                    };
                }),
                info: _.map(resultMap.compatibilityData[vmId].infos, function (info) {
                    return {
                        message: info.message,
                        localizedMessage: info.message
                    };
                }),
                host: this.compatibilityResultsPresenter.NO_HOST_REF,
                vm: validationResult.entity
            };
            if (!currentResult.error.length && !currentResult.warning.length
                && !currentResult.info.length) {
                return;
            }
            validationResult.result.push(currentResult);
        };
        VmMigrateStorageSelectionValidationService.prototype.hasSuccess = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var vms = arguments[0];
            _.each(arguments, function (successMap) {
                if (successMap !== vms) {
                    _.each(vms, function (state, vmId) {
                        vms[vmId] = vms[vmId] && successMap[vmId];
                    });
                }
            });
            var result = true;
            _.each(vms, function (vmState) {
                result = result && vmState;
            });
            return result;
        };
        VmMigrateStorageSelectionValidationService.prototype.checkPrivileges = function (validationModel) {
            var _this = this;
            var storageIds = [];
            _.each(validationModel.virtualDisksByVm, function (vmDisks) {
                _.each(vmDisks, function (vmDisk) {
                    if (!!vmDisk.storage && storageIds.indexOf(vmDisk.storage) === -1) {
                        storageIds.push(vmDisk.storage);
                    }
                });
            });
            return this.authorizationService.checkPrivilegesForMultipleObjects(storageIds, ["Datastore.AllocateSpace"]).then(function (privilegesMap) {
                var vmCompatibilityMap = {};
                var successMap = {};
                _.each(validationModel.virtualDisksByVm, function (vmDisks, vmId) {
                    vmCompatibilityMap[vmId] = {
                        errors: [],
                        warnings: [],
                        infos: []
                    };
                    _.each(vmDisks, function (vmDisk) {
                        // For PMEM storage is optional. We need to skip those disks.
                        if (!vmDisk.storage) {
                            return;
                        }
                        if (!privilegesMap[vmDisk.storage]["Datastore.AllocateSpace"]) {
                            vmCompatibilityMap[vmId].errors = [{
                                    icon: "vsphere-icon-status-error",
                                    message: _this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.NoPermissionOnDatastore"),
                                    contents: []
                                }];
                            successMap[vmId] = false;
                        }
                        else {
                            successMap[vmId] = true;
                        }
                    });
                });
                return {
                    compatibilityData: vmCompatibilityMap,
                    successMap: successMap
                };
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.checkCompatibility = function (validationModel) {
            return this.migrationService.validateStorage(validationModel).then(function (validationResultsArray) {
                return validationResultsArray;
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.checkVmPlacement = function (validationModel) {
            var _this = this;
            var assignmentsWithProfiles = [];
            // The map contains the index in the assignmentsWithProfiles of each of the vm disks.
            // The index is undefined if the disk is not added to assignmentsWithProfiles.
            // The map used for mapping the result to the corresponding vm disk.
            var diskResultIndexMap = {};
            var vmCompatibilityMap = {};
            var successMap = {};
            // Init the maps and inspect the disks for profile info.
            _.each(validationModel.virtualDisksByVm, function (vmDisks, vmId) {
                diskResultIndexMap[vmId] = {};
                successMap[vmId] = true;
                vmCompatibilityMap[vmId] = {
                    errors: [],
                    warnings: [],
                    infos: []
                };
                _.each(vmDisks, function (disk) {
                    if (disk.profile) {
                        diskResultIndexMap[vmId][disk.key] = assignmentsWithProfiles.length;
                        assignmentsWithProfiles.push({
                            storageId: disk.storage,
                            profile: disk.profile
                        });
                    }
                });
            });
            if (assignmentsWithProfiles.length === 0) {
                return this.$q.resolve({
                    compatibilityData: vmCompatibilityMap,
                    successMap: successMap
                });
            }
            return this.compatibilityCheckService.validateVmPlacementForMultipleVmsNoFilter(assignmentsWithProfiles)
                .then(function (result) {
                return _this.formatVmPlacementResults(result, validationModel, diskResultIndexMap);
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.checkReplicationGroupAssignments = function (validationModel) {
            var _this = this;
            var vmCompatibilityMap = {};
            var successMap = {};
            _.each(validationModel.virtualDisksByVm, function (vmDisks, vmId) {
                vmCompatibilityMap[vmId] = {
                    errors: [],
                    warnings: [],
                    infos: []
                };
                var vmRgAssignments = [];
                vmDisks.forEach(function (vmDisk) {
                    if (vmDisk.replicationGroup) {
                        vmRgAssignments.push(vmDisk.replicationGroup);
                    }
                });
                var validationError = _this.spbmReplicationGroupInfoService
                    .validateVmReplicationGroupAssignments(vmRgAssignments);
                if (validationError) {
                    vmCompatibilityMap[vmId].errors = [{
                            icon: "vsphere-icon-status-error",
                            message: validationError,
                            contents: []
                        }];
                    successMap[vmId] = false;
                }
                else {
                    successMap[vmId] = true;
                }
            });
            return {
                compatibilityData: vmCompatibilityMap,
                successMap: successMap
            };
        };
        VmMigrateStorageSelectionValidationService.prototype.formatVmPlacementResults = function (result, validationModel, diskResultIndexMap) {
            var _this = this;
            var vmCompatibilityMap = {};
            var successMap = {};
            _.each(validationModel.virtualDisksByVm, function (vmDisks, vmId) {
                vmCompatibilityMap[vmId] = {
                    errors: [],
                    warnings: [],
                    infos: []
                };
                var spbmPolicyWarning = _this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.SpbmPolicyWarning");
                var spbmPolicyWarningAdded = false;
                _.each(vmDisks, function (disk) {
                    var idx = diskResultIndexMap[vmId][disk.key];
                    if (idx === undefined) {
                        return;
                    }
                    _.each(result.errors[idx], function (error) {
                        if (!error) {
                            return;
                        }
                        var errorMessage = error.localizedMessage || error.message;
                        if (!errorMessage && error.faultMessage && error.faultMessage.length > 0) {
                            errorMessage = error.faultMessage[0].message;
                        }
                        if (errorMessage) {
                            var containsError = _.any(vmCompatibilityMap[vmId].errors, function (errorObj) {
                                return errorObj.message === errorMessage;
                            });
                            if (!containsError) {
                                vmCompatibilityMap[vmId].errors.push({
                                    icon: "vsphere-icon-status-error",
                                    message: errorMessage,
                                    contents: []
                                });
                            }
                            return;
                        }
                    });
                    // In case the server returns a generic message (e.g. VSAN policy message on VC 6.0),
                    // we return only that message. In case it returns a more specific message,
                    // we return the specific message
                    _.each(result.warnings[idx], function (warning) {
                        if (!warning) {
                            return;
                        }
                        var warningObj = {
                            icon: "vsphere-icon-status-warning",
                            message: spbmPolicyWarning,
                            contents: []
                        };
                        var warningMessage = warning.localizedMessage;
                        if (!warningMessage && warning.faultMessage &&
                            warning.faultMessage.length > 0) {
                            warningMessage = warning.faultMessage[0].message;
                        }
                        if (warningMessage) {
                            var containsWarning = _.any(vmCompatibilityMap[vmId].warnings, function (warning) {
                                return warning.message === warningMessage;
                            });
                            if (!containsWarning) {
                                warningObj.message = warningMessage;
                                vmCompatibilityMap[vmId].warnings.push(warningObj);
                            }
                            return;
                        }
                        if (!spbmPolicyWarningAdded) {
                            spbmPolicyWarningAdded = true;
                            vmCompatibilityMap[vmId].warnings.push(warningObj);
                        }
                    });
                });
                successMap[vmId] = !vmCompatibilityMap[vmId].errors.length;
            });
            return {
                compatibilityData: vmCompatibilityMap,
                successMap: successMap
            };
        };
        VmMigrateStorageSelectionValidationService.prototype.requestProvisioningCost = function (validationModel) {
            var _this = this;
            var vsanStorageType = "vsan";
            var vitrualDisksByVm = validationModel.virtualDisksByVm;
            var firstVmDisks = vitrualDisksByVm[validationModel.vms[0]];
            var vcId = this.defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(firstVmDisks[0].storage);
            var specs = [];
            var containsVsan = false;
            _.each(vitrualDisksByVm, function (singleVmDisks) {
                _.each(singleVmDisks, function (singleDisk) {
                    containsVsan = containsVsan || singleDisk.storageType === vsanStorageType;
                    var spec = _this.createCalculateCostSpec(singleDisk);
                    specs.push(spec);
                });
            });
            if (!containsVsan) {
                return this.$q.when(this.formatDiskCostSpec([], vitrualDisksByVm));
            }
            return this.dataService.getProperties(vcId, ["spbmCreateCostData"], {
                propertyParams: [{
                        propertyName: "spbmCreateCostData",
                        parameterType: "[Lcom.vmware.vsphere.client.spbm.spec.CalculateProvisioningCostSpec;",
                        parameter: specs
                    }]
            }).then(function (response) {
                return _this.formatDiskCostSpec(response.spbmCreateCostData, vitrualDisksByVm);
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.createCalculateCostSpec = function (disk) {
            var spec = new CalculateProvisioningCostSpec();
            // Note: The config file has no capacityInBytes
            spec.sizeInBytes = disk.capacityInBytes ? disk.capacityInBytes : 1;
            if (disk.profile && disk.profile.id !== this.storageProfileService.DEFAULT_ID) {
                spec.profileId = new ProfileId();
                spec.profileId.uniqueId = disk.profile.id;
            }
            spec.storageContainer = this.defaultUriSchemeUtil.getManagedObjectReference(disk.storage);
            return spec;
        };
        VmMigrateStorageSelectionValidationService.prototype.formatDiskCostSpec = function (response, vitrualDisksByVm) {
            var _this = this;
            if (!response || !response.length) {
                var compMap_1 = {};
                var successMap_1 = {};
                _.each(vitrualDisksByVm, function (singleVmDisks, vmId) {
                    compMap_1[vmId] = {
                        errors: [],
                        warnings: [],
                        infos: []
                    };
                    successMap_1[vmId] = true;
                });
                return {
                    compatibilityData: compMap_1,
                    successMap: successMap_1
                };
            }
            var idx = 0;
            var vmCompatibilityMap = {};
            var successMap = {};
            var showConsumptionMap = {};
            _.each(vitrualDisksByVm, function (singleVmDisks, vmId) {
                var vmDataUsage = 0;
                var vmSsdUsage = 0;
                vmCompatibilityMap[vmId] = {
                    errors: [],
                    warnings: [],
                    infos: []
                };
                successMap[vmId] = true;
                _.each(singleVmDisks, function (singleDisk) {
                    var costData = response[idx];
                    idx++;
                    var policySatisfiability = costData.cost;
                    var diskCapacityInBytes = costData.size;
                    if (policySatisfiability && policySatisfiability.reason
                        && policySatisfiability.reason.message) {
                        if (!policySatisfiability.isSatisfiable) {
                            // add warning
                            if (!_this.containsMessage(vmCompatibilityMap[vmId].warnings, policySatisfiability.reason.message)) {
                                vmCompatibilityMap[vmId].warnings.push({
                                    icon: "vsphere-icon-status-warning",
                                    message: policySatisfiability.reason.message,
                                    contents: []
                                });
                            }
                            showConsumptionMap[vmId] = false;
                        }
                        else {
                            // add info
                            if (!_this.containsMessage(vmCompatibilityMap[vmId].infos, policySatisfiability.reason.message)) {
                                vmCompatibilityMap[vmId].infos.push({
                                    icon: "vsphere-icon-help-info-hover",
                                    message: policySatisfiability.reason.message,
                                    contents: []
                                });
                            }
                            if (showConsumptionMap[vmId] === undefined) {
                                showConsumptionMap[vmId] = true;
                            }
                        }
                    }
                    if (policySatisfiability && policySatisfiability.isSatisfiable &&
                        policySatisfiability.cost) {
                        var policyCost = policySatisfiability.cost;
                        // We are interested in the projected capacity of the disk when it
                        // is fully provisioned.
                        vmDataUsage += diskCapacityInBytes *
                            policyCost.diskSpaceToAddressSpaceRatio;
                        vmSsdUsage += policyCost.currentFlashReadCacheSize +
                            policyCost.changeFlashReadCacheSize;
                        if (showConsumptionMap[vmId] === undefined) {
                            showConsumptionMap[vmId] = true;
                        }
                    }
                });
                if (!showConsumptionMap[vmId]) {
                    return;
                }
                vmCompatibilityMap[vmId].infos.push({
                    icon: "vsphere-icon-help-info-hover",
                    message: _this.i18nService.getString("VmUi", "whatIf.vsanConsumption", _this.bytesFilter(vmDataUsage), _this.bytesFilter(vmSsdUsage)),
                    contents: []
                });
            });
            return {
                compatibilityData: vmCompatibilityMap,
                successMap: successMap
            };
        };
        VmMigrateStorageSelectionValidationService.prototype.containsMessage = function (messageArray, message) {
            return _.any(messageArray, function (messageObj) {
                return messageObj.message === message;
            });
        };
        VmMigrateStorageSelectionValidationService.prototype.getSuccessByVm = function (validationResultsArray) {
            var _this = this;
            var successCountByVmId = {};
            _.each(validationResultsArray, function (validationResult) {
                var vmId = _this.defaultUriSchemeUtil.getVsphereObjectId(validationResult.entity);
                _.each(validationResult.result, function (result) {
                    if (!successCountByVmId[vmId]) {
                        successCountByVmId[vmId] = 0;
                    }
                    if (!result.error) {
                        successCountByVmId[vmId]++;
                    }
                });
                if (!validationResult.result && validationResult.error) {
                    if (!successCountByVmId[vmId]) {
                        successCountByVmId[vmId] = 0;
                    }
                }
            });
            var succesByVmId = {};
            _.each(successCountByVmId, function (successCount, vmId) {
                succesByVmId[vmId] = successCount >= 1;
            });
            return succesByVmId;
        };
        VmMigrateStorageSelectionValidationService.$inject = [
            "authorizationService",
            "compatibilityCheckService",
            "i18nService",
            "migrationService",
            "compatibilityResultsPresenter",
            "$q",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "dataService",
            "bytesFilter",
            "storageProfileService",
            "spbmReplicationGroupInfoService"
        ];
        return VmMigrateStorageSelectionValidationService;
    }());
    h5_vm.VmMigrateStorageSelectionValidationService = VmMigrateStorageSelectionValidationService; // class VmMigrateStorageSelectionValidationService
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrateStorageSelectionValidationService", VmMigrateStorageSelectionValidationService);
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    /**
     * Processes vm storage configuration required for migrating a vm to a resource in
     * another datacenter when vm storage is not to be changed. If a datastore is added to
     * hosts in different datacenters it is represented in the inventory by 2 separate
     * MORs and the datastores are considered mirrored`. In this case we should specify
     * the MOR of the mirror datastore in the final relocate spec. This is why we need
     * to find those mirror datastore refs and give it ot the relocate API.
     */
    var VmMigrateStretchedStorageService = (function () {
        function VmMigrateStretchedStorageService($q, dataServiceUtil, defaultUriSchemeUtil, managedEntityConstants) {
            this.$q = $q;
            this.dataServiceUtil = dataServiceUtil;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.PROP_DC = "dc";
            this.PROP_VM_DS_INFO = "vmDatastoresInfo";
            this.PROP_VM_VIRTUAL_DISKS = "virtualDisks";
            this.PROP_VM_HOME_DATASTORE = "vmHomeDatastore";
            this._objectProperties = {};
        }
        /**
         * Collects VM storage configuration given a target resource (Host, Cluster
         * Resource pool, VApp). For all vms NOT in the target resource datacenter returns
         * storage configuration containing the correct MORs to the mirrored datastores
         * that need to be used for vm config file and vm disks location
         * @param targetResource The host, cluster, resource pool or vapp where vms are to
         *    be migrated.
         * @param sourceVms The vms being migrated
         * @returns {any} A promise resolved with dictionary containing an array of
         *    VirtualDiskRecord objects for each vm that is no the the same datacenter
         *    as the target resource. If all vms are in the same datacenter returned
         *    promise is resolved with undefined.
         */
        VmMigrateStretchedStorageService.prototype.processStretchedStorage = function (targetResource, sourceVms) {
            var _this = this;
            return this.fetchVmsUsingStretchedStorage(targetResource, sourceVms).then(function (vms) {
                if (!vms.length) {
                    return undefined;
                }
                var requests = [
                    _this.fetchVmProperties(vms),
                    _this.fetchAccessibleDatastores(targetResource)];
                return _this.$q.all(requests).then(function () {
                    var result = _this.buildVmDisksRecords(targetResource, vms);
                    return result;
                });
            });
        };
        /**
         * Returns a promise resolved with an array containing all vms that are not in the
         * target resource datacenter.
         */
        VmMigrateStretchedStorageService.prototype.fetchVmsUsingStretchedStorage = function (targetResource, vms) {
            var _this = this;
            return this.requestMissingProperties(vms.concat(targetResource), [this.PROP_DC]).then(function () {
                var targetDc = _this._objectProperties[targetResource][_this.PROP_DC];
                return _.filter(vms, function (vmId) {
                    return !_this.equalReferences(_this._objectProperties[vmId][_this.PROP_DC], targetDc);
                });
            });
        };
        VmMigrateStretchedStorageService.prototype.fetchVmProperties = function (vms) {
            return this.requestMissingProperties(vms, [
                this.PROP_VM_DS_INFO,
                this.PROP_VM_HOME_DATASTORE,
                this.PROP_VM_VIRTUAL_DISKS]);
        };
        VmMigrateStretchedStorageService.prototype.fetchAccessibleDatastores = function (targetResource) {
            return this.requestMissingProperties([targetResource], [this.getDatastorePropertyName(targetResource)]);
        };
        VmMigrateStretchedStorageService.prototype.getDatastorePropertyName = function (targetResource) {
            var objectType = this.defaultUriSchemeUtil.getEntityType(targetResource);
            var datastoreProperty = objectType === this.managedEntityConstants.V_APP
                || objectType === this.managedEntityConstants.RESOURCE_POOL ?
                "computeResourceDatastore" : "datastore";
            return datastoreProperty;
        };
        /**
         * Checks whether all properties have already been retrieved for the object and if
         * all have been fetched returns those values. Otherwise, if any give property
         * is missing then fetches all properties specified.
         */
        VmMigrateStretchedStorageService.prototype.requestMissingProperties = function (objs, properties) {
            var _this = this;
            // Data should be retrieved for an object if no data for the object has yet been
            // retrieved or some properties are missing.
            var missingObjs = _.filter(objs, function (obj) {
                return !_this._objectProperties[obj]
                    || _.some(properties, function (prop) { return !_this._objectProperties[obj][prop]; });
            });
            return !objs.length ?
                this.$q.resolve() :
                this.dataServiceUtil.getPropertiesForObjects(missingObjs, properties).then(function (response) {
                    _this.addPropertiesToCache(response);
                });
        };
        VmMigrateStretchedStorageService.prototype.addPropertiesToCache = function (response) {
            var _this = this;
            _.each(response, function (data, objId) {
                if (!_this._objectProperties[objId]) {
                    _this._objectProperties[objId] = data;
                }
                else {
                    angular.extend(_this._objectProperties[objId], data);
                }
            });
        };
        VmMigrateStretchedStorageService.prototype.buildVmDisksRecords = function (targetHost, vms) {
            var _this = this;
            var diskByVm = {};
            var resourceAccessibleDatastores = this._objectProperties[targetHost][this.getDatastorePropertyName(targetHost)];
            _.each(vms, function (vmId) {
                var props = _this._objectProperties[vmId];
                diskByVm[vmId] = [{
                        key: "_configFile",
                        storage: _this.findMirroredDatastore(_.find(props[_this.PROP_VM_DS_INFO], function (dsInfo) { return _this.equalReferences(dsInfo.ref, props[_this.PROP_VM_HOME_DATASTORE]); }), resourceAccessibleDatastores)
                    }];
                _.each(props[_this.PROP_VM_VIRTUAL_DISKS], function (diskData) {
                    diskByVm[vmId].push({
                        key: diskData.key,
                        storage: _this.findMirroredDatastore(_.find(props[_this.PROP_VM_DS_INFO], function (dsInfo) { return _this.equalReferences(dsInfo.ref, diskData.backing.datastore); }), resourceAccessibleDatastores)
                    });
                });
            });
            return diskByVm;
        };
        VmMigrateStretchedStorageService.prototype.findMirroredDatastore = function (vmDatastoreInfo, resourceAccessibleDatastores) {
            var _this = this;
            var mirrorRef = _.find(vmDatastoreInfo.mirrors, function (mirrorRef) {
                return _.find(resourceAccessibleDatastores, function (datastoreRef) {
                    return _this.equalReferences(datastoreRef, mirrorRef);
                });
            });
            return this.defaultUriSchemeUtil.getVsphereObjectId(mirrorRef);
        };
        VmMigrateStretchedStorageService.prototype.equalReferences = function (ref1, ref2) {
            return (ref1.value === ref2.value) &&
                (ref1.type === ref2.type) &&
                (ref1.serverGuid === ref2.serverGuid);
        };
        VmMigrateStretchedStorageService.$inject = ["$q", "dataServiceUtil", "defaultUriSchemeUtil", "managedEntityConstants"];
        return VmMigrateStretchedStorageService;
    }());
    h5_vm.VmMigrateStretchedStorageService = VmMigrateStretchedStorageService;
    angular.module("com.vmware.vsphere.client.vm").factory("vmMigrateStretchedStorageService", ["$injector", function ($injector) {
            return {
                newInstance: function () {
                    return $injector.instantiate(VmMigrateStretchedStorageService);
                }
            };
        }]);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var ValidateComputeResourceStateBuilder = (function () {
        function ValidateComputeResourceStateBuilder(managedEntityConstants, defaultUriSchemeUtil) {
            this.managedEntityConstants = managedEntityConstants;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this._isValid = false;
        }
        ValidateComputeResourceStateBuilder.prototype.setComputeResource = function (computeResource) {
            this._computeResourceId = computeResource;
            this._computeResourceType = this.defaultUriSchemeUtil.getEntityType(computeResource);
            return this;
        };
        ValidateComputeResourceStateBuilder.prototype.setData = function (data) {
            this._data = data;
            return this;
        };
        ValidateComputeResourceStateBuilder.prototype.setIsValid = function (isValid) {
            this._isValid = isValid;
            return this;
        };
        ValidateComputeResourceStateBuilder.prototype.setValidationResult = function (validationResult) {
            this._validationResult = validationResult;
            return this;
        };
        ValidateComputeResourceStateBuilder.prototype.setParams = function (params) {
            this._params = params;
            return this;
        };
        ValidateComputeResourceStateBuilder.prototype.build = function () {
            var data = this._data;
            var state = {
                resourceRef: this.defaultUriSchemeUtil
                    .getManagedObjectReference(this._computeResourceId),
                targetResourcePoolRef: data.result.resourcePoolRef,
                hostName: data.result.hostName ? data.result.hostName : this._params.hostName,
                clusterName: (data.result.clusterName ? data.result.clusterName : this._params.clusterName),
                isValid: this._isValid,
                validationResults: this.transformErrorsIntoWarningsIfNeeded(this._validationResult)
            };
            if (this._computeResourceType === this.managedEntityConstants.V_APP ||
                this._computeResourceType === this.managedEntityConstants.RESOURCE_POOL) {
                _.extend(state, {
                    hostRef: data.result.hostRef,
                    resPoolName: data.result.resourcePoolName ? data.result.resourcePoolName : this._params.resPoolName,
                    clusterRef: data.result.clusterRef
                });
            }
            this.cleanup();
            return state;
        };
        ValidateComputeResourceStateBuilder.prototype.cleanup = function () {
            this._computeResourceId = null;
            this._computeResourceType = "";
            this._data = null;
        };
        ValidateComputeResourceStateBuilder.prototype.transformErrorsIntoWarningsIfNeeded = function (validationResults) {
            // When the compute resource is a cluster, resource pool or a vApp
            // and the overall validation is successful - remove the error messages for
            // individual hosts.
            if ((this._computeResourceType === this.managedEntityConstants.CLUSTER
                || this._computeResourceType === this.managedEntityConstants.RESOURCE_POOL
                || this._computeResourceType === this.managedEntityConstants.V_APP)
                && this._isValid) {
                return _.map(validationResults, function (validationResult) {
                    var result = _.extend({}, validationResult);
                    _.each(result.result, function (hostResult) {
                        if (!!hostResult.error) {
                            hostResult.warning = hostResult.warning
                                ? hostResult.warning.concat(hostResult.error)
                                : hostResult.error;
                            hostResult.error = null;
                        }
                        return hostResult;
                    });
                    return result;
                });
            }
            return validationResults;
        };
        return ValidateComputeResourceStateBuilder;
    }());
    h5_vm.ValidateComputeResourceStateBuilder = ValidateComputeResourceStateBuilder;
    angular.module("com.vmware.vsphere.client.vm")
        .factory("vmMigrateValidateComputeResourceStateBuilderFactory", ["managedEntityConstants", "defaultUriSchemeUtil",
        function (managedEntityConstants, defaultUriSchemeUtil) {
            return {
                create: function () {
                    return new ValidateComputeResourceStateBuilder(managedEntityConstants, defaultUriSchemeUtil);
                }
            };
        }]);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var MoveVmViewComponent = (function () {
        function MoveVmViewComponent() {
            this.bindings = {
                objectIds: "<",
                isTemplate: "<",
                datacenter: "<",
                // for move of a single vm
                virtualCenter: "<",
                // in environment with many VCs we should display only
                // the one from that all selected vms are.
                // the move to action should not be available for selection
                // of multiple vms from different VCs
                onSubmit: "=",
                // when `Ok` is pressed
                submitDisabled: "=",
                // `OK` button should be disabled
                alerts: "=",
                // an alert will be shown
                closeModal: "<" // method of the modal dialog, when invoked the modal closes
            };
            this.controller = MoveVmController;
            this.templateUrl = "vm-ui/resources/vm/services/wizards/moveVm/moveVmViewComponent.html";
        }
        return MoveVmViewComponent;
    }());
    h5_vm.MoveVmViewComponent = MoveVmViewComponent;
    var MoveVmController = (function () {
        /**
         * Builds the initial state of the modal dialog content
         * - sets the `OK` button as disabled
         * - initializes the onSubmit method that will be called after `OK` is pressed
         * @param moveVmService
         * @param i18nService
         * @param $element
         * @param $timeout
         */
        function MoveVmController(moveVmService, i18nService, vuiConstants, $element, $timeout) {
            var _this = this;
            this.$element = $element;
            this.$timeout = $timeout;
            this.loading = false;
            this._moveVmService = moveVmService;
            this._i18nService = i18nService;
            // mark the `OK` button as disabled
            this.submitDisabled = true;
            this.loadingLabel = this._i18nService.getString("CommonUi", "wizard.loading");
            this.treeAriaDescription = this._i18nService.getString("VmUi", "MoveToFolderDialog.treeDescription");
            this.tabName = this._i18nService.getString("VmUi", "actionMoveVmInventoryFolder");
            this.treeHtml = "vm_folders_tree.html";
            if (this.objectIds.length === 1) {
                this.treeHtml = "vm_folders_in_datacenter_tree.html";
            }
            // initializes the onSubmit method that will be called after `OK` is pressed
            // it closes the modal and applies the move operation
            this.onSubmit = function () {
                _this.submitDisabled = true;
                _this.loading = true;
                _this._moveVmService
                    .validateMove(_this.objectIds, _this._targetId).then(function (error) {
                    if (!error) {
                        _this._moveVmService.applyMove(_this.objectIds, _this._targetId);
                        _this.closeModal();
                    }
                    else {
                        var alert_1 = {
                            type: vuiConstants.validationBanner.type.ERROR,
                            text: error
                        };
                        _this.alerts = [alert_1];
                    }
                    _this.loading = false;
                    _this.submitDisabled = false;
                });
            };
        }
        MoveVmController.prototype.$onInit = function () {
            var _this = this;
            this.$timeout(function () {
                var firstTab = _this.$element[0].querySelector("button");
                if (firstTab) {
                    firstTab.focus();
                }
            }, 0);
        };
        /**
         * Invoked when the selection in the tree is changed.
         * Marks the `OK` button as enabled, because now we have a selection in the tree
         * And saves the selected object id
         * @param objectId
         */
        MoveVmController.prototype.onLocationSelected = function (objectId) {
            this.submitDisabled = false;
            this._targetId = objectId;
        };
        MoveVmController.$inject = ["moveVmService", "i18nService", "vuiConstants",
            "$element", "$timeout"];
        return MoveVmController;
    }());
    h5_vm.MoveVmController = MoveVmController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("moveVmView", new MoveVmViewComponent());
})(h5_vm || (h5_vm = {}));



/**
 * @name com.vmware.vsphere.client.vm:upgradeVmHardwareConstants
 * @module ccom.vmware.vsphere.client.vm
 *
 * @description
 *    The `upgradeVmHardwareConstants` service holds VM compatibility constants.
 */
angular.module('com.vmware.vsphere.client.vm').constant('upgradeVmHardwareConstants', {
   hardwareUpgradePolicy : {
      never: "never",
      onSoftPowerOff: "onSoftPowerOff",
      always: "always"
   }
});

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('vmVuiWizardPageBuilder', vmVuiWizardPageBuilder);

   vmVuiWizardPageBuilder.$inject = [
      'wizardPageService',
      '$q'
   ];

   function vmVuiWizardPageBuilder(wizardPageService, $q) {
      return {
         buildVuiWizardPage: function(wizardConfig, options) {
            return {
               title: options.title,
               description: options.description,
               contentUrl: options.contentUrl,
               defaultState: options.defaultState,
               onCommit: function() {
                  return commitIntermediatePage(wizardConfig, options);
               },
               disableNext: function() {
                  return (options.model.hasOwnProperty('pageFinishedLoading') && !options.model.pageFinishedLoading())
                        || (options.model.hasOwnProperty('validationFinishedLoading') && !options.model.validationFinishedLoading());
               }
            };
         },
         buildVuiWizardFinishPage: function(wizardConfig, options) {
            return {
               title: options.title,
               description: options.description,
               contentUrl: options.contentUrl,
               onCommit: function() {
                  return commitFinalPage(wizardConfig, options);
               },
               finishReady: function() {
                  return !options.model.hasOwnProperty('pageFinishedLoading') || options.model.pageFinishedLoading();
               }
            };
         }
      };

      function validatePage(pageModel, wizardConfig) {
         return $q.when(pageModel.validatePage()).then(function(validationResult) {
            if (validationResult && validationResult.error) {
               wizardPageService.markPageIncompleteWithError(wizardConfig, validationResult.error);
               return $q.reject(validationResult);
            } else {
               return validationResult;
            }
         });
      }

      function commitIntermediatePage(wizardConfig, options) {
         return validatePage(options.model, wizardConfig).then(function(validationResult) {
            return $q.when(options.model.submitPage(validationResult)).then(function(result) {
               if (wizardConfig.currentPage && wizardConfig.currentPage.title !==
                     options.title) {
                  return $q.reject();
               }
               if (result.invalidateNextPages) {
                  wizardPageService.invalidateNextPages(wizardConfig, result.wizardFlow, options.title);
               }
               wizardPageService.markPageComplete(wizardConfig, result.wizardFlow);
               return true;
            });
         }, function(validationResult) {
            if (validationResult && validationResult.invalidateNextPages) {
               wizardPageService.invalidateNextPages(wizardConfig, validationResult.wizardFlow, options.title);
            }
            return false;
         });
      }

      function commitFinalPage(wizardConfig, options) {
         return validatePage(options.model, wizardConfig).then(function() {
            return options.model.submitPage();
         });
      }
   }
}());

angular.module('com.vmware.vsphere.client.vm').service('vuiService', ['vuiWizardService', function (vuiWizardService) {
   return {
      createWizard: vuiWizardService
   };
}]);

var h5_vm;
(function (h5_vm) {
    var CloneVappBasicInformationController = (function () {
        function CloneVappBasicInformationController($scope) {
            this.$scope = $scope;
            this.basicInformationData = this.getBasicInformationData();
            if (!this.$scope.cloneVmBasicInformationPageModel.basicInformation) {
                this.$scope.cloneVmBasicInformationPageModel.basicInformation = this.basicInformationData.params;
            }
            else {
                // Reuse existing model when navigated back in the wizard.
                this.basicInformationData.params = this.$scope.cloneVmBasicInformationPageModel.basicInformation;
            }
        }
        CloneVappBasicInformationController.prototype.getBasicInformationData = function () {
            var vmName = this.$scope.wizardViewData.getSourceObjectName();
            var vmId = this.$scope.wizardViewData.getSourceObjectId();
            return {
                params: {
                    templateType: h5_vm.TemplateType.OVF_TEMPLATE,
                    name: vmName,
                    notes: "",
                    vmId: vmId,
                    cloneOvfType: h5_vm.CloneType.NEW_TEMPLATE,
                    valid: true,
                    isPrivilegeError: false
                },
                isVMTXPhase2: false
            };
        };
        CloneVappBasicInformationController.prototype.clonePagesChange = function (cloneType) {
            this.$scope.vuiWizard.validationBanner.messages = [];
            var isVMTX = this.basicInformationData.params.templateType === h5_vm.TemplateType.VM_TEMPLATE;
            var isUpdate = this.basicInformationData.params.cloneOvfType !== h5_vm.CloneType.NEW_TEMPLATE;
            this.$scope.cloneVmBasicInformationPageModel.changePages(isVMTX, isUpdate);
        };
        CloneVappBasicInformationController.$inject = ["$scope"];
        return CloneVappBasicInformationController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("cloneVappBasicInformationController", CloneVappBasicInformationController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmBasicInformationController = (function () {
        function CloneVmBasicInformationController($scope) {
            this.$scope = $scope;
            this.basicInformationData = this.getBasicInformationData();
            if (!this.$scope.cloneVmBasicInformationPageModel.basicInformation) {
                this.$scope.cloneVmBasicInformationPageModel.basicInformation = this.basicInformationData.params;
            }
            else {
                // Reuse existing model when navigated back in the wizard.
                this.basicInformationData.params = this.$scope.cloneVmBasicInformationPageModel.basicInformation;
            }
        }
        CloneVmBasicInformationController.prototype.getBasicInformationData = function () {
            var vmName = this.$scope.wizardViewData.getSourceObjectName();
            var vmId = this.$scope.wizardViewData.getSourceObjectId();
            if (this.$scope.cloneVmBasicInformationPageModel.isVMTXPhase2Enabled) {
                return {
                    params: {
                        templateType: h5_vm.TemplateType.VM_TEMPLATE,
                        name: vmName,
                        notes: "",
                        folderObjectId: this.$scope.wizardViewData.defaultTarget,
                        vcObjectId: this.$scope.wizardViewData._viewData.vCenterId,
                        folder: null,
                        vmId: vmId,
                        cloneOvfType: h5_vm.CloneType.NEW_TEMPLATE,
                        valid: true,
                        isPrivilegeError: false
                    },
                    isVMTXPhase2: true
                };
            }
            return {
                params: {
                    templateType: h5_vm.TemplateType.VM_TEMPLATE,
                    name: vmName,
                    notes: "",
                    vmId: vmId,
                    cloneOvfType: h5_vm.CloneType.NEW_TEMPLATE,
                    valid: true,
                    isPrivilegeError: false
                },
                isVMTXPhase2: false
            };
        };
        CloneVmBasicInformationController.prototype.clonePagesChange = function (cloneType) {
            this.$scope.vuiWizard.validationBanner.messages = [];
            var isVMTX = this.basicInformationData.params.templateType === h5_vm.TemplateType.VM_TEMPLATE;
            var isUpdate = this.basicInformationData.params.cloneOvfType !== h5_vm.CloneType.NEW_TEMPLATE;
            this.$scope.cloneVmBasicInformationPageModel.changePages(isVMTX, isUpdate);
        };
        CloneVmBasicInformationController.$inject = ["$scope"];
        return CloneVmBasicInformationController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("cloneVmBasicInformationController", CloneVmBasicInformationController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLibraryItemController = (function () {
        function CloneVmLibraryItemController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.i18n = i18nService.getString;
            this.libraryItemData = {
                vmId: $scope.wizardViewData.getSourceObjectId(),
                selectedLibraryItemId: this.$scope.cloneVmLibraryItemPageModel.contentLibraryItem &&
                    this.$scope.cloneVmLibraryItemPageModel.contentLibraryItem.id
            };
        }
        CloneVmLibraryItemController.prototype.onSelectedLibraryItemChange = function (selectedLibraryItem) {
            this.$scope.vuiWizard.validationBanner.messages = [];
            this.$scope.cloneVmLibraryItemPageModel.contentLibraryItem = selectedLibraryItem;
        };
        CloneVmLibraryItemController.$inject = ["$scope", "i18nService"];
        return CloneVmLibraryItemController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("cloneVmLibraryItemController", CloneVmLibraryItemController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var CloneVmLocationController = (function () {
        function CloneVmLocationController($scope) {
            this.$scope = $scope;
            this.isOvfWorkflow = true;
            this.locationData = {
                vmId: $scope.wizardViewData.getSourceObjectId(),
                selectedLibraryId: this.$scope.cloneVmLocationPageModel.contentLibrary &&
                    this.$scope.cloneVmLocationPageModel.contentLibrary.id
            };
            this.isOvfWorkflow =
                ($scope.cloneVmBasicInformationPageModel.basicInformation.templateType === h5_vm.TemplateType.OVF_TEMPLATE);
        }
        CloneVmLocationController.prototype.onSelectedLibraryChange = function (selectedLibrary) {
            this.$scope.vuiWizard.validationBanner.messages = [];
            this.$scope.cloneVmLocationPageModel.contentLibrary = selectedLibrary;
        };
        CloneVmLocationController.$inject = ["$scope"];
        return CloneVmLocationController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("cloneVmLocationController", CloneVmLocationController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var TemplateType = h5_vm.TemplateType;
    var CloneType = h5_vm.CloneType;
    var CloneVmReviewController = (function () {
        function CloneVmReviewController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "ProvisioningUiLib"; }
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                return i18nService.getString.apply(i18nService, [bundle, key].concat(args));
            };
            this.basicInformationData = $scope.cloneVmBasicInformationPageModel.basicInformation;
            this.vmtxPhase2Enabled = $scope.cloneVmBasicInformationPageModel.isVMTXPhase2Enabled;
            this.cloneAsVMTX = this.basicInformationData.templateType === TemplateType.VM_TEMPLATE;
            this.cloneOvfType = this.basicInformationData.cloneOvfType !== CloneType.NEW_TEMPLATE;
            if (this.vmtxPhase2Enabled && this.cloneAsVMTX) {
                var crInfo = $scope.cloneVmReviewPageModel.getComputeResourceInfo();
                this.computeResourceName = crInfo.name;
                this.computeResourceType = crInfo.label;
            }
            if (!this.cloneOvfType || this.cloneAsVMTX) {
                this.locationData = $scope.cloneVmLocationPageModel.contentLibrary;
            }
            if (this.cloneOvfType && !this.cloneAsVMTX) {
                this.libraryItemData = $scope.cloneVmLibraryItemPageModel.contentLibraryItem;
            }
            if (this.cloneAsVMTX) {
                var isAdvancedStorageMode = $scope.datastorePageModel.form.isAdvancedStorageMode;
                this.storageData = isAdvancedStorageMode ? this.getAdvancedStorageDetails() : this.getSimpleStorageDetails();
            }
        }
        CloneVmReviewController.prototype.getSimpleStorageDetails = function () {
            var storageDetailsView = new StorageDetailsView();
            var datastorePageModelForm = this.$scope.datastorePageModel.form;
            storageDetailsView.vmHomeDatastore = datastorePageModelForm.selectedStorage.name;
            storageDetailsView.vmHomeStoragePolicy = datastorePageModelForm.storageProfilesData._currentVmProfileAssignment.vmHomeProfile.label;
            return storageDetailsView;
        };
        CloneVmReviewController.prototype.getAdvancedStorageDetails = function () {
            var storageDetailsView = new StorageDetailsView();
            var storageConfig = this.$scope.datastorePageModel.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
            storageDetailsView.vmHomeDatastore = storageConfig.vmHome.storageObj.name;
            storageDetailsView.vmHomeStoragePolicy =
                storageConfig.vmHome.storageProfile ? storageConfig.vmHome.storageProfile.label : '';
            storageDetailsView.vmDiskInfo = [];
            for (var index = 0; index < storageConfig.vmDisks.length; index++) {
                var vmDisk = storageConfig.vmDisks[index];
                var profileLabel = vmDisk.storageProfile ? vmDisk.storageProfile.label : '-';
                var diskInfo = {
                    name: vmDisk.name,
                    datastore: this.i18n("sharesAndType", "VmUi", vmDisk.storageObj.name, profileLabel)
                };
                storageDetailsView.vmDiskInfo.push(diskInfo);
            }
            return storageDetailsView;
        };
        CloneVmReviewController.$inject = ["$scope", "i18nService"];
        return CloneVmReviewController;
    }());
    var StorageDetailsView = (function () {
        function StorageDetailsView() {
        }
        return StorageDetailsView;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("cloneVmReviewController", CloneVmReviewController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareCompatibility = (function () {
        function VmHardwareCompatibility(i18nService, helpService, idGeneratorService) {
            var _this = this;
            this.i18nService = i18nService;
            this.helpService = helpService;
            this.idGeneratorService = idGeneratorService;
            this.HW_VERSION_INFO_ID = "com.vmware.vsphere.vm_admin.doc.vc_312";
            this.compatibilityLabel =
                this.i18nService.getString('VmUi', 'hwVersion.selector.label');
            this.popupParams = {
                title: this.i18nService.getString('Common', 'help'),
                message: this.i18nService.getString('Common', 'signpost.hardwareVersionSelector'),
                linkLabel: this.i18nService.getString('VmUi', 'hwVersion.info.helperlink.label'),
                linkFunction: function () {
                    helpService.showHelpPage(_this.HW_VERSION_INFO_ID);
                }
            };
            this.scheduleUpgradeOnPowerOfLabel =
                this.i18nService.getString('VmUi', 'VmUpgradePage.onSoftPowerOff');
            this.showMultipleVmsWarning = false;
            this.changeUpgradabelWarning();
            this.descriptionId = this.idGeneratorService.nextId();
        }
        VmHardwareCompatibility.prototype.selectionChange = function () {
            this.changeUpgradabelWarning();
            if (this.onChangeMethod && typeof this.onChangeMethod === 'function') {
                this.onChangeMethod(this.selectedVersion);
            }
        };
        VmHardwareCompatibility.prototype.changeUpgradabelWarning = function () {
            if (this.allVmsLength > 1) {
                var vmsLength = 0;
                if (this.selectedVersion.vms) {
                    vmsLength = this.selectedVersion.vms.length;
                }
                this.showMultipleVmsWarning = true;
                this.multipleVmsWarning =
                    this.i18nService.getString('VmUi', 'SelectVmVersionPage.UpgradableWarning', vmsLength, this.allVmsLength);
            }
        };
        VmHardwareCompatibility.$inject = ['i18nService', 'helpService', 'idGeneratorService'];
        return VmHardwareCompatibility;
    }());
    h5_vm.VmHardwareCompatibility = VmHardwareCompatibility;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareCompatibility', {
        templateUrl: 'vm-ui/resources/vm/views/compatibility/vmHardwareCompatibility.html',
        controller: VmHardwareCompatibility,
        /**
         *
         * description                     text to be displayed above the select
         * supportedVersions               the available hardware versions
         * selectedVersion                 object containing the expected selected version,
         *                                 should contain `id` property
         * onChangeMethod(optional)        Method to be called when selection changes
         * scheduleMode(optional)          flag, set to true to show the upgrade checkbox
         *                                 for upgrade after guest os shutdown
         * isUpgradeAfterGuestOsShutdown   flag true for the upgrade after guest os
         *                    (optional)   shutdown checkbox to be checked
         * allVmsLength(optional)           in case the operation is called on
         *                                 multiple objects,should contain
         *                                 count of all the selected vms
         */
        bindings: {
            description: '<',
            supportedVersions: '=',
            selectedVersion: '=',
            onChangeMethod: '<',
            scheduleMode: '<',
            isUpgradeAfterGuestOsShutdown: '=',
            allVmsLength: '<'
        }
    });
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareCompatibilityService = (function () {
        function VmHardwareCompatibilityService(i18nService) {
            this.i18nService = i18nService;
        }
        /**
         * Builds an array of vm versions, to be used in the vmHardwareCompatibility component
         * for display of the possible hardware versions for the selected vm/s
         * @param optionDescriptors      array of possible hardware versions for the vm,
         *                               in format as returned from the Vc
         * @param is65VcOrLater   boolean  set to true if the Vc's version is 6.5 or later, false if not
         * @returns {VmVersion[]}        an array of objects, used for display
         *                               of the possible hardware versions for the selected vm/s
         */
        VmHardwareCompatibilityService.prototype.buildVmVersions = function (optionDescriptors, is65VcOrLater) {
            var _this = this;
            var vmVersions = _.map(optionDescriptors, function (optionDescriptor) {
                return _this.buildVmVersion(optionDescriptor, is65VcOrLater);
            });
            return vmVersions;
        };
        /**
         * Given an array of VmData, builds an array of vmVersions, ordered by key,
         * containing information for which vms the version is applicable
         * @param data:VmData[]           an array of VmData per Vm, containing the Vm's
         *                                hardware version and option descriptors
         * @param is65VcOrLater  boolean  shows if the Vc in which the vm is placed is 6.5
         *                                or later version
         * @returns {VmVersion[]}         an array of VmVersions, whose key is the Vm version key
         *                                (Ex: {
         *                                      'vmx-07': {
         *                                           key: 'vmx-07',
         *                                           name:'ESX/ESXi 4.0 and later',
         *                                           compatibilityInfo: 'This virtual machine uses hardware version 7...'
         *                                           vms:['urn:vmomi:VirtualMachine:vm-100:1111-2222-3333', '...', ...]
         *                                        },{...},...}
         */
        VmHardwareCompatibilityService.prototype.buildSupportedVersionsForVms = function (data, is65VcOrLater) {
            var _this = this;
            var supportedVersions = new Array();
            angular.forEach(data, function (vmData, vmId) {
                var vmOptionDescriptors = vmData.optionDescriptors;
                var vmHardwareVersion = vmData['config.version'];
                _this.buildVmSupportedOptions(vmId, vmOptionDescriptors, vmHardwareVersion, is65VcOrLater, supportedVersions);
            });
            return _.sortBy(supportedVersions, 'id');
        };
        /**
         * Given a Vm's current hardware version and option descriptors,
         * adds to the supportedVersions array option dewcriptors that are not yet added,
         * or adds the vm's id to the array of supported Vms per a Hardware version
         * @param vmId string                  the Id of the vm
         * @param optionDescriptors            the supported option descriptors for the Vm
         * @param vmHardwareVersion            the current hardware version of the Vm
         * @param is65VcOrLater  boolean       shows if the Vc in which the vm is placed is 6.5
         * @param supportedVersions            an array of VmVersions
         */
        VmHardwareCompatibilityService.prototype.buildVmSupportedOptions = function (vmId, optionDescriptors, vmHardwareVersion, is65VcOrLater, supportedVersions) {
            for (var i = 0; i < optionDescriptors.length; i++) {
                if (vmHardwareVersion < optionDescriptors[i].key
                    && optionDescriptors[i].upgradeSupported) {
                    var supportedVersion = _.find(supportedVersions, function (version) {
                        return version.id === optionDescriptors[i].key;
                    });
                    if (!supportedVersion) {
                        supportedVersion =
                            this.buildVmVersion(optionDescriptors[i], is65VcOrLater);
                        supportedVersion.vms = [vmId];
                        supportedVersions.push(supportedVersion);
                    }
                    else {
                        var vms = supportedVersion.vms;
                        if (!vms) {
                            vms = [];
                        }
                        vms.push(vmId);
                    }
                }
            }
        };
        /**
         * Builds an VmVersion object from the supplied optionDescriptor,
         * changing the compatibilityInfo text according to the Vc's version
         * @param optionDescriptor
         * @param is65VcOrLater boolean    shows if the Vc in which the vm is placed is 6.5
         * @returns {VmVersion}
         */
        VmHardwareCompatibilityService.prototype.buildVmVersion = function (optionDescriptor, is65VcOrLater) {
            return {
                id: optionDescriptor.key,
                name: this.i18nService.getString('VmUi', 'VmHardware.HWVersion.short.' + optionDescriptor.key),
                compatibilityInfo: is65VcOrLater ?
                    this.i18nService.getString('VmUi', 'SelectVmVersionPage.' + optionDescriptor.key) :
                    this.i18nService.getString('VmUi', 'SelectVmVersionPageLessThan65Vc.' + optionDescriptor.key)
            };
        };
        VmHardwareCompatibilityService.$inject = ['i18nService'];
        return VmHardwareCompatibilityService;
    }());
    h5_vm.VmHardwareCompatibilityService = VmHardwareCompatibilityService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareCompatibilityService', VmHardwareCompatibilityService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (VmDisplayMode) {
        VmDisplayMode[VmDisplayMode["CreateMode"] = 0] = "CreateMode";
        VmDisplayMode[VmDisplayMode["ReadMode"] = 1] = "ReadMode";
        VmDisplayMode[VmDisplayMode["ReadAdvancedMode"] = 2] = "ReadAdvancedMode";
        VmDisplayMode[VmDisplayMode["UpdateMode"] = 3] = "UpdateMode";
    })(h5_vm.VmDisplayMode || (h5_vm.VmDisplayMode = {}));
    var VmDisplayMode = h5_vm.VmDisplayMode;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    (function (VmWorkflowMode) {
        VmWorkflowMode[VmWorkflowMode["CreateMode"] = 0] = "CreateMode";
        VmWorkflowMode[VmWorkflowMode["UpdateMode"] = 1] = "UpdateMode";
        VmWorkflowMode[VmWorkflowMode["CloneMode"] = 2] = "CloneMode";
        VmWorkflowMode[VmWorkflowMode["DeployVmtxMode"] = 3] = "DeployVmtxMode";
    })(h5_vm.VmWorkflowMode || (h5_vm.VmWorkflowMode = {}));
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareCpuIoMmuController = (function () {
        function VmHardwareCpuIoMmuController(i18nService, vmHardwareCpuIoMmuService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vmHardwareCpuIoMmuService = vmHardwareCpuIoMmuService;
            this.onChange = function () {
                _this.onIoMmuChange({ configFlags: _this.configFlags });
            };
            this.disabled = function () {
                return _this.vmHardwareCpuIoMmuService.isDisabled(_this.vmWorkflowMode, _this.vbsEnabled, _this.powerState, _this.privileges);
            };
            this.i18n = i18nService.getString;
            this.vmHardwareCpuIoMmuService.getSignPostParams()
                .then(function (value) {
                _this.signPostParams = value;
            });
        }
        VmHardwareCpuIoMmuController.$inject = ["i18nService", "vmHardwareCpuIoMmuService"];
        return VmHardwareCpuIoMmuController;
    }());
    h5_vm.VmHardwareCpuIoMmuController = VmHardwareCpuIoMmuController;
    var VmHardwareCpuIoMmuComponent = (function () {
        function VmHardwareCpuIoMmuComponent() {
            this.controller = VmHardwareCpuIoMmuController;
            this.templateUrl = "vm-ui/resources/vm/views/components/vmHardwareCpuIoMmu/vm-hardware-cpu-io-mmu.html";
            this.bindings = {
                configFlags: "<",
                privileges: "<",
                vmWorkflowMode: "<",
                powerState: "<",
                onIoMmuChange: "&",
                vbsEnabled: "<"
            };
        }
        return VmHardwareCpuIoMmuComponent;
    }());
    h5_vm.VmHardwareCpuIoMmuComponent = VmHardwareCpuIoMmuComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareCpuIoMmu", new VmHardwareCpuIoMmuComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareCpuIoMmuService = (function () {
        function VmHardwareCpuIoMmuService(i18nService, templateHelperService, vmHardwareUtil) {
            this.i18nService = i18nService;
            this.templateHelperService = templateHelperService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareCpuIoMmuService.prototype.getSignPostParams = function () {
            var _this = this;
            var ioMmuVirtTemplate = 'vm-ui/resources/vm/views/components/vmHardwareCpuIoMmu/iommuHelpText.html';
            return this.templateHelperService.renderTemplateWithScope(ioMmuVirtTemplate, { i18n: this.i18nService.getString })
                .then(function (content) {
                return {
                    message: content,
                    title: _this.i18nService.getString('Common', 'help'),
                    class: 'io-mmu-help-text'
                };
            });
        };
        VmHardwareCpuIoMmuService.prototype.haveConfigSettingsPermission = function (privileges) {
            var retVal = this.vmHardwareUtil.checkPrivileges(privileges, [h5_vm.Privileges.VM_CONFIG_SETTINGS]);
            return retVal;
        };
        VmHardwareCpuIoMmuService.prototype.isVmPoweredOn = function (powerState) {
            return powerState === 'poweredOn';
        };
        VmHardwareCpuIoMmuService.prototype.isVmSuspended = function (powerState) {
            return powerState === "suspended";
        };
        VmHardwareCpuIoMmuService.prototype.isDisabled = function (vmWorkflowMode, vbsEnabled, powerState, privileges) {
            if (vbsEnabled) {
                return true;
            }
            var havePermission = this.haveConfigSettingsPermission(privileges);
            var poweredOnOrSuspended = this.isVmPoweredOn(powerState) || this.isVmSuspended(powerState);
            switch (vmWorkflowMode) {
                default:
                    return false;
                case h5_vm.VmWorkflowMode.CreateMode:
                    return false;
                case h5_vm.VmWorkflowMode.CloneMode:
                    return !havePermission;
                case h5_vm.VmWorkflowMode.UpdateMode:
                    return !havePermission || poweredOnOrSuspended;
            }
        };
        ;
        VmHardwareCpuIoMmuService.$inject = [
            'i18nService',
            'templateHelperService',
            'vmHardwareUtil',
        ];
        return VmHardwareCpuIoMmuService;
    }());
    h5_vm.VmHardwareCpuIoMmuService = VmHardwareCpuIoMmuService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareCpuIoMmuService', VmHardwareCpuIoMmuService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskLocationService = (function () {
        function VmHardwareVirtualDiskLocationService($q, $rootScope, i18nService, vmDatastoreLocationBrowserService, defaultUriSchemeUtil, managedEntityConstants, authorizationService) {
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.i18nService = i18nService;
            this.vmDatastoreLocationBrowserService = vmDatastoreLocationBrowserService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.authorizationService = authorizationService;
            this.STYLE_HAS_ERROR = 'has-error';
            this.PRIVILEGE_DATASTORE_ALLOCATE_SPACE = 'Datastore.AllocateSpace';
        }
        VmHardwareVirtualDiskLocationService.prototype.onLocationChange = function (selectedStorageItem, vmStorageBrowserMetadata, vmStorageProfileMetadata, vmId, showStoragePods) {
            var _this = this;
            if (!this.isBrowseOption(selectedStorageItem)) {
                return this.$q.when({
                    selectedStorageItem: selectedStorageItem,
                    selectedStorageProfile: vmStorageProfileMetadata.selectedProfile
                });
            }
            return this.getStorageSelectorItems(vmId, vmStorageBrowserMetadata)
                .then(function (storageSelectorItems) {
                vmStorageBrowserMetadata.storageData.storageLocatorItemsData = storageSelectorItems;
                return _this.vmDatastoreLocationBrowserService.choose(_this.$rootScope, {
                    storageData: vmStorageBrowserMetadata.storageData,
                    storageProfilesData: vmStorageProfileMetadata,
                    disableSdrs: !showStoragePods
                });
            });
        };
        VmHardwareVirtualDiskLocationService.prototype.getErrorStyle = function (diskLocationErrorConfig) {
            return diskLocationErrorConfig.isVisible ? this.STYLE_HAS_ERROR : '';
        };
        VmHardwareVirtualDiskLocationService.prototype.getErrorMessage = function (result, datastores, storageLocatorItemsData) {
            var _this = this;
            var message = "";
            var found = false;
            if (!this
                .isValid(result.selectedStorageItem)) {
                message = this.i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.NoPermissionOnDatastore');
            }
            var rdmSupportedDatastore = this.getRdmSupportedDatastore(datastores, storageLocatorItemsData);
            if (!message) {
                rdmSupportedDatastore.forEach(function (disk) {
                    if (_this.defaultUriSchemeUtil.compareIds(result.selectedStorageItem.storageObject.storageRef, disk.storageRef)) {
                        found = true;
                    }
                });
            }
            if (!found) {
                var selectedObjectType = this.defaultUriSchemeUtil.getEntityType(result.selectedStorageItem.id);
                message = selectedObjectType === 'StoragePod' ? this.i18nService.getString('VmUi', 'DiskConfig.RDMUnsupportedCluster')
                    : this.i18nService.getString('VmUi', 'DiskConfig.RDMUnsupported');
            }
            return message;
        };
        VmHardwareVirtualDiskLocationService.prototype.getRdmSupportedDatastore = function (datastores, storageLocatorItemsData) {
            var rdmSupportedDatastore = _.filter(datastores, function (d) { return d.capability.rawDiskMappingsSupported; });
            var rdmSupportedStoragePods = _.filter(storageLocatorItemsData.storageLocatorItemsData, function (d) { return d.isRDMSupported; });
            var nonClusterDatastore = _.filter(storageLocatorItemsData.datastoreItems, function (d) { return d.parentStoragePod === null; });
            var datastore = _.filter(nonClusterDatastore, function (ds1) {
                return _.some(rdmSupportedDatastore, function (ds2) {
                    return JSON.stringify(ds2.datastore.datastore) === JSON.stringify(ds1.storageRef);
                });
            });
            return _.union(datastore, rdmSupportedStoragePods);
        };
        VmHardwareVirtualDiskLocationService.prototype.buildLocationOptions = function (selectedStorage) {
            var storeWithVmOption = {
                name: this.i18nService.getString('VmUi', 'DiskPage.StoreWithVM')
            };
            var browseDialogOption = {
                name: this.i18nService.getString('VmUi', 'DiskPage.Browse')
            };
            if (selectedStorage) {
                var selectedStorageOption = {
                    name: selectedStorage.name,
                    id: selectedStorage.id,
                    storageObject: selectedStorage.storageObject
                };
                var model = {
                    options: [storeWithVmOption,
                        selectedStorageOption,
                        browseDialogOption],
                    selection: selectedStorageOption
                };
                return model;
            }
            return {
                options: [storeWithVmOption, browseDialogOption],
                selection: storeWithVmOption
            };
        };
        VmHardwareVirtualDiskLocationService.prototype.isDifferent = function (storageOptionA, storageOptionB) {
            return storageOptionA.id !== storageOptionB.id;
        };
        VmHardwareVirtualDiskLocationService.prototype.isValid = function (selectedStorageOption) {
            var _this = this;
            var storageId = selectedStorageOption.id;
            var storageName = selectedStorageOption.name;
            var storeWithVmOption = this.i18nService
                .getString('VmUi', 'DiskPage.StoreWithVM');
            var browseDialogOptionName = this.i18nService
                .getString('VmUi', 'DiskPage.Browse');
            if (storageName === browseDialogOptionName) {
                return this.$q.when(true);
            }
            if (storageName === storeWithVmOption) {
                return this.$q.when(true);
            }
            var storageType = this.defaultUriSchemeUtil.getEntityType(storageId);
            if (storageType === this.managedEntityConstants.STORAGE_POD) {
                return this.$q.when(true);
            }
            return this.authorizationService.checkPrivileges(storageId, [this.PRIVILEGE_DATASTORE_ALLOCATE_SPACE])
                .then(function (privilegeStatuses) {
                var hasPriv = privilegeStatuses[0];
                return _this.$q.when(hasPriv);
            });
        };
        ;
        VmHardwareVirtualDiskLocationService.prototype.isBrowseOption = function (selectedOption) {
            var browseDialogOptionName = this.i18nService.getString('VmUi', 'DiskPage.Browse');
            return selectedOption.name === browseDialogOptionName;
        };
        VmHardwareVirtualDiskLocationService.prototype.getStorageSelectorItems = function (vmId, vmStorageBrowserMetadata) {
            if (vmStorageBrowserMetadata.storageData.storageLocatorItemsData) {
                return this.$q.when(vmStorageBrowserMetadata.storageData.storageLocatorItemsData);
            }
            else {
                return this.vmDatastoreLocationBrowserService.getStorageLocatorItems(vmId);
            }
        };
        VmHardwareVirtualDiskLocationService.$inject = ['$q',
            '$rootScope',
            'i18nService',
            'vmDatastoreLocationBrowserService',
            'defaultUriSchemeUtil',
            'managedEntityConstants',
            'authorizationService'];
        return VmHardwareVirtualDiskLocationService;
    }());
    h5_vm.VmHardwareVirtualDiskLocationService = VmHardwareVirtualDiskLocationService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskLocationService', VmHardwareVirtualDiskLocationService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmDisplayMode = h5_vm.VmDisplayMode;
    var VmHardwareVirtualDiskLocationController = (function () {
        function VmHardwareVirtualDiskLocationController(vmHardwareVirtualDiskLocationService, i18nService) {
            var _this = this;
            this.vmHardwareVirtualDiskLocationService = vmHardwareVirtualDiskLocationService;
            this.i18nService = i18nService;
            this.onLocationChange = function (newValue, oldValue) {
                _this.prevSelection = oldValue;
                _this.vmHardwareVirtualDiskLocationService.onLocationChange(_this.selected, _this.vmStorageBrowserMetadata, _this.vmStorageProfileMetadata, _this.vmId, _this.showStoragePods).then(function (result) {
                    if (_this.vmHardwareVirtualDiskLocationService
                        .isDifferent(_this.selected, result.selectedStorageItem)) {
                        _this.setErrorMessage(result);
                        var locationOptionInfo = _this.vmHardwareVirtualDiskLocationService
                            .buildLocationOptions(result.selectedStorageItem);
                        _this.locationOptions = locationOptionInfo.options;
                        _this.selected = result.selectedStorageItem;
                        _this.onChange({
                            selectedStorageProfile: result.selectedStorageProfile,
                            selectedStorageItem: result.selectedStorageItem
                        });
                    }
                }, function () {
                    _this.selected = _this.prevSelection;
                });
            };
            this.setErrorMessage = function (result) {
                var message = _this.vmHardwareVirtualDiskLocationService.getErrorMessage(result, _this.datastore, _this.vmStorageBrowserMetadata.storageData.storageLocatorItemsData);
                _this.diskLocationError = !!message;
                _this.diskLocationErrorConfig = {
                    message: message,
                    isVisible: _this.diskLocationError
                };
            };
        }
        VmHardwareVirtualDiskLocationController.prototype.$onInit = function () {
            this.setLocationContext(this.selectedStorage);
        };
        VmHardwareVirtualDiskLocationController.prototype.$onChanges = function (changes) {
        };
        VmHardwareVirtualDiskLocationController.prototype.getErrorStyle = function () {
            return this.vmHardwareVirtualDiskLocationService
                .getErrorStyle(this.diskLocationErrorConfig);
        };
        VmHardwareVirtualDiskLocationController.prototype.setLocationContext = function (selectedStorage) {
            var locationOptionInfo = this.vmHardwareVirtualDiskLocationService
                .buildLocationOptions(selectedStorage);
            this.locationOptions = locationOptionInfo.options;
            this.selected = locationOptionInfo.selection;
            this.prevSelection = this.selected;
            this.isCreateMode = this.displayMode === VmDisplayMode.CreateMode;
            this.diskLocationErrorConfig = {
                message: this.i18nService.getString('VmUi', 'DiskConfig.RDMUnsupported'),
                isVisible: this.diskLocationError
            };
        };
        VmHardwareVirtualDiskLocationController.$inject = [
            'vmHardwareVirtualDiskLocationService',
            'i18nService'];
        return VmHardwareVirtualDiskLocationController;
    }());
    h5_vm.VmHardwareVirtualDiskLocationController = VmHardwareVirtualDiskLocationController;
    var VmHardwareVirtualDiskLocation = (function () {
        function VmHardwareVirtualDiskLocation() {
            /**
             * onChange                   on-change callback
             * displayMode                Display mode of location [Create/Read]
             * vmStorageBrowserMetadata   data used by the storage-locator
             * vmStorageProfileMetadata   data used to show the storage
             *                            profiles (policies)
             */
            this.bindings = {
                onChange: '&',
                displayMode: '<',
                ariaLabel: '<',
                vmStorageBrowserMetadata: '<',
                vmStorageProfileMetadata: '<',
                vmId: '<',
                showStoragePods: '<',
                diskLocationError: '=',
                datastore: '<',
                selectedStorage: '<'
            };
            this.controller = VmHardwareVirtualDiskLocationController;
            this.templateUrl = 'vm-ui/resources/vm/views/components/' +
                'vmHardwareVirtualDiskLocation/vm-hardware-virtual-disk-location.html';
        }
        return VmHardwareVirtualDiskLocation;
    }());
    h5_vm.VmHardwareVirtualDiskLocation = VmHardwareVirtualDiskLocation;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskLocation', new VmHardwareVirtualDiskLocation());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmStorageBrowserMetadata = (function () {
        function VmStorageBrowserMetadata(storageData) {
            this.storageData = storageData;
        }
        return VmStorageBrowserMetadata;
    }());
    h5_vm.VmStorageBrowserMetadata = VmStorageBrowserMetadata;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmDisplayMode = h5_vm.VmDisplayMode;
    var VmHardwareVirtualDiskSharesController = (function () {
        function VmHardwareVirtualDiskSharesController(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.onSharesChange = function (value) {
                _this.selected.shares = value;
                _this.onChangeCallback();
            };
            this.onSharesLevelChange = function () {
                var level = _this.selected.level.data;
                _this.isCustomShareLevel = (level === 'custom');
                if (!_this.isCustomShareLevel) {
                    _this.selected.shares = _this.recalculateSharesValue(level);
                }
                _this.onChangeCallback();
            };
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskSharesController.prototype.$onInit = function () {
            if (this.sharesContext) {
                this.setSharesContext();
            }
        };
        VmHardwareVirtualDiskSharesController.prototype.$onChanges = function (changes) {
            if (changes.sharesContext.currentValue) {
                this.setSharesContext();
            }
        };
        VmHardwareVirtualDiskSharesController.prototype.setFormNames = function () {
            if (this.sharesId) {
                this.formInputName = this.sharesId + '-shares-value';
                this.formSelectName = this.sharesId + '-shares-levels';
            }
            else {
                this.formInputName = 'shares-value';
                this.formSelectName = 'shares-levels';
            }
        };
        VmHardwareVirtualDiskSharesController.prototype.setSharesContext = function () {
            var _this = this;
            this.sharesId = this.sharesContext.sharesId;
            this.sharesInfo = this.sharesContext.sharesInfo;
            this.showRecommendations = this.sharesContext.showRecommendations;
            this.shareMin = this.sharesContext.shareMin;
            this.shareMax = this.sharesContext.shareMax;
            this.sharesLevelPresetOptions = this.sharesContext.sharesLevelPresetOptions;
            this.setFormNames();
            this.shareLevels = [
                { label: this.i18n('VmUi', 'sharesInfoLevel.low'), data: 'low' },
                { label: this.i18n('VmUi', 'sharesInfoLevel.normal'), data: 'normal' },
                { label: this.i18n('VmUi', 'sharesInfoLevel.high'), data: 'high' },
                { label: this.i18n('VmUi', 'sharesInfoLevel.custom'), data: 'custom' }
            ];
            this.shareValidationErrorMessages = {
                max: function () { return _this.i18n('Common', 'SharesControl.RangeError', _this.shareMin, _this.shareMax); },
                min: function () { return _this.i18n('Common', 'SharesControl.RangeError', _this.shareMin, _this.shareMax); }
            };
            if (this.showRecommendations) {
                this.shareRecommendationValues = [{
                        value: this.shareMin, name: 'Minimum'
                    }, {
                        value: this.shareMax, name: 'Maximum'
                    }];
            }
            this.selected = {
                level: _.find(this.shareLevels, function (level) {
                    return level.data === _this.sharesInfo.level;
                }),
                shares: this.sharesInfo.shares
            };
            this.isCustomShareLevel = (this.sharesInfo.level === 'custom');
            this.readMode = (this.displayMode === VmDisplayMode.ReadMode ||
                this.displayMode === VmDisplayMode.ReadAdvancedMode);
        };
        VmHardwareVirtualDiskSharesController.prototype.selectedShareValues = function () {
            var shares = this.selected.shares;
            var level = this.selected.level.label;
            return shares + " " + level;
        };
        VmHardwareVirtualDiskSharesController.prototype.isValidShare = function () {
            return this.selected.shares >= this.shareMin &&
                this.selected.shares <= this.shareMax;
        };
        VmHardwareVirtualDiskSharesController.prototype.onChangeCallback = function () {
            if (this.isValidShare()) {
                this.onChange({
                    shares: {
                        level: this.selected.level.data,
                        shares: this.selected.shares
                    }
                });
            }
        };
        VmHardwareVirtualDiskSharesController.prototype.recalculateSharesValue = function (level) {
            if (!this.isCustomShareLevel) {
                var value = this.sharesLevelPresetOptions[level];
                if (value === undefined || value === null) {
                    throw new Error('Unknown level: ' + level);
                }
                return value;
            }
        };
        VmHardwareVirtualDiskSharesController.$inject = [
            'i18nService',
            'vmHardwareVirtualDiskSharesService'
        ];
        return VmHardwareVirtualDiskSharesController;
    }());
    var VmHardwareVirtualDiskShares = (function () {
        function VmHardwareVirtualDiskShares() {
            this.bindings = {
                onChange: '&',
                displayMode: '<',
                ariaLabel: '<',
                sharesContext: '<',
                isDisabled: '<'
            };
            this.controller = VmHardwareVirtualDiskSharesController;
            this.templateUrl = 'vm-ui/resources/vm/views/components' +
                '/vmHardwareVirtualDiskShares/vm-hardware-virtual-disk-shares.html';
        }
        return VmHardwareVirtualDiskShares;
    }());
    h5_vm.VmHardwareVirtualDiskShares = VmHardwareVirtualDiskShares;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskShares', new VmHardwareVirtualDiskShares());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareVirtualDiskSharesService = (function () {
        function VmHardwareVirtualDiskSharesService(vmHardwareUtil) {
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareVirtualDiskSharesService.prototype.isEditSharesDisabled = function (privileges, createMode, diskSharesSupported) {
            return !this.hasPrivilegesToEditShares(privileges, createMode) || !diskSharesSupported;
        };
        VmHardwareVirtualDiskSharesService.prototype.hasPrivilegesToEditShares = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_RESOURCE_PRIVILEGE, Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareVirtualDiskSharesService.$inject = [
            'vmHardwareUtil'];
        return VmHardwareVirtualDiskSharesService;
    }());
    h5_vm.VmHardwareVirtualDiskSharesService = VmHardwareVirtualDiskSharesService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskSharesService', VmHardwareVirtualDiskSharesService);
})(h5_vm || (h5_vm = {}));







var h5_vm;
(function (h5_vm) {
    var VmDisplayMode = h5_vm.VmDisplayMode;
    var VmHardwareVirtualDiskSharingCtrl = (function () {
        function VmHardwareVirtualDiskSharingCtrl(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.onSharingChange = function () {
                _this.onChange({ sharing: _this.selected });
            };
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskSharingCtrl.prototype.$onInit = function () {
            if (this.sharingInfo) {
                this.setSharingContext();
            }
        };
        VmHardwareVirtualDiskSharingCtrl.prototype.$onChanges = function (changes) {
            if (changes.sharingInfo.currentValue) {
                this.setSharingContext();
            }
        };
        VmHardwareVirtualDiskSharingCtrl.prototype.setSharingContext = function () {
            this.selected = this.sharingInfo.selectedSharing;
            this.sharingOptions = this.sharingInfo.sharingOptions;
            this.isSelectable = this.sharingInfo.enableSharing && (this.sharingOptions && this.sharingOptions.length > 0);
            this.isReadOnly = (this.displayMode === VmDisplayMode.ReadMode ||
                this.displayMode === VmDisplayMode.ReadAdvancedMode);
        };
        VmHardwareVirtualDiskSharingCtrl.$inject = [
            'i18nService'
        ];
        return VmHardwareVirtualDiskSharingCtrl;
    }());
    var VmHardwareVirtualDiskSharing = (function () {
        function VmHardwareVirtualDiskSharing() {
            this.bindings = {
                onChange: '&',
                displayMode: '<',
                ariaLabel: '<',
                sharingInfo: '<'
            };
            this.controller = VmHardwareVirtualDiskSharingCtrl;
            this.templateUrl = 'vm-ui/resources/vm/views/components' +
                '/vmHardwareVirtualDiskSharing/vm-hardware-virtual-disk-sharing.html';
        }
        return VmHardwareVirtualDiskSharing;
    }());
    h5_vm.VmHardwareVirtualDiskSharing = VmHardwareVirtualDiskSharing;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskSharing', new VmHardwareVirtualDiskSharing());
})(h5_vm || (h5_vm = {}));







var h5_vm;
(function (h5_vm) {
    var VmDisplayMode = h5_vm.VmDisplayMode;
    var VmHardwareVirtualDiskStorageProfileCtrl = (function () {
        function VmHardwareVirtualDiskStorageProfileCtrl(i18nService) {
            var _this = this;
            this.i18nService = i18nService;
            this.onStorageProfileChange = function (selectedProfile) {
                _this.onChange({ selectedProfile: selectedProfile });
            };
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskStorageProfileCtrl.prototype.$onInit = function () {
            if (this.vmStorageProfileMetadata) {
                this.setStorageProfileContext();
            }
        };
        VmHardwareVirtualDiskStorageProfileCtrl.prototype.$onChanges = function (changes) {
            if (changes.vmStorageProfileMetadata.currentValue) {
                this.setStorageProfileContext();
            }
        };
        VmHardwareVirtualDiskStorageProfileCtrl.prototype.setStorageProfileContext = function () {
            this.selected = this.vmStorageProfileMetadata.selectedProfile;
            this.storageProfiles = this.vmStorageProfileMetadata.storageProfiles;
            this.isSelectable = (this.storageProfiles && this.storageProfiles.length > 0);
            this.isReadOnly = (this.displayMode === VmDisplayMode.ReadMode ||
                this.displayMode === VmDisplayMode.ReadAdvancedMode);
        };
        VmHardwareVirtualDiskStorageProfileCtrl.$inject = [
            'i18nService'
        ];
        return VmHardwareVirtualDiskStorageProfileCtrl;
    }());
    var VmHardwareVirtualDiskStorageProfile = (function () {
        function VmHardwareVirtualDiskStorageProfile() {
            this.bindings = {
                onChange: '&',
                displayMode: '<',
                ariaLabel: '<',
                vmStorageProfileMetadata: '<',
                errorConfig: '<'
            };
            this.controller = VmHardwareVirtualDiskStorageProfileCtrl;
            this.templateUrl = 'vm-ui/resources/vm/views/components' +
                '/vmHardwareVirtualDiskStorageProfile/vm-hardware-virtual-disk-storage-profile.html';
        }
        return VmHardwareVirtualDiskStorageProfile;
    }());
    h5_vm.VmHardwareVirtualDiskStorageProfile = VmHardwareVirtualDiskStorageProfile;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskStorageProfile', new VmHardwareVirtualDiskStorageProfile());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmStorageProfileMetadata = (function () {
        function VmStorageProfileMetadata(storageProfiles, selectedProfile) {
            this.storageProfiles = storageProfiles;
            this.selectedProfile = selectedProfile;
        }
        return VmStorageProfileMetadata;
    }());
    h5_vm.VmStorageProfileMetadata = VmStorageProfileMetadata;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var GosUserMappingWrapper = (function () {
        function GosUserMappingWrapper() {
        }
        return GosUserMappingWrapper;
    }());
    angular.module("com.vmware.vsphere.client.vm").component("gosUserMappingWrapper", {
        bindings: {
            vmId: "<"
        },
        controller: GosUserMappingWrapper,
        template: "\n          <vsc-guestos-user-mapping-container [vm-id]=\"$ctrl.vmId\"></vsc-guestos-user-mapping-container>"
    });
})(h5_vm || (h5_vm = {}));



var vm_ui;
(function (vm_ui) {
    var TpmCertDetailInfoController = (function () {
        function TpmCertDetailInfoController(i18nService, timeFormatterService, vxPropertyViewService, $q) {
            this.i18nService = i18nService;
            this.timeFormatterService = timeFormatterService;
            this.vxPropertyViewService = vxPropertyViewService;
            this.$q = $q;
            this.NA_STRING = i18nService.getString("VmUi", "VmTpm.info.na");
        }
        TpmCertDetailInfoController.prototype.$onChanges = function () {
            this.refresh();
        };
        TpmCertDetailInfoController.prototype.refresh = function () {
            var _this = this;
            if (!this.certificateInfo) {
                return;
            }
            var timePromises = {
                validFrom: this.timeFormatterService.formatDate(this.certificateInfo.validFrom),
                validTo: this.timeFormatterService.formatDate(this.certificateInfo.validTo),
            };
            this.$q.all(timePromises).then(function (timePromisesResponse) {
                var builder = _this.vxPropertyViewService.createPropertyViewBuilder();
                var generalCategory = builder.category("general");
                var generalSection = generalCategory.section("generalSection");
                // Subject not shown on purpose
                // generalSection.property(
                //       this.i18nService.getString("VmUi", "certificateInfo.subject"),
                //       this.certificateInfo.subjectName || this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.issuer"), _this.certificateInfo.issuerName || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.version"), _this.certificateInfo.version || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.kind"), _this.certificateInfo.kind || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.validFrom"), timePromisesResponse.validFrom || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.validTo"), timePromisesResponse.validTo || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.algorithm"), _this.certificateInfo.algorithmName || _this.NA_STRING);
                generalSection.property(_this.i18nService.getString("VmUi", "certificateInfo.publicKey"), _this.certificateInfo.publicKeyAlgorithmName || _this.NA_STRING);
                _this.propertyViewData = builder.build();
            });
        };
        TpmCertDetailInfoController.$inject = ["i18nService", "timeFormatterService",
            "vxPropertyViewService", "$q"];
        return TpmCertDetailInfoController;
    }());
    vm_ui.TpmCertDetailInfoController = TpmCertDetailInfoController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("tpmCertDetailInfo", {
        template: "<vx-property-view data=\"$ctrl.propertyViewData\"></vx-property-view>",
        bindings: {
            certificateInfo: "<"
        },
        controller: TpmCertDetailInfoController
    });
})(vm_ui || (vm_ui = {}));



var h5_vm;
(function (h5_vm) {
    var TPM_EXPORT_ACTION = "vsphere.core.vm.tpm.export";
    var TpmCertListController = (function () {
        function TpmCertListController(i18nService, vuiConstants, commonActionBarService, columnRenderersRegistry, navigation, vmTpmService, $scope, visibilityAwareDataUpdateNotificationService, $element, vcH5ConstantsService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.commonActionBarService = commonActionBarService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.navigation = navigation;
            this.vmTpmService = vmTpmService;
            this.$scope = $scope;
            this.visibilityAwareDataUpdateNotificationService = visibilityAwareDataUpdateNotificationService;
            this.$element = $element;
            this.vcH5ConstantsService = vcH5ConstantsService;
            this.refresh = function () {
                _this.loading = true;
                _this.vmTpmService.getCertificates(_this.vmId)
                    .then(function (result) {
                    _this.datagridOptions.data = result;
                })
                    .finally(function () {
                    _this.loading = false;
                });
            };
            this.i18n = i18nService.getString;
            this.vmId = this.navigation.getRoute().objectId;
        }
        TpmCertListController.prototype.getColumnDefinitions = function () {
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer('text');
            return [
                {
                    displayName: this.i18nService.getString("VmUi", "certificate.type"),
                    field: "algorithmName",
                    template: function (item) {
                        return textRenderer(["algorithmName"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("VmUi", "certificate.publicKeyAlgorithmName"),
                    field: "publicKeyAlgorithmName",
                    template: function (item) {
                        return textRenderer(["publicKeyAlgorithmName"], item);
                    }
                },
                {
                    displayName: this.i18nService.getString("VmUi", "certificate.issuer"),
                    field: "issuerNameCN",
                    template: function (item) {
                        return textRenderer(["issuerNameCN"], item);
                    }
                }
            ];
        };
        TpmCertListController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                data: [],
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                resizable: true,
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
            this.$scope.comparator = function () {
                // This is for selecting the single Certificate item by default when the TPM list is displayed
                return true;
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (_this.masterDetailsViewContext) {
                        _this.masterDetailsViewContext.selectedItems = newValue;
                        _this.updateActionBar();
                    }
                }
            });
            this.refresh();
            this.updateActionBar();
            this.subscribeForUpdates();
        };
        TpmCertListController.prototype.updateActionBar = function () {
            var self = this;
            this.commonActionBarService.updateActionBar(this.datagridOptions.actionBarOptions, "actions", [this.vmId], [{
                    actionId: TPM_EXPORT_ACTION,
                    isActionAvailable: function () {
                        return (self.datagridOptions.selectedItems.length === 1);
                    },
                    getActionInvocationContext: function () {
                        return self.datagridOptions.selectedItems[0];
                    }
                }]);
        };
        TpmCertListController.prototype.subscribeForUpdates = function () {
            var self = this;
            var dataUpdateEventsConfig = {};
            dataUpdateEventsConfig[self.vcH5ConstantsService.DATA_REFRESH_INVOCATION_EVENT] = {
                handler: self.refresh
            };
            dataUpdateEventsConfig[self.vcH5ConstantsService.MODEL_CHANGED_EVENT] = {
                handler: self.refresh,
                checker: function (event, objectChangeInfo) {
                    var changeId = null;
                    if (objectChangeInfo.operationType === 'CHANGE') {
                        changeId = objectChangeInfo.objectId;
                    }
                    return (self.vmId === changeId);
                }
            };
            this.visibilityAwareDataUpdateNotificationService.subscribeForDataUpdate(this.$element, this.refresh, dataUpdateEventsConfig);
        };
        TpmCertListController.$inject = [
            'i18nService',
            'vuiConstants',
            'commonActionBarService',
            'columnRenderersRegistry',
            'navigation',
            'vmTpmService',
            '$scope',
            'visibilityAwareDataUpdateNotificationService',
            '$element',
            'vcH5ConstantsService'
        ];
        return TpmCertListController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("tpmCertListComponent", {
        templateUrl: "vm-ui/resources/vm/views/configure/tpm/tpm-cert-list.component.html",
        bindings: {
            masterDetailsViewContext: "<"
        },
        controller: TpmCertListController
    });
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential  */
var h5_ui;
(function (h5_ui) {
    var TpmConfigCertController = (function () {
        function TpmConfigCertController(i18nService, $q) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.masterDetailsViewContext = {};
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("VmUi", "VmTpm.certificateInfo"),
                        templateUrl: "vm-ui/resources/vm/views/configure/tpm/tpm-cert-detail-info.html",
                        uid: "certDetailInfo"
                    }
                ])
            };
        }
        TpmConfigCertController.$inject = ["i18nService", "$q"];
        return TpmConfigCertController;
    }());
    h5_ui.TpmConfigCertController = TpmConfigCertController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmTpmCertificates", {
        templateUrl: "vm-ui/resources/vm/views/configure/tpm/tpm-config-cert.component.html",
        controller: TpmConfigCertController
    });
})(h5_ui || (h5_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential  */
var h5_ui;
(function (h5_ui) {
    var TpmConfigCsrController = (function () {
        function TpmConfigCsrController() {
            this.masterDetailsViewContext = {};
            this.detailsViewData = {
                // No detail view for CSR since there is nothing more to show
                tabsPromise: []
            };
        }
        return TpmConfigCsrController;
    }());
    h5_ui.TpmConfigCsrController = TpmConfigCsrController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmTpmCertSigningRequests", {
        templateUrl: "vm-ui/resources/vm/views/configure/tpm/tpm-config-csr.component.html",
        controller: TpmConfigCsrController
    });
})(h5_ui || (h5_ui = {}));



var h5_vm;
(function (h5_vm) {
    var TPM_EXPORT_ACTION = "vsphere.core.vm.tpm.export";
    var TpmCsrListController = (function () {
        function TpmCsrListController(i18nService, vuiConstants, commonActionBarService, columnRenderersRegistry, navigation, vmTpmService, $scope) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.commonActionBarService = commonActionBarService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.navigation = navigation;
            this.vmTpmService = vmTpmService;
            this.$scope = $scope;
            this.refresh = function () {
                _this.loading = true;
                _this.vmTpmService.getCertSigningRequests(_this.vmId)
                    .then(function (result) {
                    _this.datagridOptions.data = result;
                })
                    .finally(function () {
                    _this.loading = false;
                });
            };
            this.i18n = i18nService.getString;
            this.vmId = this.navigation.getRoute().objectId;
        }
        TpmCsrListController.prototype.getColumnDefinitions = function () {
            var textRenderer = this.columnRenderersRegistry.getColumnRenderer('text');
            return [
                {
                    displayName: this.i18nService.getString("VmUi", "certificate.type"),
                    field: "algorithmName",
                    template: function (item) {
                        return textRenderer(["algorithmName"], item);
                    }
                }
            ];
        };
        TpmCsrListController.prototype.$onInit = function () {
            var _this = this;
            this.datagridOptions = {
                data: [],
                height: "100%",
                columnDefs: this.getColumnDefinitions(),
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                resizable: true,
                selectedItems: [],
                actionBarOptions: { actions: [] }
            };
            this.$scope.$watch(function () {
                return _this.datagridOptions.selectedItems;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (_this.masterDetailsViewContext) {
                        _this.masterDetailsViewContext.selectedItems = newValue;
                        _this.updateActionBar();
                    }
                }
            });
            this.refresh();
            this.updateActionBar();
        };
        TpmCsrListController.prototype.updateActionBar = function () {
            var self = this;
            this.commonActionBarService.updateActionBar(this.datagridOptions.actionBarOptions, "actions", [this.vmId], [{
                    actionId: TPM_EXPORT_ACTION,
                    isActionAvailable: function () {
                        return (self.datagridOptions.selectedItems.length === 1);
                    },
                    getActionInvocationContext: function () {
                        return self.datagridOptions.selectedItems[0];
                    }
                }]);
        };
        TpmCsrListController.$inject = [
            'i18nService',
            'vuiConstants',
            'commonActionBarService',
            'columnRenderersRegistry',
            'navigation',
            'vmTpmService',
            '$scope'
        ];
        return TpmCsrListController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("tpmCsrListComponent", {
        templateUrl: "vm-ui/resources/vm/views/configure/tpm/tpm-csr-list.component.html",
        bindings: {
            vmId: "<",
            masterDetailsViewContext: "<"
        },
        controller: TpmCsrListController
    });
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var LunSelectorDialogService = (function () {
        function LunSelectorDialogService(i18nService, clarityModalService, bytesFilter) {
            var _this = this;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.bytesFilter = bytesFilter;
            this.currentSelection = null;
            /**
             * Opens an OK/Cancel modal dialog with the lunSelectiongrid
             * @params
             * vmConfigEnvironment:
             *    the full vmConfigEnvironment of the VM.
             * okHandler:
             *    a function handler to handle when selection is made and OK is pressed
             *    selection result will be passed back through it.
             */
            this.openLunSelectorDialog = function (existingRdmDisks, vmConfigEnvironment, okHandler) {
                var dialogData = {
                    lunData: _this.processVmConfig(existingRdmDisks, vmConfigEnvironment)
                };
                _this.okHandler = okHandler;
                _this.modalOptions = {
                    title: _this.i18nService.getString("VmUi", "FormSelectLUN.SelectLUN"),
                    contentTemplate: 'vm-ui/resources/vm/views/controls/LUNSelector/lunSelectorDialog.html',
                    defaultButton: 'submit',
                    dialogData: dialogData,
                    size: 'lg',
                    modalClass: '',
                    hideSubmitButton: false,
                    submitDisabled: true,
                    selectedItems: [],
                    alerts: [],
                    onSubmit: _this.onOkClicked
                };
                angular.extend(_this.modalOptions, { selectionChanged: _this.selectionChanged });
                _this.clarityModalService.openOkCancelModal(_this.modalOptions);
            };
            this.selectionChanged = function (newSelection) {
                _this.currentSelection = newSelection;
                if (_this.currentSelection.length === 0) {
                    _this.modalOptions.submitDisabled = true;
                }
                else {
                    _this.modalOptions.submitDisabled = false;
                }
            };
            this.onOkClicked = function () {
                if (_this.currentSelection.length !== 1) {
                    return false;
                }
                if (_this.okHandler && typeof _this.okHandler === 'function') {
                    _this.okHandler(_this.currentSelection);
                }
                return true;
            };
            /**
             * @private method
             * @param configEnv
             * @returns {Array}
             */
            this.processVmConfig = function (existingRdmDisks, configEnv) {
                var result = [];
                if (!configEnv || _.isEmpty(configEnv) ||
                    _.isEmpty(configEnv.configTarget) ||
                    _.isEmpty(configEnv.configTarget.scsiDisk)) {
                    return result;
                }
                _.each(configEnv.configTarget.scsiDisk, function (scsiDisk) {
                    if (!_.isEmpty(scsiDisk.disk) &&
                        !_this.isDiskInUse(existingRdmDisks, scsiDisk.disk)) {
                        var disk = scsiDisk.disk;
                        var diskInfo = {
                            deviceName: disk.deviceName,
                            lunName: disk.displayName,
                            capacity: scsiDisk.capacity,
                            displayCapacity: _this.bytesFilter(scsiDisk.capacity, 'B', 'Auto', 2),
                            lunNum: scsiDisk.lunNumber,
                            driveType: scsiDisk.ssd ? _this.i18nService.getString("VmUi", "FormSelectLUN.DriveType.SSD") :
                                _this.i18nService.getString("VmUi", "FormSelectLUN.DriveType.NonSSD"),
                            hardwareAcceleration: _this.i18nService.getString("VmUi", "RawDisk." + disk.vStorageSupport),
                            lunID: disk.canonicalName,
                            pathId: disk.canonicalName
                        };
                        result.push(diskInfo);
                    }
                });
                return result;
            };
            this.isDiskInUse = function (existingRdmDisks, disk) {
                var diskIsInUse = false;
                for (var i = 0; i < existingRdmDisks.length; i++) {
                    diskIsInUse = existingRdmDisks[i].backing.deviceName === disk.deviceName;
                    if (diskIsInUse) {
                        break;
                    }
                }
                return diskIsInUse;
            };
        }
        LunSelectorDialogService.$inject = [
            'i18nService',
            'clarityModalService',
            'bytesFilter'];
        return LunSelectorDialogService;
    }());
    h5_vm.LunSelectorDialogService = LunSelectorDialogService;
    angular
        .module('com.vmware.vsphere.client.vm')
        .service('lunSelectorDialogService', LunSelectorDialogService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var LunSelectorList = (function () {
        function LunSelectorList() {
            this.bindings = {
                lunData: "<",
                selectionChanged: '&'
            };
            this.controller = LunSelectorListController;
            this.template = "<div id='lunSelectorGrid' class='lun-selector-list'><div vui-datagrid='$ctrl.gridOptions' vx-stretch-grid></div></div>";
        }
        return LunSelectorList;
    }());
    h5_vm.LunSelectorList = LunSelectorList;
    var LunSelectorListController = (function () {
        function LunSelectorListController(i18nService, vuiConstants) {
            var _this = this;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.i18n = function (id) {
                return _this.i18nService.getString('VmUi', id);
            };
            this.getGridOptions = function () {
                var options = {
                    sortMode: _this.vuiConstants.grid.sortMode.SINGLE,
                    selectionMode: _this.vuiConstants.grid.selectionMode.SINGLE,
                    selectedItems: _this.selectedItems,
                    searchable: false,
                    resizable: true,
                    data: _this.lunData,
                    columnDefs: _this.getColumnDefs(),
                    onChange: _this.onSelectionChanged,
                    height: '200px'
                };
                return options;
            };
            this.getColumnDefs = function () {
                return [
                    {
                        displayName: _this.i18n('FormSelectLUN.Name'),
                        field: 'lunName',
                        type: 'string'
                    },
                    {
                        displayName: _this.i18n('FormSelectLUN.PathID'),
                        field: 'pathId',
                        type: 'string'
                    },
                    {
                        displayName: _this.i18n('FormSelectLUN.LUN'),
                        field: 'lunNum',
                        type: 'string'
                    },
                    {
                        displayName: _this.i18n('FormSelectLUN.Capacity'),
                        field: 'displayCapacity',
                        type: 'string'
                    },
                    {
                        displayName: _this.i18n('FormSelectLUN.DriveType'),
                        field: 'driveType',
                        type: 'string'
                    },
                    {
                        displayName: _this.i18n('FormSelectLUN.HardwareAcceleration'),
                        field: 'hardwareAcceleration',
                        type: 'string'
                    }
                ];
            };
            this.onSelectionChanged = function (selectedItems) {
                _this.selectionChanged({ selectedItems: selectedItems });
            };
            this.gridOptions = this.getGridOptions();
        }
        LunSelectorListController.$inject = ['i18nService', 'vuiConstants'];
        return LunSelectorListController;
    }());
    h5_vm.LunSelectorListController = LunSelectorListController;
    angular.module('com.vmware.vsphere.client.vm')
        .component('lunSelectorList', new LunSelectorList());
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningDatastoreFaultsController',
         VmProvisioningDatastoreFaultsController);

   VmProvisioningDatastoreFaultsController.$inject = [
      '$scope',
      'i18nService',
      'vuiConstants'
   ];

   function VmProvisioningDatastoreFaultsController(
      $scope,
      i18nService,
      vuiConstants
   ) {
      var self = this;
      self.gridDescription = i18nService.getString('VmUi', 'dsRecommendation.FaultsTitle');
      var faultsList = $scope.modalOptions.dialogData.faults;
      self.dataGridOptions = {
         columnDefs: [
            {
               displayName: i18nService.getString('VmUi', 'FtFaultDetailsList.description'),
               field: 'message',
               width: '100%',
               template: faultItemTemplate
            }
         ],
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         data: faultsList,
         resizable: true,
         searchable: false,
         height: 350
      };

      function faultItemTemplate(data) {
         if (!data.localizedMessage) {
            if (data.message) {
               data.localizedMessage = data.message;
            } else {
               return '';
            }
         }

         return '<div class="sdrs-fault-item">' + _.escape(data.localizedMessage) + '</div>';
      }
   }
})();

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningDatastoreRecommendationsController',
         VmProvisioningDatastoreRecommendationsController);

   VmProvisioningDatastoreRecommendationsController.$inject = [
      '$scope',
      'defaultUriSchemeUtil',
      'datastoreRecommendationsDatagridOptionsService'
   ];

   function VmProvisioningDatastoreRecommendationsController(
      $scope,
      defaultUriSchemeUtil,
      datastoreRecommendationsDatagridOptionsService
   ) {
      var self = this;

      self.descriptionText = $scope.modalOptions.dialogData.descriptionText;
      self.dataGridOptions = datastoreRecommendationsDatagridOptionsService.getDatagridOptions(
         $scope.modalOptions.dialogData,
         $scope.modalOptions.dialogData.selection
      );

      $scope.preselectRecommendationComparator = function(recommendation) {
         if (_.isEmpty($scope.modalOptions.dialogData.selection)) {
            return false;
         }
         return recommendation.key === $scope.modalOptions.dialogData.selection.key;
      };

      $scope.$watch(function(){return self.dataGridOptions.selectedItems;}, function(selectedItems) {
         if (!selectedItems.length) {
            return null;
         }

         var selectedRecommendation = selectedItems[0];
         var possibleDatastores = $scope.modalOptions.dialogData.possibleDatastores;
         $scope.modalOptions.dialogData.selection = {
            recommendationSpec: selectedRecommendation,
            datastoreName: getRecommendedDs(selectedRecommendation, possibleDatastores)
         };
      });

      function getRecommendedDs(recommendation, idToNameMap) {
         var datastoreMoRef = recommendation.actions[0].destination;
         var datastoreUid = defaultUriSchemeUtil.getVsphereObjectId(datastoreMoRef);
         return idToNameMap[datastoreUid];
      }
   }
})();

var h5_vm;
(function (h5_vm) {
    var VmProvisioningCustomizeTemplateController = (function () {
        function VmProvisioningCustomizeTemplateController($scope, vmProvisioningCustomizeTemplatePageModel) {
            var _this = this;
            this.$scope = $scope;
            this.vmProvisioningCustomizeTemplatePageModel = vmProvisioningCustomizeTemplatePageModel;
            this.pageModel = this.$scope.vmProvisioningCustomizeTemplatePageModel;
            this.pageModel.wizardViewData = this.$scope.wizardViewData;
            this.pageModel.vmParams = this.$scope.vmParams;
            this.$scope.vuiWizard.currentPage.disableNext = function () {
                return !_this.form.valid;
            };
        }
        VmProvisioningCustomizeTemplateController.prototype.$onInit = function () {
            this.customizeTemplateParams = this.pageModel.customizeTemplateParams;
            this.ipAllocationPolicy = this.pageModel.ipAllocationPolicyParams;
            this.form = this.pageModel.form;
        };
        VmProvisioningCustomizeTemplateController.prototype.onStatusChange = function (componentStatus) {
            this.form.valid = componentStatus.valid;
            this.form.customizeTemplateParams = componentStatus.result;
        };
        VmProvisioningCustomizeTemplateController.$inject = ["$scope", "vmProvisioningCustomizeTemplatePageModel"];
        return VmProvisioningCustomizeTemplateController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningCustomizeTemplateController", VmProvisioningCustomizeTemplateController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningDeploymentOptionsController = (function () {
        function VmProvisioningDeploymentOptionsController($scope, vmProvisioningDeploymentOptionsService) {
            this.$scope = $scope;
            this.vmProvisioningDeploymentOptionsService = vmProvisioningDeploymentOptionsService;
            this.deploymentOptionParams = this.$scope.vmProvisioningDeploymentConfigPageModel.form.deploymentOptionParams;
        }
        VmProvisioningDeploymentOptionsController.prototype.$onInit = function () {
            this.vmProvisioningDeploymentOptionsService
                .figureOutTheItemSelectedInDeploymentOptions(this.deploymentOptionParams);
        };
        VmProvisioningDeploymentOptionsController.prototype.onSelectionChange = function (selectedOption) {
            this.deploymentOptionParams.selectedKey = selectedOption.key;
        };
        VmProvisioningDeploymentOptionsController.$inject = ["$scope", "vmProvisioningDeploymentOptionsService"];
        return VmProvisioningDeploymentOptionsController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningDeploymentOptionsController", VmProvisioningDeploymentOptionsController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningDeploymentOptionsService = (function () {
        function VmProvisioningDeploymentOptionsService() {
        }
        VmProvisioningDeploymentOptionsService.prototype.figureOutTheItemSelectedInDeploymentOptions = function (deploymentOptionParams) {
            if (deploymentOptionParams
                && deploymentOptionParams.deploymentOptions
                && deploymentOptionParams.deploymentOptions.length > 0) {
                this.createIsSelectedFieldInEachOption(deploymentOptionParams);
            }
        };
        VmProvisioningDeploymentOptionsService.prototype.createIsSelectedFieldInEachOption = function (deploymentOptionParams) {
            var currentSelectedOptionKey = deploymentOptionParams.selectedKey;
            _.each(deploymentOptionParams.deploymentOptions, function (option) {
                option['defaultChoice'] = (option.key === currentSelectedOptionKey) ? true : false;
                option['isSelected'] = option.defaultChoice;
            });
        };
        return VmProvisioningDeploymentOptionsService;
    }());
    angular.module("com.vmware.vsphere.client.vm").service('vmProvisioningDeploymentOptionsService', VmProvisioningDeploymentOptionsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningEulaDisplayController = (function () {
        function VmProvisioningEulaDisplayController(i18nService, $location, $anchorScroll, eulaDisplayService) {
            this.i18nService = i18nService;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.eulaDisplayService = eulaDisplayService;
            this.linkDescriptions = [];
            if (!_.isEmpty(this.form.eulaInfo) && !_.isEmpty(this.form.eulaInfo.eulas)) {
                this.numberOfEulasFound = this.form.eulaInfo.eulas.length;
                this.headerDescription = this.eulaDisplayService.getEulaDescription(this.numberOfEulasFound);
                this.linkDescriptions = this.eulaDisplayService.getInfoDescriptions(this.numberOfEulasFound);
            }
        }
        VmProvisioningEulaDisplayController.prototype.scrollTo = function (id) {
            this.$location.hash(id);
            this.$anchorScroll();
        };
        VmProvisioningEulaDisplayController.$inject = [
            "i18nService",
            "$location",
            "$anchorScroll",
            "vmProvisioningEulaDisplayService"
        ];
        return VmProvisioningEulaDisplayController;
    }());
    var VmProvisioningEulaDisplay = (function () {
        function VmProvisioningEulaDisplay() {
            this.controller = VmProvisioningEulaDisplayController;
            this.templateUrl = "vm-ui/resources/vm/views/createVmWizard/" +
                "deployOvfPages/vmProvisioningEula/vm-provisioning-eula-display.html";
            this.bindings = {
                form: "="
            };
        }
        return VmProvisioningEulaDisplay;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningEulaDisplay", new VmProvisioningEulaDisplay());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningEulaDisplayService = (function () {
        function VmProvisioningEulaDisplayService(i18nService) {
            this.i18nService = i18nService;
        }
        VmProvisioningEulaDisplayService.prototype.getEulaDescription = function (numberOfEulasFound) {
            var eulaDescription = "";
            if (numberOfEulasFound > 0) {
                eulaDescription = (numberOfEulasFound === 1) ?
                    this.i18nService.getString("ProvisioningUiLib", "AcceptEulaPage.acceptSingle") :
                    this.i18nService.getString("ProvisioningUiLib", "AcceptEulaPage.acceptAllAtOnce", [numberOfEulasFound]);
            }
            return eulaDescription;
        };
        /*
           Remove this method after the Bug#1804672 is fixed
        */
        VmProvisioningEulaDisplayService.prototype.getInfoDescriptions = function (numberOfEulasFound) {
            var infoDescriptions = [];
            for (var i = 0; i < numberOfEulasFound; i++) {
                infoDescriptions.push("Agreement " + (i + 1));
            }
            return infoDescriptions;
        };
        VmProvisioningEulaDisplayService.$inject = ["i18nService"];
        return VmProvisioningEulaDisplayService;
    }());
    angular.module("com.vmware.vsphere.client.vm").
        service("vmProvisioningEulaDisplayService", VmProvisioningEulaDisplayService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningEulaController = (function () {
        function VmProvisioningEulaController($scope) {
            var _this = this;
            this.$scope = $scope;
            this.form = this.$scope.vmProvisioningEulaPageModel.form;
            this.$scope.vuiWizard.currentPage.disableNext = function () {
                return !_this.form.eulaInfo.allEULAAccepted;
            };
        }
        VmProvisioningEulaController.$inject = ["$scope"];
        return VmProvisioningEulaController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningEulaController", VmProvisioningEulaController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningProductDetailsController = (function () {
        function VmProvisioningProductDetailsController($scope, i18nService, vuiConstants, vmProvisioningProductDetailsDataModel) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.vmProvisioningProductDetailsDataModel = vmProvisioningProductDetailsDataModel;
            this.EULA_OBJ_TYPE = "com.vmware.vcenter.ovf.EulaParams";
            this.DEPLOYMENT_OPTIONS_OBJ_TYPE = "com.vmware.vcenter.ovf.DeploymentOptionParams";
            this.viewData = this.$scope.wizardViewData;
            this.vmSpec = this.$scope.vmParams;
            var commonContext = this.viewData.getDeployFromLibraryCommonContext();
            this.model = this.$scope.productDetailsPageModel;
            this.model.dataModel = vmProvisioningProductDetailsDataModel;
            this.model.dataModel.initProductDetails(commonContext);
            this.model.dataModel.updateVmNameToDeploy(this.vmSpec.getName(), commonContext);
            this.model.form.isReady = true;
            this.controlFutureWizardPagesBehavior(commonContext);
        }
        VmProvisioningProductDetailsController.prototype.controlFutureWizardPagesBehavior = function (commonContext) {
            var eulaPage = this.getEulaWizardPageObject(this.$scope.vuiWizardPages);
            var deploymentConfigPage = this.getDeploymentOptionsWizardPageObject(this.$scope.vuiWizardPages);
            var scaleoutConfigurationPage = this.getScaleoutConfigurationPageObject(this.$scope.vuiWizardPages);
            var networkPage = this.getNetworkPageObject(this.$scope.vuiWizardPages);
            var vserviceProviderPage = this.getVservicePageObject(this.$scope.vuiWizardPages);
            var customizeTemplatePage = this.getCustomizeTemplatePageObject(this.$scope.vuiWizardPages);
            if (eulaPage) {
                eulaPage.state = this.unskipEulaPage(commonContext) ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
            if (deploymentConfigPage) {
                deploymentConfigPage.state = this.unskipDeploymentConfigPage(commonContext) ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
            if (scaleoutConfigurationPage) {
                scaleoutConfigurationPage.state = this.unskipScaleoutConfiguration() ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
            if (networkPage) {
                networkPage.state = this.unskipNetworksPage() ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
            if (customizeTemplatePage) {
                customizeTemplatePage.state = this.unskipCustomizeTemplatePage() ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
            if (vserviceProviderPage) {
                vserviceProviderPage.state = this.unskipVserviceProviderPage() ?
                    this.vuiConstants.wizard.pageState.DISABLED : this.vuiConstants.wizard.pageState.SKIPPED;
            }
        };
        VmProvisioningProductDetailsController.prototype.getEulaWizardPageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title ===
                    _this.i18nService.getString("Common", "EulaControl.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.getDeploymentOptionsWizardPageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title === _this.i18nService.getString("Common", "DeploymentOptions.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.getScaleoutConfigurationPageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title === _this.i18nService.getString("ProvisioningUiLib", "ScaleoutPage.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.getNetworkPageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title === _this.i18nService.getString("ProvisioningUiLib", "SelectNetworksPage.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.getCustomizeTemplatePageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title === _this.i18nService.getString("Common", "UserDefinedPropertiesPage.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.getVservicePageObject = function (vuiWizardPages) {
            var _this = this;
            return _.find(vuiWizardPages, function (page) {
                return (page.title === _this.i18nService.getString("ProvisioningUiLib", "VServicePage.title"));
            });
        };
        VmProvisioningProductDetailsController.prototype.unskipEulaPage = function (commonContext) {
            var _this = this;
            var eulaInfo = _.find(commonContext, function (item) {
                return (_.isEqual(item._type, _this.EULA_OBJ_TYPE));
            });
            return (eulaInfo && !_.isEmpty(eulaInfo.eulas));
        };
        VmProvisioningProductDetailsController.prototype.unskipDeploymentConfigPage = function (commonContext) {
            var _this = this;
            var deploymentOptions = _.find(commonContext, function (item) {
                return (_.isEqual(item._type, _this.DEPLOYMENT_OPTIONS_OBJ_TYPE));
            });
            return !_.isUndefined(deploymentOptions);
        };
        VmProvisioningProductDetailsController.prototype.unskipScaleoutConfiguration = function () {
            var scaleoutConfiguration = this.viewData.getSclaeoutConfigurationFromLibraryCommonContext();
            return !_.isUndefined(scaleoutConfiguration) &&
                Array.isArray(scaleoutConfiguration.groups) &&
                scaleoutConfiguration.groups.length > 0;
        };
        VmProvisioningProductDetailsController.prototype.unskipNetworksPage = function () {
            var networkMappingParams = this.viewData.getNetworkMappingParamsFromLibraryCommonContext();
            var ipAllocationParams = this.viewData.getIpAllocationParamsFromLibraryCommonContext();
            return !_.isUndefined(networkMappingParams) ||
                !_.isUndefined(ipAllocationParams);
        };
        VmProvisioningProductDetailsController.prototype.unskipCustomizeTemplatePage = function () {
            var userDefinedProperties = this.viewData.getCustomizeTemplateFromLibraryCommonContext();
            return !_.isUndefined(userDefinedProperties);
        };
        VmProvisioningProductDetailsController.prototype.unskipVserviceProviderPage = function () {
            var vserviceParams = this.viewData.getVserviceContextFromLibraryCommonContext();
            return !_.isUndefined(vserviceParams);
        };
        VmProvisioningProductDetailsController.$inject = [
            "$scope",
            "i18nService",
            "vuiConstants",
            "vmProvisioningProductDetailsDataModel"
        ];
        return VmProvisioningProductDetailsController;
    }());
    angular
        .module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningProductDetailsController", VmProvisioningProductDetailsController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningScaleoutConfigurationController = (function () {
        function VmProvisioningScaleoutConfigurationController($scope) {
            var _this = this;
            this.$scope = $scope;
            this.scaleoutConfiguration = {
                params: this.getScaleoutConfigurationParams(),
                valid: true
            };
            this.$scope.vuiWizard.currentPage.disableNext = function () {
                return !_this.scaleoutConfiguration.valid;
            };
        }
        VmProvisioningScaleoutConfigurationController.prototype.getScaleoutConfigurationParams = function () {
            var scaleoutParams = this.$scope
                .vmProvisioningScaleoutConfigurationPageModel
                .virtualMachineSpecBuilderObj
                .getSclaeoutConfigurationFromLibraryCommonContext();
            return scaleoutParams.groups;
        };
        VmProvisioningScaleoutConfigurationController.$inject = ["$scope"];
        return VmProvisioningScaleoutConfigurationController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningScaleoutConfigurationController", VmProvisioningScaleoutConfigurationController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var OvfConstants = h5_vm.OvfDeployConstants;
    var VmProvisioningSelectOvfComponent = (function () {
        function VmProvisioningSelectOvfComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/createVmWizard/deployOvfPages/vmProvisioningSelectOvf/vm-provisioning-select-ovf.component.html";
            this.controller = VmProvisioningSelectOvfController;
            this.controllerAs = "ctrl";
            this.bindings = {
                pageModel: "<",
                wizard: "<",
                wizardManager: "<",
            };
        }
        return VmProvisioningSelectOvfComponent;
    }());
    /**
     * The select template (local/url) page controller.
     */
    var VmProvisioningSelectOvfController = (function () {
        function VmProvisioningSelectOvfController($scope, AngularInjector, clarityModalService, i18nService, vuiConstants, featureFlagsService, ovfSelectionValidator) {
            var _this = this;
            this.$scope = $scope;
            this.AngularInjector = AngularInjector;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.featureFlagsService = featureFlagsService;
            this.ovfSelectionValidator = ovfSelectionValidator;
            this.ovfSelectionErrorMsg = '';
            this.mode = "deploy";
            this.DUMMY_LIBRARY_ID = "urn:vapi:com.vmware.content.Library:Dummy-Library-Id";
            this.onSelectorComponentStatusChanged = function (sourceSelectorEvent) {
                if (!sourceSelectorEvent.isValid) {
                    _this.form.ovfUrl = null;
                    _this.form.selectedFiles = null;
                    //isValid = true can be still not usable for localfile
                    //we need to do a deep OVF check to be sure that User's file selection is
                    //valid indeed
                    //but false always means unable to proceed in any case
                    _this.form.isValid = false;
                    _this.ovfSelectionErrorMsg = '';
                    return;
                }
                if (sourceSelectorEvent.sourceType === OvfConstants.DEPLOYMENT_URL) {
                    _this.form.isValid = true;
                    _this.form.isLocalDeployment = false;
                    _this.form.ovfUrl = sourceSelectorEvent.url;
                    _this.ovfSelectionErrorMsg = '';
                }
                else {
                    _this.form.isLocalDeployment = true;
                    if (sourceSelectorEvent.workflowType === OvfConstants.TEMPLATE_TYPE_OVF) {
                        _this.ovfSelectionValidator.validate(_this.contextObjId, sourceSelectorEvent.selectedFiles)
                            .then(function (result) {
                            _this.form.isValid = !result.hasError;
                            _this.form.userSelectedFiles = sourceSelectorEvent.selectedFiles;
                            _this.ovfSelectionErrorMsg = result.hasError ? result.errorMsg : '';
                        });
                    }
                    else if (sourceSelectorEvent.workflowType === OvfConstants.TEMPLATE_TYPE_OVA) {
                        //invoke OvaMapper: receive the list of files
                        var ovaMapperService = _this.AngularInjector.get('vscOvaMapperProxyService');
                        if (ovaMapperService) {
                            ovaMapperService.getFilesFromOva(sourceSelectorEvent.selectedFiles[0])
                                .then(function (ovaFiles) {
                                _this.ovfSelectionValidator.validate(_this.contextObjId, ovaFiles)
                                    .then(function (result) {
                                    _this.form.isValid = !result.hasError;
                                    _this.form.userSelectedFiles = ovaFiles;
                                    _this.ovfSelectionErrorMsg = result.hasError ? _this.i18n('ProvisioningUiLib', 'DeployOvfPage.invalidOva') : '';
                                });
                            });
                        }
                    }
                    _this.form.selectedFiles = sourceSelectorEvent.selectedFiles;
                }
            };
            this.i18n = i18nService.getString;
        }
        VmProvisioningSelectOvfController.prototype.$onInit = function () {
            var _this = this;
            this.form = this.pageModel.form;
            this.fileBrowserOptions = {
                enabled: true,
                showValidationErrors: true,
                selectMultiple: true,
                fileFilter: []
            };
            this.contextObjId = this.pageModel.getContextObjId();
            this.wizard.currentPage.onCommit = function () {
                var uriProbeService = _this.AngularInjector.get('vscUriProbeService');
                if (!_this.form.hasAcceptedUntrustedSource && !_this.form.isLocalDeployment) {
                    return uriProbeService.validate({ url: _this.form.ovfUrl,
                        libraryId: _this.DUMMY_LIBRARY_ID
                    }).then(function (resultObj) {
                        if (resultObj && resultObj.unknownSource) {
                            _this.openSslThumbprintAlert(resultObj.sslThumbprint);
                            return false;
                        }
                        _this.wizard.currentPage.state = _this.vuiConstants.wizard.pageState.COMPLETED;
                        _this.pageModel.submitPage();
                        return true;
                    }, function (error) {
                        _this.form.isValid = false;
                        _this.ovfSelectionErrorMsg = (error && error.displayErrors) ? error.displayErrors[0] : '';
                        return false;
                    });
                }
                else {
                    _this.wizard.currentPage.state = _this.vuiConstants.wizard.pageState.COMPLETED;
                    _this.pageModel.submitPage();
                    return true;
                }
            };
        };
        VmProvisioningSelectOvfController.prototype.openSslThumbprintAlert = function (sslThumbprint) {
            var _this = this;
            this.clarityModalService.openConfirmationModal({
                title: this.i18n("LibraryUi", "ProbeUtil.probeFailureDialog.title"),
                message: !_.isEmpty(sslThumbprint) ? this.i18nService.getString("LibraryUi", "ProbeUtil.probeFailureDialog.message.certificateErrorWithThumbprint", sslThumbprint) : this.i18nService.getString("LibraryUi", "ProbeUtil.probeFailureDialog.message.certificateError"),
                preserveNewlines: !_.isEmpty(sslThumbprint) ? true : false,
                saveButtonLabel: this.i18n("LibraryUi", "yes"),
                clarityIcon: {
                    shape: "warning",
                    class: "is-warning",
                    size: !_.isEmpty(sslThumbprint) ? 64 : 32
                },
                submit: function () {
                    _this.form.sslThumbprint = sslThumbprint;
                    _this.form.hasAcceptedUntrustedSource = true;
                    _this.wizardManager.onNextClick();
                    return true;
                },
                onCancel: function () {
                    _this.form.sslThumbprint = "";
                }
            });
        };
        VmProvisioningSelectOvfController.$inject = [
            '$scope',
            'AngularInjector',
            'clarityModalService',
            'i18nService',
            'vuiConstants',
            'featureFlagsService',
            'vscOvfSelectionValidatorProxyService'
        ];
        return VmProvisioningSelectOvfController;
    }());
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningSelectOvfComponent", new VmProvisioningSelectOvfComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmProvisioningVserviceController = (function () {
        function VmProvisioningVserviceController($scope) {
            this.$scope = $scope;
            this.vserviceContext =
                $scope.wizardViewData.getVserviceContextFromLibraryCommonContext();
            //Pre-selecting provider to either 0 or a preselected index.
            if (this.vserviceContext && this.vserviceContext.dependencies) {
                this.vserviceContext.dependencies.forEach(function (dependency) {
                    if (dependency.availableProviders) {
                        var selectableIndex = 0;
                        // If provider was previously selected.
                        if (dependency.selectedProviderKey) {
                            selectableIndex = dependency.availableProviders.findIndex(function (provider) {
                                return (provider.key === dependency.selectedProviderKey);
                            });
                        }
                        dependency.selectedProviderKey =
                            dependency.availableProviders[selectableIndex].key;
                    }
                });
            }
        }
        VmProvisioningVserviceController.$inject = ["$scope"];
        return VmProvisioningVserviceController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmProvisioningVserviceController", VmProvisioningVserviceController);
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningCloneOptionsComponent = (function () {
        function VmProvisioningCloneOptionsComponent() {
            this.controller = VmProvisioningCloneOptionsController;
            this.templateUrl = "vm-ui/resources/vm/views/createVmWizard/vm-provisioning-clone-options-page.component.html";
            this.bindings = {
                pageModel: "<",
                creationType: "<",
                wizardConfig: "<"
            };
        }
        return VmProvisioningCloneOptionsComponent;
    }());
    h5_vm.VmProvisioningCloneOptionsComponent = VmProvisioningCloneOptionsComponent;
    var VmProvisioningCloneOptionsController = (function () {
        function VmProvisioningCloneOptionsController(wizardPageService, i18nService, configurationService) {
            this.wizardPageService = wizardPageService;
            this.i18nService = i18nService;
            this.configurationService = configurationService;
            this.i18n = i18nService.getString;
        }
        VmProvisioningCloneOptionsController.prototype.$onInit = function () {
            var _this = this;
            this.pageModel.resetForm();
            this.pages = this.wizardConfig.pages;
            var flows = this.wizardConfig.flows;
            if (flows && flows.length > 0) {
                var flow = _.find(flows, function (flow) {
                    return _this.creationType === flow.id;
                });
                if (flow) {
                    this.pages = flow.pages;
                }
            }
            this.changeGosPageState();
            this.changeCustomizeHwPageState();
        };
        VmProvisioningCloneOptionsController.prototype.changeGosPageState = function () {
            if (!this.pageModel.form.customizeOs) {
                this.wizardPageService.markPageSkipped(this.pages, this.i18nService.getString('VmUi', 'CustomizeGuestOsProvisioningPage.Title'));
                this.wizardPageService.markPageSkipped(this.pages, this.i18nService.getString('VmUi', 'UserSettingsPage.Title'));
            }
            else {
                this.wizardPageService.markPageDisabled(this.pages, this.i18nService.getString('VmUi', 'CustomizeGuestOsProvisioningPage.Title'));
            }
        };
        VmProvisioningCloneOptionsController.prototype.changeCustomizeHwPageState = function () {
            if (!this.pageModel.form.customizeHw) {
                this.wizardPageService.markPageSkipped(this.pages, this.i18nService.getString('VmUi', 'CustomizeHardwareProvisioningPage.Title'));
            }
            else {
                this.wizardPageService.markPageDisabled(this.pages, this.i18nService.getString('VmUi', 'CustomizeHardwareProvisioningPage.Title'));
            }
        };
        ;
        VmProvisioningCloneOptionsController.$inject = [
            "wizardPageService",
            "i18nService",
            "configurationService"
        ];
        return VmProvisioningCloneOptionsController;
    }());
    h5_vm.VmProvisioningCloneOptionsController = VmProvisioningCloneOptionsController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningCloneOptions", new VmProvisioningCloneOptionsComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectAnyTemplatePageModelFactory = (function () {
        function VmProvisioningSelectAnyTemplatePageModelFactory($q, i18nService, vmProvisioningSelectTemplatePageModel) {
            return function (wizardScope) {
                return new VmProvisioningSelectAnyTemplatePageModel($q, i18nService, vmProvisioningSelectTemplatePageModel, wizardScope);
            };
        }
        VmProvisioningSelectAnyTemplatePageModelFactory.$inject = [
            "$q",
            "i18nService",
            "vmProvisioningSelectTemplatePageModel"
        ];
        return VmProvisioningSelectAnyTemplatePageModelFactory;
    }());
    var VmProvisioningSelectAnyTemplatePageModel = (function () {
        function VmProvisioningSelectAnyTemplatePageModel($q, i18nService, vmProvisioningSelectTemplatePageModel, wizardScope) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.vcTemplatePageModelService = vmProvisioningSelectTemplatePageModel;
            this.initFromWizardScope(wizardScope);
        }
        VmProvisioningSelectAnyTemplatePageModel.prototype.initFromWizardScope = function (wizardScope) {
            this.vcTemplatePageModel = new this.vcTemplatePageModelService(wizardScope.vmParams, wizardScope.wizardViewData, wizardScope.config);
            this._virtualSpecBuilder = wizardScope.vmParams;
            this._wizardViewData = wizardScope.wizardViewData;
            this._wizardConfig = wizardScope.config;
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.getVcTemplatePageModel = function () {
            return this.vcTemplatePageModel;
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.getVcTemplateSelection = function () {
            return this.vcTemplatePageModel.getSelectionId();
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.getIsVcTemplateSelected = function () {
            return this.vcTemplatePageModel.getSelectionIsTemplate();
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.getClTemplateSelection = function () {
            var item = this._wizardViewData.getSelectedTemplate();
            return item;
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.setClTemplateSelection = function (item) {
            this._wizardViewData.setSelectedTemplate(item);
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.resetStorage = function () {
            if (!this._virtualSpecBuilder) {
                return;
            }
            this._virtualSpecBuilder.resetStorage();
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.resetForm = function () {
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.isSameTemplate = function (a, b) {
            if (a && b) {
                return a.templateId === b.templateId;
            }
            return false;
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.isTemplateChanged = function () {
            var a = this._wizardViewData.getSelectedTemplate();
            var b = this.submittedClTemplate;
            if (this.isSameTemplate(a, b)) {
                return false;
            }
            else {
                return true;
            }
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.validatePage = function () {
            if (this._wizardViewData.getSelectedTemplate()) {
                return {};
            }
            return this.vcTemplatePageModel.validatePage();
        };
        VmProvisioningSelectAnyTemplatePageModel.prototype.submitPage = function () {
            var selectedTemplate = this._wizardViewData.getSelectedTemplate();
            if (selectedTemplate) {
                this._wizardConfig.title = this.i18nService.getString("VmUi", "ProvisioningTypes.DeployFromTemplate.WizardTitle.2", selectedTemplate.templateName);
                var changed = this.isTemplateChanged();
                var retVal = {
                    wizardFlow: "deployVmFromAnyTemplate",
                    invalidateNextPages: changed
                };
                this._virtualSpecBuilder.setVmId(undefined);
                if (changed) {
                    this.resetStorage();
                    this.submittedClTemplate = selectedTemplate;
                }
                return retVal;
            }
            if (this.submittedClTemplate) {
                this.submittedClTemplate = null;
                this.resetStorage();
            }
            var result = this.vcTemplatePageModel.submitPage();
            result.wizardFlow = "deployVmFromAnyTemplate";
            return result;
        };
        VmProvisioningSelectAnyTemplatePageModel.$inject = [
            "$q",
            "i18nService",
            "vmProvisioningSelectTemplatePageModel"];
        return VmProvisioningSelectAnyTemplatePageModel;
    }());
    h5_vm.VmProvisioningSelectAnyTemplatePageModel = VmProvisioningSelectAnyTemplatePageModel;
    angular.module("com.vmware.vsphere.client.vm")
        .factory("vmProvisioningSelectAnyTemplatePageModel", VmProvisioningSelectAnyTemplatePageModelFactory);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectTemplateComponent = (function () {
        function VmProvisioningSelectTemplateComponent() {
            this.bindings = {
                pageModel: "<",
                wizardViewData: "<",
                onSelectionChanged: "&"
            };
            this.controller = VmProvisioningSelectTemplateToConvertPageController;
            this.templateUrl = "vm-ui/resources/vm/views/createVmWizard/vm-provisioning-select-template-page.component.html";
        }
        return VmProvisioningSelectTemplateComponent;
    }());
    h5_vm.VmProvisioningSelectTemplateComponent = VmProvisioningSelectTemplateComponent;
    var VmProvisioningSelectTemplateToConvertPageController = (function () {
        function VmProvisioningSelectTemplateToConvertPageController(defaultUriSchemeUtil, i18nService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18nService = i18nService;
            this.treeViewConfig = {
                preselectRoot: false,
                expandPreselectedNode: true
            };
            var creationType = this.pageModel.virtualMachineSpecBuilder.getCreationType();
            if (creationType === this.pageModel.getLastSelectedCreationType()) {
                this.preselectionId = this.pageModel.getSelectionId();
            }
            this.selectTemplateDescription = this.i18nService.getString("VmUi", "SelectTemplateProvisioningPage.Template.Description");
        }
        VmProvisioningSelectTemplateToConvertPageController.prototype.onChange = function (item) {
            var _this = this;
            this.setLoadingIndicator(true);
            this.pageModel.updateSelection(item);
            this.triggerOnSelectionChange();
            this.pageModel.validateSelection().then(function (compatibilityMessage) {
                _this.compatibilityMessage = compatibilityMessage;
                _this.setLoadingIndicator(false);
            });
        };
        VmProvisioningSelectTemplateToConvertPageController.prototype.setLoadingIndicator = function (setting) {
            if (this.pageModel.showLoadingIndicator) {
                this.pageModel.config.loading = setting;
            }
        };
        VmProvisioningSelectTemplateToConvertPageController.prototype.triggerOnSelectionChange = function () {
            if (this.onSelectionChanged) {
                this.onSelectionChanged();
            }
        };
        VmProvisioningSelectTemplateToConvertPageController.$inject = [
            "defaultUriSchemeUtil",
            "i18nService"
        ];
        return VmProvisioningSelectTemplateToConvertPageController;
    }());
    h5_vm.VmProvisioningSelectTemplateToConvertPageController = VmProvisioningSelectTemplateToConvertPageController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningSelectTemplate", new VmProvisioningSelectTemplateComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningCloneGuestOsController', VmProvisioningCloneGuestOsController);

   VmProvisioningCloneGuestOsController.$inject = [
      '$scope',
      'i18nService',
      'wizardPageService'
   ];

   function VmProvisioningCloneGuestOsController($scope,
                                                 i18nService,
                                                 wizardPageService) {
      var self = this;
      var model = $scope.vmProvisioningCloneCustomizeGuestOsPageModel;
      self.form = model.getForm();
      self.readyToView = false;
      self.uncustomizableMessage = '';

      model.resetForm();

      self.form.setPageLoading = function (bool) {
         $scope.config.loading = bool;
      };

      self.form.showUserSettingsPage = function(showPage) {
         var pages = $scope.config.pages;

         if ($scope.config.flows && $scope.config.flows.length > 0) {
            var flow = _.find($scope.config.flows, function(flow) {
               return $scope.attributes.creationType === flow.id;
            });
            if (flow) {
               pages = flow.pages;
            }
         }
         if (showPage) {
            wizardPageService.markPageDisabled(
                  pages,
                  i18nService.getString('VmUi', 'UserSettingsPage.Title')
            );
         } else {
            wizardPageService.markPageSkipped(
                  pages,
                  i18nService.getString('VmUi', 'UserSettingsPage.Title'));
         }
      };

      $scope.preselectGuestOsComparator = function(guestOs) {
         if (!self.form.selectedSpec) {
            return false;
         }

         return guestOs.name === self.form.selectedSpec.name;
      };

      $scope.$watch(
         function() { return self.form.datagridOptions.selectedItems;},
         function(newItems, oldItems) {
            if (newItems !== oldItems) {
               wizardPageService.clearErrors($scope.config);
               self.form.selectedSpec = !newItems || newItems.length === 0 ?
                     null :
                     newItems[0];
            }
         },
         /* inequality of the self.form.datagridOptions.selectedItems is determined
            according to the angular.equals function. */
         true);
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningComputeResourceController', VmProvisioningComputeResourceController);

   VmProvisioningComputeResourceController.$inject = ['$scope', 'i18nService',
      'zoneDigestPatchService', 'treeViewErrorConstants'];

   function VmProvisioningComputeResourceController($scope, i18nService,
         zoneDigestPatchService, treeViewErrorConstants) {
      var self = this;

      $scope.$on('$destroy', function() {
         setLoadingIndicator(false);
      });

      $scope.computeResourcePageModel.resetForm();
      self.title = i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Compatibility');
      self.description = i18nService.getString('VmUi', 'SelectResourcePoolProvisioningPage.Description');
      self.pageReady = false;
      setLoadingIndicator(true);
      $scope.computeResourcePageModel.getTreeType().then(function (treeType) {
         self.treeType = treeType;
         self.pageReady = true;
         if (!self.preselectedNode) {
            setLoadingIndicator(false);
         }
      });
      self.rootObjReference = $scope.computeResourcePageModel.getTreeRootReference();
      self.preselectedNode = $scope.computeResourcePageModel.form.selectedComputeResourceId;
      self.config = {
         preselectRoot: false
      };

      var lastValidationId = 0;

      self.onChange = function(objectId, objectName) {
         $scope.wizardManager.clearValidationBanner();

         $scope.computeResourcePageModel.form.selectedComputeResourceId = objectId;
         $scope.computeResourcePageModel.form.selectedComputeResourceName = objectName;

         $scope.config.loadingMessage = i18nService.getString('CommonUi', 'wizard.validating');
         self.validatingSelectedCrAriaLabel =
            i18nService.getString('VmUi',
               'ProvisioningWizard.selectCrPage.validatingAriaLabelFormat',
               $scope.computeResourcePageModel.form.selectedComputeResourceName);

         var validationId = ++lastValidationId;

         setLoadingIndicator(false);
         setIsValidating(true);
         $scope.computeResourcePageModel.validateSelection()
               .then(function(compatibilityResults) {
                  if(validationId === lastValidationId) {
                     self.contents = compatibilityResults;
                  }
               })
               .then(function() {
                  if(validationId === lastValidationId) {
                     setIsValidating(false);
                  }
                  zoneDigestPatchService.digest();
               });
      };

      self.onError = function(error) {
         if (error.name === treeViewErrorConstants.SELECTION.name) {
            setLoadingIndicator(false);
         }
      };

      function setLoadingIndicator(setting) {
         $scope.config.loading = setting;
      }

      function setIsValidating(isLoading) {
         self.isValidating = !!isLoading;
      }
   }
})();

(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmProvisioningDatastorePageController', VmProvisioningDatastorePageController);

   VmProvisioningDatastorePageController.$inject = [
      '$scope',
      '$q',
      '$element',
      '$timeout',
      'i18nService',
      'defaultUriSchemeUtil',
      'diskFormatService',
      'storageSelectorService',
      'storageSelectorConstants',
      'creationTypeConstants',
      'dataService',
      'storageProfileService',
      'initialStorageConfigurationService',
      'pmemUtilService',
      'featureFlagsService'
   ];

   function VmProvisioningDatastorePageController($scope,
         $q,
         $element,
         $timeout,
         i18nService,
         defaultUriSchemeUtil,
         diskFormatService,
         storageSelectorService,
         storageSelectorConstants,
         creationTypeConstants,
         dataService,
         storageProfileService,
         initialStorageConfigurationService,
         pmemUtilService,
         featureFlagsService) {
      var self = this;
      // When going back to a page with a selected storage, the newValue and oldValue
      // in the watch for the self.form.selectedStorage are equal, so no validation
      // event is invoked. So we have introduced the flag to enforce validation.
      var preserveInitialSelection = false;

      self.i18n = i18nService;

      var model = $scope.datastorePageModel;
      self.form = model.form;

      var isScheduledTask = $scope.scheduleTaskData ?
         $scope.scheduleTaskData.isScheduledTask : false;

      self.podDisplayDisabled = model.podDisplayDisabled() || isScheduledTask;
      self.isVmtxWorkflow = model.isCloningVmtxTemplate() || model.isDeployVmFromVmtxTemplate();
      self.isDiskGroupsAvailable = false;

      self.disableDefaultPreselectionInBasicMode = model.virtualMachineSpecBuilder.isXvc();

//      if (model.isInDeployTemplateMode()) {
//         self.disableDefaultPreselectionInBasicMode = true;
//      }

      self.showReplicationGroups = !model.isInDeployVmFromOvf();

      self.storageSelectorApi = storageSelectorService.getStorageSelectorApiObj();

      // In Create  mode we prefer signpost hints - in clone we prefer alert hints.
      self.showStorageBaselineSignpostHints = !model.isInCloningMode();

      self.isEncryptionOptionsVisible = !model.isInCloningMode()
         && model.virtualMachineSpecBuilder.getHasEncryptNewVmPrivilege();
      self.isEncryptionOptionsDisabled = true;
      self.encryptionOptionsDisabledReason = undefined;
      model.virtualMachineSpecBuilder.getStoragePageData()
            .then(function(response) {
               response = response.vmStoragePageData;
               // If already disabled, leave it this way
               if (self.encryptionOptionsDisabledReason) {
                  return;
               }

               // When the user doesn't have permission to aggregate the KMS statuses,
               // don't stop him because he will still be able to create encrypted VM
               // if the KMS servers are OK.
               if (response && response.h5DefaultKmipClusterStatus
                     && response.h5DefaultKmipClusterStatus.noPermission) {
                  self.isEncryptionOptionsDisabled = false;
                  return;
               }

               var isConnectionNormal = response && response.h5DefaultKmipClusterStatus &&
                     response.h5DefaultKmipClusterStatus.connectionStatus === h5_vm.ConnectionStatus.CONNECTED;
               var isCertificateExpired = response && response.h5DefaultKmipClusterStatus &&
                     response.h5DefaultKmipClusterStatus.certificateStatus === h5_vm.CertStatus.EXPIRED;

               self.isEncryptionOptionsDisabled = !isConnectionNormal || isCertificateExpired;
               if (!isConnectionNormal) {
                  self.encryptionOptionsDisabledReason =
                        i18nService.getString('VmUi', 'VmCryptConfig.reason.noKms');
               } else if (isCertificateExpired) {
                  self.encryptionOptionsDisabledReason =
                        i18nService.getString('VmUi', 'VmCryptConfig.reason.kmsCertificateRequiresUpdate');
               }
            }, function() {
               self.isEncryptionOptionsDisabled = true;
               self.encryptionOptionsDisabledReason =
                     i18nService.getString('VmUi', 'VmCryptConfig.reason.noKms');
            });

      //Restore storage selector state if there is such
      var storageSelectorState = angular.copy(model.virtualMachineSpecBuilder.getStorageSelectorState());
      if (storageSelectorState) {
         this.form.storageSelectorState = storageSelectorState;
         this.storageSelectorState = storageSelectorState;
      } else {
         this.form.storageSelectorState =
               storageSelectorService.getStorageSelectorState();
         preserveInitialSelection = true;
      }
      this.storageSelectorState = this.form.storageSelectorState;

      self.title = i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Compatibility');
      self.description = i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.Description');
      self.pageLoadError = undefined;

      $scope.config.loading = true;

      var shouldRequestHostIcons = true;
      this.onShowDetailsClick = function (contents) {
         var hostIds = _.chain(contents)
               .pluck('hostId').without(undefined).uniq().value();

         if (!hostIds.length || !shouldRequestHostIcons) {
            return $q.resolve();
         }

         return dataService.getPropertiesForObjects(hostIds, ['primaryIconId']).then(function (results) {
            _.each(contents, function (hostObject) {
               if (hostObject.hostId) {
                  hostObject.icon = results[hostObject.hostId].primaryIconId;
               }
            });
         });
      };

       // Compute resource ID is not available for clone VMTX template
       // Using the source VMs ID as the compute resource in that case
       if (model.isCloningVmtxTemplate() && !featureFlagsService.CL_Native_VMTX_Phase2Enabled()) {
           var vmId = $scope.wizardViewData.getSourceObjectId();
           model.setComputeResourceId(vmId);
       }

      var resource = model.getComputeResourceOwnerId() || model.getComputeResourceId();
      var gridPromise = model.getStorageLocatorData(resource);

      var profilesPromise = model
            .getProfilesData(model.getServerGuid());

      var sourceId = model.virtualMachineSpecBuilder.getVmId() || (
            $scope.wizardViewData &&
            $scope.wizardViewData.getSelectedTemplate() &&
            $scope.wizardViewData.getSelectedTemplate().templateId);

      var allPromises = {
         'model': model.load(),
         'grid': gridPromise,
         'profiles': profilesPromise
      };
      if (isAdvancedStorageAvailableForCurrentFlow(
                  model.virtualMachineSpecBuilder.getCreationType())) {
         if (model.isInDeployFromTemplateMode()) {
            // Deploy from OVF/ContentLibrary
            allPromises['getStorageSelectorData'] = {};
            allPromises['getStorageSelectorData']['virtualDisks'] = model.requestVmDisksInDeployFromTemplateMode();
            allPromises['getStorageSelectorData']['vmHomeDatastore'] =
                  model.requestVmHomeDatastoresInDeployFromTemplateMode();
            self.isDiskGroupsAvailable = true;
         } else {
            var getStorageSelectorDataPromise = model.getStorageSelectorData(sourceId);
            allPromises['getStorageSelectorData'] = getStorageSelectorDataPromise;
         }
      } else if (model.isInDeployFromTemplateMode()) {
         // Deploy from OVF/ContentLibrary
         allPromises['getStorageSelectorData'] = {};
         allPromises['getStorageSelectorData']['virtualDisks'] = model.requestVmDisksInDeployFromTemplateMode();
         allPromises['getStorageSelectorData']['vmHomeDatastore'] =
               model.requestVmHomeDatastoresInDeployFromTemplateMode();
      } else {
         // The default values - usually empty (but DEFINED) objects
         allPromises['getStorageSelectorData'] = {};
         allPromises['getStorageSelectorData']['virtualDisks'] = model.form.vmDisksData;
         allPromises['getStorageSelectorData']['vmHomeDatastore'] = model.form.vmsHomeDatastore;
      }
      $q.all(allPromises).then(function (results) {
         if (!results['grid']) {
            self.pageLoadError = new Error(
               i18nService.getString('VmUi', 'SelectDatastoreProvisioningPage.noStorageAvailable'));
            self.pageReady = false;
            $scope.config.loading = false;
            return;
         }

         setupDiskFormatSettings();

         var vmId = model.virtualMachineSpecBuilder.getVmId();

         var profiles = results['profiles'];

         if (self.isEncryptionOptionsVisible) {
            var encryptionProfile = _.find(profiles.storageProfiles, function (profile) {
               return storageProfileService.isEncryptionStorageProfile(profile);
            });

            if (!encryptionProfile) {
               if (!model.virtualMachineSpecBuilder.getHasManageEncryptionPolicyPrivilege()) {
                  self.isEncryptionOptionsVisible = false;
               }

               if (!self.encryptionOptionsDisabledReason) {
                  self.isEncryptionOptionsDisabled = true;
                  self.encryptionOptionsDisabledReason =
                  i18nService.getString('VmUi', 'VmCryptConfig.reason.noEncryptionPolicies');
               }
            }
         }

         if (results['getStorageSelectorData']) {
            profiles.vmProfileAssignments = {};
            profiles.vmProfileAssignments[sourceId] = results['getStorageSelectorData'].
                  storagePoliciesAssignments;

            profiles.vmReplicationGroupAssignments = {};
            profiles.vmReplicationGroupAssignments[sourceId] =
                  results['getStorageSelectorData'].vmReplicationGroupAssignments;
         }

         if (model.isInDeployFromTemplateMode()) {
            self.unsupportedStorageBaselineIds = [storageSelectorConstants.PMEM_STORAGE_BASELINE.id];

            profiles._storageProfiles =
                  model.getRecommendedProfilesForTemplateDeployment(profiles.storageProfiles);
            self.form.storageLocatorItemsData.datastoreItems =
                  model.getRecommendedDatastoresForTemplateDeployment();
         }

         self.modeSettings = storageSelectorService.getStorageSelectorModeSettings(
               isAdvancedStorageAvailableForCurrentFlow(
                     model.virtualMachineSpecBuilder.getCreationType()));

         var names = model.getVmNames();
         names[vmId] = model.virtualMachineSpecBuilder.getName();

         var destinationHostId =
               defaultUriSchemeUtil.getEntityType(model.getComputeResourceId()) === "HostSystem"
                     ? model.getComputeResourceId() : null;
         var vmDiskData = results['getStorageSelectorData'].virtualDisks;
         var vmHomeDatastoreData = results['getStorageSelectorData'].vmHomeDatastore;

         var vmData = [];
         if (vmId || vmDiskData) {
            // common_ui.StorageSelectorVmProperties
            vmData.push({
               id: vmId,
               name: names[vmId],
               homeDatastore: vmHomeDatastoreData ? vmHomeDatastoreData[vmId]: null,
               destinationHost: destinationHostId,
               disksData: vmDiskData ? vmDiskData[vmId] : null
            });
         }

         storageSelectorService.getStorageSelectorData(vmId || model.getComputeResourceId(),
               self.form.storageLocatorItemsData, true, vmData, profiles)
            .then(function (storageSelectorData) {

            // If we are in create VM workflow, we need to pass the VM destination host
            // to the storageSelectorData.
            if (!vmId && storageSelectorData.sourceVmStorageConfig &&
                  storageSelectorData.sourceVmStorageConfig.length &&
                  !storageSelectorData.sourceVmStorageConfig[0].destinationHostId) {
               storageSelectorData.sourceVmStorageConfig[0].destinationHostId = destinationHostId;
            }
            self.storageSelectorData = storageSelectorData;

            var scheduledData = model.virtualMachineSpecBuilder.getScheduledData();
            if (scheduledData && scheduledData.storageData) {
               var isCreateFromScratch = model.virtualMachineSpecBuilder.getCreationType() ===
                     creationTypeConstants.CREATE_FROM_SCRATCH;
               initialStorageConfigurationService.computeSourceVmStorageConfig(scheduledData.storageData.initialVmStorageConfig,
                     profiles._storageProfiles, self.storageSelectorData, isCreateFromScratch);
            }

            model.virtualMachineSpecBuilder
               .setSourceVmStorageConfig(storageSelectorData.sourceVmStorageConfig);

            var initialReplicationGroup;
            if (storageSelectorData.sourceVmStorageConfig &&
                  storageSelectorData.sourceVmStorageConfig.length) {
               initialReplicationGroup =
                     self.storageSelectorData.sourceVmStorageConfig[0].vmHome.replicationGroup;
            }
            if (storageSelectorData.storageProfilesData.error) {
               model.virtualMachineSpecBuilder.containsSpbmIssues(true);
            } else {
               model.virtualMachineSpecBuilder.containsSpbmIssues(false);
            }
            // Set the selected item to the first storage pod
            // or datastore item from the queried storages.
            if (!storageSelectorState
                  && (self.form.storageLocatorItemsData.datastoreItems.length > 0
                  || self.form.storageLocatorItemsData.storagePodItems.length > 0)) {

               var itemToSelect = model.getItemToSelect(
                     self.form.storageLocatorItemsData.datastoreItems,
                     self.form.storageLocatorItemsData.storagePodItems
               );

               var profileToSelect = model.getProfileToSelect();

               self.storageSelectorData.initialConfig = storageSelectorService.getStorageSelectorInitialConfig(
                     itemToSelect,
                     profileToSelect,
                     initialReplicationGroup
               );

               if (scheduledData && scheduledData.storageData) {
                  initialStorageConfigurationService.initSelectedStorageItems(
                        self.storageSelectorState, self.storageSelectorData, scheduledData.storageData);
               }

            }
            self.pageReady = true;
            $scope.config.loading = false;

            // focus the first input on the page
            focusFirstElement();
         });
         // If a VM is being cloned or template is being deployed/cloned, the source
         // VM/template profile should be the one assigned to its clone by default
         if (!self.form.storageProfileHasBeenSelected && profiles.vmProfileAssignments &&
               profiles.vmProfileAssignments[vmId] && profiles.vmProfileAssignments[vmId].homeStorageProfile) {
            self.form.storageProfilesData.selectedProfile =
                  buildProfileItem(profiles.vmProfileAssignments[vmId].homeStorageProfile);
         }
      });

      var lastValidationId = 0;

      function isAdvancedStorageAvailableForCurrentFlow(flowType) {
         return flowType === creationTypeConstants.CLONE_VM_TO_TEMPLATE ||
                flowType === creationTypeConstants.CLONE_VM_TO_VM ||
                flowType === creationTypeConstants.CLONE_TEMPLATE_TO_VM ||
                flowType === creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE ||
                flowType === creationTypeConstants.CLONE_AS_VMTEMPLATE_TO_LIBRARY ||
                flowType === creationTypeConstants.DEPLOY_VM_FROM_VMTX ||
                model.isDiskGroupsAvailable();

      }

      function validateSelection(selectedStorage, selectedProfileId, diskFormat) {
         setIsValidating(true);
         var validationId = ++lastValidationId;

         var rgValidationError = self.storageSelectorApi.validateReplicationGroupSelection();

         var sourceVmStorageConfig = self.storageSelectorData.vmStorageConfig[0];
         model.validateSelection(selectedStorage, selectedProfileId, diskFormat,
               rgValidationError, sourceVmStorageConfig)
               .then(function(compatibilityMessages) {
                  if(validationId === lastValidationId) {
                     self.contents = compatibilityMessages;
                     shouldRequestHostIcons = true;
                  }
               })
               .then(function() {
                  if(validationId === lastValidationId) {
                     setIsValidating(false);
                  }
               });
      }

      function validateAdvancedSelection(selectedStorage) {
         setIsValidating(true);
         var validationId = ++lastValidationId;

         var sourceVmStorageConfig = self.storageSelectorData.vmStorageConfig[0];

         model.validateAdvancedSelection(selectedStorage, sourceVmStorageConfig)
               .then(function(compatibilityMessages) {
                  if(validationId === lastValidationId) {
                     self.contents = compatibilityMessages;
                  }
               })
               .then(function() {
                  if(validationId === lastValidationId) {
                     setIsValidating(false);
                  }
               });
      }

      function setIsValidating(isValidating) {
         self.isValidating = !!isValidating;
         $scope.config.loading = isValidating;
      }

      function setupDiskFormatSettings() {
         self.form.diskFormatSettings.diskFormatSupported = isDiskFormatSupported();
         self.form.diskFormatSettings.sameAsSourceSupported = isSameAsSourceSupported();
         self.form.diskFormatSettings.drsPlacement = model.isInDeployTemplateMode();
      }

      function isDiskFormatSupported() {
         return model.isInCloningMode() || model.isInDeployFromTemplateMode();
      }

      function isSameAsSourceSupported() {
         return model.isInCloningMode();
      }

      function buildProfileItem(profile) {
         if (!profile) {
            return null;
         }
         return {
            label: profile.name,
            id: profile.profileId.uniqueId,
            profileObj: profile
         };
      }

      self.onSelectionChanged = function () {
         $scope.wizardManager.clearValidationBanner();
         var selectedProfile = self.storageSelectorData.vmStorageConfig[0].vmHome.storageProfile;
         // vmStorageConfig is the actual/ultimate output from the storageSelector
         self.form.vmStorageConfig = self.storageSelectorData.vmStorageConfig;
         self.form.diskFormatSettings = self.storageSelectorState.basicModeState.diskFormatSettings;
         model.setSelectionIsValid(false);
         var selectedStorage;
         switch (self.storageSelectorState.mode) {
            case "basicMode":
               selectedStorage = self.storageSelectorState.basicModeState.selectedItem;
               if (model.isInDeployTemplateMode() ||
                     isSelectionComplete() ||
                     self.storageSelectorData.storageProfilesData.error) {
                  validateSelection(selectedStorage, selectedProfile && selectedProfile.id, self.form.diskFormatSettings);
               }
               self.form.isAdvancedStorageMode = false;
               model.virtualMachineSpecBuilder.setStorageSelectorState(self.form.storageSelectorState);
               break;
            case "advancedMode":
               selectedStorage = self.storageSelectorState.vmStorageConfigInAdvancedMode[0].vmHome.storageObj;
               self.form.isAdvancedStorageMode = true;
               validateAdvancedSelection(selectedStorage);
               if (preserveInitialSelection || (self.form.storageSelectorState.recentlySelectedStorageItemsInAdvancedMode &&
                     self.form.storageSelectorState.recentlySelectedStorageItemsInAdvancedMode.length)) {
                  model.virtualMachineSpecBuilder.setStorageSelectorState(self.form.storageSelectorState);
                  preserveInitialSelection = false;
               }
               break;
         }
      };

      function isSelectionComplete() {
         var isIncomplete = _.some(self.storageSelectorData.vmStorageConfig,
               function (vmStorageConfig /*common_ui.VmStorageConfig*/) {
            // Check the VM home storage availability
            if (!vmStorageConfig.vmHome.storageObj) {
               // The full selection is not here yet
               return true;
            }

            // If all disks should go to PMEM there is no need to validate that
            // they have a proper selection.
            if (self.storageSelectorState.storageBaselineId ===
                  storageSelectorConstants.PMEM_STORAGE_BASELINE.id) {
               return false;
            }

            // And then each disk storage availability
            return _.some(vmStorageConfig.vmDisks, function (diskStorageConfig) {
               // If nothing is selected and the disk is not on a PMEM storage
               // then selection is INCOMPLETE.
               return !diskStorageConfig.storageObj
                     && !pmemUtilService.isPMemStoragePolicy(
                           diskStorageConfig.storageProfile);
            });
         });

         return !isIncomplete;
      }

      function focusFirstElement() {
         // focus the first input on the page
         $timeout(function () {
            var firstInput = $element[0].querySelector("input:not([disabled]),select,button");
            if (firstInput) {
               firstInput.focus();
            }
         }, 0);
      }

   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmProvisioningFinishCloneController',
               VmProvisioningFinishCloneController);

   VmProvisioningFinishCloneController.$inject = [
      '$scope',
      'datastoreRecommendationService',
      'i18nService'
   ];

   function VmProvisioningFinishCloneController($scope,
         datastoreRecommendationService,
         i18nService) {
      var self = this;
      var model = $scope.vmProvisioningFinishCloneVmPageModel;

      model.resetForm();
      self.form = model.form;

      var sourceObjectInfo = model.getSourceObjectInfo();
      var targetObjectInfo = model.getTargetObjectInfo();

      var crInfo = model.getComputeResourceInfo();
      $scope.computeResourceName = crInfo.name;
      $scope.computeResourceType = crInfo.label;

      $scope.provisioningTypeName = model.presentProvisioningType();
      $scope.sourceObjectName = sourceObjectInfo.name;
      $scope.sourceObjectLabel = sourceObjectInfo.label;
      $scope.targetObjectName = targetObjectInfo.name;
      $scope.targetObjectLabel = targetObjectInfo.label;
      //Wrap in anonymous function in order to preserve the functions "this" context.
      //Otherwise it's replaced by the $scope's this.
      self.datastoreLabel = model.presentTargetStorageName();
      self.isStorageProfileAvailable = function() {
         return model.isStorageProfileSpecified();
      };
      self.isReplicationGroupAvailable = function() {
         return model.isReplicationGroupSpecified();
      };
      $scope.targetFolderName = model.getTargetFolderName();
      $scope.diskFormat = model.presentDiskFormat();
      $scope.vmStorageProfile = model.getStorageProfile();
      $scope.vmReplicationGroup = model.getReplicationGroup();
      $scope.gosCustomizationSpecName = model.getGosCustomizationSpecName();
      $scope.gosWasCustomized = model.isGosCustomized();
      $scope.newDisks = model.shouldShowDisks() ? model.getNewDisks() : [];
      $scope.existingDisks = model.shouldShowDisks() ? model.getExistingDisks() : [];
      $scope.nvdimmDevices = model.getNvdimmDevicesInfo();
      $scope.shouldDsiplayHwCustomizedProperties = model.shouldDsiplayHwCustomizedProperties();
      if($scope.shouldDsiplayHwCustomizedProperties){
         $scope.numberOfCpus = model.getNumberOfCpus();
         $scope.allocatedMemory = model.getAllocatedMemory();
         $scope.networkDevices = model.getNetworkInterfaces();
      }

      $scope.config.loadingMessage =
            i18nService.getString('CommonUi', 'wizard.loading');
      $scope.config.loading = true;
      model.fetchStoragePlacementRecommendations().then(function() {
         self.recommendationFaults = [];
      }, function(faults) {
         self.recommendationFaults = faults;
      }).then(function() {
         $scope.config.loading = false;
         self.datastoreLabel = model.presentTargetStorageName();
         model.setDisksDatastoreInfo($scope.newDisks);
         model.setDisksDatastoreInfo($scope.existingDisks);
      });

      self.openFaultsDialog = function() {
         datastoreRecommendationService.openFaultsDialog($scope, self.recommendationFaults);
      };

      self.openRecommendationsDialog = function(disk) {
         datastoreRecommendationService.openRecommendationsDialog(disk ? disk.diskKey : undefined, $scope, model)
               .then(function() {
                  self.datastoreLabel = model.presentTargetStorageName();
                  model.setDisksDatastoreInfo($scope.newDisks);
                  model.setDisksDatastoreInfo($scope.existingDisks);
               });
      };

      self.shouldDisplayRecommendations = function(disk) {
         if(model.virtualMachineSpecBuilder.isXvc()) {
            return false;
         }
         var storageObject;
         if (disk) {
            storageObject = disk.getStorageObject();
            // Pmem disks are not affected by SDRS
            if (disk.isPmemDisk) {
               return false;
            }
         }
         else {
            storageObject = model.virtualMachineSpecBuilder.getStorageObject();
         }
         return datastoreRecommendationService.areRecommendationsAvailableForStorageObject(storageObject);
      };

      self.isNewDisk = function(disk) {
         return disk.diskKey < 0;
      };

      self.shouldShowStorageProfile = function(diskObject) {
         // The disk object has the disk key in "diskKey" property
         var diskKey = {
            key: diskObject.diskKey
         };
         return !model.diskHasDefaultStoragePolicy(diskKey);
      };

      this.shouldShowDiskFormat = function() {
         return $scope.diskFormat && !model.isAdvancedStorageMode();
      };

      self.getStorageHint = function() {
         var hint = '';
         if (model.shouldShowDisks()) {
            return hint;
         }
         var pmemDiskInfo = model.getPmemDiskInfo();
         if (pmemDiskInfo.hasPmemDisk) {
            hint = pmemDiskInfo.hasRegularDisk ?
                  i18nService.getString(
                        'VmUi', 'ProvisioningWizardSummaryPage.pmem.hint.hybridBaseline') :
                  i18nService.getString(
                        'VmUi', 'ProvisioningWizardSummaryPage.pmem.hint.pmemBaseline');
         }
         if (pmemDiskInfo.hasDowngradedPmemDisk) {
            hint =  i18nService.getString(
                  'VmUi', 'ProvisioningWizardSummaryPage.pmem.hint.standardBaseline');
         }
         return hint;
      };


   }

})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningFinishController', VmProvisioningFinishController);

   VmProvisioningFinishController.$inject = [
      '$scope',
      'datastoreRecommendationService',
      'i18nService'
   ];

   function VmProvisioningFinishController(
      $scope,
      datastoreRecommendationService,
      i18nService
   ) {
      var self = this;
      var model = $scope.vmProvisioningFinishCreateVmPageModel;

      var crInfo = model.getComputeResourceInfo();
      $scope.computeResourceName = crInfo.name;
      $scope.computeResourceLabel = crInfo.label;

      //Wrap in anonymous function in order to preserve the functions "this" context.
      //Otherwise it's replaced by the $scope's this.
      self.datastoreLabel = model.presentTargetStorageName();
      self.isStorageProfileAvailable = function() {
         return model.isStorageProfileSpecified();
      };

      self.isVmHomeEncrypted = function() {
         return model.isVmHomeEncrypted();
      };
      self.areAllDisksEncrypted = function() {
         return model.areAllDisksEncrypted();
      };

      $scope.numberOfCpus = model.getNumberOfCpus();
      $scope.allocatedMemory = model.getAllocatedMemory();
      $scope.vmVersion = model.getVmVersionCompatibility();
      $scope.vmName = model.getVmName();
      $scope.targetFolderName = model.getTargetFolderName();
      $scope.vmStorageProfile = model.getStorageProfile();
      $scope.vmReplicationGroupLabel = model.getReplicationGroup();
      $scope.guestOsName = model.getGuestOsName();
      $scope.vbsEnabled = model.getVbsEnabled();
      $scope.networkDevices = model.getNetworkInterfaces();
      $scope.disks = model.getDisks();
      $scope.scsiControllers = model.getScsiControllers();
      $scope.tpmDeviceExists = !!model.getTpmDevice();
      $scope.nvdimmDevices = model.getNvdimmDevicesInfo();

      $scope.config.loadingMessage =
            i18nService.getString('CommonUi', 'wizard.loading');
      $scope.config.loading = true;
      model.fetchStoragePlacementRecommendations().then(function() {
         self.recommendationFaults = [];
      }, function(faults) {
         self.recommendationFaults = faults;
      }).then(function() {
         $scope.config.loading = false;
         self.datastoreLabel = model.presentTargetStorageName();
         model.setDisksDatastoreInfo($scope.disks);
      });

      self.openFaultsDialog = function() {
         datastoreRecommendationService.openFaultsDialog($scope, self.recommendationFaults);
      };

      self.openRecommendationsDialog = function(disk) {
         datastoreRecommendationService.openRecommendationsDialog(disk ? disk.diskKey : undefined, $scope, model)
               .then(function() {
                  self.datastoreLabel = model.presentTargetStorageName();
                  model.setDisksDatastoreInfo($scope.disks);
               });
      };

      self.shouldDisplayRecommendations = function (disk) {
         var storageObject;
         if(disk){
            storageObject = disk.getStorageObject();
         }
         else{
            storageObject = model.virtualMachineSpecBuilder.getStorageObject();
         }

         return datastoreRecommendationService
               .areRecommendationsAvailableForStorageObject(storageObject);
      };

      self.isNewDisk = function(disk) {
         return disk.diskKey < 0;
      };

      self.shouldShowStorageProfile = function(diskObject) {
         // The disk object has the disk key in "diskKey" property
         var diskKey = {
            key: diskObject.diskKey
         };
         return !model.diskHasDefaultStoragePolicy(diskKey);
      };
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .controller('VmProvisioningFinishConvertToVmController', VmProvisioningFinishConvertToVmController);

   VmProvisioningFinishConvertToVmController.$inject = ['$scope'];

   function VmProvisioningFinishConvertToVmController($scope) {
      var model = $scope.vmProvisioningFinishConvertToVmPageModel;
      var computeResourceInfo = model.getComputeResourceInfo();
      
      this.provisioningTypeName = model.getProvisioningType();
      this.templateName = model.getTemplateName();      
      this.targetResourceTypeLabel = computeResourceInfo.label;
      this.targetResourceName = computeResourceInfo.name;
   }
})();

var h5_vm;
(function (h5_vm) {
    var VmProvisioningFinishRegisterController = (function () {
        function VmProvisioningFinishRegisterController(i18nService) {
            this.i18nService = i18nService;
            var isTemplate = this.pageModel.getIsTemplate();
            this.vmNameLabel = isTemplate ?
                this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.TemplateName") :
                this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.VmName");
            this.vmName = this.pageModel.getVmName();
            this.targetFolderLabel = this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Folder");
            this.targetFolderName = this.pageModel.getTargetFolderName();
            var computeResourceInfo = this.pageModel.getComputeResourceInfo();
            this.computeResourceType = computeResourceInfo.label;
            this.computeResourceName = computeResourceInfo.name;
        }
        VmProvisioningFinishRegisterController.$inject = [
            "i18nService"];
        return VmProvisioningFinishRegisterController;
    }());
    h5_vm.VmProvisioningFinishRegisterController = VmProvisioningFinishRegisterController;
    var VmProvisioningFinishRegisterComponent = (function () {
        function VmProvisioningFinishRegisterComponent() {
            this.controller = VmProvisioningFinishRegisterController;
            this.templateUrl =
                "vm-ui/resources/vm/views/createVmWizard/vmProvisioningFinishRegisterComponent.html";
            this.bindings = {
                pageModel: "<"
            };
        }
        return VmProvisioningFinishRegisterComponent;
    }());
    h5_vm.VmProvisioningFinishRegisterComponent = VmProvisioningFinishRegisterComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningFinishRegister", new VmProvisioningFinishRegisterComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * The select Guest OS page controller.
 */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningGuestOsController', VmProvisioningGuestOsController);

   VmProvisioningGuestOsController.$inject = ['$scope', 'i18nService', 'templateHelperService'];

   function VmProvisioningGuestOsController($scope, i18nService, templateHelperService) {
      var self = this;

      $scope.config.loadingMessage =  i18nService.getString('CommonUi', 'wizard.loading');
      $scope.config.loading = true;
      $scope.guestOsPageModel.resetForm().then(function () {
         $scope.config.loading = false;
      });
      self.form = $scope.guestOsPageModel.form;

      $scope.$on('$destroy', function() {
         $scope.config.loading = false;
      });

      var enableVBSHelpTemplate = 'vm-ui/resources/vm/views/createVmWizard/enableVBSHelpText.html';
      templateHelperService.renderTemplateWithScope(enableVBSHelpTemplate, $scope).then(function(content) {
         $scope.enableVBSSignPostParams = {
            message: content,
            title: i18nService.getString('Common', 'help'),
            class: 'cpu-mmu-help-text'
         };
      });
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * The select VM name and folder page controller.
 */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningNameAndFolderController', VmProvisioningNameAndFolderController);

   VmProvisioningNameAndFolderController.$inject = ['$scope', 'i18nService', 'creationTypeConstants', 'wizardPageService'];

   function VmProvisioningNameAndFolderController($scope, i18nService, creationTypeConstants, wizardPageService) {
      var self = this;

      $scope.nameAndFolderPageModel.resetForm();

      self.form = $scope.nameAndFolderPageModel.form;
      self.treeType = $scope.nameAndFolderPageModel.getTreeType();
      self.treeRoot = $scope.nameAndFolderPageModel.getTreeRoot();
      self.preselectedLocation = $scope.nameAndFolderPageModel.targetIdToPreselect();
      self.pageInstructions = $scope.nameAndFolderPageModel.pageInstructions();
      self.wizardType =  $scope.vmParams.getCreationType();
      self.invalidNameMessage = '';

      self.onNameChanged = function() {
         self.invalidNameMessage =
               $scope.nameAndFolderPageModel.checkVmName(false);
         self.wideTooltip = self.invalidNameMessage.length > 80;
      };

      self.onTargetChange = function(locationId, locationName, nodeTypeId, item) {
         _.assign(self.form.selectedTarget, {
            uid: locationId,
            name: locationName,
            type: nodeTypeId,
            item: item
         });

         setLoadingIndicator(true);
         $scope.config.loadingMessage = i18nService.getString('CommonUi', 'wizard.validating');

         $scope.nameAndFolderPageModel.validateSelection().then(function (compatibilityMessage) {
            self.compatibilityMessage = compatibilityMessage;
            setLoadingIndicator(false);
         });
      };

      var pages = $scope.vuiWizardPages;

      self.changeGosPageState = function() {
         if (!self.form.customizeOs) {
            wizardPageService.markPageSkipped(
                  pages,
                  i18nService.getString('VmUi', 'CustomizeGuestOsProvisioningPage.Title')
            );
            wizardPageService.markPageSkipped(
                  pages,
                  i18nService.getString('VmUi', 'UserSettingsPage.Title')
            );
         } else {
            wizardPageService.markPageDisabled(
                  pages,
                  i18nService.getString('VmUi', 'CustomizeGuestOsProvisioningPage.Title')
            );
         }
      };

      self.isInDeployFromTemplateMode = function () {
         return self.wizardType === creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE;
      };

      function setLoadingIndicator(setting) {
         $scope.config.loading = setting;
      }

      $scope.$on('$destroy', function() {
         setLoadingIndicator(false);
      });
   }

})();

var h5_vm;
(function (h5_vm) {
    var IpAllocationPolicy = (function () {
        function IpAllocationPolicy() {
        }
        IpAllocationPolicy.DHCP = "DHCP";
        IpAllocationPolicy.STATIC_MANUAL = "STATIC_MANUAL";
        IpAllocationPolicy.STATIC_IPPOOL = "STATIC_IPPOOL";
        IpAllocationPolicy.TRANSIENT_IPPOOL = "TRANSIENT_IPPOOL";
        return IpAllocationPolicy;
    }());
    h5_vm.IpAllocationPolicy = IpAllocationPolicy;
    var IpProtocol = (function () {
        function IpProtocol() {
        }
        IpProtocol.IPV4 = "IPV4";
        IpProtocol.IPV6 = "IPV6";
        return IpProtocol;
    }());
    h5_vm.IpProtocol = IpProtocol;
    var VmProvisioningNetworkMappingController = (function () {
        function VmProvisioningNetworkMappingController($scope, i18nService, vuiConstants) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vuiConstants = vuiConstants;
            this.i18n = this.i18nService.getString;
        }
        VmProvisioningNetworkMappingController.prototype.$onInit = function () {
            var _this = this;
            if (this.networkMappings) {
                this.dataGridOptions = {
                    columnDefs: [
                        {
                            displayName: this
                                .i18nService
                                .getString('ProvisioningUiLib', 'NetworkMappingsControl.templateNetworkColumnHeader'),
                            field: 'name'
                        },
                        {
                            displayName: this
                                .i18nService
                                .getString('ProvisioningUiLib', 'NetworkMappingsControl.selectedNetworkColumnHeader'),
                            field: 'target',
                            template: function () {
                                return _this.buildDestinationNetworkDropdown();
                            }
                        }
                    ],
                    selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                    selectedItems: [],
                    data: this.networkMappings.sourceNetworks
                };
                this.cancelOnTargetNetworkChanged = this.$scope.$on('onTargetNetworkChanged', function (e, dataItem) {
                    var changedNetwork = _this.findNetworkByName(dataItem.name);
                    changedNetwork.target = dataItem.target;
                });
            }
            if (this.ipAllocationParams) {
                this.populateLocalizedNamesForIpAllocation();
                this.populateLocalizedNamesForIpProtocol();
            }
        };
        VmProvisioningNetworkMappingController.prototype.findNetworkByName = function (name) {
            var network = _.find(this.networkMappings.sourceNetworks, function (nw) {
                return nw.name === name;
            });
            return network;
        };
        VmProvisioningNetworkMappingController.prototype.buildDestinationNetworkDropdown = function () {
            var _this = this;
            var dropdownTemplate = ['<div class="select" >',
                '<select class="location-select"',
                'ng-change="$emit(\'onTargetNetworkChanged\',dataItem)"',
                'name="destination-networks"',
                'ng-model="dataItem.target">'];
            _.each(this.networkMappings.targetNetworks, function (network) {
                if (network.accessible) {
                    dropdownTemplate.push(_this.buildDestinationNetworkOption(network.id, network.name));
                }
            });
            dropdownTemplate.push([
                "</select></div>"
            ]);
            var template = dropdownTemplate.join('');
            return template;
        };
        VmProvisioningNetworkMappingController.prototype.buildDestinationNetworkOption = function (id, name) {
            return "<option value=\"" + id + "\">" + name + "</option>";
        };
        VmProvisioningNetworkMappingController.prototype.getLocalizedIpAllocationPolicy = function (policy) {
            switch (policy) {
                case IpAllocationPolicy.STATIC_MANUAL:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.staticManual");
                case IpAllocationPolicy.DHCP:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.dhcp");
                case IpAllocationPolicy.STATIC_IPPOOL:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.staticIpPool");
                case IpAllocationPolicy.TRANSIENT_IPPOOL:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.transientIpPool");
            }
        };
        VmProvisioningNetworkMappingController.prototype.getLocalizedIpProtocol = function (protocol) {
            switch (protocol) {
                case IpProtocol.IPV4:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.ipv4");
                case IpProtocol.IPV6:
                    return this.i18nService.getString("ProvisioningUiLib", "IpAllocationControl.ipv6");
            }
        };
        VmProvisioningNetworkMappingController.prototype.populateLocalizedNamesForIpAllocation = function () {
            var _this = this;
            this.ipAllocationParams.supportedIpAllocationPolicy = this.ipAllocationParams.supportedIpAllocationPolicy.map(function (o) {
                o.localizedName = _this.getLocalizedIpAllocationPolicy(o.name);
                return o;
            });
        };
        VmProvisioningNetworkMappingController.prototype.populateLocalizedNamesForIpProtocol = function () {
            var _this = this;
            this.ipAllocationParams.supportedIpProtocol = this.ipAllocationParams.supportedIpProtocol.map(function (o) {
                o.localizedName = _this.getLocalizedIpProtocol(o.name);
                return o;
            });
        };
        VmProvisioningNetworkMappingController.$inject = [
            "$scope",
            "i18nService",
            "vuiConstants"
        ];
        return VmProvisioningNetworkMappingController;
    }());
    h5_vm.VmProvisioningNetworkMappingController = VmProvisioningNetworkMappingController;
    var VmProvisioningNetworkMappingComponent = (function () {
        function VmProvisioningNetworkMappingComponent() {
            this.controller = VmProvisioningNetworkMappingController;
            this.templateUrl = 'vm-ui/resources/vm/views/createVmWizard/vmProvisioningNetworkMapping/vm-provisioning-network-mapping.html';
            this.bindings = {
                networkMappings: "=",
                ipAllocationParams: "=",
                isValidated: "="
            };
        }
        return VmProvisioningNetworkMappingComponent;
    }());
    h5_vm.VmProvisioningNetworkMappingComponent = VmProvisioningNetworkMappingComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmProvisioningNetworkMapping", new VmProvisioningNetworkMappingComponent());
})(h5_vm || (h5_vm = {}));



(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningNetworkPageController', VmProvisioningNetworkPageController);

   VmProvisioningNetworkPageController.$inject = [
      '$scope',
      '$q',
      'i18nService',
      'defaultUriSchemeUtil'
   ];

   function VmProvisioningNetworkPageController($scope) {
      var self = this;
      var model = $scope.networkPageModel;
      self.networkMappingParams = model.getNetworkMappingParams();
      self.ipAllocationParams = model.getIpAllocationParams();
   }
})();
(function () {
   'use strict';

   angular
   .module('com.vmware.vsphere.client.vm')
   .controller('VmProvisioningSelectCreationTypeController', [
      '$scope',
      'i18nService',
      'creationTypeConstants',
      'createVmChangeCreationTypeService',
      VmProvisioningSelectCreationTypeController
   ]);

   function VmProvisioningSelectCreationTypeController(
         $scope,
         i18nService,
         creationTypeConstants,
         createVmChangeCreationTypeService) {
      var self = this;
      var localizationMap = {};
      localizationMap[creationTypeConstants.CREATE_FROM_SCRATCH] = 'CreateFromScratch';
      localizationMap[creationTypeConstants.CLONE_VM_TO_VM] = 'CloneVmToVm';
      localizationMap[creationTypeConstants.CLONE_VM_TO_TEMPLATE] = 'CloneVmToTemplate';
      localizationMap[creationTypeConstants.DEPLOY_VM_FROM_ANY_TEMPLATE] = 'DeployFromTemplate';
      localizationMap[creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE] = 'DeployFromTemplate';
      localizationMap[creationTypeConstants.CONVERT_TEMPLATE_TO_VM] = 'ConvertTemplateToVm';
      localizationMap[creationTypeConstants.CLONE_TEMPLATE_TO_TEMPLATE] = 'CloneTemplateToTemplate';

      self.creationTypes = [];
      _.each($scope.config.flows, function(flow) {
         if(isSubFlow(flow)) {
            // skip workflows which are sub-workflows of other workflows different from
            // the main CREATE_FROM_SCRATCH workflow.
            // Such is the case with DEPLOY_VM_FROM_TEMPLATE and CONVERT_TEMPLATE_TO_VM
            // which are sub-workflows of the DEPLOY_VM_FROM_ANY_TEMPLATE flow and get
            // branched later in the `Select temaplte` page of the flow.
            return;
         }
         var localizationKey = flow.id;
         self.creationTypes.push({
            name:        i18nService.getString('VmUi', 'ProvisioningTypes.'+ localizationMap[localizationKey] +'.Title'),
            wizardTitle: i18nService.getString('VmUi', 'ProvisioningTypes.'+ localizationMap[localizationKey] +'.WizardTitle.1'),
            description: i18nService.getString('VmUi', 'ProvisioningTypes.'+ localizationMap[localizationKey] +'.Description'),
            creationType: flow.id
         });
      });

      if ($scope.attributes.creationType) {
         var flowToSelect = _.find($scope.config.flows, function(flow) {
            return flow.id === $scope.attributes.creationType;
         });
         var creationTypeToSelect = isSubFlow(flowToSelect) ?
               flowToSelect.parentWorkflow : flowToSelect.id;
         self.selectedCreationType = _.find(self.creationTypes, function (type) {
            return type.creationType === creationTypeToSelect;
         });
      } else {
         self.selectedCreationType = self.creationTypes[0];
      }

      $scope.$watch('ctrl.selectedCreationType', function(selectedCreationType, oldCreationType) {
         createVmChangeCreationTypeService.changeCreationType(
               $scope, selectedCreationType, oldCreationType);
      });

      /**
       * Retirns true if the flow has a parent workflow other than CREATE_FROM_SCRATCH.
       * Otherwise returns false.
       */
      function isSubFlow(flow) {
         return flow.parentWorkflow
               && flow.parentWorkflow !== creationTypeConstants.CREATE_FROM_SCRATCH;
      }
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningSelectTemplateController', VmProvisioningSelectTemplateController);

   VmProvisioningSelectTemplateController.$inject = [
      '$scope',
      '$element',
      '$timeout',
      'i18nService',
      'contentLibraryService',
      'createVmChangeCreationTypeService',
      'creationTypeConstants',
      'vuiConstants'
   ];

   function VmProvisioningSelectTemplateController(
         $scope, $element, $timeout, i18nService, contentLibraryService,
         createVmChangeCreationTypeService, creationTypeConstants, vuiConstants) {
      var self = this;
      var loadingMessage = i18nService.getString('CommonUi', 'wizard.loading');

      self.pageModel = $scope.selectAnyTemplateModel;
      self.pageModel.vcTemplatePageModel.showLoadingIndicator = false;

      self.clTemplateTabLabel = i18nService.getString('VmUi',
            'SelectTemplateProvisioningPage.clTemplateTab.label');
      self.vcTemplateTabLabel = i18nService.getString('VmUi',
            'SelectTemplateProvisioningPage.vcTemplateTab.label');
      self.isVcTabSelected = self.pageModel.getIsVcTemplateSelected();

      self.datagridOptions = {
         columnDefs: [
            {
               displayName: i18nService.getString('VmUi',
                     'SelectTemplateProvisioningPage.clTemplateTab.templateName.label'),
               field: 'templateName'
            },
            {
               displayName: i18nService.getString('VmUi',
                     'SelectTemplateProvisioningPage.clTemplateTab.libraryName.label'),
               field: 'libraryName'
            }
         ],
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: []
      };

      // focus the first tab on the page
      $timeout(function () {
         var firstTab = $element[0].querySelector("clr-tab-link");
         firstTab.querySelector("button").focus();
      }, 0);

      self.watchSelectedItems = function() {

      $scope.$watch(function() {
               return self.datagridOptions.selectedItems;
            },
            function(selectedItems) {
               var selectedItem = selectedItems && selectedItems.length ?
                     selectedItems[0] : undefined;
               self.pageModel.setClTemplateSelection(selectedItem);
               if (selectedItem) {
                  // If something was selected in the library template list then we need to
                  // clear the selection in the other tab and set the correct creation type
                  // so that the workflow path changes.
                  clearVcTemplateSelection();
                  changeCreationType(creationTypeConstants.DEPLOY_VM_FROM_TEMPLATE);
               }
            }
      );
      };

      $scope.clPreselectComparator = function(gridDataItem) {
         var itemToSelect = self.pageModel.getClTemplateSelection();
         if (itemToSelect) {
            return itemToSelect.templateId === gridDataItem.templateId;
         }
         return false;
      };

      self.onVcTemplateSelectionChanged = function() {
         if (self.pageModel.getVcTemplateSelection()) {
            // If something was selected in the vsphere tree view then we need to
            // clear the selection in the other tab and set the correct creation type
            // so that the workflow path changes.
            clearClTemplateSelection();
         }

         if (self.pageModel.getIsVcTemplateSelected()) {
            changeCreationType(creationTypeConstants.CLONE_TEMPLATE_TO_VM);
         }
      };

      var sourceObjectId = $scope.wizardViewData.getSourceObjectId();
      if ($scope.wizardViewData.defaultTarget) {
         sourceObjectId = $scope.wizardViewData.defaultTarget;
      }

      setLoadingIndicator(true);
      contentLibraryService.getAllTemplates(sourceObjectId).then(function(templateData) {
         var templateProperty, libraryProperty, gosTypeProperty, gosDescriptorProperty;
         var templateDataGridContent = _.map(templateData.libraryTemplates.resultSet[0].items, function(item) {
            templateProperty = _.find(item.properties, function(prop) {
               return (prop.propertyName === 'com.vmware.content.library.ItemModel/name');
            });
            libraryProperty = _.find(item.properties, function(prop) {
               return (prop.propertyName === 'com.vmware.content.library.ItemModel/libraryName');
            });
            gosTypeProperty = _.find(item.properties, function(prop) {
                return (prop.propertyName === 'com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osType');
            });
            gosDescriptorProperty = _.find(item.properties, function(prop) {
               return (prop.propertyName === 'com.vmware.content.type.ovf.OvfTemplate/vmTemplate/osDescription');
            });
            return {
               templateName: templateProperty.value,
               libraryName: libraryProperty.value,
               templateId: item.resourceObject,
               gosType: gosTypeProperty.value,
               gosDescription: gosDescriptorProperty.value
            };
         });
         self.datagridOptions.data = templateDataGridContent;
         // preselect
         var selection = self.pageModel.getClTemplateSelection();
         var selectedItem = selection && _.find(self.datagridOptions.data, function(item) {
            return (item.templateId === selection.templateId);
         });
         if (selectedItem) {
            self.datagridOptions.selectedItems = [selectedItem];
         }

      }).then(function() {
         setLoadingIndicator(false);
         self.watchSelectedItems();
      });

      function setLoadingIndicator(toggle) {
         $scope.config.loadingMessage = loadingMessage;
         $scope.config.loading = toggle;
      }

      function clearClTemplateSelection() {
         var grid = $element.find('.library-template-selector [kendo-grid]');
         if(grid && grid.data('kendoGrid')) {
            grid.data('kendoGrid').clearSelection();
         }
      }

      function clearVcTemplateSelection() {
         var tree = $element.find('[vx-tree-view]');
         tree.data("kendoTreeView").select($());
         // For some reason deselect does not trigger onChange() in the vc template
         // selector so we need to clear the model directly
         self.pageModel.getVcTemplatePageModel().clearSelection();
      }

      function changeCreationType(selectedCreationType) {
         createVmChangeCreationTypeService.changeCreationType(
               $scope, {
                  creationType: selectedCreationType,
                  wizardTitle: i18nService.getString('VmUi',
                        'ProvisioningTypes.DeployFromTemplate.WizardTitle.1')
               });
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

/**
 * The select VM name and folder page controller.
 */
(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningSelectVmToCloneController', VmProvisioningSelectVmToCloneController);

   VmProvisioningSelectVmToCloneController.$inject = [
      '$scope',
      'i18nService',
      'defaultUriSchemeUtil',
      'managedEntityConstants'
   ];

   function VmProvisioningSelectVmToCloneController($scope, i18nService, defaultUriSchemeUtil, managedEntityConstants) {
      var self = this;

      this.treeDescription = i18nService.getString('VmUi', 'SelectTemplateProvisioningPage.Vm.Description');

      this.onChange = function (objectId, text, nodeTypeId) {
         $scope.wizardManager.clearValidationBanner();
         setVmId(objectId);
         $scope.wizardViewData.setSourceObjectName(text);

         setLoadingIndicator(true);
         $scope.config.loadingMessage = i18nService.getString('CommonUi', 'wizard.validating');

         $scope.selectVmToClonePageModel.validateSelection().then(function (compatibilityMessage) {
            self.compatibilityMessage = compatibilityMessage;
            setLoadingIndicator(false);
         });
      };

      this.selectedItem = $scope.vmParams.getVmId();

      this.treeConfig = {
         preselectRoot: false,
         expandPreselectedNode: true
      };

      function setLoadingIndicator(setting) {
         $scope.config.loading = setting;
      }

      function setVmId(vmId) {
         if (defaultUriSchemeUtil.getEntityType(vmId)
               !== managedEntityConstants.VIRTUAL_MACHINE) {
            $scope.vmParams.setVmId(undefined);
            return;
         }

         $scope.vmParams.setVmId(vmId);
      }
   }

})();

var h5_vm;
(function (h5_vm) {
    var VmProvisioningSelectVMTXTemplateController = (function () {
        function VmProvisioningSelectVMTXTemplateController($timeout, $element) {
            this.$timeout = $timeout;
            this.$element = $element;
            $timeout(function () {
                var tree = $element[0].querySelector("[vx-tree-view]");
                if (tree) {
                    tree.focus();
                }
            }, 0);
        }
        VmProvisioningSelectVMTXTemplateController.$inject = ["$timeout", "$element"];
        return VmProvisioningSelectVMTXTemplateController;
    }());
    h5_vm.VmProvisioningSelectVMTXTemplateController = VmProvisioningSelectVMTXTemplateController;
    angular.module("com.vmware.vsphere.client.vm")
        .controller("VmProvisioningSelectVMTXTemplateController", VmProvisioningSelectVMTXTemplateController);
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmProvisioningUserSettingsController', VmProvisioningUserSettingsController);

   VmProvisioningUserSettingsController.$inject = ['$scope', '$element', '$timeout', 'ipParserService', 'i18nService',
   'nicValidatorService'];

   function VmProvisioningUserSettingsController($scope, $element, $timeout, ipParserService, i18nService,
         nicValidatorService) {
      $scope.userSettingsPageModel.resetForm();
      $timeout(function() {
         var firstInput = $element[0].querySelector('input');
         if (firstInput) {
            firstInput.focus();
         }
      }, 0);
      this.form = $scope.userSettingsPageModel.form;

      this.validateComputerName = $scope.userSettingsPageModel.validateComputerName;

      this.validateIpAddress = function(nic) {
         nic.errors.addressInvalid = nicValidatorService.isIpAddressInvalid(nic);
      };
      this.validateSubnet = function(nic) {
         nic.errors.subnetMaskInvalid = nicValidatorService.isSubnetMaskInvalid(nic);
      };

      this.validateDefaultGateway = function(nic) {
         nic.errors.defaultGatewayInvalid = nicValidatorService.isDefaultGatewayInvalid(nic);
      };
      this.validateAlternateGateway = function(nic) {
         nic.errors.alternateGatewayInvalid = nicValidatorService.isAlternateGatewayInvalid(nic);
      };

      this.validateIp6Address = function(nic) {
         nic.errors.addressInvalid = nicValidatorService.isIp6AddressInvalid(nic);
      };
      this.validateIp6Subnet = function(nic) {
         nic.errors.subnetPrefixLengthInvalid = nicValidatorService.isIp6SubnetInvalid(nic);
      };

      this.addGateway = function(nic) {
         this.validateGateway(nic.lastGateway, nic);
         if (!nic.lastGateway || nic.gatewayInvalid) {
            return;
         }

         nic.gateway.push(nic.lastGateway);
         nic.gridGatewaysOptions.data = nic.gateway;

         nic.lastGateway = "";
      };

      this.validateGateway = function(gateway, nic) {
         if (!gateway) {
            nic.gatewayInvalid = null;
            return;
         }
         var isValid = ipParserService.isIpv6AddressValid(gateway);
         var isDuplicate = _.any(nic.gateway, function(currentGateway) {
            return currentGateway === gateway;
         });

         if (!isValid) {
            nic.gatewayInvalid =
                  i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.error.ipv6.address");
         }

         if (isDuplicate) {
            nic.gatewayInvalid =
                  i18nService.getString("VmUi", "CustomizationParametersPageBase.nic.error.ipv6.duplicate", gateway);
         }

         if (isValid && !isDuplicate) {
            nic.gatewayInvalid = null;
         }
      };

      this.expandedChanged = function(expanded, nic) {
         nic.expanded = expanded;
         $scope.userSettingsPageModel.hasAlerts(nic);
      };

      this.shouldExpand = function(index) {
         if (index === 0 && this.form.nics && this.form.nics.length === 1) {
            return true;
         }

         return false;
      };

      this.tooltipRole = function(hasTooltip) {
         return hasTooltip ? 'tooltip' : '';
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmProvisioningVmVersionController', VmProvisioningVmVersionController);

   VmProvisioningVmVersionController.$inject = ['$scope', 'i18nService',
         'wizardPageService', '$filter',
         'helpService'];

   function VmProvisioningVmVersionController($scope, i18nService,
            wizardPageService, $filter, helpService) {
      this.i18n = i18nService.getString;
      this.model = $scope.selectVmVersionPageModel;
      this.form = this.model.form;
      this.form.vmParams = $scope.vmParams;
      var compatibilityLoading;
      this.form.setLoading = function(isLoading) {
         // We only want to set the loading to false if we initially set it to true
         if (!$scope.config.loading && isLoading) {
            compatibilityLoading = true;
            $scope.config.loading = true;
         } else if (compatibilityLoading && !isLoading) {
            $scope.config.loading = false;
            compatibilityLoading = false;
         }
      };

      this.checkCompatibility = function(vmVersion) {
         this.form.compatibility(vmVersion);
      }.bind(this);

      $scope.config.loadingMessage =  i18nService.getString('CommonUi', 'wizard.loading');
      $scope.config.loading = true;
      this.model.resetForm().catch(function(reason) {
         wizardPageService.markPageIncompleteWithError(
               $scope.config, $filter('errorFormat')(reason));
      }).then(function () {
         $scope.config.loading = false;
      });
   }
})();

var h5_vm;
(function (h5_vm) {
    var FtErrorsWarningController = (function () {
        function FtErrorsWarningController($scope, vuiConstants, i18nService, columnRenderersRegistry, ftVmWizardService, ftVmService) {
            var _this = this;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.ftVmWizardService = ftVmWizardService;
            this.ftVmService = ftVmService;
            var dialogData = $scope.modalOptions.dialogData;
            this.objectId = dialogData.objectId;
            this.faultDefaultDescriptionText = dialogData.errorText;
            this.iconTextRenderer = this.columnRenderersRegistry.getColumnRenderer('icon-text');
            this.gridOptions = this.ftVmService.getErrorPageGridOptions(dialogData.allIssuesArray);
            $scope.modalOptions.onSubmit = function () {
                _this.ftVmWizardService.invokeWizard(_this.objectId, dialogData.manager);
                return true;
            };
        }
        FtErrorsWarningController.$inject = [
            "$scope",
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry",
            "ftVmWizardService",
            "ftVmService"
        ];
        return FtErrorsWarningController;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .controller('FtErrorsWarningController', FtErrorsWarningController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtReadyToCompleteController = (function () {
        function FtReadyToCompleteController($rootScope, $scope, i18nService, ftVmService, mutationService, defaultUriSchemeUtil, vxPropertyViewService, vmFtConstants) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.ftVmService = ftVmService;
            this.mutationService = mutationService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vxPropertyViewService = vxPropertyViewService;
            this.vmFtConstants = vmFtConstants;
            this.selectedDatastore = $scope.manager.getSelectedDatastore();
            this.selectedHost = $scope.manager.getSelectedHost();
            var devices = this.$scope.manager.getDevices();
            this.availableDevices = this.ftVmService.getAvailableDevices(devices);
            this.selectedDatastores = $scope.manager.getSelectedDatastores();
            this.readyToCompletePageInfo = this.getPropertyViewData();
        }
        FtReadyToCompleteController.prototype.getPropertyViewData = function () {
            var _this = this;
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var sectionBuilder = builder
                .category("")
                .section("");
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("VmUi", "turnOnFtWizard.summary.hostLabel"))
                .exit()
                .valueBuilder()
                .text(this.selectedHost.name);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("VmUi", "turnOnFtWizard.summary.vmxFileDatastoreLabel"))
                .exit()
                .valueBuilder()
                .text(this.selectedDatastores[this.vmFtConstants.fileTypes.CONFIGURATION].name);
            sectionBuilder.propertyBuilder()
                .keyBuilder()
                .text(this.i18nService.getString("VmUi", "turnOnFtWizard.summary.metainfDatastoreLabel"))
                .exit()
                .valueBuilder()
                .text(this.selectedDatastores[this.vmFtConstants.fileTypes.TIE_BREAKER].name);
            _.each(this.availableDevices, function (device) {
                sectionBuilder.propertyBuilder()
                    .keyBuilder()
                    .text(_this.i18nService.getString("VmUi", "turnOnFtWizard.summary.virtualDisksFormat", device.deviceInfo.label))
                    .exit()
                    .valueBuilder()
                    .text(_this.selectedDatastores[_this.vmFtConstants.fileTypes.VIRTUAL_DISK + device.key].name);
            });
            return builder.build();
        };
        FtReadyToCompleteController.$inject = [
            "$rootScope",
            "$scope",
            "i18nService",
            "ftVmService",
            "mutationService",
            "defaultUriSchemeUtil",
            "vxPropertyViewService",
            "vmFtConstants"
        ];
        return FtReadyToCompleteController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("FtReadyToCompleteController", FtReadyToCompleteController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtSelectDatastoresController = (function () {
        function FtSelectDatastoresController($scope, vuiConstants, i18nService, columnRenderersRegistry, ftVmService, dataService, defaultUriSchemeUtil, storageSelectorService, diskFormatService, clarityModalService, clarityConstants, vmFtConstants) {
            var _this = this;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            this.columnRenderersRegistry = columnRenderersRegistry;
            this.ftVmService = ftVmService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageSelectorService = storageSelectorService;
            this.diskFormatService = diskFormatService;
            this.clarityModalService = clarityModalService;
            this.clarityConstants = clarityConstants;
            this.vmFtConstants = vmFtConstants;
            this.selectedStorageItems = {};
            this.managerSelectedStorageItems = {};
            this.managerBasicSelectedStorageItems = {};
            this.selectedStorageItemsNames = {};
            this.allStorageItems = {};
            this.manager = $scope.manager;
            this.selectedVm = this.manager.getTargetUid();
            this.storageSelectorState = this.vmFtConstants.storageSelectionModes.BASIC_MODE;
            var devices = this.$scope.manager.getDevices();
            this.availableDevices = this.ftVmService.getAvailableDevices(devices);
            this.gridOptions = this.ftVmService.getSelectDatastoreGridOptions(this.manager.getConfigCompatibleDatastores());
            this.hasAvailableHosts = false;
            this.hasSelectedDatastore = false;
            this.advancedGridOptions = this.ftVmService.getAdvancedDatastoreGridOptions();
            _.each(this.manager.getCompatibleDatastores(), function (datastore) {
                _this.selectedStorageItemsNames[datastore.provider.value] = datastore.name;
            });
            this.dataService.getData(this.selectedVm, "com.vmware.vsphere.client.vm.model.VmFtAdvancedStorageData")
                .then(function (data) {
                _this.initialData = data.vmDisks;
                _this.advancedGridOptions.data = _this.buildRowsData(_this.initialData);
                _this.manager.setNumberOfVmFiles(_this.initialData.length);
            });
            $scope.$watch(function () { return _this.gridOptions.selectedItems[0]; }, function (newSelectedItem) {
                if (newSelectedItem) {
                    _this.hasSelectedDatastore = true;
                    _this.compatibilityResultMessagesMap = {};
                    _this.manager.setNoHostsCompatible(false);
                    _this.hasAvailableHosts = true;
                    _this.validateDatastoreSelection(newSelectedItem);
                }
                else {
                    _this.hasSelectedDatastore = false;
                }
            });
            $scope.basicModeComparator = this.basicModeComparator.bind(this);
            this.manager.setIsAdvancedMode(false);
        }
        FtSelectDatastoresController.prototype.basicModeComparator = function (dataItem) {
            return this.manager.getSelectedDatastore() && dataItem.provider.value ===
                this.manager.getSelectedDatastore().provider.value;
        };
        // adds functions to the row, that can be called on ng-click and ng-change from the template
        FtSelectDatastoresController.prototype.buildRowsData = function (vmDisks) {
            var _this = this;
            var data = [];
            var rowFunctions = {
                onDatastoreComboClick: function (event, dataItem) {
                    if (event.target.value !== "") {
                        return;
                    }
                    if (event && event.target && event.target.blur) {
                        // hide the dropdown's pop-up
                        event.target.blur();
                    }
                    dataItem.onDatastoreChange(dataItem);
                },
                onDatastoreChange: function (dataItem) {
                    if (!dataItem.storageItemId) {
                        _this.showDatastoreSelector(dataItem);
                    }
                    else {
                        _this.selectedStorageItems[dataItem.id] = dataItem.storageItemId;
                        _.each(_this.selectedStorageItems, function (storageItem, index) {
                            _this.managerSelectedStorageItems[index] = {
                                provider: storageItem,
                                name: _this.selectedStorageItemsNames[storageItem.value]
                            };
                        });
                        _this.manager.setSelectedDatastores(_this.managerSelectedStorageItems);
                        if (_this.manager.validateSelectedDatastores()) {
                            _this.hasSelectedDatastore = true;
                            _this.validateDatastoreSelection(null, true);
                        }
                    }
                }
            };
            _.each(vmDisks, function (vmDisk) {
                angular.extend(vmDisk, rowFunctions);
                if (_this.selectedStorageItems[vmDisk.id]) {
                    angular.extend(vmDisk, {
                        storageItems: _this.updateStorageItems(vmDisk.id),
                        storageItemId: _this.selectedStorageItems[vmDisk.id]
                    });
                }
                data.push(vmDisk);
            });
            return data;
        };
        // opens a modal with datastores for advanced selection per file
        FtSelectDatastoresController.prototype.showDatastoreSelector = function (dataItem) {
            var _this = this;
            var datastores;
            if (dataItem.itemType === this.vmFtConstants.fileTypes.TIE_BREAKER) {
                datastores = this.manager.getMetaCompatibleDatastores();
            }
            else if (dataItem.itemType === this.vmFtConstants.fileTypes.CONFIGURATION) {
                datastores = this.manager.getConfigCompatibleDatastores();
            }
            else {
                datastores = this.manager.getCompatibleDatastores();
            }
            var modalOptions = {
                contentTemplate: "vm-ui/resources/vm/views/ft/ftStorageSelectorDialog.html",
                title: this.i18nService.getString("Common", "StorageLocatorDialog.Title"),
                defaultButton: "submit",
                size: "lg",
                dialogData: {
                    datastores: datastores,
                    isDatastoreSelected: false,
                    selectedDatastore: {}
                },
                modalClass: "ft-advanced-datastore-selection-wizard",
                alerts: [],
                onSubmit: function () {
                    if (!modalOptions.dialogData.isDatastoreSelected) {
                        modalOptions.alerts = [{
                                text: _this.i18nService.getString("Common", "storageSelector.incompleteSelection"),
                                type: _this.clarityConstants.notifications.type.ERROR
                            }];
                        return false;
                    }
                    _this.updateSelectedDatastore(dataItem, modalOptions.dialogData.selectedDatastore);
                    return true;
                },
                onCancel: function () {
                    dataItem.storageItemId = _this.selectedStorageItems[dataItem.id];
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        //adds storage items to dropdown in advanced storage selection and browse at the end
        FtSelectDatastoresController.prototype.updateStorageItems = function (id) {
            var _this = this;
            var items = [];
            _.forEach(this.allStorageItems[id], function (recentItem) { return _this.addStorageItemOptionToList(items, _this.buildStorageItemOption(recentItem)); });
            items = _.sortBy(items, "label");
            items.push({
                id: "",
                label: this.i18nService.getString("Common", "DiskLocatorControl.Browse")
            });
            return items;
        };
        FtSelectDatastoresController.prototype.addStorageItemOptionToList = function (items, itemToAdd) {
            if (!_.find(items, function (item) { return item.id === itemToAdd.id; })) {
                items.push(itemToAdd);
            }
        };
        FtSelectDatastoresController.prototype.buildStorageItemOption = function (storageObj) {
            return {
                id: storageObj.provider,
                label: storageObj.name
            };
        };
        FtSelectDatastoresController.prototype.updateSelectedDatastore = function (dataItem, datastore) {
            var _this = this;
            this.selectedStorageItems[dataItem.id] = datastore.provider;
            _.each(this.selectedStorageItems, function (storageItem, index) {
                _this.managerSelectedStorageItems[index] = {
                    provider: storageItem,
                    name: _this.selectedStorageItemsNames[storageItem.value]
                };
            });
            this.manager.setSelectedDatastores(this.managerSelectedStorageItems);
            if (this.manager.validateSelectedDatastores()) {
                this.hasSelectedDatastore = true;
                this.validateDatastoreSelection(null, true);
            }
            if (!this.allStorageItems[dataItem.id]) {
                this.allStorageItems[dataItem.id] = [];
            }
            if (!_.find(this.allStorageItems[dataItem.id], function (item) { return item.provider === datastore.provider; })) {
                this.allStorageItems[dataItem.id].push(datastore);
            }
            this.advancedGridOptions.data = this.buildRowsData(this.initialData);
        };
        FtSelectDatastoresController.prototype.validateDatastoreSelection = function (newSelectedItem, isAdvancedMode) {
            var _this = this;
            if (isAdvancedMode === void 0) { isAdvancedMode = false; }
            if (!isAdvancedMode) {
                if (newSelectedItem && newSelectedItem !== null) {
                    if (this.initialData && this.initialData.length > 0) {
                        _.each(this.initialData, function (file) {
                            _this.managerBasicSelectedStorageItems[file.id] = newSelectedItem;
                        });
                        this.manager.setSelectedDatastores(this.managerBasicSelectedStorageItems);
                    }
                    this.manager.setSelectedDatastore(newSelectedItem);
                    this.validateSelection();
                }
            }
            else {
                this.validateSelection();
            }
        };
        FtSelectDatastoresController.prototype.validateSelection = function () {
            var _this = this;
            this.getCompatibleHosts().then(function (response) {
                _this.compatibleHosts = response.ftCompatibleHosts;
                var compatibleHostsIds = _this.ftVmService.getFtHostsIds(_this.compatibleHosts);
                _this.getHostNames(compatibleHostsIds).then(function (response) {
                    _this.compatibilityResultMessagesMap =
                        _this.ftVmService.getCompatibilityResultMessages(_this.compatibleHosts);
                    _.each(response, function (item, key) {
                        var currentItem = _this.compatibilityResultMessagesMap[key];
                        _.extend(currentItem, {
                            name: item.name
                        });
                    });
                    _this.hasAvailableHosts =
                        _this.ftVmService.hasFtHostWithoutErrors(_this.compatibleHosts);
                    _this.manager.setNoHostsCompatible(!_this.hasAvailableHosts);
                });
            });
        };
        FtSelectDatastoresController.prototype.getHostNames = function (hostIds) {
            return this.dataService.getPropertiesForObjects(hostIds, ["name"]);
        };
        FtSelectDatastoresController.prototype.getCompatibleHosts = function () {
            return this.dataService.getProperties(this.selectedVm, ["ftCompatibleHosts"], this.ftVmService.createSecondaryVmSpecParameter(this.manager, this.availableDevices));
        };
        /**
         * Switches between basic and advanced mode.
         */
        FtSelectDatastoresController.prototype.toggleSelectionMode = function () {
            switch (this.storageSelectorState) {
                case this.vmFtConstants.storageSelectionModes.BASIC_MODE:
                    this.storageSelectorState =
                        this.vmFtConstants.storageSelectionModes.ADVANCED_MODE;
                    break;
                case this.vmFtConstants.storageSelectionModes.ADVANCED_MODE:
                    this.storageSelectorState =
                        this.vmFtConstants.storageSelectionModes.BASIC_MODE;
                    break;
            }
            this.onSelectionModeChanged();
        };
        FtSelectDatastoresController.prototype.onSelectionModeChanged = function () {
            this.hasSelectedDatastore = false;
            switch (this.storageSelectorState) {
                case this.vmFtConstants.storageSelectionModes.BASIC_MODE:
                    this.manager.setIsAdvancedMode(false);
                    if (this.manager.getSelectedDatastore()) {
                        this.hasSelectedDatastore = true;
                    }
                    break;
                case this.vmFtConstants.storageSelectionModes.ADVANCED_MODE:
                    this.manager.setIsAdvancedMode(true);
                    this.manager.setSelectedDatastores(this.managerSelectedStorageItems);
                    if (this.manager.validateSelectedDatastores()) {
                        this.hasSelectedDatastore = true;
                        this.validateDatastoreSelection(null, true);
                    }
                    break;
            }
            this.hasAvailableHosts = true;
            this.compatibilityResultMessagesMap = null;
        };
        FtSelectDatastoresController.$inject = [
            "$scope",
            "vuiConstants",
            "i18nService",
            "columnRenderersRegistry",
            "ftVmService",
            "dataService",
            "defaultUriSchemeUtil",
            "storageSelectorService",
            "diskFormatService",
            "clarityModalService",
            "clarityConstants",
            "vmFtConstants"
        ];
        return FtSelectDatastoresController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("FtSelectDatastoresController", FtSelectDatastoresController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtSelectHostController = (function () {
        function FtSelectHostController($scope, storageSelectorService, dataService, defaultUriSchemeUtil, $rootScope, ftVmService, i18nService) {
            this.$scope = $scope;
            this.storageSelectorService = storageSelectorService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.$rootScope = $rootScope;
            this.ftVmService = ftVmService;
            this.i18nService = i18nService;
            this.loading = true;
            this.showAllHosts = false;
        }
        FtSelectHostController.prototype.$onInit = function () {
            var _this = this;
            this.selectedVm = this.$scope.manager.getTargetUid();
            this.selectedDatastore = this.$scope.manager.getSelectedDatastore();
            var devices = this.$scope.manager.getDevices();
            this.availableDevices = this.ftVmService.getAvailableDevices(devices);
            this.showAllHosts = false;
            this.getCompatibleHosts().then(function (data) {
                _this.compatibleHosts = data.ftCompatibleHosts;
                _this.compatbileHostsMap = _this.ftVmService.convertCompatibleHostsIntoMap(_this.compatibleHosts);
                _this.messages = [];
                _this.loading = false;
                _this.objectSelectorConfigCompatibleHosts = _this.generateObjectLocator(true);
                _this.objectSelectorConfigAllHosts = _this.generateObjectLocator(false);
                _this.$scope.manager.setSelectedHost(null);
            });
        };
        FtSelectHostController.prototype.getCompatibleHosts = function () {
            return this.dataService.getProperties(this.selectedVm, ["ftCompatibleHosts"], this.ftVmService.createSecondaryVmSpecParameter(this.$scope.manager, this.availableDevices));
        };
        FtSelectHostController.prototype.showAllHostsAction = function () {
            this.messages = [];
            this.showAllHosts = !this.showAllHosts;
        };
        FtSelectHostController.prototype.generateObjectLocator = function (showCompatibleHosts) {
            var _this = this;
            var hosts = this.compatibleHosts;
            if (showCompatibleHosts) {
                hosts = _.filter(hosts, function (ftHost) {
                    return ftHost.errors === null;
                });
            }
            var hostsRefs = _.map(hosts, function (host) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(host.ftHost);
            });
            var datacenter = this.$scope.manager.getDatacenter();
            var target = this.defaultUriSchemeUtil.getVsphereObjectId(datacenter);
            this.loading = false;
            return {
                contextObject: target,
                multipleSelect: false,
                listTabConfig: {
                    listConfig: [{
                            label: "",
                            listViewId: "vsphere.core.host.list",
                            dataModels: ["HostSystem"],
                            filterId: "hostsInDatacenterByMorObjectsFilter",
                            filterParams: hostsRefs
                        }]
                },
                onSelectionChanged: function (newSelectedItems) {
                    var selectedHost = newSelectedItems[0];
                    var faultToleranceData = _this.compatbileHostsMap[selectedHost.id];
                    _this.$scope.manager.setSelectedHost(_.extend(selectedHost, faultToleranceData));
                    _this.messages =
                        _this.ftVmService.generateValidationMessages(selectedHost, _this.compatbileHostsMap);
                    if (_this.messages.length === 0) {
                        _this.messages = [{
                                type: "Success",
                                text: _this.i18nService.getString('VmUi', 'turnOnFtWizard.compatibilityChecksSucceeded')
                            }];
                    }
                }
            };
        };
        FtSelectHostController.$inject = [
            "$scope",
            "storageSelectorService",
            "dataService",
            "defaultUriSchemeUtil",
            "$rootScope",
            "ftVmService",
            "i18nService"
        ];
        return FtSelectHostController;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .controller('FtSelectHostController', FtSelectHostController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var FtStorageSelectorDialogController = (function () {
        function FtStorageSelectorDialogController($scope, ftVmService) {
            var _this = this;
            this.$scope = $scope;
            this.ftVmService = ftVmService;
            this.gridOptions = this.ftVmService.getSelectDatastoreGridOptions($scope.modalOptions.dialogData.datastores);
            $scope.$watch("ctrl.gridOptions.selectedItems", function (newSelection) {
                if (newSelection[0] && newSelection[0] !== null) {
                    _this.$scope.modalOptions.dialogData.isDatastoreSelected = true;
                    _this.$scope.modalOptions.dialogData.selectedDatastore = newSelection[0];
                }
                else {
                    _this.$scope.modalOptions.dialogData.isDatastoreSelected = false;
                }
            });
        }
        FtStorageSelectorDialogController.$inject = [
            "$scope",
            "ftVmService"
        ];
        return FtStorageSelectorDialogController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("FtStorageSelectorDialogController", FtStorageSelectorDialogController);
})(h5_vm || (h5_vm = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
      .component('migrateSelectNetworkAdvancedView', {
         templateUrl: 'vm-ui/resources/vm/views/migrationWizard/components/migrateSelectNetworkAdvancedView.html',
         controller: MigrateSelectNetworkAdvancedViewController,
         controllerAs: 'ctrl',
         bindings: {
            data: '<',
            migrateSelectNetworkService: '<',
            prefetchedNetworks : '<'
         }
      });

   MigrateSelectNetworkAdvancedViewController.$inject = [
      'i18nService',
      'defaultUriSchemeUtil',
      'vuiConstants',
      'NetworkSelectorMode',
      'networkSelectorDialogService',
      'NetworkPageViewModes'
   ];

   function MigrateSelectNetworkAdvancedViewController(
      i18nService,
      defaultUriSchemeUtil,
      vuiConstants,
      NetworkSelectorMode,
      networkSelectorDialogService,
      NetworkPageViewModes
   ) {

      var self = this;
      init();

      function init() {
         self.gridOptions = getGridOptions();
         initNetworkSelector();
      }

      function getGridOptions () {
         return {
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            searchable: false,
            resizable: true,
            data: self.data,
            columnDefs: getColumnDefs(),
            encoded: false,
            selectedItems: [],
            pageConfig: {
               hidePager: true
            }
         };
      }



      function getColumnDefs() {
         return [
            {
               displayName: i18nService.getString('Common', 'vns.vm'),
               field: 'vmName',
               type: 'string',
               sortable: true
            },
            {
               displayName: i18nService.getString('Common', 'vns.networkAdapter'),
               field: 'sourceAdapterLabel',
               type: 'string',
               sortable: true
            },
            {
               displayName: i18nService.getString('Common', 'vns.basic.source'),
               field: 'sourceNetworkName',
               type: 'string',
               sortable: true
            },
            {
               displayName: i18nService.getString('Common', 'vns.basic.destination'),
               field: 'destinationNetworkName',
               sortable: false,
               template: getNetworkSelector
            }
         ];
      }

      function getNetworkSelector(data) {
         return '<div network-selector ' +
               'object-ref="$parent.$parent.ctrl.networkProviderId" '+
               'mode="$parent.$parent.ctrl.networkSelectorMode" '+
               'filter-spec="$parent.$parent.ctrl.networkSelectorFilterSpec" '+
               'dialog-spec="$parent.$parent.ctrl.networkSelectorDialogSpec" '+
               'preselected-network="$parent.$parent.ctrl.destinationNetworks['+ data.index +']" '+
               'prefetched-networks="$parent.$parent.ctrl.prefetchedNetworks" '+
               'on-selected-networks="$parent.$parent.ctrl.onSelectNetworks(selectedNetworks,' + data.index + ')" ' +
               'sort-params="$parent.$parent.ctrl.sortParams">'+
               '</div>';
      }

      function buildDestinationNetworks() {
         self.destinationNetworks = _.map(self.migrateSelectNetworkService.getAdvancedNetworkMatches(), function (networkItem) {
            return {
               id: defaultUriSchemeUtil.getVsphereObjectId(networkItem.destinationNetwork),
               name: networkItem.destinationNetworkName,
               opaqueNetworkType: networkItem.opaqueNetworkType
            };
         });
      }

      function initNetworkSelector() {
         self.networkProviderId = self.migrateSelectNetworkService.getNetworkProviderId();
         self.networkSelectorMode = NetworkSelectorMode.SINGLE_SELECTION_DROPDOWN;
         self.networkSelectorFilterSpec =
               networkSelectorDialogService.createNetworkSelectorFilterSpec(
                     true/*includeStandardNetworks*/,
                     true/*includeOpaqueNetworks*/,
                     true/*includeDistributedPortGroups*/,
                     false/*includeUplinkPortGroups*/,
                     true/*includeOpaqueNetworkTypes*/);
         self.sortParams = [{field:"name", dir:"asc"}];
         buildDestinationNetworks();

         self.networkSelectorDialogSpec =
               networkSelectorDialogService.createNetworkSelectorDialogSpec(
                     ['Network.Assign'],
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.conTargetPage.noDvpgPrivilegeMessage')
               );
         self.onSelectNetworks = function(selectedNetworks, rowIndex) {
            self.migrateSelectNetworkService.onSelectNetwork(selectedNetworks[0],
                  self.data[rowIndex], NetworkPageViewModes.ADVANCED);

            buildDestinationNetworks();
         };

      }
   }
}());

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
      .component('migrateSelectNetworkBasicView', {
         templateUrl: 'vm-ui/resources/vm/views/migrationWizard/components/migrateSelectNetworkBasicView.html',
         controller: MigrateSelectNetworkBasicViewController,
         controllerAs: 'ctrl',
         bindings: {
            data: '<',
            migrateSelectNetworkService: '<',
            prefetchedNetworks : '<'
         }
      });

   MigrateSelectNetworkBasicViewController.$inject = [
      'i18nService',
      'defaultUriSchemeUtil',
      'vuiConstants',
      'NetworkSelectorMode',
      'networkSelectorDialogService',
      '$scope',
      'NetworkPageViewModes'
   ];

   function MigrateSelectNetworkBasicViewController(
      i18nService,
      defaultUriSchemeUtil,
      vuiConstants,
      NetworkSelectorMode,
      networkSelectorDialogService,
      $scope,
      NetworkPageViewModes) {

      var self = this;
      init();

      function init () {
         self.i18n = i18nService.getString;

         self.gridOptions = getGridOptions();
         self.detailsGridOptions = getDetailsGridOptions();
         initNetworkSelector();
         $scope.$watch(function() {
            if(self.gridOptions) {
               return self.gridOptions.selectedItems;
            }
         }, function(newValue, oldValue) {
            if (!newValue || !newValue.length) {
               self.detailsGridOptions.data = [];
            } else if (!oldValue || !oldValue.length || newValue[0] !== oldValue[0]) {
               var selectedRow = newValue[0];
               var rows = _.map(selectedRow.adapterMatches, function(match) {
                  var sourceVmId = defaultUriSchemeUtil.getVsphereObjectId(match.sourceVm);
                  return {
                     vm: selectedRow._attachedVmNamesById[sourceVmId],
                     sourceAdapter: match.sourceAdapter.deviceInfo.label,
                     networkName: selectedRow.networkName
                  };
               });
               var networkLabel = selectedRow.networkName;
               if (!networkLabel) {
                  networkLabel = self.i18n(
                        'VmUi', 'MigrationWizard.readyPage.invalidNetworkName');
               }
               self.selectNetworkDetailsGridDescription = self.i18n(
                     'Common', 'vns.networkDetails.header', networkLabel);
               self.detailsGridOptions.data = rows;
            }
         });
      }

      function getGridOptions () {
         return {
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            searchable: false,
            resizable: true,
            data: self.data,
            columnDefs: getColumnDefs(),
            encoded: false,
            selectedItems: [],
            pageConfig: {
               hidePager: true
            }
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: self.i18n('Common', 'vns.basic.source'),
               field: 'networkName',
               type: 'string',
               sortable: true
            },
            {
               displayName: self.i18n('Common', 'vns.usedBy'),
               field: '_usedBy',
               type: 'string',
               sortable: true,
               template: function(item) {
                  return _.escape(item.usedBy());
               },
               width:'40%'
            },
            {
               displayName: self.i18n('Common', 'vns.basic.destination'),
               field: 'destinationNetworkName',
               encoded: false,
               template: getNetworkSelector
            }
         ];
      }

      function getNetworkSelector(data) {
         return '<div network-selector ' +
               'object-ref="$parent.$parent.ctrl.networkProviderId" '+
               'mode="$parent.$parent.ctrl.networkSelectorMode" '+
               'filter-spec="$parent.$parent.ctrl.networkSelectorFilterSpec" '+
               'dialog-spec="$parent.$parent.ctrl.networkSelectorDialogSpec" '+
               'preselected-network="$parent.$parent.ctrl.destinationNetworks['+ data.index +']" '+
               'prefetched-networks="$parent.$parent.ctrl.prefetchedNetworks" '+
               'on-selected-networks="$parent.$parent.ctrl.onSelectNetworks(selectedNetworks,' + data.index + ')" ' +
               'sort-params="$parent.$parent.ctrl.sortParams">'+
               '</div>';
      }

      function getDetailsGridOptions() {
         return {
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            searchable: false,
            resizable: true,
            data: [],
            columnDefs: getDetailsColumnDefs(),
            pageConfig: {
               hidePager: true
            }
         };
      }

      function getDetailsColumnDefs() {
         return [
            {
               displayName: self.i18n('Common', 'vns.vm'),
               field: 'vm',
               type: 'string',
               sortable: true,
               width:'40%'
            }, {
               displayName: self.i18n('Common', 'vns.networkAdapter'),
               field: 'sourceAdapter',
               type: 'string'
            }, {
               displayName: self.i18n('Common', 'vns.network'),
               field: 'networkName',
               type: 'string',
               sortable: true
            }
         ];
      }

      function buildDestinationNetworks() {
         self.destinationNetworks = _.map(
               self.data,
               function (networkItem) {
                  return {
                     id: defaultUriSchemeUtil.getVsphereObjectId(
                           networkItem.destinationNetworkRef),
                     name: networkItem.destinationNetworkName,
                     opaqueNetworkType: networkItem.opaqueNetworkType
                  };
               });
      }

      function initNetworkSelector() {
         self.networkProviderId = self.migrateSelectNetworkService.getNetworkProviderId();
         self.networkSelectorMode = NetworkSelectorMode.SINGLE_SELECTION_DROPDOWN;
         self.networkSelectorFilterSpec =
               networkSelectorDialogService.createNetworkSelectorFilterSpec(
                     true/*includeStandardNetworks*/,
                     true/*includeOpaqueNetworks*/,
                     true/*includeDistributedPortGroups*/,
                     false/*includeUplinkPortGroups*/,
                     true/*includeOpaqueNetworkTypes*/);
         self.sortParams = [{field:"name", dir:"asc"}];

         buildDestinationNetworks();

         self.networkSelectorDialogSpec =
               networkSelectorDialogService.createNetworkSelectorDialogSpec(
                     ['Network.Assign'],
                     i18nService.getString(
                           'NetworkUi',
                           'AddNetworkingWizard.conTargetPage.noDvpgPrivilegeMessage')
               );
         self.onSelectNetworks = function(selectedNetworks, rowIndex) {
            self.migrateSelectNetworkService.onSelectNetwork(selectedNetworks[0],
                  self.data[rowIndex], NetworkPageViewModes.BASIC)
            .then(function() {
               buildDestinationNetworks();
            });
         };
      }
   }
}());









var h5_vm;
(function (h5_vm) {
    var VmPlacementFaultFormatter = (function () {
        function VmPlacementFaultFormatter($q, i18nService, defaultUriSchemeUtil, dataService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
        }
        VmPlacementFaultFormatter.prototype.formatFaults = function (drsFaults) {
            var _this = this;
            if (_.isEmpty(drsFaults)) {
                return this.$q.when([]);
            }
            var vms = [];
            _.each(drsFaults, function (vmFault) {
                _this.pushIfNotPresent(vms, vmFault.vm);
            });
            var dataRequest = this.dataService.getPropertiesForObjects(vms, [
                VmPlacementFaultFormatter.PROPERTY_NAME,
                VmPlacementFaultFormatter.PROPERTY_HOSTNAME]);
            return this.$q.when(dataRequest)
                .then(function (vmData) {
                var result = [];
                _.each(drsFaults, function (vmFault) {
                    _.each(vmFault.fault, function (fault) {
                        result.push(_this.newFormattedFault(fault.message, vmFault.vm, vmData));
                    });
                });
                return _.sortBy(result, function (fault) { return fault.vmName; });
            });
        };
        VmPlacementFaultFormatter.prototype.newFormattedFault = function (message, vm, vmData) {
            var vmName = "";
            var hostName = "";
            var vmId = this.toId(vm);
            if (vmId && vmData[vmId]) {
                vmName = vmData[vmId][VmPlacementFaultFormatter.PROPERTY_NAME];
                hostName = vmData[vmId][VmPlacementFaultFormatter.PROPERTY_HOSTNAME];
            }
            return {
                vmId: vmId,
                message: message,
                vmName: vmName,
                hostName: hostName
            };
        };
        ;
        VmPlacementFaultFormatter.prototype.pushIfNotPresent = function (entityIds, ref) {
            if (ref && entityIds) {
                if (entityIds.indexOf(this.toId(ref)) < 0) {
                    entityIds.push(this.toId(ref));
                }
            }
        };
        VmPlacementFaultFormatter.prototype.toId = function (ref) {
            return ref ? this.defaultUriSchemeUtil.getVsphereObjectId(ref) : undefined;
        };
        VmPlacementFaultFormatter.$inject = [
            "$q",
            "i18nService",
            "defaultUriSchemeUtil",
            "dataService"
        ];
        VmPlacementFaultFormatter.PROPERTY_NAME = "name";
        VmPlacementFaultFormatter.PROPERTY_HOSTNAME = "hostName";
        return VmPlacementFaultFormatter;
    }());
    h5_vm.VmPlacementFaultFormatter = VmPlacementFaultFormatter;
    angular
        .module("com.vmware.vsphere.client.vm")
        .service("vmPlacementFaultFormatter", VmPlacementFaultFormatter);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmPlacementFaultViewController = (function () {
        function VmPlacementFaultViewController($q, $scope, vuiConstants, i18nService) {
            this.$q = $q;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
        }
        VmPlacementFaultViewController.prototype.$onInit = function () {
            this.init();
        };
        VmPlacementFaultViewController.prototype.init = function () {
            var MISSING_VALUE = this.i18nService.getString("VmUi", "drs.faults.missingObjectName");
            this.gridOptions = {
                columnDefs: [{
                        displayName: this.i18nService.getString("Common", "drs.faultView.vmColumn"),
                        field: "vmName",
                        width: "25%",
                        template: kendo.template("#if(vmName){#" +
                            "   <span class='vsphere-icon-vm'></span>#:vmName#" +
                            "#}else{#" +
                            MISSING_VALUE +
                            "#}#")
                    }, {
                        displayName: this.i18nService.getString("Common", "drs.faultView.hostColumn"),
                        field: "hostName",
                        width: "25%",
                        template: kendo.template("#if(hostName){#" +
                            "   <span class='vsphere-icon-host'></span>#:hostName#" +
                            "#}else{#" +
                            MISSING_VALUE +
                            "#}#")
                    }, {
                        displayName: this.i18nService.getString("Common", "drs.faultView.descriptionColumn"),
                        field: "message",
                        width: "50%",
                        template: "#:message#"
                    }],
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.faults,
                resizable: true,
                searchable: false,
                height: 350
            };
        };
        VmPlacementFaultViewController.$inject = [
            "$q",
            "$scope",
            "vuiConstants",
            "i18nService"];
        return VmPlacementFaultViewController;
    }());
    h5_vm.VmPlacementFaultViewController = VmPlacementFaultViewController;
    var VmPlacementFaultView = (function () {
        function VmPlacementFaultView() {
            this.controller = VmPlacementFaultViewController;
            this.templateUrl =
                "vm-ui/resources/vm/views/migrationWizard/components/" +
                    "vmPlacementRecommendation/vmPlacementFaultView.html";
            this.bindings = {
                faults: "<"
            };
        }
        return VmPlacementFaultView;
    }());
    h5_vm.VmPlacementFaultView = VmPlacementFaultView;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("vmPlacementFaultView", new VmPlacementFaultView());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmXdrsRecommendationDialogService = (function () {
        function VmXdrsRecommendationDialogService($q, clarityModalService, i18nService) {
            this.$q = $q;
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
        }
        VmXdrsRecommendationDialogService.prototype.showRecommendations = function (recommendations, selectedRecommendationKey) {
            var deferredSelection = this.$q.defer();
            var dialogData = {
                recommendations: recommendations,
                selectedRecommendationKey: selectedRecommendationKey,
            };
            var modalOptions = {
                contentTemplate: "vm-ui/resources/vm/views/migrationWizard/components/" +
                    "vmPlacementRecommendation/vmPlacementRecommendationDialog.html",
                title: this.i18nService.getString("VmUi", "PlacementRecommendationDialog.title"),
                size: 'lg',
                dialogData: dialogData,
                onSubmit: function () {
                    deferredSelection.resolve({
                        selectedRecommendationKey: dialogData.selectedRecommendationKey
                    });
                    return true;
                },
                onCancel: function () {
                    deferredSelection.reject();
                    return false;
                },
                defaultButton: 'submit',
                submitButtonTitle: this.i18nService
                    .getString("VmUi", "PlacementRecommendationDialog.ok")
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
            return deferredSelection.promise;
        };
        VmXdrsRecommendationDialogService.prototype.showFaults = function (faults) {
            var modalOptions = {
                contentTemplate: "vm-ui/resources/vm/views/migrationWizard/components/" +
                    "vmPlacementRecommendation/vmPlacementRecommendationDialog.html",
                title: this.i18nService.getString("VmUi", "PlacementRecommendationDialog.faults.title"),
                size: "lg",
                hideSubmitButton: true,
                closeButtonTitle: this.i18nService.getString("Common", "saveButtonLabel"),
                defaultButton: "close",
                dialogData: {
                    faults: faults
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        VmXdrsRecommendationDialogService.$inject = [
            "$q",
            "clarityModalService",
            "i18nService"];
        return VmXdrsRecommendationDialogService;
    }());
    h5_vm.VmXdrsRecommendationDialogService = VmXdrsRecommendationDialogService;
    angular.module("com.vmware.vsphere.client.vm").service("vmPlacementRecommendationDialogService", VmXdrsRecommendationDialogService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    /**
     * Formats a VMODL Recommendation structure into displayable `FormattedRecommendation`
     * structure
     */
    var VmPlacementRecommendationFormatter = (function () {
        function VmPlacementRecommendationFormatter($q, i18nService, defaultUriSchemeUtil, dataServiceUtil) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataServiceUtil = dataServiceUtil;
        }
        VmPlacementRecommendationFormatter.prototype.formatRecommendations = function (recommendations) {
            var _this = this;
            if (!recommendations || !recommendations.length) {
                return this.$q.resolve([]);
            }
            return this.requestData(recommendations).then(function (entityData) {
                var formattedRecommendations = [];
                _.each(recommendations, function (rawRecommendation, key) {
                    var formattedRec = {
                        key: rawRecommendation.key,
                        priority: _this.ratingToPriority(rawRecommendation.rating),
                        reasonText: _this.text("PlacementRecommendationView.recommendationItemText", (key + 1).toString(), rawRecommendation.reasonText),
                        warningText: rawRecommendation.warningDetails && rawRecommendation.warningDetails.message ?
                            rawRecommendation.warningDetails.message : rawRecommendation.warningText || "",
                        actions: _this.formatActions(rawRecommendation.action, entityData)
                    };
                    formattedRecommendations.push(formattedRec);
                });
                return formattedRecommendations;
            });
        };
        VmPlacementRecommendationFormatter.prototype.requestData = function (recommendations) {
            var extractedEntities = this.extractRelatedEntities(recommendations);
            var requests = {
                vmData: this.dataServiceUtil.getPropertiesForObjects(extractedEntities.vms, [
                    VmPlacementRecommendationFormatter.PROPERTY_NAME,
                    VmPlacementRecommendationFormatter.PROPERTY_VMDEVICES]),
                otherData: this.dataServiceUtil.getPropertiesForObjects(extractedEntities.other, [VmPlacementRecommendationFormatter.PROPERTY_NAME])
            };
            return this.$q.all(requests).then(function (response) {
                var data = angular.extend({}, response.vmData, response.otherData);
                return data;
            });
        };
        VmPlacementRecommendationFormatter.prototype.extractRelatedEntities = function (recommendations) {
            var _this = this;
            var result = {
                vms: [],
                other: []
            };
            _.each(recommendations, function (recommendation) {
                _.each(recommendation.action, function (action) {
                    _this.pushIfNotPresent(result.other, action.targetHost);
                    _this.pushIfNotPresent(result.vms, action.vm);
                    if (action.relocateSpec) {
                        _this.pushIfNotPresent(result.other, action.relocateSpec.datastore);
                        _.each(action.relocateSpec.disk, function (diskLocator) {
                            _this.pushIfNotPresent(result.other, diskLocator.datastore);
                        });
                    }
                });
            });
            return result;
        };
        VmPlacementRecommendationFormatter.prototype.formatActions = function (actions, entitytData) {
            var _this = this;
            if (!actions || !actions.length) {
                return [];
            }
            var formattedActions = [];
            _.each(actions, function (action) {
                if (action._type !== "com.vmware.vim.binding.vim.cluster.PlacementAction") {
                    return;
                }
                var placementAction = action;
                if (placementAction.targetHost) {
                    formattedActions.push({
                        icon: "vsphere-icon-host",
                        text: _this.text("PlacementRecommendationView.vmHostPlacementItemText", _this.getEntityName(placementAction.vm, entitytData), _this.getEntityName(placementAction.targetHost, entitytData))
                    });
                }
                var noDiskLocators = !placementAction.relocateSpec.disk
                    || !placementAction.relocateSpec.disk.length;
                if (noDiskLocators) {
                    formattedActions.push({
                        icon: "vsphere-icon-vm",
                        text: _this.text("PlacementRecommendationView.vmStoragePlacementItemText", _this.getEntityName(placementAction.vm, entitytData), _this.getEntityName(placementAction.relocateSpec.datastore, entitytData))
                    });
                }
                else {
                    formattedActions.push({
                        icon: "vsphere-icon-vm",
                        text: _this.text("PlacementRecommendationView.vmxPlacementItemText", _this.getEntityName(placementAction.vm, entitytData), _this.getEntityName(placementAction.relocateSpec.datastore, entitytData))
                    });
                    _.each(placementAction.relocateSpec.disk, function (locator, index) {
                        formattedActions.push({
                            icon: "vx-icon-vmDisk",
                            text: _this.text("PlacementRecommendationView.vmdkPlacementItemText", _this.getEntityName(placementAction.vm, entitytData), _this.getDiskLabel(placementAction.vm, locator.diskId, entitytData), _this.getEntityName(locator.datastore, entitytData))
                        });
                    });
                }
            });
            return formattedActions;
        };
        VmPlacementRecommendationFormatter.prototype.ratingToPriority = function (rating) {
            if (rating === void 0) { rating = 0; }
            // The DRS-assigned star rating can be up to MAX_STAR_RATING (more being better).
            // Calculate the differential between this recommendation's rating and the best
            // possible DRS rating.
            var differentialFromBest = VmPlacementRecommendationFormatter.MAX_STAR_RATING - rating;
            // The priority rating can be down to MAX_PRIORITY_RATING (less being better).
            // Add the calculated differential to the best possible priority rating to obtain
            // the priority rating of this recommendation.
            return VmPlacementRecommendationFormatter.MAX_PRIORITY_RATING
                + differentialFromBest;
        };
        VmPlacementRecommendationFormatter.prototype.getEntityName = function (ref, entityData) {
            var data = entityData[this.toId(ref)];
            var name = "";
            if (data) {
                name = data[VmPlacementRecommendationFormatter.PROPERTY_NAME];
            }
            return name;
        };
        VmPlacementRecommendationFormatter.prototype.getDiskLabel = function (vm, diskId, entityData) {
            var data = entityData[this.toId(vm)];
            var diskLabel = "";
            if (data) {
                var vmDevices = data[VmPlacementRecommendationFormatter.PROPERTY_VMDEVICES];
                var diskDevice = _.find(vmDevices, function (device) { return device.key === diskId; });
                if (diskDevice) {
                    diskLabel = diskDevice.deviceInfo.label;
                }
            }
            return diskLabel;
        };
        VmPlacementRecommendationFormatter.prototype.pushIfNotPresent = function (entityIds, ref) {
            if (ref && entityIds) {
                if (entityIds.indexOf(this.toId(ref)) < 0) {
                    entityIds.push(this.toId(ref));
                }
            }
        };
        VmPlacementRecommendationFormatter.prototype.toId = function (ref) {
            return this.defaultUriSchemeUtil.getVsphereObjectId(ref);
        };
        VmPlacementRecommendationFormatter.prototype.text = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return (_a = this.i18nService).getString.apply(_a, ["VmUi", key].concat(params));
            var _a;
        };
        VmPlacementRecommendationFormatter.$inject = [
            "$q",
            "i18nService",
            "defaultUriSchemeUtil",
            "dataServiceUtil"
        ];
        VmPlacementRecommendationFormatter.PROPERTY_NAME = "name";
        VmPlacementRecommendationFormatter.PROPERTY_VMDEVICES = "config/hardware/device";
        VmPlacementRecommendationFormatter.MAX_STAR_RATING = 5;
        VmPlacementRecommendationFormatter.MAX_PRIORITY_RATING = 1;
        return VmPlacementRecommendationFormatter;
    }());
    h5_vm.VmPlacementRecommendationFormatter = VmPlacementRecommendationFormatter;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmPlacementRecommendationFormatter", VmPlacementRecommendationFormatter);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmPlacementRecommendationViewController = (function () {
        function VmPlacementRecommendationViewController($q, $scope, vuiConstants, i18nService) {
            var _this = this;
            this.$q = $q;
            this.$scope = $scope;
            this.vuiConstants = vuiConstants;
            this.i18nService = i18nService;
            // This is purposely declared as a property bound to then component's `this`
            // so it doesn't lose the `this` reference later when invoked by the
            // `preselect-comparator` directive.
            this.preselectRecommendation = _.bind(function (gridItem) {
                return gridItem.key === _this.selectedRecommendationKey;
            }, this);
        }
        VmPlacementRecommendationViewController.prototype.$onInit = function () {
            this.init();
        };
        VmPlacementRecommendationViewController.prototype.init = function () {
            var _this = this;
            this.descriptionText = this.text("PlacementRecommendationView.header");
            this.gridOptions = {
                columnDefs: [{
                        displayName: this.text("PlacementRecommendationView.recommendation"),
                        template: kendo.template("#:reasonText# #:warningText#" +
                            "<ul class='placement-recommendation-column'> " +
                            "  # for (var i = 0; i < actions.length; i++) { #" +
                            "     <li>" +
                            "         <span class=#:actions[i].icon#></span>" +
                            "         <span>#:actions[i].text#</span>" +
                            "     </li>" +
                            "   # } # " +
                            "</ul>"),
                        field: 'reasonText',
                        width: '80%'
                    }, {
                        displayName: this.text("PlacementRecommendationView.priority"),
                        field: 'priority',
                        template: '<div style="text-align: center;">#:priority#</div>'
                    }
                ],
                sortMode: this.vuiConstants.grid.sortMode.SINGLE,
                selectionMode: this.vuiConstants.grid.selectionMode.SINGLE,
                selectedItems: [],
                data: this.recommendations,
                resizable: true,
                searchable: false,
                height: 350
            };
            this.$scope.$watch(function () {
                return _this.gridOptions.selectedItems;
            }, function (newSelection, oldSelection) {
                var newItem = newSelection && !!newSelection.length ?
                    newSelection[0] : undefined;
                var oldItem = oldSelection && !!oldSelection.length ?
                    oldSelection[0] : undefined;
                if (newItem !== oldItem) {
                    _this.onSelectionRecommendationChanged(newItem);
                }
            });
        };
        VmPlacementRecommendationViewController.prototype.onSelectionRecommendationChanged = function (newRecommendationItem) {
            var newKey = newRecommendationItem ?
                newRecommendationItem.key : undefined;
            if (newKey !== this.selectedRecommendationKey) {
                this.selectedRecommendationKey = newKey;
            }
        };
        VmPlacementRecommendationViewController.prototype.text = function (key) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return (_a = this.i18nService).getString.apply(_a, ["VmUi", key].concat(params));
            var _a;
        };
        VmPlacementRecommendationViewController.$inject = [
            "$q",
            "$scope",
            "vuiConstants",
            "i18nService"];
        return VmPlacementRecommendationViewController;
    }());
    h5_vm.VmPlacementRecommendationViewController = VmPlacementRecommendationViewController;
    var VmPlacementRecommendationView = (function () {
        function VmPlacementRecommendationView() {
            this.controller = VmPlacementRecommendationViewController;
            this.templateUrl =
                "vm-ui/resources/vm/views/migrationWizard/components/" +
                    "vmPlacementRecommendation/vmPlacementRecommendationView.html";
            this.bindings = {
                recommendations: "<",
                selectedRecommendationKey: "="
            };
        }
        return VmPlacementRecommendationView;
    }());
    h5_vm.VmPlacementRecommendationView = VmPlacementRecommendationView;
    angular
        .module("com.vmware.vsphere.client.vm")
        .component("vmPlacementRecommendationView", new VmPlacementRecommendationView());
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .constant('NetworkPageViewModes', {
            BASIC: 'basic',
            ADVANCED: 'advanced'
         });
}());

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmMigrationScheduledTaskEditDefaultsValidationSpec = com.vmware.vsphere.client.h5.vm.model.migration.VmMigrationScheduledTaskEditDefaultsValidationSpec;
    var MigrateVmScheduledDataToModelMapper = (function () {
        function MigrateVmScheduledDataToModelMapper($q, defaultUriSchemeUtil, mutationService, diskProvisioningService, storageProfileService, initialStorageConfigurationService) {
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.diskProvisioningService = diskProvisioningService;
            this.storageProfileService = storageProfileService;
            this.initialStorageConfigurationService = initialStorageConfigurationService;
        }
        MigrateVmScheduledDataToModelMapper.prototype.applyDataToModels = function (migrationWizardManager, schedulingData) {
            var _this = this;
            // No scheduling data, so nothing to apply, so just return
            if (!schedulingData || !schedulingData.spec) {
                return this.$q.when({});
            }
            var vm = schedulingData.entity;
            var args = schedulingData.spec.argument;
            var spec = args[0].value;
            // Priority is undefined when using cold migration
            var movePriority = args[1].value ? args[1].value[1] : undefined;
            var vmId = this.defaultUriSchemeUtil.getVsphereObjectId(vm);
            var validationSpec = new VmMigrationScheduledTaskEditDefaultsValidationSpec();
            validationSpec.spec = spec;
            validationSpec.movePriority = movePriority;
            return this.mutationService.validate(vmId, validationSpec._type, validationSpec).then(function (response) {
                _this.onDefaultsCollected(migrationWizardManager, response);
                _this.applyDataToStorageModel(migrationWizardManager, vmId, spec, response);
            });
        };
        MigrateVmScheduledDataToModelMapper.prototype.onDefaultsCollected = function (migrationWizardManager, validationResult) {
            var defaultsData = validationResult.result;
            // Set the migration type - this is not applied on a model, but on
            // the migrationWizardManager internal data structure ... yeah it sucks, I know.
            migrationWizardManager.setSelectedMode(defaultsData.migrationType);
            var computeResourceId = this.defaultUriSchemeUtil.getVsphereObjectId(defaultsData.computeResource);
            migrationWizardManager.computeResourceTreePageModel.initialResource =
                computeResourceId;
            migrationWizardManager.computeResourcePageModel.initialComputeResource =
                computeResourceId;
            // Always restore the network selection page in advanced mode, as finding
            // out whether basic or advanced mode had been used just from the relocate
            // spec is nearly impossible.
            migrationWizardManager.networkPageModel.initialViewMode = "advanced";
            // since we are already in advanced mode, mark the view as changed
            migrationWizardManager.networkPageModel.setSelectNetworkPageIsViewChanged(true);
            migrationWizardManager.networkPageModel.initialMatches =
                defaultsData.networkMatches;
            migrationWizardManager.priorityPageModel.initialPriority =
                defaultsData.movePriority;
        };
        MigrateVmScheduledDataToModelMapper.prototype.applyDataToStorageModel = function (migrationWizardManager, vmId, spec, validationResult) {
            var defaultsData = validationResult.result;
            var pageModel = migrationWizardManager.storagePageModel;
            pageModel.initialViewMode = this.initialStorageConfigurationService
                .computeStoragePageViewMode(spec);
            pageModel.initialVmStorageConfig = this.initialStorageConfigurationService
                .computeInitialVmStorageConfig(vmId, spec, defaultsData.replicationGroupsData);
        };
        MigrateVmScheduledDataToModelMapper.$inject = [
            "$q",
            "defaultUriSchemeUtil",
            "mutationService",
            "diskProvisioningService",
            "storageProfileService",
            "initialStorageConfigurationService"
        ];
        return MigrateVmScheduledDataToModelMapper;
    }());
    h5_vm.MigrateVmScheduledDataToModelMapper = MigrateVmScheduledDataToModelMapper; // class
    angular.module("com.vmware.vsphere.client.vm").service("migrateVmScheduledDataToModelMapper", MigrateVmScheduledDataToModelMapper);
})(h5_vm || (h5_vm = {})); // h5_vm



angular.module('com.vmware.vsphere.client.vm').service('migrateVmWizardService', [
   'vuiService',
   'mutationService',
   'clarityModalService',
   'defaultUriSchemeUtil',
   'i18nService',
   '$rootScope',
   '$timeout',
   'vmMigrationSelectMigrationTypePageService',
   'vmMigrationSelectComputeResourcePageService',
   'vmMigrationSelectStoragePageService',
   'vmMigrationSelectPriorityPageService',
   'vmMigrationFinishPageService',
   'vuiConstants',
   'migrationTypeConstants',
   'vmFtConstants',
   'configurationService',
   'wizardPageService',
   '$q',
   'MigrationWizardManager',
   'vmMigrationSelectNetworkPageService',
   'vmMigrationSelectComputeResourceTreePageService',
   'vmMigrationSelectFolderPageService',
   'actionConfirmationService',
   'managedByMessageBuilderService',
   'vmMigrationScheduleTaskPageService',
   'migrateVmScheduledDataToModelMapper',
   function (
      vuiService,
      mutationService,
      clarityModalService,
      defaultUriSchemeUtil,
      i18nService,
      $rootScope,
      $timeout,
      vmMigrationSelectMigrationTypePageService,
      vmMigrationSelectComputeResourcePageService,
      vmMigrationSelectStoragePageService,
      vmMigrationSelectPriorityPageService,
      vmMigrationFinishPageService,
      vuiConstants,
      migrationTypeConstants,
      vmFtConstants,
      configurationService,
      wizardPageService,
      $q,
      MigrationWizardManager,
      vmMigrationSelectNetworkPageService,
      vmMigrationSelectComputeResourceTreePageService,
      vmMigrationSelectFolderPageService,
      actionConfirmationService,
      managedByMessageBuilderService,
      vmMigrationScheduleTaskPageService,
      migrateVmScheduledDataToModelMapper
   ) {

      return {
         showWizard: function (vmIds, context, actionEval) {
            var destinationTarget = null;
            if (context && context.dropTarget) {
               destinationTarget = context.dropTarget;
            }
            var migrationType = null;
            if (context && context.migrationType) {
               migrationType = context.migrationType;
            }

            return validateWorkflow(vmIds, actionEval, context).then(function (validateWorkflowResult) {
               if (!validateWorkflowResult.continue) {
                  return undefined;
               }
               vmIds = validateWorkflowResult.availableVms;
               var vmProperties = validateWorkflowResult.vmProperties;
               // All vms are verified to be with the same power state
               // so just take the first one
               var isHotMigration = vmProperties[vmIds[0]].powerState === 'poweredOn';

               var isNetworkSelectionRequired = checkIfNetworkSelectionRequired(
                     vmProperties, validateWorkflowResult.hasNetworkAdapter) ;

               var wizardScope = $rootScope.$new();
               wizardScope.locationSpec = {};
               wizardScope.migrationWizardManager = new MigrationWizardManager(
                     wizardScope, vmProperties);
               wizardScope.migrationWizardManager.isNetworkSelectionRequired =
                     isNetworkSelectionRequired;
               // TODO - vaivanov - figure out who uses this and remove it once the
               // dependent component supports multiple vm migration.
               wizardScope.vmId = vmIds[0];
               wizardScope.vmName = vmProperties[vmIds[0]].name;

               // Used by SelectMigrationTypePage. Needs to be removed when page
               // starts supporting multiple vm case.
               var hostData = vmProperties[vmIds[0]].host;
               wizardScope.attributes = {
                  creationType: migrationTypeConstants.MIGRATE_RESOURCE_ONLY,
                  hostData: hostData
               };
               wizardScope.destinationTarget = destinationTarget;
               if (migrationType) {
                  wizardScope.migrationWizardManager.setSelectedMode(migrationType);
               }
               var flowIds = [
                  migrationTypeConstants.MIGRATE_RESOURCE_ONLY,
                  migrationTypeConstants.MIGRATE_STORAGE_ONLY,
                  migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE
               ];

               var selectMigrationTypePage = vmMigrationSelectMigrationTypePageService
                     .build(wizardScope, flowIds);
               var computeResourcePage = vmMigrationSelectComputeResourcePageService
                     .build(wizardScope);
               var computeResourceTreePage = vmMigrationSelectComputeResourceTreePageService
                     .build(wizardScope);
               var selectFolderPage = vmMigrationSelectFolderPageService
                     .build(wizardScope);
               var selectPriorityPage = vmMigrationSelectPriorityPageService
                     .build(wizardScope);

               var storagePage = vmMigrationSelectStoragePageService
                     .build(wizardScope);

               var migrateFinishPage = vmMigrationFinishPageService
                     .build(wizardScope);

               var selectNetworkPage = vmMigrationSelectNetworkPageService
                     .build(wizardScope);


               var flows = [
                  {
                     id: migrationTypeConstants.MIGRATE_RESOURCE_ONLY,
                     pages: buildMigrateComputeResourcePages()
                  },
                  {
                     id: migrationTypeConstants.MIGRATE_STORAGE_ONLY,
                     pages: buildMigrateStoragePages()
                  },
                  {
                     id: migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE,
                     pages: buildMigrateComputeResourceAndStoragePages()
                  }
               ];

               var pages;

               var wizardTitleSingle = 'MigrationWizard.title.single';
               if (actionEval && actionEval.additionalData
                     && actionEval.additionalData.isScheduledTask === true) {
                  var scheduleTaskPage = vmMigrationScheduleTaskPageService
                     .build(wizardScope, actionEval.additionalData
                        .schedulingData.schedulingSpec);
                  wizardScope.migrationWizardManager.vmWizardScheduleTaskPageModel
                        .mutationSpec = actionEval.additionalData.schedulingData;
                  wizardScope.migrationWizardManager.vmWizardScheduleTaskPageModel
                        .isScheduledTaskFlow = actionEval.additionalData.isScheduledTask;

                  pages = [
                     scheduleTaskPage,
                     selectMigrationTypePage
                  ];

                  if (actionEval.additionalData.schedulingData.scheduleTaskOperationMode === 1) { // Edit
                     wizardTitleSingle = 'ScheduledTask.Edit.' + wizardTitleSingle;
                  } else {
                     wizardTitleSingle = 'ScheduledTask.' + wizardTitleSingle;
                  }

               } else {
                  pages = [
                     selectMigrationTypePage
                  ];
               }

               var wizardTitle = vmIds.length === 1 ?
                     i18nService.getString(
                           'VmUi', wizardTitleSingle,
                           vmProperties[vmIds[0]].name) :
                     i18nService.getString(
                           'VmUi', 'MigrationWizard.Title.Multi',
                           vmIds.length);

               wizardScope.wizardConfig = {
                  title: wizardTitle,
                  pages: wizardPageService.initializePageStates(pages),
                  cssClass: 'migrate-vm-wizard',
                  flows: wizardPageService.initializeFlowStates(flows)
               };

               var schedulingData = actionEval && actionEval.additionalData &&
                     actionEval.additionalData.schedulingData;
               migrateVmScheduledDataToModelMapper.applyDataToModels(
                     wizardScope.migrationWizardManager,
                     schedulingData
               ).then(function () {
                  vuiService.createWizard({
                     scope: wizardScope,
                     configObjectName: 'wizardConfig'
                  }).show();
               });

               wizardScope.$watch(function() {
                  return wizardScope.migrationWizardManager.computeResourcePageModel.computeResource;
               }, function(newValue) {
                  showFolderPageIfNeeded(wizardScope.wizardConfig.flows,
                        migrationTypeConstants.MIGRATE_RESOURCE_ONLY, newValue);
               });

               wizardScope.$watch(function() {
                  return wizardScope.migrationWizardManager.computeResourceTreePageModel.resource;
               }, function(newValue) {
                  showFolderPageIfNeeded(wizardScope.wizardConfig.flows,
                        migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE, newValue);
               });

               return wizardScope;

               function showFolderPageIfNeeded(flows, flowId, newItem) {
                  if (!newItem) {
                     return;
                  }

                  var flow = _.find(flows, function(flow) {
                     return flow.id === flowId;
                  });
                  var pages = flow.pages;

                  if (!isVcChanged(newItem)) {
                     wizardPageService.markPageSkipped(
                           pages,
                           i18nService.getString('VmUi', 'MigrationWizard.selectFolderPage.Title')
                     );
                  } else {
                     wizardPageService.markPageDisabled(
                           pages,
                           i18nService.getString('VmUi', 'MigrationWizard.selectFolderPage.Title')
                     );
                  }
               }

               function checkIfNetworkSelectionRequired(vmProperties, hasNetworkAdapter) {
                  // If none of the migrated VMs have virtual network adapter, don't show the
                  // network selection page.
                  // If a secondary FT VM is being migrated, don't show network selection page.
                  if (!hasNetworkAdapter || hasSecondaryVms(vmProperties)) {
                     return false;
                  }

                  // If there is no secondary FT VM within the ones being migrated, and at
                  // least one of them has a virtual network adapter, show the network
                  // selection page.
                  return true;
               }

               function hasSecondaryVms(vmProperties) {
                  var PROP_VM_FTSTATE = 'runtime/faultToleranceState';
                  var PROP_VM_FTINFO = 'config/ftInfo';

                  return _.some(vmProperties, function(singleVmProperies) {
                     return (singleVmProperies[PROP_VM_FTSTATE] !== vmFtConstants.NOT_CONFIGURED &&
                     singleVmProperies[PROP_VM_FTINFO] &&
                     singleVmProperies[PROP_VM_FTINFO].role > 1);
                  });
               }

               function isVcChanged(newItem) {
                  var sourceServerId = defaultUriSchemeUtil.getPartsFromVsphereObjectId(vmIds[0]).serverGuid;
                  var destinationSeverId = defaultUriSchemeUtil.getPartsFromVsphereObjectId(newItem).serverGuid;
                  return sourceServerId !== destinationSeverId;
               }

               function buildMigrateComputeResourcePages() {
                  var migrateResourcePages = [computeResourcePage];

                  selectFolderPage.defaultState = vuiConstants.wizard.pageState.SKIPPED;
                  migrateResourcePages.push(selectFolderPage);

                  if (isNetworkSelectionRequired) {
                     migrateResourcePages.push(selectNetworkPage);
                  }

                  if (isHotMigration) {
                     migrateResourcePages.push(selectPriorityPage);
                  }

                  migrateResourcePages.push(migrateFinishPage);

                  return migrateResourcePages;
               }

               function buildMigrateStoragePages() {
                  return [
                     storagePage,
                     migrateFinishPage
                  ];
               }
               function buildMigrateComputeResourceAndStoragePages () {
                  var migrateComputeResourceAndStoragePages = [];
                  migrateComputeResourceAndStoragePages.push(computeResourceTreePage);
                  migrateComputeResourceAndStoragePages.push(storagePage);

                  selectFolderPage.defaultState = vuiConstants.wizard.pageState.SKIPPED;
                  migrateComputeResourceAndStoragePages.push(selectFolderPage);

                  if (isNetworkSelectionRequired) {
                     migrateComputeResourceAndStoragePages.push(selectNetworkPage);
                  }
                  if (isHotMigration) {
                     migrateComputeResourceAndStoragePages.push(selectPriorityPage);
                  }
                  migrateComputeResourceAndStoragePages.push(migrateFinishPage);

                  return migrateComputeResourceAndStoragePages;
               }
            });
         }
      };

      function validateWorkflow(vmIds, actionEval, context) {
         return mutationService.validateSpec(
               "com.vmware.vsphere.client.h5.vm.model.migration.VmMigrationFlowValidationSpec",
               {vms: vmIds})
               .then(function(validationResult) {
                  return handleErrorsAndWarnings(validationResult, actionEval, context);
               });
      }

      function handleErrorsAndWarnings(validation, actionEval, context) {
         // TODO - vaivanov - Add support for showing multiple errors and warnings.
         // Currently validation can generate up to 1 error and up to 1 warning.
         // So there is no need for UI that can display multiple errors and warnings.
         // The only case not covered here is when we have 1 warning and 1 error.
         // The can happen if user chooses to migrate at least 1 FT vm along with some
         // other VMs with different power state. In this case we show only the error
         // for VMs in different power state without the FT warning.
         var deferred = $q.defer();
         var errors = validation.error ?
               [i18nService.getString("VmUi", "ValidateVmsView.ErrorGeneric")] :
               validation.result.errors;
         if (!_.isEmpty(errors)) {
            var errorOptions = {
               title: i18nService.getString("VmUi", "ValidateVmsView.Title"),
               message: validation.result.errors[0],
               icon: 'vui-icon32-error',
               submit: function() {
                  deferred.resolve({
                     continue: false,
                     vmProperties: {},
                     availableVms: []
                  });
               },
               hideCancelButton: true
            };
            clarityModalService.openConfirmationModal(errorOptions);
         } else if (!_.isEmpty(validation.result.warnings)) {
            // Here we set the availability of the action of the VMs, which are filtered out
            // from the warning, to 'false' in order to have the correct count in
            // the message from the action framework
            _.each(actionEval.evaluationStatuses, function(status, vmId) {
               status.available = _.contains(validation.result.availableVms, vmId);
            });
            var warningOptions = {
               title: i18nService.getString("VmUi", "ValidateVmsView.Title"),
               message: validation.result.warnings[0],
               icon: 'icon-warning-32',
               saveButtonLabel: i18nService.getString("VmUi", "ValidateVmsView.Continue"),
               submit: function() {
                  confirmIfRequired(actionEval, validation.result.availableVms, context,
                        validation.result.vmProperties).then(function() {
                     deferred.resolve({
                        continue: true,
                        vmProperties: validation.result.vmProperties,
                        availableVms: validation.result.availableVms,
                        hasNetworkAdapter: validation.result.hasNetworkAdapter
                     });
                  });
                  return true;
               },
               onCancel: function() {
                  deferred.resolve({
                     continue: false,
                     vmProperties: {},
                     availableVms: []
                  });
                  return true;
               }
            };
            clarityModalService.openConfirmationModal(warningOptions);
         } else {
            confirmIfRequired(actionEval, validation.result.availableVms, context,
                  validation.result.vmProperties).then(function() {
               deferred.resolve({
                  continue: true,
                  vmProperties: validation.result.vmProperties,
                  availableVms: validation.result.availableVms,
                  hasNetworkAdapter: validation.result.hasNetworkAdapter
               });
            });
         }

         return deferred.promise;
      }

      function confirmIfRequired(actionEval, vmIds, context, vmProperties) {
         if (!actionEval || (context && context.dropTarget)) {
            return $q.when();
         }
         var deferred = $q.defer();

         actionEval.action.confirmationTextSome = null;
         actionEval.action.confirmationTextAll = null;

         var withProceed = Object.keys(actionEval.evaluationStatuses).length === 1;
         managedByMessageBuilderService.buildWarningMessage(vmIds, withProceed, vmProperties)
               .then(function(managedByInfoMessage) {
                  if (managedByInfoMessage) {
                     actionEval.action.confirmationText = managedByInfoMessage;
                     managedByInfoMessage += "\n\n";
                     actionEval.action.confirmationTextSome = managedByInfoMessage +
                           i18nService.getString("Common", "defaultConfirmation.someOK");
                     actionEval.action.confirmationTextAll = managedByInfoMessage +
                           i18nService.getString("Common", "defaultConfirmation.allOK");
                  }

                  actionConfirmationService.confirmIfRequired(actionEval, function() {
                     deferred.resolve();
                  }, true);
         });
         return deferred.promise;
      }
   }]);

angular.module('com.vmware.vsphere.client.vm').constant('migrationTypeConstants',
      {
         MIGRATE_RESOURCE_ONLY: 'changeResourceOnly',
         MIGRATE_STORAGE_ONLY: 'changeStorageOnly',
         MIGRATE_RESOURCE_AND_STORAGE: 'changeComputeResourceAndStorage'
      }
);

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateFinishPageComponent = (function () {
        function MigrateFinishPageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/migrateFinishPageComponent.html";
            this.controller = MigrateFinishPageController;
            this.controllerAs = "ctrl";
            this.bindings = {
                migrationWizardManager: "<",
                wizardConfig: "<",
                pageModel: "<",
                destinationTarget: "<"
            };
        }
        return MigrateFinishPageComponent;
    }());
    h5_vm.MigrateFinishPageComponent = MigrateFinishPageComponent;
    var MigrateFinishPageController = (function () {
        function MigrateFinishPageController($scope, i18n, $q, datastoreRecommendationsDialogService, datastoreFaultsDialogService, defaultUriSchemeUtil, storageProfileService, vmPlacementRecommendationDialogService, vmPlacementRecommendationFormatter, vmPlacementFaultFormatter, wizardPageService, spbmReplicationGroupInfoService) {
            this.$scope = $scope;
            this.$q = $q;
            this.datastoreRecommendationsDialogService = datastoreRecommendationsDialogService;
            this.datastoreFaultsDialogService = datastoreFaultsDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageProfileService = storageProfileService;
            this.vmPlacementRecommendationDialogService = vmPlacementRecommendationDialogService;
            this.vmPlacementRecommendationFormatter = vmPlacementRecommendationFormatter;
            this.vmPlacementFaultFormatter = vmPlacementFaultFormatter;
            this.wizardPageService = wizardPageService;
            this.spbmReplicationGroupInfoService = spbmReplicationGroupInfoService;
            this.i18nService = i18n.getString;
        }
        MigrateFinishPageController.prototype.$onInit = function () {
            var _this = this;
            this.setIsLoading(true);
            this.$q.all({
                recommendationsCompleted: this.migrationWizardManager.fetchRecommendations(),
                namesData: this.migrationWizardManager.requestFolderData()
            }).then(function () {
                _this.initialize();
            }).then(function () {
                _this.setIsLoading(false);
            });
        };
        MigrateFinishPageController.prototype.initialize = function () {
            var _this = this;
            this.pageModel = this.migrationWizardManager.getFinishPageState();
            this.migrationTypeTitle = this.i18nService("VmUi", this.pageModel.migrationType);
            if (this.pageModel.xdrsRecommendationService &&
                this.pageModel.xdrsRecommendationService.hasInitErrors()) {
                this.wizardPageService.markPageIncompleteWithError(this.wizardConfig, this.i18nService("VmUi", "MigrationWizard.readyPage.error.xdrs.retrievalFailed"));
            }
            // Show vm name in single vm migration or show vm count in multiple vm migration.
            this.vmText = this.pageModel.vmIds.length === 1 ?
                this.pageModel.vmNames[this.pageModel.vmIds[0]] :
                this.i18nService("VmUi", "MigrationWizard.readyPage.migratingVms", this.pageModel.vmIds.length);
            this.showSdrsSummary = this.pageModel.recommendationService &&
                (this.pageModel.recommendationService.hasRecommendations()
                    || this.pageModel.recommendationService.hasFaults());
            var profile = this.pageModel.profile;
            if (!profile || (profile.id === this.storageProfileService.DEFAULT_ID)) {
                this.profileLabel = undefined;
            }
            else {
                // In case of "keep existing" the label is bogus - stretch for
                // the actual profile name.
                this.profileLabel = profile.keepExistingProfileAssignments ?
                    (profile.profileObj ? profile.profileObj.name : undefined) :
                    profile.label;
            }
            if (this.pageModel.replicationGroup) {
                this.replicationGroupLabel = this.spbmReplicationGroupInfoService
                    .getReplicationGroupName(this.pageModel.replicationGroup);
            }
            else {
                this.replicationGroupLabel = "";
            }
            this.openXdrsRecommendations = function () {
                _this.setIsLoading(false);
                var recommendations = _this.pageModel.xdrsRecommendationService.getRecommendations();
                if (!_this.xdrsFormattedRecommendations) {
                    _this.xdrsFormattedRecommendations = _this.vmPlacementRecommendationFormatter
                        .formatRecommendations(recommendations);
                }
                _this.xdrsFormattedRecommendations.then(function (formattedRecommendations) {
                    _this.vmPlacementRecommendationDialogService.showRecommendations(formattedRecommendations, _this.pageModel.xdrsRecommendationService.getSelectedRecommendation().key)
                        .then(function (dialogData) {
                        var selectedRecommendation = _.find(recommendations, function (rec) {
                            return rec.key === dialogData.selectedRecommendationKey;
                        });
                        if (selectedRecommendation) {
                            _this.pageModel.xdrsRecommendationService
                                .setSelectedRecommendation(selectedRecommendation);
                        }
                    });
                }).then(function () {
                    _this.setIsLoading(false);
                });
            };
            this.openXdrsFaults = function () {
                _this.setIsLoading(false);
                var faults = _this.pageModel.xdrsRecommendationService.getFaults();
                if (!_this.xdrsFormattedFaults) {
                    _this.xdrsFormattedFaults = _this.vmPlacementFaultFormatter.formatFaults(faults);
                }
                _this.xdrsFormattedFaults.then(function (formattedFaults) {
                    _this.vmPlacementRecommendationDialogService.showFaults(formattedFaults);
                }).then(function () {
                    _this.setIsLoading(false);
                });
            };
            this.$scope.openRecommendationsDialog = function (vm, disk) {
                if (!disk && !_this.migrationWizardManager.model.isAdvancedStorageMode) {
                    disk = {
                        storageUrn: _this.defaultUriSchemeUtil.getVsphereObjectId(_this.pageModel.storage.storageRef),
                        parentStoragePodUrn: _this.pageModel.storage.parentStoragePod ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(_this.pageModel.storage.parentStoragePod) :
                            undefined
                    };
                }
                var recommendationService = _this.migrationWizardManager
                    .getStorageRecommendationsServiceInstance();
                var recommendations = recommendationService
                    .getDiskRecommendations(vm.vmId, disk);
                _this.datastoreRecommendationsDialogService.openDialog(recommendations, _this.pageModel.storageNameMap, recommendationService.getSelectedRecommendation(vm.vmId, disk), vm.vmName).then(function (results) {
                    recommendationService
                        .setSelectedRecommendation(vm.vmId, disk, results.recommendationSpec);
                    // Update the finishPageModel to get the new labels for the disks
                    _this.pageModel = _this.migrationWizardManager.getFinishPageState();
                });
            };
            this.$scope.openFaultsDialog = function (vm) {
                var faults = _this.migrationWizardManager
                    .getStorageRecommendationsServiceInstance().getFaultsForVm(vm.vmId);
                _this.datastoreFaultsDialogService.openDialog(_this.$scope, faults);
            };
        };
        MigrateFinishPageController.prototype.getStorageHint = function () {
            var hint = "";
            if (this.pageModel.pmemDiskInfo.hasPmemDisk) {
                hint = this.pageModel.pmemDiskInfo.hasRegularDisk ?
                    this.i18nService("VmUi", "MigrationWizard.readyPage.pmem.hint.hybridBaseline") :
                    this.i18nService("VmUi", "MigrationWizard.readyPage.pmem.hint.pmemBaseline");
            }
            if (this.pageModel.pmemDiskInfo.hasDowngradedPmemDisk) {
                hint = this.i18nService("VmUi", "MigrationWizard.readyPage.pmem.hint.standardBaseline");
            }
            return hint;
        };
        MigrateFinishPageController.prototype.setIsLoading = function (value) {
            this.wizardConfig.loading = value;
        };
        MigrateFinishPageController.$inject = [
            "$scope",
            "i18nService",
            "$q",
            "datastoreRecommendationsDialogService",
            "datastoreFaultsDialogService",
            "defaultUriSchemeUtil",
            "storageProfileService",
            "vmPlacementRecommendationDialogService",
            "vmPlacementRecommendationFormatter",
            "vmPlacementFaultFormatter",
            "wizardPageService",
            "spbmReplicationGroupInfoService"
        ];
        return MigrateFinishPageController;
    }());
    h5_vm.MigrateFinishPageController = MigrateFinishPageController; // class
    angular.module("com.vmware.vsphere.client.vm").component("migrateFinishPageComponent", new MigrateFinishPageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateFinishPageModel = (function () {
        function MigrateFinishPageModel() {
        }
        return MigrateFinishPageModel;
    }());
    h5_vm.MigrateFinishPageModel = MigrateFinishPageModel; // class
})(h5_vm || (h5_vm = {})); // module



var h5_vm;
(function (h5_vm) {
    var MigrateSelectFolderPageComponent = (function () {
        function MigrateSelectFolderPageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectFolderPageComponent.html";
            this.controller = MigrateSelectFolderPageComponentController;
            this.controllerAs = "ctrl";
            this.bindings = {
                wizardConfig: "<",
                migrationWizardManager: "<",
                pageModel: "<",
                // target from drag and drop operation
                destinationTarget: "<"
            };
        }
        return MigrateSelectFolderPageComponent;
    }());
    h5_vm.MigrateSelectFolderPageComponent = MigrateSelectFolderPageComponent; // MigrateSelectFolderPageComponent
    var MigrateSelectFolderPageComponentController = (function () {
        function MigrateSelectFolderPageComponentController($scope, defaultUriSchemeUtil, managedEntityConstants, migrationService, compatibilityResultsPresenter, i18nService, wizardPageService, dataService, authorizationService, $q) {
            this.$scope = $scope;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.migrationService = migrationService;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
            this.dataService = dataService;
            this.authorizationService = authorizationService;
            this.$q = $q;
        }
        MigrateSelectFolderPageComponentController.prototype.$onInit = function () {
            var _this = this;
            this.pageInstructions = this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.Instructions");
            this.treeType = "VmFoldersTreeFromDatacenter";
            this.treeRoot = this.pageModel.datacenter;
            if (this.pageModel.selectedTarget) {
                this.preselectedLocation = this.pageModel.selectedTarget.uid;
                // disable `Next` button
                this.pageModel.isLoading = true;
            }
            this.dcFolderIdsCache = {};
            this.$scope.$on("$destroy", function () {
                _this.setLoadingIndicator(false);
            });
        };
        MigrateSelectFolderPageComponentController.prototype.onTargetChange = function (locationId, locationName, nodeTypeId) {
            var _this = this;
            if (!locationId || !locationName || !nodeTypeId) {
                return;
            }
            if (this.preselectedLocation === locationId) {
                // Tree has loaded to its preselection - enable `Next` button
                this.pageModel.isLoading = false;
            }
            this.pageModel.selectedTarget = {
                uid: locationId,
                name: locationName,
                type: nodeTypeId
            };
            this.setLoadingIndicator(true);
            this.validateSelection(this.pageModel.selectedTarget).then(function () {
                _this.setLoadingIndicator(false);
            });
        };
        /**
         * Performs VM folder validation. The validation includes:
         * if datacenter is selected:
         *       - Its default VM folder should be retrieved
         *       - User should have privilege for migrating VM to this default VM folder
         * if VM folder is selected:
         *       - User should have privilege for migrating VM to the VM folder
         */
        MigrateSelectFolderPageComponentController.prototype.validateSelection = function (selectedTargetObj) {
            var _this = this;
            this.compatibilityContents = [];
            this.wizardConfig.loadingMessage = this.i18nService.getString("CommonUi", "wizard.validating");
            // get the selected folder, check if it is DC or VM folder and calculate correct target folder
            var destinationType = this.defaultUriSchemeUtil.getEntityType(selectedTargetObj.uid);
            if (destinationType === this.managedEntityConstants.DATACENTER) {
                if (this.dcFolderIdsCache[selectedTargetObj.uid]) {
                    return this.ckeckPrivilegesOnFolder(this.dcFolderIdsCache[selectedTargetObj.uid]);
                }
                else {
                    return this.dataService.getProperties(selectedTargetObj.uid, ["vmFolder"])
                        .then(function (result) {
                        var dcFolderUid = _this.defaultUriSchemeUtil
                            .getVsphereObjectId(result["vmFolder"]);
                        _this.dcFolderIdsCache[selectedTargetObj.uid] = dcFolderUid;
                        _this.ckeckPrivilegesOnFolder(dcFolderUid);
                    });
                }
            }
            else if (destinationType === this.managedEntityConstants.FOLDER) {
                return this.ckeckPrivilegesOnFolder(selectedTargetObj.uid);
            }
            // selectedTargetObj is not valid type
            return this.$q.when({});
        };
        MigrateSelectFolderPageComponentController.prototype.ckeckPrivilegesOnFolder = function (destinationFolderUid) {
            var _this = this;
            var requiredPrivileges = ["VirtualMachine.Inventory.Create",
                "VirtualMachine.Inventory.Register"];
            return this.authorizationService.checkPrivileges(destinationFolderUid, requiredPrivileges)
                .then(function (privilegeStatuses) {
                if (_this.hasPrivileges(privilegeStatuses)) {
                    _this.pageModel.destinationFolder = destinationFolderUid;
                    _this.compatibilityContents = _this.makeCompatibilityMessage(true);
                }
                else {
                    _this.pageModel.destinationFolder = undefined;
                    var destinationType = void 0;
                    if (_this.pageModel.selectedTarget) {
                        destinationType = _this.defaultUriSchemeUtil
                            .getEntityType(_this.pageModel.selectedTarget.uid);
                    }
                    _this.compatibilityContents = _this.makeCompatibilityMessage(false, destinationType);
                }
            });
        };
        MigrateSelectFolderPageComponentController.prototype.hasPrivileges = function (privilegeStatuses) {
            var hasActionPrivileges = true;
            for (var i = 0; i < privilegeStatuses.length; i++) {
                if (!privilegeStatuses[i]) {
                    hasActionPrivileges = false;
                    break;
                }
            }
            return hasActionPrivileges;
        };
        MigrateSelectFolderPageComponentController.prototype.makeCompatibilityMessage = function (hasActionPrivileges, destinationType) {
            if (hasActionPrivileges) {
                return [{
                        icon: "vsphere-icon-status-ok",
                        message: this.i18nService.getString("VmUi", "MigrationCompatibilityResultsView.Success"),
                        contents: []
                    }];
            }
            var message = this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.error.NoRegisterVmPrivilegeOnFolder");
            if (destinationType === this.managedEntityConstants.DATACENTER) {
                message = this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.error.NoRegisterVmPrivilegeOnDatacenter");
            }
            return [{
                    icon: "vsphere-icon-status-error",
                    message: message,
                    contents: []
                }];
        };
        MigrateSelectFolderPageComponentController.prototype.setLoadingIndicator = function (setting) {
            this.wizardConfig.loading = setting;
        };
        MigrateSelectFolderPageComponentController.$inject = [
            "$scope",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "migrationService",
            "compatibilityResultsPresenter",
            "i18nService",
            "wizardPageService",
            "dataService",
            "authorizationService",
            "$q"
        ];
        return MigrateSelectFolderPageComponentController;
    }()); // class MigrateSelectFolderPageComponentController
    angular.module("com.vmware.vsphere.client.vm").component("migrateSelectFolderPageComponent", new MigrateSelectFolderPageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateSelectFolderPageModel = (function () {
        function MigrateSelectFolderPageModel() {
            /**
             * [input]
             *
             * The VMs being migrated.
             */
            this.vms = [];
        }
        return MigrateSelectFolderPageModel;
    }());
    h5_vm.MigrateSelectFolderPageModel = MigrateSelectFolderPageModel; // class
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateSelectNetworkPageComponent = (function () {
        function MigrateSelectNetworkPageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectNetworkPageComponent.html";
            this.controller = MigrateSelectNetworkPageComponentController;
            this.controllerAs = "ctrl";
            this.bindings = {
                migrationWizardManager: "<",
                wizardConfig: "<",
                pageModel: "<",
                destinationTarget: "<"
            };
        }
        return MigrateSelectNetworkPageComponent;
    }());
    h5_vm.MigrateSelectNetworkPageComponent = MigrateSelectNetworkPageComponent;
    var MigrateSelectNetworkPageComponentController = (function () {
        function MigrateSelectNetworkPageComponentController($scope, i18nService, vmMigrateSelectNetworkServiceClass, networkPageViewModes, defaultUriSchemeUtil, zoneDigestPatchService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.vmMigrateSelectNetworkServiceClass = vmMigrateSelectNetworkServiceClass;
            this.networkPageViewModes = networkPageViewModes;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.zoneDigestPatchService = zoneDigestPatchService;
            //
            // Properties accessed in the HTML
            //
            this.isValidating = false;
            this.pageReady = false;
            this.compatibilityTitle = this.i18nService.getString("VmUi", "MigrationWizard.networkPage.compatibility");
            this.networkPageAriaLabel = this.i18nService.getString("VmUi", "MigrationWizard.networkPage.description");
            this.selectNetworkGridDescription = this.i18nService.getString("Common", "vns.basic.description");
        }
        MigrateSelectNetworkPageComponentController.prototype.requestData = function (vmIds) {
            var _this = this;
            this.setIsLoading(true);
            this.vmMigrateSelectNetworkService
                .requestData(vmIds)
                .then(function (result) {
                if (!!result.prefetchedNetworksPromise) {
                    result.prefetchedNetworksPromise.then(function () {
                        _this.$scope.$broadcast("onPrefetchNetworksCompleted");
                    });
                }
                _this.setIsLoading(false);
                _this.onDataRequested();
                _this.pageModel.setSelectNetworkPageIsInitialized(true);
            }, function () {
                _this.setIsLoading(false);
            });
        };
        MigrateSelectNetworkPageComponentController.prototype.getViewMode = function () {
            return this.pageModel.getSelectNetworkPageViewMode();
        };
        MigrateSelectNetworkPageComponentController.prototype.setIsLoading = function (isLoading) {
            this.wizardConfig.loading = isLoading;
        };
        MigrateSelectNetworkPageComponentController.prototype.setIsValidating = function (isValidating) {
            this.isValidating = isValidating;
            this.pageModel.setSelectNetworkPageIsValidating(this.isValidating);
            // patching the application because there is a issue which
            // prevents the digest from execution when data is changed
            // TODO - vasila remove this call when the issue is resolved
            this.zoneDigestPatchService.digest();
        };
        MigrateSelectNetworkPageComponentController.prototype.$onInit = function () {
            var _this = this;
            var computeResourceUrn = this.defaultUriSchemeUtil.getVsphereObjectId(this.migrationWizardManager.getDestinationComputeResourceRef());
            this.pageModel.checkResourceAndReset(computeResourceUrn);
            this.vmMigrateSelectNetworkService = new this.vmMigrateSelectNetworkServiceClass(this.migrationWizardManager, this.pageModel, function (v) { return _this.setIsValidating(v); });
            this.pageReady = false;
            this.compatibilityMessages = [];
            if (this.pageModel.getSelectNetworkPageViewMode() ===
                this.networkPageViewModes.BASIC) {
                this.advancedButtonText = this.i18nService.getString("Common", "vns.switchToAdvanced");
            }
            else {
                this.advancedButtonText = this.i18nService.getString("Common", "vns.switchToBasic");
            }
            // TODO speev: Is this vmName variable used?
            this.vmName = this.migrationWizardManager.getVmName();
            this.compatibilityMessages = this.vmMigrateSelectNetworkService.getCompatibilityMessages();
            if (!this.pageModel.getSelectNetworkPageIsInitialized()) {
                this.pageModel.setBasicCompatibilityResultsCache(null);
                this.pageModel.setAdvancedCompatibilityResultsCache(null);
                this.pageModel.isBasicPageValid = false;
                this.pageModel.isAdvancedPageValid = false;
                this.requestData(this.migrationWizardManager.getVmIds());
            }
            else {
                this.onDataRequested();
                this.vmMigrateSelectNetworkService.buildBasicData();
                this.vmMigrateSelectNetworkService.buildAdvancedData();
                this.vmMigrateSelectNetworkService.checkCompatibility();
            }
        };
        MigrateSelectNetworkPageComponentController.prototype.onDataRequested = function () {
            this.pageReady = true;
            this.basicViewData = this.vmMigrateSelectNetworkService.getBasicViewData();
            this.advancedViewData = this.vmMigrateSelectNetworkService.getAdvancedViewData();
            this.prefetchedNetworksBasic = this.vmMigrateSelectNetworkService.
                getPrefetchedNetworks().basic;
            this.prefetchedNetworksAdvanced = this.vmMigrateSelectNetworkService.
                getPrefetchedNetworks().advanced;
        };
        MigrateSelectNetworkPageComponentController.prototype.onAndvancedButtonClick = function () {
            if (this.pageModel.getSelectNetworkPageViewMode() ===
                this.networkPageViewModes.ADVANCED) {
                this.pageModel.setSelectNetworkPageViewMode(this.networkPageViewModes.BASIC);
                this.selectNetworkGridDescription = this.i18nService.getString("Common", "vns.basic.description");
                this.advancedButtonText = this.i18nService.getString("Common", "vns.switchToAdvanced");
            }
            else {
                this.pageModel.setSelectNetworkPageViewMode(this.networkPageViewModes.ADVANCED);
                this.selectNetworkGridDescription = this.i18nService.getString("Common", "vns.advanced.description");
                this.advancedButtonText = this.i18nService.getString("Common", "vns.switchToBasic");
            }
            this.vmMigrateSelectNetworkService.syncNetworkMatches();
            this.vmMigrateSelectNetworkService.checkCompatibility();
        };
        MigrateSelectNetworkPageComponentController.$inject = [
            "$scope",
            "i18nService",
            "vmMigrateSelectNetworkService",
            "NetworkPageViewModes",
            "defaultUriSchemeUtil",
            "zoneDigestPatchService"
        ];
        return MigrateSelectNetworkPageComponentController;
    }());
    h5_vm.MigrateSelectNetworkPageComponentController = MigrateSelectNetworkPageComponentController; // class
    angular.module("com.vmware.vsphere.client.vm").component("migrateSelectNetworkPageComponent", new MigrateSelectNetworkPageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateSelectNetworkPageModel = (function () {
        function MigrateSelectNetworkPageModel() {
            /**
             * [page specific]
             *
             * Indicates if the compatibility checks of the basic view have passed successfully
             */
            this.isBasicPageValid = false;
            /**
             * [page specific]
             *
             * Indicates if the compatibility checks of the advanced view have passed successfully
             */
            this.isAdvancedPageValid = false;
            this.state = {
                selectNetworkPage: {
                    computeResourceUrn: "",
                    viewModeState: undefined,
                    isViewChanged: false,
                    basicViewMatches: [],
                    advancedViewMatches: [],
                    isInitialized: false,
                    isValidating: false,
                    basicCompatibilityResultsCache: null,
                    advancedCompatibilityResultsCache: null,
                    viewData: {},
                    prefetchedNetworks: {
                        basic: [],
                        advanced: [],
                        totalMatchesCount: 0
                    }
                }
            };
        }
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPageViewMode = function () {
            return this.state.selectNetworkPage.viewModeState ||
                this.initialViewMode ||
                "basic";
        };
        MigrateSelectNetworkPageModel.prototype.setSelectNetworkPageViewMode = function (viewState) {
            this.state.selectNetworkPage.viewModeState = viewState;
        };
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPageIsViewChanged = function () {
            return this.state.selectNetworkPage.isViewChanged;
        };
        MigrateSelectNetworkPageModel.prototype.setSelectNetworkPageIsViewChanged = function (value) {
            this.state.selectNetworkPage.isViewChanged = value;
        };
        MigrateSelectNetworkPageModel.prototype.getBasicNetworkMatches = function () {
            return this.state.selectNetworkPage.basicViewMatches;
        };
        MigrateSelectNetworkPageModel.prototype.setBasicNetworkMatches = function (values) {
            this.state.selectNetworkPage.basicViewMatches = values;
        };
        MigrateSelectNetworkPageModel.prototype.getAdvancedNetworkMatches = function () {
            return this.state.selectNetworkPage.advancedViewMatches;
        };
        MigrateSelectNetworkPageModel.prototype.setAdvancedNetworkMatches = function (values) {
            this.state.selectNetworkPage.advancedViewMatches = values;
        };
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPageIsInitialized = function () {
            return this.state.selectNetworkPage.isInitialized;
        };
        MigrateSelectNetworkPageModel.prototype.setSelectNetworkPageIsInitialized = function (value) {
            this.state.selectNetworkPage.isInitialized = !!value;
        };
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPageIsValidating = function () {
            return this.state.selectNetworkPage.isValidating;
        };
        MigrateSelectNetworkPageModel.prototype.setSelectNetworkPageIsValidating = function (value) {
            this.state.selectNetworkPage.isValidating = !!value;
        };
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPageViewData = function () {
            return this.state.selectNetworkPage.viewData;
        };
        MigrateSelectNetworkPageModel.prototype.getSelectNetworkPagePrefechedNetworks = function () {
            return this.state.selectNetworkPage.prefetchedNetworks;
        };
        MigrateSelectNetworkPageModel.prototype.getBasicCompatibilityResultsCache = function () {
            return this.state.selectNetworkPage.basicCompatibilityResultsCache;
        };
        MigrateSelectNetworkPageModel.prototype.setBasicCompatibilityResultsCache = function (value) {
            this.state.selectNetworkPage.basicCompatibilityResultsCache = value;
        };
        MigrateSelectNetworkPageModel.prototype.getAdvancedCompatibilityResultsCache = function () {
            return this.state.selectNetworkPage.advancedCompatibilityResultsCache;
        };
        MigrateSelectNetworkPageModel.prototype.setAdvancedCompatibilityResultsCache = function (value) {
            this.state.selectNetworkPage.advancedCompatibilityResultsCache = value;
        };
        MigrateSelectNetworkPageModel.prototype.getComputeResourceUrn = function () {
            return this.state.selectNetworkPage.computeResourceUrn;
        };
        MigrateSelectNetworkPageModel.prototype.setComputeResourceUrn = function (computeResourceUrn) {
            this.state.selectNetworkPage.computeResourceUrn = computeResourceUrn;
        };
        MigrateSelectNetworkPageModel.prototype.checkResourceAndReset = function (urn) {
            if (urn === this.getComputeResourceUrn()) {
                return;
            }
            this.reset();
            this.setComputeResourceUrn(urn);
        };
        MigrateSelectNetworkPageModel.prototype.reset = function () {
            this.state.selectNetworkPage.isInitialized = false;
        };
        return MigrateSelectNetworkPageModel;
    }());
    h5_vm.MigrateSelectNetworkPageModel = MigrateSelectNetworkPageModel; // class MigrateSelectNetworkPageModel
    var migrateSelectNetworkPageModelService = function () {
        return MigrateSelectNetworkPageModel;
    };
    angular.module("com.vmware.vsphere.client.vm")
        .service("MigrateSelectNetworkPageModel", migrateSelectNetworkPageModelService);
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2017 Vmware, Inc. All rights reserved. -- Vmware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateSelectStoragePageComponent = (function () {
        function MigrateSelectStoragePageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectStoragePageComponent.html";
            this.controller = MigrateSelectStoragePageComponentController;
            this.bindings = {
                migrationWizardManager: "<",
                wizardConfig: "<",
                pageModel: "<",
                destinationTarget: "<"
            };
        }
        return MigrateSelectStoragePageComponent;
    }());
    h5_vm.MigrateSelectStoragePageComponent = MigrateSelectStoragePageComponent;
    var MigrateSelectStoragePageComponentController = (function () {
        function MigrateSelectStoragePageComponentController(i18nService, defaultUriSchemeUtil, vmMigrateStorageSelectionValidationService, managedEntityConstants, storageSelectorService, storageSelectorConstants, dataService, $q, $element, $timeout, vmMigrateStorageLocatorService, wizardPageService, initialStorageConfigurationService, storageProfileService, pmemUtilService) {
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vmMigrateStorageSelectionValidationService = vmMigrateStorageSelectionValidationService;
            this.managedEntityConstants = managedEntityConstants;
            this.storageSelectorService = storageSelectorService;
            this.storageSelectorConstants = storageSelectorConstants;
            this.dataService = dataService;
            this.$q = $q;
            this.$element = $element;
            this.$timeout = $timeout;
            this.vmMigrateStorageLocatorService = vmMigrateStorageLocatorService;
            this.wizardPageService = wizardPageService;
            this.initialStorageConfigurationService = initialStorageConfigurationService;
            this.storageProfileService = storageProfileService;
            this.pmemUtilService = pmemUtilService;
            this.VM_HOME_DATASTORE_PROP = "vmHomeDatastore";
            this.VM_HOST_PROP = "host";
            this.VM_DEVICE_PROP = "devices";
            this.ADVANCED_PAGE_DATA_PROPERTY = "migrateAdvancedStoragePageData";
            this.compatibilityTitle = this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.Compatibility");
            this.disableStoragePods = this.migrationWizardManager.isXvcMigration()
                || this.migrationWizardManager.isXvMotion();
        }
        MigrateSelectStoragePageComponentController.prototype.$onInit = function () {
            var _this = this;
            var isAlreadyInitialized = this.initStorageSelectorState();
            this.modeSettings = this.storageSelectorService.getStorageSelectorModeSettings(true);
            this.storageSelectorApi = this.storageSelectorService.getStorageSelectorApiObj();
            this.diskFormatSettings = {
                diskFormatSupported: true,
                sameAsSourceSupported: true,
                thickDiskFormatSupported: true
            };
            this.setLoading(true);
            this.requestData().then(function (storageSelectorData /*common_ui.StorageSelectorData*/) {
                var isInitSelectedStorageItemPerformed = (!isAlreadyInitialized) &&
                    _this.initialStorageConfigurationService.initSelectedStorageItems(_this.storageSelectorState, storageSelectorData, _this.pageModel);
                if (!isInitSelectedStorageItemPerformed) {
                    _this.initSelectedStorageItem(isAlreadyInitialized ? _this.storageSelectorState : undefined, storageSelectorData);
                }
                if (_this.pageModel.initialVmStorageConfig) {
                    _this.initialStorageConfigurationService.computeSourceVmStorageConfig(_this.pageModel.initialVmStorageConfig, storageSelectorData.storageProfilesData._storageProfiles, storageSelectorData, false);
                }
                _this.storageSelectorData = storageSelectorData;
            }).finally(function () {
                _this.setLoading(false);
                _this.$timeout(function () {
                    var firstInput = _this.$element[0].querySelector(".migrate-storage-selector input[type=checkbox]");
                    if (firstInput) {
                        firstInput.focus();
                    }
                }, 0);
            });
        };
        MigrateSelectStoragePageComponentController.prototype.setLoading = function (loading) {
            this.wizardConfig.loading = loading;
        };
        MigrateSelectStoragePageComponentController.prototype.clearMessages = function () {
            this.wizardPageService.clearErrors(this.wizardConfig);
        };
        MigrateSelectStoragePageComponentController.prototype.setWarningMessages = function (messages) {
            this.wizardPageService.showWarningMessages(this.wizardConfig, messages);
        };
        ;
        MigrateSelectStoragePageComponentController.prototype.onSelectionChanged = function () {
            // Ignore selection change notifications, while the selection is not yet complete.
            if (this.isSelectionIncomplete() ||
                this.storageSelectorApi.validateReplicationGroupSelection()) {
                this.pageModel.virtualDisksByVm = {};
                this.compatibilityMessages = [];
                var errorMessage = this.storageSelectorApi.validateReplicationGroupSelection();
                if (errorMessage) {
                    this.compatibilityMessages = [{
                            contents: [],
                            icon: "vsphere-icon-status-error",
                            message: errorMessage,
                            advancedCompatibilityContents: {}
                        }];
                }
                return;
            }
            if (this.isSelectorChanged()) {
                this.validateSelection();
            }
            else {
                this.onSkipValidation();
            }
        };
        MigrateSelectStoragePageComponentController.prototype.validateSelection = function () {
            var _this = this;
            this.pageModel.isValidating = true;
            this.clearMessages();
            // NOTE: The storage selector control always sends info for all VMs and for
            // all disks (as if always the advanced mode was used)
            var virtualDisksByVm = this.getVirtualDisksByVmSelections();
            var validationModel = new h5_vm.MigrationWizardDataModel(this.pageModel.vms);
            validationModel.virtualDisksByVm = virtualDisksByVm;
            validationModel.computeResource = this.pageModel.computeResource;
            validationModel.pool = this.pageModel.pool;
            this.vmMigrateStorageSelectionValidationService.validateSelection(validationModel)
                .then(function (response) {
                _this.compatibilityMessages = response.compatibilityMessages;
                _this.pageModel.isAdvancedStorageMode = _this.storageSelectorState.mode === "advancedMode";
                _this.pageModel.virtualDisksByVm = response.hasSuccess ? virtualDisksByVm : {};
                if (_this.pageModel.isAdvancedStorageMode) {
                    _this.pageModel.lastCompatibilityMessagesAdvancedMode = response.compatibilityMessages;
                    _this.pageModel.lastSelectedStorageAdvancedMode = validationModel.virtualDisksByVm;
                }
                else {
                    _this.pageModel.lastCompatibilityMessagesBasicMode = response.compatibilityMessages;
                    _this.pageModel.lastSelectedStorageBasicMode = validationModel.virtualDisksByVm;
                    if (!_this.pageModel.lastCompatibilityMessagesAdvancedMode) {
                        _this.pageModel.lastCompatibilityMessagesAdvancedMode = response.compatibilityMessages;
                    }
                }
            }).then(function () {
                _this.pageModel.isValidating = false;
            });
        };
        /**
         * @returns
         *    'true' if the selector state was ALREADY initialized and 'false' otherwise.
         *    The state will be always initialized after this call.
         */
        MigrateSelectStoragePageComponentController.prototype.initStorageSelectorState = function () {
            if (!this.pageModel.isComputeResourceChanged && this.pageModel.storageSelectorState) {
                this.storageSelectorState = this.pageModel.storageSelectorState;
                return true;
            }
            this.pageModel.storageSelectorState =
                this.storageSelectorService.getStorageSelectorState();
            this.storageSelectorState = this.pageModel.storageSelectorState;
            return false;
        };
        MigrateSelectStoragePageComponentController.prototype.requestData = function () {
            var _this = this;
            // Return the cached value (but only if the data it depends on is not changed)
            if (!this.pageModel.isComputeResourceChanged && this.pageModel.storageSelectorData) {
                return this.$q.when(this.pageModel.storageSelectorData);
            }
            this.pageModel.isComputeResourceChanged = false;
            this.pageModel.lastSelectedStorageAdvancedMode = [];
            this.pageModel.lastSelectedStorageBasicMode = [];
            var objectId = this.pageModel.computeResource ?
                this.pageModel.computeResource : this.pageModel.vms[0];
            return this.requestVmData(objectId).then(function (data) {
                // Once we have the vm home datastores and vm disks, we pass it to the
                // storage selector so that it can request on its own some piece of data.
                return _this.storageSelectorService.getStorageSelectorData(objectId, _this.requestStorageGridData(), !_this.pageModel.isXvcMigration, // includeKeepExistingPolicies
                data.vmData, data.storageProfilesData)
                    .then(function (storageSelectorData) {
                    // Cache the last retrieved data for faster page load next time.
                    _this.pageModel.storageSelectorData = storageSelectorData;
                    _this.pageModel.storageNameMap = _this.vmMigrateStorageLocatorService.
                        getStorageObjectNameMap(storageSelectorData.storageLocatorItemsData);
                    return storageSelectorData;
                });
            });
        };
        MigrateSelectStoragePageComponentController.prototype.requestVmData = function (objectId) {
            var _this = this;
            var vmPropertiesToRetrieve = [this.VM_DEVICE_PROP, this.VM_HOME_DATASTORE_PROP];
            var isChangeStorageOnlyWorkflow = this.migrationWizardManager.getSelectedMode() === "changeStorageOnly";
            if (isChangeStorageOnlyWorkflow) {
                vmPropertiesToRetrieve.push((this.VM_HOST_PROP));
            }
            var vcGuid = this.defaultUriSchemeUtil.getManagedObjectReference(objectId).serverGuid;
            var promises = {
                advancedStorageData: this.migrationWizardManager.getAdvancedStoragePageData(),
                profiles: this.storageProfileService.fetchStorageProfilesData(vcGuid, {
                    includeKeepExisting: !this.pageModel.isXvcMigration
                })
            };
            return this.$q.all(promises).then(function (results) {
                var advancedDataByVm = results.advancedStorageData;
                var vmData = [];
                var storageProfilesData = results.profiles;
                storageProfilesData.vmProfileAssignments = {};
                storageProfilesData.vmReplicationGroupAssignments = {};
                _this.pageModel.vmHomeDatastores = {};
                _this.pageModel.vmDisks = {};
                _this.pageModel.vmHosts = {};
                _.forEach(_this.pageModel.vms, function (vmId) {
                    if (!advancedDataByVm || !advancedDataByVm[vmId] || !advancedDataByVm[vmId][_this.ADVANCED_PAGE_DATA_PROPERTY]) {
                        return;
                    }
                    var advancedDataPerVm = advancedDataByVm[vmId][_this.ADVANCED_PAGE_DATA_PROPERTY];
                    var destinationHost = null;
                    _this.pageModel.vmHosts[vmId] = _this.defaultUriSchemeUtil.getVsphereObjectId(advancedDataPerVm.host);
                    if (isChangeStorageOnlyWorkflow) {
                        if (advancedDataPerVm.host) {
                            destinationHost = _this.pageModel.vmHosts[vmId];
                        }
                    }
                    else {
                        destinationHost = (_this.pageModel.computeResource &&
                            _this.defaultUriSchemeUtil.getEntityType(_this.pageModel.computeResource) === "HostSystem")
                            ? _this.pageModel.computeResource : null;
                    }
                    var virtualDisks = advancedDataPerVm.virtualDisks || [];
                    _this.pageModel.vmDisks[vmId] = virtualDisks;
                    var vmHomeDatastoreId = advancedDataPerVm.vmHomeDatastore
                        ? _this.defaultUriSchemeUtil.getVsphereObjectId(advancedDataPerVm.vmHomeDatastore)
                        : null;
                    _this.pageModel.vmHomeDatastores[vmId] = vmHomeDatastoreId;
                    storageProfilesData.vmProfileAssignments[vmId] =
                        advancedDataPerVm.storagePoliciesAssignments;
                    storageProfilesData.vmReplicationGroupAssignments[vmId] =
                        advancedDataPerVm.vmReplicationGroupAssignments;
                    // common_ui.StorageSelectorVmProperties
                    vmData.push({
                        id: vmId,
                        name: _this.migrationWizardManager.getVmNames()[vmId],
                        homeDatastore: vmHomeDatastoreId,
                        destinationHost: destinationHost,
                        disksData: virtualDisks
                    });
                });
                return {
                    vmData: vmData,
                    storageProfilesData: storageProfilesData
                };
            });
        };
        MigrateSelectStoragePageComponentController.prototype.requestStorageGridData = function () {
            // TODO speev: Make the mode part of the page model
            if (this.migrationWizardManager.getSelectedMode() === "changeStorageOnly") {
                return this.vmMigrateStorageLocatorService.getStorageLocatorData({
                    vms: this.pageModel.vms
                });
            }
            else {
                return this.vmMigrateStorageLocatorService.getStorageLocatorData({
                    vms: this.pageModel.vms,
                    resource: this.pageModel.computeResource
                });
            }
        };
        MigrateSelectStoragePageComponentController.prototype.initSelectedStorageItem = function (storageSelectorState, storageSelectorData /*StorageSelectorData*/) {
            if (storageSelectorState) {
                // Storage selector state already exists and is initialized => we do nothing.
                // It keeps the last user selection on itw own.
                return;
            }
            if (!storageSelectorData.initialConfig) {
                storageSelectorData.initialConfig = {};
            }
            var preselection = this.calculateSelectedStorageItem(storageSelectorData.storageLocatorItemsData, storageSelectorData.sourceVmStorageConfig);
            if (preselection.reason) {
                this.setWarningMessages([preselection.reason]);
            }
            storageSelectorData.initialConfig.selectedItemInBasicMode = preselection.item;
        };
        /**
         * @returns A tuple
         *   {
         *       item -> the storage item that should be selected.
         *       reason -> if 'item' is empty, then the 'reason' contains a string
         *          explaining why there is no item to be selected.
         *   }
         */
        MigrateSelectStoragePageComponentController.prototype.calculateSelectedStorageItem = function (storageLocatorItemsData, sourceVmStorageConfig) {
            var entityType;
            entityType = this.destinationTarget ?
                this.defaultUriSchemeUtil.getEntityType(this.destinationTarget) :
                undefined;
            if (entityType === this.managedEntityConstants.DATASTORE
                || entityType === this.managedEntityConstants.STORAGE_POD) {
                var foundEntity = void 0;
                switch (entityType) {
                    case this.managedEntityConstants.DATASTORE:
                        foundEntity = this.findStorageItem(storageLocatorItemsData.datastoreItems, this.destinationTarget);
                        break;
                    case this.managedEntityConstants.STORAGE_POD:
                        foundEntity = this.findStorageItem(storageLocatorItemsData.storagePodItems, this.destinationTarget);
                        foundEntity = foundEntity.drsEnabled ? foundEntity : undefined;
                        break;
                    default:
                        foundEntity = undefined;
                        break;
                }
                var reason = void 0;
                reason = !foundEntity ? this.i18nService.getString("VmUi", "MigrationWizard.storageListPage.warning.storageNotPrelected") : undefined;
                return {
                    item: foundEntity,
                    reason: reason
                };
            }
            var currentVmsStorage = this.collectCurrentVmsStorage(sourceVmStorageConfig);
            if (_.size(currentVmsStorage) === 1) {
                var currentStorageItem = this.findStorageItem(storageLocatorItemsData.datastoreItems, currentVmsStorage[0]);
                if (currentStorageItem) {
                    var storagePod = this.findStorageItem(storageLocatorItemsData.storagePodItems, this.defaultUriSchemeUtil.getVsphereObjectId(currentStorageItem.parentStoragePod));
                    if (storagePod && storagePod.drsEnabled) {
                        // NOTE: If we preselect the current storage pod of the VM,
                        // the validation will return an error
                        return {
                            item: undefined
                        };
                    }
                    return {
                        item: currentStorageItem
                    };
                }
            }
            return {
                item: this.getSingleDatastoreOrPod(storageLocatorItemsData)
            };
        };
        // NOTE speev: All the logic below tries to predict when a single item
        // will be visualized in the storage locator an if so - return it for
        // preselection.
        MigrateSelectStoragePageComponentController.prototype.getSingleDatastoreOrPod = function (storageLocatorItemsData) {
            var _this = this;
            var drsEnabledStoragePods = _.reduce(storageLocatorItemsData.storagePodItems, function (memo, spItem) {
                if (spItem.drsEnabled) {
                    memo[_this.defaultUriSchemeUtil.getVsphereObjectId(spItem.storageRef)] = spItem;
                }
                return memo;
            }, {});
            if (_.size(drsEnabledStoragePods) > 1) {
                return undefined;
            }
            var standaloneDatastores = _.filter(storageLocatorItemsData.datastoreItems, function (dsItem) {
                return !dsItem.parentStoragePod ||
                    !drsEnabledStoragePods[_this.defaultUriSchemeUtil.getVsphereObjectId(dsItem.parentStoragePod)];
            });
            if (_.isEmpty(drsEnabledStoragePods)) {
                if (_.size(standaloneDatastores) === 1) {
                    return standaloneDatastores[0];
                }
                return undefined;
            }
            // We have 1 storage pod here - so we have at least 1 item in the grid.
            if (_.isEmpty(standaloneDatastores)) {
                // A twisted way to take the first map value
                return _.find(drsEnabledStoragePods, function () { return true; });
            }
            // More than 1 item in the grid - no selection.
            return undefined;
        };
        MigrateSelectStoragePageComponentController.prototype.getVirtualDisksByVmSelections = function () {
            var _this = this;
            var virtualDisksByVm = {};
            _.each(this.storageSelectorData.vmStorageConfig, function (vmStorageConfig /*common_ui.VmStorageConfig*/) {
                var vmId = vmStorageConfig.vmId;
                if (!virtualDisksByVm[vmId]) {
                    virtualDisksByVm[vmId] = [];
                }
                var homeStorageConfig = vmStorageConfig.vmHome;
                if (!homeStorageConfig.storageObj) {
                    // The selection is not here yet?
                    return;
                }
                // Push one record for the vm config file
                virtualDisksByVm[vmId].push({
                    key: "_configFile",
                    label: homeStorageConfig.name,
                    storage: _this.defaultUriSchemeUtil.getVsphereObjectId(homeStorageConfig.storageObj.storageRef),
                    parentStoragePod: _this.defaultUriSchemeUtil.getVsphereObjectId(homeStorageConfig.storageObj.parentStoragePod),
                    profile: homeStorageConfig.storageProfile,
                    diskFormat: homeStorageConfig.diskFormat ? {
                        label: homeStorageConfig.diskFormat.name,
                        value: homeStorageConfig.diskFormat.type
                    } : undefined,
                    storageType: homeStorageConfig.storageObj.type,
                    replicationGroup: homeStorageConfig.replicationGroup
                });
                // And one record for each VM disk
                _.each(vmStorageConfig.vmDisks, function (diskStorageConfig /*common_ui.VmComponentStorageConfig*/) {
                    virtualDisksByVm[vmId].push({
                        key: diskStorageConfig.key,
                        label: diskStorageConfig.name,
                        storage: diskStorageConfig.storageObj ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageConfig.storageObj.storageRef) : undefined,
                        parentStoragePod: diskStorageConfig.storageObj ?
                            _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageConfig.storageObj.parentStoragePod) : undefined,
                        profile: diskStorageConfig.storageProfile,
                        diskFormat: diskStorageConfig.diskFormat ? {
                            label: diskStorageConfig.diskFormat.name,
                            value: diskStorageConfig.diskFormat.type
                        } : undefined,
                        storageType: diskStorageConfig.storageObj ?
                            diskStorageConfig.storageObj.type : undefined,
                        capacityInBytes: diskStorageConfig.capacityInBytes,
                        replicationGroup: diskStorageConfig.replicationGroup,
                        origin: _.findWhere(_this.pageModel.vmDisks[vmId], { key: diskStorageConfig.key })
                    });
                });
            });
            return virtualDisksByVm;
        };
        MigrateSelectStoragePageComponentController.prototype.isSelectionIncomplete = function () {
            var _this = this;
            var result = _.some(this.storageSelectorData.vmStorageConfig, function (vmStorageConfig /*common_ui.VmStorageConfig*/) {
                // Check the VM home storage availability
                if (!vmStorageConfig.vmHome.storageObj) {
                    // The selection is not here yet
                    return true;
                }
                // If all disks should go to PMEM there is no need to validate that
                // they have a proper selection.
                if (_this.storageSelectorState.storageBaselineId ===
                    _this.storageSelectorConstants.PMEM_STORAGE_BASELINE.id) {
                    return false;
                }
                // And then each disk storage availability
                return _.some(vmStorageConfig.vmDisks, function (diskStorageConfig) {
                    // If nothing is selected and the disk is not on a PMEM storage
                    // then selection is INCOMPLETE.
                    return !diskStorageConfig.storageObj
                        && !_this.pmemUtilService.isPMemStoragePolicy(diskStorageConfig.storageProfile);
                });
            });
            return result;
        };
        MigrateSelectStoragePageComponentController.prototype.collectCurrentVmsStorage = function (sourceVmStorageConfig /*VmStorageConfig[]*/) {
            var _this = this;
            var currentStoragesMap = {};
            _.each(sourceVmStorageConfig, function (vmStorageConfig /*VmComponentStorageConfig*/) {
                if (vmStorageConfig.vmHome.storageObj) {
                    var storageId = _this.defaultUriSchemeUtil.getVsphereObjectId(vmStorageConfig.vmHome.storageObj.storageRef);
                    currentStoragesMap[storageId] = true;
                }
                _.each(vmStorageConfig.vmDisks, function (diskStorageConfig /*VmComponentStorageConfig*/) {
                    if (diskStorageConfig.storageObj) {
                        var storageId = _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageConfig.storageObj.storageRef);
                        currentStoragesMap[storageId] = true;
                    }
                });
            });
            return _.keys(currentStoragesMap);
        };
        MigrateSelectStoragePageComponentController.prototype.findStorageItem = function (listOfStorageLocatorItems, storageId) {
            var _this = this;
            return _.find(listOfStorageLocatorItems, function (item) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(item.storageRef) === storageId;
            });
        };
        MigrateSelectStoragePageComponentController.prototype.isSelectorChanged = function () {
            if (this.pageModel.isComputeResourceChanged) {
                return true;
            }
            var virtualDisksByVm = this.getVirtualDisksByVmSelections();
            this.pageModel.isAdvancedStorageMode =
                (this.storageSelectorState.mode === "advancedMode");
            var key = this.pageModel.isAdvancedStorageMode
                ? "lastSelectedStorageAdvancedMode" : "lastSelectedStorageBasicMode";
            var pageModel = this.pageModel;
            if (angular.equals(virtualDisksByVm, pageModel[key])) {
                return false;
            }
            pageModel[key] = virtualDisksByVm;
            return true;
        };
        MigrateSelectStoragePageComponentController.prototype.onSkipValidation = function () {
            if (this.pageModel.isAdvancedStorageMode) {
                this.compatibilityMessages = this.pageModel.lastCompatibilityMessagesAdvancedMode;
            }
            else {
                this.compatibilityMessages = this.pageModel.lastCompatibilityMessagesBasicMode;
            }
            this.pageModel.virtualDisksByVm = this.getVirtualDisksByVmSelections();
        };
        MigrateSelectStoragePageComponentController.$inject = [
            "i18nService",
            "defaultUriSchemeUtil",
            "vmMigrateStorageSelectionValidationService",
            "managedEntityConstants",
            "storageSelectorService",
            "storageSelectorConstants",
            "dataService",
            "$q",
            "$element",
            "$timeout",
            "vmMigrateStorageLocatorService",
            "wizardPageService",
            "initialStorageConfigurationService",
            "storageProfileService",
            "pmemUtilService"
        ];
        return MigrateSelectStoragePageComponentController;
    }());
    h5_vm.MigrateSelectStoragePageComponentController = MigrateSelectStoragePageComponentController; // class MigrateSelectStoragePageComponentController
    angular.module("com.vmware.vsphere.client.vm").component("migrateSelectStoragePageComponent", new MigrateSelectStoragePageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var MigrateSelectStoragePageModel = (function () {
        function MigrateSelectStoragePageModel() {
            /**
             * [input]
             *
             * Flag indicating whether the input property has changed.
             */
            this.isComputeResourceChanged = false;
            /**
             * [input]
             *
             * The array of VMs that will be migrated.
             */
            this.vms = [];
            /**
             * [output]
             *
             * Whether basic or advanced mode of the page is active.
             */
            this.isAdvancedStorageMode = false;
            /**
             * [output]
             *
             * Information per each virtual disk as specified by the user.
             * The VMX files is also included as a special disk with key: '_configFile'.
             */
            this.virtualDisksByVm = {};
            this.isValidating = false;
        }
        return MigrateSelectStoragePageModel;
    }());
    h5_vm.MigrateSelectStoragePageModel = MigrateSelectStoragePageModel; // class
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectComputeResourcePageComponent = (function () {
        function SelectComputeResourcePageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/selectComputeResourcePageComponent.html";
            this.controller = SelectComputeResourcePageController;
            this.controllerAs = "ctrl";
            this.bindings = {
                migrationWizardManager: "<",
                wizardConfig: "<",
                pageModel: "<",
                destinationTarget: "<"
            };
        }
        return SelectComputeResourcePageComponent;
    }());
    h5_vm.SelectComputeResourcePageComponent = SelectComputeResourcePageComponent;
    var SelectComputeResourcePageController = (function () {
        function SelectComputeResourcePageController($q, $element, $timeout, $scope, dataService, i18nService, defaultUriSchemeUtil, compatibilityResultsPresenter, managedEntityConstants, vuiConstants, wizardPageService, vmMigrateStretchedStorageService) {
            this.$q = $q;
            this.$element = $element;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.dataService = dataService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.managedEntityConstants = managedEntityConstants;
            this.vuiConstants = vuiConstants;
            this.wizardPageService = wizardPageService;
            this.vmMigrateStretchedStorageService = vmMigrateStretchedStorageService;
        }
        SelectComputeResourcePageController.prototype.$onInit = function () {
            this.compatibilityTitle = this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.compatibility");
            this.pageModel = this.migrationWizardManager.computeResourcePageModel;
            this.initializeObjectSelector();
            if (!this.pageModel.stretchedStorageService) {
                this.pageModel.stretchedStorageService =
                    this.vmMigrateStretchedStorageService.newInstance();
            }
        };
        SelectComputeResourcePageController.prototype.initializeObjectSelector = function () {
            var _this = this;
            var hostsListConfig = {
                label: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.hosts"),
                listViewId: "vsphere.core.host.list",
                dataModels: ["HostSystem"],
                filterId: "vmMigrationHostFilter",
                filterParams: this.pageModel.vms,
                useLazyInstantiation: true
            };
            var clusterListConfig = {
                label: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.clusters"),
                listViewId: "vsphere.core.cluster.list",
                dataModels: ["ClusterComputeResource"],
                filterId: "vmMigrationClusterFilter",
                filterParams: this.pageModel.vms,
                useLazyInstantiation: true
            };
            var resourcePoolsListConfig = {
                label: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.resourcePools"),
                listViewId: "vsphere.core.resourcePool.list",
                dataModels: ["ResourcePool"],
                filterId: "vmMigrationResourcePoolFilter",
                filterParams: this.pageModel.vms,
                useLazyInstantiation: true
            };
            var vAppsListConfig = {
                label: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.vapps"),
                listViewId: "vsphere.core.vApp.list",
                dataModels: ["VirtualApp"],
                filterId: "vmMigrationVirtualAppFilter",
                filterParams: this.pageModel.vms,
                useLazyInstantiation: true
            };
            // We have a user preselection in place - override other preselection targets
            var preselectedId = this.migrationWizardManager.getDestinationComputeResourceUid();
            preselectedId = preselectedId ||
                this.pageModel.initialComputeResource ||
                this.destinationTarget;
            this.objSelectorConf = {
                contextObject: this.pageModel.vms[0],
                multipleSelect: false,
                listTabConfig: {
                    selectedTabIndex: this.calculateInitialTab(preselectedId),
                    listConfig: [hostsListConfig, clusterListConfig, resourcePoolsListConfig,
                        vAppsListConfig]
                },
                tabStyle: this.vuiConstants.tabs.style.PILLS,
                selectedObjects: this.calculateSelectedObjects(preselectedId),
                onSelectionChanged: function (newItems) {
                    _this.onSelectionChanged(newItems);
                }
            };
            this.$timeout(function () {
                var firstInput = _this.$element[0].querySelector(".vm-migrate-compute-resource button.active");
                if (firstInput) {
                    firstInput.focus();
                }
            }, 0);
        };
        SelectComputeResourcePageController.prototype.onSelectionChanged = function (newItems) {
            var _this = this;
            if (!newItems || newItems.length === 0) {
                return;
            }
            var item = newItems[0]; // the obj selector has single selection
            if (!item) {
                return;
            }
            if (item.id === this.pageModel.computeResource && this.pageModel.compatibilityResultsCache) {
                this.compatibilityContents = this.pageModel.compatibilityResultsCache;
                return;
            }
            this.pageModel.isValidating = true;
            // Processing the selected object and the stretched storage are independend and
            // can be done in parallel. Processing the stretched storage in practise takes
            // less time than processing the selected object which does thorough validation.
            var processSelection = this.$q.all({
                selectedObject: this.processSelectedObject(item),
                stretchedStorage: this.pageModel.stretchedStorageService
                    .processStretchedStorage(item.id, this.pageModel.vms),
                targetDatacenter: this.dataService.getProperties(item.id, ["dc"])
            });
            processSelection.then(function (result) {
                _this.pageModel.stretchedStorage = result["stretchedStorage"];
                _this.pageModel.datacenter = _this.defaultUriSchemeUtil.getVsphereObjectId(result["targetDatacenter"]["dc"]);
                _this.pageModel.isValidating = false;
            });
        };
        SelectComputeResourcePageController.prototype.processSelectedObject = function (item) {
            var _this = this;
            return this.migrationWizardManager.changeComputeResource(item)
                .then(function (compatibilityResult) {
                if (compatibilityResult.isValid) {
                    _this.pageModel.computeResource = item.id;
                }
                else {
                    _this.pageModel.computeResource = undefined;
                }
                return _this.compatibilityResultsPresenter.formatValidationResults(compatibilityResult.validationResults, true /*includeSuccessContent*/);
            })
                .then(function (contents) {
                _this.compatibilityContents = contents;
                _this.pageModel.compatibilityResultsCache = contents;
                if (_this.migrationWizardManager.getIsComputeResourceChanged()) {
                    var pageTitle = _this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.title");
                    _this.wizardPageService.invalidateNextPages(_this.wizardConfig, _this.migrationWizardManager.getSelectedMode(), pageTitle);
                }
            });
        };
        SelectComputeResourcePageController.prototype.calculateSelectedObjects = function (destinationTargetId) {
            if (!destinationTargetId) {
                return [];
            }
            return [destinationTargetId];
        };
        SelectComputeResourcePageController.prototype.calculateInitialTab = function (destinationTargetId) {
            if (!destinationTargetId) {
                return 0;
            }
            var destinationTargetType = this.defaultUriSchemeUtil.getEntityType(destinationTargetId);
            switch (destinationTargetType) {
                case this.managedEntityConstants.CLUSTER:
                    return 1;
                case this.managedEntityConstants.RESOURCE_POOL:
                    return 2;
                case this.managedEntityConstants.V_APP:
                    return 3;
                case this.managedEntityConstants.HOST:
                    return 0;
                default:
                    return 0;
            }
        };
        SelectComputeResourcePageController.prototype.equalReferences = function (ref1, ref2) {
            return (ref1.value === ref2.value) &&
                (ref1.type === ref2.type) &&
                (ref1.serverGuid === ref2.serverGuid);
        };
        SelectComputeResourcePageController.$inject = [
            "$q",
            "$element",
            "$timeout",
            "$scope",
            "dataService",
            "i18nService",
            "defaultUriSchemeUtil",
            "compatibilityResultsPresenter",
            "managedEntityConstants",
            "vuiConstants",
            "wizardPageService",
            "vmMigrateStretchedStorageService"
        ];
        return SelectComputeResourcePageController;
    }());
    h5_vm.SelectComputeResourcePageController = SelectComputeResourcePageController;
    angular.module("com.vmware.vsphere.client.vm").component("selectComputeResourcePageComponent", new SelectComputeResourcePageComponent());
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectComputeResourcePageModel = (function () {
        function SelectComputeResourcePageModel() {
            /**
             * [input]
             *
             * The VMs being migrated.
             */
            this.vms = [];
        }
        return SelectComputeResourcePageModel;
    }());
    h5_vm.SelectComputeResourcePageModel = SelectComputeResourcePageModel; // class
})(h5_vm || (h5_vm = {})); // module



var h5_vm;
(function (h5_vm) {
    var SelectComputeResourceTreePageComponent = (function () {
        function SelectComputeResourceTreePageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/selectComputeResourceTreePageComponent.html";
            this.controller = SelectComputeResourceTreePageComponentController;
            this.controllerAs = "ctrl";
            this.bindings = {
                wizardConfig: "<",
                migrationWizardManager: "<",
                pageModel: "<",
                destinationTarget: "<"
            };
        }
        return SelectComputeResourceTreePageComponent;
    }());
    h5_vm.SelectComputeResourceTreePageComponent = SelectComputeResourceTreePageComponent; // SelectComputeResourceTreePageComponent
    var SelectComputeResourceTreePageComponentController = (function () {
        function SelectComputeResourceTreePageComponentController($scope, defaultUriSchemeUtil, managedEntityConstants, migrationService, compatibilityResultsPresenter, i18nService, dataService, wizardPageService) {
            this.$scope = $scope;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.migrationService = migrationService;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.wizardPageService = wizardPageService;
            this.config = {
                preselectRoot: false
            };
            this.compatibilityTitle = this.i18nService.getString("VmUi", "SelectDatastoreProvisioningPage.Compatibility");
            this.treeLabel = this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.description");
        }
        SelectComputeResourceTreePageComponentController.prototype.$onInit = function () {
            this.rootObjectId = this.calculateRootObject();
            this.selectedObjectId = this.calculateSelectedObject();
            if (this.selectedObjectId) {
                this.wizardConfig.loading = true;
            }
        };
        SelectComputeResourceTreePageComponentController.prototype.onChange = function (objectId, objectName) {
            this.processSelectedObject(objectId, objectName);
        };
        SelectComputeResourceTreePageComponentController.prototype.onError = function () {
            this.wizardConfig.loading = false;
        };
        SelectComputeResourceTreePageComponentController.prototype.processSelectedObject = function (objectId, objectName) {
            var _this = this;
            this.wizardPageService.clearErrors(this.wizardConfig);
            this.pageModel.isValidating = true; // disable next button and add spinner in compatibility view
            this.migrationWizardManager.changeComputeResource({
                id: objectId,
                name: objectName })
                .then(function (result) {
                _this.compatibilityResultsPresenter.formatValidationResults(result.validationResults, true /*includeSuccessContent*/)
                    .then(function (contents) {
                    _this.compatibilityContents = contents;
                    if (_this.migrationWizardManager.getIsComputeResourceChanged()) {
                        var pageTitle = _this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.title");
                        _this.wizardPageService.invalidateNextPages(_this.wizardConfig, _this.migrationWizardManager.getSelectedMode(), pageTitle);
                    }
                    if (result.isValid) {
                        _this.pageModel.resource = objectId;
                        _this.getDatastore(objectId).then(function (dc) {
                            _this.pageModel.datacenter = dc;
                        });
                    }
                    else {
                        _this.pageModel.resource = undefined;
                        _this.pageModel.datacenter = undefined;
                    }
                })
                    .then(function () {
                    _this.pageModel.isValidating = false;
                });
            })
                .then(function () {
                _this.wizardConfig.loading = false;
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.getDatastore = function (selectedObjectId) {
            var _this = this;
            return this.dataService.getProperties(selectedObjectId, ["dc"])
                .then(function (result) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(result["dc"]);
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.calculateRootObject = function () {
            // It is essential here that the isXvcMigrationPossible comes precomputed,
            // as the Tree component does not allow for async computing here and setting
            // the root object after that
            if (!this.pageModel.isXvcMigrationPossible) {
                // NOTE speev: Right now we restrict the root object to the VC from which the
                // first VM comes from.
                var firstVmId = this.pageModel.vms[0];
                return this.defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(firstVmId);
            }
            return undefined;
        };
        SelectComputeResourceTreePageComponentController.prototype.calculateSelectedObject = function () {
            // We have a user preselection in place - override the destinationTarget
            var preselectedId = this.pageModel.resource || this.pageModel.initialResource;
            if (preselectedId) {
                return preselectedId;
            }
            var destinationTargetId = this.destinationTarget;
            if (destinationTargetId) {
                var destinationTargetType = this.defaultUriSchemeUtil.getEntityType(destinationTargetId);
                switch (destinationTargetType) {
                    case this.managedEntityConstants.CLUSTER:
                    case this.managedEntityConstants.RESOURCE_POOL:
                    case this.managedEntityConstants.V_APP:
                    case this.managedEntityConstants.HOST:
                        preselectedId = destinationTargetId;
                        break;
                    default:
                        break;
                }
            }
            return preselectedId;
        };
        SelectComputeResourceTreePageComponentController.$inject = [
            "$scope",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "migrationService",
            "compatibilityResultsPresenter",
            "i18nService",
            "dataService",
            "wizardPageService"
        ];
        return SelectComputeResourceTreePageComponentController;
    }()); // class SelectComputeResourceTreePageComponentController
    angular.module("com.vmware.vsphere.client.vm").component("selectComputeResourceTreePageComponent", new SelectComputeResourceTreePageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectComputeResourceTreePageModel = (function () {
        function SelectComputeResourceTreePageModel() {
            /**
             * [input]
             *
             * The VMs being migrated.
             */
            this.vms = [];
        }
        return SelectComputeResourceTreePageModel;
    }());
    h5_vm.SelectComputeResourceTreePageModel = SelectComputeResourceTreePageModel; // class
})(h5_vm || (h5_vm = {})); // module



var h5_vm;
(function (h5_vm) {
    var SelectMigrationTypePageComponent = (function () {
        function SelectMigrationTypePageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/selectMigrationTypePageComponent.html";
            this.controller = SelectComputeResourceTreePageComponentController;
            this.controllerAs = "ctrl";
            this.bindings = {
                hostRef: "<",
                attributes: "<",
                wizardConfig: "<",
                migrationWizardManager: "<",
                pageModel: "<",
                migrationType: "<",
                destinationTarget: "<"
            };
        }
        return SelectMigrationTypePageComponent;
    }());
    h5_vm.SelectMigrationTypePageComponent = SelectMigrationTypePageComponent; // SelectComputeResourceTreePageComponent
    var SelectComputeResourceTreePageComponentController = (function () {
        function SelectComputeResourceTreePageComponentController(migrationTypeConstants, wizardPageService, dataService, dataServiceUtil, defaultUriSchemeUtil, managedEntityConstants, i18nService, $element, $timeout) {
            this.migrationTypeConstants = migrationTypeConstants;
            this.wizardPageService = wizardPageService;
            this.dataService = dataService;
            this.dataServiceUtil = dataServiceUtil;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.i18nService = i18nService;
            this.$element = $element;
            this.$timeout = $timeout;
            this.flowAvailability = {};
            this.issues = {
                changeResource: [],
                changeStorage: [],
                changeResourceAndStorage: [],
            };
            this.i18n = i18nService.getString;
        }
        SelectComputeResourceTreePageComponentController.prototype.$onInit = function () {
            var _this = this;
            if (this.pageModel.cachedProperties) {
                this.onPropertiesReceived(this.pageModel.cachedProperties);
                this.checkXvcAvailability();
                return;
            }
            this.dataService.getPropertiesForObjects(this.pageModel.vms, ["vmMigrationOptions"]).then(function (properties) {
                _this.pageModel.cachedProperties = properties;
                _this.onPropertiesReceived(properties);
                _this.checkXvcAvailability();
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.onPropertiesReceived = function (properties) {
            var _this = this;
            this.processMigrationOptions(properties);
            this.selectedMigrationType = this.calculateMigrationType();
            this.onSelectionChanged();
            this.$timeout(function () {
                var firstInput = _this.$element[0].querySelector("#selectMigrationTypePage input[value=" + _this.selectedMigrationType + "]");
                if (firstInput) {
                    firstInput.focus();
                }
            }, 0);
        };
        SelectComputeResourceTreePageComponentController.prototype.onSelectionChanged = function () {
            this.wizardConfig.currentPage.decisionOptions.selectedFlowId = this.selectedMigrationType;
            this.attributes.creationType = this.selectedMigrationType;
            this.migrationWizardManager.setSelectedMode(this.selectedMigrationType);
            this.wizardPageService.initializeFlowStates(this.wizardConfig.flows);
        };
        SelectComputeResourceTreePageComponentController.prototype.areAllHostsCompatible = function (vms) {
            var _this = this;
            // All VMs should be on ESX version 6.0 or later.
            return this.dataServiceUtil.getPropertiesForObjectsByRelation(vms, "runtime.host", ["config.product.version"]).then(function (result) {
                return _.every(result, function (properties) {
                    return _this.isEsx6OrLater(properties["config.product.version"]);
                });
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.haveSameVcOrigin = function (vms) {
            var _this = this;
            var firstGuid = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(vms[0]).serverGuid;
            return _.every(vms, function (vm) {
                var currentGuid = _this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(vm).serverGuid;
                return currentGuid === firstGuid;
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.isEsx6OrLater = function (version) {
            if (version === null) {
                return false;
            }
            if ("e.x.p" === version) {
                return true;
            }
            var digits = version.split(".");
            return (digits.length > 0 && Number(digits[0]) > 5);
        };
        // We do the check here, to have it ready on init of the compute resource tree page
        SelectComputeResourceTreePageComponentController.prototype.checkXvcAvailability = function () {
            var _this = this;
            this.pageModel.isXvcMigrationPossible = true;
            // All VMs should be on the same VC
            var hasSameOrigin = this.haveSameVcOrigin(this.pageModel.vms);
            if (!hasSameOrigin) {
                this.pageModel.isXvcMigrationPossible = false;
                return;
            }
            // All VMs should be on ESX version 6.0 or later.
            this.areAllHostsCompatible(this.pageModel.vms).then(function (areCompatible) {
                if (!areCompatible) {
                    _this.pageModel.isXvcMigrationPossible = false;
                }
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.processMigrationOptions = function (properties) {
            var _this = this;
            this.flowAvailability.changeResourceOnly = true;
            this.flowAvailability.changeStorageOnly = true;
            this.flowAvailability.changeComputeResourceAndStorage = true;
            var reasons = {
                changeResource: [],
                changeStorage: [],
                changeResourceAndStorage: [],
            };
            // Collect the options available by ANDing the options for each VM
            // and collect the reasons for un-availability of an option.
            _.each(properties, function (singleVmProps) {
                if (!singleVmProps.vmMigrationOptions) {
                    return;
                }
                _.each(singleVmProps.vmMigrationOptions.migrationAvailabilityOptions, function (option) {
                    // Change compute resource only
                    _this.flowAvailability.changeResourceOnly =
                        _this.processOption("host", option, reasons.changeResource) && _this.flowAvailability.changeResourceOnly;
                    // Change storage only
                    _this.flowAvailability.changeStorageOnly =
                        _this.processOption("datastore", option, reasons.changeStorage) && _this.flowAvailability.changeStorageOnly;
                    // Change both compute resource and storage
                    _this.flowAvailability.changeComputeResourceAndStorage =
                        _this.processOption("hostAndDatastore", option, reasons.changeResourceAndStorage) && _this.flowAvailability.changeComputeResourceAndStorage;
                });
            });
            this.showReasons(reasons.changeResource, this.issues.changeResource);
            this.showReasons(reasons.changeStorage, this.issues.changeStorage);
            this.showReasons(reasons.changeResourceAndStorage, this.issues.changeResourceAndStorage);
        };
        SelectComputeResourceTreePageComponentController.prototype.processOption = function (migrationType, option, reasons) {
            var available = true;
            if (migrationType === option.type) {
                available = option.available;
                if (!available) {
                    _.each(option.reasons, function (reason) {
                        if (!_.contains(reasons, reason)) {
                            reasons.push(reason);
                        }
                    });
                }
            }
            return available;
        };
        SelectComputeResourceTreePageComponentController.prototype.showReasons = function (reasons, container) {
            var _this = this;
            _.each(reasons, function (reason) {
                container.push(_this.getReasonText(reason));
            });
        };
        SelectComputeResourceTreePageComponentController.prototype.getReasonText = function (reason) {
            switch (reason) {
                case "hostInMaintenance":
                    return this.i18n('VmUi', "MigrationWizard.migrationTypePage.issue.hostInMaintenance");
                case "smpFt":
                    return this.i18n('VmUi', "MigrationWizard.migrationTypePage.issue.smpFt");
                case "ftSecondary":
                    return this.i18n('VmUi', "MigrationWizard.migrationTypePage.issue.ftSecondary");
                case "ftPrimaryNotInCorrectState":
                    return this.i18n('VmUi', "MigrationWizard.migrationTypePage.issue.ftPrimaryNotIncorrectState");
                case "noPrivilege":
                    return this.i18n('VmUi', "MigrationWizard.migrationTypePage.issue.noPrivilege");
            }
        };
        SelectComputeResourceTreePageComponentController.prototype.calculateMigrationType = function () {
            // If the user already was on this page and picked something
            // Or if the wizard is loaded wit specified workflow (e.g from the Move To dialog)
            // We preselect it
            var preselectedType = this.migrationWizardManager.getSelectedMode();
            if (preselectedType && this.flowAvailability[preselectedType]) {
                return preselectedType;
            }
            // If we have a drag and drop target - we preselect the appropriate workflow
            if (this.destinationTarget) {
                var entityType = this.defaultUriSchemeUtil.getEntityType(this.destinationTarget);
                switch (entityType) {
                    case this.managedEntityConstants.DATASTORE:
                    case this.managedEntityConstants.STORAGE_POD:
                        // default target is a storage object - choose 'Change Storage' path.
                        if (this.flowAvailability.changeStorageOnly) {
                            return this.migrationTypeConstants.MIGRATE_STORAGE_ONLY;
                        }
                        break;
                    default:
                        if (this.flowAvailability.changeResourceOnly) {
                            return this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY;
                        }
                }
            }
            // No destination - let the default view choice, based on availability.
            if (this.flowAvailability.changeResourceOnly) {
                return this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY;
            }
            if (this.flowAvailability.changeStorageOnly) {
                return this.migrationTypeConstants.MIGRATE_STORAGE_ONLY;
            }
            if (this.flowAvailability.changeComputeResourceAndStorage) {
                return this.migrationTypeConstants.MIGRATE_RESOURCE_AND_STORAGE;
            }
            return this.migrationTypeConstants.MIGRATE_RESOURCE_ONLY;
        };
        SelectComputeResourceTreePageComponentController.$inject = [
            "migrationTypeConstants",
            "wizardPageService",
            "dataService",
            "dataServiceUtil",
            "defaultUriSchemeUtil",
            "managedEntityConstants",
            "i18nService",
            "$element",
            "$timeout"
        ];
        return SelectComputeResourceTreePageComponentController;
    }()); // class
    angular.module("com.vmware.vsphere.client.vm").component("selectMigrationTypePageComponent", new SelectMigrationTypePageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectMigrationTypePageModel = (function () {
        function SelectMigrationTypePageModel() {
            /**
             * [input]
             *
             * The VMs being migrated.
             */
            this.vms = [];
        }
        return SelectMigrationTypePageModel;
    }());
    h5_vm.SelectMigrationTypePageModel = SelectMigrationTypePageModel; // class
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectPriorityPageComponent = (function () {
        function SelectPriorityPageComponent() {
            this.templateUrl = "vm-ui/resources/vm/views/migrationWizard/pages/selectPriorityPageComponent.html";
            this.controller = SelectPriorityPageController;
            this.controllerAs = "ctrl";
            this.bindings = {
                migrationWizardManager: "<",
                pageModel: "<",
            };
        }
        return SelectPriorityPageComponent;
    }());
    h5_vm.SelectPriorityPageComponent = SelectPriorityPageComponent;
    var SelectPriorityPageController = (function () {
        function SelectPriorityPageController(i18nService, $element, $timeout) {
            this.i18nService = i18nService;
            this.$element = $element;
            this.$timeout = $timeout;
            this.i18n = i18nService.getString;
        }
        SelectPriorityPageController.prototype.$onInit = function () {
            var _this = this;
            if (!this.pageModel.priority) {
                // Initial value for the priority.
                this.pageModel.priority = this.pageModel.initialPriority || "highPriority";
            }
            this.$timeout(function () {
                var firstInput = _this.$element[0].querySelector("#selectPriorityPageComponent input[value=highPriority]");
                if (_this.pageModel.priority === "lowPriority") {
                    firstInput = _this.$element[0].querySelector("#selectPriorityPageComponent input[value=lowPriority]");
                }
                if (firstInput) {
                    firstInput.focus();
                }
            }, 0);
        };
        SelectPriorityPageController.$inject = [
            "i18nService",
            "$element",
            "$timeout"
        ];
        return SelectPriorityPageController;
    }());
    h5_vm.SelectPriorityPageController = SelectPriorityPageController; // class
    angular.module("com.vmware.vsphere.client.vm").component("selectPriorityPageComponent", new SelectPriorityPageComponent());
})(h5_vm || (h5_vm = {})); // namespace



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var SelectPriorityPageModel = (function () {
        function SelectPriorityPageModel() {
        }
        return SelectPriorityPageModel;
    }());
    h5_vm.SelectPriorityPageModel = SelectPriorityPageModel;
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').service('vmMigrationFinishPageService', [
   'i18nService',
   'wizardPageService',
   function(i18nService, wizardPageService) {
      return {
         build: function(wizardScope) {
            return {
               title: i18nService.getString('VmUi', 'MigrationWizard.readyPage.title'),
               description: i18nService.getString('VmUi', 'MigrationWizard.readyPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migrateFinishPage.html',
               headerUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html',

               onCommit: function() {

                  var finishPageState = wizardScope.migrationWizardManager.getFinishPageState();
                  if (finishPageState.recommendationService.hasFaults()) {
                     wizardPageService.markPageIncompleteWithError(
                           wizardScope.wizardConfig,
                           i18nService.getString('VmUi', 'MigrationWizard.readyPage.error.sdrsFaults')
                     );
                     return false;
                  }

                  if (finishPageState.xdrsRecommendationService
                        && finishPageState.xdrsRecommendationService.hasFaults()) {
                     var message = finishPageState.xdrsRecommendationService.getFaultsReason();
                     wizardPageService.markPageIncompleteWithError(
                           wizardScope.wizardConfig,
                           i18nService.getString('VmUi', 'MigrationWizard.readyPage.error.xdrs.drsFault',
                                 message)
                     );
                     return false;
                  }

                  if (hasInitErrors(finishPageState)) {
                     wizardPageService.markPageIncompleteWithError(
                           wizardScope.wizardConfig,
                           i18nService.getString('VmUi', 'MigrationWizard.readyPage.error.invalid')
                     );
                     return false;
                  }

                  wizardScope.migrationWizardManager.submit();
                  wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.migrationWizardManager.getSelectedMode());
                  return true;
               },

               finishReady: function () {
                  // If the page is loading ... disable the Finish button
                  return !wizardScope.wizardConfig.loading;
               }
            };

            function hasInitErrors(finishPageState) {
               if (finishPageState.xdrsRecommendationService) {
                  return finishPageState.xdrsRecommendationService.hasInitErrors();
               }

               return finishPageState.recommendationService
                     && finishPageState.recommendationService.hasInitErrors();
            }
         }
      };
   }]
);

angular.module('com.vmware.vsphere.client.vm').service('vmMigrationSelectComputeResourcePageService', [
   'i18nService',
   'vuiConstants',
   'wizardPageService',
   function(i18nService, vuiConstants, wizardPageService) {
      return {
         build: function(wizardScope) {
            return {
               title: i18nService.getString('VmUi', 'MigrationWizard.resourceListPage.title'),
               description: i18nService.getString('VmUi', 'MigrationWizard.resourceListPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/selectComputeResourcePage.html',
               headerUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html',
               disableNext: function() {
                  return wizardScope.migrationWizardManager.computeResourcePageModel.isValidating;
               },
               onCommit: function() {
                  if (!wizardScope.migrationWizardManager.hasValidComputeResourceSelected()) {
                     wizardPageService.markPageIncompleteWithError(
                           wizardScope.wizardConfig,
                           i18nService.getString('VmUi', 'MigrationWizard.resourceListPage.error.invalid')
                     );

                     return false;
                  }

                  wizardScope.wizardConfig.validationBanner.messages = [];
                  wizardPageService.markPageComplete(wizardScope.wizardConfig,
                        wizardScope.attributes.creationType);

                  return true;
               }
            };
         }
      };
   }
]);

var h5_vm;
(function (h5_vm) {
    /**
     * A 'builder' for the SelectComputeResourceTreePage.
     */
    var VmMigrationSelectComputeResourceTreePageService = (function () {
        function VmMigrationSelectComputeResourceTreePageService(i18nService, wizardPageService, vmCryptUtilService) {
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
            this.vmCryptUtilService = vmCryptUtilService;
        }
        VmMigrationSelectComputeResourceTreePageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.title"),
                description: this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.description"),
                contentUrl: "vm-ui/resources/vm/views/migrationWizard/pages/selectComputeResourceTreePage.html",
                headerUrl: "vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html",
                disableNext: function () {
                    return wizardScope.migrationWizardManager.computeResourceTreePageModel.isValidating ||
                        !wizardScope.migrationWizardManager.computeResourceTreePageModel.resource;
                },
                onCommit: function () {
                    return _this.onCommit(wizardScope);
                }
            };
        };
        VmMigrationSelectComputeResourceTreePageService.prototype.onCommit = function (wizardScope) {
            if (!wizardScope.migrationWizardManager.hasValidComputeResourceSelected()) {
                this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, this.i18nService.getString("VmUi", "MigrationWizard.resourceListPage.error.invalid"));
                return false;
            }
            this.vmCryptUtilService.isVmCryptPolicyDisabledForMigrateWizard(wizardScope.migrationWizardManager.computeResourceTreePageModel.resource, wizardScope.migrationWizardManager.storagePageModel);
            wizardScope.wizardConfig.validationBanner.messages = [];
            this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);
            return true;
        };
        VmMigrationSelectComputeResourceTreePageService.$inject = [
            "i18nService",
            "wizardPageService",
            "vmCryptUtilService",
        ];
        return VmMigrationSelectComputeResourceTreePageService;
    }());
    h5_vm.VmMigrationSelectComputeResourceTreePageService = VmMigrationSelectComputeResourceTreePageService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrationSelectComputeResourceTreePageService", VmMigrationSelectComputeResourceTreePageService);
})(h5_vm || (h5_vm = {})); // namespace



var h5_vm;
(function (h5_vm) {
    /**
     * A "builder" for the SelectFolderPageService.
     */
    var VmMigrationSelectFolderPageService = (function () {
        function VmMigrationSelectFolderPageService(i18nService, wizardPageService) {
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
        }
        VmMigrationSelectFolderPageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.Title"),
                description: this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.Description"),
                contentUrl: "vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectFolderPage.html",
                headerUrl: "vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html",
                disableNext: function () {
                    return wizardScope.migrationWizardManager.folderPageModel.isValidating ||
                        wizardScope.migrationWizardManager.folderPageModel.isLoading;
                },
                onCommit: function () {
                    return _this.onCommit(wizardScope);
                }
            };
        };
        VmMigrationSelectFolderPageService.prototype.onCommit = function (wizardScope) {
            if (!wizardScope.migrationWizardManager.hasValidFolderSelected()) {
                this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, this.i18nService.getString("VmUi", "MigrationWizard.selectFolderPage.error.invalid"));
                return false;
            }
            wizardScope.wizardConfig.validationBanner.messages = [];
            this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);
            return true;
        };
        VmMigrationSelectFolderPageService.$inject = [
            "i18nService",
            "wizardPageService"
        ];
        return VmMigrationSelectFolderPageService;
    }());
    h5_vm.VmMigrationSelectFolderPageService = VmMigrationSelectFolderPageService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrationSelectFolderPageService", VmMigrationSelectFolderPageService);
})(h5_vm || (h5_vm = {})); // namespace



angular.module('com.vmware.vsphere.client.vm').service(
      'vmMigrationSelectMigrationTypePageService', [
         'i18nService',
         'wizardPageService',
         'vmCryptUtilService',
         'migrationTypeConstants',
         function(i18nService, wizardPageService, vmCryptUtilService, migrationTypeConstants) {
            return {
               build: function(wizardScope, flowIds) {
                  return {
                     title: i18nService.getString('VmUi', 'MigrationWizard.migrationTypePage.heading'),
                     description: i18nService.getString('VmUi', 'MigrationWizard.migrationTypePage.description'),
                     contentUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/selectMigrationTypePage.html',
                     headerUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html',
                     hostData: wizardScope.attributes.hostData,
                     decisionOptions: {
                        flowIds: flowIds,
                        selectedFlowId: migrationTypeConstants.MIGRATE_RESOURCE_ONLY
                     },
                     disableNext: function() {
                        // The call to the VC is not yet resolved
                        return !wizardScope.migrationWizardManager.migrationTypePageModel.cachedProperties;
                     },
                     onCommit: function() {
                           wizardScope.wizardConfig.validationBanner.messages = [];
                           wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);

                           if (wizardScope.migrationWizardManager.getSelectedMode() === migrationTypeConstants.MIGRATE_STORAGE_ONLY) {
                              // Evaluate if the vm crypt storage profile is available for the
                              // selected vm or not
                              vmCryptUtilService.isVmCryptPolicyDisabledForMigrateWizard(
                                    // since the vms can not be from different vCenters we
                                    // can check get the vCenter of only one of them
                                    wizardScope.migrationWizardManager._theModel.vms[0],
                                    wizardScope.migrationWizardManager.storagePageModel);

                              // Reset the compute resource to clear it from the spec sent to the backend
                              // and to initialize correctly the page in the storage only flow
                              wizardScope.migrationWizardManager.clearSelectedComputeResource();
                           }
                           return true;
                     }
                  };
               }
            };
         }]
);

var h5_vm;
(function (h5_vm) {
    var VmMigrationSelectNetworkPageService = (function () {
        function VmMigrationSelectNetworkPageService(i18nService, wizardPageService, defaultUriSchemeUtil, dataServiceUtil, MigrateSelectNetworkPageModel, NetworkPageViewModes) {
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataServiceUtil = dataServiceUtil;
            this.MigrateSelectNetworkPageModel = MigrateSelectNetworkPageModel;
            this.NetworkPageViewModes = NetworkPageViewModes;
        }
        VmMigrationSelectNetworkPageService.prototype.build = function (wizardScope) {
            var _this = this;
            return {
                title: this.i18nService.getString("VmUi", "MigrationWizard.networkPage.title"),
                description: this.i18nService.getString("VmUi", "MigrationWizard.networkPage.description"),
                contentUrl: "vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectNetworkPage.html",
                headerUrl: "vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html",
                disableNext: function () {
                    return _this.disableNext(wizardScope);
                },
                onCommit: function () {
                    return _this.onCommit(wizardScope);
                }
            };
        };
        VmMigrationSelectNetworkPageService.prototype.disableNext = function (wizardScope) {
            var pageModel = wizardScope.migrationWizardManager.networkPageModel;
            return pageModel.getSelectNetworkPageIsValidating();
        };
        VmMigrationSelectNetworkPageService.prototype.onCommit = function (wizardScope) {
            var _this = this;
            var networkProps = {
                name: "name",
                key: "key",
                dvsUuid: "dvsUuid",
                opaqueNetworkType: "summary/opaqueNetworkType",
                opaqueNetworkId: "summary/opaqueNetworkId"
            };
            var pageModel = wizardScope.migrationWizardManager.networkPageModel;
            var viewMode = pageModel.getSelectNetworkPageViewMode();
            if (viewMode === this.NetworkPageViewModes.BASIC) {
                if (!this.hasValidDestinationNetwork(pageModel, pageModel.getBasicNetworkMatches())) {
                    this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, this.i18nService.getString("Common", "vns.error.matchingIncompleteBasic"));
                    return false;
                }
            }
            else {
                if (!this.hasValidDestinationNetwork(pageModel, pageModel.getAdvancedNetworkMatches())) {
                    this.wizardPageService.markPageIncompleteWithError(wizardScope.wizardConfig, this.i18nService.getString("Common", "vns.error.matchingIncompleteAdvanced"));
                    return false;
                }
            }
            wizardScope.wizardConfig.validationBanner.messages = [];
            this.wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);
            var networkMatches = wizardScope.migrationWizardManager.getNetworkMatches();
            var destinationNetworkIds = _.uniq(_.map(networkMatches, function (nwMatch) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(nwMatch.destinationNetwork);
            }));
            return this.dataServiceUtil.getPropertiesForObjects(destinationNetworkIds, [networkProps.name, networkProps.key, networkProps.dvsUuid,
                networkProps.opaqueNetworkType, networkProps.opaqueNetworkId])
                .then(function (result) { return _this.onNetworkPropertiesReturn(wizardScope, result); });
        };
        VmMigrationSelectNetworkPageService.prototype.onNetworkPropertiesReturn = function (wizardScope, result) {
            var _this = this;
            var networkMatches = wizardScope.migrationWizardManager.getNetworkMatches();
            _.forEach(networkMatches, function (nwMatch) {
                var networkId = _this.defaultUriSchemeUtil
                    .getVsphereObjectId(nwMatch.destinationNetwork);
                var networkData = result[networkId];
                if (networkData) {
                    nwMatch.destinationSwitchUuid = networkData.dvsUuid;
                    nwMatch.destinationNetworkName = networkData.name;
                    nwMatch.destinationPortgroupKey = networkData.key;
                    nwMatch.destinationOpaqueId = networkData["summary/opaqueNetworkId"];
                    nwMatch.destinationOpaqueType = networkData["summary/opaqueNetworkType"];
                }
            });
            return true;
        };
        VmMigrationSelectNetworkPageService.prototype.hasValidDestinationNetwork = function (pageModel, matches) {
            if (matches.length <= 0) {
                return true;
            }
            if (pageModel.getSelectNetworkPageViewMode() === this.NetworkPageViewModes.BASIC
                && !pageModel.isBasicPageValid) {
                return false;
            }
            else if (pageModel.getSelectNetworkPageViewMode() === this.NetworkPageViewModes.ADVANCED
                && !pageModel.isAdvancedPageValid) {
                return false;
            }
            var isValid = true;
            _.each(matches, function (match) {
                if (!match.destinationNetwork && match.sourceNetwork) {
                    isValid = false;
                }
            });
            return isValid;
        };
        VmMigrationSelectNetworkPageService.$inject = [
            "i18nService",
            "wizardPageService",
            "defaultUriSchemeUtil",
            "dataServiceUtil",
            "MigrateSelectNetworkPageModel",
            "NetworkPageViewModes",
        ];
        return VmMigrationSelectNetworkPageService;
    }());
    h5_vm.VmMigrationSelectNetworkPageService = VmMigrationSelectNetworkPageService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrationSelectNetworkPageService", VmMigrationSelectNetworkPageService);
})(h5_vm || (h5_vm = {})); // namespace



angular.module('com.vmware.vsphere.client.vm').service('vmMigrationSelectPriorityPageService', [
   'i18nService',
   'vuiConstants',
   'wizardPageService',
   function (i18nService, vuiConstants, wizardPageService) {
      return {
         build: function (wizardScope) {

            return {
               title: i18nService.getString('VmUi', 'MigrationWizard.priorityPage.title'),
               description: i18nService.getString('VmUi', 'MigrationWizard.priorityPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/selectPriorityPage.html',
               headerUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html',
               onCommit: function () {
                  wizardPageService.markPageComplete(wizardScope.wizardConfig, wizardScope.attributes.creationType);
                  return true;
               }
            };
         }
      };
   }]
);

angular.module('com.vmware.vsphere.client.vm').service('vmMigrationSelectStoragePageService', [
   'i18nService',
   'wizardPageService',
   function (i18nService, wizardPageService) {
      return {
         build: function (wizardScope) {
            return {
               title: i18nService.getString('VmUi', 'MigrationWizard.storageListPage.title'),
               description: i18nService.getString('VmUi', 'MigrationWizard.storageListPage.description'),
               contentUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migrateSelectStoragePage.html',
               headerUrl: 'vm-ui/resources/vm/views/migrationWizard/pages/migratePagesCustomHeader.html',
               disableNext: function() {
                  return wizardScope.migrationWizardManager.storagePageModel.isValidating;
               },
               onCommit: function() {
                  if (!wizardScope.migrationWizardManager.hasValidStorage()) {
                     wizardPageService.markPageIncompleteWithError(
                        wizardScope.wizardConfig,
                        i18nService.getString('VmUi', 'MigrationWizard.storageListPage.error.invalid')
                     );
                     return false;
                  }

                  // NOTE speev: Recommendation fetching happens at the last page
                  wizardScope.wizardConfig.validationBanner.messages = [];
                  wizardPageService.markPageComplete(
                        wizardScope.wizardConfig, wizardScope.attributes.creationType);
                  return true;
               }
            };
         }
      };
   }]
);

var h5_vm;
(function (h5_vm) {
    var MigrationHelperService = (function () {
        function MigrationHelperService(defaultUriSchemeUtil) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
        }
        MigrationHelperService.prototype.isXvcOperation = function (vmIds, resourceId) {
            return this.isXvcOperationByRef(vmIds, this.defaultUriSchemeUtil.getManagedObjectReference(resourceId));
        };
        MigrationHelperService.prototype.isXvcOperationByRef = function (vmIds, resourceRef) {
            var _this = this;
            if (!resourceRef || !resourceRef.serverGuid) {
                return false;
            }
            var destinationSeverId = resourceRef.serverGuid;
            var isXvc = _.some(vmIds, function (vmId) {
                var sourceServerId = _this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(vmId).serverGuid;
                return destinationSeverId !== sourceServerId;
            });
            return isXvc;
        };
        MigrationHelperService.$inject = [
            "defaultUriSchemeUtil"
        ];
        return MigrationHelperService;
    }());
    h5_vm.MigrationHelperService = MigrationHelperService; // class MigrationHelperService
    angular.module("com.vmware.vsphere.client.vm").service("migrationHelperService", MigrationHelperService);
})(h5_vm || (h5_vm = {})); // module



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmMigrateSelectNetworkService = (function () {
        function VmMigrateSelectNetworkService($q, i18nService, dataService, dataServiceUtil, defaultUriSchemeUtil, networkSelectorDialogService, migrationService, compatibilityResultsPresenter, managedEntityConstants, networkSelectorPrefetchingService, networkPageViewModes, migrationWizardManager, pageModel, validationLoadingHandlerFn) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.dataServiceUtil = dataServiceUtil;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.migrationService = migrationService;
            this.compatibilityResultsPresenter = compatibilityResultsPresenter;
            this.managedEntityConstants = managedEntityConstants;
            this.networkSelectorPrefetchingService = networkSelectorPrefetchingService;
            this.networkPageViewModes = networkPageViewModes;
            this.migrationWizardManager = migrationWizardManager;
            this.pageModel = pageModel;
            this.validationLoadingHandlerFn = validationLoadingHandlerFn;
            this.DESTINATION_NETWORKS_FOR_VMS = "destinationNetworksForMigrateVms";
            this.MAX_PREFETCHED_NETWORKS_COUNT = 10;
            this.migrationWizardManager = migrationWizardManager;
            this.prefetchedNetworksBasic = pageModel
                .getSelectNetworkPagePrefechedNetworks().basic;
            this.prefetchedNetworksAdvanced = pageModel
                .getSelectNetworkPagePrefechedNetworks().advanced;
            this.isAutoSelectionMessageAdded = false;
            this.isSelectionPerformed = false;
            this.basicViewData = [];
            this.advancedViewData = [];
            this.compatibilityMessages = [];
            this.pageModel = pageModel;
        }
        VmMigrateSelectNetworkService.prototype.getTotalPrefetchedNetworksCount = function () {
            return this.pageModel
                .getSelectNetworkPagePrefechedNetworks().totalMatchesCount;
        };
        VmMigrateSelectNetworkService.prototype.setTotalPrefetchedNetworksCount = function (count) {
            this.pageModel
                .getSelectNetworkPagePrefechedNetworks().totalMatchesCount = count;
        };
        VmMigrateSelectNetworkService.prototype.getNetworkMatches = function () {
            return this.migrationWizardManager.getNetworkMatches();
        };
        VmMigrateSelectNetworkService.prototype.initPrefetchedNetworks = function (prefetchedNetworks) {
            this.initPrefetchedNetwork(prefetchedNetworks, this.networkPageViewModes.BASIC);
            this.initPrefetchedNetwork(prefetchedNetworks, this.networkPageViewModes.ADVANCED);
        };
        VmMigrateSelectNetworkService.prototype.initPrefetchedNetwork = function (prefetchedNetworks, viewType) {
            var _this = this;
            var list = (viewType === this.networkPageViewModes.BASIC) ?
                this.prefetchedNetworksBasic : this.prefetchedNetworksAdvanced;
            list.length = 0;
            _.each(prefetchedNetworks, function (item) {
                list.push(item);
            });
            // NOTE: Additionally push the networks from the initialMatches as 'prefetched'
            _.each(this.pageModel.initialMatches, function (match) {
                var destinationNetworkId = _this.defaultUriSchemeUtil.getVsphereObjectId(match.destinationNetwork);
                if (_.find(list, function (el) { return el.id === destinationNetworkId; })) {
                    return;
                }
                list.push({
                    name: match.destinationNetworkName,
                    id: destinationNetworkId,
                    dvsUuid: match.destinationSwitchUuid,
                    opaqueNetworkType: match.destinationOpaqueType,
                    portgroupKey: match.destinationPortgroupKey
                });
            });
        };
        VmMigrateSelectNetworkService.prototype.getViewData = function () {
            return this.pageModel.getSelectNetworkPageViewData();
        };
        VmMigrateSelectNetworkService.prototype.getAdvancedNetworkMatches = function () {
            return this.pageModel.getAdvancedNetworkMatches();
        };
        VmMigrateSelectNetworkService.prototype.setAdvancedNetworkMatches = function (values) {
            this.updateWithInitialNetworkMatchesIfAvailable(values);
            this.pageModel.setAdvancedNetworkMatches(values);
        };
        VmMigrateSelectNetworkService.prototype.getBasicNetworkMatches = function () {
            return this.pageModel.getBasicNetworkMatches();
        };
        VmMigrateSelectNetworkService.prototype.setBasicNetworkMatches = function (values) {
            this.updateWithInitialNetworkMatchesIfAvailable(values);
            return this.pageModel.setBasicNetworkMatches(values);
        };
        VmMigrateSelectNetworkService.prototype.getPrefetchedNetworks = function () {
            return this.pageModel.getSelectNetworkPagePrefechedNetworks();
        };
        VmMigrateSelectNetworkService.prototype.getNetworkProviderId = function () {
            var networkProvider = this.migrationWizardManager.getDestinationHostRef();
            if (!networkProvider) {
                networkProvider = this.migrationWizardManager.getDestinationClusterRef();
            }
            // Use host as network provider if host was selected
            return this.defaultUriSchemeUtil.getVsphereObjectId(networkProvider);
        };
        VmMigrateSelectNetworkService.prototype.getBasicViewData = function () {
            return this.basicViewData;
        };
        VmMigrateSelectNetworkService.prototype.getAdvancedViewData = function () {
            return this.advancedViewData;
        };
        VmMigrateSelectNetworkService.prototype.getCompatibilityMessages = function () {
            return this.compatibilityMessages;
        };
        VmMigrateSelectNetworkService.prototype.addCompatibilityMessage = function (message) {
            this.compatibilityMessages.push(message);
        };
        VmMigrateSelectNetworkService.prototype.addCompatibilityMessages = function (messages) {
            if (!messages) {
                return;
            }
            for (var i = 0; i < messages.length; i++) {
                this.addCompatibilityMessage(messages[i]);
            }
        };
        VmMigrateSelectNetworkService.prototype.setCompatibilityMessage = function (message) {
            this.clearCompatibilityMessages();
            this.addCompatibilityMessage(message);
        };
        VmMigrateSelectNetworkService.prototype.setCompatibilityMessages = function (messages, isPageValid) {
            this.clearCompatibilityMessages();
            this.addCompatibilityMessages(messages);
            if (this.pageModel.getSelectNetworkPageViewMode() ===
                this.networkPageViewModes.BASIC) {
                this.pageModel.setBasicCompatibilityResultsCache(messages);
                this.pageModel.isBasicPageValid = isPageValid;
            }
            else {
                this.pageModel.setAdvancedCompatibilityResultsCache(messages);
                this.pageModel.isAdvancedPageValid = isPageValid;
            }
        };
        VmMigrateSelectNetworkService.prototype.clearCompatibilityMessages = function () {
            this.compatibilityMessages.length = 0;
        };
        VmMigrateSelectNetworkService.prototype.requestData = function (vmIds) {
            var _this = this;
            var skipCompatibilityCheck = false;
            return this.$q.all({
                vmNameByIds: this.dataService.getPropertiesForObjects(vmIds, ["name"]),
                networksByIds: this.dataServiceUtil.getPropertiesForObjectsByRelation(vmIds, "allNetwork", ["name"]),
                destinationNetworkMatches: this.dataService.getProperties(this.getNetworkProviderId(), [this.DESTINATION_NETWORKS_FOR_VMS], {
                    propertyParams: [{
                            propertyName: this.DESTINATION_NETWORKS_FOR_VMS,
                            parameterType: 
                            //NOT A TYPO
                            "[Lcom.vmware.vim.binding.vmodl.ManagedObjectReference;",
                            parameter: this.defaultUriSchemeUtil.getManagedObjectReferences(vmIds)
                        }]
                })
            }).then(function (values) {
                if (_.isEmpty(values.networksByIds)) {
                    skipCompatibilityCheck = true;
                    _this.setCompatibilityMessage({
                        icon: "vsphere-icon-status-warning",
                        message: _this.i18nService.getString("VmUi", "MigrationWizard.networkPage.warning.vmHasNoNetworks"),
                        contents: []
                    });
                }
                _.each(values.destinationNetworkMatches[_this.DESTINATION_NETWORKS_FOR_VMS], function (match) {
                    var urn = _this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceNetwork);
                    // values.networksByIds could be null when all the original VM networks
                    // are no longer available
                    match.sourceNetworkName = (values.networksByIds && values.networksByIds[urn]) ?
                        values.networksByIds[urn].name : null;
                });
                var result = {};
                result.prefetchedNetworksPromise = _this.prefetchNetworks(values)
                    .then(function (prefetchedNetworks) {
                    _this.initPrefetchedNetworks(prefetchedNetworks);
                });
                _this.addDataToViewModel(values);
                _this.buildBasicData();
                _this.buildAdvancedData();
                var networkMatches = (_this.pageModel.getSelectNetworkPageViewMode() ===
                    _this.networkPageViewModes.BASIC) ?
                    _this.getBasicNetworkMatches() : _this.getAdvancedNetworkMatches();
                _this.migrationWizardManager.setNetworkMatches(networkMatches);
                if (!skipCompatibilityCheck) {
                    skipCompatibilityCheck = _.some(networkMatches, function (match) {
                        return match.sourceNetwork && !match.destinationNetwork;
                    });
                }
                if (skipCompatibilityCheck) {
                    return result;
                }
                _this.checkCompatibility();
                return result;
            });
        };
        VmMigrateSelectNetworkService.prototype.prefetchNetworks = function (values) {
            var _this = this;
            var networkSelectorFilterSpec = this.networkSelectorDialogService.createNetworkSelectorFilterSpec(true /*includeStandardNetworks*/, true /*includeOpaqueNetworks*/, true /*includeDistributedPortGroups*/, false /*includeUplinkPortGroups*/, true /*includeOpaqueNetworkTypes*/);
            var destinationNetworksForVmsFiltered = _.filter(values.destinationNetworkMatches[this.DESTINATION_NETWORKS_FOR_VMS], function (item) {
                return item.destinationNetwork;
            });
            var availableNetworks = _.map(destinationNetworksForVmsFiltered, function (networkItem) {
                return networkItem.destinationNetwork;
            });
            var prefetchedNetworksCount = this.MAX_PREFETCHED_NETWORKS_COUNT;
            var additionalParams = {
                skipLoadingNotification: true
            };
            return this.networkSelectorPrefetchingService
                .prefetchNetworks(this.getNetworkProviderId(), networkSelectorFilterSpec, availableNetworks, prefetchedNetworksCount, additionalParams)
                .then(function (networksData) {
                _this.setTotalPrefetchedNetworksCount(networksData.networkMatchesCount);
                return networksData.recentNetworks;
            });
        };
        VmMigrateSelectNetworkService.prototype.addDataToViewModel = function (values) {
            this.getViewData().vmNamesById = this.dataServiceUtil.createPropertyByObjectMap(values.vmNameByIds, "name");
            this.getViewData().sourceNetworkNamesById = this.dataServiceUtil
                .createPropertyByObjectMap(values.networksByIds, "name");
            if (!this.pageModel.getSelectNetworkPageIsInitialized()) {
                this.setBasicNetworkMatches(angular.copy(values.destinationNetworkMatches[this.DESTINATION_NETWORKS_FOR_VMS]));
                this.setAdvancedNetworkMatches(angular.copy(values.destinationNetworkMatches[this.DESTINATION_NETWORKS_FOR_VMS]));
            }
            this.getViewData().networkSelector = {};
        };
        VmMigrateSelectNetworkService.prototype.networksMatchNetworkEquals = function (match, rowSourceNetwork) {
            var rowSourceNetworkId;
            if (angular.isObject(rowSourceNetwork)) {
                rowSourceNetworkId = this.defaultUriSchemeUtil.getVsphereObjectId(rowSourceNetwork);
            }
            else {
                rowSourceNetworkId = rowSourceNetwork;
            }
            var matchSourceNetworkId;
            if (angular.isObject(match)) {
                matchSourceNetworkId = this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceNetwork);
            }
            else {
                matchSourceNetworkId = match;
            }
            return matchSourceNetworkId === rowSourceNetworkId;
        };
        VmMigrateSelectNetworkService.prototype.networksMatchSourceAdapterEquals = function (match, row) {
            var matchVmUrn = this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceVm);
            var rowMatchVmUrn = this.defaultUriSchemeUtil.getVsphereObjectId(row.sourceVm);
            return (row.sourceAdapter.key === match.sourceAdapter.key) &&
                (matchVmUrn === rowMatchVmUrn);
        };
        VmMigrateSelectNetworkService.prototype.finderBasic = function (match, row) {
            var _this = this;
            if (!row.sourceNetworkId || !match.sourceNetwork) {
                var result_1 = false;
                _.each(row.adapterMatches, function (adapter) {
                    var currentFlag = _this.networksMatchSourceAdapterEquals(match, {
                        sourceVm: adapter.sourceVm,
                        sourceAdapter: { key: adapter.sourceAdapter.key }
                    });
                    if (currentFlag) {
                        result_1 = true;
                    }
                });
                return result_1;
            }
            else {
                return this.networksMatchNetworkEquals(match, row.sourceNetworkId);
            }
        };
        VmMigrateSelectNetworkService.prototype.finderAdvanced = function (match, row) {
            if (!row.sourceNetworkId || !match.sourceNetwork) {
                return this.networksMatchSourceAdapterEquals(match, row);
            }
            return this.networksMatchNetworkEquals(match, row.sourceNetworkId) &&
                this.networksMatchSourceAdapterEquals(match, row);
        };
        VmMigrateSelectNetworkService.prototype.setDestinationNetwork = function (match, destinationNetwork) {
            match.destinationNetwork = destinationNetwork.networkRef;
            match.destinationNetworkName = destinationNetwork.name;
            match.destinationPortgroupKey = destinationNetwork.portgroupKey;
            match.destinationSwitchUuid = destinationNetwork.dvsUuid;
            match.destinationOpaqueType = destinationNetwork.opaqueNetworkType;
            match.destinationOpaqueId = destinationNetwork.destinationOpaqueId;
        };
        VmMigrateSelectNetworkService.prototype.onSelectNetwork = function (destinationNetwork, tableRow, gridType) {
            var _this = this;
            if (this.pageModel.getSelectNetworkPageViewMode() === this.networkPageViewModes.BASIC) {
                this.pageModel.setBasicCompatibilityResultsCache(null);
                this.pageModel.isBasicPageValid = false;
            }
            else {
                this.pageModel.setAdvancedCompatibilityResultsCache(null);
                this.pageModel.isAdvancedPageValid = false;
            }
            if (destinationNetwork.networkRef.type !== this.managedEntityConstants.OPAQUE_NETWORK) {
                return this.$q.when(this.onNetworkPropertiesReturn(destinationNetwork, tableRow, gridType));
            }
            var destinationNetworkId = this.defaultUriSchemeUtil.getVsphereObjectId(destinationNetwork.networkRef);
            return this.dataServiceUtil.getPropertiesForObjects([destinationNetworkId], ["summary/opaqueNetworkType", "summary/opaqueNetworkId"])
                .then(function (result) {
                destinationNetwork.destinationOpaqueId =
                    result[destinationNetworkId]["summary/opaqueNetworkId"];
                destinationNetwork.opaqueNetworkType =
                    result[destinationNetworkId]["summary/opaqueNetworkType"];
                return _this.onNetworkPropertiesReturn(destinationNetwork, tableRow, gridType);
            });
        };
        VmMigrateSelectNetworkService.prototype.onNetworkPropertiesReturn = function (destinationNetwork, tableRow, gridType) {
            var _this = this;
            var isBasic = (gridType === this.networkPageViewModes.BASIC);
            var matches = isBasic ? this.getBasicNetworkMatches()
                : this.getAdvancedNetworkMatches();
            _.each(matches, function (match) {
                var isMatching = isBasic ? _this.finderBasic(match, tableRow)
                    : _this.finderAdvanced(match, tableRow);
                if (isMatching) {
                    _this.setDestinationNetwork(match, destinationNetwork);
                }
            });
            this.removeAutoSelectionMessageIfNeeded();
            this.syncNetworkMatches();
            if (isBasic) {
                this.buildBasicData();
            }
            else {
                this.buildAdvancedData();
            }
            return this.checkCompatibility();
        };
        VmMigrateSelectNetworkService.prototype.buildBasicData = function () {
            var _this = this;
            var vmNamesById = this.getViewData().vmNamesById;
            var sourceNetworkNamesById = this.getViewData().sourceNetworkNamesById;
            var matchingData = this.getBasicNetworkMatches();
            var itemsById = {};
            this.basicViewData.length = 0;
            var data = this.basicViewData;
            var self = this;
            _.each(matchingData, function (match) {
                var networkId = _this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceNetwork);
                var sourceVmId = _this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceVm);
                var networkItem;
                if (itemsById[networkId]) {
                    networkItem = itemsById[networkId];
                    networkItem._attachedAdapters.push(match.sourceAdapter);
                    networkItem._attachedVmNamesById[sourceVmId] = vmNamesById[sourceVmId];
                    networkItem.adapterMatches.push(match);
                }
                else {
                    networkItem = {
                        index: data.length,
                        sourceNetworkId: networkId,
                        networkName: sourceNetworkNamesById[networkId],
                        _attachedVmNamesById: {},
                        _attachedAdapters: [match.sourceAdapter],
                        usedBy: function () {
                            return self.i18nService.getString("Common", "vns.usedBy.format", _.keys(this._attachedVmNamesById).length.toString(), this._attachedAdapters.length.toString());
                        },
                        destinationNetworkName: match.destinationNetworkName,
                        destinationNetworkRef: match.destinationNetwork,
                        opaqueNetworkType: match.destinationOpaqueType,
                        adapterMatches: [match]
                    };
                    networkItem._attachedVmNamesById[sourceVmId] = vmNamesById[sourceVmId];
                    itemsById[networkId] = networkItem;
                    data.push(networkItem);
                }
            });
        };
        VmMigrateSelectNetworkService.prototype.buildAdvancedData = function () {
            var _this = this;
            var vmNamesById = this.getViewData().vmNamesById;
            var sourceNetworkNamesById = this.getViewData().sourceNetworkNamesById;
            var matchingData = this.getAdvancedNetworkMatches();
            this.advancedViewData.length = 0;
            var data = this.advancedViewData;
            _.each(matchingData, function (match, index) {
                var sourceNetworkId = _this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceNetwork);
                var sourceVmId = _this.defaultUriSchemeUtil.getVsphereObjectId(match.sourceVm);
                var networkItem = {
                    index: index,
                    vmName: vmNamesById[sourceVmId],
                    sourceAdapterLabel: match.sourceAdapter.deviceInfo.label,
                    sourceAdapter: match.sourceAdapter,
                    sourceNetworkId: sourceNetworkId,
                    sourceNetworkName: sourceNetworkNamesById[sourceNetworkId],
                    destinationNetworkName: match.destinationNetworkName,
                    destinationNetworkRef: match.destinationNetwork,
                    sourceVm: match.sourceVm
                };
                data.push(networkItem);
            });
        };
        VmMigrateSelectNetworkService.prototype.updateWithInitialNetworkMatchesIfAvailable = function (values) {
            var _this = this;
            _.each(values, function (match) {
                var matchHint = _this.findMatchHint(match.sourceVm, match.sourceAdapter);
                if (matchHint) {
                    _this.updateMatchDestination(match, matchHint);
                }
            });
        };
        VmMigrateSelectNetworkService.prototype.updateMatchDestination = function (match, matchHint) {
            // NOTE: The match hint although the same structure - may not contain detailed
            // source network info - so we copy here only properties we know are populated
            match.destinationNetwork = matchHint.destinationNetwork;
            match.destinationNetworkName = matchHint.destinationNetworkName;
            match.destinationPortgroupKey = matchHint.destinationPortgroupKey;
            match.destinationSwitchUuid = matchHint.destinationSwitchUuid;
            match.destinationOpaqueId = matchHint.destinationOpaqueId;
            match.destinationOpaqueType = matchHint.destinationOpaqueType;
        };
        VmMigrateSelectNetworkService.prototype.findMatchHint = function (sourceVm, sourceAdapter) {
            var _this = this;
            if (!this.pageModel.initialMatches) {
                return undefined;
            }
            return _.find(this.pageModel.initialMatches, function (match) {
                return _this.defaultUriSchemeUtil.compareIds(match.sourceVm, sourceVm) &&
                    (match.sourceAdapter.key === sourceAdapter.key);
            });
        };
        VmMigrateSelectNetworkService.prototype.checkCompatibility = function () {
            var _this = this;
            if (this.pageModel.getSelectNetworkPageViewMode() === this.networkPageViewModes.BASIC) {
                if (this.pageModel.getBasicCompatibilityResultsCache()) {
                    this.setCompatibilityMessages(this.pageModel.getBasicCompatibilityResultsCache(), this.pageModel.isBasicPageValid);
                    return;
                }
            }
            else {
                if (this.pageModel.getAdvancedCompatibilityResultsCache()) {
                    this.setCompatibilityMessages(this.pageModel.getAdvancedCompatibilityResultsCache(), this.pageModel.isAdvancedPageValid);
                    return;
                }
            }
            this.validationLoadingHandlerFn(true);
            var isNetworkPageValid = false;
            return this.migrationService.validateNetworkPrivilege(this.migrationWizardManager.getNetworkMatches()).then(function (validationResultsArray) {
                if (_.find(validationResultsArray, function (r) {
                    return r.error;
                })) {
                    // and return it immediately - no further processing is needed.
                    return validationResultsArray;
                }
                return _this.migrationService.validateNetwork(_this.migrationWizardManager.getVmIds(), _this.migrationWizardManager.getNetworkMatches(), _this.defaultUriSchemeUtil.getVsphereObjectId(_this.migrationWizardManager.getTargetResourcePoolRef()), _this.defaultUriSchemeUtil.getVsphereObjectId(_this.migrationWizardManager.getDestinationComputeResourceRef()));
            }).then(function (validationResultsArray) {
                isNetworkPageValid = _this.migrationService.isValidationSuccessful(validationResultsArray);
                return _this.compatibilityResultsPresenter.formatValidationResults(validationResultsArray);
            }).then(function (compatibilityItems) {
                if (compatibilityItems.length > 0) {
                    _this.setCompatibilityMessages(compatibilityItems, isNetworkPageValid);
                    _this.validationLoadingHandlerFn(false);
                    return;
                }
                var result = [{
                        icon: "vsphere-icon-status-ok",
                        message: _this.i18nService.getString("VmUi", "ProvisioningWizard.CompatibilityChecksSucceeded"),
                        contents: []
                    }];
                var matches = _this.migrationWizardManager.getNetworkMatches();
                _this.addAutoSelectionMessageIfRequired(result, matches);
                _this.setCompatibilityMessages(result, isNetworkPageValid);
                _this.validationLoadingHandlerFn(false);
            });
        };
        /**
         * In case there is a single prefetched network, and it"s different than the
         * source network of some of the network matches, displays an info message
         * about that in the compatibility/validation results view, after the
         * regular validation results. This is done, because the single prefetched
         * network will be auto-selected, as the only available choice.
         */
        VmMigrateSelectNetworkService.prototype.addAutoSelectionMessageIfRequired = function (result, matches) {
            var _this = this;
            // If there are more than one prefetched networks, no need to continue.
            if (!this.isSingleNetworkPrefetched()
                || !this.areAllPortGroups(matches)
                || this.isAutoSelectionMessageAdded) {
                return;
            }
            //should use each but it iterates all items
            // _.find stops at the first match
            // we kept _  for [] / {} compatibility
            _.find(matches, function (match) {
                if (_this.isAutoSelectionMessageAdded === false
                    && match.sourceNetwork
                    && match.destinationNetwork
                    && match.sourceNetwork.value !== match.destinationNetwork.value) {
                    var infoMessage = {
                        icon: "vsphere-icon-help-info-hover",
                        message: _this.i18nService.getString("VmUi", "MigrationWizard.networkPage.info.autoSelectedDifferentNetwork"),
                        contents: []
                    };
                    result.push(infoMessage);
                    _this.isAutoSelectionMessageAdded = true;
                    return true;
                }
                return false;
            });
        };
        VmMigrateSelectNetworkService.prototype.removeAutoSelectionMessageIfNeeded = function () {
            if (this.isSelectionPerformed && this.isAutoSelectionMessageAdded) {
                this.setCompatibilityMessage({
                    icon: "vsphere-icon-status-ok",
                    message: this.i18nService.getString("VmUi", "ProvisioningWizard.CompatibilityChecksSucceeded"),
                    contents: []
                });
            }
        };
        VmMigrateSelectNetworkService.prototype.areAllPortGroups = function (matches) {
            var _this = this;
            var isPortGroupBoolean = true;
            _.each(matches, function (match) {
                if ((!match.destinationNetwork)
                    || (match.sourceNetwork.type !== match.destinationNetwork.type)
                    || (match.sourceNetwork.type !==
                        _this.managedEntityConstants.DISTRIBUTED_VIRTUAL_PORTGROUP)) {
                    isPortGroupBoolean = false;
                }
            });
            return isPortGroupBoolean;
        };
        /**
         * Determines whether the last initialized prefetched networks data
         * contains just a single non-null element, which corresponds to a single
         * network, being prefetched by the network selector dropdown.
         */
        VmMigrateSelectNetworkService.prototype.isSingleNetworkPrefetched = function () {
            return 1 === this.getTotalPrefetchedNetworksCount();
        };
        VmMigrateSelectNetworkService.prototype.syncNetworkMatches = function () {
            var _this = this;
            if (this.pageModel.getSelectNetworkPageViewMode() ===
                this.networkPageViewModes.ADVANCED) {
                if (!this.pageModel
                    .getSelectNetworkPageIsViewChanged()) {
                    this.getAdvancedNetworkMatches().length = 0;
                    _.each(this.getBasicNetworkMatches(), function (match) {
                        _this.getAdvancedNetworkMatches().push(angular.copy(match));
                    });
                    //copy basic prefetchedNetworks to advanced when
                    // we change views for the first time
                    this.initPrefetchedNetwork(this.prefetchedNetworksBasic, this.networkPageViewModes.ADVANCED);
                    this.buildAdvancedData();
                    this.pageModel.setSelectNetworkPageIsViewChanged(true);
                }
                this.migrationWizardManager.setNetworkMatches(this.getAdvancedNetworkMatches());
            }
            else {
                this.migrationWizardManager.setNetworkMatches(this.getBasicNetworkMatches());
            }
        };
        return VmMigrateSelectNetworkService;
    }());
    h5_vm.VmMigrateSelectNetworkService = VmMigrateSelectNetworkService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmMigrateSelectNetworkService", [
        "$q",
        "i18nService",
        "dataService",
        "dataServiceUtil",
        "defaultUriSchemeUtil",
        "networkSelectorDialogService",
        "migrationService",
        "compatibilityResultsPresenter",
        "managedEntityConstants",
        "networkSelectorPrefetchingService",
        "NetworkPageViewModes",
        function ($q, i18nService, dataService, dataServiceUtil, defaultUriSchemeUtil, networkSelectorDialogService, migrationService, compatibilityResultsPresenter, managedEntityConstants, networkSelectorPrefetchingService, networkPageViewModes) {
            // Anonymous constructor function to return a
            // VmMigrateSelectNetworkService instance.
            return function (migrationWizardManager, migrateSelectNetworkPageModel, validationLoadingHandlerFn) {
                return new VmMigrateSelectNetworkService($q, i18nService, dataService, dataServiceUtil, defaultUriSchemeUtil, networkSelectorDialogService, migrationService, compatibilityResultsPresenter, managedEntityConstants, networkSelectorPrefetchingService, networkPageViewModes, migrationWizardManager, migrateSelectNetworkPageModel, validationLoadingHandlerFn);
            };
        }
    ]);
})(h5_vm || (h5_vm = {})); // namespace



var h5_vm;
(function (h5_vm) {
    var LocationSpecPair = com.vmware.vsphere.client.vm.migration.LocationSpecPair;
    var VmMigrationCancelRecommendationsSpec = com.vmware.vsphere.client.h5.vm.model.migration.VmMigrationCancelRecommendationsSpec;
    var defaultUriSchemeUtil;
    var mutationService;
    var datastoreRecommendationService;
    var $q;
    var VmStorageRecommendationsService = (function () {
        function VmStorageRecommendationsService() {
            this._vmIds = [];
            this._recommendationsByPod = {};
            this._faultsByVm = {};
            this._selectedRecommendations = {};
            this._recommendationsToCancel = [];
            this._hasInitErrors = false;
        }
        /**
         * @param locationSpecPairs
         *    Pass empty array in order to reset the internally kept recommendations info.
         */
        VmStorageRecommendationsService.prototype.load = function (locationSpecPairs) {
            var _this = this;
            if (_.isEmpty(locationSpecPairs)) {
                return $q.when([]).then(function () {
                    _this.parseResponse([]);
                    _this.autoselectRecommendation();
                });
            }
            // Cancel any previously generated recommendations
            this.attachCancelRecommendations(locationSpecPairs);
            var specTypeUrl = new LocationSpecPair()._type;
            this._vmIds = _.map(locationSpecPairs, function (spec) { return defaultUriSchemeUtil.getVsphereObjectId(spec.entity); });
            return mutationService.validateMultiSpec(specTypeUrl, locationSpecPairs).then(function (res) {
                _this.parseResponse(res);
                _this.autoselectRecommendation();
            });
        };
        VmStorageRecommendationsService.prototype.hasRecommendations = function () {
            return Object.keys(this._recommendationsByPod).length > 0;
        };
        VmStorageRecommendationsService.prototype.hasFaults = function () {
            return Object.keys(this._faultsByVm).length > 0;
        };
        VmStorageRecommendationsService.prototype.hasFaultsForVm = function (vmId) {
            return !_.isEmpty(this._faultsByVm[vmId]);
        };
        VmStorageRecommendationsService.prototype.getFaultsForVm = function (vmId) {
            return this._faultsByVm[vmId];
        };
        VmStorageRecommendationsService.prototype.hasDiskRecommendations = function (vmId, vmDisk) {
            var _this = this;
            var disk = vmDisk || {};
            var podUrn = disk.parentStoragePodUrn ?
                disk.parentStoragePodUrn : disk.storageUrn;
            if (!this._recommendationsByPod[podUrn]) {
                return false;
            }
            var found = _.find(this._recommendationsByPod[podUrn], function (recommendation) { return _this.isRecommendationForVm(vmId, recommendation); });
            return !!found;
        };
        VmStorageRecommendationsService.prototype.getDiskRecommendations = function (vmId, vmDisk) {
            var _this = this;
            var disk = vmDisk || {};
            var podUrn = disk.parentStoragePodUrn ?
                disk.parentStoragePodUrn : disk.storageUrn;
            if (!this._recommendationsByPod[podUrn]) {
                return null;
            }
            return _.filter(this._recommendationsByPod[podUrn], function (recommendation) { return _this.isRecommendationForVm(vmId, recommendation); });
        };
        VmStorageRecommendationsService.prototype.getAllDiskRecommendationsAsArray = function () {
            var result = [];
            _.each(this._recommendationsByPod, function (recommendations) {
                result = result.concat(recommendations);
            });
            return result;
        };
        VmStorageRecommendationsService.prototype.getSelectedRecommendationsByVm = function () {
            var _this = this;
            var recommendationsByVm = {};
            _.each(this._selectedRecommendations, function (perPodRecommendations) {
                _.each(_this._vmIds, function (vmId) {
                    if (!recommendationsByVm[vmId]) {
                        recommendationsByVm[vmId] = [];
                    }
                    var vmRecommendation = perPodRecommendations[vmId];
                    if (vmRecommendation) {
                        recommendationsByVm[vmId].push(vmRecommendation);
                    }
                });
            });
            return recommendationsByVm;
        };
        VmStorageRecommendationsService.prototype.setSelectedRecommendation = function (vmId, disk, recommendation) {
            var storagePodId = disk.parentStoragePodUrn ?
                disk.parentStoragePodUrn : disk.storageUrn;
            this._selectedRecommendations[storagePodId][vmId] = recommendation.spec;
        };
        VmStorageRecommendationsService.prototype.getSelectedRecommendation = function (vmId, disk) {
            var storagePodId = disk.parentStoragePodUrn ?
                disk.parentStoragePodUrn : disk.storageUrn;
            if (this._selectedRecommendations[storagePodId]) {
                return this._selectedRecommendations[storagePodId][vmId];
            }
            else {
                return undefined;
            }
        };
        VmStorageRecommendationsService.prototype.cancelRecommendations = function (excludeSelected) {
            var cancelRecommendations = this.getRecommendationToCancel(excludeSelected);
            if (!_.isEmpty(cancelRecommendations)) {
                var cancelSpec = new VmMigrationCancelRecommendationsSpec();
                cancelSpec.keys = cancelRecommendations;
                var rootFolder = defaultUriSchemeUtil
                    .getRootFolderFromVsphereObjectId(this._vmIds[0]);
                mutationService.apply(rootFolder, cancelSpec._type, cancelSpec);
                this._recommendationsToCancel = [];
            }
        };
        VmStorageRecommendationsService.prototype.attachCancelRecommendations = function (locationsSpecPairs, excludeSelected) {
            if (excludeSelected === void 0) { excludeSelected = false; }
            var recommendationKeys = this.getRecommendationToCancel(excludeSelected);
            if (!_.isEmpty(locationsSpecPairs) && !_.isEmpty(recommendationKeys)) {
                // Put all recommendations that need to be canceled into the first pair.
                var pair = locationsSpecPairs[0];
                pair.spec.cancelRecommendations = recommendationKeys;
            }
        };
        ;
        VmStorageRecommendationsService.prototype.getRecommendationToCancel = function (excludeSelected) {
            if (excludeSelected === void 0) { excludeSelected = false; }
            var keys = this._recommendationsToCancel;
            if (excludeSelected) {
                var selectedKeys_1 = [];
                _.each(this._selectedRecommendations, function (selectedByVm) {
                    _.each(selectedByVm, function (selected) {
                        selectedKeys_1.push(selected.key);
                    });
                });
                keys = _.difference(keys, selectedKeys_1);
            }
            return keys;
        };
        VmStorageRecommendationsService.prototype.parseResponse = function (res) {
            var _this = this;
            this._recommendationsByPod = {};
            this._faultsByVm = {};
            this._hasInitErrors = false;
            _.each(res, function (response) {
                if (!response) {
                    return;
                }
                var vmId = defaultUriSchemeUtil.getVsphereObjectId(response.entity);
                _.each(response.result, function (outerResult) {
                    if (outerResult.result && outerResult.result.recommendations) {
                        var recs = outerResult.result.recommendations;
                        _this._recommendationsToCancel = [];
                        _.each(recs, function (item) {
                            _this._recommendationsToCancel.push(item.key);
                            var storagePodId = defaultUriSchemeUtil
                                .getVsphereObjectId(item.target);
                            if (!_this._recommendationsByPod[storagePodId]) {
                                _this._recommendationsByPod[storagePodId] = [];
                            }
                            _this._recommendationsByPod[storagePodId].push(item);
                        });
                    }
                    if (outerResult.result && outerResult.result.drsFault) {
                        _.each(outerResult.result.drsFault.faultsByVm, function (fault) {
                            var vmId = defaultUriSchemeUtil.getVsphereObjectId(fault.vm);
                            if (!_this._faultsByVm[vmId]) {
                                _this._faultsByVm[vmId] = [];
                            }
                            _this._faultsByVm[vmId] = _this._faultsByVm[vmId].concat(fault.fault);
                        });
                    }
                    if (outerResult.error) {
                        if (!_this._faultsByVm[vmId]) {
                            _this._faultsByVm[vmId] = [];
                        }
                        _this._faultsByVm[vmId] = _this._faultsByVm[vmId].concat(response.result[0].error);
                    }
                });
                if (response.error) {
                    _this._hasInitErrors = true;
                }
            });
        };
        VmStorageRecommendationsService.prototype.getTopRecommendations = function () {
            var _this = this;
            var topRecommendations = {};
            _.each(this._recommendationsByPod, function (recommendations, storagePodId) {
                topRecommendations[storagePodId] = {};
                _.each(_this._vmIds, function (vmId) {
                    var topRecommendation = _this.findTopRecommendationForVm(vmId, recommendations);
                    if (topRecommendation) {
                        topRecommendations[storagePodId][vmId] = topRecommendation;
                    }
                });
            });
            return topRecommendations;
        };
        VmStorageRecommendationsService.prototype.hasInitErrors = function () {
            return this._hasInitErrors;
        };
        VmStorageRecommendationsService.prototype.autoselectRecommendation = function () {
            this._selectedRecommendations = this.getTopRecommendations();
        };
        VmStorageRecommendationsService.prototype.findTopRecommendationForVm = function (vmId, allRecommendations) {
            var _this = this;
            var vmRecommendations = _.filter(allRecommendations, function (recommendation) { return _this.isRecommendationForVm(vmId, recommendation); });
            return datastoreRecommendationService
                .findTopRecommendation(vmRecommendations);
        };
        VmStorageRecommendationsService.prototype.isRecommendationForVm = function (vmId, recommendation) {
            if (!recommendation || _.isEmpty(recommendation.action)) {
                return false;
            }
            var found = _.find(recommendation.action, function (action) { return vmId === defaultUriSchemeUtil.getVsphereObjectId(action.vm); });
            return !!found;
        };
        return VmStorageRecommendationsService;
    }());
    h5_vm.VmStorageRecommendationsService = VmStorageRecommendationsService; // class
    angular.module("com.vmware.vsphere.client.vm").service("VmStorageRecommendationsService", [
        "defaultUriSchemeUtil",
        "mutationService",
        "datastoreRecommendationService",
        "$q",
        function (_defaultUriSchemeUtil, _mutationService, _datastoreRecommendationService, _q) {
            defaultUriSchemeUtil = _defaultUriSchemeUtil;
            mutationService = _mutationService;
            datastoreRecommendationService = _datastoreRecommendationService;
            $q = _q;
            return VmStorageRecommendationsService;
        }
    ]);
})(h5_vm || (h5_vm = {})); // module



var h5_vm;
(function (h5_vm) {
    var defaultUriSchemeUtil;
    var mutationService;
    var VmXdrsRecommendationService = (function () {
        function VmXdrsRecommendationService() {
            this._recommendations = [];
            this._faults = [];
            this._selectedRecommendation = undefined;
            this._hasInitErrors = false;
        }
        /**
         * Fetches and saves xDRS recommendations
         * @param locationSpecPair
         *    Contains info a about the VM being migrated and the location specification
         *    with wich the migration will be executed.
         */
        VmXdrsRecommendationService.prototype.load = function (clusterId, locationSpecPair) {
            var _this = this;
            var vmPlacementSpec = {
                _type: "com.vmware.vsphere.client.vm.migration.VmPlacementSpec",
                vm: locationSpecPair.entity,
                relocateSpec: locationSpecPair.spec.relocateSpec,
                priority: locationSpecPair.spec.priority
            };
            vmPlacementSpec.vm = locationSpecPair.entity;
            vmPlacementSpec.relocateSpec = locationSpecPair.spec.relocateSpec;
            vmPlacementSpec.priority = locationSpecPair.spec.priority;
            return mutationService.validate(clusterId, vmPlacementSpec._type, vmPlacementSpec).then(function (response) {
                _this._hasInitErrors = false;
                if (response.error ||
                    !response.result ||
                    (!response.result.recommendations && !response.result.drsFault)) {
                    _this._hasInitErrors = true;
                }
                _this.init(response.result);
            });
        };
        VmXdrsRecommendationService.prototype.getSelectedRecommendation = function () {
            return this._selectedRecommendation;
        };
        VmXdrsRecommendationService.prototype.setSelectedRecommendation = function (value) {
            this._selectedRecommendation = value;
        };
        VmXdrsRecommendationService.prototype.hasRecommendations = function () {
            return this._recommendations && !!this._recommendations.length;
        };
        VmXdrsRecommendationService.prototype.getRecommendations = function () {
            return this._recommendations;
        };
        VmXdrsRecommendationService.prototype.hasFaults = function () {
            return this._faults && !!this._faults.length;
        };
        VmXdrsRecommendationService.prototype.getFaults = function () {
            return this._faults;
        };
        VmXdrsRecommendationService.prototype.getFaultsReason = function () {
            return this._faultsReason;
        };
        VmXdrsRecommendationService.prototype.hasInitErrors = function () {
            return this._hasInitErrors;
        };
        VmXdrsRecommendationService.prototype.init = function (placementResult) {
            this._recommendations = placementResult && placementResult.recommendations ?
                placementResult.recommendations : [];
            this._faults = placementResult && placementResult.drsFault ?
                placementResult.drsFault.faultsByVm : [];
            this._faultsReason = placementResult && placementResult.drsFault ?
                placementResult.drsFault.reason : "";
            this._selectedRecommendation = this.getTopRecommendation(this._recommendations);
        };
        VmXdrsRecommendationService.prototype.getTopRecommendation = function (recommendations) {
            if (!recommendations) {
                return undefined;
            }
            var topRec = undefined;
            recommendations.forEach(function (rec) {
                if (!topRec) {
                    topRec = rec;
                }
                else if (rec.rating > topRec.rating) {
                    topRec = rec;
                }
            });
            return topRec;
        };
        return VmXdrsRecommendationService;
    }());
    h5_vm.VmXdrsRecommendationService = VmXdrsRecommendationService; // class
    angular.module("com.vmware.vsphere.client.vm").service("vmXdrsRecommendationService", [
        "defaultUriSchemeUtil",
        "mutationService",
        function (_defaultUriSchemeUtil, _mutationService) {
            defaultUriSchemeUtil = _defaultUriSchemeUtil;
            mutationService = _mutationService;
            return VmXdrsRecommendationService;
        }
    ]);
})(h5_vm || (h5_vm = {})); // module



(function () {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmPowerOnFailuresController', VmPowerOnFailuresController);

   VmPowerOnFailuresController.$inject = [
      '$scope',
      'i18nService',
      'columnRenderersRegistry',
      'defaultUriSchemeUtil',
   ];

   function VmPowerOnFailuresController($scope, i18nService, columnRenderersRegistry, defaultUriSchemeUtil) {
      var self = this;

      var dialogData = $scope.modalOptions.dialogData;

      var objectNameRenderer = columnRenderersRegistry.getColumnRenderer('object-name');
      var wrappedTextRenderer = columnRenderersRegistry.getColumnRenderer('wrapped-text');
      var hostNameRenderer = columnRenderersRegistry.getColumnRenderer('host-name');

      var treeListData = [];

      for (var i = 0; i < dialogData.notAttempted.length; i++) {
         var notAttemptedItem = dialogData.notAttempted[i];

         var vmId = defaultUriSchemeUtil.getVsphereObjectId(notAttemptedItem.vm);

         var parent = {
            id: notAttemptedItem.vm.value,
            parentId: null,
            vmName: _.escape(dialogData.vmsProps[vmId].name),
            vmPrimaryIconId: dialogData.vmsProps[vmId].primaryIconId,
            hostName: i18nService.getString('VmUi', 'PowerOnVmFaultsView.host.notApplicable'),
            hideHostIcon: true,
            description: notAttemptedItem.fault.localizedMessage
         };

         treeListData.push(parent);

         var errors = notAttemptedItem.fault.error;
         if (errors) {
            for (var j = 0; j < errors.length; j++) {
               var child = {
                  id: notAttemptedItem.vm.value + "_child_" + j,
                  parentId: parent.id,
                  vmName: _.escape(dialogData.vmsProps[vmId].name),
                  vmPrimaryIconId: dialogData.vmsProps[vmId].primaryIconId,
                  hostName: _.escape(dialogData.vmsProps[vmId].hostName),
                  hideHostIcon: false,
                  description: errors[j].message
               };
               treeListData.push(child);
            }
         }
      }

      var treeListDataSource = new kendo.data.TreeListDataSource({
         data: treeListData,
         schema: {
            model: {
               id: "id",
               expanded: true
            }
         },
      });

      var treeListColumns = [{
         title: i18nService.getString('VmUi', 'PowerOnVmFaultsList.virtualMachine'),
         field: 'vmName',
         template: function(failureItem) {
            return objectNameRenderer(['', 'vmPrimaryIconId', 'vmName'],
                  failureItem);
         }
      }, {
         title: i18nService.getString('VmUi', 'PowerOnVmFaultsList.host'),
         field: 'hostName',
         template: function(failureItem) {
            return hostNameRenderer(['', 'hostName'], failureItem);
         }
      }, {
         title: i18nService.getString('VmUi', 'PowerOnVmFaultsList.description'),
         field: 'description',
         template: function(failureItem) {
            return wrappedTextRenderer(['description'], failureItem);
         }
      }];

      self.treeListOptions = {
         dataSource: treeListDataSource,
         resizable: true,
         columns: treeListColumns,
         sortable: true,
      };
   }
})();

(function () {
   'use strict';

   angular
   .module('com.vmware.vsphere.client.vm')
   .controller('VmPowerOnRecommendationsController', VmPowerOnRecommendationsController);

   VmPowerOnRecommendationsController.$inject = ['$scope', 'vuiConstants', 'i18nService',
      'vmRecommendationsService'];

   function VmPowerOnRecommendationsController($scope, vuiConstants, i18nService, vmRecommendationsService) {
      var self = this;

      $scope.modalOptions.onSubmit = function () {
         var selectedItems = self.dataGridOptions.selectedItems;
         if (selectedItems.length > 0) {
            var selectedItem = selectedItems[0];
            var target = selectedItem.targetClusterId;
            var recommendation = recommendationsByKey[selectedItem.key];
            vmRecommendationsService.applyRecommendation(target, recommendation);

            $scope.modalOptions.alerts = [];
            return true;
         } else {
            $scope.modalOptions.alerts  = [{
               text: i18nService.getString('VmUi','VmPowerOnRecommendationsController.errorSelectOneRecommendation'),
               type: vuiConstants.notifications.type.ERROR
            }];
            return false;
         }
      };

      var recommendationLabel = i18nService.getString('VmUi', 'RecommendationsList.recommendationColumnHeaderText');
      var priorityLabel = i18nService.getString('VmUi', 'RecommendationsList.priorityColumnHeaderText');
      var rawRecommendations = $scope.modalOptions.dialogData.rawRecommendations;
      var recommendationsByKey = _.indexBy(rawRecommendations, 'key');
      self.dataGridOptions = {
         dataBound: selectFirstRow,
         columnDefs: [
            {
               displayName: recommendationLabel,
               template: kendo.template("#:reasonText#" +
               "<ul> " +
               "  # for (var i = 0; i < actions.length; i++) { #" +
               "     <li ng-non-bindable><span class=\"#:actions[i].icon#\"></span>#:actions[i].text#</li>" +
               "   # } # " +
               "</ul>"),
               field: 'reasonText',
               width: '80%'
            },
            {
               displayName: priorityLabel,
               field: 'priority',
               template: '<div style="text-align: center;">#:priority#</div>'
            }
         ],
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         data: $scope.modalOptions.dialogData.recommendations,
         resizable: true,
         searchable: false,
         height: 350
      };

      function selectFirstRow() {
         var grid = $("#recommendations > div").data("kendoGrid");
         if (grid) {
            grid.select("tr:first");
         }
      }
   }
})();

(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmQuestionAnswerDialogController', VmQuestionAnswerDialogController);

   VmQuestionAnswerDialogController.$inject = ['$rootScope', '$scope', '$element', '$timeout',
      'mutationService', 'dataService', 'i18nService', 'defaultUriSchemeUtil'];

   function VmQuestionAnswerDialogController($rootScope, $scope, $element, $timeout,
         mutationService, dataService, i18nService, defaultUriSchemeUtil) {
      var PROPERTY_QUESTION = 'VirtualMachine/localizedQuestion';
      var PROPERTY_OTHER_VMS_COUNT_WITH_SAME_QUESTION = 'otherVmsCountWithSameQuestion';
      var PROPERTY_VC_NAME = 'vCenterName';

      var self = this;
      self.vmId = $scope.modalOptions.dialogData.vmId;
      self.vmQuestionIssue = $scope.modalOptions.dialogData.vmQuestionIssue;
      self.selectedChoice = self.vmQuestionIssue ?
            self.vmQuestionIssue.details.choice.defaultIndex : -1;
      self.showOtherVmsSelector = false;

      // in case of multi vm question this contains the refs of the other selected vms
      self.otherVmsRef = [];

      $scope.modalOptions.onSubmit = function() {
         if (self.loading) {
            return false;
         }

         var otherVmRefs = _.map(self.otherVmsRef, function(vmId) {
            return defaultUriSchemeUtil.getManagedObjectReference(vmId);
         });

         var firstMsgId;
         if (self.vmQuestionIssue.details.message &&
               self.vmQuestionIssue.details.message.length > 0) {
            firstMsgId = self.vmQuestionIssue.details.message[0].id;
         }
         var multipleVmQuestionAnswerSpec = {
            questionId: self.vmQuestionIssue.details.id,
            firstMessageId: firstMsgId,
            answerChoice: self.selectedChoice,
            otherVmRefs: otherVmRefs
         };

         mutationService.apply(
               self.vmId,
               'com.vmware.vsphere.client.h5.vm.MultipleVmQuestionAnswerSpec',
               multipleVmQuestionAnswerSpec)
            .then(function() {
               $rootScope.$broadcast('IssueChangeEvent');
            });

         return true;
      };

      requestData();

      function requestData() {
         self.loading = true;
         $scope.modalOptions.submitDisabled = true;

         var propsToRequest = [PROPERTY_OTHER_VMS_COUNT_WITH_SAME_QUESTION,
            PROPERTY_VC_NAME];

         if (!self.vmQuestionIssue) {
            propsToRequest.push(PROPERTY_QUESTION);
         }

         dataService.getProperties(self.vmId, propsToRequest).then(function (results) {
            if (results[PROPERTY_QUESTION]) {
               var questionInfo = results[PROPERTY_QUESTION];
               self.vmQuestionIssue = {
                  details: questionInfo
               };
               self.selectedChoice = self.vmQuestionIssue ?
                     self.vmQuestionIssue.details.choice.defaultIndex : 0;
            }

            self.otherVmsCount = results[PROPERTY_OTHER_VMS_COUNT_WITH_SAME_QUESTION];

            if (self.otherVmsCount > 0) {
               var vcName = results[PROPERTY_VC_NAME];
               self.answerOtherMachinesLabel = i18nService.getString(
                     'VmUi', 'VmQuestionAnswerView.answerOtherMachines',
                     self.otherVmsCount, vcName);
               self.selectOtherVmsLinkText = getShowVmsLabel();
            } else {
               self.answerOtherMachinesLabel = i18nService.getString(
                     'VmUi', 'VmQuestionAnswerView.noOtherMachines');
            }

            self.loading = false;
            $scope.modalOptions.submitDisabled = false;
            focusFirstInput();
         });
      }

      self.toggleSelectVmsView = function() {
         self.showOtherVmsSelector = !self.showOtherVmsSelector;
         self.selectOtherVmsLinkText = getShowVmsLabel();
         if (!self.showOtherVmsSelector) {
            // otherwise digest in progress is thrown
            $timeout(function() {
               var grid = $element.find('[list-view-id="vsphere.core.vm.list"] [kendo-grid]');
               grid.data('kendoGrid').clearSelection();
            }, 0);

         } else {
            $timeout(function() {
               var grid = $element.find('[list-view-id="vsphere.core.vm.list"] [kendo-grid]');
               if (grid) {
                  var kendoGrid = grid.data('kendoGrid');
                  if (kendoGrid) {
                     kendoGrid.resize();
                  }
               }
            }, 0);
         }
      };

      var otherVmsWithSameQuestionConfig = {
         label: i18nService.getString('Common', 'typeResource.vmPlural'),
         listViewId: 'vsphere.core.vm.list',
         dataModels: ["VirtualMachine"],
         filterId: 'otherVmsWithSameQuesitonFilter',
         preselectComparator: function(vmItem) {
            return false;
         }
      };

      self.objSelectorConfig = {
         contextObject: self.vmId,
         multipleSelect: true,
         listTabConfig: {
            selectedTabIndex: 0,
            listConfig: [otherVmsWithSameQuestionConfig]
         },
         onSelectionChanged: onVmSelectionChange
      };

      function getShowVmsLabel() {
         return self.showOtherVmsSelector ?
               i18nService.getString('VmUi', 'VmQuestionAnswerView.cancelVmsSelection') :
               i18nService.getString('VmUi', 'VmQuestionAnswerView.selectVms');
      }

      function onVmSelectionChange(vmsData) {
         self.otherVmsRef = null;
         if (!vmsData) {
            return;
         }

         self.otherVmsRef = [];
         for (var i = 0; i < vmsData.length; i++) {
            self.otherVmsRef.push(vmsData[i].id);
         }
      }

      function focusFirstInput() {
         $timeout(function() {
            var firstInput = $element[0].querySelector('input[type="radio"]');
            if (firstInput) {
               firstInput.focus();
            }
         }, 0);
      }
   }
})();

/* Copyright 2015 Vmware, Inc. All rights reserved. -- Vmware Confidential */
angular.module('com.vmware.vsphere.client.vm').service('controllerNodeFinderService', ['vmDeviceInfoService',
function (vmDeviceInfoService) {
   return {
      findNextAvailableNodeForController: findNextAvailableNodeForController
   };

   function findNextAvailableNodeForController (controllerKey, availableNodes, connectedDevices) {
      connectedDevices = _.filter(connectedDevices, function (device){ return device.controllerKey === controllerKey;});

      if (connectedDevices.length < 1) {
         return availableNodes[0];
      }

      if (connectedDevices.length >= availableNodes.length) {
         return null;
      }

      var sortedConnectedDevices = _.sortBy(connectedDevices, 'unitNumber');
      return _.find(availableNodes, function(node, index) {
         var device = sortedConnectedDevices[index];
         if (device === undefined || node.key !== device.unitNumber) {
            return node;
         }
      });
   }
}]);


angular.module('com.vmware.vsphere.client.vm').service('datastoreNameFetcher',
      ['dataService', 'defaultUriSchemeUtil', function (dataService, defaultUriSchemeUtil) {
   return {
      fetchNames: function (vmId) {
         return dataService.getProperties(vmId, ['host']).then(function(response) {
            var hostId = defaultUriSchemeUtil.getVsphereObjectId(response.host);
            return dataService.getProperties(hostId, ['dc']);
         }).then(function(response) {
            var dcId = defaultUriSchemeUtil.getVsphereObjectId(response.dc);
            return dataService.getProperties(dcId, ['datastore']);
         }).then(function(response) {
            return response.datastore;
         });
      }
   };
}]);

var h5_vm;
(function (h5_vm) {
    var DeviceClassLineageService = (function () {
        function DeviceClassLineageService() {
            this.virtualDeviceClassMap = this.getVirtualDeviceClassMap();
            this.deviceTypeLookUp = {};
            this.collectTypes(this.virtualDeviceClassMap, null);
            this.loggedMissingDeviceTypeWarnings = [];
        }
        /**
         * Checks if a given device class name is a sub class of another
         *
         * @param subClassName : fully qualified class name of the sub type
         * @param superClassName : fully qualified class name of the super type
         * @returns {boolean}
         */
        DeviceClassLineageService.prototype.isClassNameSubclassOf = function (subClassName, superClassName) {
            subClassName = this.getSimpleClassName(subClassName);
            superClassName = this.getSimpleClassName(superClassName);
            var deviceType = this.deviceTypeLookUp[subClassName];
            if (!deviceType) {
                if (!this.loggedMissingDeviceTypeWarnings[subClassName]) {
                    console.warn("Unable to find device class for " + subClassName);
                    this.loggedMissingDeviceTypeWarnings[subClassName] = true;
                }
                return false;
            }
            while (true) {
                if (deviceType.type === superClassName) {
                    return true;
                }
                if (!deviceType.parent) {
                    return false;
                }
                deviceType = deviceType.parent;
            }
        };
        /**
         * Gives the type of VirtualController for a given controller's type class
         *
         * @param controllerTypeClass : fully qualified class name of the virtual controller
         * @returns {string | null} : 1) The type of the current controller if its parent's type is "VirtualController"
         *                            2) Else, traverses the parent hierarchy levels until it finds the controller whose
         *                               parent's type is "VirtualController" and returns that controller's type.
         *                            3) Null if it cannot find such a controller.
         */
        DeviceClassLineageService.prototype.getVirtualControllerType = function (controllerTypeClass) {
            var simpleClassName = this.getSimpleClassName(controllerTypeClass);
            var controller = this.deviceTypeLookUp[simpleClassName];
            while (controller) {
                if (controller.parent && controller.parent.type === "VirtualController") {
                    return controller.type;
                }
                else {
                    controller = controller.parent;
                }
            }
            return null;
        };
        DeviceClassLineageService.prototype.getSimpleClassName = function (fullyQualifiedClassName) {
            var index = fullyQualifiedClassName.lastIndexOf(".");
            if (index >= 0) {
                return fullyQualifiedClassName.substr(index + 1);
            }
            return fullyQualifiedClassName;
        };
        DeviceClassLineageService.prototype.collectTypes = function (arr, parent) {
            var _this = this;
            arr.forEach(function (typeObj) {
                typeObj.parent = parent;
                _this.deviceTypeLookUp[typeObj.type] = typeObj;
                if (typeObj.children) {
                    _this.collectTypes(typeObj.children, typeObj);
                }
            });
        };
        DeviceClassLineageService.prototype.getVirtualDeviceClassMap = function () {
            return [
                {
                    type: 'VirtualDevice',
                    children: [
                        {
                            type: 'VirtualCdrom'
                        },
                        {
                            type: 'VirtualNVDIMM'
                        },
                        {
                            type: 'VirtualController',
                            children: [
                                {
                                    type: 'VirtualIDEController'
                                },
                                {
                                    type: 'VirtualNVMEController'
                                },
                                {
                                    type: 'VirtualNVDIMMController'
                                },
                                {
                                    type: 'VirtualPCIController'
                                },
                                {
                                    type: 'VirtualPS2Controller'
                                },
                                {
                                    type: 'VirtualSATAController',
                                    children: [
                                        {
                                            type: 'VirtualAHCIController'
                                        }
                                    ]
                                },
                                {
                                    type: 'VirtualSCSIController',
                                    children: [
                                        {
                                            type: 'ParaVirtualSCSIController'
                                        },
                                        {
                                            type: 'VirtualBusLogicController'
                                        },
                                        {
                                            type: 'VirtualLsiLogicController'
                                        },
                                        {
                                            type: 'VirtualLsiLogicSASController'
                                        }
                                    ]
                                },
                                {
                                    type: 'VirtualSIOController'
                                },
                                {
                                    type: 'VirtualUSBController'
                                },
                                {
                                    type: 'VirtualUSBXHCIController'
                                }
                            ]
                        },
                        {
                            type: 'VirtualDisk'
                        },
                        {
                            type: 'VirtualEthernetCard',
                            children: [
                                {
                                    type: 'VirtualE1000'
                                },
                                {
                                    type: 'VirtualE1000e'
                                },
                                {
                                    type: 'VirtualPCNet32'
                                },
                                {
                                    type: 'VirtualSriovEthernetCard'
                                },
                                {
                                    type: 'VirtualVmxnet',
                                    children: [
                                        {
                                            type: 'VirtualVmxnet2'
                                        },
                                        {
                                            type: 'VirtualVmxnet3',
                                            children: [
                                                {
                                                    type: 'VirtualVmxnet3Vrdma'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'InputDevice',
                            children: [
                                {
                                    type: 'VirtualKeyboard'
                                },
                                {
                                    type: 'VirtualPointingDevice'
                                }
                            ]
                        },
                        {
                            type: 'VirtualFloppy'
                        },
                        {
                            type: 'VirtualVideoCard'
                        },
                        {
                            type: 'VirtualVMCIDevice'
                        },
                        {
                            type: 'VirtualVMIROM'
                        },
                        {
                            type: 'VirtualParallelPort'
                        },
                        {
                            type: 'VirtualPCIPassthrough'
                        },
                        {
                            type: 'VirtualSCSIPassthrough'
                        },
                        {
                            type: 'VirtualSerialPort'
                        },
                        {
                            type: 'VirtualSoundCard',
                            children: [
                                {
                                    type: 'VirtualEnsoniq1371'
                                },
                                {
                                    type: 'VirtualHdAudioCard'
                                },
                                {
                                    type: 'VirtualSoundBlaster16'
                                }
                            ]
                        },
                        {
                            type: 'VirtualUSB'
                        },
                        {
                            type: 'VirtualTPM'
                        },
                    ]
                }];
        };
        DeviceClassLineageService.$inject = [];
        return DeviceClassLineageService;
    }());
    h5_vm.DeviceClassLineageService = DeviceClassLineageService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('deviceClassLineageService', DeviceClassLineageService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var DiskControllerAdvice = (function () {
        function DiskControllerAdvice(controller, busNo, unitNo) {
            this.recommendedController = _.isUndefined(controller) ? null : controller;
            this.recommendedBusNo = _.isUndefined(busNo) ? -1 : busNo;
            this.recommendedUnitNo = _.isUndefined(unitNo) ? 0 : unitNo;
        }
        return DiskControllerAdvice;
    }());
    h5_vm.DiskControllerAdvice = DiskControllerAdvice;
    /**
     * service used to find available disk-controller that can be reused to attach
     * devices.
     */
    var DiskControllerIndexAdviserService = (function () {
        function DiskControllerIndexAdviserService(nodeCountService, deviceClassLineageService) {
            this.nodeCountService = nodeCountService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.INVALID = -1;
            this.MAX_SCSILIMIT = 4; //also applies to SATA
            this.MAX_SATALIMIT = 4;
            this.MAX_IDELIMIT = 2;
            this.VIRTUAL_IDE_CONTROLLER = "VirtualIDEController";
            this.VIRTUAL_SATA_CONTROLLER = "VirtualSATAController";
            this.VIRTUAL_SCSI_CONTROLLER = "VirtualSCSIController";
        }
        /**
         *
         * @param inflatedController (the controller whose empty slot is being queried
         * @param deviceOptions : the options available for the devices/controllers
         * @param inflatedDevices : all devices not marked for removal
         * @param deviceType : "VirtualDisk"
         * @returns {number} (the empty node where the device can be attached to)
         */
        DiskControllerIndexAdviserService.prototype.getNextAvailableNodeIndexForController = function (inflatedController, deviceOptions, inflatedDevices, deviceType) {
            var controller = inflatedController.getCurrentDevice();
            var maxNodeCount = this.nodeCountService.getMaxNodeCountForControllerType(controller._type, deviceOptions, deviceType);
            var reservedIndices = [];
            if (controller.scsiCtlrUnitNumber) {
                reservedIndices.push(controller.scsiCtlrUnitNumber);
            }
            var occupiedNodeIndices = [];
            occupiedNodeIndices = occupiedNodeIndices.concat(reservedIndices);
            var inflatedDevicesAttachedToThisController = _.filter(inflatedDevices, function (inflatedDevice) {
                var device = inflatedDevice.getCurrentDevice();
                return device.controllerKey === inflatedController.getKey();
            });
            if (inflatedDevicesAttachedToThisController.length >= maxNodeCount) {
                return this.INVALID;
            }
            _.map(inflatedDevicesAttachedToThisController, function (device) {
                occupiedNodeIndices.push(device.getCurrentDevice().unitNumber);
            });
            for (var candidateNodeIndex = 0; candidateNodeIndex <= maxNodeCount; candidateNodeIndex++) {
                if (!_.contains(occupiedNodeIndices, candidateNodeIndex)) {
                    return candidateNodeIndex;
                }
            }
            return this.INVALID;
        };
        /**
         *
         * @param controllerType : controller type
         * @param deviceOptions : device options
         * @param otherInflatedDevices : all inflated devices of this VM
         * @param deviceType : 'VirtualDisk'
         * @returns : result : an advice object containing:
         *    recommendedController : the found controller to reuse. if not null, check the recommendedUnitNumber
         *                         if null, create a new one, but first check the recommendedBusNumber
         *    recommendedBusNumber : If controller is found, this value does not matter.
         *                            If Controller is not found (null) : this will tell which Bus to create the
         *                            controller on. -1 (INVALID) signifies max controller limit reached.
         *    recommendedUnitNumber : if controller is found, use this value to attach the device to
         *
         *    situation : No Controller exists yet :
         *          {recommendedController: null, recommendedBusNumber: 0, recommendedUnitNumber: 0}
         *    situation : Maximum limit of controllers fully used up
         *          {recommendedController: null, recommendedBusNumber: -1, recommendedUnitNumber: X}
         *    situation : Existing Controllers fully used up (caller must create a new one)
         *          {recommendedController: controller, recommendedBusNumber: value, recommendedUnitNumber: 0}
         *    situation : Existing Controllers have empty slots for reuse
         *          {recommendedController: controller, recommendedBusNumber: X, recommendedUnitNumber: value}
         */
        DiskControllerIndexAdviserService.prototype.getAdviceOnReusableController = function (controllerType, deviceOptions, otherInflatedDevices, deviceType) {
            var _this = this;
            var usedBusList = [], recommendedUnitNo = 0, recommendedController = null;
            var controllerTypeToCheckAgainst = this.deviceClassLineageService.getVirtualControllerType(controllerType.typeClass);
            var maxControllerLimit = this.getControllerLimit(controllerTypeToCheckAgainst);
            var targetControllerList = _.filter(otherInflatedDevices, function (inflatedDevice) {
                return (controllerTypeToCheckAgainst) ? inflatedDevice.isOfType(controllerTypeToCheckAgainst) : false;
            });
            if (_.isEmpty(targetControllerList)) {
                //no controller exists of this type
                //let the caller create the first one on Bus 0, attach device on Unit 0
                return new DiskControllerAdvice(null, 0, 0);
            }
            _.every(targetControllerList, function (controllerDevice) {
                recommendedUnitNo = _this.getNextAvailableNodeIndexForController(controllerDevice, deviceOptions, otherInflatedDevices, deviceType);
                usedBusList.push(controllerDevice.getCurrentDevice().busNumber);
                recommendedController = (recommendedUnitNo !== _this.INVALID) ? controllerDevice : null;
                return recommendedController === null;
            });
            var result = new DiskControllerAdvice(recommendedController, this.INVALID, recommendedUnitNo);
            //if recommendedController exists : empty slot is present : all good, just return
            //OR if max no. of controllers are fully used up, (then recommendedController is null)
            //so return : In either case the recommendedBus is -1 and should not be considered
            if (result.recommendedController || usedBusList.length >= maxControllerLimit) {
                return result;
            }
            //So we have some available controller slots that can be used to create
            //a new controller. Figure which busNo.   Also force the unitNo to 0
            for (var i = 0; i < maxControllerLimit; i++) {
                if (!_.contains(usedBusList, i)) {
                    result.recommendedBusNo = i;
                    result.recommendedUnitNo = 0;
                    break;
                }
            }
            return result;
        };
        // TODO:- Include the limit for other controller types as well.
        //        When the class becomes fully generic supporting all other types of controllers, then we need to rename
        //        the class to ControllerIndexAdviserService
        DiskControllerIndexAdviserService.prototype.getControllerLimit = function (controllerType) {
            switch (controllerType) {
                case this.VIRTUAL_SCSI_CONTROLLER: return this.MAX_SCSILIMIT;
                case this.VIRTUAL_SATA_CONTROLLER: return this.MAX_SATALIMIT;
                case this.VIRTUAL_IDE_CONTROLLER: return this.MAX_IDELIMIT;
                default: return 0;
            }
        };
        DiskControllerIndexAdviserService.$inject = ['nodeCountService', 'deviceClassLineageService'];
        return DiskControllerIndexAdviserService;
    }());
    h5_vm.DiskControllerIndexAdviserService = DiskControllerIndexAdviserService;
    angular
        .module('com.vmware.vsphere.client.vm')
        .service('diskControllerIndexAdviserService', DiskControllerIndexAdviserService);
})(h5_vm || (h5_vm = {}));



var vm_ui;
(function (vm_ui) {
    var ExistingHardDiskSelectorDialogService = (function () {
        function ExistingHardDiskSelectorDialogService(clarityModalService, i18nService, defaultUriSchemeUtil, datastoreBrowserConstants) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
        }
        ExistingHardDiskSelectorDialogService.prototype.openExistingDiskSelectorDialog = function (vmConfigEnvironment, okHandler) {
            var _this = this;
            var dsBrowserId = this.defaultUriSchemeUtil.getVsphereObjectId(vmConfigEnvironment.datastoreBrowser);
            var vmDatastores = vmConfigEnvironment.configTarget.datastore;
            var datastoreIds = _.map(vmDatastores, function (vmDatastore) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(vmDatastore.datastore.datastore);
            });
            var initialFileQueryType = this.datastoreBrowserConstants.fileQueryType.VM_DISK_TYPE_WITH_DETAILS;
            var filterQueryTypes = [{
                    label: this.i18nService.getString('Common', 'dsBrowser.vmDiskFile'),
                    value: this.datastoreBrowserConstants.fileQueryType.VM_DISK_TYPE_WITH_DETAILS
                }];
            var dialogData = {
                datastoreBrowserId: dsBrowserId,
                datastoreIds: datastoreIds,
                initialFileQueryType: initialFileQueryType,
                filterFileQueryTypes: filterQueryTypes,
                showVmImagesFolder: true,
                selectedFileChanged: function (selectedFile) {
                    _this.selectedFile = selectedFile;
                    _this.modalOptions.submitDisabled = !_this.selectedFile;
                }
            };
            this.okHandler = okHandler;
            this.modalOptions = {
                title: this.i18nService.getString("Common", "dsBrowser.defaultTitle"),
                contentTemplate: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/' +
                    'vmHardwareExistingDisk/select-existing-hard-disk.view.html',
                defaultButton: 'submit',
                dialogData: dialogData,
                size: 'lg',
                modalClass: '',
                hideSubmitButton: false,
                submitDisabled: true,
                selectedItems: [],
                alerts: [],
                onSubmit: function () {
                    if (_this.selectedFile === null) {
                        return false;
                    }
                    if (_this.okHandler && typeof _this.okHandler === "function") {
                        _this.okHandler(_this.selectedFile);
                    }
                    return true;
                }
            };
            this.clarityModalService.openOkCancelModal(this.modalOptions);
        };
        ExistingHardDiskSelectorDialogService.$inject = ['clarityModalService', 'i18nService',
            'defaultUriSchemeUtil', 'datastoreBrowserConstants'];
        return ExistingHardDiskSelectorDialogService;
    }());
    vm_ui.ExistingHardDiskSelectorDialogService = ExistingHardDiskSelectorDialogService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("existingHardDiskSelectorDialogService", ExistingHardDiskSelectorDialogService);
})(vm_ui || (vm_ui = {}));



(function() {

   'use strict';
   angular.module('com.vmware.vsphere.client.vm').service('guestOsService', guestOsService);

   function guestOsService() {
      return {
         getGuestOsDescriptor: getGuestOsDescriptor,
         getSelectedGuestOs: getSelectedGuestOs,
         getAppropriateGuestOs: getAppropriateGuestOs
      };

      function getGuestOsDescriptor(vmConfigContext, gosVersion) {
         var guestOSDescriptor = vmConfigContext.environment.configOption.guestOSDescriptor;
         return _.find(guestOSDescriptor, function(osDescriptor) {
            return osDescriptor.id === gosVersion.id;
         });
      }

      function getSelectedGuestOs(vmConfigContext) {
         var guestOSDescriptor = vmConfigContext.environment.configOption.guestOSDescriptor;
         if (guestOSDescriptor.length > 1) {
            throw new Error('Expected only one guestOSDescriptor but found ' + guestOSDescriptor.length);
         }
         return guestOSDescriptor[0];
      }

      function getAppropriateGuestOs(vmConfigContext, vmVersion) {
         var guestOs;
         if (vmConfigContext.environment.configOption.guestOSDescriptor.length > 1) {
            guestOs = getGuestOsDescriptor(
                  vmConfigContext,
                  vmVersion);
         } else {
            guestOs = getSelectedGuestOs(vmConfigContext);
         }
         return guestOs;
      }
   }
}());


/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var InitialStorageConfigurationService = (function () {
        function InitialStorageConfigurationService($q, defaultUriSchemeUtil, mutationService, diskProvisioningService, storageProfileService, vmDeviceInfoService) {
            this.$q = $q;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.mutationService = mutationService;
            this.diskProvisioningService = diskProvisioningService;
            this.storageProfileService = storageProfileService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.BASIC_MODE = "basicMode";
            this.ADVANCED_MODE = "advancedMode";
        }
        InitialStorageConfigurationService.prototype.computeInitialVmStorageConfig = function (vmId, spec, replicationGroupsData) {
            var _this = this;
            var result = new h5_vm.VmStorageConfig();
            result.vmId = vmId;
            result.vmHome = {
                key: -1,
                storageObj: spec.datastore &&
                    {
                        storageRef: spec.datastore
                    },
                storageProfile: this.computeStorageProfile(spec.profile),
                replicationGroup: this.computeReplicationGroup(spec.profile, replicationGroupsData)
            };
            result.vmDisks = [];
            var vmDisks = result.vmDisks;
            _.each(spec.disk, function (diskLocator) {
                vmDisks.push({
                    key: diskLocator.diskId,
                    storageObj: diskLocator.datastore &&
                        {
                            storageRef: diskLocator.datastore,
                        },
                    diskFormat: diskLocator.diskBackingInfo &&
                        _this.diskProvisioningService.getFormat(diskLocator.diskBackingInfo),
                    storageProfile: _this.computeStorageProfile(diskLocator.profile),
                    replicationGroup: _this.computeReplicationGroup(diskLocator.profile, replicationGroupsData)
                });
            });
            this.buildVmDisks(spec.deviceChange, result.vmDisks, {});
            return result;
        };
        InitialStorageConfigurationService.prototype.computeInitialVmStorageConfigForCreateVm = function (datastoreRef, deviceChange, datastoreRefs, profiles, replicationGroupsData) {
            var result = new h5_vm.VmStorageConfig();
            result.vmId = "";
            result.vmHome = {
                key: -1,
                storageObj: {
                    storageRef: datastoreRef
                },
                storageProfile: this.computeStorageProfile(profiles),
                replicationGroup: this.computeReplicationGroup(profiles, replicationGroupsData)
            };
            result.vmDisks = [];
            this.buildVmDisks(deviceChange, result.vmDisks, datastoreRefs);
            return result;
        };
        InitialStorageConfigurationService.prototype.computeSourceVmStorageConfig = function (initialVmStorageConfig, profiles, storageSelectorData, isCreateFromScratch) {
            var sourceVmStorageConfig = angular.copy(initialVmStorageConfig);
            if (isCreateFromScratch) {
                storageSelectorData.sourceVmStorageConfig = [sourceVmStorageConfig];
            }
            if (!_.isEmpty(sourceVmStorageConfig.vmDisks)) {
                _.each(sourceVmStorageConfig.vmDisks, function (disk) {
                    var originalDisk = _.find(storageSelectorData.sourceVmStorageConfig[0].vmDisks, function (vmDisk) {
                        return vmDisk.key === disk.key;
                    });
                    if (originalDisk) {
                        var profile = _.find(profiles, function (profile) {
                            return profile.id === (disk.storageProfile && disk.storageProfile.id);
                        });
                        if (profile) {
                            originalDisk.storageProfile = profile;
                        }
                    }
                });
            }
        };
        InitialStorageConfigurationService.prototype.buildVmDisks = function (deviceChange, vmDisks, datastoreRefs) {
            var _this = this;
            _.each(deviceChange, function (device) {
                if (_this.vmDeviceInfoService.isDeviceSubclassOf(device.device, "VirtualDisk")) {
                    var datastoreName = device.device && device.device.backing &&
                        device.device.backing.fileName;
                    var datastore = void 0;
                    if (datastoreName) {
                        var match = datastoreName.match(/\[(.*)\]/);
                        datastoreName = match ? match[1] : "";
                        datastore = datastoreRefs[datastoreName];
                    }
                    vmDisks.push({
                        key: device.device.key,
                        storageObj: datastore &&
                            {
                                storageRef: datastore,
                            },
                        diskFormat: device.device && device.device.backing &&
                            _this.diskProvisioningService.getFormat(device.device.backing),
                        storageProfile: _this.computeStorageProfile(device.profile),
                        replicationGroup: _this.computeReplicationGroup(device.profile)
                    });
                }
            });
        };
        InitialStorageConfigurationService.prototype.computeStorageProfile = function (profiles) {
            if (!profiles || !profiles[0]) {
                return undefined;
            }
            var id = this.storageProfileService.getProfileIdFromSpec(profiles[0]);
            if (!id) {
                return undefined;
            }
            return { id: id };
        };
        InitialStorageConfigurationService.prototype.computeReplicationGroup = function (profiles, replicationGroupsData) {
            if (!profiles || !profiles[0] || !profiles[0].replicationSpec) {
                return undefined;
            }
            var id = profiles[0].replicationSpec.replicationGroupId;
            if (!id) {
                return undefined;
            }
            var stringId = id === null ? "" : id.faultDomainId.id + ":" + id.deviceGroupId.id;
            var groupInfo;
            if (stringId && replicationGroupsData && replicationGroupsData[stringId]) {
                groupInfo = replicationGroupsData[stringId];
            }
            return {
                id: id,
                groupInfo: groupInfo
            };
        };
        InitialStorageConfigurationService.prototype.computeStoragePageViewMode = function (spec) {
            var _this = this;
            if (spec.datastore && !spec.disk) {
                return this.BASIC_MODE;
            }
            // Seek if there is a disk locator which is different from the home datastore
            var referenceStorage = spec.datastore;
            var uniqueDiskLocator = _.find(spec.disk, function (diskLocator) {
                return !_this.defaultUriSchemeUtil.compareNullableIds(diskLocator.datastore, referenceStorage);
            });
            // If unique found - this means different disks go to different storage -
            // so editing in advanced mode is required
            if (uniqueDiskLocator) {
                return this.ADVANCED_MODE;
            }
            var referenceDisk = spec.disk && spec.disk[0];
            uniqueDiskLocator = referenceDisk && _.find(spec.disk, function (diskLocator) {
                return !_this.diskProvisioningService.areDiskFormatsEqual(diskLocator.diskBackingInfo, referenceDisk.diskBackingInfo);
            });
            if (uniqueDiskLocator) {
                return this.ADVANCED_MODE;
            }
            var referenceProfile = spec.profile && spec.profile[0];
            uniqueDiskLocator = _.find(spec.disk, function (diskLocator) {
                return !_this.storageProfileService.areProfileSpecsEqual(diskLocator.profile && diskLocator.profile[0], referenceProfile, true);
            });
            if (uniqueDiskLocator) {
                return this.ADVANCED_MODE;
            }
            return this.BASIC_MODE;
        };
        /**
         * @returns {boolean}
         *    'true' if things were preselected due to initial data present in the model
         *    and 'false' otherwise.
         */
        InitialStorageConfigurationService.prototype.initSelectedStorageItems = function (storageSelectorState, storageSelectorData /*StorageSelectorData*/, storageData) {
            var _this = this;
            if (!storageData.initialViewMode ||
                !storageData.initialVmStorageConfig) {
                return false;
            }
            storageSelectorState.mode = storageData.initialViewMode;
            var vmId = storageData.initialVmStorageConfig.vmId;
            if (storageSelectorState.mode === this.BASIC_MODE) {
                if (!storageSelectorData.initialConfig) {
                    storageSelectorData.initialConfig = {};
                }
                var storageObj = storageData.initialVmStorageConfig.vmHome.storageObj;
                var storageId = this.defaultUriSchemeUtil.getVsphereObjectId(storageObj && storageObj.storageRef);
                var storageItem = this.findStorageItem(storageSelectorData.storageLocatorItemsData.datastoreItems, storageId);
                storageSelectorData.initialConfig.selectedItemInBasicMode = storageItem;
                // In basic mode all disks should have the same format
                var diskA = storageData.initialVmStorageConfig.vmDisks[0];
                var diskFormat = diskA && diskA.diskFormat;
                storageSelectorData.initialConfig.selectedDiskFormatInBasicMode = diskFormat;
                var storageProfile = storageData.initialVmStorageConfig
                    .vmHome.storageProfile;
                var storageProfileId = storageProfile && storageProfile.id;
                var storageProfileItem = this.findStorageProfileItem(storageSelectorData.storageProfilesData.storageProfiles, storageProfileId);
                storageSelectorData.initialConfig
                    .selectedStorageProfileInBasicMode = storageProfileItem;
                var replicationGroup = storageData.initialVmStorageConfig
                    .vmHome.replicationGroup;
                storageSelectorData.initialConfig.selectedReplicationGroupInBasicMode = replicationGroup;
            }
            else {
                if (!storageSelectorState.vmStorageConfigInAdvancedMode) {
                    // Тhis line is borrowed from StorageSelector::initAdvancedModeData
                    storageSelectorState.vmStorageConfigInAdvancedMode =
                        angular.copy(storageSelectorData.sourceVmStorageConfig);
                    var properVmStorageConfig = _.find(storageSelectorState.vmStorageConfigInAdvancedMode, function (currentVmStorageConfig) {
                        return currentVmStorageConfig.vmId === vmId;
                    });
                    if (properVmStorageConfig) {
                        var storageObj = storageData.initialVmStorageConfig.vmHome.storageObj;
                        var storageId = this.defaultUriSchemeUtil.getVsphereObjectId(storageObj && storageObj.storageRef);
                        properVmStorageConfig.vmHome.storageObj = this.findStorageItem(storageSelectorData.storageLocatorItemsData.datastoreItems, storageId);
                        properVmStorageConfig.vmHome.replicationGroup = storageData
                            .initialVmStorageConfig.vmHome.replicationGroup;
                        // NOTE: vmHome does not have diskFormat setting
                        var storageProfile = storageData.initialVmStorageConfig
                            .vmHome.storageProfile;
                        var storageProfileId = storageProfile && storageProfile.id;
                        var storageProfileItem = this.findStorageProfileItem(storageSelectorData.storageProfilesData.storageProfiles, storageProfileId);
                        properVmStorageConfig.vmHome.storageProfile = storageProfileItem;
                        _.each(properVmStorageConfig.vmDisks, function (properVmDisk) {
                            var initialVmDisk = _.find(storageData.initialVmStorageConfig.vmDisks, function (disk) {
                                return disk.key === properVmDisk.key;
                            });
                            if (!initialVmDisk) {
                                return;
                            }
                            var diskStorageObj = initialVmDisk.storageObj;
                            var diskStorageId = _this.defaultUriSchemeUtil.getVsphereObjectId(diskStorageObj && diskStorageObj.storageRef);
                            properVmDisk.storageObj = _this.findStorageItem(storageSelectorData.storageLocatorItemsData.datastoreItems, diskStorageId);
                            properVmDisk.diskFormat = initialVmDisk.diskFormat;
                            var diskProfile = initialVmDisk.storageProfile;
                            var diskProfileId = diskProfile && diskProfile.id;
                            var diskProfileItem = _this.findStorageProfileItem(storageSelectorData.storageProfilesData.storageProfiles, diskProfileId);
                            properVmDisk.storageProfile = diskProfileItem;
                            properVmDisk.replicationGroup = initialVmDisk.replicationGroup;
                        });
                    }
                }
            }
            return true;
        };
        InitialStorageConfigurationService.prototype.findStorageItem = function (listOfStorageLocatorItems, storageId) {
            var _this = this;
            return _.find(listOfStorageLocatorItems, function (item) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(item.storageRef) === storageId;
            });
        };
        InitialStorageConfigurationService.prototype.findStorageProfileItem = function (listOfStorageProfileItems, storageProfileId) {
            return _.find(listOfStorageProfileItems, function (sp) { return sp.id === storageProfileId; });
        };
        InitialStorageConfigurationService.$inject = [
            "$q",
            "defaultUriSchemeUtil",
            "mutationService",
            "diskProvisioningService",
            "storageProfileService",
            "vmDeviceInfoService"
        ];
        return InitialStorageConfigurationService;
    }());
    h5_vm.InitialStorageConfigurationService = InitialStorageConfigurationService;
    angular.module("com.vmware.vsphere.client.vm").service("initialStorageConfigurationService", InitialStorageConfigurationService);
})(h5_vm || (h5_vm = {}));



(function () {
   angular.module('com.vmware.vsphere.client.vm').service('nodeCountService', NodeCountService);

   NodeCountService.$inject = ['deviceClassLineageService'];

   function NodeCountService(deviceClassLineageService) {
      return { getMaxNodeCountForControllerType: getMaxNodeCountForControllerType };

      function getMaxNodeCountForControllerType (controllerType, deviceOptions, deviceType) {
         var deviceToKeySuffix = {
            VirtualDisk: 'Disks',
            VirtualCdrom: 'Cdroms'
         };

         var controllerTypeOptions = _.find(deviceOptions, function (option) {
            return deviceClassLineageService.isClassNameSubclassOf(
               controllerType,
               option.type.typeClass
            );
         });

         var matcher = new RegExp("^num\\w+" + deviceToKeySuffix[deviceType] + "$");
         var numDiskKey = _.find(_.keys(controllerTypeOptions), function (key) {
            return key.match(matcher);
         });
         if (!numDiskKey) {
            throw new Error('Could not find max node count for ' + deviceType);
         }

         return controllerTypeOptions[numDiskKey].max;
      }
   }
})();

/* Copyright 2015 Vmware, Inc. All rights reserved. -- Vmware Confidential */
/**
 * The open console service retrieves required params in order to open a console in a new browser tab
 */
angular.module('com.vmware.vsphere.client.vm')
      .factory('openConsoleService', ['$rootScope', '$q', 'dataService', 'userSessionExService', 'browserLanguage',
         function ($rootScope, $q, dataService, userSessionExService, browserLanguage) {

            /** Public method **/
            return {
               openConsole: openConsole
            };

            function openConsole(vmUid, vmId, serverGuid) {
               var host, sessionTicket, thumbprint, vmName, locale;

               var namePromise = dataService.getProperties(vmUid, ['name']).then(getVMName);
               var ticketPromise = userSessionExService.acquireCloneTicket(serverGuid).then(getTicketInfo);

               $q.all([namePromise, ticketPromise]).then(function() {
                  buildURLOpenConsole(vmId, vmName, serverGuid, host, sessionTicket, thumbprint);
               });

               //--- Implementations ---//
               function getVMName(response) {
                  vmName = response.name;
               }

               function getTicketInfo(cloneSessionInfo) {
                  host = getHostFromURL(cloneSessionInfo.serverInfo.serviceUrl);
                  sessionTicket = cloneSessionInfo.sessionTicket;
                  thumbprint = cloneSessionInfo.serverInfo.thumbprint;
                  locale = browserLanguage.get();

                  function getHostFromURL(url) {
                     var l = document.createElement("a");
                     l.href = url;
                     return l.host;
                  }
               }

               function buildURLOpenConsole(vmId, vmName, serverGuid, host, sessionTicket, thumbprint) {
                  window.open("webconsole.html?vmId=" + vmId + "&vmName=" + encodeURIComponent(vmName) + "&serverGuid=" + serverGuid +
                        "&host=" + host + '&sessionTicket=' + sessionTicket + '&thumbprint=' + thumbprint + '&locale=' + locale);
               }
            }

         }]);

var h5_vm;
(function (h5_vm) {
    // The hardware data model expected by the vmHardwareSummaryController.
    // This is a private class used for readability.  No need to keep it separate.
    var HardwareViewData = (function () {
        function HardwareViewData() {
        }
        return HardwareViewData;
    }());
    /**
     * Service converting the OvfTemplate hardware data to the format used by the VM hardware summary
     */
    var OvfTemplateHardwareDataMapping = (function () {
        function OvfTemplateHardwareDataMapping() {
        }
        OvfTemplateHardwareDataMapping.prototype.convertOvfTemplateHardwareData = function (data) {
            var hwData = new HardwareViewData();
            hwData.hardware = {
                numCPU: data.cpu.numCpus,
                memoryMB: data.memory.size,
                device: this.convertDevices(data)
            };
            hwData.cpuAllocation = {
                reservation: data.cpu.reservation ? data.cpu.reservation : 0,
                limit: data.cpu.limit ? data.cpu.limit : -1,
                shares: data.cpu.shares ? data.cpu.shares : "-"
            };
            hwData.memoryData = {
                memoryAllocation: {
                    reservation: data.memory.reservation ? data.memory.reservation : 0,
                    limit: data.memory.limit ? data.memory.limit : -1,
                    shares: data.memory.shares ? data.memory.shares : "-"
                },
                memoryUtilization: 0,
                isVmTemplate: true
            };
            return hwData;
        };
        // TODO usbControllerData?
        OvfTemplateHardwareDataMapping.prototype.convertDevices = function (data) {
            var devices = [];
            var self = this;
            if (data.diskData) {
                var key_1 = 2000;
                data.diskData.forEach(function (diskItem) {
                    devices.push({
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualDisk",
                        key: key_1++,
                        deviceInfo: {
                            label: diskItem.name
                        },
                        backing: {},
                        capacityInKB: diskItem.diskCapacity * 1014
                    });
                });
            }
            if (data.nicData) {
                var key_2 = 4000;
                data.nicData.forEach(function (nicItem) {
                    devices.push({
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualE1000",
                        key: key_2++,
                        deviceInfo: {
                            label: nicItem.name,
                            summary: nicItem.networkName
                        },
                        backing: {},
                        macAddress: nicItem.macAddress,
                        startConnected: nicItem.startConnected
                    });
                });
            }
            if (data.driveData) {
                var key_3 = 16000;
                data.driveData.forEach(function (driveItem) {
                    devices.push({
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualCdrom",
                        key: key_3++,
                        deviceInfo: {
                            label: driveItem.name,
                            type: driveItem.type,
                            subType: driveItem.subType
                        },
                        backing: {}
                    });
                });
            }
            if (data.floppyData) {
                var key_4 = 17000;
                data.floppyData.forEach(function (item) {
                    devices.push({
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualFloppy",
                        key: key_4++,
                        deviceInfo: {
                            label: item.name,
                            type: item.type
                        },
                        backing: {}
                    });
                });
            }
            if (data.videoCardData) {
                var key_5 = 500;
                data.videoCardData.forEach(function (item) {
                    devices.push({
                        _type: "com.vmware.vim.binding.vim.vm.device.VirtualVideoCard",
                        key: key_5++,
                        deviceInfo: {
                            label: item.name,
                            type: item.type
                        },
                        videoRamSizeInKB: item.videoRamSize,
                        numDisplays: item.numDisplays ? item.numDisplays : "-",
                        enable3DSupport: item.enable3d,
                        use3dRenderer: "-"
                    });
                });
            }
            if (data.diskControllerData) {
                var key_6 = 200;
                data.diskControllerData.forEach(function (ctrlItem) {
                    devices.push({
                        _type: self.getDeviceControllerType(ctrlItem),
                        key: key_6++,
                        deviceInfo: {
                            label: ctrlItem.name
                        },
                        backing: {}
                    });
                });
            }
            return devices;
        };
        OvfTemplateHardwareDataMapping.prototype.getDeviceControllerType = function (ctrlData) {
            switch (ctrlData.type) {
                case "SCSI":
                    return "com.vmware.vim.binding.vim.vm.device.VirtualSCSIController";
                case "IDE":
                    return "com.vmware.vim.binding.vim.vm.device.VirtualIDEController";
                // TODO complete this list if if makes sense for OvfTemplates
                default:
                    return "com.vmware.vim.binding.vim.vm.device.VirtualController";
            }
        };
        return OvfTemplateHardwareDataMapping;
    }());
    h5_vm.OvfTemplateHardwareDataMapping = OvfTemplateHardwareDataMapping;
    angular.module('com.vmware.vsphere.client.vm')
        .service('ovfTemplateHardwareDataMapping', OvfTemplateHardwareDataMapping);
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 Vmware, Inc. All rights reserved. -- Vmware Confidential */
/**
 * The open console service retrieves required params in order to open a console in a new browser tab
 */
angular.module('com.vmware.vsphere.client.vm')
      .factory('remoteConsoleService', ['$rootScope', '$q', 'dataService', 'userSessionExService', 'defaultUriSchemeUtil',
         function ($rootScope, $q, dataService, userSessionExService, defaultUriSchemeUtil) {

            /** Public method **/
            return {
               getRemoteConsoleUrl: getRemoteConsoleUrl
            };

            function getRemoteConsoleUrl(vmUid) {
               var sessionTicket, host;
               var remoteConsoleDeferred = $q.defer();

               var vmRef = defaultUriSchemeUtil.getManagedObjectReference(vmUid);

               userSessionExService.acquireCloneTicket(vmRef.serverGuid).then(getTicketInfo).then(function(info) {
                  remoteConsoleDeferred.resolve(retrieveRemoteConsoleUrl(info.sessionTicket, info.host, vmRef.value));
               });

               return remoteConsoleDeferred.promise;

               //--- Implementations ---//
               function getTicketInfo(cloneSessionInfo) {
                  host = getHostnameWithPort(cloneSessionInfo.serverInfo.serviceUrl);
                  sessionTicket = cloneSessionInfo.sessionTicket;

                  function getHostnameWithPort(url) {
                     var l = document.createElement("a");
                     l.href = url;
                     return l.host;
                  }

                  return {
                     host: host,
                     sessionTicket: sessionTicket
                  };

               }

               function retrieveRemoteConsoleUrl(sessionTicket, host, vmId) {
                  var remoteConsoleUrl = "vmrc://clone:" + sessionTicket + "@" + host + "/?moid=" + vmId;
                  return remoteConsoleUrl;
               }
            }

         }]);
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .service('selectIsoFileService', SelectIsoFileService);

   SelectIsoFileService.$inject = ['clarityModalService', 'i18nService',
      'defaultUriSchemeUtil', 'datastoreBrowserConstants'];

   function SelectIsoFileService(clarityModalService, i18nService,
         defaultUriSchemeUtil, datastoreBrowserConstants) {

      return {
         display: function (scope) {
            var selectedIsoFile;

            var contentUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/' +
                  'vmHardwareVirtualDisk/select-iso-file.view.html';
            var modalOptions = {
               title: i18nService.getString('Common', 'dsBrowser.defaultTitle'),
               contentTemplate: contentUrl,
               defaultButton: 'submit',
               size: 'lg',
               hideSubmitButton: false,
               submitDisabled: true,
               onSubmit: function () {
                  scope.device.backing.fileName = selectedIsoFile.path;
                  scope.$broadcast('isoDeviceBackingChange', scope.device.backing);
                  return true;
               }
            };

            var dsBrowserId = defaultUriSchemeUtil.getVsphereObjectId(
                  scope.vmConfigContext.environment.datastoreBrowser);
            var vmDatastores = scope.vmConfigContext.environment.configTarget.datastore;
            var datastoreIds = _.map(vmDatastores, function(vmDatastore) {
               return defaultUriSchemeUtil.getVsphereObjectId(vmDatastore.datastore.datastore);
            });
            var initialFileQueryType = datastoreBrowserConstants.fileQueryType.ISO_IMAGE
                  + datastoreBrowserConstants.fileQueryType.FOLDERS
                  + datastoreBrowserConstants.fileQueryType.FLOPPY_IMAGE;
            var filterQueryTypes = [{
                  label: i18nService.getString('Common', 'dsBrowser.isoImageFile'),
                  value: datastoreBrowserConstants.fileQueryType.ISO_IMAGE
                     + datastoreBrowserConstants.fileQueryType.FOLDERS
               },
               {
                  label: i18nService.getString('Common', 'dsBrowser.allFiles'),
                  value: datastoreBrowserConstants.fileQueryType.ALL_FILES
               }
            ];
            modalOptions.dsFileBrowserData = {
               datastoreBrowserId: dsBrowserId,
               datastoreIds: datastoreIds,
               initialFileQueryType: initialFileQueryType,
               filterFileQueryTypes: filterQueryTypes,
               showVmImagesFolder: true,
               selectedFileChanged: function (selectedFile) {
                  selectedIsoFile = selectedFile;
                  modalOptions.submitDisabled = !selectedIsoFile;
               }
            };

            clarityModalService.openOkCancelModal(modalOptions);
         }
      };
   }
})();

var h5_vm;
(function (h5_vm) {
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var VmHardwareDeviceMenuService = (function () {
        function VmHardwareDeviceMenuService(vmHardwareUtil, i18nService, featureFlagsService) {
            this.vmHardwareUtil = vmHardwareUtil;
            this.i18nService = i18nService;
            this.featureFlagsService = featureFlagsService;
            this.i18n = i18nService.getString;
        }
        VmHardwareDeviceMenuService.prototype.getAddDeviceActions = function (availablePrivileges, workflow, keysToFilterOut) {
            if (workflow === void 0) { workflow = h5_vm.VmWorkflowMode.UpdateMode; }
            if (keysToFilterOut === void 0) { keysToFilterOut = []; }
            var hasAddRemovePrivilege = this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE]);
            if (workflow === h5_vm.VmWorkflowMode.CreateMode) {
                // Generic add-remove privilege not needed for new VM.
                // Permissions for Disk, Existing disk, USB device and Raw Device still do matter even for new VM
                hasAddRemovePrivilege = true;
            }
            var filteredActions = this.getAllAddDeviceActions(availablePrivileges, hasAddRemovePrivilege);
            keysToFilterOut.map(function (key) {
                if (filteredActions.hasOwnProperty(key)) {
                    delete filteredActions[key];
                }
            });
            return filteredActions;
        };
        VmHardwareDeviceMenuService.prototype.getAllAddDeviceActions = function (availablePrivileges, hasAddRemovePrivilege) {
            return {
                addNewCdDvdDriveAction: {
                    id: "addNewCdDvdDriveAction",
                    label: this.i18n("VmUi", "VmDeviceManager.Cdrom"),
                    deviceType: "VirtualCdrom",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewUSBDeviceAction: {
                    id: "addNewUSBDeviceAction",
                    label: this.i18n("VmUi", "VmDeviceManager.USBDevice"),
                    deviceType: "VirtualUSB",
                    hasPrivilege: this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_HOST_USB_DEVICE])
                },
                addNewHardDiskAction: {
                    id: "addNewHardDiskAction",
                    label: this.i18n("VmUi", "VmDeviceManager.HardDisk"),
                    deviceType: "VirtualDisk",
                    hasPrivilege: this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_ADDNEWDISK_PRIVILEGE])
                },
                addNewRDMDiskAction: {
                    id: "addNewRDMDiskAction",
                    label: this.i18n("VmUi", "VmDeviceManager.RDMDisk"),
                    deviceType: "RDMDisk",
                    hasPrivilege: this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_RAWDEVICE_PRIVILEGE])
                },
                addExistingDiskAction: {
                    id: "addExistingDiskAction",
                    label: this.i18n("VmUi", "VmDeviceManager.ExistingHardDisk"),
                    deviceType: "ExistingHardDisk",
                    hasPrivilege: this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_ADDEXISTINGDISK_PRIVILEGE])
                },
                addNewNetworkAdapterAction: {
                    id: "addNewNetworkAdapterAction",
                    label: this.i18n("VmUi", "VmDeviceManager.NetworkAdapter"),
                    deviceType: "VirtualEthernetCard",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewSCSIControllerAction: {
                    id: "addNewSCSIControllerAction",
                    label: this.i18n("VmUi", "VmDeviceManager.SCSIController"),
                    deviceType: "VirtualSCSIController",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewUSBControllerAction: {
                    id: "addNewUSBControllerAction",
                    label: this.i18n("VmUi", "VmDeviceManager.USBController"),
                    deviceType: "VirtualUSBController",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewSATAControllerAction: {
                    id: 'addNewSATAControllerAction',
                    label: this.i18n('VmUi', 'VmDeviceManager.SATAController'),
                    deviceType: DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER,
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewNvdimmAction: {
                    id: "addNewNvdimmAction",
                    label: this.i18n("VmUi", "VmDeviceManager.NvDimm"),
                    deviceType: "VirtualNVDIMM",
                    hasPrivilege: this.hasPrivilegesToAddDevice(availablePrivileges, [h5_vm.Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE]),
                    featureFlag: this.isNvmFeatureFlagEnabled()
                },
                addNewNVMeControllerAction: {
                    id: "addNewNVMeControllerAction",
                    label: this.i18n("VmUi", "VmDeviceManager.NVME"),
                    deviceType: "VirtualNVMEController",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addPciSharedAction: {
                    id: "addPciSharedAction",
                    label: this.i18n("VmUi", "VmDeviceManager.SharedPCI"),
                    deviceType: "VirtualPCIPassthroughShared",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addPciDeviceAction: {
                    id: "addPciDeviceAction",
                    label: this.i18n("VmUi", "VmDeviceManager.PCIDevice"),
                    deviceType: "VirtualPCIPassthrough",
                    hasPrivilege: hasAddRemovePrivilege
                },
                addNewTpmAction: {
                    id: 'addNewTpmAction',
                    label: this.i18n('VmUi', 'VmDeviceManager.NewTPM'),
                    deviceType: 'VirtualTPM',
                    hasPrivilege: true,
                    featureFlag: this.isVTpmFeatureFlagEnabled()
                },
                addSerialPortAction: {
                    id: "addSerialPortAction",
                    label: this.i18n("VmUi", "VmDeviceManager.SerialPort"),
                    deviceType: DeviceTypeConstants.VIRTUAL_SERIAL_PORT,
                    hasPrivilege: hasAddRemovePrivilege
                }
            };
        };
        VmHardwareDeviceMenuService.prototype.isVTpmFeatureFlagEnabled = function () {
            return (typeof this.featureFlagsService.HWv14Enabled === 'function') ?
                this.featureFlagsService.HWv14Enabled() : false;
        };
        VmHardwareDeviceMenuService.prototype.isNvmFeatureFlagEnabled = function () {
            return (typeof this.featureFlagsService.PMemEnabled === "function") ?
                this.featureFlagsService.PMemEnabled() : false;
        };
        VmHardwareDeviceMenuService.prototype.hasPrivilegesToAddDevice = function (availablePrivileges, requiredPrivileges) {
            return this.vmHardwareUtil.checkPrivileges(availablePrivileges, requiredPrivileges);
        };
        VmHardwareDeviceMenuService.prototype.isAddDeviceMenuEnabled = function (menuItems) {
            return _.some(menuItems, function (menuItem) {
                return menuItem.enabled === true;
            });
        };
        VmHardwareDeviceMenuService.prototype.getAddDevicesMenuConfig = function (addDevice) {
            return {
                showMenu: false,
                menuItems: [],
                itemClick: addDevice
            };
        };
        VmHardwareDeviceMenuService.prototype.getAddDeviceMenuItems = function (addDeviceActionDefs) {
            var _this = this;
            var addDeviceItems = [];
            var actionDefinitions = _.values(addDeviceActionDefs);
            actionDefinitions.forEach(function (actionDef) {
                if (typeof actionDef.featureFlag === "undefined" || actionDef.featureFlag) {
                    var item = _this.getAddDeviceItem(actionDef);
                    addDeviceItems.push(item);
                }
            });
            return addDeviceItems;
        };
        VmHardwareDeviceMenuService.prototype.getAddDeviceItem = function (actionDef) {
            return {
                id: actionDef.id,
                label: actionDef.label,
                itemClick: actionDef.clickHandler,
                enabled: actionDef.hasPrivilege,
                featureFlag: actionDef.featureFlag
            };
        };
        VmHardwareDeviceMenuService.$inject = [
            "vmHardwareUtil",
            "i18nService",
            "featureFlagsService"
        ];
        return VmHardwareDeviceMenuService;
    }());
    h5_vm.VmHardwareDeviceMenuService = VmHardwareDeviceMenuService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareDeviceMenuService", VmHardwareDeviceMenuService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmStorageConfig = (function () {
        function VmStorageConfig() {
        }
        VmStorageConfig.prototype.getVmHomeProfile = function () {
            return this.vmHome && this.vmHome.storageProfile;
        };
        VmStorageConfig.prototype.getVmHomeStorage = function () {
            return this.vmHome && this.vmHome.storageObj;
        };
        VmStorageConfig.prototype.getReplicationGroupAssignments = function () {
            var result = [];
            if (this.vmHome && this.vmHome.replicationGroup) {
                result.push(this.vmHome.replicationGroup);
            }
            _.forEach(this.vmDisks, function (diskConfig) {
                if (diskConfig && diskConfig.replicationGroup) {
                    result.push(diskConfig.replicationGroup);
                }
            });
            return result;
        };
        return VmStorageConfig;
    }());
    h5_vm.VmStorageConfig = VmStorageConfig;
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 Vmware, Inc. All rights reserved. -- Vmware Confidential */
angular.module('com.vmware.vsphere.client.vm').factory('vmDeviceInfoService', [
   'i18nService',
   'deviceClassLineageService',
   'defaultUriSchemeUtil',
   'managedEntityConstants',
   function (
      i18nService,
      deviceClassLineageService,
      defaultUriSchemeUtil ,
      managedEntityConstants
   ) {
      // ----- Public API -------

      return {
         isDeviceSubclassOf: isDeviceSubclassOf,
         isDeviceInstanceOf: isDeviceInstanceOf,
         getEthernetCardLabel: getEthernetCardLabel,
         getScsiControllerLabel: getScsiControllerLabel,
         getStorageObjectLabel: getStorageObjectLabel,
         optionForDevice: optionForDevice,
         backingOptionForDevice: backingOptionForDevice,
         availableControllersForDevice: availableControllersForDevice,
         findCdromControllerNodes: findCdromControllerNodes,
         findHardDiskControllerNodes: findHardDiskControllerNodes,
         getControllerAndNodeLabelText: getControllerAndNodeLabelText,
         buildAvailableNetworkList: buildAvailableNetworkList,
         getNetworkInfo: getNetworkInfo,
         buildNetworkDeviceBacking: buildNetworkDeviceBacking,
         getDeviceEthernetCard: getDeviceEthernetCard
      };

      function isDeviceSubclassOf(rawDevice, className) {
         if(!rawDevice._type) {return false;}
         var simpleDeviceClassName = getSimpleDeviceClassName(rawDevice);
         return deviceClassLineageService.isClassNameSubclassOf(simpleDeviceClassName, className);
      }

      function isDeviceInstanceOf(rawDevice, className) {
         if(!rawDevice._type) {return false;}
         return getSimpleDeviceClassName(rawDevice) === getSimpleClassNameFromDeviceType(className);
      }

      function getDeviceEthernetCard(device) {
         return {
            name: device._type,
            typeClass: device._type,
            wsdlName: getSimpleClassNameFromDeviceType(device._type)
         };
      }

      function getEthernetCardLabel(deviceType) {
         var label;
         var getString = i18nService.getString;

         switch (getSimpleClassNameFromDeviceType(deviceType)) {
            case 'VirtualE1000':
               label = getString('VmUi', "NetworkConfig.E1000");
               break;
            case 'VirtualPCNet32':
               label = getString('VmUi', "NetworkConfig.PCNet32");
               break;
            case 'VirtualVmxnet3':
               label = getString('VmUi', "NetworkConfig.VirtualVmxnet3");
               break;
            case 'VirtualVmxnet3Vrdma':
               label = getString('VmUi', "NetworkConfig.VirtualVmxnet3Vrdma");
               break;
            case 'VirtualVmxnet2':
               label = getString('VmUi', "NetworkConfig.VirtualVmxnet2");
               break;
            case 'VirtualVmxnet':
               label = getString('VmUi', "NetworkConfig.VirtualVmxnet");
               break;
            case 'VirtualE1000e':
               label = getString('VmUi', "NetworkConfig.E1000e");
               break;
            case 'VirtualSriovEthernetCard':
               label = getString('VmUi', "NetworkConfig.Sriov");
               break;
            default:
               label = getString('VmUi', "NetworkConfig.Unknown");
         }

         return label;
      }

      function getScsiControllerLabel (controller) {
         return i18nService.getString('VmUi', 'SCSIControllerConfig.' + getSimpleDeviceClassName(controller));
      }

      function getStorageObjectLabel (storageObject, datastoreName,
            storageObjectIsStandaloneDS, storageNameMap) {
         if (!datastoreName) {
            if(storageObjectIsStandaloneDS && storageObject.name) {
               return storageObject.name;
            }

            return i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.GettingData');
         }
         var dsClusterName;
         var recommendedText;

         // If the storageObject is a cluster, then the datastoreName is the name of
         // the recommended datastore.
         if (storageObject.storageRef.type === managedEntityConstants.STORAGE_POD) {
            recommendedText = i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.Recommended');
            dsClusterName = storageObject.name;

            return i18nService
                  .getString('VmUi', 'ProvisioningWizardSummaryPage.PodAndDsRecommended',
                        dsClusterName, datastoreName, recommendedText, '');
         }

         // If the storageObject is datastore with a parent pod.
         if (!storageObjectIsStandaloneDS) {
            var storagePodUrn = defaultUriSchemeUtil
               .getVsphereObjectId(storageObject.parentStoragePod);
            dsClusterName = storageNameMap[storagePodUrn];

            return i18nService
                  .getString('VmUi', 'ProvisioningWizardSummaryPage.PodAndDsRecommended',
                        dsClusterName, datastoreName, '', '');
         }

         return datastoreName;
      }

      function optionForDevice (vmConfigContext, inflatedDevice, connectedInflatedDevices) {
         // Every device has a set of options that can be configured (disk mode, etc)
         var device = inflatedDevice.getCurrentDevice();

         // Finding the correct options set sometimes also requires knowing the controller
         //   type this device lives on (SATA, SCSI, IDE...) which is not information that
         //   lives directly on the device, so first we must find the controller. (Controllers
         //   are themselves a type of device so are included in the list of connected
         //   devices)/
         var inflatedController = _.find(connectedInflatedDevices, function (inflatedCandidate) {
            var candidate = inflatedCandidate.getCurrentDevice();
            return candidate.key === device.controllerKey;
         });

         if (!inflatedController) {
            throw new Error('Could not find controller with device id ' + device.controllerKey);
         }

         // Now that we know the device and controller, we can find the option set for that type
         var hardwareOptions = vmConfigContext.environment.configOption.hardwareOptions;
         return _.find(hardwareOptions.virtualDeviceOption, function (option) {
            return (option.type.name === device._type) &&
               (option.controllerType && isDeviceSubclassOf(inflatedController.getCurrentDevice(), option.controllerType.name));
         });
      }

      function backingOptionForDevice (vmConfigContext, inflatedDevice, allInflatedDevices) {
         var deviceOption = optionForDevice(vmConfigContext, inflatedDevice, allInflatedDevices);

         return _.find(deviceOption.backingOption, function (option) {
            return option.type.name === inflatedDevice.getCurrentDevice().backing._type;
         });
      }

      function availableControllersForDevice (inflatedDevice, allInflatedDevices) {
         var allowedTypes;
         if (inflatedDevice.isOfType('VirtualCdrom')) {
            allowedTypes = ['VirtualIDEController', 'VirtualSATAController'];
         } else if (inflatedDevice.isOfType('VirtualDisk')) {
            allowedTypes = ['VirtualIDEController', 'VirtualSATAController', 'VirtualSCSIController', 'VirtualNVMEController'];
         } else {
            throw new Error("Don't know what controllers are allowed for the device with type " + inflatedDevice.getCurrentDevice()._type);
         }

         return _.filter(allInflatedDevices, function (possibleInflatedController) {
            return isDeviceSubclassOfAny(possibleInflatedController, allowedTypes);
         });
      }

      function findCdromControllerNodes(controller, virtualDeviceOptions) {
         var keyRegex = /num\w+Cdrom/;
         return findControllerNodes(controller, virtualDeviceOptions, keyRegex);
      }

      function findHardDiskControllerNodes(controller, virtualDeviceOptions) {
         var keyRegex = /num\w+Disk/;
         return findControllerNodes(controller, virtualDeviceOptions, keyRegex);
      }

      function findControllerNodes(controller, virtualDeviceOptions, keyRegex) {
         var controllerOption = _.find(virtualDeviceOptions, function (option) {
            return option.type.typeClass === controller._type;
         });

         var numDeviceKey = _.find(_.keys(controllerOption), function (key) {
            return key.match(keyRegex);
         });

         var max = controllerOption[numDeviceKey].max;
         var nodes = [];
         for (var i = 0; i < max; i++) {
            nodes.push({
               controllerTypePrefix: displayPrefixForController(controller),
               controllerBusNumber: controller.busNumber,
               deviceUnitNumber: i
            });
         }

         return nodes;
      }

      function getControllerAndNodeLabelText(controllerType, controllerBusNumber, deviceUnitNumber) {
         var simpleDeviceClassName = getSimpleClassNameFromDeviceType(controllerType);

         var localizationKeySuffix = 'Ide';
         if (deviceClassLineageService.isClassNameSubclassOf(simpleDeviceClassName, 'VirtualSCSIController')) {
            localizationKeySuffix = 'Scsi';
         } else if (deviceClassLineageService.isClassNameSubclassOf(simpleDeviceClassName, 'VirtualSATAController')) {
            localizationKeySuffix = 'Sata';
         } else if (deviceClassLineageService.isClassNameSubclassOf(simpleDeviceClassName, 'VirtualNVMEController')) {
            localizationKeySuffix = 'Nvme';
         }

         return i18nService.getString('VmUi', 'ProvisioningWizardSummaryPage.VdNode' + localizationKeySuffix, controllerBusNumber, deviceUnitNumber);
      }

      function displayPrefixForController(controller) {
         if (isDeviceSubclassOf(controller, 'VirtualIDEController')) {
            return 'IDE';
         } else if (isDeviceSubclassOf(controller, 'VirtualSCSIController')) {
            return 'SCSI';
         } else if (isDeviceSubclassOf(controller, 'VirtualNVMEController')) {
            return 'NVME';
         } else if (isDeviceSubclassOf(controller, 'VirtualSATAController')) {
            return 'SATA';
         } else {
            throw new Error("Don't know how to render controller type prefix for a ", controller._type);
         }
      }

      function buildAvailableNetworkList(configTarget) {

         var availableNetworks = getAvailableNetworks(configTarget);

         _.each(availableNetworks, function(network) {
            var networkName = '', networkDetails = '';
            if (network) {
               if (network.portgroupName) {
                  networkName = network.portgroupName;
                  if (network.switchName) {
                     networkDetails = network.switchName;
                  }
               } else if (network.network) {
                  networkName = network.network.name;
                  if (network.network.opaqueNetworkType) {
                     networkDetails = network.network.opaqueNetworkType;
                  }
               }
            }
            if (networkDetails) {
               network.displayName = i18nService.getString('VmUi', 'VmHardwareView.networkDisplayName', networkName, networkDetails);
            } else {
               network.displayName = networkName;
            }
         });
         return availableNetworks;
      }

      function getNetworkInfo(configTarget, networkId) {

         var availableNetworks = getAvailableNetworks(configTarget);

         var moid;

         var result = _.find(availableNetworks, function(nw) {
            var type = nw._type;
            switch(type) {
               case h5_vm.NetworkType.STD_NETWORK:
               case h5_vm.NetworkType.NSX_NETWORK:
                  moid = nw.network.network; break;
               case h5_vm.NetworkType.DVSWITCH:
                  moid = nw.distributedVirtualSwitch; break;
               case h5_vm.NetworkType.DVPORGGROUP:
                  moid = nw.portgroup; break;
            }
            return networkId === defaultUriSchemeUtil.getVsphereObjectId(moid);
         });
         return result;
      }

      function buildNetworkDeviceBacking(network) {

         var backing;
         if (!network) {
            backing = {
               _type: h5_vm.NetBackingType.STD_NETWORK,
               deviceName: '',
               network: null
            };
            return backing;
         }

         switch(network._type) {
            case h5_vm.NetworkType.NSX_NETWORK:
               backing = {
                  _type: h5_vm.NetBackingType.NSX_NETWORK,
                  opaqueNetworkId: network.network.opaqueNetworkId,
                  opaqueNetworkType: network.network.opaqueNetworkType
               };
               break;
            case h5_vm.NetworkType.DVPORGGROUP:
               backing = {
                  _type: h5_vm.NetBackingType.DVPORGGROUP,
                  port: {
                     _type: 'com.vmware.vim.binding.vim.dvs.PortConnection',
                     portgroupKey: network.portgroupKey,
                     switchUuid: network.switchUuid
                  }
               };
               break;
            case h5_vm.NetworkType.STD_NETWORK:
               backing = {
                  _type: h5_vm.NetBackingType.STD_NETWORK,
                  deviceName: network.name,
                  network: angular.extend(network.network.network, {
                     'type': 'Network'
                  })
               };
               break;
         }

         return backing;
      }

      // ------ Private API -----

      function getSimpleClassNameFromDeviceType(fullyQualifiedClassName) {
         var index = fullyQualifiedClassName.lastIndexOf(".");
         if (index >= 0) {
            return fullyQualifiedClassName.substr(index + 1);
         }
         return fullyQualifiedClassName;
      }

      function isDeviceSubclassOfAny(inflatedDevice, types) {
         return _.any(types, function(type) {
            return isDeviceSubclassOf(inflatedDevice.getCurrentDevice(), type);
         });
      }

      function getSimpleDeviceClassName(rawDevice) {
         return getSimpleClassNameFromDeviceType(rawDevice._type);
      }

      function getAvailableNetworks(configTarget) {
         var portgroupTargets = _.filter(configTarget.distributedVirtualPortgroup, function (portgroupInfo) {
            return !portgroupInfo.uplinkPortgroup;
         });
         var targetNetworks = configTarget.network || [];
         var availableNetworks = targetNetworks.concat(portgroupTargets);

         var nsx = configTarget.opaqueNetwork || [];
         availableNetworks = availableNetworks.concat(nsx);

         return availableNetworks;
      }
   }]);

angular.module('com.vmware.vsphere.client.vm').factory('vmDeviceManagementService', [
   'vmDeviceInfoService',
   'opticalDriveService',
   'lunSelectorDialogService',
   'diskProvisioningService',
   'networkAdapterService',
   'scsiControllerService',
   'sataControllerService',
   'usbDeviceService',
   'usbControllerService',
   'nvmeControllerService',
   'pciSharedService',
   'existingHardDiskSelectorDialogService',
   'tpmProvisioningService',
   'nvdimmProvisioningService',
   'deviceTypeConstants',
   '$q',
   'i18nService',
   'vmCryptUtilService',
   'clarityModalService',
   'storageProfileService',
   'serialPortService',
   function(vmDeviceInfoService,
         opticalDriveService,
         lunSelectorDialogService,
         diskProvisioningService,
         networkAdapterService,
         scsiControllerService,
         sataControllerService,
         usbDeviceService,
         usbControllerService,
         nvmeControllerService,
         pciSharedService,
         existingHardDiskSelectorDialogService,
         tpmProvisioningService,
         nvdimmProvisioningService,
         deviceTypeConstants,
         $q,
         i18nService,
         vmCryptUtilService,
         clarityModalService,
         storageProfileService,
         serialPortService) {
      return {
         createNewDevice: function (
               deviceType,
               vmConfigEnvironment,
               guestOsDescriptor,
               virtualMachineDevices,
               additionalParameters) {
            var mergedInflatedDevices =
                  virtualMachineDevices.getAllDevicesNotMarkedForRemoval();

            var createdInflatedDeviceContainer;
            var deviceOptions = vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption;
            var configTarget = vmConfigEnvironment.configTarget;
            switch (deviceType) {
               case "VirtualUSBController":
                  createdInflatedDeviceContainer =
                        usbControllerService.makeDefaultUSBController(
                              guestOsDescriptor,
                              vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
                              virtualMachineDevices, additionalParameters);
                  break;
               case "VirtualUSB":
                  var hostUsbList = configTarget.usb;

                  var usb20 = virtualMachineDevices.devicesNotMarkedForRemovalOfType('VirtualUSBController');
                  var usb30 = virtualMachineDevices.devicesNotMarkedForRemovalOfType('VirtualUSBXHCIController');

                  if (_.isEmpty(usb20) && _.isEmpty(usb30)) {
                     this.createNewDevice('VirtualUSBController', vmConfigEnvironment, guestOsDescriptor, virtualMachineDevices, additionalParameters);
                  }

                  createdInflatedDeviceContainer = usbDeviceService.makeUSBDevice(
                        deviceOptions,
                        hostUsbList,
                        mergedInflatedDevices
                  );

                  break;

               case deviceTypeConstants.CDROM:
                  createdInflatedDeviceContainer = opticalDriveService.makeDefaultOpticalDrive(
                        vmConfigEnvironment,
                        guestOsDescriptor,
                        mergedInflatedDevices);
                  break;
               case deviceTypeConstants.VIRTUALDISK:
                  createdInflatedDeviceContainer =
                        diskProvisioningService.makeDefaultVirtualDisk(
                              vmConfigEnvironment,
                              guestOsDescriptor,
                              mergedInflatedDevices,
                              additionalParameters);
                  break;
               case deviceTypeConstants.RDMDISK:
                  var deferredRDM = $q.defer();
                  lunSelectorDialogService.openLunSelectorDialog(virtualMachineDevices.getRdmDisksNotMarkedForRemoval(),
                        vmConfigEnvironment, function (selectedItem) {
                           if (!selectedItem || _.isEmpty(selectedItem)) {
                              return ;
                           }
                           var createdInflatedDeviceContainer =
                                 diskProvisioningService.makeDefaultRDMDisk(
                                       vmConfigEnvironment,
                                       guestOsDescriptor,
                                       mergedInflatedDevices,
                                       additionalParameters,
                                       selectedItem[0]);
                           deferredRDM.resolve(addDevice(createdInflatedDeviceContainer, virtualMachineDevices));
                        });
                  return deferredRDM.promise;
               case deviceTypeConstants.EXISTINGHARDDISK:
                  var deferredExisting = $q.defer();
                  existingHardDiskSelectorDialogService.openExistingDiskSelectorDialog(vmConfigEnvironment, function (selectedFile) {
                     createdInflatedDeviceContainer = diskProvisioningService.makeDefaultVirtualDiskFromExistingDisk(
                           vmConfigEnvironment,
                           guestOsDescriptor,
                           mergedInflatedDevices,
                           additionalParameters,
                           selectedFile
                     );

                     if (createdInflatedDeviceContainer.device.isDiskAlreadyEncrypted()
                        && !vmCryptUtilService.isVmHomeEncrypted(
                           additionalParameters.vmConfigContext)) {
                        addEncryptedDiskToUnencryptedVm(deferredExisting, additionalParameters,
                           createdInflatedDeviceContainer, virtualMachineDevices);
                     } else {
                        deferredExisting.resolve(addDevice(createdInflatedDeviceContainer, virtualMachineDevices));
                     }
                  });
                  return deferredExisting.promise;
               case deviceTypeConstants.ETHERNET:
                  createdInflatedDeviceContainer =
                        networkAdapterService.makeDefaultNetworkAdapter(
                              vmConfigEnvironment,
                              guestOsDescriptor);
                  break;

               case deviceTypeConstants.VirtualPCIPassthrough:
                  createdInflatedDeviceContainer = pciSharedService.createPciDevice(vmConfigEnvironment, virtualMachineDevices);
                  break;

               case deviceTypeConstants.VirtualPCIPassthrough + "Shared":
                  createdInflatedDeviceContainer = pciSharedService.createPciSharedDevice(vmConfigEnvironment, virtualMachineDevices);
                  break;

               case deviceTypeConstants.SCSICONTROLLER:
                  createdInflatedDeviceContainer =
                        scsiControllerService.makeDefaultSCSIController(
                              guestOsDescriptor,
                              vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
                              virtualMachineDevices);
                  break;
               case deviceTypeConstants.NVME_CONTROLLER:
                  createdInflatedDeviceContainer =
                        nvmeControllerService.makeDefaultNVMeController(
                              guestOsDescriptor,
                              vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
                              virtualMachineDevices,
                              vmConfigEnvironment.powerState);
                  break;
               case deviceTypeConstants.VIRTUAL_SATA_CONTROLLER:
                  createdInflatedDeviceContainer =
                     sataControllerService.makeDefaultSataController(
                        vmConfigEnvironment.configOption.hardwareOptions.virtualDeviceOption,
                        virtualMachineDevices);
                  break;
               case deviceTypeConstants.TPM:
                  createdInflatedDeviceContainer =
                        tpmProvisioningService.makeDefaultTpm(additionalParameters.serverGuid,
                              additionalParameters.callback);
                  break;
               case deviceTypeConstants.NVDIMM:
                  createdInflatedDeviceContainer =
                        nvdimmProvisioningService.makeDefaultNvdimm(vmConfigEnvironment,
                              guestOsDescriptor,
                              virtualMachineDevices,
                              additionalParameters);
                  break;
               case deviceTypeConstants.VIRTUAL_SERIAL_PORT:
                  createdInflatedDeviceContainer = serialPortService.makeDefaultSerialPort(
                        vmConfigEnvironment, virtualMachineDevices);
                  break;
               default:
                  throw new Error('Unknown device: ' + deviceType);
            }
            return $q.when(addDevice(createdInflatedDeviceContainer, virtualMachineDevices));
         }
      };

      function addDevice(createdInflatedDeviceContainer, virtualMachineDevices) {
         if (!createdInflatedDeviceContainer || !createdInflatedDeviceContainer.device) {
            return;
         }

         var virtualDeviceForDeviceController =
               createdInflatedDeviceContainer.controller;
         if (virtualDeviceForDeviceController) {
            if(!virtualMachineDevices.getVirtualDevice(
                  virtualDeviceForDeviceController.getKey())) {
               virtualMachineDevices.addVirtualDevice(virtualDeviceForDeviceController);
            }
         }

         virtualMachineDevices.addVirtualDevice(createdInflatedDeviceContainer.device);
         return createdInflatedDeviceContainer.device.getKey();
      }

      function addEncryptedDiskToUnencryptedVm(promise, additionalParameters, createdInflatedDeviceContainer, virtualMachineDevices) {
         clarityModalService.openConfirmationModal({
            message: i18nService.getString('VmUi', 'VmCryptConfig.alert.addEncryptedDisk'),
            clarityIcon: {
               shape: "warning",
               class: "is-warning",
               size: 48
            },
            showXIcon: false,
            preserveNewlines: true,
            saveButtonLabel: i18nService.getString("Common", "yes.label"),
            cancelButtonLabel: i18nService.getString("Common", "no.label"),
            submit: function() {
               // Choose an encryption profile
               if (!additionalParameters.storageProfiles
                  || additionalParameters.storageProfiles.$$state.status !== 1
                  || !additionalParameters.storageProfiles.$$state.value) {
                  promise.reject();
                  return;
               }

               var encryptionProfile = vmCryptUtilService.findEncryptionProfile(
                  additionalParameters.storageProfiles.$$state.value);
               if (!encryptionProfile) {
                  promise.reject();
                  showWarning(i18nService.getString('VmUi', 'VmCryptConfig.reason.noEncryptionPolicies'));
                  return;
               }

               // Check KMS servers availability
               vmCryptUtilService.getDefaultKmipServerStatus(additionalParameters.serverGuid, true)
                  .then(function(response) {
                     // When the user doesn't have permission to aggregate the KMS statuses,
                     // don't stop him because he will still be able to create encrypted VM
                     // if the KMS servers are OK.
                     var noPermission = response && response.h5DefaultKmipClusterStatus
                        && response.h5DefaultKmipClusterStatus.noPermission;

                     var isConnectionNormal = response && response.h5DefaultKmipClusterStatus &&
                        response.h5DefaultKmipClusterStatus.connectionStatus === h5_vm.ConnectionStatus.CONNECTED;
                     var isCertificateExpired = response && response.h5DefaultKmipClusterStatus &&
                        response.h5DefaultKmipClusterStatus.certificateStatus === h5_vm.CertStatus.EXPIRED;

                     if (!noPermission && !isConnectionNormal) {
                        promise.reject();
                        showWarning(i18nService.getString('VmUi', 'VmCryptConfig.reason.noKms'));
                        return;
                     }
                     if (!noPermission && isCertificateExpired) {
                        promise.reject();
                        showWarning(i18nService.getString('VmUi', 'VmCryptConfig.reason.kmsCertificateRequiresUpdate'));
                        return;
                     }

                     addEncryptedDisk(promise, encryptionProfile, additionalParameters,
                           createdInflatedDeviceContainer, virtualMachineDevices);
                  }, function() {
                     // if the kms status can not be retrieved proceed as if
                     // the status is correct
                     addEncryptedDisk(promise, encryptionProfile, additionalParameters,
                           createdInflatedDeviceContainer, virtualMachineDevices);
                  });
            },
            onCancel: function () {
               promise.reject();
            }
         });
      }

      function addEncryptedDisk(promise, encryptionProfile, additionalParameters, createdInflatedDeviceContainer, virtualMachineDevices) {
         // Encrypt the VM
         var encryptionProfileSpec =
               storageProfileService.makeProfile(encryptionProfile.id);
         additionalParameters.vmConfigContext.vmProfile = [encryptionProfileSpec];

         // Assign the encryption profile to the disk
         createdInflatedDeviceContainer.device.setOriginalProfile(encryptionProfileSpec);
         createdInflatedDeviceContainer.device.updateDiskProfile(encryptionProfile);

         promise.resolve({
            newVmProfile: encryptionProfile,
            newDeviceKey: addDevice(createdInflatedDeviceContainer, virtualMachineDevices)
         });
      }

      function showWarning(message) {
         clarityModalService.openConfirmationModal({
            message: message,
            clarityIcon: {
               shape: 'warning',
               class: 'is-warning',
               size: 48
            },
            showXIcon: false,
            hideCancelButton: true,
         });
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var HARDWARE_DATA = 'com.vmware.vsphere.client.vm.model.HardwareConfigData';
    var VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY = 'VirtualMachine/vmStorageProfileAssignments';
    var HARDWARE_DATA_RESULT = 'hardwareDataResult';
    var STORAGE_PROFILES_RESULT = 'storageProfilesResult';
    var VM_STORAGE_PROFILE_ASSIGNMENTS_RESULT = 'vmStorageProfileAssignmentsResult';
    var HAS_ADD_REMOVE_DEVICE_PRIVILEGE_RESULT = 'hasAddRemoveDevicePrivilegeResult';
    var VmHardwareBaseService = (function () {
        function VmHardwareBaseService(vmHardwareUtil, dataService, vmNetworkService, defaultUriSchemeUtil, storageProfileService, $q, vmDeviceInfoService, VirtualMachineDevices) {
            this.vmHardwareUtil = vmHardwareUtil;
            this.dataService = dataService;
            this.vmNetworkService = vmNetworkService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.storageProfileService = storageProfileService;
            this.$q = $q;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.VirtualMachineDevices = VirtualMachineDevices;
        }
        VmHardwareBaseService.prototype.getDataPromises = function (vmId) {
            var hardwareDataPromise = this.dataService.getData(vmId, HARDWARE_DATA);
            var promises = {};
            promises[HARDWARE_DATA_RESULT] = hardwareDataPromise;
            return this.$q.all(promises);
        };
        VmHardwareBaseService.prototype.useData = function (vmId, properties) {
            var hardwareData = properties[HARDWARE_DATA_RESULT];
            var storageProfiles = properties[STORAGE_PROFILES_RESULT];
            var configTargets = hardwareData.vmConfigContext.environment.configTarget;
            var availableNetworks = this.vmDeviceInfoService.buildAvailableNetworkList(configTargets);
            var guestOsFamilyKey = hardwareData.guestOsFamilyKey;
            var vmStorageProfileAssignments = properties[VM_STORAGE_PROFILE_ASSIGNMENTS_RESULT];
            if (vmStorageProfileAssignments) {
                if (vmStorageProfileAssignments.hasOwnProperty(VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY)) {
                    vmStorageProfileAssignments = vmStorageProfileAssignments[VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY];
                }
            }
            var hasAddRemoveDevicePrivilege = properties[HAS_ADD_REMOVE_DEVICE_PRIVILEGE_RESULT];
            var result = {
                vmConfigContext: hardwareData.vmConfigContext,
                originalConfig: angular.copy(hardwareData.vmConfigContext.config),
                privileges: {
                    hasAddRemoveDevicePrivilege: hasAddRemoveDevicePrivilege
                },
                availableNetworks: availableNetworks,
                storageProfiles: storageProfiles,
                guestOsFamilyKey: guestOsFamilyKey,
                vmStorageProfileAssignments: undefined
            };
            if (vmStorageProfileAssignments !== null) {
                result.vmStorageProfileAssignments = vmStorageProfileAssignments;
            }
            return result;
        };
        VmHardwareBaseService.prototype.getAndFormatData = function (vmId) {
            var _this = this;
            return this.getDataPromises(vmId).then(function (properties) {
                return _this.useData(vmId, properties);
            });
        };
        VmHardwareBaseService.prototype.getVmNetworkInfo = function (networkProviderId, vmNetworkDevices) {
            return this.vmNetworkService.getVmNetworkInfo(networkProviderId, vmNetworkDevices);
        };
        VmHardwareBaseService.prototype.buildVirtualDevices = function (hardwareData) {
            var virtualDeviceOptionsByDeviceType = _.indexBy(hardwareData.vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption, function (deviceOption) {
                return deviceOption.type.name;
            });
            var virtualMachineDevices = new this.VirtualMachineDevices(hardwareData.vmConfigContext.config.hardware.device, hardwareData.vmStorageProfileAssignments, hardwareData.storageProfiles, hardwareData.availableNetworks, virtualDeviceOptionsByDeviceType);
            return virtualMachineDevices;
        };
        VmHardwareBaseService.VIRTUAL_ETHERNET_CARD = 'VirtualEthernetCard';
        return VmHardwareBaseService;
    }());
    h5_vm.VmHardwareBaseService = VmHardwareBaseService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareBaseService', VmHardwareBaseService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    angular.module('com.vmware.vsphere.client.vm').service('vmHardwareCdromManagerService', [
        '$q',
        'i18nService',
        'EditableVirtualDevice',
        'vmHardwareUtil',
        'featureFlagsService',
        'contentLibraryService',
        'vcService',
        function ($q, i18nService, EditableVirtualDevice, vmHardwareUtil, featureFlagsService, contentLibraryService, vcService) {
            var EMULATION_ID = 1;
            var PASSTHROUGH_ID = 2;
            var CLIENT_DEVICE = 'CdromConfig.ClientDevice';
            var DATASTORE_ISO_FILE = 'CdromConfig.DatastoreISOFile';
            var CONTENT_LIBRARY_ISO_FILE = 'CdromConfig.CLISOFile';
            var HOST_DEVICE = 'CdromConfig.HostDevice';
            var NOT_AVAILABLE_HOST_DEVICE = 'NotAvailableHostDevice';
            var EMULATION_MODE = {
                label: i18nService.getString('VmUi', 'CdromConfig.EmulateCdrom'),
                id: EMULATION_ID
            };
            var PASSTHROUGH_MODE = {
                label: i18nService.getString('VmUi', 'CdromConfig.PassthroughCdrom'),
                id: PASSTHROUGH_ID
            };
            var cdromList;
            return {
                createCdromList: createCdromList,
                createIsoBacking: createIsoBacking,
                getNewDeviceBacking: getNewDeviceBacking,
                createClientDeviceBacking: createClientDeviceBacking,
                getAvailableMediaTypes: getAvailableMediaTypes,
                getInitialMediaType: getInitialMediaType,
                getInitialDeviceMode: getInitialDeviceMode,
                getAvailableDeviceModes: getAvailableDeviceModes,
                isClientDevice: isClientDevice,
                isDevicePresentInTheHost: isDevicePresentInTheHost,
                isHostDevice: isHostDevice,
                isDatastoreISOFile: isDatastoreISOFile,
                isContentLibraryISOFile: isContentLibraryISOFile,
                isRemoteDevice: isRemoteDevice,
                isCdRomDisabled: isCdRomDisabled,
                isCdRomConnectedAtPowerOnDisabled: isCdRomConnectedAtPowerOnDisabled,
                isCdRomConnectedDisabled: isCdRomConnectedDisabled,
                isDeviceModeDisabled: isDeviceModeDisabled,
                hasPrivileges: hasPrivileges,
                hasHostDevicebacking: hasHostDevicebacking
            };
            function hasPrivileges(privileges) {
                return vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE]);
            }
            function createCdromList(rawCdromList) {
                cdromList = _.map(rawCdromList, function (cdrom, idx) {
                    return {
                        id: idx,
                        name: cdrom.name
                    };
                });
                return cdromList;
            }
            function createIsoBacking(isoFileName, datastore, backingObjectId) {
                return {
                    _type: "com.vmware.vim.binding.vim.vm.device.VirtualCdrom$IsoBackingInfo",
                    fileName: isoFileName,
                    datastore: datastore ? datastore : null,
                    backingObjectId: backingObjectId ? backingObjectId : null
                };
            }
            // this method also updates scope.properties.deviceMode :(
            function getNewDeviceBacking(properties) {
                var mediaTypeId = properties.mediaType.id;
                var backing;
                if (mediaTypeId === HOST_DEVICE) {
                    properties.deviceMode = EMULATION_MODE;
                    if (cdromList.length > 0) {
                        properties.selectedCdrom = cdromList[0];
                        backing = createHostDeviceBacking(properties.selectedCdrom);
                    }
                }
                else if (mediaTypeId === CLIENT_DEVICE) {
                    backing = createClientDeviceBacking(properties.deviceMode);
                }
                return backing;
            }
            function createClientDeviceBacking(deviceMode) {
                var backing = {
                    deviceName: ""
                };
                if (deviceMode.id === EMULATION_ID) {
                    backing._type = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$RemoteAtapiBackingInfo';
                }
                else if (deviceMode.id === PASSTHROUGH_ID) {
                    backing._type = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$RemotePassthroughBackingInfo';
                    backing.exclusive = false;
                }
                else {
                    throw new Error("Unknown mode: " + deviceMode);
                }
                return backing;
            }
            function getAvailableMediaTypes(cdromList, objectId) {
                return vcService.is65VcOrLater(objectId)
                    .then(function (is65VcOrLater) {
                    var mediaTypeKeys = getMediaTypeKeys(cdromList, is65VcOrLater);
                    return _.map(mediaTypeKeys, function (key) {
                        return {
                            id: key,
                            label: i18nService.getString('VmUi', key)
                        };
                    });
                });
            }
            function getAvailableDeviceModes() {
                return [PASSTHROUGH_MODE, EMULATION_MODE];
            }
            function isClientDevice(mediaType) {
                return mediaType && mediaType.id === CLIENT_DEVICE;
            }
            function isRemoteDevice(backing) {
                return backing._type.indexOf('Remote') >= 0;
            }
            function isHostDevice(mediaType) {
                return mediaType && mediaType.id === HOST_DEVICE;
            }
            function isDatastoreISOFile(mediaType) {
                return mediaType && mediaType.id === DATASTORE_ISO_FILE;
            }
            function isContentLibraryISOFile(mediaType) {
                return mediaType && mediaType.id === CONTENT_LIBRARY_ISO_FILE;
            }
            function hasHostDevicebacking(device) {
                if (!_.isEmpty(device) &&
                    device.backing &&
                    device.backing._type === "com.vmware.vim.binding.vim.vm.device.VirtualCdrom$AtapiBackingInfo") {
                    return true;
                }
                return false;
            }
            // the two below are only used once to initialize scope.properties
            // i thought about making a function that initializes properties and return the
            // correct object, but then it's not as clear what's really on scope.properties   ¯\_(ツ)_/¯
            function getInitialDeviceMode(backingType) {
                if (backingType.match('Passthrough')) {
                    return PASSTHROUGH_MODE;
                }
                else {
                    return EMULATION_MODE;
                }
            }
            function getInitialMediaType(backing, availableMediaTypes) {
                var deferred = $q.defer();
                var backingType = backing._type;
                if (backingType.match('IsoBackingInfo')) {
                    var DS_ISO_FILE = findMediaType(DATASTORE_ISO_FILE);
                    var CL_ISO_FILE_1 = findMediaType(CONTENT_LIBRARY_ISO_FILE);
                    // by default return at least normal ISO,
                    // unless we successfully query ContentLibrary
                    var retVal_1 = { mediaType: DS_ISO_FILE };
                    contentLibraryService.getContentLibraryItemByDatastorePath(backing.fileName)
                        .then(function (result) {
                        var Item = (function () {
                            function Item() {
                            }
                            return Item;
                        }());
                        var item = result.contentLibraryItemByDatastorePath;
                        var errors = item ? item.errorMessages : [];
                        var failed = Array.isArray(errors) && errors.length > 0;
                        // We using friendlyName filed to fill in html input.
                        // It also hooked to validation via "required" attribute.
                        var friendlyName = item ? item.friendlyName : "";
                        if (!friendlyName || friendlyName === "") {
                            // fail back to normal ISO if missing friendly name
                            failed = true;
                        }
                        if (item && !failed) {
                            retVal_1 = { mediaType: CL_ISO_FILE_1, selectedIsoItem: item };
                        }
                        deferred.resolve(retVal_1);
                    }, function (error) {
                        // returning as Datastore ISO in case of CL error
                        deferred.resolve(retVal_1);
                    });
                }
                else if (backing._type.match('Remote')) {
                    deferred.resolve({
                        mediaType: findMediaType(CLIENT_DEVICE)
                    });
                }
                else {
                    var hostDevice = findMediaType(HOST_DEVICE);
                    //If the host doesn't have cd, the host device is not available
                    if (!hostDevice) {
                        hostDevice = {
                            id: NOT_AVAILABLE_HOST_DEVICE
                        };
                    }
                    deferred.resolve({
                        mediaType: hostDevice
                    });
                }
                function findMediaType(id) {
                    return _.find(availableMediaTypes, function (element) {
                        return element.id === id;
                    });
                }
                return deferred.promise;
            }
            function isCdRomDisabled(privileges, skipPrivilegeCheck) {
                if (skipPrivilegeCheck) {
                    return false;
                }
                var hasPrivilege = vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.SetCDMedia']);
                return !hasPrivilege;
            }
            function isCdRomConnectedAtPowerOnDisabled(mediaType, privileges, skipPrivilegeCheck) {
                var validate = function () {
                    return isClientDevice(mediaType);
                };
                if (skipPrivilegeCheck) {
                    return validate();
                }
                var hasPrivilege = vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.DeviceConnection']);
                return !hasPrivilege || validate();
            }
            function isCdRomConnectedDisabled(backing, privileges, skipPrivilegeCheck) {
                var validate = function () {
                    return isRemoteDevice(backing);
                };
                if (skipPrivilegeCheck) {
                    return validate();
                }
                var hasPrivilege = vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.DeviceConnection']);
                return !hasPrivilege || validate();
            }
            function isDevicePresentInTheHost(deviceName, cdRomList) {
                if (_.isEmpty(cdRomList)) {
                    return false;
                }
                return _.some(cdRomList, function (device) {
                    return device.name === deviceName;
                });
            }
            function isDeviceModeDisabled(mediaType, privileges, skipPrivilegeCheck) {
                var validate = function () {
                    return isDatastoreISOFile(mediaType) || isContentLibraryISOFile(mediaType) || isHostDevice(mediaType);
                };
                if (skipPrivilegeCheck) {
                    return validate();
                }
                var hasPrivilege = vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Interact.SetCDMedia']);
                return !hasPrivilege || validate();
            }
            // ----- private ----- //
            function getMediaTypeKeys(cdromList, is65VcOrLater) {
                var keys = [];
                keys.push(CLIENT_DEVICE);
                if (cdromList.length > 0) {
                    keys.push(HOST_DEVICE);
                }
                keys.push(DATASTORE_ISO_FILE);
                if (featureFlagsService.h5uiDirectIsoMountFromCLEnabled && is65VcOrLater) {
                    keys.push(CONTENT_LIBRARY_ISO_FILE);
                }
                return keys;
            }
            function createHostDeviceBacking(selectedCdrom) {
                return {
                    _type: "com.vmware.vim.binding.vim.vm.device.VirtualCdrom$AtapiBackingInfo",
                    deviceName: selectedCdrom.name
                };
            }
        }
    ]);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmHardwareBaseService = h5_vm.VmHardwareBaseService;
    var VmConfigContext = com.vmware.vsphere.client.vm.config.VmConfigContext;
    var VmHardwareCloneService = (function (_super) {
        __extends(VmHardwareCloneService, _super);
        function VmHardwareCloneService(vmFactoryService, vmHardwareUtil, dataService, vmNetworkService, defaultUriSchemeUtil, storageProfileService, $q, vmDeviceInfoService, VirtualMachineDevices, managedEntityConstants, deviceTypeConstants) {
            _super.call(this, vmHardwareUtil, dataService, vmNetworkService, defaultUriSchemeUtil, storageProfileService, $q, vmDeviceInfoService, VirtualMachineDevices);
            this.vmFactoryService = vmFactoryService;
            this.managedEntityConstants = managedEntityConstants;
            this.deviceTypeConstants = deviceTypeConstants;
            this.CONFIG_PROPERTY = "config";
            this.STORAGE_PROFILES_PROPERTY = "vmStorageProfileAssignments";
            this.CONFIG_RESULT = "configResult";
            this.STORAGE_PROFILES_RESULT = "spResult";
            this.PARENT_PRIVILEGES_RESULT = "parentPrivilegesResult";
        }
        VmHardwareCloneService.prototype.getAndFormatData = function (vmParams, wizardViewData) {
            var _this = this;
            var dataPromises = this.getPromises(vmParams);
            return dataPromises.then(function (dataResults) {
                var hardwareDataProperties = _.extend({}, dataResults[_this.CONFIG_RESULT], dataResults[_this.STORAGE_PROFILES_RESULT]);
                // set the vmVersion, so that the config environment can be retrieved for it
                // in the next call
                vmParams.setVmVersion(hardwareDataProperties.config.version);
                // retrieve the environment
                return vmParams.getVmConfigEnvironment().then(function (poolProperties) {
                    var result = _this.buildHardwareData(vmParams, wizardViewData, poolProperties, hardwareDataProperties, dataResults[_this.PARENT_PRIVILEGES_RESULT]);
                    if (vmParams.getRecreateVm() || !vmParams.getVmConfigSpec()) {
                        result.virtualMachineDevices = _this.buildVirtualDevices(result);
                        _this.vmFactoryService.buildCloneVM(vmParams, result.vmConfigContext, result.virtualMachineDevices, result.originalConfig, result.vmStorageProfileAssignments);
                        vmParams.setRecreateVm(false);
                        // Still need to assign resourcePool after fetching environment,
                        // see CustomizeHardwareProvisioningPageMediator#onEnvironmentLoaded in Flex
                        result.vmConfigContext.environment.configTarget.resourcePool =
                            vmParams.getResourcePool().runtime;
                    }
                    else {
                        // The storage on some other disk than the vmx can be changed on the storage page,
                        // so here we recreate the storage info according to vmParams.getStorageDiskList
                        var virtualDisks = result.virtualMachineDevices.existingDevicesOfType(_this.deviceTypeConstants.VIRTUALDISK);
                        _this.vmFactoryService.applyStorageToVirtualDisks(virtualDisks, result.vmStorageProfileAssignments, vmParams);
                    }
                    var vmConfigSpecConfig = vmParams.getVmConfigSpec();
                    result.vmConfigContext.config = vmConfigSpecConfig;
                    result.virtualMachineDevices = vmParams.getVirtualMachineDevices();
                    // return hardwareConfigData;
                    return _this.getVmNetworkInfoForClone(vmParams).then(function (networkInfoData) {
                        result.networkProviderId = networkInfoData.networkProviderId;
                        result.availableNetworks = networkInfoData.availableNetworks;
                        return result;
                    });
                });
            });
        };
        VmHardwareCloneService.prototype.getVmNetworkInfoForClone = function (vmParams) {
            var networkProviderId = vmParams.getComputeResourceId();
            var vmNetworkDevices = vmParams.getVirtualMachineDevices()
                .existingDevicesOfType(VmHardwareBaseService.VIRTUAL_ETHERNET_CARD);
            return _super.prototype.getVmNetworkInfo.call(this, networkProviderId, vmNetworkDevices);
        };
        VmHardwareCloneService.prototype.getPromises = function (vmParams) {
            var vmConfigPromise = this.dataService.getProperties(vmParams.getVmId(), [this.CONFIG_PROPERTY]);
            var vmStorageProfileAssignmentsPromise = this.dataService
                .getProperties(vmParams.getVmId(), [this.STORAGE_PROFILES_PROPERTY], 
            // Suppress error notification as it is likely to fail if SPS is down
            { skipErrorInterceptor: true })
                .catch(function () { return { "vmStorageProfileAssignments": undefined }; });
            var promises = {};
            promises[this.CONFIG_RESULT] = vmConfigPromise;
            promises[this.STORAGE_PROFILES_RESULT] = vmStorageProfileAssignmentsPromise;
            promises[this.PARENT_PRIVILEGES_RESULT] = vmParams.getPrivileges();
            return this.$q.all(promises);
        };
        /**
         * Builds an object containing the needed hardware data used for building the
         * `Customize hardware page`
         */
        VmHardwareCloneService.prototype.buildHardwareData = function (vmParams, wizardViewData, poolProperties, hardwareDataProperties, privileges) {
            var vmConfigEnvironment = poolProperties.vmConfigEnvironmentPerPool;
            var availableNetworks = this.getAvailableNetworks(vmConfigEnvironment);
            var hardwareConfig = this.createConfigInfoObject(hardwareDataProperties[this.CONFIG_PROPERTY]);
            var vmConfigContext = new VmConfigContext();
            vmConfigContext.environment = vmConfigEnvironment;
            vmConfigContext.config = angular.copy(hardwareConfig);
            vmConfigContext.privileges = privileges;
            var guestOsDescriptor = _.find(vmConfigEnvironment.configOption.guestOSDescriptor, function (descriptor) {
                return descriptor.id === vmParams.getGuestOsId();
            });
            var result = {
                originalConfig: hardwareConfig,
                selectedStorageProfile: vmParams.getSelectedStorageProfile(),
                selectedReplicationGroupInfo: vmParams.getSelectedReplicationGroupInfo(),
                vmConfigContext: vmConfigContext,
                guestOsFamilyKey: guestOsDescriptor ? guestOsDescriptor.family : null,
                filterNetworksObjId: vmParams.getFilterNetworksObjectId(),
                virtualMachineDevices: vmParams.getVirtualMachineDevices(),
                networkProviderId: null,
                availableNetworks: availableNetworks,
                storageProfiles: wizardViewData.getStorageProfiles()
            };
            if (hardwareDataProperties[this.STORAGE_PROFILES_PROPERTY] !== null) {
                result.vmStorageProfileAssignments =
                    hardwareDataProperties[this.STORAGE_PROFILES_PROPERTY];
            }
            return result;
        };
        /**
         * Returns a config info object and adds the correct type to it,
         * since it is missing when returned from the backend,
         * but is needed when the object is sent
         * @param hardwareDataProperties
         * @returns {any}
         */
        VmHardwareCloneService.prototype.createConfigInfoObject = function (hardwareDataProperties) {
            return angular.extend({ _type: "com.vmware.vim.binding.vim.vm.ConfigInfo" }, hardwareDataProperties);
        };
        VmHardwareCloneService.prototype.getAvailableNetworks = function (vmConfigEnvironment) {
            var configTargets = vmConfigEnvironment.configTarget;
            var availableNetworks = this.vmDeviceInfoService.buildAvailableNetworkList(configTargets);
            return availableNetworks;
        };
        VmHardwareCloneService.$inject = [
            "vmFactoryService",
            "vmHardwareUtil",
            "dataService",
            "vmNetworkService",
            "defaultUriSchemeUtil",
            "storageProfileService",
            "$q",
            "vmDeviceInfoService",
            "VirtualMachineDevices",
            "managedEntityConstants",
            "deviceTypeConstants"
        ];
        return VmHardwareCloneService;
    }(VmHardwareBaseService));
    h5_vm.VmHardwareCloneService = VmHardwareCloneService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareCloneService", VmHardwareCloneService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var SharesInfo = com.vmware.vim.binding.vim.SharesInfo;
    var VmHardwareCpuService = (function () {
        function VmHardwareCpuService(vmHardwareUtil, guestOsService, cpuClockFilter, i18nService) {
            this.vmHardwareUtil = vmHardwareUtil;
            this.guestOsService = guestOsService;
            this.cpuClockFilter = cpuClockFilter;
            this.i18nService = i18nService;
            this.i18n = i18nService.getString;
        }
        VmHardwareCpuService.prototype.getVmCapabilities = function (vmConfigContext) {
            var retVal = vmConfigContext.environment.configOption.capabilities;
            return retVal;
        };
        VmHardwareCpuService.prototype.getHostCapabilities = function (vmConfigContext) {
            var retVal = vmConfigContext.environment.hostCapability;
            return retVal;
        };
        VmHardwareCpuService.prototype.isNumCpuEnabled = function (powerState, config, isFtVm, guest, privileges, createMode) {
            if (createMode) {
                return true;
            }
            if (isFtVm) {
                return false;
            }
            if (!this.haveCpuCountPermission(privileges)) {
                return false;
            }
            var support = (guest ? guest.supportsCpuHotAdd : false);
            if (config.cpuHotAddEnabled === false || support === false) {
                if (this.isPowerOnState(powerState)) {
                    return false;
                }
            }
            if (this.isSuspendedState(powerState)) {
                return false;
            }
            return true;
        };
        VmHardwareCpuService.prototype.isCreatingNewVm = function (createMode) {
            var retVal = false;
            if (createMode) {
                retVal = true;
            }
            return retVal;
        };
        ;
        VmHardwareCpuService.prototype.isReservationEnabled = function (ctx, createMode) {
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (!this.haveChangeResourcePermission(ctx)) {
                return false;
            }
            return true;
        };
        ;
        VmHardwareCpuService.prototype.isLimitEnabled = function (ctx, createMode) {
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (!this.haveChangeResourcePermission(ctx)) {
                return false;
            }
            return true;
        };
        ;
        VmHardwareCpuService.prototype.isSharesEnabled = function (ctx, createMode) {
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (!this.haveChangeResourcePermission(ctx)) {
                return false;
            }
            return true;
        };
        ;
        VmHardwareCpuService.prototype.isNestedHVSupportedOnVmAndHost = function (ctx) {
            var vm_capabilities = this.getVmCapabilities(ctx);
            var host_capabilities = this.getHostCapabilities(ctx);
            var vm_supported = vm_capabilities.nestedHVSupported;
            var host_supported = host_capabilities.nestedHVSupported;
            var retVal = (vm_supported === true) && (host_supported === true);
            return retVal;
        };
        VmHardwareCpuService.prototype.isNestedHVEnabled = function (ctx, createMode) {
            var supported = this.isNestedHVSupportedOnVmAndHost(ctx);
            if (supported !== true) {
                return false;
            }
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (this.isPoweredOn(ctx)) {
                return false;
            }
            if (!this.haveSettingsPermission(ctx)) {
                return false;
            }
            return true;
        };
        ;
        VmHardwareCpuService.prototype.isCpuIdEnabled = function (ctx, createMode) {
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (this.isPoweredOn(ctx)) {
                return false;
            }
            if (this.isSuspended(ctx)) {
                return false;
            }
            if (!this.haveSettingsPermission(ctx)) {
                return false;
            }
            return true;
        };
        ;
        VmHardwareCpuService.prototype.isCpuMmuEnabled = function (ctx, createMode) {
            if (this.isCreatingNewVm(createMode)) {
                return true;
            }
            if (!this.haveSettingsPermission(ctx)) {
                return false;
            }
            return true;
        };
        VmHardwareCpuService.prototype.isSuspended = function (ctx) {
            if (ctx.environment.powerState === 'suspended') {
                return true;
            }
            return false;
        };
        VmHardwareCpuService.prototype.isPoweredOn = function (ctx) {
            if (this.isPowerOnState(ctx.environment.powerState)) {
                return true;
            }
            return false;
        };
        VmHardwareCpuService.prototype.isSuspendedState = function (state) {
            if (state === 'suspended') {
                return true;
            }
            return false;
        };
        VmHardwareCpuService.prototype.isPowerOnState = function (state) {
            if (state === 'poweredOn') {
                return true;
            }
            return false;
        };
        VmHardwareCpuService.prototype.haveCpuCountPermission = function (privileges) {
            var CPU_COUNT = 'VirtualMachine.Config.CPUCount';
            var retVal = this.vmHardwareUtil.checkPrivileges(privileges, [CPU_COUNT]);
            return retVal;
        };
        VmHardwareCpuService.prototype.haveChangeResourcePermission = function (vmConfigContext) {
            var privileges = vmConfigContext.privileges;
            var CONFIG_RESOURCE = 'VirtualMachine.Config.Resource';
            var retVal = this.vmHardwareUtil.checkPrivileges(privileges, [CONFIG_RESOURCE]);
            return retVal;
        };
        VmHardwareCpuService.prototype.haveSettingsPermission = function (vmConfigContext) {
            var retVal = this.vmHardwareUtil.haveVmConfigSettingsPermission(vmConfigContext);
            return retVal;
        };
        VmHardwareCpuService.prototype.checkPrivileges = function (id, privileges) {
            var retVal = this.vmHardwareUtil.checkPrivileges(privileges, [id]);
            return retVal;
        };
        VmHardwareCpuService.prototype.isCpuHotPlugEnabled = function (vmPowerState, ftState, ftInfo, guestOs, privileges, createMode) {
            var gOsCpuHotAddEnabled = (guestOs ? guestOs.supportsCpuHotAdd : false);
            if (vmPowerState === 'poweredOn' || this.vmHardwareUtil.isFtVm(ftState, ftInfo) || !gOsCpuHotAddEnabled) {
                return false;
            }
            return !!(this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.CPUCount']) || createMode);
        };
        /**
         * Helper method to populate the list of acceptable values for number of cores
         * per socket. It also populates data provider for number of cores per socket.
         * Called when numCPU or guest OS changes.
         */
        VmHardwareCpuService.prototype.buildSupportedCoresPerSocket = function (vmConfigContext, originalConfig, guestOs) {
            var result = [];
            var isMultipleCoresPerSocketSupported = vmConfigContext.environment.configOption.
                capabilities.multipleCoresPerSocketSupported;
            var numCPU = vmConfigContext.config.hardware.numCPU;
            var maxCoresPerSocket;
            if (isMultipleCoresPerSocketSupported) {
                maxCoresPerSocket = Math.min(guestOs.numSupportedCoresPerSocket, vmConfigContext.environment.configOption.hardwareOptions.numCoresPerSocket.max, numCPU);
            }
            else {
                maxCoresPerSocket = 1;
            }
            for (var i = 1; i <= maxCoresPerSocket; i++) {
                var sockets = numCPU / i;
                if (((numCPU % i) !== 0) ||
                    (sockets > guestOs.numSupportedPhysicalSockets)) {
                    continue;
                }
                result.push(i);
            }
            var originalCoresPerSocket = originalConfig.hardware.numCoresPerSocket;
            var originalNumCPU = originalConfig.hardware.numCPU;
            if (result.length === 0) {
                if (numCPU === originalNumCPU) {
                    result.push(originalCoresPerSocket);
                }
                else {
                    result.push(1);
                }
            }
            return result;
        };
        /**
         * Helper method to populate the list of acceptable values for number of virtual CPUs.
         * Called when guest OS changes.
         */
        VmHardwareCpuService.prototype.buildSupportedCpus = function (vmConfigContext, guestOs, createMode) {
            if (!(vmConfigContext.environment && vmConfigContext.environment.configTarget
                && vmConfigContext.environment.configOption)) {
                return [];
            }
            var hostMax = vmConfigContext.environment.configTarget.numCpus;
            var gosMax = guestOs.supportedMaxCPUs;
            var numSupportedPhysicalSockets = guestOs.numSupportedPhysicalSockets;
            var numCoresPerSocket = vmConfigContext.config.hardware.numCoresPerSocket;
            var poweredOn = (vmConfigContext.environment.powerState === 'poweredOn');
            var hotAddEnabled = this.isHotAddEnabled(vmConfigContext, guestOs);
            var hotRemoveEnabled = this.isHotRemoveEnabled(vmConfigContext, guestOs);
            var originalCpuNumber = vmConfigContext.config.hardware.numCPU;
            var canAdd = !poweredOn || (poweredOn && hotAddEnabled);
            var canRemove = !poweredOn || (poweredOn && hotRemoveEnabled);
            var isMultipleCoresPerSocketSupported = vmConfigContext.environment.configOption.
                capabilities.multipleCoresPerSocketSupported;
            // Indicates if cores per socket value of this VM is editable.
            var isCoresPerSocketEditable = !poweredOn && isMultipleCoresPerSocketSupported;
            var privileges = vmConfigContext.privileges;
            var hasPrivilege = this.checkPrivilege(privileges, 'VirtualMachine.Config.CPUCount', createMode);
            var acceptableCpus = vmConfigContext.environment.configOption.hardwareOptions.numCPU;
            var supportedCpus = [];
            var isValidCpuNumber = function (cpuNumber, hostMax, gosMax) {
                return ((hostMax < 0) || (cpuNumber <= hostMax)) && ((gosMax < 0) || (cpuNumber <= gosMax));
            };
            var canCpuNumberChange = function (cpuNumber, originalCpuNumber, canRemove, canAdd) {
                return (cpuNumber === originalCpuNumber) ||
                    ((cpuNumber < originalCpuNumber) && canRemove) ||
                    ((cpuNumber > originalCpuNumber) && canAdd);
            };
            _.forEach(acceptableCpus, function (cpuNumber) {
                if (isValidCpuNumber(cpuNumber, hostMax, gosMax) &&
                    canCpuNumberChange(cpuNumber, originalCpuNumber, canRemove, canAdd)) {
                    // Further restrict list of valid values for number of CPUs if
                    // VM is hot (or generally speaking cores per socket is not editable).
                    // In this case number of CPUs should be multiple of cores per socket and
                    // number of sockets should obey guest OS limits
                    if (isMultipleCoresPerSocketSupported
                        && !isCoresPerSocketEditable
                        && hasPrivilege
                        && ((cpuNumber % numCoresPerSocket) > 0 ||
                            (cpuNumber / numCoresPerSocket) > numSupportedPhysicalSockets)) {
                        return;
                    }
                    supportedCpus.push(cpuNumber);
                }
            });
            return supportedCpus;
        };
        /**
         * Indicates if virtual processors can be added while this
         * virtual machine is running.
         */
        VmHardwareCpuService.prototype.isHotAddEnabled = function (vmConfigContext, guestOs) {
            // It is possible hotAddEnabled flag in the backend to be true
            // although the guest OS does not support hot add operations.
            // This happens when VM was previously configured with more advanced guest OS
            // that supports hot add and hot add is enabled by user. Then if VM is reconfigured
            // to use guest OS w/o hot add support, hotAddEnabled flag remains enabled.
            // We should not show that CPU hot add is enabled, when gos
            // does not support it, although the UI is disabled.
            return vmConfigContext.config.cpuHotAddEnabled
                && guestOs.supportsCpuHotAdd;
        };
        /**
         * Indicates if virtual processors can be removed while this
         * virtual machine is running AND guest supports that.
         */
        VmHardwareCpuService.prototype.isHotRemoveEnabled = function (vmConfigContext, guestOs) {
            // see comments for hotAddEnabled
            return vmConfigContext.config.cpuHotRemoveEnabled
                && guestOs.supportsCpuHotRemove;
        };
        VmHardwareCpuService.prototype.checkPrivilege = function (privileges, privilege, createMode) {
            if (privileges) {
                return privileges.indexOf(privilege) > -1;
            }
            else if (createMode) {
                return true;
            }
            return false;
        };
        VmHardwareCpuService.prototype.getMaxReservation = function (configContext) {
            // See CpuConfig.as#onResourceAllocChange for original implementation
            var minUpperLimit = 0;
            var numCpus = configContext.config.hardware.numCPU;
            var mhzPerCore = configContext.environment.hostCpuMhz;
            var vmPoweredOn = this.vmHardwareUtil.isVmPoweredOn(configContext.environment.powerState);
            var isInCluster = configContext.environment.isInCluster;
            var cpuUsage = configContext.environment.configTarget.resourcePool.cpu;
            var maxUsage = cpuUsage.maxUsage;
            var limit = configContext.config.cpuAllocation.limit;
            var reservation = configContext.config.cpuAllocation.reservation;
            var configuredReservation = reservation ? reservation : 0;
            var min = 0;
            if (vmPoweredOn) {
                min = configuredReservation;
            }
            var maxCpuReservPhysLimit = maxUsage;
            if (mhzPerCore) {
                maxCpuReservPhysLimit = numCpus * mhzPerCore;
            }
            if (!vmPoweredOn) {
                minUpperLimit = Math.max(maxUsage, configuredReservation);
            }
            else {
                if (cpuUsage.unreservedForVm !== -1) {
                    minUpperLimit = cpuUsage.unreservedForVm;
                }
                minUpperLimit += min;
            }
            if ((minUpperLimit > maxCpuReservPhysLimit) && !isInCluster) {
                if (!vmPoweredOn) {
                    minUpperLimit = Math.min(maxCpuReservPhysLimit, cpuUsage.unreservedForVm);
                }
                else {
                    minUpperLimit = Math.min(maxCpuReservPhysLimit, minUpperLimit);
                }
            }
            var reservationMaxLimit;
            if (limit !== -1) {
                reservationMaxLimit = Math.min(limit, minUpperLimit);
            }
            else {
                reservationMaxLimit = minUpperLimit;
            }
            return reservationMaxLimit;
        };
        VmHardwareCpuService.prototype.formatEnabledDisabled = function (isEnabled) {
            if (isEnabled) {
                return this.i18n('VmUi', 'VmCpuView.Enabled');
            }
            else {
                return this.i18n('VmUi', 'VmCpuView.Disabled');
            }
        };
        VmHardwareCpuService.prototype.formatRecommendations = function (recommendations) {
            var _this = this;
            _.each(recommendations, function (r) {
                r.formattedValue = _this.cpuClockFilter(r.value);
            });
        };
        VmHardwareCpuService.prototype.isCpuIdMaskExposed = function (configContext) {
            // See CpuIdConfig.as#examineNxState for the full proper implementation of this
            var mask;
            if (configContext.config.cpuFeatureMask && configContext.config.cpuFeatureMask.length > 0) {
                mask = configContext.config.cpuFeatureMask[0];
            }
            else {
                mask = configContext.environment.configOption.guestOSDescriptor[0].cpuFeatureMask[0];
            }
            if (mask.edx && mask.edx[11] === 'H') {
                return true;
            }
            return false;
        };
        /**
         * Verify that the virtual machine is turned off.
         * Verify that the virtual machine does not reside in a DRS cluster.
         * Verify that the host has more than one physical processor core.
         *
         * @returns {boolean}
         */
        VmHardwareCpuService.prototype.isSchedulingAffinityShown = function (configContext) {
            var isVmPoweredOn = this.vmHardwareUtil.isVmPoweredOn(configContext.environment.powerState);
            var isInCluster = configContext.environment.isInCluster;
            var hasMultipleCpus = configContext.environment.configTarget.numCpus > 1;
            return !isVmPoweredOn && !isInCluster && hasMultipleCpus;
        };
        VmHardwareCpuService.prototype.isSchedulingAffinityEnabled = function (configContext, createMode) {
            if (createMode) {
                return true;
            }
            return this.checkPrivilege(configContext.privileges, "VirtualMachine.Config.Resource");
        };
        VmHardwareCpuService.prototype.getAffinityDisplayValue = function (affinitySet) {
            var current;
            var previous = affinitySet[0], rest = affinitySet.slice(1);
            var rangeStart = affinitySet[0], remaining = affinitySet.slice(1);
            var result = [];
            var addToResult = function (rangeStart, current) {
                if (rangeStart !== current) {
                    result.push(rangeStart + "-" + current);
                }
                else {
                    result.push(current);
                }
            };
            for (var i = 0; i < affinitySet.length; i++) {
                current = affinitySet[i];
                if (i > 0 && current !== previous + 1) {
                    addToResult(rangeStart, previous);
                    rangeStart = current;
                }
                previous = current;
            }
            addToResult(rangeStart, current);
            return result.join(",");
        };
        VmHardwareCpuService.prototype.getCpuAffinitySignpostContext = function (configContext) {
            // See VmCpuPageMediator.as#initCpuAffinity for original implementation
            var affinityText, htStatus, numProcs;
            var numCpus = configContext.environment.configTarget.numCpus;
            var numCpuCores = configContext.environment.configTarget.numCpuCores;
            if (numCpus === 0 || numCpuCores === 0) {
                htStatus = this.i18n('VmUi', 'Affinity.HyperThreading.Unknown');
                numProcs = this.i18n('VmUi', 'Affinity.NumProcs.Unknown', numCpuCores);
                affinityText = this.i18n('VmUi', 'Affinity.SelectAffinity.Unknown');
            }
            else if (numCpuCores !== numCpus) {
                htStatus = this.i18n('VmUi', 'Affinity.HyperThreading.Active');
                numProcs = this.i18n('VmUi', 'Affinity.NumProcs.Logical', numCpus);
                affinityText = this.i18n('VmUi', 'Affinity.SelectAffinity.Logical');
            }
            else {
                htStatus = this.i18n('VmUi', 'Affinity.HyperThreading.Inactive');
                numProcs = this.i18n('VmUi', 'Affinity.NumProcs.Physical', numCpuCores);
                affinityText = this.i18n('VmUi', 'Affinity.SelectAffinity.Physical');
            }
            return {
                i18n: this.i18nService.getString,
                affinityText: affinityText,
                htStatus: htStatus,
                numProcs: numProcs
            };
        };
        /**
         * Validates CPU scheduling affinity pattern
         *
         * @param affinity CPU affinity pattern (e.g. "0,1-3,4,6")
         * @param numCpus
         *
         * @return {boolean}
         */
        VmHardwareCpuService.prototype.validateAffinity = function (affinity, numCpus) {
            // return true if affinity is "empty"
            if (affinity.trim() === "") {
                return true;
            }
            var isValidNumber = function (input) {
                return input && !isNaN(Number(input));
            };
            var affinitySets = affinity.split(",");
            for (var _i = 0, affinitySets_1 = affinitySets; _i < affinitySets_1.length; _i++) {
                var set = affinitySets_1[_i];
                var range = set.trim().split('-');
                if (range.length === 2) {
                    var start = range[0], end = range[1];
                    var startAffinity = void 0;
                    var endAffinity = void 0;
                    if (isValidNumber(start)) {
                        startAffinity = Number(start);
                    }
                    else {
                        return false;
                    }
                    if (isValidNumber(end)) {
                        endAffinity = Number(end);
                    }
                    else {
                        return false;
                    }
                    if (startAffinity > endAffinity || endAffinity > numCpus - 1) {
                        return false;
                    }
                }
                else if (range.length === 1) {
                    var value = range[0];
                    var affinityValue = void 0;
                    if (isValidNumber(value)) {
                        affinityValue = Number(value);
                        if (affinityValue > numCpus - 1) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            return true;
        };
        /**
         * Transform an affinity string to an affinity set
         * Assumes affinity input is valid
         *
         * @param {string} affinity
         * @returns {Array<number>}
         *
         */
        VmHardwareCpuService.prototype.transformAffinity = function (affinity) {
            var affinitySet = [];
            if (affinity.trim() === '') {
                return affinitySet;
            }
            var affinitySets = affinity.split(',');
            for (var _i = 0, affinitySets_2 = affinitySets; _i < affinitySets_2.length; _i++) {
                var set = affinitySets_2[_i];
                var range = set.trim().split('-');
                if (range.length === 2) {
                    var start = range[0], end = range[1];
                    var startAffinity = Number(start);
                    var endAffinity = Number(end);
                    for (var i = startAffinity; i <= endAffinity; i++) {
                        affinitySet.push(i);
                    }
                }
                else if (range.length === 1) {
                    var value = range[0];
                    var affinityValue = Number(value);
                    affinitySet.push(affinityValue);
                }
            }
            return affinitySet;
        };
        VmHardwareCpuService.prototype.setUpSharesInfo = function (ctx, createMode) {
            var sharesInfo = new SharesInfo();
            sharesInfo.level = "normal";
            sharesInfo.shares = 1000;
            var allocation = ctx.config.cpuAllocation;
            if (!allocation) {
                return sharesInfo;
            }
            var info = allocation.shares;
            if (this.isSharesEnabled(ctx, createMode)) {
                sharesInfo = info;
            }
            else if (info) {
                sharesInfo.level = info.level;
                sharesInfo.shares = info.shares;
            }
            return sharesInfo;
        };
        VmHardwareCpuService.$inject = [
            'vmHardwareUtil',
            'guestOsService',
            'cpuClockFilter',
            'i18nService'
        ];
        return VmHardwareCpuService;
    }());
    h5_vm.VmHardwareCpuService = VmHardwareCpuService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareCpuService', VmHardwareCpuService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareBaseService = h5_vm.VmHardwareBaseService;
    var VmHardwareCreateService = (function () {
        function VmHardwareCreateService(vmFactoryService, authorizationService, vmHardwareVersionService, vmNetworkService, i18nService, $q) {
            this.vmFactoryService = vmFactoryService;
            this.authorizationService = authorizationService;
            this.vmHardwareVersionService = vmHardwareVersionService;
            this.vmNetworkService = vmNetworkService;
            this.i18nService = i18nService;
            this.$q = $q;
        }
        VmHardwareCreateService.prototype.getVmNetworkInfo = function (networkProviderId, vmNetworkDevices) {
            return this.vmNetworkService.getVmNetworkInfo(networkProviderId, vmNetworkDevices);
        };
        VmHardwareCreateService.prototype.getVmNetworkInfoForCreate = function (vmParams, virtualMachineDevices) {
            var networkProviderId = vmParams.getComputeResourceId();
            var vmNetworkDevices = virtualMachineDevices.newDevicesOfType(VmHardwareBaseService.VIRTUAL_ETHERNET_CARD);
            return this.getVmNetworkInfo(networkProviderId, vmNetworkDevices);
        };
        VmHardwareCreateService.prototype.getAndFormatData = function (vmParams, wizardViewData) {
            var _this = this;
            return vmParams.getVmConfigEnvironment().then(function (poolProperties) {
                var vmConfigEnvironment = poolProperties.vmConfigEnvironmentPerPool;
                var virtualMachineDevices = vmParams.getVirtualMachineDevices();
                var scheduledTaskData = vmParams.getScheduledData();
                var isScheduledTask = !_.isEmpty(scheduledTaskData) && scheduledTaskData.useScheduledTaskData;
                if (vmParams.getRecreateVm() || !vmParams.getVmConfigSpec()) {
                    virtualMachineDevices = _this.vmFactoryService.buildVirtualDevicesForCreate(vmConfigEnvironment, isScheduledTask);
                }
                var promises = {
                    networkInfoForCreate: _this.getVmNetworkInfoForCreate(vmParams, virtualMachineDevices),
                    folderRequiredPrivileges: vmParams.getPrivileges(),
                    retrieveGosDescriptor: _this.$q.when()
                };
                if (vmParams.shouldRetrieveGosDescriptor()) {
                    promises.retrieveGosDescriptor = vmParams.retrieveGosDescriptor();
                }
                return _this.$q.all(promises).then(function (result) {
                    if (!_.isEmpty(result.retrieveGosDescriptor)) {
                        vmConfigEnvironment.configOption.guestOSDescriptor[0] =
                            result.retrieveGosDescriptor.vmConfigGuestOsDescriptor;
                    }
                    var grantedFolderPrivileges = result.folderRequiredPrivileges;
                    if (vmParams.getRecreateVm() || !vmParams.getVmConfigSpec()) {
                        var vmData = _this.vmFactoryService.buildNewVM(vmConfigEnvironment, vmParams, virtualMachineDevices, grantedFolderPrivileges);
                        var vmConfigSpec = vmData.vmConfigSpec;
                        vmParams.setVirtualMachineDevices(vmData.virtualMachineDevices);
                        vmParams.setVmConfigSpec(vmConfigSpec);
                        vmParams.setRecreateVm(false);
                        // Still need to assign resourcePool after fetching environment,
                        // see CustomizeHardwareProvisioningPageMediator#onEnvironmentLoaded in Flex
                        vmConfigEnvironment.configTarget.resourcePool = vmParams.getResourcePool().runtime;
                    }
                    var vmConfigSpecConfig = vmParams.getVmConfigSpec().config;
                    var hardwareConfigData = {
                        originalConfig: angular.copy(vmConfigSpecConfig),
                        selectedStorageProfile: vmParams.getSelectedStorageProfile(),
                        selectedReplicationGroupInfo: vmParams.getSelectedReplicationGroupInfo(),
                        storageProfiles: wizardViewData.getStorageProfiles(),
                        vmVersion: _this.i18nService.getString("VmUi", "VmHardware.HWVersion.vmVersionLabel", _this.vmHardwareVersionService.getLongText(vmConfigSpecConfig.version)),
                        vmConfigContext: {
                            environment: vmConfigEnvironment,
                            config: vmConfigSpecConfig,
                            privileges: grantedFolderPrivileges
                        },
                        guestOsFamilyKey: poolProperties.guestOsFamilyKey,
                        virtualMachineDevices: vmParams.getVirtualMachineDevices(),
                        filterNetworksObjId: vmParams.getFilterNetworksObjectId(),
                        networkProviderId: result.networkInfoForCreate.networkProviderId,
                        availableNetworks: result.networkInfoForCreate.availableNetworks
                    };
                    return hardwareConfigData;
                });
            });
        };
        VmHardwareCreateService.$inject = [
            "vmFactoryService",
            "authorizationService",
            "vmHardwareVersionService",
            "vmNetworkService",
            "i18nService",
            "$q"
        ];
        return VmHardwareCreateService;
    }());
    h5_vm.VmHardwareCreateService = VmHardwareCreateService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareCreateService", VmHardwareCreateService);
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmHardwareBaseService = h5_vm.VmHardwareBaseService;
    var VmHardwareEditService = (function (_super) {
        __extends(VmHardwareEditService, _super);
        function VmHardwareEditService($rootScope, vmFactoryService, mutationService, storageLocatorService, vcH5ConstantsService, vmHardwareUtil, dataService, vmNetworkService, defaultUriSchemeUtil, storageProfileService, $q, vmDeviceInfoService, VirtualMachineDevices) {
            _super.call(this, vmHardwareUtil, dataService, vmNetworkService, defaultUriSchemeUtil, storageProfileService, $q, vmDeviceInfoService, VirtualMachineDevices);
            this.$rootScope = $rootScope;
            this.vmFactoryService = vmFactoryService;
            this.mutationService = mutationService;
            this.storageLocatorService = storageLocatorService;
            this.vcH5ConstantsService = vcH5ConstantsService;
        }
        VmHardwareEditService.prototype.getHost = function (ctx) {
            var rtHostId = this.defaultUriSchemeUtil.getVsphereObjectId(ctx.rtInfo.host);
            return rtHostId;
        };
        VmHardwareEditService.prototype.fetchProfiles = function (vmId) {
            var serverGuid = this.defaultUriSchemeUtil.getManagedObjectReference(vmId).serverGuid;
            return this.storageProfileService.fetchProfiles(serverGuid);
        };
        VmHardwareEditService.prototype.fetchAssignments = function (vmId) {
            var names = ["vmStorageProfileAssignments"];
            return this.dataService.getProperties(vmId, names);
        };
        VmHardwareEditService.prototype.fetchRgroups = function (vmId) {
            var names = ["vmReplicationGroupAssignments"];
            return this.dataService.getProperties(vmId, names);
        };
        VmHardwareEditService.prototype.getVmConfigContext = function (vmId) {
            var _this = this;
            var CTX = "vmConfigContext";
            var promise = this.dataService.getProperties(vmId, [CTX]);
            var retVal = promise.then(function (properties) {
                var ctx = properties[CTX];
                var data = { hardwareDataResult: { vmConfigContext: ctx } };
                return _super.prototype.useData.call(_this, vmId, data);
            });
            return retVal;
        };
        VmHardwareEditService.prototype.getAndFormatData = function (vmId) {
            var _this = this;
            var cfgContext = this.$q.when(this.getVmConfigContext(vmId));
            var retVal = cfgContext.then(function (data) {
                var profiles = _this.fetchProfiles(vmId);
                var assignments = _this.fetchAssignments(vmId);
                var rgroups = _this.fetchRgroups(vmId);
                var retVal = _this.postProcess(data, profiles, assignments, rgroups);
                return retVal;
            });
            return retVal;
        };
        ;
        VmHardwareEditService.prototype.postProcess = function (data, profiles, assignments, rgroups) {
            var host = data.vmConfigContext.rtInfo.host;
            data.host = host;
            data.filterNetworksObjId = this.defaultUriSchemeUtil.getVsphereObjectId(host);
            data.virtualMachineDevices = _super.prototype.buildVirtualDevices.call(this, data);
            data.storageProfiles = profiles;
            data.vmStorageProfileAssignments = assignments;
            data.vmReplicationGroupAssignments = rgroups;
            var promises = { hardwareConfigPromise: this.$q.when(data) };
            return this.$q.all(promises);
        };
        ;
        VmHardwareEditService.prototype.getStorageLocatorItems = function (rtHostId) {
            return this.storageLocatorService
                .getStorageLocatorData(rtHostId, rtHostId);
        };
        VmHardwareEditService.prototype.getVmNetworkInfo = function (hostRef, hardwareConfigData) {
            var networkProviderId = this.defaultUriSchemeUtil
                .getVsphereObjectId(hostRef);
            var vmNetworkDevices = hardwareConfigData.virtualMachineDevices
                .existingDevicesOfType(VmHardwareBaseService.VIRTUAL_ETHERNET_CARD);
            return _super.prototype.getVmNetworkInfo.call(this, networkProviderId, vmNetworkDevices);
        };
        VmHardwareEditService.prototype.update = function (vmId, operation, originalVmConfig, vmConfigContextConfig, virtualMachineDevices, cpuFeatureMask, vmProfile) {
            var deviceChanges = virtualMachineDevices.getFinalChanges();
            var mutationOptions = {
                originalConfig: originalVmConfig,
                config: vmConfigContextConfig,
                deviceChange: deviceChanges,
                cpuFeatureMask: cpuFeatureMask,
                npivWwnOp: vmConfigContextConfig.npivWwnOp
            };
            if (vmProfile) {
                mutationOptions.profile = vmProfile;
            }
            this.mutationService.apply(vmId, 'com.vmware.vsphere.client.vm.VmConfigSpec', mutationOptions, operation);
            this.broadcastEditSaved(vmId);
        };
        ;
        VmHardwareEditService.prototype.applyRecommendationAndUpdate = function (vmId, recommendationKeys, operation) {
            var vmRecommendationSpec = {
                recommendations: recommendationKeys
            };
            this.mutationService.apply(vmId, 'com.vmware.vsphere.client.vm.storageDrs.VmRecommendationsSpec', vmRecommendationSpec, operation);
            this.broadcastEditSaved(vmId);
        };
        ;
        VmHardwareEditService.prototype.broadcastEditSaved = function (vmId) {
            this.$rootScope.$broadcast(this.vcH5ConstantsService.VM_EDIT_SAVED, {
                vmId: vmId
            });
        };
        ;
        VmHardwareEditService.$inject = [
            '$rootScope',
            'vmFactoryService',
            'mutationService',
            'storageLocatorService',
            'vcH5ConstantsService',
            'vmHardwareUtil',
            'dataService',
            'vmNetworkService',
            'defaultUriSchemeUtil',
            'storageProfileService',
            '$q',
            'vmDeviceInfoService',
            'VirtualMachineDevices'
        ];
        return VmHardwareEditService;
    }(VmHardwareBaseService));
    h5_vm.VmHardwareEditService = VmHardwareEditService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareEditService', VmHardwareEditService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareMemoryService = (function () {
        function VmHardwareMemoryService(vmHardwareUtil) {
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareMemoryService.prototype.getReservationMaxLimit = function (memoryUsage, configuredMemory, memoryAllocation, vmPowerState) {
            var configuredReservation = 0;
            var configuredLimit = -1;
            if (memoryAllocation) {
                if (memoryAllocation.reservation) {
                    configuredReservation = memoryAllocation.reservation;
                }
                if (memoryAllocation.hasOwnProperty("limit")) {
                    configuredLimit = memoryAllocation.limit;
                }
            }
            var vmPoweredOn = this.vmHardwareUtil.isVmPoweredOn(vmPowerState);
            var min = vmPoweredOn ? configuredReservation : 0;
            var maxUsage = this.vmHardwareUtil.bytesToMB(memoryUsage.maxUsage);
            var minUpperLimit = 0;
            var reservationMaxLimit = 0;
            if (!vmPoweredOn) {
                minUpperLimit = Math.max(maxUsage, configuredReservation);
            }
            else {
                if (memoryUsage.unreservedForVm !== -1) {
                    minUpperLimit = this.vmHardwareUtil.bytesToMB(memoryUsage.unreservedForVm);
                }
                minUpperLimit += min;
            }
            // do not reserve more than configured memory (no need?)
            if (minUpperLimit > configuredMemory) {
                minUpperLimit = configuredMemory;
            }
            if (configuredLimit !== -1) {
                reservationMaxLimit = Math.min(configuredLimit, minUpperLimit);
            }
            else {
                reservationMaxLimit = minUpperLimit;
            }
            return reservationMaxLimit;
        };
        VmHardwareMemoryService.prototype.getMinMemoryMB = function (config, environment) {
            if (this.vmHardwareUtil.isVmPoweredOn(environment.powerState) && config.memoryHotAddEnabled) {
                return config.hardware.memoryMB;
            }
            return environment.configOption.hardwareOptions.memoryMB.min;
        };
        VmHardwareMemoryService.prototype.getMaxMemoryMB = function (config, environment) {
            if (this.vmHardwareUtil.isVmPoweredOn(environment.powerState) && config.memoryHotAddEnabled) {
                return config.hotPlugMemoryLimit;
            }
            return environment.configOption.hardwareOptions.memoryMB.max;
        };
        VmHardwareMemoryService.prototype.isMemoryDisabled = function (config, environment, privileges, skipPrivilegeCheck) {
            var _this = this;
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                if (_this.getMinMemoryMB(config, environment) >= _this.getMaxMemoryMB(config, environment)) {
                    return true;
                }
                else {
                    return !config.memoryHotAddEnabled && _this.vmHardwareUtil.isVmPoweredOn(environment.powerState);
                }
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Memory']);
                return !hasPrivilege || validate();
            }
        };
        VmHardwareMemoryService.prototype.isReservationDisabled = function (config, privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                return config.memoryReservationLockedToMax;
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Resource']);
                return !hasPrivilege || validate();
            }
        };
        VmHardwareMemoryService.prototype.isMaxReservationDisabled = function (rtInfo, privileges, capabilities, skipPrivilegeCheck) {
            if (rtInfo === void 0) { rtInfo = {}; }
            if (capabilities === void 0) { capabilities = {}; }
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                return rtInfo.faultToleranceState === 'enabled' || !capabilities.memoryReservationLockSupported;
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Resource']);
                return !hasPrivilege || validate();
            }
        };
        VmHardwareMemoryService.prototype.isLimitDisabled = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return false;
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Resource']);
                return !hasPrivilege;
            }
        };
        VmHardwareMemoryService.prototype.isSharesDisabled = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return false;
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Resource']);
                return !hasPrivilege;
            }
        };
        VmHardwareMemoryService.prototype.isMemoryHotPlugDisabled = function (environment, privileges, selectedGuestOs, skipPrivilegeCheck) {
            var _this = this;
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            var validate = function () {
                var doesNotSupportMemoryHotAdd = !selectedGuestOs.supportsMemoryHotAdd;
                return _this.vmHardwareUtil.isVmPoweredOn(environment.powerState) || doesNotSupportMemoryHotAdd;
            };
            if (skipPrivilegeCheck) {
                return validate();
            }
            else {
                var hasPrivilege = this.vmHardwareUtil.checkPrivileges(privileges, ['VirtualMachine.Config.Memory']);
                return !hasPrivilege || validate();
            }
        };
        VmHardwareMemoryService.$inject = [
            'vmHardwareUtil'
        ];
        return VmHardwareMemoryService;
    }());
    h5_vm.VmHardwareMemoryService = VmHardwareMemoryService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareMemoryService', VmHardwareMemoryService);
})(h5_vm || (h5_vm = {}));



//todo: Figure out where this logic is needed, otherwise delete.

// (function() {
//    'use strict';
//    angular.module('com.vmware.vsphere.client.vm').factory('vmHardwareService', vmHardwareService);
//
//    vmHardwareService.$inject = [
//       'authorizationService',
//       'dataService',
//       'defaultUriSchemeUtil',
//       'storageProfileService',
//       '$q',
//       'vmDeviceInfoService',
//       'VirtualMachineDevices'];
//
//    function vmHardwareService (
//       authorizationService,
//       dataService, defaultUriSchemeUtil, storageProfileService,
//       $q, vmDeviceInfoService, VirtualMachineDevices) {
//
//       var HARDWARE_DATA = 'com.vmware.vsphere.client.vm.model.HardwareConfigData';
//       var VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY = 'VirtualMachine/vmStorageProfileAssignments';
//       var HARDWARE_DATA_RESULT = 'hardwareDataResult';
//       var STORAGE_PROFILES_RESULT = 'storageProfilesResult';
//       var VM_STORAGE_PROFILE_ASSIGNMENTS_RESULT = 'vmStorageProfileAssignmentsResult';
//
//       var checkPermissions = function(vmId) {
//          return authorizationService.checkPrivilege(vmId, 'VirtualMachine.Config.AddRemoveDevice');
//       };
//
//       var checkPrivileges = function(vmConfigContextPrivileges, privileges) {
//          return _.difference(privileges, vmConfigContextPrivileges).length === 0;
//       };
//
//       var isPrimaryVm = function(ftRole) {
//          return (ftRole === 1);
//       };
//
//       var isSecondaryVm = function(ftRole) {
//          return (ftRole > 1);
//       };
//
//       var isPrimaryFtVm = function(ftState, ftInfo) {
//          if (!ftInfo) {
//             return false;
//          }
//
//          return (ftState !== 'notConfigured') && isPrimaryVm(ftInfo.role);
//       };
//
//       var isSecondaryFtVm = function(ftState, ftInfo) {
//          if (!ftInfo) {
//             return false;
//          }
//
//          return (ftState !== 'notConfigured') && isSecondaryVm(ftInfo.role);
//       };
//
//       var isFtVm = function(ftState, ftInfo) {
//          return isPrimaryFtVm(ftState, ftInfo) || isSecondaryFtVm(ftState, ftInfo);
//       };
//
//       var isVmPoweredOn = function(vmPowerState) {
//          return vmPowerState === 'poweredOn';
//       };
//       var bytesToMB = function(bytes) {
//          var MB_FACTOR = 1024 * 1024;
//          return bytes / MB_FACTOR;
//       };
//       var getDataPromises = function(vmId) {
//          var hardwareDataPromise = dataService.getData(vmId, HARDWARE_DATA);
//          var serverGuid = defaultUriSchemeUtil.getManagedObjectReference(vmId).serverGuid;
//          var storageProfilesPromise = storageProfileService.fetchProfiles(serverGuid);
//          var vmStorageProfileAssignmentsPromise = dataService.getProperties(
//             vmId, [VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY],
//             // Suppress error notification ({skipErrorInterceptor:true})
//             // as this is likely to fail if user has no privileges.
//             // Also prevent the combined promise of being rejected
//             // since vm storage profiles are not required for the
//             // edit settings dialog to initialize.
//             { skipErrorInterceptor: true }).catch(function() {
//          });
//          var promises = {};
//          promises[HARDWARE_DATA_RESULT] = hardwareDataPromise;
//          promises[STORAGE_PROFILES_RESULT] = storageProfilesPromise;
//          promises[VM_STORAGE_PROFILE_ASSIGNMENTS_RESULT] = vmStorageProfileAssignmentsPromise;
//
//          return $q.all(promises);
//       };
//       var useData = function(vmId, properties) {
//
//          var hardwareData = properties[HARDWARE_DATA_RESULT];
//          var storageProfiles = properties[STORAGE_PROFILES_RESULT];
//          var configTargets = hardwareData.vmConfigContext.environment.configTarget;
//          var availableNetworks = vmDeviceInfoService.buildAvailableNetworkList(configTargets);
//          var guestOsFamilyKey = hardwareData.guestOsFamilyKey;
//          var vmStorageProfileAssignments = properties[VM_STORAGE_PROFILE_ASSIGNMENTS_RESULT];
//
//          var result = {
//             vmConfigContext: hardwareData.vmConfigContext,
//             originalConfig: angular.copy(hardwareData.vmConfigContext.config),
//             privileges: {
//                hasAddRemoveDevicePrivilege: this.checkPermissions(vmId)
//             },
//             availableNetworks: availableNetworks,
//             storageProfiles: storageProfiles,
//             guestOsFamilyKey: guestOsFamilyKey
//          };
//          if (vmStorageProfileAssignments !== null) {
//             result.vmStorageProfileAssignments = vmStorageProfileAssignments;
//          }
//          return result;
//
//       };
//       var getAndFormatData = function(vmId) {
//          var _this = this;
//          return this.getDataPromises(vmId).then(function(properties) {
//             return _this.useData(vmId, properties);
//          });
//       };
//       var buildVirtualDevices = function(hardwareData) {
//          var virtualDeviceOptionsByDeviceType = _.indexBy(
//             hardwareData.vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption,
//             function(deviceOption) {
//                return deviceOption.type.name;
//             }
//          );
//
//          var virtualMachineDevices = new VirtualMachineDevices(
//             hardwareData.vmConfigContext.config.hardware.device,
//             hardwareData.vmStorageProfileAssignments,
//             hardwareData.storageProfiles,
//             hardwareData.availableNetworks,
//             virtualDeviceOptionsByDeviceType);
//
//          return virtualMachineDevices;
//       };
//
//       return {
//          checkPermissions: checkPermissions,
//          checkPrivileges: checkPrivileges,
//          isFtVm: isFtVm,
//          isVmPoweredOn: isVmPoweredOn,
//          bytesToMB: bytesToMB,
//          getDataPromises: getDataPromises,
//          useData: useData,
//          getAndFormatData: getAndFormatData,
//          buildVirtualDevices: buildVirtualDevices
//       };
//    }
// }());

angular.module('com.vmware.vsphere.client.vm')
.factory('vmHardwareVersionService', ['i18nService', function (i18nService) {
   var HW_UPGRADE_STATUS_NONE = 'none';
   var HW_UPGRADE_STATUS_FAILED = 'failed';

   return {
      getVersionNumber: getVersionNumber,
      getLongText: getLongText,
      getScheduledUpgradeData: getScheduledUpgradeData
   };

   function getVersionNumber(vmVersionId) {
      var vmVersionNumber = parseInt(vmVersionId.split("-")[1]);

      if (_.isNaN(vmVersionNumber)) {
         return -1;
      }
      return vmVersionNumber;
   }

   function getLongText(vmVersion) {
      return i18nService.getString('VmUi', 'VmHardware.HWVersion.long.' + vmVersion);
   }

   function getScheduledUpgradeData(vmHardwareData) {
      var statusStr, errorStr;
      var upgradeStatus;
      if (vmHardwareData.upgrade && vmHardwareData.upgrade.scheduledHardwareUpgradeStatus) {
         upgradeStatus = vmHardwareData.upgrade.scheduledHardwareUpgradeStatus;
      }

      if (upgradeStatus !== HW_UPGRADE_STATUS_NONE) {
         statusStr = i18nService.getString('VmUi', 'VmHardwareView.' + upgradeStatus);

         if (upgradeStatus === HW_UPGRADE_STATUS_FAILED) {
            errorStr = buildFaultMessage(vmHardwareData.upgrade.fault);
         }
      }

      return {
         status: statusStr,
         error: errorStr
      };
   }

   function buildFaultMessage(fault) {
      var msg = '';
      var separator = '';

      if (fault && fault.faultMessage && fault.faultMessage.length > 0) {
         fault.faultMessage.forEach(function(lmsg) {

            msg += separator + lmsg.message;

            if (separator === '') {
               separator  = '\n';
            }
         });
      }
      return msg;
   }
}]);

angular.module('com.vmware.vsphere.client.vm')
.factory('vmRecommendationsService', ['dataService', 'actionDialogService', 'mutationService', 'i18nService',
   'defaultUriSchemeUtil', '$q', 'logService',
   function (dataService, actionDialogService, mutationService, i18nService,
         defaultUriSchemeUtil, $q, logService) {

      var log = logService('vmRecommendationsService');

      var fetchRecommendations = function (response) {
         if (angular.isUndefined(response) || angular.isUndefined(response[0])) {
            return $q.reject();
         }

         var recommendations = response[0].result ? response[0].result.recommendations : null;
         if (recommendations === null || recommendations.length === 0) {
            return $q.reject();
         }

         var targetHostsIds = collectTargetHostsIds(recommendations);
         var promises = _.map(targetHostsIds, function(target) {
            return dataService.getProperties(target, ['name']);
         });

         var targetVmIds = collectTargetVmIds(recommendations);
         var vmPromises = _.map(targetVmIds, function(target) {
            return dataService.getProperties(target, ['name', 'primaryIconId']);
         });

         var hostNameById = {};

         return $q.all(vmPromises).then(function (result) {
            var vmInfoById = {};
            _.each(result, function (info) {
               vmInfoById[info.id] = info;
            });

            return $q.all(promises).then(function (res) {
               _.each(res, function (x) {
                  hostNameById[x.id] = x.name;
               });
               var data = createResults(recommendations, vmInfoById, hostNameById);
               return data;
            });
         });
      };

      var applyRecommendations = function (objectId, keys) {
         var spec = {
            "operation": "apply",
            "keys": keys
         };
         var propertyObjectType = 'com.vmware.vsphere.client.cluster.services.recommendations.ClusterRecommendationSpec';
         return mutationService.apply(objectId, propertyObjectType, spec);
      };

      var applyRecommendation = function (objectId, recommendation) {
         var propertyObjectType = 'com.vmware.vim.binding.vim.cluster.Recommendation';
         return mutationService.apply(objectId, propertyObjectType, recommendation);
      };

      function collectTargetVmIds(recommendations) {
         var vmIds = [];
         _.each(recommendations, function(recommendation) {
            _.each(recommendation.action, function(action) {
               var target = defaultUriSchemeUtil.getVsphereObjectId(action.target);
               vmIds.push(target);
            });
         });
         return vmIds;
      }


      function collectTargetHostsIds(recommendations) {
         if (recommendations === null || recommendations.length === 0) {
            return [];
         }
         return _.reduce(recommendations, function(aux, i) {
            if (i.action === null || i.action.length === 0) {
               return aux;
            }

            var mapper = function (action) {
               if (action._type === 'com.vmware.vim.binding.vim.cluster.InitialPlacementAction') {
                  return defaultUriSchemeUtil.getVsphereObjectId(action.targetHost);
               } else if (action._type === 'com.vmware.vim.binding.vim.cluster.MigrationAction') {
                  return [defaultUriSchemeUtil.getVsphereObjectId(action.drsMigration.source),
                          defaultUriSchemeUtil.getVsphereObjectId(action.drsMigration.destination)];
               } else {
                  log.error('Unknown action type: ', action);
               }
            };
            var targetHostsIds = _.chain(i.action).map(mapper).flatten().value();
            return aux.concat(targetHostsIds);
         }, []);
      }

      function ratingToPriority(starRating) {
         var maxStarRatingDrsAssignsToRecommendations = 5;
         return (maxStarRatingDrsAssignsToRecommendations - starRating) + 1;
      }

      function createResults(recommendations, vmInfoById, hostNameById) {
         return _.map(recommendations, function(recommendation, i) {
            var reasonTxt = i18nService.getString('VmUi', 'RecommendationListItemData.recommendation',
            i + 1, recommendation.reasonText);
            var info = {
               reasonText: reasonTxt,
               priority: ratingToPriority(recommendation.rating),
               actions: createActions(recommendation.action, vmInfoById, hostNameById),
               key: recommendation.key,
               targetClusterId: defaultUriSchemeUtil.getVsphereObjectId(recommendation.target)
            };
            return info;
         });
      }

      function createActions(actions, vmInfoById, hostNameById) {
         return _.map(actions, function (action) {
            var vmId, vmInfo, recommendationText;
            if (action._type === 'com.vmware.vim.binding.vim.cluster.InitialPlacementAction') {
               var hostId = defaultUriSchemeUtil.getVsphereObjectId(action.targetHost);
               vmId = defaultUriSchemeUtil.getVsphereObjectId(action.target);
               vmInfo = vmInfoById[vmId];
               recommendationText = i18nService.getEscapedString('VmUi',
               'RecommendationListItemData.initialPlacement', vmInfo.name, hostNameById[hostId]);
               return {
                  text: recommendationText,
                  icon: vmInfo.primaryIconId
               };
            } else if (action._type === 'com.vmware.vim.binding.vim.cluster.MigrationAction') {
               var sourceHostId = defaultUriSchemeUtil.getVsphereObjectId(action.drsMigration.source);
               var destinationHostId = defaultUriSchemeUtil.getVsphereObjectId(action.drsMigration.destination);
                vmId = defaultUriSchemeUtil.getVsphereObjectId(action.target);
               var key = 'RecommendationListItemData.migration';
               var sourceHostName = hostNameById[sourceHostId];
               var destinationHostName = hostNameById[destinationHostId];
               vmInfo = vmInfoById[vmId];
               recommendationText = i18nService.getEscapedString('VmUi', key, vmInfo.name, sourceHostName,
                     destinationHostName);
               return {
                  text: recommendationText,
                  icon: vmInfo.primaryIconId
               };
            } else {
               log.error('Unknown action type: ', action);
            }
         });
      }

      return {
         fetchRecommendations: fetchRecommendations,
         applyRecommendations: applyRecommendations,
         applyRecommendation: applyRecommendation
      };
   }]);

var h5_vm;
(function (h5_vm) {
    var VmHardwareUtil = h5_vm.VmHardwareUtil;
    var ResourceAllocationInfo = com.vmware.vim.binding.vim.ResourceAllocationInfo;
    var VmConfig = (function () {
        function VmConfig(vmConfigContext, guest, privileges, workflow, i18nService, removeDevice) {
            if (removeDevice === void 0) { removeDevice = null; }
            this.vmConfigContext = vmConfigContext;
            this.guest = guest;
            this.privileges = privileges;
            this.workflow = workflow;
            this.i18nService = i18nService;
            this.removeDevice = removeDevice;
            this.originalRAM = 0;
            this.BIOS_LIMIT_MB = 6128 * 1024;
            this.FIRMWARE_EFI = "efi";
            this.environment = this.vmConfigContext.environment;
            if (!this.environment) {
                throw new Error("Class VmConfig missing config environment");
            }
            this.config = vmConfigContext.config;
            if (this.config && this.config.hardware) {
                this.originalRAM = this.config.hardware.memoryMB;
            }
            this.powerState = this.environment.powerState;
            this.removeInvalidCPUs();
        }
        VmConfig.prototype.removeInvalidCPUs = function () {
            if (!this.environment.configOption) {
                return;
            }
            if (!this.guest) {
                return;
            }
            var options = this.environment.configOption.hardwareOptions;
            if (!options) {
                return;
            }
            var maxCores = this.guest.numSupportedCoresPerSocket;
            var maxSockets = this.guest.numSupportedPhysicalSockets;
            var newCPU = [];
            // preserve original values in case user selects different guest
            if (!options.cpuBackup) {
                options.cpuBackup = options.numCPU.concat();
            }
            var oldCPU = options.cpuBackup;
            for (var _i = 0, oldCPU_1 = oldCPU; _i < oldCPU_1.length; _i++) {
                var cpus = oldCPU_1[_i];
                for (var cores = 1; cores <= maxCores; cores++) {
                    var modulo = cpus % cores;
                    if (modulo !== 0) {
                        continue;
                    }
                    var sockets = cpus / cores;
                    if (sockets > maxSockets) {
                        continue;
                    }
                    else {
                        newCPU.push(cpus);
                        break;
                    }
                }
            }
            options.numCPU = newCPU;
            return;
        };
        VmConfig.prototype.getGuestOsDescriptror = function () {
            return this.guest;
        };
        VmConfig.prototype.getVmConfigContext = function () {
            return this.vmConfigContext;
        };
        VmConfig.prototype.getI18nService = function () {
            return this.i18nService;
        };
        VmConfig.prototype.i18n = function (key) {
            return this.i18nService.getString("VmUi", key);
        };
        Object.defineProperty(VmConfig.prototype, "grantedConfigSettings", {
            get: function () {
                if (!this.privileges) {
                    return true;
                }
                var retVal = h5_vm.VmHardwareUtil.hasPrivileges(this.privileges, [h5_vm.Privileges.VM_CONFIG_SETTINGS]);
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "grantedEditDevice", {
            get: function () {
                if (!this.privileges) {
                    return true;
                }
                var retVal = h5_vm.VmHardwareUtil.hasPrivileges(this.privileges, [h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE]);
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "grantedRemoveDevice", {
            get: function () {
                if (!this.privileges) {
                    return true;
                }
                var retVal = h5_vm.VmHardwareUtil.hasPrivileges(this.privileges, [h5_vm.Privileges.VM_ADDREMOVEDEVICE]);
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "grantedDeviceConnection", {
            get: function () {
                if (!this.privileges) {
                    return true;
                }
                var retVal = h5_vm.VmHardwareUtil.hasPrivileges(this.privileges, [h5_vm.Privileges.VM_INTERACT_DEVICE_CONNECTION]);
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.canRemoveDevice = function (option) {
            if (this.isUpdate) {
                if (this.suspended) {
                    return false;
                }
                var granted = this.grantedRemoveDevice;
                if (!granted) {
                    return false;
                }
                var hotRemoveSupported = option ? option.hotRemoveSupported : true;
                if (this.poweredOn && !hotRemoveSupported) {
                    return false;
                }
                return true;
            }
            if (this.isClone) {
                var granted = this.grantedRemoveDevice;
                return granted;
            }
            return true;
        };
        VmConfig.prototype.getVideoCardOption = function () {
            var options = this.getVirtualDeviceOption();
            if (!options) {
                return null;
            }
            var match = function (item) {
                //TODO wsdlName is wrong, type.name or type.typeClass? - check java docs
                // Turned out wsldName is VirtualMachineVideoCard, not VirtualVideoCard
                return item.type.name === "com.vmware.vim.binding.vim.vm.device.VirtualVideoCard";
            };
            var option = _.find(options, match);
            var retVal = option;
            return retVal;
        };
        Object.defineProperty(VmConfig.prototype, "configTarget", {
            get: function () {
                var retVal = this.environment.configTarget;
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.getGpuProfileList = function () {
            var retVal = this.configTarget.sharedGpuPassthroughTypes;
            return retVal;
        };
        VmConfig.prototype.getSerialPortList = function () {
            var retVal = this.configTarget.serial;
            if (!retVal) {
                retVal = [];
            }
            return retVal;
        };
        VmConfig.prototype.getPciPassList = function () {
            var retVal = this.configTarget.pciPassthrough;
            return retVal;
        };
        VmConfig.prototype.getVirtualDeviceOption = function () {
            if (!this.environment || !this.environment.configOption) {
                return [];
            }
            return this.environment.configOption.hardwareOptions.virtualDeviceOption;
        };
        Object.defineProperty(VmConfig.prototype, "poweredOn", {
            get: function () {
                return this.powerState === 'poweredOn';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "poweredOff", {
            get: function () {
                return this.powerState === 'poweredOff';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "suspended", {
            get: function () {
                return this.powerState === 'suspended';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "isCreate", {
            get: function () {
                return this.workflow === h5_vm.VmWorkflowMode.CreateMode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "isUpdate", {
            get: function () {
                return this.workflow === h5_vm.VmWorkflowMode.UpdateMode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmConfig.prototype, "isClone", {
            get: function () {
                return this.workflow === h5_vm.VmWorkflowMode.CloneMode;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.isEditDeviceDisabled = function (hotEditable) {
            if (hotEditable === void 0) { hotEditable = false; }
            var DISABLED = true;
            var enabled = false;
            if (this.isCreate) {
                return enabled;
            }
            if (this.isUpdate) {
                if (!this.grantedEditDevice) {
                    return DISABLED;
                }
                if (this.poweredOff) {
                    return enabled;
                }
                else if (this.suspended) {
                    return DISABLED;
                }
                else if (this.poweredOn) {
                    if (hotEditable) {
                        return enabled;
                    }
                    else {
                        return DISABLED;
                    }
                }
            }
            if (!this.grantedEditDevice) {
                return DISABLED;
            }
            return enabled;
        };
        VmConfig.prototype.memoryUnderReserved = function () {
            if (!this.config) {
                return false;
            }
            if (!this.config.memoryAllocation) {
                return true;
            }
            var allocation = this.config.memoryAllocation;
            var memoryMB = this.config.hardware.memoryMB;
            if (memoryMB > allocation.reservation) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.getVmCaps = function () {
            var retVal = {};
            if (this.environment && this.environment.configOption) {
                return this.environment.configOption.capabilities;
            }
            else {
                return {};
            }
        };
        Object.defineProperty(VmConfig.prototype, "memoryMB", {
            // Memory section begins
            get: function () {
                return this.config.hardware.memoryMB;
            },
            set: function (value) {
                this.config.hardware.memoryMB = value;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.validateMemoryMB = function (value) {
            var OK = { error: "", valid: true };
            if (!value) {
                return OK;
            }
            if (false === this.isCreate) {
                // Don't validate existing value unless new VM
                // Since currently there is no easy way
                // to both show memory error and enable OK
                if (this.originalRAM === value) {
                    return OK;
                }
            }
            var os = this.getGuestOsDescriptror();
            if (os) {
                var max = os.supportedMaxMemMB;
                if (value > max) {
                    var maxError = this.i18n("VmMemory.GuestMaxError");
                    maxError += " " + os.fullName;
                    return { error: maxError, valid: false };
                }
            }
            if (true === this.isEfiConfigured()) {
                return OK;
            }
            if (value > this.BIOS_LIMIT_MB) {
                var biosError = this.i18n("VmMemory.BiosMaxError");
                return { error: biosError, valid: false };
            }
            return OK;
        };
        VmConfig.prototype.getMemoryRecommendations = function () {
            var os = this.getGuestOsDescriptror();
            if (!os) {
                return [];
            }
            var mbLabel = this.i18n("VmMemory.MB");
            var gbLabel = this.i18n("VmMemory.GB");
            var maxLabel = this.i18n("VmMemory.GuestOSmax");
            var minLabel = this.i18n("VmMemory.GuestOSmin");
            var format = function (memMB) {
                if (memMB > 1024) {
                    var value = memMB / 1024;
                    return value.toString() + " " + gbLabel;
                }
                return memMB.toString() + mbLabel;
            };
            var min = os.supportedMinMemMB;
            var max = os.supportedMaxMemMB;
            var retVal = [
                { name: os.fullName, value: this.memoryMB, formattedValue: " " },
                { name: maxLabel, value: max, formattedValue: format(max) },
                { name: minLabel, value: min, formattedValue: format(min) }
            ];
            return retVal;
        };
        VmConfig.prototype.reserveAllMemory = function () {
            if (!this.config) {
                return;
            }
            if (!this.config.memoryAllocation) {
                this.config.memoryAllocation = new ResourceAllocationInfo();
            }
            var allocation = this.config.memoryAllocation;
            var memoryMB = this.config.hardware.memoryMB;
            allocation.reservation = memoryMB;
            if (this.getVmCaps().memoryReservationLockSupported) {
                this.config.memoryReservationLockedToMax = true;
            }
        };
        VmConfig.prototype.canReserveAllMemory = function () {
            if (this.isUpdate) {
                var granted = VmHardwareUtil.hasPrivileges(this.vmConfigContext.privileges, [h5_vm.Privileges.VM_CONFIG_SETTINGS]);
                if (!granted) {
                    return false;
                }
                return true;
            }
            else if (this.isCreate) {
                return true;
            }
            else if (this.isClone) {
                return true;
            }
            return true;
        };
        Object.defineProperty(VmConfig.prototype, "cpu", {
            // Memory section ends
            // CPU section begins
            get: function () {
                var retVal = this.config.hardware.numCPU;
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.getBiosCpuLimit = function () {
            return VmConfig.ONE_TWENTY_EIGHT;
        };
        VmConfig.prototype.isBigCpu = function () {
            if (this.cpu > VmConfig.ONE_TWENTY_EIGHT) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.isCpuHotplugError = function (originalConfig) {
            if (!this.isUpdate) {
                return false;
            }
            if (false === this.poweredOn) {
                return false;
            }
            var oldCpu = originalConfig.hardware.numCPU;
            if (this.cpu === oldCpu) {
                return false;
            }
            if (oldCpu > this.getBiosCpuLimit()) {
                return false; // we above 128 already, good
            }
            if (this.cpu > this.getBiosCpuLimit()) {
                return true; // report error
            }
            return false; // no error
        };
        VmConfig.prototype.isCpuFirmwareError = function () {
            if (this.isEfiConfigured()) {
                return false;
            }
            if (this.cpu > this.getBiosCpuLimit()) {
                return true;
            }
            return false;
        };
        Object.defineProperty(VmConfig.prototype, "firmware", {
            get: function () {
                var retVal = this.config.firmware;
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.afterFirmwareChanged = function () {
            var cpu = this.cpu;
            if (cpu > this.getBiosCpuLimit()) {
                this.ensureBigCpu();
            }
        };
        VmConfig.prototype.isFirmwareLocked = function () {
            var retVal = this.isEfiConfigured() && this.isEfiRequired();
            return retVal;
        };
        VmConfig.prototype.isEfiRequired = function () {
            var numCPU = this.cpu;
            if (numCPU > this.getBiosCpuLimit()) {
                return true;
            }
            if (this.memoryMB > this.BIOS_LIMIT_MB) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.configureEfi = function () {
            this.config.firmware = this.FIRMWARE_EFI;
            return;
        };
        VmConfig.prototype.isEfiConfigured = function () {
            if (this.firmware === this.FIRMWARE_EFI) {
                return true;
            }
            else {
                return false;
            }
        };
        Object.defineProperty(VmConfig.prototype, "vvtd", {
            // VVTD section (aka IO MMU)
            get: function () {
                return this.config.flags.vvtdEnabled;
            },
            set: function (value) {
                this.config.flags.vvtdEnabled = value;
            },
            enumerable: true,
            configurable: true
        });
        VmConfig.prototype.isVvtdEnabled = function () {
            var flags = this.config.flags;
            if (true === flags.vvtdEnabled) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.isVvtdRequired = function () {
            var flags = this.config.flags;
            if (flags && true === flags.vbsEnabled) {
                return true;
            }
            if (this.cpu > this.getBiosCpuLimit()) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.isBadPowerState = function () {
            if (this.isCreate) {
                return false;
            }
            if (this.isClone) {
                return false;
            }
            if (this.isUpdate) {
                if (this.poweredOn) {
                    return true;
                }
                if (this.suspended) {
                    return true;
                }
            }
            return false;
        };
        VmConfig.prototype.isBadUser = function () {
            if (this.isCreate) {
                return false;
            }
            if (this.isClone) {
                return false;
            }
            if (this.isUpdate) {
                if (false === this.grantedConfigSettings) {
                    return true;
                }
            }
            return false;
        };
        VmConfig.prototype.isConfigReadonly = function () {
            if (this.isBadPowerState()) {
                return true;
            }
            if (this.isBadUser()) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.isVvtdReadonly = function () {
            if (this.isVvtdEnabled() && this.isVvtdRequired()) {
                return true;
            }
            if (this.isConfigReadonly()) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.isVvtdEnforced = function () {
            if (this.isVvtdEnabled() && this.isVvtdRequired()) {
                return true;
            }
            return true;
        };
        VmConfig.prototype.isVbsConfigured = function () {
            if (!this.config) {
                return false;
            }
            var flags = this.config.flags;
            if (!flags) {
                return false;
            }
            if (true === flags.vbsEnabled) {
                return true;
            }
            return false;
        };
        VmConfig.prototype.whyVvtdRequired = function () {
            var reasonCpu = this.isBigCpu();
            var reasonVbs = this.isVbsConfigured();
            if (!reasonCpu && !reasonVbs) {
                return "";
            }
            var textCPU = this.i18n('VmCpu.iommu.DescriptionCpu128');
            var textVBS = this.i18n('VmCpu.iommu.Description');
            var textCPUVSB = textVBS + "<br>" + textCPU;
            if (reasonCpu && reasonVbs) {
                return textCPUVSB;
            }
            if (reasonCpu) {
                return textCPU;
            }
            if (reasonVbs) {
                return textVBS;
            }
            return "";
        };
        VmConfig.prototype.enableVvtd = function () {
            var flags = this.config.flags;
            flags.vvtdEnabled = true;
            return;
        };
        VmConfig.prototype.afterCpuChange = function () {
            var cpu = this.cpu;
            if (cpu > this.getBiosCpuLimit()) {
                this.ensureBigCpu();
            }
        };
        VmConfig.prototype.firmwareDoesNotSupportBigCpu = function () {
            if (this.isEfiConfigured()) {
                return false;
            }
            return true;
        };
        VmConfig.prototype.ensureBigCpu = function () {
            var isEfiForced = false;
            var isVvtdForced = false;
            if (this.isUpdate) {
                if (!this.poweredOff) {
                    return;
                }
                if (this.firmwareDoesNotSupportBigCpu()) {
                    return;
                }
            }
            if (this.isClone && this.firmwareDoesNotSupportBigCpu()) {
                return;
            }
            if (this.isCreate && false === this.isEfiConfigured()) {
                this.configureEfi();
                isEfiForced = true;
            }
            if (false === this.isVvtdEnabled()) {
                this.enableVvtd();
                isVvtdForced = true;
            }
            if (isEfiForced && isVvtdForced) {
                this.showI18nMsg("VmCpu.EFI_VVTD_FORCED");
            }
            else if (isEfiForced) {
                this.showI18nMsg("VmCpu.EFI_FORCED");
            }
            else if (isVvtdForced) {
                this.showI18nMsg("VmCpu.VVTD_FORCED");
            }
            return;
        };
        VmConfig.prototype.showI18nMsg = function (key) {
            var msg = this.i18n(key);
            if (this.showMsg) {
                this.showMsg(msg);
            }
        };
        // CPU section ends
        VmConfig.prototype.getPciPassthoughOption = function () {
            var options = this.getVirtualDeviceOption();
            if (!options) {
                return null;
            }
            var prefix = "com.vmware.vim.binding.vim.vm.device.";
            var type_name = prefix + "VirtualPCIPassthrough";
            var match = function (item) {
                return item.type.name === type_name;
            };
            var option = _.find(options, match);
            var retVal = option;
            return retVal;
        };
        ;
        VmConfig.prototype.getDeviceOption = function (device) {
            if (!device) {
                return null;
            }
            var device_type = device._type;
            var options = this.getVirtualDeviceOption();
            if (!options) {
                return null;
            }
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var item = options_1[_i];
                if (!item) {
                    continue;
                }
                var typeClass = item.type.typeClass;
                if (typeClass === device_type) {
                    return item;
                }
            }
            return null;
        };
        VmConfig.prototype.remove = function (device) {
            if (this.removeDevice) {
                this.removeDevice(device);
            }
        };
        VmConfig.prototype.deviceRemoveEnabled = function (hotRemoveSupported) {
            if (hotRemoveSupported === void 0) { hotRemoveSupported = false; }
            if (this.isCreate) {
                return true;
            }
            if (this.isUpdate) {
                if (false === this.grantedRemoveDevice) {
                    return false;
                }
                if (this.poweredOff) {
                    return true;
                }
                else if (this.suspended) {
                    return false;
                }
                else if (this.poweredOn) {
                    return hotRemoveSupported;
                }
            }
            else if (this.isClone) {
                if (false === this.grantedRemoveDevice) {
                    return false;
                }
            }
            return true;
        };
        VmConfig.prototype.isConnectDeviceDisabled = function () {
            if (this.isCreate) {
                return false;
            }
            else if (this.isUpdate) {
                if (!this.grantedDeviceConnection) {
                    return true;
                }
                if (this.suspended) {
                    return true;
                }
            }
            else if (this.isClone) {
                return !this.grantedDeviceConnection;
            }
            return false;
        };
        VmConfig.prototype.debugPermissions = function (array) {
            this.privileges = array;
        };
        VmConfig.prototype.debugNoPermissions = function () {
            this.privileges = [];
        };
        VmConfig.prototype.debugPowerState = function (value) {
            this.powerState = value;
        };
        VmConfig.prototype.debugPoweredOff = function () {
            this.debugPowerState(h5_vm.PowerState.POWERED_OFF);
        };
        VmConfig.prototype.debugPoweredOn = function () {
            this.debugPowerState(h5_vm.PowerState.POWERED_ON);
        };
        VmConfig.prototype.debugSuspended = function () {
            this.debugPowerState(h5_vm.PowerState.SUSPENDED);
        };
        VmConfig.prototype.debugWorkflow = function (value) {
            this.workflow = value;
        };
        VmConfig.prototype.debugCloneVm = function () {
            this.debugWorkflow(h5_vm.VmWorkflowMode.CloneMode);
        };
        VmConfig.prototype.debugNewVm = function () {
            this.debugWorkflow(h5_vm.VmWorkflowMode.CreateMode);
        };
        VmConfig.prototype.debugEditVm = function () {
            this.debugWorkflow(h5_vm.VmWorkflowMode.UpdateMode);
        };
        VmConfig.ONE_TWENTY_EIGHT = 128;
        return VmConfig;
    }());
    h5_vm.VmConfig = VmConfig;
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').directive('vmEditSettings', [function () {
   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmEditSettings.html',
      restrict: 'AE',
      controller: 'VmEditSettingsController',
      controllerAs: 'vmEditSettingsController'
   };
}]);

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * The edit settings controller.
 */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmEditSettingsController', VmEditSettingsController);

   VmEditSettingsController.$inject = [
      '$scope',
      '$element',
      '$timeout',
      'creationTypeConstants',
      'vmHardwareEditService',
      'vmHardwareCreateService',
      'vmHardwareCloneService'];

   function VmEditSettingsController (
         $scope,
         $element,
         $timeout,
         creationTypeConstants,
         vmHardwareEditService,
         vmHardwareCreateService,
         vmHardwareCloneService
   ) {
      initialize();

      // ============public =========

      $scope.isInputStateValid = function () {
         var isValid = true;

         isValid = !$scope.loading;
         validationErrorsMap.forEach(function(flag) {
            isValid = isValid && flag;
         });

         return isValid;
      };

      // collect validation errors from the child tabs
      $scope.$on("onChildValidationChange", function( $event, childId, isValidState ) {
         $event.stopPropagation();
         validationErrorsMap.set(childId, isValidState);
      });

      $scope.$on("editSettingsAlertMessageChanged", function( $event, options ) {
         $event.stopPropagation();
         $scope.alertOptions = options;
      });

      $scope.onTabSelected = function($event) {
         $scope.alertOptions = undefined;
      };

      // ============private =========
      var validationErrorsMap;
      function initialize () {
         validationErrorsMap = new Map();
         $scope.deployVmtx = false;

         $scope.loading = true;
         if ($scope.modalOptions) {
            fetchForEditMode();
         } else if ($scope.vmParams.getCreationType() === creationTypeConstants.CLONE_VM_TO_VM ||
               $scope.vmParams.getCreationType() === creationTypeConstants.CLONE_TEMPLATE_TO_VM ||
               $scope.vmParams.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
            fetchForCloneMode();
            $scope.deployVmtx = $scope.vmParams.getCreationType() === creationTypeConstants.DEPLOY_VM_FROM_VMTX;
         } else {
            fetchForCreate();
         }
      }

      function fetchForCreate () {
         vmHardwareCreateService.getAndFormatData($scope.vmParams, $scope.wizardViewData)
               .then(setHardwareConfig);
      }

      function fetchForEditMode () {
         $scope.startEditSettings = Date.now();
         var vmId = $scope.modalOptions.availableTargets[0];
         $scope.vmId = vmId;
         vmHardwareEditService.getAndFormatData(vmId)
               .then(function(result) {
                  setHardwareConfig(result.hardwareConfigPromise);
               });
      }

      function fetchForCloneMode () {
         vmHardwareCloneService.getAndFormatData($scope.vmParams, $scope.wizardViewData)
               .then(setHardwareConfig);
      }

      function setHardwareConfig (hardwareConfigData) {

         var log = function(msg) {
            if (window && window.console && window.console.log) {
               window.console.log(msg);
            }
         };

         $scope.endEditSettings = Date.now();
         log("Edit VM Settings blocking data loading took " + ($scope.endEditSettings - $scope.startEditSettings) + "ms");
         $scope.loading = false;
         $scope.isInvalid = false;
         $scope.hardwareConfigData = hardwareConfigData;
         var ctx = hardwareConfigData.vmConfigContext;
         var times = ctx? ctx.times: null;
         if (times) {
            log("Java timing " + times.javaTiming);
            var javaTotal = times.javaFinishTime - times.javaStartTime;
            log("Java total for getVmConfigContext = " + javaTotal + "ms");
         }

         var callback = function() {
            $scope.showVmOptions = true;
         };

         setTimeout(callback, 1000);

         // focus the first tab on the page
         $timeout(function () {
            var firstTab = $element[0].querySelector("clr-tab-link");
            if (firstTab) {
               firstTab.querySelector("button").focus();
            }
         }, 0);
      }
   }
})();

angular.module('com.vmware.vsphere.client.vm').directive('sharesControl', ['$document', 'i18nService', function ($document, i18nService) {
   'use strict';

   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/sharesControl/sharesControl.html',
      scope: {
         sharesInfo: '=',
         sharesValueMap: '=',
         shareValueMin: '@',
         shareValueMax: '@',
         isDisabled: '=',
         formInputFieldName: '@',
         formSelectFieldName: '@',
         showRecommendations: '=?',
         sharesAriaLabel: '<?',
         quantityCaretAriaLabel: "<?",
         quantityAriaLabel: "<?"
      },
      link: function (scope, element, attrs, ctrl) {
         scope.i18n = i18nService.getString;
         scope.shareValueMin = parseInt(scope.shareValueMin, 10);
         scope.shareValueMax = parseInt(scope.shareValueMax, 10);
         scope.shareValueErrorMessages = {
            max: function() { return scope.i18n('Common', 'SharesControl.RangeError', scope.shareValueMin, scope.shareValueMax); },
            min: function() { return scope.i18n('Common', 'SharesControl.RangeError', scope.shareValueMin, scope.shareValueMax); }
         };
         scope.shareInfoLevels = [
            {label: scope.i18n('VmUi', 'sharesInfoLevel.low'), data: 'low'},
            {label: scope.i18n('VmUi', 'sharesInfoLevel.normal'), data: 'normal'},
            {label: scope.i18n('VmUi', 'sharesInfoLevel.high'), data: 'high'},
            {label: scope.i18n('VmUi', 'sharesInfoLevel.custom'), data: 'custom'}
         ];

         scope.showRecommendations = angular.isDefined(scope.showRecommendations) ? scope.showRecommendations : true;
         if (scope.showRecommendations) {
            scope.shareInfoValues = [{
               value: scope.shareValueMin, name: 'Minimum'
            }, {
               value: scope.shareValueMax, name: 'Maximum'
            }];
         }

         scope.properties = {
            selectedSharesLevel: _.find(scope.shareInfoLevels, function(x) {
               return scope.sharesInfo && x.data === scope.sharesInfo.level;
            })
         };

         scope.$watch('properties.selectedSharesLevel', function (newLevel) {
            if (!newLevel) {
               return;
            }
            scope.sharesInfo.level = newLevel.data;
            scope.isShareLevelCustom = scope.sharesInfo.level === 'custom';
            updateSharesData();
         });

         scope.$watch('sharesValueMap', function (newLevel) {
            if (!newLevel) {
               return;
            }
            updateSharesData();
         }, true);

         function updateSharesData() {
            var level = scope.sharesInfo.level;
            scope.properties.selectedSharesLevel = _.find(scope.shareInfoLevels, function(x) { return x.data === level; });
            if (scope.sharesInfo.level !== 'custom') {
               scope.sharesInfo.shares = reCalculateSharesValue(level);
            }
         }

         function reCalculateSharesValue(level) {
            if (level === 'custom') {
               return scope.sharesInfo.shares;
            } else {
               var value = scope.sharesValueMap[level];
               if (value === undefined || value === null) {
                  throw new Error('Unknown level: ', level);
               }
               return value;
            }
         }
      }
   };
}]);

angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareCdrom', [
   'i18nService',
   'vcH5ConstantsService',
   'vmDeviceInfoService',
   'selectIsoFileService',
   'vmHardwareCdromManagerService',
   'defaultUriSchemeUtil',
   'datastoreBrowserTreeService',
   'datastoreBrowserConstants',
   'contentLibraryIsoSelectorModalService',
   'logService',
   function (i18nService,
             vcH5ConstantsService,
             vmDeviceInfoService,
             selectIsoFileService,
             vmHardwareCdromManagerService,
             defaultUriSchemeUtil,
             datastoreBrowserTreeService,
             datastoreBrowserConstants,
             contentLibraryIsoSelectorModalService,
             logService) {

      var log = logService('vmHardwareCdrom');

      return {
         scope: {
            inflatedDevice: '=',
            vmConfigContext: '=',
            virtualMachineDevicesNeededForControllerAndNode: '=',
            mergedInflatedDevices: '=',
            removeCallback: '&',
            createMode: '=',
            computeResourceId: '@',
            expanded: "=",
            vmId: "="
         },
         require: '^form',
         templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCdrom/vmHardwareCdrom.html',
         link: {
            pre: function (scope, element, attrs, formCtrl) {
               scope.device = scope.inflatedDevice.getCurrentDevice();
               scope.formCtrl = formCtrl;
               scope.i18n = i18nService.getString;
               var cdRomList = copyAvailableCdRomListOnTheHost(scope.vmConfigContext.environment.configTarget.cdRom);
               if(vmHardwareCdromManagerService.hasHostDevicebacking(scope.device)
                     && !vmHardwareCdromManagerService.isDevicePresentInTheHost(scope.device.backing.deviceName, cdRomList)) {
                     cdRomList.push({ name: scope.device.backing.deviceName });
               }
               scope.cdromList = vmHardwareCdromManagerService.createCdromList(cdRomList);

               var isoErrors = {
                  noError: {
                     isVisible: false
                  },
                  fileMissing: {
                     isVisible: true,
                     message: scope.i18n('VmUi', 'CdromPage.FileRequired')
                  },
                  fileDoesNotExists: {
                     isVisible: true,
                     message: scope.i18n('VmUi', 'AsyncFileValidator.NotFound')
                  }
               };

               scope.errors = {
                  isoError: isoErrors.fileMissing,
                  isoErrorForCL: isoErrors.noError
               };
               scope.controllerSelectorName = 'editCdrom' + scope.inflatedDevice.getKey() + 'Controller';
               scope.controllerNodeSelectorName = 'editCdrom' + scope.inflatedDevice.getKey() + 'ControllerNode';
               scope.isVmPoweredOn = scope.vmConfigContext.environment.powerState === 'poweredOn';
               scope.isNewCdDvdDrive = scope.inflatedDevice.isNew();
               scope.skipPermissionCheck = scope.isNewCdDvdDrive || scope.createMode;
               scope.availableDeviceModes = vmHardwareCdromManagerService.getAvailableDeviceModes();
               scope.properties = {
                  deviceMode: vmHardwareCdromManagerService.getInitialDeviceMode(scope.device.backing._type),
                  startConnected: scope.device.connectable.startConnected,
                  connected: scope.device.connectable.connected,
                  controllerNode: null
               };

               vmHardwareCdromManagerService.getAvailableMediaTypes(scope.cdromList,
                     scope.vmId ? scope.vmId : scope.computeResourceId)
                  .then(function (types) {
                     scope.availableMediaTypes = types;
                     return vmHardwareCdromManagerService.getInitialMediaType(scope.device.backing,
                           scope.availableMediaTypes);
                  })
                  .then(function (initialMediaType) {
                     scope.properties.mediaType = initialMediaType.mediaType;
                     scope.properties.selectedIsoItem = initialMediaType.selectedIsoItem;

                     scope.$watchGroup(['properties.mediaType', 'device.backing.fileName'], function (newValues, oldValues) {
                        if (!_.isEqual(newValues, oldValues)) {
                           var newMediaType = newValues[0];
                           scope.validateCdDrive(newMediaType);
                        }
                     });

                     scope.$watch('properties.mediaType', function (newMediaType, oldMediaType) {
                        if (_.isEqual(newMediaType, oldMediaType)) {
                           return;
                        }
                        scope.properties.startConnected = false;
                        scope.properties.connected = false;

                        updatePreviousIsoSelection(oldMediaType);

                        if (vmHardwareCdromManagerService.isDatastoreISOFile(newMediaType)) {
                           if (scope.previousDatastoreISOSelection) {
                              scope.device.backing.fileName = scope.previousDatastoreISOSelection;
                           }
                           else {
                              scope.browseForDatastoreIso();
                           }
                           scope.$evalAsync(addIsoFileValidator);
                        } else if (vmHardwareCdromManagerService.isContentLibraryISOFile(newMediaType)) {
                           if (scope.previousContentLibraryISOSelection) {
                              scope.device.backing.fileName = scope.previousContentLibraryISOSelection;
                           }
                           else {
                              scope.browseForContentLibraryIso();
                           }
                        }
                        else {
                           var backing = vmHardwareCdromManagerService.getNewDeviceBacking(scope.properties);
                           scope.device.backing = backing;
                        }
                     });

                  },function (error) {
                     log.error(error);
                  });

               if (scope.device.backing.deviceName) {
                  scope.properties.selectedCdrom = _.find(scope.cdromList, function (entry) {
                     return entry.name === scope.device.backing.deviceName;
                  });
               }

               scope.availableControllers = vmDeviceInfoService.availableControllersForDevice(
                  scope.inflatedDevice,
                  scope.virtualMachineDevicesNeededForControllerAndNode.getAllDevicesNotMarkedForRemoval()
               );

               scope.properties.controller = _.find(scope.availableControllers, function (controller) {
                  return controller.getKey() === scope.device.controllerKey;
               });
               if (!scope.properties.controller) {
                  throw new Error('Could not find controller for device: ', scope.inflatedDevice.getKey());
               }

               scope.validateCdDrive = function (mediaType) {
                  if (vmHardwareCdromManagerService.isContentLibraryISOFile(mediaType)) {
                     setFormValidity(true);
                     if (scope.properties.selectedIsoItem) {
                        scope.device.backing = vmHardwareCdromManagerService.createIsoBacking(
                           scope.properties.selectedIsoItem.isoPath,
                           scope.device.backing.datastore,
                           scope.device.backing.backingObjectId);
                     }
                  }
                  else if (vmHardwareCdromManagerService.isDatastoreISOFile(mediaType)) {
                     // sometimes watcher for device.backing.filename is triggered
                     // after the device is marked for removal and validates the
                     // device, we don't want this to happen if device is already
                     // marked for removal
                     if (scope.inflatedDevice.isMarkedForRemoval()) {
                        setFormValidity(true);
                        return;
                     }

                     setFormValidity(false);
                     debouncedRefreshCallback();
                  }
                  else {
                     setFormValidity(true);
                  }
               };

               scope.hasEditCdRomError = function () {
                  var backingFileNameField = getBackingFileNameField();
                  if (backingFileNameField) {
                     return backingFileNameField.$invalid;
                  }
                  return false;
               };

               scope.shouldRemoveDeviceBeDisabled = function () {
                  if (!scope.createMode && !vmHardwareCdromManagerService.hasPrivileges(scope.vmConfigContext.privileges)) {
                     return true;
                  }

                  if (scope.isVmPoweredOn) {
                     var controllerOptions = vmDeviceInfoService.optionForDevice(
                        scope.vmConfigContext, scope.inflatedDevice, scope.virtualMachineDevicesNeededForControllerAndNode.getAllDevicesNotMarkedForRemoval()
                     );
                     return !controllerOptions.hotRemoveSupported;
                  }

                  return false;
               };

               scope.onCdRomRemoval = function () {
                  if (!scope.shouldRemoveDeviceBeDisabled() && scope.removeCallback) {
                     scope.removeCallback()(scope.inflatedDevice);

                     // on device removal mark form valid if it was not, later
                     // if removal is reverted, we will re-calculate validity
                     setFormValidity(true);
                  }
               };

               scope.onRevertRemoval = function () {
                  if (!scope.inflatedDevice) {
                     return;
                  }

                  scope.inflatedDevice.revertRemoval();
                  // re-calculate the form validity, because it was maked valid
                  // on device removal
                  scope.validateCdDrive(scope.properties.mediaType);
               };

               scope.browseForDatastoreIso = function () {
                  selectIsoFileService.display(scope);
               };

               scope.browseForContentLibraryIso = function () {
                  contentLibraryIsoSelectorModalService
                     .openContentLibraryIsoSelector(scope.computeResourceId,
                        scope.properties.selectedIsoItem,
                        function (selectedIsoItem) {
                           scope.properties.selectedIsoItem = selectedIsoItem;
                           scope.device.backing.fileName = scope.properties.selectedIsoItem.isoPath;
                           scope.errors.isoErrorForCL = isoErrors.noError;
                        },function () {
                           if(!scope.properties || !scope.properties.selectedIsoItem){
                              scope.errors.isoErrorForCL = isoErrors.fileMissing;
                           }
                        });
               };

               scope.isDatastoreISOFile = function () {
                  return vmHardwareCdromManagerService.isDatastoreISOFile(scope.properties.mediaType);
               };
               scope.isContentLibraryISOFile = function () {
                  return vmHardwareCdromManagerService.isContentLibraryISOFile(scope.properties.mediaType);
               };

               scope.isHostDevice = function () {
                  return vmHardwareCdromManagerService.isHostDevice(scope.properties.mediaType);
               };

               scope.isClientDevice = function () {
                  return vmHardwareCdromManagerService.isClientDevice(scope.properties.mediaType);
               };

               scope.isRemoteDevice = function () {
                  var device = scope.inflatedDevice.getCurrentDevice();
                  return vmHardwareCdromManagerService.isRemoteDevice(device.backing);
               };

               scope.$watchGroup(['properties.startConnected', 'properties.connected'], function (newValue) {
                  scope.device.connectable.startConnected = newValue[0];
                  scope.device.connectable.connected = newValue[1];
               });

               scope.$watch('properties.deviceMode', function (newValue) {
                  if (vmHardwareCdromManagerService.isClientDevice(scope.properties.mediaType)) {
                     var backing = vmHardwareCdromManagerService.createClientDeviceBacking(newValue);
                     scope.device.backing = backing;
                  }
               });

               scope.onControllerNodeChanged = function (deviceController, node) {
                  if (!node) {
                     return;
                  }
                  scope.device.unitNumber = node.key;
               };

               scope.onCdRomChanged = function (selectedCdRomName) {
                  scope.device.backing.deviceName = selectedCdRomName;
               };

               scope.isCdRomDisabled = function () {
                  return vmHardwareCdromManagerService.isCdRomDisabled(scope.vmConfigContext.privileges,
                     scope.skipPermissionCheck);
               };

               scope.isCdRomConnectedAtPowerOnDisabled = function () {
                  return vmHardwareCdromManagerService.isCdRomConnectedAtPowerOnDisabled(scope.properties.mediaType,
                     scope.vmConfigContext.privileges,
                     scope.skipPermissionCheck);
               };

               scope.isCdRomConnectedDisabled = function () {
                  var device = scope.inflatedDevice.getCurrentDevice();
                  return vmHardwareCdromManagerService.isCdRomConnectedDisabled(device.backing,
                     scope.vmConfigContext.privileges,
                     scope.skipPermissionCheck);
               };

               scope.isDeviceModeDisabled = function () {
                  return vmHardwareCdromManagerService.isDeviceModeDisabled(scope.properties.mediaType,
                     scope.vmConfigContext.privileges,
                     scope.skipPermissionCheck);
               };

               scope.hasError = function () {
                  var hardwareCdromformaName = 'vmHardwareCdRomForm' + scope.inflatedDevice.getKey();
                  return scope.formCtrl[hardwareCdromformaName].$invalid || scope.isHostDeviceBackingInvalid();
               };

               scope.isHostDeviceBackingInvalid = function() {

                  if (vmHardwareCdromManagerService.hasHostDevicebacking(scope.device) &&
                        !vmHardwareCdromManagerService.isDevicePresentInTheHost(scope.device.backing.deviceName,
                              scope.vmConfigContext.environment.configTarget.cdRom)) {
                     return true;
                  }

                  return false;
               };

               scope.getCdRomLabel = function(cdRomDeviceName) {
                   if (!vmHardwareCdromManagerService.isDevicePresentInTheHost(cdRomDeviceName,
                               scope.vmConfigContext.environment.configTarget.cdRom)){
                      return cdRomDeviceName + " (" + scope.i18n('VmUi', 'CdromPage.DeviceNotAvailable') + ")";
                   }

                   return cdRomDeviceName;
               };

               var debouncedRefreshCallback = _.debounce(function () {
                  validateDataStoreIsoFileAndSetDeviceBacking(scope.device.backing.fileName);
               }, vcH5ConstantsService.CHANGELOG_REFRESH_DELAY);

               function setFormValidity(validity) {
                  var backingFileNameField = getBackingFileNameField();
                  if (backingFileNameField) {
                     backingFileNameField.$setValidity(getIsoValidatorName(), validity);
                  }
               }

               function validateDataStoreIsoFileAndSetDeviceBacking(fileName) {
                  if (_.isEmpty(fileName)) {
                     scope.errors.isoError = isoErrors.fileMissing;
                     setFormValidity(false);
                  } else {
                     var dsBrowserId = defaultUriSchemeUtil.getVsphereObjectId(
                        scope.vmConfigContext.environment.datastoreBrowser);
                     var fileType = datastoreBrowserConstants.fileQueryType.ISO_IMAGE;
                     datastoreBrowserTreeService.isFileExists(dsBrowserId, fileName, fileType)
                        .then(function (fileExists) {
                           scope.errors.isoError = fileExists ?
                              isoErrors.noError :
                              isoErrors.fileDoesNotExists;
                           setFormValidity(fileExists);
                           if (fileExists) {
                              scope.device.backing = vmHardwareCdromManagerService.createIsoBacking(
                                 fileName,
                                 scope.device.backing.datastore,
                                 scope.device.backing.backingObjectId);
                           }
                        });
                  }
               }

               function addIsoFileValidator() {
                  var backingFileNameField = getBackingFileNameField();
                  if (backingFileNameField && !backingFileNameField.$validators[getIsoValidatorName()]) {
                     backingFileNameField.$validators[getIsoValidatorName()] = function (modelValue, viewValue) {
                        return true;
                     };
                  }
               }

               function getBackingFileNameField() {
                  var hardwareCdromformaName = 'vmHardwareCdRomForm' + scope.inflatedDevice.getKey();
                  var backingFileNameFieldName = 'editCdrom' + scope.inflatedDevice.getKey() + 'BackingFileName';
                  return scope.formCtrl[hardwareCdromformaName][backingFileNameFieldName];
               }

               function getIsoValidatorName() {
                  return 'isoValidator' + scope.inflatedDevice.getKey();
               }

               function updatePreviousIsoSelection(oldMediaType) {
                  if (vmHardwareCdromManagerService.isDatastoreISOFile(oldMediaType)) {
                     scope.previousDatastoreISOSelection = scope.device.backing.fileName;
                  } else if (vmHardwareCdromManagerService.isContentLibraryISOFile(oldMediaType)) {
                     scope.previousContentLibraryISOSelection = scope.device.backing.fileName;
                  }
               }

               function copyAvailableCdRomListOnTheHost(availableCdRomList) {
                  var hostCdRomList = [];
                  if (!_.isEmpty(availableCdRomList)) {
                     hostCdRomList = availableCdRomList.slice(0);
                  }

                  return hostCdRomList;
               }

               var i18n = function(key, section) {
                  if (!section) {
                     section = 'CdromPage';
                  }
                  return i18nService.getString('VmUi', section + '.' + key);
               };

               scope.ARIA_LBL_MEDIA_TYPE = i18n('MediaType');
               scope.ARIA_LBL_CONNECTED = i18n('Connected');
               scope.ARIA_LBL_START_CONNECTED = i18n('ConnectAtPowerOn', 'ConnectDevice');
               scope.ARIA_LBL_MODE = i18n('DeviceMode');
               scope.ARIA_LBL_FILE = i18n('Media');
               scope.ARIA_LBL_BROWSE = i18n('Browse');
               scope.ARIA_LBL_HOST = i18n('HostDevice', 'CdromConfig');
            }
         }
      };
   }
]);

var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var VmHardwareController = (function () {
        function VmHardwareController($scope, $document, creationTypeConstants, cpuService, guestOsService, vmDeviceInfoService, vmHardwareUtil, vmHardwareEditService, vmDeviceManagementService, i18nService, defaultUriSchemeUtil, vmEditSettingsDatastoreRecommendationService, storageProfileService, dataService, $q, vmHardwareDeviceMenuService, nvdimmProvisioningService, vmCryptUtilService, tpmProvisioningService, virtualDiskSettingsFormService, basicDiskUtilService) {
            var _this = this;
            this.$scope = $scope;
            this.$document = $document;
            this.creationTypeConstants = creationTypeConstants;
            this.cpuService = cpuService;
            this.guestOsService = guestOsService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.vmHardwareEditService = vmHardwareEditService;
            this.vmDeviceManagementService = vmDeviceManagementService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.vmEditSettingsDatastoreRecommendationService = vmEditSettingsDatastoreRecommendationService;
            this.storageProfileService = storageProfileService;
            this.dataService = dataService;
            this.$q = $q;
            this.vmHardwareDeviceMenuService = vmHardwareDeviceMenuService;
            this.nvdimmProvisioningService = nvdimmProvisioningService;
            this.vmCryptUtilService = vmCryptUtilService;
            this.tpmProvisioningService = tpmProvisioningService;
            this.virtualDiskSettingsFormService = virtualDiskSettingsFormService;
            this.basicDiskUtilService = basicDiskUtilService;
            this.PCI_CONTROLLER_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualPCIController";
            this.NVME_CONTROLLER_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualNVMEController";
            this.VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY = "vmStorageProfileAssignments";
            this.VM_REPLICATION_GROUP_ASSIGNMENTS_PROPERTY = "vmReplicationGroupAssignments";
            this.VM_HOST_PROPERTY = "host";
            this.TPM_VIEW_ID = "TPM_VIEW_ID";
            this.ON_CHILD_CHANGE_EVENT = "onChildValidationChange";
            //this is the number of hard disks that will be displayed as solo elements
            //if total-count-of-hdd > 4 then embed them all in a static group called "Hard disks"
            this.MAX_SOLO_HARD_DISK_COUNT = 4;
            this.maxPciDevicesControllers = 32;
            this.maxEthernetCards = 10;
            this.maxPCIPassthrough = 6;
            this.pciEthernetCount = 0;
            this.keepExistingProfileAssignments = false;
            this.totalHardDiskSizeText = '';
            this.hardDiskStackBlockClicked = false;
            this.isGroupingHardDisks = false;
            this.removeDevice = function (virtualDevice) {
                _this.removeDeviceInternal(virtualDevice);
            };
            this.$scope.config = this.$scope.config || {};
            this.$scope.config.loading = true;
            this.isInvalid = false;
            this.iconForDevice = this.vmDeviceInfoService.iconForDevice;
            this.storageLocatorItemsData = this.$scope.storageLocatorItemsData;
            this.isXVc = this.$scope.vmParams && this.$scope.vmParams.isXvc();
            this.canAddDevice = true;
            this.banner = {};
            this.deployVmtxMode = false;
            this.stackBlocksExpandedState = this.$scope.customizeHardwarePageModel
                ? this.$scope.customizeHardwarePageModel.getStackBlocksExpandedState()
                : { virtualDevices: [] };
            var checkForErrors;
            if (this.$scope.modalOptions) {
                this.setupForEditMode();
                checkForErrors = function (isInvalid) {
                    _this.notifyValidationChange(!isInvalid);
                    _this.isInvalid = isInvalid;
                };
            }
            else if ($scope.vmParams.getCreationType() === creationTypeConstants.CLONE_VM_TO_VM
                || $scope.vmParams.getCreationType() === creationTypeConstants.CLONE_TEMPLATE_TO_VM
                || this.$scope.vmParams.getCreationType() === this.creationTypeConstants.DEPLOY_VM_FROM_VMTX) {
                this.deployVmtxMode = this.$scope.vmParams.getCreationType() === this.creationTypeConstants.DEPLOY_VM_FROM_VMTX;
                this.setupForCloneMode();
                checkForErrors = function (isInvalid) {
                    _this.notifyValidationChange(!isInvalid);
                    $scope.customizeHardwarePageModel.setFormValidity(!isInvalid);
                };
            }
            else {
                this.setupForCreate();
                checkForErrors = function (isInvalid) {
                    _this.notifyValidationChange(!isInvalid);
                    $scope.customizeHardwarePageModel.setFormValidity(!isInvalid);
                };
            }
            $scope.$watch("hardwareForm.$invalid", checkForErrors, true);
            this.addDevicesMenuConfig = this.vmHardwareDeviceMenuService.getAddDevicesMenuConfig(function (event, clickedItem) {
                _this.addDevice(event, clickedItem);
            });
            this.createMode = this.vmWorkflowMode === VmWorkflowMode.CreateMode;
            this.cloneMode = this.vmWorkflowMode === VmWorkflowMode.CloneMode;
            this.pciEthernetCount = 0;
            if (this.virtualEthernetCard) {
                this.pciEthernetCount = this.virtualEthernetCard.length;
            }
            var globalClickHandler = function (e) {
                _this.hideAddDevicesMenu(e);
            };
            this.$document.on("click", globalClickHandler);
            this.$scope.$on("$destroy", function () {
                _this.$document.off("click", globalClickHandler);
            });
            this.removeDevice = function (virtualDevice) {
                _this.removeDeviceInternal(virtualDevice);
            };
        }
        VmHardwareController.prototype.updateActionDefsForAddDeviceMenu = function (keysToRemove) {
            keysToRemove = keysToRemove ? keysToRemove : [];
            // hide the option only in edit mode
            if (this.vmWorkflowMode === VmWorkflowMode.UpdateMode && !this.showNewNvidmmMenu()) {
                keysToRemove.push("addNewNvdimmAction");
            }
            this.addDeviceActionDefs = this.vmHardwareDeviceMenuService.getAddDeviceActions(this.vmConfigContext.privileges, this.vmWorkflowMode, keysToRemove);
        };
        ;
        VmHardwareController.prototype.removeDeviceInternal = function (virtualDevice) {
            var _this = this;
            var deviceKey = virtualDevice.getKey();
            this.virtualMachineDevices.removeDeviceByKey(deviceKey);
            this.$scope.$broadcast("deviceRemoved", {
                deviceKey: virtualDevice.getKey(),
                deviceType: virtualDevice.getCurrentDevice()._type
            });
            if (this.vmDeviceInfoService.isDeviceSubclassOf(virtualDevice.getCurrentDevice(), 'VirtualTPM')) {
                this.shouldAllowAddTpmAction().then(function (result) {
                    if (result) {
                        _this.updateActionDefsForAddDeviceMenu();
                    }
                    else {
                        _this.updateActionDefsForAddDeviceMenu(['addNewTpmAction']);
                    }
                });
                this.$scope.$emit(this.ON_CHILD_CHANGE_EVENT, this.TPM_VIEW_ID, true);
            }
            if (!_.isUndefined(this.stackBlocksExpandedState.virtualDevices[deviceKey])) {
                delete this.stackBlocksExpandedState.virtualDevices[deviceKey];
            }
        };
        VmHardwareController.prototype.getNewDevices = function (deviceType) {
            return this.virtualMachineDevices.newDevicesOfType(deviceType);
        };
        VmHardwareController.prototype.isThereNewSATA = function () {
            return this.virtualMachineDevices.newDevicesOfType(DeviceTypeConstants.VIRTUAL_SATA_CONTROLLER).length > 0;
        };
        VmHardwareController.prototype.toggleAddDevicesMenu = function () {
            this.addDevicesMenuConfig.showMenu = !this.addDevicesMenuConfig.showMenu;
            if (this.addDevicesMenuConfig.showMenu) {
                this.addDevicesMenuConfig.menuItems = this.vmHardwareDeviceMenuService.getAddDeviceMenuItems(this.addDeviceActionDefs);
            }
        };
        VmHardwareController.prototype.getUSBControllerList = function () {
            var retVal = [];
            var usb2 = this.virtualMachineDevices.existingDevicesOfType(DeviceTypeConstants.VIRTUAL_USB_CONTROLLER);
            var usb3 = this.virtualMachineDevices.existingDevicesOfType(DeviceTypeConstants.VIRTUAL_USB_XHCI_CONRTOLLER);
            var usb2new = this.virtualMachineDevices.newDevicesOfType(DeviceTypeConstants.VIRTUAL_USB_CONTROLLER);
            var usb3new = this.virtualMachineDevices.newDevicesOfType(DeviceTypeConstants.VIRTUAL_USB_XHCI_CONRTOLLER);
            retVal = retVal.concat(usb2).concat(usb3).concat(usb2new).concat(usb3new);
            return retVal;
        };
        VmHardwareController.prototype.getExistingAndNewDevices = function (shortType) {
            var retVal = [];
            var oldList = this.virtualMachineDevices.existingDevicesOfType(shortType);
            var newList = this.virtualMachineDevices.newDevicesOfType(shortType);
            retVal = retVal.concat(oldList).concat(newList);
            return retVal;
        };
        VmHardwareController.prototype.getUSBDeviceList = function () {
            var retVal = this.getExistingAndNewDevices(DeviceTypeConstants.VIRTUAL_USB);
            return retVal;
        };
        VmHardwareController.prototype.getInflatedVideoCard = function () {
            var list = this.getExistingAndNewDevices(DeviceTypeConstants.VIDEO_CARD);
            if (!list || list.length < 1) {
                return null;
            }
            var videoCard = list[0];
            videoCard.attachVmConfig(this.vmConfig);
            return videoCard;
        };
        VmHardwareController.prototype.getPciSharedList = function () {
            return this.getPciDeviceList(true);
        };
        VmHardwareController.prototype.getPciDeviceList = function (needShared) {
            if (needShared === void 0) { needShared = false; }
            var list = this.getExistingAndNewDevices(DeviceTypeConstants.VirtualPCIPassthrough);
            var retVal = [];
            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                var item = list_1[_i];
                var device = item;
                var isShared = device.isSharedPCIBackingType();
                if (isShared !== needShared) {
                    continue;
                }
                device.attachVmConfig(this.vmConfig);
                device.removeCallback = this.removeDevice;
                retVal.push(item);
            }
            return retVal;
        };
        VmHardwareController.prototype.isDiskGroupingRequired = function () {
            return this.isGroupingHardDisks;
        };
        // hard disks stack block is a stack-view introduced to put all hard-disks under
        // one stack-block element that reads "Hard disks". That nested stack-view is
        // using clarity stack-view's styling way of drawing a stack-view (as opposed to the
        // clr-stack-view: component way).
        // This function handles the click event on the new row/stack-block introduced called "Hard disks".
        VmHardwareController.prototype.hardDisksStackClicked = function () {
            this.hardDiskStackBlockClicked = !this.hardDiskStackBlockClicked;
        };
        Object.defineProperty(VmHardwareController.prototype, "hardDisksStackExpanded", {
            // initially the "Hard disks" stack-view is not expanded. so that's the false state.
            // next click expands it - and allows all ng-repeat to fill in the hard disks.
            get: function () {
                return this.hardDiskStackBlockClicked;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareController.prototype.isAddDeviceMenuEnabled = function () {
            if (this.isEditingSuspendedVM() || this.deployVmtxMode) {
                // NO adding devices/controllers when editing suspended VM
                return false;
            }
            if (this.addDevicesMenuConfig.menuItems.length === 0) {
                this.addDevicesMenuConfig.menuItems = this.vmHardwareDeviceMenuService.getAddDeviceMenuItems(this.addDeviceActionDefs);
            }
            return this.vmHardwareDeviceMenuService.isAddDeviceMenuEnabled(this.addDevicesMenuConfig.menuItems);
        };
        VmHardwareController.prototype.isEditingSuspendedVM = function () {
            if (this.vmWorkflowMode !== VmWorkflowMode.UpdateMode) {
                return false;
            }
            return h5_vm.VmHardwareUtil.isSuspended(this.vmConfigContext);
        };
        // deliver change to parent
        VmHardwareController.prototype.notifyValidationChange = function (isValid) {
            this.$scope.$emit("onChildValidationChange", this, isValid);
        };
        VmHardwareController.prototype.isRDMDisk = function (virtualDisk) {
            return virtualDisk.isRDMDisk();
        };
        VmHardwareController.prototype.isNotRDMDisk = function (virtualDisk) {
            return !virtualDisk.isRDMDisk();
        };
        VmHardwareController.prototype.checkPciLimit = function () {
            if (this.pciEthernetCount >= this.maxEthernetCards) {
                this.showError(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceLimitReached"));
                this.canAddDevice = false;
            }
            else {
                this.clearError();
                this.canAddDevice = true;
            }
        };
        VmHardwareController.prototype.emitInfo = function (msg) {
            this.$scope.$emit("editSettingsAlertMessageChanged", msg);
        };
        VmHardwareController.prototype.showInfo = function (txt) {
            var msg = {
                isVisible: true,
                class: "info-standard",
                iconShape: "info-standard",
                text: txt };
            this.emitInfo(msg);
        };
        VmHardwareController.prototype.showError = function (message) {
            var bannerMessage = [{
                    text: message,
                    type: "error"
                }];
            if (this.$scope.config && this.$scope.config.validationBanner) {
                this.$scope.config.validationBanner.messages = bannerMessage;
            }
            else {
                this.banner.messages = bannerMessage;
            }
        };
        VmHardwareController.prototype.clearError = function () {
            if (this.$scope.config && this.$scope.config.validationBanner) {
                this.$scope.config.validationBanner.messages = [];
            }
            else {
                this.banner.messages = [];
            }
        };
        VmHardwareController.prototype.updatePciCounter = function () {
            var _this = this;
            this.virtualControllers = this.virtualMachineDevices.existingDevicesOfType(DeviceTypeConstants.VIRTUAL_CONTROLLER);
            this.changeDevices = this.virtualMachineDevices.getDeviceChanges();
            if (this.virtualEthernetCard) {
                this.pciEthernetCount = this.virtualEthernetCard.length;
            }
            this.changeDevices.forEach(function (spec) {
                if (_this.vmHardwareUtil.isEthernetDevice(spec)) {
                    var op = spec.operation;
                    if (op === "add") {
                        _this.pciEthernetCount++;
                    }
                    else if (op === "remove") {
                        _this.pciEthernetCount--;
                    }
                }
            });
        };
        VmHardwareController.prototype.showErrorByDeviceType = function (deviceType) {
            if (deviceType === DeviceTypeConstants.VIRTUAL_USB) {
                return this.showErrorForUsb();
            }
            // check for other device types as needed
            return false;
        };
        VmHardwareController.prototype.showErrorForUsb = function () {
            if (h5_vm.VmHardwareUsbControllerUtil.areBothUSBControllerMarkedForRemoval(this.virtualMachineDevices)) {
                this.showError(this.i18nService.getString("VmUi", "VmDeviceManager.BothUSBControllersMarkedForRemoval"));
                return true;
            }
            return false;
        };
        VmHardwareController.prototype.addDevice = function (event, clickedItem) {
            var _this = this;
            this.clearError();
            var deviceType = this.addDeviceActionDefs[clickedItem.id].deviceType;
            var additionalParameters = {};
            if (deviceType === DeviceTypeConstants.VIRTUALDISK
                || deviceType === DeviceTypeConstants.RDMDISK
                || deviceType === DeviceTypeConstants.EXISTINGHARDDISK) {
                additionalParameters.selectedStorageProfile = this.selectedStorageProfile;
                additionalParameters.selectedReplicationGroupInfo = this.selectedReplicationGroupInfo;
            }
            if (deviceType === 'VirtualTPM') {
                this.addDeviceActionDefs = this.vmHardwareDeviceMenuService.getAddDeviceActions(this.vmConfigContext.privileges, this.vmWorkflowMode, ['addNewTpmAction']);
                additionalParameters.serverGuid = this.getServerGuid();
                additionalParameters.callback = function (virtualTpmDevice) {
                    if (virtualTpmDevice.state === virtualTpmDevice.NOT_CONNECTED ||
                        virtualTpmDevice.state === virtualTpmDevice.CONNECTING) {
                        _this.$scope.$emit(_this.ON_CHILD_CHANGE_EVENT, _this.TPM_VIEW_ID, false);
                        if (_this.$scope.customizeHardwarePageModel) {
                            _this.$scope.customizeHardwarePageModel.setFormValidity(false);
                        }
                    }
                };
            }
            if (deviceType === DeviceTypeConstants.ETHERNET) {
                this.updatePciCounter();
                this.checkPciLimit();
            }
            if (this.showErrorByDeviceType(deviceType)) {
                return;
            }
            if (deviceType === "VirtualNVDIMM") {
                this.populateAdditionalParametersForNvdimm(additionalParameters);
            }
            if (deviceType === DeviceTypeConstants.EXISTINGHARDDISK) {
                additionalParameters.vmConfigContext = this.vmConfigContext;
                additionalParameters.serverGuid = this.getServerGuid();
                additionalParameters.storageProfiles = this.storageProfiles;
            }
            if (this.canAddDevice) {
                try {
                    this.vmDeviceManagementService.createNewDevice(deviceType, this.vmConfigContext.environment, this.getGuestOsDescriptor(), this.virtualMachineDevices, additionalParameters).then(function (result) {
                        var newDeviceKey = result.newDeviceKey
                            ? result.newDeviceKey
                            : result;
                        if (result.newVmProfile) {
                            if (_this.$scope.vmParams) {
                                _this.$scope.vmParams.setSelectedStorageProfile(result.newVmProfile);
                                _this.selectedStorageProfile = result.newVmProfile;
                                if (_this.$scope.vmParams.getStorageSelectorState()) {
                                    var storageSelectorState = _this.$scope.vmParams.getStorageSelectorState();
                                    if (storageSelectorState.basicModeState
                                        && storageSelectorState.basicModeState.profilesData) {
                                        storageSelectorState.basicModeState.profilesData.selectedProfile =
                                            result.newVmProfile;
                                    }
                                }
                            }
                            _this.$scope.$broadcast("vmHomeStorageProfileChanged", result.newVmProfile);
                        }
                        _this.$scope.$broadcast("deviceAdded", {
                            deviceKey: newDeviceKey,
                            deviceType: deviceType
                        });
                        _this.stackBlocksExpandedState.virtualDevices[newDeviceKey] = false;
                    });
                }
                catch (error) {
                    this.showError.call(this, error.message);
                }
            }
        };
        VmHardwareController.prototype.getGuestOsDescriptor = function () {
            var _this = this;
            if (this.vmWorkflowMode === VmWorkflowMode.CreateMode
                || this.vmWorkflowMode === VmWorkflowMode.CloneMode) {
                return _.find(this.vmConfigContext.environment.configOption.guestOSDescriptor, function (osDescriptor) {
                    return osDescriptor.id === _this.$scope.vmParams.getGosVersion().id;
                });
            }
            else {
                return this.vmConfigContext.environment.configOption.guestOSDescriptor[0];
            }
        };
        VmHardwareController.prototype.getServerGuid = function () {
            if (this.vmWorkflowMode === VmWorkflowMode.CreateMode) {
                return this.defaultUriSchemeUtil.getManagedObjectReference(this.$scope.vmParams.getTargetInformation().folderUid).serverGuid;
            }
            else {
                return this.defaultUriSchemeUtil.getManagedObjectReference(this.vmId).serverGuid;
            }
        };
        VmHardwareController.prototype.setupVbsProperties = function (vbsProperties, config) {
            this.setVbsEnabled(true, config);
            config.flags.vvtdEnabled = vbsProperties["flags.vvtdEnabled"];
            config.nestedHVEnabled = vbsProperties["nestedHVEnabled"];
        };
        VmHardwareController.prototype.setVbsEnabled = function (enabled, config) {
            config.flags.vbsEnabled = enabled;
        };
        VmHardwareController.prototype.setupForCreate = function () {
            var _this = this;
            this.vmWorkflowMode = VmWorkflowMode.CreateMode;
            this.$scope.$on("$destroy", function () {
                _this.$scope.config.loading = false;
            });
            var guestOs = this.guestOsService.getGuestOsDescriptor(this.$scope.hardwareConfigData.vmConfigContext, this.$scope.vmParams.getGosVersion());
            var setupData = angular.extend({}, this.$scope.hardwareConfigData, {
                guestOs: guestOs
            });
            this.setup(setupData);
            this.storageLocatorItemsData = this.$scope.wizardViewData.getStorageLocatorItemsData();
            this.setStorageForDisk = function (storageInfo, device) {
                _this.$scope.vmParams.setStorageForDisk(storageInfo, device);
            };
            this.getStorageForDisk = function (diskKey) {
                return _this.$scope.vmParams.getStorageForDisk(diskKey);
            };
            this.vmStorageId = this.defaultUriSchemeUtil.getVsphereObjectId(this.$scope.vmParams.getStorageObject().storageRef);
            if (this.$scope.vmParams.getVbsSupported()) {
                if (this.$scope.vmParams.getVbsEnabled()) {
                    this.setupVbsProperties(this.getVbsProperties("flags.vbsEnabled"), this.$scope.vmParams.getVmConfigSpec().config);
                }
                else {
                    this.setVbsEnabled(false, this.$scope.vmParams.getVmConfigSpec().config);
                }
            }
            this.computeResourceId = this.$scope.vmParams.getComputeResourceId();
            if (this.$scope.vmParams.getStorageSelectorState()) {
                this.storageBaselineId =
                    this.$scope.vmParams.getStorageSelectorState().storageBaselineId;
            }
        };
        VmHardwareController.prototype.initializeCpu = function (vmConfigContext) {
            // TODO civanova: After implementing memory affinity add logic for
            // initializing vmConfigContext.config.memoryAffinity the same way cpuAffinity
            // is initialized when missing
            var hasPrivilege = vmConfigContext.privileges.indexOf(Privileges.VM_RESOURCE_PRIVILEGE) > -1;
            if (hasPrivilege && !vmConfigContext.config.cpuAffinity) {
                vmConfigContext.config.cpuAffinity = {
                    _type: "com.vmware.vim.binding.vim.vm.AffinityInfo",
                    affinitySet: []
                };
            }
            if (!vmConfigContext.config.cpuFeatureMask) {
                vmConfigContext.config.cpuFeatureMask = [];
            }
        };
        VmHardwareController.prototype.setupForCloneMode = function () {
            var _this = this;
            this.vmWorkflowMode = VmWorkflowMode.CloneMode;
            this.$scope.$on("$destroy", function () {
                _this.$scope.config.loading = false;
            });
            this.vmId = this.$scope.vmParams.getVmId();
            this.$scope.vmParams.setCustomizeCloneHardware(true);
            var vmConfigContext = this.$scope.hardwareConfigData.vmConfigContext;
            var guestOs = this.guestOsService
                .getAppropriateGuestOs(vmConfigContext, this.$scope.vmParams.getGosVersion());
            this.initializeCpu(vmConfigContext);
            var setupData = angular.extend({}, this.$scope.hardwareConfigData, {
                guestOs: guestOs
            });
            this.setup(setupData);
            this.storageLocatorItemsData = this.$scope.wizardViewData.getStorageLocatorItemsData();
            var storageSelectorState = this.$scope.vmParams.getStorageSelectorState();
            if (storageSelectorState) {
                this.storageBaselineId = storageSelectorState.storageBaselineId;
                if (storageSelectorState.mode === "basicMode"
                    && !_.isEmpty(storageSelectorState.basicModeState)
                    && !_.isEmpty(storageSelectorState.basicModeState.profilesData)
                    && !_.isEmpty(storageSelectorState.basicModeState.profilesData.selectedProfile)) {
                    var keepExistingProfileAssignments = storageSelectorState.basicModeState
                        .profilesData.selectedProfile.keepExistingProfileAssignments;
                    this.keepExistingProfileAssignments = !_.isUndefined(keepExistingProfileAssignments)
                        ?
                            keepExistingProfileAssignments
                        : false;
                }
            }
            this.setStorageForDisk = function (storageInfo, device) {
                _this.$scope.vmParams.setStorageForDisk(storageInfo, device);
            };
            this.computeResourceId = this.$scope.vmParams.getComputeResourceId();
            this.vmStorageId = this.defaultUriSchemeUtil.getVsphereObjectId(this.$scope.vmParams.getStorageObject().storageRef);
            this.getStorageForDisk = function (diskKey) {
                return _this.$scope.vmParams.getStorageForDisk(diskKey);
            };
            this.selectedDiskFormat = this.$scope.vmParams.getDiskFormat();
        };
        VmHardwareController.prototype.setupForEditMode = function () {
            var _this = this;
            this.vmId = this.$scope.modalOptions.availableTargets[0];
            this.vmWorkflowMode = VmWorkflowMode.UpdateMode;
            var guestOs = this.guestOsService.getSelectedGuestOs(this.$scope.hardwareConfigData.vmConfigContext);
            var setupData = angular.extend({}, this.$scope.hardwareConfigData, {
                guestOs: guestOs
            });
            this.isVmPoweredOn = setupData.vmConfigContext.environment.powerState === 'poweredOn';
            var vmDatastore = setupData.vmConfigContext.storageInfo.datastore;
            this.vmStorageId = vmDatastore ?
                this.defaultUriSchemeUtil.getVsphereObjectId(vmDatastore) : null;
            this.setup(setupData, true, false);
            var requests = {
                vmAssignmentsPropertiesRequest: this.vmAssignmentsProperties
            };
            this.$q.all(requests).then(function (response) {
                var data = response.vmAssignmentsPropertiesRequest;
                if (!data) {
                    return;
                }
                var assignments = data.vmStorageProfileAssignments;
                var replication = data.vmReplicationGroupAssignments;
                if (assignments) {
                    assignments.then(function (val) {
                        val = val.vmStorageProfileAssignments;
                        if (!val) {
                            return;
                        }
                        var profile = val.homeStorageProfile;
                        _this.selectedStorageProfile = {
                            profileObj: profile
                        };
                        if (profile) {
                            _this.selectedStorageProfile.id = profile.profileId.uniqueId;
                            _this.selectedStorageProfile.label = profile.name;
                        }
                    });
                }
                if (data.host) {
                    _this.computeResourceId = _this.defaultUriSchemeUtil.getVsphereObjectId(data.host);
                }
                if (replication) {
                    replication.then(function (val) {
                        val = val.vmReplicationGroupAssignments;
                        _this.vmHomeReplicationGroup = _this.getVmHomeRg(val);
                    });
                }
                else {
                    _this.vmHomeReplicationGroup = null;
                }
            });
            // todo This needs to be moved up to vmEditSettings directive
            this.$scope.$parent.save = function () {
                var vmConfigContextConfig = _this.vmConfigContext.config;
                var originalVmConfig = _this.originalConfig;
                var virtualMachineDevices = _this.virtualMachineDevices;
                var operation = _this.$scope.modalOptions.title;
                var vmId = _this.vmId;
                // TODO refactor to a proper name `vmConfigContextConfig` https://www.pivotaltracker.com/story/show/138740157
                var cpuFeatureMask = _this.cpuService.createCpuIdInfoDelta(originalVmConfig.cpuFeatureMask, vmConfigContextConfig.cpuFeatureMask);
                var vmProfile = _this.vmConfigContext.vmProfile;
                var storageObject = {};
                var storageInfo = _this.vmConfigContext.storageInfo;
                if (storageInfo.datastore) {
                    storageObject.storageRef = storageInfo.datastore;
                    storageObject.parentStoragePod = storageInfo.datastoreCluster;
                    // XXX - vaivanov
                    // storageLocator js extends the storageRef with this isSdrsEnabled property which is not correct
                    // but we need to replicate this behavior here till that is fixed. We need that because we want to reuse
                    // the podSelectionSpecService.createSpec() logic.
                    if (storageObject.parentStoragePod) {
                        storageObject.parentStoragePod.isSdrsEnabled = storageInfo.isSdrsEnabledForDsCluster;
                    }
                }
                else if (storageInfo.datastoreCluster) {
                    storageObject.storageRef = storageInfo.datastoreCluster;
                    // XXX - vaivanov
                    // storageLocator js extends the storageRef with this isSdrsEnabled property which is not correct
                    // but we need to replicate this behavior here till that is fixed. We need setupforthat because we want to reuse
                    // the podSelectionSpecService.createSpec() logic.
                    storageObject.storageRef.isSdrsEnabled = storageInfo.isSdrsEnabledForDsCluster;
                }
                else {
                    storageObject = undefined; // Valid case when missing System.Read on storage
                }
                if (_this.vmEditSettingsDatastoreRecommendationService.shouldCheckRecommendations(storageObject, virtualMachineDevices)) {
                    _this.vmEditSettingsDatastoreRecommendationService.getRecommendations(vmId, storageObject, virtualMachineDevices, originalVmConfig, vmConfigContextConfig, cpuFeatureMask, function (result) {
                        if (result) {
                            // send mutation request
                            var recommendationKeys = [result.recommendationSpec.key];
                            _this.vmHardwareEditService.applyRecommendationAndUpdate(vmId, recommendationKeys, operation);
                            _this.$scope.closeModal();
                        }
                    }, function (error) {
                        var errorMessage = "";
                        if (error && error.length > 0 && error[0].message) {
                            errorMessage = error[0].message;
                        }
                        else {
                            errorMessage = _this.i18nService.getString("VmUi", "SdrsRecommendations.faults.generic");
                        }
                        _this.$scope.$emit("editSettingsAlertMessageChanged", {
                            isVisible: true,
                            class: "alert-warning",
                            iconShape: "exclamation-triangle",
                            text: errorMessage
                        });
                    });
                }
                else {
                    _this.vmHardwareEditService.update(vmId, operation, originalVmConfig, vmConfigContextConfig, virtualMachineDevices, cpuFeatureMask, vmProfile);
                    _this.$scope.closeModal();
                }
            };
        };
        VmHardwareController.prototype.isVmHomeEncrypted = function () {
            // if the config context is not yet retrieved do not consider the VM encrypted
            if (_.isEmpty(this.vmConfigContext)) {
                return false;
            }
            return this.vmCryptUtilService
                .isVmHomeEncrypted(this.vmConfigContext);
        };
        VmHardwareController.prototype.setup = function (setupData, requestVmHost, updateVmHomeRg) {
            var _this = this;
            if (requestVmHost === void 0) { requestVmHost = false; }
            if (updateVmHomeRg === void 0) { updateVmHomeRg = true; }
            this.vmConfigContext = setupData.vmConfigContext;
            this.originalConfig = setupData.originalConfig;
            this.stackBlocksExpandedState = this.buildStackBlockExpandedStateForDevices(this.stackBlocksExpandedState, setupData.virtualMachineDevices);
            this.virtualMachineDevices = setupData.virtualMachineDevices;
            var existingVirtualDisks = this.virtualMachineDevices.existingDevicesOfType('VirtualDisk');
            this.isGroupingHardDisks = existingVirtualDisks && existingVirtualDisks.length > this.MAX_SOLO_HARD_DISK_COUNT;
            var totalHardDisksCount = existingVirtualDisks ? existingVirtualDisks.length : 0;
            this.totalHardDiskSizeText = this.i18nService.getString('VmUi', 'DiskPage.groupedMode.content', totalHardDisksCount, this.buildTotalHardDiskSizeText(existingVirtualDisks));
            if (setupData.storageProfiles) {
                this.storageProfiles = this.$q.when(setupData.storageProfiles);
            }
            else {
                var serverGuid = this.defaultUriSchemeUtil.getManagedObjectReference(this.vmId).serverGuid;
                this.storageProfiles = this.storageProfileService.fetchProfiles(serverGuid);
            }
            var vmAssignmentsProperties = {
                vmStorageProfileAssignments: setupData.vmStorageProfileAssignments,
                vmReplicationGroupAssignments: setupData.vmReplicationGroupAssignments,
                host: setupData.host
            };
            this.vmAssignmentsProperties = this.$q.when(vmAssignmentsProperties);
            if (this.vmId) {
                var propsToRetrieve = [];
                if (!vmAssignmentsProperties.vmStorageProfileAssignments) {
                    propsToRetrieve.push(this.VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY);
                }
                if (!vmAssignmentsProperties.vmReplicationGroupAssignments) {
                    propsToRetrieve.push(this.VM_REPLICATION_GROUP_ASSIGNMENTS_PROPERTY);
                }
                if (requestVmHost && !vmAssignmentsProperties.host) {
                    propsToRetrieve.push(this.VM_HOST_PROPERTY);
                }
                if (propsToRetrieve.length) {
                    this.vmAssignmentsProperties = this.dataService.getProperties(this.vmId, propsToRetrieve, 
                    // Suppress error notification ({skipErrorInterceptor:true})
                    // as this is likely to fail if user has no privileges.
                    // Also prevent the combined promise of being rejected
                    // since vm storage profiles are not required for the
                    // edit settings dialog to initialize.
                    { skipErrorInterceptor: true })
                        .then(function (response) {
                        if (!response) {
                            return vmAssignmentsProperties;
                        }
                        return {
                            vmStorageProfileAssignments: response[_this.VM_STORAGE_PROFILE_ASSIGNMENTS_PROPERTY] ||
                                vmAssignmentsProperties.vmStorageProfileAssignments,
                            vmReplicationGroupAssignments: response[_this.VM_REPLICATION_GROUP_ASSIGNMENTS_PROPERTY] ||
                                vmAssignmentsProperties.vmReplicationGroupAssignments,
                            host: response[_this.VM_HOST_PROPERTY] || vmAssignmentsProperties.host
                        };
                    })
                        .catch(function () {
                    });
                }
            }
            if (setupData.vmVersion) {
                this.vmVersion = setupData.vmVersion;
            }
            if (setupData.selectedStorageProfile) {
                this.selectedStorageProfile = setupData.selectedStorageProfile;
                this.vmConfigContext.vmProfile = [this.selectedStorageProfile];
            }
            this.getAdvancedConfigurationForDisk = function (virtualDisk) {
                return _this.getAdvancedConfigurationForDiskInternal(virtualDisk);
            };
            if (setupData.selectedReplicationGroupInfo) {
                this.selectedReplicationGroupInfo = setupData.selectedReplicationGroupInfo;
                if (updateVmHomeRg) {
                    this.vmHomeReplicationGroup = this.selectedReplicationGroupInfo;
                }
            }
            this.selectedGuestOs = setupData.guestOs;
            this.filterNetworksObjId = setupData.filterNetworksObjId;
            this.virtualControllers = this.virtualMachineDevices
                .existingDevicesOfType(DeviceTypeConstants.VIRTUAL_CONTROLLER);
            this.virtualScsiControllers = this.virtualMachineDevices
                .existingDevicesOfType(DeviceTypeConstants.SCSICONTROLLER);
            this.inputDevices = this.virtualMachineDevices
                .existingDevicesOfType(DeviceTypeConstants.INPUT_DEVICE);
            this.virtualEthernetCard = this.virtualMachineDevices
                .existingDevicesOfType(DeviceTypeConstants.ETHERNET);
            this.pciEthernetCount = this.virtualEthernetCard.length;
            this.errorConfig = {
                valid: true,
                message: ""
            };
            this.networkProviderId = setupData.networkProviderId;
            this.availableNetworks = setupData.availableNetworks;
            this.shouldAllowAddTpmAction().then(function (result) {
                if (result) {
                    _this.updateActionDefsForAddDeviceMenu();
                }
                else {
                    _this.updateActionDefsForAddDeviceMenu(['addNewTpmAction']);
                }
            });
            this.controllerOptions = this.vmHardwareUtil.getDeviceOption(this.vmConfigContext, this.PCI_CONTROLLER_TYPE);
            if (this.controllerOptions) {
                this.maxEthernetCards = this.controllerOptions.numEthernetCards.max;
                this.maxPCIPassthrough = this.controllerOptions.numPCIPassthroughDevices.max;
                this.maxPciDevicesControllers = this.controllerOptions.devices.max;
            }
            this.nvmeDeviceOption = this.vmHardwareUtil.getDeviceOption(this.vmConfigContext, this.NVME_CONTROLLER_TYPE);
            this.vmConfig = new h5_vm.VmConfig(this.vmConfigContext, this.selectedGuestOs, this.vmConfigContext.privileges, this.vmWorkflowMode, this.i18nService, this.removeDevice);
            this.vmConfig.showMsg = this.showInfo.bind(this);
            this.$scope.hardwareConfigData.vm = this.vmConfig;
            // propogate the selectedGuestOs information into a common object so vmOptions can use too
            this.$scope.hardwareConfigData.vmConfigContext.selectedGuestOs = this.selectedGuestOs;
            this.$scope.config.loading = false;
        };
        VmHardwareController.prototype.buildTotalHardDiskSizeText = function (allDisks) {
            var _this = this;
            if (!allDisks || allDisks.length <= 0) {
                return '';
            }
            var totalSizeText = '', resultSizeInMB = 0;
            _.each(allDisks, function (disk) {
                //bring all to the common unit: MB and ADD
                resultSizeInMB += _this.virtualDiskSettingsFormService.getCapacityInMB(disk.getCurrentDevice()); //MB
            });
            var displayDiskSize = this.basicDiskUtilService.determineDisplayDiskSize(resultSizeInMB);
            return this.basicDiskUtilService.roundToPrecision(displayDiskSize.size, 2).toString() +
                ' ' + displayDiskSize.unitText;
        };
        VmHardwareController.prototype.shouldAllowAddTpmAction = function () {
            var _this = this;
            return this.tpmProvisioningService.checkDefaultKmsServer(this.getServerGuid()).then(function (result) {
                var isPrivilegeEnabled = _this.vmHardwareUtil.checkPrivileges(_this.vmConfigContext.privileges, [
                    Privileges.CRYPTOGRAPHER_ENCRYPT,
                    Privileges.CRYPTOGRAPHER_ENCRYPT_NEW_VM
                ]);
                if (!result || !result.defaultKmsClusterExists || !isPrivilegeEnabled) {
                    return _this.$q.when(false);
                }
                else {
                    // A VM can only have one tpm device at most.
                    var maxTpmDevices = 1;
                    var numTPMDevices = _this.virtualMachineDevices.devicesOfType('VirtualTPM').length;
                    if (numTPMDevices < maxTpmDevices) {
                        var selectedGuestOsFirmware = _this.selectedGuestOs ? _this.selectedGuestOs.recommendedFirmware : undefined;
                        var doesGosSupportTPM = _this.selectedGuestOs ? !!_this.selectedGuestOs.supportsTPM20 : false;
                        var firmware = _this.vmConfigContext.config.firmware ? _this.vmConfigContext.config.firmware :
                            selectedGuestOsFirmware;
                        var isFirmwareBios = firmware === "bios";
                        var shouldAllow = !isFirmwareBios && doesGosSupportTPM;
                        return _this.$q.when(shouldAllow);
                    }
                    return _this.$q.when(false);
                }
            });
        };
        VmHardwareController.prototype.getPropertyRelations = function () {
            return _.reduce(this.vmConfigContext.environment.configOption.propertyRelations, function (map, obj) {
                map[obj.key.name] = obj.relations;
                return map;
            }, {});
        };
        VmHardwareController.prototype.getVbsProperties = function (vbsEnabled) {
            return _.reduce(this.getPropertyRelations()[vbsEnabled], function (map, obj) {
                map[obj.name] = obj.val;
                return map;
            }, {});
        };
        VmHardwareController.prototype.hideAddDevicesMenu = function (e) {
            if (this.addDevicesMenuConfig.showMenu && this.isItAddNewDeviceElement(e.toElement)) {
                this.addDevicesMenuConfig.showMenu = false;
            }
        };
        VmHardwareController.prototype.isItAddNewDeviceElement = function (elem) {
            return elem.innerText.toUpperCase().trim() !== this.i18nService.getString("VmUi", "VmDeviceManager.AddNewDevice").toUpperCase();
        };
        VmHardwareController.prototype.populateAdditionalParametersForNvdimm = function (additionalParameters) {
            if (this.vmWorkflowMode === VmWorkflowMode.UpdateMode) {
                additionalParameters.vm = {
                    powerState: this.vmConfigContext.rtInfo.powerState
                };
            }
            additionalParameters.vmWorkflow = this.vmWorkflowMode;
            additionalParameters.storageProfiles = this.storageProfiles;
        };
        VmHardwareController.prototype.getAdvancedConfigurationForDiskInternal = function (virtualDisk) {
            if (!this.$scope.vmParams.getIsAdvancedStorageMode()) {
                return undefined;
            }
            var advancedDiskConfigurations = this.$scope.vmParams
                .getStorageSelectorState().vmStorageConfigInAdvancedMode[0].vmDisks;
            return _.find(advancedDiskConfigurations, function (advancedDiskConfig) {
                return advancedDiskConfig.key === virtualDisk.getKey();
            });
        };
        VmHardwareController.prototype.showNewNvidmmMenu = function () {
            var vmConfigEnv = this.vmConfigContext.environment;
            var additionalParams = {};
            this.populateAdditionalParametersForNvdimm(additionalParams);
            return this.nvdimmProvisioningService.canAddNvdimm(vmConfigEnv, this.getGuestOsDescriptor(), this.virtualMachineDevices, additionalParams);
        };
        VmHardwareController.prototype.buildStackBlockExpandedStateForDevices = function (expandedState, virtualDevices) {
            _.each(virtualDevices.getAllDevicesNotMarkedForRemoval(), function (virtualDevice) {
                var devKey = virtualDevice.getKey();
                if (_.isUndefined(expandedState.virtualDevices[devKey])) {
                    expandedState.virtualDevices[devKey] = false;
                }
            });
            return expandedState;
        };
        VmHardwareController.prototype.getSortedVirtualDisks = function () {
            return this.virtualMachineDevices.existingSortedDevicesOfType('VirtualDisk');
        };
        VmHardwareController.prototype.getVmHomeRg = function (array) {
            if (!array) {
                return null;
            }
            var vmRef = this.defaultUriSchemeUtil.getManagedObjectReference(this.vmId);
            var result = null;
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                if (item && (item.vmObjectId === vmRef.value)) {
                    result = item.replicationGroup;
                }
            }
            return result;
        };
        VmHardwareController.prototype.getSerialPortDeviceList = function () {
            var retVal = this.getExistingAndNewDevices('VirtualSerialPort');
            for (var _i = 0, retVal_1 = retVal; _i < retVal_1.length; _i++) {
                var item = retVal_1[_i];
                item.attachVmConfig(this.vmConfig);
            }
            return retVal;
        };
        VmHardwareController.$inject = [
            "$scope",
            "$document",
            "creationTypeConstants",
            "cpuService",
            "guestOsService",
            "vmDeviceInfoService",
            "vmHardwareUtil",
            "vmHardwareEditService",
            "vmDeviceManagementService",
            "i18nService",
            "defaultUriSchemeUtil",
            "vmEditSettingsDatastoreRecommendationService",
            "storageProfileService",
            "dataService",
            "$q",
            "vmHardwareDeviceMenuService",
            "nvdimmProvisioningService",
            "vmCryptUtilService",
            "tpmProvisioningService",
            "virtualDiskSettingsFormService",
            "basicDiskUtilService"
        ];
        return VmHardwareController;
    }());
    angular
        .module("com.vmware.vsphere.client.vm")
        .controller("VmHardwareController", VmHardwareController);
})(h5_vm || (h5_vm = {}));



var vm_ui;
(function (vm_ui) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareControllerAndNodeService = (function () {
        function VmHardwareControllerAndNodeService(vmHardwareUtil) {
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareControllerAndNodeService.prototype.isEditVmHardwareControllerAndNodeDisabled = function (inflatedDevice, privileges, powerState) {
            // in some cases in clone workflow initially scope.inflatedDevice is
            // undefined, so preventing NPE here
            if (!inflatedDevice) {
                return true;
            }
            if (inflatedDevice.isNew()) {
                return false;
            }
            if (!this.vmHardwareUtil.isVmPoweredOff(powerState) || !this.hasPrivilegesToEdit(privileges)) {
                return true;
            }
            return false;
        };
        VmHardwareControllerAndNodeService.prototype.hasPrivilegesToEdit = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareControllerAndNodeService.$inject = [
            "vmHardwareUtil"
        ];
        return VmHardwareControllerAndNodeService;
    }());
    vm_ui.VmHardwareControllerAndNodeService = VmHardwareControllerAndNodeService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareControllerAndNodeService", VmHardwareControllerAndNodeService);
})(vm_ui || (vm_ui = {}));



angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareControllerAndNode', [
   'i18nService',
   'informationalDialogService',
   'controllerNodeFinderService',
   'vmDeviceInfoService',
   'vmHardwareControllerAndNodeService',
   function(
      i18nService,
      informationalDialogService,
      controllerNodeFinderService,
      vmDeviceInfoService,
      vmHardwareControllerAndNodeService
   ) {
      return {
         templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareControllerAndNode/vmHardwareControllerAndNode.html',
         scope: {
            inflatedDevice: '=',
            node: '=',
            powerState: '=',
            availableControllers: '=',
            virtualMachineDevices: '=',
            selectorName: '=',
            controllerSelectorName: '=',
            deviceController: '=',
            privileges: '=',
            onControllerChangeCallback: '&'
         },
         link: function(scope) {
            scope.i18n = i18nService.getString;
            init_aria(scope);

            var oldNode;
            scope.$watch('virtualMachineDevices.getDeviceChanges()', function () {
               if (scope.deviceController) {
                  updateNodeOptions();
               }
            }, true);

            // in clone workflow when you expand some stackblock that has device
            // node and go back, and then forth - when the Device node block is
            // being initialized the "scope.deviceController" is not set when
            // link function of the directive is called and as a result the device
            // nodes are not loaded, in order to avoid this adding listener for
            // deviceController change to update the node options later
            // this does not affect Edit settings workflow
            scope.$watch(function () {
               return scope.deviceController;
            }, function (newValue, oldValue) {
               if (newValue && newValue !== oldValue) {
                  updateNodeOptions();
               }
            });

            function updateNodeOptions() {
               scope.nodeOptions = buildNodeOptionsWithLabelsForOccupiedNodes();
               scope.node = _.find(scope.nodeOptions, function(option) {
                  return option.key === scope.inflatedDevice.getCurrentDevice().unitNumber;
               });
               oldNode = scope.node;
            }

            function buildNodeOptionsWithLabelsForOccupiedNodes() {
               var controllerNodes = buildControllerNodes(scope.deviceController, scope.inflatedDevice);

               var connectedDevices = scope.virtualMachineDevices.getDevicesAttachedToControllerKey(
                  scope.deviceController.getKey()
               );

               return _.map(controllerNodes, function(node) {
                  var deviceForNode = _.find(connectedDevices, function(device) {
                     return node.key === device.unitNumber;
                  });

                  if (deviceForNode) {
                     node.name += ' ' + deviceForNode.deviceInfo.label;
                  }

                  return node;
               });
            }

            var oldController = scope.deviceController; // in case we need to revert the selection
            scope.onControllerChange = function(newController) {
               var availableControllerNodes = buildControllerNodes(scope.deviceController, scope.inflatedDevice);

               var devicesWithNodes = scope.virtualMachineDevices.getDevicesThatHaveBeenAssignedToNodes();

               var nextAvailableNode = controllerNodeFinderService.findNextAvailableNodeForController(
                  newController.getKey(),
                  availableControllerNodes,
                  devicesWithNodes
               );

               if (nextAvailableNode) {
                  var deviceSpec = scope.inflatedDevice.getCurrentDeviceSpec();
                  deviceSpec.device.unitNumber = nextAvailableNode.key;
                  deviceSpec.device.controllerKey = newController.getKey();
                  oldController = newController;

                  updateNodeOptions();

                  if (scope.onControllerChangeCallback) {
                     scope.onControllerChangeCallback({
                        deviceController: scope.deviceController,
                        node: scope.node
                     });
                  }
               } else {
                  scope.deviceController = oldController;
                  var controllerName = newController.getCurrentDevice().deviceInfo.label;
                  informationalDialogService.display({
                     title: controllerName,
                     content: i18nService.getString('VmUi', 'GenericDevicePage.ControllerTaken', controllerName),
                     width: '300px',
                     height: '150px'
                  });
               }
            };

            scope.onControllerNodeChange = function(newNode) {
               if (newNode.key === oldNode.key) {
                  return;
               }

               var nodeIsInUse = scope.virtualMachineDevices.isNodeInUse(scope.deviceController.getKey(), newNode.key);

               if (nodeIsInUse) {
                  informationalDialogService.display({
                     title: [newNode.name, scope.inflatedDevice.getCurrentDevice().deviceInfo.label].join(' '),
                     content: i18nService.getString('VmUi', 'GenericDevicePage.NodeTaken'),
                     width: '300px',
                     height: '150px'
                  });
                  scope.node = oldNode;
               } else {
                  oldNode = newNode;
                  scope.inflatedDevice.getCurrentDevice().unitNumber = newNode.key;

                  if (scope.onControllerChangeCallback) {
                     scope.onControllerChangeCallback({
                        deviceController: scope.deviceController,
                        node: scope.node
                     });
                  }
               }
            };

            scope.disableSelection = function() {
               return vmHardwareControllerAndNodeService.isEditVmHardwareControllerAndNodeDisabled(scope.inflatedDevice, scope.privileges, scope.powerState);
            };
         }
      };

      function buildControllerNodes(controller, device) {
         var rawController = controller.getCurrentDevice();

         var controllerNodeIndices;
         if (device.isOfType('VirtualCdrom')) {
            controllerNodeIndices = controller.getCdromNodeIndices();
         } else if (device.isOfType('VirtualDisk')) {
            controllerNodeIndices = controller.getDiskNodeIndices();
         } else {
            throw new Error("Don't know how to determine controller nodes for device" + device.getCurrentDevice());
         }

         return _.map(controllerNodeIndices, function(index) {
            return {
               name: vmDeviceInfoService.getControllerAndNodeLabelText(rawController._type, rawController.busNumber, index),
               key: index
            };
         });
      }

      function init_aria(scope) {
         var i18n = function(key) {
            return i18nService.getString("VmUi", 'DiskPage.' + key);
         };
         scope.ARIA_LBL_CTRL = i18n("Controller");
         scope.ARIA_LBL_NODE = i18n("Node");
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var CpuMmuViewController = (function () {
        function CpuMmuViewController(cpuMmuService) {
            var _this = this;
            this.cpuMmuService = cpuMmuService;
            this.onChange = function () {
                _this.onCpuMmuChange({ selectedOption: _this.selectedOption });
            };
            this.isCpuMmuDisabled = function () {
                return _this.cpuMmuService.isCpuMmuDisabled(_this.vmConfigContext, _this.createMode);
            };
            this.cpuMmuOptions = cpuMmuService.getCpuMmuOptions();
            this.selectedOption = cpuMmuService.getCpuMmuCurrentSelection(cpuMmuService.getCpuMmuCurrentConfig(this.vmConfigContext));
        }
        CpuMmuViewController.$inject = [
            "cpuMmuOptionService"
        ];
        return CpuMmuViewController;
    }());
    h5_vm.CpuMmuViewController = CpuMmuViewController;
    var CpuMmuViewComponent = (function () {
        function CpuMmuViewComponent() {
            this.controller = CpuMmuViewController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/" +
                "vmHardwareCpu/cpuMmu/cpu-mmu-view.html";
            this.bindings = {
                vmConfigContext: "<",
                onCpuMmuChange: "&",
                createMode: "<",
                ariaLabel: "<?"
            };
        }
        return CpuMmuViewComponent;
    }());
    h5_vm.CpuMmuViewComponent = CpuMmuViewComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("cpuMmuView", new CpuMmuViewComponent());
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm')
   .directive('vmHardwareCpu',
      [
         'templateHelperService',
         'i18nService',
         'cpuService',
         'vmHardwareCpuService',
         'vmHardwareUtil',
         'guestOsService',
         'helpService',
         '$injector',
         function (
            templateHelperService,
            i18nService,
            cpuService,
            vmHardwareCpuService,
            vmHardwareUtil,
            guestOsService,
            helpService,
            $injector) {
            return {
               templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/vmHardwareCpu.html',
               scope: {
                  createMode: "=",
                  deployVmtxMode: "=",
                  vmWorkflowMode: "=",
                  originalConfig: "=",
                  vm: "<",
                  vmConfigContext: "=",
                  vbsEnabled: "=",
                  expanded: "="
               },
               link: {
                  pre: function(scope) {
                     var initailizationStepDone = false;
                     var initailizationShares;

                     init();

                     scope.$watch('vmConfigContext.config.cpuAllocation.limit', function(limit) {
                        scope.reservationMax = (limit === -1) ? vmHardwareCpuService.getMaxReservation(scope.vmConfigContext) : limit;
                        setUpReservationErrorMessages();
                        scope.reservationRecommendations = [
                           {
                              name: scope.i18n('VmUi', 'VmCpu.Reservation.Current'),
                              value: scope.originalConfig.cpuAllocation.reservation
                           },
                           {name: scope.i18n('VmUi', 'VmCpu.Reservation.Minimum'), value: 0},
                           {name: scope.i18n('VmUi', 'VmCpu.Reservation.Maximum'), value: scope.reservationMax}
                        ];
                        vmHardwareCpuService.formatRecommendations(scope.reservationRecommendations);
                     });

                     scope.$watch('vmConfigContext.config.cpuAllocation.reservation', function(reservation) {
                        scope.limitRecommendations = [
                           {
                              name: scope.i18n('VmUi', 'VmCpu.Limit.Current'),
                              value: scope.originalConfig.cpuAllocation.limit
                           },
                           {name: scope.i18n('VmUi', 'VmCpu.Limit.Minimum'), value: reservation},
                           {name: scope.i18n('VmUi', 'VmCpu.Limit.Maximum'), value: -1}
                        ];
                        vmHardwareCpuService.formatRecommendations(scope.limitRecommendations);
                     });

                     scope.$watch('vmConfigContext.config.hardware.numCPU', function(numCPU) {
                        var guestOs = guestOsService.getGuestOsDescriptor(scope.vmConfigContext, {
                           id: scope.vmConfigContext.config.guestId
                        });
                        scope.coresPerSocketOptions = vmHardwareCpuService.buildSupportedCoresPerSocket(scope.vmConfigContext, scope.originalConfig, guestOs);

                        var numCoresPerSocket = scope.vmConfigContext.config.hardware.numCoresPerSocket;
                        if (scope.coresPerSocketOptions.indexOf(numCoresPerSocket) < 0) {
                           scope.vmConfigContext.config.hardware.numCoresPerSocket =
                              scope.coresPerSocketOptions[0];
                        }

                        var numCpu = scope.vmConfigContext.config.hardware.numCPU;
                        if (numCpu) {
                           scope.sharesValueMap = {
                              low: 500 * numCpu,
                              normal: 1000 * numCpu,
                              high: 2000 * numCpu
                           };
                           var level = scope.sharesInfo.level;
                           if (level !== 'custom') {
                              if (!initailizationStepDone) {
                                 initailizationShares = scope.sharesValueMap[level];
                              }

                              initailizationStepDone = true;
                              scope.sharesInfo.shares = scope.sharesValueMap[level];
                           }
                        }
                     });

                     scope.isEditNumCpuEnabled = function() {
                        var ctx = this.vmConfigContext;
                        var guest = guestOsService.getAppropriateGuestOs(ctx, { id: ctx.config.guestId });
                        var powerState = ctx.environment.powerState;
                        var retVal = vmHardwareCpuService.isNumCpuEnabled(powerState, ctx.config, this.isFtVm, guest, ctx.privileges, scope.createMode);
                        return retVal;
                     };

                     scope.isEditCoresPerSocketEnabled = function() {
                        if (!scope.createMode) {
                           var ctx = this.vmConfigContext;
                           var powerState = ctx.environment.powerState;

                           if (this.isVmInPoweredOnState(powerState)) {
                              return false;
                           }

                           if (this.isVmInSuspendedState(powerState)) {
                              return false;
                           }
                        }

                        return this.isEditNumCpuEnabled();
                     };

                     scope.isEditReservationEnabled = function() {
                        return vmHardwareCpuService.isReservationEnabled(this.vmConfigContext, scope.createMode);
                     };

                     scope.isEditLimitEnabled = function() {
                        return vmHardwareCpuService.isLimitEnabled(this.vmConfigContext, scope.createMode);
                     };

                     scope.isEditSharesEnabled = function() {
                        return vmHardwareCpuService.isSharesEnabled(this.vmConfigContext, scope.createMode);
                     };

                     scope.isEditCpuIdEnabled = function() {
                        return vmHardwareCpuService.isCpuIdEnabled(this.vmConfigContext, scope.createMode);
                     };

                     scope.isEditNestedHVEnabled = function() {
                        return vmHardwareCpuService.isNestedHVEnabled(this.vmConfigContext, scope.createMode);
                     };
                     scope.isEditCpuMmuEnabled = function() {
                        return vmHardwareCpuService.isCpuMmuEnabled(this.vmConfigContext, scope.createMode);
                     };

                     scope.isCpuHotPlugEnabled = function() {
                        return vmHardwareCpuService.isCpuHotPlugEnabled(
                           this.vmConfigContext.environment.powerState,
                           (this.vmConfigContext.rtInfo ? this.vmConfigContext.rtInfo.faultToleranceState : null),
                           this.vmConfigContext.config.ftInfo,
                           guestOsService.getAppropriateGuestOs(this.vmConfigContext, { id: this.vmConfigContext.config.guestId }),
                           this.vmConfigContext.privileges,
                           scope.createMode);
                     };

                     scope.cpuHotPlug = function(cpuHotAddEnabled) {
                        if (angular.isDefined(cpuHotAddEnabled)) {
                           this.vmConfigContext.config.cpuHotAddEnabled = cpuHotAddEnabled;
                        }
                        return isCpuHotPlugChecked.call(this);
                     };

                     var isCpuHotPlugChecked = function() {
                        var guestOs = guestOsService.getAppropriateGuestOs(this.vmConfigContext, { id: this.vmConfigContext.config.guestId });
                        var gOsCpuHotAddEnabled = (guestOs ? guestOs.supportsCpuHotAdd : false);
                        return this.vmConfigContext.config.cpuHotAddEnabled && gOsCpuHotAddEnabled;
                     };

                      scope.hasError = function() {
                         if(!_.isEmpty(scope.vmHardwareCpuForm)){
                            return scope.vmHardwareCpuForm.$invalid;
                         }
                         return false;
                      };


                     scope.hasChanged = function() {
                        var level = scope.sharesInfo.level;

                        var isChanged = scope.vmConfigContext.config.hardware.numCPU !== scope.originalConfig.hardware.numCPU;
                        isChanged = isChanged || scope.originalConfig.cpuAllocation.reservation !== scope.vmConfigContext.config.cpuAllocation.reservation;
                        isChanged = isChanged || scope.originalConfig.cpuAllocation.limit !== scope.vmConfigContext.config.cpuAllocation.limit;
                        isChanged = isChanged || scope.vmConfigContext.config.cpuHotAddEnabled !== scope.originalConfig.cpuHotAddEnabled;
                        isChanged = isChanged || scope.vmConfigContext.config.flags.virtualExecUsage !== scope.originalConfig.flags.virtualExecUsage;
                        isChanged = isChanged || scope.vmConfigContext.config.flags.virtualMmuUsage !== scope.originalConfig.flags.virtualMmuUsage;

                        if (level !== 'custom') {
                           isChanged = isChanged ||
                              scope.sharesInfo.shares !== initailizationShares;
                        } else {
                           isChanged = isChanged ||
                              scope.sharesInfo.shares !== scope.originalConfig.cpuAllocation.shares.shares;
                        }

                        return isChanged;
                     };

                     scope.isVmInPoweredOnState = function(powerState) {
                        return vmHardwareUtil.isVmPoweredOn(powerState);
                     };

                     scope.isVmInSuspendedState = function(powerState) {
                        return vmHardwareUtil.isVmSuspended(powerState);
                     };

                     scope.isEnablePerfCountersIsDisabled = function() {
                        var hasVMConfigSettingsPrivileges =
                           _.contains(scope.vmConfigContext.privileges, 'VirtualMachine.Config.Settings');
                        return scope.vmConfigContext.environment.powerState !== 'poweredOff' ||
                              !scope.vmConfigContext.environment.configOption.capabilities.vPMCSupported ||
                              !scope.vmConfigContext.environment.hostCapability.vPMCSupported ||
                              !hasVMConfigSettingsPrivileges;
                     };

                     scope.onAdvancedCpuIdMaskSubmit = function(response) {
                        var maskFlag = response.flagState;
                        var advanced = maskFlag === "advanced" ? true : false;
                        scope.cpuIdMaskSettings = cpuService.getCpuIdMaskSettingOptions(advanced);
                        scope.cpuIdMaskSelectedSetting = cpuService.getCpuIdMaskFlagSelection(maskFlag);
                        scope.vmConfigContext.config.cpuFeatureMask = response.cpuIdMask;
                     };

                     scope.onCpuIdMaskAdvanced = function() {
                        var advancedCpuIdMaskService = $injector.get('vscAdvancedCpuIdMaskModalService');
                        advancedCpuIdMaskService.showAdvancedCpuIdMaskModal(scope.vmConfigContext, scope.onAdvancedCpuIdMaskSubmit.bind(this));
                     };

                     scope.onCpuIdMaskChange = function() {
                        if (scope.cpuIdMaskSelectedSetting === scope.cpuIdMaskSelectedSettingOld) {
                           return;
                        }
                        scope.cpuIdMaskSelectedSettingOld = scope.cpuIdMaskSelectedSetting;
                        cpuService.updateCpuIdMaskSetting(scope.cpuIdMaskSelectedSetting, scope.vmConfigContext);
                        scope.cpuIdMaskSelectedSetting = cpuService.getCpuIdMaskSettingForVm(scope.vmConfigContext);
                        //if user has changed this - advanced option cannot reappear. So remove it.
                        scope.cpuIdMaskSettings = cpuService.getCpuIdMaskSettingOptions();
                     };

                     scope.onCpuMmuChange = function(selectedOption) {
                        scope.vmConfigContext.config.flags.virtualExecUsage = selectedOption._cpuUsage;
                        scope.vmConfigContext.config.flags.virtualMmuUsage  = selectedOption._mmuUsage;
                     };

                     scope.isSchedulingAffinityShown = function() {
                        return vmHardwareCpuService.isSchedulingAffinityShown(scope.vmConfigContext);
                     };

                     scope.isHVDisabled = function () {
                        if (!scope.isEditNestedHVEnabled()) {
                           return true;
                        }

                        return scope.vbsEnabled || !scope.createMode &&
                           scope.isVmInPoweredOnState(scope.vmConfigContext.environment.powerState);
                     };

                     scope.isSchedulingAffinityEnabled = function() {
                        return vmHardwareCpuService.isSchedulingAffinityEnabled(scope.vmConfigContext, scope.createMode);
                     };
                     scope.onIOMmuChange = function (configFlags) {
                        scope.vmConfigContext.config.flags.vvtdEnabled = configFlags.vvtdEnabled;
                     };

                     scope.isMultipleCoresPerSocketSupported = function() {
                        return scope.vmConfigContext.environment.configOption
                           .capabilities.multipleCoresPerSocketSupported;
                     };

                     function setUpReservationErrorMessages() {
                        scope.reservationErrorMessages = {
                           max: function() {
                              return scope.i18n('VmUi', 'Util.Validation.ValidRange',
                                 scope.i18n('VmUi', 'VmCpu.Label.Reservation'),
                                 scope.i18n('VmUi', 'cpuReservationLimit', 0),
                                 scope.i18n('VmUi', 'cpuReservationLimit', scope.reservationMax)
                              );
                           }
                        };
                     }

                     function setUpReservationAndLimitUnitOptions() {
                        var mhzLabel = scope.i18n('VmUi', 'VmCpu.MHz');
                        var ghzLabel = scope.i18n('VmUi', 'VmCpu.GHz');
                        scope.reservationUnitOptions = [
                           {label: mhzLabel, multiplier: 1},
                           {label: ghzLabel, multiplier: 1000}
                        ];
                        scope.limitUnitOptions = [
                           {label: mhzLabel, multiplier: 1},
                           {label: ghzLabel, multiplier: 1000}
                        ];
                     }

                     function setUpSharesInfo() {
                        scope.sharesInfo = vmHardwareCpuService.setUpSharesInfo(scope.vmConfigContext, scope.createMode);
                     }

                     function setFieldValues(scope) {
                        var data = scope.vmConfigContext.config;
                        var cpuHotPlug = scope.i18n('VmUi', 'VmCpu.Label.CpuHotPlug');
                        var cpuAffinity = vmHardwareCpuService.getAffinityDisplayValue(
                              data.cpuAffinity ? data.cpuAffinity.affinitySet : []);
                        var cpuIdMask = vmHardwareCpuService.isCpuIdMaskExposed(scope.vmConfigContext) ?
                           scope.i18n('VmUi', 'CpuIdMask.exposed') :
                           scope.i18n('VmUi', 'CpuIdMask.hidden');

                        scope.fieldValue = {
                           NestedHV: vmHardwareCpuService.formatEnabledDisabled(data.hardwareVirtualization),
                           PerfCounters: vmHardwareCpuService.formatEnabledDisabled(data.performanceCounters),
                           CpuHotPlug: cpuHotPlug,
                           CpuAffinity: cpuAffinity,
                           CpuIdMask: cpuIdMask
                        };
                     }

                     function setSignPosts(scope, changeSignPost) {
                        var cpuMmuVirtTemplate = changeSignPost ?
                           'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuMmuVirtualization6.7HostVm13HelpText.html'
                           : 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuMmuVirtualizationHelpText.html';
                        templateHelperService.renderTemplateWithScope(cpuMmuVirtTemplate, scope).then(function(content) {
                           scope.cpuMmuVirtSignPostParams = {
                              message: content,
                              title: i18nService.getString('Common', 'help'),
                              class: 'cpu-mmu-help-text'
                           };
                        });

                        var nestedHVTemplate = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/nestedHVHelpText.html';
                        templateHelperService.renderTemplateWithScope(nestedHVTemplate, scope).then(function(content) {
                           scope.nestedHVSignPostParams = {
                              message: content,
                              title: i18nService.getString('Common', 'help'),
                              class: 'nested-hv-help-text'
                           };
                        });

                        var cpuAffinityTemplate = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuAffinityHelpText.html';
                        templateHelperService.renderTemplateWithScope(cpuAffinityTemplate,
                           vmHardwareCpuService.getCpuAffinitySignpostContext(scope.vmConfigContext))
                           .then(function(content) {
                              scope.cpuAffinitySignPostParams = {
                                 message: content,
                                 title: i18nService.getString('Common', 'help'),
                                 height: '250px'
                              };
                           });

                        function setupCpuGeneralHelpSignPost(url) {
                           var cpuGeneralHelpTemplate = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareCpu/cpuGeneralHelpText.html';
                           templateHelperService.renderTemplateWithScope(cpuGeneralHelpTemplate, _.extend(scope, {cpuGeneralHelpUrl: url}))
                              .then(function(content) {
                                 scope.cpuGeneralHelpSignPostParams = {
                                    message: content,
                                    title: i18nService.getString('Common', 'help')
                                 };
                              });
                        }

                        var CPU_HELP_ID = 'com.vmware.vsphere.vm_admin.doc.vc_153';
                        helpService.getHelpPageUrl(CPU_HELP_ID)
                           .then(function(url) {
                              setupCpuGeneralHelpSignPost(url);
                           });
                     }
                     function init_aria() {
                        scope.RSRV_UNIT_ARIA_LBL =
                        scope.RSRV_QUANTITY_CARET_ARIA_LBL =
                        scope.RSRV_QUANTITY_ARIA_LBL = scope.fieldLabel('Reservation');

                        scope.LIMIT_UNIT_ARIA_LBL =
                        scope.LIMIT_QUANTITY_CARET_ARIA_LBL =
                        scope.LIMIT_QUANTITY_ARIA_LBL = scope.fieldLabel('Limit');

                        scope.SHARES_ARIA_LBL =
                        scope.SHARES_CARET_ARIA_LBL =
                        scope.SHARES_QNT_ARIA_LBL = scope.fieldLabel('Shares');
                        scope.IOMMU_ARIA_LBL = scope.fieldLabel('ioMmuVirtualization');
                        scope.INFO_PNG = scope.i18n('CommonImages', 'info');
                        scope.LBL_VVTD_ENABLED = scope.i18n('VmUi', 'enabled');
                     }

                     function init() {
                        scope.i18n = i18nService.getString;

                        scope.fieldLabel = function(field) {
                           return scope.i18n('VmUi', 'VmCpu.Label.' + field);
                        };
                        init_aria();
                        scope.validationError = {message: "", isVisible: true};
                        scope.isFtVm = vmHardwareUtil.isFtVmConfigContext(scope.vmConfigContext);
                        var changeSignPost = false;
                        var vmCapabilities = scope.vmConfigContext.environment.configOption.capabilities;
                        scope.showCpuMmuVirtualization = !!(vmCapabilities.virtualMmuUsageIgnored &&
                        vmCapabilities.virtualExecUsageIgnored);
                        var hostCapabilities = scope.vmConfigContext.environment.hostCapability;

                        if(!!(hostCapabilities.virtualMmuUsageIgnored &&
                           hostCapabilities.virtualExecUsageIgnored) && !scope.showCpuMmuVirtualization) {
                           changeSignPost = true;
                        }

                        scope.sharesValueMap = {
                           low: 0,
                           normal: 0,
                           high: 0
                        };

                        setUpReservationAndLimitUnitOptions();
                        setUpReservationErrorMessages();
                        setUpCpuIdMaskSettings();
                        setFieldValues(scope);
                        setSignPosts(scope, changeSignPost);
                        setUpSharesInfo();

                        var guestOs = guestOsService.getGuestOsDescriptor(scope.vmConfigContext, {
                           id: scope.vmConfigContext.config.guestId
                        });
                        scope.numCpuOptions = vmHardwareCpuService.buildSupportedCpus(scope.vmConfigContext, guestOs, scope.createMode);
                        scope.validNumCpuOptions = angular.copy(scope.numCpuOptions);
                        if (scope.numCpuOptions.indexOf(scope.vmConfigContext.config.hardware.numCPU) < 0) {
                           scope.numCpuOptions.push(scope.vmConfigContext.config.hardware.numCPU);
                        }

                        scope.coresPerSocketOptions = vmHardwareCpuService.buildSupportedCoresPerSocket(scope.vmConfigContext, scope.originalConfig, guestOs);

                        scope.fields = _.keys(scope.fieldValue);

                        scope.ioMmuVirtualizationSupported = guestOs.vvtdSupported && guestOs.vvtdSupported.supported;

                        scope.disableVvtdCheckbox = function() {
                           var vm = scope.vm;
                           if (!vm) {
                              return false;
                           }

                           if (vm.isVvtdReadonly()) {
                              return true;
                           }
                           return false;
                        };

                        scope.showVvtdInfo = function() {
                           if (!scope.vvtdSignPostParams) {
                              scope.vvtdSignPostParams = {};
                           }
                           var params = scope.vvtdSignPostParams;
                           var vm = scope.vm;

                           if (!vm) {
                              return false;
                           }

                           if (vm.isVvtdRequired()) {
                              params.title = scope.i18n('Common', 'help');
                              params.message = vm.whyVvtdRequired();
                              return true;
                           }
                           return false;
                        };
                     }

                     function setUpCpuIdMaskSettings() {
                        var maskFlag = cpuService.determineCpuIdMaskFlag(scope.vmConfigContext);
                        var advanced = maskFlag === "advanced" ? true : false;
                        scope.cpuIdMaskSettings = cpuService.getCpuIdMaskSettingOptions(advanced);
                        scope.cpuIdMaskSelectedSetting = cpuService.getCpuIdMaskFlagSelection(maskFlag);
                        //save the original selection
                        scope.cpuIdMaskSelectedSettingOld = scope.cpuIdMaskSelectedSetting;
                     }

                     function setupCpuIdMaskSettings2() {
                        scope.cpuIdMaskSelectedSetting = cpuService.getCpuIdMaskSettingForVm(scope.vmConfigContext);
                        scope.cpuIdMaskSettings = cpuService.getCpuIdMaskSettingOptions();
                     }
                  },

                  post: function(scope) {
                     function validateCpuCount() {
                        var cpuCountError = {
                           message: scope.i18n("VmUi", "VmCpu.Error.InvalidCpuCount"),
                           isVisible: false
                        };
                        var selectedCpuCount = scope.vmConfigContext.config.hardware.numCPU;

                        var setEditCpuValidity = function(valid, message) {
                           var form = scope.vmHardwareCpuForm;
                           if (form) {
                              form.$setValidity("editCPU", valid);
                           }
                           cpuCountError.isVisible = !valid;
                           if (message) {
                              cpuCountError.message = message;
                           }
                        };


                        if (scope.validNumCpuOptions && scope.validNumCpuOptions.indexOf(selectedCpuCount) >= 0) {
                           setEditCpuValidity(true);
                        } else {
                           setEditCpuValidity(false);
                        }

                        if (scope.vm) {
                           if (scope.vm.isCpuHotplugError(scope.originalConfig)) {
                              setEditCpuValidity(false, scope.i18n("VmUi", "VmCpu.Hotplug128Error"));
                           }
                           if (scope.vm.isCpuFirmwareError()) {
                              setEditCpuValidity(false, scope.i18n("VmUi", "VmCpu.CpuFirmwareError"));
                           }
                        }
                        return cpuCountError;
                     }

                     function validateAffinity() {
                        var affinityError = {
                           message: scope.i18n('VmUi', 'CpuAffinityValidator.Error.BadAffinity'),
                           isVisible: false
                        };
                        var numCpus = scope.vmConfigContext.environment.configTarget.numCpus;
                        var affinity = scope.fieldValue.CpuAffinity;
                        var validated = vmHardwareCpuService.validateAffinity(affinity, numCpus);

                        if (!validated) {
                           affinityError.isVisible = true;
                           if (scope.vmHardwareCpuForm && scope.vmHardwareCpuForm.cpuAffinity) {
                              scope.vmHardwareCpuForm.cpuAffinity.$setValidity('badAffinityPattern', false);
                           }
                        } else {
                           if (scope.vmHardwareCpuForm && scope.vmHardwareCpuForm.cpuAffinity) {
                              scope.vmHardwareCpuForm.cpuAffinity.$setValidity('badAffinityPattern', true);
                           }
                        }

                        return affinityError;
                     }

                     scope.onCpuCountChange = function() {
                        scope.cpuCountError = validateCpuCount();
                        if (scope.vm) {
                           scope.vm.afterCpuChange();
                        }
                     };

                     scope.$watch('vmConfigContext.config.firmware', function(firmware) {
                        scope.cpuCountError = validateCpuCount();
                     });


                     scope.onAffinityChange = function() {
                        var affinityError = validateAffinity();
                        scope.affinityError = affinityError;

                        var isAffinityValid = !affinityError.isVisible;
                        if (isAffinityValid) {
                           scope.vmConfigContext.config.cpuAffinity.affinitySet =
                              vmHardwareCpuService.transformAffinity(scope.fieldValue.CpuAffinity);
                        }
                     };

                     scope.isAffinityInvalid = function() {
                        if (scope.vmHardwareCpuForm && scope.vmHardwareCpuForm.cpuAffinity) {
                           return scope.vmHardwareCpuForm.cpuAffinity.$dirty &&
                              scope.vmHardwareCpuForm.cpuAffinity.$error.badAffinityPattern;
                        }
                        return false;
                     };

                     scope.cpuCountError = validateCpuCount();
                     scope.affinityError = validateAffinity();
                  }
               }
            };
         }
      ]
   );

var VmConfigContext = com.vmware.vsphere.client.vm.config.VmConfigContext;
var ConfigInfo = com.vmware.vim.binding.vim.vm.ConfigInfo;
var GuestOsDescriptor = com.vmware.vim.binding.vim.vm.GuestOsDescriptor;
var SharesInfo = com.vmware.vim.binding.vim.SharesInfo;
var VmHardwareUtil = h5_vm.VmHardwareUtil;
var VmHardwareMemoryService = h5_vm.VmHardwareMemoryService;
var VmConfig = h5_vm.VmConfig;
angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareMemory', [
    'i18nService',
    'numberFormatterService',
    'scopeUtil',
    'bytesFilter',
    'vmHardwareUtil',
    'vmHardwareMemoryService',
    function (i18nService, numberFormatterService, scopeUtil, bytesFilter, vmHardwareUtil, vmHardwareMemoryService) {
        return {
            scope: {
                vm: '=',
                vmConfigContext: '=',
                originalConfig: '=',
                createMode: '=',
                deployVmtxMode: "=",
                expanded: '=',
                selectedGuestOs: '='
            },
            templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareMemory/vmHardwareMemory.html',
            link: {
                pre: function (iScope) {
                    var scope = iScope;
                    var initailizationStepDone = false;
                    var initailizationShares;
                    scope.i18n = i18nService.getString;
                    scope.MAX_SHARES_VALUE = 1000000;
                    scope.MIN_SHARES_VALUE = 1;
                    scope.fieldLabel = function (field) {
                        return scope.i18n('VmUi', 'label' + field);
                    };
                    scope.memoryOptions = [
                        { label: scope.i18n('VmUi', "Vm.Units.MB"), multiplier: 1 },
                        { label: scope.i18n('VmUi', "Vm.Units.GB"), multiplier: 1024 },
                        { label: scope.i18n('VmUi', "Vm.Units.TB"), multiplier: 1024 * 1024 }
                    ];
                    if (scope.vm) {
                        scope.memoryRecommendations = scope.vm.getMemoryRecommendations();
                    }
                    var memoryMB = scope.vmConfigContext.config.hardware.memoryMB;
                    if (memoryMB < 1024) {
                        scope.vmConfigContext.config.hardware.memoryUnitPreferred = scope.memoryOptions[0];
                    }
                    scope.onMemoryReservationLockedToMax = function () {
                        if (scope.vmConfigContext.config.memoryReservationLockedToMax) {
                            scope.vmConfigContext.config.memoryAllocation.reservation = scope.vmConfigContext.config.hardware.memoryMB;
                        }
                    };
                    var memoryValidator = {
                        name: "memoryMB",
                        validate: validateFn,
                        message: errorFn,
                        error: ""
                    };
                    function validateFn(mb) {
                        if (!scope.vm) {
                            return true;
                        }
                        var result = scope.vm.validateMemoryMB(mb);
                        memoryValidator.error = result.error;
                        return result.valid;
                    }
                    function errorFn() {
                        return memoryValidator.error;
                    }
                    scope.memoryValidators = [memoryValidator];
                    scope.onUnitChanged = function (newUnit) {
                        scope.vmConfigContext.config.hardware.memoryUnitPreferred = newUnit;
                    };
                    scope.onReservationUnitChanged = function (newUnit) {
                        scope.vmConfigContext.config.memoryAllocation.reservationMemoryUnitPreferred = newUnit;
                    };
                    scope.onLimitUnitChanged = function (newUnit) {
                        scope.vmConfigContext.config.memoryAllocation.limitMemoryUnitPreferred = newUnit;
                    };
                    scope.sharesValueMap = {
                        low: 0,
                        normal: 0,
                        high: 0
                    };
                    var unlimitedLabel = scope.i18n('VmUi', 'labelUnlimited');
                    var limit = -1, reservation = 0;
                    if (_.isEmpty(scope.vmConfigContext.config.memoryAllocation)
                        || !scope.vmConfigContext.config.memoryAllocation.isInitialized) {
                        limit = scope.originalConfig.memoryAllocation ?
                            scope.originalConfig.memoryAllocation.limit : -1;
                        reservation = scope.originalConfig.memoryAllocation ?
                            scope.originalConfig.memoryAllocation.reservation : 0;
                        scope.vmConfigContext.config.memoryAllocation.isInitialized = true;
                        //set default units
                        scope.vmConfigContext.config.memoryAllocation.reservationMemoryUnitPreferred =
                            scope.memoryOptions[0];
                        scope.vmConfigContext.config.memoryAllocation.limitMemoryUnitPreferred =
                            scope.memoryOptions[0];
                    }
                    scope.limitRecommendations = [
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Limit.Current'),
                            value: limit
                        },
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Limit.Minimum'),
                            value: 0
                        },
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Limit.Maximum'),
                            value: -1
                        }
                    ];
                    scope.reservationRecommendations = [
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Reservation.Current'),
                            value: reservation
                        },
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Reservation.Minimum'),
                            value: 0
                        },
                        {
                            name: scope.i18n('VmUi', 'VmMemory.Reservation.Maximum'),
                            value: 0
                        }
                    ];
                    function getReservationErrorMessage() {
                        return scope.i18n('VmUi', 'Util.Validation.ValidRange', scope.i18n('VmUi', 'VmMemory.Label.Reservation'), scope.i18n('VmUi', 'memValue', 0), scope.i18n('VmUi', 'memValue', scope.limits.reservationMaxLimit));
                    }
                    function setReservationErrorMessage() {
                        scope.reservationErrorMessages = {
                            max: getReservationErrorMessage,
                            min: getReservationErrorMessage
                        };
                    }
                    setReservationErrorMessage();
                    var formatter = function (r) {
                        r.formattedValue = r.value === -1 ? unlimitedLabel : bytesFilter(r.value, 'MB');
                    };
                    scope.$watchGroup(['vmConfigContext.config.memoryAllocation.reservation',
                        'vmConfigContext.config.memoryAllocation.limit',
                        'vmConfigContext.config.hardware.memoryMB'], function (data) {
                        var reservation = scope.vmConfigContext.config.memoryAllocation.reservation;
                        if (reservation) {
                            scope.limitRecommendations[1].value = reservation;
                        }
                        scope.limits = {
                            reservationMaxLimit: getReservationMaxLimit()
                        };
                        setReservationErrorMessage();
                        scope.reservationRecommendations[2].value = scope.limits.reservationMaxLimit;
                        _.each(scope.limitRecommendations, formatter);
                        _.each(scope.reservationRecommendations, formatter);
                        var memoryMB = scope.vmConfigContext.config.hardware.memoryMB;
                        if (memoryMB) {
                            scope.sharesValueMap = {
                                low: Math.min(5 * memoryMB, scope.MAX_SHARES_VALUE),
                                normal: Math.min(10 * memoryMB, scope.MAX_SHARES_VALUE),
                                high: Math.min(20 * memoryMB, scope.MAX_SHARES_VALUE)
                            };
                            var level = scope.sharesInfo.level;
                            if (level !== 'custom') {
                                if (!initailizationStepDone) {
                                    initailizationShares = scope.sharesValueMap[level];
                                }
                                initailizationStepDone = true;
                                scope.sharesInfo.shares = scope.sharesValueMap[level];
                            }
                        }
                    });
                    scope.hasChanged = function () {
                        var isChanged = false;
                        var level = scope.vmConfigContext.config.cpuAllocation.shares.level;
                        isChanged = scope.vmConfigContext.config.hardware.memoryMB !== scope.originalConfig.hardware.memoryMB;
                        isChanged = isChanged || scope.originalConfig.memoryAllocation.reservation !== scope.vmConfigContext.config.memoryAllocation.reservation;
                        isChanged = isChanged || scope.originalConfig.memoryAllocation.limit !== scope.vmConfigContext.config.memoryAllocation.limit;
                        isChanged = isChanged || scope.vmConfigContext.config.memoryHotAddEnabled !== scope.originalConfig.memoryHotAddEnabled;
                        if (level !== 'custom') {
                            isChanged = isChanged ||
                                scope.sharesInfo.shares !== initailizationShares;
                        }
                        else {
                            isChanged = isChanged ||
                                scope.sharesInfo.shares !== scope.originalConfig.memoryAllocation.shares.shares;
                        }
                        return isChanged;
                    };
                    function getReservationMaxLimit() {
                        var memoryUsage = scope.vmConfigContext.environment.configTarget.resourcePool.memory;
                        var configuredMemory = scope.vmConfigContext.config.hardware.memoryMB;
                        var memoryAllocation = scope.vmConfigContext.config.memoryAllocation;
                        var vmPowerState = scope.vmConfigContext.environment.powerState;
                        var reservationMaxLimit = vmHardwareMemoryService.getReservationMaxLimit(memoryUsage, configuredMemory, memoryAllocation, vmPowerState);
                        return reservationMaxLimit;
                    }
                    function rangeError() {
                        var maxAllowedMemInGB = scope.maxAllowedMemory / 1024;
                        var key, maxAllowedMemory;
                        if (maxAllowedMemInGB < 1) {
                            key = "vmHardwareMemory.invalidMemoryRangeMB";
                            maxAllowedMemory = scope.maxAllowedMemory;
                        }
                        else {
                            key = "vmHardwareMemory.invalidMemoryRangeGB";
                            maxAllowedMemory = maxAllowedMemInGB;
                        }
                        return scope.i18n("VmUi", key, scope.minAllowedMemory, numberFormatterService.format(maxAllowedMemory, {
                            fractionSize: 1,
                            trimTrailingZeros: true
                        }));
                    }
                    scope.$watch('vmConfigContext', function (vmConfigContext) {
                        if (!vmConfigContext) {
                            return;
                        }
                        scope.minAllowedMemory = vmHardwareMemoryService.getMinMemoryMB(scope.vmConfigContext.config, scope.vmConfigContext.environment);
                        scope.maxAllowedMemory = vmHardwareMemoryService.getMaxMemoryMB(scope.vmConfigContext.config, scope.vmConfigContext.environment);
                        if (vmConfigContext.config) {
                            scope.memoryIncrementSize = vmConfigContext.config.hotPlugMemoryIncrementSize || 4;
                        }
                        else {
                            scope.memoryIncrementSize = 4;
                        }
                        scope.memoryErrorMessages = {
                            max: rangeError,
                            min: rangeError,
                            mod: scope.i18n("VmUi", "VmMemory.ErrorMultiple", scope.memoryIncrementSize + " MB")
                        };
                    });
                    scope.isMemoryDisabled = function () {
                        return vmHardwareMemoryService.isMemoryDisabled(scope.vmConfigContext.config, scope.vmConfigContext.environment, scope.vmConfigContext.privileges, scope.createMode);
                    };
                    scope.isReservationDisabled = function () {
                        return vmHardwareMemoryService.isReservationDisabled(scope.vmConfigContext.config, scope.vmConfigContext.privileges, scope.createMode);
                    };
                    scope.isMaxReservationDisabled = function () {
                        return vmHardwareMemoryService.isMaxReservationDisabled(scope.vmConfigContext.rtInfo, scope.vmConfigContext.privileges, scope.vmConfigContext.environment.configOption.capabilities, scope.createMode);
                    };
                    scope.isLimitDisabled = function () {
                        return vmHardwareMemoryService.isLimitDisabled(scope.vmConfigContext.privileges, scope.createMode);
                    };
                    scope.isSharesDisabled = function () {
                        return vmHardwareMemoryService.isSharesDisabled(scope.vmConfigContext.privileges, scope.createMode);
                    };
                    scope.isMemoryHotPlugDisabled = function () {
                        return vmHardwareMemoryService.isMemoryHotPlugDisabled(scope.vmConfigContext.environment, scope.vmConfigContext.privileges, scope.selectedGuestOs, scope.createMode);
                    };
                    scope.hasError = function () {
                        if (!_.isEmpty(scope.vmHardwareMemoryForm)) {
                            return scope.vmHardwareMemoryForm.$invalid;
                        }
                        return false;
                    };
                    var info = scope.vmConfigContext.config.memoryAllocation.shares;
                    scope.sharesInfo = info;
                    if (scope.isSharesDisabled() && info !== null) {
                        // value copy to avoid modifying underlying shares when no permissions etc.
                        scope.sharesInfo = { level: info.level, shares: info.shares, _type: "" };
                    }
                    scope.init_aria = function () {
                        scope.ARIA_LBL_MEMORY = scope.i18n('VmUi', 'VmMemory.Title');
                        scope.ARIA_LBL_RSRV = scope.fieldLabel('Reservation');
                        scope.ARIA_LBL_LIMIT = scope.fieldLabel('Limit');
                        scope.ARIA_LBL_SHARES = scope.fieldLabel('Shares');
                    };
                    scope.init_aria();
                }
            }
        };
    }]);



var h5_vm;
(function (h5_vm) {
    var SharesInfo = com.vmware.vim.binding.vim.SharesInfo;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VirtualEthernetCard$ResourceAllocationInfo = (function () {
        function VirtualEthernetCard$ResourceAllocationInfo() {
        }
        return VirtualEthernetCard$ResourceAllocationInfo;
    }());
    var VmHardwareNetworkController = (function () {
        function VmHardwareNetworkController(i18nService, vmDeviceInfoService, networkSelectorDialogService, defaultUriSchemeUtil, NetworkSelectorMode, vmNetworkService, vmHardwareNetworkService, VirtualMachineDevices, $q) {
            var _this = this;
            this.i18nService = i18nService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.networkSelectorDialogService = networkSelectorDialogService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.NetworkSelectorMode = NetworkSelectorMode;
            this.vmNetworkService = vmNetworkService;
            this.vmHardwareNetworkService = vmHardwareNetworkService;
            this.VirtualMachineDevices = VirtualMachineDevices;
            this.$q = $q;
            this.MAX_BANDWIDTH = 10000;
            this.reservationMax = this.MAX_BANDWIDTH;
            this.ARIA_LBL_RESTORE = this.i18n('DeviceDeletedControl.Restore');
            this.ARIA_LBL_REMOVE = this.i18n('DeviceDeletedControl.DeviceDeleted');
            this.ARIA_LBL_START_CONNECTED = this.i18n('ConnectDevice.ConnectAtPowerOn');
            this.ARIA_LBL_CONNECTED = this.i18n('ConnectDevice.Connected');
            this.ARIA_LBL_MTU = this.i18n('NetworkPage.GuestOSMTUChange');
            this.ARIA_LBL_RSRV = this.i18n('NetworkPage.Reservation');
            this.ARIA_LBL_LIMIT = this.i18n('NetworkPage.Limit');
            this.ARIA_LBL_NIC_TYPE = this.i18n('VmNetView.adapterType');
            this.ARIA_LBL_UPT = this.i18n('NetworkPage.UptCompatibility');
            this.ARIA_LBL_SRIOV_PF = this.i18n('NetworkPage.PhysicalFunction');
            this.ARIA_LBL_SHARES = this.i18n('NetworkPage.Shares');
            this.isHotAddDevice = function () {
                return _this.virtualNetworkDevice.isNew() &&
                    _this.vmWorkflowMode === VmWorkflowMode.UpdateMode &&
                    _this.isVmPoweredOn();
            };
            this.buildNetworkSelectorSpec = function () {
                return {
                    filterSpec: _this.vmNetworkService.getVmNetworkSelectorFilterSpec(),
                    dialogSpec: _this.networkSelectorDialogService.createNetworkSelectorDialogSpec(["Network.Assign"], _this.i18nService.getString("Common", "NetworkSelectorDialog.noPrivileges"), _this.i18nService.getString("Common", "NetworkSelectorDialog.noPrivilegesAndMore"))
                };
            };
            this.checkIsNetworkAvailable = function () {
                _this.errorConfig.isVisible = false;
                _this.selectedNetworkValid = true;
                if (_this.virtualNetworkDevice.isMarkedForRemoval()) {
                    // If the device is marked for removal we automatically count it
                    // valid and don't need to trigger any further validation.
                    _this.setErrorVisibility([true /*is valid*/]);
                    return;
                }
                if (!_.isEmpty(_this.properties.selectedNetwork) && _this.vmWorkflowMode !== VmWorkflowMode.UpdateMode) {
                    _this.vmHardwareNetworkService.checkNetworkPrivileges(_this.properties.selectedNetwork.id)
                        .then(function (result) {
                        _this.setErrorVisibility(result);
                    });
                }
            };
            this.onConnectAtPowerOnChange = function () {
                _this.device.connectable.startConnected = _this.properties.connectAtPowerOn;
                if (_this.isHotAddDevice()) {
                    _this.setConnectedValue(_this.properties.connectAtPowerOn);
                }
            };
            this.setConnectedValue = function (newValue) {
                _this.properties.connected = newValue;
                _this.device.connectable.connected = newValue;
            };
            this.onConnectChange = function () {
                _this.device.connectable.connected = _this.properties.connected;
                if (_this.isHotAddDevice()) {
                    _this.setConnectAtPowerOnValue(_this.properties.connected);
                }
            };
            this.setConnectAtPowerOnValue = function (newValue) {
                _this.properties.connectAtPowerOn = newValue;
                _this.device.connectable.startConnected = newValue;
            };
            this.onNetworkAdapterTypeChange = function () {
                _this.device._type = _this.properties.selectedAdapterType.type.name;
                _this.updateSelectedDeviceProtocol();
                _this.updateNetworkReservationSupported();
                _this.afterAdapterTypeChange();
            };
            this._mtuChangeValueAllow = { value: true, id: 1 };
            this._mtuChangeValueDisallow = { value: false, id: 0 };
            this.reservationMax = this.MAX_BANDWIDTH;
        }
        VmHardwareNetworkController.prototype.i18n = function (key) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (!this.i18nService) {
                return "";
            }
            return this.i18nService.getString("VmUi", key, rest);
        };
        VmHardwareNetworkController.prototype.$onInit = function () {
            var _this = this;
            this.initSriov();
            this.device = this.virtualNetworkDevice.getCurrentDevice();
            this.originalAllocation = angular.copy(this.device.resourceAllocation);
            this.resourceAllocation = this.device.resourceAllocation;
            this.properties = {};
            var nwSelectorSpec = this.buildNetworkSelectorSpec();
            var singleSelectedNetworkObject = this.vmHardwareNetworkService.buildNetworkItemForSelectedNetworkBacking(this.vmConfigContext.environment.configTarget, this.virtualNetworkDevice.getCurrentDevice());
            var networkProviderId = this.networkProvider ?
                this.networkProvider :
                this.vmHardwareNetworkService.getNetworkProviderFromVmConfig(this.vmConfigContext);
            this.networkSelectorModel = {
                objectRef: networkProviderId,
                mode: this.NetworkSelectorMode.SINGLE_SELECTION_DROPDOWN,
                filterSpec: nwSelectorSpec.filterSpec,
                dialogSpec: nwSelectorSpec.dialogSpec,
                selectedNetwork: singleSelectedNetworkObject,
                prefetchedNetworks: [singleSelectedNetworkObject]
            };
            this.onNetworkSelectionChanged = function (selectedNetworks) {
                var currentNetwork = selectedNetworks[0];
                var networkId = _this.defaultUriSchemeUtil.getVsphereObjectId(currentNetwork.networkRef);
                var networkInfo = _this.vmDeviceInfoService.getNetworkInfo(_this.vmConfigContext.environment.configTarget, networkId);
                _this.virtualNetworkDevice.setNetwork(networkInfo);
                var selectedNetwork = {
                    id: networkId, name: currentNetwork.name, networkInfo: networkInfo
                };
                _this.properties.selectedNetwork = selectedNetwork;
                _this.checkIsNetworkAvailable();
                if (_this.isNetworkReservationSupported()) {
                    _this.device.resourceAllocation = _this.resourceAllocation;
                    _this.properties.reservationSupported = true;
                }
                else {
                    _this.device.resourceAllocation = _this.newResourceAllocationInfo();
                    _this.properties.reservationSupported = false;
                }
            };
            this.onPreloadNetworks = function () {
                if (_this.vmWorkflowMode !== VmWorkflowMode.UpdateMode || !_this.vmId) {
                    return _this.$q.when(undefined);
                }
                // Get networks from the VM config target in the VM Edit mode
                if (_this.vmConfigContext.configTargetIsBeingUpdated) {
                    return _this.$q.when(_this.vmHardwareNetworkService.getNetworkSelectorNetworks(_this.vmNetworkService.getVmNetworkSelectorFilterSpec(), _this.vmConfigContext.environment.configTarget));
                }
                return _this.vmHardwareNetworkService.getVmConfigTarget(_this.vmId).then(function (configTargetWithNetworksResult) {
                    if (configTargetWithNetworksResult &&
                        configTargetWithNetworksResult.vmConfigTarget) {
                        _this.vmConfigContext.configTargetIsBeingUpdated = true;
                        _this.vmConfigContext.environment.configTarget =
                            configTargetWithNetworksResult.vmConfigTarget;
                        return _this.vmHardwareNetworkService.getNetworkSelectorNetworks(_this.vmNetworkService.getVmNetworkSelectorFilterSpec(), _this.vmConfigContext.environment.configTarget);
                    }
                    // If the networks can not be retrieved from the config target,
                    // they will be retrieved from the network selector
                    return undefined;
                });
            };
            this.errorConfig = {
                message: this.i18n("NetworkPage.NoPermission"),
                isVisible: false
            };
            this.deviceProtocols = this.vmHardwareNetworkService.getPVRDMADeviceProtocols();
            this.updateSelectedDeviceProtocol();
            this.adapterTypes = [];
            var recommendedAdapterType;
            var gosDescriptor = this.selectedGuestOs;
            var hardwareDeviceOptions = this.vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption;
            // adding device ethernetcard
            var deviceEthernetCard = this.vmDeviceInfoService.getDeviceEthernetCard(this.device);
            gosDescriptor.supportedEthernetCard.forEach(function (gosSupportedType) {
                hardwareDeviceOptions.forEach(function (hardwareSupportedType) {
                    if (gosSupportedType.name === hardwareSupportedType.type.name || deviceEthernetCard.name === hardwareSupportedType.type.name) {
                        if (gosDescriptor.recommendedEthernetCard.name === hardwareSupportedType.type.name) {
                            recommendedAdapterType = hardwareSupportedType;
                        }
                        _this.adapterTypes.push(hardwareSupportedType);
                    }
                });
            });
            this.adapterTypes = _.uniq(this.adapterTypes, false, function (item) {
                return item.type.name;
            });
            this.removePVRDMAIfLimitReached();
            this.properties = {
                selectedAdapterType: this.vmNetworkService.getSelectedNetworkTypeForDevice(this.device, recommendedAdapterType, this.adapterTypes, hardwareDeviceOptions),
                selectedNetwork: {
                    id: this.virtualNetworkDevice.getNetworkId(),
                    name: this.virtualNetworkDevice.getNetworkName(),
                    networkInfo: this.virtualNetworkDevice.getNetwork()
                },
                connected: this.device.connectable.connected,
                connectAtPowerOn: this.device.connectable.startConnected
            };
            this.getEthernetCardLabel = this.vmDeviceInfoService.getEthernetCardLabel;
            this.selectedNetworkValid = true;
            this.setupResourceAllocation();
        };
        VmHardwareNetworkController.prototype.isVmPoweredOn = function () {
            return this.vmHardwareNetworkService.isVmPoweredOn(this.vmConfigContext);
        };
        VmHardwareNetworkController.prototype.$postLink = function () {
            this.checkIsNetworkAvailable();
            this.checkSriovValidity();
        };
        VmHardwareNetworkController.prototype.isRemoveDisabled = function () {
            if (this.isNew() || this.deployVmtxMode) {
                return false;
            }
            else {
                return this.vmHardwareNetworkService.isRemoveNetworkAdapterDisabled(this.vmConfigContext.privileges);
            }
        };
        VmHardwareNetworkController.prototype.onRemoveDevice = function () {
            if (!this.isRemoveDisabled() && this.removeCallback) {
                this.removeCallback()(this.virtualNetworkDevice);
                // on device removal mark form valid if it was not, later
                // if removal is reverted, we will re-calculate validity
                this.setErrorVisibility([true /*isValid*/]);
                this.vmHardwareNetworkForm.$setValidity("sriov", true);
            }
        };
        VmHardwareNetworkController.prototype.revertRemoval = function () {
            if (!this.virtualNetworkDevice) {
                return;
            }
            this.virtualNetworkDevice.revertRemoval();
            // re-calculate the form validity, because it was maked valid
            // on device removal
            this.checkIsNetworkAvailable();
            this.setSriovValidity();
        };
        VmHardwareNetworkController.prototype.hasError = function () {
            if (!_.isEmpty(this.vmHardwareNetworkForm)) {
                return this.vmHardwareNetworkForm.$invalid;
            }
            return false;
        };
        ;
        VmHardwareNetworkController.prototype.shouldDisplayPVRDMADeviceProtocol = function () {
            return this.supportsDeviceProtocol();
        };
        VmHardwareNetworkController.prototype.getDeviceProtocolLabel = function (deviceProtocol) {
            return this.vmHardwareNetworkService.getPVRDMADeviceProtocolLabel(deviceProtocol);
        };
        VmHardwareNetworkController.prototype.updateSelectedDeviceProtocol = function () {
            // if (this.featureFlagsService.VRDMA_ROCEV2Enabled()) {
            //    return;
            // }
            if (!this.virtualNetworkDevice.isNew()) {
                return;
            }
            if (this.supportsDeviceProtocol()) {
                if (!this.device.deviceProtocol) {
                    this.device.deviceProtocol = this.vmHardwareNetworkService.getDefaultRDMAProtocol(this.getVrdmaOption());
                }
                this.device.deviceProtocol = this.device.deviceProtocol || this.deviceProtocols[0];
            }
        };
        VmHardwareNetworkController.prototype.setErrorVisibility = function (result) {
            var isAvailable = result[0];
            if (isAvailable === undefined) {
                isAvailable = true;
            }
            this.errorConfig.isVisible = !isAvailable;
            this.selectedNetworkValid = isAvailable;
            this.vmHardwareNetworkForm.$setValidity("nested", this.selectedNetworkValid);
        };
        VmHardwareNetworkController.prototype.isSriovEthernetCardType = function (type) {
            return type === "com.vmware.vim.binding.vim.vm.device.VirtualSriovEthernetCard";
        };
        VmHardwareNetworkController.prototype.isNetworkSelectDisabled = function () {
            return this.vmNetworkService.isNetworkSelectDisabled(this.vmConfigContext.privileges, this.isNew());
        };
        VmHardwareNetworkController.prototype.isConnectedDisabled = function () {
            if (this.isNotConnectable()) {
                return true;
            }
            return this.vmNetworkService.isConnectedDisabled(this.vmConfigContext.privileges, this.isNew());
        };
        VmHardwareNetworkController.prototype.isConnectedAtPowerOnDisabled = function () {
            if (this.isNotConnectable()) {
                return true;
            }
            return this.vmNetworkService.isConnectedAtPowerOnDisabled(this.vmConfigContext.privileges, this.isNew());
        };
        VmHardwareNetworkController.prototype.isMacAddressDisabled = function () {
            return this.vmNetworkService.isMacAddressDisabled(this.vmConfigContext.environment.powerState, this.virtualNetworkDevice.isNew(), this.vmConfigContext.privileges, this.vmWorkflowMode === VmWorkflowMode.CreateMode);
        };
        VmHardwareNetworkController.prototype.isNetworkAdapterDisabled = function () {
            if (this.isNew()) {
                return false;
            }
            else {
                return true;
            }
        };
        VmHardwareNetworkController.prototype.uptCompatibility = function (value) {
            var device = this.device;
            var deviceOption = this.properties.selectedAdapterType;
            if (angular.isDefined(value)) {
                this.vmNetworkService.setUptCompatibility(device, value);
                return value;
            }
            else {
                return this.vmNetworkService.getUptCompatibility(device, deviceOption);
            }
        };
        VmHardwareNetworkController.prototype.isEditUptCompatibilityDisabled = function () {
            return this.vmNetworkService.isEditUptCompatibilityDisabled(this.vmConfigContext, this.isNew());
        };
        VmHardwareNetworkController.prototype.isUptCompatibilityVisible = function () {
            var deviceOption = this.properties.selectedAdapterType;
            return this.vmNetworkService.isUptCompatibilityVisible(deviceOption);
        };
        VmHardwareNetworkController.prototype.setupResourceAllocation = function () {
            this.sharesValueMap = { low: 25, normal: 50, high: 100 };
            this.updateNetworkReservationSupported();
            if (!this.resourceAllocation) {
                this.resourceAllocation = this.newResourceAllocationInfo();
                if (this.isNetworkReservationSupported()) {
                    this.device.resourceAllocation = this.resourceAllocation;
                }
            }
            this.updateReservationRange();
            this.setupBandwidthUnits();
            this.reservationErrorMessages = { max: this.getReservationError.bind(this) };
            this.limitErrorMessages = { max: this.getReservationError.bind(this) };
            this.updateReservationRecommendations();
            this.updateLimitRecommendations();
            this.setupLimitValidator();
            return;
        };
        VmHardwareNetworkController.prototype.updateNetworkReservationSupported = function () {
            this.properties.reservationSupported = this.isNetworkReservationSupported();
        };
        VmHardwareNetworkController.prototype.isNetworkReservationSupported = function () {
            if (this.isSriovEthernetCardType(this.device._type)) {
                return false;
            }
            var networkInfo = this.properties.selectedNetwork.networkInfo;
            if (networkInfo && networkInfo.hasOwnProperty("networkReservationSupported")) {
                return networkInfo.networkReservationSupported;
            }
            return false;
        };
        VmHardwareNetworkController.prototype.newResourceAllocationInfo = function () {
            var retVal = new VirtualEthernetCard$ResourceAllocationInfo();
            retVal._type = "com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$ResourceAllocation";
            retVal.share = new SharesInfo();
            retVal.reservation = 0;
            retVal.limit = -1;
            retVal.share.level = "normal";
            retVal.share.shares = 50;
            return retVal;
        };
        VmHardwareNetworkController.prototype.setupLimitValidator = function () {
            this.limitValidator = {
                name: "validateLimit",
                validate: this.validateLimit.bind(this),
                message: this.getLimitError.bind(this)
            };
            this.limitValidators = [this.limitValidator];
        };
        VmHardwareNetworkController.prototype.validateLimit = function (value) {
            if (value === -1) {
                return true;
            }
            if (value > this.MAX_BANDWIDTH) {
                return false;
            }
            if (value < 1) {
                return false;
            }
            return true;
        };
        VmHardwareNetworkController.prototype.onLimitChanged = function () {
            this.updateReservationRange();
            this.updateReservationRecommendations();
        };
        VmHardwareNetworkController.prototype.updateReservationRange = function () {
            if (this.resourceAllocation && this.resourceAllocation.limit > 0) {
                this.reservationMax = this.resourceAllocation.limit;
            }
            else {
                this.reservationMax = this.MAX_BANDWIDTH;
            }
        };
        VmHardwareNetworkController.prototype.onReservationChanged = function () {
            this.updateLimitRecommendations();
        };
        VmHardwareNetworkController.prototype.updateReservationRecommendations = function () {
            var resourceAllocation = this.originalAllocation;
            var currentValue = resourceAllocation ? resourceAllocation.reservation : 0;
            this.reservationRecommendations = [
                { name: this.i18n("NetworkPage.CurrentValue"), value: currentValue },
                { name: this.i18n("NetworkPage.Minimum"), value: 0 },
                { name: this.i18n("NetworkPage.Maximum"), value: this.reservationMax },
            ];
        };
        VmHardwareNetworkController.prototype.updateLimitRecommendations = function () {
            var UNLIMITED_VALUE = this.i18nService.getString("Common", "unlimited");
            var resourceAllocation = this.originalAllocation;
            var currentValue = resourceAllocation ? resourceAllocation.limit : 0;
            var formattedCurrentValue = currentValue.toString();
            if (currentValue === -1) {
                formattedCurrentValue = UNLIMITED_VALUE;
            }
            this.limitRecommendations = [
                {
                    name: this.i18n("NetworkPage.CurrentValue"), value: currentValue,
                    formattedValue: formattedCurrentValue
                },
                { name: this.i18n("NetworkPage.Minimum"), value: 1 },
                { name: this.i18n("NetworkPage.Maximum"), value: this.MAX_BANDWIDTH },
                { name: UNLIMITED_VALUE, value: -1, formattedValue: UNLIMITED_VALUE }
            ];
        };
        VmHardwareNetworkController.prototype.getReservationError = function () {
            var mhzLabel = this.i18nService.getString("Common", "megabitSec.label");
            var name = this.i18n("NetworkPage.Reservation");
            var min = "0";
            var max = this.reservationMax.toString() + " " + mhzLabel;
            var retVal = this.i18nService.getString("VmUi", "Util.Validation.ValidRange", name, min, max);
            return retVal;
        };
        VmHardwareNetworkController.prototype.getLimitError = function () {
            var mhzLabel = this.i18nService.getString("Common", "megabitSec.label");
            var name = this.i18n("NetworkPage.Limit");
            var min = 1;
            var max = this.MAX_BANDWIDTH.toString() + " " + mhzLabel;
            var retVal = this.i18nService.getString("VmUi", "Util.Validation.ValidRange", name, min.toString(), max);
            return retVal;
        };
        VmHardwareNetworkController.prototype.setupBandwidthUnits = function () {
            var mhzLabel = this.i18nService.getString("Common", "megabitSec.label");
            var ghzLabel = this.i18nService.getString("Common", "gigabitSec.label");
            this.reservationUnitOptions = [
                { label: mhzLabel, multiplier: 1 },
                { label: ghzLabel, multiplier: 1000 }
            ];
        };
        VmHardwareNetworkController.prototype.isNew = function () {
            if (this.virtualNetworkDevice) {
                return this.virtualNetworkDevice.isNew();
            }
            return false;
        };
        VmHardwareNetworkController.prototype.initSriov = function () {
            this._mtuChangeValueAllow.label = this.i18n("NetworkConfig.AllowGuestOSMtuChange");
            this._mtuChangeValueDisallow.label = this.i18n("NetworkConfig.AllowGuestOSMtuChangeNot");
            this.sriov = new h5_vm.VmHwSriovDriver(this.vmConfigContext, this.virtualNetworkDevice, this.vmWorkflowMode);
        };
        VmHardwareNetworkController.prototype.isSriovEthernetCard = function () {
            return this.isSriovEthernetCardType(this.device._type);
        };
        VmHardwareNetworkController.prototype.afterAdapterTypeChange = function () {
            this.setSriovValidity();
            if (!this.isSriovEthernetCard()) {
                return;
            }
            if (this.sriov.available()) {
                this.sriov.switchToSriovAdapterType();
            }
        };
        VmHardwareNetworkController.prototype.setSriovValidity = function () {
            if (!this.isSriovEthernetCard()) {
                this.sriovValid(true);
                return;
            }
            if (this.isVmPoweredOn()) {
                this.sriovValid(false);
            }
            if (this.sriov.unavailable()) {
                this.sriovValid(false);
            }
        };
        VmHardwareNetworkController.prototype.sriovValid = function (valid) {
            this.vmHardwareNetworkForm.$setValidity("sriov", valid);
        };
        Object.defineProperty(VmHardwareNetworkController.prototype, "sriovValue", {
            get: function () {
                return this.sriov.sriovValue;
            },
            set: function (value) {
                this.sriov.sriovValue = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareNetworkController.prototype.sriovList = function () {
            return this.sriov.sriovList();
        };
        VmHardwareNetworkController.prototype.isSriovVisible = function () {
            return this.isSriovEthernetCard();
        };
        VmHardwareNetworkController.prototype.isSriovSelectVisible = function () {
            if (this.sriov.available()) {
                return this.isSriovEthernetCard() && this.isNew();
            }
            else {
                return false;
            }
        };
        VmHardwareNetworkController.prototype.isSriovLabelVisible = function () {
            return !this.isSriovSelectVisible();
        };
        VmHardwareNetworkController.prototype.getSriovLabelText = function () {
            if (this.sriov.unavailable()) {
                return this.i18n("NetworkPage.SriovNotAvailable");
            }
            return this.sriov.getSriovLabelText();
        };
        Object.defineProperty(VmHardwareNetworkController.prototype, "isSriovWarningVisible", {
            get: function () {
                return this.isSriovEthernetCard() && this.sriov.available();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "sriovWarningText", {
            get: function () {
                var retVal = this.i18n("NetworkPage.WarnLimitedOperations");
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "isMemWarnVisible", {
            get: function () {
                if (this.sriov.unavailable()) {
                    return false;
                }
                if (false === this.isSriovVisible()) {
                    return false;
                }
                return this.sriov.reservationIssue();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "memWarnText", {
            get: function () {
                return this.i18n("NetworkPage.WarnReservation");
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareNetworkController.prototype.isNotConnectable = function () {
            // SR-IOV adapter case
            return this.vmNetworkService.isNotConnectable(this.device, this.vmConfigContext);
        };
        Object.defineProperty(VmHardwareNetworkController.prototype, "showHotAddError", {
            get: function () {
                if (!this.isNew()) {
                    return false;
                }
                if (this.isSriovEthernetCard() && this.isVmPoweredOn()) {
                    return true;
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "hotAddErrorText", {
            get: function () {
                return this.i18n("NetworkPage.HotAddError");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "mtuChangeValue", {
            get: function () {
                if (!this.isSriovEthernetCard()) {
                    return this._mtuChangeValueDisallow;
                }
                if (this.sriov.allowMtuChange) {
                    return this._mtuChangeValueAllow;
                }
                else {
                    return this._mtuChangeValueDisallow;
                }
            },
            set: function (item) {
                if (!this.isSriovEthernetCard()) {
                    return;
                }
                this.sriov.allowMtuChange = item.value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "mtuChangeList", {
            get: function () {
                return [this._mtuChangeValueAllow, this._mtuChangeValueDisallow];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "isMtuChangeVisible", {
            get: function () {
                return this.isSriovEthernetCard();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "isMtuChangeEditable", {
            get: function () {
                return this.sriov.isAllowMtuChangeEditable();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareNetworkController.prototype, "showDeviceWarning", {
            get: function () {
                return this.isMemWarnVisible;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareNetworkController.prototype.checkSriovValidity = function () {
            if (this.virtualNetworkDevice.isMarkedForRemoval()) {
                // If the device is marked for removal we automatically count it
                // valid and don't need to trigger any further validation.
                this.sriovValid(true);
                return;
            }
            if (this.isSriovEthernetCard() && !this.virtualNetworkDevice.isNew()) {
                // if the device already exists, but it's compute resource has been changed
                // and no longer supports SR-IOV mark it as invalid
                if (this.sriov.unavailable()) {
                    this.sriovValid(false);
                }
            }
        };
        VmHardwareNetworkController.prototype.getVrdmaOption = function () {
            var type = this.properties.selectedAdapterType;
            var option = type;
            return option;
        };
        VmHardwareNetworkController.prototype.supportsDeviceProtocol = function () {
            var option = this.getVrdmaOption();
            return this.vmHardwareNetworkService.supportsDeviceProtocol(option);
        };
        VmHardwareNetworkController.prototype.isPVRDMALimitReached = function () {
            if (this.virtualNetworkDevice.isNew()) {
                return this.vmHardwareNetworkService.isPVRDMALimitReached(this.virtualMachineDevices, this.vmConfigContext);
            }
            return false;
        };
        VmHardwareNetworkController.prototype.removePVRDMAIfLimitReached = function () {
            if (!this.virtualNetworkDevice.isNew()) {
                return;
            }
            if (this.isPVRDMALimitReached()) {
                this.adapterTypes = this.vmHardwareNetworkService.removePVRDMAType(this.adapterTypes);
            }
        };
        VmHardwareNetworkController.$inject = [
            "i18nService",
            "vmDeviceInfoService",
            "networkSelectorDialogService",
            "defaultUriSchemeUtil",
            "NetworkSelectorMode",
            "vmNetworkService",
            "vmHardwareNetworkService",
            "vmHardwareVersionService",
            "$q"
        ];
        return VmHardwareNetworkController;
    }());
    var VmHardwareNetwork = (function () {
        function VmHardwareNetwork() {
            this.bindings = {
                virtualNetworkDevice: "<",
                virtualMachineDevices: "<",
                networkProvider: "<",
                availableNetworks: "<",
                networkPrivilegeMap: "<",
                vmWorkflowMode: "<",
                selectedGuestOs: "<",
                filterNetworksObjId: "<",
                vmConfigContext: "<",
                removeCallback: "&",
                vmId: "<",
                deployVmtxMode: "=",
                expanded: "="
            };
            this.controller = VmHardwareNetworkController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareNetwork/vm-hardware-network.html";
        }
        return VmHardwareNetwork;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareNetwork", new VmHardwareNetwork());
})(h5_vm || (h5_vm = {}));



var vm_ui;
(function (vm_ui) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareNetworkService = (function () {
        function VmHardwareNetworkService($q, i18nService, dataService, defaultUriSchemeUtil, authorizationService, vmHardwareUtil, vmHardwareVersionService) {
            this.$q = $q;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.authorizationService = authorizationService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.vmHardwareVersionService = vmHardwareVersionService;
            this.ROCEV1 = "rocev1";
            this.ROCEV2 = "rocev2";
            this.PCI_CONTROLLER_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualPCIController";
            this.RDMA_DEVICE_CLASS = "com.vmware.vim.binding.vim.vm.device.VirtualVmxnet3Vrdma";
        }
        VmHardwareNetworkService.prototype.isVmPoweredOn = function (vmConfigContext) {
            return this.vmHardwareUtil.isVmPoweredOn(vmConfigContext.environment.powerState);
        };
        VmHardwareNetworkService.prototype.getNetworkProviderFromVmConfig = function (vmConfigContext) {
            return this.defaultUriSchemeUtil.getVsphereObjectId(vmConfigContext.rtInfo.host);
        };
        VmHardwareNetworkService.prototype.getVmConfigTarget = function (vmId) {
            return this.dataService.getProperties(vmId, ['vmConfigTarget']);
        };
        /**
         * Get the network selector networks from the VM environment browser config target
         * @param filterSpec
         *       The filter spec of the network selector
         * @param configTarget
         *       VM environment browser config target
         * @returns An array of NetworkSelectorPortgroupData objects
         */
        VmHardwareNetworkService.prototype.getNetworkSelectorNetworks = function (filterSpec, configTarget) {
            var _this = this;
            var networkSelectorData = [];
            if (!configTarget || !filterSpec) {
                return networkSelectorData;
            }
            if (filterSpec.includeDistributedPortGroups) {
                var dvpgInfos = configTarget.distributedVirtualPortgroup;
                if (dvpgInfos && dvpgInfos.length > 0) {
                    _.forEach(dvpgInfos, function (dvpgInfo) {
                        if (filterSpec.includeUplinkPortGroups || !dvpgInfo.uplinkPortgroup) {
                            var dvpgData = _this.createDvpgNetworkSelectorData(dvpgInfo);
                            if (dvpgData) {
                                networkSelectorData.push(dvpgData);
                            }
                        }
                    });
                }
            }
            if (filterSpec.includeOpaqueNetworks) {
                var opaqueNetworkInfos = configTarget.opaqueNetwork;
                if (opaqueNetworkInfos && opaqueNetworkInfos.length > 0) {
                    _.forEach(opaqueNetworkInfos, function (opaqueNetworkInfo) {
                        var opaqueNetworkData = _this.createOpaqueNetworkSelectorData(opaqueNetworkInfo);
                        if (opaqueNetworkData) {
                            networkSelectorData.push(opaqueNetworkData);
                        }
                    });
                }
            }
            if (filterSpec.includeStandardNetworks) {
                var networkInfos = configTarget.network;
                if (networkInfos && networkInfos.length > 0) {
                    _.forEach(networkInfos, function (networkInfo) {
                        var standardNetworkData = _this.createStandardNetworkSelectorData(networkInfo);
                        if (standardNetworkData) {
                            networkSelectorData.push(standardNetworkData);
                        }
                    });
                }
            }
            return networkSelectorData;
        };
        VmHardwareNetworkService.prototype.createDvpgNetworkSelectorData = function (dvpgInfo) {
            if (!dvpgInfo) {
                return undefined;
            }
            return {
                _type: "com.vmware.vsphere.client.modules.api.networkselector.NetworkSelectorPortgroupData",
                name: dvpgInfo.portgroupName,
                portgroupKey: dvpgInfo.portgroupKey,
                dvsName: dvpgInfo.switchName,
                dvsUuid: dvpgInfo.switchUuid,
                networkRef: dvpgInfo.portgroup,
                isUplink: dvpgInfo.uplinkPortgroup
            };
        };
        VmHardwareNetworkService.prototype.createOpaqueNetworkSelectorData = function (opaqueNetworkInfo) {
            if (!opaqueNetworkInfo || !opaqueNetworkInfo.network) {
                return undefined;
            }
            return {
                _type: "com.vmware.vsphere.client.modules.api.networkselector.NetworkSelectorPortgroupData",
                isOpaqueNetwork: true,
                name: opaqueNetworkInfo.name,
                networkRef: opaqueNetworkInfo.network.network,
                opaqueNetworkType: opaqueNetworkInfo.network.opaqueNetworkType
            };
        };
        VmHardwareNetworkService.prototype.createStandardNetworkSelectorData = function (networkInfo) {
            if (!networkInfo || !networkInfo.network) {
                return undefined;
            }
            return {
                _type: "com.vmware.vsphere.client.modules.api.networkselector.NetworkSelectorPortgroupData",
                isStandardNetwork: true,
                name: networkInfo.name,
                networkRef: networkInfo.network.network
            };
        };
        VmHardwareNetworkService.prototype.checkNetworkPrivileges = function (id) {
            if (id) {
                return this.authorizationService.checkPrivileges(id, ['Network.Assign']);
            }
            else {
                return this.$q.when([false]);
            }
        };
        VmHardwareNetworkService.prototype.buildNetworkItemForSelectedNetworkBacking = function (configTarget, device) {
            var backing = device.backing;
            if (backing._type.indexOf('DistributedVirtualPortBackingInfo') > -1) {
                return this.buildDistributedVirtualPortGroupItem(configTarget, backing);
            }
            else if (backing._type.indexOf('OpaqueNetworkBackingInfo') > -1) {
                return this.buildOpaqueNetworkItem(configTarget, backing);
            }
            else if (backing._type.indexOf('NetworkBackingInfo') > -1) {
                return this.buildNetworkItem(configTarget, backing);
            }
        };
        VmHardwareNetworkService.prototype.getResourcePoolForVm = function (vmId) {
            return this.dataService.getProperties(vmId, ['resourcePool']);
        };
        VmHardwareNetworkService.prototype.canConfigurePVRDMADeviceProtocol = function (vmVersion) {
            //TODO: replace this with a flag passed from the backend
            return this.vmHardwareVersionService.getVersionNumber(vmVersion) >= 14;
        };
        VmHardwareNetworkService.prototype.getPVRDMADeviceProtocols = function () {
            return [this.ROCEV1, this.ROCEV2];
        };
        VmHardwareNetworkService.prototype.getPVRDMADeviceProtocolLabel = function (deviceProtocol) {
            return this.i18nService.getString('VmUi', 'NetworkConfig.VirtualVmxnet3Vrdma.' + deviceProtocol);
        };
        /* Private */
        VmHardwareNetworkService.prototype.buildDistributedVirtualPortGroupItem = function (configTarget, backing) {
            var identifier = backing.port.portgroupKey;
            var allPortGroups = configTarget.distributedVirtualPortgroup;
            var selection = _.find(allPortGroups, function (item) {
                return (item.portgroupKey === identifier);
            });
            if (!selection) {
                return this.generateEmptyNetworkItem();
            }
            var mor = selection.portgroup;
            var uri = this.defaultUriSchemeUtil.createVmomiUri(mor.type, mor.value, mor.serverGuid);
            return this.generateNetworkItem(selection.portgroupName, selection.switchUuid, uri, uri, null);
        };
        VmHardwareNetworkService.prototype.buildNetworkItem = function (configTarget, backing) {
            var identifier = backing.deviceName;
            var allNetworks = configTarget.network;
            var selection = _.find(allNetworks, function (item) {
                return (item.name === identifier);
            });
            if (!selection) {
                return this.generateEmptyNetworkItem();
            }
            var mor = selection.network.network;
            var uri = this.defaultUriSchemeUtil.createVmomiUri(mor.type, mor.value, mor.serverGuid);
            return this.generateNetworkItem(selection.name, null, uri, uri, null);
        };
        VmHardwareNetworkService.prototype.buildOpaqueNetworkItem = function (configTarget, backing) {
            /*TODO somashekars: test this code with NSX switch available in the inventory*/
            var identifier = backing.opaqueNetworkId;
            var allOpaqueNetworks = configTarget.opaqueNetwork;
            var selection = _.find(allOpaqueNetworks, function (item) {
                return (item.network.opaqueNetworkId === identifier);
            });
            if (!selection) {
                return this.generateEmptyNetworkItem();
            }
            var opaqueNetwork = selection.network;
            return this.generateNetworkItem(opaqueNetwork.name, null, opaqueNetwork.opaqueNetworkId, opaqueNetwork.opaqueNetworkId, opaqueNetwork.opaqueNetworkType);
        };
        VmHardwareNetworkService.prototype.generateEmptyNetworkItem = function () {
            return this.generateNetworkItem("", null, null, null, null);
        };
        VmHardwareNetworkService.prototype.generateNetworkItem = function (name, dvsUuid, networkId, id, opaqueNetworkType) {
            return {
                name: name,
                dvsUuid: dvsUuid,
                networkId: networkId,
                id: id,
                opaqueNetworkType: opaqueNetworkType
            };
        };
        VmHardwareNetworkService.prototype.isRemoveNetworkAdapterDisabled = function (privileges) {
            return !this.hasAddRemoveDevicePrivilege(privileges);
        };
        VmHardwareNetworkService.prototype.hasAddRemoveDevicePrivilege = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE]);
        };
        VmHardwareNetworkService.prototype.supportsDeviceProtocol = function (option) {
            var vrdmaOption = option;
            if (!vrdmaOption) {
                return false;
            }
            var choice = vrdmaOption.deviceProtocol;
            if (!choice) {
                return false;
            }
            if (choice.choiceInfo.length < 2) {
                return false;
            }
            return true;
        };
        VmHardwareNetworkService.prototype.getDefaultRDMAProtocol = function (vrdmaOption) {
            if (!vrdmaOption) {
                return "";
            }
            var choice = vrdmaOption.deviceProtocol;
            var array = choice.choiceInfo;
            var defaultIndex = choice.defaultIndex;
            if (defaultIndex === 0 && array.length > 1) {
                defaultIndex = 1;
            }
            var item = array[defaultIndex];
            return item.key;
        };
        VmHardwareNetworkService.prototype.isPVRDMALimitReached = function (virtualMachineDevices, vmConfigContext) {
            var max = this.getPVRDMALimit(vmConfigContext);
            var count = this.getPVRDMACount(virtualMachineDevices);
            return count >= max;
        };
        VmHardwareNetworkService.prototype.getPVRDMACount = function (virtualMachineDevices) {
            var vrdmaList = virtualMachineDevices.devicesOfType("VirtualVmxnet3Vrdma");
            if (!vrdmaList || vrdmaList.length === 0) {
                return 0;
            }
            var vrdmaEthernetCount = vrdmaList.length;
            return vrdmaEthernetCount;
        };
        VmHardwareNetworkService.prototype.getPVRDMALimit = function (vmConfigContext) {
            var pciControllerOptions = this.vmHardwareUtil.getDeviceOption(vmConfigContext, this.PCI_CONTROLLER_TYPE);
            var numVrdmaOption = pciControllerOptions.numVmxnet3VrdmaEthernetCards;
            var vrdmaEthernetMaxCount = 1;
            if (numVrdmaOption) {
                vrdmaEthernetMaxCount = numVrdmaOption.max;
            }
            return vrdmaEthernetMaxCount;
        };
        VmHardwareNetworkService.prototype.removeType = function (adapterTypes, clazz) {
            var retVal;
            var filterFn = function (item) { return item.type.name !== clazz; };
            retVal = _.filter(adapterTypes, filterFn);
            return retVal;
        };
        VmHardwareNetworkService.prototype.removePVRDMAType = function (adapterTypes) {
            var clazz = this.RDMA_DEVICE_CLASS;
            return this.removeType(adapterTypes, clazz);
        };
        VmHardwareNetworkService.$inject = [
            "$q",
            "i18nService",
            "dataService",
            "defaultUriSchemeUtil",
            "authorizationService",
            "vmHardwareUtil",
            "vmHardwareVersionService"
        ];
        return VmHardwareNetworkService;
    }());
    vm_ui.VmHardwareNetworkService = VmHardwareNetworkService; // class ends
    angular.module("com.vmware.vsphere.client.vm").service("vmHardwareNetworkService", VmHardwareNetworkService);
})(vm_ui || (vm_ui = {}));



var h5_vm;
(function (h5_vm) {
    var VmHwSriovDriver = (function () {
        function VmHwSriovDriver(vm, virtualNetworkDevice, workflow) {
            this.vm = vm;
            this.virtualNetworkDevice = virtualNetworkDevice;
            this.workflow = workflow;
            this.service = new h5_vm.VmHwSriovService();
            this.device = this.virtualNetworkDevice.getCurrentDevice();
            if (vm && vm.environment) {
                this.configTarget = this.vm.environment.configTarget;
                var network = this.virtualNetworkDevice.getNetwork();
                this._sriovList = this.service.getSriovList(vm, network);
                var sriovInfo = this.service.getSriovInfo(this.device, this._sriovList);
                if (sriovInfo) {
                    this._sriovValue = sriovInfo;
                }
            }
        }
        VmHwSriovDriver.prototype.isSriovEthernetCardType = function (type) {
            return type === "com.vmware.vim.binding.vim.vm.device.VirtualSriovEthernetCard";
        };
        VmHwSriovDriver.prototype.unavailable = function () {
            return !this.available();
        };
        VmHwSriovDriver.prototype.available = function () {
            if (!this.configTarget) {
                return false;
            }
            if (this.configTarget) {
                if (this.configTarget.sriov && this.configTarget.sriov.length > 0) {
                    // TODO count PF items only;
                    return true;
                }
            }
            return false;
        };
        VmHwSriovDriver.prototype.switchToSriovAdapterType = function () {
            var network = this.virtualNetworkDevice.getNetwork();
            this._sriovList = this.service.switchToSriovAdapterType(this.device, this.vm, network);
            this._sriovValue = this._sriovList[0];
        };
        VmHwSriovDriver.prototype.isSriovEthernetCard = function () {
            return this.isSriovEthernetCardType(this.device._type);
        };
        Object.defineProperty(VmHwSriovDriver.prototype, "sriovValue", {
            get: function () {
                return this._sriovValue;
            },
            set: function (value) {
                this.service.assignSriovBacking(this.device, value);
                this._sriovValue = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSriovDriver.prototype.sriovList = function () {
            return this._sriovList;
        };
        VmHwSriovDriver.prototype.isNew = function () {
            if (this.virtualNetworkDevice) {
                return this.virtualNetworkDevice.isNew();
            }
            return false;
        };
        VmHwSriovDriver.prototype.getSriovLabelText = function () {
            if (this.isNew()) {
                return "";
            }
            else {
                return this.service.getSriovDeviceText(this.device, this.vm);
            }
        };
        VmHwSriovDriver.prototype.reservationIssue = function () {
            if (!this.vm) {
                return false;
            }
            var config = this.vm.config;
            var memoryMB = config.hardware.memoryMB;
            var reservation = config.memoryAllocation ? config.memoryAllocation.reservation : 0;
            if (memoryMB > reservation) {
                return true;
            }
            return false;
        };
        Object.defineProperty(VmHwSriovDriver.prototype, "allowMtuChange", {
            get: function () {
                if (!this.device) {
                    return false;
                }
                return this.device.allowGuestOSMtuChange;
            },
            set: function (value) {
                if (!this.device) {
                    return;
                }
                this.device.allowGuestOSMtuChange = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSriovDriver.prototype.isAllowMtuChangeEditable = function () {
            if (this.isNew()) {
                return true;
            }
            return this.service.isAllowMtuChangeEditable(this.vm, this.workflow);
        };
        return VmHwSriovDriver;
    }());
    h5_vm.VmHwSriovDriver = VmHwSriovDriver;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var NetworkInfo = com.vmware.vim.binding.vim.vm.NetworkInfo;
    var ManagedObjectReference = com.vmware.vim.binding.vmodl.ManagedObjectReference;
    var VmHwSriovFixture = (function () {
        function VmHwSriovFixture() {
        }
        VmHwSriovFixture.prototype.getSriovInfo = function () {
            return VmHwSriovFixture.makeSriovInfo();
        };
        VmHwSriovFixture.prototype.getMultipleSriovInfo = function () {
            var info = [{
                    "_type": "com.vmware.vim.binding.vim.vm.SriovInfo",
                    "name": "",
                    "configurationTag": [],
                    "pciDevice": {
                        "_type": "com.vmware.vim.binding.vim.host.PciDevice",
                        "id": "0000:04:00.0",
                        "classId": 512,
                        "bus": 4,
                        "slot": 0,
                        "physicalSlot": 0,
                        "slotDescription": "",
                        "function": 0,
                        "vendorId": -32634,
                        "subVendorId": -32634,
                        "vendorName": "Intel Corporation",
                        "deviceId": 5404,
                        "subDeviceId": -24516,
                        "parentBridge": "0000:00:07.0",
                        "deviceName": "82599EB 10 Gigabit TN Network Connection"
                    },
                    "systemId": "5b74bbaa-3542-aa1c-57c1-180373f2fec5",
                    "virtualFunction": false,
                    "pnic": "vmnic4",
                    "devicePool": {
                        "_type": "com.vmware.vim.binding.vim.vm.SriovNetworkDevicePoolInfo",
                        "key": "5295db74-7343-6f96-d123-59974c659348",
                        "switchKey": "",
                        "switchUuid": "50 29 20 56 ec 99 0d 18-eb a1 ba b3 0a e1 06 cd"
                    }
                }, {
                    "_type": "com.vmware.vim.binding.vim.vm.SriovInfo",
                    "name": "",
                    "configurationTag": [],
                    "pciDevice": {
                        "_type": "com.vmware.vim.binding.vim.host.PciDevice",
                        "id": "0000:05:00.0",
                        "classId": 512,
                        "bus": 4,
                        "slot": 0,
                        "physicalSlot": 0,
                        "slotDescription": "",
                        "function": 0,
                        "vendorId": -32634,
                        "subVendorId": -32634,
                        "vendorName": "Intel Corporation",
                        "deviceId": 5404,
                        "subDeviceId": -24516,
                        "parentBridge": "0000:00:07.0",
                        "deviceName": "82599EB 10 Gigabit TN Network Connection"
                    },
                    "systemId": "5b74bbaa-3542-aa1c-57c1-180373f2fec5",
                    "virtualFunction": true,
                    "pnic": "vmnic5",
                    "devicePool": {
                        "_type": "com.vmware.vim.binding.vim.vm.SriovNetworkDevicePoolInfo",
                        "key": "5295db74-7343-6f96-d123-59974c659348",
                        "switchKey": "",
                        "switchUuid": "50 29 20 56 ec 99 0d 18-eb a1 ba b3 0a e1 06 cd"
                    }
                }, {
                    "_type": "com.vmware.vim.binding.vim.vm.SriovInfo",
                    "name": "",
                    "configurationTag": [],
                    "pciDevice": {
                        "_type": "com.vmware.vim.binding.vim.host.PciDevice",
                        "id": "0000:06:00.0",
                        "classId": 512,
                        "bus": 4,
                        "slot": 0,
                        "physicalSlot": 0,
                        "slotDescription": "",
                        "function": 0,
                        "vendorId": -32634,
                        "subVendorId": -32634,
                        "vendorName": "Intel Corporation",
                        "deviceId": 5404,
                        "subDeviceId": -24516,
                        "parentBridge": "0000:00:07.0",
                        "deviceName": "82599EB 10 Gigabit TN Network Connection"
                    },
                    "systemId": "5b74bbaa-3542-aa1c-57c1-180373f2fec5",
                    "virtualFunction": false,
                    "pnic": "vmnic6",
                    "devicePool": {
                        "_type": "com.vmware.vim.binding.vim.vm.SriovNetworkDevicePoolInfo",
                        "key": "5295db74-7343-6f96-d123-59974c659348",
                        "switchKey": "5295db74-7343-6f96-d123-59974c659348",
                        "switchUuid": ""
                    }
                }];
            return info;
        };
        VmHwSriovFixture.makeSriovInfo = function () {
            var info = {
                "_type": "com.vmware.vim.binding.vim.vm.SriovInfo",
                "name": "",
                "configurationTag": [],
                "pciDevice": {
                    "_type": "com.vmware.vim.binding.vim.host.PciDevice",
                    "id": "0000:04:00.0",
                    "classId": 512,
                    "bus": 4,
                    "slot": 0,
                    "physicalSlot": 0,
                    "slotDescription": "",
                    "function": 0,
                    "vendorId": -32634,
                    "subVendorId": -32634,
                    "vendorName": "Intel Corporation",
                    "deviceId": 5404,
                    "subDeviceId": -24516,
                    "parentBridge": "0000:00:07.0",
                    "deviceName": "82599EB 10 Gigabit TN Network Connection"
                },
                "systemId": "5b74bbaa-3542-aa1c-57c1-180373f2fec5",
                "virtualFunction": false,
                "pnic": "vmnic4",
                "devicePool": {
                    "_type": "com.vmware.vim.binding.vim.vm.SriovNetworkDevicePoolInfo",
                    "key": "5295db74-7343-6f96-d123-59974c659348",
                    "switchKey": "",
                    "switchUuid": "50 29 20 56 ec 99 0d 18-eb a1 ba b3 0a e1 06 cd"
                }
            };
            return info;
        };
        VmHwSriovFixture.prototype.fixContext = function () {
            var vm = { environment: { configTarget: { sriov: [this.getSriovInfo()] } } };
            vm.config = {
                hardware: { memoryMB: 100 },
                memoryAllocation: { reservation: 0 }
            };
            return vm;
        };
        VmHwSriovFixture.prototype.makeNetworkInfo = function () {
            var network = new NetworkInfo();
            network.vswitch = "vswitch-1";
            network.network = { network: new ManagedObjectReference() };
            return network;
        };
        VmHwSriovFixture.addSriov = function (vm) {
            vm.environment.configTarget.sriov = [VmHwSriovFixture.makeSriovInfo()];
        };
        return VmHwSriovFixture;
    }());
    h5_vm.VmHwSriovFixture = VmHwSriovFixture;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var SriovInfo = com.vmware.vim.binding.vim.vm.SriovInfo;
    var VirtualSriovEthernetCard$SriovBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSriovEthernetCard$SriovBackingInfo;
    var SriovNetworkDevicePoolInfo = com.vmware.vim.binding.vim.vm.SriovNetworkDevicePoolInfo;
    var DistributedVirtualPortgroupInfo = com.vmware.vim.binding.vim.dvs.DistributedVirtualPortgroupInfo;
    var NetworkInfo = com.vmware.vim.binding.vim.vm.NetworkInfo;
    var PciDevice = com.vmware.vim.binding.vim.host.PciDevice;
    var VmHwSriovService = (function () {
        function VmHwSriovService() {
        }
        VmHwSriovService.prototype.switchToSriovAdapterType = function (device, vm, network) {
            var list = this.getSriovList(vm, network);
            if (!list || list.length === 0) {
                device.sriovBacking = null;
                return [{ pnic: "Unavailable" }];
            }
            var sriovInfo = list[0];
            this.assignSriovBacking(device, sriovInfo);
            device.allowGuestOSMtuChange = false;
            return list;
        };
        /* Populates VirtualSriovEthernetCard.sriovBacking based SriovInfo */
        VmHwSriovService.prototype.assignSriovBacking = function (device, sriovInfo) {
            if (!sriovInfo) {
                delete device.sriovBacking;
                return;
            }
            if (sriovInfo.pciDevice && sriovInfo.pciDevice.deviceName === "auto") {
                device.sriovBacking = null;
                return;
            }
            device.sriovBacking = this.makeSriovBacking(sriovInfo);
        };
        VmHwSriovService.prototype.isAllowMtuChangeEditable = function (vm, workflow) {
            if (h5_vm.VmWorkflowMode.CreateMode === workflow) {
                return true;
            }
            var permissions = h5_vm.VmHardwareUtil.userHasModifyDevicePermission(vm);
            if (h5_vm.VmWorkflowMode.UpdateMode === workflow) {
                if (h5_vm.VmHardwareUtil.isSuspended(vm)) {
                    return false; // not editable
                }
                if (h5_vm.VmHardwareUtil.isPoweredOn(vm)) {
                    return false; // not editable
                }
                return permissions;
            }
            else if (h5_vm.VmWorkflowMode.CloneMode === workflow) {
                return permissions;
            }
            return true;
        };
        VmHwSriovService.prototype.makeSriovBacking = function (sriovInfo) {
            var pciBacking = h5_vm.PciDeviceService.info2backing(sriovInfo);
            var sriovBacking = new VirtualSriovEthernetCard$SriovBackingInfo();
            sriovBacking.physicalFunctionBacking = pciBacking;
            return sriovBacking;
        };
        VmHwSriovService.prototype.getSriovList = function (vm, networkInfo) {
            var sriov = vm.environment.configTarget.sriov;
            var retVal = this.getSriovPF(sriov);
            if (this.sriovPoolConfigured(networkInfo, sriov)) {
                retVal.unshift(this.makeAutoimatic());
            }
            return retVal;
        };
        VmHwSriovService.prototype.makeAutoimatic = function () {
            var auto = new SriovInfo();
            auto.pnic = "Automatic"; //TODO i18n
            auto.pciDevice = new PciDevice();
            auto.pciDevice.deviceName = "auto";
            auto.label = "Automatic";
            return auto;
        };
        VmHwSriovService.prototype.sriovPoolConfigured = function (networkInfo, array) {
            if (!array || !networkInfo) {
                return false;
            }
            var VMODL_VM_STD_INFO = new NetworkInfo()._type;
            var VMODL_VM_DPORT_INFO = new DistributedVirtualPortgroupInfo()._type;
            var nwType = networkInfo._type;
            var pools = this.getSriovNetworkDevicePools(array);
            if (nwType === VMODL_VM_STD_INFO) {
                return this.IsStdSwtichOnPool(networkInfo, pools);
            }
            else if (nwType === VMODL_VM_DPORT_INFO) {
                return this.isDvsSriovPool(networkInfo, pools);
            }
            return false; // e.g. NSX
        };
        VmHwSriovService.prototype.getSriovNetworkDevicePools = function (array) {
            if (!array) {
                return [];
            }
            var retVal = [];
            // SriovInfo could be associated to multiple devices (device pool)
            // DevicePool comes in two flavours - plain pool and network-related pool
            // We are interested in network-related pools to check if
            // currently see if selected network has pool association to allow automatic device from that pool.
            var NETWORK_POOL = new SriovNetworkDevicePoolInfo()._type;
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                if (item.virtualFunction || !item.devicePool) {
                    continue;
                }
                var type = item.devicePool._type;
                if (type !== NETWORK_POOL) {
                    continue;
                }
                retVal.push(item.devicePool);
            }
            return retVal;
        };
        VmHwSriovService.prototype.IsStdSwtichOnPool = function (info, array) {
            if (!array || !info) {
                return false;
            }
            var switchKey = info.vswitch;
            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
                var item = array_2[_i];
                if (!item.switchKey) {
                    continue;
                }
                if (switchKey === item.switchKey) {
                    return true;
                }
            }
            return false;
        };
        VmHwSriovService.prototype.isDvsSriovPool = function (info, array) {
            if (!array || !info) {
                return false;
            }
            var switchUuid = info.switchUuid;
            for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
                var item = array_3[_i];
                if (switchUuid === item.switchUuid) {
                    return true;
                }
            }
            return false;
        };
        VmHwSriovService.prototype.getSriovPF = function (input) {
            if (!input) {
                return [];
            }
            var output = [];
            for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
                var item = input_1[_i];
                if (item && (false === item.virtualFunction)) {
                    output.push(item);
                    var label = item.pnic + " " + this.info2text(item);
                    item.label = label;
                }
            }
            return output;
        };
        VmHwSriovService.prototype.getSriovDeviceText = function (device, vm) {
            if (!device) {
                return "";
            }
            var backing = device.sriovBacking;
            if (!backing) {
                return "";
            }
            var pfBacking = backing.physicalFunctionBacking;
            if (!pfBacking) {
                return "";
            }
            var sriov = vm.environment.configTarget.sriov;
            var retVal = this.getPfBackingText(pfBacking, sriov);
            return retVal;
        };
        /** Finds the device's matching SriovInfo */
        VmHwSriovService.prototype.getSriovInfo = function (device, sriov) {
            if (!device) {
                return null;
            }
            var backing = device.sriovBacking;
            if (!backing) {
                // if the sriov backing is not set, and there is automatic sriovInfo select that
                var autoSriov = _.find(sriov, function (sriovInfo) {
                    return sriovInfo.pnic === "Automatic";
                });
                return autoSriov ? autoSriov : null;
            }
            var pfBacking = backing.physicalFunctionBacking;
            if (!pfBacking) {
                return null;
            }
            var info = this.findSriovInfo(pfBacking, sriov);
            return info;
        };
        /** Finds matching PCI device in boxed array and formats display label, resets label to empty string if no match */
        VmHwSriovService.prototype.getPfBackingText = function (backing, input) {
            if (!backing) {
                return "";
            }
            var info = this.findSriovInfo(backing, input);
            if (!info) {
                return backing.id; // 'bus:slot.function
            }
            var retVal = this.info2text(info);
            return retVal;
        };
        VmHwSriovService.prototype.findSriovInfo = function (pci, array) {
            if (!pci || !pci.id || !array) {
                return null;
            }
            var pciDevice_id = pci.id;
            for (var _i = 0, array_4 = array; _i < array_4.length; _i++) {
                var info = array_4[_i];
                if (info && info.pciDevice.id === pciDevice_id) {
                    return info;
                }
            }
            return null;
        };
        VmHwSriovService.prototype.info2text = function (item) {
            var info = item;
            if (!info) {
                return "";
            }
            var id = info.pciDevice.id;
            var vendor = info.pciDevice.vendorName;
            var name = info.pciDevice.deviceName;
            var retVal = id + " | " + name + " " + vendor;
            return retVal;
        };
        return VmHwSriovService;
    }());
    h5_vm.VmHwSriovService = VmHwSriovService;
})(h5_vm || (h5_vm = {}));
angular.module("com.vmware.vsphere.client.vm").service("VmHardwareNetworkSriovService", h5_vm.VmHwSriovService);



var h5_vm;
(function (h5_vm) {
    var PmemUtilService = h5_vm.PmemUtilService;
    var VmHardwareNvdimmController = (function () {
        function VmHardwareNvdimmController() {
            this.bindings = {
                nvdimmControllerDevice: "<",
                removeCallback: "&",
                vmConfigContext: "<",
                vmWorkflow: "<",
                virtualMachineDevices: "<",
                selectedGuestOs: "<"
            };
            this.controller = VmHardwareNvdimmControllerController;
            this.templateUrl =
                "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareNvdimmController/vm-hardware-nvdimm-controller.component.html";
        }
        return VmHardwareNvdimmController;
    }());
    h5_vm.VmHardwareNvdimmController = VmHardwareNvdimmController;
    var VmHardwareNvdimmControllerController = (function () {
        function VmHardwareNvdimmControllerController(i18nService, virtualNvdimmService, pmemUtilService, pmemCapacityService, $scope) {
            this.i18nService = i18nService;
            this.virtualNvdimmService = virtualNvdimmService;
            this.pmemUtilService = pmemUtilService;
            this.pmemCapacityService = pmemCapacityService;
            this.$scope = $scope;
            this.deviceName = this.nvdimmControllerDevice
                .getCurrentDevice().deviceInfo.label;
            this.isRemoveDisabled = this.virtualNvdimmService.isControllerRemoveDisabled(this.vmConfigContext, this.virtualMachineDevices, this.vmWorkflow);
        }
        VmHardwareNvdimmControllerController.prototype.$onInit = function () {
            var _this = this;
            this.listenerDeregistrationFuction = this.$scope.$on(this.virtualNvdimmService.NVDIMM_REMOVED, function (event) {
                _this.isRemoveDisabled = _this.virtualNvdimmService.isControllerRemoveDisabled(_this.vmConfigContext, _this.virtualMachineDevices, _this.vmWorkflow);
                // When the removal is disabled then there are non-removed NVDIMMs
                // revert the removal of this controller to preserve the NVDIMMs operational.
                if (_this.isRemoveDisabled
                    && _this.nvdimmControllerDevice.isMarkedForRemoval()) {
                    _this.revertNvdimmControllerRemoval();
                }
            });
        };
        VmHardwareNvdimmControllerController.prototype.$onDestroy = function () {
            if (this.listenerDeregistrationFuction) {
                this.listenerDeregistrationFuction();
            }
        };
        VmHardwareNvdimmControllerController.prototype.removeNvdimmController = function () {
            if (!this.isRemoveDisabled && this.removeCallback) {
                this.removeCallback()(this.nvdimmControllerDevice);
            }
        };
        VmHardwareNvdimmControllerController.prototype.revertNvdimmControllerRemoval = function () {
            this.nvdimmControllerDevice.revertRemoval();
        };
        VmHardwareNvdimmControllerController.prototype.getAvailablePmemCapacity = function () {
            return this.pmemUtilService.getAvailablePmemCapacity(this.vmConfigContext);
        };
        VmHardwareNvdimmControllerController.prototype.getNvDimmDeviceSummary = function () {
            var nvDimmDevices = this.virtualMachineDevices
                .devicesOfTypeNotMarkedForRemoval(PmemUtilService.NVDIMM);
            var totalNvdimmMemoryInMB = this.pmemCapacityService
                .getTotalNvdimmMemory(this.virtualMachineDevices);
            return this.i18nService.getString("VmUi", "NVDIMM.totalNVDIMMs", nvDimmDevices.length, totalNvdimmMemoryInMB);
        };
        VmHardwareNvdimmControllerController.prototype.getSupportedPmemByGuestOs = function () {
            return this.pmemUtilService.getSupportedPmemByGuestOs(this.selectedGuestOs);
        };
        VmHardwareNvdimmControllerController.prototype.i18n = function (key, param, bundle) {
            if (param === void 0) { param = ""; }
            if (bundle === void 0) { bundle = "VmUi"; }
            return this.i18nService.getString(bundle, key, param);
        };
        VmHardwareNvdimmControllerController.$inject = [
            "i18nService",
            "virtualNvdimmService",
            "pmemUtilService",
            "pmemCapacityService",
            "$scope"
        ];
        return VmHardwareNvdimmControllerController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareNvdimmController", new VmHardwareNvdimmController());
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareOther', ['i18nService', function(i18nService) {
   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareOther/vmHardwareOther.html',
      controllerAs: 'vmHardwareOtherCtrl',

      controller: function() {

         this.getSummaryText = function(inflatedDevice, type) {
            var device = inflatedDevice.getCurrentDevice();
            var summary = device.deviceInfo.summary;
            var label = device.deviceInfo.label;
            var deviceType = device._type;
            if (deviceType === 'com.vmware.vim.binding.vim.vm.device.VirtualKeyboard' ||
               deviceType === 'com.vmware.vim.binding.vim.vm.device.VirtualPointingDevice') {
               return label;
            } else if (type === 'InputDevice') {
               return summary;
            } else {
               return (summary === label) ? summary : label + ' (' + summary + ')';
            }
         };
      },

      link: function(scope) {
         scope.i18n = i18nService.getString;
      }
   };
}])
   .filter("deviceTypeFilter", function() {
      return function(value, type) {

         return value.filter( function(o) {
            return !o.isOfType(type);
         });

      };
   });

var h5_vm;
(function (h5_vm) {
    var VirtualPCIPassthrough = com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough;
    var VirtualPCIPassthrough$VmiopBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough$VmiopBackingInfo;
    var VirtualPCIPassthrough$DeviceBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough$DeviceBackingInfo;
    var PciDeviceService = (function () {
        function PciDeviceService(deviceService, i18nService, deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
            this.deviceService = deviceService;
            this.i18nService = i18nService;
            this.deviceDiffService = deviceDiffService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        PciDeviceService.prototype.createPciDevice = function (env, virtualMachineDevices) {
            var target = env.configTarget;
            var deviceOptions = env.configOption.hardwareOptions.virtualDeviceOption;
            var powerState = env.powerState;
            var device = new VirtualPCIPassthrough();
            // (1) check if device supported for this VM version. Minimum is VM version 7 (ESX 4.0)
            var pciOption = _.find(deviceOptions, function (item) {
                return item.type.name === device._type;
            });
            if (!pciOption) {
                // VM version 4 does not support VirtualPCIPassthrough, throw exception to show error
                throw this.newErrorDeviceNotSupported();
            }
            var controllerOption = _.find(deviceOptions, function (item) {
                return item.type.wsdlName === "VirtualPCIController";
            });
            // (2) ensure maximum not reached based on controller limit
            var max = 16; // safe limit in case controller option is missing
            if (controllerOption && controllerOption.numPCIPassthroughDevices) {
                // real limit - 16 since HWv11 (ESX 6.0), 6 before that
                // https://kb.vmware.com/s/article/2051652
                max = controllerOption.numPCIPassthroughDevices.max;
            }
            var count = virtualMachineDevices.findDevicesOfType("VirtualPCIPassthrough").length;
            if (count >= max) {
                throw this.newErrorDeviceLimitReached();
            }
            // (3) check if any pciPassthrough devices present
            if (!target || !target.pciPassthrough || target.pciPassthrough.length === 0) {
                throw this.newErrorNoPCIDevices();
            }
            // (4) check if hot add supported (via pciOption.plugAndPlay)
            if (powerState === "poweredOn" && !pciOption.plugAndPlay) {
                throw this.newErrorHotAddNotSupported();
            }
            // (5) Configure backing and complete device creation
            device.backing = PciDeviceService.info2backing(target.pciPassthrough[0]);
            device.key = this.deviceService.newKey();
            var editable = new h5_vm.VmHwPciDevice(device, this.deviceDiffService, this.vmDeviceInfoService, this.vmHardwareUtil);
            this.deviceService.setDeviceInfo(editable);
            return {
                device: editable
            };
        };
        PciDeviceService.prototype.createPciSharedDevice = function (env, virtualMachineDevices) {
            var target = env.configTarget;
            var deviceOptions = env.configOption.hardwareOptions.virtualDeviceOption;
            var powerState = env.powerState;
            // (1) check if device option is here
            var pciOption = _.find(deviceOptions, function (item) {
                return item.type.wsdlName === "VirtualPCIPassthrough";
            });
            if (!pciOption) {
                // VM version 4 does not support ANY PCI passthrough (both device backed and shared GPU)
                throw this.newErrorDeviceNotSupported();
            }
            // (2) check if vmiop device backing type supported
            var max = this.getVmiopMaxInstances(pciOption);
            if (max <= 0) {
                // VM version 11+ required
                throw this.newErrorDeviceNotSupported();
            }
            // (3) Check if over limit of vmiop devices with
            var allDevices = virtualMachineDevices.findDevicesOfType("VirtualPCIPassthrough");
            var count = this.countVmiopBacking(allDevices);
            if (count >= max) {
                throw this.newErrorDeviceLimitReached();
            }
            // (4) For running vm check if hot add supported (via pciOption.plugAndPlay)
            if (powerState === "poweredOn" && !pciOption.plugAndPlay) {
                throw this.newErrorHotAddNotSupported();
            }
            if (powerState === "suspended") {
                this.newErrorHotAddNotSupported();
            }
            var device = new VirtualPCIPassthrough();
            var backing = new VirtualPCIPassthrough$VmiopBackingInfo();
            var vgpuList = target.sharedGpuPassthroughTypes;
            backing.vgpu = (vgpuList && vgpuList.length > 0) ? vgpuList[0].vgpu : "";
            device.backing = backing;
            device.key = this.deviceService.newKey();
            var editable = new h5_vm.VmHwPciDevice(device, this.deviceDiffService, this.vmDeviceInfoService, this.vmHardwareUtil);
            this.deviceService.setDeviceInfo(editable);
            return {
                device: editable
            };
        };
        PciDeviceService.prototype.countVmiopBacking = function (array) {
            var retVal = 0;
            try {
                for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                    var item = array_1[_i];
                    if (item && item.isSharedPCIBackingType()) {
                        retVal++;
                    }
                    else {
                        continue;
                    }
                }
            }
            catch (e) {
            }
            return retVal;
        };
        PciDeviceService.prototype.newErrorDeviceLimitReached = function () {
            return new Error(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceLimitReached"));
        };
        PciDeviceService.prototype.newErrorDeviceNotSupported = function () {
            return new Error(this.i18nService.getString("VmUi", "VmDeviceManager.DeviceNotSupported"));
        };
        PciDeviceService.prototype.newErrorNoPCIDevices = function () {
            return new Error(this.i18nService.getString("VmUi", "VmDeviceManager.NoPCIDevices"));
        };
        PciDeviceService.prototype.newErrorHotAddNotSupported = function () {
            return this.newError(this.i18nService.getString, "HotAddNotSupported");
        };
        PciDeviceService.prototype.newError = function (i18n, key) {
            var msg = i18n("VmUi", "VmDeviceManager." + key);
            var retVal = new Error(msg);
            return retVal;
        };
        /** Either updates backing (if not null) or creates and return new one after copying over all ids*/
        PciDeviceService.info2backing = function (info, backing) {
            if (backing === void 0) { backing = null; }
            if (backing === null) {
                backing = new VirtualPCIPassthrough$DeviceBackingInfo();
            }
            if (info === null) {
                return backing;
            }
            backing.systemId = info.systemId;
            backing.deviceName = info.pciDevice.deviceName;
            backing.deviceId = info.pciDevice.deviceId.toString(16);
            backing.id = info.pciDevice.id;
            backing.vendorId = info.pciDevice.vendorId;
            return backing;
        };
        PciDeviceService.prototype.getVmiopMaxInstances = function (option) {
            var VMIOP_TYPE = "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthroughOption$VmiopBackingOption";
            if (!option) {
                return 0;
            }
            var array = option.backingOption;
            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
                var item = array_2[_i];
                var itemType = item._type;
                if (VMIOP_TYPE === itemType) {
                    var backingOption = item; // as VirtualPCIPassthroughOption$VmiopBackingOption;
                    if (backingOption.maxInstances) {
                        return backingOption.maxInstances;
                    }
                    else {
                        return 0;
                    }
                }
            }
            return 0;
        };
        PciDeviceService.$inject = ["deviceService", "i18nService", "deviceDiffService", "vmDeviceInfoService", "vmHardwareUtil"];
        return PciDeviceService;
    }());
    h5_vm.PciDeviceService = PciDeviceService;
    angular.module("com.vmware.vsphere.client.vm").service("pciSharedService", PciDeviceService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHwPciDeviceController = (function () {
        function VmHwPciDeviceController(i18nService) {
            this.i18nService = i18nService;
        }
        VmHwPciDeviceController.prototype.$onDestroy = function () {
            if (this.inflatedDevice) {
                this.inflatedDevice.cleanup();
            }
            this.inflatedDevice = null;
        };
        VmHwPciDeviceController.prototype.$onInit = function () {
            if (this.inflatedDevice) {
                this.deviceLabel = this.inflatedDevice.deviceLabel();
            }
            else {
                this.deviceLabel = "";
            }
        };
        VmHwPciDeviceController.prototype.i18n = function (key) {
            if (!this.i18nService) {
                return "";
            }
            var retVal = this.i18nService.getString("VmUi", "PciDevicePage." + key);
            return retVal;
        };
        VmHwPciDeviceController.prototype.removeDevice = function () {
            if (!this.inflatedDevice) {
                return;
            }
            if (!this.inflatedDevice.canRemove()) {
                return;
            }
            this.inflatedDevice.removeDevice();
        };
        VmHwPciDeviceController.prototype.revertRemoval = function () {
            if (this.inflatedDevice) {
                this.inflatedDevice.revertRemoval();
            }
        };
        VmHwPciDeviceController.prototype.isMarkedForRemoval = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            return this.inflatedDevice.isMarkedForRemoval();
        };
        VmHwPciDeviceController.prototype.isRemoveDisabled = function () {
            if (!this.inflatedDevice) {
                return true;
            }
            return !this.inflatedDevice.canRemove();
        };
        VmHwPciDeviceController.prototype.deviceList = function () {
            if (!this.inflatedDevice) {
                return [];
            }
            try {
                var retVal = this.inflatedDevice.deviceList();
                return retVal;
            }
            catch (err) {
                return [];
            }
        };
        Object.defineProperty(VmHwPciDeviceController.prototype, "deviceValue", {
            get: function () {
                if (!this.inflatedDevice) {
                    return null;
                }
                return this.inflatedDevice.deviceValue;
            },
            set: function (value) {
                if (!this.inflatedDevice) {
                    return;
                }
                this.inflatedDevice.deviceValue = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwPciDeviceController.prototype.isEditDeviceValueDisabled = function () {
            if (!this.inflatedDevice) {
                return true;
            }
            var retVal = this.inflatedDevice.deviceValue_isReadonly();
            return retVal;
        };
        VmHwPciDeviceController.prototype.showMemorySection = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            var retVal = this.inflatedDevice.memoryUnderReserved();
            return retVal;
        };
        VmHwPciDeviceController.prototype.showDeviceWarning = function () {
            return this.showMemorySection();
        };
        VmHwPciDeviceController.prototype.reserveAllMemory = function (ev) {
            if (!this.inflatedDevice) {
                return;
            }
            this.inflatedDevice.reserveAllMemory();
        };
        VmHwPciDeviceController.$inject = ["i18nService"];
        return VmHwPciDeviceController;
    }());
    h5_vm.VmHwPciDeviceController = VmHwPciDeviceController;
    var VmHwPciDeviceComponent = (function () {
        function VmHwPciDeviceComponent(bindings, controller, templateUrl) {
            if (bindings === void 0) { bindings = { inflatedDevice: '<' }; }
            if (controller === void 0) { controller = VmHwPciDeviceController; }
            if (templateUrl === void 0) { templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwarePciDevice/vm-hw-pci-device.html'; }
            this.bindings = bindings;
            this.controller = controller;
            this.templateUrl = templateUrl;
        }
        return VmHwPciDeviceComponent;
    }());
    angular.module('com.vmware.vsphere.client.vm').component('vmHwPciDevice', new VmHwPciDeviceComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VmHwPciDevice = (function (_super) {
        __extends(VmHwPciDevice, _super);
        function VmHwPciDevice(original, deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
            _super.call(this, original, deviceDiffService, vmDeviceInfoService, vmHardwareUtil);
            this.target = [];
            this.choice = [];
            this.option = null;
            this._gpuProfileInfoList = [];
            this._sharedGpuList = [];
            this._deviceValue = null;
            this.rawDevice = _super.prototype.getCurrentDevice.call(this);
            this.backing = this.rawDevice.backing;
            this.target = [];
        }
        VmHwPciDevice.prototype.onVmConfigAttached = function () {
            if (this.vm === null) {
                return;
            }
            this.option = this.vm.getPciPassthoughOption();
            this.rawDevice = _super.prototype.getCurrentDevice.call(this);
            this.backing = this.rawDevice.backing;
            this._gpuProfileInfoList = this.vm.getGpuProfileList();
            this.target = this.vm.getPciPassList();
            this.buildSharedGpuList();
            this.choice = this.buildDeviceList();
            this._deviceValue = this.findHostPciDevice();
            return;
        };
        VmHwPciDevice.prototype.buildDeviceList = function () {
            if (this.isSharedPCIBackingType()) {
                return [];
            }
            var list = [];
            if (!this.target) {
                this.target = [];
                return [];
            }
            for (var _i = 0, _a = this.target; _i < _a.length; _i++) {
                var info = _a[_i];
                //let label = info.pciDevice.deviceName;
                var label = this.info2text(info);
                var key = info.pciDevice.id;
                var value = info;
                var item = { label: label, value: value, key: key };
                list.push(item);
            }
            return list;
        };
        // Shared PCI part.
        VmHwPciDevice.prototype.buildSharedGpuList = function () {
            if (!this.isSharedPCIBackingType()) {
                return;
            }
            var currentValue = this.sharedGpuValue;
            var retVal = [];
            if (!this._gpuProfileInfoList) {
                this._gpuProfileInfoList = [];
            }
            for (var _i = 0, _a = this._gpuProfileInfoList; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item) {
                    var vgpu = item.vgpu;
                    retVal.push(vgpu);
                }
            }
            if (retVal.indexOf(currentValue) < 0) {
                retVal.push(currentValue);
            }
            this._sharedGpuList = retVal;
        };
        Object.defineProperty(VmHwPciDevice.prototype, "sharedGpuList", {
            get: function () {
                return this._sharedGpuList;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwPciDevice.prototype, "sharedGpuListIsEmpty", {
            get: function () {
                if (!this._gpuProfileInfoList) {
                    return true;
                }
                if (this._gpuProfileInfoList.length === 0) {
                    return true;
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwPciDevice.prototype, "sharedGpuValue", {
            get: function () {
                var vmiopBacking = this.backing;
                if (!vmiopBacking) {
                    return "";
                }
                return vmiopBacking.vgpu;
            },
            set: function (value) {
                var vmiopBacking = this.backing;
                if (!vmiopBacking) {
                    return;
                }
                vmiopBacking.vgpu = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwPciDevice.prototype.sharedGpuValue_isReadonly = function () {
            if (!this.vm) {
                // optimistically allow editing if somehow missing data
                return false;
            }
            return this.vm.isEditDeviceDisabled();
        };
        VmHwPciDevice.prototype.deviceList = function () {
            var retVal = this.choice;
            return retVal;
        };
        Object.defineProperty(VmHwPciDevice.prototype, "deviceValue", {
            get: function () {
                return this._deviceValue;
            },
            set: function (item) {
                this._deviceValue = item;
                if (item) {
                    h5_vm.PciDeviceService.info2backing(item.value, this.backing);
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHwPciDevice.prototype.deviceValue_isReadonly = function () {
            if (this.isNew()) {
                return false;
            }
            else {
                return true;
            }
        };
        VmHwPciDevice.prototype.findHostPciDevice = function () {
            var pciBacking = this.backing;
            for (var _i = 0, _a = this.choice; _i < _a.length; _i++) {
                var item = _a[_i];
                var info = item.value;
                var deviceId = this.backing.id;
                if (info.pciDevice.id === deviceId) {
                    return item;
                }
            }
            var unavailable = "Unavailable(" + pciBacking.id + ")";
            var retVal = { label: unavailable, value: null, key: -1 };
            this.choice.push(retVal);
            return retVal;
        };
        VmHwPciDevice.prototype.isSharedPCIBackingType = function () {
            var backing = _super.prototype.getCurrentDevice.call(this).backing;
            var type = backing._type;
            if (type && type.toUpperCase().indexOf("VMIOP") > -1) {
                return true;
            }
            else {
                return false;
            }
        };
        VmHwPciDevice.prototype.memoryUnderReserved = function () {
            if (!this.vm) {
                return false;
            }
            var retVal = this.vm.memoryUnderReserved();
            return retVal;
        };
        VmHwPciDevice.prototype.reserveAllMemory = function () {
            if (!this.vm) {
                return;
            }
            this.vm.reserveAllMemory();
        };
        VmHwPciDevice.prototype.canRemove = function () {
            if (!this.vm) {
                return false;
            }
            var retVal = this.vm.canRemoveDevice(this.option);
            return retVal;
        };
        VmHwPciDevice.prototype.info2text = function (item) {
            var info = item;
            if (!info) {
                return "";
            }
            var id = info.pciDevice.id;
            var vendor = info.pciDevice.vendorName;
            var name = info.pciDevice.deviceName;
            var retVal = id + " | " + name + " " + vendor;
            return retVal;
        };
        return VmHwPciDevice;
    }(h5_vm.EditableVirtualDeviceClass));
    h5_vm.VmHwPciDevice = VmHwPciDevice;
    function GetVirtualPCIFactory(deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
        var factoryFn = function (rawDevice) {
            var instance = new VmHwPciDevice(rawDevice, deviceDiffService, vmDeviceInfoService, vmHardwareUtil);
            return instance;
        };
        return factoryFn;
    }
    angular.module('com.vmware.vsphere.client.vm')
        .factory('VirtualPCITs', ['deviceDiffService', 'vmDeviceInfoService', 'vmHardwareUtil', GetVirtualPCIFactory]);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHwPciDeviceSetup = (function () {
        function VmHwPciDeviceSetup() {
        }
        VmHwPciDeviceSetup.setup = function (fixtures, virtualMachineDevicesHelpers, i18nService, vmVersion, powerState, modifyDevice, mode, shared) {
            if (vmVersion === void 0) { vmVersion = 11; }
            if (shared === void 0) { shared = false; }
            var fix = fixtures.vmHardwareConfigData();
            var ctx = fix.vmConfigContext;
            var guest = ctx.environment.configOption.guestOSDescriptor[0];
            var environment = ctx.environment;
            environment.powerState = powerState;
            var privileges = ctx.privileges;
            if (!modifyDevice) {
                privileges = _.without(ctx.privileges, h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE);
            }
            environment.configTarget.pciPassthrough = VmHwPciDeviceSetup.getPciPassthoughFixture();
            var pciDeviceFixture = shared ? VmHwPciDeviceSetup.getPciSharedFixture() : VmHwPciDeviceSetup.getPciDeviceFixture();
            ctx.config.hardware.device.push(pciDeviceFixture);
            var virtualMachineDevices = virtualMachineDevicesHelpers.buildVirtualMachineDevices(ctx);
            var inflatedDevice = virtualMachineDevices.getVirtualDevice(13001);
            var vm = new h5_vm.VmConfig(ctx, guest, privileges, mode, i18nService);
            inflatedDevice.attachVmConfig(vm);
            inflatedDevice.removeCallback = VmHwPciDeviceSetup.removeCallback;
            return inflatedDevice;
        };
        VmHwPciDeviceSetup.removeCallback = function (inflatedDevice) {
            inflatedDevice.markForRemoval();
        };
        VmHwPciDeviceSetup.getPciSharedFixture = function () {
            var retVal = {
                "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough",
                "key": 13001,
                "deviceInfo": {
                    "_type": "com.vmware.vim.binding.vim.Description",
                    "label": "PCI device 0",
                    "summary": "NVIDIA GRID vGPU profile1"
                },
                "backing": {
                    "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough$VmiopBackingInfo",
                    "vgpu": "profile1"
                },
                "connectable": null,
                "slotInfo": null,
                "controllerKey": 100,
                "unitNumber": 18
            };
            return retVal;
        };
        VmHwPciDeviceSetup.getPciDeviceFixture = function () {
            var retVal = {
                "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough",
                "key": 13001,
                "deviceInfo": {
                    "_type": "com.vmware.vim.binding.vim.Description",
                    "label": "PCI device 1",
                    "summary": ""
                },
                "backing": {
                    "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough$DeviceBackingInfo",
                    "deviceName": "",
                    "useAutoDetect": null,
                    "id": "0000:00:1d.1",
                    "deviceId": "3a35",
                    "systemId": "4f881b30-0eab-995c-46a9-e83935aed97e",
                    "vendorId": -32634
                },
                "connectable": null,
                "slotInfo": null,
                "controllerKey": 100,
                "unitNumber": 19
            };
            return retVal;
        };
        VmHwPciDeviceSetup.getPciPassthoughFixture = function () {
            var device1 = {
                _type: "com.vmware.vim.binding.vim.vm.PciPassthroughInfo",
                name: "",
                // "configurationTag": null,
                pciDevice: {
                    _type: "com.vmware.vim.binding.vim.host.PciDevice",
                    id: "0000:00:1d.1",
                    classId: 3075,
                    bus: 0,
                    slot: 29,
                    function: 1,
                    vendorId: -32634,
                    subVendorId: 4156,
                    vendorName: "Intel Corporation",
                    deviceId: 14901,
                    subDeviceId: 13069,
                    // "parentBridge": null,
                    deviceName: "82801JI (ICH10 Family) USB UHCI Controller #2"
                },
                systemId: "4f881b30-0eab-995c-46a9-e83935aed97e"
            };
            var device2 = {
                "_type": "com.vmware.vim.binding.vim.vm.PciPassthroughInfo",
                "name": "",
                // "configurationTag": null,
                "pciDevice": {
                    "_type": "com.vmware.vim.binding.vim.host.PciDevice",
                    "id": "0000:00:1d.2",
                    "classId": 3075,
                    "bus": 0,
                    "slot": 29,
                    "function": 2,
                    "vendorId": -32634,
                    "subVendorId": 4156,
                    "vendorName": "Intel Corporation",
                    "deviceId": 14902,
                    "subDeviceId": 13069,
                    // "parentBridge": null,
                    "deviceName": "82801JI (ICH10 Family) USB UHCI Controller #3"
                },
                "systemId": "4f881b30-0eab-995c-46a9-e83935aed97e"
            };
            var retVal = [];
            retVal.push(device1, device2);
            return retVal;
        };
        VmHwPciDeviceSetup.getPciSharedFixtureOld = function () {
            var retVal = {
                "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough",
                "key": 13001,
                "deviceInfo": {
                    "_type": "com.vmware.vim.binding.vim.Description",
                    "label": "PCI device 0",
                    "summary": "NVIDIA GRID vGPU 1"
                },
                "backing": {
                    "_type": "com.vmware.vim.binding.vim.vm.device.VirtualPCIPassthrough$VmiopBackingInfo",
                    "vgpu": "1"
                },
                "connectable": null,
                "slotInfo": null,
                "controllerKey": 100,
                "unitNumber": 18
            };
            return retVal;
        };
        return VmHwPciDeviceSetup;
    }());
    h5_vm.VmHwPciDeviceSetup = VmHwPciDeviceSetup;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHwPciSharedController = (function () {
        function VmHwPciSharedController(i18nService) {
            this.i18nService = i18nService;
            this.removalDisabled = true;
            this.pciList = [];
        }
        VmHwPciSharedController.prototype.$onInit = function () {
            if (this.inflatedDevice) {
                this.deviceLabel = this.inflatedDevice.deviceLabel();
            }
            else {
                this.deviceLabel = "";
            }
            this.removalDisabled = true;
            // PCI list from Config target not changing.
            // Then we could cache it in onInit.
            // But consider calculating list of available devices,
            // by removing thos already in use (not done in Flex)
            this.pciList = this.inflatedDevice.deviceList();
        };
        VmHwPciSharedController.prototype.i18n = function (key) {
            if (!this.i18nService) {
                return "";
            }
            var retVal = this.i18nService.getString("VmUi", "PciDevicePage." + key);
            return retVal;
        };
        VmHwPciSharedController.prototype.removeDevice = function () {
            if (!this.inflatedDevice) {
                return;
            }
            if (!this.inflatedDevice.canRemove()) {
                return;
            }
            this.inflatedDevice.removeDevice();
        };
        VmHwPciSharedController.prototype.revertRemoval = function () {
            if (this.inflatedDevice) {
                this.inflatedDevice.revertRemoval();
            }
        };
        VmHwPciSharedController.prototype.isMarkedForRemoval = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            return this.inflatedDevice.isMarkedForRemoval();
        };
        VmHwPciSharedController.prototype.isRemoveDisabled = function () {
            if (!this.inflatedDevice) {
                return true;
            }
            var retVal = (this.inflatedDevice.canRemove() === false);
            return retVal;
        };
        Object.defineProperty(VmHwPciSharedController.prototype, "pluginValue", {
            get: function () {
                var retVal = "NVIDIA GRID vGPU";
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwPciSharedController.prototype, "pluginList", {
            get: function () {
                var retVal = ["NVIDIA GRID vGPU"];
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwPciSharedController.prototype, "profileList", {
            get: function () {
                var retVal = this.inflatedDevice.sharedGpuList;
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwPciSharedController.prototype, "profile", {
            get: function () {
                if (!this.inflatedDevice) {
                    return "";
                }
                var retVal = this.inflatedDevice.sharedGpuValue;
                return retVal;
            },
            set: function (value) {
                if (!this.inflatedDevice) {
                    return;
                }
                this.inflatedDevice.sharedGpuValue = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwPciSharedController.prototype.isProfileValueDisabled = function () {
            if (!this.inflatedDevice) {
                return true;
            }
            var retVal = this.inflatedDevice.sharedGpuValue_isReadonly();
            return retVal;
        };
        VmHwPciSharedController.prototype.isProfileInputVisible = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            var retVal = this.inflatedDevice.sharedGpuListIsEmpty;
            return retVal;
        };
        VmHwPciSharedController.prototype.isProfileSelectVisible = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            var retVal = !this.inflatedDevice.sharedGpuListIsEmpty;
            return retVal;
        };
        VmHwPciSharedController.prototype.showMemorySection = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            var retVal = this.inflatedDevice.memoryUnderReserved();
            return retVal;
        };
        VmHwPciSharedController.prototype.showDeviceWarning = function () {
            return this.showMemorySection();
        };
        VmHwPciSharedController.prototype.reserveAllMemory = function (ev) {
            if (!this.inflatedDevice) {
                return;
            }
            this.inflatedDevice.reserveAllMemory();
        };
        VmHwPciSharedController.$inject = ["i18nService"];
        return VmHwPciSharedController;
    }());
    h5_vm.VmHwPciSharedController = VmHwPciSharedController;
    var VmHwPciSharedComponent = (function () {
        function VmHwPciSharedComponent(bindings, controller, templateUrl) {
            if (bindings === void 0) { bindings = { inflatedDevice: '<' }; }
            if (controller === void 0) { controller = VmHwPciSharedController; }
            if (templateUrl === void 0) { templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwarePciDevice/vm-hw-pci-shared.html'; }
            this.bindings = bindings;
            this.controller = controller;
            this.templateUrl = templateUrl;
        }
        return VmHwPciSharedComponent;
    }());
    angular.module('com.vmware.vsphere.client.vm').component('vmHwPciShared', new VmHwPciSharedComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VmDisplayMode = h5_vm.VmDisplayMode;
    var VmStorageProfileMetadata = h5_vm.VmStorageProfileMetadata;
    var VmStorageBrowserMetadata = h5_vm.VmStorageBrowserMetadata;
    var StorageResourceManager$IOAllocationInfo = com.vmware.vim.binding.vim.StorageResourceManager$IOAllocationInfo;
    var SharesInfo = com.vmware.vim.binding.vim.SharesInfo;
    var VmHardwareRdmVirtualDiskCtrl = (function () {
        function VmHardwareRdmVirtualDiskCtrl($q, $rootScope, $scope, $timeout, i18nService, virtualDiskSettingsFormService, storageProfileService, vmHardwareRdmVirtualDiskService, vmHardwareVirtualDiskService, datastoreService, vmDeviceInfoService, defaultUriSchemeUtil, basicDiskUtilService, vmCryptUtilService) {
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.i18nService = i18nService;
            this.virtualDiskSettingsFormService = virtualDiskSettingsFormService;
            this.storageProfileService = storageProfileService;
            this.vmHardwareRdmVirtualDiskService = vmHardwareRdmVirtualDiskService;
            this.vmHardwareVirtualDiskService = vmHardwareVirtualDiskService;
            this.datastoreService = datastoreService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.basicDiskUtilService = basicDiskUtilService;
            this.vmCryptUtilService = vmCryptUtilService;
            this.diskLocationError = false;
            this.isDiskProfileValid = true;
            this.isComponentInitiailized = false;
            this.VIRTUAL_COMPATIBILITY_MODE = "virtualMode";
            this.PHYSICAL_COMPATIBILITY_MODE = "physicalMode";
            this.DELETE_FILE_FROM_DISK_OPERATION = "destroy";
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
            this.subscribeToDeviceEvents();
        }
        VmHardwareRdmVirtualDiskCtrl.prototype.isNewDevice = function () {
            // in clone workflow for some reason this call is done before onInit
            // of the current component is completed, as a result since
            // DiskLocationError is not yet evaluated the vm-hardware-virtual-disk-location
            // component does not show a validation error even there is such. So to
            // prevent this we are waiting this onInit to complete and then to allow
            // the location component to be rendered
            if (!this.isComponentInitiailized) {
                return false;
            }
            return this.inflatedDevice.isNew();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.$onInit = function () {
            var _this = this;
            this.buildSettingsForm().then(function () {
                _this.setStorageProfileMetadata();
                _this.setSharingInfo();
                _this.setLocationBrowserMetadata();
                _this.setSharesInfo();
                _this.setDeviceNodeInfo();
                _this.setCompatibilityMode();
                _this.setDiskMode();
                _this.setIopsLimit();
                _this.setPhysicalLunInfo();
                _this.setDiskFile();
                _this.setFlashCacheInfo();
                _this.setSelectedStorage();
                _this.checkDiskLocationError();
                _this.setupExpandChangeListener();
                _this.deviceLabel = _this.inflatedDevice.getCurrentDevice().deviceInfo.label;
                _this.locationLabel = _this.i18n("DiskPage.Location");
                _this.diskFileLabel = _this.i18n("DiskPage.DiskFile");
                _this.sharingLabel = _this.i18n("DiskPage.Sharing");
                _this.sharesLabel = _this.i18n("DiskPage.Shares");
                _this.revertRemovalLabel = _this.i18n("DiskPage.revertRemoval");
                _this.removeLabel = _this.i18n("DiskPage.remove");
                _this.cacheReservationLabel = _this.i18n("DiskPage.CacheReservation");
                _this.iopsLimitLabel = _this.i18n("DiskPage.LimitIOPs");
                _this.deviceRemovedLabel = _this.i18n("RemoveDevice.DeviceRemoved");
                _this.deleteFilesLabel = _this.i18n("DeviceDeletedControl.DeleteFiles");
                _this.storageProfileLabel = _this.i18n("DiskPage.Profile");
                _this.physicalLunLabel = _this.i18n("DiskPage.PhysicalLUN");
                _this.diskModeLabel = _this.i18n("DiskPage.DiskMode");
                _this.compatibilityModeLabel = _this.i18n("DiskPage.CompatibilityMode");
                _this.deviceNodeLabel = _this.i18n("DiskPage.VirtualDeviceNode");
                _this.isCreateMode = (_this.displayMode === VmDisplayMode.CreateMode);
                _this.diskProfileErrorConfig = {
                    message: _this.i18n('DiskConfig.ErrorCrypt2RDM'),
                    isVisible: false
                };
                if (_this.vmStorageProfileMetadata) {
                    _this.onStorageProfileChange(_this.vmStorageProfileMetadata.selectedProfile);
                }
                else {
                    _this.checkEncryptionWarning();
                }
                _this.isComponentInitiailized = true;
                _this.destroyDisk = _this.inflatedDevice.getDiskFileOperation() ===
                    _this.DELETE_FILE_FROM_DISK_OPERATION;
            });
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.deviceEventCallback = function (event, device) {
            if (!device) {
                return;
            }
            var type = device.deviceType;
            if (device.deviceKey === this.inflatedDevice.getKey()
                && this.inflatedDevice.isNew()) {
                this.$rootScope.$broadcast(this.vmHardwareVirtualDiskService.DISKS_UPDATED);
            }
            if (!this.vmHardwareRdmVirtualDiskService.isDiskController(type)) {
                return;
            }
            this.rebuildControllersDropdown();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.subscribeToDeviceEvents = function () {
            var callback = this.deviceEventCallback.bind(this);
            this.$scope.$on('deviceAdded', callback);
            this.$scope.$on('deviceRemoved', callback);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.rebuildControllersDropdown = function () {
            var devices = this.virtualMachineDevices.getAllDevicesNotMarkedForRemoval();
            var controllers = this.virtualDiskSettingsFormService.buildControllersDropdown(this.inflatedDevice, devices);
            this.settingsForm.controllers = controllers;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.$onChanges = function (changes) {
            if (changes.vmConfigContext && changes.vmConfigContext.currentValue
                && this.vmConfigContext.vmProfile) {
                this.checkEncryptionWarning();
            }
        };
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "shouldDisplayStorageProfile", {
            get: function () {
                return this.expanded && (this.inflatedDevice.isNew()
                    || this.vmWorkflowMode === VmWorkflowMode.UpdateMode);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "shouldDisplayPhysicalLun", {
            get: function () {
                return this.expanded && !!(this.physicalLunInfo && this.physicalLunInfo.name);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "shouldDisplayCompatibilityMode", {
            get: function () {
                return this.expanded && !this.inflatedDevice.isCreatedFromExistingDisk();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "shouldDisplayDiskMode", {
            get: function () {
                return this.expanded &&
                    this.inflatedDevice.getCurrentDevice().backing.compatibilityMode === this.VIRTUAL_COMPATIBILITY_MODE;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "shouldDisplayFlashCache", {
            get: function () {
                return this.expanded && this.flashCacheInfo && this.flashCacheInfo.vFlashSupportedOnHost;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "isCompatibilityModeEditable", {
            get: function () {
                return this.inflatedDevice.isNew();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHardwareRdmVirtualDiskCtrl.prototype, "isFlashCacheReservationDisabled", {
            get: function () {
                return this.inflatedDevice.getCurrentDevice().backing.compatibilityMode === this.PHYSICAL_COMPATIBILITY_MODE
                    || this.vmHardwareRdmVirtualDiskService.isEditFlashReadCacheDisabled(this.vmConfigContext.privileges, this.isNewDevice());
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareRdmVirtualDiskCtrl.prototype.isEditIopsLimitDisabled = function () {
            return this.isSharesDisabled();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isSharesDisabled = function () {
            return this.vmHardwareRdmVirtualDiskService.isSharesOrLimitDisabled(this.vmConfigContext.privileges, this.isNewDevice());
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isEncryptionProfileApplied = function () {
            return this.inflatedDevice.isEncryptionProfileApplied();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onLocationChange = function (selectedStorageProfile, selectedStorageItem) {
            this.updateSelectedProfile(selectedStorageProfile);
            this.inflatedDevice.updateFileName("[" + selectedStorageItem.name + "]");
            this.inflatedDevice.updateDiskProfile(selectedStorageProfile);
            this.setStorageForDisk({
                storageInfo: selectedStorageItem,
                device: this.inflatedDevice.getCurrentDevice()
            });
            this.inflatedDevice.updateDatastoreMor(selectedStorageItem.storageObject.storageRef);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onDiskDistroyStatusChange = function () {
            this.vmHardwareRdmVirtualDiskService.onDiskDistroyStatusChange(this.destroyDisk, this.inflatedDevice);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isRemoveDisabled = function () {
            if (this.vmWorkflowMode === VmWorkflowMode.UpdateMode) {
                return this.vmHardwareRdmVirtualDiskService.isRemoveRdmDiskDisabled(this.vmConfigContext.privileges);
            }
            return false;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onRemove = function () {
            if (!this.isRemoveDisabled() && this.removeCallback) {
                this.removeCallback()(this.inflatedDevice);
            }
        };
        ;
        VmHardwareRdmVirtualDiskCtrl.prototype.markedForRemoval = function () {
            return this.inflatedDevice.isMarkedForRemoval();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.revertRemoval = function () {
            this.inflatedDevice.revertRemoval();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.errorMessages = function () {
            return {};
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.validators = function () {
            return [
                {
                    name: "non-zero",
                    validate: function (value) { return value !== 0; },
                    message: this.i18n("DiskConfig.ErrorCapacityZero")
                }
            ];
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.hasError = function () {
            var formName = this.getFormName();
            if (!_.isEmpty(this[formName])) {
                this.updateLocationValidity(formName);
                return this[formName].$invalid;
            }
            return false;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.expandedChanged = function (expanded) {
            if (this.expanded === expanded) {
                return;
            }
            this.expanded = expanded;
            if (this.expanded && this.isGroupingHardDisks) {
                //broadcast to all the other hard disks
                this.$rootScope.$broadcast(this.vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, {
                    deviceKey: this.inflatedDevice.getKey()
                });
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setupExpandChangeListener = function () {
            var _this = this;
            this.$rootScope.$on(this.vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, function (event, key) {
                if (_this.inflatedDevice.getKey() === key.deviceKey) {
                    //nothing to do, just return
                    return;
                }
                _this.expanded = false;
            });
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.updateLocationValidity = function (formName) {
            this[formName].$setValidity('disk-location', !this.diskLocationError);
            this.updateFormValidity(this[formName]);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isVmPoweredOn = function () {
            return this.vmHardwareRdmVirtualDiskService.isPoweredOn(this.vmConfigContext);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isDiskModeDisabled = function () {
            return this.vmHardwareRdmVirtualDiskService
                .isDiskModeDisabled(this.inflatedDevice, this.vmWorkflowMode, this.vmConfigContext);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.getFormName = function () {
            this.formKey = this.inflatedDevice.getKey().toString().replace("-", "__");
            return "vmHardwareRdmVirtualDisk" + this.formKey;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onCompatibilityModeChange = function (compatiblityModeOption) {
            this.inflatedDevice.updateCompatibilityMode(compatiblityModeOption);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onStorageProfileChange = function (selectedProfile) {
            this.updateSelectedProfile(selectedProfile);
            this.inflatedDevice.updateDiskProfile(selectedProfile);
            this.checkEncryptionWarning();
            this.$rootScope.$broadcast(this.vmHardwareVirtualDiskService.DISKS_UPDATED);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onSharingChange = function (sharing) {
            this.inflatedDevice.updateSharing(sharing.value);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onFlashCacheReservationChange = function (reservationInMB) {
            this.inflatedDevice.updateFlashCacheReservation(reservationInMB);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.ensureIOAllocation = function () {
            var disk = this.inflatedDevice.getCurrentDevice();
            if (!disk.storageIOAllocation) {
                disk.storageIOAllocation = new StorageResourceManager$IOAllocationInfo();
            }
            if (!disk.storageIOAllocation.shares) {
                disk.storageIOAllocation.shares = new SharesInfo();
            }
            return;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onSharesChange = function (shares) {
            this.ensureIOAllocation();
            this.inflatedDevice.updateShares(shares);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onIopsLimitChange = function (limit) {
            this.ensureIOAllocation();
            this.inflatedDevice.updateStorageIOAllocation(limit);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onDiskControllerChange = function (selectedController, selectedControllerNode) {
            if (selectedControllerNode) {
                this.inflatedDevice.updateControllerAndNodeKeys(selectedController.getKey(), selectedControllerNode.key);
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.onDiskModeChange = function (diskMode) {
            this.inflatedDevice.updateDiskMode(diskMode);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.hasChanged = function () {
            return this.inflatedDevice.hasChanged();
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setFlashCacheInfo = function () {
            this.flashCacheInfo = this.vmHardwareRdmVirtualDiskService.getFlashCacheReservationInfo(this.inflatedDevice.getCurrentDevice(), this.vmConfigContext.environment.hostCapability.vFlashSupported);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setSelectedStorage = function () {
            var device = this.inflatedDevice.getCurrentDevice();
            if (this.getStorageForDisk && this.inflatedDevice.isNew()) {
                var selectedStorageForDisk = this.getStorageForDisk({ diskKey: device.key });
                if (selectedStorageForDisk) {
                    this.selectedStorage = {
                        key: selectedStorageForDisk.diskKey,
                        id: selectedStorageForDisk.dsId,
                        name: selectedStorageForDisk.dsName,
                        storageObject: selectedStorageForDisk.dsObject
                    };
                }
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setStorageProfileMetadata = function () {
            var _this = this;
            if (!this.settingsForm) {
                this.buildSettingsForm();
            }
            // set default if not set
            if (this.settingsForm.storageProfile && !this.settingsForm.storageProfile.selection) {
                this.settingsForm.storageProfile.options.some(function (option) {
                    if (option.id === "defaultId") {
                        _this.settingsForm.storageProfile.selection = option;
                        return true;
                    }
                    return false;
                });
            }
            if (this.settingsForm.storageProfile) {
                this.vmStorageProfileMetadata = new VmStorageProfileMetadata(this.settingsForm.storageProfile.options, this.settingsForm.storageProfile.selection);
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.updateSelectedProfile = function (selectedProfile) {
            // TODO: ajaffer, what is a better way other than creating a new object?
            this.vmStorageProfileMetadata
                = new VmStorageProfileMetadata(this.vmStorageProfileMetadata.storageProfiles, selectedProfile);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.checkEncryptionWarning = function () {
            this.updateDiskProfileValidity(!this.isEncryptionProfileApplied());
        };
        ;
        VmHardwareRdmVirtualDiskCtrl.prototype.updateDiskProfileValidity = function (isValid) {
            this.isDiskProfileValid = isValid;
            if (this.diskProfileErrorConfig) {
                this.diskProfileErrorConfig.isVisible = !isValid;
            }
            var form = this[this.getFormName()];
            if (form) {
                var diskProfileElem = form['storage-profile'];
                if (diskProfileElem) {
                    diskProfileElem.$invalid = !isValid;
                }
                form.$setValidity('diskProfile', isValid);
                this.updateFormValidity(form);
            }
        };
        ;
        VmHardwareRdmVirtualDiskCtrl.prototype.updateFormValidity = function (form) {
            form.$invalid = !this.isDiskProfileValid || !!this.diskLocationError;
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setIopsLimit = function () {
            this.iopsLimit = this.vmHardwareRdmVirtualDiskService.getIopsLimit(this.inflatedDevice);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setLocationBrowserMetadata = function () {
            var storageData = {
                storageLocatorItemsData: this.storageLocatorItemsData
            };
            this.vmStorageBrowserMetadata = new VmStorageBrowserMetadata(storageData);
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.checkDiskLocationError = function () {
            var _this = this;
            var datastoreInfo = this.datastoreService.findDatastore(this.vmStorageId, this.vmConfigContext.environment.configTarget);
            if (datastoreInfo === null) {
                var rdmSupportedDatastore = _.filter(this.vmConfigContext.environment.configTarget.datastore, function (ds) {
                    return ds.capability.rawDiskMappingsSupported;
                });
                var disksInStorage = _.filter(this.storageLocatorItemsData.datastoreItems, function (ds) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(ds.parentStoragePod) === _this.vmStorageId;
                });
                datastoreInfo = rdmSupportedDatastore[_.findLastIndex(rdmSupportedDatastore, {
                    name: disksInStorage[0].name
                })];
            }
            if (this.inflatedDevice.getCurrentDevice().key > 0 ||
                (datastoreInfo &&
                    datastoreInfo.capability.rawDiskMappingsSupported &&
                    this.inflatedDevice.getCurrentDevice().key < 0)) {
                this.diskLocationError = false;
            }
            else {
                this.diskLocationError = true;
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setCompatibilityMode = function () {
            this.compatibilityModeInfo = this.vmHardwareRdmVirtualDiskService
                .getCompatibilityModeInfo(this.vmConfigContext, this.inflatedDevice, this.virtualMachineDevices.getAllDevicesNotMarkedForRemoval());
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setDiskMode = function () {
            this.diskModeInfo = this.vmHardwareRdmVirtualDiskService
                .getDiskModeInfo(this.vmConfigContext, this.inflatedDevice, this.virtualMachineDevices.getAllDevicesNotMarkedForRemoval());
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setSharingInfo = function () {
            if (!this.settingsForm) {
                this.buildSettingsForm();
            }
            this.sharingInfo = {
                sharingOptions: this.settingsForm.sharing.options,
                selectedSharing: this.settingsForm.sharing.selection,
                enableSharing: this.vmHardwareRdmVirtualDiskService
                    .enableSharing(this.vmConfigContext, this.inflatedDevice)
            };
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setSharesInfo = function () {
            if (!this.settingsForm) {
                this.buildSettingsForm();
            }
            this.sharesContext = {
                sharesId: this.getFormName(),
                shareMin: this.settingsForm.shares.min,
                shareMax: this.settingsForm.shares.max,
                sharesInfo: {
                    level: this.settingsForm.shares.value.level,
                    shares: this.settingsForm.shares.value.shares,
                },
                sharesLevelPresetOptions: this.settingsForm.shares.presetOptions,
                showRecommendations: false
            };
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setDeviceNodeInfo = function () {
            var formKey = this.inflatedDevice.getKey().toString().replace("-", "__");
            var controllerSelectorName = "editVirtualDeviceController" + formKey;
            var controllerNodeSelectorName = "editVirtualDeviceNode" + formKey;
            this.deviceNodeInfo = {
                inflatedDevice: this.inflatedDevice,
                virtualMachineDevices: this.virtualMachineDevices,
                controllerNodeSelectorName: controllerNodeSelectorName,
                controllerSelectorName: controllerSelectorName,
                virtualDiskSettingsForm: this.settingsForm,
                vmConfigContext: this.vmConfigContext
            };
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setPhysicalLunInfo = function () {
            this.physicalLunInfo = {
                name: this.inflatedDevice.getCurrentDevice().backing.deviceName
            };
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.setDiskFile = function () {
            var device = this.inflatedDevice.getCurrentDevice();
            if (device && device.backing && device.backing.fileName) {
                this.displayDiskFile = this.expanded && this.vmWorkflowMode !== VmWorkflowMode.CloneMode;
                this.diskFile = device.backing.fileName;
            }
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.getDiskText = function () {
            if (!this.capacity) {
                return '';
            }
            var diskSize = this.basicDiskUtilService.determineDisplayDiskSize(this.capacity.valueInMB);
            return diskSize ?
                (this.basicDiskUtilService.roundToPrecision(diskSize.size, 2).toString() + ' ' + diskSize.unitText) :
                '';
        };
        ;
        VmHardwareRdmVirtualDiskCtrl.prototype.getSelectedVirtualNodeText = function () {
            if (this.deviceNodeInfo && this.deviceNodeInfo.virtualDiskSettingsForm &&
                this.deviceNodeInfo.virtualDiskSettingsForm.controllers) {
                var rawController = this.deviceNodeInfo.virtualDiskSettingsForm.controllers.selection.getCurrentDevice();
                if (rawController) {
                    return this.vmDeviceInfoService.getControllerAndNodeLabelText(rawController._type, rawController.busNumber, this.inflatedDevice.getCurrentDevice().unitNumber);
                }
            }
            return '';
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.buildSettingsForm = function () {
            var _this = this;
            return this.$q.all(this.getAllBackendStorageCallPromises()).then(function (results) {
                _this.storageProfiles = results.storageProfilesPromiseResult;
                _this.vmAssignmentsProperties = results.vmAssignmentsPromiseResult || {};
                if (_this.vmWorkflowMode === VmWorkflowMode.UpdateMode
                    && _this.vmAssignmentsProperties
                    && _this.vmAssignmentsProperties.vmStorageProfileAssignments
                    && _this.storageProfiles
                    && !_this.inflatedDevice.isNew()) {
                    var profile = _this.storageProfileService.makeProfileFromDevice(_this.inflatedDevice.getCurrentDeviceSpec().device, _this.storageProfiles, _this.vmAssignmentsProperties.vmStorageProfileAssignments);
                    _this.inflatedDevice.setOriginalProfile(profile);
                }
                _this.diskLocationError = false;
                _this.settingsForm = _this.vmHardwareRdmVirtualDiskService.buildSettingsForm(_this.vmAssignmentsProperties.vmStorageProfileAssignments, _this.vmWorkflowMode, _this.vmConfigContext, _this.inflatedDevice, _this.vmStorageId, _this.selectedStorageProfile, _this.storageProfiles, _this.virtualMachineDevices);
                _this.capacity = {
                    validUnits: _this.settingsForm.capacity.validUnits,
                    maxInMB: _this.settingsForm.capacity.maxInMB,
                    minInMB: _this.settingsForm.capacity.minInMB,
                    valueInMB: _this.settingsForm.capacity.valueInMB,
                    memoryUnitPreferred: _this.settingsForm.capacity.memoryUnitPreferred.label
                };
            });
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.getAllBackendStorageCallPromises = function () {
            if (this.vmAssignmentsProperties && this.vmWorkflowMode === VmWorkflowMode.UpdateMode) {
                return this.vmHardwareVirtualDiskService.getAllBackendStorageCallPromises(this.$q, this.vmAssignmentsProperties, this.storageProfiles);
            }
            return {
                storageProfilesPromiseResult: this.storageProfiles,
                vmAssignmentsPromiseResult: this.vmAssignmentsProperties
            };
        };
        VmHardwareRdmVirtualDiskCtrl.prototype.isExpandable = function () {
            if (!this.settingsForm) {
                return false;
            }
            else {
                return true;
            }
        };
        ;
        VmHardwareRdmVirtualDiskCtrl.$inject = [
            '$q',
            '$rootScope',
            '$scope',
            '$timeout',
            'i18nService',
            'virtualDiskSettingsFormService',
            'storageProfileService',
            'vmHardwareRdmVirtualDiskService',
            'vmHardwareVirtualDiskService',
            'datastoreService',
            'vmDeviceInfoService',
            'defaultUriSchemeUtil',
            'basicDiskUtilService',
            'vmCryptUtilService'
        ];
        return VmHardwareRdmVirtualDiskCtrl;
    }());
    var VmHardwareRdmVirtualDisk = (function () {
        function VmHardwareRdmVirtualDisk() {
            /**
             * vmWorkflowMode        Workflow mode [Create/Update]
             * displayMode           Display mode of Virtual RDM Disk [Create/Read/Update]
             * inflatedDevice        Virtual Disk
             * vmConfigContext       Virtual Machine configuration's representative object
             * virtualMachineDevices Wrapper service for virtual machine devices
             */
            this.bindings = {
                vmWorkflowMode: "<",
                displayMode: "<",
                inflatedDevice: "<",
                vmStorageId: "@",
                vmConfigContext: "<",
                virtualMachineDevices: "<",
                getStorageForDisk: "&",
                storageProfiles: "<",
                isVmEncrypted: "<",
                selectedStorageProfile: "<",
                storageLocatorItemsData: "<",
                vmAssignmentsProperties: "<",
                computeResourceId: '<',
                removeCallback: "&",
                vmId: "<",
                showStoragePods: "<",
                expanded: "=",
                vmStorageObject: "<",
                setStorageForDisk: "&",
                isGroupingHardDisks: "<",
            };
            this.controller = VmHardwareRdmVirtualDiskCtrl;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/" +
                "vmHardwareRDMVirtualDisk/vm-hardware-rdm-virtual-disk.html";
        }
        return VmHardwareRdmVirtualDisk;
    }());
    h5_vm.VmHardwareRdmVirtualDisk = VmHardwareRdmVirtualDisk;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareRdmVirtualDisk", new VmHardwareRdmVirtualDisk());
})(h5_vm || (h5_vm = {}));



var vm_ui;
(function (vm_ui) {
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var DeviceType = h5_vm.DeviceType;
    var VmHardwareRdmVirtualDiskService = (function () {
        function VmHardwareRdmVirtualDiskService(deviceClassLineageService, virtualDiskSettingsFormService, vmHardwareVirtualDiskSharesService, vmHardwareVirtualDiskCompatibilityModeService, vmHardwareVirtualDiskModeService, vmHardwareVirtualDiskIopsService, vmHardwareVirtualDiskFlashReadCacheService, vmHardwareUtil) {
            this.deviceClassLineageService = deviceClassLineageService;
            this.virtualDiskSettingsFormService = virtualDiskSettingsFormService;
            this.vmHardwareVirtualDiskSharesService = vmHardwareVirtualDiskSharesService;
            this.vmHardwareVirtualDiskCompatibilityModeService = vmHardwareVirtualDiskCompatibilityModeService;
            this.vmHardwareVirtualDiskModeService = vmHardwareVirtualDiskModeService;
            this.vmHardwareVirtualDiskIopsService = vmHardwareVirtualDiskIopsService;
            this.vmHardwareVirtualDiskFlashReadCacheService = vmHardwareVirtualDiskFlashReadCacheService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareRdmVirtualDiskService.prototype.buildSettingsForm = function (vmStorageProfileAssignments, vmWorkflowMode, vmConfigContext, inflatedDevice, vmStorageId, selectedStorageProfile, storageProfiles, virtualMachineDevices) {
            return this.virtualDiskSettingsFormService.build(vmStorageProfileAssignments, vmWorkflowMode === VmWorkflowMode.CreateMode
                || vmWorkflowMode === VmWorkflowMode.CloneMode, vmConfigContext, inflatedDevice, vmStorageId, selectedStorageProfile, storageProfiles, virtualMachineDevices);
        };
        VmHardwareRdmVirtualDiskService.prototype.isPoweredOn = function (vmConfigContext) {
            return vmConfigContext.environment.powerState === "poweredOn";
        };
        VmHardwareRdmVirtualDiskService.prototype.enableSharing = function (vmConfigContext, inflatedDevice) {
            return !(this.isPoweredOn(vmConfigContext) && !inflatedDevice.isNew());
        };
        VmHardwareRdmVirtualDiskService.prototype.onDiskDistroyStatusChange = function (destroyDisk, inflatedDevice) {
            if (destroyDisk) {
                inflatedDevice.setDiskFileOperation("destroy");
            }
            else {
                inflatedDevice.setDiskFileOperation(null);
            }
        };
        VmHardwareRdmVirtualDiskService.prototype.isEditFlashReadCacheDisabled = function (privileges, isNewDevice) {
            return this.vmHardwareVirtualDiskFlashReadCacheService.isEditFlashReadCacheDisabled(privileges, isNewDevice);
        };
        VmHardwareRdmVirtualDiskService.prototype.isSharesOrLimitDisabled = function (privileges, isNewDevice) {
            if (isNewDevice) {
                return false;
            }
            var required = [h5_vm.Privileges.VM_RAWDEVICE_PRIVILEGE, h5_vm.Privileges.VM_CONFIG_RESOURCE];
            if (this.vmHardwareUtil.checkPrivileges(privileges, required)) {
                return false;
            }
            else {
                return true;
            }
        };
        VmHardwareRdmVirtualDiskService.prototype.isRemoveRdmDiskDisabled = function (privileges) {
            return !this.hasPrivilegesToRemoveDisk(privileges);
        };
        VmHardwareRdmVirtualDiskService.prototype.hasPrivilegesToRemoveDisk = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [h5_vm.Privileges.VM_RAWDEVICE_PRIVILEGE]);
        };
        VmHardwareRdmVirtualDiskService.prototype.isDiskModeDisabled = function (inflatedDevice, vmWorkflowMode, vmConfigContext) {
            return this.vmHardwareVirtualDiskModeService.isEditDiskModeDisabled(inflatedDevice, vmWorkflowMode === VmWorkflowMode.CreateMode, vmConfigContext);
        };
        VmHardwareRdmVirtualDiskService.prototype.getCompatibilityModeInfo = function (vmConfigContext, inflatedDevice, allInflatedDevices) {
            return this.vmHardwareVirtualDiskCompatibilityModeService.getCompatibilityModeInfo(vmConfigContext, inflatedDevice, allInflatedDevices);
        };
        VmHardwareRdmVirtualDiskService.prototype.getDiskModeInfo = function (vmConfigContext, inflatedDevice, allVirtualDevices) {
            return this.vmHardwareVirtualDiskModeService.getDiskModeInfo(vmConfigContext, inflatedDevice, allVirtualDevices);
        };
        VmHardwareRdmVirtualDiskService.prototype.getIopsLimit = function (device) {
            return this.vmHardwareVirtualDiskIopsService.getIopsLimit(device);
        };
        VmHardwareRdmVirtualDiskService.prototype.getFlashCacheReservationInfo = function (device, vFlashSupportedOnHost) {
            return this.vmHardwareVirtualDiskFlashReadCacheService.getFlashCacheReservationInfo(device, vFlashSupportedOnHost);
        };
        VmHardwareRdmVirtualDiskService.prototype.isDiskController = function (deviceType) {
            var _this = this;
            var isClassOrSubclass = function (deviceClass, baseClass) {
                return (deviceClass === baseClass) || (_this.deviceClassLineageService.isClassNameSubclassOf(deviceClass, baseClass));
            };
            var isScsi = isClassOrSubclass(deviceType, DeviceType.SCSICONTROLLER);
            var isSata = isClassOrSubclass(deviceType, DeviceType.VIRTUAL_SATA_CONTROLLER);
            var isNvme = isClassOrSubclass(deviceType, DeviceType.NVME_CONTROLLER);
            var isIDE = isClassOrSubclass(deviceType, DeviceType.IDE);
            return isScsi || isSata || isNvme || isIDE;
        };
        VmHardwareRdmVirtualDiskService.$inject = [
            "deviceClassLineageService",
            "virtualDiskSettingsFormService",
            "vmHardwareVirtualDiskSharesService",
            "vmHardwareVirtualDiskCompatibilityModeService",
            "vmHardwareVirtualDiskModeService",
            "vmHardwareVirtualDiskIopsService",
            "vmHardwareVirtualDiskFlashReadCacheService",
            "vmHardwareUtil"
        ];
        return VmHardwareRdmVirtualDiskService;
    }());
    vm_ui.VmHardwareRdmVirtualDiskService = VmHardwareRdmVirtualDiskService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareRdmVirtualDiskService", VmHardwareRdmVirtualDiskService);
})(vm_ui || (vm_ui = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareScsiCtrlController = (function () {
        function VmHardwareScsiCtrlController(i18nService, deviceClassLineageService, VmController, vmHardwareScsiControllerService) {
            this.i18nService = i18nService;
            this.deviceClassLineageService = deviceClassLineageService;
            this.VmController = VmController;
            this.vmHardwareScsiControllerService = vmHardwareScsiControllerService;
            this.LBL_TYPE = this.i18n('SCSIControllerPage.ChangeType');
            this.LBL_SHARING = this.i18n('SCSIControllerPage.SCSIBusSharing');
        }
        VmHardwareScsiCtrlController.prototype.i18n = function (key, bundle) {
            if (bundle === void 0) { bundle = "VmUi"; }
            return this.i18nService.getString(bundle, key);
        };
        VmHardwareScsiCtrlController.prototype.$onInit = function () {
            var _this = this;
            this.device = this.inflatedDevice.getCurrentDevice();
            var deviceOptions = this.vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption;
            var vmController = new this.VmController(this.device, deviceOptions);
            this.deviceName = this.getSCSIName(this.device._type);
            this.scsiTypeList = this.getSCSITypeList(deviceOptions);
            this.busSharingList = _.map(vmController.sharingOptions(), function (unformattedSharingType) {
                return _this.createSharingListItem(unformattedSharingType);
            });
            this.unsupportedWarning = this.getUnsupportedWarning(this.inflatedDevice.getCurrentDevice()._type);
            this.properties = {
                selectedScsiType: {
                    name: this.deviceName,
                    id: this.device._type
                },
                selectedBusSharing: this.createSharingListItem(this.device.sharedBus)
            };
        };
        VmHardwareScsiCtrlController.prototype.onScsiControllerTypeChange = function () {
            var scsiTypeId = this.properties.selectedScsiType.id;
            this.deviceName = this.getSCSIName(scsiTypeId);
            this.inflatedDevice.getCurrentDevice()._type = scsiTypeId;
            this.unsupportedWarning = this.getUnsupportedWarning(this.inflatedDevice.getCurrentDevice()._type);
        };
        ;
        VmHardwareScsiCtrlController.prototype.onScsiControllerRemove = function () {
            if (this.isRemoveScsiControllerEnabled() && this.removeCallback) {
                this.removeCallback()(this.inflatedDevice);
            }
        };
        ;
        VmHardwareScsiCtrlController.prototype.onScsiBusSharingChange = function () {
            this.inflatedDevice.getCurrentDevice().sharedBus = this.properties.selectedBusSharing.id;
        };
        ;
        VmHardwareScsiCtrlController.prototype.isRemoveScsiControllerEnabled = function () {
            if (this.createMode) {
                return !this.isControllerInUse();
            }
            if (this.isControllerInUse() || !this.vmHardwareScsiControllerService.hasAddRemoveDevicePrivilege(this.vmConfigContext.privileges)) {
                return false;
            }
            return !this.isVmInSuspendedState();
        };
        ;
        VmHardwareScsiCtrlController.prototype.isEditScsiControllerDisabled = function () {
            return this.vmHardwareScsiControllerService.isEditScsiControllerDisabled(this.vmConfigContext.environment.powerState, this.vmConfigContext.privileges, this.inflatedDevice.isNew());
        };
        VmHardwareScsiCtrlController.prototype.isVmInPoweredOnState = function () {
            if (this.vmConfigContext.environment.powerState === "poweredOn") {
                return true;
            }
            else {
                return false;
            }
        };
        ;
        VmHardwareScsiCtrlController.prototype.isVmInSuspendedState = function () {
            if (this.vmConfigContext.environment.powerState === "suspended") {
                return true;
            }
            else {
                return false;
            }
        };
        ;
        VmHardwareScsiCtrlController.prototype.getUnsupportedWarning = function (selectedControllerType) {
            var index = _.findIndex(this.selectedGuestOs.supportedDiskControllerList, function (current) {
                return current.typeClass === selectedControllerType;
            });
            if (index < 0) {
                return this.i18n("SCSIControllerConfig.NotRecommended");
            }
            else {
                return undefined;
            }
        };
        VmHardwareScsiCtrlController.prototype.getSCSITypeList = function (deviceOptions) {
            var _this = this;
            var scsiTypeOptionList = _.select(deviceOptions, function (diskController) {
                return _this.deviceClassLineageService.isClassNameSubclassOf(diskController.type.name, "VirtualSCSIController");
            });
            var scsiTypeList = _.map(scsiTypeOptionList, function (scsiTypeOption) {
                return {
                    name: _this.getSCSIName(scsiTypeOption.type.name),
                    id: scsiTypeOption.type.typeClass
                };
            });
            return scsiTypeList;
        };
        VmHardwareScsiCtrlController.prototype.getSCSIName = function (type) {
            var scsiControllerName = _.last(type.split("."));
            return this.i18n("SCSIControllerConfig." + scsiControllerName);
        };
        VmHardwareScsiCtrlController.prototype.createSharingListItem = function (type) {
            return {
                name: this.i18n("SCSIControllerConfig." + type),
                id: type
            };
        };
        VmHardwareScsiCtrlController.prototype.isControllerInUse = function () {
            var devices = this.virtualMachineDevices.getDevicesAttachedToControllerKey(this.inflatedDevice.getKey());
            return devices.length > 0;
        };
        VmHardwareScsiCtrlController.$inject = [
            "i18nService",
            "deviceClassLineageService",
            "VmController",
            "vmHardwareScsiControllerService"
        ];
        return VmHardwareScsiCtrlController;
    }());
    var VmHardwareScsiController = (function () {
        function VmHardwareScsiController() {
            this.bindings = {
                inflatedDevice: "<",
                createMode: "<",
                vmConfigContext: "<",
                virtualMachineDevices: "<",
                selectedGuestOs: "<",
                removeCallback: "&",
                expanded: "="
            };
            this.controller = VmHardwareScsiCtrlController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareScsiController/" +
                "vmHardwareScsiController.html";
        }
        return VmHardwareScsiController;
    }());
    h5_vm.VmHardwareScsiController = VmHardwareScsiController;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareScsiController", new VmHardwareScsiController());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareScsiControllerService = (function () {
        function VmHardwareScsiControllerService(vmHardwareUtil) {
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareScsiControllerService.prototype.isEditScsiControllerDisabled = function (powerState, privileges, isNew) {
            if (isNew) {
                return false;
            }
            return this.vmHardwareUtil.isVmPoweredOn(powerState) || !this.hasPrivilegesToEdit(privileges, isNew);
        };
        VmHardwareScsiControllerService.prototype.hasPrivilegesToEdit = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareScsiControllerService.prototype.hasAddRemoveDevicePrivilege = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_ADDREMOVEDEVICE_PRIVILEGE]);
        };
        VmHardwareScsiControllerService.$inject = [
            'vmHardwareUtil'];
        return VmHardwareScsiControllerService;
    }());
    h5_vm.VmHardwareScsiControllerService = VmHardwareScsiControllerService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareScsiControllerService', VmHardwareScsiControllerService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareSerialPortFileBrowserController = (function () {
        function VmHardwareSerialPortFileBrowserController($scope, i18nService, defaultUriSchemeUtil, datastoreBrowserConstants) {
            var _this = this;
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
            this.formData = { selectedTreeItem: null, fileName: "" };
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
            this.dsFileBrowserData = this.getDatastoreFileBrowserData();
            this.setFilePathForSubmitCallback();
            $scope.$watchCollection(function () { return _this.formData; }, this.validateForm.bind(this));
        }
        VmHardwareSerialPortFileBrowserController.prototype.hasValidFileNameAndFolderLocation = function () {
            var hasFileName = this.formData.fileName.length > 0;
            var hasSelectedFolder = this.formData.selectedTreeItem;
            return hasFileName && hasSelectedFolder;
        };
        VmHardwareSerialPortFileBrowserController.prototype.getFilePath = function () {
            return this.formData.selectedTreeItem.path + "/" + this.formData.fileName;
        };
        VmHardwareSerialPortFileBrowserController.prototype.validateForm = function () {
            this.$scope.modalOptions.submitDisabled = !this.hasValidFileNameAndFolderLocation();
        };
        VmHardwareSerialPortFileBrowserController.prototype.setFilePathForSubmitCallback = function () {
            var _this = this;
            var onSubmitCallback = this.$scope.modalOptions.onSubmit;
            this.$scope.modalOptions.onSubmit = function () {
                var filePath = _this.getFilePath();
                onSubmitCallback(filePath);
                _this.$scope.destroyModal();
            };
        };
        VmHardwareSerialPortFileBrowserController.prototype.getDatastoreFileBrowserData = function () {
            var _this = this;
            var vmId = this.$scope.modalOptions.dialogData.vmId;
            var vmConfigContext = this.$scope.modalOptions.dialogData.vmConfigContext;
            var vmDatastores = vmConfigContext.environment.configTarget.datastore;
            var datastoreIds = vmDatastores.map(function (vmDatastore) {
                return _this.defaultUriSchemeUtil.getVsphereObjectId(vmDatastore.datastore.datastore);
            });
            var initialFileQueryType = this.datastoreBrowserConstants.fileQueryType.ALL_FILES;
            return {
                vmId: vmId,
                datastoreIds: datastoreIds,
                initialFileQueryType: initialFileQueryType,
                showVmImagesFolder: true,
                disablePreselect: true
            };
        };
        VmHardwareSerialPortFileBrowserController.$inject = [
            "$scope",
            "i18nService",
            "defaultUriSchemeUtil",
            "datastoreBrowserConstants"
        ];
        return VmHardwareSerialPortFileBrowserController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .controller("vmHardwareSerialPortFileBrowserController", VmHardwareSerialPortFileBrowserController);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareSerialPortService = (function () {
        function VmHardwareSerialPortService(i18nService, clarityModalService, defaultUriSchemeUtil) {
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
        }
        VmHardwareSerialPortService.prototype.openFileBrowserModal = function (vmConfigContext, onSubmitCallback) {
            var dsBrowserId = this.defaultUriSchemeUtil.getVsphereObjectId(vmConfigContext.environment.datastoreBrowser);
            var modalOptions = {
                title: this.i18n("SerialPortPage.FileBrowser.Title"),
                submitButtonTitle: this.i18n("SerialPortPage.FileBrowser.Save"),
                contentTemplate: "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSerialPort/vm-hardware-serial-port-file-browser.html",
                defaultButton: "submit",
                size: "lg",
                onSubmit: onSubmitCallback,
                onCancel: function () { },
                dialogData: {
                    vmId: dsBrowserId,
                    vmConfigContext: vmConfigContext
                }
            };
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        VmHardwareSerialPortService.$inject = ["i18nService", "clarityModalService", "defaultUriSchemeUtil"];
        return VmHardwareSerialPortService;
    }());
    h5_vm.VmHardwareSerialPortService = VmHardwareSerialPortService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareSerialPortService", VmHardwareSerialPortService);
})(h5_vm || (h5_vm = {}));



var VmHwSerialPort = h5_vm.VmHwSerialPort;
var VmHwSerialPortLabels = (function () {
    function VmHwSerialPortLabels() {
    }
    VmHwSerialPortLabels.prototype.initialize = function (i18n) {
        this.REMOVING = i18n("RemoveDevice.DeviceRemoved");
        this.CONNECTED = i18n("ConnectDevice.Connected");
        this.START_CONNECTED = i18n("ConnectDevice.ConnectAtPowerOn");
        this.START_CONNECTED_SHORT = i18n("ConnectDevice.ConnectAtPowerOnShort");
        var page = function (key) {
            return i18n("SerialPortPage." + key);
        };
        this.STATUS = page("Status");
        this.CONNECTION = page("Connection");
        this.OUTPUT_FILE = page("ConnectedFile");
        this.FILE_PLACEHOLDER = page("ConnectedFile.Placeholder");
        this.BROWSE = page("Browse");
        this.PHYSICAL = page("Device");
        this.PIPE_NAME = page("PipeName");
        this.NEAR_END = page("NearEnd");
        this.FAR_END = page("FarEnd");
        this.IO_MODE = page("IOMode");
        this.YIELD_CPU = page("YieldCPU");
        this.DIRECTION = page("Direction");
        this.PORT_URI = page("PortURI");
        this.USE_VSPCURI = page("UseVSPC");
        this.VSPCURI = page("VSPCURI");
        var cfg = function (key) {
            return i18n("SerialPortConfig." + key);
        };
        this.CLIENT = cfg("client");
        this.SERVER = cfg("server");
        this.PIPE_FAR_END_VM = cfg("Vm");
        this.PIPE_FAR_END_PROCESS = cfg("Process");
    };
    return VmHwSerialPortLabels;
}());



var h5_vm;
(function (h5_vm) {
    var VmHwSerialPortController = (function () {
        function VmHwSerialPortController(i18nService, vmHardwareSerialPortService) {
            this.i18nService = i18nService;
            this.vmHardwareSerialPortService = vmHardwareSerialPortService;
            this.LABELS = new VmHwSerialPortLabels();
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
            this.LABELS.initialize(this.i18n);
        }
        Object.defineProperty(VmHwSerialPortController.prototype, "ID", {
            get: function () {
                if (!this.port.key) {
                    return "0";
                }
                return this.port.key.toString();
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.$onInit = function () {
            this.port.attachLabels(this.i18n);
            if (this.port.isNew()) {
                this.expanded = true;
            }
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "hasChanged", {
            get: function () {
                return this.port.hasChanged();
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.revalidate = function () {
            var isValid = this.port.isValid();
            this.setValidity(isValid);
            return isValid;
        };
        VmHwSerialPortController.prototype.setValidity = function (isValid) {
            if (this.form) {
                this.form.$setValidity("", isValid, this.form);
            }
        };
        VmHwSerialPortController.prototype.remove = function () {
            this.port.removeDevice();
            this.expanded = false;
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "isRemoveDisabled", {
            get: function () {
                return this.port.removeDisabled();
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.restore = function () {
            this.port.revertRemoval();
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "NotMarkedForRemoval", {
            get: function () {
                return (true !== this.port.isMarkedForRemoval());
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isMarkedForRemoval", {
            get: function () {
                return this.port.isMarkedForRemoval();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "deviceLabel", {
            get: function () {
                return this.port.deviceLabel();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "connected", {
            get: function () {
                return this.port.connected;
            },
            set: function (value) {
                this.port.connected = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isConnectDisabled", {
            get: function () {
                return this.port.isConnectDeviceDisabled();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isEditDisabled", {
            get: function () {
                return this.port.isEditDeviceDisabled();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "startConnected", {
            get: function () {
                return this.port.startConnected;
            },
            set: function (value) {
                this.port.startConnected = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "backingValue", {
            get: function () {
                return this.port.backing;
            },
            set: function (value) {
                this.expanded = true;
                this.port.backing = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "backingList", {
            get: function () {
                return this.port.backingList;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.getBackingLabel = function (backingType) {
            var _this = this;
            var label = function (key) {
                return _this.i18n("SerialPortConfig." + key);
            };
            if (backingType.indexOf("FileBacking") > -1) {
                return label("File");
            }
            else if (backingType.indexOf("DeviceBacking") > -1) {
                return label("Device");
            }
            else if (backingType.indexOf("PipeBacking") > -1) {
                return label("Pipe");
            }
            else if (backingType.indexOf("URIBacking") > -1) {
                return label("Network");
            }
            return "";
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "showFileBacking", {
            get: function () {
                return this.port.hasFileBacking;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "yield", {
            get: function () {
                return this.port.yield;
            },
            set: function (value) {
                this.port.yield = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "file", {
            get: function () {
                return this.port.file;
            },
            set: function (value) {
                this.port.file = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isFileInvalid", {
            get: function () {
                return !this.port.isFileValid();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "fileError", {
            get: function () {
                return "invalid file name";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "deviceList", {
            get: function () {
                return this.port.deviceList;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "deviceValue", {
            get: function () {
                return this.port.deviceValue;
            },
            set: function (value) {
                this.port.deviceValue = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "filePlaceHolder", {
            get: function () {
                return this.LABELS.FILE_PLACEHOLDER;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showDeviceBacking", {
            get: function () {
                return this.port.hasDeviceBacking;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showPipeBacking", {
            get: function () {
                return this.port.hasPipeBacking;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showURIBacking", {
            get: function () {
                return this.port.hasURIBacking;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showProxy", {
            get: function () {
                return this.showURIBacking && this.port.vspc;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showStartConnectedInHeader", {
            get: function () {
                if (this.expanded) {
                    return false;
                }
                if (this.port.vm.isUpdate) {
                    if (this.port.vm.poweredOn) {
                        return false;
                    }
                }
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "showConnectedInHeader", {
            get: function () {
                if (this.port.vm.isUpdate) {
                    if (this.port.vm.poweredOn) {
                        return true;
                    }
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.browse = function () {
            var _this = this;
            this.vmHardwareSerialPortService.openFileBrowserModal(this.port.vm.getVmConfigContext(), function (filePath) {
                _this.port.file = filePath;
            });
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "pipe", {
            // PIPE BACKING SECTION - pipe (string), nearEnd (enum), farEnd (boolean)
            get: function () {
                return this.port.pipe;
            },
            set: function (value) {
                this.port.pipe = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isPipeInvalid", {
            get: function () {
                return !this.port.isPipeValid();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "pipeError", {
            get: function () {
                return this.port.getPipeError();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "nearEndList", {
            get: function () {
                return this.port.nearEndList;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.getNearEndLabel = function (value) {
            switch (value) {
                case "client":
                    return this.LABELS.CLIENT;
                case "server":
                    return this.LABELS.SERVER;
                default:
                    return "";
            }
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "nearEndValue", {
            get: function () {
                return this.port.nearEnd;
            },
            set: function (value) {
                this.port.nearEnd = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "farEndList", {
            get: function () {
                return this.port.farEndList;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.getFarEndLabel = function (value) {
            if (value) {
                return this.LABELS.PIPE_FAR_END_PROCESS;
            }
            else {
                return this.LABELS.PIPE_FAR_END_VM;
            }
        };
        Object.defineProperty(VmHwSerialPortController.prototype, "farEndValue", {
            get: function () {
                return this.port.farEnd;
            },
            set: function (value) {
                this.port.farEnd = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "serviceURI", {
            // URI BACKING SECTION
            get: function () {
                return this.port.serviceURI;
            },
            set: function (value) {
                this.port.serviceURI = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isServiceInvalid", {
            get: function () {
                return !this.port.isServiceURIValid();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "serviceError", {
            get: function () {
                return this.port.getServiceURIError();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "vspc", {
            get: function () {
                return this.port.vspc;
            },
            set: function (value) {
                this.port.vspc = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "proxy", {
            get: function () {
                return this.port.proxyURI;
            },
            set: function (value) {
                this.port.proxyURI = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isProxyInvalid", {
            get: function () {
                return !this.port.isProxyURIValid();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "isProxyDisabled", {
            get: function () {
                if (this.isEditDisabled) {
                    return true;
                }
                if (!this.port.vspc) {
                    return true;
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "proxyError", {
            get: function () {
                return this.port.getProxyURIError();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "directionList", {
            get: function () {
                return this.port.directionList;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPortController.prototype, "directionValue", {
            get: function () {
                return this.port.direction;
            },
            set: function (value) {
                this.port.direction = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPortController.prototype.getDirectionLabel = function (value) {
            switch (value) {
                case "client":
                    return this.LABELS.CLIENT;
                case "server":
                    return this.LABELS.SERVER;
                default:
                    return "";
            }
        };
        VmHwSerialPortController.$inject = ["i18nService", "vmHardwareSerialPortService"];
        return VmHwSerialPortController;
    }());
    var VmHwSerialPortComponent = (function () {
        function VmHwSerialPortComponent() {
            this.bindings = {
                port: "<",
                expanded: "="
            };
            this.controller = VmHwSerialPortController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSerialPort/vm-hw-serial-port.html";
        }
        return VmHwSerialPortComponent;
    }());
    h5_vm.VmHwSerialPortComponent = VmHwSerialPortComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHwSerialPort", new VmHwSerialPortComponent());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var VirtualSerialPort$DeviceBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$DeviceBackingInfo;
    var VirtualSerialPort$FileBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$FileBackingInfo;
    var VirtualSerialPort$PipeBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$PipeBackingInfo;
    var VirtualSerialPort$ThinPrintBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$ThinPrintBackingInfo;
    var VirtualSerialPort$URIBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$URIBackingInfo;
    var VirtualDevice$ConnectInfo = com.vmware.vim.binding.vim.vm.device.VirtualDevice$ConnectInfo;
    var VmHwSerialPort = (function (_super) {
        __extends(VmHwSerialPort, _super);
        function VmHwSerialPort(original, deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
            _super.call(this, original, deviceDiffService, vmDeviceInfoService, vmHardwareUtil);
            this.option = null;
            this.deviceBacking = new VirtualSerialPort$DeviceBackingInfo();
            this.fileBacking = new VirtualSerialPort$FileBackingInfo();
            this.pipeBacking = new VirtualSerialPort$PipeBackingInfo();
            this.thinPrintBacking = new VirtualSerialPort$ThinPrintBackingInfo();
            this.uriBacking = new VirtualSerialPort$URIBackingInfo();
            // Common secion: Connected/Start connected
            this._connectable = new VirtualDevice$ConnectInfo();
            this._vspc = false;
            if (!original.backing) {
                original.backing = this.fileBacking;
            }
        }
        VmHwSerialPort.prototype.onVmConfigAttached = function () {
            this.rawDevice = _super.prototype.getCurrentDevice.call(this);
            this.option = this.vm.getDeviceOption(this.rawDevice);
            this.findOptions();
            this.findBacking();
            return;
        };
        VmHwSerialPort.prototype.findBacking = function () {
            if (!this.rawDevice) {
                return;
            }
            var backing = this.rawDevice.backing;
            if (!backing) {
                return;
            }
            var type = backing._type;
            if (type === this.fileBacking._type) {
                this.fileBacking = backing;
            }
            else if (type === this.deviceBacking._type) {
                this.deviceBacking = backing;
            }
            else if (backing._type === this.pipeBacking._type) {
                this.pipeBacking = backing;
            }
            else if (this.uriBacking._type === backing._type) {
                this.uriBacking = backing;
            }
            var defaultChoice = function (choices) {
                if (!choices) {
                    return "";
                }
                var index = choices.defaultIndex;
                var array = choices.choiceInfo;
                var retVal = array[index].key;
                return retVal;
            };
            if (!this.pipeBacking.endpoint) {
                this.pipeBacking.endpoint = defaultChoice(this.pipeOption.endpoint);
            }
            if (!this.pipeBacking.hasOwnProperty("noRxLoss")) {
                this.pipeBacking.noRxLoss = this.pipeOption.noRxLoss.defaultValue;
            }
            if (!this.uriBacking.direction) {
                this.uriBacking.direction = defaultChoice(this.uriOption.directions);
            }
            this._vspc = this.notEmpty(this.proxyURI);
        };
        VmHwSerialPort.prototype.attachLabels = function (i18n0) {
            var i18n = function (key) {
                return i18n0("SerialPortConfig." + key);
            };
            // const attachLabel = (obj: any, key: string) => {
            //    const text = i18n(key);
            //    obj.label = text;
            // };
            //
            // attachLabel(this.fileBacking, "File");
            // attachLabel(this.deviceBacking, "Device");
            // attachLabel(this.pipeBacking, "Pipe");
            // attachLabel(this.uriBacking, "Network");
        };
        Object.defineProperty(VmHwSerialPort.prototype, "connectable", {
            get: function () {
                if (this.rawDevice.connectable) {
                    return this.rawDevice.connectable;
                }
                else {
                    return this._connectable;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "connected", {
            get: function () {
                return this.connectable.connected;
            },
            set: function (value) {
                this.connectable.connected = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "startConnected", {
            get: function () {
                return this.connectable.startConnected;
            },
            set: function (value) {
                this.connectable.startConnected = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPort.prototype.removeDisabled = function () {
            if (!this.option) {
                return false;
            }
            return _super.prototype.removeDeviceDisabled.call(this, this.option);
        };
        Object.defineProperty(VmHwSerialPort.prototype, "deviceList", {
            // Device Backing section
            get: function () {
                var list = this.vm.getSerialPortList();
                var retVal = [];
                for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                    var item = list_1[_i];
                    retVal.push(item.name);
                }
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "deviceValue", {
            get: function () {
                if (!this.deviceBacking.deviceName) {
                    var list = this.deviceList;
                    this.deviceBacking.deviceName = list && list.length > 0 ? list[0] : "";
                }
                return this.deviceBacking.deviceName;
            },
            set: function (item) {
                this.deviceBacking.deviceName = item;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPort.prototype.findOptions = function () {
            this.option = this.vm.getDeviceOption(this.rawDevice);
            var array = this.option ? this.option.backingOption : [];
            var prefix = "com.vmware.vim.binding.vim.vm.device.VirtualSerialPort$";
            var suffix = "BackingInfo";
            var fix = function (str) {
                return prefix + str + suffix;
            };
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                var typeClass = item.type.typeClass;
                if (typeClass === fix("Device")) {
                    this.deviceOption = item;
                }
                else if (typeClass === fix("File")) {
                    this.fileOption = item;
                }
                else if (typeClass === fix("URI")) {
                    this.uriOption = item;
                }
                else if (typeClass === fix("ThinPrint")) {
                    this.thinPrintOption = item;
                }
                else if (typeClass === fix("Pipe")) {
                    this.pipeOption = item;
                }
            }
        };
        Object.defineProperty(VmHwSerialPort.prototype, "yield", {
            // COMMON PROPERTIES (all backing types)
            get: function () {
                return this.rawDevice.yieldOnPoll;
            },
            set: function (value) {
                this.rawDevice.yieldOnPoll = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "file", {
            // FILE BACKING
            get: function () {
                if (!this.fileBacking) {
                    return "";
                }
                return this.fileBacking.fileName;
            },
            set: function (value) {
                if (!this.fileBacking) {
                    return;
                }
                this.fileBacking.fileName = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "backing", {
            get: function () {
                return this.rawDevice.backing._type;
            },
            set: function (value) {
                var backing = this.findBackingByType(value);
                this.rawDevice.backing = backing;
            },
            enumerable: true,
            configurable: true
        });
        VmHwSerialPort.prototype.findBackingByType = function (type) {
            switch (type) {
                case this.fileBacking._type:
                    return this.fileBacking;
                case this.deviceBacking._type:
                    return this.deviceBacking;
                case this.pipeBacking._type:
                    return this.pipeBacking;
                case this.uriBacking._type:
                    return this.uriBacking;
            }
            return this.fileBacking;
        };
        Object.defineProperty(VmHwSerialPort.prototype, "backingType", {
            get: function () {
                if (!this.rawDevice.backing) {
                    return "";
                }
                return this.rawDevice.backing._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "backingList", {
            get: function () {
                return [this.fileBacking._type, this.deviceBacking._type, this.pipeBacking._type, this.uriBacking._type];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "hasFileBacking", {
            get: function () {
                return this.backingType === this.fileBacking._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "hasDeviceBacking", {
            get: function () {
                return this.backingType === this.deviceBacking._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "hasPipeBacking", {
            get: function () {
                return this.backingType === this.pipeBacking._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "hasURIBacking", {
            get: function () {
                return this.backingType === this.uriBacking._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "serviceURI", {
            // URI backing section (aka Network backing)
            get: function () {
                return this.uriBacking.serviceURI;
            },
            set: function (value) {
                this.uriBacking.serviceURI = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "vspc", {
            get: function () {
                return this._vspc;
            },
            set: function (value) {
                if (!value) {
                    this.uriBacking.proxyURI = "";
                }
                this._vspc = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "proxyURI", {
            get: function () {
                return this.uriBacking.proxyURI;
            },
            set: function (value) {
                this.uriBacking.proxyURI = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "directionList", {
            get: function () {
                // these are values of enum
                return ["client", "server"];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "direction", {
            get: function () {
                return this.uriBacking.direction;
            },
            set: function (value) {
                this.uriBacking.direction = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "pipe", {
            // PIPE BACKING
            get: function () {
                return this.pipeBacking.pipeName;
            },
            set: function (value) {
                this.pipeBacking.pipeName = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "nearEnd", {
            get: function () {
                return this.pipeBacking.endpoint;
            },
            set: function (value) {
                this.pipeBacking.endpoint = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "nearEndList", {
            get: function () {
                if (!this.pipeOption || !this.pipeOption.endpoint) {
                    return [];
                }
                return this.pipeOption.endpoint.choiceInfo.map(function (value) {
                    return value.key;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "farEndList", {
            get: function () {
                return [false, true];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VmHwSerialPort.prototype, "farEnd", {
            get: function () {
                return this.pipeBacking.noRxLoss;
            },
            set: function (value) {
                this.pipeBacking.noRxLoss = value;
            },
            enumerable: true,
            configurable: true
        });
        //   -------------------------------------------------------------------
        VmHwSerialPort.prototype.isValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            if (this.hasFileBacking) {
                return this.isFileValid();
            }
            else if (this.hasPipeBacking) {
                return this.isPipeValid();
            }
            else if (this.hasURIBacking) {
                return this.isServiceURIValid() && this.isProxyURIValid();
            }
            else if (this.hasDeviceBacking) {
                return this.isEsxDeviceValid();
            }
            return true;
        };
        VmHwSerialPort.prototype.notEmpty = function (str) {
            if (!str) {
                return false;
            }
            if (str.length < 1) {
                return false;
            }
            return true;
        };
        VmHwSerialPort.prototype.isFileValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            return this.notEmpty(this.file);
        };
        VmHwSerialPort.prototype.getFileError = function () {
            return _super.prototype.i18n.call(this, "SerialPortPage.FileRequired");
        };
        VmHwSerialPort.prototype.isPipeValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            return this.notEmpty(this.pipe);
        };
        VmHwSerialPort.prototype.getPipeError = function () {
            return _super.prototype.i18n.call(this, "SerialPortPage.PipeRequired");
        };
        VmHwSerialPort.prototype.isEsxDeviceValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            return this.notEmpty(this.deviceValue);
        };
        VmHwSerialPort.prototype.isServiceURIValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            return this.notEmpty(this.serviceURI);
        };
        VmHwSerialPort.prototype.getServiceURIError = function () {
            return _super.prototype.i18n.call(this, "SerialPortPage.ServiceURIRequired");
        };
        VmHwSerialPort.prototype.isProxyURIValid = function () {
            if (_super.prototype.isMarkedForRemoval.call(this)) {
                return true;
            }
            if (!this.vspc) {
                return true;
            }
            return this.notEmpty(this.proxyURI);
        };
        VmHwSerialPort.prototype.getProxyURIError = function () {
            return _super.prototype.i18n.call(this, "SerialPortPage.ConcentratorURIRequired");
        };
        return VmHwSerialPort;
    }(h5_vm.EditableVirtualDeviceClass));
    h5_vm.VmHwSerialPort = VmHwSerialPort;
    function GetSerilPortFactory(deviceDiffService, vmDeviceInfoService, vmHardwareUtil) {
        var factoryFn = function (rawDevice) {
            var instance = new VmHwSerialPort(rawDevice, deviceDiffService, vmDeviceInfoService, vmHardwareUtil);
            return instance;
        };
        return factoryFn;
    }
    angular.module('com.vmware.vsphere.client.vm')
        .factory('VmHwSerialPort', ['deviceDiffService', 'vmDeviceInfoService', 'vmHardwareUtil', GetSerilPortFactory]);
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSettings', [
   function(
   ) {
      return {
         templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareSettings.html',
         controller: 'VmHardwareController',
         controllerAs: 'ctrl'
      };
   }]);
var h5_vm;
(function (h5_vm) {
    var FileOnChange = (function () {
        function FileOnChange() {
            this.scope = {
                handler: '&fileOnChange'
            };
            this.restrict = 'A';
            this.controllerAs = 'fileOnChangeCtrl';
            this.controller = FileOnChangeController;
        }
        FileOnChange.Metastructure = {
            name: "fileOnChange",
            factory: [function () { return new FileOnChange(); }]
        };
        return FileOnChange;
    }());
    var FileOnChangeController = (function () {
        function FileOnChangeController($scope, $element) {
            this.$scope = $scope;
            this.$element = $element;
        }
        FileOnChangeController.prototype.$onInit = function () {
        };
        FileOnChangeController.prototype.$postLink = function () {
            var _this = this;
            this.$element.bind('change', function (event) {
                _this.$scope.$apply(function () {
                    if (event.target.files && event.target.files.length) {
                        var filesObject = { files: event.target.files };
                        _this.$scope.handler(filesObject);
                    }
                });
            });
        };
        FileOnChangeController.$inject = [
            '$scope',
            '$element'
        ];
        return FileOnChangeController;
    }());
    angular
        .module('com.vmware.vsphere.client.vm')
        .directive(FileOnChange.Metastructure.name, FileOnChange.Metastructure.factory);
})(h5_vm || (h5_vm = {}));



// todo: Combine with storage-ui's fileReaderService and move file to common module
var h5_vm;
(function (h5_vm) {
    var VmFileReaderService = (function () {
        function VmFileReaderService($q) {
            this.$q = $q;
        }
        VmFileReaderService.prototype.readFileContentAsBinaryString = function (file) {
            if (!file) {
                return this.$q.when(null);
            }
            var deferredResult = this.$q.defer();
            var fileReader = new FileReader();
            fileReader.onload = function () {
                var dataUrl = fileReader.result;
                deferredResult.resolve(dataUrl);
            };
            fileReader.addEventListener("load", function () {
                var dataUrl = fileReader.result;
                deferredResult.resolve(dataUrl);
            });
            fileReader.addEventListener("error", function () {
                deferredResult.resolve(null);
            });
            fileReader.readAsBinaryString(file);
            return deferredResult.promise;
        };
        VmFileReaderService.$inject = ["$q"];
        return VmFileReaderService;
    }());
    h5_vm.VmFileReaderService = VmFileReaderService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmFileReaderService", VmFileReaderService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var TpmCertificateSelector = (function () {
        function TpmCertificateSelector() {
            this.bindings = {
                tpmCertificate: "<",
                onCertificateChange: "&"
            };
            this.controller = TpmCertificateSelectorController;
            this.templateUrl =
                'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/tpmCertificateSelector/' +
                    'tpm-certificate-selector.component.html';
        }
        return TpmCertificateSelector;
    }());
    h5_vm.TpmCertificateSelector = TpmCertificateSelector;
    var TpmCertificateSelectorController = (function () {
        function TpmCertificateSelectorController(i18nService, $element, $timeout, vmFileReaderService, vmTpmService) {
            this.i18nService = i18nService;
            this.$element = $element;
            this.$timeout = $timeout;
            this.vmFileReaderService = vmFileReaderService;
            this.vmTpmService = vmTpmService;
            this.certificateDropdownOptions = [];
            this.invalidCertAlertOptions = {
                text: '',
                isClosed: true
            };
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = 'VmUi'; }
                return i18nService.getString(bundle, key);
            };
            this.errorConfig = {
                message: "",
                isVisible: false
            };
            this.selectedCertificate = this.tpmCertificate;
            this.certificateDropdownOptions.push(this.tpmCertificate);
        }
        TpmCertificateSelectorController.prototype.$onInit = function () {
        };
        TpmCertificateSelectorController.prototype.$postLink = function () {
            this.certificateFileInput = this.$element.find("input[type='file']");
        };
        TpmCertificateSelectorController.prototype.openFileSelector = function () {
            var _this = this;
            this.$timeout(function () {
                _this.certificateFileInput.click();
            }, 0);
        };
        TpmCertificateSelectorController.prototype.showAlertForInvalidCertificate = function (errorText) {
            this.invalidCertAlertOptions.text = errorText;
            this.invalidCertAlertOptions.isClosed = false;
        };
        TpmCertificateSelectorController.prototype.uploadCertificate = function (files) {
            var _this = this;
            if (files && files.length) {
                var certificateFile = files[0];
                this.vmFileReaderService.readFileContentAsBinaryString(certificateFile).then(function (base64EncodedCertificate) {
                    _this.vmTpmService.parseCertificate(base64EncodedCertificate).then(function (certificate) {
                        if (!certificate) {
                            // Certificate is invalid
                            _this.showAlertForInvalidCertificate(_this.i18n('VmDeviceManager.TPMCertificateInvalid'));
                        }
                        else {
                            _this.onCertificateChange({
                                uploadedCertificate: certificate,
                                originalCertificate: _this.tpmCertificate
                            });
                        }
                    }, function (error) {
                        _this.showAlertForInvalidCertificate(_this.i18n('VmDeviceManager.TPMCertificateInvalid'));
                    });
                });
            }
        };
        TpmCertificateSelectorController.$inject = [
            'i18nService',
            '$element',
            '$timeout',
            'vmFileReaderService',
            'vmTpmService'
        ];
        return TpmCertificateSelectorController;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .component('tpmCertificateSelector', new TpmCertificateSelector());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareTpm = (function () {
        function VmHardwareTpm() {
            this.bindings = {
                tpmDevice: "<",
                removeCallback: "&",
                createMode: "<",
                vmPoweredOn: "<",
                vmId: "<"
            };
            this.controller = VmHardwareTpmController;
            this.templateUrl =
                'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/vm-hardware-tpm.component.html';
        }
        return VmHardwareTpm;
    }());
    h5_vm.VmHardwareTpm = VmHardwareTpm;
    var VmHardwareTpmController = (function () {
        function VmHardwareTpmController(i18nService, templateHelperService, vmTpmService) {
            this.i18nService = i18nService;
            this.templateHelperService = templateHelperService;
            this.vmTpmService = vmTpmService;
            this.showModal = false;
            this.tpmCertificates = [];
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = 'VmUi'; }
                return i18nService.getString(bundle, key);
            };
        }
        VmHardwareTpmController.prototype.$onInit = function () {
            var _this = this;
            this.device = this.tpmDevice.getCurrentDevice();
            var tpmHelpTemplate = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareTpm/tpm-help-text.html';
            var spacing = "<br><br>";
            var kbArticleLink = "https://kb.vmware.com/selfservice/microsites/search.do?language=en_US&cmd=" +
                "displayKC&externalId=2147566";
            var scope = {
                i18n: this.i18n,
                createMode: this.createMode,
                vmPoweredOn: this.vmPoweredOn,
                actionableText: this.i18n('VmDeviceManager.TpmHelpAdd.NewVM.Description') + spacing,
                extraText: '',
                kbArticleLink: kbArticleLink,
                linkLabel: this.i18n('VmDeviceManager.TpmHelp.Link.Label')
            };
            if (!this.createMode && this.vmId) {
                this.vmTpmService.getCertificates(this.vmId)
                    .then(function (result) {
                    _this.tpmCertificates = _.forEach(result, function (tmpCertificate, index) {
                        return tmpCertificate.id = index;
                    });
                });
                scope.actionableText = this.i18n('VmDeviceManager.TpmHelpAddDelete.ExistingVM.Description') + spacing;
                scope.extraText = this.i18n('VmDeviceManager.TpmHelp.KMS.Description') + spacing;
            }
            this.templateHelperService.renderTemplateWithScope(tpmHelpTemplate, scope).then(function (content) {
                _this.tpmSignPostParams = {
                    message: content,
                    title: _this.i18nService.getString('Common', 'help'),
                    class: ''
                };
            });
        };
        VmHardwareTpmController.prototype.isTpmRemovalDisabled = function () {
            return this.vmPoweredOn;
        };
        VmHardwareTpmController.prototype.onCertificateUpdate = function (uploadedCertificate, originalCertificate) {
            var index = originalCertificate.id;
            if (Array.isArray(this.device.endorsementKeyCertificate) &&
                this.device.endorsementKeyCertificate.length > 0) {
                this.device.endorsementKeyCertificate[index] = {
                    value: this.vmTpmService.stripHeadersFromCertificate(uploadedCertificate.rawData)
                };
            }
            this.tpmCertificates[index] = uploadedCertificate;
        };
        VmHardwareTpmController.prototype.onTpmRemoval = function () {
            if (this.tpmDevice.isNew()) {
                this.removeCallback()(this.tpmDevice);
            }
            else {
                this.showModal = true;
            }
        };
        VmHardwareTpmController.prototype.onAcceptModalWarning = function () {
            this.showModal = false;
            this.removeCallback()(this.tpmDevice);
        };
        VmHardwareTpmController.prototype.onCancelModalWarning = function () {
            this.showModal = false;
        };
        VmHardwareTpmController.$inject = [
            'i18nService',
            'templateHelperService',
            'vmTpmService'
        ];
        return VmHardwareTpmController;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareTpm', new VmHardwareTpm());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareUsbControllerCtrl = (function () {
        function VmHardwareUsbControllerCtrl(i18nService) {
            this.i18nService = i18nService;
            this.i18n = function (key) {
                var rest = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    rest[_i - 1] = arguments[_i];
                }
                return i18nService.getString("VmUi", "USBControllerPage." + key, rest);
            };
        }
        VmHardwareUsbControllerCtrl.prototype.$onInit = function () {
            this.rawDevice = this.inflatedDevice.getCurrentDevice();
        };
        VmHardwareUsbControllerCtrl.prototype.getDeviceLabel = function () {
            if (!this.rawDevice) {
                return "";
            }
            else {
                return this.rawDevice.deviceInfo.label;
            }
        };
        VmHardwareUsbControllerCtrl.prototype.isUnsupportedByGuest = function () {
            return h5_vm.VmHardwareUsbControllerUtil.isUnsupportedByGuest(this.inflatedDevice, this.selectedGuestOs);
        };
        VmHardwareUsbControllerCtrl.prototype.getUSBLabel = function () {
            if (!this.rawDevice) {
                return "";
            }
            var type = this.rawDevice._type;
            return this.getUsbTypeLabel(type);
        };
        VmHardwareUsbControllerCtrl.prototype.getUsbTypeList = function () {
            var options = this.vmConfigContext.environment.configOption.hardwareOptions.virtualDeviceOption;
            var usb3option = _.find(options, function (item) {
                return item.type.wsdlName === "VirtualUSBXHCIController";
            });
            var retVal = [
                h5_vm.VmHardwareUsbControllerUtil.GetUsb20VmodlType()
            ];
            if (usb3option) {
                retVal.push(h5_vm.VmHardwareUsbControllerUtil.GetUsb30VmodlType());
            }
            return retVal;
        };
        VmHardwareUsbControllerCtrl.prototype.getUsbTypeLabel = function (value) {
            var i18nKey = h5_vm.VmHardwareUsbControllerUtil.GetUsbTypeI18nKey(value);
            return this.i18nService.getString("VmUi", i18nKey);
        };
        Object.defineProperty(VmHardwareUsbControllerCtrl.prototype, "usbType", {
            get: function () {
                return this.rawDevice._type;
            },
            set: function (value) {
                this.rawDevice._type = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareUsbControllerCtrl.prototype.isUsbTypeEditable = function () {
            if (this.inflatedDevice && this.inflatedDevice.isNew()) {
                return true;
            }
            else {
                return false;
            }
        };
        VmHardwareUsbControllerCtrl.prototype.isMarkedForRemoval = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            else {
                return this.inflatedDevice.isMarkedForRemoval();
            }
        };
        VmHardwareUsbControllerCtrl.prototype.isRemoveDisabled = function () {
            return h5_vm.VmHardwareUsbControllerUtil.isRemovalDisabled(this.inflatedDevice, this.virtualMachineDevices, this.vmConfigContext, this.vmWorkflowMode);
        };
        VmHardwareUsbControllerCtrl.prototype.removeDevice = function () {
            if (!this.isRemoveDisabled() && this.removeCallback) {
                this.removeCallback()(this.inflatedDevice);
            }
        };
        VmHardwareUsbControllerCtrl.prototype.revertRemoval = function () {
            if (this.inflatedDevice) {
                this.inflatedDevice.revertRemoval();
            }
        };
        VmHardwareUsbControllerCtrl.$inject = [
            "i18nService"
        ];
        return VmHardwareUsbControllerCtrl;
    }());
    var VmHardwareUsbControllerComponent = (function () {
        function VmHardwareUsbControllerComponent() {
            this.bindings = {
                inflatedDevice: "<",
                selectedGuestOs: "<",
                removeCallback: "&",
                vmConfigContext: "<",
                virtualMachineDevices: "<",
                vmWorkflowMode: "<",
                expanded: "="
            };
            this.controller = VmHardwareUsbControllerCtrl;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareUsbController/vm-hardware-usb-controller.html";
        }
        return VmHardwareUsbControllerComponent;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareUsbController", new VmHardwareUsbControllerComponent());
})(h5_vm || (h5_vm = {}));



var VmWorkflowMode = h5_vm.VmWorkflowMode;
var VmHardwareUsbControllerInput = (function () {
    function VmHardwareUsbControllerInput() {
    }
    return VmHardwareUsbControllerInput;
}());



var h5_vm;
(function (h5_vm) {
    var VmHardwareUtil = h5_vm.VmHardwareUtil;
    var DeviceTypeConstants = h5_vm.DeviceTypeConstants;
    var VmHardwareUsbControllerUtil = (function () {
        function VmHardwareUsbControllerUtil() {
        }
        VmHardwareUsbControllerUtil.GetUsb20VmodlType = function () {
            return "com.vmware.vim.binding.vim.vm.device.VirtualUSBController";
        };
        VmHardwareUsbControllerUtil.GetUsb30VmodlType = function () {
            return "com.vmware.vim.binding.vim.vm.device.VirtualUSBXHCIController";
        };
        VmHardwareUsbControllerUtil.isUnsupportedByGuest = function (inflatedDevice, guest) {
            var devType = inflatedDevice.getCurrentDevice()._type;
            var list = guest.supportedUSBControllerList;
            if (!_.find(list, function (item) { return item.typeClass === devType; })) {
                return true;
            }
            else {
                return false;
            }
        };
        VmHardwareUsbControllerUtil.GetUsbTypeI18nKey = function (type) {
            if (type === h5_vm.VmHardwareUsbControllerUtil.GetUsb20VmodlType()) {
                return 'USBController.USB20';
            }
            if (type === h5_vm.VmHardwareUsbControllerUtil.GetUsb30VmodlType()) {
                return ('USBController.USB30');
            }
            return "";
        };
        VmHardwareUsbControllerUtil.isRemovalDisabled = function (inflatedUSBcontroller, virtualMachineDevices, ctx, workflow) {
            var updateVm = workflow === h5_vm.VmWorkflowMode.UpdateMode;
            if (!inflatedUSBcontroller) {
                return true; // DISABLE removal
            }
            var rawDevice = inflatedUSBcontroller.getCurrentDevice();
            if (!rawDevice) {
                return true; // DISABLE removal
            }
            if (!inflatedUSBcontroller.isNew()) {
                if (!VmHardwareUtil.userHasAddRemoveDevicePermission(ctx)) {
                    return true; // DISABLE removal
                }
            }
            if (updateVm && VmHardwareUtil.isSuspended(ctx)) {
                return true; // DISABLE removal for suspended VM (editing)
            }
            if (VmHardwareUsbControllerUtil.hasAttachedDevices(rawDevice)) {
                // So, if there are elements there,
                // this would be existing controller with existing USB devices assigned to this controller.
                // Even if we are about to remove USB devices assigned to this USB controller,
                // we'd rather wait till reconfigure actually remove all those devices and ensure that controller gets empty.
                // We might allow removal of USB controller with devices still on it, if devices also marked for removal,
                // but we normally not doing this in UI.
                // Backend actually allows removal of controller with devices attached
                // and it might be OK to allow this in UI when VM is powered off.
                return true; // disable removal
            }
            // we get here if we don't have any pre-existing USB devices on ths USB controller
            var newUSBList = virtualMachineDevices.newDevicesOfType(DeviceTypeConstants.VIRTUAL_USB);
            if (!newUSBList || newUSBList.length === 0) {
                return false; // ENABLE removal, as we dont' have any new devices.
            }
            // We have some new USB devices, so we need to keep at least one USB controller:
            // either USB 2.0 or USB 3.0
            if (VmHardwareUsbControllerUtil.isSecondUSBControllerAvailable(rawDevice, virtualMachineDevices)) {
                return false; // ENABLE removal, as we have alternate USB controller to host new USB devices
            }
            return true; // DISABLE removal as we adding USB devices and there is no backup USB controller
        };
        VmHardwareUsbControllerUtil.isSecondUSBControllerAvailable = function (rawDevice, virtualMachineDevices) {
            // It's possible to have one USB 2.0 controller and one USB 3.0 controller.
            var usb20type = VmHardwareUsbControllerUtil.GetUsb20VmodlType();
            var usb30type = VmHardwareUsbControllerUtil.GetUsb30VmodlType();
            // typeA is type of "this one" of rawDevice
            var typeA = rawDevice._type;
            // typeB is "the other one", i.e. if current one is USB 3.0,
            //  there other one is USB 20 and another way around
            var typeB = typeA === usb20type ? usb30type : usb20type;
            var typeBList = virtualMachineDevices.devicesNotMarkedForRemovalOfType(typeB);
            if (typeBList && typeBList.length > 0) {
                return true;
            }
            return false;
        };
        VmHardwareUsbControllerUtil.hasAttachedDevices = function (rawUSBController) {
            if (!rawUSBController) {
                return false;
            }
            if (!rawUSBController.device) {
                return false;
            }
            // vim.vm.VirtualDevice.device is array containing keys of devices
            // attached to this controller.
            // In case of USB controller we don't modify this array (hopefully).
            var existingUsbDevicesKeys = rawUSBController.device;
            if (!existingUsbDevicesKeys) {
                return false;
            }
            if (rawUSBController.device.length > 0) {
                return true;
            }
            return false;
        };
        VmHardwareUsbControllerUtil.areBothUSBControllerMarkedForRemoval = function (virtualMachineDevices) {
            var usb20removal = virtualMachineDevices.devicesMarkedForRemovalOfType(DeviceTypeConstants.VIRTUAL_USB_CONTROLLER);
            var usb30removal = virtualMachineDevices.devicesMarkedForRemovalOfType(DeviceTypeConstants.VIRTUAL_USB_XHCI_CONRTOLLER);
            if (!usb20removal || !usb30removal) {
                return false;
            }
            if (usb20removal.length > 0 && usb30removal.length > 0) {
                return true;
            }
            return false;
        };
        return VmHardwareUsbControllerUtil;
    }());
    h5_vm.VmHardwareUsbControllerUtil = VmHardwareUsbControllerUtil;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareUsbDeviceComponent = (function () {
        function VmHardwareUsbDeviceComponent() {
            this.bindings = {
                inflatedDevice: "<",
                selectedGuestOs: "<",
                removeCallback: "&",
                vmConfigContext: "<",
                expanded: "="
            };
            this.controller = VmHardwareUsbDeviceController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareUsbDevice/vm-hardware-usb-device.html";
        }
        return VmHardwareUsbDeviceComponent;
    }());
    var VmHardwareUsbDeviceController = (function () {
        function VmHardwareUsbDeviceController(i18nService) {
            this.i18nService = i18nService;
            this.i18n = function (key) {
                var rest = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    rest[_i - 1] = arguments[_i];
                }
                return i18nService.getString("VmUi", "USBDevicePage." + key, rest);
            };
        }
        VmHardwareUsbDeviceController.prototype.$onInit = function () {
            this.usb = this.inflatedDevice;
            this.i18n = this.usb.i18n;
            this.usb.onInit(this.vmConfigContext);
        };
        VmHardwareUsbDeviceController.prototype.$postLink = function () {
            this.validateUSBSelection();
        };
        VmHardwareUsbDeviceController.prototype.getDeviceLabel = function () {
            return this.usb.getDeviceLabel();
        };
        VmHardwareUsbDeviceController.prototype.getUsbDeviceLabel = function () {
            return this.usb.getUsbDeviceLabel(this.vmConfigContext);
        };
        VmHardwareUsbDeviceController.prototype.isMarkedForRemoval = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            else {
                return this.inflatedDevice.isMarkedForRemoval();
            }
        };
        VmHardwareUsbDeviceController.prototype.hasError = function () {
            return this.isNew() && !this.usb.isDeviceAvailable();
        };
        VmHardwareUsbDeviceController.prototype.isRemoveDisabled = function () {
            return !this.usb.isRemovalEnabled();
        };
        VmHardwareUsbDeviceController.prototype.removeDevice = function () {
            if (this.usb.hostUsb) {
                this.usb.hostUsb.taken = false;
            }
            if (!this.isRemoveDisabled() && this.removeCallback) {
                this.removeCallback()(this.inflatedDevice);
            }
        };
        VmHardwareUsbDeviceController.prototype.revertRemoval = function () {
            this.inflatedDevice.revertRemoval();
        };
        VmHardwareUsbDeviceController.prototype.isNew = function () {
            return this.inflatedDevice && this.inflatedDevice.isNew();
        };
        VmHardwareUsbDeviceController.prototype.getHostUsbList = function () {
            var array = this.vmConfigContext.environment.configTarget.usb;
            return array;
        };
        VmHardwareUsbDeviceController.prototype.getHostUsbLabel = function (item) {
            if (!item) {
                return "";
            }
            return item.description;
        };
        Object.defineProperty(VmHardwareUsbDeviceController.prototype, "hostUsb", {
            get: function () {
                return this.usb.hostUsb;
            },
            set: function (value) {
                if (!value) {
                    return;
                }
                var oldValue = this.usb.hostUsb;
                this.usb.hostUsb = value;
                value.taken = true;
                if (oldValue) {
                    oldValue.taken = false;
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareUsbDeviceController.prototype.isDevicePresent = function () {
            return this.usb.isDevicePresent();
        };
        VmHardwareUsbDeviceController.prototype.validateUSBSelection = function () {
            var error = this.hasError();
            var formName = "vmHardwareUsbDevice";
            this.usbError = {
                message: this.getDeviceAvailableText(),
                isVisible: error
            };
            this.vmHardwareUsbDevice.$setValidity("newDevice", !error);
        };
        Object.defineProperty(VmHardwareUsbDeviceController.prototype, "USBUniqueID", {
            get: function () {
                return this.usb.getUSBUniqueID();
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareUsbDeviceController.prototype.getUSBConnectionStatusText = function () {
            return this.usb.getUSBConnectionStatusText();
        };
        VmHardwareUsbDeviceController.prototype.getVMotionSupportText = function () {
            return this.usb.getVMotionSupportText();
        };
        // Section for new USB device
        VmHardwareUsbDeviceController.prototype.getDeviceAvailableText = function () {
            return this.usb.getDeviceAvailableText();
        };
        Object.defineProperty(VmHardwareUsbDeviceController.prototype, "vMotion", {
            get: function () {
                return this.usb.vMotion;
            },
            set: function (value) {
                this.usb.vMotion = value;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareUsbDeviceController.$inject = [
            "i18nService",
        ];
        return VmHardwareUsbDeviceController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareUsbDevice", new VmHardwareUsbDeviceComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VirtualUSB$RemoteClientBackingInfo = com.vmware.vim.binding.vim.vm.device.VirtualUSB$RemoteClientBackingInfo;
    var VmHardwareUsbDeviceUtil = (function () {
        function VmHardwareUsbDeviceUtil() {
        }
        VmHardwareUsbDeviceUtil.getUsbTargetDescription = function (rawDevice, vmConfigContext) {
            if (!rawDevice || !rawDevice.backing) {
                return "";
            }
            var backing = rawDevice.backing;
            var deviceInfo = rawDevice.deviceInfo;
            if (backing._type === VmHardwareUsbDeviceUtil.clientUsb) {
                return deviceInfo.summary;
            }
            var info = VmHardwareUsbDeviceUtil.getTargetUsbInfo(rawDevice, vmConfigContext);
            if (info) {
                return info.description;
            }
            var deviceBacking = backing;
            return deviceBacking.deviceName;
        };
        VmHardwareUsbDeviceUtil.getTargetUsbInfo = function (rawDevice, vmConfigContext) {
            if (!rawDevice || !rawDevice.backing) {
                return null;
            }
            if (!vmConfigContext) {
                return null;
            }
            var backing = rawDevice.backing;
            if (!backing.hasOwnProperty("deviceName")) {
                return null; // client usb backing
            }
            var deviceName = backing['deviceName'];
            var usbTargets = vmConfigContext.environment.configTarget.usb;
            var info = _.find(usbTargets, function (info) {
                return (info && info.physicalPath === deviceName);
            });
            if (info) {
                return info;
            }
            return null;
        };
        VmHardwareUsbDeviceUtil.getUSBUniqueID = function (rawDevice) {
            if (!rawDevice || !rawDevice.backing) {
                return "";
            }
            var backing = rawDevice.backing;
            if (!backing.hasOwnProperty("deviceName")) {
                return ""; // client usb backing
            }
            var hostname = !backing.hasOwnProperty("hostname")
                ? "localhost" // local backing
                : backing["hostname"]; // remote backing
            var deviceName = backing['deviceName'];
            return "host: " + hostname + " device: " + deviceName;
        };
        VmHardwareUsbDeviceUtil.clientUsb = new VirtualUSB$RemoteClientBackingInfo()._type;
        return VmHardwareUsbDeviceUtil;
    }());
    h5_vm.VmHardwareUsbDeviceUtil = VmHardwareUsbDeviceUtil;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVideocardController = (function () {
        function VmHardwareVideocardController(i18nService) {
            this.i18nService = i18nService;
            this.ARIA_LBL_VIDEO = this.i18n2('Title');
            this.ARIA_LBL_NUM_DISPLAYS = this.i18n2('NumberOfDisplays');
            this.ARIA_LBL_VRAM = this.i18n2('TotalVideoMemory');
            this.ARIA_LBL_3D = this.i18n2('3DGraphics');
            this.ARIA_LBL_3DRNDR = this.i18n2('3DRenderer');
            this.ARIA_LBL_3DRAM = this.i18n2('3DMemory');
            this.expanded = false;
            return;
        }
        VmHardwareVideocardController.prototype.i18n2 = function (key, section) {
            if (section === void 0) { section = "VideoCardPage"; }
            var retVal = this.i18nService.getString("VmUi", section + "." + key);
            return retVal;
        };
        VmHardwareVideocardController.prototype.i18n = function (key) {
            if (this.inflatedDevice) {
                return this.inflatedDevice.i18n(key);
            }
            return "";
        };
        VmHardwareVideocardController.prototype.isReady = function () {
            if (!this.inflatedDevice) {
                return false;
            }
            return true;
        };
        VmHardwareVideocardController.prototype.hasChanged = function () {
            if (this.isReady()) {
                return this.inflatedDevice.hasChanged();
            }
            else {
                return false;
            }
        };
        VmHardwareVideocardController.prototype.$postLink = function () {
            this.videoRamSizeInKB_Validatate();
            this.graphicsMemorySizeInMB_Validate();
        };
        VmHardwareVideocardController.prototype.hasError = function () {
            if (!_.isEmpty(this.vmHardwareVideoCardForm)) {
                return this.vmHardwareVideoCardForm.$invalid;
            }
            return false;
        };
        ;
        // PART 0 useAutoDetect
        VmHardwareVideocardController.prototype.useAutoDetect_List = function () {
            if (this.isReady()) {
                return this.inflatedDevice.useAutoDetect_List();
            }
            return [];
        };
        VmHardwareVideocardController.prototype.useAutoDetect_Text = function (value) {
            if (this.isReady()) {
                return this.inflatedDevice.useAutoDetect_Text(value);
            }
            return "";
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "useAutoDetect", {
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.useAutoDetect;
                }
                return false;
            },
            set: function (value) {
                if (this.isReady()) {
                    this.inflatedDevice.useAutoDetect = value;
                    this.expandIfCustomSettings();
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.expandIfCustomSettings = function () {
            if (!this.isReady()) {
                return;
            }
            if (this.inflatedDevice.useAutoDetect) {
                return;
            }
            this.expanded = true;
        };
        VmHardwareVideocardController.prototype.useAutoDetect_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.useAutoDetect_isEditDisabled();
            }
            else {
                return true;
            }
        };
        // PART 1 videoRamSizeInKB
        VmHardwareVideocardController.prototype.videoRamSizeInKB_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.videoRamSizeInKB_isEditDisabled();
            }
            return true;
        };
        VmHardwareVideocardController.prototype.videoRamSizeInKB_isInvalid = function () {
            if (this.isReady()) {
                return this.inflatedDevice.videoRamSizeInKB_isInvalid();
            }
            else {
                return false;
            }
        };
        VmHardwareVideocardController.prototype.videoRamSizeInKB_getError = function () {
            if (this.isReady()) {
                return this.inflatedDevice.videoRamSizeInKB_getError();
            }
            else {
                return "";
            }
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "videoRamSizeInKB", {
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.videoRamSizeInKB;
                }
                else {
                    return "";
                }
            },
            set: function (value) {
                if (this.isReady()) {
                    this.inflatedDevice.videoRamSizeInKB = value;
                    this.videoRamSizeInKB_Validatate();
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.videoRamSizeInKB_Validatate = function () {
            if (this.isReady()) {
                var invalid = this.inflatedDevice.videoRamSizeInKB_isInvalid();
                this.setValidityByName('videoRamSizeInKB', invalid);
            }
        };
        VmHardwareVideocardController.prototype.setValidityByName = function (name, invalid) {
            if (!this.isReady()) {
                return;
            }
            var ngmc = this.vmHardwareVideoCardForm[name];
            if (ngmc) {
                var key = name + "_value";
                var valid = !invalid;
                ngmc.$setValidity(key, valid);
            }
        };
        // PART 2 numberOfDisplays
        VmHardwareVideocardController.prototype.numberOfDisplays_List = function () {
            if (this.isReady()) {
                return this.inflatedDevice.numDisplays_getList();
            }
            return [];
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "numberOfDisplays", {
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.numDisplays;
                }
                return 1;
            },
            set: function (value) {
                if (this.isReady()) {
                    this.inflatedDevice.numDisplays = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.numberOfDisplays_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.numDisplays_isEditDisabled();
            }
            return true;
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "enable3DSupport", {
            // PART 3 enable3DSupport
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.enable3DSupport;
                }
                else {
                    return false;
                }
            },
            set: function (value) {
                if (this.isReady()) {
                    this.inflatedDevice.enable3DSupport = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.enable3DSupport_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.enable3DSupport_isEditDisabled();
            }
            return true;
        };
        VmHardwareVideocardController.prototype.enable3DSupport_isVisible = function () {
            if (this.isReady()) {
                return this.inflatedDevice.enable3DSupport_isVisible();
            }
            else {
                return true;
            }
        };
        // PART 4 use3dRenderer
        VmHardwareVideocardController.prototype.use3dRenderer_isVisible = function () {
            if (this.isReady()) {
                return this.inflatedDevice.use3dRenderer_isVisible();
            }
            else {
                return true;
            }
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "use3dRenderer", {
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.use3dRenderer;
                }
                return "";
            },
            set: function (value) {
                if (this.isReady()) {
                    this.inflatedDevice.use3dRenderer = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.use3dRenderer_List = function () {
            if (this.isReady()) {
                return this.inflatedDevice.use3dRenderer_List();
            }
            return [];
        };
        VmHardwareVideocardController.prototype.use3dRenderer_Text = function (value) {
            if (this.isReady()) {
                return this.inflatedDevice.use3dRenderer_Text(value);
            }
            return "";
        };
        VmHardwareVideocardController.prototype.use3dRenderer_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.use3dRenderer_isEditDisabled();
            }
            return true;
        };
        Object.defineProperty(VmHardwareVideocardController.prototype, "graphicsMemorySizeInMB", {
            // PART 5 graphicsMemorySizeInKB
            get: function () {
                if (this.isReady()) {
                    return this.inflatedDevice.graphicsMemorySizeInMB;
                }
                return "";
            },
            set: function (text) {
                if (this.isReady()) {
                    this.inflatedDevice.graphicsMemorySizeInMB = text;
                    this.graphicsMemorySizeInMB_Validate();
                }
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVideocardController.prototype.graphicsMemorySizeInMB_Validate = function () {
            if (this.isReady()) {
                var invalid = this.inflatedDevice.graphicsMemorySizeInMB_isInvalid();
                this.setValidityByName('graphicsMemorySizeInMB', invalid);
            }
        };
        VmHardwareVideocardController.prototype.graphicsMemorySizeInMB_isEditDisabled = function () {
            if (this.isReady()) {
                return this.inflatedDevice.graphicsMemorySizeInMB_isEditDisabled();
            }
            else {
                return true;
            }
        };
        VmHardwareVideocardController.prototype.graphicsMemorySizeInMB_isVisible = function () {
            if (!this.isReady()) {
                return false;
            }
            return this.inflatedDevice.graphicsMemorySizeInMB_isVisible();
        };
        VmHardwareVideocardController.prototype.graphicsMemorySizeInMB_isInvalid = function () {
            if (this.isReady()) {
                return this.inflatedDevice.graphicsMemorySizeInMB_isInvalid();
            }
            else {
                return false;
            }
        };
        VmHardwareVideocardController.prototype.graphicsMemorySizeInMB_getError = function () {
            if (this.isReady()) {
                return this.inflatedDevice.graphicsMemorySizeInMB_getError();
            }
            else {
                return "";
            }
        };
        VmHardwareVideocardController.prototype.getAutoIncreaseText = function () {
            if (this.isReady()) {
                return this.inflatedDevice.getAutoIncreaseText();
            }
            else {
                return "";
            }
        };
        VmHardwareVideocardController.prototype.getAutoIncreaseVisible = function () {
            if (this.isReady()) {
                return this.inflatedDevice.getAutoIncreaseVisible();
            }
            else {
                return false;
            }
        };
        VmHardwareVideocardController.$inject = ["i18nService"];
        return VmHardwareVideocardController;
    }());
    var VmHardwareVideocardComponent = (function () {
        function VmHardwareVideocardComponent(bindings, controller, templateUrl) {
            if (bindings === void 0) { bindings = { inflatedDevice: '<' }; }
            if (controller === void 0) { controller = VmHardwareVideocardController; }
            if (templateUrl === void 0) { templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVideoCard/vm-hw-video-card.html'; }
            this.bindings = bindings;
            this.controller = controller;
            this.templateUrl = templateUrl;
        }
        return VmHardwareVideocardComponent;
    }());
    angular.module('com.vmware.vsphere.client.vm').component('vmHardwareVideoCard', new VmHardwareVideocardComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var RENDERER = (function () {
        function RENDERER() {
        }
        RENDERER.AUTOMATIC = "automatic";
        RENDERER.SOFTWARE = "software";
        RENDERER.HARDWARE = "hardware";
        return RENDERER;
    }());
    var VirtualVideoCardClass = (function () {
        function VirtualVideoCardClass(video, isScheduledTask) {
            if (isScheduledTask === void 0) { isScheduledTask = false; }
            this.OP_ADD = "add";
            this.videoRamSizeText = null;
            this.videoRamSizeInKB_Error = "";
            // Logic to bump videoRamSize when user enables 3D support - ----------------------
            this.preBumpVideoMemoryInKB = undefined;
            this.autoIncreaseInfoText = "";
            this.autoIncreaseInfoVisible = false;
            this._graphicsMemorySizeInMB = null;
            this.graphicsMemorySizeInMBError = "";
            this.base = this;
            this.rawDevice = video;
            this.isScheduledTask = isScheduledTask;
            this.originalDevice = angular.copy(video);
        }
        VirtualVideoCardClass.prototype.attachVmConfig = function (value) {
            if (this.vmConfig || !value) {
                return;
            }
            this.vmConfig = value;
            this.onVmConfigAttached();
        };
        VirtualVideoCardClass.prototype.onVmConfigAttached = function () {
            this.rawDevice = this.base.getCurrentDevice();
            if (!this.vm) {
                return;
            }
            this.option = this.vm.getVideoCardOption();
            this.guest = this.vm.getGuestOsDescriptror();
            this.i18nService = this.vm.getI18nService();
            if (this.vm.isCreate) {
                VirtualVideoCardClass.fixNewVideoCard(this.rawDevice, this.option, this.guest, this.isScheduledTask);
                this.fixDeviceSpecOp();
            }
        };
        VirtualVideoCardClass.prototype.fixDeviceSpecOp = function () {
            var spec = this.base.getCurrentDeviceSpec();
            if (this.vm.isCreate) {
                spec.operation = this.OP_ADD;
            }
        };
        VirtualVideoCardClass.fixNewVideoCard = function (video, option, guest, isScheduledTask) {
            if (isScheduledTask === void 0) { isScheduledTask = false; }
            if (!video) {
                return;
            }
            if (!video.useAutoDetect) {
                video.useAutoDetect = false;
            }
            if (!video.numDisplays) {
                video.numDisplays = 1;
            }
            if (!video.videoRamSizeInKB && guest) {
                video.videoRamSizeInKB = guest.vRAMSizeInKB.defaultValue;
            }
            // In case the device is restored from a scheduled task
            // use the device's enable3DSupport value
            // Otherwise use virtual HW default as starting point
            // defaultValue seems to be false for HWv13, but true for HWv14??
            // Note that this is guest-agnostic default value.
            // Alternatively we could use guest.recommended3D - TBD
            if (!isScheduledTask) {
                video.enable3DSupport = option ? option.support3D.defaultValue : false;
            }
            if (guest && !guest.supports3D) {
                // Override vHW default, force enable3D to false if unsupported by guest,
                video.enable3DSupport = false;
            }
            if (!video.use3dRenderer && option && option.use3dRendererSupported) {
                if (option.use3dRendererSupported.supported) {
                    video.use3dRenderer = RENDERER.AUTOMATIC;
                }
            }
            if (!video.graphicsMemorySizeInKB && option) {
                if (option.graphicsMemorySizeSupported
                    && option.graphicsMemorySizeSupported.supported) {
                    // && option.graphicsMemorySizeSupported.defaultValue) {
                    video.graphicsMemorySizeInKB = option.graphicsMemorySizeInKB.defaultValue;
                }
            }
        };
        VirtualVideoCardClass.prototype.i18n = function (key) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (this.i18nService) {
                return this.i18nService.getString('VmUi', 'VideoCardPage.' + key, rest);
            }
            else {
                return "";
            }
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "vm", {
            get: function () {
                return this.vmConfig;
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.hasChanged = function () {
            if (!this.rawDevice) {
                return false;
            }
            else {
                return this.base.hasChanged();
            }
        };
        VirtualVideoCardClass.prototype.isEditDeviceDisabled = function () {
            if (!this.vm) {
                return true;
            }
            return this.vm.isEditDeviceDisabled();
        };
        VirtualVideoCardClass.prototype.reduceKB2MB = function (value) {
            if (!value) {
                return 0;
            }
            var retVal = value / 1024;
            return retVal;
        };
        VirtualVideoCardClass.prototype.increaseMB2KB = function (value) {
            if (!value) {
                return 0;
            }
            var retVal = value * 1024;
            return retVal;
        };
        VirtualVideoCardClass.prototype.formatKB2MB = function (valueInKB) {
            if (valueInKB === null) {
                return "";
            }
            if (angular.isUndefined(valueInKB)) {
                return "";
            }
            var megabytes = this.reduceKB2MB(valueInKB);
            return megabytes.toString();
        };
        // PART 1 - AUTODETECT ------------------------------------------------------------
        VirtualVideoCardClass.prototype.useAutoDetect_List = function () {
            return [true, false];
        };
        VirtualVideoCardClass.prototype.useAutoDetect_Text = function (value) {
            if (value) {
                return this.i18n('AutoDetect');
            }
            else {
                return this.i18n('SpecifyCustom');
            }
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "useAutoDetect", {
            get: function () {
                return this.rawDevice.useAutoDetect;
            },
            set: function (value) {
                this.rawDevice.useAutoDetect = value;
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.useAutoDetect_isEditDisabled = function () {
            return this.isEditDeviceDisabled();
        };
        // PART 2 - VIDEO MEMORY ----------------------------------------------------------
        // videoRamSizeInKB maximum was 128MB for VM versions 4,7 and 8
        // In VM version 8 VMware added 3D graphics
        // Then we realized that 128MB is tight for 3D graphics
        // So, in VM version 9 max for videoRam was increase to 512.
        // And same was for VM version 10 - 512MB max
        // Then for VM version 11, dedicated graphics memory was
        // introduced to handle 3D.
        // At the same time max videoRamSize dropped back to 128MB
        VirtualVideoCardClass.prototype.videoRamSizeInKB_isEditDisabled = function () {
            if (this.useAutoDetect) {
                return true;
            }
            return this.isEditDeviceDisabled();
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "videoRamSizeInKB", {
            get: function () {
                if (this.videoRamSizeText === null) {
                    this.initVideoRamSizeText();
                }
                if (this.videoRamSizeText === null) {
                    return "";
                }
                return this.videoRamSizeText;
            },
            set: function (textMB) {
                if (textMB === this.videoRamSizeText) {
                    return;
                }
                this.videoRamSizeText = textMB;
                var valueInMB = parseFloat(textMB);
                var valueInKb = this.increaseMB2KB(valueInMB);
                this.videoRamSizeInKB_Error = this.videoRamSizeInKB_validate(valueInKb);
                this.rawDevice.videoRamSizeInKB = this.increaseMB2KB(valueInMB);
                return;
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.initVideoRamSizeText = function () {
            if (!this.rawDevice) {
                return;
            }
            var valueInKB = this.rawDevice.videoRamSizeInKB;
            this.videoRamSizeText = this.formatKB2MB(valueInKB);
        };
        VirtualVideoCardClass.prototype.videoRamSizeInKB_isInvalid = function () {
            if (this.videoRamSizeInKB_Error) {
                return true;
            }
            else {
                return false;
            }
        };
        VirtualVideoCardClass.prototype.videoRamSizeInKB_getError = function () {
            return this.videoRamSizeInKB_Error;
        };
        VirtualVideoCardClass.prototype.videoRamSizeInKB_validate = function (value) {
            if (!this.option) {
                return "";
            }
            var max = this.option.videoRamSizeInKB.max;
            var min = this.option.videoRamSizeInKB.min;
            if (value < min || value > max) {
                return this.formatRangeError(min / 1024, max / 1024, 'TotalVideoMemory');
            }
            else {
                return "";
            }
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "numDisplays", {
            // PART 3 - NUMBER OF DISPLAYS (numDisplays) --------------------------------------
            // For VM version 4 we support only one display (aka monitor).
            // Since VM version 7, max coming as 10.
            // But for some reasons Flex UI hard limited numDisplays to 4.
            get: function () {
                return this.rawDevice.numDisplays;
            },
            set: function (value) {
                if (this.rawDevice.numDisplays === value) {
                    return;
                }
                var oldValue = this.rawDevice.numDisplays;
                this.rawDevice.numDisplays = value;
                this.afterNumDisplaysChanged(oldValue, value);
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.afterNumDisplaysChanged = function (oldValue, newValue) {
            var delta = newValue - oldValue;
            if (!this.enable3DSupport) {
                return;
            }
            if (this.graphicsMemorySupported()) {
                return;
            }
            this.bumpUpVideoRamByMB(delta * 16);
        };
        VirtualVideoCardClass.prototype.numDisplays_isEditDisabled = function () {
            if (this.useAutoDetect) {
                return true;
            }
            return this.isEditDeviceDisabled();
        };
        VirtualVideoCardClass.prototype.numDisplays_getList = function () {
            if (!this._numDisplays_List_Cached) {
                this.numDisplays_List_init();
            }
            return this._numDisplays_List_Cached;
        };
        VirtualVideoCardClass.prototype.numDisplays_List_init = function () {
            var max = this.get_numDisplays_max();
            var array = [];
            for (var value = 1; value <= max; value++) {
                array.push(value);
            }
            this._numDisplays_List_Cached = array;
        };
        VirtualVideoCardClass.prototype.get_numDisplays_max = function () {
            var retVal = 0;
            if (this.option && this.option.numDisplays) {
                retVal = this.option.numDisplays.max;
            }
            if (!retVal) {
                retVal = 4;
            }
            return retVal;
        };
        //  -- PART 4 - enable3DSupport (true/false) ----------------------------------------------
        VirtualVideoCardClass.prototype.enable3DSupport_isVisible = function () {
            if (this.enable3DSupport) {
                // already enabled, so we better show it
                return true;
            }
            return true;
        };
        VirtualVideoCardClass.prototype.enable3DSupport_isEditDisabled = function () {
            if (this.isEditDeviceDisabled()) {
                return true;
            }
            if (this.enable3DSupport) {
                return false;
            }
            if (this.guestLacks3DSupport()) {
                return true;
            }
            return false;
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "enable3DSupport", {
            get: function () {
                return this.rawDevice.enable3DSupport;
            },
            set: function (value) {
                if (value === this.rawDevice.enable3DSupport) {
                    return;
                }
                if (this.enable3DSupport_isEditDisabled()) {
                    return;
                }
                this.rawDevice.enable3DSupport = value;
                this.afterEnable3DSupportChanged(value);
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.afterEnable3DSupportChanged = function (value) {
            if (this.graphicsMemorySupported()) {
                return;
            }
            if (value) {
                this.bump2dMemoryFor3dOps();
            }
            else {
                this.restore2dMemory();
            }
        };
        VirtualVideoCardClass.prototype.bump2dMemoryFor3dOps = function () {
            this.preBumpVideoMemoryInKB = this.rawDevice.videoRamSizeInKB;
            var rawNumDisplays = this.rawDevice.numDisplays;
            var newValueInMB = 64 + (rawNumDisplays - 1) * 16;
            this.bumpVideoRamToMB(newValueInMB);
            if (rawNumDisplays === 1) {
                this.autoIncreaseInfoText = this.i18n('3DAutoIncrease');
            }
            else {
                this.autoIncreaseInfoText = this.i18n('3DAutoIncrease2');
            }
            this.autoIncreaseInfoVisible = true;
        };
        VirtualVideoCardClass.prototype.restore2dMemory = function () {
            if (this.preBumpVideoMemoryInKB) {
                this.updateVideoRamSize(this.preBumpVideoMemoryInKB);
                this.preBumpVideoMemoryInKB = undefined;
            }
            this.autoIncreaseInfoVisible = false;
            this.autoIncreaseInfoText = "";
        };
        VirtualVideoCardClass.prototype.getAutoIncreaseText = function () {
            return this.autoIncreaseInfoText;
        };
        VirtualVideoCardClass.prototype.getAutoIncreaseVisible = function () {
            return this.autoIncreaseInfoVisible;
        };
        VirtualVideoCardClass.prototype.graphicsMemorySupported = function () {
            if (!this.option) {
                return false;
            }
            var boolOption = this.option.graphicsMemorySizeSupported;
            if (!boolOption) {
                return false;
            }
            if (boolOption.supported) {
                return true;
            }
            return false;
        };
        VirtualVideoCardClass.prototype.bumpVideoRamToMB = function (newValueInMB) {
            var newValueInKB = this.trimVideoRamSize(newValueInMB * 1024);
            this.updateVideoRamSize(newValueInKB);
        };
        VirtualVideoCardClass.prototype.bumpUpVideoRamByMB = function (bumpInMB) {
            var oldValueInKB = this.rawDevice.videoRamSizeInKB;
            var newValueInKB = oldValueInKB + (bumpInMB * 1024);
            newValueInKB = this.trimVideoRamSize(newValueInKB);
            this.updateVideoRamSize(newValueInKB);
        };
        VirtualVideoCardClass.prototype.updateVideoRamSize = function (newValueInKB) {
            this.rawDevice.videoRamSizeInKB = newValueInKB;
            this.videoRamSizeText = null;
        };
        VirtualVideoCardClass.prototype.trimVideoRamSize = function (valueInKb) {
            var newValue = valueInKb;
            if (this.option && this.option.videoRamSizeInKB) {
                var max = this.option.videoRamSizeInKB.max;
                if (newValue > max) {
                    newValue = max;
                }
                var min = this.option.videoRamSizeInKB.min;
                if (newValue < min) {
                    newValue = min;
                }
            }
            return newValue;
        };
        VirtualVideoCardClass.prototype.guestLacks3DSupport = function () {
            if (this.guest && !this.guest.supports3D) {
                return true;
            }
            return false;
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "use3dRenderer", {
            // PART 5 - 3D RENDERER (software/hardware/auto) ----------------------------------
            get: function () {
                return this.rawDevice.use3dRenderer;
            },
            set: function (value) {
                this.rawDevice.use3dRenderer = value;
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.use3dRenderer_List = function () {
            return [RENDERER.AUTOMATIC, RENDERER.HARDWARE, RENDERER.SOFTWARE];
        };
        VirtualVideoCardClass.prototype.use3dRenderer_Text = function (value) {
            return this.i18n(value);
        };
        VirtualVideoCardClass.prototype.use3dRenderer_isEditDisabled = function () {
            if (this.isEditDeviceDisabled()) {
                return true;
            }
            if (this.guestLacks3DSupport()) {
                return true;
            }
            if (!this.enable3DSupport) {
                return true;
            }
            return false;
        };
        //   PART 6 - 3D MEMORY (MB) ------------------------------------------------------
        VirtualVideoCardClass.prototype.graphicsMemorySizeInMB_isVisible = function () {
            if (!this.option) {
                return true;
            }
            var boolOption = this.option.graphicsMemorySizeSupported;
            if (boolOption && boolOption.supported) {
                return true;
            }
            return false;
        };
        VirtualVideoCardClass.prototype.graphicsMemorySizeInMB_isEditDisabled = function () {
            if (this.isEditDeviceDisabled()) {
                return true;
            }
            if (this.guestLacks3DSupport()) {
                return true;
            }
            if (!this.enable3DSupport) {
                return true;
            }
            return false;
        };
        Object.defineProperty(VirtualVideoCardClass.prototype, "graphicsMemorySizeInMB", {
            get: function () {
                if (this._graphicsMemorySizeInMB === null) {
                    var value = this.rawDevice.graphicsMemorySizeInKB;
                    var text = "";
                    if (value === null) {
                        text = "";
                    }
                    else {
                        text = (value / 1024).toString();
                    }
                    this._graphicsMemorySizeInMB = text;
                }
                return this._graphicsMemorySizeInMB;
            },
            set: function (text) {
                this._graphicsMemorySizeInMB = text;
                var value = parseFloat(text);
                this.rawDevice.graphicsMemorySizeInKB = value * 1024;
                this.graphicsMemorySizeInMBError = this.graphicsMemorySizeInMB_getErrorText();
            },
            enumerable: true,
            configurable: true
        });
        VirtualVideoCardClass.prototype.graphicsMemorySizeInMB_isInvalid = function () {
            var txt = this.graphicsMemorySizeInMBError;
            if (txt && txt.length > 0) {
                return true;
            }
            else {
                return false;
            }
        };
        VirtualVideoCardClass.prototype.graphicsMemorySizeInMB_getError = function () {
            this.graphicsMemorySizeInMBError = this.graphicsMemorySizeInMB_getErrorText();
            return this.graphicsMemorySizeInMBError;
        };
        VirtualVideoCardClass.prototype.graphicsMemorySizeInMB_getErrorText = function () {
            var SUCCESS = "";
            if (!this.rawDevice) {
                return SUCCESS;
            }
            var valueInKB = this.rawDevice.graphicsMemorySizeInKB;
            if (angular.isUndefined(valueInKB)) {
                return SUCCESS;
            }
            if (!this.option) {
                return SUCCESS;
            }
            var optionInKB = this.option.graphicsMemorySizeInKB;
            if (!optionInKB) {
                return SUCCESS;
            }
            var maxInKB = optionInKB.max;
            var minInKB = optionInKB.min;
            if (valueInKB >= minInKB && valueInKB <= maxInKB) {
                return SUCCESS;
            }
            return this.formatRangeError(minInKB / 1024, maxInKB / 1024, '3DMemory');
        };
        VirtualVideoCardClass.prototype.formatRangeError = function (min, max, name) {
            name = this.i18n(name);
            var mbSuffix = " " + this.i18n("MB");
            var lower = min.toLocaleString() + mbSuffix;
            var upper = max.toLocaleString() + mbSuffix;
            var format = "Util.Validation.ValidRange"; //{0} must be between {1} and {2}.
            var retVal = this.i18nService.getString("VmUi", format, name, lower, upper);
            return retVal;
        };
        VirtualVideoCardClass.prototype.use3dRenderer_isVisible = function () {
            if (!this.option) {
                return true;
            }
            var booleOption = this.option.use3dRendererSupported;
            if (booleOption && booleOption.supported) {
                return true;
            }
            return false;
        };
        return VirtualVideoCardClass;
    }());
    h5_vm.VirtualVideoCardClass = VirtualVideoCardClass;
    function GetVirtualVideoCardClass(EditableVirtualDevice) {
        var factoryFn = function (rawDevice, isScheduledTask) {
            if (isScheduledTask === void 0) { isScheduledTask = false; }
            var instance = new VirtualVideoCardClass(rawDevice, isScheduledTask);
            EditableVirtualDevice.call(instance, rawDevice);
            return instance;
        };
        return factoryFn;
    }
    angular.module('com.vmware.vsphere.client.vm')
        .factory('VirtualVideoCard', ['EditableVirtualDevice', GetVirtualVideoCardClass]);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VirtualVideoCardSetup = (function () {
        function VirtualVideoCardSetup() {
        }
        VirtualVideoCardSetup.setup = function (fixtures, virtualMachineDevicesHelpers, i18nService, vmVersion, guest3dSupport, powerState, modifyDevice, mode, support3DDefaultValue, isScheduledTask, rawDeviceEnable3DSupport) {
            if (vmVersion === void 0) { vmVersion = 11; }
            if (guest3dSupport === void 0) { guest3dSupport = true; }
            if (support3DDefaultValue === void 0) { support3DDefaultValue = false; }
            if (isScheduledTask === void 0) { isScheduledTask = false; }
            if (rawDeviceEnable3DSupport === void 0) { rawDeviceEnable3DSupport = false; }
            var fix = fixtures.vmHardwareConfigData();
            if (rawDeviceEnable3DSupport) {
                var videoCardRawDevice = _.find(fix.vmConfigContext.config.hardware.device, function (device) {
                    return device._type === "com.vmware.vim.binding.vim.vm.device.VirtualVideoCard";
                });
                if (videoCardRawDevice) {
                    videoCardRawDevice.enable3DSupport = rawDeviceEnable3DSupport;
                }
            }
            var ctx = fix.vmConfigContext;
            var guest = ctx.environment.configOption.guestOSDescriptor[0];
            var environment = ctx.environment;
            environment.powerState = powerState;
            var privileges = ctx.privileges;
            if (!modifyDevice) {
                privileges = _.without(ctx.privileges, h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE);
            }
            guest.supports3D = guest3dSupport;
            var options = environment.configOption.hardwareOptions.virtualDeviceOption;
            var option = VirtualVideoCardSetup.findVideoCardOption(options);
            if (vmVersion >= 7) {
                // miltimon introduced in VM version 7
                option.numDisplays.max = 10;
            }
            else {
                option.numDisplays.max = 1;
            }
            if (vmVersion === 9 || vmVersion === 10) {
                // In version 9 and 10 we already had 3D support
                // but we didn't have graphics memory yet,
                // instead videoRam was max increased to 512MB
                option.videoRamSizeInKB.max = 512 * 1024;
            }
            else {
                // starting from VM version 11
                // max dropped back to 128 MB
                option.videoRamSizeInKB.max = 128 * 1024;
            }
            // 3D was introduced in VM version 9
            // but option always coming as false
            // and we use guest flag instead
            option.support3D.supported = false;
            option.support3D.defaultValue = support3DDefaultValue;
            // 3D renderer was introduced in VM version 9,
            // together with 3D support
            if (vmVersion > 8) {
                option.use3dRendererSupported.supported = true;
            }
            else {
                option.use3dRendererSupported.supported = false;
            }
            // VM version 11 introduces graphics memory to offload 3D
            if (vmVersion > 10) {
                option.graphicsMemorySizeSupported.supported = true;
            }
            else {
                option.graphicsMemorySizeSupported.supported = false;
            }
            var virtualMachineDevices = virtualMachineDevicesHelpers.buildVirtualMachineDevices(ctx, isScheduledTask);
            var vm = new h5_vm.VmConfig(ctx, guest, privileges, mode, i18nService);
            var inflatedVideoCard = virtualMachineDevices.getVirtualDevice(500);
            if (mode === h5_vm.VmWorkflowMode.CreateMode) {
                // New VM wizard does ot populate raw device fields.
                // We have to fix place defaults before we render it in customize hardware.
                // Here we nullify rawDevice fixture to test this behaviour
                VirtualVideoCardSetup.unsetRawDevice(inflatedVideoCard.rawDevice);
            }
            inflatedVideoCard.attachVmConfig(vm);
            return inflatedVideoCard;
        };
        VirtualVideoCardSetup.unsetRawDevice = function (rawDevice) {
            // rawDevice.videoRamSizeInKB = null;
            // rawDevice.enable3DSupport = null;
            // rawDevice.graphicsMemorySizeInKB = null;
            // rawDevice.numDisplays = null;
            // rawDevice.useAutoDetect = null;
            // rawDevice.use3dRenderer = null;
        };
        VirtualVideoCardSetup.findVideoCardOption = function (options) {
            var match = function (item) {
                //TODO wsdlName is wrong, type.name or type.typeClass? - check java docs
                // Turned out wsldName is VirtualMachineVideoCard, not VirtualVideoCard
                return item.type.name === "com.vmware.vim.binding.vim.vm.device.VirtualVideoCard";
            };
            var option = _.find(options, match);
            var retVal = option;
            return retVal;
        };
        return VirtualVideoCardSetup;
    }());
    h5_vm.VirtualVideoCardSetup = VirtualVideoCardSetup;
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareVirtualDiskService = (function () {
        function VmHardwareVirtualDiskService(managedEntityConstants, authorizationService, i18nService, vmHardwareUtil, vmHardwareVirtualDiskSharesService, vmHardwareVirtualDiskIopsService, vmHardwareVirtualDiskModeService, vmHardwareVirtualDiskFlashReadCacheService) {
            this.managedEntityConstants = managedEntityConstants;
            this.authorizationService = authorizationService;
            this.i18nService = i18nService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.vmHardwareVirtualDiskSharesService = vmHardwareVirtualDiskSharesService;
            this.vmHardwareVirtualDiskIopsService = vmHardwareVirtualDiskIopsService;
            this.vmHardwareVirtualDiskModeService = vmHardwareVirtualDiskModeService;
            this.vmHardwareVirtualDiskFlashReadCacheService = vmHardwareVirtualDiskFlashReadCacheService;
            this.DISK_SIZE_UPDATED = "disk-size-updated";
            this.DISKS_UPDATED = "disks-updated";
            this.DISK_STACK_EXPANDED = "disk-stack-expanded";
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskService.prototype.isEditSharesDisabled = function (inflatedDevice, createMode, diskSharesSupported) {
            return this.vmHardwareVirtualDiskSharesService.isEditSharesDisabled(inflatedDevice, createMode, diskSharesSupported);
        };
        VmHardwareVirtualDiskService.prototype.isEditDiskModeDisabled = function (inflatedDevice, createMode, vmConfigContext) {
            return this.vmHardwareVirtualDiskModeService.isEditDiskModeDisabled(inflatedDevice, createMode, vmConfigContext);
        };
        VmHardwareVirtualDiskService.prototype.isEditIopsLimitDisabled = function (privileges, createMode) {
            return this.vmHardwareVirtualDiskIopsService.isEditIopsLimitDisabled(privileges, createMode);
        };
        VmHardwareVirtualDiskService.prototype.isRemoveDiskDisabled = function (privileges) {
            return !this.hasPrivilegesToRemoveDisk(privileges);
        };
        VmHardwareVirtualDiskService.prototype.hasPrivilegesToRemoveDisk = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_REMOVEDISK_PRIVILEGE]);
        };
        VmHardwareVirtualDiskService.prototype.isEditFlashReadCacheDisabled = function (privileges, createMode) {
            return this.vmHardwareVirtualDiskFlashReadCacheService.isEditFlashReadCacheDisabled(privileges, createMode);
        };
        VmHardwareVirtualDiskService.prototype.hasPrivilegesToEditCapacity = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_DISKEXTEND_PRIVILEGE]);
        };
        VmHardwareVirtualDiskService.prototype.hasPrivilegesToEditShares = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_RESOURCE_PRIVILEGE]);
        };
        VmHardwareVirtualDiskService.prototype.isStoragePod = function (selectedStorageInfo) {
            return selectedStorageInfo &&
                selectedStorageInfo.storageObject &&
                selectedStorageInfo.storageObject.storageRef &&
                selectedStorageInfo.storageObject.storageRef.type === this.managedEntityConstants.STORAGE_POD;
        };
        VmHardwareVirtualDiskService.prototype.hasDatastoreAllocateSpacePrivilege = function (storageId) {
            var promise = this.authorizationService.checkPrivileges(storageId, [Privileges.DATASTORE_ALLOCATESPACE_PRIVILEGE]);
            return promise.then(function (privilegeStatuses) {
                return !!privilegeStatuses[0];
            });
        };
        VmHardwareVirtualDiskService.prototype.buildStorageSelectConfig = function (selectedStorage) {
            var storeWithVmOption = { name: this.i18n('VmUi', 'DiskPage.StoreWithVM') };
            var browseDialogOption = { name: this.i18n('VmUi', 'DiskPage.Browse') };
            var dataStores = {};
            if (selectedStorage) {
                var selectedStorageOption = {
                    name: selectedStorage.name,
                    id: selectedStorage.id,
                    storageObject: selectedStorage.storageObject
                };
                dataStores = {
                    options: [storeWithVmOption, selectedStorageOption, browseDialogOption],
                    selection: selectedStorageOption
                };
            }
            else {
                dataStores = {
                    options: [storeWithVmOption, browseDialogOption],
                    selection: storeWithVmOption
                };
            }
            return dataStores;
        };
        ;
        VmHardwareVirtualDiskService.prototype.getAllBackendStorageCallPromises = function ($q, vmAssignmentsProperties, storageProfiles) {
            var input = vmAssignmentsProperties;
            var vmAssignmentsPromise = input.then(function (result) {
                var nested = {
                    assignments: result.vmStorageProfileAssignments,
                    replication: result.vmReplicationGroupAssignments
                };
                if (!nested.replication) {
                    nested.replication = $q.when({});
                }
                nested = $q.all(nested).then(function (res) {
                    var assignments = res.assignments.vmStorageProfileAssignments;
                    var replication = res.replication.vmReplicationGroupAssignments;
                    var retVal = {
                        vmStorageProfileAssignments: assignments,
                        vmReplicationGroupAssignments: replication
                    };
                    return retVal;
                }, function (reason) {
                    return {
                        vmStorageProfileAssignments: null,
                        vmReplicationGroupAssignments: null
                    };
                });
                return nested;
            }).catch(function (reason) {
                return {
                    vmStorageProfileAssignments: null,
                    vmReplicationGroupAssignments: null
                };
            });
            var retVal = {
                storageProfilesPromiseResult: storageProfiles,
                vmAssignmentsPromiseResult: vmAssignmentsPromise
            };
            return retVal;
        };
        VmHardwareVirtualDiskService.$inject = ['managedEntityConstants',
            'authorizationService',
            'i18nService',
            'vmHardwareUtil',
            'vmHardwareVirtualDiskSharesService',
            'vmHardwareVirtualDiskIopsService',
            'vmHardwareVirtualDiskModeService',
            'vmHardwareVirtualDiskFlashReadCacheService'];
        return VmHardwareVirtualDiskService;
    }());
    h5_vm.VmHardwareVirtualDiskService = VmHardwareVirtualDiskService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskService', VmHardwareVirtualDiskService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmDatastoreLocationBrowserController',
         VmDatastoreLocationBrowserController);

   VmDatastoreLocationBrowserController.$inject = [
      '$scope',
      'i18nService'
   ];

   function VmDatastoreLocationBrowserController(
      $scope,
      i18nService
   ) {

      var self = this;
      var i18n = i18nService.getString.bind(i18nService, 'Common');
      $scope.i18n = i18nService.getString;

      self.descriptionText = i18n('StorageLocatorControl.SelectDatastoreDesc');
   }
})();

(function () {
   angular.module('com.vmware.vsphere.client.vm')
         .service('vmDatastoreLocationBrowserService', vmDatastoreLocationBrowserService);

   vmDatastoreLocationBrowserService.$inject = [
       '$q',
       'i18nService',
       'dataService',
       'clarityModalService',
       'defaultUriSchemeUtil',
       'storageLocatorService'
   ];

   function vmDatastoreLocationBrowserService(
       $q,
       i18nService,
       dataService,
       clarityModalService,
       defaultUriSchemeUtil,
       storageLocatorService
   ) {
      return {
         getStorageLocatorItems: function (vmId) {
             return dataService.getProperties(vmId, 'host')
                .then(function(result) {
                   var hostRef = defaultUriSchemeUtil.getVsphereObjectId(result.host);
                   return storageLocatorService
                       .getStorageLocatorData(hostRef, hostRef);
             });
         },
         choose: function (scope, options) {
            var deferredSelection = $q.defer();

            var modalOptions = {
               storageData: options.storageData,
               storageProfilesData: options.storageProfilesData,
               disableSdrs: options.disableSdrs,
               comparatorWrapper: options.comparatorWrapper,
               preselectItem: options.preselectItem,
               onSelectionChanged: function (selectedItem) {
                  modalOptions.submitDisabled = !selectedItem;
               },
               title: i18nService.getString('Common', 'StorageLocatorDialog.Title'),
               contentTemplate: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmDatastoreLocationBrowserDialog.html',
               defaultButton: 'submit',
               size: 'lg',
               hideSubmitButton: false,
               submitDisabled: true,
               onCancel: function() {
                  deferredSelection.reject();
                  return true;
               }
            };

            modalOptions.onSubmit = function() {
               deferredSelection.resolve({
                  selectedStorageItem: {
                     storageObject: modalOptions.storageData.selectedStorageItem,
                     name: modalOptions.storageData.selectedStorageItem.name,
                     id: defaultUriSchemeUtil.getVsphereObjectId(modalOptions.storageData.selectedStorageItem.storageRef)
                  },
                  selectedStorageProfile: modalOptions.storageProfilesData.selectedProfile
               });
               return true;
            };

            clarityModalService.openOkCancelModal(modalOptions);

            return deferredSelection.promise;
         }
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .component('vmHardwareVirtualDisk', {
            templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmHardwareVirtualDisk.html',
            controller: VmHardwareVirtualDiskController,
            controllerAs: 'ctrl',
            bindings: {
               inflatedDevice: '<',
               selectedStorageProfile: '<',
               selectedDiskFormat: '<',
               storageBaselineId: '<',
               getAdvancedConfigurationForDisk: '&',
               getStorageForDisk: '&',
               storageProfiles: '<',
               isVmEncrypted: '<',
               createMode: '<',
               cloneMode: '<',
               deployVmtxMode: '<',
               virtualMachineDevices: '<',
               setStorageForDisk: '&',
               vmConfigContext: '<',
               vmStorageId: '@',
               vmAssignmentsProperties: '<',
               computeResourceId: '<',
               vmHomeReplicationGroup: '<',
               storageLocatorItemsData: '<',
               removeCallback: '&',
               vmId: '<',
               showStoragePods: '<',
               expanded: '=',
               keepExistingProfileAssignments: '<',
               isGroupingHardDisks: '<'
            }
         });

   VmHardwareVirtualDiskController.$inject = [
      '$q',
      '$scope',
      '$rootScope',
      '$element',
      'i18nService',
      'virtualDiskSettingsFormService',
      'diskProvisioningService',
      'vmDatastoreLocationBrowserService',
      'defaultUriSchemeUtil',
      'datastoreService',
      'authorizationService',
      'VirtualDisk',
      'vmHardwareVirtualDiskService',
      'vmDeviceInfoService',
      'managedEntityConstants',
      'deviceClassLineageService',
      '$timeout',
      'diskBackingInfoConstants',
      'storageProfileService',
      'spbmReplicationGroupInfoService',
      'deviceTypeConstants',
      'virtualDiskPmemService',
      'vmCryptUtilService',
      'basicDiskUtilService'
   ];

   function VmHardwareVirtualDiskController(
         $q,
         $scope,
         $rootScope,
         $element,
         i18nService,
         virtualDiskSettingsFormService,
         diskProvisioningService,
         vmDatastoreLocationBrowserService,
         defaultUriSchemeUtil,
         datastoreService,
         authorizationService,
         VirtualDisk,
         vmHardwareVirtualDiskService,
         vmDeviceInfoService,
         managedEntityConstants,
         deviceClassLineageService,
         $timeout,
         diskBackingInfoConstants,
         storageProfileService,
         spbmReplicationGroupInfoService,
         deviceTypeConstants,
         virtualDiskPmemService,
         vmCryptUtilService,
         basicDiskUtilService
   ) {

      var DELETE_FILE_FROM_DISK_OPERATION = 'destroy';

      var browseDialogOption, selectedStorage, buildStorageSelectConfig,
            checkDiskLocationPrivilege, storeWithVmOption, setDiskLocationValidity;
      var self = this;

      var device = self.inflatedDevice.getCurrentDevice();

      var datastoreInfo = datastoreService.findDatastore(
         self.vmStorageId,
         self.vmConfigContext.environment.configTarget);
      self.isPoweredOn = self.vmConfigContext.environment.powerState === 'poweredOn';
      self.deviceName = device.deviceInfo.label;
      self.formKey = self.inflatedDevice.getKey().toString().replace('-', '__');
      self.i18n = i18nService.getString;
      self.controllerSelectorName = 'editVirtualDeviceController' + self.formKey;
      self.controllerNodeSelectorName = 'editVirtualDeviceNode' + self.formKey;
      self.deleteFilesFromDisk = false;
      if (self.inflatedDevice.getDiskFileOperation() === DELETE_FILE_FROM_DISK_OPERATION) {
         self.deleteFilesFromDisk = true;
      }
      self.formId = 'vmHardwareVirtualDiskForm' + self.formKey;
      self.diskLocationErrorConfig = {
         message: self.i18n('VmUi',
               'SelectDatastoreProvisioningPage.NoPermissionOnDatastore'),
         isVisible: false
      };

      self.diskProfileErrorConfig = {
         message: undefined,
         isVisible: false
      };
      self.isPmemDisk = self.inflatedDevice.isPmemDisk();
      self.isExistingPmemDisk =
            self.inflatedDevice.isPmemDisk() && !self.inflatedDevice.isNew();

      self.isVmHomeProfileChanged = false;
      self.isDiskAlreadyEncrypted = self.inflatedDevice.isDiskAlreadyEncrypted();
      self.isStorageProfileChanged = false;
      self.isEncryptionProfileApplied = self.inflatedDevice.isEncryptionProfileApplied();

      $scope.$watch(function() {
         return self.vmConfigContext.vmProfile;
      }, _.bind(function(newValue, oldValue) {
         if (newValue !== oldValue) {
            self.isVmHomeProfileChanged = true;
            self.checkEncryptionWarning();
         }
      }, self));

      $scope.$watch(function() {
         return self.inflatedDevice.storageProfile;
      }, _.bind(function(newValue, oldValue) {
         if (newValue !== oldValue) {
            self.updateProfile(newValue, null, false);
            if (self.virtualDiskSettingsForm.storageProfile) {
               self.virtualDiskSettingsForm.storageProfile.selection = newValue;
            }
         }
      }, self));

      self.onUnitChanged = function(newUnit) {
         self.virtualDiskSettingsForm.capacity.memoryUnitPreferred = newUnit;
         self.inflatedDevice.getCurrentDeviceSpec().memoryUnitPreferred = newUnit;
      };

      self.onValueChanged = function() {
         self.inflatedDevice.updateCapacity(
               self.virtualDiskSettingsForm.capacity.valueInMB);

         $rootScope.$broadcast(vmHardwareVirtualDiskService.DISK_SIZE_UPDATED, {
            size: self.virtualDiskSettingsForm.capacity.valueInMB,
            units: self.virtualDiskSettingsForm.capacity.memoryUnitPreferred.label
         });
      };

      self.isExpandable = function() {
         if (self.deployVmtxMode) {
            return false;
         }
         if (!self.virtualDiskSettingsForm) {
            return false;
         } else {
            return true;
         }
      };

      self.updateProfileFromUi = function(selectedStorageProfile) {
         self.updateProfile(selectedStorageProfile);
         self.inflatedDevice.setStorageProfileManuallySet(true);
         updateReplicationGroupData(selectedStorageProfile);
      };

      self.updateProfile = function(selectedStorageProfile, replicationGroupInfo, broadcastEvent) {
         self.isStorageProfileChanged = true;
         replicationGroupInfo = replicationGroupInfo ||
            (self.selectedReplicationGroupItem
               ? self.selectedReplicationGroupItem.replicationGroupInfo
               : null);

         self.inflatedDevice.updateDiskProfile(selectedStorageProfile, replicationGroupInfo);

         self.isPmemDisk = virtualDiskPmemService.handlePmemIfPmemProfile(
               self.inflatedDevice, selectedStorageProfile, self.selectedDiskFormat);
         self.isEncryptionProfileApplied = self.inflatedDevice.isEncryptionProfileApplied();
         if (!self.isEncryptionProfileApplied) {
            self.inflatedDevice.getCurrentDevice().backing.keyId = null;
         }

         self.checkEncryptionWarning();

         if (broadcastEvent !== false) {
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISKS_UPDATED);
         }
      };

      self.checkEncryptionWarning = function() {
         // VM Home must be encrypted in order to encrypt disks
         if (self.isEncryptionProfileApplied && !self.isVmHomeEncrypted()) {
            self.setDiskProfileValidity(false,
               self.i18n('VmUi', 'DiskConfig.ErrorVmHomeEncryptionRequired'));
            return;
         }

         // Can't encrypt while adding existing disk
         if (self.inflatedDevice.isCreatedFromExistingDisk()
            && self.isEncryptionProfileApplied && !self.isDiskAlreadyEncrypted) {
            self.setDiskProfileValidity(false,
               self.i18n('VmUi', 'DiskConfig.ErrorNoEncryptionOnAttach'));
            return;
         }

         // Can't decrypt while adding existing disk
         if (self.inflatedDevice.isCreatedFromExistingDisk()
               && !self.isEncryptionProfileApplied && self.isDiskAlreadyEncrypted) {
            self.setDiskProfileValidity(false,
                  self.i18n('VmUi', 'DiskConfig.ErrorNoDecryptionOnAttach'));
            return;
         }

         self.setDiskProfileValidity(true);
      };

      self.isVmHomeEncrypted = function() {
         // Check if the VM Home profile is encryption one
         if (self.vmConfigContext.vmProfile) {
            var vmHomeProfile = storageProfileService.findProfile(
                  self.storageProfiles, self.vmConfigContext.vmProfile[0]);
            self.isVmEncrypted = storageProfileService
                  .isEncryptionStorageProfile(vmHomeProfile);
            return self.isVmEncrypted;
         }

         // If the VM profile is not changed and VM Home is encrypted - return TRUE.
         // The key will be empty when in provisioning mode,
         // so only return if there is a key.
         if (!self.isVmHomeProfileChanged &&
            !vmCryptUtilService.isCryptoKeyEmpty(self.vmConfigContext.config.keyId)) {
            self.isVmEncrypted = true;
            return self.isVmEncrypted;
         }

         return self.isVmEncrypted;
      };

      self.getDiskEncryptionStatus = function() {
         return vmCryptUtilService.getDiskEncryptionStatus(self.isDiskAlreadyEncrypted,
            self.isStorageProfileChanged, self.isEncryptionProfileApplied);
      };

      self.setDiskProfileValidity = function(isValid, errorMessage) {
         self.diskProfileErrorConfig.isVisible = !isValid;
         self.diskProfileErrorConfig.message = errorMessage;

         var form = self[self.formId];
         if (form) {
            var diskProfileElem = form['storage-profile'];
            if (diskProfileElem) {
               diskProfileElem.$invalid = !isValid;
            }
            self[self.formId].$setValidity('diskProfile', isValid);
         }
      };

      self.updateDiskProvisioningType = function(selectedProvisionOptionType) {
         var backingType = diskProvisioningService.backingInfoKeys(selectedProvisionOptionType);
         self.inflatedDevice.updateDiskProvisioningOption(backingType);
      };

      self.updateDiskController = function(selectedController, selectedControllerNode) {
         if (selectedControllerNode) {
            self.inflatedDevice.updateControllerAndNodeKeys(selectedController.getKey(), selectedControllerNode.key);
         }
      };

      /** We want to show the disk file in the following cases:
       * - when we edit an existing disk
       * - when we add a disk from an existing one
       * We don't want to show it when:
       * - creating a new disk
       * - cloning an existing disk
       */
      self.showDiskFile = function() {
         return self.expanded &&
            ((!self.createMode && !self.cloneMode)
               || self.inflatedDevice.isCreatedFromExistingDisk())
            && !!self.virtualDiskSettingsForm && !!self.virtualDiskSettingsForm.diskFile;
      };

      self.isRemoveDisabled = function() {
         if(!self.createMode) {
            return vmHardwareVirtualDiskService.isRemoveDiskDisabled(self.vmConfigContext.privileges);
         }

         return false;
      };

      self.onRemoveHardDisk = function() {
         if(!self.isRemoveDisabled() && self.removeCallback){
            self.removeCallback()(self.inflatedDevice);
            if (self.isPmemDisk) {
               self.deleteFilesFromDisk = true;
               self.updateDiskFileOperation();
            }
         }
      };

      self.isEditIopsLimitDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditIopsLimitDisabled(
               self.vmConfigContext.privileges, self.createMode);
      };

      self.getPmemMax = function() {
         return virtualDiskPmemService.getMaxAllowedCapacity(
               self.vmConfigContext, self.inflatedDevice, self.virtualMachineDevices);
      };

      self.getDiskText = function() {
         if (!self.virtualDiskSettingsForm) {
            return '';
         }
         var diskSize = basicDiskUtilService.determineDisplayDiskSize(
               self.virtualDiskSettingsForm.capacity.valueInMB);
         return diskSize ?
               (basicDiskUtilService.roundToPrecision(diskSize.size, 2).toString() + ' ' + diskSize.unitText ) :
               '';
      };

      self.shouldShowDiskSizeLabelOnly = function() {
         if (!self.virtualDiskSettingsForm) {
            return true;
         }

         return !self.inflatedDevice.isNew() && self.isGroupingHardDisks &&
               (!self.virtualDiskSettingsForm.capacity.validUnits ||
               !self.expanded);
      };

      self.getMax = function() {
         if(isExistingDiskAddition()) {
            //To Skip validation errors on a disabled field
            return Number.MAX_VALUE;
         } else {
            if (self.isPmemDisk) {
               return self.getPmemMax();
            }
            return self.virtualDiskSettingsForm.capacity.maxInMB;
         }
      };

      self.getMin = function() {
         if(isExistingDiskAddition()) {
            //To Skip validation errors on a disabled field
            return Number.MIN_VALUE;
         } else {
            if (!self.isDiskEditable) {
               return Number.MIN_VALUE;
            }
            if (self.isExistingPmemDisk) {
               return self.inflatedDevice.getOriginalCapacityInMB();
            }
            if (self.isPmemDisk) {
               return virtualDiskPmemService.getDefaultMinValueForNewPmemDisk();
            }
            return self.virtualDiskSettingsForm.capacity.minInMB;
         }
      };

      var formId = 'vmHardwareVirtualDiskForm' + self.formKey;

      self.replicationGroupItems = [];
      self.selectedReplicationGroupItem = null;

      self.replicationGroupErrorConfig = {
         message: "",
         isVisible: false
      };

      var validateReplicationGroupSelection = function() {

         function getReplicationGroupError() {

            if (!self.replicationGroupItems || !self.replicationGroupItems.length) {
               return "";
            }

            if (!self.selectedReplicationGroupItem) {
               return self.i18n("VmUi", "DiskConfig.selectReplicationGroup");
            }

            var rgAssignments = [];
            if (self.vmHomeReplicationGroup) {
               rgAssignments.push(self.vmHomeReplicationGroup);
            }
            _.forEach(self.virtualMachineDevices.devicesNotMarkedForRemovalOfType("VirtualDisk"), function(virtualDisk) {
               var diskRg = null;
               if (self.cloneMode) {
                  var advancedConfiguration =
                        self.getAdvancedConfigurationForDisk({virtualDiskDevice: virtualDisk});
                  if (advancedConfiguration) {
                     diskRg = advancedConfiguration.replicationGroup;
                  } else {
                     diskRg = virtualDisk.getCurrentReplicationGroup();
                  }
               } else {
                  diskRg = virtualDisk.getCurrentReplicationGroup();
               }
               if (diskRg) {
                  rgAssignments.push(diskRg);
               }
            });

            return spbmReplicationGroupInfoService
               .validateVmReplicationGroupAssignments(rgAssignments);
         }

         self.replicationGroupErrorConfig.message = getReplicationGroupError();
         var isValid = !self.replicationGroupErrorConfig.message;
         self.replicationGroupErrorConfig.isVisible = !isValid;

         var form = self[formId];
         if (form) {
            var replicationGroupElem = form['replication-group'];
            if (replicationGroupElem) {
               replicationGroupElem.$invalid = !isValid;
            }
            self[formId].$setValidity('replicationGroup', isValid);
         }
      };

      self.virtualMachineDevices.addRgValidationCallback(
            device.key, validateReplicationGroupSelection);

      var updateReplicationGroupData = function(selectedProfile, selectedStorageRef) {

         if ((self.cloneMode && !self.inflatedDevice.isNew())) {
            return;
         }

         if (!selectedProfile && self.virtualDiskSettingsForm.storageProfile) {
            selectedProfile = self.virtualDiskSettingsForm.storageProfile.selection;
         }

         if (!selectedStorageRef) {
            var currentSpec = self.inflatedDevice.getCurrentDeviceSpec();

            if (currentSpec && currentSpec.device && currentSpec.device.backing &&
                  currentSpec.device.backing.datastore) {
               selectedStorageRef = currentSpec.device.backing.datastore;
            } else if (self.vmStorageId) {
               selectedStorageRef = defaultUriSchemeUtil.getManagedObjectReference(
                     self.vmStorageId);
            }
         }

         storageProfileService.requestCompatibilityResultForDatastore(
               selectedProfile && selectedProfile.profileObj,
               selectedStorageRef).then( function(result) {

            self.replicationGroupItems = [];
            self.selectedReplicationGroupItem = null;

            var currentRgId = self.inflatedDevice.getCurrentReplicationGroup() ?
                  self.inflatedDevice.getCurrentReplicationGroup().id: null;

            var triggerRgUpdate = !!currentRgId;

            if (result && result.compatibilityResult) {

               var computeResourceRef = self.computeResourceId
                     ? defaultUriSchemeUtil.getManagedObjectReference(self.computeResourceId)
                     : null;
               var hostRefs = (computeResourceRef && computeResourceRef.type === "HostSystem")
                     ? [computeResourceRef]
                     : [];

               var replicationGroupInfos =
                     spbmReplicationGroupInfoService.extractReplicationGroupInfos(
                           result.compatibilityResult, hostRefs, result.replicationGroupInfo);

               _.forEach(replicationGroupInfos, function(rg) {
                  var rgItem = {
                     label: spbmReplicationGroupInfoService.getReplicationGroupName(rg),
                     replicationGroupInfo: rg
                  };
                  self.replicationGroupItems.push(rgItem);
                  if (currentRgId && spbmReplicationGroupInfoService.equalReplicationGroupIds(
                        currentRgId, rg.id)) {
                     self.selectedReplicationGroupItem = rgItem;
                  }
               });

               if (!currentRgId || self.selectedReplicationGroupItem) {
                  // if there was no initial RG or it has beed re-selected
                  // no need to trigger RG update.
                  triggerRgUpdate = false;
               }
            }

            if (triggerRgUpdate) {
               self.onReplicationGroupSelectionChange();
            }

            validateReplicationGroupSelection();
         });
      };

      self.onReplicationGroupSelectionChange = function() {
         self.updateProfile(self.virtualDiskSettingsForm.storageProfile.selection);
         validateReplicationGroupSelection();
         self.virtualMachineDevices.notifyRgValidationCallbacks();
      };

      self.onDatastoreSelectionChange = function(newSelection, oldSelection) {
         if (newSelection.name === browseDialogOption.name) {
            if (self.getStorageForDisk) {
               selectedStorage = self.getStorageForDisk({ diskKey: device.key });
            }

            //set the storageObject.storageRef if it is missing, so we can keep the selection
            //in the location browser window, even when going back and forward
            //through the wizard's pages
            if ((!oldSelection.storageObject || !oldSelection.storageObject.storageRef)
                  && oldSelection.id) {

               oldSelection.storageObject = oldSelection.storageObject ?
                     oldSelection.storageObject : {};

               oldSelection.storageObject.storageRef =
                     defaultUriSchemeUtil.getManagedObjectReference(oldSelection.id);
            }

            getStorageLocatorItemsForCreateOrEditMode().then(function (result) {
               var selectedProfile = self.virtualDiskSettingsForm.storageProfile
                     ? self.virtualDiskSettingsForm.storageProfile.selection
                     : undefined;
               vmDatastoreLocationBrowserService.choose($scope, {
                  storageProfilesData: {
                     storageProfiles: self.storageProfiles,
                     selectedProfile: selectedProfile
                  },
                  storageData: {
                     storageLocatorItemsData: result,
                     selectedStorageItem: oldSelection.storageObject
                  },
                  disableSdrs: !self.showStoragePods
               }).then(
                     function (selectionsFromBrowserService) {
                        if (!self.virtualDiskSettingsForm.storageProfile) {
                           self.virtualDiskSettingsForm.storageProfile = {};
                        }

                        self.virtualDiskSettingsForm.storageProfile.selection =
                              selectionsFromBrowserService.selectedStorageProfile;
                        self.updateProfile(
                              selectionsFromBrowserService.selectedStorageProfile);
                        self.datastores = buildStorageSelectConfig(
                              selectionsFromBrowserService.selectedStorageItem);
                        checkDiskLocationPrivilege(self.datastores.selection.id);
                        setCapacityAndErrorMessage(
                              self.datastores.selection, self.datastores.selection.id);

                        updateReplicationGroupData(
                              selectionsFromBrowserService.selectedStorageProfile,
                              selectionsFromBrowserService.selectedStorageItem.storageObject.storageRef);

                        self.virtualDiskSettingsForm.diskProvisioningOptions =
                              virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                                    self.datastores.selection.storageObject.type,
                                    self.datastores.selection.storageObject.vStorageSupport);
                        self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                              self.virtualDiskSettingsForm.diskProvisioningOptions[0];
                     }, function () {
                        self.datastores.selection = oldSelection;
                     });
            });
         } else if (newSelection.name === storeWithVmOption.name) {
            setDiskLocationValidity(true);
            setCapacityAndErrorMessage(null);
            updateReplicationGroupData();
            self.virtualDiskSettingsForm.diskProvisioningOptions =
                  virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                        datastoreInfo?datastoreInfo.datastore.type:"",
                        datastoreInfo?datastoreInfo.vStorageSupport:"");
            self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0];
         } else {
            checkDiskLocationPrivilege(newSelection.id);
            setCapacityAndErrorMessage(newSelection, newSelection.id);

            updateReplicationGroupData(null, self.datastores.selection.storageObject.storageRef);

            self.virtualDiskSettingsForm.diskProvisioningOptions =
                  virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                        self.datastores.selection.storageObject.type,
                        self.datastores.selection.storageObject.vStorageSupport);
            self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0];
         }
      };

      self.expandedChanged = function(expanded) {
         if (self.expanded === expanded) {
            return;
         }
         self.expanded = expanded;

         if (self.inflatedDevice.isNew()) {
            setDiskLocationValidity(!self.diskLocationErrorConfig.isVisible);
            self.setDiskProfileValidity(!self.diskProfileErrorConfig.isVisible,
               self.diskProfileErrorConfig.message);
         } else if (self.expanded && self.isGroupingHardDisks) {
            //broadcast to all the other hard disks
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, {
               deviceKey: self.inflatedDevice.getKey()
            });
         }
      };

      $rootScope.$on(vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, function(event, key) {
         if (self.inflatedDevice.getKey() === key.deviceKey) {
            //nothing to do, just return
            return;
         }
         self.expanded = false;
      });

      $q.all(getAllBackendStorageCallPromises()).then(function (results) {
         self.storageProfiles = results.storageProfilesPromiseResult;

         self.vmAssignmentsProperties = results.vmAssignmentsPromiseResult || {};

         if (!(self.createMode || self.cloneMode)
               && self.vmAssignmentsProperties
               && self.vmAssignmentsProperties.vmStorageProfileAssignments && self.storageProfiles) {

            var currentDevice = self.inflatedDevice.getCurrentDeviceSpec().device;
            var replicationGroup = null;
            if (currentDevice && currentDevice.key) {
               _.forEach(results.vmAssignmentsPromiseResult.vmReplicationGroupAssignments,
                     function (rgAssignment) {
                        if (rgAssignment && rgAssignment.vmObjectId) {
                           var vmObjectIdSegments = rgAssignment.vmObjectId.split(":");
                           if (vmObjectIdSegments.length > 1 &&
                                 vmObjectIdSegments[1] === currentDevice.key.toString()) {
                              replicationGroup = rgAssignment.replicationGroup;
                           }
                        }
                     });
            }

            var profile = storageProfileService.makeProfileFromDevice(
                  currentDevice,
                  self.storageProfiles,
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  replicationGroup,
                  self.inflatedDevice.isNew());

            self.inflatedDevice.setOriginalProfile(profile, replicationGroup);
         }

         if (self.inflatedDevice.isNew()) {
            self.virtualDiskSettingsForm = virtualDiskSettingsFormService.build(
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  self.createMode || self.cloneMode,
                  self.vmConfigContext,
                  self.inflatedDevice,
                  self.vmStorageId,
                  self.selectedStorageProfile,
                  self.storageProfiles,
                  self.virtualMachineDevices
            );
            // if there is already selected disk provisioning type - use it, otherwise default
            // to the first option
            var diskProvisioningType = self.virtualDiskSettingsForm.selectedDiskProvisioningOption ?
                  self.virtualDiskSettingsForm.selectedDiskProvisioningOption.type :
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0].type;
            self.updateDiskProvisioningType(diskProvisioningType);

            if (self.virtualDiskSettingsForm.storageProfile
                  && self.virtualDiskSettingsForm.storageProfile.selection) {
               self.updateProfile(
                  self.virtualDiskSettingsForm.storageProfile.selection,
                  self.inflatedDevice.getCurrentReplicationGroup());
            }

            var lastPrivCheckedStorageId = {
               id: null,
               hasPrivilege: true
            };
            storeWithVmOption = { name: self.i18n('VmUi', 'DiskPage.StoreWithVM') };
            browseDialogOption = { name: self.i18n('VmUi', 'DiskPage.Browse') };
            buildStorageSelectConfig = function(selectedStorage) {
               if (selectedStorage) {
                  var selectedStorageOption = {
                     name: selectedStorage.name,
                     id: selectedStorage.id,
                     storageObject: selectedStorage.storageObject
                  };
                  return {
                     options: [storeWithVmOption, selectedStorageOption, browseDialogOption],
                     selection: selectedStorageOption
                  };
               } else {
                  return {
                     options: [storeWithVmOption, browseDialogOption],
                     selection: storeWithVmOption
                  };
               }
            };

            checkDiskLocationPrivilege = function(storageId) {
               var storageType = defaultUriSchemeUtil.getEntityType(storageId);
               //if storage pod, do not check privileges
               if (storageType === managedEntityConstants.STORAGE_POD) {
                  setDiskLocationValidity(true);
                  return;
               }
               //if we go back to the already selected storage
               //do not check for privileges second time, but
               //invalidate the form if needed (for errors to appear)
               if (lastPrivCheckedStorageId.id === storageId) {
                  setDiskLocationValidity(lastPrivCheckedStorageId.hasPrivilege);
                  return;
               }

               lastPrivCheckedStorageId.id = storageId;
               var priv = ['Datastore.AllocateSpace'];
               var promise = authorizationService.checkPrivileges(storageId, priv);
               return promise.then(function(privilegeStatuses) {
                  var hasPriv = privilegeStatuses[0];
                  lastPrivCheckedStorageId.hasPrivilege = hasPriv;
                  setDiskLocationValidity(hasPriv);
               });
            };

            setDiskLocationValidity = function(isValid) {
               self.diskLocationErrorConfig.isVisible = !isValid;
               $timeout(function() {
                  var form = self[formId];
                  if (form) {
                     var diskLocationElem = form['disk-location'];
                     if (diskLocationElem) {
                        diskLocationElem.$invalid = !isValid;
                     }
                     self[formId].$setValidity('diskLocation', isValid);
                  }
               }, 50);
            };

            selectedStorage = null;
            if (self.getStorageForDisk) {
               var selectedStorageForDisk = self.getStorageForDisk(
                     { diskKey: device.key });
               if (selectedStorageForDisk) {
                  selectedStorage = {
                     key: selectedStorageForDisk.dsKey,
                     id: selectedStorageForDisk.dsId,
                     name: selectedStorageForDisk.dsName,
                     storageObject: selectedStorageForDisk.dsObject
                  };
               }
            }
            self.datastores = buildStorageSelectConfig(selectedStorage);
         } else {
            self.virtualDiskSettingsForm = virtualDiskSettingsFormService.build(
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  self.createMode || self.cloneMode,
                  self.vmConfigContext,
                  self.inflatedDevice,
                  self.vmStorageId,
                  null,
                  self.storageProfiles,
                  self.virtualMachineDevices);
         }

         applyPmemPostProcessingToDisk();

         postInit();
      });

      self.revertRemoval = function() {
         self.inflatedDevice.revertRemoval();
         self.virtualMachineDevices.notifyRgValidationCallbacks();
      };

      $scope.$on('deviceAdded', function(event, device) {
         if (isAddedDeviceAController(device.deviceType)) {
            rebuildControllersDropdown();
         }
      });
      $scope.$on('deviceRemoved', function(event, device) {
         if (self.inflatedDevice.isOfType("VirtualDisk")) {
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISKS_UPDATED);
         }

         if (isAddedDeviceAController(device.deviceType)) {
            rebuildControllersDropdown();
         }
         validateReplicationGroupSelection();
      });

      self.isDiskEditable = determineDiskEditability();
      self.isRDMDisk = determineIfRdmDisk();

      self.isEditDiskModeDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditDiskModeDisabled(
               self.inflatedDevice, self.createMode, self.vmConfigContext);
      };

      self.isEditFlashReadCacheDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditFlashReadCacheDisabled(
               self.vmConfigContext.privileges, self.createMode);
      };

      self.isEditSharesDisabled = function() {
        return self.isPmemDisk || vmHardwareVirtualDiskService.isEditSharesDisabled(
              self.vmConfigContext.privileges,
              self.createMode,
              self.vmConfigContext.environment.configOption.capabilities.diskSharesSupported);
      };

      self.isDiskSharingDisabled = function() {
         return self.isPmemDisk || (self.isPoweredOn && !self.inflatedDevice.isNew());
      };

      self.customValidators = [
         {
            name: 'non-zero',
            validate: function(value) {
               return value !== 0;
            },
            message: self.i18n('VmUi', 'DiskConfig.ErrorCapacityZero')
         }
      ];

      self.hasPrivilegesToEdit = function() {
         return vmHardwareVirtualDiskService.hasPrivilegesToEditCapacity(self.vmConfigContext.privileges, self.createMode) ;
      };

      self.updateDiskFileOperation = function() {
         if (self.deleteFilesFromDisk) {
            self.inflatedDevice.setDiskFileOperation(DELETE_FILE_FROM_DISK_OPERATION);
         } else {
            self.inflatedDevice.setDiskFileOperation(undefined);
         }
      };

      self.updateFlashCacheReservation = function(flashCacheReservation) {
         self.inflatedDevice.updateFlashCacheReservation(flashCacheReservation);
      };

      self.hasError = function() {
           if(!_.isEmpty(self[self.formId])){
               return self[self.formId].$invalid;
           }
           return false;
      };

      self.shouldDisplayShares = function(expanded){
           if(!_.isEmpty(self[self.formId])){
               var errors = self[self.formId].$error;
               if(!_.isEmpty(errors)){
                  for(var obj in errors){
                     if(errors[obj].length >1 && (errors[obj][1].$name).startsWith('DiskSharesValue')){
                        return true;
                     }

                  }
               }
           }
           return expanded;
       };

       self.shouldDisplayIOPS = function(expanded){
           if(!_.isEmpty(self[self.formId])){
               var errors = self[self.formId].$error;
               if(!_.isEmpty(errors)){
                   for(var obj in errors){
                       if(errors[obj].length >1 && (errors[obj][1].$name).startsWith('IopsLimitValue')){
                           return true;
                       }

                   }
               }
           }
           return expanded;
       };

       buildIopsLimitDetails();

      self.showVmStoragePolicy = function(expanded) {
         expanded = expanded || false;
         return expanded && (!self.cloneMode || self.inflatedDevice.isNew());
      };

      self.showReplicationGroup = function(expanded) {
         expanded = expanded || false;
         return expanded && self.replicationGroupItems.length &&
               (!self.cloneMode || self.inflatedDevice.isNew());
      };

      self.areStorageProfilesReadOnly = function() {
         return !self.virtualDiskSettingsForm
            || !self.virtualDiskSettingsForm.storageProfile
               || !self.virtualDiskSettingsForm.storageProfile.options
               || self.virtualDiskSettingsForm.storageProfile.options.length === 0
               || self.isExistingPmemDisk;
      };

      self.shouldDisableDiskEdit = function() {
         return !self.isDiskEditable ||
               self.inflatedDevice.isCreatedFromExistingDisk() ||
               !self.hasPrivilegesToEdit();
      };


      self.getSelectedVirtualNodeText = function() {
         if (self.virtualDiskSettingsForm && self.virtualDiskSettingsForm.controllers) {
            var rawController = self.virtualDiskSettingsForm.controllers.selection.getCurrentDevice();

            return vmDeviceInfoService.getControllerAndNodeLabelText(
               rawController._type, rawController.busNumber, self.inflatedDevice.getCurrentDevice().unitNumber);
         }
         return '';
      };

      /* ------------------------ private ------------------------ */

      function isExistingDiskAddition() {
            return self.inflatedDevice.isNew() && self.inflatedDevice.isCreatedFromExistingDisk();
      }

      function determineDiskEditability() {
         if (determineIfRdmDisk()) {
            //if RDM disk, always return false
            return false;
         }

         if (self.createMode) {
            return true;
         } else if (self.isPmemDisk && self.isPoweredOn) {
            return false;
         } else {
            return self.inflatedDevice.getCurrentDevice().backing.parent ? false : true;
         }
      }

      function determineIfRdmDisk() {
         return self.inflatedDevice.getCurrentDevice().backing._type ===
               diskBackingInfoConstants.RAWDISKMAPPING;
      }

      function buildIopsLimitDetails() {
         var MIN = 16;
         var MAX = (Math.pow(2, 31) - 1);
         self.iopsLimitDetails = {};

         self.iopsLimitDetails.min = MIN;
         self.iopsLimitDetails.max = MAX;
         self.iopsLimitDetails.iopsRecommendations = [
            {
               name: self.i18n('VmUi', 'VmCpu.Limit.Minimum'),
               value: MIN
            },
            {
               name: self.i18n('VmUi', 'VmCpu.Limit.Maximum'),
               value: MAX
            }
         ];
         self.iopsLimitDetails.iopsLimitSelectList = [
            {
               label: self.i18n('VmUi', 'DiskConfig.Unlimited'),
               data: 'unlimited'
            },
            {
               label: self.i18n('VmUi', 'sharesInfoLevel.custom'),
               data: 'custom'
            }
         ];

         self.iopsLimitDetails.errorMessage = {
            max: function() {
               return self.i18n('Common', 'SharesControl.RangeError', MIN, MAX);
            },
            min: function() {
               return self.i18n('Common', 'SharesControl.RangeError', MIN, MAX);
            }
         };

         self.iopsLimitDetails.selectChange = function() {
            if (self.iopsLimitDetails.iopsLimitSelection.data === 'unlimited') {
               self.virtualDiskSettingsForm.ioLimit = VirtualDisk.UNLIMITED_DISK;
            } else {
               self.virtualDiskSettingsForm.ioLimit = MIN;
            }
            self.inflatedDevice.updateStorageIOAllocation(self.virtualDiskSettingsForm.ioLimit);
         };
      }

      function applyPmemPostProcessingToDisk() {
         // Use the applyPmemProfile function in create mode to set Pmem Storage Policy
         // when Pmem Baseline is selected.
         if (self.createMode && applyPmemProfileToDisk()) {
            return;
         }

         if (self.cloneMode) {
            var advancedConfiguration =
                  self.getAdvancedConfigurationForDisk(self.inflatedDevice);
            if (advancedConfiguration) {
               self.updateProfile(advancedConfiguration.storageProfile,
                     advancedConfiguration.replicationGroup);
               return;
            }
            if (applyPmemProfileToDisk()) {
               return;
            }
            if (!self.inflatedDevice.isStorageProfileManuallySet()) {
               var diskProfile = self.selectedStorageProfile;
               if (!self.inflatedDevice.isNew() && self.keepExistingProfileAssignments) {
                  diskProfile = storageProfileService.getDefaultProfile();

                  var diskAssignment = storageProfileService.findDiskAssignment(
                        self.vmAssignmentsProperties.vmStorageProfileAssignments,
                        self.inflatedDevice.getCurrentDevice());
                  if (diskAssignment) {
                     diskProfile = {
                        id: diskAssignment.profile.profileId.uniqueId,
                        label: diskAssignment.profile.name
                     };
                  }
               }

               self.updateProfile(diskProfile,
                     self.inflatedDevice.getCurrentReplicationGroup());
               self.virtualDiskSettingsForm.storageProfile.selection = diskProfile;
            }
         }
      }

      function findPmemProfile(storageProfiles) {
         return _.find(storageProfiles, function(storageProfile) {
            return storageProfileService.isPmemStorageProfile(storageProfile);
         });
      }

      function applyPmemProfileToDisk() {
         if (virtualDiskPmemService.shouldApplyPmemProfileToDisk(
               self.inflatedDevice, self.storageBaselineId)) {
            // In hybrid mode the pmem disks need to have their profile set to the Pmem
            // profile in order to show up correctly on the RTC page.
            // The RTC page gets its data about disks from virtualMachineDevices, which
            // is directly populated by this component (for disks at least)
            var pmemStorageProfile = findPmemProfile(self.storageProfiles);
            self.updateProfile(pmemStorageProfile);
            self.virtualDiskSettingsForm.storageProfile.selection = pmemStorageProfile;
            return true;
         }
         return false;
      }

      function postInit() {
         setErrorMessage(self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage);

         self.iopsLimitDetails.iopsLimitSelection =
               (self.virtualDiskSettingsForm.ioLimit === VirtualDisk.UNLIMITED_DISK) ?
                     self.iopsLimitDetails.iopsLimitSelectList[0] :
                     self.iopsLimitDetails.iopsLimitSelectList[1];

         if (!self.createMode) {
            self.errorMessages.min =
                  self.i18n('VmUi', 'DiskConfig.ErrorCapacityShrink');
         }

         updateReplicationGroupData();
      }

      function setErrorMessage(maxErrorMessage) {
         self.errorMessages = {
            max: maxErrorMessage
         };
      }

      function setCapacityAndErrorMessage(selectedStorageInfo, datastoreId) {
         var datastoreInfo = datastoreService.findDatastore(
               datastoreId || self.vmStorageId,
               self.vmConfigContext.environment.configTarget);

         if (selectedStorageInfo && !isStoragePod(selectedStorageInfo)) {
            self.virtualDiskSettingsForm.diskFile = '[' + selectedStorageInfo.name + ']';
         }
         else {
            self.virtualDiskSettingsForm.diskFile = '';
         }

         var capacity = virtualDiskSettingsFormService.buildCapacity(
               self.inflatedDevice,
               self.createMode || self.cloneMode,
               datastoreInfo);
         self.virtualDiskSettingsForm.capacity.minInMB = capacity.minInMB;
         self.virtualDiskSettingsForm.capacity.maxInMB = capacity.maxInMB;
         self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage =
               capacity.maxExceededErrorMessage;
         self.virtualDiskSettingsForm.capacity.isMaxAvailable =
               capacity.isMaxAvailable;
         setErrorMessage(self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage);

         self.setStorageForDisk({ storageInfo: selectedStorageInfo, device: device });

         self.inflatedDevice.updateFileName(self.virtualDiskSettingsForm.diskFile);

         if (selectedStorageInfo && selectedStorageInfo.storageObject) {
            self.inflatedDevice.updateDatastoreMor(selectedStorageInfo.storageObject.storageRef);
            if (selectedStorageInfo.storageObject.parentStoragePod) {
               self.inflatedDevice.updateParentStoragePodMor(
                     selectedStorageInfo.storageObject.parentStoragePod);
            }
         } else {
            self.inflatedDevice.updateDatastoreMor(null);
         }
      }

      function isStoragePod(selectedStorageInfo) {
         return selectedStorageInfo &&
               selectedStorageInfo.storageObject &&
               selectedStorageInfo.storageObject.storageRef &&
               selectedStorageInfo.storageObject.storageRef.type === managedEntityConstants.STORAGE_POD;
      }

      function isAddedDeviceAController(deviceType) {
         var isScsiController = deviceType === deviceTypeConstants.SCSICONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.SCSICONTROLLER);
         var isSataController = deviceType === deviceTypeConstants.VIRTUAL_SATA_CONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.VIRTUAL_SATA_CONTROLLER);
         var isNvmeController = deviceType === deviceTypeConstants.NVME_CONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.NVME_CONTROLLER);
         return isScsiController || isSataController || isNvmeController;
      }

      function rebuildControllersDropdown() {
         self.virtualDiskSettingsForm.controllers =
               virtualDiskSettingsFormService.buildControllersDropdown(
                     self.inflatedDevice,
                     self.virtualMachineDevices.getAllDevicesNotMarkedForRemoval()
                     );
      }

      function getStorageLocatorItemsForCreateOrEditMode() {
         if (self.storageLocatorItemsData) {
            return $q.when(self.storageLocatorItemsData);
         } else {
            return vmDatastoreLocationBrowserService.getStorageLocatorItems(self.vmId);
         }
      }

      function getAllBackendStorageCallPromises () {

         if (self.createMode || self.cloneMode || !self.vmAssignmentsProperties) {
            return {
               storageProfilesPromiseResult: self.storageProfiles,
               vmAssignmentsPromiseResult: self.vmAssignmentsProperties
            };
         }

         return vmHardwareVirtualDiskService.getAllBackendStorageCallPromises
         ($q, self.vmAssignmentsProperties, self.storageProfiles);

      }

      function init_aria() {
         var i18n = function(key) {
            return i18nService.getString("VmUi", 'DiskPage.' + key);
         };

         self.ARIA_LBL_CAPACITY = self.i18n("VmUi", "VmDiskView.capacity");
         self.ARIA_LBL_PROFILE = i18n('Profile');
         self.ARIA_LBL_LOCATION = i18n('Location');
         self.ARIA_LBL_RGROUP = i18n('ProtectionGroup');
         self.ARIA_LBL_PROVISION = i18n('DiskProvisioning');
         self.ARIA_LBL_LIMIT_IOPS = i18n('LimitIOPs');
         self.ARIA_LBL_CACHE = i18n('CacheReservation');
         self.ARIA_LBL_SHARING = i18n('Sharing');
         self.ARIA_LBL_SHARES = i18n('Shares');
         self.ARIA_LBL_DISK_MODE = i18n('DiskMode');

         i18n = function(key) {
            return i18nService.getString("VmUi", 'DeviceDeletedControl.' + key);
         };
         self.ARIA_LBL_REMOVE = i18n('DeviceDeleted');
         self.ARIA_LBL_DESTROY = i18n('DeleteFiles');
         self.ARIA_LBL_RESTORE = i18n('Restore');
      }

      init_aria();
   }
}());

var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskCompatibilityModeController = (function () {
        function VmHardwareVirtualDiskCompatibilityModeController() {
        }
        VmHardwareVirtualDiskCompatibilityModeController.prototype.onCompatibilityModeChange = function (newSelection) {
            this.onChange({
                compatibilityMode: newSelection.value
            });
        };
        return VmHardwareVirtualDiskCompatibilityModeController;
    }());
    var VmHardwareVirtualDiskCompatibilityMode = (function () {
        function VmHardwareVirtualDiskCompatibilityMode() {
            this.bindings = {
                isDisabled: '<',
                ariaLabel: '<',
                compatibilityModeInfo: '<',
                onChange: '&'
            };
            this.controller = VmHardwareVirtualDiskCompatibilityModeController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/' +
                'vmHardwareVirtualDiskCompatibilityMode/vm-hardware-virtual-disk-compatibility-mode.html';
        }
        return VmHardwareVirtualDiskCompatibilityMode;
    }());
    h5_vm.VmHardwareVirtualDiskCompatibilityMode = VmHardwareVirtualDiskCompatibilityMode;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskCompatibilityMode', new VmHardwareVirtualDiskCompatibilityMode());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskCompatibilityModeService = (function () {
        function VmHardwareVirtualDiskCompatibilityModeService(i18nService, vmDeviceInfoService) {
            this.i18nService = i18nService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.VIRTUAL_COMPATIBILITY_MODE = "virtualMode";
        }
        VmHardwareVirtualDiskCompatibilityModeService.prototype.getCompatibilityModeInfo = function (vmConfigContext, inflatedDevice, allInflatedDevices) {
            var _this = this;
            var optionsForDiskBacking = this.vmDeviceInfoService.backingOptionForDevice(vmConfigContext, inflatedDevice, allInflatedDevices);
            if (!optionsForDiskBacking.compatibilityMode) {
                return;
            }
            var options = _.map(optionsForDiskBacking.compatibilityMode.choiceInfo, function (modeOption) {
                return {
                    name: _this.i18nService.getString('VmUi', 'DiskPage.' + modeOption.key),
                    value: modeOption.key
                };
            });
            var selection = _.find(options, function (option) {
                return option.value === inflatedDevice.getCurrentDevice().backing.compatibilityMode;
            });
            return {
                options: options,
                selection: selection
            };
        };
        VmHardwareVirtualDiskCompatibilityModeService.$inject = [
            'i18nService',
            'vmDeviceInfoService'
        ];
        return VmHardwareVirtualDiskCompatibilityModeService;
    }());
    h5_vm.VmHardwareVirtualDiskCompatibilityModeService = VmHardwareVirtualDiskCompatibilityModeService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskCompatibilityModeService', VmHardwareVirtualDiskCompatibilityModeService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskFlashReadCacheController = (function () {
        function VmHardwareVirtualDiskFlashReadCacheController(i18nService) {
            this.i18nService = i18nService;
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskFlashReadCacheController.prototype.onFlashCacheReservationChange = function () {
            this.onChange({
                flashCacheReservation: this.flashCacheReservationInfo.valueInMB
            });
        };
        VmHardwareVirtualDiskFlashReadCacheController.$inject = [
            'i18nService'
        ];
        return VmHardwareVirtualDiskFlashReadCacheController;
    }());
    var VmHardwareVirtualDiskFlashReadCache = (function () {
        function VmHardwareVirtualDiskFlashReadCache() {
            this.bindings = {
                flashCacheReservationInfo: '<',
                isDisabled: '<',
                ariaLabel: '<',
                onChange: '&'
            };
            this.controller = VmHardwareVirtualDiskFlashReadCacheController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/' +
                'vmHardwareVirtualDiskFlashReadCache/vm-hardware-virtual-disk-flash-read-cache.html';
        }
        return VmHardwareVirtualDiskFlashReadCache;
    }());
    h5_vm.VmHardwareVirtualDiskFlashReadCache = VmHardwareVirtualDiskFlashReadCache;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskFlashReadCache', new VmHardwareVirtualDiskFlashReadCache());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareVirtualDiskFlashReadCacheService = (function () {
        function VmHardwareVirtualDiskFlashReadCacheService(virtualDiskSettingsFormService, vmHardwareUtil, i18nService) {
            this.virtualDiskSettingsFormService = virtualDiskSettingsFormService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.i18nService = i18nService;
        }
        VmHardwareVirtualDiskFlashReadCacheService.prototype.getFlashCacheReservationInfo = function (device, vFlashSupportedOnHost) {
            return {
                vFlashSupportedOnHost: vFlashSupportedOnHost,
                valueInMB: device.vFlashCacheConfigInfo ? device.vFlashCacheConfigInfo.reservationInMB : 0,
                validUnits: [
                    { label: this.i18nService.getString('VmUi', "Vm.Units.MB"), multiplier: 1 }
                ]
            };
        };
        VmHardwareVirtualDiskFlashReadCacheService.prototype.hasPrivilegesToEditFlashReadCache = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareVirtualDiskFlashReadCacheService.prototype.isEditFlashReadCacheDisabled = function (privileges, createMode) {
            return !this.hasPrivilegesToEditFlashReadCache(privileges, createMode);
        };
        VmHardwareVirtualDiskFlashReadCacheService.$inject = [
            "virtualDiskSettingsFormService",
            "vmHardwareUtil",
            "i18nService"
        ];
        return VmHardwareVirtualDiskFlashReadCacheService;
    }());
    h5_vm.VmHardwareVirtualDiskFlashReadCacheService = VmHardwareVirtualDiskFlashReadCacheService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmHardwareVirtualDiskFlashReadCacheService", VmHardwareVirtualDiskFlashReadCacheService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var IopsLimitDetails = (function () {
        function IopsLimitDetails(i18nService, unlimited, iopsLimit) {
            var _this = this;
            this.i18nService = i18nService;
            this.unlimited = unlimited;
            this.iopsLimit = iopsLimit;
            this.IOPSLIMIT_MIN = 16;
            this.IOPSLIMIT_MAX = (Math.pow(2, 31) - 1);
            this.IOPS_UNLIMITED_SELECTION = "unlimited";
            this.IOPS_CUSTOM_SELECTION = "custom";
            var i18n = i18nService.getString;
            this.min = this.IOPSLIMIT_MIN;
            this.max = this.IOPSLIMIT_MAX;
            this.iopsRecommendations = [
                {
                    name: i18n('VmUi', 'VmCpu.Limit.Minimum'),
                    value: this.IOPSLIMIT_MIN
                },
                {
                    name: i18n('VmUi', 'VmCpu.Limit.Maximum'),
                    value: this.IOPSLIMIT_MAX
                }
            ];
            this.iopsLimitSelectList = [
                {
                    label: i18n('VmUi', 'DiskConfig.Unlimited'),
                    data: 'unlimited'
                },
                {
                    label: i18n('VmUi', 'sharesInfoLevel.custom'),
                    data: 'custom'
                }
            ];
            this.errorMessage = {
                max: function () { return i18n('Common', 'SharesControl.RangeError', _this.IOPSLIMIT_MIN, _this.IOPSLIMIT_MAX); },
                min: function () { return i18n('Common', 'SharesControl.RangeError', _this.IOPSLIMIT_MIN, _this.IOPSLIMIT_MAX); }
            };
            this.iopsLimitSelection =
                (iopsLimit === unlimited) ?
                    this.iopsLimitSelectList[0] :
                    this.iopsLimitSelectList[1];
        }
        return IopsLimitDetails;
    }());
    h5_vm.IopsLimitDetails = IopsLimitDetails;
    var IopsRecommendation = (function () {
        function IopsRecommendation() {
        }
        return IopsRecommendation;
    }());
    h5_vm.IopsRecommendation = IopsRecommendation;
    var IopsLimitSelect = (function () {
        function IopsLimitSelect() {
        }
        return IopsLimitSelect;
    }());
    h5_vm.IopsLimitSelect = IopsLimitSelect;
    var VmHardwareVirtualDiskIopsController = (function () {
        function VmHardwareVirtualDiskIopsController(i18nService, VirtualDisk) {
            this.i18nService = i18nService;
            this.VirtualDisk = VirtualDisk;
            this.i18n = i18nService.getString;
        }
        VmHardwareVirtualDiskIopsController.prototype.onIopsLimitSelectionChange = function () {
            if (this.iopsLimitDetails.iopsLimitSelection.data === this.iopsLimitDetails.IOPS_UNLIMITED_SELECTION) {
                this.iopsLimit = this.VirtualDisk.UNLIMITED_DISK;
            }
            else {
                this.iopsLimit = this.iopsLimitDetails.IOPSLIMIT_MIN;
            }
            this.onChange({ iopsLimit: this.iopsLimit });
        };
        VmHardwareVirtualDiskIopsController.prototype.onIopsLimitValueChange = function () {
            this.onChange({ iopsLimit: this.iopsLimit });
        };
        VmHardwareVirtualDiskIopsController.prototype.isCustom = function () {
            if (this.iopsLimitDetails) {
                return this.iopsLimitDetails.iopsLimitSelection.data === this.iopsLimitDetails.IOPS_CUSTOM_SELECTION;
            }
            else {
                return false;
            }
        };
        VmHardwareVirtualDiskIopsController.prototype.$onInit = function () {
            if (this.iopsLimit) {
                this.iopsLimitDetails = new IopsLimitDetails(this.i18nService, this.VirtualDisk.UNLIMITED_DISK, this.iopsLimit);
            }
        };
        VmHardwareVirtualDiskIopsController.prototype.$onChanges = function (changes) {
            if (changes.iopsLimit.currentValue) {
                this.iopsLimitDetails = new IopsLimitDetails(this.i18nService, this.VirtualDisk.UNLIMITED_DISK, this.iopsLimit);
            }
        };
        VmHardwareVirtualDiskIopsController.$inject = [
            'i18nService',
            'VirtualDisk'
        ];
        return VmHardwareVirtualDiskIopsController;
    }());
    var VmHardwareVirtualDiskIops = (function () {
        function VmHardwareVirtualDiskIops() {
            this.bindings = {
                iopsLimit: '<',
                isDisabled: '<',
                ariaLabel: '<',
                onChange: '&'
            };
            this.controller = VmHardwareVirtualDiskIopsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/' +
                'vmHardwareVirtualDiskIops/vm-hardware-virtual-disk-iops.html';
        }
        return VmHardwareVirtualDiskIops;
    }());
    h5_vm.VmHardwareVirtualDiskIops = VmHardwareVirtualDiskIops;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskIops', new VmHardwareVirtualDiskIops());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareVirtualDiskIopsService = (function () {
        function VmHardwareVirtualDiskIopsService(i18nService, vmHardwareUtil) {
            this.i18nService = i18nService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareVirtualDiskIopsService.prototype.getIopsLimit = function (device) {
            var iopsLimit = device.getCurrentDevice().storageIOAllocation.limit;
            return iopsLimit === -1 ? this.i18nService.getString('VmUi', 'DiskConfig.Unlimited') : iopsLimit;
        };
        VmHardwareVirtualDiskIopsService.prototype.isEditIopsLimitDisabled = function (privileges, createMode) {
            return !this.hasPrivilegeToEditIopsLimit(privileges, createMode);
        };
        VmHardwareVirtualDiskIopsService.prototype.hasPrivilegeToEditIopsLimit = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_RESOURCE_PRIVILEGE, Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareVirtualDiskIopsService.$inject = [
            "i18nService",
            "vmHardwareUtil"
        ];
        return VmHardwareVirtualDiskIopsService;
    }());
    h5_vm.VmHardwareVirtualDiskIopsService = VmHardwareVirtualDiskIopsService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskIopsService', VmHardwareVirtualDiskIopsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskModeController = (function () {
        function VmHardwareVirtualDiskModeController(vmHardwareVirtualDiskModeService, i18nService) {
            var _this = this;
            this.vmHardwareVirtualDiskModeService = vmHardwareVirtualDiskModeService;
            this.i18nService = i18nService;
            this.i18n = this.i18nService.getString;
            this.vmHardwareVirtualDiskModeService.getDiskModeSignPostParams()
                .then(function (value) {
                _this.diskModeSignPostParams = value;
            });
        }
        VmHardwareVirtualDiskModeController.prototype.onDiskModeChange = function () {
            this.onChange({ diskMode: this.diskModeInfo.selection.value });
        };
        VmHardwareVirtualDiskModeController.$inject = ['vmHardwareVirtualDiskModeService', 'i18nService'];
        return VmHardwareVirtualDiskModeController;
    }());
    var VmHardwareVirtualDiskMode = (function () {
        function VmHardwareVirtualDiskMode() {
            this.bindings = {
                diskModeInfo: '<',
                isDisabled: '<',
                ariaLabel: '<',
                onChange: '&'
            };
            this.controller = VmHardwareVirtualDiskModeController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDiskShared/' +
                'vmHardwareVirtualDiskMode/vm-hardware-virtual-disk-mode.html';
        }
        return VmHardwareVirtualDiskMode;
    }());
    h5_vm.VmHardwareVirtualDiskMode = VmHardwareVirtualDiskMode;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskMode', new VmHardwareVirtualDiskMode());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskModeService = (function () {
        function VmHardwareVirtualDiskModeService(vmDeviceInfoService, i18nService, templateHelperService, vmHardwareUtil) {
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.i18nService = i18nService;
            this.templateHelperService = templateHelperService;
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmHardwareVirtualDiskModeService.prototype.getDiskModeInfo = function (vmConfigContext, inflatedDevice, allVirtualDevices) {
            var _this = this;
            var optionsForDiskBacking = this.vmDeviceInfoService.backingOptionForDevice(vmConfigContext, inflatedDevice, allVirtualDevices);
            var options = _.map(optionsForDiskBacking.diskMode.choiceInfo, function (modeOption) {
                return {
                    name: _this.i18nService.getString('VmUi', 'DiskConfig.' + modeOption.key),
                    value: modeOption.key
                };
            });
            var selection = _.find(options, function (option) {
                return option.value === inflatedDevice.getCurrentDevice().backing.diskMode;
            });
            return {
                options: options,
                selection: selection
            };
        };
        VmHardwareVirtualDiskModeService.prototype.getDiskModeSignPostParams = function () {
            var _this = this;
            var diskModeSignPostTemplate = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/' +
                'vmHardwareVirtualDiskShared/vmHardwareVirtualDiskMode/vm-hardware-virtual-disk-mode-sign-post.html';
            return this.templateHelperService.renderTemplateWithScope(diskModeSignPostTemplate, { i18n: this.i18nService.getString })
                .then(function (content) {
                return {
                    message: content,
                    title: _this.i18nService.getString('Common', 'help'),
                    height: '250px'
                };
            });
        };
        VmHardwareVirtualDiskModeService.prototype.hasPrivilegesToEditDiskMode = function (privileges, skipPrivilegeCheck) {
            if (skipPrivilegeCheck === void 0) { skipPrivilegeCheck = false; }
            if (skipPrivilegeCheck) {
                return true;
            }
            return this.vmHardwareUtil.checkPrivileges(privileges, [h5_vm.Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmHardwareVirtualDiskModeService.prototype.isEditDiskModeDisabled = function (inflatedDevice, createMode, vmConfigContext) {
            if (!this.hasPrivilegesToEditDiskMode(vmConfigContext.privileges, createMode)) {
                return true;
            }
            if (this.vmHardwareUtil.isVmPoweredOn(vmConfigContext.environment.powerState) && !inflatedDevice.isNew()) {
                return true;
            }
            if (createMode) {
                return false;
            }
            else {
                return inflatedDevice.getCurrentDevice().backing.parent ? true : false;
            }
        };
        VmHardwareVirtualDiskModeService.$inject = [
            'vmDeviceInfoService',
            'i18nService',
            'templateHelperService',
            'vmHardwareUtil'
        ];
        return VmHardwareVirtualDiskModeService;
    }());
    h5_vm.VmHardwareVirtualDiskModeService = VmHardwareVirtualDiskModeService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareVirtualDiskModeService', VmHardwareVirtualDiskModeService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualDiskTypeController = (function () {
        function VmHardwareVirtualDiskTypeController(vmHardwareRdmVirtualDiskTypeService) {
            this.vmHardwareRdmVirtualDiskTypeService = vmHardwareRdmVirtualDiskTypeService;
        }
        Object.defineProperty(VmHardwareVirtualDiskTypeController.prototype, "provisioningTypeLabel", {
            get: function () {
                if (!this.deviceBacking) {
                    return "";
                }
                if (!this.vmHardwareRdmVirtualDiskTypeService) {
                    return "";
                }
                var retVal = this.vmHardwareRdmVirtualDiskTypeService.getProvisioningTypeLabel(this.deviceBacking);
                return retVal;
            },
            enumerable: true,
            configurable: true
        });
        VmHardwareVirtualDiskTypeController.$inject = ['vmHardwareRdmVirtualDiskTypeService'];
        return VmHardwareVirtualDiskTypeController;
    }());
    var VmHardwareVirtualDiskType = (function () {
        function VmHardwareVirtualDiskType() {
            this.bindings = {
                deviceBacking: '<'
            };
            this.controller = VmHardwareVirtualDiskTypeController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmHardwareSettings/' +
                'vmHardwareVirtualDiskType/vm-hardware-virtual-disk-type.html';
        }
        return VmHardwareVirtualDiskType;
    }());
    h5_vm.VmHardwareVirtualDiskType = VmHardwareVirtualDiskType;
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmHardwareVirtualDiskType', new VmHardwareVirtualDiskType());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VmHardwareRdmVirtualDiskTypeService = (function () {
        function VmHardwareRdmVirtualDiskTypeService(i18nService, diskBackingInfoConstants, diskProvisioningService) {
            this.i18nService = i18nService;
            this.diskBackingInfoConstants = diskBackingInfoConstants;
            this.diskProvisioningService = diskProvisioningService;
        }
        VmHardwareRdmVirtualDiskTypeService.prototype.isRdmDisk = function (deviceBacking) {
            return deviceBacking._type ===
                this.diskBackingInfoConstants.RAWDISKMAPPING;
        };
        VmHardwareRdmVirtualDiskTypeService.prototype.getProvisioningTypeLabel = function (deviceBacking) {
            if (this.isRdmDisk(deviceBacking)) {
                return this.i18nService.getString('VmUi', 'VmDeviceManager.RDMDisk');
            }
            return this.diskProvisioningService
                .getName(deviceBacking);
        };
        VmHardwareRdmVirtualDiskTypeService.$inject = [
            'i18nService',
            'diskBackingInfoConstants',
            'diskProvisioningService'
        ];
        return VmHardwareRdmVirtualDiskTypeService;
    }());
    h5_vm.VmHardwareRdmVirtualDiskTypeService = VmHardwareRdmVirtualDiskTypeService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmHardwareRdmVirtualDiskTypeService', VmHardwareRdmVirtualDiskTypeService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var PmemUtilService = h5_vm.PmemUtilService;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VirtualNvdimmService = (function () {
        function VirtualNvdimmService(pmemUtilService, pmemCapacityService, i18nService) {
            this.pmemUtilService = pmemUtilService;
            this.pmemCapacityService = pmemCapacityService;
            this.i18nService = i18nService;
            this.NVDIMM_REMOVED = "nvdimmRemoved";
            this.MB_UNIT_LOCALIZED = this.i18nService.getString("VmUi", "Vm.Units.MB");
            this.GB_UNIT_LOCALIZED = this.i18nService.getString("VmUi", "Vm.Units.GB");
        }
        VirtualNvdimmService.prototype.getGrowthGranularityInMB = function (vmConfigContext, guestOs, vmWorkflow) {
            var result;
            if (!this.isUpdateWorkflow(vmWorkflow)
                || this.vmIsPoweredOff(vmConfigContext)) {
                result = guestOs.persistentMemoryColdGrowthGranularityMB;
            }
            else {
                result = guestOs.persistentMemoryHotGrowthGranularityMB;
            }
            if (isNaN(result) || result === 0) {
                result = 1;
            }
            return result;
        };
        VirtualNvdimmService.prototype.isGrowthSupported = function (vmConfigContext, guestOs, vmWorkflow) {
            var result;
            if (this.isCloneWorkflow(vmWorkflow)) {
                return true;
            }
            if (!this.isUpdateWorkflow(vmWorkflow)
                || this.vmIsPoweredOff(vmConfigContext)) {
                result = guestOs.persistentMemoryColdGrowthSupported;
            }
            else {
                result = guestOs.persistentMemoryHotGrowthSupported;
            }
            return result;
        };
        VirtualNvdimmService.prototype.isRemoveDisabled = function (vmConfigContext, guestOs, vmWorkflow) {
            if (!this.isUpdateWorkflow(vmWorkflow)
                || this.vmIsPoweredOff(vmConfigContext)) {
                return false;
            }
            else {
                return !guestOs.persistentMemoryHotRemoveSupported;
            }
        };
        VirtualNvdimmService.prototype.isControllerRemoveDisabled = function (vmConfigContext, virtualMachineDevices, vmWorkflow) {
            if (!this.isUpdateWorkflow(vmWorkflow)
                || this.vmIsPoweredOff(vmConfigContext)) {
                return !this.areAllNvdimmsMarkedForRemoval(virtualMachineDevices);
            }
            else {
                var controllerOption = this.pmemUtilService.findOption(vmConfigContext.environment, PmemUtilService.NVDIMM_CONTROLLER);
                var hotRemoveSupported = controllerOption.hotRemoveSupported;
                return !(hotRemoveSupported
                    || !this.areAllNvdimmsMarkedForRemoval(virtualMachineDevices));
            }
        };
        VirtualNvdimmService.prototype.getMinimumAllowedCapacity = function (vmConfigContext, guestOs, device /* inflatedDevice */) {
            var nvdimmOption = this.pmemUtilService.findOption(vmConfigContext.environment, PmemUtilService.NVDIMM);
            var guestOsMin = guestOs.supportedMinPersistentMemoryMB;
            var newDeviceMinMemMB = Math.max(nvdimmOption.capacityInMB.min, guestOsMin);
            if (device.isNew()) {
                return newDeviceMinMemMB;
            }
            else {
                return device.getCurrentDevice().capacityInMB;
            }
        };
        VirtualNvdimmService.prototype.getMaximumAllowedCapacity = function (vmConfigContext, guestOs, device, virtualMachineDevices) {
            return this.pmemCapacityService.getMaxCapacityForNvdimm(vmConfigContext, guestOs, device, virtualMachineDevices);
        };
        VirtualNvdimmService.prototype.getIsNvmAndRamExceedingGuestOsLimits = function (vmConfigContext, guestOs, virtualMachineDevices) {
            return this.pmemCapacityService.getIsNvmAndRamExceedingGuestOsLimits(vmConfigContext, guestOs, virtualMachineDevices);
        };
        VirtualNvdimmService.prototype.getDefaultMemoryUnit = function (rawNvdimmDevice) {
            if (!rawNvdimmDevice) {
                return this.GB_UNIT_LOCALIZED;
            }
            return rawNvdimmDevice.capacityInMB < 1024
                ? this.MB_UNIT_LOCALIZED : this.GB_UNIT_LOCALIZED;
        };
        VirtualNvdimmService.prototype.areAllNvdimmsMarkedForRemoval = function (virtualMachineDevices) {
            var countOfRemovedNvdimms = 0;
            var countOfAllNvdimms = 0;
            var nvdimmArray = virtualMachineDevices.devicesOfType(PmemUtilService.NVDIMM);
            for (var _i = 0, nvdimmArray_1 = nvdimmArray; _i < nvdimmArray_1.length; _i++) {
                var nvdimm = nvdimmArray_1[_i];
                countOfAllNvdimms++;
                if (nvdimm.isMarkedForRemoval()) {
                    countOfRemovedNvdimms++;
                }
            }
            return countOfRemovedNvdimms === countOfAllNvdimms;
        };
        VirtualNvdimmService.prototype.vmIsPoweredOff = function (vmConfigContext) {
            if (!vmConfigContext || !vmConfigContext.rtInfo) {
                return false;
            }
            return vmConfigContext.rtInfo.powerState
                === VirtualNvdimmService.POWERED_OFF_STATE;
        };
        VirtualNvdimmService.prototype.isUpdateWorkflow = function (vmWorkflow) {
            return vmWorkflow === VmWorkflowMode.UpdateMode;
        };
        VirtualNvdimmService.prototype.isCloneWorkflow = function (vmWorkflow) {
            return vmWorkflow === VmWorkflowMode.CloneMode;
        };
        VirtualNvdimmService.POWERED_OFF_STATE = "poweredOff";
        VirtualNvdimmService.$inject = [
            "pmemUtilService",
            "pmemCapacityService",
            "i18nService"
        ];
        return VirtualNvdimmService;
    }());
    h5_vm.VirtualNvdimmService = VirtualNvdimmService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("virtualNvdimmService", VirtualNvdimmService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmHardwareVirtualNvdimm = (function () {
        function VmHardwareVirtualNvdimm() {
            this.bindings = {
                nvdimmDevice: "<",
                removeCallback: "&",
                vmWorkflowMode: "<",
                vmConfigContext: "<",
                virtualMachineDevices: "<",
                selectedGuestOs: "<"
            };
            this.controller = VmHardwareVirtualNvdimmController;
            this.templateUrl =
                "vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualNvdimm/vm-hardware-virtual-nvdimm.component.html";
        }
        return VmHardwareVirtualNvdimm;
    }());
    h5_vm.VmHardwareVirtualNvdimm = VmHardwareVirtualNvdimm;
    var VmHardwareVirtualNvdimmController = (function () {
        function VmHardwareVirtualNvdimmController(i18nService, virtualNvdimmService, pmemUtilService, $scope, $rootScope, vmHardwareVirtualDiskService) {
            this.i18nService = i18nService;
            this.virtualNvdimmService = virtualNvdimmService;
            this.pmemUtilService = pmemUtilService;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.vmHardwareVirtualDiskService = vmHardwareVirtualDiskService;
            this.memoryOptions = this.getMemoryOptions();
            this.rawNvdimmDevice = this.nvdimmDevice.getCurrentDevice();
            this.deviceName = this.rawNvdimmDevice.deviceInfo.label;
            this.growthGranularityMB = this.virtualNvdimmService.getGrowthGranularityInMB(this.vmConfigContext, this.selectedGuestOs, this.vmWorkflowMode);
            this.isGrowthEnabled = this.virtualNvdimmService.isGrowthSupported(this.vmConfigContext, this.selectedGuestOs, this.vmWorkflowMode);
            this.minAllowedCapacity = this.virtualNvdimmService.getMinimumAllowedCapacity(this.vmConfigContext, this.selectedGuestOs, this.nvdimmDevice);
            this.calculateMaxAllowedCapacity();
            this.isRemoveDisabled = this.virtualNvdimmService.isRemoveDisabled(this.vmConfigContext, this.selectedGuestOs, this.vmWorkflowMode);
            this.defaultMemoryUnit = this.virtualNvdimmService.getDefaultMemoryUnit(this.rawNvdimmDevice);
            this.capacityErrorMessages = this.getDefaultErrorMessages(this.growthGranularityMB, this.minAllowedCapacity);
        }
        VmHardwareVirtualNvdimmController.prototype.calculateMaxAllowedCapacity = function () {
            this.maxAllowedCapacity = this.virtualNvdimmService.getMaximumAllowedCapacity(this.vmConfigContext, this.selectedGuestOs, this.nvdimmDevice, this.virtualMachineDevices);
        };
        VmHardwareVirtualNvdimmController.prototype.$onInit = function () {
            var _this = this;
            this.dummyCapacity = this.rawNvdimmDevice.capacityInMB;
            this.listenerDeregistrationFuction = this.$scope.$on(this.virtualNvdimmService.NVDIMM_REMOVED, function (event) {
                _this.calculateMaxAllowedCapacity();
            });
            this.hardDiskListenerDeregistrationFuction = this.$scope.$on(this.vmHardwareVirtualDiskService.DISK_SIZE_UPDATED, function (event) {
                _this.calculateMaxAllowedCapacity();
            });
        };
        VmHardwareVirtualNvdimmController.prototype.$onDestroy = function () {
            if (this.listenerDeregistrationFuction) {
                this.listenerDeregistrationFuction();
            }
            if (this.hardDiskListenerDeregistrationFuction) {
                this.hardDiskListenerDeregistrationFuction();
            }
        };
        VmHardwareVirtualNvdimmController.prototype.onCapacityChange = function (value) {
            this.rawNvdimmDevice.capacityInMB = value;
            this.calculateMaxAllowedCapacity();
            var exceedsGuestMemory = this.virtualNvdimmService.getIsNvmAndRamExceedingGuestOsLimits(this.vmConfigContext, this.selectedGuestOs, this.virtualMachineDevices);
            this.capacityErrorMessages = {
                max: exceedsGuestMemory
                    ? this.i18n("NVDIMM.exceedsGuest1") : this.i18n("NVDIMM.exceedsPMem"),
                min: this.i18n("NVDIMM.noShrink", this.minAllowedCapacity.toString()),
                mod: this.i18n("NVDIMM.growGranularityError", this.growthGranularityMB.toString())
            };
        };
        VmHardwareVirtualNvdimmController.prototype.hasError = function () {
            if (!_.isEmpty(this.$scope.vmHardwareNvdimmForm)) {
                return this.$scope.vmHardwareNvdimmForm.$invalid;
            }
            return false;
        };
        VmHardwareVirtualNvdimmController.prototype.removeNvdimm = function () {
            if (!this.isRemoveDisabled && this.removeCallback) {
                this.nvdimmDevice.setFileOperation("destroy");
                this.removeCallback()(this.nvdimmDevice);
                this.broadcastNvdimmRemoveded();
            }
        };
        VmHardwareVirtualNvdimmController.prototype.revertNvdimmRemoval = function () {
            this.nvdimmDevice.revertRemoval();
            this.nvdimmDevice.setFileOperation(undefined);
            this.broadcastNvdimmRemoveded();
        };
        VmHardwareVirtualNvdimmController.prototype.getAvailablePmemCapacity = function () {
            return this.pmemUtilService.getAvailablePmemCapacity(this.vmConfigContext);
        };
        VmHardwareVirtualNvdimmController.prototype.getSupportedPmemByGuestOs = function () {
            return this.pmemUtilService.getSupportedPmemByGuestOs(this.selectedGuestOs);
        };
        VmHardwareVirtualNvdimmController.prototype.i18n = function (key, param, bundle) {
            if (param === void 0) { param = ""; }
            if (bundle === void 0) { bundle = "VmUi"; }
            return this.i18nService.getString(bundle, key, param);
        };
        VmHardwareVirtualNvdimmController.prototype.getDefaultErrorMessages = function (growthGranularityMB, minAllowedCapacity) {
            return {
                max: this.i18n("NVDIMM.exceedsPMem"),
                min: this.i18n("NVDIMM.noShrink", minAllowedCapacity.toString()),
                mod: this.i18n("NVDIMM.growGranularityError", growthGranularityMB.toString())
            };
        };
        VmHardwareVirtualNvdimmController.prototype.getMemoryOptions = function () {
            return [
                { label: this.virtualNvdimmService.MB_UNIT_LOCALIZED, multiplier: 1 },
                { label: this.virtualNvdimmService.GB_UNIT_LOCALIZED, multiplier: 1024 }
            ];
        };
        VmHardwareVirtualNvdimmController.prototype.broadcastNvdimmRemoveded = function () {
            this.$rootScope.$broadcast(this.virtualNvdimmService.NVDIMM_REMOVED);
        };
        VmHardwareVirtualNvdimmController.$inject = [
            "i18nService",
            "virtualNvdimmService",
            "pmemUtilService",
            "$scope",
            "$rootScope",
            "vmHardwareVirtualDiskService"
        ];
        return VmHardwareVirtualNvdimmController;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmHardwareVirtualNvdimm", new VmHardwareVirtualNvdimm());
})(h5_vm || (h5_vm = {}));



var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var h5_vm;
(function (h5_vm) {
    var BootOptionsData = com.vmware.vim.binding.vim.vm.BootOptions;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var BootOptionsConstants = (function () {
        function BootOptionsConstants() {
        }
        BootOptionsConstants.BOOT_DELAY_MIN = 0;
        BootOptionsConstants.BOOT_DELAY_MAX = 10000;
        BootOptionsConstants.RETRY_DELAY_MIN = 10;
        BootOptionsConstants.RETRY_DELAY_MAX = 2147483;
        BootOptionsConstants.BOOT_DELAY_STEP = 100;
        BootOptionsConstants.VM_POWERED_OFF = "poweredOff";
        return BootOptionsConstants;
    }());
    h5_vm.BootOptionsConstants = BootOptionsConstants;
    /**
     * class holds the menuItem data for the firmware select
     */
    var FirmwareMenuItem = (function () {
        function FirmwareMenuItem(displayName, realName, id, isRecommended) {
            this.displayName = displayName;
            this.realName = realName;
            this.id = id;
            this.isRecommended = isRecommended;
        }
        return FirmwareMenuItem;
    }());
    h5_vm.FirmwareMenuItem = FirmwareMenuItem;
    /**
     * class representing the view viewModel, and can be directly applied to
     * hardwareConfigData back by calling cloneBootOptionsData().
     * inherits the vmodl class BootOptions
     */
    var BootOptionsViewModel = (function (_super) {
        __extends(BootOptionsViewModel, _super);
        function BootOptionsViewModel(model) {
            if (model === void 0) { model = {}; }
            _super.call(this);
            // private members
            this.BOOT_DELAY_DEFAULT = BootOptionsConstants.BOOT_DELAY_MIN;
            this.RETRY_DELAY_DEFAULT = BootOptionsConstants.RETRY_DELAY_MIN *
                BootOptionsViewModel.MILLISECONDS;
            this.RETRY_ENABLED_DEFAULT = false;
            this.ENTER_BIOS_DEFAULT = false;
            this.bootDelayMin = BootOptionsConstants.BOOT_DELAY_MIN;
            this.bootDelayMax = BootOptionsConstants.BOOT_DELAY_MAX;
            this.bootDelayStep = BootOptionsConstants.BOOT_DELAY_STEP;
            this.retryDelayMin = BootOptionsConstants.RETRY_DELAY_MIN;
            this.retryDelayMax = BootOptionsConstants.RETRY_DELAY_MAX;
            this.firmwareList = [];
            this.firmwareWarningFlag = false;
            this.firmwareCompatibilityWarningFlag = false;
            this.incompatibleFirmware = "";
            this.inCreateMode = false;
            this.bootRecoverySettingsEditDisabled = false;
            this.bootDelayEditDisabled = false;
            this.isEnterBIOSSetupEditDisabled = false;
            this.bootRetryEditDisabled = false;
            this.bootRetryDelayEditDisabled = false;
            this.bootOptionsSupported = false;
            this.bootRetryOptionsSupported = false;
            this.bootDelay = model.bootDelay || this.BOOT_DELAY_DEFAULT;
            this.bootRetryDelay = model.bootRetryDelay || this.RETRY_DELAY_DEFAULT;
            // convert this field to sec.
            this.bootRetryDelay = this.bootRetryDelay / BootOptionsViewModel.MILLISECONDS;
            this.bootRetryEnabled = model.bootRetryEnabled || this.RETRY_ENABLED_DEFAULT;
            this.efiSecureBootEnabled = model.efiSecureBootEnabled || false;
            this.enterBIOSSetup = model.enterBIOSSetup || this.ENTER_BIOS_DEFAULT;
            this.networkBootProtocol = model.networkBootProtocol || null;
            this.bootOrder = model.bootOrder || null;
        }
        /**
         * makes a clone of this object and returns
         * @returns {BootOptionsData}
         */
        BootOptionsViewModel.prototype.cloneBootOptionsData = function () {
            var result = new BootOptionsData();
            result._type = "com.vmware.vim.binding.vim.vm.BootOptions";
            result.bootDelay = this.bootDelay;
            result.bootRetryDelay = this.bootRetryDelay * BootOptionsViewModel.MILLISECONDS;
            result.bootRetryEnabled = this.bootRetryEnabled;
            result.bootOrder = this.bootOrder;
            result.efiSecureBootEnabled = this.efiSecureBootEnabled;
            result.networkBootProtocol = this.networkBootProtocol;
            result.enterBIOSSetup = this.enterBIOSSetup;
            return result;
        };
        BootOptionsViewModel.prototype.selectFirmware = function (id) {
            var array = this.firmwareList;
            if (!array) {
                return;
            }
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                if (item && item.id === id) {
                    this.firmwareSelection = item;
                    return;
                }
            }
        };
        // public properties
        BootOptionsViewModel.MILLISECONDS = 1000;
        return BootOptionsViewModel;
    }(BootOptionsData));
    h5_vm.BootOptionsViewModel = BootOptionsViewModel;
    var BootOptionsBuilderService = (function () {
        function BootOptionsBuilderService(i18nService, templateHelperService) {
            var _this = this;
            this.i18nService = i18nService;
            this.templateHelperService = templateHelperService;
            this.STEP_MIDVALUE = BootOptionsConstants.BOOT_DELAY_STEP / 2;
            // ==========================================================================
            // ============================public methods================================
            // ==========================================================================
            /**
             * @param configContext : the configContext directly received from hardwareConfigData
             *
             * @returns {BootOptionsViewModel} returns a typed viewModel reflecting bootOptions
             */
            this.buildViewModel = function (configContext, mode, isVbsEnabled, vbsPropertyValues) {
                var result;
                if (!configContext || !configContext.config || !configContext.config.bootOptions) {
                    // return the default viewModel
                    result = new BootOptionsViewModel();
                }
                else {
                    result = new BootOptionsViewModel(configContext.config.bootOptions);
                }
                var firmwareToSelect = '';
                if (isVbsEnabled) {
                    result.efiSecureBootEnabled = vbsPropertyValues["bootOptions.efiSecureBootEnabled"];
                    firmwareToSelect = vbsPropertyValues["firmware"];
                }
                result = _this.addFirmwareListToModel(result, configContext, firmwareToSelect);
                result.firmwareEnabled = configContext.environment.powerState === BootOptionsConstants.VM_POWERED_OFF;
                if (_this.needsPrivilegeCheck(mode)) {
                    _this.checkSettingsPrivileges(result, configContext);
                }
                var caps = configContext.environment.configOption.capabilities;
                result.bootOptionsSupported = caps.bootOptionsSupported;
                result.bootRetryOptionsSupported = caps.bootRetryOptionsSupported;
                return result;
            };
            /**
             * @param viewModel : the view Model from which to extract the bootOptionsData
             * @returns {any} : the bootOptions object that can be set on hardwareConfigData
             */
            this.processBootOptionsForUpdate = function (viewModel, originalModel) {
                if (!viewModel) {
                    return null;
                }
                // first ensure we're within the boundaries
                viewModel.bootDelay = _this.limitBootDelay(viewModel.bootDelay, originalModel) ||
                    BootOptionsConstants.BOOT_DELAY_MIN;
                viewModel.bootDelay = _this.roundOff(viewModel.bootDelay);
                // ensure we're within the boundaries.
                viewModel.bootRetryDelay = _this.limitBootRetryDelay(viewModel.bootRetryDelay, originalModel) ||
                    BootOptionsConstants.RETRY_DELAY_MIN;
                // now make a clone of the core for the update bubble back to parent
                var updatedModel = viewModel;
                return updatedModel;
            };
            this.roundOff = function (value) {
                var remainder = value % BootOptionsConstants.BOOT_DELAY_STEP;
                return (remainder === 0) ? value :
                    (remainder < _this.STEP_MIDVALUE) ? (value - remainder) :
                        (value + BootOptionsConstants.BOOT_DELAY_STEP - remainder);
            };
            this.i18n = i18nService.getString;
        }
        BootOptionsBuilderService.prototype.isBootRetryDelayEditDisabled = function (viewModel) {
            if (viewModel === null) {
                return false;
            }
            return viewModel.bootRetryDelayEditDisabled || !viewModel.bootRetryEnabled;
        };
        BootOptionsBuilderService.prototype.needsPrivilegeCheck = function (mode) {
            if (mode !== VmWorkflowMode.CreateMode) {
                return true;
            }
            return false;
        };
        BootOptionsBuilderService.prototype.checkSettingsPrivileges = function (result, configContext) {
            var userHas = h5_vm.VmHardwareUtil.userHasVmSettingsPermission(configContext);
            if (userHas === true) {
                return;
            }
            result.firmwareEnabled = false;
            result.bootRecoverySettingsEditDisabled = true;
            result.bootDelayEditDisabled = true;
            result.isEnterBIOSSetupEditDisabled = true;
            result.bootRetryEditDisabled = true;
            result.bootRetryDelayEditDisabled = true;
            return;
        };
        BootOptionsBuilderService.prototype.shouldEnableFirmwareWarning = function (model, originalFirmwareSelection) {
            return !model.inCreateMode && model.firmwareSelection.id !== originalFirmwareSelection.id;
        };
        BootOptionsBuilderService.prototype.shouldEnableFirmwareCompatibilityWarning = function (model) {
            return !model.inCreateMode && model.incompatibleFirmware === model.firmwareSelection.id;
        };
        BootOptionsBuilderService.prototype.getFirmwareSignPostParams = function () {
            var _this = this;
            var bootOptionsTemplate = 'vm-ui/resources/vm/views/settings/vmOptions/bootOptions/boot-options-firmware-help-text.html';
            return this.templateHelperService.renderTemplateWithScope(bootOptionsTemplate, { i18n: this.i18nService.getString })
                .then(function (content) {
                return {
                    message: content,
                    title: _this.i18nService.getString('Common', 'help'),
                    class: 'boot-options-help-text'
                };
            });
        };
        BootOptionsBuilderService.prototype.getSecureBootSignPostParams = function () {
            var _this = this;
            var bootOptionsTemplate = 'vm-ui/resources/vm/views/settings/vmOptions/bootOptions/boot-options-secureBoot-help-text.html';
            return this.templateHelperService.renderTemplateWithScope(bootOptionsTemplate, { i18n: this.i18nService.getString })
                .then(function (content) {
                return {
                    message: content,
                    title: _this.i18nService.getString('Common', 'help'),
                    class: 'boot-options-help-text'
                };
            });
        };
        // ========================================================================================
        // ================================private methods=========================================
        // ========================================================================================
        BootOptionsBuilderService.prototype.addFirmwareListToModel = function (model, configContext, firmwareToSelect) {
            if (!configContext || !configContext.config ||
                !configContext.environment ||
                !configContext.environment.configOption ||
                _.isEmpty(configContext.environment.configOption.guestOSDescriptor)) {
                // add the default menu item
                model.firmwareList.push(this.buildFirmwareMenuItem("", "unknown"));
                model.firmwareSelection = model.firmwareList[0];
                return model;
            }
            // build the firmware list
            var configOption = configContext.environment.configOption;
            if (configOption.guestOSDescriptor.length > 1) {
                // create mode will have more than 1 gosDescriptors - so find the guestId set on the VM
                var guestId = configContext.config.guestId;
                model = this.addFirmwareListForCreateMode(model, guestId, configOption.guestOSDescriptor, firmwareToSelect);
            }
            else {
                model = this.buildFirmwareListOnModel(model, configOption.guestOSDescriptor[0], configContext.config.firmware);
            }
            return model;
        };
        BootOptionsBuilderService.prototype.addFirmwareListForCreateMode = function (model, guestId, gosDescriptorList, firmwareToSelect) {
            var gosTarget = _.find(gosDescriptorList, function (gosDesc) {
                return gosDesc.id === guestId;
            });
            // gosFirmware = '' in createMode
            return this.buildFirmwareListOnModel(model, gosTarget, "", true, firmwareToSelect);
        };
        BootOptionsBuilderService.prototype.buildFirmwareListOnModel = function (model, gosDescriptor, gosFirmware, createMode, firmwareToSelect) {
            var _this = this;
            if (createMode === void 0) { createMode = false; }
            if (firmwareToSelect === void 0) { firmwareToSelect = ""; }
            firmwareToSelect = _.isEmpty(firmwareToSelect) ?
                !_.isEmpty(gosFirmware) ? gosFirmware : gosDescriptor.recommendedFirmware :
                firmwareToSelect;
            _.each(gosDescriptor.supportedFirmware, function (firmware) {
                var firmwareMenuItem = _this.buildFirmwareMenuItem(gosDescriptor.recommendedFirmware, firmware);
                model.firmwareList.push(firmwareMenuItem);
                model.inCreateMode = createMode;
                if (firmwareToSelect === firmware) {
                    model.firmwareSelection = firmwareMenuItem;
                }
            });
            if (!createMode && !_.contains(gosDescriptor.supportedFirmware, gosFirmware)) {
                var firmwareMenuItem = this.buildFirmwareMenuItem(gosDescriptor.recommendedFirmware, gosFirmware);
                model.firmwareList.push(firmwareMenuItem);
                model.inCreateMode = createMode;
                model.firmwareSelection = firmwareMenuItem;
                model.incompatibleFirmware = gosFirmware;
            }
            return model;
        };
        BootOptionsBuilderService.prototype.buildFirmwareMenuItem = function (recommendedFirmware, firmware) {
            var isRecommended = false;
            var firmwareRealName = this.i18n("VmUi", "BIOSOptions." + firmware); // default
            var firmwareDisplayName = firmwareRealName;
            if (recommendedFirmware === firmware && !_.isEmpty(recommendedFirmware)) {
                firmwareDisplayName = firmwareRealName + " " + this.i18n("VmUi", "BIOSOptions.recommended");
                isRecommended = true;
            }
            return new FirmwareMenuItem(firmwareDisplayName, firmwareRealName, firmware, isRecommended);
        };
        BootOptionsBuilderService.prototype.limitBootDelay = function (value, originalModel) {
            return isNaN(value) ? originalModel.bootDelay :
                (value > BootOptionsConstants.BOOT_DELAY_MAX) ? BootOptionsConstants.BOOT_DELAY_MAX :
                    (value < BootOptionsConstants.BOOT_DELAY_MIN) ? BootOptionsConstants.BOOT_DELAY_MIN :
                        value;
        };
        BootOptionsBuilderService.prototype.limitBootRetryDelay = function (value, originalModel) {
            return isNaN(value) ? originalModel.bootRetryDelay / BootOptionsViewModel.MILLISECONDS :
                (value > BootOptionsConstants.RETRY_DELAY_MAX) ? BootOptionsConstants.RETRY_DELAY_MAX :
                    (value < BootOptionsConstants.RETRY_DELAY_MIN) ? BootOptionsConstants.RETRY_DELAY_MIN :
                        value;
        };
        BootOptionsBuilderService.$inject = [
            "i18nService", "templateHelperService"
        ];
        return BootOptionsBuilderService;
    }());
    h5_vm.BootOptionsBuilderService = BootOptionsBuilderService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmBootOptionsBuilderService", BootOptionsBuilderService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var BootOptions = (function () {
        function BootOptions() {
            this.bindings = {
                vm: '<',
                vmConfigContext: '<',
                vmWorkflowMode: '<',
                onBootoptionsUpdate: '&?',
                onFirmwareUpdate: '&?',
                vbsEnabled: '<',
                vbsProperties: '<',
                doesTpmExist: '&',
                expanded: '='
            };
            this.controller = BootOptionsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmOptions/bootOptions/bootOptions.html';
        }
        return BootOptions;
    }());
    h5_vm.BootOptions = BootOptions;
    var BootOptionsController = (function () {
        function BootOptionsController(i18nService, vmBootOptionsBuilderService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vmBootOptionsBuilderService = vmBootOptionsBuilderService;
            /**
             * build the passed on vmConfigContext to be used
             * by the view.
             */
            this.$onInit = function () {
                _this.viewModel = _this.vmBootOptionsBuilderService
                    .buildViewModel(_this.vmConfigContext, _this.vmWorkflowMode, _this.vbsEnabled, _this.vbsProperties);
                _this.originalCoreModel = _this.viewModel.cloneBootOptionsData();
                _this.originalFirmwareSelection = angular.copy(_this.viewModel.firmwareSelection);
                _this.viewModel.firmwareCompatibilityWarningFlag = _this.vmBootOptionsBuilderService
                    .shouldEnableFirmwareCompatibilityWarning(_this.viewModel);
            };
            /**
             * any view changes will trigger this, update the parent
             * with the updated viewModel immediately.
             */
            this.onPropertyChanged = function () {
                var updatedModel = _this.vmBootOptionsBuilderService
                    .processBootOptionsForUpdate(_this.viewModel, _this.originalCoreModel)
                    .cloneBootOptionsData();
                if (_this.onBootoptionsUpdate) {
                    _this.onBootoptionsUpdate({ updatedModel: updatedModel });
                }
            };
            this.getString = function (strKeyWithParam, strKeySubstitutable) {
                var strSubstitutable = _this.i18n('VmUi', 'BIOSOptions.' + strKeySubstitutable);
                return _this.i18n('VmUi', strKeyWithParam, strSubstitutable);
            };
            this.i18n = i18nService.getString;
            this.vmBootOptionsBuilderService.getFirmwareSignPostParams()
                .then(function (value) {
                _this.signFirmwarePostParams = value;
            });
            this.vmBootOptionsBuilderService.getSecureBootSignPostParams()
                .then(function (value) {
                _this.signSecureBootPostParams = value;
            });
        }
        BootOptionsController.prototype.isBootRetryDelayEditDisabled = function () {
            return this.vmBootOptionsBuilderService.isBootRetryDelayEditDisabled(this.viewModel);
        };
        BootOptionsController.prototype.onFirmwareSelectionChanged = function () {
            this.viewModel.firmwareWarningFlag = this.vmBootOptionsBuilderService
                .shouldEnableFirmwareWarning(this.viewModel, this.originalFirmwareSelection);
            this.viewModel.firmwareCompatibilityWarningFlag = this.vmBootOptionsBuilderService
                .shouldEnableFirmwareCompatibilityWarning(this.viewModel);
            if (!this.isSecureBootAllowed()) {
                this.viewModel.efiSecureBootEnabled = false;
                this.onPropertyChanged();
            }
            var newFirmware = this.viewModel.firmwareSelection.id;
            if (this.onFirmwareUpdate) {
                this.onFirmwareUpdate({ newFirmware: newFirmware });
            }
        };
        BootOptionsController.prototype.isFirmwareDisabled = function () {
            if (this.vm && this.vm.isFirmwareLocked()) {
                return true;
            }
            // TODO fortes - move logic below to vm.isFirmwareLocked
            return this.vbsEnabled || !this.viewModel.firmwareEnabled || this.doesTpmExist();
        };
        BootOptionsController.prototype.isVbsEnabled = function () {
            return this.vbsEnabled;
        };
        BootOptionsController.prototype.isSecureBootAllowed = function () {
            var selectedFirmware = this.viewModel.firmwareSelection;
            var firmware = selectedFirmware ? selectedFirmware.id : 'bios';
            var selectedOs = this.vmConfigContext.selectedGuestOs;
            return firmware === 'efi' && selectedOs && selectedOs.supportsSecureBoot;
        };
        BootOptionsController.prototype.showFirmwareCompatibilityWarning = function () {
            return this.viewModel.firmwareCompatibilityWarningFlag;
        };
        Object.defineProperty(BootOptionsController.prototype, "firmware", {
            get: function () {
                var retVal = this.vmConfigContext.config.firmware;
                return retVal;
            },
            set: function (value) {
                if (this.vmConfigContext) {
                    this.vmConfigContext.config.firmware = value;
                }
                if (this.vm) {
                    this.vm.afterFirmwareChanged();
                }
                if (this.viewModel) {
                    this.viewModel.selectFirmware(value);
                    this.onFirmwareSelectionChanged();
                }
            },
            enumerable: true,
            configurable: true
        });
        BootOptionsController.$inject = [
            'i18nService',
            'vmBootOptionsBuilderService'
        ];
        return BootOptionsController;
    }());
    h5_vm.BootOptionsController = BootOptionsController;
    angular
        .module('com.vmware.vsphere.client.vm')
        .component('bootOptions', new BootOptions());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var SpbmData = (function () {
        function SpbmData() {
        }
        return SpbmData;
    }());
    var EcnryptionOptionsController = (function () {
        function EcnryptionOptionsController($scope, $q, i18nService, storageProfileService, vmCryptUtilService, defaultUriSchemeUtil) {
            this.$scope = $scope;
            this.$q = $q;
            this.i18nService = i18nService;
            this.storageProfileService = storageProfileService;
            this.vmCryptUtilService = vmCryptUtilService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.ENCRYPTED_VMOTION_MODE_DISABLED = "disabled";
            this.ENCRYPTED_VMOTION_MODE_OPPORTUNISTIC = "opportunistic";
            this.ENCRYPTED_VMOTION_MODE_REQUIRED = "required";
            this.hasVmConfigSettingsPriviledge = false;
            this.hasStorageProfileViewPermission = false;
            this.hasCryptographerManageKeyServersPermission = false;
            this.isKmipStatusChecked = false;
            this.hostSupportsEncryption = false;
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
        }
        EcnryptionOptionsController.prototype.$onInit = function () {
            var _this = this;
            this.waitSpbmData().then(function () {
                _this.initEncryptionProfiles();
                _this.initialize();
            });
            this.$scope.$on('vmHomeStorageProfileChanged', function ($event, newProfile) {
                _this.vmStorageProfile = newProfile;
                _this.initEncryptionProfiles();
            });
        };
        EcnryptionOptionsController.prototype.initialize = function () {
            this.selectedEncryptionProfile = this.vmStorageProfile;
            this.encryptedVmotionModes = [this.ENCRYPTED_VMOTION_MODE_DISABLED,
                this.ENCRYPTED_VMOTION_MODE_OPPORTUNISTIC,
                this.ENCRYPTED_VMOTION_MODE_REQUIRED];
            this.migrateEncryption = this.ENCRYPTED_VMOTION_MODE_OPPORTUNISTIC;
            if (!!this.vmConfigContext.config && !!this.vmConfigContext.config.migrateEncryption) {
                this.migrateEncryption = this.vmConfigContext.config.migrateEncryption;
            }
            if (this.isVmHomeEncrypted() || this.doesTpmExist) {
                this.migrateEncryption = this.ENCRYPTED_VMOTION_MODE_REQUIRED;
            }
            this.onMigrateEncryptionChanged();
            this.hasVmConfigSettingsPriviledge =
                h5_vm.VmHardwareUtil.userHasVmSettingsPermission(this.vmConfigContext);
            this.hasStorageProfileViewPermission =
                h5_vm.VmHardwareUtil.userHasStorageProfileViewPermission(this.vmConfigContext);
            this.hasCryptographerManageKeyServersPermission =
                h5_vm.VmHardwareUtil.userHasCryptographerManageKeyServersPermission(this.vmConfigContext);
            this.hostSupportsEncryption = this.vmConfigContext.environment.hostCapability.cryptoSupported;
            this.canChangeVmHomePolicy = this.workflowMode === h5_vm.VmWorkflowMode.UpdateMode;
            if (this.expanded) {
                this.checkKmipStatusIfNeeded();
            }
        };
        EcnryptionOptionsController.prototype.expandedChanged = function (ev) {
            this.checkKmipStatusIfNeeded();
        };
        EcnryptionOptionsController.prototype.checkKmipStatusIfNeeded = function () {
            if (this.isKmipStatusChecked) {
                return;
            }
            this.isKmipStatusChecked = true;
            this.checkKmipStatus();
        };
        EcnryptionOptionsController.prototype.checkKmipStatus = function () {
            var _this = this;
            if (!this.hasCryptographerManageKeyServersPermission) {
                this.canEncryptHdds = true;
            }
            else {
                this.canEncryptHdds = false;
                if (this.hostSupportsEncryption) {
                    var serverGuid = this.workflowMode === h5_vm.VmWorkflowMode.UpdateMode
                        ? this.vmConfigContext.rtInfo.host.serverGuid
                        : this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(this.datacenterId).serverGuid;
                    this.vmCryptUtilService.getDefaultKmipServerStatus(serverGuid, true).then(function (response) {
                        // If already disabled, leave it this way
                        if (_this.canNotEncryptReason) {
                            return;
                        }
                        // When the user doesn't have permission to aggregate the KMS statuses,
                        // don't stop him because he will still be able to create encrypted VM
                        // if the KMS servers are OK.
                        if (response && response.h5DefaultKmipClusterStatus
                            && response.h5DefaultKmipClusterStatus.noPermission) {
                            _this.canEncryptHdds = true;
                            return;
                        }
                        var isConnectionNormal = response && response.h5DefaultKmipClusterStatus &&
                            response.h5DefaultKmipClusterStatus.connectionStatus === h5_vm.ConnectionStatus.CONNECTED;
                        var isCertificateExpired = response && response.h5DefaultKmipClusterStatus &&
                            response.h5DefaultKmipClusterStatus.certificateStatus === h5_vm.CertStatus.EXPIRED;
                        var isVmHomeEncrypted = _this.isVmHomeEncrypted();
                        _this.canEncryptHdds = isVmHomeEncrypted || (isConnectionNormal && !isCertificateExpired);
                        if (!isVmHomeEncrypted) {
                            if (!isConnectionNormal) {
                                _this.canNotEncryptReason =
                                    _this.i18nService.getString("VmUi", "VmCryptConfig.reason.noKms");
                            }
                            else if (isCertificateExpired) {
                                _this.canNotEncryptReason =
                                    _this.i18nService.getString("VmUi", "VmCryptConfig.reason.kmsCertificateRequiresUpdate");
                            }
                        }
                    }, function () {
                        // if the KMS status can not be retrieved allow the user to continue
                        _this.canEncryptHdds = true;
                    });
                }
            }
        };
        EcnryptionOptionsController.prototype.$onChanges = function (changes) {
            if (changes.vmStorageProfile) {
            }
            if (changes.doesTpmExist) {
                // When Trust Platform Module is present, the encrypted VMotion
                // is set to `Required` and should not be passed as part of the config spec.
                if (this.doesTpmExist) {
                    this.migrateEncryption = this.ENCRYPTED_VMOTION_MODE_REQUIRED;
                }
                this.onMigrateEncryptionChanged();
            }
            if (changes.hardDisks) {
                this.refreshHddEncryptionStatuses();
            }
        };
        EcnryptionOptionsController.prototype.initEncryptionProfiles = function () {
            var _this = this;
            if (!this.storageProfiles || !this.vmStorageProfile) {
                return;
            }
            {
                this.encryptionProfiles = _.filter(this.storageProfiles, function (profile) {
                    return _this.storageProfileService
                        .isEncryptionStorageProfile(profile);
                });
                if (_.isEmpty(this.encryptionProfiles)) {
                    this.canEncryptHdds = false;
                    this.canNotEncryptReason =
                        this.i18nService.getString("VmUi", "VmCryptConfig.reason.noEncryptionPolicies");
                }
                var noEncryptionProfile = void 0;
                if (this.storageProfileService
                    .isEncryptionStorageProfile(this.vmStorageProfile)) {
                    // VM home is encrypted
                    noEncryptionProfile = this.storageProfileService.getDefaultProfile();
                    this.selectedEncryptionProfile = this.vmStorageProfile;
                    this.migrateEncryption = this.ENCRYPTED_VMOTION_MODE_REQUIRED;
                    this.onMigrateEncryptionChanged();
                }
                else {
                    // VM home is not encrypted
                    noEncryptionProfile = angular.copy(this.vmStorageProfile);
                    this.selectedEncryptionProfile = noEncryptionProfile;
                }
                noEncryptionProfile.label =
                    this.i18nService.getString("VmUi", "VmCryptConfig.encryptVM.profileNone");
                this.encryptionProfiles.splice(0, 0, noEncryptionProfile);
            }
        };
        EcnryptionOptionsController.prototype.onStorageProfileChanged = function (storageProfile) {
            var _this = this;
            var previousEncryptionProfile = this.selectedEncryptionProfile;
            this.selectedEncryptionProfile = storageProfile;
            // Change the profile for the VM
            this.vmConfigContext.vmProfile =
                [this.storageProfileService.makeProfile(storageProfile.id)];
            if (this.isVmHomeEncrypted()) {
                this.migrateEncryption = this.ENCRYPTED_VMOTION_MODE_REQUIRED;
                this.onMigrateEncryptionChanged();
                // Set the encryption policy to all disks that are:
                // - not encrypted
                // - encrypted and storage policy is not set manually
                _.each(this.hardDisks, function (disk) {
                    var isDiskEncrypted = disk.isDiskEncrypted();
                    var canChangeDiskProfile = !disk.isStorageProfileManuallySet()
                        && disk.getProfile()
                        && disk.getProfile().profileId === previousEncryptionProfile.id;
                    if (!isDiskEncrypted || canChangeDiskProfile) {
                        disk.updateDiskProfile(_this.selectedEncryptionProfile);
                    }
                });
                // Hide any warnings
                this.onAlert({
                    options: {
                        isVisible: false
                    }
                });
            }
            else {
                this.vmConfigContext.config.keyId = null;
                // Decrypt all disks that are:
                // - not created from existing disks
                // - encrypted
                _.each(this.hardDisks, function (disk) {
                    if (!disk.isCreatedFromExistingDisk()
                        && disk.isDiskEncrypted()) {
                        disk.updateDiskProfile(_this.storageProfileService.getDefaultProfile());
                    }
                });
                // Show warning that VM home and all disks will be unencrypted
                this.onAlert({
                    options: {
                        isVisible: true,
                        class: "alert-warning",
                        iconShape: "exclamation-triangle",
                        text: this.i18nService.getString("VmUi", "VmCryptConfig.alert.vmHomeNotEncypted")
                    }
                });
            }
            this.refreshHddEncryptionStatuses();
        };
        EcnryptionOptionsController.prototype.toggleEncryptHardDisk = function (disk) {
            if (disk.isCreatedFromExistingDisk()) {
                return;
            }
            var nonEncryptionProfileLabel = this.storageProfileService.getDefaultProfile().label;
            if (disk.isDiskEncrypted()) {
                // Decrypt
                disk.updateDiskProfile(this.storageProfileService.getDefaultProfile());
                disk.getCurrentDevice().backing.keyId = null;
            }
            else {
                // Encrypt
                disk.updateDiskProfile(this.selectedEncryptionProfile);
            }
            this.refreshHddEncryptionStatuses();
            if (this.hasUnencryptedDisks()) {
                this.onAlert({
                    options: {
                        isVisible: true,
                        class: "alert-warning",
                        iconShape: "exclamation-triangle",
                        text: this.i18nService.getString("VmUi", "VmCryptConfig.alert.someDisksAreNotEncypted", nonEncryptionProfileLabel)
                    }
                });
            }
            else {
                this.onAlert({
                    options: {
                        isVisible: true,
                        class: "alert-success",
                        iconShape: "check-circle",
                        text: this.i18n("VmCryptConfig.alert.allDisksAreEncypted")
                    }
                });
            }
        };
        EcnryptionOptionsController.prototype.onMigrateEncryptionChanged = function () {
            // When VM home is encrypted, or Trust Platform Module is present,
            // the encrypted VMotion should not be passed as part of the re-config spec.
            if (this.isVmHomeEncrypted() || this.doesTpmExist) {
                delete this.vmConfigContext.config.migrateEncryption;
                return;
            }
            if (this.migrateEncryption) {
                this.vmConfigContext.config.migrateEncryption = this.migrateEncryption;
            }
        };
        EcnryptionOptionsController.prototype.isVmotionReadOnly = function () {
            if (this.doesTpmExist) {
                return true;
            }
            if (this.workflowMode === h5_vm.VmWorkflowMode.UpdateMode
                && !this.hasVmConfigSettingsPriviledge) {
                return true;
            }
            return this.isVmHomeEncrypted();
        };
        EcnryptionOptionsController.prototype.isVmHomeEncrypted = function () {
            return this.storageProfileService
                .isEncryptionStorageProfile(this.selectedEncryptionProfile);
        };
        EcnryptionOptionsController.prototype.isVmPoweredOn = function () {
            return this.vmConfigContext.rtInfo &&
                this.vmConfigContext.rtInfo.powerState === "poweredOn";
        };
        EcnryptionOptionsController.prototype.displayEncryptVmBlock = function () {
            return this.hostSupportsEncryption &&
                this.hasStorageProfileViewPermission &&
                this.workflowMode !== h5_vm.VmWorkflowMode.CloneMode;
        };
        EcnryptionOptionsController.prototype.displayEncryptVmDisksBlock = function () {
            return this.displayEncryptVmBlock() &&
                this.isVmHomeEncrypted() &&
                !_.isEmpty(this.hardDisks);
        };
        EcnryptionOptionsController.prototype.buildSignPostContentVmotion = function () {
            var _this = this;
            var titlesAndTips = [{
                    title: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.vtpm.Text"),
                    tip: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.vtpm.Tip")
                }, {
                    title: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.disabled.Text"),
                    tip: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.disabled.Tip")
                }, {
                    title: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.opportunistic.Text"),
                    tip: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.opportunistic.Tip")
                }, {
                    title: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.required.Text"),
                    tip: this.i18nService.getString("VmUi", "VmCryptConfig.vMotion.required.Tip")
                }];
            var elements = [];
            _.each(titlesAndTips, function (titleAndTip, index) {
                if (index !== 0 || _this.doesTpmExist) {
                    elements.push("<li>\n                  <div class=\"title\">" + titleAndTip.title + "</div>\n                  <div class=\"tip\">" + titleAndTip.tip + "</div>\n               </li>");
                }
            });
            return "<ul>" + elements.join(" ") + "</ul>";
        };
        EcnryptionOptionsController.prototype.refreshHddEncryptionStatuses = function () {
            this.hardDiskEncryptionStatuses = _.map(this.hardDisks, function (disk) {
                disk.diskEncryptionStatus = undefined;
                return disk.isDiskEncrypted();
            });
        };
        EcnryptionOptionsController.prototype.hasUnencryptedDisks = function () {
            return _.contains(this.hardDiskEncryptionStatuses, false);
        };
        EcnryptionOptionsController.prototype.waitSpbmData = function () {
            var _this = this;
            var done = this.$q.when();
            if (this.workflowMode !== h5_vm.VmWorkflowMode.UpdateMode) {
                // no waiting for new and clone, only for edit
                return done;
            }
            var spbm = {
                assignments: this.vmStorageProfileAssignments,
                profiles: this.storageProfiles
            };
            return this.$q.all(spbm).then(function (data) {
                var spbm = data;
                _this.applySpbmData(spbm);
                return done;
            });
        };
        EcnryptionOptionsController.prototype.applySpbmData = function (spbm) {
            this.vmStorageProfileAssignments = spbm.assignments.vmStorageProfileAssignments;
            this.storageProfiles = spbm.profiles;
            this.initVmHomeProfile();
        };
        EcnryptionOptionsController.prototype.initVmHomeProfile = function () {
            if (!this.vmStorageProfileAssignments) {
                this.vmStorageProfile = null;
                return;
            }
            this.vmStorageProfile = this.storageProfileService.getDefaultProfile();
            var homeProfile = this.vmStorageProfileAssignments.homeStorageProfile;
            if (!homeProfile || !homeProfile.profileId) {
                // keep default profile
                return;
            }
            var uniqueId = homeProfile.profileId.uniqueId;
            var profile = _.find(this.storageProfiles, function (item) {
                return (item.id === uniqueId);
            });
            if (!profile) {
                // keep default profile
                return;
            }
            this.vmStorageProfile = profile;
        };
        EcnryptionOptionsController.$inject = [
            "$scope",
            '$q',
            "i18nService",
            "storageProfileService",
            "vmCryptUtilService",
            "defaultUriSchemeUtil",
        ];
        return EcnryptionOptionsController;
    }());
    var EncryptionOptions = (function () {
        function EncryptionOptions() {
            this.bindings = {
                workflowMode: "<",
                vmStorageProfileAssignments: "<",
                storageProfiles: "<",
                vmStorageProfile: "<",
                hardDisks: "<",
                vmConfigContext: "<",
                datacenterId: "<",
                onAlert: "&",
                doesTpmExist: "<",
                expanded: "="
            };
            this.controller = EcnryptionOptionsController;
            this.templateUrl = "vm-ui/resources/vm/views/settings/vmOptions/encryption/encryption-options.html";
        }
        return EncryptionOptions;
    }());
    angular.module("com.vmware.vsphere.client.vm")
        .component("encryptionOptions", new EncryptionOptions());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var SelectOption = (function () {
        function SelectOption() {
        }
        return SelectOption;
    }()); // option for html select
    var VmGeneralOptionsController = (function () {
        function VmGeneralOptionsController(i18nService, service) {
            this.i18nService = i18nService;
            this.service = service;
            this.ARIA_LBL_NAME = this.i18n2('vm_name_body');
            this.ARIA_LBL_GOS_FML = this.i18n2('gos_family');
            this.ARIA_LBL_GOS_VER = this.i18n2('gos_version');
            this.guestOsListRequested = false;
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = "VmUi"; }
                return i18nService.getString(bundle, key);
            };
        }
        VmGeneralOptionsController.prototype.i18n2 = function (key, section) {
            if (section === void 0) { section = 'GeneralOptions'; }
            return this.i18nService.getString("VmUi", section + '.' + key);
        };
        VmGeneralOptionsController.prototype.$onInit = function () {
            if (this.modalOptions) {
                this.setupForEditMode();
            }
            else {
                this.setupForCloneAndCreate();
            }
        };
        VmGeneralOptionsController.prototype.setupForEditMode = function () {
            this.editMode = true;
            this.vmName = this.config.name;
            this.vmConfigFile = this.config.files.vmPathName;
            this.vmWorkingLocation = this.config.files.snapshotDirectory;
        };
        VmGeneralOptionsController.prototype.expandedChanged = function (ev) {
            if (!this.editMode) {
                return;
            }
            this.requestGuestOsListIfNeeded();
        };
        VmGeneralOptionsController.prototype.requestGuestOsListIfNeeded = function () {
            if (!this.editMode) {
                return;
            }
            if (this.guestOsListRequested) {
                return;
            }
            this.guestOsListRequested = true;
            this.service.getAllGosVersionsPromise(this.vmId).then(this.onGuestOsList.bind(this));
        };
        VmGeneralOptionsController.prototype.onGuestOsList = function (result) {
            this.guestOsList = result ? result.guestOsList : [];
            this.initGuestOptions();
        };
        VmGeneralOptionsController.prototype.initGuestOptions = function () {
            var guestId = this.config.guestId;
            var guest = this.service.findDescriptor(guestId, this.guestOsList);
            var familyId = guest ? guest.family : "otherGuestFamily";
            familyId = this.service.simplifyFamily(familyId);
            this.gosFamily = this.service.familyObject(familyId);
            this.gosFamilyOptions = this.service.getGosFamilyOptions();
            var guestName = this.config.guestFullName;
            this.gosVersion = { id: guestId, name: guestName };
            var array = this.service.getFamilyVersions(familyId, this.guestOsList);
            this.gosVersionOptions = this.service.getVersionsOptions(array);
        };
        VmGeneralOptionsController.prototype.setupForCloneAndCreate = function () {
            this.vmName = this.vmParams.getName();
            this.gosFamily = {
                name: this.vmParams.getGosFamily().name, id: ""
            };
            this.gosFamilyOptions = [this.gosFamily];
            this.gosVersion = {
                name: this.vmParams.getGosVersion().name, id: ""
            };
            this.gosVersionOptions = [this.gosVersion];
            this.editMode = false;
        };
        VmGeneralOptionsController.prototype.isEditNameDisabled = function () {
            return this.service.isEditNameDisabled(this.vmConfigContext.privileges, this.editMode);
        };
        VmGeneralOptionsController.prototype.isEditGOSDisabled = function () {
            return !this.editMode
                || this.service.isEditGOSDisabled(this.vmConfigContext);
        };
        VmGeneralOptionsController.prototype.familyChanged = function () {
            // ng-change comes here
            if (!this.editMode || !this.guestOsList) {
                return;
            }
            this.changeFamily(this.gosFamily.id);
        };
        VmGeneralOptionsController.prototype.changeFamily = function (familyId) {
            if (!this.editMode || !this.guestOsList) {
                return;
            }
            var array = this.service.getFamilyVersions(familyId, this.guestOsList);
            if (!array || array.length === 0) {
                return;
            }
            var guestOs = array[0];
            this.gosVersion = { name: guestOs.fullName, id: guestOs.id };
            this.gosVersionOptions = this.service.getVersionsOptions(array);
            this.updateConfigInfo(guestOs);
        };
        VmGeneralOptionsController.prototype.versionChanged = function () {
            if (!this.editMode) {
                return;
            }
            if (!this.guestOsList || !this.gosVersion) {
                return;
            }
            var guestId = this.gosVersion.id;
            var guest = this.service.findDescriptor(guestId, this.guestOsList);
            if (guest) {
                this.updateConfigInfo(guest);
            }
        };
        VmGeneralOptionsController.prototype.updateConfigInfo = function (gos) {
            if (!this.editMode) {
                return;
            }
            this.config.guestFullName = gos.fullName;
            this.config.guestId = gos.id;
        };
        VmGeneralOptionsController.$inject = [
            'i18nService',
            'vmGeneralOptionsService'
        ];
        return VmGeneralOptionsController;
    }());
    var VmGeneralOptions = (function () {
        function VmGeneralOptions() {
            this.bindings = {
                config: '<?',
                vmId: '<',
                vmParams: '<?',
                vmConfigContext: '<',
                modalOptions: '<?',
                expanded: '='
            };
            this.controller = VmGeneralOptionsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmOptions/generalOptions/general-options.html';
        }
        return VmGeneralOptions;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .component('generalOptions', new VmGeneralOptions());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmHardwareUtil = h5_vm.VmHardwareUtil;
    var SelectOption = (function () {
        function SelectOption() {
        }
        return SelectOption;
    }());
    ; // option for html select
    var VmGeneralOptionsService = (function () {
        function VmGeneralOptionsService(i18nService, vmHardwareUtil, gosFamilyConstants, dataService) {
            this.i18nService = i18nService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.gosFamilyConstants = gosFamilyConstants;
            this.dataService = dataService;
            this.i18n = i18nService.getString;
        }
        VmGeneralOptionsService.prototype.hasPrivilegesToRename = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_RENAME]);
        };
        VmGeneralOptionsService.prototype.hasPrivilegesToEditGos = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_SETTINGS]);
        };
        VmGeneralOptionsService.prototype.familyObject = function (id) {
            return {
                id: id,
                name: this.i18n('VmUi', 'GeneralOptions.gos_family.' + id)
            };
        };
        VmGeneralOptionsService.prototype.isEditNameDisabled = function (privileges, editMode) {
            return editMode ? !this.hasPrivilegesToRename(privileges) : false;
        };
        VmGeneralOptionsService.prototype.isEditGOSDisabled = function (vmConfigContext) {
            if (VmHardwareUtil.isPoweredOff(vmConfigContext)) {
                return !this.hasPrivilegesToEditGos(vmConfigContext.privileges);
            }
            else {
                return true;
            }
        };
        VmGeneralOptionsService.prototype.getGosFamilyOptions = function () {
            return [
                this.familyObject(this.gosFamilyConstants.WINDOWS),
                this.familyObject(this.gosFamilyConstants.LINUX),
                this.familyObject(this.gosFamilyConstants.OTHER)
            ];
        };
        VmGeneralOptionsService.prototype.getFamilyVersions = function (family, array) {
            if (!array) {
                return [];
            }
            var retVal = [];
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                var osFamily = this.simplifyFamily(item.family);
                family = this.simplifyFamily(family);
                if (osFamily === family) {
                    retVal.push(item);
                }
            }
            return retVal;
        };
        VmGeneralOptionsService.prototype.simplifyFamily = function (osFamily) {
            if (osFamily !== "windowsGuest" && osFamily !== "linuxGuest") {
                osFamily = "otherGuestFamily";
            }
            return osFamily;
        };
        VmGeneralOptionsService.prototype.getVersionsOptions = function (array) {
            var retVal = [];
            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
                var item = array_2[_i];
                var pair = { name: item.fullName, id: item.id };
                retVal.push(pair);
            }
            return retVal;
        };
        VmGeneralOptionsService.prototype.findDescriptor = function (guestId, array) {
            if (!array || !guestId) {
                return null;
            }
            ;
            for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
                var item = array_3[_i];
                if (guestId === item.id) {
                    return item;
                }
            }
            return null;
        };
        VmGeneralOptionsService.prototype.getAllGosVersionsPromise = function (vmId) {
            return this.dataService.getProperties(vmId, ["guestOsList"]);
        };
        VmGeneralOptionsService.$inject = [
            "i18nService",
            "vmHardwareUtil",
            "gosFamilyConstants",
            "dataService"
        ];
        return VmGeneralOptionsService;
    }());
    h5_vm.VmGeneralOptionsService = VmGeneralOptionsService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmGeneralOptionsService", VmGeneralOptionsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var LegacyVappOptionsView = (function () {
        function LegacyVappOptionsView(vcH5ConstantsService) {
            this.vcH5ConstantsService = vcH5ConstantsService;
            this.version = -1;
            this.watchObjects = [];
            this.liveProperties = ["config.vAppConfig", "disabledMethod", "runtime.powerState"];
            this.refreshEventTypes = [];
            this.refreshEventTypes.push(vcH5ConstantsService.DATA_REFRESH_INVOCATION_EVENT);
            this.refreshEventTypes.push(vcH5ConstantsService.OBJECT_DETAILS_CHANGED_EVENT);
            this.refreshEventTypes.push(vcH5ConstantsService.MODEL_CHANGED_EVENT);
        }
        LegacyVappOptionsView.prototype.$onInit = function () {
            this.watchObjects = [this.vmId];
        };
        LegacyVappOptionsView.prototype.onRefresh = function () {
            this.version++;
        };
        LegacyVappOptionsView.$inject = ["vcH5ConstantsService"];
        return LegacyVappOptionsView;
    }());
    angular.module("com.vmware.vsphere.client.vm").component("legacyVappOptionsView", {
        bindings: {
            vmId: "<"
        },
        controller: LegacyVappOptionsView,
        template: "\n          <div vx-refreshable \n            watch-objects=\"{{$ctrl.watchObjects}}\"\n            refresh=\"$ctrl.onRefresh()\"\n            live-refresh-properties=\"$ctrl.liveProperties\"\n            refresh-event-types=\"{{$ctrl.refreshEventTypes}}\"> \n             <vm-edit-vapp-options-component [vm-id]=\"$ctrl.vmId\" [version]=\"$ctrl.version\">\n            </vm-edit-vapp-options-component>\n         </div>"
    });
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var StandbyOptionsController = (function () {
        function StandbyOptionsController(i18nService, vmStandbyOptionsService, vmDeviceInfoService) {
            var _this = this;
            this.i18nService = i18nService;
            this.vmStandbyOptionsService = vmStandbyOptionsService;
            this.vmDeviceInfoService = vmDeviceInfoService;
            this.onStandbyOptionsChange = function () {
                _this.onChange({
                    standbyAction: _this.standbyValue
                });
                _this.setWakeOnLanValues({});
            };
            this.onWakeOnLanChange = function (device) {
                // since the wakeOnLan values are in a separate object, we need to
                // actually modify the real device's values when applicable
                if (_this.standbyValue !== 'powerOnSuspend') {
                    device.wakeOnLanEnabled = !device.wakeOnLanEnabled;
                }
            };
            this.isWakeOnLanVisible = function () {
                var guestOsSupported = false;
                var capabilitiesSupported = false;
                if (!_.isEmpty(_this.vmConfigContext)) {
                    guestOsSupported = _this.vmConfigContext.selectedGuestOs &&
                        _this.vmConfigContext.selectedGuestOs.supportsWakeOnLan;
                    capabilitiesSupported = _this.vmConfigContext.environment &&
                        _this.vmConfigContext.environment.configOption &&
                        _this.vmConfigContext.environment.configOption.capabilities &&
                        _this.vmConfigContext.environment.configOption.capabilities.s1AcpiManagementSupported;
                }
                return guestOsSupported && capabilitiesSupported;
            };
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = 'VmUi'; }
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                return i18nService.getString.apply(i18nService, [bundle, key].concat(args));
            };
            this.vmStandbyOptionsService = vmStandbyOptionsService;
            this.vmDeviceInfoService = vmDeviceInfoService;
        }
        StandbyOptionsController.prototype.$onInit = function () {
            this.standbyValue = this.options ? (this.options.standbyAction || 'checkpoint') : 'checkpoint';
            this.standbyOptions = [
                {
                    id: 'suspend',
                    label: this.i18n('VmStandbyPage.Suspend'),
                    value: 'powerOnSuspend'
                },
                {
                    id: 'leaveOn',
                    label: this.i18n('VmStandbyPage.LeaveOn'),
                    value: 'checkpoint'
                }
            ];
            this.setExpandedDevices();
            this.setOriginalWakeOnLanValues();
            if (this.vmWorkflowMode === h5_vm.VmWorkflowMode.CreateMode) {
                this.setWakeOnLanValues({
                    forceTrue: true
                }); // set all the values to true
            }
            else {
                this.setWakeOnLanValues({});
            }
        };
        StandbyOptionsController.prototype.getErrorString = function (device) {
            var osName = this.vmConfigContext.selectedGuestOs ? this.vmConfigContext.selectedGuestOs.fullName : '';
            var type = this.vmDeviceInfoService.getEthernetCardLabel(device._type);
            return this.i18n('VmStandbyPage.WakeUnsupported', 'VmUi', osName, type);
        };
        StandbyOptionsController.prototype.setExpandedDevices = function () {
            this.expandedDevices = {};
            for (var i = 0; i < this.networkDevices.length; i++) {
                var device = this.networkDevices[i];
                var currentDevice = device.getCurrentDevice();
                // need to tie the device to a key otherwise ng-repeat will
                // add a $$hashKey attribute to the devices which messes with
                // our internal diffing function on unit tests
                this.expandedDevices[currentDevice.key] = currentDevice;
            }
        };
        // save the state of the original devices so that we can determine if
        // wakeOnLanEnabled was originally true or false
        StandbyOptionsController.prototype.setOriginalWakeOnLanValues = function () {
            var _this = this;
            this.originalWakeOnLanValues = {};
            angular.forEach(this.expandedDevices, (function (device) {
                // if we are in the create workflow, values are defaulted to true
                _this.originalWakeOnLanValues[device.key] =
                    _this.vmWorkflowMode === h5_vm.VmWorkflowMode.CreateMode ? true : device.wakeOnLanEnabled;
            }));
        };
        // update the wakeOnLan values when the standby mode changes
        StandbyOptionsController.prototype.setWakeOnLanValues = function (options) {
            var _this = this;
            this.wakeOnLanValues = {};
            angular.forEach(this.expandedDevices, (function (device) {
                // if standbyValue is 'powerOnSuspend', then all wakeOnLan is automatically disabled
                if (options.forceTrue) {
                    _this.wakeOnLanValues[device.key] = true;
                }
                else {
                    _this.wakeOnLanValues[device.key] = _this.standbyValue === 'powerOnSuspend' ? false : device.wakeOnLanEnabled;
                }
            }));
        };
        StandbyOptionsController.prototype.getDeviceLabel = function (device) {
            var suffix = '';
            var backing = device.backing;
            if (backing && backing._type === 'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$NetworkBackingInfo') {
                var deviceName = backing.deviceName;
                suffix = deviceName ? ' (' + deviceName + ')' : ''; // deviceName can be empty apparently
            }
            else if (backing && backing._type === 'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$DistributedVirtualPortBackingInfo') {
                var info = this.findPortgroupInfo(backing);
                suffix = info ? ' (' + info.portgroupName + ')' : '';
            }
            else if (backing && backing._type === 'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$OpaqueNetworkBackingInfo') {
                var network = this.findOpaqueInfo(backing);
                suffix = network ? ' (' + network.name + ')' : '';
            }
            return device.deviceInfo.label + suffix;
        };
        StandbyOptionsController.prototype.findPortgroupInfo = function (portGroup) {
            return this.vmStandbyOptionsService.findPortgroupInfo(portGroup, this.vmConfigContext);
        };
        StandbyOptionsController.prototype.findOpaqueInfo = function (backing) {
            return this.vmStandbyOptionsService.findOpaqueInfo(backing, this.vmConfigContext);
        };
        StandbyOptionsController.prototype.isTypeSupported = function (device) {
            return this.vmStandbyOptionsService.isTypeSupported(device, this.vmConfigContext);
        };
        StandbyOptionsController.prototype.isEditSettingsDisabled = function () {
            return this.vmStandbyOptionsService.isEditSettingsDisabled(this.vmConfigContext.privileges, this.vmWorkflowMode);
        };
        StandbyOptionsController.prototype.isEditWakeOnLanDisabled = function (device) {
            return this.vmStandbyOptionsService.isEditWakeOnLanDisabled(device, {
                vmConfigContext: this.vmConfigContext,
                originalWakeOnLanValues: this.originalWakeOnLanValues,
                standbyValue: this.standbyValue,
                vmWorkflowMode: this.vmWorkflowMode
            });
        };
        StandbyOptionsController.$inject = [
            'i18nService',
            'vmStandbyOptionsService',
            'vmDeviceInfoService'
        ];
        return StandbyOptionsController;
    }());
    var StandbyOptions = (function () {
        function StandbyOptions() {
            this.bindings = {
                vmWorkflowMode: '<',
                onChange: '&',
                networkDevices: '<',
                vmConfigContext: '<',
                options: '<',
                expanded: '='
            };
            this.controller = StandbyOptionsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmOptions/standbyOptions/standby-options.html';
        }
        return StandbyOptions;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .component('standbyOptions', new StandbyOptions());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VmStandbyOptionsService = (function () {
        function VmStandbyOptionsService(vmHardwareUtil) {
            this.vmHardwareUtil = vmHardwareUtil;
        }
        VmStandbyOptionsService.prototype.hasPrivilegesToEditSettings = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_SETTINGS]);
        };
        VmStandbyOptionsService.prototype.isEditSettingsDisabled = function (privileges, mode) {
            if (mode === VmWorkflowMode.UpdateMode) {
                return !this.hasPrivilegesToEditSettings(privileges);
            }
            if (mode === VmWorkflowMode.CloneMode) {
                return !this.hasPrivilegesToEditSettings(privileges);
            }
            return false;
        };
        VmStandbyOptionsService.prototype.hasPrivilegesToEditDevices = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_EDITDEVICE_PRIVILEGE]);
        };
        VmStandbyOptionsService.prototype.isEditDevicesDisabled = function (privileges, mode) {
            if (mode !== VmWorkflowMode.CreateMode) {
                return !this.hasPrivilegesToEditDevices(privileges);
            }
            return false;
        };
        VmStandbyOptionsService.prototype.isEditWakeOnLanDisabled = function (device, ctx) {
            if (device && !this.isTypeSupported(device, ctx.vmConfigContext) && !ctx.originalWakeOnLanValues[device.key]) {
                // if the device is already disabled and the type is not supported,
                // then don't let the user try to enable the device
                return true;
            }
            if (ctx.standbyValue === 'powerOnSuspend') {
                // if standbyValue is set to suspend, devices are disabled
                return true;
            }
            return this.isEditDevicesDisabled(ctx.vmConfigContext.privileges, ctx.vmWorkflowMode);
        };
        VmStandbyOptionsService.prototype.isTypeSupported = function (device, vmConfigContext) {
            var guestOs = vmConfigContext.selectedGuestOs;
            if (!guestOs) {
                return true;
            }
            var guestOsCards = guestOs.wakeOnLanEthernetCard;
            if (!guestOsCards || !guestOsCards.length) {
                return false;
            }
            var deviceType = device._type;
            for (var i = 0; i < guestOsCards.length; i++) {
                var cardTypeClass = guestOsCards[i].typeClass;
                if (cardTypeClass === deviceType) {
                    return true;
                }
            }
            return false;
        };
        VmStandbyOptionsService.prototype.findPortgroupInfo = function (portGroup, vmConfigContext) {
            var retVal = {};
            var switchUuid = portGroup.port.switchUuid;
            var portgroupKey = portGroup.port.portgroupKey;
            var portgroups = vmConfigContext.environment.configTarget.distributedVirtualPortgroup;
            for (var i = 0; i < portgroups.length; i++) {
                var group = portgroups[i];
                if (switchUuid === group.switchUuid && portgroupKey === group.portgroupKey) {
                    retVal = group;
                }
            }
            return retVal;
        };
        VmStandbyOptionsService.prototype.findOpaqueInfo = function (backing, vmConfigContext) {
            var retVal = {};
            var networkUuid = backing.opaqueNetworkId;
            var networkType = backing.opaqueNetworkType;
            var opaqueNetworks = vmConfigContext.environment.configTarget.opaqueNetwork;
            for (var i = 0; i < opaqueNetworks.length; i++) {
                var network = opaqueNetworks[i];
                if (networkUuid === network.network.opaqueNetworkId && networkType === network.network.opaqueNetworkType) {
                    retVal = network;
                }
            }
            return retVal;
        };
        VmStandbyOptionsService.$inject = [
            "vmHardwareUtil"
        ];
        return VmStandbyOptionsService;
    }());
    h5_vm.VmStandbyOptionsService = VmStandbyOptionsService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmStandbyOptionsService", VmStandbyOptionsService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var VBS = (function () {
        function VBS() {
            this.bindings = {
                configFlags: '<',
                guestOsDescriptor: '<',
                onVbsUpdate: '&',
                visible: '<',
                vmPoweredOn: '<'
            };
            this.controller = VbsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmOptions/vbs/vbs.html';
        }
        return VBS;
    }());
    h5_vm.VBS = VBS;
    var VbsController = (function () {
        function VbsController(i18nService, featureFlagsService) {
            var _this = this;
            this.i18nService = i18nService;
            this.featureFlagsService = featureFlagsService;
            /**
             * any view changes will trigger this, update the parent
             * with the updated viewModel immediately.
             */
            this.onPropertyChanged = function () {
                _this.onVbsUpdate({ vbsEnabled: _this.configFlags.vbsEnabled });
                if (_this.configFlags.vbsEnabled) {
                    _this.vbsWillTurnOn = true;
                    _this.vbsWillTurnOff = false;
                }
                else {
                    _this.vbsWillTurnOn = false;
                    _this.vbsWillTurnOff = true;
                }
            };
            /**
             * build the passed on vmConfigContext to be used
             * by the view.
             */
            this.$onInit = function () {
                if (!_this.featureFlagsService.hardwareV14_vbsEnabled ||
                    !_this.featureFlagsService.hardwareV14_vbsEnabled() ||
                    !_this.guestOsDescriptor.vbsSupported ||
                    !_this.guestOsDescriptor.vbsSupported.supported) {
                    _this.visible = false;
                }
            };
            this.isDisabled = function () {
                return _this.vmPoweredOn;
            };
            this.i18n = i18nService.getString;
        }
        VbsController.$inject = [
            'i18nService', 'featureFlagsService'
        ];
        return VbsController;
    }());
    h5_vm.VbsController = VbsController;
    angular
        .module('com.vmware.vsphere.client.vm')
        .component('vbs', new VBS());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var Privileges = h5_vm.Privileges;
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VmHardwareUtil = h5_vm.VmHardwareUtil;
    var VmAdvancedOptionsService = (function () {
        function VmAdvancedOptionsService(i18nService, vmHardwareUtil) {
            this.i18nService = i18nService;
            this.vmHardwareUtil = vmHardwareUtil;
            this.isEditingLsLevelVisible = function (vmConfigContext) {
                var host = vmConfigContext.environment.hostCapability;
                if (host) {
                    return !!host.latencySensitivitySupported;
                }
                else {
                    return false;
                }
            };
            this.i18n = i18nService.getString;
        }
        VmAdvancedOptionsService.prototype.hasPrivilegesToEditSwapFileLocation = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_SWAPFILEPLACEMENT]);
        };
        VmAdvancedOptionsService.prototype.hasCapabilitiesToEditSwapFileLocation = function (capabilities) {
            return capabilities.swapPlacementSupported;
        };
        VmAdvancedOptionsService.prototype.isEditSwapFileLocationDisabled = function (privileges, capabilities) {
            return !this.hasPrivilegesToEditSwapFileLocation(privileges) || !this.hasCapabilitiesToEditSwapFileLocation(capabilities);
        };
        VmAdvancedOptionsService.prototype.hasPrivilegesToDisableAcceleration = function (privileges) {
            return this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_SETTINGS]);
        };
        VmAdvancedOptionsService.prototype.isDisableAccelerationDisabled = function (privileges, workflow) {
            if (workflow === VmWorkflowMode.CreateMode) {
                return false; // in create enabled
            }
            return !this.hasPrivilegesToDisableAcceleration(privileges);
        };
        VmAdvancedOptionsService.prototype.isEnableLoggingDisabled = function (privileges, workflow) {
            if (workflow === VmWorkflowMode.CreateMode) {
                return false; // in create enabled
            }
            return !this.vmHardwareUtil.checkPrivileges(privileges, [Privileges.VM_CONFIG_SETTINGS]);
        };
        VmAdvancedOptionsService.prototype.isEditMonitorTypeDisabled = function (vmConfigContext, workflow) {
            var ctx = vmConfigContext;
            if (VmWorkflowMode.CreateMode === workflow) {
                return false; // edit Enabled
            }
            if (h5_vm.VmHardwareUtil.noVmSettingsPermission(ctx)) {
                return true; // edit Disabled;
            }
            if (VmWorkflowMode.CloneMode === workflow) {
                return false; // edit Enabled
            }
            var capabilities = VmHardwareUtil.getVmCapabilities(ctx);
            var poweredOnChangeSupported = capabilities.poweredOnMonitorTypeChangeSupported;
            var isVmPoweredOff = VmHardwareUtil.isPoweredOff(ctx);
            if (!isVmPoweredOff && (poweredOnChangeSupported !== true)) {
                return true; // edit Disabled
            }
            if (this.vmHardwareUtil.isFtVmConfigContext(ctx)) {
                return true; // edit Disabled
            }
            if (VmHardwareUtil.hasRecordReplay(ctx)) {
                return true; // edit Disabled
            }
            return false; // edit Enabled
        };
        VmAdvancedOptionsService.prototype.getMonitorTypeList = function (vmConfigContext) {
            var list = vmConfigContext && vmConfigContext.environment
                && vmConfigContext.environment.configOption
                && vmConfigContext.environment.configOption.supportedMonitorType;
            if (!list || list.length === 0) {
                return ["release", "debug"];
            }
            return list;
        };
        VmAdvancedOptionsService.prototype.getLsLevelList = function (vmConfigContext) {
            return ["normal", "high"];
        };
        VmAdvancedOptionsService.prototype.isEditingLsLevelDisabled = function (vmConfigContext, workflow) {
            var ctx = vmConfigContext;
            if (!this.isEditingLsLevelVisible(ctx)) {
                return true; // edit Disabled
            }
            if (VmWorkflowMode.CreateMode === workflow) {
                return false; // edit enabled
            }
            if (h5_vm.VmHardwareUtil.noVmSettingsPermission(ctx) ||
                h5_vm.VmHardwareUtil.noVmResourcePermission(ctx)) {
                return true; // edit Disabled;
            }
            if (VmWorkflowMode.CloneMode === workflow) {
                return false; // edit Enabled
            }
            return false;
        };
        VmAdvancedOptionsService.$inject = [
            "i18nService",
            "vmHardwareUtil"
        ];
        return VmAdvancedOptionsService;
    }());
    h5_vm.VmAdvancedOptionsService = VmAdvancedOptionsService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmAdvancedOptionsService", VmAdvancedOptionsService);
})(h5_vm || (h5_vm = {}));



(function() {
    'use strict';


    angular.module('com.vmware.vsphere.client.vm')
       .component('vmAdvancedOptions', {
           templateUrl: 'vm-ui/resources/vm/views/settings/vmOptions/vmAdvancedOptions/vmAdvancedOptions.html',
           controller: VmAdvancedOptionsController,
           controllerAs: 'ctrl',
           bindings: {
               advancedOptions: '=',
               swapPlacementType: '=',
               vmConfigContext: '<',
               vmWorkflowMode: '<',
               expanded: '='
           }
       });

    VmAdvancedOptionsController.$inject = ['i18nService',
      'vmAdvancedOptionsService', 'vscAdvancedEditConfigurationModalService', 'vmHardwareUtil'];

    function VmAdvancedOptionsController (i18nService,
       vmAdvancedOptionsService,
       advancedEditConfigurationModalService,
       vmHardwareUtil) {

       var self = this;
       var i18n = function(key) {
          return i18nService.getString("VmUi", 'AdvancedOptions.' + key);
       };

       self.LBL_TITLE = i18n('title');
       self.LBL_EXPAND = i18n('expand');
       self.LBL_SETTINGS = i18n('settings');
       self.LBL_ACCEL = i18n('settings.acceleration');
       self.LBL_LOGGING = i18n('settings.logging');
       self.LBL_MONITOR = i18n('monitor');
       self.LBL_SWAP = i18n('swapfile');
       self.LBL_SWAP_DEF = i18n('swapfile.default');
       self.LBL_SWAP_VM = i18n('swapfile.vm');
       self.LBL_SWAP_HOST = i18n('swapfile.host');
       self.LBL_PARAMS = i18n('config_params');
       self.LBL_EDIT_PARAMS = i18n('config_params.label');
       self.LBL_LATENCY = i18n('latency_sensitivity.label');

       self.service = vmAdvancedOptionsService;
       self.vmHardwareUtil = vmHardwareUtil;
       self.monitorTypeList = self.service.getMonitorTypeList(self.vmConfigContext);

       const hasPrivilege =
          self.vmConfigContext.privileges.indexOf(h5_vm.Privileges.VM_RESOURCE_PRIVILEGE) > -1;
       if ((hasPrivilege || self.vmWorkflowMode === h5_vm.VmWorkflowMode.CreateMode)
             && !self.vmConfigContext.config.latencySensitivity) {
          self.vmConfigContext.config.latencySensitivity = {
             _type: "com.vmware.vim.binding.vim.LatencySensitivity",
             level: "normal",
             sensitivity: null
          };
       }
       self.lsense = self.vmConfigContext.config.latencySensitivity;

       if (!self.lsense) {
          self.lsense = {level: "normal"};
       }

       self.swapPlacementTypeOptions = [
          {
             id: 'inherit',
             label: self.LBL_SWAP_DEF.split('\n')[0],
             description: self.LBL_SWAP_DEF.split('\n')[1]
          },
          {
             id: 'vmDirectory',
             label: self.LBL_SWAP_VM.split('\n')[0],
             description: self.LBL_SWAP_VM.split('\n')[1]
          },
          {
             id: 'hostLocal',
             label: self.LBL_SWAP_HOST.split('\n')[0],
             description: self.LBL_SWAP_HOST.split('\n')[1]
          }
       ];

       this.openAdvancedEditConfigurationModal = function () {
          advancedEditConfigurationModalService.openModal(
             self.vmConfigContext,
             this.vmConfigContext.environment.powerState,
             self.vmHardwareUtil.checkPrivileges(self.vmConfigContext.privileges, ["VirtualMachine.Config.AdvancedConfig"]));
       };

       this.isEditSwapFileLocationDisabled = function() {
          return vmAdvancedOptionsService.isEditSwapFileLocationDisabled(self.vmConfigContext.privileges, self.vmConfigContext.environment.configOption.capabilities);
       };

       this.getMonitorTypeLabel = function(value) {
          return i18n('monitor.' + value);
       };

       this.isEditMonitorTypeDisabled = function() {
          return self.service.isEditMonitorTypeDisabled(self.vmConfigContext, self.vmWorkflowMode);
       };

       this.isDisableAccelerationDisabled = function () {
          return vmAdvancedOptionsService.isDisableAccelerationDisabled(self.vmConfigContext.privileges, self.vmWorkflowMode);
       };

       this.isEnableLoggingDisabled = function() {
          return vmAdvancedOptionsService.isEnableLoggingDisabled(self.vmConfigContext.privileges, self.vmWorkflowMode);
       };

       // Section for Latency Sensitivity (Ls) Level

       this.getSetLsLevel = function(value) {
          return angular.isDefined(value) ? (self.lsense.level = value) : self.lsense.level;
       };

       this.getLsLevelList = function () {
          return self.service.getLsLevelList(self.vmConfigContext);
       };

       this.getLsLevelLabel = function (item) {
          var key =  "VmOptionsView.Advanced.LatencySensitivityLevel." + item;
          return i18nService.getString('VmUi', key);
       };

       this.isEditingLsLevelDisabled = function() {
          return self.service.isEditingLsLevelDisabled(self.vmConfigContext, self.vmWorkflowMode);
       };
       this.isEditingLsLevelVisible = function() {
          return self.service.isEditingLsLevelVisible(self.vmConfigContext);
       };

       // End of Latency Sensitivity Level section

       // Default values
       if (self.advancedOptions.enableLogging === undefined) {
          self.advancedOptions.enableLogging = true;
       }
       if (self.swapPlacementType === undefined && !this.isEditSwapFileLocationDisabled()) {
          self.swapPlacementType = self.swapPlacementTypeOptions[0].id;
       }
    }
})();

angular.module('com.vmware.vsphere.client.vm').directive('vmOptions', [
   function() {
   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmOptions/vmOptions.html',
      controller: 'VmOptionsController',
      controllerAs: 'vmOptionsController'
   };
}]);

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmOptionsController', VmOptionsController);

   VmOptionsController.$inject = [
      '$scope',
      '$q',
      'vmHardwareUtil',
      'vmHardwareVirtualDiskService',
      'defaultUriSchemeUtil',
      'storageProfileService',
      'creationTypeConstants'
   ];

   function VmOptionsController($scope, $q, vmHardwareUtil, vmHardwareVirtualDiskService,
      defaultUriSchemeUtil, storageProfileService, creationTypeConstants) {

      this.networkAdapterDevices = $scope.hardwareConfigData.virtualMachineDevices.findDevicesOfType('VirtualEthernetCard');

      this.stackBlocksExpandedState = $scope.customizeHardwarePageModel
            ? $scope.customizeHardwarePageModel.getStackBlocksExpandedState()
            : {};

      var self = this;

      self.hardDisks = $scope.hardwareConfigData.virtualMachineDevices.devicesOfType('VirtualDisk');

      self.storageProfiles = $scope.hardwareConfigData.storageProfiles;
      self.vmStorageProfileAssignments = $scope.hardwareConfigData.vmStorageProfileAssignments;

      if (!$scope.modalOptions) {
         // Wizard mode - we have the data we need
         self.vmStorageProfile = $scope.hardwareConfigData.selectedStorageProfile;
      } else {
         self.vmStorageProfile = null;
      }

      this.workflow = calculateWorkflow($scope);

      // We need to detect changes in both the hard disks count and the disk profiles
      $scope.$on(vmHardwareVirtualDiskService.DISKS_UPDATED, function($event) {
         self.hardDisks = $scope.hardwareConfigData.virtualMachineDevices.devicesOfType('VirtualDisk');
      });

      $scope.$on('vmHomeStorageProfileChanged', function($event, newProfile) {
         self.vmStorageProfile = newProfile;
      });

      this.onVmwareToolsChange = function(vmToolsOptions) {
         $scope.hardwareConfigData.vmConfigContext.config.tools = vmToolsOptions;
      };

      this.isVmPoweredOn = function() {
         return vmHardwareUtil.isVmPoweredOn($scope.hardwareConfigData.vmConfigContext.environment.powerState);
      };

      this.hasVmConfigSettingsPrivilege = function() {
         return vmHardwareUtil.checkPrivileges($scope.hardwareConfigData.vmConfigContext.privileges, ['VirtualMachine.Config.Settings']);
      };

      self.onBootOptionsChanged = function(updatedModel) {
         $scope.hardwareConfigData.vmConfigContext.config.bootOptions = updatedModel;
      };

      self.onVbsUpdate = function(vbsEnabled) {
         var config = $scope.hardwareConfigData.vmConfigContext.config;
         config.flags.vbsEnabled = vbsEnabled;
         self.vbsEnabled = vbsEnabled;

         if (vbsEnabled) {
            setupVbsProperties(config);
            updateVbsProperties(config);
         }
      };

      self.onAlert = function(options) {
         $scope.$emit('editSettingsAlertMessageChanged', options);
      };

      function setupVbsProperties (config) {
         config.bootOptions = {
            _type: "com.vmware.vim.binding.vim.vm.BootOptions",
            efiSecureBootEnabled: self.vbsProperties["bootOptions.efiSecureBootEnabled"]
         };
         config.firmware = self.vbsProperties["firmware"];
      }

      function updateVbsProperties (config) {
         config.flags.vvtdEnabled = self.vbsProperties["flags.vvtdEnabled"];
         config.nestedHVEnabled = self.vbsProperties["nestedHVEnabled"];
      }

      self.onFirmwareSelectionChanged = function(newFirmware) {
         $scope.hardwareConfigData.vmConfigContext.config.firmware = newFirmware;
         if (newFirmware.toLowerCase() === "bios") {
            $scope.ctrl.updateActionDefsForAddDeviceMenu(['addNewTpmAction']);
         } else {
            $scope.ctrl.updateActionDefsForAddDeviceMenu();
         }
      };

      self.onStandbyOptionsChange = function(standbyAction) {
         $scope.hardwareConfigData.vmConfigContext.config.defaultPowerOps.standbyAction = standbyAction;
      };

      self.vbsVisible = function() {
         return !!$scope.modalOptions;
      };

      self.getVbsProperties = function()  {
         var propertyRelations = _.reduce($scope.hardwareConfigData.vmConfigContext.environment.configOption.propertyRelations, function(map, obj) {
            map[obj.key.name] = obj.relations;
            return map;
         }, {});

         return _.reduce(propertyRelations["flags.vbsEnabled"], function(map, obj) {
            map[obj.name] = obj.val;
            return map;
         }, {});
      };

      self.doesTPMExist = function () {
         if ($scope.ctrl && $scope.ctrl.virtualMachineDevices) {
            return $scope.ctrl.virtualMachineDevices.devicesOfType('VirtualTPM').length > 0;
         }
         return false;
      };

      function calculateWorkflow (scope) {
         if (scope.modalOptions) {
            return h5_vm.VmWorkflowMode.UpdateMode;
         } else if (scope.vmParams.getCreationType() === creationTypeConstants.CLONE_VM_TO_VM
               || scope.vmParams.getCreationType() === creationTypeConstants.CLONE_TEMPLATE_TO_VM) {
            return h5_vm.VmWorkflowMode.CloneMode;
         } else {
            return h5_vm.VmWorkflowMode.CreateMode;
         }
      }

      initialize();

      function initialize () {
         self.vbsProperties = self.getVbsProperties();
         if ($scope.vmParams &&
               $scope.vmParams.getVbsEnabled) {
            self.vbsEnabled = $scope.vmParams.getVbsEnabled();
         } else {
            self.vbsEnabled = $scope.hardwareConfigData.vmConfigContext.config.flags.vbsEnabled;
         }


         if (self.vbsEnabled) {
            setupVbsProperties($scope.hardwareConfigData.vmConfigContext.config);
         }
      }
   }

})();

var h5_vm;
(function (h5_vm) {
    var VmWorkflowMode = h5_vm.VmWorkflowMode;
    var VmwareToolsController = (function () {
        function VmwareToolsController(i18nService, creationTypeConstants, vmHardwareUtil) {
            var _this = this;
            this.i18nService = i18nService;
            this.creationTypeConstants = creationTypeConstants;
            this.vmHardwareUtil = vmHardwareUtil;
            this.ARIA_LBL_UPGRADE = this.i18n2('upgrade.policy');
            this.ARIA_LBL_TIME_SYNC = this.i18n2('time.synch');
            this.ARIA_LBL_AFTER_POWER_ON = this.i18n2('scripts.after_power_on');
            this.ARIA_LBL_AFTER_RESUME = this.i18n2('scripts.after_resuming');
            this.ARIA_LBL_BEFORE_SUSPEND = this.i18n2('scripts.before_suspending');
            this.ARIA_LBL_BEFORE_SHUTDOWN = this.i18n2('scripts.before_shutting_guest');
            this.toolsUpgradePolicyEnabled = function () {
                if (_this.vmWorkflowMode === VmWorkflowMode.CreateMode) {
                    return true;
                }
                if (!_this.vmHasConfigSettingsPrivilege) {
                    return false;
                }
                return true;
            };
            this.syncTimeWithHostDisabled = function () {
                if (!_this.vmToolsCapabilities.toolsSyncTimeSupported) {
                    return true;
                }
                if (_this.vmWorkflowMode === VmWorkflowMode.CreateMode) {
                    return false;
                }
                return !_this.vmHasConfigSettingsPrivilege;
            };
            this.onVmwareToolsChange = function () {
                _this.vmToolsOptions._type = 'com.vmware.vim.binding.vim.vm.ToolsConfigInfo';
                _this.onChange({
                    vmToolsOptions: _this.vmToolsOptions,
                    vmDefaultPowerOperations: _this.vmDefaultPowerOperations
                });
            };
            this.i18n = function (key, bundle) {
                if (bundle === void 0) { bundle = 'VmUi'; }
                return i18nService.getString(bundle, key);
            };
        }
        VmwareToolsController.prototype.i18n2 = function (key, section) {
            if (section === void 0) { section = 'VMwareTools'; }
            return this.i18nService.getString("VmUi", section + '.' + key);
        };
        VmwareToolsController.prototype.$onInit = function () {
            this.canChangeScriptOptions = (this.vmWorkflowMode === VmWorkflowMode.CreateMode) || (this.vmHasConfigSettingsPrivilege && !this.vmHardwareUtil.isVmPoweredOn(this.vmPowerState));
        };
        VmwareToolsController.$inject = [
            'i18nService',
            'creationTypeConstants',
            'vmHardwareUtil'
        ];
        return VmwareToolsController;
    }());
    var VmwareTools = (function () {
        function VmwareTools() {
            this.bindings = {
                vmWorkflowMode: '<',
                vmDefaultPowerOperations: '<',
                vmToolsOptions: '<',
                vmToolsCapabilities: '<',
                vmPowerState: '<',
                vmHasConfigSettingsPrivilege: '<',
                onChange: '&',
                expanded: '='
            };
            this.controller = VmwareToolsController;
            this.templateUrl = 'vm-ui/resources/vm/views/settings/vmOptions/vmwareTools/vmware-tools.html';
        }
        return VmwareTools;
    }());
    angular.module('com.vmware.vsphere.client.vm')
        .component('vmwareTools', new VmwareTools());
})(h5_vm || (h5_vm = {}));



(function() {
   angular.module('com.vmware.vsphere.client.vm').controller('manageSnapshotsController', manageSnapshotsController);

   manageSnapshotsController.$inject = ['snapshotService', '$scope', 'snapshotTreeService', 'defaultUriSchemeUtil',
      'vcH5ConstantsService', 'i18nService', 'clarityModalService'];

   function manageSnapshotsController(snapshotService, $scope, snapshotTreeService, defaultUriSchemeUtil, vcH5ConstantsService, i18nService, clarityModalService) {
      var self = this;
      var description;
      var label;
      self.updateSnapshotTreeDebounced = _.debounce(updateSnapshotTree, 300);
      self.vmId = $scope.modalOptions.availableTargets[0];
      self.liveRefreshProperties = ["config.hardware.device", "snapshot.rootSnapshotList",
         "snapshot.currentSnapshot", "rootSnapshot", "snapshot"];
      self.isEditing = false;

      $scope.$on(vcH5ConstantsService.MODEL_CHANGED_EVENT, onModelChanged);

      function buildAlertOptions(options) {
         var baseOptions = {
            title: options.title,
            message: options.message || '',
            submit: options.submit
         };

         return baseOptions;
      }

      function onModelChanged(event, objChangeInfo) {
         if (objChangeInfo.objectId !== self.vmId) {
            return;
         }
         if (objChangeInfo.operationType === 'CHANGE') {
            self.updateSnapshotTreeDebounced();
         } else if (objChangeInfo.operationType === 'DELETE') {
            $scope.closeModal();
         }
      }

      function updateSnapshotTree() {
         snapshotService.getSnapshotsForVM(self.vmId).then(function(response) {
            var treeViewOptions = snapshotTreeService.formatData(response);
            self.treeViewOptions = treeViewOptions;
            self.hasSnapshots = hasSnapshots(treeViewOptions);
            self.setAsSelected(snapshotTreeService.getCurrentSnapshot());
            treeViewOptions.onClick = function(treeItem) {
               self.setAsSelected(treeItem);
            };
            getPrivileges();
            getCapabilities();
         });
      }

      function hasSnapshots(treeViewOptions) {
         if(angular.isArray(treeViewOptions.data) && treeViewOptions.data.length > 0){
            if(angular.isArray(treeViewOptions.data[0].items) && treeViewOptions.data[0].items.length > 0){
               return treeViewOptions.data[0].items[0].iconClass !== snapshotTreeService.icons.youAreHere;
            }
         }

         return false;
      }

      function updateDiskUsageLabel(iconClass) {
         var isRootSnapshot = iconClass === snapshotTreeService.icons.vm;
         var diskUsageLabelKey = isRootSnapshot ? 'SnapshotManagerView.FullDiskUsage' : 'SnapshotManagerView.DiskUsage';
         self.diskUsageLabel = i18nService.getString('vmuiSnapshot', diskUsageLabelKey);
      }

      updateSnapshotTree();

      this.setAsSelected = function(treeItem) {
         updateDiskUsageLabel(treeItem.iconClass);
         self.selectedSnapshot = treeItem;
         self.isSnapshotSelected = Boolean(treeItem.metadata && treeItem.metadata.snapshotMOR);
         self.isRootSelected = treeItem.iconClass === snapshotTreeService.icons.vm;
         $scope.revertAlertOptions.message = i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.RevertToSnapshot', treeItem.label);
         self.isSelectedItemEditable = !self.isRootSelected && treeItem.iconClass !== snapshotTreeService.icons.youAreHere;
         $scope.removeAlertOptions.message = i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.Delete.Message', treeItem.label);
         description = treeItem.metadata.description;
         label = treeItem.label;
         self.isEditing = false;
      };

      function getSnapshotId() {
         var snapshotMOR = self.selectedSnapshot.metadata.snapshotMOR;
         if (snapshotMOR) {
            return defaultUriSchemeUtil.getVsphereObjectId(snapshotMOR);
         }
      }

      //// Revert to Snapshot

      $scope.revertAlertOptions = buildAlertOptions({
         title: i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.ConfirmRevert'),
         submit: onRevertToConfirmation
      });

      this.onRevertToButtonClicked = function() {
         clarityModalService.openConfirmationModal($scope.revertAlertOptions);
      };

      function onRevertToConfirmation() {
         snapshotService.revertToSnapshot(self.selectedSnapshot.metadata.snapshotMOR);
      }

      //// Remove selected snapshot

      $scope.removeAlertOptions = buildAlertOptions({
         title: i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.ConfirmDelete'),
         submit: onRemoveSelectedSnapshotConfirmation
      });

      this.onRemoveSelectedSnapshotButtonClicked = function() {
         clarityModalService.openConfirmationModal($scope.removeAlertOptions);
      };

      function onRemoveSelectedSnapshotConfirmation() {
         var snapshotId = getSnapshotId();
         if (snapshotId) {
            snapshotService.removeSnapshot(snapshotId);
         }
      }

      //// Remove All Snapshots

      this.onRemoveAllSnapshotsButtonClicked = function() {
         snapshotService.openRemoveAllSnapshotsConfirmationDialog(self.vmId);
      };


      //// Editing snapshot details

      this.onEditSelectedSnapshotButtonClicked = function() {
         description = self.selectedSnapshot.metadata.description;
         label = self.selectedSnapshot.label;
         self.isEditing = true;
      };

      this.onConfirmEditButtonClicked = function() {
         self.isEditing = false;
         snapshotService.updateSnapshot(
            self.vmId,
            getSnapshotId(),
            self.selectedSnapshot.label,
            self.selectedSnapshot.metadata.description
         );
      };

      this.onCancelEditButtonClicked = function() {
         self.selectedSnapshot.label = label;
         self.selectedSnapshot.metadata.description = description;
         self.isEditing = false;
      };

      this.isEditDisabled = function() {
         return !(self.isSelectedItemEditable && self.hasEditPrivilege && self.snapshotConfigSupported);
      };

       this.isRevertDisabled = function() {
           return !(self.isSnapshotSelected && self.hasRevertPrivilege && self.revertToSnapshotSupported);
       };

      function getPrivileges() {
           snapshotService.getPrivilegesForVM(self.vmId).then(function(response) {
               self.hasDeletePrivilege = response[0];
               self.hasRevertPrivilege = response[1];
               self.hasEditPrivilege = response[2];
           });

      }

      function getCapabilities() {
           snapshotService.getCapabilitiesForVM(self.vmId).then(function(response) {
               self.snapshotConfigSupported = response.capability.snapshotConfigSupported;
               self.revertToSnapshotSupported = response.capability.revertToSnapshotSupported;
           });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('snapshotDialogController', snapshotDialogController);

   snapshotDialogController.$inject = ['$scope', 'snapshotService', 'i18nService'];


   function snapshotDialogController($scope, snapshotService, i18nService) {
      var self = this;
      self.isMemoryDisabled = snapshotService.isTakingSnapshotWithMemoryDisabled($scope.modalOptions.dialogData);
      self.isQuiesceEnabled = snapshotService.isQuiesceEnabled($scope.modalOptions.dialogData) && self.isMemoryDisabled;
      self.includeMemory = snapshotService.isSnapshotTakenWithMemoryByDefault($scope.modalOptions.dialogData);
      self.quiesce = false;
      self.snapshotName = i18nService.getString('vmuiSnapshot', 'SnapshotManagerView.DefaultSnapshotName') + ' ' +
            new Date().toLocaleString();

      self.enableDisableMemoryQuiesce = function() {
         self.isQuiesceEnabled = snapshotService.isQuiesceEnabled($scope.modalOptions.dialogData) && !self.includeMemory;
         self.isMemoryDisabled = snapshotService.isTakingSnapshotWithMemoryDisabled($scope.modalOptions.dialogData) || self.quiesce;
      };

      self.createSnapshot = function() {
         var vmId = $scope.modalOptions.dialogData.objectId;
         snapshotService.takeSnapshot(vmId, self.snapshotName, self.snapshotDescription, self.includeMemory, self.quiesce);
         $scope.closeModal();
      };

      $scope.handleKeypress = function($event) {
         if ($event.which === 13) {
            $event.stopPropagation();
         }
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Snapshot service
 */
(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .service('snapshotService', snapshotService);

   snapshotService.$inject = ['mutationService',
      'dataService',
      'defaultUriSchemeUtil',
      'i18nService',
      'clarityModalService',
      'authorizationService',
      'managedByMessageBuilderService',
      'actionConfirmationService','actionsService', '$q'];

   function snapshotService(mutationService, dataService, defaultUriSchemeUtil, i18nService,
         clarityModalService, authorizationService, managedByMessageBuilderService, actionConfirmationService,
         actionsService, $q) {

      var MUTATION_SNAPSHOT_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotSpec';
      var MUTATION_SNAPSHOT_REMOVAL_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotRemovalSpec';
      var MUTATION_SNAPSHOT_CONSOLIDATE_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotConsolidateSpec';
      var MUTATION_SNAPSHOT_REVERT_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotRevertSpec';
      var MUTATION_SNAPSHOT_EDIT_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotEditSpec';
      var MUTATION_SNAPSHOT_REMOVE_ALL_SPEC = 'com.vmware.vsphere.client.vm.snapshot.VmSnapshotRemoveAllSpec';
      const POWER_STATE = h5_vm.PowerState;

      function takeSnapshot(vmId, snapshotName, snapshotDescription, includeMemory, quiesce) {
         var vmSnapshotSpec = {
            name: snapshotName,
            description: snapshotDescription,
            vm: defaultUriSchemeUtil.getManagedObjectReference(vmId),
            memory: includeMemory,
            quiesce: quiesce
         };
         mutationService.add(MUTATION_SNAPSHOT_SPEC, vmSnapshotSpec);
      }

      function getSnapshotsForVM(id, getManagedByInfo) {
         var properties = ['name', 'snapshot', 'diskUsage'];
         if(getManagedByInfo) {
            properties.push("managedByInfo");
         }
         return dataService.getProperties(id, properties);
      }

      function getCapabilitiesForVM(id) {
         return dataService.getProperties(id, ['capability']);
      }

      function getPrivilegesForVM(id) {
         var reqPrivileges = [h5_vm.Privileges.VM_REMOVE_SNAPSHOT, h5_vm.Privileges.VM_REVERT_SNAPSHOT, h5_vm.Privileges.VM_RENAME_SNAPSHOT];
         return authorizationService.checkPrivileges(id, reqPrivileges);
      }

      function removeSnapshot(snapshotId) {
         var vmSnapshotRemovalSpec = {
            removeChildren: false,
            consolidate: true
         };
         return mutationService.remove(snapshotId, MUTATION_SNAPSHOT_REMOVAL_SPEC, vmSnapshotRemovalSpec);
      }

      function removeAllSnapshots(vmId) {
         return mutationService.remove(vmId, MUTATION_SNAPSHOT_REMOVE_ALL_SPEC, {});
      }

      function updateSnapshot(vmId, snapshotId, name, description) {
         var vmSnapshotEditSpec = {
            name: name,
            description: description,
            vm: defaultUriSchemeUtil.getManagedObjectReference(vmId)
         };
         mutationService.apply(snapshotId, MUTATION_SNAPSHOT_EDIT_SPEC, vmSnapshotEditSpec);
      }

      function revertToCurrentSnapshot(vmId) {
         applySnapshotRevert(vmId);
      }

      function revertToSnapshot(snapshotMOR) {
         return applySnapshotRevert(defaultUriSchemeUtil.getVsphereObjectId(snapshotMOR));
      }

      function applySnapshotRevert(objectUri) {
         var vmSnapshotRevertSpec = {
            suppressPowerOn: false
         };
         return mutationService.apply(objectUri, MUTATION_SNAPSHOT_REVERT_SPEC, vmSnapshotRevertSpec);
      }

      function onRevertToActionMenuClicked(vmId, data) {
         var snapshotName = getLastSnapshotName(data.snapshot.rootSnapshotList[0]);
         var propertiesPerObject = {};
         propertiesPerObject[vmId] = data;
         var yesHandler = function() {
            applySnapshotRevert(vmId);
         };

         var titleText = i18nService.getString(
               'vmuiSnapshot', 'SnapshotActionCommand.ConfirmRevert');
         var messageText = i18nService.getString(
               'vmuiSnapshot', 'SnapshotActionCommand.RevertToSnapshot', snapshotName);

         managedByMessageBuilderService.buildWarningMessage([vmId], false, propertiesPerObject)
               .then(function(managedByInfoMessage) {
                  if (managedByInfoMessage) {
                     messageText = managedByInfoMessage + "\n\n" + messageText;
                  }
                  var dialogProperties = buildDialogOptions(yesHandler, messageText, titleText, data.name);
                  actionConfirmationService.showConfirmationDialog(dialogProperties);
               });
      }

      function getLastSnapshotName(root) {
         if (root.childSnapshotList === null || !root.childSnapshotList) {
            return root.name;
         }

         return getLastSnapshotName(root.childSnapshotList[0]);
      }

      function consolidateSnapshots(vmId) {
         return mutationService.apply(vmId, MUTATION_SNAPSHOT_CONSOLIDATE_SPEC, {});
      }

      function openTakeSnapshotDialog(availableTargets, actionEval) {
         var vmId = availableTargets[0];
         var actionPromise = actionsService.getActions(vmId, ['vsphere.core.vm.actions.installToolsAction']);
         var dataServicePromise = dataService.getProperties(vmId, ["powerState", "capability", "name"]);

         return $q.all([actionPromise, dataServicePromise])
               .then(function(responses) {
                  var state = responses[1];
                  var vmToolsInstalledNeeded = responses[0][0].available;

                  clarityModalService.openModal(
                        actionEval,
                        availableTargets,
                        {
                           objectId: vmId,
                           powerState: state.powerState,
                           memorySupported: state.capability.memorySnapshotsSupported,
                           quiesceSupported: state.capability.quiescedSnapshotsSupported,
                           diskOnlySnapshotOnSuspendedVMSupported: state.capability.diskOnlySnapshotOnSuspendedVMSupported,
                           vmToolsInstalledNeeded: vmToolsInstalledNeeded,
                           secondaryTitle: state.name
                        },
                        "vm-ui/resources/vm/views/snapshots/snapshotDialog.html"
                  );
               });
      }

      function openManageSnapshotDialog(availableTargets, actionEval) {
         clarityModalService.openModal(actionEval, availableTargets, undefined,
               "vm-ui/resources/vm/views/snapshots/vmManageSnapshots.html");
      }

      function openConsolidateSnapshotDialog(availableTargets) {
         var vmId = availableTargets[0];
         var yesHandler = function() {
            consolidateSnapshots(vmId);
         };
         var titleText = i18nService.getString(
               'vmuiSnapshot', 'SnapshotActionCommand.ConfirmConsolidate');
         var messageText = i18nService.getString(
               'vmuiSnapshot', 'SnapshotActionCommand.Consolidate.All');

         managedByMessageBuilderService.buildWarningMessage([vmId], false)
               .then(function(managedByInfoMessage) {
                  if (managedByInfoMessage) {
                     messageText = managedByInfoMessage + "\n\n" + messageText;
                  }
                  var dialogProperties = buildDialogOptions(yesHandler, messageText, titleText, "", vmId);
                  actionConfirmationService.showConfirmationDialog(dialogProperties);
               });
      }

      function openRemoveAllSnapshotsConfirmationDialog(vmId) {
         var removeAllAlertOptions = {
            title: i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.ConfirmDeleteAll'),
            message: i18nService.getString('vmuiSnapshot', 'SnapshotActionCommand.DeleteSnapshotForVM'),
            showXIcon: false,
            submit: function() { removeAllSnapshots(vmId); }
         };
         clarityModalService.openConfirmationModal(removeAllAlertOptions);
      }

      function buildDialogOptions(yesHandler, messageText, titleText, name, vmId) {
         var subTitle = {};
         if (vmId) {
            subTitle.objectId = vmId;
         } else if (name) {
            subTitle.text = name;
         }
         var alertProperties = {
            title: titleText,
            message: messageText,
            yesHandler: yesHandler,
            useClarity: true,
            icon: null,
            clarityIcon: {
               shape: "warning",
               class: "is-warning",
               size: 48
            },
            showXIcon: false
         };

         if (!_.isEmpty(subTitle)) {
            alertProperties.subTitle = subTitle;
         }

         return alertProperties;
      }

      function isSnapshotTakenWithMemoryByDefault(dialogData) {
         return (dialogData.powerState !== POWER_STATE.POWERED_OFF);
      }

      function isTakingSnapshotWithMemoryDisabledForEditing(dialogData) {
         return dialogData.powerState === POWER_STATE.POWERED_OFF
               || !dialogData.memorySupported
               || (dialogData.powerState === POWER_STATE.SUSPENDED && !dialogData.diskOnlySnapshotOnSuspendedVMSupported);
      }

      function isQuiesceEnabled(dialogData) {
         return dialogData.powerState === POWER_STATE.POWERED_ON && dialogData.quiesceSupported
            && !dialogData.vmToolsInstalledNeeded;
      }

      return {
         takeSnapshot: takeSnapshot,
         getSnapshotsForVM: getSnapshotsForVM,
         revertToCurrentSnapshot: revertToCurrentSnapshot,
         revertToSnapshot: revertToSnapshot,
         removeSnapshot: removeSnapshot,
         removeAllSnapshots: removeAllSnapshots,
         updateSnapshot: updateSnapshot,
         onRevertToActionMenuClicked: onRevertToActionMenuClicked,
         consolidateSnapshots: consolidateSnapshots,
         getPrivilegesForVM: getPrivilegesForVM,
         getCapabilitiesForVM: getCapabilitiesForVM,
         openTakeSnapshotDialog: openTakeSnapshotDialog,
         openManageSnapshotDialog: openManageSnapshotDialog,
         openConsolidateSnapshotDialog: openConsolidateSnapshotDialog,
         openRemoveAllSnapshotsConfirmationDialog: openRemoveAllSnapshotsConfirmationDialog,
         isQuiesceEnabled: isQuiesceEnabled,
         isTakingSnapshotWithMemoryDisabled: isTakingSnapshotWithMemoryDisabledForEditing,
         isSnapshotTakenWithMemoryByDefault: isSnapshotTakenWithMemoryByDefault
      };
   }
}());

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm').service('snapshotTreeService', snapshotTreeService);

   snapshotTreeService.$inject = ['timeFormatterService', 'i18nService'];

   const POWERSTATE = h5_vm.PowerState;
   var icons = {
      vm: 'vsphere-icon-vm',
      snapshotPoweredOff: 'vsphere-icon-snapshot',
      snapshotPoweredOn: 'vsphere-icon-snapshot_run',
      snapshotSuspended: 'vsphere-icon-snapshot_suspend',
      youAreHere: 'vsphere-icon-snapshot_here'
   };
   var timeFormatter;
   var currentSnapshot;
   var i18n;

   function snapshotTreeService(timeFormatterService, i18nService) {
      timeFormatter = timeFormatterService;
      i18n = i18nService;
      return {
         formatData: formatData,
         getCurrentSnapshot: getCurrentSnapshot,
         icons: icons
      };
   }

   function formatData(snapshotData) {
      var rootVMNode = buildRootVMNode(snapshotData);

      if (snapshotData.snapshot && snapshotData.snapshot.rootSnapshotList) {
         rootVMNode.items = buildChildSnapshotTreeItems(snapshotData.snapshot.rootSnapshotList, snapshotData);
      } else {
         currentSnapshot = _.pick(rootVMNode, ['label', 'metadata', 'iconClass']);
         rootVMNode.selected = true;
         rootVMNode.items = [buildYouAreHereTreeItem(snapshotData)];
      }

      return { data: [rootVMNode] };
   }

   function getCurrentSnapshot() {
      return currentSnapshot;
   }

   function buildRootVMNode(snapshotData) {
      var optionalProperties = {
         diskUsage: snapshotData.diskUsage.totalDiskUsageInBytes
      };
      return buildTreeItem(snapshotData.name, icons.vm, optionalProperties);
   }

   function buildYouAreHereTreeItem(snapshotData) {
      var optionalProperties = {
         diskUsage: snapshotData.diskUsage.currentDiskUsageInBytes
      };
      return buildTreeItem(i18n.getString('vmuiSnapshot', 'SnapshotManagerView.YouAreHere'), icons.youAreHere, optionalProperties);
   }

   function buildTreeItem(label, icon, optionalProperties) {
      var treeItem = {
         label: label,
         iconClass: icon,
         items: [],
         expanded: true
      };

      if (optionalProperties) {
         treeItem.metadata = optionalProperties;
      }

      return treeItem;
   }

   function getUsageDataForSnapshot(childSnapshot, snapshotDiskUsageArray) {
      for (var i = 0; i < snapshotDiskUsageArray.length; i++) {
         if (childSnapshot.snapshot.value === snapshotDiskUsageArray[i].snapshotId) {
            return snapshotDiskUsageArray[i].diskUsageInBytes;
         }
      }
   }

   function childTreeItem(rootSnapshotList, snapshotData) {
      var childItem = buildSnapshotTreeItem(rootSnapshotList, snapshotData);
      var currentSnapshotObject = snapshotData.snapshot.currentSnapshot;

      if (rootSnapshotList.childSnapshotList !== null) {
         childItem.items = buildChildSnapshotTreeItems(rootSnapshotList.childSnapshotList, snapshotData);
      }

      if (currentSnapshotObject && rootSnapshotList.snapshot.value === currentSnapshotObject.value) {
         currentSnapshot = _.pick(childItem, ['label', 'metadata']);
         childItem.selected = true;
         childItem.items.unshift(buildYouAreHereTreeItem(snapshotData));
      }

      return childItem;
   }

   function buildSnapshotTreeItem(rootSnapShotList, snapshotData) {
      var optionalProperties = {
         'description': rootSnapShotList.description,
         'createTime': rootSnapShotList.createTime,
         'snapshotMOR': rootSnapShotList.snapshot,
         'isMemoryIncluded': getMemorySnapshot(rootSnapShotList.state),
         'quiesced': rootSnapShotList.quiesced ? i18n.getString('vmuiSnapshot', 'SnapshotManagerView.Option.Yes')
               : i18n.getString('vmuiSnapshot', 'SnapshotManagerView.Option.No'),
         'diskUsage': getUsageDataForSnapshot(rootSnapShotList, snapshotData.diskUsage.snapshotDiskUsage)
      };
      timeFormatter.formatDate(rootSnapShotList.createTime).then(function(formattedTime) {
         optionalProperties.createTime = formattedTime;
      });
      return buildTreeItem(rootSnapShotList.name, getSnapshotIcon(rootSnapShotList.state), optionalProperties);
   }

   function buildChildSnapshotTreeItems(rootSnapshotList, snapshotData) {
      return _.map(rootSnapshotList, function(rootSnapshotList) {
         return childTreeItem(rootSnapshotList, snapshotData);
      });
   }

   function getMemorySnapshot(state) {
      switch (state) {
         case POWERSTATE.SUSPENDED:
         case POWERSTATE.POWERED_ON:
            return i18n.getString('vmuiSnapshot', 'SnapshotManagerView.Option.Yes');
         case POWERSTATE.POWERED_OFF:
            return i18n.getString('vmuiSnapshot', 'SnapshotManagerView.Option.No');
         default:
            return i18n.getString('vmuiSnapshot', 'SnapshotManagerView.Option.No');
      }
   }

   function getSnapshotIcon(state) {
      switch (state) {
         case POWERSTATE.SUSPENDED: return icons.snapshotSuspended;
         case POWERSTATE.POWERED_ON:
            return icons.snapshotPoweredOn;
         case POWERSTATE.POWERED_OFF:
            return icons.snapshotPoweredOff;
         default:
            return icons.snapshotPoweredOff;
      }
   }

})();

(function() {
   'use strict';
   angular.module('com.vmware.platform.ui')
      .controller('SelectConsoleDialogController', SelectConsoleDialogController);

   SelectConsoleDialogController.$inject = [
      '$scope',
      '$rootScope',
      'i18nService',
      'persistenceService',
      'actionsService'
   ];

   function SelectConsoleDialogController($scope, $rootScope, i18nService, persistenceService, actionsService) {
      var self = this;
      self.$scope = $scope;
      var PROPERTY_DEFAULT_CONSOLE = 'com.vmware.usersettings.defaultConsole';
      var ACTION_OPEN_CONSOLE = "vsphere.core.vm.actions.openConsole";
      var ACTION_LAUNCH_REMOTE_CONSOLE = "vsphere.core.vm.actions.launchRemoteConsole";
      self.currentlySelectedFormat = "WEB_CONSOLE";
      
      self.onClick = function() {
         if (self.shouldRemember) {
            var value = {'defaultConsole' : self.currentlySelectedFormat };
            persistenceService.setData(PROPERTY_DEFAULT_CONSOLE, value, {}, 'defaultConsole',  'CONTENT_TYPE_TEXT');
         }

         var action = (self.currentlySelectedFormat === "WEB_CONSOLE") ? ACTION_OPEN_CONSOLE : ACTION_LAUNCH_REMOTE_CONSOLE;
         actionsService.getAction(action, [$scope.modalOptions.dialogData.vmId])
            .then(function(action) {
               actionsService.invokeAction(action);
            });
         return true;
      };

      $scope.modalOptions.onSubmit = self.onClick;
   }
})();

var h5_vm;
(function (h5_vm) {
    var SelectHostModalService = (function () {
        function SelectHostModalService(clarityModalService, i18nService, defaultUriSchemeUtil, datastoreBrowserConstants, contentLibraryService, dataService) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
            this.contentLibraryService = contentLibraryService;
            this.dataService = dataService;
        }
        SelectHostModalService.prototype.openHostDeviceSelector = function (computeResourceId, okHandler, cancelHandler) {
            var _this = this;
            var dialogData = {
                i18nService: this.i18nService,
                hosts: [],
                selectedHost: '',
                isLoading: true,
                onHostChange: this.onHostChange.bind(this)
            };
            this.dataService.getProperties(computeResourceId, ['vmCdromContext']).then(function (response) {
                _this.processResponse(response, dialogData, okHandler, cancelHandler);
            });
        };
        SelectHostModalService.prototype.processResponse = function (response, dialogData, okHandler, cancelHandler) {
            dialogData.isLoading = false;
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "USBDevicePage.SelectHostDevice"),
                contentTemplate: 'vm-ui/resources/vm/views/summary/modals/select-host/select-host.html',
                defaultButton: 'submit',
                size: 'md',
                dialogData: dialogData,
                hideSubmitButton: false,
                submitDisabled: true,
                onCancel: this.onCancel.bind(this, cancelHandler)
            };
            if (response.vmCdromContext.cdRom) {
                dialogData.hosts = response.vmCdromContext.cdRom;
                dialogData.selectedHost = dialogData.hosts[0];
                modalOptions.submitDisabled = false;
            }
            modalOptions.dialogData.isSelectorDisabled = this.isSelectorDisabled.bind(this, modalOptions);
            modalOptions.onSubmit = this.onSubmit.bind(this, okHandler, modalOptions),
                this.clarityModalService.openOkCancelModal(modalOptions);
            return modalOptions;
        };
        ;
        SelectHostModalService.prototype.onCancel = function (callback) {
            if (angular.isFunction(callback)) {
                callback();
            }
        };
        ;
        SelectHostModalService.prototype.onSubmit = function (callback, modalOptions) {
            if (angular.isFunction(callback)) {
                callback(modalOptions.dialogData.selectedHost);
            }
            return true;
        };
        ;
        SelectHostModalService.prototype.isSelectorDisabled = function (modalOptions) {
            return (modalOptions.dialogData.isLoading || !modalOptions.dialogData.hosts.length);
        };
        SelectHostModalService.prototype.onHostChange = function (item, modalOptions) {
            modalOptions.dialogData.selectedHost = item;
            modalOptions.submitDisabled = false;
        };
        ;
        SelectHostModalService.$inject = ['clarityModalService',
            'i18nService',
            'defaultUriSchemeUtil',
            'datastoreBrowserConstants',
            'contentLibraryService',
            'dataService'];
        return SelectHostModalService;
    }());
    h5_vm.SelectHostModalService = SelectHostModalService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("selectHostModalService", SelectHostModalService);
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    var SelectIsoModalService = (function () {
        function SelectIsoModalService(clarityModalService, i18nService, defaultUriSchemeUtil, datastoreBrowserConstants, contentLibraryService, dataService) {
            this.clarityModalService = clarityModalService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.datastoreBrowserConstants = datastoreBrowserConstants;
            this.contentLibraryService = contentLibraryService;
            this.dataService = dataService;
        }
        SelectIsoModalService.prototype.openIsoDeviceSelector = function (computeResourceId, okHandler, cancelHandler) {
            var _this = this;
            var dialogData = {
                i18nService: this.i18nService,
                selectedIso: {},
                datastoreBrowserId: '',
                datastoreIds: new Array(),
                initialFileQueryType: '',
                filterFileQueryTypes: new Array(),
                showVmImagesFolder: true,
                onIsoChange: this.onIsoChange.bind(this),
            };
            this.dataService.getProperties(computeResourceId, ['vmCdromContext']).then(function (response) { return _this.processResponse(response, dialogData, okHandler, cancelHandler); });
        };
        SelectIsoModalService.prototype.processResponse = function (response, dialogData, okHandler, cancelHandler) {
            var _this = this;
            var dsBrowserId = this.defaultUriSchemeUtil.getVsphereObjectId(response.vmCdromContext.datastoreBrowser);
            var vmDatastores = response.vmCdromContext.datastore;
            var datastoreIds;
            if (vmDatastores) {
                datastoreIds = vmDatastores.map(function (vmDatastore) {
                    return _this.defaultUriSchemeUtil.getVsphereObjectId(vmDatastore.datastore.datastore);
                });
            }
            else {
                datastoreIds = [];
            }
            var initialFileQueryType = this.datastoreBrowserConstants.fileQueryType.ISO_IMAGE
                + this.datastoreBrowserConstants.fileQueryType.FOLDERS
                + this.datastoreBrowserConstants.fileQueryType.FLOPPY_IMAGE;
            var filterQueryTypes = [{
                    label: this.i18nService.getString('Common', 'dsBrowser.isoImageFile'),
                    value: this.datastoreBrowserConstants.fileQueryType.ISO_IMAGE
                        + this.datastoreBrowserConstants.fileQueryType.FOLDERS
                },
                {
                    label: this.i18nService.getString('Common', 'dsBrowser.allFiles'),
                    value: this.datastoreBrowserConstants.fileQueryType.ALL_FILES
                }
            ];
            dialogData.datastoreBrowserId = dsBrowserId;
            dialogData.datastoreIds = datastoreIds;
            dialogData.initialFileQueryType = initialFileQueryType;
            dialogData.filterFileQueryTypes = filterQueryTypes;
            var modalOptions = {
                title: this.i18nService.getString("VmUi", "contentLibISO.infoHeader"),
                contentTemplate: 'vm-ui/resources/vm/views/summary/modals/select-iso/select-iso.html',
                defaultButton: 'submit',
                size: 'lg',
                dialogData: dialogData,
                hideSubmitButton: false,
                submitDisabled: true,
                onCancel: this.onCancel.bind(this)
            };
            modalOptions.onSubmit = this.onSubmit.bind(this, okHandler, modalOptions);
            this.clarityModalService.openOkCancelModal(modalOptions);
            return modalOptions;
        };
        ;
        SelectIsoModalService.prototype.onCancel = function (callback) {
            if (angular.isFunction(callback)) {
                callback();
            }
        };
        ;
        SelectIsoModalService.prototype.onSubmit = function (callback, modalOptions) {
            if (angular.isFunction(callback)) {
                callback(modalOptions.dialogData.selectedIso);
            }
            return true;
        };
        ;
        SelectIsoModalService.prototype.onIsoChange = function (item, modalOptions) {
            modalOptions.dialogData.selectedIso = item;
            if (item) {
                modalOptions.submitDisabled = false;
            }
            else {
                modalOptions.submitDisabled = true;
            }
        };
        ;
        SelectIsoModalService.$inject = ['clarityModalService',
            'i18nService',
            'defaultUriSchemeUtil',
            'datastoreBrowserConstants',
            'contentLibraryService',
            'dataService'];
        return SelectIsoModalService;
    }());
    h5_vm.SelectIsoModalService = SelectIsoModalService;
    angular.module("com.vmware.vsphere.client.vm")
        .service("selectIsoModalService", SelectIsoModalService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VirtualDeviceSpec = com.vmware.vim.binding.vim.vm.device.VirtualDeviceSpec;
    var VmHardwareSummaryCdrom = (function () {
        function VmHardwareSummaryCdrom() {
            this.templateUrl = "vm-ui/resources/vm/views/summary/vm-hardware-summary-cdrom.html";
            this.controller = VmHardwareSummaryCdromController;
            this.bindings = {
                device: '=',
                ctrl: '='
            };
        }
        return VmHardwareSummaryCdrom;
    }());
    h5_vm.VmHardwareSummaryCdrom = VmHardwareSummaryCdrom; // VmHardwareSummaryCdrom
    var VmHardwareSummaryCdromController = (function () {
        function VmHardwareSummaryCdromController(contentLibraryService, i18nService, selectIsoFileService, contentLibraryIsoSelectorModalService, selectHostModalService, selectIsoModalService, defaultUriSchemeUtil, dataService, authorizationService, mutationService, configurationService) {
            this.contentLibraryService = contentLibraryService;
            this.i18nService = i18nService;
            this.selectIsoFileService = selectIsoFileService;
            this.contentLibraryIsoSelectorModalService = contentLibraryIsoSelectorModalService;
            this.selectHostModalService = selectHostModalService;
            this.selectIsoModalService = selectIsoModalService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.authorizationService = authorizationService;
            this.mutationService = mutationService;
            this.configurationService = configurationService;
            this.lastAccessedISOFile = '';
            this.hasDeviceConnectionPriv = false;
            this.hasSetCdMediaPriv = false;
            this.hasCLConfig = true;
            this.BACKING_ISO = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$IsoBackingInfo';
            this.BACKING_ATAPI = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$AtapiBackingInfo';
            this.BACKING_REMOTE_ATAPI = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$RemoteAtapiBackingInfo';
            this.VM_DEVICE_CONNECTION_SPEC = 'com.vmware.vsphere.client.vm.VmDeviceConnectionSpec';
            this.i18n = i18nService.getString;
        }
        VmHardwareSummaryCdromController.prototype.$onInit = function () {
            var deviceInfo = this.device.deviceInfo;
            this.label = (deviceInfo) ? deviceInfo.label : '';
            if (!this.ctrl.isVmTemplateCLitem) {
                this.getPermissions(['VirtualMachine.Interact.DeviceConnection', 'VirtualMachine.Interact.SetCDMedia']);
            }
            this.checkForCLConfig();
            if (this.shouldRefetchISOItemType()) {
                this.fetchISOItemType();
            }
        };
        VmHardwareSummaryCdromController.prototype.shouldShowDropdown = function () {
            return (!this.ctrl.isVmTemplateCLitem &&
                !this.ctrl.hardwareViewData.isTemplate &&
                this.ctrl.hardwareViewData.powerState === 'poweredOn') ? true : false;
        };
        ;
        VmHardwareSummaryCdromController.prototype.getDeviceConnected = function () {
            if (this.ctrl && this.ctrl.isVmTemplateCLitem) {
                return this.getOvfTemplateDeviceType();
            }
            var connKey = this.isDeviceConnected() ? 'connected' : 'disconnected';
            return this.i18n('VmUi', 'DeviceConnection.' + connKey);
        };
        ;
        VmHardwareSummaryCdromController.prototype.isDeviceConnected = function () {
            return this.device.connectable && this.device.connectable.connected;
        };
        ;
        VmHardwareSummaryCdromController.prototype.getConnectedTo = function () {
            if (this.isLoading) {
                return this.i18n('VmUi', 'DeviceConnection.loading');
            }
            switch (this.device.backing._type) {
                case this.BACKING_ISO:
                    if (this.shouldRefetchISOItemType()) {
                        this.fetchISOItemType();
                        return;
                    }
                    return this.isContentLibraryIso
                        ? this.i18n('VmUi', 'DeviceConnection.manager.info.cl_image_file')
                        : this.i18n('VmUi', 'DeviceConnection.manager.info.host_image_file');
                case this.BACKING_ATAPI:
                    this.resetLastAccessedISOBackingInfo();
                    return this.i18n('VmUi', 'DeviceConnection.manager.info.host_cdrom_device');
                case this.BACKING_REMOTE_ATAPI:
                    this.resetLastAccessedISOBackingInfo();
                    return this.i18n('VmUi', 'DeviceConnection.manager.info.client_machine');
                default:
                    this.resetLastAccessedISOBackingInfo();
                    return this.i18n('VmUi', 'DeviceConnection.manager.unknown_device');
            }
        };
        ;
        VmHardwareSummaryCdromController.prototype.disconnectCdRom = function () {
            this.expanded = false;
            this.device.connectable.connected = false;
            this.device.connectable.startConnected = false;
            this.mutate();
        };
        ;
        VmHardwareSummaryCdromController.prototype.connectToHostCdDevice = function () {
            var _this = this;
            this.selectHostModalService.openHostDeviceSelector(this.ctrl.objectId, function (resp) {
                var backing = _this.device.backing;
                backing.deviceName = resp.name;
                backing._type = _this.BACKING_ATAPI;
                _this.device.connectable.connected = true;
                _this.mutate();
            });
        };
        ;
        VmHardwareSummaryCdromController.prototype.browseForDatastoreIso = function () {
            var _this = this;
            this.selectIsoModalService.openIsoDeviceSelector(this.ctrl.objectId, function (resp) {
                var backing = _this.device.backing;
                backing.fileName = resp.path;
                backing._type = _this.BACKING_ISO;
                _this.device.connectable.connected = true;
                _this.mutate();
            });
        };
        ;
        VmHardwareSummaryCdromController.prototype.browseForContentLibraryIso = function () {
            var _this = this;
            var onCancel = function () { };
            this.dataService.getProperties(this.ctrl.objectId, ['resourcePool']).then(function (response) {
                var rpId = _this.defaultUriSchemeUtil.getVsphereObjectId(response.resourcePool);
                _this.contentLibraryIsoSelectorModalService.openContentLibraryIsoSelector(rpId, undefined, function (selectedIsoItem) {
                    var backing = _this.device.backing;
                    backing.fileName = selectedIsoItem.isoPath;
                    backing._type = _this.BACKING_ISO;
                    _this.device.connectable.connected = true;
                    _this.mutate();
                }, onCancel);
            });
        };
        ;
        VmHardwareSummaryCdromController.prototype.mutate = function () {
            var connection = {};
            var spec = new VirtualDeviceSpec();
            spec.device = this.device;
            spec.operation = 'edit';
            connection.deviceSpec = spec;
            this.mutationService.apply(this.ctrl.objectId, this.VM_DEVICE_CONNECTION_SPEC, connection);
        };
        VmHardwareSummaryCdromController.prototype.shouldRefetchISOItemType = function () {
            return !!this.device.backing &&
                (this.device.backing._type === this.BACKING_ISO) &&
                (this.getCurrentFileName() !== this.lastAccessedISOFile);
        };
        VmHardwareSummaryCdromController.prototype.resetLastAccessedISOBackingInfo = function () {
            this.lastAccessedISOFile = '';
            this.isContentLibraryIso = false;
        };
        VmHardwareSummaryCdromController.prototype.getCurrentFileName = function () {
            var backing = this.device.backing;
            return !!this.device && !!backing ? backing.fileName : '';
        };
        VmHardwareSummaryCdromController.prototype.hasPermission = function () {
            return (this.hasDeviceConnectionPriv && this.hasSetCdMediaPriv);
        };
        VmHardwareSummaryCdromController.prototype.hasPermissionAndConfigForCL = function () {
            return (this.hasPermission() &&
                this.hasCLConfig);
        };
        VmHardwareSummaryCdromController.prototype.getCurrentDeviceName = function () {
            var backing = this.device.backing;
            return !!this.device && !!backing ? backing.deviceName : '';
        };
        VmHardwareSummaryCdromController.prototype.fetchISOItemType = function () {
            var _this = this;
            if (this.isDeviceConnected()) {
                this.isLoading = true;
                this.contentLibraryService.getContentLibraryItemByDatastorePath(this.getCurrentFileName())
                    .then(function (isoItem) {
                    if (isoItem && isoItem.contentLibraryItemByDatastorePath &&
                        !_this.isoItemHasErrorMessage(isoItem)) {
                        _this.isContentLibraryIso = true;
                    }
                    else {
                        _this.resetLastAccessedISOBackingInfo(); //reset first
                    }
                    //set the filename also for the HOST ISO
                    _this.lastAccessedISOFile = _this.getCurrentFileName();
                }).then(function () {
                    _this.isLoading = false;
                });
            }
        };
        VmHardwareSummaryCdromController.prototype.isoItemHasErrorMessage = function (isoItem) {
            return isoItem.contentLibraryItemByDatastorePath &&
                Array.isArray(isoItem.contentLibraryItemByDatastorePath.errorMessages) &&
                isoItem.contentLibraryItemByDatastorePath.errorMessages.length > 0;
        };
        VmHardwareSummaryCdromController.prototype.getDeviceOrFile = function () {
            if (this.isLoading) {
                return {
                    title: this.i18n('VmUi', 'DeviceConnection.loading'),
                    value: this.i18n('VmUi', 'DeviceConnection.loading')
                };
            }
            if (this.device.backing) {
                if (this.getCurrentDeviceName()) {
                    return {
                        title: this.i18n('VmUi', 'DeviceConnection.manager.info.device'),
                        value: this.getCurrentDeviceName()
                    };
                }
                if (this.getCurrentFileName()) {
                    return {
                        title: this.i18n('VmUi', 'DeviceConnection.manager.info.file'),
                        value: this.getCurrentFileName()
                    };
                }
            }
        };
        ;
        VmHardwareSummaryCdromController.prototype.getOvfTemplateDeviceType = function () {
            var info = this.device.deviceInfo;
            var type = (info && info.type) ? info.type : '';
            var subType = (info && info.subType) ? info.subType : '';
            var typeStr = this.i18n('LibraryUi', 'vm.hardware.drive.type.' + type);
            var subTypeStr = this.i18n('LibraryUi', 'vm.hardware.drive.subType.' + subType);
            return typeStr + "/" + subTypeStr;
        };
        ;
        VmHardwareSummaryCdromController.prototype.getPermissions = function (items) {
            var _this = this;
            this.authorizationService.checkPrivileges(this.ctrl.objectId, items)
                .then(function (privilegesStatuses) {
                _this.hasDeviceConnectionPriv = privilegesStatuses[0];
                _this.hasSetCdMediaPriv = privilegesStatuses[1];
            });
        };
        VmHardwareSummaryCdromController.prototype.checkForCLConfig = function () {
            var _this = this;
            this.configurationService.getProperty('vmc.gateway.mode')
                .then(function (resp) {
                if (resp === 'true') {
                    _this.hasCLConfig = false;
                }
            });
        };
        VmHardwareSummaryCdromController.$inject = [
            'contentLibraryService',
            'i18nService',
            'selectIsoFileService',
            'contentLibraryIsoSelectorModalService',
            'selectHostModalService',
            'selectIsoModalService',
            'defaultUriSchemeUtil',
            'dataService',
            'authorizationService',
            'mutationService',
            'configurationService'
        ];
        return VmHardwareSummaryCdromController;
    }()); // VmHardwareSummaryCdromController
    angular.module("com.vmware.vsphere.client.vm").component("vmHardwareSummaryCdrom", new VmHardwareSummaryCdrom());
})(h5_vm || (h5_vm = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmHardwareSummaryEncryption = (function () {
        function VmHardwareSummaryEncryption() {
            this.templateUrl = "vm-ui/resources/vm/views/summary/vm-hardware-summary-encryption.html";
            this.controller = VmHardwareSummaryEncryptionController;
            this.bindings = {
                devices: "<",
            };
        }
        return VmHardwareSummaryEncryption;
    }());
    h5_vm.VmHardwareSummaryEncryption = VmHardwareSummaryEncryption; // VmHardwareSummaryPmem
    var VmHardwareSummaryEncryptionController = (function () {
        function VmHardwareSummaryEncryptionController(i18nService, vmCryptUtilService) {
            this.i18nService = i18nService;
            this.vmCryptUtilService = vmCryptUtilService;
        }
        VmHardwareSummaryEncryptionController.prototype.$onInit = function () {
            this.label = this.i18nService.getString("VmUi", "VmCryptConfig.encryptionLabel");
        };
        VmHardwareSummaryEncryptionController.prototype.$onChanges = function (changes) {
            if (!changes.devices) {
                return;
            }
            this.refreshContent();
        };
        VmHardwareSummaryEncryptionController.prototype.refreshContent = function () {
            this.vmConfigContent = this.i18nService.getString("VmUi", "VmCryptConfig.vmHomeEncrypted");
            var allDisksCount = this.devices[h5_vm.DeviceTypeConstants.VIRTUALDISK] ?
                this.devices[h5_vm.DeviceTypeConstants.VIRTUALDISK].length : 0;
            var encryptedDisksCount = this.getEncryptedDisksCount();
            if (encryptedDisksCount === 0) {
                this.disksContent =
                    this.i18nService.getString("VmUi", "VmCryptConfig.StatusDisksNone");
            }
            else if (allDisksCount === encryptedDisksCount) {
                if (allDisksCount === 1) {
                    this.disksContent =
                        this.i18nService.getString("VmUi", "VmCryptConfig.StatusDisks1Encrypted");
                }
                else {
                    this.disksContent =
                        this.i18nService.getString("VmUi", "VmCryptConfig.StatusDisksAll", allDisksCount);
                }
            }
            else {
                this.disksContent =
                    this.i18nService.getString("VmUi", "VmCryptConfig.StatusDisksSome", encryptedDisksCount, allDisksCount);
            }
        };
        VmHardwareSummaryEncryptionController.prototype.getEncryptedDisksCount = function () {
            var _this = this;
            return _.filter(this.devices[h5_vm.DeviceTypeConstants.VIRTUALDISK], function (device) {
                return _this.vmCryptUtilService.isExistingDiskEncrytped(device);
            }).length;
        };
        VmHardwareSummaryEncryptionController.$inject = [
            "i18nService",
            "vmCryptUtilService"
        ];
        return VmHardwareSummaryEncryptionController;
    }()); // VmHardwareSummaryEncryptionmController
    angular.module("com.vmware.vsphere.client.vm").component("vmHardwareSummaryEncryption", new VmHardwareSummaryEncryption());
})(h5_vm || (h5_vm = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmHardwareSummaryFloppy = (function () {
        function VmHardwareSummaryFloppy() {
            this.templateUrl = "vm-ui/resources/vm/views/summary/vm-hardware-summary-floppy.html";
            this.controller = VmHardwareSummaryFloppyController;
            this.bindings = {
                device: '=',
                ctrl: '='
            };
        }
        return VmHardwareSummaryFloppy;
    }());
    h5_vm.VmHardwareSummaryFloppy = VmHardwareSummaryFloppy; // VmHardwareSummaryFloppy
    var VmHardwareSummaryFloppyController = (function () {
        function VmHardwareSummaryFloppyController(contentLibraryService, i18nService, defaultUriSchemeUtil, dataService, authorizationService, mutationService) {
            this.contentLibraryService = contentLibraryService;
            this.i18nService = i18nService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.authorizationService = authorizationService;
            this.mutationService = mutationService;
            this.BACKING_FLOPPY_HOST_IMAGE = 'com.vmware.vim.binding.vim.vm.device.VirtualFloppy$ImageBackingInfo';
            this.BACKING_FLOPPY_HOST_FLOPPY_DEVICE = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$DeviceBackingInfo';
            this.BACKING_FLOPPY_REMOTE_CLIENT_DEVICE = 'com.vmware.vim.binding.vim.vm.device.VirtualCdrom$RemoteDeviceBackingInfo';
            this.i18n = i18nService.getString;
        }
        VmHardwareSummaryFloppyController.prototype.$onInit = function () {
            var deviceInfo = this.device.deviceInfo;
            this.label = (this.device || deviceInfo) ? deviceInfo.label : '';
        };
        VmHardwareSummaryFloppyController.prototype.getDeviceConnected = function () {
            var connKey = this.isDeviceConnected() ? 'connected' : 'disconnected';
            return this.i18n('VmUi', 'DeviceConnection.' + connKey);
        };
        ;
        VmHardwareSummaryFloppyController.prototype.isDeviceConnected = function () {
            return this.device.connectable && this.device.connectable.connected;
        };
        ;
        VmHardwareSummaryFloppyController.prototype.getConnectedTo = function () {
            if (this.ctrl && this.ctrl.isVmTemplateCLitem) {
                var deviceInfo = this.device.deviceInfo;
                return this.i18n('LibraryUi', 'vm.hardware.floppy.type.' + deviceInfo.type);
            }
            if (this.isLoading) {
                return this.i18n('VmUi', 'DeviceConnection.loading');
            }
            switch (this.device.backing._type) {
                case this.BACKING_FLOPPY_HOST_IMAGE:
                    return this.i18n('VmUi', 'DeviceConnection.manager.info.host_image_file');
                case this.BACKING_FLOPPY_HOST_FLOPPY_DEVICE:
                    return this.i18n('VmUi', 'DeviceConnection.manager.info.host_floppy_device');
                case this.BACKING_FLOPPY_REMOTE_CLIENT_DEVICE:
                    return this.i18n('VmUi', 'DeviceConnection.manager.info.remote_client_device');
                default:
                    return this.i18n('VmUi', 'DeviceConnection.manager.unknown_device');
            }
        };
        ;
        VmHardwareSummaryFloppyController.prototype.getCurrentFileName = function () {
            var backing = this.device.backing;
            return !!this.device && !!backing ? backing.fileName : '';
        };
        VmHardwareSummaryFloppyController.prototype.getCurrentDeviceName = function () {
            var backing = this.device.backing;
            return !!this.device && !!backing ? backing.deviceName : '';
        };
        VmHardwareSummaryFloppyController.prototype.getDeviceOrFile = function () {
            if (this.ctrl && this.ctrl.isVmTemplateCLitem) {
                var deviceInfo = this.device.deviceInfo;
                return this.i18n('LibraryUi', 'vm.hardware.floppy.type.' + deviceInfo.type);
            }
            if (this.isLoading) {
                return this.i18n('VmUi', 'DeviceConnection.loading');
            }
            if (this.device.backing) {
                if (this.getCurrentDeviceName()) {
                    return {
                        title: this.i18n('VmUi', 'DeviceConnection.manager.info.device'),
                        value: this.getCurrentDeviceName()
                    };
                }
                if (this.getCurrentFileName()) {
                    return {
                        title: this.i18n('VmUi', 'DeviceConnection.manager.info.file'),
                        value: this.getCurrentFileName()
                    };
                }
            }
        };
        ;
        VmHardwareSummaryFloppyController.$inject = [
            'contentLibraryService',
            'i18nService',
            'selectIsoFileService',
            'contentLibraryIsoSelectorModalService',
            'selectHostModalService',
            'defaultUriSchemeUtil',
            'dataService',
            'authorizationService',
            'mutationService'
        ];
        return VmHardwareSummaryFloppyController;
    }()); // VmHardwareSummaryFloppyController
    angular.module("com.vmware.vsphere.client.vm").component("vmHardwareSummaryFloppy", new VmHardwareSummaryFloppy());
})(h5_vm || (h5_vm = {}));



/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';

   angular
      .module('com.vmware.vsphere.client.vm')
      .controller('VmHardwareSummaryController', VmHardwareSummaryController);

   VmHardwareSummaryController.$inject = [
      '$scope',
      'dataService',
      'i18nService',
      'actionsService',
      'feedbackService',
      'deviceOrganizer',
      'vmDeviceInfoService',
      'logService',
      'ovfTemplateHardwareDataMapping',
      'pmemUtilService',
      'vmCryptUtilService',
      'defaultUriSchemeUtil',
      '$q',
      'managedEntityConstants',
      'diskBackingInfoConstants'
   ];

   function VmHardwareSummaryController (
      $scope,
      dataService,
      i18nService,
      actionsService,
      feedbackService,
      deviceOrganizer,
      vmDeviceInfoService,
      logService,
      ovfTemplateHardwareDataMapping,
      pmemUtilSevice,
      vmCryptUtilService,
      defaultUriSchemeUtil,
      $q,
      managedEntityConstants,
      diskBackingInfoConstants
   ) {
      var self = this;
      var objectId = $scope._route.objectId;

      self.liveRefreshProperties = [
         'config.hardware.numCPU',
         'config.hardware.memoryMB',
         'config.hardware.device',
         'config.version'
      ];

      self.watchObjects = [ objectId ];

      self.objectId = objectId;
      self.isEncryptionSummaryVisible = false;
      self.isPmemSummaryVisible = false;
      self.displayHardDiskDevices = [];

      // Flag to re-use this VM hardware summary portlet for Content Library ovf templates
      self.isVmTemplateCLitem = (objectId.indexOf("urn:vapi:com.vmware.content.library.Item") === 0);

      var editSettingsLabel = i18nService.getString('VmUi', 'actionLabelEditSettings');
      var editSettingsAriaLabel = i18nService.getString('VmUi', 'actionDescEditSettings');

      if ($scope.portlet) {
         if (self.isVmTemplateCLitem) {
            $scope.portlet.footerLinks = null;
         } else {
            actionsService.getAction("vsphere.core.vm.editSettingsAction", [ objectId ])
                  .then(function (action) {
                     var linkEnabled = !!action && !!action.available;
                     self.editAction = action && action.available ? action : undefined;
                     $scope.portlet.footerLinks = [{
                        label: editSettingsLabel,
                        ariaLabel: editSettingsAriaLabel,
                        onClick: self.invokeEditAction,
                        enabled: linkEnabled
                     }];
                  });
         }
      }

      self.invokeEditAction = function (event) {
         if (event) {
            event.stopPropagation();
            event.preventDefault();
         }
         return self.editAction ? actionsService.invokeAction(self.editAction) : null;
      };

      self.getVmHardwareData = function () { return getVMId().then(function (vmId) { getVMHardwareViewData(vmId); }); };
      self.getVmHardwareData();

      self.getGroupedDiskText = function() {
         return i18nService.getString('VmUi', 'summaryView.groupedDisks.value', self.totalHardDiskCount);
      };

      function getVMId() {
         if (self.isVmTemplateCLitem) {
            var TYPE_PROPERTY = 'type';
            var MOR_ID_OF_VMTX_PROPERTY = 'morIdOfVmtx';

            return dataService.getProperties(self.objectId, [ TYPE_PROPERTY, MOR_ID_OF_VMTX_PROPERTY ])
                  .then(function(response) {
                     if (response && response[TYPE_PROPERTY] === managedEntityConstants.VM_TEMPLATE) {
                        var vmtxItemMor = response[MOR_ID_OF_VMTX_PROPERTY];
                        var vmId = defaultUriSchemeUtil.createVmomiUri(vmtxItemMor.type,
                              vmtxItemMor.value, vmtxItemMor.serverGuid);
                        self.isVmTemplateCLitem = false;
                        if (!self.watchObjects.includes(vmId)) {
                           self.watchObjects.push(vmId);
                        }
                        return $q.resolve(vmId);
                     }

                     return $q.resolve(self.objectId);
                  });
         }

         return $q.resolve(self.objectId);
      }

      function getVMHardwareViewData (vmId) {
         var log = logService('VmHardwareSummaryController');
         var dataModel = self.isVmTemplateCLitem ?
               'com.vmware.vsphere.client.library.h5model.OvfTemplateHardwareData' :
               'com.vmware.vsphere.client.vm.model.HardwareViewData';

         dataService
             .getData(vmId, dataModel,
                     {queryName: 'VmHardwareSummaryController.' + getVMHardwareViewData.name})
            .then(function(hardwareViewData) {
               if (self.isVmTemplateCLitem) {
                  if(hardwareViewData.isVappTemplate) {
                     hardwareViewData = null;
                     return;
                  }
                  hardwareViewData =
                        ovfTemplateHardwareDataMapping.convertOvfTemplateHardwareData(hardwareViewData);
               }
               self.hardwareViewData = hardwareViewData;
               if (hardwareViewData.hardware) {
                  var devices = hardwareViewData.hardware.device;

                  var devicesToDisplay = _.reject(devices, function(device){
                     // Hide devices which are not marshalled correctly to avoid displaying this error in the UI
                     // ** FIX ME device.VirtualDevice.label (vm.vmsg)
                     // TODO remove this once VMODL is stable in order to make errors more obvious to QA?
                    var rejectDevice = vmDeviceInfoService.isDeviceInstanceOf(device, 'VirtualDevice');

                     if(rejectDevice) {
                        log.error('Invalid device (unstable VMODL between ESX and VC?): ' + JSON.stringify(device));
                     }

                     return rejectDevice;
                  });

                  devicesToDisplay = _.filter(devicesToDisplay, function(device) {
                     return device._type !== "com.vmware.vim.binding.vim.vm.device.VirtualTPM";
                  });

                  self.devices = deviceOrganizer.groupAndSortDevices(devicesToDisplay);

                  var allVirtualDisks = self.devices['VirtualDisk'];

                  var allDisks = _.partition(self.devices['VirtualDisk'], function(disk) {
                     return !isRDMDisk(disk);
                  });

                  var allHardDisks = allDisks && allDisks[0] ? allDisks[0] : [];
                  var allRdmDisks = allDisks && allDisks[1] ? allDisks[1] : [];


                  self.shouldGroupHardDisks = allVirtualDisks ? allVirtualDisks.length > 2 : false;
                  self.totalHardDiskCount = allVirtualDisks ? allVirtualDisks.length : 0;

                  //reset first
                  self.displayHardDiskDevices = [];
                  self.displayRdmDiskDevices = [];

                  if (self.shouldGroupHardDisks) {
                     //just add the first one per UX spec
                     if (allHardDisks.length) {
                        self.displayHardDiskDevices.push(allHardDisks[0]);
                     } else {
                        self.displayRdmDiskDevices.push(allRdmDisks[0]);
                     }
                  } else {
                     self.displayHardDiskDevices = allHardDisks;
                     self.displayRdmDiskDevices = allRdmDisks;
                  }

                  var tpmDevice = _.filter(devices, function(device) {
                     return device._type === "com.vmware.vim.binding.vim.vm.device.VirtualTPM";
                  });

                  if (tpmDevice && tpmDevice.length > 0) {
                     self.tpmDevice = tpmDevice[0];
                  } else {
                     self.tpmDevice = null;
                  }

                  self.isPmemSummaryVisible = isPmemSummaryVisibile(self.devices);
                  self.isEncryptionSummaryVisible =
                     !vmCryptUtilService.isCryptoKeyEmpty(hardwareViewData.cryptoKeyId);
               } else {
                  // temporary debug message to understand how hardware can be null here for many users
                  // See http://h5-feedbackportal.eng.vmware.com:3000/feedback?errlist=1&id=b079aa4c
                  feedbackService.sendDebugMessage('null hardwareViewData.hardware in VmHardwareSummaryController!', hardwareViewData);
               }
            });
      }

      function isPmemSummaryVisibile(devices) {
         if (!_.isEmpty(self.devices['VirtualNVDIMM'])) {
            return true;
         }

         return _.some(devices['VirtualDisk'], function(device) {
            return pmemUtilSevice.isPmemDisk(device);
         });
      }

      function isRDMDisk(diskDevice) {
         return diskDevice && diskDevice.backing._type ===
               diskBackingInfoConstants.RAWDISKMAPPING;
      }
   }
})();

angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryCpu', ['i18nService', function (i18nService) {
   return {
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryCpu.html',
      scope: {
         ctrl: '='
      },
      link: function(scope) {
         scope.i18n = i18nService.getString;
         scope.fieldLabel = function (key) {
            return i18nService.getString('VmUi', key);
         };
         scope.isTemplate = scope.ctrl.hardwareViewData.memoryData.isVmTemplate;
         scope.$watch('ctrl.hardwareViewData.cpuAllocation', function(cpuAllocation) {
            if (!cpuAllocation) {
               return;
            }

            setFieldValues(scope);
            scope.fields = _.keys(scope.fieldValue);
         });

         function formatLimitForDisplay(limit) {
            if (limit < 0) {
               return scope.i18n('VmUi', 'labelUnlimited');
            } else {
               return scope.i18n('VmUi', 'cpuReservationLimit', limit);
            }
         }

         function formatEnabledDisabled(boolean) {
            if (boolean) {
               return scope.i18n('VmUi', 'VmCpuView.Enabled');
            } else {
               return scope.i18n('VmUi', 'VmCpuView.Disabled');
            }
         }

         function setFieldValues(scope) {
            var data = scope.ctrl.hardwareViewData;
            var utilization = scope.i18n('VmUi', 'numCpuUtilization', data.hardware.numCPU,
               data.cpuUtilization);
            var configured = scope.i18n('VmUi', 'numCpu', data.hardware.numCPU);
            var cpuHotPlug = scope.i18n('VmUi', 'VmCpu.Label.CpuHotPlug');
            var reservation = scope.i18n('VmUi', 'cpuReservationLimit', data.cpuAllocation.reservation);
            var limit = formatLimitForDisplay(data.cpuAllocation.limit);
            var shares = scope.ctrl.isVmTemplateCLitem ? data.cpuAllocation.shares :
                  scope.i18n('VmUi', 'sharesAndType', data.cpuAllocation.shares.shares,
                  scope.i18n('VmUi', 'sharesInfoLevel.' + data.cpuAllocation.shares.level));

            scope.fieldValue = {
               ConfiguredCPU: configured,
               Utilization: utilization,
               Reservation: reservation,
               Limit: limit,
               NestedHV: formatEnabledDisabled(data.hardwareVirtualization),
               IommuHV: formatEnabledDisabled(data.vvtdEnabled),
               PerfCounters: formatEnabledDisabled(data.performanceCounters),
               CpuHotPlug: cpuHotPlug,
               Shares: shares
            };
         }
      }
   };
}]);
angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryHwVersion', ['i18nService',
   'vmHardwareVersionService', function (i18nService, vmHardwareVersionService) {
   return {
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryHwVersion.html',
      scope: {
         ctrl: '='
      },
      link: function(scope) {
         scope.vmHwVersionLabel = i18nService.getString('VmUi', 'VmHardwareView.HWVersion');

         scope.$watch('ctrl.hardwareViewData', function(hwData) {
            var vmVersion = hwData.vmVersion;
            scope.vmHwVersion = vmHardwareVersionService.getLongText(vmVersion);

            var scheduledUpgradeData = vmHardwareVersionService.getScheduledUpgradeData(hwData);
            scope.hasScheduledUpgrade = !!scheduledUpgradeData.status;
            scope.scheduledUpgradeStatus = scheduledUpgradeData.status;
            scope.scheduledUpgradeError = scheduledUpgradeData.error;
         });
      }
   };
}]);

angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryMemory',
      ['$filter', 'i18nService', 'feedbackService', function ($filter, i18nService, feedbackService) {
   return {
      scope: {
         ctrl: '='
      },
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryMemory.html',
      link: function (scope) {
         scope.i18n = i18nService.getString;
         scope.fieldLabel = function (field) {
            return scope.i18n('VmUi', 'label' + field);
         };

         scope.isTemplate = scope.ctrl.hardwareViewData.memoryData.isVmTemplate;
         var isVmTemplateCLitem = scope.ctrl.isVmTemplateCLitem;

         scope.$watch('ctrl.hardwareViewData', function (data) {
            if (!data || !data.hardware) {
               return;
            }
            var bytesFilter = $filter('bytes');
            scope.memoryUtilizationPercentage = Math.round(data.memoryData.memoryUtilization / data.hardware.memoryMB * 100);
            if (scope.memoryUtilizationPercentage > 100) {
               scope.memoryUtilizationPercentage = 100;
            }
            var configuredMemory = scope.i18n('VmUi', 'memValue', data.hardware.memoryMB);
            var utilization = isVmTemplateCLitem ? "" :
               scope.i18n('VmUi', 'h5memValueUtilization', bytesFilter(data.hardware.memoryMB, 'MB', 'GB'),
                  bytesFilter(data.memoryData.memoryUtilization, 'MB', 'GB'));
            var shares = isVmTemplateCLitem ? data.memoryData.memoryAllocation.shares :
               scope.i18n('VmUi', 'sharesAndType', data.memoryData.memoryAllocation.shares.shares,
                  scope.i18n('VmUi', 'sharesInfoLevel.' + data.memoryData.memoryAllocation.shares.level));
            var reservation = scope.i18n('VmUi', 'memValue', data.memoryData.memoryAllocation.reservation);
            var limit = data.memoryData.memoryAllocation.limit < 0 ? scope.i18n('VmUi', 'labelUnlimited') :
               data.memoryData.memoryAllocation.limit;
            var hostOverhead = scope.i18n('VmUi', 'memValue', data.memoryData.overheadMemory);

            scope.fieldValue = {
               ConfiguredMemory: configuredMemory,
               Utilization: utilization,
               Shares: shares,
               Reservation: reservation,
               Limit: limit,
               HostOverhead: hostOverhead
            };

            scope.fields = _.keys(scope.fieldValue);
         });
      }
   };
}]);

angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryNetwork', [
   'dataService',
   'vmDeviceInfoService',
   'i18nService',
   'scopeUtil',
   'defaultUriSchemeUtil',
   'navigation',
   function (dataService, vmDeviceInfoService, i18nService, scopeUtil, defaultUriSchemeUtil, navigation) {
   return {
      scope: {
         device: '=',
         ctrl: '='
      },
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryNetwork.html',
      link: function (scope) {
         var DISTRIBUTED_PORTGROUP_BACKING_TYPE =
               'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$DistributedVirtualPortBackingInfo';
         var OPAQUE_NETWORK_BACKING_TYPE =
               'com.vmware.vim.binding.vim.vm.device.VirtualEthernetCard$OpaqueNetworkBackingInfo';

         scope.i18n = i18nService.getString;
         scope.isTemplate = scope.ctrl.hardwareViewData.memoryData.isVmTemplate;
         scope.ethernetCardLabel = vmDeviceInfoService.getEthernetCardLabel(scope.device._type);
         navigation.populateScope(scope);

         scope.$watch('device', function() {
            setNetworkProperties(scope.device.backing);
         });

         if (!scope.ctrl.isVmTemplateCLitem) {
            scopeUtil.watchUntilTrue(scope, 'expanded', function () {
               var vmId = defaultUriSchemeUtil.getVsphereObjectId(scope.ctrl.hardwareViewData.provider);

               dataService.getProperties(vmId, 'runtime').then(function (vmProperties) {
                  var deviceRuntimeData = _.find(vmProperties.runtime.device, function (d) {
                     return d.key === scope.device.key;
                  });
                  if (deviceRuntimeData) {
                     scope.directpathEnabled = deviceRuntimeData.runtimeState.vmDirectPathGen2Active;
                  }
               });
            });
         }

         scope.labelForConnectionState = function () {
            if (!scope.device.connectable) {
               return;
            }
            var connectionLabel = i18nService.getString('VmUi', scope.device.connectable.connected ?
                  'VmHardwareView.deviceConnected' :
                  'VmHardwareView.deviceDisconnected');
            return i18nService.getString('VmUi', 'VmNetView.networkConnection', connectionLabel);
         };

         function setNetworkProperties(deviceBacking) {
            if (!deviceBacking) {
               scope.networkName = "";
               scope.networkRef = null;
            }
            var selectedNetworkData;
            if (deviceBacking._type === DISTRIBUTED_PORTGROUP_BACKING_TYPE) {
               selectedNetworkData = _.find(scope.ctrl.hardwareViewData.dvPortGroupData, function (dvPortGroupData) {
                  return dvPortGroupData.key === deviceBacking.port.portgroupKey;
               });
            } else if (deviceBacking._type === OPAQUE_NETWORK_BACKING_TYPE) {
               selectedNetworkData =
                     _.find(scope.ctrl.hardwareViewData.opaqueNetworkData, function (opaqueNetworkData) {
                        return opaqueNetworkData.opaqueNetworkType === deviceBacking.opaqueNetworkType &&
                              opaqueNetworkData.opaqueNetworkId === deviceBacking.opaqueNetworkId;
                     });
            } else {
               scope.networkName = scope.device.deviceInfo.summary;
               scope.networkRef = defaultUriSchemeUtil.getVsphereObjectId(deviceBacking.network);
            }
            if (selectedNetworkData) {
               scope.networkName = selectedNetworkData.name;
               scope.networkRef = defaultUriSchemeUtil.getVsphereObjectId(selectedNetworkData.provider);
            }
            if (scope.ctrl.isVmTemplateCLitem) {
               scope.connectOnStart = scope.device.startConnected;
            }
         }
      }
   };
}]);

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmHardwareSummaryNvdimm = (function () {
        function VmHardwareSummaryNvdimm() {
            this.templateUrl = "vm-ui/resources/vm/views/summary/vmHardwareSummaryNvdimm.html";
            this.controller = VmHardwareSummaryNvdimmController;
            this.bindings = {
                device: "<"
            };
        }
        return VmHardwareSummaryNvdimm;
    }());
    h5_vm.VmHardwareSummaryNvdimm = VmHardwareSummaryNvdimm; // VmHardwareSummaryNvdimm
    var VmHardwareSummaryNvdimmController = (function () {
        function VmHardwareSummaryNvdimmController(bytesFilter) {
            this.bytesFilter = bytesFilter;
        }
        VmHardwareSummaryNvdimmController.prototype.$onInit = function () {
            this.label = this.device.deviceInfo.label;
            this.content = this.getContent();
        };
        VmHardwareSummaryNvdimmController.prototype.getContent = function () {
            return this.bytesFilter(this.device.capacityInMB, "MB");
        };
        VmHardwareSummaryNvdimmController.prototype.$onChanges = function (changesObj) {
            var deviceChange = changesObj["device"];
            if (!deviceChange || deviceChange.isFirstChange()) {
                return;
            }
            this.content = this.getContent();
        };
        VmHardwareSummaryNvdimmController.$inject = [
            "bytesFilter"
        ];
        return VmHardwareSummaryNvdimmController;
    }()); // VmHardwareSummaryNvdimmController
    angular.module("com.vmware.vsphere.client.vm").component("vmHardwareSummaryNvdimm", new VmHardwareSummaryNvdimm());
})(h5_vm || (h5_vm = {}));



angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryOther', ['i18nService', function (i18nService) {
   return {
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryOther.html',
      scope: {
         ctrl: '=',
         devices: '='
      },
      link: function(scope) {
         scope.i18n = i18nService.getString;

         scope.getSummaryText = function (device, type) {
            var summary = device.deviceInfo.summary;
            var label = device.deviceInfo.label;
            var deviceType = device._type;

            if (deviceType === 'com.vmware.vim.binding.vim.vm.device.VirtualKeyboard' ||
                deviceType === 'com.vmware.vim.binding.vim.vm.device.VirtualPointingDevice') {
               return label;
            } else if (type === 'InputDevice') {
               return summary;
            } else {
               return (summary === label) ? summary :
                     summary ? label + ' (' + summary + ')' : label;
            }
         };
      }
   };
}]);

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmHardwareSummaryPmem = (function () {
        function VmHardwareSummaryPmem() {
            this.templateUrl = "vm-ui/resources/vm/views/summary/vmHardwareSummaryPmem.html";
            this.controller = VmHardwareSummaryPmemController;
            this.bindings = {
                devices: "<",
            };
        }
        return VmHardwareSummaryPmem;
    }());
    h5_vm.VmHardwareSummaryPmem = VmHardwareSummaryPmem; // VmHardwareSummaryPmem
    var VmHardwareSummaryPmemController = (function () {
        function VmHardwareSummaryPmemController(bytesFilter, i18nService, pmemUtilService) {
            this.bytesFilter = bytesFilter;
            this.i18nService = i18nService;
            this.pmemUtilService = pmemUtilService;
        }
        VmHardwareSummaryPmemController.prototype.$onInit = function () {
            this.label = this.i18nService.getString("VmUi", "VmHardwareSummaryView.PMem");
            this.content = this.getContent();
        };
        VmHardwareSummaryPmemController.prototype.getContent = function () {
            return this.bytesFilter(this.getTotalMemoryInKb(), "KB");
        };
        VmHardwareSummaryPmemController.prototype.$onChanges = function (changesObj) {
            var devicesChange = changesObj["devices"];
            if (!devicesChange || devicesChange.isFirstChange()) {
                return;
            }
            this.content = this.getContent();
        };
        VmHardwareSummaryPmemController.prototype.getTotalMemoryInKb = function () {
            var _this = this;
            if (_.isEmpty(this.devices)) {
                return 0;
            }
            var capacityInKb = 0;
            _.each(this.devices["VirtualNVDIMM"], function (device) {
                capacityInKb += (device.capacityInMB * 1024);
            });
            _.each(this.devices["VirtualDisk"], function (disk) {
                if (_this.pmemUtilService.isPmemDisk(disk)) {
                    capacityInKb += disk.capacityInKB;
                }
            });
            return capacityInKb;
        };
        VmHardwareSummaryPmemController.$inject = [
            "bytesFilter",
            "i18nService",
            "pmemUtilService"
        ];
        return VmHardwareSummaryPmemController;
    }()); // VmHardwareSummaryPmemController
    angular.module("com.vmware.vsphere.client.vm").component("vmHardwareSummaryPmem", new VmHardwareSummaryPmem());
})(h5_vm || (h5_vm = {}));



/**
 * Created by vmware on 12/2/16.
 */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
      .component('vmHardwareSummaryVideoCard', {
         bindings: {
            device: '<'
         },
         templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryVideoCard.html',
         controller: VmHardwareSummaryVideoCardController
      });

   VmHardwareSummaryVideoCardController.$inject = [
      'i18nService'
   ];

   function VmHardwareSummaryVideoCardController(i18nService) {
      this.i18n = i18nService.getString;
   }
})();

angular.module('com.vmware.vsphere.client.vm').directive('vmHardwareSummaryVirtualDisk',
   ['i18nService', 'dataService', 'scopeUtil', 'defaultUriSchemeUtil', 'navigation',
    'pmemUtilService', 'vmCryptUtilService',
   function (i18nService, dataService, scopeUtil, defaultUriSchemeUtil, navigation,
             pmemUtilService, vmCryptUtilService) {
   return {
      templateUrl: 'vm-ui/resources/vm/views/summary/vmHardwareSummaryVirtualDisk.html',
      scope: {
         device: '=',
         ctrl: '='
      },
      link: function (scope) {
         scope.i18n = i18nService.getString;
         scope.deviceLabel = scope.device.deviceInfo.label;

         navigation.populateScope(scope);

         // PMem
         scope.$watch(function() { return scope.device.backing.datastore; }, function() {
            var datastore = scope.device.backing.datastore;
            if (datastore) {
               scope.datastoreRef = defaultUriSchemeUtil.getVsphereObjectId(datastore);
               scope.datastoreInfo = getDatastoreInfo(scope.datastoreRef, scope.ctrl.hardwareViewData.datastoreInfo);
               scope.isPmemDisk = pmemUtilService.isPmemDisk(scope.device);
            }
         });

         // Encryption status
         refreshEncryptionStatus(scope.device);
         scope.$watch(function() { return scope.device.backing; }, function(newValue, oldValue) {
            if (newValue === oldValue) {
               return;
            }

            refreshEncryptionStatus(scope.device);
         });

         function refreshEncryptionStatus(device) {
            scope.deviceLabel = vmCryptUtilService.isExistingDiskEncrytped(device)
               ? i18nService.getString('VmUi', 'VmDiskView.encryptedDiskLabel', device.deviceInfo.label)
               : device.deviceInfo.label;
         }

         function getDatastoreInfo(datastoreRef, datastoreInfos) {
            return _.find(datastoreInfos, function (info) {
               return defaultUriSchemeUtil.getVsphereObjectId(info.provider) === datastoreRef;
            });
         }
      }
   };
}]);

angular.module('com.vmware.vsphere.client.vm').directive('vmSummaryImage', [
   'i18nService',
   'actionsService',
   'featureFlagsService',
   'dataService',
   'persistenceService',
   'clarityModalService',
   function (i18nService, actionsService, featureFlagsService, dataService, persistenceService, clarityModalService) {
      return {
         templateUrl: 'vm-ui/resources/vm/views/summary/vmSummaryImage.html',
         link: function (scope) {
            var vmId = scope.entityReference;
            scope.screenshotInProgress = false;

            scope.i18n = i18nService.getString;
            scope.featureFlagsService = featureFlagsService;
            scope.launchConsoleActionEval = null;

            scope.getVmScreenshot = getVmScreenshot;
            scope.imageBytes = getBlackImage();

            var PROPERTY_DEFAULT_CONSOLE = "com.vmware.usersettings.defaultConsole";
            var ACTION_OPEN_CONSOLE = "vsphere.core.vm.actions.openConsole";
            var ACTION_LAUNCH_REMOTE_CONSOLE = "vsphere.core.vm.actions.launchRemoteConsole";
            var ACTION_DOWNLOAD_VMRC = "vsphere.core.vm.actions.downloadVMRC";

            scope.$watch('summaryData', function (newValue, oldValue) {
               angular.extend(scope, params(scope.summaryData, scope.i18n));

               if (!scope.launchConsoleActionEval || newValue !== oldValue) {
                  if (angular.isDefined(newValue.isTemplate) && !newValue.isTemplate) {
                     evaluateLaunchRemoteConsole();
                  }

                  if(oldValue.powerState !== newValue.powerState) {
                     if(newValue.powerState === 'poweredOff') {
                        scope.imageBytes = null;
                     } else {
                        getVmScreenshot();
                     }
                  }
               }
            }, true);

            scope.signPostContentTemplate = '<div class="locked-vm-signpost-content">' +
                  i18nService.getString('VmUi', 'summaryView.unlockVm.signpost.text') +
                  '</div>';

            getVmScreenshot();

            scope.vmrcInfoSignPostParams = {
               message: i18nService.getString('VmUi', 'summaryView.downloadVMRCPlayer.tooltip'),
               title: i18nService.getString('Common', 'help'),
               linkLabel: i18nService.getString('VmUi', 'summaryView.downloadVMRCPlayer'),
               linkFunction: downloadVmrcClicked
            };

            scope.launchVmrcInfoSignPostParams = {
               message: i18nService.getString('VmUi', 'summaryView.launchVMRCConsoleInfo.text'),
               title: i18nService.getString('VmUi', 'summaryView.launchVMRCConsole'),
               linkLabel: i18nService.getString('VmUi', 'summaryView.downloadVMRCPlayer'),
               linkFunction: downloadVmrcClicked
            };

            scope.itemClicked = function (targetId) {

               var conditionObj = {
                  key: 'uid',
                  op: '=',
                  value: PROPERTY_DEFAULT_CONSOLE
               };

               persistenceService.getData(conditionObj).then(function (data) {
                  var consolePreferencesData = data[0];
                  if (consolePreferencesData
                     && consolePreferencesData.value
                     && consolePreferencesData.value.defaultConsole) {
                        var consoleType = consolePreferencesData.value.defaultConsole;
                     if (consoleType === "WEB_CONSOLE") {
                        scope.launchWebConsole();
                     } else {
                        scope.launchVMRCConsole();
                     }
                  } else {
                        clarityModalService.openOkCancelModal({
                           contentTemplate: 'vm-ui/resources/vm/views/summary/modals/select-default-console/SelectConsoleDialog.html',
                           title: i18nService.getString('VmUi', 'launchConsoleModal.title'),
                           dialogData: {
                              vmId: targetId
                           }
                        });
                  }
               });
            };

            scope.unlockVmClicked = function (targetId) {
               actionsService.getAction("vsphere.core.vm.actions.cryptoUnlock", [targetId])
                  .then(function (action) {
                     actionsService.invokeAction(action);
                  });
            };

            scope.unlockVmClicked = function (targetId) {
               actionsService.getAction("vsphere.core.vm.actions.cryptoUnlock", [targetId])
                  .then(function (action) {
                     actionsService.invokeAction(action);
                  });
            };

            scope.launchVMRCConsole = function () {
               actionsService.getAction(ACTION_LAUNCH_REMOTE_CONSOLE, [vmId])
                  .then(function(action) {
                     actionsService.invokeAction(action);
                  });
            };

            scope.launchWebConsole = function () {
               actionsService.getAction(ACTION_OPEN_CONSOLE, [vmId])
                  .then(function(action) {
                     actionsService.invokeAction(action);
                  });
            };

            function getVmScreenshot() {
               if (scope.screenshotInProgress) {
                  return;
               }

               scope.screenshotInProgress = true;
               dataService.getProperties(scope.entityReference, ["vmScreenshot"], {
                  propertyParams: [{
                     propertyName: "vmScreenshot",
                     parameterType: "com.vmware.vsphere.client.vm.screenshot.VmScreenshotSize",
                     parameter: {
                        width: 160,
                        height: 120
                     }
                  }]
               }).then(function (response) {
                  var vmScreenshot = response["vmScreenshot"];
                  if (!_.isEmpty(vmScreenshot)) {
                     scope.imageBytes = vmScreenshot;
                  }
               }).then(function () {
                  scope.screenshotInProgress = false;
               });
            }

            function evaluateLaunchRemoteConsole() {
               actionsService.getAction("vsphere.core.vm.actions.launchRemoteConsole", [vmId])
                     .then(function(action) {
                        scope.launchConsoleActionEval = action;
                     });
            }

            function downloadVmrcClicked() {
               actionsService.getAction("vsphere.core.vm.actions.downloadVMRC")
                  .then(function (action) {
                     actionsService.invokeAction(action);
                  });
            }

            function getBlackImage() {
               return "R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
            }
         }
      };

      function params(model, i18n) {
         var imageCaption, imageCaptionIcon, stateLabel, isWebConsoleAvailable;
         if (!model.powerState || model.isTemplate) {
            return;
         }

         switch (model.powerState) {
            case 'poweredOn' :
               isWebConsoleAvailable = true;
               imageCaption = i18n('VmUi', 'VmImage.poweredOn');
               imageCaptionIcon = 'icon-vSphere-vmPowerOn';
               break;
            case 'poweredOff' :
               stateLabel = i18n('VmUi', 'VmImage.poweredOff');
               isWebConsoleAvailable = false;
               break;
            case 'suspended' :
               imageCaption = i18n('VmUi', 'VmImage.suspended');
               imageCaptionIcon = 'icon-vSphere-vmSuspend';
               isWebConsoleAvailable = false;
               break;
         }

         return {
            isWebConsoleAvailable: isWebConsoleAvailable,
            stateLabel: stateLabel,
            imageCaption: imageCaption,
            imageCaptionIcon: imageCaptionIcon
         };
      }
   }
]);

var h5_vm;
(function (h5_vm) {
    var VmTpmController = (function () {
        function VmTpmController($rootScope, vmTpmService, i18nService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.vmTpmService = vmTpmService;
            this.i18nService = i18nService;
            this.i18n = i18nService.getString;
            this.vmTpmService.getCertificates(this.vmId)
                .then(function (result) {
                _this.tpmCertificates = result;
            });
        }
        VmTpmController.prototype.navigateToConfigureTab = function () {
            this.$rootScope._navigateToViewAndObject('vsphere.core.vm.manage.settings.tpmCertificatesView', this.vmId);
        };
        VmTpmController.$inject = ['$rootScope', 'vmTpmService', 'i18nService'];
        return VmTpmController;
    }());
    h5_vm.VmTpmController = VmTpmController;
    var VmTpmComponent = (function () {
        function VmTpmComponent() {
            this.controller = VmTpmController;
            this.templateUrl = "vm-ui/resources/vm/views/summary/vmTpm/vm-tpm.html";
            this.bindings = {
                vmId: "<",
                label: "<"
            };
        }
        return VmTpmComponent;
    }());
    h5_vm.VmTpmComponent = VmTpmComponent;
    angular.module("com.vmware.vsphere.client.vm")
        .component("vmTpm", new VmTpmComponent());
})(h5_vm || (h5_vm = {}));



var h5_vm;
(function (h5_vm) {
    h5_vm.BEGIN_CERT_MARKER = "-----BEGIN CERTIFICATE-----\n";
    h5_vm.END_CERT_MARKER = "\n-----END CERTIFICATE-----\n";
    h5_vm.BEGIN_CSR_MARKER = "-----BEGIN CERTIFICATE REQUEST-----\n";
    h5_vm.END_CSR_MARKER = "\n-----END CERTIFICATE REQUEST-----\n";
    var VmTpmService = (function () {
        function VmTpmService(dataService, $http, $q) {
            this.dataService = dataService;
            this.$http = $http;
            this.$q = $q;
        }
        VmTpmService.prototype.stripHeadersFromCertificate = function (rawCertificate) {
            var stripCertHeaderRegex = /-+BEGIN CERTIFICATE-+([^-]+)-+END CERTIFICATE-+/im;
            var match = rawCertificate.match(stripCertHeaderRegex);
            return match ? match[1] : rawCertificate;
        };
        VmTpmService.prototype.getCertificates = function (vmId) {
            return this.dataService.getProperties(vmId, ['tpmCertificates'])
                .then(function (result) {
                return _.map(result.tpmCertificates.certificateInfos, function (certificateInfo) {
                    certificateInfo.rawData = h5_vm.BEGIN_CERT_MARKER + certificateInfo.rawData + h5_vm.END_CERT_MARKER;
                    return certificateInfo;
                });
            });
        };
        VmTpmService.prototype.getCertSigningRequests = function (vmId) {
            return this.dataService.getProperties(vmId, ['tpmCertificates'])
                .then(function (result) {
                return _.map(result.tpmCertificates.csrInfos, function (csrInfo) {
                    csrInfo.rawData = h5_vm.BEGIN_CSR_MARKER + csrInfo.rawData + h5_vm.END_CSR_MARKER;
                    return csrInfo;
                });
            });
        };
        VmTpmService.prototype.isTpmRemovalDisabled = function (vmPoweredOn) {
            return vmPoweredOn;
        };
        VmTpmService.prototype.parseCertificate = function (rawCertificate) {
            var _this = this;
            if (!rawCertificate) {
                return this.$q.when(null);
            }
            var rawCertificateStrippedOfHeaders = this.stripHeadersFromCertificate(rawCertificate);
            var url = 'certs/cert-info';
            var data = $.param({
                certificate: rawCertificateStrippedOfHeaders
            });
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            return this.$http.post(url, data, config).then(function (response) {
                var certificate = response.data;
                var cnFound = certificate.issuerName.match(/CN=([^,]*)/);
                certificate.issuerNameCN = cnFound ? cnFound[1] : certificate.issuerName;
                certificate.rawData = rawCertificate;
                return certificate;
            }, function (error) {
                return _this.$q.reject(error.data);
            });
        };
        VmTpmService.$inject = [
            'dataService',
            '$http',
            '$q'
        ];
        return VmTpmService;
    }());
    h5_vm.VmTpmService = VmTpmService;
    angular.module('com.vmware.vsphere.client.vm')
        .service('vmTpmService', VmTpmService);
})(h5_vm || (h5_vm = {}));



(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.vm')
         .controller('InstallUpgradeVmToolsController', InstallUpgradeVmToolsController);

   InstallUpgradeVmToolsController.$inject = [
         '$scope',
         '$element',
         '$timeout',
         'installUpgradeVmToolsService',
         'i18nService',
         'managedByMessageBuilderService'
   ];

   function InstallUpgradeVmToolsController(
         $scope,
         $element,
         $timeout,
         installUpgradeVmToolsService,
         i18nService,
         managedByMessageBuilderService
   ) {
      var TOOLS_AUTO_UPGRADE = 'auto';

      var self = this;
      var groupedVms = {};

      self.installCount = 0;
      self.upgradeCount = 0;
      // total count includes also non-available vms
      self.totalCount = $scope.modalOptions.dialogData.totalVmsCount;
      self.selectedUpgradeMethod = TOOLS_AUTO_UPGRADE;
      self.multiUpgradeOptions = '';

      var availableVmIds = $scope.modalOptions.dialogData.availableVmIds;

      self.buttonContinueText = i18nService
         .getString('VmUi', 'defaultConsole.dialog.button.continue');
      self.instructionText = i18nService
         .getString('VmUi', 'VmToolsPopupForm.multiAction.instruction');

      if (_.isEmpty(availableVmIds)) {
         self.installCount = 0;
         self.upgradeCount = 0;
         self.skippedCount = self.totalCount;

         $timeout(function() {
            const elementToFocus = $element[0].querySelector("#install-upgrade-vmware-tools-ok-button");
            if (elementToFocus) {
               elementToFocus.focus();
            }
         }, 0);
      } else {
         self.loading = true;
         installUpgradeVmToolsService.getGroupedVms(availableVmIds)
            .then(function (result) {
               groupedVms = result.groupedVms;
               managedByMessageBuilderService
                     .buildWarningMessage(availableVmIds, false, result.properties)
                     .then(function(managedByMessage) {
                        self.managedByMessage = managedByMessage;
                        self.installCount = groupedVms.install.length;
                        self.upgradeCount = groupedVms.upgrade.length;
                        self.skippedCount = self.totalCount - (self.installCount + self.upgradeCount);

                        var selector = "#install-upgrade-vmware-tools-ok-button";
                        if(self.installCount > 0) {
                           selector = "#install-upgrade-vmware-tools-submit-button";
                        }

                        if(self.upgradeCount > 0) {
                           if (self.selectedUpgradeMethod === TOOLS_AUTO_UPGRADE) {
                              selector = "#install-upgrade-vmware-tools-automatic-upgrade";
                           } else {
                              selector = "#install-upgrade-vmware-tools-interactive-upgrade";
                           }
                        }

                        $timeout(function() {
                           const elementToFocus = $element[0].querySelector(selector);
                           if (elementToFocus) {
                              elementToFocus.focus();
                           }
                        }, 0);
                     });
            })
            .then(function(){
               self.loading = false;
            });
      }

      self.cancel = function() {
         $scope.closeModal();
      };

      self.submit = function() {
         installUpgradeVmToolsService.installTools(groupedVms.install);
         installUpgradeVmToolsService.upgradeTools(groupedVms.upgrade,
               self.selectedUpgradeMethod, self.multiUpgradeOptions);
         $scope.closeModal();
      };

      self.isAutoUpgradeSelected = function() {
         return self.selectedUpgradeMethod === TOOLS_AUTO_UPGRADE;
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .service('installUpgradeVmToolsService', installUpgradeVmToolsService);

   installUpgradeVmToolsService.$inject = ['dataService', 'mutationService'];

   function installUpgradeVmToolsService(dataService, mutationService) {

      var TOOLS_RUNNING_STATUS = 'toolsRunningStatus';
      var TOOLS_VERSION_STATUS = 'toolsVersionStatus';
      var POWER_STATE = 'runtime.powerState';
      var MANAGED_BY_INFO = 'managedByInfo';

      var POWERED_OFF = 'poweredOff';
      var GUEST_TOOLS_NOT_RUNNING = 'guestToolsNotRunning';
      var GUEST_TOOLS_RUNNING = 'guestToolsRunning';
      var GUEST_TOOLS_NEED_UPGRADE = 'guestToolsNeedUpgrade';
      var GUEST_TOOLS_SUPPORTED_OLD = 'guestToolsSupportedOld';
      var GUEST_TOOLS_TOO_OLD = 'guestToolsTooOld';
      var GUEST_TOOLS_BLACKLISTED = 'guestToolsBlacklisted';
      var TOOLS_AUTO_UPGRADE = 'auto';
      var TOOLS_INTERACTIVE_UPGRADE = 'interactive';
      var VM_TOOLS_INSTALL_SPEC = 'com.vmware.vsphere.client.vm.tools.VmToolsInstallerSpec';

      return {
         getGroupedVms: getGroupedVms,
         installTools: installTools,
         upgradeTools: upgradeTools
      };

      function getGroupedVms(availableVmIds) {
         var propsToRequest = [TOOLS_RUNNING_STATUS, TOOLS_VERSION_STATUS, POWER_STATE, MANAGED_BY_INFO];
         var groupedVms = dataService.getPropertiesForObjects(availableVmIds, propsToRequest)
               .then(function(result) {
                  var groupedVms = groupResults(result);
                  var propertiesAndGroupdVmsResult = {
                     groupedVms: groupedVms,
                     properties: result
                  };
                  return propertiesAndGroupdVmsResult;
               });
         return groupedVms;
      }

      function groupResults(vmsData) {
         var groupedVms = {
            poweredOff: [],
            install: [],
            upgrade: []
         };
         _.each(vmsData, function(vmData, vmRef) {

            if (vmData[POWER_STATE] === POWERED_OFF) {
               groupedVms.poweredOff.push(vmRef);
            } else {
               if (vmData[TOOLS_RUNNING_STATUS] === GUEST_TOOLS_NOT_RUNNING) {
                  groupedVms.install.push(vmRef);
               } else if (canUpgrade(vmData)) {
                  groupedVms.upgrade.push(vmRef);
               }
            }

         });

         return groupedVms;
      }

      function canUpgrade(vmData) {
         var toolsNeedUpgrade = vmData[TOOLS_VERSION_STATUS] === GUEST_TOOLS_NEED_UPGRADE
               || vmData[TOOLS_VERSION_STATUS] === GUEST_TOOLS_SUPPORTED_OLD
               || vmData[TOOLS_VERSION_STATUS] === GUEST_TOOLS_TOO_OLD
               || vmData[TOOLS_VERSION_STATUS] === GUEST_TOOLS_BLACKLISTED;

         return vmData[TOOLS_RUNNING_STATUS] === GUEST_TOOLS_RUNNING
               && toolsNeedUpgrade;
      }

      function installTools(vmIds) {
         if (vmIds.length === 0) {
            return;
         }

         var vmToolsInstallerSpec = {
            operation: 'mountInstaller'
         };
         mutationService.applyOnMultiEntity(
               vmIds,
               VM_TOOLS_INSTALL_SPEC,
               vmToolsInstallerSpec
         );
      }

      function upgradeTools(vmIds, upgradeMethod, advancedOptions) {
         if (vmIds.length === 0) {
            return;
         }

         var vmToolsInstallerSpec;

         if (upgradeMethod === TOOLS_AUTO_UPGRADE) {
            vmToolsInstallerSpec = {
               operation: 'upgradeTools',
               upgradeOptions: advancedOptions
            };
         } else if (upgradeMethod === TOOLS_INTERACTIVE_UPGRADE) {
            vmToolsInstallerSpec = {
               operation: 'mountInstaller'
            };
         }
         mutationService.applyOnMultiEntity(
               vmIds,
               VM_TOOLS_INSTALL_SPEC,
               vmToolsInstallerSpec
         );
      }
   }
}());

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var h5_vm;
(function (h5_vm) {
    var VmCryptUtilService = (function () {
        function VmCryptUtilService(defaultUriSchemeUtil, dataService, storageProfileService, i18nService) {
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.dataService = dataService;
            this.storageProfileService = storageProfileService;
            this.i18nService = i18nService;
        }
        VmCryptUtilService.prototype.isExistingDiskEncrytped = function (device /* VirtualDisk */) {
            if (!device || !device.backing) {
                return false;
            }
            var keyId = this.getCryptoKeyId(device.backing);
            if (this.isCryptoKeyEmpty(keyId)) {
                return false;
            }
            return true;
        };
        VmCryptUtilService.prototype.isCryptoKeyEmpty = function (keyId) {
            return !keyId || !keyId.keyId;
        };
        VmCryptUtilService.prototype.getKmipClusters = function (serverGuid) {
            var rootFolder = this.defaultUriSchemeUtil.getRootFolder(serverGuid);
            return this.dataService.getProperties(rootFolder, [VmCryptUtilService.PROPERTY_KMIP_CLUSTERS]);
        };
        VmCryptUtilService.prototype.getDefaultKmipServerStatus = function (serverGuid, skipErrorInterceptor) {
            if (skipErrorInterceptor === void 0) { skipErrorInterceptor = false; }
            var rootFolder = this.defaultUriSchemeUtil.getRootFolder(serverGuid);
            return this.dataService.getProperties(rootFolder, [VmCryptUtilService.PROPERTY_DEFAULT_KMIP_CLUSTER_STATUS], {
                skipErrorInterceptor: skipErrorInterceptor
            });
        };
        VmCryptUtilService.prototype.getDiskEncryptionStatus = function (isDiskAlreadyEncrypted, isStorageProfileChanged, isEncryptionProfileApplied) {
            // Disk will be encrypted
            if (!isDiskAlreadyEncrypted && isStorageProfileChanged && isEncryptionProfileApplied) {
                return this.i18nService.getString('VmUi', 'DiskPage.diskWillBeEncrypted');
            }
            // Disk will be decrypted
            if (isDiskAlreadyEncrypted && isStorageProfileChanged && !isEncryptionProfileApplied) {
                return this.i18nService.getString('VmUi', 'DiskPage.diskWillBeDecrypted');
            }
            // Disk is encrypted and will stay like this
            if (isDiskAlreadyEncrypted) {
                return this.i18nService.getString('VmUi', 'DiskPage.Encrypted');
            }
            return undefined;
        };
        VmCryptUtilService.prototype.isVmHomeEncrypted = function (vmConfigContext) {
            if (vmConfigContext.vmProfile) {
                return this.storageProfileService
                    .isEncryptionStorageProfile(vmConfigContext.vmProfile[0]);
            }
            if (!this.isCryptoKeyEmpty(vmConfigContext.config.keyId)) {
                return true;
            }
            return false;
        };
        VmCryptUtilService.prototype.findEncryptionProfile = function (profiles) {
            var _this = this;
            return _.find(profiles, function (profile) {
                return _this.storageProfileService
                    .isEncryptionStorageProfile(profile);
            });
        };
        VmCryptUtilService.prototype.isVmCryptPolicyDisabledForMigrateWizard = function (managedEntity, model) {
            var serverGuid = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(managedEntity).serverGuid;
            model.isEncryptionOptionsDisabled = false;
            this.getDefaultKmipServerStatus(serverGuid)
                .then(function (response) {
                // When the user doesn't have permission to aggregate the KMS statuses,
                // don't stop him because he will still be able to create encrypted VM
                // if the KMS servers are OK.
                if (response && response.h5DefaultKmipClusterStatus
                    && response.h5DefaultKmipClusterStatus.noPermission) {
                    model.isEncryptionOptionsDisabled = false;
                    return;
                }
                var isConnectionNormal = response && response.h5DefaultKmipClusterStatus &&
                    response.h5DefaultKmipClusterStatus.connectionStatus === ConnectionStatus.CONNECTED;
                var isCertificateExpired = response && response.h5DefaultKmipClusterStatus &&
                    response.h5DefaultKmipClusterStatus.certificateStatus === CertStatus.EXPIRED;
                model.isEncryptionOptionsDisabled = !isConnectionNormal || isCertificateExpired;
            });
            return;
        };
        VmCryptUtilService.prototype.getCryptoKeyId = function (backing) {
            if (backing === null) {
                return null;
            }
            if (backing.keyId || backing.keyid) {
                return backing.keyId || backing.keyid;
            }
            return null;
        };
        VmCryptUtilService.$inject = [
            "defaultUriSchemeUtil",
            "dataService",
            "storageProfileService",
            "i18nService"
        ];
        VmCryptUtilService.PROPERTY_KMIP_CLUSTERS = "kmipClusters";
        VmCryptUtilService.PROPERTY_DEFAULT_KMIP_CLUSTER_STATUS = "h5DefaultKmipClusterStatus";
        return VmCryptUtilService;
    }());
    h5_vm.VmCryptUtilService = VmCryptUtilService;
    (function (ConnectionStatus) {
        ConnectionStatus[ConnectionStatus["CONNECTED"] = "CONNECTED"] = "CONNECTED";
        ConnectionStatus[ConnectionStatus["NO_TRUST_CONNECTION"] = "NO_TRUST_CONNECTION"] = "NO_TRUST_CONNECTION";
        ConnectionStatus[ConnectionStatus["ERROR_RETRIEVING"] = "ERROR_RETRIEVING"] = "ERROR_RETRIEVING";
    })(h5_vm.ConnectionStatus || (h5_vm.ConnectionStatus = {}));
    var ConnectionStatus = h5_vm.ConnectionStatus;
    (function (CertStatus) {
        CertStatus[CertStatus["GOOD"] = "GOOD"] = "GOOD";
        CertStatus[CertStatus["ABOUT_TO_EXPIRE"] = "ABOUT_TO_EXPIRE"] = "ABOUT_TO_EXPIRE";
        CertStatus[CertStatus["EXPIRED"] = "EXPIRED"] = "EXPIRED";
        CertStatus[CertStatus["NA"] = "NA"] = "NA";
        CertStatus[CertStatus["ERROR_RETRIEVING"] = "ERROR_RETRIEVING"] = "ERROR_RETRIEVING";
    })(h5_vm.CertStatus || (h5_vm.CertStatus = {}));
    var CertStatus = h5_vm.CertStatus;
    angular.module("com.vmware.vsphere.client.vm")
        .service("vmCryptUtilService", VmCryptUtilService);
})(h5_vm || (h5_vm = {}));



/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmInstallToolsController', VmInstallToolsController);

   VmInstallToolsController.$inject = ['$scope', 'i18nService', 'mutationService',
      'managedByMessageBuilderService'];

   function VmInstallToolsController($scope, i18nService, mutationService, managedByMessageBuilderService) {
      var self = this;
      var i18n = _.bind(i18nService.getString, i18nService, 'VmUi');
      self.loading = true;
      managedByMessageBuilderService
            .buildWarningMessage([$scope.modalOptions.dialogData.objectId])
            .then(function(managedByMessage) {
               self.loading = false;
               self.header = i18n('VmToolsPopupForm.header');
               self.managedByMessage = managedByMessage;
               self.instruction = i18n('VmToolsPopupForm.singleInstall.instruction');
               self.mount = i18n('VmToolsPopupForm.singleInstall.mount');
               self.cancel = i18nService.getString('Common', 'cancelButtonLabel');
            });

      $scope.onSubmit = mountInstaller;

      function mountInstaller() {
         var objectId = $scope.modalOptions.dialogData.objectId;
         var propertyObjectType = 'com.vmware.vsphere.client.vm.tools.VmToolsInstallerSpec';
         var vmToolsInstallerSpec = {
            operation: 'mountInstaller'
         };
         mutationService.apply(objectId, propertyObjectType, vmToolsInstallerSpec);
         $scope.closeModal();

         return true;
      }
   }
})();

(function() {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.vm')
         .controller('VmUpgradeToolsController', VmUpgradeToolsController);

   VmUpgradeToolsController.$inject = ['$scope', '$element', '$timeout', 'i18nService', 'mutationService',
      'dataService', 'managedByMessageBuilderService'];

   function VmUpgradeToolsController($scope, $element, $timeout, i18nService, mutationService, dataService,
         managedByMessageBuilderService) {
      var PROPERTY_TOOLS_AUTO_UPDATE_SUPPORT = "capability.toolsAutoUpdateSupported";
      var PROPERTY_MANAGED_BY_INFO = "managedByInfo";
      var self = this;

      self.TOOLS_INTERACTIVE_UPGRADE = "toolsInteractiveUpgrade";
      self.TOOLS_AUTO_UPGRADE = "toolsAutoUpgrade";

      self.toolsAutoUpdateSupported = true;
      self.loading = false;
      self.header = i18nService.getString('VmUi', 'VmToolsPopupForm.header');
      self.instruction = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.instruction');
      self.cancelBtn = i18nService.getString('Common', 'cancelButtonLabel');
      self.interactiveLabel = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.interactive');
      self.interactiveExplained = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.interactiveExplained');
      self.autoLabel = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.auto');
      self.autoExplained = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.autoExplained');
      self.advancedOptionsLabel = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.advancedOptions');
      self.upgradeLabel = i18nService.getString('VmUi', 'VmToolsPopupForm.singleUpgrade.upgrade');
      self.toolsUpgradeValue = 'toolsAutoUpgrade';
      self.toolsUpgradeAdvancedOptions = '';
      self.isAutoUpgradeSelected = function() {
         return self.toolsUpgradeValue === 'toolsAutoUpgrade';
      };

      $scope.onSubmit = upgradeTools;

      requestData();

      function upgradeTools() {
         var objectId = $scope.modalOptions.dialogData.objectId;
         var propertyObjectType = 'com.vmware.vsphere.client.vm.tools.VmToolsInstallerSpec';
         var vmToolsInstallerSpec;
         if (self.toolsUpgradeValue === self.TOOLS_AUTO_UPGRADE) {
            vmToolsInstallerSpec = {
               operation: 'upgradeTools',
               upgradeOptions: self.toolsUpgradeAdvancedOptions
            };
         } else if (self.toolsUpgradeValue === self.TOOLS_INTERACTIVE_UPGRADE) {
            vmToolsInstallerSpec = {
               operation: 'mountInstaller'
            };
         }

         mutationService.apply(objectId, propertyObjectType, vmToolsInstallerSpec);
         $scope.closeModal();
         return true;
      }

      function requestData() {
         self.loading = true;
         var objectId = $scope.modalOptions.dialogData.objectId;
         dataService.getProperties(
               objectId,
               [PROPERTY_TOOLS_AUTO_UPDATE_SUPPORT, PROPERTY_MANAGED_BY_INFO]
         ).then(function(result) {
            var managedByProperties = {};
            managedByProperties[objectId] = result;
            managedByMessageBuilderService
                  .buildWarningMessage([objectId], false, managedByProperties)
                  .then(function(managedByMessage) {
                     self.loading = false;
                     self.managedByMessage = managedByMessage;
                     self.toolsAutoUpdateSupported = result[PROPERTY_TOOLS_AUTO_UPDATE_SUPPORT];
                     if (!self.toolsAutoUpdateSupported) {
                        self.toolsUpgradeValue = self.TOOLS_INTERACTIVE_UPGRADE;
                     }

                     // Determine which one of the radio buttons is preselected and set the focus on it
                     var selector = "";
                     if(self.toolsUpgradeValue === self.TOOLS_AUTO_UPGRADE) {
                        selector = "#toolsAutoUpgradeRadio";
                     } else {
                        selector = "#toolsInteractiveUpgradeRadio";
                     }

                     $timeout(function() {
                        var radio = $element[0].querySelector(selector);
                        if (radio) {
                           radio.focus();
                        }
                     }, 0);
                  });
         });
      }
   }
})();

angular.module('com.vmware.vsphere.client.vm').run(['$templateCache', function($templateCache) {$templateCache.put('vm-ui/resources/vm/views/summary/vm-hardware-summary-cdrom.html','<clr-stack-block [(clr-sb-expanded)]="$ctrl.expanded"\n                 [(clr-sb-expandable)]="$ctrl.isDeviceConnected()"\n                 class="vm-hardware-summary-cdrom">\n   <clr-stack-label ng-attr-title="{{ $ctrl.label }}">\n      <span>{{ $ctrl.label }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content class="device-status">\n      <span ng-if="!$ctrl.expanded">\n         {{$ctrl.getDeviceConnected()}}\n      </span>\n\n      <div\n         class="dropdown bottom-right vm-hardware-summary-cdrom-dropdown pull-right"\n         ng-if="$ctrl.shouldShowDropdown()"\n         ng-class="{\'open\': isOpen}" ng-click="isOpen = !isOpen">\n\n         <button type="button" class="dropdown-toggle">\n            <clr-icon shape="connect" size="18"\n                      ng-if="$ctrl.isDeviceConnected()"></clr-icon>\n            <clr-icon shape="disconnect" size="18"\n                      ng-if="!$ctrl.isDeviceConnected()"></clr-icon>\n            <clr-icon shape="caret down"></clr-icon>\n         </button>\n         <div class="dropdown-menu">\n            <button type="button" class="dropdown-item"\n                    test-id="dropdown-item-disconnect"\n                    ng-class="{\'disabled\': $ctrl.disconnectDeviceDisabled}"\n                    ng-if="$ctrl.device.connectable.connected"\n                    ng-disabled="!$ctrl.hasDeviceConnectionPriv"\n                    ng-click="$ctrl.disconnectCdRom()">{{$ctrl.i18n(\'VmUi\',\n               \'DeviceConnection.manager.disconnect\')}}\n            </button>\n            <button type="button" class="dropdown-item"\n                    test-id="dropdown-item-host-device"\n                    ng-class="{\'disabled\': $ctrl.connectHostDeviceDisabled}"\n                    ng-if="!$ctrl.isDeviceConnected()"\n                    ng-disabled="!$ctrl.hasPermission()"\n                    ng-click="$ctrl.connectToHostCdDevice()">\n               {{$ctrl.i18n(\'VmUi\',\n               \'DeviceConnection.manager.connect_host_cd_device_short\')}}\n            </button>\n            <button type="button" class="dropdown-item"\n                    test-id="dropdown-item-datastore-iso"\n                    ng-if="!$ctrl.isDeviceConnected()"\n                    ng-disabled="!$ctrl.hasPermission()"\n                    ng-click="$ctrl.browseForDatastoreIso()">\n               {{$ctrl.i18n(\'VmUi\',\n               \'DeviceConnection.manager.connect_host_cd_image_short\')}}\n            </button>\n            <button type="button" class="dropdown-item"\n                    test-id="dropdown-item-cl-iso"\n                    ng-if="!$ctrl.isDeviceConnected()"\n                    ng-disabled="!$ctrl.hasPermissionAndConfigForCL()"\n                    ng-click="$ctrl.browseForContentLibraryIso()">\n               {{$ctrl.i18n(\'VmUi\',\n               \'DeviceConnection.manager.connect_host_cliso_image_short\')}}\n            </button>\n         </div>\n      </div>\n   </clr-stack-content>\n\n   <!--Connected to row-->\n   <clr-stack-block ng-if="$ctrl.isDeviceConnected()">\n      <clr-stack-label\n         ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'DeviceConnection.manager.info.connected_to\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'DeviceConnection.manager.info.connected_to\') }}\n      </clr-stack-label>\n      <clr-stack-content class="device-connected-to">{{$ctrl.getConnectedTo()}}</clr-stack-content>\n   </clr-stack-block>\n\n   <!--Device row-->\n   <clr-stack-block ng-if="$ctrl.isDeviceConnected()">\n      <clr-stack-label\n         ng-attr-title="{{ $ctrl.getDeviceOrFile().title }}">{{ $ctrl.getDeviceOrFile().title }}</clr-stack-label>\n      <clr-stack-content class="device-file-or-device">{{$ctrl.getDeviceOrFile().value}}</clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vm-hardware-summary-encryption.html','<clr-stack-block>\n   <clr-stack-label ng-attr-title="$ctrl.label">\n      <span>{{ $ctrl.label }}</span>\n   </clr-stack-label>\n   <clr-stack-content>\n      <div>{{ $ctrl.vmConfigContent }}</div>\n      <div>{{ $ctrl.disksContent }}</div>\n   </clr-stack-content>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vm-hardware-summary-floppy.html','<clr-stack-block [(clr-sb-expanded)]="expanded"\n                 [(clr-sb-expandable)]="$ctrl.isDeviceConnected()">\n   <clr-stack-label ng-attr-title="{{ $ctrl.label }}">\n      <span>{{ $ctrl.label }}</span>\n   </clr-stack-label>\n\n   <clr-stack-content class="device-status">\n      <span ng-if="!expanded">\n         {{$ctrl.getDeviceConnected()}}\n      </span>\n   </clr-stack-content>\n\n   <!--Connected to row-->\n   <clr-stack-block ng-if="$ctrl.isDeviceConnected()">\n      <clr-stack-label\n         ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'DeviceConnection.manager.info.connected_to\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'DeviceConnection.manager.info.connected_to\') }}\n      </clr-stack-label>\n      <clr-stack-content class="device-connected-to">{{$ctrl.getConnectedTo()}}</clr-stack-content>\n   </clr-stack-block>\n\n   <!--Device row-->\n   <clr-stack-block ng-if="$ctrl.isDeviceConnected()">\n      <clr-stack-label\n         ng-attr-title="{{$ctrl.getDeviceOrFile().title}}">{{$ctrl.getDeviceOrFile().title}}</clr-stack-label>\n      <clr-stack-content class="device-file-or-device">{{$ctrl.getDeviceOrFile().value}}</clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummary.html','<div ng-controller="VmHardwareSummaryController as ctrl">\n   <clr-stack-view class="clr-component"\n                   ng-if="ctrl.hardwareViewData"\n                   vx-refreshable watch-objects=\'{{ctrl.watchObjects}}\'\n                   live-refresh-properties="ctrl.liveRefreshProperties"\n                   refresh=\'ctrl.getVmHardwareData()\'>\n\n      <vm-hardware-summary-encryption ng-if="ctrl.isEncryptionSummaryVisible"\n               devices="ctrl.devices">\n      </vm-hardware-summary-encryption>\n\n      <vm-hardware-summary-cpu ctrl="ctrl">\n      </vm-hardware-summary-cpu>\n\n      <vm-hardware-summary-memory ctrl="ctrl">\n      </vm-hardware-summary-memory>\n\n      <vm-hardware-summary-pmem ng-if="ctrl.isPmemSummaryVisible"\n               devices="ctrl.devices">\n      </vm-hardware-summary-pmem>\n\n      <vm-hardware-summary-virtual-disk\n               ctrl="ctrl"\n               class="vm-hardware-summary-virtual-disk"\n               device="device"\n               ng-repeat="device in ctrl.displayHardDiskDevices track by device.key">\n      </vm-hardware-summary-virtual-disk>\n\n      <vm-hardware-summary-virtual-disk\n         ctrl="ctrl"\n         class="vm-hardware-summary-virtual-disk"\n         device="device"\n         ng-repeat="device in ctrl.displayRdmDiskDevices track by device.key">\n      </vm-hardware-summary-virtual-disk>\n\n      <clr-stack-block ng-if="ctrl.shouldGroupHardDisks">\n         <clr-stack-label>\n            {{i18n(\'VmUi\', \'summaryView.groupedDisks.label\')}}\n         </clr-stack-label>\n         <clr-stack-content>\n            <a href="{{ctrl.getGroupedDiskText()}}" ng-click="ctrl.invokeEditAction($event)">\n               {{ctrl.getGroupedDiskText()}}\n            </a>\n         </clr-stack-content>\n      </clr-stack-block>\n\n      <vm-hardware-summary-network\n               ctrl="ctrl"\n               device="device"\n               ng-repeat="device in ctrl.devices[\'VirtualEthernetCard\'] track by device.key">\n      </vm-hardware-summary-network>\n\n      <vm-hardware-summary-cdrom\n               ctrl="ctrl"\n               device="device"\n               ng-repeat="device in ctrl.devices[\'VirtualCdrom\'] track by device.key">\n      </vm-hardware-summary-cdrom>\n\n      <vm-hardware-summary-floppy\n         ctrl="ctrl"\n         device="device"\n         ng-repeat="device in ctrl.devices[\'VirtualFloppy\'] track by device.key">\n      </vm-hardware-summary-floppy>\n\n      <vm-hardware-summary-video-card\n         device="device"\n         ng-repeat="device in ctrl.devices[\'VirtualVideoCard\'] track by device.key">\n      </vm-hardware-summary-video-card>\n\n      <vm-hardware-summary-nvdimm\n         device="device"\n         ng-repeat="device in ctrl.devices[\'VirtualNVDIMM\'] track by device.key">\n      </vm-hardware-summary-nvdimm>\n\n      <vm-tpm ng-if="ctrl.tpmDevice" label="ctrl.tpmDevice.deviceInfo.summary"\n              vm-id="ctrl.objectId"></vm-tpm>\n\n      <clr-stack-block\n              ng-repeat="device in ctrl.devices[\'VirtualDevice\'] track by device.key">\n         <clr-stack-label ng-attr-title="{{ device.deviceInfo.label }}">\n               {{ device.deviceInfo.label }}\n         </clr-stack-label>\n         <clr-stack-content>\n               {{ device.deviceInfo.summary }}\n         </clr-stack-content>\n      </clr-stack-block>\n\n      <vm-hardware-summary-other ctrl="ctrl" devices="ctrl.devices">\n      </vm-hardware-summary-other>\n\n      <vm-hardware-summary-hw-version ctrl="ctrl" ng-if="!ctrl.isVmTemplateCLitem">\n      </vm-hardware-summary-hw-version>\n\n   </clr-stack-view>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryCpu.html','<clr-stack-block class="numCpu" [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmCpu.Title\')}}">\n      {{i18n(\'VmUi\', \'VmCpu.Title\')}}\n   </clr-stack-label>\n\n   <clr-stack-content class="value">\n      <span ng-if="!expanded">\n         {{i18n(\'VmUi\', \'numCpu\', ctrl.hardwareViewData.hardware.numCPU)}}\n      </span>\n   </clr-stack-content>\n\n   <clr-stack-block ng-if="!isTemplate" class="Utilization">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelUtilization\') }}">{{ fieldLabel(\'labelUtilization\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'Utilization\'] }}</clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="isTemplate" class="ConfiguredCPU">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelConfigured\') }}">{{ fieldLabel(\'labelConfigured\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'ConfiguredCPU\'] }}</clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="Shares">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelShares\') }}">{{ fieldLabel(\'labelShares\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'Shares\'] }}</clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="Reservation">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelReservation\') }}">{{ fieldLabel(\'labelReservation\') }}</clr-stack-label>\n      <clr-stack-content>\n         <div class="reservation-value">{{ fieldValue[\'Reservation\'] }}</div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="Limit">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelLimit\') }}">{{ fieldLabel(\'labelLimit\') }}</clr-stack-label>\n      <clr-stack-content>\n         <div>{{ fieldValue[\'Limit\'] }}</div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.isVmTemplateCLitem" class="NestedHV">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelNestedHV\') }}">{{ fieldLabel(\'labelNestedHV\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'NestedHV\'] }}</clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.isVmTemplateCLitem" class="ioMmu">\n      <clr-stack-label>{{ fieldLabel(\'labelIoMmuHV\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'IommuHV\'] }}</clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block ng-if="!ctrl.isVmTemplateCLitem" class="PerfCounters">\n      <clr-stack-label ng-attr-title="{{ fieldLabel(\'labelVPMCEnabled\') }}">{{ fieldLabel(\'labelVPMCEnabled\') }}</clr-stack-label>\n      <clr-stack-content>{{ fieldValue[\'PerfCounters\'] }}</clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryHwVersion.html','<clr-stack-block class="hwversion">\n   <clr-stack-label class="value" ng-attr-title="{{ vmHwVersionLabel }}">\n      <span>{{ vmHwVersionLabel }}</span>\n   </clr-stack-label>\n   <clr-stack-content class="value">\n      <div>{{ vmHwVersion }}</div>\n      <div ng-if="hasScheduledUpgrade">\n         <div>{{scheduledUpgradeStatus}}</div>\n         <div class="hw-upgrade-error" title="{{scheduledUpgradeError}}">\n            {{scheduledUpgradeError}}\n         </div>\n      </div>\n   </clr-stack-content>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryMemory.html','<clr-stack-block class="memory" [(clr-sb-expanded)]="expanded">\n    <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmMemory.Title\')}}">\n        {{i18n(\'VmUi\', \'VmMemory.Title\')}}\n    </clr-stack-label>\n\n    <clr-stack-content class="memory-heading">\n       <span ng-if="!expanded">\n          <div ng-if="ctrl.hardwareViewData.hardware.memoryMB && !expanded && !isTemplate">\n             <vx-resource-meter percentage="memoryUtilizationPercentage" orientation="vertical"></vx-resource-meter>\n             {{ fieldValue[\'Utilization\'] }}\n          </div>\n          <div ng-if="!expanded && isTemplate">\n             {{ fieldValue[\'ConfiguredMemory\'] }}\n          </div>\n       </span>\n    </clr-stack-content>\n\n    <clr-stack-block ng-if="!isTemplate" class="Utilization">\n        <clr-stack-label ng-attr-title="{{ fieldLabel(\'Utilization\') }}">\n            {{ fieldLabel(\'Utilization\') }}\n        </clr-stack-label>\n        <clr-stack-content>\n           <vx-resource-meter percentage="memoryUtilizationPercentage" orientation="vertical"></vx-resource-meter>\n           {{ fieldValue[\'Utilization\'] }}\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block ng-if="isTemplate" class="ConfiguredMemory">\n        <clr-stack-label ng-attr-title="{{ fieldLabel(\'Configured\') }}" ng-bind="fieldLabel(\'Configured\')"></clr-stack-label>\n        <clr-stack-content>{{ fieldValue[\'ConfiguredMemory\'] }}</clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block class="Shares">\n        <clr-stack-label ng-attr-title="{{ fieldLabel(\'Shares\') }}" ng-bind="fieldLabel(\'Shares\')"></clr-stack-label>\n        <clr-stack-content ng-bind="fieldValue[\'Shares\']"></clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block class="Reservation">\n        <clr-stack-label ng-attr-title="{{ fieldLabel(\'Reservation\') }}" ng-bind="fieldLabel(\'Reservation\')"></clr-stack-label>\n        <clr-stack-content ng-bind="fieldValue[\'Reservation\']"></clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block class="Limit">\n        <clr-stack-label ng-attr-title="{{fieldLabel(\'Limit\')}}" ng-bind="fieldLabel(\'Limit\')"></clr-stack-label>\n        <clr-stack-content ng-bind="fieldValue[\'Limit\']"></clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block ng-if="!isTemplate" class="HostOverhead">\n        <clr-stack-label ng-attr-title="{{ fieldLabel(\'HostOverhead\') }}" ng-bind="fieldLabel(\'HostOverhead\')"></clr-stack-label>\n        <clr-stack-content class="stack-view-cell" ng-bind="fieldValue[\'HostOverhead\']"></clr-stack-content>\n    </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryNetwork.html','<clr-stack-block [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-attr-title="{{device.deviceInfo.label}}">\n       {{device.deviceInfo.label}}\n   </clr-stack-label>\n   <clr-stack-content>\n      <div ng-if="!expanded && !ctrl.isVmTemplateCLitem">\n         <a ng-click="_navigateToObject(networkRef)">\n            {{networkName}}</a> {{labelForConnectionState()}}\n      </div>\n      <div ng-if="!expanded && ctrl.isVmTemplateCLitem">\n            {{networkName}}\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block>\n      <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmNetView.adapterType\')}}">\n          {{i18n(\'VmUi\', \'VmNetView.adapterType\')}}\n      </clr-stack-label>\n\n      <clr-stack-content ng-bind="ethernetCardLabel">\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block>\n      <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmNetView.macAddress\')}}">\n         {{i18n(\'VmUi\', \'VmNetView.macAddress\')}}\n      </clr-stack-label>\n\n      <clr-stack-content ng-bind="device.macAddress">\n      </clr-stack-content>\n   </clr-stack-block>\n\n    <clr-stack-block ng-if="!isTemplate">\n        <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmNetView.directPath\')}}">\n            {{i18n(\'VmUi\', \'VmNetView.directPath\')}}\n        </clr-stack-label>\n\n        <clr-stack-content>\n            {{i18n(\'NetworkUi\', directpathEnabled ? \'DirectPath.status.active\' : \'DirectPath.status.inactive\')}}\n        </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block>\n        <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmNetView.network\')}}">\n            {{i18n(\'VmUi\', \'VmNetView.network\')}}\n        </clr-stack-label>\n\n        <clr-stack-content ng-if="!ctrl.isVmTemplateCLitem">\n            <a ng-click="_navigateToObject(networkRef)">\n                {{networkName}}</a> {{labelForConnectionState()}}\n        </clr-stack-content>\n\n       <clr-stack-content ng-if="ctrl.isVmTemplateCLitem">\n             {{networkName}}\n       </clr-stack-content>\n    </clr-stack-block>\n\n    <clr-stack-block ng-if="ctrl.isVmTemplateCLitem">\n       <clr-stack-label ng-attr-title="{{i18n(\'VmUi\', \'VmNetView.connectOnStart\')}}">\n         {{i18n(\'VmUi\', \'VmNetView.connectOnStart\')}}\n       </clr-stack-label>\n\n       <clr-stack-content>\n          {{i18n(\'VmUi\', connectOnStart ? \'yes\' : \'no\')}}\n       </clr-stack-content>\n    </clr-stack-block>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryNvdimm.html','<clr-stack-block>\n   <clr-stack-label ng-attr-title="$ctrl.label">\n      <span>{{ $ctrl.label }}</span>\n   </clr-stack-label>\n   <clr-stack-content>\n      {{ $ctrl.content }}\n   </clr-stack-content>\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryOther.html','<clr-stack-block [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-attr-title="{{ i18n(\'VmUi\', \'VmHardwareView.OtherHardware\') }}">\n      {{ i18n(\'VmUi\', \'VmHardwareView.OtherHardware\') }}\n   </clr-stack-label>\n\n   <clr-stack-content>\n      <div ng-if="!expanded">\n         {{ i18n(\'VmUi\', \'VmHardwareView.AdditionalHardware\') }}\n      </div>\n   </clr-stack-content>\n\n   <clr-stack-block class="controllers">\n      <clr-stack-label ng-attr-title="{{ i18n(\'VmUi\', \'VmOtherHardwareView.Controllers\') }}"\n        ng-bind="i18n(\'VmUi\', \'VmOtherHardwareView.Controllers\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="controller vm-hardware-generic"\n              ng-repeat="device in devices[\'VirtualController\'] track by device.key"\n              ng-bind="getSummaryText(device, \'VirtualController\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="scsi-adapters">\n      <clr-stack-label ng-attr-title="{{ i18n(\'VmUi\', \'VmOtherHardwareView.ScsiAdapters\') }}"\n        ng-bind="i18n(\'VmUi\', \'VmOtherHardwareView.ScsiAdapters\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="scsi-adapter vm-hardware-generic"\n              ng-repeat="device in devices[\'VirtualSCSIController\'] track by device.key"\n              ng-bind="getSummaryText(device, \'VirtualSCSIController\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="input-devices" ng-if="!ctrl.isVmTemplateCLitem">\n      <clr-stack-label ng-attr-title="{{ i18n(\'VmUi\', \'VmOtherHardwareView.InputDevices\') }}"\n        ng-bind="i18n(\'VmUi\', \'VmOtherHardwareView.InputDevices\')"></clr-stack-label>\n      <clr-stack-content>\n         <div class="input-device vm-hardware-generic"\n              ng-repeat="device in devices[\'InputDevice\'] track by device.key"\n              ng-bind="getSummaryText(device, \'InputDevice\')">\n         </div>\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryPmem.html','<clr-stack-block>\n   <clr-stack-label ng-attr-title="$ctrl.label">\n      <span>{{ $ctrl.label }}</span>\n   </clr-stack-label>\n   <clr-stack-content>\n      <span\n            aria-label="{{ $ctrl.label + \' - \' + $ctrl.content }}">{{ $ctrl.content }}</span>\n   </clr-stack-content>\n</clr-stack-block>\n\n\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryVideoCard.html','<clr-stack-block class="videocard" [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.Title\') }}">\n      {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.Title\') }}\n   </clr-stack-label>\n\n   <clr-stack-content class="videocard__value">\n      <span ng-if="!expanded">\n         {{ $ctrl.device.videoRamSizeInKB | bytes: \'KB\'}}\n      </span>\n   </clr-stack-content>\n\n   <clr-stack-block class="videocard__memory">\n      <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.TotalVideoMemory\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.TotalVideoMemory\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         {{ $ctrl.device.videoRamSizeInKB | bytes: \'KB\'}}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="videocard__display">\n      <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.NumberOfDisplays\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.NumberOfDisplays\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         {{ $ctrl.device.numDisplays }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="videocard__3dgraphics">\n      <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DGraphics\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DGraphics\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         {{ $ctrl.device.enable3DSupport | enabled }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="videocard__3drenderer">\n      <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DRenderer\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DRenderer\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         {{ $ctrl.device.use3dRenderer | render3d }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="videocard__3dmemory">\n      <clr-stack-label ng-attr-title="{{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DMemory\') }}">\n         {{ $ctrl.i18n(\'VmUi\', \'VideoCardPage.3DMemory\') }}\n      </clr-stack-label>\n      <clr-stack-content>\n         {{ $ctrl.device.graphicsMemorySizeInKB | bytes: \'KB\' }}\n      </clr-stack-content>\n   </clr-stack-block>\n\n</clr-stack-block>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmHardwareSummaryVirtualDisk.html','<clr-stack-block ng-form name="vmHardwareVirtualDisk{{formKey}}"\n                 [(clr-sb-expanded)]="expanded">\n   <clr-stack-label ng-attr-title="{{deviceLabel}}">\n      {{deviceLabel}}\n   </clr-stack-label>\n   <clr-stack-content>\n      <div ng-if="!expanded" ng-bind="device.capacityInKB | bytes:\'KB\'"/>\n   </clr-stack-content>\n\n   <clr-stack-block class="capacity">\n      <clr-stack-label\n         ng-attr-title="{{ i18n(\'VmUi\', \'VmDiskView.capacity\') }}"\n         ng-bind="i18n(\'VmUi\', \'VmDiskView.capacity\')"></clr-stack-label>\n      <clr-stack-content\n         ng-bind="device.capacityInKB | bytes:\'KB\'"></clr-stack-content>\n   </clr-stack-block>\n\n\n   <clr-stack-block ng-if="!ctrl.isVmTemplateCLitem && !isPmemDisk">\n      <clr-stack-label\n         ng-attr-title="{{ i18n(\'VmUi\', \'VmDiskView.diskType\') }}"\n         ng-bind="i18n(\'VmUi\', \'VmDiskView.diskType\')"></clr-stack-label>\n      <clr-stack-content>\n         <vm-hardware-virtual-disk-type\n            device-backing="device.backing"></vm-hardware-virtual-disk-type>\n      </clr-stack-content>\n   </clr-stack-block>\n\n   <clr-stack-block class="location" ng-if="!ctrl.isVmTemplateCLitem">\n      <clr-stack-label\n         ng-attr-title="{{ i18n(\'VmUi\', \'VmDiskView.location\') }}"\n         ng-bind="i18n(\'VmUi\', \'VmDiskView.location\')"></clr-stack-label>\n      <clr-stack-content>\n         <a ng-click="_navigateToObject(datastoreRef)"\n               ng-class="{\'virtual-disk-link-not-clickable\': isPmemDisk}">\n            {{datastoreInfo.name}}</a> {{i18n(\'VmUi\',\n         \'VmDiskView.datastoreFreeSpace\', (datastoreInfo.freeSpaceInBytes |\n         bytes:\'B\'))}}\n      </clr-stack-content>\n   </clr-stack-block>\n</clr-stack-block>\n\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmSummaryImage.html','<div class="summary-image-block" ng-if="summaryData.name" vx-refreshable\n     refresh="getVmScreenshot()" refresh-event-types="dataRefreshInvocationEvent">\n   <div class="summary-image-state-label" ng-if="stateLabel">\n      <div>\n         <div>{{stateLabel}}</div>\n         <div ng-if="summaryData.isVmLocked">\n            {{::i18n(\'VmUi\', \'summaryView.stateLabel.locked.suffix\')}}\n         </div>\n      </div>\n   </div>\n   <div ng-if="!stateLabel">\n      <img ng-src="{{imageUrl}}" ng-if="!imageBytes && !screenshotInProgress" alt="">\n      <div class="summary-image-state-label flex-row spinner-body"\n           ng-show="!imageBytes && screenshotInProgress">\n         <span class="spinner spinner-inline"></span>\n      </div>\n      <div class="summary-image-thumbnail-container"\n           ng-if="imageBytes"\n           ng-click="itemClicked(entityReference)">\n         <img class="summary-image-thumbnail"\n              ng-src="data:image/png;base64,{{imageBytes}}"\n              alt="">\n         <span class="summary-image-caption">\n                <span ng-class="imageCaptionIcon"></span>\n                {{imageCaption}}\n             </span>\n      </div>\n   </div>\n\n   <div ng-if="!summaryData.isTemplate && !summaryData.isVmLocked" class="launch-web-console">\n      <div>\n         <div class="launch-web-console-text-disabled"\n              ng-if="!isWebConsoleAvailable">\n            {{i18n(\'VmUi\', \'summaryView.launchWebConsole\')}}\n         </div>\n         <a class="launch-web-console-text" href="" ng-click="itemClicked(entityReference)"\n            ng-if="isWebConsoleAvailable"\n            target="_blank">\n            {{i18n(\'VmUi\', \'summaryView.launchWebConsole\')}}</a>\n      </div>\n   </div>\n   <div ng-if="!summaryData.isTemplate && !summaryData.isVmLocked">\n         <span class="launch-remote-console">\n            <a class="launch-remote-console-text" href="" ng-click="launchVMRCConsole()" target="_blank"\n               vui-sign-post=\'launchVmrcInfoSignPostParams\'  ng-class="{\'disabled-link\': !launchConsoleActionEval.available}">{{i18n(\'VmUi\', \'summaryView.launchVMRCConsole\')}}</a>\n            <a class="launch-remote-console-icon" vui-sign-post=\'vmrcInfoSignPostParams\'\n               href="" role="button">\n               <img ng-src="{{i18n(\'CommonImages\', \'info\')}}" alt="{{vmrcInfoSignPostParams.title}}">\n            </a>\n         </span>\n   </div>\n   <div ng-if="!summaryData.isTemplate && summaryData.isVmLocked && featureFlagsService.VMcrypt2Enabled()" class="unlock-vm">\n      <a href="" ng-click="unlockVmClicked(entityReference)">\n          {{::i18n(\'VmUi\', \'summaryView.unlockVm.label\')}}\n      </a>\n      <vsc-sign-post [sign-post-position]="\'right\'"\n                     [sign-post-header]="::i18n(\'VmUi\', \'summaryView.unlockVm.signpost.title\')"\n                     [sign-post-content-template]="signPostContentTemplate">\n      </vsc-sign-post>\n   </div>\n</div>\n');
$templateCache.put('vm-ui/resources/vm/views/summary/vmSummaryImageWrapper.html','<vm-summary-image></vm-summary-image>');
$templateCache.put('vm-ui/resources/vm/views/summary/vmTpm/vm-tpm.html','<clr-stack-block [(clr-sb-expanded)]="expanded">\n   <clr-stack-label>\n      {{ $ctrl.label }}\n   </clr-stack-label>\n   <clr-stack-content>\n      {{$ctrl.i18n(\'VmUi\', \'VmDeviceManager.TPMPresent\')}}\n   </clr-stack-content>\n\n   <clr-stack-block ng-repeat="tpmCertificate in $ctrl.tpmCertificates">\n      <clr-stack-label>\n         {{ tpmCertificate.algorithmName }}-{{tpmCertificate.publicKeyAlgorithmName}}\n      </clr-stack-label>\n      <clr-stack-content>{{ tpmCertificate.issuerNameCN }}</clr-stack-content>\n   </clr-stack-block>\n   <clr-stack-block><a\n      data-test-id="tpm-manage-certificates"\n      ng-click="$ctrl.navigateToConfigureTab()">\n      {{$ctrl.i18n(\'VmUi\',\'VmDeviceManager.ManageCertificates\')}}</a>\n   </clr-stack-block>\n\n</clr-stack-block>\n\n\n');
$templateCache.put('vm-ui/resources/vm/views/summary/modals/select-default-console/SelectConsoleDialog.html','<!-- Change Date Time Format Dialog -->\n<form class="compact select-default-console"\n      ng-controller="SelectConsoleDialogController as ctrl">\n   <div class="radio">\n      <input type="radio"\n             name="console-web"\n             id="console-web"\n             value="WEB_CONSOLE"\n             ng-model="ctrl.currentlySelectedFormat">\n      <label for="console-web">\n         {{i18n(\'Common\', \'changeDefaultConsole.web\')}}\n      </label>\n   </div>\n   <div class="radio">\n      <input type="radio"\n             name="console-vmrc"\n             id="console-vmrc"\n             value="VMRC_CONSOLE"\n             ng-model="ctrl.currentlySelectedFormat">\n      <label for="console-vmrc">\n         {{i18n(\'Common\', \'changeDefaultConsole.vmrc\')}}\n      </label>\n   </div>\n   <div class="checkbox">\n      <input type="checkbox" id="remember" ng-model="shouldRemember">\n      <label for="remember">\n         {{i18n(\'VmUi\', \'launchConsoleModal.remember\')}}</label>\n   </div>\n</form>\n\n\n');
$templateCache.put('vm-ui/resources/vm/views/summary/modals/select-host/select-host.html','<form name="host-select-form">\n      <div class="select" ng-class="{\'disabled\': modalOptions.dialogData.isLoading}">\n         <select name="host-select" id="host-select"\n                 ng-change="modalOptions.dialogData.onHostChange(modalOptions.dialogData.selectedHost, modalOptions)"\n                 ng-options="option.name for option in modalOptions.dialogData.hosts"\n                 ng-model="modalOptions.dialogData.selectedHost"\n                 ng-disabled="modalOptions.dialogData.isSelectorDisabled()">\n            <option value="" ng-if="!modalOptions.dialogData.hosts.length">\n               {{modalOptions.dialogData.i18nService.getString(\'VmUi\',\n               \'DeviceConnection.select_device.no_host_device_available\')}}\n            </option>\n         </select>\n      </div>\n</form>');
$templateCache.put('vm-ui/resources/vm/views/summary/modals/select-iso/select-iso.html','<div>\n   <datastore-file-browser\n      object-id="modalOptions.dialogData.datastoreBrowserId"\n      datastore-ids="modalOptions.dialogData.datastoreIds"\n      initial-file-query-type="modalOptions.dialogData.initialFileQueryType"\n      filter-file-query-types="modalOptions.dialogData.filterFileQueryTypes"\n      show-vm-images-folder="modalOptions.dialogData.showVmImagesFolder"\n      selected-file-changed="modalOptions.dialogData.onIsoChange(selectedFile, modalOptions)">\n   </datastore-file-browser>\n</div>\n');}]);


/* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.host = {
   angularModule: angular.module('com.vmware.vsphere.client.host',
         ['com.vmware.platform.ui', 'com.vmware.vsphere.client.commonModule',
               'com.vmware.vsphere.client.licenseLibUi'])
};

/*
 * Registers host action invokers in the h5.actions cache.
 *
 * We do this in the run block of the module so that invokers can take
 * advantage of angular services injected into a closure.
 */
angular.module('com.vmware.vsphere.client.host')
   .run([
      'columnRenderersRegistry',
      'templateHelperService',
      function(columnRenderersRegistry, templateHelperService) {

         var clusterLinkRenderer = {
            'cluster-link': function(props, data, config) {
               var objLinkRenderer = columnRenderersRegistry.getColumnRenderer(
                  'object-link');
               return objLinkRenderer([props[0], props[1], 'vsphere-icon-cluster'],
                  data,
                  config);
            }
         };

         var hostHaStateTemplate = "<span class='object' title='{{title}}'><i class='{{icon}}'></i>{{text}}</span>";
         var compiledHostHaStateTemplate = templateHelperService.getHtmlEscapingTemplateRenderFunction(hostHaStateTemplate);

         var haStateRenderer = {
            'host-ha-state': function(props, data) {
               var icon = '';
               var text = data[props[0]];

               switch (data[props[1]]) {
                  case 'master':
                  case 'connectedToMaster':
                     icon = "vsphere-icon-status-ok";
                     break;
                  case 'uninitialized':
                  case 'election':
                     icon = "vsphere-icon-status-warning";
                     break;
                  case 'fdmUnreachable':
                  case 'hostDown':
                  case 'initializationError':
                  case 'networkIsolated':
                  case 'networkPartitionedFromMaster':
                  case 'uninitializationError':
                     icon = "vsphere-icon-status-error";
                     break;

                  default:
                     icon = "vsphere-icon-status-unknown";
               }

               return compiledHostHaStateTemplate({ title: text, icon: icon, text: text });
            }
         };

         var hostVersionRenderer = {
            'host-version': function(props, data) {
               if (data[props[0]] === null || data[props[1]] === null){
                  return "";
               }

               if (data[props[0]] !== 'embeddedEsx') {
                  return "";
               }

               return data[props[1]];
            }
         };

         columnRenderersRegistry.registerColumnRenderers(clusterLinkRenderer);
         columnRenderersRegistry.registerColumnRenderers(haStateRenderer);
         columnRenderersRegistry.registerColumnRenderers(hostVersionRenderer);
      }
   ])
   .run([
   '$rootScope',
   'hciCapabilityService',
   'mutationService',
   'actionDialogService',
   'actionConfirmationService',
   'removeHostAction',
   'columnRenderersRegistry',
   'i18nService',
   'addHostWizardService',
   'clarityModalService',
   'refreshCertificateService',
   'hostAuthService',
   'securityProfileDialogService',
   'hostConnectionService',
   'suppressWarningSettingService',
   'moveHostToService',
   'assignLicenseService',
   'vscExportWizardLauncherService',
   'addHostsActionWizardService',
   'vuiUtils',
   'vxGridSettingsService',
   'suppressWarningSettingConstants',
   function($rootScope,
         hciCapabilityService,
         mutationService,
         actionDialogService,
         actionConfirmationService,
         removeHostAction,
         columnRenderersRegistry,
         i18nService,
         addHostWizardService,
         clarityModalService,
         refreshCertificateService,
         hostAuthService,
         securityProfileDialogService,
         hostConnectionService,
         suppressWarningSettingService,
         moveHostToService,
         assignLicenseService,
         vscExportWizardLauncherService,
         addHostsActionWizardService,
         vuiUtils,
         vxGridSettingsService,
         suppressWarningSettingConstants) {
      /*
       * Action for editing power configuration (hardware) of the host.
       */
      h5.actions["vsphere.core.host.actions.editPowerConfigHardware"] = function(actionEval, availableTargets) {

         var modalOptions = {
            title: i18nService.getString('HostUi', 'powerPolicy.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/EditPowerConfigHardware.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions["vsphere.core.host.actions.editPowerConfigSoftware"] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi',
                  'powerConfigSoftware.powerManagementSettings'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/editPowerConfigSoftware.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions["vsphere.core.host.actions.editAgentVmSettings"] = function(actionEval, availableTargets) {

         var modalOptions = {
            title: i18nService.getString('HostUi', 'settings.agentVm.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/EditAgentVmSettings.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.enterMaintenanceMode'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'actionEnterMaintenanceLabel'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/maintenanceMode/MaintenanceModeConfirmation.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.exitMaintenanceMode'] = function(actionEval, availableTargets) {
         var maintenanceAction = { maintenanceOpType: 'exit' };
         mutationService.applyOnMultiEntity(availableTargets,
               'com.vmware.vsphere.client.host.maintenance.HostMaintenanceSpec', maintenanceAction);
      };

      h5.actions['vsphere.core.host.actions.enterStandbyAction'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'actionEnterStandbyLabel'),
            subTitle: availableTargets.length > 1 ? "" : {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/standby/standbyModeConfirmationDialog.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.exitStandby'] = function(actionEval, availableTargets) {
         var hostStandbySpec = {
            standbyOpType: 'exit'
         };
         mutationService.applyOnMultiEntity(
               availableTargets,
               'com.vmware.vsphere.client.host.standby.HostStandbySpec',
               hostStandbySpec
         );
      };

      h5.actions['vsphere.core.host.actions.shutdownAction'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: availableTargets.length === 1 ? i18nService.getString('HostUi', 'actionShutdownHostDialogTitle') :
                i18nService.getString('HostUi', 'actionShutdownHostsDialogTitle'),
            subTitle: availableTargets.length > 1 ? "" : {
               objectId: availableTargets[0]
            },
            dialogData: {
               availableTargets: availableTargets
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/shutdownConfirmation.html'
         };
         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.rebootAction'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: availableTargets.length === 1 ? i18nService.getString('HostUi', 'actionRebootHostDialogTitle') :
                i18nService.getString('HostUi', 'actionRebootHostsDialogTitle'),
            subTitle: availableTargets.length > 1 ? "" : {
               objectId: availableTargets[0]
            },
            dialogData: {
               availableTargets: availableTargets
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/RebootConfirmation.html'
         };
         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editAdvancedSystemSettings'] = function(actionEval, availableTargets, context) {
         context = { selectedItems: vxGridSettingsService.getSelectedSettings() };
         var modalOptions = {
            title: i18nService.getString('HostUi', 'advancedSettings.edit.dialogTitle'),
            subTitle: {
               objectId: availableTargets[0]
            },
            dialogData: {
               availableTargets: availableTargets,
               selectedItems: context.selectedItems
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/advancedSystemSettings/editAdvancedSystemSettings.html',
            size: 'lg'
         };
         clarityModalService.openOkCancelModal(modalOptions);

      };

      h5.actions['vsphere.core.host.actions.enableEncryptionMode'] = function(actionEval, availableTargets, context) {
         mutationService.apply(context.entityId,
            'com.vmware.vsphere.client.host.config.HostEncryptionModeSpec',
            {'encryptionMode': 'safe'});
      };

      h5.actions['vsphere.core.host.actions.connectHost'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'actionConnectLabel'),
            subTitle: availableTargets.length > 1 ? "" : {
               objectId: availableTargets[0]
            },
            message: availableTargets.length > 1 ?
                  i18nService.getString('HostUi', 'confirmReconnect.multipleHostsWarning') :
                  i18nService.getString('HostUi', 'confirmReconnect.singleHostWarning'),
            icon: 'icon-warning-32',
            submit: function() {
               hostConnectionService.reconnect(availableTargets);
            },
            preserveNewlines: true
         };
         clarityModalService.openConfirmationModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.disconnectHost'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'actionDisconnectLabel'),
            subTitle: availableTargets.length > 1 ? "" : {
               objectId: availableTargets[0]
            },
            message: availableTargets.length > 1 ? i18nService.getString('HostUi', 'confirmDisconnectHostsQuestion') :
                  i18nService.getString('HostUi', 'confirmDisconnectHostQuestion'),
            icon: 'icon-warning-32',
            submit: function() {
               hostConnectionService.disconnect(availableTargets);
            },
            preserveNewlines: true
         };
         clarityModalService.openConfirmationModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.reconfigureDAS'] = function(actionEval, availableTargets) {
         mutationService.applyOnMultiEntity(availableTargets,
               'com.vmware.vsphere.client.host.config.ReconfigureDasSpec', {});
      };

      h5.actions['vsphere.core.host.actions.removeHost'] = function(actionEval, availableTargets) {
         removeHostAction.perform(availableTargets);
      };

      h5.actions['vsphere.core.host.actions.editVmStartupShutdownAction'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'vmStartUp.editLabel'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/vmStartupShutdown/editVmStartupShutdown.html',
            size: 'lg',
            modalClass: 'editVmStartupShutdown'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editSwapfileLocation'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'editSwapfile.titleFormat'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/editVmSwapFileLocationView.html',
            size: 'lg',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editDefaultHwVersionAction'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'defaultVmCompatibilityDialog.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/EditDefaultVmCompatibility.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.navToSettings'] = function(actionEval, availableTargets) {
         $rootScope._navigateToViewAndObject('vsphere.core.host.manage', availableTargets[0]);
      };

      h5.actions['vsphere.core.host.actions.refreshServicesAction'] = function(actionEval, availableTargets) {
         mutationService.apply(availableTargets[0],
               'com.vmware.vsphere.client.host.config.RefreshServicesSpec', {});
      };

      h5.actions['vsphere.core.host.actions.addHost'] = function(actionEval, availableTargets) {
         addHostWizardService.showWizard(availableTargets[0], actionEval);
      };

      h5.actions['vsphere.core.host.actions.service.editStartupPolicy'] =
            function(actionEval, availableTargets, dialogData) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'service.edit.startup.policy.title'),
            subTitle: {
               text: dialogData.service.label
            },
            defaultButton: 'submit',
            contentTemplate:
                  'host-ui/resources/host/views/settings/hostServices/editServiceStartupPolicyDialog.html',
            modalClass: 'edit-service-startup-policy-dialog',
            dialogData: {
               model: {
                  service: dialogData.service,
                  hostId: dialogData.hostId
               }
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editFirewallSettings'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'editFirewallSettingsDialog.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate:
                  'host-ui/resources/host/views/settings/editFirewallSettingsDialog.html',
            size: 'lg',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editTimeConfigurationSettings'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'timeConfig.editTimeConfiguration'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            size: 'lg',
            contentTemplate: 'host-ui/resources/host/views/settings/timeConfiguration/editTimeConfigurationDialog.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.authenticationServiceSettingsJoinDomain'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'authJoinDomain.tiwoName'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            modalClass: 'edit-auth-join-domain-dialog',
            contentTemplate:
                  'host-ui/resources/host/views/settings/authenticationServices/authJoinDomainDialog.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.authenticationServiceSettingsLeaveDomain'] = function(actionEval, availableTargets) {
         hostAuthService.leaveDomain(availableTargets[0]);
      };

      h5.actions['vsphere.core.host.actions.authenticationServiceSettingsAddCertificate'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'importCert.actionDescription'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            modalClass: 'edit-auth-add-certificate-dialog',
            contentTemplate:
                  'host-ui/resources/host/views/settings/authenticationServices/authImportCertificateDialog.html',
            dialogData: {
               availableTargets: availableTargets
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editImageProfile'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'imageProfileAcceptance.label'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/securityProfile/editImageProfileAcceptanceLevel.html'
         };
         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editEncryptionMode'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi','hostEncryption.edit.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/securityProfile/editEncryptionMode.html'
         };
         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editLockdownMode'] = function(actionEval, availableTargets) {
         securityProfileDialogService.show(availableTargets[0], actionEval);
      };

      h5.actions['vsphere.core.host.configissues.SuppressESXiAndSSHConfigIssue'] = function(actionEval, availableTargets) {
         suppressWarningSettingService.suppressWarnings(availableTargets[0],
               suppressWarningSettingConstants.SUPPRESS_SHELL_WARNING_KEY);
      };

      h5.actions['vsphere.core.host.configissues.SuppressHyperthreadWarning'] = function(actionEval, availableTargets) {
         suppressWarningSettingService.suppressWarnings(availableTargets[0],
               suppressWarningSettingConstants.SUPPRESS_HYPERTHREAD_WARNING_KEY);
      };


      h5.actions['vsphere.core.host.actions.editSystemSwap'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi','userWorldSwap.edit.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            dialogData: {
               availableTargets: availableTargets
            },
            modalClass: 'edit-system-swap-settings',
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/systemSwap/editSystemSwapSettingsView.html'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.refreshCertificate'] = function(actionEval, availableTargets) {
         refreshCertificateService.refreshCertificate(availableTargets[0]);
      };

      h5.actions['vsphere.core.host.actions.refreshCaCertificate'] = function(actionEval, availableTargets) {
         refreshCertificateService.refreshCaCertificate(availableTargets[0]);
      };

      h5.actions['vsphere.core.host.configissues.SuppressNoRedundantManagementNetworkIssue'] = function(actionEval, availableTargets) {
         var hostId = availableTargets[0];
         var operationName = i18nService.getString(
               'HostUi', 'SuppressHostNoRedundantManagementNetwork.taskName');
         mutationService.apply(hostId,
               'com.vmware.vsphere.client.host.config.SuppressHostNoRedundantManagementNetworkWarningSpec',
               {}, operationName
         );
      };

      h5.actions['vsphere.core.host.actions.editProcessorGeneralConfig'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'processorConfig.generalConfiguration'),
            subTitle: {
               objectId: availableTargets[0]
            },
            icon: 'icon-warning-32',
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/processors/editHardwareProcessorsView.html'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editBootOptions'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'bootDevice.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            icon: 'icon-warning-32',
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/processors/editBootOptions.html'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editPciDevices'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'vmdpConfig.edit.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/pciDevices/editPciDevicesView.html',
            size: 'lg'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.moveHostTo'] = function(actionEval, availableTargets) {

            var modalOptions = {
               title: i18nService.getString('HostUi', 'actionMoveHostTitle'),
               subTitle: {
                  objectId: availableTargets[0]
               },
               defaultButton: 'submit',
               dialogData: {
                  objectIds: availableTargets
               },
               contentTemplate: 'host-ui/resources/host/views/settings/moveto/moveToDialog.html'
            };
            clarityModalService.openOkCancelModal(modalOptions);

      };

      h5.actions['vsphere.core.host.actions.editHostGraphics'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'settings.graphics.editHostConfigForm.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/graphics/editHostGraphicsSettingsView.html'
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };
      h5.actions['vsphere.core.host.actions.refreshPciDevices'] = function(actionEval, availableTargets) {
         var hostId = availableTargets[0];
         mutationService.apply(
               hostId,
               'com.vmware.vsphere.client.h5.host.vmdp.spec.HostVmdpRefreshSpec',
               {});
      };

      h5.actions['vsphere.core.host.actions.moveHostToDrag'] = function(actionEval, availableTargets, destinationTarget) {
         moveHostToService.moveHostTo(destinationTarget.dropTarget, availableTargets);
      };

      h5.actions['vsphere.core.host.actions.editSmartCardAuthentication'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'smartCardAuthnetication.title'),
            subTitle: {
               objectId: availableTargets[0]
            },
            size: 'lg',
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/authenticationServices/editSmartCardAuthenticationDialog.html',
            objectId: availableTargets[0]
         };

         clarityModalService.openOkCancelModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.clearNfsKerberosCredentials'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'nfsCredentials.clear.confirm.title'),
            message: i18nService.getString('HostUi', 'nfsCredentials.clear.confirm.text'),
            icon: "icon-warning-32",
            submit: function() {
               mutationService.apply(
                     availableTargets[0],
                     'com.vmware.vsphere.client.storage.NfsClearCredentialsSpec',
                     {});
               return true;
            },
            preserveNewlines: true
         };

         clarityModalService.openConfirmationModal(modalOptions);
      };

      h5.actions['vsphere.core.host.actions.editNfsKerberosCredentials'] = function(actionEval, availableTargets) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'nfsCredentials.edit.dialogTitle'),
            subTitle: {
               objectId: availableTargets[0]
            },
            size: 'md',
            defaultButton: 'submit',
            contentTemplate: 'host-ui/resources/host/views/settings/authenticationServices/editNfsKerberosCredentialsDialog.html',
            objectId: availableTargets[0]
         };
         clarityModalService.openOkCancelModal(modalOptions);
      };

      /*
       * Action 'Assign License' to a host.
       */
      h5.actions["vsphere.core.host.assignLicenseKeyAction"] = function(actionEval, availableTargets) {
         if (_.isEmpty(availableTargets)) {
            return;
         }

         assignLicenseService.showAssignLicenseForm(availableTargets);
      };

      /*
       * Export system logs on single host.
       */
      h5.actions["vsphere.core.host.exportLogsAction"] = function(actionEval, availableTargets, context) {
         if (_.isEmpty(availableTargets)) {
            return;
         }

         vscExportWizardLauncherService.showSystemLogExportDialog(availableTargets);
      };
      var angularZone = window.Zone.current;
      /*
       * Action 'Add Hosts' to a cluster.
       */
      h5.actions['vsphere.core.hci.addHosts'] = function (actionEval, availableTargets) {
         angularZone.run(function () {
            var clusterId = availableTargets[0];
            hciCapabilityService.checkHCISupported(clusterId).then(
                  function (isHCISupported) {
                     vuiUtils.safeApply($rootScope, function () {
                        if (isHCISupported) {
                           addHostsActionWizardService.openWizard(clusterId);
                        } else {
                           addHostWizardService.showWizard(clusterId);
                        }
                     });
                  });
         });
      };
   }]);

var host_ui;
(function (host_ui) {
    var AddHostsActionWizardService = (function () {
        function AddHostsActionWizardService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(AddHostsActionWizardService.prototype, "addHostsActionWizardService", {
            get: function () {
                if (!this._addHostsActionWizardService) {
                    this._addHostsActionWizardService = this.$injector.get("hciAddHostsActionWizardService");
                }
                return this._addHostsActionWizardService;
            },
            enumerable: true,
            configurable: true
        });
        AddHostsActionWizardService.prototype.openWizard = function (clusterId) {
            return this.addHostsActionWizardService.openWizard(clusterId);
        };
        AddHostsActionWizardService.$inject = ['$injector'];
        return AddHostsActionWizardService;
    }());
    host_ui.AddHostsActionWizardService = AddHostsActionWizardService;
    angular.module("com.vmware.vsphere.client.host").service("addHostsActionWizardService", AddHostsActionWizardService);
})(host_ui || (host_ui = {}));



angular.module('com.vmware.vsphere.client.host')
      .constant('helpConstants', {
         EDIT_DEFAULT_VM_COMPATIBILITY_ID: "com.vmware.vsphere.vm_admin.doc.vc_312"
      });

(function () {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:hostServiceStartupPolicy
    *
    * @description
    *    Represents vim.host.Service.Policy enum values.
    *    
    *    List of available constants
    *    
    *    - **`ON`** : Service should be started when the host starts up.
    *    - **`OFF`** : Service should not be started when the host starts up.
    *    - **`AUTOMATIC`** : Service should run if and only if it has open firewall ports.
    */
   angular
      .module('com.vmware.vsphere.client.host')
      .constant('hostServiceStartupPolicy', {
         ON: 'on',
         OFF: 'off',
         AUTOMATIC: 'automatic'
      });
})();

(function () {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:systemSwapSettingsConstants
    *
    * @description
    *    - admissionControlPolicy
    *       - **`DATASTORE_OPTION_TYPE`** : Datastore system swap configuration option type
    *       - **`HOST_CACHE_OPTION_TYPE`** : Host cache system swap configuration option type
    *       - **`HOST_LOCAL_SWAP_OPTION_TYPE`** : Host local system swap configuration option type
    *       - **`DISABLED_TYPE`** : Disable system swap configuration option type
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('systemSwapConfigurationConstants', {
            systemSwapConfigurationOptionType: {
               DATASTORE_OPTION_TYPE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$DatastoreOption',
               HOST_CACHE_OPTION_TYPE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$HostCacheOption',
               HOST_LOCAL_SWAP_OPTION_TYPE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$HostLocalSwapOption',
               DISABLED_TYPE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$DisabledOption'
            }
         });
})();

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.host')
         .service('bytesFormatter', BytesFormatterService);

   BytesFormatterService.$inject = ['i18nService', 'numberFormatterService'];

   function BytesFormatterService(i18nService, numberFormatterService) {

      var UNIT_FACTOR_B = 1024;

      var KB = UNIT_FACTOR_B;
      var MB = KB * UNIT_FACTOR_B;
      var GB = MB * UNIT_FACTOR_B;
      var TB = GB * UNIT_FACTOR_B;
      var LABEL_KB = i18nService.getString('CommonUi', 'kiloByte.label');
      var LABEL_MB = i18nService.getString('CommonUi', 'megaByte.label');
      var LABEL_GB = i18nService.getString('CommonUi', 'gigaByte.label');
      var LABEL_TB = i18nService.getString('CommonUi', 'teraByte.label');

      function bytesFormat(value) {
         var label = i18nService.getString('CommonUi', 'byte.label');
         if (value >= TB) {
            value /= TB;
            label = LABEL_TB;
         } else if (value >= GB) {
            value /= GB;
            label = LABEL_GB;
         } else if (value >= MB) {
            value /= MB;
            label = LABEL_MB;
         } else if (value >= KB) {
            value /= KB;
            label = LABEL_KB;
         }

         return numberFormatterService.format(value, {
            fractionSize: 2,
            suffix: label
         });
      }

      return {
         bytesFormat: bytesFormat
      };
   }
}());

(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.host')
      .service('confirmationDialogWithReasonService', confirmationDialogWithReasonService);

   confirmationDialogWithReasonService.$inject = ['i18nService', 'vuiConstants', 'mutationService', 'dataService'];

   function confirmationDialogWithReasonService(i18nService, vuiConstants, mutationService, dataService) {

      return {
         fetchHostNameAndMaintenanceModeStatus: fetchHostNameAndMaintenanceModeStatus,
         fetchHostsNameAndMaintenanceModeStatus: fetchHostsNameAndMaintenanceModeStatus,
         fetchHostsRebootData: fetchHostsRebootData,
         onOKClicked: onOKClicked
      };

      function fetchHostNameAndMaintenanceModeStatus(hostId, updateControllerCallback) {
         dataService.getProperties(hostId, ['name', 'inMaintenanceMode']).then(function (properties) {
            updateControllerCallback(properties.name, properties.inMaintenanceMode);
         });
      }

      function fetchHostsNameAndMaintenanceModeStatus(hostIds, updateMultipleControllerCallback) {
         dataService.getPropertiesForObjects(hostIds, ['name', 'inMaintenanceMode']).then(function (data) {
            _.each(hostIds, function(hostId, index) {
               var loading = true;
               if (index === hostIds.length - 1) {
                  loading = false;
               }
               updateMultipleControllerCallback(data[hostId].name, data[hostId].inMaintenanceMode, hostId, loading);

            });
         });
      }

      function fetchHostsRebootData(hostIds, updateMultipleControllerCallback) {
         dataService.getPropertiesForObjects(hostIds, ['name', 'inMaintenanceMode',
            'config.vsanHostConfig.enabled']).then(function (data) {
            _.each(hostIds, function(hostId, index) {
               var loading = true;
               if (index === hostIds.length - 1) {
                  loading = false;
               }

               updateMultipleControllerCallback(data[hostId].name, data[hostId].inMaintenanceMode,
                     data[hostId]['config.vsanHostConfig.enabled'], hostId, loading);
            });
         });
      }

      function onOKClicked(getReason, getOnlyMmHosts, type, modalOptions, targets, getMmHosts) {
         if (!getReason()) {
            showError(i18nService.getString('HostUi', 'bootDevice.rebootAndShutdownReasonEnterReason'), modalOptions);
            return false;
         }

         var hostPowerSpec = {powerOpType: type, reason: getReason(), force: true};
         if (getOnlyMmHosts()) {
            if(getMmHosts().length === 0) {
               return true;
            }
            mutationService.applyOnMultiEntity(getMmHosts(), 'com.vmware.vsphere.client.host.powerops.HostPowerSpec',
                hostPowerSpec);
         } else {
            mutationService.applyOnMultiEntity(targets, 'com.vmware.vsphere.client.host.powerops.HostPowerSpec',
                hostPowerSpec);
         }
         return true;
      }

      function showError(errorMessage, modalOptions) {
         modalOptions.alerts = [{
            text: errorMessage,
            type: vuiConstants.validationBanner.type.ERROR
         }];
      }
   }
}());


angular.module('com.vmware.vsphere.client.host').service('connectInfoParser', [
   function() {
      return {
         parse: function(connectInfo) {
            var parsedConnectInfo = {};
            parsedConnectInfo.connectInfo = connectInfo;
            parsedConnectInfo.name = connectInfo.host.config.name;
            parsedConnectInfo.vendor = connectInfo.host.hardware.vendor;
            parsedConnectInfo.model = connectInfo.host.hardware.model;
            parsedConnectInfo.version = connectInfo.host.config.product.fullName;
            parsedConnectInfo.vms = _.map(connectInfo.vm, function(vm) {
               return vm.config.name;
            });
            parsedConnectInfo.networks = _.map(connectInfo.network, function(network) {
               return network.summary.name;
            });
            parsedConnectInfo.datastores = _.map(connectInfo.datastore, function(datastore) {
               return datastore.summary.name;
            });
            parsedConnectInfo.serverIp = connectInfo.serverIp;
            parsedConnectInfo.hostAccessManagerAvailable =
               !!connectInfo.capability && connectInfo.capability.hostAccessManagerSupported;
            return parsedConnectInfo;
         }
      };
   }]
);
(function() {
   'use strict';

   /**
    * Service that provides cluster HCI capability information.
    */
   angular.module('com.vmware.vsphere.client.host')
      .service('hciCapabilityService', hciCapabilityService);

   hciCapabilityService.$inject = ['dataService', "defaultUriSchemeUtil"];

   function hciCapabilityService(dataService, defaultUriSchemeUtil) {
      var hciSupportMap = {};

      return {
         checkHCISupported: checkHCISupported
      };

      function checkHCISupported(clusterId) {
         var clusterRef =
               defaultUriSchemeUtil.getManagedObjectReference(clusterId);

         if (!hciSupportMap[clusterRef.serverGuid]) {
            var serviceInstanceRef = {
               "value": "ServiceInstance",
               "type": "ServiceInstance",
               "serverGuid": clusterRef.serverGuid
            };
            var serviceInstanceId =
                  defaultUriSchemeUtil.getVsphereObjectId(serviceInstanceRef);

            hciSupportMap[clusterRef.serverGuid] = dataService.getProperties(
                  serviceInstanceId, ["capability.hciWorkflowSupported"])
                  .then(function (data) {
                     return data ? !!data["capability.hciWorkflowSupported"] : false;
                  });
         }

         return hciSupportMap[clusterRef.serverGuid];
      }
   }
})();

angular.module('com.vmware.vsphere.client.host').factory('HostAdder', [
   'mutationService',
   'defaultUriSchemeUtil',
   'managedEntityConstants',
   'dataService',
   'hostnameParser',
   'lockdownModeStrings',
   'addHostWizardPageModelGetter',
   'licenseCommonUtil',
   'connectInfoParser',
   'i18nService',
   'addHostWizardConstants',
   'vscSchedulingHelper',
   function(mutationService,
         defaultUriSchemeUtil,
         managedEntityConstants,
         dataService,
         hostnameParser,
         lockdownModeStrings,
         addHostWizardPageModelGetter,
         licenseCommonUtil,
         connectInfoParser,
         i18nService,
         addHostWizardConstants,
         vscSchedulingHelper) {
      return function HostAdder() {
         var state = {};

         var manager = {
            getNameLocationPageModel: addHostWizardPageModelGetter.getNameLocationPageModel.bind(this, state),
            getConnectionSettingsPageModel: addHostWizardPageModelGetter.getConnectionSettingsPageModel.bind(this, state),
            getHostSummaryPageModel: addHostWizardPageModelGetter.getHostSummaryPageModel.bind(this, state),
            getAssignLicensePageModel: addHostWizardPageModelGetter.getAssignLicensePageModel.bind(this, state),
            getLockdownModePageModel: addHostWizardPageModelGetter.getLockdownModePageModel.bind(this, state),
            getVmLocationPageModel: addHostWizardPageModelGetter.getVmLocationPageModel.bind(this, state),
            getResourceLocationPageModel: addHostWizardPageModelGetter.getResourceLocationPageModel.bind(this, state),
            getResourcePoolInput: addHostWizardPageModelGetter.getResourcePoolInput.bind(this, state),
            getReadyToCompletePageModel: addHostWizardPageModelGetter.getReadyToCompletePageModel.bind(this, state),
            isHostnameValid: addHostWizardPageModelGetter.isHostnameValid.bind(this, state),
            isUsernameValid: addHostWizardPageModelGetter.isUsernameValid.bind(this, state),
            getHostAlreadyManagedMessage: addHostWizardPageModelGetter.getHostAlreadyManagedMessage.bind(this, state),
            getStateLoadedFlag: addHostWizardPageModelGetter.getStateLoadedFlag.bind(this, state),
            getDestinationUid: addHostWizardPageModelGetter.getDestinationUid.bind(this, state),
            getScheduleTaskPageModel: addHostWizardPageModelGetter.getScheduleTaskPageModel.bind(this, state),

            getLastAssetAssignLicenseValidationResult: function() {
               return state.lastAssetAssignLicenseValidationResult;
            },

            getErrorInResponse: function() {
               return state.errorInResponse;
            },

            setStateLoadedFlag: function(value) {
               state.loadedFlag = value;
            },

            setDatacenter: function(dc) {
               state.dc = dc;
            },

            setDestination: function(destination) {
               state.destination = {
                  ref: destination.ref,
                  name: destination.name,
                  icon: destination.icon,
                  drsState: destination.drsState
               };
            },

            setDestinationUid: function(destinationUid) {
               state.destinationUid = destinationUid;
            },

            isDestinationCluster: function() {
               return state.destination && state.destination.ref.type === managedEntityConstants.CLUSTER;
            },

            isDestinationDrsEnabledCluster: function() {
               return this.isDestinationCluster() && state.destination.drsState;
            },

            setOperationName: function(name) {
               state.operationName = name;
            },

            setHostname: function(hostname) {
               state.userEnteredHostname = hostname;
               var parsedHostname = hostnameParser.parse(hostname);
               if (parsedHostname) {
                  state.hostname = parsedHostname.hostname;
                  state.port = parsedHostname.port;
               } else {
                  state.hostname = null;
                  state.port = null;
               }
            },

            setHostUid: function(hostUid) {
               state.hostUid = hostUid;
            },

            setReconnectHost: function(reconnectHost) {
               state.reconnectHost = reconnectHost;
            },

            setUserSelectedLicense: function(license) {
               state.userSelectedLicense = license;
            },

            setConnectInfo: function(connectInfo) {
               _.extend(state, connectInfoParser.parse(connectInfo));
            },

            setConnectionSettings: function(settings) {
               state.username = settings.username;
               state.password = settings.password;
            },

            setSslThumbprint: function(thumbprint) {
               state.sslThumbprint = thumbprint;
            },

            setVmLocation: function(vmLocation) {
               state.vmLocation = {
                  ref: vmLocation.ref,
                  displayName: vmLocation.displayName
               };
            },

            setResourceLocationType: function(resourceLocationType) {
               state.resourceLocationType = resourceLocationType;
            },

            setResourceLocationName: function(resourceLocationName) {
               state.resourceLocationName = resourceLocationName;
            },

            setLockdownMode: function(lockdownMode) {
              state.lockdownMode = lockdownMode;
            },

            isReconnectHost: function() {
               return state.reconnectHost;
            },

            setScheduleTaskPageModel: function(scheduleTaskPageModel) {
               state.scheduleTaskPageModel = scheduleTaskPageModel;
            },

            /**
             * Requests all licenses for a vCenter instance and saves the query so it can be used in @function validateLicense.
             */
            prepareLicenseValidation: function (model) {
               state.preFetchedLicenses = dataService
                     .getProperties(model.rootFolder, ['licenses'], { skipErrorInterceptor: true })
                     .catch(function() {
                        // Return null to notify that no licenses were retrieved successfully.
                        return null;
                     });
            },
            validateLicense: function (model) {
               state.lastAssetAssignLicenseValidationResult = null;

               return state.preFetchedLicenses.then(function (licenseData) {
                  var licenses = licenseData ? licenseData.licenses : null;
                  return mutationService.validateSpec(
                     "com.vmware.license.client.cis.management.ds.specs.AssetAssignLicenseConnectInfoValidateSpec",
                     {
                        connectInfo: model.connectInfo,
                        scope: {
                           id: model.serverGuid
                        },
                        licenses: licenses
                     }
                  ).then(
                     function (response) {
                        if (response && response.result) {
                           var validationResult = response.result;
                           licenseCommonUtil.normalizeValidationResult(
                              validationResult
                           );
                           state.lastAssetAssignLicenseValidationResult = validationResult;

                           return validationResult;
                        } else {
                           state.errorInResponse = response.error;
                        }
                     }
                  );
               });
            },

            validateConnection: function() {
               var objectId;
               if (state.reconnectHost) {
                  objectId = state.hostUid;
               } else {
                  objectId = defaultUriSchemeUtil.getVsphereObjectId(state.destination.ref);
               }
               return mutationService.validate(
                     objectId,
                     'com.vmware.vsphere.client.host.add.HostConnectionSpec',
                     buildHostConnectionSpec()
               );
            },

            submit: function() {
               if (!state.vmLocation || state.vmLocation.ref.type === managedEntityConstants.FOLDER) {
                  addHost();
               } else {
                  dataService.getProperties(defaultUriSchemeUtil.getVsphereObjectId(state.vmLocation.ref), ['vmFolder']).then(function(data) {
                     state.vmLocation.ref = data.vmFolder;
                     addHost();
                  });
               }
            }
         };

         function addHost() {
            if (state.reconnectHost) {
               mutationService.apply(state.hostUid,
                     'com.vmware.vsphere.client.host.connection.api.HostConnectionStateSpec',
                     buildHostConnectionStateSpec(),
                     state.operationName
               );
            } else {
               if (!!state.scheduleTaskPageModel) {
                  mutationService.add(
                     'com.vmware.vise.data.scheduling.ScheduledMutationOperationSpec',
                     buildHostAddScheduledTaskSpec());
               } else {
                  mutationService.add(
                     'com.vmware.vsphere.client.host.add.HostAddSpec',
                     buildHostAddSpec(),
                     state.operationName);
               }
            }
         }

         function buildHostConnectionSpec() {
            var spec = {
               hostName: state.hostname,
               hostPort: state.port,
               userName: state.username,
               password: state.password,
               sslThumbprint: state.sslThumbprint
            };

            return spec;
         }

         function buildHostAddSpec() {
            var licenseKey = null;
            var hasEmbeddedOemLicense = state.userSelectedLicense.embeddedOem &&
                  state.userSelectedLicense.embeddedOem.toLowerCase() === "true";
            if (!hasEmbeddedOemLicense &&
                  !_.isEmpty(state.userSelectedLicense.serialKeys)) {
               licenseKey = state.userSelectedLicense.serialKeys[0];
            }

            var spec = _.extend(buildHostConnectionSpec(), {
               container: state.destination.ref,
               licenseKey: licenseKey
            });

            if (state.vmLocation) {
               spec.vmFolder = state.vmLocation.ref;
            }

            if (state.hostAccessManagerAvailable) {
               spec.lockdownMode = lockdownModeStrings.forSpec(state.lockdownMode);
               spec.enableLockDownMode = false;
            } else {
               spec.enableLockDownMode = state.lockdownMode === 'normal';
            }

            if (state.resourceLocationType === addHostWizardConstants.RESOURCE_LOCATION_NEW) {
               spec.newRpName = state.resourceLocationName;
            }

            return spec;
         }

         function buildHostAddScheduledTaskSpec() {

            var hostSpec = buildHostAddSpec();
            var mutationSpec = state.scheduleTaskPageModel;

            mutationSpec.spec = hostSpec;
            mutationSpec.spec._type = 'com.vmware.vsphere.client.host.add.HostAddSpec';
            mutationSpec.schedulingSpec.recurrence =
               vscSchedulingHelper.formatRecurrenceData(mutationSpec.schedulingSpec.recurrence);
            return mutationSpec;
         }

         /**
          * Builds a <code>HostConnectionStateSpec</code> for requesting host reconnection.
          */
         function buildHostConnectionStateSpec() {
            var connectSpec = _.extend(buildHostConnectionSpec(), {
               _type: 'com.vmware.vim.binding.vim.host.ConnectSpec',
               force: true
            });

            if (state.vmLocation) {
               connectSpec.vmFolder = state.vmLocation.ref;
            }

            var spec = {
               connectionOpType: 'connect',
               connectSpec: connectSpec
            };

            return spec;
         }

         return manager;
      };
   }
]);

angular.module('com.vmware.vsphere.client.host')
      .service('hostDataValidationService', [function () {
         var DOMAIN_NAME_REGEX = /^[a-zA-Z0-9]+([\.\-]?[a-zA-Z0-9]+)*\.[a-zA-Z]+(\/(.)+)*$/;
   return {
      isDomainValid:function(domain){
         return DOMAIN_NAME_REGEX.test(domain);
      }
   };
}]);

angular.module('com.vmware.vsphere.client.host').service('hostnameParser', [
   'ipParserService',
   function(ipParserService) {
      var DIGIT_REG_EX = new RegExp("^\\d+$");
      var DEFAULT_PORT = -1;

      return {
         parse: function(rawHostname) {
            if (!rawHostname) {
               return undefined;
            }

            var parsedAsIpAddress = parseAsIp(rawHostname);
            if (parsedAsIpAddress) {
               return parsedAsIpAddress;
            }

            var parsedAsHostname = parseAsHostname(rawHostname);
            if (parsedAsHostname && !containsInvalidChars(parsedAsHostname.hostname)) {
               return parsedAsHostname;
            }

            return undefined;
         }
      };

      function parseAsIp(hostname) {
         var parsedIpAddress = ipParserService.parse(hostname);
         if (parsedIpAddress) {
            return {
               hostname: parsedIpAddress.address,
               port: parsedIpAddress.port || DEFAULT_PORT
            };
         } else {
            return null;
         }
      }

      function parseAsHostname(hostname) {
         var indexOfPort = hostname.lastIndexOf(":");
         if (indexOfPort < 0) {
            return {
               hostname: hostname,
               port: DEFAULT_PORT
            };
         }

         var port = hostname.substring(indexOfPort + 1, hostname.length);
         if (DIGIT_REG_EX.test(port)) {
            return {
               hostname: hostname.substring(0, indexOfPort),
               port: parseInt(port)
            };
         }

         return undefined;
      }

      function containsInvalidChars(hostname) {
         var invalidCharacters = ['!', '@', '#', '%', '$', '^', '&', '*', ':'];

         for (var i = 0; i < invalidCharacters.length; i++) {
            if (hostname.indexOf(invalidCharacters[i]) > DEFAULT_PORT) {
               return true;
            }
         }

         return false;
      }

   }]
);
angular.module('com.vmware.vsphere.client.host').service('hostVuiService', ['vuiWizardService', function (vuiWizardService) {
   return {
      createWizard: vuiWizardService
   };
}]);

angular.module('com.vmware.vsphere.client.host').service('lockdownModeStrings', ['i18nService',
   function(i18nService) {
      var lockdownModeSpecStrings = {
         disabled: 'lockdownDisabled',
         normal: 'lockdownNormal',
         strict: 'lockdownStrict'
      };

      var lockdownModeDisplayStrings = {
         disabled: 'addHostWizard.confirmationPage.lockDownModeValueDisabled',
         normal: 'addHostWizard.confirmationPage.lockDownModeValueNormal',
         strict: 'addHostWizard.confirmationPage.lockDownModeValueStrict'
      };

      return {
         forSpec: function(lockdownMode) {
            return lockdownModeSpecStrings[lockdownMode];
         },

         forDisplay: function(lockdownMode) {
            var key = lockdownModeDisplayStrings[lockdownMode];
            if (key) {
               return i18nService.getString('HostUi', key);
            } else {
               return undefined;
            }
         }
      };
   }]
);

angular.module('com.vmware.vsphere.client.host')
      .factory('hostConnectionService',
            ['dataService', 'mutationService', 'alertService',
               'i18nService', 'addHostWizardService', 'defaultUriSchemeUtil',
               function(dataService, mutationService, alertService,
                        i18nService, addHostWizardService, defaultUriSchemeUtil) {
                  var reconnect = function(availableTargets) {
                     var hostConnectionSpec = { connectionOpType: 'connect' };
                     var operationName = i18nService.getString('HostUi',
                           'reconnectHostOperation.name');

                     mutationService.applyOnMultiEntity(availableTargets,
                           'com.vmware.vsphere.client.h5.host.connect.spec.ReconnectConnectionStateSpec',
                           hostConnectionSpec,
                           operationName).then(function(operationResults) {
                        for (var i = 0; i < operationResults.length; i++) {
                           if (operationResults[i].error) {
                              addHostWizardService.showWizardInReconnectState(
                                    defaultUriSchemeUtil.getVsphereObjectId(operationResults[i].entity));
                              break;
                           }
                        }
                     });
                     return true;
                  };

                  var disconnect = function(availableTargets) {
                     var hostConnectionSpec = { connectionOpType: 'disconnect' };

                     mutationService.applyOnMultiEntity(availableTargets,
                           'com.vmware.vsphere.client.host.connection.api.HostConnectionStateSpec',
                           hostConnectionSpec);
                     return true;
                  };

                  return {
                     reconnect: reconnect,
                     disconnect: disconnect
                  };

               }
            ]);

angular.module('com.vmware.vsphere.client.host')
      .factory('removeHostAction',
            ['dataService', 'mutationService', 'alertService', 'i18nService', 'clarityModalService',
               'defaultUriSchemeUtil', 'hostConnectionState',
               function (dataService, mutationService, alertService, i18nService, clarityModalService,
                     defaultUriSchemeUtil, hostConnectionState) {
                  var perform = function (objectIds) {
                     var groupedHosts = [];
                     getGroupedHosts(objectIds).then(function (result) {
                        groupedHosts = result;

                        if (groupedHosts.removableHostsNames.length === 0 && groupedHosts.nonRemovableHosts.length > 0) {
                           showError(groupedHosts.nonRemovableHosts);
                        } else {
                           showConfirmation(groupedHosts.removableHostsNames, function() {
                              mutationService.removeOnMultiEntity(
                                 groupedHosts.removableHostsObjToRemoveId);

                              if (groupedHosts.nonRemovableHosts.length > 0) {
                                 showError(groupedHosts.nonRemovableHosts);
                              }
                           });
                        }
                     });
                  };

                  return {
                     perform: perform
                  };


                  function showConfirmation(targetNames, onSubmitCallback){
                     var modalOptions  = {
                        title: targetNames.length > 1 ?
                              i18nService.getString('HostUi','actionRemoveHostsCaption') :
                              i18nService.getString('HostUi','actionRemoveHostCaption'),
                        subTitle: targetNames.length > 1 ? "" : {
                           text: targetNames[0]
                        },
                        message: targetNames.length > 1 ?
                              i18nService.getString('HostUi', 'actionRemoveHostsWarning', targetNames) :
                              i18nService.getString('HostUi', 'actionRemoveHostWarning'),
                        saveButtonLabel: i18nService.getString('Common', 'yes.label'),
                        cancelButtonLabel: i18nService.getString('Common', 'no.label'),
                        preserveNewlines: true,
                        icon: 'vx-icon-warning-32x32',
                        submit: onSubmitCallback
                     };

                     clarityModalService.openConfirmationModal(modalOptions);
                  }

                  function showError(targetObjectsName) {
                     var errorTitle = targetObjectsName.length > 1 ?
                           i18nService.getString('HostUi', 'actionRemoveHostsCaption', targetObjectsName) :
                           i18nService.getString('HostUi', 'actionRemoveHostCaption', targetObjectsName);
                     var errorText = targetObjectsName.length > 1 ?
                           i18nService.getString('HostUi', 'actionRemoveHostsError', targetObjectsName) :
                           i18nService.getString('HostUi', 'actionRemoveHostError', targetObjectsName);
                     alertService.error(errorTitle, errorText);
                  }

                  function getGroupedHosts(objectIds) {
                     return dataService.getPropertiesForObjects(objectIds, ['parent', 'runtime', 'name'])
                           .then(function (data) {
                              var groupedHosts = {
                                 nonRemovableHosts: [],
                                 removableHostsNames: [],
                                 removableHostsObjToRemoveId: []
                              };
                              _.each(objectIds, function(objectId) {
                                 var parent = data[objectId].parent;
                                 var runtime = data[objectId].runtime;
                                 var name = data[objectId].name;
                                 if (parent.type === 'ClusterComputeResource' &&
                                       runtime.connectionState === hostConnectionState.CONNECTED &&
                                       !runtime.inMaintenanceMode) {
                                    groupedHosts.nonRemovableHosts.push(name);
                                 } else {
                                    var objectToRemoveId = (parent.type === 'ComputeResource')
                                          ? defaultUriSchemeUtil.getVsphereObjectId(parent)
                                          : objectId;
                                    groupedHosts.removableHostsNames.push(name);
                                    groupedHosts.removableHostsObjToRemoveId.push(objectToRemoveId);
                                 }
                              });
                              return groupedHosts;
                           });
                  }
               }
            ]);

angular.module('com.vmware.vsphere.client.host').factory('VuiWizardHelper', [
   '$rootScope', 'wizardPageService', 'hostVuiService', 'defaultUriSchemeUtil',
      'managedEntityConstants', 'dataService', 'addHostWizardConstants',
      'i18nService',
   function($rootScope, wizardPageService, hostVuiService, defaultUriSchemeUtil,
         managedEntityConstants, dataService, addHostWizardConstants, i18nService){
      return function VuiWizardHelper(title) {
         var wizardConfig;

         return {
            markPageComplete: function(flow) {
               wizardPageService.clearErrors(wizardConfig);
               return wizardPageService.markPageComplete(wizardConfig, flow);
            },
            markPageIncompleteWithError: function(message) {
               return wizardPageService.markPageIncompleteWithError(wizardConfig, message);
            },
            markPageIncompleteWithErrors: function(messages) {
               return wizardPageService.markPageIncompleteWithErrors(wizardConfig, messages);
            },
            clearErrors: function() {
               return wizardPageService.clearErrors(wizardConfig);
            },
            showLoadingIndicator: function() {
               return wizardPageService.showLoadingIndicator(wizardConfig);
            },
            hideLoadingIndicator: function() {
               return wizardPageService.hideLoadingIndicator(wizardConfig);
            },
            show: function(pages, manager, cssClass){
               wizardConfig = {
                  title: title,
                  pages: wizardPageService.initializePageStates(pages),
                  cssClass: cssClass,
                  resizeMinHeight: 500,
                  onFinish: function () {
                     manager.submit();
                     return true;
                  }
               };

               var wizardScope = $rootScope.$new();
               wizardScope.manager = manager;
               wizardScope.wizardConfig = wizardConfig;

               hostVuiService.createWizard({
                  scope: wizardScope,
                  configObjectName: 'wizardConfig'
               }).show();

               this.showLoadingIndicator();
               var self = this;
               fetchWizardData(manager).then(function() {
                  self.hideLoadingIndicator();
               });
            }
         };

         function fetchWizardData(hostAdder) {
            var destinationUid = hostAdder.getDestinationUid();
            var destinationRef = defaultUriSchemeUtil.getPartsFromVsphereObjectId(destinationUid);
            var propertiesToFetch;
            if (destinationRef.type === managedEntityConstants.DATACENTER) {
               propertiesToFetch = ['name', 'primaryIconId'];
            } else {
               propertiesToFetch = ['name', 'primaryIconId', 'dc', 'configuration.drsConfig.enabled'];
            }
            return dataService.getProperties(destinationUid, propertiesToFetch).then(function(properties) {
               if (destinationRef.type !== managedEntityConstants.DATACENTER) {
                  hostAdder.setDatacenter(properties.dc);
               } else {
                  hostAdder.setDatacenter(destinationRef);
               }

               hostAdder.setDestination({
                  ref: destinationRef,
                  name: properties.name,
                  icon: properties.primaryIconId,
                  drsState: properties["configuration.drsConfig.enabled"]
               });

               if (hostAdder.isDestinationDrsEnabledCluster()) {
                  hostAdder.setResourceLocationType(addHostWizardConstants.RESOURCE_LOCATION_ROOT);
               }
               reEvaluatePagesVisibility(hostAdder);
               hostAdder.setStateLoadedFlag(true);
            });
         }

         function reEvaluatePagesVisibility(hostAdder){
            _.each(wizardConfig.pages, function(page) {
               changePageVisibility(page,
                     i18nService.getString('HostUi', 'addHostWizard.assignLicensePage.title'),
                     assignLicenseAndLockdownPageCondition(hostAdder));
               changePageVisibility(page,
                     i18nService.getString('HostUi', 'addHostWizard.lockDownPage.title'),
                     assignLicenseAndLockdownPageCondition(hostAdder));
               changePageVisibility(page,
                     i18nService.getString('HostUi', 'addHostWizard.vmLocationPage.title'),
                     assignVmLocationPageCondition(hostAdder));
               changePageVisibility(page,
                     i18nService.getString('HostUi', 'addHostWizard.drsClusterRpPage.title'),
                     assignResourcePoolPageCondition(hostAdder));
            });
         }

         function changePageVisibility(page, title, condition) {
            if(condition && page.title === title){
                  wizardPageService.markPageSkipped(wizardConfig.pages, title);
            }
         }

         function assignLicenseAndLockdownPageCondition(hostAdder) {
            return hostAdder.isReconnectHost();
         }

         function assignVmLocationPageCondition(hostAdder) {
            return hostAdder.isDestinationCluster() && !hostAdder.isReconnectHost();
         }

         function assignResourcePoolPageCondition(hostAdder) {
            return !hostAdder.isDestinationDrsEnabledCluster() ||
                  hostAdder.isReconnectHost();
         }
      };
   }]
);

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('StandbyModeConfirmationController', StandbyModeConfirmationController);

   StandbyModeConfirmationController.$inject = ['$scope', 'mutationService', 'standbyModeConfirmationService', '$element', '$timeout' +
   ''];

   function StandbyModeConfirmationController($scope, mutationService, confirmationService, $element, $timeout) {
      var hostStandbySpec = {
         standbyOpType: 'enter'
      };
      var self = this;
      self.loading = true;
      self.confirmationData = [];
      self.hasWarningMessages = false;
      self.shouldEvacuateVms = false;

      var targets = $scope.modalOptions.dialogData.availableTargets;

      $scope.modalOptions.onSubmit = enterHostInStandByMode;
      $scope.evacuateVms = false;

      $scope.onEvacuateVmsChange = function(evacuateVms) {
         hostStandbySpec.evacuatePoweredOffVms = evacuateVms;
      };

      mutationService.validateOnMultiEntity(targets,
            'com.vmware.vsphere.client.host.standby.HostStandbySpec',
            hostStandbySpec).then(function(data) {
         //error handling
         var validationData = confirmationService.processStandbyValidationResult(data);

         self.confirmationData = validationData;
         self.hasWarningMessages = validationData.warningMessages.length > 0;
         self.shouldEvacuateVms = validationData.shouldEvacuateVms;
         self.loading = false;
      });

      function enterHostInStandByMode() {
         mutationService.applyOnMultiEntity(
               targets,
               'com.vmware.vsphere.client.host.standby.HostStandbySpec',
               hostStandbySpec
         );
         return true;
      }
   }

})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('standbyModeConfirmationService',
         StandbyModeConfirmationService);

   StandbyModeConfirmationService.$inject = ['i18nService'];

   function StandbyModeConfirmationService(i18nService) {
      function processStandbyValidationResult(data) {
         var warningMessages = [];
         var label, description;
         var shouldEvacuateVms = false;
         var lastStandbyExitUncertainHosts = [];
         var highAvailabilityCompromiseHosts = [];
         var highAvailabilityCompromiseClusters= [];

         var vmsPoweredOnHosts = [];
         _.each(data, function(validationResult) {
            if (validationResult.result.lastStandbyExitUncertain) {
               lastStandbyExitUncertainHosts.push(validationResult.result.hostName);
            }
            if (validationResult.result.highAvailabilityCompromise) {
               if(!highAvailabilityCompromiseHosts[validationResult.result.parentClusterName]) {
                  highAvailabilityCompromiseHosts[validationResult.result.parentClusterName] = [];
                  highAvailabilityCompromiseClusters.push(validationResult.result.parentClusterName);
               }
               highAvailabilityCompromiseHosts[validationResult.result.parentClusterName].push(validationResult.result.hostName);

            }
            if (validationResult.result.vmsPoweredOn) {
               vmsPoweredOnHosts.push(validationResult.result.hostName);
            }
            if(validationResult.result.drsEnabled && validationResult.result.vmsCount > 0) {
               shouldEvacuateVms = true;
            }
         });

         if (lastStandbyExitUncertainHosts.length > 0) {
            label = i18nService.getString(
                        'HostUi','ConfirmStandbyForm.lastStandbyUncertainWarningMessage.label');
            description =  i18nService.getString(
                     'HostUi','ConfirmStandbyForm.lastStandbyUncertainWarningMessage.description',
                lastStandbyExitUncertainHosts.join(', ') );
            messagePush(label, description);
         }

         _.each(highAvailabilityCompromiseClusters, function(cluster) {
            if (highAvailabilityCompromiseHosts[cluster].length > 0) {
               label = i18nService.getString(
                   'HostUi','ConfirmStandbyForm.highAvailabilityWarning.label');
               description =  i18nService.getString(
                   'HostUi','ConfirmStandbyForm.highAvailabilityWarning.description',
                   cluster,
                   highAvailabilityCompromiseHosts[cluster].join(', '));
               messagePush(label, description);
            }
         });

         if(vmsPoweredOnHosts.length > 0){
            label = i18nService.getString(
                  'HostUi','actionEnterStandbyVMsPoweredOnTitle');
            description =  i18nService.getString(
                  'HostUi','actionEnterStandbyVMsPoweredOn',
                vmsPoweredOnHosts.join(', '));
            messagePush(label, description);
         }

         return {
            hostname: data[0].result.hostName,
            warningMessages: warningMessages,
            shouldEvacuateVms: shouldEvacuateVms
         };
         function messagePush(label, description){
            var isExpanded = warningMessages.length === 0;
            warningMessages.push({
               shortDescription: label,
               message: description,
               expanded: isExpanded
            });
         }
      }

      return {
         processStandbyValidationResult: processStandbyValidationResult
      };
   }
})();

angular.module('com.vmware.vsphere.client.host').constant('addHostWizardConstants',
   {
      RESOURCE_LOCATION_ROOT: 'clusterRootResourcePool',
      RESOURCE_LOCATION_NEW: 'newResourcePool',
      LICENSE_RESOURCE_MODEL : 'License',
      LICENSE_PROPERTY : 'license',
      LICENSE_TYPE_PROPERTY : 'licenseType',
      LICENSE_SCOPE_PROPERTY : 'scope',
      LICENSE_SERIAL_KEY_TYPE : 'SERIAL_KEY'
   }
);

angular.module('com.vmware.vsphere.client.host').service('addHostWizardPageModelGetter', [
   'defaultUriSchemeUtil',
   'lockdownModeStrings',
   'managedEntityConstants',
   'addHostWizardConstants',
   'i18nService',
   'hostWizardScheduleTaskPageModel',
   function(defaultUriSchemeUtil,
            lockdownModeStrings,
            managedEntityConstants,
            addHostWizardConstants,
            i18nService,
            hostWizardScheduleTaskPageModel) {
      return {
         getNameLocationPageModel: function(state) {
            return {
               destinationName: state.destination.name,
               destinationIcon: state.destination.icon,
               hostname: state.userEnteredHostname,
               reconnectHost: state.reconnectHost
            };
         },

         getConnectionSettingsPageModel: function(state) {
            return {
               username: state.username,
               password: state.password
            };
         },

         getHostSummaryPageModel: function(state) {
            return {
               name: state.name,
               vendor: state.vendor,
               model: state.model,
               version: state.version,
               vms: state.vms,
               serverIp: state.serverIp
            };
         },

         getAssignLicensePageModel: function(state) {
            return {
               serverGuid: state.destination.ref.serverGuid,
               connectInfo: state.connectInfo,
               userSelectedLicense: state.userSelectedLicense
            };
         },

         getLockdownModePageModel: function(state) {
            return {
               lockdownMode: state.lockdownMode || 'disabled',
               showStrictModeOption: state.hostAccessManagerAvailable
            };
         },

         getVmLocationPageModel: function(state) {
            var model = {
               treeRoot: defaultUriSchemeUtil.getVsphereObjectId(state.dc)
            };

            if (state.vmLocation) {
               model.selectedLocationId = defaultUriSchemeUtil.getVsphereObjectId(state.vmLocation.ref);
            }

            return model;
         },

         getResourceLocationPageModel: function(state) {
            var resourceLocationName = state.resourceLocationName
               || i18nService.getString('HostUi', 'addHostWizard.defaultNewRpNameValueFormat', state.hostname);

            return {
               resourceLocationType: state.resourceLocationType,
               resourceLocationName: resourceLocationName
            };
         },

         getResourcePoolInput: function(state) {
            return {
               destination: state.destination.ref,
               type: state.resourceLocationType,
               name: state.resourceLocationName
            };
         },

         getReadyToCompletePageModel: function(state) {
            var model = {
               name: state.name,
               version: state.version,
               licenseName: state.userSelectedLicense ? state.userSelectedLicense.name : "",
               vms: state.vms,
               networks: state.networks,
               datastores: state.datastores,
               lockdownMode: lockdownModeStrings.forDisplay(state.lockdownMode),
               destinationName: state.destination.name,
               destinationIcon: state.destination.icon
            };

            if (state.vmLocation) {
               model.vmLocation = state.vmLocation.displayName;
            }

            if (state.destination.ref.type === managedEntityConstants.CLUSTER && state.destination.drsState === true) {
               if (state.resourceLocationType === addHostWizardConstants.RESOURCE_LOCATION_ROOT) {
                  model.destinationResourceLocation = state.destination.name;
               } else {
                  model.destinationResourceLocation = state.resourceLocationName;
               }
            }

            return model;
         },

         isHostnameValid: function(state) {
            return !!state.hostname;
         },

         isUsernameValid: function(state) {
            return state.username && state.username.length > 0;
         },

         getHostAlreadyManagedMessage: function(state) {

            if (!!state.serverIp) {
               var hasFtVmOnHost = false;
               if (!_.isEmpty(state.connectInfo.vm)) {
                  hasFtVmOnHost = _.any(state.connectInfo.vm, function(vm) { return vm.config && vm.config.ftInfo; });
               }

               var message = hasFtVmOnHost ?
                   i18nService.getString('HostUi', 'addHostWizard.hostSummaryPage.ftVmExistsOnHostMsgFormat', state.serverIp) :
                   i18nService.getString('HostUi', 'addHostWizard.hostSummaryPage.alreadyManagedMessageFormat', state.serverIp);

               return message;
            }
            return "";
         },

         getStateLoadedFlag: function(state){
            return state.loadedFlag;
         },

         getDestinationUid: function(state) {
            return state.destinationUid;
         },

         getScheduleTaskPageModel: function(state) {
            return {
               hostWizardScheduleTaskPageModel: state.scheduleTaskPageModel
            };
         }
      };
   }]
);

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service which handles the wizard showing and wiring the wizard steps
 */
angular.module('com.vmware.vsphere.client.host').service('addHostWizardService', [
   'hostVuiService',
   'i18nService',
   'dataService',
   '$rootScope',
   'addHostNameLocationPageService',
   'addHostConnectionSettingsPageService',
   'addHostHostSummaryPageService',
   'addHostAssignLicensePageService',
   'addHostLockdownModePageService',
   'addHostVmLocationPageService',
   'addHostResourceLocationPageService',
   'addHostReadyToCompletePageService',
   'HostAdder',
   'vuiConstants',
   'wizardPageService',
   'defaultUriSchemeUtil',
   'VuiWizardHelper',
   'addHostScheduleTaskPageService',
   'lockdownModeStrings',
   function(hostVuiService,
         i18nService,
         dataService,
         $rootScope,
         addHostNameLocationPageService,
         addHostConnectionSettingsPageService,
         addHostHostSummaryPageService,
         addHostAssignLicensePageService,
         addHostLockdownModePageService,
         addHostVmLocationPageService,
         addHostResourceLocationPageService,
         addHostReadyToCompletePageService,
         HostAdder,
         vuiConstants,
         wizardPageService,
         defaultUriSchemeUtil,
         VuiWizardHelper,
         addHostScheduleTaskPageService,
         lockdownModeStrings) {

      return {
         showWizardInReconnectState: function(hostUid) {
            dataService.getProperties(hostUid, ['dcOrUserCreatedHostFolder',
               'cluster', 'name']).then(function(properties) {
               var parentRef = properties.cluster;
               if (!parentRef) {
                  parentRef = properties.dcOrUserCreatedHostFolder;
               }

               if (!parentRef) {
                  return;
               }
               var destinationUid = defaultUriSchemeUtil.getVsphereObjectId(parentRef);
               invokeWizard(destinationUid, hostUid, properties.name);
            });
         },
         showWizard: function(destinationUid, actionEval) {
            invokeWizard(destinationUid, null, null, actionEval);
         }
      };

      function invokeWizard(destinationUid, hostUid, hostName, actionEval) {
         var addHostWizardTitle = 'addHostWizard.title';
         if (actionEval && actionEval.additionalData &&
               actionEval.additionalData.isScheduledTask) {
            if (actionEval.additionalData.schedulingData.scheduleTaskOperationMode === 1) {
               addHostWizardTitle = 'scheduledtask.edit.' + addHostWizardTitle;
            } else {
               addHostWizardTitle = 'scheduledtask.' + addHostWizardTitle;
            }
         }
         var title = i18nService.getString('HostUi', addHostWizardTitle);
         var hostAdder = new HostAdder();
         var wizard = new VuiWizardHelper(title);

         hostAdder.setDestinationUid(destinationUid);
         var pages = [];
         var reconnectHost = !!hostUid;
         if (reconnectHost) {
            hostAdder.setHostUid(hostUid);
            hostAdder.setHostname(hostName);
            hostAdder.setReconnectHost(reconnectHost);
            var operationName = i18nService.getString('HostUi',
                  'reconnectHostOperation.name');
            hostAdder.setOperationName(operationName);
            pages = createWizardPages(hostAdder, wizard, actionEval);

            wizard.show(pages, hostAdder, 'add-host-wizard');
         } else {
            hostAdder.setOperationName(title);
            // In case of edit schedule task we initialize the data in the wizard
            if (actionEval && actionEval.additionalData &&
                  actionEval.additionalData.isScheduledTask &&
                  actionEval.additionalData.schedulingData.scheduleTaskOperationMode === 1) {
               openEditAddHostScheduledTaskWizard(hostAdder, wizard, actionEval);
            } else {
               pages = createWizardPages(hostAdder, wizard, actionEval);
               wizard.show(pages, hostAdder, 'add-host-wizard');
            }
         }
      }

      function createWizardPages(hostAdder, wizard, actionEval) {
         var pages = [];
         if (actionEval && actionEval.additionalData
               && actionEval.additionalData.isScheduledTask === true) {
            hostAdder.getScheduleTaskPageModel.isScheduledTaskFlow
                  = actionEval.additionalData.isScheduledTask;
            hostAdder.getScheduleTaskPageModel.mutationSpec
                  = actionEval.additionalData.schedulingData;
            pages.push(addHostScheduleTaskPageService.build(hostAdder, wizard));
         }
         pages.push(addHostNameLocationPageService.build(hostAdder, wizard));
         pages.push(addHostConnectionSettingsPageService.build(hostAdder, wizard));
         pages.push(addHostHostSummaryPageService.build(wizard));
         pages.push(addHostAssignLicensePageService.build(hostAdder, wizard));
         pages.push(addHostLockdownModePageService.build(wizard));
         pages.push(addHostVmLocationPageService.build(hostAdder, wizard));
         pages.push(addHostResourceLocationPageService.build(
               hostAdder, wizard));
         pages.push(addHostReadyToCompletePageService.build());

         return pages;
      }

      /**
       * Method to open the edit scheduled task for add host. It opens the same
       * wizard for adding a host but with filled data and with first page -> the
       * scheduled task page which is ready for edit.
       * @param hostAdder The host model which is used to pass a data
       * @param wizard Object which is used to invoke the actual wizard
       * @param actionEval The actionEval object used to create the wizard pages
       */
      function openEditAddHostScheduledTaskWizard(hostAdder, wizard, actionEval) {
         var pages = [];
         // An array of type MethodActionArgument
         var args = actionEval.additionalData.schedulingData.spec.argument;
         // An object of type Connection spec
         var connectSpec = args[0].value;
         hostAdder.setHostname(connectSpec.hostName);
         hostAdder.setConnectionSettings({
            username: connectSpec.userName,
            password: connectSpec.password
         });
         hostAdder.setSslThumbprint(connectSpec.sslThumbprint);
         // When scheduling mode is enabled creation of new RP is disabled
         hostAdder.setResourceLocationType(null);

         hostAdder.setLockdownMode(lockdownModeStrings.forSpec(connectSpec.lockdownMode));

         // Get VM name if the vm folder is presented
         if (connectSpec.vmFolder) {
            var vmId = defaultUriSchemeUtil.getVsphereObjectId(connectSpec.vmFolder);
            dataService.getProperties(vmId, ['name'])
                  .then(function(result) {
                     var displayName = "";
                     if (result && result.name) {
                        displayName = result.name;
                     }
                     hostAdder.setVmLocation({
                        ref: connectSpec.vmFolder,
                        displayName: displayName
                     });
                     pages = createWizardPages(hostAdder, wizard, actionEval);
                     wizard.show(pages, hostAdder, 'add-host-wizard');
                  });
         } else {
            pages = createWizardPages(hostAdder, wizard, actionEval);
            wizard.show(pages, hostAdder, 'add-host-wizard');
         }
      }
   }
]);

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller(
         'AddHostAssignLicensePageController',
         AddHostAssignLicensePageController
   );

   AddHostAssignLicensePageController.$inject = [
      '$scope',
      'vuiConstants'
   ];

   function AddHostAssignLicensePageController($scope, vuiConstants) {
      var self = this;
      self.model = $scope.manager.getAssignLicensePageModel();
      self.selectedLicense = self.model.userSelectedLicense;

      self.onLicenseItemChanged = function(licenseItem) {
         $scope.manager.setUserSelectedLicense(licenseItem);
      };

      $scope.wizardConfig.loading = true;
      $scope.manager.validateLicense(self.model).then(
         function(validationResult /*AssetAssignLicenseValidationResult*/) {
            $scope.wizardConfig.loading = false;
            self.validationResult = validationResult;

            var errorInResponse = $scope.manager.getErrorInResponse();
            if (errorInResponse) {
               $scope.wizardConfig.validationBanner.messages = [{
                  type: vuiConstants.notifications.type.ERROR,
                  text: errorInResponse.localizedMessage
               }];
            }
         }
      );
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostConnectionSettingsPageController', [
         '$scope',
         function($scope) {
            var self = this;

            self.model = $scope.manager.getConnectionSettingsPageModel();

            $scope.$watch(function(){ return self.model; }, function(model){
               $scope.manager.setConnectionSettings(model);
            }, true);
         }
      ]
   );
})();
/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostHostSummaryPageController', AddHostHostSummaryPageController);

   AddHostHostSummaryPageController.$inject = ['$scope'];

   function AddHostHostSummaryPageController($scope) {
      _.extend(this, $scope.manager.getHostSummaryPageModel());
      _.extend(this, {
         warningMessage: $scope.manager.getHostAlreadyManagedMessage()
      });
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostLockdownModePageController', [
      '$scope',
      function($scope) {
         var self = this;

         this.model = $scope.manager.getLockdownModePageModel();

         $scope.$watch(function(){ return self.model.lockdownMode; }, function(lockdownMode) {
            $scope.manager.setLockdownMode(lockdownMode);
         });
      }
   ]);
})();
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostNameLocationPageController', [
         '$scope',
         function($scope) {
            var self = this;
            if(!$scope.manager.getStateLoadedFlag()) {
               $scope.$watch($scope.manager.getStateLoadedFlag, function(value) {
                  if (value) {
                     initializeView();
                  }
               });
            } else{
               initializeView();
            }

            function initializeView() {
               self.model = $scope.manager.getNameLocationPageModel();
               $scope.$watch(function() {
                  return self.model;
               }, function(model) {
                  $scope.manager.setHostname(model.hostname);
               }, true);
            }
         }
      ]
   );
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostReadyToCompletePageController', [
      '$scope', 'i18nService', 'vxPropertyViewService',
      function($scope, i18nService, vxPropertyViewService) {
         var model = $scope.manager.getReadyToCompletePageModel();

         var hostStr = _.bind(i18nService.getString, i18nService, 'HostUi');
         var getValue = function(value) {
            if (!value) {
               return hostStr('none.label');
            }
            return value;
         };

         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = builder.category('').section('');

         sectionBuilder
               .property(
                     hostStr('addHostWizard.confirmationPage.hostNameLabel'),
                     model.name
               )
               .propertyBuilder()
               .keyBuilder()
               .text(hostStr('addHostWizard.confirmationPage.locationLabel'))
               .exit()
               .valueBuilder()
               .text(model.destinationName)
               .icon(model.destinationIcon)
               .exit().exit()
               .property(
                     hostStr('addHostWizard.confirmationPage.hostVersionLabel'),
                     model.version
               );

         if (model.licenseName) {
            sectionBuilder.property(
                  hostStr('addHostWizard.confirmationPage.licenseKeyLabel'),
                  model.licenseName
            );
         }

         sectionBuilder.property(
               hostStr('addHostWizard.confirmationPage.networksLabel'),
               getValue(model.networks)
         ).property(
                     hostStr('addHostWizard.confirmationPage.datastoresLabel'),
                     getValue(model.datastores)
         );

         if (model.lockdownMode) {
            sectionBuilder.property(
                  hostStr('addHostWizard.confirmationPage.lockDownModeLabel'),
                  model.lockdownMode
            );
         }

         if (model.vmLocation) {
            sectionBuilder.property(
                  hostStr('addHostWizard.confirmationPage.vmLocationLabel'),
                  model.vmLocation
            );
         }

         if (model.destinationResourceLocation) {
            sectionBuilder.property(
                  hostStr('addHostWizard.confirmationPage.rpLabel'),
                  model.destinationResourceLocation
            );
         }

         this.propertyViewData = builder.build();
      }
   ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.host')
      .controller('AddHostResourceLocationPageController', ['$scope', 'addHostWizardConstants', AddHostResourceLocationPageController]);

   function AddHostResourceLocationPageController($scope, addHostWizardConstants) {
      this.model = $scope.manager.getResourceLocationPageModel();
      this.addHostWizardConstants = addHostWizardConstants;

      $scope.$watch('ctrl.model.resourceLocationType', function(resourceLocationType) {
         $scope.manager.setResourceLocationType(resourceLocationType);
      });

      $scope.$watch('ctrl.model.resourceLocationName', function(resourceLocationName) {
         $scope.manager.setResourceLocationName(resourceLocationName);
      });
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddHostVmLocationPageController', [
      '$scope',
      'defaultUriSchemeUtil',
      function ($scope, defaultUriSchemeUtil) {
         this.model = $scope.manager.getVmLocationPageModel();

         this.onVmLocationSelected = function (locationId, locationName) {
            var locationRef = defaultUriSchemeUtil.getManagedObjectReference(locationId);
            $scope.manager.setVmLocation({ref: locationRef, displayName: locationName});
         };
      }
   ]);
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service for Assign License page
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service(
         'addHostAssignLicensePageService',
         addHostAssignLicensePageService
   );

   addHostAssignLicensePageService.$inject = [
      'i18nService',
      'licenseValidationUtil',
      '$q',
      'defaultUriSchemeUtil'
   ];

   function addHostAssignLicensePageService(i18nService, licenseValidationUtil, $q, defaultUriSchemeUtil) {

      return {
         build: function(hostAdder, vuiWizardHelper) {
            var destinationRef = { 
               rootFolder: defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(hostAdder.getDestinationUid()) 
            };
            hostAdder.prepareLicenseValidation(destinationRef);

            return {
               title: i18nService.getString('HostUi', 'addHostWizard.assignLicensePage.title'),
               description: i18nService.getString('HostUi', 'addHostWizard.assignLicensePage.description'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostAssignLicensePage.html',
               onCommit: function() {
                  if (!hostAdder.getLastAssetAssignLicenseValidationResult()) {
                     return false;
                  }

                  var errors = licenseValidationUtil.getValidationBlockingErrors(
                        hostAdder.getAssignLicensePageModel().userSelectedLicense,
                        hostAdder.getLastAssetAssignLicenseValidationResult(),
                        true
                  );

                  if (!_.isEmpty(errors)) {
                     vuiWizardHelper.markPageIncompleteWithErrors(errors);
                     return false;
                  } else {
                     var warnings = licenseValidationUtil.getValidationWarnings(
                           hostAdder.getAssignLicensePageModel().userSelectedLicense,
                           hostAdder.getLastAssetAssignLicenseValidationResult(),
                           true
                     );

                     if (!_.isEmpty(warnings)) {
                        return licenseValidationUtil.showLicenseWarningsConfirmationDialog(warnings)
                              .then(function (result) {
                                 if (result) {
                                    vuiWizardHelper.markPageComplete();
                                 } else {
                                    vuiWizardHelper.markPageIncompleteWithErrors([]);
                                 }
                                 return result;
                              }, function (reason) {
                                 vuiWizardHelper.markPageIncompleteWithErrors([]);
                                 return $q.reject(reason);
                              });
                     } else {
                        vuiWizardHelper.markPageComplete();
                        return true;
                     }
                  }
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to validate the host connection spec and ask the user to
 * confirm the acceptance of the host certificate
 */
(function () {
    'use strict';
    angular.module('com.vmware.vsphere.client.host')
        .service('addHostConnectionSettingsPageService', addHostConnectionSettingsPageService);

    addHostConnectionSettingsPageService.$inject = ['i18nService',
        'actionConfirmationService',
        '$q'];

    function addHostConnectionSettingsPageService(i18nService, actionConfirmationService,
          $q) {
        return {
            build: function (hostAdder, vuiWizardHelper) {
                return {
                    title: i18nService.getString('HostUi', 'addHostWizard.hostConnectionPage.title'),
                    description: i18nService.getString('HostUi', 'addHostWizard.hostConnectionPage.description'),
                    contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostConnectionSettingsPage.html',
                    onCommit: function () {
                        var certificateConfirmationDeferred = $q.defer();
                        if (hostAdder.isUsernameValid()) {
                            vuiWizardHelper.showLoadingIndicator();
                            hostAdder.validateConnection().then(function(responseData){
                                vuiWizardHelper.hideLoadingIndicator();
                                return responseData;
                            }).then(function (responseData) {
                                if (responseData.error && responseData.error.thumbprint) {
                                    showCertificateConfirmation(certificateConfirmationDeferred, responseData);
                                } else {
                                    updatePage(responseData, certificateConfirmationDeferred);
                                }
                            });
                        } else {
                            vuiWizardHelper.markPageIncompleteWithError(
                                i18nService.getString('HostUi', 'addHostWizard.hostConnectionPage.missingUsername')
                            );
                            certificateConfirmationDeferred.resolve(false);
                        }

                        return certificateConfirmationDeferred.promise;
                    }
                };


                /**
                 * Shows the alert dialog containing the thumbprint of the host and based on the
                 * user action (accepting the certificate) allows or denies going to the next page
                 *
                 * @param deferred to allow or deny the going to the next page
                 * @param responseData response itself
                 */
                function showCertificateConfirmation(deferred, responseData) {
                    // Build different message based on the host version
                    var thumbprint = responseData.error.thumbprint;
                    var text = i18nService.getString('HostUi',
                       responseData.result.isEsx60OrHigher ?
                          'addHostWizard.hostConnectionPage.sslVerifyWarningMsgFormat60' :
                          'addHostWizard.hostConnectionPage.sslVerifyWarningMsgFormat',
                       thumbprint);

                    var alertProperties = {
                        title: i18nService.getString('HostUi', 'addHostWizard.hostConnectionPage.sslVerifyWarningTitle'),
                        message: text,
                        yesHandler: function () {
                            // In case of clicking Yes, we should verify again the connection spec by
                            // using the sslThumbprint provided in the response
                            vuiWizardHelper.showLoadingIndicator();
                            hostAdder.setSslThumbprint(thumbprint);
                            hostAdder.validateConnection().then(function (responseData) {
                                vuiWizardHelper.hideLoadingIndicator();
                                updatePage(responseData, deferred);
                            });
                            return true;
                        },
                        noHandler: function () {
                            // In case of clicking No, we should just display the error from the response
                            vuiWizardHelper.markPageIncompleteWithError(
                               responseData.error.localizedMessage
                            );
                            deferred.resolve(false);
                        },
                        yesIsDefaultButton: false,
                        useClarity: true,
                        parent: '.vui-wizard'
                    };
                    actionConfirmationService.showConfirmationDialog(alertProperties);
                }

                /**
                 * Based on the response, the page will be update with the response error or
                 * will allow going to the next page
                 *
                 * @param responseData response itself
                 * @param wizardConfig needed to update the page state
                 * @param deferred to allow or deny the going to the next page
                 */
                function updatePage(responseData, deferred) {
                    if (responseData.error) {
                        vuiWizardHelper.markPageIncompleteWithError(
                           _.escape(responseData.error.localizedMessage)
                        );
                        deferred.resolve(false);
                    } else {
                        hostAdder.setConnectInfo(responseData.result.connectInfo);
                        vuiWizardHelper.markPageComplete();
                        deferred.resolve(true);
                    }
                }
            }
        };


    }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service for Host Summary page
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
      .service('addHostHostSummaryPageService', addHostHostSummaryPageService);

   addHostHostSummaryPageService.$inject = ['i18nService'];

   function addHostHostSummaryPageService(i18nService) {
      return {
         build: function (vuiWizardHelper) {
            return {
               title: i18nService.getString('HostUi', 'addHostWizard.hostSummaryPage.title'),
               description: i18nService.getString('HostUi', 'addHostWizard.hostSummaryPage.description'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostHostSummaryPage.html',
               onCommit: function () {
                  vuiWizardHelper.markPageComplete();
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to validate that the host name is with the correct format
 */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('addHostLockdownModePageService', addHostLockdownModePageService);

   addHostLockdownModePageService.$inject = ['i18nService'];

   function addHostLockdownModePageService(i18nService) {
      return {
         build: function (vuiWizardHelper) {
            return {
               title: i18nService.getString('HostUi', 'addHostWizard.lockDownPage.title'),
               description: i18nService.getString('HostUi', 'addHostWizard.lockDownPage.description'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostLockdownModePage.html',
               onCommit: function () {
                     vuiWizardHelper.markPageComplete();
                     return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Service to validate that the host name is with the correct format
 */
(function () {
    'use strict';
    angular.module('com.vmware.vsphere.client.host').service('addHostNameLocationPageService', addHostNameLocationPageService);

    addHostNameLocationPageService.$inject = ['i18nService'];

    function addHostNameLocationPageService(i18nService) {
        return {
            build: function (hostAdder, vuiWizardHelper) {
                return {
                    title: i18nService.getString('HostUi', 'addHostWizard.hostNameAndLocationPage.title'),
                    description: i18nService.getString('HostUi', 'addHostWizard.hostNameAndLocationPage.hostNameDescription'),
                    contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostNameLocationPage.html',
                    onCommit: function () {
                       if(hostAdder.isHostnameValid()) {
                          vuiWizardHelper.markPageComplete();
                          return true;
                        } else {
                            vuiWizardHelper.markPageIncompleteWithError(i18nService.getString('HostUi', 'addHostWizard.hostNameAndLocationPage.invalidHostError'));
                            return false;
                        }
                    }
                };
            }
        };
    }
})();

angular.module('com.vmware.vsphere.client.host').service('addHostReadyToCompletePageService', [
   'i18nService',
   function (i18nService) {
      return {
         build: function () {
            return {
               title: i18nService.getString('HostUi', 'addHostWizard.confirmationPage.title'),
               description: i18nService.getString('HostUi', 'addHostWizard.confirmationPage.description'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostReadyToCompletePage.html'
            };
         }
      };
   }]
);

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service(
      'addHostResourceLocationPageService',
      addHostResourceLocationPageService
   );

   addHostResourceLocationPageService.$inject = ['i18nService', 'addHostWizardConstants',
         'mutationService', 'logService', 'defaultUriSchemeUtil'];

   function addHostResourceLocationPageService(i18nService, addHostWizardConstants,
         mutationService, logService, defaultUriSchemeUtil) {
      var log = logService('addHostResourceLocationPageService');
      return {
         build: function (wizardManager, vuiWizardHelper) {
            return {
               title: i18nService.getString('HostUi', 'addHostWizard.drsClusterRpPage.title'),
               description: i18nService.getString('HostUi', 'addHostWizard.drsClusterRpPage.description'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostResourceLocationPage.html',
               onCommit: function () {
                  var model = wizardManager.getResourcePoolInput();
                  return validateResourcePoolInput(model);
               }
            };

            function validateResourcePoolInput(model) {
               if (model.type === addHostWizardConstants.RESOURCE_LOCATION_ROOT) {
                  vuiWizardHelper.markPageComplete();
                  return true;
               }

               if (!model.name ||
                     model.name.length === 0) {
                  var errorMessage = i18nService.getString('HostUi',
                        'hostToClusterOp.resPoolPage.rpNameReqError');
                  vuiWizardHelper.markPageIncompleteWithError(errorMessage);
                  return false;
               }
               var clusterUid = defaultUriSchemeUtil.getVsphereObjectId(
                     model.destination);
               return validateResourcePoolName(clusterUid,
                     model.name);
            }

            function validateResourcePoolName(clusterUid, name) {
               vuiWizardHelper.showLoadingIndicator();
               return mutationService.validate(
                     clusterUid,
                     'com.vmware.vsphere.client.h5.rp.CreateResourcePoolNameSpec',
                     buildCreateResourcePoolNameSpec(name)
               ).then(validationResultHandler);
            }

            function validationResultHandler(validationResult) {
               vuiWizardHelper.hideLoadingIndicator();
               if (!validationResult) {
                  log.error("Server error: Can't validate resource location name.");
               }

               if (validationResult && validationResult.error) {
                  if (validationResult.error.message) {
                     log.error(validationResult.error.message);
                  } else {
                     log.error("Server error: The validation result has an error");
                  }
               }

               if (validationResult && validationResult.result &&
                  validationResult.result.length > 0) {
                  vuiWizardHelper.markPageIncompleteWithError(
                     validationResult.result);
                  return false;
               }

               vuiWizardHelper.markPageComplete();
               return true;
            }

            function buildCreateResourcePoolNameSpec(resourceLocationName) {
               var spec = {
                  name: resourceLocationName
               };
               return spec;
            }
         }
      };
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
      .service('addHostVmLocationPageService', addHostVmLocationPageService);

   addHostVmLocationPageService.$inject = ['i18nService'];

   function addHostVmLocationPageService(i18nService) {
      return {
         build: function (hostAdder, wizard) {
            return {
               title: i18nService.getString('HostUi', 'addHostWizard.vmLocationPage.title'),
               contentUrl: 'host-ui/resources/host/views/addHostWizard/pages/addHostVmLocationPage.html',
               onCommit: function () {
                  if (!hostAdder.getVmLocationPageModel().selectedLocationId) {
                     wizard.markPageIncompleteWithErrors([
                           i18nService.getString('HostUi',
                                 'addHostWizard.vmLocationPage.error')]);
                     return false;
                  }

                  wizard.markPageComplete();
                  return true;
               }
            };
         }
      };
   }
})();

/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var host_ui;
(function (host_ui) {
    var HostWizardScheduleTaskPageModel = (function () {
        function HostWizardScheduleTaskPageModel() {
        }
        HostWizardScheduleTaskPageModel.prototype.validatePage = function () {
            return {};
        };
        HostWizardScheduleTaskPageModel.prototype.submitPage = function () {
            return {
                invalidateNextPages: false
            };
        };
        HostWizardScheduleTaskPageModel.prototype.resetForm = function () { };
        return HostWizardScheduleTaskPageModel;
    }());
    host_ui.HostWizardScheduleTaskPageModel = HostWizardScheduleTaskPageModel; // class
    var hostWizardScheduleTaskPageModelService = function () {
        return HostWizardScheduleTaskPageModel;
    };
    angular.module("com.vmware.vsphere.client.host")
        .service("hostWizardScheduleTaskPageModel", hostWizardScheduleTaskPageModelService);
})(host_ui || (host_ui = {})); // module



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
var host_ui;
(function (host_ui) {
    /**
     * A "builder" for the ScheduleTaskPageService.
     */
    var AddHostScheduleTaskPageService = (function () {
        function AddHostScheduleTaskPageService(i18nService, wizardPageService) {
            this.i18nService = i18nService;
            this.wizardPageService = wizardPageService;
        }
        AddHostScheduleTaskPageService.prototype.build = function (hostAdder, vuiWizardHelper) {
            var _this = this;
            return {
                title: this.i18nService.getString("HostUi", "addHostWizard.scheduleTaskPage.title"),
                contentUrl: "host-ui/resources/host/views/addHostWizard/scheduleTaskWizard/"
                    + "scheduleTaskPage/hostWizardScheduleTaskPage.html",
                onCommit: function () {
                    return _this.onCommit(hostAdder, vuiWizardHelper);
                }
            };
        };
        AddHostScheduleTaskPageService.prototype.onCommit = function (hostAdder, vuiWizardHelper) {
            var recurrence = hostAdder.getScheduleTaskPageModel.mutationSpec.
                schedulingSpec.recurrence;
            var isFormStatusValid = hostAdder.getScheduleTaskPageModel.mutationSpec.
                schedulingSpec.isFormStatusValid;
            if (recurrence && isFormStatusValid) {
                hostAdder.setScheduleTaskPageModel(hostAdder.getScheduleTaskPageModel.mutationSpec);
                vuiWizardHelper.markPageComplete();
                return true;
            }
            else {
                vuiWizardHelper.markPageIncompleteWithError(this.i18nService.getString("HostUi", "addHostWizard.scheduleTaskPage.invalidHostSchedulerError"));
                return false;
            }
        };
        AddHostScheduleTaskPageService.$inject = [
            "i18nService",
            "wizardPageService"
        ];
        return AddHostScheduleTaskPageService;
    }());
    host_ui.AddHostScheduleTaskPageService = AddHostScheduleTaskPageService; // class
    angular.module("com.vmware.vsphere.client.host").service("addHostScheduleTaskPageService", AddHostScheduleTaskPageService);
})(host_ui || (host_ui = {})); // namespace



(function() {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:hardwareHealthConstants
    *
    * @description
    *    Represents Hardware Health Status enum values.
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('hardwareHealthConstants', {
            status: {
               NORMAL: 'normal',
               WARNING: 'warning',
               ALERT: 'alert',
               UNKNOWN: 'unknown'
            },
            HARDWARE_STATUS_PROPERTY: 'hardwareStatus',
            HARDWARE_STATUS_65_PROPERTY: 'hardwareHealthStatus',
            HARDWARE_STATUS_XML_PROPERTY: 'hardwareStatusXml',
            ACTION: {
               REFRESH_DATA: 'refresh_data',
               RESET_SENSORS: 'reset_sensors',
               RESET_EVENTS: 'reset_events',
               EXPORT_XML: 'export_xml'
            },
            OPERATION: {
               REFRESH_DATA: "REFRESH_DATA",
               RESET_SENSORS: "RESET_SENSORS",
               RESET_EVENTS_LOG: "RESET_EVENTS_LOG"
            },
            SENSOR_ICONS: {
               processor: 'vx-icon-CPU',
               temperature: 'vx-icon-temp',
               storage: 'vx-icon-storage',
               battery: 'vx-icon-battery',
               fan: 'vx-icon-fan',
               memory: 'vx-icon-memory',
               pci: 'vx-icon-pci',
               voltage: 'vx-icon-voltage',
               power: 'vx-icon-power',
               network: 'vx-icon-network',
               software: 'vx-icon-software',
               bmc: 'vx-icon-system_board',
               sel: 'vx-icon-sel',
               cable: 'vx-icon-cable',
               watchdog: 'vx-icon-watchdog'
            }
         });
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('HardwareHealthController', HardwareHealthController);

   HardwareHealthController.$inject = [
      '$scope',
      '$rootScope',
      '$element',
      'hardwareHealthConstants',
      'hardwareHealthService',
      'vuiConstants',
      'vxPropertyViewService',
      'i18nService',
      'authorizationService',
      'vcService',
      'defaultUriSchemeUtil',
      'visibilityMonitorService'
   ];

   function HardwareHealthController(
         $scope,
         $rootScope,
         $element,
         constants,
         hardwareHealthService,
         vuiConstants,
         vxPropertyViewService,
         i18nService,
         authorizationService,
         vcService,
         defaultUriSchemeUtil,
         visibilityMonitorService) {

      this.constants = constants;
      this.hardwareHealthService = hardwareHealthService;
      this.vxPropertyViewService = vxPropertyViewService;
      this.i18nService = i18nService;
      this.authorizationService = authorizationService;
      this.vcService = vcService;

      this.data = null;
      this.sensors = [];
      this.alertsAndWarnings = [];
      this.systemEventLog = [];
      this.hostId = $scope._route.objectId;
      this.loading = false;
      this.hasActionPrivileges = true;
      this.sensorsShown = false;
      this.alertsAndWarningsShown = false;
      this.systemEventLogShown = false;
      this.is65VcOrLater = null;
      this.is66VcOrLater = null;
      this.showExpandRowLabel = false;

      this.liveRefreshProperties = [
         'hardware.systemInfo',
         'hardware.biosInfo',
         'runtime.healthSystemRuntime.systemHealthInfo.numericSensorInfo'
      ];
      var self = this;
      this.headerOptions = hardwareHealthService
            .createHeaderOptions(this.hostId);

      this.sensorActionBarOptions = hardwareHealthService
            .createSensorActionBarOptions(this.hostId);

      this.alertsAndWarningsActionBarOptions = hardwareHealthService
            .createAlertsAndWarningsActionBarOptions(this.hostId);
      this.alertAndWarningDatagridOptions = hardwareHealthService
            .createAlertsAndWarningsDatagridOptions();

      this.systemEventLogActionBarOptions = hardwareHealthService
            .createSystemEventLogActionBarOptions(this.hostId);
      this.systemEventLogDatagridOptions = hardwareHealthService
            .createSystemEventLogDatagridOptions();

      this.splitterOptions = {
         orientation: vuiConstants.splitter.orientation.HORIZONTAL,
         height: '100%',
         resizable: false,
         panes: [{
            size: '50%'
         }, {
            size: '50%'
         }]
      };

      this.detailHeaderOptions = {
         title: i18nService.getString('HostUi',
               'hardwareHealth.sensors.sensorDetails.title'),
         objectId: this.hostId
      };
      this.propertyViewMessage = i18nService.getString('HostUi',
            'hardwareHealth.sensors.sensorDetails.noItems');
      this.propertyViewData = null;
      this.showPropertyGrid = false;

      this.getHardwareHealthDataByVcVersion();

      var cleanUpAlarmsFunc = $rootScope.$on('alarms', onAlarmsUpdates);

      /**
       * When new websocket updates to alarms are received
       *
       * @param event
       *    the triggering event
       * @param partialUpdate
       *    contains updates/deletes
       */
      function onAlarmsUpdates(event, partialUpdate) {
         _.each(partialUpdate.updates, function(partialupdate) {
            if (partialupdate.data && partialupdate.data.entity &&
                partialupdate.data.entity._value === defaultUriSchemeUtil.getPartsFromVsphereObjectId(self.hostId).value) {
               self.requestHardwareHealthData();
               return;
            }
         });

      }

      this.visibilitySubscriberId = visibilityMonitorService
          .subscribeForVisibilityChange($element, function (visible) {
         if (!visible) {
            cleanUpAlarmsFunc();
         } else {
            cleanUpAlarmsFunc = $rootScope.$on('alarms', onAlarmsUpdates);
         }
      });

      $scope.$on("$destroy", function () {
         if (self.visibilitySubscriberId !== null) {
            visibilityMonitorService.unsubscribe(self.visibilitySubscriberId);
            self.visibilitySubscriberId = null;
         }
         cleanUpAlarmsFunc();
      });
   }

   HardwareHealthController.prototype.checkPrivileges = function() {
      this.authorizationService
            .checkPrivileges(this.hostId, ['Host.Cim.CimInteraction'])
            .then(function(privilegesStatuses) {
               this.hasActionPrivileges = !!privilegesStatuses[0];
               this.updateActionbarButtonStatus();
            }.bind(this));
   };

   HardwareHealthController.prototype.updateActionbarButtonStatus = function() {
      var hasSensorData = (this.sensorTreeListOptions && this.sensorTreeListOptions.dataSource.data().length !== 0)
            || this.sensors.length > 0;
      _.each(this.sensorActionBarOptions.actions, function(action) {
         action.enabled = this.hardwareHealthService.getActionStatus(action.id,
               hasSensorData, this.hasActionPrivileges);
      }, this);
      _.each(this.alertsAndWarningsActionBarOptions.actions, function(action) {
         action.enabled = this.hardwareHealthService.getActionStatus(action.id,
               hasSensorData, this.hasActionPrivileges);
      }, this);
      _.each(this.systemEventLogActionBarOptions.actions, function(action) {
         action.enabled = this.hardwareHealthService.getActionStatus(action.id,
               hasSensorData, this.hasActionPrivileges);
      }, this);
   };

   HardwareHealthController.prototype.getDefaultHardwareHealthData = function() {
      var defaultHardwareHealthData = {};
      defaultHardwareHealthData[this.constants.HARDWARE_STATUS_PROPERTY] = {
         alertsAndWarnings: [],
         bios: null,
         chassis: [],
         sensorCounts: null,
         sensors: [],
         systemEventLog: []
      };

      return defaultHardwareHealthData;
   };

   HardwareHealthController.prototype.getHardwareHealthDataByVcVersion = function() {
      this.vcService.is66VcOrLater(this.hostId).then(function(is66VcOrLater) {
         this.is66VcOrLater = is66VcOrLater;
         if (is66VcOrLater) {
            this.hardwareHealthService.requestHardwareHealthData(this.hostId,
                  this.constants.HARDWARE_STATUS_65_PROPERTY)
                  .then(function(data) {
                     this.loading = false;
                     this.hardwareHealthService.getUserTimeFormat()
                           .then(function(timeFormat) {
                              this.initVc66OrLaterHardwareHealthData(data, timeFormat);
                              this.checkPrivileges();
                           }.bind(this));
                  }.bind(this));
         } else {
            this.initHardwareHealthData();
         }
      }.bind(this));
   };


   HardwareHealthController.prototype.initHardwareHealthData = function() {
      this.vcService.is65VcOrLater(this.hostId).then(function(is65VcOrLater) {
         this.is65VcOrLater = is65VcOrLater;

         this.sensorTreeListOptions = this.hardwareHealthService
            .createSensorTreeListOptions(this.showPropertyGridItemDetails.bind(this),
                  is65VcOrLater);
         this.requestHardwareHealthData();

         this.checkPrivileges();
      }.bind(this));
   };

   HardwareHealthController.prototype.requestHardwareHealthData = function() {
      if (this.is65VcOrLater === null) {
         return;
      }

      var hardwareStatusProperty = this.is65VcOrLater ?
         this.constants.HARDWARE_STATUS_65_PROPERTY :
         this.constants.HARDWARE_STATUS_PROPERTY;

      this.loading = true;

      this.hardwareHealthService.requestHardwareHealthData(this.hostId,
            hardwareStatusProperty)
         .then(function(data) {
            this.loading = false;
            this.hardwareHealthService.getUserTimeFormat()
                  .then(function(timeFormat) {
                     data = angular.merge({}, this.getDefaultHardwareHealthData(), data);
                     var hardwareHealthData = data[hardwareStatusProperty];
                     var oldHardwareHealthData = this.data;
                     this.data = hardwareHealthData;
                     if (!_.isEmpty(hardwareHealthData.sensors)) {
                        hardwareHealthData.sensors = this.getExtendedHardwareHealthData(
                              hardwareHealthData.sensors, timeFormat);
                     }
                     this.sensorCountLabels = this.hardwareHealthService
                           .getSensorCountLabels(hardwareHealthData.sensorCounts);

                     var sensorsPartialUpdate =
                           this.getSensorsPartialUpdate(hardwareHealthData,
                                 oldHardwareHealthData);
                     if (sensorsPartialUpdate === false) {
                        this.sensorTreeListOptions.dataSource = this.hardwareHealthService
                              .createSensorTreeListDataSource(hardwareHealthData.sensors);
                     } else {
                        this.sensorTreeListOptions.dataSource.pushUpdate(sensorsPartialUpdate);
                     }

                     this.alertAndWarningDatagridOptions.data = hardwareHealthData.alertsAndWarnings;
                     this.systemEventLogDatagridOptions.data =
                           _.isNull(hardwareHealthData.systemEventLog) ? [] :
                                 this.getExtendedHardwareHealthData(hardwareHealthData
                                       .systemEventLog, timeFormat);

                     this.updateActionbarButtonStatus();
                  }.bind(this));
         }.bind(this));
   };

   HardwareHealthController.prototype.showPropertyGridItemDetails = function(id) {
      if (typeof id === 'string' && id.length > 0) {
         var sensor = _.find(this.sensorTreeListOptions.dataSource.data(), function(item) {
            return item.id === id;
         });

         var sensorDetails = sensor.details;
         if (sensorDetails) {
            var builder = this.vxPropertyViewService.createPropertyViewBuilder();
            var categoryBuilder = builder.category('');
            var sensorIcon = this.hardwareHealthService.getSensorIcon(sensor.sensorType);
            var sectionBuilder = categoryBuilder
                  .section('')
                  .title(sensor.name)
                  .titleIcon(sensorIcon);

            _.each(sensorDetails, function(sensorDetail) {
               sectionBuilder.property(sensorDetail.label, sensorDetail.value);
            }, this);

            this.propertyViewData = builder.build();
            this.showPropertyGrid = true;
         } else {
            this.propertyViewMessage = this.i18nService.getString('HostUi',
                  'hardwareHealth.sensors.sensorDetails.noDetails');
            this.showPropertyGrid = false;
         }
      } else {
         this.showPropertyGrid = false;
         this.propertyViewMessage = this.i18nService.getString('HostUi',
               'hardwareHealth.sensors.sensorDetails.noItems');
      }
   };

   HardwareHealthController.prototype.showSensorsTab = function() {
      this.sensorsShown = true;
   };

   HardwareHealthController.prototype.showAlertsAndWarningsTab = function() {
      this.alertsAndWarningsShown = true;
   };

   HardwareHealthController.prototype.showSystemEventLogTab = function() {
      this.systemEventLogShown = true;
   };

   HardwareHealthController.prototype.getSensorsPartialUpdate =
         function(newHardwareHealthData, oldHardwareHealthData) {
            if (!oldHardwareHealthData) {
               return false;
            }

            var newSensorsMetadata = _.map(newHardwareHealthData.sensors, function(item) {
               return _.pick(item, 'id', 'parentId', 'type');
            });
            var oldSensorsMetadata = _.map(oldHardwareHealthData.sensors, function(item) {
               return _.pick(item, 'id', 'parentId', 'type');
            });

            if (!_.isEqual(newSensorsMetadata, oldSensorsMetadata)) {
               return false;
            }

            var updatedSensors = _.filter(
                  newHardwareHealthData.sensors,
                  function(newSensor, index) {
                     var oldSensor = oldHardwareHealthData.sensors[index];
                     return !_.isEqual(newSensor, oldSensor);
                  }
            );
            return updatedSensors;
         };

   HardwareHealthController.prototype.initVc66OrLaterHardwareHealthData = function(data, timeFormat) {
      data = angular.merge({}, this.getDefaultHardwareHealthData(), data);
      var hardwareHealthData = data['hardwareHealthStatus'];
      this.data = hardwareHealthData;
      this.sensorCountLabels = this.hardwareHealthService
            .getSensorCountLabels(hardwareHealthData.sensorCounts);
      if (hardwareHealthData.sensors && hardwareHealthData.sensors.length > 0) {
         this.sensors = this.getExtendedSensorsHardwareHealthData(hardwareHealthData.sensors, timeFormat);
         this.showExpandRowLabel = _.some(hardwareHealthData.sensors, function(sensor) {
            return (sensor.selEntriesList && sensor.selEntriesList.length > 0) || sensor.fru;
         });
      }
      this.alertsAndWarnings = _.isNull(hardwareHealthData.alertsAndWarnings)
      || _.isEmpty(hardwareHealthData.alertsAndWarnings) ? [] : hardwareHealthData.alertsAndWarnings;
      this.systemEventLog = _.isNull(hardwareHealthData.systemEventLog)
      || _.isEmpty(hardwareHealthData.systemEventLog)
            ? [] : this.getExtendedHardwareHealthData(hardwareHealthData.systemEventLog, timeFormat);

      this.updateActionbarButtonStatus();
   };

   HardwareHealthController.prototype.getExtendedHardwareHealthData = function(sensors, timeFormat) {
      return _.map(sensors, function(sensor) {
         var timestampFormatted = this.hardwareHealthService
               .getTimestampFormatted(sensor.timestamp, timeFormat);

         return _.extend(sensor, {
            timestampFormatted: sensor.timestamp !== null
                  ? timestampFormatted : this.i18nService.getString('Common', 'notAvailable')
         });
      }.bind(this));
   };

   HardwareHealthController.prototype.getExtendedSensorsHardwareHealthData = function(sensors, timeFormat) {
      return _.map(sensors, function(sensor) {
         var timestampFormatted = this.hardwareHealthService
               .getTimestampFormatted(sensor.timestamp, timeFormat);
         var extendedSelEntriesList = _.isNull(sensor.selEntriesList) || _.isEmpty(sensor.selEntriesList)
               ? [] : this.getExtendedSelEntriesList(sensor.selEntriesList, timeFormat);

         return _.extend(sensor, {
            timestampFormatted: sensor.timestamp !== null
                  ? timestampFormatted : this.i18nService.getString('Common', 'notAvailable'),
            selEntriesList: extendedSelEntriesList
         });
      }.bind(this));
   };

   HardwareHealthController.prototype.getExtendedSelEntriesList = function(selEntriesList, timeFormat) {
      return _.map(selEntriesList, function(selEntry) {
         var timestampFormatted = this.hardwareHealthService
               .getTimestampFormatted(selEntry.timestamp, timeFormat);

         return _.extend(selEntry, {
            timestampFormatted: selEntry.timestamp !== null
                  ? timestampFormatted : this.i18nService.getString('Common', 'notAvailable')
         });
      }.bind(this));
   };

})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.host').service("hardwareHealthService", hardwareHealthService);

   hardwareHealthService.$inject = [
      'fileSaverService',
      'dataService',
      'columnRenderersRegistry',
      'i18nService',
      'hardwareHealthConstants',
      'mutationService',
      'clarityModalService',
      '$rootScope',
      'timeFormatterService'];

   function hardwareHealthService(fileSaverService,
      dataService, columnRenderersRegistry, i18nService, constants,
      mutationService, clarityModalService, $rootScope, timeFormatterService) {

      var healthStatusSortMap = {
         unknown: 0,
         alert: 1,
         warning: 2,
         normal: 3
      };

      function createSensorTreeListDataSource(data) {
         var dataSource = new kendo.data.TreeListDataSource({
            data: data,
            schema: {
               model: {
                  id: "id",
                  expanded: false
               }
            }
         });
         dataSource.read();
         return dataSource;
      }

      // Sensors list
      function createSensorTreeListOptions(showPropertyGridItemDetails, isVc65OrLater) {
         var columns = [];

         if (isVc65OrLater) {
            columns.push({
               field: 'sensorId',
               title: getString('idHeaderText'),
               template: getSensorIdRenderer,
               width: '10%'
            });
         }

         columns = columns.concat([
            {
               field: "name",
               title: getString('sensorHeaderText'),
               template: getSensorRenderer,
               width: '35%'
            }, {
               field: "status",
               title: getString('statusHeaderText'),
               template: function(dataItem) {
                  return getStatusRenderer(dataItem.status);
               },
               sortable: {
                  compare: compareStatusValues
               },
               width: '15%'
            }, {
               field: "reading",
               title: getString('readingHeaderText'),
               template: getReadingRenderer,
               width: '15%'
            }
         ]);

         if (isVc65OrLater) {
            columns.push({
               field: 'category',
               title: getString('categoryHeaderText'),
               template: '#:sensorType#',
               width: '15%'
            });
            columns.push({
               field: 'timestampFormatted',
               title: getString('timestampHeaderText'),
               template: '#:timestampFormatted#',
               width: '15%'
            });
         }

         return {
            dataSource: createSensorTreeListDataSource([]),
            sortable: {
               mode: 'multiple'
            },
            columns: columns,
            resizable: false,
            selectable: "row",
            change: function() {
               var selectedRow = this.dataItem(this.select()[0]);
               var id = !!selectedRow.parentId ? selectedRow.id : "";
               showPropertyGridItemDetails(id);
            }
         };
      }

      function createSensorActionBarOptions(hostId) {
         var refreshAction = createSensorActionObject(
               constants.ACTION.REFRESH_DATA,
               hostId,
               i18nService.getString('HostUi', 'hardwareHealth.sensors.refresh'),
               constants.OPERATION.REFRESH_DATA);

         var exportXmlAction = createExportXmlAction(hostId);

         return {
            actions: [refreshAction, exportXmlAction]
         };
      }

      function createAlertsAndWarningsActionBarOptions(hostId) {
         var refreshAction = createSensorActionObject(
               constants.ACTION.REFRESH_DATA,
               hostId,
               i18nService.getString('HostUi', 'hardwareHealth.sensors.refresh'),
               constants.OPERATION.REFRESH_DATA);

         var exportXmlAction = createExportXmlAction(hostId);

         return {
            actions: [refreshAction, exportXmlAction]
         };
      }

      function createSystemEventLogActionBarOptions(hostId) {
         var refreshAction = createSensorActionObject(
               constants.ACTION.REFRESH_DATA,
               hostId,
               i18nService.getString('HostUi', 'hardwareHealth.systemEventLog.refresh'),
               constants.OPERATION.REFRESH_DATA);

         var resetAction = createSensorActionObject(
               constants.ACTION.RESET_EVENTS,
               hostId,
               i18nService.getString('HostUi', 'hardwareHealth.systemEventLog.reset'),
               constants.OPERATION.RESET_EVENTS_LOG
         );

         var exportXmlAction = createExportXmlAction(hostId);

         return {
            actions: [refreshAction, resetAction, exportXmlAction]
         };
      }

      function createExportXmlAction(hostId) {
         return {
            id: constants.ACTION.EXPORT_XML,
            label: i18nService.getString('HostUi', "hardwareHealth.sensors.export"),
            enabled: false,
            onClick: function() {
               return handleExportXmlActionClick(hostId);
            }
         };
      }

      function handleExportXmlActionClick(hostId) {
         var modalScope = $rootScope.$new();
         modalScope.cimXmlData = null;
         modalScope.loading = true;
         modalScope.exportData = function() {
            fileSaverService.save(modalScope.cimXmlData, modalScope.fileName);
         };
         modalScope.modalOptions = {
            title: i18nService.getString('HostUi', 'hardwareHealth.modal.exportDialogTitle'),
            contentUrl: 'host-ui/resources/host/views/monitor/hardwareHealthExportView.html',
            size: 'lg'
         };

         requestHardwareHealthXmlData(hostId)
               .then(function(data) {
                  modalScope.loading = false;
                  modalScope.cimXmlData = data[constants.HARDWARE_STATUS_XML_PROPERTY];
                  var hostName = data['name'];
                  modalScope.fileName = !hostName ? 'host_health_data.xml' : hostName + ".xml";
                  modalScope.modalOptions.title = i18nService.getString('HostUi',
                              'hardwareHealth.modal.exportDialogTitle') + " " + hostName;
               });

         clarityModalService.openPopUp(modalScope);
      }

      function requestHardwareHealthXmlData(hostId) {
         return dataService.getProperties(hostId,
               [constants.HARDWARE_STATUS_XML_PROPERTY, 'name']);
      }

      function createSensorActionObject(actionId, hostId, label, operation) {
         return {
            id: actionId,
            label: label,
            enabled: true,
            onClick: function() {
               return resetSensorsOperation(hostId, operation);
            }
         };
      }

      function resetSensorsOperation(hostId, operation) {
         var specType = 'com.vmware.vsphere.client.cimmonitor.CimMonitorSpec';
         var spec = {
            operationId: operation
         };

         var operationName = getOperationMessage(operation);
         mutationService
               .apply(hostId, specType, spec, operationName);
      }

      function getOperationMessage(operation) {
         var messageId;
         switch (operation) {
            case  constants.OPERATION.REFRESH_DATA:
               messageId = 'cimDataBeingRefreshed';
               break;
            case constants.OPERATION.RESET_EVENTS_LOG:
               messageId = 'cimEventLogBeingReset';
               break;
            default:
               messageId = 'cimDataBeingRefreshed';
         }

         return i18nService.getString('HostUi', messageId);
      }

      // Alerts and Warnings list
      function createAlertsAndWarningsDatagridOptions() {
         return {
            data: [],
            columnDefs: [
               {
                  field: "name",
                  displayName: getString('sensorHeaderText'),
                  template: function(dataItem) {
                     return getSensorRenderer(dataItem);
                  }
               },
               {
                  field: "status",
                  type: "object",
                  searchable: false,
                  displayName: getString('statusHeaderText'),
                  template: function(dataItem) {
                     return getStatusRenderer(dataItem.status);
                  },
                  sortable: function(dataItemOne, dataItemTwo) {
                     return compareStatusValues(dataItemOne, dataItemTwo);
                  }
               },
               {
                  field: "reading",
                  displayName: getString('readingHeaderText'),
                  template: function(dataItem) {
                     return getReadingRenderer(dataItem);
                  }
               }
            ],
            height: '100%',
            resizable: false
         };
      }

      // System Event Log list
      function createSystemEventLogDatagridOptions() {
         return {
            data: [],
            columnDefs: [
               {
                  displayName: getString('systemEventLogMessageTimestampHeaderText'),
                  field: 'timestampFormatted',
                  template: '#:timestampFormatted#',
                  sortable: false,
                  searchable: false
               },
               {
                  displayName: getString('systemEventLogMessageHeaderText'),
                  field: 'message',
                  template: function(dataItem) {
                     return getEventMessageRenderer(dataItem);
                  },
                  sortable: false,
                  searchable: false
               }
            ],
            height: '100%',
            resizable: false
         };
      }

      function createHeaderOptions(hostId) {
         return {
            title: getString('title'),
            objectId: hostId
         };
      }

      function requestHardwareHealthData(hostId, hardwareStatusProperty) {
         return dataService.getProperties(hostId, [hardwareStatusProperty]);
      }

      function getEventTimestampRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('text');
         return renderer(['timestamp'], data);
      }

      function getEventMessageRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('text');
         return renderer(['message'], data);
      }

      function getString(key, count) {
         return i18nService.getString('HostUi', 'hardwareHealth.' + key, count);
      }

      function compareStatusValues(statusOne, statusTwo) {
         var statusValueOne = statusOne.status[0].status;
         var statusValueTwo = statusTwo.status[0].status;
         return healthStatusSortMap[statusValueOne] -
            healthStatusSortMap[statusValueTwo];
      }

      function getSensorCountLabels(sensorCounts) {
         if (!sensorCounts) {
            return null;
         }

         return {
            oneAlert: getString('oneAlert'),
            oneWarning: getString('oneWarning'),
            nAlerts: getString('nAlerts', sensorCounts.alerts),
            nWarnings: getString('nWarnings', sensorCounts.warnings),
            sensor: getString('sensor'),
            sensors: getString('sensors', sensorCounts.all),
            noAlertsWarningNSensors: getString('noAlertOrWarningOutOfNSensors',
                  sensorCounts.all),
            noAlertsWarningOneSensor: getString('noAlertOrWarningOutOfOneSensor')
         };
      }

      /**
       * Renders data based on 'icon-text' renderer by inserting icon and text
       * @param data - data.sensorType defines the icon and data.sensor defines
       * the text
       * @returns {*}
       */
      function getSensorRenderer(data) {
         if (!data.sensorType) {
            return '';
         }
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');
         return renderer(['icon', 'text'], {
            icon: getSensorIcon(data.sensorType),
            text: data.name
         });
      }

      /**
       * Renders status text and standard status icon based on 'status'
       * renderer by status data
       * @param status - normal, warning or alert, text is status
       * @returns {*}
       */
      function getStatusRenderer(status) {
         if (!status || status.length === 0) {
            return '';
         }
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');

         var data = status.map(function(statusItem) {
            return renderer(['icon', 'text'], {
               icon: getStatusIcon(statusItem.status),
               text: statusItem.statusMessage
            });
         })
               .reduce(function(accumulator, current) {
                  return accumulator + current;
               });
         return data;
      }

      /**
       * Renders data based on the data reading. The text renderer checks null values
       * and replaces them with empty string
       * @param data - sensor data
       * @returns {*}
       */
      function getReadingRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('text');
         return renderer(['reading'], data);
      }

      function getSensorIdRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('text');

         var sensorIdData = {
            sensorId: data.sensorId !== null ? data.sensorId :
                  i18nService.getString('HostUi', 'none.label')
         };

         return renderer(['sensorId'], sensorIdData);
      }

      function getStatusIcon(status) {
         switch (status) {
            case constants.status.NORMAL:
               return 'vsphere-icon-status-ok';
            case constants.status.WARNING:
               return 'vsphere-icon-status-warning';
            case constants.status.ALERT:
               return 'vsphere-icon-status-error';
            case constants.status.UNKNOWN:
               return 'vui-icon-datagrid-status-unknown';
            default:
               return '';
         }
      }

      /**
       * Gets sensor icon by type, defaults to other icon.
       * @param type - processor, temp, storage, battery, fan, etc.
       * @returns {*}
       */
      function getSensorIcon(type) {
         return constants.SENSOR_ICONS[type.toLowerCase()] || 'vx-icon-other';
      }

      function getActionStatus(actionId, hasData, hasActionPrivilege) {
         var actionStatusEnabled;
         if (actionId === constants.ACTION.EXPORT_XML) {
            actionStatusEnabled = hasData && hasActionPrivilege;
         } else {
            actionStatusEnabled = hasActionPrivilege;
         }
         return actionStatusEnabled;
      }

      function getUserTimeFormat() {
         return timeFormatterService.getUserTimeFormatPreference();
      }

      function getTimestampFormatted(sensorTimestamp, timeFormat) {
         return timeFormatterService.timestampToText(sensorTimestamp, timeFormat);
      }

      return {
         createHeaderOptions: createHeaderOptions,
         createSensorTreeListDataSource: createSensorTreeListDataSource,
         createSensorTreeListOptions: createSensorTreeListOptions,
         createSensorActionBarOptions: createSensorActionBarOptions,
         createAlertsAndWarningsActionBarOptions: createAlertsAndWarningsActionBarOptions,
         createSystemEventLogActionBarOptions: createSystemEventLogActionBarOptions,
         createAlertsAndWarningsDatagridOptions: createAlertsAndWarningsDatagridOptions,
         createSystemEventLogDatagridOptions: createSystemEventLogDatagridOptions,
         requestHardwareHealthData: requestHardwareHealthData,
         getSensorCountLabels: getSensorCountLabels,
         getSensorIcon: getSensorIcon,
         requestHardwareHealthXmlData: requestHardwareHealthXmlData,
         getActionStatus: getActionStatus,
         getUserTimeFormat: getUserTimeFormat,
         getTimestampFormatted: getTimestampFormatted
      };
   }
}());

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('advancedSystemSettingsService',
         AdvancedSystemSettingsService);

   AdvancedSystemSettingsService.$inject = ['vuiConstants',
      'i18nService', 'mutationService', 'resourceService'];

   function AdvancedSystemSettingsService(vuiConstants, i18nService,
                                          mutationService, resourceService) {

      function getGridOptions(onSaveFn, customValidation) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getColumnDefs(customValidation),
            height: '100%',
            editable: {
               mode: 'incell',
               createAt: 'bottom'
            },
            // handler for grid save
            save: onSaveFn
         };
      }

      function getColumnDefs(customValidation) {
         return [
            {
               displayName: getString('advancedSettings.edit.nameColumnHeader'),
               field: 'key',
               type: 'string',
               searchable: false,
               editable: false,
               width: '480px'
            },
            {
               displayName: getString('advancedSettings.edit.valueColumnHeader'),
               field: 'value',
               type: 'string',
               searchable: false,
               editable: {
                  validator: {
                     validationFunction: customValidation
                  }
               }
            }
         ];
      }

      function getString(key, params) {
         return i18nService.getString('HostUi', key, params);
      }

      function updateAdvancedSystemSettings(hostId, settings) {
         var optionValues = _.values(settings);
         var hostAdvancedSettingsSpec = {
            hostSettingsChangeset: optionValues
         };
         var operationName = getString('advancedSettings.edit.taskName');

         mutationService.apply(hostId,
               'com.vmware.vsphere.client.host.config.HostAdvancedSettingsSpec',
               hostAdvancedSettingsSpec,
               operationName);
      }

      function loadAdvancedSystemSettings(hostId, gridOptions) {
         resourceService.getResourceInfo(hostId, 'advancedSettings').then(function(hostProperties) {
            gridOptions.data = hostProperties.properties;
         });
      }

      function createOptionValue(event) {
         var optionValue = {
            _type: 'com.vmware.vim.binding.vim.option.OptionValue',
            key: event.model.key,
            value: [getType(event.model.type), event.values.value]
         };

         return optionValue;
      }

      function getType(type) {
         var result;
         switch (type) {
            case 'int':
               result = 'java.lang.Integer';
               break;
            case 'long':
               result = 'java.lang.Long';
               break;
            case 'boolean':
               result = 'java.lang.Boolean';
               break;
            default:
               result = 'java.lang.String';
               break;
         }
         return result;
      }

      function getOptionValueSpec(staticValueSpace) {
         var toReturn = {
            min: null,
            max: null,
            enumeration: []
         };
         _.each(staticValueSpace, function(valueSpace) {
            if (valueSpace.type === "MININCLUSIVE") {
               toReturn.min = valueSpace.value;
            }
            if (valueSpace.type === "MAXINCLUSIVE") {
               toReturn.max = valueSpace.value;
            }
            if (valueSpace.type === "ENUMERATION") {
               toReturn.enumeration.push(valueSpace.value);
            }
         });
         return toReturn;
      }

      function getSelectedSettingData(selectedItem) {
         var ALLOWED_BOOLEAN_VALUES = "true, false";
         var displaySettingsData = {
            allowedMin: null,
            allowedMax: null,
            allowedValues: null,
            description: null
         };

         var staticValueSpace;
         var description;
         var type;
         if (!_.isEmpty(selectedItem)) {
            staticValueSpace = selectedItem[0].staticValueSpace;
            description = selectedItem[0].description;
            type = selectedItem[0].type;
         }
         var staticValue = getOptionValueSpec(staticValueSpace);

         if (type === "boolean") {
            displaySettingsData.allowedValues = ALLOWED_BOOLEAN_VALUES;
         } else {
            displaySettingsData.allowedValues = staticValue.enumeration.filter(
                  function(e) {
                     return !!e.trim();
                  }).join(", ");
         }

         displaySettingsData.allowedMin = staticValue.min;
         displaySettingsData.allowedMax = staticValue.max;
         displaySettingsData.description = description;

         return displaySettingsData;
      }

      function getValidationResult(validationRule, inputData) {
         var validationResult = {
            status: true,
            message: null
         };

         if (!validationRule) {
            return validationResult;
         }

         validationResult = validateByType(inputData, validationRule.type);
         if (validationResult.status) {
            validationResult = validateByStaticValueSpace(inputData,
                  validationRule.staticValueSpace);
         }
         return validationResult;
      }

      function validateByType(inputData, type) {
         var validationResult = {
            status: false,
            message: getString('advancedSettings.invalidInput')
         };

         switch (type) {
            case 'int':
            case 'long':
               if (isInt(inputData)) {
                  validationResult.status = true;
                  validationResult.message = null;
               }
               break;
            case 'boolean':
               if (inputData === 'false' ||
                     inputData === 'true') {
                  validationResult.status = true;
                  validationResult.message = null;
               }
               break;
            default:
               validationResult.status = true;
               validationResult.message = null;
               break;
         }
         return validationResult;
      }

      function isInt(value) {
         var integerValue = Number.parseInt(value);
         if (integerValue <= Number.MIN_SAFE_INTEGER ||
               integerValue >= Number.MAX_SAFE_INTEGER) {
            return true;
         }
         return value !== 'NaN' && integerValue.toString() === value;
      }

      function validateByStaticValueSpace(inputData, validationRules) {
         var validResult = {
            status: true,
            message: null
         };

         if (!validationRules) {
            return validResult;
         }

         if (validationRules.min !== null &&
               validationRules.min > Number.MIN_SAFE_INTEGER &&
               validationRules.min > inputData) {
            validResult.status = false;
            validResult.message = getString('advancedSettings.numberInput.minError',
                  validationRules.min);
         }
         if (validationRules.max !== null &&
               validationRules.max < Number.MAX_SAFE_INTEGER &&
               validationRules.max < inputData) {
            validResult.status = false;
            validResult.message = getString('advancedSettings.numberInput.maxError',
                  validationRules.max);
         }
         if (validationRules.enumeration.length > 0 &&
               validationRules.enumeration.indexOf(inputData) < 0) {
            validResult.status = false;
            validResult.message = getString('advancedSettings.invalidInput');
         }
         return validResult;
      }

      return {
         getGridOptions: getGridOptions,
         updateAdvancedSystemSettings: updateAdvancedSystemSettings,
         loadAdvancedSystemSettings: loadAdvancedSystemSettings,
         createOptionValue: createOptionValue,
         getOptionValueSpec: getOptionValueSpec,
         getSelectedSettingData: getSelectedSettingData,
         getValidationResult: getValidationResult
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditAdvancedSystemSettingsController',
         EditAdvancedSystemSettingsController);

   EditAdvancedSystemSettingsController.$inject = ['$scope',
      'advancedSystemSettingsService', 'vuiConstants', 'i18nService',
      'resourceService'];

   function EditAdvancedSystemSettingsController($scope,
         advancedSystemSettingsService, vuiConstants, i18nService,
         resourceService) {

      $scope.modalOptions.onSubmit = onSubmit.bind(this);
      var hostId = $scope.modalOptions.dialogData.availableTargets[0];
      var self = this;
      var allProperties = [];
      self.selectedSetting = {};
      self.validationMap = {};
      self.gridOptions = advancedSystemSettingsService.getGridOptions(onSave, customValidation);
      self.filterPlaceholderText = i18nService.getString('Common',
            'filter.label');
      self.filterSettings = filterSettings;
      self.searchTerm = '';
      $scope.hasValidationError = false;

      self.preselectComparator = function(dataGridItem) {
         var preselect = false;
         var selectedItems = $scope.modalOptions.dialogData.selectedItems;
         if (selectedItems && !_.isEmpty(selectedItems)) {
            preselect = dataGridItem.key === selectedItems[0].key;
         }
         return preselect;
      };

      loadGridData();

      $scope.$watch(function () {
               return self.gridOptions.selectedItems;
            },
            function (selectedItems) {
               self.selectedSetting = advancedSystemSettingsService.getSelectedSettingData(
                     selectedItems);
            });


      function onSubmit() {
         if ($scope.hasValidationError) {
            $scope.modalOptions.alerts = [{
               text: i18nService.getString('HostUi', 'advancedSettings.validationError'),
               type: vuiConstants.validationBanner.type.ERROR
            }];
            return false;
         } else {
            if ($scope.changedHostAdvancedSettings) {
               advancedSystemSettingsService.updateAdvancedSystemSettings(hostId,
                     $scope.changedHostAdvancedSettings);
               $scope.changedHostAdvancedSettings = null;
            }
            return true;
         }
      }

      function loadGridData() {
         resourceService.getResourceInfo(hostId, 'advancedSettings').then(
               function(hostProperties) {
                  allProperties = hostProperties.properties;
                  self.gridOptions.data = hostProperties.properties;
               });
      }

      function customValidation(input) {
         var validationItemName = input.parent().parent().find('td:first-child').text();
         var selectedItem = self.gridOptions.selectedItems[0];
         if (selectedItem !== undefined &&
               validationItemName === selectedItem.key && !self.validationMap[validationItemName]) {
            self.validationMap[validationItemName] = {
               type: selectedItem.type,
               staticValueSpace: advancedSystemSettingsService.getOptionValueSpec(
                     selectedItem.staticValueSpace)
            };
         }

         var validationRules = self.validationMap[validationItemName];
         var inputData = input.val();
         var validationResult = advancedSystemSettingsService.getValidationResult(
               validationRules, inputData);

         if (validationResult.status === false) {
            $scope.hasValidationError = true;
            input.attr("data-validationFunction-msg", validationResult.message);
         }
         else {
            $scope.hasValidationError = false;
         }
         return validationResult.status;
      }

      function onSave(event) {
         var optionValue = advancedSystemSettingsService.createOptionValue(event);
         if (!$scope.changedHostAdvancedSettings) {
            $scope.changedHostAdvancedSettings = {};
         }
         $scope.changedHostAdvancedSettings[optionValue.key] = optionValue;
      }

      function filterSettings() {
         var search = self.searchTerm.toLowerCase();
         self.gridOptions.data = allProperties.filter(function(property) {
            var value = property.value || '';
            return property.key.toLowerCase().indexOf(search) !== -1 ||
                  value.toLowerCase().indexOf(search) !== -1;
         });
      }
   }
})();

(function() {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('authConstants', {
            loginType: {
               LOGIN_USING_CREDENTIAL: 'credential',
               LOGIN_USING_CAM_SERVER: 'camServer'
            }
         });
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('authAddCertificateController',
               AuthAddCertificateController);

   AuthAddCertificateController.$inject = [
      '$scope',
      'i18nService',
      'hostAuthService',
      'ipParserService'];

   function AuthAddCertificateController($scope,
         i18nService,
         hostAuthService,
         ipParserService) {
      var self = this;

      $scope.certificateInfo = {
         path: "",
         ip: ""
      };

      self.settingHeader = {
         title: i18nService.getString('HostUi',
               'authJoinDomain.activeDirAuthChoicesBlockTitle')
      };
      var hostId = $scope.modalOptions.dialogData.availableTargets[0];
      $scope.modalOptions.onSubmit = onSubmit;

      function onSubmit() {
         $scope.modalOptions.isAlertClosed = true;
         $scope.modalOptions.alerts = [];
         validateIpAddress($scope.certificateInfo.ip);
         validatePath($scope.certificateInfo.path);

         if ($scope.modalOptions.alerts.length === 0) {
            hostAuthService.addCertificate(hostId, $scope.certificateInfo);
            return true;
         } else {
            $scope.modalOptions.isAlertClosed = false;
         }
      }

      function validatePath(path) {
         if (!path) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('importCert.error.certPathRequired',
                        $scope.modalOptions.alerts);
         }
      }

      function validateIpAddress(ipAddress) {
         if (!ipAddress) {
            $scope.modalOptions.alerts = hostAuthService.addAlertMessage(
                  'importCert.error.serverIPRequired',
                  $scope.modalOptions.alerts);
         } else if (!ipParserService.isAddressValid(ipAddress)) {
            $scope.modalOptions.alerts = hostAuthService.addAlertMessage(
                  'importCert.error.serverIPInvalid',
                  $scope.modalOptions.alerts);
         }
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('authJoinDomainController',
               AuthJoinDomainController);

   AuthJoinDomainController.$inject = [
      '$scope',
      'i18nService',
      'authConstants',
      'dataService',
      'hostDataValidationService',
      'hostAuthService',
      'ipParserService'];

   function AuthJoinDomainController($scope,
         i18nService,
         authConstants,
         dataService,
         hostDataValidationService,
         hostAuthService,
         ipParserService) {
      var self = this;
      self.settingHeader = {
         title: i18nService.getString('HostUi', 'authJoinDomain.activeDirAuthChoicesBlockTitle')
      };

      var hostId = $scope.modalOptions.dialogData.availableTargets[0];
      $scope.loginType = authConstants.loginType;
      $scope.isProxyAuthenticationSupported = true;
      $scope.domainInfo = {
         domain: "",
         loginType: authConstants.loginType.LOGIN_USING_CREDENTIAL,
         username: "",
         password: "",
         ipAddress: ""
      };

      $scope.modalOptions.onSubmit = onSubmit;

      function onSubmit() {
         $scope.modalOptions.isAlertClosed = true;

         validateDomainInfo($scope.domainInfo);
         if ($scope.modalOptions.alerts.length === 0) {
            hostAuthService.joinDomain(hostId, $scope.domainInfo);
            return true;
         } else {
            $scope.modalOptions.isAlertClosed = false;
         }
      }

      fetchViewData();

      function fetchViewData() {
         dataService.getProperties(
               hostId,
               ["isProxyAuthenticationSupported"])
               .then(function(data) {
                  $scope.isProxyAuthenticationSupported = data.isProxyAuthenticationSupported;
               });
      }

      function validateDomainInfo(domainInfo) {
         $scope.modalOptions.alerts = [];
         validateDomainName(domainInfo.domain);

         if (domainInfo.loginType === authConstants.loginType.LOGIN_USING_CREDENTIAL) {
            validateUserName(domainInfo.username);
         } else {
            validateProxyIpAddress(domainInfo.ipAddress);
         }
      }

      function validateUserName(username) {
         if (!username) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('authJoinDomain.error.usernameRequired',
                        $scope.modalOptions.alerts);
         }
      }

      function validateDomainName(domain) {
         if (!domain) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('authJoinDomain.error.domainRequired',
                        $scope.modalOptions.alerts);
         } else  if (!hostDataValidationService.isDomainValid(domain)) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('authJoinDomain.error.domainInvalid',
                        $scope.modalOptions.alerts);
         }
      }

      function validateProxyIpAddress(proxyIpAddress) {
         if (!proxyIpAddress) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('authJoinDomain.error.camServerRequired',
                        $scope.modalOptions.alerts);
         } else if (!ipParserService.isAddressValid(proxyIpAddress)) {
            $scope.modalOptions.alerts =
                  hostAuthService.addAlertMessage('authJoinDomain.error.camServerInvalid',
                        $scope.modalOptions.alerts);
         }
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AuthServicesController', AuthServicesController);

   AuthServicesController.$inject = [
      '$scope', 'dataService', 'i18nService', 'vxPropertyViewService', 'timeFormatterService', 'hostAuthService'
   ];

   function AuthServicesController($scope,
         dataService,
         i18nService,
         vxPropertyViewService,
         timeFormatterService,
         hostAuthService) {

      var isSmartCardAuthenticationEnabledProperty = 'isSmartCardAuthenticationEnabled';
      var smartCardTrustAnchorsProperty = 'smartCardTrustAnchors';
      var objectId = $scope._route.objectId;
      this.objectsToWatch = [objectId];
      this.settingsViewHeaderAccessor = {};
      this.smartcardSettingsViewHeaderAccessor = {};
      this.nfsKerberosCredentialsViewAccessor = {};
      this.headerOptions = hostAuthService.hostAuthHeaderOptions(objectId);
      this.smartCardHeaderOptions = hostAuthService.smartCardHeaderOptions();
      this.nfsKerberosHeaderOptions = hostAuthService.nfsKerberosHeaderOptions();
      this.smartCardData = {};
      this.data = {};
      this.smartcardSupported = false;
      // nfs kerberos view
      this.nfsKerberosSupported = false;
      this.userName = i18nService.getString('StorageUi', 'nfsCredentials.noUserName');
      this.enabled = false;
      this.state = '';

      this.liveRefreshProperties = [
         'config.network.dnsConfig.searchDomain',
         'config.network.dnsConfig.address',
         'config.network.netStackInstance',
         'config.domainList',
         'config.authenticationManagerInfo.authConfig',
         'config.service.service'
      ];

      this.refresh = function() {
         this.getViewData();
         if (this.settingsViewHeaderAccessor &&
               this.settingsViewHeaderAccessor.refresh &&
               this.smartcardSettingsViewHeaderAccessor &&
               this.smartcardSettingsViewHeaderAccessor.refresh &&
               this.nfsKerberosCredentialsViewAccessor &&
               this.nfsKerberosCredentialsViewAccessor.refresh) {
            this.settingsViewHeaderAccessor.refresh();
            this.smartcardSettingsViewHeaderAccessor.refresh();
            this.nfsKerberosCredentialsViewAccessor.refresh();
         }
      };

      this.getViewData = function() {

         dataService
               .getData(objectId,
                     "com.vmware.vsphere.client.h5.host.model.authentiaction.AuthenticationServicesData")
               .then(function(data) {
                  if (data) {
                     this.smartcardSupported = data.isSmartCardAuthenticationSupported;
                     //Don't request smart card data for 5.5 host
                     if (this.smartcardSupported && data.isHostConnected) {
                        dataService.getProperties(objectId,
                              [isSmartCardAuthenticationEnabledProperty,
                                 smartCardTrustAnchorsProperty]).then(function(data) {
                           if (data) {
                              this.smartCardData.enabled = hostAuthService.getSmartCardEnabledStatus(data.isSmartCardAuthenticationEnabled);
                              this.setGridOptionsData(data);
                           }
                        }.bind(this));
                     }
                     this.data.domain = i18nService.getString('HostUi', 'none.label');
                     this.data.trustedDomain = i18nService.getString('HostUi', 'none.label');
                     this.setAuthenticationStatus(data);
                     this.buildPropertyViewData(data);
                     this.nfsKerberosSupported = data.isNfsSupproted;
                     if (this.nfsKerberosSupported) {
                        this.setNfsKerberosCredentials(data);
                     }
                  }
               }.bind(this));
      };

      this.setGridOptionsData = function(data) {
         if (data.smartCardTrustAnchors) {
            timeFormatterService.getUserTimeFormatPreference()
                  .then(function(userTimeFormat) {
                     this.datagridOptions = hostAuthService.getDatagridOptions(userTimeFormat);
                     this.datagridOptions.data = data.smartCardTrustAnchors;

                  }.bind(this));
         }
      };

      this.setAuthenticationStatus = function(data) {
         if (data.isActiveDirectoryAuthenticationUsed) {
            this.data.authStatus = i18nService.getString('HostUi',
                  'authServices.directory.devices.active');

            var config = data.authenticationConfig;
            for (var index in config) {
               if (config[index]['_type'] === "com.vmware.vim.binding.vim.host.ActiveDirectoryInfo") {
                  this.data.domain = config[index].joinedDomain;
                  this.data.trustedDomain = config[index].trustedDomain;
                  break;
               }
            }
         } else {
            this.data.authStatus = i18nService.getString('HostUi',
                  'authServices.directory.devices.local');
         }
      };

      this.buildPropertyViewData = function() {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var categoryBuilder = builder.category('');

         hostAuthService.buildDirectoryServicesConfigSection(categoryBuilder, this.data.authStatus);
         hostAuthService.buildDomainSettingsSection(categoryBuilder, this.data);

         this.propertyViewData = builder.build();
      };

      this.setNfsKerberosCredentials = function(data) {
         if (data.inDomain) {
            if (!data.nfsKerberosUser) {
               this.state = i18nService.getString('StorageUi', 'nfsCredentials.state.noUser');
            } else { // active
               this.state = i18nService.getString('StorageUi', 'nfsCredentials.state.enabled');
            }
         } else { // disabled, not in domain
            this.state = i18nService.getString('StorageUi', 'nfsCredentials.state.noDomain');
         }

         this.enabled = data.inDomain && data.nfsKerberosUser;

         this.userName = this.enabled ?
               data.nfsKerberosUser :
               i18nService.getString('StorageUi', 'nfsCredentials.noUserName');
      };

      this.getViewData();
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditNfsKerberosCredentialsController',
         EditNfsKerberosCredentialsController);

   EditNfsKerberosCredentialsController.$inject = ['$scope', 'dataService',
         'i18nService', 'mutationService', 'vuiConstants', '$q'];

   function EditNfsKerberosCredentialsController($scope, dataService, i18nService,
         mutationService, vuiConstants, $q) {
      var objectId = $scope.modalOptions.objectId;
      // this is in case user clicks OK without updating values; in that case
      // updateValues method should run so that red borders are displayed
      var valuesUpdated = false;
      var arePasswordsMatching = true;
      var isPasswordEmpty = true;
      var isUsernameEmpty = true;
      // error message for dialog alert
      var errorMessage = i18nService.getString('HostUi', 'nfsCredentials.edit.emptyPassword');
      // tooltip for username error
      var self = this;

      self.loading = true;
      self.usernameError = {
         message: '',
         isVisible: false
      };
      // tooltip for password error
      self.passwordError = {
         message: '',
         isVisible: false
      };

      $scope.modalOptions.onSubmit = function () {
         $scope.modalOptions.alerts = [];
         if (!isUsernameEmpty && !isPasswordEmpty && arePasswordsMatching) {
            mutationService.apply(
                  objectId,
                  "com.vmware.vsphere.client.storage.NfsEditCredentialsSpec",
                  {
                     userName: self.username,
                     password: self.password
                  });
            return true;
         } else {
            // thsi is called to display red borders and tooltips appropriately in
            // case OK is clicked without updating the inputs
            if (!valuesUpdated) {
               self.updateValue();
            }
            $scope.modalOptions.alerts  = [{
               text: errorMessage,
               type: vuiConstants.notifications.type.ERROR
            }];
            return false;
         }
      };

      self.updateValue = function() {
         valuesUpdated = true;
         arePasswordsMatching = self.password === self.confirmPassword;
         isPasswordEmpty = (!self.password) || self.password === '';
         isUsernameEmpty = (!self.username) || self.username === '';
         self.passwordError.isVisible = !arePasswordsMatching || isPasswordEmpty;
         self.usernameError.isVisible = isUsernameEmpty;

         // set username error
         if (isUsernameEmpty) {
            errorMessage = self.usernameError.message =
                  i18nService.getString('HostUi', 'nfsCredentials.edit.emptyUserName');
         }

         // set password error
         if (isPasswordEmpty) {
            errorMessage = self.passwordError.message =
                  i18nService.getString('HostUi', 'nfsCredentials.edit.emptyPassword');
         } else if (!arePasswordsMatching) {
            errorMessage = self.passwordError.message =
                  i18nService.getString('HostUi', 'nfsCredentials.edit.confirmPassword.error');
         }
      };

      getViewData();

      function getViewData() {
         dataService.getProperties(objectId, ['nfsKerberosUser'])
               .then(function(data) {
                  if (data) {
                     self.username = data.nfsKerberosUser;
                     isUsernameEmpty = !data.nfsKerberosUser;
                     if (isUsernameEmpty) {
                        errorMessage = i18nService
                              .getString('HostUi', 'nfsCredentials.edit.emptyUserName');
                     }
                  } else {
                     isUsernameEmpty = true;
                     errorMessage = i18nService
                           .getString('HostUi', 'nfsCredentials.edit.emptyUserName');
                  }
                  self.loading = false;
               })
               .catch(function(error) {
                  self.loading = false;
                  $q.reject(error);
               });
      }
   }
})();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditSmartCardAuthenticationController',
         EditSmartCardAuthenticationController);

   EditSmartCardAuthenticationController.$inject = ['$scope', '$element', 'dataService', 'timeFormatterService', 'editSmartCardAuthService', '$timeout', 'i18nService', 'clarityConstants'];

   function EditSmartCardAuthenticationController($scope, $element, dataService, timeFormatterService, editSmartCardAuthService, $timeout, i18nService, clarityConstants) {
      this.loading = true;
      this.objectId = $scope.modalOptions.objectId;
      this.gridWidget = null;
      this.isSmartCardAuthenticationEnabled = false;
      this.isSmartCardAuthenticationEnabledOldState = false;
      this.originalSmartCardTrustAnchors = [];


      var fileInput = $element.find('input[type="file"]');
      var fileReader = new FileReader();

      var addAction = getAddAction.call(this);
      var removeAction = getRemoveAction.call(this);

      fileInput.on('change', onFileInputChange.bind(this));
      fileReader.onload = function(event) {
         if (!event.target.result) {
            return;
         }

         editSmartCardAuthService
               .validateCertificate(this.objectId, event.target.result)
               .then(function(response) {
                  if (response && response.result) {
                     var alreadyInDataGrid = _.some(this.datagridOptions.data, function(item) {
                        return item.serialNumber === response.result[0].serialNumber;
                     });
                     if (!alreadyInDataGrid) {
                        this.datagridOptions.data.push(response.result[0]);
                     }

                  } else {
                     $scope.modalOptions.alerts = [{
                        text: i18nService.getString("HostUi", "editSmartCardAuthentication.error"),
                        type: clarityConstants.notifications.type.ERROR
                     }];
                     $scope.modalOptions.isAlertClosed = false;
                  }
               }.bind(this));
      }.bind(this);

      $scope.modalOptions.alerts = [];
      $scope.modalOptions.isAlertClosed = true;

      this.getViewData = function() {
         dataService.getProperties(this.objectId, ['isSmartCardAuthenticationEnabled', 'smartCardTrustAnchors']).then(function(data) {
            timeFormatterService.getUserTimeFormatPreference()
                  .then(function(userTimeFormat) {
                     this.initializeData(data, userTimeFormat);
                  }.bind(this));
         }.bind(this));
      };

      $scope.modalOptions.onSubmit = function() {
         return editSmartCardAuthService.updateCertificateData(
               this.objectId,
               this.originalSmartCardTrustAnchors,
               this.datagridOptions.data,
               this.isSmartCardAuthenticationEnabled,
               this.isSmartCardAuthenticationEnabledOldState
         );
      }.bind(this);

      $scope.$watch(
            function() {
               if (this.datagridOptions) {
                  return this.datagridOptions.selectedItems.length;
               }
            }.bind(this),
            function(newLength) {
               removeAction.enabled = (newLength > 0);
            }.bind(this)
      );

      $scope.$on('kendoWidgetCreated', function(event, widget) {
         if (!widget || widget.constructor !== kendo.ui.Grid) {
            return;
         }
         this.gridWidget = widget;
      }.bind(this));

      $scope.$watchCollection(function() {
         if (this.datagridOptions && this.datagridOptions.data) {
            return this.datagridOptions.data;
         }
      }.bind(this), function(newValue, oldValue) {
         if (this.gridWidget && newValue !== oldValue) {
            this.gridWidget.dataSource.data(newValue);
            this.gridWidget.refresh();
         }

      }.bind(this));

      function onFileInputChange (event) {
         $scope.modalOptions.alerts = [];
         $scope.modalOptions.isAlertClosed = true;

         var file = event.target.files[0];
         // after this method finishes the onload is called internally
         fileReader.readAsArrayBuffer(file);
         fileInput.prop('value', '');
      }

      function getRemoveAction() {
         return {
            actionId: 'removeCertificates',
            label: i18nService.getString('HostUi', 'smartCardAuthentication.removeCertificate'),
            tooltipText: i18nService.getString('HostUi', 'smartCardAuthentication.removeCertificate'),
            enabled: false,
            iconClass: 'vx-icon-removeIcon'
         };
      }

      function getAddAction() {
         return {
            actionId: 'addCertificate',
            label: i18nService.getString('HostUi', 'smartCardAuthentication.addCertificate'),
            tooltipText: i18nService.getString('HostUi', 'smartCardAuthentication.addCertificate'),
            enabled: true,
            iconClass: 'vx-icon-addIcon',
            onClick: function() {
               fileInput.click();
            }
         };
      }

      this.initializeData = function(data, userTimeFormat) {
         this.isSmartCardAuthenticationEnabled = data.isSmartCardAuthenticationEnabled;
         this.isSmartCardAuthenticationEnabledOldState = data.isSmartCardAuthenticationEnabled;
         this.datagridOptions = editSmartCardAuthService.getDataGridOptions(userTimeFormat);
         this.originalSmartCardTrustAnchors = data.smartCardTrustAnchors;
         this.datagridOptions.data = angular.merge([], data.smartCardTrustAnchors);
         removeAction.onClick = function() {
            var selectedItem = this.datagridOptions.selectedItems[0];
            this.datagridOptions.data = _.filter(this.datagridOptions.data, function(item) {
               return selectedItem.serialNumber !== item.serialNumber;
            });
         }.bind(this);
         this.datagridOptions.actionBarOptions.actions = [addAction, removeAction];
         this.loading = false;
      };

      this.getViewData();

   }
})();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('editSmartCardAuthService',
         EditSmartCardAuthService);

   EditSmartCardAuthService.$inject = ['timeFormatterService', 'i18nService', 'mutationService', 'vuiConstants'];

   function EditSmartCardAuthService(timeFormatterService, i18nService, mutationService, vuiConstants) {
      function getColumnDefs(userTimeFormat) {
         return [
            {
               field: 'subject',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.subject')
            },
            {
               field: 'issuer',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.issuer')
            },
            {
               field: 'version',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.version')
            },
            {
               field: 'validFrom',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.validFrom'),
               template: function(data) {
                  return timeFormatterService.timestampToText(
                        parseInt(data.validFrom),
                        userTimeFormat
                  );
               }
            },
            {
               field: 'validTo',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.validTo'),
               template: function(data) {
                  return timeFormatterService.timestampToText(
                        parseInt(data.validTo),
                        userTimeFormat
                  );
               }
            },
            {
               field: 'algorithm',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.algorithm')
            },            {
               field: 'publicKey',
               sortable: false,
               searchable: false,
               displayName: i18nService.getString('HostUi',
                     'smartCardAuthnetication.certificates.publicKeyAlgorithm')
            }];
      }

      function getDataGridOptions(userTimeFormat) {
         return {
            columnDefs: getColumnDefs(userTimeFormat),
            data: [],
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            actionBarOptions: {
               actions: []
            },
            resizable: false,
            height: '275px'
         };
      }

      function validateCertificate(objectId, file) {
         // Needs a conversion from an Int8Array to a normal JS array, as the Int8Array could not be send
         // to backend ( we expect byte array there), and an error is thrown if we send an Int8Array
         var byteArray = new Int8Array(file);
         var normalArray = Array.prototype.slice.call(byteArray);
         // validate the file to be added as certificate, if correct a X509Spec Object containing the certificate as a string, is returned
         return mutationService.validate(
               objectId,
               'com.vmware.vsphere.client.host.DecodePemFileSpec',
               {
                  file: normalArray
               });
      }


      function updateCertificateData(objectId, originalData, modifiedData,
            isSmartCardAuthenticationEnabled, isSmartCardAuthenticationEnabledOldState) {

         function certificateArrayToSerialNumberToCertificateMap(certificates) {
            return _.object(
                  _.map(certificates, function(certificate) {
                     return certificate.serialNumber;
                  }),
                  certificates
            );
         }

         var originalDataSerialNumberToCertificateMap = certificateArrayToSerialNumberToCertificateMap(originalData);
         var modifiedDataSerialNumberToCertificateMap = certificateArrayToSerialNumberToCertificateMap(modifiedData);

         var addCertificates = _.map(
               _.filter(
                     modifiedData,
                     function(item) {
                        return !originalDataSerialNumberToCertificateMap.hasOwnProperty(item.serialNumber);
                     }
               ),
               function(item) {
                  return item.certificateAsString;
               }
         );

         var removeCertificates = _.map(
               _.filter(
                     originalData,
                     function(item) {
                        return !modifiedDataSerialNumberToCertificateMap.hasOwnProperty(item.serialNumber);
                     }
               ),
               function(item) {
                  return {
                     algorithm: item.algorithm,
                     thumbprint: item.thumbprint
                  };
               });

         var enableStateChanged = isSmartCardAuthenticationEnabled !== isSmartCardAuthenticationEnabledOldState;
         var smartCardSpec = {
            removeCertificates: removeCertificates,
            addCertificates: addCertificates,
            enable: enableStateChanged ? isSmartCardAuthenticationEnabled : null
         };

         // If we have changes than the mutation operation should be invoked
         // Otherwise we should not make a request
         if (!_.isEmpty(removeCertificates) || !_.isEmpty(addCertificates) || enableStateChanged) {
            mutationService.apply(
                  objectId,
                  'com.vmware.vsphere.client.host.SmartCardAuthSettingsSpec',
                  smartCardSpec
            );
         }
         return true;
      }


      return {
         getDataGridOptions: getDataGridOptions,
         validateCertificate: validateCertificate,
         updateCertificateData: updateCertificateData
      };
   }
})
();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('hostAuthService',
         HostAuthService);

   HostAuthService.$inject = ['mutationService', 'authConstants', 'i18nService', 'vuiConstants', 'timeFormatterService'];

   function HostAuthService(mutationService, authConstants, i18nService, vuiConstants, timeFormatterService) {

      function leaveDomain(hostId) {
         mutationService.apply(
               hostId,
               'com.vmware.vsphere.client.host.DomainSettingSpec',
               {});
      }

      function joinDomain(hostId, domainInfo) {
         var spec = {
            domain: domainInfo.domain
         };
         if (domainInfo.loginType === authConstants.loginType.LOGIN_USING_CREDENTIAL) {
            spec.username = domainInfo.username;
            spec.password = domainInfo.password;
         } else {
            spec.camServer = domainInfo.ipAddress;
         }
         mutationService.apply(
               hostId,
               'com.vmware.vsphere.client.host.DomainSettingSpec',
               spec);

      }

      function addCertificate(hostId, certificateInfo) {
         var spec = {
            certPath: certificateInfo.path,
            serverIp: certificateInfo.ip
         };
         mutationService.apply(
               hostId,
               'com.vmware.vsphere.client.host.ImportCertificateInfo',
               spec);

      }

      function addAlertMessage(messageKey, alerts) {
         var alertMessage = {
            text: i18nService.getString('HostUi', messageKey),
            type: vuiConstants.notifications.type.ERROR
         };
         alerts.push(alertMessage);
         return alerts;
      }
      function hostAuthHeaderOptions(objectId){
         return {
            title: i18nService.getString('HostUi', 'authServices.settings.tabLabel'),
            objectId: objectId,
            actions: [
               {
                  actionUid: 'vsphere.core.host.actions.authenticationServiceSettingsAddCertificate',
                  customLabel: i18nService.getString('HostUi', 'importCert.actionLabel')
               },
               {
                  actionUid: 'vsphere.core.host.actions.authenticationServiceSettingsJoinDomain',
                  customLabel: i18nService.getString('HostUi', 'authJoinDomain.actionLabel')
               },
               {
                  actionUid: 'vsphere.core.host.actions.authenticationServiceSettingsLeaveDomain',
                  customLabel: i18nService.getString('HostUi', 'authLeaveDomain.actionLabel')
               }]
         };
      }
      function smartCardHeaderOptions(){
         return {
            title: i18nService.getString('HostUi', 'smartCardAuthnetication.title'),
            actions: [
               {
                  actionUid: 'vsphere.core.host.actions.editSmartCardAuthentication',
                  customLabel: i18nService.getString('HostUi', 'smartCardAuthentication.editAction.label')

               }
            ]
         };
      }

      function nfsKerberosHeaderOptions() {
         return {
            title: i18nService.getString('StorageUi','nfsCredentials.blockTitle'),
            actions: [
                  {
                     actionUid: 'vsphere.core.host.actions.clearNfsKerberosCredentials',
                     customLabel: i18nService.getString('HostUi', 'nfsCredentials.clear.actionLabel')
                  }, {
                     actionUid: 'vsphere.core.host.actions.editNfsKerberosCredentials',
                     customLabel: i18nService.getString('HostUi', 'nfsCredentials.edit.actionLabel')
                  }
               ]
         };
      }

      function getSmartCardEnabledStatus(smartCardStatus) {
         var status;
         if (smartCardStatus) {
            status = i18nService.getString('HostUi', 'smartCardAuthentication.enabled.label');
         } else {
            status = i18nService.getString('HostUi', 'smartCardAuthentication.disabled.label');
         }
         return status;
      }
      function getDatagridOptions(userTimeFormat) {
         return {
            selectionMode: "single",
            sortMode: "single",
            searchable: false,
            columnDefs: [
               {
                  field: 'subject',
                  sortable: false,
                  searchable: false,
                  displayName: i18nService.getString('HostUi',
                        'smartCardAuthnetication.certificates.subject')
               },
               {
                  field: 'issuer',
                  sortable: false,
                  searchable: false,
                  displayName: i18nService.getString('HostUi',
                        'smartCardAuthnetication.certificates.issuer')
               },
               {
                  field: 'validTo',
                  sortable: false,
                  searchable: false,
                  displayName: i18nService.getString('HostUi',
                        'smartCardAuthnetication.certificates.validTo'),
                  template: function(data){
                     return timeFormatterService.timestampToText(
                           parseInt(data.validTo),
                           userTimeFormat
                     );
                  }
               }],
            data: [],
            height: '200px',
            pageConfig: {
               hidePager: true
            }
         };
      }
      function buildDomainSettingsSection(categoryBuilder, domainObject) {
         categoryBuilder.section('domainSettings')
               .title(i18nService.getString(
                     'HostUi',
                     'authServices.domain.settingsTitle'
               ))
               .property(
                     i18nService.getString(
                           'HostUi',
                           'authServices.domain.settings.domain'
                     ),
                     domainObject.domain
               )
               .property(
                     i18nService.getString(
                           'HostUi',
                           'authServices.domain.settings.trustedControllers'
                     ),
                     domainObject.trustedDomain
               );
      }
      function buildDirectoryServicesConfigSection(categoryBuilder, authStatus) {
         categoryBuilder.section('directoryServicesConfig')
               .title(i18nService.getString(
                     'HostUi',
                     'authServices.directory.configTitle'
               ))
               .property(
                     i18nService.getString(
                           'HostUi',
                           'authServices.directory.typeTitle'
                     ),
                     authStatus
               );
      }

      return {
         leaveDomain: leaveDomain,
         joinDomain: joinDomain,
         addCertificate: addCertificate,
         addAlertMessage: addAlertMessage,
         hostAuthHeaderOptions: hostAuthHeaderOptions,
         smartCardHeaderOptions: smartCardHeaderOptions,
         nfsKerberosHeaderOptions: nfsKerberosHeaderOptions,
         getSmartCardEnabledStatus: getSmartCardEnabledStatus,
         getDatagridOptions: getDatagridOptions,
         buildDomainSettingsSection: buildDomainSettingsSection,
         buildDirectoryServicesConfigSection: buildDirectoryServicesConfigSection
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('DefaultVmCompatibilityController', DefaultVmCompatibilityController);

   DefaultVmCompatibilityController.$inject = ['$scope', 'i18nService', 'dataService', 'defaultUriSchemeUtil'];

   function DefaultVmCompatibilityController($scope, i18nService, dataService, defaultUriSchemeUtil) {
      var self = this;

      $scope.i18nService = i18nService;

      self.objectsToWatch = [$scope._route.objectId];
      // in case of host - if in cluster - cluster's configurationEx else hosts
      // in case of datacenter - configuration
      self.liveRefreshProperties = ['configurationEx', 'configuration'];

      function setValue(defaultHardwareVersionKey, parent) {
         var defaultHardwareString;
         if (defaultHardwareVersionKey) {
            defaultHardwareString = i18nService.getString(
                  'VmUi', 'VmHardware.HWVersion.short.' + defaultHardwareVersionKey);
         } else {
            defaultHardwareString = i18nService.getString(
                  'VmUi', 'defaultVmHwVersionView.default');
         }

         if (parent) {
            // Watch parent compute resource for changes in case current object is host
            self.objectsToWatch.push(defaultUriSchemeUtil.getVsphereObjectId(parent));

            if (parent.type === 'ClusterComputeResource') {
               defaultHardwareString = i18nService.getString(
                     'VmUi', 'defaultVmHwVersionView.compatibilityHostInCluster',
                     defaultHardwareString);
            }
         }
         self.defaultVmHwVersion = defaultHardwareString;
      }

      self.headerOptions = {
         title: i18nService.getString('VmUi', 'defaultVmHardwareVersion')
      };

      var contentSpec = $scope._view.contentSpec;
      var defaultHardwareVersionProperty;
      var propertiesToRequest = [];

      if (contentSpec && contentSpec.metadata) {
         if (contentSpec.metadata.editActionId) {
            self.headerOptions.actions = [{
               actionUid: contentSpec.metadata.editActionId,
               customLabel: i18nService.getString('Common', 'settingsView.defaultEditActionLabel')
            }];
         }
         if (contentSpec.metadata.defaultHardwareVersionProperty) {
            defaultHardwareVersionProperty = contentSpec.metadata.defaultHardwareVersionProperty;
            propertiesToRequest.push(defaultHardwareVersionProperty);
         }
         if (!!contentSpec.metadata.watchParentForChanges) {
            propertiesToRequest.push('parent');
         }
      }

      if (propertiesToRequest.length > 0 && defaultHardwareVersionProperty) {
         self.fetchViewData = function() {
            dataService.getProperties($scope._route.objectId, propertiesToRequest)
               .then(function(propertiesData) {
                  setValue(propertiesData[defaultHardwareVersionProperty], propertiesData.parent);
               });
         };

         self.fetchViewData();
      }

   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditAgentVmSettingsController',
         ['$scope',
            'dataService',
            'mutationService',
            'i18nService',
            EditAgentVmSettingsCtrl]);

   function EditAgentVmSettingsCtrl($scope,
                                    dataService,
                                    mutationService,
                                    i18nService) {

      var self = this;
      self.loading = true;

      var objectId = $scope.modalOptions.dialogData.availableTargets[0];

      $scope.modalOptions.onSubmit = onOKClicked.bind(this);

      getViewData();

      function getViewData() {
         dataService.getProperties(objectId, ['fullAgentVmSettings'])
               .then(function (response) {
                  self.datastoreOptions = response.fullAgentVmSettings.datastores;
                  var selectedDatastore = response.fullAgentVmSettings.selectedDatastore;

                  if (!selectedDatastore) {
                     self.selectedDatastore = null;
                  } else {
                     var selectedDatastoreIndex = findSelectedIndex(
                           self.datastoreOptions, selectedDatastore);
                     self.selectedDatastore = self.datastoreOptions[selectedDatastoreIndex];
                  }

                  self.networkOptions = response.fullAgentVmSettings.networks;
                  var selectedNetwork = response.fullAgentVmSettings.selectedNetwork;

                  if (!selectedNetwork) {
                     self.selectedNetwork = null;
                  } else {
                     var selectedNetworkIndex = findSelectedIndex(
                           self.networkOptions, selectedNetwork);
                     self.selectedNetwork = self.networkOptions[selectedNetworkIndex];
                  }

                  self.loading = false;
               });
      }

      function findSelectedIndex(objArray, objectToSearchFor) {
         return _.findIndex(objArray, function (item) {
            return _.isEqual(item.value, objectToSearchFor);
         });
      }

      function onOKClicked() {
         mutationService.apply(objectId,
               "com.vmware.vsphere.client.h5.host.config.spec.AgentVmSettingsSpec",
               {
                  datastore: self.selectedDatastore ?
                        self.selectedDatastore.value : null,
                  network: self.selectedNetwork ?
                        self.selectedNetwork.value : null
               },
               i18nService.getString('HostUi', 'settings.agentVm.operation'));
         return true;
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditDefaultVmCompatiblityController', EditDefaultVmCompatiblityController);

   EditDefaultVmCompatiblityController.$inject = ['$scope',
      'i18nService', 'dataService', 'mutationService', 'helpService', 'helpConstants',
      'defaultUriSchemeUtil'];

   function EditDefaultVmCompatiblityController($scope,
         i18nService, dataService, mutationService, helpService, helpConstants,
         defaultUriSchemeUtil) {
      var self = this;
      var undefinedHwVersionKey = 'unspecified';

      self.popupParams = {
         title: i18nService.getString('Common', 'help'),
         message: i18nService.getString('Common', 'signpost.hardwareVersionSelector'),
         linkLabel : i18nService.getString('HostUi', 'edit.defaultvm.helperlink.label'),
         linkFunction : function(){
            helpService.showHelpPage(helpConstants.EDIT_DEFAULT_VM_COMPATIBILITY_ID);
         }
      };

      self.loading = true;
      $scope.modalOptions.submitDisabled = true;

      $scope.i18nService = i18nService;

      var objectId = $scope._route.objectId;

      $scope.modalOptions.onSubmit = function() {
         if (self.loading) {
            return false;
         }

         var selectedKey = '';
         if (self.selectedOption.key !== undefinedHwVersionKey) {
            selectedKey = self.selectedOption.key;
         }
         mutationService.apply(objectId,
            'com.vmware.vsphere.client.mixed.DefaultHwVersionSpec',
            {hwVersionKey: selectedKey},
            'EditDefaultVmCompatibility');

         return true;
      };

      self.compatibilityOptions = [];

      var entityType = defaultUriSchemeUtil.getEntityType(objectId);

      dataService.getProperties(objectId,
            ['optionDescriptorsWithCreateSupported', 'defaultHardwareVersionKey'])
      .then(function(data) {
         var options = data.optionDescriptorsWithCreateSupported;
         var defaultConfigOption = 0;
         self.compatibilityOptions.push({
            key: undefinedHwVersionKey,
            localizedShortString: i18nService.getString('HostUi',
                  entityType === 'Datacenter' ?
                        'defaultVmCompatibilityDialog.short.unspecifiedForDc' :
                        'defaultVmCompatibilityDialog.short.unspecifiedForCr'),
            localizedDescriptionString: i18nService.getString('HostUi',
                  entityType === 'Datacenter' ?
                        'defaultVmCompatibilityDialog.unspecifiedForDc' :
                        'defaultVmCompatibilityDialog.unspecifiedForCr')
         });

         var moreOptions = _.map(options, function(option, index) {
            if (option.defaultConfigOption) {
               defaultConfigOption = index + 1;
            }

            return {
               key: option.key,
               localizedShortString: i18nService.getString('HostUi',
                     'defaultVmCompatibilityDialog.short.' + option.key),
               localizedDescriptionString: i18nService.getString('HostUi',
                     'defaultVmCompatibilityDialog.' + option.key)
            };

         });

         self.compatibilityOptions = self.compatibilityOptions.concat(moreOptions);

         if(!data.defaultHardwareVersionKey) {
            self.selectedOption = self.compatibilityOptions[0];
         } else {
            self.selectedOption = self.compatibilityOptions[defaultConfigOption];
         }
         self.loading = false;
         $scope.modalOptions.submitDisabled = false;
      });
   }
})();

(function() {
   'use strict';

   /**
    * Host firewall connections grid controller.
    */
   angular.module('com.vmware.vsphere.client.host')
         .controller('EditFirewallSettingsController', EditFirewallSettingsController);

   EditFirewallSettingsController.$inject =
         ['$scope', 'i18nService', 'dataService', 'mutationService', 'editFirewallSettingsService'];

   function EditFirewallSettingsController($scope,
         i18nService, dataService,
         mutationService,
         editFirewallSettingsService) {
      var self = this;

      self.hostId = $scope.modalOptions.dialogData.availableTargets[0];

      self.firewallService = editFirewallSettingsService;
      self.filterPlaceholderText = i18nService.getString('Common', 'filter.label');
      self.searchTerm = '';
      self.dataGridOriginalData = [];
      self.filterSettings = filterSettings;
      $scope.datagridOptions = self.firewallService.getDataGridOptions();
      $scope.ipObject = {};
      self.getViewData = getViewData;
      $scope.modalOptions.onSubmit = submit;

      function getViewData() {
         setPageBusy(true);
         dataService
               .getData(
                     self.hostId,
                     'com.vmware.vsphere.client.h5.host.model.FirewallSettingsData')
               .then(function(data) {
                  self.originalData = data.connections;
                  self.modifiedData = _.map(data.connections, function(dataItem) {
                     return angular.merge({}, dataItem);
                  });
                  var gridData = _.map(self.modifiedData, function(dataItem) {
                     return angular.merge({
                        _rawItem: dataItem
                     }, dataItem);
                  });

                  self.dataGridOriginalData = gridData;
                  $scope.datagridOptions.data = gridData;
                  setPageBusy(false);
               });
      }

      $scope.$watch('ipObject.ipList', function(newData) {
         $scope.ipError = !self.firewallService.validateIpAddresses(newData);
      });

      $scope.$watch('datagridOptions.selectedItems', function(newData, oldData) {
         $scope.ipErrorShow = false;
         if (newData && newData.length === 1) {
            $scope.selectedDatagridItem = true;
            var filteredIpData = self.firewallService.removeInvalidData($scope.ipObject.ipList);
            if ($scope.ipError && !$scope.ipObject.allIp) {
               if (oldData) {
                  $scope.datagridOptions.selectedItems[0] = oldData[0];
                  blockSelectionOfDatagrid(oldData[0].uid);
                  $scope.invalidItems = filteredIpData.invalidItems;
                  $scope.ipErrorShow = true;
               }
            }
            else {
               if ($scope.ipError && $scope.ipObject.allIp) {
                  $scope.ipObject.ipList = filteredIpData.filteredItems;
               }
               if (oldData[0]) {
                  createModifiedObject(oldData[0], $scope.ipObject.ipList, $scope.ipObject.allIp);
               }

               $scope.datagridOptions.selectedItems[0] = newData[0];
               if (newData[0].ipList.toLowerCase() !== "all") {
                  $scope.ipObject.ipList = newData[0].ipList;
               } else {
                  $scope.ipObject.ipList =
                        self.firewallService.createIpListFromRawData(
                              newData[0].rawIpList
                        );
               }
               $scope.ipObject.allIp = newData[0].rawIpList.allIp;
            }

         } else {
            $scope.selectedDatagridItem = false;
         }
      });

      function blockSelectionOfDatagrid(uid) {
         $('[data-uid='+uid+'] td:nth-child(2) td:nth-child(2)').mousedown().mouseup();
         $('tbody[role="rowgroup"] tr').attr('aria-selected','false').removeClass('k-state-selected');
         $('[data-uid='+uid+']').attr('aria-selected','true').addClass('k-state-selected');
      }

      function createModifiedObject(oldData, ipList, allIp) {
         $scope.ipError = false;
         $scope.ipErrorShow = false;

         // If allIp checkbox is clicked we should remove the invalid data
         if (allIp) {
            if (oldData){
               // Remove the invalid addresses
               var validData = self.firewallService.removeInvalidData(ipList);
               var validIpList = validData ? validData.filteredItems : "";
               // Create the new valid raw ip list with the removed invalid data
               var rawValidIpAddresses = !_.isEmpty(validIpList) ? self.firewallService.createRawIpList(validIpList) : [];

               oldData.rawIpList.ipAddress = rawValidIpAddresses;
               oldData.ipList = validIpList;

               var validRawIpNetworks = !_.isEmpty(validIpList) ? self.firewallService.createRawNetworkList(validIpList) : [];
               oldData.rawIpList.ipNetwork = validRawIpNetworks;
               oldData.rawIpList.allIp = allIp;

               oldData._rawItem.rawIpList.allIp = allIp;
               oldData._rawItem.rawIpList.ipNetwork = validRawIpNetworks;
               oldData._rawItem.rawIpList.ipAddress = rawValidIpAddresses;
               oldData._rawItem.ipList = validIpList;
            }
            return true;
         } else {
            if (self.firewallService.validateIpAddresses(ipList)) {
               if (oldData){
                  var rawIpList = self.firewallService.createRawIpList(ipList);
                  oldData.rawIpList.ipAddress = rawIpList;
                  oldData.ipList = ipList;

                  var rawIpNetworks = self.firewallService.createRawNetworkList(ipList);
                  oldData.rawIpList.ipNetwork = rawIpNetworks;
                  oldData.rawIpList.allIp = allIp;

                  oldData._rawItem.rawIpList.allIp = allIp;
                  oldData._rawItem.rawIpList.ipNetwork = rawIpNetworks;
                  oldData._rawItem.rawIpList.ipAddress = rawIpList;
                  oldData._rawItem.ipList = ipList;

               }
               return true;
            } else {
               $scope.invalidItems = self.firewallService.removeInvalidData(ipList).invalidItems;
               $scope.ipError = true;
               $scope.ipErrorShow = true;
               return false;
            }
         }
      }

      function getString(key) {
         return i18nService.getString("HostUi", key);
      }

      function submit() {
         var isValid = createModifiedObject($scope.datagridOptions.selectedItems[0],
               $scope.ipObject.ipList,
               $scope.ipObject.allIp);
         if (!isValid) {
            return;
         }
         var spec = self.firewallService.createSpec(
               self.modifiedData, self.originalData);

         if (_.isEmpty(spec)) {
            return true;
         }

         mutationService.apply(
               self.hostId,
               'com.vmware.vsphere.client.h5.host.firewall.spec.FirewallConfigurationSpec',
               spec,
               getString('editFirewallSettingsDialog.applySecurityProfileOperationName')
         );
         return true;
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         self.loading = isBusy;
      }

      function filterSettings() {
         var propertiesToSearchInFor = ["serviceName", "serviceKey", "daemonStatus",
            "inboundDirectionInfo.combinedPorts", "outboundDirectionInfo.combinedPorts"];

         $scope.datagridOptions.data = self.firewallService.filterSettings(
               self.dataGridOriginalData,
               self.searchTerm,
               propertiesToSearchInFor);
      }

      getViewData();
   }
})
();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('editFirewallSettingsService',
         EditFirewallSettingsService);

   EditFirewallSettingsService.$inject = ['ipParserService', 'vuiConstants', 'i18nService'];

   function EditFirewallSettingsService(ipParserService, vuiConstants, i18nService) {



      // -- Public methods

      function createIpListFromRawData(rawIpList) {
         var ips = '';
         var networks = '';
         if (rawIpList.ipAddress && rawIpList.ipAddress.length > 0) {
            ips = rawIpList.ipAddress.join();
         }

         if (rawIpList.ipNetwork && rawIpList.ipNetwork.length > 0) {
            _.each(rawIpList.ipNetwork, function(network, index) {
               networks += network.network + "/" + network.prefixLength;
               if (index !== rawIpList.ipNetwork.length - 1) {
                  networks += ", ";
               }
            });
         }
         if (ips !== '' && networks !== '') {
            return ips + ', ' + networks;
         } else if (ips !== '' && networks === '') {
            return ips;
         } else if (ips === '' && networks !== '') {
            return networks;
         } else {
            return "";
         }
      }

      function createRawIpList(ipList) {
         var arrayOfIps = [];
         if (ipList) {
            var ipAddresses = ipList.split(',');
            _.each(ipAddresses, function(ip) {
               if (ip.indexOf('/') === -1) {
                  arrayOfIps.push(ip.trim());
               }
            });
         }

         return arrayOfIps;
      }

      function removeInvalidData(ipList) {
         if (!ipList) {
            return;
         }
         var rawIpList = ipList.split(',');

         var filteredItems = _.filter(rawIpList, function(ip) {
            return validateIpAddress(ip);
         });

         var invalidItems = _.filter(rawIpList, function(ip) {
            return !validateIpAddress(ip);
         });

         return {
            filteredItems: filteredItems.join(),
            invalidItems: invalidItems.join()
         };
      }

      function validateIpAddresses(ipAddressesText) {

         if (!ipAddressesText) {
            return true;
         }

         if (ipAddressesText === "") {
            return true;
         }
         var rawIpAddresses = ipAddressesText.split(',');

         return _.every(rawIpAddresses, function(item){
            return validateIpAddress(item);
         });
      }

      function createRawNetworkList(ipNetworkList) {
         var arrayOfIpNetworks = [];
         if (ipNetworkList) {
            var ipAddressesAndNetworks = ipNetworkList.split(',');
            _.each(ipAddressesAndNetworks, function(ip) {
               if (ip.indexOf('/') > -1) {
                  var network = ip.split('/');
                  arrayOfIpNetworks.push(
                        {
                           network: network[0].trim(),
                           prefixLength: parseInt(network[1])
                        }
                  );
               }
            });
         }

         return arrayOfIpNetworks;
      }

      function getDataGridOptions() {
         return {
            height: '100%',
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            selectedItems: [],
            resizable: true,
            data: [],
            columnDefs: getColumnDefs(),
            sortOrder: [{
               field: 'serviceName',
               dir: 'asc'
            }],
            groupOrder: [{
               field: 'group',
               dir: 'asc'
            }]
         };
      }

      function createSpec(modifiedData, originalData) {
         var spec = {};
         var enabledIpList = createEnabledAndIpList(modifiedData, originalData);
         var emptyIpList = _.isEmpty(enabledIpList.connectionsWithModifiedIpList);
         var emptyEnabledList = _.isEmpty(enabledIpList.connectionsWithModifiedEnabledState);

         if (emptyEnabledList && emptyIpList) {
            return spec;
         }
         if (emptyIpList) {  // ENABLED Spec
            spec = {
               rulesetToEnabledState: getRulesetToEnabledStateMap(
                     enabledIpList.connectionsWithModifiedEnabledState
               )
            };
         } else if (emptyEnabledList) {  // IP Spec
            spec = {
               ipNetworkConfigurationSpec: getRulesetToIpListStateMap(
                     enabledIpList.connectionsWithModifiedIpList
               )
            };
         } else {  // Both
            spec = {
               rulesetToEnabledState: getRulesetToEnabledStateMap(
                     enabledIpList.connectionsWithModifiedEnabledState
               ),
               ipNetworkConfigurationSpec: getRulesetToIpListStateMap(
                     enabledIpList.connectionsWithModifiedIpList
               )
            };
         }
         return spec;
      }

      // -- Private methods

      function getString(key) {
         return i18nService.getString("HostUi", key);
      }


      function validateIpAddress(ip) {
         ip = ip.trim();

         if (ipParserService.isIpv6AddressValid(ip)
               || ipParserService.isIpv4AddressValid(ip)) {
            return true;
         } else {
            var maskedIpAddress = ip.split('/');
            return validMaskedIpAddress(maskedIpAddress);
         }
      }

      function validMaskedIpAddress(maskedIpAddress) {
         if (maskedIpAddress && maskedIpAddress.length === 2) {
            var ipAddress = maskedIpAddress[0];
            var mask = parseInt(maskedIpAddress[1]);
            var validIpVersion4 = ipParserService.isIpv4AddressValid(ipAddress) &&
                  mask >= 0 && mask < 32;
            var validIpVersion6 = ipParserService.isIpv6AddressValid(ipAddress) &&
                  mask >= 0 && mask <= 128;
            return validIpVersion4 || validIpVersion6;
         }
         return false;
      }

      function getColumnDefs() {
         return [
            {
               displayName: getString('editFirewallSettingsDialog.grid.column.groupLabel'),
               field: 'group',
               visible: false
            },{
            displayName: getString('firewallConnection.serviceName'),
            field: 'serviceName',
            filterable: false,
            searchable: false,
            template: function(dataItem) {
               return createCheckboxWithServiceName(dataItem);
            }
         }, {
            displayName: getString('editFirewallSettingsDialog.grid.column.inbound'),
            field: 'inboundDirectionInfo.combinedPorts',
            filterable: false,
            searchable: false,
            template: function(dataItem) {
               return dataItem.inboundDirectionInfo.combinedPorts || getString('none.label');
            }
         }, {
            displayName: getString('editFirewallSettingsDialog.grid.column.outbound'),
            field: 'outboundDirectionInfo.combinedPorts',
            filterable: false,
            searchable: false,
            template: function(dataItem) {
               return dataItem.outboundDirectionInfo.combinedPorts || getString('none.label');
            }
         }, {
            displayName: getString('editFirewallSettingsDialog.grid.column.daemonStatus'),
            field: 'daemonStatus',
            filterable: false,
            searchable: false,
            template: function(dataItem) {
               return getDaemonStatusDisplayMessage(dataItem.daemonStatus);
            }
         }];
      }

      function createCheckboxWithServiceName(dataItem) {
         return '' +
               '<label>' +
               '  <input type="checkbox" ' +
               '     ng-model="dataItem.enabled"' +
               '     ng-change="dataItem._rawItem.enabled = dataItem.enabled">' +
               '  {{dataItem.serviceName}}' +
               '</label>';
      }

      function getConnectionsWithModifiedEnabledState(modifiedData, originalData) {
         return _.filter(modifiedData, function(modifiedItemData, index) {
            return modifiedItemData.enabled !== originalData[index].enabled;
         });
      }

      function getConnectionsWithModifiedIpAddresses(modifiedData, originalData) {
         return _.filter(modifiedData, function(modifiedItemData, index) {
            return (modifiedItemData.rawIpList.allIp !== originalData[index].rawIpList.allIp) ||
                  (modifiedItemData.ipList !== originalData[index].ipList);
         });
      }

      function getRulesetToEnabledStateMap(connectionsWithModifiedEnabledState) {
         return _.object(_.map(connectionsWithModifiedEnabledState, function(item) {
            return [item.serviceKey, item.enabled];
         }));
      }

      function getRulesetToIpListStateMap(connectionsWithModifiedIpList) {
         return _.object(_.map(connectionsWithModifiedIpList, function(item) {
            return [item.serviceKey, {
               allIp: item.rawIpList.allIp,
               ipAddresses: item.rawIpList.ipAddress,
               ipNetworks: item.rawIpList.ipNetwork
            }];
         }));
      }


      function createEnabledAndIpList(modifiedData, originalData) {
         var connectionsWithModifiedEnabledState =
               getConnectionsWithModifiedEnabledState(
                     modifiedData,
                     originalData
               );

         var connectionsWithModifiedIpList =
               getConnectionsWithModifiedIpAddresses(
                     modifiedData,
                     originalData
               );
         return {
            connectionsWithModifiedEnabledState: connectionsWithModifiedEnabledState,
            connectionsWithModifiedIpList: connectionsWithModifiedIpList
         };

      }

      function filterSettings(originalData, searchTerm, propertiesToSearchInFor) {
         var searchValue = searchTerm.toLowerCase();
         return _.filter(originalData, function(item) {
            return isSearchValuePresentedInProperties(item, searchValue, propertiesToSearchInFor);
         });
      }

      function isSearchValuePresentedInProperties(item, searchItem, properties) {
         return _.some(properties, function(property) {
            var currentPropertyValue = item[property];
            return property === 'daemonStatus' ?
                  searchInDaemonStatus(currentPropertyValue, searchItem) :
            currentPropertyValue.toLowerCase().indexOf(searchItem) >= 0;
         });
      }

      function searchInDaemonStatus(daemonStatusValue, searchItem) {
         var daemonStatusDisplayMessageLowerCase =
               getDaemonStatusDisplayMessage(daemonStatusValue).toLowerCase();

         return daemonStatusDisplayMessageLowerCase.indexOf(searchItem) >= 0;
      }

      function getDaemonStatusDisplayMessage(daemonStatus) {
         var status = '';
         if (daemonStatus === null){
            status = getString('editFirewallSettingsDialog.daemonStatus.notPresented');
         }
         else {
            status = daemonStatus === 'true' ?
                  getString('editFirewallSettingsDialog.daemonStatus.running') :
                  getString('editFirewallSettingsDialog.daemonStatus.stopped');
         }

         return status;
      }

      return {
         createIpListFromRawData: createIpListFromRawData,
         removeInvalidData: removeInvalidData,
         createRawIpList: createRawIpList,
         validateIpAddresses: validateIpAddresses,
         createRawNetworkList: createRawNetworkList,
         getDataGridOptions: getDataGridOptions,
         createSpec: createSpec,
         filterSettings: filterSettings
      };

   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * EditPowerConfigHardwareController - Responsible for editing the power config hardware options of host.
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditPowerConfigHardwareController',
         ['$scope', 'dataService', 'mutationService',EditPowerConfigHardwareCtrl]);

   function EditPowerConfigHardwareCtrl($scope, dataService, mutationService) {
      var self = this;
      var objectId = $scope.modalOptions.dialogData.availableTargets[0];
      self.model = { selectedPolicyKey: null };
      self.data = {};

      $scope.modalOptions.onSubmit = onOKClicked.bind(this);

      getViewData();

      // Functions
      function getViewData() {
         self.loading = true;
         dataService.getProperties(objectId, ['powerSystemCapability','config.powerSystemInfo.currentPolicy'])
         .then(function(response) {
            self.data = response;
            self.model.selectedPolicyKey = response['config.powerSystemInfo.currentPolicy'].key;
            self.loading = false;
         });
      }

      function onOKClicked() {
         if (!self.model.selectedPolicyKey) {
            return true;
         }
         var powerConfigHardwareSpec = {
            policyKey: self.model.selectedPolicyKey
         };
         var propType = 'com.vmware.vsphere.client.host.config.PowerConfigHardwareSpec';
         var operation = $scope.modalOptions.title;

         mutationService.apply(objectId, propType, powerConfigHardwareSpec, operation);

         // Return true to dismiss the dialog.
         return true;
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('EditPowerConfigSoftwareController', EditPowerConfigSoftwareController);

   EditPowerConfigSoftwareController.$inject = ['$scope', 'dataService',
      'mutationService', 'ipParserService', 'vuiConstants', 'i18nService', '$q'];

   function EditPowerConfigSoftwareController($scope, dataService,
         mutationService, ipParserService, vuiConstants, i18nService, $q) {
      var self = this;
      var objectId = $scope.modalOptions.dialogData.availableTargets[0];
      self.loading = false;

      $scope.modalOptions.isAlertClosed = true;
      $scope.modalOptions.onSubmit = onSubmit;
      getViewData();

      function getViewData() {
         setPageBusy(true);
         dataService.getProperties(objectId, ['powerConfigSoftware'])
               .then(function(response) {
                  initData(response.powerConfigSoftware.properties);
                  setPageBusy(false);
               })
               .catch(function(error) {
                  setPageBusy(false);
                  $q.reject(error);
               });
      }

      function initData(properties) {
         _.each(properties, function(property) {
                  switch (property.name) {
                     case 'login':
                        self.userName = property.value;
                        break;
                     case 'password':
                        self.password = property.value;
                        break;
                     case 'bmcIpAddress':
                        self.bmcIpAddress = property.value;
                        break;
                     case 'bmcMacAddress':
                        self.bmcMacAddress = property.value;
                        break;
                  }
               }
         );
      }

      function onSubmit() {
         var data = {
            login: self.userName,
            password: self.password,
            bmcIpAddress: self.bmcIpAddress,
            bmcMacAddress: self.bmcMacAddress
         };
         var validationMessages = validatePowerConfigSoftwareSpec(data);
         if (validationMessages.length === 0) {
            mutationService.apply(objectId,
                  'com.vmware.vsphere.client.h5.host.config.spec.PowerConfigSoftwareSpec',
                  data);
            return true;
         } else {
            showValidationMessages(validationMessages);
            return false;
         }
      }

      function validatePowerConfigSoftwareSpec(data) {
         var validationMessages = [];
         if (data.login === '' && data.password === '' && data.bmcIpAddress === ''
               && data.bmcMacAddress === '' ) {
            return validationMessages;
         }

         if (data.login === '' || data.password === '' || data.bmcIpAddress === ''
               || data.bmcMacAddress === '') {
            var allParametersRequiredMessage = i18nService.getString('HostUi',
                  'powerConfigSoftware.error.allParametersRequired');
            validationMessages.push(allParametersRequiredMessage);
         }

         if (data.bmcIpAddress !== '' &&
               !ipParserService.isAddressValid(data.bmcIpAddress)) {
            var invalidIpAddress = i18nService.getString('HostUi',
                  'powerConfigSoftware.error.invalidIpAddress');
            validationMessages.push(invalidIpAddress);
         }

         return validationMessages;
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         self.loading = isBusy;
      }

      function showValidationMessages(messages) {
          var validationErrorMessages = _.map(messages, function(message) {
            return {
               type: vuiConstants.validationBanner.type.ERROR,
               text: message
            };
         });
         $scope.modalOptions.isAlertClosed = false;
         $scope.modalOptions.alerts = validationErrorMessages;
         return false;
      }
   }
})();

(function() {
   angular.module('com.vmware.vsphere.client.host').controller(
         'EditVmSwapfileLocationController', EditVmSwapfileLocationController);

   EditVmSwapfileLocationController.$inject = ['$scope', 'dataService',
      'bytesFormatter', 'i18nService', 'vuiConstants', 'mutationService', '$q'];

   function EditVmSwapfileLocationController($scope, dataService,
         bytesFormatter, i18nService, vuiConstants, mutationService, $q) {
      var hostId = $scope.modalOptions.dialogData.availableTargets[0];
      var self = this;
      $scope.modalOptions.isAlertClosed = true;
      self.datastoreMorefs = [];
      self.datastores = [];
      setPageBusy(true);
      self.gridOptions = {
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         sortMode: vuiConstants.grid.sortMode.SINGLE,
         searchable: false,
         resizable: true,
         selectedItems: [],
         data: [],
         columnDefs: getColumnDefs(),
         height: 'auto'
      };

      $scope.$watch(function() {
               return self.gridOptions.selectedItems;
            },
            function(selectedItems) {
               self.selectedDatastore = selectedItems[0];
            });

      $scope.modalOptions.onSubmit = onOkClick;

      getDialogViewData();

      function getDialogViewData() {
         dataService.getData(
               hostId,
               'com.vmware.vsphere.client.h5.host.model.SwapfileLocationData'
         ).then(function(data) {
            if (data) {
               self.originalSwapFileLocation = data.vmSwapPlacement;
               self.swapfileLocation = data.vmSwapPlacement;
               self.computeResource = data.computeResource;
               self.isRadioDisabled = data.isStandalone ?
                     false : self.swapfileLocation !== "vmDirectory";
            }
         });

         getDatastores();
      }

      function getDatastores() {
         dataService.getProperties(hostId,
               ['configTargetDatastoreInfo'])
               .then(function(data) {
                  if (data) {
                     self.gridOptions.data = processDatastores(data.configTargetDatastoreInfo);
                  }
                  setPageBusy(false);
               }).catch(function(error) {
                  setPageBusy(false);
                  $q.reject(error);
               });
      }

      function processDatastores(datastoreInfos) {
         datastoreInfos = _.filter(datastoreInfos, function(datastoreInfo) {
            return datastoreInfo.datastore.type !== 'VVOL';
         });

         self.datastoreMorefs = _.map(datastoreInfos, function(datastoreInfo) {
            return {
               name: datastoreInfo.name,
               moRef: datastoreInfo.datastore.datastore
            };
         });

         return _.map(datastoreInfos, function(datastoreInfo) {
            var provisionedCapacity = calculateProvisionedCapacity(datastoreInfo.datastore);
            return {
               name: datastoreInfo.name,
               raw_capacity: datastoreInfo.datastore.capacity,
               capacity: bytesFormatter.bytesFormat(datastoreInfo.datastore.capacity),
               raw_provisioned: provisionedCapacity,
               provisioned: bytesFormatter.bytesFormat(provisionedCapacity),
               raw_free: datastoreInfo.datastore.freeSpace,
               free: bytesFormatter.bytesFormat(datastoreInfo.datastore.freeSpace),
               type: datastoreInfo.datastore.type,
               thin: calculateThinCapacity(datastoreInfo)
            };
         });
      }

      function calculateProvisionedCapacity(datastore) {
         var freeCapacity = datastore.freeSpace;
         var totalCapacity = datastore.capacity;
         var provisionedCapacity = totalCapacity - freeCapacity;

         if (datastore.uncommitted && !isNaN(datastore.uncommitted)) {
            provisionedCapacity += datastore.uncommitted;
         }

         return provisionedCapacity;
      }

      function calculateThinCapacity(datastoreInfo) {
         var thinLabel = i18nService.getString("HostUi", "swapfile.supported");

         if (datastoreInfo.capability
               && !datastoreInfo.capability.perFileThinProvisioningSupported) {
            thinLabel = i18nService.getString("HostUi", "swapfile.notsupported");
         }

         return thinLabel;
      }

      function onOkClick() {
         var hostSwapFileReconfigureSpec = {
            swapFileLocationType: self.swapfileLocation,
            computeResource: self.computeResource,
            reconfigure: self.swapfileLocation !== self.originalSwapFileLocation
         };

         if (self.swapfileLocation && self.swapfileLocation === 'hostLocal') {
            if (self.selectedDatastore) {
               var datastoreMoref = _.find(self.datastoreMorefs, function(datastoreMoref){
                  return datastoreMoref.name === self.selectedDatastore.name;
               });
               hostSwapFileReconfigureSpec.datastore = datastoreMoref.moRef;
            } else {
               $scope.modalOptions.alerts = [{
                  type: vuiConstants.validationBanner.type.ERROR,
                  text: i18nService
                        .getString('HostUi', 'settings.swapfile.missing.datastore.error')
               }];
               $scope.modalOptions.isAlertClosed = false;
               return false;
            }
         }

         mutationService.apply(hostId,
               'com.vmware.vsphere.client.host.config.HostSwapFileReconfigureSpec',
               hostSwapFileReconfigureSpec);
         return true;
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         self.loading = isBusy;
      }

      function getColumnDefs() {
         return [
            {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.name'),
               field: 'name'
            },
            {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.capacity'),
               field: 'capacity',
               sortable: function compare(firstItem, secondItem) {
                  return sort(firstItem, secondItem, 'raw_capacity');
               }
            },
            {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.provisioned'),
               field: 'provisioned',
               sortable: function compare(firstItem, secondItem) {
                  return sort(firstItem, secondItem, 'raw_provisioned');
               }
            },
            {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.free'),
               field: 'free',
               sortable: function compare(firstItem, secondItem) {
                  return sort(firstItem, secondItem, 'raw_free');
               }
            }, {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.type'),
               field: 'type'
            },
            {
               displayName: i18nService.getString('HostUi', 'swapfile.datastore.thin'),
               field: 'thin'
            }
         ];
      }

      function sort(firstItem, secondItem, sortProperty) {
         if (firstItem[sortProperty] < secondItem[sortProperty]) {
            return -1;
         }
         if (firstItem[sortProperty] > secondItem[sortProperty]) {
            return 1;
         }
         return 0;
      }
   }
})();

(function () {
   'use strict';

   /**
    * Host firewall connections grid controller.
    */
   angular.module('com.vmware.vsphere.client.host')
         .controller('FirewallSettingsController', FirewallSettingsController);

   FirewallSettingsController.$inject =
         ['$scope', 'vuiConstants', 'i18nService', 'dataService'];

   function FirewallSettingsController(
         $scope, vuiConstants, i18nService, dataService) {
      var self = this;

      self.hostId = $scope._route.objectId;
      self.watchForObjects = [self.hostId];
      self.liveRefreshProperties = ['config.firewall.ruleset', 'config.service.service'];
      self.datagridOptions = getDataGridOptions();
      self.headerOptions = getHeaderOptions();
      self.getViewData = getViewData;

      getViewData();

      function getViewData() {
         self.loading = true;
         dataService
               .getData(
                     self.hostId,
                     'com.vmware.vsphere.client.h5.host.model.FirewallSettingsData')
               .then(function (data) {
                  var gridData = _.map(data.connections, function(connection) {
                     var inboundConnection = angular.merge({}, connection);
                     inboundConnection.directionInfo =
                           inboundConnection.inboundDirectionInfo;
                     delete inboundConnection.inboundDirectionInfo;
                     delete inboundConnection.outboundDirectionInfo;

                     var outboundConnection = angular.merge({}, connection);
                     outboundConnection.directionInfo =
                           outboundConnection.outboundDirectionInfo;
                     delete outboundConnection.inboundDirectionInfo;
                     delete outboundConnection.outboundDirectionInfo;

                     return [inboundConnection, outboundConnection];
                  });
                  gridData = _.flatten(gridData);
                  gridData = _.filter(gridData, function(connection) {
                     return connection.enabled &&
                           (!_.isEmpty(connection.directionInfo.rawTcpPorts) ||
                              !_.isEmpty(connection.directionInfo.rawUdpPorts));
                  });

                  self.datagridOptions.data = gridData;
                  self.loading = false;
               });
      }

      function getHeaderOptions() {
         return {
            title: getString('securityProfile.firewall'),
            objectId: self.hostId,
            actions: [{
               actionUid: 'vsphere.core.host.actions.editFirewallSettings',
               customLabel: i18nService.getString('HostUi', 'editFirewallSettingsButton.label')
            }]
         };
      }

      function getDataGridOptions() {
         return {
            height: '100%',
            selectionMode: vuiConstants.grid.selectionMode.NONE,
            selectedItems: [],
            data: [],
            columnDefs: getColumnDefs(),
            sortOrder: [{
               field: 'serviceName',
               dir: 'asc'}],
            groupOrder: [{
               field: 'directionInfo.direction',
               dir: 'asc'}]
         };
      }

      function getColumnDefs() {
         return [
            {
               displayName: getString("firewallConnection.connection"),
               field: 'directionInfo.direction',
               visible: false
            },
            {
               displayName: getString('firewallConnection.serviceName'),
               field: 'serviceName',
               template: '#:serviceName#'
            },
            {
               displayName: getString('firewallConnection.tcpPort'),
               field: 'directionInfo.tcpPorts',
               template: function(dataItem) {
                  return dataItem.directionInfo.tcpPorts || getString('none.label');
               }
            },
            {
               displayName: getString('firewallConnection.udpPort'),
               field: 'directionInfo.udpPorts',
               template: function(dataItem) {
                  return dataItem.directionInfo.udpPorts || getString('none.label');
               }
            },
            {
               displayName: getString('firewallConnection.ipAddresses'),
               field: 'ipList',
               template: function(dataItem) {
                  return dataItem.ipList || getString('none.label');
               }
            }
         ];
      }

      function getString(key) {
         return i18nService.getString("HostUi", key);
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('editGraphicDeviceController', EditGraphicDeviceController);

   EditGraphicDeviceController.$inject = [
      '$scope',
      'mutationService',
      'hostServicesConstants'
   ];

   function EditGraphicDeviceController($scope, mutationService, hostServicesConstants) {
      var self = this;
      var selectedItem = $scope.modalOptions.dialogData.selectedItem;
      var hostId = $scope.modalOptions.dialogData.objectId;
      self.xorgServiceRestart = true;
      if (selectedItem.configuredType === ' ') {
         self.sharedMode = '';
      } else {
         self.sharedMode = selectedItem.configuredType;
      }

      $scope.modalOptions.onSubmit = function() {
         var hostGraphicsConfigSpec =
         {
            '_type': 'com.vmware.vim.binding.vim.host.GraphicsConfig',
            hostDefaultGraphicsType: $scope.modalOptions.dialogData.defaultGraphicsType,
            sharedPassthruAssignmentPolicy: $scope.modalOptions.dialogData.sharedPassthruAssignmentPolicy,
            deviceType: [{
               '_type': 'com.vmware.vim.binding.vim.host.GraphicsConfig$DeviceType',
               deviceId: selectedItem.pciId,
               graphicsType: self.sharedMode
            }]
         };


         mutationService.apply(
               hostId,
               'com.vmware.vim.binding.vim.host.GraphicsConfig',
               hostGraphicsConfigSpec
         );

         if(self.xorgServiceRestart){
            mutationService.apply(
               hostId,
               'com.vmware.vsphere.client.host.config.ServiceActionSpec',
               {
                  action : hostServicesConstants.action.RESTART,
                  serviceKey: "xorg"
               }
            );
         }

         $scope.closeModal();
      };
   }
})();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('editHostGraphicsSettingsController', EditHostGraphicsSettingsController);

   EditHostGraphicsSettingsController.$inject = [
      '$scope',
      'mutationService',
      'dataService',
      'i18nService'
   ];

   function EditHostGraphicsSettingsController($scope, mutationService, dataService, i18nService) {
      var hostId = $scope._route.objectId;

      dataService.getData(
            hostId,
            'com.vmware.vsphere.client.h5.host.model.GraphicsData')
            .then(function(data) {
               if (data) {
                  this.defaultGraphicsType = data.defaultGraphicsType;
                  this.sharedPassthruAssignmentPolicy = data.sharedPassthruAssignmentPolicy;
               }
            }.bind(this));

      $scope.modalOptions.onSubmit = function() {
         var operationName =
               i18nService.getString(
                     'HostUi',
                     'settings.graphics.hostConfigView.update.operationName');

         mutationService.apply(
               hostId,
               'com.vmware.vim.binding.vim.host.GraphicsConfig',
               {
                  '_type': 'com.vmware.vim.binding.vim.host.GraphicsConfig',
                  hostDefaultGraphicsType: this.defaultGraphicsType,
                  sharedPassthruAssignmentPolicy: this.sharedPassthruAssignmentPolicy
               },
               operationName
         );
         $scope.closeModal();
      }.bind(this);
   }
})();



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('hostGraphicsController', HostGraphicsController);

   HostGraphicsController.$inject = [
      '$scope',
      'dataService',
      'hostGraphicsService'];

   function HostGraphicsController(
         $scope,
         dataService,
         service) {
      var self = this;
      self.hostId = $scope._route.objectId;
      self.watchForObjects = [self.hostId];
      self.headerOptions = service.getHostSettingsHeaderOptions(self.hostId);
      self.getData = getData;
      self.liveRefreshProperties = ['config.graphicsConfig.hostDefaultGraphicsType',
         'config.graphicsConfig.sharedPassthruAssignmentPolicy', 'config.graphicsInfo'];

      getData();

      function getData() {
         dataService
               .getData(
                     self.hostId,
                     'com.vmware.vsphere.client.h5.host.model.GraphicsData')
               .then(function(data) {
                  if (data) {
                     self.typeLabel = service.getTypeLabel(data.defaultGraphicsType);
                     self.policyLabel = service.getPolicyLabel(data.sharedPassthruAssignmentPolicy);
                     self.isHostSettingsEnabled = data.isHostSettingsEnabled;
                  }
               });
      }
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('hostGraphicsDevicesController', HostGraphicsDevicesController);

   HostGraphicsDevicesController.$inject = ['$scope', 'i18nService', 'dataService', 'hostGraphicsService', 'clarityModalService'];

   function HostGraphicsDevicesController($scope, i18nService, dataService, hostGraphicsService, clarityModalService) {
      var self = this;

      self.hostId = $scope._route.objectId;
      $scope.dataGridGraphicsOptions = hostGraphicsService.getGridGraphicsOptions(
         openEditDeviceSettings);
      $scope.dataGridVmOptions = hostGraphicsService.getGridVmsOptions();
      self.headerOptions = {
         title: i18nService.getString('HostUi', 'settings.graphics.devicesView.title')
      };
      self.watchForObjects = [self.hostId];
      self.liveRefreshProperties = ['config.graphicsConfig.deviceType', 'config.graphicsInfo'];
      self.loadGraphicsSettingsData = function() {

         dataService.getData(
            self.hostId,
            'com.vmware.vsphere.client.h5.host.model.GraphicsData')
            .then(function(data) {
               if (data && data.graphicsInformation) {
                  $scope.defaultGraphicsType = data.defaultGraphicsType;
                  $scope.sharedPassthruAssignmentPolicy = data.sharedPassthruAssignmentPolicy;
                  $scope.dataGridGraphicsOptions.data = data.graphicsInformation;
                  if (data.isHostSettingsEnabled) {
                     $scope.dataGridGraphicsOptions.actionBarOptions.actions[0].enabled = true;
                  }
               }
         });
      };
      $scope.$watch('dataGridGraphicsOptions.selectedItems',
         function(newItems, oldItems) {
            if (newItems && newItems !== oldItems) {
               hostGraphicsService.getVmInfoAndUpdateGridData(newItems, setGridData);
               if (newItems[0]) {
                  $scope.titleOfGraphicCard = i18nService.getString(
                     'HostUi',
                     'settings.graphics.vmsView.title',
                     newItems[0].deviceName);
            }
            }
         });
      function openEditDeviceSettings() {
         var modalOptions = {
            title: i18nService.getString('HostUi',
               'settings.graphics.editDevicesConfigForm.title'),
            subTitle : {
               text: $scope.dataGridGraphicsOptions.selectedItems[0].pciId
            },
            contentTemplate: 'host-ui/resources/host/views/settings/graphics/editGraphicDeviceView.html',
            defaultButton: 'submit',
            dialogData: {
               selectedItem: $scope.dataGridGraphicsOptions.selectedItems[0],
               defaultGraphicsType : $scope.defaultGraphicsType,
               sharedPassthruAssignmentPolicy: $scope.sharedPassthruAssignmentPolicy,
               objectId: self.hostId
            }
         };
         clarityModalService.openOkCancelModal(modalOptions);
      }
      function setGridData(data) {
         $scope.dataGridVmOptions.data = data;
      }
      self.loadGraphicsSettingsData();
   }
})();

(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.host')
         .service("hostGraphicsService", hostGraphicsService);

   hostGraphicsService.$inject = [
      'i18nService',
      'bytesFormatter',
      'vuiConstants',
      'defaultUriSchemeUtil',
      'dataService',
      'columnRenderersRegistry'];

   function hostGraphicsService(i18nService,
                                bytesFormatter,
                                vuiConstants,
                                defaultUriSchemeUtil,
                                dataService,
                                columnRenderersRegistry) {
      return {
         getTypeLabel: getTypeLabel,
         getPolicyLabel: getPolicyLabel,
         getGridGraphicsOptions: getGridGraphicsOptions,
         getVmInfoAndUpdateGridData: getVmInfoAndUpdateGridData,
         getGridVmsOptions: getGridVmsOptions,
         getHostSettingsHeaderOptions: getHostSettingsHeaderOptions
      };

      function getTypeLabel(typeKey) {
         var typeLabel;
         switch (typeKey) {
            case 'shared':
               typeLabel = i18nService.getString('HostUi',
                  'settings.graphics.type.default.shared');
               break;
            case 'sharedDirect':
               typeLabel = i18nService.getString('HostUi',
                  'settings.graphics.type.default.sharedDirect');
               break;
            default:
               typeLabel = "";
               break;
         }
         return typeLabel;
      }

      function getPolicyLabel(policyKey) {
         var policyLabel;
         switch (policyKey) {
            case 'performance':
               policyLabel = i18nService.getString('HostUi',
                  'settings.graphics.hostConfigView.performancePolicy');
               break;
            case 'consolidation':
               policyLabel = i18nService.getString('HostUi',
                  'settings.graphics.hostConfigView.consolidationPolicy');
               break;
            default:
               policyLabel = "";
               break;
         }
         return policyLabel;
      }

      function getTypeMessage(type) {
         var messages = {
            "basic": i18nService.getString('HostUi',
               'settings.graphics.type.default.basic'),
            "shared": i18nService.getString('HostUi',
               'settings.graphics.type.default.shared'),
            "sharedDirect": i18nService.getString('HostUi',
               'settings.graphics.type.default.sharedDirect'),
            "direct": i18nService.getString('HostUi',
               'settings.graphics.type.default.direct')
         };
         return messages[type];
      }

      function getColumnGraphicsDefs() {
         return [
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.nameColumn'),
               field: 'deviceName',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('HostUi',
                  'vmdpConfig.deviceId.label'),
               field: 'pciId',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.vendorColumn'),
               field: 'vendor',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.activeTypeColumn'),
               field: 'defaultType',
               type: 'string',
               editable: false,
               template: function(data) {
                  return getTypeMessage(data.defaultType);
               }
            },
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.configuredTypeColumn'),
               field: 'configuredType',
               type: 'string',
               editable: false,
               template: function(data) {
                  if (data.configuredType && data.configuredType !== '') {
                     return getTypeMessage(data.configuredType);
                  } else {
                     return i18nService.getString('HostUi', 'settings.graphics.type.na');
                  }
               }
            },
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.memoryColumn'),
               field: 'memory',
               type: 'string',
               editable: false,
               template: function(data) {
                  return bytesFormatter.bytesFormat(data.memory);
               }
            }
         ];
      }

      function getColumnVmsDefs() {
         return [
            {
               displayName: i18nService.getString('HostUi',
                  'settings.graphics.devicesView.nameColumn'),
               field: 'name',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('HostUi',
                  'stateHeaderText'),
               field: 'powerState',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('HostUi',
                  'statusHeaderText'),
               field: 'overallStatus',
               type: 'string',
               editable: false,
               template: iconTextRenderer
            },
            {
               displayName: i18nService.getString('VmUi',
                  'provisionedSpaceHeaderText'),
               field: 'usedSpace',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('VmUi',
                  'usedSpaceHeaderText'),
               field: 'provisionedSpace',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('VmUi',
                  'hostCPUHeaderText'),
               field: 'overallCpuUsage',
               type: 'string',
               editable: false
            },
            {
               displayName: i18nService.getString('VmUi',
                  'hostMemHeaderText'),
               field: 'hostMemoryUsage',
               type: 'string',
               editable: false
            }
         ];
      }

      function iconTextRenderer(data) {
         var renderer = columnRenderersRegistry.getColumnRenderer('icon-text');
         var iconTextParameter = getIconAndLabel(data.overallStatus);
         var renderedColumnValue = renderer(['icon', 'text'], iconTextParameter);
         return renderedColumnValue;
      }

      function getGridGraphicsOptions(callback) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getColumnGraphicsDefs(),
            actionBarOptions: {
               actions: [getEditGraphicDeviceAction(callback)]
            },
            height: 'calc(100% - 12px)'
         };
      }

      function getVmInfoAndUpdateGridData(selectedVms, callback) {
         var selectedVm = selectedVms[0];
         if (selectedVm && selectedVm.vms && selectedVm.vms[0]) {
            var vmObjects = [];
            var vmDetailsInfo = [];
            _.each(selectedVm.vms, function(vm) {
               vmObjects.push(defaultUriSchemeUtil.getVsphereObjectId(vm));
            });

            dataService.getPropertiesForObjects(
               vmObjects,
               [
                  'parent',
                  'name',
                  'runtime.powerState',
                  'overallStatus',
                  'summary.storage.committed',
                  'summary.storage.uncommitted',
                  'summary.quickStats.overallCpuUsage',
                  'summary.quickStats.hostMemoryUsage',
                  'storage.perDatastoreUsage'
               ]).then(function(data) {
               _.each(vmObjects, function(vm) {
                  vmDetailsInfo.push(data[vm]);
               });
               callback(portVmInfo(vmDetailsInfo));
            });

         } else {
            callback([]);
         }
      }

      function portVmInfo(vms) {
         var objectToReturn = [];
         _.each(vms, function(vm) {
            objectToReturn.push({
               name: vm.name,
               powerState: i18nService.getString('Common', 'powerState.' + vm['runtime.powerState']),
               overallStatus: vm.overallStatus,
               usedSpace: bytesFormatter.bytesFormat(getVmCommittedSpace(vm)),
               provisionedSpace: bytesFormatter.bytesFormat(getTotalProvisionedSpace(vm)),
               overallCpuUsage: vm['summary.quickStats.overallCpuUsage'] + " " +
               i18nService.getString('CommonUi', 'megaHertz.label'),
               hostMemoryUsage: vm['summary.quickStats.hostMemoryUsage'] + " " +
               i18nService.getString('CommonUi', 'megaByte.label')
            });
         });
         return objectToReturn;
      }

      function getVmCommittedSpace(vm){
         var datastoreType = 'Datastore';
         if(vm.parent.type === datastoreType && vm['storage.perDatastoreUsage'] !== null){
            var virtualMachineUsageOnDatastore = vm['storage.perDatastoreUsage'];
            var dsUsage = _.find(virtualMachineUsageOnDatastore, function(item) {
               return item.datastore === vm.parent;
            });

            return dsUsage.committed;
         }
         return vm['summary.storage.committed'];
      }

      function getVmUncommittedSpace(vm) {
         var datastoreType = 'Datastore';
         if(vm.parent.type === datastoreType && vm['storage.perDatastoreUsage'] !== null){
            var virtualMachineUsageOnDatastore = vm['storage.perDatastoreUsage'];
            var dsUsage = _.find(virtualMachineUsageOnDatastore, function(item) {
               return item.datastore === vm.parent;
            });

            return dsUsage.uncommitted;
         }
         return vm['summary.storage.uncommitted'];
      }

      function getTotalProvisionedSpace(vm) {
         return getVmCommittedSpace(vm) + getVmUncommittedSpace(vm);
      }


      function getIconAndLabel(status) {
         var iconClass, label;
         switch (status) {
            case 'green':
               iconClass = 'vsphere-icon-status-ok';
               label = getLabelTextForStatus(status);
               break;
            case 'yellow':
               iconClass = 'vsphere-icon-status-warning';
               label = getLabelTextForStatus(status);
               break;
            case 'red':
               iconClass = 'vsphere-icon-status-error';
               label = getLabelTextForStatus(status);
               break;
            case 'grey':
               iconClass = 'vsphere-icon-status-unknown';
               label = getLabelTextForStatus(status);
               break;
            default:
               iconClass = 'vsphere-icon-status-unknown';
               label = getLabelTextForStatus(status);
               break;
         }

         var iconAndText = {
            icon: iconClass,
            text: label
         };

         return iconAndText;
      }

      function getLabelTextForStatus(status) {
         var labelText = "";
         if (status) {
            var propertyKey = "entityStatus." + status;
            labelText = i18nService.getString('Common', propertyKey);
         }

         return labelText;
      }

      function getGridVmsOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getColumnVmsDefs(),
            height: 'calc(100% - 10px)'
         };
      }

      function getEditGraphicDeviceAction(callback) {
         return {
            actionId: 'editGraphicDevice',
               tooltipText: i18nService.getString('HostUi',
            'settings.graphics.devicesView.button.edit.tooltip'),
            iconClass: 'vx-icon-edit16x16',
            enabled: false,
            onClick: callback
         };
      }

      function getHostSettingsHeaderOptions(hostId) {
         return {
            title: i18nService.getString('HostUi', 'settings.graphics.editHostConfigForm.title'),
            objectId: hostId,
            actions: [{
               actionUid: 'vsphere.core.host.actions.editHostGraphics',
               customLabel: i18nService.getString('HostUi', 'settings.graphics.hostConfigView.edit.label')
            }]
         };
      }
   }
}());

(function() {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.host')
         .controller(
               'hostGraphicsTabsController',
               HostGraphicsTabsController);

   HostGraphicsTabsController.$inject = ['$scope', 'dataService'];

   function HostGraphicsTabsController($scope, dataService) {
      var self = this;
      self.hostId = $scope._route.objectId;
      self.getData = getData;
      getData();

      function getData() {
         dataService
               .getData(
                     self.hostId,
                     'com.vmware.vsphere.client.h5.host.model.GraphicsData')
               .then(function(data) {
                  if (data) {
                     self.isHostSettingsEnabled = data.isHostSettingsEnabled;
                  }
               });
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Factory that contains the settings views header options to be used with vx-settings-block-header directive
 * and settings views option to be used with vx-gridview-settings or vx-stackview-settings directive for each host data-driven settings
 * extension id.
 */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').factory('HostDataDrivenSettingsConfigFactory', HostDataDrivenSettingsConfigFactory);

   var i18n, timeService, qService;
   HostDataDrivenSettingsConfigFactory.$inject = ['i18nService', 'timeFormatterService', '$q'];

   function HostDataDrivenSettingsConfigFactory(i18nService, timeFormatterService, $q) {
      i18n = i18nService;
      timeService = timeFormatterService;
      qService = $q;
      return {
         'vsphere.core.host.manage.settings.agentVmSettingsView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'settings.agentVm.title'),
               actions: [{ actionUid:'vsphere.core.host.actions.editAgentVmSettings',
                           customLabel: i18nService.getString('HostUi', 'settings.edit')
                        }]
            },
            settingsViewOptions: {
               propertyName: 'agentVmSettings',
               liveRefreshProperties: [
                     'summary.config.agentVmNetwork',
                     'summary.config.agentVmDatastore',
                     'config.fileSystemVolume.mountInfo'
               ]
            }
         },
         'vsphere.core.host.manage.settings.memoryConfigView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'settings.memoryConfig.title'),
               actions: []
            },
            settingsViewOptions: {
               propertyName: 'memoryConfig',
               liveRefreshEnabled: false
            }
         },
         'vsphere.core.host.manage.settings.powerConfigHardwareView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'settings.powerConfigHardware.title'),
               actions: [{ actionUid:'vsphere.core.host.actions.editPowerConfigHardware',
                           customLabel: i18nService.getString('HostUi', 'settings.edit')
                        }]
            },
            settingsViewOptions: {
               propertyName: 'powerConfigHardware',
               delayRefreshTimeInMsecsOnObjectUpdate: 1000,
               liveRefreshProperties: [
                  'config.powerSystemInfo.currentPolicy.name',
                  'hardware.cpuPowerManagementInfo.currentPolicy',
                  'config.powerSystemInfo.currentPolicy.description',
                  'config.powerSystemInfo.currentPolicy.shortName',
                  'config.powerSystemInfo.currentPolicy.key'
               ]
            }
         },
         'vsphere.core.host.manage.settings.powerConfigSoftwareView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'powerConfigSoftware.powerManagementSettings'),
               actions: [{ actionUid:'vsphere.core.host.actions.editPowerConfigSoftware',
                           customLabel: i18nService.getString('HostUi', 'settings.edit')
               }]
            },
            settingsViewOptions: {
               propertyName: 'powerConfigSoftware',
               liveRefreshProperties: [
                  'config.ipmi.bmcMacAddress',
                  'config.ipmi.bmcIpAddress',
                  'config.ipmi.login'
               ]
            }
         },
         'vsphere.core.host.manage.settings.certificateView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'settings.certificate.title'),
               actions: [{ actionUid:'vsphere.core.host.actions.refreshCertificate',
                           customLabel: i18nService.getString('HostUi',
                                 'settings.certificate.refresh.label')
               }, { actionUid:'vsphere.core.host.actions.refreshCaCertificate',
                     customLabel: i18nService.getString('HostUi',
                           'settings.certificate.refreshCA.label')
               }]
            },
            settingsViewOptions: {
               propertyName: 'certificateConfig',
               supportedKey: 'isCertificateManagerSupported',
               unsupportedMessage: i18nService.getString('HostUi', 'certificate.unsupported.msg'),
               liveRefreshProperties: [
                  "config.certificate"
               ],
               formatValueCallback: formatCertificateValue

            }
         },
         'vsphere.core.host.manage.settings.advancedSystemSettingsView': {
            headerOptions: {
               title: i18nService.getString('HostUi', 'advancedSettings.view.title'),
               actions: [{ actionUid:'vsphere.core.host.actions.editAdvancedSystemSettings',
                  customLabel: i18nService.getString('HostUi', 'settings.edit')
               }]
            },
            settingsViewOptions: {
               type: 'grid',
               propertyName: 'advancedSettings',
               liveRefreshProperties: [
                  "config.option"
               ]
            }
         }
      };
   }

   /**
    * Property value format function - in some cases the property value is not a string and it requires some custom
    * formatting.
    * @param propName
    *    Name of the property.
    * @param contentValue
    *    Raw value of the property - might be a string or an object.
    */
   function formatCertificateValue(propName, contentValue) {
      if (propName === 'certificateStatus') {
         return qService.when(formatCertificateStatusValue(contentValue));
      }

      if (propName === 'certificateValidFrom' ||
            propName === 'certificateValidTo') {
         return qService.when(contentValue);
      }

      // for all the properties that there is no need for custom formatting - just return the raw content value
      return qService.when(contentValue);
   }

   function formatCertificateStatusValue(statusKey) {
      var nonNullStatusKey = statusKey || 'unknown';
      return i18n.getString('HostUi', 'certificate.status.' + nonNullStatusKey);
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('EditServiceStartupPolicyController', EditServiceStartupPolicyController);

   EditServiceStartupPolicyController.$inject = ['$scope', 'mutationService',
      'hostServicesConstants', 'i18nService'];

   function EditServiceStartupPolicyController($scope, mutationService,
         hostServicesConstants, i18nService) {
      var objectId = $scope.modalOptions.dialogData.model.hostId;
      var serviceKeyId = $scope.modalOptions.dialogData.model.service.key;

      $scope.policy = hostServicesConstants.policy;
      $scope.selectedPolicy = $scope.modalOptions.dialogData.model.service.policy;

      $scope.modalOptions.onSubmit = function() {
         mutationService.apply(objectId,
               'com.vmware.vsphere.client.host.config.ServicePolicySpec',
               {policy:$scope.selectedPolicy, serviceKey:serviceKeyId});
         return true;
      };

      $scope.popupParams = {
         title: i18nService.getString('HostUi','policy.auto.label'),
         message: i18nService.getString('HostUi','policy.auto.desc')
      };
   }
})();

(function() {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:hostServiceStatus
    *
    * @description
    *    Represents vim.host.Service.Policy enum values.
    *
    *    List of available constants
    *
    *    - **`ON`** : Service should be started when the host starts up.
    *    - **`OFF`** : Service should not be started when the host starts up.
    *    - **`AUTOMATIC`** : Service should run if and only if it has open firewall ports.
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('hostServicesConstants', {
            status: {
               RUNNING: 'true',
               STOPPED: 'false'
            },
            action: {
               START: 'start',
               STOP: 'stop',
               RESTART: 'restart',
               EDIT: 'edit'
            },
            policy:{
               ON: 'on',
               OFF: 'off',
               AUTOMATIC: 'automatic'
            },
            NO_PRIVILEGE: 'No privilege'
         });
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('HostServicesController', HostServicesController);

   HostServicesController.$inject = ['$scope', 'dataService', 'hostServicesService',
      'authorizationService'];

   function HostServicesController($scope,
         dataService,
         hostServicesService,
         authorizationService) {

      var objectId = $scope._route.objectId;
      var hasPrivileges = true;
      var selectedItemKey = '';
      var self = this;

      self.headerOptions = hostServicesService.getViewHeaderOptions(objectId);
      self.datagridOptions = hostServicesService.getDatagridOptions(
            serviceCommandCallback);
      self.updateViewData = updateViewData;
      self.showMenu = hostServicesService.showServiceActionContextMenu;
      self.watchForObjects = [objectId];
      self.isHostConnected = false;
      self.liveRefreshProperties = ['config.service.service'];
      $scope.preselectComparator = function(gridDataItem) {
         return selectedItemKey && selectedItemKey === gridDataItem.key;
      };

      updateViewData();
      initializeSelectionChangeEventWatch();

      function updateViewData() {
         checkPrivileges();
         updateListData();
      }

      function checkPrivileges() {
         authorizationService.checkPrivileges(objectId, ['Host.Config.NetService'])
               .then(function(privilegesStatuses) {
                        hasPrivileges = privilegesStatuses[0];
                        updateServiceActionButtonStatus();
                     }
               );
      }

      function updateListData() {
         selectedItemKey = getSelectedItemKey();
         dataService.getProperties(objectId, ['config.service', 'runtime.connectionState']).then(function(data) {
            if (data && data['config.service']) {
               self.datagridOptions.data = data['config.service'].service || [];
            }

            if (data && data['runtime.connectionState']) {
               self.isHostConnected = data['runtime.connectionState'] === "connected";
            }

         });
      }

      function initializeSelectionChangeEventWatch() {
         $scope.$watchCollection(function() {
            return self.datagridOptions.selectedItems;
         }, onSelectedItemChanged);
      }

      function getSelectedItemRunningStatus() {
         var selectedItem = getSelectedGridItem();
         return selectedItem.running;
      }

      function getSelectedItemKey() {
         var selectedItem = getSelectedGridItem();
         return selectedItem.key;
      }

      function getSelectedGridItem() {
         var selectedGridItem;
         if (!_.isEmpty(self.datagridOptions.selectedItems)) {
            selectedGridItem = self.datagridOptions.selectedItems[0];
         } else {
            selectedGridItem = '';
         }
         return selectedGridItem;
      }

      function updateServiceActionButtonStatus() {
         var serviceStatus = getSelectedItemRunningStatus();
         self.datagridOptions.actionBarOptions.updateActionBar(serviceStatus,
               hasPrivileges, self.isHostConnected);
      }

      function onSelectedItemChanged() {
         updateServiceActionButtonStatus();
      }

      function serviceCommandCallback(actionId) {
         var currentlySelectedItem = self.datagridOptions.selectedItems[0];
         var itemKey = currentlySelectedItem.key;
         var itemLabel = currentlySelectedItem.label;
         var itemPolicy = currentlySelectedItem.policy;
         var item = { key: itemKey, label: itemLabel, policy: itemPolicy };
         hostServicesService.confirmAndExecuteServiceCommand(objectId, actionId, item);
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('hostServicesService',
         HostServicesService);

   HostServicesService.$inject = ['hostServicesConstants', 'i18nService', 'logService',
      'mutationService', 'vuiActionsMenuService', '$rootScope', 'vuiConstants',
      'actionConfirmationService', 'actionsService', 'clarityModalService'];

   function HostServicesService(hostServicesConstants, i18Service, logService,
         mutationService, vuiActionsMenuService, $rootScope,
         vuiConstants, actionConfirmationService, actionsService, clarityModalService) {

      var EDIT_SERVICE_STARTUP_POLICY =
            'vsphere.core.host.actions.service.editStartupPolicy';
      var log = logService('HostServicesService');

      var startButton = {
         id: hostServicesConstants.action.START,
         tooltipText: getString('service.start.action.description'),
         label: getString('service.start.action.label'),
         enabled: false,
         iconClass: 'vx-icon-serviceStart'
      };
      var stopButton = {
         id: hostServicesConstants.action.STOP,
         tooltipText: getString('service.stop.action.description'),
         label: getString('service.stop.action.label'),
         enabled: false,
         iconClass: 'vx-icon-serviceStop'
      };
      var restartButton = {
         id: hostServicesConstants.action.RESTART,
         tooltipText: getString('service.restart.action.description'),
         label: getString('service.restart.action.label'),
         enabled: false,
         iconClass: 'vx-icon-serviceRestart'
      };

      var editButton = {
         id: hostServicesConstants.action.EDIT,
         tooltipText: getString('service.edit.action.description'),
         label: getString('service.edit.action.label'),
         enabled: false,
         iconClass: 'vx-icon-serviceEdit'
      };

      function updateButtonStatus(serviceStatus) {
         switch (serviceStatus) {
            case hostServicesConstants.status.RUNNING:
               startButton.enabled = false;
               stopButton.enabled = true;
               restartButton.enabled = true;
               editButton.enabled = true;
               break;
            case hostServicesConstants.status.STOPPED:
               startButton.enabled = true;
               stopButton.enabled = false;
               restartButton.enabled = false;
               editButton.enabled = true;
               break;
			default:
               startButton.enabled = false;
               stopButton.enabled = false;
               restartButton.enabled = false;
               editButton.enabled = false;
			   break;
         }
      }

      function updateActionBar(serviceStatus, hasPrivileges, hostConnected) {
         if (hostConnected && hasPrivileges) {
            updateButtonStatus(serviceStatus);
         } else {
            updateButtonStatus(hostServicesConstants.NO_PRIVILEGE);
         }
      }

      function getString(key, parameters) {
         return i18Service.getString('HostUi', key, parameters);
      }

      function createActionBar(callback) {
         startButton.onClick = function() {
            callback(hostServicesConstants.action.START);
         };

         stopButton.onClick = function() {
            callback(hostServicesConstants.action.STOP);
         };

         restartButton.onClick = function() {
            callback(hostServicesConstants.action.RESTART);
         };

         editButton.onClick = function() {
            callback(hostServicesConstants.action.EDIT);
         };
         return {
            actions: [
               restartButton, startButton, stopButton,
               vuiConstants.actions.SEPARATOR, editButton
            ],
            updateActionBar: updateActionBar
         };
      }

      function confirmAndExecuteServiceCommand(hostId, actionId, service) {
         function executeCommand() {
            executeServiceCommand(hostId, actionId, service.key);
         }
         var modalOptions = {};
         switch (actionId) {
            case hostServicesConstants.action.RESTART:
               modalOptions = {
                   title :getString('service.restart.confirmation.title'),
                   message :getString('service.restart.confirmation.text', service.label),
                   submit : executeCommand
               };
               clarityModalService.openConfirmationModal(modalOptions);
               break;
            case hostServicesConstants.action.START:
               executeCommand();
               break;
            case hostServicesConstants.action.STOP:
               modalOptions = {
                  title :getString('service.stop.confirmation.title'),
                  message :getString('service.stop.confirmation.text', service.label),
                  submit : executeCommand
               };
               clarityModalService.openConfirmationModal(modalOptions);
               break;
            case hostServicesConstants.action.EDIT:
               //TODO move the action in plugin xml
               actionsService.invokeAction({
                  available: true,
                  invoker: [EDIT_SERVICE_STARTUP_POLICY],
                  action: {
                    uid:EDIT_SERVICE_STARTUP_POLICY
                  }
               }, { hostId: hostId,
                   service: service});
               break;
			default:
               break;
         }
      }

      function executeServiceCommand(hostId, actionId, serviceKey) {
         var specType = 'com.vmware.vsphere.client.host.config.ServiceActionSpec';
         var spec = {
            action: actionId,
            serviceKey: serviceKey
         };

         return mutationService.apply(hostId, specType, spec);
      }

      function getColumnDefs() {
         return [
            {
               displayName: getString('services.col.name'),
               field: 'label'
            },
            {
               displayName: getString('services.col.daemon'),
               field: 'running',
               template: function(dataItem) {
                  if (dataItem.running === "true") {
                     return getString('daemon.running');
                  } else {
                     return getString('daemon.stopped');
                  }
               }
            },
            {
               displayName: getString('services.col.startupPolicy'),
               field: 'policy',
               template: function(dataItem) {
                  return getPolicyText(dataItem.policy);
               }
            }
         ];
      }

      function getViewHeaderOptions(objectId) {
         return {
            title: getString('settings.service'),
            objectId: objectId,
            actions: [{
               actionUid: 'vsphere.core.host.actions.refreshServicesAction',
               customLabel: getString('refresh.services.button.label')
            }]
         };
      }

      function getPolicyText(policy) {
         var policyText;
         switch (policy) {
            case hostServicesConstants.policy.ON:
               policyText = getString('policy.on.label');
               break;
            case hostServicesConstants.policy.OFF:
               policyText = getString('policy.off.label');
               break;
            case hostServicesConstants.policy.AUTOMATIC:
               policyText = getString('policy.auto.label');
               break;
            default:
               log.error("Unexpected startup policy: " + policy);
               policyText = getString('policy.na.label');
         }
         return policyText;
      }

      function showServiceActionContextMenu(event) {
         var menuTitle = '';
         if (event && !_.isEmpty(event.data) && event.data[0]) {
            menuTitle = getString('service.menu.label', event.data[0].label);
         }
         var localScope = $rootScope.$new();
         localScope.hostServicesMenuDescriptor = {
            label: menuTitle,
            iconClass: '',
            items: [
               restartButton, startButton, stopButton,
               vuiConstants.actions.SEPARATOR, editButton
            ]
         };

         var target = event.currentTarget;
         if (!target && event) {
            target = event.target;
         }

         var menuOptions = {
            scope: localScope,
            configObjectName: 'hostServicesMenuDescriptor',
            target: target,
            coordinates: { x: event.clientX, y: event.clientY },
            menuContainerId: 'applicationMenuContainer'
         };

         vuiActionsMenuService.showMenu(menuOptions);
      }


      function getDatagridOptions(serviceActionBarCallback) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            searchable: false,
            resizable: false,
            selectedItems: [],
            actionBarOptions: createActionBar(serviceActionBarCallback),
            data: [],
            columnDefs: getColumnDefs(),
            height: '100%',
            pageConfig: {
               hidePager: true
            }
         };
      }

      return {
         confirmAndExecuteServiceCommand: confirmAndExecuteServiceCommand,
         getColumnDefs: getColumnDefs,
         showServiceActionContextMenu: showServiceActionContextMenu,
         getDatagridOptions: getDatagridOptions,
         getViewHeaderOptions: getViewHeaderOptions
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('HostSettingsDataDrivenController', HostSettingsDataDrivenController);

   HostSettingsDataDrivenController.$inject = ['$scope', 'HostDataDrivenSettingsConfigFactory'];

   function HostSettingsDataDrivenController($scope, HostDataDrivenSettingsConfigFactory) {
      var self = this;

      var extensionId = $scope._route.extensionId;
      var headerOptions = HostDataDrivenSettingsConfigFactory[extensionId].headerOptions;
      var settingsViewOptions = HostDataDrivenSettingsConfigFactory[extensionId].settingsViewOptions;

      var objectId = $scope._route.objectId;
      headerOptions.objectIds = [objectId];
      settingsViewOptions.objectId = objectId;
      settingsViewOptions.setSelectedAdvancedOption = true;
      if(!angular.isDefined(settingsViewOptions.type)) {
         // Default view is stack view.
         settingsViewOptions.type = 'stack';
      }
      self.headerOptions = headerOptions;
      self.settingsViewOptions = settingsViewOptions;
   }
})();

(function () {
    'use strict';
    angular
        .module('com.vmware.vsphere.client.host')
        .controller('MaintenanceModeConfirmationController',
            MaintenanceModeConfirmationController);

    MaintenanceModeConfirmationController.$inject = [
        '$scope',
        'maintenanceModeConfirmationService',
        'maintenanceModeConstants',
        'i18nService'];

    function MaintenanceModeConfirmationController(scope,
                                                   mmcService,
                                                   mmConstants,
                                                   i18nService) {

        var self = this;
        self.loading = true;
        self.shouldMigrateVms = true;
        scope.modalOptions.onSubmit = onOkClicked;
        var targets = scope.modalOptions.dialogData.availableTargets;
        self.hostId = targets[0];
        self.precheckUnsupportedImage = "";
        self.precheckUnsupportedText = "";

        // Pre-check is not supported for multiple hosts.
        self.multipleHostsSelected = targets.length > 1;
        if (self.multipleHostsSelected) {
            self.precheckUnsupportedImage = "vsphere-icon-status-warning";
            self.precheckUnsupportedText = i18nService.getString(
                'HostUi',
                'ConfirmMaintenanceForm.vsanEvacuation.precheck.unsupported'
            );
        }

        mmcService.retrieveVsanData(targets, onVsanDataRetrieved);

        function onVsanDataRetrieved(result) {
            var hostCount = result.hostCount;
            var drsEnabled = result.drsEnabled;
            self.hostName = result.hostName;
            self.clusterMor = result.clusterMor;
            self.showMigrationConfirmation = !!(hostCount && drsEnabled);
            self.isVsanSupportedAndEnabled = !!result.isVsanSupportedAndEnabled;
            // resize the dialog due to large dialog content
            if (self.isVsanSupportedAndEnabled) {
               scope.modalOptions.size = 'lg';
            }

            self.loading = false;
        }

        self.onVsanSelectedDecommisionModeChanged = function(event) {
            self.vSanEvacuationType = event;
        };

        function onOkClicked() {
            return mmcService.onOKClicked(
                targets,
                self.isVsanSupportedAndEnabled,
                self.shouldMigrateVms,
                self.showMigrationConfirmation,
                self.vSanEvacuationType ? self.vSanEvacuationType : mmcService.getDefaultEvacuationType());
        }
    }
})();

angular
   .module('com.vmware.vsphere.client.host')
   .service('maintenanceModeConfirmationService',
      [
         'maintenanceModeConstants',
         'i18nService',
         'mutationService',
         'dataService',
         'clarityModalService',
         function(maintenanceModeConstants,
                  i18nService,
                  mutationService,
                  dataService,
                  clarityModalService) {

            var getString = _.partial(i18nService.getString, 'HostUi');

            return {
               retrieveVsanData: retrieveVsanData,
               onOKClicked: onOKClicked,
               getDefaultEvacuationType: getDefaultEvacuationType
            };

            function retrieveVsanData(targets, onVsanDataRetrieved) {
               dataService
                  .getData(
                     targets[0],
                     'com.vmware.vsphere.client.h5.host.model.HostMaintenanceModeData')
                  .then(function(result) {
                     if (result) {
                        onVsanDataRetrieved(result);
                     }
                  });
            }

            function getDefaultEvacuationType() {
               return maintenanceModeConstants.ENSURE_OBJECT_ACCESSIBILITY;
            }

            function onOKClicked(targets,
                                 isVsanSupportedAndEnabled,
                                 shouldMigrateVms,
                                 showMigrationConfirmation,
                                 vSanEvacuationType) {
               var evacuatePoweredOffVms = shouldMigrateVms && showMigrationConfirmation;
               var hostMaintenanceModeSpec = createMaintenanceModeSpec(
                  isVsanSupportedAndEnabled,
                  evacuatePoweredOffVms,
                  vSanEvacuationType);

               mutationService.applyOnMultiEntity(
                  targets,
                  'com.vmware.vsphere.client.host.maintenance.HostMaintenanceSpec',
                  hostMaintenanceModeSpec);

               dataService
                  .getProperties(
                     targets[0],
                     ['name', 'poweredOnVMs._length'])
                  .then(
                     function(hostProperties) {
                        if (hostProperties['poweredOnVMs._length'] > 0) {
                           var modalOptions = {
                              title: i18nService.getString('Common',
                                 'issueStatus.warning'),
                              subTitle: {
                                 objectId: targets[0]
                              },
                              hideCancelButton: true,
                              message: getString(
                                 'actionEnterMaintenanceVMsPoweredOn',
                                 hostProperties.name),
                              icon: 'icon-warning-32',
                              submit: function() {
                                 return true;
                              },
                              preserveNewlines: true
                           };
                           clarityModalService.openConfirmationModal(modalOptions);
                        }
                     });

               return true;
            }

            function createMaintenanceModeSpec(isVsanSupportedAndEnabled,
                                               shouldEvacuatePoweredOffVms,
                                               evacuationType) {

               var hostMaintenanceModeSpec = {
                  maintenanceOpType: 'enter',
                  evacuatePoweredOffVms: shouldEvacuatePoweredOffVms
               };

               if (isVsanSupportedAndEnabled) {
                  hostMaintenanceModeSpec.maintenanceSpec = {
                     _type: "com.vmware.vim.binding.vim.host.MaintenanceSpec",
                     vsanMode: {
                        _type: "com.vmware.vim.binding.vim.vsan.host.DecommissionMode",
                        objectAction: evacuationType
                     }
                  };
               }

               return hostMaintenanceModeSpec;
            }
         }]);

angular.module('com.vmware.vsphere.client.host')
   .constant("maintenanceModeConstants", {
      EVACUATE_ALL_DATA: "evacuateAllData",
      ENSURE_OBJECT_ACCESSIBILITY: "ensureObjectAccessibility",
      NO_ACTION: "noAction"
   });

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var host_ui;
(function (host_ui) {
    var HardwareMemoryComponent = (function () {
        function HardwareMemoryComponent() {
            this.templateUrl = "host-ui/resources/host/views/settings/memory/hardwareMemoryComponent.html";
            this.controller = HardwareMemoryController;
            this.controllerAs = "ctrl";
            this.bindings = {
                hostId: "<"
            };
        }
        return HardwareMemoryComponent;
    }());
    host_ui.HardwareMemoryComponent = HardwareMemoryComponent; // HardwareMemoryComponent
    var HardwareMemoryController = (function () {
        function HardwareMemoryController(hardwareMemoryService, featureFlagsService) {
            this.hardwareMemoryService = hardwareMemoryService;
            this.featureFlagsService = featureFlagsService;
        }
        HardwareMemoryController.prototype.$onInit = function () {
            var memorySettingsObject = this.hardwareMemoryService.getMemorySettingsOptions(this.hostId);
            this.memoryHeaderOptions = memorySettingsObject.headerOptions;
            this.memorySettingsViewOptions = memorySettingsObject.settingsViewOptions;
            var pmemSettingsObject = this.hardwareMemoryService.getPmemSettingsOptions(this.hostId);
            this.pmemHeaderOptions = pmemSettingsObject.headerOptions;
            this.pmemSettingsViewOptions = pmemSettingsObject.settingsViewOptions;
            this.isPmemEnabled = this.featureFlagsService.PMemEnabled();
        };
        HardwareMemoryController.$inject = [
            "hardwareMemoryService",
            "featureFlagsService"
        ];
        return HardwareMemoryController;
    }());
    host_ui.HardwareMemoryController = HardwareMemoryController; // HardwareMemoryController
    angular.module("com.vmware.vsphere.client.host")
        .component("hardwareMemoryComponent", new HardwareMemoryComponent());
})(host_ui || (host_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var host_ui;
(function (host_ui) {
    var HardwareMemoryService = (function () {
        function HardwareMemoryService(i18nService, bytesFilter) {
            this.i18nService = i18nService;
            this.bytesFilter = bytesFilter;
            this.PROP_TOTAL_PMEM = "totalPMem";
            this.PROP_AVAILABLE_PMEM = "availablePMem";
            this.PROP_NOT_AVAILABLE = "--";
        }
        /**
         * Property value format function - in some cases the property value is not a string and it requires some custom
         * formatting.
         * @param propName
         *    Name of the property.
         * @param contentValue
         *    Raw value of the property - might be a string or an object.
         */
        HardwareMemoryService.prototype.formatPropertyValue = function (propName, contentValue) {
            if (propName === this.PROP_TOTAL_PMEM || propName === this.PROP_AVAILABLE_PMEM) {
                if (contentValue === this.PROP_NOT_AVAILABLE) {
                    return this.bytesFilter(0, "MB");
                }
                return this.bytesFilter(contentValue, "MB");
            }
            // for all the properties that there is no need for custom formatting - just return the raw content value
            return contentValue;
        };
        HardwareMemoryService.prototype.getMemorySettingsOptions = function (hostId) {
            var headerOptions = this.getHeaderOptions("settings.memoryConfig.title", hostId);
            return {
                headerOptions: headerOptions,
                settingsViewOptions: this.getSettingsViewOptions("memoryConfig", hostId)
            };
        };
        HardwareMemoryService.prototype.getPmemSettingsOptions = function (hostId) {
            var headerOptions = this.getHeaderOptions("settings.pMemConfig.title", hostId);
            return {
                headerOptions: headerOptions,
                settingsViewOptions: this.getSettingsViewOptions("pMemConfig", hostId)
            };
        };
        HardwareMemoryService.prototype.getHeaderOptions = function (titleProperty, hostId) {
            return {
                title: this.i18nService.getString("HostUi", titleProperty),
                actions: [],
                objectIds: [hostId]
            };
        };
        HardwareMemoryService.prototype.getSettingsViewOptions = function (propertyName, hostId) {
            var _this = this;
            return {
                objectId: hostId,
                propertyName: propertyName,
                formatValueCallback: function (propName, contentValue) {
                    return _this.formatPropertyValue(propName, contentValue);
                },
                type: "stack"
            };
        };
        HardwareMemoryService.$inject = [
            "i18nService",
            "bytesFilter"
        ];
        return HardwareMemoryService;
    }());
    host_ui.HardwareMemoryService = HardwareMemoryService; // class
    angular.module("com.vmware.vsphere.client.host").service("hardwareMemoryService", HardwareMemoryService);
})(host_ui || (host_ui = {})); // module



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('moveHostToController', MoveHostToController);

   MoveHostToController.$inject = [
      '$scope',
      'moveHostToService',
      'defaultUriSchemeUtil'
   ];

   function MoveHostToController($scope,
         moveHostToService, defaultUriSchemeUtil) {
      var self = this;
      self.hostIds = $scope.modalOptions.dialogData.objectIds;
      self.onLocationSelected = onLocationSelected;
      self.treeRoot = defaultUriSchemeUtil.getRootFolderFromVsphereObjectId(self.hostIds[0]);

      $scope.modalOptions.onSubmit = function() {
         moveHostToService.moveHostTo(self.entityToMoveHostTo,self.hostIds);

         $scope.closeModal();
      };

      function onLocationSelected(objectReference) {
         self.entityToMoveHostTo = objectReference;
      }
   }
})();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('moveHostToService',
         MoveHostToService);

   MoveHostToService.$inject = ['i18nService',
      'mutationService',
      'clarityModalService',
      'dataService',
      '$q',
      'defaultUriSchemeUtil'];

   function MoveHostToService(i18nService,
         mutationService,
         clarityModalService,
         dataService,
         $q,
         defaultUriSchemeUtil) {


      function displayMaintenanceModeErrorDialog(clusterName) {
         var modalOptions = {
            message: i18nService.getString('HostUi', 'hostNotInMaintenanceModeError',
                  clusterName),
            title: i18nService.getString('HostUi', 'common.util.error'),
            icon: "vx-icon-warning-32x32",
            hideCancelButton: true,
            preserveNewlines: true,
            submit: function() {
            }
         };
         clarityModalService.openConfirmationModal(modalOptions);
      }

      function showWarningDialog(clusterName, hostMors, entityToMoveHostTo) {
         var modalOptions = {
            message: i18nService.getString('HostUi', 'cluster.moveInto.noDRS.singleHost',
                  clusterName),
            title: i18nService.getString('HostUi', 'common.util.warning'),
            icon: "vx-icon-warning-32x32",
            preserveNewlines: true,
            submit: function() {
               var moveSpec = {
                  entities: hostMors,
                  attributes: null,
                  allowLoosingNestedRps: true
               };
               mutationService.apply(
                     entityToMoveHostTo,
                     'com.vmware.vsphere.client.h5.host.moveHost.MoveHostSpec',
                     moveSpec
               );
            }
         };
         clarityModalService.openConfirmationModal(modalOptions);
      }

      function showMoveVmsAndRpsDialog(hostMor,
            hostId,
            hostName,
            entityToMoveHostTo,
            dpmTurnedOn) {
         var modalOptions = {
            title: i18nService.getString('HostUi',
                  'warning.hostNotConnectedToAllDsClusterDatastores.single.dialogTitle'),
            subTitle: {
               objectId: hostId
            },
            contentTemplate: 'host-ui/resources/host/views/settings/moveto/moveHostVmsAndRpsDialog.html',
            defaultButton: 'submit',
            dialogData: {
               hostMor: hostMor,
               hostId: hostId,
               hostName: hostName,
               dpmTurnedOn: dpmTurnedOn,
               entityToMoveHostTo: entityToMoveHostTo
            }
         };
         clarityModalService.openOkCancelModal(modalOptions);
      }

      function getMoveRpSpec(hostMor, moveToRoot) {
         return {
            entities: [hostMor],
            attributes: null,
            allowLoosingNestedRps: true,
            moveVmsAndRpsConfigSpec: {
               moveEnabled: true,
               moveToRoot: moveToRoot,
               moveToCustomRp: !moveToRoot
            }
         };
      }

      function showRpmWarningCondition(hostId, dpmTurnedOn) {
         var deferred = $q.defer();
         if (dpmTurnedOn) {
            var showDpmWarning = false;
            dataService.getData(
                  hostId,
                  'com.vmware.vsphere.client.h5.host.moveHost.HostConfigInformation').then(function(data) {
               if (data && !data.lastExitSucceeded) {
                  showDpmWarning = true;
               }
               deferred.resolve(showDpmWarning);
            });
         }
         return deferred.promise;
      }

      function moveHostTo(entityToMoveHostTo, hostIds) {

         var hostMors = _.map(hostIds, function(hostId) {
            return defaultUriSchemeUtil.getManagedObjectReference(hostId);
         });

         var moveSpec = {
            entities: hostMors,
            attributes: null,
            allowLoosingNestedRps: false,
            moveVmsAndRpsConfigSpec: {
               moveEnabled: false,
               moveToRoot: false,
               moveToCustomRp: false
            }
         };

         mutationService.apply(
               entityToMoveHostTo,
               'com.vmware.vsphere.client.h5.host.moveHost.MoveHostSpec',
               moveSpec).then(function(operationsResult) {

            if (!operationsResult.error) {
               var allResults = operationsResult.result;

               var hostNotInMaintenanceModeOpResult = _.find(allResults, function(operationResult) {
                  var operationParameter = operationResult.parameter;
                  return operationParameter && operationParameter.displayMaintenanceModeError;
               });

               if (!hostNotInMaintenanceModeOpResult) {
                  _.each(allResults, function(operationResult) {
                     var operationParameter = operationResult.parameter;
                     if (operationParameter && operationParameter.showWarningDialog) {
                        showWarningDialog(operationParameter.clusterName,
                              hostMors,
                              entityToMoveHostTo);
                     } else if (operationParameter && operationParameter.showMovementDialog) {
                        var currentHostMor = operationParameter.hostRef;
                        var hostId = defaultUriSchemeUtil.getVsphereObjectId(currentHostMor);
                        showMoveVmsAndRpsDialog(
                              currentHostMor,
                              hostId,
                              operationParameter.hostName,
                              entityToMoveHostTo,
                              operationParameter.dpmTurnedOn);
                     }
                  });
               } else {
                  displayMaintenanceModeErrorDialog(hostNotInMaintenanceModeOpResult.clusterName);
               }
            }
         });
      }

      return {
         getMoveRpSpec: getMoveRpSpec,
         showRpmWarningCondition: showRpmWarningCondition,
         moveHostTo: moveHostTo
      };
   }
})();


(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('moveHostVmsAndRpsController', MoveHostVmsAndRpsController);

   MoveHostVmsAndRpsController.$inject = [
      '$scope',
      'mutationService',
      'i18nService',
      'moveHostToService',
      'vuiConstants'
   ];

   function MoveHostVmsAndRpsController($scope,
         mutationService,
         i18nService,
         moveHostToService,
         vuiConstants) {
      var self = this;
      self.destinationType = "root";
      self.hostId = $scope.modalOptions.dialogData.hostId;
      self.hostName = $scope.modalOptions.dialogData.hostName;
      self.showDpmWarning = false;

      moveHostToService.showRpmWarningCondition(self.hostId,
            $scope.modalOptions.dialogData.dpmTurnedOn,
            self.showDpmWarning)
            .then(function(data){
               self.showDpmWarning = data;
            });

      $scope.modalOptions.onSubmit = function() {
         var moveSpec = {};
         if (self.destinationType === 'root') {
            moveSpec = moveHostToService.getMoveRpSpec(
                  $scope.modalOptions.dialogData.hostMor,
                  true
            );

            mutationService.apply(
                  $scope.modalOptions.dialogData.entityToMoveHostTo,
                  'com.vmware.vsphere.client.h5.host.moveHost.MoveHostSpec',
                  moveSpec
            );
            $scope.closeModal();

         } else {

            // Handle error if RP name is empty
            if (!self.destination) {
               $scope.modalOptions.alerts = [];
               var alertMsg = i18nService.getString(
                     'HostUi',
                     'hostToClusterOp.resPoolPage.rpNameReqError'
               );
               $scope.modalOptions.alerts.push({
                  text: alertMsg,
                  type: vuiConstants.validationBanner.type.ERROR
               });
            } else {
               moveSpec = moveHostToService.getMoveRpSpec(
                     $scope.modalOptions.dialogData.hostMor,
                     false
               );
               moveSpec.moveVmsAndRpsConfigSpec.newRpName = self.destination;
               mutationService.apply(
                     $scope.modalOptions.dialogData.entityToMoveHostTo,
                     'com.vmware.vsphere.client.h5.host.moveHost.MoveHostSpec',
                     moveSpec
               ).then(function(response) {
                  // Handle errors if RP name is not valid
                  var responseParameter = response.parameter;
                  if (responseParameter && responseParameter.unsuccessfulMovementOperation) {
                     var alertMsg = i18nService.getString(
                           'HostUi',
                           'moveHost.moveVms.error.nameAlreadyExist',
                           self.destination
                     );
                     $scope.modalOptions.alerts = [];
                     $scope.modalOptions.alerts.push({
                        text: alertMsg,
                        type: vuiConstants.validationBanner.type.ERROR
                     });
                  } else {
                     $scope.closeModal();
                  }
               });
            }
         }
      };

   }
})();


var host_ui;
(function (host_ui) {
    var HostSoftwarePackagesController = (function () {
        function HostSoftwarePackagesController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.hostId = $scope._route.objectId;
            this.objectsToWatch = [$scope._route.objectId];
            this.headerOptions = {
                title: this.i18nService.getString('HostUi', 'imageProfileTOC.softwarePackages.header'),
                actions: []
            };
        }
        HostSoftwarePackagesController.$inject = ["$scope", "i18nService"];
        return HostSoftwarePackagesController;
    }());
    angular.module("com.vmware.vsphere.client.host")
        .controller("HostSoftwarePackagesController", HostSoftwarePackagesController);
})(host_ui || (host_ui = {}));



(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
      .controller('editPciDevicesController', EditPciDevicesController);

   EditPciDevicesController.$inject = ['$scope',
      'dataService',
      'i18nService',
      'pciDeviceService',
      'vuiUtils',
      '$element'];

   function EditPciDevicesController($scope,
                                     dataService,
                                     i18nService,
                                     pciDeviceService,
                                     vuiUtils,
                                     $element) {
      var objectId = $scope._route.objectId;
      var hostStr = _.bind(i18nService.getString, i18nService, 'HostUi');
      var self = this;
      self.getData = getData;

      getData();

      $scope.modalOptions.onSubmit = onSubmit;
      self.treeListWidget = null;
      self.showPciDevicePortlets = true;
      self.showHideLabel = hostStr('vmdpConfig.hidedetails.label');

      self.showPortlets = function() {
         if (self.showHideLabel === hostStr('vmdpConfig.hidedetails.label')) {
            self.showPciDevicePortlets = false;
            self.showHideLabel = hostStr('vmdpConfig.showdetails.label');
         } else {
            self.showPciDevicePortlets = true;
            self.showHideLabel = hostStr('vmdpConfig.hidedetails.label');
         }
      };

      function onSubmit() {
         var pciPassthruUpdateSpec = pciDeviceService
            .getChangedPciDevicesUpdateSpec(self.treeListOptions.dataSource.data());

         var pciDevicesWithEsxiDevice =
            pciDeviceService.getPciDevicesWithEsxiDevice(self.treeListOptions.dataSource.data());

         if (pciDevicesWithEsxiDevice.length > 0) {
            pciDeviceService.showConfirmationDialog(
               pciDevicesWithEsxiDevice,
               pciPassthruUpdateSpec,
               $scope.closeModal,
               objectId);
         } else {
            return pciDeviceService.applyEditPciDevices(pciPassthruUpdateSpec, objectId);
         }
      }


      function getData() {
         dataService.getData(objectId,
            'com.vmware.vsphere.client.h5.host.vmdp.VmdpDeviceNodeData').then(
            function (data) {
               if (data) {
                  self.modifiedData = _.map(data.vmdpDeviceNodeList, function(dataItem) {
                     return angular.merge({
                        _originalStatus: dataItem.status
                     }, dataItem);
                  });

                  self.initializeTreeListDataSource(self.modifiedData);
               }
            });
      }

      self.initializeTreeListDataSource = function(data) {
         self.treeListOptions.dataSource = new kendo.data.TreeListDataSource({
            data: data,
            schema: treeListDataSourceSchema
         });
         self.treeListOptions.dataSource.read();
      };

      var treeListDataSourceSchema = {
         model: {
            id: "nodeId",
            expanded: true
         }
      };

      self.treeListColumns = [
         {
            field: "busId",
            title: hostStr('vmdpConfig.idColHeader.label'),
            template: function(dataItem) {
               return pciDeviceService.createPciDeviceCheckbox(dataItem);
            }
         },
         {
            field: "statusMessage",
            title: hostStr('vmdpConfig.statusHeader.label')
         },
         {
            field: "vendor",
            title: hostStr('vmdpConfig.vendorName.label')
         },
         {
            field: "deviceName",
            title: hostStr('vmdpConfig.deviceNameHeader.label'),
            template: pciDeviceService.textTitleRenderer
         },
         {
            field: "esxDeviceInfo",
            title: hostStr('vmdpConfig.esxName.label'),
            template: function(dataItem) {
               return dataItem.esxDeviceInfo ? dataItem.esxDeviceInfo.split(" ")[0] : '';
            }
         }
      ];

      $element.on("selectPciDevice", function(event, dataItemUid) {
         event.stopPropagation();

         var data = self.treeListOptions.dataSource.data();

         var dataItem = _.find(data, function(item) {
            return item.uid === dataItemUid;
         });

         if (dataItem.dependentDevice) {
            // here it will find itself also
            _.each(data, function(item) {
               if (dataItem.dependentDevice === item.dependentDevice) {
                  pciDeviceService.updateStatus(item);
               }
            });
         } else {
            pciDeviceService.updateStatus(dataItem);
         }

         self.treeListWidget.refresh();
      });

      self.onTreeListSelect = function() {
         var row = self.treeListWidget.select();
         var data = self.treeListWidget.dataItem(row);
         if (data) {
            self.pciDetailsData =
               pciDeviceService.createPciDetails(data);
            self.pciDeviceBusDetatils =
               pciDeviceService.createPciBusDetails(data);
            self.esxDeviceInfo =
               pciDeviceService.createEsxDeviceInfoDetails(data);
            self.directPathMessage = data.directPathMessage;
            self.selectedPciId = data.busId;
            self.hasSelectedPciDevice = true;
         } else {
            self.hasSelectedPciDevice = false;
         }
      };

      self.treeListOptions = {
         columns: self.treeListColumns,
         sortable: false,
         resizable: true,
         selectable: true,
         change: _.partial(vuiUtils.safeApply, $scope, self.onTreeListSelect)
      };
   }
})();

(function () {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
      .controller('pciDevicesController', PciDevicesController);

   PciDevicesController.$inject = ['$scope', 'dataService',
      'i18nService', 'pciDeviceService', 'columnRenderersRegistry', 'vuiUtils'];

   function PciDevicesController($scope,
         dataService, i18nService, pciDeviceService, columnRenderersRegistry, vuiUtils) {
      var objectId = $scope._route.objectId;
      var hostStr = _.bind(i18nService.getString, i18nService, 'HostUi');
      var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('icon-text');
      var treeListDataSourceSchema = {
         model: {
            id: "nodeId",
            expanded: true
         }
      };
      var self = this;

      self.headerOptions = {
         title: hostStr('vmdpConfig.list.title'),
         actions: [
            {
               actionUid: 'vsphere.core.host.actions.refreshPciDevices',
               customLabel: i18nService.getString('Common', 'refresh')
            },
            {
               actionUid: 'vsphere.core.host.actions.editPciDevices',
               customLabel: i18nService.getString('HostUi',
                     'vmdpConfig.editButton.label')
             }]
      };
      self.gridOptions = pciDeviceService.getGridOptions();
      self.splitterOptions = pciDeviceService.getSplitterOptions();
      self.showCapablePassthruDevices = true;
      self.showAllDevices = false;
      self.watchForObjects = [objectId];
      self.liveRefreshProperties = [
         'config.pciPassthruInfo',
         'summary.rebootRequired'
      ];
      self.updateViewData = updateViewData;
      self.getAllDevicesData = getAllDevicesData;
      self.rebootHost = function() {
         h5.actions['vsphere.core.host.actions.rebootAction']({}, [objectId]);
      };

      self.treeListWidget = null;
      self.treeListColumns = [
         {
            field: "busId",
            title: hostStr('vmdpConfig.idColHeader.label'),
            template: function(dataItem) {
               return iconTextRenderer(['icon', 'text'], {
                  icon: 'vx-icon-pci',
                  text: dataItem.busId
               });
            }
         },
         {
            field: "statusMessage",
            title: hostStr('vmdpConfig.statusHeader.label')
         },
         {
            field: "vendor",
            title: hostStr('vmdpConfig.vendorName.label')
         },
         {
            field: "deviceName",
            title: hostStr('vmdpConfig.deviceNameHeader.label'),
            template: pciDeviceService.textTitleRenderer
         },
         {
            field: "esxDeviceInfo",
            title: hostStr('vmdpConfig.esxName.label'),
            template: function(dataItem) {
               return dataItem.esxDeviceInfo ? dataItem.esxDeviceInfo.split(" ")[0] : '';
            }
         }
      ];

      self.initializeTreeListDataSource = function(data) {
         self.treeListOptions.dataSource = new kendo.data.TreeListDataSource({
            data: data,
            schema: treeListDataSourceSchema
         });
         self.treeListOptions.dataSource.read();
      };

      self.onShowCapablePassthruDevices = onShowCapablePassthruDevices;
      self.onShowAllDevices = onShowAllDevices;

      updateViewData();

      self.onTreeListSelect = function() {
         var row = self.treeListWidget.select();
         var data = self.treeListWidget.dataItem(row);
         if (data) {
            self.pciDetailsTreeData =
                  pciDeviceService.createPciDetails(data);
            self.pciDeviceTreeBusDetatils =
                  pciDeviceService.createPciBusDetails(data);
            self.treeEsxDeviceInfo =
                  pciDeviceService.createEsxDeviceInfoDetails(data);
            self.treeDirectPathMessage = data.directPathMessage;
            self.selectedTreePciId = data.busId;
            self.hasSelectedTreePciDevice = true;
         } else {
            self.hasSelectedTreePciDevice = false;
         }
      };

      self.treeListOptions = {
         columns: self.treeListColumns,
         sortable: false,
         resizable: true,
         selectable: true,
         change: _.partial(vuiUtils.safeApply, $scope, self.onTreeListSelect)
      };

      $scope.pciDevicesPreselectComparator = pciDevicesPreselectComparator;

      function updateViewData() {
         dataService.getData(objectId,
            'com.vmware.vsphere.client.h5.host.vmdp.VmdpDeviceInfoData').then(
            function (data) {
               if (data) {
                  self.gridOptions.data = data.availableVmdpDeviceInfo;
                  self.pendingDevicesMessage =
                        pciDeviceService.formatPendingDeviceMessage(self.gridOptions.data);
                  addWatchForSelectedItems();
               }
            });
      }

      function getAllDevicesData() {
         dataService.getData(objectId,
               'com.vmware.vsphere.client.h5.host.vmdp.VmdpAllDevicesNodeData').then(
               function (data) {
                  if (data) {
                     self.allDevicesData = data.vmdpDeviceNodeList;
                     self.allPendingDevicesMessage =
                           pciDeviceService.formatPendingDeviceMessage(self.allDevicesData);
                     self.initializeTreeListDataSource(self.allDevicesData);
                  }
               });
      }

      function addWatchForSelectedItems() {
         $scope.$watch(
            function () {
               return self.gridOptions.selectedItems;
            },
            function (selectedItems) {
               if (selectedItems && selectedItems.length > 0) {
                  self.pciDetailsData =
                     pciDeviceService.createPciDetails(selectedItems[0]);
                  self.pciDeviceBusDetatils =
                     pciDeviceService.createPciBusDetails(selectedItems[0]);
                  self.esxDeviceInfo =
                     pciDeviceService.createEsxDeviceInfoDetails(selectedItems[0]);
                  self.directPathMessage = selectedItems[0].directPathMessage;
                  self.selectedPciId = selectedItems[0].busId;
                  self.hasSelectedPciDevice = true;
               } else {
                  self.hasSelectedPciDevice = false;
               }
            });
      }

      function pciDevicesPreselectComparator(gridDataItem) {
         return self.hasSelectedPciDevice && gridDataItem &&
               self.selectedPciId === gridDataItem.busId;
      }

      function onShowCapablePassthruDevices() {
         self.showCapablePassthruDevices = true;
         self.showAllDevices = false;
      }

      function onShowAllDevices() {
         self.showCapablePassthruDevices = false;
         self.showAllDevices = true;
         self.splitterOptionsAllItems = pciDeviceService.getSplitterOptions();
         if (!self.allDevicesData) {
            getAllDevicesData();
         }
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('pciDeviceService',
      PciDeviceService);

   PciDeviceService.$inject = ['vxPropertyViewService', 'i18nService',
      'columnRenderersRegistry', 'vuiConstants','mutationService', 'clarityModalService'];

   function PciDeviceService(vxPropertyViewService, i18nService, columnRenderersRegistry,
      vuiConstants, mutationService, clarityModalService) {
      var iconTextRenderer = columnRenderersRegistry.getColumnRenderer('icon-text');
      var hostStr = _.bind(i18nService.getString, i18nService, 'HostUi');
      var NOT_CONFIGURABLE = 'NOT_CONFIGURABLE';
      var AVAILABLE = "AVAILABLE";
      var UNAVAILABLE = "UNAVAILABLE";
      var AVAILABLE_PENDING = "AVAILABLE_PENDING";
      var UNAVAILABLE_PENDING = "UNAVAILABLE_PENDING";

      function createPciDetails(pciDevice) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();
         var sectionBuilder = builder.category('').section(
            'pciDetailsData').title(hostStr('vmdpConfig.pciDeviceDetails.label'));

         sectionBuilder.property(
            hostStr('vmdpConfig.deviceName.label'),
            pciDevice.deviceName
         ).property(
            hostStr('vmdpConfig.deviceId.label'),
            pciDevice.deviceId
         ).property(
            hostStr('vmdpConfig.subDeviceId.label'),
            pciDevice.subDeviceId
         ).property(
            hostStr('vmdpConfig.classId.label'),
            pciDevice.classId
         ).property(
            hostStr('vmdpConfig.vendorName.label'),
            pciDevice.vendor
         ).property(
            hostStr('vmdpConfig.vendorId.label'),
            pciDevice.vendorId
         ).property(
            hostStr('vmdpConfig.subVendorId.label'),
            pciDevice.subVendorId
         );
         return builder.build();
      }

      function createEsxDeviceInfoDetails(pciDevice) {
         if (pciDevice.esxDeviceInfo) {
            var builder = vxPropertyViewService.createPropertyViewBuilder();

            var sectionBuilder = builder.category('').section('esxDeviceInfo');

            sectionBuilder.property(
                  hostStr('vmdpConfig.esxName.label'),
                  pciDevice.esxDeviceInfo
            );

            return builder.build();
         }

         return null;
      }

      function createPciBusDetails(pciDevice) {
         var builder = vxPropertyViewService.createPropertyViewBuilder();

         var sectionBuilder = builder.category('').section('busDetails').title(
               hostStr('vmdpConfig.bsfLocation.label'));

         sectionBuilder.property(
               hostStr('vmdpConfig.id.label'),
               pciDevice.busId
         ).property(
               hostStr('vmdpConfig.bus.label'),
               pciDevice.bus
         ).property(
               hostStr('vmdpConfig.slot.label'),
               pciDevice.busSlot
         ).property(
               hostStr('vmdpConfig.function.label'),
               pciDevice.function
         );

         return builder.build();
      }

      function getSplitterOptions() {
         return  {
            orientation: vuiConstants.splitter.orientation.VERTICAL,
            panes: [
               {
                  min: '150px',
                  size: '47%'
               }, {
                  min: '250px',
                  size: '53%'
               }
            ]
         };
      }

      function getGridOptions() {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            resizable: true,
            selectedItems: [],
            data: [],
            columnDefs: getColumnDefs(),
            height: '100%',
            pageConfig: {
               hidePager: true
            }
         };
      }

      function getColumnDefs() {
         return [
            {
               field: "busId",
               displayName: hostStr('vmdpConfig.idColHeader.label'),
               template: function(dataItem) {
                  var icon = 'vx-icon-pci';
                  if (dataItem.status === AVAILABLE_PENDING || dataItem.status === UNAVAILABLE_PENDING) {
                     icon = 'vx-icon-pci-pt-reboot';
                  }
                  return iconTextRenderer(['icon', 'text'], {
                     icon: icon,
                     text: dataItem.busId
                  });
               }
            },
            {
               field: "statusMessage",
               displayName: hostStr('vmdpConfig.statusHeader.label')
            },
            {
               field: "vendor",
               displayName: hostStr('vmdpConfig.vendorName.label')
            },
            {
               field: "deviceName",
               displayName: hostStr('vmdpConfig.deviceNameHeader.label'),
               template: textTitleRenderer
            }
         ];
      }

      function textTitleRenderer(data) {
         var text = data && data.deviceName ? data.deviceName : '';

         return '<span title=\"' + text + '\">' + text + '</span>';
      }

      function countPendingDevices(data) {
         var availablePending = _.filter(data, function(item) {
            return item.status === AVAILABLE_PENDING;
         }).length;

         var unavailablePending = _.filter(data, function(item) {
            return item.status === UNAVAILABLE_PENDING;
         }).length;

         return {
            availablePendingDevices: availablePending,
            unavailablePendingDevices: unavailablePending
         };
      }

      function formatPendingDeviceMessage(data) {
         var pendingDevices = countPendingDevices(data);
         var availablePendingDevices = pendingDevices.availablePendingDevices;
         var unavailablePendingDevices = pendingDevices.unavailablePendingDevices;

         var availablePendingDevicesCode = ((availablePendingDevices >= 2) ? 2 : availablePendingDevices).toString();
         var unavailablePendingDevicesCode = ((unavailablePendingDevices >= 2) ? 2 : unavailablePendingDevices).toString();

         var availableMessages = getAvailableMessages(availablePendingDevices, unavailablePendingDevices);

         return availableMessages[availablePendingDevicesCode+unavailablePendingDevicesCode];

      }

      function getAvailableMessages(availablePendingDevices, unavailablePendingDevices) {
         return {
            "00" : '',
            "01" : hostStr(
                  'vmdpConfig.rebootToDeactivateDevicesSingular.label',
                  unavailablePendingDevices
            ),
            "02" : hostStr(
                  'vmdpConfig.rebootToDeactivateDevicesPlural.label',
                  unavailablePendingDevices
            ),
            "10" : hostStr(
                  'vmdpConfig.rebootToActivateDevicesSingular.label',
                  availablePendingDevices
            ),
            "20" : hostStr(
                  'vmdpConfig.rebootToActivateDevicesPlural.label',
                  availablePendingDevices
            ),
            "11" : hostStr(
                  'vmdpConfig.rebootToChangeDevicesSingular.label',
                  availablePendingDevices,
                  unavailablePendingDevices
            ),
            "12" : hostStr(
                  'vmdpConfig.rebootToChangeDevicesSingular.label',
                  availablePendingDevices,
                  unavailablePendingDevices
            ),
            "21" : hostStr(
                  'vmdpConfig.rebootToChangeDevicesPlural.label',
                  availablePendingDevices,
                  unavailablePendingDevices
            ),
            "22" : hostStr(
                  'vmdpConfig.rebootToChangeDevicesPlural.label',
                  availablePendingDevices,
                  unavailablePendingDevices
            )
         };
      }

      function getChangedDevices(dataItems) {
         return _.filter(dataItems, function(dataItem) {
            return dataItem.status !== dataItem._originalStatus;
         });
      }

      function getPciDevicesWithEsxiDevice(dataItems) {
         var changedPciDevices = getChangedDevices(dataItems);
         return _.filter(changedPciDevices, function(dataItem) {
            return dataItem.esxDeviceInfo !== null;
         });
      }

      function getChangedPciDevicesUpdateSpec(dataItems) {
         var changedPciDevices = getChangedDevices(dataItems);
         return getPciPassthruUpdateSpec(changedPciDevices);
      }

      function getModalDescription(pciDevicesWithEsxiDevice) {
         var title,devices,description;
         if (pciDevicesWithEsxiDevice.length === 1) {
            // Singular label
            title = hostStr('vmdpConfig.esxDeviceWarningSingular.title');
            devices = getDevicesString(pciDevicesWithEsxiDevice);
            description =hostStr(
                  'vmdpConfig.esxDeviceWarningSingular.label',
                  devices
            );
         } else if (pciDevicesWithEsxiDevice.length === 2) {
            // Dual
            title = hostStr('vmdpConfig.esxDeviceWarningDual.title');
            devices = getDevicesString(pciDevicesWithEsxiDevice);
            description = hostStr(
               'vmdpConfig.esxDeviceWarningDual.label',
               devices
            );
         } else {
            // Plural
            title = hostStr('vmdpConfig.esxDeviceWarningPlural.title');
            devices = getDevicesString(pciDevicesWithEsxiDevice);
            description = hostStr(
               'vmdpConfig.esxDeviceWarningPlural.label',
               devices
            );
         }

         return {
            description: description,
            title: title
         };
      }

      function getDevicesString(devicesArray) {
         var esxDeviceMessages = _.map(devicesArray, function(device) {
            var key;

           if (device.esxDeviceInfo.indexOf('virtual switch') !== -1) {
              key = 'vmdpConfig.esxSwitchWarning.label';
            } else if (device.esxDeviceInfo.indexOf('dvs') !== -1) {
              key = 'vmdpConfig.esxDvsWarning.label';
            }

            if (key) {
               var esxDeviceInfoArray = device.esxDeviceInfo.split(' ');
               var nic = esxDeviceInfoArray[0];
               var esxDevice = esxDeviceInfoArray[esxDeviceInfoArray.length - 1].replace(')','');
               // return nic on vswitch or dvs message
               return hostStr(
                     key,
                     device.busId,
                     nic,
                     esxDevice
                  );
            }

            // return the storage device message
            return hostStr(
                    'vmdpConfig.esxDeviceWarning.label',
                    device.busId,
                    device.esxDeviceInfo);
         });

         return esxDeviceMessages.join(',\n');
      }

      function createPciDeviceCheckbox(dataItem) {
         return dataItem.status === NOT_CONFIGURABLE ? notConfigurablePciDevices(dataItem) :
               configurablePciDevices(dataItem);
      }

      function configurablePciDevices(dataItem) {
         dataItem.enabled = dataItem.status &&
               (dataItem.status === AVAILABLE_PENDING ||
               dataItem.status === AVAILABLE);

         return "<label><input type=\"checkbox\" " +
               " " + (dataItem.enabled ? "checked" : "") +
               " onchange=\"$(this).trigger('selectPciDevice', '" + dataItem.uid + "')\"/>" +
               iconTextRenderer(['icon', 'text'], {
                  icon: 'vx-icon-pci',
                  text: dataItem.busId
               }) +
               '</label>';
      }

      function notConfigurablePciDevices(dataItem) {
         return iconTextRenderer(['icon', 'text'], {
            icon: 'vx-icon-pci',
            text: dataItem.busId
         });
      }

      function updateStatus(dataItem) {
         switch(dataItem.status){
            case AVAILABLE_PENDING:
               dataItem.status = UNAVAILABLE;
               dataItem.statusMessage = hostStr('vmdpConfig.devStatus.unavailable');
               break;
            case AVAILABLE:
               dataItem.status = UNAVAILABLE_PENDING;
               dataItem.statusMessage = hostStr('vmdpConfig.devStatus.unavailableLater');
               break;
            case UNAVAILABLE_PENDING:
               dataItem.status = AVAILABLE;
               dataItem.statusMessage = hostStr('vmdpConfig.devStatus.available');
               break;
            case UNAVAILABLE:
               dataItem.status = AVAILABLE_PENDING;
               dataItem.statusMessage = hostStr('vmdpConfig.devStatus.availableLater');
               break;
            default:
               break;
         }
      }

      function isVmdpPassthruEnabled(dataItem) {
         return dataItem.status === AVAILABLE || dataItem.status === AVAILABLE_PENDING;
      }

      function applyEditPciDevices(pciPassthruUpdateSpec, objectId) {
         if (!_.isEmpty(pciPassthruUpdateSpec.configs)) {
            mutationService.apply(objectId,
               "com.vmware.vsphere.client.host.config.PciPassthruUpdateSpec",
               pciPassthruUpdateSpec);
         }
         return true;
      }

      function showConfirmationDialog(pciDevicesWithEsxiDevice, pciPassthruUpdateSpec, callback, objectId) {
         var okHandler = function() {
            applyEditPciDevices(pciPassthruUpdateSpec, objectId);
            callback();
         };

         var description = getModalDescription(pciDevicesWithEsxiDevice);
         var modalOptions = {
            title: description.title,
            message: description.description,
            submit: okHandler,
            icon: 'icon-warning-32',
            saveButtonLabel: hostStr('answerYes'),
            cancelButtonLabel: hostStr('answerNo'),
            preserveNewlines:true
         };

         clarityModalService.openConfirmationModal(modalOptions);
      }

      function getPciPassthruUpdateSpec(data) {
         return {
            configs: convertPciDeviceInfoToPciDeviceConfig(data)
         };
      }

      function convertPciDeviceInfoToPciDeviceConfig(data) {
         return _.map(data, function(item){
            return {
               '_type': 'com.vmware.vim.binding.vim.host.PciPassthruConfig',
               id: item.vmdpDeviceId,
               passthruEnabled: isVmdpPassthruEnabled(item)
            };
         });
      }

      return {
         createPciDetails: createPciDetails,
         createPciBusDetails: createPciBusDetails,
         createEsxDeviceInfoDetails: createEsxDeviceInfoDetails,
         getGridOptions: getGridOptions,
         getSplitterOptions: getSplitterOptions,
         formatPendingDeviceMessage: formatPendingDeviceMessage,
         getChangedPciDevicesUpdateSpec: getChangedPciDevicesUpdateSpec,
         createPciDeviceCheckbox: createPciDeviceCheckbox,
         updateStatus: updateStatus,
         getPciDevicesWithEsxiDevice: getPciDevicesWithEsxiDevice,
         applyEditPciDevices:applyEditPciDevices,
         showConfirmationDialog:showConfirmationDialog,
         textTitleRenderer: textTitleRenderer
      };
   }
})();


var host_ui;
(function (host_ui) {
    var EditBootOptionsController = (function () {
        function EditBootOptionsController($scope, dataService, mutationService, i18nService) {
            this.$scope = $scope;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.i18nService = i18nService;
            this.hostId = $scope._route.objectId;
            $scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.getBootDevices();
        }
        EditBootOptionsController.prototype.getBootDevices = function () {
            var _this = this;
            this.dataService.getProperties(this.hostId, ["bootDeviceInfo"])
                .then(function (data) {
                if (data && data.bootDeviceInfo) {
                    _this.bootDevices = data.bootDeviceInfo.bootDevices;
                    _this.selectedOption = _this.getCurrentDeviceByKey(data.bootDeviceInfo.currentBootDeviceKey);
                }
                else {
                    _this.bootDevices = [];
                    _this.selectedOption = {
                        key: "",
                        description: ""
                    };
                }
            });
        };
        EditBootOptionsController.prototype.getCurrentDeviceByKey = function (bootDeviceKey) {
            return _.find(this.bootDevices, function (bootDevice) {
                return bootDeviceKey === bootDevice.key;
            });
        };
        EditBootOptionsController.prototype.onSubmit = function () {
            var bootOptionsSpec = {
                bootDeviceKey: this.selectedOption.key,
                rebootAfterApply: false
            };
            this.mutationService.apply(this.hostId, "com.vmware.vsphere.client.host.config.BootDeviceConfigSpec", bootOptionsSpec, this.i18nService.getString("HostUi", "bootDevice.operationName"));
            return true;
        };
        EditBootOptionsController.$inject = ["$scope", "dataService", "mutationService", "i18nService"];
        return EditBootOptionsController;
    }());
    angular.module("com.vmware.vsphere.client.host")
        .controller("EditBootOptionsController", EditBootOptionsController);
})(host_ui || (host_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditHardwareProcessorsController',
         EditHardwareProcessorsController);

   EditHardwareProcessorsController.$inject = ['$scope', 'mutationService', 'resourceService'];

   function EditHardwareProcessorsController($scope, mutationService, resourceService) {
      var self = this;
      self.hostId = $scope._route.objectId;
      self.viewData = null;

      function getData() {
         resourceService.getResourceInfo(self.hostId, 'processorGeneralConfig')
               .then(function(data) {
                  self.viewData = data.properties;
               });

      }

      getData();

      $scope.modalOptions.onSubmit = function() {
         var hyperthreadingSpec = {
            hyperthreading: {
               htOnRestart: self.hyperthreadingAvailable
            }
         };
         mutationService.applyByPropName(self.hostId, 'processorGeneralConfig', hyperthreadingSpec);
         return true;
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('HardwareProcessorsController', HardwareProcessorsController);

   HardwareProcessorsController.$inject =
         ['$scope', 'hardwareProcessorsService'];

   function HardwareProcessorsController($scope, hardwareService) {
      this.hostId = $scope._route.objectId;
      this.watchForObjects = [this.hostId];
      var generalSettingsObject = hardwareService.getGeneralSettingsOptions(this.hostId);
      this.generalHeaderOptions = generalSettingsObject.headerOptions;
      this.generalSettingsViewOptions = generalSettingsObject.settingsViewOptions;

      var systemSettingsObject = hardwareService.getSystemSettingsOptions(this.hostId);
      this.systemHeaderOptions = systemSettingsObject.headerOptions;
      this.systemSettingsViewOptions = systemSettingsObject.settingsViewOptions;
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('hardwareProcessorsService',
         HardwareProcessorsService);

   HardwareProcessorsService.$inject = ['i18nService'];

   function HardwareProcessorsService(i18nService) {

      /**
       * Property value format function - in some cases the property value is not a string and it requires some custom
       * formatting.
       * @param propName
       *    Name of the property.
       * @param contentValue
       *    Raw value of the property - might be a string or an object.
       */
      function formatPropertyValue(propName, contentValue) {
         if (propName === 'hyperthreading') {
            return formatHyperthreadingValue(contentValue);
         }

         // for all the properties that there is no need for custom formatting - just return the raw content value
         return contentValue;
      }


      function getGeneralSettingsOptions(hostId) {

         var headerOptions = getHeaderOptions('processorConfig.generalConfiguration', hostId);
         headerOptions.actions.push({
            actionUid: 'vsphere.core.host.actions.editProcessorGeneralConfig',
            customLabel: i18nService.getString('HostUi',
                  'processorConfig.editGeneralConfiguration')
         });

         return {
            headerOptions: headerOptions,
            settingsViewOptions: getSettingsViewOptions('processorGeneralConfig', hostId)
         };
      }

      function getSystemSettingsOptions(hostId) {

         var headerOptions = getHeaderOptions('processorConfig.systemConfiguration', hostId);
         headerOptions.actions.push({
            actionUid: 'vsphere.core.host.actions.editBootOptions',
            customLabel: i18nService.getString('HostUi',
                  'processorConfig.bootOptions')
         });

         return {
            headerOptions: headerOptions,
            settingsViewOptions: getSettingsViewOptions('processorSystemConfig', hostId)
         };
      }

      function formatHyperthreadingValue(contentValue) {
         if (!contentValue) {
            return null;
         }

         // is hyperthreading available
         var hyperAvailable = contentValue.htAvailable;
         if (!hyperAvailable) {
            return i18nService.getString('HostUi', 'notAvailable');
         }

         // current hyperthreading value
         var hyper = contentValue.ht;
         // value on restart (of the host)
         var hyperOnRestart = contentValue.htOnRestart;

         var enabledLabel = i18nService.getString('HostUi', 'enabled');
         var disabledLabel = i18nService.getString('HostUi', 'disabled');
         if (hyper === hyperOnRestart) {
            return hyper ? enabledLabel : disabledLabel;
         }

         var onRestartLabel = hyperOnRestart ?
               i18nService.getString('HostUi', 'onRestartFormat', enabledLabel) :
               i18nService.getString('HostUi', 'onRestartFormat', disabledLabel);

         return hyper ?
               i18nService.getString('HostUi', 'processorConfig.hyperThreadingFormat', enabledLabel, onRestartLabel) :
               i18nService.getString('HostUi', 'processorConfig.hyperThreadingFormat', disabledLabel, onRestartLabel);
      }

      function formatCertificateStatusValue(statusKey) {
         var nonNullStatusKey = statusKey || 'unknown';
         return i18nService.getString('HostUi', 'certificate.status.' + nonNullStatusKey);
      }

      function getHeaderOptions(titleProperty, hostId) {
         return {
            title: i18nService.getString(
                  'HostUi',
                  titleProperty
            ),
            actions: [],
            objectIds: [hostId]
         };
      }

      function getSettingsViewOptions(propertyName, hostId) {
         return {
            objectId: hostId,
            propertyName: propertyName,
            formatValueCallback: formatPropertyValue,
            type: 'stack'
         };
      }

      return {
         formatPropertyValue :formatPropertyValue,
         getGeneralSettingsOptions : getGeneralSettingsOptions,
         getSystemSettingsOptions: getSystemSettingsOptions
      };

}})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular
      .module('com.vmware.vsphere.client.host')
      .controller('RebootConfirmationController', RebootConfirmationController);

   RebootConfirmationController.$inject = ['$scope', 'confirmationDialogWithReasonService', 'dataService', 'i18nService'];

   function RebootConfirmationController(scope, dialogService, dataService, i18nService) {
      var self = this;
      var hostIds = scope.modalOptions.dialogData.availableTargets;

      scope.modalOptions.onSubmit = dialogService.onOKClicked.bind(this, getReason, getOnlyMmHosts, 'reboot',
          scope.modalOptions, hostIds, getMmHosts);

      self.loading = true;
      self.inMaintenanceMode = true;
      self.onlyMmHosts = false;

      if (hostIds.length > 1) {
         self.multipleHosts = true;
         self.onlyMmHosts = true;
         self.hostsNotInMm = [];
         self.hostsInMm = [];
         self.selectedHosts = [];
         dialogService.fetchHostsRebootData(hostIds, updateMultipleControllerCallback);
         scope.modalOptions.size = 'lg';
         self.showGuardRail = true;
      } else {
         self.hostId = hostIds[0];
         dataService.getData(self.hostId,
               'com.vmware.vsphere.client.h5.host.model.HostRebootData')
               .then(function(result) {
                  if (result) {
                     updateControllerCallback(result);
                  }
               });
      }


      function updateControllerCallback(result) {
         self.hostName = result.hostName;
         self.clusterMor = result.clusterMor;
         self.isVsanSupportedAndEnabled = !!result.isVsanSupportedAndEnabled;
         self.inMaintenanceMode = result.inMaintenanceMode;
         // resize the dialog due to large dialog content
         if (self.isVsanSupportedAndEnabled) {
            scope.modalOptions.size = 'lg';
         }

         self.showGuardRail = !self.inMaintenanceMode;
         self.loading = false;
      }

      function updateMultipleControllerCallback(hostName, inMaintenanceMode, vSanEnabled,
            hostId, loading) {
         self.isVsanSupportedAndEnabled = self.isVsanSupportedAndEnabled
               ? self.isVsanSupportedAndEnabled : vSanEnabled;
         if (!inMaintenanceMode) {
            self.inMaintenanceMode = inMaintenanceMode;
            self.hostsNotInMm.push(hostName);
            self.selectedHosts.push({
               label: i18nService.getString('HostUi', 'rebootHostNotInMaintenanceMode', hostName),
               iconClass: 'vsphere-icon-host'
            });
         } else {
            self.hostsInMm.push(hostId);
            self.selectedHosts.push({
               label: hostName,
               iconClass: 'vsphere-icon-host-maintenance'
            });
         }

         self.loading = loading;
      }

      function getReason() {
         return self.rebootReason;
      }

      function getOnlyMmHosts() {
         return self.onlyMmHosts;
      }

      function getMmHosts() {
         return self.hostsInMm;
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('refreshCertificateService',
         RefreshCertificateService);
   RefreshCertificateService.$inject = ['mutationService'];

   function RefreshCertificateService(mutationService) {

      function refreshCertificate(hostId) {

         mutationService.applyOnMultiEntity(
               [hostId],
               'com.vmware.vsphere.client.host.certificates.HostCertificateOpSpec',
               {certOpType:'refresh'}
         );
      }
      function refreshCaCertificate(hostId){
         mutationService.applyOnMultiEntity(
               [hostId],
               'com.vmware.vsphere.client.host.certificates.HostCertificateOpSpec',
               {certOpType:'refreshCACertificates'}
         );
      }

      return {
         refreshCertificate: refreshCertificate,
         refreshCaCertificate:refreshCaCertificate
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('AddExceptionUsersController',
         AddExceptionUsersController);

   AddExceptionUsersController.$inject = ['$scope'];

   function AddExceptionUsersController($scope) {

      var self = this;
      self.users = '';

      self.parseUsers = function() {
         var splittedUsers = _.filter(self.users.split(';'), function(user) {return user !== '';});

         return _.map(splittedUsers, function(item) {
            return item.replace(/localhost\//i, '');
         });
      }.bind(this);

      $scope.modalOptions.onSubmit = function() {
         var existingExceptionUsers = $scope.modalOptions.dialogData.model.exceptionUsers;
         $scope.modalOptions.dialogData.model.exceptionUsers =
               _.union(existingExceptionUsers, self.parseUsers());
         $scope.modalOptions.dialogData.datagridOptions.data =
               $scope.modalOptions.dialogData.model.exceptionUsers;
         $scope.modalOptions.dialogData.gridWidget.refresh();
         return true;
      };
   }
})();

var host_ui;
(function (host_ui) {
    var EditEncryptionModeController = (function () {
        function EditEncryptionModeController($scope, i18nService, dataService, mutationService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.dataService = dataService;
            this.mutationService = mutationService;
            this.encryptionModes = [];
            $scope.modalOptions.onSubmit = this.onSubmit.bind(this);
            this.hostId = $scope._route.objectId;
            this.encryptionModes = [
                this.getModeByKey("safe"),
                this.getModeByKey("incapable"),
            ];
            this.getData();
        }
        EditEncryptionModeController.prototype.getData = function () {
            var _this = this;
            this.dataService.getProperties(this.hostId, [
                "runtime.cryptoState"
            ]).then(function (result) {
                if (result) {
                    if (result["runtime.cryptoState"] && result["runtime.cryptoState"] === "safe") {
                        _this.isEncryptionModeEnabled = true;
                        _this.encryptionMode = _this.getModeByKey("safe");
                    }
                    else {
                        _this.isEncryptionModeEnabled = false;
                        _this.encryptionMode = _this.getModeByKey("incapable");
                    }
                }
            });
        };
        EditEncryptionModeController.prototype.onSubmit = function () {
            if (!this.isEncryptionModeEnabled) {
                this.mutationService.apply(this.hostId, "com.vmware.vsphere.client.host.config.HostEncryptionModeSpec", { "encryptionMode": this.encryptionMode.key });
            }
            return true;
        };
        EditEncryptionModeController.prototype.getModeByKey = function (key) {
            return ({
                "safe": {
                    key: "safe",
                    label: this.i18nService.getString("HostUi", "hostEncryption.mode.enabled")
                },
                "incapable": {
                    key: "incapable",
                    label: this.i18nService.getString("HostUi", "hostEncryption.mode.disabled")
                }
            }[key]);
        };
        EditEncryptionModeController.$inject = ["$scope", "i18nService", "dataService", "mutationService"];
        return EditEncryptionModeController;
    }());
    angular.module("com.vmware.vsphere.client.host")
        .controller("editEncryptionModeController", EditEncryptionModeController);
})(host_ui || (host_ui = {}));



(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditExceptionUsersController', EditExceptionUsersController);

   EditExceptionUsersController.$inject = ['$scope', 'i18nService', 'vuiConstants', 'clarityModalService'];

   function EditExceptionUsersController($scope, i18nService, vuiConstants,clarityModalService) {
      var self = this;
      self.model = $scope.manager.getExceptionUsersPageModel();
      self.gridWidget = null;

      $scope.$on('kendoWidgetCreated', function(event, widget) {
         if (!widget || widget.constructor !== kendo.ui.Grid) {
            return;
         }

         self.gridWidget = widget;
      });

      var removeItemsButton = {
         actionId: 'removeItems',
         tooltipText: i18nService.getString('HostUi', 'removeExceptionUser.action.description'),
         label: i18nService.getString('HostUi', 'removeExceptionUser.action.label'),
         enabled: self.model.exceptionUsers,
         iconClass: 'vx-icon-removeIcon',
         onClick: removeSelectedItem
      };

      var addExceptionUsersButton = {
         actionId: 'addExceptionUsers',
         tooltipText: i18nService.getString('HostUi', 'addExceptionUser.action.description'),
         label: i18nService.getString('HostUi', 'addExceptionUser.action.label'),
         enabled: true,
         iconClass: 'vx-icon-addIcon',
         onClick: addExceptionUser
      };

      $scope.$watchCollection(function() {
         return self.datagridOptions.selectedItems;
      }, function() {
         if(self.datagridOptions.selectedItems && self.datagridOptions.selectedItems.length > 0){
            removeItemsButton.enabled = true;
         }else {
            removeItemsButton.enabled = false;
         }
      });

      self.datagridOptions = {
         columnDefs: [
            {
               displayName: i18nService.getString('HostUi', 'editExceptionUsersView.colHeader.User'),
               field: 'exceptionUsers',
               template : function(dataItem) {
                  return dataItem;
               }
            }
         ],
         data : self.model.exceptionUsers ? self.model.exceptionUsers : [],
         selectionMode: vuiConstants.grid.selectionMode.SINGLE,
         selectedItems: [],
         actionBarOptions: {
            actions: [addExceptionUsersButton, removeItemsButton]
         },
         resizable: false,
         height: '240px'
      };

      function addExceptionUser(){

         var modalOptions = {
            title : i18nService.getString('HostUi','addExceptionUser.action.label'),
            contentTemplate: 'host-ui/resources/host/views/settings/securityProfile/addExceptionUserView.html',
            dialogData: {
               model: self.model,
               gridWidget: self.gridWidget,
               datagridOptions: self.datagridOptions
            },
            defaultButton: 'submit'

         };

         clarityModalService.openOkCancelModal(modalOptions);
      }

      function removeSelectedItem(){
         var selectedItem = self.datagridOptions.selectedItems[0];
         if(selectedItem){
            self.datagridOptions.data = _.filter(self.model.exceptionUsers, function(item){
               return selectedItem !== item;
            });

            self.model.exceptionUsers = self.datagridOptions.data;
         }
         // refresh gird with kendo
         if (self.gridWidget) {
            self.gridWidget.refresh();
         }
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditImageProfileAcceptanceLevelController',
         ['$scope','$rootScope',
            'mutationService',
            'dataService',
            'i18nService',
            'imageProfileEvents',
            EditImageProfileAcceptanceLevelController]);

   function EditImageProfileAcceptanceLevelController($scope, $rootScope,
         mutationService,
         dataService,
         i18nService,
         imageProfileEvents) {

      var objectId = $scope._route.objectId;
      var self = this;

      $scope.modalOptions.onSubmit = onSubmit;

      self.dialogSubtitle = i18nService.getString('HostUi', 'edit.imageProfile.desc');

      self.imageAcceptanceLevelOptions = getOptions();
      self.changeEvent = false;

      getViewData();

      function getViewData() {
         self.loading = true;
         dataService.getProperties(objectId, ['imageAcceptanceLevel'])
               .then(function(result) {
                  self.selectedOption = getOptionObjectByValue(result.imageAcceptanceLevel);
                  self.loading = false;
               });
      }

      $scope.$watch(function() {
         return self.selectedOption;
      }, function(newValue, oldValue) {
         if (newValue !== oldValue) {
            self.changeEvent = true;
         }
      }, true);

      function onSubmit() {
         if (!self.changeEvent) {
            return true;
         }

         mutationService.apply(objectId,
               "com.vmware.vsphere.client.host.config.ImageProfileAcceptanceLevelSpec",
               {
                  acceptanceLevel: self.selectedOption.value
               },
               i18nService.getString('HostUi', 'acceptanceLevel.operation')).then(function(operationResult) {
            if (!operationResult.error) {
               $rootScope.$emit(imageProfileEvents.UPDATE_HOST_IMAGE_PROFILE_ACCEPTANCE_LEVEL);
            }
         });

         return true;
      }

      function getOptions() {
         return [{
            label: i18nService.getString('HostUi', 'acceptanceLevel.vmware_certified'),
            value: 'vmware_certified'
         }, {
            label: i18nService.getString('HostUi', 'acceptanceLevel.vmware_accepted'),
            value: 'vmware_accepted'
         }, {
            label: i18nService.getString('HostUi', 'acceptanceLevel.partner'),
            value: 'partner'
         }, {
            label: i18nService.getString('HostUi', 'acceptanceLevel.community'),
            value: 'community'
         }];
      }

      function getOptionObjectByValue(value) {
         var options = getOptions();

         var result = _.filter(options, function(option) {
            return option.value === value;
         });

         return result ? result[0] : null;
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('EditLockdownModeController',
         EditLockdownModeController);

   EditLockdownModeController.$inject = ['$scope'];

   function EditLockdownModeController($scope) {
      var self = this;
      self.model = $scope.manager.getLockdownModePageModel();
   }
})();

var host_ui;
(function (host_ui) {
    var EncryptionMode = (function () {
        function EncryptionMode() {
            this.controllerAs = "ctrl";
            this.bindings = {
                header: "<",
                hostEncryption: "<"
            };
            this.templateUrl =
                "host-ui/resources/host/views/settings/securityProfile/encryptionModeTemplate.html";
            this.controller = EncryptionModeController;
        }
        EncryptionMode.$inject = [
            "i18nService"
        ];
        return EncryptionMode;
    }());
    host_ui.EncryptionMode = EncryptionMode;
    var EncryptionModeController = (function () {
        function EncryptionModeController(i18nService) {
            this.i18nService = i18nService;
            this.i18n = i18nService.getString.bind(i18nService);
            this.subtitle = this.i18nService.getString("HostUi", "hostEncryption.description");
            this.encryptionLabel = this.i18nService.getString("HostUi", "hostEncryption.mode.label");
        }
        EncryptionModeController.$inject = [
            "i18nService"
        ];
        return EncryptionModeController;
    }());
    host_ui.EncryptionModeController = EncryptionModeController;
    angular.module("com.vmware.vsphere.client.host")
        .component("encryptionMode", new EncryptionMode());
})(host_ui || (host_ui = {}));



(function() {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:imageProfileEvents
    *
    * @description
    *    Represents image profile events for activity notifications.
    *
    *    List of available constants
    *
    *    - **`UPDATE_HOST_IMAGE_PROFILE_ACCEPTANCE_LEVEL`** : The event has to be dispatched when
    *    the host image profile acceptance level has been changed.
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('imageProfileEvents', {
            UPDATE_HOST_IMAGE_PROFILE_ACCEPTANCE_LEVEL: 'updateHostImageProfileAcceptanceLevel'
         });
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('SecurityProfileController', SecurityProfileController);

   SecurityProfileController.$inject = ['$scope', '$rootScope', 'dataService',
      'i18nService', 'imageProfileEvents'];

   function SecurityProfileController($scope, $rootScope, dataService,
         i18nService, imageProfileEvents) {

      var objectId = $scope._route.objectId;
      $scope.i18nService = i18nService;
      this.objectsToWatch = [objectId];
      this.liveRefreshProperties = [
         'config.lockdownMode',
         'config.service.service'
      ];

      this.headerOptions = {
         title: getString('securityProfile.lockdownMode.label'),
         actions: [{
            actionUid: 'vsphere.core.host.actions.editLockdownMode',
            customLabel: getString('settings.edit')
         }],
         objectId: objectId
      };

      this.imageAcceptanceLevelHeaderOptions = {
         title: getString('imageProfileAcceptance.label'),
         actions: [{
            actionUid: 'vsphere.core.host.actions.editImageProfile',
            customLabel: getString('imageProfile.action.label')
         }],
         objectId: objectId
      };

      this.encryptionMode = {
         title: getString('hostEncryption.label'),
         actions: [{
            actionUid: 'vsphere.core.host.actions.editEncryptionMode',
            customLabel: getString('settings.edit')
         }],
         objectId: this.objectsToWatch
      };

      this.setSecurityProfileProperties = function(data) {
         this.lockdownMode = getString(lockdownKeyify(data.lockdownMode));
         this.exceptionUsers = data.exceptionUsers;
         this.showExceptionUsers = data.isHostAccessManagerAvailable;
         this.isHostEncryptionCapable = !!data.cryptoState;
         this.hostEncryption =
               data.cryptoState && data.cryptoState === 'safe' ?
                     getString('hostEncryption.mode.enabled') : getString('hostEncryption.mode.disabled');
      };

      this.fetchViewData = function() {
         dataService.getProperties(objectId, ['securityProfileSummaryData']).then(function(data) {
            if (data && data.securityProfileSummaryData) {
               this.setSecurityProfileProperties(data.securityProfileSummaryData);
               this.getImageAcceptanceLevel(data.securityProfileSummaryData);
            }
         }.bind(this));
      };

      var updateImageAcceptanceLevelListener = $rootScope.$on(
            imageProfileEvents.UPDATE_HOST_IMAGE_PROFILE_ACCEPTANCE_LEVEL, function(event, data) {
               this.getImageAcceptanceLevel();
            }.bind(this));

      // $scope $destroy
      $scope.$on('$destroy', function() {
         updateImageAcceptanceLevelListener();
      });


      this.getImageAcceptanceLevel = function(data) {
         this.imageAcceptanceLevel = getString('acceptanceLevel.nameLoadingPlaceholder');
         if (!data || !data.imageAcceptanceLevel) {
            dataService.getProperties(objectId, [
               'imageAcceptanceLevel'
            ]).then(function(result) {
               if (result) {
                  this.imageAcceptanceLevel = getString(
                        getAcceptanceLevelLocalizationKey(result.imageAcceptanceLevel));
               }
            }.bind(this));
         } else {
            this.imageAcceptanceLevel = getString(
                  getAcceptanceLevelLocalizationKey(data.imageAcceptanceLevel));
         }
      };

      function getString(key) {
         return i18nService.getString('HostUi', key);
      }

      this.fetchViewData();

      function lockdownKeyify(mode) {
         return {
            'lockdownNormal': 'lockdownView.mode.normal.label',
            'lockdownStrict': 'lockdownView.mode.strict.label',
            'lockdownDisabled': 'lockdownView.mode.disabled.label'
         }[mode];
      }

      function getAcceptanceLevelLocalizationKey(mode) {
         return {
            'vmware_certified': 'acceptanceLevel.vmware_certified',
            'vmware_accepted': 'acceptanceLevel.vmware_accepted',
            'partner': 'acceptanceLevel.partner',
            'community': 'acceptanceLevel.community'
         }[mode];
      }
   }
})();

(function() {
   'use strict';

   /**
    * Factory that handles Host Security Profile edit related operations.
    * Builds all the edit Host Security Profile dialog page models and submits the
    * edited data to the server.
    */
   angular.module('com.vmware.vsphere.client.host')
         .factory('SecurityProfileDialogManager', SecurityProfileDialogManager);

   SecurityProfileDialogManager.$inject = ['i18nService', 'mutationService'];

   function SecurityProfileDialogManager(i18nService, mutationService) {

      return function SecurityProfileDialogManager(securityProfileData, securityProfileDialogOptions) {

         var lockdownModeDef, exceptionUsersDef, isChanged = false;

         createPages();

         return {
            getPageDefinitions: getPageDefinitions,
            getLockdownModePageModel: getLockdownModePageModel,
            getExceptionUsersPageModel: getExceptionUsersPageModel,
            submit: submit
         };

         function createPages() {
            // page definitions have properties like page, model, etc.
            lockdownModeDef = {
               page: {
                  title: i18nService.getString('HostUi', 'editLockdownView.title'),
                  contentUrl: 'host-ui/resources/host/views/settings/securityProfile/editLockdownModeView.html'
               }
            };
            exceptionUsersDef = {
               page: {
                  title: i18nService.getString('HostUi', 'editExceptionUsersView.title'),
                  contentUrl: 'host-ui/resources/host/views/settings/securityProfile/editExceptionUsersView.html'
               }
            };
         }

         function getPageDefinitions() {
            var pages = [];

            pages.push(lockdownModeDef.page);
            if (securityProfileData.isHostAccessManagerAvailable) {
               pages.push(exceptionUsersDef.page);
            }
            return pages;
         }

         function getLockdownModePageModel() {
            if (!lockdownModeDef.model) {
               lockdownModeDef.model = {
                  lockdownMode: securityProfileData.lockdownMode,
                  hostAccessManagerAvailable: securityProfileData.isHostAccessManagerAvailable
               };
            }
            return lockdownModeDef.model;
         }

         function getExceptionUsersPageModel() {
            if (!exceptionUsersDef.model) {
               exceptionUsersDef.model = {
                  exceptionUsers: securityProfileData.exceptionUsers
               };
            }
            return exceptionUsersDef.model;
         }

         function submit() {
            // isChanged - checks if there is a change in either lockdown mode or exception user or both,
            // otherwise don't call the mutation op
            var hostLockdownModeUpdateSpec = {};
            if (lockdownModeDef.model && lockdownModeDef.model.lockdownMode !== securityProfileData.lockdownMode) {
               hostLockdownModeUpdateSpec.lockdownMode = lockdownModeDef.model.lockdownMode;
               isChanged = true;
            }

            var hostId = securityProfileDialogOptions.actionDetails.availableTargets[0];

            // this depends on the host version
            if (securityProfileData.isHostAccessManagerAvailable) {
               if (exceptionUsersDef.model && exceptionUsersDef.model.exceptionUsers !== securityProfileData.exceptionUsers) {
                  hostLockdownModeUpdateSpec.exceptionUsers = exceptionUsersDef.model.exceptionUsers;
                  isChanged = true;
               }
            }

            if (isChanged) {
               mutationService.apply(hostId,
                     "com.vmware.vsphere.client.host.config.HostLockdownModeUpdateSpec",
                     hostLockdownModeUpdateSpec
               );
            }

            return true;
         }
      };
   }
})();

(function() {
   'use strict';

   /**
    * Opens Edit Security Profile dialog as a multi page dialog.
    */
   angular.module('com.vmware.vsphere.client.host')
         .service('securityProfileDialogService', securityProfileDialogService);

   securityProfileDialogService.$inject = ['dataService', '$rootScope', 'i18nService',
      'vxMultiPageDialogService', 'SecurityProfileDialogManager'];

   function securityProfileDialogService(dataService, $rootScope, i18nService,
         vxMultiPageDialogService, SecurityProfileDialogManager) {

      return {
         show: show
      };

      function show(hostId, actionEval) {
         var securityData = {};
         var dialogScope = $rootScope.$new();
         dialogScope.dialogOptions = {};

         var dialogManager = new SecurityProfileDialogManager(securityData, dialogScope.dialogOptions);
         dialogScope.manager = dialogManager;

         _.extend(dialogScope.dialogOptions, {
            iconClass: actionEval.action.icon,
            actionDetails: {
               actionEval: actionEval,
               availableTargets: [hostId]
            },
            show: true,
            loading: true, // this prevents the dialog from being initialized
                           // until ha data is loaded
            loadingMessage: i18nService.getString('CommonUi', 'wizard.loading'),
            confirmOptions: {
               onClick: dialogManager.submit
            },
            resizable: true,
            draggable: true,
            maximizable: true,
            pages: dialogManager.getPageDefinitions(),
            title: i18nService.getString('HostUi', 'securityProfile.lockdownMode', '')
         });

         var options = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vxMultiPageDialogService(options);

         dataService.getProperties(hostId, ['lockdownMode', 'exceptionUsers', 'isHostAccessManagerAvailable', 'name']).then(function(data) {
            _.extend(securityData, data);
            dialogScope.dialogOptions.pages = dialogManager.getPageDefinitions();
            dialogScope.dialogOptions.title = i18nService.getString('HostUi', 'securityProfile.lockdownMode', securityData.name);
            dialogScope.dialogOptions.loading = false;
         });
      }
   }
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('ShutdownConfirmationController', ShutdownConfirmationController);

   ShutdownConfirmationController.$inject = ['$scope', 'confirmationDialogWithReasonService'];

   function ShutdownConfirmationController(scope, dialogService) {
      var self = this;
      var hostIds = scope.modalOptions.dialogData.availableTargets;

      scope.modalOptions.onSubmit = dialogService.onOKClicked.bind(this, getReason, getOnlyMmHosts, 'shutdown',
          scope.modalOptions, hostIds, getMmHosts);

      self.loading = true;
      self.inMaintenanceMode = true;
      self.onlyMmHosts = false;

      if (hostIds.length > 1) {
         self.multipleHosts = true;
         self.onlyMmHosts = true;
         self.hostsNotInMm = [];
         self.hostsInMm = [];
         self.hostsNames = [];
         dialogService.fetchHostsNameAndMaintenanceModeStatus(hostIds, updateMultipleControllerCallback);
      } else {
         dialogService.fetchHostNameAndMaintenanceModeStatus(hostIds, updateControllerCallback);
      }


      function updateControllerCallback(hostName, inMaintenanceMode) {
         self.loading = false;
         self.hostName = hostName;
         self.inMaintenanceMode = inMaintenanceMode;
      }

      function updateMultipleControllerCallback(hostName, inMaintenanceMode, hostId, loading) {
         self.loading = loading;
         self.hostsNames.push(hostName);

         if (!inMaintenanceMode) {
            self.inMaintenanceMode = inMaintenanceMode;
            self.hostsNotInMm.push(hostName);
         } else {
            self.hostsInMm.push(hostId);
         }
      }

      function getReason() {
         return self.shutdownReason;
      }

      function getOnlyMmHosts() {
         return self.onlyMmHosts;
      }

      function getMmHosts() {
         return self.hostsInMm;
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('SystemResourceReservationsController', SystemResourceReservationsController);

   SystemResourceReservationsController.$inject = ['$scope', 'dataService', 'i18nService'];

   function SystemResourceReservationsController($scope, dataService, i18nService) {
      var self = this;
      var objectId = $scope._route.objectId;
      var headerOptions = {
         title: i18nService.getString('HostUi', 'systemResource.reservation'),
         objectId: objectId
      };

      self.headerOptions = headerOptions;
      self.cpuAllocation = null;
      self.memoryAllocation = null;

      self.fetchViewData = function (){

         dataService.getProperties($scope._route.objectId, ['systemResourceReservations'])
               .then(function (result) {
                     self.cpuAllocation = result.systemResourceReservations.cpuAllocation;
                     self.memoryAllocation = result.systemResourceReservations.memoryAllocation;
               });
      };

      self.fetchViewData();
   }
})();
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('editSystemSwapSettingsController',
               EditSystemSwapSettingsController);

   EditSystemSwapSettingsController.$inject = [
      '$scope',
      'dataService',
      'systemSwapConstants', 'mutationService'];

   function EditSystemSwapSettingsController($scope,
                                             dataService,
                                             systemSwapConstants,
                                             mutationService) {
      var self = this;
      var hostId = $scope.modalOptions.dialogData.availableTargets[0];
      self.systemSwapSettings = {
         canUseDatastore: false,
         canUseHostCache: false,
         canUseHostSwapFile: false,
         selectedDatastore: null
      };

      $scope.modalOptions.onSubmit = updateSystemSwapConfiguration;

      getSystemSwapData();

      function getSystemSwapData() {
         dataService.getProperties(hostId,
               ['config.systemSwapConfiguration', 'availableDatastoreNames'])
               .then(function(data) {
                  self.datastoreNames = data.availableDatastoreNames;
                  initCheckboxValues(data['config.systemSwapConfiguration']);
               });
      }

      function updateSystemSwapConfiguration() {
         mutationService.apply(hostId,
               'com.vmware.vim.binding.vim.host.SystemSwapConfiguration',
               createSystemSwapConfiguration()
         );

         return true;
      }

      function createSystemSwapConfiguration() {
         return {
            '_type': 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration',
            option: getOptions()
         };
      }

      function getOptions() {
         var arrayToReturn = [];
         if (self.systemSwapSettings.canUseDatastore) {
            var option = createSwapSystemOption(systemSwapConstants.systemSwapType.DATASTORE,
                  arrayToReturn.length
            );
            option.datastore = self.systemSwapSettings.selectedDatastore;
            arrayToReturn.push(option);
         }

         if (self.systemSwapSettings.canUseHostCache) {
            arrayToReturn.push(
                  createSwapSystemOption(systemSwapConstants.systemSwapType.HOST_CACHE,
                        arrayToReturn.length
                  )
            );
         }

         if (self.systemSwapSettings.canUseHostSwapFile) {
            arrayToReturn.push(
                  createSwapSystemOption(systemSwapConstants.systemSwapType.HOST_SWAP_LOCATION,
                        arrayToReturn.length
                  )
            );
         }

         if (arrayToReturn.length === 0) {
            arrayToReturn.push(
                  createSwapSystemOption(systemSwapConstants.systemSwapType.DISABLED,
                        arrayToReturn.length
                  )
            );
         }
         return arrayToReturn;
      }

      function createSwapSystemOption(type, key) {
         return {
            '_type': type,
            key: key
         };
      }

      function initCheckboxValues(systemSwapConfig) {
         if (systemSwapConfig === null) {
            return;
         }
         _.each(systemSwapConfig.option, function(option) {
            switch (option['_type']) {
               case systemSwapConstants.systemSwapType.DATASTORE:
                  self.systemSwapSettings.canUseDatastore = true;
                  self.systemSwapSettings.selectedDatastore = option.datastore;
                  break;
               case systemSwapConstants.systemSwapType.HOST_CACHE:
                  self.systemSwapSettings.canUseHostCache = true;
                  break;
               case systemSwapConstants.systemSwapType.HOST_SWAP_LOCATION:
                  self.systemSwapSettings.canUseHostSwapFile = true;
                  break;
               default:
                  break;
            }
         });

         if (!self.systemSwapSettings.selectedDatastore && !_.isEmpty(self.datastoreNames)) {
            self.systemSwapSettings.selectedDatastore = self.datastoreNames[0];
         }
      }
   }
})();

(function() {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:systemSwapConstants
    *
    * @description
    *    Represents vim.host.Service.Policy enum values.
    *
    *    List of available constants
    *    - systemSwapType - different SystemSwapConfiguration option types.
    *        - **`DATASTORE`**
    *        - **`HOST_CACHE`**
    *        - **`HOST_SWAP_LOCATION`**
    *        - **`DISABLED`**
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('systemSwapConstants', {
            systemSwapType: {
               DATASTORE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$DatastoreOption',
               HOST_CACHE: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$HostCacheOption',
               HOST_SWAP_LOCATION: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$HostLocalSwapOption',
               DISABLED: 'com.vmware.vim.binding.vim.host.SystemSwapConfiguration$DisabledOption'
            }
         });
})();

/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('SystemSwapSettingsController', SystemSwapSettingsController);

   SystemSwapSettingsController.$inject = ['$rootScope', 'dataService', 'i18nService',
         'systemSwapConfigurationConstants', '$q'];

   function SystemSwapSettingsController($rootScope, dataService, i18nService,
         constants, $q) {
      this.loading = true;
      var objectId = $rootScope._route.objectId;
      this.headerOptions = {
         title: i18nService.getString('HostUi', 'userWorldSwap.header'),
         objectId: objectId,
         actions: [{
            actionUid: 'vsphere.core.host.actions.editSystemSwap',
            customLabel: i18nService.getString('Common', 'settingsView.defaultEditActionLabel')
         }]
      };
      this.watchForObjects = [objectId];
      this.systemSwapConfigurationMessages = [];
      this.liveRefreshProperties = ['config.systemSwapConfiguration.option'];

      this.getViewData = function() {
         dataService.getProperties(objectId, ['config.systemSwapConfiguration'])
               .then(function(data) {
                  this.processResponseData(data);
                  this.loading = false;
               }.bind(this))
               .catch(function(error) {
                  this.loading = false;
                  $q.reject(error);
               }.bind(this));
      };

      this.processResponseData = function(data) {
         var systemSwapConfig = data['config.systemSwapConfiguration'];
         this.systemSwapConfigurationMessages = [];
         if (!systemSwapConfig) {
            return;
         }
         _.each(systemSwapConfig.option, function(option) {
            switch (option._type) {
               case constants.systemSwapConfigurationOptionType.HOST_CACHE_OPTION_TYPE:
                  this.systemSwapConfigurationMessages.push(
                        i18nService.getString('HostUi', 'userWorldSwap.hostCache')
                  );
                  break;
               case constants.systemSwapConfigurationOptionType.HOST_LOCAL_SWAP_OPTION_TYPE:
                  this.systemSwapConfigurationMessages.push(
                        i18nService.getString('HostUi', 'userWorldSwap.localDatastore')
                  );
                  break;
               case constants.systemSwapConfigurationOptionType.DATASTORE_OPTION_TYPE:
                  this.systemSwapConfigurationMessages.push(
                        i18nService.getString('HostUi', 'userWorldSwap.userSpecifiedDatastore', option.datastore)
                  );
                  break;
               case constants.systemSwapConfigurationOptionType.DISABLED_TYPE:
                  this.systemSwapConfigurationMessages.push(
                        i18nService.getString('HostUi', 'userWorldSwap.disabled', option.datastore)
                  );
                  break;
               default:
                  break;
            }
            this.systemSwapConfigurationMessages = _.uniq(this.systemSwapConfigurationMessages);
         }, this);
      };

      this.getViewData();
   }
})();

(function() {
   'use strict';

   /**
    * Host edit time configuration controller.
    */
   angular.module('com.vmware.vsphere.client.host')
         .controller('EditTimeConfigurationController', EditTimeConfigurationController);

   EditTimeConfigurationController.$inject =
         ['$scope', 'dataService', 'mutationService', 'editTimeConfigurationService',
         'i18nService', 'vuiConstants'];

   function EditTimeConfigurationController($scope, dataService,
         mutationService, timeConfigService, i18nService, vuiConstants) {
      var self = this;

      self.objectId = $scope.modalOptions.dialogData.availableTargets[0];
      self.startService = false;

      setPageBusy(true);
      $scope.modalOptions.isAlertClosed = true;
      $scope.modalOptions.defaultButton = 'submit';
      $scope.modalOptions.onSubmit = submit;
      self.policyDropdownList = timeConfigService.getPolicyDropdownList();

      function submit() {
         $scope.modalOptions.alerts = [];
         $scope.modalOptions.isAlertClosed = true;

         self.initDataObject.date = moment(self.initDataObject.dateObj).format('YYYY-MM-DD');
         var timeConfigSpec = timeConfigService.createTimeConfigSpec(
               $scope.modalOptions,
               self.initDataObject,
               self.startService);

         if (self.startService && !self.initDataObject.ntpServers) {
            $scope.modalOptions.alerts.push({
               type: vuiConstants.validationBanner.type.ERROR,
               text: i18nService.getString("HostUi", "timeConfig.startWarning")
            });
            $scope.modalOptions.isAlertClosed = false;
         }

         if ($scope.modalOptions.alerts.length === 0) {
            mutationService.apply(
                  self.objectId,
                  'com.vmware.vsphere.client.host.config.TimeConfigSpec',
                  timeConfigSpec
            );
            return true;
         }
      }

      getViewData();

      function getViewData() {
         dataService
               .getData(
                     self.objectId,
                     'com.vmware.vsphere.client.h5.host.model.TimeConfigData'
               ).then(function(data) {
            self.data = data;
            if (self.data) {
               self.initDataObject = timeConfigService.initData(self.data);
               self.initDataObject.dateObj = moment(self.data.currentTimeInMillis).toDate();
            }
            setPageBusy(false);
         });
      }

      function setPageBusy(isBusy) {
         $scope.modalOptions.submitDisabled = isBusy;
         self.loading = isBusy;
      }
   }
})
();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('editTimeConfigurationService',
         EditTimeConfigurationService);
   EditTimeConfigurationService.$inject = [
      'i18nService',
      'hostServicesConstants',
      'vuiConstants'];

   function EditTimeConfigurationService(i18nService, hostServicesConstants, vuiConstants) {

      // -- Public methods --

      var ntpServiceId;
      var dateTimeConfig;
      var objectId;
      var timeConfigSpec;

      function initService(data, objId) {
         ntpServiceId = data.ntpServiceId;
         dateTimeConfig = data.dateTimeConfig;
         objectId = objId;
         timeConfigSpec = {
            _type: 'com.vmware.vsphere.client.host.config.TimeConfigSpec',
            dateTimeConfig: dateTimeConfig
         };
      }

      function initData(data) {
         return {
            dateTimeConfig: data.dateTimeConfig,
            ntpServiceId: data.ntpServiceId,
            selectedPolicy: getPolicyByKey(data.ntpServicePolicy),
            manuallySetTime: !data.ntpClientEnabled,
            ntpServers: data.dateTimeConfig.ntpConfig.server ? data.dateTimeConfig.ntpConfig.server.join() : '',
            isRunning: data.ntpServiceState,
            serviceStatus: data.ntpServiceState ?
                  i18nService.getString(
                        'HostUi',
                        'timeConfig.ntpServiceStatusRunning') :
                  i18nService.getString(
                        'HostUi',
                        'timeConfig.ntpServiceStatusStopped'),
            date: moment(data.currentTimeInMillis).format('YYYY-MM-DD'),
            time: moment(data.currentTimeInMillis).format('HH:mm:ss')

         };
      }

      function createTimeConfigSpec(modalOptions, initDataObject, startService) {
         modalOptions.alerts = [];
         modalOptions.isAlertClosed = true;

         if (initDataObject.manuallySetTime) {
            return createManuallyTimeConfigSpec(
                  initDataObject,
                  modalOptions
            );
         } else {
            return createEnabledNtpTimeConfigSpec(
                  initDataObject,
                  startService
            );
         }
      }


      function getPolicyDropdownList() {
         return [
            {
               key: 'automatic',
               label: i18nService.getString('HostUi', 'timeConfig.startupPolicyOpenPorts')
            },
            {
               key: 'on',
               label: i18nService.getString('HostUi', 'timeConfig.startupPolicyWithHost')
            },
            {
               key: 'off',
               label: i18nService.getString('HostUi', 'timeConfig.startupPolicyManually')
            }
         ];
      }

      // -- Private methods --

      function createManuallyTimeConfigSpec(initDataObject, modalOptions) {
         var timeConfigSpec = createDefaultTimeConfigSpec(initDataObject, false);

         try {
            timeConfigSpec.targetTime = parseDateTime(initDataObject.date, initDataObject.time);
         } catch (e) {
            modalOptions.alerts.push({
               type: vuiConstants.validationBanner.type.ERROR,
               text: i18nService.getString(
                     'HostUi',
                     'timeConfig.dateTimeFormat.error')
            });

            modalOptions.isAlertClosed = false;
         }

         return timeConfigSpec;
      }

      function createEnabledNtpTimeConfigSpec(initDataObject, startService) {
         var timeConfigSpec = createDefaultTimeConfigSpec(initDataObject, true);

         if (startService) {
            timeConfigSpec.action = hostServicesConstants.action.START;
         }
         timeConfigSpec.dateTimeConfig.ntpConfig = {
            _type: 'com.vmware.vim.binding.vim.host.NtpConfig',
            configFile: [],
            server: getServers(initDataObject.ntpServers)
         };

         return timeConfigSpec;
      }

      function createDefaultTimeConfigSpec(initDataObject, enableNtpClient) {
         var timeConfigSpec = {};

         timeConfigSpec.enableNtpClient = enableNtpClient;
         timeConfigSpec.dateTimeConfig = initDataObject.dateTimeConfig;
         timeConfigSpec.serviceId = initDataObject.ntpServiceId;
         timeConfigSpec.servicePolicy = initDataObject.selectedPolicy.key;

         return timeConfigSpec;
      }

      function getServers(ntpServers) {
         ntpServers = ntpServers ? ntpServers : '';
         var servers = ntpServers.split(',');
         servers = _.map(servers, function(server) {
            return server.trim();
         });
         servers = _.filter(servers, function(server) {
            return !!server;
         });
         return servers;
      }

      function parseDateTime(date, time) {
         if (typeof date !== 'string' || !moment(date, 'YYYY-MM-DD', true).isValid()) {
            throw new Error('Invalid date');
         }

         if (typeof time !== 'string' || !moment(time, 'HH:mm:ss', true).isValid()) {
            throw new Error('Invalid time');
         }

         return moment(date + ' ' + time, 'YYYY-MM-DD HH:mm:ss', true).toDate();
      }

      function getPolicyByKey(key) {

         var policyDropdownList = getPolicyDropdownList();

         return _.filter(policyDropdownList, function(item) {
            return item.key === key;
         })[0];
      }

      return {
         getPolicyDropdownList: getPolicyDropdownList,
         createTimeConfigSpec: createTimeConfigSpec,
         initData: initData,
         initService: initService
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('TimeConfigSettingsController', TimeConfigSettingsController);

   TimeConfigSettingsController.$inject = ['$scope', 'dataService', 'i18nService', 'timeFormatterService'];

   function TimeConfigSettingsController($scope, dataService, i18nService, timeFormatterService) {
      var self = this;
      var objectId = $scope._route.objectId;
      var headerOptions = {
         title: i18nService.getString('HostUi', 'timeConfig.tabLabel'),
         objectId: objectId,
         actions: [{
            actionUid: 'vsphere.core.host.actions.editTimeConfigurationSettings',
            customLabel: i18nService.getString('HostUi', 'editTimeConfigurationButton.label')
         }]
      };

      self.headerOptions = headerOptions;
      self.watchForObjects = [objectId];
      self.getViewData = getViewData;
      self.data = {};
      self.liveRefreshProperties = [
         'config.dateTimeInfo.ntpConfig.configFile',
         'config.dateTimeInfo.ntpConfig.server',
         'config.firewall.ruleset',
         'config.service.service'
      ];

      getViewData();

      function getViewData() {
         dataService
               .getData(objectId, 'com.vmware.vsphere.client.h5.host.model.TimeConfigData')
               .then(function(data) {
                  if (!data) {
                     return;
                  }

                  timeFormatterService
                        .formatDate(data.currentTimeInMillis)
                        .then(function(formattedDate) {
                           self.data = data;
                           self.currentTime = formattedDate;
                        });
               });
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('editSingleVmStartupShutdownService',
         EditSingleVmStartupShutdownService);

   EditSingleVmStartupShutdownService.$inject = ['vmStartupShutdownConstants',
      'i18nService', 'clarityModalService', '$rootScope', 'editVmStartupShutdownService','clarityConstants'];

   function EditSingleVmStartupShutdownService(constants, i18nService,
                                               clarityModalService, $rootScope,
                                               editVmStartupShutdownService, clarityConstants) {

      function openSingleVmStartupShutdownSettingsDialog(vmName,
                                                         vmPowerInfo,
                                                         systemDefaultPowerInfo,
                                                         updatePowerInfo) {
         var modalOptions = {
            title: i18nService.getString('HostUi', 'editSingleVmStartupShutdownSettingsDialog.title'),
            subTitle: {
               text: vmName
            },
            contentTemplate: 'host-ui/resources/host/views/settings/vmStartupShutdown/editSingleVmStartupShutdownSettingsDialog.html',
            defaultButton: 'submit',
            alerts: [],
            dialogData: {
               vmPowerInfoSettings: initPowerInfoSettings(vmPowerInfo, systemDefaultPowerInfo)
            },
            onSubmit: function() {
               var powerInfoData = readPowerInfoData(modalOptions.dialogData.vmPowerInfoSettings);
               var messages = editVmStartupShutdownService.validateStartStopDelay(
                     powerInfoData.startDelay,powerInfoData.stopDelay,
                     modalOptions.dialogData.vmPowerInfoSettings.startupSettings.startupType,
                     modalOptions.dialogData.vmPowerInfoSettings.shutdownSettings.shutdownType);
               if (messages.length > 0) {
                  modalOptions.alerts = _.map(messages, function(message){
                     return {text: message,
                        type: clarityConstants.notifications.type.ERROR
                     };
                  });
                  return false;
               }
               vmPowerInfo =_.extend(vmPowerInfo, powerInfoData);
               updatePowerInfo(vmPowerInfo);
               return true;
            }
         };

         clarityModalService.openOkCancelModal(modalOptions);
      }

      function initPowerInfoSettings(powerInfo, systemDefaultPowerInfo) {

         var vmPowerInfoSettings = {
            startupSettings: {
               startupType: getDelayType(powerInfo.startDelay),
               startDelay: getDelayValue(powerInfo.startDelay,
                     systemDefaultPowerInfo.startDelay),
               heartbeat: getHeartBeat(powerInfo.waitForHeartbeat, systemDefaultPowerInfo)
            },

            shutdownSettings: {
               shutdownType: getDelayType(powerInfo.stopDelay),
               stopDelay: getDelayValue(powerInfo.stopDelay, systemDefaultPowerInfo.stopDelay),
               stopAction: getStopAction(powerInfo.stopAction, systemDefaultPowerInfo)
            }
         };
         return vmPowerInfoSettings;
      }

      function getStopAction(action, systemDefault) {
         if (action === constants.SYSTEM_DEFAULT) {
            return getStopAction(systemDefault.stopAction);
         } else {
            // User specified
            return _.find(editVmStartupShutdownService.getShutdownActionOptions(), function(item) {
               return item.action === action;
            });
         }
      }

      function getDelayValue(delay, systemDefault) {
         if (delay === constants.SYSTEM_DEFAULT_DELAY) {
            return systemDefault;
         } else {
            // User specified
            return delay;
         }
      }

      function getHeartBeat(heartbeat, systemDefault) {
         if (heartbeat === constants.heartbeat.YES) {
            return true;
         } else if (heartbeat === constants.heartbeat.NO) {
            return false;
         } else if (heartbeat === constants.heartbeat.SYSTEM_DEFAULT) {
            return systemDefault.waitForHeartbeat;
         }
      }

      function getDelayType(delay) {
         if (delay === constants.SYSTEM_DEFAULT_DELAY) {
            // Use Dafulat
            return constants.SYSTEM_DEFAULT;
         } else {
            // User specified
            return constants.USER_DEFINED;
         }
      }

      function readPowerInfoData(vmPowerInfoSettings) {
         var powerInfo = {};
         if (vmPowerInfoSettings.startupSettings.startupType === constants.SYSTEM_DEFAULT) {
            powerInfo.startDelay = -1;
            powerInfo.waitForHeartbeat = constants.heartbeat.SYSTEM_DEFAULT;
         } else {
            powerInfo.startDelay = vmPowerInfoSettings.startupSettings.startDelay;
            if (vmPowerInfoSettings.startupSettings.heartbeat) {
               powerInfo.waitForHeartbeat = constants.heartbeat.YES;
            } else {
               powerInfo.waitForHeartbeat = constants.heartbeat.NO;
            }

         }

         if (vmPowerInfoSettings.shutdownSettings.shutdownType === constants.SYSTEM_DEFAULT) {
            powerInfo.stopDelay = -1;
            powerInfo.stopAction = constants.SYSTEM_DEFAULT;
         } else {
            powerInfo.stopDelay = vmPowerInfoSettings.shutdownSettings.stopDelay;
            powerInfo.stopAction = vmPowerInfoSettings.shutdownSettings.stopAction.action;
         }
         return powerInfo;
      }

      return {
         openSingleVmStartupShutdownSettingsDialog: openSingleVmStartupShutdownSettingsDialog
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('editSingleVmStartupShutdownSettingsDialogController',
               EditSingleVmStartupShutdownSettingsDialogController);

   EditSingleVmStartupShutdownSettingsDialogController.$inject = [
      '$scope',
      'editVmStartupShutdownService',
      'vmStartupShutdownConstants',
      'i18nService'];

   function EditSingleVmStartupShutdownSettingsDialogController($scope,
         editVmStartupShutdownService,
         vmStartupShutdownConstants,
         i18nService) {
      var self = this;
      self.SYSTEM_DEFAULT = vmStartupShutdownConstants.SYSTEM_DEFAULT;
      self.USER_DEFINED = vmStartupShutdownConstants.USER_DEFINED;
      self.START_DELAY_MIN_VALUE = 0;
      self.START_DELAY_MAX_VALUE = 65535;
      self.STOP_DELAY_MIN_VALUE = 0;
      self.STOP_DELAY_MAX_VALUE = 65535;
      self.startupSettingHeader = {
         title: i18nService.getString('HostUi',
               'editSingleVmStartupShutdownSettingsDialog.startupSetting.header')
      };
      self.shutdownSettingHeader = {
         title: i18nService.getString('HostUi',
               'editSingleVmStartupShutdownSettingsDialog.shutdownSetting.header')
      };
      self.shutdownActionOptions = editVmStartupShutdownService.getShutdownActionOptions();
      self.startupSettings = $scope.modalOptions.dialogData.vmPowerInfoSettings.startupSettings;
      self.shutdownSettings = $scope.modalOptions.dialogData.vmPowerInfoSettings.shutdownSettings;

      self.validateStartDelay = function(event) {
         if (typeof self.startupSettings.startDelay === "undefined") {
            var valueFromInput = event.target.value;
            if (valueFromInput > self.START_DELAY_MAX_VALUE) {
               self.startupSettings.startDelay = self.START_DELAY_MAX_VALUE;
            } else {
               self.startupSettings.startDelay = self.START_DELAY_MIN_VALUE;
            }
         }
      };
      self.validateStopDelay = function(event) {
         if (typeof self.shutdownSettings.stopDelay === "undefined") {
            var valueFromInput = event.target.value;

            if (valueFromInput > self.STOP_DELAY_MAX_VALUE) {
               self.shutdownSettings.stopDelay = self.STOP_DELAY_MAX_VALUE;
            } else {
               self.shutdownSettings.stopDelay = self.STOP_DELAY_MIN_VALUE;
            }
         }
      };

   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host')
         .controller('EditVmStartupShutdownController', EditVmStartupShutdownController);

   EditVmStartupShutdownController.$inject = [
      '$scope',
      'dataService',
      'editVmStartupShutdownService',
      'i18nService',
      'vmStartupShutdownService',
      'vmStartupShutdownConstants',
      '$timeout',
      'editSingleVmStartupShutdownService',
      'vuiConstants'];

   function EditVmStartupShutdownController($scope,
                                            dataService,
                                            editVmStartupShutdownService,
                                            i18nService,
                                            vmStartupShutdownService,
                                            constants,
                                            $timeout,
                                            editSingleVmStartupShutdownService,
                                            vuiConstants) {
      $scope.modalOptions.onSubmit = onSubmit;
      var self = this;
      self.loading = true;
      var hostId = $scope._route.objectId;
      self.headerOptions = {
         title: i18nService.getString('HostUi', 'vmStartUp.VmStartupAndShutdown'),
         objectId: hostId,
         actions: []
      };
      self.datagridOptions = vmStartupShutdownService.createDatagridOptions(true,
            moveUpDownAction, onEditClick);
      $scope.dialogData = {};
      initializeSelectionChangeEventWatch();
      self.vmStartupData = [];
      self.hostAutoStartConfig = null;
      self.oldSelection = null;
      self.gridWidget = null;

      $scope.preselectComparator = function(gridDataItem) {
         return self.oldSelection && gridDataItem.powerInfoKey &&
               self.oldSelection.powerInfoKey.value === gridDataItem.powerInfoKey.value;
      };

      dataService.getData(hostId, "com.vmware.vsphere.client.h5.host.model.HostAutoStartData").then(function(hostAutoStartData) {
         self.hostAutoStartConfig = hostAutoStartData.autoStartConfig;
         self.vmStartupData = hostAutoStartData.vmStartupData;
         self.hostAutoStartConfig.powerInfo = editVmStartupShutdownService.setDefaultPowerInfoForVms(
               self.vmStartupData,
               self.hostAutoStartConfig
         );
         $scope.dialogData = editVmStartupShutdownService.createDialogOptions(
               self.hostAutoStartConfig, self.vmStartupData);
         self.datagridOptions.data = vmStartupShutdownService.populateDatagrid(
               self.hostAutoStartConfig,
               self.vmStartupData
         );
         self.shutdownActionOptions = editVmStartupShutdownService.getShutdownActionOptions();
         self.loading = false;
      });

      $scope.$watch('dialogData', function(newData) {
         //remove self.loading check when clarity has
         //real load indicator which prevent
         //clicking until the page is loading.
         if (_.isEmpty(newData) || self.loading) {
            return;
         }

         self.hostAutoStartConfig.defaults = editVmStartupShutdownService.createSystemDefaultsSettings(
               $scope.dialogData);
         repopulateDataGrid();
      }, true);

      function onSubmit() {
         //remove self.loading check when clarity has real load indicator which prevent
         //clicking until the page is loading.
         if (self.loading) {
            return false;
         }

         $scope.modalOptions.alerts = [];
         var messages = editVmStartupShutdownService.validateStartStopDelay(
               $scope.dialogData.startupDelay,
               $scope.dialogData.shutdownDelay,
               null, null);

         if (messages.length > 0) {
            $scope.modalOptions.alerts = _.map(messages, function(message) {
               return {
                  text: message,
                  type: vuiConstants.validationBanner.type.ERROR
               };
            });
            return false;
         } else {
            editVmStartupShutdownService.updateHostVmStartupShutdownData(
                  hostId,
                  $scope.dialogData,
                  self.hostAutoStartConfig.powerInfo);
            return true;
         }
      }

      function initializeSelectionChangeEventWatch() {
         $scope.$watchCollection(function() {
            return self.datagridOptions.selectedItems;
         }, onSelectedItemChanged);
      }

      function onSelectedItemChanged() {
         updateServiceActionButtonStatus();
      }

      function moveUpDownAction(state) {
         if (self.datagridOptions.selectedItems.length !== 1) {
            return;
         }
         var selectedItem = self.datagridOptions.selectedItems[0];
         var selectedObjectRef = getPowerInfoForSelectedItem(selectedItem);

         if (state === constants.state.UP) {
            selectedObjectRef =
                  editVmStartupShutdownService.moveUpAction(
                        selectedObjectRef,
                        self.hostAutoStartConfig.powerInfo,
                        moveChangeOrderAction
                  );
         }

         if (state === constants.state.DOWN) {
            selectedObjectRef =
                  editVmStartupShutdownService.moveDownAction(
                        selectedObjectRef,
                        self.hostAutoStartConfig.powerInfo,
                        moveChangeOrderAction
                  );
         }

         self.oldSelection = angular.merge({}, selectedItem);

         repopulateDataGrid();
         //Waiting ui to be rendered after repopulating the datagrid
         // which is caused by moveUp/moveDown actions

         $timeout(function() {
            refreshGrid();
         }, 0, false);
      }

      function moveChangeOrderAction(index, selectedObjectStartOrder) {
         if (self.hostAutoStartConfig.powerInfo[index]) {
            self.hostAutoStartConfig.powerInfo[index].startOrder = selectedObjectStartOrder;
         }
      }

      function updateServiceActionButtonStatus() {

         var moveUpButton = self.datagridOptions.actionBarOptions.actions[0];
         var moveDownButton = self.datagridOptions.actionBarOptions.actions[1];
         var editButton = self.datagridOptions.actionBarOptions.actions[2];

         if (_.isEmpty(self.datagridOptions.selectedItems)) {
            moveUpButton.enabled = false;
            moveDownButton.enabled = false;
            editButton.enabled = false;
            return;
         }
         var selectedItem = self.datagridOptions.selectedItems[0];

         switch (selectedItem.category) {
            case constants.category.MANUAL:
               moveUpButton.enabled = true;
               moveDownButton.enabled = false;
               editButton.enabled = false;
               break;
            case constants.category.AUTOMATIC:
               moveUpButton.enabled = true;
               moveDownButton.enabled = true;
               editButton.enabled = true;
               break;
            case constants.category.AUTOMATIC_ORDERED:
               moveDownButton.enabled = true;
               editButton.enabled = true;
               if (selectedItem.startOrder === 1) {
                  moveUpButton.enabled = false;
               } else {
                  moveUpButton.enabled = true;
               }
               break;
            default:
               moveUpButton.enabled = false;
               moveDownButton.enabled = false;
               editButton.enabled = false;
               break;
         }
      }

      $scope.$on('kendoWidgetCreated', function(event, widget) {
         if (!widget || widget.constructor !== kendo.ui.Grid) {
            return;
         }

         self.gridWidget = widget;
      });

      function onEditClick() {
         if (self.datagridOptions.selectedItems.length !== 1) {
            return;
         }
         var selectedItem = self.datagridOptions.selectedItems[0];
         var powerInfo = getPowerInfoForSelectedItem(selectedItem);
         var systemDefaultPowerInfo = self.hostAutoStartConfig.defaults;
         editSingleVmStartupShutdownService.openSingleVmStartupShutdownSettingsDialog(
               selectedItem.name,
               powerInfo,
               systemDefaultPowerInfo,
               updatePowerInfo);
      }

      function updatePowerInfo(updatedPowerInfo) {
         var key = updatedPowerInfo.key.value;
         var updatedVmPowerInfoIndex = editVmStartupShutdownService.findPowerInfoIndex(
               self.hostAutoStartConfig.powerInfo,
               key);
         self.hostAutoStartConfig.powerInfo[updatedVmPowerInfoIndex] = updatedPowerInfo;
         repopulateDataGrid();
      }

      function getPowerInfoForSelectedItem(selectedItem) {
         var selectedVmPowerInfoIndex = editVmStartupShutdownService.findPowerInfoIndex(
               self.hostAutoStartConfig.powerInfo,
               selectedItem.powerInfoKey);
         return self.hostAutoStartConfig.powerInfo[selectedVmPowerInfoIndex];
      }

      function repopulateDataGrid() {
         self.datagridOptions.data = vmStartupShutdownService.populateDatagrid(
               self.hostAutoStartConfig,
               self.vmStartupData
         );
      }

      function refreshGrid() {
         if (self.gridWidget) {
            // amarinov gangelov: Sometimes the grid scroll glitches (jumps) after
            // refresh so store the position before the refresh and restore it
            // after that
            var gridScrollTop = self.gridWidget.virtualScrollable.verticalScrollbar.scrollTop();
            self.gridWidget.refresh();
            self.gridWidget.virtualScrollable.verticalScrollbar.scrollTop(gridScrollTop);

            // amarinov gangelov: In certain cases the selected item is not
            // scrolled into the view so scroll it...
            var selectedItemRow = self.gridWidget.items().filter('.k-state-selected');
            if (selectedItemRow.length === 1) {
               self.gridWidget.virtualScrollable.scrollIntoView(selectedItemRow);

               if (selectedItemRow.scrollParent) {
                  var itemTop = selectedItemRow[0].offsetTop;
                  var itemBottom = itemTop + selectedItemRow.height();
                  var viewportTop = selectedItemRow.scrollParent().scrollTop();
                  var viewportBottom = viewportTop +
                        selectedItemRow.scrollParent().height();

                  if (itemTop < viewportTop) {
                     gridScrollTop = itemTop;
                     self.gridWidget.virtualScrollable.verticalScrollbar.scrollTop(
                           gridScrollTop
                     );
                  } else if (viewportBottom < itemBottom) {
                     gridScrollTop = viewportTop + (itemBottom - viewportBottom);
                     self.gridWidget.virtualScrollable.verticalScrollbar.scrollTop(
                           gridScrollTop
                     );
                  }
               }
            }
         }
      }

      self.validateStartupDelay = function() {
         if (typeof $scope.dialogData.startupDelay === "undefined") {
            $scope.dialogData.startupDelay = 0;
         }
      };
      self.validateShutdownDelay = function() {
         if (typeof $scope.dialogData.shutdownDelay === "undefined") {
            $scope.dialogData.shutdownDelay = 0;
         }
      };
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('editVmStartupShutdownService',
      EditVmStartupShutdownService);

   EditVmStartupShutdownService.$inject = ['vmStartupShutdownConstants',
      'i18nService', 'mutationService'];

   function EditVmStartupShutdownService(vmStartupShutdownConstants, i18nService,
                                         mutationService) {

      var shutdownActionOptions = [
         {
            name: i18nService.getString('HostUi', 'vmStartUp.actionGuestShutdown'),
            action: 'guestshutdown'
         },
         {
            name: i18nService.getString('HostUi', 'vmStartUp.actionPowerOff'),
            action: 'poweroff'
         },
         {
            name: i18nService.getString('HostUi', 'vmStartUp.actionPowerSuspend'),
            action: 'suspend'
         },
         {
            name: i18nService.getString('HostUi', 'vmStartUp.actionNone'),
            action: 'none'
         }
      ];

      function getShutdownActionOptions() {
         return shutdownActionOptions;
      }

      function createDialogOptions(hostAutoStartConfig, vmStartupData) {
         return {
            autoPowerVms: hostAutoStartConfig.defaults.enabled,
            startupDelay: hostAutoStartConfig.defaults.startDelay,
            shutdownDelay: hostAutoStartConfig.defaults.stopDelay,
            shutdownAction: getShutdownAction(hostAutoStartConfig.defaults),
            vmStartupData: vmStartupData,
            waitForHeartbeat: hostAutoStartConfig.defaults.waitForHeartbeat
         };
      }

      function getShutdownAction(autoStartDefaults) {
         return _.find(shutdownActionOptions, function (option) {
            return autoStartDefaults.stopAction.toLowerCase() === option.action;
         });
      }

      function createSystemDefaultsSettings(dialogData) {
         return {
            enabled: dialogData.autoPowerVms,
            startDelay: dialogData.startupDelay,
            stopDelay: dialogData.shutdownDelay,
            waitForHeartbeat: dialogData.waitForHeartbeat,
            stopAction: dialogData.shutdownAction.action,
            _type: 'com.vmware.vim.binding.vim.host.AutoStartManager$SystemDefaults'
         };
      }

      function updateHostVmStartupShutdownData(hostId, dialogData, powerInfos) {
         var newAutostartConfigSpec = {
            defaults: createSystemDefaultsSettings(dialogData),
            powerInfo: populatePowerInfo(filteredVmsOnHost(dialogData.vmStartupData), powerInfos)
         };
         var typedSpec = _.extend(newAutostartConfigSpec, {
            _type: 'com.vmware.vim.binding.vim.host.AutoStartManager$Config'
         });
         mutationService.apply(
            hostId,
            'com.vmware.vim.binding.vim.host.AutoStartManager$Config',
            typedSpec);
      }

      function populatePowerInfo(vmsOnHost, powerInfos) {
         return _.map(vmsOnHost, function (vm) {
            var powerInfoElement = _.find(powerInfos, function (powerInfo) {
               return vm.provider.value === powerInfo.key.value;
            });

            return {
               _type: "com.vmware.vim.binding.vim.host.AutoStartManager$AutoPowerInfo",
               key: vm.provider,
               startAction: powerInfoElement.startAction,
               startDelay: powerInfoElement.startDelay,
               startOrder: powerInfoElement.startOrder,
               stopAction: powerInfoElement.stopAction,
               stopDelay: powerInfoElement.stopDelay,
               waitForHeartbeat: powerInfoElement.waitForHeartbeat
            };
         });
      }

      function filteredVmsOnHost(vmStartupData) {
         return _.filter(vmStartupData, function (vm) {
            return vm.isNormalVMOrPrimaryFTVM === true;
         });
      }

      function moveUpAction(selectedObjectRef, vmsPowerInfos, changeOrderCallback) {
         var newStartOrderValue;
         var oldStartOrderValue;
         var indexOfOldStartOrderValue;
         var max = getHighestStartOrderVm(vmsPowerInfos);

         // Manual
         if (selectedObjectRef.startAction === vmStartupShutdownConstants.startAction.NONE) {
            selectedObjectRef.startAction = vmStartupShutdownConstants.startAction.POWER_ON_API_VALUE;
            selectedObjectRef.startOrder = -1;
         }
         // Automatic
         else if (selectedObjectRef.startAction.toLowerCase() === vmStartupShutdownConstants.startAction.POWER_ON_LOWERCASE &&
            selectedObjectRef.startOrder === -1) {
            selectedObjectRef.startOrder = ++max;
         }
         // Automatic ordered
         else {
            newStartOrderValue = selectedObjectRef.startOrder;
            oldStartOrderValue = --newStartOrderValue;

            indexOfOldStartOrderValue = findIndexOfVmStartOrderValue(vmsPowerInfos, oldStartOrderValue);

            changeOrderCallback(indexOfOldStartOrderValue, selectedObjectRef.startOrder);
            selectedObjectRef.startOrder = oldStartOrderValue;
         }

         return selectedObjectRef;
      }

      function moveDownAction(selectedObjectRef, vmsPowerInfos, changeOrderCallback) {
         var newStartOrderValue;
         var oldStartOrderValue;
         var indexOfOldStartOrderValue;
         var max = getHighestStartOrderVm(vmsPowerInfos);

         // Automatic
         if (selectedObjectRef.startAction.toLowerCase() === vmStartupShutdownConstants.startAction.POWER_ON_LOWERCASE &&
            selectedObjectRef.startOrder === -1) {
            selectedObjectRef.startAction = vmStartupShutdownConstants.startAction.NONE;
         }
         // Automatic ordered
         else if (selectedObjectRef.startAction.toLowerCase() === vmStartupShutdownConstants.startAction.POWER_ON_LOWERCASE &&
            selectedObjectRef.startOrder !== -1) {
            if (selectedObjectRef.startOrder === max) {
               selectedObjectRef.startOrder = -1;
            } else {
               newStartOrderValue = selectedObjectRef.startOrder;
               oldStartOrderValue = ++newStartOrderValue;

               indexOfOldStartOrderValue = findIndexOfVmStartOrderValue(vmsPowerInfos, oldStartOrderValue);
               changeOrderCallback(indexOfOldStartOrderValue, selectedObjectRef.startOrder);
               selectedObjectRef.startOrder = newStartOrderValue;
            }
         }
         return selectedObjectRef;
      }

      function findIndexOfVmStartOrderValue(vmsPowerInfos, currentVmOrder) {
         return _.findIndex(vmsPowerInfos, function (powerInfo) {
            return powerInfo.startOrder === currentVmOrder;
         });
      }

      function getHighestStartOrderVm(vmsPowerInfos) {
         var max = 0;
         _.each(vmsPowerInfos, function (vmPowerInfo) {
            if (vmPowerInfo.startAction.toLowerCase() === vmStartupShutdownConstants.startAction.POWER_ON_LOWERCASE &&
               vmPowerInfo.startOrder > max) {
               max = vmPowerInfo.startOrder;
            }
         });
         return max;
      }

      function findPowerInfoIndex(vmsPowerInfos, powerInfoKey) {
         return _.findIndex(vmsPowerInfos, function (powerInfo) {
            return powerInfo.key.value === powerInfoKey.value;
         });
      }

      function setDefaultPowerInfoForVms(vmOnHost, vmPowerInfos) {
         return _.map(vmOnHost, function (vm) {
            var vmPowerInfo = _.find(vmPowerInfos.powerInfo, function (powerInfo) {
               return vm.provider.value === powerInfo.key.value;
            });

            if (!vmPowerInfo) {
               vmPowerInfo = vmDefaultPowerInfo(vm);
            }
            return vmPowerInfo;
         });
      }

      function vmDefaultPowerInfo(vm) {
         return {
            _type: "com.vmware.vim.binding.vim.host.AutoStartManager$AutoPowerInfo",
            key: vm.provider,
            startAction: vmStartupShutdownConstants.startAction.NONE,
            startDelay: vmStartupShutdownConstants.SYSTEM_DEFAULT_DELAY,
            startOrder: -1,
            stopAction: vmStartupShutdownConstants.SYSTEM_DEFAULT,
            stopDelay: vmStartupShutdownConstants.SYSTEM_DEFAULT_DELAY,
            waitForHeartbeat: vmStartupShutdownConstants.heartbeat.SYSTEM_DEFAULT
         };
      }

      function validateStartStopDelay(startDelay, stopDelay, startupType, shutdownType) {
         var validationMessages = [];
         if (_.isNull(startDelay) ||
            _.isUndefined(startDelay)) {
            validationMessages.push(
               i18nService.getString('HostUi', 'vmStartUp.validationError.fieldsRequired'));
         } else if ( _.isNull(stopDelay) || _.isUndefined(stopDelay)) {
            validationMessages.push(
               i18nService.getString('HostUi', 'vmStartUp.validationError.fieldsRequired'));
         }
         var intStartDelay = Number.parseInt(startDelay);
         var intStopDelay = Number.parseInt(stopDelay);
         if (!_.isNull(startDelay) && !_.isUndefined(startDelay)  &&
            (!isInt(startDelay.toString()) || !isValidDelay (intStartDelay, startupType))) {
            validationMessages.push(
               i18nService.getString('HostUi', 'vmStartUp.validationError.fieldsMaxValue',
                  vmStartupShutdownConstants.MAX_ALLOWED_DELAY));
         } else if (!_.isNull(stopDelay) && !_.isUndefined(stopDelay)  &&
            (!isInt(stopDelay.toString()) || !isValidDelay(intStopDelay, shutdownType))) {
            validationMessages.push(
               i18nService.getString('HostUi', 'vmStartUp.validationError.fieldsMaxValue',
                  vmStartupShutdownConstants.MAX_ALLOWED_DELAY));
         }
         return validationMessages;
      }
      
      function isValidDelay(delay, delayType) {
         if ((delay < 0 && vmStartupShutdownConstants.SYSTEM_DEFAULT !== delayType ) ||
              delay > vmStartupShutdownConstants.MAX_ALLOWED_DELAY) {
            return false;
         } else {
            return true;
         }
      }

      function isInt(value) {
         var integerValue = Number.parseInt(value);
         if (integerValue <= Number.MIN_SAFE_INTEGER ||
            integerValue >= Number.MAX_SAFE_INTEGER) {
            return true;
         }
         return value !== 'NaN' && integerValue.toString() === value;
      }

      return {
         createDialogOptions: createDialogOptions,
         updateHostVmStartupShutdownData: updateHostVmStartupShutdownData,
         getShutdownActionOptions: getShutdownActionOptions,
         setDefaultPowerInfoForVms: setDefaultPowerInfoForVms,
         moveUpAction: moveUpAction,
         moveDownAction: moveDownAction,
         findPowerInfoIndex: findPowerInfoIndex,
         createSystemDefaultsSettings: createSystemDefaultsSettings,
         validateStartStopDelay: validateStartStopDelay
      };
   }
})();

(function() {
   'use strict';

   /**
    * @name com.vmware.vsphere.client.host:hostServiceStatus
    *
    * @description
    *    Represents vim.host.Service.Policy enum values.
    *
    *    List of available constants
    *
    *    - **`ON`** : Service should be started when the host starts up.
    *    - **`OFF`** : Service should not be started when the host starts up.
    *    - **`AUTOMATIC`** : Service should run if and only if it has open firewall ports.
    */
   angular
         .module('com.vmware.vsphere.client.host')
         .constant('vmStartupShutdownConstants', {
            category: {
               MANUAL: 'Manual',
               AUTOMATIC: 'Automatic',
               AUTOMATIC_ORDERED: 'Automatic Ordered'
            },
            state: {
               UP: 'up',
               DOWN: 'down',
               EDIT: 'edit'
            },
            startAction: {
               NONE: 'none',
               POWER_ON_LOWERCASE: 'poweron',
               POWER_ON_API_VALUE: 'powerOn'
            },
            heartbeat: {
               YES: 'yes',
               NO: 'no',
               SYSTEM_DEFAULT: 'systemDefault'
            },
            SYSTEM_DEFAULT: 'systemDefault',
            USER_DEFINED: 'userDefined',
            SYSTEM_DEFAULT_DELAY: -1,
            MAX_ALLOWED_DELAY:65535
         });
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').service('vmStartupShutdownService',
         VmStartupShutdownService);

   VmStartupShutdownService.$inject = [
      'i18nService',
      'vuiConstants',
      'vmStartupShutdownConstants',
      'templateHelperService'];

   function VmStartupShutdownService(i18nService, vuiConstants, vmConstants, templateHelperService) {

      function populateDatagrid(autoStartConfig, vmStartupData) {
         var vmsOnHost = _.filter(vmStartupData, function(vm) {
            return vm.isNormalVMOrPrimaryFTVM === true;
         });
         var vmPerCategory = {
            automaticOrdered: [],
            automatic: [],
            manualStartup: []
         };

         if (!autoStartConfig || !autoStartConfig.defaults) {
            return [];
         }

         _.forEach(vmsOnHost, function(vm) {
            createVmItem(vm, autoStartConfig, vmPerCategory);
         });

         vmPerCategory.automaticOrdered.sort(function(a, b) {
            return a.startOrder - b.startOrder;
         });

         vmPerCategory.automaticOrdered.unshift(createCategoryItem("vmStartUp.categoryAutomaticOrdered"));
         vmPerCategory.automatic.unshift(createCategoryItem("vmStartUp.categoryAutomatic"));
         vmPerCategory.manualStartup.unshift(createCategoryItem("vmStartUp.categoryManual"));

         var result = [];
         if (vmPerCategory.automaticOrdered.length > 1) {
            result = result.concat(vmPerCategory.automaticOrdered);
         }

         if (vmPerCategory.automatic.length > 1) {
            result = result.concat(vmPerCategory.automatic);
         }

         if (vmPerCategory.manualStartup.length > 1) {
            result = result.concat(vmPerCategory.manualStartup);
         }

         return result;
      }

      function createDatagridOptions(dialogShowExtendedOptions, callbackStartUp, onEditClick) {
         return {
            selectionMode: vuiConstants.grid.selectionMode.SINGLE,
            sortMode: vuiConstants.grid.sortMode.SINGLE,
            searchable: false,
            resizable: true,
            selectedItems: [],
            actionBarOptions: dialogShowExtendedOptions ? createActionBar(callbackStartUp, onEditClick) : null,
            columnDefs: [
               {
                  field: 'startOrderFormatted',
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '<span class="{{startOrderColumnClasses}}">{{startOrderFormatted}}</span>'
                  ),
                  sortable: false,
                  searchable: false,
                  displayName: i18nService.getString('HostUi', 'vmStartUp.StartupOrder')
               },
               {
                  field: 'name',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '<span title="{{name}}">{{name}}</span>'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.VMColumn')
               },
               {
                  field: 'startUp',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '{{startUp}}'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.StartUpColumn')
               },
               {
                  field: 'startUpDelay',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '{{startUpDelay}}'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.StartUpDelayColumn')
               },
               {
                  field: 'vmwareTools',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '{{vmwareTools}}'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.vmWareToolsColumns'),
                  visible: !!dialogShowExtendedOptions
               },
               {
                  field: 'shutdown',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '{{shutdown}}'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.ShutdownBehaviorColumn')
               },
               {
                  field: 'shutdownDelay',
                  sortable: false,
                  searchable: false,
                  template: templateHelperService.getHtmlEscapingTemplateRenderFunction(
                     '{{shutdownDelay}}'
                  ),
                  displayName: i18nService.getString('HostUi', 'vmStartUp.ShutdownDelayColumn')
               }
            ],
            data: [],
            height: '100%',
            pageConfig: {
               hidePager: true
            }
         };
      }

      var moveUpButton = {
         actionId: vmConstants.state.UP,
         tooltipText: i18nService.getString('HostUi', 'vmStartUp.button.moveUp.description'),
         enabled: false,
         label: i18nService.getString('HostUi', 'vmStartUp.MoveUp'),
         iconClass: 'vx-icon-moveUp'
      };
      var moveDownButton = {
         actionId: vmConstants.state.DOWN,
         tooltipText: i18nService.getString('HostUi', 'vmStartUp.button.moveDown.description'),
         enabled: false,
         label: i18nService.getString('HostUi', 'vmStartUp.MoveDown'),
         iconClass: 'vx-icon-moveDown'
      };
      var editButton = {
         actionId: vmConstants.state.EDIT,
         tooltipText: i18nService.getString('HostUi', 'vmStartUp.Edit'),
         enabled: false,
         label: i18nService.getString('HostUi', 'vmStartUp.Edit'),
         iconClass: 'vx-icon-edit16x16'
      };

      function createActionBar(moveUpAndDown, onEditClickCallback) {
         moveUpButton.onClick = function() {
            moveUpAndDown(vmConstants.state.UP);
         };

         moveDownButton.onClick = function() {
            moveUpAndDown(vmConstants.state.DOWN);
         };
         editButton.onClick = function() {
            onEditClickCallback();

         };
         return {
            actions: [
               moveUpButton, moveDownButton, editButton
            ],
            updateActionBar: function() {
            }
         };
      }

      function createVmItem(vm, autoStartConfig, vmPerCategory) {

         var powerInfo = findPowerInfoForVm(autoStartConfig, vm.provider);
         var autoStartDefaults = autoStartConfig.defaults;

         if (!powerInfo) {
            powerInfo = autoStartDefaults;
         }

         var vmListItem = getVmListItem(vm, powerInfo, autoStartDefaults);

         switch (vmListItem.category) {
            case vmConstants.category.MANUAL:
               vmPerCategory.manualStartup.push(vmListItem);
               break;
            case vmConstants.category.AUTOMATIC_ORDERED:
               vmPerCategory.automaticOrdered.push(vmListItem);
               break;
            default:   //case "Automatic":
               vmPerCategory.automatic.push(vmListItem);
         }
      }

      function getVmListItem(vm, powerInfo, autoStartDefaults) {
         var startOrder = powerInfo.startOrder || -1;
         var startOrderFormatted = startOrder > -1 ? startOrder : "";

         var vmListItem = {
            startOrder: startOrder,
            startOrderFormatted: startOrderFormatted,
            startOrderColumnClasses: 'automatic-order',
            name: vm.name,
            startUp: function() {
               if (powerInfo.startAction &&
                     powerInfo.startAction.toLowerCase() === vmConstants.startAction.POWER_ON_LOWERCASE) {
                  return i18nService.getString('HostUi', 'vmStartUp.vmStartupEnabled');
               } else {
                  return i18nService.getString('HostUi', 'vmStartUp.vmStartupDisabled');
               }
            }(),
            startUpDelay: powerInfo.startDelay !== vmConstants.SYSTEM_DEFAULT_DELAY ?
                  powerInfo.startDelay :
                  autoStartDefaults.startDelay,
            shutdown: getShutdownBehaviorLabel(powerInfo.stopAction, autoStartDefaults),
            shutdownDelay: powerInfo.stopDelay !== vmConstants.SYSTEM_DEFAULT_DELAY ?
                  powerInfo.stopDelay :
                  autoStartDefaults.stopDelay,
            vmwareTools: getVMwareTools(powerInfo, autoStartDefaults),
            powerInfoKey: powerInfo.key
         };

         if (!powerInfo.startAction || (powerInfo.startAction === vmConstants.startAction.NONE)) {
            vmListItem.category = vmConstants.category.MANUAL;
         } else if (powerInfo.startOrder > -1) {
            vmListItem.category = vmConstants.category.AUTOMATIC_ORDERED;
         } else {
            vmListItem.category = vmConstants.category.AUTOMATIC;
         }
         return vmListItem;
      }

      function getVMwareTools(powerInfo, autoStartDefaults) {
         if (powerInfo === autoStartDefaults ||
               powerInfo.waitForHeartbeat === vmConstants.heartbeat.SYSTEM_DEFAULT) {
            if (!!autoStartDefaults.waitForHeartbeat) {
               return i18nService.getString('HostUi', 'vmStartUp.toolsContinueLabel');

            } else {
               return i18nService.getString('HostUi', 'vmStartUp.toolsWaitStatupLabel');
            }
         } else {
            if (powerInfo.waitForHeartbeat === vmConstants.heartbeat.YES) {
               return i18nService.getString('HostUi', 'vmStartUp.toolsContinueLabel');
            } else {
               return i18nService.getString('HostUi', 'vmStartUp.toolsWaitStatupLabel');
            }
         }
      }

      function createCategoryItem(category) {
         return {
            startOrder: -1,
            startOrderFormatted: i18nService.getString('HostUi', category),
            startOrderColumnClasses: 'vm-startup-category',
            name: "",
            startUp: "",
            startUpDelay: "",
            shutdown: "",
            shutdownDelay: ""
         };
      }

      function getShutdownBehaviorLabel(behavior, defaultConfig) {
         switch (behavior.toLowerCase()) {
            case 'poweroff':
               return i18nService.getString('HostUi', 'vmStartUp.actionPowerOff');
            case 'suspend':
               return i18nService.getString('HostUi', 'vmStartUp.actionPowerSuspend');
            case 'none':
               return i18nService.getString('HostUi', 'vmStartUp.actionNone');
            case 'guestshutdown':
               return i18nService.getString('HostUi', 'vmStartUp.actionGuestShutdown');
            case 'systemdefault':
               return getShutdownBehaviorLabel(defaultConfig.stopAction, null);
            default:
               return '';
         }
      }

      function findPowerInfoForVm(autoStartConfig, vmProvider) {
         return _.find(autoStartConfig.powerInfo, function(possiblePowerInfo) {
            return _.isEqual(vmProvider, possiblePowerInfo.key);
         });
      }

      return {
         populateDatagrid: populateDatagrid,
         createDatagridOptions: createDatagridOptions,
         findPowerInfoForVm: findPowerInfoForVm
      };
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('VMStartupShutdownViewController', VMStartupShutdownViewController);

   VMStartupShutdownViewController.$inject = ['$scope', 'i18nService', 'dataService', 'vmStartupShutdownService'];

   function VMStartupShutdownViewController($scope, i18nService, dataService, vmStartupShutdownService) {
      var self = this;
      self.loader = true;

      var hostId = $scope._route.objectId;
      self.headerOptions = {
         title: i18nService.getString('HostUi', 'vmStartUp.VmStartupAndShutdown'),
         objectId: hostId,
         actions: [{
            actionUid: 'vsphere.core.host.actions.editVmStartupShutdownAction',
            customLabel: i18nService.getString('Common', 'settingsView.defaultEditActionLabel')
         }]
      };
      self.objectsToWatch = [hostId];
      self.liveRefreshProperties = [
         'config.autoStart.powerInfo',
         'config.autoStart.defaults.stopDelay',
         'config.autoStart.defaults.enabled',
         'config.autoStart.defaults.stopAction',
         'config.autoStart.defaults.startDelay',
         'vm'
      ];

      self.datagridOptions = vmStartupShutdownService.createDatagridOptions();
      self.fetchViewData = fetchViewData;
      fetchViewData();

      function fetchViewData() {
         dataService.getData(hostId, "com.vmware.vsphere.client.h5.host.model.HostAutoStartData")
               .then(function(hostAutoStartData) {
                  var hostAutoStartConfig = hostAutoStartData.autoStartConfig;
                  self.datagridOptions.data = vmStartupShutdownService.populateDatagrid(
                        hostAutoStartConfig,
                        hostAutoStartData.vmStartupData
                  );
                  self.loader = true;
               });
      }
   }
})();

(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.host').controller('SwapFileLocationController',
         SwapFileLocationController);

   SwapFileLocationController.$inject =
         ['$scope', 'dataService', 'i18nService', 'defaultUriSchemeUtil'];

   function SwapFileLocationController($scope, dataService, i18n, defaultUriSchemeUtil) {
      var self = this;
      var hostId = $scope._route.objectId;

      self.objectsToWatch = [hostId];
      self.headerOptions = {
         title: i18n.getString('HostUi', 'settings.swapfileHeader'),
         objectId: hostId,
         actions: [{ actionUid: 'vsphere.core.host.actions.editSwapfileLocation',
             customLabel: i18n.getString('HostUi', 'settings.edit')
         }]
      };

      self.data = {};
      self.isStandalone = true;
      self.isDatastore = false;
      self.swapfileLocation = null;
      self.clusterInfo = null;
      self.liveRefreshProperties = ['config.localSwapDatastore',
         'config.fileSystemVolume.mountInfo'];

      self.getViewData = getViewData;

      getViewData();

      function getViewData() {
         dataService.getData(
               hostId,
               'com.vmware.vsphere.client.h5.host.model.SwapfileLocationData'
         ).then(function(data) {
            self.data = data;
            processData();
         });
      }

      function processData() {
         if (!self.data) {
            return;
         }

         self.isStandalone = self.data.isStandalone;

         if (self.data.vmSwapPlacement === "vmDirectory") {
            self.swapfileLocation = getLocation('vmDir');
            self.isDatastore = false;
            self.clusterInfo = self.isStandalone ? null : getMessages('clusteredVmDirectory');
         } else {
            self.clusterInfo = self.isStandalone ? null : getMessages('clusteredDatastore');
            setSwapfileDatastore();
         }
      }

      function setSwapfileDatastore() {
         if (!self.data.localSwapDatastore) {
            self.swapfileLocation = getLocation('noDatastore');
            self.isDatastore = false;
            return;
         }
         self.swapfileLocation = self.data.datastoreName;
         self.isDatastore = true;
         self.datastoreRef = defaultUriSchemeUtil
               .getVsphereObjectId(self.data.localSwapDatastore);
      }

      function getMessages(state) {
         return {
            clusteredDatastore: i18n.getString('HostUi', 'swapfile.hostInCluster.dataStore'),
            clusteredVmDirectory: i18n.getString('HostUi', 'swapfile.hostInCluster.vmDirectory')
         }[state];
      }

      function getLocation(location) {
         return {
            vmDir: i18n.getString('HostUi', 'swapfile.vmDirectory'),
            noDatastore: i18n.getString('HostUi', 'swapfile.noDataStore')
         }[location];
      }
   }
})();

/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * HostConfigurationController
 */
angular.
module('com.vmware.vsphere.client.host').
controller('HostConfigurationController', ['$scope', '$controller', '$sce', 'i18nService', 'dataService',
   function($scope, $controller, $sce, i18nService, dataService) {

      function getImageProfileData() {
         dataService.getProperties($scope._route.objectId, ['imageProfileName'])
            .then(function(data) {
               $scope.imageProfile = !!data['imageProfileName'] ?
                  data['imageProfileName'] :
                  i18nService.getString('HostUi', 'config.imageProfileNotAvailable');
            });
      }

      function getHaStateImage() {
         if (!$scope.data || !$scope.data.haStateImage) {
            return null;
         }

         switch ($scope.data.haStateImage) {
            case 'statusGreen':
               return "vsphere-icon-status-ok";
            case 'statusYellow':
               return "vsphere-icon-status-warning";
            case 'statusRed':
               return "vsphere-icon-status-error";
            case 'statusUnknown':
               return "vsphere-icon-status-unknown";
            default:
               return null;
         }
      }

      function getHaStateImageAriaLabel() {
         if (!$scope.data || !$scope.data.haStateImage) {
            return null;
         }

         switch ($scope.data.haStateImage) {
            case 'statusYellow':
               return "Common:entityStatus.yellow";
            case 'statusRed':
               return "Common:entityStatus.red";
            case 'statusUnknown':
               return "Common:entityStatus.gray";
            default:
               return null;
         }
      }

      function getHaStateDescriptionHtml() {
         if (!$scope.data || !$scope.data.haStateString) {
            return null;
         }

         return $sce.trustAsHtml(i18nService.getString('HostUi', $scope.data.haStateString + '.description'));
      }

      function getUpFtUnsupportedReasonsRows() {
         if (!$scope.data || $scope.data.ftSupported || !Array.isArray($scope.data.ftUnsupportedReasonRows)) {
            return [];
         }

         return $scope.data.ftUnsupportedReasonRows;
      }

      function getSmpFtUnsupportedReasonsRows() {
         if (!$scope.data || $scope.data.cptFtSupported || !Array.isArray($scope.data.cptUnsupportedReasonRows)) {
            return [];
         }

         return $scope.data.cptUnsupportedReasonRows;
      }

      angular.extend(this, $controller('GenericPortletController', { $scope: $scope }));

      this.getHaStateImage = getHaStateImage;
      this.getHaStateImageAriaLabel = getHaStateImageAriaLabel;
      this.getHaStateDescriptionHtml = getHaStateDescriptionHtml;
      this.getUpFtUnsupportedReasonsRows = getUpFtUnsupportedReasonsRows;
      this.getSmpFtUnsupportedReasonsRows = getSmpFtUnsupportedReasonsRows;

      this.liveRefreshProperties = ['runtime.dasHostState', 'summary.currentEVCModeKey',
         'runtime.connectionState', 'config.virtualNicManagerInfo.netConfig'];

      $scope.imageProfile = i18nService.getString('HostUi', 'config.imageProfileLoading');
      getImageProfileData();

      $scope.$watch("data.dasHostState && data.dasHostState.state", function (value) {
         if (!value) {
            $scope.haStackBlockExpanded = false;
         }
      });

      $scope.$watch("ctrl.getUpFtUnsupportedReasonsRows().length > 0", function (value) {
         if (!value) {
            $scope.upFtStackBlockExpanded = false;
         }
      });

      $scope.$watch("ctrl.getSmpFtUnsupportedReasonsRows().length > 0", function (value) {
         if (!value) {
            $scope.smpFtStackBlockExpanded = false;
         }
      });
   }]);

angular.
module('com.vmware.vsphere.client.host').
controller('HostHardwareController', [
      '$scope', '$controller', 'featureFlagsService','dataService',
function($scope, $controller, featureFlagsService, dataService) {
   angular.extend(this, $controller('GenericPortletController', {$scope: $scope}));

   this.liveRefreshProperties = ['runtime.connectionState', 'datastore'];


    $scope.navigateToDatastores = function() {
        $scope._navigate('vsphere.core.host.relatedDatastoresTab', $scope._route.objectId);
    };

    $scope.navigateToNetworks = function() {
        $scope._navigate('vsphere.core.host.relatedNetworksTab', $scope._route.objectId);
    };

    var pmemData = this.pmemData = {
       enabled: false,
       loading: false,
       pmemUsageText: undefined,
       pmemSizeText: undefined
    };

    var closeDataWatch = $scope.$watch("data", function(newData) {
       // Data model is of type HostHardwareData which is an IdentifiableQueryBinding.
       // Dataservice will populate provider property with the ManagedObjectReference
       // of the HostSystem. This can leveraged to see when data is loaded.
       if (!newData.hasOwnProperty("provider")) {
          return;
       }
       if (isPmemFeatureEnabled() && newData.hasPmemStorage) {
          loadPmemData();
       }
    });

    $scope.$on('$destroy', function() {
       closeDataWatch();
    });

    function loadPmemData() {
       pmemData.enabled = true;
       pmemData.loading = true;
       dataService.getData(
             $scope._route.objectId,
             "com.vmware.vsphere.client.host.model.HostPmemData"
       ).then(function(hostPmemData /* HostPmemData */) {
          pmemData.pmemSizeText = hostPmemData.pmemSizeText;
          pmemData.pmemUsageText = hostPmemData.pmemUsageText;
          pmemData.pmemUsagePercentage = hostPmemData.pmemUsagePercentage;
          pmemData.loading = false;
       }, function() {
          pmemData.loading = false;
       });
    }

    function isPmemFeatureEnabled() {
       return (typeof featureFlagsService.PMemEnabled === "function") ?
             featureFlagsService.PMemEnabled() : false;
    }
}]);

angular
      .module('com.vmware.vsphere.client.host')
      .constant('suppressWarningSettingConstants', {
         SUPPRESS_SHELL_WARNING_KEY: 'UserVars.SuppressShellWarning',
         SUPPRESS_HYPERTHREAD_WARNING_KEY: 'UserVars.SuppressHyperthreadWarning',
         WARNING_SUPPRESS_VALUE: {
            TRUE: 1,
            FALSE: 0
         }
      });

(function() {
   'use strict';
   angular
         .module('com.vmware.vsphere.client.host')
         .service('suppressWarningSettingService', SuppressWarningSettingService);

   SuppressWarningSettingService.$inject = [
      'resourceService',
      'mutationService',
      '$rootScope',
      'suppressWarningSettingConstants'];

   function SuppressWarningSettingService(resourceService, mutationService, $rootScope, constants) {

      return {
         suppressWarnings: suppressWarnings
      };

      function suppressWarnings(hostId, key) {
         resourceService
               .getResourceInfo(hostId, 'advancedSettings')
               .then(function(result) {
                  var advancedSettingsProperties = result.properties;
                  var suppressWarningObject =
                        getSuppressWarningObject(advancedSettingsProperties, key);
                  updateSuppressWarningObject(suppressWarningObject, hostId);
               });
      }

      function getSuppressWarningObject(advancedSettingsProperties, warningKey) {
         var suppressWarningObject = advancedSettingsProperties.find(function(propertyElement) {
            return propertyElement.key === warningKey;
         });
         return suppressWarningObject;
      }

      function updateSuppressWarningObject(suppressWarningObject, hostId) {

         suppressWarningObject.value = constants.WARNING_SUPPRESS_VALUE.TRUE;
         var hostAdvancedSettingsSpec = createHostAdvancedSettingsSpec(suppressWarningObject);

         mutationService
               .apply(
                     hostId,
                     'com.vmware.vsphere.client.host.config.HostAdvancedSettingsSpec',
                     hostAdvancedSettingsSpec)
               .then(function(operationResult) {
                  if (operationResult && operationResult.error) {
                     return;
                  }
                  $rootScope.$broadcast('IssueChangeEvent');
               });
      }

      function createHostAdvancedSettingsSpec(suppressWarningObject) {

         var changedAdvancedSettings = [{
            _type: 'com.vmware.vim.binding.vim.option.OptionValue',
            key: suppressWarningObject.key,
            value: [getType(suppressWarningObject.type), suppressWarningObject.value]
         }];

         return {
            hostSettingsChangeset: changedAdvancedSettings
         };
      }

      function getType(type) {
         var result;
         switch (type) {
            case 'int':
               result = 'java.lang.Integer';
               break;
            case 'long':
               result = 'java.lang.Long';
               break;
            case 'boolean':
               result = 'java.lang.Boolean';
               break;
            default:
               result = 'java.lang.String';
               break;
         }
         return result;
      }
   }
})();



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This ts file has to be loaded first
 */
var h5_vapp;
(function (h5_vapp) {
    h5 = h5 || {};
    h5.vcextension = {
        angularModule: angular.module("com.vmware.vsphere.client.vcextension", ["com.vmware.platform.ui"])
    };
    function initModule(agencyOperationManager) {
        // Put initialization code here, e.g. action invokers, column renderers, shortcut
        // handlers, drag'n'drop rules, etc.
        h5.actions["com.vmware.eam.actions.agencyIssue.resolve"] =
            function (actionEval, availableTargets, context) {
                agencyOperationManager.resolveIssue(context.agencyId, context.issueKey);
            };
        h5.actions["com.vmware.eam.actions.agency.deleteAgency"] =
            function (actionEval, availableTargets, context) {
                agencyOperationManager.deleteAgency(availableTargets, context);
            };
        h5.actions["com.vmware.eam.actions.agency.resolveAllIssues"] =
            function (actionEval, availableTargets, context) {
                agencyOperationManager.resolveAllIssues(availableTargets, context);
            };
    }
    angular.module("com.vmware.vsphere.client.vcextension")
        .run(["agencyOperationManagerService", initModule]);
})(h5_vapp || (h5_vapp = {}));



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Controller for Legacy solutions portlet for vc extensions
 */
var h5_vcextension;
(function (h5_vcextension) {
    var VcExtensionSummarySolutionsViewController = (function () {
        function VcExtensionSummarySolutionsViewController($scope) {
            this.$scope = $scope;
            this.vcexstensionId = this.$scope._route.objectId;
        }
        VcExtensionSummarySolutionsViewController.$inject = ["$scope"];
        return VcExtensionSummarySolutionsViewController;
    }());
    h5_vcextension.VcExtensionSummarySolutionsViewController = VcExtensionSummarySolutionsViewController;
    angular.module("com.vmware.vsphere.client.vcextension")
        .controller("vcExtensionSummarySolutionsViewController", VcExtensionSummarySolutionsViewController);
})(h5_vcextension || (h5_vcextension = {}));





h5 = h5 || {};
h5.autodeploy = {
    angularModule: angular.module("com.vmware.vsphere.client.autodeploy", [])
};





/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

h5 = h5 || {};
h5.codecapture = {
   angularModule: angular.module('com.vmware.vsphere.client.codecapture', [])
};
var codecapture_ui;
(function (codecapture_ui) {
    var CodeCaptureViewController = (function () {
        function CodeCaptureViewController() {
        }
        CodeCaptureViewController.prototype.$onInit = function () {
            this.onResize();
        };
        CodeCaptureViewController.prototype.onResize = function () {
            var _this = this;
            setTimeout(function () {
                _this.resized = !_this.resized;
            }, 100);
        };
        return CodeCaptureViewController;
    }());
    angular.module("com.vmware.vsphere.client.codecapture")
        .controller("CodeCaptureViewController", CodeCaptureViewController);
})(codecapture_ui || (codecapture_ui = {}));





h5 = h5 || {};

h5['dashboard-lite'] = {
   angularModule: angular.module('com.vmware.vsphere.client.dashboard-lite', [])
};



/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

h5 = h5 || {};
h5.devcenter = {
   angularModule: angular.module('com.vmware.vsphere.client.devcenter', [])
};


/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
h5 = h5 || {};
h5.licenseLib = {
   angularModule: angular.module('com.vmware.vsphere.client.licenseLibUi',
         ['com.vmware.platform.ui', 'com.vmware.vsphere.client.commonModule'])
};

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';

   angular.module('com.vmware.vsphere.client.licenseLibUi')
      .component("licenseSelector", {
         templateUrl: "license-lib-ui/resources/license/components/licenseSelector/licenseSelector.html",
         controller: LicenseSelectorController,
         bindings: {
            licenseData: '<?',
            selectedLicenseItem: '=?',
            onItemChange: '&',
            isAddHostState: '=?'
         }
      });

   LicenseSelectorController.$inject = [
      '$scope',
      'vuiUtils',
      'i18nService',
      'licenseCommonUtil',
      'licenseTreeListUtil',
      'licenseValidationUtil',
      'columnRenderersRegistry',
      'vuiDialogService'
   ];

   function LicenseSelectorController (
      $scope,
      vuiUtils,
      i18nService,
      licenseCommonUtil,
      licenseTreeListUtil,
      licenseValidationUtil,
      columnRenderersRegistry,
      vuiDialogService
   ) {

      var NAME_FIELD = 'name';
      var LICENSE_KEY_FIELD = 'licenseKey';
      var PRODUCT_FIELD = 'product';
      var CAPACITY_FIELD = 'capacity';

      function iconNameRendererFactory(nameField, iconField) {
         return (function(data) {
            var name = data[nameField];
            var iconClass = data[iconField];

            if (!name && !iconClass) {
               return "";
            }

            var objectLinkRenderer =
               columnRenderersRegistry.getColumnRenderer('object-link');
            return objectLinkRenderer([undefined, nameField, iconClass], data);
         });
      }

      function scrollSelectedTreeListItemIntoView() {
         var itemNode = self.treeListWidget.select();

         if (itemNode.length !== 1 || !itemNode.scrollParent || !itemNode.scrollParent() ||
            itemNode.scrollParent().length === 0) {
            return;
         }

         var scrollParent = itemNode.scrollParent();

         var itemTop = itemNode[0].offsetTop;
         var itemBottom = itemTop + itemNode.height();
         var viewportTop = scrollParent.scrollTop();
         var viewportBottom = viewportTop + scrollParent.height();

         if (itemTop < viewportTop) {
            scrollParent.scrollTop(itemTop);
         } else if (viewportBottom < itemBottom) {
            scrollParent.scrollTop(viewportTop + (itemBottom - viewportBottom));
         }
      }

      /**
       * Makes the license key column match its content width if there is at least
       * one serial key in the grid.
       * Otherwise it uses the standard grid algorithm to calculate the width.
       */
      function autofitLicenseKeyColumnIfSerialKeysExist() {
         if (!self.treeListWidget || !self.treeListWidget.columns
               || !self.treeListWidget.dataSource
               || !self.treeListWidget.dataSource.options
               || !self.treeListWidget.dataSource.options.data
               || !self.treeListWidget.dataSource.options.data.length) {
            return;
         }

         var serialKeyExistInGrid = false;
         var treeListData = self.treeListOptions.dataSource.options.data;
         serialKeyExistInGrid = treeListData.some(function(license) {
            return license && license.licenseKey !== "--";
         });

         if (!serialKeyExistInGrid) {
            return;
         }

         for (var i = 0; i < self.treeListWidget.columns.length; i++) {
            if (LICENSE_KEY_FIELD === self.treeListWidget.columns[i].field) {
               self.treeListWidget.autoFitColumn(i);
            }
         }
      }

      var self = this;

      var treeListDataSourceSchema = {
         model: {
            id: "id",
            expanded: false
         }
      };
      var licensePreselected = false;

      self.ValidationMessageType = licenseCommonUtil.ValidationMessageType;

      self.licenseValidationMessages = [];
      self.validationPanelTitle = i18nService.getString(
         'LicenseLibUi',
         'assignLicense.validationTitle'
      );

      self.i18nService = i18nService;
      self.treeListWidget = null;
      self.treeListColumns = [{
         title: i18nService.getString('LicenseLibUi', 'list.licenses.column.name'),
         field: NAME_FIELD,
         template: iconNameRendererFactory('name', 'icon')
      }, {
         title: i18nService.getString('LicenseLibUi', 'list.licenses.column.serialKey'),
         field: LICENSE_KEY_FIELD
      }, {
         title: i18nService.getString('LicenseLibUi', 'list.licenses.column.product'),
         field: PRODUCT_FIELD
      }, {
         title: i18nService.getString('LicenseLibUi', 'list.licenses.column.usage'),
         field: '',
         template: function(dataItem) {
            var label = dataItem.usage.current.label;
            var tooltip = '';
            if (dataItem.usage.current.tooltip) {
               tooltip = dataItem.usage.current.tooltip;
            }

            var templateElement = $('<div></div>')
               .text(label)
               .attr('title', tooltip);

            if (dataItem.usage.current.indicateUsageChange) {
               templateElement.addClass('changed-usage-highlight');
            }

            return templateElement[0].outerHTML;
         }
      }, {
         title: i18nService.getString('LicenseLibUi', 'list.licenses.column.limit'),
         field: CAPACITY_FIELD,
         sortable: {
            compare: function(license1, license2) {
               var capacity1 = parseInt(license1.capacity.split(" ")[0]);
               var capacity2 = parseInt(license2.capacity.split(" ")[0]);
               return capacity1 - capacity2;
            }
         }
      }];

      self.handleTreeListChange = function() {
         var selectedLicense = null;

         if (self.treeListWidget.select().length === 1) {
            var dataItem = self.treeListWidget.dataItem(self.treeListWidget.select());
            selectedLicense = dataItem._license;
         } else {
            selectedLicense = null;
         }

         if (!_.isEqual(self.selectedLicenseItem, selectedLicense)) {
            self.selectedLicenseItem = selectedLicense;
            self.onItemChange({item: selectedLicense});
         }

         self.licenseValidationMessages =
            licenseValidationUtil.getValidationMessages(
               selectedLicense,
               self.licenseData,
               self.isAddHostState
            );

         if (selectedLicense) {
            self.validationPanelTitle = i18nService.getString(
               'LicenseLibUi',
               'assignLicense.validationTitle.license',
               selectedLicense.name
            );
         } else {
            self.validationPanelTitle = i18nService.getString(
               'LicenseLibUi',
               'assignLicense.validationTitle'
            );
         }

         _.each(self.treeListOptions.dataSource.data(), function(item) {
            if (item._license.uri === licenseCommonUtil.getLicenseUri(selectedLicense)) {
               item.usage.current = item.usage.selected;
            } else {
               item.usage.current = item.usage.deselected;
            }
         });

         self.treeListWidget.refresh();
      };

      self.handleTreeListDataBound = function() {
         if (!self.treeListWidget || !self.licenseData || licensePreselected) {
            return;
         }

         autofitLicenseKeyColumnIfSerialKeysExist();

         licensePreselected = true;
         var preSelectedLicenseUri = licenseCommonUtil.getLicenseUri(
            licenseCommonUtil.getPreSelectedLicense(
               self.licenseData,
               self.selectedLicenseItem
            ));

         $scope.$evalAsync(function() {
            var preSelectedLicenseDataItem =
               _.filter(self.treeListOptions.dataSource.rootNodes(), function(item) {
                  var itemLicenseUri = licenseCommonUtil.getLicenseUri(item._license);
                  return preSelectedLicenseUri === itemLicenseUri;
               });

            if (preSelectedLicenseDataItem.length === 1) {
               var preSelectedLicenseItemNode =
                  self.treeListWidget.itemFor(preSelectedLicenseDataItem[0]);
               self.treeListWidget.select(preSelectedLicenseItemNode);
               scrollSelectedTreeListItemIntoView();
            } else {
               self.treeListWidget.select($([]));
            }
         });
      };

      self.showValidationMessageDetailsDialog = function(validationMessage) {
         var dialogScope = $scope.$new(true);
         dialogScope.dialogOptions = {
            title: i18nService.getString(
               'LicenseLibUi',
               'assignLicense.validationMessageDetails.dialog.title'
            ),
            contentUrl: 'license-lib-ui/resources/license/components/licenseSelector' +
                  '/licenceValidationMessageDetailsContent.html',
            show: true,
            rejectOptions: {
               visible: false
            },
            confirmOptions: {
               label: i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.validationMessageDetails.dialog.okButtonLabel'
               )
            },
            height: 'auto',
            width: '450px'
         };
         dialogScope.contentModel = {
            validationMessage: validationMessage
         };

         var options = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vuiDialogService(options);
      };

      self.treeListOptions = {
         columns: self.treeListColumns,
         sortable: true,
         resizable: true,
         selectable: true,
         change: _.partial(vuiUtils.safeApply, $scope, self.handleTreeListChange),
         dataBound: _.partial(vuiUtils.safeApply, $scope, self.handleTreeListDataBound)
      };

      self.$onChanges = function(changes) {
         if (changes.hasOwnProperty("licenseData") &&
               changes.licenseData.previousValue !== changes.licenseData.currentValue) {
            self.licenseData = changes.licenseData.currentValue;
            populateLicenseList();
         }
      };

      function populateLicenseList() {
         if (self.licenseData) {
            self.treeListOptions.dataSource = new kendo.data.TreeListDataSource({
               data: licenseTreeListUtil.createLicenseTreeListItems(self.licenseData),
               schema: treeListDataSourceSchema
            });
            self.treeListOptions.dataSource.read();
         }
      }
   }
})();

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
angular.module('com.vmware.vsphere.client.licenseLibUi')
      .constant('licenseConstants', {
         LICENSE_TYPE: 'License',
         EVALUATION_LICENSE_ID: 'EVALUATION_LICENSE_ID',
         LICENSE_EXPIRATION_MAX_WARNING_DAYS_REMAINING: 60,
         LicenseAssignRestriction: {
            ExpiredLicense: 'ExpiredLicense',
            EmbeddedOemLicense: 'EmbeddedOemLicense'
         },
         LimitEnforcementType: {
            NOT_ENFORCED: 'NOT_ENFORCED',
            SOFT_ENFORCED: 'SOFT_ENFORCED',
            HARD_ENFORCED: 'HARD_ENFORCED'
         },
         RESPONSE_FAULT: {
            LICENSING_METHOD_FAULT: "com.vmware.license.client.cis.util.LicensingMethodFault"
         }

      });

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var license_lib_ui;
(function (license_lib_ui) {
    var AssignLicenseService = (function () {
        function AssignLicenseService(mutationService, licenseCommonUtil, i18nService, clarityModalService, defaultUriSchemeUtil) {
            this.mutationService = mutationService;
            this.licenseCommonUtil = licenseCommonUtil;
            this.i18nService = i18nService;
            this.clarityModalService = clarityModalService;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.ASSET_TYPE = "Asset";
        }
        AssignLicenseService.prototype.retrieveLicenses = function (assetRefs) {
            var _this = this;
            return this.mutationService.validateOnMultiEntity(assetRefs, "com.vmware.license.client.cis.management.ds.specs.AssetAssignLicenseValidateSpec", {}).then(function (response) {
                if (_.isEmpty(response)) {
                    return null;
                }
                if (response[0].error) {
                    throw response[0].error;
                }
                var validationResult = response[0].result;
                _this.licenseCommonUtil.normalizeValidationResult(validationResult);
                return validationResult;
            });
        };
        AssignLicenseService.prototype.assignLicense = function (assetUris, licenseUri) {
            return this.mutationService.applyOnMultiEntity(assetUris, "com.vmware.license.client.cis.management.ds.specs.AssetAssignLicenseSpec", {
                licenseRef: licenseUri,
                _type: "com.vmware.license.client.cis.management.ds.specs.AssetAssignLicenseSpec"
            }, this.i18nService.getString('LicenseLibUi', "action.assignLicense.operationName"));
        };
        AssignLicenseService.prototype.assignNewLicense = function (assetUris, serialKeys, newLicenseName) {
            return this.mutationService.applyOnMultiEntity(assetUris, "com.vmware.license.client.cis.management.ds.specs.LicenseCreateSpec", {
                name: newLicenseName,
                serialKeys: serialKeys,
                _type: "com.vmware.license.client.cis.management.ds.specs.LicenseCreateSpec"
            });
        };
        AssignLicenseService.prototype.showAssignLicenseForm = function (assetRefs) {
            var modalOptions = {
                title: this.getTitle(assetRefs),
                contentTemplate: 'license-lib-ui/resources/license/views/assignLicense/assignLicenseForm.html',
                size: 'xl',
                defaultButton: "submit",
                modalClass: "assign-license-modal",
                dialogData: {
                    availableTargets: assetRefs
                }
            };
            if (assetRefs.length === 1 && this.defaultUriSchemeUtil.getEntityType(assetRefs[0]) !== this.ASSET_TYPE) {
                modalOptions.subTitle = {
                    objectId: assetRefs[0]
                };
            }
            this.clarityModalService.openOkCancelModal(modalOptions);
        };
        AssignLicenseService.prototype.getTitle = function (assetRefs) {
            var title = this.i18nService.getString("LicenseLibUi", "assignLicense.title");
            if (assetRefs && assetRefs.length > 1) {
                title += " - " + this.i18nService.getString("LicenseLibUi", "dialogTitle.multipleObjectsPrefix", assetRefs.length);
            }
            return title;
        };
        AssignLicenseService.$inject = [
            'mutationService',
            'licenseCommonUtil',
            'i18nService',
            'clarityModalService',
            'defaultUriSchemeUtil'
        ];
        return AssignLicenseService;
    }());
    license_lib_ui.AssignLicenseService = AssignLicenseService;
    angular.module("com.vmware.vsphere.client.licenseLibUi").service("assignLicenseService", AssignLicenseService);
})(license_lib_ui || (license_lib_ui = {}));



/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.licenseLibUi')
         .service(
               'licenseCommonUtil',
               licenseCommonUtil
         );

   licenseCommonUtil.$inject = ['licenseConstants', 'defaultUriSchemeUtil'];

   function licenseCommonUtil(licenseConstants, defaultUriSchemeUtil) {
      var ValidationMessageType = {
         TEXT: 'TEXT',
         OK: 'OK',
         INFO: 'INFO',
         WARNING: 'WARNING',
         ALERT: 'ALERT'
      };

      var ValidationMessageDetailsType = {
         TEXT: 'TEXT',
         TEXT_AND_LIST: 'TEXT_AND_LIST'
      };

      function getAggregatedCostUnitUsage(licenseRef /*URI as String*/,
            productRef /*URI as String*/,
            costUnitId /*String*/,
            assignLicenseAggregatedUsages /*AssignLicenseAggregatedUsages*/) {

         var licenseRefToLicenseUsages = null;
         if (assignLicenseAggregatedUsages) {
            licenseRefToLicenseUsages =
                  assignLicenseAggregatedUsages.licenseRefToLicenseUsages;
         }
         var aggregatedLicenseUsages = null;
         if (licenseRef &&
               licenseRefToLicenseUsages &&
               licenseRefToLicenseUsages[licenseRef]) {
            aggregatedLicenseUsages = licenseRefToLicenseUsages[licenseRef];
         }

         var aggregatedProductUsages = null;
         if (productRef &&
               aggregatedLicenseUsages &&
               aggregatedLicenseUsages.productRefToProductUsages &&
               aggregatedLicenseUsages.productRefToProductUsages[productRef]) {
            aggregatedProductUsages =
                  aggregatedLicenseUsages.productRefToProductUsages[productRef];
         }

         var aggregatedCostUnitUsage = null;
         if (costUnitId &&
               aggregatedProductUsages &&
               aggregatedProductUsages.costUnitIdToCostUnitUsage &&
               aggregatedProductUsages.costUnitIdToCostUnitUsage[costUnitId]) {
            aggregatedCostUnitUsage =
                  aggregatedProductUsages.costUnitIdToCostUnitUsage[costUnitId];
         }

         return aggregatedCostUnitUsage;
      }

      function getAssetUnsupportedFeatures(licenseRef /*URI as String*/,
            assetRef /*URI as String*/,
            unsupportedFeatures /*AssignLicenseUnsupportedFeatures*/) {

         var result = {
            unsupportedFeaturesInUse: [],
            unsupportedAvailableFeatures: []
         };

         if (!unsupportedFeatures) {
            return result;
         }

         if (!unsupportedFeatures.licenseRefToUnsupportedFeatures) {
            return result;
         }

         var unsupportedLicenseFeatures =
               unsupportedFeatures.licenseRefToUnsupportedFeatures[licenseRef];
         if (!unsupportedLicenseFeatures) {
            return result;
         }

         var assetRefToUnsupportedFeaturesInUse = {};
         if (!_.isEmpty(unsupportedLicenseFeatures.assetRefToUnsupportedFeaturesInUse)) {
            assetRefToUnsupportedFeaturesInUse =
                  unsupportedLicenseFeatures.assetRefToUnsupportedFeaturesInUse;
         }

         var assetRefToUnsupportedAvailableFeatures = {};
         if (!_.isEmpty(unsupportedLicenseFeatures.assetRefToUnsupportedAvailableFeatures)) {
            assetRefToUnsupportedAvailableFeatures =
                  unsupportedLicenseFeatures.assetRefToUnsupportedAvailableFeatures;
         }

         if (!_.isEmpty(assetRefToUnsupportedFeaturesInUse[assetRef])) {
            result.unsupportedFeaturesInUse =
                  assetRefToUnsupportedFeaturesInUse[assetRef];
         }

         if (!_.isEmpty(assetRefToUnsupportedAvailableFeatures[assetRef])) {
            result.unsupportedAvailableFeatures =
                  assetRefToUnsupportedAvailableFeatures[assetRef];
         }

         return result;
      }

      function isUnlimitedCapacityCostUnit(costUnit /*CostUnit*/) /*boolean*/ {
         return costUnit.limit === 0;
      }

      function isEoemLicense(license /*License*/) /*boolean*/ {
         return !!license.embeddedOem;
      }

      function isEvaluationLicense(license /*License*/) /*boolean*/ {
         return !!license.isEvaluation;
      }

      function isPermanentLicense(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*boolean*/ {
         return getLicenseExpirationRemainingDays(license, validationResult) ===
               Number.POSITIVE_INFINITY;
      }

      function isExpiredLicense(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*boolean*/ {
         return getLicenseExpirationRemainingDays(license, validationResult) <= 0;
      }

      function isExpiringLicense(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*boolean*/ {
         return getLicenseExpirationRemainingDays(license, validationResult) <=
               licenseConstants.LICENSE_EXPIRATION_MAX_WARNING_DAYS_REMAINING;
      }

      function isUnassignableEoemLicense(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*boolean*/ {

         var licenseAssignInfo = getLicenseAssignInfo(license, validationResult);
         return _.contains(
               licenseAssignInfo.assignRestrictions,
               licenseConstants.LicenseAssignRestriction.EmbeddedOemLicense
         );
      }

      function isLicenseFromAnotherVc(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {
         if (validationResult.licenseFromAnotherVcRef === null) {
            return false;
         }

         return validationResult.licenseFromAnotherVcRef === license.uri;
      }

      function getAssignableLicenses(validationResult /*AssetAssignLicenseValidationResult*/) /*Array.<License>*/ {
         if (validationResult) {
            return _.map(validationResult.licensesAssignInfos,
                  function(license) {
                     return license.license;
                  });
         } else {
            return [];
         }
      }

      function getPreSelectedLicense(validationResult /*AssetAssignLicenseValidationResult*/,
            userSelectedLicense /*License*/) /*License*/ {

         var assignableLicenses = getAssignableLicenses(validationResult);

         userSelectedLicense = _.find(assignableLicenses, function(license) {
            return license.uri === getLicenseUri(userSelectedLicense);
         });
         if (userSelectedLicense) {
            return userSelectedLicense;
         }

         if (validationResult && validationResult.assets && validationResult.assets.length > 1 &&
               getLicenseUri(validationResult.assets[0].license) !==
               getLicenseUri(validationResult.assets[1].license)) {
            return null;
         }

         var assignedLicense = _.find(assignableLicenses, function(license) {
            return license.uri === getLicenseUri(validationResult.assets[0].license);
         });
         if (assignedLicense) {
            return assignedLicense;
         }

         if (assignableLicenses.length > 0) {
            return assignableLicenses[0];
         }

         return null;
      }

      function normalizeValidationResult(validationResult /*AssetAssignLicenseValidationResult*/) /*void*/ {

         var asset = validationResult.assets[0];
         var assignableLicenses = getAssignableLicenses(validationResult);

         var assignableEvaluationLicenses =
               _.filter(assignableLicenses, function(license) {
                  return isEvaluationLicense(license);
               });

         var assignableEvaluationLicense = null;
         if (assignableEvaluationLicenses.length === 1) {
            assignableEvaluationLicense = assignableEvaluationLicenses[0];
         }

         if (asset.evaluationLicense && !getLicenseUri(asset.evaluationLicense)) {
            if (getLicenseUri(assignableEvaluationLicense)) {
               asset.evaluationLicense.uri = assignableEvaluationLicense.uri;
            } else {
               asset.evaluationLicense.uri = getDefaultEvaluationLicenseUri();
            }
         }

         if (!getLicenseUri(asset.license) && isEvaluationLicense(asset.license)) {
            if (getLicenseUri(assignableEvaluationLicense)) {
               asset.license.uri = assignableEvaluationLicense.uri;
            } else {
               asset.license.uri = getDefaultEvaluationLicenseUri();
            }
         }
      }

      function getDefaultEvaluationLicenseUri() {
         return defaultUriSchemeUtil.createUri(
               licenseConstants.LICENSE_TYPE,
               licenseConstants.EVALUATION_LICENSE_ID
         );
      }

      function getLicenseUri(license) {
         if (license) {
            return license.uri;
         }

         return null;
      }

      function getLicenseAssignInfo(license /*Licence*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*Array.<License>*/ {
         return _.find(validationResult.licensesAssignInfos,
               function(licenseAssignInfo) {
                  return licenseAssignInfo.license.uri === license.uri;
               });
      }

      function getLicenseExpirationRemainingDays(license /*Licence*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*Number*/ {

         var licenseAssignInfo = getLicenseAssignInfo(license, validationResult);
         if (_.contains(licenseAssignInfo.assignRestrictions,
                     licenseConstants.LicenseAssignRestriction.ExpiredLicense)) {
            return 0;
         }

         var expirationTime = license.expirationTime;
         var expirationDate = license.expirationDate;

         if (expirationDate === null) {
            // Never expires
            if (expirationTime === null) {
               return Number.POSITIVE_INFINITY;
            } else if (expirationTime === 0) {
               return 0;
            }

            throw new Error('Can\'t calculate remaining days');
         }

         var nowMoment = moment();
         var expirationMoment = moment(expirationDate);
         if (expirationMoment.diff(nowMoment, 'milliseconds') <= 0) {
            return 0;
         }

         var days = Math.round(expirationMoment.diff(nowMoment, 'days', true));
         // Days are rounded so if there are less than 12 hours remaining, then days
         // will be 0 so make it to 1.
         if (days === 0) {
            days = 1;
         }

         return days;
      }

      function UsageValidationItem(product/*Product*/, costUnits/*Array.<CostUnit>*/) {
         this.product = product;
         this.costUnits = costUnits;
      }

      function ValidationMessage(id, type, message, details) {
         this.id = id;
         this.type = type;
         this.message = message;
         this.details = details;
      }

      function ValidationMessageDetailsBase(type) {
         this.type = type;
      }

      function ValidationMessageTextDetails(text) {
         ValidationMessageDetailsBase.call(this, ValidationMessageDetailsType.TEXT);
         this.text = text;
      }

      ValidationMessageTextDetails.prototype =
            _.create(ValidationMessageDetailsBase.prototype);
      ValidationMessageTextDetails.prototype.constructor = ValidationMessageTextDetails;

      function ValidationMessageTextAndListDetails(text, list) {
         ValidationMessageDetailsBase.call(
               this,
               ValidationMessageDetailsType.TEXT_AND_LIST
         );
         this.text = text;
         this.list = list;
      }

      ValidationMessageTextAndListDetails.prototype =
            _.create(ValidationMessageDetailsBase.prototype);
      ValidationMessageTextAndListDetails.prototype.constructor =
            ValidationMessageTextAndListDetails;

      return {
         /* Methods */
         getAggregatedCostUnitUsage: getAggregatedCostUnitUsage,
         isUnlimitedCapacityCostUnit: isUnlimitedCapacityCostUnit,
         isEoemLicense: isEoemLicense,
         isEvaluationLicense: isEvaluationLicense,
         isPermanentLicense: isPermanentLicense,
         isExpiredLicense: isExpiredLicense,
         isExpiringLicense: isExpiringLicense,
         isUnassignableEoemLicense: isUnassignableEoemLicense,
         isLicenseFromAnotherVc: isLicenseFromAnotherVc,
         getAssignableLicenses: getAssignableLicenses,
         getPreSelectedLicense: getPreSelectedLicense,
         normalizeValidationResult: normalizeValidationResult,
         getDefaultEvaluationLicenseUri: getDefaultEvaluationLicenseUri,
         getLicenseUri: getLicenseUri,
         getLicenseExpirationRemainingDays: getLicenseExpirationRemainingDays,
         getAssetUnsupportedFeatures: getAssetUnsupportedFeatures,
         /* Classes */
         UsageValidationItem: UsageValidationItem,
         ValidationMessage: ValidationMessage,
         ValidationMessageDetailsBase: ValidationMessageDetailsBase,
         ValidationMessageTextDetails: ValidationMessageTextDetails,
         ValidationMessageTextAndListDetails: ValidationMessageTextAndListDetails,
         /* Enums */
         ValidationMessageType: ValidationMessageType,
         ValidationMessageDetailsType: ValidationMessageDetailsType
      };
   }
}());

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.licenseLibUi')
         .service('licenseTreeListUtil', licenseTreeListUtil);

   licenseTreeListUtil.$inject = ['i18nService', 'licenseCommonUtil'];

   function licenseTreeListUtil(i18nService, licenseCommonUtil) {

      function createLicenseTreeListItems(validationResult /*AssetAssignLicenseValidationResult*/) {
            var assignableLicenses = licenseCommonUtil.getAssignableLicenses(
               validationResult
         );

         var items = _.flatten(_.map(assignableLicenses, function(license) {
            return angular.extend(
                  createLicenseItem(license, validationResult), {
                     parentId: null
                  });
         }));

         var allItems = [];
         while (items.length > 0) {
            var item = items.shift();

            if (item._children) {
               /* jshint loopfunc: true */
               _.each(item._children, function (child) {
                  child.parentId = item.id;
               });

               Array.prototype.push.apply(items, item._children);
               delete item._children;
            }

            allItems.push(item);
         }

         return allItems;
      }

      function createLicenseItem(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {
         var assetAssignedLicenseUri =
               licenseCommonUtil.getLicenseUri(validationResult.assets[0].license);

         var icon = (license.uri === assetAssignedLicenseUri) ?
               "vx-icon-licenseAssigned" : "vx-icon-license";
         var licenseKey = (license.isEvaluation || _.isEmpty(license.serialKeys)) ?
               '--' : license.serialKeys[0];

         var licenseGridItem = {
            id: license.uri,
            _license: license,
            name: license.name,
            icon: icon,
            licenseKey: licenseKey
         };

         var productGridItems =
               _.map(license.productRestrictions, function(productRestriction) {
                  return createProductItem(
                        license,
                        productRestriction.product,
                        validationResult
                  );
               });

         if (_.isEmpty(productGridItems)) {
            var usage = createLicenseItemUsage(
                  license,
                  null,
                  null,
                  validationResult.aggregatedUsages
            );

            productGridItems = [{
               id: license.uri,
               _license: license,
               product: '--',
               capacity: '--',
               usage: usage
            }];
         }

         licenseGridItem = angular.extend(licenseGridItem, productGridItems.shift());
         if (!licenseGridItem._children) {
            licenseGridItem._children = [];
         }
         licenseGridItem._children = licenseGridItem._children.concat(productGridItems);

         return licenseGridItem;
      }

      function createProductItem(license /*License*/,
            product /*Product*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         var productGridItem = {
            id: (license.uri + ' _ ' + product.uri),
            _license: license,
            product: product.formattedName
         };

         var costUnitGridItems = _.map(product.costUnits, function(costUnit) {
            return createCostUnitItem(
                  license,
                  product,
                  costUnit,
                  validationResult
            );
         });

         if (_.isEmpty(costUnitGridItems)) {
            var usage = createLicenseItemUsage(
                  license,
                  product,
                  null,
                  validationResult.aggregatedUsages
            );

            costUnitGridItems = [{
               id: (license.uri + ' _ ' + product.uri),
               _license: license,
               capacity: '--',
               usage: usage
            }];
         }

         productGridItem = angular.extend(productGridItem, costUnitGridItems.shift());
         productGridItem._children = costUnitGridItems;

         return productGridItem;
      }

      function createCostUnitItem(license /*License*/,
            product /*Product*/,
            costUnit /*CostUnit*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         var usage = createLicenseItemUsage(
               license,
               product,
               costUnit,
               validationResult.aggregatedUsages
         );

         var costUnitGridItem = {
            id: (license.uri + ' _ ' + product.uri + ' _ ' + costUnit.id),
            _license: license,
            capacity: costUnit.valueFormat.replace(/%s/g, costUnit.limit),
            usage: usage
         };

         return costUnitGridItem;
      }

      function createLicenseItemUsage(license /*License*/,
            product /*Product*/,
            costUnit /*CostUnit*/,
            assignLicenseAggregatedUsages/*AssignLicenseAggregatedUsages*/) {

         var initialUsageObject = {
            value: NaN,
            label: "--",
            indicateUsageChange: false,
            tooltip: null
         };

         var licenseRef = license.uri;
         var productRef = null;
         var costUnitId = null;

         if (product) {
            productRef = product.uri;

            if (costUnit) {
               costUnitId = costUnit.id;

               initialUsageObject.value = costUnit.usage;
               initialUsageObject.label =
                     costUnit.valueFormat.replace(/%s/g, costUnit.usage);
            }
         }

         var aggregatedCostUnitUsage = licenseCommonUtil.getAggregatedCostUnitUsage(
               licenseRef,
               productRef,
               costUnitId,
               assignLicenseAggregatedUsages);

         var usage = {
            current: angular.merge({}, initialUsageObject),
            selected: createSelectedDeselectedUsageObject(
                  initialUsageObject,
                  aggregatedCostUnitUsage,
                  true
            ),
            deselected: createSelectedDeselectedUsageObject(
                  initialUsageObject,
                  aggregatedCostUnitUsage,
                  false
            )
         };
         usage.current = usage.deselected;

         return usage;
      }

      function createSelectedDeselectedUsageObject(initialUsageObject,
            aggregatedCostUnitUsage /*AssignLicenseAggregatedCostUnitUsage*/,
            selected /*boolean*/) {

         if (!aggregatedCostUnitUsage) {
            return angular.merge({}, initialUsageObject);
         }

         var isUsageCalculationComplete = aggregatedCostUnitUsage.aggregationComplete;
         var value = null;
         if (selected) {
            value = aggregatedCostUnitUsage.usageWithAggregatedAssetUsage;
         } else {
            value = aggregatedCostUnitUsage.usageWithoutAggregatedAssetUsage;
            isUsageCalculationComplete = true;
         }
         var valueFormat = aggregatedCostUnitUsage.costUnit.valueFormat;
         var label = valueFormat.replace(/%s/g, value);

         var indicateUsageChange = true;
         var tooltip = null;

         var usageDifferenceValue = value - initialUsageObject.value;
         var usageDifferenceLabel = valueFormat.replace(/%s/g, usageDifferenceValue);

         if (usageDifferenceValue < 0) {
            tooltip = i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.usageRemoved',
                  initialUsageObject.label
            );
         } else if (usageDifferenceValue === 0 && !isUsageCalculationComplete) {
            tooltip = i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.unavailableUsageDataForAllAssets',
                  initialUsageObject.label
            );
         } else if (usageDifferenceValue > 0) {
            if (isUsageCalculationComplete) {
               tooltip = i18nService.getString(
                     'LicenseLibUi',
                     'assignLicense.usageAdded',
                     usageDifferenceLabel,
                     initialUsageObject.label
               );
            } else {
               tooltip = i18nService.getString(
                     'LicenseLibUi',
                     'assignLicense.unavailableUsageDataForSomeAssets',
                     usageDifferenceLabel,
                     initialUsageObject.label
               );
            }
         } else {
            indicateUsageChange = false;
         }

         return {
            value: value,
            label: label,
            indicateUsageChange: indicateUsageChange,
            tooltip: tooltip
         };
      }

      return {
         createLicenseTreeListItems: createLicenseTreeListItems
      };
   }
}());

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.licenseLibUi')
         .service(
               'licenseValidationMessageBuilder',
               licenseValidationMessageBuilder
         );

   licenseValidationMessageBuilder.$inject = ['i18nService', 'licenseCommonUtil', '$sce'];

   function licenseValidationMessageBuilder(i18nService, licenseCommonUtil, $sce) {
      var licenseUiString = _.partial(i18nService.getString, 'LicenseLibUi');
      var ValidationMessage = licenseCommonUtil.ValidationMessage;
      var ValidationMessageType = licenseCommonUtil.ValidationMessageType;
      var ValidationMessageTextDetails =
            licenseCommonUtil.ValidationMessageTextDetails;
      var ValidationMessageTextAndListDetails =
            licenseCommonUtil.ValidationMessageTextAndListDetails;

      function buildNoLicenseSelectedValidationMessage() {
         return buildValidationMessage(
               'noLicenseSelectedMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.noLicenseSelected')
         );
      }

      function buildSuccessValidationMessage() {
         return buildValidationMessage(
               'validationSuccessMessage',
               ValidationMessageType.OK,
               licenseUiString('assignLicense.validationSuccess')
         );
      }

      function buildLicenseFromAnotherVcValidationMessage() {
         return buildValidationMessageWithTextDetails(
               'licenseFromAnotherVcValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.licenseFromAnotherVcSelected.short'),
               licenseUiString('assignLicense.licenseFromAnotherVcSelected.long')
         );
      }

      function buildEmbeddedOemLicenseUnassignableValidationMessage() {
         return buildValidationMessage(
               'embeddedOemUnassignableValidationMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.unassignableEoemLicense')
         );
      }

      function buildAddHostEmbeddedOemLicenseUnassignableValidationMessage() {
         return buildValidationMessage(
               'embeddedOemUnassignableValidationMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.unassignableEoemLicense.addHost')
         );
      }

      function buildEmbeddedOemLicenseAssignValidationMessage() {
         return buildValidationMessage(
               'embeddedOemAssignValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.embeddedOemLicenseAssign')
         );
      }

      function buildEmbeddedOemLicenseUnassignValidationMessage() {
         return buildValidationMessage(
               'embeddedOemUnassignValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.embeddedOemLicenseUnassign')
         );
      }

      function buildAssetDlfVersionValidationMessage() {
         return buildValidationMessageWithTextDetails(
               'assetDlfVersionValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.unsupportedDlfVersion.short'),
               licenseUiString('assignLicense.unsupportedDlfVersion.long')
         );
      }

      function buildFeaturesInUseValidationMessage(unsupportedFeaturesInUse /*Array.<Feature>*/,
            assetName /*string*/) {

         return buildFeaturesValidationMessage(
               'featuresInUseValidationMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.unsupportedFeaturesInUse.short'),
               unsupportedFeaturesInUse,
               assetName,
               licenseUiString('assignLicense.unsupportedFeaturesInUse.long')
         );
      }

      function buildAvailableFeaturesValidationMessage(unsupportedAvailableFeatures /*Array.<Feature>*/,
            assetName /*string*/) {

         return buildFeaturesValidationMessage('availableFeaturesValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.unsupportedAvailableFeatures.short'),
               unsupportedAvailableFeatures,
               assetName,
               licenseUiString('assignLicense.unsupportedAvailableFeatures.long')
         );
      }

      function buildInsufficientCapacityValidationMessage(usageValidationItems /*Array.<UsageValidationItem>*/) {

         return buildUsageValidationMessage(
               'insufficientCapacityValidationMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.insufficientCapacity.short'),
               licenseUiString('assignLicense.insufficientCapacity.long'),
               usageValidationItems
         );
      }

      function buildUnavailableUsageDataValidationMessage(usageValidationItems /*Array.<UsageValidationItem>*/) {

         return buildUsageValidationMessage(
               'unavailableUsageDataValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.unavailableUsageData.short'),
               licenseUiString('assignLicense.unavailableUsageData.long'),
               usageValidationItems
         );
      }

      function buildUnknownCapacitySufficiencyValidationMessage(usageValidationItems /*Array.<UsageValidationItem>*/) {

         return buildUsageValidationMessage(
               'unavailableUsageDataValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString('assignLicense.unknownCapacitySufficiency.short'),
               licenseUiString('assignLicense.unknownCapacitySufficiency.long'),
               usageValidationItems
         );
      }

      function buildLicenseExpiringValidationMessage(licenseExpirationRemainingDays /*int > 0*/) {
         return buildValidationMessage(
               'licenseExpiringValidationMessage',
               ValidationMessageType.WARNING,
               licenseUiString(
                     'assignLicense.licenseExpiring',
                     licenseExpirationRemainingDays
               )
         );
      }

      function buildLicenseExpiredValidationMessage() {
         return buildValidationMessage(
               'licenseExpiredValidationMessage',
               ValidationMessageType.ALERT,
               licenseUiString('assignLicense.licenseExpired')
         );
      }

      function buildFeaturesValidationMessage(id,
            type,
            message,
            unsupportedFeatures /*Array.<Feature>*/,
            assetName /*string*/,
            detailsText) {

         var featuresFormattedIds /*Array.<string>*/ =
               _.map(unsupportedFeatures, function(feature) {
                  return feature.formattedId;
               });
         var featuresDelim = licenseUiString('assignLicense.unsupportedFeatures.delim');
         var featuresListText = featuresFormattedIds.join(featuresDelim);

         var detailsList = [licenseUiString(
               'assignLicense.unsupportedFeatures.format',
               assetName,
               featuresListText
         )];

         return buildValidationMessageWithTextAndListDetails(
               id,
               type,
               message,
               detailsText,
               detailsList
         );
      }

      function buildUsageValidationMessage(id,
            type,
            message,
            detailsText,
            usageValidationItems /*Array.<UsageValidationItem>*/) {

         var detailsList = _.map(usageValidationItems, function(validationItem) {
            var costUnits /*Array.<CostUnit>*/ = validationItem.costUnits;
            var costUnitsFormattedIds /*Array.<string>*/ =
                  _.map(costUnits, function(costUnit) {
                     return costUnit.formattedId;
                  });
            var costUnitsDelim = licenseUiString(
                  'assignLicense.usageValidation.delim'
            );
            var costUnitsText = costUnitsFormattedIds.join(costUnitsDelim);

            return licenseUiString(
                  'assignLicense.usageValidation.format',
                  validationItem.product.formattedName,
                  costUnitsText
            );
         });

         return buildValidationMessageWithTextAndListDetails(
               id,
               type,
               message,
               detailsText,
               detailsList
         );
      }

      function buildValidationMessage(id,
            type,
            message,
            details) {

         message = $sce.trustAsHtml(message);

         return new ValidationMessage(
               id,
               type,
               message,
               details
         );
      }

      function buildValidationMessageWithTextDetails(id,
            type,
            message,
            detailsText) {

         detailsText = $sce.trustAsHtml(detailsText);

         var details = new ValidationMessageTextDetails(
               detailsText
         );

         return buildValidationMessage(
               id,
               type,
               message,
               details);
      }

      function buildValidationMessageWithTextAndListDetails(id,
            type,
            message,
            detailsText,
            detailsList) {

         detailsText = $sce.trustAsHtml(detailsText);
         detailsList = _.map(detailsList, function (detailsListItem) {
            return $sce.trustAsHtml(detailsListItem);
         });

         var details = new ValidationMessageTextAndListDetails(
               detailsText,
               detailsList
         );

         return buildValidationMessage(
               id,
               type,
               message,
               details);
      }

      return {
         buildNoLicenseSelectedValidationMessage: buildNoLicenseSelectedValidationMessage,
         buildSuccessValidationMessage: buildSuccessValidationMessage,
         buildLicenseFromAnotherVcValidationMessage: buildLicenseFromAnotherVcValidationMessage,
         buildEmbeddedOemLicenseUnassignableValidationMessage: buildEmbeddedOemLicenseUnassignableValidationMessage,
         buildEmbeddedOemLicenseAssignValidationMessage: buildEmbeddedOemLicenseAssignValidationMessage,
         buildEmbeddedOemLicenseUnassignValidationMessage: buildEmbeddedOemLicenseUnassignValidationMessage,
         buildAddHostEmbeddedOemLicenseUnassignableValidationMessage: buildAddHostEmbeddedOemLicenseUnassignableValidationMessage,
         buildAssetDlfVersionValidationMessage: buildAssetDlfVersionValidationMessage,
         buildFeaturesInUseValidationMessage: buildFeaturesInUseValidationMessage,
         buildAvailableFeaturesValidationMessage: buildAvailableFeaturesValidationMessage,
         buildInsufficientCapacityValidationMessage: buildInsufficientCapacityValidationMessage,
         buildUnavailableUsageDataValidationMessage: buildUnavailableUsageDataValidationMessage,
         buildUnknownCapacitySufficiencyValidationMessage: buildUnknownCapacitySufficiencyValidationMessage,
         buildLicenseExpiringValidationMessage: buildLicenseExpiringValidationMessage,
         buildLicenseExpiredValidationMessage: buildLicenseExpiredValidationMessage
      };
   }
}());

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.licenseLibUi')
         .service('licenseValidationUtil', licenseValidationUtil);

   licenseValidationUtil.$inject = [
      'licenseValidationMessageBuilder',
      'licenseCommonUtil',
      'licenseConstants',
      'i18nService',
      '$q',
      '$rootScope',
      'vuiDialogService'
   ];

   function licenseValidationUtil(validationMessageBuilder, licenseCommonUtil,
         licenseConstants, i18nService, $q, $rootScope, vuiDialogService) {
      var UsageValidationItem = licenseCommonUtil.UsageValidationItem;

      function getValidationMessages(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState /*Boolean*/) {
         if (!license) {
            license = null;
         }

         var validationMessages /*Array.<ValidationMessage>*/ = [
            getNoLicenseSelectedValidationMessage(license),
            getLicenseFromAnotherVcValidationMessage(license, validationResult),
            getEoemValidationMessage(license, validationResult, isAddHostState),
            getFeaturesValidationMessage(license, validationResult, isAddHostState),
            getUsageValidationMessage(license, validationResult),
            getExpirationValidationMessage(license, validationResult)
         ];

         validationMessages = _.filter(validationMessages,
               function(message) {
                  return message !== null;
               });

         if (_.isEmpty(validationMessages)) {
            validationMessages = [
               getSuccessValidationMessage()
            ];
         }

         return validationMessages;
      }

      function getValidationBlockingErrors(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState /*Boolean*/) {
         if (!license) {
            license = null;
         }

         var validationBlockingErrors = [
            getNoLicenseSelectedBlockingError(license),
            getExpiredLicenseBlockingError(license, validationResult),
            getEoemBlockingError(license, validationResult, isAddHostState),
            getFeaturesInUseBlockingError(license, validationResult, isAddHostState),
            getInsufficientCapacityBlockingError(license, validationResult)
         ];

         validationBlockingErrors = _.filter(validationBlockingErrors,
               function(error) {
                  return error !== null;
               });

         return validationBlockingErrors;
      }

      function getValidationWarnings(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         if (!license) {
            license = null;
         }

         var validationWarnings = [
            getLicenseFromAnotherVcWarning(license, validationResult),
            getInsufficientCapacityWarning(license, validationResult)
         ];

         validationWarnings = _.filter(validationWarnings,
               function(error) {
                  return error !== null;
               });

         return validationWarnings;
      }

      function showLicenseWarningsConfirmationDialog(warnings) {
         var deferred = $q.defer();
         var promise = deferred.promise;

         var dialogScope = $rootScope.$new();
         dialogScope.dialogOptions = {
            title: i18nService.getString(
               'LicenseLibUi',
               'assignLicense.warning.confirmationDialog.title'
            ),
            contentUrl: 'license-lib-ui/resources/license/components/licenseSelector' +
               '/licenseWarningsConfirmationDialogContent.html',
            show: true,
            rejectOptions: {
               label: i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.warning.confirmationDialog.cancelButtonLabel'
               ),
               onClick: function() {
                  deferred.reject(false);
                  return true;
               }
            },
            confirmOptions: {
               label: i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.warning.confirmationDialog.okButtonLabel'
               ),
               onClick: function() {
                  deferred.resolve(true);
                  return true;
               }
            },
            width: '600px',
            height: 'auto'
         };
         dialogScope.contentModel = {
            warnings: warnings
         };

         var options = {
            scope: dialogScope,
            configObjectName: 'dialogOptions'
         };

         vuiDialogService(options);

         return promise;
      }

      function getSuccessValidationMessage() {
         return validationMessageBuilder.buildSuccessValidationMessage();
      }

      function getNoLicenseSelectedValidationMessage(license/*License*/) {
         if (license === null) {
            return validationMessageBuilder.buildNoLicenseSelectedValidationMessage();
         }

         return null;
      }

      function getLicenseFromAnotherVcValidationMessage(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {
         if (license === null) {
            return null;
         }

         if (licenseCommonUtil.isLicenseFromAnotherVc(license, validationResult)) {
            return validationMessageBuilder.buildLicenseFromAnotherVcValidationMessage();
         }

         return null;
      }

      function getEoemValidationMessage(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState) /*ValidationMessage*/ {
         if (license === null) {
            return null;
         }
         var assignedLicense = validationResult.assets[0].license;

         if (licenseCommonUtil.getLicenseUri(license) ===
               licenseCommonUtil.getLicenseUri(assignedLicense)) {
            // We have selected the currently assigned license to all assets. No EOEM
            // license assignments are changed.
            return null;
         }

         if (licenseCommonUtil.isUnassignableEoemLicense(license, validationResult)) {
            if (isAddHostState) {
               return validationMessageBuilder
                     .buildAddHostEmbeddedOemLicenseUnassignableValidationMessage();
            } else {
               return validationMessageBuilder
                     .buildEmbeddedOemLicenseUnassignableValidationMessage();
            }
         }

         if (assignedLicense && licenseCommonUtil.isEoemLicense(assignedLicense)) {
            // The new license is not EOEM. We need to check whether some of the assets
            // have EOEM license currently assigned, which we will change with non-EOEM.
            return validationMessageBuilder
                  .buildEmbeddedOemLicenseUnassignValidationMessage();
         }

         if (licenseCommonUtil.isEoemLicense(license)) {
            // If the selected license is EOEM and it is not currently assigned to all
            // assets, we are assigning it to at least 1 new asset, thus we are changing
            // the EOEM license assignments.
            return validationMessageBuilder
                  .buildEmbeddedOemLicenseAssignValidationMessage();
         }

         return null;
      }

      function getFeaturesValidationMessage(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState) /*ValidationMessage*/ {
         if (license === null) {
            return null;
         }

         if (isAddHostState && license.isEvaluation) {
            // There is no option to validate host evaluation license in add host state
            // because the lack of info about evaluation license in ConnectInfo object.
            // Selecting evaluation license in add host state is considered as upgrade.
            return null;
         }

         if (!validationResult.isAssetDlfVersionSupported) {
            return validationMessageBuilder.buildAssetDlfVersionValidationMessage();
         }

         var asset = validationResult.assets[0];
         var assetUnsupportedFeatures = licenseCommonUtil.getAssetUnsupportedFeatures(
               license.uri,
               asset.uri,
               validationResult.unsupportedFeatures
         );

         if (!_.isEmpty(assetUnsupportedFeatures.unsupportedFeaturesInUse)) {
            return validationMessageBuilder.buildFeaturesInUseValidationMessage(
                  assetUnsupportedFeatures.unsupportedFeaturesInUse,
                  asset.name
            );
         }

         if (!_.isEmpty(assetUnsupportedFeatures.unsupportedAvailableFeatures)) {
            return validationMessageBuilder.buildAvailableFeaturesValidationMessage(
                  assetUnsupportedFeatures.unsupportedAvailableFeatures,
                  asset.name
            );
         }

         // There are no validation problems with the features of the new license.
         return null;
      }

      function getUsageValidationMessage(license /*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*ValidationMessage*/ {
         if (license === null) {
            return null;
         }

         var insufficientCapacityUsageValidationItems /*Array.<UsageValidationItem>*/ =
               getInsufficientCapacityUsageValidationItems(
                     license,
                     validationResult.aggregatedUsages
               );
         if (!_.isEmpty(insufficientCapacityUsageValidationItems)) {
            return validationMessageBuilder.buildInsufficientCapacityValidationMessage(
                  insufficientCapacityUsageValidationItems
            );
         }

         var unavailableUsageDataUsageValidationItems /*Array.<UsageValidationItem>*/ =
               getUnavailableDataUsageValidationItems(
                     license,
                     validationResult.aggregatedUsages
               );
         if (!_.isEmpty(unavailableUsageDataUsageValidationItems)) {
            if (areAllCostUnitCapacitiesUnlimited(unavailableUsageDataUsageValidationItems)) {
               return validationMessageBuilder.buildUnavailableUsageDataValidationMessage(
                     unavailableUsageDataUsageValidationItems
               );
            } else {
               return validationMessageBuilder.buildUnknownCapacitySufficiencyValidationMessage(
                     unavailableUsageDataUsageValidationItems
               );
            }
         }

         // There are no validation problems with the usage of the new license.
         return null;
      }

      function getInsufficientCapacityUsageValidationItems(license/*license*/,
            assignLicenseAggregatedUsages /*AssignLicenseAggregatedUsages*/) /*Array.<*UsageValidationItem>*/ {

         if (license === null) {
            return [];
         }

         return _.filter(
               _.map(license.productRestrictions, function(productRestriction) {
                  var product = productRestriction.product;

                  var costUnitsWithInsufficientCapacity =
                        getCostUnitsWithInsufficientCapacity(
                              license,
                              product,
                              assignLicenseAggregatedUsages
                        );

                  if (_.isEmpty(costUnitsWithInsufficientCapacity)) {
                     return null;
                  }

                  return new UsageValidationItem(
                        product,
                        costUnitsWithInsufficientCapacity
                  );
               }),
               function(validationItem) {
                  return !_.isNull(validationItem);
               });

      }

      function getCostUnitsWithInsufficientCapacity(license /*License*/,
            product /*Product*/,
            assignLicenseAggregatedUsages /*AssignLicenseAggregatedUsages*/) /*Array.<CostUnit>*/ {

         if (license === null || product === null) {
            return [];
         }

         return _.filter(product.costUnits, function(costUnit) {
            if (licenseCommonUtil.isUnlimitedCapacityCostUnit(costUnit)) {
               return false;
            }

            var aggregatedCostUnitUsage = licenseCommonUtil.getAggregatedCostUnitUsage(
                  license.uri,
                  product.uri,
                  costUnit.id,
                  assignLicenseAggregatedUsages
            );

            if (aggregatedCostUnitUsage === null) {
               return false;
            }

            var costUnitUsageWithAsset = licenseCommonUtil.isEoemLicense(license) ?
                  aggregatedCostUnitUsage.maxAssetUsage :
                  aggregatedCostUnitUsage.usageWithAggregatedAssetUsage;

            return costUnitUsageWithAsset > costUnit.limit;
         });
      }

      function getUnavailableDataUsageValidationItems(license/*license*/,
            assignLicenseAggregatedUsages /*AssignLicenseAggregatedUsages*/) /*Array.<*UsageValidationItem>*/ {

         if (license === null) {
            return [];
         }

         return _.filter(
               _.map(license.productRestrictions, function(productRestriction) {
                  var product = productRestriction.product;

                  var costUnitsWithMissingAssetsContribution =
                        getCostUnitsWithMissingAssetsContribution(
                              license,
                              product,
                              assignLicenseAggregatedUsages
                        );

                  if (_.isEmpty(costUnitsWithMissingAssetsContribution)) {
                     return null;
                  }

                  return new UsageValidationItem(
                        product,
                        costUnitsWithMissingAssetsContribution
                  );
               }),
               function(validationItem) {
                  return !_.isNull(validationItem);
               });
      }

      function getCostUnitsWithMissingAssetsContribution(license /*License*/,
            product /*Product*/,
            assignLicenseAggregatedUsages /*AssignLicenseAggregatedUsages*/) /*Array.<CostUnit>*/ {

         if (license === null || product === null) {
            return [];
         }

         return _.filter(product.costUnits, function(costUnit) {
            var aggregatedCostUnitUsage = licenseCommonUtil.getAggregatedCostUnitUsage(
                  license.uri,
                  product.uri,
                  costUnit.id,
                  assignLicenseAggregatedUsages);

            return aggregatedCostUnitUsage !== null && !aggregatedCostUnitUsage.aggregationComplete;
         });
      }

      function areAllCostUnitCapacitiesUnlimited(validationItems /*Array.<UsageValidationItem>*/) /*boolean*/ {
         return _.every(validationItems, function(validationItem) {
            return _.every(validationItem.costUnits, function(costUnit) {
               return licenseCommonUtil.isUnlimitedCapacityCostUnit(costUnit);
            });
         });
      }

      function getExpirationValidationMessage(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) /*ValidationMessage*/ {
         if (license === null) {
            return null;
         }

         if (licenseCommonUtil.isPermanentLicense(license, validationResult)) {
            return null;
         }

         if (licenseCommonUtil.isExpiredLicense(license, validationResult)) {
            return validationMessageBuilder.buildLicenseExpiredValidationMessage();
         }

         if (licenseCommonUtil.isExpiringLicense(license, validationResult)) {
            // License expires in less than <X> days
            var remainingDays = licenseCommonUtil.getLicenseExpirationRemainingDays(
                  license, validationResult
            );

            return validationMessageBuilder
                  .buildLicenseExpiringValidationMessage(remainingDays);
         }

         return null;
      }

      function getNoLicenseSelectedBlockingError(license/*License*/) {
         if (license === null) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.blockingError.noLicenseSelected'
            );
         }

         return null;
      }

      function getExpiredLicenseBlockingError(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         if (license === null) {
            return null;
         }

         if (licenseCommonUtil.isPermanentLicense(license, validationResult)) {
            return null;
         }

         if (licenseCommonUtil.isExpiredLicense(license, validationResult)) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.blockingError.licenseExpired'
            );
         }

         return null;
      }

      function getEoemBlockingError(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState /*Boolean*/) {

         if (license === null) {
            return null;
         }

         var assignedLicense = validationResult.assets[0].license;

         if (licenseCommonUtil.getLicenseUri(license) ===
               licenseCommonUtil.getLicenseUri(assignedLicense)) {
            // We have selected the currently assigned license to all assets. No EOEM
            // license assignments are changed.
            return null;
         }

         if (licenseCommonUtil.isUnassignableEoemLicense(license, validationResult)) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.blockingError.unassignableEoemLicense'
                        + (isAddHostState ? ".addHost" : "")
            );
         }

         return null;
      }

      function getFeaturesInUseBlockingError(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/,
            isAddHostState /*Boolean*/) {

         if (license === null) {
            return null;
         }

         if (isAddHostState && license.isEvaluation) {
            // There is no option to validate host evaluation license in add host state
            // because the lack of info about evaluation license in ConnectInfo object.
            // Selecting evaluation license in add host state is considered as upgrade.
            return null;
         }

         var asset = validationResult.assets[0];

         var assetUnsupportedFeatures = licenseCommonUtil.getAssetUnsupportedFeatures(
               license.uri,
               asset.uri,
               validationResult.unsupportedFeatures
         );

         if (!_.isEmpty(assetUnsupportedFeatures.unsupportedFeaturesInUse)) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.blockingError.unsupportedFeaturesInUse'
            );
         }

         return null;
      }

      function getInsufficientCapacityBlockingError(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         var insufficientCapacityItems /*UsageValidationItem*/ =
               getInsufficientCapacityUsageValidationItems(
                     license,
                     validationResult.aggregatedUsages
               );

         var hasInsufficientCapacityCostUnitWithHardEnforcedLimit =
               _.some(insufficientCapacityItems, function(insufficientCapacityItem) {
                  return _.some(insufficientCapacityItem.costUnits, function(costUnit) {
                     return licenseConstants.LimitEnforcementType.HARD_ENFORCED ===
                           costUnit.limitEnforcementType;
                  });
               });

         if (hasInsufficientCapacityCostUnitWithHardEnforcedLimit) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.blockingError.insufficientCapacity'
            );
         }

         return null;
      }

      function getLicenseFromAnotherVcWarning(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         if (license === null) {
            return null;
         }

         if (licenseCommonUtil.isLicenseFromAnotherVc(license, validationResult)) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.warning.licenseFromAnotherVc'
            );
         }

         return null;
      }

      function getInsufficientCapacityWarning(license/*License*/,
            validationResult /*AssetAssignLicenseValidationResult*/) {

         if (license === null) {
            return null;
         }

         var insufficientCapacityItems /*UsageValidationItem*/ =
               getInsufficientCapacityUsageValidationItems(
                     license,
                     validationResult.aggregatedUsages
               );

         if (!_.isEmpty(insufficientCapacityItems)) {
            return i18nService.getString(
                  'LicenseLibUi',
                  'assignLicense.warning.insufficientCapacity'
            );
         }

         return null;

      }

      return {
         getValidationMessages: getValidationMessages,
         getValidationBlockingErrors: getValidationBlockingErrors,
         getValidationWarnings: getValidationWarnings,
         showLicenseWarningsConfirmationDialog: showLicenseWarningsConfirmationDialog
      };
   }
}());

/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
var license_lib_ui;
(function (license_lib_ui) {
    var AssignLicenseFormController = (function () {
        function AssignLicenseFormController($scope, assignLicenseService, clarityConstants, licenseConstants, licenseValidationUtil, defaultUriSchemeUtil, managedEntityConstants, i18nService) {
            this.$scope = $scope;
            this.assignLicenseService = assignLicenseService;
            this.clarityConstants = clarityConstants;
            this.licenseConstants = licenseConstants;
            this.licenseValidationUtil = licenseValidationUtil;
            this.defaultUriSchemeUtil = defaultUriSchemeUtil;
            this.managedEntityConstants = managedEntityConstants;
            this.i18nService = i18nService;
            this.NEW_LICENSE_URI = "urn:vri:License:NEW_LICENSE_ID";
            this.TABS = [
                {
                    label: this.i18nService.getString("LicenseLibUi", "assignLicense.tab.existingLicenses"),
                    id: "existing-licenses-btn",
                    value: "existing-licenses",
                    submitButtonDisabled: true
                },
                {
                    label: this.i18nService.getString("LicenseLibUi", "assignLicense.tab.newLicense"),
                    id: "new-license-btn",
                    value: "new-license",
                    submitButtonDisabled: true
                }
            ];
        }
        AssignLicenseFormController.prototype.$onInit = function () {
            var _this = this;
            this.selectedTab = this.TABS[0].value;
            this.$scope.modalOptions.onSubmit = function () {
                if (_this.dataRetrievalError) {
                    return true;
                }
                if (!_this.selectedLicense) {
                    return false;
                }
                // Validation methods all search for the license in the this.licenseData which does not contain the new license.
                // Moreover, each hosted component (the grid for the existing licenses and form for adding a new license)
                // should be responsible for its validation errors.
                var errors = _this.selectedLicense.uri === _this.NEW_LICENSE_URI
                    ? []
                    : _this.licenseValidationUtil.getValidationBlockingErrors(_this.selectedLicense, _this.licenseData, false);
                if (!_.isEmpty(errors)) {
                    _this.setModalErrors(errors);
                    return false;
                }
                var warnings = _this.licenseValidationUtil.getValidationWarnings(_this.selectedLicense, _this.licenseData, false);
                if (!_.isEmpty(warnings)) {
                    return _this.licenseValidationUtil.showLicenseWarningsConfirmationDialog(warnings)
                        .then(function (result) {
                        _this.performLicenseAssignment();
                        return true;
                    }, function (reason) {
                        return false;
                    });
                }
                _this.performLicenseAssignment();
                return true;
            };
            this.loading = true;
            this.assetRefs = this.$scope.modalOptions.dialogData.availableTargets;
            this.assignLicenseService.retrieveLicenses(this.assetRefs).then(function (licenseData) {
                _this.licenseData = licenseData;
                _this.loading = false;
            }).catch(function (responseError) {
                if (_this.isClusterNotRegistered(responseError)) {
                    _this.dataRetrievalError =
                        _this.i18nService.getString('LicenseLibUi', 'assets.clusterNotRegistered');
                }
                else {
                    _this.dataRetrievalError = responseError.localizedMessage;
                }
                _this.loading = false;
            });
        };
        AssignLicenseFormController.prototype.onTabChanged = function () {
            var _this = this;
            var currentTab = this.TABS.filter(function (item) {
                return item.value === _this.selectedTab;
            });
            this.toggleSubmitButtonState(currentTab[0].submitButtonDisabled);
        };
        AssignLicenseFormController.prototype.toggleSubmitButtonState = function (disabled) {
            this.$scope.modalOptions.submitDisabled = disabled;
        };
        AssignLicenseFormController.prototype.existingLicensesTabSubmitButtonDisabled = function (disabled) {
            this.TABS[0].submitButtonDisabled = disabled;
            if (this.selectedTab === this.TABS[0].value) {
                this.toggleSubmitButtonState(disabled);
            }
        };
        AssignLicenseFormController.prototype.newLicenseTabSubmitButtonDisabled = function (isStateValid) {
            this.TABS[1].submitButtonDisabled = !isStateValid;
            if (this.selectedTab === this.TABS[1].value) {
                this.toggleSubmitButtonState(!isStateValid);
            }
        };
        Object.defineProperty(AssignLicenseFormController.prototype, "showNewLicenseView", {
            get: function () {
                return this.selectedTab === this.TABS[1].value;
            },
            enumerable: true,
            configurable: true
        });
        AssignLicenseFormController.prototype.onLicenseItemChanged = function (license) {
            this.selectedLicense = license;
        };
        AssignLicenseFormController.prototype.isClusterNotRegistered = function (error) {
            return error._type === this.licenseConstants.RESPONSE_FAULT.LICENSING_METHOD_FAULT
                && this.areAllAssetsClusterServerObjects();
        };
        AssignLicenseFormController.prototype.areAllAssetsClusterServerObjects = function () {
            var _this = this;
            if (!this.assetRefs) {
                return false;
            }
            var areAllClusterRefs = _.every(this.assetRefs, function (assetRef) {
                var objectType = _this.defaultUriSchemeUtil.getEntityType(assetRef);
                return objectType === _this.managedEntityConstants.CLUSTER;
            });
            return areAllClusterRefs;
        };
        AssignLicenseFormController.prototype.setModalErrors = function (errors) {
            var _this = this;
            var errorObjects = _.map(errors, function (err) {
                return {
                    text: err,
                    type: _this.clarityConstants.notifications.type.ERROR
                };
            });
            this.$scope.modalOptions.alerts = errorObjects;
        };
        AssignLicenseFormController.prototype.performLicenseAssignment = function () {
            var licenseUri = this.selectedLicense.uri;
            var assetUris = _.map(this.licenseData.assets, function (asset) {
                return asset.uri;
            });
            if (licenseUri === this.NEW_LICENSE_URI) {
                this.assignLicenseService.assignNewLicense(assetUris, this.selectedLicense.serialKeys, this.selectedLicense.name);
            }
            else {
                this.assignLicenseService.assignLicense(assetUris, licenseUri);
            }
        };
        AssignLicenseFormController.$inject = [
            '$scope',
            'assignLicenseService',
            'clarityConstants',
            'licenseConstants',
            'licenseValidationUtil',
            'defaultUriSchemeUtil',
            'managedEntityConstants',
            'i18nService'
        ];
        return AssignLicenseFormController;
    }());
    license_lib_ui.AssignLicenseFormController = AssignLicenseFormController;
    angular.module('com.vmware.vsphere.client.licenseLibUi').controller('AssignLicenseFormController', AssignLicenseFormController);
})(license_lib_ui || (license_lib_ui = {}));





/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
h5 = h5 || {};
h5.license = {
   angularModule: angular.module('com.vmware.vsphere.client.licenseUi', [
      'com.vmware.platform.ui', 'com.vmware.vsphere.client.commonModule',
      'com.vmware.vsphere.client.licenseLibUi'
   ])
};

angular.module('com.vmware.vsphere.client.licenseUi')
   .run(['serialKeyLicenseActionsService', function(serialKeyLicenseActionsService) {
      h5.actions["vsphere.core.administration.removeLicensesAction"] =
            function(actionEval, availableTargets, context) {
               if(!availableTargets) {
                  return;
               }

               serialKeyLicenseActionsService.removeLicenseKey(availableTargets);
            };

      h5.actions["vsphere.core.administration.renameLicenseAction"] =
            function(actionEval, availableTargets, context) {
               if(!availableTargets || !context) {
                  return;
               }

               serialKeyLicenseActionsService.renameSerialKeyLicense(context);
            };

      h5.actions["vsphere.core.administration.addLicenseAction"] =
            function(actionEval, availableTargets, context) {
               if (!context) {
                  return;
               }

               serialKeyLicenseActionsService.addSerialKeyLicense(context);
            };

      h5.actions["vsphere.core.administration.syncFromPortalAction"] =
            function(actionEval, availableTargets, context) {
               if (!context) {
                  return;
               }

               serialKeyLicenseActionsService.syncSerialKeyLicenses(context);
            };
   }])
   .run(['assetActionsService', 'assignLicenseService',
      function(assetActionsService, assignLicenseService) {
         h5.actions["vsphere.core.administration.removeSolutionsAction"] =
            function(actionEval, availableTargets, context) {
               if (!availableTargets) {
                  return;
               }

               assetActionsService.removeSolution(availableTargets);
            };

         h5.actions["vsphere.core.administration.assignLicenseKeyAction"] =
            function(actionEval, availableTargets, context) {
               if (!availableTargets) {
                  return;
               }

               assignLicenseService.showAssignLicenseForm(availableTargets);
            };
      }]);

var license_ui;
(function (license_ui) {
    var AssetActionsService = (function () {
        function AssetActionsService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(AssetActionsService.prototype, "vcAssetActionsService", {
            get: function () {
                if (!this._vcAssetActionsService) {
                    this._vcAssetActionsService = this.$injector.get("vcAssetActionsService");
                }
                return this._vcAssetActionsService;
            },
            enumerable: true,
            configurable: true
        });
        AssetActionsService.prototype.removeSolution = function (solutionsToRemove) {
            this.vcAssetActionsService.removeSolution(solutionsToRemove);
        };
        AssetActionsService.$inject = ['$injector'];
        return AssetActionsService;
    }());
    license_ui.AssetActionsService = AssetActionsService;
    angular.module('com.vmware.vsphere.client.licenseUi').service('assetActionsService', AssetActionsService);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var SerialKeyLicenseActionsService = (function () {
        function SerialKeyLicenseActionsService($injector) {
            this.$injector = $injector;
        }
        Object.defineProperty(SerialKeyLicenseActionsService.prototype, "vcSerialKeyLicenseActionsService", {
            get: function () {
                if (!this._vcSerialKeyLicenseActionsService) {
                    this._vcSerialKeyLicenseActionsService = this.$injector.get("vcSerialKeyLicenseActionsService");
                }
                return this._vcSerialKeyLicenseActionsService;
            },
            enumerable: true,
            configurable: true
        });
        SerialKeyLicenseActionsService.prototype.removeLicenseKey = function (licenseUriIds) {
            this.vcSerialKeyLicenseActionsService.removeLicenseKey(licenseUriIds);
        };
        SerialKeyLicenseActionsService.prototype.renameSerialKeyLicense = function (license) {
            this.vcSerialKeyLicenseActionsService.renameSerialKeyLicense(license);
        };
        SerialKeyLicenseActionsService.prototype.addSerialKeyLicense = function (scope) {
            this.vcSerialKeyLicenseActionsService.addSerialKeyLicense(scope);
        };
        SerialKeyLicenseActionsService.prototype.syncSerialKeyLicenses = function (scope) {
            this.vcSerialKeyLicenseActionsService.syncSerialKeyLicenses(scope);
        };
        SerialKeyLicenseActionsService.$inject = ['$injector'];
        return SerialKeyLicenseActionsService;
    }());
    license_ui.SerialKeyLicenseActionsService = SerialKeyLicenseActionsService;
    angular.module('com.vmware.vsphere.client.licenseUi').service('serialKeyLicenseActionsService', SerialKeyLicenseActionsService);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicensesManagementConstants = (function () {
        function LicensesManagementConstants() {
            this.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID = "vsphere.core.administration.licensesView";
            this.LICENSES_ADMINISTRATION_VIEW_TAB_ID = "license.management.licensesList";
            this.PRODUCTS_ADMINISTRATION_VIEW_TAB_ID = "license.management.productsList";
            this.ASSETS_ADMINISTRATION_VIEW_TAB_ID = "license.management.assetsList";
            this.LICENSES_MANAGEMENT_NAVIGATION_REQUEST_EVENT = "licensingManagementNavigationRequest";
            this.LICENSES_MANAGEMENT_NAVIGATION_PERFORMED_EVENT = "licensingManagementNavigationPerformed";
            this.ASSETS_MANAGEMENT_NAVIGATION_PERFORMED_EVENT = "assetsManagementNavigationRequest";
            this.LICENSES_MANAGEMENT_SELECTED_TAB_CHANGED_EVENT = "licensingManagementSelectedTabChanged";
        }
        return LicensesManagementConstants;
    }());
    license_ui.LicensesManagementConstants = LicensesManagementConstants;
    angular.module('com.vmware.vsphere.client.licenseUi').constant('licensesManagementConstants', new LicensesManagementConstants());
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicensesManagementNavigationService = (function () {
        function LicensesManagementNavigationService(navigation, licensesManagementConstants) {
            this.navigation = navigation;
            this.licensesManagementConstants = licensesManagementConstants;
            this.TAB_IDS_DELIMITER = ",";
        }
        LicensesManagementNavigationService.prototype.navigateByProvidedLicensingRouteObject = function (licensingRouteObject) {
            if (!licensingRouteObject) {
                return;
            }
            var routingInformation = {};
            if (licensingRouteObject.tabPaths && licensingRouteObject.tabPaths.length) {
                routingInformation.tabPaths = licensingRouteObject.tabPaths.join(this.TAB_IDS_DELIMITER);
            }
            if (licensingRouteObject.itemId) {
                routingInformation.itemId = licensingRouteObject.itemId;
            }
            angular.extend(routingInformation, this.extractAdditionalParametersFromRoute());
            this.navigation.navigate(licensingRouteObject.extensionId, null, routingInformation);
        };
        LicensesManagementNavigationService.prototype.navigateToLicensesManagementTabByTabId = function (tabId) {
            // if the url route already indicates that the given tab is selected, do nothing.
            var route = this.navigation.getRouteFromUrl();
            if (route && route.extensionId === this.licensesManagementConstants.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID) {
                if (route.tabPaths && route.tabPaths.length) {
                    var tabPaths_1 = route.tabPaths.split(this.TAB_IDS_DELIMITER);
                    if (tabPaths_1[0] === tabId) {
                        return;
                    }
                }
                else if (!tabId || !tabId.length) {
                    // If the given tab id is empty then it must be navigated to the default view.
                    // The route extracted from the URL indicates that it is already navigated to the default view,
                    // so do nothing
                    return;
                }
            }
            var tabPaths = tabId ? [tabId] : [];
            var licensingRouteObject = {
                extensionId: this.licensesManagementConstants.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID,
                tabPaths: tabPaths
            };
            this.navigateByProvidedLicensingRouteObject(licensingRouteObject);
        };
        LicensesManagementNavigationService.prototype.extractLicensingRouteObjectFromUrl = function (rootTabPathIndex) {
            var route = this.navigation.getRouteFromUrl();
            if (!route || !route.extensionId) {
                return null;
            }
            var licensingRouteObject = {
                extensionId: route.extensionId,
                tabPaths: []
            };
            if (route.tabPaths && route.tabPaths.length) {
                licensingRouteObject.tabPaths = route.tabPaths
                    .split(this.TAB_IDS_DELIMITER);
                if (rootTabPathIndex) {
                    var removeCount = isNaN(rootTabPathIndex) ? 0 : rootTabPathIndex;
                    licensingRouteObject.tabPaths.splice(0, removeCount);
                }
            }
            if (route.itemId) {
                licensingRouteObject.itemId = route.itemId;
            }
            return licensingRouteObject;
        };
        /**
         * Check if the given tabPaths correspond to a view which can handle the navigation request represented by the licensing route object
         *
         * @param tabPaths - The tabPaths against which the navigation request has to be tested
         * @param licensingRouteObject - Represents the location it is tried to be navigated to.
         * @returns {boolean} True if the tabPaths represents a view which can process the navigation request
         *       in the form of licensing route object. False otherwise.
         */
        LicensesManagementNavigationService.prototype.canNavigationRequestInLicensingRouteBeHandled = function (tabPaths, licensingRouteObject) {
            if (!licensingRouteObject || !licensingRouteObject.tabPaths || !tabPaths) {
                return false;
            }
            // If the given tab ids are more than the tab ids in the licensing route object then the navigation request can't be handled.
            if (tabPaths.length > licensingRouteObject.tabPaths.length) {
                return false;
            }
            if (tabPaths.length === 0 && licensingRouteObject.tabPaths.length > 0) {
                return false;
            }
            for (var index = 0; index < tabPaths.length; index++) {
                if (tabPaths[index] !== licensingRouteObject.tabPaths[index]) {
                    return false;
                }
            }
            return true;
        };
        /**
         * Create a licensing route object which to include only the tab ids coming after the tab ids given with tabPaths parameter.
         *
         * @param tabPaths The tabPaths which have to be used when determining which are the sub tabs.
         * @param licensingRouteObject The licensing route object from which the new route object with the sub tabs, has to be created.
         * @returns {any} New licensing route object only with the sub tabs.
         */
        LicensesManagementNavigationService.prototype.createLicensingRouteObjectForSubTabs = function (tabPaths, licensingRouteObject) {
            if (!tabPaths || !tabPaths.length
                || !licensingRouteObject
                || !licensingRouteObject.tabPaths
                || !licensingRouteObject.tabPaths.length) {
                return null;
            }
            if (tabPaths.length > licensingRouteObject.tabPaths.length) {
                return null;
            }
            var subtabPaths = [];
            for (var index = 0; index < licensingRouteObject.tabPaths.length; index++) {
                if (index < tabPaths.length && licensingRouteObject.tabPaths[index] !== tabPaths[index]) {
                    return null;
                }
                if (index >= tabPaths.length) {
                    subtabPaths.push(licensingRouteObject.tabPaths[index]);
                }
            }
            return {
                extensionId: licensingRouteObject.extensionId,
                tabPaths: subtabPaths,
                itemId: licensingRouteObject.itemId
            };
        };
        LicensesManagementNavigationService.prototype.emitLicensesManagementNavigationRequestOnScope = function ($scope, licensingRouteObject) {
            if (!licensingRouteObject) {
                return;
            }
            $scope.$emit(this.licensesManagementConstants.LICENSES_MANAGEMENT_NAVIGATION_REQUEST_EVENT, licensingRouteObject);
        };
        LicensesManagementNavigationService.prototype.emitAssetsManagementNavigationPerformedOnScope = function ($scope, licensingRouteObject) {
            if (!licensingRouteObject) {
                return;
            }
            $scope.$emit(this.licensesManagementConstants.ASSETS_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, licensingRouteObject);
        };
        LicensesManagementNavigationService.prototype.registerNavigationPerformedEventListener = function ($scope, handleNavigationRequestCallback) {
            $scope.$on(this.licensesManagementConstants.LICENSES_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, function (event, data) {
                handleNavigationRequestCallback(data);
            });
        };
        LicensesManagementNavigationService.prototype.registerAssetsNavigationPerformedEventListener = function ($scope, handleNavigationRequestCallback) {
            $scope.$on(this.licensesManagementConstants.ASSETS_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, function (event, data) {
                handleNavigationRequestCallback(data);
            });
        };
        LicensesManagementNavigationService.prototype.extractAdditionalParametersFromRoute = function () {
            var additionalParameters = {};
            var route = this.navigation.getRouteFromUrl();
            var PARAMS = ['itemId', 'tabPaths'];
            var additionalRootParameters = route.getAdditionalParams();
            for (var key in additionalRootParameters) {
                if (PARAMS.indexOf(key) === -1 && !angular.isFunction(additionalRootParameters[key])) {
                    additionalParameters[key] = additionalRootParameters[key];
                }
            }
            return additionalParameters;
        };
        LicensesManagementNavigationService.prototype.appendAdditionalParametersToRoutingInfo = function (routingInfo) {
            var route = this.navigation.getRouteFromUrl();
            var PARAMS = ['itemId', 'tabPaths'];
            var additionalParameters = route.getAdditionalParams();
            for (var key in additionalParameters) {
                if (PARAMS.indexOf(key) === -1 && !angular.isFunction(additionalParameters[key] && routingInfo[key])) {
                    routingInfo[key] = additionalParameters[key];
                }
            }
        };
        LicensesManagementNavigationService.$inject = [
            "navigation",
            "licensesManagementConstants"
        ];
        return LicensesManagementNavigationService;
    }());
    license_ui.LicensesManagementNavigationService = LicensesManagementNavigationService;
    angular.module('com.vmware.vsphere.client.licenseUi').service('licensesManagementNavigationService', LicensesManagementNavigationService);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicensingRouteObjectsFactoryService = (function () {
        function LicensingRouteObjectsFactoryService(licensesManagementConstants) {
            this.licensesManagementConstants = licensesManagementConstants;
        }
        LicensingRouteObjectsFactoryService.prototype.createProductsListLicensingRouteObject = function (productId) {
            return {
                extensionId: this.licensesManagementConstants.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID,
                tabPaths: [this.licensesManagementConstants.PRODUCTS_ADMINISTRATION_VIEW_TAB_ID],
                itemId: productId
            };
        };
        LicensingRouteObjectsFactoryService.prototype.createLicensesListLicensingRouteObject = function (licenseId) {
            return {
                extensionId: this.licensesManagementConstants.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID,
                tabPaths: [],
                itemId: licenseId
            };
        };
        LicensingRouteObjectsFactoryService.prototype.createAssetsListLicensingRouteObject = function (assetType, assetId) {
            var licensingRouteObject = {
                extensionId: this.licensesManagementConstants.ADMINISTRATION_LICENSES_VIEWS_EXTENSION_ID,
                tabPaths: [this.licensesManagementConstants.ASSETS_ADMINISTRATION_VIEW_TAB_ID],
                itemId: assetId
            };
            if (assetType && assetType.length) {
                licensingRouteObject.tabPaths.push(assetType);
            }
            return licensingRouteObject;
        };
        LicensingRouteObjectsFactoryService.$inject = [
            "licensesManagementConstants"
        ];
        return LicensingRouteObjectsFactoryService;
    }());
    license_ui.LicensingRouteObjectsFactoryService = LicensingRouteObjectsFactoryService;
    angular.module('com.vmware.vsphere.client.licenseUi').service('licensingRouteObjectsFactoryService', LicensingRouteObjectsFactoryService);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var AssetsAdministrationViewController = (function () {
        function AssetsAdministrationViewController($scope, licensingRouteObjectsFactoryService, licensesManagementNavigationService, licensesManagementConstants) {
            this.$scope = $scope;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensesManagementConstants = licensesManagementConstants;
        }
        AssetsAdministrationViewController.prototype.$onInit = function () {
            var _this = this;
            this.scopeProvider = this.$scope.scopeProvider;
            this.tabPaths = this.$scope.tabPaths;
            this.licensesManagementNavigationService.registerNavigationPerformedEventListener(this.$scope, function (licensingRouteObject) {
                _this.handleNavigationRequest(licensingRouteObject);
            });
            this.registerSelectedTabChangedEventListener();
            this.tryProcessNavigationRouteInfoInUrl();
        };
        AssetsAdministrationViewController.prototype.onSelectedAssetTabIdChanged = function (assetTabId) {
            if (assetTabId && this.selectedAssetTabId !== assetTabId) {
                this.selectedAssetTabId = assetTabId;
                this.focusedAssetItemUri = undefined;
                this.triggerNavigationRequestToSelectedAssetTab();
            }
        };
        AssetsAdministrationViewController.prototype.triggerNavigationRequestToSelectedAssetTab = function () {
            var assetsListRouteObject = this.licensingRouteObjectsFactoryService
                .createAssetsListLicensingRouteObject(this.selectedAssetTabId, this.focusedAssetItemUri);
            this.licensesManagementNavigationService
                .emitLicensesManagementNavigationRequestOnScope(this.$scope, assetsListRouteObject);
        };
        AssetsAdministrationViewController.prototype.handleNavigationRequest = function (licensingRouteObject) {
            if (licensingRouteObject &&
                this.licensesManagementNavigationService.canNavigationRequestInLicensingRouteBeHandled(this.tabPaths, licensingRouteObject)) {
                var licensingRouteObjectForSubTabs = this.licensesManagementNavigationService.createLicensingRouteObjectForSubTabs(this.tabPaths, licensingRouteObject);
                if (licensingRouteObjectForSubTabs && licensingRouteObjectForSubTabs.tabPaths.length > 0) {
                    if (this.selectedAssetTabId === licensingRouteObjectForSubTabs.tabPaths[0]) {
                        this.broadcastEventForAssetsManagementNavigationPerformed(licensingRouteObjectForSubTabs);
                    }
                    this.selectedAssetTabId = licensingRouteObjectForSubTabs.tabPaths[0];
                    this.focusedAssetItemUri = licensingRouteObjectForSubTabs.itemId;
                }
            }
        };
        AssetsAdministrationViewController.prototype.registerSelectedTabChangedEventListener = function () {
            var _this = this;
            this.$scope.$on(this.licensesManagementConstants.LICENSES_MANAGEMENT_SELECTED_TAB_CHANGED_EVENT, function (event, data) {
                _this.selectedTab = data.selectedTab;
                var shouldSelectCurrentTabAsDefault = data.isDefault && _this.isCurrentTabDefaultTab();
                if (_this.selectedAssetTabId && (shouldSelectCurrentTabAsDefault || _this.isCurrentTabSelected())) {
                    _this.triggerNavigationRequestToSelectedAssetTab();
                }
            });
        };
        AssetsAdministrationViewController.prototype.broadcastEventForLicensesManagementNavigationPerformed = function (licensingRouteObject) {
            this.$scope.$broadcast(this.licensesManagementConstants.LICENSES_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, licensingRouteObject);
        };
        AssetsAdministrationViewController.prototype.broadcastEventForAssetsManagementNavigationPerformed = function (licensingRouteObject) {
            this.$scope.$broadcast(this.licensesManagementConstants.ASSETS_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, licensingRouteObject);
        };
        AssetsAdministrationViewController.prototype.tryProcessNavigationRouteInfoInUrl = function () {
            var licensingRouteObject = this.licensesManagementNavigationService.extractLicensingRouteObjectFromUrl();
            this.handleNavigationRequest(licensingRouteObject);
        };
        AssetsAdministrationViewController.prototype.isCurrentTabDefaultTab = function () {
            return !(this.tabPaths && this.tabPaths.length);
        };
        AssetsAdministrationViewController.prototype.isCurrentTabSelected = function () {
            return !!(this.tabPaths && this.tabPaths.length > 0
                && this.selectedTab && this.selectedTab.id === this.tabPaths[this.tabPaths.length - 1]);
        };
        AssetsAdministrationViewController.$inject = [
            "$scope",
            "licensingRouteObjectsFactoryService",
            "licensesManagementNavigationService",
            "licensesManagementConstants"
        ];
        return AssetsAdministrationViewController;
    }());
    license_ui.AssetsAdministrationViewController = AssetsAdministrationViewController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('AssetsAdministrationViewController', AssetsAdministrationViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var AssetsGridViewController = (function () {
        function AssetsGridViewController($scope, licensesManagementNavigationService, licensingRouteObjectsFactoryService, commonActionBarService) {
            this.$scope = $scope;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
            this.commonActionBarService = commonActionBarService;
            this.ACTION_BAR_ACTIONS = "actions";
            this.ASSIGN_LICENSE_KEY_ACTION_ID = "vsphere.core.administration.assignLicenseKeyAction";
            this.REMOVE_SOLUTION_ACTION_ID = "vsphere.core.administration.removeSolutionsAction";
            this.ASSET_TYPE_SOLUTION = "SOLUTION";
            this.selectedAssets = [];
            this.selectedAssetsUris = [];
        }
        AssetsGridViewController.prototype.$onInit = function () {
            var _this = this;
            this.actionBarOptions = {
                actions: []
            };
            this.licensesManagementNavigationService.registerAssetsNavigationPerformedEventListener(this.$scope, function (licensingRouteObject) {
                _this.handleNavigationRequest(licensingRouteObject);
            });
            this.focusedAssetUri = this.$scope.masterDetailsViewContext.getFocusedAssetItemUri();
            if (this.focusedAssetUri) {
                this.triggerNavigationRequestToFocusedAssetItem();
            }
            this.updateActionBar();
        };
        AssetsGridViewController.prototype.onSelectedAssetsChanged = function (selectedAssets) {
            if (selectedAssets && selectedAssets.length > 0) {
                this.selectedAssets = selectedAssets;
            }
            else {
                this.selectedAssets = [];
            }
            this.selectedAssetsUris = this.extractAssetsUris(this.selectedAssets);
            this.updateActionBar();
        };
        AssetsGridViewController.prototype.onFocusedAssetChanged = function (focusedAsset) {
            if (this.focusedAsset !== focusedAsset) {
                this.focusedAsset = focusedAsset;
                this.$scope.masterDetailsViewContext.selectedItems = [focusedAsset];
            }
            this.focusedAssetUri = this.focusedAsset && this.focusedAsset.uri;
            this.triggerNavigationRequestToFocusedAssetItem();
        };
        AssetsGridViewController.prototype.triggerNavigationRequestToFocusedAssetItem = function () {
            var selectedAssetTabId = this.$scope.masterDetailsViewContext.getSelectedAssetTabId();
            var assetsListRouteObject = this.licensingRouteObjectsFactoryService
                .createAssetsListLicensingRouteObject(selectedAssetTabId, this.focusedAssetUri);
            this.licensesManagementNavigationService
                .emitLicensesManagementNavigationRequestOnScope(this.$scope, assetsListRouteObject);
        };
        AssetsGridViewController.prototype.updateActionBar = function () {
            var _this = this;
            var updatedOptions = [];
            if (this.actionBarOptions && this.actionBarOptions.actions && this.actionBarOptions.actions.length) {
                this.actionBarOptions.actions.forEach(function (action) {
                    if (action.actionId) {
                        action.enabled = false;
                    }
                });
            }
            this.commonActionBarService.updateActionBar(updatedOptions, this.ACTION_BAR_ACTIONS, this.selectedAssetsUris, this.getActions()).then(function () {
                _this.actionBarOptions = updatedOptions;
            });
        };
        AssetsGridViewController.prototype.getActions = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: this.ASSIGN_LICENSE_KEY_ACTION_ID,
                getActionInvocationContext: function () {
                    return _this.selectedAssetsUris;
                },
                isActionVisible: function (actionDef) {
                    return !!(_this.selectedAssetsUris && _this.selectedAssetsUris.length > 0 && actionDef);
                }
            });
            if (this.$scope.masterDetailsViewContext.assetType === this.ASSET_TYPE_SOLUTION) {
                actionDefs.push({
                    actionId: this.REMOVE_SOLUTION_ACTION_ID,
                    isActionVisible: function (actionDef) {
                        return !!(_this.selectedAssetsUris && _this.selectedAssetsUris.length > 0 && actionDef);
                    }
                });
            }
            return actionDefs;
        };
        AssetsGridViewController.prototype.handleNavigationRequest = function (licensingRouteObject) {
            if (licensingRouteObject &&
                this.licensesManagementNavigationService.canNavigationRequestInLicensingRouteBeHandled([this.$scope.masterDetailsViewContext.getSelectedAssetTabId()], licensingRouteObject)) {
                if (licensingRouteObject.itemId) {
                    this.focusedAssetUri = licensingRouteObject.itemId;
                }
            }
        };
        AssetsGridViewController.prototype.extractAssetsUris = function (assets) {
            var assetsUris = [];
            if (assets && assets.length > 0) {
                assetsUris = assets.map(function (asset) {
                    return asset && asset.uri;
                });
            }
            return assetsUris;
        };
        AssetsGridViewController.$inject = ["$scope",
            "licensesManagementNavigationService",
            "licensingRouteObjectsFactoryService",
            "commonActionBarService"];
        return AssetsGridViewController;
    }());
    license_ui.AssetsGridViewController = AssetsGridViewController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('AssetsGridViewController', AssetsGridViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var AssetsMasterDetailsViewController = (function () {
        function AssetsMasterDetailsViewController($scope, i18nService, $q) {
            this.$scope = $scope;
            this.i18nService = i18nService;
            this.$q = $q;
        }
        AssetsMasterDetailsViewController.prototype.$onInit = function () {
            var _this = this;
            this.masterDetailsViewContext = {
                assetType: this.assetType,
                getSelectedTab: function () {
                    return _this.selectedTab;
                },
                scopeProvider: this.scopeProvider,
                getSelectedAssetTabId: function () {
                    return _this.selectedAssetTabId;
                },
                getFocusedAssetItemUri: function () {
                    return _this.focusedAssetItemUri;
                }
            };
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.products.details.summary"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/assetsDetailsSummaryTabView.html",
                        uid: "assets.summaryTab"
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.assets.details.featuresTab"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/assetsDetailsFeaturesTabView.html",
                        uid: "assets.featuresTab"
                    }
                ])
            };
        };
        AssetsMasterDetailsViewController.$inject = ["$scope", "i18nService", "$q"];
        return AssetsMasterDetailsViewController;
    }());
    license_ui.AssetsMasterDetailsViewController = AssetsMasterDetailsViewController;
    angular.module("com.vmware.vsphere.client.licenseUi")
        .component("assetsMasterDetailsViewWrapper", {
        controller: AssetsMasterDetailsViewController,
        template: "<div class=\"fill-parent\">\n                              <vx-master-details-component\n                                    master-view-template-url=\"license-ui/resources/license/views/management/licenses/assets/assetsGridView.html\"\n                                    details-view-template-url=\"resources/ui/components/masterdetails/vxTabbedDetailsView.html\"\n                                    details-view-data=\"$ctrl.detailsViewData\"\n                                    master-details-view-context=\"$ctrl.masterDetailsViewContext\"\n                                    is-resizable=\"true\">\n                              </vx-master-details-component>\n                           </div>",
        bindings: {
            assetType: "<",
            selectedTab: "<",
            scopeProvider: "<",
            focusedAssetItemUri: "<"
        }
    });
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicensesTabbedViewController = (function () {
        function LicensesTabbedViewController($scope, vcLicensingPrivilegesService, licensesManagementNavigationService, licensingRouteObjectsFactoryService, i18n, licensesManagementConstants) {
            this.$scope = $scope;
            this.vcLicensingPrivilegesService = vcLicensingPrivilegesService;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
            this.i18n = i18n;
            this.licensesManagementConstants = licensesManagementConstants;
            this.scopeProvider = "licensing_service_version1";
            this.PORTAL_URL = "https://my.vmware.com/";
            this.tabs = [];
            this.tabViewParams = {};
            this.loading = false;
            this.isGlobalLicensePrivilegeGranted = false;
        }
        LicensesTabbedViewController.prototype.$onInit = function () {
            var _this = this;
            this.tabViewParams = {
                scopeProvider: this.scopeProvider
            };
            this.loading = true;
            this.vcLicensingPrivilegesService
                .checkIfGlobalLicensePrivilegeIsGranted(this.scopeProvider)
                .then(function (globalLicensePrivilegeGranted) {
                _this.isGlobalLicensePrivilegeGranted = globalLicensePrivilegeGranted;
                if (_this.isGlobalLicensePrivilegeGranted) {
                    _this.initializeTabs();
                    _this.registerListenerForLicensesManagementNavigationRequest();
                    _this.attachWatchOnSelectedTab();
                    _this.tryHandleAdditionalNavigationalInformationInUrl();
                    // register listener for handling additional information in URL
                    _this.$scope.$on("vxRouteChangeSuccess", function () {
                        _this.tryHandleAdditionalNavigationalInformationInUrl();
                    });
                }
            }).finally(function () {
                _this.loading = false;
            });
        };
        LicensesTabbedViewController.prototype.initializeTabs = function () {
            this.tabs = [{
                    name: this.i18n.getString("LicenseLibUi", "management.name"),
                    templateUrl: "license-ui/resources/license/views/management/licenses/serial-key-licenses/licensesAdministrationView.html",
                    id: this.licensesManagementConstants.LICENSES_ADMINISTRATION_VIEW_TAB_ID,
                    tabParams: this.createTabParamWithTabId()
                }, {
                    name: this.i18n.getString("LicenseLibUi", "management.navigation.products"),
                    templateUrl: "license-ui/resources/license/views/management/licenses/products/productsAdministrationView.html",
                    id: this.licensesManagementConstants.PRODUCTS_ADMINISTRATION_VIEW_TAB_ID,
                    tabParams: this.createTabParamWithTabId(this.licensesManagementConstants.PRODUCTS_ADMINISTRATION_VIEW_TAB_ID)
                }, {
                    name: this.i18n.getString("LicenseLibUi", "management.navigation.assets"),
                    templateUrl: "license-ui/resources/license/views/management/licenses/assets/assetsAdministrationView.html",
                    id: this.licensesManagementConstants.ASSETS_ADMINISTRATION_VIEW_TAB_ID,
                    tabParams: this.createTabParamWithTabId(this.licensesManagementConstants.ASSETS_ADMINISTRATION_VIEW_TAB_ID)
                }];
            this.selectedTab = this.tabs[0];
        };
        LicensesTabbedViewController.prototype.tryHandleAdditionalNavigationalInformationInUrl = function () {
            var licensingRouteObject = this.licensesManagementNavigationService.extractLicensingRouteObjectFromUrl();
            this.handleNavigationRequest(licensingRouteObject);
        };
        LicensesTabbedViewController.prototype.registerListenerForLicensesManagementNavigationRequest = function () {
            var _this = this;
            this.$scope.$on(this.licensesManagementConstants.LICENSES_MANAGEMENT_NAVIGATION_REQUEST_EVENT, function (event, licensingRouteObject) {
                event.stopPropagation();
                _this.handleNavigationRequest(licensingRouteObject);
            });
        };
        LicensesTabbedViewController.prototype.handleNavigationRequest = function (licensingRouteObject) {
            if (!licensingRouteObject) {
                return;
            }
            if (licensingRouteObject.tabPaths && licensingRouteObject.tabPaths.length) {
                this.selectedTab = this.findTabById(licensingRouteObject.tabPaths[0]);
                this.licensingRouteObject = licensingRouteObject;
                this.licensesManagementNavigationService
                    .navigateByProvidedLicensingRouteObject(licensingRouteObject);
                this.broadcastEventForLicensesManagementNavigationPerformed(licensingRouteObject);
            }
            else {
                this.selectedTab = this.tabs[0];
                this.navigateToDefaultLicensingTab(licensingRouteObject.itemId);
                this.broadcastEventForLicensesManagementNavigationPerformed(licensingRouteObject);
            }
        };
        LicensesTabbedViewController.prototype.navigateToDefaultLicensingTab = function (itemId) {
            var licensesListRouteObject = this.licensingRouteObjectsFactoryService.createLicensesListLicensingRouteObject(itemId);
            this.licensesManagementNavigationService.navigateByProvidedLicensingRouteObject(licensesListRouteObject);
        };
        LicensesTabbedViewController.prototype.broadcastEventForLicensesManagementNavigationPerformed = function (licensingRouteObject) {
            this.$scope.$broadcast(this.licensesManagementConstants.LICENSES_MANAGEMENT_NAVIGATION_PERFORMED_EVENT, licensingRouteObject);
        };
        LicensesTabbedViewController.prototype.broadcastEventForLicensesManagementSelectedTabChanged = function (newTab, isDefault) {
            if (isDefault === void 0) { isDefault = false; }
            var selectedTabInfo = {
                selectedTab: newTab,
                isDefault: isDefault
            };
            this.$scope.$broadcast(this.licensesManagementConstants.LICENSES_MANAGEMENT_SELECTED_TAB_CHANGED_EVENT, selectedTabInfo);
        };
        LicensesTabbedViewController.prototype.attachWatchOnSelectedTab = function () {
            var _this = this;
            this.$scope.$watch(function () {
                return _this.selectedTab;
            }, function (newTab) {
                if (!newTab || !newTab.id) {
                    return;
                }
                if (newTab.id === _this.tabs[0].id) {
                    _this.licensesManagementNavigationService.navigateToLicensesManagementTabByTabId();
                    _this.broadcastEventForLicensesManagementSelectedTabChanged(newTab, true);
                    return;
                }
                _this.licensesManagementNavigationService.navigateToLicensesManagementTabByTabId(newTab.id);
                _this.broadcastEventForLicensesManagementSelectedTabChanged(newTab);
            });
        };
        LicensesTabbedViewController.prototype.findTabById = function (tabId) {
            if (!tabId) {
                return;
            }
            return this.tabs.find(function (tab) {
                return tabId === tab.id;
            });
        };
        LicensesTabbedViewController.prototype.createTabParamWithTabId = function (tabId) {
            var tabPaths = tabId ? [tabId] : [];
            return { tabPaths: tabPaths };
        };
        LicensesTabbedViewController.$inject = [
            "$scope",
            "vcLicensingPrivilegesService",
            "licensesManagementNavigationService",
            "licensingRouteObjectsFactoryService",
            "i18nService",
            "licensesManagementConstants"
        ];
        return LicensesTabbedViewController;
    }());
    license_ui.LicensesTabbedViewController = LicensesTabbedViewController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('LicensesTabbedViewController', LicensesTabbedViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var ProductLicensesViewController = (function () {
        function ProductLicensesViewController($scope, licensesManagementNavigationService, licensingRouteObjectsFactoryService) {
            this.$scope = $scope;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
        }
        ProductLicensesViewController.prototype.onFocusedLicenseChanged = function (selectedLicense) {
            this.triggerNavigationRequestToSelectedLicenseItem();
        };
        ProductLicensesViewController.prototype.triggerNavigationRequestToSelectedLicenseItem = function () {
            var licenses = this.$scope.masterDetailsViewContext.selectedItem.licenses;
            if (licenses && licenses.length > 0) {
                var licensesListRouteObject = this.licensingRouteObjectsFactoryService
                    .createLicensesListLicensingRouteObject(licenses[0].uri);
                this.licensesManagementNavigationService
                    .emitLicensesManagementNavigationRequestOnScope(this.$scope, licensesListRouteObject);
            }
        };
        ProductLicensesViewController.$inject = ["$scope", "licensesManagementNavigationService", "licensingRouteObjectsFactoryService"];
        return ProductLicensesViewController;
    }());
    license_ui.ProductLicensesViewController = ProductLicensesViewController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('ProductLicensesViewController', ProductLicensesViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var ProductsAdministrationViewController = (function () {
        function ProductsAdministrationViewController(i18nService, $q, $scope) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.$scope = $scope;
        }
        ProductsAdministrationViewController.prototype.$onInit = function () {
            this.masterDetailsViewContext = {
                scopeProvider: this.$scope.scopeProvider,
                tabPaths: this.$scope.tabPaths
            };
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.products.details.summary"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/products/productsDetailsView.html",
                        uid: "product.generalTab"
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.license.summary.productFeatures.label"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/products/productFeaturesView.html",
                        uid: "product.features"
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "products.tab.licenses.title"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/products/productLicensesView.html",
                        uid: "product.licenses"
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.vcs"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/vcAssetsList.html",
                        uid: "product.vcAssets",
                        metadata: {
                            relevantFor: "isAssignableToVcs"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.hosts"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/hostAssetsList.html",
                        uid: "product.hostAssets",
                        metadata: {
                            relevantFor: "isAssignableToHosts"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.clusters"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/clusterAssetsList.html",
                        uid: "product.clusterAssets",
                        metadata: {
                            relevantFor: "isAssignableToClusters"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.solutions"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/solutionAssetsList.html",
                        uid: "product.solutionAssets",
                        metadata: {
                            relevantFor: "isAssignableToSolutions"
                        }
                    }
                ])
            };
        };
        ProductsAdministrationViewController.$inject = ["i18nService", "$q", "$scope"];
        return ProductsAdministrationViewController;
    }());
    angular.module("com.vmware.vsphere.client.licenseUi")
        .controller("ProductsAdministrationViewController", ProductsAdministrationViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var ProductsListViewController = (function () {
        function ProductsListViewController($scope, licensesManagementNavigationService, licensingRouteObjectsFactoryService, licensesManagementConstants) {
            this.$scope = $scope;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
            this.licensesManagementConstants = licensesManagementConstants;
        }
        ProductsListViewController.prototype.$onInit = function () {
            var _this = this;
            this.scopeProvider = this.$scope.masterDetailsViewContext.scopeProvider;
            this.tabPaths = this.$scope.masterDetailsViewContext.tabPaths;
            this.licensesManagementNavigationService.registerNavigationPerformedEventListener(this.$scope, function (licensingRouteObject) {
                _this.handleNavigationRequest(licensingRouteObject);
            });
            this.registerSelectedTabChangedEventListener();
            this.tryProcessNavigationRouteInfoInUrl();
        };
        ProductsListViewController.prototype.onSelectedProductChanged = function (selectedProduct) {
            if (this.selectedProduct !== selectedProduct) {
                this.selectedProduct = selectedProduct;
                this.selectedProductUri = this.extractUriFromProductAggregationItem(this.selectedProduct);
                this.$scope.masterDetailsViewContext.selectedItems = [selectedProduct];
                this.triggerNavigationRequestToSelectedProductItem();
            }
        };
        ProductsListViewController.prototype.handleNavigationRequest = function (licensingRouteObject) {
            if (licensingRouteObject
                && this.licensesManagementNavigationService.canNavigationRequestInLicensingRouteBeHandled(this.tabPaths, licensingRouteObject)) {
                if (licensingRouteObject.itemId) {
                    this.selectedProductUri = licensingRouteObject.itemId;
                }
            }
        };
        ProductsListViewController.prototype.extractUriFromProductAggregationItem = function (productAggregationItem) {
            var productUri = undefined;
            if (productAggregationItem && productAggregationItem.product
                && productAggregationItem.product.product
                && productAggregationItem.product.product.uri) {
                productUri = productAggregationItem.product.product.uri;
            }
            return productUri;
        };
        ProductsListViewController.prototype.triggerNavigationRequestToSelectedProductItem = function () {
            var productsListRouteObject = this.licensingRouteObjectsFactoryService
                .createProductsListLicensingRouteObject(this.selectedProductUri);
            this.licensesManagementNavigationService
                .emitLicensesManagementNavigationRequestOnScope(this.$scope, productsListRouteObject);
        };
        ProductsListViewController.prototype.registerSelectedTabChangedEventListener = function () {
            var _this = this;
            this.$scope.$on(this.licensesManagementConstants.LICENSES_MANAGEMENT_SELECTED_TAB_CHANGED_EVENT, function (event, data) {
                _this.selectedTab = data.selectedTab;
                var shouldSelectCurrentTabAsDefault = data.isDefault && _this.isCurrentTabDefaultTab();
                if (_this.selectedProductUri && (shouldSelectCurrentTabAsDefault || _this.isCurrentTabSelected())) {
                    _this.triggerNavigationRequestToSelectedProductItem();
                }
            });
        };
        ProductsListViewController.prototype.tryProcessNavigationRouteInfoInUrl = function () {
            var licensingRouteObject = this.licensesManagementNavigationService.extractLicensingRouteObjectFromUrl();
            this.handleNavigationRequest(licensingRouteObject);
        };
        ProductsListViewController.prototype.isCurrentTabDefaultTab = function () {
            return !(this.tabPaths && this.tabPaths.length);
        };
        ProductsListViewController.prototype.isCurrentTabSelected = function () {
            return !!(this.tabPaths && this.tabPaths.length > 0
                && this.selectedTab && this.selectedTab.id === this.tabPaths[this.tabPaths.length - 1]);
        };
        ProductsListViewController.$inject = [
            "$scope",
            "licensesManagementNavigationService",
            "licensingRouteObjectsFactoryService",
            "licensesManagementConstants"
        ];
        return ProductsListViewController;
    }());
    license_ui.ProductsListViewController = ProductsListViewController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('ProductsListViewController', ProductsListViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicenseDetailsProductsTabController = (function () {
        function LicenseDetailsProductsTabController($scope, licensesManagementNavigationService, licensingRouteObjectsFactoryService) {
            this.$scope = $scope;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
        }
        LicenseDetailsProductsTabController.prototype.onSelectedProductChanged = function (productItem) {
            if (productItem && productItem.product && productItem.product.uri) {
                var productsListRouteObject = this.licensingRouteObjectsFactoryService
                    .createProductsListLicensingRouteObject(productItem.product.uri);
                this.licensesManagementNavigationService
                    .emitLicensesManagementNavigationRequestOnScope(this.$scope, productsListRouteObject);
            }
        };
        LicenseDetailsProductsTabController.$inject = ["$scope", "licensesManagementNavigationService", "licensingRouteObjectsFactoryService"];
        return LicenseDetailsProductsTabController;
    }());
    angular.module("com.vmware.vsphere.client.licenseUi")
        .controller("LicenseDetailsProductsTabController", LicenseDetailsProductsTabController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var LicensesAdministrationViewController = (function () {
        function LicensesAdministrationViewController(i18nService, $q, $scope) {
            this.i18nService = i18nService;
            this.$q = $q;
            this.$scope = $scope;
        }
        LicensesAdministrationViewController.prototype.$onInit = function () {
            this.masterDetailsViewContext = {
                scopeProvider: this.$scope.scopeProvider,
                tabPaths: this.$scope.tabPaths
            };
            this.detailsViewData = {
                tabsPromise: this.$q.when([
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.license.summary.tabLabel"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/serial-key-licenses/details/licenseDetailsSummaryTab.html",
                        uid: "license.summary"
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.license.summary.productFeatures.label"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/serial-key-licenses/details/productsFeatures.html",
                        uid: "license.features",
                        metadata: {
                            relevantFor: "!isEvaluation"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "list.products"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/serial-key-licenses/details/licenseDetailsProductsTab.html",
                        uid: "license.products",
                        metadata: {
                            relevantFor: "!isEvaluation"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.vcs"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/vcAssetsList.html",
                        uid: "license.vcAssets",
                        metadata: {
                            relevantFor: "isAssignableToVcs"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.hosts"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/hostAssetsList.html",
                        uid: "license.hostAssets",
                        metadata: {
                            relevantFor: "isAssignableToHosts"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.clusters"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/clusterAssetsList.html",
                        uid: "license.clusterAssets",
                        metadata: {
                            relevantFor: "isAssignableToClusters"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "management.navigation.solutions"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/assets/solutionAssetsList.html",
                        uid: "license.solutionAssets",
                        metadata: {
                            relevantFor: "isAssignableToSolutions"
                        }
                    },
                    {
                        name: this.i18nService.getString("LicenseLibUi", "license.tab.myvmware.title"),
                        templateUrl: "license-ui/resources/license/views/management/licenses/serial-key-licenses/details/myVmwareLicenseDetailsTab.html",
                        uid: "myvmwarelicense.summary",
                        metadata: {
                            relevantFor: "isMyVmwareLicense"
                        }
                    }
                ])
            };
        };
        LicensesAdministrationViewController.$inject = ["i18nService", "$q", "$scope"];
        return LicensesAdministrationViewController;
    }());
    license_ui.LicensesAdministrationViewController = LicensesAdministrationViewController;
    angular.module("com.vmware.vsphere.client.licenseUi")
        .controller("LicensesAdministrationViewController", LicensesAdministrationViewController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var SerialKeyLicensesListController = (function () {
        function SerialKeyLicensesListController($scope, $q, vcLicensingPrivilegesService, commonActionBarService, vuiConstants, licensesManagementNavigationService, licensingRouteObjectsFactoryService, licensesManagementConstants, licenseCommonUtil) {
            this.$scope = $scope;
            this.$q = $q;
            this.vcLicensingPrivilegesService = vcLicensingPrivilegesService;
            this.commonActionBarService = commonActionBarService;
            this.vuiConstants = vuiConstants;
            this.licensesManagementNavigationService = licensesManagementNavigationService;
            this.licensingRouteObjectsFactoryService = licensingRouteObjectsFactoryService;
            this.licensesManagementConstants = licensesManagementConstants;
            this.licenseCommonUtil = licenseCommonUtil;
            this.ACTION_BAR_ACTIONS = "actions";
            this.REMOVE_LICENSE_ACTION_ID = "vsphere.core.administration.removeLicensesAction";
            this.RENAME_LICENSE_ACTION_ID = "vsphere.core.administration.renameLicenseAction";
            this.ADD_LICENSE_ACTION_ID = "vsphere.core.administration.addLicenseAction";
            this.SYNC_LICENSES_ACTION_ID = "vsphere.core.administration.syncFromPortal";
            this.selectedLicenses = [];
            this.selectedLicensesUris = [];
            this.isVc65OrLater = false;
        }
        SerialKeyLicensesListController.prototype.$onInit = function () {
            var _this = this;
            this.scopeProvider = this.$scope.masterDetailsViewContext.scopeProvider;
            this.tabPaths = this.$scope.masterDetailsViewContext.tabPaths;
            this.defaultEvaluationLicenseUri = this.licenseCommonUtil.getDefaultEvaluationLicenseUri();
            this.actionBarOptions = {
                actions: []
            };
            this.updateActionBar();
            // Only show the Sync action if we have
            // at least one VC with version >= 6.5.
            this.vcLicensingPrivilegesService.checkIfVc65OrLaterIsPresent(this.scopeProvider)
                .then(function (result) {
                _this.isVc65OrLater = result;
                _this.updateActionBar();
            });
            this.licensesManagementNavigationService.registerNavigationPerformedEventListener(this.$scope, function (licensingRouteObject) {
                _this.handleNavigationRequest(licensingRouteObject);
            });
            this.registerSelectedTabChangedEventListener();
            this.tryProcessNavigationRouteInfoInUrl();
        };
        SerialKeyLicensesListController.prototype.onSelectedLicensesChanged = function (selectedLicenseItems) {
            if (!selectedLicenseItems || !selectedLicenseItems.length) {
                this.selectedLicenses = [];
            }
            else {
                this.selectedLicenses = selectedLicenseItems.map(function (selectedLicenseItem) {
                    return selectedLicenseItem && selectedLicenseItem.license;
                });
            }
            this.selectedLicensesUris = this.extractLicensesUris(this.selectedLicenses);
            this.updateActionBar();
        };
        SerialKeyLicensesListController.prototype.onFocusedLicenseChanged = function (focusedLicense) {
            this.focusedLicense = focusedLicense && focusedLicense.license;
            this.focusedLicenseUri = this.getFocusedLicenseUri();
            if (focusedLicense) {
                this.$scope.masterDetailsViewContext.selectedItems = [focusedLicense];
            }
            else {
                this.$scope.masterDetailsViewContext.selectedItems = [];
            }
            this.triggerNavigationRequestToFocusedLicenseItem();
        };
        SerialKeyLicensesListController.prototype.updateActionBar = function () {
            var _this = this;
            if (this.actionBarOptions && this.actionBarOptions.actions && this.actionBarOptions.actions.length) {
                this.actionBarOptions.actions.forEach(function (action) {
                    if (action.actionId &&
                        action.actionId !== _this.ADD_LICENSE_ACTION_ID && action.actionId !== _this.SYNC_LICENSES_ACTION_ID) {
                        action.enabled = false;
                    }
                });
            }
            var updateActionBarWithNoContextOptions = { actions: [] };
            var updateActionBarWithNoContext = this.commonActionBarService.updateActionBar(updateActionBarWithNoContextOptions, this.ACTION_BAR_ACTIONS, [], this.getActionsWithoutAvailabilityChecks());
            var updateActionBarWithLicensesUrisContextOptions = { actions: [] };
            var updateActionBarWithLicensesUrisContext = this.commonActionBarService.updateActionBar(updateActionBarWithLicensesUrisContextOptions, this.ACTION_BAR_ACTIONS, this.selectedLicensesUris, this.getActionsWithAvailabilityChecks());
            this.$q.all([updateActionBarWithNoContext, updateActionBarWithLicensesUrisContext])
                .then(function () {
                _this.actionBarOptions.actions = updateActionBarWithNoContextOptions.actions
                    .concat(updateActionBarWithLicensesUrisContextOptions.actions);
            });
        };
        SerialKeyLicensesListController.prototype.getActionsWithoutAvailabilityChecks = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: this.ADD_LICENSE_ACTION_ID,
                getActionInvocationContext: function () {
                    return _this.scopeProvider;
                },
                isActionVisible: function (actionDef) {
                    return !!actionDef;
                }
            }, {
                actionId: this.SYNC_LICENSES_ACTION_ID,
                getActionInvocationContext: function () { return _this.scopeProvider; },
                isActionVisible: function (actionDef) { return !!actionDef && _this.isVc65OrLater; }
            });
            actionDefs.push(this.vuiConstants.actions.SEPARATOR);
            actionDefs.push({
                actionId: this.RENAME_LICENSE_ACTION_ID,
                getActionInvocationContext: function () {
                    return _this.selectedLicenses[0];
                },
                isActionVisible: function (actionDef) {
                    return !!(_this.selectedLicensesUris.length > 0 && actionDef);
                },
                isActionAvailable: function (actionDef) {
                    return !!(_this.selectedLicensesUris.length === 1
                        && _this.selectedLicensesUris[0] !== _this.defaultEvaluationLicenseUri
                        && actionDef);
                }
            });
            return actionDefs;
        };
        SerialKeyLicensesListController.prototype.getActionsWithAvailabilityChecks = function () {
            var _this = this;
            var actionDefs = [];
            actionDefs.push({
                actionId: this.REMOVE_LICENSE_ACTION_ID,
                isActionVisible: function (actionDef) {
                    return !!(_this.selectedLicensesUris.length > 0 && actionDef);
                },
                getActionInvocationContext: function () {
                    return _this.selectedLicensesUris;
                }
            });
            return actionDefs;
        };
        SerialKeyLicensesListController.prototype.handleNavigationRequest = function (licensingRouteObject) {
            if (licensingRouteObject
                && this.licensesManagementNavigationService.canNavigationRequestInLicensingRouteBeHandled(this.tabPaths, licensingRouteObject)) {
                if (licensingRouteObject.itemId) {
                    this.focusedLicenseUri = licensingRouteObject.itemId;
                }
                var additionalParams = this.licensesManagementNavigationService.extractAdditionalParametersFromRoute();
                if (additionalParams.sortColumn) {
                    this.sortColumn = additionalParams.sortColumn;
                }
            }
        };
        SerialKeyLicensesListController.prototype.getFocusedLicenseUri = function () {
            return this.focusedLicense && this.focusedLicense.uri;
        };
        SerialKeyLicensesListController.prototype.extractLicensesUris = function (licenses) {
            var licensesUris = [];
            if (licenses && licenses.length > 0) {
                licensesUris = licenses.map(function (license) {
                    return license && license.uri;
                });
            }
            return licensesUris;
        };
        SerialKeyLicensesListController.prototype.triggerNavigationRequestToFocusedLicenseItem = function () {
            var licensesListRouteObject = this.licensingRouteObjectsFactoryService
                .createLicensesListLicensingRouteObject(this.focusedLicenseUri);
            this.licensesManagementNavigationService
                .emitLicensesManagementNavigationRequestOnScope(this.$scope, licensesListRouteObject);
        };
        SerialKeyLicensesListController.prototype.registerSelectedTabChangedEventListener = function () {
            var _this = this;
            this.$scope.$on(this.licensesManagementConstants.LICENSES_MANAGEMENT_SELECTED_TAB_CHANGED_EVENT, function (event, data) {
                _this.selectedTab = data.selectedTab;
                var shouldSelectCurrentTabAsDefault = data.isDefault && _this.isCurrentTabDefaultTab();
                if (_this.focusedLicenseUri && (shouldSelectCurrentTabAsDefault || _this.isCurrentTabSelected())) {
                    _this.triggerNavigationRequestToFocusedLicenseItem();
                }
            });
        };
        SerialKeyLicensesListController.prototype.tryProcessNavigationRouteInfoInUrl = function () {
            var licensingRouteObject = this.licensesManagementNavigationService.extractLicensingRouteObjectFromUrl();
            this.handleNavigationRequest(licensingRouteObject);
        };
        SerialKeyLicensesListController.prototype.isCurrentTabDefaultTab = function () {
            return !(this.tabPaths && this.tabPaths.length);
        };
        SerialKeyLicensesListController.prototype.isCurrentTabSelected = function () {
            return !!(this.tabPaths && this.tabPaths.length > 0
                && this.selectedTab && this.selectedTab.id === this.tabPaths[this.tabPaths.length - 1]);
        };
        SerialKeyLicensesListController.$inject = [
            "$scope",
            "$q",
            "vcLicensingPrivilegesService",
            "commonActionBarService",
            "vuiConstants",
            "licensesManagementNavigationService",
            "licensingRouteObjectsFactoryService",
            "licensesManagementConstants",
            "licenseCommonUtil"
        ];
        return SerialKeyLicensesListController;
    }());
    license_ui.SerialKeyLicensesListController = SerialKeyLicensesListController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('SerialKeyLicensesListController', SerialKeyLicensesListController);
})(license_ui || (license_ui = {}));



var license_ui;
(function (license_ui) {
    var AssetSettingsLicenseController = (function () {
        function AssetSettingsLicenseController($scope, i18nService) {
            this.$scope = $scope;
            this.i18nService = i18nService;
        }
        AssetSettingsLicenseController.prototype.$onInit = function () {
            this.objectId = this.$scope._route.objectId ||
                this.$scope._vxViewNodeData.node.contentSpec.metadata.objectId;
            this.shouldShowActions = false;
            this.headerOptions = {
                title: this.i18nService.getString("LicenseLibUi", "management.assets.settings.title"),
                objectId: this.objectId,
                actions: []
            };
        };
        AssetSettingsLicenseController.prototype.refreshActionsVisible = function (data) {
            if (!data || !data.asset || !data.asset.managedObjectRef) {
                return;
            }
            // if there are assets we put assign license in headerOptions actions and show them
            this.shouldShowActions = !data.asset.notFound;
            if (this.shouldShowActions) {
                var metadata = this.$scope._vxViewNodeData.node.contentSpec.metadata;
                if (metadata && metadata.actionId) {
                    this.headerOptions.actions = [{
                            actionUid: metadata.actionId,
                            customLabel: this.i18nService.getString("LicenseLibUi", "action.assignLicense.operationName")
                        }];
                }
            }
        };
        AssetSettingsLicenseController.$inject = ["$scope", "i18nService"];
        return AssetSettingsLicenseController;
    }());
    license_ui.AssetSettingsLicenseController = AssetSettingsLicenseController;
    angular.module('com.vmware.vsphere.client.licenseUi').controller('AssetSettingsLicenseController', AssetSettingsLicenseController);
})(license_ui || (license_ui = {}));




